
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4c36"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4c36"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.4";

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.4" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.4"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.4"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.4";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});

parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.4";

});



parcelRegister("cpTWE", function(module, exports) {

$parcel$export(module.exports, "NonFullScreenPageMode", () => NonFullScreenPageMode);
$parcel$export(module.exports, "ReadingDirection", () => ReadingDirection);
$parcel$export(module.exports, "PrintScaling", () => PrintScaling);
$parcel$export(module.exports, "Duplex", () => Duplex);
$parcel$export(module.exports, "default", () => $90a3375623cd9a5a$export$2e2bcd8739ae039);

var $8auL6 = parcelRequire("8auL6");

var $8gQNC = parcelRequire("8gQNC");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var asEnum = function(rawValue, enumType) {
    if (rawValue === undefined) return undefined;
    return enumType[rawValue];
};
var NonFullScreenPageMode;
(function(NonFullScreenPageMode) {
    /**
     * After exiting FullScreen mode, neither the document outline nor thumbnail
     * images should be visible.
     */ NonFullScreenPageMode["UseNone"] = "UseNone";
    /** After exiting FullScreen mode, the document outline should be visible. */ NonFullScreenPageMode["UseOutlines"] = "UseOutlines";
    /** After exiting FullScreen mode, thumbnail images should be visible. */ NonFullScreenPageMode["UseThumbs"] = "UseThumbs";
    /**
     * After exiting FullScreen mode, the optional content group panel should be
     * visible.
     */ NonFullScreenPageMode["UseOC"] = "UseOC";
})(NonFullScreenPageMode || (NonFullScreenPageMode = {}));
var ReadingDirection;
(function(ReadingDirection) {
    /** The predominant reading order is Left to Right. */ ReadingDirection["L2R"] = "L2R";
    /**
     * The predominant reading order is Right to left (including vertical writing
     * systems, such as Chinese, Japanese and Korean).
     */ ReadingDirection["R2L"] = "R2L";
})(ReadingDirection || (ReadingDirection = {}));
var PrintScaling;
(function(PrintScaling) {
    /** No page scaling. */ PrintScaling["None"] = "None";
    /* Use the PDF reader's default print scaling. */ PrintScaling["AppDefault"] = "AppDefault";
})(PrintScaling || (PrintScaling = {}));
var Duplex;
(function(Duplex) {
    /** The PDF reader should print single-sided. */ Duplex["Simplex"] = "Simplex";
    /**
     * The PDF reader should print double sided and flip on the short edge of the
     * sheet.
     */ Duplex["DuplexFlipShortEdge"] = "DuplexFlipShortEdge";
    /**
     * The PDF reader should print double sided and flip on the long edge of the
     * sheet.
     */ Duplex["DuplexFlipLongEdge"] = "DuplexFlipLongEdge";
})(Duplex || (Duplex = {}));
var ViewerPreferences = /** @class */ function() {
    /** @ignore */ function ViewerPreferences(dict) {
        this.dict = dict;
    }
    ViewerPreferences.prototype.lookupBool = function(key) {
        var returnObj = this.dict.lookup((0, $dPHSK.default).of(key));
        if (returnObj instanceof (0, $8gQNC.default)) return returnObj;
        return undefined;
    };
    ViewerPreferences.prototype.lookupName = function(key) {
        var returnObj = this.dict.lookup((0, $dPHSK.default).of(key));
        if (returnObj instanceof (0, $dPHSK.default)) return returnObj;
        return undefined;
    };
    /** @ignore */ ViewerPreferences.prototype.HideToolbar = function() {
        return this.lookupBool('HideToolbar');
    };
    /** @ignore */ ViewerPreferences.prototype.HideMenubar = function() {
        return this.lookupBool('HideMenubar');
    };
    /** @ignore */ ViewerPreferences.prototype.HideWindowUI = function() {
        return this.lookupBool('HideWindowUI');
    };
    /** @ignore */ ViewerPreferences.prototype.FitWindow = function() {
        return this.lookupBool('FitWindow');
    };
    /** @ignore */ ViewerPreferences.prototype.CenterWindow = function() {
        return this.lookupBool('CenterWindow');
    };
    /** @ignore */ ViewerPreferences.prototype.DisplayDocTitle = function() {
        return this.lookupBool('DisplayDocTitle');
    };
    /** @ignore */ ViewerPreferences.prototype.NonFullScreenPageMode = function() {
        return this.lookupName('NonFullScreenPageMode');
    };
    /** @ignore */ ViewerPreferences.prototype.Direction = function() {
        return this.lookupName('Direction');
    };
    /** @ignore */ ViewerPreferences.prototype.PrintScaling = function() {
        return this.lookupName('PrintScaling');
    };
    /** @ignore */ ViewerPreferences.prototype.Duplex = function() {
        return this.lookupName('Duplex');
    };
    /** @ignore */ ViewerPreferences.prototype.PickTrayByPDFSize = function() {
        return this.lookupBool('PickTrayByPDFSize');
    };
    /** @ignore */ ViewerPreferences.prototype.PrintPageRange = function() {
        var PrintPageRange = this.dict.lookup((0, $dPHSK.default).of('PrintPageRange'));
        if (PrintPageRange instanceof (0, $8auL6.default)) return PrintPageRange;
        return undefined;
    };
    /** @ignore */ ViewerPreferences.prototype.NumCopies = function() {
        var NumCopies = this.dict.lookup((0, $dPHSK.default).of('NumCopies'));
        if (NumCopies instanceof (0, $j04jt.default)) return NumCopies;
        return undefined;
    };
    /**
     * Returns `true` if PDF readers should hide the toolbar menus when displaying
     * this document.
     * @returns Whether or not toolbars should be hidden.
     */ ViewerPreferences.prototype.getHideToolbar = function() {
        var _a, _b;
        return (_b = (_a = this.HideToolbar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should hide the menu bar when displaying this
     * document.
     * @returns Whether or not the menu bar should be hidden.
     */ ViewerPreferences.prototype.getHideMenubar = function() {
        var _a, _b;
        return (_b = (_a = this.HideMenubar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should hide the user interface elements in
     * the document's window (such as scroll bars and navigation controls),
     * leaving only the document's contents displayed.
     * @returns Whether or not user interface elements should be hidden.
     */ ViewerPreferences.prototype.getHideWindowUI = function() {
        var _a, _b;
        return (_b = (_a = this.HideWindowUI()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should resize the document's window to fit
     * the size of the first displayed page.
     * @returns Whether or not the window should be resized to fit.
     */ ViewerPreferences.prototype.getFitWindow = function() {
        var _a, _b;
        return (_b = (_a = this.FitWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should position the document's window in the
     * center of the screen.
     * @returns Whether or not to center the document window.
     */ ViewerPreferences.prototype.getCenterWindow = function() {
        var _a, _b;
        return (_b = (_a = this.CenterWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if the window's title bar should display the document
     * `Title`, taken from the document metadata (see [[PDFDocument.getTitle]]).
     * Returns `false` if the title bar should instead display the filename of the
     * PDF file.
     * @returns Whether to display the document title.
     */ ViewerPreferences.prototype.getDisplayDocTitle = function() {
        var _a, _b;
        return (_b = (_a = this.DisplayDocTitle()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns the page mode, which tells the PDF reader how to display the
     * document after exiting full-screen mode.
     * @returns The page mode after exiting full-screen mode.
     */ ViewerPreferences.prototype.getNonFullScreenPageMode = function() {
        var _a, _b;
        var mode = (_a = this.NonFullScreenPageMode()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(mode, NonFullScreenPageMode)) !== null && _b !== void 0 ? _b : NonFullScreenPageMode.UseNone;
    };
    /**
     * Returns the predominant reading order for text.
     * @returns The text reading order.
     */ ViewerPreferences.prototype.getReadingDirection = function() {
        var _a, _b;
        var direction = (_a = this.Direction()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(direction, ReadingDirection)) !== null && _b !== void 0 ? _b : ReadingDirection.L2R;
    };
    /**
     * Returns the page scaling option that the PDF reader should select when the
     * print dialog is displayed.
     * @returns The page scaling option.
     */ ViewerPreferences.prototype.getPrintScaling = function() {
        var _a, _b;
        var scaling = (_a = this.PrintScaling()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(scaling, PrintScaling)) !== null && _b !== void 0 ? _b : PrintScaling.AppDefault;
    };
    /**
     * Returns the paper handling option that should be used when printing the
     * file from the print dialog.
     * @returns The paper handling option.
     */ ViewerPreferences.prototype.getDuplex = function() {
        var _a;
        var duplex = (_a = this.Duplex()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return asEnum(duplex, Duplex);
    };
    /**
     * Returns `true` if the PDF page size should be used to select the input
     * paper tray.
     * @returns Whether or not the PDF page size should be used to select the
     *          input paper tray.
     */ ViewerPreferences.prototype.getPickTrayByPDFSize = function() {
        var _a;
        return (_a = this.PickTrayByPDFSize()) === null || _a === void 0 ? void 0 : _a.asBoolean();
    };
    /**
     * Returns an array of page number ranges, which are the values used to
     * initialize the print dialog box when the file is printed. Each range
     * specifies the first (`start`) and last (`end`) pages in a sub-range of
     * pages to be printed. The first page of the PDF file is denoted by 0.
     * For example:
     * ```js
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * const includesPage3 = viewerPrefs
     *   .getPrintRanges()
     *   .some(pr => pr.start =< 2 && pr.end >= 2)
     * if (includesPage3) console.log('printRange includes page 3')
     * ```
     * @returns An array of objects, each with the properties `start` and `end`,
     *          denoting page indices. If not, specified an empty array is
     *          returned.
     */ ViewerPreferences.prototype.getPrintPageRange = function() {
        var rng = this.PrintPageRange();
        if (!rng) return [];
        var pageRanges = [];
        for(var i = 0; i < rng.size(); i += 2){
            // Despite the spec clearly stating that "The first page of the PDF file
            // shall be donoted by 1", several test PDFs (spec 1.7) created in
            // Acrobat XI 11.0 and also read with Reader DC 2020.013 indicate this is
            // actually a 0 based index.
            var start = rng.lookup(i, (0, $j04jt.default)).asNumber();
            var end = rng.lookup(i + 1, (0, $j04jt.default)).asNumber();
            pageRanges.push({
                start: start,
                end: end
            });
        }
        return pageRanges;
    };
    /**
     * Returns the number of copies to be printed when the print dialog is opened
     * for this document.
     * @returns The default number of copies to be printed.
     */ ViewerPreferences.prototype.getNumCopies = function() {
        var _a, _b;
        return (_b = (_a = this.NumCopies()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
    };
    /**
     * Choose whether the PDF reader's toolbars should be hidden while the
     * document is active.
     * @param hideToolbar `true` if the toolbar should be hidden.
     */ ViewerPreferences.prototype.setHideToolbar = function(hideToolbar) {
        var HideToolbar = this.dict.context.obj(hideToolbar);
        this.dict.set((0, $dPHSK.default).of('HideToolbar'), HideToolbar);
    };
    /**
     * Choose whether the PDF reader's menu bar should be hidden while the
     * document is active.
     * @param hideMenubar `true` if the menu bar should be hidden.
     */ ViewerPreferences.prototype.setHideMenubar = function(hideMenubar) {
        var HideMenubar = this.dict.context.obj(hideMenubar);
        this.dict.set((0, $dPHSK.default).of('HideMenubar'), HideMenubar);
    };
    /**
     * Choose whether the PDF reader should hide user interface elements in the
     * document's window (such as scroll bars and navigation controls), leaving
     * only the document's contents displayed.
     * @param hideWindowUI `true` if the user interface elements should be hidden.
     */ ViewerPreferences.prototype.setHideWindowUI = function(hideWindowUI) {
        var HideWindowUI = this.dict.context.obj(hideWindowUI);
        this.dict.set((0, $dPHSK.default).of('HideWindowUI'), HideWindowUI);
    };
    /**
     * Choose whether the PDF reader should resize the document's window to fit
     * the size of the first displayed page.
     * @param fitWindow `true` if the window should be resized.
     */ ViewerPreferences.prototype.setFitWindow = function(fitWindow) {
        var FitWindow = this.dict.context.obj(fitWindow);
        this.dict.set((0, $dPHSK.default).of('FitWindow'), FitWindow);
    };
    /**
     * Choose whether the PDF reader should position the document's window in the
     * center of the screen.
     * @param centerWindow `true` if the window should be centered.
     */ ViewerPreferences.prototype.setCenterWindow = function(centerWindow) {
        var CenterWindow = this.dict.context.obj(centerWindow);
        this.dict.set((0, $dPHSK.default).of('CenterWindow'), CenterWindow);
    };
    /**
     * Choose whether the window's title bar should display the document `Title`
     * taken from the document metadata (see [[PDFDocument.setTitle]]). If
     * `false`, the title bar should instead display the PDF filename.
     * @param displayTitle `true` if the document title should be displayed.
     */ ViewerPreferences.prototype.setDisplayDocTitle = function(displayTitle) {
        var DisplayDocTitle = this.dict.context.obj(displayTitle);
        this.dict.set((0, $dPHSK.default).of('DisplayDocTitle'), DisplayDocTitle);
    };
    /**
     * Choose how the PDF reader should display the document upon exiting
     * full-screen mode. This entry is meaningful only if the value of the
     * `PageMode` entry in the document's [[PDFCatalog]] is `FullScreen`.
     *
     * For example:
     * ```js
     * import { PDFDocument, NonFullScreenPageMode, PDFName } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     *
     * // Set the PageMode
     * pdfDoc.catalog.set(PDFName.of('PageMode'),PDFName.of('FullScreen'))
     *
     * // Set what happens when full-screen is closed
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setNonFullScreenPageMode(NonFullScreenPageMode.UseOutlines)
     * ```
     *
     * @param nonFullScreenPageMode How the document should be displayed upon
     *                              exiting full screen mode.
     */ ViewerPreferences.prototype.setNonFullScreenPageMode = function(nonFullScreenPageMode) {
        (0, $j0tvB.assertIsOneOf)(nonFullScreenPageMode, 'nonFullScreenPageMode', NonFullScreenPageMode);
        var mode = (0, $dPHSK.default).of(nonFullScreenPageMode);
        this.dict.set((0, $dPHSK.default).of('NonFullScreenPageMode'), mode);
    };
    /**
     * Choose the predominant reading order for text.
     *
     * This entry has no direct effect on the document's contents or page
     * numbering, but may be used to determine the relative positioning of pages
     * when displayed side by side or printed n-up.
     *
     * For example:
     * ```js
     * import { PDFDocument, ReadingDirection } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setReadingDirection(ReadingDirection.R2L)
     * ```
     *
     * @param readingDirection The reading order for text.
     */ ViewerPreferences.prototype.setReadingDirection = function(readingDirection) {
        (0, $j0tvB.assertIsOneOf)(readingDirection, 'readingDirection', ReadingDirection);
        var direction = (0, $dPHSK.default).of(readingDirection);
        this.dict.set((0, $dPHSK.default).of('Direction'), direction);
    };
    /**
     * Choose the page scaling option that should be selected when a print dialog
     * is displayed for this document.
     *
     * For example:
     * ```js
     * import { PDFDocument, PrintScaling } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setPrintScaling(PrintScaling.None)
     * ```
     *
     * @param printScaling The print scaling option.
     */ ViewerPreferences.prototype.setPrintScaling = function(printScaling) {
        (0, $j0tvB.assertIsOneOf)(printScaling, 'printScaling', PrintScaling);
        var scaling = (0, $dPHSK.default).of(printScaling);
        this.dict.set((0, $dPHSK.default).of('PrintScaling'), scaling);
    };
    /**
     * Choose the paper handling option that should be selected by default in the
     * print dialog.
     *
     * For example:
     * ```js
     * import { PDFDocument, Duplex } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setDuplex(Duplex.DuplexFlipShortEdge)
     * ```
     *
     * @param duplex The double or single sided printing option.
     */ ViewerPreferences.prototype.setDuplex = function(duplex) {
        (0, $j0tvB.assertIsOneOf)(duplex, 'duplex', Duplex);
        var dup = (0, $dPHSK.default).of(duplex);
        this.dict.set((0, $dPHSK.default).of('Duplex'), dup);
    };
    /**
     * Choose whether the PDF document's page size should be used to select the
     * input paper tray when printing. This setting influences only the preset
     * values used to populate the print dialog presented by a PDF reader.
     *
     * If PickTrayByPDFSize is true, the check box in the print dialog associated
     * with input paper tray should be checked. This setting has no effect on
     * operating systems that do not provide the ability to pick the input tray
     * by size.
     *
     * @param pickTrayByPDFSize `true` if the document's page size should be used
     *                          to select the input paper tray.
     */ ViewerPreferences.prototype.setPickTrayByPDFSize = function(pickTrayByPDFSize) {
        var PickTrayByPDFSize = this.dict.context.obj(pickTrayByPDFSize);
        this.dict.set((0, $dPHSK.default).of('PickTrayByPDFSize'), PickTrayByPDFSize);
    };
    /**
     * Choose the page numbers used to initialize the print dialog box when the
     * file is printed. The first page of the PDF file is denoted by 0.
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     *
     * // We can set the default print range to only the first page
     * viewerPrefs.setPrintPageRange({ start: 0, end: 0 })
     *
     * // Or we can supply noncontiguous ranges (e.g. pages 1, 3, and 5-7)
     * viewerPrefs.setPrintPageRange([
     *   { start: 0, end: 0 },
     *   { start: 2, end: 2 },
     *   { start: 4, end: 6 },
     * ])
     * ```
     *
     * @param printPageRange An object or array of objects, each with the
     *                       properties `start` and `end`, denoting a range of
     *                       page indices.
     */ ViewerPreferences.prototype.setPrintPageRange = function(printPageRange) {
        if (!Array.isArray(printPageRange)) printPageRange = [
            printPageRange
        ];
        var flatRange = [];
        for(var idx = 0, len = printPageRange.length; idx < len; idx++){
            flatRange.push(printPageRange[idx].start);
            flatRange.push(printPageRange[idx].end);
        }
        (0, $j0tvB.assertEachIs)(flatRange, 'printPageRange', [
            'number'
        ]);
        var pageRanges = this.dict.context.obj(flatRange);
        this.dict.set((0, $dPHSK.default).of('PrintPageRange'), pageRanges);
    };
    /**
     * Choose the default number of copies to be printed when the print dialog is
     * opened for this file.
     * @param numCopies The default number of copies.
     */ ViewerPreferences.prototype.setNumCopies = function(numCopies) {
        (0, $j0tvB.assertRange)(numCopies, 'numCopies', 1, Number.MAX_VALUE);
        (0, $j0tvB.assertInteger)(numCopies, 'numCopies');
        var NumCopies = this.dict.context.obj(numCopies);
        this.dict.set((0, $dPHSK.default).of('NumCopies'), NumCopies);
    };
    /** @ignore */ ViewerPreferences.fromDict = function(dict) {
        return new ViewerPreferences(dict);
    };
    /** @ignore */ ViewerPreferences.create = function(context) {
        var dict = context.obj({});
        return new ViewerPreferences(dict);
    };
    return ViewerPreferences;
}();
var $90a3375623cd9a5a$export$2e2bcd8739ae039 = ViewerPreferences;

});
parcelRegister("8auL6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f271df805933107$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $j04jt = parcelRequire("j04jt");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");

var $nAWRe = parcelRequire("nAWRe");
var $5f271df805933107$var$PDFArray = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFArray, _super);
    function PDFArray(context) {
        var _this = _super.call(this) || this;
        _this.array = [];
        _this.context = context;
        return _this;
    }
    PDFArray.prototype.size = function() {
        return this.array.length;
    };
    PDFArray.prototype.push = function(object) {
        this.array.push(object);
    };
    PDFArray.prototype.insert = function(index, object) {
        this.array.splice(index, 0, object);
    };
    PDFArray.prototype.indexOf = function(object) {
        var index = this.array.indexOf(object);
        return index === -1 ? undefined : index;
    };
    PDFArray.prototype.remove = function(index) {
        this.array.splice(index, 1);
    };
    PDFArray.prototype.set = function(idx, object) {
        this.array[idx] = object;
    };
    PDFArray.prototype.get = function(index) {
        return this.array[index];
    };
    PDFArray.prototype.lookupMaybe = function(index) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        return (_a = this.context).lookupMaybe.apply(_a, (0, $cOQTW.__spreadArrays)([
            this.get(index)
        ], types));
    };
    PDFArray.prototype.lookup = function(index) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        return (_a = this.context).lookup.apply(_a, (0, $cOQTW.__spreadArrays)([
            this.get(index)
        ], types));
    };
    PDFArray.prototype.asRectangle = function() {
        if (this.size() !== 4) throw new (0, $nAWRe.PDFArrayIsNotRectangleError)(this.size());
        var lowerLeftX = this.lookup(0, (0, $j04jt.default)).asNumber();
        var lowerLeftY = this.lookup(1, (0, $j04jt.default)).asNumber();
        var upperRightX = this.lookup(2, (0, $j04jt.default)).asNumber();
        var upperRightY = this.lookup(3, (0, $j04jt.default)).asNumber();
        var x = lowerLeftX;
        var y = lowerLeftY;
        var width = upperRightX - lowerLeftX;
        var height = upperRightY - lowerLeftY;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    };
    PDFArray.prototype.asArray = function() {
        return this.array.slice();
    };
    PDFArray.prototype.clone = function(context) {
        var clone = PDFArray.withContext(context || this.context);
        for(var idx = 0, len = this.size(); idx < len; idx++)clone.push(this.array[idx]);
        return clone;
    };
    PDFArray.prototype.toString = function() {
        var arrayString = '[ ';
        for(var idx = 0, len = this.size(); idx < len; idx++){
            arrayString += this.get(idx).toString();
            arrayString += ' ';
        }
        arrayString += ']';
        return arrayString;
    };
    PDFArray.prototype.sizeInBytes = function() {
        var size = 3;
        for(var idx = 0, len = this.size(); idx < len; idx++)size += this.get(idx).sizeInBytes() + 1;
        return size;
    };
    PDFArray.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).LeftSquareBracket;
        buffer[offset++] = (0, $8zvel.default).Space;
        for(var idx = 0, len = this.size(); idx < len; idx++){
            offset += this.get(idx).copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
        }
        buffer[offset++] = (0, $8zvel.default).RightSquareBracket;
        return offset - initialOffset;
    };
    PDFArray.prototype.scalePDFNumbers = function(x, y) {
        for(var idx = 0, len = this.size(); idx < len; idx++){
            var el = this.lookup(idx);
            if (el instanceof (0, $j04jt.default)) {
                var factor = idx % 2 === 0 ? x : y;
                this.set(idx, (0, $j04jt.default).of(el.asNumber() * factor));
            }
        }
    };
    PDFArray.withContext = function(context) {
        return new PDFArray(context);
    };
    return PDFArray;
}((0, $11c5J.default));
var $5f271df805933107$export$2e2bcd8739ae039 = $5f271df805933107$var$PDFArray;

});
parcelRegister("cOQTW", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $955330a26152f448$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $955330a26152f448$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $955330a26152f448$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $955330a26152f448$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $955330a26152f448$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__spreadArrays", () => $955330a26152f448$export$6388937ca91ccae8);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $955330a26152f448$var$extendStatics = function(d, b) {
    $955330a26152f448$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $955330a26152f448$var$extendStatics(d, b);
};
function $955330a26152f448$export$a8ba968b8961cb8a(d, b) {
    $955330a26152f448$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $955330a26152f448$export$18ce0697a983be9b = function() {
    $955330a26152f448$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $955330a26152f448$export$18ce0697a983be9b.apply(this, arguments);
};
function $955330a26152f448$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $955330a26152f448$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $955330a26152f448$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $955330a26152f448$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $955330a26152f448$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $955330a26152f448$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $955330a26152f448$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $955330a26152f448$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $955330a26152f448$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $955330a26152f448$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $955330a26152f448$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($955330a26152f448$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $955330a26152f448$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $955330a26152f448$export$10c90e4f7922046c(v) {
    return this instanceof $955330a26152f448$export$10c90e4f7922046c ? (this.v = v, this) : new $955330a26152f448$export$10c90e4f7922046c(v);
}
function $955330a26152f448$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $955330a26152f448$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $955330a26152f448$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $955330a26152f448$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $955330a26152f448$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $955330a26152f448$export$19a8beecd37a4c45 === "function" ? $955330a26152f448$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $955330a26152f448$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $955330a26152f448$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $955330a26152f448$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $955330a26152f448$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $955330a26152f448$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("j04jt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd515ce6ac431bbb$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $hiEdU = parcelRequire("hiEdU");

var $11c5J = parcelRequire("11c5J");
var $dd515ce6ac431bbb$var$PDFNumber = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFNumber, _super);
    function PDFNumber(value) {
        var _this = _super.call(this) || this;
        _this.numberValue = value;
        _this.stringValue = (0, $hiEdU.numberToString)(value);
        return _this;
    }
    PDFNumber.prototype.asNumber = function() {
        return this.numberValue;
    };
    /** @deprecated in favor of [[PDFNumber.asNumber]] */ PDFNumber.prototype.value = function() {
        return this.numberValue;
    };
    PDFNumber.prototype.clone = function() {
        return PDFNumber.of(this.numberValue);
    };
    PDFNumber.prototype.toString = function() {
        return this.stringValue;
    };
    PDFNumber.prototype.sizeInBytes = function() {
        return this.stringValue.length;
    };
    PDFNumber.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.stringValue, buffer, offset);
        return this.stringValue.length;
    };
    PDFNumber.of = function(value) {
        return new PDFNumber(value);
    };
    return PDFNumber;
}((0, $11c5J.default));
var $dd515ce6ac431bbb$export$2e2bcd8739ae039 = $dd515ce6ac431bbb$var$PDFNumber;

});
parcelRegister("fvYKZ", function(module, exports) {
$parcel$export(module.exports, "arrayAsString", () => (parcelRequire("4ISq8")).arrayAsString);
$parcel$export(module.exports, "byAscendingId", () => (parcelRequire("4ISq8")).byAscendingId);
$parcel$export(module.exports, "canBeConvertedToUint8Array", () => (parcelRequire("4ISq8")).canBeConvertedToUint8Array);
$parcel$export(module.exports, "last", () => (parcelRequire("4ISq8")).last);
$parcel$export(module.exports, "mergeIntoTypedArray", () => (parcelRequire("4ISq8")).mergeIntoTypedArray);
$parcel$export(module.exports, "mergeUint8Arrays", () => (parcelRequire("4ISq8")).mergeUint8Arrays);
$parcel$export(module.exports, "pluckIndices", () => (parcelRequire("4ISq8")).pluckIndices);
$parcel$export(module.exports, "range", () => (parcelRequire("4ISq8")).range);
$parcel$export(module.exports, "reverseArray", () => (parcelRequire("4ISq8")).reverseArray);
$parcel$export(module.exports, "sortedUniq", () => (parcelRequire("4ISq8")).sortedUniq);
$parcel$export(module.exports, "sum", () => (parcelRequire("4ISq8")).sum);
$parcel$export(module.exports, "toUint8Array", () => (parcelRequire("4ISq8")).toUint8Array);
$parcel$export(module.exports, "typedArrayFor", () => (parcelRequire("4ISq8")).typedArrayFor);
$parcel$export(module.exports, "waitForTick", () => (parcelRequire("ggjMi")).waitForTick);
$parcel$export(module.exports, "breakTextIntoLines", () => (parcelRequire("7Kmy8")).breakTextIntoLines);
$parcel$export(module.exports, "charAtIndex", () => (parcelRequire("7Kmy8")).charAtIndex);
$parcel$export(module.exports, "charFromCode", () => (parcelRequire("7Kmy8")).charFromCode);
$parcel$export(module.exports, "charFromHexCode", () => (parcelRequire("7Kmy8")).charFromHexCode);
$parcel$export(module.exports, "charSplit", () => (parcelRequire("7Kmy8")).charSplit);
$parcel$export(module.exports, "cleanText", () => (parcelRequire("7Kmy8")).cleanText);
$parcel$export(module.exports, "copyStringIntoBuffer", () => (parcelRequire("7Kmy8")).copyStringIntoBuffer);
$parcel$export(module.exports, "findLastMatch", () => (parcelRequire("7Kmy8")).findLastMatch);
$parcel$export(module.exports, "lineSplit", () => (parcelRequire("7Kmy8")).lineSplit);
$parcel$export(module.exports, "mergeLines", () => (parcelRequire("7Kmy8")).mergeLines);
$parcel$export(module.exports, "padStart", () => (parcelRequire("7Kmy8")).padStart);
$parcel$export(module.exports, "parseDate", () => (parcelRequire("7Kmy8")).parseDate);
$parcel$export(module.exports, "toCharCode", () => (parcelRequire("7Kmy8")).toCharCode);
$parcel$export(module.exports, "toCodePoint", () => (parcelRequire("7Kmy8")).toCodePoint);
$parcel$export(module.exports, "toHexString", () => (parcelRequire("7Kmy8")).toHexString);
$parcel$export(module.exports, "toHexStringOfMinLength", () => (parcelRequire("7Kmy8")).toHexStringOfMinLength);
$parcel$export(module.exports, "hasUtf16BOM", () => (parcelRequire("ejAvl")).hasUtf16BOM);
$parcel$export(module.exports, "utf16Decode", () => (parcelRequire("ejAvl")).utf16Decode);
$parcel$export(module.exports, "utf16Encode", () => (parcelRequire("ejAvl")).utf16Encode);
$parcel$export(module.exports, "bytesFor", () => (parcelRequire("hiEdU")).bytesFor);
$parcel$export(module.exports, "numberToString", () => (parcelRequire("hiEdU")).numberToString);
$parcel$export(module.exports, "sizeInBytes", () => (parcelRequire("hiEdU")).sizeInBytes);
$parcel$export(module.exports, "error", () => (parcelRequire("hP0hy")).error);
$parcel$export(module.exports, "encodeToBase64", () => (parcelRequire("fZ8o5")).encodeToBase64);
$parcel$export(module.exports, "isStandardFont", () => (parcelRequire("cbIAG")).isStandardFont);
$parcel$export(module.exports, "rectanglesAreEqual", () => (parcelRequire("cbIAG")).rectanglesAreEqual);
$parcel$export(module.exports, "assertEachIs", () => (parcelRequire("j0tvB")).assertEachIs);
$parcel$export(module.exports, "assertInteger", () => (parcelRequire("j0tvB")).assertInteger);
$parcel$export(module.exports, "assertIs", () => (parcelRequire("j0tvB")).assertIs);
$parcel$export(module.exports, "assertIsOneOf", () => (parcelRequire("j0tvB")).assertIsOneOf);
$parcel$export(module.exports, "assertIsOneOfOrUndefined", () => (parcelRequire("j0tvB")).assertIsOneOfOrUndefined);
$parcel$export(module.exports, "assertIsSubset", () => (parcelRequire("j0tvB")).assertIsSubset);
$parcel$export(module.exports, "assertMultiple", () => (parcelRequire("j0tvB")).assertMultiple);
$parcel$export(module.exports, "assertOrUndefined", () => (parcelRequire("j0tvB")).assertOrUndefined);
$parcel$export(module.exports, "assertPositive", () => (parcelRequire("j0tvB")).assertPositive);
$parcel$export(module.exports, "assertRange", () => (parcelRequire("j0tvB")).assertRange);
$parcel$export(module.exports, "assertRangeOrUndefined", () => (parcelRequire("j0tvB")).assertRangeOrUndefined);
$parcel$export(module.exports, "pdfDocEncodingDecode", () => (parcelRequire("iSBb0")).pdfDocEncodingDecode);

$parcel$export(module.exports, "Cache", () => (parcelRequire("clYSv")).default);
parcelRequire("4ISq8");
parcelRequire("ggjMi");
parcelRequire("7Kmy8");
parcelRequire("ejAvl");
parcelRequire("hiEdU");
parcelRequire("hP0hy");
parcelRequire("fZ8o5");
parcelRequire("cbIAG");
parcelRequire("j0tvB");
parcelRequire("iSBb0");

var $clYSv = parcelRequire("clYSv");

});
parcelRegister("4ISq8", function(module, exports) {

$parcel$export(module.exports, "last", () => $37057c446bb711eb$export$4c7897fafd92b108);
$parcel$export(module.exports, "typedArrayFor", () => $37057c446bb711eb$export$98b44e66722b6f4d);
$parcel$export(module.exports, "mergeIntoTypedArray", () => $37057c446bb711eb$export$8907b5381cbcd9a7);
$parcel$export(module.exports, "mergeUint8Arrays", () => $37057c446bb711eb$export$99cee7ee2de7e6e4);
$parcel$export(module.exports, "arrayAsString", () => $37057c446bb711eb$export$5f8f9664fe5c5f14);
$parcel$export(module.exports, "byAscendingId", () => $37057c446bb711eb$export$55b6b1f56c6e1ba5);
$parcel$export(module.exports, "sortedUniq", () => $37057c446bb711eb$export$720e3b5aefb27114);
$parcel$export(module.exports, "reverseArray", () => $37057c446bb711eb$export$c9b97e771c4a8302);
$parcel$export(module.exports, "sum", () => $37057c446bb711eb$export$8a63f25cc62965f1);
$parcel$export(module.exports, "range", () => $37057c446bb711eb$export$d02631cccf789723);
$parcel$export(module.exports, "pluckIndices", () => $37057c446bb711eb$export$279d041ff3481d88);
$parcel$export(module.exports, "canBeConvertedToUint8Array", () => $37057c446bb711eb$export$20e9c5ed92218c4b);
$parcel$export(module.exports, "toUint8Array", () => $37057c446bb711eb$export$73470fd2221e6aef);

var $fZ8o5 = parcelRequire("fZ8o5");

var $7Kmy8 = parcelRequire("7Kmy8");
var $37057c446bb711eb$export$4c7897fafd92b108 = function(array) {
    return array[array.length - 1];
};
var $37057c446bb711eb$export$98b44e66722b6f4d = function(value) {
    if (value instanceof Uint8Array) return value;
    var length = value.length;
    var typedArray = new Uint8Array(length);
    for(var idx = 0; idx < length; idx++)typedArray[idx] = value.charCodeAt(idx);
    return typedArray;
};
var $37057c446bb711eb$export$8907b5381cbcd9a7 = function() {
    var arrays = [];
    for(var _i = 0; _i < arguments.length; _i++)arrays[_i] = arguments[_i];
    var arrayCount = arrays.length;
    var typedArrays = [];
    for(var idx = 0; idx < arrayCount; idx++){
        var element = arrays[idx];
        typedArrays[idx] = element instanceof Uint8Array ? element : $37057c446bb711eb$export$98b44e66722b6f4d(element);
    }
    var totalSize = 0;
    for(var idx = 0; idx < arrayCount; idx++)totalSize += arrays[idx].length;
    var merged = new Uint8Array(totalSize);
    var offset = 0;
    for(var arrIdx = 0; arrIdx < arrayCount; arrIdx++){
        var arr = typedArrays[arrIdx];
        for(var byteIdx = 0, arrLen = arr.length; byteIdx < arrLen; byteIdx++)merged[offset++] = arr[byteIdx];
    }
    return merged;
};
var $37057c446bb711eb$export$99cee7ee2de7e6e4 = function(arrays) {
    var totalSize = 0;
    for(var idx = 0, len = arrays.length; idx < len; idx++)totalSize += arrays[idx].length;
    var mergedBuffer = new Uint8Array(totalSize);
    var offset = 0;
    for(var idx = 0, len = arrays.length; idx < len; idx++){
        var array = arrays[idx];
        mergedBuffer.set(array, offset);
        offset += array.length;
    }
    return mergedBuffer;
};
var $37057c446bb711eb$export$5f8f9664fe5c5f14 = function(array) {
    var str = '';
    for(var idx = 0, len = array.length; idx < len; idx++)str += (0, $7Kmy8.charFromCode)(array[idx]);
    return str;
};
var $37057c446bb711eb$export$55b6b1f56c6e1ba5 = function(a, b) {
    return a.id - b.id;
};
var $37057c446bb711eb$export$720e3b5aefb27114 = function(array, indexer) {
    var uniq = [];
    for(var idx = 0, len = array.length; idx < len; idx++){
        var curr = array[idx];
        var prev = array[idx - 1];
        if (idx === 0 || indexer(curr) !== indexer(prev)) uniq.push(curr);
    }
    return uniq;
};
var $37057c446bb711eb$export$c9b97e771c4a8302 = function(array) {
    var arrayLen = array.length;
    for(var idx = 0, len = Math.floor(arrayLen / 2); idx < len; idx++){
        var leftIdx = idx;
        var rightIdx = arrayLen - idx - 1;
        var temp = array[idx];
        array[leftIdx] = array[rightIdx];
        array[rightIdx] = temp;
    }
    return array;
};
var $37057c446bb711eb$export$8a63f25cc62965f1 = function(array) {
    var total = 0;
    for(var idx = 0, len = array.length; idx < len; idx++)total += array[idx];
    return total;
};
var $37057c446bb711eb$export$d02631cccf789723 = function(start, end) {
    var arr = new Array(end - start);
    for(var idx = 0, len = arr.length; idx < len; idx++)arr[idx] = start + idx;
    return arr;
};
var $37057c446bb711eb$export$279d041ff3481d88 = function(arr, indices) {
    var plucked = new Array(indices.length);
    for(var idx = 0, len = indices.length; idx < len; idx++)plucked[idx] = arr[indices[idx]];
    return plucked;
};
var $37057c446bb711eb$export$20e9c5ed92218c4b = function(input) {
    return input instanceof Uint8Array || input instanceof ArrayBuffer || typeof input === 'string';
};
var $37057c446bb711eb$export$73470fd2221e6aef = function(input) {
    if (typeof input === 'string') return (0, $fZ8o5.decodeFromBase64DataUri)(input);
    else if (input instanceof ArrayBuffer) return new Uint8Array(input);
    else if (input instanceof Uint8Array) return input;
    else throw new TypeError('`input` must be one of `string | ArrayBuffer | Uint8Array`');
};

});
parcelRegister("fZ8o5", function(module, exports) {

$parcel$export(module.exports, "encodeToBase64", () => $ba330f1ee33d4a3b$export$373f4c3083978ffd);
$parcel$export(module.exports, "decodeFromBase64DataUri", () => $ba330f1ee33d4a3b$export$f6810f5086699d73);
/*
 * The `chars`, `lookup`, `encode`, and `decode` members of this file are
 * licensed under the following:
 *
 *     base64-arraybuffer
 *     https://github.com/niklasvh/base64-arraybuffer
 *
 *     Copyright (c) 2012 Niklas von Hertzen
 *     Licensed under the MIT license.
 *
 */ var $ba330f1ee33d4a3b$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $ba330f1ee33d4a3b$var$lookup = new Uint8Array(256);
for(var $ba330f1ee33d4a3b$var$i = 0; $ba330f1ee33d4a3b$var$i < $ba330f1ee33d4a3b$var$chars.length; $ba330f1ee33d4a3b$var$i++)$ba330f1ee33d4a3b$var$lookup[$ba330f1ee33d4a3b$var$chars.charCodeAt($ba330f1ee33d4a3b$var$i)] = $ba330f1ee33d4a3b$var$i;
var $ba330f1ee33d4a3b$export$373f4c3083978ffd = function(bytes) {
    var base64 = '';
    var len = bytes.length;
    for(var i = 0; i < len; i += 3){
        base64 += $ba330f1ee33d4a3b$var$chars[bytes[i] >> 2];
        base64 += $ba330f1ee33d4a3b$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $ba330f1ee33d4a3b$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $ba330f1ee33d4a3b$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
var $ba330f1ee33d4a3b$export$83edfd8fcc66ec17 = function(base64) {
    var bufferLength = base64.length * 0.75;
    var len = base64.length;
    var i;
    var p = 0;
    var encoded1;
    var encoded2;
    var encoded3;
    var encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    var bytes = new Uint8Array(bufferLength);
    for(i = 0; i < len; i += 4){
        encoded1 = $ba330f1ee33d4a3b$var$lookup[base64.charCodeAt(i)];
        encoded2 = $ba330f1ee33d4a3b$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $ba330f1ee33d4a3b$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $ba330f1ee33d4a3b$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
};
// This regex is designed to be as flexible as possible. It will parse certain
// invalid data URIs.
var $ba330f1ee33d4a3b$var$DATA_URI_PREFIX_REGEX = /^(data)?:?([\w\/\+]+)?;?(charset=[\w-]+|base64)?.*,/i;
var $ba330f1ee33d4a3b$export$f6810f5086699d73 = function(dataUri) {
    var trimmedUri = dataUri.trim();
    var prefix = trimmedUri.substring(0, 100);
    var res = prefix.match($ba330f1ee33d4a3b$var$DATA_URI_PREFIX_REGEX);
    // Assume it's not a data URI - just a plain base64 string
    if (!res) return $ba330f1ee33d4a3b$export$83edfd8fcc66ec17(trimmedUri);
    // Remove the data URI prefix and parse the remainder as a base64 string
    var fullMatch = res[0];
    var data = trimmedUri.substring(fullMatch.length);
    return $ba330f1ee33d4a3b$export$83edfd8fcc66ec17(data);
};

});

parcelRegister("7Kmy8", function(module, exports) {

$parcel$export(module.exports, "toCharCode", () => $5a3e522cca792aad$export$d90166409dd04e85);
$parcel$export(module.exports, "toCodePoint", () => $5a3e522cca792aad$export$93bf578f015d73f0);
$parcel$export(module.exports, "toHexStringOfMinLength", () => $5a3e522cca792aad$export$6ac97d2d1bf41f39);
$parcel$export(module.exports, "padStart", () => $5a3e522cca792aad$export$36cf564d487b5178);
$parcel$export(module.exports, "toHexString", () => $5a3e522cca792aad$export$f4915efbb94d4d01);
$parcel$export(module.exports, "charFromCode", () => $5a3e522cca792aad$export$207031940e6950ad);
$parcel$export(module.exports, "charFromHexCode", () => $5a3e522cca792aad$export$ceedd1b69dcde7a5);
$parcel$export(module.exports, "copyStringIntoBuffer", () => $5a3e522cca792aad$export$c41a03555c37a984);
$parcel$export(module.exports, "cleanText", () => $5a3e522cca792aad$export$6b5e57d20078142b);
$parcel$export(module.exports, "lineSplit", () => $5a3e522cca792aad$export$4f60280859794d8c);
$parcel$export(module.exports, "mergeLines", () => $5a3e522cca792aad$export$b5bf5e120f07cbe);
$parcel$export(module.exports, "charAtIndex", () => $5a3e522cca792aad$export$1a93fc5af577aa5c);
$parcel$export(module.exports, "charSplit", () => $5a3e522cca792aad$export$78f5a8ab9b5e7f1e);
$parcel$export(module.exports, "breakTextIntoLines", () => $5a3e522cca792aad$export$38936f7739928807);
$parcel$export(module.exports, "parseDate", () => $5a3e522cca792aad$export$6b862160d295c8e);
$parcel$export(module.exports, "findLastMatch", () => $5a3e522cca792aad$export$dc1d7d42f51764e3);
var $5a3e522cca792aad$export$d90166409dd04e85 = function(character) {
    return character.charCodeAt(0);
};
var $5a3e522cca792aad$export$93bf578f015d73f0 = function(character) {
    return character.codePointAt(0);
};
var $5a3e522cca792aad$export$6ac97d2d1bf41f39 = function(num, minLength) {
    return $5a3e522cca792aad$export$36cf564d487b5178(num.toString(16), minLength, '0').toUpperCase();
};
var $5a3e522cca792aad$export$f4915efbb94d4d01 = function(num) {
    return $5a3e522cca792aad$export$6ac97d2d1bf41f39(num, 2);
};
var $5a3e522cca792aad$export$207031940e6950ad = function(code) {
    return String.fromCharCode(code);
};
var $5a3e522cca792aad$export$ceedd1b69dcde7a5 = function(hex) {
    return $5a3e522cca792aad$export$207031940e6950ad(parseInt(hex, 16));
};
var $5a3e522cca792aad$export$36cf564d487b5178 = function(value, length, padChar) {
    var padding = '';
    for(var idx = 0, len = length - value.length; idx < len; idx++)padding += padChar;
    return padding + value;
};
var $5a3e522cca792aad$export$c41a03555c37a984 = function(str, buffer, offset) {
    var length = str.length;
    for(var idx = 0; idx < length; idx++)buffer[offset++] = str.charCodeAt(idx);
    return length;
};
var $5a3e522cca792aad$export$505d8f7c00d806ca = function(prefix, suffixLength) {
    if (suffixLength === void 0) suffixLength = 4;
    return prefix + "-" + Math.floor(Math.random() * Math.pow(10, suffixLength));
};
var $5a3e522cca792aad$export$7c57da42ce8e346f = function(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
var $5a3e522cca792aad$export$6b5e57d20078142b = function(text) {
    return text.replace(/\t|\u0085|\u2028|\u2029/g, '    ').replace(/[\b\v]/g, '');
};
var $5a3e522cca792aad$export$60bd2eb6e5a75df0 = [
    '\\n',
    '\\f',
    '\\r',
    '\\u000B'
];
var $5a3e522cca792aad$export$634cc0013ed0f624 = [
    '\n',
    '\f',
    '\r',
    '\u000B'
];
var $5a3e522cca792aad$export$3fc8feceeed3beb0 = function(text) {
    return /^[\n\f\r\u000B]$/.test(text);
};
var $5a3e522cca792aad$export$4f60280859794d8c = function(text) {
    return text.split(/[\n\f\r\u000B]/);
};
var $5a3e522cca792aad$export$b5bf5e120f07cbe = function(text) {
    return text.replace(/[\n\f\r\u000B]/g, ' ');
};
var $5a3e522cca792aad$export$1a93fc5af577aa5c = function(text, index) {
    // Get the first code unit and code unit value
    var cuFirst = text.charCodeAt(index);
    var cuSecond;
    var nextIndex = index + 1;
    var length = 1;
    if (// Check if it's the start of a surrogate pair.
    cuFirst >= 0xd800 && cuFirst <= 0xdbff && // high surrogate
    text.length > nextIndex // there is a next code unit
    ) {
        cuSecond = text.charCodeAt(nextIndex);
        if (cuSecond >= 0xdc00 && cuSecond <= 0xdfff) length = 2; // low surrogate
    }
    return [
        text.slice(index, index + length),
        length
    ];
};
var $5a3e522cca792aad$export$78f5a8ab9b5e7f1e = function(text) {
    var chars = [];
    for(var idx = 0, len = text.length; idx < len;){
        var _a = $5a3e522cca792aad$export$1a93fc5af577aa5c(text, idx), c = _a[0], cLen = _a[1];
        chars.push(c);
        idx += cLen;
    }
    return chars;
};
var $5a3e522cca792aad$var$buildWordBreakRegex = function(wordBreaks) {
    var newlineCharUnion = $5a3e522cca792aad$export$60bd2eb6e5a75df0.join('|');
    var escapedRules = [
        '$'
    ];
    for(var idx = 0, len = wordBreaks.length; idx < len; idx++){
        var wordBreak = wordBreaks[idx];
        if ($5a3e522cca792aad$export$3fc8feceeed3beb0(wordBreak)) throw new TypeError("`wordBreak` must not include " + newlineCharUnion);
        escapedRules.push(wordBreak === '' ? '.' : $5a3e522cca792aad$export$7c57da42ce8e346f(wordBreak));
    }
    var breakRules = escapedRules.join('|');
    return new RegExp("(" + newlineCharUnion + ")|((.*?)(" + breakRules + "))", 'gm');
};
var $5a3e522cca792aad$export$38936f7739928807 = function(text, wordBreaks, maxWidth, computeWidthOfText) {
    var regex = $5a3e522cca792aad$var$buildWordBreakRegex(wordBreaks);
    var words = $5a3e522cca792aad$export$6b5e57d20078142b(text).match(regex);
    var currLine = '';
    var currWidth = 0;
    var lines = [];
    var pushCurrLine = function() {
        if (currLine !== '') lines.push(currLine);
        currLine = '';
        currWidth = 0;
    };
    for(var idx = 0, len = words.length; idx < len; idx++){
        var word = words[idx];
        if ($5a3e522cca792aad$export$3fc8feceeed3beb0(word)) pushCurrLine();
        else {
            var width = computeWidthOfText(word);
            if (currWidth + width > maxWidth) pushCurrLine();
            currLine += word;
            currWidth += width;
        }
    }
    pushCurrLine();
    return lines;
};
// See section "7.9.4 Dates" of the PDF specification
var $5a3e522cca792aad$var$dateRegex = /^D:(\d\d\d\d)(\d\d)?(\d\d)?(\d\d)?(\d\d)?(\d\d)?([+\-Z])?(\d\d)?'?(\d\d)?'?$/;
var $5a3e522cca792aad$export$6b862160d295c8e = function(dateStr) {
    var match = dateStr.match($5a3e522cca792aad$var$dateRegex);
    if (!match) return undefined;
    var year = match[1], _a = match[2], month = _a === void 0 ? '01' : _a, _b = match[3], day = _b === void 0 ? '01' : _b, _c = match[4], hours = _c === void 0 ? '00' : _c, _d = match[5], mins = _d === void 0 ? '00' : _d, _e = match[6], secs = _e === void 0 ? '00' : _e, _f = match[7], offsetSign = _f === void 0 ? 'Z' : _f, _g = match[8], offsetHours = _g === void 0 ? '00' : _g, _h = match[9], offsetMins = _h === void 0 ? '00' : _h;
    // http://www.ecma-international.org/ecma-262/5.1/#sec-15.9.1.15
    var tzOffset = offsetSign === 'Z' ? 'Z' : "" + offsetSign + offsetHours + ":" + offsetMins;
    var date = new Date(year + "-" + month + "-" + day + "T" + hours + ":" + mins + ":" + secs + tzOffset);
    return date;
};
var $5a3e522cca792aad$export$dc1d7d42f51764e3 = function(value, regex) {
    var _a;
    var position = 0;
    var lastMatch;
    while(position < value.length){
        var match = value.substring(position).match(regex);
        if (!match) return {
            match: lastMatch,
            pos: position
        };
        lastMatch = match;
        position += ((_a = match.index) !== null && _a !== void 0 ? _a : 0) + match[0].length;
    }
    return {
        match: lastMatch,
        pos: position
    };
};

});


parcelRegister("ggjMi", function(module, exports) {

$parcel$export(module.exports, "waitForTick", () => $bd6d7b74aa8160e5$export$3b7198a3beef1a5f);
/**
 * Returns a Promise that resolves after at least one tick of the
 * Macro Task Queue occurs.
 */ var $bd6d7b74aa8160e5$export$3b7198a3beef1a5f = function() {
    return new Promise(function(resolve) {
        setTimeout(function() {
            return resolve();
        }, 0);
    });
};

});

parcelRegister("ejAvl", function(module, exports) {

$parcel$export(module.exports, "utf16Encode", () => $a6bf2813aae3d0a0$export$73704d2337848c8e);
$parcel$export(module.exports, "highSurrogate", () => $a6bf2813aae3d0a0$export$8d3bd4086f36eaeb);
$parcel$export(module.exports, "lowSurrogate", () => $a6bf2813aae3d0a0$export$382051c72943492d);
$parcel$export(module.exports, "isWithinBMP", () => $a6bf2813aae3d0a0$export$919ae47c3852aa15);
$parcel$export(module.exports, "hasSurrogates", () => $a6bf2813aae3d0a0$export$d5ab89e7561b44ab);
$parcel$export(module.exports, "utf16Decode", () => $a6bf2813aae3d0a0$export$b89f54f9db637f79);
$parcel$export(module.exports, "hasUtf16BOM", () => $a6bf2813aae3d0a0$export$41e7c15c75b1b24d);

var $7Kmy8 = parcelRequire("7Kmy8");
var $a6bf2813aae3d0a0$export$e1b32e613f230dc6 = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    var encoded = [];
    if (byteOrderMark) encoded.push(0xef, 0xbb, 0xbf);
    for(var idx = 0, len = input.length; idx < len;){
        var codePoint = input.codePointAt(idx);
        // One byte encoding
        if (codePoint < 0x80) {
            var byte1 = codePoint & 0x7f;
            encoded.push(byte1);
            idx += 1;
        } else if (codePoint < 0x0800) {
            var byte1 = codePoint >> 6 & 0x1f | 0xc0;
            var byte2 = codePoint & 0x3f | 0x80;
            encoded.push(byte1, byte2);
            idx += 1;
        } else if (codePoint < 0x010000) {
            var byte1 = codePoint >> 12 & 0x0f | 0xe0;
            var byte2 = codePoint >> 6 & 0x3f | 0x80;
            var byte3 = codePoint & 0x3f | 0x80;
            encoded.push(byte1, byte2, byte3);
            idx += 1;
        } else if (codePoint < 0x110000) {
            var byte1 = codePoint >> 18 & 0x07 | 0xf0;
            var byte2 = codePoint >> 12 & 0x3f | 0x80;
            var byte3 = codePoint >> 6 & 0x3f | 0x80;
            var byte4 = codePoint >> 0 & 0x3f | 0x80;
            encoded.push(byte1, byte2, byte3, byte4);
            idx += 2;
        } else throw new Error("Invalid code point: 0x" + (0, $7Kmy8.toHexString)(codePoint));
    }
    return new Uint8Array(encoded);
};
var $a6bf2813aae3d0a0$export$73704d2337848c8e = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    var encoded = [];
    if (byteOrderMark) encoded.push(0xfeff);
    for(var idx = 0, len = input.length; idx < len;){
        var codePoint = input.codePointAt(idx);
        // Two byte encoding
        if (codePoint < 0x010000) {
            encoded.push(codePoint);
            idx += 1;
        } else if (codePoint < 0x110000) {
            encoded.push($a6bf2813aae3d0a0$export$8d3bd4086f36eaeb(codePoint), $a6bf2813aae3d0a0$export$382051c72943492d(codePoint));
            idx += 2;
        } else throw new Error("Invalid code point: 0x" + (0, $7Kmy8.toHexString)(codePoint));
    }
    return new Uint16Array(encoded);
};
var $a6bf2813aae3d0a0$export$919ae47c3852aa15 = function(codePoint) {
    return codePoint >= 0 && codePoint <= 0xffff;
};
var $a6bf2813aae3d0a0$export$d5ab89e7561b44ab = function(codePoint) {
    return codePoint >= 0x010000 && codePoint <= 0x10ffff;
};
var $a6bf2813aae3d0a0$export$8d3bd4086f36eaeb = function(codePoint) {
    return Math.floor((codePoint - 0x10000) / 0x400) + 0xd800;
};
var $a6bf2813aae3d0a0$export$382051c72943492d = function(codePoint) {
    return (codePoint - 0x10000) % 0x400 + 0xdc00;
};
var $a6bf2813aae3d0a0$var$ByteOrder;
(function(ByteOrder) {
    ByteOrder["BigEndian"] = "BigEndian";
    ByteOrder["LittleEndian"] = "LittleEndian";
})($a6bf2813aae3d0a0$var$ByteOrder || ($a6bf2813aae3d0a0$var$ByteOrder = {}));
var $a6bf2813aae3d0a0$var$REPLACEMENT = "\uFFFD".codePointAt(0);
var $a6bf2813aae3d0a0$export$b89f54f9db637f79 = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    // Need at least 2 bytes of data in UTF-16 encodings
    if (input.length <= 1) return String.fromCodePoint($a6bf2813aae3d0a0$var$REPLACEMENT);
    var byteOrder = byteOrderMark ? $a6bf2813aae3d0a0$var$readBOM(input) : $a6bf2813aae3d0a0$var$ByteOrder.BigEndian;
    // Skip byte order mark if needed
    var idx = byteOrderMark ? 2 : 0;
    var codePoints = [];
    while(input.length - idx >= 2){
        var first = $a6bf2813aae3d0a0$var$decodeValues(input[idx++], input[idx++], byteOrder);
        if ($a6bf2813aae3d0a0$var$isHighSurrogate(first)) {
            if (input.length - idx < 2) // Need at least 2 bytes left for the low surrogate that is required
            codePoints.push($a6bf2813aae3d0a0$var$REPLACEMENT);
            else {
                var second = $a6bf2813aae3d0a0$var$decodeValues(input[idx++], input[idx++], byteOrder);
                if ($a6bf2813aae3d0a0$var$isLowSurrogate(second)) codePoints.push(first, second);
                else // Low surrogates should always follow high surrogates
                codePoints.push($a6bf2813aae3d0a0$var$REPLACEMENT);
            }
        } else if ($a6bf2813aae3d0a0$var$isLowSurrogate(first)) {
            // High surrogates should always come first since `decodeValues()`
            // accounts for the byte ordering
            idx += 2;
            codePoints.push($a6bf2813aae3d0a0$var$REPLACEMENT);
        } else codePoints.push(first);
    }
    // There shouldn't be extra byte(s) left over
    if (idx < input.length) codePoints.push($a6bf2813aae3d0a0$var$REPLACEMENT);
    return String.fromCodePoint.apply(String, codePoints);
};
/**
 * Returns `true` if the given `codePoint` is a high surrogate.
 * @param codePoint The code point to be evaluated.
 *
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Description
 */ var $a6bf2813aae3d0a0$var$isHighSurrogate = function(codePoint) {
    return codePoint >= 0xd800 && codePoint <= 0xdbff;
};
/**
 * Returns `true` if the given `codePoint` is a low surrogate.
 * @param codePoint The code point to be evaluated.
 *
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Description
 */ var $a6bf2813aae3d0a0$var$isLowSurrogate = function(codePoint) {
    return codePoint >= 0xdc00 && codePoint <= 0xdfff;
};
/**
 * Decodes the given utf-16 values first and second using the specified
 * byte order.
 * @param first The first byte of the encoding.
 * @param second The second byte of the encoding.
 * @param byteOrder The byte order of the encoding.
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Examples
 */ var $a6bf2813aae3d0a0$var$decodeValues = function(first, second, byteOrder) {
    // Append the binary representation of the preceding byte by shifting the
    // first one 8 to the left and than applying a bitwise or-operator to append
    // the second one.
    if (byteOrder === $a6bf2813aae3d0a0$var$ByteOrder.LittleEndian) return second << 8 | first;
    if (byteOrder === $a6bf2813aae3d0a0$var$ByteOrder.BigEndian) return first << 8 | second;
    throw new Error("Invalid byteOrder: " + byteOrder);
};
/**
 * Returns whether the given array contains a byte order mark for the
 * UTF-16BE or UTF-16LE encoding. If it has neither, BigEndian is assumed.
 *
 * Reference: https://en.wikipedia.org/wiki/Byte_order_mark#UTF-16
 *
 * @param bytes The byte array to be evaluated.
 */ // prettier-ignore
var $a6bf2813aae3d0a0$var$readBOM = function(bytes) {
    return $a6bf2813aae3d0a0$var$hasUtf16BigEndianBOM(bytes) ? $a6bf2813aae3d0a0$var$ByteOrder.BigEndian : $a6bf2813aae3d0a0$var$hasUtf16LittleEndianBOM(bytes) ? $a6bf2813aae3d0a0$var$ByteOrder.LittleEndian : $a6bf2813aae3d0a0$var$ByteOrder.BigEndian;
};
var $a6bf2813aae3d0a0$var$hasUtf16BigEndianBOM = function(bytes) {
    return bytes[0] === 0xfe && bytes[1] === 0xff;
};
var $a6bf2813aae3d0a0$var$hasUtf16LittleEndianBOM = function(bytes) {
    return bytes[0] === 0xff && bytes[1] === 0xfe;
};
var $a6bf2813aae3d0a0$export$41e7c15c75b1b24d = function(bytes) {
    return $a6bf2813aae3d0a0$var$hasUtf16BigEndianBOM(bytes) || $a6bf2813aae3d0a0$var$hasUtf16LittleEndianBOM(bytes);
};

});

parcelRegister("hiEdU", function(module, exports) {

$parcel$export(module.exports, "numberToString", () => $c983519a4c18aa89$export$f67be9d9b0e25d7b);
$parcel$export(module.exports, "sizeInBytes", () => $c983519a4c18aa89$export$cc6acfd7a782614d);
$parcel$export(module.exports, "bytesFor", () => $c983519a4c18aa89$export$3c7962b7d5fa4e42);
// tslint:disable radix
/**
 * Converts a number to its string representation in decimal. This function
 * differs from simply converting a number to a string with `.toString()`
 * because this function's output string will **not** contain exponential
 * notation.
 *
 * Credit: https://stackoverflow.com/a/46545519
 */ var $c983519a4c18aa89$export$f67be9d9b0e25d7b = function(num) {
    var numStr = String(num);
    if (Math.abs(num) < 1.0) {
        var e = parseInt(num.toString().split('e-')[1]);
        if (e) {
            var negative = num < 0;
            if (negative) num *= -1;
            num *= Math.pow(10, e - 1);
            numStr = '0.' + new Array(e).join('0') + num.toString().substring(2);
            if (negative) numStr = '-' + numStr;
        }
    } else {
        var e = parseInt(num.toString().split('+')[1]);
        if (e > 20) {
            e -= 20;
            num /= Math.pow(10, e);
            numStr = num.toString() + new Array(e + 1).join('0');
        }
    }
    return numStr;
};
var $c983519a4c18aa89$export$cc6acfd7a782614d = function(n) {
    return Math.ceil(n.toString(2).length / 8);
};
var $c983519a4c18aa89$export$3c7962b7d5fa4e42 = function(n) {
    var bytes = new Uint8Array($c983519a4c18aa89$export$cc6acfd7a782614d(n));
    for(var i = 1; i <= bytes.length; i++)bytes[i - 1] = n >> (bytes.length - i) * 8;
    return bytes;
};

});

parcelRegister("hP0hy", function(module, exports) {

$parcel$export(module.exports, "error", () => $cf976b189519155d$export$a3bc9b8ed74fc);
var $cf976b189519155d$export$a3bc9b8ed74fc = function(msg) {
    throw new Error(msg);
};

});

parcelRegister("cbIAG", function(module, exports) {

$parcel$export(module.exports, "values", () => $8df919e62912d805$export$68c286be0e7e55b7);
$parcel$export(module.exports, "isStandardFont", () => $8df919e62912d805$export$f2950432a4491977);
$parcel$export(module.exports, "rectanglesAreEqual", () => $8df919e62912d805$export$93263d7e9f52c023);
parcelRequire("eNCdi");
var $kkdJe = parcelRequire("kkdJe");
var $8df919e62912d805$export$68c286be0e7e55b7 = function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $8df919e62912d805$export$59252e21bbb61725 = $8df919e62912d805$export$68c286be0e7e55b7((0, $kkdJe.FontNames));
var $8df919e62912d805$export$f2950432a4491977 = function(input) {
    return $8df919e62912d805$export$59252e21bbb61725.includes(input);
};
var $8df919e62912d805$export$93263d7e9f52c023 = function(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
};

});
parcelRegister("eNCdi", function(module, exports) {
$parcel$export(module.exports, "Font", () => (parcelRequire("kkdJe")).Font);
$parcel$export(module.exports, "FontNames", () => (parcelRequire("kkdJe")).FontNames);
$parcel$export(module.exports, "Encodings", () => (parcelRequire("90iSP")).Encodings);
parcelRequire("kkdJe");
parcelRequire("90iSP");

});
parcelRegister("kkdJe", function(module, exports) {

$parcel$export(module.exports, "FontNames", () => $ecc0531572753d26$export$a1e7b970f5a14844);
$parcel$export(module.exports, "Font", () => $ecc0531572753d26$export$89abf52a030e56ee);

var $5JpfH = parcelRequire("5JpfH");

var $3uXKw = parcelRequire("3uXKw");

var $7ybLn = parcelRequire("7ybLn");

var $fCZVO = parcelRequire("fCZVO");

var $cOHfc = parcelRequire("cOHfc");

var $eVbDh = parcelRequire("eVbDh");

var $g9ZKL = parcelRequire("g9ZKL");

var $hgkij = parcelRequire("hgkij");

var $4W9K8 = parcelRequire("4W9K8");

var $gbK7N = parcelRequire("gbK7N");

var $lan6Z = parcelRequire("lan6Z");

var $1zetG = parcelRequire("1zetG");

var $53nEH = parcelRequire("53nEH");

var $fhfja = parcelRequire("fhfja");

var $enbPQ = parcelRequire("enbPQ");
// prettier-ignore
var $ecc0531572753d26$var$compressedJsonForFontName = {
    'Courier': (0, (/*@__PURE__*/$parcel$interopDefault($cOHfc))),
    'Courier-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($3uXKw))),
    'Courier-Oblique': (0, (/*@__PURE__*/$parcel$interopDefault($fCZVO))),
    'Courier-BoldOblique': (0, (/*@__PURE__*/$parcel$interopDefault($7ybLn))),
    'Helvetica': (0, (/*@__PURE__*/$parcel$interopDefault($4W9K8))),
    'Helvetica-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($eVbDh))),
    'Helvetica-Oblique': (0, (/*@__PURE__*/$parcel$interopDefault($hgkij))),
    'Helvetica-BoldOblique': (0, (/*@__PURE__*/$parcel$interopDefault($g9ZKL))),
    'Times-Roman': (0, (/*@__PURE__*/$parcel$interopDefault($53nEH))),
    'Times-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($gbK7N))),
    'Times-Italic': (0, (/*@__PURE__*/$parcel$interopDefault($1zetG))),
    'Times-BoldItalic': (0, (/*@__PURE__*/$parcel$interopDefault($lan6Z))),
    'Symbol': (0, (/*@__PURE__*/$parcel$interopDefault($fhfja))),
    'ZapfDingbats': (0, (/*@__PURE__*/$parcel$interopDefault($enbPQ)))
};
var $ecc0531572753d26$export$a1e7b970f5a14844;
(function(FontNames) {
    FontNames["Courier"] = "Courier";
    FontNames["CourierBold"] = "Courier-Bold";
    FontNames["CourierOblique"] = "Courier-Oblique";
    FontNames["CourierBoldOblique"] = "Courier-BoldOblique";
    FontNames["Helvetica"] = "Helvetica";
    FontNames["HelveticaBold"] = "Helvetica-Bold";
    FontNames["HelveticaOblique"] = "Helvetica-Oblique";
    FontNames["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
    FontNames["TimesRoman"] = "Times-Roman";
    FontNames["TimesRomanBold"] = "Times-Bold";
    FontNames["TimesRomanItalic"] = "Times-Italic";
    FontNames["TimesRomanBoldItalic"] = "Times-BoldItalic";
    FontNames["Symbol"] = "Symbol";
    FontNames["ZapfDingbats"] = "ZapfDingbats";
})($ecc0531572753d26$export$a1e7b970f5a14844 || ($ecc0531572753d26$export$a1e7b970f5a14844 = {}));
var $ecc0531572753d26$var$fontCache = {};
var $ecc0531572753d26$export$89abf52a030e56ee = /** @class */ function() {
    function Font() {
        var _this = this;
        this.getWidthOfGlyph = function(glyphName) {
            return _this.CharWidths[glyphName];
        };
        this.getXAxisKerningForPair = function(leftGlyphName, rightGlyphName) {
            return (_this.KernPairXAmounts[leftGlyphName] || {})[rightGlyphName];
        };
    }
    Font.load = function(fontName) {
        var cachedFont = $ecc0531572753d26$var$fontCache[fontName];
        if (cachedFont) return cachedFont;
        var json = (0, $5JpfH.decompressJson)($ecc0531572753d26$var$compressedJsonForFontName[fontName]);
        var font = Object.assign(new Font(), JSON.parse(json));
        font.CharWidths = font.CharMetrics.reduce(function(acc, metric) {
            acc[metric.N] = metric.WX;
            return acc;
        }, {});
        font.KernPairXAmounts = font.KernPairs.reduce(function(acc, _a) {
            var name1 = _a[0], name2 = _a[1], width = _a[2];
            if (!acc[name1]) acc[name1] = {};
            acc[name1][name2] = width;
            return acc;
        }, {});
        $ecc0531572753d26$var$fontCache[fontName] = font;
        return font;
    };
    return Font;
}();

});
parcelRegister("5JpfH", function(module, exports) {

$parcel$export(module.exports, "decompressJson", () => $42c4be4670940c1e$export$134b8d792d6efd14);
$parcel$export(module.exports, "padStart", () => $42c4be4670940c1e$export$36cf564d487b5178);
/*
 * The `chars`, `lookup`, and `decodeFromBase64` members of this file are
 * licensed under the following:
 *
 *     base64-arraybuffer
 *     https://github.com/niklasvh/base64-arraybuffer
 *
 *     Copyright (c) 2012 Niklas von Hertzen
 *     Licensed under the MIT license.
 *
 */ 
var $ckCqy = parcelRequire("ckCqy");
var $42c4be4670940c1e$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $42c4be4670940c1e$var$lookup = new Uint8Array(256);
for(var $42c4be4670940c1e$var$i = 0; $42c4be4670940c1e$var$i < $42c4be4670940c1e$var$chars.length; $42c4be4670940c1e$var$i++)$42c4be4670940c1e$var$lookup[$42c4be4670940c1e$var$chars.charCodeAt($42c4be4670940c1e$var$i)] = $42c4be4670940c1e$var$i;
var $42c4be4670940c1e$export$83edfd8fcc66ec17 = function(base64) {
    var bufferLength = base64.length * 0.75;
    var len = base64.length;
    var i;
    var p = 0;
    var encoded1;
    var encoded2;
    var encoded3;
    var encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    var bytes = new Uint8Array(bufferLength);
    for(i = 0; i < len; i += 4){
        encoded1 = $42c4be4670940c1e$var$lookup[base64.charCodeAt(i)];
        encoded2 = $42c4be4670940c1e$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $42c4be4670940c1e$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $42c4be4670940c1e$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
};
var $42c4be4670940c1e$var$arrayToString = function(array) {
    var str = '';
    for(var i = 0; i < array.length; i++)str += String.fromCharCode(array[i]);
    return str;
};
var $42c4be4670940c1e$export$134b8d792d6efd14 = function(compressedJson) {
    return $42c4be4670940c1e$var$arrayToString((0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).inflate($42c4be4670940c1e$export$83edfd8fcc66ec17(compressedJson)));
};
var $42c4be4670940c1e$export$36cf564d487b5178 = function(value, length, padChar) {
    var padding = '';
    for(var idx = 0, len = length - value.length; idx < len; idx++)padding += padChar;
    return padding + value;
};

});
parcelRegister("ckCqy", function(module, exports) {
// Top level file is just a mixin of submodules & constants
'use strict';

var $9CLQF = parcelRequire("9CLQF");
var $8fa5292818130bae$require$assign = $9CLQF.assign;

var $2wbN5 = parcelRequire("2wbN5");

var $3OYOJ = parcelRequire("3OYOJ");

var $hf4Xu = parcelRequire("hf4Xu");
var $8fa5292818130bae$var$pako = {};
$8fa5292818130bae$require$assign($8fa5292818130bae$var$pako, $2wbN5, $3OYOJ, $hf4Xu);
module.exports = $8fa5292818130bae$var$pako;

});
parcelRegister("9CLQF", function(module, exports) {
'use strict';
var $701cc75d47025217$var$TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';
function $701cc75d47025217$var$_has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
module.exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(var p in source)if ($701cc75d47025217$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
module.exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var $701cc75d47025217$var$fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var $701cc75d47025217$var$fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
module.exports.setTyped = function(on) {
    if (on) {
        module.exports.Buf8 = Uint8Array;
        module.exports.Buf16 = Uint16Array;
        module.exports.Buf32 = Int32Array;
        module.exports.assign(module.exports, $701cc75d47025217$var$fnTyped);
    } else {
        module.exports.Buf8 = Array;
        module.exports.Buf16 = Array;
        module.exports.Buf32 = Array;
        module.exports.assign(module.exports, $701cc75d47025217$var$fnUntyped);
    }
};
module.exports.setTyped($701cc75d47025217$var$TYPED_OK);

});

parcelRegister("2wbN5", function(module, exports) {

$parcel$export(module.exports, "Deflate", () => $1d57b756249bc6d3$export$ae157b6234afe138, (v) => $1d57b756249bc6d3$export$ae157b6234afe138 = v);
$parcel$export(module.exports, "deflate", () => $1d57b756249bc6d3$export$2316623ecd1285ab, (v) => $1d57b756249bc6d3$export$2316623ecd1285ab = v);
$parcel$export(module.exports, "deflateRaw", () => $1d57b756249bc6d3$export$e95d6a8f69fb340a, (v) => $1d57b756249bc6d3$export$e95d6a8f69fb340a = v);
$parcel$export(module.exports, "gzip", () => $1d57b756249bc6d3$export$69f0ea7cf3a331a8, (v) => $1d57b756249bc6d3$export$69f0ea7cf3a331a8 = v);
var $1d57b756249bc6d3$export$ae157b6234afe138;
var $1d57b756249bc6d3$export$2316623ecd1285ab;
var $1d57b756249bc6d3$export$e95d6a8f69fb340a;
var $1d57b756249bc6d3$export$69f0ea7cf3a331a8;
'use strict';

var $lGf86 = parcelRequire("lGf86");

var $9CLQF = parcelRequire("9CLQF");

var $iC2HB = parcelRequire("iC2HB");

var $7gAmB = parcelRequire("7gAmB");

var $9WDto = parcelRequire("9WDto");
var $1d57b756249bc6d3$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $1d57b756249bc6d3$var$Z_NO_FLUSH = 0;
var $1d57b756249bc6d3$var$Z_FINISH = 4;
var $1d57b756249bc6d3$var$Z_OK = 0;
var $1d57b756249bc6d3$var$Z_STREAM_END = 1;
var $1d57b756249bc6d3$var$Z_SYNC_FLUSH = 2;
var $1d57b756249bc6d3$var$Z_DEFAULT_COMPRESSION = -1;
var $1d57b756249bc6d3$var$Z_DEFAULT_STRATEGY = 0;
var $1d57b756249bc6d3$var$Z_DEFLATED = 8;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $1d57b756249bc6d3$var$Deflate(options) {
    if (!(this instanceof $1d57b756249bc6d3$var$Deflate)) return new $1d57b756249bc6d3$var$Deflate(options);
    this.options = $9CLQF.assign({
        level: $1d57b756249bc6d3$var$Z_DEFAULT_COMPRESSION,
        method: $1d57b756249bc6d3$var$Z_DEFLATED,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $1d57b756249bc6d3$var$Z_DEFAULT_STRATEGY,
        to: ''
    }, options || {});
    var opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $9WDto();
    this.strm.avail_out = 0;
    var status = $lGf86.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $1d57b756249bc6d3$var$Z_OK) throw new Error($7gAmB[status]);
    if (opt.header) $lGf86.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        var dict;
        // Convert data if needed
        if (typeof opt.dictionary === 'string') // If we need to compress text, change encoding to utf8.
        dict = $iC2HB.string2buf(opt.dictionary);
        else if ($1d57b756249bc6d3$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $lGf86.deflateSetDictionary(this.strm, dict);
        if (status !== $1d57b756249bc6d3$var$Z_OK) throw new Error($7gAmB[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $1d57b756249bc6d3$var$Deflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var status, _mode;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $1d57b756249bc6d3$var$Z_FINISH : $1d57b756249bc6d3$var$Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
    strm.input = $iC2HB.string2buf(data);
    else if ($1d57b756249bc6d3$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $9CLQF.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $lGf86.deflate(strm, _mode); /* no bad return value */ 
        if (status !== $1d57b756249bc6d3$var$Z_STREAM_END && status !== $1d57b756249bc6d3$var$Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === $1d57b756249bc6d3$var$Z_FINISH || _mode === $1d57b756249bc6d3$var$Z_SYNC_FLUSH)) {
            if (this.options.to === 'string') this.onData($iC2HB.buf2binstring($9CLQF.shrinkBuf(strm.output, strm.next_out)));
            else this.onData($9CLQF.shrinkBuf(strm.output, strm.next_out));
        }
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $1d57b756249bc6d3$var$Z_STREAM_END);
    // Finalize on the last chunk.
    if (_mode === $1d57b756249bc6d3$var$Z_FINISH) {
        status = $lGf86.deflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $1d57b756249bc6d3$var$Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $1d57b756249bc6d3$var$Z_SYNC_FLUSH) {
        this.onEnd($1d57b756249bc6d3$var$Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $1d57b756249bc6d3$var$Deflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $1d57b756249bc6d3$var$Deflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $1d57b756249bc6d3$var$Z_OK) {
        if (this.options.to === 'string') this.result = this.chunks.join('');
        else this.result = $9CLQF.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $1d57b756249bc6d3$var$deflate(input, options) {
    var deflator = new $1d57b756249bc6d3$var$Deflate(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $7gAmB[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $1d57b756249bc6d3$var$deflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $1d57b756249bc6d3$var$deflate(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $1d57b756249bc6d3$var$gzip(input, options) {
    options = options || {};
    options.gzip = true;
    return $1d57b756249bc6d3$var$deflate(input, options);
}
$1d57b756249bc6d3$export$ae157b6234afe138 = $1d57b756249bc6d3$var$Deflate;
$1d57b756249bc6d3$export$2316623ecd1285ab = $1d57b756249bc6d3$var$deflate;
$1d57b756249bc6d3$export$e95d6a8f69fb340a = $1d57b756249bc6d3$var$deflateRaw;
$1d57b756249bc6d3$export$69f0ea7cf3a331a8 = $1d57b756249bc6d3$var$gzip;

});
parcelRegister("lGf86", function(module, exports) {

$parcel$export(module.exports, "deflateInit2", () => $fc8941aa2060205a$export$a65c7b2bde87cb70, (v) => $fc8941aa2060205a$export$a65c7b2bde87cb70 = v);
$parcel$export(module.exports, "deflateSetHeader", () => $fc8941aa2060205a$export$1cd50f7b2515ba19, (v) => $fc8941aa2060205a$export$1cd50f7b2515ba19 = v);
$parcel$export(module.exports, "deflate", () => $fc8941aa2060205a$export$2316623ecd1285ab, (v) => $fc8941aa2060205a$export$2316623ecd1285ab = v);
$parcel$export(module.exports, "deflateEnd", () => $fc8941aa2060205a$export$599854fa319a815f, (v) => $fc8941aa2060205a$export$599854fa319a815f = v);
$parcel$export(module.exports, "deflateSetDictionary", () => $fc8941aa2060205a$export$f55e0b3ab66b5d46, (v) => $fc8941aa2060205a$export$f55e0b3ab66b5d46 = v);
var $fc8941aa2060205a$export$72b35d618fb8ad9b;
var $fc8941aa2060205a$export$a65c7b2bde87cb70;
var $fc8941aa2060205a$export$8f99f0e30bc7dd53;
var $fc8941aa2060205a$export$e78fab288549509;
var $fc8941aa2060205a$export$1cd50f7b2515ba19;
var $fc8941aa2060205a$export$2316623ecd1285ab;
var $fc8941aa2060205a$export$599854fa319a815f;
var $fc8941aa2060205a$export$f55e0b3ab66b5d46;
var $fc8941aa2060205a$export$12b6e1fcadea22f9;
'use strict';

var $9CLQF = parcelRequire("9CLQF");

var $hx6dX = parcelRequire("hx6dX");

var $gJUj4 = parcelRequire("gJUj4");

var $5UMyJ = parcelRequire("5UMyJ");

var $7gAmB = parcelRequire("7gAmB");
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $fc8941aa2060205a$var$Z_NO_FLUSH = 0;
var $fc8941aa2060205a$var$Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var $fc8941aa2060205a$var$Z_FULL_FLUSH = 3;
var $fc8941aa2060205a$var$Z_FINISH = 4;
var $fc8941aa2060205a$var$Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $fc8941aa2060205a$var$Z_OK = 0;
var $fc8941aa2060205a$var$Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $fc8941aa2060205a$var$Z_STREAM_ERROR = -2;
var $fc8941aa2060205a$var$Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var $fc8941aa2060205a$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $fc8941aa2060205a$var$Z_DEFAULT_COMPRESSION = -1;
var $fc8941aa2060205a$var$Z_FILTERED = 1;
var $fc8941aa2060205a$var$Z_HUFFMAN_ONLY = 2;
var $fc8941aa2060205a$var$Z_RLE = 3;
var $fc8941aa2060205a$var$Z_FIXED = 4;
var $fc8941aa2060205a$var$Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $fc8941aa2060205a$var$Z_UNKNOWN = 2;
/* The deflate compression method */ var $fc8941aa2060205a$var$Z_DEFLATED = 8;
/*============================================================================*/ var $fc8941aa2060205a$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $fc8941aa2060205a$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $fc8941aa2060205a$var$DEF_MEM_LEVEL = 8;
var $fc8941aa2060205a$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $fc8941aa2060205a$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $fc8941aa2060205a$var$L_CODES = $fc8941aa2060205a$var$LITERALS + 1 + $fc8941aa2060205a$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $fc8941aa2060205a$var$D_CODES = 30;
/* number of distance codes */ var $fc8941aa2060205a$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $fc8941aa2060205a$var$HEAP_SIZE = 2 * $fc8941aa2060205a$var$L_CODES + 1;
/* maximum heap size */ var $fc8941aa2060205a$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $fc8941aa2060205a$var$MIN_MATCH = 3;
var $fc8941aa2060205a$var$MAX_MATCH = 258;
var $fc8941aa2060205a$var$MIN_LOOKAHEAD = $fc8941aa2060205a$var$MAX_MATCH + $fc8941aa2060205a$var$MIN_MATCH + 1;
var $fc8941aa2060205a$var$PRESET_DICT = 0x20;
var $fc8941aa2060205a$var$INIT_STATE = 42;
var $fc8941aa2060205a$var$EXTRA_STATE = 69;
var $fc8941aa2060205a$var$NAME_STATE = 73;
var $fc8941aa2060205a$var$COMMENT_STATE = 91;
var $fc8941aa2060205a$var$HCRC_STATE = 103;
var $fc8941aa2060205a$var$BUSY_STATE = 113;
var $fc8941aa2060205a$var$FINISH_STATE = 666;
var $fc8941aa2060205a$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $fc8941aa2060205a$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $fc8941aa2060205a$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $fc8941aa2060205a$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $fc8941aa2060205a$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $fc8941aa2060205a$var$err(strm, errorCode) {
    strm.msg = $7gAmB[errorCode];
    return errorCode;
}
function $fc8941aa2060205a$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $fc8941aa2060205a$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $fc8941aa2060205a$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $9CLQF.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $fc8941aa2060205a$var$flush_block_only(s, last) {
    $hx6dX._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $fc8941aa2060205a$var$flush_pending(s.strm);
}
function $fc8941aa2060205a$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $fc8941aa2060205a$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $fc8941aa2060205a$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $9CLQF.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $gJUj4(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $5UMyJ(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $fc8941aa2060205a$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
        scan = strend - $fc8941aa2060205a$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $fc8941aa2060205a$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD)) {
            $9CLQF.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $fc8941aa2060205a$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $fc8941aa2060205a$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $fc8941aa2060205a$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $fc8941aa2060205a$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead === 0 && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $fc8941aa2060205a$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
        if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $hx6dX._tr_tally(s, s.strstart - s.match_start, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $fc8941aa2060205a$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $fc8941aa2060205a$var$Z_FILTERED || s.match_length === $fc8941aa2060205a$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $fc8941aa2060205a$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $fc8941aa2060205a$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $hx6dX._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $fc8941aa2060205a$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $fc8941aa2060205a$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $hx6dX._tr_tally(s, 1, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $fc8941aa2060205a$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $fc8941aa2060205a$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $fc8941aa2060205a$var$configuration_table;
$fc8941aa2060205a$var$configuration_table = [
    /*      good lazy nice chain */ new $fc8941aa2060205a$var$Config(0, 0, 0, 0, $fc8941aa2060205a$var$deflate_stored),
    /* 0 store only */ new $fc8941aa2060205a$var$Config(4, 4, 8, 4, $fc8941aa2060205a$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $fc8941aa2060205a$var$Config(4, 5, 16, 8, $fc8941aa2060205a$var$deflate_fast),
    /* 2 */ new $fc8941aa2060205a$var$Config(4, 6, 32, 32, $fc8941aa2060205a$var$deflate_fast),
    /* 3 */ new $fc8941aa2060205a$var$Config(4, 4, 16, 16, $fc8941aa2060205a$var$deflate_slow),
    /* 4 lazy matches */ new $fc8941aa2060205a$var$Config(8, 16, 32, 32, $fc8941aa2060205a$var$deflate_slow),
    /* 5 */ new $fc8941aa2060205a$var$Config(8, 16, 128, 128, $fc8941aa2060205a$var$deflate_slow),
    /* 6 */ new $fc8941aa2060205a$var$Config(8, 32, 128, 256, $fc8941aa2060205a$var$deflate_slow),
    /* 7 */ new $fc8941aa2060205a$var$Config(32, 128, 258, 1024, $fc8941aa2060205a$var$deflate_slow),
    /* 8 */ new $fc8941aa2060205a$var$Config(32, 258, 258, 4096, $fc8941aa2060205a$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $fc8941aa2060205a$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $fc8941aa2060205a$var$configuration_table[s.level].max_lazy;
    s.good_match = $fc8941aa2060205a$var$configuration_table[s.level].good_length;
    s.nice_match = $fc8941aa2060205a$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $fc8941aa2060205a$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $fc8941aa2060205a$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $fc8941aa2060205a$var$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $9CLQF.Buf16($fc8941aa2060205a$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $9CLQF.Buf16((2 * $fc8941aa2060205a$var$D_CODES + 1) * 2);
    this.bl_tree = new $9CLQF.Buf16((2 * $fc8941aa2060205a$var$BL_CODES + 1) * 2);
    $fc8941aa2060205a$var$zero(this.dyn_ltree);
    $fc8941aa2060205a$var$zero(this.dyn_dtree);
    $fc8941aa2060205a$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $9CLQF.Buf16($fc8941aa2060205a$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $9CLQF.Buf16(2 * $fc8941aa2060205a$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $fc8941aa2060205a$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new $9CLQF.Buf16(2 * $fc8941aa2060205a$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $fc8941aa2060205a$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $fc8941aa2060205a$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $fc8941aa2060205a$var$Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $fc8941aa2060205a$var$INIT_STATE : $fc8941aa2060205a$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $fc8941aa2060205a$var$Z_NO_FLUSH;
    $hx6dX._tr_init(s);
    return $fc8941aa2060205a$var$Z_OK;
}
function $fc8941aa2060205a$var$deflateReset(strm) {
    var ret = $fc8941aa2060205a$var$deflateResetKeep(strm);
    if (ret === $fc8941aa2060205a$var$Z_OK) $fc8941aa2060205a$var$lm_init(strm.state);
    return ret;
}
function $fc8941aa2060205a$var$deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $fc8941aa2060205a$var$Z_OK;
}
function $fc8941aa2060205a$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    var wrap = 1;
    if (level === $fc8941aa2060205a$var$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $fc8941aa2060205a$var$MAX_MEM_LEVEL || method !== $fc8941aa2060205a$var$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $fc8941aa2060205a$var$Z_FIXED) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $fc8941aa2060205a$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $fc8941aa2060205a$var$MIN_MATCH - 1) / $fc8941aa2060205a$var$MIN_MATCH);
    s.window = new $9CLQF.Buf8(s.w_size * 2);
    s.head = new $9CLQF.Buf16(s.hash_size);
    s.prev = new $9CLQF.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $9CLQF.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $fc8941aa2060205a$var$deflateReset(strm);
}
function $fc8941aa2060205a$var$deflateInit(strm, level) {
    return $fc8941aa2060205a$var$deflateInit2(strm, level, $fc8941aa2060205a$var$Z_DEFLATED, $fc8941aa2060205a$var$MAX_WBITS, $fc8941aa2060205a$var$DEF_MEM_LEVEL, $fc8941aa2060205a$var$Z_DEFAULT_STRATEGY);
}
function $fc8941aa2060205a$var$deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $fc8941aa2060205a$var$Z_BLOCK || flush < 0) return strm ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR) : $fc8941aa2060205a$var$Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $fc8941aa2060205a$var$FINISH_STATE && flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$err(strm, strm.avail_out === 0 ? $fc8941aa2060205a$var$Z_BUF_ERROR : $fc8941aa2060205a$var$Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $fc8941aa2060205a$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $fc8941aa2060205a$var$put_byte(s, 31);
            $fc8941aa2060205a$var$put_byte(s, 139);
            $fc8941aa2060205a$var$put_byte(s, 8);
            if (!s.gzhead) {
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $fc8941aa2060205a$var$put_byte(s, $fc8941aa2060205a$var$OS_CODE);
                s.status = $fc8941aa2060205a$var$BUSY_STATE;
            } else {
                $fc8941aa2060205a$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$EXTRA_STATE;
            }
        } else {
            var header = $fc8941aa2060205a$var$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $fc8941aa2060205a$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $fc8941aa2060205a$var$BUSY_STATE;
            $fc8941aa2060205a$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
                $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $fc8941aa2060205a$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$NAME_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$NAME_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$COMMENT_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$COMMENT_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $fc8941aa2060205a$var$HCRC_STATE;
        } else s.status = $fc8941aa2060205a$var$HCRC_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $fc8941aa2060205a$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
                $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $fc8941aa2060205a$var$BUSY_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $fc8941aa2060205a$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $fc8941aa2060205a$var$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $fc8941aa2060205a$var$rank(flush) <= $fc8941aa2060205a$var$rank(old_flush) && flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $fc8941aa2060205a$var$FINISH_STATE && strm.avail_in !== 0) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $fc8941aa2060205a$var$Z_NO_FLUSH && s.status !== $fc8941aa2060205a$var$FINISH_STATE) {
        var bstate = s.strategy === $fc8941aa2060205a$var$Z_HUFFMAN_ONLY ? $fc8941aa2060205a$var$deflate_huff(s, flush) : s.strategy === $fc8941aa2060205a$var$Z_RLE ? $fc8941aa2060205a$var$deflate_rle(s, flush) : $fc8941aa2060205a$var$configuration_table[s.level].func(s, flush);
        if (bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED || bstate === $fc8941aa2060205a$var$BS_FINISH_DONE) s.status = $fc8941aa2060205a$var$FINISH_STATE;
        if (bstate === $fc8941aa2060205a$var$BS_NEED_MORE || bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $fc8941aa2060205a$var$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $fc8941aa2060205a$var$BS_BLOCK_DONE) {
            if (flush === $fc8941aa2060205a$var$Z_PARTIAL_FLUSH) $hx6dX._tr_align(s);
            else if (flush !== $fc8941aa2060205a$var$Z_BLOCK) {
                $hx6dX._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $fc8941aa2060205a$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $fc8941aa2060205a$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $fc8941aa2060205a$var$Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$Z_OK;
    if (s.wrap <= 0) return $fc8941aa2060205a$var$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 24 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $fc8941aa2060205a$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $fc8941aa2060205a$var$Z_OK : $fc8941aa2060205a$var$Z_STREAM_END;
}
function $fc8941aa2060205a$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== $fc8941aa2060205a$var$INIT_STATE && status !== $fc8941aa2060205a$var$EXTRA_STATE && status !== $fc8941aa2060205a$var$NAME_STATE && status !== $fc8941aa2060205a$var$COMMENT_STATE && status !== $fc8941aa2060205a$var$HCRC_STATE && status !== $fc8941aa2060205a$var$BUSY_STATE && status !== $fc8941aa2060205a$var$FINISH_STATE) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    strm.state = null;
    return status === $fc8941aa2060205a$var$BUSY_STATE ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_DATA_ERROR) : $fc8941aa2060205a$var$Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function $fc8941aa2060205a$var$deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $fc8941aa2060205a$var$INIT_STATE || s.lookahead) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $gJUj4(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new $9CLQF.Buf8(s.w_size);
        $9CLQF.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $fc8941aa2060205a$var$fill_window(s);
    while(s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - ($fc8941aa2060205a$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $fc8941aa2060205a$var$MIN_MATCH - 1;
        $fc8941aa2060205a$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $fc8941aa2060205a$var$Z_OK;
}
$fc8941aa2060205a$export$72b35d618fb8ad9b = $fc8941aa2060205a$var$deflateInit;
$fc8941aa2060205a$export$a65c7b2bde87cb70 = $fc8941aa2060205a$var$deflateInit2;
$fc8941aa2060205a$export$8f99f0e30bc7dd53 = $fc8941aa2060205a$var$deflateReset;
$fc8941aa2060205a$export$e78fab288549509 = $fc8941aa2060205a$var$deflateResetKeep;
$fc8941aa2060205a$export$1cd50f7b2515ba19 = $fc8941aa2060205a$var$deflateSetHeader;
$fc8941aa2060205a$export$2316623ecd1285ab = $fc8941aa2060205a$var$deflate;
$fc8941aa2060205a$export$599854fa319a815f = $fc8941aa2060205a$var$deflateEnd;
$fc8941aa2060205a$export$f55e0b3ab66b5d46 = $fc8941aa2060205a$var$deflateSetDictionary;
$fc8941aa2060205a$export$12b6e1fcadea22f9 = 'pako deflate (from Nodeca project)'; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 

});
parcelRegister("hx6dX", function(module, exports) {

$parcel$export(module.exports, "_tr_init", () => $cc3a58b664fcb155$export$4e4fc0157c3cd14d, (v) => $cc3a58b664fcb155$export$4e4fc0157c3cd14d = v);
$parcel$export(module.exports, "_tr_stored_block", () => $cc3a58b664fcb155$export$8959e34c5e020172, (v) => $cc3a58b664fcb155$export$8959e34c5e020172 = v);
$parcel$export(module.exports, "_tr_flush_block", () => $cc3a58b664fcb155$export$44f15b52eef0cf41, (v) => $cc3a58b664fcb155$export$44f15b52eef0cf41 = v);
$parcel$export(module.exports, "_tr_tally", () => $cc3a58b664fcb155$export$b3cbce147289408f, (v) => $cc3a58b664fcb155$export$b3cbce147289408f = v);
$parcel$export(module.exports, "_tr_align", () => $cc3a58b664fcb155$export$bfb360e02ee9b403, (v) => $cc3a58b664fcb155$export$bfb360e02ee9b403 = v);
var $cc3a58b664fcb155$export$4e4fc0157c3cd14d;
var $cc3a58b664fcb155$export$8959e34c5e020172;
var $cc3a58b664fcb155$export$44f15b52eef0cf41;
var $cc3a58b664fcb155$export$b3cbce147289408f;
var $cc3a58b664fcb155$export$bfb360e02ee9b403;
'use strict';

var $9CLQF = parcelRequire("9CLQF");
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $cc3a58b664fcb155$var$Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $cc3a58b664fcb155$var$Z_BINARY = 0;
var $cc3a58b664fcb155$var$Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $cc3a58b664fcb155$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $cc3a58b664fcb155$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $cc3a58b664fcb155$var$STORED_BLOCK = 0;
var $cc3a58b664fcb155$var$STATIC_TREES = 1;
var $cc3a58b664fcb155$var$DYN_TREES = 2;
/* The three kinds of block type */ var $cc3a58b664fcb155$var$MIN_MATCH = 3;
var $cc3a58b664fcb155$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $cc3a58b664fcb155$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $cc3a58b664fcb155$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $cc3a58b664fcb155$var$L_CODES = $cc3a58b664fcb155$var$LITERALS + 1 + $cc3a58b664fcb155$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $cc3a58b664fcb155$var$D_CODES = 30;
/* number of distance codes */ var $cc3a58b664fcb155$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $cc3a58b664fcb155$var$HEAP_SIZE = 2 * $cc3a58b664fcb155$var$L_CODES + 1;
/* maximum heap size */ var $cc3a58b664fcb155$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $cc3a58b664fcb155$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $cc3a58b664fcb155$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $cc3a58b664fcb155$var$END_BLOCK = 256;
/* end of block literal code */ var $cc3a58b664fcb155$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $cc3a58b664fcb155$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $cc3a58b664fcb155$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $cc3a58b664fcb155$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $cc3a58b664fcb155$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $cc3a58b664fcb155$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $cc3a58b664fcb155$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $cc3a58b664fcb155$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $cc3a58b664fcb155$var$static_ltree = new Array(($cc3a58b664fcb155$var$L_CODES + 2) * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $cc3a58b664fcb155$var$static_dtree = new Array($cc3a58b664fcb155$var$D_CODES * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $cc3a58b664fcb155$var$_dist_code = new Array($cc3a58b664fcb155$var$DIST_CODE_LEN);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $cc3a58b664fcb155$var$_length_code = new Array($cc3a58b664fcb155$var$MAX_MATCH - $cc3a58b664fcb155$var$MIN_MATCH + 1);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $cc3a58b664fcb155$var$base_length = new Array($cc3a58b664fcb155$var$LENGTH_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $cc3a58b664fcb155$var$base_dist = new Array($cc3a58b664fcb155$var$D_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $cc3a58b664fcb155$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $cc3a58b664fcb155$var$static_l_desc;
var $cc3a58b664fcb155$var$static_d_desc;
var $cc3a58b664fcb155$var$static_bl_desc;
function $cc3a58b664fcb155$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $cc3a58b664fcb155$var$d_code(dist) {
    return dist < 256 ? $cc3a58b664fcb155$var$_dist_code[dist] : $cc3a58b664fcb155$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $cc3a58b664fcb155$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $cc3a58b664fcb155$var$send_bits(s, value, length) {
    if (s.bi_valid > $cc3a58b664fcb155$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $cc3a58b664fcb155$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $cc3a58b664fcb155$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $cc3a58b664fcb155$var$send_code(s, c, tree) {
    $cc3a58b664fcb155$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $cc3a58b664fcb155$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $cc3a58b664fcb155$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $cc3a58b664fcb155$var$gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $cc3a58b664fcb155$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $cc3a58b664fcb155$var$gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array($cc3a58b664fcb155$var$MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $cc3a58b664fcb155$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($cc3a58b664fcb155$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $cc3a58b664fcb155$var$LENGTH_CODES - 1; code++){
        $cc3a58b664fcb155$var$base_length[code] = length;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_lbits[code]; n++)$cc3a58b664fcb155$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $cc3a58b664fcb155$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code]; n++)$cc3a58b664fcb155$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $cc3a58b664fcb155$var$D_CODES; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code] - 7; n++)$cc3a58b664fcb155$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $cc3a58b664fcb155$var$gen_codes($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++){
        $cc3a58b664fcb155$var$static_dtree[n * 2 + 1] = 5;
        $cc3a58b664fcb155$var$static_dtree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $cc3a58b664fcb155$var$static_l_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$extra_lbits, $cc3a58b664fcb155$var$LITERALS + 1, $cc3a58b664fcb155$var$L_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_d_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_dtree, $cc3a58b664fcb155$var$extra_dbits, 0, $cc3a58b664fcb155$var$D_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_bl_desc = new $cc3a58b664fcb155$var$StaticTreeDesc(new Array(0), $cc3a58b664fcb155$var$extra_blbits, 0, $cc3a58b664fcb155$var$BL_CODES, $cc3a58b664fcb155$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $cc3a58b664fcb155$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $cc3a58b664fcb155$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$cc3a58b664fcb155$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $cc3a58b664fcb155$var$bi_windup(s) {
    if (s.bi_valid > 8) $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $cc3a58b664fcb155$var$copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $cc3a58b664fcb155$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $cc3a58b664fcb155$var$put_short(s, len);
        $cc3a58b664fcb155$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $9CLQF.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $cc3a58b664fcb155$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $cc3a58b664fcb155$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $cc3a58b664fcb155$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($cc3a58b664fcb155$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $cc3a58b664fcb155$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $cc3a58b664fcb155$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $cc3a58b664fcb155$var$_length_code[lc];
            $cc3a58b664fcb155$var$send_code(s, code + $cc3a58b664fcb155$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $cc3a58b664fcb155$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $cc3a58b664fcb155$var$base_length[code];
                $cc3a58b664fcb155$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $cc3a58b664fcb155$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $cc3a58b664fcb155$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $cc3a58b664fcb155$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $cc3a58b664fcb155$var$base_dist[code];
                $cc3a58b664fcb155$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $cc3a58b664fcb155$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $cc3a58b664fcb155$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$cc3a58b664fcb155$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $cc3a58b664fcb155$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $cc3a58b664fcb155$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $cc3a58b664fcb155$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$cc3a58b664fcb155$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$cc3a58b664fcb155$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$cc3a58b664fcb155$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $cc3a58b664fcb155$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REP_3_6, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_3_10, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 3);
        } else {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_11_138, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $cc3a58b664fcb155$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $cc3a58b664fcb155$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $cc3a58b664fcb155$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $cc3a58b664fcb155$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $cc3a58b664fcb155$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$cc3a58b664fcb155$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $cc3a58b664fcb155$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $cc3a58b664fcb155$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $cc3a58b664fcb155$var$send_bits(s, dcodes - 1, 5);
    $cc3a58b664fcb155$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $cc3a58b664fcb155$var$send_bits(s, s.bl_tree[$cc3a58b664fcb155$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $cc3a58b664fcb155$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    for(n = 32; n < $cc3a58b664fcb155$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $cc3a58b664fcb155$var$Z_BINARY;
}
var $cc3a58b664fcb155$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $cc3a58b664fcb155$var$_tr_init(s) {
    if (!$cc3a58b664fcb155$var$static_init_done) {
        $cc3a58b664fcb155$var$tr_static_init();
        $cc3a58b664fcb155$var$static_init_done = true;
    }
    s.l_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_ltree, $cc3a58b664fcb155$var$static_l_desc);
    s.d_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_dtree, $cc3a58b664fcb155$var$static_d_desc);
    s.bl_desc = new $cc3a58b664fcb155$var$TreeDesc(s.bl_tree, $cc3a58b664fcb155$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $cc3a58b664fcb155$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $cc3a58b664fcb155$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $cc3a58b664fcb155$var$copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $cc3a58b664fcb155$var$_tr_align(s) {
    $cc3a58b664fcb155$var$send_bits(s, $cc3a58b664fcb155$var$STATIC_TREES << 1, 3);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, $cc3a58b664fcb155$var$static_ltree);
    $cc3a58b664fcb155$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $cc3a58b664fcb155$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $cc3a58b664fcb155$var$Z_UNKNOWN) s.strm.data_type = $cc3a58b664fcb155$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $cc3a58b664fcb155$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $cc3a58b664fcb155$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $cc3a58b664fcb155$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $cc3a58b664fcb155$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $cc3a58b664fcb155$var$Z_FIXED || static_lenb === opt_lenb) {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$compress_block(s, $cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$static_dtree);
    } else {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $cc3a58b664fcb155$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $cc3a58b664fcb155$var$init_block(s);
    if (last) $cc3a58b664fcb155$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $cc3a58b664fcb155$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($cc3a58b664fcb155$var$_length_code[lc] + $cc3a58b664fcb155$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$cc3a58b664fcb155$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
$cc3a58b664fcb155$export$4e4fc0157c3cd14d = $cc3a58b664fcb155$var$_tr_init;
$cc3a58b664fcb155$export$8959e34c5e020172 = $cc3a58b664fcb155$var$_tr_stored_block;
$cc3a58b664fcb155$export$44f15b52eef0cf41 = $cc3a58b664fcb155$var$_tr_flush_block;
$cc3a58b664fcb155$export$b3cbce147289408f = $cc3a58b664fcb155$var$_tr_tally;
$cc3a58b664fcb155$export$bfb360e02ee9b403 = $cc3a58b664fcb155$var$_tr_align;

});

parcelRegister("gJUj4", function(module, exports) {
'use strict';
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $c2fc869ba2d0859c$var$adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
module.exports = $c2fc869ba2d0859c$var$adler32;

});

parcelRegister("5UMyJ", function(module, exports) {
'use strict';
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function $44e7d98dd6723a9a$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $44e7d98dd6723a9a$var$crcTable = $44e7d98dd6723a9a$var$makeTable();
function $44e7d98dd6723a9a$var$crc32(crc, buf, len, pos) {
    var t = $44e7d98dd6723a9a$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
module.exports = $44e7d98dd6723a9a$var$crc32;

});

parcelRegister("7gAmB", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};

});


parcelRegister("iC2HB", function(module, exports) {

$parcel$export(module.exports, "string2buf", () => $d8cddf31faab2448$export$7a4c1b2f775b5a9f, (v) => $d8cddf31faab2448$export$7a4c1b2f775b5a9f = v);
$parcel$export(module.exports, "buf2binstring", () => $d8cddf31faab2448$export$a751fe64af8a9a51, (v) => $d8cddf31faab2448$export$a751fe64af8a9a51 = v);
$parcel$export(module.exports, "binstring2buf", () => $d8cddf31faab2448$export$1d1a7119601ff18c, (v) => $d8cddf31faab2448$export$1d1a7119601ff18c = v);
$parcel$export(module.exports, "buf2string", () => $d8cddf31faab2448$export$49a50563f377746, (v) => $d8cddf31faab2448$export$49a50563f377746 = v);
$parcel$export(module.exports, "utf8border", () => $d8cddf31faab2448$export$53dee3f58a714214, (v) => $d8cddf31faab2448$export$53dee3f58a714214 = v);
// String encode/decode helpers
// convert string to array (typed, when possible)
var $d8cddf31faab2448$export$7a4c1b2f775b5a9f;
// Convert byte array to binary string
var $d8cddf31faab2448$export$a751fe64af8a9a51;
// Convert binary string (typed, when possible)
var $d8cddf31faab2448$export$1d1a7119601ff18c;
// convert array to string
var $d8cddf31faab2448$export$49a50563f377746;
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $d8cddf31faab2448$export$53dee3f58a714214;
'use strict';

var $9CLQF = parcelRequire("9CLQF");
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var $d8cddf31faab2448$var$STR_APPLY_OK = true;
var $d8cddf31faab2448$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, [
        0
    ]);
} catch (__) {
    $d8cddf31faab2448$var$STR_APPLY_OK = false;
}
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $d8cddf31faab2448$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var $d8cddf31faab2448$var$_utf8len = new $9CLQF.Buf8(256);
for(var $d8cddf31faab2448$var$q = 0; $d8cddf31faab2448$var$q < 256; $d8cddf31faab2448$var$q++)$d8cddf31faab2448$var$_utf8len[$d8cddf31faab2448$var$q] = $d8cddf31faab2448$var$q >= 252 ? 6 : $d8cddf31faab2448$var$q >= 248 ? 5 : $d8cddf31faab2448$var$q >= 240 ? 4 : $d8cddf31faab2448$var$q >= 224 ? 3 : $d8cddf31faab2448$var$q >= 192 ? 2 : 1;
$d8cddf31faab2448$var$_utf8len[254] = $d8cddf31faab2448$var$_utf8len[254] = 1; // Invalid sequence start
$d8cddf31faab2448$export$7a4c1b2f775b5a9f = function(str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new $9CLQF.Buf8(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper (used in 2 places)
function $d8cddf31faab2448$var$buf2binstring(buf, len) {
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $d8cddf31faab2448$var$STR_APPLY_UIA_OK || !buf.subarray && $d8cddf31faab2448$var$STR_APPLY_OK) return String.fromCharCode.apply(null, $9CLQF.shrinkBuf(buf, len));
    }
    var result = '';
    for(var i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
}
$d8cddf31faab2448$export$a751fe64af8a9a51 = function(buf) {
    return $d8cddf31faab2448$var$buf2binstring(buf, buf.length);
};
$d8cddf31faab2448$export$1d1a7119601ff18c = function(str) {
    var buf = new $9CLQF.Buf8(str.length);
    for(var i = 0, len = buf.length; i < len; i++)buf[i] = str.charCodeAt(i);
    return buf;
};
$d8cddf31faab2448$export$49a50563f377746 = function(buf, max) {
    var i, out, c, c_len;
    var len = max || buf.length;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        c_len = $d8cddf31faab2448$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $d8cddf31faab2448$var$buf2binstring(utf16buf, out);
};
$d8cddf31faab2448$export$53dee3f58a714214 = function(buf, max) {
    var pos;
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $d8cddf31faab2448$var$_utf8len[buf[pos]] > max ? pos : max;
};

});

parcelRegister("9WDto", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $73d8265e2c50d00b$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
module.exports = $73d8265e2c50d00b$var$ZStream;

});


parcelRegister("3OYOJ", function(module, exports) {

$parcel$export(module.exports, "Inflate", () => $2c8537a6b47169be$export$d1de70a877d6e43c, (v) => $2c8537a6b47169be$export$d1de70a877d6e43c = v);
$parcel$export(module.exports, "inflate", () => $2c8537a6b47169be$export$cae1ce83fe4a1782, (v) => $2c8537a6b47169be$export$cae1ce83fe4a1782 = v);
$parcel$export(module.exports, "inflateRaw", () => $2c8537a6b47169be$export$d0f0aa2d05c905c5, (v) => $2c8537a6b47169be$export$d0f0aa2d05c905c5 = v);
$parcel$export(module.exports, "ungzip", () => $2c8537a6b47169be$export$95adf9d270383091, (v) => $2c8537a6b47169be$export$95adf9d270383091 = v);
/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $2c8537a6b47169be$export$d1de70a877d6e43c;
var $2c8537a6b47169be$export$cae1ce83fe4a1782;
var $2c8537a6b47169be$export$d0f0aa2d05c905c5;
var $2c8537a6b47169be$export$95adf9d270383091;
'use strict';

var $fzvBq = parcelRequire("fzvBq");

var $9CLQF = parcelRequire("9CLQF");

var $iC2HB = parcelRequire("iC2HB");

var $hf4Xu = parcelRequire("hf4Xu");

var $7gAmB = parcelRequire("7gAmB");

var $9WDto = parcelRequire("9WDto");

var $9t6AE = parcelRequire("9t6AE");
var $2c8537a6b47169be$var$toString = Object.prototype.toString;
/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $2c8537a6b47169be$var$Inflate(options) {
    if (!(this instanceof $2c8537a6b47169be$var$Inflate)) return new $2c8537a6b47169be$var$Inflate(options);
    this.options = $9CLQF.assign({
        chunkSize: 16384,
        windowBits: 0,
        to: ''
    }, options || {});
    var opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $9WDto();
    this.strm.avail_out = 0;
    var status = $fzvBq.inflateInit2(this.strm, opt.windowBits);
    if (status !== $hf4Xu.Z_OK) throw new Error($7gAmB[status]);
    this.header = new $9t6AE();
    $fzvBq.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === 'string') opt.dictionary = $iC2HB.string2buf(opt.dictionary);
        else if ($2c8537a6b47169be$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $fzvBq.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $hf4Xu.Z_OK) throw new Error($7gAmB[status]);
        }
    }
}
/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $2c8537a6b47169be$var$Inflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var dictionary = this.options.dictionary;
    var status, _mode;
    var next_out_utf8, tail, utf8str;
    // Flag to properly process Z_BUF_ERROR on testing inflate call
    // when we check that all output data was flushed.
    var allowBufError = false;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $hf4Xu.Z_FINISH : $hf4Xu.Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === 'string') // Only binary strings can be decompressed on practice
    strm.input = $iC2HB.binstring2buf(data);
    else if ($2c8537a6b47169be$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $9CLQF.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $fzvBq.inflate(strm, $hf4Xu.Z_NO_FLUSH); /* no bad return value */ 
        if (status === $hf4Xu.Z_NEED_DICT && dictionary) status = $fzvBq.inflateSetDictionary(this.strm, dictionary);
        if (status === $hf4Xu.Z_BUF_ERROR && allowBufError === true) {
            status = $hf4Xu.Z_OK;
            allowBufError = false;
        }
        if (status !== $hf4Xu.Z_STREAM_END && status !== $hf4Xu.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $hf4Xu.Z_STREAM_END || strm.avail_in === 0 && (_mode === $hf4Xu.Z_FINISH || _mode === $hf4Xu.Z_SYNC_FLUSH)) {
                if (this.options.to === 'string') {
                    next_out_utf8 = $iC2HB.utf8border(strm.output, strm.next_out);
                    tail = strm.next_out - next_out_utf8;
                    utf8str = $iC2HB.buf2string(strm.output, next_out_utf8);
                    // move tail
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) $9CLQF.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                    this.onData(utf8str);
                } else this.onData($9CLQF.shrinkBuf(strm.output, strm.next_out));
            }
        }
        // When no more input data, we should check that internal inflate buffers
        // are flushed. The only way to do it when avail_out = 0 - run one more
        // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
        // Here we set flag to process this error properly.
        //
        // NOTE. Deflate does not return error in this case and does not needs such
        // logic.
        if (strm.avail_in === 0 && strm.avail_out === 0) allowBufError = true;
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $hf4Xu.Z_STREAM_END);
    if (status === $hf4Xu.Z_STREAM_END) _mode = $hf4Xu.Z_FINISH;
    // Finalize on the last chunk.
    if (_mode === $hf4Xu.Z_FINISH) {
        status = $fzvBq.inflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $hf4Xu.Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $hf4Xu.Z_SYNC_FLUSH) {
        this.onEnd($hf4Xu.Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $2c8537a6b47169be$var$Inflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $2c8537a6b47169be$var$Inflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $hf4Xu.Z_OK) {
        if (this.options.to === 'string') // Glue & convert here, until we teach pako to send
        // utf8 aligned strings to onData
        this.result = this.chunks.join('');
        else this.result = $9CLQF.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/ function $2c8537a6b47169be$var$inflate(input, options) {
    var inflator = new $2c8537a6b47169be$var$Inflate(options);
    inflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $7gAmB[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $2c8537a6b47169be$var$inflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $2c8537a6b47169be$var$inflate(input, options);
}
$2c8537a6b47169be$export$d1de70a877d6e43c = $2c8537a6b47169be$var$Inflate;
$2c8537a6b47169be$export$cae1ce83fe4a1782 = $2c8537a6b47169be$var$inflate;
$2c8537a6b47169be$export$d0f0aa2d05c905c5 = $2c8537a6b47169be$var$inflateRaw;
$2c8537a6b47169be$export$95adf9d270383091 = $2c8537a6b47169be$var$inflate;

});
parcelRegister("fzvBq", function(module, exports) {

$parcel$export(module.exports, "inflateInit2", () => $b562a383a327bea1$export$6792d92addc5c8a0, (v) => $b562a383a327bea1$export$6792d92addc5c8a0 = v);
$parcel$export(module.exports, "inflate", () => $b562a383a327bea1$export$cae1ce83fe4a1782, (v) => $b562a383a327bea1$export$cae1ce83fe4a1782 = v);
$parcel$export(module.exports, "inflateEnd", () => $b562a383a327bea1$export$224e1a443c3fba76, (v) => $b562a383a327bea1$export$224e1a443c3fba76 = v);
$parcel$export(module.exports, "inflateGetHeader", () => $b562a383a327bea1$export$6d4647cb9e1c75fc, (v) => $b562a383a327bea1$export$6d4647cb9e1c75fc = v);
$parcel$export(module.exports, "inflateSetDictionary", () => $b562a383a327bea1$export$60da749bed98ccf8, (v) => $b562a383a327bea1$export$60da749bed98ccf8 = v);
var $b562a383a327bea1$export$42de45683a92ba94;
var $b562a383a327bea1$export$7633ac2cd30f9650;
var $b562a383a327bea1$export$6710ea52c4ec9d6a;
var $b562a383a327bea1$export$9c140b25e26874f9;
var $b562a383a327bea1$export$6792d92addc5c8a0;
var $b562a383a327bea1$export$cae1ce83fe4a1782;
var $b562a383a327bea1$export$224e1a443c3fba76;
var $b562a383a327bea1$export$6d4647cb9e1c75fc;
var $b562a383a327bea1$export$60da749bed98ccf8;
var $b562a383a327bea1$export$220f6291ca35fd71;
'use strict';

var $9CLQF = parcelRequire("9CLQF");

var $gJUj4 = parcelRequire("gJUj4");

var $5UMyJ = parcelRequire("5UMyJ");

var $6OFFF = parcelRequire("6OFFF");

var $bxjQM = parcelRequire("bxjQM");
var $b562a383a327bea1$var$CODES = 0;
var $b562a383a327bea1$var$LENS = 1;
var $b562a383a327bea1$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $b562a383a327bea1$var$Z_FINISH = 4;
var $b562a383a327bea1$var$Z_BLOCK = 5;
var $b562a383a327bea1$var$Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $b562a383a327bea1$var$Z_OK = 0;
var $b562a383a327bea1$var$Z_STREAM_END = 1;
var $b562a383a327bea1$var$Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var $b562a383a327bea1$var$Z_STREAM_ERROR = -2;
var $b562a383a327bea1$var$Z_DATA_ERROR = -3;
var $b562a383a327bea1$var$Z_MEM_ERROR = -4;
var $b562a383a327bea1$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $b562a383a327bea1$var$Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $b562a383a327bea1$var$HEAD = 1; /* i: waiting for magic header */ 
var $b562a383a327bea1$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $b562a383a327bea1$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $b562a383a327bea1$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $b562a383a327bea1$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $b562a383a327bea1$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $b562a383a327bea1$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $b562a383a327bea1$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $b562a383a327bea1$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $b562a383a327bea1$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $b562a383a327bea1$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $b562a383a327bea1$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var $b562a383a327bea1$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $b562a383a327bea1$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $b562a383a327bea1$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $b562a383a327bea1$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $b562a383a327bea1$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $b562a383a327bea1$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $b562a383a327bea1$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $b562a383a327bea1$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $b562a383a327bea1$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $b562a383a327bea1$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $b562a383a327bea1$var$DIST = 23; /* i: waiting for distance code */ 
var $b562a383a327bea1$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $b562a383a327bea1$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $b562a383a327bea1$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $b562a383a327bea1$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $b562a383a327bea1$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $b562a383a327bea1$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $b562a383a327bea1$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $b562a383a327bea1$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $b562a383a327bea1$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $b562a383a327bea1$var$ENOUGH_LENS = 852;
var $b562a383a327bea1$var$ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $b562a383a327bea1$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $b562a383a327bea1$var$DEF_WBITS = $b562a383a327bea1$var$MAX_WBITS;
function $b562a383a327bea1$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $b562a383a327bea1$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $9CLQF.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $9CLQF.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $b562a383a327bea1$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $b562a383a327bea1$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $9CLQF.Buf32($b562a383a327bea1$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $9CLQF.Buf32($b562a383a327bea1$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $b562a383a327bea1$var$inflateResetKeep(strm);
}
function $b562a383a327bea1$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $b562a383a327bea1$var$inflateReset(strm);
}
function $b562a383a327bea1$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $b562a383a327bea1$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $b562a383a327bea1$var$inflateReset2(strm, windowBits);
    if (ret !== $b562a383a327bea1$var$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function $b562a383a327bea1$var$inflateInit(strm) {
    return $b562a383a327bea1$var$inflateInit2(strm, $b562a383a327bea1$var$DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $b562a383a327bea1$var$virgin = true;
var $b562a383a327bea1$var$lenfix, $b562a383a327bea1$var$distfix; // We have no pointers in JS, so keep tables separate
function $b562a383a327bea1$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($b562a383a327bea1$var$virgin) {
        var sym;
        $b562a383a327bea1$var$lenfix = new $9CLQF.Buf32(512);
        $b562a383a327bea1$var$distfix = new $9CLQF.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $bxjQM($b562a383a327bea1$var$LENS, state.lens, 0, 288, $b562a383a327bea1$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $bxjQM($b562a383a327bea1$var$DISTS, state.lens, 0, 32, $b562a383a327bea1$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $b562a383a327bea1$var$virgin = false;
    }
    state.lencode = $b562a383a327bea1$var$lenfix;
    state.lenbits = 9;
    state.distcode = $b562a383a327bea1$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $b562a383a327bea1$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $9CLQF.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $9CLQF.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $9CLQF.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $9CLQF.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $b562a383a327bea1$var$inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $9CLQF.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $b562a383a327bea1$var$TYPE) state.mode = $b562a383a327bea1$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $b562a383a327bea1$var$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $b562a383a327bea1$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $b562a383a327bea1$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $b562a383a327bea1$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $b562a383a327bea1$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $b562a383a327bea1$var$DICTID : $b562a383a327bea1$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $b562a383a327bea1$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $b562a383a327bea1$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$TIME;
        /* falls through */ case $b562a383a327bea1$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$OS;
        /* falls through */ case $b562a383a327bea1$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$EXLEN;
        /* falls through */ case $b562a383a327bea1$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $5UMyJ(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $b562a383a327bea1$var$EXTRA;
        /* falls through */ case $b562a383a327bea1$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $9CLQF.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $b562a383a327bea1$var$NAME;
        /* falls through */ case $b562a383a327bea1$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $b562a383a327bea1$var$COMMENT;
        /* falls through */ case $b562a383a327bea1$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $b562a383a327bea1$var$HCRC;
        /* falls through */ case $b562a383a327bea1$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $b562a383a327bea1$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$DICT;
        /* falls through */ case $b562a383a327bea1$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $b562a383a327bea1$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $b562a383a327bea1$var$TYPE;
        /* falls through */ case $b562a383a327bea1$var$TYPE:
            if (flush === $b562a383a327bea1$var$Z_BLOCK || flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $b562a383a327bea1$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $b562a383a327bea1$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$LEN_; /* decode codes */ 
                    if (flush === $b562a383a327bea1$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $b562a383a327bea1$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $b562a383a327bea1$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$COPY_;
            if (flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$COPY_:
            state.mode = $b562a383a327bea1$var$COPY;
        /* falls through */ case $b562a383a327bea1$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $9CLQF.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$LENLENS;
        /* falls through */ case $b562a383a327bea1$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $bxjQM($b562a383a327bea1$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$CODELENS;
        /* falls through */ case $b562a383a327bea1$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $b562a383a327bea1$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $b562a383a327bea1$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $bxjQM($b562a383a327bea1$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $bxjQM($b562a383a327bea1$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $b562a383a327bea1$var$LEN_;
            if (flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$LEN_:
            state.mode = $b562a383a327bea1$var$LEN;
        /* falls through */ case $b562a383a327bea1$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $6OFFF(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $b562a383a327bea1$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $b562a383a327bea1$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $b562a383a327bea1$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$LENEXT;
        /* falls through */ case $b562a383a327bea1$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $b562a383a327bea1$var$DIST;
        /* falls through */ case $b562a383a327bea1$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$DISTEXT;
        /* falls through */ case $b562a383a327bea1$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $b562a383a327bea1$var$MATCH;
        /* falls through */ case $b562a383a327bea1$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $5UMyJ(state.check, output, _out, put - _out) : $gJUj4(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $b562a383a327bea1$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$LENGTH;
        /* falls through */ case $b562a383a327bea1$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$DONE;
        /* falls through */ case $b562a383a327bea1$var$DONE:
            ret = $b562a383a327bea1$var$Z_STREAM_END;
            break inf_leave;
        case $b562a383a327bea1$var$BAD:
            ret = $b562a383a327bea1$var$Z_DATA_ERROR;
            break inf_leave;
        case $b562a383a327bea1$var$MEM:
            return $b562a383a327bea1$var$Z_MEM_ERROR;
        case $b562a383a327bea1$var$SYNC:
        /* falls through */ default:
            return $b562a383a327bea1$var$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $b562a383a327bea1$var$BAD && (state.mode < $b562a383a327bea1$var$CHECK || flush !== $b562a383a327bea1$var$Z_FINISH)) {
        if ($b562a383a327bea1$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = $b562a383a327bea1$var$MEM;
            return $b562a383a327bea1$var$Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $5UMyJ(state.check, output, _out, strm.next_out - _out) : $gJUj4(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $b562a383a327bea1$var$TYPE ? 128 : 0) + (state.mode === $b562a383a327bea1$var$LEN_ || state.mode === $b562a383a327bea1$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $b562a383a327bea1$var$Z_FINISH) && ret === $b562a383a327bea1$var$Z_OK) ret = $b562a383a327bea1$var$Z_BUF_ERROR;
    return ret;
}
function $b562a383a327bea1$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $b562a383a327bea1$var$DICT) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $b562a383a327bea1$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $gJUj4(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $b562a383a327bea1$var$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $b562a383a327bea1$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $b562a383a327bea1$var$MEM;
        return $b562a383a327bea1$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $b562a383a327bea1$var$Z_OK;
}
$b562a383a327bea1$export$42de45683a92ba94 = $b562a383a327bea1$var$inflateReset;
$b562a383a327bea1$export$7633ac2cd30f9650 = $b562a383a327bea1$var$inflateReset2;
$b562a383a327bea1$export$6710ea52c4ec9d6a = $b562a383a327bea1$var$inflateResetKeep;
$b562a383a327bea1$export$9c140b25e26874f9 = $b562a383a327bea1$var$inflateInit;
$b562a383a327bea1$export$6792d92addc5c8a0 = $b562a383a327bea1$var$inflateInit2;
$b562a383a327bea1$export$cae1ce83fe4a1782 = $b562a383a327bea1$var$inflate;
$b562a383a327bea1$export$224e1a443c3fba76 = $b562a383a327bea1$var$inflateEnd;
$b562a383a327bea1$export$6d4647cb9e1c75fc = $b562a383a327bea1$var$inflateGetHeader;
$b562a383a327bea1$export$60da749bed98ccf8 = $b562a383a327bea1$var$inflateSetDictionary;
$b562a383a327bea1$export$220f6291ca35fd71 = 'pako inflate (from Nodeca project)'; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 

});
parcelRegister("6OFFF", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $4f67bc996330e695$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $4f67bc996330e695$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $4f67bc996330e695$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $4f67bc996330e695$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $4f67bc996330e695$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $4f67bc996330e695$var$TYPE;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $4f67bc996330e695$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};

});

parcelRegister("bxjQM", function(module, exports) {
'use strict';

var $9CLQF = parcelRequire("9CLQF");
var $86622ca50c32b2ec$var$MAXBITS = 15;
var $86622ca50c32b2ec$var$ENOUGH_LENS = 852;
var $86622ca50c32b2ec$var$ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $86622ca50c32b2ec$var$CODES = 0;
var $86622ca50c32b2ec$var$LENS = 1;
var $86622ca50c32b2ec$var$DISTS = 2;
var $86622ca50c32b2ec$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $86622ca50c32b2ec$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $86622ca50c32b2ec$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $86622ca50c32b2ec$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $9CLQF.Buf16($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $9CLQF.Buf16($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $86622ca50c32b2ec$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $86622ca50c32b2ec$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $86622ca50c32b2ec$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $86622ca50c32b2ec$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $86622ca50c32b2ec$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $86622ca50c32b2ec$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $86622ca50c32b2ec$var$LENS) {
        base = $86622ca50c32b2ec$var$lbase;
        base_index -= 257;
        extra = $86622ca50c32b2ec$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $86622ca50c32b2ec$var$dbase;
        extra = $86622ca50c32b2ec$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};

});


parcelRegister("hf4Xu", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};

});

parcelRegister("9t6AE", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $6e4bef2851e6b301$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
module.exports = $6e4bef2851e6b301$var$GZheader;

});




parcelRegister("3uXKw", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("7ybLn", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("fCZVO", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("cOHfc", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("eVbDh", function(module, exports) {
module.exports = JSON.parse("\"eJyNnVtzG0eyrf8KA0/7RMhzJJK6+U2+zMX2mJYsEuJMzANEtihsgYQMEITaO/Z/P41CV+bKlaug86JQf6uArsrKXNVX8H8m3y9vb7u7+8m3k4t/btazm+7o5PmTZy+PTl88eXk6eTT56/Lu/tfZbTc0+Hu3eOju51ezb75bLq532maxYO2oarPb+aJndRCm3fzm425/Y8N/3M8W86tXdzeLoeXjYXv91/mX7vq3+f3Vx8m396tN92jy/cfZanZ1361+73af/PHLfXd33V2/Wd7O7sY+fvfd8svk239/8+T540ffHB+/ePTk8eOTRy+fHf/n0eR8aLxazO+635br+f18eTf59ptBBuHtx/nVp7tuvZ58+3TgF91qXZpNHj8+/svjx4+Hnfy6HAawG8z3y8/9ajeGo/+6+j9HT16+ePpo9+/z8u/L3b8vH5d/nx+9ul6+745+79f33e366B93V8vV5+Vqdt9d/+Xo6NVicfRm9z3rozfduls9DNTDOF8fzY7uV7Pr7na2+nS0/HD0y/xued9/7r4ZGi2OXv3taHZ3/X+Xq6P58AXrzfv1/Ho+W8279V+Gzv447Op6fnfz+9XHrsxA6cnv98NHZqvrqg4Nv599/vs4Ic+fvHg0eVe3np4cP5q8Wl/tAr0axR862/7m+PHzR5Pf76//Pp18+2QnDv+/2P3/9PF+vv7Z3a/mV0NA//0/k+m7ybfHz4dGvw5dWX+eDXH830d7fHJyssfdl6vF7Nb46fPTPf9jsxzi9X5hytOnz/bK3eb2/W6ibu6ydr1cLGYr4y+GiSn8c7e62qV7FZ4fH++F2e0grYf4mGQdLj0oM557/Xm26u4W3YeWRB+r3Zitd9+4/uQdfzEO9/Nis85duBqqdJZ38bH//LG7y82HocyXYiTrxWz9MQfrz261zHR512V4vxUt7z+uOtH2w3KzEnT+INqu518E7B46MbddiKmnw/xOpNXVcrG8y3jd3c6jZDOw2NlAot0fm9ki45tVN5SzD/PZkyc1abp1sZqqvHz+dJx7kX2vMvouo+8z+sH3/Oz5Hv2YO/NX/2BNhb/l7/p7Tph/5DD/lD/4c97jL156NeT/zB/8NffrLA/ot9zqdf6uN/mDv+d+vc0fPM8fvPBZOx0neppbvcvoMu/xXzn53g+L2afuPtiGhfz9oMU65c9FT7FUnK2v5vOr+epqc5tnbbOz7fWw/nR5j8XfQmfsY7M8nve51VVudZ1bieL8kD94k9HH3OV5Rv+d9/gpt/IStiXhNu/xLqNlRp9F1WerFxa4zpG4z9+1yR98yJWwza2Ek/aOdsc9xfRzV3f5FRPh+MXjmpWrRvtD2Xg/X1w3l/rr5VaYe1idPWL35TjNk+NJrbgPuwND9Fkfs1o7PiyWq7ng667xLVeb1bCMX3kAj0+wbNbzcuCaoluPWnRZ3Wzmg3K7vNdHDju5fPFX5Bh6S5wPc8HE8dNwKCcPB65nNzedSNs9x0MxOuDYzV236kTtD8dCs5vV7DOY2tOaWcNJRCd80MP7frY+EOHD6kofK9gERH04KRg/Pxxizz+v52shDWO9/7jchGPFtOyH5PaZW80eRD3Mrjb36tClePmHRfcla43Kup1drdThzvtVp3Z8vbyfXYWKc2k+zCQGwJQV1qF3trseQqqOUTd3N7PV5nYx24jdLG+Gw8xP4utmOA6Yl9uQsy688sOek+cjW66uPwzHeeHA0I9Q4iLrByCR+x7OYA/Pntoebgen2yxwF7ayzMRie70r+vVaLGCLuGNfeSK3I5KlGNRQn8Mp8ZD34hziH2lK3QliBvryH/PGlyY5qf51cfb86Cj3oC4X1/OHOSS0fyT2zA+YRXF4txsfOj/0ob4Rg3U596IygaHmr/T9hVJx3J6IGdWDfyb2zmeCPuBnAWknfs4weASchBxXJ1YDfX7yvIrjVQ+xK3IdXztjHvgodVx+VR3w8mjlaDRVP9KXw7FTqda3RWOFcCarhAzRw1yzJ/rha9z76ct66rn8s7u7EZn7Ju7Cz+LUID05DhbJocx9xQuJHc02xnrFY/Xznxw5i+rbj8uVGNUZ7d3DQFVgJ3pU8Kd1EaOwWTXRDjxienErFzjWm3KUsxL9jSnoUWzxaKtmgrebxf3886IX/WqU/9s4QEuk4Xjrfj5bXM8/fMhz1bet4de4H09YkSxeGwfT7MCq05auGuO9a9lgK2N+jQHyxZDqHy+/DUcMeA3OToFWy0/dHZ4ImTmuupv5Oh76eonGyYblONdFPdRYb4aqDucjHmw6hrTCbERm2Ur1fzU+8C+q8NOX9di1XOmK18Eszj/ef8zw+6YBLpRv2VjuGybTNVfHlvCqdfhwICtjgP18uVUavG9zhdaMtJae1jK6bu0517Ht++BhCa+Y9bigW9wLA78PJu2euF0ecMTUNfu6240YSWMNX8rjTK8FPvixq0/xCOfFySn4+JDAqyGR1/n7fud8Pa2Tv2gsJD8fXH9/iRPnpxJ2X0eZYrIFt4wYJuetGv8ldtviMETt42wBS0Mt8t2pSaxwnwu1BJgvx8MmT7WvTGCjFLrWgG6imeKAxmlVs6rPRn6XB4iWwbLnlhDXg010KmMbS/731AlbuMhtTs3Or+dXymh/iF8EB2aHDnd/pcNa625j3t4czuuD+3rV+M5XTZOOpwM2A/F73IgPHFD+2Fruad9+iVie3dkBWTwSsG87WAo0QeaXB/e0WN7s5vtuKcK9bJvpJq9jNYOGr2pU8s3Bye1gJfeYN9L3Tq7jdnHnLh80u+e3lrsfN7u7kf95NPm5W939NpuvdveQ/z15tbtbPXn0zenj/zwat/buEdC+nxGNpo7wb8PWU9/au0pAODAUzsL3nOUu4NIbuE1VoPv6Dyg4T1DGkAW2vzoU0L5wEL0OW2+HrZe+VWOGKIzehfMQi/M6ekBh9MBh9EDr6AHR6EGx0QMb6zqwYidILoatF7Y1Hbae2dblsPXkiW/WISGDvgPeDJsnvlU/CCjEAjh8H9AaC0AUC1AsFsAsFsDGWDh5CJmwDVoft/KI+tzzsRGWpiEqDuNUpM65UqsC5WqIata4LNyqnuXv5hI2rurYxFzMJlFFG9dlbTLXtglU4Mapyit/nRHUuyEqeueq8qt6niPKHmBcGYGJ2Q1MIkswrn3BZDYHE9ghTIg2UTF4RUVgGBWhaxhj6zBB+EfVwEQMUd0ZV3ZiYrsy2ViMa3cxmS3GBPYZE6LZVPyQE3KbW/UCNQIhXGg0A3QhQ1TfxsmFnLMLVQVcyBC5kHHpQlU9y9/NLmRcuZCJ2YVMIhcyrl3IZHYhE8iFjJMLVf46I3AhQ+RCzpULVfU8R5RdyLhyIROzC5lELmRcu5DJ7EImsAuZEF2oYnChisCFKkIXMsYuZIJwoaqBCxmi4jOuXMjEdmWyCxnXLmQyu5AJ7EImRBeq+CEn5Da36gVqBEK4EIYGrShyqvQokimRyM4UZLCnyMmjoiiNKjQ5a+yPLSuKyrdii2xeUScHi6K2sdiGvSyqZGhRJFcL4usGB3+LnEyOROV0ocl5Y17Y86KojC+2yO4XdbLAKGofjG3YDKPKjhjVaItBA28MHAwycHTJKLBVRlX4ZWgAphk5GUYUlX3GFl/xFTbSKGo3jW3YUqPKvhrVaK5Be2jUxbbRvm/xQ/ETrusEPRcpGRVK5LdBYrcFEbwWKTktStJnocGZ3A97LErKYVHP/ooquStK2luxBTsrauSrKJGrgvRaUnBUpOSnQVJuCg3OZezZSVFSPop6dlFUyUNR0g6KLdg/UWP3RC16JyjgnEDBN4GiayJmz0RNOCbI4JdIqdpRUl6J+kEvYJ9ESbsktmCPRI0dErXoj6A8yAzfyra9pu1ICVccR4+WaIhMxTiZoXN2wqqADRoiDzQuDbCqZ/m72fqMK98zMZueSeR4xrXdmcxeZwIZnXFyucpfZwT+ZojMzblytqqe54iypxlXhmZidjOTyMqMax8zmU3MBHYwE6J9VQzeVREYV0XoWsbYskwQflU1MCtDVH/GlU2Z2K5MNijj2p1MZmsygX3JhGhKFT/khNzmVr1AjUAIF6p9RRtyRhXuAhkRCOxEJoEVOSMvckGakcln4vvZjlxQfuRqNiTXyJFc0JbkOnuSK2RKLpArmfBaMPAlZ2RMIChnMvlcxJe9yQVlTq5md3KN7MkF7U+us0G5wg7lSrQo4+BRxsCkjKFLOWSbckX4lIlgVM6oQF1QVuXqgfpls3JBu5XrbFeusF+5Eg3L+IPI1a1o1yvWiolwrdoxdC1nZAQukGuBwK5lEriWM3ItF6RrmXwmvp9dywXlWq5m13KNXMsF7Vqus2u5Qq7lArmWCa8FA9dyRq4FgnItk89FfNm1XFCu5Wp2LdfItVzQruU6u5Yr7FquRNcyDq5lDFzLGLqWQ3YtV4RrmQiu5Ywq1AXlWq4eqF92LRe0a7nOruUKu5Yr0bWMP4hc3Yp2vWKtmAjXWo2/6OG7q4RMoGLyK8PsVqMAXlUJOVXF0qdG8Sx9L3tUxcqhqpb9qSrkThVrb6oqO1Pl5EsVkyuN+HUi4EiVkB8ZVm40iucphuxEFSsfqlp2oaqQB1WsHaiq7D+Vs/tUHr1npOA8IwHfGQm6TkXsOZULxxkl8JtKqLIqVl5TtWbNsc9UrF2mquwxlbPDVB79ZaQPKeu2qU2fiR69cJUx19FWDFHhGidjcc7OUhWwFkPkLcaluVT1LH8324tx5S8mZoMxiRzGuLYYk9ljTCCTMU4uU/nrjMBnDJHROFdOU9XzHFH2GuPKbEzMbmMS2Y1x7Tcms+GYwI5jQrScisFzKgLTqQhdxxjbjgnCd6oGxmOIas+4sh4T25XJ5mNcu4/JbD8msP+YEA2o4oeckNvcqheoEYjsQt8N9FXcip8tqDoGIBHSwvUeYiALoiAVRvEpLISmkFq+jnbV9cS3LJ0che4CxwRzWrsLiKYcFBsIMBsIsHEge/LDGPdT34pu+gPGHZDw1h8o7kCjo/4Q4g7Mugts7C6QaJs/jCXvW9OwtSv0575VRwcIuux0/3tsdXJ3ZPzJNUOj/2L4DFEMjVMgjatomphDahLF1TgH1wSOsAkxzIYp1pVfZDTNCEJviOJvPE9ClWgmKk7TUV4IjNNREU9H5TwdlcvpqKKYjirxdFSepqMKaTqqQNNRMU/HyC8ymmaE01ERT0flYjpGiadjxDQdfx1n4oVv1V0BqvEHFEIPHDoEtAYckMUamIUZ2BhhIDW4jnbjPPatOgJAdQSAwgiAwwiA1hEAshEAsxEAG0cApI7AUZ2tJ48N2UyN7Kdxqo59Kw70J5wqQGKgP9FUAY0D/SlMFTAa6E8wVUDiQH+CgTqxcTraxK08zE1jTBs5pk0eEx+SgSJGuxGj3YTR/jzZn/Kc+FY8LipIHAQVng6CCo0HQQXJA8mi0OFRYfV8BlA8Ftqhctzy1LbsWMhRPYFBFA6PnOPhEVB7TTRgO2py5MdGzvzYyNhyNwLfskg7ipF2jpF2apF2xJF2xSPtzCLtyCJtaBPivsn5oc47fp6oU46fJ+ls42eR1aCI/ODTi58nfGaxI70tUGUrLtEFpYU2vIsf6oIECgGpKhrUJAeGGlCMSNXhokYcOZKpyEileosqJD8JVIWkUkGyKmqTmuQy5Qa5YqkFFS+pXMckc0lHGaqbBCp0UlXNU5Nc/tSAnIBUbQrUiP2BZLIKUsk1orppJRJ7CalfLyThMNTgYCE1fIcaHS6k5EYkR2OKIngUCWRXpCbn+mWC1/DKVrx8t0fiyt1O2B3ej5eddptTO0bdbZULWce+aSUODOvScfwFzUE6jZLgfo3nl0m6vPPLRF3Z+SW/o+qIgnDwHVVTMRz4BueLiDAw+Q1OFkSIqtaKU9BbYp8DwWFrv/X4S8wriCAJFEdWVTRjG4xpVCCyUcD4ksJRJlnEOrZoRVy0Otykb4WS56BdwGOD0V5xDgxR9J2ruFcVI14ZxLoijLIxjq8JIrJVa8U06C2xz4HgCBpPsRuO08oJ5lPfirccCop3gwoSNyAKT/ceCo23HQqiWwqF0d2EwsKNhELqeunorZn5Gc45ojDdLlyE75mGrXdhy6/QnE3SxZmzibous6P13Nd3aee+I6oWA9NgiObCOE2IcTUrJuapMYnmxzhPkgk8UybE6TJMc4brDoWBZ6+x7pB6kb97mtG7jGBa00LEPE9wlWiWK+apDi9TwXxHTpMeRZr5KKrpjy1yDkSdEiGKnA1R5ZSIasyLqFFypPc6VfQ4TQ6916maXDT2N23wdw0O+aNfb5RizqSgUzoFjXMKXkSBjEJK+YQSZRNKKpdQz5mEKuURSpxFqHEOoRYzCBXKH3qHLceJc6f9DltucCH3M5X0naSQMerVLiHlbAGVcgUUzpT6pgCkiSHKEeOUIMZVdpiYU8MkygvjnBQmcEaYENPBMOUCvuxDYeAsaLzsQ+pF/u5pRu8ygmlP78YwzxNeJZrtinmq47k5zjgrNPEs0/yzrNKA2+Rs4BaUFCxzbrDOKcJ6zBRWKWFIftuMKadPklUWUaOL5n6nTeVdU4EMY4USjeWcb9SC0o5Uzj57uh/yzhllnAuUay6oLHM155drlFkucE65wtnkSswj55RB4UUejghnTetFHpYvxPdPBXsnGORFft8lCTkXTKMsMM7zX083YfoN0ewbp8k3rubexDz1JtHMG+eJN4Hn3YQ47YZp1vEaBIWB57xxDYLUi/zd04zeZQTTnS5KMM+TXSWa64p5qutTYzDVhmiqjdNUG1dTbWKeapNoqo3zVJvAU21CnGrDNNX44CeFgae68eAnqRf5u6cZvcsIpjo9J8k8T3WVaKorpqn+bZzl8cmE33CGkdXZRUZP1rkQHq1z7M/WOYNH6BzCM3QO7SE6R3UGgflzMmUrXjErKD7RWJC4q1J4uq5WaLx/UhDdDymMboIUFu58FBLvKv4G8zZeTdyh2KDLg7L7iIj0oDo5qHCbEHAeayfG2omxLkOK2f0+QOKRr8LTrZxC44NeBcmHw4tCT38VFh8JLyg+2/UbVscY/dcTfMS0bMVHTAsSj5gWnh4xLTQ+YlqQfMS0KPSIaWH0iGlh4RHT155GPow6tD15M9nfzYet+GxOQeLZnMLTszmFxmdzCpLP5hSFns0prE4RoPjY0ZvRn2GrZj6i4MounMetPN7zxnjP5XjP83h5IkER4z2nZ5HewEQ68WXkzQQfMnwzrhSuXcal+Q2tDyOtVzFh9g1RSIyruJiYg2MSRci4DpPJHCsTKEGMU5bgdWhGlC+N69CkngvUiJXMIRPbseJsMn44VimvTODkMiFmWL7UbghyDa+rUyvOOnVdfZTqg8SQeoYonMZVOE3M4TSJwmlch9NkDqcJlHrGKfUqfysQpZ5zlXpVPReoESuZeia2Y8WpZ/xwrFLqmcCpZ0JMPXy0nTIEUg8fbadWnHrq0fYqpefYjqXAoT3wHJtuIsKsn2PTaiPkjefYtMypqp9jk+rbpsDJe+h5B9nmvCkcjLlO6tjkazFPCR7V/5+Y52SPckr5KFPipwdBZJZiEaTnQOQnUkE0nwLZNximu5z9vfSt+g2A6hkToDApwGEPQGv4AVk4gVkMgY2BA1Lz15G/oPoWSxiQONV4S8UKNJ5qvBVlCQqdarzFAgQUTzV2aHeO98K34rsaBcV3NQoS72oUnt7VKDS+q1EQvatRGL2rUVh4V6OQ+K7GDl0tFzTyeu7qbXafeOZbdZSAqrEgwlECh1EihVNXwHXwgGzwwGzwzj72nz925Zzr2NgyjGqZZ2vZmJqlnJplnho+nQVFTJqdzgLKM2Sns45WcSsPZBW93IV1dzvPU74JpbjJ9rFpeMVGesUmewU/kgqKcJGNcJFNcpFtmPA+buUk7XPm4buILwlRENK7iMxVhNS7iCxRrPK7iCxwbPhdRMbktXj8fkqIXFcfv7OY/TcdvzPXTpyP31kgT07H78TBxQxRrRgnnzauHMHEbAsmkTcYZxswgQ3chOjihsko/LXPhQodmXrFXa4Ftnfj5PHOhdGb2K45Zfmmke8bZ/M3gVeAKqRloArLHAxeEIwfygGxNJjUyIHGImFyK0V4uTDeSAVeOCpfCdQYul5HqioWkyrBimKo4ahybTGx7Zy8yhjXS43JLWNNi44J2li3Odt6gRrlpFajcKCPa1IUOI5R5fUpqjLWsYmIeGzAcY9qCm+UU5CjTKGOIq9k6XLAqRR4VTtwOUA3ESucvhyg1cZq17gcoGVe+fTlAKmi7UeBiz6qvCJGVXpibCKcMTZgf4xqssEop/UyyrRqRpENM6jsaCTGdTS+SNeq5bSmRpVXVlLV+hqbfM1L5FobW/CKG9W07kY5rb5BzmtwfMmuFc60Hkf16xmo1ubY4GAGttbp2OhwmqY1O6oHEzGt30FdNYWDYWus6KGNWtdDA1zdo3BwbdIrfWzytdUnrfpRbaz9sdHhJSofB0T50BK1bdVA3xQOWkM+Sjif4BM953g8ACg+x3OeVn7g6XriOa7xgOiZnfOwmgMLT+qc47rtqNroiRH6IZR6PRnH2nj1xjmN+tCrNy7m8TdevXHOkWi9euNCjEnj1RvjFJ30ysrIG6+sEKdgHXplhUQVtq+8skI6BfDgKyukcigPvLJCGgVVvr2hIsjhlW9vBEqhbb+9ESQV1oNvbwSVQnrg7Y2gcTibb28EhUIpXm3IseIw5lcbHFEAG682OFeha7/a4BIFrfVqgwscLv1qg2MKFL8SQKHgEDVfCUgKBezwKwFJVuH76isBqQUF8yuvBCSdQ3vwlYCkUqAbz8LruHLYxbPwwCjUrWfhQVDhPfAsPGgU0uaz8KBwGBvPwgOn0KVHxzkqHC77iW0IlzMKlwsULhdUuFzN4XKNwuUCh8sVDpcrMVzOKVwmULiMc7jGXw6GYFVCoaqYAlWxClPVcpCqQiGqmANUOYen8hicSik0I6bAjJTCcjGG5IVvxdOVCwwFIHG2d0EhABrP6y7C0IHRNYQLGDKQeJK2Q/6zzGUrzlxB8SzLhbO4FVOhIDHfhae5LjTOc0Hy94KLQrNfWD0/BRSnd4d20/rMt+IpS0E1BIDEdYvC0ylNofH6Q0F00aEwutJQ2DhjQOoIHMXT2YtJekR7h+Kguzw5dqUGkZ6vTs5XuBADOE9jJyarozLdMbu44tm5u6Dy0rfiKXlB4jy88HTyXWg84y5InmYXhc6tC6s5Biheyr2Y5Ke2dyxfiNjRTZjZTc7GTSP1NjL1Njn1+DICKCIpNyIpNyEpp6PrwVbs9RRdD5AYyJRcD2gcyDS4HjDq7hRcD0isoekEH7iboncBEo95Tcm7gMYHuqbCu0ChR7em6F2A4oNx09G7Tn0r3gyYoncBEjcFpuRdQOPl/2nwLmD0q7VT8C4g8Vr+FLzrCRC8Cj0drWv/I2VTtC5A9nYJoPwLbVOyLqT4donj+BNt02BdwPztEmNmXT7UZUi4ZS6SZaMilrIilrki2LpAEbVi1gUoFwZdqJ2Sc/m87Zzr1MZvzgUoJp5zTDynlniO+GaTK56SzjwlndWUNNKHeupz3fepvi9Hwxt/qekSHQ+ZvZEGLL6IAwK+iQPYXsUB5m/cAPRXbgDWd24A2RtpznbW99y34ot8l8n6gKd3+y7R+gDRxIFigwFW8xJQ7bajmS2wl2h9gOLN4stkfcDTscElWh8gOgK4DNYHLFxHv0Trc1RL6CmQW/xl5svR+174VjyfuETvQ5TPJy7J+5CC9wGOpxmXwfuA0WnG5Wh0MARzOmTq1cxL8jrE9GrmpXA7lPitzUv0O2T0hublJP8Y9iVZns/XJjbaiIFuWgPd6IFuxEDZ91BSA3XnQxhfT7206/RgBukmRBLY0/RtiKQKd0s3IpKQfC7fikgKOV66GcECeF96x4y5ckH1jhlL5Ietd8xYZmdM75gxJ4+sHIzSELmlcbJM48o3TczmaRI5qHG2URPYS02IhmqYXNVvMoVS5XtPXANgc4bIaY2T3ToXnmtiNl6XsvuaRhZsnH3YBDbjKizFoJMtmyAty1ThW6axeZnQcDDTk42ZwqZtAjt3upPIgvDwKm1E8+TmJhyMj/J101rxaTm86c34ZK83hQyfbvlVJ1T3/JTGzt+866caCP9X9/2UllYBeedPibQWqHt/QoMVASktCiipdQH1vDSgSqsDSnqBwBa8RqBGywRKtFKABIsFUlovUKIlAyW1aqCeFw5Uae1AiZcP1HgFQS0uIqjQOhJuBgfHELeJRYGBaSOlNQUlWlaCJFYW1PPiEtS8vqBMSwxKvMqgxgsNaEsdkrTcoCYdFRsIU0WZfRW1hrVik+SuKPIChBqvQepRAaGJlQjUjf5QWo9Q+1oA1aqE8oEAttYmbHIogHmFQjEuUkM5TfxXQsqW/66PoXj/yYXd3yTc/5WH3dY2bPl1nrIVr/MUlK7zVNfDHhmibhmXfasqdLCibUZ97gH313ju9Ngx7LQh6rRx2emqQqcr2mbU5x5wp43nTodnlaDnkVP3oyjHEJrAQALfNnjf6B+PK4p5cJDuMDSkNDCU5LCgAQwK6FbSXvaJh4NSHkx9zAdGYoiGYVyOoaowgIq2GfW5B9xv47nT9tgH9NoZddsF2W+ToePGtoL1oh/cdxdy5+0hDOi8M+q8C7Lz4c/Tjx0Nf56eWS/6wZ2Xf55+1MYHJaDrlVDHK5bdhr96PXYQ/up1JH3aN3dX/NXrUam/QAe9NUTdNS77i38kd+we/pFcQn3uAfdZ/ZHcvfR+oAvbc9ny4wRDqpdF8IObijbhq+nv4b1PxxrAZd/o7+G9FwcUoNCN0Pfh8AFY+LWK92OkfauPW3kMOY5XA/VA7LY+Be2T+gGRqzH4sBX3dZWDD0K8xXs1dtx70MeZvKKOj7QeC3zMCIZgSPamqguBaETGD38RjQ2PbaiTPEp1bDNK9uJrRjBUQ7KHVV0IREM1fviLaKj4viR1koeq3pes0nBat1jMaLAGcbgOdT9NX0jIg3bla1/HAzelV11Og3clD39/cjRZf55d7T5yOtJywp3/bM1xlhta/MLh9GxybTstW1f7v10LyE38Ovj3dR2ob9kIHeHQ9nTcA+7YEO298of86W1GvUDUI+OpW7uKG4O03zleSj028hA+sA1bX8JWH7diR1J97yldpx87whd2jyN+yJ/fZvQlo14g6qb0or1EPz4w9pVfTz+O+CF/fpvRl4x6gaiv0kxGSbwmUjus3hI5FtpD4+u2Df6lwfsW5+G0zqpGPV+IG0ckrsEcJ+VBftFW0i+S9prSKBonU1X1a3M8CFB4FCA96O/aavxF476BeSio5bHQayHjOPitkOOIH/Lntxl9yagXiPqrzgdHiV8PGDub3g44Jv4gvmIr2BfBesWoy/I0cNT4Gf2xz+kR/WPiD+IrtoJ9EaxXjPosz/722ocJXiSvpItb8aigoHotHFH+AePC05HDnuKflHUcf9e4IPr14sLo14t3bGlHOWUrHjIVJE6KCk8nGoXGk6KC5ElRUeikqLB46FVQfDr0wyRcgq6IDp1OohDozX6unvjGOGwg40whgTgA9jAg9GkCOsYGSA0AoDpHjvykXVxeaF5aqO1gpEbicA3HMTvOAzctjd6VFAKTYhwMUzCMU0TyZeCbxmXgm4OXgSOEMOkfgdBiDNmBn4DQLVL42j8AoRvEUDZ+/kGrFNao3rTCxCEmVQW6/knNY9+KNsN/SHNPP43utHfcT+hOgKJ9Ok+W/QndCRDfA3LFHdSZXVVyZHfK9ij/SoYWaCyHfiVDN8kjbPxKhlb1uFu/kqFlikbjVzL26iKszouwBi/y6ruQ6+4inwct8knPonHSs2if9MQrAvj1+QchtEC7av8gxNig/v2XbUa9QPT16u/P7qXbCV7pLFux2goSi3rhqQoLjYt6QXJRLwot6oXRlc7CwpXO2wn+2d1bHDEg6N2e3k3qTWXbikddd2mwwNMh1t0k3DA2JP9GxN0k3h42RkdZdxO8GVzJ7uD11LbcHsU9FH335C4+4RURBaH1fFcUczjE012R68CoZ7uiwCHKT3YFDMHKt5LvUrUzz7HD37t7Qohip3/vjsUcu/R7d8x17PLv3bHAsePfuyMMscNLLhQIjp265FKl9JtCT6TAcTzwm0K6iYip/k0hrTbi2/hNIS2nWMvfFJIixj0tITKUaQ6aS8jYoN47gzkwRNE3ruJuYo64SRRr4zrKJnN8TeDImhBjivcbTyPqcyA4gu2bi8sJ3llbhnV4t+V/uGkZdrXMe1nqHaB3EYJd4UXck9iqzx/kPbcdbpmucCoOHUlXOE9E+77xPdyvrzw3Aoeu2DV5uRIpdEs++xEodengsx9LvGpHCLqCV+1OYqs+f5B70H6Kg47FsRekQGdIgT6R0je/jXvIcu5ouF7IDDoXrheeULtefJa7cuCxkXrWgX3IB9OGoAd4fE0f5P2r4+tRQksiBLuvCHafjWvZMK5l27g+T/D84DN+FlA6K6gXzFp3GKPeEuM9RvoqU1+4uug+3Ncv3f//m9NnptYPXscPGa73DIXmN3wjjnGMmrrpG1vEa49BC3ERY1jFsBiuHVJavRostdBZ0WI3t88ErjtUWvzFUtLqTWuthu6oFnnyq+SFMgRp96wHbsUJK6j2EpF1DuB4/f2ZkeugW/o4urF6KFt2KcsRXb8ywV569y9bxq08EHXlvPBU1IXGk+yC5El2Uegku7CYvQXFK+c7ZFfOPWx/hAbrMO51NJcVZhEimx+EjVje11s5ZSO0cv5QL0yu9oYHG+GC7Cra3QjtdrsPzRBNlHFKO+ece3Qvv0ay4uvcklPRnqn2uBiipDQuo2lPSFF6Vr4UqDF+ma0m5pQ1ifLWuE5ekzmDTaA0Nk65zM9O8DT8kZuuc+A4v41TkjvnTHfl0AR5bhtRiQ8nDZTJfSaxDsS5wKjY8xweEUOUDMapGJxzMfBfqngW8XVuycVQORSDISoG4zLW6Y9H0A6WAjXGL4tB/e0IlqgYWn87gmUuhvS3I5hTMaS/HUHT8Eduus6B42IwTsXgnIvBlUMT5PluRBUDXMGiTO4zicUgLl9VJVxUwZKIAidGVLk8SE1FEnUqlSBetz6Vyibfr3uqBC6hg/frVJtUTukGlxYORlAXWPMGl27AxXbwBpdulApP3+DSKhdhUFMpBvWP1sfWrWlIxRlVLlFSU6GS/vU0gLqMXJYuXwqV1de3OBVz6zroXo/Xi2qYEOUHEj0gATbuAcJLjXQKPG6Vv905vuhnyJ/1IU63yIN6YadQlUwT2f0JyvHM3JAlB3G8EBClevY+npa/yOKo7PN3mMOJO1rZigVeUDUbQKLQC0/VXWgs6YKoRAuj+4mFhfuJhcT6fADrfWFk518nvhVvOj4kpwKebkY+oCcBIiMCxX9xzVm1HEB1HI7op8u2MLRTI27N2+zH24YJb6XzbrPdbpseuxXGus1uus0WusWh7Qeyu4Ls9x3KVry1UVB8rm6P8o2OwtM9jj1Nz9UVHO96FER3NAqjmxn9WCsnvhXzqsdaASRSradaARpTrQ+1Asx/ws/ZWCtAYo71qVb6MA99noc+z0PfmIdezkOv56HP89CLeegb81CK4KltWRE4ikXgHIvAqRWBIy4CV7wInFkROLIiMET1XRdEzCpDlFrGKb+MqyQzMWeaSZRuxjnnTODEMyFmn2FKQb7MQqGAdDBEGWmc0tK5yE0Tc4K6lLPUNEpV45yvJnDShms3TyOi9G1cuyExJ3K+dkNcp7S4dkMCJXe+dhM5pzncpINMR0rJjhLlO0oq5VHPWY8qJT5KnPuocfqjFisAFSqC/C6IiBWkG1KqBpSoIIIkagL1XBZBzZWBMhUHSlwfqHGJgAZVgpQKBSVVK6jnckGVKgYlXTTYgusGNSodlKh6xGtAY1L8OYHnmP+EHAASnlj+k2ccMJ9n/UnzCzQ8hfwnziag+Lzxn+DjTGKn2cUTzt0XHp6UNBB2cMY0pOTfI68nm10mcVyG47gc53GZlsblShqXSXFchmlcxmlc+JJUp2kcX5DiGKOUxxn0NNaopvEGOY45SDTuoMHY//O//w/7Vd1G\"");

});

parcelRegister("g9ZKL", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("hgkij", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("4W9K8", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("gbK7N", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("lan6Z", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("1zetG", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("53nEH", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("fhfja", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("enbPQ", function(module, exports) {
module.exports = JSON.parse("\"eJxtmNtu20YQhl+F4FULyMGeD7pz3AY1ChtG7NpFA18w1NomIlECSRcxgrx7SVk7+wOdG8H5OJydf2Z2d5gf9cV+t0v9VK/r+6vXsXlOlbHe28paq229qj/t++m62aXZ4J/m8PRb1z9/baZxefK63Z6eXN5dVMvTCh83u277xr/6kLrnl2XNq7TpXnczuZyabdee98/b2VzM/x4/dd/T5qab2pd6PQ2vaVVfvDRD005puE3Lu7eH1HbN9hTjx4/77/X6y5lcnUmjVzHIVVDicVX/1W/SsO36dLMfu6nb9/X6TAoBD+5euvZbn8axXtuZ36dhPJrVQqgPQoh5hev91LWLkIv94W1Ygq9+aX+tZAx2tfz64284/sblN/rqfLP/mqrbt3FKu7G67Nv9cNgPzZQ2H6rz7bb6vLgZq89pTMO/M/xfEqturJpqSM/d7GJIm2oamk3aNcO3av80O5xh3yyKmm1193ZIT02bqovTKjP+MAf++7zsZvZ3276kYyWWXB0z99S18/PbafPHQ71W4fjn/fxnFO+ZvkrT0LVzTr78qB/+nk38bHM9exgP8zr1z9U7jt6840YW5uSJKcZOCaBBnKgm5mU8MVNYyMwWFvO7Ukagkmgg6sDWQ5yFFqjzUrLEaQ3BEmiwNsMSaZS0vgWfOkPHWQowNeTUc0kumnxZvsgPxlGai6VTGUqAVCTQ6QkWnc77DKEiLktSUBJKqHIQZ86d8gCpHYoiEzMsb1ubYy8vW50DChB5ZhGqrijD0EqUIeiaEHIfCg5Kpuu0ApiToaGPSY0uaQsyr65L2oKi1yFt1PLaQ3lzfXTgXodGoJYzglndSLDMPg1sTPJpQJHJigw0QrGERqD9YhyTOgONQDUyuF1zaxuokc/BW2ztXCMrGZ9WMW1oQZHIXWNBkSCfRZEL5BMUiZw6CzVSFCfUSGZFNjIldoKDkonTKQiJIGzWmFd3BizJJ9SINoLDriOfUCOZS+zg+KGD1qGiLNMLxtJD1/ns00ON6EzyUCM6vbxhoBKaqbG3DFQCNiL1iHccBPV0DHhQH/JW8EW90dkyFKGywCJU0WkVSvSGeiSUODWFFD0HYdPQVoiRgfPMA+/nnRgiAyNYSjpWNQcNSMrtFCUH4ZIRpSCWocFCSuhCEY6hoUClc0WC52BJlCYYLQdhN+hygRRRlo5BKRRLS6oihSqh+ZzzRGG1Mo4Iz1LoP0qsxDGFzk0JE42ji0jCPejomJKCuwil4m5CiRMEUMVSzVLDUstSx1Juc0oVWMpqY295qVltmtWmWW2a1aZZbZrVplltmtWmWW2G1WZYbYbVZlhthtVmWG2G1WZYbYbVZlhtltVmWW2W1WZZbZbVZlltltVmWW2W1QYjQCh7E2aAQHeGhCFgPoNoy8KNb2wxBhmGKBxoUZXlLGsLI6AsftEDHV0wIURVbANLcTKlGGBIKPOAxCmhePCKUwFzAmpDFRQvjA9R06Hq8TONvshgKDCuRAZTXigUxjxNFfKRo3CLhnIJBMFRvMZpqpNBMlQJzGT5WFQMVQI/AikPMIhEU1aDjqJvQwmjSHB05cC9jbYwc5UtAHNLhDw41ha+lEqF4JaH3gmB61SYcqInxTDmQK8v08vjqv4zDf1N0w3Lf4A8/vwPpfK11w==\"");

});


parcelRegister("90iSP", function(module, exports) {

$parcel$export(module.exports, "Encodings", () => $68e2c2ff57f5b549$export$c85030bb86979d84);
/* tslint:disable max-classes-per-file */ 
var $5JpfH = parcelRequire("5JpfH");

var $9zuq9 = parcelRequire("9zuq9");
var $68e2c2ff57f5b549$var$decompressedEncodings = (0, $5JpfH.decompressJson)((0, (/*@__PURE__*/$parcel$interopDefault($9zuq9))));
var $68e2c2ff57f5b549$var$allUnicodeMappings = JSON.parse($68e2c2ff57f5b549$var$decompressedEncodings);
var $68e2c2ff57f5b549$var$Encoding = /** @class */ function() {
    function Encoding(name, unicodeMappings) {
        var _this = this;
        this.canEncodeUnicodeCodePoint = function(codePoint) {
            return codePoint in _this.unicodeMappings;
        };
        this.encodeUnicodeCodePoint = function(codePoint) {
            var mapped = _this.unicodeMappings[codePoint];
            if (!mapped) {
                var str = String.fromCharCode(codePoint);
                var hexCode = "0x" + (0, $5JpfH.padStart)(codePoint.toString(16), 4, '0');
                var msg = _this.name + " cannot encode \"" + str + "\" (" + hexCode + ")";
                throw new Error(msg);
            }
            return {
                code: mapped[0],
                name: mapped[1]
            };
        };
        this.name = name;
        this.supportedCodePoints = Object.keys(unicodeMappings).map(Number).sort(function(a, b) {
            return a - b;
        });
        this.unicodeMappings = unicodeMappings;
    }
    return Encoding;
}();
var $68e2c2ff57f5b549$export$c85030bb86979d84 = {
    Symbol: new $68e2c2ff57f5b549$var$Encoding('Symbol', $68e2c2ff57f5b549$var$allUnicodeMappings.symbol),
    ZapfDingbats: new $68e2c2ff57f5b549$var$Encoding('ZapfDingbats', $68e2c2ff57f5b549$var$allUnicodeMappings.zapfdingbats),
    WinAnsi: new $68e2c2ff57f5b549$var$Encoding('WinAnsi', $68e2c2ff57f5b549$var$allUnicodeMappings.win1252)
};

});
parcelRegister("9zuq9", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});




parcelRegister("j0tvB", function(module, exports) {

$parcel$export(module.exports, "assertIsOneOf", () => $dd64e83d12710def$export$8883a3014ee46cd1);
$parcel$export(module.exports, "assertIsOneOfOrUndefined", () => $dd64e83d12710def$export$846079600c50354e);
$parcel$export(module.exports, "assertIsSubset", () => $dd64e83d12710def$export$dce66947695c582f);
$parcel$export(module.exports, "assertIs", () => $dd64e83d12710def$export$6fee1f82edcf4a03);
$parcel$export(module.exports, "assertOrUndefined", () => $dd64e83d12710def$export$92143017cb173fb0);
$parcel$export(module.exports, "assertEachIs", () => $dd64e83d12710def$export$47fbce961905bcd0);
$parcel$export(module.exports, "assertRange", () => $dd64e83d12710def$export$6698b6d148bc9b0c);
$parcel$export(module.exports, "assertRangeOrUndefined", () => $dd64e83d12710def$export$bce4080186be486);
$parcel$export(module.exports, "assertMultiple", () => $dd64e83d12710def$export$c9f5acf8e31d1a2e);
$parcel$export(module.exports, "assertInteger", () => $dd64e83d12710def$export$a59e49f1e2708383);
$parcel$export(module.exports, "assertPositive", () => $dd64e83d12710def$export$2cad8b74f3cf13dd);
/* tslint:disable:ban-types */ 
var $cbIAG = parcelRequire("cbIAG");
var $dd64e83d12710def$export$c7ce26e85cccb3a8 = function(val) {
    return "`" + val + "`";
};
var $dd64e83d12710def$export$1909b7b8a28995a9 = function(val) {
    return "'" + val + "'";
};
// prettier-ignore
var $dd64e83d12710def$var$formatValue = function(value) {
    var type = typeof value;
    if (type === 'string') return $dd64e83d12710def$export$1909b7b8a28995a9(value);
    else if (type === 'undefined') return $dd64e83d12710def$export$c7ce26e85cccb3a8(value);
    else return value;
};
var $dd64e83d12710def$export$2ac73c5d250d45a9 = function(value, valueName, values) {
    var allowedValues = new Array(values.length);
    for(var idx = 0, len = values.length; idx < len; idx++){
        var v = values[idx];
        allowedValues[idx] = $dd64e83d12710def$var$formatValue(v);
    }
    var joinedValues = allowedValues.join(' or ');
    // prettier-ignore
    return $dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be one of " + joinedValues + ", but was actually " + $dd64e83d12710def$var$formatValue(value);
};
var $dd64e83d12710def$export$8883a3014ee46cd1 = function(value, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $cbIAG.values)(allowedValues);
    for(var idx = 0, len = allowedValues.length; idx < len; idx++){
        if (value === allowedValues[idx]) return;
    }
    throw new TypeError($dd64e83d12710def$export$2ac73c5d250d45a9(value, valueName, allowedValues));
};
var $dd64e83d12710def$export$846079600c50354e = function(value, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $cbIAG.values)(allowedValues);
    $dd64e83d12710def$export$8883a3014ee46cd1(value, valueName, allowedValues.concat(undefined));
};
var $dd64e83d12710def$export$dce66947695c582f = function(values, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $cbIAG.values)(allowedValues);
    for(var idx = 0, len = values.length; idx < len; idx++)$dd64e83d12710def$export$8883a3014ee46cd1(values[idx], valueName, allowedValues);
};
var $dd64e83d12710def$export$e2b5c5db9e2009fd = function(val) {
    if (val === null) return 'null';
    if (val === undefined) return 'undefined';
    if (typeof val === 'string') return 'string';
    if (isNaN(val)) return 'NaN';
    if (typeof val === 'number') return 'number';
    if (typeof val === 'boolean') return 'boolean';
    if (typeof val === 'symbol') return 'symbol';
    if (typeof val === 'bigint') return 'bigint';
    if (val.constructor && val.constructor.name) return val.constructor.name;
    if (val.name) return val.name;
    if (val.constructor) return String(val.constructor);
    return String(val);
};
var $dd64e83d12710def$export$26b9f946b448f23e = function(value, type) {
    if (type === 'null') return value === null;
    if (type === 'undefined') return value === undefined;
    if (type === 'string') return typeof value === 'string';
    if (type === 'number') return typeof value === 'number' && !isNaN(value);
    if (type === 'boolean') return typeof value === 'boolean';
    if (type === 'symbol') return typeof value === 'symbol';
    if (type === 'bigint') return typeof value === 'bigint';
    if (type === Date) return value instanceof Date;
    if (type === Array) return value instanceof Array;
    if (type === Uint8Array) return value instanceof Uint8Array;
    if (type === ArrayBuffer) return value instanceof ArrayBuffer;
    if (type === Function) return value instanceof Function;
    return value instanceof type[0];
};
var $dd64e83d12710def$export$6e3e1e6304e79984 = function(value, valueName, types) {
    var allowedTypes = new Array(types.length);
    for(var idx = 0, len = types.length; idx < len; idx++){
        var type = types[idx];
        if (type === 'null') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('null');
        if (type === 'undefined') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('undefined');
        if (type === 'string') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('string');
        else if (type === 'number') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('number');
        else if (type === 'boolean') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('boolean');
        else if (type === 'symbol') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('symbol');
        else if (type === 'bigint') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('bigint');
        else if (type === Array) allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('Array');
        else if (type === Uint8Array) allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('Uint8Array');
        else if (type === ArrayBuffer) allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('ArrayBuffer');
        else allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8(type[1]);
    }
    var joinedTypes = allowedTypes.join(' or ');
    // prettier-ignore
    return $dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be of type " + joinedTypes + ", but was actually of type " + $dd64e83d12710def$export$c7ce26e85cccb3a8($dd64e83d12710def$export$e2b5c5db9e2009fd(value));
};
var $dd64e83d12710def$export$6fee1f82edcf4a03 = function(value, valueName, types) {
    for(var idx = 0, len = types.length; idx < len; idx++){
        if ($dd64e83d12710def$export$26b9f946b448f23e(value, types[idx])) return;
    }
    throw new TypeError($dd64e83d12710def$export$6e3e1e6304e79984(value, valueName, types));
};
var $dd64e83d12710def$export$92143017cb173fb0 = function(value, valueName, types) {
    $dd64e83d12710def$export$6fee1f82edcf4a03(value, valueName, types.concat('undefined'));
};
var $dd64e83d12710def$export$47fbce961905bcd0 = function(values, valueName, types) {
    for(var idx = 0, len = values.length; idx < len; idx++)$dd64e83d12710def$export$6fee1f82edcf4a03(values[idx], valueName, types);
};
var $dd64e83d12710def$export$6698b6d148bc9b0c = function(value, valueName, min, max) {
    $dd64e83d12710def$export$6fee1f82edcf4a03(value, valueName, [
        'number'
    ]);
    $dd64e83d12710def$export$6fee1f82edcf4a03(min, 'min', [
        'number'
    ]);
    $dd64e83d12710def$export$6fee1f82edcf4a03(max, 'max', [
        'number'
    ]);
    max = Math.max(min, max);
    if (value < min || value > max) // prettier-ignore
    throw new Error($dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be at least " + min + " and at most " + max + ", but was actually " + value);
};
var $dd64e83d12710def$export$bce4080186be486 = function(value, valueName, min, max) {
    $dd64e83d12710def$export$6fee1f82edcf4a03(value, valueName, [
        'number',
        'undefined'
    ]);
    if (typeof value === 'number') $dd64e83d12710def$export$6698b6d148bc9b0c(value, valueName, min, max);
};
var $dd64e83d12710def$export$c9f5acf8e31d1a2e = function(value, valueName, multiplier) {
    $dd64e83d12710def$export$6fee1f82edcf4a03(value, valueName, [
        'number'
    ]);
    if (value % multiplier !== 0) // prettier-ignore
    throw new Error($dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be a multiple of " + multiplier + ", but was actually " + value);
};
var $dd64e83d12710def$export$a59e49f1e2708383 = function(value, valueName) {
    if (!Number.isInteger(value)) throw new Error($dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be an integer, but was actually " + value);
};
var $dd64e83d12710def$export$2cad8b74f3cf13dd = function(value, valueName) {
    if (![
        1,
        0
    ].includes(Math.sign(value))) // prettier-ignore
    throw new Error($dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be a positive number or 0, but was actually " + value);
};

});

parcelRegister("iSBb0", function(module, exports) {

$parcel$export(module.exports, "pdfDocEncodingDecode", () => $dbea1b9ee80fa12b$export$ea426b9c784ba215);

var $7Kmy8 = parcelRequire("7Kmy8");
// Mapping from PDFDocEncoding to Unicode code point
var $dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode = new Uint16Array(256);
// Initialize the code points which are the same
for(var $dbea1b9ee80fa12b$var$idx = 0; $dbea1b9ee80fa12b$var$idx < 256; $dbea1b9ee80fa12b$var$idx++)$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[$dbea1b9ee80fa12b$var$idx] = $dbea1b9ee80fa12b$var$idx;
// Set differences (see "Table D.2 – PDFDocEncoding Character Set" of the PDF spec)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x16] = (0, $7Kmy8.toCharCode)('\u0017'); // SYNCRONOUS IDLE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x18] = (0, $7Kmy8.toCharCode)('\u02D8'); // BREVE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x19] = (0, $7Kmy8.toCharCode)('\u02C7'); // CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1a] = (0, $7Kmy8.toCharCode)('\u02C6'); // MODIFIER LETTER CIRCUMFLEX ACCENT
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1b] = (0, $7Kmy8.toCharCode)('\u02D9'); // DOT ABOVE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1c] = (0, $7Kmy8.toCharCode)('\u02DD'); // DOUBLE ACUTE ACCENT
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1d] = (0, $7Kmy8.toCharCode)('\u02DB'); // OGONEK
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1e] = (0, $7Kmy8.toCharCode)('\u02DA'); // RING ABOVE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1f] = (0, $7Kmy8.toCharCode)('\u02DC'); // SMALL TILDE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x7f] = (0, $7Kmy8.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x80] = (0, $7Kmy8.toCharCode)('\u2022'); // BULLET
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x81] = (0, $7Kmy8.toCharCode)('\u2020'); // DAGGER
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x82] = (0, $7Kmy8.toCharCode)('\u2021'); // DOUBLE DAGGER
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x83] = (0, $7Kmy8.toCharCode)('\u2026'); // HORIZONTAL ELLIPSIS
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x84] = (0, $7Kmy8.toCharCode)('\u2014'); // EM DASH
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x85] = (0, $7Kmy8.toCharCode)('\u2013'); // EN DASH
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x86] = (0, $7Kmy8.toCharCode)('\u0192'); // LATIN SMALL LETTER SCRIPT F
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x87] = (0, $7Kmy8.toCharCode)('\u2044'); // FRACTION SLASH (solidus)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x88] = (0, $7Kmy8.toCharCode)('\u2039'); // SINGLE LEFT-POINTING ANGLE QUOTATION MARK
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x89] = (0, $7Kmy8.toCharCode)('\u203A'); // SINGLE RIGHT-POINTING ANGLE QUOTATION MARK
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8a] = (0, $7Kmy8.toCharCode)('\u2212'); // MINUS SIGN
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8b] = (0, $7Kmy8.toCharCode)('\u2030'); // PER MILLE SIGN
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8c] = (0, $7Kmy8.toCharCode)('\u201E'); // DOUBLE LOW-9 QUOTATION MARK (quotedblbase)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8d] = (0, $7Kmy8.toCharCode)('\u201C'); // LEFT DOUBLE QUOTATION MARK (quotedblleft)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8e] = (0, $7Kmy8.toCharCode)('\u201D'); // RIGHT DOUBLE QUOTATION MARK (quotedblright)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8f] = (0, $7Kmy8.toCharCode)('\u2018'); // LEFT SINGLE QUOTATION MARK (quoteleft)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x90] = (0, $7Kmy8.toCharCode)('\u2019'); // RIGHT SINGLE QUOTATION MARK (quoteright)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x91] = (0, $7Kmy8.toCharCode)('\u201A'); // SINGLE LOW-9 QUOTATION MARK (quotesinglbase)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x92] = (0, $7Kmy8.toCharCode)('\u2122'); // TRADE MARK SIGN
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x93] = (0, $7Kmy8.toCharCode)('\uFB01'); // LATIN SMALL LIGATURE FI
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x94] = (0, $7Kmy8.toCharCode)('\uFB02'); // LATIN SMALL LIGATURE FL
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x95] = (0, $7Kmy8.toCharCode)('\u0141'); // LATIN CAPITAL LETTER L WITH STROKE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x96] = (0, $7Kmy8.toCharCode)('\u0152'); // LATIN CAPITAL LIGATURE OE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x97] = (0, $7Kmy8.toCharCode)('\u0160'); // LATIN CAPITAL LETTER S WITH CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x98] = (0, $7Kmy8.toCharCode)('\u0178'); // LATIN CAPITAL LETTER Y WITH DIAERESIS
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x99] = (0, $7Kmy8.toCharCode)('\u017D'); // LATIN CAPITAL LETTER Z WITH CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9a] = (0, $7Kmy8.toCharCode)('\u0131'); // LATIN SMALL LETTER DOTLESS I
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9b] = (0, $7Kmy8.toCharCode)('\u0142'); // LATIN SMALL LETTER L WITH STROKE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9c] = (0, $7Kmy8.toCharCode)('\u0153'); // LATIN SMALL LIGATURE OE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9d] = (0, $7Kmy8.toCharCode)('\u0161'); // LATIN SMALL LETTER S WITH CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9e] = (0, $7Kmy8.toCharCode)('\u017E'); // LATIN SMALL LETTER Z WITH CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9f] = (0, $7Kmy8.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0xa0] = (0, $7Kmy8.toCharCode)('\u20AC'); // EURO SIGN
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0xad] = (0, $7Kmy8.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
var $dbea1b9ee80fa12b$export$ea426b9c784ba215 = function(bytes) {
    var codePoints = new Array(bytes.length);
    for(var idx = 0, len = bytes.length; idx < len; idx++)codePoints[idx] = $dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[bytes[idx]];
    return String.fromCodePoint.apply(String, codePoints);
};

});

parcelRegister("clYSv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fe6ab59ebda0f6a$export$2e2bcd8739ae039);
var $8fe6ab59ebda0f6a$var$Cache = /** @class */ function() {
    function Cache(populate) {
        this.populate = populate;
        this.value = undefined;
    }
    Cache.prototype.getValue = function() {
        return this.value;
    };
    Cache.prototype.access = function() {
        if (!this.value) this.value = this.populate();
        return this.value;
    };
    Cache.prototype.invalidate = function() {
        this.value = undefined;
    };
    Cache.populatedBy = function(populate) {
        return new Cache(populate);
    };
    return Cache;
}();
var $8fe6ab59ebda0f6a$export$2e2bcd8739ae039 = $8fe6ab59ebda0f6a$var$Cache;

});


parcelRegister("11c5J", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bdf4392b99cfcf1$export$2e2bcd8739ae039);

var $nAWRe = parcelRequire("nAWRe");
var $0bdf4392b99cfcf1$var$PDFObject = /** @class */ function() {
    function PDFObject() {}
    PDFObject.prototype.clone = function(_context) {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'clone');
    };
    PDFObject.prototype.toString = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'toString');
    };
    PDFObject.prototype.sizeInBytes = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'sizeInBytes');
    };
    PDFObject.prototype.copyBytesInto = function(_buffer, _offset) {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'copyBytesInto');
    };
    return PDFObject;
}();
var $0bdf4392b99cfcf1$export$2e2bcd8739ae039 = $0bdf4392b99cfcf1$var$PDFObject;

});
parcelRegister("nAWRe", function(module, exports) {

$parcel$export(module.exports, "MethodNotImplementedError", () => $046ecf435f71da9c$export$b549a6777be1bc17);
$parcel$export(module.exports, "PrivateConstructorError", () => $046ecf435f71da9c$export$20e18464cd4b43a);
$parcel$export(module.exports, "UnexpectedObjectTypeError", () => $046ecf435f71da9c$export$ab03f98a62c22159);
$parcel$export(module.exports, "UnsupportedEncodingError", () => $046ecf435f71da9c$export$5de8fe8a6031fb92);
$parcel$export(module.exports, "ReparseError", () => $046ecf435f71da9c$export$df523155c7c35e23);
$parcel$export(module.exports, "MissingPageContentsEmbeddingError", () => $046ecf435f71da9c$export$48e9be38307e3c37);
$parcel$export(module.exports, "UnrecognizedStreamTypeError", () => $046ecf435f71da9c$export$f8343077e7fd3a86);
$parcel$export(module.exports, "PageEmbeddingMismatchedContextError", () => $046ecf435f71da9c$export$22c55e00f6509a2c);
$parcel$export(module.exports, "PDFArrayIsNotRectangleError", () => $046ecf435f71da9c$export$a76bae7761f3d760);
$parcel$export(module.exports, "InvalidPDFDateStringError", () => $046ecf435f71da9c$export$8638e3ad1edceac8);
$parcel$export(module.exports, "InvalidTargetIndexError", () => $046ecf435f71da9c$export$845c01ec1ddb8877);
$parcel$export(module.exports, "CorruptPageTreeError", () => $046ecf435f71da9c$export$1012d63cae1523f8);
$parcel$export(module.exports, "IndexOutOfBoundsError", () => $046ecf435f71da9c$export$19a77d83c7473130);
$parcel$export(module.exports, "InvalidAcroFieldValueError", () => $046ecf435f71da9c$export$d39c49ea9be644ec);
$parcel$export(module.exports, "MultiSelectValueError", () => $046ecf435f71da9c$export$6606fe23b6c4542c);
$parcel$export(module.exports, "MissingDAEntryError", () => $046ecf435f71da9c$export$dfa101de065b3cc2);
$parcel$export(module.exports, "MissingTfOperatorError", () => $046ecf435f71da9c$export$b5ee390f1267b133);
$parcel$export(module.exports, "NumberParsingError", () => $046ecf435f71da9c$export$81adf4c464255546);
$parcel$export(module.exports, "NextByteAssertionError", () => $046ecf435f71da9c$export$fda6cb3cf0fe0c76);
$parcel$export(module.exports, "PDFObjectParsingError", () => $046ecf435f71da9c$export$b8907968b8d7f502);
$parcel$export(module.exports, "PDFInvalidObjectParsingError", () => $046ecf435f71da9c$export$72474f06fb3a1c6b);
$parcel$export(module.exports, "PDFStreamParsingError", () => $046ecf435f71da9c$export$b1a91b84397f50d6);
$parcel$export(module.exports, "UnbalancedParenthesisError", () => $046ecf435f71da9c$export$92803ff0e03167f9);
$parcel$export(module.exports, "StalledParserError", () => $046ecf435f71da9c$export$b934c61834236c8);
$parcel$export(module.exports, "MissingPDFHeaderError", () => $046ecf435f71da9c$export$cf6bd1b11dd05d74);
$parcel$export(module.exports, "MissingKeywordError", () => $046ecf435f71da9c$export$bc024c15c94be864);

var $cOQTW = parcelRequire("cOQTW");
parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $046ecf435f71da9c$export$b549a6777be1bc17 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MethodNotImplementedError, _super);
    function MethodNotImplementedError(className, methodName) {
        var _this = this;
        var msg = "Method " + className + "." + methodName + "() not implemented";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MethodNotImplementedError;
}(Error);
var $046ecf435f71da9c$export$20e18464cd4b43a = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PrivateConstructorError, _super);
    function PrivateConstructorError(className) {
        var _this = this;
        var msg = "Cannot construct " + className + " - it has a private constructor";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PrivateConstructorError;
}(Error);
var $046ecf435f71da9c$export$ab03f98a62c22159 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnexpectedObjectTypeError, _super);
    function UnexpectedObjectTypeError(expected, actual) {
        var _this = this;
        var name = function(t) {
            var _a, _b;
            return (_a = t === null || t === void 0 ? void 0 : t.name) !== null && _a !== void 0 ? _a : (_b = t === null || t === void 0 ? void 0 : t.constructor) === null || _b === void 0 ? void 0 : _b.name;
        };
        var expectedTypes = Array.isArray(expected) ? expected.map(name) : [
            name(expected)
        ];
        var msg = "Expected instance of " + expectedTypes.join(' or ') + ", " + ("but got instance of " + (actual ? name(actual) : actual));
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnexpectedObjectTypeError;
}(Error);
var $046ecf435f71da9c$export$5de8fe8a6031fb92 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnsupportedEncodingError, _super);
    function UnsupportedEncodingError(encoding) {
        var _this = this;
        var msg = encoding + " stream encoding not supported";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnsupportedEncodingError;
}(Error);
var $046ecf435f71da9c$export$df523155c7c35e23 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(ReparseError, _super);
    function ReparseError(className, methodName) {
        var _this = this;
        var msg = "Cannot call " + className + "." + methodName + "() more than once";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ReparseError;
}(Error);
var $046ecf435f71da9c$export$3afc9350d4666214 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingCatalogError, _super);
    function MissingCatalogError(ref) {
        var _this = this;
        var msg = "Missing catalog (ref=" + ref + ")";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingCatalogError;
}(Error);
var $046ecf435f71da9c$export$48e9be38307e3c37 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingPageContentsEmbeddingError, _super);
    function MissingPageContentsEmbeddingError() {
        var _this = this;
        var msg = "Can't embed page with missing Contents";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingPageContentsEmbeddingError;
}(Error);
var $046ecf435f71da9c$export$f8343077e7fd3a86 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnrecognizedStreamTypeError, _super);
    function UnrecognizedStreamTypeError(stream) {
        var _a, _b, _c;
        var _this = this;
        var streamType = (_c = (_b = (_a = stream === null || stream === void 0 ? void 0 : stream.contructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : stream === null || stream === void 0 ? void 0 : stream.name) !== null && _c !== void 0 ? _c : stream;
        var msg = "Unrecognized stream type: " + streamType;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnrecognizedStreamTypeError;
}(Error);
var $046ecf435f71da9c$export$22c55e00f6509a2c = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PageEmbeddingMismatchedContextError, _super);
    function PageEmbeddingMismatchedContextError() {
        var _this = this;
        var msg = "Found mismatched contexts while embedding pages. All pages in the array passed to `PDFDocument.embedPages()` must be from the same document.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PageEmbeddingMismatchedContextError;
}(Error);
var $046ecf435f71da9c$export$a76bae7761f3d760 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFArrayIsNotRectangleError, _super);
    function PDFArrayIsNotRectangleError(size) {
        var _this = this;
        var msg = "Attempted to convert PDFArray with " + size + " elements to rectangle, but must have exactly 4 elements.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PDFArrayIsNotRectangleError;
}(Error);
var $046ecf435f71da9c$export$8638e3ad1edceac8 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidPDFDateStringError, _super);
    function InvalidPDFDateStringError(value) {
        var _this = this;
        var msg = "Attempted to convert \"" + value + "\" to a date, but it does not match the PDF date string format.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidPDFDateStringError;
}(Error);
var $046ecf435f71da9c$export$845c01ec1ddb8877 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidTargetIndexError, _super);
    function InvalidTargetIndexError(targetIndex, Count) {
        var _this = this;
        var msg = "Invalid targetIndex specified: targetIndex=" + targetIndex + " must be less than Count=" + Count;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidTargetIndexError;
}(Error);
var $046ecf435f71da9c$export$1012d63cae1523f8 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(CorruptPageTreeError, _super);
    function CorruptPageTreeError(targetIndex, operation) {
        var _this = this;
        var msg = "Failed to " + operation + " at targetIndex=" + targetIndex + " due to corrupt page tree: It is likely that one or more 'Count' entries are invalid";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return CorruptPageTreeError;
}(Error);
var $046ecf435f71da9c$export$19a77d83c7473130 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(IndexOutOfBoundsError, _super);
    function IndexOutOfBoundsError(index, min, max) {
        var _this = this;
        var msg = "index should be at least " + min + " and at most " + max + ", but was actually " + index;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return IndexOutOfBoundsError;
}(Error);
var $046ecf435f71da9c$export$d39c49ea9be644ec = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidAcroFieldValueError, _super);
    function InvalidAcroFieldValueError() {
        var _this = this;
        var msg = "Attempted to set invalid field value";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidAcroFieldValueError;
}(Error);
var $046ecf435f71da9c$export$6606fe23b6c4542c = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MultiSelectValueError, _super);
    function MultiSelectValueError() {
        var _this = this;
        var msg = "Attempted to select multiple values for single-select field";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MultiSelectValueError;
}(Error);
var $046ecf435f71da9c$export$dfa101de065b3cc2 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingDAEntryError, _super);
    function MissingDAEntryError(fieldName) {
        var _this = this;
        var msg = "No /DA (default appearance) entry found for field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingDAEntryError;
}(Error);
var $046ecf435f71da9c$export$b5ee390f1267b133 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingTfOperatorError, _super);
    function MissingTfOperatorError(fieldName) {
        var _this = this;
        var msg = "No Tf operator found for DA of field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingTfOperatorError;
}(Error);
var $046ecf435f71da9c$export$81adf4c464255546 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(NumberParsingError, _super);
    function NumberParsingError(pos, value) {
        var _this = this;
        var msg = "Failed to parse number " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + "): \"" + value + "\"");
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return NumberParsingError;
}(Error);
var $046ecf435f71da9c$export$fd202455a19cb700 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFParsingError, _super);
    function PDFParsingError(pos, details) {
        var _this = this;
        var msg = "Failed to parse PDF document " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + "): " + details);
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PDFParsingError;
}(Error);
var $046ecf435f71da9c$export$fda6cb3cf0fe0c76 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(NextByteAssertionError, _super);
    function NextByteAssertionError(pos, expectedByte, actualByte) {
        var _this = this;
        var msg = "Expected next byte to be " + expectedByte + " but it was actually " + actualByte;
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return NextByteAssertionError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$b8907968b8d7f502 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFObjectParsingError, _super);
    function PDFObjectParsingError(pos, byte) {
        var _this = this;
        var msg = "Failed to parse PDF object starting with the following byte: " + byte;
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFObjectParsingError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$72474f06fb3a1c6b = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFInvalidObjectParsingError, _super);
    function PDFInvalidObjectParsingError(pos) {
        var _this = this;
        var msg = "Failed to parse invalid PDF object";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFInvalidObjectParsingError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$b1a91b84397f50d6 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFStreamParsingError, _super);
    function PDFStreamParsingError(pos) {
        var _this = this;
        var msg = "Failed to parse PDF stream";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFStreamParsingError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$92803ff0e03167f9 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnbalancedParenthesisError, _super);
    function UnbalancedParenthesisError(pos) {
        var _this = this;
        var msg = "Failed to parse PDF literal string due to unbalanced parenthesis";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return UnbalancedParenthesisError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$b934c61834236c8 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(StalledParserError, _super);
    function StalledParserError(pos) {
        var _this = this;
        var msg = "Parser stalled";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return StalledParserError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$cf6bd1b11dd05d74 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingPDFHeaderError, _super);
    function MissingPDFHeaderError(pos) {
        var _this = this;
        var msg = "No PDF header found";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return MissingPDFHeaderError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$bc024c15c94be864 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingKeywordError, _super);
    function MissingKeywordError(pos, keyword) {
        var _this = this;
        var msg = "Did not find expected keyword '" + (0, $4ISq8.arrayAsString)(keyword) + "'";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return MissingKeywordError;
}($046ecf435f71da9c$export$fd202455a19cb700);

});



parcelRegister("8zvel", function(module, exports) {

$parcel$export(module.exports, "default", () => $63d9d14d65819945$export$2e2bcd8739ae039);
var $63d9d14d65819945$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Null"] = 0] = "Null";
    CharCodes[CharCodes["Backspace"] = 8] = "Backspace";
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["Newline"] = 10] = "Newline";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationPoint"] = 33] = "ExclamationPoint";
    CharCodes[CharCodes["Hash"] = 35] = "Hash";
    CharCodes[CharCodes["Percent"] = 37] = "Percent";
    CharCodes[CharCodes["LeftParen"] = 40] = "LeftParen";
    CharCodes[CharCodes["RightParen"] = 41] = "RightParen";
    CharCodes[CharCodes["Plus"] = 43] = "Plus";
    CharCodes[CharCodes["Minus"] = 45] = "Minus";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Period"] = 46] = "Period";
    CharCodes[CharCodes["ForwardSlash"] = 47] = "ForwardSlash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["One"] = 49] = "One";
    CharCodes[CharCodes["Two"] = 50] = "Two";
    CharCodes[CharCodes["Three"] = 51] = "Three";
    CharCodes[CharCodes["Four"] = 52] = "Four";
    CharCodes[CharCodes["Five"] = 53] = "Five";
    CharCodes[CharCodes["Six"] = 54] = "Six";
    CharCodes[CharCodes["Seven"] = 55] = "Seven";
    CharCodes[CharCodes["Eight"] = 56] = "Eight";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["LessThan"] = 60] = "LessThan";
    CharCodes[CharCodes["GreaterThan"] = 62] = "GreaterThan";
    CharCodes[CharCodes["A"] = 65] = "A";
    CharCodes[CharCodes["D"] = 68] = "D";
    CharCodes[CharCodes["E"] = 69] = "E";
    CharCodes[CharCodes["F"] = 70] = "F";
    CharCodes[CharCodes["O"] = 79] = "O";
    CharCodes[CharCodes["P"] = 80] = "P";
    CharCodes[CharCodes["R"] = 82] = "R";
    CharCodes[CharCodes["LeftSquareBracket"] = 91] = "LeftSquareBracket";
    CharCodes[CharCodes["BackSlash"] = 92] = "BackSlash";
    CharCodes[CharCodes["RightSquareBracket"] = 93] = "RightSquareBracket";
    CharCodes[CharCodes["a"] = 97] = "a";
    CharCodes[CharCodes["b"] = 98] = "b";
    CharCodes[CharCodes["d"] = 100] = "d";
    CharCodes[CharCodes["e"] = 101] = "e";
    CharCodes[CharCodes["f"] = 102] = "f";
    CharCodes[CharCodes["i"] = 105] = "i";
    CharCodes[CharCodes["j"] = 106] = "j";
    CharCodes[CharCodes["l"] = 108] = "l";
    CharCodes[CharCodes["m"] = 109] = "m";
    CharCodes[CharCodes["n"] = 110] = "n";
    CharCodes[CharCodes["o"] = 111] = "o";
    CharCodes[CharCodes["r"] = 114] = "r";
    CharCodes[CharCodes["s"] = 115] = "s";
    CharCodes[CharCodes["t"] = 116] = "t";
    CharCodes[CharCodes["u"] = 117] = "u";
    CharCodes[CharCodes["x"] = 120] = "x";
    CharCodes[CharCodes["LeftCurly"] = 123] = "LeftCurly";
    CharCodes[CharCodes["RightCurly"] = 125] = "RightCurly";
    CharCodes[CharCodes["Tilde"] = 126] = "Tilde";
})($63d9d14d65819945$var$CharCodes || ($63d9d14d65819945$var$CharCodes = {}));
var $63d9d14d65819945$export$2e2bcd8739ae039 = $63d9d14d65819945$var$CharCodes;

});


parcelRegister("8gQNC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6058c6342b5f9099$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
var $6058c6342b5f9099$var$ENFORCER = {};
var $6058c6342b5f9099$var$PDFBool = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFBool, _super);
    function PDFBool(enforcer, value) {
        var _this = this;
        if (enforcer !== $6058c6342b5f9099$var$ENFORCER) throw new (0, $nAWRe.PrivateConstructorError)('PDFBool');
        _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFBool.prototype.asBoolean = function() {
        return this.value;
    };
    PDFBool.prototype.clone = function() {
        return this;
    };
    PDFBool.prototype.toString = function() {
        return String(this.value);
    };
    PDFBool.prototype.sizeInBytes = function() {
        return this.value ? 4 : 5;
    };
    PDFBool.prototype.copyBytesInto = function(buffer, offset) {
        if (this.value) {
            buffer[offset++] = (0, $8zvel.default).t;
            buffer[offset++] = (0, $8zvel.default).r;
            buffer[offset++] = (0, $8zvel.default).u;
            buffer[offset++] = (0, $8zvel.default).e;
            return 4;
        } else {
            buffer[offset++] = (0, $8zvel.default).f;
            buffer[offset++] = (0, $8zvel.default).a;
            buffer[offset++] = (0, $8zvel.default).l;
            buffer[offset++] = (0, $8zvel.default).s;
            buffer[offset++] = (0, $8zvel.default).e;
            return 5;
        }
    };
    PDFBool.True = new PDFBool($6058c6342b5f9099$var$ENFORCER, true);
    PDFBool.False = new PDFBool($6058c6342b5f9099$var$ENFORCER, false);
    return PDFBool;
}((0, $11c5J.default));
var $6058c6342b5f9099$export$2e2bcd8739ae039 = $6058c6342b5f9099$var$PDFBool;

});

parcelRegister("dPHSK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a12213d87b46303c$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");

var $6InlX = parcelRequire("6InlX");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $a12213d87b46303c$var$decodeName = function(name) {
    return name.replace(/#([\dABCDEF]{2})/g, function(_, hex) {
        return (0, $7Kmy8.charFromHexCode)(hex);
    });
};
var $a12213d87b46303c$var$isRegularChar = function(charCode) {
    return charCode >= (0, $8zvel.default).ExclamationPoint && charCode <= (0, $8zvel.default).Tilde && !(0, $6InlX.IsIrregular)[charCode];
};
var $a12213d87b46303c$var$ENFORCER = {};
var $a12213d87b46303c$var$pool = new Map();
var $a12213d87b46303c$var$PDFName = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFName, _super);
    function PDFName(enforcer, name) {
        var _this = this;
        if (enforcer !== $a12213d87b46303c$var$ENFORCER) throw new (0, $nAWRe.PrivateConstructorError)('PDFName');
        _this = _super.call(this) || this;
        var encodedName = '/';
        for(var idx = 0, len = name.length; idx < len; idx++){
            var character = name[idx];
            var code = (0, $7Kmy8.toCharCode)(character);
            encodedName += $a12213d87b46303c$var$isRegularChar(code) ? character : "#" + (0, $7Kmy8.toHexString)(code);
        }
        _this.encodedName = encodedName;
        return _this;
    }
    PDFName.prototype.asBytes = function() {
        var bytes = [];
        var hex = '';
        var escaped = false;
        var pushByte = function(byte) {
            if (byte !== undefined) bytes.push(byte);
            escaped = false;
        };
        for(var idx = 1, len = this.encodedName.length; idx < len; idx++){
            var char = this.encodedName[idx];
            var byte = (0, $7Kmy8.toCharCode)(char);
            var nextChar = this.encodedName[idx + 1];
            if (!escaped) {
                if (byte === (0, $8zvel.default).Hash) escaped = true;
                else pushByte(byte);
            } else if (byte >= (0, $8zvel.default).Zero && byte <= (0, $8zvel.default).Nine || byte >= (0, $8zvel.default).a && byte <= (0, $8zvel.default).f || byte >= (0, $8zvel.default).A && byte <= (0, $8zvel.default).F) {
                hex += char;
                if (hex.length === 2 || !(nextChar >= '0' && nextChar <= '9' || nextChar >= 'a' && nextChar <= 'f' || nextChar >= 'A' && nextChar <= 'F')) {
                    pushByte(parseInt(hex, 16));
                    hex = '';
                }
            } else pushByte(byte);
        }
        return new Uint8Array(bytes);
    };
    // TODO: This should probably use `utf8Decode()`
    // TODO: Polyfill Array.from?
    PDFName.prototype.decodeText = function() {
        var bytes = this.asBytes();
        return String.fromCharCode.apply(String, Array.from(bytes));
    };
    PDFName.prototype.asString = function() {
        return this.encodedName;
    };
    /** @deprecated in favor of [[PDFName.asString]] */ PDFName.prototype.value = function() {
        return this.encodedName;
    };
    PDFName.prototype.clone = function() {
        return this;
    };
    PDFName.prototype.toString = function() {
        return this.encodedName;
    };
    PDFName.prototype.sizeInBytes = function() {
        return this.encodedName.length;
    };
    PDFName.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.encodedName, buffer, offset);
        return this.encodedName.length;
    };
    PDFName.of = function(name) {
        var decodedValue = $a12213d87b46303c$var$decodeName(name);
        var instance = $a12213d87b46303c$var$pool.get(decodedValue);
        if (!instance) {
            instance = new PDFName($a12213d87b46303c$var$ENFORCER, decodedValue);
            $a12213d87b46303c$var$pool.set(decodedValue, instance);
        }
        return instance;
    };
    /* tslint:disable member-ordering */ PDFName.Length = PDFName.of('Length');
    PDFName.FlateDecode = PDFName.of('FlateDecode');
    PDFName.Resources = PDFName.of('Resources');
    PDFName.Font = PDFName.of('Font');
    PDFName.XObject = PDFName.of('XObject');
    PDFName.ExtGState = PDFName.of('ExtGState');
    PDFName.Contents = PDFName.of('Contents');
    PDFName.Type = PDFName.of('Type');
    PDFName.Parent = PDFName.of('Parent');
    PDFName.MediaBox = PDFName.of('MediaBox');
    PDFName.Page = PDFName.of('Page');
    PDFName.Annots = PDFName.of('Annots');
    PDFName.TrimBox = PDFName.of('TrimBox');
    PDFName.ArtBox = PDFName.of('ArtBox');
    PDFName.BleedBox = PDFName.of('BleedBox');
    PDFName.CropBox = PDFName.of('CropBox');
    PDFName.Rotate = PDFName.of('Rotate');
    PDFName.Title = PDFName.of('Title');
    PDFName.Author = PDFName.of('Author');
    PDFName.Subject = PDFName.of('Subject');
    PDFName.Creator = PDFName.of('Creator');
    PDFName.Keywords = PDFName.of('Keywords');
    PDFName.Producer = PDFName.of('Producer');
    PDFName.CreationDate = PDFName.of('CreationDate');
    PDFName.ModDate = PDFName.of('ModDate');
    return PDFName;
}((0, $11c5J.default));
var $a12213d87b46303c$export$2e2bcd8739ae039 = $a12213d87b46303c$var$PDFName;

});
parcelRegister("6InlX", function(module, exports) {

$parcel$export(module.exports, "IsIrregular", () => $4e38f796f0a0073a$export$5a447e10c710a69b);

var $8zvel = parcelRequire("8zvel");

var $eOx0D = parcelRequire("eOx0D");

var $14u6w = parcelRequire("14u6w");
var $4e38f796f0a0073a$export$5a447e10c710a69b = new Uint8Array(256);
for(var $4e38f796f0a0073a$var$idx = 0, $4e38f796f0a0073a$var$len = 256; $4e38f796f0a0073a$var$idx < $4e38f796f0a0073a$var$len; $4e38f796f0a0073a$var$idx++)$4e38f796f0a0073a$export$5a447e10c710a69b[$4e38f796f0a0073a$var$idx] = (0, $14u6w.IsWhitespace)[$4e38f796f0a0073a$var$idx] || (0, $eOx0D.IsDelimiter)[$4e38f796f0a0073a$var$idx] ? 1 : 0;
$4e38f796f0a0073a$export$5a447e10c710a69b[(0, $8zvel.default).Hash] = 1;

});
parcelRegister("eOx0D", function(module, exports) {

$parcel$export(module.exports, "IsDelimiter", () => $ac8f572666c7d7dc$export$30620680eaa3becd);

var $8zvel = parcelRequire("8zvel");
var $ac8f572666c7d7dc$export$30620680eaa3becd = new Uint8Array(256);
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).LeftParen] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).RightParen] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).LessThan] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).GreaterThan] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).LeftSquareBracket] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).RightSquareBracket] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).LeftCurly] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).RightCurly] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).ForwardSlash] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).Percent] = 1;

});

parcelRegister("14u6w", function(module, exports) {

$parcel$export(module.exports, "IsWhitespace", () => $0c7d843fbd7cd19d$export$38c4de915d0e2c37);

var $8zvel = parcelRequire("8zvel");
var $0c7d843fbd7cd19d$export$38c4de915d0e2c37 = new Uint8Array(256);
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).Null] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).Tab] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).Newline] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).FormFeed] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).CarriageReturn] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).Space] = 1;

});




var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));




var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));


/**
 * App.js - entry shell: routing, form state (factFind), layout (MainAppLayout), and page composition.
 * Calculations and constants live in src/calculations and src/constants; feature UI in src/features and src/pages.
 * See REFACTOR_STATUS.md and ARCHITECTURE.md for structure and next priorities.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $db42588f972bc829$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $db42588f972bc829$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const $db42588f972bc829$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = $db42588f972bc829$export$86f54f62aa7a7514(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const $db42588f972bc829$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const $db42588f972bc829$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};


/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $65855df5fc59b2ec$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};



const $d2b1338ec3fa0df8$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>(0, $acw62.createElement)("svg", {
        ref: ref,
        ...(0, $65855df5fc59b2ec$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $db42588f972bc829$export$3d46f4579dba46e5)("lucide", className),
        ...!children && !(0, $db42588f972bc829$export$ab365959aa6deed0)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));


const $810dc495bedb1cb1$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $acw62.forwardRef)(({ className: className, ...props }, ref)=>(0, $acw62.createElement)((0, $d2b1338ec3fa0df8$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $db42588f972bc829$export$3d46f4579dba46e5)(`lucide-${(0, $db42588f972bc829$export$73bda83cddbc7187)((0, $db42588f972bc829$export$6fb43ff9addf7357)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $db42588f972bc829$export$6fb43ff9addf7357)(iconName);
    return Component;
};


const $00824d397ec63c04$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
            key: "wmoenq"
        }
    ],
    [
        "path",
        {
            d: "M12 9v4",
            key: "juzpu7"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const $00824d397ec63c04$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("triangle-alert", $00824d397ec63c04$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8afc40d49a7e79bf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 8V4H8",
            key: "hb8ula"
        }
    ],
    [
        "rect",
        {
            width: "16",
            height: "12",
            x: "4",
            y: "8",
            rx: "2",
            key: "enze0r"
        }
    ],
    [
        "path",
        {
            d: "M2 14h2",
            key: "vft8re"
        }
    ],
    [
        "path",
        {
            d: "M20 14h2",
            key: "4cs60a"
        }
    ],
    [
        "path",
        {
            d: "M15 13v2",
            key: "1xurst"
        }
    ],
    [
        "path",
        {
            d: "M9 13v2",
            key: "rq6x2g"
        }
    ]
];
const $8afc40d49a7e79bf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("bot", $8afc40d49a7e79bf$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e3f86240925e7a9e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.801 10A10 10 0 1 1 17 3.335",
            key: "yps3ct"
        }
    ],
    [
        "path",
        {
            d: "m9 11 3 3L22 4",
            key: "1pflzl"
        }
    ]
];
const $e3f86240925e7a9e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-check-big", $e3f86240925e7a9e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cfb3b3013a649f15$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const $cfb3b3013a649f15$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("x", $cfb3b3013a649f15$export$3efd853dbb351e94);


/**
 * AgedCarePage – container for the aged care module: the landing on a saved plan, the analyser, and
 * the guide as a reference that never loses the reader's place (UX review, 17 Oct 2026).
 *
 * WHERE IT OPENS.
 *   - A plan is being reopened (Home's "Open", or "Model another home"): straight into the analyser,
 *     which lands on the plan rather than on an empty step 1.
 *   - "Start a new model from scratch": the analyser on an empty step 1, asking the setup questions again.
 *   - Plans exist on the file: the landing — this home's chosen plan, one column.
 *   - Nothing modelled yet: step 1 of the analyser, with the fees primer open and the guide a link.
 *
 * THE GUIDE IS A LINK, NOT A GATE (replacing the 22 Sep 2026 guide-first ruling, by the owner's
 * decision of 17 Oct). It used to stand in front of every route in and to unmount the analyser when
 * opened from inside it, losing the room price and the step. Now it opens over the page the reader
 * left, which stays mounted beneath it, and "Back" returns there.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * Puts the app's scrolling region back to the top.
 *
 * WHY THIS IS A SHARED HELPER AND NOT `querySelector('.overflow-y-auto')`. That is what the client
 * profile used, and it never worked: the sidebar nav also carries `overflow-y-auto` and sits FIRST
 * in the DOM, so every "scroll to top" between fact-find steps scrolled the navigation instead of
 * the page. Nobody noticed because the nav is usually already at its top, so the call appeared to be
 * a harmless no-op rather than a miss. Reported as landing mid-page (2026-08-22).
 *
 * The scroll container is marked with `data-app-scroll-container` in MainAppLayout, so this targets
 * the one element that actually scrolls. The window is scrolled too: layouts that let the document
 * scroll instead (and the standalone pages that render outside the shell) need that, and on a layout
 * where the window never scrolls it costs nothing.
 */ const $dec1f2e646bc0140$export$6c82760a196ed58 = 'data-app-scroll-container';
function $dec1f2e646bc0140$export$d9e308d9ad0c84b6(behavior = 'smooth') {
    if (typeof document === 'undefined') return;
    const container = document.querySelector(`[${$dec1f2e646bc0140$export$6c82760a196ed58}]`);
    if (container) container.scrollTo({
        top: 0,
        behavior: behavior
    });
    if (typeof window !== 'undefined') window.scrollTo({
        top: 0,
        behavior: behavior
    });
}


/**
 * AgedCareCostsExplained – Explainer page for aged care fees (BDF, RAD/DAP, HSC, NCCC, extra services).
 * Uses client's financial position for example MTA calculations. Rendered when user chooses "Understand costs" before the calculator.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * ratesAndThresholds.ts
 * Central source for Age Pension, tax, deeming, gifting, downsizer, and related rates.
 * Update this file when rates change (indexation: 20 March & 20 September for pension; quarterly for MPIR).
 * Ported verbatim from frontend/src/constants/ratesAndThresholds.js — keep both in sync until the
 * frontend copy is retired (see the calculation-engine migration plan).
 */ /**
 * WHEN this file was last brought up to date, and when it next falls due.
 *
 * Rates in here are hand-maintained against published figures, so the only thing standing between a
 * client and a stale calculation is somebody remembering. `RATES_REVIEW_BY` is that reminder with teeth:
 * `ratesFreshness.test.ts` fails once the date passes, naming what has changed and where to update it.
 * A failing build is a nuisance; quoting a superseded Age Pension rate to a client is worse.
 *
 * The dates that matter, so the next reviewer does not have to rediscover them:
 *   - Age Pension rates and both means-test limits — indexed 20 MARCH and 20 SEPTEMBER
 *   - Aged care fee caps and MTA thresholds — those two dates AND 1 JULY (`AGED_CARE_SCHEDULE.effectiveDate`).
 *     The Department publishes a 1 July schedule that moves the means-test income thresholds, the
 *     fourth asset threshold and the maximum RAD even though the pension does not move. Missed once,
 *     July–September 2026; see agedCareSchedule.ts.
 *   - MPIR — QUARTERLY, on 1 July / 1 October / 1 January / 1 April (`mpiQuarterLabel`)
 *   - Tax brackets, Medicare thresholds, LITO and SAPTO — 1 JULY, with the Budget
 *
 * `RATES_FINANCIAL_YEAR` is what the assumptions page shows the reader, so the page cannot drift from
 * the figures beneath it — which it had, describing 2026-27 brackets under a 2025-26 heading.
 */ const $1abe73eeef086faf$export$345389c3d55d014a = '2026-27';
const $1abe73eeef086faf$export$1559bbb51d90e77a = '2027-01-01';
const $1abe73eeef086faf$export$946308c675ba021d = {
    agePension: '20 September 2026',
    // Assets-test limits, income free areas/cut-offs, deeming thresholds and the funeral-bond limit
    // index on 1 JULY; the pension RATE indexes 20 March / 20 September. Verified against Services
    // Australia's pages (each "last updated 1 July 2026") on 16 September 2026 — the file had sat on
    // the March figures for ten weeks, exactly as the aged-care schedule had (see agedCareSchedule.ts).
    assetAndIncomeTests: '1 July 2026',
    agedCareSchedule: '20 September 2026 (DoH schedule of fees and charges for residential care); MPIR and the 1 July 2014 maximum means-tested care fee from 1 October 2026',
    supportAtHomeSchedule: '20 September 2026',
    taxBrackets: '2026-27 (includes the 15% bracket legislated from 1 July 2026)',
    // The levy thresholds are legislated retrospectively each May (2025-26 is the latest set); the
    // surcharge tiers are published ahead (2026-27); LITO and SAPTO do not index.
    medicareLowIncomeThresholds: '2025-26 (ATO, 30 June 2026)',
    medicareLevySurcharge: '2026-27 (ATO)',
    lito: 'from 1 July 2022 (not indexed)',
    sapto: 'from 1 July 2024 (not indexed)'
};
const $1abe73eeef086faf$export$5b6998cba7880742 = 67;
const $1abe73eeef086faf$export$d3d0fa1dd4309cd0 = {
    single: 32180.20,
    couple: 48516.00
};
const $1abe73eeef086faf$export$5c5a47a925656819 = {
    single: 1235.00,
    coupleEach: 930.80
};
const $1abe73eeef086faf$export$c43d5cc6e7d53048 = {
    single: 366.60,
    coupleEach: 275.60
};
const $1abe73eeef086faf$export$f2edcf3efd8592d9 = {
    single: 333000,
    couple: 499000
};
const $1abe73eeef086faf$export$6dfa3415233daaeb = {
    single: 745750,
    couple: 1121000
};
const $1abe73eeef086faf$export$9a84fd450010fb2e = {
    single: {
        homeowner: {
            full: 333000,
            cutoff: 745750
        },
        nonHomeowner: {
            full: 600000,
            cutoff: 1012750
        }
    },
    couple: {
        homeowner: {
            full: 499000,
            cutoff: 1121000
        },
        nonHomeowner: {
            full: 766000,
            cutoff: 1388000
        }
    },
    coupleIllnessSeparated: {
        homeowner: {
            full: 499000,
            cutoff: 1324500
        },
        nonHomeowner: {
            full: 766000,
            cutoff: 1591500
        }
    }
};
const $1abe73eeef086faf$export$6ca758cf677ce6c5 = 78; // $3 per fortnight * 26 fortnights
const $1abe73eeef086faf$export$704950d172afcdf8 = {
    single: 5876,
    couple: 10296
};
const $1abe73eeef086faf$export$bad1f8cb9d172d1b = {
    single: 70236.40,
    couple: 107328.00,
    coupleIllnessSeparated: 139016.80
};
const $1abe73eeef086faf$export$d0c93f26057d6047 = 0.50; // 50c for every dollar over
const $1abe73eeef086faf$export$63f1528eb9e21fc5 = {
    single: 66800,
    couple: 110600
};
const $1abe73eeef086faf$export$7ccf16e55e6cf86b = 0.0175; // 1.75%
const $1abe73eeef086faf$export$fe9b80c24d06bb6b = 0.0375; // 3.75%
const $1abe73eeef086faf$export$89d00d368c27d070 = [
    {
        age: 64,
        rate: 0.04
    },
    {
        age: 74,
        rate: 0.05
    },
    {
        age: 79,
        rate: 0.06
    },
    {
        age: 84,
        rate: 0.07
    },
    {
        age: 89,
        rate: 0.09
    },
    {
        age: 94,
        rate: 0.11
    },
    {
        age: Infinity,
        rate: 0.14
    }
];
const $1abe73eeef086faf$export$b8352069eaf11cd3 = [
    {
        limit: 18200,
        rate: 0,
        base: 0
    },
    {
        limit: 45000,
        rate: 0.15,
        base: 0
    },
    {
        limit: 135000,
        rate: 0.30,
        base: 4020
    },
    {
        limit: 190000,
        rate: 0.37,
        base: 31020
    },
    {
        limit: Infinity,
        rate: 0.45,
        base: 51370
    }
];
const $1abe73eeef086faf$export$4cbeb02de57151c1 = [
    {
        limit: 18200,
        rate: 0,
        base: 0
    },
    {
        limit: 45000,
        rate: 0.14,
        base: 0
    },
    {
        limit: 135000,
        rate: 0.30,
        base: 3752
    },
    {
        limit: 190000,
        rate: 0.37,
        base: 30752
    },
    {
        limit: Infinity,
        rate: 0.45,
        base: 51102
    }
];
const $1abe73eeef086faf$export$e17cd6cc373bed0e = Number($1abe73eeef086faf$export$345389c3d55d014a.slice(0, 4));
function $1abe73eeef086faf$export$71d73f2c4d006402(fyStartYear) {
    const fy = fyStartYear ?? $1abe73eeef086faf$export$e17cd6cc373bed0e;
    return fy >= 2027 ? $1abe73eeef086faf$export$4cbeb02de57151c1 : $1abe73eeef086faf$export$b8352069eaf11cd3;
}
const $1abe73eeef086faf$export$ff4b97dcd3d2d7f1 = 0.02;
const $1abe73eeef086faf$export$ae133c7b255163d3 = {
    single: {
        lower: 28011,
        upper: 35013
    },
    couple: {
        lower: 47238,
        upper: 59047
    },
    singleSenior: {
        lower: 44268,
        upper: 55335
    },
    coupleSenior: {
        lower: 61623,
        upper: 77028
    },
    /** The family LOWER threshold rises by this for each dependent child or student — not modelled (D.3.30). */ perDependentChild: 4338,
    /** …and the family UPPER threshold by this. */ perDependentChildUpper: 5423
};
const $1abe73eeef086faf$export$3f2efd37e8996007 = {
    tiers: [
        {
            singleUpTo: 105000,
            familyUpTo: 210000,
            rate: 0
        },
        {
            singleUpTo: 123000,
            familyUpTo: 246000,
            rate: 0.01
        },
        {
            singleUpTo: 164000,
            familyUpTo: 328000,
            rate: 0.0125
        },
        {
            singleUpTo: Infinity,
            familyUpTo: Infinity,
            rate: 0.015
        }
    ],
    perExtraChild: 1500
};
const $1abe73eeef086faf$export$641e54d6b906f309 = 0.30;
const $1abe73eeef086faf$export$c3b5f1f009bc99af = {
    maxOffset: 700,
    firstThreshold: 37500,
    secondThreshold: 45000,
    cutOut: 66667,
    firstTaperPerDollar: 0.05,
    secondTaperPerDollar: 0.015
};
const $1abe73eeef086faf$export$c2f6cffbd7c53bc0 = 0.125;
const $1abe73eeef086faf$export$e66d40af5bf25f2b = {
    single: {
        maxOffset: 2230,
        shadeIn: 34919,
        cutOut: 52759
    },
    coupleMember: {
        maxOffset: 1602,
        shadeIn: 30994,
        cutOut: 43810
    },
    illnessSeparatedMember: {
        maxOffset: 2040,
        shadeIn: 33732,
        cutOut: 50052
    }
};
const $1abe73eeef086faf$export$c5a41c20c8e5e4e0 = 10000;
const $1abe73eeef086faf$export$9cd36ea38af5a5f3 = 30000;
const $1abe73eeef086faf$export$42edd27decf8c272 = 300000;
const $1abe73eeef086faf$export$807e93be6ec93c1b = 2100000;
const $1abe73eeef086faf$export$336257db52e6aa69 = $1abe73eeef086faf$export$807e93be6ec93c1b / 16;
const $1abe73eeef086faf$export$29a056d5c6e73455 = 1600000;
const $1abe73eeef086faf$export$37fe9b0fd154e7ca = 32500;
const $1abe73eeef086faf$export$e5af7a7374b9aef3 = 130000;
const $1abe73eeef086faf$export$2b0b6412a74e90de = 75;
const $1abe73eeef086faf$export$93a0015d1424f140 = 3;
const $1abe73eeef086faf$export$e2cf792e99a08354 = 267000;
const $1abe73eeef086faf$export$2dec321660c3b7e8 = {
    effectiveDate: '2026-09-20',
    taperRate: 0.75,
    rates: {
        single: {
            minRent: 157.80,
            maxPayment: 223.80
        },
        singleSharer: {
            minRent: 157.80,
            maxPayment: 149.20
        },
        coupleCombined: {
            minRent: 255.80,
            maxPayment: 211.00
        },
        // One of a couple separated due to illness / partner in respite care or prison → single rate.
        illnessSeparated: {
            minRent: 157.80,
            maxPayment: 223.80
        },
        temporarilySeparated: {
            minRent: 157.80,
            maxPayment: 211.00
        }
    }
};
const $1abe73eeef086faf$export$aca3edb7cd7a3f17 = 16250;
const $1abe73eeef086faf$export$b240b1751c6944fa = {
    effectiveDate: '2026-10-01',
    /** 1 October – 31 December 2026 (DoH schedule from 20 September 2026). */ MPIR: 0.0851,
    mpiQuarterLabel: "1 October 2026 \u2013 31 December 2026",
    /** "Means tested care fee — from 1 October 2026" maximum daily rate (1 July 2014 arrangements). */ maxMeansTestedCareFeeDaily: 380.46
};
const $1abe73eeef086faf$export$e51ae1118d375fce = 2.5;
const $1abe73eeef086faf$export$73468023b612116d = 3992.30; // Annual - $153.55 per fortnight
const $1abe73eeef086faf$export$c8dfc1647fc5656 = {
    65: 19.96,
    66: 19.22,
    67: 18.49,
    68: 17.77,
    69: 17.05,
    70: 16.34,
    71: 15.64,
    72: 14.94,
    73: 14.25,
    74: 13.57,
    75: 12.9,
    76: 12.24,
    77: 11.59,
    78: 10.95,
    79: 10.33,
    80: 9.72,
    81: 9.12,
    82: 8.54,
    83: 7.98,
    84: 7.44,
    85: 6.92,
    86: 6.42,
    87: 5.94,
    88: 5.48,
    89: 5.04,
    90: 4.62,
    91: 4.22,
    92: 3.84,
    93: 3.49,
    94: 3.16,
    95: 2.85
};
const $1abe73eeef086faf$export$3599b35124f1fb09 = [
    {
        id: 'salary',
        name: 'Salary / Wages',
        assessable: true,
        taxable: true,
        manualEntry: true
    },
    {
        id: 'carerAllowance',
        name: 'Carer Allowance',
        assessable: false,
        taxable: false,
        manualEntry: false,
        rate: 3992.30,
        tooltip: 'A supplementary payment for those who provide daily care. It is non-taxable and not income/asset tested.'
    },
    {
        id: 'dvaDisability',
        name: 'DVA Disability Pension',
        assessable: false,
        taxable: false,
        manualEntry: true,
        tooltip: 'This is paid to compensate for injury or illness related to service. It is tax-free and not counted as income for the Age Pension income test.'
    },
    {
        id: 'dvaWarWidow',
        name: "DVA War Widow(er)'s Pension",
        assessable: true,
        taxable: false,
        manualEntry: true,
        tooltip: 'This pension is tax-free, but it IS counted as income for the Age Pension income test.'
    },
    {
        id: 'overseasPension',
        name: 'Overseas Pension',
        assessable: true,
        taxable: true,
        manualEntry: true,
        tooltip: 'Most overseas pensions are assessable for both the Centrelink income test and for Australian income tax.'
    },
    // A lifetime pension paid by a super fund's formula, not bought with a lump sum (UniSuper's Defined
    // Benefit Division, CSS, PSS, the military and state schemes). Its own rules — the capped tax-free
    // part for the income test, the pre-1998 asset-test exemption, the valuation factor where it is
    // counted, the defined benefit income cap for tax — live in definedBenefitPension.ts (15 Oct 2026).
    {
        id: 'definedBenefitPension',
        name: 'Lifetime pension from a super fund (defined benefit)',
        assessable: true,
        taxable: true,
        manualEntry: true,
        tooltip: "You didn't buy this with a lump sum: it is paid from your years in the fund, like CSS, PSS, UniSuper's Defined Benefit Division or a military scheme. Centrelink counts it as income less its tax-free part (capped at 10%), and usually not as an asset."
    },
    {
        id: 'boarders',
        name: 'Boarders / Lodgers',
        assessable: true,
        taxable: true,
        manualEntry: true,
        tooltip: "Money from boarders or lodgers living in your home. Centrelink counts only part of it: 70% for a room only, 50% with breakfast, 20% with full board. Payments from your parent, child or sibling are not counted \u2014 leave those out."
    },
    {
        id: 'other',
        name: 'Other Income',
        assessable: true,
        taxable: true,
        manualEntry: true,
        isCustom: true
    }
];
const $1abe73eeef086faf$export$e9d8121e3e2863b = {
    lodging: 0.7,
    bedAndBreakfast: 0.5,
    board: 0.2
};
function $1abe73eeef086faf$export$987faef8d6ff298e(boardType) {
    return $1abe73eeef086faf$export$e9d8121e3e2863b[boardType] ?? $1abe73eeef086faf$export$e9d8121e3e2863b.lodging;
}


/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f9e50e5a44fb11e0$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
];
const $f9e50e5a44fb11e0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("arrow-right", $f9e50e5a44fb11e0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1571f1c57333e026$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "20",
            height: "12",
            x: "2",
            y: "6",
            rx: "2",
            key: "9lu3g6"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "2",
            key: "1c9p78"
        }
    ],
    [
        "path",
        {
            d: "M6 12h.01M18 12h.01",
            key: "113zkx"
        }
    ]
];
const $1571f1c57333e026$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("banknote", $1571f1c57333e026$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7d167a906f54f167$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
            key: "l5xja"
        }
    ],
    [
        "path",
        {
            d: "M9 13a4.5 4.5 0 0 0 3-4",
            key: "10igwf"
        }
    ],
    [
        "path",
        {
            d: "M6.003 5.125A3 3 0 0 0 6.401 6.5",
            key: "105sqy"
        }
    ],
    [
        "path",
        {
            d: "M3.477 10.896a4 4 0 0 1 .585-.396",
            key: "ql3yin"
        }
    ],
    [
        "path",
        {
            d: "M6 18a4 4 0 0 1-1.967-.516",
            key: "2e4loj"
        }
    ],
    [
        "path",
        {
            d: "M12 13h4",
            key: "1ku699"
        }
    ],
    [
        "path",
        {
            d: "M12 18h6a2 2 0 0 1 2 2v1",
            key: "105ag5"
        }
    ],
    [
        "path",
        {
            d: "M12 8h8",
            key: "1lhi5i"
        }
    ],
    [
        "path",
        {
            d: "M16 8V5a2 2 0 0 1 2-2",
            key: "u6izg6"
        }
    ],
    [
        "circle",
        {
            cx: "16",
            cy: "13",
            r: ".5",
            key: "ry7gng"
        }
    ],
    [
        "circle",
        {
            cx: "18",
            cy: "3",
            r: ".5",
            key: "1aiba7"
        }
    ],
    [
        "circle",
        {
            cx: "20",
            cy: "21",
            r: ".5",
            key: "yhc1fs"
        }
    ],
    [
        "circle",
        {
            cx: "20",
            cy: "8",
            r: ".5",
            key: "1e43v0"
        }
    ]
];
const $7d167a906f54f167$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("brain-circuit", $7d167a906f54f167$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $27f56d6cfb7d79f8$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "16",
            height: "20",
            x: "4",
            y: "2",
            rx: "2",
            key: "1nb95v"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "16",
            y1: "6",
            y2: "6",
            key: "x4nwl0"
        }
    ],
    [
        "line",
        {
            x1: "16",
            x2: "16",
            y1: "14",
            y2: "18",
            key: "wjye3r"
        }
    ],
    [
        "path",
        {
            d: "M16 10h.01",
            key: "1m94wz"
        }
    ],
    [
        "path",
        {
            d: "M12 10h.01",
            key: "1nrarc"
        }
    ],
    [
        "path",
        {
            d: "M8 10h.01",
            key: "19clt8"
        }
    ],
    [
        "path",
        {
            d: "M12 14h.01",
            key: "1etili"
        }
    ],
    [
        "path",
        {
            d: "M8 14h.01",
            key: "6423bh"
        }
    ],
    [
        "path",
        {
            d: "M12 18h.01",
            key: "mhygvu"
        }
    ],
    [
        "path",
        {
            d: "M8 18h.01",
            key: "lrp35t"
        }
    ]
];
const $27f56d6cfb7d79f8$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("calculator", $27f56d6cfb7d79f8$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4f88028b3cc726f6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
const $4f88028b3cc726f6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-down", $4f88028b3cc726f6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c31db635520dc385$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
];
const $c31db635520dc385$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-left", $c31db635520dc385$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $52885985d1db6c06$export$3efd853dbb351e94 = [
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "2",
            y2: "22",
            key: "7eqyqh"
        }
    ],
    [
        "path",
        {
            d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6",
            key: "1b0p4s"
        }
    ]
];
const $52885985d1db6c06$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("dollar-sign", $52885985d1db6c06$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6315759428919b56$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            x: "3",
            y: "8",
            width: "18",
            height: "4",
            rx: "1",
            key: "bkv52"
        }
    ],
    [
        "path",
        {
            d: "M12 8v13",
            key: "1c76mn"
        }
    ],
    [
        "path",
        {
            d: "M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7",
            key: "6wjy6b"
        }
    ],
    [
        "path",
        {
            d: "M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5",
            key: "1ihvrl"
        }
    ]
];
const $6315759428919b56$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("gift", $6315759428919b56$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $95e9e50748ea8ef2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
            key: "c3ymky"
        }
    ],
    [
        "path",
        {
            d: "M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27",
            key: "1uw2ng"
        }
    ]
];
const $95e9e50748ea8ef2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("heart-pulse", $95e9e50748ea8ef2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $bee7e1f6335e67ab$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8",
            key: "5wwlr5"
        }
    ],
    [
        "path",
        {
            d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
            key: "1d0kgt"
        }
    ]
];
const $bee7e1f6335e67ab$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("house", $bee7e1f6335e67ab$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e52b122f04c04d7d$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 16v-4",
            key: "1dtifu"
        }
    ],
    [
        "path",
        {
            d: "M12 8h.01",
            key: "e9boi3"
        }
    ]
];
const $e52b122f04c04d7d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("info", $e52b122f04c04d7d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e57d6b071418ede9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
            key: "1gvzjb"
        }
    ],
    [
        "path",
        {
            d: "M9 18h6",
            key: "x1upvd"
        }
    ],
    [
        "path",
        {
            d: "M10 22h4",
            key: "ceow96"
        }
    ]
];
const $e57d6b071418ede9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("lightbulb", $e57d6b071418ede9$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f4da941c85c0c5fe$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M8 12h8",
            key: "1wcyev"
        }
    ],
    [
        "path",
        {
            d: "M12 8v8",
            key: "napkw2"
        }
    ]
];
const $f4da941c85c0c5fe$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-plus", $f4da941c85c0c5fe$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5faf23ec0b8e3e8e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
            key: "4pj2yx"
        }
    ],
    [
        "path",
        {
            d: "M20 3v4",
            key: "1olli1"
        }
    ],
    [
        "path",
        {
            d: "M22 5h-4",
            key: "1gvqau"
        }
    ],
    [
        "path",
        {
            d: "M4 17v2",
            key: "vumght"
        }
    ],
    [
        "path",
        {
            d: "M5 18H3",
            key: "zchphs"
        }
    ]
];
const $5faf23ec0b8e3e8e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("sparkles", $5faf23ec0b8e3e8e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c9921f4f81a419f0$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 7h6v6",
            key: "box55l"
        }
    ],
    [
        "path",
        {
            d: "m22 7-8.5 8.5-5-5L2 17",
            key: "1t1m79"
        }
    ]
];
const $c9921f4f81a419f0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("trending-up", $c9921f4f81a419f0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c38b5b11d1e2b813$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "path",
        {
            d: "M16 3.128a4 4 0 0 1 0 7.744",
            key: "16gr8j"
        }
    ],
    [
        "path",
        {
            d: "M22 21v-2a4 4 0 0 0-3-3.87",
            key: "kshegd"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ]
];
const $c38b5b11d1e2b813$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("users", $c38b5b11d1e2b813$export$3efd853dbb351e94);


/**
 * What situation is this household in — right now, and under the scenario being modelled?
 *
 * Three questions, each answered from nothing but the fact-find and the strategy options laid over
 * it: is this couple illness-separated, which partner should the aged-care modeller treat as being
 * in residential care, and do the MTA income bands read off the couple row or the single one. No
 * money is assessed here and nothing is indexed; these decide which RULE the assessment then applies.
 *
 * They live in their own module because of who asks them. The means test asks (financialCalculations
 * calls the first from inside `calculateFinancials`), but so does every aged-care and Support at Home
 * screen in the frontend — a dozen of them — none of which runs an assessment client-side. While
 * these three sat in financialCalculations.ts, that made the frontend a source-level consumer of the
 * whole assessment engine for the sake of three predicates over `adviceFor`, `relationship` and
 * `currentResidency`, and kept the engine in shared/ where it did not need to be.
 *
 * If you add a fourth, the test is the same: does it decide which rule applies (here) or compute a
 * figure under one (the assessors)?
 */ function $8eecd0af141b9afb$export$9b95c99516118f10(factFind, strategyOptions = {}) {
    if (factFind?.adviceFor !== 'couple') return false;
    const mode = factFind?.relationship?.illnessSeparatedMode || 'auto';
    if (mode === 'yes') return true;
    if (mode === 'no') return false;
    const explicit = factFind?.relationship?.separatedByIllness;
    if (explicit === true) return true;
    if (explicit === false) return false;
    const clientRes = strategyOptions?.clientResidencyOverride || factFind?.client?.currentResidency;
    const partnerRes = strategyOptions?.partnerResidencyOverride || factFind?.partner?.currentResidency;
    const oneInRac = clientRes === 'aged_care' && partnerRes !== 'aged_care' || partnerRes === 'aged_care' && clientRes !== 'aged_care';
    if (oneInRac) return true;
    /*
     * BOTH in residential care (7 Oct 2026). Two residents are a couple living apart because of
     * illness — each in their own room, assessed on half the combined means — so each is paid at the
     * single rate. A couple sharing one room and able to live together is the exception, and the
     * profile's `illnessSeparatedMode: 'no'` says so.
     */ if (clientRes === 'aged_care' && partnerRes === 'aged_care') return true;
    return false;
}
function $8eecd0af141b9afb$export$7b84565bbb0eef12(factFind) {
    if (factFind?.adviceFor !== 'couple' || !factFind?.goals?.aged_care) return {};
    const forWho = factFind.goals.aged_care_for;
    const clientHome = factFind?.client?.currentResidency || 'own_home';
    const partnerHome = factFind?.partner?.currentResidency || 'own_home';
    if (forWho === 'client') return {
        clientResidencyOverride: 'aged_care',
        partnerResidencyOverride: partnerHome
    };
    if (forWho === 'partner') return {
        clientResidencyOverride: clientHome,
        partnerResidencyOverride: 'aged_care'
    };
    if (forWho === 'both') return {
        clientResidencyOverride: 'aged_care',
        partnerResidencyOverride: 'aged_care'
    };
    return {
        clientResidencyOverride: 'aged_care',
        partnerResidencyOverride: partnerHome
    };
}
function $8eecd0af141b9afb$export$5f0bb1b091776594(factFind) {
    if (factFind?.adviceFor === 'couple') return $8eecd0af141b9afb$export$7b84565bbb0eef12(factFind);
    if (!factFind?.goals?.aged_care) return {};
    return {
        clientResidencyOverride: 'aged_care'
    };
}
function $8eecd0af141b9afb$export$6a0c2f6602682b05(factFind, strategyOptions = {}) {
    if (factFind?.adviceFor !== 'couple') return false;
    /*
     * NO HOME-VALUE CONDITION, deliberately. This used to begin `if (home.value <= 0) return false`,
     * on the reasoning that a home worth nothing has no exemption to argue about. But whether a
     * partner is living in the home is a fact about the household, not about the valuation — and
     * the check was redundant twice over:
     *
     *   - the engine's only caller (agedCareCostsEngine, via hasAgedCareProtectedPerson) is already
     *     inside `if (home && Number(home.value) > 0 && ...)`, so it never asked without a value;
     *   - the client profile asks "who will stay in the home?" on the same screen that collects the
     *     value, so the question appeared while the field was blank and vanished as it was typed.
     *
     * Asked by the owner, 2026-08-20: "what does having a home value have to do with the fact that
     * we know the partner is living in the home?" Nothing, so it is gone.
     */ const fromGoal = $8eecd0af141b9afb$export$7b84565bbb0eef12(factFind);
    const clientRes = strategyOptions?.clientResidencyOverride || fromGoal.clientResidencyOverride || factFind?.client?.currentResidency || 'own_home';
    const partnerRes = strategyOptions?.partnerResidencyOverride || fromGoal.partnerResidencyOverride || factFind?.partner?.currentResidency || 'own_home';
    const clientInCare = clientRes === 'aged_care';
    const partnerInCare = partnerRes === 'aged_care';
    // Both in care leaves nobody behind; neither in care means the means test isn't running yet.
    if (clientInCare === partnerInCare) return false;
    return (clientInCare ? partnerRes : clientRes) === 'own_home';
}
function $8eecd0af141b9afb$export$3f6250a0954ba7fc(factFind, strategyOptions = {}) {
    if (factFind?.adviceFor !== 'couple') return false;
    const clientRes = strategyOptions?.clientResidencyOverride || factFind?.client?.currentResidency;
    const partnerRes = strategyOptions?.partnerResidencyOverride || factFind?.partner?.currentResidency;
    if (clientRes === 'aged_care' && partnerRes === 'aged_care') return true;
    if (factFind?.goals?.aged_care_for === 'both') return true;
    const oneInRac = clientRes === 'aged_care' && partnerRes !== 'aged_care' || partnerRes === 'aged_care' && clientRes !== 'aged_care';
    if (oneInRac) return true;
    if (factFind?.goals?.aged_care) {
        const agedFor = factFind.goals.aged_care_for;
        if (agedFor === 'client' || agedFor === 'partner') return true;
    }
    return $8eecd0af141b9afb$export$9b95c99516118f10(factFind, strategyOptions);
}


/**
 * Which residential-care FEE ARRANGEMENTS a resident is on — the 1 November 2025 rules (hotelling
 * and non-clinical care contributions) or the 1 July 2014 rules (the means-tested care fee) kept
 * open by the "no worse off" principle.
 *
 * THE RULE (Department of Health, "Fee and accommodation arrangements for residential aged care",
 * updated 19 Dec 2025; "Means tested fees for residential aged care"; residential fee scenarios for
 * the 1 July 2014 arrangements, rates at 20 Mar 2026; the Department's residential fees webinar FAQ,
 * Q2.10; verified 17 Sep 2026):
 *
 *   A person who on 12 September 2024 was receiving a Home Care Package, approved as eligible for
 *   one, or waiting for one on the National Priority System, and who first enters residential care
 *   on or after 1 November 2025, is on the 1 JULY 2014 FEE ARRANGEMENTS: a basic daily fee and a
 *   MEANS-TESTED CARE FEE, and no hotelling or non-clinical care contribution. They may opt in to the
 *   1 November 2025 fee arrangements at any time, and cannot undo it.
 *
 *   Their ACCOMMODATION is on the 1 November 2025 arrangements regardless — deposit retention and
 *   DAP indexation apply — because accommodation grandfathering only covers people already living in
 *   a home on 31 October 2025. Nothing here touches accommodation.
 *
 * The profile records the answer per person (`careNeeds.<person>Acat.hcpBeforeSep2024`); this
 * module is the one place that turns it into a regime, so the fee engine, the projection, the
 * suggestion engine, the screens and the advice document cannot disagree about which rules a
 * client is on. "Unsure" is treated as the 1 November 2025 rules — the arrangements that charge
 * more — and the advice document says so.
 */ function $5a5496da6ce58554$export$ae585aa0224e16d3(acat) {
    return acat?.hcpBeforeSep2024 === 'yes';
}
function $5a5496da6ce58554$export$5abaa7bce38f1a1e(factFind) {
    if (factFind?.adviceFor !== 'couple') return [
        'client'
    ];
    const forWho = factFind?.goals?.aged_care_for;
    if (forWho === 'partner') return [
        'partner'
    ];
    if (forWho === 'both') return [
        'client',
        'partner'
    ];
    return [
        'client'
    ];
}
function $5a5496da6ce58554$var$acatOf(factFind, person) {
    return person === 'partner' ? factFind?.careNeeds?.partnerAcat : factFind?.careNeeds?.clientAcat;
}
function $5a5496da6ce58554$export$4a48561f28024b31(factFind) {
    const residents = $5a5496da6ce58554$export$5abaa7bce38f1a1e(factFind);
    return residents.length > 0 && residents.every((person)=>$5a5496da6ce58554$export$bddfdde6cc011e6c(factFind, person));
}
const $5a5496da6ce58554$export$2c3b55f37a29fc7 = '2025-11-01';
function $5a5496da6ce58554$export$388e9988095daada(factFind, person) {
    const p = person === 'partner' ? factFind?.partner : factFind?.client;
    const entry = p?.careStay?.entryDate;
    return p?.currentResidency === 'aged_care' && typeof entry === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(entry) && entry < $5a5496da6ce58554$export$2c3b55f37a29fc7;
}
function $5a5496da6ce58554$export$bddfdde6cc011e6c(factFind, person) {
    return $5a5496da6ce58554$export$ae585aa0224e16d3($5a5496da6ce58554$var$acatOf(factFind, person)) || $5a5496da6ce58554$export$388e9988095daada(factFind, person);
}
function $5a5496da6ce58554$export$a860283168d05510(factFind, strategyOptions = {}, /**
     * ONE person's arrangements, where the run prices two residents separately (7 Oct 2026). Absent,
     * the household rule above applies — every resident covered, or the 2025 rules for all.
     */ person) {
    const covered = person ? $5a5496da6ce58554$export$bddfdde6cc011e6c(factFind, person) : $5a5496da6ce58554$export$4a48561f28024b31(factFind);
    if (!covered) return '2025';
    return strategyOptions?.residentialFeeArrangements === '2025' ? '2025' : '2014';
}
function $5a5496da6ce58554$export$143dce70fd711d6a(factFind, person) {
    // One person's own figure where the run keeps a cap counter per resident (7 Oct 2026).
    if (person) return Math.max(0, Number($5a5496da6ce58554$var$acatOf(factFind, person)?.priorCareContributionsPaid) || 0);
    return $5a5496da6ce58554$export$5abaa7bce38f1a1e(factFind).reduce((sum, person)=>{
        const paid = Number($5a5496da6ce58554$var$acatOf(factFind, person)?.priorCareContributionsPaid) || 0;
        return sum + Math.max(0, paid);
    }, 0);
}
function $5a5496da6ce58554$export$eaed1be475c1255d(arrangements) {
    return arrangements === '2014' ? '1 July 2014 fee arrangements (means-tested care fee; no hotelling or non-clinical care contribution)' : '1 November 2025 fee arrangements (hotelling and non-clinical care contributions)';
}


/**
 * Phase 1d — Entity-held family home: Age Pension principal-home exemption and aged care cap.
 * Ported verbatim from frontend/src/calculations/entityHomeRules.js.
 */ 
function $8d8b97815ba787de$export$a536911c6e269e06(factFind) {
    const isPartnered = factFind?.adviceFor === 'couple';
    if (factFind?.client?.currentResidency === 'own_home') return true;
    return isPartnered && factFind?.partner?.currentResidency === 'own_home';
}
function $8d8b97815ba787de$export$b960f612817c7255(factFind, strategyOptions = {}) {
    const home = factFind?.home || {};
    const homeValue = home.value || 0;
    if (homeValue <= 0) return false;
    if (home.ownership !== 'other_entity' || !home.entityId || home.entityId === '__unsure__') return false;
    if (strategyOptions.rentHome || strategyOptions.downsizeHome) return false;
    if (home.securityOfTenure === false) return false;
    return $8d8b97815ba787de$export$a536911c6e269e06(factFind);
}
function $8d8b97815ba787de$export$d8162e7c9246435b(factFind) {
    const home = factFind?.home || {};
    return (home.value || 0) > 0 && home.ownership === 'other_entity' && !!home.entityId && home.entityId !== '__unsure__';
}
/**
 * The `home.protectedPerson` answers that actually confer the exemption.
 *
 * An allow-list, not "anything except 'no'". The field also carries answers that describe the home's
 * occupancy WITHOUT conferring anything — `occupied_not_protected` is someone living there who fails
 * the protected-person test, an adult child in work being the usual case, and `will_rent_out` is a
 * home let to a tenant. Under the old test those would have exempted the home simply by not being the
 * string 'no'. Being an allow-list is what lets new occupancy answers be added without touching a
 * single fee: anything not named here is assessed.
 */ const $8d8b97815ba787de$var$AGED_CARE_PROTECTED_PERSONS = new Set([
    'partner',
    'dependent_child',
    'carer',
    'close_relative'
]);
function $8d8b97815ba787de$export$a4f0fcc41e754c67(factFind, strategyOptions = {}) {
    const home = factFind?.home || {};
    // `factFind.protectedPerson` is the pre-`home` location, still read for files written back then
    // and typed only as an index-signature value — hence the String().
    const protectedPersonValue = String(home?.protectedPerson ?? factFind?.protectedPerson ?? '');
    if ($8d8b97815ba787de$var$AGED_CARE_PROTECTED_PERSONS.has(protectedPersonValue)) return true;
    return (0, $8eecd0af141b9afb$export$6a0c2f6602682b05)(factFind, strategyOptions);
}
function $8d8b97815ba787de$export$b7ce9409c997295e(factFind, strategyOptions = {}, homeCap) {
    if (!$8d8b97815ba787de$export$d8162e7c9246435b(factFind)) return null;
    const homeValue = factFind.home?.value || 0;
    if (strategyOptions.rentHome || strategyOptions.downsizeHome) return Math.min(homeValue, homeCap);
    if ($8d8b97815ba787de$export$a4f0fcc41e754c67(factFind, strategyOptions)) return 0;
    return Math.min(homeValue, homeCap);
}


/**
 * How the family home is treated for the hotelling and non-clinical care contributions, said for
 * THIS client rather than as three "if" cases (owner, 15 Oct 2026: the box also showed for a client
 * with no home at all). Null where nobody in the household owns a home — then there is nothing to
 * say. The exemption itself is the engine's own rule (hasAgedCareProtectedPerson), so the fee and the
 * explanation of the fee cannot disagree.
 */ 

/**
 * householdPosition.ts — where each person lives, and what that means, said ONCE.
 *
 * The profile records a living arrangement per person and the means tests read it carefully:
 * homeowner or not, a village or granny flat interest above the extra allowable amount, a former
 * home kept while in care. But every screen used to answer "do they own a home?" its own way —
 * most read the CLIENT's arrangement alone, so a couple where only the partner owned the home lost
 * the property strategies, and Support at Home priced its contributions on the wrong thresholds.
 * (Owner, 7 Oct 2026: the living-arrangement permutations review.)
 *
 * Everything here is a predicate over the fact-find and the strategy options laid over it. No money
 * is assessed; these decide which rule the assessors and the screens then apply.
 */ 
/**
 * Granny flat arrangement — Centrelink reasonable-value (reasonableness) test + deprivation.
 * Ported verbatim from frontend/src/calculations/grannyFlatArrangement.js.
 *
 * Reasonable value = combined annual partnered Age Pension rate (ON THE DATE the right was
 * established) × conversion factor (age next birthday at establishment; younger of a couple).
 * Deprivation = max(0, total amount paid − value of the granny-flat interest).
 *
 * THE THREE FACE-VALUE FORMS (Social Security Guide 4.6.4.50; Services Australia's worked examples,
 * verified 2 Oct 2026). Transferring the title of the home, paying for the construction of the
 * accommodation, or buying a property in the family member's name — on its own — is accepted as the
 * price of the right: no reasonableness test, no gift, whatever the amount. The test applies when
 * cash (or other assets) is paid, or when anything is given ON TOP of one of those three. Then the
 * right is valued at the greater of what was provided (the home, the build) and the formula, and
 * everything given above that is deprivation. So:
 *   - cash only:               gift = max(0, cash − reasonable value)
 *   - home title only:         gift = 0 (interest = home value)
 *   - construction only:       gift = 0 (interest = max(reasonable, construction) ≥ construction)
 *   - construction + cash:     gift = max(0, construction + cash − max(reasonable, construction))
 *   - home title + cash:       gift = max(0, home + cash − max(reasonable, home)) = cash where home ≥ reasonable
 * `amountPaid` is the CASH paid to the family, exclusive of the construction cost — the fact-find and
 * the module both capture the build separately (`constructionCost`).
 */ /**
 * Granny flat — reasonable value conversion factors.
 * Source: DSS Social Security Guide 4.6.4.60.
 * Ported verbatim from frontend/src/constants/grannyFlatConversionFactors.js.
 */ const $cc61f543ca04abdf$export$f1b3a18121463ec1 = {
    51: 33.94,
    52: 33.02,
    53: 32.09,
    54: 31.18,
    55: 30.27,
    56: 29.37,
    57: 28.47,
    58: 27.57,
    59: 26.69,
    60: 25.80,
    61: 24.92,
    62: 24.05,
    63: 23.18,
    64: 22.33,
    65: 21.48,
    66: 20.64,
    67: 19.80,
    68: 18.98,
    69: 18.16,
    70: 17.36,
    71: 16.56,
    72: 15.77,
    73: 15.01,
    74: 14.25,
    75: 13.50,
    76: 12.78,
    77: 12.07,
    78: 11.37,
    79: 10.70,
    80: 10.04,
    81: 9.41,
    82: 8.80,
    83: 8.21,
    84: 7.65,
    85: 7.11,
    86: 6.60,
    87: 6.13,
    88: 5.68,
    89: 5.26,
    90: 4.87,
    91: 4.52,
    92: 4.19,
    93: 3.89,
    94: 3.63,
    95: 3.40,
    96: 3.19,
    97: 3.01,
    98: 2.86,
    99: 2.72,
    100: 2.60
};
const $cc61f543ca04abdf$export$38e8f55d454ba6a0 = 51;
const $cc61f543ca04abdf$export$284174f2faf1f355 = 100;
function $cc61f543ca04abdf$export$526d0998e326b4e0(ageNextBirthday) {
    const age = Math.round(Number(ageNextBirthday));
    if (!Number.isFinite(age)) return $cc61f543ca04abdf$export$f1b3a18121463ec1[$cc61f543ca04abdf$export$284174f2faf1f355];
    const clamped = Math.min($cc61f543ca04abdf$export$284174f2faf1f355, Math.max($cc61f543ca04abdf$export$38e8f55d454ba6a0, age));
    return $cc61f543ca04abdf$export$f1b3a18121463ec1[clamped];
}
var $cc61f543ca04abdf$export$2e2bcd8739ae039 = $cc61f543ca04abdf$export$f1b3a18121463ec1;


/**
 * Historical combined-partnered Age Pension rate, by indexation date.
 * Used by the granny-flat reasonable-value test (rate as at the date the right was established).
 * Ported verbatim from frontend/src/constants/historicalPensionRates.js.
 */ const $fed38245453014be$export$cfc5a96c406e4774 = [
    {
        effectiveDate: '2020-09-20',
        basicAnnual: 33732.40,
        totalAnnual: 37013.60
    },
    {
        effectiveDate: '2021-03-20',
        basicAnnual: 34034.00,
        totalAnnual: 37341.20
    },
    {
        effectiveDate: '2021-09-20',
        basicAnnual: 34580.00,
        totalAnnual: 37923.60
    },
    {
        effectiveDate: '2022-03-20',
        basicAnnual: 35308.00,
        totalAnnual: 38708.80
    },
    {
        effectiveDate: '2022-09-20',
        basicAnnual: 36722.40,
        totalAnnual: 40237.60
    },
    {
        effectiveDate: '2023-03-20',
        basicAnnual: 38079.60,
        totalAnnual: 41704.00
    },
    {
        effectiveDate: '2023-09-20',
        basicAnnual: 39296.40,
        totalAnnual: 42988.40
    },
    {
        effectiveDate: '2024-03-20',
        basicAnnual: 40003.60,
        totalAnnual: 43752.80
    },
    {
        effectiveDate: '2024-09-20',
        basicAnnual: 41043.60,
        totalAnnual: 44855.20
    },
    {
        effectiveDate: '2025-03-20',
        basicAnnual: 41210.00,
        totalAnnual: 45037.20
    },
    {
        effectiveDate: '2025-09-20',
        basicAnnual: 42322.80,
        totalAnnual: 46202.00
    },
    {
        effectiveDate: '2026-03-20',
        basicAnnual: 43128.80,
        totalAnnual: 47070.40
    },
    {
        effectiveDate: '2026-09-20',
        basicAnnual: 44506.80,
        totalAnnual: 48516.00
    }
];
const $fed38245453014be$export$d5c6980bf49707d3 = 'total';
function $fed38245453014be$export$d95eae51de7871b2(date) {
    const d = date instanceof Date ? date : new Date(date);
    if (!(d instanceof Date) || Number.isNaN(d.getTime())) return null;
    let match = null;
    for (const entry of $fed38245453014be$export$cfc5a96c406e4774){
        if (new Date(entry.effectiveDate) <= d) match = entry;
        else break;
    }
    if (!match) return null;
    const combinedAnnual = $fed38245453014be$export$d5c6980bf49707d3 === 'basic' ? match.basicAnnual : match.totalAnnual;
    return {
        combinedAnnual: combinedAnnual,
        basis: $fed38245453014be$export$d5c6980bf49707d3,
        effectiveDate: match.effectiveDate
    };
}
var $fed38245453014be$export$2e2bcd8739ae039 = $fed38245453014be$export$cfc5a96c406e4774;


/**
 * Gifting & deprived assets for Age Pension-style means tests.
 * Ported verbatim from frontend/src/calculations/giftingDeprivation.js.
 *
 * Uses Australian financial years ending 30 June. Legacy/UI keys `yearYYYY` in `giftsHistory` mean:
 * total gifts in the FY 1 July (YYYY−1) – 30 June YYYY.
 */ 
function $171a6d8ba8937a5f$export$9e47c78a2ac7c305(date) {
    const d = date instanceof Date ? date : new Date(date);
    const y = d.getFullYear();
    const m = d.getMonth(); // 0 = Jan
    return m >= 6 ? y + 1 : y;
}
/** The dated gifts a gift history carries (`gifts: [{ date, amount }]`), when it does. */ function $171a6d8ba8937a5f$var$datedGiftsOf(giftsHistory) {
    const list = giftsHistory?.gifts;
    return Array.isArray(list) ? list : [];
}
function $171a6d8ba8937a5f$export$653e7b96a80afaf8(target, amount, date) {
    const n = Math.max(0, Number(amount) || 0);
    const d = $171a6d8ba8937a5f$var$giftDay(date);
    if (!(n > 0) || Number.isNaN(d.getTime())) return;
    const history = target.giftsHistory ?? (target.giftsHistory = {
        hasGifted: true
    });
    const gifts = Array.isArray(history.gifts) ? history.gifts : [];
    const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    history.gifts = [
        ...gifts,
        {
            date: iso,
            amount: n
        }
    ];
    history.hasGifted = true;
}
function $171a6d8ba8937a5f$export$57a934492fb10c62(giftsHistory, strategyGiftsByFyEnd = {}) {
    const byFy = $171a6d8ba8937a5f$var$buildUndatedGiftsByFinancialYear(giftsHistory, strategyGiftsByFyEnd);
    for (const g of $171a6d8ba8937a5f$var$datedGiftsOf(giftsHistory)){
        const d = $171a6d8ba8937a5f$var$giftDay(g?.date);
        const n = Math.max(0, Number(g?.amount) || 0);
        if (n > 0 && !Number.isNaN(d.getTime())) {
            const fy = $171a6d8ba8937a5f$export$9e47c78a2ac7c305(d);
            byFy.set(fy, (byFy.get(fy) || 0) + n);
        }
    }
    return byFy;
}
/** Totals per FY end year of the gifts known only by their financial year (`yearYYYY`, plus strategy FY gifts). */ function $171a6d8ba8937a5f$var$buildUndatedGiftsByFinancialYear(giftsHistory, strategyGiftsByFyEnd = {}) {
    const byFy = new Map();
    const add = (fy, amt)=>{
        const n = Math.max(0, Number(amt) || 0);
        if (n <= 0) return;
        byFy.set(fy, (byFy.get(fy) || 0) + n);
    };
    if (giftsHistory && typeof giftsHistory === 'object') for (const key of Object.keys(giftsHistory)){
        if (!key.startsWith('year')) continue;
        const fy = parseInt(key.slice(4), 10);
        if (!Number.isFinite(fy)) continue;
        add(fy, giftsHistory[key]);
    }
    if (strategyGiftsByFyEnd && typeof strategyGiftsByFyEnd === 'object') for (const [k, v] of Object.entries(strategyGiftsByFyEnd)){
        const fy = parseInt(k, 10);
        if (Number.isFinite(fy)) add(fy, v);
    }
    return byFy;
}
const $171a6d8ba8937a5f$var$addYears = (d, years)=>new Date(d.getFullYear() + years, d.getMonth(), d.getDate());
/**
 * A gift's day as a LOCAL calendar day. `new Date('2026-07-01')` is midnight UTC — 10am on 1 July in Australia —
 * so a gift made on the day an assessment is struck would read as made after it. A `YYYY-MM-DD` (or `YYYY-MM`)
 * string is taken as that day, locally; a Date is used as it stands.
 */ function $171a6d8ba8937a5f$var$giftDay(value) {
    if (value instanceof Date) return new Date(value.getFullYear(), value.getMonth(), value.getDate());
    const m = /^(\d{4})-(\d{2})(?:-(\d{2}))?/.exec(String(value ?? ''));
    if (m) return new Date(Number(m[1]), Number(m[2]) - 1, m[3] ? Number(m[3]) : 1);
    const d = new Date(String(value ?? ''));
    return Number.isNaN(d.getTime()) ? d : new Date(d.getFullYear(), d.getMonth(), d.getDate());
}
/**
 * THE FIVE YEARS RUN FROM THE DAY OF THE GIFT (owner, 24 Oct 2026; Services Australia operational guide
 * 108-06010010-05: "assessed as a deprived asset for 5 years from the date of the gift"). Until then the
 * excess was counted while its FINANCIAL YEAR was within the last five, so a June gift dropped off about a
 * year early.
 *
 * The free areas stay financial-year rules: $10,000 a financial year and $30,000 over a rolling five
 * financial years. They are used in the order the gifts were made, so the first $10,000 given in a year is
 * free and what comes after is the excess; each gift's excess then counts for five years from its own day.
 *
 * A gift the profile records only by financial year (`yearYYYY`) has no day. It is treated as given on
 * 30 June of that year — the conservative reading: counted for the longest the rule allows, five years
 * from that 30 June, and never dropped early. (It counts from the start of that year, and uses the free
 * areas in that order, so a gift recorded for the current year is counted at once.) A dated list,
 * `giftsHistory.gifts: [{ date, amount }]`, is read when present, so the profile can record the day later
 * without this engine changing again.
 */ function $171a6d8ba8937a5f$var$giftEvents(byFyUndated, dated) {
    const events = [];
    for (const [fy, amount] of byFyUndated){
        if (!(amount > 0)) continue;
        const fyStart = new Date(fy - 1, 6, 1);
        events.push({
            start: fyStart.getTime(),
            end: new Date(fy + 5, 6, 1).getTime(),
            order: fyStart.getTime(),
            fy: fy,
            amount: amount
        });
    }
    for (const g of dated){
        const amount = Math.max(0, Number(g?.amount) || 0);
        const d = $171a6d8ba8937a5f$var$giftDay(g?.date);
        if (!(amount > 0) || Number.isNaN(d.getTime())) continue;
        events.push({
            start: d.getTime(),
            end: $171a6d8ba8937a5f$var$addYears(d, 5).getTime(),
            order: d.getTime(),
            fy: $171a6d8ba8937a5f$export$9e47c78a2ac7c305(d),
            amount: amount
        });
    }
    return events.sort((a, b)=>a.order - b.order);
}
/** The excess above the free areas still counted on `asOf`, gift by gift. */ function $171a6d8ba8937a5f$var$deprivedOn(events, asOf, annualLimit, fiveYearLimit) {
    const freeByFy = new Map();
    const freeUsed = (from, to)=>{
        let t = 0;
        for(let y = from; y <= to; y++)t += freeByFy.get(y) || 0;
        return t;
    };
    const at = asOf.getTime();
    let counted = 0;
    for (const e of events){
        const free = Math.min(e.amount, Math.max(0, annualLimit - (freeByFy.get(e.fy) || 0)), Math.max(0, fiveYearLimit - freeUsed(e.fy - 4, e.fy)));
        freeByFy.set(e.fy, (freeByFy.get(e.fy) || 0) + free);
        const excess = e.amount - free;
        if (excess > 0 && e.start <= at && at < e.end) counted += excess;
    }
    return counted;
}
/**
 * THE MONTH OF A YEAR'S GIFTS (owner, 24 Oct 2026). The profile records each financial year's gifts as a total
 * (`yearYYYY`) and, when known, the calendar month they were made (`monthYYYY`, 1–12; with several gifts,
 * the latest). That year's total is dated the LAST day of that month — never dropped early — in the right
 * calendar year: July–December fall in the year before the financial year ends, January–June in that year.
 * With no month ("not sure"), the year is read as given on 30 June, as above.
 */ function $171a6d8ba8937a5f$var$monthDatedProfileGifts(giftsHistory) {
    const out = [];
    if (!giftsHistory || typeof giftsHistory !== 'object') return out;
    for (const key of Object.keys(giftsHistory)){
        if (!key.startsWith('month')) continue;
        const fy = parseInt(key.slice(5), 10);
        const month = Math.round(Number(giftsHistory[key]));
        const amount = Math.max(0, Number(giftsHistory[`year${fy}`]) || 0);
        if (!Number.isFinite(fy) || !(month >= 1 && month <= 12) || !(amount > 0)) continue;
        const calendarYear = month >= 7 ? fy - 1 : fy;
        out.push({
            date: new Date(calendarYear, month, 0),
            amount: amount,
            fy: fy
        }); // day 0 of the next month = the month's last day
    }
    return out;
}
function $171a6d8ba8937a5f$export$e13ba859aba62a6b(giftsHistory, options = {}) {
    const { asOfDate: asOfDate = new Date(), strategyGiftsByFyEnd: strategyGiftsByFyEnd = {}, datedGifts: datedGifts = [], annualLimit: annualLimit = (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0), fiveYearLimit: fiveYearLimit = (0, $1abe73eeef086faf$export$9cd36ea38af5a5f3) } = options;
    const byFy = $171a6d8ba8937a5f$var$buildUndatedGiftsByFinancialYear(giftsHistory || {}, strategyGiftsByFyEnd);
    // A year's total the profile dates by month (`monthYYYY`) is dated, not left to the year-end reading.
    const monthDated = $171a6d8ba8937a5f$var$monthDatedProfileGifts(giftsHistory);
    for (const g of monthDated)byFy.delete(g.fy);
    // Gifts recorded with their day: a plan's (recordDatedGift), or the profile's dated list.
    const events = $171a6d8ba8937a5f$var$giftEvents(byFy, [
        ...monthDated,
        ...$171a6d8ba8937a5f$var$datedGiftsOf(giftsHistory),
        ...datedGifts
    ]);
    if (events.length === 0) return 0;
    return $171a6d8ba8937a5f$var$deprivedOn(events, asOfDate, annualLimit, fiveYearLimit);
}
function $171a6d8ba8937a5f$export$6f9e3cf7d82eb9f9(giftsHistory, strategyOptions = {}, asOfDate = new Date(), extraGiftsByFyEnd = null, /** Gifts with their day (a granny flat right paid above its value, dated to the arrangement). */ extraDatedGifts = null) {
    const strategyGiftsByFyEnd = {};
    // A strategy's gift is made on the day assessed: the five years run from then.
    const datedGifts = [
        ...extraDatedGifts || []
    ];
    const addStrategyGift = (raw)=>{
        const n = raw || 0;
        if (n > 0) datedGifts.push({
            date: asOfDate,
            amount: n
        });
    };
    if (strategyOptions?.downsizeDetails?.giftingAmount) addStrategyGift(strategyOptions.downsizeDetails.giftingAmount);
    if (strategyOptions?.otherStrategies?.gifting && strategyOptions?.otherStrategies?.giftingAmount) addStrategyGift(strategyOptions.otherStrategies.giftingAmount);
    if (strategyOptions?.investmentPropertyDetails?.giftingAmount) addStrategyGift(strategyOptions.investmentPropertyDetails.giftingAmount);
    if (extraGiftsByFyEnd && typeof extraGiftsByFyEnd === 'object') for (const [fy, amt] of Object.entries(extraGiftsByFyEnd)){
        const n = amt || 0;
        if (n > 0) strategyGiftsByFyEnd[fy] = (strategyGiftsByFyEnd[fy] || 0) + n;
    }
    return $171a6d8ba8937a5f$export$e13ba859aba62a6b(giftsHistory, {
        asOfDate: asOfDate,
        strategyGiftsByFyEnd: strategyGiftsByFyEnd,
        datedGifts: datedGifts
    });
}


function $a528307a9ba99a26$export$99c2240daa2a90c(residency, factFind) {
    if (residency === 'granny_flat') return true;
    return residency === 'with_family' && factFind?.livingWithFamily?.grannyFlatInterest === true;
}
function $a528307a9ba99a26$export$eb48a6112ea73d5a(factFind, currentCombinedPartneredRate) {
    const gf = factFind?.grannyFlat;
    const isPartnered = factFind?.adviceFor === 'couple';
    const isGf = $a528307a9ba99a26$export$99c2240daa2a90c(factFind?.client?.currentResidency, factFind) || isPartnered && $a528307a9ba99a26$export$99c2240daa2a90c(factFind?.partner?.currentResidency, factFind);
    if (!isGf || !gf?.dateEntered) return null;
    const dateEntered = gf.dateEntered;
    const ageAtDate = (dob)=>{
        if (!dob) return null;
        const b = new Date(dob);
        const a = new Date(dateEntered);
        let age = a.getFullYear() - b.getFullYear();
        if (a.getMonth() < b.getMonth() || a.getMonth() === b.getMonth() && a.getDate() < b.getDate()) age--;
        return age;
    };
    const clientNb = factFind?.client?.dob ? ageAtDate(factFind.client.dob) + 1 : null;
    const partnerNb = isPartnered && factFind?.partner?.dob ? ageAtDate(factFind.partner.dob) + 1 : null;
    const ageNextBirthdayAtEntry = isPartnered && partnerNb != null ? Math.min(clientNb ?? Infinity, partnerNb) : clientNb;
    const dep = $a528307a9ba99a26$export$c045940c54a80b46({
        amountPaid: gf.amountPaid ?? 0,
        propertyTransferredValue: gf.propertyTransferredValue ?? 0,
        // The home they lived in is a face-value form; another property or other assets are not
        // (owner, 8 Oct 2026). Older records that never said are the home.
        propertyAtFaceValue: !gf.transferredKind || gf.transferredKind === 'home',
        constructionCost: gf.constructionCost ?? 0,
        ageNextBirthdayAtEntry: ageNextBirthdayAtEntry,
        dateEntered: dateEntered,
        currentCombinedPartneredRate: currentCombinedPartneredRate
    });
    return {
        ...dep,
        establishmentFyEnd: (0, $171a6d8ba8937a5f$export$9e47c78a2ac7c305)(new Date(dateEntered))
    };
}
function $a528307a9ba99a26$export$fa1eb478e8c8b011({ ageNextBirthday: ageNextBirthday, combinedPartneredPensionRate: combinedPartneredPensionRate }) {
    const factor = (0, $cc61f543ca04abdf$export$526d0998e326b4e0)(ageNextBirthday);
    const rate = combinedPartneredPensionRate || 0;
    return rate * factor;
}
function $a528307a9ba99a26$export$1b5c7c7dc96b8baf({ amountPaid: amountPaid, propertyTransferredValue: propertyTransferredValue = 0, propertyAtFaceValue: propertyAtFaceValue = true, constructionCost: constructionCost = 0, ageNextBirthday: ageNextBirthday, combinedPartneredPensionRate: combinedPartneredPensionRate }) {
    const cash = amountPaid || 0;
    const property = propertyTransferredValue || 0;
    const construction = constructionCost || 0;
    const conversionFactor = (0, $cc61f543ca04abdf$export$526d0998e326b4e0)(ageNextBirthday);
    const reasonableValue = $a528307a9ba99a26$export$fa1eb478e8c8b011({
        ageNextBirthday: ageNextBirthday,
        combinedPartneredPensionRate: combinedPartneredPensionRate
    });
    // The "consideration received" the person can value up to: the home/construction provided.
    const providedValue = Math.max(propertyAtFaceValue ? property : 0, construction);
    // Value of the granny-flat interest = greater of the reasonableness amount and what was actually provided.
    const interestValue = Math.max(reasonableValue, providedValue);
    // Everything GIVEN for the right (what could be a gift): cash paid + property transferred + the
    // build paid for. Construction on its own can never exceed the interest value (it sets the floor),
    // so it only produces a gift when cash is paid on top — the guide's "additional assets" case.
    const totalPaid = cash + property + construction;
    const deprivation = Math.max(0, totalPaid - interestValue);
    return {
        reasonableValue: reasonableValue,
        interestValue: interestValue,
        totalPaid: totalPaid,
        deprivation: deprivation,
        ageNextBirthday: ageNextBirthday,
        conversionFactor: conversionFactor,
        combinedPartneredPensionRate: combinedPartneredPensionRate || 0,
        providedValue: providedValue
    };
}
function $a528307a9ba99a26$export$c045940c54a80b46({ amountPaid: amountPaid, propertyTransferredValue: propertyTransferredValue = 0, propertyAtFaceValue: propertyAtFaceValue = true, constructionCost: constructionCost = 0, ageNextBirthdayAtEntry: ageNextBirthdayAtEntry, dateEntered: dateEntered, currentCombinedPartneredRate: currentCombinedPartneredRate }) {
    const atDate = dateEntered ? (0, $fed38245453014be$export$d95eae51de7871b2)(dateEntered) : null;
    const rateUsed = atDate ? atDate.combinedAnnual : currentCombinedPartneredRate || 0;
    const result = $a528307a9ba99a26$export$1b5c7c7dc96b8baf({
        amountPaid: amountPaid,
        propertyAtFaceValue: propertyAtFaceValue,
        propertyTransferredValue: propertyTransferredValue,
        constructionCost: constructionCost,
        ageNextBirthday: ageNextBirthdayAtEntry,
        combinedPartneredPensionRate: rateUsed
    });
    return {
        ...result,
        rateUsed: rateUsed,
        rateBasis: atDate ? atDate.basis : 'current-fallback',
        rateApproximated: !atDate
    };
}
function $a528307a9ba99a26$export$6bae1904888d8a72(factFind) {
    const liabilities = factFind?.liabilities || {};
    let total = 0;
    for (const m of liabilities.mortgages || [])if (!m?.assetLink || m.assetLink === 'home') total += Math.max(0, Number(m?.balance) || 0);
    for (const h of liabilities.helocDebt || [])total += Math.max(0, Number(h?.balance) || 0);
    return total;
}
function $a528307a9ba99a26$export$828d07fe6ecf7e29(factFind, startDate, today = new Date()) {
    const now = Math.max(0, Number(factFind?.home?.value) || 0);
    const start = startDate ? startDate instanceof Date ? startDate : new Date(String(startDate)) : null;
    const years = start && !Number.isNaN(start.getTime()) ? (start.getTime() - today.getTime()) / 31557600000 : 0;
    const rate = Number(factFind?.home?.homeGrowthRate) || 0;
    const grown = years > 0 && rate !== 0;
    const homeValue = grown ? now * Math.pow(1 + rate / 100, years) : now;
    const loans = $a528307a9ba99a26$export$6bae1904888d8a72(factFind);
    return {
        homeValue: homeValue,
        loans: loans,
        given: Math.max(0, homeValue - loans),
        grown: years > 0
    };
}


const $d1b9bbc5238c0548$export$5325210a1005d69a = {
    own_home: 'in their own home',
    renting: 'renting',
    with_family: 'living with family',
    retirement_village: 'in a retirement village',
    aged_care: 'in residential aged care',
    granny_flat: 'in a granny flat'
};
const $d1b9bbc5238c0548$var$num = (v)=>{
    const x = typeof v === 'number' ? v : parseFloat(String(v ?? ''));
    return Number.isFinite(x) ? x : 0;
};
const $d1b9bbc5238c0548$export$411666eeb8222a3e = (ff)=>ff?.adviceFor === 'couple';
function $d1b9bbc5238c0548$export$bbffb86c2f82211a(ff, who, strategyOptions = {}) {
    const override = who === 'client' ? strategyOptions?.clientResidencyOverride : strategyOptions?.partnerResidencyOverride;
    const recorded = who === 'client' ? ff?.client?.currentResidency : ff?.partner?.currentResidency;
    const r = override || recorded || '';
    if (r === 'with_family' && (0, $a528307a9ba99a26$export$99c2240daa2a90c)(r, ff)) return 'granny_flat';
    return r;
}
function $d1b9bbc5238c0548$export$2f999b99c41ee933(ff) {
    if (ff?.client?.currentResidency === 'own_home') return true;
    return $d1b9bbc5238c0548$export$411666eeb8222a3e(ff) && ff?.partner?.currentResidency === 'own_home';
}
function $d1b9bbc5238c0548$export$268c35eb6bb35c50(ff, strategyOptions = {}) {
    if ($d1b9bbc5238c0548$export$bbffb86c2f82211a(ff, 'client', strategyOptions) === 'aged_care') return true;
    return $d1b9bbc5238c0548$export$411666eeb8222a3e(ff) && $d1b9bbc5238c0548$export$bbffb86c2f82211a(ff, 'partner', strategyOptions) === 'aged_care';
}
function $d1b9bbc5238c0548$export$98f904391e5edbc2(ff, strategyOptions = {}) {
    if ($d1b9bbc5238c0548$var$num(ff?.home?.value) <= 0) return false;
    return $d1b9bbc5238c0548$export$2f999b99c41ee933(ff) || $d1b9bbc5238c0548$export$268c35eb6bb35c50(ff, strategyOptions);
}
function $d1b9bbc5238c0548$export$6d9ac5bb8b103361(ff) {
    return $d1b9bbc5238c0548$var$num(ff?.home?.value) > 0 && !$d1b9bbc5238c0548$export$2f999b99c41ee933(ff) && !$d1b9bbc5238c0548$export$268c35eb6bb35c50(ff);
}
function $d1b9bbc5238c0548$export$bdceaa91a7a2e637(ff, strategyOptions = {}) {
    const partnered = $d1b9bbc5238c0548$export$411666eeb8222a3e(ff);
    const clientResidency = $d1b9bbc5238c0548$export$bbffb86c2f82211a(ff, 'client', strategyOptions);
    const partnerResidency = partnered ? $d1b9bbc5238c0548$export$bbffb86c2f82211a(ff, 'partner', strategyOptions) : '';
    let isHomeowner = clientResidency === 'own_home' || partnered && partnerResidency === 'own_home';
    if (strategyOptions.rentHome || strategyOptions.downsizeHome) isHomeowner = false;
    if (strategyOptions.downsizeDetails && $d1b9bbc5238c0548$var$num(strategyOptions.downsizeDetails.newHomePurchasePrice) > 0) isHomeowner = true;
    const inCare = clientResidency === 'aged_care' || partnered && partnerResidency === 'aged_care';
    if (inCare && $d1b9bbc5238c0548$var$num(ff?.home?.value) > 0 && !strategyOptions.rentHome && !strategyOptions.downsizeHome) isHomeowner = true;
    if (inCare && strategyOptions.formerHomeExemptionEnded) isHomeowner = false;
    const rvResident = clientResidency === 'retirement_village' || partnered && partnerResidency === 'retirement_village';
    // Once the village has paid the exit entitlement out (8 Oct 2026), the interest is money in hand.
    const rvInterestHeld = !strategyOptions.villageInterestSold && (rvResident || ff?.client?.currentResidency === 'retirement_village' || partnered && ff?.partner?.currentResidency === 'retirement_village');
    const rvEntryContribution = $d1b9bbc5238c0548$var$num(ff?.retirementVillage?.entryContribution);
    const rvIsHomeowner = rvInterestHeld && rvEntryContribution > (0, $1abe73eeef086faf$export$e2cf792e99a08354);
    if (rvIsHomeowner) isHomeowner = true;
    const grannyFlatResident = (0, $a528307a9ba99a26$export$99c2240daa2a90c)(clientResidency, ff) || partnered && (0, $a528307a9ba99a26$export$99c2240daa2a90c)(partnerResidency, ff);
    const grannyFlatEntryContribution = $d1b9bbc5238c0548$var$num(ff?.grannyFlat?.amountPaid) + $d1b9bbc5238c0548$var$num(ff?.grannyFlat?.propertyTransferredValue) + $d1b9bbc5238c0548$var$num(ff?.grannyFlat?.constructionCost);
    const grannyFlatIsHomeowner = grannyFlatResident && grannyFlatEntryContribution > (0, $1abe73eeef086faf$export$e2cf792e99a08354);
    if (grannyFlatIsHomeowner) isHomeowner = true;
    return {
        isHomeowner: isHomeowner,
        rvResident: rvResident,
        rvInterestHeld: rvInterestHeld,
        rvIsHomeowner: rvIsHomeowner,
        rvEntryContribution: rvEntryContribution,
        grannyFlatResident: grannyFlatResident,
        grannyFlatIsHomeowner: grannyFlatIsHomeowner,
        grannyFlatEntryContribution: grannyFlatEntryContribution
    };
}
function $d1b9bbc5238c0548$export$98f8498295c235e7(ff) {
    const couple = $d1b9bbc5238c0548$export$411666eeb8222a3e(ff);
    const person = (who)=>{
        const residency = $d1b9bbc5238c0548$export$bbffb86c2f82211a(ff, who);
        const p = who === 'client' ? ff?.client : ff?.partner;
        return {
            who: who,
            name: String(p?.firstName || '').trim() || (who === 'client' ? 'the client' : 'their partner'),
            residency: residency,
            words: residency ? $d1b9bbc5238c0548$export$5325210a1005d69a[residency] : '',
            inCare: residency === 'aged_care'
        };
    };
    const client = person('client');
    const partner = couple ? person('partner') : null;
    return {
        client: client,
        partner: partner,
        couple: couple,
        livingApart: !!partner && !!client.residency && !!partner.residency && client.residency !== partner.residency,
        anyoneOwnsHome: $d1b9bbc5238c0548$export$2f999b99c41ee933(ff),
        homeValue: $d1b9bbc5238c0548$var$num(ff?.home?.value),
        holdsHomeNobodyLivesIn: $d1b9bbc5238c0548$export$6d9ac5bb8b103361(ff),
        someoneInCare: client.inCare || !!partner?.inCare,
        bothInCare: !!partner && client.inCare && partner.inCare
    };
}


function $0785c68479a63d37$export$f909db9361901de9(factFind, strategyOptions = {}) {
    if (!(0, $d1b9bbc5238c0548$export$2f999b99c41ee933)(factFind)) return null;
    const exempt = (0, $8d8b97815ba787de$export$a4f0fcc41e754c67)(factFind, strategyOptions);
    const partnerStays = (0, $8eecd0af141b9afb$export$6a0c2f6602682b05)(factFind, strategyOptions);
    const forWhom = factFind.goals?.aged_care_for;
    const stayingName = partnerStays ? (forWhom === 'partner' ? factFind.client?.firstName : factFind.partner?.firstName) || 'your partner' : null;
    const capped = 'the home is counted, but only up to the capped amount (not the full value)';
    if (exempt && stayingName) return {
        lead: `${stayingName} lives in the home, so it is not counted`,
        leadRest: ' in the aged care assets assessment while they are there.',
        change: `If that changes \u{2014} for example ${stayingName} later moves out \u{2014} ${capped}, which can increase your HSC and NCCC. The funding options page lets you test that.`
    };
    if (exempt) return {
        lead: 'A protected person lives in the home, so it is not counted',
        leadRest: ' in the aged care assets assessment while they are there.',
        change: `If that changes \u{2014} if they later move out \u{2014} ${capped}, which can increase your HSC and NCCC.`
    };
    return {
        lead: "No protected person lives in the home, so it is counted \u2014 but only up to the capped amount",
        leadRest: ' (not the full value) in the aged care assets assessment.',
        change: "If a protected person \u2014 a partner, a dependent child, a carer or a close relative \u2014 lives there, the home is not counted at all."
    };
}


/**
 * Assessable income for the residential aged care means test (the MTA behind the hotelling and
 * non-clinical care contributions).
 *
 * THE RULE, per the Aged Care Act 2024 arrangements: ordinary income as assessed for the Age
 * Pension PLUS the person's income support payment, EXCLUDING the minimum pension supplement and
 * the energy supplement.
 *
 *   - DVA CLIK 4.3 ("What is total assessable income"): total assessable income "includes a
 *     resident's income support payment (excluding the minimum pension supplement and energy
 *     supplement), and their ordinary/adjusted income as per pension assessment rules".
 *   - DoHAC, "Means assessment for residential aged care" (1 Nov 2025 arrangements): assessable
 *     income "includes the person's social security payment (such as their Age Pension or Service
 *     Pension) but excludes the Energy Supplement and minimum pension supplement".
 *   - The income free area ($35,313.20 at 20 Mar 2026) is CONSTRUCTED on this basis — it sits just
 *     above the maximum single pension precisely so that a full pensioner with little else pays no
 *     income-tested amount. Testing pension-exclusive income against it hands every client an
 *     extra ~$31k of headroom that the Schedule never intended.
 *
 * THE DEFECT THIS REPLACES (adviser-verified against a live client, 2026-08-21): the engine fed
 * the means test `totalAssessableIncome` — the Age Pension income-test measure, which by
 * definition excludes the pension itself. For a single part-pensioner in care the income-tested
 * amount came out $0 and the NCCC was understated by ~$11/day (~$3,900/yr). The couple branch was
 * even written as though the pension were included (subtract it, halve, add half back — which
 * cancels), so the intent existed; the data feed didn't match it.
 *
 * Rate note: each member of an illness-separated couple receives SINGLE-rate supplements, and a
 * couple with someone in residential care is illness-separated — the caller passes that flag from
 * `isIllnessSeparatedCouple` / its strategy context rather than this module re-deriving it.
 */ 
/** The supplements excluded from one person's counted income support, per the rate that applies to them. */ function $8ab1e06940ee4f8b$var$perPersonExclusion(singleRates) {
    return singleRates ? (0, $1abe73eeef086faf$export$5c5a47a925656819).single + (0, $1abe73eeef086faf$export$c43d5cc6e7d53048).single : (0, $1abe73eeef086faf$export$5c5a47a925656819).coupleEach + (0, $1abe73eeef086faf$export$c43d5cc6e7d53048).coupleEach;
}
function $8ab1e06940ee4f8b$export$392d49a94b1386e5(financials, options) {
    const ordinary = financials.totalAssessableIncome || 0;
    const support = Math.max(0, financials.socialSecurity || 0);
    if (!options.isCouple) {
        const includable = Math.max(0, support - $8ab1e06940ee4f8b$var$perPersonExclusion(true));
        return ordinary + includable;
    }
    // Illness-separated members are paid — and shed — SINGLE-rate supplements. `socialSecurity` is
    // the household total; both members of a pensioner couple ordinarily receive the pension, so
    // two exclusions apply, floored at what is actually paid (a tiny part-pension cannot go
    // negative). Where only one member is on payment this excludes slightly too much, which errs
    // toward a marginally HIGHER counted income and fee — the conservative side for advice.
    const eachRate = options.illnessSeparated !== false;
    const includable = Math.max(0, support - 2 * $8ab1e06940ee4f8b$var$perPersonExclusion(eachRate));
    return (ordinary + includable) / 2;
}


/**
 * Calculation engine client — the financial-advice calculation engine now runs server-side
 * (server/src/rest/calculation/) rather than in the browser. One thin wrapper per REST entry
 * point, matching the original local function's parameter order 1:1 so call sites only need to
 * add `await calculationApi.` in front of the existing call (see the calculation-engine migration
 * plan for the exceptions — a handful of functions that used to mutate their arguments in place
 * now return the mutated object(s) instead, since that's the only way a REST call can "mutate").
 */ 'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Walk the prototype chain (excluding the shared Object.prototype) looking for
 * an own `prop`. This distinguishes genuine own/inherited members — including
 * class accessors and template prototypes — from members injected via
 * Object.prototype pollution (e.g. `Object.prototype.username = '...'`), which
 * live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $c319b2c832c2914a$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null && obj !== Object.prototype){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        if ($c319b2c832c2914a$var$hasOwnProperty(obj, prop)) return true;
        obj = $c319b2c832c2914a$var$getPrototypeOf(obj);
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $c319b2c832c2914a$var$getSafeProp = (obj, prop)=>obj != null && $c319b2c832c2914a$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if (!$c319b2c832c2914a$var$isObject(val)) return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $c319b2c832c2914a$var$getPrototypeOf(prototype) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
    // Symbol.iterator as evidence the value is a tagged/iterable type rather
    // than a plain object, while ignoring keys injected onto Object.prototype.
    !$c319b2c832c2914a$var$hasOwnInPrototypeChain(val, $c319b2c832c2914a$var$toStringTag) && !$c319b2c832c2914a$var$hasOwnInPrototypeChain(val, $c319b2c832c2914a$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c319b2c832c2914a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c319b2c832c2914a$var$isObject(val) || $c319b2c832c2914a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $c319b2c832c2914a$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $c319b2c832c2914a$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $c319b2c832c2914a$var$G = $c319b2c832c2914a$var$getGlobal();
const $c319b2c832c2914a$var$FormDataCtor = typeof $c319b2c832c2914a$var$G.FormData !== 'undefined' ? $c319b2c832c2914a$var$G.FormData : undefined;
const $c319b2c832c2914a$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($c319b2c832c2914a$var$FormDataCtor && thing instanceof $c319b2c832c2914a$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $c319b2c832c2914a$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$c319b2c832c2914a$var$isFunction(thing.append)) return false;
    const kind = $c319b2c832c2914a$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c319b2c832c2914a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $c319b2c832c2914a$var$findKey(obj, key) {
    if ($c319b2c832c2914a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $c319b2c832c2914a$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $c319b2c832c2914a$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($c319b2c832c2914a$var$isPlainObject(existing) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(existing, val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c319b2c832c2914a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $c319b2c832c2914a$var$isBuffer(source)) continue;
        $c319b2c832c2914a$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $c319b2c832c2914a$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($c319b2c832c2914a$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $c319b2c832c2914a$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === 'FormData' && thing[$c319b2c832c2914a$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($c319b2c832c2914a$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $c319b2c832c2914a$var$isSafeIterable = (thing)=>thing != null && $c319b2c832c2914a$var$hasOwnInPrototypeChain(thing, $c319b2c832c2914a$var$iterator) && $c319b2c832c2914a$var$isIterable(thing);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isEmptyObject: $c319b2c832c2914a$var$isEmptyObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isReactNativeBlob: $c319b2c832c2914a$var$isReactNativeBlob,
    isReactNative: $c319b2c832c2914a$var$isReactNative,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnInPrototypeChain: $c319b2c832c2914a$var$hasOwnInPrototypeChain,
    getSafeProp: $c319b2c832c2914a$var$getSafeProp,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable,
    isSafeIterable: $c319b2c832c2914a$var$isSafeIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $f8f5102fdfcbfec9$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $f8f5102fdfcbfec9$var$sanitizeValue(value, invalidChars) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$f8f5102fdfcbfec9$var$sanitizeValue(item, invalidChars));
    return $f8f5102fdfcbfec9$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $f8f5102fdfcbfec9$export$9e344cffce061a22 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $f8f5102fdfcbfec9$export$59dd66c2a12d8f62 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $f8f5102fdfcbfec9$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $f8f5102fdfcbfec9$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : (0, $f8f5102fdfcbfec9$export$9e344cffce061a22)(String(value));
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(header) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


'use strict';
const $4e2395edb77acf3a$var$REDACTED = '[REDACTED ****]';
function $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $4e2395edb77acf3a$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source) && $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $4e2395edb77acf3a$var$REDACTED : visit(value);
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
class $4e2395edb77acf3a$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $4e2395edb77acf3a$var$AxiosError(error.message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $4e2395edb77acf3a$var$redactConfig(config, redactKeys) : (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$4e2395edb77acf3a$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$4e2395edb77acf3a$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$4e2395edb77acf3a$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$4e2395edb77acf3a$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$4e2395edb77acf3a$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$4e2395edb77acf3a$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$4e2395edb77acf3a$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$4e2395edb77acf3a$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$4e2395edb77acf3a$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$4e2395edb77acf3a$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $e6cbd383b18c9625$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
'use strict';
const $e6cbd383b18c9625$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? $e6cbd383b18c9625$export$659081b45d03227d : options.maxDepth;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if (typeof $e6cbd383b18c9625$require$Buffer !== 'undefined') return $e6cbd383b18c9625$require$Buffer.from(value);
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNative(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $f66f8c7b4f247caf$var$encode) : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


'use strict';
function $8df8fedf1c1e4428$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(_options, 'encode') || $8df8fedf1c1e4428$export$c564cdbbe6da493;
    const serializeFn = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};






'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}






'use strict';
const $5f8142930b3b943f$var$MAX_DEPTH = (0, $e6cbd383b18c9625$export$659081b45d03227d);
function $5f8142930b3b943f$var$throwIfDepthExceeded(index) {
    if (index > $5f8142930b3b943f$var$MAX_DEPTH) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $5f8142930b3b943f$var$MAX_DEPTH, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    const path = [];
    const pattern = /\w+|\[(\w*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $5f8142930b3b943f$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $5f8142930b3b943f$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


'use strict';
const $843bf0209bc94df8$var$own = (obj, key)=>obj != null && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $843bf0209bc94df8$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $843bf0209bc94df8$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $843bf0209bc94df8$var$own(this, 'transitional') || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $843bf0209bc94df8$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $843bf0209bc94df8$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $843bf0209bc94df8$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;



'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $9fd0919e266b4fda$var$CanceledError extends (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;



const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        if (!e || typeof e.loaded !== 'number') return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(()=>fn(...args));






var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin), (0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};



'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
const $598acbfafd2c63c5$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
const $598acbfafd2c63c5$var$httpProtocolControlCharacters = /[\t\n\r]/g;
function $598acbfafd2c63c5$var$stripLeadingC0ControlOrSpace(url) {
    let i = 0;
    while(i < url.length && url.charCodeAt(i) <= 0x20)i++;
    return url.slice(i);
}
function $598acbfafd2c63c5$var$normalizeURLForProtocolCheck(url) {
    return $598acbfafd2c63c5$var$stripLeadingC0ControlOrSpace(url).replace($598acbfafd2c63c5$var$httpProtocolControlCharacters, '');
}
function $598acbfafd2c63c5$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string' && $598acbfafd2c63c5$var$malformedHttpProtocol.test($598acbfafd2c63c5$var$normalizeURLForProtocolCheck(url))) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Invalid URL: missing "//" after protocol', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
}
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $598acbfafd2c63c5$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $598acbfafd2c63c5$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}




'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, 'validateStatus') && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}




const $ab4625fac3104691$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $ab4625fac3104691$var$setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($ab4625fac3104691$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $ab4625fac3104691$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $ab4625fac3104691$var$resolveConfig(config) {
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(auth, 'username') || '';
        const password = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $ab4625fac3104691$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        $ab4625fac3104691$var$setFormDataHeaders(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $ab4625fac3104691$export$2e2bcd8739ae039 = $ab4625fac3104691$var$resolveConfig;



const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request aborted', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(msg, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach((0, $f8f5102fdfcbfec9$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>signal.addEventListener('abort', onabort, {
            once: true
        }));
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: compute the exact percent-decoded UTF-8 byte length.
 *
 * @param {string} url
 * @returns {number}
 */ const $da69a2069c6136ea$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $da69a2069c6136ea$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $da69a2069c6136ea$var$isHexDigit(str.charCodeAt(i + 1)) && $da69a2069c6136ea$var$isHexDigit(str.charCodeAt(i + 2));
function $da69a2069c6136ea$export$2e2bcd8739ae039(url) {
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) {
        let effectiveLen = body.length;
        const len = body.length; // cache length
        for(let i = 0; i < len; i++)if (body.charCodeAt(i) === 37 /* '%' */  && i + 2 < len) {
            const a = body.charCodeAt(i + 1);
            const b = body.charCodeAt(i + 2);
            const isHex = $da69a2069c6136ea$var$isHexDigit(a) && $da69a2069c6136ea$var$isHexDigit(b);
            if (isHex) {
                effectiveLen -= 2;
                i += 2;
            }
        }
        let pad = 0;
        let idx = len - 1;
        const tailIsPct3D = (j)=>j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
            body.charCodeAt(j - 1) === 51 && // '3'
            (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100); // 'D' or 'd'
        if (idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) {
                pad++;
                idx--;
            } else if (tailIsPct3D(idx)) {
                pad++;
                idx -= 3;
            }
        }
        if (pad === 1 && idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) pad++;
            else if (tailIsPct3D(idx)) pad++;
        }
        const groups = Math.floor(effectiveLen / 4);
        const bytes = groups * 3 - (pad || 0);
        return bytes > 0 ? bytes : 0;
    }
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $da69a2069c6136ea$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
}


const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.18.1";



const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $e52be20a9fc15e96$var$isFunction } = (0, $c319b2c832c2914a$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $e52be20a9fc15e96$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $e52be20a9fc15e96$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $e52be20a9fc15e96$var$factory = (env)=>{
    const globalObject = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global !== undefined && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global !== null ? (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $e52be20a9fc15e96$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $e52be20a9fc15e96$var$isFunction(Request);
    const isResponseSupported = $e52be20a9fc15e96$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $e52be20a9fc15e96$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(configAuth, 'username') || '';
                const password = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($e52be20a9fc15e96$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($e52be20a9fc15e96$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $da69a2069c6136ea$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $c9465135abb26626$export$b0119225647bd83)(stream, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(requestContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Stream request bodies are not supported by the current fetch implementation', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $f8f5102fdfcbfec9$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(responseContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $e52be20a9fc15e96$var$seedCache = new Map();
const $e52be20a9fc15e96$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $e52be20a9fc15e96$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $e52be20a9fc15e96$var$factory(env));
        map = target;
    }
    return target;
};
const $e52be20a9fc15e96$var$adapter = $e52be20a9fc15e96$export$3105c6651375d4fa();
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: {
        get: $e52be20a9fc15e96$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $e8c8c7960873e9ee$var$getAdapter(adapters, config) {
    adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $e8c8c7960873e9ee$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $e8c8c7960873e9ee$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}






'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('options must be an object', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};




'use strict';
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            legacyInterceptorReqResOrdering: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            advertiseZstdAcceptEncoding: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            validateStatusUndefinedResolves: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a, create: $b302555736d21bd7$export$185802fd694ee1f5 } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);


/**
 * Account/auth client — OAuth2 (RFC 6749) against OUR OWN backend, not a third-party auth SaaS.
 *
 *   POST /oauth/token        — grant_type=password (sign-in) or grant_type=refresh_token (silent
 *                               refresh). Returns { access_token, refresh_token, expires_in }.
 *   POST /rest/auth/*        — sign-up, verify-code, resend, password-reset request/confirm, logout.
 *
 * The refresh token is the only thing persisted (in localStorage — it's opaque and single-purpose);
 * the access token lives in memory only and is silently refreshed shortly before it expires.
 *
 * Every request that could end with a session names two things about where it came from — this app's
 * client_id (see OAUTH_CLIENT_ID) and this browser (see deviceIdentifier) — and the server binds the
 * session to both, refusing any later refresh that does not present the same pair. So a refresh token
 * taken from this browser is of no use to another client, or from another browser.
 */ /**
 * Where the API lives — decided in ONE place.
 *
 * WHAT WENT WRONG, 2026-09-10. Eight service files each carried their own copy of
 * `process.env.REACT_APP_API_BASE_URL || 'http://localhost:8787'`. A production frontend was then
 * rebuilt without that variable set, so every one of them fell back to LOCALHOST — on a live site,
 * where localhost is the visitor's own machine and nothing is listening. Login, saving, the
 * calculation engine and the beta gate were all pointing at a machine that isn't the server.
 *
 * The beta gate happened to be the first thing on the page that calls the API, so it was the first
 * to fail, and it failed visibly — which made it look like the gate's bug. It was not: the gate
 * caught a deploy in which nothing would have worked, and said so before anyone got far enough in to
 * be confused by it.
 *
 * TWO CHANGES, so this cannot repeat:
 *
 *   ONE COPY. Eight identical fallbacks is how one gets corrected and seven do not. Everything now
 *   resolves through here.
 *
 *   A SANE FALLBACK. Defaulting to localhost is right in development and never right anywhere else.
 *   When the page is served from a real domain and no address was configured, the API is assumed to
 *   be on the SAME ORIGIN as the app — which is how this is actually deployed. A missing build
 *   variable can now cost, at worst, a same-origin guess that is very likely correct, instead of
 *   silently aiming the whole application at the visitor's own computer.
 *
 * Setting REACT_APP_API_BASE_URL at build time still wins, and is still the right thing to do when
 * the API is on a different host from the site.
 */ /** True for the addresses a developer's own machine answers on. */ function $4e54353814e6aea9$var$isLocalHostname(hostname) {
    return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1' || hostname === '[::1]';
}
function $4e54353814e6aea9$export$8ebae31efd30e025() {
    const configured = String('').trim();
    if (configured) return configured.replace(/\/+$/, '');
    if (typeof window !== 'undefined' && window.location) {
        const { hostname: hostname, origin: origin } = window.location;
        // A real domain: the API sits alongside the app unless we were told otherwise.
        if (hostname && !$4e54353814e6aea9$var$isLocalHostname(hostname) && origin) return origin.replace(/\/+$/, '');
    }
    return 'http://localhost:8787';
}


// Deliberately not a recognizable name (no "token"/"auth"/"awise") and the value is obfuscated at
// rest (see obfuscate/deobfuscate below) — raises the bar for casual inspection of localStorage.
// NOTE: this is NOT a defense against XSS/script-execution in the page; a script running on the
// page can read every localStorage key and reverse a string as easily as reading it plain. The
// real protections are server-side: short-lived refresh tokens, single-use rotation, reuse/theft
// detection, and the client binding below (see oauthRoutes.ts).
const $cc9e8a24185b91b0$var$REFRESH_TOKEN_KEY = 'kx7Q2vLmN9pRzT4';
/**
 * The "don't ask me for a code on this browser for 30 days" token.
 *
 * Same treatment as the refresh token, and for the same reasons: an unrecognisable key, obfuscated
 * at rest, and no illusion that either stops a script running on the page. What actually limits the
 * damage is on the server — it expires, it is stored only as a hash, and revoking a device kills it
 * everywhere at once (see mfaRepo.ts).
 *
 * It is deliberately NOT cleared on sign-out. Signing out means "I have finished", not "this
 * computer is no longer mine" — clearing it would ask for a code every single time anyone signs
 * out and back in, which is most of the point of having it gone.
 */ const $cc9e8a24185b91b0$var$DEVICE_TOKEN_KEY = 'dv8H3wYcB2kFqX6';
/**
 * This app's OAuth client_id — who we are when we ask for a token.
 *
 * A random, opaque value, fixed for the life of this client. The server records it against every
 * session this app opens and will only refresh such a session for a caller presenting the same value
 * (server/src/oauth/clientBinding.ts). So a refresh token lifted out of this browser cannot be spent
 * from a script, a CLI, or any other client that talks to the same API — it gets invalid_grant, not a
 * working session.
 *
 * IT IS NOT A SECRET, and nothing may ever be granted on the strength of it. It is compiled into the
 * JavaScript bundle and anyone can read it out of devtools or send it by hand; RFC 6749 §2.2 is
 * explicit that a client_id is not a credential. What it does is narrow and still worth having: it
 * keeps a token from crossing between clients, which rotation on its own does nothing about.
 *
 * DO NOT CHANGE IT. Every live session is bound to this exact string, so a new value would refuse to
 * refresh any of them and sign every signed-in user out on deploy. (Hardcoded rather than read from
 * REACT_APP_* for the same reason: an environment that forgot to set it would do precisely that.)
 */ const $cc9e8a24185b91b0$var$OAUTH_CLIENT_ID = 'acw-web-Q3eViougX2sngB1FpXv1HA';
/**
 * This browser, as a string — sent with every request that could end with a session, and checked on
 * every refresh thereafter (see server/src/oauth/deviceBinding.ts).
 *
 * WHAT IT BUYS. The server records it against the session and will only refresh that session for a
 * caller presenting the same value. So a refresh token lifted out of this browser — out of
 * localStorage by a script, out of a disk image, out of a copied profile — cannot be spent from
 * anywhere else: not from curl, not from another machine, not from a different locale. The client_id
 * above stops a token crossing between APPLICATIONS; this stops it crossing between BROWSERS while
 * still claiming to be this one, which is the shape an actual token theft takes.
 *
 * IT IS NOT A SECRET, and nothing is granted on the strength of it. The browser already sends its
 * user agent on every request, anybody can set the header to anything, and a script able to steal the
 * refresh token can read `navigator` just as easily. It raises the cost of replaying a token
 * elsewhere from zero to "also copy the fingerprint", and it makes a token pasted into a terminal
 * fail by default. The server stores only a hash of it and no endpoint ever returns it.
 *
 * WHY userAgent + language AND NOT SOMETHING STABLER. This is the owner's specification: the same
 * browser, with the same language. Both halves move — the user agent on roughly every browser update,
 * the language when somebody changes a setting — and when either does, that session's next refresh is
 * refused and the person signs in again. That is the accepted trade, not a defect; it is worth
 * knowing that a monthly browser release is inside the 30-day life of a refresh token, so this will
 * cost occasional, legitimate re-logins.
 *
 * WRAPPED, because this runs during module use in environments that may have no `navigator` at all
 * (a test, a server-side render). An identifier we cannot build is simply omitted — which the server
 * reads as "this session makes no claim", exactly as it did before this existed, rather than failing
 * a sign-in over a fingerprint.
 */ function $cc9e8a24185b91b0$var$deviceIdentifier() {
    try {
        const { userAgent: userAgent, language: language } = navigator;
        if (!userAgent) return undefined;
        return `${userAgent} ${language ?? ''}`.trim();
    } catch  {
        return undefined;
    }
}
/**
 * The two bindings every session-producing request carries. One helper so a new call site cannot pick
 * up the client_id and silently forget the device — which would leave that session unbound, and
 * unbound sessions are precisely what the check is for.
 */ function $cc9e8a24185b91b0$var$sessionBindings() {
    const device = $cc9e8a24185b91b0$var$deviceIdentifier();
    return {
        client_id: $cc9e8a24185b91b0$var$OAUTH_CLIENT_ID,
        ...device ? {
            device_identifier: device
        } : {}
    };
}
/** Reversible, non-cryptographic obfuscation — just avoids the raw token sitting in plain sight. */ function $cc9e8a24185b91b0$var$obfuscate(value) {
    return [
        ...value
    ].reverse().join('');
}
function $cc9e8a24185b91b0$var$deobfuscate(value) {
    return [
        ...value
    ].reverse().join('');
}
function $cc9e8a24185b91b0$var$getApiBaseUrl() {
    // One source for this — see services/apiBase.ts for why eight copies was a problem.
    return (0, $4e54353814e6aea9$export$8ebae31efd30e025)();
}
function $cc9e8a24185b91b0$var$getStoredRefreshToken() {
    const stored = localStorage.getItem($cc9e8a24185b91b0$var$REFRESH_TOKEN_KEY);
    return stored ? $cc9e8a24185b91b0$var$deobfuscate(stored) : null;
}
function $cc9e8a24185b91b0$var$setStoredRefreshToken(token) {
    if (token) localStorage.setItem($cc9e8a24185b91b0$var$REFRESH_TOKEN_KEY, $cc9e8a24185b91b0$var$obfuscate(token));
    else localStorage.removeItem($cc9e8a24185b91b0$var$REFRESH_TOKEN_KEY);
}
/*
 * Every localStorage access is wrapped, because it THROWS rather than returning empty in a browser
 * set to block site data, and in a private window on some configurations. An unhandled throw here
 * would happen during sign-in, before any error boundary is useful — and the correct behaviour when
 * we cannot remember a device is simply to ask for a code, which is the safe answer anyway.
 */ function $cc9e8a24185b91b0$var$getStoredDeviceToken() {
    try {
        const stored = localStorage.getItem($cc9e8a24185b91b0$var$DEVICE_TOKEN_KEY);
        return stored ? $cc9e8a24185b91b0$var$deobfuscate(stored) : null;
    } catch  {
        return null;
    }
}
function $cc9e8a24185b91b0$var$setStoredDeviceToken(token) {
    try {
        if (token) localStorage.setItem($cc9e8a24185b91b0$var$DEVICE_TOKEN_KEY, $cc9e8a24185b91b0$var$obfuscate(token));
        else localStorage.removeItem($cc9e8a24185b91b0$var$DEVICE_TOKEN_KEY);
    } catch  {
    /* Cannot remember this browser — it will be asked for a code next time. */ }
}
function $cc9e8a24185b91b0$export$6b80968fe2572a48() {
    $cc9e8a24185b91b0$var$setStoredDeviceToken(null);
}
// In-memory only — never persisted, so a stolen localStorage dump alone can't impersonate a live
// session for longer than the current access token's short lifetime.
let $cc9e8a24185b91b0$var$accessToken = null;
let $cc9e8a24185b91b0$var$accessTokenExpiresAt = 0; // epoch ms
function $cc9e8a24185b91b0$var$applyTokenResponse(data) {
    $cc9e8a24185b91b0$var$accessToken = data.access_token || null;
    $cc9e8a24185b91b0$var$accessTokenExpiresAt = $cc9e8a24185b91b0$var$accessToken ? Date.now() + Math.max(0, (data.expires_in || 0) - 30) * 1000 : 0;
    $cc9e8a24185b91b0$var$setStoredRefreshToken(data.refresh_token || null);
}
function $cc9e8a24185b91b0$var$clearSession() {
    $cc9e8a24185b91b0$var$accessToken = null;
    $cc9e8a24185b91b0$var$accessTokenExpiresAt = 0;
    $cc9e8a24185b91b0$var$setStoredRefreshToken(null);
}
/** RFC 6749 §5.1/§5.2 token endpoint. Returns the parsed body either way (ok/error shape). */ async function $cc9e8a24185b91b0$var$requestToken(params) {
    let res;
    try {
        res = await fetch(`${$cc9e8a24185b91b0$var$getApiBaseUrl()}/oauth/token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            // client_id goes on BOTH grants, and it has to: the password grant is where the session
            // records it, and the refresh grant is where it is checked. Sending it on one and not the
            // other would bind every session and then refuse to refresh any of them.
            body: new URLSearchParams({
                ...params,
                ...$cc9e8a24185b91b0$var$sessionBindings()
            }).toString()
        });
    } catch  {
        // `fetch` REJECTS when the request never reaches the server — a dropped connection, a server
        // restarting, a laptop waking up. This is the only place that can tell that apart from a
        // server that answered, so it is caught here rather than left to every caller: every consumer of
        // getAccessToken() but one awaited it bare, so a momentary blip during a silent token refresh
        // became an unhandled rejection and threw a full-screen error overlay over the whole app
        // (adviser-reported, 2026-08-20).
        return {
            ok: false,
            status: 0,
            data: {},
            networkError: true
        };
    }
    const data = await res.json().catch(()=>({}));
    return {
        ok: res.ok,
        status: res.status,
        data: data
    };
}
// Refresh tokens are single-use (server rotates + revokes on reuse — see oauthRoutes.ts). If two
// callers both see the access token expired at once, they must share ONE refresh instead of each
// spending the same stored refresh token: the loser would get back an already-revoked token and
// trip the server's reuse/theft detection, which revokes the whole family (including the winner's).
let $cc9e8a24185b91b0$var$refreshPromise = null;
async function $cc9e8a24185b91b0$var$doRefreshAccessToken() {
    const refreshToken = $cc9e8a24185b91b0$var$getStoredRefreshToken();
    if (!refreshToken) return null;
    const { ok: ok, data: data, networkError: networkError } = await $cc9e8a24185b91b0$var$requestToken({
        grant_type: 'refresh_token',
        refresh_token: refreshToken
    });
    // Unreachable is NOT a refusal. Clearing the session here would sign a client out for being
    // briefly offline — and worse, throw away a refresh token that is still perfectly good. Report
    // "no token right now" and leave the stored token alone so the next call can try again.
    if (networkError) return null;
    if (!ok) {
        $cc9e8a24185b91b0$var$clearSession();
        return null;
    }
    $cc9e8a24185b91b0$var$applyTokenResponse(data);
    return $cc9e8a24185b91b0$var$accessToken;
}
/** Silent refresh: trade the stored refresh token for a fresh pair. Clears the session on failure.
 *  Concurrent callers share the same in-flight request rather than racing separate ones. */ function $cc9e8a24185b91b0$var$refreshAccessToken() {
    if (!$cc9e8a24185b91b0$var$refreshPromise) $cc9e8a24185b91b0$var$refreshPromise = $cc9e8a24185b91b0$var$doRefreshAccessToken().finally(()=>{
        $cc9e8a24185b91b0$var$refreshPromise = null;
    });
    return $cc9e8a24185b91b0$var$refreshPromise;
}
function $cc9e8a24185b91b0$export$176fd7948efa0903() {
    $cc9e8a24185b91b0$var$accessTokenExpiresAt = 0;
    return $cc9e8a24185b91b0$var$refreshAccessToken();
}
async function $cc9e8a24185b91b0$export$84773cc9bf7dbe87() {
    if ($cc9e8a24185b91b0$var$accessToken && Date.now() < $cc9e8a24185b91b0$var$accessTokenExpiresAt) return $cc9e8a24185b91b0$var$accessToken;
    return $cc9e8a24185b91b0$var$refreshAccessToken();
}
function $cc9e8a24185b91b0$var$friendlyTokenError(data) {
    if (data?.error_description === 'email_not_verified') return {
        needsEmailConfirm: true
    };
    return {
        message: data?.error_description || 'Incorrect email or password.'
    };
}
async function $cc9e8a24185b91b0$export$9670d83f11d4b64a(email, password) {
    const deviceToken = $cc9e8a24185b91b0$var$getStoredDeviceToken();
    const { ok: ok, data: data, networkError: networkError } = await $cc9e8a24185b91b0$var$requestToken({
        grant_type: 'password',
        username: email,
        password: password,
        // A browser that passed a challenge recently gets to skip this one.
        ...deviceToken ? {
            device_token: deviceToken
        } : {}
    });
    // Never blame the password for a connection problem: friendlyTokenError's default is "Incorrect
    // email or password", which is both wrong and infuriating when the server simply could not be
    // reached.
    if (networkError) return {
        ok: false,
        message: "We couldn't reach AgedCareWise just then. Check your connection and try again."
    };
    if (!ok) return {
        ok: false,
        ...$cc9e8a24185b91b0$var$friendlyTokenError(data)
    };
    if (data.mfa_required && typeof data.mfa_token === 'string') // Deliberately NOT applied as a session — there isn't one yet.
    return {
        ok: false,
        mfaRequired: true,
        mfaToken: data.mfa_token
    };
    $cc9e8a24185b91b0$var$applyTokenResponse(data);
    return {
        ok: true,
        mustSetUpTwoFactor: Boolean(data.mfa_enrolment_required)
    };
}
async function $cc9e8a24185b91b0$export$e58ad95e33a8ebbd(mfaToken, code, trustThisDevice) {
    let res;
    try {
        res = await fetch(`${$cc9e8a24185b91b0$var$getApiBaseUrl()}/oauth/mfa/challenge`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                mfa_token: mfaToken,
                code: code,
                trust_device: trustThisDevice,
                ...$cc9e8a24185b91b0$var$sessionBindings()
            })
        });
    } catch  {
        return {
            ok: false,
            message: "We couldn't reach AgedCareWise just then. Check your connection and try again."
        };
    }
    const data = await res.json().catch(()=>({}));
    if (!res.ok) return {
        ok: false,
        message: String(data?.error_description || "That code wasn't right. Please try again.")
    };
    $cc9e8a24185b91b0$var$applyTokenResponse(data);
    if (typeof data.device_token === 'string') $cc9e8a24185b91b0$var$setStoredDeviceToken(data.device_token);
    return {
        ok: true,
        usedRecoveryCode: Boolean(data.used_recovery_code),
        ...typeof data.recoveryCodesRemaining === 'number' ? {
            recoveryCodesRemaining: data.recoveryCodesRemaining
        } : {}
    };
}
async function $cc9e8a24185b91b0$export$cf64224bcd829024(email, password) {
    const res = await fetch(`${$cc9e8a24185b91b0$var$getApiBaseUrl()}/rest/auth/signup`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            email: email,
            password: password
        })
    });
    const data = await res.json().catch(()=>({}));
    if (!res.ok) return {
        ok: false,
        message: data?.message || "We couldn't create your account just now."
    };
    return {
        ok: true,
        needsEmailConfirm: Boolean(data.needsEmailConfirm)
    };
}
async function $cc9e8a24185b91b0$export$feab9165e44c6d62(email, code) {
    const res = await fetch(`${$cc9e8a24185b91b0$var$getApiBaseUrl()}/rest/auth/verify`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            email: email,
            code: code,
            ...$cc9e8a24185b91b0$var$sessionBindings()
        })
    });
    const data = await res.json().catch(()=>({}));
    if (!res.ok || !data.ok) return {
        ok: false
    };
    $cc9e8a24185b91b0$var$applyTokenResponse(data);
    return {
        ok: true,
        mustSetUpTwoFactor: Boolean(data.mfa_enrolment_required)
    };
}
async function $cc9e8a24185b91b0$export$bb28b2d3718a590f(email) {
    const res = await fetch(`${$cc9e8a24185b91b0$var$getApiBaseUrl()}/rest/auth/resend`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            email: email
        })
    });
    const data = await res.json().catch(()=>({}));
    if (!res.ok) return {
        ok: false,
        message: data?.message
    };
    return {
        ok: true
    };
}
async function $cc9e8a24185b91b0$export$db579c517e4aeb29(email) {
    try {
        const res = await fetch(`${$cc9e8a24185b91b0$var$getApiBaseUrl()}/rest/auth/password-reset/request`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email
            })
        });
        const data = await res.json().catch(()=>({}));
        if (!res.ok) return {
            ok: false,
            message: data?.error?.message || 'Could not send the email just now.'
        };
        return {
            ok: true,
            exists: Boolean(data.exists)
        };
    } catch  {
        return {
            ok: false,
            message: 'Could not reach the server. Check your connection and try again.'
        };
    }
}
async function $cc9e8a24185b91b0$export$e2853351e15b7895(resetToken, newPassword) {
    const res = await fetch(`${$cc9e8a24185b91b0$var$getApiBaseUrl()}/rest/auth/password-reset/confirm`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            token: resetToken,
            password: newPassword,
            ...$cc9e8a24185b91b0$var$sessionBindings()
        })
    });
    const data = await res.json().catch(()=>({}));
    if (!res.ok || !data.ok) return {
        ok: false,
        message: data?.message || 'That reset link is invalid or has expired.'
    };
    $cc9e8a24185b91b0$var$applyTokenResponse(data);
    return {
        ok: true
    };
}
/** Decode the current access token's claims without verifying it (display-only; the server is
 *  always the source of truth for anything that matters). */ function $cc9e8a24185b91b0$var$decodeAccessToken(token) {
    try {
        const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        return payload;
    } catch  {
        return null;
    }
}
async function $cc9e8a24185b91b0$export$a79e7ef8c396bb0e() {
    const token = await $cc9e8a24185b91b0$export$84773cc9bf7dbe87();
    if (!token) return null;
    const claims = $cc9e8a24185b91b0$var$decodeAccessToken(token);
    if (!claims?.sub) return null;
    try {
        const res = await fetch(`${$cc9e8a24185b91b0$var$getApiBaseUrl()}/rest/me`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        if (!res.ok) return {
            id: claims.sub,
            email: claims.email || '',
            firstName: '',
            lastName: ''
        };
        const data = await res.json();
        return {
            id: data.user.id,
            email: data.user.email || '',
            firstName: data.user.firstName || '',
            lastName: data.user.lastName || ''
        };
    } catch  {
        return {
            id: claims.sub,
            email: claims.email || '',
            firstName: '',
            lastName: ''
        };
    }
}
async function $cc9e8a24185b91b0$export$ee515d2564ec047b(firstName, lastName) {
    const token = await $cc9e8a24185b91b0$export$84773cc9bf7dbe87();
    if (!token) return {
        ok: false,
        message: 'Not signed in'
    };
    const res = await fetch(`${$cc9e8a24185b91b0$var$getApiBaseUrl()}/rest/me/name`, {
        method: 'PUT',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            firstName: firstName.trim(),
            lastName: lastName.trim()
        })
    });
    if (!res.ok) return {
        ok: false
    };
    return {
        ok: true
    };
}
async function $cc9e8a24185b91b0$export$b0ac3a1c242cb1ea() {
    const refreshToken = $cc9e8a24185b91b0$var$getStoredRefreshToken();
    $cc9e8a24185b91b0$var$clearSession();
    if (refreshToken) await fetch(`${$cc9e8a24185b91b0$var$getApiBaseUrl()}/rest/auth/logout`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            refresh_token: refreshToken
        })
    }).catch(()=>{});
}
/** Every /rest/mfa/* call goes through here so the bearer token and the empty body are never forgotten. */ async function $cc9e8a24185b91b0$var$mfaRequest(path, init = {}) {
    const token = await $cc9e8a24185b91b0$export$84773cc9bf7dbe87();
    if (!token) return {
        ok: false,
        status: 401,
        message: 'Please sign in again.'
    };
    const method = init.method ?? 'POST';
    let res;
    try {
        res = await fetch(`${$cc9e8a24185b91b0$var$getApiBaseUrl()}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            /*
       * A JSON content-type with NO body is rejected by Fastify before any handler or guard runs, so
       * an action route that takes no arguments still needs `{}` — otherwise "you are not signed in"
       * arrives dressed as a body-parsing error and nobody can tell what went wrong.
       */ ...method === 'GET' ? {} : {
                body: JSON.stringify(init.body ?? {})
            }
        });
    } catch  {
        return {
            ok: false,
            status: 0,
            message: "We couldn't reach AgedCareWise just then. Please try again."
        };
    }
    const data = await res.json().catch(()=>({}));
    if (!res.ok) return {
        ok: false,
        status: res.status,
        message: String(data?.error?.message || data?.message || 'Something went wrong. Please try again.')
    };
    return {
        ok: true,
        data: data
    };
}
async function $cc9e8a24185b91b0$export$765583c85b261dc2() {
    const res = await $cc9e8a24185b91b0$var$mfaRequest('/rest/mfa/status', {
        method: 'GET'
    });
    return res.ok ? res.data : null;
}
async function $cc9e8a24185b91b0$export$ed9663ad0ae94f4d() {
    const res = await $cc9e8a24185b91b0$var$mfaRequest('/rest/mfa/enrol/start');
    return res.ok ? {
        ok: true,
        ...res.data
    } : {
        ok: false,
        message: res.message
    };
}
async function $cc9e8a24185b91b0$export$86f29dce9d2b89d0(code, trustThisDevice) {
    const res = await $cc9e8a24185b91b0$var$mfaRequest('/rest/mfa/enrol/confirm', {
        body: {
            code: code,
            trust_device: trustThisDevice,
            ...$cc9e8a24185b91b0$var$sessionBindings()
        }
    });
    if (!res.ok) return {
        ok: false,
        message: res.message
    };
    $cc9e8a24185b91b0$var$applyTokenResponse(res.data);
    if (typeof res.data.device_token === 'string') $cc9e8a24185b91b0$var$setStoredDeviceToken(res.data.device_token);
    return {
        ok: true,
        recoveryCodes: res.data.recoveryCodes ?? []
    };
}
async function $cc9e8a24185b91b0$export$5441625492178b0a() {
    const res = await $cc9e8a24185b91b0$var$mfaRequest('/rest/mfa/disable', {
        body: {
            ...$cc9e8a24185b91b0$var$sessionBindings()
        }
    });
    if (!res.ok) return {
        ok: false,
        message: res.message
    };
    if (res.data?.access_token) $cc9e8a24185b91b0$var$applyTokenResponse(res.data);
    // The 30-day pass on this browser was granted by a factor that no longer exists.
    $cc9e8a24185b91b0$export$6b80968fe2572a48();
    return {
        ok: true
    };
}
async function $cc9e8a24185b91b0$export$b9b2bfcc65762c74() {
    const res = await $cc9e8a24185b91b0$var$mfaRequest('/rest/mfa/recovery-codes');
    return res.ok ? {
        ok: true,
        recoveryCodes: res.data.recoveryCodes ?? []
    } : {
        ok: false,
        message: res.message
    };
}
async function $cc9e8a24185b91b0$export$ba099937acaf6189() {
    const res = await $cc9e8a24185b91b0$var$mfaRequest('/rest/mfa/devices', {
        method: 'GET'
    });
    return res.ok && Array.isArray(res.data) ? res.data : [];
}
async function $cc9e8a24185b91b0$export$48c5329203f063b8() {
    const res = await $cc9e8a24185b91b0$var$mfaRequest('/rest/mfa/devices/revoke-all');
    // This browser is one of the ones just revoked, so drop our copy too rather than presenting a
    // token the server has already forgotten.
    if (res.ok) $cc9e8a24185b91b0$export$6b80968fe2572a48();
    return res.ok ? {
        ok: true
    } : {
        ok: false,
        message: res.message
    };
}


/**
 * CurrencyInput/NumberInput emit `number | undefined` on every keystroke (undefined when blank),
 * so the fields below are already real numbers or absent by the time a save reaches this point —
 * this is a backstop, not a live conversion path, against a future numeric field being wired up
 * to a raw text input (or otherwise assigned a stray string) without going through
 * CurrencyInput/NumberInput. FormInput is text-only (email/tel/date/month) and never emits a
 * numeric-field value at all, so it can't be the source of a stray string here either.
 * `assets[].costBase` used to be excluded here (it doubled as a 'Pre CGT' text marker), but the
 * pre-1985 exemption is now derived from the asset's recorded acquisition month (see
 * capitalGainsTax.ts's isPreCgtAsset), so costBase normalizes like every other numeric field below.
 * `acquiredOn` is a `YYYY-MM` string from a FormInput and is deliberately NOT listed as numeric.
 */ const $3b66eba236b50ffc$export$51d57466d53d81f = {
    home: [
        'value',
        'homeGrowthRate',
        'likelyRent',
        'likelyExpenses',
        'landSizeValue',
        'separateTitlesValue',
        'businessUseValue',
        'equityReleaseAmount',
        'commercialReverseMortgageAmount'
    ],
    rent: [
        'rentAmount'
    ],
    grannyFlat: [
        'amountPaid',
        'propertyTransferredValue',
        'constructionCost'
    ],
    retirementVillage: [
        'entryContribution',
        'ongoingFees',
        'yearsResidency',
        'dmfPctPerYear',
        'dmfCapYears',
        'capitalGainSharePct',
        'expectedResaleValue',
        'reinstatementCost',
        'refundMonths',
        'expectedResaleMonths'
    ],
    livingWithFamily: [
        'saleProceeds',
        'boardPerWeek'
    ],
    careStay: [
        'roomPrice',
        'radPaid',
        'dailyPayment',
        'contributionsPaidThisYear',
        'contributionsPaidToDate'
    ],
    assetItem: [
        'value',
        'incomeRate',
        'growthRate',
        'frankingCredit',
        'costBase',
        'rent',
        'expenses',
        'purchasePrice',
        'rcv',
        'income',
        'guaranteePeriodYears',
        'reversionPct'
    ],
    liabilityItem: [
        'balance',
        'repayments',
        'interestRate',
        'loanTerm'
    ],
    structureItem: [
        'apportionmentClient',
        'apportionmentPartner',
        'annualDistributionPa'
    ],
    otherIncomeItem: [
        'amount',
        'dbPaymentAmount',
        'dbDeductibleAmount',
        'dbIndexationPct',
        'dbReversionPct'
    ],
    expenses: [
        'livingExpenses'
    ],
    capitalExpenseItem: [
        'amount'
    ],
    /** frontend/App.js's coupleValidation useState — CurrencyInput/raw-number-input backed, so
   *  already numbers in practice, but sellingCosts is explicitly kept as '' when cleared
   *  (see CoupleValidationModal.js) and needs the same drop-when-blank treatment as everything else. */ coupleValidationItem: [
        'partnerAnnualRent',
        'sellingCosts',
        'emergencyFund',
        'partnerEntryYear',
        'partnerFutureRoomPrice',
        'stampDuty'
    ]
};
function $3b66eba236b50ffc$export$e6ed5a41d50496b3(obj, fields) {
    if (!obj || typeof obj !== 'object') return;
    const rec = obj;
    for (const field of fields){
        if (!(field in rec)) continue;
        const value = rec[field];
        if (typeof value !== 'string') continue;
        const trimmed = value.trim();
        if (trimmed === '') {
            delete rec[field];
            continue;
        }
        const parsed = parseFloat(trimmed);
        if (Number.isNaN(parsed)) delete rec[field];
        else rec[field] = parsed;
    }
}
function $3b66eba236b50ffc$export$a9c2d1d6ba0d8024(fd) {
    if (!fd) return;
    $3b66eba236b50ffc$export$e6ed5a41d50496b3(fd.home, $3b66eba236b50ffc$export$51d57466d53d81f.home);
    $3b66eba236b50ffc$export$e6ed5a41d50496b3(fd.rent, $3b66eba236b50ffc$export$51d57466d53d81f.rent);
    $3b66eba236b50ffc$export$e6ed5a41d50496b3(fd.grannyFlat, $3b66eba236b50ffc$export$51d57466d53d81f.grannyFlat);
    $3b66eba236b50ffc$export$e6ed5a41d50496b3(fd.retirementVillage, $3b66eba236b50ffc$export$51d57466d53d81f.retirementVillage);
    $3b66eba236b50ffc$export$e6ed5a41d50496b3(fd.livingWithFamily, $3b66eba236b50ffc$export$51d57466d53d81f.livingWithFamily);
    $3b66eba236b50ffc$export$e6ed5a41d50496b3(fd.client?.careStay, $3b66eba236b50ffc$export$51d57466d53d81f.careStay);
    $3b66eba236b50ffc$export$e6ed5a41d50496b3(fd.partner?.careStay, $3b66eba236b50ffc$export$51d57466d53d81f.careStay);
    $3b66eba236b50ffc$export$63f3c40af3c9d80d(fd.assets);
    for (const list of Object.values(fd.liabilities || {}))if (Array.isArray(list)) list.forEach((item)=>$3b66eba236b50ffc$export$e6ed5a41d50496b3(item, $3b66eba236b50ffc$export$51d57466d53d81f.liabilityItem));
    if (Array.isArray(fd.structures)) fd.structures.forEach((item)=>$3b66eba236b50ffc$export$e6ed5a41d50496b3(item, $3b66eba236b50ffc$export$51d57466d53d81f.structureItem));
    if (Array.isArray(fd.income?.otherIncomes)) fd.income.otherIncomes.forEach((item)=>$3b66eba236b50ffc$export$e6ed5a41d50496b3(item, $3b66eba236b50ffc$export$51d57466d53d81f.otherIncomeItem));
    $3b66eba236b50ffc$export$e6ed5a41d50496b3(fd.expenses, $3b66eba236b50ffc$export$51d57466d53d81f.expenses);
    if (Array.isArray(fd.expenses?.capitalExpenses)) fd.expenses.capitalExpenses.forEach((item)=>$3b66eba236b50ffc$export$e6ed5a41d50496b3(item, $3b66eba236b50ffc$export$51d57466d53d81f.capitalExpenseItem));
}
function $3b66eba236b50ffc$export$6811a62c555fd7e8(item) {
    $3b66eba236b50ffc$export$e6ed5a41d50496b3(item, $3b66eba236b50ffc$export$51d57466d53d81f.assetItem);
}
function $3b66eba236b50ffc$export$479c6e144c5d2033(item) {
    $3b66eba236b50ffc$export$e6ed5a41d50496b3(item, $3b66eba236b50ffc$export$51d57466d53d81f.liabilityItem);
}
function $3b66eba236b50ffc$export$63f3c40af3c9d80d(assets) {
    for (const list of Object.values(assets || {}))if (Array.isArray(list)) list.forEach((item)=>$3b66eba236b50ffc$export$e6ed5a41d50496b3(item, $3b66eba236b50ffc$export$51d57466d53d81f.assetItem));
}


/**
 * Investment profiles — THE single published source for what super and pension balances are
 * assumed to earn, everywhere in the product.
 *
 * One table serves three consumers, so no rate can drift out of step with the others:
 *   1. The client profile's super / account-based-pension cards — the risk-profile dropdown
 *      pre-fills the "assumed annual return" field from this table (Balanced by default).
 *   2. Strategy-created assets — when a suggestion-engine strategy books a downsizer
 *      contribution, it invests in the same diversified share / managed-fund portfolio the
 *      sell-and-invest strategies assume (4% income + 5% growth, 70% franked ≈ 9% gross). A
 *      100%-growth-assets portfolio IS the High growth allocation, so the strategy constants in
 *      downsizerContributionUtils.ts are DERIVED from this table's High growth row. Before this
 *      table existed the product carried five different numbers for two wrappers (7% new-ABP
 *      default, 5% engine fallback, hidden 5% super default, 9% strategy ABP, 7.65% strategy
 *      accumulation).
 *   3. The Assumptions page and SOA appendices — they display these figures rather than their
 *      own copies.
 *
 * The wrapper-neutral principle (adviser ruling, 2026-08-18): super and pension are wrappers
 * around the same investments, so within a profile the underlying portfolio return is one number
 * and only the TAX differs. As of 2026-08-19 that principle is STRUCTURAL rather than asserted:
 * a profile is defined ONLY by its portfolio (income, growth, franked share) and both wrapper
 * figures are DERIVED from it —
 *      pension     = income + growth            (pension-phase earnings are tax-free: net = gross)
 *      accumulation = pension − componentised fund tax   (see fundTaxDragPct)
 * — so no one, including a licensee setting their own assumptions, can enter a super figure that
 * contradicts the portfolio it is supposed to describe. It also collapses what used to be two
 * numbers (a "typical published" accumulation preset and a separately-derived strategy rate) into
 * one, which is what a firm's actuary would expect: one portfolio, one tax model, one answer.
 *
 * All figures are % p.a., net of fund fees and taxes.
 */ /** Accumulation-phase earnings tax inside the fund. Pension phase pays none. */ const $0f2c0a6799fe36da$export$1efbd2068a715997 = 0.15;
/** Company tax rate behind franking credits (the gross-up factor is frankingRate / (1 − 30%)). */ const $0f2c0a6799fe36da$var$FRANKING_COMPANY_RATE = 0.3;
const $0f2c0a6799fe36da$export$35a2faf371deff8d = 0.10;
function $0f2c0a6799fe36da$export$e081fd95b8a8205d(split, incomeTaxRate, gainsTaxRate) {
    const frankedIncome = split.incomeRatePct * (split.frankingPct / 100);
    const frankingCredits = frankedIncome * ($0f2c0a6799fe36da$var$FRANKING_COMPANY_RATE / (1 - $0f2c0a6799fe36da$var$FRANKING_COMPANY_RATE));
    const incomeTax = incomeTaxRate * (split.incomeRatePct + frankingCredits) - frankingCredits;
    const gainsTax = gainsTaxRate * split.growthRatePct;
    return incomeTax + gainsTax;
}
const $0f2c0a6799fe36da$var$round2 = (n)=>Math.round(n * 100) / 100;
function $0f2c0a6799fe36da$export$cd457b0896bf574b(label, personal) {
    const pensionNetPct = $0f2c0a6799fe36da$var$round2(personal.incomeRatePct + personal.growthRatePct);
    return {
        label: label,
        personal: {
            ...personal
        },
        pensionNetPct: pensionNetPct,
        accumulationNetPct: $0f2c0a6799fe36da$var$round2(pensionNetPct - $0f2c0a6799fe36da$export$e081fd95b8a8205d(personal, $0f2c0a6799fe36da$export$1efbd2068a715997, $0f2c0a6799fe36da$export$35a2faf371deff8d))
    };
}
const $0f2c0a6799fe36da$export$a1842411b99a91f0 = {
    conservative: {
        label: 'Conservative',
        personal: {
            incomeRatePct: 3.2,
            growthRatePct: 1.5,
            frankingPct: 20
        }
    },
    moderately_conservative: {
        label: 'Moderately conservative',
        personal: {
            incomeRatePct: 3.2,
            growthRatePct: 2.4,
            frankingPct: 35
        }
    },
    balanced: {
        label: 'Balanced',
        personal: {
            incomeRatePct: 3.1,
            growthRatePct: 3.5,
            frankingPct: 50
        }
    },
    growth: {
        label: 'Growth',
        personal: {
            incomeRatePct: 3.5,
            growthRatePct: 4.0,
            frankingPct: 60
        }
    },
    // 100% growth assets — the 4% income + 5% growth, 70%-franked share / managed-fund portfolio
    // every sell-and-invest strategy books.
    high_growth: {
        label: 'High growth',
        personal: {
            incomeRatePct: 4,
            growthRatePct: 5,
            frankingPct: 70
        }
    }
};
const $0f2c0a6799fe36da$export$55c76d26484d72a8 = {
    conservative: $0f2c0a6799fe36da$export$cd457b0896bf574b('Conservative', $0f2c0a6799fe36da$export$a1842411b99a91f0.conservative.personal),
    moderately_conservative: $0f2c0a6799fe36da$export$cd457b0896bf574b('Moderately conservative', $0f2c0a6799fe36da$export$a1842411b99a91f0.moderately_conservative.personal),
    balanced: $0f2c0a6799fe36da$export$cd457b0896bf574b('Balanced', $0f2c0a6799fe36da$export$a1842411b99a91f0.balanced.personal),
    growth: $0f2c0a6799fe36da$export$cd457b0896bf574b('Growth', $0f2c0a6799fe36da$export$a1842411b99a91f0.growth.personal),
    high_growth: $0f2c0a6799fe36da$export$cd457b0896bf574b('High growth', $0f2c0a6799fe36da$export$a1842411b99a91f0.high_growth.personal)
};
const $0f2c0a6799fe36da$export$c14c81fc2b7ae703 = JSON.parse(JSON.stringify($0f2c0a6799fe36da$export$55c76d26484d72a8));
const $0f2c0a6799fe36da$export$62973aa9238fb7ab = {
    bankIncomePct: 2,
    termDepositIncomePct: 4,
    sharesIncomePct: 4,
    sharesGrowthPct: 5,
    sharesFrankingPct: 70,
    propertyYieldPct: 3.5,
    propertyExpenseRatioPct: 25,
    propertyGrowthPct: 5
};
const $0f2c0a6799fe36da$export$b037eefb915b86ec = {
    ...$0f2c0a6799fe36da$export$62973aa9238fb7ab
};
/** Every asset-class figure is a percentage; only franking may exceed the return range. */ const $0f2c0a6799fe36da$var$ASSET_CLASS_BOUNDS = {
    bankIncomePct: 30,
    termDepositIncomePct: 30,
    sharesIncomePct: 30,
    sharesGrowthPct: 30,
    sharesFrankingPct: 100,
    propertyYieldPct: 30,
    propertyExpenseRatioPct: 100,
    propertyGrowthPct: 30
};
function $0f2c0a6799fe36da$export$1789f7f4cdb387a(cma) {
    const problems = [];
    if (!cma || typeof cma !== 'object') return [
        'No assumptions provided.'
    ];
    const merged = {};
    for (const id of $0f2c0a6799fe36da$export$56315028e4277c0c){
        const override = cma.profiles?.[id];
        const label = $0f2c0a6799fe36da$export$55c76d26484d72a8[id].label;
        const personal = override?.personal;
        if (!override) {
            merged[id] = $0f2c0a6799fe36da$export$55c76d26484d72a8[id];
            continue;
        }
        const returns = [
            personal?.incomeRatePct,
            personal?.growthRatePct
        ];
        const franking = personal?.frankingPct;
        if (returns.some((n)=>typeof n !== 'number' || !Number.isFinite(n) || n < 0 || n > 30) || typeof franking !== 'number' || !Number.isFinite(franking) || franking < 0 || franking > 100) {
            problems.push(`${label}: income and growth must be numbers between 0% and 30%, and the franked share between 0% and 100%.`);
            merged[id] = $0f2c0a6799fe36da$export$55c76d26484d72a8[id];
            continue;
        }
        merged[id] = $0f2c0a6799fe36da$export$cd457b0896bf574b(label, personal);
    }
    if (problems.length === 0) for(let i = 1; i < $0f2c0a6799fe36da$export$56315028e4277c0c.length; i++){
        const prev = merged[$0f2c0a6799fe36da$export$56315028e4277c0c[i - 1]];
        const curId = $0f2c0a6799fe36da$export$56315028e4277c0c[i];
        const cur = merged[curId];
        if (cur.pensionNetPct <= prev.pensionNetPct) problems.push(`${$0f2c0a6799fe36da$export$55c76d26484d72a8[curId].label}: each option must earn more than the one before it (this one totals ${cur.pensionNetPct.toFixed(2)}%, the one above ${prev.pensionNetPct.toFixed(2)}%).`);
    }
    for (const [key, max] of Object.entries($0f2c0a6799fe36da$var$ASSET_CLASS_BOUNDS)){
        const value = cma.assetClasses?.[key];
        if (value === undefined) continue;
        if (typeof value !== 'number' || !Number.isFinite(value) || value < 0 || value > max) problems.push(`${key}: must be a number between 0% and ${max}%.`);
    }
    if (cma.newMoneyDefaultProfile && !(cma.newMoneyDefaultProfile in $0f2c0a6799fe36da$export$55c76d26484d72a8)) problems.push('The new-money default must be one of the five options.');
    return problems;
}
let $0f2c0a6799fe36da$var$activeFirmCma = null;
/** The signed-in firm's set (frontend, applied at boot) — what `resetFirmAssumptions` restores TO,
 *  so a transient per-request apply can never strip the session's own firm table. */ let $0f2c0a6799fe36da$var$persistentCma = null;
function $0f2c0a6799fe36da$export$202e846e294fdcb3(cma) {
    if (cma) {
        const problems = $0f2c0a6799fe36da$export$a42016e3c679edd(cma);
        if (problems.length > 0) return problems;
        $0f2c0a6799fe36da$var$persistentCma = cma;
        return [];
    }
    $0f2c0a6799fe36da$var$persistentCma = null;
    $0f2c0a6799fe36da$export$86de4199c2044792();
    return [];
}
function $0f2c0a6799fe36da$export$a42016e3c679edd(cma) {
    if (!cma) return [
        'No assumptions provided.'
    ];
    const problems = $0f2c0a6799fe36da$export$1789f7f4cdb387a(cma);
    if (problems.length > 0) return problems;
    $0f2c0a6799fe36da$var$writeTable(cma);
    $0f2c0a6799fe36da$var$activeFirmCma = cma;
    return [];
}
/** Writes a set (or the tool defaults, with null) into the active tables, in place. */ function $0f2c0a6799fe36da$var$writeTable(cma) {
    for (const id of $0f2c0a6799fe36da$export$56315028e4277c0c){
        const override = cma?.profiles?.[id];
        // Both wrapper figures are DERIVED from the portfolio — a stored set's own accumulation /
        // pension fields (legacy shape) are deliberately ignored, so the table can never carry a
        // super figure that contradicts the portfolio beside it.
        const row = override?.personal ? $0f2c0a6799fe36da$export$cd457b0896bf574b($0f2c0a6799fe36da$export$55c76d26484d72a8[id].label, override.personal) : $0f2c0a6799fe36da$export$55c76d26484d72a8[id];
        $0f2c0a6799fe36da$export$c14c81fc2b7ae703[id].accumulationNetPct = row.accumulationNetPct;
        $0f2c0a6799fe36da$export$c14c81fc2b7ae703[id].pensionNetPct = row.pensionNetPct;
        $0f2c0a6799fe36da$export$c14c81fc2b7ae703[id].personal = {
            ...row.personal
        };
    }
    for (const key of Object.keys($0f2c0a6799fe36da$export$62973aa9238fb7ab)){
        const override = cma?.assetClasses?.[key];
        $0f2c0a6799fe36da$export$b037eefb915b86ec[key] = typeof override === 'number' ? override : $0f2c0a6799fe36da$export$62973aa9238fb7ab[key];
    }
}
function $0f2c0a6799fe36da$export$86de4199c2044792() {
    $0f2c0a6799fe36da$var$writeTable($0f2c0a6799fe36da$var$persistentCma);
    $0f2c0a6799fe36da$var$activeFirmCma = $0f2c0a6799fe36da$var$persistentCma;
}
function $0f2c0a6799fe36da$export$8bdfa8b8b11554d0() {
    return $0f2c0a6799fe36da$var$activeFirmCma;
}
/**
 * Runs `fn` with a fact-find's embedded firm assumptions applied, ALWAYS restoring the defaults
 * after — the server-side seam. Calculation requests carry the firm's table inside the fact-find
 * (`factFind.firmAssumptions`, injected by the frontend per request and schema-validated), so the
 * engine needs no tenant lookup and the applied numbers travel with the file they priced. Safe
 * because every engine evaluation is synchronous: nothing else can interleave between apply and
 * reset on a single-threaded runtime.
 */ let $0f2c0a6799fe36da$var$withFirmDepth = 0;
function $0f2c0a6799fe36da$export$6f00a5b82b44e208(factFind, fn) {
    const cma = factFind?.firmAssumptions;
    // RE-ENTRANT: evaluators wrap their whole run, and inside it the projection engine and the
    // financial assessor wrap again with clones of the same fact-find. Only the OUTERMOST frame
    // applies and resets — an inner reset would strip the firm's numbers mid-projection.
    $0f2c0a6799fe36da$var$withFirmDepth++;
    let applied = false;
    if ($0f2c0a6799fe36da$var$withFirmDepth === 1 && cma) applied = $0f2c0a6799fe36da$export$a42016e3c679edd(cma).length === 0; // invalid set: run on defaults, never half-applied
    try {
        return fn();
    } finally{
        $0f2c0a6799fe36da$var$withFirmDepth--;
        if (applied) $0f2c0a6799fe36da$export$86de4199c2044792();
    }
}
const $0f2c0a6799fe36da$export$56315028e4277c0c = [
    'conservative',
    'moderately_conservative',
    'balanced',
    'growth',
    'high_growth'
];
const $0f2c0a6799fe36da$export$f692c4a779b1d5f6 = 'balanced';
function $0f2c0a6799fe36da$export$d5067509ad465da9(profileId, wrapper) {
    const row = $0f2c0a6799fe36da$export$c14c81fc2b7ae703[profileId];
    return wrapper === 'pension' ? row.pensionNetPct : row.accumulationNetPct;
}
function $0f2c0a6799fe36da$export$acc007763407ac2f(wrapper, rate) {
    const value = Number(rate);
    if (rate === null || rate === undefined || rate === '' || !Number.isFinite(value)) return 'custom';
    for (const id of $0f2c0a6799fe36da$export$56315028e4277c0c){
        if (Math.abs($0f2c0a6799fe36da$export$d5067509ad465da9(id, wrapper) - value) < 0.005) return id;
    }
    return 'custom';
}
const $0f2c0a6799fe36da$export$6a5447bd1ce1c210 = 'conservative';
function $0f2c0a6799fe36da$export$580cfd0c6323bf7e(factFind) {
    const raw = factFind?.goals?.newMoneyInvestmentProfile;
    if (raw && raw in $0f2c0a6799fe36da$export$c14c81fc2b7ae703) return raw;
    // A firm may set its own unanswered-new-money default; the tool's is Conservative.
    return $0f2c0a6799fe36da$var$activeFirmCma?.newMoneyDefaultProfile || $0f2c0a6799fe36da$export$6a5447bd1ce1c210;
}
function $0f2c0a6799fe36da$export$848647f164f42923(factFind) {
    const raw = factFind?.goals?.newMoneyInvestmentProfile;
    return !!raw && raw in $0f2c0a6799fe36da$export$c14c81fc2b7ae703;
}
function $0f2c0a6799fe36da$export$2916b5515a75a453(profileId) {
    return $0f2c0a6799fe36da$export$c14c81fc2b7ae703[profileId].personal;
}
function $0f2c0a6799fe36da$export$7bfc03a1cb4bfc25(profileId) {
    return $0f2c0a6799fe36da$export$c14c81fc2b7ae703[profileId].accumulationNetPct;
}
const $0f2c0a6799fe36da$export$9693b383bd49e40a = 0.30;
const $0f2c0a6799fe36da$export$4dc921a4380ac181 = 10;
function $0f2c0a6799fe36da$export$d4067a97c0e75560(profileId) {
    const row = $0f2c0a6799fe36da$export$c14c81fc2b7ae703[profileId];
    return $0f2c0a6799fe36da$var$round2(row.pensionNetPct - $0f2c0a6799fe36da$export$e081fd95b8a8205d(row.personal, $0f2c0a6799fe36da$export$9693b383bd49e40a, $0f2c0a6799fe36da$export$9693b383bd49e40a));
}



function $55a1d8a64f1e5dfa$var$getApiBaseUrl() {
    // One source for this — see services/apiBase.ts for why eight copies was a problem.
    return (0, $4e54353814e6aea9$export$8ebae31efd30e025)();
}
async function $55a1d8a64f1e5dfa$var$authHeaders() {
    const token = await (0, $cc9e8a24185b91b0$export$84773cc9bf7dbe87)();
    if (!token) throw new Error('Not signed in');
    return {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
}
// Request-body keys that carry a whole fact-find-shaped object (`factFind` — the wire name the routes
// still read, whatever the local is called — or an equivalent clone, e.g. getGrannyFlatBeforeAfter's
// `baseFactFind`, applyResidualDeployment's `data`) vs. a single asset row vs. the whole assets map.
// The calc engine's Money fields are typed `number` — this is the single choke point every
// calculation-engine call passes through, so numeric-input strings are coerced here rather than at
// each of the ~50 call sites across the app.
const $55a1d8a64f1e5dfa$var$FACTFIND_SHAPED_KEYS = [
    'factFind',
    'baseFactFind',
    'baselineFactFind',
    'simulatedFactFind',
    'data'
];
const $55a1d8a64f1e5dfa$var$ASSET_ITEM_KEYS = [
    'asset',
    'propertyAsset'
];
const $55a1d8a64f1e5dfa$var$ASSETS_MAP_KEYS = [
    'assets'
];
function $55a1d8a64f1e5dfa$var$normalizeCalcRequestBody(body) {
    // Loosely typed on purpose: this is the choke point every calc-engine call passes through (~50
    // call sites), carrying whatever mix of factFind/asset/strategyOptions shapes each route needs.
    const clone = structuredClone(body ?? {});
    // The signed-in firm's capital market assumptions ride with every fact-find-shaped payload, so
    // the server engine prices at the SAME table this browser session displays — the one rule this
    // whole system rests on: the numbers shown must be the numbers used. Refreshed per request from
    // the firm's current settings; absent for consumer/default sessions.
    const firmCma = (0, $0f2c0a6799fe36da$export$8bdfa8b8b11554d0)();
    for (const key of $55a1d8a64f1e5dfa$var$FACTFIND_SHAPED_KEYS)if (clone[key]) {
        (0, $3b66eba236b50ffc$export$a9c2d1d6ba0d8024)(clone[key]);
        if (firmCma) clone[key].firmAssumptions = firmCma;
    }
    for (const key of $55a1d8a64f1e5dfa$var$ASSET_ITEM_KEYS)if (clone[key]) (0, $3b66eba236b50ffc$export$6811a62c555fd7e8)(clone[key]);
    for (const key of $55a1d8a64f1e5dfa$var$ASSETS_MAP_KEYS)if (clone[key]) (0, $3b66eba236b50ffc$export$63f3c40af3c9d80d)(clone[key]);
    return clone;
}
/**
 * How long a COMPOSITE suggestion-engine call may take. The ordinary 30s suits the fine-grained
 * calls (one assessment, one projection); it is the wrong budget for an evaluation that projects
 * every candidate a generator produced. Measured at ~100ms per candidate per run, so the aged care
 * engine — which can generate 300+ scenarios for a client with several asset types (19 RAD levels
 * × funding-order permutations × keep/rent × downsize variants, plus debt-payoff twins) — crossed
 * 30s and failed outright with "timeout of 30000ms exceeded", after the adviser had waited the
 * full 30 seconds. Correctness is not negotiable, so the answer is to allow the time rather than
 * to evaluate fewer candidates.
 */ const $55a1d8a64f1e5dfa$var$COMPOSITE_ENGINE_TIMEOUT_MS = 180000;
/*
 * THE HEAVY ENGINE RUNS ARE KEPT (owner, 20 Oct 2026: "for a plan that is saved … shouldn't it open up
 * immediately. The processing wheel should generally only happen the first time you do the run").
 * A composite engine call (every candidate projected) is cached by EXACTLY what was sent — the
 * normalised body, which includes the whole file, the service plan, the options and the firm's
 * assumptions — plus today's date and the server's engine run id (a restart or deploy starts afresh).
 * So any change at all is a new key and runs again; an identical request is answered at once, in
 * memory for this tab and from the browser's own store after a reload. Identical calls in flight share
 * one request. Results are data the server already returned to this browser; nothing new is stored
 * anywhere else.
 */ /*
 * KEPT SMALL (26 Oct 2026: a tab reached 2.6 GB and the store failed with "structuredClone … out of memory").
 * One aged care run is tens of megabytes — every candidate's yearly rows — so 40 of them in memory, and a
 * store that read all 40 back to find the oldest, was gigabytes. A few runs cover going back and forth
 * between a file's screens; anything older simply runs again.
 */ const $55a1d8a64f1e5dfa$var$ENGINE_MEMO_MAX = 3;
const $55a1d8a64f1e5dfa$var$ENGINE_STORE_MAX = 8;
const $55a1d8a64f1e5dfa$var$engineMemo = new Map();
const $55a1d8a64f1e5dfa$var$engineInFlight = new Map();
let $55a1d8a64f1e5dfa$var$engineRevPromise = null;
function $55a1d8a64f1e5dfa$var$engineRev(headers) {
    if (!$55a1d8a64f1e5dfa$var$engineRevPromise) $55a1d8a64f1e5dfa$var$engineRevPromise = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${$55a1d8a64f1e5dfa$var$getApiBaseUrl()}/rest/calculation/engine-rev`, {
        headers: headers,
        timeout: 10000
    }).then((r)=>String(r.data?.result || '') || null).catch(()=>{
        $55a1d8a64f1e5dfa$var$engineRevPromise = null;
        return null;
    });
    return $55a1d8a64f1e5dfa$var$engineRevPromise;
}
/** A fast 53-bit string hash (cyrb53) — the key only needs to tell requests apart, not be secret. */ function $55a1d8a64f1e5dfa$var$hashString(str) {
    let h1 = 0xdeadbeef;
    let h2 = 0x41c6ce57;
    for(let i = 0; i < str.length; i++){
        const ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507) ^ Math.imul(h2 ^ h2 >>> 13, 3266489909);
    h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507) ^ Math.imul(h1 ^ h1 >>> 13, 3266489909);
    return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString(36) + str.length.toString(36);
}
const $55a1d8a64f1e5dfa$var$localDay = ()=>{
    const d = new Date();
    return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
};
/**
 * The browser's own store, for results that should survive a reload. Every failure is a cache miss.
 *
 * Version 2 (26 Oct 2026) keeps each run's time in a separate small 'meta' store, so pruning reads only
 * keys and times — never the runs themselves — and drops the version-1 store, which could hold forty
 * runs from earlier server restarts that no request would ever match again.
 */ let $55a1d8a64f1e5dfa$var$engineStorePromise = null;
function $55a1d8a64f1e5dfa$var$engineStore() {
    if ($55a1d8a64f1e5dfa$var$engineStorePromise) return $55a1d8a64f1e5dfa$var$engineStorePromise;
    $55a1d8a64f1e5dfa$var$engineStorePromise = new Promise((resolve)=>{
        try {
            if (typeof indexedDB === 'undefined') {
                resolve(null);
                return;
            }
            const req = indexedDB.open('acw-engine-cache', 2);
            req.onupgradeneeded = ()=>{
                const db = req.result;
                if (db.objectStoreNames.contains('runs')) db.deleteObjectStore('runs');
                if (db.objectStoreNames.contains('meta')) db.deleteObjectStore('meta');
                db.createObjectStore('runs');
                db.createObjectStore('meta');
            };
            req.onsuccess = ()=>resolve(req.result);
            req.onerror = ()=>resolve(null);
            req.onblocked = ()=>resolve(null);
        } catch  {
            resolve(null);
        }
    });
    return $55a1d8a64f1e5dfa$var$engineStorePromise;
}
function $55a1d8a64f1e5dfa$export$285cb3e34ba4e96(entries, currentKey, max = $55a1d8a64f1e5dfa$var$ENGINE_STORE_MAX) {
    const [, rev, day] = currentKey.split('|');
    const stale = entries.filter((e)=>{
        const [, r, d] = e.key.split('|');
        return r !== rev || d !== day;
    }).map((e)=>e.key);
    const live = entries.filter((e)=>!stale.includes(e.key)).sort((a, b)=>a.at - b.at);
    const over = live.slice(0, Math.max(0, live.length - max)).map((e)=>e.key);
    return [
        ...stale,
        ...over
    ];
}
async function $55a1d8a64f1e5dfa$var$storeGet(key) {
    const db = await $55a1d8a64f1e5dfa$var$engineStore();
    if (!db) return undefined;
    return new Promise((resolve)=>{
        try {
            const r = db.transaction('runs', 'readonly').objectStore('runs').get(key);
            r.onsuccess = ()=>resolve(r.result?.value);
            r.onerror = ()=>resolve(undefined);
        } catch  {
            resolve(undefined);
        }
    });
}
async function $55a1d8a64f1e5dfa$var$storePut(key, value) {
    const db = await $55a1d8a64f1e5dfa$var$engineStore();
    if (!db) return;
    try {
        const tx = db.transaction([
            'runs',
            'meta'
        ], 'readwrite');
        tx.objectStore('runs').put({
            value: value
        }, key);
        const meta = tx.objectStore('meta');
        meta.put(Date.now(), key);
        // Keep the newest few — read from the small 'meta' store only, never the runs themselves.
        const times = meta.getAll();
        const keys = meta.getAllKeys();
        tx.oncomplete = ()=>{
            const at = times.result || [];
            const ks = keys.result || [];
            const drop = $55a1d8a64f1e5dfa$export$285cb3e34ba4e96(ks.map((k, i)=>({
                    key: String(k),
                    at: Number(at[i]) || 0
                })), key);
            if (!drop.length) return;
            try {
                const t2 = db.transaction([
                    'runs',
                    'meta'
                ], 'readwrite');
                drop.forEach((k)=>{
                    t2.objectStore('runs').delete(k);
                    t2.objectStore('meta').delete(k);
                });
            } catch  {}
        };
    } catch  {}
}
const $55a1d8a64f1e5dfa$export$5af2600f75f369ac = [
    1000,
    2000,
    4000,
    8000,
    15000
];
async function $55a1d8a64f1e5dfa$export$19c0e332f9adb982(send, delays = $55a1d8a64f1e5dfa$export$5af2600f75f369ac) {
    for(let attempt = 0;; attempt += 1)try {
        return await send();
    } catch (err) {
        const noResponse = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).isAxiosError(err) && !err.response && err.code !== 'ECONNABORTED';
        if (!noResponse || attempt >= delays.length) throw err;
        await new Promise((r)=>setTimeout(r, delays[attempt]));
    }
}
async function $55a1d8a64f1e5dfa$export$294edb0a4b4cafe8(send) {
    try {
        return await send(await $55a1d8a64f1e5dfa$var$authHeaders());
    } catch (err) {
        if (!(0, $57966c7e0affc4cb$export$2e2bcd8739ae039).isAxiosError(err) || err.response?.status !== 401) throw err;
        await (0, $cc9e8a24185b91b0$export$176fd7948efa0903)();
        return send(await $55a1d8a64f1e5dfa$var$authHeaders());
    }
}
async function $55a1d8a64f1e5dfa$var$postCalc(name, body, timeoutMs = 30000) {
    const headers = await $55a1d8a64f1e5dfa$var$authHeaders();
    const normalised = $55a1d8a64f1e5dfa$var$normalizeCalcRequestBody(body);
    let key = null;
    if (timeoutMs === $55a1d8a64f1e5dfa$var$COMPOSITE_ENGINE_TIMEOUT_MS) {
        const rev = await $55a1d8a64f1e5dfa$var$engineRev(headers);
        if (rev) key = `${name}|${rev}|${$55a1d8a64f1e5dfa$var$localDay()}|${$55a1d8a64f1e5dfa$var$hashString(JSON.stringify(normalised))}`;
    }
    if (key) {
        if ($55a1d8a64f1e5dfa$var$engineMemo.has(key)) return structuredClone($55a1d8a64f1e5dfa$var$engineMemo.get(key));
        const flying = $55a1d8a64f1e5dfa$var$engineInFlight.get(key);
        if (flying) return structuredClone(await flying);
        const stored = await $55a1d8a64f1e5dfa$var$storeGet(key);
        if (stored !== undefined) {
            $55a1d8a64f1e5dfa$var$engineMemo.set(key, stored);
            while($55a1d8a64f1e5dfa$var$engineMemo.size > $55a1d8a64f1e5dfa$var$ENGINE_MEMO_MAX)$55a1d8a64f1e5dfa$var$engineMemo.delete($55a1d8a64f1e5dfa$var$engineMemo.keys().next().value);
            return structuredClone(stored);
        }
    }
    try {
        const request = $55a1d8a64f1e5dfa$export$19c0e332f9adb982(()=>$55a1d8a64f1e5dfa$export$294edb0a4b4cafe8((current)=>(0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$55a1d8a64f1e5dfa$var$getApiBaseUrl()}/rest/calculation/${name}`, normalised, {
                    headers: current,
                    timeout: timeoutMs
                }))).then((res)=>res.data.result);
        if (key) $55a1d8a64f1e5dfa$var$engineInFlight.set(key, request);
        const result = await request;
        if (!key) return result;
        $55a1d8a64f1e5dfa$var$engineInFlight.delete(key);
        $55a1d8a64f1e5dfa$var$engineMemo.set(key, result);
        while($55a1d8a64f1e5dfa$var$engineMemo.size > $55a1d8a64f1e5dfa$var$ENGINE_MEMO_MAX)$55a1d8a64f1e5dfa$var$engineMemo.delete($55a1d8a64f1e5dfa$var$engineMemo.keys().next().value);
        $55a1d8a64f1e5dfa$var$storePut(key, result);
        return structuredClone(result);
    } catch (err) {
        if (key) $55a1d8a64f1e5dfa$var$engineInFlight.delete(key);
        // "timeout of 30000ms exceeded" tells an adviser nothing they can act on.
        if ((0, $57966c7e0affc4cb$export$2e2bcd8739ae039).isAxiosError(err) && err.code === 'ECONNABORTED') throw new Error("This analysis is taking longer than we allow for. It usually means there are a lot of strategies to model for this client \u2014 try shortening the projection period, then run it again.");
        throw err;
    }
}
const $55a1d8a64f1e5dfa$export$463f0620dd36e1f8 = (factFind, strategyOptions = {}, yearsSinceRented = 0, projectionContext = {})=>$55a1d8a64f1e5dfa$var$postCalc('calculateFinancials', {
        factFind: factFind,
        strategyOptions: strategyOptions,
        yearsSinceRented: yearsSinceRented,
        projectionContext: projectionContext
    });
const $55a1d8a64f1e5dfa$export$6f9e3cf7d82eb9f9 = (giftsHistory, strategyOptions = {}, asOfDate = new Date(), extraGiftsByFyEnd = null)=>$55a1d8a64f1e5dfa$var$postCalc('calculateDeprivedAssets', {
        giftsHistory: giftsHistory,
        strategyOptions: strategyOptions,
        asOfDate: asOfDate,
        extraGiftsByFyEnd: extraGiftsByFyEnd
    });
const $55a1d8a64f1e5dfa$export$a9748024cd29327a = (agedCareAssessableIncome, agedCareAssessableAssets, useScheduleCoupleIncomeBands)=>$55a1d8a64f1e5dfa$var$postCalc('computeMeansTestedFees', {
        agedCareAssessableIncome: agedCareAssessableIncome,
        agedCareAssessableAssets: agedCareAssessableAssets,
        useScheduleCoupleIncomeBands: useScheduleCoupleIncomeBands
    });
const $55a1d8a64f1e5dfa$export$10bd982d1f08e6ee = (agedCareAssessableIncome, agedCareAssessableAssets, useScheduleCoupleIncomeBands)=>$55a1d8a64f1e5dfa$var$postCalc('getMtaBreakdown', {
        agedCareAssessableIncome: agedCareAssessableIncome,
        agedCareAssessableAssets: agedCareAssessableAssets,
        useScheduleCoupleIncomeBands: useScheduleCoupleIncomeBands
    });
const $55a1d8a64f1e5dfa$export$a42dd84ddeb28371 = (agedCareAssessableIncome, agedCareAssessableAssets, useScheduleCoupleIncomeBands)=>$55a1d8a64f1e5dfa$var$postCalc('computeMeansTestedCareFee2014', {
        agedCareAssessableIncome: agedCareAssessableIncome,
        agedCareAssessableAssets: agedCareAssessableAssets,
        useScheduleCoupleIncomeBands: useScheduleCoupleIncomeBands
    });
const $55a1d8a64f1e5dfa$export$fb677777baef0897 = ({ factFind: factFind, financials: financials, radInput: radInput, radPaid: radPaid, overallStrategy: overallStrategy, extraServiceFeeInput: extraServiceFeeInput = 0, formatCurrency: formatCurrency = false, resident: resident, radPaidHousehold: radPaidHousehold })=>$55a1d8a64f1e5dfa$var$postCalc('calculateAgedCareCosts', {
        factFind: factFind,
        financials: financials,
        radInput: radInput,
        radPaid: radPaid,
        overallStrategy: overallStrategy,
        extraServiceFeeInput: extraServiceFeeInput,
        formatCurrency: !!formatCurrency,
        ...resident ? {
            resident: resident
        } : {},
        ...radPaidHousehold != null ? {
            radPaidHousehold: radPaidHousehold
        } : {}
    });
const $55a1d8a64f1e5dfa$export$9b95c99516118f10 = (factFind, strategyOptions = {})=>$55a1d8a64f1e5dfa$var$postCalc('isIllnessSeparatedCouple', {
        factFind: factFind,
        strategyOptions: strategyOptions
    });
const $55a1d8a64f1e5dfa$export$7b84565bbb0eef12 = (factFind)=>$55a1d8a64f1e5dfa$var$postCalc('getAgedCareModellerResidencyOverrides', {
        factFind: factFind
    });
const $55a1d8a64f1e5dfa$export$8ada184d5eef4694 = (dob, refDate = new Date())=>$55a1d8a64f1e5dfa$var$postCalc('calculateAge', {
        dob: dob,
        refDate: refDate
    });
const $55a1d8a64f1e5dfa$export$3f6250a0954ba7fc = (factFind, strategyOptions = {})=>$55a1d8a64f1e5dfa$var$postCalc('resolveMtaCoupleIncomeThresholds', {
        factFind: factFind,
        strategyOptions: strategyOptions
    });
const $55a1d8a64f1e5dfa$export$75699a59a86ef1ab = (factFind, strategyOptions, agedCareCosts, legacyYears, options = {})=>$55a1d8a64f1e5dfa$var$postCalc('runProjections', {
        factFind: factFind,
        strategyOptions: strategyOptions,
        agedCareCosts: agedCareCosts,
        legacyYears: legacyYears,
        options: options
    }, $55a1d8a64f1e5dfa$var$COMPOSITE_ENGINE_TIMEOUT_MS);
const $55a1d8a64f1e5dfa$export$e95a0c7472081943 = (factFind, candidates, legacyYears, supportCostAnnual = 0)=>$55a1d8a64f1e5dfa$var$postCalc('evaluateCashflowPensionCandidates', {
        factFind: factFind,
        candidates: candidates,
        legacyYears: legacyYears,
        supportCostAnnual: supportCostAnnual
    }, $55a1d8a64f1e5dfa$var$COMPOSITE_ENGINE_TIMEOUT_MS);
const $55a1d8a64f1e5dfa$export$78e9d7fb110b2cac = (params)=>$55a1d8a64f1e5dfa$var$postCalc('computeYearOneFullAustralianFyBlend', params);
const $55a1d8a64f1e5dfa$export$ec33525b18058039 = (params)=>$55a1d8a64f1e5dfa$var$postCalc('computeYearOneFullAustralianFyBlendSupportAtHome', params);
const $55a1d8a64f1e5dfa$export$7c78bf5386f0643f = (params)=>$55a1d8a64f1e5dfa$var$postCalc('computeYearOneFullAustralianFyBlendRetirementVillage', params);
const $55a1d8a64f1e5dfa$export$e5422a7f4e7fbdd0 = (factFind, strategyOptions, villageInputs, legacyYears, options = {})=>$55a1d8a64f1e5dfa$var$postCalc('runRetirementVillageProjections', {
        factFind: factFind,
        strategyOptions: strategyOptions,
        villageInputs: villageInputs,
        legacyYears: legacyYears,
        options: options
    }, $55a1d8a64f1e5dfa$var$COMPOSITE_ENGINE_TIMEOUT_MS);
const $55a1d8a64f1e5dfa$export$15cb494f5ce70974 = (villageInputs)=>$55a1d8a64f1e5dfa$var$postCalc('getVillageCostSummary', {
        villageInputs: villageInputs
    });
const $55a1d8a64f1e5dfa$export$51ca4b84e58af4b9 = (factFind, rvStrategy, villageInputs)=>$55a1d8a64f1e5dfa$var$postCalc('buildSimulatedFactFindForVillageStrategy', {
        factFind: factFind,
        rvStrategy: rvStrategy,
        villageInputs: villageInputs
    });
const $55a1d8a64f1e5dfa$export$2f966089c4f904da = (factFind, propertyAsset, grossAmount)=>$55a1d8a64f1e5dfa$var$postCalc('computeRvIpNetForAllocation', {
        factFind: factFind,
        propertyAsset: propertyAsset,
        grossAmount: grossAmount
    });
const $55a1d8a64f1e5dfa$export$d5119f51b5211c8b = (factFind, entryFeeFunding = {}, cgtOverrides = {})=>$55a1d8a64f1e5dfa$var$postCalc('computeRvEntryFeeFundingTotals', {
        factFind: factFind,
        entryFeeFunding: entryFeeFunding,
        cgtOverrides: cgtOverrides
    });
const $55a1d8a64f1e5dfa$export$8e7496bf07ef5a98 = (factFind, propertyAsset, amountToSell)=>$55a1d8a64f1e5dfa$var$postCalc('computeInvestmentPropertyNetForAmount', {
        factFind: factFind,
        propertyAsset: propertyAsset,
        amountToSell: amountToSell
    });
const $55a1d8a64f1e5dfa$export$fb67395f10ad20c9 = (factFind, strategy)=>$55a1d8a64f1e5dfa$var$postCalc('buildAnnuityImpact', {
        factFind: factFind,
        strategy: strategy
    });
const $55a1d8a64f1e5dfa$export$3e335727e573fe15 = (factFind, annuityRecord)=>$55a1d8a64f1e5dfa$var$postCalc('applyAnnuityToFactFind', {
        factFind: factFind,
        annuityRecord: annuityRecord
    });
const $55a1d8a64f1e5dfa$export$fc6c67b5fdf45998 = (annuityRecord)=>$55a1d8a64f1e5dfa$var$postCalc('summariseAnnuityImpact', {
        annuityRecord: annuityRecord
    });
const $55a1d8a64f1e5dfa$export$3db873cf0123b7cf = (factFind, financials, participantType = 'standard', nwopCategory = null, meansDisclosed = true, previousITCF = 0, person = 'client', contributionOptions = {})=>$55a1d8a64f1e5dfa$var$postCalc('calculateSupportAtHomeContribution', {
        factFind: factFind,
        financials: financials,
        participantType: participantType,
        nwopCategory: nwopCategory,
        meansDisclosed: meansDisclosed,
        previousITCF: previousITCF,
        person: person,
        contributionOptions: contributionOptions
    });
const $55a1d8a64f1e5dfa$export$3fe0e13ec85e5380 = (factFind, financials, participantType = 'standard', nwopCategory = null, meansDisclosed = true, previousITCF = 0, incomeSplitRatio = 0.5, contributionOptions = {})=>$55a1d8a64f1e5dfa$var$postCalc('calculateIndividualContributions', {
        factFind: factFind,
        financials: financials,
        participantType: participantType,
        nwopCategory: nwopCategory,
        meansDisclosed: meansDisclosed,
        previousITCF: previousITCF,
        incomeSplitRatio: incomeSplitRatio,
        contributionOptions: contributionOptions
    });
const $55a1d8a64f1e5dfa$export$7fb415e878d63867 = (annualContribution, currentCumulative = 0, participantType = 'standard')=>$55a1d8a64f1e5dfa$var$postCalc('yearsUntilCapReached', {
        annualContribution: annualContribution,
        currentCumulative: currentCumulative,
        participantType: participantType
    });
const $55a1d8a64f1e5dfa$export$bb01b201c6492ed7 = (factFind, asset, saleAmount, details = {})=>$55a1d8a64f1e5dfa$var$postCalc('calculateSharePartialDisposalTax', {
        factFind: factFind,
        asset: asset,
        saleAmount: saleAmount,
        details: details
    });
const $55a1d8a64f1e5dfa$export$1436ab50c5990307 = (taxSummary, overrideTotal)=>$55a1d8a64f1e5dfa$var$postCalc('getEffectiveDisposalCgt', {
        taxSummary: taxSummary,
        overrideTotal: overrideTotal
    });
const $55a1d8a64f1e5dfa$export$2778f99280b2ce68 = (raw)=>$55a1d8a64f1e5dfa$var$postCalc('parseCgtOverride', {
        raw: raw
    });
const $55a1d8a64f1e5dfa$export$777cdddf3f231419 = (factFind, investmentPropertyDetails)=>$55a1d8a64f1e5dfa$var$postCalc('getInvestmentPropertyTaxSummary', {
        factFind: factFind,
        investmentPropertyDetails: investmentPropertyDetails
    });
const $55a1d8a64f1e5dfa$export$f70460bedec8e810 = (factFind, asset, details = {})=>$55a1d8a64f1e5dfa$var$postCalc('calculateInvestmentPropertyDisposalTax', {
        factFind: factFind,
        asset: asset,
        details: details
    });
const $55a1d8a64f1e5dfa$export$57d0fb9544f11f95 = (asset, config)=>$55a1d8a64f1e5dfa$var$postCalc('resolveCostBase', {
        asset: asset,
        config: config
    });
const $55a1d8a64f1e5dfa$export$321afe5948362992 = (asset)=>$55a1d8a64f1e5dfa$var$postCalc('isPreCgtAsset', {
        asset: asset
    });
const $55a1d8a64f1e5dfa$export$4925b8eeac08d64e = ({ costBase: costBase, proceeds: proceeds, acquisitionDate: acquisitionDate, disposalDate: disposalDate = new Date(), cpiRate: cpiRate = 0, config: config })=>$55a1d8a64f1e5dfa$var$postCalc('assessableGainForSale', {
        costBase: costBase,
        proceeds: proceeds,
        acquisitionDate: acquisitionDate,
        disposalDate: disposalDate,
        cpiRate: cpiRate,
        config: config
    });
const $55a1d8a64f1e5dfa$export$bb4a59e402c33896 = (simulatedFactFind, options = {})=>$55a1d8a64f1e5dfa$var$postCalc('runGrannyFlatProjections', {
        simulatedFactFind: simulatedFactFind,
        options: options
    });
const $55a1d8a64f1e5dfa$export$b426c10567c13d23 = (baseFactFind, gf)=>$55a1d8a64f1e5dfa$var$postCalc('getGrannyFlatBeforeAfter', {
        baseFactFind: baseFactFind,
        gf: gf
    });
const $55a1d8a64f1e5dfa$export$a4daa50757e2f837 = (baseFactFind, gf = {})=>$55a1d8a64f1e5dfa$var$postCalc('buildSimulatedFactFindForGrannyFlat', {
        baseFactFind: baseFactFind,
        gf: gf
    });
const $55a1d8a64f1e5dfa$export$eb48a6112ea73d5a = (factFind, currentCombinedPartneredRate)=>$55a1d8a64f1e5dfa$var$postCalc('getGrannyFlatDeprivationFromFactFind', {
        factFind: factFind,
        currentCombinedPartneredRate: currentCombinedPartneredRate
    });
const $55a1d8a64f1e5dfa$export$e0ff603d890d58d6 = (factFind, candidates, legacyYears, grannyFlatDate, /** The calendar the rows are cut on; the deep dive passes 'calendar_year' with ONE candidate. */ projectionPeriodMode)=>$55a1d8a64f1e5dfa$var$postCalc('evaluateGrannyFlatCandidates', {
        factFind: factFind,
        candidates: candidates,
        legacyYears: legacyYears,
        ...grannyFlatDate ? {
            grannyFlatDate: grannyFlatDate
        } : {},
        ...projectionPeriodMode ? {
            projectionPeriodMode: projectionPeriodMode
        } : {}
    }, $55a1d8a64f1e5dfa$var$COMPOSITE_ENGINE_TIMEOUT_MS);
const $55a1d8a64f1e5dfa$export$3c56e8c3a3f7ace8 = (factFind, candidates, legacyYears, downsizeDate, /** The calendar the rows are cut on; the deep dive passes 'calendar_year' with ONE candidate. */ projectionPeriodMode)=>$55a1d8a64f1e5dfa$var$postCalc('evaluateDownsizerCandidates', {
        factFind: factFind,
        candidates: candidates,
        legacyYears: legacyYears,
        ...downsizeDate ? {
            downsizeDate: downsizeDate
        } : {},
        ...projectionPeriodMode ? {
            projectionPeriodMode: projectionPeriodMode
        } : {}
    }, $55a1d8a64f1e5dfa$var$COMPOSITE_ENGINE_TIMEOUT_MS);
const $55a1d8a64f1e5dfa$export$d1e9143ee86c38c3 = (factFind, villageInputs, candidates, legacyYears, villageEntryDate)=>$55a1d8a64f1e5dfa$var$postCalc('evaluateRetirementVillageCandidates', {
        factFind: factFind,
        villageInputs: villageInputs,
        candidates: candidates,
        legacyYears: legacyYears,
        ...villageEntryDate ? {
            villageEntryDate: villageEntryDate
        } : {}
    }, $55a1d8a64f1e5dfa$var$COMPOSITE_ENGINE_TIMEOUT_MS);
const $55a1d8a64f1e5dfa$export$2440fc29f5473353 = (factFind, servicePlan, legacyYears, evaluationOptions)=>$55a1d8a64f1e5dfa$var$postCalc('computeSupportAtHomeBaselineData', {
        factFind: factFind,
        servicePlan: servicePlan,
        legacyYears: legacyYears,
        evaluationOptions: evaluationOptions
    }, $55a1d8a64f1e5dfa$var$COMPOSITE_ENGINE_TIMEOUT_MS);
const $55a1d8a64f1e5dfa$export$6b5b0c38f513b6f3 = (args)=>$55a1d8a64f1e5dfa$var$postCalc('sahCareUpTests', args, $55a1d8a64f1e5dfa$var$COMPOSITE_ENGINE_TIMEOUT_MS);
const $55a1d8a64f1e5dfa$export$7d4b40198f92b886 = (factFind, baselineData, servicePlan, legacyYears, candidates, evaluationOptions)=>$55a1d8a64f1e5dfa$var$postCalc('evaluateSupportAtHomeStrategies', {
        factFind: factFind,
        baselineData: baselineData,
        servicePlan: servicePlan,
        legacyYears: legacyYears,
        candidates: candidates,
        evaluationOptions: evaluationOptions
    }, $55a1d8a64f1e5dfa$var$COMPOSITE_ENGINE_TIMEOUT_MS);
const $55a1d8a64f1e5dfa$export$4a966bd6278b0c87 = (factFind, agedCareCosts, scenarios, legacyYears, careStartDate, radDrawdown, /** `'2025'` = a no-worse-off resident opting in to the 1 November 2025 fee arrangements; a fact about the case, like the entry date. */ residentialFeeArrangements, /**
   * The calendar the candidates' rows are cut on. Omit for the ranking run.
   *
   * The deep dive passes 'calendar_year' with ONE scenario in the array to re-cut that candidate:
   * the fact-find a candidate is projected from is derived server-side and never sent here, so the
   * re-run has to go back through the engine rather than be rebuilt on this side (owner, 23 Sep 2026).
   */ projectionPeriodMode, /** The couple's second room, where both are entering care (see the engine's `SecondRoomInput`). */ secondRoom, /** A change of aged care home for someone already in care (see the engine's `FacilityMoveInput`); every candidate but "stay put" moves them. */ facilityMove, /** Leaving a retirement village for care (see the engine's `VillageExitInput`): the exit entitlement pays the room when it arrives. */ villageExit, /** Rows without the year's HTML working and full-year blend (26 Oct 2026); a plan is asked for in full before it is opened. */ lite)=>$55a1d8a64f1e5dfa$var$postCalc('evaluateAgedCareRadFundingScenarios', {
        factFind: factFind,
        agedCareCosts: agedCareCosts,
        scenarios: scenarios,
        legacyYears: legacyYears,
        ...careStartDate ? {
            careStartDate: careStartDate
        } : {},
        ...radDrawdown ? {
            radDrawdown: radDrawdown
        } : {},
        ...residentialFeeArrangements ? {
            residentialFeeArrangements: residentialFeeArrangements
        } : {},
        ...projectionPeriodMode ? {
            projectionPeriodMode: projectionPeriodMode
        } : {},
        ...secondRoom && secondRoom.roomPrice > 0 ? {
            secondRoom: secondRoom
        } : {},
        ...facilityMove && facilityMove.newRoomPrice > 0 ? {
            facilityMove: facilityMove
        } : {},
        ...villageExit && villageExit.entitlement > 0 ? {
            villageExit: villageExit
        } : {},
        ...lite ? {
            lite: true
        } : {}
    }, $55a1d8a64f1e5dfa$var$COMPOSITE_ENGINE_TIMEOUT_MS);
const $55a1d8a64f1e5dfa$export$a72a115b20fefbbf = (assets, factFind, details = {}, options = {})=>$55a1d8a64f1e5dfa$var$postCalc('applyDownsizerContributionsToAssets', {
        assets: assets,
        factFind: factFind,
        details: details,
        options: options
    });
const $55a1d8a64f1e5dfa$export$323aae9f0aa61406 = (factFind, ownership = 'client')=>$55a1d8a64f1e5dfa$var$postCalc('isDownsizerContributionEligible', {
        factFind: factFind,
        ownership: ownership
    });
const $55a1d8a64f1e5dfa$export$d1b692f4d3924fcd = (factFind, ownership = 'client')=>$55a1d8a64f1e5dfa$var$postCalc('canCommenceAbpFromDownsizer', {
        factFind: factFind,
        ownership: ownership
    });
const $55a1d8a64f1e5dfa$export$e4323f936f13d681 = (factFind, strategyOptions = {})=>$55a1d8a64f1e5dfa$var$postCalc('applyAgedCareDownsizeToFactFind', {
        factFind: factFind,
        strategyOptions: strategyOptions
    });
const $55a1d8a64f1e5dfa$export$525fe6203be9cb4 = (factFind, scenario)=>$55a1d8a64f1e5dfa$var$postCalc('agedCareScenarioPositionFactFind', {
        factFind: factFind,
        scenario: scenario
    });
const $55a1d8a64f1e5dfa$export$b7160ddedb3f53b2 = (factFind, candidate)=>$55a1d8a64f1e5dfa$var$postCalc('cashflowPensionCandidatePositionFactFind', {
        factFind: factFind,
        candidate: candidate
    });
const $55a1d8a64f1e5dfa$export$56004bc8d68e8454 = (deployment)=>$55a1d8a64f1e5dfa$var$postCalc('describeResidualDeployment', {
        deployment: deployment
    });
const $55a1d8a64f1e5dfa$export$efee12160933bebf = (data, deployment, ctx = {})=>$55a1d8a64f1e5dfa$var$postCalc('applyResidualDeployment', {
        data: data,
        deployment: deployment,
        ctx: ctx
    });
const $55a1d8a64f1e5dfa$export$1fcf7232357bf4d8 = (balance, annualRate, termYears, frequency = 'monthly', loanType = 'pi')=>$55a1d8a64f1e5dfa$var$postCalc('calculateLoanRepayment', {
        balance: balance,
        annualRate: annualRate,
        termYears: termYears,
        frequency: frequency,
        loanType: loanType
    });
const $55a1d8a64f1e5dfa$export$514a4d0718b14c96 = (assessableIncome)=>$55a1d8a64f1e5dfa$var$postCalc('calculateMarginalTaxRate', {
        assessableIncome: assessableIncome
    });
const $55a1d8a64f1e5dfa$export$e13ba859aba62a6b = (giftsHistory, options = {})=>$55a1d8a64f1e5dfa$var$postCalc('calculateDeprivedAssetsFromGifts', {
        giftsHistory: giftsHistory,
        options: options
    });
const $55a1d8a64f1e5dfa$export$57a934492fb10c62 = async (giftsHistory, strategyGiftsByFyEnd = {})=>new Map(await $55a1d8a64f1e5dfa$var$postCalc('buildGiftsByFinancialYear', {
        giftsHistory: giftsHistory,
        strategyGiftsByFyEnd: strategyGiftsByFyEnd
    }));
const $55a1d8a64f1e5dfa$export$548fd6b682208d71 = (balance, ownerAge)=>$55a1d8a64f1e5dfa$var$postCalc('getAnnualMinimumAbpDraw', {
        balance: balance,
        ownerAge: ownerAge
    });
const $55a1d8a64f1e5dfa$export$99098e979a7d958e = (asset)=>$55a1d8a64f1e5dfa$var$postCalc('getAbpProjectionNominatedAnnual', {
        asset: asset
    });
const $55a1d8a64f1e5dfa$export$399e556d15149d82 = (asset, factFind, yearIndex = 1)=>$55a1d8a64f1e5dfa$var$postCalc('markAbpFundedAcquisitionAfterLiquidation', {
        asset: asset,
        factFind: factFind,
        yearIndex: yearIndex
    });
const $55a1d8a64f1e5dfa$export$a6df0512b6a05b11 = (factFind)=>$55a1d8a64f1e5dfa$var$postCalc('initializeAbpProjectionNomineesOnFactFind', {
        factFind: factFind
    });
const $55a1d8a64f1e5dfa$export$9e47c78a2ac7c305 = (date)=>$55a1d8a64f1e5dfa$var$postCalc('getAustralianFYEndingYearContainingDate', {
        date: date
    });


/**
 * constants/index.js
 * Re-exports all constants for convenient importing.
 */ 
/**
 * Aged Care Schedule – single source of truth for means-tested fee rates and thresholds.
 * Aligned with Aged Care Act 2024 s319 (daily means tested amount), s278 (hotelling), s279 (NCCC).
 * Ported verbatim from frontend/src/constants/agedCareSchedule.js.
 *
 * SOURCE: the Department of Health, Disability and Ageing's "Schedule of fees and charges for
 * residential care". It is published THREE times a year, not two: 20 March, 1 JULY and 20 September.
 * The 1 July edition is easy to miss because the Age Pension does not move then — but on 1 July 2026
 * it moved the means-test income thresholds, the fourth asset threshold and the maximum RAD, and this
 * file sat on the March figures for ten weeks. On a client with $544,884 of assessable assets that
 * showed a $1.82/day NCCC the Act did not ask for (the fourth asset threshold had moved past them).
 * `agedCareScheduleOfficial.test.ts` now pins every figure here to the current official document, so
 * the next edition has to be a deliberate update of both.
 */ const $815d7df20c36742b$export$36c4ec5f3f340aef = {
    /** Date of the DoH schedule these figures are taken from (editions: 20 Mar, 1 Jul, 20 Sep); MPIR updates quarterly separately. */ effectiveDate: '2026-09-20',
    /** Maximum Permissible Interest Rate — Department of Health, quarterly. */ mpiQuarterLabel: "1 October 2026 \u2013 31 December 2026",
    // --- Income thresholds (annual) – Single --- (Schedule 20 Sep 2026)
    incomeFreeAreaSingle: 36454.60,
    firstIncomeThresholdSingle: 90130.04,
    secondIncomeThresholdSingle: 105048,
    thirdIncomeThresholdSingle: 121173.20,
    fourthIncomeThresholdSingle: 145818.40,
    // --- Income thresholds (annual) – Couple (illness separated, single rate) --- (Schedule 20 Sep 2026)
    incomeFreeAreaCouple: 35726.60,
    firstIncomeThresholdCouple: 89402.04,
    secondIncomeThresholdCouple: 105048,
    thirdIncomeThresholdCouple: 121173.20,
    fourthIncomeThresholdCouple: 142906.40,
    // --- Asset thresholds (same for single and couple) --- (Schedule 20 Sep 2026)
    assetFreeArea: 66500,
    firstAssetThreshold: 219858.40,
    secondAssetThreshold: 266000,
    thirdAssetThreshold: 369366.66,
    fourthAssetThreshold: 552858.40,
    // --- Caps and supplements (daily unless noted) --- (Schedule 20 Sep 2026)
    MAS: 73.73,
    maxHotellingDaily: 22.15,
    maxNCCCDaily: 109.45,
    ncccLifetimeCap: 140652.80,
    /** The Department's own figure — "1,460 days (not indexed)" — rather than 4 × 365 + a leap day. */ nccc4YearDays: 1460,
    // --- Other --- (Schedule 20 Sep 2026)
    homeExemptionCap: 219858.40,
    /** Max daily BDF (Schedule 20 Sep 2026, 1 Nov 2025 arrangements) = 85% of basic single age pension ($1,135.40/fn). */ basicDailyFeeDaily: 68.93,
    basicDailyFeeRate: 0.85,
    singlePensionAnnual: 32180.20,
    /** 1 October – 31 December 2026 (applied 2 October 2026 from RATES_FROM_1_OCTOBER_2026; was 8.43%). */ MPIR: 0.0851,
    /** Max refundable accommodation deposit without IHACPA approval (Schedule 20 Sep 2026 — unchanged). */ maxRAD: 789686,
    /** Minimum permissible asset level (Schedule 20 Sep 2026). */ minPermissibleAssetLevel: 66500,
    /**
     * THE 1 JULY 2014 FEE ARRANGEMENTS — the means-tested care fee, kept open for residents covered
     * by the "no worse off" principle (on 12 September 2024 receiving, approved for or waiting for a
     * Home Care Package; entering residential care from 1 November 2025; not opted in). Same
     * schedule edition, section "Rates for post 1 July 2014 fee and accommodation arrangements";
     * the formula is the Department's residential fee scenarios for the 1 July 2014 arrangements
     * (Sofia / Jane / Roger). Verified 17 Sep 2026 against the 1 July 2026 schedule (v2.0); figures
     * moved to the 20 September 2026 schedule on 21 Sep 2026.
     *
     *   income-tested amount = 50% × (assessable income − income free area) ÷ 364
     *   asset-tested amount  = [17.5% × (assets between the asset free area and the first threshold)
     *                          + 1% × (between the first and second thresholds)
     *                          + 2% × (above the second threshold)] ÷ 364
     *   means-tested care fee = min( max(0, MTA − maximum accommodation supplement), daily maximum )
     *
     * The asset free area, first threshold, home exemption cap and maximum accommodation supplement
     * are the same figures as the 1 November 2025 rules use; the second threshold is not.
     */ arrangements2014: {
        incomeFreeAreaSingle: 36454.60,
        /** Couple, illness separated — the single rate row. */ incomeFreeAreaCouple: 35726.60,
        incomeRate: 0.5,
        assetFreeArea: 66500,
        firstAssetThreshold: 219858.40,
        secondAssetThreshold: 526575.20,
        assetRateBand1: 0.175,
        assetRateBand2: 0.01,
        assetRateBand3: 0.02,
        /** "Means tested care fee — from 1 October 2026" maximum daily rate (applied 2 October 2026; was $372.03). */ maxMeansTestedCareFeeDaily: 380.46,
        /** Fee stops for the rest of the year of care once reached; restarts on the anniversary of entry. */ mtcfAnnualCap: 37055.98,
        /** Shared with Home Care Package income-tested care fees and Support at Home no-worse-off contributions. */ mtcfLifetimeCap: 88934.57
    }
};
function $815d7df20c36742b$export$70401087ee91fcf5(factor) {
    const s = $815d7df20c36742b$export$36c4ec5f3f340aef;
    const x = (v)=>v * factor;
    return {
        ...s,
        incomeFreeAreaSingle: x(s.incomeFreeAreaSingle),
        firstIncomeThresholdSingle: x(s.firstIncomeThresholdSingle),
        secondIncomeThresholdSingle: x(s.secondIncomeThresholdSingle),
        thirdIncomeThresholdSingle: x(s.thirdIncomeThresholdSingle),
        fourthIncomeThresholdSingle: x(s.fourthIncomeThresholdSingle),
        incomeFreeAreaCouple: x(s.incomeFreeAreaCouple),
        firstIncomeThresholdCouple: x(s.firstIncomeThresholdCouple),
        secondIncomeThresholdCouple: x(s.secondIncomeThresholdCouple),
        thirdIncomeThresholdCouple: x(s.thirdIncomeThresholdCouple),
        fourthIncomeThresholdCouple: x(s.fourthIncomeThresholdCouple),
        assetFreeArea: x(s.assetFreeArea),
        firstAssetThreshold: x(s.firstAssetThreshold),
        secondAssetThreshold: x(s.secondAssetThreshold),
        thirdAssetThreshold: x(s.thirdAssetThreshold),
        fourthAssetThreshold: x(s.fourthAssetThreshold),
        MAS: x(s.MAS),
        maxHotellingDaily: x(s.maxHotellingDaily),
        maxNCCCDaily: x(s.maxNCCCDaily),
        ncccLifetimeCap: x(s.ncccLifetimeCap),
        homeExemptionCap: x(s.homeExemptionCap),
        basicDailyFeeDaily: x(s.basicDailyFeeDaily),
        singlePensionAnnual: x(s.singlePensionAnnual),
        maxRAD: x(s.maxRAD),
        minPermissibleAssetLevel: x(s.minPermissibleAssetLevel),
        arrangements2014: {
            ...s.arrangements2014,
            incomeFreeAreaSingle: x(s.arrangements2014.incomeFreeAreaSingle),
            incomeFreeAreaCouple: x(s.arrangements2014.incomeFreeAreaCouple),
            assetFreeArea: x(s.arrangements2014.assetFreeArea),
            firstAssetThreshold: x(s.arrangements2014.firstAssetThreshold),
            secondAssetThreshold: x(s.arrangements2014.secondAssetThreshold),
            maxMeansTestedCareFeeDaily: x(s.arrangements2014.maxMeansTestedCareFeeDaily),
            mtcfAnnualCap: x(s.arrangements2014.mtcfAnnualCap),
            mtcfLifetimeCap: x(s.arrangements2014.mtcfLifetimeCap)
        }
    };
}
var $815d7df20c36742b$export$2e2bcd8739ae039 = $815d7df20c36742b$export$36c4ec5f3f340aef;


/**
 * Support at Home funding levels and their annual budgets — the ONE table every screen, the
 * contribution engine and the advice documents read.
 *
 * SOURCE: Department of Health, Disability and Ageing, "Support at Home program – classifications
 * and budgets" (edition effective 1 July 2026; filed in docs/reference) and the Department's
 * "Funding classifications for Support at Home" page. Budgets index on 1 July each year. Until
 * 17 Sep 2026 this table carried the 1 November 2025 figures (actuarial review pack F.33).
 *
 * TWO KINDS OF LEVEL. A person assessed on or after 1 November 2025 receives one of the EIGHT
 * classifications on their Notice of Decision. A person who was receiving a Home Care Package, or
 * approved for one, before 1 November 2025 was moved onto a TRANSITIONED HCP LEVEL with the same
 * funding as their package (levels 1–4) — including people who were still on the waiting list, who
 * receive that funding when a place becomes available. They stay on it until they are reassessed
 * into a classification. The transitioned levels are marked so the "eight classifications" tables
 * on the Support at Home pages do not list them as classifications.
 */ const $c220d08b55e5dd64$export$bfae9591cc0d7897 = {
    sah_level_1: {
        label: 'Support at Home - Classification 1',
        budget: 11010.01,
        description: 'Basic support for low care needs. Typical services include housekeeping, social support, and personal care assistance.'
    },
    sah_level_2: {
        label: 'Support at Home - Classification 2',
        budget: 16451.35,
        description: 'Low-level care needs. Supports activities of daily living, personal care, and occasional allied health services.'
    },
    sah_level_3: {
        label: 'Support at Home - Classification 3',
        budget: 22536.81,
        description: 'Intermediate care needs. Regular personal care, domestic assistance, allied health, and social support services.'
    },
    sah_level_4: {
        label: 'Support at Home - Classification 4',
        budget: 30468.51,
        description: 'Intermediate-high care needs. Increased personal care, nursing support, allied health, and community access services.'
    },
    sah_level_5: {
        label: 'Support at Home - Classification 5',
        budget: 40729.53,
        description: 'High care needs. Significant personal care, nursing, allied health, and more frequent service delivery.'
    },
    sah_level_6: {
        label: 'Support at Home - Classification 6',
        budget: 49365.27,
        description: 'High care needs. Comprehensive care package with extensive personal care, nursing, allied health, and clinical support.'
    },
    sah_level_7: {
        label: 'Support at Home - Classification 7',
        budget: 59660.0,
        description: 'Very high care needs. Intensive personal care, frequent nursing visits, extensive allied health, and palliative care support.'
    },
    sah_level_8: {
        label: 'Support at Home - Classification 8',
        budget: 80137.12,
        description: 'Highest level of care. Maximum support with intensive personal care, complex nursing management, specialist allied health, and comprehensive clinical services.'
    },
    hcp_transition_1: {
        label: 'Home Care Package Level 1 (transitioned)',
        budget: 11272.15,
        description: 'The funding of a Level 1 Home Care Package, carried into Support at Home unchanged. Applies until a new assessment places the person in one of the eight classifications.',
        transitional: true
    },
    hcp_transition_2: {
        label: 'Home Care Package Level 2 (transitioned)',
        budget: 19821.76,
        description: 'The funding of a Level 2 Home Care Package, carried into Support at Home unchanged. Applies until a new assessment places the person in one of the eight classifications.',
        transitional: true
    },
    hcp_transition_3: {
        label: 'Home Care Package Level 3 (transitioned)',
        budget: 43148.74,
        description: 'The funding of a Level 3 Home Care Package, carried into Support at Home unchanged. Applies until a new assessment places the person in one of the eight classifications.',
        transitional: true
    },
    hcp_transition_4: {
        label: 'Home Care Package Level 4 (transitioned)',
        budget: 65415.91,
        description: 'The funding of a Level 4 Home Care Package, carried into Support at Home unchanged. Applies until a new assessment places the person in one of the eight classifications.',
        transitional: true
    }
};
const $c220d08b55e5dd64$export$712f07a1eb8135ac = Object.keys($c220d08b55e5dd64$export$bfae9591cc0d7897).filter((k)=>!$c220d08b55e5dd64$export$bfae9591cc0d7897[k].transitional);
const $c220d08b55e5dd64$export$5e8d2d3fba9733e4 = Object.keys($c220d08b55e5dd64$export$bfae9591cc0d7897).filter((k)=>$c220d08b55e5dd64$export$bfae9591cc0d7897[k].transitional);
function $c220d08b55e5dd64$export$36fcde3ddb6f0194(level) {
    return level ? $c220d08b55e5dd64$export$bfae9591cc0d7897[level]?.budget ?? 0 : 0;
}


/**
 * Asset and liability type definitions used by the calculation engine.
 * Ported from frontend/src/constants/assetTypes.js — deliberately omits the `icon` field
 * (lucide-react, UI-only). `assetDisplayName` IS needed — the Support at Home suggestion-engine
 * evaluator (suggestionEngine/supportAtHome.ts, ported from strategy/SupportAtHomeStrategyEvaluator.js)
 * uses it to label asset-allocation rows.
 */ const $bfa4518c9dced417$export$e18ad1b53d14ba76 = [
    {
        id: 'bankAccounts',
        name: 'Bank Accounts / Cash',
        isLiquid: true,
        hasCgt: false
    },
    {
        id: 'termDeposits',
        name: 'Term Deposits',
        isLiquid: true,
        hasCgt: false
    },
    {
        id: 'investmentProperty',
        name: 'Investment Property',
        isLiquid: false,
        hasCgt: true
    },
    {
        id: 'shares',
        name: 'Shares / Managed Funds',
        isLiquid: true,
        hasCgt: true
    },
    /*
     * An investment (insurance) bond: taxed inside at 30%, tax-free in the holder's hands after ten
     * years, counted in full and deemed by Centrelink. Not liquid for the engine's purposes — the
     * projection leaves it untouched until its ten years are up (investmentBondPlugin), and no CGT:
     * the life office has already paid the tax on the growth.
     */ {
        id: 'investmentBonds',
        name: 'Investment / Insurance Bond',
        isLiquid: false,
        hasCgt: false
    },
    {
        id: 'superannuation',
        name: 'Superannuation (Accumulation)',
        individualOnly: true,
        isLiquid: true,
        hasCgt: false
    },
    {
        id: 'accountBasedPensions',
        name: 'Account Based Pension (Super)',
        individualOnly: true,
        isLiquid: true,
        hasCgt: false
    },
    {
        id: 'annuities',
        name: 'Annuities',
        individualOnly: true,
        isLiquid: false,
        hasCgt: false
    },
    {
        id: 'funeralBonds',
        name: 'Funeral Bonds',
        individualOnly: true,
        isLiquid: false,
        hasCgt: false
    },
    /*
     * A funeral paid for in advance with a funeral director (owner, 5 Oct 2026). Not a funeral bond:
     * a bond is an investment, exempt only up to the indexed limit; a prepaid funeral is exempt from
     * both means tests with NO cap, provided it is a contract for future services and not refundable.
     */ {
        id: 'prepaidFuneral',
        name: 'Prepaid Funeral (with a funeral director)',
        individualOnly: true,
        isLiquid: false,
        hasCgt: false
    },
    /*
     * Money lent to someone else — usually family (owner, 5 Oct 2026). A financial asset: counted at
     * the balance still owed (not the interest), and deemed, whether or not it is being repaid.
     * Not liquid: the projection cannot sell a loan to fund anything.
     */ {
        id: 'loansToOthers',
        name: 'Money Lent to Others',
        isLiquid: false,
        hasCgt: false
    },
    {
        id: 'personalAssets',
        name: 'Personal Assets (e.g. cars, contents etc.)',
        isLiquid: false,
        hasCgt: false
    },
    {
        id: 'other',
        name: 'Other Asset',
        isLiquid: false,
        hasCgt: true
    }
];
const $bfa4518c9dced417$export$dfcae3bc547409fc = [
    {
        id: 'mortgages',
        name: 'Mortgage / Home Loan',
        hasCgt: false
    },
    {
        id: 'personalLoans',
        name: 'Personal Loans',
        hasCgt: false
    },
    {
        id: 'creditCards',
        name: 'Credit Card Debt',
        hasCgt: false
    },
    /*
     * A reverse mortgage belongs here with every other debt, and until 2026-08-22 it had nowhere to
     * live. The only place to record one was a question on the Living Arrangements step
     * (`home.commercialReverseMortgageAmount`) which was written to the fact-find and then READ BY
     * NOTHING: not net worth, not the means test, not any projection. A client with a $200,000
     * reverse mortgage had their estate overstated by $200,000 and no screen showed the debt.
     *
     * Recorded as a liability it is counted in net worth automatically (assessNetWorth sums every
     * liability bucket), and correctly draws no repayment schedule — `isOutsidePersonalCashflow`
     * already excludes `reverse_mortgage` because the interest capitalises rather than being
     * serviced. `reverseMortgageBalanceGrowth` in loanPlugin compounds it across a projection.
     */ {
        id: 'reverseMortgages',
        name: 'Reverse Mortgage',
        hasCgt: false
    },
    /*
     * The Home Equity Access Scheme, for the same reason and with the same history: an existing HEAS
     * loan could only be recorded on the Living Arrangements step, where `home.equityReleaseAmount`
     * was written and read by nothing at all. Government-set rate, capitalising like a reverse
     * mortgage, and equally invisible to every calculation until now.
     */ {
        id: 'homeEquityAccessScheme',
        name: 'Home Equity Access Scheme (HEAS)',
        hasCgt: false
    }
];
const $bfa4518c9dced417$export$87285386e0429fb5 = (asset, assetType)=>{
    const desc = (asset?.description || asset?.name || '').trim();
    if (desc) return desc;
    return $bfa4518c9dced417$export$e18ad1b53d14ba76.find((t)=>t.id === assetType)?.name || $bfa4518c9dced417$export$dfcae3bc547409fc.find((t)=>t.id === assetType)?.name || 'Account';
};
const $bfa4518c9dced417$export$580aed46e3360c20 = (assetType)=>!!$bfa4518c9dced417$export$e18ad1b53d14ba76.find((t)=>t.id === assetType)?.hasCgt;


/**
 * UI-only icon lookup for the asset/liability type ids defined in
 * shared/src/calculation/constants/assetTypes.ts. That module is deliberately data-only (no
 * lucide-react dependency, since it's shared with the server) — this is where the frontend
 * attaches an icon per id for display (e.g. the Assets/Liabilities step legends).
 */ /**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8474226e5f2f9b18$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "16",
            height: "20",
            x: "4",
            y: "2",
            rx: "2",
            ry: "2",
            key: "76otgf"
        }
    ],
    [
        "path",
        {
            d: "M9 22v-4h6v4",
            key: "r93iot"
        }
    ],
    [
        "path",
        {
            d: "M8 6h.01",
            key: "1dz90k"
        }
    ],
    [
        "path",
        {
            d: "M16 6h.01",
            key: "1x0f13"
        }
    ],
    [
        "path",
        {
            d: "M12 6h.01",
            key: "1vi96p"
        }
    ],
    [
        "path",
        {
            d: "M12 10h.01",
            key: "1nrarc"
        }
    ],
    [
        "path",
        {
            d: "M12 14h.01",
            key: "1etili"
        }
    ],
    [
        "path",
        {
            d: "M16 10h.01",
            key: "1m94wz"
        }
    ],
    [
        "path",
        {
            d: "M16 14h.01",
            key: "1gbofw"
        }
    ],
    [
        "path",
        {
            d: "M8 10h.01",
            key: "19clt8"
        }
    ],
    [
        "path",
        {
            d: "M8 14h.01",
            key: "6423bh"
        }
    ]
];
const $8474226e5f2f9b18$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("building", $8474226e5f2f9b18$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5476308704ab732d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2",
            key: "5owen"
        }
    ],
    [
        "circle",
        {
            cx: "7",
            cy: "17",
            r: "2",
            key: "u2ysq9"
        }
    ],
    [
        "path",
        {
            d: "M9 17h6",
            key: "r8uit2"
        }
    ],
    [
        "circle",
        {
            cx: "17",
            cy: "17",
            r: "2",
            key: "axvx0g"
        }
    ]
];
const $5476308704ab732d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("car", $5476308704ab732d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1299b0a605d22052$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "5",
            rx: "2",
            key: "ynyp8z"
        }
    ],
    [
        "line",
        {
            x1: "2",
            x2: "22",
            y1: "10",
            y2: "10",
            key: "1b3vmo"
        }
    ]
];
const $1299b0a605d22052$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("credit-card", $1299b0a605d22052$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4fe65c91329e5f2f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1",
            key: "3pnvol"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "8",
            r: "2",
            key: "1822b1"
        }
    ],
    [
        "path",
        {
            d: "M12 10v12",
            key: "6ubwww"
        }
    ],
    [
        "path",
        {
            d: "M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z",
            key: "9hd38g"
        }
    ],
    [
        "path",
        {
            d: "M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z",
            key: "ufn41s"
        }
    ]
];
const $4fe65c91329e5f2f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("flower-2", $4fe65c91329e5f2f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5f6f007318f39d57$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 3h12l4 6-10 13L2 9Z",
            key: "1pcd5k"
        }
    ],
    [
        "path",
        {
            d: "M11 3 8 9l4 13 4-13-3-6",
            key: "1fcu3u"
        }
    ],
    [
        "path",
        {
            d: "M2 9h20",
            key: "16fsjt"
        }
    ]
];
const $5f6f007318f39d57$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("gem", $5f6f007318f39d57$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $07139920b5ad0ce2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17",
            key: "geh8rc"
        }
    ],
    [
        "path",
        {
            d: "m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
            key: "1fto5m"
        }
    ],
    [
        "path",
        {
            d: "m2 16 6 6",
            key: "1pfhp9"
        }
    ],
    [
        "circle",
        {
            cx: "16",
            cy: "9",
            r: "2.9",
            key: "1n0dlu"
        }
    ],
    [
        "circle",
        {
            cx: "6",
            cy: "5",
            r: "3",
            key: "151irh"
        }
    ]
];
const $07139920b5ad0ce2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("hand-coins", $07139920b5ad0ce2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $199a795aa57ac65f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m11 17 2 2a1 1 0 1 0 3-3",
            key: "efffak"
        }
    ],
    [
        "path",
        {
            d: "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4",
            key: "9pr0kb"
        }
    ],
    [
        "path",
        {
            d: "m21 3 1 11h-2",
            key: "1tisrp"
        }
    ],
    [
        "path",
        {
            d: "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3",
            key: "1uvwmv"
        }
    ],
    [
        "path",
        {
            d: "M3 4h8",
            key: "1ep09j"
        }
    ]
];
const $199a795aa57ac65f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("handshake", $199a795aa57ac65f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d6a5496c00590d14$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12.662 21H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v2.475",
            key: "uubd2h"
        }
    ],
    [
        "path",
        {
            d: "M14.959 12.717A1 1 0 0 0 14 12h-4a1 1 0 0 0-1 1v8",
            key: "p7f341"
        }
    ],
    [
        "path",
        {
            d: "M15 18h6",
            key: "3b3c90"
        }
    ],
    [
        "path",
        {
            d: "M18 15v6",
            key: "9wciyi"
        }
    ]
];
const $d6a5496c00590d14$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("house-plus", $d6a5496c00590d14$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $05565f19ab398c04$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 18v-7",
            key: "wt116b"
        }
    ],
    [
        "path",
        {
            d: "M11.12 2.198a2 2 0 0 1 1.76.006l7.866 3.847c.476.233.31.949-.22.949H3.474c-.53 0-.695-.716-.22-.949z",
            key: "1m329m"
        }
    ],
    [
        "path",
        {
            d: "M14 18v-7",
            key: "vav6t3"
        }
    ],
    [
        "path",
        {
            d: "M18 18v-7",
            key: "aexdmj"
        }
    ],
    [
        "path",
        {
            d: "M3 22h18",
            key: "8prr45"
        }
    ],
    [
        "path",
        {
            d: "M6 18v-7",
            key: "1ivflk"
        }
    ]
];
const $05565f19ab398c04$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("landmark", $05565f19ab398c04$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e325251f2797f6cf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
];
const $e325251f2797f6cf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("shield-check", $e325251f2797f6cf$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0f45c1e8ae52ad76$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
            key: "975kel"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "7",
            r: "4",
            key: "17ys0d"
        }
    ]
];
const $0f45c1e8ae52ad76$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("user", $0f45c1e8ae52ad76$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $33b542e8915cec79$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1",
            key: "18etb6"
        }
    ],
    [
        "path",
        {
            d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4",
            key: "xoc0q4"
        }
    ]
];
const $33b542e8915cec79$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("wallet", $33b542e8915cec79$export$3efd853dbb351e94);


const $f5fad7fcd622224a$export$e614075a23fb1335 = {
    bankAccounts: (0, $05565f19ab398c04$export$2e2bcd8739ae039),
    termDeposits: (0, $1571f1c57333e026$export$2e2bcd8739ae039),
    investmentProperty: (0, $8474226e5f2f9b18$export$2e2bcd8739ae039),
    shares: (0, $c9921f4f81a419f0$export$2e2bcd8739ae039),
    investmentBonds: (0, $5f6f007318f39d57$export$2e2bcd8739ae039),
    superannuation: (0, $33b542e8915cec79$export$2e2bcd8739ae039),
    accountBasedPensions: (0, $07139920b5ad0ce2$export$2e2bcd8739ae039),
    annuities: (0, $07139920b5ad0ce2$export$2e2bcd8739ae039),
    funeralBonds: (0, $e325251f2797f6cf$export$2e2bcd8739ae039),
    prepaidFuneral: (0, $4fe65c91329e5f2f$export$2e2bcd8739ae039),
    loansToOthers: (0, $199a795aa57ac65f$export$2e2bcd8739ae039),
    personalAssets: (0, $5476308704ab732d$export$2e2bcd8739ae039),
    other: (0, $f4da941c85c0c5fe$export$2e2bcd8739ae039)
};
const $f5fad7fcd622224a$export$adac0024f8acd71 = {
    mortgages: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
    personalLoans: (0, $0f45c1e8ae52ad76$export$2e2bcd8739ae039),
    creditCards: (0, $1299b0a605d22052$export$2e2bcd8739ae039),
    reverseMortgages: (0, $d6a5496c00590d14$export$2e2bcd8739ae039),
    homeEquityAccessScheme: (0, $05565f19ab398c04$export$2e2bcd8739ae039)
};


/**
 * initialFactFind.ts – default form state for Client Profile and aged care flows.
 * Single source of truth for initial form shape; update when new fact-find fields are added.
 */ /**
 * Which of a client's asset rates are THEIR OWN figures rather than the published assumption, and
 * the same fact-find with those figures put back to the defaults.
 *
 * A client (or the person entering their profile) may set the growth or income rate on any asset —
 * Moneysmart's own planner allows it, and so do we. But a Statement of Advice is personal advice
 * given under a licence, so a rate the client chose must be reported as their decision, with the
 * consequence shown in dollars: the same plan run once more at our default rates. That comparison
 * is only honest if it changes NOTHING but the rates — same assets sold, same order, same deposit,
 * same borrowing — which is why this resets the rates on a fact-find the plan has already been
 * applied to, rather than asking the engine to choose a plan afresh.
 *
 * What counts as the client's own figure:
 *   - Bank, term deposits, shares: a rate that differs from the published asset-class default.
 *   - Investment property: the growth rate only. Its income is the recorded rent in dollars, not a
 *     yield (see assetAssumptionRows.ts), so there is no "income rate" to have changed.
 *   - Super and account-based pensions: a rate matching NO investment option. Picking "Growth" from
 *     the dropdown is choosing a published assumption, not writing one; only a hand-typed figure
 *     counts, and it is measured against the Balanced default the profile form starts from.
 * A field left blank is not a choice — the engine applies its default — so it is never reported.
 *
 * Read at use time against the ACTIVE tables, so a firm's own capital market assumptions are the
 * defaults where a firm has set them (investmentProfiles.ts).
 */ 
const $2cee3e5f0555e7bc$export$2a98a0810772f8e0 = 5;
/** A number the client actually typed — blank, null or nonsense is "left to the default". */ function $2cee3e5f0555e7bc$var$typedRate(value) {
    if (value === null || value === undefined || value === '') return null;
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
}
const $2cee3e5f0555e7bc$var$differs = (a, b)=>Math.abs(a - b) >= 0.005;
/** The overrides on one asset, in the order a reader expects (income before growth). */ function $2cee3e5f0555e7bc$var$overridesOn(assetType, asset) {
    const ac = (0, $0f2c0a6799fe36da$export$b037eefb915b86ec);
    const description = asset.description || 'Unnamed asset';
    const out = [];
    const income = $2cee3e5f0555e7bc$var$typedRate(asset.incomeRate);
    const growth = $2cee3e5f0555e7bc$var$typedRate(asset.growthRate);
    const push = (measure, chosen, fallback)=>{
        if (chosen !== null && $2cee3e5f0555e7bc$var$differs(chosen, fallback)) out.push({
            assetType: assetType,
            description: description,
            measure: measure,
            chosenPct: chosen,
            defaultPct: fallback
        });
    };
    switch(assetType){
        case 'bankAccounts':
            push('income', income, ac.bankIncomePct);
            break;
        case 'termDeposits':
            push('income', income, ac.termDepositIncomePct);
            break;
        case 'shares':
            push('income', income, ac.sharesIncomePct);
            push('growth', growth, ac.sharesGrowthPct);
            break;
        case 'investmentProperty':
            push('growth', growth, ac.propertyGrowthPct);
            break;
        case 'superannuation':
            if (growth !== null && (0, $0f2c0a6799fe36da$export$acc007763407ac2f)('accumulation', growth) === 'custom') push('growth', growth, (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703).balanced.accumulationNetPct);
            break;
        case 'accountBasedPensions':
            if (growth !== null && (0, $0f2c0a6799fe36da$export$acc007763407ac2f)('pension', growth) === 'custom') push('growth', growth, (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703).balanced.pensionNetPct);
            break;
        default:
            break;
    }
    return out;
}
/** The family home's growth, where the client typed their own figure. */ function $2cee3e5f0555e7bc$var$homeOverride(factFind) {
    const growth = $2cee3e5f0555e7bc$var$typedRate(factFind?.home?.homeGrowthRate);
    if (growth === null || !$2cee3e5f0555e7bc$var$differs(growth, $2cee3e5f0555e7bc$export$2a98a0810772f8e0)) return [];
    return [
        {
            assetType: 'home',
            description: 'Family home',
            measure: 'growth',
            chosenPct: growth,
            defaultPct: $2cee3e5f0555e7bc$export$2a98a0810772f8e0
        }
    ];
}
function $2cee3e5f0555e7bc$export$40fbafa413a26149(factFind) {
    const assets = factFind?.assets || {};
    return [
        ...$2cee3e5f0555e7bc$var$homeOverride(factFind),
        ...Object.entries(assets).flatMap(([assetType, rows])=>(rows || []).flatMap((asset)=>$2cee3e5f0555e7bc$var$overridesOn(assetType, asset)))
    ];
}
function $2cee3e5f0555e7bc$export$d0c209ebea676c25(factFind) {
    return $2cee3e5f0555e7bc$export$40fbafa413a26149(factFind).length > 0;
}
function $2cee3e5f0555e7bc$export$46052f49dde64127(overrides) {
    return overrides.some((o)=>o.chosenPct > o.defaultPct);
}
function $2cee3e5f0555e7bc$export$d2d5e7cb7f9df3f(factFind) {
    const assets = factFind.assets || {};
    const reset = {};
    for (const [assetType, rows] of Object.entries(assets))reset[assetType] = rows?.map((asset)=>{
        const overrides = $2cee3e5f0555e7bc$var$overridesOn(assetType, asset);
        if (!overrides.length) return asset;
        const next = {
            ...asset
        };
        for (const o of overrides)if (o.measure === 'growth') next.growthRate = o.defaultPct;
        else next.incomeRate = o.defaultPct;
        return next;
    });
    return $2cee3e5f0555e7bc$var$homeOverride(factFind).length && factFind.home ? {
        ...factFind,
        assets: reset,
        home: {
            ...factFind.home,
            homeGrowthRate: $2cee3e5f0555e7bc$export$2a98a0810772f8e0
        }
    } : {
        ...factFind,
        assets: reset
    };
}


const $b116352393ba4abb$export$55f731ae3600e88a = {
    completer: 'client',
    completerFirstName: '',
    completerLastName: '',
    completerRelationship: '',
    adviceFor: 'single',
    client: {
        firstName: '',
        lastName: '',
        email: '',
        preferredPhone: '',
        dob: '',
        // Deliberately blank: asked on step 4, and nothing about a client's housing should be assumed
        // on their behalf. Seeding 'own_home' modelled a home owner whether or not anyone said so.
        currentResidency: '',
        healthStatus: 'good'
    },
    partner: {
        firstName: '',
        lastName: '',
        dob: '',
        // Deliberately blank: asked on step 4, and nothing about a client's housing should be assumed
        // on their behalf. Seeding 'own_home' modelled a home owner whether or not anyone said so.
        currentResidency: '',
        healthStatus: 'good'
    },
    goals: {},
    /** Couple means-test override (Dashboard): illnessSeparatedMode `auto` | `yes` | `no` */ relationship: {
        illnessSeparatedMode: 'auto'
    },
    careNeeds: {
        /*
         * NO DEFAULT ANSWER (owner, 2026-08-31). This used to default to 'no', which meant a brand
         * new client arrived at the care-assessment question with an answer already given on their
         * behalf — and, since 'no' now opens the entry-level support explainer, with a screenful of
         * copy about a question they had not been asked yet.
         *
         * Undefined leaves every radio unselected, which is the honest state: we do not know.
         * Nothing downstream reads a missing status as anything but "not answered" — the level
         * questions test `=== 'yes'`, the fork panel tests `'no' | 'in_progress'`, and the
         * apply-for-an-assessment insight tests `=== 'no'` (which was also firing early).
         */ clientAcat: {
            recommendation: {}
        },
        partnerAcat: {
            recommendation: {}
        }
    },
    home: {
        homeGrowthRate: (0, $2cee3e5f0555e7bc$export$2a98a0810772f8e0),
        // Must always be a valid enum value (factFindSchema.ts home.ownership has no '' option) —
        // 'client' matches Step4_FamilyHome's own single-applicant display fallback
        // (factFind.ownership || (isPartnered ? 'joint' : 'client')), so autosaving before the user
        // ever visits the Family Home step (or for an adviceFor: 'single' file) still validates.
        ownership: 'client',
        entityId: '',
        landSize: false,
        separateTitles: false,
        primaryProductionUse: false,
        farmContinuouslyWorked: false,
        farmPrimaryIncome: false,
        businessUse: false,
        // Must always be a valid enum value (factFindSchema.ts home.businessAssociation has no ''
        // option) — same reasoning as `ownership` above. Only surfaced in the UI once
        // businessUse + businessContinues are both true, so 'self' here is inert until then.
        businessAssociation: 'self',
        businessReceivesRent: false,
        businessContinues: false,
        equityRelease: false,
        commercialReverseMortgage: false,
        protectedPerson: 'no',
        /** other_entity + occupant: reasonable security of tenure for Age Pension principal home (§5.8) */ securityOfTenure: true
    },
    rent: {},
    grannyFlat: {},
    retirementVillage: {},
    livingWithFamily: {},
    assets: {},
    liabilities: {},
    /** Trusts, companies, partnerships — Phase 1a fact-find; engine Phase 1b */ structures: [],
    structuresGateAnswer: false,
    /** Phase 2 — AC/SAH/RV suggestion engine: include entity assets in suggested funding (default exclude). */ structureFundingInSuggestions: 'exclude',
    income: {
        otherIncomes: []
    },
    expenses: {
        livingExpenses: 0,
        capitalExpenses: [],
        expenseMode: 'total'
    },
    family: {
        childrenCount: 0
    }
};


/**
 * insightsConfig.js – copy and config for Client Profile insight cards (goals, family/estate).
 * Used by ClientProfile in App.js to render WelcomeInsight cards. Icons from lucide-react.
 */ /**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3b634449cc961be6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ],
    [
        "path",
        {
            d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z",
            key: "1mlx9k"
        }
    ],
    [
        "path",
        {
            d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3",
            key: "mhlwft"
        }
    ]
];
const $3b634449cc961be6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("file-question-mark", $3b634449cc961be6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $adb270212de20834$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
            key: "1rqfz7"
        }
    ],
    [
        "path",
        {
            d: "M14 2v4a2 2 0 0 0 2 2h4",
            key: "tnqrlb"
        }
    ],
    [
        "path",
        {
            d: "M10 9H8",
            key: "b1mrlr"
        }
    ],
    [
        "path",
        {
            d: "M16 13H8",
            key: "t4e002"
        }
    ],
    [
        "path",
        {
            d: "M16 17H8",
            key: "z1uh3a"
        }
    ]
];
const $adb270212de20834$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("file-text", $adb270212de20834$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $604e08b57548a73d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528",
            key: "1jaruq"
        }
    ]
];
const $604e08b57548a73d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("flag", $604e08b57548a73d$export$3efd853dbb351e94);


/**
 * "Not in place" for an estate document — NO **or** UNSURE (owner-reported, 2026-08-31).
 *
 * Someone who does not KNOW whether they have a Will, an Enduring Power of Attorney or an Advance
 * Care Directive is in the same practical position as someone who does not have one: they cannot
 * rely on it, and the first person to find out will be their family at the worst possible moment.
 * Treating 'unsure' as a pass hid the insight from exactly the people most likely to need it.
 *
 * The super nomination insight already worked this way (owner-caught, 2026-08-25). These three were
 * left behind; this is the same rule applied consistently.
 */ const $af797c9747431756$var$notInPlace = (value)=>value === 'no' || value === 'unsure';
const $af797c9747431756$export$4c8d4692eb54c080 = {
    default: {
        title: "Your Goals & Needs",
        text: "Defining your goals and care needs helps us tailor strategies that align with your priorities for lifestyle, finances, and legacy.",
        icon: (0, $604e08b57548a73d$export$2e2bcd8739ae039)
    },
    home_care: {
        title: "Support at Home",
        text: "There are eight Support at Home classifications, each with a different government subsidy. Your classification is set through an aged care needs assessment and determines your budget for services such as cleaning, personal care, and nursing.",
        icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039)
    },
    aged_care: {
        title: "Residential Aged Care",
        text: "Moving into aged care involves significant financial decisions, including how to pay for your accommodation (lump-sum RAD, daily DAP, or a combination) and ongoing fees. These choices have a major impact on your pension and estate.",
        icon: (0, $8474226e5f2f9b18$export$2e2bcd8739ae039)
    },
    retirement_village: {
        title: "Retirement Village",
        text: "Retirement villages offer an independent lifestyle with community benefits. The financial contracts can be complex, often involving an entry payment, ongoing fees, and exit fees (Deferred Management Fee) that affect your final return.",
        icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039)
    },
    granny_flat: {
        title: "Granny Flat Interest",
        text: "A granny flat arrangement involves transferring assets or money to family in exchange for a lifetime right to live in their home. This has specific and complex implications for your pension eligibility and estate planning.",
        icon: (0, $95e9e50748ea8ef2$export$2e2bcd8739ae039)
    },
    downsize_home: {
        title: "Downsizing the Home",
        text: "Downsizing is often about moving to a more manageable property. If this frees up capital, it can significantly impact your assets for the Age Pension test. Special 'downsizer' rules may allow you to contribute some sale proceeds to super.",
        icon: (0, $33b542e8915cec79$export$2e2bcd8739ae039)
    },
    acat_assessment: {
        title: "What is an aged care needs assessment?",
        text: "An aged care needs assessment is required to access government-funded aged care services, including Support at Home and, where approved, residential aged care and respite. It is a free assessment, usually completed by an assessment organisation (often in your home). You can get a referral from your GP or apply through My Aged Care. (Formerly known as an ACAT or ACAS assessment.)",
        icon: (0, $3b634449cc961be6$export$2e2bcd8739ae039)
    }
};
const $af797c9747431756$export$3f9d2c6e16b79b3f = [
    {
        key: 'default',
        trigger: ()=>true,
        title: "Protecting Your Family & Legacy",
        text: "Estate planning isn't just about legal documents\u2014it's about protecting your family from stress, disputes, and unnecessary costs. Clear communication and proper planning now ensures your wishes are respected and your family relationships remain strong.",
        icon: (0, $e325251f2797f6cf$export$2e2bcd8739ae039)
    },
    {
        key: 'noWill',
        trigger: (family)=>$af797c9747431756$var$notInPlace(family.clientWill) || $af797c9747431756$var$notInPlace(family.partnerWill),
        title: "What Happens If You Die Without a Will?",
        text: "If you pass away without a valid Will, your assets will be distributed according to state intestacy laws. This may not reflect your wishes and can cause delays, extra costs, and family disputes. It's strongly recommended to have a valid Will in place.",
        icon: (0, $adb270212de20834$export$2e2bcd8739ae039)
    },
    {
        key: 'noEpoa',
        trigger: (family)=>$af797c9747431756$var$notInPlace(family.clientEpoa) || $af797c9747431756$var$notInPlace(family.partnerEpoa),
        title: "Why You Need an Enduring Power of Attorney",
        text: "Without an EPOA, your family may need to apply to a tribunal to manage your finances or health decisions if you lose capacity. This process can be lengthy and stressful. Having an EPOA ensures someone you trust can act on your behalf.",
        icon: (0, $0f45c1e8ae52ad76$export$2e2bcd8739ae039)
    },
    {
        key: 'noAcd',
        trigger: (family)=>$af797c9747431756$var$notInPlace(family.clientAcd) || $af797c9747431756$var$notInPlace(family.partnerAcd),
        title: "The Importance of an Advance Care Directive",
        text: "An Advance Care Directive lets you express your wishes for medical care if you can't communicate them yourself. Without one, your family and doctors may face difficult decisions without knowing your preferences.",
        icon: (0, $95e9e50748ea8ef2$export$2e2bcd8739ae039)
    },
    {
        key: 'complexFamily',
        trigger: (family)=>family.complexDynamics === true,
        title: "Preventing Family Disputes",
        text: "Blended families or estranged relationships require extra care in estate planning. Open, honest conversations about your wishes can prevent costly legal battles and preserve family relationships. Consider involving all relevant family members in discussions about your care and estate plans.",
        icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039)
    },
    {
        key: 'unevenAssistance',
        trigger: (family)=>family.unevenAssistance === true,
        title: "Gifts & Loans to Children",
        text: "Significant gifts or loans to one child can cause disputes after your death. It's important to document these arrangements and consider how they affect your estate plan.",
        icon: (0, $6315759428919b56$export$2e2bcd8739ae039)
    },
    {
        key: 'noSuperNom',
        // 'unsure' fires it too (owner-caught, 2026-08-25): someone who doesn't KNOW whether a
        // nomination exists needs this explanation at least as much as someone who has none.
        trigger: (family)=>[
                'none',
                'unsure',
                undefined,
                ''
            ].includes(family.clientSuperNom) || [
                'none',
                'unsure',
                undefined,
                ''
            ].includes(family.partnerSuperNom),
        title: "Securing Your Super for Your Family",
        text: "Your superannuation is often one of your largest assets. Without a binding nomination, the fund trustee decides who receives your super\u2014which may not align with your wishes. A binding nomination ensures your super goes to the right person and provides certainty for your family.",
        icon: (0, $33b542e8915cec79$export$2e2bcd8739ae039)
    },
    {
        key: 'mentalCapacityConcern',
        trigger: (family, completer, isPartnered)=>{
            // Written longhand before `notInPlace` existed, and it already had the rule right —
            // this insight is where the no-or-unsure reasoning came from. Now it shares one copy.
            const clientMissingWillOrEpoa = $af797c9747431756$var$notInPlace(family.clientWill) || $af797c9747431756$var$notInPlace(family.clientEpoa);
            const partnerMissingWillOrEpoa = !!isPartnered && ($af797c9747431756$var$notInPlace(family.partnerWill) || $af797c9747431756$var$notInPlace(family.partnerEpoa));
            return clientMissingWillOrEpoa || partnerMissingWillOrEpoa;
        },
        title: "What If Mental Capacity Is Lost Without a Will or EPOA?",
        text: "If your loved one has already lost mental capacity and doesn't have a Will or Enduring Power of Attorney, the process to manage their affairs becomes more complex. The process varies by state and typically involves applying to a tribunal for guardianship or administration orders.",
        icon: (0, $00824d397ec63c04$export$2e2bcd8739ae039),
        hasModal: true
    }
];
const $af797c9747431756$export$f162ba13832dfb2a = `A cashflow deficit just means that in a given year, you're spending more than you're bringing in \u{2014} which is normal once fees and everyday living costs are included. ` + `It's usually manageable as long as you have savings to draw on to cover the gap. ` + `It's worth a closer look if those savings start running low, or if you're leaning on borrowing that your income couldn't comfortably repay.`;
const $af797c9747431756$export$3bfa84927d928e59 = 'Comparison Yr1';
const $af797c9747431756$export$340a7c95a5102e15 = 5000;
const $af797c9747431756$export$2d988e4b0f835e56 = 'Lower RAD, near-best legacy';
const $af797c9747431756$export$3b0ce11bc50cfe61 = `Even in a year where your cashflow is negative, your overall wealth can still grow \u{2014} for example, if your investments or home rise in value by more than the amount you draw down. These are estimates based on the assumptions in this plan.`;
const $af797c9747431756$export$f647930263b04324 = 'These figures are illustrative only. Outcomes depend on timing, investment returns, fees, Centrelink reassessments, and legislative or policy changes.';


/**
 * Step 4 living-arrangement insight knowledge.
 * AgedCareWise models financial outcomes (cashflow, Age Pension, legacy) only.
 */ 
/**
 * The Step 4 insight explaining land the home exemption does not cover.
 *
 * WHY. The property questions on that step now change real numbers — land on a separate title, and
 * land beyond 2 hectares where the Extended Land Use Test fails, are assessable assets (see
 * shared/src/calculation/homeLandRules.ts). A client who answers "yes, and it's worth $1,000,000"
 * has just moved their Age Pension and their care fee substantially, and until this panel existed
 * nothing on the screen said so.
 *
 * WHAT IT SAYS, and what it deliberately does not. It states the treatment and the direction of the
 * effect, in the terms of whichever goals the client actually selected. It does NOT quote a precise
 * pension figure: the taper only bites above the assets threshold, which depends on their whole
 * balance sheet, so a number here would be wrong for anyone already over or well under it. The
 * projections are where exact figures belong.
 */ 
/**
 * How much of the family home's land the exemption does NOT cover.
 *
 * THE RULE. The principal home is exempt from the Age Pension assets test together with up to
 * 2 hectares of adjacent land ON THE SAME TITLE. Two things fall outside that:
 *
 *   1. LAND ON A SEPARATE TITLE. A title that does not have the house on it is not part of the
 *      principal home, so it is an ordinary assessable asset. No test, no exception.
 *
 *   2. LAND BEYOND 2 HECTARES on the same title. Assessable, UNLESS the EXTENDED LAND USE TEST
 *      applies — which needs BOTH a long-term (20-year) continuous attachment to the property AND
 *      effective use of the land. Where it applies, all the adjacent land on that title is exempt
 *      however large it is.
 *
 * Sources: Social Security Guide 4.6.8 (Assessing Land Adjacent to the Principal Home), 4.6.8.50
 * (general provisions for the extended land use test) and 4.6.8.60 (long-term 20-year continuous
 * attachment); DVA CLIK, Extended Land Use Test. "Effective use" is satisfied where the land is
 * used to its potential to generate income, or where it has little or no such potential.
 *
 * WHY THIS EXISTS. Until 2026-08-22 all four of the property questions on the Living Arrangements
 * step were dead data: `landSize`, `landSizeValue`, `separateTitles`, `separateTitlesValue` and the
 * farm/business follow-ups were written to the fact-find and READ BY NOTHING. They appeared only as
 * displayed facts in the SOA. A client with $500,000 of land on a second title had it counted in
 * neither the Age Pension assets test nor the aged care means test — overstating the pension and
 * understating the care fee, both in the client's favour and both wrong.
 *
 * WHERE THE MONEY LANDS. This value belongs in `assessableAssetsNoHome`, not with the home. That
 * matters for residential aged care, where the HOME is counted only up to the capped amount
 * ($214,884): land outside the exemption is not the home, so it is assessed at its full value with
 * no cap. Putting it in with the home would silently cap it too.
 *
 * NET WORTH IS UNAFFECTED. These values are a PORTION of the home value already entered, which is
 * what the fact-find labels say ("of the home value above"). Adding them to net worth as well would
 * count the same land twice.
 */ const $7d105583031dfe3e$var$numberOf = (value)=>{
    const n = parseFloat(String(value ?? ''));
    return Number.isFinite(n) && n > 0 ? n : 0;
};
function $7d105583031dfe3e$export$3f2cdb774189de73(factFind) {
    const home = factFind?.home || {};
    const twentyYearAttachment = home.longTermLandAttachment === true || home.farmContinuouslyWorked === true;
    const effectiveUse = home.effectiveLandUse === true || home.primaryProductionUse === true;
    return twentyYearAttachment && effectiveUse;
}
function $7d105583031dfe3e$export$2649ec7132aeb253(factFind) {
    const home = factFind?.home || {};
    const separateTitleLand = home.separateTitles ? $7d105583031dfe3e$var$numberOf(home.separateTitlesValue) : 0;
    const excessLandValue = home.landSize ? $7d105583031dfe3e$var$numberOf(home.landSizeValue) : 0;
    const testApplies = excessLandValue > 0 && $7d105583031dfe3e$export$3f2cdb774189de73(factFind);
    const excessLand = testApplies ? 0 : excessLandValue;
    return {
        excessLand: excessLand,
        separateTitleLand: separateTitleLand,
        total: excessLand + separateTitleLand,
        extendedLandUseTestApplies: testApplies
    };
}


const $5731a635b9eda7f9$var$money = (value)=>`$${Math.round(value).toLocaleString('en-AU')}`;
/** What this land does to each goal the client selected. Only the goals they chose are shown. */ function $5731a635b9eda7f9$var$goalImpacts(goals) {
    const blocks = [];
    if (goals?.aged_care) blocks.push({
        label: 'Residential aged care',
        summary: 'This land is counted at its full value in the aged care means test. The home itself is only ever counted up to the capped amount, but land outside the exemption is not the home, so no cap applies to it. That pushes up the means-tested care contribution.'
    });
    if (goals?.home_care) blocks.push({
        label: 'Support at Home',
        summary: 'Home care contributions are means tested on the same assets, so this land raises what would be paid towards a package.'
    });
    if (goals?.downsize_home) blocks.push({
        label: 'Downsizing',
        summary: "This land is already counted, so selling it does not change the assets test the way selling an exempt home does \u2014 the value simply moves from land into cash or investments. What changes is the income it then earns, which is income tested."
    });
    if (goals?.retirement_village) blocks.push({
        label: 'Retirement village',
        summary: 'Moving to a village does not make this land exempt. If it is kept, it stays an assessable asset alongside whatever the village entry contribution is assessed as.'
    });
    if (goals?.granny_flat) blocks.push({
        label: 'Granny flat',
        summary: 'Land kept after moving into a granny flat arrangement stays assessable, and is separate from how the granny flat interest itself is assessed.'
    });
    return blocks;
}
function $5731a635b9eda7f9$export$25a2ea5ac2a1fbbb(factFind) {
    const home = factFind?.home || {};
    const declaredExcessLand = home.landSize === true;
    const declaredSeparateTitle = home.separateTitles === true;
    if (!declaredExcessLand && !declaredSeparateTitle) return null;
    const assessment = (0, $7d105583031dfe3e$export$2649ec7132aeb253)(factFind);
    const goals = factFind.goals || {};
    const excessValue = Number(home.landSizeValue) || 0;
    const separateValue = Number(home.separateTitlesValue) || 0;
    // Answered yes but not valued yet: say what is missing rather than describing a $0 effect.
    if (assessment.total === 0 && !assessment.extendedLandUseTestApplies) {
        const missing = [];
        if (declaredExcessLand && excessValue === 0) missing.push('the land beyond 2 hectares');
        if (declaredSeparateTitle && separateValue === 0) missing.push('the land on the second title');
        if (missing.length === 0) return null;
        return {
            title: 'Land outside the home exemption',
            icon: 'land',
            subtitle: 'A value is needed before we can model it',
            paragraphs: [
                `Add a value for ${missing.join(' and ')} above. Until then we treat it as nothing, which will understate the assets test and overstate the Age Pension.`
            ],
            goalsIntro: null,
            goalBlocks: []
        };
    }
    const paragraphs = [];
    if (assessment.extendedLandUseTestApplies) paragraphs.push(`Because there has been 20 years or more on this property and the extra land is being put to use, Centrelink's extended land use test applies \u{2014} so ALL the land around the home is exempt from the assets test, however large it is. That is worth confirming with Centrelink, since it rests on both of those answers continuing to hold.`);
    else if (excessValue > 0) paragraphs.push(`Only the home and the first 2 hectares around it are exempt. The ${$5731a635b9eda7f9$var$money(excessValue)} of land beyond that is counted as an ordinary asset, because the extended land use test needs both 20 years on the property and the land being put to use.`);
    if (separateValue > 0) paragraphs.push(`A title without the house on it is not part of the principal home, so the ${$5731a635b9eda7f9$var$money(separateValue)} on the second title is counted as an ordinary asset. There is no exemption for it and no size test \u{2014} it is treated like any other property they own.`);
    if (assessment.total > 0) {
        const annualPensionEffect = assessment.total / 1000 * (0, $1abe73eeef086faf$export$6ca758cf677ce6c5);
        paragraphs.push(`Counting ${$5731a635b9eda7f9$var$money(assessment.total)} of land reduces the Age Pension by up to ${$5731a635b9eda7f9$var$money(annualPensionEffect)} a year \u{2014} $3 per fortnight for every $1,000 \u{2014} though only for the part of their assets above the pension threshold. The projections show the actual figure for this file.`);
    }
    return {
        title: 'Land outside the home exemption',
        icon: 'land',
        subtitle: assessment.extendedLandUseTestApplies ? 'Exempt under the extended land use test' : `${$5731a635b9eda7f9$var$money(assessment.total)} counted as an assessable asset`,
        paragraphs: paragraphs,
        goalsIntro: assessment.total > 0 && $5731a635b9eda7f9$var$goalImpacts(goals).length > 0 ? 'What that means for the goals selected in Step 3:' : null,
        goalBlocks: assessment.total > 0 ? $5731a635b9eda7f9$var$goalImpacts(goals) : []
    };
}


/**
 * WHAT THE VILLAGE WOULD PAY BACK TODAY — the live card under "Retirement village" on the Living
 * Arrangements step (owner, 8 Oct 2026). The exit entitlement laid out in the order the contract
 * applies it, every line from the fields as they are typed, adding to the one figure the snapshot's
 * total, net worth and the estate all carry (villageExit.villageInterestToday). The arithmetic is
 * the shared function's; this only names its parts.
 */ /**
 * LEAVING A RETIREMENT VILLAGE FOR RESIDENTIAL CARE (owner, 7 Oct 2026). What the village pays back
 * when a resident leaves — the exit entitlement — and when, from the terms the profile records:
 *
 *   entitlement = expected resale value (or the entry contribution)
 *                 − departure fee (the deferred management fee: a % a year of the entry or resale
 *                   price, for up to a capped number of years of residency)
 *                 − reinstatement cost
 *                 − the operator's share of any capital gain (the resident keeps their share).
 *
 * The refund arrives on the state's timeline where the unit has not resold sooner: the states set
 * a longstop (retirementVillageStateRules.ts — NSW 6 or 12 months, VIC about 6, QLD and SA 18, WA
 * 12; TAS, ACT and NT set none, so 12 is assumed and the contract decides). Until it arrives the
 * amount owed is an asset of the resident's and the new room's deposit is not yet paid from it.
 *
 * The same arithmetic the village module uses for a move IN (retirementVillageCalculations.ts),
 * here for a move OUT.
 */ /**
 * Retirement Village (Independent Living) – calculations only.
 * Does NOT call or alter calculateAgedCareCosts, computeMeansTestedFees, getMtaBreakdown.
 * May call calculateFinancials with prepared factFind for pension/cashflow.
 *
 * Ported verbatim from frontend/src/calculations/RetirementVillageCalculations.js.
 */ 
/**
 * financialCalculations.ts
 * Core financial engine: Age Pension, tax, deeming, cashflow, aged care costs.
 * Ported verbatim from frontend/src/calculations/FinancialCalculations.js — see the golden-master
 * regression suite (server/tests/rest/calculation/goldenMaster/) for the parity proof.
 *
 * `calculateFinancials` computes ONE year's assessment; {@link ../projectionEngine.ts} walks that
 * snapshot forward year by year, which is why the two now sit beside each other. This directory holds
 * the assessment that engine is built on — the means test, deeming, the pension, tax, expenses, net
 * worth, loan repayments, home equity release — with the individual rules injected as assessors owned
 * by the projection plugins (see `../plugins/`).
 *
 * It lived in `shared/` until the frontend stopped importing it. Nothing in `frontend/src` calls this
 * function: the browser reaches it over HTTP, through `/rest/calculation` (see calculationApi.ts).
 * What kept it in `shared/` was four small helpers that happened to share this file — they are now in
 * `shared/src/calculation/householdStatus.ts` and `giftingDeprivation.ts`.
 */ /**
 * A change of aged care home, applied to a balance sheet AS AT THE MOVE (8 Oct 2026): the old deposit's
 * refundable balance comes back, the nominated assets have been sold for the rest, the new deposit is
 * paid, and whatever is left of the refund stays in the bank. Used for the position the new home's
 * fees are assessed on (the Suggestion Engine) and for the "after the move" position screens quote
 * (the Analyser). The projection does the same thing day by day (facilityMovePlugin).
 */ /**
 * Paying the RAD: which assets are liquidated for it, and what the balance sheet looks like afterwards.
 *
 * THE one implementation. It existed twice for most of this codebase's life — in the frontend's
 * `strategy/StrategyIntegrationUtils.ts`, where it was written, and as a verbatim port inside the
 * server's `suggestionEngine/agedCare.ts` — with each copy reaching for its own build of the funding
 * helpers underneath. Two copies of an arithmetic that decides what a client is told their strategy
 * costs is one copy too many, and they HAD drifted: one produced a `NaN` balance where the other
 * produced a number, for an asset carrying no recorded value. Both now import this.
 *
 * It lives in `shared/` rather than in either caller because that is the only place both can reach.
 * The server's suggestion engine and the frontend's Support-at-Home funding panels both need it, and
 * the frontend cannot import the server's copy without dragging the whole suggestion engine into a
 * browser bundle.
 *
 * A NOTE ON WHEN THIS HAPPENS, because the function itself cannot say it: this is applied to a
 * fact-find BEFORE any projection runs, so the assets leave the balance sheet at the projection's
 * origin. That is wrong whenever care starts later than the run does — a client entering in nine
 * months does not sell their shares today — and it is why `strategyOptions.careStartDate` can defer
 * the CARE COSTS but not yet the payment that funds them. Making this a dated event inside the engine
 * is the outstanding piece of work; see the note on `radPlugin.beforeProjection`.
 */ /**
 * Phase 2 — entity-aware strategy funding helpers (Aged Care manual control slice 1).
 * Ported from frontend/src/utils/entityFundingUtils.js — deliberately a MINIMAL subset: only the
 * exports actually consumed by calculations/entityDisposalTax.ts, calculations/
 * retirementVillageCalculations.ts, calculation/assetLiquidation.ts (the server-side duplicate of
 * strategy/StrategyIntegrationUtils.js's `liquidateChosenAssets`), and
 * calculation/suggestionEngine/downsizer.ts (the server-side duplicate of features/supportAtHome/
 * supportAtHomeFactFindMutators.js's `applyDownsizeToFactFind`, which needs
 * `debitFromPersonalBankFirst`). Everything else in the frontend file (RAD-slider grouping helpers,
 * the suggestion-engine funding disclaimer, etc.) is UI-only and was never a dependency of the
 * calculation engine.
 *
 * Note: this file and ../entityDisposalTax.ts import from each other (resolveRadFundingEntry needs
 * calculateSharePartialDisposalTax/parseCgtOverride; entityDisposalTax needs findAssetInFactFind/
 * parseRadFundingAssetKey from here). This is a pre-existing circular import in the original
 * frontend code — both symbols are only referenced inside function bodies, never at module-eval
 * time, so ESM's live bindings resolve it safely. Do not try to "fix" it; the golden master proves
 * behavior either way.
 */ /**
 * Client Profile — trust, company, and partnership structure types (plain-language labels).
 * Ported from frontend/src/constants/clientStructureTypes.js — deliberately omits the UI-only
 * form-building/validation exports (`createStructureId`, `createEmptyStructure`,
 * `validateStructureApportionment`) since the calculation engine never calls them.
 */ const $1773fcf9595c5c0a$export$d2183eae03e7e94c = 'entity:';
const $1773fcf9595c5c0a$export$e2e42979292e1004 = [
    {
        id: 'family_trust',
        label: 'Family trust'
    },
    {
        id: 'unit_trust',
        label: 'Unit trust'
    },
    {
        id: 'private_company',
        label: 'Private company'
    },
    {
        id: 'partnership',
        label: 'Partnership'
    },
    {
        id: 'other',
        label: "Other / I'm not sure"
    }
];
function $1773fcf9595c5c0a$export$66d936c41d42a933(entityId) {
    return `${$1773fcf9595c5c0a$export$d2183eae03e7e94c}${entityId}`;
}
function $1773fcf9595c5c0a$export$22ac2880024a2dd9(ownership) {
    return typeof ownership === 'string' && ownership.startsWith($1773fcf9595c5c0a$export$d2183eae03e7e94c);
}
function $1773fcf9595c5c0a$export$6a61da9f052ec919(ownership) {
    if (!$1773fcf9595c5c0a$export$22ac2880024a2dd9(ownership)) return null;
    return ownership.slice($1773fcf9595c5c0a$export$d2183eae03e7e94c.length);
}
function $1773fcf9595c5c0a$export$378ace8cc3e15f6d(typeId) {
    return $1773fcf9595c5c0a$export$e2e42979292e1004.find((t)=>t.id === typeId)?.label || 'Arrangement';
}
function $1773fcf9595c5c0a$export$b93377b4473f408b(structure, isPartnered) {
    const clientPct = Math.min(100, Math.max(0, structure.apportionmentClient || 0));
    const partnerPct = isPartnered ? Math.min(100, Math.max(0, structure.apportionmentPartner || 0)) : 0;
    return Math.min(100, clientPct + partnerPct);
}
function $1773fcf9595c5c0a$export$292b9fd0d68dfd69(structure, isPartnered) {
    return Math.max(0, 100 - $1773fcf9595c5c0a$export$b93377b4473f408b(structure, isPartnered));
}


/**
 * Disposal tax entry points for investment property and partial share/managed-fund sales, plus the
 * accountant CGT override.
 *
 * The CGT MATH ITSELF now lives in ./disposalCgt.ts — this module is a thin adapter that maps the
 * long-standing call signatures (and the UI's free-text cost base field) onto it. It previously held
 * its own copy of the cost-base/gain/marginal-rate logic, which had drifted from the three other
 * copies elsewhere in the codebase; see disposalCgt.ts's header for what that drift caused.
 *
 * Note: this file and ./support/entityFundingUtils.ts import from each other (see that file's
 * header comment) — a pre-existing, safe circular import (function-body-only references).
 */ 
/**
 * Capital Gains Tax on a disposal — THE single implementation.
 *
 * This replaces four independent copies of the same "proportional cost base → assessable gain →
 * marginal rate" math that had drifted apart (`entityDisposalTax.calculateAssetDisposalTax`,
 * `taxAndLoanUtils.calculateCgt`, `retirementVillageCalculations.computeInvestmentPropertyNetForAmount`,
 * `SupportAtHomeHelpers.calculateCgtForStrategy`). They disagreed on ownership splitting, on whether
 * selling costs reduced the gain, and on which reform inputs were passed — so the same asset could
 * produce different CGT depending on which screen the adviser was on. All four now delegate here.
 *
 * WHAT CHANGED vs the old implementations (all deliberate):
 *
 *  1. Tax on the gain is now DIFFERENTIAL, not a flat marginal rate: the tax on the person's income
 *     INCLUDING their share of the gain, less the tax on the same income WITHOUT it. That single change
 *     picks up three things the flat rate missed —
 *       • bracket steps (the old flat top-rate overstated gains that straddled a threshold),
 *       • the 2% Medicare levy on the gain (previously never charged),
 *       • the SAPTO/LITO taper the gain causes (previously the offsets survived the gain intact,
 *         understating tax in the sale year for pensioner clients).
 *     Net direction varies by client; it is now correct rather than conservative-by-accident.
 *
 *  2. Ownership is always honoured. A jointly-owned asset splits 50/50 across both partners' own
 *     positions; `partner`-owned taxes the partner. Previously the aged-care path taxed the entire gain
 *     at the client's rate regardless of ownership, while the retirement village path split correctly.
 *
 *  3. The 1-Jul-2027 reform is actually wired: real disposal date, a non-zero CPI for indexing the
 *     post-commencement slice, and the 30% minimum-tax floor (with its income-support exemption),
 *     which existed in `capitalGainsTax.ts` but was never called from production code.
 *
 * KNOWN LIMITATION (surfaced, not hidden): the fact-find only records acquisition as a `'pre' | 'post'`
 * 1985 flag, not a real date. The reform's straddle apportionment needs an actual acquisition date, so
 * where one is absent we assume a long-held asset (`DEFAULT_ACQUISITION_DATE`) and attach a warning to
 * the result whenever that assumption actually affects the answer — i.e. post-commencement disposals.
 * Advisers can override the CGT figure outright (see `getEffectiveDisposalCgt`).
 */ /**
 * Capital Gains Tax regime configuration — single source of truth + the reform on/off switch.
 * Ported verbatim from frontend/src/constants/cgtReform.js.
 */ const $9d417e6055be1d2a$export$4e9d9ceebe11543e = {
    /** Master switch. false => behave exactly as the pre-reform 50% discount regime, app-wide. */ reformEnabled: true,
    /** Reform commences for gains accruing on/after this date. */ commencementDate: '2027-07-01',
    /** Pre-reform / grandfathered / pre-commencement discount (the legacy 50% CGT discount). */ discountRate: 0.50,
    /** Minimum holding period for the discount / for the reform to apply (12 months). */ minDiscountHoldingMonths: 12,
    /** Minimum (floor) tax rate on the real (post-commencement, indexed) gain. */ minimumTaxRate: 0.30,
    /**
     * Means-tested income-support recipients (e.g. Age Pension, JobSeeker) are exempt from the 30%
     * minimum tax in any year they receive a payment.
     */ incomeSupportExempt: true,
    /** Retained 60% discount for qualifying affordable housing (unchanged by the reform). */ affordableHousingDiscountRate: 0.60,
    /**
     * Default CPI used to index the cost base of the POST-commencement slice of a gain.
     * Only relevant once `commencementDate` has passed. Callers that know the plan's own inflation
     * assumption (projections do) should pass it instead of relying on this.
     *
     * This must never be left at 0: indexation IS the reform's replacement for the 50% discount, so a
     * zero CPI would tax the whole nominal post-commencement gain and materially overstate CGT.
     */ defaultCpiRate: 0.025,
    /**
     * When a CGT asset has no cost base recorded, assume a cost base of 25% of current value (i.e. a 75%
     * gain) — a conservative default. Adviser-overridable via the asset's actual cost base.
     */ assumedCostBaseFraction: 0.25
};
var $9d417e6055be1d2a$export$2e2bcd8739ae039 = $9d417e6055be1d2a$export$4e9d9ceebe11543e;


/**
 * Capital Gains Tax engine — the single place that decides the TAXABLE capital gain and the
 * 30% minimum-tax floor, under either the legacy 50% discount regime or the 1-Jul-2027 reform.
 * Ported verbatim from frontend/src/calculations/capitalGainsTax.js — see the golden-master
 * regression suite (server/tests/rest/calculation/goldenMaster/) for the parity proof.
 *
 * NOTE (main residence): the family home stays CGT-free under the reform — this engine is for
 * ASSESSABLE assets (investment property, shares/managed funds, units), never the main residence.
 */ 
const $b9032eccb178cc91$var$MS_PER_YEAR = 31557600000;
function $b9032eccb178cc91$export$e557acc6c40effbe(from, to) {
    const a = new Date(from).getTime();
    const b = new Date(to).getTime();
    if (!Number.isFinite(a) || !Number.isFinite(b)) return 0;
    return Math.max(0, (b - a) / $b9032eccb178cc91$var$MS_PER_YEAR);
}
function $b9032eccb178cc91$export$80759b1428b770f7(costBase, years, cpiRate) {
    const cb = Number(costBase) || 0;
    if (!(cb > 0) || !(years > 0) || !(cpiRate > 0)) return cb;
    return cb * Math.pow(1 + cpiRate, years);
}
function $b9032eccb178cc91$export$2da8422d722b2151({ costBase: costBase, proceeds: proceeds, holdingYears: holdingYears, preYears: preYears }) {
    const cb = Number(costBase) || 0;
    const p = Number(proceeds) || 0;
    if (!(cb > 0) || !(holdingYears > 0) || !(preYears > 0) || p <= 0) return cb;
    const fraction = Math.min(1, preYears / holdingYears);
    return cb * Math.pow(p / cb, fraction);
}
function $b9032eccb178cc91$export$3303a7493d3b9925(acquisitionDate, disposalDate, config = (0, $9d417e6055be1d2a$export$4e9d9ceebe11543e)) {
    const holdingYears = $b9032eccb178cc91$export$e557acc6c40effbe(acquisitionDate, disposalDate);
    if (!config.reformEnabled) return {
        phase: 'old',
        holdingYears: holdingYears,
        preYears: holdingYears,
        postYears: 0
    };
    const commence = new Date(config.commencementDate).getTime();
    const acq = new Date(acquisitionDate).getTime();
    const disp = new Date(disposalDate).getTime();
    if (disp <= commence) return {
        phase: 'old',
        holdingYears: holdingYears,
        preYears: holdingYears,
        postYears: 0
    };
    if (acq >= commence) return {
        phase: 'new',
        holdingYears: holdingYears,
        preYears: 0,
        postYears: holdingYears
    };
    return {
        phase: 'straddle',
        holdingYears: holdingYears,
        preYears: $b9032eccb178cc91$export$e557acc6c40effbe(acquisitionDate, config.commencementDate),
        postYears: $b9032eccb178cc91$export$e557acc6c40effbe(config.commencementDate, disposalDate)
    };
}
function $b9032eccb178cc91$export$9003ec1a931d0da5(params) {
    const config = params.config || (0, $9d417e6055be1d2a$export$4e9d9ceebe11543e);
    const cb = Math.max(0, Number(params.costBase) || 0);
    const proceeds = Math.max(0, Number(params.proceeds) || 0);
    const cpiRate = params.cpiRate != null ? Number(params.cpiRate) : 0;
    const discountRate = params.discountRate != null ? Number(params.discountRate) : config.discountRate;
    const { phase: phase, holdingYears: holdingYears, preYears: preYears, postYears: postYears } = params.phase ? params : $b9032eccb178cc91$export$3303a7493d3b9925(params.acquisitionDate, params.disposalDate, config);
    const grossGain = Math.max(0, proceeds - cb);
    const eligibleForDiscount = holdingYears >= config.minDiscountHoldingMonths / 12;
    const zero = {
        grossGain: 0,
        preCommencementTaxable: 0,
        postCommencementTaxable: 0,
        totalTaxable: 0,
        valueAtCommencement: cb,
        phase: phase
    };
    if (grossGain <= 0) return zero;
    if (phase === 'old') {
        const taxable = eligibleForDiscount ? grossGain * (1 - discountRate) : grossGain;
        return {
            grossGain: grossGain,
            preCommencementTaxable: taxable,
            postCommencementTaxable: 0,
            totalTaxable: taxable,
            valueAtCommencement: cb,
            phase: phase
        };
    }
    if (phase === 'new') {
        const idxCb = $b9032eccb178cc91$export$80759b1428b770f7(cb, holdingYears, cpiRate);
        const taxable = Math.max(0, proceeds - idxCb);
        return {
            grossGain: grossGain,
            preCommencementTaxable: 0,
            postCommencementTaxable: taxable,
            totalTaxable: taxable,
            valueAtCommencement: cb,
            phase: phase
        };
    }
    // straddle: 50% discount on the gain to commencement, indexation on the gain after.
    const valComm = params.valueAtCommencement != null ? Number(params.valueAtCommencement) : $b9032eccb178cc91$export$2da8422d722b2151({
        costBase: cb,
        proceeds: proceeds,
        holdingYears: holdingYears,
        preYears: preYears
    });
    const preGross = Math.max(0, valComm - cb);
    const preTaxable = eligibleForDiscount ? preGross * (1 - discountRate) : preGross;
    const idxValComm = $b9032eccb178cc91$export$80759b1428b770f7(valComm, postYears, cpiRate);
    const postTaxable = Math.max(0, proceeds - idxValComm);
    return {
        grossGain: grossGain,
        preCommencementTaxable: preTaxable,
        postCommencementTaxable: postTaxable,
        totalTaxable: preTaxable + postTaxable,
        valueAtCommencement: valComm,
        phase: phase
    };
}
function $b9032eccb178cc91$export$24bf1cd46b37291b(grossGain, config = (0, $9d417e6055be1d2a$export$4e9d9ceebe11543e)) {
    const g = Math.max(0, Number(grossGain) || 0);
    return g * (1 - config.discountRate);
}
const $b9032eccb178cc91$export$8e8046f1601fbb03 = '2000-01-01';
function $b9032eccb178cc91$export$a8d693a210faf7c(asset) {
    const raw = typeof asset?.acquiredOn === 'string' ? asset.acquiredOn.trim() : '';
    const match = /^(\d{4})-(\d{2})$/.exec(raw);
    if (!match) return null;
    const year = Number(match[1]);
    const month = Number(match[2]);
    if (!Number.isFinite(year) || !Number.isFinite(month) || month < 1 || month > 12) return null;
    // Reject implausible years rather than silently producing a wild holding period.
    if (year < 1900 || year > 2200) return null;
    return new Date(year, month - 1, 1);
}
function $b9032eccb178cc91$export$57d0fb9544f11f95(asset, config = (0, $9d417e6055be1d2a$export$4e9d9ceebe11543e)) {
    const entered = asset?.costBase ?? 0;
    if (entered > 0) return {
        costBase: entered,
        assumed: false
    };
    const value = asset?.value ?? 0;
    return {
        costBase: value * config.assumedCostBaseFraction,
        assumed: value > 0
    };
}
/** CGT started on 20 September 1985; assets acquired before then are generally exempt. */ const $b9032eccb178cc91$var$CGT_START_YEAR = 1985;
const $b9032eccb178cc91$var$CGT_START_MONTH = 9; // September — the 20th, hence the boundary-month note below
function $b9032eccb178cc91$export$321afe5948362992(asset) {
    const acquired = $b9032eccb178cc91$export$a8d693a210faf7c(asset);
    if (acquired) {
        const year = acquired.getFullYear();
        if (year !== $b9032eccb178cc91$var$CGT_START_YEAR) return year < $b9032eccb178cc91$var$CGT_START_YEAR;
        return acquired.getMonth() + 1 < $b9032eccb178cc91$var$CGT_START_MONTH;
    }
    return asset?.acquisitionDate === 'pre';
}
function $b9032eccb178cc91$export$4925b8eeac08d64e({ costBase: costBase, proceeds: proceeds, acquisitionDate: acquisitionDate, disposalDate: disposalDate = new Date(), cpiRate: cpiRate = 0, config: config = (0, $9d417e6055be1d2a$export$4e9d9ceebe11543e) }) {
    return $b9032eccb178cc91$export$9003ec1a931d0da5({
        costBase: costBase,
        proceeds: proceeds,
        acquisitionDate: acquisitionDate || $b9032eccb178cc91$export$8e8046f1601fbb03,
        disposalDate: disposalDate,
        cpiRate: cpiRate,
        config: config
    }).totalTaxable;
}
function $b9032eccb178cc91$export$55eec17788642ecf({ postCommencementTaxable: postCommencementTaxable, marginalTaxOnPost: marginalTaxOnPost, isIncomeSupportRecipient: isIncomeSupportRecipient, config: config = (0, $9d417e6055be1d2a$export$4e9d9ceebe11543e) }) {
    const g = Math.max(0, Number(postCommencementTaxable) || 0);
    const marginal = Math.max(0, Number(marginalTaxOnPost) || 0);
    if (!config.reformEnabled || g <= 0) return marginal;
    if (isIncomeSupportRecipient && config.incomeSupportExempt) return marginal;
    return Math.max(marginal, g * config.minimumTaxRate);
}




/**
 * Income tax — what each person owes on the income they were assessed on, as a pure function.
 *
 * Given the two tax positions `incomeAssessment.ts` struck (assessable sources, deductions, franking
 * credits), this applies the tax system to each of them in the order the ATO does, which is the whole
 * substance of the module:
 *
 *   1. TAXABLE INCOME = salary + assessable investment income − deductions.
 *   2. GROSS TAX from the marginal brackets.
 *   3. FRANKING CREDITS come off first, as tax already paid by the company on the client's behalf.
 *   4. SAPTO (the seniors and pensioners offset) then LITO (the low-income offset), each capped at the
 *      tax still standing — the order matters, and neither is refundable: an offset cannot take the bill
 *      below zero or turn into a payment.
 *   5. THE MEDICARE LEVY is added last, and offsets do NOT reduce it — which is why a retiree with no
 *      income tax to pay can still owe the levy.
 *
 * Two things about the levy are worth knowing because they are easy to misread. It is assessed on the
 * PERSON but thresholded on the FAMILY: a couple is tested against the combined figure, and where they
 * are between the family thresholds each pays a share of the family levy in proportion to their own
 * income. And a senior or pensioner entitled to SAPTO is tested on higher thresholds than everyone else.
 *
 *   6. THE MEDICARE LEVY SURCHARGE is added after the levy for a person WITHOUT private hospital cover
 *      whose income for surcharge purposes (taxable income plus any net investment loss added back) puts
 *      the household past the base tier: 1%, 1.25% or 1.5% of that person's own income. Private cover
 *      avoids the surcharge and NOTHING ELSE — until 17 Sep 2026 the engine treated `person.phi` as
 *      exempting the levy itself, which understated a covered client's tax by 2% of their income.
 *
 * The offsets and brackets are passed in per call, not read from the constants: a projected year is taxed
 * against indexed rates, and `calculateFinancials` resolves those before calling in. That is also why the
 * Medicare calculation can live here at all — it used to be a closure inside `calculateFinancials` for
 * want of anywhere to put the `rates` it depends on.
 *
 * Extracted from `calculateFinancials`'s "--- 6. Tax Calculation ---" block, which still calls it —
 * through the injectable {@link IncomeTaxAssessor} seam, so the projection engine can hand in the
 * assessor owned by its incomeTaxPlugin.
 */ 
/**
 * Currency formatting and parsing utilities used by the calculation engine.
 * Ported from frontend/src/utils/currency.js — omits `isCurrencyField` (a form-label heuristic,
 * UI-only, never called by calculations/).
 */ /**
 * A fact-find money field as a plain number, 0 when it is absent or unreadable.
 *
 * `FactFind` types every money field `number`, and the REST boundary coerces to match (see
 * factFindNumericSchema.ts) — but in-process callers are not obliged to, so some paths still hand over
 * the numeric STRING a form input produced. This is the one place that discrepancy is handled.
 *
 * It replaced a scattering of `parseFloat(asset.value)` calls, which typechecked only while the
 * surrounding parameter was `any`: once a fact-find is typed, passing a `number` to `parseFloat` is an
 * error, and "coerce a value the types already call a number" is the wrong thing to write anyway.
 * Behaviour is unchanged — a number passes through, a numeric string parses, anything else is 0.
 */ function $f0c9bf200cde0a0e$export$d5dd4ec4ecfc0a2b(value) {
    const amount = typeof value === 'number' ? value : parseFloat(String(value ?? ''));
    return Number.isFinite(amount) ? amount : 0;
}
function $f0c9bf200cde0a0e$export$dc5333890dfc7d0(value) {
    if (!value || value === '') return '';
    const cleanValue = String(value).replace(/[$,\s]/g, '');
    const numValue = parseFloat(String(cleanValue));
    return isNaN(numValue) ? '' : numValue.toString();
}
/*
 * A whole number grouped in threes with commas — exactly what `toLocaleString()` gives for one under the
 * runtime's locale, checked once here, and used only when that check holds (24 Oct 2026: a projection
 * formats tens of thousands of figures, and `toLocaleString` per figure was a measurable share of a cold
 * aged care analysis). Any other locale, or a figure too large to print plainly, takes `toLocaleString`.
 */ const $f0c9bf200cde0a0e$var$GROUPS_WITH_COMMAS = 1234567..toLocaleString() === '1,234,567' && 999..toLocaleString() === '999' && 1000..toLocaleString() === '1,000';
function $f0c9bf200cde0a0e$var$groupThousands(whole) {
    if (!$f0c9bf200cde0a0e$var$GROUPS_WITH_COMMAS || !(whole < 1e15)) return whole.toLocaleString();
    const digits = String(whole);
    const len = digits.length;
    if (len <= 3) return digits;
    let out = '';
    for(let i = 0; i < len; i++){
        if (i > 0 && (len - i) % 3 === 0) out += ',';
        out += digits[i];
    }
    return out;
}
function $f0c9bf200cde0a0e$export$3dc27271f5d5c629(value) {
    if (value === null || value === undefined || isNaN(value)) return '$0';
    const num = typeof value === 'number' ? value : parseFloat(String(value)) || 0;
    const roundedValue = Math.round(num);
    return `${roundedValue < 0 ? '-' : ''}$${$f0c9bf200cde0a0e$var$groupThousands(Math.abs(roundedValue))}`;
}
function $f0c9bf200cde0a0e$export$3f5163df82d5e96(value) {
    return `<nv>${$f0c9bf200cde0a0e$export$3dc27271f5d5c629(value)}</nv>`;
}
function $f0c9bf200cde0a0e$export$50a31df933489641(value) {
    if (value === '' || value === undefined || value === null) return '';
    const n = Number(value);
    if (isNaN(n)) return '';
    return '$' + n.toLocaleString('en-AU', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
}


/**
 * The rate at which the Medicare levy phases in between a threshold's lower and upper bound: 10c per
 * dollar of income above the lower one, until the full {@link MEDICARE_LEVY_RATE} applies to the whole
 * income instead.
 */ const $231c5fe5568c4f9c$var$MEDICARE_LEVY_SHADE_IN_RATE = 0.10;
const $231c5fe5568c4f9c$export$3873f5b68a2e0751 = (0, $1abe73eeef086faf$export$b8352069eaf11cd3).map((b, i)=>({
        ...b,
        previousLimit: i === 0 ? 0 : (0, $1abe73eeef086faf$export$b8352069eaf11cd3)[i - 1].limit
    }));
function $231c5fe5568c4f9c$export$f2c8f7fe82b5a229(brackets) {
    return brackets.map((b, i)=>({
            ...b,
            previousLimit: i === 0 ? 0 : brackets[i - 1].limit
        }));
}
const $231c5fe5568c4f9c$export$76f2629190a16093 = (taxableIncome, brackets)=>{
    if (taxableIncome <= 0 || !brackets?.length) return 0;
    let tax = 0;
    let remainingIncome = taxableIncome;
    for (const bracket of brackets){
        if (remainingIncome <= 0) break;
        const bracketWidth = bracket.limit === Infinity ? Infinity : bracket.limit - (bracket.previousLimit || 0);
        const taxableInBracket = Math.min(remainingIncome, bracketWidth);
        tax += taxableInBracket * bracket.rate;
        remainingIncome -= taxableInBracket;
    }
    return tax;
};
const $231c5fe5568c4f9c$export$32eed5f4447a26d2 = (taxableIncome, brackets = $231c5fe5568c4f9c$export$3873f5b68a2e0751)=>$231c5fe5568c4f9c$export$76f2629190a16093(taxableIncome, brackets);
function $231c5fe5568c4f9c$export$9ecf5542cff0e246(taxableIncome, brackets) {
    const bracket = brackets.find((b)=>taxableIncome <= b.limit) || brackets[brackets.length - 1];
    return bracket.rate;
}
function $231c5fe5568c4f9c$export$22af65338fcd05cf(taxableIncome, lito = (0, $1abe73eeef086faf$export$c3b5f1f009bc99af)) {
    if (taxableIncome == null || taxableIncome <= 0) return 0;
    const ti = taxableIncome;
    if (ti <= lito.firstThreshold) return lito.maxOffset;
    if (ti <= lito.secondThreshold) return Math.max(0, lito.maxOffset - (ti - lito.firstThreshold) * lito.firstTaperPerDollar);
    if (ti < lito.cutOut) {
        const atSecondBandStart = lito.maxOffset - (lito.secondThreshold - lito.firstThreshold) * lito.firstTaperPerDollar;
        return Math.max(0, atSecondBandStart - (ti - lito.secondThreshold) * lito.secondTaperPerDollar);
    }
    return 0;
}
function $231c5fe5568c4f9c$export$49dbe3118fe8ca9e(rebateIncome, band, taperRate = (0, $1abe73eeef086faf$export$c2f6cffbd7c53bc0)) {
    if (!band) return 0;
    const ri = rebateIncome == null ? 0 : rebateIncome;
    if (ri <= band.shadeIn) return band.maxOffset;
    if (ri >= band.cutOut) return 0;
    return Math.max(0, band.maxOffset - taperRate * (ri - band.shadeIn));
}
function $231c5fe5568c4f9c$export$1cdbf71a09396579() {
    return {
        lito: {
            ...(0, $1abe73eeef086faf$export$c3b5f1f009bc99af)
        },
        sapto: {
            single: {
                ...(0, $1abe73eeef086faf$export$e66d40af5bf25f2b).single
            },
            coupleMember: {
                ...(0, $1abe73eeef086faf$export$e66d40af5bf25f2b).coupleMember
            },
            illnessSeparatedMember: {
                ...(0, $1abe73eeef086faf$export$e66d40af5bf25f2b).illnessSeparatedMember
            }
        }
    };
}
function $231c5fe5568c4f9c$export$3e0cfe4b9bf248df(scale) {
    const s = (n)=>Math.round(scale(n));
    return {
        lito: {
            maxOffset: s((0, $1abe73eeef086faf$export$c3b5f1f009bc99af).maxOffset),
            firstThreshold: s((0, $1abe73eeef086faf$export$c3b5f1f009bc99af).firstThreshold),
            secondThreshold: s((0, $1abe73eeef086faf$export$c3b5f1f009bc99af).secondThreshold),
            cutOut: s((0, $1abe73eeef086faf$export$c3b5f1f009bc99af).cutOut),
            firstTaperPerDollar: (0, $1abe73eeef086faf$export$c3b5f1f009bc99af).firstTaperPerDollar,
            secondTaperPerDollar: (0, $1abe73eeef086faf$export$c3b5f1f009bc99af).secondTaperPerDollar
        },
        sapto: {
            single: {
                maxOffset: s((0, $1abe73eeef086faf$export$e66d40af5bf25f2b).single.maxOffset),
                shadeIn: s((0, $1abe73eeef086faf$export$e66d40af5bf25f2b).single.shadeIn),
                cutOut: s((0, $1abe73eeef086faf$export$e66d40af5bf25f2b).single.cutOut)
            },
            coupleMember: {
                maxOffset: s((0, $1abe73eeef086faf$export$e66d40af5bf25f2b).coupleMember.maxOffset),
                shadeIn: s((0, $1abe73eeef086faf$export$e66d40af5bf25f2b).coupleMember.shadeIn),
                cutOut: s((0, $1abe73eeef086faf$export$e66d40af5bf25f2b).coupleMember.cutOut)
            },
            illnessSeparatedMember: {
                maxOffset: s((0, $1abe73eeef086faf$export$e66d40af5bf25f2b).illnessSeparatedMember.maxOffset),
                shadeIn: s((0, $1abe73eeef086faf$export$e66d40af5bf25f2b).illnessSeparatedMember.shadeIn),
                cutOut: s((0, $1abe73eeef086faf$export$e66d40af5bf25f2b).illnessSeparatedMember.cutOut)
            }
        }
    };
}
function $231c5fe5568c4f9c$export$c3818d4c83bdc6df(taxableIncome, relationshipStatus, isSenior, familyTaxableIncome, medicareLevyThresholds) {
    if (taxableIncome <= 0) return 0;
    const singleThresholds = isSenior && medicareLevyThresholds.singleSenior || medicareLevyThresholds.single;
    if (relationshipStatus === 'single') {
        if (taxableIncome <= singleThresholds.lower) return 0;
        if (taxableIncome > singleThresholds.upper) return taxableIncome * (0, $1abe73eeef086faf$export$ff4b97dcd3d2d7f1);
        return (taxableIncome - singleThresholds.lower) * $231c5fe5568c4f9c$var$MEDICARE_LEVY_SHADE_IN_RATE;
    }
    const coupleThresholds = isSenior && medicareLevyThresholds.coupleSenior || medicareLevyThresholds.couple;
    if (familyTaxableIncome <= coupleThresholds.lower) return 0;
    if (taxableIncome <= singleThresholds.lower) return 0;
    if (familyTaxableIncome > coupleThresholds.upper) return taxableIncome * (0, $1abe73eeef086faf$export$ff4b97dcd3d2d7f1);
    const familyLevy = (familyTaxableIncome - coupleThresholds.lower) * $231c5fe5568c4f9c$var$MEDICARE_LEVY_SHADE_IN_RATE;
    return familyTaxableIncome > 0 ? familyLevy * (taxableIncome / familyTaxableIncome) : 0;
}
function $231c5fe5568c4f9c$export$c956bafa47f29828(mlsIncome, relationshipStatus, hasPhi, familyMlsIncome, lowIncomeThreshold, rates = (0, $1abe73eeef086faf$export$3f2efd37e8996007)) {
    if (hasPhi || mlsIncome <= 0 || mlsIncome <= lowIncomeThreshold) return 0;
    const tested = relationshipStatus === 'single' ? mlsIncome : familyMlsIncome;
    const tier = rates.tiers.find((t)=>tested <= (relationshipStatus === 'single' ? t.singleUpTo : t.familyUpTo)) ?? rates.tiers[rates.tiers.length - 1];
    return mlsIncome * tier.rate;
}
function $231c5fe5568c4f9c$export$5a709ffc9109087e(position) {
    // Salary reaches the position as a named source among the investment ones (see PersonTaxPosition),
    // so it is set aside by name: a net investment loss is deductions in excess of INVESTMENT income.
    const investmentIncome = position.investmentSources.filter((s)=>!$231c5fe5568c4f9c$var$SALARY_LIKE.test(s.name)).reduce((sum, s)=>sum + s.amount, 0);
    const deductions = position.deductionSources.reduce((sum, d)=>sum + d.amount, 0);
    const netInvestmentLoss = Math.max(0, deductions - investmentIncome);
    return $231c5fe5568c4f9c$export$e0a51b6acb20dacf(position) + netInvestmentLoss;
}
/** How a salary source is named in a tax position — the tool's own descriptions and a client's. */ const $231c5fe5568c4f9c$var$SALARY_LIKE = /salary|wage|employment/i;
function $231c5fe5568c4f9c$export$e0a51b6acb20dacf(position) {
    return position.salary + position.investmentSources.reduce((sum, source)=>sum + source.amount, 0) - position.deductionSources.reduce((sum, deduction)=>sum + deduction.amount, 0);
}
/** No tax, no working — an absent partner. */ const $231c5fe5568c4f9c$var$NO_TAX = {
    netTax: 0,
    totalTaxable: 0,
    breakdown: []
};
/**
 * Taxes one person: their taxable income, the tax on it, the offsets against that tax in statutory
 * order, and the levy on top — rendering the working line by line as it goes.
 */ function $231c5fe5568c4f9c$var$taxOnePerson(personName, taxable, phi, relationshipStatus, familyTaxableIncome, familyMlsIncome, personAge, saptoBand, rates, lito) {
    const totalInvestmentIncome = taxable.investmentSources.reduce((sum, s)=>sum + s.amount, 0);
    const totalDeductions = taxable.deductionSources.reduce((sum, d)=>sum + d.amount, 0);
    const totalTaxable = taxable.salary + totalInvestmentIncome - totalDeductions;
    const grossTax = $231c5fe5568c4f9c$export$76f2629190a16093(totalTaxable, rates.taxBrackets);
    // Pension age is the tool's proxy for SAPTO entitlement (as it is for the offset itself below).
    const isSenior = personAge != null && personAge >= (0, $1abe73eeef086faf$export$5b6998cba7880742);
    const medicare = $231c5fe5568c4f9c$export$c3818d4c83bdc6df(totalTaxable, relationshipStatus, isSenior, familyTaxableIncome, rates.medicareLevyThresholds);
    const levyLowerThreshold = (isSenior && rates.medicareLevyThresholds.singleSenior || rates.medicareLevyThresholds.single).lower;
    const surcharge = $231c5fe5568c4f9c$export$c956bafa47f29828($231c5fe5568c4f9c$export$5a709ffc9109087e(taxable), relationshipStatus, phi === true, familyMlsIncome, levyLowerThreshold, rates.medicareLevySurcharge ?? (0, $1abe73eeef086faf$export$3f2efd37e8996007));
    // Franking credits are tax the company already paid on this income, so they come off before any
    // offset is considered. This can go negative — a refund.
    const incomeTaxBeforeOffsets = grossTax - taxable.frankingCredits;
    const saptoEligible = personAge != null && personAge >= (0, $1abe73eeef086faf$export$5b6998cba7880742) && saptoBand;
    // Rebate income is properly taxable income plus certain add-backs; taxable income stands in for it.
    const rebateIncomeProxy = totalTaxable;
    const saptoRaw = saptoEligible ? $231c5fe5568c4f9c$export$49dbe3118fe8ca9e(rebateIncomeProxy, saptoBand, (0, $1abe73eeef086faf$export$c2f6cffbd7c53bc0)) : 0;
    // Non-refundable: each offset is capped at the tax still standing, and SAPTO is applied first.
    const saptoUsed = Math.min(saptoRaw, Math.max(0, incomeTaxBeforeOffsets));
    const afterSapto = incomeTaxBeforeOffsets - saptoUsed;
    const litoRaw = $231c5fe5568c4f9c$export$22af65338fcd05cf(totalTaxable, lito);
    const litoUsed = Math.min(litoRaw, Math.max(0, afterSapto));
    // Offsets particular income earns (the 10% on an untaxed-source defined benefit pension): also
    // non-refundable, taken last against whatever still stands.
    const incomeOffsetsRaw = taxable.taxOffsets ?? 0;
    const incomeOffsetsUsed = Math.min(incomeOffsetsRaw, Math.max(0, afterSapto - litoUsed));
    // The levy and the surcharge are added AFTER the offsets, which is why they survive them.
    const netTax = afterSapto - litoUsed - incomeOffsetsUsed + medicare + surcharge;
    const breakdown = [
        {
            label: `--- ${personName}'s Tax ---`,
            value: ''
        },
        {
            label: 'Salary Income',
            value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(taxable.salary)
        },
        {
            label: 'Assessable Investment Income',
            value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(totalInvestmentIncome)
        }
    ];
    taxable.investmentSources.forEach((source)=>{
        breakdown.push({
            label: `  - ${source.name}`,
            value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(source.amount)
        });
    });
    breakdown.push({
        label: 'Less: Deductions',
        value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(-totalDeductions)
    });
    taxable.deductionSources.forEach((deduction)=>{
        breakdown.push({
            label: `  - ${deduction.name}`,
            value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(-deduction.amount)
        });
    });
    breakdown.push({
        label: 'Total Taxable Income',
        value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(totalTaxable)
    }, {
        label: `Marginal Tax Rate`,
        value: `${$231c5fe5568c4f9c$export$9ecf5542cff0e246(totalTaxable, rates.taxBrackets) * 100}%`
    }, {
        label: 'Gross Tax Payable',
        value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(grossTax)
    }, {
        label: 'Medicare Levy',
        value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(medicare)
    });
    if (surcharge > 0) breakdown.push({
        label: 'Medicare Levy Surcharge (no private hospital cover)',
        value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(surcharge)
    });
    breakdown.push({
        label: 'Less: Franking Credits',
        value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(-taxable.frankingCredits)
    });
    if (saptoUsed > 0) breakdown.push({
        label: 'Less: SAPTO (Seniors & Pensioners)',
        value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(-saptoUsed)
    });
    if (litoUsed > 0) breakdown.push({
        label: 'Less: Low Income Tax Offset (LITO)',
        value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(-litoUsed)
    });
    if (incomeOffsetsUsed > 0) breakdown.push({
        label: 'Less: Defined benefit pension offset (10%, untaxed source)',
        value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(-incomeOffsetsUsed)
    });
    breakdown.push({
        label: 'Net Tax Payable',
        value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(netTax)
    });
    return {
        breakdown: breakdown,
        netTax: netTax,
        totalTaxable: totalTaxable
    };
}
const $231c5fe5568c4f9c$export$f866a82f070179fc = (input)=>{
    const { rates: rates, clientTaxable: clientTaxable, partnerTaxable: partnerTaxable, isPartnered: isPartnered, illnessSeparated: illnessSeparated, relationshipStatus: relationshipStatus, client: client, partner: partner, clientAge: clientAge, partnerAge: partnerAge } = input;
    const taxOffsets = rates.taxOffsets || $231c5fe5568c4f9c$export$1cdbf71a09396579();
    const saptoBandForPerson = !isPartnered ? taxOffsets.sapto.single : illnessSeparated ? taxOffsets.sapto.illnessSeparatedMember : taxOffsets.sapto.coupleMember;
    const clientTotalTaxable = $231c5fe5568c4f9c$export$e0a51b6acb20dacf(clientTaxable);
    const partnerTotalTaxable = isPartnered ? $231c5fe5568c4f9c$export$e0a51b6acb20dacf(partnerTaxable) : 0;
    const familyTaxableIncome = clientTotalTaxable + partnerTotalTaxable;
    const familyMlsIncome = $231c5fe5568c4f9c$export$5a709ffc9109087e(clientTaxable) + (isPartnered ? $231c5fe5568c4f9c$export$5a709ffc9109087e(partnerTaxable) : 0);
    const clientTax = $231c5fe5568c4f9c$var$taxOnePerson(client.firstName || 'Client', clientTaxable, client.phi, relationshipStatus, familyTaxableIncome, familyMlsIncome, clientAge, saptoBandForPerson, rates, taxOffsets.lito);
    const partnerTax = isPartnered ? $231c5fe5568c4f9c$var$taxOnePerson(partner.firstName || 'Partner', partnerTaxable, partner.phi, relationshipStatus, familyTaxableIncome, familyMlsIncome, partnerAge, saptoBandForPerson, rates, taxOffsets.lito) : $231c5fe5568c4f9c$var$NO_TAX;
    return {
        client: clientTax,
        partner: partnerTax,
        totalTax: clientTax.netTax + partnerTax.netTax,
        taxBreakdown: [
            ...clientTax.breakdown,
            ...partnerTax.breakdown
        ],
        familyTaxableIncome: familyTaxableIncome
    };
};



const $1fbcfc2df3ed29e9$export$b19d6e0d06506959 = 0.45;
const $1fbcfc2df3ed29e9$export$5188da13a3c4d98a = 6;
function $1fbcfc2df3ed29e9$export$4c49a6418cae2f44(asset, disposalDate, valuationDate = new Date()) {
    if (!asset?.formerHome) return null;
    const raw = String(asset.firstRentedOn || '');
    if (!/^\d{4}-\d{2}$/.test(raw)) return null;
    const firstRentedOn = new Date(raw + '-01T00:00:00');
    if (!Number.isFinite(firstRentedOn.getTime())) return null;
    const yearsSinceFirstRented = Math.max(0, (0, $b9032eccb178cc91$export$e557acc6c40effbe)(firstRentedOn, disposalDate));
    const exempt = yearsSinceFirstRented <= $1fbcfc2df3ed29e9$export$5188da13a3c4d98a;
    const taxableFraction = exempt ? 0 : Math.max(0, Math.min(1, (yearsSinceFirstRented - $1fbcfc2df3ed29e9$export$5188da13a3c4d98a) / yearsSinceFirstRented));
    const value = Math.max(0, Number(asset.value) || 0);
    const growth = asset.growthRate != null && Number.isFinite(Number(asset.growthRate)) ? Number(asset.growthRate) : (0, $2cee3e5f0555e7bc$export$2a98a0810772f8e0);
    const yearsToToday = Math.max(0, (0, $b9032eccb178cc91$export$e557acc6c40effbe)(firstRentedOn, valuationDate));
    const costBaseReset = value / Math.pow(1 + growth / 100, yearsToToday);
    return {
        firstRentedOn: firstRentedOn,
        yearsSinceFirstRented: yearsSinceFirstRented,
        exempt: exempt,
        taxableFraction: taxableFraction,
        costBaseReset: costBaseReset
    };
}
function $1fbcfc2df3ed29e9$export$ccfe146b55a752dd(clientIncome, partnerIncome, isPartnered) {
    return {
        rates: {
            taxBrackets: (0, $231c5fe5568c4f9c$export$3873f5b68a2e0751),
            medicareLevyThresholds: (0, $1abe73eeef086faf$export$ae133c7b255163d3),
            taxOffsets: (0, $231c5fe5568c4f9c$export$1cdbf71a09396579)()
        },
        relationshipStatus: isPartnered ? 'couple' : 'single',
        isPartnered: isPartnered,
        illnessSeparated: false,
        receivesIncomeSupport: false,
        client: {
            taxableIncome: clientIncome || 0,
            frankingCredits: 0,
            age: null,
            hasPhi: false
        },
        partner: {
            taxableIncome: partnerIncome || 0,
            frankingCredits: 0,
            age: null,
            hasPhi: false
        }
    };
}
/** A person's stored figures as the `PersonTaxPosition` the income-tax assessor takes. */ function $1fbcfc2df3ed29e9$var$taxPositionOf(person, extraTaxableIncome) {
    return {
        salary: person.taxableIncome + extraTaxableIncome,
        investmentSources: [],
        frankingCredits: person.frankingCredits,
        deductionSources: []
    };
}
/**
 * The extra tax this person pays if `extraTaxableIncome` is added to their income — brackets, Medicare
 * levy (including the couple family thresholds) and the SAPTO/LITO taper all included, because the
 * household is re-assessed both ways by `incomeTax.ts`'s own assessor. Nothing here re-implements a
 * tax rule: the gain is taxed by the same code that taxes every other dollar in the product.
 */ function $1fbcfc2df3ed29e9$var$taxOnExtraIncome(owner, extraTaxableIncome, ctx) {
    if (!(extraTaxableIncome > 0)) return 0;
    const assess = (extraClient, extraPartner)=>(0, $231c5fe5568c4f9c$export$f866a82f070179fc)({
            rates: ctx.rates,
            clientTaxable: $1fbcfc2df3ed29e9$var$taxPositionOf(ctx.client, extraClient),
            partnerTaxable: $1fbcfc2df3ed29e9$var$taxPositionOf(ctx.partner, extraPartner),
            isPartnered: ctx.isPartnered,
            illnessSeparated: ctx.illnessSeparated,
            relationshipStatus: ctx.relationshipStatus,
            client: {
                phi: ctx.client.hasPhi
            },
            partner: {
                phi: ctx.partner.hasPhi
            },
            clientAge: ctx.client.age,
            partnerAge: ctx.partner.age
        })[owner].netTax;
    const before = assess(0, 0);
    const after = assess(owner === 'client' ? extraTaxableIncome : 0, owner === 'partner' ? extraTaxableIncome : 0);
    // Clamped at 0: a gain can never reduce tax, and franking-credit refunds must not net off here —
    // the refund is already reported in the year's cashflow.
    return Math.max(0, after - before);
}
/**
 * One person's CGT on their share, including the reform's 30% floor on the real (post-commencement)
 * portion. The differential calculation yields a single figure for the whole share, so the pre- and
 * post-commencement portions are attributed pro-rata by assessable amount before the floor is applied
 * to the post portion only.
 */ function $1fbcfc2df3ed29e9$var$personCgt(owner, preShare, postShare, ctx) {
    const assessableGainShare = preShare + postShare;
    if (!(assessableGainShare > 0)) return {
        owner: owner,
        assessableGainShare: 0,
        cgt: 0,
        effectiveRate: 0,
        minimumTaxUplift: 0
    };
    const marginalTax = $1fbcfc2df3ed29e9$var$taxOnExtraIncome(owner, assessableGainShare, ctx);
    const postPortionOfTax = marginalTax * (postShare / assessableGainShare);
    const prePortionOfTax = marginalTax - postPortionOfTax;
    const postAfterFloor = (0, $b9032eccb178cc91$export$55eec17788642ecf)({
        postCommencementTaxable: postShare,
        marginalTaxOnPost: postPortionOfTax,
        isIncomeSupportRecipient: ctx.receivesIncomeSupport
    });
    const cgt = prePortionOfTax + postAfterFloor;
    return {
        owner: owner,
        assessableGainShare: assessableGainShare,
        cgt: cgt,
        effectiveRate: cgt / assessableGainShare,
        minimumTaxUplift: Math.max(0, postAfterFloor - postPortionOfTax)
    };
}
/** Split an assessable gain across the applicants according to the asset's ownership. */ function $1fbcfc2df3ed29e9$var$splitByOwnership(ownership, isPartnered) {
    if (!isPartnered) return {
        client: 1,
        partner: 0
    };
    if (ownership === 'partner') return {
        client: 0,
        partner: 1
    };
    if (ownership === 'joint') return {
        client: 0.5,
        partner: 0.5
    };
    // 'client' and anything unrecognised. Note the old taxAndLoanUtils.calculateCgt returned ZERO CGT
    // for an unrecognised ownership (including entity-owned assets), silently under-taxing the sale.
    return {
        client: 1,
        partner: 0
    };
}
function $1fbcfc2df3ed29e9$export$c06c916a0ca433d3(input) {
    const { taxContext: ctx, asset: asset, salePrice: salePrice = 0, sellingCosts: sellingCosts = 0, originalAssetValue: originalAssetValue, costBaseOverride: costBaseOverride, disposalDate: disposalDate = new Date(), cpiRate: cpiRate = (0, $9d417e6055be1d2a$export$4e9d9ceebe11543e).defaultCpiRate, structures: structures, trustDisposal: trustDisposal, valuationDate: valuationDate = new Date() } = input;
    const netSaleProceeds = salePrice - sellingCosts;
    // A former home rented out: the main-residence absence rule (see formerHomeAbsence).
    const absence = $1fbcfc2df3ed29e9$export$4c49a6418cae2f44(asset, disposalDate, valuationDate);
    const ownership = asset?.ownership;
    const entityId = (0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(ownership) ? (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(ownership) : null;
    const structure = entityId ? (structures || []).find((s)=>s.id === entityId) : null;
    const structureName = structure?.name?.trim() || null;
    // Who bears the tax. Resolved up front so that a pre-CGT / zero-gain disposal still reports the
    // structure it WOULD have been taxed through (panels key their explanatory copy off this).
    const structureType = structure?.type || (entityId ? 'family_trust' : null);
    const taxMethod = !entityId ? 'personal_marginal' : structureType === 'private_company' ? 'company_rate' : structureType === 'partnership' ? 'partnership_apportioned' : trustDisposal === 'retain' ? 'trust_retain' : 'trust_distribute';
    const isPreCGT = (0, $b9032eccb178cc91$export$321afe5948362992)(asset) || !!absence?.exempt;
    const baseResult = {
        salePrice: salePrice,
        sellingCosts: sellingCosts,
        isPreCGT: isPreCGT,
        perPerson: [],
        clientEstimatedCgt: null,
        partnerEstimatedCgt: null,
        clientAssessableGainShare: null,
        partnerAssessableGainShare: null,
        clientMarginalRate: null,
        partnerMarginalRate: null,
        apportionmentClientPct: null,
        apportionmentPartnerPct: null,
        structureName: structureName
    };
    // --- Cost base (apportioned when only part of the holding is sold) ---
    const valueForCostBase = originalAssetValue != null && originalAssetValue > 0 ? originalAssetValue : salePrice;
    const explicitCostBase = costBaseOverride != null && costBaseOverride > 0 ? costBaseOverride : null;
    const totalCostBase = isPreCGT ? 0 : absence ? absence.costBaseReset : explicitCostBase ?? (0, $b9032eccb178cc91$export$57d0fb9544f11f95)({
        costBase: asset?.costBase,
        value: valueForCostBase
    }).costBase;
    const proportionalCostBase = originalAssetValue != null && originalAssetValue > 0 && salePrice < originalAssetValue ? totalCostBase * (salePrice / originalAssetValue) : totalCostBase;
    if (isPreCGT || !(salePrice > 0)) return {
        ...baseResult,
        costBase: proportionalCostBase,
        capitalGain: 0,
        assessableCapitalGain: 0,
        estimatedCGT: 0,
        netProceeds: netSaleProceeds,
        taxMethod: taxMethod,
        entityDisposalWarning: null,
        acquisitionDateAssumed: false,
        disposalPhase: 'old'
    };
    // Selling costs reduce the gain (they form part of the cost base for CGT purposes).
    const capitalGain = Math.max(0, netSaleProceeds - proportionalCostBase);
    // --- Assessable gain under the applicable regime ---
    // A recorded acquisition date drives BOTH the 12-month 50% discount test and the 1-Jul-2027 split.
    // Where it is absent we fall back to a long-held asset, which grants the discount — so an asset
    // actually bought within the last year would be under-taxed. That is why the absence is reported
    // (see `acquisitionDateAssumed`) and prompted for in the fact-find rather than silently absorbed.
    const recordedAcquisition = absence ? absence.firstRentedOn : (0, $b9032eccb178cc91$export$a8d693a210faf7c)(asset);
    const gain = (0, $b9032eccb178cc91$export$9003ec1a931d0da5)({
        costBase: proportionalCostBase,
        proceeds: netSaleProceeds,
        acquisitionDate: recordedAcquisition ?? (0, $b9032eccb178cc91$export$8e8046f1601fbb03),
        disposalDate: disposalDate,
        cpiRate: cpiRate,
        config: (0, $9d417e6055be1d2a$export$4e9d9ceebe11543e)
    });
    // A former home sold after six years away: only the time beyond six years is taxed.
    const assessableCapitalGain = absence ? gain.totalTaxable * absence.taxableFraction : gain.totalTaxable;
    // Only worth raising where it can actually change the answer: there has to be a gain to tax.
    const dateAssumptionMatters = !recordedAcquisition && assessableCapitalGain > 0;
    const acquisitionWarning = dateAssumptionMatters ? 'No acquisition date is recorded for this asset, so it is assumed to have been held for more than 12 months (which allows the 50% CGT discount) and to have been acquired before the 1 July 2027 CGT changes. If it was bought within the last 12 months the CGT would be higher. Record the month acquired, or override the CGT estimate.' : null;
    const finish = (fields)=>{
        const clientDetail = fields.perPerson?.find((p)=>p.owner === 'client') || null;
        const partnerDetail = fields.perPerson?.find((p)=>p.owner === 'partner') || null;
        return {
            ...baseResult,
            costBase: proportionalCostBase,
            capitalGain: capitalGain,
            assessableCapitalGain: fields.assessableCapitalGain,
            estimatedCGT: fields.estimatedCGT,
            netProceeds: netSaleProceeds - fields.estimatedCGT,
            taxMethod: fields.taxMethod,
            entityDisposalWarning: fields.warning || acquisitionWarning,
            acquisitionDateAssumed: dateAssumptionMatters,
            disposalPhase: gain.phase,
            perPerson: fields.perPerson || [],
            clientEstimatedCgt: clientDetail ? clientDetail.cgt : null,
            partnerEstimatedCgt: partnerDetail ? partnerDetail.cgt : null,
            clientAssessableGainShare: clientDetail ? clientDetail.assessableGainShare : null,
            partnerAssessableGainShare: partnerDetail ? partnerDetail.assessableGainShare : null,
            clientMarginalRate: clientDetail ? clientDetail.effectiveRate : null,
            partnerMarginalRate: partnerDetail ? partnerDetail.effectiveRate : null,
            apportionmentClientPct: fields.apportionmentClientPct ?? null,
            apportionmentPartnerPct: fields.apportionmentPartnerPct ?? null
        };
    };
    if (assessableCapitalGain <= 0) return finish({
        assessableCapitalGain: 0,
        estimatedCGT: 0,
        taxMethod: taxMethod,
        warning: null
    });
    // --- Entity structures that tax the gain in the entity, not in the applicants' hands ---
    if (taxMethod === 'company_rate') // No CGT discount for companies — the whole nominal gain is taxed at the company rate.
    return finish({
        assessableCapitalGain: capitalGain,
        estimatedCGT: capitalGain * (0, $1abe73eeef086faf$export$641e54d6b906f309),
        taxMethod: taxMethod,
        warning: "Gain taxed in the company. Cash remains in the company until distributed \u2014 confirm dividends and franking with your accountant."
    });
    if (taxMethod === 'trust_retain') return finish({
        assessableCapitalGain: capitalGain,
        estimatedCGT: capitalGain * $1fbcfc2df3ed29e9$export$b19d6e0d06506959,
        taxMethod: taxMethod,
        warning: "Gain retained in trust \u2014 top trust rate applied. Confirm with your accountant."
    });
    // --- Taxed in the applicants' hands ---
    // Entity (distributing trust / partnership): split by the structure's apportionment percentages.
    // Personally held: split by the asset's ownership.
    let clientFraction;
    let partnerFraction;
    let apportionmentClientPct = null;
    let apportionmentPartnerPct = null;
    if (entityId) {
        const clientPct = Math.min(100, Math.max(0, structure?.apportionmentClient || 0));
        const partnerPct = ctx.isPartnered ? Math.min(100, Math.max(0, structure?.apportionmentPartner || 0)) : 0;
        const combined = (0, $1773fcf9595c5c0a$export$b93377b4473f408b)(structure, ctx.isPartnered) || 100;
        clientFraction = clientPct / combined;
        partnerFraction = partnerPct / combined;
        apportionmentClientPct = clientPct;
        apportionmentPartnerPct = partnerPct;
    } else {
        const split = $1fbcfc2df3ed29e9$var$splitByOwnership(ownership, ctx.isPartnered);
        clientFraction = split.client;
        partnerFraction = split.partner;
    }
    const perPerson = [];
    if (clientFraction > 0) perPerson.push($1fbcfc2df3ed29e9$var$personCgt('client', gain.preCommencementTaxable * clientFraction, gain.postCommencementTaxable * clientFraction, ctx));
    if (partnerFraction > 0) perPerson.push($1fbcfc2df3ed29e9$var$personCgt('partner', gain.preCommencementTaxable * partnerFraction, gain.postCommencementTaxable * partnerFraction, ctx));
    return finish({
        assessableCapitalGain: assessableCapitalGain,
        estimatedCGT: perPerson.reduce((sum, p)=>sum + p.cgt, 0),
        taxMethod: taxMethod,
        warning: null,
        perPerson: perPerson,
        apportionmentClientPct: apportionmentClientPct,
        apportionmentPartnerPct: apportionmentPartnerPct
    });
}


/**
 * Resolves the household tax context that `disposalCgt.computeDisposalCgt` needs.
 *
 * Kept separate from `disposalCgt.ts` so THAT module stays pure (no dependency on
 * `calculateFinancials`) and can be unit-tested and called from inside a projection year without
 * recomputing the household position.
 *
 * Note: this module and `financialCalculations.ts` sit in the same pre-existing, safe import cycle as
 * `entityDisposalTax.ts` — references are function-body-only, never evaluated at module load.
 */ 

function $77244093e528572f$export$ccd3cb45b428c7dc(factFind, financials) {
    if (financials?.taxContext) return financials.taxContext;
    if (factFind) {
        const computed = (0, $db6ce683330fb15a$export$463f0620dd36e1f8)(factFind);
        if (computed?.taxContext) return computed.taxContext;
    }
    return (0, $1fbcfc2df3ed29e9$export$ccfe146b55a752dd)(financials?.clientAssessableIncome || 0, financials?.partnerAssessableIncome || 0, factFind?.adviceFor === 'couple');
}



function $a764bc0f6f904854$export$2778f99280b2ce68(raw) {
    if (raw === null || raw === undefined || raw === '') return null;
    const n = parseFloat(String(raw));
    return Number.isFinite(n) && n >= 0 ? n : null;
}
function $a764bc0f6f904854$export$1436ab50c5990307(taxSummary, overrideTotal) {
    if (!taxSummary) return {
        calculatedCGT: 0,
        estimatedCGT: 0,
        effectiveCGT: 0,
        isOverridden: false,
        netProceeds: 0
    };
    const calculatedCGT = taxSummary.estimatedCGT ?? 0;
    const override = $a764bc0f6f904854$export$2778f99280b2ce68(overrideTotal);
    const isOverridden = override != null;
    const effectiveCGT = isOverridden ? override : calculatedCGT;
    const salePrice = taxSummary.salePrice ?? 0;
    const sellingCosts = taxSummary.sellingCosts ?? 0;
    return {
        ...taxSummary,
        calculatedCGT: calculatedCGT,
        estimatedCGT: effectiveCGT,
        effectiveCGT: effectiveCGT,
        isOverridden: isOverridden,
        netProceeds: salePrice - sellingCosts - effectiveCGT
    };
}
function $a764bc0f6f904854$export$6efa70c7a551111e(factFind, radFunding = {}, cgtOverrides = {}) {
    if (!radFunding) return 0;
    let total = 0;
    Object.entries(radFunding).forEach(([assetKey, saleAmountRaw])=>{
        const parsed = (0, $85f2560fc9a239a0$export$eb5d467aa7d657c6)(assetKey);
        if (!parsed || parsed.assetType !== 'shares') return;
        const saleAmount = parseFloat(String(saleAmountRaw)) || 0;
        if (saleAmount <= 0) return;
        const located = (0, $85f2560fc9a239a0$export$f59ccf8b394d8480)({
            assets: factFind?.assets
        }, parsed.assetType, parsed.assetId);
        if (!located?.asset?.costBase) return;
        const taxResult = $a764bc0f6f904854$export$bb01b201c6492ed7(factFind, located.asset, saleAmount, {
            trustDisposal: 'distribute'
        });
        const effective = $a764bc0f6f904854$export$1436ab50c5990307(taxResult, cgtOverrides[assetKey]);
        total += effective.effectiveCGT || 0;
    });
    return total;
}
function $a764bc0f6f904854$export$f689812f949e0dfa(costBaseText) {
    return {
        costBase: parseFloat(String(costBaseText ?? '').trim()) || 0
    };
}
function $a764bc0f6f904854$var$runDisposal(factFind, asset, params) {
    const { costBase: parsedCostBase } = $a764bc0f6f904854$export$f689812f949e0dfa(params.costBaseText ?? '');
    return (0, $1fbcfc2df3ed29e9$export$c06c916a0ca433d3)({
        taxContext: (0, $77244093e528572f$export$ccd3cb45b428c7dc)(factFind, params.financials),
        asset: asset,
        salePrice: params.salePrice,
        sellingCosts: params.sellingCosts,
        originalAssetValue: params.originalAssetValue,
        costBaseOverride: parsedCostBase > 0 ? parsedCostBase : null,
        disposalDate: params.disposalDate,
        cpiRate: params.cpiRate,
        structures: factFind?.structures,
        trustDisposal: params.trustDisposal
    });
}
function $a764bc0f6f904854$export$f70460bedec8e810(factFind, asset, details = {}) {
    const salePrice = details.salePrice || asset?.value || 0;
    const sellingCosts = details.sellingCosts || salePrice * 0.025;
    return $a764bc0f6f904854$var$runDisposal(factFind, asset, {
        salePrice: salePrice,
        sellingCosts: sellingCosts,
        costBaseText: details.costBase ?? asset?.costBase ?? '',
        trustDisposal: details.trustDisposal,
        disposalDate: details.disposalDate,
        cpiRate: details.cpiRate,
        financials: details.financials
    });
}
function $a764bc0f6f904854$export$bb01b201c6492ed7(factFind, asset, saleAmount, details = {}) {
    const salePrice = saleAmount || 0;
    const currentValue = asset?.value || 0;
    // `originalValue` is the holding's value BEFORE this sale — it is what the cost base gets apportioned
    // against. It defaults to the asset's CURRENT value because every caller passes an asset that has not
    // yet been reduced by the sale (the reduction happens afterwards, e.g. assetLiquidation.ts mutates a
    // clone). `details.originalValue` remains available for any caller that DOES pre-reduce the asset.
    //
    // This previously defaulted to `currentValue + salePrice`, which assumed the asset had already been
    // decremented. No caller does, so the pre-sale value was overstated — for a full sale it doubled, which
    // apportioned only half the cost base to the sale and inflated the gain (a $200k holding with a $150k
    // cost base showed a $125k gain instead of $50k). Note it only ever affected assets with an ENTERED
    // cost base: where none is recorded the 25%-of-value assumption is itself proportional to the value, so
    // the two errors cancelled exactly.
    const originalValue = details.originalValue != null ? details.originalValue || 0 : currentValue;
    return $a764bc0f6f904854$var$runDisposal(factFind, asset, {
        salePrice: salePrice,
        // Brokerage on a share sale is immaterial at this level of estimate.
        sellingCosts: 0,
        costBaseText: asset?.costBase ?? '',
        originalAssetValue: originalValue,
        trustDisposal: details.trustDisposal,
        disposalDate: details.disposalDate,
        cpiRate: details.cpiRate,
        financials: details.financials
    });
}
function $a764bc0f6f904854$export$7d1a41f6cfaa2776() {
    return {
        extraCashflowItems: []
    };
}
function $a764bc0f6f904854$export$777cdddf3f231419(factFind, investmentPropertyDetails) {
    if (!investmentPropertyDetails || !factFind?.assets?.investmentProperty?.length) return null;
    const selectedPropertyId = investmentPropertyDetails.selectedPropertyId;
    const investmentProperty = factFind.assets.investmentProperty.find((p)=>p.id === selectedPropertyId) || factFind.assets.investmentProperty[0];
    if (!investmentProperty) return null;
    const result = $a764bc0f6f904854$export$f70460bedec8e810(factFind, investmentProperty, investmentPropertyDetails);
    const effective = $a764bc0f6f904854$export$1436ab50c5990307(result, investmentPropertyDetails?.cgtOverrideTotal);
    if ((0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(investmentProperty.ownership) && effective.entityDisposalWarning) effective.warning = effective.entityDisposalWarning;
    else if ((0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(investmentProperty.ownership) && !effective.entityDisposalWarning && effective.taxMethod !== 'personal_marginal') effective.warning = null;
    return effective;
}


function $85f2560fc9a239a0$export$4d0dc62775eae74e(left, right) {
    if (left == null || right == null) return false;
    return String(left) === String(right);
}
function $85f2560fc9a239a0$var$findAssetIndexById(assetList, assetId) {
    if (!Array.isArray(assetList)) return -1;
    return assetList.findIndex((a)=>$85f2560fc9a239a0$export$4d0dc62775eae74e(a.id, assetId));
}
function $85f2560fc9a239a0$export$f59ccf8b394d8480(factFind, assetType, assetId) {
    const list = factFind?.assets?.[assetType];
    const index = $85f2560fc9a239a0$var$findAssetIndexById(list, assetId);
    if (index < 0) return null;
    return {
        asset: list?.[index],
        index: index
    };
}
function $85f2560fc9a239a0$export$eb5d467aa7d657c6(key) {
    if (!key || typeof key !== 'string') return null;
    const dash = key.indexOf('-');
    if (dash <= 0) return null;
    const assetType = key.slice(0, dash);
    const assetId = key.slice(dash + 1);
    if (!assetType || !assetId) return null;
    return {
        assetType: assetType,
        assetId: assetId
    };
}
function $85f2560fc9a239a0$export$351785600ef65fdf(factFind, assetKey, grossAmount, cgtOverrides = {}) {
    const gross = Math.max(0, grossAmount || 0);
    if (gross <= 0) return {
        gross: 0,
        cgt: 0,
        net: 0
    };
    const parsed = $85f2560fc9a239a0$export$eb5d467aa7d657c6(assetKey);
    if (!parsed || parsed.assetType !== 'shares') return {
        gross: gross,
        cgt: 0,
        net: gross
    };
    const located = $85f2560fc9a239a0$export$f59ccf8b394d8480(factFind, parsed.assetType, parsed.assetId);
    if (!located?.asset) return {
        gross: gross,
        cgt: 0,
        net: gross
    };
    // NB: a missing cost base no longer means $0 CGT — calculateSharePartialDisposalTax applies the
    // shared 25%-of-value assumed cost base (resolveCostBase), disclosed in-app and in the SOA.
    const taxResult = (0, $a764bc0f6f904854$export$bb01b201c6492ed7)(factFind, located.asset, gross, {
        trustDisposal: 'distribute'
    });
    const override = (0, $a764bc0f6f904854$export$2778f99280b2ce68)(cgtOverrides[assetKey]);
    const cgt = override != null ? override : taxResult.estimatedCGT ?? 0;
    return {
        gross: gross,
        cgt: cgt,
        net: Math.max(0, gross - cgt)
    };
}
function $85f2560fc9a239a0$export$e98193fa2b9f521b(factFind, radFunding = {}, cgtOverrides = {}) {
    let grossTotal = 0;
    let netTotal = 0;
    let shareCgtTotal = 0;
    const byKey = {};
    Object.entries(radFunding || {}).forEach(([key, amount])=>{
        const entry = $85f2560fc9a239a0$export$351785600ef65fdf(factFind, key, amount, cgtOverrides);
        byKey[key] = entry;
        grossTotal += entry.gross;
        netTotal += entry.net;
        shareCgtTotal += entry.cgt;
    });
    return {
        grossTotal: grossTotal,
        netTotal: netTotal,
        shareCgtTotal: shareCgtTotal,
        byKey: byKey
    };
}
/** First personal/joint bank account (excludes entity-owned rows). */ function $85f2560fc9a239a0$var$findPersonalBankAccount(assets) {
    const list = assets?.bankAccounts;
    if (!Array.isArray(list) || list.length === 0) return null;
    return list.find((a)=>!(0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(a?.ownership)) || list[0];
}
function $85f2560fc9a239a0$export$ade9707014c4664e(assets, cgtAmount, ownership) {
    const cgt = Math.max(0, cgtAmount || 0);
    if (cgt <= 0 || !assets?.bankAccounts?.length) return;
    if ((0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(ownership)) {
        const entityId = (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(ownership);
        const entityOwn = (0, $1773fcf9595c5c0a$export$66d936c41d42a933)(entityId);
        const entityBank = assets.bankAccounts.find((a)=>a.ownership === entityOwn) || null;
        if (entityBank) {
            entityBank.value = Math.max(0, (entityBank.value || 0) - cgt);
            return;
        }
    }
    const personalBank = $85f2560fc9a239a0$var$findPersonalBankAccount(assets);
    if (personalBank) personalBank.value = Math.max(0, (personalBank.value || 0) - cgt);
}
function $85f2560fc9a239a0$export$e820d52c8da26912(assets, amount) {
    const debit = Math.max(0, amount || 0);
    if (debit <= 0 || !assets?.bankAccounts?.length) return;
    const personalBank = $85f2560fc9a239a0$var$findPersonalBankAccount(assets);
    if (!personalBank) return;
    personalBank.value = Math.max(0, (personalBank.value || 0) - debit);
}


/**
 * Account-based pension (ABP) projection helpers — minimum drawdown vs client nomination,
 * and marking pensions partially liquidated to fund acquisitions (RAD, village entry, etc.).
 * Ported verbatim from frontend/src/calculations/abpProjectionUtils.js.
 *
 * `markAbpFundedAcquisitionAfterLiquidation` is also duplicated (unchanged) into
 * frontend/src/strategy/StrategyIntegrationUtils.js's frontend copy — see the calculation-engine
 * migration plan for why (strategy/ stays client-side but calls this function).
 */ 
/**
 * Date helper utilities — single source for age calculation used across the engine.
 * Ported verbatim from frontend/src/utils/dateHelpers.js.
 */ /**
 * A `YYYY-MM-DD` strategy input as a LOCAL date, or null when absent or malformed.
 *
 * Built from the components rather than `new Date(iso)`, which parses a bare date string as UTC and so
 * lands on the previous day for anyone east of Greenwich — every Australian user. These dates are
 * compared against each other and printed into advice documents, so a silent one-day shift would put
 * an asset sale on the wrong side of an entry date.
 */ function $876c355975468a36$export$489a569037cfef1b(raw) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(raw ?? ''));
    return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])) : null;
}
function $876c355975468a36$export$322b36d80aef60ca(date) {
    return date.toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });
}
function $876c355975468a36$export$8ada184d5eef4694(dob, refDate = new Date()) {
    if (!dob) return null;
    const birthDate = new Date(dob);
    const referenceDate = new Date(refDate);
    let age = referenceDate.getFullYear() - birthDate.getFullYear();
    const monthDiff = referenceDate.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || monthDiff === 0 && referenceDate.getDate() < birthDate.getDate()) age--;
    return age;
}


function $e0f54937e270d5ff$export$a7b4a1ff258d7449(ownerAge) {
    if (ownerAge == null || ownerAge === '') return 0;
    const bracket = (0, $1abe73eeef086faf$export$89d00d368c27d070).find((b)=>ownerAge <= b.age);
    return bracket ? bracket.rate : 0.14;
}
function $e0f54937e270d5ff$export$548fd6b682208d71(balance, ownerAge) {
    return (balance || 0) * $e0f54937e270d5ff$export$a7b4a1ff258d7449(ownerAge);
}
function $e0f54937e270d5ff$export$b659e4d91c30570a(asset, factFind, yearIndex = 1) {
    // A partner-owned pension is assessed on the partner, unless the fact-find knows nothing about
    // them at all, in which case it falls back to the client — as it always has.
    const partner = factFind?.partner;
    const owner = asset.ownership === 'partner' && (partner?.__age != null || partner?.dob) ? partner : factFind?.client;
    if (owner?.__age != null) return owner.__age;
    if (owner?.dob) return (0, $876c355975468a36$export$8ada184d5eef4694)(owner.dob) + (Math.max(1, yearIndex) - 1);
    return null;
}
function $e0f54937e270d5ff$export$399e556d15149d82(asset, factFind, yearIndex = 1) {
    asset.__abpFundedAcquisition = true;
    const ownerAge = $e0f54937e270d5ff$export$b659e4d91c30570a(asset, factFind, yearIndex);
    const bal = asset.value ?? 0;
    const minAnnual = $e0f54937e270d5ff$export$548fd6b682208d71(bal, ownerAge);
    asset.income = bal > 0 ? minAnnual : 0;
}
function $e0f54937e270d5ff$export$1df4c9adff17d812(asset) {
    if (asset.__abpFundedAcquisition === true) return;
    if (asset.__abpProjectionNominatedAnnual == null) asset.__abpProjectionNominatedAnnual = asset.income ?? 0;
}
function $e0f54937e270d5ff$export$99098e979a7d958e(asset) {
    if (asset.__abpProjectionNominatedAnnual != null) return asset.__abpProjectionNominatedAnnual;
    return asset.income ?? 0;
}
function $e0f54937e270d5ff$export$a6df0512b6a05b11(factFind) {
    (factFind.assets?.accountBasedPensions || []).forEach((asset)=>{
        $e0f54937e270d5ff$export$1df4c9adff17d812(asset);
    });
}
function $e0f54937e270d5ff$export$c51a624cb79b7039(asset, ownerAge) {
    const bal = asset.value ?? 0;
    if (bal <= 0) {
        asset.income = 0;
        return;
    }
    if (asset.__abpFundedAcquisition === true) {
        asset.income = $e0f54937e270d5ff$export$548fd6b682208d71(bal, ownerAge);
        return;
    }
    const nom = $e0f54937e270d5ff$export$99098e979a7d958e(asset);
    const minAnnual = $e0f54937e270d5ff$export$548fd6b682208d71(bal, ownerAge);
    asset.income = Math.max(nom, minAnnual);
}
function $e0f54937e270d5ff$export$a9369956cfc0490b(factFind, yearIndex) {
    (factFind.assets?.accountBasedPensions || []).forEach((asset)=>{
        const ownerAge = $e0f54937e270d5ff$export$b659e4d91c30570a(asset, factFind, yearIndex);
        if (ownerAge == null) return;
        $e0f54937e270d5ff$export$c51a624cb79b7039(asset, ownerAge);
    });
}


/** Applies one liquidation to the fact-find being mutated, returning the GROSS taken and NET raised. */ function $b71b41b8944942d4$var$liquidateOne(originalFactFind, modifiedFactFind, assetType, assetId, // Deliberately `unknown`: `StrategyOptions.radFunding` is the one figure in that bag documented as
// reaching the engine inconsistently typed (the RAD slider's producers never agreed), so it is
// coerced here at the point of use rather than trusted to be a number.
amount, cgtOverrides) {
    // A liquidation naming no asset funds nothing. Checked before the lookup rather than left to it,
    // because the helper takes an id it can actually match on.
    if (assetId === undefined) return {
        gross: 0,
        net: 0
    };
    const located = (0, $85f2560fc9a239a0$export$f59ccf8b394d8480)(modifiedFactFind, assetType, assetId);
    if (!located) return {
        gross: 0,
        net: 0
    };
    // An asset cannot fund more than it holds. Without this an over-allocation — an adviser typing
    // 500,000 against a 120,000 account, or a saved strategy whose asset has since fallen in value —
    // drove that asset's balance NEGATIVE and credited the full amount to the deposit, inventing money
    // and then carrying the negative through every later year of the projection. Both former copies of
    // this function did it, identically, which is why holding them against each other never found it.
    //
    // Clamped BEFORE the amount is priced, so CGT is struck on the shares actually sold rather than on
    // the larger number that was asked for.
    const available = Math.max(0, Number(located.asset.value) || 0);
    const requested = Math.max(0, Number(amount) || 0);
    const fundable = Math.min(requested, available);
    if (fundable <= 0) return {
        gross: 0,
        net: 0
    };
    // Gross and net are resolved against the ORIGINAL fact-find, not the one being mutated: a second
    // liquidation of the same asset must be priced off what the client actually held, not off what an
    // earlier entry in the same pass has already taken out of it.
    const { gross: gross, net: net } = (0, $85f2560fc9a239a0$export$351785600ef65fdf)(originalFactFind, `${assetType}-${assetId}`, fundable, cgtOverrides);
    if (gross <= 0) return {
        gross: 0,
        net: 0
    };
    const asset = located.asset;
    // `__originalValue` is a sentinel the means test reads: `assessableMeans.ts` infers a pre-2015 ABP's
    // commutation from the gap between it and the current value when `strategyOptions.radFunding` does
    // not spell one out. Written before the FIRST subtraction and kept through any later ones (the
    // day-of-sale top-up can draw the same asset twice), and never cleared.
    if (asset.__originalValue === undefined) asset.__originalValue = asset.value;
    // `|| 0` rather than `parseFloat`, which returns NaN for an asset carrying no value and puts that
    // NaN into the balance sheet — from where it reaches net worth and assessable assets without ever
    // announcing itself. This is the one point the two former copies disagreed on.
    asset.value = (asset.value || 0) - gross;
    if (assetType === 'accountBasedPensions') (0, $e0f54937e270d5ff$export$399e556d15149d82)(asset, modifiedFactFind, 1);
    return {
        gross: gross,
        net: net
    };
}
/**
 * Liquidates the nominated assets to pay the RAD, returning a NEW fact-find — the caller's is never
 * touched. The proceeds become a single synthetic `radPaid` asset, which is how the rest of the engine
 * recognises that a deposit has been paid (see `radPlugin`, and `sumRadPaidAssets`).
 *
 * Accepts both funding shapes because both are in the wild: the suggestion engine stores the grouped
 * one, the manual RAD allocator the flat one. Which is in hand is detected rather than declared, since
 * a caller passing the wrong flag would be a silent no-op.
 *
 * `net` rather than gross is what lands in `radPaid`: selling an asset to fund a deposit has to fund
 * its own CGT first, so the deposit is what survives the tax. `cgtOverrides` lets an accountant's own
 * figure replace the estimate, per funding key.
 *
 * The `1` handed to `markAbpFundedAcquisitionAfterLiquidation` is the projection year the liquidation
 * happens in, and it is hardcoded because this runs before any projection — see the module note.
 */ /**
 * Sells the nominated assets IN PLACE, returning the net proceeds — the deposit-free half of
 * {@link applyRadFundingToFactFind}, which is this plus the `radPaid` row.
 *
 * Split out so the projection engine can do the two things on their own dates. Selling assets and
 * paying a deposit are one act only when they happen at the same instant, which is exactly what the
 * combined function assumes: a client who liquidates in October to move in in March holds cash for
 * five months, and that cash is deemed, means-tested and spendable in a way an already-paid deposit is
 * not. See `radPlugin`, which credits these proceeds to the bank on the sale date and pays the deposit
 * out of it on the care date.
 *
 * `pricedAgainst` is the fact-find CGT and net are struck against, defaulting to the one being
 * mutated. A caller holding an un-mutated original should pass it, so that several liquidations in one
 * pass are each priced off what the client actually held rather than off what an earlier entry left.
 */ /** The funding plan flattened to one shape, in plan order — both wire formats normalise to this. */ function $b71b41b8944942d4$var$normaliseFundingEntries(radFunding) {
    const entries = [];
    const isManualKeyFormat = Object.keys(radFunding).some((key)=>(0, $85f2560fc9a239a0$export$eb5d467aa7d657c6)(key));
    if (isManualKeyFormat) for (const [assetKey, amount] of Object.entries(radFunding)){
        const parsed = (0, $85f2560fc9a239a0$export$eb5d467aa7d657c6)(assetKey);
        if (!parsed) continue;
        // The manual-key shape carries a bare gross amount here, never the grouped object below.
        entries.push({
            assetType: parsed.assetType,
            assetId: parsed.assetId,
            amount: Math.max(0, Number(amount) || 0)
        });
    }
    else for (const [assetType, liquidations] of Object.entries(radFunding)){
        // A non-object entry is discarded rather than wrapped: wrapping a bare number yields a
        // liquidation with neither an id nor an amount, which finds no asset and funds nothing —
        // the same outcome, reached by pretending the input was well-formed.
        const liquidationList = Array.isArray(liquidations) ? liquidations : liquidations && typeof liquidations === 'object' ? [
            liquidations
        ] : [];
        for (const liquidation of liquidationList){
            if (liquidation?.id === undefined) continue;
            entries.push({
                assetType: assetType,
                assetId: liquidation.id,
                amount: Math.max(0, Number(liquidation.amount) || 0)
            });
        }
    }
    return entries;
}
function $b71b41b8944942d4$export$5857282f1a3caa15(factFind, radFunding, cgtOverrides = {}, pricedAgainst = factFind) {
    if (!radFunding) return {
        netProceeds: 0,
        grossRequested: 0,
        grossDrawn: 0,
        topUps: [],
        grossShortfall: 0
    };
    const entries = $b71b41b8944942d4$var$normaliseFundingEntries(radFunding);
    let netProceeds = 0;
    let grossDrawn = 0;
    const grossRequested = entries.reduce((sum, e)=>sum + e.amount, 0);
    for (const entry of entries){
        const drawn = $b71b41b8944942d4$var$liquidateOne(pricedAgainst, factFind, entry.assetType, entry.assetId, entry.amount, cgtOverrides);
        netProceeds += drawn.net;
        grossDrawn += drawn.gross;
    }
    // DAY-OF-SALE TOP-UP (adviser ruling, 2026-08-19). A funding plan is struck against the
    // balances of the day it is MADE, and a dated sale happens later — pension drawdowns and
    // market movement mean an asset can hold less on the day than the plan allocated ($116 on a
    // $480,000 deposit, in the case that surfaced this). Any adviser would take the difference
    // from the next nominated asset without a second thought, so the engine now does: the
    // remainder is drawn from the SAME assets the plan nominated, in plan order, from whatever
    // they still hold. Assets the plan marked KEPT are never touched — the plan names who funds
    // the deposit; drift only re-weights among them. What survives after that is a genuine
    // shortfall: the nominated assets themselves are exhausted, which is worth a loud sentence.
    const topUps = [];
    let remaining = grossRequested - grossDrawn;
    if (remaining > 0.5) for (const entry of entries){
        if (remaining <= 0.5) break;
        const drawn = $b71b41b8944942d4$var$liquidateOne(pricedAgainst, factFind, entry.assetType, entry.assetId, remaining, cgtOverrides);
        if (drawn.gross <= 0) continue;
        netProceeds += drawn.net;
        grossDrawn += drawn.gross;
        remaining -= drawn.gross;
        topUps.push({
            assetType: entry.assetType,
            assetId: entry.assetId,
            gross: drawn.gross
        });
    }
    return {
        netProceeds: netProceeds,
        grossRequested: grossRequested,
        grossDrawn: grossDrawn,
        topUps: topUps,
        grossShortfall: Math.max(0, remaining)
    };
}
function $b71b41b8944942d4$export$37e3e9e9ea12b9ea(factFind, radFunding, cgtOverrides = {}, pricedAgainst = factFind) {
    return $b71b41b8944942d4$export$5857282f1a3caa15(factFind, radFunding, cgtOverrides, pricedAgainst).netProceeds;
}
function $b71b41b8944942d4$export$8a0c5ad907f77392(factFind, radFunding, cgtOverrides = {}) {
    if (!radFunding) return structuredClone(factFind);
    const modifiedFactFind = structuredClone(factFind);
    // Priced against the caller's original, which `structuredClone` has just detached from the copy
    // being mutated — the same "value the client actually held" the in-place helper is documented to use.
    const totalRadPaidNet = $b71b41b8944942d4$export$37e3e9e9ea12b9ea(modifiedFactFind, radFunding, cgtOverrides, factFind);
    if (totalRadPaidNet > 0) {
        if (!modifiedFactFind.assets) modifiedFactFind.assets = {};
        modifiedFactFind.assets.radPaid = [
            {
                id: 'radPaid',
                description: 'RAD Paid',
                value: totalRadPaidNet,
                income: 0,
                growthRate: 0
            }
        ];
    }
    return modifiedFactFind;
}



const $7902ca900a473358$var$DAY_MS = 86400000;
const $7902ca900a473358$var$ISO = /^\d{4}-\d{2}-\d{2}$/;
function $7902ca900a473358$export$9a209edac0ea183f(radPaid, entryDate, asAt, grandfathered) {
    const paid = Math.max(0, Number(radPaid) || 0);
    const entry = typeof entryDate === 'string' && $7902ca900a473358$var$ISO.test(entryDate) ? new Date(entryDate + 'T00:00:00') : null;
    if (grandfathered || !entry || paid <= 0) return {
        balance: paid,
        retained: 0,
        retentionDaysTaken: 0
    };
    const days = Math.max(0, Math.min(1825, Math.floor((asAt.getTime() - entry.getTime()) / $7902ca900a473358$var$DAY_MS)));
    const balance = paid * Math.pow(1 - 0.02 / 365, days);
    return {
        balance: balance,
        retained: paid - balance,
        retentionDaysTaken: days
    };
}
function $7902ca900a473358$export$9338a7bd7bb34516(factFind, asAt) {
    const rows = [];
    for (const person of [
        'client',
        'partner'
    ]){
        const p = person === 'partner' ? factFind.partner : factFind.client;
        const stay = p?.careStay;
        if (!stay || p?.currentResidency !== 'aged_care' || !((Number(stay.radPaid) || 0) > 0)) continue;
        if (person === 'partner' && factFind.adviceFor !== 'couple') continue;
        const grandfathered = (0, $5a5496da6ce58554$export$388e9988095daada)(factFind, person);
        const { balance: balance, retentionDaysTaken: retentionDaysTaken } = $7902ca900a473358$export$9a209edac0ea183f(Number(stay.radPaid) || 0, stay.entryDate, asAt, grandfathered);
        rows.push({
            id: 'radPaid',
            type: 'radPaid',
            description: 'RAD Paid',
            value: balance,
            income: 0,
            growthRate: 0,
            ownership: person,
            __radRetentionDaysTaken: retentionDaysTaken,
            ...grandfathered ? {
                __noRetention: true
            } : {}
        });
    }
    return rows;
}
function $7902ca900a473358$export$2a6399fb2105ee37(factFind, asAt = new Date()) {
    const rows = $7902ca900a473358$export$9338a7bd7bb34516(factFind, asAt);
    if (rows.length === 0) return factFind;
    const have = factFind.assets?.radPaid || [];
    const missing = rows.filter((r)=>!have.some((h)=>(h.ownership ?? 'client') === (r.ownership ?? 'client')));
    if (missing.length === 0) return factFind;
    return {
        ...factFind,
        assets: {
            ...factFind.assets || {},
            radPaid: [
                ...have,
                ...missing
            ]
        }
    };
}
function $7902ca900a473358$export$f0b7a61c305d05db(factFind, move) {
    // The nominated assets are sold first (this also clones the fact-find). `applyRadFundingToFactFind`
    // REPLACES the `radPaid` list with one row holding the proceeds, so the net raised is that row and
    // the original list is read from the caller's fact-find, not the sold one.
    const bag = move.radFunding && Object.keys(move.radFunding).length > 0 ? move.radFunding : null;
    const sold = (0, $b71b41b8944942d4$export$8a0c5ad907f77392)(factFind, bag, move.cgtOverrides ?? {});
    const soldNet = bag ? $7902ca900a473358$var$sumRadRows(sold) : 0;
    const rows = factFind.assets?.radPaid || [];
    // The mover's existing deposit (their row) and the sale's proceeds row are both replaced below by
    // the one new deposit; anyone else's deposit stays.
    const refund = Math.max(0, Number(move.refundToday) || 0);
    const target = Math.max(0, Number(move.radTarget) || 0);
    const deposit = Math.min(target, refund + Math.max(0, soldNet));
    const fromRefund = Math.min(refund, deposit);
    const fromSale = Math.max(0, deposit - fromRefund);
    const surplus = Math.max(0, refund + Math.max(0, soldNet) - deposit);
    if (!sold.assets) sold.assets = {};
    sold.assets.radPaid = [
        ...rows.filter((r)=>(r.ownership ?? move.person) !== move.person && r.id !== 'radPaid'),
        ...deposit > 0 ? [
            {
                id: 'radPaid',
                type: 'radPaid',
                description: 'RAD Paid',
                value: deposit,
                income: 0,
                growthRate: 0,
                ownership: move.person
            }
        ] : []
    ];
    if (surplus > 0) $7902ca900a473358$var$creditBank(sold, surplus);
    return {
        factFind: sold,
        deposit: deposit,
        fromRefund: fromRefund,
        fromSale: fromSale,
        surplus: surplus
    };
}
function $7902ca900a473358$var$sumRadRows(ff) {
    return (ff.assets?.radPaid || []).reduce((t, r)=>t + (Number(r.value) || 0), 0);
}
function $7902ca900a473358$var$creditBank(ff, amount) {
    if (!ff.assets) ff.assets = {};
    const banks = ff.assets.bankAccounts = ff.assets.bankAccounts || [];
    if (banks.length === 0) {
        banks.push({
            id: 'bank-move-surplus',
            type: 'bankAccounts',
            description: 'Bank account',
            value: amount,
            ownership: 'client',
            incomeRate: 0
        });
        return;
    }
    const largest = banks.reduce((best, b)=>(Number(b.value) || 0) > (Number(best.value) || 0) ? b : best, banks[0]);
    largest.value = (Number(largest.value) || 0) + amount;
}






/**
 * Age Pension entitlement — the means test, as a pure function.
 *
 * Given a client's already-assessed position (assessable assets, deemed and other assessable income,
 * relationship/homeowner/age status), this decides what pension they are entitled to: the assets test
 * and the income test, whichever is the more restrictive, plus Commonwealth Rent Assistance, the
 * illness-separated and one-of-a-couple-eligible adjustments, and the HEAS reduction. It also renders
 * the `socialSecurityBreakdown` — the line-by-line working the UI shows in its Age Pension tooltip.
 *
 * Extracted from `calculateFinancials`, which is where this ran inline (as its "--- 3. Age Pension
 * Calculation ---" block) and which still calls it: the pension is part of that function's cashflow,
 * so it cannot simply be lifted out to the server. What it CAN be is injected — see
 * {@link AgePensionAssessor}. `calculateFinancials` now asks an assessor for the entitlement rather
 * than computing it, and the projection engine passes in the one owned by its agePensionPlugin, which
 * is the single place both the entitlement and the fortnightly payment of it are described.
 *
 * This module does NOT decide what counts as an assessable asset or as assessable income — that is
 * upstream, in `assessableMeans.ts`, and is shared with the aged-care means test. It takes those totals
 * as given.
 */ 

function $f6d9b8637d64d262$export$8f1c149d58db72a9(rentPerFortnight, situationKey, ra = (0, $1abe73eeef086faf$export$2dec321660c3b7e8)) {
    const band = ra.rates[situationKey] || ra.rates.single;
    const rent = rentPerFortnight || 0;
    const excess = Math.max(0, rent - band.minRent);
    const fortnightly = Math.min(excess * ra.taperRate, band.maxPayment);
    return fortnightly * 26;
}
function $f6d9b8637d64d262$export$c3f4236fbd9377cb(rates, { isPartnered: isPartnered, isHomeowner: isHomeowner, isIllnessSeparated: isIllnessSeparated }) {
    const group = isPartnered ? isIllnessSeparated ? rates.assetTestLimits?.coupleIllnessSeparated : rates.assetTestLimits?.couple : rates.assetTestLimits?.single;
    const branch = isHomeowner ? group?.homeowner : group?.nonHomeowner;
    return {
        lower: branch?.full ?? rates.assetTestLower[isPartnered ? 'couple' : 'single'],
        upper: branch?.cutoff ?? rates.assetTestUpper[isPartnered ? 'couple' : 'single']
    };
}
const $f6d9b8637d64d262$export$482390490d6631b8 = (input)=>{
    const { rates: rates, isPartnered: isPartnered, relationshipStatus: relationshipStatus, illnessSeparated: illnessSeparated, isHomeowner: isHomeowner, clientAge: clientAge, partnerAge: partnerAge, assessableAssets: assessableAssets, deprivedAsset: deprivedAsset, formerHomeCounted: formerHomeCounted = 0, deemedIncome: deemedIncome, deemingThreshold: deemingThreshold, financialAssetsForDeeming: financialAssetsForDeeming, assessableIncomeFromPensions: assessableIncomeFromPensions, netRentalIncomeForPension: netRentalIncomeForPension, otherAssessableIncome: otherAssessableIncome, investmentPropertyRentalForPension: investmentPropertyRentalForPension, partnerAssessableIncomeFromPensions: partnerAssessableIncomeFromPensions, partnerNetRentalIncomeForPension: partnerNetRentalIncomeForPension, partnerOtherAssessableIncome: partnerOtherAssessableIncome, partnerInvestmentPropertyRentalForPension: partnerInvestmentPropertyRentalForPension, clientResidency: clientResidency, partnerResidency: partnerResidency, rvResident: rvResident, rvIsHomeowner: rvIsHomeowner, factFind: factFind, heasAgePensionReduction: heasAgePensionReduction, structureAttribution: structureAttribution, pre2015ABPDetails: pre2015ABPDetails, definedBenefitDetails: definedBenefitDetails = [], withoutBreakdown: withoutBreakdown = false } = input;
    // Computed unconditionally — `calculateFinancials` reports it whether or not the client is of
    // pension age, because the aged-care means test reads it too.
    const totalAssessableIncome = deemedIncome + assessableIncomeFromPensions + netRentalIncomeForPension + otherAssessableIncome + investmentPropertyRentalForPension + partnerInvestmentPropertyRentalForPension + partnerAssessableIncomeFromPensions + partnerNetRentalIncomeForPension + partnerOtherAssessableIncome;
    let agePension = 0;
    let rentAssistanceIncome = 0;
    const basePensionRate = rates.pensionRates[relationshipStatus];
    const pensionRate = isPartnered && illnessSeparated ? rates.pensionRates.single * 2 : basePensionRate;
    const clientEligibleByAge = !!(clientAge && clientAge >= (0, $1abe73eeef086faf$export$5b6998cba7880742));
    const partnerEligibleByAge = !!(isPartnered && partnerAge && partnerAge >= (0, $1abe73eeef086faf$export$5b6998cba7880742));
    const isEligibleByAge = clientEligibleByAge || partnerEligibleByAge;
    const onlyOneOfCoupleEligible = isPartnered && clientEligibleByAge !== partnerEligibleByAge;
    let pensionFromAssetTest = pensionRate;
    let pensionFromIncomeTest = pensionRate;
    let pensionDeterminingTest;
    let socialSecurityBreakdown;
    if (isEligibleByAge) {
        const { lower: assetLowerLimit, upper: assetUpperLimit } = $f6d9b8637d64d262$export$c3f4236fbd9377cb(rates, {
            isPartnered: isPartnered,
            isHomeowner: isHomeowner,
            isIllnessSeparated: illnessSeparated
        });
        let assetTestResult = 'Full Pension';
        let assetExcess = 0;
        let assetReductionApplied = 0;
        if (assessableAssets > assetUpperLimit) {
            pensionFromAssetTest = 0;
            assetTestResult = 'Nil';
        } else if (assessableAssets > assetLowerLimit) {
            assetExcess = assessableAssets - assetLowerLimit;
            const reduction = assetExcess / 1000 * (0, $1abe73eeef086faf$export$6ca758cf677ce6c5);
            assetReductionApplied = reduction;
            pensionFromAssetTest = Math.max(0, pensionRate - reduction);
            assetTestResult = 'Part Pension';
        }
        const incomeLowerLimit = rates.incomeTestLower[relationshipStatus];
        const incomeUpperLimit = isPartnered ? illnessSeparated ? rates.incomeTestCutoff.coupleIllnessSeparated : rates.incomeTestCutoff.couple : rates.incomeTestCutoff.single;
        let incomeTestResult = 'Full Pension';
        if (totalAssessableIncome > incomeLowerLimit) {
            const excessIncome = totalAssessableIncome - incomeLowerLimit;
            const reduction = excessIncome * (0, $1abe73eeef086faf$export$d0c93f26057d6047);
            pensionFromIncomeTest = Math.max(0, pensionRate - reduction);
            incomeTestResult = 'Part Pension';
            if (pensionFromIncomeTest === 0) incomeTestResult = 'Nil';
        }
        agePension = Math.min(pensionFromAssetTest, pensionFromIncomeTest);
        pensionDeterminingTest = pensionFromAssetTest < pensionFromIncomeTest ? 'Asset Test' : 'Income Test';
        // --- Rent Assistance (CRA), integrated into the means-test taper (LA-2 taper fix) ---
        {
            const clientRents = clientResidency === 'renting';
            const partnerRents = isPartnered && partnerResidency === 'renting';
            const rvNonHomeownerRA = rvResident && !rvIsHomeowner;
            const landlordType = factFind.rent?.landlordType;
            const raLandlordEligible = landlordType !== 'family' && landlordType !== 'public_housing';
            /*
             * A village resident below the extra allowable amount is a non-homeowner whose ongoing
             * fees count as rent (SSA s 13(8)). The profile records those fees on the village
             * record; until 7 Oct 2026 only a MODELLED village move copied them into `rent`, so an
             * existing resident was paid no Rent Assistance at all.
             */ const rentPerWeek = factFind.rent?.rentAmount || 0 || (rvNonHomeownerRA ? Number(factFind.retirementVillage?.ongoingFees) || 0 : 0);
            const rentPerFortnight = rentPerWeek * 2;
            if ((clientRents || partnerRents || rvNonHomeownerRA) && raLandlordEligible && rentPerWeek > 0) {
                const raSituation = isPartnered ? illnessSeparated ? 'illnessSeparated' : 'coupleCombined' : factFind.rent?.sharedAccommodation === true ? 'singleSharer' : 'single';
                const raMax = $f6d9b8637d64d262$export$8f1c149d58db72a9(rentPerFortnight, raSituation);
                const rawAssetReduction = assessableAssets > assetLowerLimit ? (assessableAssets - assetLowerLimit) / 1000 * (0, $1abe73eeef086faf$export$6ca758cf677ce6c5) : 0;
                const rawIncomeReduction = totalAssessableIncome > incomeLowerLimit ? (totalAssessableIncome - incomeLowerLimit) * (0, $1abe73eeef086faf$export$d0c93f26057d6047) : 0;
                const combinedMax = pensionRate + raMax;
                const combinedEntitlement = Math.min(Math.max(0, combinedMax - rawAssetReduction), Math.max(0, combinedMax - rawIncomeReduction));
                rentAssistanceIncome = Math.min(Math.max(0, combinedEntitlement - agePension), raMax);
            }
        }
        if (onlyOneOfCoupleEligible) agePension = agePension / 2;
        if (heasAgePensionReduction > 0) agePension = Math.max(0, agePension - heasAgePensionReduction);
        socialSecurityBreakdown = withoutBreakdown ? [] : [
            ...isPartnered ? [
                {
                    label: 'Couple treatment',
                    value: illnessSeparated ? 'Illness separated' : 'Standard couple'
                }
            ] : [],
            {
                label: '--- Asset Test ---',
                value: ''
            },
            {
                label: 'Your Assets',
                value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(assessableAssets)
            },
            ...formerHomeCounted > 0 ? [
                {
                    label: 'Former home counted (two-year exemption ended; assessed as a non-homeowner)',
                    value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(formerHomeCounted)
                }
            ] : [],
            {
                label: 'Deprived Assets',
                value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(deprivedAsset)
            },
            {
                label: 'Full Pension Limit',
                value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(assetLowerLimit)
            },
            {
                label: 'Nil Pension Limit',
                value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(assetUpperLimit)
            },
            {
                label: 'Result',
                value: assetTestResult
            },
            ...assetTestResult === 'Part Pension' ? [
                {
                    label: 'Assets above full-pension limit',
                    value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(assetExcess)
                },
                {
                    label: 'Asset-test taper rate',
                    value: '$3 per fortnight per $1000'
                },
                {
                    label: 'Asset-test reduction applied',
                    value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(assetReductionApplied)
                }
            ] : [],
            {
                label: 'Pension under this test',
                value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(pensionFromAssetTest)
            },
            {
                label: '--- Income Test ---',
                value: ''
            },
            {
                label: 'Deemed Income',
                value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(deemedIncome)
            },
            ...isPartnered ? [
                {
                    label: '  - Combined Financial Assets',
                    value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(financialAssetsForDeeming)
                }
            ] : [],
            {
                label: 'Other Assessable Income',
                value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(assessableIncomeFromPensions + netRentalIncomeForPension + otherAssessableIncome + investmentPropertyRentalForPension + partnerInvestmentPropertyRentalForPension + partnerAssessableIncomeFromPensions + partnerNetRentalIncomeForPension + partnerOtherAssessableIncome)
            },
            ...assessableIncomeFromPensions > 0 ? [
                {
                    label: '  - Client Pension Income',
                    value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(assessableIncomeFromPensions)
                }
            ] : [],
            ...netRentalIncomeForPension > 0 ? [
                {
                    label: '  - Client Rental Income (family home)',
                    value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(netRentalIncomeForPension)
                }
            ] : [],
            ...investmentPropertyRentalForPension > 0 ? [
                {
                    label: '  - Client Investment Property Rental',
                    value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(investmentPropertyRentalForPension)
                }
            ] : [],
            ...otherAssessableIncome > 0 ? [
                {
                    label: '  - Client Other Income',
                    value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(otherAssessableIncome)
                }
            ] : [],
            ...isPartnered && partnerAssessableIncomeFromPensions > 0 ? [
                {
                    label: '  - Partner Pension Income',
                    value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(partnerAssessableIncomeFromPensions)
                }
            ] : [],
            ...isPartnered && partnerNetRentalIncomeForPension > 0 ? [
                {
                    label: '  - Partner Rental Income (family home)',
                    value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(partnerNetRentalIncomeForPension)
                }
            ] : [],
            ...isPartnered && partnerInvestmentPropertyRentalForPension > 0 ? [
                {
                    label: '  - Partner Investment Property Rental',
                    value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(partnerInvestmentPropertyRentalForPension)
                }
            ] : [],
            ...isPartnered && partnerOtherAssessableIncome > 0 ? [
                {
                    label: '  - Partner Other Income',
                    value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(partnerOtherAssessableIncome)
                }
            ] : [],
            ...structureAttribution?.structureLines?.length ? [
                {
                    label: '--- Trusts & companies (apportioned) ---',
                    value: ''
                },
                ...structureAttribution.structureLines.flatMap((line)=>[
                        ...line.clientAmount > 0 ? [
                            {
                                label: `${line.label} (client share)`,
                                value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(line.clientAmount)
                            }
                        ] : [],
                        ...isPartnered && line.partnerAmount > 0 ? [
                            {
                                label: `${line.label} (partner share)`,
                                value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(line.partnerAmount)
                            }
                        ] : []
                    ])
            ] : [],
            ...pre2015ABPDetails.length > 0 ? [
                {
                    label: '--- Pre-2015 ABP (deductible amount) ---',
                    value: ''
                },
                ...pre2015ABPDetails.flatMap((d)=>[
                        ...d.commutations > 0 ? [
                            {
                                label: `  ${d.description}: Commutations (e.g. RAD drawdown)`,
                                value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(d.commutations)
                            }
                        ] : [],
                        {
                            label: `  ${d.description}: Relevant number (at commencement)`,
                            value: typeof d.relevantNumber === 'number' ? d.relevantNumber.toFixed(2) : String(d.relevantNumber)
                        },
                        {
                            label: `  ${d.description}: Deductible amount (p.a.)`,
                            value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(d.deductibleAmount)
                        },
                        {
                            label: `  ${d.description}: Assessable (payment \u{2212} deductible)`,
                            value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(d.assessableAmount)
                        }
                    ])
            ] : [],
            ...definedBenefitDetails.length > 0 ? [
                {
                    label: '--- Defined benefit pension (payment less its tax-free part, capped at 10%) ---',
                    value: ''
                },
                ...definedBenefitDetails.flatMap((d)=>[
                        {
                            label: `  ${d.description}: Annual payment`,
                            value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(d.annualPayment)
                        },
                        {
                            label: `  ${d.description}: Tax-free part counted${d.deductibleEntered > d.deductibleApplied + 0.5 ? ' (capped at 10%)' : ''}`,
                            value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(d.deductibleApplied)
                        },
                        {
                            label: `  ${d.description}: Assessable income`,
                            value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(d.assessableIncome)
                        },
                        d.assetTestExempt ? {
                            label: `  ${d.description}: Assets test`,
                            value: 'Not counted (exempt)'
                        } : {
                            label: `  ${d.description}: Asset value (payment \xd7 factor ${d.valuationFactor ?? "\u2014"})`,
                            value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(d.assetValue)
                        }
                    ])
            ] : [],
            {
                label: 'Total Assessable Income',
                value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(totalAssessableIncome)
            },
            {
                label: 'Full Pension Limit',
                value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(incomeLowerLimit)
            },
            {
                label: 'Nil Pension Limit',
                value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(incomeUpperLimit)
            },
            {
                label: 'Result',
                value: incomeTestResult
            },
            {
                label: 'Pension under this test',
                value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(pensionFromIncomeTest)
            },
            {
                label: '--- Deeming Details ---',
                value: ''
            },
            // Rounded to the rate's own precision: 0.0175 * 100 is 1.7500000000000002 in floating point,
            // and that is what a client saw in the breakdown (owner, 22 Sep 2026).
            {
                label: `Up to ${(0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(deemingThreshold)}`,
                value: `${+((0, $1abe73eeef086faf$export$7ccf16e55e6cf86b) * 100).toFixed(4)}%`
            },
            {
                label: `Over ${(0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(deemingThreshold)}`,
                value: `${+((0, $1abe73eeef086faf$export$fe9b80c24d06bb6b) * 100).toFixed(4)}%`
            },
            {
                label: '--- Final Entitlement ---',
                value: ''
            },
            {
                label: 'Determined By',
                value: pensionDeterminingTest
            },
            {
                label: 'Pension Before HEAS',
                value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(Math.min(pensionFromAssetTest, pensionFromIncomeTest))
            },
            ...heasAgePensionReduction > 0 ? [
                {
                    label: 'Less: HEAS Reduction',
                    value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(-heasAgePensionReduction)
                }
            ] : [],
            {
                label: 'Final Pension (p.a.)',
                value: (0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(agePension)
            }
        ];
    } else socialSecurityBreakdown = [
        {
            label: 'Not eligible for Age Pension due to age.',
            value: ''
        }
    ];
    return {
        agePension: agePension,
        rentAssistanceIncome: rentAssistanceIncome,
        totalAssessableIncome: totalAssessableIncome,
        socialSecurityBreakdown: socialSecurityBreakdown
    };
};


/**
 * Assessable assets & income — what a client's balance sheet and income look like to the MEANS TESTS,
 * as a pure function.
 *
 * This is the walk that decides WHAT COUNTS, before any test is applied to it: which assets are
 * assessable and which are exempt (the family home while someone lives in it, a RAD, funeral bonds up
 * to the per-person limit), which of them are FINANCIAL assets and so get deemed, and which income
 * streams are assessable and whose they are (client, partner, or split 50/50). It also strikes the one
 * genuinely intricate piece of income assessment in the fact-find: a pre-1 January 2015 account-based
 * pension, whose assessable income is its annual payment less a deductible amount derived from the
 * purchase price, the commutations taken out of it and the owner's life expectancy at commencement.
 *
 * What it deliberately does NOT do is test any of it. The totals here are struck once and read TWICE —
 * by the Age Pension means test (see `agePension.ts`) and by the residential aged-care means test
 * (server-side, `agedCareCostsEngine.ts`) — which is exactly why the assessment is separate from
 * either: the two tests disagree about thresholds and rates, but not about what a client owns.
 * Deeming, deprivation (gifting) and the reverse-mortgage proceeds are applied to these totals by the
 * caller, not here — see `calculateFinancials`'s sections 2 and 3.
 *
 * Extracted from `calculateFinancials`'s "--- 1. Assessable Assets & Income (for Pension) ---" block,
 * which still calls it — through the injectable {@link AssessableMeansAssessor} seam, so the projection
 * engine can hand in the assessor owned by its assessableMeansPlugin. See that plugin for why the code
 * lives here rather than in it.
 */ /**
 * DEFINED BENEFIT PENSIONS (owner, 12–15 Oct 2026; built for the UniSuper conversation).
 *
 * A lifetime pension paid from a super fund by a formula — UniSuper's Defined Benefit Division, CSS,
 * PSS, the military schemes, the state schemes — not bought with a lump sum. It has no account
 * balance behind it. The profile records it as an INCOME entry (type `definedBenefitPension`), and
 * this module holds every rule the engine applies to it. Nothing here is ever sold, commuted or
 * restructured by a strategy.
 *
 * THE RULES, each from the Social Security Guide page the owner supplied on 15 Oct 2026:
 *
 *   - INCOME TEST (4.9.3.30): assessable income = annual payment − deductible amount, and from
 *     1 January 2016 the deductible amount is capped at 10% of the gross payment. The three military
 *     schemes (DFRDB, MilitarySuper, DFRB) are excluded from the cap. The same whether or not the
 *     pension is counted as an asset.
 *   - ASSETS TEST, EXEMPT (4.9.2.20): a LIFETIME defined benefit pension is indefinitely exempt where
 *     the scheme was established before 20 September 1998, provided the product before then, the
 *     product was exempt then, and the member's pension comes from that pre-1998 product — the date
 *     the member's own pension started does not matter. DFRDB and MilitarySuper are exempt outright.
 *   - ASSETS TEST, COUNTED (4.9.3.30, 4.9.5.60): a pension that is NOT exempt is valued at the annual
 *     payment × the pension valuation factor for the person's age next birthday and the pension's
 *     indexation rate (Social Security (Pension Valuation Factor) Determination 2018), reassessed
 *     every year.
 *   - TAX (ATO, defined benefit income cap): from age 60 the payment is tax‑free up to the cap
 *     ($131,250 for 2026‑27 = general transfer balance cap ÷ 16); 50% of anything above it is
 *     assessable income. Under 60 the payment is taxed at marginal rates — modelled here as fully
 *     assessable, without the 15% offset a taxed‑source pension attracts, which errs on the side of
 *     MORE tax (D.3; the clients this module serves are over 60).
 *   - REVERSION: on the member's death a set share continues to the spouse for life (UniSuper:
 *     62.5%). Recorded and disclosed; the projection does not model a death.
 *
 * The aged care means test takes its income and asset definitions from these same rules (see
 * agedCareAssessableIncome.ts), so the treatment flows through to the fees; that flow‑through is on
 * the reviewer's list to confirm (F_GAPS).
 */ 
const $f94c75e8792c4be0$export$3ab31fcc31991e8a = 2.5;
const $f94c75e8792c4be0$export$b4aa6e37cd918cff = 0.10;
const $f94c75e8792c4be0$export$3587e0218c6e04b3 = [
    {
        id: 'unisuper',
        name: 'UniSuper Defined Benefit Indexed Pension',
        preSept1998Product: true,
        military: false,
        reversionPct: 62.5,
        indexed: true,
        taxedSource: true,
        note: 'Open to members in the Defined Benefit Division since before 1 July 1998. A spouse automatically receives 62.5% for life.'
    },
    {
        id: 'css',
        name: 'CSS (Commonwealth Superannuation Scheme)',
        preSept1998Product: true,
        military: false,
        reversionPct: 67,
        indexed: true,
        taxedSource: false,
        note: 'Closed to new members since 1990. A spouse generally receives 67%.'
    },
    {
        id: 'pss',
        name: 'PSS (Public Sector Superannuation Scheme)',
        preSept1998Product: true,
        military: false,
        reversionPct: 67,
        indexed: true,
        taxedSource: false,
        note: 'Closed to new members since 2005. A spouse generally receives 67%.'
    },
    {
        id: 'dfrdb',
        name: 'DFRDB (Defence Force Retirement and Death Benefits)',
        preSept1998Product: true,
        military: true,
        reversionPct: 62.5,
        indexed: true,
        taxedSource: false,
        note: "A military pension: not counted as an asset, and the tax\u2011free part is not capped for the income test."
    },
    {
        id: 'militarySuper',
        name: 'MilitarySuper (Military Superannuation and Benefits Scheme)',
        preSept1998Product: true,
        military: true,
        reversionPct: 62.5,
        indexed: true,
        taxedSource: false,
        note: "A military pension: not counted as an asset, and the tax\u2011free part is not capped for the income test."
    },
    {
        id: 'stateScheme',
        name: 'A state government scheme (e.g. State Super, QSuper, ESSSuper, Super SA)',
        preSept1998Product: true,
        military: false,
        reversionPct: null,
        indexed: true,
        taxedSource: false,
        note: "The long\u2011standing state schemes predate 1998; check the spouse share on the scheme\u2019s statement."
    },
    {
        id: 'other',
        name: 'Another fund',
        preSept1998Product: false,
        military: false,
        reversionPct: null,
        indexed: true,
        taxedSource: true,
        note: 'Whether the pension counts as an asset turns on whether the pension product existed before 20 September 1998.'
    }
];
function $f94c75e8792c4be0$export$9bb8c8dca6c61774(fundId) {
    return $f94c75e8792c4be0$export$3587e0218c6e04b3.find((f)=>f.id === fundId) ?? $f94c75e8792c4be0$export$3587e0218c6e04b3[$f94c75e8792c4be0$export$3587e0218c6e04b3.length - 1];
}
function $f94c75e8792c4be0$export$ecbf3b113ae95cba(item) {
    return item?.type === 'definedBenefitPension';
}
const $f94c75e8792c4be0$var$PERIODS_PER_YEAR = {
    weekly: 52,
    fortnightly: 26,
    monthly: 12,
    annually: 1
};
function $f94c75e8792c4be0$export$2ed8828a9a102eef(perPayment, frequency) {
    const p = Number(perPayment);
    if (!Number.isFinite(p) || p <= 0) return 0;
    const periods = $f94c75e8792c4be0$var$PERIODS_PER_YEAR[frequency || 'fortnightly'] ?? 26;
    return p * periods;
}
const $f94c75e8792c4be0$var$num = (v)=>{
    const n = typeof v === 'number' ? v : parseFloat(String(v ?? ''));
    return Number.isFinite(n) ? n : 0;
};
function $f94c75e8792c4be0$export$7a7c8a164271f50d(item) {
    return Math.max(0, $f94c75e8792c4be0$var$num(item.amount));
}
function $f94c75e8792c4be0$export$84b1b46a5f039238(item) {
    return Math.max(0, $f94c75e8792c4be0$var$num(item.dbDeductibleAmount));
}
function $f94c75e8792c4be0$export$e62ab2ce095cbce8(item) {
    if (typeof item.dbMilitary === 'boolean') return item.dbMilitary;
    return $f94c75e8792c4be0$export$9bb8c8dca6c61774(item.dbFund).military;
}
function $f94c75e8792c4be0$export$aef814a01ac886(item) {
    if (typeof item.dbPreSept1998Product === 'boolean') return item.dbPreSept1998Product;
    return $f94c75e8792c4be0$export$9bb8c8dca6c61774(item.dbFund).preSept1998Product;
}
function $f94c75e8792c4be0$export$5cd4c78204505f87(item) {
    const payment = $f94c75e8792c4be0$export$7a7c8a164271f50d(item);
    const deductible = $f94c75e8792c4be0$export$84b1b46a5f039238(item);
    const cap = $f94c75e8792c4be0$export$e62ab2ce095cbce8(item) ? deductible : Math.min(deductible, payment * $f94c75e8792c4be0$export$b4aa6e37cd918cff);
    return Math.max(0, payment - cap);
}
function $f94c75e8792c4be0$export$e7a717cb4a367b12(item) {
    return $f94c75e8792c4be0$export$e62ab2ce095cbce8(item) || $f94c75e8792c4be0$export$aef814a01ac886(item);
}
const $f94c75e8792c4be0$export$de1807d2495f5808 = [
    {
        maxAgeNextBirthday: 20,
        factors: [
            82,
            60,
            45,
            35,
            28,
            23,
            21,
            19,
            16,
            14
        ]
    },
    {
        maxAgeNextBirthday: 25,
        factors: [
            74,
            55,
            42,
            33,
            27,
            22,
            20,
            19,
            16,
            14
        ]
    },
    {
        maxAgeNextBirthday: 30,
        factors: [
            66,
            51,
            40,
            32,
            26,
            21,
            20,
            18,
            16,
            14
        ]
    },
    {
        maxAgeNextBirthday: 35,
        factors: [
            58,
            46,
            37,
            30,
            25,
            21,
            19,
            18,
            15,
            13
        ]
    },
    {
        maxAgeNextBirthday: 40,
        factors: [
            51,
            41,
            33,
            28,
            23,
            20,
            18,
            17,
            15,
            13
        ]
    },
    {
        maxAgeNextBirthday: 45,
        factors: [
            44,
            36,
            30,
            25,
            22,
            19,
            17,
            16,
            14,
            13
        ]
    },
    {
        maxAgeNextBirthday: 50,
        factors: [
            38,
            32,
            27,
            23,
            20,
            17,
            16,
            15,
            13,
            12
        ]
    },
    {
        maxAgeNextBirthday: 55,
        factors: [
            32,
            27,
            24,
            21,
            18,
            16,
            15,
            14,
            13,
            11
        ]
    },
    {
        maxAgeNextBirthday: 60,
        factors: [
            26,
            23,
            20,
            18,
            16,
            14,
            14,
            13,
            12,
            11
        ]
    },
    {
        maxAgeNextBirthday: 65,
        factors: [
            21,
            19,
            17,
            15,
            14,
            12,
            12,
            11,
            10,
            10
        ]
    },
    {
        maxAgeNextBirthday: 70,
        factors: [
            16,
            15,
            14,
            12,
            11,
            11,
            10,
            10,
            9,
            8
        ]
    },
    {
        maxAgeNextBirthday: 75,
        factors: [
            12,
            11,
            10,
            10,
            9,
            8,
            8,
            8,
            7,
            7
        ]
    },
    {
        maxAgeNextBirthday: 80,
        factors: [
            9,
            9,
            8,
            8,
            7,
            7,
            7,
            7,
            6,
            6
        ]
    },
    {
        maxAgeNextBirthday: 85,
        factors: [
            6,
            6,
            5,
            5,
            5,
            5,
            5,
            4,
            4,
            4
        ]
    },
    {
        maxAgeNextBirthday: 90,
        factors: [
            4,
            4,
            4,
            3,
            3,
            3,
            3,
            3,
            3,
            3
        ]
    },
    {
        maxAgeNextBirthday: 95,
        factors: [
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3
        ]
    },
    {
        maxAgeNextBirthday: 100,
        factors: [
            3,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2
        ]
    },
    {
        maxAgeNextBirthday: Infinity,
        factors: [
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ]
    }
];
function $f94c75e8792c4be0$export$b3681fc9f4ca39f5(indexationPct) {
    const r = Number.isFinite(indexationPct) ? indexationPct : 0;
    if (r >= 8) return 0;
    if (r >= 7) return 1;
    if (r >= 6) return 2;
    if (r >= 5) return 3;
    if (r >= 4) return 4;
    if (r >= 3) return 5;
    if (r >= 2.5) return 6;
    if (r >= 2) return 7;
    if (r >= 1) return 8;
    return 9;
}
function $f94c75e8792c4be0$export$de94e21a93329055(age, indexationPct) {
    const ageNextBirthday = Math.floor(Math.max(0, age)) + 1;
    const row = $f94c75e8792c4be0$export$de1807d2495f5808.find((r)=>ageNextBirthday <= r.maxAgeNextBirthday) ?? $f94c75e8792c4be0$export$de1807d2495f5808[$f94c75e8792c4be0$export$de1807d2495f5808.length - 1];
    return row.factors[$f94c75e8792c4be0$export$b3681fc9f4ca39f5(indexationPct)];
}
function $f94c75e8792c4be0$export$f0fe79d04edb032c(item, cpiPct) {
    const indexed = typeof item.dbIndexed === 'boolean' ? item.dbIndexed : $f94c75e8792c4be0$export$9bb8c8dca6c61774(item.dbFund).indexed;
    if (!indexed) return 0;
    const own = $f94c75e8792c4be0$var$num(item.dbIndexationPct);
    return own > 0 ? own : Math.max(0, cpiPct);
}
function $f94c75e8792c4be0$export$10a68bbb3610b29f(item, ownerAge, cpiPct) {
    if ($f94c75e8792c4be0$export$e7a717cb4a367b12(item)) return 0;
    if (ownerAge == null || !Number.isFinite(ownerAge)) return 0;
    return $f94c75e8792c4be0$export$7a7c8a164271f50d(item) * $f94c75e8792c4be0$export$de94e21a93329055(ownerAge, $f94c75e8792c4be0$export$f0fe79d04edb032c(item, cpiPct));
}
function $f94c75e8792c4be0$export$e3225b085066838f(item) {
    if (typeof item.dbTaxedSource === 'boolean') return item.dbTaxedSource;
    return $f94c75e8792c4be0$export$9bb8c8dca6c61774(item.dbFund).taxedSource;
}
function $f94c75e8792c4be0$export$82e9ac24bf6bfaa1(item, ownerAge, cap = (0, $1abe73eeef086faf$export$336257db52e6aa69)) {
    const payment = $f94c75e8792c4be0$export$7a7c8a164271f50d(item);
    if (ownerAge != null && ownerAge >= 60 && $f94c75e8792c4be0$export$e3225b085066838f(item)) return Math.max(0, payment - cap) * 0.5;
    return Math.max(0, payment - $f94c75e8792c4be0$export$84b1b46a5f039238(item));
}
function $f94c75e8792c4be0$export$90c16105f11197a4(item, ownerAge, cap = (0, $1abe73eeef086faf$export$336257db52e6aa69)) {
    if (ownerAge == null || ownerAge < 60 || $f94c75e8792c4be0$export$e3225b085066838f(item)) return 0;
    const taxablePart = $f94c75e8792c4be0$export$82e9ac24bf6bfaa1(item, ownerAge, cap);
    const underCap = Math.max(0, Math.min(taxablePart, cap - $f94c75e8792c4be0$export$84b1b46a5f039238(item)));
    return 0.1 * underCap;
}
function $f94c75e8792c4be0$export$6a8e7b9692f3a0df(item) {
    const preset = $f94c75e8792c4be0$export$9bb8c8dca6c61774(item.dbFund);
    if (preset.id === 'other' || preset.id === 'stateScheme') return 'the fund';
    return preset.name.split(' ')[0] ?? 'the fund';
}
function $f94c75e8792c4be0$export$2c79ed3bdd59f4c8(item) {
    const own = item.dbReversionPct;
    if (typeof own === 'number' && Number.isFinite(own)) return Math.max(0, Math.min(100, own));
    return $f94c75e8792c4be0$export$9bb8c8dca6c61774(item.dbFund).reversionPct;
}
function $f94c75e8792c4be0$export$8caf030cd99f0901(item) {
    const pct = $f94c75e8792c4be0$export$2c79ed3bdd59f4c8(item);
    return pct == null ? null : $f94c75e8792c4be0$export$7a7c8a164271f50d(item) * pct / 100;
}
function $f94c75e8792c4be0$export$6486cc97165e7a50(item, input) {
    const payment = $f94c75e8792c4be0$export$7a7c8a164271f50d(item);
    if (payment <= 0) return [];
    const { ownerName: ownerName, ownerAge: ownerAge, partnerName: partnerName, cpiPct: cpiPct, money: money } = input;
    const out = [];
    if ($f94c75e8792c4be0$export$e7a717cb4a367b12(item)) out.push(`Centrelink does not count this pension as an asset.`);
    else if (ownerAge == null) out.push(`Centrelink counts this pension as an asset, valued from ${ownerName}'s age. Enter a date of birth to see the figure.`);
    else {
        const value = $f94c75e8792c4be0$export$10a68bbb3610b29f(item, ownerAge, cpiPct);
        out.push(`Centrelink counts this pension as worth about ${money(Math.round(value))} while ${ownerName} is ${Math.floor(ownerAge)}, falling each year with age. It is not part of the estate.`);
    }
    const assessable = $f94c75e8792c4be0$export$5cd4c78204505f87(item);
    const deductible = $f94c75e8792c4be0$export$84b1b46a5f039238(item);
    if (deductible <= 0) out.push(`The whole ${money(Math.round(payment))} counts as income each year, because no tax-free part was entered.`);
    else if ($f94c75e8792c4be0$export$e62ab2ce095cbce8(item)) out.push(`${money(Math.round(assessable))} of the ${money(Math.round(payment))} counts as income each year (the tax-free part is not capped for a military pension).`);
    else out.push(`${money(Math.round(assessable))} of the ${money(Math.round(payment))} counts as income each year (the tax-free part counts up to 10% of the payment).`);
    const taxable = $f94c75e8792c4be0$export$82e9ac24bf6bfaa1(item, ownerAge);
    const taxedSource = $f94c75e8792c4be0$export$e3225b085066838f(item);
    if (ownerAge != null && ownerAge >= 60 && !taxedSource) {
        const offset = $f94c75e8792c4be0$export$90c16105f11197a4(item, ownerAge);
        const fund = $f94c75e8792c4be0$export$6a8e7b9692f3a0df(item);
        out.push(`${money(Math.round(taxable))} of it is taxed as income at ${ownerName}'s marginal rate, less a 10% tax offset of ${money(Math.round(offset))}, because ${fund} pays it from an untaxed source.`);
    } else if (ownerAge != null && ownerAge >= 60) out.push(taxable > 0 ? `It is tax-free up to ${money((0, $1abe73eeef086faf$export$336257db52e6aa69))} a year; half of the ${money(Math.round(payment - (0, $1abe73eeef086faf$export$336257db52e6aa69)))} above that is taxed.` : `It is tax-free, being under the ${money((0, $1abe73eeef086faf$export$336257db52e6aa69))} a year cap.`);
    else if (!taxedSource) out.push(`The payment is taxed as income at ${ownerName}'s marginal rate; from 60 a 10% tax offset applies, because it is paid from an untaxed source.`);
    else out.push(`Under 60 the payment is taxed as income; from 60 it is tax-free up to ${money((0, $1abe73eeef086faf$export$336257db52e6aa69))} a year.`);
    const reversion = $f94c75e8792c4be0$export$8caf030cd99f0901(item);
    if (partnerName && reversion != null) out.push(`If ${ownerName} dies first, ${partnerName} receives ${money(Math.round(reversion))} a year for life.`);
    else if (partnerName) out.push(`Enter the share that continues to ${partnerName} if ${ownerName} dies first; it is on the fund's statement.`);
    else out.push(`It stops at death; nothing passes to the estate.`);
    return out;
}




/**
 * Phase 1b — Trust/company attribution for means test, tax, and cashflow.
 * Entity-owned assets are excluded from personal paths; apportioned totals merge into calculateFinancials.
 * Ported verbatim from frontend/src/calculations/structureAttribution.js.
 */ 

/**
 * Phase 1c — entity-linked liabilities.
 * Ported from frontend/src/utils/structureLiabilitiesUtils.js — omits `getStructureLiabilityWarnings`
 * and `buildOwnershipOptions` (UI form/warning-banner helpers, never called by calculations/).
 */ 

/**
 * taxAndLoanUtils.ts – loan repayment and tax/CGT helpers.
 * Ported verbatim from frontend/src/calculations/taxAndLoanUtils.js.
 */ 

function $c9ee841cca8af175$export$1fcf7232357bf4d8(balance, annualRate, termYears, frequency = 'monthly', loanType = 'pi') {
    if (!balance || !annualRate || !termYears) return 0;
    const L = balance;
    const r_annual = annualRate / 100;
    let n_periods_per_year;
    switch(frequency){
        case 'weekly':
            n_periods_per_year = 52;
            break;
        case 'fortnightly':
            n_periods_per_year = 26;
            break;
        default:
            n_periods_per_year = 12; // monthly
    }
    const r_periodic = r_annual / n_periods_per_year;
    const n_total_periods = termYears * n_periods_per_year;
    if (loanType === 'io') return L * r_periodic;
    // Principal & Interest
    if (r_periodic === 0) return L / n_total_periods;
    const numerator = r_periodic * Math.pow(1 + r_periodic, n_total_periods);
    const denominator = Math.pow(1 + r_periodic, n_total_periods) - 1;
    if (denominator === 0) return 0;
    return L * (numerator / denominator);
}
function $c9ee841cca8af175$export$32eed5f4447a26d2(income) {
    for(let i = (0, $1abe73eeef086faf$export$b8352069eaf11cd3).length - 1; i >= 0; i--){
        const b = (0, $1abe73eeef086faf$export$b8352069eaf11cd3)[i];
        if (income > (i === 0 ? 0 : (0, $1abe73eeef086faf$export$b8352069eaf11cd3)[i - 1].limit)) return b.base + (income - (i === 0 ? 0 : (0, $1abe73eeef086faf$export$b8352069eaf11cd3)[i - 1].limit)) * b.rate;
    }
    return 0;
}
function $c9ee841cca8af175$export$514a4d0718b14c96(assessableIncome) {
    for(let i = (0, $1abe73eeef086faf$export$b8352069eaf11cd3).length - 1; i >= 0; i--){
        if (assessableIncome > (i === 0 ? 0 : (0, $1abe73eeef086faf$export$b8352069eaf11cd3)[i - 1].limit)) return (0, $1abe73eeef086faf$export$b8352069eaf11cd3)[i].rate;
    }
    return 0;
}
function $c9ee841cca8af175$export$e9c177028b9071dc(asset, saleAmount, simulatedFinancials, { disposalDate: disposalDate, cpiRate: cpiRate } = {}) {
    const value = asset?.value || 0;
    if (!value || saleAmount <= 0) return 0;
    // `taxContext` is present on every `calculateFinancials` result; the fallback only covers a stale
    // payload produced before it existed, and loses SAPTO/Medicare precision (see its own doc comment).
    const taxContext = simulatedFinancials?.taxContext ?? (0, $1fbcfc2df3ed29e9$export$ccfe146b55a752dd)(simulatedFinancials?.clientAssessableIncome || 0, simulatedFinancials?.partnerAssessableIncome || 0, asset?.ownership === 'joint' || asset?.ownership === 'partner');
    return (0, $1fbcfc2df3ed29e9$export$c06c916a0ca433d3)({
        taxContext: taxContext,
        asset: asset,
        salePrice: saleAmount,
        // Brokerage on a share sale is immaterial at this level of estimate.
        sellingCosts: 0,
        originalAssetValue: value,
        disposalDate: disposalDate,
        cpiRate: cpiRate,
        structures: simulatedFinancials?.structures
    }).estimatedCGT;
}


/**
 * Which liabilities CAPITALISE rather than being serviced out of the client's cashflow.
 *
 * A reverse mortgage and a Home Equity Access Scheme loan are both repaid out of the property when
 * it is eventually sold, not out of income. Nothing leaves the bank for them each month, so giving
 * one a repayment schedule would show a client money going out that they never actually pay — and
 * would double-count against a balance that is meanwhile growing on its own.
 *
 * ONE DEFINITION, because there are three separate places that need it: the repayment assessor
 * (`loanRepayments.ts`), the structure-liability repayment helper, and the projection accrual that
 * compounds these balances (`loanPlugin.ts`). Until 2026-08-22 the first two each tested
 * `type === 'reverse_mortgage'` inline, which was the only value that existed then. When existing
 * reverse mortgages and HEAS loans became recordable as ordinary liabilities — they previously had
 * nowhere to live but a Living Arrangements question that no calculation ever read — those inline
 * tests would have missed the new category ids and handed both a repayment schedule they never pay.
 *
 * `reverse_mortgage` and `heas` are the ids the STRATEGY modeller injects; `reverseMortgages` and
 * `homeEquityAccessScheme` are the LIABILITY_TYPES category ids a client records against. Both
 * spellings resolve, so a strategy-injected loan and a client-recorded one behave identically.
 */ const $eb5ee2a9aeb43da8$export$47bc491607fda980 = new Set([
    'reverse_mortgage',
    'reverseMortgages',
    'heas',
    'homeEquityAccessScheme'
]);
function $eb5ee2a9aeb43da8$export$95d06fd31af89cb5(liability) {
    return $eb5ee2a9aeb43da8$export$47bc491607fda980.has(String(liability?.type || ''));
}
const $eb5ee2a9aeb43da8$export$143dcd48cd2c279 = 8.8;
const $eb5ee2a9aeb43da8$export$253d5eafce412b21 = 3.95;
const $eb5ee2a9aeb43da8$export$3d9da4ea838ea10f = {
    reverse_mortgage: $eb5ee2a9aeb43da8$export$143dcd48cd2c279,
    reverseMortgages: $eb5ee2a9aeb43da8$export$143dcd48cd2c279,
    heas: $eb5ee2a9aeb43da8$export$253d5eafce412b21,
    homeEquityAccessScheme: $eb5ee2a9aeb43da8$export$253d5eafce412b21
};
function $eb5ee2a9aeb43da8$export$1b1c345b360f098c(liability) {
    const recorded = liability?.interestRate;
    if (typeof recorded === 'number' && Number.isFinite(recorded)) return recorded;
    return $eb5ee2a9aeb43da8$export$3d9da4ea838ea10f[String(liability?.type || '')] ?? $eb5ee2a9aeb43da8$export$143dcd48cd2c279;
}


/**
 * CREDIT CARDS — how a card is paid, and what that costs (owner, 26 Oct 2026).
 *
 * A card has no term, so its repayment cannot be derived the way a mortgage's can, and a family
 * member filling in the profile rarely knows the figure. The profile therefore asks HOW the card is
 * paid rather than how much, and this module turns that answer into the month's payment and interest.
 * Before it, a card with no repayment typed in was modelled as costing nothing: no payment, no
 * interest, the balance standing still for the whole projection.
 *
 *   'full'    Paid off in full every month. No interest is charged; the balance is this month's
 *             spending, which is already in the living costs. It stays owed at the same figure (a
 *             rolling monthly bill) and draws no separate repayment.
 *   'minimum' Pays the minimum each month: interest accrues at the card's rate and the minimum is
 *             taken, recalculated each month on what is then owed.
 *   'fixed'   Pays a set amount each month: the amount entered (`repayments`).
 *   'unsure'  Not sure: treated as the minimum, and said to be an estimate.
 *
 * An older card with no answer is read as 'fixed' when a repayment was typed, else 'unsure'.
 *
 * THE MINIMUM. The greater of 2% of the closing balance or $25, and never more than is owed. This is
 * the rule of three of the four major banks for their standard personal cards:
 *   - CommBank: the greater of 2% of the closing balance or $25
 *     (commbank.com.au/articles/credit-cards/credit-card-minimum-repayment.html);
 *   - ANZ: 2% of the closing balance, or the lesser of $25 and the closing balance
 *     (ANZ credit cards key facts sheet);
 *   - NAB: 2% or $25, whichever is greater (nab.com.au/keyfactsheet);
 *   - Westpac: 2% or $10 today, moving to 2.5% or $25 from 30 November 2026
 *     (westpac.com.au/credit-cards/credit-card-changes.html).
 * Checked 26 Oct 2026.
 *
 * THE TYPICAL RATE, used when no rate is recorded: 20.99% a year, the RBA's average for standard
 * cards as quoted by Mozo and Finder in 2026 (mozo.com.au/credit-cards; finder.com.au "how much credit
 * card debt does the average Australian have"). Shown on the profile as typical, and editable.
 */ const $55a6490f14a54563$export$5099c7558e378636 = 2;
const $55a6490f14a54563$export$ce5bf72935d1586b = 25;
const $55a6490f14a54563$export$4f8392bee1006cb3 = 20.99;
function $55a6490f14a54563$export$b0f8a46bdf3c210d(liability, category) {
    return liability?.type === 'creditCards' || category === 'creditCards';
}
const $55a6490f14a54563$var$num = (v)=>{
    const n = typeof v === 'number' ? v : parseFloat(String(v ?? ''));
    return Number.isFinite(n) ? n : 0;
};
function $55a6490f14a54563$export$ee09c2c29b17798e(card) {
    const s = card.cardPaymentStyle;
    if (s === 'full' || s === 'minimum' || s === 'fixed' || s === 'unsure') return s;
    return $55a6490f14a54563$var$num(card.repayments) > 0 ? 'fixed' : 'unsure';
}
/** True when no rate is recorded at all — blank, not a typed 0 (an interest-free card is a real thing). */ const $55a6490f14a54563$var$rateIsBlank = (card)=>card.interestRate == null || String(card.interestRate).trim() === '' || !Number.isFinite(parseFloat(String(card.interestRate)));
function $55a6490f14a54563$export$134b96fa640de378(card) {
    return $55a6490f14a54563$export$ee09c2c29b17798e(card) !== 'full' && $55a6490f14a54563$var$rateIsBlank(card);
}
function $55a6490f14a54563$export$55bc0f912152ac52(card) {
    if ($55a6490f14a54563$export$ee09c2c29b17798e(card) === 'full') return 0;
    return $55a6490f14a54563$var$rateIsBlank(card) ? $55a6490f14a54563$export$4f8392bee1006cb3 : Math.max(0, $55a6490f14a54563$var$num(card.interestRate));
}
function $55a6490f14a54563$export$8dfb74eb158d4665(closingBalance) {
    if (!(closingBalance > 0)) return 0;
    return Math.min(closingBalance, Math.max(closingBalance * $55a6490f14a54563$export$5099c7558e378636 / 100, $55a6490f14a54563$export$ce5bf72935d1586b));
}
function $55a6490f14a54563$export$c0043d492522b6(card) {
    const amount = Math.max(0, $55a6490f14a54563$var$num(card.repayments));
    if (card.cardPaymentStyle != null) return amount;
    if (card.frequency === 'weekly') return amount * 52 / 12;
    if (card.frequency === 'fortnightly') return amount * 26 / 12;
    return amount;
}
function $55a6490f14a54563$export$d77d593f49b035db(card, owed) {
    const style = $55a6490f14a54563$export$ee09c2c29b17798e(card);
    if (style === 'full' || !(owed > 0)) return {
        interest: 0,
        payment: 0,
        closing: Math.max(0, owed)
    };
    const interest = owed * ($55a6490f14a54563$export$55bc0f912152ac52(card) / 100 / 12);
    const closingBeforePayment = owed + interest;
    const due = style === 'fixed' ? $55a6490f14a54563$export$c0043d492522b6(card) : $55a6490f14a54563$export$8dfb74eb158d4665(closingBeforePayment);
    const payment = Math.min(due, closingBeforePayment);
    return {
        interest: interest,
        payment: payment,
        closing: closingBeforePayment - payment
    };
}
function $55a6490f14a54563$export$cc7da59b25ca17e7(card, openingBalance, months = 12) {
    let owed = openingBalance;
    let paid = 0;
    let interestAccrued = 0;
    let firstPayment = 0;
    for(let m = 0; m < months && owed > 0; m++){
        const month = $55a6490f14a54563$export$d77d593f49b035db(card, owed);
        if (m === 0) firstPayment = month.payment;
        paid += month.payment;
        interestAccrued += month.interest;
        owed = month.closing;
    }
    return {
        paid: paid,
        interestAccrued: interestAccrued,
        closingBalance: owed,
        firstPayment: firstPayment
    };
}
function $55a6490f14a54563$export$eb26b844a1947c6e(card) {
    const style = $55a6490f14a54563$export$ee09c2c29b17798e(card);
    const balance = Math.max(0, $55a6490f14a54563$var$num(card.balance));
    if (style === 'full' || balance <= 0) return {
        style: style,
        monthlyPayment: 0,
        monthlyInterest: 0,
        grows: false,
        months: style === 'full' ? null : 0,
        totalInterest: 0
    };
    const first = $55a6490f14a54563$export$d77d593f49b035db(card, balance);
    if (first.payment <= first.interest + 0.005) return {
        style: style,
        monthlyPayment: first.payment,
        monthlyInterest: first.interest,
        grows: true,
        months: null,
        totalInterest: 0
    };
    let owed = balance;
    let totalInterest = 0;
    let months = 0;
    while(owed > 0.005 && months < 600){
        const m = $55a6490f14a54563$export$d77d593f49b035db(card, owed);
        totalInterest += m.interest;
        owed = m.closing;
        months++;
    }
    return {
        style: style,
        monthlyPayment: first.payment,
        monthlyInterest: first.interest,
        grows: false,
        months: owed > 0.005 ? null : months,
        totalInterest: totalInterest
    };
}
function $55a6490f14a54563$export$7d8ffbf26dcfd37b(liability, category) {
    if (!liability) return 0;
    if ($55a6490f14a54563$export$b0f8a46bdf3c210d(liability, category)) return $55a6490f14a54563$export$55bc0f912152ac52(liability);
    return $55a6490f14a54563$var$num(liability.interestRate);
}


const $66c36853b590c88a$var$LIQUID_ASSET_TYPES = new Set((0, $bfa4518c9dced417$export$e18ad1b53d14ba76).filter((t)=>t.isLiquid).map((t)=>t.id));
/**
 * The debt types whose repayment can be DERIVED, because they run to a term and amortise. A credit card
 * revolves and has no term, so there is nothing to derive from and the client's own payment is the only
 * honest figure.
 */ const $66c36853b590c88a$var$TERM_LOAN_TYPES = new Set([
    'mortgages',
    'personalLoans'
]);
function $66c36853b590c88a$export$b5ec401fafcd623d(liabilityType) {
    return $66c36853b590c88a$var$TERM_LOAN_TYPES.has(String(liabilityType ?? ''));
}
function $66c36853b590c88a$export$8bcb8e3cf0ba65ef(item) {
    return item.repaymentCalculation === 'auto' && (item.balance || 0) > 0 && (item.interestRate || 0) > 0 && (item.loanTerm || 0) > 0;
}
function $66c36853b590c88a$export$e10cf1ee911e064f(item) {
    if ((0, $eb5ee2a9aeb43da8$export$95d06fd31af89cb5)(item) || item.excludeFromCashflow === true) return 0;
    // A card is paid by how the profile says it is paid, month by month on what is owed (creditCards.ts).
    if ((0, $55a6490f14a54563$export$b0f8a46bdf3c210d)(item)) return (0, $55a6490f14a54563$export$cc7da59b25ca17e7)(item, item.balance || 0).paid;
    const balance = item.balance || 0;
    const rate = item.interestRate || 0;
    const term = item.loanTerm || 0;
    const freq = item.frequency || 'monthly';
    const loanType = item.loanType || 'pi';
    const periodicRepayment = $66c36853b590c88a$export$8bcb8e3cf0ba65ef(item) ? (0, $c9ee841cca8af175$export$1fcf7232357bf4d8)(balance, rate, term, freq, loanType) : item.repayments || 0;
    switch(freq){
        case 'weekly':
            return periodicRepayment * 52;
        case 'fortnightly':
            return periodicRepayment * 26;
        default:
            return periodicRepayment * 12;
    }
}
function $66c36853b590c88a$export$cdbab4fc15bcd079(liability, factFind) {
    if ((0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(liability.ownership)) {
        const id = (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(liability.ownership);
        return id && id !== '__unsure__' ? id : null;
    }
    if (liability.type !== 'mortgages') return null;
    if (liability.assetLink === 'home' || liability.assetLink === 'none') {
        if (factFind.home?.ownership === 'other_entity' && factFind.home?.entityId) return factFind.home.entityId;
        return null;
    }
    const prop = (factFind.assets?.investmentProperty || []).find((p)=>String(p.id) === String(liability.assetLink));
    if (prop && (0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(prop.ownership)) return (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(prop.ownership);
    return null;
}
function $66c36853b590c88a$export$ec9081b12e34149d(liability, factFind) {
    return $66c36853b590c88a$export$cdbab4fc15bcd079(liability, factFind) != null;
}
function $66c36853b590c88a$export$513b229c1d6f572a(typeId) {
    return $66c36853b590c88a$var$LIQUID_ASSET_TYPES.has(typeId);
}



const $834081b8d1820bea$var$FUNERAL_BOND_EXEMPT_LIMIT_PER_PERSON = 15000;
const $834081b8d1820bea$var$DEEMING_FINANCIAL_TYPES = new Set([
    'bankAccounts',
    'termDeposits',
    'shares',
    'investmentBonds',
    'accountBasedPensions',
    'loansToOthers'
]);
function $834081b8d1820bea$var$emptyPool() {
    return {
        assessableAssets: 0,
        assessableAssetsNoHome: 0,
        financialForDeeming: 0,
        liquidAssetsGross: 0,
        liabilitiesGross: 0,
        liabilitiesNoHome: 0,
        loanRepaymentsAnnual: 0,
        investmentPropertyRental: 0,
        assessableIncomeFromPensions: 0,
        funeralBondGross: 0,
        investmentIncomeCash: 0,
        rentalExpenses: 0,
        incomeItems: []
    };
}
function $834081b8d1820bea$var$getAssessableValue(type, asset) {
    const value = asset.value || 0;
    if (type === 'annuities' && asset.assessableAsset !== undefined) return asset.assessableAsset || 0;
    return value;
}
function $834081b8d1820bea$var$getMinimumPensionDrawdownRate(age) {
    if (!age) return 0;
    const bracket = (0, $1abe73eeef086faf$export$89d00d368c27d070).find((b)=>age <= b.age);
    return bracket ? bracket.rate : 0;
}
function $834081b8d1820bea$var$recordIncomeItem(pool, label, taxable, deductions, franking, cash) {
    pool.incomeItems.push({
        label: label,
        taxable: taxable,
        deductions: deductions,
        franking: franking,
        cash: cash
    });
    pool.investmentIncomeCash += cash;
    pool.rentalExpenses += deductions;
}
function $834081b8d1820bea$export$ee0c222516237885(factFind, options = {}) {
    const { isPartnered: isPartnered, clientAge: clientAge, partnerAge: partnerAge, strategyOptions: strategyOptions = {} } = options;
    const structures = factFind.structures || [];
    if (!structures.length) return null;
    const principalHomeExempt = (0, $8d8b97815ba787de$export$b960f612817c7255)(factFind, strategyOptions);
    const entityHomeEntityId = principalHomeExempt && factFind.home?.entityId ? factFind.home.entityId : null;
    const pools = {};
    structures.forEach((s)=>{
        pools[String(s.id)] = $834081b8d1820bea$var$emptyPool();
    });
    const addToPool = (entityId, fn)=>{
        if (!entityId || entityId === '__unsure__' || !pools[entityId]) return;
        fn(pools[entityId]);
    };
    Object.entries(factFind.assets || {}).forEach(([type, assetList])=>{
        (assetList || []).forEach((asset)=>{
            if (!(0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(asset.ownership)) return;
            const entityId = (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(asset.ownership);
            addToPool(entityId, (pool)=>{
                const value = asset.value || 0;
                const assessableValue = $834081b8d1820bea$var$getAssessableValue(type, asset);
                if (type === 'radPaid' || type === 'prepaidFuneral') return;
                if (type === 'funeralBonds') {
                    pool.funeralBondGross += value;
                    return;
                }
                const isPre2015ABP = type === 'accountBasedPensions' && asset.commencementDateOption === 'pre-2015';
                const isFinancialForDeeming = !isPre2015ABP && ($834081b8d1820bea$var$DEEMING_FINANCIAL_TYPES.has(type) || type === 'annuities' && asset.annuityType !== 'lifetime');
                if (isFinancialForDeeming) pool.financialForDeeming += value;
                if ((0, $66c36853b590c88a$export$513b229c1d6f572a)(type)) pool.liquidAssetsGross += value;
                if (type === 'investmentProperty') {
                    const rent = asset.rent || 0;
                    const expenses = asset.expenses || 0;
                    const netRental = Math.max(0, rent - expenses);
                    pool.investmentPropertyRental += netRental;
                    pool.assessableAssets += assessableValue;
                    pool.assessableAssetsNoHome += assessableValue;
                    $834081b8d1820bea$var$recordIncomeItem(pool, asset.description || 'Investment Property', rent, expenses, 0, rent);
                    return;
                }
                if (type === 'home') {
                    const skipPrincipalHome = principalHomeExempt && entityId === entityHomeEntityId;
                    if (!skipPrincipalHome && !strategyOptions.rentHome && !strategyOptions.downsizeHome) pool.assessableAssets += assessableValue;
                    return;
                }
                if (type !== 'funeralBonds') {
                    pool.assessableAssets += assessableValue;
                    pool.assessableAssetsNoHome += assessableValue;
                }
                if (type === 'shares') {
                    const dividend = value * ((asset.incomeRate || 0) / 100);
                    const frankingPercent = (asset.frankingCredit || 0) / 100;
                    const frankedAmount = dividend * frankingPercent;
                    const frankingCredit = frankedAmount * ((0, $1abe73eeef086faf$export$641e54d6b906f309) / (1 - (0, $1abe73eeef086faf$export$641e54d6b906f309)));
                    const taxable = dividend + frankingCredit;
                    $834081b8d1820bea$var$recordIncomeItem(pool, asset.description || 'Shares', taxable, 0, frankingCredit, dividend);
                } else if (type === 'bankAccounts') {
                    const rate = (asset.incomeRate || 0) / 100;
                    const interest = value * rate;
                    $834081b8d1820bea$var$recordIncomeItem(pool, asset.description || 'Bank Interest', interest, 0, 0, interest);
                } else if (type === 'termDeposits') {
                    const rate = (asset.incomeRate || 0) / 100;
                    const interest = value * rate;
                    const label = asset.description || 'Term Deposit';
                    $834081b8d1820bea$var$recordIncomeItem(pool, label, interest, 0, 0, interest);
                } else if (type === 'accountBasedPensions' && !isPre2015ABP) {
                    const ownerAge = clientAge || partnerAge || 65;
                    const minDrawdown = value * $834081b8d1820bea$var$getMinimumPensionDrawdownRate(ownerAge);
                    const payment = value > 0 ? asset.income || 0 : 0;
                    const cash = Math.max(payment, minDrawdown);
                    const taxable = ownerAge >= 60 ? 0 : cash;
                    $834081b8d1820bea$var$recordIncomeItem(pool, asset.description || 'ABP', taxable, 0, 0, cash);
                } else if (type === 'annuities' || type === 'other') {
                    let cash;
                    let taxable;
                    if (type === 'annuities') {
                        cash = asset.annualPayment || 0;
                        taxable = asset.assessableIncome || cash;
                    } else {
                        const rate = asset.income ? asset.income / value : 0;
                        cash = value * rate;
                        taxable = cash;
                    }
                    $834081b8d1820bea$var$recordIncomeItem(pool, asset.description || type, taxable, 0, 0, cash);
                }
            });
        });
    });
    const home = factFind.home || {};
    const homeValue = home.value || 0;
    if (homeValue > 0 && home.ownership === 'other_entity' && home.entityId) addToPool(home.entityId, (pool)=>{
        if (!(principalHomeExempt && home.entityId === entityHomeEntityId)) pool.assessableAssets += homeValue;
    });
    Object.values(factFind.liabilities || {}).forEach((list)=>{
        (list || []).forEach((liability)=>{
            const entityId = (0, $66c36853b590c88a$export$cdbab4fc15bcd079)(liability, factFind);
            if (!entityId) return;
            const balance = liability.balance || 0;
            addToPool(entityId, (pool)=>{
                pool.liabilitiesGross += balance;
                pool.loanRepaymentsAnnual += (0, $66c36853b590c88a$export$e10cf1ee911e064f)(liability);
                const securedOnHome = liability.type === 'mortgages' && (liability.assetLink === 'home' || factFind.home?.ownership === 'other_entity' && factFind.home?.entityId === entityId && !liability.assetLink);
                if (!securedOnHome) pool.liabilitiesNoHome += balance;
                if (liability.type === 'mortgages' && liability.assetLink && liability.assetLink !== 'home') {
                    const prop = factFind.assets?.investmentProperty?.find((p)=>String(p.id) === String(liability.assetLink));
                    const rate = liability.interestRate || 0;
                    const interest = balance * (rate / 100 || 0);
                    if (prop && interest > 0) $834081b8d1820bea$var$recordIncomeItem(pool, `Loan Interest (${prop.description || 'property'})`, 0, interest, 0, 0);
                }
            });
        });
    });
    const funeralBondExemptLimit = isPartnered ? $834081b8d1820bea$var$FUNERAL_BOND_EXEMPT_LIMIT_PER_PERSON * 2 : $834081b8d1820bea$var$FUNERAL_BOND_EXEMPT_LIMIT_PER_PERSON;
    const result = {
        assessableAssets: 0,
        assessableAssetsNoHome: 0,
        financialAssetsForDeeming: 0,
        investmentPropertyRentalForPension: 0,
        partnerInvestmentPropertyRentalForPension: 0,
        clientDistributionMeansTestIncome: 0,
        partnerDistributionMeansTestIncome: 0,
        assessableIncomeFromPensions: 0,
        partnerAssessableIncomeFromPensions: 0,
        investmentIncomeCash: 0,
        entityPrincipalHomeExempt: principalHomeExempt,
        rentalExpenses: 0,
        loanRepaymentsAnnual: 0,
        applicantsLiquidAssets: 0,
        clientTax: {
            investmentSources: [],
            deductionSources: [],
            frankingCredits: 0
        },
        partnerTax: {
            investmentSources: [],
            deductionSources: [],
            frankingCredits: 0
        },
        structureLines: []
    };
    let funeralBondExemptUsed = 0;
    structures.forEach((structure)=>{
        const combinedPct = (0, $1773fcf9595c5c0a$export$b93377b4473f408b)(structure, !!isPartnered);
        if (combinedPct <= 0) return;
        const clientPct = Math.min(100, Math.max(0, structure.apportionmentClient || 0));
        const partnerPct = isPartnered ? Math.min(100, Math.max(0, structure.apportionmentPartner || 0)) : 0;
        const pool = pools[String(structure.id)] || $834081b8d1820bea$var$emptyPool();
        const structureName = structure.name?.trim() || 'Trust/company';
        let assessable = Math.max(0, pool.assessableAssets - pool.liabilitiesGross);
        let assessableNoHome = Math.max(0, pool.assessableAssetsNoHome - pool.liabilitiesNoHome);
        if (pool.funeralBondGross > 0) {
            const remainingExempt = Math.max(0, funeralBondExemptLimit - funeralBondExemptUsed);
            const exemptPortion = Math.min(pool.funeralBondGross, remainingExempt);
            const assessableFuneral = Math.max(0, pool.funeralBondGross - exemptPortion);
            funeralBondExemptUsed += exemptPortion;
            assessable += assessableFuneral;
            assessableNoHome += assessableFuneral;
        }
        const clientShare = (pct)=>(amount)=>amount * (pct / 100);
        const clientAssets = clientShare(clientPct)(assessable);
        const partnerAssets = clientShare(partnerPct)(assessable);
        const clientAssetsNoHome = clientShare(clientPct)(assessableNoHome);
        const partnerAssetsNoHome = clientShare(partnerPct)(assessableNoHome);
        const clientFinancial = clientShare(clientPct)(pool.financialForDeeming);
        const partnerFinancial = clientShare(partnerPct)(pool.financialForDeeming);
        const distributionOverride = structure.annualDistributionPa || 0;
        const useDistForMeansTest = distributionOverride > 0 && combinedPct > 0 && structure.useDistributionForMeansTest !== false;
        const clientRental = useDistForMeansTest ? 0 : clientShare(clientPct)(pool.investmentPropertyRental);
        const partnerRental = useDistForMeansTest ? 0 : clientShare(partnerPct)(pool.investmentPropertyRental);
        const clientPensionInc = clientShare(clientPct)(pool.assessableIncomeFromPensions);
        const partnerPensionInc = clientShare(partnerPct)(pool.assessableIncomeFromPensions);
        result.assessableAssets += clientAssets + partnerAssets;
        result.assessableAssetsNoHome += clientAssetsNoHome + partnerAssetsNoHome;
        result.financialAssetsForDeeming += clientFinancial + partnerFinancial;
        result.investmentPropertyRentalForPension += clientRental;
        result.partnerInvestmentPropertyRentalForPension += partnerRental;
        result.assessableIncomeFromPensions += clientPensionInc;
        result.partnerAssessableIncomeFromPensions += partnerPensionInc;
        if (distributionOverride > 0 && combinedPct > 0) {
            const clientDist = distributionOverride * (clientPct / combinedPct);
            const partnerDist = distributionOverride * (partnerPct / combinedPct);
            result.investmentIncomeCash += clientDist + partnerDist;
            if (useDistForMeansTest) {
                result.clientDistributionMeansTestIncome += clientDist;
                result.partnerDistributionMeansTestIncome += partnerDist;
            }
        } else {
            result.investmentIncomeCash += clientShare(clientPct)(pool.investmentIncomeCash);
            result.investmentIncomeCash += clientShare(partnerPct)(pool.investmentIncomeCash);
            result.rentalExpenses += clientShare(clientPct)(pool.rentalExpenses);
            result.rentalExpenses += clientShare(partnerPct)(pool.rentalExpenses);
        }
        result.loanRepaymentsAnnual += clientShare(clientPct)(pool.loanRepaymentsAnnual);
        result.loanRepaymentsAnnual += clientShare(partnerPct)(pool.loanRepaymentsAnnual);
        const netLiquid = Math.max(0, pool.liquidAssetsGross - pool.liabilitiesGross);
        result.applicantsLiquidAssets += clientShare(clientPct)(netLiquid);
        result.applicantsLiquidAssets += clientShare(partnerPct)(netLiquid);
        const applyIncomeToPerson = (personTax, pct)=>{
            pool.incomeItems.forEach((item)=>{
                const share = item.taxable * (pct / 100);
                const dedShare = item.deductions * (pct / 100);
                const frankShare = item.franking * (pct / 100);
                if (share > 0) personTax.investmentSources.push({
                    name: `${item.label} (${structureName})`,
                    amount: share
                });
                if (dedShare > 0) personTax.deductionSources.push({
                    name: `${item.label} Expenses (${structureName})`,
                    amount: dedShare
                });
                personTax.frankingCredits += frankShare;
            });
        };
        applyIncomeToPerson(result.clientTax, clientPct);
        if (isPartnered) applyIncomeToPerson(result.partnerTax, partnerPct);
        if (clientAssets + partnerAssets > 0 || pool.liabilitiesGross > 0) result.structureLines.push({
            label: `  - ${structureName} (apportioned net assets)`,
            clientAmount: clientAssets,
            partnerAmount: partnerAssets
        });
    });
    const hasAny = result.assessableAssets > 0 || result.financialAssetsForDeeming > 0 || result.investmentIncomeCash > 0 || result.investmentPropertyRentalForPension > 0 || result.loanRepaymentsAnnual > 0;
    return hasAny || result.clientTax.investmentSources.length > 0 ? result : null;
}
function $834081b8d1820bea$export$e498786b37b83f3f(ownership) {
    return (0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(ownership);
}


/**
 * annuityStrategies.ts
 * Centralises all calculations related to annuity-based strategies.
 * Ported verbatim from frontend/src/calculations/AnnuityStrategies.js.
 */ 
/**
 * ANNUITY PRICES — read from the published rate sheet, never invented.
 *
 * THE FAULT THIS REPLACES (25 September 2026). Annuity income came from a base rate plus a flat age
 * step, invented in code. Checked against Challenger's published adviser sheet it paid roughly HALF
 * the market at every age and in every shape: 4.80% where the sheet said 8.30% at 65, 5.80% where
 * the sheet said 10.49% at 75. Because annuity income feeds the estate, the cashflow and the means
 * test, that understatement flowed into every module and made the suggestion engine rank annuity
 * strategies worse than they deserve. Three separate things were wrong — the base was too low, the
 * age step was flat when the real one accelerates, and the cost of CPI indexation was set at 0.60
 * percentage points when the sheet's own gap is 1.49 to 1.81.
 *
 * WHAT CHANGED. Rates are now DATA. `annuityRates.generated.ts` holds the published sheet, imported
 * by `scripts/import-annuity-rates.mjs`; this file is the only thing that reads it, and it does not
 * invent anything the sheet does not say. Where the sheet stops, it says so rather than guessing
 * quietly: every answer carries `extrapolated`, and the screens print a note when it is true.
 *
 * WHICH COLUMN IS WHICH SHAPE. The sheet prices two liquidity options, and they are exactly our two
 * client-facing choices:
 *   Enhanced  — no death benefit, no withdrawal value, highest income. Our "nil residual".
 *   Flexible  — a withdrawal period and a death benefit on the capital access schedule, less income.
 *               Our "capital returned".
 * The guaranteed shape (the whole amount to the estate whenever you die) is neither: it is an
 * annuity bought together with a life policy, and the sheet prices it as one product, so it has its
 * own table and its own function here.
 *
 * WHAT THE SHEET DOES NOT PUBLISH. Lifetime rates stop at age 75. Above that we extrapolate from the
 * 70-to-75 slope and flag it. That errs LOW: the one real data point we have above 75 (the annuity
 * inside the guaranteed product, from Challenger's own calculator) prices an 85-year-old man's
 * annuity slice near 19.9%, where this extrapolation gives about 13.1%. Erring low understates the
 * annuity rather than flattering it, which is the safe direction, but the actuary should look at it.
 */ /**
 * GENERATED FILE - DO NOT EDIT BY HAND.
 *
 * Challenger's published adviser rate sheet, turned into data by `scripts/import-annuity-rates.mjs`.
 * To update: save the new sheet over `docs/reference/cll_rates.pdf`, run `npm run rates:import`,
 * run `npm run test:shared`, and commit. Any hand edit here is lost on the next import.
 *
 * WHAT THE NUMBERS ARE.
 *   lifetime.<indexation>.<sex>[age] = [Flexible, Enhanced] yearly payment per $100,000 invested.
 *       Flexible carries a withdrawal period and a death benefit (our "capital returned" shape);
 *       Enhanced carries neither and pays more (our "nil residual" shape).
 *   lifetime.<indexation>.reversionary = the same, for a couple where the income continues to the
 *       survivor. Keyed by the age PAIR the sheet quotes, not by a single age.
 *   carePlus.<sex>[age] = yearly payment per $100,000 of TOTAL money invested, before any adviser
 *       fee, for the annuity-plus-insurance shape that guarantees the whole amount to the estate.
 *   fixedTerm.rcv100 / rcv0 [term] = the earning rate as a PERCENT a year, by payment frequency.
 *
 * Ages the sheet publishes: 60 to 75 for the lifetime shapes, 70 to 100 for the guaranteed shape.
 * `annuityRates.ts` interpolates between them and flags anything it has to extrapolate.
 */ const $f382c0c03e85e697$export$715b59b6902993f9 = {
    "source": "Challenger Rates (adviser): Liquid Lifetime, CarePlus, Fixed Term",
    "sourceFile": "cll_rates.pdf",
    "effectiveFrom": "2026-09-21",
    "effectiveTo": "2026-09-27",
    "importedAt": "2026-09-25",
    "lifetime": {
        "noIndexation": {
            "male": {
                "60": [
                    7259,
                    7695
                ],
                "65": [
                    7694,
                    8297
                ],
                "70": [
                    8331,
                    9173
                ],
                "75": [
                    9324,
                    10492
                ]
            },
            "female": {
                "60": [
                    7084,
                    7341
                ],
                "65": [
                    7473,
                    7820
                ],
                "70": [
                    8023,
                    8541
                ],
                "75": [
                    8863,
                    9681
                ]
            },
            "reversionary": [
                {
                    "maleAge": 65,
                    "femaleAge": 60,
                    "flexible": 7060,
                    "enhanced": 7079
                },
                {
                    "maleAge": 65,
                    "femaleAge": 65,
                    "flexible": 7290,
                    "enhanced": 7324
                },
                {
                    "maleAge": 70,
                    "femaleAge": 65,
                    "flexible": 7456,
                    "enhanced": 7485
                },
                {
                    "maleAge": 70,
                    "femaleAge": 70,
                    "flexible": 7797,
                    "enhanced": 7853
                }
            ]
        },
        "cpi": {
            "male": {
                "60": [
                    5548,
                    5881
                ],
                "65": [
                    6061,
                    6537
                ],
                "70": [
                    6775,
                    7460
                ],
                "75": [
                    7833,
                    8815
                ]
            },
            "female": {
                "60": [
                    5329,
                    5522
                ],
                "65": [
                    5794,
                    6063
                ],
                "70": [
                    6428,
                    6843
                ],
                "75": [
                    7352,
                    8030
                ]
            },
            "reversionary": [
                {
                    "maleAge": 65,
                    "femaleAge": 60,
                    "flexible": 5261,
                    "enhanced": 5275
                },
                {
                    "maleAge": 65,
                    "femaleAge": 65,
                    "flexible": 5545,
                    "enhanced": 5570
                },
                {
                    "maleAge": 70,
                    "femaleAge": 65,
                    "flexible": 5729,
                    "enhanced": 5751
                },
                {
                    "maleAge": 70,
                    "femaleAge": 70,
                    "flexible": 6129,
                    "enhanced": 6172
                }
            ]
        }
    },
    "carePlus": {
        "male": {
            "70": 5790,
            "75": 5793,
            "80": 5805,
            "85": 5825,
            "90": 5849,
            "95": 5877,
            "100": 5907
        },
        "female": {
            "70": 5813,
            "75": 5801,
            "80": 5792,
            "85": 5791,
            "90": 5800,
            "95": 5819,
            "100": 5857
        }
    },
    "fixedTerm": {
        "rcv100": {
            "1": {
                "monthly": 5.46,
                "yearly": null
            },
            "2": {
                "monthly": 5.65,
                "yearly": 5.8
            },
            "3": {
                "monthly": 5.79,
                "yearly": 5.95
            },
            "4": {
                "monthly": 5.79,
                "yearly": 5.95
            },
            "5": {
                "monthly": 5.79,
                "yearly": 5.95
            },
            "6": {
                "monthly": 5.84,
                "yearly": 6
            },
            "10": {
                "monthly": 5.98,
                "yearly": 6.15
            },
            "15": {
                "monthly": 6.08,
                "yearly": 6.25
            },
            "20": {
                "monthly": 6.13,
                "yearly": 6.3
            }
        },
        "rcv0": {
            "1": {
                "monthly": 5.22,
                "yearly": null
            },
            "2": {
                "monthly": 5.46,
                "yearly": 5.6
            },
            "3": {
                "monthly": 5.65,
                "yearly": 5.8
            },
            "4": {
                "monthly": 5.79,
                "yearly": 5.95
            },
            "5": {
                "monthly": 5.79,
                "yearly": 5.95
            },
            "6": {
                "monthly": 5.79,
                "yearly": 5.95
            },
            "10": {
                "monthly": 5.89,
                "yearly": 6.05
            },
            "15": {
                "monthly": 5.98,
                "yearly": 6.15
            },
            "20": {
                "monthly": 6.03,
                "yearly": 6.2
            }
        }
    }
};


const $d697a0cc78e06dde$export$f5eecd14f41f6e98 = 14;
function $d697a0cc78e06dde$export$dd575ab7aedb8603(today = new Date()) {
    const from = (0, $f382c0c03e85e697$export$715b59b6902993f9).effectiveFrom;
    const ageInDays = Math.max(0, Math.round((today.getTime() - new Date(from + 'T00:00:00Z').getTime()) / 86400000));
    return {
        source: (0, $f382c0c03e85e697$export$715b59b6902993f9).source,
        effectiveFrom: from,
        effectiveTo: (0, $f382c0c03e85e697$export$715b59b6902993f9).effectiveTo,
        importedAt: (0, $f382c0c03e85e697$export$715b59b6902993f9).importedAt,
        ageInDays: ageInDays,
        stale: ageInDays > $d697a0cc78e06dde$export$f5eecd14f41f6e98,
        label: `the published rates for the week of ${$d697a0cc78e06dde$var$formatSheetDate(from)}`
    };
}
function $d697a0cc78e06dde$var$formatSheetDate(iso) {
    const d = new Date(iso + 'T00:00:00Z');
    if (Number.isNaN(d.getTime())) return iso;
    const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];
    return `${d.getUTCDate()} ${months[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}
/**
 * Read `table` at `key`, interpolating between the keys it has. Outside the published range it
 * carries the nearest segment's slope onward and says so, rather than clamping — a clamp would
 * silently price an 88-year-old as if he were 75.
 */ function $d697a0cc78e06dde$var$interpolate(table, key) {
    const keys = Object.keys(table).map(Number).sort((a, b)=>a - b);
    // Every key below is read from the table itself, so a miss is a bug, not a missing age; the
    // checked lookup says so loudly rather than letting an undefined turn into NaN downstream.
    const at = (k)=>{
        const v = table[String(k)];
        if (v === undefined) throw new Error(`annuity rate table has no entry for ${k}`);
        return v;
    };
    const keyAt = (i)=>{
        const k = keys[i];
        if (k === undefined) throw new Error(`annuity rate table index ${i} out of range`);
        return k;
    };
    if (keys.length === 0) return {
        value: 0,
        extrapolated: true
    };
    if (keys.length === 1) return {
        value: at(keyAt(0)),
        extrapolated: keyAt(0) !== key
    };
    const exact = table[String(key)];
    if (exact !== undefined) return {
        value: exact,
        extrapolated: false
    };
    const first = keyAt(0);
    const last = keyAt(keys.length - 1);
    const segment = (lo, hi, extrapolated)=>{
        const vLo = at(lo);
        const vHi = at(hi);
        const t = (key - lo) / (hi - lo);
        return {
            value: vLo + (vHi - vLo) * t,
            extrapolated: extrapolated
        };
    };
    if (key < first) return segment(keyAt(0), keyAt(1), true);
    if (key > last) return segment(keyAt(keys.length - 2), last, true);
    for(let i = 1; i < keys.length; i++){
        if (key <= keyAt(i)) return segment(keyAt(i - 1), keyAt(i), false);
    }
    return {
        value: at(last),
        extrapolated: true
    };
}
/** Pull one liquidity option out of a [Flexible, Enhanced] block into a plain age → dollars map. */ function $d697a0cc78e06dde$var$optionTable(block, option) {
    const out = {};
    for (const [age, pair] of Object.entries(block))out[age] = pair[option];
    return out;
}
/**
 * The sex to price against when the fact-find does not record one.
 *
 * FEMALE, deliberately, and note this is the OPPOSITE default to `lifeExpectancyAt`, which reads an
 * unknown sex as male. Each default is the cautious direction for its own job. A woman's longer life
 * expectancy buys her a LOWER annuity payment at the same age, so pricing an unknown client as
 * female never overstates the income a strategy would produce. The life table's default runs the
 * other way because there a SHORTER expectancy is the cautious answer: it keeps the capital access
 * schedule inside what the rules allow.
 */ function $d697a0cc78e06dde$var$priceAs(sex) {
    return sex === 'male' ? 'male' : 'female';
}
function $d697a0cc78e06dde$export$9ad772f55a285440(query) {
    const { age: age, sex: sex, indexation: indexation = false, residualCapital: residualCapital = 0, partnerAge: partnerAge = null } = query;
    const block = indexation ? (0, $f382c0c03e85e697$export$715b59b6902993f9).lifetime.cpi : (0, $f382c0c03e85e697$export$715b59b6902993f9).lifetime.noIndexation;
    const sexKey = $d697a0cc78e06dde$var$priceAs(sex);
    const table = block[sexKey];
    const residual = Math.min(1, Math.max(0, residualCapital || 0));
    const enhanced = $d697a0cc78e06dde$var$interpolate($d697a0cc78e06dde$var$optionTable(table, 1), age);
    const flexible = $d697a0cc78e06dde$var$interpolate($d697a0cc78e06dde$var$optionTable(table, 0), age);
    // Per $100,000, blended between the two published shapes, then expressed as a fraction.
    const perHundredThousand = enhanced.value + (flexible.value - enhanced.value) * residual;
    let rate = perHundredThousand / 100000;
    let extrapolated = enhanced.extrapolated || flexible.extrapolated;
    if (partnerAge != null && partnerAge > 0) {
        const joint = $d697a0cc78e06dde$var$reversionaryRate(block.reversionary, age, partnerAge, residual);
        if (joint) {
            rate = joint.value / 100000;
            extrapolated = extrapolated || joint.extrapolated;
        }
    }
    const sheet = $d697a0cc78e06dde$export$dd575ab7aedb8603();
    const shape = residual >= 0.999 ? 'with the full amount back' : residual <= 0.001 ? 'with nothing back' : `with ${Math.round(residual * 100)}% back`;
    const basis = extrapolated ? `Estimated from ${sheet.label}, which stop at age 75. A quote will differ.` : `From ${sheet.label}, for a lifetime annuity ${shape}${indexation ? ', indexed to prices' : ''}.`;
    return {
        rate: $d697a0cc78e06dde$var$clampRate(rate),
        extrapolated: extrapolated,
        basis: basis
    };
}
/**
 * What a reversionary annuity pays, where the income continues to the survivor.
 *
 * The sheet quotes these against AGE PAIRS rather than single ages — M65/F60, M65/F65, M70/F65 and
 * M70/F70 — so they cannot be looked up the way the single-life tables can. The four pairs are
 * monotonic in the AVERAGE of the two ages (62.5, 65, 67.5 and 70), which is what you would expect,
 * since a reversionary annuity is priced on how long at least one of the two will live. So we key
 * the table on that average and read it directly. Using all four published pairs beats deriving a
 * discount from the two same-age ones, and it gets the direction right: a younger partner means the
 * income runs longer and therefore pays LESS, which the sheet's own M65/F60 row confirms.
 *
 * This replaces the flat 0.4-percentage-point joint discount the code used to apply, which happened
 * to be about right at 65 and too small by half at 70.
 */ function $d697a0cc78e06dde$var$reversionaryRate(reversionary, age, partnerAge, residual) {
    const byAverageAge = {};
    for (const row of reversionary){
        const average = (row.maleAge + row.femaleAge) / 2;
        byAverageAge[String(average)] = row.enhanced + (row.flexible - row.enhanced) * residual;
    }
    if (Object.keys(byAverageAge).length < 2) return null;
    return $d697a0cc78e06dde$var$interpolate(byAverageAge, (age + partnerAge) / 2);
}
function $d697a0cc78e06dde$export$841b99c047c4e0d(query) {
    const sexKey = $d697a0cc78e06dde$var$priceAs(query.sex);
    const table = (0, $f382c0c03e85e697$export$715b59b6902993f9).carePlus[sexKey];
    const found = $d697a0cc78e06dde$var$interpolate(table, query.age);
    const sheet = $d697a0cc78e06dde$export$dd575ab7aedb8603();
    return {
        rate: $d697a0cc78e06dde$var$clampRate(found.value / 100000),
        extrapolated: found.extrapolated,
        basis: found.extrapolated ? `Estimated from ${sheet.label}, which cover ages 70 to 100. A quote will differ.` : `From ${sheet.label}, before any adviser fee.`
    };
}
function $d697a0cc78e06dde$export$5fbe270ae518244(query) {
    const residual = Math.min(1, Math.max(0, query.residualCapital || 0));
    const term = Math.max(1, query.termYears || 1);
    const yearlyOnly = (rows)=>{
        const out = {};
        for (const key of Object.keys(rows)){
            // The one-year term has no yearly-payment rate published; its monthly rate is the closest
            // thing the sheet offers and is the more conservative of the two.
            const row = rows[key];
            const value = row ? row.yearly ?? row.monthly : null;
            if (value != null) out[key] = value;
        }
        return out;
    };
    const rcv0 = $d697a0cc78e06dde$var$interpolate(yearlyOnly((0, $f382c0c03e85e697$export$715b59b6902993f9).fixedTerm.rcv0), term);
    const rcv100 = $d697a0cc78e06dde$var$interpolate(yearlyOnly((0, $f382c0c03e85e697$export$715b59b6902993f9).fixedTerm.rcv100), term);
    const percent = rcv0.value + (rcv100.value - rcv0.value) * residual;
    const sheet = $d697a0cc78e06dde$export$dd575ab7aedb8603();
    const extrapolated = rcv0.extrapolated || rcv100.extrapolated;
    return {
        rate: $d697a0cc78e06dde$var$clampRate(percent / 100),
        extrapolated: extrapolated,
        basis: extrapolated ? `Estimated from ${sheet.label}, which cover terms of 1 to 20 years. A quote will differ.` : `From ${sheet.label}, for a ${Math.round(term)}-year term.`
    };
}
/**
 * The last line of defence. Nothing the sheet publishes comes close to these bounds, so this only
 * ever catches an extrapolation that has run away or a mis-imported table that slipped the
 * importer's own checks.
 */ function $d697a0cc78e06dde$var$clampRate(rate) {
    if (!Number.isFinite(rate)) return 0.05;
    return Math.min(0.25, Math.max(0.02, rate));
}


/**
 * THE GUARANTEED SHAPE'S TWO HALVES, and who is offered it.
 *
 * "The full amount to your family, whenever you die" is not one annuity but two products bought
 * together: a lifetime annuity whose own death benefit runs down on the capital access schedule, and
 * a life policy that pays whatever the annuity would not. The pair is priced as one, so the INCOME
 * can be read off the published rate sheet (`annuityRates.ts`); the MEANS TEST cannot, because the
 * two halves are counted differently and only the provider prices how a client's money divides
 * between them. Challenger's own calculator carries that division for every age and sex, and
 * `constants/carePlusSplit.generated.ts` is that table, imported by `scripts/import-careplus-split.py`.
 *
 * THE FAULT THIS CLOSES (27 Sep 2026, owner-caught). The app showed the guaranteed shape as a card,
 * priced its income, and then modelled nothing: the figures beneath the card were for a different
 * shape, and nothing reached the projection. That was worse than not showing it. Before 25 Sep it
 * had modelled "100% back for life" on a plain annuity, which is a product nobody sells; this is
 * the product that actually does it, modelled from the provider's own numbers.
 */ /**
 * GENERATED FILE - DO NOT EDIT BY HAND.
 *
 * How a client's money divides between the two halves of the guaranteed annuity shape, read out of
 * Challenger's aged care calculator by `scripts/import-careplus-split.py`. To update: save a newer
 * calculator over `docs/reference/aged_care_calculator.xlsm`, run the script, run
 * `npm run test:shared`, commit. Any hand edit here is lost on the next import.
 *
 * WHAT THE NUMBERS ARE. For each age and sex, the SHARE of the total invested that buys the life
 * policy (`insurance`) and the share that buys the lifetime annuity (`annuity`). They sum to 1. The
 * nil adviser fee column only. The insurance share rises with age because an older client's annuity
 * slice returns less, so more policy is needed to guarantee the same amount.
 *
 * WHY IT MATTERS. The two halves are means-tested differently: the annuity slice at 60% then 30% of
 * its price, the insurance slice at the greater of the premium paid and its surrender value. Without
 * this split the guaranteed shape cannot be modelled at all, only displayed.
 *
 * Source workbook valid to 2026-09-27. Imported 2026-09-27.
 */ const $cdca3d06cbe28cd4$export$dba5d249bd0810fd = {
    source: 'aged_care_calculator.xlsm',
    validTo: "2026-09-27",
    importedAt: '2026-09-27',
    male: {
        64: {
            insurance: 0.388817,
            annuity: 0.611183
        },
        65: {
            insurance: 0.401169,
            annuity: 0.598831
        },
        66: {
            insurance: 0.414398,
            annuity: 0.585602
        },
        67: {
            insurance: 0.428604,
            annuity: 0.571396
        },
        68: {
            insurance: 0.443855,
            annuity: 0.556145
        },
        69: {
            insurance: 0.445541,
            annuity: 0.554459
        },
        70: {
            insurance: 0.462189,
            annuity: 0.537811
        },
        71: {
            insurance: 0.480045,
            annuity: 0.519955
        },
        72: {
            insurance: 0.499123,
            annuity: 0.500877
        },
        73: {
            insurance: 0.501533,
            annuity: 0.498467
        },
        74: {
            insurance: 0.521805,
            annuity: 0.478195
        },
        75: {
            insurance: 0.543186,
            annuity: 0.456814
        },
        76: {
            insurance: 0.565762,
            annuity: 0.434238
        },
        77: {
            insurance: 0.567768,
            annuity: 0.432232
        },
        78: {
            insurance: 0.591599,
            annuity: 0.408402
        },
        79: {
            insurance: 0.616852,
            annuity: 0.383148
        },
        80: {
            insurance: 0.618637,
            annuity: 0.381363
        },
        81: {
            insurance: 0.645397,
            annuity: 0.354603
        },
        82: {
            insurance: 0.647057,
            annuity: 0.352943
        },
        83: {
            insurance: 0.675442,
            annuity: 0.324558
        },
        84: {
            insurance: 0.677033,
            annuity: 0.322968
        },
        85: {
            insurance: 0.707085,
            annuity: 0.292915
        },
        86: {
            insurance: 0.708660,
            annuity: 0.291340
        },
        87: {
            insurance: 0.740326,
            annuity: 0.259674
        },
        88: {
            insurance: 0.741951,
            annuity: 0.258049
        },
        89: {
            insurance: 0.774986,
            annuity: 0.225014
        },
        90: {
            insurance: 0.776714,
            annuity: 0.223286
        },
        91: {
            insurance: 0.778324,
            annuity: 0.221676
        },
        92: {
            insurance: 0.812477,
            annuity: 0.187523
        },
        93: {
            insurance: 0.814243,
            annuity: 0.185757
        },
        94: {
            insurance: 0.815899,
            annuity: 0.184101
        },
        95: {
            insurance: 0.817459,
            annuity: 0.182541
        },
        96: {
            insurance: 0.852078,
            annuity: 0.147923
        },
        97: {
            insurance: 0.853828,
            annuity: 0.146172
        },
        98: {
            insurance: 0.855484,
            annuity: 0.144516
        },
        99: {
            insurance: 0.857067,
            annuity: 0.142933
        },
        100: {
            insurance: 0.858563,
            annuity: 0.141437
        }
    },
    female: {
        64: {
            insurance: 0.323971,
            annuity: 0.676029
        },
        65: {
            insurance: 0.335558,
            annuity: 0.664442
        },
        66: {
            insurance: 0.338192,
            annuity: 0.661808
        },
        67: {
            insurance: 0.350929,
            annuity: 0.649071
        },
        68: {
            insurance: 0.364563,
            annuity: 0.635437
        },
        69: {
            insurance: 0.379150,
            annuity: 0.620850
        },
        70: {
            insurance: 0.394718,
            annuity: 0.605282
        },
        71: {
            insurance: 0.411324,
            annuity: 0.588677
        },
        72: {
            insurance: 0.428932,
            annuity: 0.571068
        },
        73: {
            insurance: 0.433342,
            annuity: 0.566658
        },
        74: {
            insurance: 0.451988,
            annuity: 0.548012
        },
        75: {
            insurance: 0.471516,
            annuity: 0.528484
        },
        76: {
            insurance: 0.491936,
            annuity: 0.508064
        },
        77: {
            insurance: 0.513317,
            annuity: 0.486683
        },
        78: {
            insurance: 0.517460,
            annuity: 0.482540
        },
        79: {
            insurance: 0.539902,
            annuity: 0.460098
        },
        80: {
            insurance: 0.563412,
            annuity: 0.436588
        },
        81: {
            insurance: 0.567375,
            annuity: 0.432625
        },
        82: {
            insurance: 0.592083,
            annuity: 0.407917
        },
        83: {
            insurance: 0.617950,
            annuity: 0.382050
        },
        84: {
            insurance: 0.621864,
            annuity: 0.378136
        },
        85: {
            insurance: 0.649014,
            annuity: 0.350987
        },
        86: {
            insurance: 0.652821,
            annuity: 0.347179
        },
        87: {
            insurance: 0.681274,
            annuity: 0.318726
        },
        88: {
            insurance: 0.710674,
            annuity: 0.289326
        },
        89: {
            insurance: 0.714733,
            annuity: 0.285267
        },
        90: {
            insurance: 0.718556,
            annuity: 0.281444
        },
        91: {
            insurance: 0.749294,
            annuity: 0.250706
        },
        92: {
            insurance: 0.753277,
            annuity: 0.246723
        },
        93: {
            insurance: 0.757126,
            annuity: 0.242874
        },
        94: {
            insurance: 0.788994,
            annuity: 0.211006
        },
        95: {
            insurance: 0.793285,
            annuity: 0.206715
        },
        96: {
            insurance: 0.797611,
            annuity: 0.202389
        },
        97: {
            insurance: 0.830406,
            annuity: 0.169594
        },
        98: {
            insurance: 0.835220,
            annuity: 0.164780
        },
        99: {
            insurance: 0.839663,
            annuity: 0.160337
        },
        100: {
            insurance: 0.843662,
            annuity: 0.156338
        }
    }
};


function $d08210caeacdc75a$export$3568d8429413a44e(age, sex) {
    /*
     * AN UNKNOWN SEX READS AS MALE HERE — the OPPOSITE of the rate table's default, and I first wrote
     * it the wrong way round (27 Sep 2026, caught the same day while explaining the figure to the
     * owner). The principle is the same everywhere: an unrecorded sex must never flatter the
     * strategy. For the RATE that means female, because a woman's payment is lower and so the income
     * benefit is understated. For the SPLIT it means male, because a man's insurance share is the
     * HIGHER one at every age, so more of the money is counted at cost, assessed assets are higher,
     * and the pension benefit is understated. Reading an unknown client as female here did the
     * reverse: it counted less, lifted the pension, and overstated what the guarantee buys.
     */ const table = sex === 'female' ? (0, $cdca3d06cbe28cd4$export$dba5d249bd0810fd).female : (0, $cdca3d06cbe28cd4$export$dba5d249bd0810fd).male;
    const ages = Object.keys(table).map(Number).sort((a, b)=>a - b);
    // Every age below is read from the table itself (or clamped into its range), so a miss is a bug;
    // the checked lookups say so rather than letting an undefined become NaN in the means test.
    const first = ages[0];
    const last = ages[ages.length - 1];
    if (first === undefined || last === undefined) throw new Error('CarePlus split table is empty');
    const at = (a)=>{
        const row = table[String(a)];
        if (!row) throw new Error(`CarePlus split table has no row for age ${a}`);
        return row;
    };
    if (!Number.isFinite(age)) return {
        ...at(last),
        clamped: true
    };
    if (age <= first) return {
        ...at(first),
        clamped: age < first
    };
    if (age >= last) return {
        ...at(last),
        clamped: age > last
    };
    const lo = Math.floor(age);
    const hi = Math.ceil(age);
    if (lo === hi) return {
        ...at(lo),
        clamped: false
    };
    const t = age - lo;
    const a = at(lo);
    const b = at(hi);
    const insurance = a.insurance + (b.insurance - a.insurance) * t;
    return {
        insurance: insurance,
        annuity: 1 - insurance,
        clamped: false
    };
}
function $d08210caeacdc75a$export$12d6ed847371277() {
    return {
        source: (0, $cdca3d06cbe28cd4$export$dba5d249bd0810fd).source,
        validTo: (0, $cdca3d06cbe28cd4$export$dba5d249bd0810fd).validTo,
        importedAt: (0, $cdca3d06cbe28cd4$export$dba5d249bd0810fd).importedAt
    };
}
function $d08210caeacdc75a$export$7095ab72ebd46272(factFind, owner = 'client') {
    const person = (who)=>{
        const acat = factFind?.careNeeds?.[who === 'client' ? 'clientAcat' : 'partnerAcat'];
        const residency = factFind?.[who]?.currentResidency;
        const inResidentialCare = residency === 'aged_care' || residency === 'residential_care';
        const onSupportAtHome = residency === 'home_care' || residency === 'support_at_home';
        // An approval, or an application in train, counts: the shape is bought at the point of entry.
        const approved = acat?.status === 'yes' || acat?.status === 'applied' || acat?.status === 'assessed';
        return inResidentialCare || onSupportAtHome || approved;
    };
    if (owner === 'joint') return person('client') || person('partner');
    return person(owner);
}


const $f7f7b62814c3b615$export$b8491b3bda867dd = {
    55: {
        male: 28.82,
        female: 31.92
    },
    56: {
        male: 27.93,
        female: 31.00
    },
    57: {
        male: 27.06,
        female: 30.08
    },
    58: {
        male: 26.19,
        female: 29.17
    },
    59: {
        male: 25.32,
        female: 28.26
    },
    60: {
        male: 24.47,
        female: 27.35
    },
    61: {
        male: 23.62,
        female: 26.45
    },
    62: {
        male: 22.78,
        female: 25.56
    },
    63: {
        male: 21.94,
        female: 24.67
    },
    64: {
        male: 21.12,
        female: 23.78
    },
    65: {
        male: 20.30,
        female: 22.90
    },
    66: {
        male: 19.48,
        female: 22.02
    },
    67: {
        male: 18.68,
        female: 21.15
    },
    68: {
        male: 17.89,
        female: 20.29
    },
    69: {
        male: 17.10,
        female: 19.43
    },
    70: {
        male: 16.32,
        female: 18.59
    },
    71: {
        male: 15.56,
        female: 17.75
    },
    72: {
        male: 14.80,
        female: 16.92
    },
    73: {
        male: 14.06,
        female: 16.10
    },
    74: {
        male: 13.33,
        female: 15.30
    },
    75: {
        male: 12.62,
        female: 14.50
    },
    76: {
        male: 11.92,
        female: 13.72
    },
    77: {
        male: 11.24,
        female: 12.96
    },
    78: {
        male: 10.58,
        female: 12.21
    },
    79: {
        male: 9.94,
        female: 11.48
    },
    80: {
        male: 9.32,
        female: 10.77
    },
    81: {
        male: 8.72,
        female: 10.08
    },
    82: {
        male: 8.14,
        female: 9.42
    },
    83: {
        male: 7.59,
        female: 8.78
    },
    84: {
        male: 7.06,
        female: 8.16
    },
    85: {
        male: 6.55,
        female: 7.57
    },
    86: {
        male: 6.08,
        female: 7.01
    },
    87: {
        male: 5.63,
        female: 6.48
    },
    88: {
        male: 5.21,
        female: 5.98
    },
    89: {
        male: 4.83,
        female: 5.51
    },
    90: {
        male: 4.48,
        female: 5.09
    },
    91: {
        male: 4.16,
        female: 4.69
    },
    92: {
        male: 3.88,
        female: 4.33
    },
    93: {
        male: 3.62,
        female: 4.00
    },
    94: {
        male: 3.39,
        female: 3.71
    },
    95: {
        male: 3.18,
        female: 3.44
    },
    96: {
        male: 2.99,
        female: 3.20
    },
    97: {
        male: 2.81,
        female: 2.99
    },
    98: {
        male: 2.65,
        female: 2.80
    },
    99: {
        male: 2.50,
        female: 2.63
    },
    100: {
        male: 2.37,
        female: 2.49
    },
    101: {
        male: 2.25,
        female: 2.36
    },
    102: {
        male: 2.15,
        female: 2.24
    },
    103: {
        male: 2.06,
        female: 2.14
    },
    104: {
        male: 1.98,
        female: 2.04
    },
    105: {
        male: 1.90,
        female: 1.96
    }
};
const $f7f7b62814c3b615$export$97c58f575ae57007 = (v)=>v === 'male' || v === 'female' ? v : null;
function $f7f7b62814c3b615$export$63cc42efad7816ac(age, sex) {
    const tableAge = $f7f7b62814c3b615$var$clamp(Math.round(age), 55, 105);
    const row = $f7f7b62814c3b615$export$b8491b3bda867dd[tableAge];
    if (!row) return 15;
    return sex === 'female' ? row.female : row.male;
}
/*
 * ANNUITY PRICES LIVE IN `annuityRates.ts`, READ FROM THE PUBLISHED SHEET.
 *
 * What stood here until 25 September 2026 was a `DEFAULT_RATE_RULES` table: a base rate, a flat age
 * step and three discounts, all invented. Measured against Challenger's published adviser sheet it
 * paid about HALF the market at every age and in both shapes, so every annuity strategy in every
 * module was understated. The rules also carried a `care` block that nothing could ever reach,
 * because no caller has ever set `annuityType` to `'care'`.
 *
 * Rates are a price, not a constant, so they are now data imported weekly from the sheet. See
 * `annuityRates.ts` for which published column maps to which client-facing shape, and
 * `scripts/import-annuity-rates.mjs` for the update drill.
 */ const $f7f7b62814c3b615$var$clamp = (value, min, max)=>Math.min(Math.max(value, min), max);
const $f7f7b62814c3b615$var$roundCurrency = (value)=>Math.round((value + Number.EPSILON) * 100) / 100;
function $f7f7b62814c3b615$export$b263bc911c6d9872({ age: age, partnerAge: partnerAge = null, type: type = 'single', sex: sex = null, partnerSex: partnerSex = null }) {
    // A joint or reversionary annuity is planned on the LONGER of the two lives — the rule the capital
    // access schedule applies where the income continues to a partner.
    const own = $f7f7b62814c3b615$export$63cc42efad7816ac(age, sex);
    if (type === 'joint' && partnerAge !== null && partnerAge !== undefined) return Math.max(own, $f7f7b62814c3b615$export$63cc42efad7816ac(partnerAge, partnerSex));
    return own;
}
function $f7f7b62814c3b615$export$5c496b19d3677ed3(lifeExpectancyYears) {
    return Math.max(1, Math.floor(lifeExpectancyYears));
}
function $f7f7b62814c3b615$export$db240080e052bedc(yearsElapsed, periodYears) {
    const period = Math.max(0, periodYears);
    const elapsed = Math.max(0, yearsElapsed);
    if (period <= 0 || elapsed >= period) return 0;
    return Math.max(0, Math.min(1, (period - elapsed) / period));
}
function $f7f7b62814c3b615$export$704532a9d5d3e528(yearsElapsed, periodYears) {
    const period = Math.max(0, periodYears);
    const elapsed = Math.max(0, yearsElapsed);
    if (period <= 0 || elapsed >= period) return 0;
    if (elapsed < period / 2) return 1;
    return $f7f7b62814c3b615$export$db240080e052bedc(elapsed, period);
}
/**
 * What the provider would pay, from the published sheet.
 *
 * A LIFETIME annuity gets a payment rate straight from the sheet's own two liquidity options. A
 * FIXED TERM gets an EARNING rate, which `buildAnnuityImpact` then amortises into a payment, because
 * a term annuity hands capital back through its payments. A GUARANTEED shape gets the rate for the
 * annuity-and-insurance product the sheet prices as one.
 *
 * The answer carries `extrapolated` so the screens can say when the sheet does not publish the
 * client's age and we have carried its last slope onward. Nothing here invents a rate.
 */ function $f7f7b62814c3b615$var$estimateIndicativeRate({ annuityType: annuityType, age: age, partnerAge: partnerAge, indexation: indexation, residualCapital: residualCapital, termYears: termYears, sex: sex }) {
    if (annuityType === 'fixedTerm') return (0, $d697a0cc78e06dde$export$5fbe270ae518244)({
        termYears: termYears || 1,
        residualCapital: residualCapital
    });
    if (annuityType === 'guaranteed') return (0, $d697a0cc78e06dde$export$841b99c047c4e0d)({
        age: age,
        sex: sex
    });
    return (0, $d697a0cc78e06dde$export$9ad772f55a285440)({
        age: age,
        sex: sex,
        indexation: indexation,
        residualCapital: residualCapital,
        partnerAge: partnerAge
    });
}
function $f7f7b62814c3b615$var$computeAnnualPaymentWithIndexation(purchaseAmount, rate, options) {
    if (!options.indexation || options.annuityType === 'fixedTerm') return purchaseAmount * rate;
    // With indexation we assume the rate represents the first year's payment.
    return purchaseAmount * rate;
}
function $f7f7b62814c3b615$var$calculateDeductionAmount({ purchaseAmount: purchaseAmount, residualCapital: residualCapital, lifeExpectancyYears: lifeExpectancyYears, termYears: termYears, annuityType: annuityType }) {
    const residualValue = residualCapital ? purchaseAmount * residualCapital : 0;
    const capitalToReturn = purchaseAmount - residualValue;
    if (annuityType === 'fixedTerm' && termYears) return capitalToReturn / termYears;
    const divisor = lifeExpectancyYears || 1;
    return capitalToReturn / divisor;
}
const $f7f7b62814c3b615$export$81ae1e5a84bdeba6 = 0.6;
const $f7f7b62814c3b615$export$f2c1a9b136ca5093 = 0.3;
const $f7f7b62814c3b615$export$241299d9c804a8e1 = 85;
const $f7f7b62814c3b615$export$609a559abf3c422 = 5;
function $f7f7b62814c3b615$export$514e014a7cb2a24(ageAtCommencement, yearsElapsed = 0) {
    // An unknown age cannot be shown to have passed the threshold, so it gets the higher rate. The
    // cautious direction: it never claims a discount the client may not have reached.
    if (ageAtCommencement == null || !(ageAtCommencement > 0)) return $f7f7b62814c3b615$export$81ae1e5a84bdeba6;
    const yearsToThresholdAge = Math.max(0, $f7f7b62814c3b615$export$241299d9c804a8e1 - ageAtCommencement);
    const yearsToThresholdDay = Math.max(yearsToThresholdAge, $f7f7b62814c3b615$export$609a559abf3c422);
    return (yearsElapsed || 0) >= yearsToThresholdDay ? $f7f7b62814c3b615$export$f2c1a9b136ca5093 : $f7f7b62814c3b615$export$81ae1e5a84bdeba6;
}
function $f7f7b62814c3b615$var$deriveAssessableAsset({ annuityType: annuityType, purchaseAmount: purchaseAmount, residualCapital: residualCapital = 0, deductionAmount: deductionAmount = 0, yearsElapsed: yearsElapsed = 0, age: age, partnerAge: partnerAge = null, owner: owner = 'client', ownerSex: ownerSex = null }) {
    if (annuityType === 'fixedTerm') {
        const residualValue = purchaseAmount * (residualCapital || 0);
        // If 100% RCV, full purchase price assessed throughout term
        if (residualCapital >= 1) return purchaseAmount;
        // If RCV < 100%, asset reduces over time: Max(Residual Value, Purchase Price - (Deduction × Years))
        if (deductionAmount > 0 && yearsElapsed > 0) {
            const capitalReturned = deductionAmount * yearsElapsed;
            return Math.max(residualValue, purchaseAmount - capitalReturned);
        }
        // Initial assessment (yearsElapsed = 0): Full purchase price
        return purchaseAmount;
    }
    /*
     * THE GUARANTEED SHAPE IS TWO PRODUCTS, COUNTED TWO WAYS. The annuity slice is a compliant
     * lifetime income stream, so it gets the 60% then 30% treatment on ITS price. The life policy
     * is not an income stream at all: Centrelink counts it at the greater of the premium paid and
     * its surrender value. The surrender value starts below the premium (it is the present value of
     * a benefit that has not fallen due) and can climb above it in later years; we count the
     * premium, which is the floor Challenger's own calculator applies, and record in the pack that
     * the true figure can be higher late in life (D.2.12b). Net effect, and worth knowing: the
     * guaranteed shape cuts assessed assets by only about 40% of the annuity slice — about 21% of
     * the money at 70, 12% at 85, 7% at 95 — because most of the money is buying insurance.
     */ if (annuityType === 'guaranteed') {
        const split = (0, $d08210caeacdc75a$export$3568d8429413a44e)(owner === 'partner' ? partnerAge ?? age : age, ownerSex);
        const annuitySlice = purchaseAmount * split.annuity;
        const insuranceSlice = purchaseAmount * split.insurance;
        const ownerAgeForRate = owner === 'partner' ? partnerAge : age;
        return annuitySlice * $f7f7b62814c3b615$export$514e014a7cb2a24(ownerAgeForRate, yearsElapsed) + insuranceSlice;
    }
    // Lifetime annuities: 60% of the purchase price until the threshold day, then 30%.
    if (owner === 'joint' && partnerAge !== null) {
        const clientShare = purchaseAmount / 2;
        const partnerShare = purchaseAmount / 2;
        return clientShare * $f7f7b62814c3b615$export$514e014a7cb2a24(age, yearsElapsed) + partnerShare * $f7f7b62814c3b615$export$514e014a7cb2a24(partnerAge, yearsElapsed);
    }
    const ownerAge = owner === 'partner' ? partnerAge : age;
    return purchaseAmount * $f7f7b62814c3b615$export$514e014a7cb2a24(ownerAge, yearsElapsed);
}
function $f7f7b62814c3b615$export$fb67395f10ad20c9(factFind, strategy) {
    const { annuityType: annuityType, purchaseAmount: purchaseAmount, fundingSource: fundingSource, age: age, partnerAge: partnerAge = null, indexation: indexation = false, residualCapital: residualCapital = 0, termYears: termYears = null, incomeOverride: incomeOverride = null, assessableIncomeOverride: assessableIncomeOverride = null, assessableAssetOverride: assessableAssetOverride = null, owner: owner = 'client', reversionary: reversionary = false, guaranteePeriodYears: guaranteePeriodYears = 0, reversionPct: reversionPct = null } = strategy;
    // A deferred lifetime annuity: payments start `deferralYears` after purchase. Only a lifetime
    // product defers; a fixed term with a deferral is not a product anyone sells.
    const deferralYears = annuityType === 'lifetime' ? Math.max(0, Math.round(Number(strategy.deferralYears) || 0)) : 0;
    if (!purchaseAmount || purchaseAmount <= 0) return {
        warnings: [
            'Enter an annuity purchase amount to see projections.'
        ]
    };
    // Whose life the schedule runs on: the owner's, or the longer of the two where the income continues
    // to the partner (joint, or reversionary). Sex from the fact-find; unknown reads as the shorter table.
    // It is read BEFORE the rate call because the published sheet prices men and women differently.
    const ownerSex = $f7f7b62814c3b615$export$97c58f575ae57007(owner === 'partner' ? factFind?.partner?.sex : factFind?.client?.sex);
    const otherSex = $f7f7b62814c3b615$export$97c58f575ae57007(owner === 'partner' ? factFind?.client?.sex : factFind?.partner?.sex);
    const jointLife = owner === 'joint' || reversionary === true;
    // Priced at the age the payments START, on capital the provider is assumed to have grown through
    // the deferral (DEFERRED_ANNUITY_ACCUMULATION_RATE) — indicative, and low, see that constant.
    const rateAnswer = $f7f7b62814c3b615$var$estimateIndicativeRate({
        annuityType: annuityType,
        age: age + deferralYears,
        partnerAge: jointLife && partnerAge != null ? partnerAge + deferralYears : null,
        indexation: indexation,
        residualCapital: residualCapital,
        termYears: termYears,
        sex: ownerSex
    });
    const indicativeRate = rateAnswer.rate;
    const deferralUplift = deferralYears > 0 ? Math.pow(1 + $f7f7b62814c3b615$export$c9c5872609b421e8, deferralYears) : 1;
    let annualPaymentIndicative = $f7f7b62814c3b615$var$computeAnnualPaymentWithIndexation(purchaseAmount, indicativeRate * deferralUplift, {
        indexation: indexation,
        annuityType: annuityType
    });
    /*
     * A FIXED TERM RETURNS ITS CAPITAL THROUGH THE PAYMENTS. The indicative rate is an earning rate
     * on the capital; the payment on a term annuity is that earning PLUS the part of the capital that
     * is not coming back at the end, spread over the term (an amortising payment). With the capital
     * fully returned (RCV 100%) the payment is the earning alone, as before; with none returned the
     * payment amortises the whole purchase price. Until 17 Sep 2026 every fixed term was priced at
     * the earning alone, so a nil-residual term annuity paid LESS than the capital it was supposed
     * to hand back each year — an impossible product, and one whose income-test deduction then
     * exceeded its payment.
     */ if (annuityType === 'fixedTerm' && termYears && termYears > 0) {
        const residualPart = purchaseAmount * Math.min(1, Math.max(0, residualCapital || 0));
        const amortised = purchaseAmount - residualPart;
        const r = indicativeRate;
        const amortisingPayment = r > 0 ? amortised * r / (1 - Math.pow(1 + r, -termYears)) : amortised / termYears;
        annualPaymentIndicative = amortisingPayment + residualPart * r;
    }
    const lifeExpectancyYears = annuityType === 'fixedTerm' ? termYears : $f7f7b62814c3b615$export$b263bc911c6d9872({
        age: age,
        partnerAge: jointLife ? partnerAge : null,
        type: jointLife && partnerAge !== null ? 'joint' : 'single',
        sex: ownerSex,
        partnerSex: otherSex
    });
    const capitalAccessPeriod = annuityType === 'lifetime' && lifeExpectancyYears ? $f7f7b62814c3b615$export$5c496b19d3677ed3(lifeExpectancyYears) : null;
    const deductionAmount = $f7f7b62814c3b615$var$calculateDeductionAmount({
        purchaseAmount: purchaseAmount,
        residualCapital: residualCapital,
        lifeExpectancyYears: lifeExpectancyYears,
        termYears: termYears,
        annuityType: annuityType
    });
    // For lifetime annuities commenced on or after 1 July 2019: income test = 60% of payments (no deduction).
    // The guaranteed shape's payments all come from its annuity half, so the same 60% applies.
    let assessableIncomeCalculated;
    if (annuityType === 'lifetime' || annuityType === 'guaranteed') assessableIncomeCalculated = annualPaymentIndicative * 0.60;
    else if (annuityType === 'fixedTerm') // Term ≤ 5 years: subject to deeming (simplified here via deduction method, noted in UI).
    // Term > 5 years: deduction method applies.
    assessableIncomeCalculated = annualPaymentIndicative - deductionAmount;
    else assessableIncomeCalculated = annualPaymentIndicative - deductionAmount;
    const assessableAssetCalculated = $f7f7b62814c3b615$var$deriveAssessableAsset({
        annuityType: annuityType,
        purchaseAmount: purchaseAmount,
        residualCapital: residualCapital,
        deductionAmount: deductionAmount,
        yearsElapsed: 0,
        age: age,
        partnerAge: partnerAge,
        owner: owner,
        ownerSex: ownerSex
    });
    const annualPayment = incomeOverride !== null && !Number.isNaN(incomeOverride) ? incomeOverride : annualPaymentIndicative;
    const assessableIncome = assessableIncomeOverride !== null && !Number.isNaN(assessableIncomeOverride) ? assessableIncomeOverride : assessableIncomeCalculated;
    const assessableAsset = assessableAssetOverride !== null && !Number.isNaN(assessableAssetOverride) ? assessableAssetOverride : assessableAssetCalculated;
    /*
     * WHAT THE ESTATE GETS. A plain annuity: the residual the client chose, which `ageAnnuityAsset`
     * then winds down on the capital access schedule. The guaranteed shape: the whole purchase
     * price, always — the life policy pays whatever the annuity does not, and nothing here or in
     * the ageing ever reduces it. That is the entire point of the product.
     */ const isGuaranteed = annuityType === 'guaranteed';
    const residualValue = isGuaranteed ? purchaseAmount : residualCapital ? purchaseAmount * residualCapital : 0;
    const split = isGuaranteed ? (0, $d08210caeacdc75a$export$3568d8429413a44e)(age, ownerSex) : null;
    let fundingSourceType = 'bank';
    let fundingSourceId = null;
    let fundingSourceLabel = 'Bank accounts / cash';
    if (typeof fundingSource === 'string') fundingSourceType = fundingSource;
    else if (fundingSource && typeof fundingSource === 'object') {
        fundingSourceType = fundingSource.type || fundingSourceType;
        fundingSourceId = fundingSource.assetId ?? null;
        if (fundingSource.label) fundingSourceLabel = fundingSource.label;
    }
    const annuityRecord = {
        id: strategy.id || `annuity-${Date.now()}`,
        annuityType: annuityType,
        purchaseAmount: purchaseAmount,
        fundingSource: fundingSource,
        fundingSourceType: fundingSourceType,
        fundingSourceId: fundingSourceId,
        fundingSourceLabel: fundingSourceLabel,
        age: age,
        partnerAge: partnerAge,
        indexation: indexation,
        // A guaranteed shape returns everything; the field is kept at 1 so every reader that
        // scales by it (net worth, the recap, the cards) sees the full amount.
        residualCapital: isGuaranteed ? 1 : residualCapital,
        termYears: termYears,
        owner: owner,
        reversionary: reversionary,
        indicativeRate: indicativeRate,
        /** Where the rate came from, in a sentence a client can read, and whether we had to go past
         *  the ages the sheet publishes. The screens print both. */ rateBasis: rateAnswer.basis,
        rateExtrapolated: rateAnswer.extrapolated,
        rateSheetWeek: (0, $d697a0cc78e06dde$export$dd575ab7aedb8603)().effectiveFrom,
        annualPayment: $f7f7b62814c3b615$var$roundCurrency(annualPayment),
        assessableIncome: $f7f7b62814c3b615$var$roundCurrency(Math.max(0, assessableIncome)),
        assessableAsset: $f7f7b62814c3b615$var$roundCurrency(Math.max(0, assessableAsset)),
        deductionAmount: $f7f7b62814c3b615$var$roundCurrency(Math.max(0, deductionAmount)),
        residualValue: $f7f7b62814c3b615$var$roundCurrency(Math.max(0, residualValue)),
        deferralYears: deferralYears,
        // A guarantee period and a spouse's share, where the shape has them (15 Oct 2026).
        guaranteePeriodYears: annuityType === 'lifetime' ? Math.max(0, Number(guaranteePeriodYears) || 0) : 0,
        reversionPct: reversionPct != null && Number.isFinite(Number(reversionPct)) ? Number(reversionPct) : null,
        // The capital access schedule this annuity's death benefit follows (lifetime only). The
        // guaranteed shape has no schedule to follow: its death benefit never moves.
        lifeExpectancyYears: annuityType === 'lifetime' ? lifeExpectancyYears : null,
        capitalAccessPeriodYears: capitalAccessPeriod,
        ownerSex: ownerSex,
        lifeExpectancySexKnown: annuityType === 'lifetime' ? jointLife && partnerAge !== null ? ownerSex != null && otherSex != null : ownerSex != null : true,
        /*
         * THE GUARANTEED SHAPE'S TWO HALVES, in dollars, so the screens can show the client where
         * their money went and the means test can count each half its own way. From Challenger's
         * calculator, by age and sex; `splitClamped` says the age fell outside the table.
         */ ...split ? {
            annuitySlice: $f7f7b62814c3b615$var$roundCurrency(purchaseAmount * split.annuity),
            insuranceSlice: $f7f7b62814c3b615$var$roundCurrency(purchaseAmount * split.insurance),
            splitClamped: split.clamped
        } : {}
    };
    if (deferralYears > 0) {
        // Nothing is paid, and nothing counted as income, until the deferral ends. The figures the
        // payments will take from then on ride along so the ageing plugin can switch them in.
        annuityRecord.deferredAnnualPayment = annuityRecord.annualPayment;
        annuityRecord.deferredAssessableIncome = annuityRecord.assessableIncome;
        annuityRecord.annualPayment = 0;
        annuityRecord.assessableIncome = 0;
    }
    return annuityRecord;
}
function $f7f7b62814c3b615$export$3e335727e573fe15(factFind, annuityRecord) {
    const modified = structuredClone(factFind);
    const { fundingSource: fundingSource, fundingSourceType: fundingSourceType, fundingSourceId: fundingSourceId, purchaseAmount: purchaseAmount } = annuityRecord;
    const amount = purchaseAmount;
    let remaining = amount;
    const reduceFromList = (list, assetId, accessor = 'value')=>{
        if (!list) return remaining;
        const targetId = assetId !== null && assetId !== undefined ? String(assetId) : null;
        list.some((item)=>{
            if (remaining <= 0) return true;
            if (targetId && String(item.id ?? item.assetId ?? item.accountId) !== targetId) return false;
            const currentRaw = item[accessor] ?? item.balance;
            const currentValue = currentRaw || 0;
            if (currentValue <= 0) return !!targetId;
            const reduction = Math.min(currentValue, remaining);
            const updated = currentValue - reduction;
            if (item[accessor] !== undefined) item[accessor] = updated;
            else if (item.balance !== undefined) item.balance = updated;
            remaining -= reduction;
            return !!targetId;
        });
        return remaining;
    };
    let sourceType = fundingSourceType || (typeof fundingSource === 'object' ? fundingSource.type : fundingSource);
    let targetAssetId = fundingSourceId;
    // Handle asset ID format (e.g., "bankAccounts-123") from Aged Care section
    if (typeof fundingSource === 'object' && fundingSource.id && fundingSource.id.includes('-')) {
        const parts = fundingSource.id.split('-');
        const assetTypeFromId = parts[0];
        targetAssetId = parts.slice(1).join('-'); // Rejoin in case asset.id contains dashes
        if (assetTypeFromId === 'bankAccounts') sourceType = 'bank';
        else if (assetTypeFromId === 'accountBasedPensions') sourceType = 'abp';
        else if (assetTypeFromId === 'superannuation') sourceType = 'super';
        else sourceType = assetTypeFromId;
    }
    if (sourceType === 'bank' || sourceType === 'bankAccounts') remaining = reduceFromList(modified.assets?.bankAccounts, targetAssetId, 'value');
    else if (sourceType === 'shares') remaining = reduceFromList(modified.assets?.shares, targetAssetId, 'value');
    else if (sourceType === 'abp' || sourceType === 'accountBasedPensions') remaining = reduceFromList(modified.assets?.accountBasedPensions, targetAssetId);
    else if (sourceType === 'super' || sourceType === 'superannuation') remaining = reduceFromList(modified.assets?.superannuation, targetAssetId, 'value');
    else if (sourceType === 'termDeposits') remaining = reduceFromList(modified.assets?.termDeposits, targetAssetId, 'value');
    if (remaining > 0) {
        if (!modified.assets) modified.assets = {};
        if (!modified.assets.bankAccounts) modified.assets.bankAccounts = [
            {
                id: 'auto-bank-adjust',
                type: 'bankAccounts',
                description: 'Cash balance',
                value: 0,
                /* interest, not capital growth — see bankPlugin.ts */ incomeRate: 2,
                growthRate: 0,
                ownership: 'joint'
            }
        ];
        const first = modified.assets.bankAccounts[0];
        const current = first.value || 0;
        const reduction = Math.min(current, remaining);
        first.value = current - reduction;
        remaining -= reduction;
    }
    if (!modified.assets) modified.assets = {};
    if (!modified.assets.annuities) modified.assets.annuities = [];
    // Remove any existing annuities with the same ID to avoid duplicates when settings change.
    modified.assets.annuities = modified.assets.annuities.filter((a)=>a.id !== annuityRecord.id);
    // One shape for every builder — see annuityAssetFromRecord. A fixed-term annuity's `value`
    // reduces as capital comes back; a lifetime one carries `assessableAsset` (60% → 30%).
    modified.assets.annuities.push($f7f7b62814c3b615$export$5dc1cd0ab6cd8d79(annuityRecord, {
        ownership: annuityRecord.owner || 'joint'
    }));
    return modified;
}
function $f7f7b62814c3b615$export$2be9eb0e3e9661dd(factFind, annuityRecord) {
    const before = $f7f7b62814c3b615$export$7e7ce6636f3d5157(factFind);
    const applied = $f7f7b62814c3b615$export$3e335727e573fe15(factFind, annuityRecord);
    return {
        factFind: applied,
        drawnFrom: $f7f7b62814c3b615$export$5865f4cba3381c61(before, $f7f7b62814c3b615$export$7e7ce6636f3d5157(applied))
    };
}
function $f7f7b62814c3b615$export$c21193cd9e9c34e8(assetValue, drawnByThisAnnuity, claimedByRad) {
    return Math.max(0, $f7f7b62814c3b615$var$numOr(assetValue, 0) + $f7f7b62814c3b615$var$numOr(drawnByThisAnnuity, 0) - $f7f7b62814c3b615$var$numOr(claimedByRad, 0));
}
function $f7f7b62814c3b615$export$7e7ce6636f3d5157(factFind) {
    const out = {};
    for (const assetType of (0, $bfa4518c9dced417$export$e18ad1b53d14ba76).filter((t)=>t.isLiquid).map((t)=>t.id))for (const asset of factFind?.assets?.[assetType] || [])out[`${assetType}-${asset?.id}`] = $f7f7b62814c3b615$var$numOr(asset?.value ?? asset?.balance, 0);
    return out;
}
function $f7f7b62814c3b615$export$5865f4cba3381c61(before, after) {
    const out = {};
    for (const [key, was] of Object.entries(before)){
        const drawn = was - (after[key] ?? 0);
        if (drawn > 0.005) out[key] = drawn;
    }
    return out;
}
function $f7f7b62814c3b615$export$fc6c67b5fdf45998(annuityRecord) {
    if (!annuityRecord) return null;
    return {
        annuityType: annuityRecord.annuityType,
        annualPayment: annuityRecord.annualPayment,
        assessableIncome: annuityRecord.assessableIncome,
        assessableAsset: annuityRecord.assessableAsset,
        residualValue: annuityRecord.residualValue,
        fundingSourceLabel: annuityRecord.fundingSourceLabel,
        owner: annuityRecord.owner,
        // Where the rate came from, and — for the guaranteed shape — how the money split between the
        // annuity and the life policy. The screens show both; nothing else reads them.
        rateBasis: annuityRecord.rateBasis,
        rateExtrapolated: annuityRecord.rateExtrapolated,
        annuitySlice: annuityRecord.annuitySlice,
        insuranceSlice: annuityRecord.insuranceSlice,
        splitClamped: annuityRecord.splitClamped
    };
}
const $f7f7b62814c3b615$export$49d65fcd35b59101 = 5;
const $f7f7b62814c3b615$export$c9c5872609b421e8 = 0.04;
const $f7f7b62814c3b615$var$numOr = (v, fallback)=>{
    const n = typeof v === 'number' ? v : parseFloat(String(v ?? ''));
    return Number.isFinite(n) ? n : fallback;
};
function $f7f7b62814c3b615$export$29809e01670bbd48(from, to) {
    let years = to.getFullYear() - from.getFullYear();
    const beforeAnniversary = to.getMonth() < from.getMonth() || to.getMonth() === from.getMonth() && to.getDate() < from.getDate();
    if (beforeAnniversary) years -= 1;
    return Math.max(0, years);
}
function $f7f7b62814c3b615$export$bd8e16e0fe2cc905(asset, asOf = new Date()) {
    if (!asset?.commencementDate || asset?.commencementDateUnsure) return null;
    const text = String(asset.commencementDate);
    // A bare date is read as a LOCAL date, so it compares with the projection's local dates.
    const commenced = /^\d{4}-\d{2}-\d{2}$/.test(text) ? new Date(`${text}T00:00:00`) : new Date(text);
    if (Number.isNaN(commenced.getTime())) return null;
    return $f7f7b62814c3b615$export$29809e01670bbd48(commenced, asOf);
}
function $f7f7b62814c3b615$export$39dd0455f19e0b2c(asset, asOf = new Date(), ownerAgeNow = null) {
    const rawType = String(asset?.annuityType ?? '');
    const termYears = (()=>{
        const t = $f7f7b62814c3b615$var$numOr(asset?.termYears ?? asset?.term, 0);
        return t > 0 ? t : null;
    })();
    const isGuaranteed = rawType === 'guaranteed';
    const isFixed = !isGuaranteed && (rawType === 'fixedTerm' || rawType === 'fixed_term' || rawType === '' && termYears != null && asset?.assessableAsset === undefined);
    const isLifetime = rawType === 'lifetime' || rawType === '' && !isFixed;
    const value = Math.max(0, $f7f7b62814c3b615$var$numOr(asset?.value, 0));
    const purchaseAmount = Math.max(0, $f7f7b62814c3b615$var$numOr(asset?.purchasePrice, 0)) || value;
    // A guaranteed shape's estate value is its whole price, whatever a stale field says.
    const residualValue = isGuaranteed ? purchaseAmount : Math.max(0, $f7f7b62814c3b615$var$numOr(asset?.residualValue ?? asset?.rcv, 0));
    const deferralYears = Math.max(0, $f7f7b62814c3b615$var$numOr(asset?.deferralYears, 0));
    const yearsElapsed = asset?.__annuityYearsElapsed != null ? Math.max(0, $f7f7b62814c3b615$var$numOr(asset.__annuityYearsElapsed, 0)) : $f7f7b62814c3b615$export$bd8e16e0fe2cc905(asset, asOf) ?? 0;
    let kind;
    if (isGuaranteed) kind = 'guaranteed';
    else if (isLifetime) kind = 'lifetime';
    else if (termYears != null && termYears <= $f7f7b62814c3b615$export$49d65fcd35b59101) kind = 'shortTerm';
    else kind = 'longTerm';
    const matured = (kind === 'longTerm' || kind === 'shortTerm') && termYears != null && yearsElapsed >= termYears;
    const indexed = kind === 'lifetime' && (asset?.indexed === true || asset?.indexation === true);
    const guaranteePeriodYears = kind === 'lifetime' ? Math.max(0, $f7f7b62814c3b615$var$numOr(asset?.guaranteePeriodYears, 0)) : 0;
    const reversionRaw = $f7f7b62814c3b615$var$numOr(asset?.reversionPct, -1);
    const reversionPct = reversionRaw >= 0 ? Math.min(100, reversionRaw) : null;
    // The deductible amount: recorded by a builder, else struck from the terms.
    let deductionAmount = 0;
    const recorded = $f7f7b62814c3b615$var$numOr(asset?.deductionAmount, -1);
    if (recorded >= 0) deductionAmount = recorded;
    else if (kind === 'guaranteed') {
        // The tax-free component of each payment runs on the ANNUITY half, which returns nothing
        // of its own price (the policy does that), over life expectancy at commencement.
        const ageAtCommencement = asset?.__ageAtCommencement != null ? $f7f7b62814c3b615$var$numOr(asset.__ageAtCommencement, 0) : ownerAgeNow != null ? ownerAgeNow - yearsElapsed : null;
        const annuitySlice = Math.max(0, $f7f7b62814c3b615$var$numOr(asset?.annuitySlice, 0)) || purchaseAmount * (0, $d08210caeacdc75a$export$3568d8429413a44e)(ageAtCommencement ?? 85, $f7f7b62814c3b615$export$97c58f575ae57007(asset?.__ownerSex)).annuity;
        if (ageAtCommencement != null && ageAtCommencement > 0) {
            const lifeExpectancy = $f7f7b62814c3b615$export$b263bc911c6d9872({
                age: ageAtCommencement,
                partnerAge: null,
                type: 'single',
                sex: $f7f7b62814c3b615$export$97c58f575ae57007(asset?.__ownerSex)
            });
            deductionAmount = lifeExpectancy > 0 ? annuitySlice / lifeExpectancy : 0;
        }
    } else if (kind !== 'lifetime') deductionAmount = termYears ? Math.max(0, purchaseAmount - residualValue) / termYears : 0;
    else {
        const ageAtCommencement = asset?.__ageAtCommencement != null ? $f7f7b62814c3b615$var$numOr(asset.__ageAtCommencement, 0) : ownerAgeNow != null ? ownerAgeNow - yearsElapsed : null;
        if (ageAtCommencement != null && ageAtCommencement > 0) {
            const lifeExpectancy = $f7f7b62814c3b615$export$b263bc911c6d9872({
                age: ageAtCommencement,
                partnerAge: null,
                type: 'single'
            });
            deductionAmount = lifeExpectancy > 0 ? Math.max(0, purchaseAmount - residualValue) / lifeExpectancy : 0;
        }
    }
    const statedPayment = Math.max(0, $f7f7b62814c3b615$var$numOr(asset?.annualPayment ?? asset?.income, 0));
    let annualPayment = statedPayment;
    if (kind === 'lifetime' && deferralYears > 0) annualPayment = yearsElapsed >= deferralYears ? Math.max(0, $f7f7b62814c3b615$var$numOr(asset?.deferredAnnualPayment, statedPayment)) : 0;
    if (matured) annualPayment = 0;
    return {
        kind: kind,
        purchaseAmount: purchaseAmount,
        annualPayment: annualPayment,
        deductionAmount: deductionAmount,
        residualValue: residualValue,
        termYears: termYears,
        deferralYears: deferralYears,
        yearsElapsed: yearsElapsed,
        matured: matured,
        indexed: indexed,
        guaranteePeriodYears: guaranteePeriodYears,
        reversionPct: reversionPct
    };
}
function $f7f7b62814c3b615$export$96362d760c8a6bfb(asset, asOf = new Date()) {
    const terms = $f7f7b62814c3b615$export$39dd0455f19e0b2c(asset, asOf);
    if (terms.kind === 'shortTerm' || terms.matured) return 0;
    if (terms.kind === 'guaranteed') {
        // All of its payments come from the annuity half: 60% counted, no deferral to wait out.
        const statedNum = $f7f7b62814c3b615$var$numOr(asset?.assessableIncome, -1);
        return statedNum >= 0 && terms.annualPayment > 0 ? statedNum : terms.annualPayment * 0.6;
    }
    if (terms.kind === 'lifetime') {
        if (terms.deferralYears > 0 && terms.yearsElapsed < terms.deferralYears) return 0;
        const stated = terms.deferralYears > 0 ? asset?.deferredAssessableIncome : asset?.assessableIncome;
        const statedNum = $f7f7b62814c3b615$var$numOr(stated, -1);
        return statedNum >= 0 && terms.annualPayment > 0 ? statedNum : terms.annualPayment * 0.6;
    }
    const statedNum = $f7f7b62814c3b615$var$numOr(asset?.assessableIncome, -1);
    if (statedNum >= 0) return statedNum;
    return Math.max(0, terms.annualPayment - terms.deductionAmount);
}
function $f7f7b62814c3b615$export$5296e135279e19b5(asset, ownerAgeNow, asOf = new Date()) {
    const terms = $f7f7b62814c3b615$export$39dd0455f19e0b2c(asset, asOf);
    if (terms.kind === 'longTerm' || terms.kind === 'shortTerm') return Math.max(0, $f7f7b62814c3b615$var$numOr(asset?.value, 0));
    if (asset?.assessableAsset !== undefined && asset?.assessableAsset !== null) return Math.max(0, $f7f7b62814c3b615$var$numOr(asset.assessableAsset, 0));
    const ageAtCommencement = asset?.__ageAtCommencement != null ? $f7f7b62814c3b615$var$numOr(asset.__ageAtCommencement, 0) : ownerAgeNow != null ? ownerAgeNow - terms.yearsElapsed : null;
    if (terms.kind === 'guaranteed') {
        // Reconstruct the two halves where a stored figure is missing: annuity half at 60%/30%,
        // insurance half at the premium paid.
        const split = (0, $d08210caeacdc75a$export$3568d8429413a44e)(ageAtCommencement ?? 85, $f7f7b62814c3b615$export$97c58f575ae57007(asset?.__ownerSex));
        const annuitySlice = Math.max(0, $f7f7b62814c3b615$var$numOr(asset?.annuitySlice, 0)) || terms.purchaseAmount * split.annuity;
        const insuranceSlice = Math.max(0, $f7f7b62814c3b615$var$numOr(asset?.insuranceSlice, 0)) || terms.purchaseAmount * split.insurance;
        return annuitySlice * $f7f7b62814c3b615$export$514e014a7cb2a24(ageAtCommencement, terms.yearsElapsed) + insuranceSlice;
    }
    return terms.purchaseAmount * $f7f7b62814c3b615$export$514e014a7cb2a24(ageAtCommencement, terms.yearsElapsed);
}
function $f7f7b62814c3b615$export$38d1a4266d3e3f44(asset, { yearsElapsed: yearsElapsed, ownerAgeNow: ownerAgeNow, partnerAgeNow: partnerAgeNow = null, ownerSex: ownerSex = null, partnerSex: partnerSex = null, indexationPct: indexationPct = 0 }) {
    asset.__annuityYearsElapsed = Math.max(0, yearsElapsed);
    const terms = $f7f7b62814c3b615$export$39dd0455f19e0b2c(asset);
    if (terms.kind === 'guaranteed') {
        /*
         * NOTHING TAPERS, ONE THING STEPS. The death benefit is the whole price for life, so the
         * residual is pinned to it every year regardless of what the record carried in. The only
         * moving part is the annuity half's assets-test rate, which steps from 60% to 30% on the
         * owner's threshold day exactly as a plain lifetime annuity's does; the insurance half stays
         * at the premium paid. No deferral, no maturity, no capital access schedule.
         */ const elapsed = terms.yearsElapsed;
        const ageAtCommencement = asset.__ageAtCommencement != null ? $f7f7b62814c3b615$var$numOr(asset.__ageAtCommencement, 0) : ownerAgeNow != null ? ownerAgeNow - elapsed : null;
        if (asset.__ageAtCommencement == null && ageAtCommencement != null) asset.__ageAtCommencement = ageAtCommencement;
        if (asset.__ownerSex == null && ownerSex) asset.__ownerSex = ownerSex;
        const purchase = terms.purchaseAmount;
        const split = (0, $d08210caeacdc75a$export$3568d8429413a44e)(ageAtCommencement ?? 85, $f7f7b62814c3b615$export$97c58f575ae57007(asset.__ownerSex));
        if (asset.annuitySlice == null) asset.annuitySlice = $f7f7b62814c3b615$var$roundCurrency(purchase * split.annuity);
        if (asset.insuranceSlice == null) asset.insuranceSlice = $f7f7b62814c3b615$var$roundCurrency(purchase * split.insurance);
        asset.residualCapital = 1;
        asset.residualValue = $f7f7b62814c3b615$var$roundCurrency(purchase);
        asset.assessableAsset = $f7f7b62814c3b615$var$roundCurrency($f7f7b62814c3b615$var$numOr(asset.annuitySlice, 0) * $f7f7b62814c3b615$export$514e014a7cb2a24(ageAtCommencement, elapsed) + $f7f7b62814c3b615$var$numOr(asset.insuranceSlice, 0));
        return {
            matured: false,
            residualPaid: 0
        };
    }
    if (terms.kind === 'lifetime') {
        const elapsed = terms.yearsElapsed;
        const ageAtCommencement = asset.__ageAtCommencement != null ? $f7f7b62814c3b615$var$numOr(asset.__ageAtCommencement, 0) : ownerAgeNow != null ? ownerAgeNow - elapsed : null;
        if (asset.__ageAtCommencement == null && ageAtCommencement != null) asset.__ageAtCommencement = ageAtCommencement;
        const purchase = terms.purchaseAmount;
        /*
         * THE DEATH BENEFIT FOLLOWS THE CAPITAL ACCESS SCHEDULE — see capitalAccessDeathBenefitFactor.
         * The initial share is what the builder recorded (or, for an annuity entered on the profile,
         * what its residual was when first seen); the period is the one stamped at purchase, else
         * struck from the age at commencement and the owner's sex (unknown = the shorter table).
         */ if (asset.residualCapital == null && purchase > 0) asset.residualCapital = Math.min(1, Math.max(0, terms.residualValue / purchase));
        if (asset.__ownerSex == null && ownerSex) asset.__ownerSex = ownerSex;
        if (asset.capitalAccessPeriodYears == null && ageAtCommencement != null && ageAtCommencement > 0) {
            const joint = asset.ownership === 'joint' || asset.reversionary === true;
            const partnerAtCommencement = joint && partnerAgeNow != null ? partnerAgeNow - elapsed : null;
            asset.capitalAccessPeriodYears = $f7f7b62814c3b615$export$5c496b19d3677ed3($f7f7b62814c3b615$export$b263bc911c6d9872({
                age: ageAtCommencement,
                partnerAge: partnerAtCommencement,
                type: partnerAtCommencement != null ? 'joint' : 'single',
                sex: $f7f7b62814c3b615$export$97c58f575ae57007(asset.__ownerSex),
                partnerSex: partnerSex
            }));
        }
        if (asset.capitalAccessPeriodYears != null) asset.residualValue = $f7f7b62814c3b615$var$roundCurrency(purchase * $f7f7b62814c3b615$var$numOr(asset.residualCapital, 0) * $f7f7b62814c3b615$export$704532a9d5d3e528(elapsed, $f7f7b62814c3b615$var$numOr(asset.capitalAccessPeriodYears, 0)));
        if (asset.ownership === 'joint' && partnerAgeNow != null) {
            const partnerAtCommencement = asset.__partnerAgeAtCommencement != null ? $f7f7b62814c3b615$var$numOr(asset.__partnerAgeAtCommencement, 0) : partnerAgeNow - elapsed;
            if (asset.__partnerAgeAtCommencement == null) asset.__partnerAgeAtCommencement = partnerAtCommencement;
            asset.assessableAsset = purchase / 2 * $f7f7b62814c3b615$export$514e014a7cb2a24(ageAtCommencement, elapsed) + purchase / 2 * $f7f7b62814c3b615$export$514e014a7cb2a24(partnerAtCommencement, elapsed);
        } else asset.assessableAsset = purchase * $f7f7b62814c3b615$export$514e014a7cb2a24(ageAtCommencement, elapsed);
        if (terms.deferralYears > 0) {
            const started = elapsed >= terms.deferralYears;
            asset.annualPayment = started ? Math.max(0, $f7f7b62814c3b615$var$numOr(asset.deferredAnnualPayment, 0)) : 0;
            asset.assessableIncome = started ? Math.max(0, $f7f7b62814c3b615$var$numOr(asset.deferredAssessableIncome, asset.annualPayment * 0.6)) : 0;
        }
        /*
         * INFLATION-LINKED (15 Oct 2026): the payment rises at CPI each year from the year payments
         * start, off the first-year payment stamped the first time the asset is aged (a profile-entered
         * annuity's `income`, a builder's `annualPayment`). 60% of the risen payment counts as income.
         */ if (terms.indexed) {
            const started = elapsed >= terms.deferralYears;
            if (started) {
                if (asset.__annuityBasePayment == null) asset.__annuityBasePayment = Math.max(0, $f7f7b62814c3b615$var$numOr(asset.annualPayment ?? asset.income, 0));
                const base = $f7f7b62814c3b615$var$numOr(asset.__annuityBasePayment, 0);
                const yearsPaying = Math.max(0, elapsed - terms.deferralYears);
                asset.annualPayment = $f7f7b62814c3b615$var$roundCurrency(base * Math.pow(1 + Math.max(0, indexationPct) / 100, yearsPaying));
                asset.assessableIncome = $f7f7b62814c3b615$var$roundCurrency(asset.annualPayment * 0.6);
            }
        }
        /*
         * A GUARANTEE PERIOD (15 Oct 2026): within it the estate receives the remaining guaranteed
         * payments as a lump sum, never more than the capital access schedule's death-benefit ceiling
         * for that year. Beside a residual the schedule already gives, the larger stands.
         */ if (terms.guaranteePeriodYears > 0) {
            const paying = Math.max(0, $f7f7b62814c3b615$var$numOr(asset.annualPayment ?? terms.annualPayment, 0));
            const remaining = Math.max(0, terms.guaranteePeriodYears - elapsed) * paying;
            const ceiling = asset.capitalAccessPeriodYears != null ? purchase * $f7f7b62814c3b615$export$704532a9d5d3e528(elapsed, $f7f7b62814c3b615$var$numOr(asset.capitalAccessPeriodYears, 0)) : purchase;
            const guaranteed = $f7f7b62814c3b615$var$roundCurrency(Math.min(remaining, ceiling));
            asset.residualValue = Math.max($f7f7b62814c3b615$var$numOr(asset.residualValue, 0), guaranteed);
        }
        return {
            matured: false,
            residualPaid: 0
        };
    }
    // Fixed term: capital comes back through the payments, so the counted value falls to the residual.
    if (terms.matured) {
        asset.value = 0;
        asset.annualPayment = 0;
        asset.assessableIncome = 0;
        return {
            matured: true,
            residualPaid: terms.residualValue
        };
    }
    asset.value = Math.max(terms.residualValue, terms.purchaseAmount - terms.deductionAmount * terms.yearsElapsed);
    return {
        matured: false,
        residualPaid: 0
    };
}
function $f7f7b62814c3b615$export$38d1175d7c1034ee(asset) {
    const terms = $f7f7b62814c3b615$export$39dd0455f19e0b2c(asset);
    // The guaranteed shape is worth its whole price to the estate, always.
    if (terms.kind === 'guaranteed') return Math.max(0, terms.purchaseAmount);
    if (terms.kind !== 'lifetime') return Math.max(0, $f7f7b62814c3b615$var$numOr(asset?.value, 0));
    return asset?.residualValue !== undefined ? Math.max(0, $f7f7b62814c3b615$var$numOr(asset.residualValue, 0)) : Math.max(0, $f7f7b62814c3b615$var$numOr(asset?.value, 0));
}
function $f7f7b62814c3b615$export$5dc1cd0ab6cd8d79(record, overrides = {}) {
    const isLifetime = record.annuityType === 'lifetime';
    const isGuaranteed = record.annuityType === 'guaranteed';
    const deferralYears = Math.max(0, $f7f7b62814c3b615$var$numOr(record.deferralYears, 0));
    const kindLabel = isGuaranteed ? 'Guaranteed' : isLifetime ? deferralYears > 0 ? 'Deferred lifetime' : 'Lifetime' : 'Fixed-term';
    const asset = {
        id: overrides.id ?? record.id,
        type: 'annuities',
        description: overrides.description ?? `${kindLabel} annuity`,
        value: record.purchaseAmount,
        purchasePrice: record.purchaseAmount,
        ownership: overrides.ownership ?? record.owner ?? 'client',
        annualPayment: record.annualPayment,
        assessableIncome: record.assessableIncome,
        residualValue: record.residualValue,
        deductionAmount: record.deductionAmount,
        termYears: record.termYears || null,
        annuityType: record.annuityType,
        __annuityYearsElapsed: 0
    };
    if (record.age != null) asset.__ageAtCommencement = record.age;
    if (record.partnerAge != null) asset.__partnerAgeAtCommencement = record.partnerAge;
    if (isGuaranteed) {
        asset.assessableAsset = record.assessableAsset;
        asset.residualCapital = 1;
        asset.annuitySlice = record.annuitySlice;
        asset.insuranceSlice = record.insuranceSlice;
        if (record.ownerSex) asset.__ownerSex = record.ownerSex;
    }
    if (isLifetime) {
        asset.assessableAsset = record.assessableAsset;
        asset.residualCapital = Math.min(1, Math.max(0, $f7f7b62814c3b615$var$numOr(record.residualCapital, 0)));
        if (record.capitalAccessPeriodYears != null) asset.capitalAccessPeriodYears = $f7f7b62814c3b615$var$numOr(record.capitalAccessPeriodYears, 0) || null;
        if (record.lifeExpectancySexKnown != null) asset.lifeExpectancySexKnown = !!record.lifeExpectancySexKnown;
        if (record.ownerSex) asset.__ownerSex = record.ownerSex;
        if (deferralYears > 0) {
            asset.deferralYears = deferralYears;
            asset.deferredAnnualPayment = record.deferredAnnualPayment;
            asset.deferredAssessableIncome = record.deferredAssessableIncome;
        }
        // The inflation-linked shape and a guarantee period, so the ageing plugin grows the payment
        // and the estate carries the guarantee (15 Oct 2026).
        if (record.indexation) asset.indexed = true;
        if ($f7f7b62814c3b615$var$numOr(record.guaranteePeriodYears, 0) > 0) asset.guaranteePeriodYears = $f7f7b62814c3b615$var$numOr(record.guaranteePeriodYears, 0);
        if ($f7f7b62814c3b615$var$numOr(record.reversionPct, -1) >= 0) asset.reversionPct = $f7f7b62814c3b615$var$numOr(record.reversionPct, 0);
    }
    return asset;
}


const $ca198d51af38f7a6$export$7a71776828710814 = ({ factFind: factFind, strategyOptions: strategyOptions, isPartnered: isPartnered, clientAge: clientAge, partnerAge: partnerAge, clientResidency: clientResidency, partnerResidency: partnerResidency, yearsSinceRented: yearsSinceRented, rvResident: rvResident, rvInterestHeld: rvInterestHeld, rvIsHomeowner: rvIsHomeowner, rvEntryContribution: rvEntryContribution, grannyFlatCountedInterest: grannyFlatCountedInterest = 0, structureAttribution: structureAttribution })=>{
    const { assets: assets, income: income = {} } = factFind;
    let assessableAssets = 0;
    let assessableAssetsNoHome = 0;
    let financialAssetsForDeeming = 0;
    let assessableIncomeFromPensions = 0;
    let netRentalIncomeForPension = 0;
    let otherAssessableIncome = 0;
    let partnerAssessableIncomeFromPensions = 0;
    let partnerNetRentalIncomeForPension = 0;
    let partnerOtherAssessableIncome = 0;
    let investmentPropertyRentalForPension = 0;
    let partnerInvestmentPropertyRentalForPension = 0;
    const definedBenefitDetails = [];
    // Process 'Other Incomes'
    (income.otherIncomes || []).forEach((inc)=>{
        const incomeType = (0, $1abe73eeef086faf$export$3599b35124f1fb09).find((t)=>t.id === inc.type);
        // A DEFINED BENEFIT PENSION (SS Guide 4.9.3.30, 4.9.2.20, 4.9.5.60; definedBenefitPension.ts):
        // income = the payment less its deductible amount, the deductible capped at 10% of the payment;
        // an asset only where the pension product postdates 20 Sep 1998 (then payment × the valuation
        // factor for the owner's age), never deemed.
        if ((0, $f94c75e8792c4be0$export$ecbf3b113ae95cba)(inc)) {
            const assessable = (0, $f94c75e8792c4be0$export$5cd4c78204505f87)(inc);
            const ownerAge = inc.ownership === 'partner' && isPartnered ? partnerAge : clientAge;
            const assetValue = (0, $f94c75e8792c4be0$export$10a68bbb3610b29f)(inc, ownerAge, (0, $f94c75e8792c4be0$export$3ab31fcc31991e8a));
            if (inc.ownership === 'client') otherAssessableIncome += assessable;
            else if (inc.ownership === 'partner' && isPartnered) partnerOtherAssessableIncome += assessable;
            else {
                otherAssessableIncome += assessable / 2;
                if (isPartnered) partnerOtherAssessableIncome += assessable / 2;
            }
            if (assetValue > 0) {
                assessableAssets += assetValue;
                assessableAssetsNoHome += assetValue;
            }
            const payment = (0, $f94c75e8792c4be0$export$7a7c8a164271f50d)(inc);
            const entered = (0, $f94c75e8792c4be0$export$84b1b46a5f039238)(inc);
            const exempt = (0, $f94c75e8792c4be0$export$e7a717cb4a367b12)(inc);
            definedBenefitDetails.push({
                description: inc.description || (0, $f94c75e8792c4be0$export$9bb8c8dca6c61774)(inc.dbFund).name,
                annualPayment: payment,
                deductibleEntered: entered,
                deductibleApplied: payment - assessable,
                assessableIncome: assessable,
                assetTestExempt: exempt,
                assetValue: assetValue,
                valuationFactor: exempt || ownerAge == null ? null : (0, $f94c75e8792c4be0$export$de94e21a93329055)(ownerAge, (0, $f94c75e8792c4be0$export$f0fe79d04edb032c)(inc, (0, $f94c75e8792c4be0$export$3ab31fcc31991e8a)))
            });
            return;
        }
        let isAssessable = incomeType?.assessable;
        if (incomeType?.isCustom) isAssessable = inc.isAssessable;
        if (isAssessable) {
            // Boarders and lodgers: only part of the payment is income (boardIncomeShare).
            const amount = (inc.amount || 0) * (inc.type === 'boarders' ? (0, $1abe73eeef086faf$export$987faef8d6ff298e)(inc.boardType) : 1);
            if (inc.ownership === 'client') otherAssessableIncome += amount;
            else if (inc.ownership === 'partner' && isPartnered) partnerOtherAssessableIncome += amount;
            else {
                otherAssessableIncome += amount / 2;
                if (isPartnered) partnerOtherAssessableIncome += amount / 2;
            }
        }
    });
    if (strategyOptions.rentHome) {
        const annualRent = (strategyOptions.rentAmount || 0) * 52;
        const annualExpenses = strategyOptions.rentExpenses || 0;
        const netRental = annualRent - annualExpenses;
        if (yearsSinceRented >= 2) {
            const homeValue = factFind.home?.value || 0;
            assessableAssets += homeValue;
        }
        const homeOwnership = factFind.home?.ownership || 'joint';
        if (homeOwnership === 'client') netRentalIncomeForPension += netRental;
        else if (homeOwnership === 'partner') {
            if (isPartnered) partnerNetRentalIncomeForPension += netRental;
            else netRentalIncomeForPension += netRental;
        } else {
            netRentalIncomeForPension += netRental / 2;
            if (isPartnered) partnerNetRentalIncomeForPension += netRental / 2;
        }
    }
    // The family home is exempt from the assets test ONLY while it is someone's principal residence.
    const someoneLivesInFamilyHome = clientResidency === 'own_home' || isPartnered && partnerResidency === 'own_home';
    const inAgedCare = clientResidency === 'aged_care' || isPartnered && partnerResidency === 'aged_care';
    const retainedFormerHomeAssessable = !someoneLivesInFamilyHome && !inAgedCare && !strategyOptions.rentHome && !strategyOptions.downsizeHome;
    if (strategyOptions.formerPrincipalHomeAssessable || retainedFormerHomeAssessable) {
        const homeValue = factFind.home?.value || 0;
        if (homeValue > 0) assessableAssets += homeValue;
    }
    /*
     * LAND THE HOME EXEMPTION DOES NOT COVER — land on a separate title, and land beyond 2 hectares
     * where the extended land use test fails. See shared/src/calculation/homeLandRules.ts for the
     * rule and its sources.
     *
     * It goes into `assessableAssetsNoHome` as well as `assessableAssets`, and that placement is the
     * point: residential aged care counts the HOME only up to the capped amount, then adds
     * `assessableAssetsNoHome` on top at full value. Land outside the exemption is not the home, so
     * it must not inherit the cap.
     *
     * Skipped entirely when the whole home value has already been assessed above — a home rented for
     * two years or more, or a former home retained — because these values are a PORTION of that same
     * home value, and counting them again would assess the land twice.
     */ const homeAlreadyAssessedInFull = strategyOptions.rentHome && yearsSinceRented >= 2 || !!strategyOptions.formerPrincipalHomeAssessable || retainedFormerHomeAssessable;
    if (!homeAlreadyAssessedInFull) {
        const nonExemptLand = (0, $7d105583031dfe3e$export$2649ec7132aeb253)(factFind).total;
        if (nonExemptLand > 0) {
            assessableAssets += nonExemptLand;
            assessableAssetsNoHome += nonExemptLand;
        }
    }
    // Funeral bonds are exempt up to the limit PER PERSON, spent in the order the bonds are found.
    const funeralBondExemptLimit = isPartnered ? (0, $1abe73eeef086faf$export$aca3edb7cd7a3f17) * 2 : (0, $1abe73eeef086faf$export$aca3edb7cd7a3f17);
    let funeralBondExemptUsed = 0;
    const pre2015ABPDetails = [];
    Object.entries(assets || {}).forEach(([type, assetList])=>{
        (assetList || []).forEach((asset)=>{
            if ((0, $834081b8d1820bea$export$e498786b37b83f3f)(asset.ownership)) return;
            // Coerced on purpose: the API route guarantees numeric leaves (factFindNumericSchema), but a
            // fact-find built in a test with a text value would otherwise be CONCATENATED into the sum
            // ('0' + 1000 → '01000') and every figure downstream of it silently ten times too large.
            const value = Number(asset.value) || 0;
            /*
             * ANNUITIES, read one way (annuityStrategies.ts, F.7 — 17 Sep 2026). A lifetime annuity
             * counts at 60%/30% of its purchase price; a fixed term at its reducing value. A SHORT
             * term (five years or less) is a financial investment and is deemed below; a long term
             * and a lifetime annuity have their payments counted as income instead (further down).
             */ const annuityTerms = type === 'annuities' ? (0, $f7f7b62814c3b615$export$39dd0455f19e0b2c)(asset) : null;
            const annuityOwnerAge = asset.ownership === 'partner' ? partnerAge : clientAge;
            const assessableValue = annuityTerms ? (0, $f7f7b62814c3b615$export$5296e135279e19b5)(asset, annuityOwnerAge) : value;
            const isPre2015ABP = type === 'accountBasedPensions' && asset.commencementDateOption === 'pre-2015';
            if (!isPre2015ABP && ([
                'bankAccounts',
                'termDeposits',
                'shares',
                'investmentBonds',
                'accountBasedPensions',
                'loansToOthers'
            ].includes(type) || annuityTerms != null && annuityTerms.kind === 'shortTerm')) {
                if (asset.ownership === 'client') financialAssetsForDeeming += value;
                else if (asset.ownership === 'partner' && isPartnered) financialAssetsForDeeming += value;
                else if (isPartnered) financialAssetsForDeeming += value;
                else financialAssetsForDeeming += value / 2;
            }
            if (type === 'superannuation') {
                if (asset.ownership === 'client' && clientAge && clientAge < (0, $1abe73eeef086faf$export$5b6998cba7880742)) return;
                if (asset.ownership === 'partner' && partnerAge && partnerAge < (0, $1abe73eeef086faf$export$5b6998cba7880742)) return;
            }
            if (type === 'home') {
                if (!strategyOptions.rentHome && !strategyOptions.downsizeHome) assessableAssets += value;
            } else if (type === 'radPaid') ;
            else if (type === 'prepaidFuneral') ;
            else if (type === 'funeralBonds') {
                const remainingExempt = funeralBondExemptLimit - funeralBondExemptUsed;
                const exemptPortion = Math.min(value, remainingExempt);
                const assessablePortion = Math.max(0, value - exemptPortion);
                funeralBondExemptUsed += exemptPortion;
                if (assessablePortion > 0) {
                    assessableAssets += assessablePortion;
                    assessableAssetsNoHome += assessablePortion;
                }
            } else if (type === 'investmentProperty') {
                const rent = asset.rent || 0;
                const expenses = asset.expenses || 0;
                const netRental = Math.max(0, rent - expenses);
                if (asset.ownership === 'client') investmentPropertyRentalForPension += netRental;
                else if (asset.ownership === 'partner' && isPartnered) partnerInvestmentPropertyRentalForPension += netRental;
                else {
                    const half = netRental / 2;
                    investmentPropertyRentalForPension += half;
                    if (isPartnered) partnerInvestmentPropertyRentalForPension += half;
                }
                assessableAssets += assessableValue;
                assessableAssetsNoHome += assessableValue;
            } else {
                assessableAssets += assessableValue;
                assessableAssetsNoHome += assessableValue;
            }
            // Pre-1 Jan 2015 ABP: assessable income = annual payment minus deductible amount.
            if (isPre2015ABP) {
                const purchasePrice = asset.purchasePrice || 0;
                let commutations = 0;
                if (strategyOptions.radFunding && type === 'accountBasedPensions') {
                    const radKey = `${type}-${asset.id}`;
                    commutations = Math.max(0, parseFloat(String(strategyOptions.radFunding[radKey])) || 0);
                }
                if (commutations === 0 && asset.__originalValue != null) {
                    const orig = asset.__originalValue || 0;
                    const curr = asset.value || 0;
                    commutations = Math.max(0, orig - curr);
                }
                const annualPayment = asset.income || 0;
                let ownerAge;
                if (asset.ownership === 'client') ownerAge = clientAge;
                else if (asset.ownership === 'partner' && isPartnered) ownerAge = partnerAge;
                else if (isPartnered) ownerAge = clientAge != null && partnerAge != null ? Math.min(clientAge, partnerAge) : clientAge || partnerAge;
                else ownerAge = clientAge;
                let ageAtCommencement = ownerAge != null ? ownerAge : 65;
                if (asset.commencementDate && !asset.commencementDateUnsure) {
                    const commDate = new Date(asset.commencementDate);
                    const now = new Date();
                    const yearsSince = (now.getTime() - commDate.getTime()) / 31557600000;
                    ageAtCommencement = Math.round(ageAtCommencement - yearsSince);
                }
                const ageClamped = Math.min(95, Math.max(65, ageAtCommencement));
                const relevantNumber = (0, $1abe73eeef086faf$export$c8dfc1647fc5656)[ageClamped] != null ? (0, $1abe73eeef086faf$export$c8dfc1647fc5656)[ageClamped] : (0, $1abe73eeef086faf$export$c8dfc1647fc5656)[95];
                const deductibleAmount = relevantNumber > 0 ? Math.max(0, purchasePrice - commutations) / relevantNumber : 0;
                const assessableFromABP = Math.max(0, annualPayment - deductibleAmount);
                pre2015ABPDetails.push({
                    description: (asset.description || 'ABP').trim() || 'ABP',
                    relevantNumber: relevantNumber,
                    deductibleAmount: deductibleAmount,
                    assessableAmount: assessableFromABP,
                    commutations: commutations
                });
                if (asset.ownership === 'client') assessableIncomeFromPensions += assessableFromABP;
                else if (asset.ownership === 'partner' && isPartnered) partnerAssessableIncomeFromPensions += assessableFromABP;
                else {
                    const half = assessableFromABP / 2;
                    assessableIncomeFromPensions += half;
                    if (isPartnered) partnerAssessableIncomeFromPensions += half;
                }
            }
            /*
             * ANNUITY PAYMENTS IN THE INCOME TEST. Until 17 Sep 2026 no annuity's payments reached
             * this test at all — the asset was counted and the income forgotten, which flattered every
             * annuity strategy by the income test's 50-cent taper on 60% of the payments. Lifetime:
             * 60% of the payments (nil while deferred). Long-term fixed: payment less the deductible
             * amount. Short-term fixed: nothing here — it was deemed above.
             */ if (annuityTerms) {
                const assessableFromAnnuity = (0, $f7f7b62814c3b615$export$96362d760c8a6bfb)(asset);
                if (assessableFromAnnuity > 0) {
                    if (asset.ownership === 'client') assessableIncomeFromPensions += assessableFromAnnuity;
                    else if (asset.ownership === 'partner' && isPartnered) partnerAssessableIncomeFromPensions += assessableFromAnnuity;
                    else {
                        const half = assessableFromAnnuity / 2;
                        assessableIncomeFromPensions += half;
                        if (isPartnered) partnerAssessableIncomeFromPensions += half;
                    }
                }
            }
        });
    });
    if (structureAttribution) {
        assessableAssets += structureAttribution.assessableAssets;
        assessableAssetsNoHome += structureAttribution.assessableAssetsNoHome;
        financialAssetsForDeeming += structureAttribution.financialAssetsForDeeming;
        investmentPropertyRentalForPension += structureAttribution.investmentPropertyRentalForPension;
        partnerInvestmentPropertyRentalForPension += structureAttribution.partnerInvestmentPropertyRentalForPension;
        assessableIncomeFromPensions += structureAttribution.assessableIncomeFromPensions;
        partnerAssessableIncomeFromPensions += structureAttribution.partnerAssessableIncomeFromPensions;
        otherAssessableIncome += structureAttribution.clientDistributionMeansTestIncome || 0;
        partnerOtherAssessableIncome += structureAttribution.partnerDistributionMeansTestIncome || 0;
    }
    // A retirement-village entry contribution at or below the Extra Allowable Amount is assessed as an
    // asset in its own right (and NOT deemed); above it the resident is a homeowner and it is exempt.
    if ((rvInterestHeld ?? rvResident) && !rvIsHomeowner && rvEntryContribution > 0) {
        assessableAssets += rvEntryContribution;
        assessableAssetsNoHome += rvEntryContribution;
    }
    // The granny flat twin of the rule above (Social Security Guide 4.6.4, special residences).
    if (grannyFlatCountedInterest > 0) {
        assessableAssets += grannyFlatCountedInterest;
        assessableAssetsNoHome += grannyFlatCountedInterest;
    }
    return {
        assessableAssets: assessableAssets,
        assessableAssetsNoHome: assessableAssetsNoHome,
        financialAssetsForDeeming: financialAssetsForDeeming,
        assessableIncomeFromPensions: assessableIncomeFromPensions,
        netRentalIncomeForPension: netRentalIncomeForPension,
        otherAssessableIncome: otherAssessableIncome,
        investmentPropertyRentalForPension: investmentPropertyRentalForPension,
        partnerAssessableIncomeFromPensions: partnerAssessableIncomeFromPensions,
        partnerNetRentalIncomeForPension: partnerNetRentalIncomeForPension,
        partnerOtherAssessableIncome: partnerOtherAssessableIncome,
        partnerInvestmentPropertyRentalForPension: partnerInvestmentPropertyRentalForPension,
        pre2015ABPDetails: pre2015ABPDetails,
        definedBenefitDetails: definedBenefitDetails
    };
};


/**
 * Deemed income & deprivation — the two rules that make a client's means-test position larger than
 * what they literally hold, as a pure function.
 *
 *   - DEEMING: Centrelink does not ask what a client's financial assets actually earn. It assumes a
 *     return — 1.25% up to the situation's threshold, 3.25% above it — and assesses that instead. A
 *     client with $500,000 in a zero-interest account is assessed on deemed income all the same, and a
 *     client whose shares beat the rates keeps the difference untested.
 *   - DEPRIVATION: a gift above the free areas doesn't leave the balance sheet for five years. What is
 *     "deprived" keeps counting BOTH ways — as an asset for the assets test, and as a financial asset
 *     that is then deemed — which is why the two rules are struck together here rather than apart: the
 *     deeming base includes the deprived amount. A granny-flat arrangement whose entry contribution
 *     exceeded the reasonableness cap is deprivation of exactly the same kind, and is folded in.
 *
 * What this does NOT do is decide which assets are financial in the first place, or apply any threshold
 * to the income it produces. The former is upstream in `assessableMeans.ts`; the latter is the income
 * test in `agePension.ts`. It takes the base as given and hands back a larger one.
 *
 * Extracted from `calculateFinancials`'s "--- 2. Deemed Income from Financial Assets ---" block, which
 * still calls it — through the injectable {@link DeemedIncomeAssessor} seam, so the projection engine
 * can hand in the assessor owned by its deemedIncomePlugin. See that plugin for why the code lives here
 * rather than in it.
 */ 


function $e84dc16b58a17cc1$export$5ac28bba1918f63e(financialAssets, threshold) {
    if (financialAssets <= threshold) return financialAssets * (0, $1abe73eeef086faf$export$7ccf16e55e6cf86b);
    return threshold * (0, $1abe73eeef086faf$export$7ccf16e55e6cf86b) + (financialAssets - threshold) * (0, $1abe73eeef086faf$export$fe9b80c24d06bb6b);
}
const $e84dc16b58a17cc1$export$abef4f2b4ca712ce = (input)=>{
    const { rates: rates, relationshipStatus: relationshipStatus, factFind: factFind, strategyOptions: strategyOptions, asOfDate: asOfDate } = input;
    const deemingThreshold = rates.deemingThresholds[relationshipStatus];
    // A granny-flat entry contribution above the reasonableness cap is a gift made the day the arrangement
    // starts, not today — so it counts for five years from that day (24 Oct 2026: it was bucketed into the
    // financial year, which dropped a June arrangement's gift about a year early). Passed to the gifting
    // engine as a dated gift; the free areas apply to it as to any other.
    let grannyFlatGift = null;
    {
        const gfDep = (0, $a528307a9ba99a26$export$eb48a6112ea73d5a)(factFind, rates.pensionRates.couple);
        const dateEntered = factFind?.grannyFlat?.dateEntered;
        if (gfDep && gfDep.deprivation > 0 && dateEntered) grannyFlatGift = [
            {
                date: String(dateEntered),
                amount: gfDep.deprivation
            }
        ];
    }
    const deprivedAsset = (0, $171a6d8ba8937a5f$export$6f9e3cf7d82eb9f9)(factFind.giftsHistory || {}, strategyOptions, asOfDate, null, grannyFlatGift);
    const assessableAssets = input.assessableAssets + deprivedAsset;
    const financialAssetsForDeeming = input.financialAssetsForDeeming + deprivedAsset;
    return {
        deemedIncome: $e84dc16b58a17cc1$export$5ac28bba1918f63e(financialAssetsForDeeming, deemingThreshold),
        deemingThreshold: deemingThreshold,
        deprivedAsset: deprivedAsset,
        assessableAssets: assessableAssets,
        financialAssetsForDeeming: financialAssetsForDeeming
    };
};


/**
 * Expenses — what the year costs the client, as a pure function.
 *
 * Four outflows, each with a rule of its own:
 *
 *   - LIVING EXPENSES: the client's cost of living, which a strategy scenario may override
 *     (`scenarioLivingExpenses`) to model spending differently without touching the fact-find.
 *   - CAPITAL EXPENSES: one-off costs a client has pencilled in against a MONTH (`YYYY-MM`) — a new car,
 *     a bathroom. Only those falling inside the year being assessed count, which is the whole subtlety
 *     here: see {@link sumCapitalExpensesForProjectionPeriod}.
 *   - THE PARTNER'S RENT: where the rent-the-home strategy has the client renting their home out, the
 *     partner's own rent elsewhere is a weekly figure, annualised.
 *   - AGED-CARE COSTS: the annual cost of care, passed in already computed by the caller
 *     (`integratedAgedCareCost`) — the aged-care engine's figure, not one struck here.
 *
 * What this does NOT do is total the year's outgoings. Tax, rental expenses and loan repayments are
 * assessed elsewhere (incomeTax.ts, incomeAssessment.ts, loanRepayments.ts) and `calculateFinancials`
 * adds all of them together with these to strike its cashflow.
 *
 * Extracted from `calculateFinancials`'s "--- 7. Final Cash Flow & Net Worth ---" block, which still
 * calls it — through the injectable {@link ExpenseAssessor} seam, so the projection engine can hand in
 * the assessor owned by its expensesPlugin, the plugin that already owns WHEN these outflows leave the
 * bank.
 */ /**
 * The living expenses a scenario runs on (owner, 9 Oct 2026).
 *
 * The aged care screen asks what the household spends once care begins. An adviser may enter $0 —
 * the resident's needs are met by the home and there is no one else to keep — and that is a real
 * answer, not a blank. The year-by-year projection always honoured it; the first-year assessment,
 * the Suggestion Engine's candidates and several screens read it with `||`, so $0 fell back to the
 * profile's figure. Bob's walk-in projection ran on $0 while every card around it ran on $25,000,
 * and the two estates differed by $107,733.
 *
 * One rule now: a figure that was ENTERED — any finite number, $0 included — is used; only a blank
 * (undefined, null, empty text) falls back to the fact-find's living expenses.
 */ function $1b5ad53cec30af73$export$6be0003f148d19de(value) {
    if (value === undefined || value === null) return null;
    if (typeof value === 'string' && value.trim() === '') return null;
    const n = typeof value === 'number' ? value : Number(String(value).replace(/[$,\s]/g, ''));
    return Number.isFinite(n) ? Math.max(0, n) : null;
}
function $1b5ad53cec30af73$export$df3d7258e77c9184(scenario, fallback) {
    const entered = $1b5ad53cec30af73$export$6be0003f148d19de(scenario);
    if (entered != null) return entered;
    return $1b5ad53cec30af73$export$6be0003f148d19de(fallback) ?? 0;
}


/**
 * The projection anchor date — where "Year 1" starts, and how it is resolved from the two places a
 * caller can specify it.
 *
 * Anchors are DAY-PRECISE. They were rounded back to the first of the month until 2026-08-06, on the
 * grounds that strategy periods are month-based to match the fact-find's `YYYY-MM` fields — a capital
 * expense recorded as `2027-04` has no day, so the bands it is tested against were given none either.
 * The cost was that a projection run on the 6th opened on the 1st and told the adviser so, charging the
 * client for five days before they had walked in the door.
 *
 * Only the ANCHOR is day-precise; the fact-find's `YYYY-MM` fields still are not, and
 * `sumCapitalExpensesForProjectionPeriod` reconciles the two by comparing a `YYYY-MM` expense against
 * the MONTH the period opens in. So an expense pencilled in for the opening month still counts in full,
 * which is the lenient reading and the one that keeps a mid-month anchor from silently dropping it.
 *
 * What day precision cost elsewhere: the twelve monthly growth instalments assume a period opens on an
 * instalment boundary, and a period opening on the 6th skips its month's instalment entirely. See
 * {@link openingMonthGrowthFraction}, the stub that makes up the difference.
 *
 * Extracted from `financialCalculations.ts` when the expense assessment moved to `expenses.ts`, which
 * needs these too — keeping them there would have made the two modules import each other's values at
 * runtime. They are re-exported from `financialCalculations.ts`, where existing callers import
 * {@link resolveProjectionAnchorDate} from.
 */ function $25a6d6ce063e5c01$export$df3923bccac58bc5() {
    const n = new Date();
    return new Date(n.getFullYear(), n.getMonth(), n.getDate());
}
function $25a6d6ce063e5c01$export$9bd49f46f18fa631(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}
function $25a6d6ce063e5c01$export$e657445e487096a6(strategyOptions = {}) {
    const raw = strategyOptions?.projectionAnchorDate;
    if (raw != null && raw !== '') {
        const d = raw instanceof Date ? new Date(raw.getTime()) : new Date(raw);
        if (!Number.isNaN(d.getTime())) return $25a6d6ce063e5c01$export$9bd49f46f18fa631(d);
    }
    return $25a6d6ce063e5c01$export$df3923bccac58bc5();
}
function $25a6d6ce063e5c01$export$350c843ef3b76423(projectionContext = {}) {
    const raw = projectionContext.projectionAnchorDate;
    if (raw != null && raw !== '') {
        const d = raw instanceof Date ? raw : new Date(raw);
        if (!Number.isNaN(d.getTime())) return $25a6d6ce063e5c01$export$9bd49f46f18fa631(d);
    }
    return $25a6d6ce063e5c01$export$df3923bccac58bc5();
}



function $40f7e03c879d6a85$export$f33bc506e2de0119(yearField) {
    if (!yearField || typeof yearField !== 'string') return null;
    const m = String(yearField).trim().match(/^(\d{4})-(\d{2})$/);
    if (!m) return null;
    const y = parseInt(m[1], 10);
    const mo = parseInt(m[2], 10) - 1;
    if (mo < 0 || mo > 11 || y < 1900 || y > 2200) return null;
    return new Date(y, mo, 1);
}
function $40f7e03c879d6a85$export$913493dc085fc47a(expenses, projectionContext = {}) {
    const anchor = (0, $25a6d6ce063e5c01$export$350c843ef3b76423)(projectionContext);
    const py = projectionContext.yearIndex;
    const strategyYear = py != null && py > 0 ? py : 1;
    const yearStart = new Date(anchor.getFullYear() + strategyYear - 1, anchor.getMonth(), 1);
    const yearEnd = new Date(anchor.getFullYear() + strategyYear, anchor.getMonth(), 1);
    const list = expenses?.capitalExpenses || [];
    return list.reduce((sum, exp)=>{
        const d = $40f7e03c879d6a85$export$f33bc506e2de0119(exp.year);
        if (!d || Number.isNaN(d.getTime())) return sum;
        if (d >= yearStart && d < yearEnd) return sum + (exp.amount || 0);
        return sum;
    }, 0);
}
function $40f7e03c879d6a85$export$125a551309f0a1c2(expenses, projectionContext = {}) {
    const rawStart = projectionContext.capitalExpensePeriodStart;
    const rawEnd = projectionContext.capitalExpensePeriodEnd;
    if (rawStart != null && rawEnd != null) {
        const periodStart = rawStart instanceof Date ? rawStart : new Date(rawStart);
        const periodEnd = rawEnd instanceof Date ? rawEnd : new Date(rawEnd);
        if (!Number.isNaN(periodStart.getTime()) && !Number.isNaN(periodEnd.getTime())) {
            const ps = new Date(periodStart.getFullYear(), periodStart.getMonth(), 1);
            const list = expenses?.capitalExpenses || [];
            return list.reduce((sum, exp)=>{
                const d = $40f7e03c879d6a85$export$f33bc506e2de0119(exp.year);
                if (!d || Number.isNaN(d.getTime())) return sum;
                const monthStart = new Date(d.getFullYear(), d.getMonth(), 1);
                if (monthStart.getTime() >= ps.getTime() && monthStart.getTime() <= periodEnd.getTime()) return sum + (exp.amount || 0);
                return sum;
            }, 0);
        }
    }
    return $40f7e03c879d6a85$export$913493dc085fc47a(expenses, projectionContext);
}
function $40f7e03c879d6a85$export$18f81a38244ba86a(factFind, strategyOptions, projectionContext) {
    if (!factFind) return {
        housingCosts: 0,
        housingCostsLabel: ''
    };
    const people = factFind.adviceFor === 'couple' ? [
        'client',
        'partner'
    ] : [
        'client'
    ];
    const careFrac = Number(projectionContext?.careFrac);
    const shareOfYear = (kind)=>{
        if (people.some((p)=>(0, $d1b9bbc5238c0548$export$bbffb86c2f82211a)(factFind, p, strategyOptions) === kind)) return 1;
        const leftForCare = people.some((p)=>(0, $d1b9bbc5238c0548$export$bbffb86c2f82211a)(factFind, p, {}) === kind && (0, $d1b9bbc5238c0548$export$bbffb86c2f82211a)(factFind, p, strategyOptions) === 'aged_care');
        if (!leftForCare) return 0;
        return Number.isFinite(careFrac) ? Math.max(0, Math.min(1, 1 - careFrac)) : 0;
    };
    const escalation = Number(projectionContext?.housingEscalationFactor) > 0 ? Number(projectionContext.housingEscalationFactor) : 1;
    const rent = (Number(factFind.rent?.rentAmount) || 0) * 52 * shareOfYear('renting');
    const village = (Number(factFind.retirementVillage?.ongoingFees) || 0) * 52 * shareOfYear('retirement_village');
    const board = (Number(factFind.livingWithFamily?.boardPerWeek) || 0) * 52 * shareOfYear('with_family');
    const kinds = [
        rent > 0 ? 'rent' : '',
        village > 0 ? 'village fees' : '',
        board > 0 ? 'board' : ''
    ].filter(Boolean);
    return {
        housingCosts: (rent + village + board) * escalation,
        housingCostsLabel: kinds.join(', ')
    };
}
const $40f7e03c879d6a85$export$143d196fe9af26ab = ({ expenses: expenses, factFind: factFind, strategyOptions: strategyOptions, projectionContext: projectionContext })=>{
    const livingExpenses = (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(strategyOptions.scenarioLivingExpenses, expenses?.livingExpenses);
    const { housingCosts: housingCosts, housingCostsLabel: housingCostsLabel } = $40f7e03c879d6a85$export$18f81a38244ba86a(factFind, strategyOptions, projectionContext);
    const capitalExpenses = $40f7e03c879d6a85$export$125a551309f0a1c2(expenses, projectionContext);
    let partnerRent = 0;
    if (strategyOptions.rentHome && strategyOptions.partnerRent) partnerRent = strategyOptions.partnerRent * 52;
    const integratedAgedCareCost = strategyOptions.integratedAgedCareCost || 0;
    return {
        livingExpenses: livingExpenses,
        capitalExpenses: capitalExpenses,
        partnerRent: partnerRent,
        integratedAgedCareCost: integratedAgedCareCost,
        housingCosts: housingCosts,
        housingCostsLabel: housingCostsLabel
    };
};


/**
 * Net worth — everything the client owns, less everything they owe, as a pure function.
 *
 * The simplest of the assessments, with two things in it worth stating:
 *
 *   - THE HOME COUNTS. Unlike the means tests, where the family home is exempt while someone lives in
 *     it, net worth is what the client is actually worth — so the home is in, at its full value,
 *     always.
 *   - AN ANNUITY IS WORTH ITS RESIDUAL, not its purchase price. A lifetime annuity's `value` is what was
 *     put into it; what the client (or their estate) could still get back is `residualValue`, which
 *     declines to nothing over the guarantee period. Where that field is set it is what counts.
 *
 * Extracted from `calculateFinancials`'s "--- 7. Final Cash Flow & Net Worth ---" block, which still
 * calls it — through the injectable {@link NetWorthAssessor} seam, so the projection engine can hand in
 * the assessor owned by its netWorthPlugin.
 *
 * NOTE a sibling that is deliberately NOT merged into this: the netWorthPlugin has its own
 * `sumAssetValues`, which walks the same assets with the same annuity rule but ALSO skips non-object
 * entries and non-finite values, and emits debug logging. On well-formed data the two agree exactly.
 * They part company on two inputs only, both of which the HTTP boundary's numeric schema should already
 * have excluded:
 *   - an `Infinity` value propagates into the total here, where the plugin skips it;
 *   - a `null` entry in an asset list makes this walk THROW, where the plugin skips it.
 * (A `NaN` value behaves identically in both — `NaN || 0` is 0.) Unifying them would therefore change
 * what `calculateFinancials` returns, or whether it returns at all, so they are left as they are: the
 * projection reports the plugin's figure and this is what a standalone caller gets. See
 * netWorthPlugin.test.ts, which pins the difference.
 */ 


function $12a1d07f40c8ac3b$export$4d6dbfbefa93b8eb(factFind, strategyOptions = {}, asOfDate) {
    const today = (0, $4633117ee929ec27$export$6005e8b092eea057)(new Date());
    const asAt = asOfDate ? (0, $4633117ee929ec27$export$6005e8b092eea057)(new Date(asOfDate)) : today;
    // An OLD unit awaiting its payout after a move to another village or a granny flat (8 Oct 2026):
    // worth what it will pay until the day it does.
    const pending = strategyOptions.villageExit;
    const oldUnitPending = pending && !strategyOptions.villageInterestSold && pending.refundDate && asAt < pending.refundDate ? Math.max(0, Number(pending.entitlement) || 0) : 0;
    // A unit given up with its payout still to come is worth what it will pay — the entitlement fixed
    // on the day it was given up — not a resale that keeps growing (9 Oct 2026).
    if (oldUnitPending > 0) return oldUnitPending;
    // The village MODULE (a move IN) carries its own contract on the run's options and adds the
    // refundable contribution to its day-one figure itself (retirementVillageProjections.ts); its
    // plugin values every later year. Here, for its runs, only the old unit's payout.
    if (strategyOptions.retirementVillage) return oldUnitPending;
    if (!(0, $4633117ee929ec27$export$cb26bf32ff9b2b4d)(factFind, strategyOptions)) return oldUnitPending;
    const e = (0, $4633117ee929ec27$export$3da79be84c8bf9e7)(factFind, asAt, {
        resaleGrowthPct: (0, $2cee3e5f0555e7bc$export$2a98a0810772f8e0),
        resaleBaseDate: today
    });
    return e ? Math.max(0, e.entitlement) : 0;
}
const $12a1d07f40c8ac3b$export$496a401322cf5aad = ({ factFind: factFind, strategyOptions: strategyOptions = {}, asOfDate: asOfDate })=>{
    const { home: home, assets: assets, liabilities: liabilities } = factFind;
    let totalAssetsValue = 0;
    if (home && home.value) totalAssetsValue += home.value || 0;
    totalAssetsValue += $12a1d07f40c8ac3b$export$4d6dbfbefa93b8eb(factFind, strategyOptions, asOfDate);
    Object.values(assets || {}).forEach((assetList)=>{
        (assetList || []).forEach((asset)=>{
            if (asset.type === 'annuities') // A lifetime annuity is worth its residual; a fixed term the capital still to be
            // returned (its reducing `value`) — see annuityNetWorthValueOf.
            totalAssetsValue += (0, $f7f7b62814c3b615$export$38d1175d7c1034ee)(asset);
            else totalAssetsValue += asset.value || 0;
        });
    });
    let totalLiabilities = 0;
    Object.values(liabilities || {}).forEach((list)=>(list || []).forEach((item)=>totalLiabilities += item.balance || 0));
    return {
        netWorth: totalAssetsValue - totalLiabilities,
        totalAssetsValue: totalAssetsValue,
        totalLiabilities: totalLiabilities
    };
};


/**
 * Home-equity release — what a Reverse Mortgage or the Home Equity Access Scheme puts in the client's
 * hands this year, and what the means tests make of it, as a pure function.
 *
 * Both strategies turn home equity into spendable money without selling the home, and neither is repaid
 * out of cashflow: the balance compounds and is settled from the estate (that half is the projection
 * engine's loanPlugin, which owns these loans' balances). What this assesses is the near side of them —
 * the money arriving, and its means-test consequences:
 *
 *   - REGULAR PAYMENTS (either scheme) are cash income for the year: the instalment annualised at its
 *     own frequency. They are NOT an assessable asset — the money is drawn as it is spent.
 *   - A REVERSE MORTGAGE LUMP SUM is different, because what happens to it decides whether it is
 *     assessed. Spent on a RAD it is exempt (a RAD always is); left over it is cash the client now holds,
 *     and so both an assessable asset and a deemed financial one. It is never income: borrowing is not
 *     earning.
 *   - The HEAS pension reduction is structurally present and always zero. That is deliberate, not
 *     unfinished: L-AP2 in the legislation validation register records that HEAS payments are a
 *     non-assessable government loan which must NOT reduce the pension, and the field is kept so the
 *     old dollar-for-dollar deduction cannot quietly come back. See homeEquityReleaseFixes.test.ts.
 *
 * The other deliberate zero is L-RM1: a lump sum NOT going into a RAD reports no proceeds here, because
 * the caller that models such a strategy has already added the money to the client's bank balance
 * (the AgedCareAnalyser `simulatedFactFind` contract). Assessing it again would count it twice.
 *
 * Extracted from `calculateFinancials`'s "--- 3. Reverse Mortgage & HEAS Calculations ---" block, which
 * still calls it — through the injectable {@link HomeEquityReleaseAssessor} seam, so the projection
 * engine can hand in the assessor owned by its loanPlugin, which is the plugin that already owns these
 * two loans' compounding balances.
 */ function $cd0ced93285377f1$export$33e2f80d866787ac(paymentAmount, frequency) {
    const amount = paymentAmount || 0;
    return frequency === 'fortnightly' ? amount * 26 : amount * 12;
}
const $cd0ced93285377f1$export$77552529cd80a5f8 = (input)=>{
    const { strategyOptions: strategyOptions, factFind: factFind } = input;
    let reverseMortgageIncome = 0;
    let reverseMortgageLoanProceeds = 0;
    let heasIncome = 0;
    const heasAgePensionReduction = 0;
    if (strategyOptions.reverseMortgage && strategyOptions.reverseMortgageDetails) {
        const rmDetails = strategyOptions.reverseMortgageDetails;
        const useForRad = rmDetails.useForRad || false;
        if (rmDetails.loanStructure === 'lump_sum') {
            const loanAmount = rmDetails.loanAmount || 0;
            const establishmentFees = rmDetails.establishmentFees || 0;
            const netProceeds = Math.max(0, loanAmount - establishmentFees);
            reverseMortgageIncome = 0;
            if (useForRad) {
                // Whatever the RAD absorbs is exempt; only the remainder is a countable asset. No RAD
                // figure at all means the whole loan was raised for it, so nothing is left over.
                const radCap = strategyOptions.radInput || factFind?.radInput || 0;
                const radPortionApplied = radCap > 0 ? Math.min(netProceeds, radCap) : netProceeds;
                reverseMortgageLoanProceeds = Math.max(0, netProceeds - radPortionApplied);
            } else // L-RM1: the caller has already banked these proceeds — see this module's header.
            reverseMortgageLoanProceeds = 0;
        } else if (rmDetails.loanStructure === 'regular_payments') {
            reverseMortgageIncome = $cd0ced93285377f1$export$33e2f80d866787ac(rmDetails.regularPaymentAmount || 0, rmDetails.regularPaymentFrequency || 'fortnightly');
            reverseMortgageLoanProceeds = 0;
        }
    }
    if (strategyOptions.heas && strategyOptions.heasDetails) heasIncome = $cd0ced93285377f1$export$33e2f80d866787ac(strategyOptions.heasDetails.paymentAmount || 0, strategyOptions.heasDetails.paymentFrequency || 'fortnightly');
    const assessProceeds = reverseMortgageLoanProceeds > 0;
    return {
        reverseMortgageIncome: reverseMortgageIncome,
        reverseMortgageLoanProceeds: reverseMortgageLoanProceeds,
        heasIncome: heasIncome,
        heasAgePensionReduction: heasAgePensionReduction,
        assessableAssets: assessProceeds ? input.assessableAssets + reverseMortgageLoanProceeds : input.assessableAssets,
        financialAssetsForDeeming: assessProceeds ? input.financialAssetsForDeeming + reverseMortgageLoanProceeds : input.financialAssetsForDeeming
    };
};


/**
 * Income assessment — what a client's assets and income streams actually earn this year, who is taxed on
 * it, and how much of it arrives as cash, as a pure function.
 *
 * One walk, two different questions answered about every dollar, which is why they are answered
 * together:
 *
 *   - the TAX position: each person's assessable income sources, their deductions, and their franking
 *     credits, attributed to whoever owns the asset (split 50/50 when jointly owned). This is what
 *     `calculateFinancials`'s tax calculation is struck on.
 *   - the CASH position: what lands in the bank. It is NOT the same figure. Reinvested share dividends
 *     are taxable but never arrive; franking credits are taxable but are not money at all; an
 *     account-based pension's drawdown is cash but is untaxed once its owner turns 60.
 *
 * The cash side is reported in buckets rather than as one total because a timing-aware consumer needs
 * the parts: the projection engine's incomePlugin pays {@link IncomeAssessment.salaryIncomeCash} and
 * {@link IncomeAssessment.investmentPropertyRentCash} monthly instead of as a 30 June lump, and its
 * expenses counterpart charges {@link IncomeAssessment.investmentPropertyExpenseCash} the same way.
 * Those three are ALSO inside the totals beside them — additive detail, not a separate flow — so a
 * standalone caller can ignore them entirely and still get a correct annual cashflow.
 *
 * Rules worth knowing, each of which the walk encodes per asset type:
 *   - SHARES: the dividend is cash (unless reinvested), but the taxable amount is the dividend GROSSED
 *     UP by its franking credit, which is then claimed back as an offset.
 *   - ACCOUNT-BASED PENSIONS: the payment is the greater of what the client nominated and the
 *     legislated minimum for their age — a pension cannot pay less than the minimum — and it is
 *     tax-free from age 60.
 *   - INVESTMENT PROPERTY: rent is taxable, expenses are deductible, and a negatively geared property
 *     therefore reduces the owner's tax while still costing them cash.
 *   - TERM DEPOSITS and 'other': income is derived from a rate where one is recorded, otherwise implied
 *     from the entered income against the balance.
 *
 * Bank interest and the rent-the-home strategy are assessed before the asset walk, and the
 * trust/company apportionment (`structureAttribution`) is merged in after it — its tax lines are struck
 * by that module, not re-derived here.
 *
 * Extracted from `calculateFinancials`'s "--- 4. Taxable Income & Cash Income Calculation ---" block,
 * which still calls it — through the injectable {@link IncomeAssessor} seam, so the projection engine
 * can hand in the assessor owned by its incomePlugin, the plugin that already owns WHEN this income
 * moves through the bank.
 */ 




/** An empty tax position, before any source is attributed to it. */ function $626517836a298099$var$emptyTaxPosition() {
    return {
        salary: 0,
        investmentSources: [],
        frankingCredits: 0,
        deductionSources: []
    };
}
const $626517836a298099$export$28b3689cc3ff6532 = ({ factFind: factFind, strategyOptions: strategyOptions, isPartnered: isPartnered, clientAge: clientAge, partnerAge: partnerAge, structureAttribution: structureAttribution })=>{
    const { assets: assets, income: income = {} } = factFind;
    const clientTaxable = $626517836a298099$var$emptyTaxPosition();
    const partnerTaxable = $626517836a298099$var$emptyTaxPosition();
    let investmentIncomeCash = 0;
    // The same money as `investmentIncomeCash`, kept apart by kind so it can be REPORTED by kind.
    const investmentIncomeParts = {
        interest: 0,
        dividends: 0,
        rent: 0,
        other: 0,
        structures: 0
    };
    let abpIncomeCash = 0;
    let otherIncomeCash = 0;
    let salaryIncomeCash = 0;
    let reinvestedDividends = 0;
    let investmentPropertyRentCash = 0;
    let investmentPropertyExpenseCash = 0;
    let totalRentalExpenses = 0;
    const bankAccounts = assets?.bankAccounts || [];
    bankAccounts.forEach((acc)=>{
        if ((0, $834081b8d1820bea$export$e498786b37b83f3f)(acc.ownership)) return;
        const value = acc.value || 0;
        const rate = acc.incomeRate || 0;
        const interest = value * rate / 100;
        investmentIncomeCash += interest;
        investmentIncomeParts.interest += interest;
        if (acc.ownership === 'client') clientTaxable.investmentSources.push({
            name: acc.description || 'Bank Interest',
            amount: interest
        });
        else if (acc.ownership === 'partner') partnerTaxable.investmentSources.push({
            name: acc.description || 'Bank Interest',
            amount: interest
        });
        else if (acc.ownership === 'joint') {
            clientTaxable.investmentSources.push({
                name: (acc.description || 'Bank Interest') + ' (50%)',
                amount: interest / 2
            });
            if (isPartnered) partnerTaxable.investmentSources.push({
                name: (acc.description || 'Bank Interest') + ' (50%)',
                amount: interest / 2
            });
        }
    });
    if (strategyOptions.rentHome) {
        const annualRent = (strategyOptions.rentAmount || 0) * 52;
        const annualExpenses = strategyOptions.rentExpenses || 0;
        investmentIncomeCash += annualRent;
        investmentIncomeParts.rent += annualRent;
        totalRentalExpenses += annualExpenses;
        const homeOwnership = factFind.home?.ownership || 'joint';
        if (homeOwnership === 'client') {
            clientTaxable.investmentSources.push({
                name: 'Rental Income - Family Home',
                amount: annualRent
            });
            clientTaxable.deductionSources.push({
                name: 'Rental Expenses - Family Home',
                amount: annualExpenses
            });
        } else if (homeOwnership === 'partner') {
            if (isPartnered) {
                partnerTaxable.investmentSources.push({
                    name: 'Rental Income - Family Home',
                    amount: annualRent
                });
                partnerTaxable.deductionSources.push({
                    name: 'Rental Expenses - Family Home',
                    amount: annualExpenses
                });
            } else {
                clientTaxable.investmentSources.push({
                    name: 'Rental Income - Family Home',
                    amount: annualRent
                });
                clientTaxable.deductionSources.push({
                    name: 'Rental Expenses - Family Home',
                    amount: annualExpenses
                });
            }
        } else {
            clientTaxable.investmentSources.push({
                name: 'Rental Income - Family Home (50%)',
                amount: annualRent / 2
            });
            clientTaxable.deductionSources.push({
                name: 'Rental Expenses - Family Home (50%)',
                amount: annualExpenses / 2
            });
            if (isPartnered) {
                partnerTaxable.investmentSources.push({
                    name: 'Rental Income - Family Home (50%)',
                    amount: annualRent / 2
                });
                partnerTaxable.deductionSources.push({
                    name: 'Rental Expenses - Family Home (50%)',
                    amount: annualExpenses / 2
                });
            }
        }
    }
    // Process 'Other Incomes' for tax and cash
    (income.otherIncomes || []).forEach((inc)=>{
        const amount = inc.amount || 0;
        const incomeType = (0, $1abe73eeef086faf$export$3599b35124f1fb09).find((t)=>t.id === inc.type);
        otherIncomeCash += amount;
        if (inc.type === 'salary') salaryIncomeCash += amount;
        // A defined benefit pension (definedBenefitPension.ts, 15 Oct 2026): a taxed source is tax-free
        // from 60 up to the defined benefit income cap, half of the excess assessable; an untaxed source
        // (CSS, PSS, the military and state schemes) is assessable at marginal rates with a 10% offset;
        // under 60 the taxable part is assessable either way.
        if ((0, $f94c75e8792c4be0$export$ecbf3b113ae95cba)(inc)) {
            const ownerAge = inc.ownership === 'partner' ? partnerAge : clientAge;
            const taxable = (0, $f94c75e8792c4be0$export$82e9ac24bf6bfaa1)(inc, ownerAge);
            const position = inc.ownership === 'partner' && isPartnered ? partnerTaxable : clientTaxable;
            if (taxable > 0) {
                const over60 = ownerAge != null && ownerAge >= 60;
                const note = !over60 ? '' : (0, $f94c75e8792c4be0$export$e3225b085066838f)(inc) ? ' (half of the part above the income cap)' : ' (untaxed source)';
                position.investmentSources.push({
                    name: `${inc.description || incomeType.name}${note}`,
                    amount: taxable
                });
            }
            const offset = (0, $f94c75e8792c4be0$export$90c16105f11197a4)(inc, ownerAge);
            if (offset > 0) position.taxOffsets = (position.taxOffsets ?? 0) + offset;
            return;
        }
        let isTaxable = incomeType?.taxable;
        if (incomeType?.isCustom) isTaxable = inc.isTaxable;
        if (isTaxable) {
            if (inc.ownership === 'client') clientTaxable.investmentSources.push({
                name: inc.description || incomeType.name,
                amount: amount
            });
            else if (inc.ownership === 'partner') partnerTaxable.investmentSources.push({
                name: inc.description || incomeType.name,
                amount: amount
            });
            else {
                clientTaxable.investmentSources.push({
                    name: `${inc.description || incomeType.name} (50%)`,
                    amount: amount / 2
                });
                if (isPartnered) partnerTaxable.investmentSources.push({
                    name: `${inc.description || incomeType.name} (50%)`,
                    amount: amount / 2
                });
            }
        }
    });
    Object.values(assets || {}).forEach((assetList)=>{
        (assetList || []).forEach((asset)=>{
            if ((0, $834081b8d1820bea$export$e498786b37b83f3f)(asset.ownership)) return;
            const value = asset.value || 0;
            let currentCashIncome;
            let currentTaxable = 0;
            let currentFranking = 0;
            let currentDeductions = 0;
            // The `''` is unreachable: every push below is guarded by `currentTaxable`/`currentDeductions`
            // being positive, which only a matched asset-type branch can make true — so `asset.type` is
            // set wherever this is read. It is here because `FactFindAsset.type` is optional.
            const incomeSourceName = asset.description || asset.type || '';
            if (asset.type === 'shares') {
                const dividend = value * ((asset.incomeRate || 0) / 100);
                const frankingPercent = (asset.frankingCredit || 0) / 100;
                const frankedAmount = dividend * frankingPercent;
                const frankingCredit = frankedAmount * ((0, $1abe73eeef086faf$export$641e54d6b906f309) / (1 - (0, $1abe73eeef086faf$export$641e54d6b906f309)));
                currentCashIncome = dividend;
                currentTaxable = dividend + frankingCredit;
                currentFranking = frankingCredit;
                // A reinvested dividend is taxed but never banked.
                if (asset.reinvest !== true) {
                    investmentIncomeCash += currentCashIncome;
                    investmentIncomeParts.dividends += currentCashIncome;
                } else reinvestedDividends += currentCashIncome;
            } else if (asset.type === 'investmentProperty') {
                const rent = asset.rent || 0;
                const expenses = asset.expenses || 0;
                currentCashIncome = rent;
                currentTaxable = rent;
                currentDeductions = expenses;
                totalRentalExpenses += expenses;
                investmentIncomeCash += currentCashIncome;
                investmentIncomeParts.rent += rent;
                investmentPropertyRentCash += rent;
                investmentPropertyExpenseCash += expenses;
            } else if (asset.type === 'accountBasedPensions') {
                let ownerAge = null;
                if (asset.ownership === 'client') ownerAge = clientAge;
                else if (asset.ownership === 'partner') ownerAge = partnerAge;
                // A pension must pay at least the legislated minimum for its owner's age. No resolvable
                // age means no minimum to impose, so the client's own nomination stands.
                const minDrawdownRate = ownerAge ? (0, $e0f54937e270d5ff$export$a7b4a1ff258d7449)(ownerAge) : 0;
                const minDrawdownAmount = value * minDrawdownRate;
                const originalUserEnteredPayment = asset.income || 0;
                // An exhausted pension pays nothing, whatever was nominated against it.
                const userEnteredPayment = value > 0 ? originalUserEnteredPayment : 0;
                currentCashIncome = Math.max(userEnteredPayment, minDrawdownAmount);
                abpIncomeCash += currentCashIncome;
                // Tax-free from 60. Unresolvable ownership (a 'joint' ABP) stays taxable.
                let isTaxable = true;
                if (asset.ownership === 'client' && clientAge && clientAge >= 60) isTaxable = false;
                else if (asset.ownership === 'partner' && partnerAge && partnerAge >= 60) isTaxable = false;
                currentTaxable = isTaxable ? currentCashIncome : 0;
            } else if (asset.type && [
                'annuities',
                'termDeposits',
                'loansToOthers',
                'other'
            ].includes(asset.type)) {
                if (asset.type === 'annuities') {
                    // `annualPayment` from a strategy, `income` from the profile — and nil while a
                    // deferred annuity is deferred or once a fixed term has ended (annuityTermsOf).
                    // TAXABLE is the payment less its deductible amount (the tax-free return of
                    // capital: ITAA 1997 s 27H), and nil where the annuity was bought with super
                    // money and the owner is 60 or over. Until 17 Sep 2026 the Centrelink 60%
                    // figure stood in for the taxable amount on a strategy-built annuity and a
                    // profile-entered one was not taxed (or paid) at all.
                    const annuityOwnerAge = asset.ownership === 'partner' ? partnerAge : clientAge;
                    const annuityTerms = (0, $f7f7b62814c3b615$export$39dd0455f19e0b2c)(asset, new Date(), annuityOwnerAge ?? null);
                    currentCashIncome = annuityTerms.annualPayment;
                    const superMoneyTaxFree = String(asset.fundingSource || '') === 'super' && (annuityOwnerAge ?? 0) >= 60;
                    currentTaxable = superMoneyTaxFree ? 0 : Math.max(0, currentCashIncome - annuityTerms.deductionAmount);
                } else {
                    let rate = 0;
                    // A loan to someone else pays the interest agreed on it, like a term deposit.
                    if ((asset.type === 'termDeposits' || asset.type === 'loansToOthers') && asset.incomeRate) rate = (asset.incomeRate || 0) / 100;
                    else if (asset.income) rate = value > 0 ? asset.income / value : 0;
                    currentCashIncome = value * rate;
                    currentTaxable = currentCashIncome;
                }
                investmentIncomeCash += currentCashIncome;
                // A term deposit pays interest; an annuity or an `other` asset does not fit any of the
                // named kinds, so it lands in `other` rather than being mislabelled.
                if (asset.type === 'termDeposits' || asset.type === 'loansToOthers') investmentIncomeParts.interest += currentCashIncome;
                else investmentIncomeParts.other += currentCashIncome;
            }
            if (asset.ownership === 'client') {
                if (currentTaxable > 0) clientTaxable.investmentSources.push({
                    name: incomeSourceName,
                    amount: currentTaxable
                });
                clientTaxable.frankingCredits += currentFranking;
                if (currentDeductions > 0) clientTaxable.deductionSources.push({
                    name: `${incomeSourceName} Expenses`,
                    amount: currentDeductions
                });
            } else if (asset.ownership === 'partner') {
                if (currentTaxable > 0) partnerTaxable.investmentSources.push({
                    name: incomeSourceName,
                    amount: currentTaxable
                });
                partnerTaxable.frankingCredits += currentFranking;
                if (currentDeductions > 0) partnerTaxable.deductionSources.push({
                    name: `${incomeSourceName} Expenses`,
                    amount: currentDeductions
                });
            } else if (asset.ownership === 'joint') {
                if (currentTaxable > 0) clientTaxable.investmentSources.push({
                    name: `${incomeSourceName} (50%)`,
                    amount: currentTaxable / 2
                });
                clientTaxable.frankingCredits += currentFranking / 2;
                if (currentDeductions > 0) clientTaxable.deductionSources.push({
                    name: `${incomeSourceName} Expenses (50%)`,
                    amount: currentDeductions / 2
                });
                if (isPartnered) {
                    if (currentTaxable > 0) partnerTaxable.investmentSources.push({
                        name: `${incomeSourceName} (50%)`,
                        amount: currentTaxable / 2
                    });
                    partnerTaxable.frankingCredits += currentFranking / 2;
                    if (currentDeductions > 0) partnerTaxable.deductionSources.push({
                        name: `${incomeSourceName} Expenses (50%)`,
                        amount: currentDeductions / 2
                    });
                }
            }
        });
    });
    if (structureAttribution) {
        investmentIncomeCash += structureAttribution.investmentIncomeCash;
        investmentIncomeParts.structures += structureAttribution.investmentIncomeCash;
        totalRentalExpenses += structureAttribution.rentalExpenses;
        structureAttribution.clientTax.investmentSources.forEach((source)=>{
            clientTaxable.investmentSources.push(source);
        });
        structureAttribution.clientTax.deductionSources.forEach((deduction)=>{
            clientTaxable.deductionSources.push(deduction);
        });
        clientTaxable.frankingCredits += structureAttribution.clientTax.frankingCredits;
        if (isPartnered) {
            structureAttribution.partnerTax.investmentSources.forEach((source)=>{
                partnerTaxable.investmentSources.push(source);
            });
            structureAttribution.partnerTax.deductionSources.forEach((deduction)=>{
                partnerTaxable.deductionSources.push(deduction);
            });
            partnerTaxable.frankingCredits += structureAttribution.partnerTax.frankingCredits;
        }
    }
    return {
        clientTaxable: clientTaxable,
        partnerTaxable: partnerTaxable,
        investmentIncomeCash: investmentIncomeCash,
        investmentIncomeParts: investmentIncomeParts,
        abpIncomeCash: abpIncomeCash,
        otherIncomeCash: otherIncomeCash,
        salaryIncomeCash: salaryIncomeCash,
        reinvestedDividends: reinvestedDividends,
        investmentPropertyRentCash: investmentPropertyRentCash,
        investmentPropertyExpenseCash: investmentPropertyExpenseCash,
        totalRentalExpenses: totalRentalExpenses
    };
};



/**
 * Loan repayments & deductions — what a client's liabilities cost them this year, and what part of
 * that cost the tax system gives back, as a pure function.
 *
 * Two outputs, from one walk of the liabilities:
 *   - SCHEDULES: each liability that is actually serviced from personal cashflow, with the frequency
 *     it is serviced at ('weekly' | 'fortnightly' | 'monthly'), its periodic repayment and the annual
 *     total. `calculateFinancials` sums the annual totals into its cashflow; the projection engine's
 *     loanRepaymentPlugin uses the frequency to take each instalment out of the bank when it is really
 *     paid, rather than as one 30 June lump.
 *   - DEDUCTIONS: interest on a mortgage secured against an INVESTMENT property is deductible against
 *     the income of whoever owns that property (split 50/50 when jointly owned). These feed
 *     `calculateFinancials`'s tax calculation, which is why the assessment cannot live server-side.
 *
 * Extracted from `calculateFinancials`'s "--- 5. Loan Repayments & Deductions ---" block, which still
 * calls it — through the injectable {@link LoanRepaymentAssessor} seam, so the projection engine can
 * hand in the assessor owned by its loanRepaymentPlugin. See that plugin for why the code lives here
 * rather than in it.
 *
 * The per-liability annual arithmetic is NOT reimplemented here: it is
 * {@link calculateAnnualLoanRepayment}, which already existed for the trust/company pool
 * (`structureAttribution`) and is now the single definition both paths use.
 */ 



const $2785794120fd71ac$export$3ad3e4b0553b8cd1 = {
    weekly: 52,
    fortnightly: 26,
    monthly: 12
};
const $2785794120fd71ac$export$1ca8b72d78e08ddf = [
    'weekly',
    'fortnightly',
    'monthly'
];
function $2785794120fd71ac$export$5e948f18eb3215c(openingBalance, periodicRepayment, periodicInterestRate, periods) {
    let balance = openingBalance;
    let paid = 0;
    let interestAccrued = 0;
    for(let period = 0; period < periods && balance > 0; period++){
        const interest = balance * periodicInterestRate;
        const payment = Math.min(periodicRepayment, balance + interest);
        balance = balance + interest - payment;
        paid += payment;
        interestAccrued += interest;
    }
    return {
        paid: paid,
        interestAccrued: interestAccrued,
        closingBalance: balance
    };
}
function $2785794120fd71ac$export$2ad427a5e953a436(loanTerm, yearsElapsed) {
    if (!loanTerm || loanTerm <= 0) return loanTerm;
    return Math.max(1, loanTerm - yearsElapsed);
}
function $2785794120fd71ac$export$eff4b4eeb8da36e7(liability, category) {
    if ((0, $55a6490f14a54563$export$b0f8a46bdf3c210d)(liability, category)) return 'monthly';
    const frequency = liability.frequency;
    return frequency === 'weekly' || frequency === 'fortnightly' ? frequency : 'monthly';
}
/**
 * True for a liability that is NOT serviced out of personal cashflow, and which therefore has neither
 * a repayment schedule nor a deduction:
 *   - a reverse mortgage or HEAS loan, whose balance is compounded rather than repaid (see
 *     loanPlugin's accrual, and capitalisingLoans.ts for what counts);
 *   - anything the user flagged `excludeFromCashflow`;
 *   - a liability belonging to a trust or company, whose repayments are pooled by `structureAttribution`.
 */ function $2785794120fd71ac$var$isOutsidePersonalCashflow(liability, factFind) {
    if ((0, $66c36853b590c88a$export$ec9081b12e34149d)(liability, factFind)) return true;
    return (0, $eb5ee2a9aeb43da8$export$95d06fd31af89cb5)(liability) || liability.excludeFromCashflow === true;
}
/**
 * The interest deduction a liability generates, if any: only a mortgage secured against an INVESTMENT
 * property the client and/or partner personally own. A loan against the family home is private
 * borrowing (`assetLink === 'home'`), and an unlinked loan is not deductible either.
 *
 * `interest` is the interest the loan actually accrues across the year, struck period by period on the
 * reducing balance (see {@link projectPrincipalAndInterestYear}) rather than once on the opening one —
 * so a client claims what the loan really cost them, which for an amortising loan is slightly less.
 */ function $2785794120fd71ac$var$deductionsFor(liability, factFind, isPartnered, interest) {
    if (liability.type !== 'mortgages' || !liability.assetLink || liability.assetLink === 'home') return [];
    // assetLink holds the linked property's (string) id.
    const linkedAsset = factFind.assets?.investmentProperty?.find((p)=>p.id === liability.assetLink);
    if (!linkedAsset || (0, $834081b8d1820bea$export$e498786b37b83f3f)(linkedAsset.ownership)) return [];
    if (linkedAsset.ownership === 'client') return [
        {
            owner: 'client',
            name: `Loan Interest (${linkedAsset.description})`,
            amount: interest
        }
    ];
    if (linkedAsset.ownership === 'partner') return [
        {
            owner: 'partner',
            name: `Loan Interest (${linkedAsset.description})`,
            amount: interest
        }
    ];
    if (linkedAsset.ownership === 'joint') {
        const name = `Loan Interest (${linkedAsset.description}) (50%)`;
        return [
            {
                owner: 'client',
                name: name,
                amount: interest / 2
            },
            // A "joint" property with no partner on the advice leaves the other half unclaimed.
            ...isPartnered ? [
                {
                    owner: 'partner',
                    name: name,
                    amount: interest / 2
                }
            ] : []
        ];
    }
    return [];
}
const $2785794120fd71ac$export$971ff34118c0c4d1 = ({ factFind: factFind, isPartnered: isPartnered, yearsElapsed: yearsElapsed = 0 })=>{
    const schedules = [];
    const deductions = [];
    let totalAnnualRepayments = 0;
    Object.entries(factFind.liabilities || {}).forEach(([category, list])=>{
        (list || []).forEach((liability, index)=>{
            if ($2785794120fd71ac$var$isOutsidePersonalCashflow(liability, factFind)) return;
            // A CREDIT CARD is paid by how the profile says it is paid (creditCards.ts). Paid in full each
            // month, it is a rolling bill already in the living costs: no interest, no separate repayment,
            // owed at the same figure. Otherwise it is walked month by month — interest at the card's rate
            // (the typical rate where none is recorded) and the month's payment struck on what is owed.
            if ((0, $55a6490f14a54563$export$b0f8a46bdf3c210d)(liability, category)) {
                if ((0, $55a6490f14a54563$export$ee09c2c29b17798e)(liability) === 'full') return;
                const openingBalance = liability.balance || 0;
                const card = (0, $55a6490f14a54563$export$cc7da59b25ca17e7)(liability, openingBalance);
                totalAnnualRepayments += card.paid;
                schedules.push({
                    id: liability.id,
                    category: category,
                    index: index,
                    description: liability.description && String(liability.description).trim() || 'Credit card',
                    type: liability.type,
                    frequency: 'monthly',
                    loanType: 'pi',
                    periodicRepayment: card.firstPayment,
                    periodicInterestRate: (0, $55a6490f14a54563$export$55bc0f912152ac52)(liability) / 100 / 12,
                    openingBalance: openingBalance,
                    annualRepayment: card.paid,
                    annualInterest: card.interestAccrued,
                    closingBalance: card.closingBalance,
                    creditCard: true
                });
                return;
            }
            const frequency = $2785794120fd71ac$export$eff4b4eeb8da36e7(liability);
            const periods = $2785794120fd71ac$export$3ad3e4b0553b8cd1[frequency];
            const loanType = liability.loanType === 'io' ? 'io' : 'pi';
            const openingBalance = liability.balance || 0;
            // The instalment is derived against what is LEFT of the term, so it stays the instalment the
            // client actually pays and the loan finishes when it is supposed to.
            const periodicRepayment = (0, $66c36853b590c88a$export$e10cf1ee911e064f)({
                ...liability,
                loanTerm: $2785794120fd71ac$export$2ad427a5e953a436(liability.loanTerm, yearsElapsed)
            }) / periods;
            const periodicInterestRate = (liability.interestRate || 0) / 100 / periods;
            // An interest-only loan pays its interest and nothing else, so every dollar of its
            // instalments is interest and its balance stands still. A principal-and-interest one is
            // amortised properly — see projectPrincipalAndInterestYear.
            const contractualAnnual = periodicRepayment * periods;
            const { paid: annualRepayment, interestAccrued: annualInterest, closingBalance: closingBalance } = loanType === 'io' ? {
                paid: contractualAnnual,
                interestAccrued: contractualAnnual,
                closingBalance: openingBalance
            } : $2785794120fd71ac$export$5e948f18eb3215c(openingBalance, periodicRepayment, periodicInterestRate, periods);
            totalAnnualRepayments += annualRepayment;
            schedules.push({
                id: liability.id,
                category: category,
                index: index,
                description: liability.description && String(liability.description).trim() || 'Loan',
                type: liability.type,
                frequency: frequency,
                loanType: loanType,
                periodicRepayment: periodicRepayment,
                periodicInterestRate: periodicInterestRate,
                openingBalance: openingBalance,
                annualRepayment: annualRepayment,
                annualInterest: annualInterest,
                closingBalance: closingBalance
            });
            deductions.push(...$2785794120fd71ac$var$deductionsFor(liability, factFind, isPartnered, annualInterest));
        });
    });
    return {
        schedules: schedules,
        totalAnnualRepayments: totalAnnualRepayments,
        deductions: deductions
    };
};







/**
 * Build indexed rates for the `yearIndex`th year of a projection — the ORDINAL (1, 2, 3 …), not a
 * calendar or financial year. Year 1 = base; year 2+ = base × (1+r)^(yearIndex-1), so the first year
 * uses current rates and future years use assumed indexation.
 *
 * Every legislated figure is indexed this way: tax brackets, pension rates, asset-test limits and the
 * Medicare thresholds all escalate off one base set by CPI. Nothing here is keyed to a named financial
 * year, which is why the engine is free to cut its rows on either calendar (see
 * plugins/engineTypes.ts).
 */ /*
 * The rates for a (year, CPI assumption, financial year) are fixed, and a projection asks for them on every
 * assessment — an opening one each year and a pension re-assessment every fortnight, for every candidate —
 * so they are worked out once per key and reused (24 Oct 2026: a cold aged care analysis ran past its time
 * limit). Nothing reads them but to read: no caller mutates a rates object (the base year already handed
 * out the shared constant tables).
 */ const $db6ce683330fb15a$var$indexedRatesCache = new Map();
function $db6ce683330fb15a$var$getIndexedRates(yearIndex, inflationPct, taxYearStart) {
    const key = `${yearIndex}|${inflationPct}|${taxYearStart}`;
    let rates = $db6ce683330fb15a$var$indexedRatesCache.get(key);
    if (!rates) {
        rates = $db6ce683330fb15a$var$getIndexedRatesUncached(yearIndex, inflationPct, taxYearStart);
        if ($db6ce683330fb15a$var$indexedRatesCache.size > 512) $db6ce683330fb15a$var$indexedRatesCache.clear();
        $db6ce683330fb15a$var$indexedRatesCache.set(key, rates);
    }
    return rates;
}
function $db6ce683330fb15a$var$getIndexedRatesUncached(yearIndex, inflationPct, taxYearStart) {
    // THE ONE FY-AWARE TABLE. Every other figure indexes off the run's first year by CPI; the marginal
    // brackets are the one table that changes by legislation on a named date (14% from 1 July 2027),
    // so they are chosen by the financial year the projection year opens in, then indexed.
    const baseBrackets = (0, $1abe73eeef086faf$export$71d73f2c4d006402)(taxYearStart);
    if (yearIndex <= 1 || inflationPct == null) return {
        pensionRates: (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0),
        assetTestLower: (0, $1abe73eeef086faf$export$f2edcf3efd8592d9),
        assetTestUpper: (0, $1abe73eeef086faf$export$6dfa3415233daaeb),
        assetTestLimits: (0, $1abe73eeef086faf$export$9a84fd450010fb2e),
        incomeTestLower: (0, $1abe73eeef086faf$export$704950d172afcdf8),
        incomeTestCutoff: (0, $1abe73eeef086faf$export$bad1f8cb9d172d1b),
        deemingThresholds: (0, $1abe73eeef086faf$export$63f1528eb9e21fc5),
        taxBrackets: (0, $231c5fe5568c4f9c$export$f2c8f7fe82b5a229)(baseBrackets),
        medicareLevyThresholds: (0, $1abe73eeef086faf$export$ae133c7b255163d3),
        medicareLevySurcharge: (0, $1abe73eeef086faf$export$3f2efd37e8996007),
        taxOffsets: (0, $231c5fe5568c4f9c$export$1cdbf71a09396579)()
    };
    const f = Math.pow(1 + inflationPct / 100, yearIndex - 1);
    const scale = (x)=>Math.round(x * f);
    const scaleObj = (o)=>({
            single: scale(o.single),
            couple: scale(o.couple)
        });
    const scaleAssetLimitTree = (tree)=>({
            single: {
                homeowner: {
                    full: scale(tree.single.homeowner.full),
                    cutoff: scale(tree.single.homeowner.cutoff)
                },
                nonHomeowner: {
                    full: scale(tree.single.nonHomeowner.full),
                    cutoff: scale(tree.single.nonHomeowner.cutoff)
                }
            },
            couple: {
                homeowner: {
                    full: scale(tree.couple.homeowner.full),
                    cutoff: scale(tree.couple.homeowner.cutoff)
                },
                nonHomeowner: {
                    full: scale(tree.couple.nonHomeowner.full),
                    cutoff: scale(tree.couple.nonHomeowner.cutoff)
                }
            },
            coupleIllnessSeparated: {
                homeowner: {
                    full: scale(tree.coupleIllnessSeparated.homeowner.full),
                    cutoff: scale(tree.coupleIllnessSeparated.homeowner.cutoff)
                },
                nonHomeowner: {
                    full: scale(tree.coupleIllnessSeparated.nonHomeowner.full),
                    cutoff: scale(tree.coupleIllnessSeparated.nonHomeowner.cutoff)
                }
            }
        });
    const taxBrackets = baseBrackets.map((b, i)=>({
            limit: b.limit === Infinity ? Infinity : scale(b.limit),
            rate: b.rate,
            base: scale(b.base),
            previousLimit: i === 0 ? 0 : scale(baseBrackets[i - 1].limit)
        }));
    const medicareLevyThresholds = {
        single: {
            lower: scale((0, $1abe73eeef086faf$export$ae133c7b255163d3).single.lower),
            upper: scale((0, $1abe73eeef086faf$export$ae133c7b255163d3).single.upper)
        },
        couple: {
            lower: scale((0, $1abe73eeef086faf$export$ae133c7b255163d3).couple.lower),
            upper: scale((0, $1abe73eeef086faf$export$ae133c7b255163d3).couple.upper)
        },
        singleSenior: {
            lower: scale((0, $1abe73eeef086faf$export$ae133c7b255163d3).singleSenior.lower),
            upper: scale((0, $1abe73eeef086faf$export$ae133c7b255163d3).singleSenior.upper)
        },
        coupleSenior: {
            lower: scale((0, $1abe73eeef086faf$export$ae133c7b255163d3).coupleSenior.lower),
            upper: scale((0, $1abe73eeef086faf$export$ae133c7b255163d3).coupleSenior.upper)
        },
        perDependentChild: scale((0, $1abe73eeef086faf$export$ae133c7b255163d3).perDependentChild),
        perDependentChildUpper: scale((0, $1abe73eeef086faf$export$ae133c7b255163d3).perDependentChildUpper)
    };
    // The surcharge tiers index each 1 July (AWOTE in law; CPI here, like every other figure).
    const medicareLevySurcharge = {
        tiers: (0, $1abe73eeef086faf$export$3f2efd37e8996007).tiers.map((t)=>({
                singleUpTo: t.singleUpTo === Infinity ? Infinity : scale(t.singleUpTo),
                familyUpTo: t.familyUpTo === Infinity ? Infinity : scale(t.familyUpTo),
                rate: t.rate
            })),
        perExtraChild: scale((0, $1abe73eeef086faf$export$3f2efd37e8996007).perExtraChild)
    };
    return {
        pensionRates: scaleObj((0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0)),
        assetTestLower: scaleObj((0, $1abe73eeef086faf$export$f2edcf3efd8592d9)),
        assetTestUpper: scaleObj((0, $1abe73eeef086faf$export$6dfa3415233daaeb)),
        assetTestLimits: scaleAssetLimitTree((0, $1abe73eeef086faf$export$9a84fd450010fb2e)),
        incomeTestLower: scaleObj((0, $1abe73eeef086faf$export$704950d172afcdf8)),
        incomeTestCutoff: {
            single: scale((0, $1abe73eeef086faf$export$bad1f8cb9d172d1b).single),
            couple: scale((0, $1abe73eeef086faf$export$bad1f8cb9d172d1b).couple),
            coupleIllnessSeparated: scale((0, $1abe73eeef086faf$export$bad1f8cb9d172d1b).coupleIllnessSeparated)
        },
        deemingThresholds: scaleObj((0, $1abe73eeef086faf$export$63f1528eb9e21fc5)),
        taxBrackets: taxBrackets,
        medicareLevyThresholds: medicareLevyThresholds,
        medicareLevySurcharge: medicareLevySurcharge,
        taxOffsets: (0, $231c5fe5568c4f9c$export$3e0cfe4b9bf248df)(scale)
    };
}
// projectionContext: { yearIndex, inflationPct, projectionAnchorDate? } for multi-year projections.
// Year 1 uses current rates; Year 2+ use indexed rates.
const $db6ce683330fb15a$var$calculateFinancialsCore = (factFind, strategyOptions = {}, yearsSinceRented = 0, projectionContext = {}, { assessAssessableMeans: assessAssessableMeans = (0, $ca198d51af38f7a6$export$7a71776828710814), assessDeemedIncome: assessDeemedIncome = (0, $e84dc16b58a17cc1$export$abef4f2b4ca712ce), assessHomeEquityRelease: assessHomeEquityRelease = (0, $cd0ced93285377f1$export$77552529cd80a5f8), assessIncome: assessIncome = (0, $626517836a298099$export$28b3689cc3ff6532), assessIncomeTax: assessIncomeTax = (0, $231c5fe5568c4f9c$export$f866a82f070179fc), assessExpenses: assessExpenses = (0, $40f7e03c879d6a85$export$143d196fe9af26ab), assessNetWorth: assessNetWorth = (0, $12a1d07f40c8ac3b$export$496a401322cf5aad), assessAgePension: assessAgePension = (0, $f6d9b8637d64d262$export$482390490d6631b8), assessLoanRepayments: assessLoanRepayments = (0, $2785794120fd71ac$export$971ff34118c0c4d1) } = {}, pensionProbe)=>{
    // Someone in care now brings their deposit with them: exempt for the pension, counted for the care
    // means test (support/facilityMove.ts, 8 Oct 2026). Unchanged where the profile records none.
    factFind = (0, $7902ca900a473358$export$2a6399fb2105ee37)(factFind);
    const yearIndex = projectionContext?.yearIndex;
    const inflationPct = projectionContext?.inflationPct;
    // The financial year this assessment is struck in (by its opening calendar year) — the projection
    // supplies it; a single-year caller means "now", the year the unqualified tables describe.
    const taxYearStart = projectionContext?.taxYearStart;
    const useIndexedRates = yearIndex != null && yearIndex > 1 && inflationPct != null;
    const rates = useIndexedRates ? $db6ce683330fb15a$var$getIndexedRates(yearIndex, inflationPct, taxYearStart) : $db6ce683330fb15a$var$getIndexedRates(1, null, taxYearStart);
    const { client: client = {}, partner: partner = {}, adviceFor: adviceFor, expenses: expenses = {} } = factFind;
    const isPartnered = adviceFor === 'couple';
    // `__age` when the caller is a PROJECTION — birthdayPlugin seeds it from the run's anchor and
    // advances it on each person's real birthday, and this assessment is struck on 1 July, so it is
    // the age they held when the financial year opened. Falling back to the date of birth is for the
    // single-year callers (the /rest/calculation endpoints, the strategy previews), which have no run
    // to be partway through and mean "as at today".
    //
    // Reading it matters more here than anywhere else the engine asks an age. This function decides
    // Age Pension age, the SAPTO thresholds and the aged-care means test, and it used to derive both
    // ages from `dob` against the wall clock — so a projection assessed year 10 with the client's
    // age TODAY, and someone who reached pension age in year 4 never reached it at all.
    const ageOf = (person)=>person?.__age ?? (person?.dob ? (0, $876c355975468a36$export$8ada184d5eef4694)(person.dob) : null);
    const clientAge = ageOf(client);
    const partnerAge = isPartnered ? ageOf(partner) : null;
    const relationshipStatus = isPartnered ? 'couple' : 'single';
    const illnessSeparated = (0, $8eecd0af141b9afb$export$9b95c99516118f10)(factFind, strategyOptions);
    const clientResidency = strategyOptions?.clientResidencyOverride || factFind?.client?.currentResidency;
    const partnerResidency = strategyOptions?.partnerResidencyOverride || factFind?.partner?.currentResidency;
    /*
     * Homeowner status, the village and granny flat tests — one rule for every assessor and screen
     * (shared/src/calculation/householdPosition.ts, 7 Oct 2026). The order and the former-home
     * retention it applies are documented there; `someoneInCare` keeps the name the rest of this
     * function reads.
     */ const homeowner = (0, $d1b9bbc5238c0548$export$bdceaa91a7a2e637)(factFind, strategyOptions);
    const someoneInCare = clientResidency === 'aged_care' || isPartnered && partnerResidency === 'aged_care';
    const { isHomeowner: isHomeowner, rvResident: rvResident, rvInterestHeld: rvInterestHeld, rvIsHomeowner: rvIsHomeowner, rvEntryContribution: rvEntryContribution, grannyFlatIsHomeowner: grannyFlatIsHomeowner, grannyFlatResident: grannyFlatResident, grannyFlatEntryContribution: grannyFlatEntryContribution } = homeowner;
    // A granny flat interest at or below the extra allowable amount: the resident is a non-homeowner
    // and what they paid is a counted asset, the same "special residence" rule as a village entry
    // contribution (owner-caught, 7 Oct 2026: only the village side was counted).
    // What is counted is the value of the right — what was given less any part that was a gift. The gift is
    // counted once, as a deprived asset (deemedIncome.ts); counting the whole amount here as well counted it
    // twice (owner's granny flat review, 24 Oct 2026; pack v1.58 — Social Security Guide 4.6.4.30).
    const grannyFlatGift = grannyFlatResident && !grannyFlatIsHomeowner ? (0, $a528307a9ba99a26$export$eb48a6112ea73d5a)(factFind, rates.pensionRates.couple)?.deprivation ?? 0 : 0;
    const grannyFlatCountedInterest = grannyFlatResident && !grannyFlatIsHomeowner ? Math.max(0, grannyFlatEntryContribution - grannyFlatGift) : 0;
    // --- 1. Assessable Assets & Income (for Pension) ---
    // What COUNTS as an assessable asset and as assessable income lives in assessableMeans.ts and is
    // INJECTED (`options.assessAssessableMeans`, defaulting to `calculateAssessableMeans`) so a caller
    // can own the rules — the projection engine passes in the assessor owned by its
    // assessableMeansPlugin. These totals are struck once and read TWICE: by the Age Pension means test
    // in section 3, and by the aged-care means test, which reads them back off this function's result.
    //
    // `structureAttribution` is resolved first because the walk merges the trust/company apportionment
    // into its totals. It stays here rather than moving into the assessor: the same apportionment also
    // carries the entity tax lines and the pooled entity loan repayments, which sections 4 and 5 read.
    const structureAttribution = (0, $834081b8d1820bea$export$ee0c222516237885)(factFind, {
        isPartnered: isPartnered,
        clientAge: clientAge,
        partnerAge: partnerAge,
        strategyOptions: strategyOptions
    });
    const means = assessAssessableMeans({
        factFind: factFind,
        strategyOptions: strategyOptions,
        isPartnered: isPartnered,
        clientAge: clientAge,
        partnerAge: partnerAge,
        clientResidency: clientResidency,
        partnerResidency: partnerResidency,
        yearsSinceRented: yearsSinceRented,
        rvResident: rvResident,
        rvInterestHeld: rvInterestHeld,
        grannyFlatCountedInterest: grannyFlatCountedInterest,
        rvIsHomeowner: rvIsHomeowner,
        rvEntryContribution: rvEntryContribution,
        structureAttribution: structureAttribution
    });
    const { assessableAssetsNoHome: assessableAssetsNoHome, assessableIncomeFromPensions: assessableIncomeFromPensions, netRentalIncomeForPension: netRentalIncomeForPension, otherAssessableIncome: otherAssessableIncome, investmentPropertyRentalForPension: investmentPropertyRentalForPension, partnerAssessableIncomeFromPensions: partnerAssessableIncomeFromPensions, partnerNetRentalIncomeForPension: partnerNetRentalIncomeForPension, partnerOtherAssessableIncome: partnerOtherAssessableIncome, partnerInvestmentPropertyRentalForPension: partnerInvestmentPropertyRentalForPension, pre2015ABPDetails: pre2015ABPDetails, definedBenefitDetails: definedBenefitDetails } = means;
    // These two are still added to below — by deprivation (section 2) and, where the client takes a
    // reverse mortgage they don't spend on a RAD, by the loan proceeds (section 3).
    let { assessableAssets: assessableAssets, financialAssetsForDeeming: financialAssetsForDeeming } = means;
    // --- 2. Deemed Income from Financial Assets ---
    // Deeming and deprivation live in deemedIncome.ts and are INJECTED (`options.assessDeemedIncome`,
    // defaulting to `calculateDeemedIncome`) so a caller can own the rules — the projection engine
    // passes in the assessor owned by its deemedIncomePlugin. The two are assessed together because a
    // deprived asset is deemed as well as counted, so the assessment hands back both the income and the
    // enlarged totals it was struck on.
    const projectionAnchorDate = projectionContext?.projectionAnchorDate != null ? projectionContext.projectionAnchorDate instanceof Date ? projectionContext.projectionAnchorDate : new Date(projectionContext.projectionAnchorDate) : new Date();
    // A projected year is assessed as at its own opening day (`assessmentDate`), so a gift ages out
    // of deprivation five years on; a standalone assessment, and a run's first year, use the anchor.
    const assessmentDate = projectionContext?.assessmentDate instanceof Date ? projectionContext.assessmentDate : projectionContext?.assessmentDate != null ? new Date(projectionContext.assessmentDate) : projectionAnchorDate;
    const deeming = assessDeemedIncome({
        rates: rates,
        relationshipStatus: relationshipStatus,
        factFind: factFind,
        strategyOptions: strategyOptions,
        asOfDate: assessmentDate,
        assessableAssets: assessableAssets,
        financialAssetsForDeeming: financialAssetsForDeeming
    });
    const { deemedIncome: deemedIncome, deemingThreshold: deemingThreshold, deprivedAsset: deprivedAsset } = deeming;
    assessableAssets = deeming.assessableAssets;
    financialAssetsForDeeming = deeming.financialAssetsForDeeming;
    // --- 3. Reverse Mortgage & HEAS Calculations ---
    // The two home-equity-release strategies live in homeEquityRelease.ts and are INJECTED
    // (`options.assessHomeEquityRelease`, defaulting to `calculateHomeEquityRelease`) so a caller can own
    // the rules — the projection engine passes in the assessor owned by its loanPlugin, which is already
    // the plugin that compounds these two loans' balances. Both the income assessed here and the balance
    // that income accrues against are therefore described in one place.
    //
    // Note the deeming above has already been struck: lump-sum proceeds enlarge the totals but are not
    // deemed in the year the loan is drawn. Long-standing behaviour, pinned by the golden master.
    const homeEquityRelease = assessHomeEquityRelease({
        strategyOptions: strategyOptions,
        factFind: factFind,
        assessableAssets: assessableAssets,
        financialAssetsForDeeming: financialAssetsForDeeming
    });
    const { reverseMortgageIncome: reverseMortgageIncome, heasIncome: heasIncome, heasAgePensionReduction: heasAgePensionReduction } = homeEquityRelease;
    assessableAssets = homeEquityRelease.assessableAssets;
    financialAssetsForDeeming = homeEquityRelease.financialAssetsForDeeming;
    // --- 3. Age Pension Calculation ---
    // The means test itself lives in agePension.ts and is INJECTED (`options.assessAgePension`,
    // defaulting to `calculateAgePension`) so a caller can own the rules — the projection engine
    // passes in the assessor owned by its agePensionPlugin, which also pays the result out
    // fortnightly. Everything above is the shared assessment of assets and income that both this and
    // the aged-care means test are struck on; everything below consumes the entitlement.
    const { agePension: agePension, rentAssistanceIncome: rentAssistanceIncome, totalAssessableIncome: totalAssessableIncome, socialSecurityBreakdown: socialSecurityBreakdown } = assessAgePension({
        rates: rates,
        isPartnered: isPartnered,
        relationshipStatus: relationshipStatus,
        illnessSeparated: illnessSeparated,
        isHomeowner: isHomeowner,
        clientAge: clientAge,
        partnerAge: partnerAge,
        assessableAssets: assessableAssets,
        deprivedAsset: deprivedAsset,
        formerHomeCounted: strategyOptions.formerHomeExemptionEnded ? Number(factFind.home?.value) || 0 : 0,
        deemedIncome: deemedIncome,
        deemingThreshold: deemingThreshold,
        financialAssetsForDeeming: financialAssetsForDeeming,
        assessableIncomeFromPensions: assessableIncomeFromPensions,
        netRentalIncomeForPension: netRentalIncomeForPension,
        otherAssessableIncome: otherAssessableIncome,
        investmentPropertyRentalForPension: investmentPropertyRentalForPension,
        partnerAssessableIncomeFromPensions: partnerAssessableIncomeFromPensions,
        partnerNetRentalIncomeForPension: partnerNetRentalIncomeForPension,
        partnerOtherAssessableIncome: partnerOtherAssessableIncome,
        partnerInvestmentPropertyRentalForPension: partnerInvestmentPropertyRentalForPension,
        clientResidency: clientResidency,
        partnerResidency: partnerResidency,
        rvResident: rvResident,
        rvIsHomeowner: rvIsHomeowner,
        factFind: factFind,
        heasAgePensionReduction: heasAgePensionReduction,
        structureAttribution: structureAttribution,
        pre2015ABPDetails: pre2015ABPDetails,
        definedBenefitDetails: definedBenefitDetails,
        // The pension alone needs no working shown (see calculateAgePensionEntitlement).
        ...pensionProbe ? {
            withoutBreakdown: true
        } : {}
    });
    // Asked for the pension alone: everything below only consumes it (income walk, loans, tax, the
    // cashflow and its breakdown), so stopping here cannot change the figure — see calculateAgePensionEntitlement.
    if (pensionProbe) {
        pensionProbe.agePension = agePension;
        return null;
    }
    // --- 4. Taxable Income & Cash Income Calculation ---
    // The income walk lives in incomeAssessment.ts and is INJECTED (`options.assessIncome`, defaulting
    // to `calculateIncomeAssessment`) so a caller can own the rules — the projection engine passes in
    // the assessor owned by its incomePlugin, which then pays the salary and rent components monthly
    // instead of settling the lot on 30 June. Both the TAX position and the CASH buckets come back: they
    // are not the same figure (a reinvested dividend is taxed but never banked, an ABP drawdown from age
    // 60 is banked but never taxed), and section 6 below needs the one while section 7 needs the other.
    //
    // `clientTaxable`/`partnerTaxable` come back as live objects because section 5 appends this year's
    // loan-interest deductions to them before the tax is struck.
    const incomeAssessment = assessIncome({
        factFind: factFind,
        strategyOptions: strategyOptions,
        isPartnered: isPartnered,
        clientAge: clientAge,
        partnerAge: partnerAge,
        structureAttribution: structureAttribution
    });
    const { clientTaxable: clientTaxable, partnerTaxable: partnerTaxable, investmentIncomeCash: investmentIncomeCash, investmentIncomeParts: investmentIncomeParts, abpIncomeCash: abpIncomeCash, otherIncomeCash: otherIncomeCash, salaryIncomeCash: salaryIncomeCash, reinvestedDividends: reinvestedDividends, investmentPropertyRentCash: investmentPropertyRentCash, investmentPropertyExpenseCash: investmentPropertyExpenseCash } = incomeAssessment;
    // Section 5's entity loan pool is added to this below.
    let totalRentalExpenses = incomeAssessment.totalRentalExpenses;
    // Always empty today (see entityDisposalTax.ts) — the seam for entity CGT triggered by RAD funding,
    // consumed by the cashflow breakdown in section 7.
    const { extraCashflowItems: radFundingEntityCgtItems } = (0, $a764bc0f6f904854$export$7d1a41f6cfaa2776)();
    // --- 5. Loan Repayments & Deductions ---
    // The liabilities walk lives in loanRepayments.ts and is INJECTED (`options.assessLoanRepayments`,
    // defaulting to `calculateLoanRepayments`) so a caller can own the rules — the projection engine
    // passes in the assessor owned by its loanRepaymentPlugin, which then pays each schedule out at its
    // own frequency instead of settling the lot on 30 June. The DEDUCTIONS have to come back here
    // rather than stay with that plugin: they are part of this function's tax calculation below.
    // `yearsElapsed` takes a year off every loan's remaining term per projected year, so an
    // auto-calculated instalment stays the one the client really pays and the loan ends on time.
    // Year 1 (and any standalone call, where `yearIndex` is absent) is the present: 0 elapsed.
    const loanRepayments = assessLoanRepayments({
        factFind: factFind,
        isPartnered: isPartnered,
        yearsElapsed: yearIndex != null && yearIndex > 1 ? yearIndex - 1 : 0
    });
    let totalLoanRepayments = loanRepayments.totalAnnualRepayments;
    for (const deduction of loanRepayments.deductions)(deduction.owner === 'client' ? clientTaxable : partnerTaxable).deductionSources.push({
        name: deduction.name,
        amount: deduction.amount
    });
    // Trust/company liabilities are excluded from the walk above and pooled here instead, already
    // annualised. They stay a single annual figure: a pool has no one servicing frequency, so unlike
    // the personal schedules there is nothing for the projection engine to time.
    if (structureAttribution?.loanRepaymentsAnnual) totalLoanRepayments += structureAttribution.loanRepaymentsAnnual;
    // --- 6. Tax Calculation ---
    // The tax system lives in incomeTax.ts and is INJECTED (`options.assessIncomeTax`, defaulting to
    // `calculateIncomeTax`) so a caller can own the rules — the projection engine passes in the assessor
    // owned by its incomeTaxPlugin. It runs HERE, after section 5, because the loan-interest deductions
    // appended up there are part of what is taxed.
    //
    // Both people are taxed in one call: a couple's Medicare levy thresholds are struck on their COMBINED
    // income, so neither can be assessed without the other.
    const incomeTax = assessIncomeTax({
        rates: rates,
        clientTaxable: clientTaxable,
        partnerTaxable: partnerTaxable,
        isPartnered: isPartnered,
        illnessSeparated: illnessSeparated,
        relationshipStatus: relationshipStatus,
        client: client,
        partner: partner,
        clientAge: clientAge,
        partnerAge: partnerAge
    });
    const { totalTax: totalTax, taxBreakdown: taxBreakdown } = incomeTax;
    const clientTotalTaxable = incomeTax.client.totalTaxable;
    const partnerTotalTaxable = incomeTax.partner.totalTaxable;
    // --- 7. Final Cash Flow & Net Worth ---
    // Two of the three things this section does are assessments with rules of their own, and both are
    // INJECTED so a caller can own them: the year's expenses (`options.assessExpenses`, defaulting to
    // `calculateExpenses` — the projection engine passes in the assessor owned by its expensesPlugin,
    // which then charges the living and rental components fortnightly) and the balance sheet
    // (`options.assessNetWorth`, defaulting to `calculateNetWorthPosition`, owned by its netWorthPlugin).
    //
    // The third — striking the cashflow and rendering it line by line — stays here. It is not a rule but
    // this function's summing-up: every figure below has already been assessed by one of the seven
    // assessors above, and adding them together is `calculateFinancials`'s own contract rather than any
    // plugin's concern. The projection engine draws the same line, keeping its `engine.cashflowCalc`
    // phase native rather than giving it to a plugin.
    const { netWorth: netWorth } = assessNetWorth({
        factFind: factFind,
        strategyOptions: strategyOptions,
        asOfDate: projectionContext?.assessmentDate
    });
    const expenseAssessment = assessExpenses({
        expenses: expenses,
        factFind: factFind,
        strategyOptions: strategyOptions,
        projectionContext: projectionContext
    });
    const { livingExpenses: livingExpenses, capitalExpenses: capitalExpenses, partnerRent: partnerRent, integratedAgedCareCost: integratedAgedCareCost } = expenseAssessment;
    // What the household pays to live where it lives — rent, village fees, board (8 Oct 2026).
    const housingCosts = Number(expenseAssessment.housingCosts) || 0;
    const housingCostsLabel = expenseAssessment.housingCostsLabel || 'rent';
    const totalGrossIncome = otherIncomeCash + investmentIncomeCash + abpIncomeCash + agePension + reverseMortgageIncome + heasIncome + rentAssistanceIncome;
    const totalExpenses = livingExpenses + totalRentalExpenses + totalTax + totalLoanRepayments + capitalExpenses + partnerRent + integratedAgedCareCost + housingCosts;
    const cashFlow = totalGrossIncome - totalExpenses;
    /*
     * Investment income, ITEMISED BY KIND.
     *
     * One "Investment Income (Cash)" line used to carry bank interest, share dividends and property
     * rent together. The total was right, but an adviser going through it with a client could not
     * say which asset produced what — and calling a rental property's income "investment income
     * (cash)" reads like a category error to the person who owns the house (reported 2026-08-22).
     *
     * Zero-value kinds are omitted rather than printed as $0, and a client whose investment income
     * happens to be all one kind still sees it named ("Interest") rather than generically. The four
     * parts sum to `investmentIncomeCash`, which is what every total is still struck from — nothing
     * here changes a figure.
     */ const investmentIncomeLines = [
        {
            label: 'Interest (bank & term deposits)',
            value: investmentIncomeParts.interest,
            series: 'investment'
        },
        {
            label: 'Dividends (shares & funds)',
            value: investmentIncomeParts.dividends,
            series: 'investment'
        },
        {
            label: 'Rent (property)',
            value: investmentIncomeParts.rent,
            series: 'investment'
        },
        {
            label: 'Trust & Company Income',
            value: investmentIncomeParts.structures,
            series: 'investment'
        },
        {
            label: 'Other Investment Income',
            value: investmentIncomeParts.other,
            series: 'investment'
        }
    ].filter((line)=>line.value !== 0);
    const cashFlowBreakdown = [
        // Fall back to the single line when the parts are all zero but the total is not, so a future
        // income source added to the walk and forgotten here still appears somewhere.
        ...investmentIncomeLines.length > 0 ? investmentIncomeLines : [
            {
                label: 'Investment Income (Cash)',
                value: investmentIncomeCash,
                series: 'investment'
            }
        ],
        /*
         * A NOTE, not a cashflow line: `note: true` marks a row that explains the figures without
         * being one of them, and every consumer that sums this breakdown must skip it.
         *
         * Reinvested dividends are taxed but never banked, so they are correctly absent from cash
         * income — but absent and forgotten look identical on screen. An adviser with $150,000 of
         * shares at 4% and no dividend line anywhere asked where the share income had gone
         * (2026-08-22). Now it says.
         */ ...reinvestedDividends > 0 ? [
            {
                label: 'Dividends reinvested (taxed, not received as cash)',
                value: reinvestedDividends,
                note: true
            }
        ] : [],
        ...abpIncomeCash > 0 ? [
            {
                label: 'ABP Income',
                value: abpIncomeCash
            }
        ] : [],
        {
            label: 'Other Income (Cash)',
            value: otherIncomeCash
        },
        {
            label: 'Age Pension (Est.)',
            value: agePension
        },
        ...reverseMortgageIncome > 0 ? [
            {
                label: 'Reverse Mortgage Payments',
                value: reverseMortgageIncome
            }
        ] : [],
        ...heasIncome > 0 ? [
            {
                label: 'HEAS Income',
                value: heasIncome
            }
        ] : [],
        ...rentAssistanceIncome > 0 ? [
            {
                label: 'Rent Assistance',
                value: rentAssistanceIncome
            }
        ] : [],
        {
            label: 'Less: Rental Expenses',
            value: -totalRentalExpenses
        },
        {
            label: 'Less: Living Expenses',
            value: -livingExpenses
        },
        ...housingCosts > 0 ? [
            {
                label: `Less: Housing Costs (${housingCostsLabel})`,
                value: -housingCosts
            }
        ] : [],
        ...integratedAgedCareCost > 0 ? [
            {
                label: 'Less: Aged Care Costs',
                value: -integratedAgedCareCost
            }
        ] : [],
        {
            label: 'Less: Capital Expenses',
            value: -capitalExpenses
        },
        {
            label: 'Less: Loan Repayments',
            value: -totalLoanRepayments
        }
    ];
    if (partnerRent > 0) cashFlowBreakdown.push({
        label: "Less: Partner's Rent",
        value: -partnerRent
    });
    if (isPartnered) {
        cashFlowBreakdown.push({
            label: incomeTax.client.netTax < 0 ? `Add: ${client.firstName || 'Client'} Tax Refund` : `Less: ${client.firstName || 'Client'} Tax`,
            value: -incomeTax.client.netTax
        });
        cashFlowBreakdown.push({
            label: incomeTax.partner.netTax < 0 ? `Add: ${partner.firstName || 'Partner'} Tax Refund` : `Less: ${partner.firstName || 'Partner'} Tax`,
            value: -incomeTax.partner.netTax
        });
    } else cashFlowBreakdown.push({
        label: totalTax < 0 ? 'Add: Tax Refund' : 'Less: Estimated Tax',
        value: -totalTax
    });
    const radFundingEntityCgtTotal = (radFundingEntityCgtItems || []).reduce((sum, item)=>sum + (item.value || 0), 0);
    if (radFundingEntityCgtTotal !== 0) radFundingEntityCgtItems.forEach((item)=>cashFlowBreakdown.push(item));
    const cashFlowWithEntityRadCgt = cashFlow + radFundingEntityCgtTotal;
    return {
        netWorth: netWorth,
        cashFlow: cashFlowWithEntityRadCgt,
        socialSecurity: agePension,
        rentAssistanceIncome: // Said separately (7 Oct 2026): the screens and the living-arrangement tests need to know
        // whether Rent Assistance is being paid and on which thresholds the pension was struck.
        rentAssistanceIncome,
        isHomeowner: isHomeowner,
        investmentIncome: investmentIncomeCash + abpIncomeCash,
        abpIncome: abpIncomeCash,
        salaryIncomeCash: // Salary component of otherIncomeCash, surfaced so the projection engine can pay it monthly
        // (see incomePlugin). Additive only — every other returned figure already accounts for salary.
        salaryIncomeCash,
        investmentPropertyRentCash: // Gross investment-property rent and expenses, plus this year's living expenses, surfaced
        // (additively) so the projection engine can pay/charge them monthly too (see expensesPlugin).
        // Already reflected in the annual cashFlow.
        investmentPropertyRentCash,
        investmentPropertyExpenseCash: investmentPropertyExpenseCash,
        livingExpensesCash: livingExpenses,
        // This period's one-off capital expenses, surfaced so the projection engine can REPORT the
        // figure on its row (the projections modal itemises it and adds it into "Total Expenses").
        // Already inside the annual `cashFlow` above — surfacing it changes no calculation, it ends
        // a silence: a year could drop by a $50,000 capital expense with nothing in the breakdown
        // saying why, because the row carried a hardcoded 0.
        capitalExpensesCash: capitalExpenses,
        // Each personally-serviced liability's repayment schedule, surfaced (additively) so the
        // projection engine can pay it at the frequency the client actually services it — weekly,
        // fortnightly or monthly (see loanRepaymentPlugin). Already reflected in the annual cashFlow
        // via `totalLoanRepayments`; the trust/company pool is not among them (see section 5).
        loanRepaymentSchedules: loanRepayments.schedules,
        netTax: totalTax,
        cashFlowBreakdown: cashFlowBreakdown,
        taxBreakdown: taxBreakdown,
        socialSecurityBreakdown: socialSecurityBreakdown,
        assessableAssets: assessableAssets,
        assessableAssetsNoHome: assessableAssetsNoHome,
        deemedIncome: deemedIncome,
        assessableIncomeFromPensions: assessableIncomeFromPensions,
        netRentalIncomeForPension: netRentalIncomeForPension,
        otherAssessableIncome: otherAssessableIncome,
        partnerAssessableIncomeFromPensions: partnerAssessableIncomeFromPensions,
        partnerNetRentalIncomeForPension: partnerNetRentalIncomeForPension,
        partnerOtherAssessableIncome: partnerOtherAssessableIncome,
        totalAssessableIncome: // Struck by the means test above (which sums the same components), and read by the aged-care
        // means test as well as the pension one — hence reported whatever the client's age.
        totalAssessableIncome,
        clientAssessableIncome: clientTotalTaxable,
        partnerAssessableIncome: partnerTotalTaxable,
        // Everything the CGT engine needs to tax a capital gain DIFFERENTIALLY under the same rules
        // applied above — this year's (possibly indexed) `rates` bag and each person's position, in the
        // exact shape `incomeTax.ts`'s assessor takes, so the gain is re-taxed by THE tax system rather
        // than an approximation of it. Without this, CGT was estimated as a flat marginal rate on the
        // whole gain, which ignored bracket steps, the Medicare levy and the SAPTO/LITO taper the gain
        // causes. See disposalCgt.ts.
        taxContext: {
            rates: rates,
            relationshipStatus: relationshipStatus,
            isPartnered: isPartnered,
            illnessSeparated: illnessSeparated,
            // Age Pension / other income support in this year exempts the client from the 2027 reform's
            // 30% minimum tax on the real gain (see CGT_REGIME.incomeSupportExempt).
            receivesIncomeSupport: (agePension || 0) > 0,
            client: {
                taxableIncome: clientTotalTaxable,
                frankingCredits: clientTaxable.frankingCredits || 0,
                age: clientAge,
                hasPhi: client?.phi === true
            },
            partner: {
                taxableIncome: partnerTotalTaxable,
                frankingCredits: partnerTaxable.frankingCredits || 0,
                age: partnerAge,
                hasPhi: partner?.phi === true
            }
        }
    };
};
const $db6ce683330fb15a$export$463f0620dd36e1f8 = (factFind, strategyOptions = {}, yearsSinceRented = 0, projectionContext = {}, options = {})=>$db6ce683330fb15a$var$calculateFinancialsCore(factFind, strategyOptions, yearsSinceRented, projectionContext, options);
const $db6ce683330fb15a$export$ec890a30e61d0e9d = (factFind, strategyOptions = {}, yearsSinceRented = 0, projectionContext = {}, options = {})=>{
    const probe = {
        agePension: 0
    };
    $db6ce683330fb15a$var$calculateFinancialsCore(factFind, strategyOptions, yearsSinceRented, projectionContext, options, probe);
    return probe.agePension;
};


/**
 * Shared downsizer contribution logic — accumulation super vs commenced ABP (minimum drawdown).
 * Ported verbatim from frontend/src/calculations/downsizerContributionUtils.js.
 */ 



/**
 * Transfer Balance Cap — the lifetime limit (~$2m per person) on money moved into retirement-phase
 * pensions. A strategy that "commences an account-based pension" for a person with no headroom is
 * recommending something the law does not allow, so the engine SPLITS at the cap: the headroom goes
 * into the pension, the excess into accumulation super (clearly named), and the ranking prices each
 * part at its own tax treatment.
 *
 * What counts against a person's cap is the amounts TRANSFERRED into retirement phase over their
 * lifetime — not today's balance (growth doesn't consume cap; drawdowns don't restore it). The tool
 * therefore works from, in order:
 *   1. the person's RECORDED lifetime transfer amount (`client/partner.transferBalanceUsed`, from
 *      the ATO's "transfer balance account" figure in myGov), asked just-in-time only when the
 *      screen below trips — never as a routine fact-find question; else
 *   2. an ESTIMATE: the person's current retirement-phase pension balances. Stated wherever it is
 *      used, and in the SOA assumptions.
 *
 * DOCUMENTED LIMITATION (adviser-accepted 2026-08-20, disclosed in the SOA assumptions whenever a
 * strategy commences a pension): the estimate can UNDERSTATE cap usage for a person who moved a
 * large sum into a pension years ago and has since drawn it down — their history is invisible to a
 * balance-based estimate. The just-in-time question exists precisely to let an adviser correct
 * this; the screen at $1.6m (the lowest possible personal cap) keeps the question away from every
 * file it cannot affect.
 */ 
const $4f5a997f1c0139af$var$num = (v)=>Math.max(0, parseFloat(String(v ?? '')) || 0);
function $4f5a997f1c0139af$export$679de7d1464bccb9(factFind, who) {
    return (factFind?.assets?.accountBasedPensions || []).reduce((sum, abp)=>{
        const value = $4f5a997f1c0139af$var$num(abp?.value);
        if (abp?.ownership === who) return sum + value;
        if (abp?.ownership === 'joint') return sum + value / 2;
        return sum;
    }, 0);
}
function $4f5a997f1c0139af$export$35f989d19c47fb75(factFind, who) {
    const person = who === 'partner' ? factFind?.partner : factFind?.client;
    const raw = person?.transferBalanceUsed;
    return raw !== undefined && raw !== null && raw !== '' && Number.isFinite(parseFloat(String(raw)));
}
function $4f5a997f1c0139af$export$78b3e2059765d50f(factFind, who) {
    if ($4f5a997f1c0139af$export$35f989d19c47fb75(factFind, who)) {
        const person = who === 'partner' ? factFind?.partner : factFind?.client;
        return $4f5a997f1c0139af$var$num(person.transferBalanceUsed);
    }
    return $4f5a997f1c0139af$export$679de7d1464bccb9(factFind, who);
}
function $4f5a997f1c0139af$export$f55aec102ef92752(factFind, who) {
    return Math.max(0, (0, $1abe73eeef086faf$export$807e93be6ec93c1b) - $4f5a997f1c0139af$export$78b3e2059765d50f(factFind, who));
}
function $4f5a997f1c0139af$export$7bf826dbcbb0ddc(factFind, who) {
    if ($4f5a997f1c0139af$export$35f989d19c47fb75(factFind, who)) return false;
    return $4f5a997f1c0139af$export$679de7d1464bccb9(factFind, who) + (0, $1abe73eeef086faf$export$42edd27decf8c272) >= (0, $1abe73eeef086faf$export$29a056d5c6e73455);
}


const $f1228be62b68f76b$export$fd180c62865277a2 = 55;
const $f1228be62b68f76b$export$e41227d4c09e51ee = (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703).high_growth.pensionNetPct;
const $f1228be62b68f76b$export$16c21d200a7b2b7 = (0, $0f2c0a6799fe36da$export$7bfc03a1cb4bfc25)('high_growth');
const $f1228be62b68f76b$export$ba36344f7e13acec = 60;
function $f1228be62b68f76b$export$52c4b531b4b88390(factFind, ownership = 'client') {
    if (ownership === 'partner' && factFind?.partner?.dob) return (0, $876c355975468a36$export$8ada184d5eef4694)(factFind.partner.dob);
    if (factFind?.client?.dob) return (0, $876c355975468a36$export$8ada184d5eef4694)(factFind.client.dob);
    return null;
}
function $f1228be62b68f76b$export$323aae9f0aa61406(factFind, ownership = 'client') {
    const age = $f1228be62b68f76b$export$52c4b531b4b88390(factFind, ownership);
    return age != null && age >= $f1228be62b68f76b$export$fd180c62865277a2;
}
function $f1228be62b68f76b$export$d1b692f4d3924fcd(factFind, ownership = 'client') {
    const age = $f1228be62b68f76b$export$52c4b531b4b88390(factFind, ownership);
    return age != null && age >= $f1228be62b68f76b$export$ba36344f7e13acec;
}
function $f1228be62b68f76b$var$resolveDownsizerAssetId(options, ownership) {
    if (options.assetId && ownership === 'client') return options.assetId;
    if (options.partnerAssetId && ownership === 'partner') return options.partnerAssetId;
    const idPrefix = options.idPrefix || 'downsizer';
    return ownership === 'partner' ? `${idPrefix}-partner` : idPrefix;
}
function $f1228be62b68f76b$export$a69cf827bb25548e(assets, factFind, options = {}) {
    const amount = Math.max(0, options.amount || 0);
    if (amount <= 0 || !assets) return;
    const ownership = options.ownership || 'client';
    const commenceIncomeStream = options.commenceIncomeStream === true;
    const ownerAge = $f1228be62b68f76b$export$52c4b531b4b88390(factFind, ownership);
    const asAbp = commenceIncomeStream && $f1228be62b68f76b$export$d1b692f4d3924fcd(factFind, ownership);
    // The same booking serves an after-tax contribution (nonConcessionalContributions.ts), which
    // names its assets differently so a balance sheet says which rule put the money there.
    const labels = {
        abp: options.labels?.abp ?? 'Downsizer ABP',
        capped: options.labels?.capped ?? 'Downsizer to super (pension cap reached)',
        contribution: options.labels?.contribution ?? 'Downsizer Contribution'
    };
    const assetId = $f1228be62b68f76b$var$resolveDownsizerAssetId(options, ownership);
    // Priced at the client's new-money profile (Conservative until they answer) — the same
    // portfolio the strategy's personal-investment leg assumes, in the wrapper's tax treatment.
    const profileId = (0, $0f2c0a6799fe36da$export$580cfd0c6323bf7e)(factFind);
    const profileRow = (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[profileId];
    const accumulationRatePct = (0, $0f2c0a6799fe36da$export$7bfc03a1cb4bfc25)(profileId);
    if (asAbp) {
        // The Transfer Balance Cap: a person can only move their remaining headroom into a
        // retirement-phase pension — recommending more is recommending something the law does not
        // allow. The pension takes the headroom; the excess is booked to accumulation super under
        // a name that says why, so it is visible in every net-worth breakdown.
        const headroom = (0, $4f5a997f1c0139af$export$f55aec102ef92752)(factFind, ownership === 'partner' ? 'partner' : 'client');
        const toPension = Math.min(amount, headroom);
        const toAccumulation = amount - toPension;
        if (toPension > 0) {
            if (!assets.accountBasedPensions) assets.accountBasedPensions = [];
            // A chosen draw above the minimum is kept, year by year (abpPlugin); below it, the minimum.
            const minimum = (0, $e0f54937e270d5ff$export$548fd6b682208d71)(toPension, ownerAge);
            const chosen = Math.max(0, Number(options.drawAmount) || 0);
            const annualIncome = Math.max(minimum, chosen);
            assets.accountBasedPensions.push({
                id: `${assetId}-abp`,
                type: 'accountBasedPensions',
                description: ownership === 'partner' ? `${labels.abp} (Partner)` : labels.abp,
                value: toPension,
                ownership: ownership,
                income: annualIncome,
                growthRate: profileRow.pensionNetPct,
                __abpFundedAcquisition: true,
                ...chosen > minimum ? {
                    __abpChosenDraw: chosen
                } : {}
            });
        }
        if (toAccumulation > 0) {
            if (!assets.superannuation) assets.superannuation = [];
            assets.superannuation.push({
                id: `${assetId}-capped`,
                type: 'superannuation',
                description: ownership === 'partner' ? `Partner ${labels.capped}` : labels.capped,
                value: toAccumulation,
                ownership: ownership,
                growthRate: accumulationRatePct
            });
        }
        return;
    }
    if (!assets.superannuation) assets.superannuation = [];
    assets.superannuation.push({
        id: assetId,
        type: 'superannuation',
        description: ownership === 'partner' ? `Partner ${labels.contribution}` : labels.contribution,
        value: amount,
        ownership: ownership,
        growthRate: accumulationRatePct
    });
}
function $f1228be62b68f76b$export$308a4644edfb910(factFind) {
    const isCouple = factFind?.adviceFor === 'couple';
    const clientAge = $f1228be62b68f76b$export$52c4b531b4b88390(factFind, 'client');
    const partnerAge = isCouple ? $f1228be62b68f76b$export$52c4b531b4b88390(factFind, 'partner') : null;
    const clientEligible = clientAge != null && clientAge >= $f1228be62b68f76b$export$fd180c62865277a2;
    const partnerEligible = isCouple && partnerAge != null && partnerAge >= $f1228be62b68f76b$export$fd180c62865277a2;
    // "Exempt" here means the means-test exemption on accumulation super below Age Pension age —
    // the only reason one member's name beats the other's.
    const clientExempt = clientEligible && clientAge < (0, $1abe73eeef086faf$export$5b6998cba7880742);
    const partnerExempt = partnerEligible && partnerAge < (0, $1abe73eeef086faf$export$5b6998cba7880742);
    const preferred = clientExempt && !partnerExempt ? 'client' : partnerExempt && !clientExempt ? 'partner' : null;
    return {
        preferred: preferred,
        clientEligible: clientEligible,
        partnerEligible: partnerEligible,
        preferredAge: preferred === 'client' ? clientAge : preferred === 'partner' ? partnerAge : null
    };
}
function $f1228be62b68f76b$export$6373eb0865b1a234(factFind, available, caps = {}) {
    const { preferred: preferred, clientEligible: clientEligible, partnerEligible: partnerEligible } = $f1228be62b68f76b$export$308a4644edfb910(factFind);
    const clientCap = Math.min((0, $1abe73eeef086faf$export$42edd27decf8c272), Math.max(0, caps.client ?? (0, $1abe73eeef086faf$export$42edd27decf8c272)));
    const partnerCap = Math.min((0, $1abe73eeef086faf$export$42edd27decf8c272), Math.max(0, caps.partner ?? (0, $1abe73eeef086faf$export$42edd27decf8c272)));
    let remaining = Math.max(0, available || 0);
    let client = 0;
    let partner = 0;
    if (preferred === 'client' && clientEligible) {
        client = Math.min(clientCap, remaining);
        remaining -= client;
        if (partnerEligible) partner = Math.min(partnerCap, remaining);
    } else if (preferred === 'partner' && partnerEligible) {
        partner = Math.min(partnerCap, remaining);
        remaining -= partner;
        if (clientEligible) client = Math.min(clientCap, remaining);
    } else if (clientEligible && partnerEligible) {
        client = Math.min(clientCap, Math.round(remaining / 2));
        remaining -= client;
        partner = Math.min(partnerCap, remaining);
    } else if (clientEligible) client = Math.min(clientCap, remaining);
    else if (partnerEligible) partner = Math.min(partnerCap, remaining);
    return {
        client: client,
        partner: partner,
        preferred: preferred
    };
}
function $f1228be62b68f76b$export$a72a115b20fefbbf(assets, factFind, details = {}, options = {}) {
    const commenceIncomeStream = details.commenceIncomeStream === true;
    $f1228be62b68f76b$export$a69cf827bb25548e(assets, factFind, {
        amount: details.downsizerContribution,
        ownership: 'client',
        commenceIncomeStream: commenceIncomeStream,
        drawAmount: details.clientDrawAmount,
        idPrefix: options.idPrefix,
        assetId: options.assetId
    });
    $f1228be62b68f76b$export$a69cf827bb25548e(assets, factFind, {
        amount: details.partnerDownsizerContribution,
        ownership: 'partner',
        commenceIncomeStream: commenceIncomeStream,
        drawAmount: details.partnerDrawAmount,
        idPrefix: options.partnerIdPrefix || options.idPrefix,
        partnerAssetId: options.partnerAssetId
    });
}







/**
 * Shared "deploy a residual lump sum" helper — mutates `data.assets` in place and returns the total
 * amount deployed so the caller can route the remainder to the bank.
 * Ported verbatim from frontend/src/calculations/residualDeployment.js.
 */ 


/**
 * Non-concessional (after-tax) super contributions — who may make one, and how much.
 *
 * WHY THIS EXISTS. Until now the only route money could take into super in this tool was a downsizer
 * contribution: $300,000 per person, once, tied to a home sale. Everything above that could only
 * land in the bank, shares, an investment property, an annuity or a gift — all of which are counted
 * by Centrelink. That mattered most for the couple this tool sees constantly in the Retirement
 * Village module: one member under Age Pension age, whose accumulation super is exempt from BOTH
 * means tests until they reach it (see downsizerContributionUtils and
 * server/tests/rest/calculation/youngerSpouseSuperExemption.test.ts). The lever existed; there was
 * simply no way to put more than $300k behind it.
 *
 * ELIGIBILITY IS ALL-OR-NOTHING, BY DESIGN. The owner's instruction (2026-08-26) was that this be
 * logic-based: where a person cannot contribute, the strategy must not appear in Manual Control and
 * must not be weighted by the Suggestion Engine — not shown greyed out, not offered and then
 * refused. `nonConcessionalCapacityFor` returns 0 in exactly those cases, and every caller treats 0
 * as "this strategy does not exist for this person".
 *
 * THE RULES MODELLED (ATO, 2026-27 — verified 2026-08-26; re-check each 1 July):
 *  - Age: must be UNDER 75. No work test applies to non-concessional contributions.
 *  - Total super balance at the previous 30 June decides the cap, in bands set by the general
 *    transfer balance cap less one and two times the annual cap:
 *        TSB < $1.84m -> $390,000 (3-year bring-forward)
 *        TSB < $1.97m -> $260,000 (2-year bring-forward)
 *        TSB < $2.10m -> $130,000 (annual cap only)
 *        TSB >= $2.10m -> NIL — no contribution at all.
 *  - The cap is frozen at the first year's rate for a bring-forward period already running; this
 *    tool models a contribution made now, so it always prices the current year's rate.
 *
 * WHAT IS DELIBERATELY NOT MODELLED: concessional contributions (a work test applies at 67-74, the
 * cap is small, and for this cohort it rarely moves the answer), and the 28-day grace a fund may
 * allow after the month a person turns 75.
 */ 

const $996111778bb35e70$var$amount = (value)=>{
    const parsed = parseFloat(String(value ?? ''));
    return Number.isFinite(parsed) ? parsed : 0;
};
function $996111778bb35e70$export$be9cac62d60c11c5(factFind, owner) {
    const assets = factFind?.assets || {};
    let total = 0;
    for (const type of [
        'superannuation',
        'accountBasedPensions'
    ])for (const asset of assets[type] || []){
        if (asset?.ownership !== owner) continue;
        total += $996111778bb35e70$var$amount(asset?.value ?? asset?.balance);
    }
    return total;
}
function $996111778bb35e70$export$47767360ada058a3(factFind, owner, statedTotalSuperBalance) {
    const isCouple = factFind?.adviceFor === 'couple';
    if (owner === 'partner' && !isCouple) return {
        owner: owner,
        cap: 0,
        years: 0,
        totalSuperBalance: 0,
        balanceEstimated: false,
        blocker: 'no_person',
        exemptFromMeansTests: false
    };
    const age = (0, $f1228be62b68f76b$export$52c4b531b4b88390)(factFind, owner);
    if (age == null) return {
        owner: owner,
        cap: 0,
        years: 0,
        totalSuperBalance: 0,
        balanceEstimated: false,
        blocker: 'no_person',
        exemptFromMeansTests: false
    };
    const balanceEstimated = statedTotalSuperBalance == null;
    const totalSuperBalance = balanceEstimated ? $996111778bb35e70$export$be9cac62d60c11c5(factFind, owner) : Math.max(0, statedTotalSuperBalance);
    const exemptFromMeansTests = age < (0, $1abe73eeef086faf$export$5b6998cba7880742);
    // Age first: under 75 or nothing at all, whatever the balance says.
    if (age >= (0, $1abe73eeef086faf$export$2b0b6412a74e90de)) return {
        owner: owner,
        cap: 0,
        years: 0,
        totalSuperBalance: totalSuperBalance,
        balanceEstimated: balanceEstimated,
        blocker: 'age',
        exemptFromMeansTests: exemptFromMeansTests
    };
    // The bands ARE the transfer balance cap less one and two annual caps — derived, never hardcoded,
    // so both figures indexing on the same 1 July can only move them together.
    const twoYearFloor = (0, $1abe73eeef086faf$export$807e93be6ec93c1b) - 2 * (0, $1abe73eeef086faf$export$e5af7a7374b9aef3);
    const oneYearFloor = (0, $1abe73eeef086faf$export$807e93be6ec93c1b) - (0, $1abe73eeef086faf$export$e5af7a7374b9aef3);
    let years;
    if (totalSuperBalance >= (0, $1abe73eeef086faf$export$807e93be6ec93c1b)) years = 0;
    else if (totalSuperBalance >= oneYearFloor) years = 1;
    else if (totalSuperBalance >= twoYearFloor) years = 2;
    else years = 3;
    return {
        owner: owner,
        cap: years * (0, $1abe73eeef086faf$export$e5af7a7374b9aef3),
        years: years,
        totalSuperBalance: totalSuperBalance,
        balanceEstimated: balanceEstimated,
        blocker: years === 0 ? 'total_super_balance' : null,
        exemptFromMeansTests: exemptFromMeansTests
    };
}
function $996111778bb35e70$export$773ed733b3205cdb(name, blocker) {
    const who = name === 'you' ? 'You' : name;
    const cannot = name === 'you' ? "can't" : "can't";
    if (blocker === 'age') return `${who} ${cannot} make an after-tax contribution \u{2014} the rules close the door at ${0, $1abe73eeef086faf$export$2b0b6412a74e90de}.`;
    if (blocker === 'total_super_balance') return `${who} ${cannot} make an after-tax contribution \u{2014} ${name === 'you' ? 'your' : 'their'} total super balance is already at the cap (${(0, $1abe73eeef086faf$export$807e93be6ec93c1b).toLocaleString('en-AU', {
        style: 'currency',
        currency: 'AUD',
        maximumFractionDigits: 0
    })}).`;
    return null;
}
function $996111778bb35e70$export$3156faa588d94c0c(factFind, stated = {}) {
    const client = $996111778bb35e70$export$47767360ada058a3(factFind, 'client', stated.client);
    const partner = $996111778bb35e70$export$47767360ada058a3(factFind, 'partner', stated.partner);
    const clientPrefers = client.cap > 0 && client.exemptFromMeansTests;
    const partnerPrefers = partner.cap > 0 && partner.exemptFromMeansTests;
    const preferred = clientPrefers && !partnerPrefers ? 'client' : partnerPrefers && !clientPrefers ? 'partner' : null;
    return {
        client: client,
        partner: partner,
        total: client.cap + partner.cap,
        preferred: preferred
    };
}
function $996111778bb35e70$export$38069100974264d(factFind, available, stated = {}) {
    const capacity = $996111778bb35e70$export$3156faa588d94c0c(factFind, stated);
    let remaining = Math.max(0, available || 0);
    let client = 0;
    let partner = 0;
    const fill = (owner)=>{
        const cap = owner === 'client' ? capacity.client.cap : capacity.partner.cap;
        const take = Math.min(cap, remaining);
        remaining -= take;
        if (owner === 'client') client = take;
        else partner = take;
    };
    if (capacity.preferred === 'client') {
        fill('client');
        fill('partner');
    } else if (capacity.preferred === 'partner') {
        fill('partner');
        fill('client');
    } else if (capacity.client.cap > 0 && capacity.partner.cap > 0) {
        // Pension-neutral: split evenly, which also spreads a later pension commencement across two
        // transfer balance caps instead of loading one.
        const half = Math.round(remaining / 2);
        client = Math.min(capacity.client.cap, half);
        remaining -= client;
        partner = Math.min(capacity.partner.cap, remaining);
    } else {
        fill('client');
        fill('partner');
    }
    return {
        client: client,
        partner: partner,
        preferred: capacity.preferred
    };
}
const $996111778bb35e70$export$805660e8993666e7 = {
    abp: 'After-tax contribution ABP',
    capped: 'After-tax contribution to super (pension cap reached)',
    contribution: 'After-tax super contribution'
};
function $996111778bb35e70$export$913c841d59a426c3(assets, factFind, options) {
    const capacity = $996111778bb35e70$export$47767360ada058a3(factFind, options.ownership, options.statedTotalSuperBalance);
    const amount = Math.min(Math.max(0, options.amount || 0), capacity.cap);
    if (amount <= 0) return 0;
    (0, $f1228be62b68f76b$export$a69cf827bb25548e)(assets, factFind, {
        amount: amount,
        ownership: options.ownership,
        commenceIncomeStream: options.commenceIncomeStream === true,
        idPrefix: options.idPrefix || 'after-tax-super',
        labels: $996111778bb35e70$export$805660e8993666e7
    });
    return amount;
}


const $86923a7f40531161$var$num = (v)=>Math.max(0, v || 0);
function $86923a7f40531161$export$90c44e1a4433ba8a(deployment) {
    if (!deployment) return 0;
    return $86923a7f40531161$var$num(deployment.shares) + $86923a7f40531161$var$num(deployment.investmentProperty) + $86923a7f40531161$var$num(deployment.ipStampDuty) + $86923a7f40531161$var$num(deployment.annuity) + $86923a7f40531161$var$num(deployment.superContribution) + $86923a7f40531161$var$num(deployment.partnerSuperContribution) + $86923a7f40531161$var$num(deployment.investmentBond);
}
function $86923a7f40531161$export$b45d0024f709a9d6(base, amount, overrides) {
    return {
        id: overrides.id,
        type: 'investmentBonds',
        description: overrides.description ?? 'Investment bond',
        value: amount,
        ownership: overrides.ownership ?? (base?.adviceFor === 'couple' ? 'joint' : 'client'),
        incomeRate: 0,
        growthRate: (0, $0f2c0a6799fe36da$export$d4067a97c0e75560)((0, $0f2c0a6799fe36da$export$580cfd0c6323bf7e)(base)),
        costBase: amount,
        __investmentBondYearsHeld: 0
    };
}
function $86923a7f40531161$export$efee12160933bebf(data, deployment, ctx = {}) {
    if (!deployment) return 0;
    const base = ctx.factFind || data;
    const idPrefix = ctx.idPrefix || 'deploy';
    const isCouple = base?.adviceFor === 'couple';
    const defaultOwnership = ctx.defaultOwnership || (isCouple ? 'joint' : 'client');
    if (!data.assets) data.assets = {};
    let deployed = 0;
    const shares = $86923a7f40531161$var$num(deployment.shares);
    if (shares > 0) {
        if (!data.assets.shares) data.assets.shares = [];
        // Priced at the client's new-money profile (Conservative until they answer).
        const split = (0, $0f2c0a6799fe36da$export$2916b5515a75a453)((0, $0f2c0a6799fe36da$export$580cfd0c6323bf7e)(base));
        data.assets.shares.push({
            id: `${idPrefix}-shares`,
            type: 'shares',
            description: 'Shares / managed funds (from proceeds)',
            value: shares,
            ownership: defaultOwnership,
            incomeRate: split.incomeRatePct,
            growthRate: split.growthRatePct,
            costBase: shares,
            frankingCredit: split.frankingPct,
            reinvest: false
        });
        deployed += shares;
    }
    const ip = $86923a7f40531161$var$num(deployment.investmentProperty);
    if (ip > 0) {
        if (!data.assets.investmentProperty) data.assets.investmentProperty = [];
        data.assets.investmentProperty.push({
            id: `${idPrefix}-inv-prop`,
            type: 'investmentProperty',
            description: 'Investment property (from proceeds)',
            value: ip,
            ownership: deployment.ipOwnership || defaultOwnership,
            rent: $86923a7f40531161$var$num(deployment.ipRent),
            expenses: $86923a7f40531161$var$num(deployment.ipExpenses),
            growthRate: (0, $0f2c0a6799fe36da$export$b037eefb915b86ec).propertyGrowthPct,
            // The duty is money spent on the purchase: gone from the proceeds, kept in the cost base.
            costBase: ip + $86923a7f40531161$var$num(deployment.ipStampDuty),
            acquisitionDate: 'post'
        });
        deployed += ip + $86923a7f40531161$var$num(deployment.ipStampDuty);
    }
    // After-tax super, capped per person at what the rules allow — the cap is applied HERE, so a
    // manual figure above it books the cap and the excess stays in the bank.
    const superClient = $86923a7f40531161$var$num(deployment.superContribution);
    if (superClient > 0) deployed += (0, $996111778bb35e70$export$913c841d59a426c3)(data.assets, base, {
        amount: superClient,
        ownership: 'client',
        commenceIncomeStream: !!deployment.superCommenceIncomeStream,
        idPrefix: `${idPrefix}-super`
    });
    const superPartner = isCouple ? $86923a7f40531161$var$num(deployment.partnerSuperContribution) : 0;
    if (superPartner > 0) deployed += (0, $996111778bb35e70$export$913c841d59a426c3)(data.assets, base, {
        amount: superPartner,
        ownership: 'partner',
        commenceIncomeStream: !!deployment.superCommenceIncomeStream,
        idPrefix: `${idPrefix}-super`
    });
    const bond = $86923a7f40531161$var$num(deployment.investmentBond);
    if (bond > 0) {
        if (!data.assets.investmentBonds) data.assets.investmentBonds = [];
        data.assets.investmentBonds.push($86923a7f40531161$export$b45d0024f709a9d6(base, bond, {
            id: `${idPrefix}-bond`,
            description: 'Investment bond (from proceeds)',
            ownership: defaultOwnership
        }));
        deployed += bond;
    }
    const annuity = $86923a7f40531161$var$num(deployment.annuity);
    if (annuity > 0) {
        const clientAge = base?.client?.dob ? (0, $876c355975468a36$export$8ada184d5eef4694)(base.client.dob) : 65;
        const owner = deployment.annuityOwner || defaultOwnership;
        // Honour the ownership choice: a single owner with no reversionary is single-life (no partner age),
        // matching the shared annuity configurator. Joint ownership or a reversionary nomination prices joint-life.
        const wantsContinuation = !!deployment.annuityReversionary || owner === 'joint';
        const partnerAge = isCouple && wantsContinuation && base?.partner?.dob ? (0, $876c355975468a36$export$8ada184d5eef4694)(base.partner.dob) : null;
        const annuityType = deployment.annuityType === 'fixedTerm' ? 'fixedTerm' : deployment.annuityType === 'guaranteed' ? 'guaranteed' : 'lifetime';
        const residualCapital = Math.min(1, Math.max(0, $86923a7f40531161$var$num(deployment.annuityResidualPercent) / 100));
        const termYears = annuityType === 'fixedTerm' ? $86923a7f40531161$var$num(deployment.annuityTermYears) || null : null;
        const deferralYears = annuityType === 'lifetime' ? Math.round($86923a7f40531161$var$num(deployment.annuityDeferralYears)) : 0;
        const incomeOverride = deployment.annuityIncomeOverride != null ? deployment.annuityIncomeOverride : null;
        const annuityRecord = (0, $f7f7b62814c3b615$export$fb67395f10ad20c9)(base, {
            id: `${idPrefix}-annuity`,
            annuityType: annuityType,
            purchaseAmount: annuity,
            age: clientAge,
            partnerAge: partnerAge,
            owner: owner,
            residualCapital: residualCapital,
            termYears: termYears,
            deferralYears: deferralYears,
            indexation: !!deployment.annuityIndexation,
            reversionary: !!deployment.annuityReversionary && !!partnerAge,
            incomeOverride: Number.isFinite(incomeOverride) ? incomeOverride : null
        });
        if (annuityRecord && !annuityRecord.warnings) {
            if (!data.assets.annuities) data.assets.annuities = [];
            const kind = annuityType === 'guaranteed' ? 'Guaranteed' : annuityType === 'lifetime' ? deferralYears > 0 ? 'Deferred lifetime' : 'Lifetime' : 'Fixed-term';
            data.assets.annuities.push((0, $f7f7b62814c3b615$export$5dc1cd0ab6cd8d79)(annuityRecord, {
                id: annuityRecord.id || `${idPrefix}-annuity`,
                description: `${kind} annuity (from proceeds)`,
                ownership: owner
            }));
            deployed += annuity;
        }
    }
    return deployed;
}
function $86923a7f40531161$export$56004bc8d68e8454(deployment) {
    if (!deployment) return [];
    const rows = [];
    const shares = $86923a7f40531161$var$num(deployment.shares);
    const ip = $86923a7f40531161$var$num(deployment.investmentProperty);
    const annuity = $86923a7f40531161$var$num(deployment.annuity);
    const superClient = $86923a7f40531161$var$num(deployment.superContribution);
    const superPartner = $86923a7f40531161$var$num(deployment.partnerSuperContribution);
    const bond = $86923a7f40531161$var$num(deployment.investmentBond);
    if (shares > 0) rows.push({
        label: 'Into shares / managed funds',
        amount: shares
    });
    if (ip > 0) rows.push({
        label: 'Into an investment property',
        amount: ip
    });
    if (ip > 0 && $86923a7f40531161$var$num(deployment.ipStampDuty) > 0) rows.push({
        label: 'Stamp duty on the investment property',
        amount: $86923a7f40531161$var$num(deployment.ipStampDuty)
    });
    if (superClient > 0) rows.push({
        label: `Into super (after-tax contribution${deployment.superCommenceIncomeStream ? ', as a pension' : ''})`,
        amount: superClient
    });
    if (superPartner > 0) rows.push({
        label: `Into partner's super (after-tax contribution${deployment.superCommenceIncomeStream ? ', as a pension' : ''})`,
        amount: superPartner
    });
    if (bond > 0) rows.push({
        label: 'Into an investment bond',
        amount: bond
    });
    if (annuity > 0) {
        const kind = deployment.annuityType === 'fixedTerm' ? `${$86923a7f40531161$var$num(deployment.annuityTermYears) ? `${$86923a7f40531161$var$num(deployment.annuityTermYears)}-year ` : ''}fixed-term` : deployment.annuityType === 'guaranteed' ? 'guaranteed (full amount to the estate)' : $86923a7f40531161$var$num(deployment.annuityDeferralYears) > 0 ? `deferred (${$86923a7f40531161$var$num(deployment.annuityDeferralYears)} years) lifetime` : 'lifetime';
        rows.push({
            label: `Into a ${kind} annuity`,
            amount: annuity
        });
    }
    return rows;
}






/**
 * Phase 2 slice 2 — entity-owned investment property sale proceeds → entity liquid pool.
 * Ported from frontend/src/utils/entityInvestmentPropertySale.js. Originally a MINIMAL subset
 * (`creditLiquidProceeds`, `removeSoldInvestmentProperty`, `routesIpProceedsToEntityPool` — all
 * `calculations/retirementVillageCalculations.ts` needed); `getSelectedInvestmentProperty`,
 * `sumInvestmentPropertyAllocations`, `creditInvestmentPropertyUnallocatedProceeds`, and
 * `applyInvestmentPropertySaleToFactFind` were added when `suggestionEngine/supportAtHome.ts`
 * (the server-side port of strategy/SupportAtHomeStrategyApplicator.js's
 * `applySellEntityInvestmentPropertyStrategy` → utils/supportAtHomeSuggestionEngineFunding.js's
 * `applySahEntityIpSaleToFactFind`) needed the whole-property-sale flow too.
 */ 



const $d63c59f9b8871996$export$1b362965f2838fdc = 'entity-ip-proceeds-';
function $d63c59f9b8871996$export$c11662d6bbf785af(factFind, asset) {
    if (!asset || !(0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(asset.ownership)) return false;
    const entityId = (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(asset.ownership);
    const structure = (factFind.structures || []).find((s)=>s.id === entityId);
    return structure?.type !== 'partnership';
}
function $d63c59f9b8871996$var$defaultBankIncomeRate(assets) {
    const list = assets?.bankAccounts;
    if (list && list.length > 0) return list[0]?.incomeRate || 2;
    return 2;
}
function $d63c59f9b8871996$export$32a0ff5e6949dfc(assets, amount, options) {
    const proceeds = Math.max(0, amount || 0);
    if (proceeds <= 0) return {
        credited: 0,
        bankId: null
    };
    const { ownership: ownership, id: id, description: description, mergeEntityId: mergeEntityId, incomeRate: incomeRate } = options;
    if (!assets.bankAccounts) assets.bankAccounts = [];
    if (mergeEntityId) {
        const entityOwn = (0, $1773fcf9595c5c0a$export$66d936c41d42a933)(mergeEntityId);
        const existing = assets.bankAccounts.find((a)=>a.ownership === entityOwn && !String(a.id || '').startsWith($d63c59f9b8871996$export$1b362965f2838fdc));
        if (existing) {
            existing.value = (existing.value || 0) + proceeds;
            return {
                credited: proceeds,
                bankId: existing.id != null ? String(existing.id) : null
            };
        }
    }
    const existingById = assets.bankAccounts.find((a)=>(0, $85f2560fc9a239a0$export$4d0dc62775eae74e)(a.id, id));
    if (existingById) {
        existingById.value = (existingById.value || 0) + proceeds;
        return {
            credited: proceeds,
            bankId: existingById.id != null ? String(existingById.id) : null
        };
    }
    assets.bankAccounts.push({
        id: id,
        type: 'bankAccounts',
        description: description,
        value: proceeds,
        ownership: ownership,
        incomeRate: incomeRate ?? $d63c59f9b8871996$var$defaultBankIncomeRate(assets),
        growthRate: 0
    });
    return {
        credited: proceeds,
        bankId: id
    };
}
function $d63c59f9b8871996$export$4728ec254314fafc(assets, propertyId) {
    if (!assets?.investmentProperty) return;
    assets.investmentProperty = assets.investmentProperty.filter((p)=>!(0, $85f2560fc9a239a0$export$4d0dc62775eae74e)(p.id, propertyId));
}
function $d63c59f9b8871996$export$cfdc34b008f59476(factFind, details) {
    if (!factFind?.assets?.investmentProperty?.length || !details) return null;
    const selectedPropertyId = details.selectedPropertyId;
    return factFind.assets.investmentProperty.find((p)=>(0, $85f2560fc9a239a0$export$4d0dc62775eae74e)(p.id, selectedPropertyId)) || factFind.assets.investmentProperty[0];
}
function $d63c59f9b8871996$export$ed6b4fd849b1a45e(details = {}) {
    return (details.radAllocation || 0) + (details.newHomePurchasePrice || 0) + (details.downsizerContribution || 0) + (details.partnerDownsizerContribution || 0) + (details.giftingAmount || 0) + (details.funeralBondPurchase || 0);
}
function $d63c59f9b8871996$export$9aa478282d1e3dc5(data, factFind, details) {
    const property = $d63c59f9b8871996$export$cfdc34b008f59476(factFind, details);
    const summary = (0, $a764bc0f6f904854$export$777cdddf3f231419)(factFind, details);
    const netProceeds = summary?.netProceeds ?? (details.salePrice || 0) - (details.sellingCosts || 0);
    const unallocated = netProceeds - $d63c59f9b8871996$export$ed6b4fd849b1a45e(details);
    if (unallocated <= 0) return {
        unallocated: 0,
        routedToEntity: false,
        entityId: null
    };
    const incomeRate = $d63c59f9b8871996$var$defaultBankIncomeRate(data.assets);
    const toEntity = property && $d63c59f9b8871996$export$c11662d6bbf785af(factFind, property);
    if (toEntity) {
        const entityId = (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(property.ownership);
        const structure = (factFind.structures || []).find((s)=>s.id === entityId);
        const name = structure?.name?.trim() || 'Trust or company';
        $d63c59f9b8871996$export$32a0ff5e6949dfc(data.assets, unallocated, {
            ownership: (0, $1773fcf9595c5c0a$export$66d936c41d42a933)(entityId),
            id: `${$d63c59f9b8871996$export$1b362965f2838fdc}${entityId}`,
            description: `Unallocated proceeds \u{2014} ${name} (from property sale)`,
            mergeEntityId: entityId,
            incomeRate: incomeRate
        });
        return {
            unallocated: unallocated,
            routedToEntity: true,
            entityId: entityId
        };
    }
    $d63c59f9b8871996$export$32a0ff5e6949dfc(data.assets, unallocated, {
        ownership: 'joint',
        id: 'investment-proceeds',
        description: 'Unallocated Investment Sale Proceeds',
        incomeRate: incomeRate
    });
    return {
        unallocated: unallocated,
        routedToEntity: false,
        entityId: null
    };
}
function $d63c59f9b8871996$export$968f08311f735e7a(data, factFind, details) {
    const property = $d63c59f9b8871996$export$cfdc34b008f59476(factFind, details);
    if (!property) return data;
    $d63c59f9b8871996$export$4728ec254314fafc(data.assets, property.id);
    if ((details.newHomePurchasePrice || 0) > 0) data.home.value = details.newHomePurchasePrice;
    if ((details.radAllocation || 0) > 0) {
        if (!data.assets.radPaid) data.assets.radPaid = [];
        data.assets.radPaid = [
            {
                id: 'rad-paid',
                type: 'radPaid',
                description: 'RAD Paid',
                value: details.radAllocation,
                ownership: 'client'
            }
        ];
    }
    $d63c59f9b8871996$export$9aa478282d1e3dc5(data, factFind, details);
    (0, $f1228be62b68f76b$export$a72a115b20fefbbf)(data.assets, factFind, details, {
        idPrefix: 'investment-downsizer-contrib',
        assetId: 'investment-downsizer-contrib',
        partnerAssetId: 'partner-investment-downsizer-contrib'
    });
    if ((details.funeralBondPurchase || 0) > 0) {
        if (!data.assets.funeralBonds) data.assets.funeralBonds = [];
        data.assets.funeralBonds.push({
            id: 'investment-fbond',
            type: 'funeralBonds',
            description: 'Funeral Bond from Proceeds',
            value: details.funeralBondPurchase,
            ownership: 'client'
        });
    }
    return data;
}



function $d6349ba6b2bbee8e$export$10a8d0dd9aa35e39(entryFee, yearsResidency, dmfPctPerYear, dmfCapYears = 12, dmfBasis = 'entry', resaleValue = 0) {
    const effectiveYears = Math.min(Math.max(0, yearsResidency), dmfCapYears || 99);
    const pctApplied = dmfPctPerYear / 100 * effectiveYears;
    const basisValue = dmfBasis === 'resale' && resaleValue > 0 ? resaleValue : entryFee;
    const dmfAmount = basisValue * Math.min(pctApplied, 1);
    return {
        dmfAmount: dmfAmount,
        dmfPctApplied: pctApplied * 100
    };
}
function $d6349ba6b2bbee8e$export$b0d4cd6d518ae318(entryFee, yearsResidency, growthRatePct, capitalGainShareToResident, dmfParams, reinstatementCost = 0) {
    const growthRate = (growthRatePct || 0) / 100;
    const resaleValue = entryFee * Math.pow(1 + growthRate, yearsResidency);
    const capitalGain = Math.max(0, resaleValue - entryFee);
    const residentShareOfGain = capitalGain * (capitalGainShareToResident ?? 0.5);
    const operatorShareOfGain = capitalGain - residentShareOfGain;
    const { dmfAmount: dmfAmount } = $d6349ba6b2bbee8e$export$10a8d0dd9aa35e39(entryFee, yearsResidency, dmfParams.dmfPctPerYear, dmfParams.dmfCapYears, dmfParams.dmfBasis || 'entry', resaleValue);
    const reinstatement = reinstatementCost || 0;
    const netToResident = entryFee + residentShareOfGain - dmfAmount - reinstatement;
    return {
        resaleValue: resaleValue,
        dmfAmount: dmfAmount,
        capitalGain: capitalGain,
        residentShareOfGain: residentShareOfGain,
        operatorShareOfGain: operatorShareOfGain,
        netToResident: netToResident
    };
}
function $d6349ba6b2bbee8e$export$15cb494f5ce70974(villageInputs) {
    const entryFee = villageInputs.entryFee || 0;
    const ongoing = villageInputs.ongoingWeeklyOrMonthly || 0;
    const freq = villageInputs.ongoingFrequency || 'monthly';
    const annualOngoing = freq === 'weekly' ? ongoing * 52 : ongoing * 12;
    const years = Math.max(0, villageInputs.yearsResidency || 0);
    const dmfParams = {
        dmfPctPerYear: villageInputs.dmfPctPerYear || 0,
        dmfCapYears: villageInputs.dmfCapYears || 0,
        dmfBasis: villageInputs.dmfBasis || 'entry'
    };
    const exit = $d6349ba6b2bbee8e$export$b0d4cd6d518ae318(entryFee, years, villageInputs.growthRatePct || 0, villageInputs.capitalGainShareToResident ?? 0.5, dmfParams, villageInputs.reinstatementCap || 0);
    return {
        entryFee: entryFee,
        annualOngoing: annualOngoing,
        yearsResidency: years,
        exitResaleValue: exit.resaleValue,
        exitDmf: exit.dmfAmount,
        exitNetToResident: exit.netToResident,
        ...exit
    };
}
function $d6349ba6b2bbee8e$export$7d88d20d32ff1227(baseFactFind, options = {}) {
    const data = structuredClone(baseFactFind);
    if (options.noPrincipalHome) {
        if (data.home) data.home.value = Number(options.homeValueForPension ?? 0);
    }
    return data;
}
// Downsizer contribution cap per person (ATO; update from Schedule). Same as used elsewhere in app.
const $d6349ba6b2bbee8e$export$42edd27decf8c272 = 300000;
function $d6349ba6b2bbee8e$export$2f966089c4f904da(factFind, propertyAsset, grossAmount) {
    const value = propertyAsset?.value || 0;
    const saleAmount = Math.min(Math.max(0, grossAmount || 0), value);
    if (saleAmount <= 0) return {
        netProceeds: 0,
        cgt: 0,
        sellingCosts: 0
    };
    if (propertyAsset && (0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(propertyAsset.ownership)) {
        const details = {
            selectedPropertyId: propertyAsset.id,
            salePrice: saleAmount,
            sellingCosts: saleAmount * 0.025,
            costBase: propertyAsset.costBase ?? ''
        };
        const summary = (0, $a764bc0f6f904854$export$777cdddf3f231419)(factFind, details);
        const netProceeds = summary?.netProceeds ?? 0;
        const cgt = summary?.effectiveCGT ?? summary?.estimatedCGT ?? 0;
        return {
            netProceeds: netProceeds,
            cgt: cgt,
            sellingCosts: saleAmount * 0.025
        };
    }
    return $d6349ba6b2bbee8e$export$8e7496bf07ef5a98(factFind, propertyAsset, saleAmount);
}
function $d6349ba6b2bbee8e$export$d5119f51b5211c8b(factFind, entryFeeFunding = {}, cgtOverrides = {}) {
    const liquidFunding = {};
    let ipNetTotal = 0;
    let ipCgtTotal = 0;
    Object.entries(entryFeeFunding || {}).forEach(([assetKey, amount])=>{
        const gross = amount || 0;
        if (gross <= 0) return;
        if (assetKey.startsWith('investmentProperty-')) {
            const idRaw = assetKey.replace(/^investmentProperty-/, '');
            const asset = factFind?.assets?.investmentProperty?.find((a)=>String(a.id) === String(idRaw));
            if (!asset) return;
            const { netProceeds: netProceeds, cgt: cgt } = $d6349ba6b2bbee8e$export$2f966089c4f904da(factFind, asset, gross);
            ipNetTotal += netProceeds;
            ipCgtTotal += cgt;
        } else liquidFunding[assetKey] = gross;
    });
    const { netTotal: liquidNet, shareCgtTotal: shareCgtTotal } = $d6349ba6b2bbee8e$var$resolveRvLiquidFundingNet(factFind, liquidFunding, cgtOverrides);
    return {
        netTotal: liquidNet + ipNetTotal,
        shareCgtTotal: shareCgtTotal,
        ipCgtTotal: ipCgtTotal,
        cgtTotal: shareCgtTotal + ipCgtTotal
    };
}
function $d6349ba6b2bbee8e$var$resolveRvLiquidFundingNet(factFind, liquidFunding, cgtOverrides) {
    let grossTotal = 0;
    let netTotal = 0;
    let shareCgtTotal = 0;
    Object.entries(liquidFunding || {}).forEach(([assetKey, amount])=>{
        const gross = Math.max(0, amount || 0);
        if (gross <= 0) return;
        grossTotal += gross;
        const entry = (0, $85f2560fc9a239a0$export$351785600ef65fdf)(factFind, assetKey, gross, cgtOverrides);
        netTotal += entry.net;
        shareCgtTotal += entry.cgt;
    });
    return {
        grossTotal: grossTotal,
        netTotal: netTotal,
        shareCgtTotal: shareCgtTotal
    };
}
/**
 * Draws `remaining` of the entry contribution from the liquid assets in the default order — bank,
 * term deposits, account-based pensions, shares — and returns what it managed to take. Mutates
 * `data.assets`. Stops when the money runs out: a village entry cannot be part-paid, and the
 * caller reports the shortfall rather than pretending (`entryFeePaid`).
 */ function $d6349ba6b2bbee8e$var$drawEntryFeeFromLiquidInOrder(data, remaining) {
    const assets = data.assets || {};
    let left = Math.max(0, remaining);
    let deducted = 0;
    if (left <= 0) return 0;
    [
        'bankAccounts',
        'termDeposits',
        'accountBasedPensions',
        'shares'
    ].forEach((type)=>{
        if (left <= 0 || !assets[type]) return;
        (assets[type] || []).forEach((asset)=>{
            if (left <= 0) return;
            const val = asset.value || 0;
            const deduct = Math.min(val, left);
            if (deduct > 0) {
                asset.value = Math.max(0, val - deduct);
                left -= deduct;
                deducted += deduct;
                if (type === 'accountBasedPensions') (0, $e0f54937e270d5ff$export$399e556d15149d82)(asset, data, 1);
            }
        });
    });
    return deducted;
}
/**
 * THE REST COMES FROM SAVINGS (owner-caught, 24 Sep 2026). A property route paid what its sale
 * netted and stopped: an $800,000 entry contribution on $651,966 of net proceeds booked the full
 * $800,000 as paid — the exit entitlement struck on money that never went in — while the screen said
 * "paid in full from selling the investment property". A village contribution has no pay-part-of-it
 * option, so whatever the sale does not cover comes from savings: the adviser's own allocation first
 * (`entryFeeFunding`, capped at the remainder), then the default draw order, and whatever is still
 * short is genuinely unpaid and is reported as such through `entryFeePaid`.
 */ function $d6349ba6b2bbee8e$var$topUpEntryFeeFromLiquid(data, baseFactFind, rvStrategy, remaining) {
    if (!(remaining > 0)) return {
        deducted: 0,
        entryFeeCgtFromIp: 0
    };
    const { totalTowardEntry: totalTowardEntry, entryFeeCgtFromIp: entryFeeCgtFromIp } = $d6349ba6b2bbee8e$export$aa654608458669c7(data, baseFactFind, rvStrategy?.entryFeeFunding || {}, rvStrategy?.entryFeeCgtOverrides || {}, remaining);
    const deducted = totalTowardEntry + $d6349ba6b2bbee8e$var$drawEntryFeeFromLiquidInOrder(data, remaining - totalTowardEntry);
    return {
        deducted: deducted,
        entryFeeCgtFromIp: entryFeeCgtFromIp
    };
}
function $d6349ba6b2bbee8e$export$aa654608458669c7(data, baselineFactFind, entryFeeFunding, cgtOverrides = {}, entryFeeCap = Infinity) {
    let totalTowardEntry = 0;
    let entryFeeCgtFromIp = 0;
    let entryRemaining = entryFeeCap != null && Number.isFinite(entryFeeCap) ? Math.max(0, entryFeeCap || 0) : Infinity;
    Object.entries(entryFeeFunding || {}).forEach(([assetId, amount])=>{
        const gross = amount || 0;
        if (gross <= 0) return;
        const parts = assetId.split('-');
        const type = parts[0];
        const idRaw = parts.length > 1 ? Number.isNaN(Number(parts[1])) ? parts.slice(1).join('-') : parts[1] : null;
        if (!data.assets?.[type] || idRaw == null) return;
        const idx = data.assets[type].findIndex((a)=>String(a.id) === String(idRaw));
        if (idx === -1) return;
        const asset = data.assets[type][idx];
        const val = asset.value || 0;
        const deduct = Math.min(gross, val);
        if (deduct <= 0) return;
        if (type === 'investmentProperty') {
            const { netProceeds: netProceeds, cgt: cgt } = $d6349ba6b2bbee8e$export$2f966089c4f904da(baselineFactFind, asset, deduct);
            const isFullSale = deduct >= val;
            if (isFullSale) (0, $d63c59f9b8871996$export$4728ec254314fafc)(data.assets, asset.id);
            else asset.value = Math.max(0, val - deduct);
            const towardEntry = Math.min(netProceeds, entryRemaining);
            totalTowardEntry += towardEntry;
            entryRemaining -= towardEntry;
            entryFeeCgtFromIp += cgt;
            if (isFullSale && (0, $d63c59f9b8871996$export$c11662d6bbf785af)(baselineFactFind, asset)) {
                const entityId = (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(asset.ownership);
                const structure = (baselineFactFind.structures || []).find((s)=>s.id === entityId);
                const name = structure?.name?.trim() || 'Trust or company';
                const residual = Math.max(0, netProceeds - towardEntry);
                if (residual > 0) (0, $d63c59f9b8871996$export$32a0ff5e6949dfc)(data.assets, residual, {
                    ownership: (0, $1773fcf9595c5c0a$export$66d936c41d42a933)(entityId),
                    id: `rv-entry-ip-residual-${entityId}`,
                    description: `Residual from investment property sale \u{2014} ${name} (after village entry)`,
                    mergeEntityId: entityId
                });
            } else if (isFullSale) {
                asset.rent = 0;
                if (asset.expenses != null) asset.expenses = 0;
            }
        } else if (type === 'shares') {
            const { gross: shareGross, net: net, cgt: cgt } = (0, $85f2560fc9a239a0$export$351785600ef65fdf)(baselineFactFind, assetId, deduct, cgtOverrides);
            const towardEntry = Math.min(net, entryRemaining);
            asset.value = Math.max(0, val - shareGross);
            totalTowardEntry += towardEntry;
            entryRemaining -= towardEntry;
            (0, $85f2560fc9a239a0$export$ade9707014c4664e)(data.assets, cgt, asset.ownership);
        } else {
            const towardEntry = Math.min(deduct, entryRemaining);
            asset.value = Math.max(0, val - deduct);
            totalTowardEntry += towardEntry;
            entryRemaining -= towardEntry;
            if (type === 'accountBasedPensions' && deduct > 0) (0, $e0f54937e270d5ff$export$399e556d15149d82)(asset, data, 1);
        }
    });
    return {
        totalTowardEntry: totalTowardEntry,
        entryFeeCgtFromIp: entryFeeCgtFromIp
    };
}
function $d6349ba6b2bbee8e$export$8e7496bf07ef5a98(factFind, propertyAsset, amountToSell, options = {}) {
    const value = propertyAsset?.value || 0;
    if (value <= 0 || amountToSell <= 0) return {
        netProceeds: 0,
        cgt: 0,
        sellingCosts: 0
    };
    const amount = Math.min(amountToSell, value);
    const sellingCosts = amount * 0.025;
    const result = (0, $1fbcfc2df3ed29e9$export$c06c916a0ca433d3)({
        taxContext: (0, $77244093e528572f$export$ccd3cb45b428c7dc)(factFind, options.financials),
        asset: propertyAsset,
        salePrice: amount,
        sellingCosts: sellingCosts,
        originalAssetValue: value,
        disposalDate: options.disposalDate,
        cpiRate: options.cpiRate,
        structures: factFind?.structures
    });
    return {
        netProceeds: Math.max(0, result.netProceeds),
        cgt: result.estimatedCGT,
        sellingCosts: sellingCosts
    };
}
function $d6349ba6b2bbee8e$var$deductFromAssetList(data, sourceIdentifier, amount) {
    if (!amount || amount <= 0) return;
    let sourceType;
    let targetAssetId;
    if (sourceIdentifier.includes('-')) {
        const parts = sourceIdentifier.split('-');
        sourceType = parts[0];
        targetAssetId = parts.slice(1).join('-');
    } else {
        sourceType = sourceIdentifier;
        targetAssetId = null;
    }
    if (sourceType === 'bank') sourceType = 'bankAccounts';
    if (!data.assets?.[sourceType]?.length) return;
    let remaining = amount;
    const list = data.assets[sourceType];
    const applyDeduction = (asset, index)=>{
        if (remaining <= 0) return;
        const currentValue = asset.value || asset.balance || 0;
        const deduction = Math.min(remaining, currentValue);
        if (deduction <= 0) return;
        if (asset.balance !== undefined) asset.balance = Math.max(0, currentValue - deduction);
        else asset.value = Math.max(0, currentValue - deduction);
        remaining -= deduction;
        if (sourceType === 'accountBasedPensions') (0, $e0f54937e270d5ff$export$399e556d15149d82)(asset, data, 1);
        const newValue = asset.value || asset.balance || 0;
        if (newValue <= 0) list.splice(index, 1);
    };
    if (targetAssetId) {
        const idx = list.findIndex((a)=>String(a.id) === String(targetAssetId));
        if (idx >= 0) applyDeduction(list[idx], idx);
    } else for(let i = 0; i < list.length && remaining > 0; i++)applyDeduction(list[i], i);
}
/**
 * Record a gift as DEPRIVATION, not merely as money that left the balance sheet.
 *
 * THE BUG THIS FIXES (found 2026-08-27). Both village gifting paths — the "Other Strategies" gift
 * from liquid assets, and the gift allocated out of home-sale proceeds — deducted the money from the
 * client's assets and stopped there. Nothing was ever written to `giftsHistory`, so the five-year
 * deprivation rules never fired: the module reported a client gifting $200,000 as immediately
 * $200,000 poorer for means-test purposes, and showed them an Age Pension rise Centrelink would not
 * pay for five years.
 *
 * It flatters the strategy, which is the dangerous direction — a plan built on it would have the
 * family give away money on the strength of a benefit that does not arrive.
 *
 * The aged care, Support at Home and downsize paths have always recorded the gift. This is the same
 * rule, in the same shape: the financial year the gift is MADE in, because that is when the clock
 * starts. `assessableMeans` then applies the free-area and five-year rules to it exactly as it does
 * for a gift made anywhere else — nothing about the assessment itself needed changing.
 */ function $d6349ba6b2bbee8e$var$recordRvGiftAsDeprivation(data, amount, asOfDate) {
    const giftAmount = Math.max(0, Number(amount) || 0);
    if (giftAmount <= 0) return;
    const when = asOfDate ? new Date(asOfDate) : new Date();
    // Dated, so the five years run from the day it is given (24 Oct 2026).
    (0, $171a6d8ba8937a5f$export$653e7b96a80afaf8)(data, giftAmount, Number.isNaN(when.getTime()) ? new Date() : when);
}
function $d6349ba6b2bbee8e$export$1a171c82f0c12495(data, otherStrategies, annuityRecord, baseFactFind) {
    const result = structuredClone(data);
    if (!otherStrategies) return result;
    if (otherStrategies.annuity && annuityRecord?.purchaseAmount > 0) try {
        const mapped = {
            ...annuityRecord
        };
        if (!mapped.age && baseFactFind?.client?.dob) mapped.age = (0, $876c355975468a36$export$8ada184d5eef4694)(baseFactFind.client.dob);
        if ((mapped.owner === 'joint' || mapped.reversionary) && !mapped.partnerAge && baseFactFind?.partner?.dob) mapped.partnerAge = (0, $876c355975468a36$export$8ada184d5eef4694)(baseFactFind.partner.dob);
        if (mapped.fundingSource?.id?.includes('-')) {
            const parts = mapped.fundingSource.id.split('-');
            const assetType = parts[0];
            if (assetType === 'bankAccounts') mapped.fundingSource = {
                ...mapped.fundingSource,
                type: 'bank'
            };
            else if (assetType === 'accountBasedPensions') mapped.fundingSource = {
                ...mapped.fundingSource,
                type: 'abp'
            };
            else mapped.fundingSource = {
                ...mapped.fundingSource,
                type: assetType
            };
        }
        const built = (0, $f7f7b62814c3b615$export$fb67395f10ad20c9)(result, mapped);
        if (built && !built.warnings) {
            if (built.fundingSource?.id?.includes('-')) {
                const parts = built.fundingSource.id.split('-');
                const assetType = parts[0];
                built.fundingSourceId = parts.slice(1).join('-');
                if (assetType === 'bankAccounts') built.fundingSourceType = 'bank';
                else if (assetType === 'accountBasedPensions') built.fundingSourceType = 'abp';
                else built.fundingSourceType = assetType;
            }
            (0, $f7f7b62814c3b615$export$3e335727e573fe15)(result, built);
        }
    } catch (e) {
        console.error('RV other strategies: annuity apply failed', e);
    }
    if (otherStrategies.gifting && otherStrategies.giftingAmount > 0) {
        $d6349ba6b2bbee8e$var$deductFromAssetList(result, otherStrategies.giftingSource || 'bankAccounts', otherStrategies.giftingAmount || 0);
        // The money leaving the balance sheet is only half of it — see recordRvGiftAsDeprivation.
        $d6349ba6b2bbee8e$var$recordRvGiftAsDeprivation(result, otherStrategies.giftingAmount || 0, otherStrategies.giftDate);
    }
    if (otherStrategies.funeralBonds && otherStrategies.funeralBondAmount > 0) {
        const funeralBondAmount = otherStrategies.funeralBondAmount || 0;
        $d6349ba6b2bbee8e$var$deductFromAssetList(result, otherStrategies.funeralBondSource || 'bankAccounts', funeralBondAmount);
        if (!result.assets.funeralBonds) result.assets.funeralBonds = [];
        result.assets.funeralBonds.push({
            id: 'rv-other-strategy-funeral-bond',
            type: 'funeralBonds',
            description: 'Funeral bond (other strategies)',
            value: funeralBondAmount,
            ownership: 'client'
        });
    }
    return result;
}
/*
 * KEEPING THE HOME, PUTTING SAVINGS TO WORK (village rebuild, 21 Oct 2026). With the home kept, a plan built
 * by hand can still buy a guaranteed income or an investment property, or invest, from savings — not only
 * from a sale. `savingsDeployment` says what (the shared ResidualDeployment shape) and
 * `savingsDeploymentFunding` which accounts pay (worked out on the page in the usual order, keeping the
 * emergency money back). The accounts are drawn after the entry payment, net of any tax on a sale of
 * shares; if they raise less than asked, the investing shrinks first. An optional loan on the property is
 * booked as a mortgage linked to it, as on the sale route.
 */ function $d6349ba6b2bbee8e$var$applyRvSavingsDeployment(data, baseFactFind, rvStrategy) {
    const dep = rvStrategy?.savingsDeployment;
    const want = (0, $86923a7f40531161$export$90c44e1a4433ba8a)(dep);
    if (!dep || !(want > 0)) return;
    const loan = Math.min(Math.max(0, Number(dep.investmentProperty) || 0), Math.max(0, Number(rvStrategy?.savingsIpLoan?.amount) || 0));
    const cash = want - loan;
    const { totalTowardEntry: raised } = $d6349ba6b2bbee8e$export$aa654608458669c7(data, baseFactFind, rvStrategy?.savingsDeploymentFunding || {}, {}, cash);
    const short = Math.max(0, cash - raised);
    const deployed = short > 0.5 ? {
        ...dep,
        shares: Math.max(0, (Number(dep.shares) || 0) - short)
    } : dep;
    (0, $86923a7f40531161$export$efee12160933bebf)(data, deployed, {
        factFind: baseFactFind,
        idPrefix: 'rv-savings'
    });
    if (loan > 0) {
        if (!data.liabilities) data.liabilities = {};
        if (!data.liabilities.mortgages) data.liabilities.mortgages = [];
        data.liabilities.mortgages.push({
            id: 'rv-savings-ip-loan',
            type: 'mortgages',
            description: 'Loan on the investment property',
            balance: loan,
            interestRate: Number(rvStrategy.savingsIpLoan.rate) > 0 ? Number(rvStrategy.savingsIpLoan.rate) : 6.5,
            loanTerm: Number(rvStrategy.savingsIpLoan.termYears) > 0 ? Number(rvStrategy.savingsIpLoan.termYears) : 25,
            loanType: 'pi',
            repaymentCalculation: 'auto',
            frequency: 'monthly',
            assetLink: 'rv-savings-inv-prop',
            ownership: dep.ipOwnership || (baseFactFind?.adviceFor === 'couple' ? 'joint' : 'client')
        });
    }
}
function $d6349ba6b2bbee8e$var$finalizeRvStrategyFactFind(result, baseFactFind, rvStrategy) {
    const os = rvStrategy?.otherStrategies;
    if (!os || !os.gifting && !os.funeralBonds && !os.annuity) return result;
    result.factFind = $d6349ba6b2bbee8e$export$1a171c82f0c12495(result.factFind, os, os.annuity ? rvStrategy.annuityRecord : null, baseFactFind);
    return result;
}
function $d6349ba6b2bbee8e$export$be9042bee889487b(rvStrategy, villageInputs, movedFactFind) {
    const options = {};
    const fundFrom = rvStrategy?.fundFrom || 'liquid';
    const rentDetails = rvStrategy?.rentDetails;
    if ((fundFrom === 'rent_home' || rvStrategy?.rentHome) && rentDetails) {
        options.rentHome = true;
        options.rentAmount = rentDetails.rentAmount || 0;
        options.rentExpenses = rentDetails.rentExpenses || 0;
        if (rentDetails.partnerRent) options.partnerRent = rentDetails.partnerRent;
    }
    const entryFee = villageInputs?.entryFee || 0;
    if (entryFee > 0 && (fundFrom === 'liquid' || fundFrom === 'rent_home' || rvStrategy?.rentHome) && (parseFloat(String(movedFactFind?.home?.value)) || 0) > 0) options.formerPrincipalHomeAssessable = true;
    return options;
}
function $d6349ba6b2bbee8e$export$51ca4b84e58af4b9(factFind, rvStrategy, villageInputs) {
    const result = $d6349ba6b2bbee8e$var$buildSimulatedFactFindForVillageStrategyInner(factFind, rvStrategy, villageInputs);
    const entryFee = villageInputs?.entryFee || 0;
    if (entryFee > 0 && result?.factFind) {
        if (!result.factFind.client) result.factFind.client = {};
        result.factFind.client.currentResidency = 'retirement_village';
        if (result.factFind.adviceFor === 'couple') {
            if (!result.factFind.partner) result.factFind.partner = {};
            result.factFind.partner.currentResidency = 'retirement_village';
        }
        // The NEW unit's record, and only that: a client moving from another village (8 Oct 2026)
        // must not carry the old unit's fees or exit terms onto the new one — the old unit is paid
        // out by the projection (villageExitPlugin) from the ORIGINAL record.
        result.factFind.retirementVillage = {
            entryContribution: entryFee
        };
        // Rent Assistance: a non-homeowner village resident (EC ≤ EAA) gets RA on their ongoing (recurrent)
        // service charges — NOT the entry contribution (DSS Guide 4.6.4.30). Supply the weekly ongoing fee on
        // factFind.rent so the shared CRA logic can pay it. Homeowner residents (EC > EAA) get no RA.
        if (entryFee <= (0, $1abe73eeef086faf$export$e2cf792e99a08354)) {
            const weeklyOngoing = ($d6349ba6b2bbee8e$export$15cb494f5ce70974(villageInputs).annualOngoing || 0) / 52;
            if (weeklyOngoing > 0) result.factFind.rent = {
                ...result.factFind.rent || {},
                rentAmount: weeklyOngoing,
                landlordType: 'retirement_village',
                sharedAccommodation: result.factFind.rent?.sharedAccommodation ?? false
            };
        }
    }
    return result;
}
function $d6349ba6b2bbee8e$var$buildSimulatedFactFindForVillageStrategyInner(factFind, rvStrategy, villageInputs) {
    const fundFrom = rvStrategy?.fundFrom || 'liquid';
    const entryFee = villageInputs?.entryFee || 0;
    // Moving from another village with the payout taken as paid at the move (8 Oct 2026): the
    // old unit's money is in the bank before anything is drawn for the new contribution.
    if (villageInputs?.oldUnitPaysAtMove && (0, $4633117ee929ec27$export$cb26bf32ff9b2b4d)(factFind)) factFind = (0, $4633117ee929ec27$export$1a564c73622db812)(factFind);
    if (fundFrom === 'rent_home') return $d6349ba6b2bbee8e$var$finalizeRvStrategyFactFind({
        factFind: structuredClone(factFind),
        entryAlreadyPaidFromSale: false,
        entryFeeCgtFromIp: 0
    }, factFind, rvStrategy);
    if (fundFrom === 'investment_property' && rvStrategy?.investmentPropertyDetails && (factFind?.assets?.investmentProperty?.length ?? 0) > 0) {
        const ipDetails = rvStrategy.investmentPropertyDetails;
        const data = structuredClone(factFind);
        if (!data.assets) data.assets = {};
        // Guaranteed non-empty by the investmentProperty.length check above (factFind.assets and
        // data.assets have the same shape — data is a structuredClone of factFind).
        const investmentProperty = data.assets.investmentProperty;
        const selectedId = ipDetails.selectedPropertyId ?? investmentProperty[0]?.id;
        const ipAsset = investmentProperty.find((p)=>String(p.id) === String(selectedId)) || investmentProperty[0];
        if (!ipAsset) return $d6349ba6b2bbee8e$var$finalizeRvStrategyFactFind({
            factFind: data,
            entryAlreadyPaidFromSale: false,
            entryFeeCgtFromIp: 0
        }, factFind, rvStrategy);
        const fullValue = ipAsset.value || 0;
        const { netProceeds: netProceeds, cgt: cgt } = $d6349ba6b2bbee8e$export$8e7496bf07ef5a98(factFind, ipAsset, fullValue);
        const entryFeeFromIp = Math.min(entryFee, Math.max(0, ipDetails.entryFeeAllocation || 0), netProceeds);
        const downsizer = Math.min($d6349ba6b2bbee8e$export$42edd27decf8c272, Math.max(0, ipDetails.downsizerContribution || 0));
        const partnerDownsizer = Math.min($d6349ba6b2bbee8e$export$42edd27decf8c272, Math.max(0, ipDetails.partnerDownsizerContribution || 0));
        const giftingAmount = Math.max(0, ipDetails.giftingAmount || 0);
        const funeralBondPurchase = Math.max(0, ipDetails.funeralBondPurchase || 0);
        const totalAllocated = entryFeeFromIp + downsizer + partnerDownsizer + giftingAmount + funeralBondPurchase;
        const residual = Math.max(0, netProceeds - totalAllocated);
        (0, $d63c59f9b8871996$export$4728ec254314fafc)(data.assets, ipAsset.id);
        if (!data.assets.bankAccounts) data.assets.bankAccounts = [];
        if (residual > 0) {
            if ((0, $d63c59f9b8871996$export$c11662d6bbf785af)(factFind, ipAsset)) {
                const entityId = (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(ipAsset.ownership);
                const structure = (factFind.structures || []).find((s)=>s.id === entityId);
                const name = structure?.name?.trim() || 'Trust or company';
                (0, $d63c59f9b8871996$export$32a0ff5e6949dfc)(data.assets, residual, {
                    ownership: (0, $1773fcf9595c5c0a$export$66d936c41d42a933)(entityId),
                    id: `rv-ip-residual-${entityId}`,
                    description: `Residual from investment property sale \u{2014} ${name} (after village entry)`,
                    mergeEntityId: entityId
                });
            } else {
                const existingResidual = data.assets.bankAccounts.find((a)=>a.id === 'rv-ip-residual');
                if (existingResidual) {
                    existingResidual.value = residual;
                    existingResidual.ownership = ipAsset.ownership || 'joint';
                } else data.assets.bankAccounts.push({
                    id: 'rv-ip-residual',
                    type: 'bankAccounts',
                    description: 'Residual from investment property sale (after village entry)',
                    value: residual,
                    /* interest, not capital growth — see bankPlugin.ts */ incomeRate: 2,
                    growthRate: 0,
                    ownership: ipAsset.ownership || 'joint'
                });
            }
        } else {
            const existingResidual = data.assets.bankAccounts.find((a)=>a.id === 'rv-ip-residual');
            if (existingResidual) existingResidual.value = 0;
        }
        (0, $f1228be62b68f76b$export$a72a115b20fefbbf)(data.assets, factFind, {
            downsizerContribution: downsizer,
            partnerDownsizerContribution: partnerDownsizer,
            commenceIncomeStream: ipDetails.commenceIncomeStream === true
        }, {
            idPrefix: 'rv-ip-downsizer',
            assetId: 'rv-ip-downsizer-client',
            partnerAssetId: 'rv-ip-downsizer-partner'
        });
        if (funeralBondPurchase > 0) {
            if (!data.assets.funeralBonds) data.assets.funeralBonds = [];
            data.assets.funeralBonds.push({
                id: 'rv-ip-funeral-bond',
                type: 'funeralBonds',
                description: 'Funeral bond (from IP sale)',
                value: funeralBondPurchase,
                ownership: 'client'
            });
        }
        // What the sale did not cover comes from savings — see topUpEntryFeeFromLiquid.
        const topUp = $d6349ba6b2bbee8e$var$topUpEntryFeeFromLiquid(data, factFind, rvStrategy, entryFee - entryFeeFromIp);
        const entryFeePaid = entryFeeFromIp + topUp.deducted;
        return $d6349ba6b2bbee8e$var$finalizeRvStrategyFactFind({
            factFind: data,
            entryAlreadyPaidFromSale: entryFeePaid > 0,
            entryFeePaid: entryFeePaid,
            entryFeeCgtFromIp: cgt + topUp.entryFeeCgtFromIp
        }, factFind, rvStrategy);
    }
    if (fundFrom === 'liquid') {
        const entryFeeFunding = rvStrategy?.entryFeeFunding || {};
        const cgtOverrides = rvStrategy?.entryFeeCgtOverrides || {};
        const data = structuredClone(factFind);
        if (!data.assets) data.assets = {};
        const assets = data.assets;
        const { totalTowardEntry: totalTowardEntry, entryFeeCgtFromIp: entryFeeCgtFromIp } = $d6349ba6b2bbee8e$export$aa654608458669c7(data, factFind, entryFeeFunding, cgtOverrides, entryFee);
        const totalDeducted = totalTowardEntry + $d6349ba6b2bbee8e$var$drawEntryFeeFromLiquidInOrder(data, entryFee - totalTowardEntry);
        $d6349ba6b2bbee8e$var$applyRvSavingsDeployment(data, factFind, rvStrategy);
        // `entryFeePaid` is what the balance sheet could ACTUALLY raise, which is not always the
        // contracted price: the loop above takes what is there and stops. Reported so the engine can
        // strike the exit entitlement on money genuinely paid — a village entry cannot be part-paid,
        // and an underfunded one must never book a refund it did not buy (owner-caught, 2026-08-26).
        return $d6349ba6b2bbee8e$var$finalizeRvStrategyFactFind({
            factFind: data,
            entryAlreadyPaidFromSale: totalDeducted > 0,
            entryFeePaid: totalDeducted,
            entryFeeCgtFromIp: entryFeeCgtFromIp
        }, factFind, rvStrategy);
    }
    if (fundFrom !== 'sell_home' || !rvStrategy.sellHomeDetails) return $d6349ba6b2bbee8e$var$finalizeRvStrategyFactFind({
        factFind: structuredClone(factFind),
        entryAlreadyPaidFromSale: false,
        entryFeeCgtFromIp: 0
    }, factFind, rvStrategy);
    const details = rvStrategy.sellHomeDetails;
    const salePrice = details.salePrice || factFind.home?.value || 0;
    const sellingCosts = details.sellingCosts || salePrice * 0.025;
    const netProceeds = Math.max(0, salePrice - sellingCosts);
    const entryFeeAllocation = Math.min(entryFee, netProceeds);
    const downsizer = Math.min($d6349ba6b2bbee8e$export$42edd27decf8c272, Math.max(0, details.downsizerContribution || 0));
    const partnerDownsizer = Math.min($d6349ba6b2bbee8e$export$42edd27decf8c272, Math.max(0, details.partnerDownsizerContribution || 0));
    const giftingAmount = Math.max(0, details.giftingAmount || 0);
    const funeralBondPurchase = Math.max(0, details.funeralBondPurchase || 0);
    const purchaseAnnuity = Math.max(0, details.purchaseAnnuity || 0);
    const purchaseInvestmentProperty = Math.max(0, details.purchaseInvestmentProperty || 0);
    /*
     * STAMP DUTY ON THE PROPERTY BOUGHT (owner, 24 Sep 2026). The duty is money that leaves the
     * sale proceeds with the price and never comes back as an asset: it is paid to the state, and
     * for capital gains tax it is an incidental cost of acquisition, so it sits in the cost base
     * (ITAA 1997 s 110-35). Where no state was chosen the duty is nil and the screen says the duty
     * is not modelled — no state, no guess.
     */ const investmentPropertyStampDuty = purchaseInvestmentProperty > 0 ? Math.max(0, parseFloat(String(details.investmentPropertyStampDuty ?? '')) || 0) : 0;
    const purchaseShares = Math.max(0, details.purchaseShares || 0);
    /*
     * BORROWING FOR THE PROPERTY, ONLY WHEN SWITCHED ON (village review decision 8, 21 Oct 2026). No tested
     * plan borrows; in "Build a plan yourself" an adviser with finance confirmed can enter a loan. The loan
     * pays part of the price, so less comes out of the sale; it is booked as a mortgage linked to the
     * property, which the engine repays (principal and interest over the term) and whose interest is
     * deducted against the rent.
     */ const ipLoan = purchaseInvestmentProperty > 0 ? Math.min(purchaseInvestmentProperty, Math.max(0, Number(details.ipLoanAmount) || 0)) : 0;
    const totalAllocated = entryFeeAllocation + downsizer + partnerDownsizer + giftingAmount + funeralBondPurchase + purchaseAnnuity + purchaseInvestmentProperty + investmentPropertyStampDuty - ipLoan + purchaseShares;
    const residual = Math.max(0, netProceeds - totalAllocated);
    const data = structuredClone(factFind);
    data.home = data.home || {};
    data.home.value = 0;
    // Existing bank/ABP/shares etc. are left unchanged. Only add one residual-from-sale entry to bank (no double-count).
    if (!data.assets) data.assets = {};
    if (!data.assets.bankAccounts) data.assets.bankAccounts = [];
    const existingResidual = data.assets.bankAccounts.find((a)=>a.id === 'rv-sell-residual');
    if (residual > 0 && !existingResidual) data.assets.bankAccounts.push({
        id: 'rv-sell-residual',
        type: 'bankAccounts',
        description: 'Residual from home sale (after village entry)',
        value: residual,
        /* interest, not capital growth — see bankPlugin.ts */ incomeRate: 2,
        growthRate: 0,
        ownership: 'joint'
    });
    else if (existingResidual && residual > 0) existingResidual.value = residual;
    /*
     * WHOSE NAME EACH THING IS BOUGHT IN (village rebuild, owner 21 Oct 2026). For a couple, an investment
     * property and the money invested from the sale were booked in the client's name alone, so every
     * dollar of rent and every dividend was taxed as theirs; and an annuity was booked as the client's
     * whoever it was bought for. Now: the property in the name chosen (both, for a couple, unless set),
     * the invested money jointly for a couple, the annuity in its owner's name.
     */ const isCoupleSale = factFind?.adviceFor === 'couple';
    const coupleOwner = (o)=>o === 'client' || o === 'partner' || o === 'joint' ? o : isCoupleSale ? 'joint' : 'client';
    (0, $f1228be62b68f76b$export$a72a115b20fefbbf)(data.assets, factFind, {
        downsizerContribution: downsizer,
        partnerDownsizerContribution: partnerDownsizer,
        commenceIncomeStream: details.commenceIncomeStream === true,
        // A chosen yearly draw from each new pension, never below the minimum (owner, 21 Oct 2026).
        clientDrawAmount: Number(details.downsizerDrawClient) || 0,
        partnerDrawAmount: Number(details.downsizerDrawPartner) || 0
    }, {
        idPrefix: 'rv-downsizer',
        assetId: 'rv-downsizer-client',
        partnerAssetId: 'rv-downsizer-partner'
    });
    // The gift is allocated out of the sale proceeds above (it reduces `residual`), so the money has
    // already left. What was missing is the deprivation record — see recordRvGiftAsDeprivation.
    $d6349ba6b2bbee8e$var$recordRvGiftAsDeprivation(data, giftingAmount, rvStrategy?.villageEntryDate || details.saleDate);
    if (funeralBondPurchase > 0) {
        if (!data.assets.funeralBonds) data.assets.funeralBonds = [];
        data.assets.funeralBonds.push({
            id: 'rv-funeral-bond',
            type: 'funeralBonds',
            description: 'Funeral bond (from home sale)',
            value: funeralBondPurchase,
            ownership: 'client'
        });
    }
    if (purchaseInvestmentProperty > 0) {
        if (!data.assets.investmentProperty) data.assets.investmentProperty = [];
        data.assets.investmentProperty.push({
            id: 'rv-sell-inv-prop',
            type: 'investmentProperty',
            description: 'Investment property (from home sale)',
            value: purchaseInvestmentProperty,
            ownership: coupleOwner(details.investmentPropertyOwner),
            rent: details.investmentPropertyRent || 0,
            expenses: details.investmentPropertyExpenses || 0,
            growthRate: (0, $0f2c0a6799fe36da$export$b037eefb915b86ec).propertyGrowthPct,
            costBase: purchaseInvestmentProperty + investmentPropertyStampDuty,
            acquisitionDate: 'post'
        });
        if (ipLoan > 0) {
            if (!data.liabilities) data.liabilities = {};
            if (!data.liabilities.mortgages) data.liabilities.mortgages = [];
            data.liabilities.mortgages.push({
                id: 'rv-ip-loan',
                type: 'mortgages',
                description: 'Loan on the investment property',
                balance: ipLoan,
                interestRate: Number(details.ipLoanRate) > 0 ? Number(details.ipLoanRate) : 6.5,
                loanTerm: Number(details.ipLoanTermYears) > 0 ? Number(details.ipLoanTermYears) : 25,
                loanType: 'pi',
                repaymentCalculation: 'auto',
                frequency: 'monthly',
                assetLink: 'rv-sell-inv-prop',
                ownership: coupleOwner(details.investmentPropertyOwner)
            });
        }
    }
    if (purchaseShares > 0) {
        if (!data.assets.shares) data.assets.shares = [];
        // Priced at the client's new-money profile (Conservative until they answer) — the same
        // portfolio, in personal names, as the strategy's super/pension legs assume in theirs.
        const split = (0, $0f2c0a6799fe36da$export$2916b5515a75a453)((0, $0f2c0a6799fe36da$export$580cfd0c6323bf7e)(factFind));
        data.assets.shares.push({
            id: 'rv-sell-shares',
            type: 'shares',
            description: 'Shares (from home sale)',
            value: purchaseShares,
            ownership: isCoupleSale ? 'joint' : 'client',
            incomeRate: split.incomeRatePct,
            growthRate: split.growthRatePct,
            costBase: purchaseShares,
            frankingCredit: split.frankingPct,
            reinvest: false
        });
    }
    if (purchaseAnnuity > 0) {
        const clientAge = factFind?.client?.dob ? (0, $876c355975468a36$export$8ada184d5eef4694)(factFind.client.dob) : 65;
        const partnerAge = factFind?.adviceFor === 'couple' && factFind?.partner?.dob ? (0, $876c355975468a36$export$8ada184d5eef4694)(factFind.partner.dob) : null;
        // Allow the RV sell-home allocator to control how the annuity is structured, using
        // the same annuity engine as Aged Care / Support at Home.
        const rawType = details.rvAnnuityType || 'lifetime';
        const annuityType = rawType === 'fixedTerm' ? 'fixedTerm' : 'lifetime';
        const residualPercent = details.rvAnnuityResidualPercent || 0;
        const residualCapital = Math.min(Math.max(residualPercent / 100, 0), 1);
        const termYears = annuityType === 'fixedTerm' ? details.rvAnnuityTermYears || null : null;
        const indexation = !!details.rvAnnuityIndexation;
        const reversionary = !!details.rvAnnuityReversionary && !!partnerAge;
        const incomeOverride = details.rvAnnuityIncomeOverride != null ? details.rvAnnuityIncomeOverride : null;
        const owner = details.rvAnnuityOwner || 'client';
        const annuityRecord = (0, $f7f7b62814c3b615$export$fb67395f10ad20c9)(factFind, {
            annuityType: annuityType,
            purchaseAmount: purchaseAnnuity,
            age: clientAge,
            partnerAge: partnerAge,
            owner: owner,
            residualCapital: residualCapital,
            termYears: termYears,
            indexation: indexation,
            reversionary: reversionary,
            incomeOverride: Number.isFinite(incomeOverride) ? incomeOverride : null
        });
        if (annuityRecord && !annuityRecord.warnings) {
            if (!data.assets.annuities) data.assets.annuities = [];
            data.assets.annuities.push((0, $f7f7b62814c3b615$export$5dc1cd0ab6cd8d79)(annuityRecord, {
                id: annuityRecord.id || 'rv-sell-annuity',
                description: `${annuityType === 'lifetime' ? 'Lifetime' : 'Fixed-term'} annuity (from home sale)`,
                ownership: isCoupleSale ? coupleOwner(owner) : 'client'
            }));
        }
    }
    // What the sale did not cover comes from savings — see topUpEntryFeeFromLiquid.
    const topUp = $d6349ba6b2bbee8e$var$topUpEntryFeeFromLiquid(data, factFind, rvStrategy, entryFee - entryFeeAllocation);
    const entryFeePaid = entryFeeAllocation + topUp.deducted;
    return $d6349ba6b2bbee8e$var$finalizeRvStrategyFactFind({
        factFind: data,
        entryAlreadyPaidFromSale: entryFeePaid > 0,
        entryFeePaid: entryFeePaid,
        entryFeeCgtFromIp: topUp.entryFeeCgtFromIp
    }, factFind, rvStrategy);
}


function $4633117ee929ec27$export$27943b3c73c6c12b(factFind) {
    if (!$4633117ee929ec27$export$cb26bf32ff9b2b4d(factFind)) return 0;
    const e = $4633117ee929ec27$export$3da79be84c8bf9e7(factFind, $4633117ee929ec27$export$6005e8b092eea057(new Date()));
    return e ? Math.max(0, e.entitlement) : 0;
}
function $4633117ee929ec27$export$da0d2a55d836e8e7(factFind, leaveDate, destination) {
    if (!((Number(factFind.retirementVillage?.entryContribution) || 0) > 0)) return null;
    const e = $4633117ee929ec27$export$3da79be84c8bf9e7(factFind, leaveDate);
    if (!e) return null;
    const feesAfterLeaving = $4633117ee929ec27$export$de22c25de5484f31(factFind.retirementVillage, leaveDate, e.refundDate);
    return {
        person: 'client',
        leaveDate: leaveDate,
        refundDate: e.refundDate,
        entitlement: e.entitlement,
        radAllocation: 0,
        interimDailyPayment: 0,
        destination: destination,
        feesAfterLeaving: {
            perDay: feesAfterLeaving.perDay,
            fullDays: feesAfterLeaving.fullDays,
            sharedDays: feesAfterLeaving.sharedDays,
            sharePct: feesAfterLeaving.sharePct,
            total: feesAfterLeaving.total
        }
    };
}
function $4633117ee929ec27$export$1a564c73622db812(factFind) {
    const payout = $4633117ee929ec27$export$27943b3c73c6c12b(factFind);
    if (!(payout > 0)) return factFind;
    const data = structuredClone(factFind);
    if (!data.assets) data.assets = {};
    const rows = Array.isArray(data.assets.bankAccounts) ? data.assets.bankAccounts : [];
    data.assets.bankAccounts = [
        ...rows,
        {
            id: 'village-payout',
            type: 'bankAccounts',
            description: 'Payout from the current village unit',
            value: payout,
            ownership: 'client',
            income: 0,
            incomeRate: 0,
            growthRate: 0
        }
    ];
    return data;
}
function $4633117ee929ec27$export$cb26bf32ff9b2b4d(factFind, strategyOptions = {}) {
    if (strategyOptions.villageInterestSold) return false;
    if (!((Number(factFind.retirementVillage?.entryContribution) || 0) > 0)) return false;
    if (factFind.client?.currentResidency === 'retirement_village') return true;
    return factFind.adviceFor === 'couple' && factFind.partner?.currentResidency === 'retirement_village';
}
function $4633117ee929ec27$export$21c4a7ba859ac116(factFind, person, bothEntering = false) {
    const record = person === 'partner' ? factFind.partner : factFind.client;
    if (record?.currentResidency !== 'retirement_village') return false;
    if (!((Number(factFind.retirementVillage?.entryContribution) || 0) > 0)) return false;
    if (factFind.adviceFor !== 'couple' || bothEntering) return true;
    return factFind.retirementVillage?.onEnteringCare === 'sell';
}
const $4633117ee929ec27$var$MS_PER_DAY = 86400000;
function $4633117ee929ec27$export$416492d1a5f46c79(fromIso, toIso) {
    const a = new Date(fromIso + 'T00:00:00').getTime();
    const b = new Date(toIso + 'T00:00:00').getTime();
    if (!Number.isFinite(a) || !Number.isFinite(b)) return 0;
    return Math.max(0, Math.round((b - a) / $4633117ee929ec27$var$MS_PER_DAY));
}
function $4633117ee929ec27$export$4248c5b777a2c251(radAllocation, leaveDate, refundDate, mpir) {
    const days = $4633117ee929ec27$export$416492d1a5f46c79(leaveDate, refundDate);
    const perDay = Math.max(0, radAllocation) * mpir / 365;
    return {
        days: days,
        perDay: perDay,
        total: perDay * days
    };
}
const $4633117ee929ec27$export$50343794bd888a5f = {
    NSW: 12,
    VIC: 6,
    QLD: 18,
    SA: 13,
    WA: 12,
    TAS: 12,
    ACT: 18,
    NT: 12
};
const $4633117ee929ec27$export$e05cb4e4afc2b30c = 12;
function $4633117ee929ec27$export$682875ad09d6ca5c(village) {
    const explicit = Number(village?.refundMonths);
    const state = String(village?.state || '').toUpperCase();
    const longstop = Number.isFinite(explicit) && explicit >= 0 ? explicit : $4633117ee929ec27$export$50343794bd888a5f[state] ?? $4633117ee929ec27$export$e05cb4e4afc2b30c;
    const resale = Number(village?.expectedResaleMonths);
    return Number.isFinite(resale) && resale > 0 ? Math.min(longstop, resale) : longstop;
}
const $4633117ee929ec27$export$248cab8c4a906294 = {
    NSW: {
        fullDays: 42,
        sharedUntil: 0,
        source: 'the NSW rule (42 days)'
    },
    VIC: {
        fullDays: 0,
        sharedUntil: 0,
        source: 'the Victorian rule (none after leaving)'
    },
    QLD: {
        fullDays: 90,
        sharedUntil: 274,
        source: 'the Queensland rule (90 days, then your share to 9 months)'
    },
    SA: {
        fullDays: 183,
        sharedUntil: 0,
        source: 'the South Australian rule (up to 6 months)'
    },
    WA: {
        fullDays: 91,
        sharedUntil: 0,
        source: 'the WA rule (3 months)'
    },
    ACT: {
        fullDays: 42,
        sharedUntil: 'untilPaid',
        source: 'the ACT rule (6 weeks, then your share until the sale)'
    },
    TAS: {
        fullDays: 0,
        sharedUntil: 'untilPaid',
        source: 'no Tasmanian limit (assumed until the payout)'
    },
    NT: {
        fullDays: 0,
        sharedUntil: 'untilPaid',
        source: 'no NT limit (assumed until the payout)'
    }
};
const $4633117ee929ec27$export$f5451b9a2b5450cd = {
    fullDays: 42,
    sharedUntil: 0,
    source: '42 days assumed (no state chosen)'
};
function $4633117ee929ec27$export$de22c25de5484f31(village, leaveDate, refundDate) {
    const perDay = Math.max(0, Number(village?.ongoingFees) || 0) * 52 / 365;
    const state = String(village?.state || '').toUpperCase();
    const rule = $4633117ee929ec27$export$248cab8c4a906294[state] ?? $4633117ee929ec27$export$f5451b9a2b5450cd;
    const waitDays = $4633117ee929ec27$export$416492d1a5f46c79(leaveDate, refundDate);
    const sharePct = Number.isFinite(Number(village?.capitalGainSharePct)) && village?.capitalGainSharePct != null ? Math.max(0, Math.min(100, Number(village.capitalGainSharePct))) : 50;
    const fullDays = Math.min(waitDays, rule.fullDays);
    const sharedEnd = rule.sharedUntil === 'untilPaid' ? waitDays : Math.min(waitDays, rule.sharedUntil);
    const sharedDays = rule.sharedUntil === 'untilPaid' || rule.sharedUntil > 0 ? Math.max(0, sharedEnd - fullDays) : 0;
    // TAS and NT (no cap) and ACT's owner-share: the "shared" period is in full where no gain share applies to it.
    const effectiveSharePct = rule.sharedUntil === 'untilPaid' && rule.fullDays === 0 ? 100 : sharePct;
    const total = perDay * fullDays + perDay * sharedDays * effectiveSharePct / 100;
    return {
        perDay: perDay,
        fullDays: fullDays,
        sharedDays: sharedDays,
        sharePct: effectiveSharePct,
        total: total,
        source: rule.source
    };
}
function $4633117ee929ec27$export$9d189192715247ff(fees, daysSinceLeaving) {
    const d = Math.max(0, daysSinceLeaving);
    const full = Math.min(d, fees.fullDays);
    const shared = Math.max(0, Math.min(d - fees.fullDays, fees.sharedDays));
    return fees.perDay * full + fees.perDay * shared * fees.sharePct / 100;
}
const $4633117ee929ec27$var$ISO = /^\d{4}-\d{2}-\d{2}$/;
function $4633117ee929ec27$export$6005e8b092eea057(d) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
function $4633117ee929ec27$export$17c93e242b2d3a22(iso, months) {
    const d = new Date(iso + 'T00:00:00');
    const day = d.getDate();
    d.setDate(1);
    d.setMonth(d.getMonth() + Math.round(months));
    const last = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
    d.setDate(Math.min(day, last));
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
function $4633117ee929ec27$export$3da79be84c8bf9e7(factFind, leaveDate, growth = {}) {
    const v = factFind.retirementVillage;
    const entry = Math.max(0, Number(v?.entryContribution) || 0);
    if (!v || entry <= 0 || !$4633117ee929ec27$var$ISO.test(leaveDate)) return null;
    const entered = typeof v.dateEntered === 'string' && $4633117ee929ec27$var$ISO.test(v.dateEntered) ? new Date(v.dateEntered + 'T00:00:00') : null;
    const leave = new Date(leaveDate + 'T00:00:00');
    const base = growth.resaleBaseDate && $4633117ee929ec27$var$ISO.test(growth.resaleBaseDate) ? new Date(growth.resaleBaseDate + 'T00:00:00') : null;
    const yearsAhead = base ? Math.max(0, (leave.getTime() - base.getTime()) / 31557600000) : 0;
    const yearsResidency = entered ? Math.max(0, (leave.getTime() - entered.getTime()) / 31557600000) : Math.max(0, Number(v.yearsResidency) || 0) + yearsAhead;
    const resaleToday = (Number(v.expectedResaleValue) || 0) > 0 ? Number(v.expectedResaleValue) : entry;
    const resaleValue = resaleToday * Math.pow(1 + (Number(growth.resaleGrowthPct) || 0) / 100, yearsAhead);
    const dmfBasis = v.dmfBasis === 'resale' ? 'resale' : 'entry';
    const { dmfAmount: dmfAmount } = (0, $d6349ba6b2bbee8e$export$10a8d0dd9aa35e39)(entry, yearsResidency, Number(v.dmfPctPerYear) || 0, Number(v.dmfCapYears) || 0, dmfBasis, resaleValue);
    const capitalGain = Math.max(0, resaleValue - entry);
    const sharePct = Number.isFinite(Number(v.capitalGainSharePct)) ? Math.max(0, Math.min(100, Number(v.capitalGainSharePct))) : 50;
    const residentShareOfGain = capitalGain * (sharePct / 100);
    const operatorShareOfGain = capitalGain - residentShareOfGain;
    const reinstatement = Math.max(0, Number(v.reinstatementCost) || 0);
    // A capital LOSS is the resident's where the resale is below the entry price (the contract may share it; the simpler, dearer case is assumed).
    const capitalLoss = Math.max(0, entry - resaleValue);
    const entitlement = Math.max(0, entry + residentShareOfGain - capitalLoss - dmfAmount - reinstatement);
    const refundMonths = $4633117ee929ec27$export$682875ad09d6ca5c(v);
    return {
        entryContribution: entry,
        resaleValue: resaleValue,
        yearsResidency: yearsResidency,
        departureFee: dmfAmount,
        reinstatement: reinstatement,
        capitalGain: capitalGain,
        residentShareOfGain: residentShareOfGain,
        operatorShareOfGain: operatorShareOfGain,
        entitlement: entitlement,
        refundMonths: refundMonths,
        refundDate: $4633117ee929ec27$export$17c93e242b2d3a22(leaveDate, refundMonths),
        state: String(v.state || '')
    };
}


/**
 * LEAVING A RETIREMENT VILLAGE FOR CARE, in the client's words (owner, 7 Oct 2026). The village pays
 * the exit entitlement months after the resident leaves, on the state's timeline; until then the
 * interest still counts as their home and the part of the room it will pay is charged daily. One
 * module for the words, so step 1, the funding card, the plan summary, the cards, the recap and the
 * advice document all say the same thing.
 */ /**
 * Shared utilities - re-exports for convenient importing
 */ /**
 * Applicant "voice" — whether the fact-find addresses the person seeking advice directly
 * ("your home", "do you have…") or refers to them by name ("Bob & Sally's home", "do Bob & Sally
 * have…").
 *
 * Step 1 asks who is completing the form. Whenever that is someone other than the applicant — a
 * family member, an attorney, an adviser — second-person labels are ambiguous at best and wrong at
 * worst: "who will stay in your home?" reads as the *completer's* home. Every label that refers to
 * the applicant's own circumstances goes through this helper instead.
 *
 * Text that addresses the *reader* rather than the applicant ("if you're not sure, leave it blank",
 * "you can change this at any time") is correct in second person for both voices and is left alone.
 *
 * Falls back to second person until the primary applicant's first name is known, so a half-filled
 * Step 2 never renders "'s Home".
 */ const $7af19dec1ba96a5f$var$capitalise = (text)=>text.charAt(0).toUpperCase() + text.slice(1);
const $7af19dec1ba96a5f$export$5d44334005555b21 = (factFind)=>{
    const completedByApplicant = (factFind?.completer || 'client') === 'client';
    const clientFirstName = (factFind?.client?.firstName || '').trim();
    const partnerFirstName = (factFind?.partner?.firstName || '').trim();
    const isPartnered = factFind?.adviceFor === 'couple';
    const names = [
        clientFirstName,
        isPartnered ? partnerFirstName : ''
    ].filter(Boolean);
    /**
     * Answering "I'm a family member" is enough — the name is NOT required.
     *
     * Third person used to wait for the client's first name, which is collected on step 2. So a
     * daughter filling this in for her mother reached a step headed "Your Details", above a
     * fieldset headed "Primary Applicant Details", one screen after giving HER OWN details under
     * "Your Details (as the person completing this form)" — the same words for two different
     * people. The headings then changed under her as she typed her mother's name. Reported
     * 2026-08-20.
     *
     * Until a name arrives the voice speaks in the third person without one, which is the whole
     * point: it is already not about the reader.
     */ const isThirdPerson = !completedByApplicant;
    // "Bob & Sally" — the couple's own preferred order is Step 2's client/partner order.
    const subject = isThirdPerson ? names.join(' & ') || "the person you're helping" : 'you';
    // Possessive sits on the last name only: "Bob & Sally's". Always "'s", including for names
    // already ending in s ("James's"), which is current Australian usage. With no name yet,
    // "their" — never "the person you're helping's".
    const possessive = isThirdPerson ? names.length ? `${subject}'s` : 'their' : 'your';
    const isPlural = !isThirdPerson || names.length > 1;
    return {
        isThirdPerson: isThirdPerson,
        subject: subject,
        Subject: $7af19dec1ba96a5f$var$capitalise(subject),
        possessive: possessive,
        Possessive: $7af19dec1ba96a5f$var$capitalise(possessive),
        pronoun: isThirdPerson ? 'they' : 'you',
        pronounPossessive: isThirdPerson ? 'their' : 'your',
        verb: (plural, singular)=>isPlural ? plural : singular
    };
};


/**
 * Currency formatting and parsing utilities
 * Used by forms, display components, and calculations.
 */ /** Parse user input (e.g. "$1,234") to numeric string for storage. Clean numeric string or '' if invalid. */ function $f94e45ac645ae232$export$dc5333890dfc7d0(value) {
    if (!value || value === '') return '';
    const cleanValue = String(value).replace(/[$,\s]/g, '');
    const numValue = parseFloat(cleanValue);
    return isNaN(numValue) ? '' : numValue.toString();
}
function $f94e45ac645ae232$export$3dc27271f5d5c629(value) {
    if (value === null || value === undefined || isNaN(Number(value))) return '$0';
    const num = typeof value === 'number' ? value : parseFloat(value) || 0;
    const roundedValue = Math.round(num);
    return `${roundedValue < 0 ? '-' : ''}$${Math.abs(roundedValue).toLocaleString()}`;
}
function $f94e45ac645ae232$export$50a31df933489641(value) {
    if (value === '' || value === undefined || value === null) return '';
    const n = Number(value);
    if (isNaN(n)) return '';
    return '$' + n.toLocaleString('en-AU', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
}


/**
 * Date helper utilities
 * Single source for age calculation used across calculations, forms, and display.
 */ /** Calculate age from date of birth. Age in years, or null if dob is falsy. */ function $5589d9476399db47$export$8ada184d5eef4694(dob, refDate = new Date()) {
    if (!dob) return null;
    const birthDate = new Date(dob);
    const referenceDate = new Date(refDate);
    let age = referenceDate.getFullYear() - birthDate.getFullYear();
    const monthDiff = referenceDate.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || monthDiff === 0 && referenceDate.getDate() < birthDate.getDate()) age--;
    return age;
}


/**
 * Australian financial year helpers (1 July → 30 June).
 * Used for FY-native projection rows: optional partial first row from anchor to 30 June.
 */ /** June 30 that closes the FY containing `date`. */ function $a72f706839aad5d3$export$2959e50727a768f6(date) {
    const d = date instanceof Date ? new Date(date.getTime()) : new Date(date);
    const y = d.getFullYear();
    const m = d.getMonth();
    const endYear = m >= 6 ? y + 1 : y;
    return new Date(endYear, 5, 30);
}
function $a72f706839aad5d3$export$a0b4f07526e12f04(date) {
    const end = $a72f706839aad5d3$export$2959e50727a768f6(date);
    return new Date(end.getFullYear() - 1, 6, 1);
}
function $a72f706839aad5d3$export$99d61b647db9de9f(start, end) {
    const s = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
    const e = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
    return Math.floor((e - s) / 86400000) + 1;
}
function $a72f706839aad5d3$export$8f178fc78bb641c9(fyStart, fyEnd) {
    const a = fyStart.getFullYear() % 100;
    const b = fyEnd.getFullYear() % 100;
    return `FY${String(a).padStart(2, '0')}/${String(b).padStart(2, '0')}`;
}
function $a72f706839aad5d3$export$3e8dcbdae0ef5696(anchorDate, rowCount) {
    const anchor = anchorDate instanceof Date ? new Date(anchorDate.getTime()) : new Date(anchorDate);
    const cursorStart = new Date(anchor.getFullYear(), anchor.getMonth(), anchor.getDate());
    const periods = [];
    for(let i = 0; i < rowCount; i++){
        const fyEndThisRow = $a72f706839aad5d3$export$2959e50727a768f6(cursorStart);
        const fyStartThisRow = $a72f706839aad5d3$export$a0b4f07526e12f04(cursorStart);
        const fullFyDays = $a72f706839aad5d3$export$99d61b647db9de9f(fyStartThisRow, fyEndThisRow);
        const periodEnd = new Date(fyEndThisRow.getTime());
        const periodStart = new Date(cursorStart.getTime());
        const periodDays = $a72f706839aad5d3$export$99d61b647db9de9f(periodStart, periodEnd);
        const yearFraction = fullFyDays > 0 ? periodDays / fullFyDays : 1;
        const isPartialFy = periodDays < fullFyDays;
        periods.push({
            periodIndex: i + 1,
            periodStart: periodStart,
            periodEnd: periodEnd,
            fyLabel: $a72f706839aad5d3$export$8f178fc78bb641c9(fyStartThisRow, fyEndThisRow),
            fyEndingYear: fyEndThisRow.getFullYear(),
            yearFraction: yearFraction,
            isPartialFy: isPartialFy,
            capitalExpensePeriodStart: new Date(periodStart.getTime()),
            capitalExpensePeriodEnd: new Date(periodEnd.getTime())
        });
        const nextJuly = new Date(periodEnd.getFullYear(), 6, 1);
        cursorStart.setTime(nextJuly.getTime());
    }
    return periods;
}


/**
 * String helpers used across the app (e.g. display names, initials).
 */ const $bebf3453094bd1f6$export$de9bdbce6502b027 = (firstName = '', lastName = '')=>{
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
};


/**
 * FormRadioGroup/FormSelect are string-based (native radio/select inputs always emit strings), but
 * the fact-find schema stores these fields as real booleans. These convert at the UI boundary so a
 * boolean factFind field can still be rendered/edited as a Yes/No control.
 */ /** Boolean (or undefined) -> 'yes' | 'no', for passing into a Yes/No control's `value` prop. */ function $8ab044f9996773da$export$3b62265a75916bfa(value) {
    return value ? 'yes' : 'no';
}
function $8ab044f9996773da$export$1923fe087c479fde(value) {
    return value === 'yes';
}
function $8ab044f9996773da$export$71dc53db491defdf(value) {
    if (value === true) return 'yes';
    if (value === false) return 'no';
    return '';
}
function $8ab044f9996773da$export$87f1f3a36f1f2332(value) {
    if (value === 'yes') return true;
    if (value === 'no') return false;
    return undefined;
}




/**
 * Two people, two entry dates — the TIMING of a couple both entering care, and the words that
 * explain it (owner, 7 Oct 2026: "dad will go in straight away but mum might be ok for a little
 * while longer … people need to make decisions based on correct information").
 *
 * Where the second person enters later there are two stages, and the screens show both:
 *   stage 1 — until the second entry: one room paid for, the family home exempt from the aged
 *             care means test because the other person still lives in it, the couple assessed as
 *             illness-separated from the first entry;
 *   stage 2 — from the second entry: both rooms paid for, the home counted (up to the cap).
 * The projection has always run that timeline; this module is the one place the words for it live,
 * so step 2, the plan summary, the recap and the advice document all say the same thing.
 */ 
function $b8d3cfe4c156722e$export$cea9846d43ecc40e(now = new Date()) {
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}
function $b8d3cfe4c156722e$export$dcba8ccb2c57a554(value, now = new Date()) {
    if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    const year = Number(value.slice(0, 4));
    return year >= now.getFullYear() - 1 && year <= now.getFullYear() + 60;
}
function $b8d3cfe4c156722e$export$b3b2f82762b8c7c4(firstDate, secondDate, now = new Date()) {
    if (!$b8d3cfe4c156722e$export$dcba8ccb2c57a554(secondDate, now)) return false;
    return secondDate > (firstDate || $b8d3cfe4c156722e$export$cea9846d43ecc40e(now));
}
function $b8d3cfe4c156722e$export$a4442bb413fc20b4(firstDate, secondDate, now = new Date()) {
    if (!$b8d3cfe4c156722e$export$dcba8ccb2c57a554(secondDate, now)) return false;
    return secondDate < (firstDate || $b8d3cfe4c156722e$export$cea9846d43ecc40e(now));
}
function $b8d3cfe4c156722e$export$e009b8a64eefbb66(iso) {
    const m = /^(\d{4})-(\d{2})/.exec(iso || '');
    if (!m) return iso;
    const d = new Date(Number(m[1]), Number(m[2]) - 1, 1);
    return d.toLocaleDateString('en-AU', {
        month: 'long',
        year: 'numeric'
    });
}
function $b8d3cfe4c156722e$export$24ee473c3b86ae0(factFind, secondPerson, fallbacks = {
    first: 'the client',
    second: 'their partner'
}) {
    const second = secondPerson === 'client' ? factFind.client : factFind.partner;
    const first = secondPerson === 'client' ? factFind.partner : factFind.client;
    return {
        firstName: (first?.firstName || '').trim() || fallbacks.first,
        secondName: (second?.firstName || '').trim() || fallbacks.second
    };
}
function $b8d3cfe4c156722e$export$20f15f6261f594de({ firstName: firstName, secondName: secondName, fromLabel: fromLabel }) {
    return `${firstName} moves in first; ${secondName} stays at home until ${fromLabel}. Until then only ${firstName}'s room is paid for, and the family home stays out of the aged care means test because ${secondName} lives there. From ${fromLabel} both rooms are paid for and the home counts, up to the capped value. The numbers below show both stages.`;
}
function $b8d3cfe4c156722e$export$a2b7e2699cfc74be({ fromLabel: fromLabel }) {
    return `From ${fromLabel} \u{2014} both in care`;
}
function $b8d3cfe4c156722e$export$af3a013ca5b458b2({ firstName: firstName, fromLabel: fromLabel }) {
    return `Until ${fromLabel} \u{2014} ${firstName}'s room only.`;
}
function $b8d3cfe4c156722e$export$d1629cfae6946451({ secondName: secondName, fromLabel: fromLabel }, dailyTotal) {
    return `From ${fromLabel}, when ${secondName} moves in: ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(dailyTotal))} a day (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(dailyTotal * 365))} a year) for both rooms.`;
}
function $b8d3cfe4c156722e$export$c84e6db632ec436a({ firstName: firstName, secondName: secondName, fromLabel: fromLabel }, figures) {
    const both = figures.phaseTwoFirstDaily + figures.secondDaily;
    return {
        untilThen: `it would cost ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(figures.firstDaily)} a day (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(figures.firstDaily * 365)}/yr) for ${firstName}'s room until ${fromLabel}.`,
        fromThen: `From ${fromLabel}, with ${secondName} in care too, ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(both)} a day (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(both * 365)}/yr) for the two rooms together \u{2014} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(figures.phaseTwoFirstDaily)} for ${firstName}'s and ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(figures.secondDaily)} for ${secondName}'s.`
    };
}
function $b8d3cfe4c156722e$export$d32c6b1cf9147a3b({ secondName: secondName, fromLabel: fromLabel }, gapPhaseTwo) {
    if (gapPhaseTwo >= 0) return `From ${fromLabel}, with ${secondName}'s room paid for too, income still covers everything.`;
    return `From ${fromLabel}, with ${secondName}'s room paid for too, the gap grows to ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(gapPhaseTwo)))} a year.`;
}
function $b8d3cfe4c156722e$export$53bd112132b420ae({ firstName: firstName, secondName: secondName, fromLabel: fromLabel }) {
    return `Living costs usually change again once ${secondName} moves in: with nobody at home, the home's running costs stop and the care home covers meals and utilities. Enter what you expect the household to spend a year from ${fromLabel}; leave it as it is if nothing changes. Until then, the figure above applies \u{2014} ${firstName} in care, ${secondName} at home.`;
}
function $b8d3cfe4c156722e$export$16b931c1d501c85b({ fromLabel: fromLabel }, amount) {
    return `From ${fromLabel}, with both in care, living costs are set to ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(amount)} a year.`;
}
function $b8d3cfe4c156722e$export$72e32d04cedd8a9d({ firstName: firstName, secondName: secondName, fromLabel: fromLabel }, firstDaily, phaseTwoDaily) {
    return `Until ${fromLabel} only ${firstName}'s room is paid for (about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(firstDaily))} a day). From ${fromLabel}, when ${secondName} moves in, the plan pays for both rooms: about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(phaseTwoDaily))} a day.`;
}


/** A daily figure keeps its cents: $69.95 a day is a real quote, and "$70" would overstate the wait. */ const $511dfa7ed5ad5c31$var$perDay = (n)=>`$${(Math.round(n * 100) / 100).toLocaleString('en-AU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })}`;
function $511dfa7ed5ad5c31$export$ae142e1c7d0c747a(f) {
    const atLimit = (f.interim?.total || 0) + (f.feesAfterLeaving?.total || 0);
    if (!(atLimit > 0.5)) return '';
    return `How long the unit takes to resell is an assumption: if it sells straight away the wait costs nothing; if it takes the full ${f.refundMonths} months, about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(atLimit))}.`;
}
function $511dfa7ed5ad5c31$export$eabd2e17c6ad2b74(f) {
    if (!(f.total > 0.5)) return '';
    const period = f.sharedDays > 0 ? `${f.fullDays} days in full, then a share for ${f.sharedDays} more` : `${f.fullDays} days`;
    return `The village's fees continue after leaving \u{2014} ${period}${f.source ? ` (${f.source})` : ''}: about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.total))}, taken from the payout.`;
}
function $511dfa7ed5ad5c31$export$b87b421136daf73c(years) {
    if (years < 1) return 'under a year';
    // To the nearest half-year: "6½ years" for 6.497.
    const rounded = Math.round(years * 2) / 2;
    const whole = Math.floor(rounded);
    const half = rounded - whole >= 0.5;
    return `${whole}${half ? "\xbd" : ''} ${whole === 1 && !half ? 'year' : 'years'}`;
}
function $511dfa7ed5ad5c31$export$6a00304d19569a72(f) {
    return `by ${(0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(f.refundDate)}`;
}
function $511dfa7ed5ad5c31$export$a942ace38e89697f(f) {
    const stayed = f.yearsResidency > 0 ? `has lived in the village for ${$511dfa7ed5ad5c31$export$b87b421136daf73c(f.yearsResidency)}` : 'lives in a retirement village';
    const fee = f.departureFee > 0.5 ? `the departure fee of ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.departureFee))}` : 'no departure fee';
    const reinstate = f.reinstatement > 0.5 ? ` and ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.reinstatement))} to reinstate the unit` : '';
    const gain = f.residentShareOfGain > 0.5 ? `, and keeping ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.residentShareOfGain))} of the gain on resale` : '';
    const resale = f.resaleValue > 0 && Math.abs(f.resaleValue - f.entryContribution) > 0.5 ? ` and the unit is expected to sell for ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(f.resaleValue)}` : '';
    return `${f.name} ${stayed}; the entry contribution was ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(f.entryContribution)}${resale}. On leaving for care the unit is sold back to the village: after ${fee}${reinstate}${gain}, about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.entitlement))} comes back. The village has up to ${f.refundMonths} months to pay it (${$511dfa7ed5ad5c31$export$6a00304d19569a72(f)}). Until then it still counts as ${f.name}'s home; from then it is money in the bank.`;
}
function $511dfa7ed5ad5c31$export$67cce8e1892a5f73(f, fromVillage, interim, useForRoom, atMove = false) {
    if (atMove) return !useForRoom || fromVillage <= 0.5 ? `The village's ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.entitlement))} exit payment is paid at the move and goes to the bank; the room is paid from savings and the strategies above.` : `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(fromVillage))} of the room is paid from the village's exit payment at the move. Savings only need to cover what it does not.${f.entitlement - fromVillage > 0.5 ? ` The other ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.entitlement - fromVillage))} goes to the bank.` : ''}`;
    if (!useForRoom || fromVillage <= 0.5) return `The village's ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.entitlement))} exit payment goes to the bank when it arrives (${$511dfa7ed5ad5c31$export$6a00304d19569a72(f)}); the room is paid from savings and the strategies above.`;
    const wait = interim.total > 0.5 ? ` Until then the home charges ${$511dfa7ed5ad5c31$var$perDay(interim.perDay)} a day on that part of the room \u{2014} about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(interim.total))} over the ${interim.days} days.` : '';
    const rest = f.entitlement - fromVillage > 0.5 ? ` The other ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.entitlement - fromVillage))} of the exit payment goes to the bank.` : '';
    return `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(fromVillage))} of the room is paid from the village's exit payment when it arrives, ${$511dfa7ed5ad5c31$export$6a00304d19569a72(f)}.${wait} Savings only need to cover what the village money does not.${rest}`;
}
function $511dfa7ed5ad5c31$export$482a9965b8c56d4f(f, fromVillage, interim, roomPrice, atMove = false) {
    const wait = !atMove && interim.total > 0.5 ? ` Until it arrives (${$511dfa7ed5ad5c31$export$6a00304d19569a72(f)}) the home charges ${$511dfa7ed5ad5c31$var$perDay(interim.perDay)} a day on the room \u{2014} about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(interim.total))} in all.` : atMove ? ' It is paid at the move.' : '';
    return `Fully covered \u{2014} the village's ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.entitlement))} exit payment pays the whole ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(roomPrice)} room price, so nothing needs to come from savings.${wait}${f.entitlement - fromVillage > 0.5 ? ` The other ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.entitlement - fromVillage))} goes to the bank.` : ''}`;
}
function $511dfa7ed5ad5c31$export$ff6c9524331ef263(f) {
    const unpaid = Math.max(0, f.roomPrice - f.deposit);
    const parts = [];
    if (f.fromSavings > 0.5) parts.push(`${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.fromSavings))} at entry${f.soldPhrase ? ` from savings (${f.soldPhrase})` : ' from savings'}`);
    if (f.fromVillage > 0.5) parts.push(`${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.fromVillage))} from the village money when it arrives`);
    const paidWith = f.deposit <= 0.5 ? `nothing is paid up front for the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(f.roomPrice)} room, so the whole of it is charged as a daily payment` : `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.deposit))} of the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(f.roomPrice)} room is paid as a deposit \u{2014} ${parts.join(', and ')}${unpaid > 0.5 ? `; the unpaid ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(unpaid))} is charged as a daily payment of ${$511dfa7ed5ad5c31$var$perDay(f.dapPerDay)} a day` : ''}`;
    const wait = f.interim && f.interim.total > 0.5 ? ` Until the village pays, ${$511dfa7ed5ad5c31$var$perDay(f.interim.perDay)} a day is charged on its ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.fromVillage))} share of the room \u{2014} about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.interim.total))} in all.` : '';
    const bank = f.toBank > 0.5 ? ` The other ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.toBank))} of the exit payment goes to the bank.` : '';
    const fees = f.feesAfterLeaving && f.feesAfterLeaving.total > 0.5 ? ` ${$511dfa7ed5ad5c31$export$eabd2e17c6ad2b74(f.feesAfterLeaving)}` : '';
    const range = f.paidAtMove ? '' : $511dfa7ed5ad5c31$export$ae142e1c7d0c747a(f);
    const sensitivity = range ? ` ${range}` : '';
    const pays = f.paidAtMove ? `the unit is sold back and the village pays about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.entitlement))} at the move` : `the unit is sold back and the village pays about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.entitlement))} ${$511dfa7ed5ad5c31$export$6a00304d19569a72(f)} (it has up to ${f.refundMonths} months)`;
    return `${f.name} leaves the village in ${f.leaveLabel}; ${pays}. ${paidWith}.${f.paidAtMove ? '' : wait}${bank}${f.paidAtMove ? '' : fees}${sensitivity} From the day the village pays, the entry contribution no longer counts as a home: ${f.name} is assessed as a non-homeowner, with the deposit exempt for the Age Pension.`;
}
function $511dfa7ed5ad5c31$export$2bd5a1cd4f86f5f0(f, destination, opts = {}) {
    const to = destination === 'village' ? 'the new village' : 'the family';
    if (opts.atMove) return `The current unit pays back about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.entitlement))}. Paid at the move, that money goes towards ${to} first and savings cover the rest. Its fees stop on the day of the move.`;
    const limit = f.state ? `the ${f.state} limit` : 'the time limit assumed';
    const fees = f.feesAfterLeaving && f.feesAfterLeaving.total > 0.5 ? ` ${$511dfa7ed5ad5c31$export$eabd2e17c6ad2b74(f.feesAfterLeaving)} ${$511dfa7ed5ad5c31$export$ae142e1c7d0c747a({
        refundMonths: f.refundMonths,
        feesAfterLeaving: f.feesAfterLeaving
    })}` : ' Its fees stop on the day of the move.';
    return `The current unit pays back about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.entitlement))}, within ${f.refundMonths} months of leaving (${limit}) \u{2014} ${$511dfa7ed5ad5c31$export$6a00304d19569a72(f)}. Until then savings pay for ${to}; the payout tops them back up when it arrives.${fees}`;
}
function $511dfa7ed5ad5c31$export$65f8669d24e0c145(f) {
    return `; the village's ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.entitlement))} exit payment goes to the bank when it arrives, ${$511dfa7ed5ad5c31$export$6a00304d19569a72(f)}`;
}



const $30388f8480cb4423$var$years = (n)=>{
    const r = Math.round(n * 10) / 10;
    return `${r} ${r === 1 ? 'year' : 'years'}`;
};
function $30388f8480cb4423$export$145bfe0a43b9b7f2(factFind) {
    const ff = factFind;
    if (!(0, $4633117ee929ec27$export$cb26bf32ff9b2b4d)(ff)) return null;
    const v = ff.retirementVillage || {};
    const e = (0, $4633117ee929ec27$export$3da79be84c8bf9e7)(ff, (0, $4633117ee929ec27$export$6005e8b092eea057)(new Date()));
    if (!e) return null;
    const entry = e.entryContribution;
    const feePct = Number(v.dmfPctPerYear) || 0;
    const capYears = Number(v.dmfCapYears) || 0;
    const feeYears = capYears > 0 ? Math.min(e.yearsResidency, capYears) : e.yearsResidency;
    const hasResidency = typeof v.dateEntered === 'string' && v.dateEntered.length >= 10 || (Number(v.yearsResidency) || 0) > 0;
    const sharePct = Number.isFinite(Number(v.capitalGainSharePct)) && v.capitalGainSharePct != null ? Number(v.capitalGainSharePct) : 50;
    const loss = Math.max(0, entry - e.resaleValue);
    const lines = [
        {
            label: 'Entry contribution',
            value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(entry)
        }
    ];
    if (e.capitalGain > 0.5) lines.push({
        label: `Plus their ${sharePct}% share of the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(e.capitalGain))} gain on a ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(e.resaleValue)} resale`,
        value: `+${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(e.residentShareOfGain))}`
    });
    else if (loss > 0.5) lines.push({
        label: `Less the shortfall on a ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(e.resaleValue)} resale`,
        value: `\u{2212}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(loss))}`
    });
    if (e.departureFee > 0.5) {
        const basis = v.dmfBasis === 'resale' ? 'the resale price' : 'the entry contribution';
        lines.push({
            label: `Less the departure fee (${feePct}% a year for ${$30388f8480cb4423$var$years(feeYears)}${capYears > 0 ? `, capped at ${capYears}` : ''}, on ${basis})`,
            value: `\u{2212}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(e.departureFee))}`
        });
    }
    if (e.reinstatement > 0.5) lines.push({
        label: 'Less reinstatement',
        value: `\u{2212}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(e.reinstatement))}`
    });
    lines.push({
        label: 'Comes back',
        value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round((0, $4633117ee929ec27$export$27943b3c73c6c12b)(ff))),
        total: true
    });
    const paragraphs = [];
    if (feePct <= 0) paragraphs.push("No departure fee is recorded, so the full entry contribution is taken as coming back. Enter the contract\u2019s terms for a closer figure.");
    else if (!hasResidency) paragraphs.push('The departure fee has nothing to accrue over yet: add the date moved in, or the years in the village, and it is taken off here.');
    const state = String(v.state || '').toUpperCase();
    const months = (0, $4633117ee929ec27$export$682875ad09d6ca5c)(v);
    const contractMonths = Number.isFinite(Number(v.refundMonths)) && v.refundMonths != null;
    const resaleSooner = (Number(v.expectedResaleMonths) || 0) > 0 && Number(v.expectedResaleMonths) <= months;
    paragraphs.push(resaleSooner ? `Paid within ${months} months of leaving \u{2014} the unit is expected to resell by then, and the village pays within days of a sale.` : contractMonths ? `Paid within ${months} months of leaving, as the contract says.` : (0, $4633117ee929ec27$export$50343794bd888a5f)[state] != null ? `Paid within ${months} months of leaving, the ${state} limit, unless the contract says sooner.` : `Paid within ${months} months of leaving is assumed; choose the state, or enter the contract\u{2019}s months, to set it.`);
    // The old unit's fees after leaving, on the state's rule, for the wait.
    const fees = (0, $4633117ee929ec27$export$de22c25de5484f31)(v, (0, $4633117ee929ec27$export$6005e8b092eea057)(new Date()), e.refundDate);
    if (fees.total > 0.5) paragraphs.push((0, $511dfa7ed5ad5c31$export$eabd2e17c6ad2b74)(fees));
    paragraphs.push('This is what sits in net worth and the estate today. In later years the resale price grows and the fee keeps accruing to its cap, so the figure moves with them.');
    return {
        title: 'What the village would pay back today',
        subtitle: "From the terms entered \u2014 updates as you type",
        paragraphs: paragraphs,
        lines: lines,
        icon: 'village'
    };
}



/** The extra allowable amount, from the one constant, so this copy never goes stale (8 Oct 2026). */ const $5d75c6e277be5884$var$EAA_TEXT = '$' + Math.floor((0, $1abe73eeef086faf$export$e2cf792e99a08354)).toLocaleString('en-AU');
const $5d75c6e277be5884$export$a0da0398771983db = {
    home_care: {
        label: 'Support at Home',
        summary: 'Your expected contributions toward home care, cashflow after those costs, and scenarios where you change the home (for example downsizing to free up money for care).',
        summaryNonHomeowner: 'Your expected contributions toward home care and your cashflow after those costs.'
    },
    aged_care: {
        label: 'Residential aged care',
        summary: 'Selling or keeping the home, renting it, accommodation payments, and who remains in the home.',
        summaryNonHomeowner: 'Accommodation payments (a refundable deposit and/or a daily payment), the means-tested care fees, and your ongoing cashflow.'
    },
    downsize_home: {
        label: 'Downsizing',
        summary: 'Proceeds from the sale and the cost of your next home.',
        summaryNonHomeowner: "Modelled if you own a home to sell \u2014 the sale proceeds and the cost of your next home."
    },
    retirement_village: {
        label: 'Retirement village',
        summary: 'Entry, ongoing and exit costs for village living.'
    },
    granny_flat: {
        label: 'Granny flat',
        summary: 'Payments or assets transferred for your right to live there.'
    }
};
const $5d75c6e277be5884$export$4b8bbd196911e3e = {
    'home_care+aged_care': 'Many people treat one option as the main plan and the other as a backup. We show the financial comparison for whichever scenarios you choose to run.',
    'home_care+downsize_home': 'We can contrast staying in your current home with selling and moving, using the figures you enter.',
    'aged_care+downsize_home': 'Often used when a partner stays behind or equity is released before care. We model the financial outcomes you set up.'
};
const $5d75c6e277be5884$export$61269d341f6e9ed5 = {
    /*
     * THE PANEL EXPLAINS; THE FORM REPORTS (owner, 8 Oct 2026). Each card says what Centrelink does
     * with the arrangement and what the module does with it — once, here. Under the fields only
     * CONSEQUENCES appear: a gift that arose or aged out, a village unit's fate once answered. The
     * general "How this is assessed" and "What this means" boxes that used to repeat these cards
     * beneath the fields are gone.
     */ own_home: {
        title: 'Your family home',
        subtitle: 'Homeowner',
        paragraphs: [
            "Your home itself isn\u2019t counted in the Age Pension assets test \u2014 its value doesn\u2019t matter. Being a homeowner does mean your other assets (savings, super, investments) are assessed against a lower threshold than someone who doesn\u2019t own a home.",
            "If you later move into care, downsize, or rent it out, the way your home is treated changes \u2014 we model each of those paths from the details you enter."
        ]
    },
    renting: {
        title: 'Renting your home',
        subtitle: 'Non-homeowner',
        paragraphs: [
            "As a renter you don\u2019t own a home, so you\u2019re assessed under the higher non-homeowner asset limits \u2014 you can hold more in assets before your pension reduces. The rent you pay is counted in your cashflow.",
            "If you get the Age Pension and pay private rent, you may also receive Commonwealth Rent Assistance on top of your pension, which we include. It isn\u2019t paid in public housing, or usually when you rent from a family member you live with."
        ]
    },
    with_family: {
        title: 'Living with family',
        subtitle: 'Non-homeowner',
        paragraphs: [
            "Living with family without owning the home, you\u2019re generally assessed under the higher non-homeowner asset limits. Any board you pay is counted in your cashflow.",
            "If you sold a home to move in, what is left of the proceeds belongs under Assets as it stands today. Anything you gave to family belongs under Gifting with its date \u2014 the five-year rule is applied there.",
            'If you paid money or transferred assets for the right to live there, that is a granny flat arrangement with its own treatment: answer the question and the right fields appear.'
        ]
    },
    granny_flat: {
        title: 'Granny flat arrangement',
        subtitle: 'Centrelink homeowner test applies',
        paragraphs: [
            "A granny flat arrangement gives you a lifetime right to live there in exchange for money or assets you transferred. If what you paid is above the \u201Cextra allowable amount\u201D (" + $5d75c6e277be5884$var$EAA_TEXT + ') you are treated as a homeowner.',
            "Signing over the home you lived in, paying for the flat to be built, or buying a property in the family\u2019s name is taken at face value as the price of the right, whatever it is worth \u2014 no part of it is a gift. Centrelink\u2019s \u201Creasonableness test\u201D applies to cash, and to another property or other assets given on top: anything above the assessed value of the right is a gift for five years from the date the arrangement started. We work that out from your figures and show the result under the fields.",
            'Two things worth settling with a solicitor: a written agreement, which makes your right to live there enforceable if circumstances change (the family member divorces, passes away, sells, or has financial trouble) and is what Centrelink looks for; and fairness between your children, since money or property given to one can leave the others worse off and is a common cause of family disputes. Both are worth reflecting in your will.'
        ]
    },
    retirement_village: {
        title: 'Retirement village',
        subtitle: 'Homeowner status depends on your entry contribution',
        paragraphs: [
            'In a retirement village you usually hold a lease or licence, not the title. Centrelink compares your entry contribution to ' + $5d75c6e277be5884$var$EAA_TEXT + ": above it you\u2019re treated as a homeowner (the contribution is exempt); at or below it as a non-homeowner (higher asset limits, and you may get Rent Assistance on the ongoing fees). Your ongoing fees are counted in your cashflow.",
            'Where the goal is residential care, the exit terms you enter let us work out what the village pays back when you leave, when, and what the wait costs. For a couple where only one is moving, what happens to the unit decides whether anything is paid out at all.'
        ]
    },
    aged_care: {
        title: 'Residential aged care',
        subtitle: 'Already in care',
        paragraphs: [
            'For residential care we model your accommodation payment (a refundable lump sum, a daily payment, or a mix), the means-tested care fees, and the basic daily fee.',
            "If you are looking to move to another home, we compare staying put with the move: the deposit comes back within 14 days, less any retention taken so far, and goes to the new home\u2019s room first; the fees switch to the new home\u2019s on the day of the move, and the yearly and lifetime caps carry on. Moving in before 1 November 2025 keeps the earlier fee rules.",
            "How your former home is treated \u2014 kept, rented, or sold, and whether a \u201Cprotected person\u201D still lives there \u2014 changes both your pension and your care fees. We model each option."
        ]
    }
};
const $5d75c6e277be5884$export$5fcc0bb37cb5399b = {
    homeGrowthRate: "Assumed growth for long-term equity and legacy projections \u2014 not a guarantee.",
    likelyRent: 'Used if you model keeping and renting the home (for example, while in care).',
    likelyExpenses: 'Annual costs if the home is rented (rates, insurance, management, maintenance). Use Calculate to estimate.'
};
const $5d75c6e277be5884$var$LIVING_GOAL_KEYS = [
    'home_care',
    'aged_care',
    'retirement_village',
    'granny_flat',
    'downsize_home'
];
const $5d75c6e277be5884$var$TWO_GOAL_PAIRS = [
    [
        'home_care',
        'aged_care'
    ],
    [
        'home_care',
        'downsize_home'
    ],
    [
        'aged_care',
        'downsize_home'
    ]
];
function $5d75c6e277be5884$export$238ecac6af8e12b7(goals = {}) {
    return $5d75c6e277be5884$var$LIVING_GOAL_KEYS.filter((key)=>goals[key]);
}
function $5d75c6e277be5884$export$3239ad646f184963(selectedGoals) {
    const labels = selectedGoals.map((g)=>$5d75c6e277be5884$export$a0da0398771983db[g]?.label).filter((label)=>Boolean(label));
    if (labels.length === 0) return '';
    if (labels.length === 1) return labels[0];
    if (labels.length === 2) return `${labels[0]} and ${labels[1]}`;
    return `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`;
}
function $5d75c6e277be5884$var$getTwoGoalNoteKey(selectedGoals) {
    if (selectedGoals.length !== 2) return null;
    for (const pair of $5d75c6e277be5884$var$TWO_GOAL_PAIRS){
        if (pair.every((g)=>selectedGoals.includes(g))) return pair.join('+');
    }
    return null;
}
/**
 * Which partner is the one staying in the home — the one NOT entering residential care.
 *
 * Only called when `partnerRemainsInFamilyHome` is already true, so exactly one of the two is headed
 * for care. Falls back to "Your partner" rather than a blank when the name has not been entered yet.
 */ function $5d75c6e277be5884$var$whoStaysInTheHome(factFind) {
    const clientEnteringCare = (factFind.goals?.aged_care_for ?? 'client') !== 'partner';
    const stayingFirstName = clientEnteringCare ? factFind.partner?.firstName : factFind.client?.firstName;
    return String(stayingFirstName || '').trim() || 'Your partner';
}
function $5d75c6e277be5884$export$590d1311ebdc5150({ factFind: factFind }) {
    let residency = factFind.client?.currentResidency || 'own_home';
    // Derived: "living with family" + paid for a right to live there → treat as a granny-flat arrangement.
    if (residency === 'with_family' && factFind.livingWithFamily?.grannyFlatInterest === true) residency = 'granny_flat';
    const selectedGoals = $5d75c6e277be5884$export$238ecac6af8e12b7(factFind.goals || {});
    const insight = $5d75c6e277be5884$export$61269d341f6e9ed5[residency] || $5d75c6e277be5884$export$61269d341f6e9ed5.own_home;
    // Always lead with the arrangement-specific content so the panel reflects the client's actual situation.
    const paragraphs = [
        ...insight.paragraphs
    ];
    // The home being exempt is the single biggest thing driving the means-tested care fee, so it is
    // said out loud — but here, in the panel that EXPLAINS things, not in the form as a question. It
    // used to be a dropdown ("will someone remain living there?") sitting directly beneath the "what
    // rent could you get for it?" fields, which read as a contradiction and invited the wrong answer.
    // Nobody has to answer it: it follows from who the care goal is for, and moves when that moves.
    if ((0, $8eecd0af141b9afb$export$6a0c2f6602682b05)(factFind)) {
        const stayingName = $5d75c6e277be5884$var$whoStaysInTheHome(factFind);
        paragraphs.push(`${stayingName} will still be living in the home, which makes it exempt from the aged care means test for as long as that is the case. ` + `That exemption is often the largest single factor in the care fee. It comes from the care goals you set in Step 3, so if those change, this changes with them.`);
    }
    // The goals chosen are the card's subtitle; a sentence repeating them said nothing (owner, 8 Oct
    // 2026). What stays is the note for a pair of goals that are usefully compared side by side.
    if (selectedGoals.length === 0) paragraphs.push('Select your goals in Step 3 to see what we include in your projections.');
    else {
        const twoGoalKey = $5d75c6e277be5884$var$getTwoGoalNoteKey(selectedGoals);
        if (twoGoalKey && $5d75c6e277be5884$export$4b8bbd196911e3e[twoGoalKey]) paragraphs.push($5d75c6e277be5884$export$4b8bbd196911e3e[twoGoalKey]);
    }
    // Goal summaries that reference "the home" only make sense for homeowners. For every other living
    // arrangement, use the non-homeowner wording so the panel doesn't talk about selling/downsizing a home.
    const isHomeownerArrangement = residency === 'own_home';
    const goalBlocks = selectedGoals.length > 1 ? selectedGoals.map((key)=>{
        const theme = $5d75c6e277be5884$export$a0da0398771983db[key];
        const summary = !isHomeownerArrangement && theme.summaryNonHomeowner ? theme.summaryNonHomeowner : theme.summary;
        return {
            label: theme.label,
            summary: summary
        };
    }) : [];
    // Land the home exemption does not cover gets its own card, below the arrangement one. Its own
    // card rather than another paragraph because it is a DIFFERENT subject: the paragraphs above are
    // about where the client lives, this is about an asset that changes their pension and their care
    // fee. It appears only once they have answered one of the land questions yes.
    const landSection = (0, $5731a635b9eda7f9$export$25a2ea5ac2a1fbbb)(factFind);
    // A village resident's exit entitlement, line by line, live from the fields (8 Oct 2026).
    const villageSection = (0, $30388f8480cb4423$export$145bfe0a43b9b7f2)(factFind);
    return [
        {
            title: insight.title,
            subtitle: selectedGoals.length > 0 ? $5d75c6e277be5884$export$3239ad646f184963(selectedGoals) : insight.subtitle,
            paragraphs: paragraphs,
            goalsIntro: goalBlocks.length > 0 ? 'Each goal adds different details to the projections above:' : null,
            goalBlocks: goalBlocks
        },
        ...villageSection ? [
            villageSection
        ] : [],
        ...landSection ? [
            landSection
        ] : []
    ];
}


/**
 * asfaBudget.ts – ASFA Comfortable Standard budget figures (hypothetical for demonstration).
 * March Quarter 2025. Ported verbatim from frontend/src/constants/asfaBudget.js.
 */ const $898ebfdbe190c9ba$export$8b6758150468ace7 = {
    couple: {
        total: 72148,
        categories: {
            'Housing': 7800,
            'Energy': 2500,
            'Food & Groceries': 15000,
            'Clothing & Footwear': 3000,
            'Household Goods & Services': 5000,
            'Health': 8000,
            'Transport': 8500,
            'Communication': 2000,
            'Recreation': 15348,
            'Miscellaneous': 5000
        }
    },
    single: {
        total: 51278,
        categories: {
            'Housing': 6500,
            'Energy': 1800,
            'Food & Groceries': 8000,
            'Clothing & Footwear': 2500,
            'Household Goods & Services': 4000,
            'Health': 6000,
            'Transport': 6500,
            'Communication': 1500,
            'Recreation': 10478,
            'Miscellaneous': 3000
        }
    }
};


/**
 * Retirement village — state/territory consumer-protection framework.
 * Ported verbatim from frontend/src/constants/retirementVillageStateRules.js. This data isn't used
 * by the FINANCIAL modelling (that's federal, lives in the engine) — it's consumed by
 * RetirementVillageCalculations-adjacent code purely to attach the right jurisdiction's
 * buyback/recurrent-charge disclosure text to a projection result.
 */ const $cb0d223b5401e577$export$5c9ab6f574716f4e = [
    {
        code: 'NSW',
        name: 'New South Wales'
    },
    {
        code: 'VIC',
        name: 'Victoria'
    },
    {
        code: 'QLD',
        name: 'Queensland'
    },
    {
        code: 'SA',
        name: 'South Australia'
    },
    {
        code: 'WA',
        name: 'Western Australia'
    },
    {
        code: 'TAS',
        name: 'Tasmania'
    },
    {
        code: 'ACT',
        name: 'Australian Capital Territory'
    },
    {
        code: 'NT',
        name: 'Northern Territory'
    }
];
const $cb0d223b5401e577$export$74f1fe9b299acc40 = {
    NSW: {
        code: 'NSW',
        name: 'New South Wales',
        act: 'Retirement Villages Act 1999 (NSW)',
        regulator: 'NSW Fair Trading',
        regulatorUrl: 'https://www.fairtrading.nsw.gov.au/housing-and-property/retirement-villages',
        disclosureDocument: 'Disclosure Statement',
        buyback: {
            hasStatutoryTimeframe: true,
            summary: 'If your home has not re-sold, registered interest holders (a registered long-term lease with at least 50% of any capital gain) can apply for their exit entitlement after 6 months (Sydney metropolitan, the Blue Mountains, Wollongong and Newcastle) or 12 months (rest of NSW). The clock generally starts about 40 days after the home is listed or you vacate. Strata, community and company-title residents are not covered by this rule.'
        },
        recurrentChargesAfterVacating: 'Recurrent charges for general services are capped at 42 days after you permanently vacate (for registered interest holders).',
        note: 'Cooling-off period of 7 days after signing. Other exit costs (departure/deferred management fee, reinstatement, capital-loss share) are set by your contract.'
    },
    VIC: {
        code: 'VIC',
        name: 'Victoria',
        act: 'Retirement Villages Act 1986 (Vic)',
        regulator: 'Consumer Affairs Victoria',
        regulatorUrl: 'https://www.consumer.vic.gov.au/housing/retirement-villages',
        disclosureDocument: 'Disclosure Statement',
        buyback: {
            hasStatutoryTimeframe: true,
            summary: "Under Victoria\u2019s reforms, residents on a lease or licence are generally entitled to be paid their exit entitlement within about 6 months of permanently leaving, even if the home has not re-sold."
        },
        recurrentChargesAfterVacating: "Your liability for ongoing charges after permanently vacating is limited under the Act \u2014 check your contract for the exact period.",
        note: '3 clear business days cooling-off. Departure fee, reinstatement and capital-gain/loss sharing are set by your contract.'
    },
    QLD: {
        code: 'QLD',
        name: 'Queensland',
        act: 'Retirement Villages Act 1999 (Qld)',
        regulator: 'Queensland Government (Fair Trading)',
        regulatorUrl: 'https://www.qld.gov.au/housing/buying-owning-home/advice-buying-home/retirement-villages',
        disclosureDocument: 'Village Comparison Document & Prospective Costs Document',
        buyback: {
            hasStatutoryTimeframe: true,
            summary: 'If your home has not re-sold, the operator must pay your exit entitlement after 18 months from when you leave or give notice. You can choose your own real-estate agent if it is unsold after 6 months.'
        },
        recurrentChargesAfterVacating: "You stop paying recurrent (general services) charges once the resale is settled or the statutory period ends \u2014 check your contract.",
        note: 'Strong statutory protections. Note the 18-month clock typically starts only after you vacate, complete reinstatement and appoint an agent. Cooling-off period applies.'
    },
    SA: {
        code: 'SA',
        name: 'South Australia',
        act: 'Retirement Villages Act 2016 (SA)',
        regulator: 'SA Consumer and Business Services',
        regulatorUrl: 'https://www.cbs.sa.gov.au/retirement-villages',
        disclosureDocument: 'Disclosure Statement',
        buyback: {
            hasStatutoryTimeframe: true,
            summary: 'If your home has not re-sold, the operator must repay your exit entitlement 18 months after you move out or give notice.'
        },
        recurrentChargesAfterVacating: "Liability for ongoing charges after vacating is limited under the Act \u2014 check your contract for the exact period.",
        note: 'Cooling-off period applies. Departure fee, reinstatement and capital-gain/loss sharing are set by your contract.'
    },
    WA: {
        code: 'WA',
        name: 'Western Australia',
        act: 'Retirement Villages Act 1992 (WA), as amended 2024',
        regulator: 'Consumer Protection (WA)',
        regulatorUrl: 'https://www.consumerprotection.wa.gov.au/retirement-villages',
        disclosureDocument: 'Disclosure Statement',
        buyback: {
            hasStatutoryTimeframe: true,
            summary: 'Under the 2024 reforms, exit entitlements for a lease-for-life (or buyback of a strata-titled home) must generally be paid within 12 months of you permanently leaving. Operators can apply to the Commissioner for an extension in limited cases.'
        },
        recurrentChargesAfterVacating: "The Act limits ongoing charges after permanently vacating and lets you ask the operator for help with aged-care fees while you wait \u2014 check your contract.",
        note: "Reform commencement is staged from 2024\u201326. No transfer duty on a compulsory buyback. Reinstatement/refurbishment rules clarified."
    },
    TAS: {
        code: 'TAS',
        name: 'Tasmania',
        act: 'Retirement Villages Act 2004 (Tas)',
        regulator: 'Consumer, Building and Occupational Services (CBOS)',
        regulatorUrl: 'https://www.cbos.tas.gov.au/topics/housing/retirement-villages',
        disclosureDocument: 'Disclosure Statement',
        buyback: {
            hasStatutoryTimeframe: false,
            summary: "Tasmania does not set a mandatory statutory buyback timeframe \u2014 when you (or your estate) are repaid depends on when the home re-sells and on your contract. Many operators offer a voluntary buyback guarantee; check your contract."
        },
        recurrentChargesAfterVacating: "How long you keep paying ongoing charges after vacating is governed by your contract \u2014 check it carefully.",
        note: 'Disputes can go to the Director of Consumer Affairs and Fair Trading and then TASCAT. Confirm exit terms in your contract.'
    },
    ACT: {
        code: 'ACT',
        name: 'Australian Capital Territory',
        act: 'Retirement Villages Act 2012 (ACT)',
        regulator: 'Access Canberra',
        regulatorUrl: 'https://www.accesscanberra.act.gov.au/',
        disclosureDocument: 'Disclosure Statement',
        buyback: {
            hasStatutoryTimeframe: false,
            summary: "The ACT does not mandate a fixed statutory buyback timeframe \u2014 repayment timing depends on resale and your contract. Some operators offer a voluntary buyback guarantee; check your contract."
        },
        recurrentChargesAfterVacating: "How long you keep paying ongoing charges after vacating is governed by your contract \u2014 check it carefully.",
        note: 'Confirm exit-entitlement and recurrent-charge terms in your contract and with Access Canberra.'
    },
    NT: {
        code: 'NT',
        name: 'Northern Territory',
        act: 'Retirement Villages Act 1995 (NT)',
        regulator: 'NT Consumer Affairs',
        regulatorUrl: 'https://consumeraffairs.nt.gov.au/',
        disclosureDocument: 'Disclosure Statement',
        buyback: {
            hasStatutoryTimeframe: false,
            summary: "The NT does not mandate a fixed statutory buyback timeframe \u2014 repayment timing depends on resale and your contract. Some operators offer a voluntary buyback guarantee; check your contract."
        },
        recurrentChargesAfterVacating: "How long you keep paying ongoing charges after vacating is governed by your contract \u2014 check it carefully.",
        note: 'Confirm exit-entitlement and recurrent-charge terms in your contract and with NT Consumer Affairs.'
    }
};
function $cb0d223b5401e577$export$432ee5f70f8b1031(code) {
    const key = (code || '').toString().toUpperCase();
    if ($cb0d223b5401e577$export$74f1fe9b299acc40[key]) return $cb0d223b5401e577$export$74f1fe9b299acc40[key];
    return {
        code: '',
        name: 'your state or territory',
        act: "your state or territory\u2019s Retirement Villages Act",
        regulator: 'your state or territory consumer-protection regulator',
        regulatorUrl: 'https://www.australia.gov.au/',
        disclosureDocument: 'Disclosure Statement',
        buyback: {
            hasStatutoryTimeframe: false,
            summary: "Exit-entitlement (buyback) rules differ by state and territory. When you (or your estate) are repaid depends on your contract and your state\u2019s Retirement Villages Act."
        },
        recurrentChargesAfterVacating: 'How long you keep paying ongoing charges after vacating depends on your state and your contract.',
        note: "Select your state to see the rules that apply to you, and always check your village\u2019s disclosure statement and contract."
    };
}


const $77d0522707ddb581$export$e18ad1b53d14ba76 = (0, $bfa4518c9dced417$export$e18ad1b53d14ba76).map((type)=>({
        ...type,
        icon: (0, $f5fad7fcd622224a$export$e614075a23fb1335)[type.id]
    }));
const $77d0522707ddb581$export$dfcae3bc547409fc = (0, $bfa4518c9dced417$export$dfcae3bc547409fc).map((type)=>({
        ...type,
        icon: (0, $f5fad7fcd622224a$export$adac0024f8acd71)[type.id]
    }));
const $77d0522707ddb581$export$39a105507aa40371 = 5;




parcelRequire("acw62");
const $f964382955d663ef$var$Card = ({ children: children, className: className = 'bg-white/60' })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `${className} backdrop-blur-xl p-6 rounded-2xl shadow-lg shadow-gray-200/50 border border-white/80 hover:shadow-xl transition-shadow duration-300`,
        children: children
    });
var $f964382955d663ef$export$2e2bcd8739ae039 = $f964382955d663ef$var$Card;



parcelRequire("acw62");
/*
 * Headings are plain navy (owner-approved polish, 25 Oct 2026: "plain dark headings instead of
 * gradient text"). The name stays so the many call sites need not change.
 */ const $6288781efbc92679$var$GradientText = ({ children: children, className: className })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `text-brand-navy ${className || ''}`,
        children: children
    });
var $6288781efbc92679$export$2e2bcd8739ae039 = $6288781efbc92679$var$GradientText;



parcelRequire("acw62");
const $cba1229c5a28a3df$var$FormInput = ({ label: label, name: name, id: id, type: type = 'text', value: value, onChange: onChange, className: className, disabled: disabled, placeholder: placeholder })=>{
    // `id` defaults to `name` for the common case (one field per page), but callers rendering the
    // same field repeatedly per row in a list (e.g. one asset/liability among several of the same
    // shape) MUST pass a row-unique `id` — a duplicate id breaks `<label for>` (clicking a label
    // can focus the wrong row's input) and is invalid HTML regardless.
    const domId = id || name;
    const handleChange = (e)=>{
        onChange(name, e.target.value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: domId,
                className: "block text-sm font-medium text-gray-700 mb-1",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: type,
                id: domId,
                name: name,
                value: value ?? '',
                onChange: handleChange,
                className: "w-full px-4 py-2 bg-white/80 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 transition disabled:bg-gray-100 disabled:cursor-not-allowed",
                disabled: disabled,
                placeholder: placeholder
            })
        ]
    });
};
var $cba1229c5a28a3df$export$2e2bcd8739ae039 = $cba1229c5a28a3df$var$FormInput;




var $acw62 = parcelRequire("acw62");

const $6be87416fe1722b6$var$CurrencyInput = ({ label: label, name: name, value: value, onChange: onChange, className: className, placeholder: placeholder, id: id, disabled: disabled, ariaLabel: ariaLabel, testId: testId })=>{
    const [error, setError] = (0, $acw62.useState)('');
    /*
     * ALWAYS ASSOCIATE THE LABEL WITH THE FIELD (2026-08-27).
     *
     * `htmlFor={id}` with no `id` passed — which is almost every caller in the app — produced a
     * label pointing at nothing: clicking it did not focus the field, and a screen reader announced
     * an unlabelled text box on every dollar amount in the product. A generated id costs nothing and
     * fixes it everywhere at once; an explicit `id` still wins for callers that need a known one.
     */ const generatedId = (0, $acw62.useId)();
    const fieldId = id ?? generatedId;
    const displayValue = value === '' || value === undefined || value === null ? '' : (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(value));
    const handleChange = (e)=>{
        // A '%' here means the user has confused a dollar field for a percentage one — reject the
        // keystroke (the controlled value below re-renders without it) and flag the mistake rather
        // than silently coercing e.g. "50%" into $50.
        if (e.target.value.includes('%')) {
            setError('This is a dollar amount, not a percentage \u2014 remove the "%".');
            return;
        }
        setError('');
        const raw = (0, $f94e45ac645ae232$export$dc5333890dfc7d0)(e.target.value);
        onChange(raw === '' ? undefined : parseFloat(raw));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: className,
        children: [
            label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: fieldId,
                className: "block text-sm font-medium text-gray-700 mb-1",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "text",
                id: fieldId,
                name: name,
                "aria-label": ariaLabel,
                "data-testid": testId,
                value: displayValue,
                onChange: handleChange,
                placeholder: placeholder,
                disabled: disabled,
                className: "w-full px-4 py-2 bg-white/80 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 transition disabled:bg-gray-100 disabled:cursor-not-allowed"
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-1 text-sm text-red-600",
                children: error
            })
        ]
    });
};
var $6be87416fe1722b6$export$2e2bcd8739ae039 = $6be87416fe1722b6$var$CurrencyInput;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $40028fb01ea8d6cd$export$4fdc02498b0062ca(draft, value) {
    const canonical = value === '' || value === undefined || value === null ? '' : String(value);
    if (draft === null) return canonical;
    const stillMeansTheSameNumber = draft === '' ? canonical === '' : Number(draft) === Number(canonical);
    return stillMeansTheSameNumber ? draft : canonical;
}
function $40028fb01ea8d6cd$export$c30993ef38beedef(value) {
    /** The raw text being typed, or null when the field is showing the canonical value. */ const [draft, setDraft] = (0, $acw62.useState)(null);
    return {
        displayValue: $40028fb01ea8d6cd$export$4fdc02498b0062ca(draft, value),
        setDraft: /** Record what was typed. Call alongside the parent's own onChange, not instead of it. */ setDraft,
        /** Drop the draft so the canonical value shows again — wire to the input's onBlur. */ syncOnBlur: ()=>setDraft(null)
    };
}


/**
 * Plain numeric input for bare counts/terms/years — anything that is neither a dollar amount
 * (CurrencyInput) nor a percentage/rate (PercentageInput). Uses a text input rather than
 * type="number" so a stray '$' or '%' actually reaches us: either means the user has confused this
 * for a currency or percentage field, so we reject the keystroke and flag the mistake rather than
 * let the browser silently swallow it. Always parses to a number on change, unlike FormInput's
 * `type="number"` mode which only does so when the caller remembers to pass that prop.
 */ const $36fba7e03e1bb69f$var$NumberInput = ({ label: label, name: name, value: value, onChange: onChange, className: className, placeholder: placeholder, id: id, disabled: disabled })=>{
    const [error, setError] = (0, $acw62.useState)('');
    // Shows what the user is typing while they type it, so a decimal point survives — see the hook.
    const { displayValue: displayValue, setDraft: setDraft, syncOnBlur: syncOnBlur } = (0, $40028fb01ea8d6cd$export$c30993ef38beedef)(value);
    const handleChange = (e)=>{
        const raw = e.target.value;
        if (raw.includes('$')) {
            setError('This is a plain number, not a dollar amount \u2014 remove the "$".');
            return;
        }
        if (raw.includes('%')) {
            setError('This is a plain number, not a percentage \u2014 remove the "%".');
            return;
        }
        setError('');
        // Kept AFTER the rejections above, so a rejected keystroke is never held as the draft.
        setDraft(raw);
        if (raw === '') {
            onChange(undefined);
            return;
        }
        const parsed = parseFloat(raw);
        onChange(Number.isNaN(parsed) ? undefined : parsed);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: className,
        children: [
            label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: id,
                className: "block text-sm font-medium text-gray-700 mb-1",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "text",
                inputMode: "decimal",
                id: id,
                name: name,
                value: displayValue,
                onChange: handleChange,
                onBlur: syncOnBlur,
                placeholder: placeholder,
                disabled: disabled,
                className: "w-full px-4 py-2 bg-white/80 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 transition disabled:bg-gray-100 disabled:cursor-not-allowed"
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-1 text-sm text-red-600",
                children: error
            })
        ]
    });
};
var $36fba7e03e1bb69f$export$2e2bcd8739ae039 = $36fba7e03e1bb69f$var$NumberInput;




var $acw62 = parcelRequire("acw62");

/**
 * Numeric input for rates/percentages (growth rates, interest rates, franking, apportionment — the
 * percentage counterpart to CurrencyInput; see NumberInput for plain counts/years). Uses a text
 * input rather than type="number" so a stray '$' actually reaches us: that means the user has
 * confused a percentage field for a dollar one, so we reject the keystroke and flag the mistake
 * rather than let the browser silently swallow it. A trailing '%' the user types is tolerated.
 */ const $fbd6bad1410bfbf4$var$PercentageInput = ({ label: label, name: name, value: value, onChange: onChange, className: className, placeholder: placeholder, id: id, disabled: disabled })=>{
    const [error, setError] = (0, $acw62.useState)('');
    // Shows what the user is typing while they type it, so a decimal point survives — see the hook.
    const { displayValue: displayValue, setDraft: setDraft, syncOnBlur: syncOnBlur } = (0, $40028fb01ea8d6cd$export$c30993ef38beedef)(value);
    /*
     * Shown as "9%" once the field is left, the way a dollar field shows "$15,000" (owner, 15 Oct
     * 2026). While it has focus the bare number is shown, so typing and deleting behave as before; the
     * change handler already strips a '%' the user types.
     */ const [focused, setFocused] = (0, $acw62.useState)(false);
    const shownValue = !focused && displayValue !== '' ? `${displayValue}%` : displayValue;
    const handleChange = (e)=>{
        const input = e.target.value;
        if (input.includes('$')) {
            setError('This is a percentage, not a dollar amount \u2014 remove the "$".');
            return;
        }
        setError('');
        // Tolerate a trailing '%' the user tacks on, plus any stray whitespace.
        const cleaned = input.replace(/[%\s]/g, '');
        // Kept AFTER the '$' rejection above, so a rejected keystroke is never held as the draft.
        setDraft(cleaned);
        if (cleaned === '') {
            onChange(undefined);
            return;
        }
        const parsed = parseFloat(cleaned);
        onChange(Number.isNaN(parsed) ? undefined : parsed);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: className,
        children: [
            label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: id,
                className: "block text-sm font-medium text-gray-700 mb-1",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "text",
                inputMode: "decimal",
                id: id,
                name: name,
                value: shownValue,
                onChange: handleChange,
                onFocus: ()=>setFocused(true),
                onBlur: ()=>{
                    setFocused(false);
                    syncOnBlur();
                },
                placeholder: placeholder,
                disabled: disabled,
                className: "w-full px-4 py-2 bg-white/80 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 transition disabled:bg-gray-100 disabled:cursor-not-allowed"
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-1 text-sm text-red-600",
                children: error
            })
        ]
    });
};
var $fbd6bad1410bfbf4$export$2e2bcd8739ae039 = $fbd6bad1410bfbf4$var$PercentageInput;



parcelRequire("acw62");
// `id` defaults to `name`, but callers rendering the same field repeatedly per row in a list
// (e.g. one asset/liability among several of the same shape) MUST pass a row-unique `id` — a
// duplicate id breaks `<label for>` (clicking a label can focus the wrong row's select) and is
// invalid HTML regardless.
const $ebc7004069b89f4a$var$FormSelect = ({ label: label, name: name, id: id, value: value, onChange: onChange, children: children, className: className })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: className,
        children: [
            label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: id || name,
                className: "block text-sm font-medium text-gray-700 mb-1",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                id: id || name,
                name: name,
                value: value,
                onChange: (e)=>onChange(name, e.target.value),
                className: "w-full px-4 py-2 bg-white/80 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 transition disabled:bg-gray-100",
                children: children
            })
        ]
    });
var $ebc7004069b89f4a$export$2e2bcd8739ae039 = $ebc7004069b89f4a$var$FormSelect;



parcelRequire("acw62");
const $fc1b91c2abdb2b42$var$FormCheckbox = ({ label: label, name: name, checked: checked, onChange: onChange })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
        htmlFor: name,
        className: "flex items-center gap-3 p-3 bg-white rounded-lg border border-gray-200 cursor-pointer hover:border-blue-300 transition has-[:checked]:border-blue-500",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "checkbox",
                id: name,
                name: name,
                checked: !!checked,
                onChange: (e)=>onChange(name, e.target.checked),
                className: "h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-sm font-medium text-gray-800",
                children: label
            })
        ]
    });
var $fc1b91c2abdb2b42$export$2e2bcd8739ae039 = $fc1b91c2abdb2b42$var$FormCheckbox;



parcelRequire("acw62");
const $63ca312685d8e198$var$FormRadioGroup = ({ label: label, name: name, value: value, onChange: onChange, options: options })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                className: "block text-sm font-medium text-gray-700 mb-2",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex items-center gap-4",
                children: options.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        className: "flex items-center gap-2 cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "radio",
                                name: name,
                                value: opt.value,
                                checked: value === opt.value,
                                onChange: (e)=>onChange(name, e.target.value),
                                className: "h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-sm text-gray-700",
                                children: opt.label
                            })
                        ]
                    }, opt.value))
            })
        ]
    });
var $63ca312685d8e198$export$2e2bcd8739ae039 = $63ca312685d8e198$var$FormRadioGroup;




var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
const $5c0ea688f7c20200$var$CalculationTooltip = ({ title: title, data: data, children: children })=>{
    const [show, setShow] = (0, $acw62.useState)(false);
    const wrapperRef = (0, $acw62.useRef)(null);
    const tooltipRef = (0, $acw62.useRef)(null);
    const [coords, setCoords] = (0, $acw62.useState)({
        top: 0,
        left: 0
    });
    (0, $acw62.useLayoutEffect)(()=>{
        if (show && wrapperRef.current && tooltipRef.current) {
            const wrapperRect = wrapperRef.current.getBoundingClientRect();
            const tooltipRect = tooltipRef.current.getBoundingClientRect();
            const spaceRight = window.innerWidth - wrapperRect.right;
            const spaceLeft = wrapperRect.left;
            if (spaceRight < tooltipRect.width / 2) tooltipRef.current.style.left = `${window.innerWidth - tooltipRect.width - 16}px`;
            if (spaceLeft < tooltipRect.width / 2) tooltipRef.current.style.left = `16px`;
        }
    }, [
        show
    ]);
    (0, $acw62.useEffect)(()=>{
        if (show && wrapperRef.current && tooltipRef.current) {
            const rect = wrapperRef.current.getBoundingClientRect();
            const tooltipHeight = tooltipRef.current.offsetHeight || 180;
            const spaceBelow = window.innerHeight - rect.bottom;
            // Prefer below; if not enough room, show above. Then clamp so tooltip stays in viewport (no scrollbar).
            let top = spaceBelow >= tooltipHeight + 16 ? rect.bottom + 16 : rect.top - tooltipHeight - 16;
            if (top < 16) top = 16;
            if (top + tooltipHeight > window.innerHeight - 16) top = window.innerHeight - tooltipHeight - 16;
            setCoords({
                top: top,
                left: rect.left + rect.width / 2
            });
        }
    }, [
        show
    ]);
    if (!Array.isArray(data)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative",
        ref: wrapperRef,
        onMouseEnter: ()=>setShow(true),
        onMouseLeave: ()=>setShow(false),
        children: [
            children,
            show && typeof window !== 'undefined' && window.document && /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                ref: tooltipRef,
                style: {
                    position: 'fixed',
                    top: coords.top,
                    left: coords.left,
                    transform: 'translateX(-50%)',
                    zIndex: 10001,
                    width: '340px',
                    maxWidth: '90vw',
                    pointerEvents: 'auto'
                },
                className: "p-3 bg-gray-800 text-white text-xs rounded-lg shadow-lg",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "font-bold text-sm mb-2 text-blue-300",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "space-y-1",
                        children: data.map((item, index)=>{
                            let displayValue = item.value;
                            if (typeof displayValue === 'number' && !isNaN(displayValue)) displayValue = Math.round(displayValue).toLocaleString();
                            if (item.emphasis) {
                                const isDeficit = item.label === 'Deficit funded from';
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: `mt-2 pt-2 border-t border-gray-600 ${isDeficit ? 'bg-red-900/20 rounded px-2 py-1' : 'bg-green-900/20 rounded px-2 py-1'}`,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "text-[10px] uppercase tracking-wide text-gray-300 mb-0.5",
                                            children: item.label
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `font-semibold ${isDeficit ? 'text-red-300' : 'text-green-300'}`,
                                            children: displayValue
                                        })
                                    ]
                                }, `emphasis-${item.label}-${index}`);
                            }
                            return item.label.startsWith('---') ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                className: "border-gray-600 my-1"
                            }, `hr-${item.label}-${index}`) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-gray-400",
                                        children: [
                                            item.label,
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-mono font-semibold",
                                        children: displayValue
                                    })
                                ]
                            }, `row-${item.label}-${index}`);
                        })
                    })
                ]
            }), document.body)
        ]
    });
};
var $5c0ea688f7c20200$export$2e2bcd8739ae039 = $5c0ea688f7c20200$var$CalculationTooltip;




var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/*
 * THE FIGURE IS THE TRIGGER (owner, 24 Oct 2026, advice-document review item 8). The year-by-year tables
 * used to put a small circled "?" beside every figure; now the figure itself carries a faint dotted
 * underline and opens its breakdown on hover, keyboard focus or a tap (a second tap, Escape, leaving it
 * or tapping elsewhere closes it). The breakdown is the app's navy panel with a pointer toward the
 * figure, labels on the left and figures right-aligned. Same rows as CalculationTooltip, same words.
 */ const $6bea2c523253f544$var$NAVY = '#0F2A4A';
const $6bea2c523253f544$var$GAP = 10;
const $6bea2c523253f544$var$MARGIN = 16;
const $6bea2c523253f544$export$f0cf907bc11408b4 = {
    textDecorationLine: 'underline',
    textDecorationStyle: 'dotted',
    textDecorationColor: '#94a3b8',
    textDecorationThickness: '1.5px',
    textUnderlineOffset: '4px',
    cursor: 'help'
};
/** A row's figure as it is shown: numbers rounded with thousands separators, words as written. */ function $6bea2c523253f544$var$shown(value) {
    return typeof value === 'number' && !isNaN(value) ? Math.round(value).toLocaleString() : value;
}
function $6bea2c523253f544$export$cc89c24534fba0cf({ id: id, title: title, data: data, style: style, arrow: arrow, panelRef: panelRef }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: panelRef,
        id: id,
        role: "tooltip",
        className: "figure-tip-panel",
        style: {
            position: 'relative',
            background: $6bea2c523253f544$var$NAVY,
            color: '#ffffff',
            borderRadius: 12,
            boxShadow: '0 12px 32px rgba(15, 42, 74, 0.28), 0 2px 6px rgba(15, 42, 74, 0.18)',
            padding: '12px 14px',
            width: 'max-content',
            minWidth: 240,
            maxWidth: 'min(360px, 90vw)',
            fontSize: 12,
            lineHeight: 1.45,
            ...style
        },
        children: [
            arrow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                "aria-hidden": "true",
                style: {
                    position: 'absolute',
                    left: arrow.left - 5,
                    top: arrow.side === 'top' ? -5 : undefined,
                    bottom: arrow.side === 'bottom' ? -5 : undefined,
                    width: 10,
                    height: 10,
                    background: $6bea2c523253f544$var$NAVY,
                    transform: 'rotate(45deg)'
                }
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    color: '#7dd3fc',
                    fontWeight: 700,
                    fontSize: 13,
                    marginBottom: 8
                },
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: 'minmax(0, 1fr) auto',
                    columnGap: 16,
                    rowGap: 4
                },
                children: data.map((item, index)=>{
                    const value = $6bea2c523253f544$var$shown(item.value);
                    if (item.emphasis) {
                        const isDeficit = item.label === 'Deficit funded from';
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                gridColumn: '1 / -1',
                                marginTop: 6,
                                padding: '6px 8px',
                                borderRadius: 6,
                                borderTop: '1px solid rgba(255, 255, 255, 0.18)',
                                background: isDeficit ? 'rgba(127, 29, 29, 0.25)' : 'rgba(20, 83, 45, 0.25)'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontSize: 10,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.04em',
                                        color: '#cbd5e1',
                                        marginBottom: 2
                                    },
                                    children: item.label
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontWeight: 600,
                                        color: isDeficit ? '#fca5a5' : '#86efac'
                                    },
                                    children: value
                                })
                            ]
                        }, `emphasis-${item.label}-${index}`);
                    }
                    if (item.label.startsWith('---')) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        style: {
                            gridColumn: '1 / -1',
                            border: 0,
                            borderTop: '1px solid rgba(255, 255, 255, 0.18)',
                            margin: '4px 0'
                        }
                    }, `hr-${item.label}-${index}`);
                    // A sentence in place of a figure (a "Note" row) reads under its label rather than squeezed beside it.
                    if (typeof value === 'string' && value.length > 28 && /[a-z]{3}/i.test(value)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            gridColumn: '1 / -1'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    color: '#cbd5e1'
                                },
                                children: [
                                    item.label,
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontWeight: 600
                                },
                                children: value
                            })
                        ]
                    }, `row-${item.label}-${index}`);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    color: '#cbd5e1'
                                },
                                children: [
                                    item.label,
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    whiteSpace: 'nowrap',
                                    textAlign: 'right',
                                    fontVariantNumeric: 'tabular-nums',
                                    fontWeight: 600
                                },
                                children: value
                            })
                        ]
                    }, `row-${item.label}-${index}`);
                })
            })
        ]
    });
}
function $6bea2c523253f544$export$2e2bcd8739ae039({ title: title, data: data, className: className = '', children: children }) {
    const id = (0, $acw62.useId)();
    const [open, setOpen] = (0, $acw62.useState)(false);
    const triggerRef = (0, $acw62.useRef)(null);
    const panelRef = (0, $acw62.useRef)(null);
    // A tap focuses the figure as well as clicking it; the click decides, so the focus must not open it first.
    const pointerRef = (0, $acw62.useRef)(null);
    const [place, setPlace] = (0, $acw62.useState)(null);
    const close = (0, $acw62.useCallback)(()=>{
        setOpen(false);
        setPlace(null);
    }, []);
    // Below the figure when there is room, otherwise above; kept inside the window with the pointer on the figure.
    (0, $acw62.useLayoutEffect)(()=>{
        if (!open || !triggerRef.current || !panelRef.current) return;
        const t = triggerRef.current.getBoundingClientRect();
        const p = panelRef.current.getBoundingClientRect();
        const below = window.innerHeight - t.bottom >= p.height + $6bea2c523253f544$var$GAP + $6bea2c523253f544$var$MARGIN || t.top < p.height + $6bea2c523253f544$var$GAP + $6bea2c523253f544$var$MARGIN;
        let top = below ? t.bottom + $6bea2c523253f544$var$GAP : t.top - p.height - $6bea2c523253f544$var$GAP;
        top = Math.max($6bea2c523253f544$var$MARGIN, Math.min(top, window.innerHeight - p.height - $6bea2c523253f544$var$MARGIN));
        const centre = t.left + t.width / 2;
        const left = Math.max($6bea2c523253f544$var$MARGIN, Math.min(centre - p.width / 2, window.innerWidth - p.width - $6bea2c523253f544$var$MARGIN));
        const arrowLeft = Math.max(16, Math.min(centre - left, p.width - 16));
        setPlace({
            top: top,
            left: left,
            arrow: {
                side: below ? 'top' : 'bottom',
                left: arrowLeft
            }
        });
    }, [
        open
    ]);
    // Escape, or a tap anywhere else, closes it; so does the page scrolling away under it.
    (0, $acw62.useEffect)(()=>{
        if (!open) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') close();
        };
        const onDown = (e)=>{
            const target = e.target;
            if (target && (triggerRef.current?.contains(target) || panelRef.current?.contains(target))) return;
            close();
        };
        document.addEventListener('keydown', onKey);
        document.addEventListener('pointerdown', onDown);
        window.addEventListener('scroll', close, true);
        window.addEventListener('resize', close);
        return ()=>{
            document.removeEventListener('keydown', onKey);
            document.removeEventListener('pointerdown', onDown);
            window.removeEventListener('scroll', close, true);
            window.removeEventListener('resize', close);
        };
    }, [
        open,
        close
    ]);
    if (!Array.isArray(data)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: className,
        children: children
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                ref: triggerRef,
                tabIndex: 0,
                "aria-describedby": open ? id : undefined,
                className: `figure-tip ${className}`.trim(),
                style: $6bea2c523253f544$export$f0cf907bc11408b4,
                onPointerEnter: (e)=>{
                    if (e.pointerType === 'mouse') setOpen(true);
                },
                onPointerLeave: (e)=>{
                    if (e.pointerType === 'mouse') close();
                },
                onPointerDown: (e)=>{
                    pointerRef.current = e.pointerType;
                },
                onFocus: ()=>{
                    if (!pointerRef.current) setOpen(true);
                },
                onBlur: ()=>{
                    pointerRef.current = null;
                    close();
                },
                onClick: ()=>{
                    const kind = pointerRef.current;
                    pointerRef.current = null;
                    if (kind && kind !== 'mouse') {
                        if (open) close();
                        else setOpen(true);
                    }
                },
                onKeyDown: (e)=>{
                    if (e.key === 'Escape') close();
                },
                children: children
            }),
            open && typeof document !== 'undefined' && /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6bea2c523253f544$export$cc89c24534fba0cf, {
                id: id,
                panelRef: panelRef,
                title: title,
                data: data,
                arrow: place?.arrow ?? null,
                style: {
                    position: 'fixed',
                    top: place?.top ?? 0,
                    left: place?.left ?? 0,
                    zIndex: 10001,
                    // Measured first, then shown where it fits.
                    visibility: place ? 'visible' : 'hidden'
                }
            }), document.body)
        ]
    });
}


/**
 * The one help device on a form field: a dotted "what's this?" beside the label that opens a small
 * card, on hover or on tap.
 *
 * WHY THIS SHAPE (owner, 22 and 24 Sep 2026). Question-mark icons "look a bit ugly", and the
 * in-place expansion the narrative uses — right for prose — pushed a two-column form apart when
 * opened beside a label ("this looks crap"). A form field wants a tooltip: it floats over the page,
 * it moves nothing, and it closes when the pointer leaves. So the trigger is words, not an icon, and
 * the card is the app's own surface — white, a hairline border, a soft shadow — not a black bubble.
 *
 * Hover opens it on a desktop; a tap toggles it on the iPads advisers demo on. It flips above the
 * trigger when there is no room below, and it is rendered through a portal so no `overflow` on an
 * ancestor can clip it.
 */ 

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
const $746196baef5db40b$var$CARD_WIDTH = 300;
const $746196baef5db40b$var$InfoIcon = ({ text: text, children: children, label: label = "what's this?", className: className = '' })=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [pinned, setPinned] = (0, $acw62.useState)(false);
    const triggerRef = (0, $acw62.useRef)(null);
    const cardRef = (0, $acw62.useRef)(null);
    const [pos, setPos] = (0, $acw62.useState)({
        top: 0,
        left: 0,
        above: false
    });
    const id = (0, $acw62.useId)();
    (0, $acw62.useLayoutEffect)(()=>{
        if (!open || !triggerRef.current) return;
        const r = triggerRef.current.getBoundingClientRect();
        const cardH = cardRef.current?.offsetHeight ?? 120;
        const vw = window.innerWidth;
        const left = Math.min(Math.max(12, r.left + r.width / 2 - $746196baef5db40b$var$CARD_WIDTH / 2), vw - $746196baef5db40b$var$CARD_WIDTH - 12);
        const roomBelow = window.innerHeight - r.bottom;
        const above = roomBelow < cardH + 16 && r.top > cardH + 16;
        setPos({
            top: above ? r.top - 8 : r.bottom + 8,
            left: left,
            above: above
        });
    }, [
        open
    ]);
    // A pinned (tapped-open) card closes on a tap anywhere else, or on Escape.
    (0, $acw62.useEffect)(()=>{
        if (!pinned) return undefined;
        const onDown = (e)=>{
            const t = e.target;
            if (triggerRef.current?.contains(t) || cardRef.current?.contains(t)) return;
            setPinned(false);
            setOpen(false);
        };
        const onKey = (e)=>{
            if (e.key === 'Escape') {
                setPinned(false);
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', onDown);
        document.addEventListener('touchstart', onDown);
        document.addEventListener('keydown', onKey);
        return ()=>{
            document.removeEventListener('mousedown', onDown);
            document.removeEventListener('touchstart', onDown);
            document.removeEventListener('keydown', onKey);
        };
    }, [
        pinned
    ]);
    const canPortal = typeof window !== 'undefined' && !!window.document;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                ref: triggerRef,
                type: "button",
                "aria-describedby": open ? id : undefined,
                "aria-expanded": open,
                onMouseEnter: ()=>setOpen(true),
                onMouseLeave: ()=>{
                    if (!pinned) setOpen(false);
                },
                onFocus: ()=>setOpen(true),
                onBlur: ()=>{
                    if (!pinned) setOpen(false);
                },
                onClick: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    const next = !pinned;
                    setPinned(next);
                    setOpen(next || open);
                },
                className: `ml-1.5 inline-flex items-center whitespace-nowrap align-baseline text-[12px] font-semibold text-blue-700 underline decoration-dotted decoration-blue-400 underline-offset-[3px] hover:text-blue-900 hover:decoration-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-300 rounded-sm ${className}`,
                children: label
            }),
            open && canPortal && /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: cardRef,
                id: id,
                role: "tooltip",
                style: {
                    position: 'fixed',
                    top: pos.top,
                    left: pos.left,
                    width: $746196baef5db40b$var$CARD_WIDTH,
                    transform: pos.above ? 'translateY(-100%)' : undefined,
                    zIndex: 10001
                },
                className: "rounded-xl border border-slate-200 bg-white p-3.5 text-[13px] leading-relaxed text-slate-700 shadow-xl shadow-slate-900/10",
                onMouseEnter: ()=>setOpen(true),
                onMouseLeave: ()=>{
                    if (!pinned) setOpen(false);
                },
                children: typeof text === 'string' ? text : children
            }), document.body)
        ]
    });
};
var $746196baef5db40b$export$2e2bcd8739ae039 = $746196baef5db40b$var$InfoIcon;



parcelRequire("acw62");


const $2a40d28b08feb5cc$var$SummaryRow = ({ label: label, value: value, breakdown: breakdown })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex justify-between items-center text-sm border-b border-gray-700 pb-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c0ea688f7c20200$export$2e2bcd8739ae039), {
                title: `${label} Calculation`,
                data: breakdown,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: `flex items-center gap-1 text-gray-400 ${breakdown ? 'cursor-help underline decoration-dotted decoration-gray-500 underline-offset-2' : ''}`,
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "font-semibold text-gray-200",
                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(value)
            })
        ]
    });
var $2a40d28b08feb5cc$export$2e2bcd8739ae039 = $2a40d28b08feb5cc$var$SummaryRow;



parcelRequire("acw62");


parcelRequire("acw62");
/**
 * Badge — small status/label pill. One flat, soft treatment for every tone so badges
 * stop mixing gradient pills with flat pills on the same screen.
 *
 * tone: 'neutral' | 'info' | 'positive' | 'warning' | 'danger'
 * size: 'sm' | 'md'
 * dot:  show a leading status dot in the tone colour.
 */ const $d137e5221e5cfba5$var$TONES = {
    neutral: {
        chip: 'bg-slate-100 text-slate-700 ring-slate-200',
        dot: 'bg-slate-400'
    },
    info: {
        chip: 'bg-blue-50 text-blue-700 ring-blue-100',
        dot: 'bg-blue-500'
    },
    positive: {
        chip: 'bg-emerald-50 text-emerald-700 ring-emerald-100',
        dot: 'bg-emerald-500'
    },
    warning: {
        chip: 'bg-amber-50 text-amber-800 ring-amber-100',
        dot: 'bg-amber-500'
    },
    danger: {
        chip: 'bg-red-50 text-red-700 ring-red-100',
        dot: 'bg-red-500'
    }
};
const $d137e5221e5cfba5$var$SIZES = {
    sm: 'text-[11px] px-2 py-0.5 gap-1',
    md: 'text-xs px-2.5 py-1 gap-1.5'
};
const $d137e5221e5cfba5$var$Badge = ({ tone: tone = 'neutral', size: size = 'md', dot: dot = false, className: className = '', children: children })=>{
    const t = $d137e5221e5cfba5$var$TONES[tone] || $d137e5221e5cfba5$var$TONES.neutral;
    const s = $d137e5221e5cfba5$var$SIZES[size] || $d137e5221e5cfba5$var$SIZES.md;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: `inline-flex items-center font-semibold rounded-full ring-1 ring-inset ${t.chip} ${s} ${className}`,
        children: [
            dot && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: `w-1.5 h-1.5 rounded-full ${t.dot}`
            }),
            children
        ]
    });
};
var $d137e5221e5cfba5$export$2e2bcd8739ae039 = $d137e5221e5cfba5$var$Badge;


const $9b5fe5727b69e005$var$FeeExplanationAccordion = ({ icon: Icon, title: title, summary: summary, details: details, isOpen: isOpen, onToggle: onToggle, applies: applies })=>{
    const getStatus = ()=>{
        if (applies === null) return null;
        if (applies === 'optional') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d137e5221e5cfba5$export$2e2bcd8739ae039), {
            tone: "info",
            dot: true,
            children: "Optional"
        });
        if (applies) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d137e5221e5cfba5$export$2e2bcd8739ae039), {
            tone: "positive",
            dot: true,
            children: "May Apply to You"
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d137e5221e5cfba5$export$2e2bcd8739ae039), {
            tone: "neutral",
            dot: true,
            children: "May Not Apply"
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `group bg-white rounded-2xl border-2 transition-all duration-300 overflow-hidden ${isOpen ? 'border-blue-300 shadow-xl shadow-blue-100/50' : 'border-gray-200 shadow-md hover:shadow-lg hover:border-blue-200'}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                onClick: onToggle,
                className: "w-full text-left p-6 md:p-8 flex items-start gap-5 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-2xl",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `flex-shrink-0 w-14 h-14 rounded-xl flex items-center justify-center transition-all duration-300 ${isOpen ? 'bg-brand-navy text-white shadow-lg shadow-blue-500/30 scale-110' : 'bg-white border border-slate-200 text-blue-600 '}`,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                            className: `w-7 h-7 transition-transform duration-300 ${isOpen ? 'scale-110' : ''}`
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex-1 min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-start justify-between gap-4 mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: `text-xl md:text-2xl font-bold transition-colors duration-300 ${isOpen ? 'text-blue-700' : 'text-gray-800 group-hover:text-blue-600'}`,
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-3 flex-shrink-0",
                                        children: [
                                            getStatus(),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                className: `w-6 h-6 text-gray-400 transition-all duration-300 ${isOpen ? 'rotate-180 text-blue-600' : 'group-hover:text-gray-600'}`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-base text-gray-600 leading-relaxed pr-4",
                                children: summary
                            })
                        ]
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "px-6 md:px-8 pb-6 md:pb-8 pl-19 md:pl-24",
                style: {
                    animation: 'fadeIn 0.3s ease-in-out'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("style", {
                        children: `
                        @keyframes fadeIn {
                            from { opacity: 0; transform: translateY(-10px); }
                            to { opacity: 1; transform: translateY(0); }
                        }
                    `
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "pt-4 border-t border-gray-200",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[11px] font-semibold tracking-wider text-slate-400 uppercase mb-3",
                                children: "The detail \u2014 optional"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "prose prose-sm max-w-none text-gray-700",
                                children: details
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $9b5fe5727b69e005$export$2e2bcd8739ae039 = $9b5fe5727b69e005$var$FeeExplanationAccordion;



parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e71d8988c230db1b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 17h6v-6",
            key: "t6n2it"
        }
    ],
    [
        "path",
        {
            d: "m22 17-8.5-8.5-5 5L2 7",
            key: "x473p"
        }
    ]
];
const $e71d8988c230db1b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("trending-down", $e71d8988c230db1b$export$3efd853dbb351e94);




/**
 * ImpactMetric — the hero results number (Age Pension, Cash Flow, Net Worth, Legacy).
 *
 * Redesigned (X4 in docs/UI_UX_HERO_PATH_AUDIT.md) to show the Before -> After story rather than only
 * the "after" value: muted before figure, arrow, bold after figure, and a clear signed delta with
 * direction + colour. White card on the canvas with a soft shadow so it reads as a primary surface.
 */ const $40c3129e5e42aeff$var$ImpactMetric = ({ title: title, subtitle: subtitle, beforeValue: beforeValue, afterValue: afterValue, isLegacy: isLegacy, legacyCaption: legacyCaption, breakdown: breakdown, layout: layout = 'card' })=>{
    const baselineOnly = beforeValue == null;
    const difference = afterValue - (beforeValue ?? afterValue);
    const isFlat = Math.round(difference) === 0;
    const isPositive = difference >= 0;
    const Icon = isPositive ? (0, $c9921f4f81a419f0$export$2e2bcd8739ae039) : (0, $e71d8988c230db1b$export$2e2bcd8739ae039);
    const deltaColor = isFlat ? 'text-slate-400' : isPositive ? 'text-emerald-600' : 'text-rose-600';
    if (layout === 'row') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-baseline justify-between gap-3 py-2.5 border-b border-slate-100 last:border-b-0",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "min-w-0 flex-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "flex items-start gap-1 text-[12px] font-bold uppercase tracking-wide text-slate-600",
                        children: breakdown ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c0ea688f7c20200$export$2e2bcd8739ae039), {
                            title: `${title} Breakdown`,
                            data: breakdown,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "cursor-help underline decoration-dotted decoration-slate-400 underline-offset-2",
                                children: title
                            })
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: title
                        })
                    }),
                    subtitle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "mt-0.5 block text-[13px] leading-snug text-slate-500",
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "shrink-0 text-right",
                children: [
                    !baselineOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "block text-[13px] tabular-nums text-slate-500",
                        children: [
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(beforeValue),
                            " \u2192"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "block text-lg font-bold leading-tight tabular-nums text-slate-900",
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(afterValue)
                    }),
                    !baselineOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: `flex items-center justify-end gap-1 text-[13px] font-semibold tabular-nums ${deltaColor}`,
                        children: [
                            !isFlat && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                size: 12,
                                className: "flex-shrink-0"
                            }),
                            isFlat ? 'No change' : `${isPositive ? '+' : ''}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(difference)}`,
                            (isLegacy || legacyCaption) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-normal text-slate-400",
                                children: legacyCaption ?? 'vs today'
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return(/* EVERY ROW LINES UP WITH ITS NEIGHBOUR'S (owner-caught, 2026-08-26: "get numbered rows to
           match — it looks poorly done"). Side-by-side tiles only read as a comparison when the two
           headline figures sit on the same line, and two things broke that:

             1. the TITLE wrapped to two lines in one tile and one in the other ("Net Worth (Today)"
                beside "Legacy Estimate"), pushing everything below it down a line; and
             2. the before-arrow-after row wrapped only when the numbers happened to be wide enough,
                so "$27,830 -> $27,830" became two lines while "$830 -> $830" stayed one.

           Both are removed at the source rather than patched with a min-height guess. Title and
           subtitle each occupy a FIXED two lines (clamped, so long copy cannot push past it), and
           the figures no longer wrap by accident: the before value always sits on its own muted
           line above the hero number. The skeleton is therefore identical in every tile whatever
           the content, which also means it holds WITHOUT the parent grid having to cooperate - so
           it is right everywhere ImpactMetric is used, not only where someone remembered. */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-white rounded-2xl border border-slate-200/70 shadow-card p-4 text-left h-full flex flex-col",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex min-h-[2rem] items-start gap-1 text-xs font-semibold uppercase tracking-wide text-slate-500",
                children: breakdown ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c0ea688f7c20200$export$2e2bcd8739ae039), {
                    title: `${title} Breakdown`,
                    data: breakdown,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "line-clamp-2 cursor-help underline decoration-dotted decoration-slate-400 underline-offset-2",
                        children: title
                    })
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "line-clamp-2",
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-0.5 line-clamp-2 min-h-[2rem] text-xs font-normal normal-case tracking-normal text-slate-400",
                children: subtitle ?? '\u00a0'
            }),
            !baselineOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-1 flex items-center gap-1 text-sm text-slate-400",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tabular-nums",
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(beforeValue)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                        size: 13,
                        className: "flex-shrink-0 text-slate-300"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-2xl font-bold text-slate-900 tabular-nums",
                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(afterValue)
            }),
            !baselineOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `mt-auto pt-1 flex items-center gap-1 text-sm font-semibold ${deltaColor}`,
                children: [
                    !isFlat && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                        size: 15,
                        className: "flex-shrink-0"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tabular-nums",
                        children: isFlat ? 'No change' : `${isPositive ? '+' : ''}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(difference)}`
                    }),
                    (isLegacy || legacyCaption) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-xs font-normal text-slate-400 ml-1",
                        children: legacyCaption ?? 'vs today'
                    })
                ]
            })
        ]
    }));
};
var $40c3129e5e42aeff$export$2e2bcd8739ae039 = $40c3129e5e42aeff$var$ImpactMetric;



parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f36710bd138be5d0$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
];
const $f36710bd138be5d0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-check", $f36710bd138be5d0$export$3efd853dbb351e94);


/**
 * InsightCard — the single "Tier A" insight surface for educational callouts.
 *
 * Replaces the legacy flat-pastel boxes (bg-amber-50 / bg-blue-50 + thin border). The card surface
 * stays white with a soft shadow; tone drives ONLY the accent rail + icon colour, so colour reads as
 * a signal rather than wallpaper. This is the shared primitive referenced as X3 in
 * docs/UI_UX_HERO_PATH_AUDIT.md. (The live "What's happening?" narrative panel is a separate piece.)
 *
 * Props:
 *   tone     'info' | 'caution' | 'positive' | 'neutral'  (default 'info')
 *   heading  optional bold heading line
 *   icon     optional lucide icon component to override the tone default
 *   children body content
 */ const $6bc32c6ef2e03125$var$TONES = {
    info: {
        rail: 'border-l-brand-blue',
        icon: 'text-brand-blue',
        chip: 'bg-blue-50',
        Icon: (0, $e52b122f04c04d7d$export$2e2bcd8739ae039)
    },
    caution: {
        rail: 'border-l-amber-400',
        icon: 'text-amber-500',
        chip: 'bg-amber-50',
        Icon: (0, $00824d397ec63c04$export$2e2bcd8739ae039)
    },
    positive: {
        rail: 'border-l-emerald-400',
        icon: 'text-emerald-500',
        chip: 'bg-emerald-50',
        Icon: (0, $f36710bd138be5d0$export$2e2bcd8739ae039)
    },
    neutral: {
        rail: 'border-l-slate-300',
        icon: 'text-slate-500',
        chip: 'bg-slate-100',
        Icon: (0, $e57d6b071418ede9$export$2e2bcd8739ae039)
    }
};
const $6bc32c6ef2e03125$var$InsightCard = ({ tone: tone = 'info', heading: heading, icon: icon, children: children, className: className = '' })=>{
    const t = $6bc32c6ef2e03125$var$TONES[tone] || $6bc32c6ef2e03125$var$TONES.info;
    const Icon = icon || t.Icon;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `bg-white rounded-2xl border border-slate-200/70 border-l-4 ${t.rail} shadow-card p-5 ${className}`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex items-start gap-3",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: `flex-shrink-0 w-9 h-9 rounded-xl ${t.chip} ${t.icon} flex items-center justify-center`,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                        size: 18,
                        strokeWidth: 2.2
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0 flex-1",
                    children: [
                        heading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm font-semibold text-slate-900 mb-1",
                            children: heading
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-sm leading-relaxed text-slate-600",
                            children: children
                        })
                    ]
                })
            ]
        })
    });
};
var $6bc32c6ef2e03125$export$2e2bcd8739ae039 = $6bc32c6ef2e03125$var$InsightCard;



parcelRequire("acw62");


const $dce351ee2283539a$var$AllocationInput = ({ icon: Icon, label: label, name: name, value: value, onChange: onChange, max: max, disabled: disabled, tooltip: tooltip })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: "block text-sm font-medium text-gray-700 mb-0.5 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                        size: 16,
                        className: "mr-2 text-gray-600"
                    }),
                    " ",
                    label,
                    " ",
                    tooltip && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                        text: tooltip
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "range",
                        min: "0",
                        max: max,
                        value: value || 0,
                        onChange: (e)=>onChange(name, parseFloat(e.target.value) || 0),
                        className: "w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-600 disabled:opacity-50",
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "w-40 shrink-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                            value: value ?? '',
                            onChange: (v)=>onChange(name, v),
                            placeholder: "0",
                            disabled: disabled,
                            className: ""
                        })
                    })
                ]
            })
        ]
    });
var $dce351ee2283539a$export$2e2bcd8739ae039 = $dce351ee2283539a$var$AllocationInput;




var $acw62 = parcelRequire("acw62");
/**
 * Button — the single source of truth for actionable controls across AgedCareWise.
 *
 * Why this exists: buttons were hand-rolled per screen, so the same action could be
 * blue/teal on one card, green on another, purple on a third. This primitive fixes the
 * visual language so hierarchy (not colour roulette) tells the user what matters.
 *
 * Hierarchy model — pick by ROLE, not by taste:
 *   primary    one per context. The main thing we want the user to do. Solid brand blue.
 *   brand      kept as a name for older call sites; since 25 Oct 2026 the same solid blue as primary
 *              (owner-approved polish: one solid blue for the main button on every screen).
 *   secondary  supporting actions sitting next to a primary. White + slate border.
 *   ghost      low-emphasis / tertiary (Back, Cancel, inline toggles). Transparent.
 *   success    kept as a name for older call sites; solid blue too — green now means only "Chosen".
 *   danger     destructive (Delete).
 *
 * Everything else (radius, weight, focus ring, transition, disabled, icon spacing, sizing)
 * is standardised here so it can never drift again.
 */ const $51ba5b1d72823edd$var$VARIANTS = {
    primary: 'bg-blue-600 text-white shadow-sm hover:bg-blue-700 focus-visible:ring-blue-500/50',
    brand: 'bg-blue-600 text-white shadow-sm hover:bg-blue-700 focus-visible:ring-blue-500/50',
    secondary: 'bg-white text-slate-700 border border-slate-300 shadow-sm hover:bg-slate-50 hover:border-slate-400 focus-visible:ring-slate-400/50',
    ghost: 'bg-transparent text-slate-600 hover:bg-slate-100 hover:text-slate-900 focus-visible:ring-slate-400/50',
    success: 'bg-blue-600 text-white shadow-sm hover:bg-blue-700 focus-visible:ring-blue-500/50',
    danger: 'bg-white text-red-600 border border-red-200 shadow-sm hover:bg-red-50 hover:border-red-300 focus-visible:ring-red-500/40'
};
const $51ba5b1d72823edd$var$SIZES = {
    sm: 'h-9 px-3.5 text-sm gap-1.5 rounded-lg',
    md: 'h-11 px-5 text-sm gap-2 rounded-lg',
    lg: 'h-12 px-7 text-base gap-2 rounded-xl'
};
const $51ba5b1d72823edd$var$ICON_SIZE = {
    sm: 16,
    md: 18,
    lg: 20
};
const $51ba5b1d72823edd$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Button({ as: as = 'button', variant: variant = 'primary', size: size = 'md', icon: Icon, iconRight: IconRight, fullWidth: fullWidth = false, className: className = '', children: children, type: type, ...props }, ref) {
    const Component = as;
    const v = $51ba5b1d72823edd$var$VARIANTS[variant] || $51ba5b1d72823edd$var$VARIANTS.primary;
    const s = $51ba5b1d72823edd$var$SIZES[size] || $51ba5b1d72823edd$var$SIZES.md;
    const iconPx = $51ba5b1d72823edd$var$ICON_SIZE[size] || $51ba5b1d72823edd$var$ICON_SIZE.md;
    const classes = [
        'inline-flex items-center justify-center font-semibold tracking-tight whitespace-nowrap',
        'transition-all duration-200 select-none',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1',
        'disabled:opacity-50 disabled:pointer-events-none',
        v,
        s,
        fullWidth ? 'w-full' : '',
        className
    ].filter(Boolean).join(' ');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ref: ref,
        className: classes,
        type: Component === 'button' ? type || 'button' : type,
        ...props,
        children: [
            Icon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                size: iconPx,
                strokeWidth: 2.2,
                className: "shrink-0"
            }),
            children,
            IconRight && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(IconRight, {
                size: iconPx,
                strokeWidth: 2.2,
                className: "shrink-0"
            })
        ]
    });
});
var $51ba5b1d72823edd$export$2e2bcd8739ae039 = $51ba5b1d72823edd$var$Button;




parcelRequire("acw62");
/**
 * IconTile — the rounded icon "chip" that sits next to headings and in cards.
 *
 * Standardises size, radius, shadow and palette so chips stop drifting between
 * blue→indigo, blue→blue, purple→pink, amber→orange at random saturations.
 *
 * variant:
 *   solid  saturated gradient tile + white icon — for headers / marquee moments.
 *   soft   tinted background + coloured icon — for inline / in-card use (calmer).
 * tone: 'brand' | 'violet' | 'emerald' | 'amber' | 'slate'
 * size: 'sm' | 'md' | 'lg'
 */ const $6f7020238dfb168a$var$TONES = {
    brand: {
        solid: 'bg-brand-navy',
        soft: 'bg-blue-50 text-blue-600'
    },
    violet: {
        solid: 'from-violet-500 to-purple-600 shadow-violet-500/25',
        soft: 'bg-violet-50 text-violet-600'
    },
    emerald: {
        solid: 'from-emerald-500 to-teal-600 shadow-emerald-500/25',
        soft: 'bg-emerald-50 text-emerald-600'
    },
    amber: {
        solid: 'from-amber-400 to-orange-500 shadow-amber-500/25',
        soft: 'bg-amber-50 text-amber-600'
    },
    slate: {
        solid: 'from-slate-500 to-slate-600 shadow-slate-500/20',
        soft: 'bg-slate-100 text-slate-600'
    }
};
const $6f7020238dfb168a$var$SIZES = {
    sm: {
        box: 'w-9 h-9 rounded-lg',
        icon: 18
    },
    md: {
        box: 'w-11 h-11 rounded-xl',
        icon: 22
    },
    lg: {
        box: 'w-12 h-12 rounded-xl',
        icon: 26
    }
};
const $6f7020238dfb168a$var$IconTile = ({ icon: Icon, tone: tone = 'brand', variant: variant = 'solid', size: size = 'md', className: className = '' })=>{
    const t = $6f7020238dfb168a$var$TONES[tone] || $6f7020238dfb168a$var$TONES.brand;
    const s = $6f7020238dfb168a$var$SIZES[size] || $6f7020238dfb168a$var$SIZES.md;
    const surface = variant === 'soft' ? t.soft : t.solid.startsWith('bg-') ? `${t.solid} text-white shadow-sm` : `bg-gradient-to-br ${t.solid} text-white shadow-md`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `inline-flex flex-shrink-0 items-center justify-center ${s.box} ${surface} ${className}`,
        children: Icon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
            size: s.icon,
            strokeWidth: 2.1
        })
    });
};
var $6f7020238dfb168a$export$2e2bcd8739ae039 = $6f7020238dfb168a$var$IconTile;


/**
 * The "How do you want to model your options?" chooser — ONE artifact for every module
 * (owner direction, 2026-08-25: "consistency of artifacts and UI where applicable"). The Aged
 * Care module set the pattern — each mode is a card with a title, a plain-words description of
 * what the mode actually does IN THIS MODULE, and an audience chip — and the other modules had
 * drifted to bare buttons that explained nothing. The copy is per-module (each mode does
 * different things in each module, and saying so is the point); the anatomy and styling are
 * shared here so they can never drift again.
 */ 
parcelRequire("acw62");
function $d9ebdae53ed46d76$export$8c6c871fdafdac17({ heading: heading = 'How do you want to model your options?', value: value, onSelect: onSelect, options: options }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            heading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "text-xl font-bold text-gray-800 mb-4",
                children: heading
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-col md:flex-row gap-4 mb-2",
                children: options.map((option)=>{
                    const selected = value === option.id;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: ()=>onSelect(option.id),
                        className: `flex-1 px-6 py-4 rounded-xl border-2 transition-all duration-200 shadow-sm font-semibold text-lg flex flex-col items-center gap-2 ${selected ? 'border-blue-600 bg-blue-50 text-blue-700 scale-105' : 'border-gray-200 bg-white text-gray-500 hover:border-blue-400 hover:bg-blue-50'}`,
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: option.title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-xs font-normal text-gray-500 leading-snug",
                                children: option.blurb
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-[10px] font-bold uppercase tracking-wide text-blue-700 bg-blue-100 rounded-full px-2.5 py-0.5",
                                children: option.chip
                            })
                        ]
                    }, option.id);
                })
            })
        ]
    });
}
var $d9ebdae53ed46d76$export$2e2bcd8739ae039 = $d9ebdae53ed46d76$export$8c6c871fdafdac17;




// DraftFactFind is structurally compatible with FactFind (formDraft.ts); the shared
// calc-engine fns below defensively coerce internally regardless (factFindTypes.ts header).
const $bf6abaf7e99e19dd$var$asFactFind = (factFind)=>factFind;
// Derived from AGED_CARE_SCHEDULE (single source); RAD retention is fixed in legislation
const $bf6abaf7e99e19dd$var$MPIR = (0, $815d7df20c36742b$export$36c4ec5f3f340aef).MPIR;
const $bf6abaf7e99e19dd$var$RAD_RETENTION_RATE = 0.02;
const $bf6abaf7e99e19dd$var$BASIC_DAILY_FEE_RATE = (0, $815d7df20c36742b$export$36c4ec5f3f340aef).basicDailyFeeRate;
const $bf6abaf7e99e19dd$var$AGED_CARE_HOME_EXEMPTION_CAP = (0, $815d7df20c36742b$export$36c4ec5f3f340aef).homeExemptionCap;
const $bf6abaf7e99e19dd$var$MAS = (0, $815d7df20c36742b$export$36c4ec5f3f340aef).MAS;
/** The schedule's own date, so this line moves with every indexation (it sat on "1 January 2026" until 22 Sep 2026). */ const $bf6abaf7e99e19dd$var$SCHEDULE_DATE_LABEL = new Date(`${(0, $815d7df20c36742b$export$36c4ec5f3f340aef).effectiveDate}T00:00:00`).toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
});
const $bf6abaf7e99e19dd$var$HSC_DAILY_CAP = (0, $815d7df20c36742b$export$36c4ec5f3f340aef).maxHotellingDaily;
const $bf6abaf7e99e19dd$var$NCCC_DAILY_CAP = (0, $815d7df20c36742b$export$36c4ec5f3f340aef).maxNCCCDaily;
const $bf6abaf7e99e19dd$var$NCCC_LIFETIME_CAP = (0, $815d7df20c36742b$export$36c4ec5f3f340aef).ncccLifetimeCap;
const $bf6abaf7e99e19dd$var$ARRANGEMENTS_2014 = (0, $815d7df20c36742b$export$36c4ec5f3f340aef).arrangements2014;
/** Read from the same tables `calculateFinancials` uses, so the label moves with each indexation. */ const $bf6abaf7e99e19dd$var$PENSION_RATES_AS_AT_LABEL = `${(0, $1abe73eeef086faf$export$946308c675ba021d).agePension} rate tables in this app`;
const $bf6abaf7e99e19dd$var$AgedCareCostsExplained = ({ setActivePage: setActivePage, onContinue: onContinue, factFind: factFind, onBack: onBack, backLabel: backLabel = 'Back to Dashboard', continueLabel: continueLabel = 'Continue to Funding Options' })=>{
    const [openAccordion, setOpenAccordion] = (0, $acw62.useState)(null);
    const [showIllnessSeparatedExplainer, setShowIllnessSeparatedExplainer] = (0, $acw62.useState)(false);
    const [showPensionTechnicalDetail, setShowPensionTechnicalDetail] = (0, $acw62.useState)(false);
    const modellerResidencyOpts = (0, $acw62.useMemo)(()=>factFind?.goals?.aged_care ? (0, $8eecd0af141b9afb$export$5f0bb1b091776594)($bf6abaf7e99e19dd$var$asFactFind(factFind)) : {}, [
        factFind
    ]);
    const showIllnessSeparatedCostNote = factFind?.adviceFor === 'couple' && factFind?.goals?.aged_care && (0, $8eecd0af141b9afb$export$9b95c99516118f10)($bf6abaf7e99e19dd$var$asFactFind(factFind), {}) !== (0, $8eecd0af141b9afb$export$9b95c99516118f10)($bf6abaf7e99e19dd$var$asFactFind(factFind), modellerResidencyOpts);
    // A resident under the no-worse-off principle pays the 1 July 2014 arrangements' means-tested
    // care fee instead of the two 2025 contributions — the same resolver the fee engine uses.
    const coveredByNoWorseOff = (0, $5a5496da6ce58554$export$4a48561f28024b31)($bf6abaf7e99e19dd$var$asFactFind(factFind));
    // The family home's treatment said for this client; null where nobody owns a home (homeTreatmentWords.ts).
    const homeTreatment = (0, $acw62.useMemo)(()=>(0, $0785c68479a63d37$export$f909db9361901de9)($bf6abaf7e99e19dd$var$asFactFind(factFind), modellerResidencyOpts), [
        factFind,
        modellerResidencyOpts
    ]);
    const [meansTestedCareFee2014, setMeansTestedCareFee2014] = (0, $acw62.useState)(null);
    const [financials, setFinancials] = (0, $acw62.useState)({
        totalAssessableIncome: 0,
        assessableAssets: 0
    });
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind).then((r)=>{
            if (!cancelled) setFinancials(r);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind
    ]);
    const assessableIncome = (financials.totalAssessableIncome || 0) / (factFind.adviceFor === 'couple' ? 2 : 1);
    const assessableAssets = (financials.assessableAssets || 0) / (factFind.adviceFor === 'couple' ? 2 : 1);
    // Calculate example MTA using client's actual financial position with a dummy RAD
    const [exampleMtaCalculation, setExampleMtaCalculation] = (0, $acw62.useState)({
        agedCareAssessableIncome: 0,
        agedCareAssessableAssets: 0,
        dailyHSC_MTA: 0,
        dailyNCCC_MTA: 0,
        dailyHSC: 0,
        dailyNCCC: 0,
        MAS: (0, $815d7df20c36742b$export$36c4ec5f3f340aef).MAS,
        mtaBreakdown: {
            incomeBelowFreeArea: true,
            incomeFreeAreaUsed: 0,
            annualIncomeTestedAmount: 0,
            assetFreeAreaUsed: 0,
            assetBandBreakdown: [],
            annualAssetTestedAmount: 0
        }
    });
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (async ()=>{
            const exampleRadPaid = 0;
            const tempFactFind = structuredClone(factFind);
            if (!tempFactFind.assets) tempFactFind.assets = {};
            if (!tempFactFind.assets.radPaid) tempFactFind.assets.radPaid = [];
            const tempFinancials = await $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(tempFactFind);
            if (cancelled) return;
            let assessableAssetsForAgedCare = (tempFinancials.assessableAssets || 0) + exampleRadPaid;
            if (factFind.home && parseFloat(String(factFind.home.value)) > 0) {
                const homeValue = parseFloat(String(factFind.home.value)) || 0;
                // Shared with the fee engine rather than re-stated here: this screen EXPLAINS the fee,
                // so a second copy of the rule could quietly contradict the number it is explaining.
                if ((0, $8d8b97815ba787de$export$a4f0fcc41e754c67)($bf6abaf7e99e19dd$var$asFactFind(factFind), modellerResidencyOpts)) assessableAssetsForAgedCare = (tempFinancials.assessableAssetsNoHome || 0) + exampleRadPaid;
                else assessableAssetsForAgedCare = (tempFinancials.assessableAssetsNoHome || 0) + Math.min(homeValue, $bf6abaf7e99e19dd$var$AGED_CARE_HOME_EXEMPTION_CAP) + exampleRadPaid;
            }
            const useScheduleCoupleIncomeBands = (0, $8eecd0af141b9afb$export$3f6250a0954ba7fc)($bf6abaf7e99e19dd$var$asFactFind(factFind), modellerResidencyOpts);
            // Same discipline as the assets above: the income composition is SHARED with the fee
            // engine (income support counts, less the minimum pension supplement and energy
            // supplement — see agedCareAssessableIncomeOf), so the explanation can never disagree
            // with the fee it explains.
            const agedCareAssessableIncome = (0, $8ab1e06940ee4f8b$export$392d49a94b1386e5)({
                totalAssessableIncome: tempFinancials.totalAssessableIncome || 0,
                socialSecurity: tempFinancials.socialSecurity || 0
            }, {
                isCouple: factFind.adviceFor === 'couple',
                illnessSeparated: useScheduleCoupleIncomeBands
            });
            const agedCareAssessableAssets = factFind.adviceFor === 'couple' ? assessableAssetsForAgedCare / 2 : assessableAssetsForAgedCare;
            const [{ dailyMTA: dailyMTA, dailyHSC: dailyHSC, dailyNCCC: dailyNCCC }, mtaBreakdown, fee2014] = await Promise.all([
                $55a1d8a64f1e5dfa$export$a9748024cd29327a(agedCareAssessableIncome, agedCareAssessableAssets, useScheduleCoupleIncomeBands),
                $55a1d8a64f1e5dfa$export$10bd982d1f08e6ee(agedCareAssessableIncome, agedCareAssessableAssets, useScheduleCoupleIncomeBands),
                coveredByNoWorseOff ? $55a1d8a64f1e5dfa$export$a42dd84ddeb28371(agedCareAssessableIncome, agedCareAssessableAssets, useScheduleCoupleIncomeBands) : Promise.resolve(null)
            ]);
            if (cancelled) return;
            setMeansTestedCareFee2014(fee2014);
            setExampleMtaCalculation({
                agedCareAssessableIncome: agedCareAssessableIncome,
                agedCareAssessableAssets: agedCareAssessableAssets,
                dailyHSC_MTA: dailyMTA,
                dailyNCCC_MTA: dailyMTA,
                dailyHSC: dailyHSC,
                dailyNCCC: dailyNCCC,
                MAS: (0, $815d7df20c36742b$export$36c4ec5f3f340aef).MAS,
                mtaBreakdown: mtaBreakdown
            });
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind,
        modellerResidencyOpts,
        coveredByNoWorseOff
    ]);
    const toggleAccordion = (id)=>{
        setOpenAccordion(openAccordion === id ? null : id);
    };
    const feeDetails = (0, $acw62.useMemo)(()=>[
            {
                id: 'bdf',
                title: "Basic Daily Fee",
                icon: (0, $1571f1c57333e026$export$2e2bcd8739ae039),
                summary: "Everyone pays this fee\u2014it covers your everyday living essentials like meals, cleaning, laundry, and utilities. Think of it as your contribution to the day-to-day services that keep the facility running smoothly.",
                details: `This fee is set by the government at ${$bf6abaf7e99e19dd$var$BASIC_DAILY_FEE_RATE * 100}% of the single basic Age Pension. It is indexed twice a year and is payable by all residents, regardless of their financial situation.`,
                applies: true // Always applies
            },
            {
                id: 'acc',
                title: "Accommodation Cost",
                icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
                summary: "This covers the cost of your room\u2014think of it like paying rent or a mortgage. You have flexibility: pay upfront as a lump sum (RAD), make daily payments (DAP), or mix both approaches to suit your situation.",
                details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mb-3",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-lg text-gray-900",
                                children: "Refundable Accommodation Deposit (RAD):"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "mb-4 text-gray-700 leading-relaxed",
                            children: [
                                "A lump-sum payment for your accommodation, which is largely refunded to your estate when you leave. Providers can deduct a retention amount of ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                    children: [
                                        $bf6abaf7e99e19dd$var$RAD_RETENTION_RATE * 100,
                                        "% per annum"
                                    ]
                                }),
                                " calculated daily on the current RAD balance (not the original amount), capped at 5 years."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mb-3",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-lg text-gray-900",
                                children: "Daily Accommodation Payment (DAP):"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "mb-4 text-gray-700 leading-relaxed",
                            children: [
                                "A daily rental-style payment calculated on any unpaid RAD amount. The interest rate used is the government's Maximum Permissible Interest Rate (MPIR), currently ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                    children: [
                                        ($bf6abaf7e99e19dd$var$MPIR * 100).toFixed(2),
                                        "% p.a."
                                    ]
                                }),
                                " This payment is not refundable."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white border border-slate-200/70 p-4 md:p-5 rounded-xl border-l-4 border-blue-500 shadow-sm mb-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $27f56d6cfb7d79f8$export$2e2bcd8739ae039), {
                                            className: "w-6 h-6 text-blue-600"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-bold text-blue-900 text-lg",
                                            children: "DAP Formula"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "bg-slate-50 p-3 rounded-lg border border-slate-200 mb-2",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "font-mono text-lg font-bold text-blue-800 text-center",
                                        children: "(Room Cost - RAD Paid) \xd7 MPIR \xf7 365"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm md:text-base text-blue-700 leading-relaxed",
                                    children: "The estimated DAP will be calculated and displayed once you enter the room cost in the next section."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white border border-slate-200/70 p-4 md:p-5 rounded-xl border-l-4 border-gray-400 shadow-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 mb-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e57d6b071418ede9$export$2e2bcd8739ae039), {
                                            className: "w-6 h-6 text-gray-600"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-bold text-gray-900 text-lg",
                                            children: "Example Calculations"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d137e5221e5cfba5$export$2e2bcd8739ae039), {
                                            tone: "neutral",
                                            className: "ml-auto",
                                            children: "$500,000 room"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    className: "text-sm md:text-base text-gray-800 space-y-2.5",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            className: "flex items-start gap-3 p-2 bg-slate-50 rounded-lg border border-slate-200",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "flex-shrink-0 w-6 h-6 rounded-full bg-blue-500 text-white text-xs font-bold flex items-center justify-center mt-0.5",
                                                    children: "1"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            className: "text-gray-900",
                                                            children: "Full DAP:"
                                                        }),
                                                        " $500,000 \xd7 ",
                                                        ($bf6abaf7e99e19dd$var$MPIR * 100).toFixed(2),
                                                        "% \xf7 365 = ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "font-mono font-bold text-blue-600",
                                                            children: [
                                                                "$",
                                                                (500000 * $bf6abaf7e99e19dd$var$MPIR / 365).toFixed(2),
                                                                "/day"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            className: "flex items-start gap-3 p-2 bg-slate-50 rounded-lg border border-slate-200",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "flex-shrink-0 w-6 h-6 rounded-full bg-blue-500 text-white text-xs font-bold flex items-center justify-center mt-0.5",
                                                    children: "2"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            className: "text-gray-900",
                                                            children: "Hybrid (50% RAD, 50% DAP):"
                                                        }),
                                                        " $250,000 \xd7 ",
                                                        ($bf6abaf7e99e19dd$var$MPIR * 100).toFixed(2),
                                                        "% \xf7 365 = ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "font-mono font-bold text-blue-600",
                                                            children: [
                                                                "$",
                                                                (250000 * $bf6abaf7e99e19dd$var$MPIR / 365).toFixed(2),
                                                                "/day"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            className: "flex items-start gap-3 p-2 bg-slate-50 rounded-lg border border-slate-200",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "flex-shrink-0 w-6 h-6 rounded-full bg-blue-500 text-white text-xs font-bold flex items-center justify-center mt-0.5",
                                                    children: "3"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            className: "text-gray-900",
                                                            children: "Full RAD:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "font-mono font-bold text-green-600",
                                                            children: "$0/day DAP"
                                                        }),
                                                        " (but $500,000 upfront)"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                applies: true // Always applies as an option
            },
            ...coveredByNoWorseOff ? [
                {
                    id: 'mtcf',
                    title: 'Means-Tested Care Fee (1 July 2014 arrangements \u2014 "no worse off")',
                    icon: (0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039),
                    summary: "Because a Home Care Package was in place or approved on 12 September 2024, the 'no worse off' principle keeps you on the 1 July 2014 fee arrangements when you enter a home: one means-tested care fee instead of the hotelling and non-clinical care contributions that residents on the 1 November 2025 rules pay, with an annual cap and a lifetime cap.",
                    details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mb-3 text-gray-700 leading-relaxed",
                                children: [
                                    "Services Australia works out an ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "income-tested amount"
                                    }),
                                    " (50% of your assessable income above the income free area of ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(factFind.adviceFor === 'couple' ? $bf6abaf7e99e19dd$var$ARRANGEMENTS_2014.incomeFreeAreaCouple : $bf6abaf7e99e19dd$var$ARRANGEMENTS_2014.incomeFreeAreaSingle),
                                    ", per day) and an ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "asset-tested amount"
                                    }),
                                    " (17.5% of assets between ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($bf6abaf7e99e19dd$var$ARRANGEMENTS_2014.assetFreeArea),
                                    " and ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($bf6abaf7e99e19dd$var$ARRANGEMENTS_2014.firstAssetThreshold),
                                    ", 1% up to ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($bf6abaf7e99e19dd$var$ARRANGEMENTS_2014.secondAssetThreshold),
                                    ", and 2% above, per day). Their sum is your means-tested amount; the fee is that amount less the maximum accommodation supplement (",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($bf6abaf7e99e19dd$var$MAS),
                                    "), capped at ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($bf6abaf7e99e19dd$var$ARRANGEMENTS_2014.maxMeansTestedCareFeeDaily),
                                    " a day."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mb-3 text-gray-700 leading-relaxed",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Caps."
                                    }),
                                    " Once you have paid ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($bf6abaf7e99e19dd$var$ARRANGEMENTS_2014.mtcfAnnualCap),
                                    " in a year of care the fee stops until the anniversary of your entry; once you have paid ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($bf6abaf7e99e19dd$var$ARRANGEMENTS_2014.mtcfLifetimeCap),
                                    " in total \u2014 counting income-tested care fees paid under your package and Support at Home contributions \u2014 it stops for good. Both caps are indexed."
                                ]
                            }),
                            meansTestedCareFee2014 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "rounded-lg border border-blue-200 bg-white p-4 text-sm text-blue-900",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "On your figures:"
                                            }),
                                            " income-tested amount ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(meansTestedCareFee2014.dailyIncomeTestedAmount),
                                            " + asset-tested amount ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(meansTestedCareFee2014.dailyAssetTestedAmount),
                                            " = means-tested amount ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(meansTestedCareFee2014.dailyMTA),
                                            " a day."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-1 font-semibold",
                                        children: [
                                            "Estimated means-tested care fee: ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(meansTestedCareFee2014.dailyMTCF),
                                            " a day (",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(meansTestedCareFee2014.dailyMTCF * 365),
                                            " a year before the caps)."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-3 text-gray-700 leading-relaxed",
                                children: "You may opt in to the 1 November 2025 fee arrangements at any time, but the election cannot be reversed. The Analyser can model both, and the Statement of Advice shows what the difference is worth over the whole plan. Your accommodation costs are on the 1 November 2025 arrangements either way."
                            })
                        ]
                    }),
                    applies: (meansTestedCareFee2014?.dailyMTCF ?? 0) > 0
                }
            ] : [],
            {
                id: 'hsc',
                title: "Hotelling Supplement Contribution (HSC)",
                icon: (0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039),
                summary: "If your income or assets are above certain thresholds, you'll contribute towards accommodation services like maintaining common areas, gardens, and building upkeep. This fee is calculated based on your financial means.",
                details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mb-4 text-gray-700 leading-relaxed",
                            children: "This fee is calculated based on a combined assessment of your income and assets. You'll only contribute if your financial means are above certain thresholds\u2014it's designed to be fair and based on what you can afford."
                        }),
                        homeTreatment && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white border border-slate-200/70 p-4 md:p-5 rounded-xl border-l-4 border-l-amber-400 shadow-sm mb-4",
                            "data-testid": "home-treatment-note",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "font-bold text-slate-900 text-lg mb-2",
                                    children: "How your family home is treated for HSC (and NCCC)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-sm md:text-base text-slate-700 leading-relaxed",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            className: "font-semibold text-slate-900",
                                            children: homeTreatment.lead
                                        }),
                                        homeTreatment.leadRest
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-2 text-sm md:text-base text-slate-700 leading-relaxed",
                                    children: homeTreatment.change
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-xs text-slate-500 mt-3",
                                    children: "Note: Age Pension (Centrelink) and aged care means testing are related but not identical\u2014some items (like RAD) and home rules can be treated differently."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white border border-slate-200/70 p-4 md:p-5 rounded-xl border-l-4 border-blue-500 shadow-sm mb-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mb-4 p-3 bg-slate-50 rounded-lg border border-slate-200",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-semibold text-blue-900 mb-2",
                                            children: "Key Terms Explained:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                            className: "text-sm text-blue-800 space-y-1.5",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        "\u2022 ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "MTA (Means Tested Amount):"
                                                        }),
                                                        " The combined total of your income tested amount and asset tested amount"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        "\u2022 ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "MAS (Maximum Accommodation Supplement):"
                                                        }),
                                                        " A daily amount ($",
                                                        $bf6abaf7e99e19dd$var$MAS.toFixed(2),
                                                        ") that represents the government's maximum accommodation supplement"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 mb-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $27f56d6cfb7d79f8$export$2e2bcd8739ae039), {
                                            className: "w-6 h-6 text-blue-600"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-bold text-blue-900 text-lg",
                                            children: "Step-by-Step Calculation"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d137e5221e5cfba5$export$2e2bcd8739ae039), {
                                            tone: "info",
                                            className: "ml-auto",
                                            children: "From 1 Nov 2025"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    className: "text-sm md:text-base text-blue-800 space-y-2.5 ml-0",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            className: "flex items-start gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "flex-shrink-0 w-6 h-6 rounded-full bg-blue-500 text-white text-xs font-bold flex items-center justify-center mt-0.5",
                                                    children: "1"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Calculate MTA:"
                                                        }),
                                                        " Add together your income tested amount and asset tested amount"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            className: "flex items-start gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "flex-shrink-0 w-6 h-6 rounded-full bg-blue-500 text-white text-xs font-bold flex items-center justify-center mt-0.5",
                                                    children: "2"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Daily MTA:"
                                                        }),
                                                        " Divide annual MTA by 364 days"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            className: "flex items-start gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "flex-shrink-0 w-6 h-6 rounded-full bg-blue-500 text-white text-xs font-bold flex items-center justify-center mt-0.5",
                                                    children: "3"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Check Threshold:"
                                                        }),
                                                        " HSC only applies if MTA > $",
                                                        $bf6abaf7e99e19dd$var$MAS.toFixed(2),
                                                        "/day (MAS amount)"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            className: "flex items-start gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "flex-shrink-0 w-6 h-6 rounded-full bg-blue-500 text-white text-xs font-bold flex items-center justify-center mt-0.5",
                                                    children: "4"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Calculate HSC:"
                                                        }),
                                                        " MTA minus MAS (capped at $",
                                                        $bf6abaf7e99e19dd$var$HSC_DAILY_CAP.toFixed(2),
                                                        "/day, indexed)"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            className: "flex items-start gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "flex-shrink-0 w-6 h-6 rounded-full bg-blue-500 text-white text-xs font-bold flex items-center justify-center mt-0.5",
                                                    children: "5"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "No Lifetime Cap:"
                                                        }),
                                                        " Unlike NCCC, HSC has no lifetime cap"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        factFind?.adviceFor === 'couple' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white border border-slate-200/70 p-4 md:p-5 rounded-xl border-l-4 border-green-400 shadow-sm mb-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                            className: "w-6 h-6 text-green-600"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-bold text-green-900 text-lg",
                                            children: "For Couples"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm md:text-base text-green-800 leading-relaxed",
                                    children: 'For couples, your assets and income are pooled (50/50 split) to determine your individual Means Tested Amount, even if you are "illness separated" (living in different locations due to care needs).'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white border border-slate-200/70 p-4 md:p-5 rounded-xl border-l-4 border-slate-400 shadow-sm mb-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $27f56d6cfb7d79f8$export$2e2bcd8739ae039), {
                                            className: "w-6 h-6 text-slate-600"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-bold text-slate-900 text-lg",
                                            children: "Understanding the Daily MTA (tiered formula)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-sm text-slate-700 leading-relaxed mb-3",
                                    children: [
                                        "The Daily MTA is the amount used in the steps above and in your example below. It is simply: ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "income-tested amount"
                                        }),
                                        " plus ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "asset-tested amount"
                                        }),
                                        '. Each of those is worked out using government rules that split your income or assets into "slices" (using the thresholds below). The rates below apply ',
                                        factFind?.adviceFor === 'couple' ? 'for couples (illness separated)' : 'for singles',
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-sm text-slate-700 space-y-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "font-semibold text-slate-800 mb-1",
                                                    children: "Income (annual assessable income)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                    className: "list-disc list-inside space-y-0.5 text-slate-700",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Income-free area:"
                                                                }),
                                                                " ",
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(factFind?.adviceFor === 'couple' ? (0, $815d7df20c36742b$export$36c4ec5f3f340aef).incomeFreeAreaCouple : (0, $815d7df20c36742b$export$36c4ec5f3f340aef).incomeFreeAreaSingle),
                                                                " \u2014 nothing is counted below this."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Thresholds that define the slices:"
                                                                }),
                                                                " First ",
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(factFind?.adviceFor === 'couple' ? (0, $815d7df20c36742b$export$36c4ec5f3f340aef).firstIncomeThresholdCouple : (0, $815d7df20c36742b$export$36c4ec5f3f340aef).firstIncomeThresholdSingle),
                                                                " \xb7 Second ",
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(factFind?.adviceFor === 'couple' ? (0, $815d7df20c36742b$export$36c4ec5f3f340aef).secondIncomeThresholdCouple : (0, $815d7df20c36742b$export$36c4ec5f3f340aef).secondIncomeThresholdSingle),
                                                                " \xb7 Third ",
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(factFind?.adviceFor === 'couple' ? (0, $815d7df20c36742b$export$36c4ec5f3f340aef).thirdIncomeThresholdCouple : (0, $815d7df20c36742b$export$36c4ec5f3f340aef).thirdIncomeThresholdSingle),
                                                                " \xb7 Fourth ",
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(factFind?.adviceFor === 'couple' ? (0, $815d7df20c36742b$export$36c4ec5f3f340aef).fourthIncomeThresholdCouple : (0, $815d7df20c36742b$export$36c4ec5f3f340aef).fourthIncomeThresholdSingle),
                                                                "."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "How it works:"
                                                                }),
                                                                " Your income above the income-free area is split into slices between these thresholds. For ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "each slice"
                                                                }),
                                                                ", 50% of that slice is added to your income-tested amount. So the thresholds tell us where each slice starts and ends; the rate (50%) is the same for every slice."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "font-semibold text-slate-800 mb-1",
                                                    children: "Assets (assessable assets)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                    className: "list-disc list-inside space-y-0.5 text-slate-700",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Asset-free area:"
                                                                }),
                                                                " ",
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $815d7df20c36742b$export$36c4ec5f3f340aef).assetFreeArea),
                                                                " \u2014 nothing is counted below this."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Thresholds that define the slices:"
                                                                }),
                                                                " First ",
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $815d7df20c36742b$export$36c4ec5f3f340aef).firstAssetThreshold),
                                                                " \xb7 Second ",
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $815d7df20c36742b$export$36c4ec5f3f340aef).secondAssetThreshold),
                                                                " \xb7 Third ",
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $815d7df20c36742b$export$36c4ec5f3f340aef).thirdAssetThreshold),
                                                                " \xb7 Fourth ",
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $815d7df20c36742b$export$36c4ec5f3f340aef).fourthAssetThreshold),
                                                                "."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "How it works:"
                                                                }),
                                                                " The ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "first slice"
                                                                }),
                                                                " (from asset-free area up to the first threshold) is counted at ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "17.5%"
                                                                }),
                                                                ". The ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "second slice"
                                                                }),
                                                                " (from the second threshold to the third threshold) is counted at ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "7.8%"
                                                                }),
                                                                ". Any assets ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "above the fourth threshold"
                                                                }),
                                                                " are also counted at ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "7.8%"
                                                                }),
                                                                ". So the thresholds define which part of your assets gets the higher rate (17.5%) and which gets the lower rate (7.8%)."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-slate-600 pt-1 border-t border-slate-200",
                                            children: [
                                                "We add the income-tested amount and asset-tested amount (both in annual terms), then divide by 364 days. That gives your ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Daily MTA"
                                                }),
                                                ", which is used in the HSC (and NCCC) calculation."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white border border-slate-200/70 p-4 md:p-5 rounded-xl border-l-4 border-gray-400 shadow-sm mb-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 mb-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {
                                            className: "w-6 h-6 text-gray-600"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-bold text-gray-900 text-lg",
                                            children: "Example Using Your Financial Position"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-sm text-gray-700 space-y-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Scenario:"
                                                }),
                                                " Based on your current financial position. Your assessable assets for aged care include any RAD you have paid\u2014the RAD is exempt from the Age Pension (Centrelink) assets test but is included in the aged care means test that determines your MTA, HSC and NCCC."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "bg-slate-50 p-3 rounded-lg border border-slate-200 space-y-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "font-semibold text-gray-900 mb-1",
                                                    children: [
                                                        "Assessable income: ",
                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(exampleMtaCalculation.agedCareAssessableIncome),
                                                        " p.a."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-gray-600 text-xs leading-relaxed",
                                                    children: [
                                                        'This is the amount used for the aged care means test. It can include Age Pension (if any), deemed income from financial assets (e.g. bank, shares, account-based pensions at statutory deeming rates), and other assessable income. It may differ from the actual income generated from these assets because of how Centrelink calculates "deemed income".',
                                                        factFind.adviceFor === 'couple' && ` This amount represents ${factFind.client?.firstName ? `${factFind.client.firstName}'s` : "the care recipient's"} share of the total assessable income.`
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "pt-1 border-t border-gray-200",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Assessable assets:"
                                                        }),
                                                        " ",
                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(exampleMtaCalculation.agedCareAssessableAssets)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "font-semibold text-gray-900 mb-1 mt-2",
                                                    children: "Applying the tiered formula (taper and bands):"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "space-y-1.5 text-sm pl-2 border-l-2 border-slate-200",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Income:"
                                                                }),
                                                                " ",
                                                                exampleMtaCalculation.mtaBreakdown.incomeBelowFreeArea ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                    children: [
                                                                        "Your assessable income (",
                                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(exampleMtaCalculation.agedCareAssessableIncome),
                                                                        ") is below the income-free area (",
                                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(exampleMtaCalculation.mtaBreakdown.incomeFreeAreaUsed),
                                                                        "), so ",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                            children: "income-tested amount = $0"
                                                                        }),
                                                                        " p.a. ($0/day)."
                                                                    ]
                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                    children: [
                                                                        "50% of each slice of your income above the income-free area (between the thresholds) \u2192 ",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(exampleMtaCalculation.mtaBreakdown.annualIncomeTestedAmount)
                                                                        }),
                                                                        " p.a. (",
                                                                        (exampleMtaCalculation.mtaBreakdown.annualIncomeTestedAmount / 364).toFixed(2),
                                                                        "/day)."
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "text-sm",
                                                            children: exampleMtaCalculation.mtaBreakdown.assetBandBreakdown.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: "Assets:"
                                                                    }),
                                                                    " Assessable assets are at or below the asset-free area (",
                                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(exampleMtaCalculation.mtaBreakdown.assetFreeAreaUsed),
                                                                    "), so ",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: "asset-tested amount = $0"
                                                                    }),
                                                                    " p.a."
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                        className: "mb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                children: "Assets:"
                                                                            }),
                                                                            " Per slice:"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                                        className: "list-disc list-inside ml-1 space-y-0.5",
                                                                        children: exampleMtaCalculation.mtaBreakdown.assetBandBreakdown.map((band, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                                                children: [
                                                                                    band.label,
                                                                                    ": ",
                                                                                    band.ratePct,
                                                                                    "% \u2192 ",
                                                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(band.amount),
                                                                                    " p.a."
                                                                                ]
                                                                            }, i))
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                        className: "mt-1",
                                                                        children: [
                                                                            "Total asset-tested amount = ",
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(exampleMtaCalculation.mtaBreakdown.annualAssetTestedAmount)
                                                                            }),
                                                                            " p.a. (",
                                                                            (exampleMtaCalculation.mtaBreakdown.annualAssetTestedAmount / 364).toFixed(2),
                                                                            "/day)."
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "pt-1 border-t border-slate-200",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Daily MTA"
                                                                }),
                                                                " = income-tested per day + asset-tested per day = ",
                                                                (exampleMtaCalculation.mtaBreakdown.annualIncomeTestedAmount / 364).toFixed(2),
                                                                " + ",
                                                                (exampleMtaCalculation.mtaBreakdown.annualAssetTestedAmount / 364).toFixed(2),
                                                                " = ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                    className: "text-blue-600",
                                                                    children: [
                                                                        exampleMtaCalculation.dailyHSC_MTA.toFixed(2),
                                                                        "/day"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        exampleMtaCalculation.dailyHSC_MTA > $bf6abaf7e99e19dd$var$MAS && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "bg-white border border-slate-200/70 p-3 rounded-lg border-l-4 border-blue-500",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "font-semibold text-blue-900 mb-1.5",
                                                    children: "HSC Calculation:"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-sm text-blue-800",
                                                    children: [
                                                        "MTA (",
                                                        exampleMtaCalculation.dailyHSC_MTA.toFixed(2),
                                                        ") - MAS (",
                                                        $bf6abaf7e99e19dd$var$MAS.toFixed(2),
                                                        ") = ",
                                                        (exampleMtaCalculation.dailyHSC_MTA - $bf6abaf7e99e19dd$var$MAS).toFixed(2)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-sm text-blue-800",
                                                    children: [
                                                        "Capped at ",
                                                        $bf6abaf7e99e19dd$var$HSC_DAILY_CAP.toFixed(2),
                                                        "/day = ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                            className: "text-blue-900",
                                                            children: [
                                                                exampleMtaCalculation.dailyHSC.toFixed(2),
                                                                " per day"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-sm text-blue-800 font-semibold mt-2 pt-2 border-t border-blue-200",
                                                    children: [
                                                        "Annual HSC: ",
                                                        exampleMtaCalculation.dailyHSC.toFixed(2),
                                                        " \xd7 365 = ",
                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(exampleMtaCalculation.dailyHSC * 365)
                                                    ]
                                                })
                                            ]
                                        }),
                                        exampleMtaCalculation.dailyHSC_MTA <= $bf6abaf7e99e19dd$var$MAS && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "bg-white border border-slate-200/70 p-3 rounded-lg border-l-4 border-green-500",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "font-semibold text-green-900 mb-1.5",
                                                    children: "HSC Result:"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-sm text-green-800",
                                                    children: [
                                                        "Your MTA (",
                                                        exampleMtaCalculation.dailyHSC_MTA.toFixed(2),
                                                        "/day) is below the MAS threshold (",
                                                        $bf6abaf7e99e19dd$var$MAS.toFixed(2),
                                                        "/day), so ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "no HSC applies"
                                                        }),
                                                        "."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white border border-slate-200/70 p-4 md:p-5 rounded-xl border-l-4 border-amber-400 shadow-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 mb-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                                            className: "w-6 h-6 text-amber-600"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-bold text-amber-900 text-lg",
                                            children: "Caps & Limits"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d137e5221e5cfba5$export$2e2bcd8739ae039), {
                                            tone: "info",
                                            className: "ml-auto",
                                            children: "From 1 Nov 2025"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-sm text-amber-700",
                                    children: [
                                        "Your HSC is capped at ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                            children: [
                                                "$",
                                                $bf6abaf7e99e19dd$var$HSC_DAILY_CAP.toFixed(2),
                                                " per day (indexed biannually)"
                                            ]
                                        }),
                                        ". Unlike the NCCC, there is no lifetime cap on this fee."
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                applies: coveredByNoWorseOff ? false : (()=>{
                    // Check if HSC actually applies based on calculated MTA, not just thresholds
                    // HSC only applies if daily MTA > MAS threshold
                    return exampleMtaCalculation.dailyHSC_MTA > $bf6abaf7e99e19dd$var$MAS;
                })()
            },
            {
                id: 'nccc',
                title: "Non-Clinical Care Contribution (NCCC)",
                icon: (0, $95e9e50748ea8ef2$export$2e2bcd8739ae039),
                summary: "This is a means-tested contribution towards non-clinical care services you receive, such as help with bathing, dressing, and mobility. Clinical support services (like nursing care) are fully funded by the government and are not included in this contribution.",
                details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mb-4 text-gray-700 leading-relaxed",
                            children: "This fee is calculated based on a combined assessment of your income and assets. You'll only contribute if your financial means are above certain thresholds\u2014it's designed to be fair and based on what you can afford."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white border border-slate-200/70 p-4 md:p-5 rounded-xl border-l-4 border-blue-500 shadow-sm mb-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mb-4 p-3 bg-slate-50 rounded-lg border border-slate-200",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-semibold text-blue-900 mb-2",
                                            children: "Key Terms Explained:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                            className: "text-sm text-blue-800 space-y-1.5",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        "\u2022 ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "MTA (Means Tested Amount):"
                                                        }),
                                                        " The combined total of your income tested amount and asset tested amount"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        "\u2022 ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "MAS (Maximum Accommodation Supplement):"
                                                        }),
                                                        " A daily amount ($",
                                                        $bf6abaf7e99e19dd$var$MAS.toFixed(2),
                                                        ") that represents the government's maximum accommodation supplement"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 mb-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $27f56d6cfb7d79f8$export$2e2bcd8739ae039), {
                                            className: "w-6 h-6 text-blue-600"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-bold text-blue-900 text-lg",
                                            children: "Step-by-Step Calculation"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d137e5221e5cfba5$export$2e2bcd8739ae039), {
                                            tone: "info",
                                            className: "ml-auto",
                                            children: "From 1 Nov 2025"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    className: "text-sm md:text-base text-blue-800 space-y-2.5 ml-0",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            className: "flex items-start gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "flex-shrink-0 w-6 h-6 rounded-full bg-blue-500 text-white text-xs font-bold flex items-center justify-center mt-0.5",
                                                    children: "1"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Calculate MTA:"
                                                        }),
                                                        " Add together your income tested amount and asset tested amount"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            className: "flex items-start gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "flex-shrink-0 w-6 h-6 rounded-full bg-blue-500 text-white text-xs font-bold flex items-center justify-center mt-0.5",
                                                    children: "2"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Daily MTA:"
                                                        }),
                                                        " Divide annual MTA by 364 days"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            className: "flex items-start gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "flex-shrink-0 w-6 h-6 rounded-full bg-blue-500 text-white text-xs font-bold flex items-center justify-center mt-0.5",
                                                    children: "3"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Check Threshold:"
                                                        }),
                                                        " NCCC only applies if MTA > $",
                                                        ($bf6abaf7e99e19dd$var$MAS + $bf6abaf7e99e19dd$var$HSC_DAILY_CAP).toFixed(2),
                                                        "/day (MAS + max hotelling)"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            className: "flex items-start gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "flex-shrink-0 w-6 h-6 rounded-full bg-blue-500 text-white text-xs font-bold flex items-center justify-center mt-0.5",
                                                    children: "4"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Calculate NCCC:"
                                                        }),
                                                        " MTA minus (MAS + max hotelling) (capped at $",
                                                        $bf6abaf7e99e19dd$var$NCCC_DAILY_CAP.toFixed(2),
                                                        "/day, indexed)"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            className: "flex items-start gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "flex-shrink-0 w-6 h-6 rounded-full bg-blue-500 text-white text-xs font-bold flex items-center justify-center mt-0.5",
                                                    children: "5"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Lifetime Cap:"
                                                        }),
                                                        " Maximum ",
                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($bf6abaf7e99e19dd$var$NCCC_LIFETIME_CAP),
                                                        " total or 4 years, whichever comes first (indexed biannually)"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        factFind?.adviceFor === 'couple' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white border border-slate-200/70 p-4 md:p-5 rounded-xl border-l-4 border-green-400 shadow-sm mb-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                            className: "w-6 h-6 text-green-600"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-bold text-green-900 text-lg",
                                            children: "For Couples"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm md:text-base text-green-800 leading-relaxed",
                                    children: 'For couples, your assets and income are pooled (50/50 split) to determine your individual Means Tested Amount, even if you are "illness separated" (living in different locations due to care needs).'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white border border-slate-200/70 p-4 md:p-5 rounded-xl border-l-4 border-gray-400 shadow-sm mb-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 mb-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {
                                            className: "w-6 h-6 text-gray-600"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-bold text-gray-900 text-lg",
                                            children: "Example Using Your Financial Position"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-sm text-gray-700 space-y-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Scenario:"
                                                }),
                                                " Based on your current financial position. Your assessable assets for aged care include any RAD you have paid\u2014the RAD is exempt from the Age Pension (Centrelink) assets test but is included in the aged care means test that determines your MTA, HSC and NCCC."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "bg-slate-50 p-3 rounded-lg border border-slate-200",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "font-semibold text-gray-900 mb-2",
                                                    children: "Daily MTA Calculation:"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "space-y-1.5 text-sm",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            children: [
                                                                "Same tiered MTA as for HSC. ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Daily MTA:"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                    className: "text-blue-600",
                                                                    children: [
                                                                        exampleMtaCalculation.dailyNCCC_MTA.toFixed(2),
                                                                        "/day"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "pt-1 border-t border-gray-200 text-gray-600",
                                                            children: [
                                                                "NCCC applies when MTA > MAS + max hotelling ($",
                                                                ($bf6abaf7e99e19dd$var$MAS + $bf6abaf7e99e19dd$var$HSC_DAILY_CAP).toFixed(2),
                                                                "/day)."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        exampleMtaCalculation.dailyNCCC > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "bg-white border border-slate-200/70 p-3 rounded-lg border-l-4 border-blue-500",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "font-semibold text-blue-900 mb-1.5",
                                                            children: "HSC (prerequisite):"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-sm text-blue-800",
                                                            children: [
                                                                "MTA (",
                                                                exampleMtaCalculation.dailyHSC_MTA.toFixed(2),
                                                                ") - MAS (",
                                                                $bf6abaf7e99e19dd$var$MAS.toFixed(2),
                                                                ") = ",
                                                                (exampleMtaCalculation.dailyHSC_MTA - $bf6abaf7e99e19dd$var$MAS).toFixed(2),
                                                                " \u2192 capped at ",
                                                                $bf6abaf7e99e19dd$var$HSC_DAILY_CAP.toFixed(2),
                                                                "/day = ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                    className: "text-blue-900",
                                                                    children: [
                                                                        exampleMtaCalculation.dailyHSC.toFixed(2),
                                                                        "/day"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "bg-white border border-slate-200/70 p-3 rounded-lg border-l-4 border-purple-500",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "font-semibold text-purple-900 mb-1.5",
                                                            children: "NCCC (MTA \u2212 MAS \u2212 max hotelling):"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-sm text-purple-800",
                                                            children: [
                                                                "MTA (",
                                                                exampleMtaCalculation.dailyNCCC_MTA.toFixed(2),
                                                                ") \u2212 ",
                                                                ($bf6abaf7e99e19dd$var$MAS + $bf6abaf7e99e19dd$var$HSC_DAILY_CAP).toFixed(2),
                                                                " = ",
                                                                (exampleMtaCalculation.dailyNCCC_MTA - $bf6abaf7e99e19dd$var$MAS - $bf6abaf7e99e19dd$var$HSC_DAILY_CAP).toFixed(2),
                                                                " \u2192 capped at ",
                                                                $bf6abaf7e99e19dd$var$NCCC_DAILY_CAP.toFixed(2),
                                                                "/day = ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                    className: "text-purple-900",
                                                                    children: [
                                                                        exampleMtaCalculation.dailyNCCC.toFixed(2),
                                                                        "/day"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-sm text-purple-800 font-semibold mt-2 pt-2 border-t border-purple-200",
                                                            children: [
                                                                "Annual NCCC: ",
                                                                exampleMtaCalculation.dailyNCCC.toFixed(2),
                                                                " \xd7 365 \u2248 ",
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(exampleMtaCalculation.dailyNCCC * 365)
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-sm text-purple-900 font-bold mt-2 pt-2 border-t-2 border-purple-300",
                                                            children: [
                                                                "HSC + NCCC (annual): ",
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(exampleMtaCalculation.dailyHSC * 365),
                                                                " + ",
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(exampleMtaCalculation.dailyNCCC * 365),
                                                                " = ",
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((exampleMtaCalculation.dailyHSC + exampleMtaCalculation.dailyNCCC) * 365)
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        exampleMtaCalculation.dailyNCCC === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "bg-white border border-slate-200/70 p-3 rounded-lg border-l-4 border-green-500",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "font-semibold text-green-900 mb-1.5",
                                                    children: "NCCC Result:"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-sm text-green-800",
                                                    children: [
                                                        "Your MTA (",
                                                        exampleMtaCalculation.dailyNCCC_MTA.toFixed(2),
                                                        "/day) is at or below the threshold (MAS + max hotelling = $",
                                                        ($bf6abaf7e99e19dd$var$MAS + $bf6abaf7e99e19dd$var$HSC_DAILY_CAP).toFixed(2),
                                                        "/day), so ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "no NCCC applies"
                                                        }),
                                                        "."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white border border-slate-200/70 p-4 md:p-5 rounded-xl border-l-4 border-amber-400 shadow-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 mb-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                                            className: "w-6 h-6 text-amber-600"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-bold text-amber-900 text-lg",
                                            children: "Caps & Limits"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d137e5221e5cfba5$export$2e2bcd8739ae039), {
                                            tone: "info",
                                            className: "ml-auto",
                                            children: "From 1 Nov 2025"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    className: "text-sm text-amber-700 space-y-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                "\u2022 ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Daily Cap:"
                                                }),
                                                " $",
                                                $bf6abaf7e99e19dd$var$NCCC_DAILY_CAP.toFixed(2),
                                                " per day (indexed biannually)"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                "\u2022 ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Lifetime Cap:"
                                                }),
                                                " ",
                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($bf6abaf7e99e19dd$var$NCCC_LIFETIME_CAP),
                                                " total or 4 years, whichever comes first (indexed biannually)"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                applies: !coveredByNoWorseOff && exampleMtaCalculation.dailyNCCC > 0
            },
            {
                id: 'esf',
                title: "Extra Service Fees",
                icon: (0, $f4da941c85c0c5fe$export$2e2bcd8739ae039),
                summary: "Want something extra? These optional fees give you access to premium services and amenities\u2014think of it like upgrading to a suite at a hotel. Completely your choice, and costs vary by provider.",
                details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mb-3",
                            children: "These fees are for services beyond the standard care requirements, such as a wider menu selection, pay-TV, or a private room with a specific view. These are a private arrangement between you and the provider and can vary significantly."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white p-3 rounded-lg border border-slate-200 border-l-4 border-l-blue-400 shadow-sm mb-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "font-semibold text-blue-800 mb-2",
                                    children: "Common Extra Services:"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    className: "text-sm text-blue-700 space-y-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "\u2022 Premium meal options and dining experiences"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "\u2022 Pay-TV, internet, and entertainment packages"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "\u2022 Private rooms with specific views or layouts"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "\u2022 Additional personal care services"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "\u2022 Transportation and outings"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white p-3 rounded-lg border border-slate-200 border-l-4 border-l-amber-400 shadow-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "font-semibold text-amber-800 mb-2",
                                    children: "Important Considerations:"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    className: "text-sm text-amber-700 space-y-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                "\u2022 These fees are ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "not"
                                                }),
                                                " means-tested"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                "\u2022 They are ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "not"
                                                }),
                                                " covered by government subsidies"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "\u2022 Costs can range from $50 to $500+ per week"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "\u2022 Always negotiate and compare providers"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                applies: 'optional'
            }
        ], [
        meansTestedCareFee2014,
        coveredByNoWorseOff,
        exampleMtaCalculation,
        $bf6abaf7e99e19dd$var$MAS,
        homeTreatment
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-6xl mx-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                variant: "ghost",
                size: "sm",
                icon: (0, $c31db635520dc385$export$2e2bcd8739ae039),
                onClick: onBack ?? (()=>setActivePage('Dashboard')),
                className: "mb-4 -ml-2",
                children: backLabel
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-4 mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                icon: (0, $1571f1c57333e026$export$2e2bcd8739ae039),
                                tone: "brand",
                                variant: "solid",
                                size: "lg",
                                className: "hidden sm:inline-flex"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-4xl md:text-5xl font-bold text-gray-900",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6288781efbc92679$export$2e2bcd8739ae039), {
                                    children: "Understanding Aged Care Costs"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-lg text-slate-700 leading-relaxed",
                        children: "Navigating aged care costs can feel overwhelming. We've broken down everything you need to know about the fees you may encounter, so you can make informed decisions with confidence."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-3 text-lg text-slate-700 leading-relaxed",
                        "data-testid": "costs-permission",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "font-bold text-slate-900",
                                children: "You don't need to understand how these fees are calculated \u2014 we do that work for you."
                            }),
                            ' ',
                            "Each card says what the fee is and whether it is likely to apply to you.",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "font-bold text-slate-900",
                                children: "Open one only if you want the detail."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-3 text-sm text-slate-500",
                        children: [
                            "Rates and thresholds are from the ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                href: "https://www.health.gov.au/resources/publications/schedule-of-fees-and-charges-for-residential-care?language=en",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "text-blue-600 hover:underline",
                                children: [
                                    "Schedule of Fees and Charges for Residential Care from ",
                                    $bf6abaf7e99e19dd$var$SCHEDULE_DATE_LABEL
                                ]
                            }),
                            ". If you entered care under different rules (for example 1 July 2014 or earlier), amounts may differ."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "space-y-4",
                children: feeDetails.filter((fee)=>!(coveredByNoWorseOff && (fee.id === 'hsc' || fee.id === 'nccc'))).map((fee)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b5fe5727b69e005$export$2e2bcd8739ae039), {
                        ...fee,
                        isOpen: openAccordion === fee.id,
                        onToggle: ()=>toggleAccordion(fee.id),
                        factFind: factFind
                    }, fee.id))
            }),
            showIllnessSeparatedCostNote && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-6 w-full rounded-2xl border border-slate-200 bg-white shadow-card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>{
                            const next = !showIllnessSeparatedExplainer;
                            setShowIllnessSeparatedExplainer(next);
                            if (!next) setShowPensionTechnicalDetail(false);
                        },
                        className: "w-full p-6 md:p-8 text-left flex items-center justify-between hover:bg-slate-50 transition-colors duration-200 rounded-2xl",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-4 min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                        className: "text-blue-600 flex-shrink-0",
                                        size: 22
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "min-w-0",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                className: "text-blue-900 font-semibold text-base md:text-lg",
                                                children: "Couples and illness-separated rules"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-blue-700/90 mt-1",
                                                children: "How thresholds here can differ from your Dashboard snapshot"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: `text-blue-600 transition-transform duration-200 flex-shrink-0 ml-2 ${showIllnessSeparatedExplainer ? 'rotate-180' : ''}`,
                                size: 22
                            })
                        ]
                    }),
                    showIllnessSeparatedExplainer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "px-6 md:px-8 pb-6 md:pb-8 pt-0 text-sm text-blue-900 border-t border-blue-100/80 space-y-3 leading-relaxed",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "You are planning for ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "residential aged care as a couple"
                                    }),
                                    ", while your profile may still show both of you at home. For your ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Dashboard"
                                    }),
                                    " snapshot we keep ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "standard couple"
                                    }),
                                    " Age Pension rules until your living situation (or your override) says otherwise. On this page and in the ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Aged Care"
                                    }),
                                    " calculator we model someone ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "entering care"
                                    }),
                                    ", where Centrelink often applies ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "illness-separated couple"
                                    }),
                                    " rules instead."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "What changes:"
                                    }),
                                    " the income and asset ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "free areas"
                                    }),
                                    " (and cut-offs) used in the means tests are usually ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "higher"
                                    }),
                                    " for an illness-separated couple than for a standard couple living together. The same assets and income can therefore produce ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "higher Age Pension"
                                    }),
                                    " and different means-tested care fees in the aged care model than in the snapshot above."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Why:"
                                    }),
                                    " Services Australia recognises that when partners are apart because of care needs, ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "household costs do not behave like a single shared home"
                                    }),
                                    ", so the tests use a different set of thresholds. This is set by government rules, not by the app."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-xs text-blue-800/90",
                                children: [
                                    "You can align the Dashboard with Centrelink using ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Illness-separated couple treatment"
                                    }),
                                    " on the Dashboard (Auto / Yes / No)."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "pt-4 mt-2 border-t border-blue-100/80",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "text-sm font-medium text-blue-800 hover:text-blue-950 underline underline-offset-2 decoration-blue-400/80",
                                        onClick: ()=>setShowPensionTechnicalDetail(!showPensionTechnicalDetail),
                                        "aria-expanded": showPensionTechnicalDetail,
                                        children: showPensionTechnicalDetail ? 'Hide technical detail' : 'Need more detail?'
                                    }),
                                    showPensionTechnicalDetail && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4 p-4 sm:p-5 bg-white/95 rounded-xl border border-blue-200/90 text-xs sm:text-sm text-slate-800 space-y-4 leading-relaxed shadow-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-slate-600",
                                                children: [
                                                    "For ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "couples"
                                                    }),
                                                    ", this app uses your ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "combined"
                                                    }),
                                                    " assessable income and assets (Centrelink-style), then applies the rules below. Figures are from our ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: $bf6abaf7e99e19dd$var$PENSION_RATES_AS_AT_LABEL
                                                    }),
                                                    "\u2014the same inputs as the calculator, not personal advice."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-semibold text-slate-900 mb-2",
                                                        children: "Maximum combined Age Pension (both members eligible)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                        className: "list-disc pl-5 space-y-1 text-slate-700",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: "Standard couple:"
                                                                    }),
                                                                    " ",
                                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).couple),
                                                                    " per year (combined maximum before means tests)."
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: "Illness-separated couple:"
                                                                    }),
                                                                    " ",
                                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single * 2),
                                                                    " per year (two \xd7 single maximum, combined)."
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-semibold text-slate-900 mb-2",
                                                        children: "Asset test \u2014 homeowner (combined assessable assets)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-slate-600 mb-2",
                                                        children: [
                                                            "Between the lower and upper limits, pension under the asset test is reduced by ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                children: [
                                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$6ca758cf677ce6c5)),
                                                                    " per year for each $1,000"
                                                                ]
                                                            }),
                                                            " of assets above the lower limit (capped at nil once assets reach the upper limit)."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "overflow-x-auto rounded-lg border border-slate-200",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                                            className: "min-w-full text-left border-collapse",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                        className: "bg-slate-100 text-slate-800",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                                className: "px-3 py-2 font-semibold border-b border-slate-200",
                                                                                children: "Treatment"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                                className: "px-3 py-2 font-semibold border-b border-slate-200",
                                                                                children: "Full pension \u2014 assets up to"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                                className: "px-3 py-2 font-semibold border-b border-slate-200",
                                                                                children: "Nil pension \u2014 assets from"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                                    className: "text-slate-700",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                    className: "px-3 py-2 border-b border-slate-100",
                                                                                    children: "Standard couple"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                    className: "px-3 py-2 border-b border-slate-100",
                                                                                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).couple.homeowner.full)
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                    className: "px-3 py-2 border-b border-slate-100",
                                                                                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).couple.homeowner.cutoff)
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                    className: "px-3 py-2",
                                                                                    children: "Illness-separated couple"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                    className: "px-3 py-2",
                                                                                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).coupleIllnessSeparated.homeowner.full)
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                    className: "px-3 py-2",
                                                                                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).coupleIllnessSeparated.homeowner.cutoff)
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-slate-600 mt-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "Non-homeowner"
                                                            }),
                                                            " limits are higher: standard couple full / nil ",
                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).couple.nonHomeowner.full),
                                                            " / ",
                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).couple.nonHomeowner.cutoff),
                                                            "; illness-separated ",
                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).coupleIllnessSeparated.nonHomeowner.full),
                                                            " / ",
                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).coupleIllnessSeparated.nonHomeowner.cutoff),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-semibold text-slate-900 mb-2",
                                                        children: "Income test (combined assessable income)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-slate-600 mb-2",
                                                        children: [
                                                            "The same ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "income free area"
                                                            }),
                                                            " applies for both treatments: ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$704950d172afcdf8).couple)
                                                            }),
                                                            " per year combined. Above that, pension under the income test falls by ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                children: [
                                                                    ((0, $1abe73eeef086faf$export$d0c93f26057d6047) * 100).toFixed(0),
                                                                    "%"
                                                                ]
                                                            }),
                                                            " of each dollar of assessable income over the free area, until it reaches nil at the cut-off below."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "overflow-x-auto rounded-lg border border-slate-200",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                                            className: "min-w-full text-left border-collapse",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                        className: "bg-slate-100 text-slate-800",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                                className: "px-3 py-2 font-semibold border-b border-slate-200",
                                                                                children: "Treatment"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                                className: "px-3 py-2 font-semibold border-b border-slate-200",
                                                                                children: "Published nil-pension income cut-off (combined)"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                                    className: "text-slate-700",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                    className: "px-3 py-2 border-b border-slate-100",
                                                                                    children: "Standard couple"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                    className: "px-3 py-2 border-b border-slate-100",
                                                                                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$bad1f8cb9d172d1b).couple)
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                    className: "px-3 py-2",
                                                                                    children: "Illness-separated couple"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                    className: "px-3 py-2",
                                                                                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$bad1f8cb9d172d1b).coupleIllnessSeparated)
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-semibold text-slate-900 mb-1",
                                                        children: "Which test decides your rate?"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-slate-700",
                                                        children: [
                                                            "The app calculates pension under the ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "asset test"
                                                            }),
                                                            " and under the ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "income test"
                                                            }),
                                                            " separately, then pays the ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "lower"
                                                            }),
                                                            " of the two."
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-12 bg-white p-8 md:p-10 rounded-2xl border border-slate-200 shadow-lg",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-3 mb-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                icon: (0, $e57d6b071418ede9$export$2e2bcd8739ae039),
                                tone: "brand",
                                variant: "solid",
                                size: "lg"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-2xl md:text-3xl font-bold text-gray-900",
                                children: "How Funding Choices Impact Your Financial Position"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-6 mb-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-slate-50 p-6 rounded-xl border border-slate-200 shadow-md hover:shadow-lg transition-shadow duration-300",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-3 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                                icon: (0, $c9921f4f81a419f0$export$2e2bcd8739ae039),
                                                tone: "brand",
                                                variant: "solid",
                                                size: "md"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                className: "text-lg font-bold text-gray-900",
                                                children: "Age Pension Considerations"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                        className: "text-sm md:text-base text-gray-700 space-y-2.5 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                className: "flex items-start gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-blue-600 mt-1",
                                                        children: "\u2022"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                className: "text-gray-900",
                                                                children: "RAD Payment:"
                                                            }),
                                                            " Reduces assessable assets, may increase Age Pension"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                className: "flex items-start gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-blue-600 mt-1",
                                                        children: "\u2022"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                className: "text-gray-900",
                                                                children: "DAP Payment:"
                                                            }),
                                                            " No impact on asset test, but reduces cash flow"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                className: "flex items-start gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-blue-600 mt-1",
                                                        children: "\u2022"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                className: "text-gray-900",
                                                                children: "Home Exemption:"
                                                            }),
                                                            " Home is exempt if a protected person lives in it"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                className: "flex items-start gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-blue-600 mt-1",
                                                        children: "\u2022"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                className: "text-gray-900",
                                                                children: "Home Rental:"
                                                            }),
                                                            " Can rent out for 2 years while remaining exempt (rental income counted)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                className: "flex items-start gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-blue-600 mt-1",
                                                        children: "\u2022"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                className: "text-gray-900",
                                                                children: "Investment Strategy:"
                                                            }),
                                                            " Consider deeming rates and asset limits"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-4 p-3 bg-white border border-slate-200/70 rounded-lg border-l-4 border-blue-500",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-xs md:text-sm text-blue-900 leading-relaxed",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "How the Age Pension is worked out:"
                                                }),
                                                " two tests. The income test counts deemed income from financial assets plus any other income, and reduces the pension by 50 cents for each dollar above the free area. The assets test reduces it by a set amount for each $1,000 of assets above the free area. Whichever test gives the lower pension is the one that applies."
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-slate-50 p-6 rounded-xl border border-slate-200 shadow-md hover:shadow-lg transition-shadow duration-300",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-3 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                                icon: (0, $6315759428919b56$export$2e2bcd8739ae039),
                                                tone: "brand",
                                                variant: "solid",
                                                size: "md"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                className: "text-lg font-bold text-gray-900",
                                                children: "Estate Planning Impact"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                        className: "text-sm md:text-base text-gray-700 space-y-2.5",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                className: "flex items-start gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-blue-600 mt-1",
                                                        children: "\u2022"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                className: "text-gray-900",
                                                                children: "RAD Refund:"
                                                            }),
                                                            " Largely refundable to estate (minus retention)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                className: "flex items-start gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-blue-600 mt-1",
                                                        children: "\u2022"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                className: "text-gray-900",
                                                                children: "DAP Payments:"
                                                            }),
                                                            " Not refundable, reduces estate value"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                className: "flex items-start gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-blue-600 mt-1",
                                                        children: "\u2022"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                className: "text-gray-900",
                                                                children: "Home Ownership:"
                                                            }),
                                                            " Consider CGT implications and estate planning"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                className: "flex items-start gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-blue-600 mt-1",
                                                        children: "\u2022"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                className: "text-gray-900",
                                                                children: "Investment Structure:"
                                                            }),
                                                            " Consider tax-effective estate planning"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-6 p-5 bg-white/90 backdrop-blur-sm rounded-xl border-l-4 border-blue-500 shadow-md",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-start gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                    icon: (0, $7d167a906f54f167$export$2e2bcd8739ae039),
                                    tone: "brand",
                                    variant: "solid",
                                    size: "md"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-bold text-gray-900 text-lg mb-2",
                                            children: "Expert Tip"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm md:text-base text-gray-700 leading-relaxed",
                                            children: "The optimal funding strategy depends on your individual circumstances, including your Age Pension status, tax position, and estate planning goals. Use this app's modelling capabilities to explore different scenarios and understand the financial impacts of your choices."
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-8 text-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                    onClick: onContinue,
                    variant: "brand",
                    size: "lg",
                    iconRight: (0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039),
                    children: continueLabel
                })
            })
        ]
    });
};
var $bf6abaf7e99e19dd$export$2e2bcd8739ae039 = $bf6abaf7e99e19dd$var$AgedCareCostsExplained;


/**
 * The Aged care landing once a plan exists — "John's aged care plan — the $800,000 room" (UX review,
 * 17 Oct 2026, the mock-up's hub screen).
 *
 * WHY. Every route into the module used to land on the education guide and then on an empty step 1,
 * so a client with a saved plan thought their work was lost. Now the module opens on the plan: one
 * card for the chosen plan — its name in words, the big number against doing nothing, the three
 * yearly figures, how the deposit is paid, and the three ways in (explain it, what could go wrong,
 * all the plans) — then the advice document and the next step, then a row of links. A breadcrumb so
 * it cannot be mistaken for Home (owner, 17 Oct 2026: the first cut "looked like a second dashboard").
 *
 * Nothing here is computed: every figure is the saved plan's own, quoted, with the doing-nothing
 * figures it was measured against at the time it was saved.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e583651be68dae50$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 3 4 7l4 4",
            key: "9rb6wj"
        }
    ],
    [
        "path",
        {
            d: "M4 7h16",
            key: "6tx8e3"
        }
    ],
    [
        "path",
        {
            d: "m16 21 4-4-4-4",
            key: "siv7j2"
        }
    ],
    [
        "path",
        {
            d: "M20 17H4",
            key: "h6l3hr"
        }
    ]
];
const $e583651be68dae50$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("arrow-left-right", $e583651be68dae50$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e1cfd183b457f6f1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 7v14",
            key: "1akyts"
        }
    ],
    [
        "path",
        {
            d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
            key: "ruj8y"
        }
    ]
];
const $e1cfd183b457f6f1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("book-open", $e1cfd183b457f6f1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $712d717556ef1508$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15 12-8.373 8.373a1 1 0 1 1-3-3L12 9",
            key: "eefl8a"
        }
    ],
    [
        "path",
        {
            d: "m18 15 4-4",
            key: "16gjal"
        }
    ],
    [
        "path",
        {
            d: "m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172V7l-2.26-2.26a6 6 0 0 0-4.202-1.756L9 2.96l.92.82A6.18 6.18 0 0 1 12 8.4V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5",
            key: "b7pghm"
        }
    ]
];
const $712d717556ef1508$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("hammer", $712d717556ef1508$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6c2a827dd5c2d433$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
            key: "1a8usu"
        }
    ],
    [
        "path",
        {
            d: "m15 5 4 4",
            key: "1mk7zo"
        }
    ]
];
const $6c2a827dd5c2d433$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("pencil", $6c2a827dd5c2d433$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4666dd9ae485baaf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ],
    [
        "path",
        {
            d: "M12 8v4",
            key: "1got3b"
        }
    ],
    [
        "path",
        {
            d: "M12 16h.01",
            key: "1drbdi"
        }
    ]
];
const $4666dd9ae485baaf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("shield-alert", $4666dd9ae485baaf$export$3efd853dbb351e94);


/**
 * What the Aged care module is showing right now, for AWise (UX review, 17 Oct 2026: the chat had
 * no idea which screen the reader was on, and no client context).
 *
 * A tiny module-level store rather than React context, because the chat lives in App.tsx above
 * every page and only needs to READ this when a message is sent. The screens write it as they
 * mount; the note is plain facts already on screen (a room price, the four numbers, the chosen
 * plan's name) — AWise quotes them and explains them; it never computes from them.
 */ let $6067e4a24a943681$var$current = null;
const $6067e4a24a943681$var$listeners = new Set();
function $6067e4a24a943681$export$62e91b0fed1d0d10(next) {
    $6067e4a24a943681$var$current = next;
    $6067e4a24a943681$var$listeners.forEach((l)=>l());
}
function $6067e4a24a943681$export$49a9c588fd4c5f9d() {
    return $6067e4a24a943681$var$current;
}
function $6067e4a24a943681$export$57cb8160b600cc84(listener) {
    $6067e4a24a943681$var$listeners.add(listener);
    return ()=>{
        $6067e4a24a943681$var$listeners.delete(listener);
    };
}



/**
 * A Manual Control funding bag (`type-id` -> amount) in the client's words: which account, how much.
 * Used wherever a deposit's funding is listed — the Suggestion Engine card's allocation grid and the
 * plan recap — so the second room's deposit is shown from the same assets the first room's is
 * (owner, 7 Oct 2026: "where is the other $310K coming from").
 */ /**
 * Phase 2 — entity-aware strategy funding helpers (Aged Care manual control slice 1).
 * Spec §5.6, §9.1.3.
 */ 


const $bd80071df75c742b$export$ec9c57e3c77471a1 = 'Confirm this action is allowed under the trust deed, company constitution, and for all owners or beneficiaries. This tool does not provide legal advice.';
function $bd80071df75c742b$export$40bc5139f87a7b00(factFind) {
    return factFind?.structureFundingInSuggestions === 'include';
}
function $bd80071df75c742b$export$6b7e895f645efa6c(factFind, asset) {
    if (!asset) return false;
    if (!$bd80071df75c742b$export$40bc5139f87a7b00(factFind) && (0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(asset?.ownership)) return false;
    return true;
}
const $bd80071df75c742b$export$e5c79349077d175d = new Set([
    'bankAccounts',
    'termDeposits',
    'shares'
]);
function $bd80071df75c742b$export$eb5d467aa7d657c6(key) {
    if (!key || typeof key !== 'string') return null;
    const dash = key.indexOf('-');
    if (dash <= 0) return null;
    const assetType = key.slice(0, dash);
    const assetId = key.slice(dash + 1);
    if (!assetType || !assetId) return null;
    return {
        assetType: assetType,
        assetId: assetId
    };
}
function $bd80071df75c742b$export$4d0dc62775eae74e(left, right) {
    if (left == null || right == null) return false;
    return String(left) === String(right);
}
function $bd80071df75c742b$export$a19965a466a5acdf(assetList, assetId) {
    if (!Array.isArray(assetList)) return -1;
    return assetList.findIndex((a)=>$bd80071df75c742b$export$4d0dc62775eae74e(a.id, assetId));
}
function $bd80071df75c742b$export$f59ccf8b394d8480(factFind, assetType, assetId) {
    const list = factFind?.assets?.[assetType];
    const index = $bd80071df75c742b$export$a19965a466a5acdf(list, assetId);
    if (index < 0) return null;
    return {
        asset: list[index],
        index: index
    };
}
function $bd80071df75c742b$var$buildRadFundingAssetRow(type, asset) {
    return {
        ...asset,
        typeId: type.id,
        typeName: type.name,
        assetId: `${type.id}-${asset.id}`,
        hasCgt: type.hasCgt
    };
}
function $bd80071df75c742b$export$a6f66b42cac1f673(factFind) {
    const assets = [];
    (0, $77d0522707ddb581$export$e18ad1b53d14ba76).forEach((type)=>{
        if (!type.isLiquid || !factFind.assets?.[type.id]) return;
        factFind.assets[type.id].forEach((asset)=>{
            if ((0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(asset.ownership)) return;
            assets.push($bd80071df75c742b$var$buildRadFundingAssetRow(type, asset));
        });
    });
    return assets;
}
function $bd80071df75c742b$export$9a49e698901c6550(factFind) {
    const structures = factFind.structures || [];
    if (!structures.length) return [];
    const byEntity = new Map();
    structures.forEach((structure)=>{
        byEntity.set(structure.id ?? '', {
            entityId: structure.id ?? '',
            entityName: structure.name?.trim() || 'Trust or company',
            structureType: structure.type,
            structureTypeLabel: (0, $1773fcf9595c5c0a$export$378ace8cc3e15f6d)(structure.type || ''),
            assets: []
        });
    });
    (0, $77d0522707ddb581$export$e18ad1b53d14ba76).forEach((type)=>{
        if (!$bd80071df75c742b$export$e5c79349077d175d.has(type.id)) return;
        if (!factFind.assets?.[type.id]) return;
        factFind.assets[type.id].forEach((asset)=>{
            if (!(0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(asset.ownership)) return;
            const entityId = (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(asset.ownership);
            if (!entityId) return;
            const group = byEntity.get(entityId);
            if (!group) return;
            group.assets.push($bd80071df75c742b$var$buildRadFundingAssetRow(type, asset));
        });
    });
    return [
        ...byEntity.values()
    ].filter((g)=>g.assets.length > 0);
}
function $bd80071df75c742b$export$7baab1aa6768ed9(factFind) {
    const structures = factFind.structures || [];
    if (!structures.length) return [];
    const byEntity = new Map();
    structures.forEach((structure)=>{
        byEntity.set(structure.id ?? '', {
            entityId: structure.id ?? '',
            entityName: structure.name?.trim() || 'Trust or company',
            structureType: structure.type,
            structureTypeLabel: (0, $1773fcf9595c5c0a$export$378ace8cc3e15f6d)(structure.type || ''),
            assets: []
        });
    });
    (0, $77d0522707ddb581$export$e18ad1b53d14ba76).forEach((type)=>{
        if (!type.isLiquid || !factFind.assets?.[type.id]) return;
        factFind.assets[type.id].forEach((asset)=>{
            if (!(0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(asset.ownership)) return;
            const entityId = (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(asset.ownership);
            if (!entityId) return;
            const group = byEntity.get(entityId);
            if (!group) return;
            group.assets.push($bd80071df75c742b$var$buildRadFundingAssetRow(type, asset));
        });
    });
    (factFind.assets?.investmentProperty || []).forEach((property)=>{
        if (!(0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(property.ownership)) return;
        const entityId = (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(property.ownership);
        if (!entityId) return;
        const group = byEntity.get(entityId);
        if (!group) return;
        group.assets.push({
            ...property,
            typeId: 'investmentProperty',
            typeName: 'Investment property',
            assetId: `investmentProperty-${property.id}`,
            hasCgt: true,
            isInvestmentProperty: true
        });
    });
    return [
        ...byEntity.values()
    ].filter((g)=>g.assets.length > 0);
}
function $bd80071df75c742b$export$797d34a55dccdf21(radFunding = {}, entityGroups = []) {
    let total = 0;
    entityGroups.forEach((group)=>{
        group.assets.forEach((asset)=>{
            total += radFunding[asset.assetId] || 0;
        });
    });
    return total;
}
function $bd80071df75c742b$export$351785600ef65fdf(factFind, assetKey, grossAmount, cgtOverrides = {}) {
    const gross = Math.max(0, grossAmount || 0);
    if (gross <= 0) return {
        gross: 0,
        cgt: 0,
        net: 0
    };
    const parsed = $bd80071df75c742b$export$eb5d467aa7d657c6(assetKey);
    if (!parsed || parsed.assetType !== 'shares') return {
        gross: gross,
        cgt: 0,
        net: gross
    };
    const located = $bd80071df75c742b$export$f59ccf8b394d8480(factFind, parsed.assetType, parsed.assetId);
    if (!located?.asset) return {
        gross: gross,
        cgt: 0,
        net: gross
    };
    // NB: a missing cost base no longer means $0 CGT — calculateSharePartialDisposalTax applies the
    // shared 25%-of-value assumed cost base (resolveCostBase), disclosed in-app and in the SOA.
    // DraftFactFind is structurally compatible with FactFind/FactFindAsset (see
    // types/formDraft.ts); the shared calc-engine fns defensively parseFloat/coerce internally
    // regardless (see factFindTypes.ts header), so this cast is safe.
    const taxResult = (0, $a764bc0f6f904854$export$bb01b201c6492ed7)(factFind, located.asset, gross, {
        trustDisposal: 'distribute'
    });
    const override = (0, $a764bc0f6f904854$export$2778f99280b2ce68)(cgtOverrides[assetKey]);
    const cgt = override != null ? override : taxResult.estimatedCGT ?? 0;
    return {
        gross: gross,
        cgt: cgt,
        net: Math.max(0, gross - cgt)
    };
}
function $bd80071df75c742b$export$e98193fa2b9f521b(factFind, radFunding = {}, cgtOverrides = {}) {
    let grossTotal = 0;
    let netTotal = 0;
    let shareCgtTotal = 0;
    const byKey = {};
    Object.entries(radFunding || {}).forEach(([key, amount])=>{
        const entry = $bd80071df75c742b$export$351785600ef65fdf(factFind, key, amount, cgtOverrides);
        byKey[key] = entry;
        grossTotal += entry.gross;
        netTotal += entry.net;
        shareCgtTotal += entry.cgt;
    });
    return {
        grossTotal: grossTotal,
        netTotal: netTotal,
        shareCgtTotal: shareCgtTotal,
        byKey: byKey
    };
}
/**
 * RAD funding sources that are PAID ACROSS rather than sold — no disposal, so no sale date to nominate
 * and no capital gain to time. Everything else is a sale.
 */ const $bd80071df75c742b$var$CASH_LIKE_RAD_FUNDING_TYPES = new Set([
    'bankAccounts',
    'termDeposits'
]);
function $bd80071df75c742b$export$c125a47c6f30fb0d(radFunding = {}, saleAllocations = {}) {
    const sellsLiquidAsset = Object.entries(radFunding || {}).some(([key, amount])=>{
        if (!((parseFloat(String(amount)) || 0) > 0)) return false;
        const assetType = $bd80071df75c742b$export$eb5d467aa7d657c6(key)?.assetType;
        return !!assetType && !$bd80071df75c742b$var$CASH_LIKE_RAD_FUNDING_TYPES.has(assetType);
    });
    const allocated = (raw)=>(parseFloat(String(raw)) || 0) > 0;
    return sellsLiquidAsset || allocated(saleAllocations.home) || allocated(saleAllocations.investmentProperty);
}
function $bd80071df75c742b$export$ff72348c3c269e0f(assets) {
    const list = assets?.bankAccounts;
    if (!Array.isArray(list) || list.length === 0) return null;
    return list.find((a)=>!(0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(a?.ownership)) || list[0];
}
function $bd80071df75c742b$export$ade9707014c4664e(assets, cgtAmount, ownership) {
    const cgt = Math.max(0, cgtAmount || 0);
    if (cgt <= 0 || !assets?.bankAccounts?.length) return;
    if ((0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(ownership)) {
        const entityId = (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(ownership);
        const entityOwn = (0, $1773fcf9595c5c0a$export$66d936c41d42a933)(entityId ?? '');
        const entityBank = assets.bankAccounts.find((a)=>a.ownership === entityOwn) || null;
        if (entityBank) {
            entityBank.value = Math.max(0, (entityBank.value || 0) - cgt);
            return;
        }
    }
    const personalBank = $bd80071df75c742b$export$ff72348c3c269e0f(assets);
    if (personalBank) personalBank.value = Math.max(0, (personalBank.value || 0) - cgt);
}
function $bd80071df75c742b$export$e820d52c8da26912(assets, amount) {
    const debit = Math.max(0, amount || 0);
    if (debit <= 0 || !assets?.bankAccounts?.length) return;
    const personalBank = $bd80071df75c742b$export$ff72348c3c269e0f(assets);
    if (!personalBank) return;
    personalBank.value = Math.max(0, (personalBank.value || 0) - debit);
}


/**
 * AN ACCOUNT'S NAME ON THE MODELLING SCREENS, TOLD APART FROM ITS TWIN (owner, 22 Oct 2026: "they might each
 * have an ABP with the same institution … I might just type in MLC for both").
 *
 * Where a couple's file has two accounts with the same description, each one owned by one of them gains its
 * owner's first name: "MLC ABP – Matthew", "MLC ABP – Sally". Everything else keeps the description as typed:
 * a unique description, a single client, a joint account, or a description that already names its owner.
 * Display only: the description on the file and every funding key are untouched.
 */ const $e850825c00b15be4$var$norm = (s)=>String(s ?? '').trim().toLowerCase();
/** How many accounts on the file carry this description (all kinds of asset). */ function $e850825c00b15be4$var$descriptionCount(factFind, desc) {
    const assets = factFind?.assets || {};
    let n = 0;
    for (const list of Object.values(assets)){
        if (!Array.isArray(list)) continue;
        for (const a of list)if ($e850825c00b15be4$var$norm(a?.description) === desc) n += 1;
    }
    return n;
}
function $e850825c00b15be4$export$87285386e0429fb5(asset, factFind, fallback = 'account') {
    const raw = String(asset?.description ?? '').trim();
    if (!raw) return fallback;
    if (factFind?.adviceFor !== 'couple') return raw;
    const ownership = String(asset?.ownership ?? '');
    const owner = ownership === 'client' ? factFind.client?.firstName : ownership === 'partner' ? factFind.partner?.firstName : null;
    const name = String(owner ?? '').trim();
    if (!name || raw.toLowerCase().includes(name.toLowerCase())) return raw;
    return $e850825c00b15be4$var$descriptionCount(factFind, $e850825c00b15be4$var$norm(raw)) > 1 ? `${raw} \u{2013} ${name}` : raw;
}


const $e5cae8423a439bf1$var$ASSET_TYPE_FALLBACKS = {
    bankAccounts: 'bank account',
    termDeposits: 'term deposit',
    accountBasedPensions: 'account-based pension',
    shares: 'shares',
    managedFunds: 'managed funds',
    investmentBonds: 'investment bond'
};
function $e5cae8423a439bf1$export$8f80043cee83ba5d(factFind, bag) {
    return Object.entries(bag || {}).map(([key, raw])=>({
            key: key,
            amount: Number(raw) || 0
        })).filter((e)=>e.amount > 0).map(({ key: key, amount: amount })=>{
        const parsed = (0, $bd80071df75c742b$export$eb5d467aa7d657c6)(key);
        const located = parsed ? (0, $bd80071df75c742b$export$f59ccf8b394d8480)(factFind, parsed.assetType, parsed.assetId) : null;
        const fallback = (parsed ? $e5cae8423a439bf1$var$ASSET_TYPE_FALLBACKS[parsed.assetType] : null) || 'savings';
        const label = located ? (0, $e850825c00b15be4$export$87285386e0429fb5)(located.asset, factFind, fallback) : fallback;
        return {
            key: key,
            label: label,
            amount: amount
        };
    });
}
/** Kinds that are SOLD to fund a deposit (a sale, with capital gains tax to consider) as against drawn down. */ const $e5cae8423a439bf1$var$SOLD_KINDS = new Set([
    'shares',
    'managedFunds',
    'investmentBonds',
    'investmentProperties'
]);
function $e5cae8423a439bf1$export$47c51e1483ee586f(lines) {
    const sold = lines.filter((l)=>$e5cae8423a439bf1$var$SOLD_KINDS.has((0, $bd80071df75c742b$export$eb5d467aa7d657c6)(l.key)?.assetType || ''));
    const drawn = lines.filter((l)=>!sold.includes(l));
    if (!lines.length) return '';
    const names = (xs)=>xs.map((l)=>l.label).join(xs.length > 2 ? ', ' : ' and ');
    if (!sold.length) return `${drawn.length > 1 ? 'These accounts are drawn down' : `${names(drawn)} is drawn down`}; no shares or property are sold.`;
    if (!drawn.length) return `${names(sold)} ${sold.length > 1 ? 'are' : 'is'} sold, with capital gains tax to consider.`;
    return `${names(drawn)} ${drawn.length > 1 ? 'are' : 'is'} drawn down; ${names(sold)} ${sold.length > 1 ? 'are' : 'is'} sold, with capital gains tax to consider.`;
}
function $e5cae8423a439bf1$export$83ba4f4a49e92f66(lines, formatCurrency) {
    const parts = lines.map((l)=>`${formatCurrency(l.amount)} from ${l.label}`);
    if (parts.length === 0) return '';
    if (parts.length === 1) return parts[0];
    return `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}`;
}


/**
 * Aged Care suggestion engine — entity funding gate (Phase 2).
 * Spec §9.1.2: default exclude entity assets from automatic RAD funding suggestions.
 */ 






function $87af0cc4cc4e8984$export$e8094e02b706031b(radFunding) {
    if (!radFunding) return 0;
    return Object.values(radFunding).flatMap((entry)=>{
        if (!entry) return [];
        if (Array.isArray(entry)) return entry;
        return [
            entry
        ];
    }).reduce((sum, item)=>sum + (item.amount || 0), 0);
}
function $87af0cc4cc4e8984$export$90d75c9b1544186f(savedStrategy) {
    if (!savedStrategy) return null;
    if (savedStrategy.source === 'suggestion_engine') {
        const radFunding = savedStrategy.strategy?.radFunding;
        return radFunding ?? null;
    }
    const manualRadFunding = savedStrategy.inputs?.radFunding;
    if (!manualRadFunding || typeof manualRadFunding !== 'object') return null;
    const normalised = {};
    Object.entries(manualRadFunding).forEach(([key, amount])=>{
        if (!amount) return;
        const parsed = (0, $bd80071df75c742b$export$eb5d467aa7d657c6)(key);
        if (!parsed) return;
        if (!normalised[parsed.assetType]) normalised[parsed.assetType] = [];
        normalised[parsed.assetType].push({
            id: parsed.assetId,
            amount: amount
        });
    });
    return Object.keys(normalised).length > 0 ? normalised : null;
}
/**
 * What the plan pays toward the room up front — the deposit itself, not the assets sold for it.
 *
 * The sum of the funding is the GROSS sold: CGT comes out of it, and a sale is rounded up past the room.
 * A plan paying $817,600 up front (and $2,400 a day as DAP) was shown on the Support at Home screen as
 * "RAD paid upfront $820,000" (25 Oct 2026). The engine's row carries the deposit (`radPaidNet`, the
 * figure its fees were struck on); a hand-built plan records it in its outputs; a plan saved before
 * either falls back to the funding, never more than the room.
 */ function $87af0cc4cc4e8984$var$depositPaidBy(savedStrategy, radFunding) {
    const row = savedStrategy.strategy || {};
    if (savedStrategy.source === 'suggestion_engine' && Number.isFinite(Number(row.radPaidNet)) && row.radPaidNet != null) return Math.max(0, Number(row.radPaidNet));
    const recorded = savedStrategy.outputs?.radPaid;
    if (recorded != null && Number.isFinite(Number(recorded))) return Math.max(0, Number(recorded));
    const sold = radFunding ? $87af0cc4cc4e8984$export$e8094e02b706031b(radFunding) : 0;
    const room = Number(savedStrategy.inputs?.radInput) || 0;
    return room > 0 ? Math.min(sold, room) : sold;
}
function $87af0cc4cc4e8984$export$2fdaec60121ed226(savedStrategy) {
    if (!savedStrategy) return null;
    const radFunding = $87af0cc4cc4e8984$export$90d75c9b1544186f(savedStrategy);
    const totalRadPaid = $87af0cc4cc4e8984$var$depositPaidBy(savedStrategy, radFunding);
    const annualCost = savedStrategy.outputs?.agedCareCost || 0;
    const livingExpenses = savedStrategy.inputs?.scenarioLivingExpenses ?? savedStrategy.strategyOptions?.scenarioLivingExpenses ?? savedStrategy.inputs?.strategyOptions?.scenarioLivingExpenses ?? savedStrategy.strategy?.strategyOptions?.scenarioLivingExpenses ?? savedStrategy.strategy?.scenario?.strategyOptions?.scenarioLivingExpenses ?? savedStrategy.strategy?.snapshot?.livingExpenses ?? savedStrategy.outputs?.livingExpenses ?? null;
    return {
        id: savedStrategy.id,
        name: savedStrategy.name,
        source: savedStrategy.source || 'manual',
        annualCost: annualCost,
        dailyCost: annualCost / 365,
        radFunding: radFunding,
        radPaid: totalRadPaid,
        livingExpenses: livingExpenses !== undefined ? livingExpenses : null,
        strategyOptions: savedStrategy.strategyOptions || savedStrategy.strategy?.strategyOptions || null,
        savedStrategy: savedStrategy,
        outputs: savedStrategy.outputs || {}
    };
}
function $87af0cc4cc4e8984$export$954872cfed54c183(savedStrategy) {
    if (!savedStrategy) return null;
    const annualContribution = savedStrategy.outputs?.annualContribution || 0;
    return {
        id: savedStrategy.id,
        name: savedStrategy.name,
        annualContribution: annualContribution,
        monthlyContribution: annualContribution / 12,
        savedStrategy: savedStrategy,
        outputs: savedStrategy.outputs || {}
    };
}
function $87af0cc4cc4e8984$export$8a0c5ad907f77392(factFind, radFunding, cgtOverrides = {}) {
    return (0, $b71b41b8944942d4$export$8a0c5ad907f77392)(factFind, radFunding, cgtOverrides);
}
function $87af0cc4cc4e8984$export$21d4401e78844349(factFind, fundingMap, cgtOverrides = {}) {
    const modified = structuredClone(factFind);
    if (!fundingMap) return {
        factFind: modified,
        net: 0,
        gross: 0,
        cgt: 0
    };
    let net = 0, gross = 0, cgt = 0;
    Object.entries(fundingMap).forEach(([assetKey, amount])=>{
        const parsed = (0, $bd80071df75c742b$export$eb5d467aa7d657c6)(assetKey);
        if (!parsed) return;
        const entry = (0, $bd80071df75c742b$export$351785600ef65fdf)(factFind, assetKey, amount, cgtOverrides);
        if (entry.gross <= 0) return;
        const located = (0, $bd80071df75c742b$export$f59ccf8b394d8480)(modified, parsed.assetType, parsed.assetId);
        if (!located) return;
        const asset = located.asset;
        asset.value = (asset.value || 0) - entry.gross;
        if (parsed.assetType === 'accountBasedPensions') (0, $e0f54937e270d5ff$export$399e556d15149d82)(asset, modified, 1);
        net += entry.net;
        gross += entry.gross;
        cgt += entry.cgt;
    });
    return {
        factFind: modified,
        net: net,
        gross: gross,
        cgt: cgt
    };
}



/**
 * Phase 2 slice 2 — entity-owned investment property sale proceeds → entity liquid pool.
 * Spec §5.6, §5.9.2, §5.9.2a.
 */ 



const $bda3664ae16bcdb0$export$1b362965f2838fdc = 'entity-ip-proceeds-';
function $bda3664ae16bcdb0$export$cfdc34b008f59476(factFind, details) {
    if (!factFind?.assets?.investmentProperty?.length || !details) return null;
    const selectedPropertyId = details.selectedPropertyId;
    return factFind.assets.investmentProperty.find((p)=>(0, $bd80071df75c742b$export$4d0dc62775eae74e)(p.id, selectedPropertyId)) || factFind.assets.investmentProperty[0];
}
function $bda3664ae16bcdb0$export$c11662d6bbf785af(factFind, asset) {
    if (!asset || !(0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(asset.ownership)) return false;
    const entityId = (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(asset.ownership);
    const structure = (factFind.structures || []).find((s)=>s.id === entityId);
    return structure?.type !== 'partnership';
}
function $bda3664ae16bcdb0$export$ed6b4fd849b1a45e(details = {}) {
    return (details.radAllocation || 0) + (details.newHomePurchasePrice || 0) + (details.downsizerContribution || 0) + (details.partnerDownsizerContribution || 0) + (details.giftingAmount || 0) + (details.funeralBondPurchase || 0);
}
function $bda3664ae16bcdb0$var$defaultBankIncomeRate(assets) {
    const list = assets?.bankAccounts;
    if (list && list.length > 0) return list[0].incomeRate || 2;
    return 2;
}
function $bda3664ae16bcdb0$export$32a0ff5e6949dfc(assets, amount, options) {
    const proceeds = Math.max(0, amount || 0);
    if (proceeds <= 0) return {
        credited: 0,
        bankId: null
    };
    const { ownership: ownership, id: id, description: description, mergeEntityId: mergeEntityId, incomeRate: incomeRate } = options;
    if (!assets.bankAccounts) assets.bankAccounts = [];
    if (mergeEntityId) {
        const entityOwn = (0, $1773fcf9595c5c0a$export$66d936c41d42a933)(mergeEntityId);
        const existing = assets.bankAccounts.find((a)=>a.ownership === entityOwn && !String(a.id || '').startsWith($bda3664ae16bcdb0$export$1b362965f2838fdc));
        if (existing) {
            existing.value = (existing.value || 0) + proceeds;
            return {
                credited: proceeds,
                bankId: existing.id ?? null
            };
        }
    }
    const existingById = assets.bankAccounts.find((a)=>(0, $bd80071df75c742b$export$4d0dc62775eae74e)(a.id, id));
    if (existingById) {
        existingById.value = (existingById.value || 0) + proceeds;
        return {
            credited: proceeds,
            bankId: existingById.id ?? null
        };
    }
    assets.bankAccounts.push({
        id: id,
        type: 'bankAccounts',
        description: description,
        value: proceeds,
        ownership: ownership,
        incomeRate: incomeRate ?? $bda3664ae16bcdb0$var$defaultBankIncomeRate(assets),
        growthRate: 0
    });
    return {
        credited: proceeds,
        bankId: id
    };
}
function $bda3664ae16bcdb0$export$9aa478282d1e3dc5(data, factFind, details) {
    const property = $bda3664ae16bcdb0$export$cfdc34b008f59476(factFind, details);
    // DraftFactFind is structurally compatible with FactFind (see types/formDraft.ts);
    // the shared calc-engine fn wants the strict type but defensively parseFloat/coerces internally
    // (see factFindTypes.ts header) regardless, so this cast is safe.
    const summary = (0, $a764bc0f6f904854$export$777cdddf3f231419)(factFind, details);
    const netProceeds = summary?.netProceeds ?? (details.salePrice || 0) - (details.sellingCosts || 0);
    const unallocated = netProceeds - $bda3664ae16bcdb0$export$ed6b4fd849b1a45e(details);
    if (unallocated <= 0) return {
        unallocated: 0,
        routedToEntity: false,
        entityId: null
    };
    const incomeRate = $bda3664ae16bcdb0$var$defaultBankIncomeRate(data.assets);
    const toEntity = !!(property && $bda3664ae16bcdb0$export$c11662d6bbf785af(factFind, property));
    if (toEntity) {
        const entityId = (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(property.ownership) ?? '';
        const structure = (factFind.structures || []).find((s)=>s.id === entityId);
        const name = structure?.name?.trim() || 'Trust or company';
        if (!data.assets) data.assets = {};
        $bda3664ae16bcdb0$export$32a0ff5e6949dfc(data.assets, unallocated, {
            ownership: (0, $1773fcf9595c5c0a$export$66d936c41d42a933)(entityId),
            id: `${$bda3664ae16bcdb0$export$1b362965f2838fdc}${entityId}`,
            description: `Unallocated proceeds \u{2014} ${name} (from property sale)`,
            mergeEntityId: entityId,
            incomeRate: incomeRate
        });
        return {
            unallocated: unallocated,
            routedToEntity: true,
            entityId: entityId
        };
    }
    if (!data.assets) data.assets = {};
    $bda3664ae16bcdb0$export$32a0ff5e6949dfc(data.assets, unallocated, {
        ownership: 'joint',
        id: 'investment-proceeds',
        description: 'Unallocated Investment Sale Proceeds',
        incomeRate: incomeRate
    });
    return {
        unallocated: unallocated,
        routedToEntity: false,
        entityId: null
    };
}
function $bda3664ae16bcdb0$export$4728ec254314fafc(assets, propertyId) {
    if (!assets?.investmentProperty) return;
    assets.investmentProperty = assets.investmentProperty.filter((p)=>!(0, $bd80071df75c742b$export$4d0dc62775eae74e)(p.id, propertyId));
}
function $bda3664ae16bcdb0$export$968f08311f735e7a(data, factFind, details) {
    const property = $bda3664ae16bcdb0$export$cfdc34b008f59476(factFind, details);
    if (!property) return data;
    $bda3664ae16bcdb0$export$4728ec254314fafc(data.assets, property.id);
    if (!data.home) data.home = {};
    if ((details.newHomePurchasePrice || 0) > 0) data.home.value = details.newHomePurchasePrice;
    if (!data.assets) data.assets = {};
    if ((details.radAllocation || 0) > 0) // 'radPaid' is a synthetic bookkeeping row, not one of the catalog AssetType ids.
    data.assets.radPaid = [
        {
            id: 'rad-paid',
            type: 'radPaid',
            description: 'RAD Paid',
            value: details.radAllocation,
            ownership: 'client'
        }
    ];
    $bda3664ae16bcdb0$export$9aa478282d1e3dc5(data, factFind, details);
    // DraftFactFind is structurally compatible with FactFind/FactFindAssetMap (see
    // types/formDraft.ts); the shared calc-engine fn defensively coerces internally regardless, so
    // this cast is safe (see factFindTypes.ts header comment).
    (0, $f1228be62b68f76b$export$a72a115b20fefbbf)(data.assets, factFind, details, {
        idPrefix: 'investment-downsizer-contrib',
        assetId: 'investment-downsizer-contrib',
        partnerAssetId: 'partner-investment-downsizer-contrib'
    });
    if ((details.funeralBondPurchase || 0) > 0) {
        if (!data.assets.funeralBonds) data.assets.funeralBonds = [];
        data.assets.funeralBonds.push({
            id: 'investment-fbond',
            type: 'funeralBonds',
            description: 'Funeral Bond from Proceeds',
            value: details.funeralBondPurchase,
            ownership: 'client'
        });
    }
    return data;
}


/**
 * Recommended minimum emergency fund to keep aside, used consistently across the modules' suggestion engines.
 *
 * Standardised as the GREATER of:
 *   - 6 months of the client's annual living expenses (annual ÷ 2) — the income-replacement rule of thumb; and
 *   - a fixed floor (MIN_EMERGENCY_FUND) — because a retiree's emergencies are lumpy CAPITAL items (a car, a major
 *     home repair, a health event), so a small percentage-of-expenses figure can be dangerously thin.
 *
 * This replaces the previously-scattered flat amounts ($30k/$50k). The client can always choose a different
 * figure; this is the sensible default the funding logic protects, and any reasonable buffer they enter wins.
 */ const $5941a0d5c38ddae8$export$ff3e96665dc0c2f8 = 50000;
function $5941a0d5c38ddae8$export$bec244491e023b43(factFind) {
    const annualLiving = factFind?.expenses?.livingExpenses || 0;
    const sixMonths = Math.round(annualLiving / 2);
    return Math.max($5941a0d5c38ddae8$export$ff3e96665dc0c2f8, sixMonths);
}


function $c549af0b979cab3f$export$75615f10e26bc58f(factFind) {
    const v = factFind?.emergencyFund;
    if (v != null && v !== '') return Math.max(0, parseFloat(String(v)) || 0);
    return (0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind);
}
function $c549af0b979cab3f$export$3b6b9af778b0e124(factFind) {
    if (!(0, $bd80071df75c742b$export$40bc5139f87a7b00)(factFind)) return [];
    const ips = factFind?.assets?.investmentProperty || [];
    return ips.filter((ip)=>(0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(ip.ownership) && (0, $bda3664ae16bcdb0$export$c11662d6bbf785af)(factFind, ip));
}
function $c549af0b979cab3f$export$ce4ad04e32b8081a(factFind) {
    const ips = factFind?.assets?.investmentProperty || [];
    const personal = ips.filter((ip)=>!(0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(ip.ownership) && (Number(ip.value) || 0) > 0).map((property)=>({
            property: property,
            isEntity: false
        }));
    const entity = $c549af0b979cab3f$export$3b6b9af778b0e124(factFind).map((property)=>({
            property: property,
            isEntity: true
        }));
    return [
        ...personal,
        ...entity
    ];
}
function $c549af0b979cab3f$export$889ca99f7e02900c(factFind, emergencyFundLimit = $c549af0b979cab3f$export$75615f10e26bc58f(factFind)) {
    const availableAssets = [];
    (0, $77d0522707ddb581$export$e18ad1b53d14ba76).forEach((type)=>{
        if (!type.isLiquid) return;
        if (!(0, $bd80071df75c742b$export$e5c79349077d175d).has(type.id) && type.id !== 'accountBasedPensions') return;
        const list = factFind.assets?.[type.id];
        if (!list?.length) return;
        list.forEach((asset)=>{
            if (!(0, $bd80071df75c742b$export$6b7e895f645efa6c)(factFind, asset)) return;
            const fullValue = asset.value || 0;
            if (fullValue <= 0) return;
            let value = fullValue;
            if (type.id === 'bankAccounts') value = Math.max(0, fullValue - emergencyFundLimit);
            if (value <= 0) return;
            availableAssets.push({
                type: type.id,
                id: asset.id,
                description: asset.description,
                value: value,
                growthRate: asset.growthRate || (type.id === 'bankAccounts' ? 2 : 5),
                incomeRate: asset.incomeRate || (type.id === 'bankAccounts' ? 2 : type.id === 'shares' ? 4 : 0),
                fullValue: fullValue
            });
        });
    });
    return availableAssets;
}
function $c549af0b979cab3f$export$9ca4abb860f88bf9(radFunding = {}) {
    const manual = {};
    Object.entries(radFunding || {}).forEach(([assetType, liquidations])=>{
        const list = Array.isArray(liquidations) ? liquidations : liquidations ? [
            liquidations
        ] : [];
        list.forEach((liq)=>{
            if (!liq || liq.id == null) return;
            const amount = liq.amount || 0;
            if (amount <= 0) return;
            const key = `${assetType}-${liq.id}`;
            manual[key] = (manual[key] || 0) + amount;
        });
    });
    return manual;
}
function $c549af0b979cab3f$export$587074b1f55c5662(factFind, scenario) {
    let data = structuredClone(factFind);
    const radFunding = scenario?.radFunding || {};
    const manualKeys = $c549af0b979cab3f$export$9ca4abb860f88bf9(radFunding);
    if (Object.keys(manualKeys).length > 0) data = (0, $87af0cc4cc4e8984$export$8a0c5ad907f77392)(data, manualKeys, {});
    const ipDetails = scenario?.strategyOptions?.investmentPropertyDetails;
    if (scenario?.strategyOptions?.sellInvestmentProperty && ipDetails) data = (0, $bda3664ae16bcdb0$export$968f08311f735e7a)(data, factFind, ipDetails);
    return data;
}
function $c549af0b979cab3f$export$880e05a68faa2e27(factFind, scenario) {
    const manualKeys = $c549af0b979cab3f$export$9ca4abb860f88bf9(scenario?.radFunding);
    const { netTotal: fromLiquid } = (0, $bd80071df75c742b$export$e98193fa2b9f521b)(factFind, manualKeys, {});
    const fromIp = scenario?.strategyOptions?.sellInvestmentProperty ? scenario?.strategyOptions?.investmentPropertyDetails?.radAllocation || 0 : 0;
    /*
     * A REVERSE MORTGAGE RAISED FOR THE DEPOSIT IS MONEY PAID TOWARD THE ROOM.
     *
     * This total is what the evaluator uses to strike the daily accommodation payment and the
     * `radPaid` the cost engine assesses, so a source missing from it is a source that quietly does
     * not pay the room. Without this, a candidate named "borrow $400,000 against the home for the
     * room" carried the debt, the interest and the estate cost — and the FULL daily accommodation
     * payment as well, because nothing had been credited against it. The projection was internally
     * consistent and completely wrong, and it would have ranked borrowing as pure loss.
     *
     * `homeEquityRelease.ts` already treats the deposit-absorbed portion as exempt rather than as a
     * countable asset, so this is the other half of a treatment that was only ever half applied.
     * Net of establishment fees, and never more than the room costs.
     */ const rm = scenario?.strategyOptions?.reverseMortgageDetails;
    const fromReverseMortgage = scenario?.strategyOptions?.reverseMortgage && rm?.useForRad && rm.loanStructure !== 'regular_payments' ? Math.max(0, (Number(rm.loanAmount) || 0) - (Number(rm.establishmentFees) || 0)) : 0;
    const roomPrice = Number(scenario?.strategyOptions?.radInput) || Infinity;
    return Math.min(roomPrice, fromLiquid + fromIp + fromReverseMortgage);
}
function $c549af0b979cab3f$export$d71abf032981a594(factFind, property, radAllocation = 0) {
    const salePrice = property.value || 0;
    return {
        selectedPropertyId: property.id,
        salePrice: salePrice,
        sellingCosts: salePrice * 0.025,
        costBase: property.costBase,
        radAllocation: radAllocation,
        newHomePurchasePrice: 0,
        downsizerContribution: 0,
        partnerDownsizerContribution: 0,
        giftingAmount: 0,
        funeralBondPurchase: 0
    };
}
function $c549af0b979cab3f$export$7956e291fd2a25ef(scenarios, factFind, context) {
    const saleable = $c549af0b979cab3f$export$ce4ad04e32b8081a(factFind);
    if (!saleable.length) return scenarios;
    const { radAmount: radAmount, agedCareCosts: agedCareCosts, cleanCoupleValidation: cleanCoupleValidation, MPIR: MPIR, radPercentagesSubset: radPercentagesSubset } = context;
    const percentages = radPercentagesSubset || [
        50,
        70,
        100
    ];
    saleable.forEach(({ property: property, isEntity: isEntity })=>{
        const entityId = isEntity ? (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(property.ownership) : null;
        const structure = entityId ? (factFind.structures || []).find((s)=>s.id === entityId) : undefined;
        const propLabel = property.description?.trim() || structure?.name?.trim() || 'investment property';
        percentages.forEach((percentage)=>{
            const radAmountForThisLevel = radAmount * (percentage / 100);
            const baseDetails = $c549af0b979cab3f$export$d71abf032981a594(factFind, property, 0);
            // DraftFactFind is structurally compatible with FactFind (see
            // types/formDraft.ts); the shared calc-engine fn defensively parseFloat/coerces
            // internally regardless (see factFindTypes.ts header), so this cast is safe.
            const summary = (0, $a764bc0f6f904854$export$777cdddf3f231419)(factFind, baseDetails);
            const netProceeds = summary?.netProceeds ?? 0;
            const radFromSale = Math.min(netProceeds, radAmountForThisLevel);
            if (radFromSale <= 0) return;
            const remainingRad = radAmountForThisLevel - radFromSale;
            let supplementaryRadFunding = {};
            if (remainingRad > 1000) {
                const variants = $c549af0b979cab3f$export$22a1348e28f91bce(factFind, remainingRad);
                supplementaryRadFunding = variants[0]?.radFunding || {};
                const funded = $c549af0b979cab3f$export$880e05a68faa2e27(factFind, {
                    radFunding: supplementaryRadFunding,
                    strategyOptions: {}
                });
                if (funded < remainingRad - 1000) return;
            }
            const ipDetails = $c549af0b979cab3f$export$d71abf032981a594(factFind, property, radFromSale);
            const dapAmount = (radAmount - radAmountForThisLevel) * MPIR + (agedCareCosts?.basicDailyFee || 70) * 365 + (agedCareCosts?.dailyHSC || 0) * 365;
            const baseStrategy = {
                radFunding: supplementaryRadFunding,
                groupKey: `ip-sale-${property.id}-${percentage}`,
                fundingOrderLabel: isEntity ? 'Entity IP sale' : 'Investment property sale',
                strategyOptions: {
                    annualDap: dapAmount,
                    sellInvestmentProperty: true,
                    investmentPropertyDetails: ipDetails,
                    downsizeHome: false,
                    scenarioLivingExpenses: (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(agedCareCosts?.scenarioLivingExpenses, factFind.expenses?.livingExpenses),
                    /* Only an ENTITY sale draws on structure funding. Setting this for a property
                       the client owns outright would tell the engine to reach into a trust that has
                       nothing to do with the sale. */ structureFundingIncluded: isEntity
                }
            };
            scenarios.push({
                ...baseStrategy,
                name: `Pay ${percentage}% RAD, Sell ${propLabel}, Keep Home`,
                groupKey: `${baseStrategy.groupKey}-Keep`,
                strategyOptions: {
                    ...baseStrategy.strategyOptions,
                    rentHome: false
                }
            });
            scenarios.push({
                ...baseStrategy,
                name: `Pay ${percentage}% RAD, Sell ${propLabel}, Rent Home`,
                groupKey: `${baseStrategy.groupKey}-Rent`,
                strategyOptions: {
                    ...baseStrategy.strategyOptions,
                    rentHome: true,
                    rentAmount: factFind.home?.likelyRent || 1000,
                    rentExpenses: factFind.home?.likelyExpenses || 10000,
                    scenarioLivingExpenses: (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(agedCareCosts?.scenarioLivingExpenses, factFind.expenses?.livingExpenses) + (cleanCoupleValidation?.partnerAnnualRent || 0)
                }
            });
        });
    });
    return scenarios;
}
function $c549af0b979cab3f$export$22a1348e28f91bce(factFind, amount, emergencyFundLimit = $c549af0b979cab3f$export$75615f10e26bc58f(factFind)) {
    const availableAssets = $c549af0b979cab3f$export$889ca99f7e02900c(factFind, emergencyFundLimit);
    if (!availableAssets.length) return [
        {
            radFunding: $c549af0b979cab3f$export$216ee3b40248ecf0(factFind, amount, emergencyFundLimit),
            orderLabel: 'Default'
        }
    ];
    const typesPresent = [
        ...new Set(availableAssets.map((a)=>a.type))
    ];
    const typeOrders = $c549af0b979cab3f$var$permutations(typesPresent);
    const ASSET_TYPE_LABELS = {
        bankAccounts: 'Bank',
        accountBasedPensions: 'ABP',
        shares: 'Shares',
        termDeposits: 'Term deposit'
    };
    const results = [];
    /*
     * WHICH PENSION PAYS (decision 10 / F.46, owner 21 Oct 2026). Every order of a couple's pensions is
     * tried too, not only the lowest-earning first (up to three pensions; above that, lowest-earning first
     * only). Ways that draw the same amounts from the same accounts are kept once.
     */ const pensionsByRate = availableAssets.filter((a)=>a.type === 'accountBasedPensions').sort((a, b)=>a.growthRate - b.growthRate);
    const pensionOrders = pensionsByRate.length > 1 && pensionsByRate.length <= 3 ? $c549af0b979cab3f$var$permutations(pensionsByRate) : [
        pensionsByRate
    ];
    const seen = new Set();
    for (const typeOrder of typeOrders)for (const pensionOrder of pensionOrders){
        const sortedAssets = [];
        for (const type of typeOrder)if (type === 'accountBasedPensions') sortedAssets.push(...pensionOrder);
        else sortedAssets.push(...availableAssets.filter((a)=>a.type === type).sort((a, b)=>b.value - a.value));
        const orderLabel = typeOrder.map((t)=>ASSET_TYPE_LABELS[t] || t).join(' -> ') + (pensionOrders.length > 1 ? ` (${pensionOrder.map((p)=>p.description || p.id).join(', ')})` : '');
        const radFunding = $c549af0b979cab3f$var$generateSingleSeFundingStrategy(sortedAssets, amount);
        if (!radFunding) continue;
        const sig = Object.keys(radFunding).sort().map((t)=>`${t}:${radFunding[t].map((e)=>`${e.id}=${Math.round(e.amount || 0)}`).join(',')}`).join('|');
        if (pensionOrders.length > 1 && seen.has(sig)) continue;
        seen.add(sig);
        results.push({
            radFunding: radFunding,
            orderLabel: orderLabel
        });
    }
    if (results.length === 0) return [
        {
            radFunding: $c549af0b979cab3f$export$216ee3b40248ecf0(factFind, amount, emergencyFundLimit),
            orderLabel: 'Default'
        }
    ];
    return results;
}
function $c549af0b979cab3f$export$216ee3b40248ecf0(factFind, amount, emergencyFundLimit = $c549af0b979cab3f$export$75615f10e26bc58f(factFind)) {
    const radFunding = {};
    let remainingAmount = amount;
    const sorted = $c549af0b979cab3f$export$889ca99f7e02900c(factFind, emergencyFundLimit).sort((a, b)=>{
        if (a.type === 'bankAccounts' && b.type !== 'bankAccounts') return -1;
        if (b.type === 'bankAccounts' && a.type !== 'bankAccounts') return 1;
        if (a.type === 'accountBasedPensions' && b.type !== 'accountBasedPensions') return -1;
        if (b.type === 'accountBasedPensions' && a.type !== 'accountBasedPensions') return 1;
        return 0;
    });
    for (const asset of sorted){
        if (remainingAmount <= 0) break;
        const liquidateAmount = Math.min(remainingAmount, asset.value);
        if (liquidateAmount <= 0) continue;
        if (!radFunding[asset.type]) radFunding[asset.type] = [];
        radFunding[asset.type].push({
            id: asset.id,
            amount: liquidateAmount
        });
        remainingAmount -= liquidateAmount;
    }
    return radFunding;
}
function $c549af0b979cab3f$var$generateSingleSeFundingStrategy(sortedAssets, amount) {
    const radFunding = {};
    let remainingAmount = amount;
    for (const asset of sortedAssets){
        if (remainingAmount <= 0) break;
        const liquidateAmount = Math.min(remainingAmount, asset.value);
        if (liquidateAmount <= 0) continue;
        if (!radFunding[asset.type]) radFunding[asset.type] = [];
        radFunding[asset.type].push({
            id: asset.id,
            amount: liquidateAmount
        });
        remainingAmount -= liquidateAmount;
    }
    if (remainingAmount > 1000) return null;
    return radFunding;
}
function $c549af0b979cab3f$var$permutations(arr) {
    if (arr.length <= 1) return [
        arr
    ];
    const result = [];
    for(let i = 0; i < arr.length; i++){
        const rest = arr.slice(0, i).concat(arr.slice(i + 1));
        for (const p of $c549af0b979cab3f$var$permutations(rest))result.push([
            arr[i],
            ...p
        ]);
    }
    return result;
}


/**
 * A plan's name in the client's words (UX review, 17 Oct 2026).
 *
 * The engine names a row for itself — "Pay 40% RAD, Keep Home + Clear Debt (Bank -> ABP)". A family
 * member reads that as code. The same row, said the way an adviser would across the table:
 *
 *   Pay $320,000 up front, keep the home
 *   40% of the room as a refundable deposit; $480,000 paid daily, at $112 a day. Kerry stays in the home.
 *
 * Nothing here is re-derived: the deposit, the room price and the daily payment are the row's own
 * figures. Rows this file does not understand (a move between homes, a village exit, two rooms)
 * fall back to the display name the engine already produces for them, so nothing is ever named wrong.
 */ 
const $95e43332fd84eec4$var$isBaseline = (name)=>/^do nothing\b/i.test(name) || /^pay the dap\b/i.test(name);
function $95e43332fd84eec4$export$b0af1214a22c17c2(row, factFind) {
    const name = String(row.name || '');
    const opts = row.strategyOptions || {};
    const ownsHome = (Number(factFind?.home?.value) || 0) > 0;
    if (opts.downsizeHome || /downsiz/i.test(name)) return 'downsize the home';
    if (opts.rentHome || /rent home|rent the home|rent out/i.test(name)) return 'rent out the home';
    if (opts.sellHome || /\bsell\b/i.test(name)) return 'sell the home';
    if (/keep home|keep the home/i.test(name)) return 'keep the home';
    return ownsHome ? 'keep the home' : null;
}
/** The extras a name can carry — a debt cleared, a lifetime income bought, money borrowed against the home. */ function $95e43332fd84eec4$var$extrasClause(row) {
    const name = String(row.name || '');
    const parts = [];
    if (/clear debt/i.test(name)) parts.push('clear the debt');
    else if (/pay down debt/i.test(name)) parts.push('pay down the debt');
    if ((Number(row.meansTestStrategy?.purchaseAmount) || 0) > 0) parts.push('buy a guaranteed income for life');
    const er = row.equityRelease;
    if (er && (Number(er.loanAmount) || 0) > 0) parts.push(er.kind === 'heas' ? 'borrow through the Home Equity Access Scheme' : 'borrow against the home');
    return parts.length ? `, ${parts.join(', ')}` : '';
}
function $95e43332fd84eec4$export$6cc0d9545ae1511e(plan, factFind) {
    const saved = String(plan?.displayName || '').trim();
    if (saved) return saved;
    const row = plan?.strategy;
    const engineName = String(plan?.name || row?.name || 'Plan');
    if (!row) return engineName;
    const w = $95e43332fd84eec4$export$f973c372d76f95c8(row, factFind, engineName);
    return w.title;
}
function $95e43332fd84eec4$export$f973c372d76f95c8(row, factFind, fallbackTitle) {
    if (!row) return {
        title: fallbackTitle,
        sub: '',
        fallback: true
    };
    const name = String(row.name || '');
    const room = Number(row.radRoomPrice) || 0;
    const paid = Math.max(0, Number(row.radPaidNet) || 0);
    const complex = !!row.facilityMove || !!row.villageExit || !!row.secondRoom;
    if (complex || !(room > 0)) return {
        title: fallbackTitle,
        sub: '',
        fallback: true
    };
    const dap = Number(row.strategySpecificAgedCareCosts?.dailyAccommodationPayment) || 0;
    const unpaid = Math.max(0, room - paid);
    const home = $95e43332fd84eec4$export$b0af1214a22c17c2(row, factFind);
    const extras = $95e43332fd84eec4$var$extrasClause(row);
    const partner = factFind?.adviceFor === 'couple' ? String(factFind?.partner?.firstName || '').trim() : '';
    const partnerStays = partner && home === 'keep the home' && factFind?.goals?.aged_care_for !== 'both';
    if ($95e43332fd84eec4$var$isBaseline(name)) return {
        title: 'Pay the whole room daily',
        sub: `Nothing paid up front and nothing sold; the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(room)} room is charged daily${dap > 0 ? `, at ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(dap))} a day` : ''}.`,
        fallback: false
    };
    const pct = Math.round(paid / room * 100);
    const fullyPaid = unpaid < 0.5;
    const er = row.equityRelease;
    const borrowed = er && (Number(er.loanAmount) || 0) > 0 ? Number(er.loanAmount) : 0;
    // A borrowing plan is named by the borrowing: "Borrow $800,000 against the home, pay the whole room up front".
    const title = borrowed > 0 && paid > 0.5 ? `Borrow ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(borrowed))} ${er?.kind === 'heas' ? 'through the Home Equity Access Scheme' : 'against the home'}, ${fullyPaid ? 'pay the whole room up front' : `pay ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(paid))} up front`}${/clear debt/i.test(name) ? ', clear the debt' : ''}` : paid > 0.5 ? `${fullyPaid ? 'Pay the whole room up front' : `Pay ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(paid))} up front`}${home ? `, ${home}` : ''}${extras}` : `Pay the room daily${home ? `, ${home}` : ''}${extras}`;
    const depositBit = paid > 0.5 ? fullyPaid ? 'The whole room as a refundable deposit' : `${pct}% of the room as a refundable deposit` : 'Nothing paid up front';
    const dailyBit = fullyPaid ? '' : `; ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(unpaid))} paid daily${dap > 0 ? `, at ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(dap))} a day` : ''}`;
    const sub = `${depositBit}${dailyBit}.${partnerStays ? ` ${partner} stays in the home.` : ''}`;
    return {
        title: title,
        sub: sub,
        fallback: false
    };
}


/**
 * fundingSummary — pure helpers for the "What it means over time" narrative beat.
 *
 * Turns a projection array into a plain-language story of how a cashflow deficit is funded
 * across the plan (bank account first, then the next liquid source), and when a source runs
 * low. Shared by every module's insight panel so the future-funding explanation is consistent.
 *
 * No React, no DOM, no app state — easy to unit-test.
 */ 
function $0fe89e03b6df746e$export$7b2b094d6d51893(row) {
    if (!row) return false;
    if (row.tag === 'heloc') return true;
    const label = (row.label || '').toLowerCase();
    return label.includes('heloc') || label.includes('borrowing against the home') || label.includes('borrowed against the home');
}
function $0fe89e03b6df746e$export$b82101157bcb6ca6(row) {
    if (!row) return false;
    if (row.tag === 'rad') return true;
    return (row.label || '').toLowerCase().includes('refundable accommodation deposit');
}
/** What the runway copy calls the deposit when it is the next source. */ const $0fe89e03b6df746e$var$RAD_SOURCE = 'refundable accommodation deposit';
const $0fe89e03b6df746e$var$sumBalances = (list)=>(list || []).reduce((s, a)=>s + (parseFloat(String(a && a.value)) || 0), 0);
// Aged Care / SAH projection rows expose annual cashflow as `cashFlow`; Retirement Village rows use
// `netCashflow` (the village-adjusted figure). Read whichever is present so one helper serves all modules.
const $0fe89e03b6df746e$var$cashFlowOf = (p)=>p && (p.cashFlow ?? p.netCashflow) || 0;
/** One projection row's unfunded shortfall, whatever the engine called it. */ const $0fe89e03b6df746e$var$unfundedOf = (p)=>Number(p.unfundedShortfall) || 0;
function $0fe89e03b6df746e$export$693cc3146baa3244(projections) {
    const years = Array.isArray(projections) ? projections : [];
    const totalYears = years.length;
    if (totalYears === 0) return {
        hasData: false
    };
    let firstDeficitYear = null;
    let bankDepletesYear = null;
    let moneyRunsOutYear = null;
    years.forEach((p, i)=>{
        const yr = p && p.year || i + 1;
        if ($0fe89e03b6df746e$var$cashFlowOf(p) < 0 && firstDeficitYear === null) firstDeficitYear = yr;
        if (bankDepletesYear === null && $0fe89e03b6df746e$var$sumBalances(p && p.assets && p.assets.bankAccounts) < 1000) bankDepletesYear = yr;
        if (moneyRunsOutYear === null && $0fe89e03b6df746e$var$unfundedOf(p) > 0.5) moneyRunsOutYear = yr;
    });
    const hasDeficit = firstDeficitYear !== null;
    // The first year the plan borrows against the home, read off the engine's own drawdown rows
    // rather than inferred from balances — borrowing is an event, not a balance.
    let borrowingStartsYear = null;
    years.forEach((p, i)=>{
        if (borrowingStartsYear !== null) return;
        if ((p?.drawdownBreakdown || []).some($0fe89e03b6df746e$export$7b2b094d6d51893)) borrowingStartsYear = p && p.year || i + 1;
    });
    // The deposit is drawn before anything is borrowed, so this is the earlier of the two events.
    let radDrawStartsYear = null;
    years.forEach((p, i)=>{
        if (radDrawStartsYear !== null) return;
        if ((p?.drawdownBreakdown || []).some($0fe89e03b6df746e$export$b82101157bcb6ca6)) radDrawStartsYear = p && p.year || i + 1;
    });
    // The rate the loan is actually accruing at, from the first year that carries the balance.
    let borrowingRate = (0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279);
    for (const p of years){
        const recorded = parseFloat(String(p?.liabilities?.helocDebt?.[0]?.interestRate ?? ''));
        if (Number.isFinite(recorded) && recorded > 0) {
            borrowingRate = recorded;
            break;
        }
    }
    // What funds the deficit once the bank runs out — first non-trivial liquid source after that
    // point, and failing that, borrowing. Borrowing is checked LAST because it is the engine's own
    // last resort: it only lends once bank, pension and shares are exhausted.
    let nextSource = null;
    if (bankDepletesYear !== null) {
        const depletesYear = bankDepletesYear;
        const after = years.find((p, i)=>(p && p.year || i + 1) >= depletesYear) || {};
        if ($0fe89e03b6df746e$var$sumBalances(after.assets && after.assets.accountBasedPensions) > 1000) nextSource = 'account-based pension';
        else if ($0fe89e03b6df746e$var$sumBalances(after.assets && after.assets.shares) > 1000) nextSource = 'shares';
        else if (radDrawStartsYear !== null) nextSource = $0fe89e03b6df746e$var$RAD_SOURCE;
        else if (borrowingStartsYear !== null) nextSource = 'borrowing against the home';
    }
    const fundedFullPlan = !hasDeficit || bankDepletesYear === null;
    const coveredPct = fundedFullPlan ? 100 : Math.max(4, Math.round(Math.max(0, (bankDepletesYear ?? 0) - 1) / totalYears * 100));
    return {
        hasData: true,
        hasDeficit: hasDeficit,
        totalYears: totalYears,
        firstDeficitYear: firstDeficitYear,
        bankDepletesYear: bankDepletesYear,
        nextSource: nextSource,
        fundedFullPlan: fundedFullPlan,
        coveredPct: coveredPct,
        borrowingStartsYear: borrowingStartsYear,
        borrowingRate: borrowingRate,
        radDrawStartsYear: radDrawStartsYear,
        moneyRunsOutYear: moneyRunsOutYear
    };
}
function $0fe89e03b6df746e$export$464558962ff4a811(projections, horizonYears) {
    const s = $0fe89e03b6df746e$export$693cc3146baa3244(projections);
    if (!s.hasData) return null;
    const basis = `Tested over ${horizonYears} years.`;
    if (!s.hasDeficit) return {
        headline: "Cashflow stays positive \u2014 no savings are drawn down",
        coveredPct: 100,
        leftLabel: 'now',
        rightLabel: 'no gap to fund',
        depleted: false,
        flag: null,
        basis: basis,
        exhaustedYear: null,
        bankDepletesYear: null,
        radDrawStartsYear: null,
        borrowingStartsYear: null
    };
    const { bankDepletesYear: bankDepletesYear, borrowingStartsYear: borrowingStartsYear, borrowingRate: borrowingRate, radDrawStartsYear: radDrawStartsYear, moneyRunsOutYear: moneyRunsOutYear, nextSource: nextSource, totalYears: totalYears = horizonYears } = s;
    // Said whenever the deposit is drawn on, because it changes two figures a client cares about —
    // the refund at the end and the daily accommodation payment — and neither shows up in cashflow.
    const radNote = radDrawStartsYear != null ? ` From about year ${radDrawStartsYear} the care fees are drawn from the refundable accommodation deposit, which reduces the refund when care ends and raises the daily accommodation payment.` : '';
    /*
     * "SAVINGS" MEANS ALL SAVINGS (owner-caught, 2026-08-26). This headline first read
     * `bankDepletesYear`, which is only the first pool emptying — the BANK ACCOUNT falling below
     * $1,000. For a household with $165,000 in the bank and $500,000 in an account-based pension
     * that produced "Savings last about 4 years" on the same screen as the walk-in note's "would
     * cover that for roughly 9 years". Both were right about different things and the screen looked
     * broken, which is the worst outcome of the two.
     *
     * The runway is therefore the year the savings are ACTUALLY exhausted: the year borrowing
     * begins (the engine only lends once bank, pension and shares are gone) or, where there is
     * nothing to borrow against, the year the engine could fund nothing at all. Which pool empties
     * first is real but secondary, and is said underneath rather than in the headline.
     */ const exhaustedYear = borrowingStartsYear ?? moneyRunsOutYear;
    if (exhaustedYear == null) return {
        headline: `Savings last beyond ${horizonYears} years`,
        coveredPct: 100,
        leftLabel: 'now',
        rightLabel: `still funded at year ${horizonYears}`,
        depleted: false,
        flag: bankDepletesYear != null && nextSource ? `The bank account runs low around year ${bankDepletesYear}; from then the shortfall comes from the ${nextSource}.${nextSource === $0fe89e03b6df746e$var$RAD_SOURCE ? ' Each dollar drawn reduces the refund when care ends and raises the daily accommodation payment.' : ''}` : null,
        basis: basis,
        exhaustedYear: null,
        bankDepletesYear: bankDepletesYear ?? null,
        radDrawStartsYear: radDrawStartsYear ?? null,
        borrowingStartsYear: null
    };
    const years = exhaustedYear === 1 ? 'about a year' : `about ${exhaustedYear} years`;
    const borrows = borrowingStartsYear != null;
    // The first pool to empty, mentioned only when it is genuinely earlier than the headline year.
    const firstPoolNote = bankDepletesYear != null && bankDepletesYear < exhaustedYear && nextSource ? ` The bank account runs low around year ${bankDepletesYear}; the ${nextSource} carries it from there.` : '';
    return {
        headline: `Savings last ${years}`,
        coveredPct: Math.max(4, Math.round(Math.max(0, exhaustedYear - 1) / totalYears * 100)),
        leftLabel: 'now',
        rightLabel: `savings gone ~year ${exhaustedYear}`,
        depleted: true,
        // Borrowing gets the warning, not merely a mention: it is a debt that grows against the
        // home until the home is sold, which is a different thing from spending another account.
        flag: borrows ? `From about year ${borrowingStartsYear} the plan borrows against the home through a reverse mortgage at about ${borrowingRate}% \u{2014} nothing is repaid, so that debt grows each year until the home is sold, and it reduces what is left at the end.${radNote}${firstPoolNote}` : `From about year ${exhaustedYear} there is nothing accessible left to cover the shortfall \u{2014} worth planning another source.${radNote}${firstPoolNote}`,
        basis: basis,
        exhaustedYear: exhaustedYear,
        bankDepletesYear: bankDepletesYear ?? null,
        radDrawStartsYear: radDrawStartsYear ?? null,
        borrowingStartsYear: borrowingStartsYear ?? null
    };
}
function $0fe89e03b6df746e$export$437127b6aedd5958(projections) {
    const s = $0fe89e03b6df746e$export$693cc3146baa3244(projections);
    if (!s.hasData) return null;
    const { hasDeficit: hasDeficit, totalYears: totalYears = 0, firstDeficitYear: firstDeficitYear, bankDepletesYear: bankDepletesYear, nextSource: nextSource, fundedFullPlan: fundedFullPlan, coveredPct: coveredPct = 100, borrowingStartsYear: borrowingStartsYear, borrowingRate: borrowingRate, radDrawStartsYear: radDrawStartsYear } = s;
    if (!hasDeficit) return {
        hasDeficit: false,
        headline: `Your cashflow stays positive across your ${totalYears}-year plan \u{2014} no savings drawdown needed.`,
        coveredPct: 100,
        leftLabel: `${totalYears}-year plan`,
        rightLabel: 'no gap',
        depleted: false,
        flag: null
    };
    // Lead differs when the first years are a surplus and the shortfall only appears later.
    const lead = (firstDeficitYear ?? 0) > 1 ? `Your cashflow starts positive, then turns to a shortfall around Year ${firstDeficitYear}. From then it's ` : `Each year's shortfall is `;
    if (fundedFullPlan) return {
        hasDeficit: true,
        headline: `${lead}drawn from the bank account, which lasts the full ${totalYears}-year plan.`,
        coveredPct: 100,
        leftLabel: 'bank account',
        rightLabel: 'covers the full plan',
        depleted: false,
        flag: null
    };
    const base = {
        hasDeficit: true,
        headline: `${lead}drawn from the bank account, which runs low around Year ${bankDepletesYear} of ${totalYears}.`,
        coveredPct: coveredPct,
        leftLabel: 'bank account',
        rightLabel: `runs low ~Year ${bankDepletesYear}`,
        depleted: true
    };
    // Borrowing gets its own sentence rather than being listed like a savings account: it is a debt
    // that grows, and a client reading "funded from borrowing against the home" needs to be told
    // what that costs them, not merely where the money appears from.
    if (nextSource === 'borrowing against the home') return {
        ...base,
        flag: `After about Year ${borrowingStartsYear ?? bankDepletesYear} the savings no longer cover the shortfall, so the plan borrows against the home through a reverse mortgage at about ${borrowingRate}%. Nothing is repaid, so that debt grows each year until the home is sold, and it reduces what is left at the end.`
    };
    // The deposit is the client's own money, but drawing it changes two figures cashflow never shows:
    // the refund at the end, and the accommodation payment from the following year.
    if (nextSource === $0fe89e03b6df746e$var$RAD_SOURCE) {
        const then = radDrawStartsYear != null && borrowingStartsYear != null ? ` Once the deposit is used up (around Year ${borrowingStartsYear}) the plan borrows against the home through a reverse mortgage at about ${borrowingRate}%.` : '';
        return {
            ...base,
            flag: `After about Year ${radDrawStartsYear ?? bankDepletesYear} the care fees are drawn from the refundable accommodation deposit. Each dollar drawn reduces the refund when care ends and raises the daily accommodation payment.${then}`
        };
    }
    return {
        ...base,
        flag: nextSource ? `After about Year ${bankDepletesYear}, the shortfall is then funded from the ${nextSource}.` : `After about Year ${bankDepletesYear} there aren't enough easily-accessible savings to cover the shortfall \u{2014} worth planning another source (for example, selling an asset).`
    };
}


/**
 * A chosen plan's saved record, brought up to date by a run that found the same plan again (25 Oct 2026).
 *
 * Home and each module's plan page read the figures saved when the plan was chosen; the plan's card reads
 * the latest run. When the rules or the day moved in between, the two disagreed for one plan ($3,286,281
 * on Home, $3,285,977 on the card). The record keeps who it is (id, when it was chosen, anything else on
 * it) and takes the run's figures. Returns null when nothing would change, so callers write nothing.
 */ const $78a369bbf1e0d995$var$FIGURES = [
    'legacyEstimate',
    'cashFlow',
    'agePension',
    'agedCareCost',
    'annualContribution'
];
const $78a369bbf1e0d995$var$sameFigures = (a, b)=>$78a369bbf1e0d995$var$FIGURES.every((k)=>Math.round(Number(a?.[k]) || 0) === Math.round(Number(b?.[k]) || 0));
function $78a369bbf1e0d995$export$d5bd7fb56baea936(records, fresh, isSamePlan = $78a369bbf1e0d995$export$5688de2ee371225, now = new Date()) {
    const at = records.findIndex((r)=>r.type === fresh.type && r.chosen === true && r.source === fresh.source && isSamePlan(r, fresh));
    if (at < 0) return null;
    const saved = records[at];
    if ($78a369bbf1e0d995$var$sameFigures(saved.outputs, fresh.outputs) && !saved.outOfDate) return null;
    const next = [
        ...records
    ];
    const { outOfDate: _found, ...kept } = {
        ...saved,
        ...fresh
    };
    next[at] = {
        ...kept,
        id: saved.id,
        createdAt: saved.createdAt,
        chosen: true,
        retestedAt: now.toISOString()
    };
    return next;
}
function $78a369bbf1e0d995$export$f4ec6e978b61cc57(record) {
    const o = record?.outOfDate;
    return o && typeof o.reason === 'string' && o.reason ? {
        reason: o.reason,
        at: String(o.at || '')
    } : null;
}
function $78a369bbf1e0d995$export$d20c84e2101d7d8a(records, type, reason, now = new Date()) {
    const at = records.findIndex((r)=>r.type === type && r.chosen === true);
    if (at < 0 || $78a369bbf1e0d995$export$f4ec6e978b61cc57(records[at])?.reason === reason) return null;
    const next = [
        ...records
    ];
    next[at] = {
        ...records[at],
        outOfDate: {
            reason: reason,
            at: now.toISOString()
        }
    };
    return next;
}
const $78a369bbf1e0d995$export$a2028cac13d6740f = "It was not among the plans when they were tested again, so its figures are out of date \u2014 open it to choose again.";
function $78a369bbf1e0d995$export$5688de2ee371225(saved, fresh) {
    const a = saved.strategy || {};
    const b = fresh.strategy || {};
    return a.name != null && String(a.name) === String(b.name) && Math.abs((Number(a.radRoomPrice) || 0) - (Number(b.radRoomPrice) || 0)) < 1 && Math.abs((Number(a.radPaidNet) || 0) - (Number(b.radPaidNet) || 0)) < 1;
}
const $78a369bbf1e0d995$export$25d19cb30292229 = "Chosen before the figures on the file were changed, so its figures are out of date \u2014 open it to choose again.";
const $78a369bbf1e0d995$var$amountOfItem = (item)=>{
    const o = item || {};
    return Math.round(Number(o.value ?? o.balance ?? o.amount ?? o.outstanding ?? 0) || 0);
};
const $78a369bbf1e0d995$var$listAmounts = (group)=>Object.keys(group || {}).sort().map((k)=>{
        const v = group[k];
        return `${k}:${Array.isArray(v) ? v.map($78a369bbf1e0d995$var$amountOfItem).join(',') : ''}`;
    }).join('|');
const $78a369bbf1e0d995$var$numericLeaves = (o, path = '')=>{
    if (o == null) return [];
    if (typeof o === 'number') return Number.isFinite(o) ? [
        `${path}=${Math.round(o)}`
    ] : [];
    if (typeof o === 'boolean') return [
        `${path}=${o}`
    ];
    if (Array.isArray(o)) return o.flatMap((v, i)=>$78a369bbf1e0d995$var$numericLeaves(v, `${path}[${i}]`));
    if (typeof o === 'object') return Object.keys(o).sort().filter((k)=>!/^id$|At$/.test(k)).flatMap((k)=>$78a369bbf1e0d995$var$numericLeaves(o[k], `${path}.${k}`));
    return [];
};
function $78a369bbf1e0d995$export$236630ee0fd3b65b(factFind) {
    const f = factFind || {};
    const person = (p)=>String((p || {}).dob || '');
    const text = [
        String(f.adviceFor || ''),
        person(f.client),
        f.adviceFor === 'couple' ? person(f.partner) : '',
        String(Math.round(Number((f.home || {}).value) || 0)),
        $78a369bbf1e0d995$var$listAmounts(f.assets),
        $78a369bbf1e0d995$var$listAmounts(f.liabilities),
        $78a369bbf1e0d995$var$numericLeaves(f.income).join(';'),
        String(Math.round(Number((f.expenses || {}).livingExpenses) || 0))
    ].join('#');
    let h = 5381;
    for(let i = 0; i < text.length; i++)h = (h * 33 ^ text.charCodeAt(i)) >>> 0;
    return h.toString(36);
}
function $78a369bbf1e0d995$export$ceccff7104f70d1e(record, factFind) {
    if (!record) return null;
    const marked = $78a369bbf1e0d995$export$f4ec6e978b61cc57(record);
    if (marked) return marked.reason;
    const saved = record.inputsFingerprint;
    return typeof saved === 'string' && saved && saved !== $78a369bbf1e0d995$export$236630ee0fd3b65b(factFind) ? $78a369bbf1e0d995$export$25d19cb30292229 : null;
}
function $78a369bbf1e0d995$export$d5989af62c88c0aa(records, id, plan, baseline, fingerprint, now = new Date()) {
    const at = records.findIndex((r)=>r.id === id);
    if (at < 0) return null;
    const saved = records[at];
    const inputs = saved.inputs || {};
    const card = inputs.card || null;
    const outputs = saved.outputs || {};
    const r = (n)=>Math.round(Number(n) || 0);
    const cardPlan = card?.plan || {};
    const same = r(Number(outputs.legacyEstimate)) === r(plan.legacy) && r(Number(outputs.agePension)) === r(plan.pension) && r(Number(outputs.cashFlow)) === r(plan.cashflow) && (!card || r(Number(cardPlan.legacy)) === r(plan.legacy) && r(Number(cardPlan.pension)) === r(plan.pension) && r(Number(cardPlan.cashflow)) === r(plan.cashflow)) && !$78a369bbf1e0d995$export$f4ec6e978b61cc57(saved) && saved.inputsFingerprint === fingerprint;
    if (same) return null;
    const next = [
        ...records
    ];
    const { outOfDate: _gone, ...kept } = saved;
    next[at] = {
        ...kept,
        inputsFingerprint: fingerprint,
        retestedAt: now.toISOString(),
        inputs: card ? {
            ...inputs,
            card: {
                ...card,
                plan: {
                    ...cardPlan,
                    ...plan
                },
                ...baseline ? {
                    baseline: baseline
                } : {}
            }
        } : inputs,
        outputs: {
            ...outputs,
            legacyEstimate: plan.legacy,
            agePension: plan.pension,
            cashFlow: plan.cashflow
        }
    };
    return next;
}
function $78a369bbf1e0d995$export$91485c71ed77db22(records, id, reason, now = new Date()) {
    const at = records.findIndex((r)=>r.id === id);
    if (at < 0 || $78a369bbf1e0d995$export$f4ec6e978b61cc57(records[at])?.reason === reason) return null;
    const next = [
        ...records
    ];
    next[at] = {
        ...records[at],
        outOfDate: {
            reason: reason,
            at: now.toISOString()
        }
    };
    return next;
}


/**
 * AGED CARE: WHAT THE FAMILY RECEIVES FROM A PLAN'S GUARANTEED INCOME (guaranteed income review E4/M4, 21 Oct
 * 2026; the agreed mock-up docs/ux-review/annuities/ screens 3 and 4).
 *
 * The shared table (AnnuityFamilyPanel) on every aged care plan with a guaranteed income: the tested plan cards,
 * the chosen plan when the client comes back, and the hand-built plan. A tested plan is compared with THE SAME
 * DEPOSIT WITHOUT THE LEVER: agedCareMeansTestCandidates layers each lever onto "Do Nothing" and the first
 * "Pay 50/75/100% RAD…" of each level and names the candidate `${base.name} + …`, so the base is the evaluated
 * row whose name is everything before " + ". The hand-built plan has no such twin, so it shows no comparison.
 *
 * Also here: which engine rows are income only (E5), so the panel can hold "Choose this plan" until the client
 * has confirmed it.
 */ 
parcelRequire("acw62");

/**
 * WHAT THE FAMILY RECEIVES FROM THE GUARANTEED INCOME, IF DEATH COMES EARLY (owner, 21 Oct 2026 — the guaranteed
 * income review E4/M4/R2 and the agreed mock-up, docs/ux-review/annuities/ screens 3 and 4).
 *
 * Every "left to the family" figure assumes the person lives the whole planning period. A family whose mother
 * bought an income-only annuity and passed away months later was never shown that outcome. This panel shows it
 * on every plan with a guaranteed income, tested or hand-built, in every module: at the start, the middle and
 * the end of the planning period, what comes back from the guaranteed income, what the family receives in
 * total with this plan, and — where the module has it — the same plan without the guaranteed income.
 *
 * POSITIONING (owner: "we don't want to offend"). It sits inside the guaranteed-income panel as plain
 * information: "If Kerry passes away", no warning colour for the types that return the money; the amber rail
 * only for income only, where the table says "nothing".
 *
 * The figures are the projection's own: each year's row carries the assets as they stand, and an annuity's
 * value there is what it pays on death that year (annuityNetWorthValueOf: the full price for the
 * annuity-and-life-cover type, the capital-access schedule for money back, nothing for income only); "the
 * family receives" is that year's estate (net worth less any tax on selling an investment property, estateOf).
 */ 
parcelRequire("acw62");


/**
 * THE TAX ON AN INVESTMENT PROPERTY WHEN IT IS SOLD, INCLUDING BY THE ESTATE (owner, 21 Oct 2026 — the
 * village review, applied to every module).
 *
 * A projection carries an investment property to the end at its value and never sells it, so "left to
 * the family" counted the whole value — the capital gains tax that falls due when the family (or the
 * estate) sells it was never taken off. Death is not itself a CGT event for the property (ITAA 1997
 * s 128-10): the beneficiary inherits the cost base, and the tax is paid on the sale. This estimates that
 * tax at each year's close as if the property were sold then, with the same single CGT engine every sale
 * in the app uses (`computeDisposalCgt`: 50% discount, the cost base held — or the app's cost-base
 * assumption where none is entered — pre-CGT property exempt, the household's own tax position that year
 * as the stand-in for the beneficiaries', whose rates are not known).
 *
 * It is NOT taken off net worth, which stays the market value of what is owned; only the figure left to
 * the family nets it. A former home being rented out is a main residence within the six-year rule and
 * is treated as the CGT engine treats it.
 */ 

const $7ca740f4c8b36af2$var$num = (v)=>Number(v) || 0;
function $7ca740f4c8b36af2$export$37c51fd14c5714ea(factFind, financials, disposalDate) {
    const props = factFind?.assets?.investmentProperty || [];
    let total = 0;
    for (const asset of props){
        const value = $7ca740f4c8b36af2$var$num(asset?.value);
        if (!(value > 0)) continue;
        // A former home not rented out is still exempt as a main residence (no other is nominated).
        if (asset?.formerHome === true && !asset?.firstRentedOn) continue;
        const r = (0, $1fbcfc2df3ed29e9$export$c06c916a0ca433d3)({
            taxContext: (0, $77244093e528572f$export$ccd3cb45b428c7dc)(factFind, financials),
            asset: asset,
            salePrice: value,
            sellingCosts: value * 0.025,
            originalAssetValue: value,
            disposalDate: disposalDate,
            structures: factFind?.structures
        });
        total += Math.max(0, $7ca740f4c8b36af2$var$num(r.estimatedCGT));
    }
    return Math.round(total);
}
function $7ca740f4c8b36af2$export$2d18df95f9b64c35(factFind, financials, disposalDate, firstRentedOn) {
    const home = factFind?.home;
    const value = $7ca740f4c8b36af2$var$num(home?.value);
    if (!(value > 0) || !firstRentedOn || !Number.isFinite(firstRentedOn.getTime())) return 0;
    const when = disposalDate ? new Date(disposalDate) : new Date();
    const rentedOn = `${firstRentedOn.getFullYear()}-${String(firstRentedOn.getMonth() + 1).padStart(2, '0')}`;
    const asset = {
        id: 'home',
        description: 'Family home',
        value: value,
        growthRate: home?.homeGrowthRate != null && Number.isFinite(Number(home.homeGrowthRate)) ? Number(home.homeGrowthRate) : undefined,
        ownership: home?.ownership && home.ownership !== 'other_entity' ? home.ownership : 'joint',
        formerHome: true,
        firstRentedOn: rentedOn
    };
    const r = (0, $1fbcfc2df3ed29e9$export$c06c916a0ca433d3)({
        taxContext: (0, $77244093e528572f$export$ccd3cb45b428c7dc)(factFind, financials),
        asset: asset,
        salePrice: value,
        sellingCosts: value * 0.025,
        originalAssetValue: value,
        disposalDate: when,
        // The value is this year's, so the cost-base reset is taken back from this year to the day it was let.
        valuationDate: when
    });
    return Math.round(Math.max(0, $7ca740f4c8b36af2$var$num(r.estimatedCGT)));
}
function $7ca740f4c8b36af2$export$8bec68a96a4d6d98(row) {
    if (!row || row.netWorth == null || !Number.isFinite(Number(row.netWorth))) return null;
    return Number(row.netWorth) - $7ca740f4c8b36af2$var$num(row.estateCgt);
}


function $8665f80549f60a1b$export$6b451904abde1f6a(horizonYears, rowCount) {
    const last = Math.max(1, Math.min(Math.round(horizonYears) || 1, rowCount || 1));
    const mid = Math.round((1 + last) / 2);
    return [
        ...new Set([
            1,
            mid,
            last
        ])
    ].filter((y)=>y >= 1 && y <= last);
}
/** Ids of the annuities already on the file, so the plan's new one can be told apart. */ function $8665f80549f60a1b$var$fileAnnuityIds(factFind) {
    const list = factFind?.assets?.annuities || [];
    return new Set(list.map((a)=>String(a?.id)));
}
function $8665f80549f60a1b$export$9d518f1287e3f18f(row, factFind) {
    const list = row?.assets?.annuities || [];
    const onFile = $8665f80549f60a1b$var$fileAnnuityIds(factFind);
    return list.filter((a)=>!onFile.has(String(a?.id))).reduce((t, a)=>t + (0, $f7f7b62814c3b615$export$38d1175d7c1034ee)(a), 0);
}
const $8665f80549f60a1b$var$estate = (row)=>row ? (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(row) : null;
const $8665f80549f60a1b$export$a8ddd02d6d0a3d46 = ({ factFind: factFind, personName: personName, amount: amount, kind: kind, incomeAYear: incomeAYear, rows: rows, compareRows: compareRows, compareNote: compareNote, horizonYears: horizonYears, testId: testId = 'annuity-family-panel', frozen: frozen = null })=>{
    const list = rows || [];
    const frozenRows = frozen && frozen.length ? frozen : null;
    if (!list.length && !frozenRows || !(amount > 0)) return null;
    const years = $8665f80549f60a1b$export$6b451904abde1f6a(horizonYears, list.length);
    const withCompare = frozenRows ? frozenRows.some((r)=>r.without != null) : !!compareRows?.length;
    const when = (y)=>y === 1 ? 'In the first year' : `After ${y} years`;
    const money = (n)=>n == null ? "\u2014" : (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
    const amountWords = (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(amount));
    const income = incomeAYear != null && incomeAYear > 0 ? `${personName} receives about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(incomeAYear))} a year for life. ` : '';
    const closing = kind === 'fullBack' ? `${income}The full ${amountWords} goes back to the family at any time. Most of what is paid buys life cover, so the pension and fee savings are smaller than with the other types.` : kind === 'moneyBack' ? `${income}The whole ${amountWords} goes back to the family in the early years; after that a smaller amount, falling to nothing once ${personName} reaches life expectancy.` : `${income}If ${personName} passes away early, the ${amountWords} is not returned, so the family receives less than without it.`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `space-y-2 rounded-xl border border-slate-200 border-l-4 bg-white px-4 py-3 text-[13px] text-slate-700 ${kind === 'incomeOnly' ? 'border-l-amber-400' : 'border-l-brand-navy'}`,
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[14px] font-semibold text-slate-900",
                children: "What the family receives from the guaranteed income"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "overflow-x-auto",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    className: "w-full min-w-[360px] text-[13px] tabular-nums",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                className: "border-b border-slate-200 text-left align-bottom text-[11.5px] font-semibold leading-tight text-slate-500",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                        className: "py-1.5 pr-3 font-semibold",
                                        children: [
                                            "If ",
                                            personName,
                                            " passes away"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "py-1.5 pr-3 text-right",
                                        children: "Comes back"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "py-1.5 pr-3 text-right",
                                        children: "The family receives"
                                    }),
                                    withCompare && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "py-1.5 text-right",
                                        children: "Without it"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                            children: [
                                frozenRows && frozenRows.map((r, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "border-b border-slate-100 last:border-0",
                                        "data-testid": `${testId}-row-${i}`,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "whitespace-nowrap py-1.5 pr-3",
                                                children: r.label
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-1.5 pr-3 text-right",
                                                children: r.fromAnnuity < 1 ? 'nothing' : money(r.fromAnnuity)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-1.5 pr-3 text-right",
                                                children: money(r.withPlan)
                                            }),
                                            withCompare && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-1.5 text-right",
                                                children: money(r.without)
                                            })
                                        ]
                                    }, r.label)),
                                !frozenRows && years.map((y)=>{
                                    const back = $8665f80549f60a1b$export$9d518f1287e3f18f(list[y - 1], factFind);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "border-b border-slate-100 last:border-0",
                                        "data-testid": `${testId}-year-${y}`,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "whitespace-nowrap py-1.5 pr-3",
                                                children: when(y)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-1.5 pr-3 text-right",
                                                children: back < 1 ? 'nothing' : money(back)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-1.5 pr-3 text-right",
                                                children: money($8665f80549f60a1b$var$estate(list[y - 1]))
                                            }),
                                            withCompare && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-1.5 text-right",
                                                children: money($8665f80549f60a1b$var$estate(compareRows[Math.min(y, compareRows.length) - 1]))
                                            })
                                        ]
                                    }, y);
                                })
                            ]
                        })
                    ]
                })
            }),
            withCompare && compareNote && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[12.5px] text-slate-500",
                children: [
                    "\u201CWithout it\u201D is ",
                    compareNote,
                    ", so the difference is the guaranteed income alone."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[12.5px] text-slate-600",
                children: closing
            })
        ]
    });
};
function $8665f80549f60a1b$export$3ab75b1250c8af22(a) {
    if (a?.annuityType === 'guaranteed') return 'fullBack';
    const r = a?.residualCapital != null ? Number(a.residualCapital) : Number(a?.annuityResidualPercent) / 100;
    return Number.isFinite(r) && r > 0 ? 'moneyBack' : 'incomeOnly';
}
var $8665f80549f60a1b$export$2e2bcd8739ae039 = $8665f80549f60a1b$export$a8ddd02d6d0a3d46;


/**
 * INCOME ONLY NEEDS THE CLIENT'S CONFIRMATION, IN EVERY MODULE, TESTED OR HAND-BUILT (owner, 21 Oct 2026; the
 * guaranteed income review E5/M2/R1 and the agreed mock-up, docs/ux-review/annuities/).
 *
 * A lifetime annuity with nothing returned pays the most, and in return the money is gone for good: nothing
 * to the family on death, even soon after buying it, and no cash-out value if plans change. A plan with one
 * cannot be chosen or saved until the client has confirmed it — and the confirmation is a RECORD, not a
 * yes/no: the amount, the date and the exact words shown, kept on the file (`goals.incomeOnlyConfirmation`)
 * and printed in the advice document. It belongs to that amount: if the amount changes, the client is asked
 * again. "I never want to be sued" (owner).
 *
 * The words are the client's own statement, so the stored words are always in the client's voice; an adviser
 * viewing the file reads the same statement about the client.
 */ 
parcelRequire("acw62");
/**
 * WHO a figure is about, in words (owner, 18 Oct 2026: "you keep bringing it back to just Robert … look
 * at who the goal applies to, don't just assume"; module reviews, 18 Oct: "Where Colin stands today" on
 * Colin and Shelly's file, "Where Joe stands today" on Joe and Kim's).
 *
 * Money figures — the Age Pension, cashflow, net worth, the estate — belong to the HOUSEHOLD, so a couple
 * is always named as both. A goal that the profile records per person ("Who is the goal … for?") is
 * named from that answer instead: pass `forWhom`.
 */ function $5d864ab5b3ee155d$export$49dda806cf6f3f0e(factFind, forWhom) {
    const client = String(factFind?.client?.firstName || '').trim();
    const partner = String(factFind?.partner?.firstName || '').trim();
    const isCouple = factFind?.adviceFor === 'couple' && !!partner;
    let names;
    if (!client) names = 'you';
    else if (!isCouple) names = client;
    else if (forWhom === 'client') names = client;
    else if (forWhom === 'partner') names = partner;
    else names = `${client} and ${partner}`;
    const plural = names === 'you' || names.includes(' and ');
    const possessive = names === 'you' ? 'your' : /s$/i.test(names) ? `${names}'` : `${names}'s`;
    return {
        names: names,
        plural: plural,
        possessive: possessive,
        stand: plural ? 'stand' : 'stands'
    };
}
/*
 * WHO IS READING (owner, 21 Oct 2026, village review decision 13): "you" when the client is signed in,
 * the household's names when an adviser opens the file from the partner portal, and names in the advice
 * document either way. The router sets this on every render from the professional case being open.
 */ let $5d864ab5b3ee155d$var$adviserViewing = false;
function $5d864ab5b3ee155d$export$ac23cdfd4b789bf(value) {
    $5d864ab5b3ee155d$var$adviserViewing = value;
}
function $5d864ab5b3ee155d$export$879d88d360a0f068() {
    return $5d864ab5b3ee155d$var$adviserViewing;
}
function $5d864ab5b3ee155d$export$4efdf34f2488f14a(factFind, forWhom) {
    const w = $5d864ab5b3ee155d$export$49dda806cf6f3f0e(factFind, forWhom);
    const toClient = !$5d864ab5b3ee155d$var$adviserViewing || w.names === 'you';
    if (toClient) return {
        you: true,
        names: 'you',
        Names: 'You',
        possessive: 'your',
        Possessive: 'Your',
        they: 'you',
        They: 'You',
        them: 'you',
        their: 'your',
        Their: 'Your',
        are: 'are',
        have: 'have',
        s: '',
        couple: w.names.includes(' and ')
    };
    const plural = w.plural;
    return {
        you: false,
        names: w.names,
        Names: w.names,
        possessive: w.possessive,
        Possessive: w.possessive,
        they: 'they',
        They: 'They',
        them: 'them',
        their: 'their',
        Their: 'Their',
        are: plural ? 'are' : 'is',
        have: plural ? 'have' : 'has',
        s: plural ? '' : 's',
        couple: plural
    };
}
/*
 * SHARED COPY, TURNED TO THE READER (village rebuild item 8, 21 Oct 2026). Copy written once for every
 * module — the risks, the explainers — speaks to the client ("If you need money in a hurry…"). An adviser
 * reading it about John and Kerry should read "If they need money in a hurry…". For the client this returns
 * the text unchanged. "you" after a verb or preposition is the object ("costs you income" → "costs them
 * income"); anywhere else it is the subject.
 */ const $5d864ab5b3ee155d$var$OBJECT_AFTER = /\b(to|for|with|from|costs?|gives?|pays?|tells?|lets?|helps?|leaves?|charges?|owes?|shows?|protects?|suits?)\s+$/i;
function $5d864ab5b3ee155d$export$ad89789727bbada3(text, v) {
    if (v.you || !text) return text;
    return text.replace(/\byourselves\b|\byourself\b/g, 'themselves').replace(/\bYours\b/g, 'Theirs').replace(/\byours\b/g, 'theirs').replace(/\bYour\b/g, 'Their').replace(/\byour\b/g, 'their').replace(/\bYou('d|'ll|'re|'ve)?\b/g, (_m, c)=>`They${c || ''}`).replace(/\byou('d|'ll|'re|'ve)?\b/g, (_m, c, offset, whole)=>!c && $5d864ab5b3ee155d$var$OBJECT_AFTER.test(whole.slice(Math.max(0, offset - 12), offset)) ? 'them' : `they${c || ''}`);
}



const $5eae79c7e46ed27e$export$9a351e8db0ad2808 = 'incomeOnlyConfirmation';
function $5eae79c7e46ed27e$export$f360ca3a161badd2(amount) {
    return `I understand that nothing from the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(amount))} will come back to me or my family, even if I pass away soon after buying it.`;
}
function $5eae79c7e46ed27e$export$3c8a471078a7436(a) {
    if (!a) return false;
    const amount = parseFloat(String(a.purchaseAmount ?? 0)) || 0;
    if (!(amount > 0)) return false;
    if (a.annuityType === 'fixedTerm' || a.annuityType === 'guaranteed') return false;
    return Math.round((Number(a.residualCapital) || 0) * 100) <= 0;
}
function $5eae79c7e46ed27e$export$f2117850dfd196a6(factFind) {
    const r = factFind?.goals?.incomeOnlyConfirmation;
    return r && Number(r.amount) > 0 ? r : null;
}
function $5eae79c7e46ed27e$export$9ad5f972205b4f88(factFind, amount) {
    const r = $5eae79c7e46ed27e$export$f2117850dfd196a6(factFind);
    return !!r && Math.abs(Number(r.amount) - Math.round(Number(amount) || 0)) < 1;
}
function $5eae79c7e46ed27e$export$655f124668ce439a(factFind, incomeOnly, amount) {
    return incomeOnly && !$5eae79c7e46ed27e$export$9ad5f972205b4f88(factFind, amount);
}
const $5eae79c7e46ed27e$var$today = ()=>{
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
function $5eae79c7e46ed27e$export$f7c134d1359c7a02(amount) {
    return {
        amount: Math.round(amount),
        date: $5eae79c7e46ed27e$var$today(),
        words: $5eae79c7e46ed27e$export$f360ca3a161badd2(amount)
    };
}
function $5eae79c7e46ed27e$export$415ddf94c95c9134(setFactFind) {
    if (!setFactFind) return undefined;
    return (confirmed, amount)=>setFactFind((prev)=>{
            const goals = {
                ...prev?.goals || {}
            };
            if (confirmed) goals[$5eae79c7e46ed27e$export$9a351e8db0ad2808] = $5eae79c7e46ed27e$export$f7c134d1359c7a02(amount);
            else delete goals[$5eae79c7e46ed27e$export$9a351e8db0ad2808];
            return {
                ...prev,
                goals: goals
            };
        });
}
/** The statement as the reader sees it: the client's own words, or the same statement about the client. */ function $5eae79c7e46ed27e$var$statementFor(factFind, amount) {
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    if (v.you) return $5eae79c7e46ed27e$export$f360ca3a161badd2(amount);
    return `${v.Names} understand${v.s} that nothing from the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(amount))} will come back to ${v.them} or ${v.their} family, even if ${v.they} pass away soon after buying it.`;
}
const $5eae79c7e46ed27e$export$61c5566b790f51c4 = ({ factFind: factFind, amount: amount, onChange: onChange, checked: given, testId: testId = 'income-only-tick-box' })=>{
    const checked = given ?? $5eae79c7e46ed27e$export$9ad5f972205b4f88(factFind, amount);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-lg border border-slate-200 border-l-4 border-l-amber-400 bg-white px-3 py-2 text-[12px] leading-relaxed text-slate-700",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "text-slate-900",
                        children: "Income only."
                    }),
                    " The highest income, and in return ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "nothing comes back"
                    }),
                    ": if death comes, even soon after buying it, the family gets nothing from the ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(amount),
                    ", and it can't be cashed in if plans change."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: "mt-2 flex items-start gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "checkbox",
                        checked: checked,
                        onChange: (e)=>onChange(e.target.checked, amount),
                        className: "mt-0.5",
                        "data-testid": "income-only-tick"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: $5eae79c7e46ed27e$var$statementFor(factFind, amount)
                            }),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-slate-500",
                                children: "Recorded with the amount and today's date, and printed in the advice document. Needed before choosing a plan with it."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $5eae79c7e46ed27e$export$4538b371a206da0c = ({ factFind: factFind, amount: amount, onChange: onChange, action: action = 'choosing', testId: testId = 'income-only-before-choose' })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const checked = $5eae79c7e46ed27e$export$9ad5f972205b4f88(factFind, amount);
    const record = $5eae79c7e46ed27e$export$f2117850dfd196a6(factFind);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-1.5 rounded-lg border border-slate-200 border-l-4 border-l-amber-400 bg-white px-3 py-2 text-[13px] text-slate-700",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                    className: "text-slate-900",
                    children: [
                        "Before ",
                        action === 'saving' ? 'saving' : v.you ? 'you choose' : `${v.names} choose${v.s}`,
                        ":"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: "flex items-start gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "checkbox",
                        checked: checked,
                        onChange: (e)=>onChange(e.target.checked, amount),
                        className: "mt-0.5",
                        "data-testid": "income-only-tick-repeat"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: $5eae79c7e46ed27e$var$statementFor(factFind, amount)
                    })
                ]
            }),
            checked && record?.date && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[12.5px] text-slate-500",
                "data-testid": "income-only-recorded",
                children: [
                    "Recorded on ",
                    record.date,
                    ", and printed in the advice document."
                ]
            }),
            !checked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[12.5px] text-slate-500",
                "data-testid": "income-only-held",
                children: [
                    "The plan can't be ",
                    action === 'saving' ? 'saved' : 'chosen',
                    " until this is ticked: its guaranteed income is the type where nothing comes back.",
                    record && Number(record.amount) > 0 ? ` (The earlier confirmation was for ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(record.amount))}; the amount has changed.)` : ''
                ]
            })
        ]
    });
};


function $09575c4cc12d1d84$export$e45920170ff81bed(row) {
    const lever = row?.meansTestStrategy;
    if (!lever || lever.type !== 'annuity') return null;
    // The amount actually bought (annuityTerms reads the built product), else the amount asked for.
    const amount = Number(row?.annuityTerms?.purchaseAmount) || Number(lever.purchaseAmount) || 0;
    if (!(amount > 0)) return null;
    return {
        amount: amount,
        kind: (0, $8665f80549f60a1b$export$3ab75b1250c8af22)(lever),
        incomeOnly: (0, $5eae79c7e46ed27e$export$3c8a471078a7436)({
            purchaseAmount: amount,
            annuityType: lever.annuityType,
            residualCapital: lever.residualCapital
        }),
        incomeAYear: Number(row?.annuityTerms?.annualPayment) || null
    };
}
function $09575c4cc12d1d84$export$b436b8674086de63(name) {
    const n = String(name || '');
    const i = n.indexOf(' + ');
    return i > 0 ? n.slice(0, i) : null;
}
function $09575c4cc12d1d84$export$b99ec4908215d8cd(row, evaluated) {
    const baseName = $09575c4cc12d1d84$export$b436b8674086de63(row?.name);
    if (!baseName) return null;
    return (evaluated || []).find((r)=>r?.name === baseName) ?? null;
}
function $09575c4cc12d1d84$export$1fb588cae1b9e959(amount) {
    return `the same deposit, paid the same way, with the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(amount))} left in savings instead`;
}
const $09575c4cc12d1d84$export$47f38349b07e923a = ({ row: row, evaluated: evaluated, factFind: factFind, personName: personName, horizonYears: horizonYears, testId: testId })=>{
    const lever = $09575c4cc12d1d84$export$e45920170ff81bed(row);
    if (!lever) return null;
    const base = $09575c4cc12d1d84$export$b99ec4908215d8cd(row, evaluated);
    const compareRows = base?.projections || null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
        factFind: factFind,
        personName: personName,
        amount: lever.amount,
        kind: lever.kind,
        incomeAYear: lever.incomeAYear,
        rows: row.projections || [],
        compareRows: compareRows,
        compareNote: compareRows?.length ? $09575c4cc12d1d84$export$1fb588cae1b9e959(lever.amount) : null,
        horizonYears: horizonYears,
        testId: testId
    });
};


/**
 * Dashboard config: next steps links and workflow steps per goal.
 * Change here when adding new goals or updating workflow copy.
 */ /**
 * ONE ICON PER LIVING ARRANGEMENT, everywhere it is shown (owner, 23 Oct 2026: Home's Start here rows, the saved
 * plans, the action plan and the menu showed different icons for the same module — downsizing and the granny
 * flat were both a plain house, the village guide had aged care's building). Keyed by plan type, with the
 * profile goal keys that name the same modules.
 */ /**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9ec88f95add56de8$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "8",
            cy: "8",
            r: "6",
            key: "3yglwk"
        }
    ],
    [
        "path",
        {
            d: "M18.09 10.37A6 6 0 1 1 10.34 18",
            key: "t5s6rm"
        }
    ],
    [
        "path",
        {
            d: "M7 6h1v4",
            key: "1obek4"
        }
    ],
    [
        "path",
        {
            d: "m16.71 13.88.7.71-2.82 2.82",
            key: "1rbuyh"
        }
    ]
];
const $9ec88f95add56de8$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("coins", $9ec88f95add56de8$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $fab2f21898bf5b1d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z",
            key: "1l6gj6"
        }
    ],
    [
        "path",
        {
            d: "M7 16v6",
            key: "1a82de"
        }
    ],
    [
        "path",
        {
            d: "M13 19v3",
            key: "13sx9i"
        }
    ],
    [
        "path",
        {
            d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5",
            key: "1sj9kv"
        }
    ]
];
const $fab2f21898bf5b1d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("trees", $fab2f21898bf5b1d$export$3efd853dbb351e94);


/**
 * Downsizing's icon: a larger house beside a smaller one (owner, 23 Oct 2026: the falling-chart arrow read as
 * a market fall). Lucide has no "move to a smaller home" icon, so this is drawn in its line style with its
 * factory, and takes the same props as any other Lucide icon.
 */ 
const $74490f6789d7fb5a$var$DownsizeHome = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)('DownsizeHome', [
    // The larger home: roof, walls, door.
    [
        'path',
        {
            d: 'M1.5 11 9 4l7.5 7',
            key: 'big-roof'
        }
    ],
    [
        'path',
        {
            d: 'M3.5 9.2V21h11V9.2',
            key: 'big-walls'
        }
    ],
    [
        'path',
        {
            d: 'M7.5 21v-5h3v5',
            key: 'big-door'
        }
    ],
    // The smaller home beside it.
    [
        'path',
        {
            d: 'm15.5 14.5 4-3.5 4 3.5',
            key: 'small-roof'
        }
    ],
    [
        'path',
        {
            d: 'M16.5 13.6V21h6v-7.4',
            key: 'small-walls'
        }
    ],
    [
        'path',
        {
            d: 'M1 21h22',
            key: 'ground'
        }
    ]
]);
var $74490f6789d7fb5a$export$2e2bcd8739ae039 = $74490f6789d7fb5a$var$DownsizeHome;


const $d5c3c2c5a9eb8655$export$388c0e4f7230aadf = {
    aged_care: (0, $8474226e5f2f9b18$export$2e2bcd8739ae039),
    home_care: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
    retirement_village: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
    downsizer: (0, $74490f6789d7fb5a$export$2e2bcd8739ae039),
    granny_flat: (0, $fab2f21898bf5b1d$export$2e2bcd8739ae039),
    cashflow_pension: (0, $9ec88f95add56de8$export$2e2bcd8739ae039)
};
const $d5c3c2c5a9eb8655$export$c5ec57f918f403fe = {
    aged_care: $d5c3c2c5a9eb8655$export$388c0e4f7230aadf.aged_care,
    home_care: $d5c3c2c5a9eb8655$export$388c0e4f7230aadf.home_care,
    retirement_village: $d5c3c2c5a9eb8655$export$388c0e4f7230aadf.retirement_village,
    downsize_home: $d5c3c2c5a9eb8655$export$388c0e4f7230aadf.downsizer,
    granny_flat: $d5c3c2c5a9eb8655$export$388c0e4f7230aadf.granny_flat,
    cashflow: $d5c3c2c5a9eb8655$export$388c0e4f7230aadf.cashflow_pension
};


const $85ae9bb7b6ee4811$export$d0620fcb9828c0c = [
    {
        text: "Review The Financial Impacts And Options Around",
        link: "Aged Care",
        page: "AgedCarePage",
        goal: "aged_care"
    },
    {
        text: "Review The Financial Impacts And Options Around",
        link: "Home Care",
        page: "HomeCarePage",
        goal: "home_care"
    },
    {
        text: "Review The Financial Impacts And Options Around",
        link: "Retirement Village",
        page: "RetirementVillagePage",
        goal: "retirement_village"
    },
    {
        text: "Review The Financial Impacts And Options Around",
        link: "Downsizing",
        page: "DownsizingPage",
        goal: "downsize_home"
    },
    {
        text: "Review The Financial Impacts And Options Around",
        link: "Granny Flat",
        page: "GrannyFlatPage",
        goal: "granny_flat"
    }
];
const $85ae9bb7b6ee4811$export$baed740720ec0ee1 = {
    /*
     * REWORKED 3 Oct 2026 (owner). The means assessment now comes BEFORE applying to homes, because
     * homes ask for the fee advice letter it produces. "Facility Application" and "Admission forms"
     * were the same act seen twice — each home has its own application, then its own agreement — so
     * they are one step; we hold no home's forms, so the pre-filled version is marked coming soon.
     */ aged_care: {
        title: 'Aged Care Journey',
        icon: (0, $d5c3c2c5a9eb8655$export$388c0e4f7230aadf).aged_care,
        steps: [
            {
                id: 'acat_assessment',
                name: 'Aged care needs assessment',
                description: 'Apply through My Aged Care, online or by phone. An assessor then visits to work out the care you are eligible for.',
                forms: [
                    'assessment_application'
                ],
                estimatedTime: '20 minutes to apply',
                status: 'pending'
            },
            {
                id: 'facility_research',
                name: 'Find and visit homes',
                description: "Shortlist aged care homes and visit them. Ask each for its room prices, its waiting list and how to apply \u2014 My Aged Care lists every home.",
                forms: [],
                estimatedTime: '2-4 weeks',
                status: 'pending'
            },
            {
                id: 'sa457_form',
                name: 'Means assessment',
                description: 'Services Australia works out what you will pay towards your care. Homes ask for the letter it produces, so do it before applying.',
                forms: [
                    'means_assessment'
                ],
                estimatedTime: '~10 min (pre-filled)',
                status: 'pending'
            },
            {
                id: 'facility_application',
                name: 'Apply and accept a place',
                description: "Each home has its own application form. When you are offered a place you sign the home's agreement, which covers your care, your room and what you pay \u2014 have it checked before you sign.",
                forms: [],
                comingSoon: [
                    'Pre-filled home applications'
                ],
                estimatedTime: '1-4 weeks',
                status: 'pending'
            },
            {
                id: 'move_in_preparation',
                name: 'Move in',
                description: 'Pack what the home allows, bring the papers it needs, and tell people you have moved.',
                forms: [
                    'move_in_checklist'
                ],
                estimatedTime: '1-2 weeks',
                status: 'pending'
            }
        ]
    },
    home_care: {
        title: 'Home Care Journey',
        icon: (0, $d5c3c2c5a9eb8655$export$388c0e4f7230aadf).home_care,
        steps: [
            {
                id: 'acat_assessment',
                name: 'Aged care needs assessment',
                description: 'Apply through My Aged Care for an assessment for Support at Home. An assessor visits to work out the services you are eligible for.',
                forms: [
                    'assessment_application_home'
                ],
                estimatedTime: '20 minutes to apply',
                status: 'pending'
            },
            {
                id: 'sah_means_form',
                name: 'Contribution assessment',
                description: 'Services Australia works out what you will contribute towards your Support at Home services.',
                forms: [
                    'means_assessment_home'
                ],
                estimatedTime: '~10 min (pre-filled)',
                status: 'pending'
            },
            {
                id: 'package_assignment',
                name: 'Wait for funding',
                description: 'After your assessment you join the national queue. You will get a letter when your funding is assigned.',
                forms: [],
                estimatedTime: '3-6 months',
                status: 'pending'
            },
            {
                id: 'provider_selection',
                name: 'Choose a provider',
                description: "Compare providers \u2014 each publishes its prices on My Aged Care \u2014 then choose one and sign its home care agreement.",
                forms: [],
                estimatedTime: '1-2 weeks',
                status: 'pending'
            },
            {
                id: 'care_planning',
                name: 'Agree your care plan',
                description: 'Your provider works out a care plan and budget with you. Check it matches the services you modelled in the Service Builder.',
                forms: [],
                estimatedTime: '2-4 weeks',
                status: 'pending'
            }
        ]
    },
    retirement_village: {
        title: 'Retirement Village Journey',
        icon: (0, $d5c3c2c5a9eb8655$export$388c0e4f7230aadf).retirement_village,
        steps: [
            {
                id: 'research_villages',
                name: 'Research and visit villages',
                description: 'Shortlist villages in the area you want, visit them, and ask each for its disclosure statement and contract.',
                forms: [],
                estimatedTime: '2-6 weeks',
                status: 'pending'
            },
            {
                id: 'contract_review',
                name: 'Compare the contracts',
                description: 'The contract decides what you pay and what comes back. Get the same questions answered for each village, then re-run the village module on the real figures.',
                forms: [
                    'village_contract_checklist'
                ],
                estimatedTime: '1-2 weeks',
                status: 'pending'
            },
            {
                id: 'legal_advice',
                name: 'Legal advice and sign',
                description: 'Have a solicitor review the contract before you sign, and use the cooling-off period if you need it.',
                forms: [],
                estimatedTime: '1-2 weeks',
                status: 'pending'
            },
            {
                id: 'settlement',
                name: 'Settle and move',
                description: 'Sell or keep your home as planned, settle, and move in.',
                forms: [
                    'moving_checklist_village'
                ],
                estimatedTime: '4-8 weeks',
                status: 'pending'
            },
            {
                id: 'notify_services_australia',
                name: 'Tell Services Australia',
                description: "Report the move and the entry contribution within 14 days \u2014 it decides whether you are a homeowner for the pension.",
                forms: [
                    'village_report'
                ],
                estimatedTime: 'Within 14 days',
                status: 'pending'
            }
        ]
    },
    downsize_home: {
        title: 'Downsizing Journey',
        icon: (0, $d5c3c2c5a9eb8655$export$388c0e4f7230aadf).downsizer,
        steps: [
            // The downsizer-super decision belongs INSIDE the modelling step (it's one of the
            // strategies compared), not as a later standalone step presuming an answer before the
            // modelling has been done. Its ATO form appears at settlement only when the saved plan
            // makes a contribution.
            {
                id: 'model_downsize',
                name: 'Model the Move',
                description: "Model the sale, the next home and what happens with the freed-up money \u2014 including whether topping up super with the downsizer contribution suits you",
                forms: [],
                estimatedTime: '30 minutes',
                status: 'pending'
            },
            {
                id: 'appraise_home',
                name: 'Appraise Your Home',
                description: 'Get market appraisals so the modelled sale price reflects reality',
                forms: [],
                estimatedTime: '1-2 weeks',
                status: 'pending'
            },
            {
                id: 'find_next_home',
                name: 'Find the Next Home',
                description: 'Research and shortlist where you want to live next',
                forms: [],
                estimatedTime: '2-8 weeks',
                status: 'pending'
            },
            {
                id: 'confirm_strategy',
                name: 'Confirm the Strategy',
                description: 'Revisit the modelling with real appraisal figures and lock in the chosen plan (super contributions, investments, debt)',
                forms: [],
                estimatedTime: '1 week',
                status: 'pending'
            },
            {
                id: 'sell_and_settle',
                name: 'Sell, Settle & Move',
                description: 'Sale campaign, settlement and the move itself. A downsizer contribution must reach your super fund, with its form, within 90 days of settlement.',
                forms: [
                    'moving_checklist_sale',
                    'downsizer_contribution'
                ],
                estimatedTime: '6-12 weeks',
                status: 'pending'
            }
        ]
    },
    granny_flat: {
        title: 'Granny Flat Journey',
        icon: (0, $d5c3c2c5a9eb8655$export$388c0e4f7230aadf).granny_flat,
        steps: [
            {
                id: 'model_arrangement',
                name: 'Model the Arrangement',
                description: 'Model the payment or transfer and its effect on pension and estate',
                forms: [],
                estimatedTime: '30 minutes',
                status: 'pending'
            },
            {
                id: 'family_agreement',
                name: 'Family Agreement',
                description: "Agree the arrangement with family \u2014 who pays what, and what happens if circumstances change",
                forms: [
                    'family_guide'
                ],
                estimatedTime: '1-2 weeks',
                status: 'pending'
            },
            {
                id: 'legal_advice',
                name: 'Legal Advice',
                description: "Put the granny flat interest in writing with independent legal advice \u2014 the solicitor brief from the family guide is the starting point",
                forms: [
                    'solicitor_brief'
                ],
                estimatedTime: '1-2 weeks',
                status: 'pending'
            },
            {
                id: 'notify_centrelink',
                name: 'Notify Services Australia',
                description: 'Call before you set it up, then report it within 14 days so the granny flat interest is assessed correctly',
                forms: [
                    'granny_flat_report'
                ],
                estimatedTime: '1 week',
                status: 'pending'
            },
            {
                id: 'build_or_move',
                name: 'Build / Move In',
                description: 'Complete any construction and make the move',
                forms: [],
                estimatedTime: 'varies',
                status: 'pending'
            }
        ]
    }
};


/**
 * WHAT EACH PLAN IS COMPARED WITH, IN EACH MODULE'S OWN WORDS (owner, 25 Oct 2026).
 *
 * Every card said "+$122,016 vs doing nothing", but "doing nothing" meant something different in each module, and in
 * aged care it was not nothing at all: the person still moves into care, pays the room daily and sells nothing. So
 * each module names its comparison for what it is:
 *
 *   aged care          "paying daily"         — the room paid daily, nothing paid up front, nothing sold
 *                       ("staying put" for a change of home: the current room and deposit kept)
 *   Support at Home    "the support alone"    — the same services, nothing else changed
 *   village, downsizing, granny flat
 *                      "staying put"          — staying in the home, nothing changed
 *                      ("keep renting" for a household that rents)
 *   cashflow           "changing nothing"
 *
 * One helper so every card, rail, Explain this, What could go wrong, Home line and advice document says the same.
 */ const $1a5a24a0286ded56$var$cap = (s)=>s.charAt(0).toUpperCase() + s.slice(1);
function $1a5a24a0286ded56$var$build(word, after, sentence) {
    return {
        word: word,
        vs: `vs ${word}`,
        label: $1a5a24a0286ded56$var$cap(word),
        after: after,
        sentence: sentence
    };
}
function $1a5a24a0286ded56$export$b3949d624101f360(module, household = {}) {
    switch(module){
        case 'agedCare':
            return household.facilityMove ? $1a5a24a0286ded56$var$build('staying put', 'staying put', 'Compared with staying in the current room and changing nothing.') : $1a5a24a0286ded56$var$build('paying daily', 'paying daily', 'Compared with paying for the room daily and selling nothing.');
        case 'supportAtHome':
            return $1a5a24a0286ded56$var$build('the support alone', 'with the support alone', 'Compared with getting the support and changing nothing else.');
        case 'cashflow':
            return $1a5a24a0286ded56$var$build('changing nothing', 'changing nothing', 'Compared with changing nothing.');
        case 'village':
        case 'downsizer':
        case 'grannyFlat':
        default:
            return household.rents ? $1a5a24a0286ded56$var$build('keep renting', 'keeping on renting', 'Compared with keeping on renting where you are and changing nothing.') : $1a5a24a0286ded56$var$build('staying put', 'staying put', 'Compared with staying in your home and changing nothing.');
    }
}
const $1a5a24a0286ded56$export$6ad898e84f176684 = $1a5a24a0286ded56$export$b3949d624101f360('agedCare');
const $1a5a24a0286ded56$export$c9c6ca79dc334e31 = $1a5a24a0286ded56$export$b3949d624101f360('supportAtHome');
function $1a5a24a0286ded56$export$71623450cbaee3cf(factFind) {
    const renting = factFind?.client?.currentResidency === 'renting' || factFind?.partner?.currentResidency === 'renting';
    return renting && !((Number(factFind?.home?.value) || 0) > 0);
}


function $b7673ace5c1b1942$export$33f556bb856de114(plan) {
    const room = Number(plan.outputs?.roomCost) || 0;
    const name = String(plan.homeName || '').trim();
    const roomWords = room > 0 ? `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(room)} room` : 'the room';
    return name ? `${name} (${roomWords})` : `the ${roomWords}`;
}
function $b7673ace5c1b1942$export$b311b9e7b1cd5020(plan, factFind) {
    return (0, $95e43332fd84eec4$export$6cc0d9545ae1511e)(plan, factFind);
}
const $b7673ace5c1b1942$var$dateWords = (iso)=>iso ? new Date(iso).toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }) : null;
const $b7673ace5c1b1942$var$LinkButton = ({ onClick: onClick, icon: icon, children: children, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: onClick,
        "data-testid": testId,
        className: "inline-flex items-center gap-1.5 text-[13px] font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
        children: [
            icon,
            children
        ]
    });
const $b7673ace5c1b1942$var$AgedCareHub = ({ factFind: factFind, plans: plans, chosen: chosen, documents: documents, onOpenPlan: onOpenPlan, onModelAnotherHome: onModelAnotherHome, onStartFresh: onStartFresh, onOpenDocument: onOpenDocument, onReadGuide: onReadGuide, onAssumptions: onAssumptions, goHome: goHome })=>{
    const goals = factFind.goals || {};
    const entering = goals.aged_care_for === 'partner' ? factFind.partner : factFind.client;
    const name = String(entering?.firstName || 'the client').trim();
    const possessive = /s$/i.test(name) ? `${name}'` : `${name}'s`;
    const others = plans.filter((p)=>p.id !== chosen?.id);
    const row = chosen?.strategy;
    const baseline = chosen?.baseline ?? null;
    const inputs = chosen?.inputs || {};
    const legacy = Number(chosen?.outputs?.legacyEstimate ?? row?.snapshot?.legacyValue) || 0;
    const care = Number(chosen?.outputs?.agedCareCost ?? row?.snapshot?.totalAgedCareCosts) || 0;
    const pension = Number(chosen?.outputs?.agePension ?? row?.snapshot?.pension) || 0;
    const cf = Number(chosen?.outputs?.cashFlow ?? row?.snapshot?.netCashflow) || 0;
    const years = Number(inputs.legacyYears) || 5;
    const legacyDelta = baseline?.legacyValue != null ? legacy - Number(baseline.legacyValue) : null;
    const pensionDelta = baseline ? pension - Number(baseline.pension || 0) : null;
    const paid = Math.max(0, Number(row?.radPaidNet) || 0);
    const fundingLines = row?.radFunding ? (0, $e5cae8423a439bf1$export$8f80043cee83ba5d)(factFind, (0, $c549af0b979cab3f$export$9ca4abb860f88bf9)(row.radFunding)) : [];
    const sold = (0, $e5cae8423a439bf1$export$83ba4f4a49e92f66)(fundingLines, (0, $f94e45ac645ae232$export$3dc27271f5d5c629));
    const sellsSomething = !!(row?.strategyOptions?.downsizeHome || row?.strategyOptions?.sellInvestmentProperty);
    const words = chosen ? (0, $95e43332fd84eec4$export$f973c372d76f95c8)(row, factFind, $b7673ace5c1b1942$export$b311b9e7b1cd5020(chosen, factFind)) : null;
    const runway = row?.projections && Array.isArray(row.projections) && row.projections.length ? (0, $0fe89e03b6df746e$export$464558962ff4a811)(row.projections, years) : null;
    const chosenDate = $b7673ace5c1b1942$var$dateWords(chosen?.createdAt);
    // The NEWEST draft (owner, 24 Oct 2026): the list is oldest first, so "Open the draft" opened the first
    // one ever written, not the one just made.
    const newestFirst = [
        ...documents
    ].sort((a, b)=>(new Date(b.createdAt ?? 0).getTime() || 0) - (new Date(a.createdAt ?? 0).getTime() || 0));
    const draft = newestFirst.find((d)=>(d.soaDeliveryStatus || 'draft') === 'draft') || newestFirst[0] || null;
    const nextStep = (0, $85ae9bb7b6ee4811$export$baed740720ec0ee1).aged_care.steps[0];
    const living = Number(inputs.scenarioLivingExpenses) || 0;
    const careStart = inputs.careStartDate ? $b7673ace5c1b1942$var$dateWords(inputs.careStartDate) : null;
    /* What AWise can see on this screen. */ (0, $acw62.useEffect)(()=>{
        const facts = chosen ? `${name}'s chosen plan for ${$b7673ace5c1b1942$export$33f556bb856de114(chosen)}: ${$b7673ace5c1b1942$export$b311b9e7b1cd5020(chosen, factFind)}. Left to the family after about ${years} years ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(legacy))}${legacyDelta != null ? ` (${legacyDelta >= 0 ? '+' : "\u2212"}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(legacyDelta)))} ${(0, $1a5a24a0286ded56$export$6ad898e84f176684).vs})` : ''}; care ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(care))} a year; Age Pension ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(pension))} a year; each year ${cf < 0 ? 'short by' : 'left over'} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(cf)))}.${sold ? ` The deposit is paid with ${sold}.` : ''}${others.length ? ` Also modelled: ${others.map((p)=>$b7673ace5c1b1942$export$33f556bb856de114(p)).join(', ')}.` : ''}` : `${plans.length} aged care plan(s) saved, none chosen yet: ${plans.map((p)=>`${$b7673ace5c1b1942$export$33f556bb856de114(p)} \u{2014} ${$b7673ace5c1b1942$export$b311b9e7b1cd5020(p, factFind)}`).join('; ')}.`;
        (0, $6067e4a24a943681$export$62e91b0fed1d0d10)({
            screen: 'hub',
            note: facts
        });
        return ()=>(0, $6067e4a24a943681$export$62e91b0fed1d0d10)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        chosen?.id,
        plans.length
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mx-auto max-w-5xl",
        "data-testid": "aged-care-hub",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] text-slate-500",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: goHome,
                        className: "underline decoration-dotted underline-offset-2 hover:text-slate-800",
                        children: "Home"
                    }),
                    " \u203A Aged care"
                ]
            }),
            chosen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                        className: "mt-2 text-[32px] font-bold leading-tight tracking-tight text-brand-navy",
                        children: [
                            possessive,
                            " aged care plan \u2014 ",
                            $b7673ace5c1b1942$export$33f556bb856de114(chosen)
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1 text-[15px] text-slate-600",
                        children: [
                            "Care starting ",
                            careStart ?? 'now',
                            living > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "; living costs of ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(living),
                                    " a year once ",
                                    name,
                                    " is in care"
                                ]
                            }) : null,
                            ".",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>onOpenPlan(chosen, 'room'),
                                className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                children: "Change these"
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>onModelAnotherHome(chosen),
                                className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                children: "Model another home"
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onStartFresh,
                                "data-testid": "hub-start-fresh-header",
                                className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                children: "Start a new model from scratch"
                            }),
                            "."
                        ]
                    }),
                    (0, $78a369bbf1e0d995$export$f4ec6e978b61cc57)(chosen) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-5 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] text-slate-700",
                        "data-testid": "hub-chosen-out-of-date",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: (0, $78a369bbf1e0d995$export$f4ec6e978b61cc57)(chosen).reason.replace(/ — open it to choose again\.$/, '.')
                                    }),
                                    " The figures below are the ones it was chosen on",
                                    chosenDate ? `, ${chosenDate}` : '',
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>onOpenPlan(chosen, 'compare'),
                                className: "rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-[13px] font-semibold text-slate-800 hover:border-blue-300",
                                children: "Choose a plan again"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-5 overflow-hidden rounded-2xl border-2 border-emerald-500 bg-white shadow-card",
                        "data-testid": "hub-chosen-plan",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap items-start justify-between gap-6 px-6 pt-5 pb-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "min-w-[260px] flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "inline-flex items-center gap-1.5 text-[12.5px] font-semibold text-emerald-700",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                                        size: 15,
                                                        strokeWidth: 2,
                                                        "aria-hidden": true
                                                    }),
                                                    "Chosen plan",
                                                    chosenDate ? `, ${chosenDate}` : ''
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                className: "mt-2 text-[22px] font-bold leading-snug tracking-tight text-slate-900",
                                                children: $b7673ace5c1b1942$export$b311b9e7b1cd5020(chosen, factFind)
                                            }),
                                            words?.sub && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-1 text-[13px] leading-relaxed text-slate-600",
                                                children: words.sub
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "text-right",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-[36px] font-bold leading-none tabular-nums tracking-tight text-brand-navy",
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(legacy))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-1 text-[13px] text-slate-600",
                                                children: [
                                                    "left to the family after about ",
                                                    years,
                                                    " ",
                                                    years === 1 ? 'year' : 'years'
                                                ]
                                            }),
                                            legacyDelta != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: `mt-0.5 text-[13px] font-bold tabular-nums ${legacyDelta >= 0 ? 'text-emerald-700' : 'text-rose-700'}`,
                                                children: [
                                                    legacyDelta >= 0 ? '+' : "\u2212",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(legacyDelta))),
                                                    " ",
                                                    (0, $1a5a24a0286ded56$export$6ad898e84f176684).vs
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 divide-y divide-slate-200 border-y border-slate-200 bg-slate-50/70 sm:grid-cols-3 sm:divide-x sm:divide-y-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "px-6 py-3.5",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-[12px] font-semibold text-slate-500",
                                                children: "Care costs"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-0.5 text-[20px] font-bold leading-none tabular-nums text-slate-900",
                                                children: [
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(care)),
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-[12px] font-medium text-slate-500",
                                                        children: "a year"
                                                    })
                                                ]
                                            }),
                                            baseline?.careCosts != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-1 text-[12px] text-slate-500",
                                                children: [
                                                    (0, $1a5a24a0286ded56$export$6ad898e84f176684).word,
                                                    ": ",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(Number(baseline.careCosts)))
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "px-6 py-3.5",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-[12px] font-semibold text-slate-500",
                                                children: [
                                                    possessive,
                                                    " Age Pension"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-0.5 text-[20px] font-bold leading-none tabular-nums text-slate-900",
                                                children: [
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(pension)),
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-[12px] font-medium text-slate-500",
                                                        children: "a year"
                                                    })
                                                ]
                                            }),
                                            pensionDelta != null && Math.round(pensionDelta) !== 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: `mt-1 text-[12px] font-semibold ${pensionDelta > 0 ? 'text-emerald-700' : 'text-rose-700'}`,
                                                children: [
                                                    pensionDelta > 0 ? '+' : "\u2212",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(pensionDelta))),
                                                    " a year"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "px-6 py-3.5",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-[12px] font-semibold text-slate-500",
                                                children: cf < 0 ? 'Each year, short by' : 'Left over each year'
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: `mt-0.5 text-[20px] font-bold leading-none tabular-nums ${cf < 0 ? 'text-slate-900' : 'text-emerald-700'}`,
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(cf)))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-1 text-[12px] text-slate-500",
                                                children: cf < 0 ? runway?.headline ? `covered by savings \u{2014} ${runway.headline.replace(/\.$/, '')}` : 'covered by savings' : 'stays in the bank'
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "px-6 py-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-[14px] leading-relaxed text-slate-800",
                                        children: paid > 0.5 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                    children: [
                                                        "How the ",
                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(paid)),
                                                        " is paid:"
                                                    ]
                                                }),
                                                " ",
                                                sold ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        sold,
                                                        "."
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        "a deposit of ",
                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(paid)),
                                                        " is paid up front."
                                                    ]
                                                }),
                                                ' ',
                                                sold ? `${(0, $e5cae8423a439bf1$export$47c51e1483ee586f)(fundingLines)} ` : '',
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>onOpenPlan(chosen, 'detail'),
                                                    className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                                    children: "See where it comes from"
                                                }),
                                                "."
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Nothing is paid up front:"
                                                }),
                                                " the whole room is charged daily, like rent, and every dollar stays where it is. ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>onOpenPlan(chosen, 'detail'),
                                                    className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                                    children: "See the full year's numbers"
                                                }),
                                                "."
                                            ]
                                        })
                                    }),
                                    row && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-4",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09575c4cc12d1d84$export$47f38349b07e923a), {
                                            row: row,
                                            evaluated: null,
                                            factFind: factFind,
                                            personName: name,
                                            horizonYears: years,
                                            testId: "hub-chosen-family"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4 grid grid-cols-1 gap-2 sm:grid-cols-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>onOpenPlan(chosen, 'explain'),
                                                className: "inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3.5 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300 hover:bg-blue-50",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                                        size: 15
                                                    }),
                                                    " Explain this"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>onOpenPlan(chosen, 'risks'),
                                                className: "inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3.5 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300 hover:bg-blue-50",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4666dd9ae485baaf$export$2e2bcd8739ae039), {
                                                        size: 15
                                                    }),
                                                    " What could go wrong"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>onOpenPlan(chosen, 'compare'),
                                                className: "inline-flex items-center justify-center gap-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 px-3.5 py-2.5 text-[14px] font-semibold text-white shadow-md ",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                                                        size: 15
                                                    }),
                                                    " All the plans we tested \u2192"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-4 grid grid-cols-1 divide-y divide-slate-200 rounded-2xl border border-slate-200 bg-white shadow-card md:grid-cols-2 md:divide-x md:divide-y-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex gap-3 px-5 py-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-blue-50 text-blue-700",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                            size: 18
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "min-w-0",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-[15px] font-semibold text-slate-900",
                                                children: [
                                                    "Advice document \u2014 ",
                                                    draft ? (draft.soaDeliveryStatus || 'draft') === 'draft' ? 'draft' : draft.soaDeliveryStatus : 'not prepared yet'
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-0.5 text-[13px] leading-relaxed text-slate-600",
                                                children: [
                                                    "The written record of this plan: what it assumes, what it costs, what could go wrong.",
                                                    ' ',
                                                    draft ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>onOpenDocument(draft),
                                                        className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                                        children: [
                                                            "Open the ",
                                                            (draft.soaDeliveryStatus || 'draft') === 'draft' ? 'draft' : 'document'
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>onOpenPlan(chosen, 'document'),
                                                        className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                                        children: "Get the advice document"
                                                    }),
                                                    "."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex gap-3 px-5 py-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-blue-600 text-[14px] font-bold text-white",
                                        children: "1"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "min-w-0",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-[15px] font-semibold text-slate-900",
                                                children: [
                                                    "Next: ",
                                                    (nextStep?.name ?? 'Aged care needs assessment').toLowerCase()
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-0.5 text-[13px] leading-relaxed text-slate-600",
                                                children: [
                                                    nextStep?.description,
                                                    ' ',
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: goHome,
                                                        className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                                        children: "Full action plan on Home"
                                                    }),
                                                    "."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-card",
                        "data-testid": "hub-model-something-else",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[15px] font-semibold text-slate-900",
                                children: "Model something else"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-0.5 text-[13px] text-slate-600",
                                children: "Each new model is saved as its own plan. This plan stays chosen until you choose another."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-col rounded-xl border border-slate-200 px-4 py-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-[14px] font-semibold text-slate-900",
                                                children: "Another home, same setup"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-0.5 flex-1 text-[13px] leading-relaxed text-slate-600",
                                                children: "Keeps the living costs and the answers to the setup questions. Only the room is new."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>onModelAnotherHome(chosen),
                                                className: "mt-3 inline-flex items-center justify-center gap-1.5 self-start rounded-lg border border-slate-300 bg-white px-3.5 py-2 text-[13px] font-semibold text-slate-800 hover:border-blue-300 hover:bg-blue-50",
                                                children: "Model another home"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-col rounded-xl border border-slate-200 px-4 py-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-[14px] font-semibold text-slate-900",
                                                children: "A new model from scratch"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-0.5 flex-1 text-[13px] leading-relaxed text-slate-600",
                                                children: "Starts again at step 1 with nothing carried over, and asks the setup questions again so you can change any of them."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: onStartFresh,
                                                "data-testid": "hub-start-fresh",
                                                className: "mt-3 inline-flex items-center justify-center gap-1.5 self-start rounded-lg border border-slate-300 bg-white px-3.5 py-2 text-[13px] font-semibold text-slate-800 hover:border-blue-300 hover:bg-blue-50",
                                                children: "Start a new model from scratch"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-5 flex flex-wrap items-center gap-x-6 gap-y-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b7673ace5c1b1942$var$LinkButton, {
                                onClick: ()=>onOpenPlan(chosen, 'room'),
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                    size: 14
                                }),
                                children: "Change the room price or start date"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b7673ace5c1b1942$var$LinkButton, {
                                onClick: ()=>onOpenPlan(chosen, 'compare'),
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e583651be68dae50$export$2e2bcd8739ae039), {
                                    size: 14
                                }),
                                children: "All the plans we tested"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b7673ace5c1b1942$var$LinkButton, {
                                onClick: ()=>onOpenPlan(chosen, 'build'),
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $712d717556ef1508$export$2e2bcd8739ae039), {
                                    size: 14
                                }),
                                children: chosen.source === 'manual_control' ? 'Change the plan you built' : 'Customise this plan'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b7673ace5c1b1942$var$LinkButton, {
                                onClick: ()=>onOpenPlan(chosen, 'build-new'),
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $712d717556ef1508$export$2e2bcd8739ae039), {
                                    size: 14
                                }),
                                children: "Build a plan yourself"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b7673ace5c1b1942$var$LinkButton, {
                                onClick: onReadGuide,
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                    size: 14
                                }),
                                children: "How aged care fees work \u2014 the guide"
                            }),
                            onAssumptions && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b7673ace5c1b1942$var$LinkButton, {
                                onClick: onAssumptions,
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                    size: 14
                                }),
                                children: "Rates and assumptions"
                            })
                        ]
                    }),
                    others.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-5 text-[13px] text-slate-600",
                        children: [
                            "Also modelled:",
                            ' ',
                            others.map((p, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                    children: [
                                        i > 0 && " \xb7 ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>onOpenPlan(p),
                                            className: "font-semibold text-blue-700 underline-offset-2 hover:underline",
                                            "data-testid": "hub-other-home",
                                            children: $b7673ace5c1b1942$export$33f556bb856de114(p)
                                        })
                                    ]
                                }, String(p.id ?? i))),
                            ". Each home is kept as its own plan; compare them from Home."
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                        className: "mt-2 text-[32px] font-bold leading-tight tracking-tight text-brand-navy",
                        children: [
                            possessive,
                            " aged care plans"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1 text-[15px] text-slate-600",
                        children: [
                            plans.length === 1 ? 'One home modelled' : `${plans.length} homes modelled`,
                            ", nothing chosen yet. Open a plan to choose it; the advice document follows the chosen plan."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-5 space-y-3",
                        children: plans.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-card",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "min-w-0",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-[15px] font-semibold text-slate-900",
                                                children: [
                                                    $b7673ace5c1b1942$export$33f556bb856de114(p).replace(/^the /, 'The '),
                                                    " \u2014 ",
                                                    $b7673ace5c1b1942$export$b311b9e7b1cd5020(p, factFind)
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-0.5 text-[13px] text-slate-500",
                                                children: [
                                                    "Left to the family ",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(Number(p.outputs?.legacyEstimate) || 0)),
                                                    " \xb7 care ",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(Number(p.outputs?.agedCareCost) || 0)),
                                                    " a year",
                                                    p.createdAt ? ` \xb7 ${$b7673ace5c1b1942$var$dateWords(p.createdAt)}` : ''
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>onOpenPlan(p),
                                        className: "inline-flex items-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3.5 py-2 text-[13px] font-semibold text-slate-800 hover:border-blue-300 hover:bg-blue-50",
                                        children: "Open"
                                    })
                                ]
                            }, String(p.id)))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-4 flex flex-wrap gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>onModelAnotherHome(plans[0] ?? null),
                                className: "inline-flex items-center gap-1.5 rounded-lg bg-blue-600 px-3.5 py-2 text-[13px] font-semibold text-white hover:bg-blue-700",
                                children: "Model another home"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onStartFresh,
                                className: "inline-flex items-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3.5 py-2 text-[13px] font-semibold text-slate-800 hover:border-blue-300 hover:bg-blue-50",
                                "data-testid": "hub-start-fresh",
                                children: "Start a new model from scratch"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-5 text-[13px] text-slate-500",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            onClick: onReadGuide,
                            className: "inline-flex items-center gap-1 font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                    size: 14
                                }),
                                " Read the full guide to aged care fees"
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $b7673ace5c1b1942$export$2e2bcd8739ae039 = $b7673ace5c1b1942$var$AgedCareHub;






/**
 * A CHANGE OF AGED CARE HOME, in the client's words (owner, 7 Oct 2026: common; "consider how we
 * explain things"). The person is in care now; every plan on the page is measured against STAYING
 * PUT, and the move is what the plans do. One module for the words, so step 1, step 2, the plan
 * summary, the cards, the recap and the advice document all say the same thing.
 */ 
/** A daily figure keeps its cents: $23.32 a day is a real quote, and "$23" would understate the year. */ const $b073c6d711dafa37$var$perDay = (n)=>`$${(Math.round(n * 100) / 100).toLocaleString('en-AU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })}`;
function $b073c6d711dafa37$export$38d95bea694c356c(facts) {
    return `Staying at ${facts.facilityName || 'the current home'}. Four numbers tell the story.`;
}
function $b073c6d711dafa37$export$7f4e2411605a6b31(facts) {
    return `This is the stay-put position: what the next year looks like if ${facts.name} stays at ${facts.facilityName || 'the current home'} and nothing changes. Every plan in step 3 \u{2014} including a move \u{2014} is measured against it.`;
}
function $b073c6d711dafa37$export$acc51e3093881ff8(f) {
    const deposit = f.paid > 0 ? f.retained > 0.5 ? `a deposit of ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(f.paid)} was paid, which would be refunded at about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.refundToday))} today (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.retained))} has been retained so far)` : `a deposit of ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(f.paid)} was paid, refundable in full${f.grandfathered ? " \u2014 no retention applies, as care began before 1 November 2025" : ''}` : 'no deposit was paid';
    const dap = f.dailyPayment > 0 ? `, and ${$b073c6d711dafa37$var$perDay(f.dailyPayment)} a day is paid on the rest of the room` : '';
    return `${f.name} has been at ${f.facilityName || 'the current home'} since ${f.entryLabel || 'entering care'}: the room was priced at ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(f.roomPrice)}, ${deposit}${dap}. Staying there is what every plan below is compared against.`;
}
function $b073c6d711dafa37$export$e2520199cd7ec4c6(f) {
    if (f.paid <= 0) return `${f.name} paid no deposit at the current home, so the whole of the new room's deposit comes from savings.`;
    const less = f.retained > 0.5 ? ` (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(f.paid)} paid, less ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.retained))} retained so far)` : '';
    return `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.refundToday))} comes back from the current deposit on the move${less} and goes to the new room first. Only what the new room costs beyond that comes from savings.`;
}
function $b073c6d711dafa37$export$1059590aefc83273(f) {
    const unpaid = Math.max(0, f.newRoomPrice - f.deposit);
    const paidWith = f.deposit <= 0 ? `nothing is paid up front for the new ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(f.newRoomPrice)} room, so the whole of it is charged as a daily payment` : `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.deposit))} of the new ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(f.newRoomPrice)} room is paid up front \u{2014} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.fromRefund))} from the refund of the current deposit${f.fromSale > 0.5 ? `, and ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.fromSale))} ${f.soldPhrase ? `from savings (${f.soldPhrase})` : 'from savings'}` : ''}${unpaid > 0.5 ? `; the unpaid ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(unpaid))} is charged as a daily payment of ${$b073c6d711dafa37$var$perDay(f.dapPerDay)} a day` : ''}`;
    const retention = f.grandfathered ? 'No retention is taken from the deposit, at either home: care began before 1 November 2025.' : f.retentionDaysTaken > 0 ? `The 2% a year retention carries on from where it is (${$b073c6d711dafa37$var$describeYears(f.retentionDaysTaken)} of the five already counted); it does not start again at the new home.` : 'The 2% a year retention runs for the first five years of the deposit, at whichever home holds it.';
    return `${f.name} moves from ${f.facilityName || 'the current home'} in ${f.moveLabel}: ${paidWith}. The fees switch to the new home's on the day of the move, and the yearly and lifetime caps carry on from where they are. ${retention}`;
}
const $b073c6d711dafa37$export$b959cdd87044c918 = 'Stay where you are';
function $b073c6d711dafa37$var$describeYears(days) {
    const years = Math.round(days / 365 * 10) / 10;
    if (years < 1) return `${Math.round(days / 30)} months`;
    return `${years} ${years === 1 ? 'year' : 'years'}`;
}



/**
 * Words for the advice document that the owner's review of 9 Oct 2026 asked for: the Age Pension
 * page's home treatment said from the arrangement the person is actually in (it read "your former
 * home" to a village resident who has none), the estate page's "worth considering" points where
 * nothing is missing (the actions box printed empty), and the one line the executive summary keeps
 * when a strategy was set aside (the box itself now sits with the alternatives).
 */ const $2411d79164c394f6$var$DEPOSIT_RULE = "A refundable accommodation deposit is not counted as an asset for the pension and is not deemed to earn income, so money moved from the bank or investments into the deposit can raise the pension. Any assets sold to fund the deposit are assessed on what remains.";
function $2411d79164c394f6$export$499ee20196e78962(i) {
    const partner = i.partnerName || 'your partner';
    if (i.partnerStays) switch(i.partnerArrangement || 'own_home'){
        case 'own_home':
            return `The home is not counted in the assets test while ${partner} lives in it, and ${i.name} is assessed as a homeowner. ${$2411d79164c394f6$var$DEPOSIT_RULE}`;
        case 'retirement_village':
            return `The village unit is the couple's home while ${partner} lives there: the entry contribution is not counted, and ${i.name} is assessed as a homeowner. ${$2411d79164c394f6$var$DEPOSIT_RULE}`;
        case 'granny_flat':
            return `The granny flat is the couple's home while ${partner} lives there, so it is not counted. ${$2411d79164c394f6$var$DEPOSIT_RULE}`;
        default:
            return `You own no home, so you are assessed as non-homeowners with the higher asset free area; that does not change when ${i.name} enters care. ${$2411d79164c394f6$var$DEPOSIT_RULE}`;
    }
    switch(i.arrangement || 'own_home'){
        case 'retirement_village':
            return "Your village unit counts as your home today, so you are assessed as a homeowner and the entry contribution is not counted. Once the village pays out your interest you are assessed as a non-homeowner: the payout is counted as an asset and deemed to earn income, " + `and the higher non-homeowner asset free area applies. ${$2411d79164c394f6$var$DEPOSIT_RULE}`;
        case 'granny_flat':
            return "Your granny flat interest is treated as your home today, so it is not counted. For up to two years after you enter care it is disregarded in the same way as a former home; after that, what is counted depends on the " + `terms of the arrangement and is for Services Australia to assess. ${$2411d79164c394f6$var$DEPOSIT_RULE}`;
        case 'renting':
            return 'You rent, so you are assessed as a non-homeowner with the higher asset free area, and that does not change when you enter care. ' + `Rent Assistance stops once you are a permanent resident. ${$2411d79164c394f6$var$DEPOSIT_RULE}`;
        case 'with_family':
            return 'You live with family and own no home, so you are assessed as a non-homeowner with the higher asset free area; ' + `that does not change when you enter care. ${$2411d79164c394f6$var$DEPOSIT_RULE}`;
        case 'aged_care':
            return `You are already in residential care, so this advice brings no change in how your home is treated; your current assessment carries on. ${$2411d79164c394f6$var$DEPOSIT_RULE}`;
        default:
            return 'Your former home is disregarded from the assets test for up to two years after you enter care. ' + `${$2411d79164c394f6$var$DEPOSIT_RULE} If the home is rented, the rent is assessable income.`;
    }
}
function $2411d79164c394f6$export$3583f111d01ddb92(i) {
    const out = [];
    if (i.radPaid > 0) out.push(`The refundable deposit of ${i.moneyWords(i.radPaid)} comes back to the estate when care ends. The home must refund it within 14 days of being shown probate or letters of administration, less anything the agreement let it draw from the deposit. The estate figures in this document count that refund.`);
    if (i.leavesVillage) out.push('If death comes before the village has paid out the unit, the payment is made to the estate on the same terms, so the timing of the village payout still matters to the family.');
    if (i.hasSuper) out.push('Super and account-based pension money left to adult children who are not financial dependants is taxed on its taxable component (15% plus the Medicare levy). Check that the nominations still say what you want once the plan has moved money.');
    if (i.hasEpoa) out.push('Once in care, the attorney under the Enduring Power of Attorney is the one who deals with the home, Services Australia and the deposit on your behalf. Make sure the home and Services Australia each hold a copy.');
    if (i.planSells) out.push('If a Will names something this plan sells (a particular account, the home), review the Will so that gift does not simply fail.');
    out.push('Review the Will, powers of attorney and nominations after major family, health or asset changes.');
    return out;
}
function $2411d79164c394f6$export$de39401204a3b4c(count) {
    return count === 1 ? 'One strategy that would have scored higher on a ranking was set aside because of age and health. It is explained under Alternative strategies considered.' : `${count} strategies that would have scored higher on a ranking were set aside because of age and health. They are explained under Alternative strategies considered.`;
}
function $2411d79164c394f6$export$aa645fc954db83c6(i) {
    // The figures every strategy is compared against are in bold (**…**, turned into <strong> by the kit),
    // and the Age Pension is among them (owner, 22 Oct 2026).
    const b = (x)=>`**${x}**`;
    const cf = `${i.cashflow < 0 ? "\u2212" : '+'}${i.moneyWords(Math.abs(Math.round(i.cashflow)))}`;
    const years = `${i.years} ${i.years === 1 ? 'year' : 'years'}`;
    let pension = '';
    if (i.pension != null && Number.isFinite(i.pension)) {
        const now = Math.round(i.pension);
        const diff = i.pensionToday != null && Number.isFinite(i.pensionToday) ? now - Math.round(i.pensionToday) : 0;
        const change = Math.abs(diff) < 1 ? ', the same as today' : ` (${diff > 0 ? 'up' : 'down'} ${i.moneyWords(Math.abs(diff))} a year from today)`;
        pension = `the Age Pension becomes ${b(`${i.moneyWords(now)} a year`)}${change}, `;
    }
    // "With no plan" bold too, so the baseline cannot be mistaken for the plan (owner, 24 Oct 2026).
    return `Moving into care changes this. ${b('With no plan')}, ${pension}the cashflow becomes ${b(`${cf} a year`)} and the estate after ${years} ${b(i.moneyWords(Math.round(i.estate)))}. The strategies in this document are measured against that.`;
}


/**
 * The estate if the household simply stays where it is (owner, 9 Oct 2026).
 *
 * The advice document's situation page shows today's position at home — pension, cashflow and net
 * worth — and the fourth tile, "What's left to the family", was the IN-CARE do-nothing figure: a
 * different basis from the other three, and for a village resident it carried the unit's payout
 * banked in year one. So the tile now projects the household as it is, with no move into care,
 * over the same horizon; the in-care baseline bridges to the strategies in a sentence under it.
 *
 * Null where someone is already in residential care (there is no "staying where you are" without
 * care to project), where the horizon is nil, or where the run fails — a missing figure is said as
 * missing, never as nothing.
 */ 

/**
 * "What happens if we do nothing?" — projected over the same period the strategy is.
 *
 * WHY THIS IS SHARED (owner direction, 2026-08-26). Every module compared its projected estate
 * against the client's net worth TODAY, which is not a benchmark — it is a different question. Five
 * years of ordinary growth makes almost any strategy look like a gain, so a plan that leaves the
 * family materially worse off than doing nothing can be reported as an improvement. Retirement
 * Village showed "+$167,743 vs today" for a plan that left $388,974 LESS than staying put.
 *
 * The benchmark is always the client's realistic alternative, run over the same years:
 *   - ELECTIVE modules (Downsizer, Granny Flat, Retirement Village) — don't do it; life as it is.
 *   - REQUIREMENT modules (Aged Care, Support at Home) — the care happens either way, so the
 *     alternative is doing it with NO strategy. Those pass their own costs in, because "no plan"
 *     still pays for care. See agedCareBaseline.ts, which additionally has to carry the residency
 *     override and therefore keeps its own richer builder.
 *
 * This helper exists so the remaining three modules cannot each grow their own version. Three
 * implementations of one idea is how the Aged Care panel and its plan summary ended up quoting
 * baselines that differed by a full year of nursing-home fees.
 */ 

var $acw62 = parcelRequire("acw62");

const $db92cec86168e39f$export$1eeeb2307db00a6b = {
    totalDailyCost: 0,
    dailyAccommodationPayment: 0,
    basicDailyFee: 0,
    dailyNCCC: 0,
    dailyHSC: 0,
    dailyExtraServiceFee: 0
};
function $db92cec86168e39f$export$4e1081e3e75fac0b(factFind, legacyYears, options = {}) {
    return $db92cec86168e39f$export$2968cabee8db6131(factFind, legacyYears, options).legacy;
}
function $db92cec86168e39f$export$2968cabee8db6131(factFind, legacyYears, options = {}) {
    const { enabled: enabled = true, strategyOptions: strategyOptions, agedCareCosts: agedCareCosts, track: track } = options;
    const [result, setResult] = (0, $acw62.useState)({
        legacy: null,
        rows: null
    });
    // Serialised so a caller passing a fresh object literal each render does not re-run forever.
    const optionsKey = JSON.stringify(strategyOptions ?? {});
    const costsKey = JSON.stringify(agedCareCosts ?? $db92cec86168e39f$export$1eeeb2307db00a6b);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        if (!enabled || !factFind || !(legacyYears > 0)) {
            setResult({
                legacy: null,
                rows: null
            });
            return undefined;
        }
        const run = $55a1d8a64f1e5dfa$export$75699a59a86ef1ab(factFind, JSON.parse(optionsKey), JSON.parse(costsKey), legacyYears);
        (track ? track(run) : run).then((rows)=>{
            if (cancelled) return;
            const last = rows?.[legacyYears - 1] ?? rows?.[rows.length - 1];
            setResult({
                legacy: (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(last),
                rows: Array.isArray(rows) ? rows : null
            });
        }).catch(()=>{
            if (!cancelled) setResult({
                legacy: null,
                rows: null
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind,
        legacyYears,
        enabled,
        optionsKey,
        costsKey
    ]);
    return result;
}


/** A care start the run never reaches: the household stays in its recorded arrangement. */ const $02192dd5d748995e$var$NEVER = '2199-01-01';
function $02192dd5d748995e$export$1c5449a14badef3c(ff) {
    const client = ff?.client?.currentResidency;
    const partner = ff?.partner?.currentResidency;
    return client === 'aged_care' || ff?.adviceFor === 'couple' && partner === 'aged_care';
}
async function $02192dd5d748995e$export$57587e83662dca06(factFind, legacyYears, opts = {}) {
    if (!factFind || !(legacyYears > 0) || $02192dd5d748995e$export$1c5449a14badef3c(factFind)) return null;
    const living = parseFloat(String(factFind.expenses?.livingExpenses ?? '')) || 0;
    try {
        const rows = await $55a1d8a64f1e5dfa$export$75699a59a86ef1ab(factFind, {
            rentHome: false,
            downsizeHome: false,
            careStartDate: $02192dd5d748995e$var$NEVER,
            scenarioLivingExpenses: living,
            ...opts.projectionPeriodMode ? {
                projectionPeriodMode: opts.projectionPeriodMode
            } : {}
        }, {
            ...(0, $db92cec86168e39f$export$1eeeb2307db00a6b),
            scenarioLivingExpenses: living
        }, legacyYears);
        const last = rows?.[legacyYears - 1] ?? rows?.[(rows?.length ?? 0) - 1];
        return (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(last);
    } catch  {
        return null;
    }
}




/**
 * What a plan's Age Pension change asks the client to DO (owner, 3 Oct 2026).
 *
 * A plan can make someone eligible who is not paid the pension today, or lift (or cut) a pension
 * they already get. None of it happens on its own: the pension is not paid automatically, and an
 * existing pension moves only once Services Australia knows about the changes. Every Statement of
 * Advice and the Action Plan say so from this one place, so they cannot drift apart.
 *
 * "Paid today" is read the way the Dashboard reads it: the do-nothing pension is above zero.
 */ /** Under about $10 a fortnight either way is noise in a projection, not a change to act on. */ const $b82b108d4741f18d$var$MIN_CHANGE = 260;
function $b82b108d4741f18d$export$143d894e260814c1(planPension, baselinePension) {
    const plan = Number.isFinite(planPension) ? planPension : 0;
    const base = Number.isFinite(baselinePension) ? baselinePension : 0;
    if (base < 1 && plan >= $b82b108d4741f18d$var$MIN_CHANGE) return 'newly_eligible';
    if (base >= 1 && plan - base >= $b82b108d4741f18d$var$MIN_CHANGE) return 'increase';
    if (base >= 1 && base - plan >= $b82b108d4741f18d$var$MIN_CHANGE) return 'decrease';
    return 'none';
}
const $b82b108d4741f18d$var$money = (v)=>`$${Math.round(v).toLocaleString('en-AU')}`;
function $b82b108d4741f18d$export$fdc5fe41a9ca9852(planPension, baselinePension, opts = {}) {
    const kind = $b82b108d4741f18d$export$143d894e260814c1(planPension, baselinePension);
    if (kind === 'none') return null;
    const order = opts.meansAssessment === 'residential' ? ' Claim it before the aged care means assessment: once you are paid the pension, Services Australia already knows your income and assets, so the assessment needs only the home form (SA485), or no form at all if there is no home, instead of the full SA457.' : opts.meansAssessment === 'home' ? ' Claim it before the Support at Home means assessment: once you are paid the pension, Services Australia already knows your income and assets and no means assessment form is needed, instead of the SA456.' : '';
    if (kind === 'newly_eligible') return {
        kind: kind,
        implication: {
            title: 'Claiming the Age Pension',
            lead: `The plan qualifies you for about ${$b82b108d4741f18d$var$money(planPension)} a year of Age Pension. It is not paid automatically: you have to claim it.`,
            body: 'Claim once the changes in this plan are made, because Services Australia assesses what you own and earn on the day it decides your claim. Claim online through myGov (Centrelink), or on the Claim for Age Pension form (SA002) with the Income and assets form (SA369). You can lodge up to 13 weeks before you reach Age Pension age. The pension is generally paid from the day you claim, not before, so claim promptly once the changes are done.' + order
        },
        nextStep: `Claim the Age Pension once the changes are made. It is not paid automatically, and the plan expects about ${$b82b108d4741f18d$var$money(planPension)} a year. Claim through myGov, or on the SA002 and SA369, which the Action Plan fills in for you.${opts.meansAssessment ? ' Do this before the means assessment.' : ''}`
    };
    if (kind === 'increase') return {
        kind: kind,
        implication: {
            title: 'Telling Services Australia',
            lead: `Your Age Pension is expected to rise from about ${$b82b108d4741f18d$var$money(baselinePension)} to ${$b82b108d4741f18d$var$money(planPension)} a year. It rises only once Services Australia knows about the changes.`,
            body: 'Report each change, such as a sale, a purchase or money moved, within 14 days, through myGov or by phone. The higher rate starts once they reassess you. Until then you are paid on what they last knew.'
        },
        nextStep: `Tell Services Australia about each change within 14 days, through myGov or by phone. Your pension is expected to rise from about ${$b82b108d4741f18d$var$money(baselinePension)} to ${$b82b108d4741f18d$var$money(planPension)} a year, and the higher rate starts only once they reassess you.`
    };
    return {
        kind: kind,
        implication: {
            title: 'Telling Services Australia',
            lead: `Your Age Pension is expected to fall from about ${$b82b108d4741f18d$var$money(baselinePension)} to ${$b82b108d4741f18d$var$money(planPension)} a year under this plan.`,
            body: 'Report each change, such as a sale, a purchase or money moved, within 14 days, through myGov or by phone. Any pension paid at the old rate after a change you have not reported is a debt you have to repay.'
        },
        nextStep: `Tell Services Australia about each change within 14 days, through myGov or by phone. Your pension is expected to fall from about ${$b82b108d4741f18d$var$money(baselinePension)} to ${$b82b108d4741f18d$var$money(planPension)} a year, and anything overpaid after a change has to be repaid.`
    };
}



/**
 * Who an advice document says the advice came from.
 *
 * A Statement of Advice has to name the entities standing behind it, and which entities those are
 * depends on HOW the firm's advice is provided — not on whether it is licensed. Three structures,
 * three different lines:
 *
 *   own_afsl      the practice IS the licensee. Its people are representatives of it by employment
 *                 and are NOT authorised representatives — ASIC does not put an employee on the AR
 *                 register — so the line must not call them one.
 *   corporate_ar  the practice is authorised by a licensee, and the adviser is authorised too. Three
 *                 entities: the person, the practice, the licensee.
 *   individual_ar the person is authorised, with no practice company between them and the licensee.
 *
 * Anything else — an accountant, a provider, a firm that has not answered yet — is not giving the
 * advice at all. We are, under our own licence, and the document says so plainly.
 *
 * Kept as a pure function with no rendering in it because it is the one piece of this feature a
 * client reads and a regulator could ask about, and because a string this consequential should be
 * testable without building a document around it.
 */ const $92fb3c34dca71663$var$clean = (v)=>(v ?? '').trim();
function $92fb3c34dca71663$export$236a6ecb53473bcf(p, platform) {
    const adviser = $92fb3c34dca71663$var$clean(p.adviserName) || 'Your adviser';
    const licensee = $92fb3c34dca71663$var$clean(p.licenseeName);
    const afsl = $92fb3c34dca71663$var$clean(p.afslNumber);
    const adviserNo = $92fb3c34dca71663$var$clean(p.adviserNumber);
    if (p.adviceStructure === 'own_afsl') {
        // "Representative", never "authorised representative": an employee or director of the
        // licensee is the former and not the latter, and the difference is a matter of fact.
        const parts = [
            adviser,
            `a representative of ${$92fb3c34dca71663$var$clean(p.firmName) || licensee || 'the licensee'}`
        ];
        if (licensee && $92fb3c34dca71663$var$clean(p.firmName) && licensee !== $92fb3c34dca71663$var$clean(p.firmName)) parts.push(licensee);
        if (afsl) parts.push(`AFSL ${afsl}`);
        return {
            line: `${parts.join(', ')}.`,
            complete: Boolean(licensee || $92fb3c34dca71663$var$clean(p.firmName)) && Boolean(afsl),
            provider: 'firm'
        };
    }
    if (p.adviceStructure === 'corporate_ar') {
        const carName = $92fb3c34dca71663$var$clean(p.carName) || $92fb3c34dca71663$var$clean(p.firmName);
        const carNo = $92fb3c34dca71663$var$clean(p.carNumber);
        const parts = [
            adviser
        ];
        if (adviserNo) parts.push(`Authorised Representative No. ${adviserNo}`);
        if (carName) parts.push(`of ${carName}`);
        if (carNo) parts.push(`Corporate Authorised Representative No. ${carNo}`);
        if (licensee) parts.push(`of ${licensee}`);
        if (afsl) parts.push(`AFSL ${afsl}`);
        return {
            line: `${parts.join(', ')}.`,
            complete: Boolean(adviserNo && carName && carNo && licensee && afsl),
            provider: 'firm'
        };
    }
    if (p.adviceStructure === 'individual_ar') {
        const parts = [
            adviser
        ];
        if (adviserNo) parts.push(`Authorised Representative No. ${adviserNo}`);
        if (licensee) parts.push(`of ${licensee}`);
        if (afsl) parts.push(`AFSL ${afsl}`);
        return {
            line: `${parts.join(', ')}.`,
            complete: Boolean(adviserNo && licensee && afsl),
            provider: 'firm'
        };
    }
    // No structure recorded: the advice is ours, given under our licence. The firm is named as the
    // introducer and nothing more — the partner terms are explicit that a non-adviser professional
    // must not be held out as the provider of the advice.
    const platformName = $92fb3c34dca71663$var$clean(platform.entityName) || 'AgedCareWise Pty Ltd';
    const platformAfsl = $92fb3c34dca71663$var$clean(platform.afslNumber);
    const firm = $92fb3c34dca71663$var$clean(p.firmName);
    const head = platformAfsl ? `${platformName}, AFSL ${platformAfsl}` : platformName;
    return {
        line: firm ? `${head}. Referred by ${firm}, who is not the provider of this advice.` : `${head}.`,
        complete: Boolean(platformAfsl),
        provider: 'platform'
    };
}
/*
 * Who the signed-in firm is, for the advice documents.
 *
 * A module-level value rather than a prop, deliberately. The Statement of Advice builders sit five
 * components below the place that knows which firm is signed in, and the alternative is threading one
 * string through every one of them — including components that have no business knowing about firms
 * at all. "Which firm is signed in" is genuinely application-wide state; a prop chain would not make
 * it less so, only harder to follow.
 *
 * Null is the honest default and the safe one: a consumer working on their own file has no firm, and
 * a document with nothing here falls back to the placeholder it has always shown.
 */ let $92fb3c34dca71663$var$currentAttribution = null;
function $92fb3c34dca71663$export$8dcd5d1de2b3df34(next) {
    $92fb3c34dca71663$var$currentAttribution = next;
}
function $92fb3c34dca71663$export$174185a301570ae7() {
    return $92fb3c34dca71663$var$currentAttribution;
}




/**
 * The one sentence every screen uses for what comes back from a lifetime annuity.
 *
 * Owner, 25 Sep 2026: the tool had promised the purchase price back "at the end" on a capital-
 * returned annuity, on every surface, while assessing it at 60%. The Centrelink rules allow both
 * only inside the capital access schedule: the full amount during the first half of the owner's life
 * expectancy, then a straight line down to nothing (annuityStrategies.ts). Ten screens said it ten
 * ways; this says it once, in words a client can act on, and each screen reads it from here.
 */ 
function $5ccd559ea4d04f2e$export$22f90741645fc6a8(input) {
    const age = typeof input.age === 'number' && Number.isFinite(input.age) ? input.age : null;
    if (age == null) return null;
    const sex = (0, $f7f7b62814c3b615$export$97c58f575ae57007)(input.sex);
    const partnerSex = (0, $f7f7b62814c3b615$export$97c58f575ae57007)(input.partnerSex);
    const joint = !!input.joint && typeof input.partnerAge === 'number' && Number.isFinite(input.partnerAge);
    const years = (0, $f7f7b62814c3b615$export$b263bc911c6d9872)({
        age: age,
        partnerAge: joint ? input.partnerAge : null,
        type: joint ? 'joint' : 'single',
        sex: sex,
        partnerSex: partnerSex
    });
    return {
        periodYears: (0, $f7f7b62814c3b615$export$5c496b19d3677ed3)(years),
        sexKnown: joint ? sex != null && partnerSex != null : sex != null
    };
}
const $5ccd559ea4d04f2e$var$halfWords = (periodYears)=>{
    const half = periodYears / 2;
    return Number.isInteger(half) ? String(half) : `${Math.floor(half)}\xbd`;
};
function $5ccd559ea4d04f2e$export$476ca360cf39c0a7(input) {
    const pct = Math.max(0, Math.min(100, Math.round(Number(input.residualPct) || 0)));
    const owner = (input.ownerName || 'you').trim() || 'you';
    const dies = owner === 'you' ? 'die' : 'dies';
    const possessive = owner === 'you' ? 'your' : `${owner}'s`;
    const amount = input.amountWords || 'the purchase price';
    if (pct <= 0) return `Nothing of ${amount} comes back on death: the provider keeps it, which is why the income is higher.`;
    const share = pct >= 100 ? `${amount.charAt(0).toUpperCase()}${amount.slice(1)}` : `${pct}% of ${amount}`;
    const period = input.periodYears != null && Number.isFinite(Number(input.periodYears)) && Number(input.periodYears) > 0 ? Number(input.periodYears) : null;
    const tail = input.sexKnown === false ? ' No sex is recorded on the profile, so the shorter life table is used.' : '';
    /*
     * TWO EDITS HERE, 25 Sep 2026, both from the owner reviewing the live screen.
     *
     * 1. THE TAPER NOW MATCHES THE MARKET. Past the halfway point the death benefit is not a fresh
     *    line of its own: it becomes the cash-out value, which has been falling since day one
     *    (capitalAccessDeathBenefitFactor). So the sentence says "whatever you could have cashed out"
     *    rather than "the amount falls each year" — one line for the client to follow, not two.
     * 2. THE CENTRELINK TAIL IS GONE. It used to end "...the most the Centrelink rules allow while
     *    still counting only 60% of the annuity." That fact is true, but this sentence appears on
     *    ten surfaces, every one of which also carries a "what this means for you" block stating the
     *    same 60%. Saying it in both places is what made the screen feel like it was repeating
     *    itself. The means test is now stated once, where the figures are.
     */ if (period == null) return `${share} comes back to the estate only if ${owner} ${dies} within the first half of ${possessive} life expectancy. After that the estate gets whatever could have been cashed out at the time, which falls to nothing by the end of that period.${tail}`;
    return `${share} comes back to the estate only if ${owner} ${dies} within the first ${$5ccd559ea4d04f2e$var$halfWords(period)} years. After that the estate gets whatever could have been cashed out at the time, falling to nothing after ${period} years.${tail}`;
}
function $5ccd559ea4d04f2e$export$2c66fbb86a8ec25c(residualPct, periodYears) {
    const pct = Math.max(0, Math.min(100, Math.round(Number(residualPct) || 0)));
    if (pct <= 0) return 'nothing back on death';
    const period = periodYears != null && Number(periodYears) > 0 ? Number(periodYears) : null;
    return period ? `${pct}% back if death is within ${$5ccd559ea4d04f2e$var$halfWords(period)} years, falling to nil by year ${period}` : `${pct}% back if death is early, falling to nil by life expectancy`;
}
function $5ccd559ea4d04f2e$export$2dfd0dacdd6d7571(input) {
    const own = $5ccd559ea4d04f2e$export$22f90741645fc6a8({
        age: input.age,
        sex: input.sex
    });
    if (!own) return null;
    const name = (input.ownerName || '').trim();
    const forWhom = name ? `for ${name}` : 'for you';
    const half = $5ccd559ea4d04f2e$var$halfWords(own.periodYears);
    const base = `${forWhom} that is about the first ${half} ${own.periodYears === 2 ? 'year' : 'years'}`;
    const partnerAge = typeof input.partnerAge === 'number' && Number.isFinite(input.partnerAge) ? input.partnerAge : null;
    if (partnerAge == null) return base;
    // The joint window runs on whichever life is longer, so it is never shorter than the single one.
    const joint = $5ccd559ea4d04f2e$export$22f90741645fc6a8({
        age: input.age,
        sex: input.sex,
        partnerAge: partnerAge,
        partnerSex: input.partnerSex,
        joint: true
    });
    if (!joint || joint.periodYears <= own.periodYears) return base;
    const other = (input.partnerName || '').trim();
    return `${base}, and longer if the payments continue to ${other || 'the survivor'}`;
}
function $5ccd559ea4d04f2e$export$46d1eb5f72e59f31(yearsElapsed) {
    const whole = Math.floor(yearsElapsed);
    return Math.abs(yearsElapsed - whole - 0.5) < 1e-9 ? `${whole}\xbd` : String(whole);
}
function $5ccd559ea4d04f2e$export$661c19f614fd3b28(input) {
    const period = Number(input.periodYears);
    const amount = Number(input.purchaseAmount);
    const pct = Math.max(0, Math.min(100, Math.round(Number(input.residualPct) || 0)));
    if (!Number.isFinite(period) || period <= 0 || !Number.isFinite(amount) || amount <= 0 || pct <= 0) return [];
    const death = amount * (pct / 100);
    /*
     * THREE ROWS: the start, the moment the guarantee ends, and the end of the period. Now that the
     * death benefit becomes the cash-out value past the halfway point, a fourth row said nothing the
     * third did not.
     *
     * THE HALFWAY POINT IS NOT A WHOLE YEAR, and rounding it broke the table (owner-caught on the
     * live screen, 26 Sep 2026). On a seven-year period the guarantee runs to 3½ years; the row was
     * being rounded to year 3, which is still INSIDE the guarantee, so the table showed the full
     * amount at year 3 and nothing at year 7 with no sign of the step between. The one moment the
     * table exists to show was the one it skipped. The mark is now the exact half.
     */ const half = period / 2;
    const seen = new Set();
    const rows = [];
    for (const mark of [
        0,
        half,
        period
    ]){
        const year = Math.max(0, Math.min(period, mark));
        if (seen.has(year)) continue;
        seen.add(year);
        rows.push({
            yearsElapsed: year,
            onDeath: death * (0, $f7f7b62814c3b615$export$704532a9d5d3e528)(year, period),
            // The withdrawal cap is a share of the PURCHASE PRICE, not of the death benefit: the two
            // caps in SIS reg 1.06A are separate lines, and only the death one is scaled by the
            // residual the client chose.
            ifCashedOut: amount * (0, $f7f7b62814c3b615$export$db240080e052bedc)(year, period)
        });
    }
    return rows.sort((a, b)=>a.yearsElapsed - b.yearsElapsed);
}
function $5ccd559ea4d04f2e$export$126eb7c270904737(input) {
    const pct = Math.max(0, Math.min(100, Math.round(Number(input.residualPct) || 0)));
    const period = Number(input.periodYears);
    const amount = Number(input.purchaseAmount);
    if (pct <= 0) return null;
    if (!Number.isFinite(period) || period <= 0 || !Number.isFinite(amount) || amount <= 0) return null;
    return amount * (0, $f7f7b62814c3b615$export$db240080e052bedc)(Number(input.yearsElapsed) || 0, period);
}
function $5ccd559ea4d04f2e$export$3d6c3509706680fc(input) {
    const pct = Math.max(0, Math.min(100, Math.round(Number(input.residualPct) || 0)));
    const owner = (input.ownerName || 'you').trim() || 'you';
    const cannot = owner === 'you' ? 'you cannot' : `${owner} cannot`;
    if (pct <= 0) return `There is no cash-out value on this shape: once it starts, ${cannot} take the money back. That is why it pays the most income.`;
    const period = input.periodYears != null && Number(input.periodYears) > 0 ? Number(input.periodYears) : null;
    const window = period ? `falling to nothing after ${period} years` : 'falling each year to nothing by the end of the period';
    return `The money is not locked away. The most that can be taken back starts at the full amount and falls in a straight line, ${window}. What the provider actually pays depends on interest rates that day and the cost of breaking the investment, so it is usually less \u{2014} and cashing out ends the income for good.`;
}
function $5ccd559ea4d04f2e$export$e4f6931f22c5a3e9(input) {
    const pct = Math.max(0, Math.min(100, Math.round(Number(input.residualPct) || 0)));
    const base = 'Sometimes called the residual capital value. The more you guarantee back, the lower your income.';
    if (pct <= 0) return `${base} At nothing back, this pays the most of any shape: the provider keeps whatever is left, and there is no cash-out value either.`;
    const period = input.periodYears != null && Number(input.periodYears) > 0 ? Number(input.periodYears) : null;
    const when = period ? `the first ${$5ccd559ea4d04f2e$var$halfWords(period)} years. After that the estate gets whatever could have been cashed out at the time, and nothing after ${period} years` : 'the first half of life expectancy. After that the estate gets whatever could have been cashed out at the time, and nothing beyond that period';
    // No Centrelink sentence here: every screen that shows this control also shows a "what this
    // means for you" block with the 60% in it, and saying it twice is what made the page feel long.
    return `${base} The full amount is paid to the estate only if death comes within ${when}.`;
}
function $5ccd559ea4d04f2e$export$60e5f05f6afbd91(input) {
    const owner = (input.ownerName || 'you').trim() || 'you';
    const dies = owner === 'you' ? 'die' : 'dies';
    const period = input.periodYears != null && Number(input.periodYears) > 0 ? Number(input.periodYears) : null;
    if (period == null) return `If ${owner} ${dies} early, how much comes back?`;
    return `If ${owner} ${dies} within the first ${$5ccd559ea4d04f2e$var$halfWords(period)} years, how much comes back?`;
}




/**
 * THE GUARANTEED INCOME SECTION OF THE ADVICE DOCUMENT (owner, 21 Oct 2026 — the guaranteed income review R1–R4
 * and the agreed mock-up, docs/ux-review/annuities/ screen 5).
 *
 * For a plan with a guaranteed income for life, the document says:
 *   - what was recommended, in the words for THAT type (what the family receives), with the income and where
 *     the figure came from: our estimate from the published rates and their date (and whether they are more
 *     than two weeks old, annuityRateSheet), or the provider's quote; a written quote is needed before buying;
 *   - the year-by-year table of what the family receives if the person passes away (the same table as the
 *     plan card, AnnuityFamilyPanel), against the same plan without the guaranteed income where there is one;
 *   - the alternatives: the best plan tested without a guaranteed income;
 *   - the assumptions, in plain words, including that the figures assume the person lives the whole period;
 *   - the client's own answers to the questions, with the date;
 *   - for income only, the client's confirmation word for word, with its date.
 *
 * Plain data, frozen when the document is made (the snapshot is re-rendered later by the licensee view). No
 * product or provider is named. Used by the village, downsizing and granny flat documents (moduleSoa.ts).
 */ 


/**
 * "Would you consider locking money away for a guaranteed income for life?" — the client's answer,
 * read by every module's candidate generator.
 *
 * Owner, 24-25 September 2026. The village Suggestion Engine asked this in its Strategy Analysis
 * Setup and no other module did, so a client who had said no in one place was still shown annuity
 * strategies everywhere else. The willingness is a property of the CLIENT, not of the module, so it
 * is saved once on the client record and honoured by all of them.
 *
 * Asked in everyday words, never as "% into an annuity" — a client should not need to know what an
 * annuity is to answer. The wording lives in the screens; this holds the answer and the rules.
 */ 
const $ff5de4128b46b139$var$APPETITES = [
    'none',
    'yes',
    'unsure'
];
const $ff5de4128b46b139$var$RESIDUALS = [
    'returned',
    'nil',
    'guaranteed',
    'both',
    'back',
    'all'
];
function $ff5de4128b46b139$export$636a9065c3f862c1(factFind) {
    const goals = factFind?.goals || {};
    const rawAppetite = goals.annuityAppetite ?? goals.rvAnnuityAppetite;
    const rawResidual = goals.annuityResidual ?? goals.rvAnnuityResidual;
    const appetite = $ff5de4128b46b139$var$APPETITES.includes(rawAppetite) ? rawAppetite : 'unsure';
    const stored = $ff5de4128b46b139$var$RESIDUALS.includes(rawResidual) ? rawResidual : 'back';
    // "Not sure", and the old "whichever works best", test the types that return the money.
    const residual = appetite !== 'yes' || stored === 'both' ? 'back' : stored;
    return {
        appetite: appetite,
        residual: residual,
        answered: $ff5de4128b46b139$var$APPETITES.includes(rawAppetite)
    };
}
function $ff5de4128b46b139$export$dfe7011c177934aa(preference) {
    return preference.appetite !== 'none';
}
function $ff5de4128b46b139$export$b8876d0a37b8526a(preference, residualCapital) {
    if (!$ff5de4128b46b139$export$dfe7011c177934aa(preference)) return false;
    const returnsCapital = Number(residualCapital) > 0;
    switch(preference.residual){
        case 'all':
            return true;
        case 'nil':
            return !returnsCapital;
        case 'returned':
        case 'back':
        case 'both':
            return returnsCapital;
        case 'guaranteed':
            return false;
        default:
            return returnsCapital;
    }
}
function $ff5de4128b46b139$export$f8400e32c0c5cc46(preference) {
    return $ff5de4128b46b139$export$dfe7011c177934aa(preference) && (preference.residual === 'all' || preference.residual === 'nil');
}
function $ff5de4128b46b139$export$623904c9366cf5a0(preference, factFind, owner = 'client') {
    if (!$ff5de4128b46b139$export$dfe7011c177934aa(preference)) return false;
    const wanted = preference.residual === 'guaranteed' || preference.residual === 'back' || preference.residual === 'all' || preference.residual === 'both';
    return wanted && (0, $d08210caeacdc75a$export$7095ab72ebd46272)(factFind, owner);
}
const $ff5de4128b46b139$export$918497a7c667b06f = 25;
function $ff5de4128b46b139$export$e46e91ebc7373b0a(factFind, moduleSharePct) {
    const goals = factFind?.goals || {};
    const answeredOn = typeof goals.annuityAnsweredOn === 'string' && goals.annuityAnsweredOn ? String(goals.annuityAnsweredOn) : null;
    const amount = Number(goals.annuityShareCapAmount);
    if (Number.isFinite(amount) && amount > 0) return {
        pct: null,
        amount: amount,
        answeredOn: answeredOn,
        answered: true
    };
    const pct = Number(goals.annuityShareCapPct);
    if (Number.isFinite(pct) && pct > 0) return {
        pct: Math.min(100, pct),
        amount: null,
        answeredOn: answeredOn,
        answered: true
    };
    const modulePct = Number(moduleSharePct);
    if (Number.isFinite(modulePct) && modulePct > 0) return {
        pct: Math.min(100, modulePct),
        amount: null,
        answeredOn: answeredOn,
        answered: true
    };
    return {
        pct: $ff5de4128b46b139$export$918497a7c667b06f,
        amount: null,
        answeredOn: answeredOn,
        answered: false
    };
}
function $ff5de4128b46b139$export$19a5715b59108050(ceiling, investable) {
    const inv = Math.max(0, Number(investable) || 0);
    if (ceiling.amount != null) return Math.min(inv, ceiling.amount);
    return Math.round(inv * ((ceiling.pct ?? $ff5de4128b46b139$export$918497a7c667b06f) / 100));
}
function $ff5de4128b46b139$export$4f927c40fcfe148a(factFind, residualCapital) {
    return $ff5de4128b46b139$export$b8876d0a37b8526a($ff5de4128b46b139$export$636a9065c3f862c1(factFind), residualCapital);
}




function $66827b1304244a1d$export$d7abe769aaaff57f(factFind) {
    const pref = (0, $ff5de4128b46b139$export$636a9065c3f862c1)(factFind);
    const ceiling = (0, $ff5de4128b46b139$export$e46e91ebc7373b0a)(factFind, factFind?.goals?.rvAnnuityShareCapPct);
    const answer = !pref.answered ? 'Not answered. We tested the types that pay the money back to the family (the suggested answer).' : pref.appetite === 'none' ? '"No, keep all the money within reach."' : pref.residual === 'all' || pref.residual === 'nil' ? '"Yes, and the most income, even if nothing goes back."' : '"Yes, if the money goes back to the family."';
    const ceilingWords = !ceiling.answered ? 'Not answered. We used the suggested ceiling: no more than 25% of the money that could be invested.' : ceiling.amount != null ? `No more than ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(ceiling.amount))}.` : `No more than ${ceiling.pct}% of the money that could be invested.`;
    return {
        answer: answer,
        ceiling: ceilingWords,
        answeredOn: ceiling.answeredOn
    };
}
function $66827b1304244a1d$export$11aaa304d9182b(i) {
    const list = i.rows || [];
    if (!(i.amount > 0) || !list.length) return null;
    const compare = i.compareRows || [];
    const years = (0, $8665f80549f60a1b$export$6b451904abde1f6a)(i.horizonYears, list.length);
    const rows = years.map((y)=>({
            label: y === 1 ? 'In the first year' : `After ${y} years`,
            fromAnnuity: Math.round((0, $8665f80549f60a1b$export$9d518f1287e3f18f)(list[y - 1], i.factFind)),
            withPlan: list[y - 1] ? Math.round(Number((0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(list[y - 1])) || 0) : null,
            without: compare.length ? Math.round(Number((0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(compare[Math.min(y, compare.length) - 1])) || 0) : null
        }));
    let sheetDate = null;
    let stale = false;
    try {
        const s = (0, $d697a0cc78e06dde$export$dd575ab7aedb8603)();
        sheetDate = s.effectiveFrom || null;
        stale = !!s.stale;
    } catch  {}
    const record = i.kind === 'incomeOnly' && (0, $5eae79c7e46ed27e$export$9ad5f972205b4f88)(i.factFind, i.amount) ? (0, $5eae79c7e46ed27e$export$f2117850dfd196a6)(i.factFind) : null;
    return {
        personName: i.personName,
        amount: Math.round(i.amount),
        kind: i.kind,
        incomeAYear: i.incomeAYear != null && i.incomeAYear > 0 ? Math.round(i.incomeAYear) : null,
        quoted: !!i.quoted,
        rateSheetDate: sheetDate,
        rateSheetStale: stale,
        rows: rows,
        compareNote: compare.length ? i.compareNote || null : null,
        alternative: i.alternative ?? null,
        plan: i.plan,
        horizonYears: Math.max(1, Math.round(i.horizonYears) || 1),
        answers: $66827b1304244a1d$export$d7abe769aaaff57f(i.factFind),
        incomeOnlyRecord: record ? {
            amount: Math.round(Number(record.amount) || 0),
            date: String(record.date || ''),
            words: String(record.words || '')
        } : null
    };
}
const $66827b1304244a1d$var$esc = (v)=>String(v ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
const $66827b1304244a1d$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
const $66827b1304244a1d$var$dateWords = (iso)=>{
    if (!iso) return '';
    const d = new Date(`${iso.slice(0, 10)}T00:00:00`);
    return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });
};
function $66827b1304244a1d$export$da84ab8401ac1a2b(kind, name) {
    if (kind === 'fullBack') return `a lifetime guaranteed income with life cover, which returns the full amount to ${name}\u{2019}s estate whenever ${name} passes away`;
    if (kind === 'moneyBack') return `a lifetime guaranteed income that returns the money to ${name}\u{2019}s estate in the early years: the whole amount if ${name} passes away in about the first half of ${name}\u{2019}s life expectancy, then a smaller amount, falling to nothing`;
    return `a lifetime guaranteed income that pays the most income and returns nothing to ${name}\u{2019}s estate, even if ${name} passes away soon after buying it`;
}
function $66827b1304244a1d$export$5f47fbab513e00f4(g) {
    const name = $66827b1304244a1d$var$esc(g.personName);
    const withCompare = g.rows.some((r)=>r.without != null);
    const source = g.quoted ? "the provider\u2019s quote" : `an estimate from published rates${g.rateSheetDate ? ` dated ${$66827b1304244a1d$var$esc($66827b1304244a1d$var$dateWords(g.rateSheetDate))}` : ''}${g.rateSheetStale ? ' (those rates are more than two weeks old, so the income may have changed)' : ''}`;
    const income = g.incomeAYear ? ` The income is about ${$66827b1304244a1d$var$money(g.incomeAYear)} a year, ${source}.` : ` The income is ${source}.`;
    const table = `<div style="overflow-x:auto"><table><thead><tr><th>If ${name} passes away</th><th style="text-align:right">From the guaranteed income</th><th style="text-align:right">The family receives in total, with this plan</th>${withCompare ? '<th style="text-align:right">The same plan without a guaranteed income</th>' : ''}</tr></thead><tbody>
${g.rows.map((r)=>`<tr><td>${$66827b1304244a1d$var$esc(r.label)}</td><td class="td-num" style="text-align:right">${r.fromAnnuity < 1 ? 'nothing' : $66827b1304244a1d$var$money(r.fromAnnuity)}</td><td class="td-num" style="text-align:right">${r.withPlan == null ? "\u2014" : $66827b1304244a1d$var$money(r.withPlan)}</td>${withCompare ? `<td class="td-num" style="text-align:right">${r.without == null ? "\u2014" : $66827b1304244a1d$var$money(r.without)}</td>` : ''}</tr>`).join('')}
</tbody></table></div>${withCompare && g.compareNote ? `<p class="small muted">The last column is ${$66827b1304244a1d$var$esc(g.compareNote)}, so the difference is the guaranteed income alone.</p>` : ''}`;
    const alt = g.alternative;
    const altLine = alt ? `<p><strong>Why this and not the alternatives.</strong> We also tested plans without a guaranteed income. The best of them, ${$66827b1304244a1d$var$esc(alt.name)}, leaves ${$66827b1304244a1d$var$money(alt.estate)} to the family after ${g.horizonYears} years, against ${$66827b1304244a1d$var$money(g.plan.estate)} with this plan; its Age Pension is ${$66827b1304244a1d$var$money(alt.pension)} a year against ${$66827b1304244a1d$var$money(g.plan.pension)}, and it leaves ${$66827b1304244a1d$var$money(alt.cashflow)} a year to spare against ${$66827b1304244a1d$var$money(g.plan.cashflow)}. ${g.kind === 'incomeOnly' ? 'This plan pays more while ' + name + ' lives, and less to the family if ' + name + ' passes away early.' : 'The table above shows what the family receives at each point if ' + name + ' passes away sooner.'}</p>` : "<p><strong>Why this and not the alternatives.</strong> The other plans tested, with and without a guaranteed income, are compared in \u201CAlternative strategies considered\u201D.</p>";
    const centrelink = g.kind === 'fullBack' ? 'Centrelink counts the income part at 60% and the life cover in full.' : 'Centrelink counts 60% of the price for the first five years, or until age 85 if that is later, and 30% after that, and 60% of each payment as income.';
    const assumptions = `<p><strong>Assumptions.</strong> The figures after ${g.horizonYears} years assume ${name} lives the whole period; the table shows what the family receives if ${name} passes away sooner. ${centrelink} The income is ${g.quoted ? "the provider\u2019s quote, scaled to this amount" : 'our estimate, not a quote'}. Before buying, ${name} should obtain a written quote; the provider\u{2019}s quote replaces our estimate. Money in a guaranteed income is hard to get back out once it is paid.</p>`;
    const answers = `<p><strong>${name}\u{2019}s answers${g.answers.answeredOn ? `, given on ${$66827b1304244a1d$var$esc($66827b1304244a1d$var$dateWords(g.answers.answeredOn))}` : ''}.</strong> Would ${name} consider putting part of the money into a guaranteed income for life? ${$66827b1304244a1d$var$esc(g.answers.answer)} At most, how much could go into it? ${$66827b1304244a1d$var$esc(g.answers.ceiling)}</p>`;
    const record = g.kind !== 'incomeOnly' ? '' : g.incomeOnlyRecord ? `<div class="callout" style="border:1px solid #cfd6e0;border-left:4px solid #d97706;background:#fff"><p class="small" style="margin:0">On ${$66827b1304244a1d$var$esc($66827b1304244a1d$var$dateWords(g.incomeOnlyRecord.date))}, ${name} confirmed: \u{201C}${$66827b1304244a1d$var$esc(g.incomeOnlyRecord.words)}\u{201D}</p></div>` : `<div class="callout" style="border:1px solid #cfd6e0;border-left:4px solid #d97706;background:#fff"><p class="small" style="margin:0">No confirmation for ${$66827b1304244a1d$var$money(g.amount)} is on file. Nothing from it comes back to ${name} or the family, even if ${name} passes away soon after buying it; ${name} must confirm this before going ahead.</p></div>`;
    return `<p class="lede">We recommend ${name} puts ${$66827b1304244a1d$var$money(g.amount)} into ${$66827b1304244a1d$var$esc($66827b1304244a1d$export$da84ab8401ac1a2b(g.kind, g.personName))}.${income}</p>
${table}
${altLine}
${assumptions}
${answers}
${record}`;
}


/**
 * strategyHorizonFlags.ts — the horizon rule, applied to the plans this module actually builds.
 *
 * The RULE lives in shared/src/calculation/strategyHorizon.ts and knows only a person and a need.
 * This file knows the plans: which engine candidate carries an annuity and with what residual, which
 * one sells the home to buy a smaller one, who owns the annuity, and who would live in the new home.
 * Every surface — the engine's cards and leader picking, Manual Control, the advice document — reads
 * its warning from here, so none of them can describe the same plan differently (owner, 23 Sep 2026).
 *
 * It moves no figure. It reads a plan and returns words, or null.
 */ /**
 * strategyHorizon.ts — does this strategy have the time it needs?
 *
 * WHY THIS EXISTS (owner, 23 Sep 2026). The fact-find asked for a health status, told the client it
 * was "used only to model care costs and government support", and used it for neither: no calculation
 * read it. Meanwhile the Suggestion Engine ranked every candidate over the same five years with the
 * same confidence for an 89-year-old as for a 70-year-old, so a nil-residual lifetime annuity — a bet
 * that pays off only if the client lives many years — could be crowned "best cashflow" for the very
 * old, precisely because the provider prices mortality in and pays them a high rate.
 *
 * WHAT IT IS. One rule, read by every surface (the engine's cards and its leader picking, Manual
 * Control's warnings, the advice document), so no screen can say something different:
 *
 *   1. The client's AGE sets a base horizon band from the life expectancy table already used to price
 *      annuities — long (more than HORIZON_LONG_YEARS), medium, or short (under HORIZON_MEDIUM_YEARS).
 *   2. A self-reported POOR health answer moves the band one step shorter. Good, fair and blank leave
 *      it alone: fair is too coarse a judgement to act on, and blank must never become a silent
 *      assumption either way.
 *   3. Each strategy declares the horizon it NEEDS. Where it needs more than the band supports, a
 *      warning is produced in plain words.
 *
 * WHAT IT IS NOT. It moves no figure: nothing here touches a projection, a ranking metric or a fee.
 * It is a suitability judgement layered on top of the arithmetic, and it never puts a life expectancy
 * on a screen — the bands are the only thing that leaves this file.
 *
 * WHOSE HORIZON. The annuity's owner (a joint annuity uses the joint expectancy); for a home sold to
 * buy a smaller one, the partner who would live in it, since in this module the client is in care.
 * Those choices are made by the callers, which know the plan; this file only knows a person.
 */ 
const $e36b043daf0f5d8d$export$2b14a4d58860ede1 = 10;
const $e36b043daf0f5d8d$export$8630ac6b69063096 = 5;
const $e36b043daf0f5d8d$export$1e4262e3bd21208e = 0.5;
const $e36b043daf0f5d8d$var$ORDER = {
    short: 0,
    medium: 1,
    long: 2
};
const $e36b043daf0f5d8d$var$normaliseHealth = (status)=>{
    const s = String(status ?? '').trim().toLowerCase();
    return s === 'good' || s === 'fair' || s === 'poor' ? s : null;
};
function $e36b043daf0f5d8d$export$75bed2c30d9e3342(years) {
    if (years > $e36b043daf0f5d8d$export$2b14a4d58860ede1) return 'long';
    if (years >= $e36b043daf0f5d8d$export$8630ac6b69063096) return 'medium';
    return 'short';
}
function $e36b043daf0f5d8d$export$e8183a25a2796188(input) {
    const age = typeof input.age === 'number' && Number.isFinite(input.age) ? input.age : null;
    if (age == null) return null;
    const joint = typeof input.partnerAge === 'number' && Number.isFinite(input.partnerAge);
    const years = (0, $f7f7b62814c3b615$export$b263bc911c6d9872)({
        age: age,
        partnerAge: joint ? input.partnerAge : null,
        type: joint ? 'joint' : 'single',
        sex: (0, $f7f7b62814c3b615$export$97c58f575ae57007)(input.sex),
        partnerSex: (0, $f7f7b62814c3b615$export$97c58f575ae57007)(input.partnerSex)
    });
    const base = $e36b043daf0f5d8d$export$75bed2c30d9e3342(years);
    if ($e36b043daf0f5d8d$var$normaliseHealth(input.healthStatus) !== 'poor') return base;
    return base === 'long' ? 'medium' : 'short';
}
function $e36b043daf0f5d8d$export$b862e219e9627722(residualCapital) {
    const share = typeof residualCapital === 'number' ? residualCapital : parseFloat(String(residualCapital ?? '0'));
    const r = Number.isFinite(share) ? share : 0;
    return r >= $e36b043daf0f5d8d$export$1e4262e3bd21208e ? 'medium' : 'long';
}
function $e36b043daf0f5d8d$export$e685c607f8cc4816(input) {
    return input.buysNewHome ? 'medium' : 'none';
}
function $e36b043daf0f5d8d$export$46b7f70746e9c9f9(need, band) {
    if (need === 'none' || band == null) return false;
    return $e36b043daf0f5d8d$var$ORDER[band] < $e36b043daf0f5d8d$var$ORDER[need === 'long' ? 'long' : 'medium'];
}
function $e36b043daf0f5d8d$export$5ad40908eb554bf5(input) {
    if (!$e36b043daf0f5d8d$export$46b7f70746e9c9f9(input.need, input.band)) return null;
    const needs = input.need === 'long' ? 'many years' : 'several years';
    const basis = input.healthConsidered ? `${input.personName}'s age and recorded health` : `${input.personName}'s age`;
    if (input.shape === 'capital_guaranteed') return `${$e36b043daf0f5d8d$var$capitalise(input.strategyLabel)} pays the full amount back on death, so a short stay loses little. Its pension and fee savings build over ${needs}, though, and ${basis} point to a shorter time frame, so there is little for ${input.personName} to gain from it.`;
    return `${$e36b043daf0f5d8d$var$capitalise(input.strategyLabel)} usually needs ${needs} to pay for itself. ${basis} point to a shorter time frame, so it may not suit ${input.personName}.`;
}
const $e36b043daf0f5d8d$var$capitalise = (s)=>s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
function $e36b043daf0f5d8d$export$ed3ccff4f05a72c7(input) {
    const age = typeof input.age === 'number' && Number.isFinite(input.age) ? input.age : null;
    if (age == null) return null;
    const joint = typeof input.partnerAge === 'number' && Number.isFinite(input.partnerAge);
    const years = (0, $f7f7b62814c3b615$export$b263bc911c6d9872)({
        age: age,
        partnerAge: joint ? input.partnerAge : null,
        type: joint ? 'joint' : 'single',
        sex: (0, $f7f7b62814c3b615$export$97c58f575ae57007)(input.sex),
        partnerSex: (0, $f7f7b62814c3b615$export$97c58f575ae57007)(input.partnerSex)
    });
    if ($e36b043daf0f5d8d$var$normaliseHealth(input.healthStatus) !== 'poor') return Math.round(years);
    const band = $e36b043daf0f5d8d$export$75bed2c30d9e3342(years);
    const capped = band === 'long' ? Math.min(years, $e36b043daf0f5d8d$export$2b14a4d58860ede1) : band === 'medium' ? Math.min(years, $e36b043daf0f5d8d$export$8630ac6b69063096) : years;
    return Math.round(capped);
}



const $3d096644ffaac9d7$var$health = (p)=>String(p?.healthStatus ?? '').trim().toLowerCase();
function $3d096644ffaac9d7$export$5d20a1bac737ae13(factFind) {
    const clientAge = (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client?.dob);
    const partnerAge = factFind.adviceFor === 'couple' ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner?.dob) : null;
    const clientName = (factFind.client?.firstName || '').trim() || 'the client';
    const partnerName = (factFind.partner?.firstName || '').trim() || 'the partner';
    const client = {
        name: clientName,
        band: (0, $e36b043daf0f5d8d$export$e8183a25a2796188)({
            age: clientAge,
            healthStatus: factFind.client?.healthStatus,
            sex: factFind.client?.sex
        }),
        healthConsidered: $3d096644ffaac9d7$var$health(factFind.client) === 'poor'
    };
    const partner = partnerAge == null ? null : {
        name: partnerName,
        band: (0, $e36b043daf0f5d8d$export$e8183a25a2796188)({
            age: partnerAge,
            healthStatus: factFind.partner?.healthStatus,
            sex: factFind.partner?.sex
        }),
        healthConsidered: $3d096644ffaac9d7$var$health(factFind.partner) === 'poor'
    };
    // A joint annuity is planned on the joint expectancy; a "poor" answer from either shortens it.
    const joint = partnerAge == null || clientAge == null ? null : {
        name: `${clientName} and ${partnerName}`,
        band: (0, $e36b043daf0f5d8d$export$e8183a25a2796188)({
            age: clientAge,
            partnerAge: partnerAge,
            sex: factFind.client?.sex,
            partnerSex: factFind.partner?.sex,
            healthStatus: $3d096644ffaac9d7$var$health(factFind.client) === 'poor' || $3d096644ffaac9d7$var$health(factFind.partner) === 'poor' ? 'poor' : undefined
        }),
        healthConsidered: $3d096644ffaac9d7$var$health(factFind.client) === 'poor' || $3d096644ffaac9d7$var$health(factFind.partner) === 'poor'
    };
    return {
        client: client,
        partner: partner,
        joint: joint
    };
}
const $3d096644ffaac9d7$var$annuityLabel = (residualCapital, guaranteed, indexed = false)=>guaranteed ? 'a lifetime annuity with the full amount guaranteed' : (0, $e36b043daf0f5d8d$export$b862e219e9627722)(residualCapital) === 'long' ? indexed ? 'a lifetime annuity rising with inflation' : 'a lifetime annuity with nil residual' : 'a lifetime annuity with capital returned';
function $3d096644ffaac9d7$export$2a10947020c112ea(input) {
    const horizons = $3d096644ffaac9d7$export$5d20a1bac737ae13(input.factFind);
    const owner = input.owner === 'partner' || input.owner === 'joint' ? input.owner : 'client';
    const who = owner === 'joint' ? horizons.joint ?? horizons.client : owner === 'partner' ? horizons.partner ?? horizons.client : horizons.client;
    const need = (0, $e36b043daf0f5d8d$export$b862e219e9627722)(input.residualCapital);
    // The guaranteed shape (annuity plus life policy) returns the whole price on death; its warning
    // is about what there is to gain, not whether it suits (9 Oct 2026).
    const guaranteed = input.annuityType === 'guaranteed';
    const warning = (0, $e36b043daf0f5d8d$export$5ad40908eb554bf5)({
        need: need,
        band: who.band,
        personName: who.name,
        strategyLabel: $3d096644ffaac9d7$var$annuityLabel(input.residualCapital, guaranteed, input.indexation === true),
        healthConsidered: who.healthConsidered,
        ...guaranteed ? {
            shape: 'capital_guaranteed'
        } : {}
    });
    return warning ? {
        warning: warning,
        need: need,
        person: owner,
        strategy: 'annuity',
        blocksLead: !guaranteed
    } : null;
}
function $3d096644ffaac9d7$export$39ef93267b18d7d1(input) {
    if (!input.sellsHome) return null;
    const buysNewHome = (typeof input.newHomePrice === 'number' ? input.newHomePrice : parseFloat(String(input.newHomePrice ?? '0'))) > 0;
    const need = (0, $e36b043daf0f5d8d$export$e685c607f8cc4816)({
        buysNewHome: buysNewHome
    });
    if (need === 'none') return null;
    const horizons = $3d096644ffaac9d7$export$5d20a1bac737ae13(input.factFind);
    const who = input.factFind.adviceFor === 'couple' && horizons.partner ? horizons.partner : horizons.client;
    const person = who === horizons.partner ? 'partner' : 'client';
    const warning = (0, $e36b043daf0f5d8d$export$5ad40908eb554bf5)({
        need: need,
        band: who.band,
        personName: who.name,
        strategyLabel: 'selling the home to buy a smaller one',
        healthConsidered: who.healthConsidered
    });
    return warning ? {
        warning: warning,
        need: need,
        person: person,
        strategy: 'downsize',
        blocksLead: true
    } : null;
}
const $3d096644ffaac9d7$var$rec = (v)=>v && typeof v === 'object' ? v : null;
function $3d096644ffaac9d7$export$5b0dcd5df12d72f4(strategy, factFind) {
    const flags = [];
    const lever = $3d096644ffaac9d7$var$rec(strategy.meansTestStrategy);
    if (lever && lever.type === 'annuity' && (Number(lever.purchaseAmount) || 0) > 0) {
        const f = $3d096644ffaac9d7$export$2a10947020c112ea({
            factFind: factFind,
            residualCapital: lever.residualCapital,
            owner: lever.ownership,
            annuityType: lever.annuityType,
            indexation: lever.indexation
        });
        if (f) flags.push(f);
    }
    const opts = $3d096644ffaac9d7$var$rec(strategy.strategyOptions);
    if (opts?.downsizeHome) {
        const details = $3d096644ffaac9d7$var$rec(opts.downsizeDetails);
        const f = $3d096644ffaac9d7$export$39ef93267b18d7d1({
            factFind: factFind,
            sellsHome: true,
            newHomePrice: details?.newHomePurchasePrice
        });
        if (f) flags.push(f);
    }
    return flags;
}
function $3d096644ffaac9d7$export$97adbbb576405d0e(strategy, factFind) {
    return $3d096644ffaac9d7$export$5b0dcd5df12d72f4(strategy, factFind).some((f)=>f.blocksLead);
}
function $3d096644ffaac9d7$export$bcf3d26e8114b217(strategy, factFind) {
    return $3d096644ffaac9d7$export$5b0dcd5df12d72f4(strategy, factFind)[0]?.warning ?? null;
}


/**
 * WHAT COULD GO WRONG — the risks of each strategy, in plain words, from one place.
 *
 * WHY (owner, 2 Oct 2026). A card told the client what a plan does and what it produces, and said
 * nothing about what could go wrong, bar the time-horizon warning. For personal advice the risks of
 * the recommendation are part of what the client is told, so they belong on the screen where the
 * choice is made AND in the Statement of Advice — and if those two are written separately they
 * drift. This file is the single list: the cards' "What could go wrong" panel and the documents
 * both read it.
 *
 * HOW IT IS SHAPED. A strategy is made of PARTS — selling the home, buying an annuity, paying a RAD,
 * renting the home out — and each part carries the same risks whichever module put it there. So the
 * list is keyed by part (`RiskKind`), each module says which parts its strategy has, and a few
 * CLIENT-SPECIFIC points (the age-and-health warning, an assumed cost base, a stamp duty figure)
 * are added on top. Every point is one bold claim and one sentence of why: the owner's rule for this
 * screen is that a wall of text is not read.
 *
 * Nothing here is recorded about whether the client opened it (owner's decision): the Statement of
 * Advice carries the same list, and that is the record.
 */ /*
 * THE SIX-YEAR RULE FOR A HOME KEPT AND RENTED OUT, said the same way on every card, in every "What could go wrong" and
 * so in every advice document (owner, 22 Oct 2026). ITAA 1997 s 118-145: a former home can stay the main residence for
 * up to six years while it earns rent, if no other home is treated as the main residence; after that, part of the gain
 * is taxable when it is sold (B.CGT.5).
 */ const $203e38d6e6c434f4$export$f1550df8cb0908cd = 'Free of it for up to six years while rented, if no other home is the main residence; after that, part of any gain is taxed on sale.';
const $203e38d6e6c434f4$export$b96695c1a4aaa70d = 'Capital gains tax: the home stays free of it for up to six years while it is rented out; after that, part of any gain can be taxed when it is sold.';
const $203e38d6e6c434f4$export$ada85937e998cb6f = {
    investmentProperty: {
        title: 'Buying an investment property',
        points: [
            {
                icon: 'lock',
                lead: "You can't sell part of it.",
                body: 'If you need money in a hurry, a property is slow and costly to turn into cash.'
            },
            {
                icon: 'receipt',
                lead: 'Buying costs come off the top.',
                body: 'Stamp duty and legal fees are paid on day one and only recovered if the property grows.'
            },
            {
                icon: 'home',
                lead: 'Rent can stop.',
                body: 'An empty property still costs rates, insurance and upkeep.'
            },
            {
                icon: 'landmark',
                lead: 'The rent counts.',
                body: "Centrelink counts the rent as income, and it's taxed."
            },
            {
                icon: 'trendDown',
                lead: 'Prices can fall as well as rise.',
                body: 'A property bought at the wrong time can be worth less than you paid for years.'
            }
        ]
    },
    shares: {
        title: 'Investing in shares or managed funds',
        points: [
            {
                icon: 'trendDown',
                lead: 'Values move, sometimes sharply.',
                body: 'A bad year can take a large amount off, and it may take years to come back.'
            },
            {
                icon: 'coins',
                lead: "Income isn't fixed.",
                body: 'Dividends and distributions can be cut without notice.'
            },
            {
                icon: 'landmark',
                lead: 'Centrelink deems the income.',
                body: 'A set rate is assumed on the balance whether or not it is actually earned.'
            },
            {
                icon: 'receipt',
                lead: 'Selling can mean tax.',
                body: 'Capital gains tax may apply when you sell.'
            }
        ]
    },
    investmentBond: {
        title: 'Buying an investment bond',
        points: [
            {
                icon: 'clock',
                lead: 'The tax benefit takes ten years.',
                body: 'Taking money out earlier can cost some of the tax advantage.'
            },
            {
                icon: 'trendDown',
                lead: "Returns aren't guaranteed.",
                body: 'The bond is invested, so its value can fall.'
            },
            {
                icon: 'percent',
                lead: 'Fees can be higher.',
                body: 'Bonds often cost more to run than a plain investment.'
            }
        ]
    },
    annuityNil: {
        title: 'A lifetime annuity that returns nothing on death',
        points: [
            {
                icon: 'lock',
                lead: 'The capital is gone.',
                body: "Once bought, the money isn't yours to take back, and nothing goes to your estate when you die."
            },
            {
                icon: 'heart',
                lead: 'It pays off only if you live long.',
                body: 'The income is guaranteed for life, so what you get back depends on how many years you receive it.'
            },
            {
                icon: 'percent',
                lead: 'The rate is set once.',
                body: "Your income is fixed when you buy and won't rise if markets or interest rates do."
            },
            {
                icon: 'fileSignature',
                lead: "The provider's quote is what counts.",
                body: 'The income shown here is an estimate; the real figure is whatever the insurer offers.'
            }
        ]
    },
    /*
     * INCOME ONLY, RISING WITH PRICES (guaranteed income review, 21 Oct 2026). It was tagged annuityNil, whose
     * point says "Your income is fixed" — the opposite of what this type does.
     */ annuityIndexed: {
        title: 'A lifetime annuity that rises with prices and returns nothing on death',
        points: [
            {
                icon: 'lock',
                lead: 'The capital is gone.',
                body: "Once bought, the money isn't yours to take back, and nothing goes to your estate when you die."
            },
            {
                icon: 'heart',
                lead: 'It pays off only if you live long.',
                body: 'The income is guaranteed for life, so what you get back depends on how many years you receive it.'
            },
            {
                icon: 'coins',
                lead: 'It starts lower.',
                body: 'The income rises with prices each year, so the first years pay less than a level income would; it takes years to catch up.'
            },
            {
                icon: 'fileSignature',
                lead: "The provider's quote is what counts.",
                body: 'The income shown here is an estimate; the real figure is whatever the insurer offers.'
            }
        ]
    },
    annuityReturned: {
        title: 'A lifetime annuity that returns capital',
        points: [
            {
                icon: 'clock',
                lead: 'Less comes back over time.',
                body: 'What you or your estate could get back winds down on a set schedule, year by year.'
            },
            {
                icon: 'coins',
                lead: 'The income is lower.',
                body: 'Protecting the capital means a smaller payment than an annuity that returns nothing.'
            },
            {
                icon: 'percent',
                lead: 'The rate is set once.',
                body: "Your income is fixed when you buy and won't rise if markets or interest rates do."
            },
            {
                icon: 'fileSignature',
                lead: "The provider's quote is what counts.",
                body: 'The income shown here is an estimate; the real figure is whatever the insurer offers.'
            }
        ]
    },
    annuityGuaranteed: {
        title: 'An annuity that returns the full amount on death',
        points: [
            {
                icon: 'shield',
                lead: 'Part of your money buys insurance.',
                body: 'Centrelink counts that part at what you paid, so the pension lift is smaller than it looks.'
            },
            {
                icon: 'coins',
                lead: 'The income is the lowest of the three shapes.',
                body: 'Guaranteeing the full amount back costs you income every year.'
            },
            {
                icon: 'fileSignature',
                lead: 'The split is an estimate.',
                body: 'How much is annuity and how much is insurance is set by the provider, not by us.'
            },
            {
                icon: 'users',
                lead: "Not everyone can buy it.",
                body: "It's sold only to people entering or receiving government-subsidised care."
            }
        ]
    },
    funeralBond: {
        title: 'Putting money in a funeral bond',
        points: [
            {
                icon: 'lock',
                lead: 'The money is for a funeral only.',
                body: "It can't be withdrawn for anything else, however your needs change."
            },
            {
                icon: 'landmark',
                lead: 'Only up to the limit is exempt.',
                body: 'Anything above the allowable amount still counts for the Age Pension.'
            },
            {
                icon: 'trendDown',
                lead: 'Returns are modest.',
                body: 'The money grows slowly, if at all, after fees.'
            }
        ]
    },
    gift: {
        title: 'Giving money away',
        points: [
            {
                icon: 'lock',
                lead: 'The money is gone.',
                body: "Once given, you can't count on getting it back, even from family."
            },
            {
                icon: 'landmark',
                lead: 'Only a small amount is exempt.',
                body: 'Gifts above $10,000 a year, or $30,000 over five years, still count for five years.'
            },
            {
                icon: 'users',
                lead: 'Family circumstances change.',
                body: 'A divorce, a debt or a death in the family can put a gift out of reach for good.'
            }
        ]
    },
    superContribution: {
        title: 'Putting money into super',
        points: [
            {
                icon: 'landmark',
                lead: 'The rules can change.',
                body: 'Government sets how super is taxed, when you can get at it and how much you can put in.'
            },
            {
                icon: 'trendDown',
                lead: "Returns aren't guaranteed.",
                body: 'Super is invested, so the balance can fall.'
            },
            {
                icon: 'calendar',
                lead: 'Limits and timing apply.',
                body: 'A downsizer contribution goes in within 90 days of the sale, once; after-tax contributions have yearly limits and stop at 75.'
            },
            {
                icon: 'coins',
                lead: 'It still counts for the pension.',
                body: 'Once you are over pension age, Centrelink counts your super.'
            }
        ]
    },
    accountBasedPension: {
        title: 'Starting an account-based pension',
        points: [
            {
                icon: 'percent',
                lead: 'Minimum payments apply.',
                body: "You must take at least a set percentage out each year, even if you'd rather leave it."
            },
            {
                icon: 'trendDown',
                lead: "Returns aren't guaranteed.",
                body: 'The balance is invested, so it can fall in a bad year.'
            },
            {
                icon: 'landmark',
                lead: 'Counted by Centrelink.',
                body: 'The balance is counted as an asset and income is deemed on it.'
            }
        ]
    },
    sellHome: {
        title: 'Selling the family home',
        points: [
            {
                icon: 'receipt',
                lead: 'Selling costs real money.',
                body: 'Agent fees, legal costs and the move itself come out of the sale price.'
            },
            {
                icon: 'landmark',
                lead: 'The money is no longer exempt.',
                body: 'A home is exempt from the Age Pension test; money from selling it that does not go into another home is counted, so the pension can fall.'
            },
            {
                icon: 'clock',
                lead: "Price and timing aren't certain.",
                body: 'The sale may take longer, or bring less, than the figure used here.'
            },
            {
                icon: 'repeat',
                lead: "It's hard to undo.",
                body: 'Getting back into the property market later usually costs more than you got out.'
            }
        ]
    },
    sellAndRent: {
        title: 'Renting instead of owning',
        points: [
            {
                icon: 'landmark',
                lead: 'The whole sale is counted.',
                body: 'With no home, every dollar of the proceeds is in the assets test and deemed to earn income.'
            },
            {
                icon: 'trendDown',
                lead: 'Rent rises for life.',
                body: 'The rent is paid every year from the money, and it goes up with the market.'
            },
            {
                icon: 'home',
                lead: 'A lease can end.',
                body: 'A landlord can sell or raise the rent; moving again costs money and is harder with age.'
            },
            {
                icon: 'coins',
                lead: 'Rent Assistance is capped.',
                body: 'It covers part of the rent, not all of it, and only while a pension is paid.'
            },
            {
                icon: 'clock',
                lead: 'No home growing in the background.',
                body: 'A home kept its value for the estate; the money now has to earn its keep.'
            }
        ]
    },
    rentHome: {
        title: 'Keeping the home and renting it out',
        points: [
            {
                icon: 'landmark',
                lead: 'The rent counts.',
                body: "Centrelink counts the rent as income, and it's taxed."
            },
            {
                icon: 'clock',
                lead: 'The home may be counted later.',
                body: 'Once you have been out of it for a time, the home itself can be counted as an asset.'
            },
            {
                icon: 'receipt',
                lead: 'Capital gains tax after six years away.',
                body: $203e38d6e6c434f4$export$f1550df8cb0908cd
            },
            {
                icon: 'home',
                lead: 'Tenants, gaps and repairs.',
                body: 'Rent can stop between tenants, and repairs and rates continue regardless.'
            },
            {
                icon: 'wrench',
                lead: "You're a landlord now.",
                body: 'Managing a property, or paying someone to, takes time or money.'
            }
        ]
    },
    /* After a move to a village or a granny flat the old home is no longer where you live, so it counts
       from the day you move — no two-year exemption, unlike a move into care (reviews, 18 Oct 2026: the
       panel said "may be counted later" beside an explanation saying it counts straight away). */ rentFormerHome: {
        title: 'Keeping the home and renting it out',
        points: [
            {
                icon: 'landmark',
                lead: 'The home and the rent both count.',
                body: "From the day you move, Centrelink counts the home as an asset and the rent as income, and the rent is taxed."
            },
            {
                icon: 'receipt',
                lead: 'Capital gains tax after six years away.',
                body: $203e38d6e6c434f4$export$f1550df8cb0908cd
            },
            {
                icon: 'home',
                lead: 'Tenants, gaps and repairs.',
                body: 'Rent can stop between tenants, and repairs and rates continue regardless.'
            },
            {
                icon: 'wrench',
                lead: "You're a landlord now.",
                body: 'Managing a property, or paying someone to, takes time or money.'
            }
        ]
    },
    keepHomeInCare: {
        title: 'Keeping the home while in care',
        points: [
            {
                icon: 'clock',
                lead: 'The exemption runs out.',
                body: "The home is exempt from the Age Pension test for two years after you enter care, unless a partner or protected person still lives there."
            },
            {
                icon: 'home',
                lead: 'An empty home still costs.',
                body: 'Rates, insurance, upkeep and security continue while nobody lives there.'
            },
            {
                icon: 'trendDown',
                lead: 'Its value can fall.',
                body: 'A home left empty for years can lose value and condition.'
            }
        ]
    },
    sellInvestmentProperty: {
        title: 'Selling an investment property',
        points: [
            {
                icon: 'receipt',
                lead: 'Capital gains tax.',
                body: 'Tax on the gain comes out of what you have to spend.'
            },
            {
                icon: 'coins',
                lead: 'The rent stops.',
                body: 'Income you had been living on is replaced by whatever the money earns next.'
            },
            {
                icon: 'clock',
                lead: 'Price and timing are not certain.',
                body: 'The sale may take longer, or bring less, than the figure used here.'
            }
        ]
    },
    transferHome: {
        title: 'Transferring the home to family',
        points: [
            {
                icon: 'lock',
                lead: 'You give up ownership.',
                body: 'The home is theirs; your right to live in it depends on them, and on your agreement.'
            },
            {
                icon: 'landmark',
                lead: 'Only what is given on top is tested.',
                body: "The home's value is taken as the price of the right, so the home itself is not a gift; cash or assets given as well can be, for five years."
            },
            {
                icon: 'users',
                lead: 'Exposed to their life.',
                body: 'Their divorce, debts or death can put the home out of your reach.'
            },
            // Owner's review, 24 Oct 2026: the transfer's costs and conditions were not said.
            {
                icon: 'receipt',
                lead: 'Stamp duty and tax.',
                body: 'Stamp duty may be payable, usually by the family, and is not in these figures; the home is free of capital gains tax for you.'
            },
            {
                icon: 'clock',
                lead: 'Leaving early can undo it.',
                body: 'If the arrangement ends within five years, Centrelink can look at the transfer again as a gift.'
            },
            {
                icon: 'home',
                lead: 'A home worth less than the homeowner line.',
                body: 'Then you are not homeowners for the Age Pension, and the right counts as an asset.'
            }
        ]
    },
    radPaid: {
        title: 'Paying the room price (RAD)',
        points: [
            {
                icon: 'lock',
                lead: 'A large sum is tied up.',
                body: "The money is refunded when you leave or die, but you can't use it in the meantime."
            },
            {
                icon: 'landmark',
                lead: 'Exempt for the pension, counted for care fees.',
                body: 'The RAD is not counted for the Age Pension, but it is counted in the means-tested care fee.'
            },
            {
                icon: 'clock',
                lead: 'The refund takes time.',
                body: 'Your estate receives it within 14 days of probate, under a government guarantee.'
            }
        ]
    },
    dap: {
        title: 'Paying for the room daily (DAP)',
        points: [
            {
                icon: 'percent',
                lead: 'It costs interest.',
                body: 'The daily payment is interest on the unpaid room price, at a rate set by government.'
            },
            {
                icon: 'repeat',
                lead: 'It never ends.',
                body: 'You pay it for as long as you stay, and nothing is building up to be refunded.'
            },
            {
                icon: 'coins',
                lead: 'It has to come from cashflow.',
                body: 'If income falls short, the payment is drawn from savings or added to the debt.'
            }
        ]
    },
    reverseMortgage: {
        title: 'A reverse mortgage',
        points: [
            {
                icon: 'trendDown',
                lead: 'The debt grows.',
                body: 'Interest is added to the loan, so what you owe rises every year even with no repayments.'
            },
            {
                icon: 'home',
                lead: 'Less left for the family.',
                body: 'The loan and all its interest are repaid from the home when it is sold.'
            },
            {
                icon: 'percent',
                lead: 'Rates can rise.',
                body: 'A higher rate means the debt grows faster.'
            },
            {
                icon: 'fileSignature',
                lead: 'Conditions apply.',
                body: 'The lender can require upkeep and insurance, and moving out can trigger repayment.'
            }
        ]
    },
    heas: {
        title: 'The Home Equity Access Scheme',
        points: [
            {
                icon: 'trendDown',
                lead: 'The debt grows.',
                body: 'Interest compounds at the government rate, so what you owe rises every year.'
            },
            {
                icon: 'home',
                lead: 'Repaid from the home.',
                body: 'The loan and its interest come out of the home when it is sold, or from your estate.'
            },
            {
                icon: 'coins',
                lead: 'Payments are capped.',
                body: 'You can draw up to 150% of the full pension, counting any pension you already receive.'
            }
        ]
    },
    clearDebt: {
        title: 'Paying off debt',
        points: [
            {
                icon: 'coins',
                lead: 'Less in reserve.',
                body: "Money used to clear a debt isn't there for an emergency."
            },
            {
                icon: 'repeat',
                lead: 'You may not get it back.',
                body: 'Once repaid, a loan may not be available to draw on again.'
            }
        ]
    },
    fromSavings: {
        title: 'Paying from savings',
        points: [
            {
                icon: 'coins',
                lead: 'Less in reserve.',
                body: 'A smaller buffer means less room for a surprise cost or a bad year.'
            },
            {
                icon: 'receipt',
                lead: 'Selling investments can mean tax.',
                body: 'Shares sold to raise the money may trigger capital gains tax.'
            }
        ]
    },
    villageEntry: {
        title: 'Moving into a retirement village',
        points: [
            {
                icon: 'fileSignature',
                lead: "You're buying a contract, not a home.",
                body: 'Leaving costs real money, through the departure fee.'
            },
            {
                icon: 'clock',
                lead: 'Your exit money waits for a re-sale.',
                body: 'You or your estate may wait months, sometimes years, for the refund.'
            },
            {
                icon: 'coins',
                lead: 'Fees continue.',
                body: 'Ongoing fees are payable, and in some states for a time after you leave.'
            },
            {
                icon: 'repeat',
                lead: 'A later move into care means moving twice.',
                body: 'Each move has its own costs and its own wait for money to come back.'
            }
        ]
    },
    grannyFlat: {
        title: 'A granny flat arrangement',
        points: [
            {
                icon: 'users',
                lead: "You're relying on family.",
                body: 'Your right to live there depends on the relationship holding.'
            },
            {
                icon: 'fileSignature',
                lead: 'Get it in writing.',
                body: 'Without a written agreement you have little protection if things change.'
            },
            {
                icon: 'landmark',
                lead: 'Paying too much counts as a gift.',
                body: 'Centrelink can treat anything above a reasonable value as a gift for five years.'
            },
            {
                icon: 'home',
                lead: 'The money becomes theirs.',
                body: 'What you pay joins their assets, exposed to their divorce, debts or death.'
            }
        ]
    },
    // A build paid for at the family member's home (owner's review, 24 Oct 2026: a build got the cash warning
    // "paying too much counts as a gift", which a build on its own can never do).
    grannyFlatBuild: {
        title: 'Paying for a build at their home',
        points: [
            {
                icon: 'users',
                lead: "You're relying on family.",
                body: 'Your right to live there depends on the relationship holding.'
            },
            {
                icon: 'fileSignature',
                lead: 'Get it in writing.',
                body: 'Without a written agreement you have little protection if things change.'
            },
            {
                icon: 'receipt',
                lead: 'Builds run over.',
                body: "Approvals, delays and over-runs are common; keep the contract and invoices, as anything paid beyond the build\u2019s cost is tested."
            },
            {
                icon: 'home',
                lead: 'The building belongs to the family member.',
                body: "It becomes part of the host\u2019s property, exposed to their divorce, debts or death; what is bought is the right to live there."
            }
        ]
    },
    keepHomeEmpty: {
        title: 'Keeping the home, empty',
        points: [
            {
                icon: 'landmark',
                lead: 'It is counted from the day you move.',
                body: 'With no one living in it, the home is counted in full for the Age Pension, and it earns nothing.'
            },
            {
                icon: 'receipt',
                lead: 'It still costs money.',
                body: 'Rates, insurance and upkeep go on, and an empty home can need a vacancy policy; these costs are not in the figures unless entered.'
            }
        ]
    },
    // Moving in with family and paying nothing (gf-move-in-only): no granny flat right, but real risks all the
    // same (live review, 22 Oct 2026: the plan showed "These are the 0 that matter").
    moveInOnly: {
        title: 'Moving in without paying for a right',
        points: [
            {
                icon: 'fileSignature',
                lead: 'No right to stay.',
                body: 'Nothing is paid and nothing is signed, so you have no legal right to live there if things change.'
            },
            {
                icon: 'users',
                lead: "You're relying on family.",
                body: 'Where you live depends on the relationship, and on their own plans for their home.'
            },
            {
                icon: 'home',
                lead: 'The empty home still costs money.',
                body: 'Rates, insurance and upkeep go on, and an empty home can need a vacancy policy; it is counted for the Age Pension from the day you move.'
            }
        ]
    },
    renovate: {
        title: 'Spending on the home',
        points: [
            {
                icon: 'receipt',
                lead: 'Costs can run over.',
                body: 'Building work rarely comes in at the first quote.'
            },
            {
                icon: 'lock',
                lead: 'The money is tied up in the home.',
                body: "It isn't there to spend, and you only get it back by selling."
            },
            {
                icon: 'trendDown',
                lead: 'You may not get it all back.',
                body: 'Not every dollar spent on a home adds a dollar to its value.'
            }
        ]
    },
    stayPut: {
        title: 'Changing nothing',
        points: [
            {
                icon: 'trendDown',
                lead: 'Costs keep rising.',
                body: 'Fees, rates and living costs go up each year whether or not your income does.'
            },
            {
                icon: 'clock',
                lead: 'A move may be forced later.',
                body: 'If care is needed, the decision may have to be made quickly and at a worse time.'
            },
            {
                icon: 'alert',
                lead: 'Nothing improves.',
                body: 'The pension, cashflow and estate stay where they are today.'
            }
        ]
    }
};
const $203e38d6e6c434f4$var$money = (n)=>`$${Math.round(n).toLocaleString('en-AU')}`;
function $203e38d6e6c434f4$export$124603ee0434ece5(kinds, specifics = {}) {
    const forYou = [];
    const fam = specifics.familyToKeepWhole;
    if (fam && fam.childrenCount > 1 && fam.amount > 0) forYou.push({
        icon: 'users',
        lead: `One of your ${fam.childrenCount} children receives ${fam.what === 'home' ? 'the home' : $203e38d6e6c434f4$var$money(fam.amount)}; ${fam.childrenCount === 2 ? 'the other does not' : 'the others do not'}.`,
        body: `${fam.what === 'home' ? `The ${$203e38d6e6c434f4$var$money(fam.amount)} home` : 'What you pay'} goes to one family now and comes out of what the rest inherit later. Decide how to keep it fair \u{2014} the Will, an advance on their inheritance, or insurance \u{2014} and write it down; the family discussion guide covers it.`
    });
    if (specifics.horizonWarning) forYou.push({
        icon: 'heart',
        lead: 'Time may be against this plan.',
        body: specifics.horizonWarning
    });
    if (specifics.savingsRunOutYear != null) forYou.push({
        icon: 'coins',
        lead: `Savings run out in year ${specifics.savingsRunOutYear}.`,
        body: 'After that, the shortfall each year has to come from somewhere else.'
    });
    if (specifics.stampDuty != null && specifics.stampDuty > 0) forYou.push({
        icon: 'receipt',
        lead: `${$203e38d6e6c434f4$var$money(specifics.stampDuty)} of stamp duty is paid on day one.`,
        body: 'It comes out of the sale proceeds and is only recovered if the property grows by at least that much.'
    });
    if (specifics.cgtAssumed) forYou.push({
        icon: 'receipt',
        lead: 'The tax figure is an assumption.',
        body: "You didn't enter what an asset cost you, so we assumed 25% of its value, which usually overstates the tax."
    });
    const seen = new Set();
    const sections = kinds.filter((k)=>seen.has(k) ? false : (seen.add(k), true)).map((kind)=>({
            kind: kind,
            title: $203e38d6e6c434f4$export$ada85937e998cb6f[kind].title,
            points: $203e38d6e6c434f4$export$ada85937e998cb6f[kind].points
        }));
    return {
        forYou: forYou,
        sections: sections
    };
}
function $203e38d6e6c434f4$export$9551dad796149f3f(risks) {
    return [
        ...risks.forYou.map((p)=>`${p.lead} ${p.body}`),
        ...risks.sections.flatMap((s)=>s.points.map((p)=>`${s.title} \u{2014} ${p.lead} ${p.body}`))
    ];
}
function $203e38d6e6c434f4$export$c301be208b2d16d(id) {
    const kinds = [];
    const has = (re)=>re.test(id);
    const bare = id.replace(/-clear-debt$/, '');
    if (/^rv-/.test(bare) && bare !== 'rv-stay-home') kinds.push('villageEntry');
    // A hand-built sale is 'gf-sell' with no suffix (24 Oct 2026): it gets the selling risks too.
    if (/^gf-/.test(bare) && !/^gf-(stay-put|sell(-|$)|move-in-only)/.test(bare)) kinds.push('grannyFlat');
    if (/^gf-sell(-|$)/.test(bare)) kinds.push('grannyFlat');
    if (/^gf-move-in-only/.test(bare)) kinds.push('moveInOnly');
    if (/^(rv-stay-home|dz-stay-put|gf-stay-put|cp-nothing)$/.test(bare)) return [
        'stayPut'
    ];
    if (has(/sell-home|^dz-(rent-)?(price|simple|super|invest|annuity|funeral|gift|your-plan)|^gf-sell(-|$)/)) kinds.push('sellHome');
    // Downsizer candidates that sell and RENT (2 Oct 2026): a renting household, said as its own part.
    if (has(/^dz-rent-/)) kinds.push('sellAndRent');
    if (has(/^rv-sell-ip|sell-ip/)) kinds.push('sellInvestmentProperty');
    if (has(/^gf-transfer-home/)) kinds.push('transferHome');
    if (has(/liquid-rent|keep-rent/)) kinds.push('rentFormerHome');
    if (has(/^rv-liquid|^gf-(fair-cash|known)/)) kinds.push('fromSavings');
    if (has(/-abp-ip$|-property$|invest-property/)) kinds.push('investmentProperty');
    if (has(/-abp-invest$|-invest$|^dz-invest$|liquid-shares|-shares$/)) kinds.push('shares');
    if (has(/invest-bond|super-and-bond|-bond$/) && !has(/funeral/)) kinds.push('investmentBond');
    if (has(/downsizer|super-after-tax|super-max|^dz-super|sell-super|-super$|-super-and|-super-(abp|invest|annuity)/)) kinds.push('superContribution');
    if (has(/-abp/)) kinds.push('accountBasedPension');
    if (has(/annuity-guaranteed/)) kinds.push('annuityGuaranteed');
    else if (has(/annuity-rcv/)) kinds.push('annuityReturned');
    else if (has(/annuity/)) kinds.push('annuityNil');
    if (has(/funeral-bond|bond-and-gift/)) kinds.push('funeralBond');
    if (has(/-gift$|bond-and-gift/)) kinds.push('gift');
    if (/-clear-debt$/.test(id)) kinds.push('clearDebt');
    return kinds;
}
function $203e38d6e6c434f4$export$bac9d5a868c209ac(id, m) {
    let kinds = $203e38d6e6c434f4$export$c301be208b2d16d(id);
    if ((m.construction || 0) > 0) {
        const cashOnTop = (m.amountPaid || 0) > 0;
        kinds = kinds.flatMap((k)=>k === 'grannyFlat' ? cashOnTop ? [
                'grannyFlatBuild',
                'grannyFlat'
            ] : [
                'grannyFlatBuild'
            ] : [
                k
            ]);
        if (!kinds.includes('grannyFlatBuild')) kinds.unshift('grannyFlatBuild');
    }
    if (m.home === 'kept' && !kinds.includes('keepHomeEmpty') && !kinds.includes('moveInOnly')) kinds.push('keepHomeEmpty');
    return kinds;
}
function $203e38d6e6c434f4$export$e1aeab26ad581b54(type, name = '') {
    const n = name.toLowerCase();
    switch(type){
        case 'doNothing':
            return [
                'stayPut'
            ];
        case 'gifting':
            return [
                'gift'
            ];
        case 'funeralBonds':
            return [
                'funeralBond'
            ];
        case 'annuity':
            return [
                n.includes('guaranteed') ? 'annuityGuaranteed' : n.includes('capital returned') ? 'annuityReturned' : 'annuityNil'
            ];
        case 'increaseHomeEquity':
        case 'renovate':
        case 'upgrade':
            return [
                'renovate'
            ];
        case 'downsize':
            {
                const kinds = [
                    'sellHome'
                ];
                if (n.includes('downsizer')) kinds.push('superContribution');
                if (n.includes('abp')) kinds.push('accountBasedPension');
                if (n.includes('repay')) kinds.push('clearDebt');
                return kinds;
            }
        case 'reverseMortgage':
            return [
                'reverseMortgage'
            ];
        case 'heas':
            return [
                'heas'
            ];
        case 'debtRepayment':
            return [
                'clearDebt'
            ];
        case 'combination':
            {
                const kinds = [];
                if (n.includes('gift')) kinds.push('gift');
                if (n.includes('funeral')) kinds.push('funeralBond');
                if (n.includes('annuity')) kinds.push(n.includes('guaranteed') ? 'annuityGuaranteed' : n.includes('capital returned') ? 'annuityReturned' : 'annuityNil');
                if (n.includes('downsize')) kinds.push('sellHome');
                if (n.includes('reverse mortgage')) kinds.push('reverseMortgage');
                if (n.includes('heas')) kinds.push('heas');
                return kinds;
            }
        default:
            return [];
    }
}
function $203e38d6e6c434f4$export$ebadbd3592b8b5e6(strategy) {
    const name = String(strategy.name || '');
    const kinds = [];
    const pct = /(\d+)% RAD/.exec(name);
    const radPct = pct ? Number(pct[1]) : 0;
    if (radPct > 0) kinds.push('radPaid');
    if (radPct < 100) kinds.push('dap');
    if (strategy.strategyOptions?.downsizeHome || /Downsize/i.test(name)) kinds.push('sellHome');
    else if (strategy.strategyOptions?.rentHome || /Rent Home/i.test(name)) kinds.push('rentHome');
    else if (/Keep Home/i.test(name) || name === 'Do Nothing') kinds.push('keepHomeInCare');
    if (strategy.strategyOptions?.sellInvestmentProperty || /Sell .*(Keep|Rent) Home/.test(name)) kinds.push('sellInvestmentProperty');
    if (/max downsizer|downsizer ABP/i.test(name)) kinds.push('superContribution');
    if (/downsizer ABP/i.test(name)) kinds.push('accountBasedPension');
    const mt = strategy.meansTestStrategy?.type;
    if (mt === 'annuity' || /annuity/i.test(name)) {
        const indexed = /rising with inflation/i.test(name) || strategy.meansTestStrategy?.indexation === true;
        kinds.push(/full amount guaranteed/i.test(name) ? 'annuityGuaranteed' : /capital returned/i.test(name) ? 'annuityReturned' : indexed ? 'annuityIndexed' : 'annuityNil');
    }
    if (mt === 'funeralBonds' || /funeral bond/i.test(name)) kinds.push('funeralBond');
    if (mt === 'gifting' || /gift/i.test(name)) kinds.push('gift');
    const er = strategy.equityRelease?.kind;
    if (er === 'heas' || /Home Equity Access Scheme/i.test(name)) kinds.push('heas');
    else if (er || /Reverse mortgage/i.test(name)) kinds.push('reverseMortgage');
    if (strategy.strategyOptions?.debtPayoff || /Clear Debt|Pay Down Debt/i.test(name)) kinds.push('clearDebt');
    if (radPct > 0 && /\(.*->.*\)/.test(name)) kinds.push('fromSavings');
    return kinds;
}


/**
 * THE ASSUMPTIONS, IN ONE PLACE (3 Oct 2026). These sections were the Assumptions page's own array;
 * they now live here so the page and every Statement of Advice appendix read the SAME list — the
 * aged care document had been carrying its own hand-typed tax brackets (the 2023-24 set, 19% and
 * 32.5%) under "Rates & thresholds used" while the engine applied 2026-27's. One source, no drift.
 *
 * Everything here is display text built from the constants the engine actually applies. Nothing is
 * computed; the page and the documents render it.
 */ /**
 * THE SUGGESTED FIGURES FOR AN INVESTMENT PROPERTY BOUGHT IN A PLAN (village rebuild, owner 21 Oct 2026).
 *
 * One source for the engine's tested plans and the "Build a plan yourself" set-up, so the card and the
 * set-up can never start from different figures:
 *   - rent: the firm's rental yield on the price (3.5% unless the firm sets its own);
 *   - two weeks a year without a tenant, when the rent stops and the costs go on;
 *   - the agent's management fee, 8% of the rent collected;
 *   - repairs and upkeep, 1% of the value a year.
 * Council rates, insurance, land tax and strata are the client's to enter — land tax turns on the land
 * value, the state's threshold and other land held, so no figure is guessed. Each is "suggested" on
 * screen until it is changed.
 */ 
const $6ee1c1106c00a64d$export$faaf7ad57b31d035 = 2;
const $6ee1c1106c00a64d$export$a7e68df0b44e69a1 = 8;
const $6ee1c1106c00a64d$export$aa7b942bbfbd31d3 = 1;
const $6ee1c1106c00a64d$export$ccb8ef6339a33b59 = `two weeks a year without a tenant, the agent's ${$6ee1c1106c00a64d$export$a7e68df0b44e69a1}% of the rent and ${$6ee1c1106c00a64d$export$aa7b942bbfbd31d3}% of the value a year for upkeep (rates, insurance and land tax only where entered)`;
function $6ee1c1106c00a64d$export$ad80a9624457bb5e(price, over = {}) {
    const p = Math.max(0, Number(price) || 0);
    const yieldPct = over.yieldPct ?? (0, $0f2c0a6799fe36da$export$b037eefb915b86ec).propertyYieldPct;
    const grossRent = over.weeklyRent != null ? Math.max(0, over.weeklyRent) * 52 : p * (yieldPct / 100);
    const vacancyWeeks = Math.min(52, Math.max(0, over.vacancyWeeks ?? $6ee1c1106c00a64d$export$faaf7ad57b31d035));
    const rent = grossRent * (52 - vacancyWeeks) / 52;
    const agentFee = rent * ((over.agentFeePct ?? $6ee1c1106c00a64d$export$a7e68df0b44e69a1) / 100);
    const upkeep = over.upkeep != null ? Math.max(0, over.upkeep) : p * ($6ee1c1106c00a64d$export$aa7b942bbfbd31d3 / 100);
    const otherCosts = Math.max(0, over.otherCosts ?? 0);
    const r = (x)=>Math.round(x);
    return {
        grossRent: r(grossRent),
        vacancyWeeks: vacancyWeeks,
        rent: r(rent),
        agentFee: r(agentFee),
        upkeep: r(upkeep),
        otherCosts: r(otherCosts),
        expenses: r(agentFee + upkeep + otherCosts)
    };
}




/**
 * WHICH PLAN LEADS, AND WHEN A SECOND PLAN IS SHOWN — one rule for every module (owner, 20 Oct 2026:
 * a "close second" leaving $5,000 more for $771 less outlay "isn't a real choice"; revised the same
 * day: "Leaves the most" must sit on the plan that leaves the most).
 *
 *  1. THE PLAN THAT LEAVES THE MOST LEADS, and its card says so.
 *  2. ONE EXCEPTION — A NEAR-TIE WITH A STEP THAT CANNOT BE UNDONE. Where the top plan takes an
 *     irreversible step (an annuity, a gift, a funeral bond, selling or transferring the home) and a
 *     plan within the larger of $10,000 or 0.5% of its estate does not, that plan leads instead, and
 *     its card says what it is: "About the most, without …".
 *  3. A SECOND CARD ONLY FOR A REAL TRADE-OFF. Another plan is shown beside the lead only when it is
 *     close enough to weigh (its estate within the larger of $50,000 or 2% of the lead's) AND clearly
 *     better on something that is not the estate: at least 20% or $50,000 less money tied up (whichever
 *     is larger), or at least $1,000 a year more to spare, or it avoids an irreversible step the lead
 *     takes. Its line says what it gives up and what it gains.
 *  4. Every plan tested stays one click away ("All the ways tested"), so nothing is hidden.
 *
 * Money tied up is read from the client's side: money no longer within reach for anything else — a
 * refundable deposit counts in full (owner, 20 Oct 2026).
 *
 * Each module supplies the four readings below for its own rows; the figures live here only.
 */ 
const $5a094123650e8adb$export$e806853ba07a113 = {
    tieMinUsd: 10000,
    tieShare: 0.005,
    considerMinUsd: 50000,
    considerShare: 0.02,
    outlayMinUsd: 50000,
    outlayShare: 0.2,
    cashflowMinUsd: 1000
};
const $5a094123650e8adb$export$e0b3c22102f89ba7 = [
    'annuityNil',
    'annuityIndexed',
    'annuityReturned',
    'annuityGuaranteed',
    'gift',
    'funeralBond',
    'sellHome',
    'sellAndRent',
    'transferHome'
];
const $5a094123650e8adb$var$STEP_WORDS = {
    annuityNil: 'locking money into an annuity',
    annuityIndexed: 'locking money into an annuity',
    annuityReturned: 'locking money into an annuity',
    annuityGuaranteed: 'locking money into an annuity',
    gift: 'giving money away',
    funeralBond: 'a funeral bond',
    sellHome: 'selling the home',
    sellAndRent: 'selling the home',
    transferHome: 'transferring the home'
};
const $5a094123650e8adb$var$irreversibleOf = (s, r)=>r.kinds(s).filter((k)=>$5a094123650e8adb$export$e0b3c22102f89ba7.includes(k));
const $5a094123650e8adb$var$stepWords = (k)=>k && $5a094123650e8adb$var$STEP_WORDS[k] || 'a step that cannot be undone';
function $5a094123650e8adb$export$d9c7424da920d33a(bestEstate) {
    return Math.max($5a094123650e8adb$export$e806853ba07a113.tieMinUsd, Math.abs(bestEstate) * $5a094123650e8adb$export$e806853ba07a113.tieShare);
}
const $5a094123650e8adb$var$topOf = (pool, r)=>pool.reduce((top, s)=>r.estate(s) > r.estate(top) ? s : top, pool[0]);
function $5a094123650e8adb$export$3ef36734776b870(pool, r) {
    if (pool.length === 0) return null;
    const best = $5a094123650e8adb$var$topOf(pool, r);
    if ($5a094123650e8adb$var$irreversibleOf(best, r).length === 0) return best;
    const band = $5a094123650e8adb$export$d9c7424da920d33a(r.estate(best));
    const clean = pool.filter((s)=>r.estate(best) - r.estate(s) <= band && $5a094123650e8adb$var$irreversibleOf(s, r).length === 0);
    return clean.length ? $5a094123650e8adb$var$topOf(clean, r) : best;
}
function $5a094123650e8adb$export$db12984b57d6f833(pool, lead, r) {
    if (!lead || pool.length === 0) return null;
    const best = $5a094123650e8adb$var$topOf(pool, r);
    const gap = r.estate(best) - r.estate(lead);
    if (!(gap >= 1)) return null;
    const avoided = $5a094123650e8adb$var$irreversibleOf(best, r).filter((k)=>!$5a094123650e8adb$var$irreversibleOf(lead, r).includes(k));
    return {
        gap: gap,
        avoids: $5a094123650e8adb$var$stepWords(avoided[0])
    };
}
const $5a094123650e8adb$export$484369b037887464 = 'Leaves the most';
function $5a094123650e8adb$export$a035dca5f387c63d(ex) {
    return ex ? `About the most, without ${ex.avoids}` : $5a094123650e8adb$export$484369b037887464;
}
function $5a094123650e8adb$export$27f705a6fa40271e(ex, formatCurrency) {
    return `Leaves ${formatCurrency(Math.round(ex.gap))} less than the plan that leaves the most, which involves ${ex.avoids}. The two are close enough to call level, so the plan without a step that cannot be undone comes first.`;
}
function $5a094123650e8adb$export$e6d5d668ed646c9b(lead, other, r) {
    const saving = r.moved(lead) - r.moved(other);
    if (saving >= Math.max($5a094123650e8adb$export$e806853ba07a113.outlayMinUsd, r.moved(lead) * $5a094123650e8adb$export$e806853ba07a113.outlayShare)) return {
        kind: 'moved',
        saving: saving
    };
    const gain = r.cashflow(other) - r.cashflow(lead);
    if (gain >= $5a094123650e8adb$export$e806853ba07a113.cashflowMinUsd) return {
        kind: 'cashflow',
        gain: gain
    };
    const avoided = $5a094123650e8adb$var$irreversibleOf(lead, r).filter((k)=>!$5a094123650e8adb$var$irreversibleOf(other, r).includes(k));
    if (avoided.length > 0) return {
        kind: 'reversible',
        avoids: $5a094123650e8adb$var$stepWords(avoided[0])
    };
    return null;
}
function $5a094123650e8adb$export$ab51b61210e311f4(pool, lead, r, sameAs) {
    if (!lead) return null;
    const leadEstate = r.estate(lead);
    const reach = Math.max($5a094123650e8adb$export$e806853ba07a113.considerMinUsd, Math.abs(leadEstate) * $5a094123650e8adb$export$e806853ba07a113.considerShare);
    const options = pool.filter((s)=>!sameAs(s, lead) && leadEstate - r.estate(s) <= reach).map((s)=>({
            s: s,
            t: $5a094123650e8adb$export$e6d5d668ed646c9b(lead, s, r)
        })).filter((x)=>x.t != null).sort((a, b)=>r.estate(b.s) - r.estate(a.s) || r.moved(a.s) - r.moved(b.s));
    const pick = options[0];
    if (!pick) return null;
    const takes = $5a094123650e8adb$var$irreversibleOf(pick.s, r).filter((k)=>!$5a094123650e8adb$var$irreversibleOf(lead, r).includes(k));
    return {
        strategy: pick.s,
        tradeOff: pick.t,
        estateGap: leadEstate - r.estate(pick.s),
        cash: r.cashflow(pick.s),
        leadCash: r.cashflow(lead),
        takes: takes.length ? $5a094123650e8adb$var$stepWords(takes[0]) : null
    };
}
function $5a094123650e8adb$export$a104569a4d958475(second, formatCurrency) {
    const f = (v)=>formatCurrency(Math.round(Math.abs(v)));
    const costs = [];
    const gains = [];
    const t = second.tradeOff;
    const d = second.cash - second.leadCash;
    /*
     * PLAIN WORDS, AGAINST A NAMED PLAN (owner, 23 Oct 2026: "Leaves $1,288 less and is $1,631 a year further short"
     * was confusing): what it is measured against comes first, and "short" is said as money needed from savings.
     */ if (second.estateGap >= 1) costs.push(`leaves ${f(second.estateGap)} less to the family`);
    else if (second.estateGap <= -1) gains.push(`leaves ${f(second.estateGap)} more to the family`);
    if (d <= -1) costs.push(second.cash < 0 ? `needs ${f(d)} a year more from savings` : `has ${f(d)} a year less to spare`);
    if (second.takes) costs.push(`involves ${second.takes}, which cannot be undone`);
    if (t.kind === 'moved') gains.push(`keeps ${f(t.saving)} more within reach (not tied up)`);
    if (d >= 1) gains.push(second.cash < 0 ? `needs ${f(d)} a year less from savings` : `has ${f(d)} a year more to spare`);
    if (t.kind === 'reversible') gains.push(`avoids ${t.avoids}, which cannot be undone`);
    if (!costs.length) return `Against the other plan shown, it ${gains.join(' and ')}.`;
    return `Against the other plan shown, it ${costs.join(' and ')}, but ${gains.join(' and ')}.`;
}
const $5a094123650e8adb$export$a1a7ae9e29edd48c = 'Nearly the most, a real trade-off you should consider';
function $5a094123650e8adb$export$8d9f0aa086032e89(second) {
    return second.estateGap <= -1 ? 'Leaves the most, with a step that cannot be undone' : $5a094123650e8adb$export$a1a7ae9e29edd48c;
}
function $5a094123650e8adb$export$af182f21f972ef03(count) {
    return `We show the plans that lead each goal, and a second only when it offers a real trade-off. All ${count.toLocaleString()} plans tested are yours to open and compare.`;
}
const $5a094123650e8adb$var$usd = (v)=>`$${v.toLocaleString('en-AU')}`;
const $5a094123650e8adb$var$pctOf = (v)=>`${+(v * 100).toFixed(1)}%`;
const $5a094123650e8adb$export$fb0a335889dd79d0 = [
    {
        label: 'A near-tie is a tie',
        value: `Within ${$5a094123650e8adb$var$usd($5a094123650e8adb$export$e806853ba07a113.tieMinUsd)} or ${$5a094123650e8adb$var$pctOf($5a094123650e8adb$export$e806853ba07a113.tieShare)}, whichever is larger`,
        text: `Two plans whose estates are within ${$5a094123650e8adb$var$usd($5a094123650e8adb$export$e806853ba07a113.tieMinUsd)} or ${$5a094123650e8adb$var$pctOf($5a094123650e8adb$export$e806853ba07a113.tieShare)} of the estate (whichever is larger) are treated as level: the projection cannot honestly tell them apart. A tie matters only where one of them takes a step that cannot be undone.`
    },
    {
        label: 'The plan that leaves the most leads',
        value: 'Unless it takes a step that cannot be undone',
        text: 'The first card is the plan that leaves the most to the family. The one exception: where that plan takes a step that cannot be undone (an annuity, a gift, a funeral bond, selling or transferring the home) and a plan level with it does not, the plan without it comes first, and its card says so.'
    },
    {
        label: 'A second plan only for a real trade-off',
        value: `Within ${$5a094123650e8adb$var$usd($5a094123650e8adb$export$e806853ba07a113.considerMinUsd)} or ${$5a094123650e8adb$var$pctOf($5a094123650e8adb$export$e806853ba07a113.considerShare)}, and clearly better on something else`,
        text: `Beside the plan that leaves the most, a second is shown only when its estate is within ${$5a094123650e8adb$var$usd($5a094123650e8adb$export$e806853ba07a113.considerMinUsd)} or ${$5a094123650e8adb$var$pctOf($5a094123650e8adb$export$e806853ba07a113.considerShare)} (whichever is larger) and it is clearly better on something else: at least ${$5a094123650e8adb$var$pctOf($5a094123650e8adb$export$e806853ba07a113.outlayShare)} or ${$5a094123650e8adb$var$usd($5a094123650e8adb$export$e806853ba07a113.outlayMinUsd)} less money tied up (whichever is larger; money tied up is money no longer within reach, a refundable deposit included), at least ${$5a094123650e8adb$var$usd($5a094123650e8adb$export$e806853ba07a113.cashflowMinUsd)} a year more to spare, or it avoids a step that cannot be undone. Its card says what it gives up and what it gains, in one line.`
    },
    {
        label: 'Every plan is yours to open',
        value: 'All plans tested, or build your own',
        text: 'The cards are a shortlist, not the only options. Every plan tested can be opened and compared under "All the ways tested", and you can build a plan yourself with your own figures.'
    }
];
/* ─── Reading "money moved" from a candidate's inputs (village, downsizer, granny flat, cashflow) ─── */ const $5a094123650e8adb$var$n = (v)=>{
    const x = parseFloat(String(v ?? ''));
    return Number.isFinite(x) && x > 0 ? x : 0;
};
function $5a094123650e8adb$export$dcb95cff3b1c1798(row) {
    const r = row || {};
    const inputs = r.inputs || r.config || r;
    const sh = inputs.sellHomeDetails || {};
    const dep = inputs.deployment || {};
    const sources = Array.isArray(inputs.fundingSources) ? inputs.fundingSources : [];
    const fromSources = sources.reduce((t, s)=>t + $5a094123650e8adb$var$n(s.amountToTake), 0);
    const named = [
        sh.giftingAmount,
        sh.funeralBondPurchase,
        sh.purchaseAnnuity,
        sh.purchaseInvestmentProperty,
        sh.purchaseShares,
        sh.downsizerContribution,
        sh.partnerDownsizerContribution,
        inputs.giftingAmount,
        inputs.funeralBondPurchase,
        inputs.newHomePurchasePrice,
        inputs.downsizerContribution,
        inputs.partnerDownsizerContribution,
        inputs.amountPaid,
        inputs.propertyTransferredValue,
        inputs.constructionCost,
        dep.annuity,
        dep.shares,
        dep.investmentProperty,
        dep.superContribution,
        dep.partnerSuperContribution,
        dep.investmentBond
    ].reduce((t, v)=>t + $5a094123650e8adb$var$n(v), 0);
    return Math.max(fromSources, named);
}
const $5a094123650e8adb$export$448a1f2525c95b5b = {
    estate: (s)=>Number(s.snapshot?.legacyValue) || 0,
    moved: (s)=>$5a094123650e8adb$export$dcb95cff3b1c1798(s),
    cashflow: (s)=>Number(s.snapshot?.netCashflow ?? s.snapshot?.cashflow ?? s.snapshot?.cashFlow) || 0,
    kinds: (s)=>(0, $203e38d6e6c434f4$export$c301be208b2d16d)(String(s.id ?? ''))
};


// Support at Home Calculation Engine — cheap/reactive slice.
// Implements 1 November 2025 contribution rules.
// Ported verbatim from frontend/src/calculations/SupportAtHomeCalculations.js.
//
// Note: calculateSupportAtHomeContribution and calculateIndividualContributions (the actual
// means-test contribution engine) live in
// server/src/rest/calculation/supportAtHomeContributionEngine.ts — they're server-only
// (non-reactive, no shared caller), unlike the lifetime-cap helpers below which are cheap
// arithmetic used directly by the frontend.

const $c424aab2467b2598$export$c5fbc76332b2670f = {
    standard: 140652.80,
    nwop: 88934.57
};
// Deeming thresholds (from Age Pension)
// Schedule of contributions for Support at Home services, 1 July 2026 (thresholds index 1 July).
const $c424aab2467b2598$var$DEEMING_THRESHOLDS = {
    single: 66800,
    couplePension: 110600,
    coupleNoPension: 55300
};
const $c424aab2467b2598$var$DEEMING_RATES = {
    lower: (0, $1abe73eeef086faf$export$7ccf16e55e6cf86b),
    upper: (0, $1abe73eeef086faf$export$fe9b80c24d06bb6b)
};
const $c424aab2467b2598$export$8138b127b5e9116c = (annualContribution, yearsOfCare)=>{
    return annualContribution * Math.min(yearsOfCare, 100); // Cap at 100 years as safety
};
const $c424aab2467b2598$export$15092489f5114a7c = (cumulativeContributions, participantType = 'standard')=>{
    const cap = participantType === 'nwop' ? $c424aab2467b2598$export$c5fbc76332b2670f.nwop : $c424aab2467b2598$export$c5fbc76332b2670f.standard;
    return cumulativeContributions >= cap;
};
const $c424aab2467b2598$export$7fb415e878d63867 = (annualContribution, currentCumulative = 0, participantType = 'standard')=>{
    if (annualContribution <= 0) return null;
    const cap = participantType === 'nwop' ? $c424aab2467b2598$export$c5fbc76332b2670f.nwop : $c424aab2467b2598$export$c5fbc76332b2670f.standard;
    const remainingCap = cap - currentCumulative;
    if (remainingCap <= 0) return 0;
    if (annualContribution >= cap) return Math.ceil(remainingCap / annualContribution);
    return Math.ceil(remainingCap / annualContribution);
};



// Aged care display values derived from schedule
const $13910bc1e93fb74e$var$MPIR = (0, $815d7df20c36742b$export$36c4ec5f3f340aef).MPIR;
const $13910bc1e93fb74e$var$RAD_RETENTION_RATE = 0.02;
const $13910bc1e93fb74e$var$BASIC_DAILY_FEE_RATE = (0, $815d7df20c36742b$export$36c4ec5f3f340aef).basicDailyFeeRate;
const $13910bc1e93fb74e$var$AGED_CARE_HOME_EXEMPTION_CAP = (0, $815d7df20c36742b$export$36c4ec5f3f340aef).homeExemptionCap;
const $13910bc1e93fb74e$var$HSC_DAILY_CAP = (0, $815d7df20c36742b$export$36c4ec5f3f340aef).maxHotellingDaily;
const $13910bc1e93fb74e$var$NCCC_DAILY_CAP = (0, $815d7df20c36742b$export$36c4ec5f3f340aef).maxNCCCDaily;
const $13910bc1e93fb74e$var$NCCC_LIFETIME_CAP = (0, $815d7df20c36742b$export$36c4ec5f3f340aef).ncccLifetimeCap;
// Medicare levy surcharge tiers, written out from the same table the tax estimate applies.
const $13910bc1e93fb74e$var$pct = (rate)=>`${(rate * 100).toFixed(2).replace(/\.?0+$/, '')}%`;
const $13910bc1e93fb74e$var$MLS_TIERS = (0, $1abe73eeef086faf$export$3f2efd37e8996007).tiers;
const $13910bc1e93fb74e$var$MLS_SINGLES = $13910bc1e93fb74e$var$MLS_TIERS.slice(1).map((t, i)=>`${$13910bc1e93fb74e$var$pct(t.rate)} over ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)($13910bc1e93fb74e$var$MLS_TIERS[i].singleUpTo)}`).join('; ');
const $13910bc1e93fb74e$var$MLS_FAMILIES = $13910bc1e93fb74e$var$MLS_TIERS.slice(1).map((t, i)=>`${$13910bc1e93fb74e$var$pct(t.rate)} over ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)($13910bc1e93fb74e$var$MLS_TIERS[i].familyUpTo)}`).join('; ');
// Asset & market assumptions (display only; used in projections elsewhere)
const $13910bc1e93fb74e$var$DEFAULT_CASH_GROWTH_RATE_PCT = 0;
const $13910bc1e93fb74e$var$DEFAULT_HOME_GROWTH_RATE = '5';
function $13910bc1e93fb74e$export$8d1b1c5d08b3c488() {
    const assumptionSections = [
        {
            title: `Aged Care Assumptions (Schedule fees as at ${(0, $815d7df20c36742b$export$36c4ec5f3f340aef).effectiveDate}; MPIR quarter ${(0, $815d7df20c36742b$export$36c4ec5f3f340aef).mpiQuarterLabel || 'see schedule'})`,
            items: [
                {
                    label: "Maximum Permissible Interest Rate (MPIR)",
                    value: `${($13910bc1e93fb74e$var$MPIR * 100).toFixed(2)}%`,
                    note: `Department of Health quarterly rate (${(0, $815d7df20c36742b$export$36c4ec5f3f340aef).mpiQuarterLabel || 'update mpiQuarterLabel in agedCareSchedule.js'})`
                },
                {
                    label: "RAD Retention Rate (p.a.)",
                    value: `${$13910bc1e93fb74e$var$RAD_RETENTION_RATE * 100}% (capped at 5 years)`,
                    note: "Applies to new entrants"
                },
                {
                    label: "Basic Daily Fee Rate",
                    value: `${$13910bc1e93fb74e$var$BASIC_DAILY_FEE_RATE * 100}% of single age pension`,
                    note: "Indexed Mar & Sep"
                },
                {
                    label: "Income free area (single)",
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $815d7df20c36742b$export$36c4ec5f3f340aef).incomeFreeAreaSingle),
                    note: "Tiered MTA; indexed Mar & Sep"
                },
                {
                    label: "First income threshold (single)",
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $815d7df20c36742b$export$36c4ec5f3f340aef).firstIncomeThresholdSingle),
                    note: "Indexed Mar & Sep"
                },
                {
                    label: "Asset free area",
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $815d7df20c36742b$export$36c4ec5f3f340aef).assetFreeArea),
                    note: "Tiered MTA; indexed Mar & Sep"
                },
                {
                    label: "First asset threshold",
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $815d7df20c36742b$export$36c4ec5f3f340aef).firstAssetThreshold),
                    note: "Indexed Mar & Sep"
                },
                {
                    label: "HSC Daily Cap (max hotelling)",
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($13910bc1e93fb74e$var$HSC_DAILY_CAP),
                    note: "Indexed Mar & Sep"
                },
                {
                    label: "NCCC Daily Cap",
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($13910bc1e93fb74e$var$NCCC_DAILY_CAP),
                    note: "Indexed Mar & Sep"
                },
                {
                    label: "NCCC Lifetime Cap",
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($13910bc1e93fb74e$var$NCCC_LIFETIME_CAP),
                    note: "Indexed Mar & Sep (Schedule of Fees and Charges)"
                },
                {
                    label: "Home Exemption Cap",
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($13910bc1e93fb74e$var$AGED_CARE_HOME_EXEMPTION_CAP),
                    note: "Capped when no protected person in home; indexed Mar & Sep"
                },
                {
                    label: "1 July 2014 arrangements (no worse off): income free area (single)",
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $815d7df20c36742b$export$36c4ec5f3f340aef).arrangements2014.incomeFreeAreaSingle),
                    note: "Means-tested care fee \u2014 residents on a Home Care Package at 12 Sep 2024; income-tested amount 50% above this"
                },
                {
                    label: "1 July 2014 arrangements: asset thresholds",
                    value: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $815d7df20c36742b$export$36c4ec5f3f340aef).arrangements2014.assetFreeArea)} / ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $815d7df20c36742b$export$36c4ec5f3f340aef).arrangements2014.firstAssetThreshold)} / ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $815d7df20c36742b$export$36c4ec5f3f340aef).arrangements2014.secondAssetThreshold)}`,
                    note: "17.5% / 1% / 2% of the slices above each; indexed Mar & Sep"
                },
                {
                    label: "1 July 2014 arrangements: means-tested care fee daily maximum",
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $815d7df20c36742b$export$36c4ec5f3f340aef).arrangements2014.maxMeansTestedCareFeeDaily),
                    note: `Schedule of Fees and Charges, ${(0, $815d7df20c36742b$export$36c4ec5f3f340aef).effectiveDate}`
                },
                {
                    label: "1 July 2014 arrangements: annual / lifetime caps",
                    value: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $815d7df20c36742b$export$36c4ec5f3f340aef).arrangements2014.mtcfAnnualCap)} / ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $815d7df20c36742b$export$36c4ec5f3f340aef).arrangements2014.mtcfLifetimeCap)}`,
                    note: "Lifetime cap shared with Home Care Package fees and Support at Home contributions; indexed Mar & Sep"
                }
            ]
        },
        {
            title: `Support at Home Assumptions (Schedule of contributions from ${(0, $1abe73eeef086faf$export$946308c675ba021d).supportAtHomeSchedule})`,
            items: [
                {
                    label: "Contribution rates by service category",
                    value: "Clinical 0%; independence 5\u201350%; everyday living 17.5\u201380%",
                    note: "Full pensioners pay the minimum, self-funded retirees the maximum; part pensioners slide on the higher of an income factor and an asset factor, on the Schedule's thresholds (the minimums are the Age Pension free areas and full-pension limits; the maximums move with the pension cut-offs each March and September)"
                },
                {
                    label: "'No worse off' rates (package held or approved at 12 Sep 2024)",
                    value: "0% / 0\u201325% on income only / 25%",
                    note: "Never more per fortnight than the income-tested care fee paid under the package"
                },
                {
                    label: "Lifetime caps \u2014 standard / no worse off",
                    value: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $c424aab2467b2598$export$c5fbc76332b2670f).standard)} / ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $c424aab2467b2598$export$c5fbc76332b2670f).nwop)}`,
                    note: "Shared with the residential NCCC and the 1 July 2014 means-tested care fee; indexed Mar & Sep"
                }
            ]
        },
        {
            title: `Social Security Assumptions (rates as at ${(0, $1abe73eeef086faf$export$946308c675ba021d).agePension}; limits and free areas from ${(0, $1abe73eeef086faf$export$946308c675ba021d).assetAndIncomeTests})`,
            items: [
                {
                    label: "Pension Age",
                    value: `${(0, $1abe73eeef086faf$export$5b6998cba7880742)} years`
                },
                {
                    label: "Single Pension Rate (p.a.)",
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single),
                    note: "Indexed Mar & Sep"
                },
                {
                    label: "Couple combined max \u2014 living together (p.a.)",
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).couple),
                    note: "Indexed Mar & Sep"
                },
                {
                    label: "Couple combined max \u2014 illness-separated (p.a.)",
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single * 2),
                    note: "Combined maximum when each member is paid up to the singles maximum (2 \xd7 single rate)\u2014higher than the standard couple combined rate; asset and income tests differ (below). Indexed Mar & Sep."
                },
                {
                    label: "Asset test \u2014 homeowner (single)",
                    value: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).single.homeowner.full)} \u{2192} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).single.homeowner.cutoff)}`,
                    note: "Lower limit (full pension) \u2192 cut-off"
                },
                {
                    label: "Asset test \u2014 homeowner (couple living together)",
                    value: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).couple.homeowner.full)} \u{2192} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).couple.homeowner.cutoff)}`,
                    note: "Combined assets; lower limit \u2192 cut-off"
                },
                {
                    label: "Asset test \u2014 homeowner (illness-separated couple)",
                    value: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).coupleIllnessSeparated.homeowner.full)} \u{2192} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).coupleIllnessSeparated.homeowner.cutoff)}`,
                    note: "Combined assets; higher cut-off than standard couples"
                },
                {
                    label: "Asset test \u2014 non-homeowner (single)",
                    value: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).single.nonHomeowner.full)} \u{2192} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).single.nonHomeowner.cutoff)}`,
                    note: "Lower limit \u2192 cut-off"
                },
                {
                    label: "Asset test \u2014 non-homeowner (couple living together)",
                    value: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).couple.nonHomeowner.full)} \u{2192} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).couple.nonHomeowner.cutoff)}`,
                    note: "Combined assets"
                },
                {
                    label: "Asset test \u2014 non-homeowner (illness-separated couple)",
                    value: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).coupleIllnessSeparated.nonHomeowner.full)} \u{2192} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9a84fd450010fb2e).coupleIllnessSeparated.nonHomeowner.cutoff)}`,
                    note: "Combined assets; higher cut-off than standard couples"
                },
                {
                    label: "Income test \u2014 free area (single)",
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$704950d172afcdf8).single),
                    note: "Annualised free area before taper"
                },
                {
                    label: "Income test \u2014 free area (couple combined)",
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$704950d172afcdf8).couple),
                    note: "Combined couple free area before taper"
                },
                {
                    label: "Income test \u2014 cut-off (single)",
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$bad1f8cb9d172d1b).single),
                    note: "Approximate pension nil rate cut-off (annualised)"
                },
                {
                    label: "Income test \u2014 cut-off (couple living together)",
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$bad1f8cb9d172d1b).couple),
                    note: "Combined cut-off"
                },
                {
                    label: "Income test \u2014 cut-off (illness-separated couple)",
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$bad1f8cb9d172d1b).coupleIllnessSeparated),
                    note: "Higher combined cut-off than standard couples"
                },
                {
                    label: "Income test taper",
                    value: "View Details",
                    details: "Single: 50\xa2 reduction per $1 of ordinary income over the free area. Couple (including illness-separated where couple rules apply): 25\xa2 per $1 of combined ordinary income over the couple free area for each partner. Confirm treatment for your circumstances with Services Australia."
                },
                {
                    label: "Deeming Rates & Thresholds",
                    value: "View Details",
                    details: `Lower Rate: ${+((0, $1abe73eeef086faf$export$7ccf16e55e6cf86b) * 100).toFixed(4)}% on first ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$63f1528eb9e21fc5).single)} (single) / ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$63f1528eb9e21fc5).couple)} (couple pensioner). Upper Rate: ${+((0, $1abe73eeef086faf$export$fe9b80c24d06bb6b) * 100).toFixed(4)}% on balance.`
                },
                {
                    label: "Projection indexation (Age Pension)",
                    value: `${(0, $1abe73eeef086faf$export$e51ae1118d375fce)}% p.a.`,
                    note: "Year 1 uses current rates/thresholds above. Year 2+ assumes rates and thresholds rise by the projection inflation rate. Actual government indexation may differ."
                }
            ]
        },
        {
            title: `Tax Assumptions (${(0, $1abe73eeef086faf$export$345389c3d55d014a)} Financial Year)`,
            items: [
                ...(0, $1abe73eeef086faf$export$b8352069eaf11cd3).map((b, i)=>({
                        label: `Tax Bracket ${i + 1}`,
                        value: i === 0 ? `0% up to ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(b.limit)}` : `${b.rate * 100}% over ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$b8352069eaf11cd3)[i - 1].limit)}`
                    })),
                {
                    label: "Medicare Levy Rate",
                    value: `${+((0, $1abe73eeef086faf$export$ff4b97dcd3d2d7f1) * 100).toFixed(4)}%`,
                    note: `Low-income thresholds (${(0, $1abe73eeef086faf$export$946308c675ba021d).medicareLowIncomeThresholds}): single ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$ae133c7b255163d3).single.lower)}\u{2013}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$ae133c7b255163d3).single.upper)}; seniors and pensioners ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$ae133c7b255163d3).singleSenior.lower)}\u{2013}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$ae133c7b255163d3).singleSenior.upper)}; family ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$ae133c7b255163d3).couple.lower)}\u{2013}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$ae133c7b255163d3).couple.upper)} (seniors ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$ae133c7b255163d3).coupleSenior.lower)}\u{2013}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$ae133c7b255163d3).coupleSenior.upper)}). Nil below the lower figure, 10% of the excess up to the upper figure, 2% above it. Private hospital cover does not change the levy.`
                },
                {
                    label: "Medicare Levy Surcharge (MLS)",
                    value: `Singles: ${$13910bc1e93fb74e$var$MLS_SINGLES}`,
                    note: `Charged only to a person without private hospital cover, on income for surcharge purposes (${(0, $1abe73eeef086faf$export$946308c675ba021d).medicareLevySurcharge} tiers). Families: ${$13910bc1e93fb74e$var$MLS_FAMILIES}; each family tier rises ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$3f2efd37e8996007).perExtraChild)} per dependent child after the first. An unanswered private-cover question is treated as no cover \u{2014} the cautious reading. Where the profile does not say whether a person holds private hospital cover, the model assumes they do not, which is the conservative direction \u{2014} answer the question on step 2 of the client profile to remove the assumption.`
                },
                {
                    label: "Low Income Tax Offset (LITO)",
                    value: `Max ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$c3b5f1f009bc99af).maxOffset)}`,
                    note: `Non-refundable; phases out across income bands up to ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$c3b5f1f009bc99af).cutOut)}. Still on ATO ${(0, $1abe73eeef086faf$export$946308c675ba021d).lito} parameters \u{2014} the new year's figures are published with the Budget. Applied after SAPTO in estimates.`
                },
                {
                    label: "SAPTO (Seniors & Pensioners Tax Offset)",
                    value: `Single max ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$e66d40af5bf25f2b).single.maxOffset)}; couple member ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$e66d40af5bf25f2b).coupleMember.maxOffset)}; illness-separated member ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$e66d40af5bf25f2b).illnessSeparatedMember.maxOffset)}`,
                    note: `Shade-in / cut-out thresholds are in the calculation engine, still on ATO ${(0, $1abe73eeef086faf$export$946308c675ba021d).sapto} parameters \u{2014} the new year's figures are published with the Budget. Rebate income is approximated from taxable income\u{2014}not a full rebate-income worksheet.`
                },
                {
                    label: "Company Tax Rate",
                    value: `${+((0, $1abe73eeef086faf$export$641e54d6b906f309) * 100).toFixed(4)}%`,
                    note: "Base rate entities may be 25%"
                },
                {
                    label: "Projection indexation (Tax thresholds)",
                    value: `${(0, $1abe73eeef086faf$export$e51ae1118d375fce)}% p.a.`,
                    note: "Year 1 uses current thresholds above. Year 2+ assumes tax and Medicare thresholds rise by the projection inflation rate. Tax rates are assumed to stay at current settings unless legislation changes."
                },
                {
                    label: 'Included in income tax estimates',
                    value: 'View summary',
                    details: 'Resident marginal tax brackets (above). Medicare Levy with income thresholds and taper zones for singles and couples/families. Franking credits reduce gross tax. SAPTO (offsets listed above) for eligible pension-age individuals. LITO (details above) after SAPTO. Medicare levy surcharge for a person without private hospital cover whose income for surcharge purposes passes the tiers above; private hospital cover never reduces the 2% levy itself.'
                },
                {
                    label: 'Not included or simplified in tax estimates',
                    value: 'View summary',
                    details: "The uplift of the Medicare levy family threshold per dependent child (the levy is tested on the family figures above). HELP/HECS repayments, Division 293 tax, foreign income tax offsets, and most other offsets not listed above. Trusts and companies you register use your apportionment % for pension and care fee estimates. Automatic strategy suggestions exclude entity assets unless you opt in; the tool does not advise whether a trust deed or company constitution allows a sale or distribution. Capital gains tax appears when specific sales or strategy-driven disposals are modelled; it is not a complete annual CGT roll-forward for every asset. Where no cost base is recorded for a CGT asset (e.g. shares or investment property), a cost base of 25% of its current value is assumed (a conservative default) \u2014 enter the actual cost base to refine. For gains realised on or after 1 July 2027 the model applies the legislated CGT reform (indexation in place of the 50% discount, with the 30% minimum tax not applying to Age Pension / income-support recipients). SAPTO/LITO eligibility can differ from ATO worksheets\u2014confirm material outcomes with your accountant or tax agent."
                }
            ]
        },
        {
            title: "Asset & Market Assumptions",
            items: [
                {
                    label: "Projection inflation (CPI) assumption",
                    value: `${(0, $1abe73eeef086faf$export$e51ae1118d375fce)}% p.a.`,
                    note: "Applied to living expenses, home (rental) expenses and rent, partner rent, and aged care care fees (BDF, HSC, NCCC); DAP is not escalated. Future capital expenses are not indexed."
                },
                {
                    label: "Default cash account income rate",
                    value: `${(0, $0f2c0a6799fe36da$export$b037eefb915b86ec).bankIncomePct.toFixed(2)}% p.a.`
                },
                {
                    label: "Default cash account growth rate",
                    value: `${$13910bc1e93fb74e$var$DEFAULT_CASH_GROWTH_RATE_PCT}% p.a.`,
                    note: "Cash earns interest; it does not appreciate."
                },
                {
                    label: "Default term deposit interest rate",
                    value: `${(0, $0f2c0a6799fe36da$export$b037eefb915b86ec).termDepositIncomePct.toFixed(2)}% p.a.`
                },
                {
                    label: "Default Home Growth Rate",
                    value: `${$13910bc1e93fb74e$var$DEFAULT_HOME_GROWTH_RATE}% p.a.`
                },
                {
                    label: "Default Share Income Rate",
                    value: `${(0, $0f2c0a6799fe36da$export$b037eefb915b86ec).sharesIncomePct.toFixed(2)}% p.a.`
                },
                {
                    label: "Default Share Growth Rate",
                    value: `${(0, $0f2c0a6799fe36da$export$b037eefb915b86ec).sharesGrowthPct.toFixed(2)}% p.a.`
                },
                {
                    label: "Default Share Franking",
                    value: `${(0, $0f2c0a6799fe36da$export$b037eefb915b86ec).sharesFrankingPct}%`
                },
                {
                    label: "Investment property",
                    value: `${(0, $0f2c0a6799fe36da$export$b037eefb915b86ec).propertyYieldPct.toFixed(2)}% yield / ${(0, $0f2c0a6799fe36da$export$b037eefb915b86ec).propertyGrowthPct.toFixed(2)}% growth p.a.`,
                    note: `Gross rent as a percentage of value. A property bought in a plan allows for ${(0, $6ee1c1106c00a64d$export$ccb8ef6339a33b59)}; a property already held uses the expenses entered on the profile.`
                },
                {
                    label: "Super & pension records saved without a rate",
                    value: "Balanced presets",
                    note: "Legacy records with no rate use the Balanced figures from the table below (pensions 6.60%, super 6.00%) \u2014 new entries always carry an explicit rate."
                }
            ]
        },
        {
            title: (0, $0f2c0a6799fe36da$export$8bdfa8b8b11554d0)() ? `Superannuation & Pension Return Assumptions \u{2014} ${(0, $0f2c0a6799fe36da$export$8bdfa8b8b11554d0)()?.firmName || 'your firm'}'s capital market assumptions${(0, $0f2c0a6799fe36da$export$8bdfa8b8b11554d0)()?.effectiveDate ? `, effective ${(0, $0f2c0a6799fe36da$export$8bdfa8b8b11554d0)()?.effectiveDate}` : ''}` : "Superannuation & Pension Return Assumptions (by investment option)",
            items: [
                ...(0, $0f2c0a6799fe36da$export$56315028e4277c0c).map((id)=>{
                    const row = (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[id];
                    return {
                        label: `${row.label}${id === (0, $0f2c0a6799fe36da$export$f692c4a779b1d5f6) ? ' (default for new entries)' : ''}`,
                        value: `${row.accumulationNetPct.toFixed(2)}% / ${row.pensionNetPct.toFixed(2)}% p.a.`,
                        note: id === (0, $0f2c0a6799fe36da$export$56315028e4277c0c)[0] ? "Accumulation / pension phase, net of fund fees and taxes \u2014 the figure a member statement reports. Open View Details on any row for the underlying portfolio split." : undefined,
                        details: `Underlying portfolio for this option: ${row.personal.incomeRatePct.toFixed(1)}% income + ${row.personal.growthRatePct.toFixed(1)}% growth = ${row.pensionNetPct.toFixed(2)}% gross, with ${row.personal.frankingPct}% of the income franked. This split prices strategy investments held in personal names (income taxed yearly with franking credits; growth subject to CGT on sale) and drives the componentised super fund tax. The pension figure equals the gross because pension-phase earnings are tax-free; the accumulation preset is the typical published net return for this option.`
                    };
                }),
                {
                    label: "Why the two phases differ",
                    value: "View Details",
                    details: "Super and pension are wrappers around the same investments \u2014 the wrapper changes the tax on the earnings, never the earnings themselves. Each option is defined by its portfolio (income, growth, and how much of the income is franked); both figures above are worked out from it. Pension-phase earnings are tax-free, so the pension figure is simply income + growth. Super (accumulation) earnings are taxed inside the fund, modelled component by component \u2014 15% on income after refundable franking credits, 10% on growth \u2014 so a heavily franked portfolio's real drag is small, exactly as real funds experience. If you know your own fund's published return, enter it directly on the account instead (choose Custom)."
                },
                {
                    label: "Pension transfer balance cap",
                    value: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$807e93be6ec93c1b))} per person (lifetime)`,
                    details: "The government limits how much anyone can move into retirement-phase pensions over their lifetime. When a strategy would commence a pension, the tool checks the person's remaining cap and moves only that much into the pension \u2014 any excess goes to accumulation super instead, clearly labelled. Cap usage comes from the ATO 'transfer balance account' figure where recorded; otherwise it is estimated from current pension balances. That estimate can understate usage for someone who moved money into a pension years ago and has since drawn it down \u2014 enter the ATO figure to correct it. The tool asks for it only when pension balances are large enough for the cap to possibly matter."
                },
                {
                    label: "Strategy-modelled investments",
                    value: "Your choice (Conservative if not set)",
                    details: 'When a recommended strategy invests money for you \u2014 for example after selling a home \u2014 it uses the investment approach recorded in your profile ("If a strategy frees up money, how would it be invested?"). If you haven\'t answered, we assume Conservative, the most cautious option, and say so wherever it applies. Whatever the approach, the same portfolio is assumed everywhere it could be held, and only the tax changes: tax-free in a pension account, component-taxed inside super (15% on income net of franking credits, 10% on growth), and at your personal rates in your own name \u2014 so the comparison between the options is fair.'
                }
            ]
        },
        {
            /*
             * HOW THE PLANS ARE CHOSEN (owner, 20 Oct 2026: "include this in the assumptions and ensure
             * that the client is aware that they can access all the models themselves"). The same rule
             * in every module; the words are built from the figures the ranking uses (planChoiceRule.ts).
             */ title: 'How the Plans Are Chosen',
            items: (0, $5a094123650e8adb$export$fb0a335889dd79d0).map((r)=>({
                    label: r.label,
                    value: r.value,
                    details: r.text
                }))
        }
    ];
    return assumptionSections;
}


/**
 * THE SHARED PIECES OF EVERY STATEMENT OF ADVICE (3 Oct 2026) — the aged care, Support at Home and
 * module documents are three HTML builders that had drifted: pastel infills the owner called
 * "old" and "shit", a four-row "situation" table, a projection table with no picture, and an
 * appendix that listed the client's assets but none of the rates the advice rested on (the aged
 * care one even hand-typed 2023-24 tax brackets). One kit, three documents:
 *
 *   - SOA_THEME_CSS — the app's own language on paper: white cards, slate borders, a coloured rule
 *     on one side of a callout, a coloured rule across the top of a figure tile, tabular numbers,
 *     and no pastel fills anywhere. Appended after each document's stylesheet so it wins.
 *   - situationFrom / renderSituationHtml — "Your situation today" as the four numbers the
 *     analyser's step 2 shows, then the household, what is owned (by type, with its share), what
 *     comes in and goes out, and what is owed.
 *   - renderLineChart / renderProjectionCharts — an SVG line chart per measure (net worth, Age
 *     Pension, cashflow; the plan against the baseline where one exists), built to the dataviz
 *     method: 2px lines, >= 8px markers with a surface ring, recessive grid, direct end labels, a
 *     legend only for two series, text in ink never in the series colour, a hover crosshair with
 *     one tooltip for every series (wired by soaBookletScript.ts — the popup inherits a CSP that
 *     forbids inline script). Palette #2563eb / #ea580c validated with the skill's checker.
 *   - renderAssumptionsAppendixHtml — the Assumptions page's own sections (assumptionSections.ts),
 *     the module's relevant ones open, the rest collapsed.
 *   - renderComparisonTable — every strategy modelled, sortable by estate, pension or cashflow.
 *   - renderToc — a clickable map of the sections, so a client can jump rather than page.
 *
 * Everything here is a pure function of plain data, so a stored snapshot re-renders identically
 * for the licensee view.
 */ 
const $8ea663173c1a6588$export$dfc7c7c5dc9d5e53 = (value)=>String(value ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
const $8ea663173c1a6588$var$num = (v)=>{
    const n = typeof v === 'number' ? v : parseFloat(String(v ?? '').replace(/[$,\s]/g, ''));
    return Number.isFinite(n) ? n : 0;
};
const $8ea663173c1a6588$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(n);
const $8ea663173c1a6588$var$prettify = (key)=>key.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/_/g, ' ').replace(/^./, (c)=>c.toUpperCase());
const $8ea663173c1a6588$export$819582c46739efcd = [
    '#2563eb',
    '#ea580c',
    '#059669'
];
const $8ea663173c1a6588$export$a7aa337a60127637 = `
/* \u{2500}\u{2500} AgedCareWise document theme (soaKit.ts): white surfaces, one coloured rule, no pastel fills \u{2500}\u{2500} */
:root{--rule-blue:#2563eb;--rule-amber:#f59e0b;--rule-green:#10b981;--rule-rose:#f43f5e;--rule-slate:#64748b;--ink-2:#334155}
.book{background:#f8fafc}
.card{border-radius:16px;box-shadow:0 10px 30px rgba(15,23,42,.06)}
.card::before{height:4px;background:linear-gradient(90deg,#2563eb,#14b8a6)}
.h2{font-size:28px;letter-spacing:-.02em;background:linear-gradient(90deg,#1e3a8a,#2563eb);-webkit-background-clip:text;background-clip:text;color:transparent}
.h3{font-size:15px;font-weight:800;text-transform:uppercase;letter-spacing:.06em;color:#64748b;margin:22px 0 10px}
.lede{font-size:16px;color:#1e293b}
.kpi,.kpi--gain,.kpi--warn{background:#fff;border:1px solid #e2e8f0;border-radius:12px;padding:16px 14px 14px;position:relative;overflow:hidden;box-shadow:0 1px 2px rgba(15,23,42,.04)}
.kpi::before{content:'';position:absolute;left:0;right:0;top:0;height:4px;background:var(--rule-slate)}
.kpi--gain::before{background:#34d399}.kpi--warn::before{background:#fb7185}
.kpi--gain .value{color:#047857}.kpi--warn .value{color:#be123c}
.kpi .value{font-size:26px;font-weight:800;letter-spacing:-.01em;font-variant-numeric:tabular-nums}
.kpi .label{font-size:12px;color:#475569;text-transform:none;letter-spacing:0;font-weight:600}
.callout,.callout--blue,.callout--amber,.callout--slate,.callout--green{background:#fff;border:1px solid #e2e8f0;border-left:4px solid var(--rule-blue);border-radius:12px;box-shadow:0 1px 2px rgba(15,23,42,.04)}
.callout--amber{border-left-color:var(--rule-amber)}.callout--green{border-left-color:var(--rule-green)}.callout--slate{border-left-color:var(--rule-slate)}
.callout-title{color:#0f172a}
.oneLine{font-size:21px;font-weight:800;line-height:1.35;color:#0f172a}
.imp-card{background:#fff;border:1px solid #e2e8f0;border-left:4px solid var(--rule-blue);border-radius:12px}
.imp-title{color:#0f172a}
.scope-in,.scope-out{background:#fff;border:1px solid #e2e8f0;border-radius:12px;padding:16px}
.scope-in{border-left:4px solid var(--rule-green)}.scope-out{border-left:4px solid var(--rule-rose)}
.scope-in h4,.scope-out h4{color:#475569}
.piece{background:#fff;border:1px solid #e2e8f0;border-left:4px solid var(--rule-blue)}
.piece-amt{color:#1d4ed8}
.opt-card{background:#fff;border:1px solid #e2e8f0;border-left:4px solid #cbd5e1}
.opt-card--selected,.opt-card--conditional{background:#fff;border-color:#e2e8f0;border-left:4px solid var(--rule-blue);box-shadow:0 10px 30px rgba(37,99,235,.10)}
.opt-card-head .opt-tag{background:#fff;border:1px solid #bfdbfe;color:#1d4ed8}
.pill-not-selected{background:#fff;border:1px solid #cbd5e1;color:#475569}
.pill-selected{background:var(--rule-blue);color:#fff}
.estate-alert{background:#fff;border:1px solid #e2e8f0;border-left:4px solid var(--rule-rose);border-radius:12px}
details,.factSection{background:#fff;border:1px solid #e2e8f0}
details summary{cursor:pointer}
th{background:#fff;border-bottom:2px solid #e2e8f0;color:#475569}
.table-proj tbody tr.proj-tr-data.proj-zebra{background:#fff}
.table-proj tbody tr.proj-tr-data:nth-child(even){background:#f8fafc}
.td-num,.soa-num{font-variant-numeric:tabular-nums}
.riskList li strong{color:#0f172a}
.muted{color:#64748b}
/* stat tiles \u{2014} the analyser's step-2 tiles */
.soa-tiles{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:12px;margin:12px 0 6px}
.soa-tile{position:relative;overflow:hidden;border:1px solid #e2e8f0;border-radius:12px;background:#fff;padding:18px 14px 14px;box-shadow:0 1px 2px rgba(15,23,42,.04)}
.soa-tile::before{content:'';position:absolute;left:0;right:0;top:0;height:4px;background:var(--rule-slate)}
.soa-tile--good::before{background:#34d399}.soa-tile--bad::before{background:#fb7185}.soa-tile--family::before{background:#0290f5}.soa-tile--cost::before{background:#64748b}
.soa-tile .t-label{font-size:13px;font-weight:600;color:#475569}
.soa-tile .t-value{font-size:26px;font-weight:800;letter-spacing:-.01em;margin-top:6px;font-variant-numeric:tabular-nums;color:#0f172a}
.soa-tile--good .t-value{color:#047857}.soa-tile--bad .t-value{color:#be123c}
.soa-tile .t-unit{font-size:13px;font-weight:600;color:#64748b;margin-left:4px}
.soa-tile .t-cap{font-size:13px;color:#64748b;margin-top:6px;line-height:1.4}
/* situation */
.soa-situ{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-top:8px}
.soa-panel{border:1px solid #e2e8f0;border-radius:12px;background:#fff;padding:14px 16px;box-shadow:0 1px 2px rgba(15,23,42,.04)}
.soa-panel h4{margin:0 0 8px;font-size:12px;font-weight:800;text-transform:uppercase;letter-spacing:.06em;color:#64748b}
.soa-rows{list-style:none;margin:0;padding:0}
.soa-rows li{display:flex;justify-content:space-between;gap:12px;padding:8px 0;border-bottom:1px solid #f1f5f9;font-size:14px}
.soa-rows li:last-child{border-bottom:0}
.soa-rows li span:first-child{color:#334155}
.soa-rows li strong{white-space:nowrap;font-variant-numeric:tabular-nums}
.soa-rows .sub{display:block;font-size:12px;color:#64748b;font-weight:400}
.soa-share{display:inline-block;height:6px;border-radius:3px;background:#2563eb;vertical-align:middle;margin-right:6px}
/* drivers \u{2014} what moves the estate */
.soa-drivers{list-style:none;margin:8px 0 0;padding:0}
.soa-drivers li{display:flex;justify-content:space-between;gap:12px;padding:9px 0;border-bottom:1px solid #f1f5f9;font-size:14px;align-items:baseline}
.soa-drivers li strong{white-space:nowrap;font-variant-numeric:tabular-nums}
.soa-drivers .minus{color:#be123c}.soa-drivers .plus{color:#047857}.soa-drivers .neutral{color:#475569}
/* charts */
.soa-tabs{display:flex;gap:6px;flex-wrap:wrap;margin:10px 0 12px}
.soa-tabs button{appearance:none;border:2px solid #e2e8f0;background:#f8fafc;color:#334155;font-weight:700;font-size:13px;padding:8px 14px;border-radius:10px;cursor:pointer}
.soa-tabs button.active{border-color:#2563eb;background:#eff6ff;color:#1e3a8a}
.soa-chart{position:relative;border:1px solid #e2e8f0;border-radius:12px;background:#fff;padding:12px 12px 6px;margin:6px 0 10px}
.soa-chart svg{display:block;width:100%;height:auto}
.soa-chart .grid line{stroke:#e2e8f0;stroke-width:1}
.soa-chart .axis text{fill:#64748b;font-size:11px;font-family:inherit}
.soa-chart .series path{fill:none;stroke-width:2;stroke-linejoin:round;stroke-linecap:round}
.soa-chart .series circle{stroke:#fff;stroke-width:2}
.soa-chart .endlabel{font-size:12px;font-weight:700;fill:#0f172a;font-family:inherit}
.soa-chart .crosshair{stroke:#94a3b8;stroke-width:1;stroke-dasharray:3 3;display:none}
.soa-chart .hit{fill:transparent;cursor:crosshair}
.soa-legend{display:flex;gap:16px;flex-wrap:wrap;font-size:13px;color:#334155;margin:0 0 6px 4px}
.soa-legend i{display:inline-block;width:18px;height:0;border-top:3px solid currentColor;vertical-align:middle;margin-right:6px;border-radius:2px}
.soa-tip{position:absolute;pointer-events:none;display:none;background:#fff;border:1px solid #e2e8f0;border-radius:10px;padding:8px 10px;font-size:12px;box-shadow:0 10px 30px rgba(15,23,42,.12);z-index:5;min-width:150px}
.soa-tip .t-title{font-weight:800;color:#0f172a;margin-bottom:4px}
.soa-tip .t-row{display:flex;justify-content:space-between;gap:12px;padding:2px 0}
.soa-tip .t-row i{display:inline-block;width:14px;border-top:3px solid currentColor;vertical-align:middle;margin-right:6px;border-radius:2px}
.soa-tip .t-row strong{font-variant-numeric:tabular-nums}
.soa-panel-chart{display:none}.soa-panel-chart.active{display:block}
/* sortable comparison table */
.soa-sort th[data-sort]{cursor:pointer;user-select:none;white-space:nowrap}
.soa-sort th[data-sort]:hover{color:#1d4ed8}
.soa-sort th[data-sort].is-sorted::after{content:' \u{25BE}';color:#2563eb}
.soa-sort tr.is-selected{background:#eff6ff}
.soa-sort .badge{display:inline-block;font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:.06em;color:#1d4ed8;border:1px solid #bfdbfe;border-radius:999px;padding:2px 7px;margin:2px 4px 0 0;background:#fff}
/* table of contents */
.soa-toc{display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:8px;margin:12px 0 4px}
.soa-toc button{appearance:none;text-align:left;border:1px solid #e2e8f0;background:#fff;border-radius:10px;padding:10px 12px;font-size:13px;font-weight:600;color:#1e293b;cursor:pointer;display:flex;gap:10px;align-items:center}
.soa-toc button:hover{border-color:#93c5fd;color:#1d4ed8}
.soa-toc button i{font-style:normal;display:inline-flex;width:22px;height:22px;border-radius:999px;background:#2563eb;color:#fff;font-size:11px;font-weight:800;align-items:center;justify-content:center;flex:none}
/* assumptions appendix */
.soa-assump{margin:10px 0;padding:0;border:1px solid #e2e8f0;border-radius:12px;background:#fff}
.soa-assump summary{padding:12px 14px;font-weight:800;color:#0f172a;list-style:none;display:flex;justify-content:space-between;align-items:center}
.soa-assump summary::after{content:'+';color:#2563eb;font-weight:800}
.soa-assump[open] summary::after{content:'\u{2013}'}
.soa-assump .a-body{padding:0 14px 10px}
.soa-assump .a-row{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:12px;padding:9px 0;border-bottom:1px solid #f1f5f9;font-size:13px}
.soa-assump .a-row:last-child{border-bottom:0}
.soa-assump .a-row .a-label{color:#334155}
.soa-assump .a-row .a-value{font-weight:700;text-align:right;white-space:nowrap;font-variant-numeric:tabular-nums}
.soa-assump .a-row .a-note{grid-column:1 / -1;font-size:12px;color:#64748b;margin-top:-4px}
/* doing nothing against this plan (owner, 24 Oct 2026): the plan's column in navy, a pill that says what it means */
.soa-dn{width:100%;border-collapse:collapse;margin:10px 0 4px;background:#fff}
.soa-dn th,.soa-dn td{padding:9px 10px;border-bottom:1px solid #e2e8f0;text-align:left;vertical-align:middle}
.soa-dn .soa-num{text-align:right;white-space:nowrap;font-variant-numeric:tabular-nums}
.soa-dn th.soa-dn-plan{color:#001E7A;border-bottom:2px solid #001E7A}
.soa-dn td.soa-dn-plan{color:#001E7A;font-weight:700}
.soa-pill{display:inline-block;border-radius:999px;padding:3px 10px;font-size:12.5px;font-weight:700;white-space:nowrap;font-variant-numeric:tabular-nums}
.soa-pill--up{color:#047857;background:#ecfdf5}
.soa-pill--down{color:#be123c;background:#fff1f2}
.soa-pill--none{color:#64748b;background:#f1f5f9}
/* figure boxes: one emphasised in navy where it sets the others */
.soa-figs{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px;margin:8px 0 10px}
.soa-fig{background:#fff;border:1px solid #e2e8f0;border-radius:12px;padding:12px 14px}
.soa-fig .label{font-size:12px;color:#475569;text-transform:none;letter-spacing:0;font-weight:600}
.soa-fig .value{font-size:22px;font-weight:800;margin-top:4px;font-variant-numeric:tabular-nums}
.soa-fig--key{border-top:4px solid #001E7A}
.soa-fig--key .value{color:#001E7A}
@media (max-width:640px){.soa-figs{grid-template-columns:1fr}.soa-dn th,.soa-dn td{padding:8px 6px}.soa-pill{white-space:normal}}
@media (max-width:860px){.soa-tiles{grid-template-columns:1fr 1fr}.soa-situ{grid-template-columns:1fr}}
/* THE PRINTED COPY (owner, 24 Oct 2026, checked as a PDF): each section starts on a new page and flows
   from its top, a heading stays with what follows it, and a chart, box or table row is never cut in two.
   Tables print at a size older readers can manage. Shared by every advice document, after its own rules. */
/* Printed as on screen even with the dialog's "background graphics" unticked (owner, 24 Oct 2026: section
   headings missing from a print to PDF \u{2014} the headings are gradient text, painted by a background). */
html,body{-webkit-print-color-adjust:exact;print-color-adjust:exact}
@media print{
  .h2{background:none !important;-webkit-background-clip:border-box !important;background-clip:border-box !important;color:#1e3a8a !important;-webkit-text-fill-color:#1e3a8a !important}
  .page,.page.active{break-before:page;page-break-before:always;break-inside:auto !important;page-break-inside:auto !important}
  .card{break-inside:auto !important;page-break-inside:auto !important}
  .h2,.h3,h3,h4,summary,.callout-title{break-after:avoid;page-break-after:avoid}
  p.small:last-child{break-before:avoid;page-break-before:avoid}
  .screen-only{display:none !important}
  details[data-print-closed]:not([open])>summary>*{display:none}
  details[data-print-closed]:not([open])>summary{list-style:none}
  details[data-print-closed]:not([open])>summary::-webkit-details-marker{display:none}
  details[data-print-closed]:not([open])>summary::before{content:"The full list of every strategy modelled is in the on-screen version of this document."}
  .soa-chart,.soa-panel,.soa-fig,.soa-figs,.soa-tiles,.callout,.soa-toc,tr{break-inside:avoid;page-break-inside:avoid}
  thead{display:table-header-group}
  table{font-size:12px !important}
}
@media print{.soa-tip{display:none !important}.soa-panel-chart{display:block !important}.soa-tabs{display:none !important}.soa-toc button{border:1px solid #d1d5db}.soa-assump{border:1px solid #d1d5db}}
`;
const $8ea663173c1a6588$var$RESIDENCY_WORDS = {
    own_home: 'Own home',
    renting: 'Renting',
    with_family: 'Living with family',
    retirement_village: 'Retirement village',
    aged_care: 'Residential aged care',
    granny_flat: 'Granny flat'
};
const $8ea663173c1a6588$var$INCOME_WORDS = {
    definedBenefitPension: 'Defined benefit pension',
    salary: 'Salary or wages',
    carerAllowance: 'Carer Allowance',
    dvaDisability: 'DVA disability pension',
    dvaWarWidow: 'DVA war widow(er) pension',
    overseasPension: 'Overseas pension',
    boarders: 'Board from boarders or lodgers',
    other: 'Other income'
};
const $8ea663173c1a6588$var$ageOf = (dob)=>{
    if (!dob) return null;
    const d = new Date(String(dob));
    if (Number.isNaN(d.getTime())) return null;
    const now = new Date();
    let a = now.getFullYear() - d.getFullYear();
    if (now.getMonth() < d.getMonth() || now.getMonth() === d.getMonth() && now.getDate() < d.getDate()) a -= 1;
    return a;
};
function $8ea663173c1a6588$export$b49cd4ac4688f9b9(factFind) {
    const fd = factFind || {};
    const isCouple = fd.adviceFor === 'couple';
    const assets = fd.assets || {};
    const assetsByType = Object.entries(assets).map(([type, list])=>({
            type: $8ea663173c1a6588$var$prettify(type),
            count: (list || []).length,
            total: (list || []).reduce((t, a)=>t + $8ea663173c1a6588$var$num(a?.value), 0)
        })).filter((r)=>r.count > 0 && r.total > 0).sort((a, b)=>b.total - a.total);
    const liabilities = Object.values(fd.liabilities || {}).flatMap((list)=>(list || []).map((l)=>({
                description: String(l?.description || $8ea663173c1a6588$var$prettify(String(l?.type || 'Debt'))),
                balance: $8ea663173c1a6588$var$num(l?.balance ?? l?.value)
            }))).filter((l)=>l.balance > 0);
    const otherIncomes = (fd.income?.otherIncomes || []).map((i)=>({
            description: String(i?.description || $8ea663173c1a6588$var$INCOME_WORDS[String(i?.type || '')] || 'Other income'),
            amount: $8ea663173c1a6588$var$num(i?.amount)
        })).filter((i)=>i.amount > 0);
    const res = (who)=>$8ea663173c1a6588$var$RESIDENCY_WORDS[String(fd[who]?.currentResidency || '')] || '';
    const residency = isCouple && res('client') !== res('partner') && res('partner') ? `${res('client') || 'Not recorded'} / ${res('partner')}` : res('client') || 'Not recorded';
    return {
        clientName: String(fd.client?.firstName || 'Client'),
        partnerName: isCouple ? String(fd.partner?.firstName || 'Partner') : '',
        clientAge: $8ea663173c1a6588$var$ageOf(fd.client?.dob),
        partnerAge: isCouple ? $8ea663173c1a6588$var$ageOf(fd.partner?.dob) : null,
        isCouple: isCouple,
        residency: residency,
        home: $8ea663173c1a6588$var$num(fd.home?.value) > 0 ? {
            value: $8ea663173c1a6588$var$num(fd.home?.value),
            ownership: String(fd.home?.ownership || 'joint')
        } : null,
        assetsByType: assetsByType,
        totalAssets: assetsByType.reduce((t, r)=>t + r.total, 0),
        liabilities: liabilities,
        otherIncomes: otherIncomes,
        livingExpenses: $8ea663173c1a6588$var$num(fd.expenses?.livingExpenses)
    };
}
function $8ea663173c1a6588$export$27b9fb11d88f112e(tiles) {
    return `<div class="soa-tiles">${tiles.map((t)=>`<div class="soa-tile soa-tile--${t.tone}"><div class="t-label">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(t.label)}</div><div class="t-value">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(t.value)}${t.unit ? `<span class="t-unit">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(t.unit)}</span>` : ''}</div><div class="t-cap">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(t.caption)}</div></div>`).join('')}</div>`;
}
function $8ea663173c1a6588$export$b23e227b9b89e73c(s, baseline, years, bridge) {
    const household = s.isCouple ? `${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(s.clientName)}${s.clientAge != null ? ` (${s.clientAge})` : ''} and ${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(s.partnerName)}${s.partnerAge != null ? ` (${s.partnerAge})` : ''}` : `${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(s.clientName)}${s.clientAge != null ? ` (${s.clientAge})` : ''}`;
    const netWorth = baseline.netWorth ?? s.totalAssets + (s.home?.value ?? 0) - s.liabilities.reduce((t, l)=>t + l.balance, 0);
    const tiles = $8ea663173c1a6588$export$27b9fb11d88f112e([
        {
            label: 'Age Pension today',
            value: $8ea663173c1a6588$var$money(Math.round(baseline.pension)),
            unit: 'a year',
            caption: baseline.pension > 0 ? "Estimated entitlement on today\u2019s assets and income." : "No entitlement on today\u2019s assets and income.",
            tone: 'good'
        },
        {
            label: baseline.cashflow < 0 ? 'Left to find each year' : 'Left over each year',
            value: `${baseline.cashflow < 0 ? "\u2212" : '+'}${$8ea663173c1a6588$var$money(Math.abs(Math.round(baseline.cashflow)))}`,
            caption: baseline.cashflow < 0 ? 'Money in, less money out. Met from savings.' : 'Money in, less money out, as things stand.',
            tone: baseline.cashflow < 0 ? 'bad' : 'good'
        },
        {
            label: 'Net worth today',
            value: $8ea663173c1a6588$var$money(Math.round(netWorth)),
            caption: s.home ? "Everything owned, less everything owed \u2014 the home included." : 'Everything owned, less everything owed.',
            tone: 'cost'
        },
        {
            label: "What's left to the family",
            value: $8ea663173c1a6588$var$money(Math.round(baseline.estate)),
            caption: `After ${years} ${years === 1 ? 'year' : 'years'}, ${baseline.name.toLowerCase()}.`,
            tone: 'family'
        }
    ]);
    const max = Math.max(1, ...s.assetsByType.map((r)=>r.total));
    const assetRows = s.assetsByType.length ? s.assetsByType.map((r)=>`<li><span><i class="soa-share" style="width:${Math.max(6, Math.round(r.total / max * 70))}px"></i>${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(r.type)}<span class="sub">${r.count} ${r.count === 1 ? 'item' : 'items'} \xb7 ${s.totalAssets > 0 ? Math.round(r.total / s.totalAssets * 100) : 0}% of investments</span></span><strong>${$8ea663173c1a6588$var$money(r.total)}</strong></li>`).join('') : '<li><span class="muted">No investments or savings recorded.</span></li>';
    const incomeRows = s.otherIncomes.length ? s.otherIncomes.map((i)=>`<li><span>${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(i.description)}</span><strong>${$8ea663173c1a6588$var$money(i.amount)} a year</strong></li>`).join('') : '<li><span class="muted">No income other than the pension and what the investments earn.</span></li>';
    const debtRows = s.liabilities.length ? s.liabilities.map((l)=>`<li><span>${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(l.description)}</span><strong>${$8ea663173c1a6588$var$money(l.balance)}</strong></li>`).join('') : '<li><span class="muted">No debts recorded.</span></li>';
    // The sentence that bridges today's position to the basis the strategies are measured on
    // (the aged care document: the in-care do-nothing run; owner, 9 Oct 2026).
    // **…** marks the figures compared against, in bold (escaped first, so nothing else becomes markup).
    const bridgeHtml = bridge ? `<p class="lede">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(bridge).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')}</p>` : '';
    return `${tiles}${bridgeHtml}
<div class="soa-situ">
<div class="soa-panel"><h4>Your household</h4><ul class="soa-rows">
<li><span>${s.isCouple ? 'Couple' : 'Single'}</span><strong>${household}</strong></li>
<li><span>Where you live</span><strong>${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(s.residency)}</strong></li>
${s.home ? `<li><span>The home<span class="sub">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53($8ea663173c1a6588$var$prettify(s.home.ownership))} \xb7 exempt from the Age Pension test while you live in it</span></span><strong>${$8ea663173c1a6588$var$money(s.home.value)}</strong></li>` : '<li><span>The home</span><strong>No home recorded</strong></li>'}
<li><span>Living expenses</span><strong>${$8ea663173c1a6588$var$money(s.livingExpenses)} a year</strong></li>
</ul></div>
<div class="soa-panel"><h4>What you own, apart from the home</h4><ul class="soa-rows">${assetRows}${s.assetsByType.length ? `<li><span><strong>Total investments and savings</strong></span><strong>${$8ea663173c1a6588$var$money(s.totalAssets)}</strong></li>` : ''}</ul></div>
<div class="soa-panel"><h4>Money coming in, apart from the pension</h4><ul class="soa-rows">${incomeRows}</ul></div>
<div class="soa-panel"><h4>What you owe</h4><ul class="soa-rows">${debtRows}</ul></div>
</div>`;
}
const $8ea663173c1a6588$var$niceStep = (span)=>{
    const raw = span / 4;
    const mag = Math.pow(10, Math.floor(Math.log10(Math.max(1, raw))));
    const norm = raw / mag;
    const step = norm <= 1 ? 1 : norm <= 2 ? 2 : norm <= 2.5 ? 2.5 : norm <= 5 ? 5 : 10;
    return step * mag;
};
const $8ea663173c1a6588$var$short = (n)=>{
    const a = Math.abs(n);
    const s = a >= 1000000 ? `$${(a / 1000000).toFixed(a % 1000000 === 0 ? 0 : 1)}m` : a >= 1000 ? `$${Math.round(a / 1000)}k` : `$${Math.round(a)}`;
    return n < 0 ? `\u{2212}${s}` : s;
};
function $8ea663173c1a6588$export$5b646f167541cbb6(opts) {
    const W = 760, H = 300, padL = 64, padR = 110, padT = 18, padB = 36;
    const innerW = W - padL - padR, innerH = H - padT - padB;
    const all = opts.series.flatMap((s)=>s.values).filter((v)=>Number.isFinite(v));
    if (!all.length || opts.categories.length < 2) return '';
    /*
     * The axis starts at zero where the data crosses it or spans most of its own size. Where every
     * value sits in a narrow band far from zero (a $5m estate moving by $200k), a zero axis would
     * flatten the two lines into one — so the band is padded instead and the chart says so.
     */ const vLo = Math.min(...all), vHi = Math.max(...all);
    const span = vHi - vLo;
    const zoomed = vLo > 0 && span < 0.5 * vHi;
    let lo = zoomed ? vLo - span * 0.25 : Math.min(0, vLo);
    let hi = zoomed ? vHi + span * 0.25 : Math.max(0, vHi);
    if (hi === lo) hi = lo + 1;
    const step = $8ea663173c1a6588$var$niceStep(hi - lo);
    lo = Math.floor(lo / step) * step;
    hi = Math.ceil(hi / step) * step;
    const n = opts.categories.length;
    const x = (i)=>padL + innerW * i / (n - 1);
    const y = (v)=>padT + innerH - (v - lo) / (hi - lo) * innerH;
    const ticks = [];
    for(let t = lo; t <= hi + step / 2; t += step)ticks.push(t);
    const grid = ticks.map((t)=>`<line x1="${padL}" x2="${W - padR}" y1="${y(t).toFixed(1)}" y2="${y(t).toFixed(1)}"${t === 0 ? ' style="stroke:#94a3b8"' : ''}/><text x="${padL - 8}" y="${(y(t) + 4).toFixed(1)}" text-anchor="end">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53($8ea663173c1a6588$var$short(t))}</text>`).join('');
    const every = n > 12 ? Math.ceil(n / 12) : 1;
    const xLabels = opts.categories.map((c, i)=>i % every === 0 || i === n - 1 ? `<text x="${x(i).toFixed(1)}" y="${H - padB + 18}" text-anchor="middle">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(c)}</text>` : '').join('');
    // End labels never sit on each other: ordered by height, each is pushed below the one above.
    const labelY = opts.series.map((s)=>y(s.values[s.values.length - 1] ?? 0) + 4);
    const order = labelY.map((v, i)=>[
            v,
            i
        ]).sort((a, b)=>a[0] - b[0]);
    for(let k = 1; k < order.length; k += 1){
        const prev = order[k - 1], cur = order[k];
        if (cur[0] - prev[0] < 14) {
            labelY[cur[1]] = prev[0] + 14;
            order[k] = [
                prev[0] + 14,
                cur[1]
            ];
        }
    }
    // Drawn last-to-first so the first series (the plan) sits on top where lines coincide.
    const seriesSvg = opts.series.map((s, si)=>{
        const color = $8ea663173c1a6588$export$819582c46739efcd[s.color ?? si] ?? $8ea663173c1a6588$export$819582c46739efcd[0];
        const pts = s.values.map((v, i)=>[
                x(i),
                y(v)
            ]);
        const d = pts.map(([px, py], i)=>`${i === 0 ? 'M' : 'L'}${px.toFixed(1)} ${py.toFixed(1)}`).join(' ');
        const last = pts[pts.length - 1];
        const circles = pts.map(([px, py], i)=>`<circle class="pt" data-i="${i}" cx="${px.toFixed(1)}" cy="${py.toFixed(1)}" r="4.5" fill="${color}"/>`).join('');
        return `<g class="series" data-series="${si}" style="color:${color}"><path d="${d}" stroke="${color}"/>${circles}<text class="endlabel" x="${(last[0] + 10).toFixed(1)}" y="${(labelY[si] ?? last[1] + 4).toFixed(1)}">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53($8ea663173c1a6588$var$short(s.values[s.values.length - 1] ?? 0))}</text></g>`;
    }).reverse().join('');
    const legend = opts.series.length > 1 ? `<div class="soa-legend">${opts.series.map((s, si)=>`<span style="color:${$8ea663173c1a6588$export$819582c46739efcd[s.color ?? si] ?? $8ea663173c1a6588$export$819582c46739efcd[0]}"><i></i><span style="color:#334155">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(s.name)}</span></span>`).join('')}</div>` : '';
    const data = $8ea663173c1a6588$export$dfc7c7c5dc9d5e53(JSON.stringify({
        categories: opts.categories,
        series: opts.series.map((s, si)=>({
                name: s.name,
                values: s.values,
                color: $8ea663173c1a6588$export$819582c46739efcd[s.color ?? si] ?? $8ea663173c1a6588$export$819582c46739efcd[0]
            })),
        padL: padL,
        padR: padR,
        W: W,
        title: opts.title
    }));
    return `<div class="soa-chart" id="${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(opts.id)}" data-chart="${data}">
<p class="small" style="margin:0 0 4px;font-weight:700;color:#0f172a">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(opts.title)}</p>${legend}
<svg viewBox="0 0 ${W} ${H}" role="img" aria-label="${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(opts.title)}">
<g class="grid">${grid}</g><g class="axis">${xLabels}</g>
${seriesSvg}
<line class="crosshair" y1="${padT}" y2="${H - padB}" x1="0" x2="0"/>
<rect class="hit" x="${padL}" y="${padT}" width="${innerW}" height="${innerH}"/>
</svg>
<div class="soa-tip"></div>
${opts.note || zoomed ? `<p class="tiny muted" style="margin:6px 0 4px">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(opts.note || '')}${zoomed ? `${opts.note ? ' ' : ''}The axis starts at ${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53($8ea663173c1a6588$var$short(lo))}, not zero, so the difference between the lines can be seen.` : ''}</p>` : ''}
</div>`;
}
function $8ea663173c1a6588$export$6534c8cb884ee17d(opts) {
    if (!opts.plan.length) return '';
    const categories = opts.plan.map((r)=>r.label);
    const base = opts.baseline && opts.baseline.length >= 2 ? opts.baseline.slice(0, categories.length) : null;
    const seriesFor = (pick)=>[
            {
                name: opts.planName,
                values: opts.plan.map(pick),
                color: 0
            },
            ...base ? [
                {
                    name: opts.baselineName || 'Baseline',
                    values: base.map(pick),
                    color: 1
                }
            ] : []
        ];
    const tabs = [
        {
            key: 'networth',
            label: 'Net worth',
            title: 'Net worth at the end of each year',
            pick: (r)=>r.netWorth,
            note: 'Everything owned less everything owed. Money drawn to cover a shortfall shows here as a flatter or falling line.'
        },
        {
            key: 'pension',
            label: 'Age Pension',
            title: 'Age Pension each year',
            pick: (r)=>r.pension,
            note: 'Rates and thresholds are indexed from year 2 at the projection inflation rate.'
        },
        {
            key: 'cashflow',
            label: 'Cashflow',
            title: 'Money in less money out, each year',
            pick: (r)=>r.cashflow,
            note: "Below the line, the year\u2019s shortfall is drawn from savings."
        }
    ];
    return `<div class="soa-tabset" data-tabset="${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(opts.idPrefix)}">
<div class="soa-tabs" role="tablist">${tabs.map((t, i)=>`<button type="button" role="tab" class="${i === 0 ? 'active' : ''}" data-tab="${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(opts.idPrefix)}-${t.key}">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(t.label)}</button>`).join('')}</div>
${tabs.map((t, i)=>`<div class="soa-panel-chart${i === 0 ? ' active' : ''}" data-panel="${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(opts.idPrefix)}-${t.key}">${$8ea663173c1a6588$export$5b646f167541cbb6({
            id: `${opts.idPrefix}-${t.key}-chart`,
            title: t.title,
            categories: categories,
            series: seriesFor(t.pick),
            note: t.note
        })}</div>`).join('')}
</div>`;
}
function $8ea663173c1a6588$export$6b235b65b4fb4ca7(rows, years, baseline) {
    const row = (r, cls = '')=>`<tr class="${cls}${r.selected ? ' is-selected' : ''}" data-selected="${r.selected ? 1 : 0}">
<td><div style="font-weight:700;color:#0f172a">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(r.name)}${r.selected ? ' <span class="badge" style="color:#047857;border-color:#a7f3d0">Your choice</span>' : ''}</div>${r.badges.map((b)=>`<span class="badge">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(b)}</span>`).join('')}${r.description ? `<div class="tiny muted" style="margin-top:4px;max-width:520px">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(r.description)}</div>` : ''}</td>
<td class="td-num soa-num" data-value="${r.pension}">${$8ea663173c1a6588$var$money(r.pension)}</td>
<td class="td-num soa-num ${r.cashflow < 0 ? 'age-neg' : ''}" data-value="${r.cashflow}">${$8ea663173c1a6588$var$money(r.cashflow)}</td>
<td class="td-num soa-num" data-value="${r.estate}"><strong>${$8ea663173c1a6588$var$money(r.estate)}</strong></td>
</tr>`;
    const plans = rows.filter((r)=>!r.sensitivity);
    const whatIfs = rows.filter((r)=>r.sensitivity);
    return `<table class="soa-sort" data-sortable>
<thead><tr><th>Strategy</th><th data-sort="1" style="text-align:right">Age Pension a year</th><th data-sort="2" style="text-align:right">Cashflow a year</th><th data-sort="3" class="is-sorted" style="text-align:right">Estate after ${years} years</th></tr></thead>
<tbody>${baseline ? `<tr class="is-baseline"><td><div style="font-weight:700;color:#0f172a">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(baseline.name)}</div><div class="tiny muted">The benchmark every strategy is measured against.</div></td><td class="td-num soa-num" data-value="${baseline.pension}">${$8ea663173c1a6588$var$money(baseline.pension)}</td><td class="td-num soa-num ${baseline.cashflow < 0 ? 'age-neg' : ''}" data-value="${baseline.cashflow}">${$8ea663173c1a6588$var$money(baseline.cashflow)}</td><td class="td-num soa-num" data-value="${baseline.estate}"><strong>${$8ea663173c1a6588$var$money(baseline.estate)}</strong></td></tr>` : ''}${plans.map((r)=>row(r)).join('')}</tbody>
${whatIfs.length ? `<tbody class="soa-whatifs"><tr><td colspan="4" style="padding-top:16px"><div class="h3" style="margin:0 0 2px">What if the price were different?</div><div class="tiny muted">Modelled to show what the price itself does. Not a recommendation.</div></td></tr>${whatIfs.map((r)=>row(r, 'is-whatif')).join('')}</tbody>` : ''}
</table>`;
}
const $8ea663173c1a6588$var$DO_NOTHING_WORDS = {
    estate: {
        higherIsBetter: true,
        up: 'more to the family',
        down: 'less to the family'
    },
    pension: {
        higherIsBetter: true,
        up: 'a year more Age Pension',
        down: 'a year less Age Pension'
    },
    cashflow: {
        higherIsBetter: true,
        up: 'a year better off',
        down: 'a year worse off'
    },
    fees: {
        higherIsBetter: false,
        up: 'a year less in fees',
        down: 'a year more in fees'
    },
    contribution: {
        higherIsBetter: false,
        up: 'a year less in contributions',
        down: 'a year more in contributions'
    }
};
function $8ea663173c1a6588$export$1929c177e07485e6(measure, delta) {
    const d = Math.round(Number(delta) || 0);
    if (d === 0) return '<span class="soa-pill soa-pill--none">no change</span>';
    const w = $8ea663173c1a6588$var$DO_NOTHING_WORDS[measure];
    const better = w.higherIsBetter ? d > 0 : d < 0;
    return `<span class="soa-pill soa-pill--${better ? 'up' : 'down'}">${better ? "\u25B2" : "\u25BC"} ${$8ea663173c1a6588$var$money(Math.abs(d))} ${better ? w.up : w.down}</span>`;
}
function $8ea663173c1a6588$export$19dae3d6ce96af14(rows, baseLabel = 'The comparison') {
    const fig = (n)=>n == null || !Number.isFinite(n) ? "\u2014" : `${n < 0 ? "\u2212" : ''}${$8ea663173c1a6588$var$money(Math.abs(Math.round(n)))}`;
    return `<table class="soa-dn">
<thead><tr><th>Measure</th><th class="soa-num">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(baseLabel)}</th><th class="soa-num soa-dn-plan">This plan</th><th>What it means for you</th></tr></thead>
<tbody>${rows.map((r)=>`<tr><td>${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(r.label)}</td><td class="soa-num">${fig(r.doNothing)}</td><td class="soa-num soa-dn-plan">${fig(r.plan)}</td><td>${$8ea663173c1a6588$export$1929c177e07485e6(r.measure, r.delta)}</td></tr>`).join('')}</tbody>
</table>`;
}
function $8ea663173c1a6588$export$ae39401b8f7dcdc4(titles) {
    return `<div class="soa-toc">${titles.map((t, i)=>`<button type="button" data-goto="${i}"><i>${i + 1}</i><span>${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(t)}</span></button>`).join('')}</div>`;
}
function $8ea663173c1a6588$export$5f05ccad41218e23(sections, openWhen) {
    return sections.map((sec)=>`<details class="soa-assump"${openWhen.test(sec.title) ? ' open' : ''}><summary>${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(sec.title)}</summary><div class="a-body">
${sec.items.map((it)=>`<div class="a-row"><div class="a-label">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(it.label)}</div><div class="a-value">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(it.value)}</div>${it.note ? `<div class="a-note">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(it.note)}</div>` : ''}${it.details ? `<div class="a-note">${$8ea663173c1a6588$export$dfc7c7c5dc9d5e53(it.details)}</div>` : ''}</div>`).join('')}
</div></details>`).join('');
}







/**
 * The rate figures each SOA's "Asset assumptions" appendix prints — one implementation, because
 * both the aged care and Support at Home booklets show the same table and had their own copies of
 * the defaults to drift apart.
 *
 * The rule this exists to enforce: THE APPENDIX MUST STATE WHAT THE MODEL ACTUALLY USED. That is
 * not always the asset's stored rate field:
 *   - INVESTMENT PROPERTY is the case that made this necessary. The engine reads a property's
 *     RENT and EXPENSES in dollars (incomeAssessment.ts) and never consults a yield percentage, so
 *     a stored `incomeRate` is dead data — the appendix used to print the firm's assumed yield
 *     beside a property whose modelled rent implied something else entirely. The row now reports
 *     the yield the recorded rent actually represents, and names the dollars behind it.
 *   - SUPER AND PENSION balances flow nothing to the client personally (an ABP's cash is its
 *     pension payment, a separate line), so their income figure is 0 by design.
 * Everything else reports its own stored rate against the published default for its class.
 */ 

const $061bee36071dd9d5$var$num = (v)=>typeof v === 'number' ? v : parseFloat(String(v ?? '')) || 0;
/** The published default rates for an asset class, read at use time (a firm's own where set). */ function $061bee36071dd9d5$var$defaultsFor(assetType) {
    const ac = (0, $0f2c0a6799fe36da$export$b037eefb915b86ec);
    switch(assetType){
        case 'bankAccounts':
            return {
                incomeRate: ac.bankIncomePct,
                growthRate: 0
            };
        case 'termDeposits':
            return {
                incomeRate: ac.termDepositIncomePct,
                growthRate: 0
            };
        case 'shares':
            return {
                incomeRate: ac.sharesIncomePct,
                growthRate: ac.sharesGrowthPct
            };
        case 'investmentProperty':
            return {
                incomeRate: ac.propertyYieldPct,
                growthRate: ac.propertyGrowthPct
            };
        case 'superannuation':
            return {
                incomeRate: 0,
                growthRate: (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703).balanced.accumulationNetPct
            };
        case 'accountBasedPensions':
            return {
                incomeRate: 0,
                growthRate: (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703).balanced.pensionNetPct
            };
        default:
            return {
                incomeRate: 0,
                growthRate: 0
            };
    }
}
function $061bee36071dd9d5$export$53e371969067f999(assetType, asset) {
    const defaults = $061bee36071dd9d5$var$defaultsFor(assetType);
    const growthRate = $061bee36071dd9d5$var$num(asset.growthRate);
    if (assetType === 'investmentProperty') {
        // What the projection actually charges and credits: the recorded dollars.
        const value = $061bee36071dd9d5$var$num(asset.value);
        const rent = $061bee36071dd9d5$var$num(asset.rent);
        const expenses = $061bee36071dd9d5$var$num(asset.expenses);
        const impliedYield = value > 0 ? rent / value * 100 : 0;
        const basis = rent > 0 || expenses > 0 ? `Rent ${(0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(Math.round(rent))} p.a., expenses ${(0, $f0c9bf200cde0a0e$export$3dc27271f5d5c629)(Math.round(expenses))} p.a. \u{2014} as recorded, not an assumed yield` : 'No rent recorded, so the model treats this property as earning nothing';
        return {
            incomeRate: impliedYield,
            growthRate: growthRate,
            overridden: true,
            basis: basis
        };
    }
    const incomeRate = $061bee36071dd9d5$var$num(asset.incomeRate);
    return {
        incomeRate: incomeRate,
        growthRate: growthRate,
        overridden: incomeRate !== defaults.incomeRate || growthRate !== defaults.growthRate,
        basis: ''
    };
}



/**
 * Which CGT-relevant assets are missing the inputs needed to estimate capital gains tax properly.
 *
 * The CGT engine can always produce a number — where the cost base is blank it assumes 25% of current
 * value, and where the acquisition month is blank it assumes the asset has been held more than 12 months
 * (so the 50% discount applies). Both assumptions are reasonable defaults and both can be materially
 * wrong, so rather than either forcing clients to supply data they may not have or letting the guess pass
 * silently, we surface the gap.
 *
 * NO VALUE THRESHOLD. An earlier version only flagged assets worth $50,000+, on the theory that small
 * holdings were not worth prompting about. In practice that meant two assets missing the same field were
 * treated differently with nothing on screen to explain why, which reads as a bug — and the assumed
 * inputs distort a small holding's CGT just as much in percentage terms. Every CGT-relevant asset with a
 * gap is now flagged, which is only tolerable because the prompt is quiet helper text rather than a
 * warning; if it is ever restyled as an alarm, revisit that.
 *
 * Used by the fact-find to prompt inline, and by the SOA to disclose assumptions behind an asset the
 * advice actually sells. The CGT engine separately attaches its own warning to any estimate that rests
 * on the acquisition-date assumption (see disposalCgt.ts).
 */ 

function $2fa27b08acd205b2$export$71af6709f85e7408(asset, assetType) {
    if (!asset || !(0, $bfa4518c9dced417$export$580aed46e3360c20)(assetType)) return null;
    if ((0, $b9032eccb178cc91$export$321afe5948362992)(asset)) return null;
    const value = Number(asset.value) || 0;
    const missingCostBase = !(Number(asset.costBase) > 0);
    const missingAcquiredOn = !(0, $b9032eccb178cc91$export$a8d693a210faf7c)(asset);
    if (!missingCostBase && !missingAcquiredOn) return null;
    return {
        assetType: assetType,
        assetId: asset.id,
        description: (asset.description || '').trim(),
        value: value,
        missingCostBase: missingCostBase,
        missingAcquiredOn: missingAcquiredOn
    };
}
function $2fa27b08acd205b2$export$e8dd49232441dce6(assets) {
    if (!assets) return [];
    const gaps = [];
    Object.entries(assets).forEach(([assetType, list])=>{
        (list || []).forEach((asset)=>{
            const gap = $2fa27b08acd205b2$export$71af6709f85e7408(asset, assetType);
            if (gap) gaps.push(gap);
        });
    });
    return gaps;
}
function $2fa27b08acd205b2$export$8dad3974ca6e3fc9(assets, realised) {
    if (!assets || !realised?.length) return [];
    const gaps = [];
    const seen = new Set();
    realised.forEach(({ assetType: assetType, assetId: assetId })=>{
        const key = `${assetType}::${String(assetId)}`;
        if (seen.has(key)) return; // one disclosure per asset, even if drawn on more than once
        seen.add(key);
        const asset = (assets[assetType] || []).find((a)=>String(a.id) === String(assetId));
        const gap = $2fa27b08acd205b2$export$71af6709f85e7408(asset, assetType);
        if (gap) gaps.push(gap);
    });
    return gaps;
}
/** How an asset is named in client-facing output. */ function $2fa27b08acd205b2$var$gapDisplayName(gap) {
    if (gap.description) return gap.description;
    return gap.assetType === 'investmentProperty' ? 'your investment property' : 'your shares / managed funds';
}
function $2fa27b08acd205b2$export$d3be57634d2c161d(gaps) {
    if (!gaps?.length) return null;
    const names = gaps.map($2fa27b08acd205b2$var$gapDisplayName);
    const clauses = [];
    if (gaps.some((g)=>g.missingCostBase)) clauses.push('where no original purchase price was recorded, a cost base of 25% of current value has been assumed, which generally overstates the gain and the tax');
    if (gaps.some((g)=>g.missingAcquiredOn)) clauses.push("where no acquisition date was recorded, the asset is assumed to have been owned for more than 12 months (so the 50% CGT discount has been applied) and to have been acquired after 20 September 1985 (so it is not treated as CGT-exempt) \u2014 if it was in fact bought within 12 months of the sale, the actual tax would be HIGHER than modelled");
    const assetList = names.length === 1 ? names[0] : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
    return `Capital gains tax on the modelled sale of ${assetList} rests on assumed inputs because the records were incomplete: ${clauses.join('; ')}. ` + 'Confirm the actual cost base and acquisition dates with a registered tax adviser before implementing, as they change the net proceeds available.';
}
function $2fa27b08acd205b2$export$22708db49a7d569f(gap) {
    const fields = [];
    const assumptions = [];
    if (gap.missingCostBase) {
        fields.push('Cost Base');
        assumptions.push('a purchase price of 25% of the current value');
    }
    if (gap.missingAcquiredOn) {
        fields.push('Month/Year Acquired'); // must match the on-screen label exactly — it points there
        assumptions.push('more than 12 months of ownership');
    }
    return `Add ${fields.join(' and ')} above for a more accurate capital gains tax estimate. For now we assume ${assumptions.join(' and ')}.`;
}






/**
 * Display name for a RAD strategy, showing the ACTUAL RAD funded (net of any CGT on assets sold to fund it)
 * — both the dollar figure and the percentage. The stored name's "65%" is the funding TARGET; once CGT is
 * netted the real RAD can be, e.g., $320,781 on a $500k room = 64%. We recompute the % from the funded
 * dollars (rounded to the nearest whole percent) and append the amount:
 *   "Pay 65% RAD, Keep Home"  ->  "Pay 64% RAD ($320,781), Keep Home".
 * No-CGT strategies are unchanged (net == target). Also strips the "(funding order)" suffix — that one
 * and no other; see FUNDING_ORDER_SUFFIX for why the difference matters.
 * Shared by the SE cards and the digital SOA so the two never disagree.
 */ /**
 * "Do Nothing" is the right name for a BASELINE and the wrong name for ADVICE.
 *
 * The scenario is the no-lump-sum case: the client still moves into care, and the accommodation is
 * still paid — every day of it — as a Daily Accommodation Payment instead of a refundable deposit.
 * That is a funding decision with real consequences (a DAP is not refunded to the estate), and calling
 * it "Do Nothing" tells a client the tool recommends inaction when the whole premise is that care must
 * be paid for somehow.
 *
 * Renamed at the DISPLAY layer only. The scenario keeps its internal name because a dozen places
 * identify the baseline by it (`name === 'do nothing'`), and renaming the identity would silently
 * detach the comparison every card is measured against.
 */ const $eb4adc50b37e37f7$var$BASELINE_STRATEGY_DISPLAY_NAME = 'Pay the DAP';
function $eb4adc50b37e37f7$export$1384c6fc4de1c498(name = '') {
    return String(name).replace($eb4adc50b37e37f7$var$FUNDING_ORDER_SUFFIX, '').trim();
}
const $eb4adc50b37e37f7$var$FUNDING_ORDER_SUFFIX = /\s*\((?:Default|(?:Bank|ABP|Shares|Term deposit)(?:\s*(?:->|→)\s*(?:Bank|ABP|Shares|Term deposit))*)\)\s*$/i;
function $eb4adc50b37e37f7$export$d2deef8f2a8f76eb(name = '', radPaidNet = null, roomPrice = null, /** The second room, where both of a couple are in care: the name then says "of each room" — or each room's own share, where what was left could not match the first's. */ secondRoom = null, /** A change of home (8 Oct 2026): "Stay where you are", or "Move — …" with the refund named. */ move = null, /** Leaving a retirement village (8 Oct 2026): the part of the deposit the village money pays, named. */ village = null) {
    const clean = String(name).replace($eb4adc50b37e37f7$var$FUNDING_ORDER_SUFFIX, '').trim();
    if (move?.stayPut || /^stay put\b/i.test(clean)) return 'Stay where you are';
    // Matched on the leading phrase so the suffixes candidates carry — "+ Clear Debt", "+ Pay Down
    // Debt (keep repayments)" — survive the rename and read as what they are: "Pay the DAP + Clear Debt".
    if (/^do nothing\b/i.test(clean)) {
        const baseline = clean.replace(/^do nothing\b/i, $eb4adc50b37e37f7$var$BASELINE_STRATEGY_DISPLAY_NAME);
        // Two rooms, nothing paid up front on either: say so, or "Pay the DAP" reads as one room.
        return secondRoom && secondRoom.roomPrice > 0 ? baseline.replace($eb4adc50b37e37f7$var$BASELINE_STRATEGY_DISPLAY_NAME, `${$eb4adc50b37e37f7$var$BASELINE_STRATEGY_DISPLAY_NAME} on both rooms`) : baseline;
    }
    if (!(radPaidNet != null && radPaidNet > 0)) return clean;
    return clean.replace(/(\d+)(%\s+RAD\b)/i, (_match, pct, rest)=>{
        const shownPct = roomPrice != null && roomPrice > 0 ? Math.round(radPaidNet / roomPrice * 100) : pct;
        if (secondRoom && secondRoom.roomPrice > 0) {
            const secondPct = Math.round(secondRoom.radPaid / secondRoom.roomPrice * 100);
            if (Math.abs(secondPct - Number(shownPct)) <= 1) return `${shownPct}% of each room (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(radPaidNet)} + ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(secondRoom.radPaid)})`;
            const first = secondRoom.leadName ? `${secondRoom.leadName}'s room` : 'the first room';
            const second = secondRoom.name ? `${secondRoom.name}'s` : 'the second';
            return `${shownPct}% of ${first} and ${secondPct}% of ${second} (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(radPaidNet)} + ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(secondRoom.radPaid)})`;
        }
        // "all from …" where that money pays the whole deposit, rather than the same figure twice
        // (owner, 9 Oct 2026: "($750,000, $750,000 of it from the village money)" read oddly).
        const fromSource = (amount, source)=>Math.abs(amount - radPaidNet) < 1 ? `, all from the ${source}` : `, ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(amount))} from the ${source}`;
        const fromRefund = move && move.fromRefund > 0.5 ? fromSource(move.fromRefund, 'refund') : '';
        const fromVillage = village && village.fromVillage > 0.5 ? fromSource(village.fromVillage, 'village money') : '';
        return `${shownPct}${rest} (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(radPaidNet)}${fromRefund}${fromVillage})`;
    }).replace(/^Pay\b/, move ? "Move \u2014 pay" : 'Pay');
}
function $eb4adc50b37e37f7$export$7dd10f1a0b1d65b9(strategyName = '') {
    const match = String(strategyName).match(/Pay\s+(\d+)%\s+RAD/i);
    if (!match) return null;
    const pct = parseInt(match[1], 10);
    return Number.isFinite(pct) ? pct : null;
}
const $eb4adc50b37e37f7$export$3ae7ca46df817469 = 0.10;
function $eb4adc50b37e37f7$export$ad99f664ac5b1922(strategy) {
    if (!strategy) return 0;
    const fundedFromLiquidAssets = Object.values(strategy.radFunding || {}).flatMap((liquidations)=>{
        if (Array.isArray(liquidations)) return liquidations;
        return liquidations ? [
            liquidations
        ] : [];
    }).reduce((sum, item)=>sum + (parseFloat(String(item?.amount)) || 0), 0);
    const fundedFromDownsize = parseFloat(String(strategy?.strategyOptions?.downsizeDetails?.radAllocation)) || 0;
    // Money the engine put to the room that was never in the funding bag: a village's exit payment
    // (8 Oct 2026) and the refund of a current deposit on a change of home. Without these, two
    // "Pay 100% RAD" rows funded mostly by the village money read as $50,000 deposits (owner-caught,
    // 9 Oct 2026: "$50,000 vs $50,000 … paying $0 less").
    const row = strategy;
    const fundedFromVillage = parseFloat(String(row?.villageExit?.fromVillage)) || 0;
    const fundedFromRefund = parseFloat(String(row?.facilityMove?.fromRefund)) || 0;
    return fundedFromLiquidAssets + fundedFromDownsize + fundedFromVillage + fundedFromRefund;
}
function $eb4adc50b37e37f7$export$93ea736db8ac60c(strategy) {
    if (!strategy) return 0;
    const lever = strategy.meansTestStrategy || {};
    const irrevocable = (parseFloat(String(lever.purchaseAmount)) || 0 // annuity — never refundable
    ) + (parseFloat(String(lever.amount)) || 0); // gift or funeral bond — gone, or locked until death
    /*
     * The RAD counts at its RETENTION, not its face value, because that is the part the client does
     * not get back. Five years at 2% is the maximum the provider keeps, so it is the honest measure
     * of what a deposit actually costs in recoverable money — and it stops a refundable deposit
     * being ranked as though it were as final as an annuity.
     */ const radRetention = $eb4adc50b37e37f7$export$ad99f664ac5b1922(strategy) * $eb4adc50b37e37f7$export$3ae7ca46df817469;
    return irrevocable + radRetention;
}
function $eb4adc50b37e37f7$export$9ac41d7814ff2d5c({ strategy: strategy, legacyYears: legacyYears = 5, partnerEntryYear: partnerEntryYear = 3, partnerRoomPrice: partnerRoomPrice = 0, originalEntrantAliveAtEvent: originalEntrantAliveAtEvent = true, baseAgedCareCosts: baseAgedCareCosts = {} }) {
    if (!strategy || !partnerRoomPrice || partnerEntryYear > legacyYears) return null;
    const yearsAffected = Math.max(0, legacyYears - partnerEntryYear + 1);
    if (yearsAffected === 0) return null;
    // First-pass heuristic: infer RAD intent from strategy name so the partner-later
    // overlay stays aligned with baseline strategy behavior without re-running projections.
    const radPct = $eb4adc50b37e37f7$export$7dd10f1a0b1d65b9(strategy.name) ?? 50;
    const targetPartnerRad = partnerRoomPrice * (radPct / 100);
    const targetPartnerDapBase = Math.max(0, partnerRoomPrice - targetPartnerRad);
    const thisStrategyRadPaid = $eb4adc50b37e37f7$export$ad99f664ac5b1922(strategy);
    const yearsSinceInitialAdmission = Math.max(1, partnerEntryYear - 1);
    const retentionYears = Math.min(yearsSinceInitialAdmission, 5);
    const retainedFromInitialRad = thisStrategyRadPaid * (1 - 0.02 * retentionYears);
    const releasedRadFromInitialEntrant = originalEntrantAliveAtEvent ? 0 : Math.max(0, retainedFromInitialRad);
    // If the original entrant has passed before the partner enters, released RAD can be
    // reused and lowers remaining DAP exposure for the second room.
    const partnerDapBaseAfterReuse = Math.max(0, targetPartnerDapBase - releasedRadFromInitialEntrant);
    const basicDailyFee = baseAgedCareCosts?.basicDailyFee || 70;
    const dailyHsc = baseAgedCareCosts?.dailyHSC || 0;
    const dailyNccc = baseAgedCareCosts?.dailyNCCC || 0;
    const dailyExtraServiceFee = baseAgedCareCosts?.dailyExtraServiceFee || 0;
    const dailyTotalFees = basicDailyFee + dailyHsc + dailyNccc + dailyExtraServiceFee;
    const annualDap = partnerDapBaseAfterReuse * (0, $815d7df20c36742b$export$36c4ec5f3f340aef).MPIR;
    const additionalAnnualCareCost = annualDap + dailyTotalFees * 365;
    // Intentionally simple v1 overlay: apply the same annualized cost for each remaining
    // year in the horizon. This is a bounded stress lens, not a full second-life branch.
    const additionalLifecycleCost = additionalAnnualCareCost * yearsAffected;
    const currentLegacy = parseFloat(String(strategy?.snapshot?.legacyValue)) || 0;
    const adjustedLegacy = currentLegacy - additionalLifecycleCost;
    const adjustmentDelta = adjustedLegacy - currentLegacy;
    return {
        baselineLegacy: currentLegacy,
        adjustedLegacy: adjustedLegacy,
        adjustmentDelta: adjustmentDelta,
        assumptions: {
            partnerEntryYear: partnerEntryYear,
            partnerRoomPrice: partnerRoomPrice,
            radPct: radPct,
            originalEntrantAliveAtEvent: originalEntrantAliveAtEvent,
            yearsAffected: yearsAffected,
            additionalAnnualCareCost: additionalAnnualCareCost,
            additionalLifecycleCost: additionalLifecycleCost,
            releasedRadFromInitialEntrant: releasedRadFromInitialEntrant
        }
    };
}
function $eb4adc50b37e37f7$export$6a1157c81203cd19(strategies, bandUsd = 5000) {
    if (!Array.isArray(strategies) || strategies.length === 0) return null;
    let maxLegacy = -Infinity;
    let topStrategy = null;
    for (const s of strategies){
        const L = parseFloat(String(s?.snapshot?.legacyValue)) || 0;
        if (L > maxLegacy) {
            maxLegacy = L;
            topStrategy = s;
        }
    }
    if (!topStrategy || maxLegacy <= 0) return null;
    const threshold = maxLegacy - bandUsd;
    // Only a plan that genuinely pays a SMALLER deposit is a lower-RAD alternative (owner-caught,
    // 9 Oct 2026: "Pay 100% RAD" was offered beside "Pay 100% RAD + $16k funeral bond" as "$750,000 vs
    // $750,000 … paying $0 less" — it tied up less only because it had no bond).
    const topRad = $eb4adc50b37e37f7$export$ad99f664ac5b1922(topStrategy);
    const candidates = strategies.filter((s)=>(parseFloat(String(s?.snapshot?.legacyValue)) || 0) >= threshold && $eb4adc50b37e37f7$export$ad99f664ac5b1922(s) < topRad - 1);
    if (candidates.length === 0) return null;
    /*
     * Ranked on LOCKED CAPITAL, not RAD paid — see estimateLockedCapitalForStrategy. The card exists
     * to offer a plan that ties up less of the client's money for near-identical estate; ranking on
     * the deposit alone let a $500,000 annuity win the slot for "avoiding" a $440,000 refundable one.
     */ let best = null;
    let bestLocked = Infinity;
    let bestLegacy = -Infinity;
    for (const s of candidates){
        const locked = $eb4adc50b37e37f7$export$93ea736db8ac60c(s);
        const leg = parseFloat(String(s?.snapshot?.legacyValue)) || 0;
        if (locked < bestLocked || locked === bestLocked && leg > bestLegacy) {
            bestLocked = locked;
            bestLegacy = leg;
            best = s;
        }
    }
    if (!best || !topStrategy?.name || best.name === topStrategy.name) return null;
    /*
     * And it must genuinely tie up less than the strategy it is offered as an alternative to. Without
     * this the card would still appear when the "alternative" commits MORE of the client's money —
     * which is not an alternative, it is a worse plan with a friendlier label.
     */ if ($eb4adc50b37e37f7$export$93ea736db8ac60c(best) >= $eb4adc50b37e37f7$export$93ea736db8ac60c(topStrategy)) return null;
    return {
        strategy: best,
        maxLegacy: maxLegacy,
        bandUsd: bandUsd,
        topLegacyStrategyName: topStrategy.name
    };
}
const $eb4adc50b37e37f7$export$6628235dfd682022 = {
    estate: (s)=>parseFloat(String(s?.snapshot?.legacyValue)) || 0,
    moved: (s)=>$eb4adc50b37e37f7$export$ad99f664ac5b1922(s) + (parseFloat(String(s?.meansTestStrategy?.purchaseAmount)) || 0) + (parseFloat(String(s?.meansTestStrategy?.amount)) || 0),
    cashflow: (s)=>parseFloat(String(s?.snapshot?.netCashflow)) || 0,
    kinds: (s)=>(0, $203e38d6e6c434f4$export$ebadbd3592b8b5e6)(s)
};




/**
 * Phase 3 — Digital SOA structure appendix (trusts / companies).
 * Spec §10, CLIENT_STRUCTURES_ENTITY_MODELLING_SPEC.md.
 */ 


function $f70ff3a065f941e2$var$prettifyAssetType(typeId) {
    const labels = {
        bankAccounts: 'Bank account',
        termDeposits: 'Term deposit',
        shares: 'Shares / managed funds',
        investmentBonds: 'Investment bond',
        accountBasedPensions: 'Account-based pension',
        investmentProperty: 'Investment property',
        funeralBonds: 'Funeral bond',
        prepaidFuneral: 'Prepaid funeral',
        loansToOthers: 'Money lent to others',
        radPaid: 'RAD paid'
    };
    return labels[typeId] || String(typeId || '').replace(/([A-Z])/g, ' $1').trim();
}
function $f70ff3a065f941e2$var$activeStructures(factFind) {
    return (factFind?.structures || []).filter((s)=>{
        const client = s.apportionmentClient || 0;
        const partner = s.apportionmentPartner || 0;
        return client > 0 || partner > 0;
    });
}
function $f70ff3a065f941e2$var$collectEntityAssetRows(factFind, structures) {
    const rows = [];
    structures.forEach((structure)=>{
        const entityOwn = (0, $1773fcf9595c5c0a$export$66d936c41d42a933)(structure.id ?? '');
        const structureName = structure.name?.trim() || 'Trust or company';
        Object.entries(factFind?.assets || {}).forEach(([assetType, list])=>{
            (list || []).forEach((asset)=>{
                if (asset?.ownership !== entityOwn) return;
                const value = asset.value || 0;
                if (value <= 0) return;
                rows.push({
                    structureName: structureName,
                    assetType: $f70ff3a065f941e2$var$prettifyAssetType(assetType),
                    description: asset.description || $f70ff3a065f941e2$var$prettifyAssetType(assetType),
                    value: value
                });
            });
        });
    });
    return rows.sort((a, b)=>a.structureName.localeCompare(b.structureName) || a.assetType.localeCompare(b.assetType));
}
function $f70ff3a065f941e2$var$radFundingUsesEntityAssets(factFind, radFunding) {
    if (!radFunding || typeof radFunding !== 'object') return false;
    const entries = [];
    Object.entries(radFunding).forEach(([key, value])=>{
        if (key.includes('-') && !Array.isArray(value) && (value === undefined || typeof value !== 'object')) {
            entries.push({
                key: key,
                amount: value
            });
            return;
        }
        const list = Array.isArray(value) ? value : value ? [
            value
        ] : [];
        list.forEach((row)=>{
            if (row?.id != null) entries.push({
                key: key,
                assetId: row.id,
                amount: row.amount
            });
        });
    });
    return entries.some((entry)=>{
        let assetType = entry.key;
        let assetId = entry.assetId;
        if (!assetId) {
            const parsed = (0, $bd80071df75c742b$export$eb5d467aa7d657c6)(entry.key);
            if (!parsed) return false;
            assetType = parsed.assetType;
            assetId = parsed.assetId;
        }
        const located = (0, $bd80071df75c742b$export$f59ccf8b394d8480)(factFind, assetType, assetId);
        return located?.asset && (0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(located.asset.ownership);
    });
}
function $f70ff3a065f941e2$export$5462a443ada0eaef(factFind, selectedStrategy) {
    if (!selectedStrategy) return false;
    if (selectedStrategy.structureFundingIncluded) return true;
    if (selectedStrategy.strategyOptions?.structureFundingIncluded) return true;
    if ($f70ff3a065f941e2$var$radFundingUsesEntityAssets(factFind, selectedStrategy.radFunding)) return true;
    if ($f70ff3a065f941e2$var$radFundingUsesEntityAssets(factFind, selectedStrategy.inputs?.radFunding)) return true;
    const ipDetails = selectedStrategy.strategyOptions?.investmentPropertyDetails || selectedStrategy.investmentPropertyDetails;
    if (selectedStrategy.strategyOptions?.sellInvestmentProperty && ipDetails) {
        const property = (0, $bda3664ae16bcdb0$export$cfdc34b008f59476)(factFind, ipDetails);
        if (property && (0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(property.ownership)) return true;
    }
    return false;
}
function $f70ff3a065f941e2$export$7a9a83c1f9700f91(factFind, options = {}) {
    const structures = $f70ff3a065f941e2$var$activeStructures(factFind);
    if (!structures.length) return null;
    const { selectedStrategy: selectedStrategy, strategySource: strategySource = 'suggestion_engine' } = options;
    const includedInSuggestions = (0, $bd80071df75c742b$export$40bc5139f87a7b00)(factFind);
    const selectedUsedEntityFunding = $f70ff3a065f941e2$export$5462a443ada0eaef(factFind, selectedStrategy);
    let automaticSuggestionsNote;
    if (strategySource === 'manual_control') automaticSuggestionsNote = 'This advice was prepared from <strong>manual control</strong> selections you made explicitly. The suggestion-engine setting for trust or company assets does not restrict manual funding choices.';
    else if (includedInSuggestions) automaticSuggestionsNote = 'In Strategy Analysis Setup you chose to <strong>include</strong> trust or company assets when the suggestion engine ranked automatic funding options (liquid assets and whole investment property sales).';
    else automaticSuggestionsNote = 'In Strategy Analysis Setup you chose <strong>personal assets only</strong> for automatic strategy suggestions (default). Entity arrangements were still included in Age Pension and aged care fee estimates.';
    let selectedStrategyNote;
    if (selectedUsedEntityFunding) selectedStrategyNote = 'Your <strong>selected strategy</strong> modelled funding from trust or company assets (for example entity bank, shares, or a whole entity-owned property sale).';
    else if (strategySource === 'manual_control') selectedStrategyNote = 'Your <strong>selected manual strategy</strong> did not model drawdowns from trust or company asset pools in the funding mix captured for this SOA.';
    else selectedStrategyNote = 'Your <strong>selected strategy</strong> did not model drawdowns from trust or company asset pools in the funding mix captured for this SOA.';
    return {
        structureRows: structures.map((s)=>({
                name: s.name?.trim() || 'Trust or company',
                typeLabel: (0, $1773fcf9595c5c0a$export$378ace8cc3e15f6d)(s.type || ''),
                apportionmentClient: s.apportionmentClient || 0,
                apportionmentPartner: s.apportionmentPartner || 0
            })),
        entityAssetRows: $f70ff3a065f941e2$var$collectEntityAssetRows(factFind, structures),
        suggestionGate: factFind?.structureFundingInSuggestions || 'exclude',
        includedInSuggestions: includedInSuggestions,
        strategySource: strategySource,
        selectedUsedEntityFunding: selectedUsedEntityFunding,
        automaticSuggestionsNote: automaticSuggestionsNote,
        selectedStrategyNote: selectedStrategyNote,
        legalNote: 'Care Companion does not determine whether a trustee or company may sell assets or make distributions. Confirm permissibility under the trust deed, company constitution, tax treatment, and for all owners or beneficiaries before implementation.',
        apportionmentDisclaimer: 'Apportionment percentages are user-supplied for modelling only and are not a Centrelink or ATO determination.'
    };
}
function $f70ff3a065f941e2$export$ef316658362fb04e(appendix, formatMoney) {
    if (!appendix) return '';
    const structureTable = `
<table>
  <thead><tr><th>Structure</th><th>Type</th><th>Client %</th><th>Partner %</th></tr></thead>
  <tbody>
    ${appendix.structureRows.map((row)=>`<tr><td>${row.name}</td><td>${row.typeLabel}</td><td>${row.apportionmentClient}%</td><td>${row.apportionmentPartner}%</td></tr>`).join('')}
  </tbody>
</table>`;
    const assetTable = appendix.entityAssetRows.length > 0 ? `
<div class="h3">Entity-owned assets in fact-find (summary)</div>
<table>
  <thead><tr><th>Structure</th><th>Asset type</th><th>Description</th><th>Value</th></tr></thead>
  <tbody>
    ${appendix.entityAssetRows.map((row)=>`<tr><td>${row.structureName}</td><td>${row.assetType}</td><td>${row.description}</td><td>${formatMoney(row.value)}</td></tr>`).join('')}
  </tbody>
</table>` : '<p class="muted small">No entity-tagged asset balances were recorded in the fact-find at the time of export.</p>';
    return `
<div class="h3">Trusts, companies &amp; related entities</div>
<p class="small muted">${appendix.apportionmentDisclaimer}</p>
${structureTable}
${assetTable}
<div class="callout callout--amber" style="margin-top:14px">
  <p class="callout-title">Suggestion engine &amp; entity funding</p>
  <p>${appendix.automaticSuggestionsNote}</p>
  <p style="margin-bottom:0">${appendix.selectedStrategyNote}</p>
</div>
<p class="small muted" style="margin-top:10px"><strong>Important:</strong> ${appendix.legalNote}</p>`;
}


/**
 * Is the tool still quoting current government figures?
 *
 * `ratesFreshness.test.ts` already fails once `RATES_REVIEW_BY` passes, but that alarm only rings where
 * a DEVELOPER can hear it. If nobody runs the tests for a few weeks the app keeps using the old rates
 * with nothing on screen to say so, and an adviser producing a Statement of Advice on 25 September
 * would quote a superseded Age Pension figure without ever being told.
 *
 * This is the same date read at RUN time, so the person giving the advice sees it too. One source, one
 * date to move: update `RATES_REVIEW_BY` when the tables are refreshed and both the test and this notice
 * go quiet together.
 */ 
/** Local midnight, so the comparison never trips a day early on a timezone east of Greenwich. */ function $d92bca4a6da5b591$var$localDate(iso) {
    const [year, month, day] = iso.split('-').map(Number);
    return new Date(year, month - 1, day);
}
/**
 * Whole days between two LOCAL calendar dates, counted on the calendar rather than in milliseconds.
 *
 * Subtracting timestamps is wrong across a daylight-saving boundary: Australia moves its clocks in
 * early October, so 180 days after a 20 September review date is an hour short of 180 × 86,400,000 and
 * floors to 179. Harmless in a day count, not harmless in the `overdue` test it also drives — that
 * would have shown the warning a day late, or withheld it a day early, twice a year. Reading the
 * calendar components through `Date.UTC` removes the offset entirely.
 */ function $d92bca4a6da5b591$var$wholeDaysBetween(from, to) {
    const asUtcDay = (d)=>Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
    return Math.round((asUtcDay(to) - asUtcDay(from)) / 86400000);
}
function $d92bca4a6da5b591$export$cb9292b5ceca2ab(iso) {
    return $d92bca4a6da5b591$var$localDate(iso).toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });
}
function $d92bca4a6da5b591$export$83e0daeeac89884f(today = new Date()) {
    const reviewBy = (0, $1abe73eeef086faf$export$1559bbb51d90e77a);
    const due = $d92bca4a6da5b591$var$localDate(reviewBy);
    const daysOverdue = $d92bca4a6da5b591$var$wholeDaysBetween(due, today);
    if (daysOverdue <= 0) return {
        overdue: false,
        reviewBy: reviewBy,
        daysOverdue: daysOverdue,
        notice: null
    };
    return {
        overdue: true,
        reviewBy: reviewBy,
        daysOverdue: daysOverdue,
        notice: `Government rates were due to be indexed on ${$d92bca4a6da5b591$export$cb9292b5ceca2ab(reviewBy)}, and these figures have not been ` + `updated since. The Age Pension, aged care and tax amounts shown may be out of date \u{2014} check them against the ` + `current published rates before relying on them. (Age Pension and aged care are indexed 20 March and ` + `20 September; tax thresholds on 1 July; the MPIR quarterly.)`
    };
}


/**
 * The words for a projection period mode, in one place.
 *
 * `projectionPeriodMode` is a real modelling choice, not a display filter: the engine PROJECTS the
 * year it REPORTS, so a calendar-year run opens on 1 January, applies growth there, and strikes its
 * tax, pension and net worth on 31 December (see `engineTypes.ts`). Every surface that describes a
 * projection therefore has to describe the mode the reader actually chose — the projections modal,
 * the Statement of Advice, and the digital SOA that outlives them both.
 *
 * Those three had grown three separate sets of hardcoded "1 July to 30 June" strings, which is how a
 * calendar-year run ends up documented as a financial-year one. This module is the single vocabulary
 * they share, so a document can never name a period the numbers underneath it were not cut on.
 *
 * `'strategy_year'` — the engine's third mode, rolling 12-month bands from the anchor — has no UI and
 * dates nothing, so it is described here only enough to keep callers total.
 */ /** The two modes the UI offers. The engine's `'strategy_year'` is not selectable. */ const $48fd3f316ae581a6$var$FINANCIAL_YEAR = {
    mode: 'financial_year',
    noun: 'financial year',
    nounPlural: 'financial years',
    opensOn: '1 July',
    closesOn: '30 June',
    span: '1 July to 30 June',
    rowLabelExample: 'FY26/27',
    differsFromTaxYear: false
};
const $48fd3f316ae581a6$var$CALENDAR_YEAR = {
    mode: 'calendar_year',
    noun: 'calendar year',
    nounPlural: 'calendar years',
    opensOn: '1 January',
    closesOn: '31 December',
    span: '1 January to 31 December',
    rowLabelExample: '2027',
    differsFromTaxYear: true
};
function $48fd3f316ae581a6$export$f15392dd2f17ee04(mode) {
    return mode === 'calendar_year' ? $48fd3f316ae581a6$var$CALENDAR_YEAR : $48fd3f316ae581a6$var$FINANCIAL_YEAR;
}
function $48fd3f316ae581a6$export$f2e75dede6de26ce(mode) {
    const period = $48fd3f316ae581a6$export$f15392dd2f17ee04(mode);
    const base = `Projections run in ${period.nounPlural} (${period.span}) from today\u{2019}s date, so the first year is a part-year ` + `covering only the days from today to the following ${period.closesOn}.`;
    if (!period.differsFromTaxYear) return base;
    // Only true of the calendar-year mode, and the reason it needs saying: the engine really does
    // assess tax over the period it reports, so a calendar row's tax is a modelling figure and not a
    // number that will ever appear on an ATO assessment.
    return `${base} Australian tax and Centrelink years run 1 July to 30 June, so tax shown on a ` + `calendar-year row is assessed over that calendar year for modelling purposes and will not ` + `match a tax return.`;
}




/**
 * STOCK PHOTOS, SERVED FROM OUR OWN SITE (1 Oct 2026, owner decision).
 *
 * These photos used to load straight from Unsplash's image server, so every page view sent the visitor's
 * internet address to a server in the United States, and the Privacy Policy had to say so. They are
 * now copies bundled with the app (the Unsplash licence allows that), and nothing on a page loads
 * from a third party. Do not add a remote image URL anywhere in the frontend: download it into this
 * folder and add a line below. frontend/tests/noThirdPartyAssets.test.ts enforces both.
 *
 * Generated list: one literal new URL() per file, because Parcel only bundles what it can see.
 */ var $91167cd2f296c69b$exports = {};
$91167cd2f296c69b$exports = import.meta.resolve("j46nz");


var $77f383bd35fe12a9$exports = {};
$77f383bd35fe12a9$exports = import.meta.resolve("knJmJ");


var $43dd11fadb33380f$exports = {};
$43dd11fadb33380f$exports = import.meta.resolve("cKYQe");


var $d7d7d83ac2904b91$exports = {};
$d7d7d83ac2904b91$exports = import.meta.resolve("ga3Kk");


var $16a0d2dbfe977cce$exports = {};
$16a0d2dbfe977cce$exports = import.meta.resolve("03xJB");


var $8e068448c42b84c7$exports = {};
$8e068448c42b84c7$exports = import.meta.resolve("afJ36");


var $cf48cc3af6ab4aa5$exports = {};
$cf48cc3af6ab4aa5$exports = import.meta.resolve("i839B");


var $a5573dd2f367a5ac$exports = {};
$a5573dd2f367a5ac$exports = import.meta.resolve("d6MGp");


var $3b455d3d6f402a4b$exports = {};
$3b455d3d6f402a4b$exports = import.meta.resolve("8KRDa");


var $3261c031c42befff$exports = {};
$3261c031c42befff$exports = import.meta.resolve("Jbnco");


var $68dd9e1464868bff$exports = {};
$68dd9e1464868bff$exports = import.meta.resolve("5VIcu");


var $13574ea65e374bf8$exports = {};
$13574ea65e374bf8$exports = import.meta.resolve("hLtdC");


var $e0fc13b02558f22c$exports = {};
$e0fc13b02558f22c$exports = import.meta.resolve("fTS3s");


var $51e9fe7cc9b1a766$exports = {};
$51e9fe7cc9b1a766$exports = import.meta.resolve("cOHZv");


var $3c7486b5ceb7d056$exports = {};
$3c7486b5ceb7d056$exports = import.meta.resolve("bgw3m");


var $350a4a0490697555$exports = {};
$350a4a0490697555$exports = import.meta.resolve("emAOZ");


var $e4e14d97f43658dd$exports = {};
$e4e14d97f43658dd$exports = import.meta.resolve("5V1o4");


var $5307433d677a3426$exports = {};
$5307433d677a3426$exports = import.meta.resolve("la2KI");


var $5b55ab4c3336fd0e$exports = {};
$5b55ab4c3336fd0e$exports = import.meta.resolve("dX5bJ");


var $fe81a64a6dfff43a$exports = {};
$fe81a64a6dfff43a$exports = import.meta.resolve("k9eHj");


var $36d451bc9aa9a00e$exports = {};
$36d451bc9aa9a00e$exports = import.meta.resolve("7ch02");


var $782aaabbcf2ea4dd$exports = {};
$782aaabbcf2ea4dd$exports = import.meta.resolve("2cO3B");


var $86712fbb49eb4cb1$exports = {};
$86712fbb49eb4cb1$exports = import.meta.resolve("kgqWK");


var $b145444ddb0d0d6b$exports = {};
$b145444ddb0d0d6b$exports = import.meta.resolve("hLsVx");


var $5758262318403da9$exports = {};
$5758262318403da9$exports = import.meta.resolve("4SkZV");


var $750c57fffb05f85e$exports = {};
$750c57fffb05f85e$exports = import.meta.resolve("7gRYE");


var $3869bb7997e6ab39$exports = {};
$3869bb7997e6ab39$exports = import.meta.resolve("xFvyR");


var $433708c3ad6513d9$exports = {};
$433708c3ad6513d9$exports = import.meta.resolve("52ZCq");


var $eb2e4d354b718a37$exports = {};
$eb2e4d354b718a37$exports = import.meta.resolve("LddPj");


var $3e79bc16b6b17658$exports = {};
$3e79bc16b6b17658$exports = import.meta.resolve("4XXxK");


var $d860e3779ef08cf2$exports = {};
$d860e3779ef08cf2$exports = import.meta.resolve("b6gN6");


var $76c6e3aa0e56928a$exports = {};
$76c6e3aa0e56928a$exports = import.meta.resolve("99O1F");


var $85ea88fc4cfadb34$exports = {};
$85ea88fc4cfadb34$exports = import.meta.resolve("jWX0J");


var $fe54a364889ac3b9$exports = {};
$fe54a364889ac3b9$exports = import.meta.resolve("aGMxx");


var $ffb9bb996413c309$exports = {};
$ffb9bb996413c309$exports = import.meta.resolve("53pll");


var $8735df7030d7acc7$exports = {};
$8735df7030d7acc7$exports = import.meta.resolve("4bz5z");


var $82f6744c5017bf18$exports = {};
$82f6744c5017bf18$exports = import.meta.resolve("76Z6Q");


var $cd0f96b414b48a52$exports = {};
$cd0f96b414b48a52$exports = import.meta.resolve("c7LSS");


var $88876749ebc1ec36$exports = {};
$88876749ebc1ec36$exports = import.meta.resolve("ibYjW");


const $5bb9a0b2f90fb898$var$STOCK = {
    '1439066615861-d1af74d74000@1920x1080': new URL($91167cd2f296c69b$exports).href,
    '1441974231531-c6227db76b6e@1920x1080': new URL($77f383bd35fe12a9$exports).href,
    '1450101499163-c8848c66ca85@1200x600': new URL($43dd11fadb33380f$exports).href,
    '1506905925346-21bda4d32df4@1920x1080': new URL($d7d7d83ac2904b91$exports).href,
    '1512917774080-9991f1c4c750@300x200': new URL($16a0d2dbfe977cce$exports).href,
    '1512917774080-9991f1c4c750@600x400': new URL($8e068448c42b84c7$exports).href,
    '1519494026892-80bbd2d6fd0d@800x600': new URL($cf48cc3af6ab4aa5$exports).href,
    '1551836022-aadb801c60ae@640x420': new URL($a5573dd2f367a5ac$exports).href,
    '1554224155-6726b3ff858f@1200x600': new URL($3b455d3d6f402a4b$exports).href,
    '1559027615-cd4628902d4a@300x200': new URL($3261c031c42befff$exports).href,
    '1559027615-cd4628902d4a@600x400': new URL($68dd9e1464868bff$exports).href,
    '1559827260-dc66d52bef19@1920x1080': new URL($13574ea65e374bf8$exports).href,
    '1560184897-ae75f418493e@800x600': new URL($e0fc13b02558f22c$exports).href,
    '1560448204-603b3fc33ddc@300x200': new URL($51e9fe7cc9b1a766$exports).href,
    '1560448204-603b3fc33ddc@600x400': new URL($3c7486b5ceb7d056$exports).href,
    '1560448204-e02f11c3d0e2@300x200': new URL($350a4a0490697555$exports).href,
    '1560448204-e02f11c3d0e2@600x400': new URL($e4e14d97f43658dd$exports).href,
    '1564013799919-ab600027ffc6@300x200': new URL($5307433d677a3426$exports).href,
    '1564013799919-ab600027ffc6@600x400': new URL($5b55ab4c3336fd0e$exports).href,
    '1571896349842-33c89424de2d@300x200': new URL($fe81a64a6dfff43a$exports).href,
    '1571896349842-33c89424de2d@600x400': new URL($36d451bc9aa9a00e$exports).href,
    '1579621970563-ebec7560ff3e@1200x600': new URL($782aaabbcf2ea4dd$exports).href,
    '1582407947304-fd86f028f716@300x200': new URL($86712fbb49eb4cb1$exports).href,
    '1582407947304-fd86f028f716@600x400': new URL($b145444ddb0d0d6b$exports).href,
    '1586023492125-27b2c045efd7@300x200': new URL($5758262318403da9$exports).href,
    '1586023492125-27b2c045efd7@600x400': new URL($750c57fffb05f85e$exports).href,
    '1595885914073-3af381bbee7e@1920x1080': new URL($3869bb7997e6ab39$exports).href,
    '1600585154340-be6161a56a0c@800x600': new URL($433708c3ad6513d9$exports).href,
    '1636893580433-5ac59809bb13@1920x1080': new URL($eb2e4d354b718a37$exports).href,
    '1641232458416-feace752b346@800x600': new URL($3e79bc16b6b17658$exports).href,
    '1658632302217-984d432b4d38@640x420': new URL($d860e3779ef08cf2$exports).href,
    '1662189793032-ccb6135a9159@1920x1080': new URL($76c6e3aa0e56928a$exports).href,
    '1664463760781-f159dfe3af30@640x420': new URL($85ea88fc4cfadb34$exports).href,
    '1683041132892-0fe990b3afc3@1920x1080': new URL($fe54a364889ac3b9$exports).href,
    '1683041133891-613b76cbebc7@1920x1080': new URL($ffb9bb996413c309$exports).href,
    '1717964134799-a98f497172a5@1920x1080': new URL($8735df7030d7acc7$exports).href,
    '1741651366517-cf81c7de3868@640x420': new URL($82f6744c5017bf18$exports).href,
    '1758686253708-f0e21317d2aa@1200x600': new URL($cd0f96b414b48a52$exports).href,
    '1776894873397-78ce93defb29@1920x1080': new URL($88876749ebc1ec36$exports).href
};
function $5bb9a0b2f90fb898$export$260036ae09c24358(id, width, height) {
    const url = $5bb9a0b2f90fb898$var$STOCK[`${id}@${width}x${height}`];
    if (!url) throw new Error(`Stock photo ${id} at ${width}x${height} is not bundled \u{2014} add it to src/assets/stock`);
    return url;
}


/**
 * THE STATEMENT OF ADVICE FOR THE MODULES THAT HAD NONE (owner, 2 Oct 2026): retirement village,
 * downsizer, granny flat, and cashflow & pension.
 *
 * ONE DOCUMENT, FOUR MODULES. The aged care Statement of Advice is the format the owner wants kept
 * ("easy to read and follow a similar format"): a cover, a booklet read one section at a time, the
 * same stylesheet and the same navigation script. This file is that booklet with the aged-care-only
 * pages taken out and the module-specific page made a parameter. Each module hands over a
 * `ModuleSoaSnapshot` — plain data, frozen at generation, including the licensee attribution — and
 * `buildModuleSoaHtml` renders it. A snapshot is stored with the advice record and re-rendered later
 * by the licensee view, so nothing here may depend on who is signed in at render time.
 *
 * WHAT THE CORPORATIONS ACT ASKS OF A STATEMENT OF ADVICE (s947B for a licensee, s947C for an
 * authorised representative; RG 175 on clear, concise and effective), and where each lives here:
 *   - a statement setting out the advice ............................. "What we recommend"
 *   - the basis on which it is given: the client's objectives, financial
 *     situation and needs, and the information relied on ............ "Your situation today",
 *                                                                       "Why this advice fits you", appendix
 *   - a warning where that information may be incomplete or inaccurate
 *     (s961H) ........................................................ "Your situation today", "Risks & limitations"
 *   - the name and contact details of the providing entity and, for a
 *     representative, the authorising licensee ...................... cover, "Fees & disclosures"
 *   - remuneration, commissions and other benefits .................. "Fees & disclosures"
 *   - associations or relationships that might influence the advice . "Fees & disclosures"
 *   - where one financial product is replaced by another (s947D): the
 *     charges, the consequences and any benefits lost ............... "If this advice replaces one
 *                                                                       investment with another"
 *   - the risks of the recommendation (RG 175, best interests) ...... "What could go wrong", "Risks & limitations"
 *
 * THE LOOK AND THE SHARED PIECES (3 Oct 2026) live in soaKit.ts — the theme without pastel fills,
 * "Your situation today", the projection charts, the sortable comparison, the contents list and
 * the rates appendix — so the aged care and Support at Home documents draw on the same pieces.
 *
 * THE CONSUMER HAT. The reader is the client, not an adviser. So the executive summary says the
 * recommendation in one line and shows the three numbers that matter against staying put; every
 * part of the plan is named in everyday words with what it does; the risks are the same bold-claim-
 * plus-one-sentence list the card showed; and anything technical sits in the appendix.
 */ 





/**
 * ProjectionsModal.tsx – 5-year projections for aged care strategy: an accordion of charts
 * (cashflow, net worth, debt) over a table of net worth, pension, care costs and cashflow.
 * Used by AgedCareAnalyser (in App.js). Props: onClose, projections, agedCareCosts, strategy, factFind, initialFinancials, currentFinancials, onPeriodModeChange, isReloading.
 *
 * Two toggles sit in the header, and BOTH are the modal's own sticky state — remembered per device
 * in projectionsModalPreferences, not passed in, so they survive closing the modal and reloading the
 * app. "Future / today's dollars" is purely presentational: the modal deflates the rows it already
 * has. "Financial year / calendar year" is not — the rows themselves are cut differently (and the
 * engine runs its plugin phases in a different order), so flipping it tells the owner to re-run the
 * projection and shows an hourglass over the charts and table until the new rows land.
 */ 

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7979593adeba180b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const $7979593adeba180b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-right", $7979593adeba180b$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8796e625a2ec43cf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 22h14",
            key: "ehvnwv"
        }
    ],
    [
        "path",
        {
            d: "M5 2h14",
            key: "pdyrp9"
        }
    ],
    [
        "path",
        {
            d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22",
            key: "1d314k"
        }
    ],
    [
        "path",
        {
            d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2",
            key: "1vvvr6"
        }
    ]
];
const $8796e625a2ec43cf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("hourglass", $8796e625a2ec43cf$export$3efd853dbb351e94);





/**
 * ProjectionChartsAccordion.tsx – the three charts at the top of the year-by-year window: money in and out,
 * what they own, what they owe.
 *
 * A three-way chooser above ONE chart (owner-approved mock-up, 25 Oct 2026). It replaced three tall blue strips
 * with their labels set upright down the side, which took a quarter of the width on a phone and read as
 * CASHFLOW / NET WORTH / DEBT — words a family member has to translate. The chooser gives the chart its width
 * back and says what each chart is in plain words.
 *
 * The chooser's choice can be held by the window (`pane` + `onPaneChange`) so the window's own heading can name
 * the chart on show; left alone, it holds its own.
 *
 * One chart is mounted at a time: each measures its own container to lay itself out, so one rendered inside a
 * hidden box would measure zero width and never re-measure. The three are three configurations of one component
 * (ProjectionChart): same zoom/pan, hover tooltips and legend toggles in each.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * ProjectionChart.tsx – the stacked-bar chart behind every pane of the Yearly Projections modal's
 * chart accordion (cashflow, net worth, debt).
 *
 * One chart, configured three ways: a stack of series per projected year, optionally a dotted
 * reference level held across the chart (cashflow's total expenses, net worth's after-debt figure)
 * and — where a `gap` is configured and the bars fall short of that line — a solid red block
 * bridging them. Zoom/pan along the year axis, a hover/focus tooltip breaking the year down, and a
 * legend whose entries switch series off (the y-axis then animates to its new scale).
 *
 * Hand-rolled SVG rather than a charting dependency: the app ships no chart library, and the
 * behaviour here (stack + reference line + gap fill + animated rescale) is a short amount of
 * geometry. Everything is inspectable DOM, which is also what lets agedCare.ui.flow.test.ts assert
 * on the marks rather than on a screenshot.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c6e669e1fd7e7ff8$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
            key: "1357e3"
        }
    ],
    [
        "path",
        {
            d: "M3 3v5h5",
            key: "1xhq8a"
        }
    ]
];
const $c6e669e1fd7e7ff8$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("rotate-ccw", $c6e669e1fd7e7ff8$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c082792a8b35a18c$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ],
    [
        "line",
        {
            x1: "21",
            x2: "16.65",
            y1: "21",
            y2: "16.65",
            key: "13gj7c"
        }
    ],
    [
        "line",
        {
            x1: "11",
            x2: "11",
            y1: "8",
            y2: "14",
            key: "1vmskp"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "14",
            y1: "11",
            y2: "11",
            key: "durymu"
        }
    ]
];
const $c082792a8b35a18c$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("zoom-in", $c082792a8b35a18c$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f7faf703d6528e5f$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ],
    [
        "line",
        {
            x1: "21",
            x2: "16.65",
            y1: "21",
            y2: "16.65",
            key: "13gj7c"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "14",
            y1: "11",
            y2: "11",
            key: "durymu"
        }
    ]
];
const $f7faf703d6528e5f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("zoom-out", $f7faf703d6528e5f$export$3efd853dbb351e94);


/**
 * chartTypes.ts – the data shape ProjectionChart draws, plus the categorical palette its series
 * are coloured from.
 *
 * One shape serves every pane of the projections modal's chart accordion (cashflow, net worth,
 * debt): a stack of series per year, an optional dotted reference level, and the tooltip detail
 * that sits behind figures the bars only total. Feature modules build these points from projection
 * rows (see features/agedCare/cashflowChartData.ts and balanceSheetChartData.ts); the chart itself
 * knows nothing about aged care.
 */ /** A stacked series. Ids are stable — the legend's on/off state and the chart's test hooks key off them. */ const $c7535f09b538739e$export$d991bcf562d2c0dd = [
    '#2a78d6',
    '#eb6834',
    '#1baf7a',
    '#eda100',
    '#e87ba4',
    '#008300',
    '#4a3aa7'
];
const $c7535f09b538739e$export$1acaf3d3ebfae0b4 = '#d03b3b';
function $c7535f09b538739e$export$b6af5a1f1fe57e89(point, series, enabled) {
    return series.reduce((sum, entry)=>enabled(entry.id) ? sum + (point.values[entry.id] || 0) : sum, 0);
}
function $c7535f09b538739e$export$48b6af00fdba8642(point, factor) {
    if (factor === 1) return point;
    const values = {};
    Object.keys(point.values).forEach((key)=>{
        values[key] = point.values[key] * factor;
    });
    return {
        ...point,
        values: values,
        reference: point.reference == null ? undefined : point.reference * factor,
        sections: point.sections?.map((section)=>({
                ...section,
                lines: section.lines.map((line)=>({
                        ...line,
                        value: line.value * factor
                    })),
                total: section.total ? {
                    ...section.total,
                    value: section.total.value * factor
                } : undefined
            })),
        summary: point.summary ? {
            ...point.summary,
            value: point.summary.value * factor
        } : undefined
    };
}


/** Chart chrome — recessive by design, so the bars are the only loud thing. */ const $e112e69924d514a5$var$SURFACE = '#ffffff';
const $e112e69924d514a5$var$INK_PRIMARY = '#0b0b0b';
const $e112e69924d514a5$var$INK_MUTED = '#898781';
const $e112e69924d514a5$var$GRIDLINE = '#e1e0d9';
const $e112e69924d514a5$var$BASELINE = '#c3c2b7';
const $e112e69924d514a5$var$MARGIN = {
    top: 16,
    right: 16,
    bottom: 40,
    left: 72
};
/**
 * Plot height, chosen from the viewport so a short window doesn't leave the projections table with
 * no room below the chart. Both bounds are deliberate: below the floor the bars stop being readable,
 * above the ceiling a tall window just gives the chart more height than it has data to fill.
 */ const $e112e69924d514a5$var$PLOT_HEIGHT_MAX = 260;
const $e112e69924d514a5$var$PLOT_HEIGHT_MIN = 150;
const $e112e69924d514a5$var$PLOT_HEIGHT_VIEWPORT_FRACTION = 0.3;
/** Bars are capped rather than filling their band — the leftover band is deliberate air. */ const $e112e69924d514a5$var$MAX_BAR_WIDTH = 24;
const $e112e69924d514a5$var$MAX_ZOOM = 8;
/** Tooltip width, narrowed to the plot when the chart itself is smaller than this. */ const $e112e69924d514a5$var$MAX_TOOLTIP_WIDTH = 288;
/**
 * One row of the legend (its content plus padding), which the empty state stands in for so a chart
 * with nothing to draw still fills the height its siblings would — switching accordion panes should
 * not make the modal jump. Approximate by nature: a legend with enough series wraps to two rows.
 */ const $e112e69924d514a5$var$LEGEND_ROW_HEIGHT = 41;
/** The plot wrapper's own bottom padding, which the empty state matches for the same reason. */ const $e112e69924d514a5$var$PLOT_PADDING_BOTTOM = 4;
/**
 * A dollars axis whose ticks land on clean numbers: a step of 1 / 2 / 2.5 / 5 × a power of ten,
 * with the top a whole number of those steps above zero.
 */ function $e112e69924d514a5$var$niceScale(peak, tickCount = 4) {
    if (!Number.isFinite(peak) || peak <= 0) return {
        max: 1000,
        ticks: [
            0,
            250,
            500,
            750,
            1000
        ]
    };
    const magnitude = Math.pow(10, Math.floor(Math.log10(peak / tickCount)));
    const normalised = peak / tickCount / magnitude;
    const step = (normalised <= 1 ? 1 : normalised <= 2 ? 2 : normalised <= 2.5 ? 2.5 : normalised <= 5 ? 5 : 10) * magnitude;
    const max = step * Math.ceil(peak / step);
    const ticks = [];
    for(let value = 0; value <= max + step / 2; value += step)ticks.push(value);
    return {
        max: max,
        ticks: ticks
    };
}
/** Compact axis tick text — the tooltip and the table below carry the exact figures. */ function $e112e69924d514a5$var$formatTick(value) {
    const abs = Math.abs(value);
    const compact = (divisor, suffix)=>{
        const scaled = value / divisor;
        return `$${Number.isInteger(scaled) ? scaled : scaled.toFixed(1)}${suffix}`;
    };
    if (abs >= 1000000) return compact(1000000, 'm');
    if (abs >= 1000) return compact(1000, 'k');
    return `$${Math.round(value)}`;
}
/** A bar segment: square where it meets the segment below, 4px rounded where it caps the stack. */ function $e112e69924d514a5$var$segmentPath(x, y, width, height, roundTop) {
    const r = roundTop ? Math.max(0, Math.min(4, width / 2, height)) : 0;
    if (r === 0) return `M${x},${y} h${width} v${height} h${-width} Z`;
    return `M${x},${y + height} L${x},${y + r} Q${x},${y} ${x + r},${y} L${x + width - r},${y} Q${x + width},${y} ${x + width},${y + r} L${x + width},${y + height} Z`;
}
function $e112e69924d514a5$var$clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}
const $e112e69924d514a5$var$prefersReducedMotion = ()=>typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
/**
 * Ease a map of numbers toward `targets`, one rAF loop for the whole map. Drives both the per-series
 * on/off weights and the y-axis top, so a legend toggle shrinks the hidden segment and rescales the
 * axis as a single coherent movement. Honours `prefers-reduced-motion` by jumping straight there.
 */ function $e112e69924d514a5$var$useTween(targets, duration = 450) {
    const [values, setValues] = (0, $acw62.useState)(targets);
    const currentRef = (0, $acw62.useRef)(targets);
    const frameRef = (0, $acw62.useRef)(0);
    // Value-based dependency: `targets` is rebuilt every render, so using its identity would restart
    // the tween on every frame it triggers.
    const targetKey = Object.keys(targets).sort().map((key)=>`${key}:${targets[key]}`).join('|');
    (0, $acw62.useEffect)(()=>{
        if ($e112e69924d514a5$var$prefersReducedMotion()) {
            cancelAnimationFrame(frameRef.current);
            currentRef.current = targets;
            setValues(targets);
            return;
        }
        const from = {
            ...currentRef.current
        };
        const startedAt = performance.now();
        const step = (now)=>{
            const t = $e112e69924d514a5$var$clamp((now - startedAt) / duration, 0, 1);
            const eased = 1 - Math.pow(1 - t, 3);
            const next = {};
            Object.keys(targets).forEach((key)=>{
                const origin = from[key] ?? targets[key];
                next[key] = origin + (targets[key] - origin) * eased;
            });
            currentRef.current = next;
            setValues(next);
            if (t < 1) frameRef.current = requestAnimationFrame(step);
        };
        cancelAnimationFrame(frameRef.current);
        frameRef.current = requestAnimationFrame(step);
        return ()=>cancelAnimationFrame(frameRef.current);
    // `targets` is deliberately excluded — `targetKey` is its value-equality stand-in.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        targetKey,
        duration
    ]);
    return values;
}
const $e112e69924d514a5$var$ProjectionChart = ({ chartId: chartId, name: name, title: title, subtitle: subtitle, ariaDescription: ariaDescription, points: points, series: configuredSeries, stackLabel: stackLabel, stackTotalLabel: stackTotalLabel, yAxisLabel: yAxisLabel, xAxisLabel: xAxisLabel, reference: reference, formatValue: formatValue, emptyMessage: emptyMessage })=>{
    const containerRef = (0, $acw62.useRef)(null);
    const svgRef = (0, $acw62.useRef)(null);
    const [width, setWidth] = (0, $acw62.useState)(0);
    const [viewportHeight, setViewportHeight] = (0, $acw62.useState)(()=>typeof window === 'undefined' ? 900 : window.innerHeight);
    const [hiddenSeries, setHiddenSeries] = (0, $acw62.useState)({});
    const [zoom, setZoom] = (0, $acw62.useState)(1);
    const [pan, setPan] = (0, $acw62.useState)(0);
    const [dragging, setDragging] = (0, $acw62.useState)(false);
    const [hover, setHover] = (0, $acw62.useState)(null);
    const dragRef = (0, $acw62.useRef)(null);
    const isEnabled = (0, $acw62.useCallback)((id)=>!hiddenSeries[id], [
        hiddenSeries
    ]);
    // A series that is zero in every year is a category this client simply doesn't have (no salary,
    // no credit cards). Dropping it keeps the legend to what's actually on screen — the configured
    // list is the full vocabulary, not a promise to show every word of it.
    const series = (0, $acw62.useMemo)(()=>configuredSeries.filter((entry)=>points.some((point)=>(point.values[entry.id] || 0) > 0)), [
        configuredSeries,
        points
    ]);
    // --- Scales -------------------------------------------------------------------------------
    const innerWidth = Math.max(0, width - $e112e69924d514a5$var$MARGIN.left - $e112e69924d514a5$var$MARGIN.right);
    const contentWidth = innerWidth * zoom;
    const bandWidth = points.length > 0 ? contentWidth / points.length : 0;
    const barWidth = Math.min($e112e69924d514a5$var$MAX_BAR_WIDTH, bandWidth * 0.55);
    const plotHeight = $e112e69924d514a5$var$clamp(Math.round(viewportHeight * $e112e69924d514a5$var$PLOT_HEIGHT_VIEWPORT_FRACTION), $e112e69924d514a5$var$PLOT_HEIGHT_MIN, $e112e69924d514a5$var$PLOT_HEIGHT_MAX);
    const plotBottom = $e112e69924d514a5$var$MARGIN.top + plotHeight;
    const pannable = contentWidth > innerWidth + 0.5;
    const minPan = Math.min(0, innerWidth - contentWidth);
    // The axis top spans EVERY year, not just the visible ones, so panning never rescales y — only a
    // legend toggle does, which is what makes that rescale legible as an animation.
    // Only a reference the chart actually DRAWS gets a say in the axis top: a point may carry one
    // for its tooltip while the chart is configured without a line (net worth's figure sits under
    // its own bars, so making room for it would only add air).
    const scale = (0, $acw62.useMemo)(()=>$e112e69924d514a5$var$niceScale(points.reduce((max, point)=>Math.max(max, (0, $c7535f09b538739e$export$b6af5a1f1fe57e89)(point, series, isEnabled), reference ? point.reference ?? 0 : 0), 0)), [
        points,
        series,
        isEnabled,
        reference
    ]);
    const targetYMax = scale.max;
    const tweenTargets = (0, $acw62.useMemo)(()=>{
        const targets = {
            yMax: targetYMax
        };
        series.forEach((entry)=>{
            targets[entry.id] = isEnabled(entry.id) ? 1 : 0;
        });
        return targets;
    }, [
        targetYMax,
        series,
        isEnabled
    ]);
    const tweened = $e112e69924d514a5$var$useTween(tweenTargets);
    const yMax = Math.max(1, tweened.yMax ?? targetYMax);
    const weightOf = (id)=>$e112e69924d514a5$var$clamp(tweened[id] ?? 1, 0, 1);
    const yFor = (value)=>plotBottom - value / yMax * plotHeight;
    const bandLeft = (index)=>$e112e69924d514a5$var$MARGIN.left + pan + index * bandWidth;
    const isBandVisible = (index)=>bandLeft(index) + bandWidth >= $e112e69924d514a5$var$MARGIN.left && bandLeft(index) <= $e112e69924d514a5$var$MARGIN.left + innerWidth;
    // Tick VALUES come from the settled scale so the labels stay clean; their POSITIONS use the
    // tweened axis top, so the gridlines slide into place with the bars.
    const ticks = scale.ticks;
    // --- Sizing -------------------------------------------------------------------------------
    // Width tracks the container (which the modal sizes), height tracks the viewport. Between them
    // the chart re-lays-out on any window resize rather than being drawn once at its opening size.
    (0, $acw62.useLayoutEffect)(()=>{
        const element = containerRef.current;
        if (!element) return;
        setWidth(element.clientWidth);
        if (typeof ResizeObserver === 'undefined') return;
        const observer = new ResizeObserver((entries)=>setWidth(entries[0].contentRect.width));
        observer.observe(element);
        return ()=>observer.disconnect();
    }, []);
    (0, $acw62.useEffect)(()=>{
        const onResize = ()=>setViewportHeight(window.innerHeight);
        window.addEventListener('resize', onResize);
        return ()=>window.removeEventListener('resize', onResize);
    }, []);
    // Re-clamp the pan whenever zoom or available width changes, so bars can never be left stranded
    // outside the plot area.
    (0, $acw62.useEffect)(()=>{
        setPan((current)=>$e112e69924d514a5$var$clamp(current, minPan, 0));
    }, [
        minPan
    ]);
    // --- Zoom & pan ---------------------------------------------------------------------------
    /** Zoom about a point (in inner-plot px), keeping the year under that point fixed. */ const zoomAbout = (0, $acw62.useCallback)((factor, anchorX)=>{
        const nextZoom = $e112e69924d514a5$var$clamp(zoom * factor, 1, $e112e69924d514a5$var$MAX_ZOOM);
        if (nextZoom === zoom) return;
        const nextContent = innerWidth * nextZoom;
        const dataFraction = contentWidth > 0 ? (anchorX - pan) / contentWidth : 0;
        setZoom(nextZoom);
        setPan($e112e69924d514a5$var$clamp(anchorX - dataFraction * nextContent, Math.min(0, innerWidth - nextContent), 0));
    }, [
        zoom,
        pan,
        innerWidth,
        contentWidth
    ]);
    // Attached natively: React registers onWheel passively, so it cannot preventDefault — and without
    // that the modal scrolls behind the chart while the reader is zooming it.
    (0, $acw62.useEffect)(()=>{
        const svg = svgRef.current;
        if (!svg) return;
        const onWheel = (event)=>{
            if (innerWidth <= 0) return;
            event.preventDefault();
            const rect = svg.getBoundingClientRect();
            zoomAbout(event.deltaY < 0 ? 1.15 : 1 / 1.15, event.clientX - rect.left - $e112e69924d514a5$var$MARGIN.left);
        };
        svg.addEventListener('wheel', onWheel, {
            passive: false
        });
        return ()=>svg.removeEventListener('wheel', onWheel);
    }, [
        zoomAbout,
        innerWidth
    ]);
    const handlePointerDown = (event)=>{
        if (event.button !== 0 || !pannable) return;
        dragRef.current = {
            pointerId: event.pointerId,
            startX: event.clientX,
            startPan: pan
        };
        setDragging(true);
        setHover(null);
        event.currentTarget.setPointerCapture(event.pointerId);
    };
    const handlePointerMove = (event)=>{
        const drag = dragRef.current;
        if (drag && drag.pointerId === event.pointerId) {
            setPan($e112e69924d514a5$var$clamp(drag.startPan + (event.clientX - drag.startX), minPan, 0));
            return;
        }
        if (bandWidth <= 0) return;
        const rect = event.currentTarget.getBoundingClientRect();
        const localX = event.clientX - rect.left;
        const index = Math.floor((localX - $e112e69924d514a5$var$MARGIN.left - pan) / bandWidth);
        if (index < 0 || index >= points.length || localX < $e112e69924d514a5$var$MARGIN.left || localX > $e112e69924d514a5$var$MARGIN.left + innerWidth) {
            setHover(null);
            return;
        }
        setHover({
            index: index,
            x: localX,
            y: event.clientY - rect.top
        });
    };
    const endDrag = (event)=>{
        const drag = dragRef.current;
        if (!drag || drag.pointerId !== event.pointerId) return;
        dragRef.current = null;
        setDragging(false);
        if (event.currentTarget.hasPointerCapture(event.pointerId)) event.currentTarget.releasePointerCapture(event.pointerId);
    };
    const resetView = ()=>{
        setZoom(1);
        setPan(0);
    };
    const toggleSeries = (id)=>setHiddenSeries((current)=>({
                ...current,
                [id]: !current[id]
            }));
    // --- Hover readout ------------------------------------------------------------------------
    const hoveredPoint = hover ? points[hover.index] : null;
    const hoveredTotal = hoveredPoint ? (0, $c7535f09b538739e$export$b6af5a1f1fe57e89)(hoveredPoint, series, isEnabled) : 0;
    /** Only meaningful where `reference.gap` is configured: how far the stack falls short of the line. */ const hoveredGap = hoveredPoint ? (hoveredPoint.reference ?? 0) - hoveredTotal : 0;
    // A configured gap OWNS the summary line: it moves with the legend, so it can only be derived
    // here. Charts without one fall back to whatever summary their data carries.
    const hoveredSummary = reference?.gap ? {
        label: hoveredGap > 0 ? reference.gap.label : reference.gap.clearedLabel,
        value: Math.abs(hoveredGap),
        tone: hoveredGap > 0 ? 'negative' : 'positive'
    } : hoveredPoint?.summary;
    /** One-line summary used for the band's accessible name — the keyboard equivalent of the tooltip. */ const describePoint = (point)=>{
        const total = (0, $c7535f09b538739e$export$b6af5a1f1fe57e89)(point, series, isEnabled);
        const parts = [
            `${stackTotalLabel} ${formatValue(total)}`
        ];
        if (reference) {
            parts.push(`${reference.label} ${formatValue(point.reference ?? 0)}`);
            if (reference.gap) {
                const gap = (point.reference ?? 0) - total;
                parts.push(`${gap > 0 ? reference.gap.label : reference.gap.clearedLabel} ${formatValue(Math.abs(gap))}`);
            }
        }
        if (point.summary && !reference?.gap) parts.push(`${point.summary.label} ${formatValue(point.summary.value)}`);
        return `${point.fullLabel}: ${parts.join(', ')}`;
    };
    if (points.length === 0) return null;
    const svgHeight = $e112e69924d514a5$var$MARGIN.top + plotHeight + $e112e69924d514a5$var$MARGIN.bottom;
    const tooltipWidth = Math.min($e112e69924d514a5$var$MAX_TOOLTIP_WIDTH, width || $e112e69924d514a5$var$MAX_TOOLTIP_WIDTH);
    const clipId = `${chartId}-chart-plot-clip`;
    const xAxisClipId = `${chartId}-chart-xaxis-clip`;
    // Nothing to draw at all (a client with no debt, say): axes and a legend would only frame an
    // empty plot, so say so in words instead — at the height they would have taken.
    const hasData = points.some((point)=>series.some((entry)=>(point.values[entry.id] || 0) > 0) || (reference ? (point.reference ?? 0) > 0 : false));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-start justify-between gap-2 px-4 pt-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                className: "text-sm font-semibold text-slate-800",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-xs text-slate-500",
                                children: hasData ? `${subtitle} Scroll to zoom; drag to pan once zoomed in.` : subtitle
                            })
                        ]
                    }),
                    hasData ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>zoomAbout(1 / 1.4, innerWidth / 2),
                                disabled: zoom <= 1,
                                className: "rounded-md p-1.5 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-800 disabled:opacity-40 disabled:hover:bg-transparent",
                                "aria-label": `Zoom out of ${name} chart`,
                                title: "Zoom out",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7faf703d6528e5f$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4",
                                    "aria-hidden": true
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>zoomAbout(1.4, innerWidth / 2),
                                disabled: zoom >= $e112e69924d514a5$var$MAX_ZOOM,
                                className: "rounded-md p-1.5 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-800 disabled:opacity-40 disabled:hover:bg-transparent",
                                "aria-label": `Zoom in to ${name} chart`,
                                title: "Zoom in",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c082792a8b35a18c$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4",
                                    "aria-hidden": true
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: resetView,
                                disabled: zoom === 1 && pan === 0,
                                className: "rounded-md p-1.5 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-800 disabled:opacity-40 disabled:hover:bg-transparent",
                                "aria-label": `Reset ${name} chart zoom`,
                                title: "Reset zoom",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6e669e1fd7e7ff8$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4",
                                    "aria-hidden": true
                                })
                            })
                        ]
                    }) : null
                ]
            }),
            !hasData ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex items-center justify-center px-4",
                style: {
                    height: svgHeight + $e112e69924d514a5$var$PLOT_PADDING_BOTTOM + $e112e69924d514a5$var$LEGEND_ROW_HEIGHT
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-center text-sm text-slate-500",
                    "data-testid": `${chartId}-empty`,
                    children: emptyMessage
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "px-4 pb-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            ref: containerRef,
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                    ref: svgRef,
                                    width: width || undefined,
                                    height: svgHeight,
                                    role: "group",
                                    "aria-label": `${title}: ${ariaDescription}`,
                                    className: `touch-none select-none ${pannable ? dragging ? 'cursor-grabbing' : 'cursor-grab' : ''}`,
                                    onPointerDown: handlePointerDown,
                                    onPointerMove: handlePointerMove,
                                    onPointerUp: endDrag,
                                    onPointerCancel: endDrag,
                                    onPointerLeave: (event)=>{
                                        endDrag(event);
                                        setHover(null);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("defs", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                                                    id: clipId,
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                        x: $e112e69924d514a5$var$MARGIN.left,
                                                        y: $e112e69924d514a5$var$MARGIN.top - 8,
                                                        width: innerWidth,
                                                        height: plotHeight + 8
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                                                    id: xAxisClipId,
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                        x: $e112e69924d514a5$var$MARGIN.left,
                                                        y: plotBottom,
                                                        width: innerWidth,
                                                        height: $e112e69924d514a5$var$MARGIN.bottom
                                                    })
                                                })
                                            ]
                                        }),
                                        ticks.map((tick)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                                        x1: $e112e69924d514a5$var$MARGIN.left,
                                                        x2: $e112e69924d514a5$var$MARGIN.left + innerWidth,
                                                        y1: yFor(tick),
                                                        y2: yFor(tick),
                                                        stroke: tick === 0 ? $e112e69924d514a5$var$BASELINE : $e112e69924d514a5$var$GRIDLINE,
                                                        strokeWidth: 1
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                                        x: $e112e69924d514a5$var$MARGIN.left - 10,
                                                        y: yFor(tick) + 4,
                                                        textAnchor: "end",
                                                        fontSize: 11,
                                                        fill: $e112e69924d514a5$var$INK_MUTED,
                                                        "data-testid": `${chartId}-y-tick`,
                                                        style: {
                                                            fontVariantNumeric: 'tabular-nums'
                                                        },
                                                        children: $e112e69924d514a5$var$formatTick(tick)
                                                    })
                                                ]
                                            }, `tick-${tick}`)),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                            x: 14,
                                            y: $e112e69924d514a5$var$MARGIN.top + plotHeight / 2,
                                            fontSize: 11,
                                            fill: $e112e69924d514a5$var$INK_MUTED,
                                            textAnchor: "middle",
                                            transform: `rotate(-90 14 ${$e112e69924d514a5$var$MARGIN.top + plotHeight / 2})`,
                                            children: yAxisLabel
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                            clipPath: `url(#${clipId})`,
                                            children: [
                                                points.map((point, index)=>{
                                                    if (!isBandVisible(index)) return null;
                                                    const barX = bandLeft(index) + (bandWidth - barWidth) / 2;
                                                    const drawn = series.map((entry)=>({
                                                            entry: entry,
                                                            value: (point.values[entry.id] || 0) * weightOf(entry.id)
                                                        })).filter((slot)=>slot.value > 0);
                                                    const total = drawn.reduce((sum, slot)=>sum + slot.value, 0);
                                                    const gap = reference?.gap ? Math.max(0, (point.reference ?? 0) - total) : 0;
                                                    const topSlotIndex = drawn.length - 1;
                                                    let cumulative = 0;
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                                        children: [
                                                            drawn.map(({ entry: entry, value: value }, drawnIndex)=>{
                                                                const top = yFor(cumulative + value);
                                                                const bottom = yFor(cumulative);
                                                                // Segments butt together — the colour change is the divider, so the stack
                                                                // reads as one continuous column against the reference line.
                                                                const height = bottom - top;
                                                                cumulative += value;
                                                                if (height < 0.5) return null;
                                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                    d: $e112e69924d514a5$var$segmentPath(barX, top, barWidth, height, gap <= 0 && drawnIndex === topSlotIndex),
                                                                    fill: entry.color,
                                                                    "data-testid": `${chartId}-segment-${entry.id}`,
                                                                    "data-year-index": index,
                                                                    style: {
                                                                        pointerEvents: 'none'
                                                                    },
                                                                    "aria-hidden": true
                                                                }, entry.id);
                                                            }),
                                                            gap > 0 && reference?.gap ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: $e112e69924d514a5$var$segmentPath(barX, yFor(point.reference ?? 0), barWidth, Math.max(0, yFor(total) - yFor(point.reference ?? 0)), true),
                                                                fill: reference.gap.color,
                                                                "data-testid": `${chartId}-segment-${reference.gap.id}`,
                                                                "data-year-index": index,
                                                                style: {
                                                                    pointerEvents: 'none'
                                                                },
                                                                "aria-hidden": true
                                                            }) : null
                                                        ]
                                                    }, `band-${index}`);
                                                }),
                                                reference ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: points.map((point, index)=>`${index === 0 ? 'M' : 'L'}${bandLeft(index)},${yFor(point.reference ?? 0)} L${bandLeft(index) + bandWidth},${yFor(point.reference ?? 0)}`).join(' '),
                                                    fill: "none",
                                                    stroke: $e112e69924d514a5$var$INK_PRIMARY,
                                                    strokeWidth: 2,
                                                    strokeDasharray: "1 5",
                                                    strokeLinecap: "round",
                                                    "data-testid": `${chartId}-${reference.id}-line`,
                                                    "aria-hidden": true
                                                }) : null,
                                                points.map((point, index)=>isBandVisible(index) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                        x: bandLeft(index),
                                                        y: $e112e69924d514a5$var$MARGIN.top,
                                                        width: bandWidth,
                                                        height: plotHeight,
                                                        fill: $e112e69924d514a5$var$INK_PRIMARY,
                                                        fillOpacity: hover?.index === index ? 0.04 : 0,
                                                        tabIndex: 0,
                                                        role: "img",
                                                        "data-testid": `${chartId}-year-${index}`,
                                                        "aria-label": describePoint(point),
                                                        onFocus: ()=>setHover({
                                                                index: index,
                                                                x: bandLeft(index) + bandWidth / 2,
                                                                y: $e112e69924d514a5$var$MARGIN.top + plotHeight / 3
                                                            }),
                                                        onBlur: ()=>setHover((current)=>current?.index === index ? null : current),
                                                        style: {
                                                            outline: 'none'
                                                        }
                                                    }, `hit-${index}`) : null)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                            x1: $e112e69924d514a5$var$MARGIN.left,
                                            x2: $e112e69924d514a5$var$MARGIN.left + innerWidth,
                                            y1: plotBottom,
                                            y2: plotBottom,
                                            stroke: $e112e69924d514a5$var$BASELINE,
                                            strokeWidth: 1
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                            clipPath: `url(#${xAxisClipId})`,
                                            children: points.map((point, index)=>isBandVisible(index) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                                    x: bandLeft(index) + bandWidth / 2,
                                                    y: plotBottom + 16,
                                                    textAnchor: "middle",
                                                    fontSize: 11,
                                                    fill: $e112e69924d514a5$var$INK_MUTED,
                                                    children: point.label
                                                }, `xtick-${index}`) : null)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                            x: $e112e69924d514a5$var$MARGIN.left + innerWidth / 2,
                                            y: svgHeight - 4,
                                            textAnchor: "middle",
                                            fontSize: 11,
                                            fill: $e112e69924d514a5$var$INK_MUTED,
                                            children: xAxisLabel
                                        })
                                    ]
                                }),
                                hover && hoveredPoint ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    role: "tooltip",
                                    "data-testid": `${chartId}-tooltip`,
                                    className: "pointer-events-none absolute z-20 rounded-lg bg-gray-800 p-3 text-xs text-white shadow-lg",
                                    style: {
                                        width: tooltipWidth,
                                        left: $e112e69924d514a5$var$clamp(hover.x + 18, 0, Math.max(0, width - tooltipWidth)),
                                        top: $e112e69924d514a5$var$clamp(hover.y - 30, 0, Math.max(0, svgHeight - 40))
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                            className: "mb-2 text-sm font-bold text-blue-300",
                                            children: hoveredPoint.fullLabel
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "mb-1 text-[10px] uppercase tracking-wide text-gray-400",
                                            children: stackLabel
                                        }),
                                        series.filter((entry)=>(hoveredPoint.values[entry.id] || 0) > 0).map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: `flex items-center justify-between gap-2 ${isEnabled(entry.id) ? '' : 'opacity-50'}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "flex items-center gap-1.5 text-gray-300",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "inline-block h-0.5 w-3 rounded-full",
                                                                style: {
                                                                    backgroundColor: entry.color
                                                                },
                                                                "aria-hidden": true
                                                            }),
                                                            entry.label,
                                                            isEnabled(entry.id) ? '' : ' (hidden)'
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: `font-mono font-semibold ${isEnabled(entry.id) ? '' : 'line-through'}`,
                                                        children: formatValue(hoveredPoint.values[entry.id] || 0)
                                                    })
                                                ]
                                            }, entry.id)),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mt-1 flex items-center justify-between gap-2 border-t border-gray-600 pt-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-gray-400",
                                                    children: stackTotalLabel
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "font-mono font-semibold",
                                                    children: formatValue(hoveredTotal)
                                                })
                                            ]
                                        }),
                                        (hoveredPoint.sections || []).map((section)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "mb-1 mt-2 text-[10px] uppercase tracking-wide text-gray-400",
                                                        children: section.title
                                                    }),
                                                    section.lines.map((line)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex items-center justify-between gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-gray-300",
                                                                    children: line.label
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "font-mono font-semibold",
                                                                    children: formatValue(line.value)
                                                                })
                                                            ]
                                                        }, line.label)),
                                                    section.total ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mt-1 flex items-center justify-between gap-2 border-t border-gray-600 pt-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-gray-400",
                                                                children: section.total.label
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-mono font-semibold",
                                                                children: formatValue(section.total.value)
                                                            })
                                                        ]
                                                    }) : null
                                                ]
                                            }, section.title)),
                                        hoveredSummary ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mt-2 flex items-center justify-between gap-2 rounded px-2 py-1",
                                            style: {
                                                backgroundColor: hoveredSummary.tone === 'negative' ? 'rgba(208,59,59,0.22)' : 'rgba(12,163,12,0.18)'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-[10px] uppercase tracking-wide text-gray-200",
                                                    children: hoveredSummary.label
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: `font-mono font-semibold ${hoveredSummary.tone === 'negative' ? 'text-red-200' : 'text-green-200'}`,
                                                    children: formatValue(hoveredSummary.value)
                                                })
                                            ]
                                        }) : null
                                    ]
                                }) : null
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-x-3 gap-y-1.5 border-t border-slate-100 px-4 py-2.5",
                        children: [
                            series.map((entry)=>{
                                const on = isEnabled(entry.id);
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>toggleSeries(entry.id),
                                    "aria-pressed": on,
                                    "data-testid": `${chartId}-legend-${entry.id}`,
                                    title: on ? `Hide ${entry.label} from the chart` : `Show ${entry.label} on the chart`,
                                    className: `inline-flex items-center gap-1.5 rounded-md px-1.5 py-0.5 text-xs transition-colors hover:bg-slate-100 ${on ? 'text-slate-700' : 'text-slate-400'}`,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "inline-block h-2.5 w-2.5 rounded-sm",
                                            style: {
                                                backgroundColor: on ? entry.color : $e112e69924d514a5$var$SURFACE,
                                                border: on ? 'none' : `1px solid ${entry.color}`
                                            },
                                            "aria-hidden": true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: on ? '' : 'line-through',
                                            children: entry.label
                                        })
                                    ]
                                }, entry.id);
                            }),
                            reference?.gap ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "inline-flex items-center gap-1.5 px-1.5 py-0.5 text-xs text-slate-700",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "inline-block h-2.5 w-2.5 rounded-sm",
                                        style: {
                                            backgroundColor: reference.gap.color
                                        },
                                        "aria-hidden": true
                                    }),
                                    reference.gap.label
                                ]
                            }) : null,
                            reference ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "inline-flex items-center gap-1.5 px-1.5 py-0.5 text-xs text-slate-700",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                        width: "14",
                                        height: "4",
                                        "aria-hidden": true,
                                        className: "shrink-0",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                            x1: "0",
                                            y1: "2",
                                            x2: "14",
                                            y2: "2",
                                            stroke: $e112e69924d514a5$var$INK_PRIMARY,
                                            strokeWidth: "2",
                                            strokeDasharray: "1 4",
                                            strokeLinecap: "round"
                                        })
                                    }),
                                    reference.label
                                ]
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
};
var $e112e69924d514a5$export$2e2bcd8739ae039 = $e112e69924d514a5$var$ProjectionChart;



/**
 * cashflowChartData.ts – turns the projection engine's per-year rows into the points the
 * projections modal's cashflow chart draws: stacked income categories, a total expenses level,
 * and the shortfall between them.
 *
 * Income comes from each year's `cashFlowBreakdown` (the numeric label/value list
 * `calculateFinancials` returns): positive lines are income, negative lines are expenses. Aged
 * care sits outside that breakdown unless the strategy integrates it, so it is appended from
 * `annualCareCost` when no expense line already covers it — same reconciliation the modal's
 * "Net Cashflow" tooltip does. Rows without a breakdown fall back to the row's scalar fields.
 */ 
const $0efeff8c700b6d35$export$f7cfe1462e18a7b4 = [
    {
        id: 'salary',
        label: 'Salary',
        color: (0, $c7535f09b538739e$export$d991bcf562d2c0dd)[0]
    },
    {
        id: 'pension',
        label: 'Age Pension',
        color: (0, $c7535f09b538739e$export$d991bcf562d2c0dd)[2]
    },
    {
        id: 'investment',
        label: 'Investment income',
        color: (0, $c7535f09b538739e$export$d991bcf562d2c0dd)[3]
    },
    {
        id: 'abp',
        label: 'ABP income',
        color: (0, $c7535f09b538739e$export$d991bcf562d2c0dd)[6]
    },
    {
        id: 'other',
        label: 'Other income',
        color: (0, $c7535f09b538739e$export$d991bcf562d2c0dd)[4]
    }
];
const $0efeff8c700b6d35$export$2e82bdc55f5a5d65 = (0, $c7535f09b538739e$export$1acaf3d3ebfae0b4);
const $0efeff8c700b6d35$var$EMPTY_INCOME = ()=>({
        salary: 0,
        pension: 0,
        investment: 0,
        abp: 0,
        other: 0
    });
/**
 * Route a positive `cashFlowBreakdown` line to an income series. Salary is split out separately.
 *
 * READS THE ENGINE'S `series` TAG FIRST, and that is not decoration. Investment income used to
 * arrive as one line labelled "Investment Income (Cash)", matched here on the substring "investment
 * income". When it was split into Interest / Dividends / Rent so a client could tell which asset
 * produced what (2026-08-22), three of those four labels no longer contained that substring — so
 * without the tag, interest, dividends and rent would all have silently landed in the "other" band
 * of every cashflow chart. The chart would still add up; it would just attribute the money to the
 * wrong thing, which is worse than an error.
 *
 * The label checks remain for lines the engine has not tagged, and for stored projections written
 * before the tag existed.
 */ function $0efeff8c700b6d35$var$seriesForIncomeLabel(label, series) {
    if (series === 'investment' || series === 'abp' || series === 'pension' || series === 'salary' || series === 'other') return series;
    const l = label.toLowerCase();
    if (l.includes('abp') || l.includes('account based pension') || l.includes('account-based pension')) return 'abp';
    // Before 'rent': Rent Assistance is an Age Pension supplement, not investment rent.
    if (l.includes('age pension') || l.includes('rent assistance')) return 'pension';
    if (l.includes('investment income') || l.startsWith('interest') || l.startsWith('dividends') || l.startsWith('rent (')) return 'investment';
    return 'other';
}
/** Strip the breakdown's `Less: ` / `Add: ` prefixes so tooltip rows read as plain expense names. */ function $0efeff8c700b6d35$var$cleanExpenseLabel(label) {
    return label.replace(/^\s*(less|add)\s*:\s*/i, '').trim() || 'Expense';
}
/** True when an expense label already covers aged care, so we must not add `annualCareCost` on top. */ function $0efeff8c700b6d35$var$isAgedCareLabel(label) {
    const l = label.toLowerCase();
    return l.includes('aged care') || l.includes('care cost');
}
function $0efeff8c700b6d35$export$dddba41614a583ac(row, index) {
    return {
        label: row.fyLabel || `Year ${index + 1}`,
        fullLabel: row.fyLabel ? index === 0 ? `Comparison Yr1 (${row.fyLabel})` : row.fyLabel : `Year ${index + 1}`
    };
}
function $0efeff8c700b6d35$export$b88c55ac44748b76(projections, agedCareFallbackAnnual = 0) {
    return (projections || []).map((year, index)=>{
        const income = $0efeff8c700b6d35$var$EMPTY_INCOME();
        const expenseLines = [];
        const breakdown = Array.isArray(year.cashFlowBreakdown) ? year.cashFlowBreakdown : null;
        const annualCareCost = year.annualCareCost || agedCareFallbackAnnual || 0;
        // Only numeric-valued breakdowns are usable here — the suggestion engine hands some callers a
        // pre-formatted (string-valued) breakdown, which the scalar fallback below handles instead.
        // `note: true` rows explain the figures without being one of them (reinvested dividends, for
        // example, which are taxed but never banked). Summing one would invent income the client
        // never receives, so they are dropped before anything adds them up.
        const numericLines = breakdown ? breakdown.filter((item)=>typeof item?.label === 'string' && typeof item?.value === 'number' && Number.isFinite(item.value) && item.note !== true) : [];
        if (numericLines.length > 0) {
            // Salary is inside the breakdown's "Other Income (Cash)" line; peel it off into its own
            // series so a working client sees salary rather than an opaque "other" block.
            let salaryToAllocate = Math.max(0, year.salaryIncome || 0);
            numericLines.forEach(({ label: label, value: value, series: tag })=>{
                if (value > 0) {
                    const series = $0efeff8c700b6d35$var$seriesForIncomeLabel(label, tag);
                    if (series === 'other' && salaryToAllocate > 0) {
                        const salaryPart = Math.min(salaryToAllocate, value);
                        salaryToAllocate -= salaryPart;
                        income.salary += salaryPart;
                        income.other += value - salaryPart;
                    } else income[series] += value;
                } else if (value < 0) expenseLines.push({
                    label: $0efeff8c700b6d35$var$cleanExpenseLabel(label),
                    value: -value
                });
            });
        } else {
            // Cash deposited, not the opening rate — this bar is money arriving in the year. They part
            // company whenever the entitlement moves mid-year (a RAD paid on entry, a birthday reaching
            // pension age); see the engine row's `agePensionPaidForPeriod`.
            income.pension = year.agePensionPaidForPeriod ?? year.socialSecurity ?? 0;
            income.abp = year.abpIncome || 0;
            income.investment = Math.max(0, (year.investmentIncome || 0) - (year.abpIncome || 0));
            income.salary = Math.max(0, year.salaryIncome || 0);
            income.other = year.rentalIncome || 0;
            const livingExpenses = year.livingExpenses || 0;
            const tax = year.tax || 0;
            const capitalExpenses = year.capitalExpenses || 0;
            if (livingExpenses > 0) expenseLines.push({
                label: 'Living Expenses',
                value: livingExpenses
            });
            if (tax > 0) expenseLines.push({
                label: 'Tax',
                value: tax
            });
            if (capitalExpenses > 0) expenseLines.push({
                label: 'Capital Expenses',
                value: capitalExpenses
            });
        }
        if (annualCareCost > 0 && !expenseLines.some((line)=>$0efeff8c700b6d35$var$isAgedCareLabel(line.label))) expenseLines.push({
            label: 'Aged Care Costs',
            value: annualCareCost
        });
        const expenses = expenseLines.reduce((sum, line)=>sum + line.value, 0);
        return {
            ...$0efeff8c700b6d35$export$dddba41614a583ac(year, index),
            values: income,
            reference: expenses,
            sections: [
                {
                    title: 'Expenses',
                    lines: expenseLines,
                    total: {
                        label: 'Total expenses',
                        value: expenses
                    }
                }
            ]
        };
    });
}


/**
 * balanceSheetChartData.ts – turns the projection engine's per-year rows into the points the
 * projections modal's net-worth and debt charts draw.
 *
 * Both read the same year-end snapshot the engine clones onto every row (`assets`, `home`,
 * `liabilities`) plus the two strategy loans it tracks outside that snapshot
 * (`reverseMortgageLoanBalance`, `heasLoanBalance`). The asset side deliberately mirrors the
 * server's `sumAssetValues`/`calculateNetWorth` (annuities count at their residual value; the home
 * is skipped when an asset row already represents it) so the bars total to the same gross assets
 * the engine netted its `netWorth` from — which is what the dotted line on the net-worth chart is.
 */ 

const $39d41c0c5ff73395$export$80fd42c7035f1e47 = [
    {
        id: 'home',
        label: 'Family home',
        color: (0, $c7535f09b538739e$export$d991bcf562d2c0dd)[0]
    },
    {
        id: 'cash',
        label: 'Cash & term deposits',
        color: (0, $c7535f09b538739e$export$d991bcf562d2c0dd)[1]
    },
    {
        id: 'shares',
        label: 'Shares & managed funds',
        color: (0, $c7535f09b538739e$export$d991bcf562d2c0dd)[2]
    },
    {
        id: 'super',
        label: 'Super & pensions',
        color: (0, $c7535f09b538739e$export$d991bcf562d2c0dd)[3]
    },
    {
        id: 'property',
        label: 'Investment property',
        color: (0, $c7535f09b538739e$export$d991bcf562d2c0dd)[4]
    },
    {
        id: 'rad',
        label: 'RAD paid',
        color: (0, $c7535f09b538739e$export$d991bcf562d2c0dd)[5]
    },
    {
        id: 'other',
        label: 'Other assets',
        color: (0, $c7535f09b538739e$export$d991bcf562d2c0dd)[6]
    }
];
const $39d41c0c5ff73395$export$fef614ae10d4350b = [
    {
        id: 'mortgages',
        label: 'Mortgage / home loan',
        color: (0, $c7535f09b538739e$export$d991bcf562d2c0dd)[0]
    },
    {
        id: 'reverseMortgage',
        label: 'Reverse mortgage',
        color: (0, $c7535f09b538739e$export$d991bcf562d2c0dd)[1]
    },
    {
        id: 'heas',
        label: 'Home Equity Access Scheme',
        color: (0, $c7535f09b538739e$export$d991bcf562d2c0dd)[2]
    },
    {
        id: 'heloc',
        label: 'Loan against the home',
        color: (0, $c7535f09b538739e$export$d991bcf562d2c0dd)[3]
    },
    {
        id: 'personalLoans',
        label: 'Personal loans',
        color: (0, $c7535f09b538739e$export$d991bcf562d2c0dd)[4]
    },
    {
        id: 'creditCards',
        label: 'Credit cards',
        color: (0, $c7535f09b538739e$export$d991bcf562d2c0dd)[5]
    },
    {
        id: 'other',
        label: 'Other debt',
        color: (0, $c7535f09b538739e$export$d991bcf562d2c0dd)[6]
    }
];
const $39d41c0c5ff73395$var$EMPTY_ASSETS = ()=>({
        home: 0,
        cash: 0,
        shares: 0,
        super: 0,
        property: 0,
        rad: 0,
        other: 0
    });
const $39d41c0c5ff73395$var$EMPTY_DEBTS = ()=>({
        mortgages: 0,
        reverseMortgage: 0,
        heas: 0,
        heloc: 0,
        personalLoans: 0,
        creditCards: 0,
        other: 0
    });
/** Route an asset bucket (the fact-find's `assets` keys, plus the engine's synthesized `radPaid`) to a series. */ function $39d41c0c5ff73395$var$seriesForAssetBucket(bucket) {
    switch(bucket){
        case 'bankAccounts':
        case 'termDeposits':
            return 'cash';
        case 'shares':
        case 'investmentBonds':
            return 'shares';
        case 'superannuation':
        case 'accountBasedPensions':
            return 'super';
        case 'investmentProperty':
            return 'property';
        case 'radPaid':
            return 'rad';
        case 'home':
            return 'home';
        // annuities, funeralBonds, personalAssets, other, and anything a strategy injects.
        default:
            return 'other';
    }
}
/** Route a liability bucket to a series. A row's own `type` wins — strategies inject typed rows into generic buckets. */ function $39d41c0c5ff73395$var$seriesForLiability(bucket, liability) {
    if (liability.type === 'reverse_mortgage') return 'reverseMortgage';
    switch(bucket){
        case 'mortgages':
            return 'mortgages';
        case 'personalLoans':
            return 'personalLoans';
        case 'creditCards':
            return 'creditCards';
        case 'helocDebt':
            return 'heloc';
        default:
            return 'other';
    }
}
/** Mirrors the server's `sumAssetValues`: annuities count at their residual value, everything else at `value`. */ function $39d41c0c5ff73395$var$assetValue(asset) {
    const raw = asset.type === 'annuities' && asset.residualValue !== undefined ? asset.residualValue : asset.value;
    return Number.isFinite(raw) ? raw : 0;
}
/** Every asset row on a year, bucket by bucket. */ function $39d41c0c5ff73395$var$forEachAsset(row, visit) {
    Object.entries(row.assets || {}).forEach(([bucket, list])=>(list || []).forEach((asset)=>asset && visit(bucket, asset)));
}
/** Every liability row on a year, bucket by bucket. */ function $39d41c0c5ff73395$var$forEachLiability(row, visit) {
    Object.entries(row.liabilities || {}).forEach(([bucket, list])=>(list || []).forEach((liability)=>liability && visit(bucket, liability)));
}
/** A year's debt lines for the tooltip, with the strategy loans appended. Only non-zero balances. */ function $39d41c0c5ff73395$var$debtLinesFor(row, labelFor) {
    const lines = [];
    $39d41c0c5ff73395$var$forEachLiability(row, (bucket, liability)=>{
        const balance = liability.balance || 0;
        if (balance > 0) lines.push({
            label: labelFor(bucket, liability),
            value: balance
        });
    });
    if ((row.reverseMortgageLoanBalance || 0) > 0) lines.push({
        label: 'Reverse mortgage',
        value: row.reverseMortgageLoanBalance
    });
    if ((row.heasLoanBalance || 0) > 0) lines.push({
        label: 'Home Equity Access Scheme',
        value: row.heasLoanBalance
    });
    return lines;
}
/** The tooltip name for a liability row: its own description, else the series it lands in. */ function $39d41c0c5ff73395$var$liabilityLabel(bucket, liability) {
    const described = (liability.description || '').trim();
    if (described) return described;
    const seriesId = $39d41c0c5ff73395$var$seriesForLiability(bucket, liability);
    return $39d41c0c5ff73395$export$fef614ae10d4350b.find((series)=>series.id === seriesId)?.label || 'Debt';
}
function $39d41c0c5ff73395$export$2b4aba4110cde27f(projections) {
    return (projections || []).map((year, index)=>{
        const values = $39d41c0c5ff73395$var$EMPTY_ASSETS();
        // The home is a fact-find field, not an asset row — except where a strategy has injected it
        // as one, in which case counting `home.value` too would double it (mirrors calculateNetWorth).
        let homeHeldAsAsset = false;
        $39d41c0c5ff73395$var$forEachAsset(year, (bucket, asset)=>{
            if (asset.type === 'home') homeHeldAsAsset = true;
            values[$39d41c0c5ff73395$var$seriesForAssetBucket(asset.type === 'home' ? 'home' : bucket)] += $39d41c0c5ff73395$var$assetValue(asset);
        });
        if (!homeHeldAsAsset) values.home += year.home?.value || 0;
        const netWorth = year.netWorth || 0;
        const debtLines = $39d41c0c5ff73395$var$debtLinesFor(year, $39d41c0c5ff73395$var$liabilityLabel);
        const totalDebt = debtLines.reduce((sum, line)=>sum + line.value, 0);
        return {
            ...(0, $0efeff8c700b6d35$export$dddba41614a583ac)(year, index),
            values: values,
            sections: totalDebt > 0 ? [
                {
                    title: 'Less debt',
                    lines: debtLines,
                    total: {
                        label: 'Total debt',
                        value: totalDebt
                    }
                }
            ] : [],
            summary: {
                label: 'Net Worth',
                value: netWorth,
                tone: netWorth >= 0 ? 'positive' : 'negative'
            }
        };
    });
}
function $39d41c0c5ff73395$export$c3417c7a35be72(projections) {
    return (projections || []).map((year, index)=>{
        const values = $39d41c0c5ff73395$var$EMPTY_DEBTS();
        $39d41c0c5ff73395$var$forEachLiability(year, (bucket, liability)=>{
            values[$39d41c0c5ff73395$var$seriesForLiability(bucket, liability)] += liability.balance || 0;
        });
        values.reverseMortgage += year.reverseMortgageLoanBalance || 0;
        values.heas += year.heasLoanBalance || 0;
        const lines = $39d41c0c5ff73395$var$debtLinesFor(year, $39d41c0c5ff73395$var$liabilityLabel);
        const total = lines.reduce((sum, line)=>sum + line.value, 0);
        return {
            ...(0, $0efeff8c700b6d35$export$dddba41614a583ac)(year, index),
            values: values,
            // The stack breakdown already names every category; this section names the individual
            // loans within them, which is the only thing the bars can't show.
            sections: lines.length > 1 ? [
                {
                    title: 'Each debt',
                    lines: lines,
                    total: {
                        label: 'Total debt',
                        value: total
                    }
                }
            ] : []
        };
    });
}


const $9530f15b0134fa22$export$949b07d5dccd05b2 = [
    {
        id: 'cashflow',
        label: 'Money in and out',
        heading: 'Money in and out, each year',
        name: 'money in and out',
        title: 'What comes in, and what each year costs',
        subtitle: 'The bars are money coming in; the dotted line is what each year costs. Red is the part paid from savings.',
        ariaDescription: 'stacked income bars against a dotted line for what each year costs, with the part paid from savings shown in red. The table below lists the same figures.',
        series: (0, $0efeff8c700b6d35$export$f7cfe1462e18a7b4),
        stackLabel: 'Income',
        stackTotalLabel: 'Total income',
        reference: {
            id: 'expenses',
            label: 'What the year costs',
            gap: {
                id: 'shortfall',
                label: 'Paid from savings',
                clearedLabel: 'Left over',
                color: (0, $c7535f09b538739e$export$1acaf3d3ebfae0b4)
            }
        },
        emptyMessage: 'No income or costs to chart for this projection.'
    },
    {
        id: 'networth',
        label: 'What they own',
        heading: 'What they own, each year',
        name: 'what they own',
        title: 'What they own at the end of each year',
        subtitle: 'By kind of asset. Hover a year for what is owed against it, and what is left once that is taken off.',
        ariaDescription: 'stacked bars of what is owned at the end of each projected year, by kind of asset. Hovering a year gives the debt owed against it and the resulting net worth. The table below lists the same figures.',
        series: (0, $39d41c0c5ff73395$export$80fd42c7035f1e47),
        stackLabel: 'Assets',
        stackTotalLabel: 'Total owned',
        emptyMessage: 'No assets to chart for this projection.'
    },
    {
        id: 'debt',
        label: 'What they owe',
        heading: 'What they owe, each year',
        name: 'what they owe',
        title: 'What they owe at the end of each year',
        subtitle: 'Loans and other borrowing, by kind, and whether they grow or run down.',
        ariaDescription: 'stacked bars of what is owed at the end of each projected year, by kind of debt.',
        series: (0, $39d41c0c5ff73395$export$fef614ae10d4350b),
        stackLabel: 'Debt',
        stackTotalLabel: 'Total owed',
        emptyMessage: 'This projection carries no loans or other debt.'
    }
];
const $9530f15b0134fa22$var$ProjectionChartsAccordion = ({ cashflow: cashflow, netWorth: netWorth, debt: debt, formatValue: formatValue, pane: pane, onPaneChange: onPaneChange })=>{
    const [ownPane, setOwnPane] = (0, $acw62.useState)('cashflow');
    const openPane = pane ?? ownPane;
    const selectPane = (id)=>{
        setOwnPane(id);
        onPaneChange?.(id);
    };
    const pointsFor = {
        cashflow: cashflow,
        networth: netWorth,
        debt: debt
    };
    if (cashflow.length === 0) return null;
    const open = $9530f15b0134fa22$export$949b07d5dccd05b2.find((p)=>p.id === openPane) ?? $9530f15b0134fa22$export$949b07d5dccd05b2[0];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-3",
        "data-testid": "projection-charts-accordion",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                role: "tablist",
                "aria-label": "Which chart to show",
                className: "flex w-full overflow-hidden rounded-lg border border-slate-300 bg-white sm:inline-flex sm:w-auto",
                children: $9530f15b0134fa22$export$949b07d5dccd05b2.map((p, i)=>{
                    const isOpen = p.id === openPane;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        role: "tab",
                        "aria-selected": isOpen,
                        "aria-controls": "projection-chart-pane",
                        id: `projection-chart-tab-${p.id}`,
                        "data-testid": `projection-chart-tab-${p.id}`,
                        onClick: ()=>selectPane(p.id),
                        className: `flex-1 px-4 py-2 text-sm font-semibold transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-blue-600 sm:flex-none ${i > 0 ? 'border-l border-slate-300' : ''} ${isOpen ? 'bg-brand-navy text-white' : 'text-slate-700 hover:bg-slate-50'}`,
                        children: p.label
                    }, p.id);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                id: "projection-chart-pane",
                role: "tabpanel",
                "aria-labelledby": `projection-chart-tab-${open.id}`,
                className: "overflow-hidden rounded-xl border border-slate-200 bg-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e112e69924d514a5$export$2e2bcd8739ae039), {
                    chartId: open.id,
                    name: open.name,
                    title: open.title,
                    subtitle: open.subtitle,
                    ariaDescription: open.ariaDescription,
                    points: pointsFor[open.id],
                    series: open.series,
                    stackLabel: open.stackLabel,
                    stackTotalLabel: open.stackTotalLabel,
                    yAxisLabel: open.id === 'cashflow' ? 'Dollars per year' : 'Dollars',
                    xAxisLabel: "Year",
                    reference: open.reference,
                    formatValue: formatValue,
                    emptyMessage: open.emptyMessage
                }, open.id)
            })
        ]
    });
};
var $9530f15b0134fa22$export$2e2bcd8739ae039 = $9530f15b0134fa22$var$ProjectionChartsAccordion;


/**
 * THE PERIOD THE PLANS ARE COMPARED OVER, SAID ONCE (owner, 25 Oct 2026).
 *
 * The plans are ranked on what they leave the family after the client's horizon, so a different horizon can
 * put a different plan first. The owner ruled against a control for the period inside the year-by-year window
 * ("you are potentially taking them somewhere completely different") and asked for a line instead. It sits in
 * the year-by-year window's footer and in every module's Explain this, in the same words.
 */ function $c3eba85390498a43$export$be94b03447321f96(years) {
    const n = Math.max(1, Math.round(Number(years) || 0));
    return `These plans are compared over ${n} ${n === 1 ? 'year' : 'years'}. Over a longer or shorter period, a different plan can come out ahead.`;
}





/**
 * projectionBreakdownStyles.ts – the stylesheet for a projection year's human-readable breakdown
 * (`ProjectionYearResult.breakdown`) as the projections modal renders it.
 *
 * Written as CSS rather than utility classes because the whole design is margins and pseudo-elements —
 * a coloured marker beside each paragraph, a 🎉 beside each birthday, a month's name stood on its end
 * down the left of its band — and the breakdown HTML itself must stay plain semantic markup that any
 * other surface can render (see BREAKDOWN_SERIES_TAGS). The engine emits one wrapper, the month band,
 * and no spacers or icons at all; everything below hangs off that class, the paragraph tags and the
 * element names alone.
 *
 * The marker colours are BUILT from the accordion's own chart series, so a paragraph's marker is
 * always exactly the colour of the bar it describes — rename or recolour a series and this follows.
 *
 * Two layouts, because the month's name has to go somewhere: below
 * {@link BREAKDOWN_RAIL_MIN_WIDTH} it is a grey bar across the top of its band, and above it the same
 * bar turned 90° into a rail down the left. Nothing else changes between them.
 */ /**
 * The `class` values a projection breakdown's elements may carry. Most of them — this list — go on a
 * `<p>` and name the chart bar that paragraph is about; the two below the list are the exceptions.
 *
 * The engine's per-year breakdown (see `ProjectionYearResult.breakdown`) is plain semantic HTML that
 * any surface can render. These tags are the one concession to the projections modal, where the
 * breakdown sits under an accordion of charts: they let it mark a paragraph's margin with the colour
 * of the bar the sentence moves — the family home's growth in the home colour, a HELOC drawdown in
 * the care-debt colour — with no extra elements and nothing for a plain renderer to trip over.
 *
 * Each tag is `<chart>-<series id>`, matching a series in the modal's charts. The mapping to actual
 * colours lives with those charts (frontend/src/features/agedCare/projectionBreakdownStyles.ts), and
 * a test there asserts every tag here still resolves to one — so a renamed series fails loudly rather
 * than silently dropping a paragraph's colour.
 *
 * Paragraphs with no single matching bar (aged care costs, living expenses, whole-of-balance-sheet
 * statements) carry no class at all, and their margin is deliberately left empty.
 */ const $784f4552e43405e4$export$fef66e020496d70d = [
    // Cashflow chart — income the year received.
    'cashflow-salary',
    'cashflow-pension',
    'cashflow-other',
    // Net Worth chart — what is owned.
    'networth-home',
    'networth-cash',
    'networth-shares',
    'networth-super',
    'networth-rad',
    // Debt chart — what is owed.
    'debt-reverseMortgage',
    'debt-heas',
    'debt-heloc'
];
const $784f4552e43405e4$export$9584f98fb3634bdd = 'birthday';
const $784f4552e43405e4$export$6f748270a8ec4e99 = 'breakdown-month';




const $18ef4d8ebb42032f$export$c2f4692642028b8d = 'projection-breakdown';
const $18ef4d8ebb42032f$export$ef1a0b29bb73c505 = '640px';
function $18ef4d8ebb42032f$export$e629b1cdc59da507() {
    const colors = {};
    const charts = [
        [
            'cashflow',
            (0, $0efeff8c700b6d35$export$f7cfe1462e18a7b4)
        ],
        [
            'networth',
            (0, $39d41c0c5ff73395$export$80fd42c7035f1e47)
        ],
        [
            'debt',
            (0, $39d41c0c5ff73395$export$fef614ae10d4350b)
        ]
    ];
    charts.forEach(([chart, series])=>series.forEach((entry)=>colors[`${chart}-${entry.id}`] = entry.color));
    return colors;
}
/**
 * A calendar, as a background image so it needs no element of its own. Single-quoted attributes and
 * an escaped `#` keep it legal inside `url("…")`; the stroke is passed in because the icon is drawn
 * white on the month band's grey heading.
 */ const $18ef4d8ebb42032f$var$calendarIcon = (stroke)=>`url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='${stroke}' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='4' width='18' height='18' rx='2'/%3E%3Cpath d='M16 2v4M8 2v4M3 10h18'/%3E%3C/svg%3E")`;
/** Only tags the engine actually emits get a marker rule — anything else leaves the gutter empty. */ function $18ef4d8ebb42032f$var$markerRules() {
    const colors = $18ef4d8ebb42032f$export$e629b1cdc59da507();
    const tagged = (0, $784f4552e43405e4$export$fef66e020496d70d).filter((tag)=>colors[tag]);
    // One shared geometry rule, then one colour per tag. `:where()` keeps specificity flat, so the
    // colour declarations below win without needing to repeat the selector list.
    const geometry = `.${$18ef4d8ebb42032f$export$c2f4692642028b8d} p:where(${tagged.map((tag)=>`.${tag}`).join(', ')})::before`;
    return [
        `${geometry} {
            content: '';
            position: absolute;
            left: calc((var(--breakdown-gutter) - var(--breakdown-marker)) / 2);
            /* Inset from both ends by half a line, so one line reads as a dot and several as a bar. */
            top: calc((var(--breakdown-line) - var(--breakdown-marker)) / 2);
            bottom: calc((var(--breakdown-line) - var(--breakdown-marker)) / 2);
            width: var(--breakdown-marker);
            border-radius: 9999px;
            background-color: var(--breakdown-marker-color);
        }`,
        ...tagged.map((tag)=>`.${$18ef4d8ebb42032f$export$c2f4692642028b8d} p.${tag} { --breakdown-marker-color: ${colors[tag]}; }`)
    ].join('\n');
}
const $18ef4d8ebb42032f$export$f612729a456e44c5 = `
.${$18ef4d8ebb42032f$export$c2f4692642028b8d} {
    /* The gutter every block indents past, and which the markers live in. */
    --breakdown-gutter: 1.5rem;
    /* How far a month band holds its text off its own right-hand edge. */
    --breakdown-inset: 0.75rem;
    --breakdown-marker: 8px;
    --breakdown-line: 1.6em;
    font-size: 0.875rem;
    line-height: var(--breakdown-line);
    color: #334155;
}
/* One band per month (the engine's own grouping), alternating white and off-white so a reader
   scrolling a year of fortnightly movements can see where one month ends and the next begins without
   stopping to read a date. */
.${$18ef4d8ebb42032f$export$c2f4692642028b8d} .${(0, $784f4552e43405e4$export$6f748270a8ec4e99)} {
    /* The rail the month's name stands up in \u{2014} claimed by the wide layout below, nothing until then. */
    --breakdown-rail: 0px;
    position: relative;
    margin: 0.5rem 0;
    padding: 0 var(--breakdown-inset) 0.5rem var(--breakdown-rail);
    border: 1px solid #e2e8f0;
    border-radius: 0.375rem;
    /* Clips the heading \u{2014} full-bleed across the band's top, or down its rail \u{2014} to those corners. */
    overflow: hidden;
    background-color: #ffffff;
}
.${$18ef4d8ebb42032f$export$c2f4692642028b8d} .${(0, $784f4552e43405e4$export$6f748270a8ec4e99)}:nth-child(even) { background-color: #f8fafc; }
.${$18ef4d8ebb42032f$export$c2f4692642028b8d} .${(0, $784f4552e43405e4$export$6f748270a8ec4e99)}:first-child { margin-top: 0; }
.${$18ef4d8ebb42032f$export$c2f4692642028b8d} .${(0, $784f4552e43405e4$export$6f748270a8ec4e99)}:last-child { margin-bottom: 0; }
/* The month's name, and the only place the calendar icon now appears: a narrow viewport gets a grey
   bar across the top of the band, in white, which is where this heading has always read from. */
.${$18ef4d8ebb42032f$export$c2f4692642028b8d} .${(0, $784f4552e43405e4$export$6f748270a8ec4e99)} > h2 {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    /* Escapes the band's right-hand inset so the bar runs edge to edge, corner to clipped corner. */
    margin: 0 calc(-1 * var(--breakdown-inset)) 0 0;
    padding: 0.25rem 0.75rem;
    background-color: #64748b;
    color: #ffffff;
    font-size: 0.75rem;
    line-height: 1.25rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}
.${$18ef4d8ebb42032f$export$c2f4692642028b8d} .${(0, $784f4552e43405e4$export$6f748270a8ec4e99)} > h2::before {
    content: '';
    /* Never squeezed by the label beside it, and never turned on its side by the rail's writing mode. */
    flex: none;
    width: 0.875rem;
    height: 0.875rem;
    background: ${$18ef4d8ebb42032f$var$calendarIcon('%23ffffff')} no-repeat center / contain;
}
/* Day headings \u{2014} the ordinal alone, because the band around them names the month and year. Their rule
   spans the band's full width, gutter included, while the text starts after it. */
.${$18ef4d8ebb42032f$export$c2f4692642028b8d} h1 {
    margin: 1.25rem calc(-1 * var(--breakdown-inset)) 0.5rem 0;
    padding: 0 0 0.25rem var(--breakdown-gutter);
    border-bottom: 1px solid #cbd5e1;
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    color: #1e293b;
}
/* The band's own heading already opens it, so its first day sits closer than a mid-band one. */
.${$18ef4d8ebb42032f$export$c2f4692642028b8d} h2 + h1 { margin-top: 0.5rem; }
/* The ordinal's raised suffix (\`1<sup>st</sup>\`). Smaller than the browser default's \`smaller\`, and
   lifted by a fixed amount, so it reads as part of the number rather than as a footnote mark. */
.${$18ef4d8ebb42032f$export$c2f4692642028b8d} h1 sup {
    font-size: 0.65em;
    vertical-align: baseline;
    position: relative;
    top: -0.45em;
}
.${$18ef4d8ebb42032f$export$c2f4692642028b8d} p {
    position: relative;
    margin: 0.25rem 0;
    padding-left: var(--breakdown-gutter);
}
.${$18ef4d8ebb42032f$export$c2f4692642028b8d} table {
    margin: 0.5rem 0 0.5rem var(--breakdown-gutter);
    width: calc(100% - var(--breakdown-gutter));
    border-collapse: collapse;
    border: 1px solid #cbd5e1;
}
.${$18ef4d8ebb42032f$export$c2f4692642028b8d} th,
.${$18ef4d8ebb42032f$export$c2f4692642028b8d} td {
    border: 1px solid #cbd5e1;
    padding: 0.25rem 0.5rem;
}
.${$18ef4d8ebb42032f$export$c2f4692642028b8d} th {
    background-color: #f1f5f9;
    text-align: left;
    font-weight: 600;
    color: #475569;
}
.${$18ef4d8ebb42032f$export$c2f4692642028b8d} td {
    text-align: right;
    font-variant-numeric: tabular-nums;
}
.${$18ef4d8ebb42032f$export$c2f4692642028b8d} tr.total {
    border-top: 2px solid #94a3b8;
    font-weight: 700;
}
.${$18ef4d8ebb42032f$export$c2f4692642028b8d} tr.total > * { background-color: #e2e8f0; }
/* A birthday's gutter carries a glyph instead of a series marker \u{2014} nothing on any chart moves, so
   there is no bar colour to echo. Centred in the gutter and locked to the first line's height, so a
   sentence that wraps keeps its emoji beside the line that names the person. */
.${$18ef4d8ebb42032f$export$c2f4692642028b8d} p.${(0, $784f4552e43405e4$export$9584f98fb3634bdd)}::before {
    content: '\u{1F389}';
    position: absolute;
    left: 0;
    top: 0;
    width: var(--breakdown-gutter);
    line-height: var(--breakdown-line);
    /* As big as the gutter will take without crowding the sentence beside it. */
    font-size: 1rem;
    text-align: center;
}
${$18ef4d8ebb42032f$var$markerRules()}
/* Wide viewport: the month's grey bar is stood on its end and becomes a rail down the band's left
   edge, which buys back the line it spent across the top and leaves the label visible the whole way
   down a long month. Narrow stays the bar above \u{2014} a rail costs horizontal room a phone hasn't got. */
@media (min-width: ${$18ef4d8ebb42032f$export$ef1a0b29bb73c505}) {
    .${$18ef4d8ebb42032f$export$c2f4692642028b8d} .${(0, $784f4552e43405e4$export$6f748270a8ec4e99)} {
        --breakdown-rail: 1.75rem;
        /* A band with one sentence in it is shorter than its own label standing up, and would clip it.
           Tall enough for the icon, the gap and eight uppercase characters of \`MMM YYYY\`. */
        min-height: 7.5rem;
    }
    .${$18ef4d8ebb42032f$export$c2f4692642028b8d} .${(0, $784f4552e43405e4$export$6f748270a8ec4e99)} > h2 {
        position: absolute;
        /* The band's padding box, i.e. the rail its left padding reserved. */
        left: 0;
        top: 0;
        bottom: 0;
        width: var(--breakdown-rail);
        margin: 0;
        padding: 0.5rem 0;
        /* Stands the label up reading BOTTOM TO TOP, in two steps because no writing mode does that on
           its own that every browser has: \`vertical-rl\` turns it 90\xb0 reading downwards, then a half turn
           of the whole box reverses it. (\`sideways-lr\` would say this in one line, and is too new.) */
        writing-mode: vertical-rl;
        transform: rotate(180deg);
        /* Along the rail (the inline axis, now vertical) and then across it. */
        justify-content: center;
        align-items: center;
        /* The half turn moves main-start to the bottom of the rail, so the icon \u{2014} the first item \u{2014} is
           laid out from there and lands back at the TOP once the box is turned. */
        flex-direction: row-reverse;
    }
    /* Turned back the right way up: the label is upside down by design, an icon never is. */
    .${$18ef4d8ebb42032f$export$c2f4692642028b8d} .${(0, $784f4552e43405e4$export$6f748270a8ec4e99)} > h2::before { transform: rotate(180deg); }
}
`;



/**
 * projectionsModalPreferences.ts – the projections modal's two header toggles, remembered on the
 * device: "financial year / calendar year" and "future dollars / today's dollars".
 *
 * These are reading preferences, not properties of a client file or a strategy — whichever way
 * someone likes to read a projection, they like it that way every time they open one. So the modal
 * owns both toggles and they persist here, rather than being handed in by whoever opens the modal
 * (which reset them to the caller's default on every open).
 *
 * AgedCareAnalyser reads the period mode too: it, not the modal, runs the engine, and calendar-year
 * rows are a separate run. Both sides read this one store, so they open in step with no flash of
 * financial-year rows under calendar-year headings.
 *
 * Every access is wrapped — localStorage throws in some private-browsing modes, and a preference
 * that can't be stored must simply fall back to the default, never break the modal.
 */ /** The two period modes the modal offers — the engine's third (`'strategy_year'`) has no UI. */ const $4f50ab660c01dd64$var$PERIOD_MODE_KEY = 'awiseProjectionsPeriodMode';
const $4f50ab660c01dd64$var$TODAYS_DOLLARS_KEY = 'awiseProjectionsTodaysDollars';
function $4f50ab660c01dd64$var$readStored(key) {
    try {
        return localStorage.getItem(key);
    } catch  {
        return null;
    }
}
function $4f50ab660c01dd64$var$writeStored(key, value) {
    try {
        localStorage.setItem(key, value);
    } catch  {
    /* private mode: the preference just won't stick */ }
}
function $4f50ab660c01dd64$export$1e222c2c280e2a28() {
    return $4f50ab660c01dd64$var$readStored($4f50ab660c01dd64$var$PERIOD_MODE_KEY) === 'calendar_year' ? 'calendar_year' : 'financial_year';
}
function $4f50ab660c01dd64$export$6e08d2e852397dd0(mode) {
    $4f50ab660c01dd64$var$writeStored($4f50ab660c01dd64$var$PERIOD_MODE_KEY, mode);
}
function $4f50ab660c01dd64$export$c27308c98589c1ec() {
    return $4f50ab660c01dd64$var$readStored($4f50ab660c01dd64$var$TODAYS_DOLLARS_KEY) === '1';
}
function $4f50ab660c01dd64$export$1c8d458778a9d2ce(todaysDollars) {
    $4f50ab660c01dd64$var$writeStored($4f50ab660c01dd64$var$TODAYS_DOLLARS_KEY, todaysDollars ? '1' : '0');
}


/** A column heading or cost label in normal case: "Support at Home Costs" reads "Support at home costs". */ const $9847d752f8df838f$var$sentenceCase = (s)=>s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s;
const $9847d752f8df838f$var$NARROW_QUERY = '(max-width: 639px)';
/**
 * True on a phone held upright (narrower than 640px), where the table becomes one card per year. Laptop and
 * iPad widths keep the table (owner, 25 Oct 2026: "would it still look like it does today on a normal
 * laptop/iPad"). Read from matchMedia rather than CSS so only ONE of the two is in the page; without matchMedia
 * (a test, an old browser) it is the table.
 */ function $9847d752f8df838f$var$useNarrowScreen() {
    const supported = typeof window !== 'undefined' && typeof window.matchMedia === 'function';
    const [narrow, setNarrow] = (0, $acw62.useState)(()=>supported ? window.matchMedia($9847d752f8df838f$var$NARROW_QUERY).matches : false);
    (0, $acw62.useEffect)(()=>{
        if (!supported) return undefined;
        const mq = window.matchMedia($9847d752f8df838f$var$NARROW_QUERY);
        const onChange = ()=>setNarrow(mq.matches);
        mq.addEventListener?.('change', onChange);
        return ()=>mq.removeEventListener?.('change', onChange);
    }, [
        supported
    ]);
    return narrow;
}
function $9847d752f8df838f$export$8acc397fcdf9fb8c(periodStart) {
    if (!periodStart) return null;
    const date = new Date(periodStart);
    if (Number.isNaN(date.getTime())) return null;
    return date.toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short'
    });
}
function $9847d752f8df838f$export$dbe2017ac6e90e6c(year, annualRate, forPeriod, formatCurrencyFn) {
    if (!year.isPartialFy || Math.abs(annualRate - forPeriod) < 1) return [];
    // Days rather than a bare fraction: "148 of 365 days" is checkable against the dates in the row's
    // own title, where "0.4055 of a year" is not.
    const days = Math.round((year.periodYearFraction ?? 1) * 365);
    return [
        {
            label: '---',
            value: ''
        },
        {
            label: 'Annual rate (the lines above)',
            value: formatCurrencyFn(annualRate)
        },
        {
            label: `This period (${days} of 365 days)`,
            value: formatCurrencyFn(forPeriod)
        }
    ];
}
function $9847d752f8df838f$export$44606fe93726a096(year, paid, formatCurrencyFn) {
    const opening = year.socialSecurity ?? 0;
    const closing = year.socialSecurityAtPeriodEnd ?? opening;
    // No material movement: keep the ordinary partial-year scaling lines (or nothing on a full year).
    if (Math.abs(closing - opening) < 1) return $9847d752f8df838f$export$dbe2017ac6e90e6c(year, opening, paid, formatCurrencyFn);
    const days = Math.round((year.periodYearFraction ?? 1) * 365);
    return [
        {
            label: '---',
            value: ''
        },
        {
            label: 'Rate at start of year (the lines above)',
            value: `${formatCurrencyFn(opening)} p.a.`
        },
        {
            label: 'Rate by end of year',
            value: `${formatCurrencyFn(closing)} p.a.`
        },
        // Plain words for the consumer; the adviser has the two rates to check against a Centrelink letter.
        {
            label: 'Why it moved',
            value: 'Re-assessed each fortnight as assets and income changed during the year'
        },
        {
            label: `Paid this period (${days} of 365 days)`,
            value: formatCurrencyFn(paid)
        }
    ];
}
/**
 * When `year.cashFlowBreakdown` is missing, split total investment income into non-ABP vs ABP for
 * reconciliation. `periodShare` scales both to the days the row covers (1 for a full row), so these
 * lines add up to the headline figure beside them rather than to a full year's.
 */ function $9847d752f8df838f$var$buildFallbackInvestmentIncomeLines(year, periodShare, formatCurrencyFn) {
    const total = year.investmentIncomeForPartialPeriod ?? year.investmentIncome ?? 0;
    const abp = (year.abpIncome ?? 0) * periodShare;
    const other = Math.max(0, total - abp);
    const lines = [];
    if (other > 0) lines.push({
        label: 'Investment Income',
        value: '+' + formatCurrencyFn(other)
    });
    if (abp > 0) lines.push({
        label: 'ABP Income',
        value: '+' + formatCurrencyFn(abp)
    });
    if (lines.length === 0 && total > 0) lines.push({
        label: 'Investment Income',
        value: '+' + formatCurrencyFn(total)
    });
    return lines;
}
const $9847d752f8df838f$export$2d0b9ca88b9f5e66 = ({ projections: projections, agedCareCosts: agedCareCosts, factFind: factFind, initialFinancials: initialFinancials, currentFinancials: currentFinancials, onPeriodModeChange: onPeriodModeChange, isReloading: isReloading = false, costLabel: costLabel = 'Aged Care Costs', costSource: costSource = 'care', comparedOverYears: comparedOverYears })=>{
    // The cost column is present unless a module said it has no recurring cost at all.
    const showCostColumn = costLabel !== null;
    const costHeading = $9847d752f8df838f$var$sentenceCase(costLabel ?? '');
    const narrow = $9847d752f8df838f$var$useNarrowScreen();
    // The chart on show — held here so the heading above the chooser names it.
    const [pane, setPane] = (0, $acw62.useState)('cashflow');
    const paneHeading = (0, $9530f15b0134fa22$export$949b07d5dccd05b2).find((p)=>p.id === pane)?.heading ?? 'Year by year';
    // Both toggles open on whatever the user last chose (see projectionsModalPreferences). Lazy
    // initialisers, so localStorage is read once per open rather than on every render. Without a
    // re-run pathway the rows are financial-year cuts and stay that way, whatever the sticky says.
    const [periodMode, setPeriodMode] = (0, $acw62.useState)(()=>onPeriodModeChange ? (0, $4f50ab660c01dd64$export$1e222c2c280e2a28)() : 'financial_year');
    // false = show nominal "future dollars" (default); true = deflate to real "today's dollars".
    const [todaysDollars, setTodaysDollars] = (0, $acw62.useState)((0, $4f50ab660c01dd64$export$c27308c98589c1ec));
    const calendarYears = periodMode === 'calendar_year';
    // Wording that follows the period the rows are cut on: a calendar row closes on 31 December, an
    // Australian financial year on 30 June. Shared with both SOAs, so a document can never name a
    // period the numbers underneath it were not cut on.
    const period = (0, $48fd3f316ae581a6$export$f15392dd2f17ee04)(periodMode);
    const periodNoun = period.noun;
    const periodCloseDate = period.closesOn;
    const [projectionsIntroExpanded, setProjectionsIntroExpanded] = (0, $acw62.useState)(false);
    /** Remember the choice, then ask the owner for rows cut the new way — it, not the view, runs the engine. */ const changePeriodMode = (mode)=>{
        if (!onPeriodModeChange) return; // no re-run pathway => the toggle isn't rendered
        setPeriodMode(mode);
        (0, $4f50ab660c01dd64$export$6e08d2e852397dd0)(mode);
        onPeriodModeChange(mode);
    };
    const changeTodaysDollars = (next)=>{
        setTodaysDollars(next);
        (0, $4f50ab660c01dd64$export$1c8d458778a9d2ce)(next);
    };
    // Which years' human-readable HTML breakdowns are expanded (see `ProjectionYear.breakdown`).
    const [breakdownExpanded, setBreakdownExpanded] = (0, $acw62.useState)({});
    const toggleBreakdown = (index)=>setBreakdownExpanded((prev)=>({
                ...prev,
                [index]: !prev[index]
            }));
    // CPI is constant across the projection (server sets it once); fall back to the engine's 2.5% default.
    const inflationPct = projections.find((y)=>y.inflationPct != null)?.inflationPct ?? 2.5;
    // "Today's dollars": deflate a year's nominal value by inflation compounded over the number of years
    // since the first projection row. Year index 0 ("Comparison Yr1" / current year) is never deflated,
    // so the toggle has no effect on first-year values.
    const isConverted = (yearIndex)=>todaysDollars && yearIndex > 0;
    const deflateFactor = (yearIndex)=>isConverted(yearIndex) ? 1 / Math.pow(1 + inflationPct / 100, yearIndex) : 1;
    const deflateAmount = (value, yearIndex)=>value * deflateFactor(yearIndex);
    /** Deflate every `$1,234` / `-$1,234` occurrence inside an arbitrary string (e.g. a pre-formatted breakdown value). */ const deflateCurrencyString = (str, yearIndex)=>{
        const factor = deflateFactor(yearIndex);
        if (factor === 1) return str;
        return str.replace(/-?\$[\d,]+/g, (match)=>{
            const negative = match.startsWith('-');
            const numeric = parseFloat(match.replace(/[-$,]/g, '')) || 0;
            return (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((negative ? -numeric : numeric) * factor);
        });
    };
    /** Deflate a tooltip breakdown's rows: numeric values numerically, pre-formatted string values by scanning for `$` amounts. */ const deflateRows = (rows, yearIndex)=>deflateFactor(yearIndex) === 1 ? rows : rows.map((row)=>({
                ...row,
                value: typeof row.value === 'number' ? deflateAmount(row.value, yearIndex) : deflateCurrencyString(row.value, yearIndex)
            }));
    // Blue text signals a value that has been converted to today's dollars; otherwise keep the base colour.
    const moneyClass = (yearIndex, baseColorClass)=>isConverted(yearIndex) ? 'text-blue-600' : baseColorClass;
    /** Render a year's breakdown HTML, replacing `<nv>` nominal-value tags: converted → deflated blue span; otherwise the plain amount. */ const renderBreakdownHtml = (html, yearIndex)=>isConverted(yearIndex) ? html.replace(/<nv>(.*?)<\/nv>/g, (_full, inner)=>`<span class="text-blue-600 font-semibold">${deflateCurrencyString(inner, yearIndex)}</span>`) : html.replace(/<\/?nv>/g, '');
    // The chart accordion's three sets of points, deflated per year exactly like the table below them
    // so the today's-dollars toggle moves both together. Built in one memo — `deflateFactor` above is
    // rebuilt every render, so a helper closing over it would have to be excluded from the deps.
    const chartPoints = (0, $acw62.useMemo)(()=>{
        const deflate = (points)=>points.map((point, index)=>(0, $c7535f09b538739e$export$48b6af00fdba8642)(point, todaysDollars && index > 0 ? 1 / Math.pow(1 + inflationPct / 100, index) : 1));
        return {
            cashflow: deflate((0, $0efeff8c700b6d35$export$b88c55ac44748b76)(projections, (agedCareCosts?.totalDailyCost || 0) * 365)),
            netWorth: deflate((0, $39d41c0c5ff73395$export$2b4aba4110cde27f)(projections)),
            debt: deflate((0, $39d41c0c5ff73395$export$c3417c7a35be72)(projections))
        };
    }, [
        projections,
        agedCareCosts,
        todaysDollars,
        inflationPct
    ]);
    const createAssetBreakdown = (yearIndex)=>{
        const year = projections[yearIndex];
        const breakdown = [];
        if (yearIndex === 0) {
            if (factFind.home?.value) breakdown.push({
                label: 'Family Home',
                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(factFind.home.value))
            });
            (0, $77d0522707ddb581$export$e18ad1b53d14ba76).forEach((type)=>{
                const assetList = factFind.assets?.[type.id];
                if (type.isLiquid && assetList) assetList.forEach((asset, index)=>{
                    const rawValue = asset.balance != null ? asset.balance : asset.value;
                    const numeric = rawValue || 0;
                    if (numeric > 0) breakdown.push({
                        label: `${asset.name || asset.description || type.name} ${index + 1}`,
                        value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(numeric)
                    });
                });
            });
            const radPaidAssets = factFind.assets?.radPaid;
            if (radPaidAssets && radPaidAssets.length > 0) radPaidAssets.forEach((rad, index)=>{
                const val = parseFloat(String(rad.value)) || 0;
                if (val > 0) breakdown.push({
                    label: `RAD Paid ${index + 1}`,
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(val)
                });
            });
        } else if (year?.assets) {
            if (year.home?.value) breakdown.push({
                label: 'Family Home',
                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(year.home.value)
            });
            if (year.assets.bankAccounts && year.assets.bankAccounts.length > 0) year.assets.bankAccounts.forEach((account, index)=>{
                if ((account.balance || 0) > 0) breakdown.push({
                    label: `${account.name || 'Bank Account'} ${index + 1}`,
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(account.balance || 0)
                });
            });
            if (year.assets.shares && year.assets.shares.length > 0) year.assets.shares.forEach((share, index)=>{
                if ((share.value || 0) > 0) breakdown.push({
                    label: `${share.name || 'Shares'} ${index + 1}`,
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(share.value || 0)
                });
            });
            if (year.assets.accountBasedPensions && year.assets.accountBasedPensions.length > 0) year.assets.accountBasedPensions.forEach((abp, index)=>{
                if ((abp.value || 0) > 0) breakdown.push({
                    label: `${abp.description || 'ABP'} ${index + 1}`,
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(abp.value || 0)
                });
            });
            if (year.assets.radPaid && year.assets.radPaid.length > 0) year.assets.radPaid.forEach((rad, index)=>{
                breakdown.push({
                    label: `RAD Paid ${index + 1}`,
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(rad.value || 0)
                });
            });
        }
        const openingBalance = yearIndex === 0 ? currentFinancials?.netWorth || initialFinancials?.netWorth || 0 : projections[yearIndex - 1]?.netWorth || 0;
        breakdown.push({
            label: '=== TOTAL NET WORTH ===',
            value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(openingBalance)
        });
        return breakdown;
    };
    const createAgePensionBreakdown = (yearIndex, agePension)=>{
        const year = projections[yearIndex];
        const breakdown = [];
        if (year?.socialSecurityBreakdown && Array.isArray(year.socialSecurityBreakdown)) year.socialSecurityBreakdown.forEach((item)=>{
            breakdown.push({
                label: item.label,
                value: typeof item.value === 'number' ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(item.value) : item.value
            });
        });
        else {
            breakdown.push({
                label: 'Age Pension',
                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(agePension)
            });
            breakdown.push({
                label: 'Family Home Status',
                value: yearIndex < 2 ? 'Exempt (first 2 years)' : 'Assessable (after 2 years)'
            });
            breakdown.push({
                label: 'Asset Test Impact',
                value: yearIndex < 2 ? 'Home exempt from asset test' : 'Home included in asset test'
            });
        }
        return breakdown;
    };
    /**
   * One row's headline figures, for the table and the phone cards alike — so the two can never disagree. Every
   * money figure is the one for the days the row COVERS: the engine's partial-period figure where it set one, the
   * annual rate otherwise. A row that opens on 6 August showed a full year's pension and care fees next to a
   * balance sheet that had only moved by the period's share — the columns disagreed with each other.
   */ const rowFigures = (index)=>{
        const year = projections[index];
        const periodShare = year.isPartialFy ? year.periodYearFraction ?? 1 : 1;
        return {
            periodShare: periodShare,
            openingBalance: index === 0 ? currentFinancials?.netWorth || initialFinancials?.netWorth || 0 : projections[index - 1]?.netWorth || 0,
            closingBalance: year.netWorth || 0,
            // The pension actually DEPOSITED across this row's days, not the rate the year opened on. They differ
            // whenever the entitlement moves inside the year — a RAD paid on 1 December lifts it from that day, and a
            // client reaching pension age in August is paid from their birthday.
            agePension: year.agePensionPaidForPeriod ?? year.socialSecurityForPartialPeriod ?? year.socialSecurity ?? 0,
            // The recurring cost this module charges: aged care / Support at Home fees by default, village fees for a
            // Retirement Village row (the engine pro-rates both to the period), nothing where the column is hidden.
            annualCareCosts: costSource === 'village' ? year.annualVillageCost ?? 0 : year.annualCareCostForPartialPeriod ?? year.annualCareCost ?? (agedCareCosts?.totalDailyCost || 0) * 365 * periodShare,
            netCashflow: year.cashFlowForPartialPeriod ?? year.cashFlow ?? 0
        };
    };
    const yearName = (year, index)=>year.fyLabel || `Year ${index + 1}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "px-4 sm:px-6 py-3 border-b border-slate-100 bg-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-wrap justify-between items-center gap-x-4 gap-y-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                            className: "min-w-0 text-lg font-bold tracking-tight text-brand-navy",
                            "data-testid": "projections-pane-heading",
                            children: paneHeading
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap items-center justify-end gap-x-3 gap-y-2 ml-auto",
                            children: [
                                onPeriodModeChange ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 text-sm font-medium",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: calendarYears ? 'text-slate-400' : 'text-slate-700',
                                            children: "Financial year"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            role: "switch",
                                            "aria-checked": calendarYears,
                                            "aria-label": calendarYears ? 'Showing calendar years' : 'Showing financial years',
                                            disabled: isReloading,
                                            onClick: ()=>changePeriodMode(calendarYears ? 'financial_year' : 'calendar_year'),
                                            title: calendarYears ? 'Showing calendar years: each row runs 1 January to 31 December. Switch left for Australian financial years.' : 'Showing Australian financial years: each row runs 1 July to 30 June. Switch right for calendar years.',
                                            className: `relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border transition-colors disabled:cursor-wait disabled:opacity-60 ${calendarYears ? 'border-brand-navy bg-brand-navy' : 'border-slate-300 bg-slate-300'}`,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: `inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform ${calendarYears ? 'translate-x-6' : 'translate-x-1'}`,
                                                "aria-hidden": true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: calendarYears ? 'text-slate-700' : 'text-slate-400',
                                            children: "Calendar year"
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 text-sm font-medium",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: todaysDollars ? 'text-slate-400' : 'text-slate-700',
                                            children: "Future dollars"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            role: "switch",
                                            "aria-checked": todaysDollars,
                                            "aria-label": todaysDollars ? "Showing today's dollars" : 'Showing future dollars',
                                            onClick: ()=>changeTodaysDollars(!todaysDollars),
                                            title: todaysDollars ? "Showing today's dollars: future values are deflated by inflation so they compare with money today. Switch left for future dollars." : "Showing future dollars (nominal): the actual amounts in each future year. Switch right for today\u2019s dollars.",
                                            className: `relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border transition-colors ${todaysDollars ? 'border-blue-300 bg-blue-500' : 'border-slate-300 bg-slate-300'}`,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: `inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform ${todaysDollars ? 'translate-x-6' : 'translate-x-1'}`,
                                                "aria-hidden": true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: todaysDollars ? 'text-blue-700' : 'text-slate-400',
                                            children: "Today's dollars"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative flex-1 min-h-0 flex",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex-1 overflow-y-auto px-4 sm:px-6 py-5 w-full min-w-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: `space-y-4 w-full max-w-none ${isReloading ? 'pointer-events-none' : ''}`,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9530f15b0134fa22$export$2e2bcd8739ae039), {
                                    cashflow: chartPoints.cashflow,
                                    netWorth: chartPoints.netWorth,
                                    debt: chartPoints.debt,
                                    formatValue: (0, $f94e45ac645ae232$export$3dc27271f5d5c629),
                                    pane: pane,
                                    onPaneChange: setPane
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex flex-wrap items-center justify-between gap-2 gap-y-1",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>setProjectionsIntroExpanded((v)=>!v),
                                        className: "inline-flex items-center gap-1.5 shrink-0 rounded-lg px-2 py-1 text-sm font-medium text-blue-700 hover:bg-slate-50 hover:text-blue-900 transition-colors",
                                        "aria-expanded": projectionsIntroExpanded,
                                        "aria-controls": "projections-five-year-intro",
                                        id: "projections-five-year-intro-toggle",
                                        children: [
                                            projectionsIntroExpanded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4 shrink-0",
                                                "aria-hidden": true
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4 shrink-0",
                                                "aria-hidden": true
                                            }),
                                            "How to read this"
                                        ]
                                    })
                                }),
                                projectionsIntroExpanded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    id: "projections-five-year-intro",
                                    role: "region",
                                    "aria-labelledby": "projections-five-year-intro-toggle",
                                    className: "w-full max-w-none rounded-lg border border-slate-200/90 bg-slate-50/70 px-3 py-2.5",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-sm text-slate-600 leading-relaxed",
                                            children: [
                                                "These projections are ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "illustrative only"
                                                }),
                                                ". They can change with the timing of your strategy, investment returns, and future threshold or rule changes."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-sm text-slate-600 leading-relaxed mt-2",
                                            children: [
                                                "Each row shows what that year ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "actually pays"
                                                }),
                                                ". The Financial Impact panel shows a ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "normalised year"
                                                }),
                                                " instead \u2014 your plan's full 12-month impact as if it were in place today \u2014 so the year the plan starts will sit between the panel's before and after figures."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-sm text-slate-600 leading-relaxed mt-2",
                                            children: [
                                                "Each row is named for the ",
                                                periodNoun,
                                                " it covers. Where your projection starts part-way through one, the row says so and every figure on it \u2014 pension, care costs, cashflow and the balance sheet \u2014 covers only the days from that date to ",
                                                periodCloseDate,
                                                ". Open a figure's tooltip to see the annual rate it was worked from and the share of it this period carries."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-slate-600 leading-relaxed mt-2",
                                            children: calendarYears ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    "Rows are cut on ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "calendar years"
                                                    }),
                                                    " (1 January to 31 December), per the toggle above, which is also how the modelling runs \u2014 growth is applied on 1 January, and the Age Pension, care fees and the closing balance sheet are struck on 31 December \u2014 so nothing is blended or estimated between periods. The one thing that does not move is the law: Australian tax and Centrelink years run 1 July to 30 June, so the tax on a calendar row is assessed over that calendar year for modelling purposes and will not match a tax return. The calculation breakdown shows every event on the real date it happened."
                                                ]
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    "Rows are cut on ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "financial years"
                                                    }),
                                                    " (1 July to 30 June), per the toggle above, which is also how the modelling runs \u2014 so each row's figures are that financial year's, with nothing blended or estimated between periods."
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-sm text-slate-600 leading-relaxed mt-2",
                                            children: [
                                                "Open a row and you'll see several dates each month. That's three separate rhythms running at once. ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "The 1st of each month"
                                                }),
                                                " is when growth is applied to the home and to investments \u2014 monthly rather than once a year, so a mid-year event lands on a realistic balance. ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Every fortnight"
                                                }),
                                                " the Age Pension arrives and living expenses come out, because that is how they are actually received and spent. ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Aged care fees"
                                                }),
                                                " come out monthly, from the day care starts. Anything with a date of its own \u2014 a birthday, moving into care, selling an asset \u2014 appears on that date. The last day of the ",
                                                periodNoun,
                                                " is where the year is squared up: any shortfall is funded and the closing balance sheet is struck."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-sm text-slate-600 leading-relaxed mt-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "The exact days are illustrative."
                                                }),
                                                " Centrelink sets each person's own pension payday, so yours will very likely fall on a different day of the fortnight to the one shown. Super and account-based pension payments depend on what you and your provider have arranged \u2014 monthly, quarterly or annually \u2014 and aged care providers invoice on their own cycles. We use regular, evenly-spaced dates so the picture is realistic and consistent; the ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                                    children: "amounts"
                                                }),
                                                " and the totals for each year are what these projections are for, not the precise day money moves."
                                            ]
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("style", {
                                    children: (0, $18ef4d8ebb42032f$export$f612729a456e44c5)
                                }),
                                !narrow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "rounded-xl border border-slate-200 overflow-x-auto shadow-sm",
                                    "data-testid": "projections-table-scroller",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                        className: "w-full text-sm border-collapse min-w-[900px]",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            className: "px-4 py-3 text-left font-semibold border-b border-slate-200/90 bg-white text-slate-600 text-xs",
                                                            children: "Year"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            className: "px-4 py-3 text-left font-semibold border-b border-slate-200/90 bg-white text-slate-600 text-xs",
                                                            children: "Owned at the start"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            className: "px-4 py-3 text-left font-semibold border-b border-slate-200/90 bg-white text-slate-600 text-xs",
                                                            children: "Age Pension"
                                                        }),
                                                        showCostColumn && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            className: "px-4 py-3 text-left font-semibold border-b border-slate-200/90 bg-white text-slate-600 text-xs",
                                                            children: costHeading
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            className: "px-4 py-3 text-left font-semibold border-b border-slate-200/90 bg-white text-slate-600 text-xs",
                                                            children: "In, less out"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            className: "px-4 py-3 text-left font-semibold border-b border-slate-200/90 bg-white text-slate-600 text-xs",
                                                            children: "Owned at the end"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            className: "px-2 py-3 border-b border-slate-200/90 bg-white w-10",
                                                            "aria-label": "Calculation breakdown"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                children: projections.map((year, index)=>{
                                                    const { periodShare: periodShare, openingBalance: openingBalance, closingBalance: closingBalance, agePension: agePension, annualCareCosts: annualCareCosts, netCashflow: netCashflow } = rowFigures(index);
                                                    const investmentIncome = year.investmentIncomeForPartialPeriod ?? year.investmentIncome ?? 0;
                                                    const fallbackInvLines = $9847d752f8df838f$var$buildFallbackInvestmentIncomeLines(year, periodShare, (0, $f94e45ac645ae232$export$3dc27271f5d5c629));
                                                    // Rental income has no partial-period sibling on the row, so it is scaled here. It
                                                    // only ever reaches the fallback tooltip lines below (the ones used when the engine
                                                    // sent no `cashFlowBreakdown`), which must still add up to the headline.
                                                    const rentalIncome = (year.rentalIncome || 0) * periodShare;
                                                    const livingExpenses = year.livingExpensesForPartialPeriod ?? year.livingExpenses ?? 0;
                                                    const tax = year.taxForPartialPeriod ?? year.tax ?? 0;
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                className: `border-b border-slate-100 last:border-b-0 transition-colors hover:bg-sky-50/50 ${index % 2 === 0 ? 'bg-white' : 'bg-slate-50/60'}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        className: "px-4 py-3 whitespace-nowrap text-sm font-medium text-slate-900",
                                                                        children: year.fyLabel ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            title: year.periodStart && year.periodEnd ? `${year.periodStart.slice(0, 10)} \u{2192} ${year.periodEnd.slice(0, 10)}` : undefined,
                                                                            children: [
                                                                                year.fyLabel,
                                                                                year.isPartialFy ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                    className: "block text-xs font-normal text-slate-500",
                                                                                    children: [
                                                                                        $9847d752f8df838f$export$8acc397fcdf9fb8c(year.periodStart) ? `from ${$9847d752f8df838f$export$8acc397fcdf9fb8c(year.periodStart)} ` : '',
                                                                                        "(partial year)"
                                                                                    ]
                                                                                }) : null
                                                                            ]
                                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                            children: [
                                                                                "Year ",
                                                                                index + 1
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        className: "px-4 py-3 whitespace-nowrap text-sm text-slate-900 relative",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bea2c523253f544$export$2e2bcd8739ae039), {
                                                                            className: `font-mono ${moneyClass(index, '')}`,
                                                                            title: "Net Worth (Opening) Breakdown",
                                                                            data: deflateRows(createAssetBreakdown(index), index),
                                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(deflateAmount(openingBalance, index))
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        className: "px-4 py-3 whitespace-nowrap text-sm relative",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bea2c523253f544$export$2e2bcd8739ae039), {
                                                                            className: `font-mono ${moneyClass(index, agePension > 0 ? 'text-green-600' : 'text-gray-500')}`,
                                                                            title: "Age Pension Breakdown (estimate)",
                                                                            data: deflateRows([
                                                                                ...createAgePensionBreakdown(index, year.socialSecurity || 0),
                                                                                ...$9847d752f8df838f$export$44606fe93726a096(year, agePension, (0, $f94e45ac645ae232$export$3dc27271f5d5c629))
                                                                            ], index),
                                                                            children: agePension > 0 ? `+${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(deflateAmount(agePension, index))}` : (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(deflateAmount(agePension, index))
                                                                        })
                                                                    }),
                                                                    showCostColumn && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        className: "px-4 py-3 whitespace-nowrap text-sm relative",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6bea2c523253f544$export$2e2bcd8739ae039), {
                                                                            className: `font-mono ${moneyClass(index, 'text-red-600')}`,
                                                                            title: `${costHeading} Breakdown`,
                                                                            data: deflateRows([
                                                                                ...year.agedCareBreakdown && year.agedCareBreakdown.length > 0 ? year.agedCareBreakdown : [
                                                                                    {
                                                                                        label: `Total ${costHeading} (annual rate)`,
                                                                                        value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(costSource === 'village' ? annualCareCosts : year.annualCareCost || 0)
                                                                                    }
                                                                                ],
                                                                                ...costSource === 'village' ? [] : $9847d752f8df838f$export$dbe2017ac6e90e6c(year, year.annualCareCost || 0, annualCareCosts, (0, $f94e45ac645ae232$export$3dc27271f5d5c629))
                                                                            ], index),
                                                                            children: [
                                                                                "-",
                                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(deflateAmount(annualCareCosts, index))
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        className: "px-4 py-3 whitespace-nowrap text-sm relative",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6bea2c523253f544$export$2e2bcd8739ae039), {
                                                                            className: `font-mono ${moneyClass(index, netCashflow >= 0 ? 'text-green-600' : 'text-red-600')}`,
                                                                            title: "Net Cashflow Breakdown",
                                                                            data: deflateRows((()=>{
                                                                                /*
                                 * The care fees leave the bank monthly from admission, outside the year's
                                 * income-and-spending lines, so they are listed here — at the same ANNUAL
                                 * rate as the lines above, which is what the year's cashflow nets them at,
                                 * so the tooltip adds up to its "Annual rate" line. Skipped only where the
                                 * engine's own lines already carry this module's cost (the village module's
                                 * fees). It used to skip on ANY line naming a village, which hid an aged
                                 * care resident's fees once village fees joined their lines (owner-caught,
                                 * 9 Oct 2026, on Bob Singletocare).
                                 */ const listed = (year.cashFlowBreakdown || []).reduce((t, item)=>t + (typeof item.value === 'number' ? item.value : 0), 0);
                                                                                const careAtAnnualRate = Math.max(0, listed - (Number(year.cashFlow) || 0));
                                                                                const engineListsCost = (year.cashFlowBreakdown || []).some((item)=>{
                                                                                    const l = item.label.toLowerCase();
                                                                                    return l.includes('aged care') || l.includes('care cost') || costSource === 'village' && l.includes('village');
                                                                                });
                                                                                const base = year.cashFlowBreakdown ? [
                                                                                    ...year.cashFlowBreakdown.map((item)=>({
                                                                                            label: item.label,
                                                                                            value: item.value
                                                                                        })),
                                                                                    ...!showCostColumn || annualCareCosts === 0 || engineListsCost || careAtAnnualRate < 1 ? [] : [
                                                                                        {
                                                                                            label: `--- ${costHeading.toUpperCase()} ---`,
                                                                                            value: ''
                                                                                        },
                                                                                        {
                                                                                            label: costSource === 'village' ? costHeading : `Less: ${costHeading} (paid monthly from the day care begins)`,
                                                                                            value: -careAtAnnualRate
                                                                                        }
                                                                                    ]
                                                                                ] : [
                                                                                    {
                                                                                        label: '--- INCOME ---',
                                                                                        value: ''
                                                                                    },
                                                                                    {
                                                                                        label: 'Age Pension',
                                                                                        value: '+' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(agePension)
                                                                                    },
                                                                                    ...fallbackInvLines,
                                                                                    {
                                                                                        label: 'Rental Income',
                                                                                        value: '+' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(rentalIncome)
                                                                                    },
                                                                                    {
                                                                                        label: '--- Total Income ---',
                                                                                        value: '+' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(agePension + investmentIncome + rentalIncome)
                                                                                    },
                                                                                    {
                                                                                        label: '--- EXPENSES ---',
                                                                                        value: ''
                                                                                    },
                                                                                    ...showCostColumn && annualCareCosts !== 0 ? [
                                                                                        {
                                                                                            label: costHeading,
                                                                                            value: '-' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(annualCareCosts)
                                                                                        }
                                                                                    ] : [],
                                                                                    {
                                                                                        label: 'Living Expenses',
                                                                                        value: '-' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(livingExpenses)
                                                                                    },
                                                                                    {
                                                                                        label: 'Tax',
                                                                                        value: '-' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(tax)
                                                                                    },
                                                                                    // Capital expenses are deliberately NOT scaled: a one-off either
                                                                                    // falls inside the period or it does not, and the engine already
                                                                                    // bands each one by the month it is pencilled in for.
                                                                                    ...(year.capitalExpenses || 0) > 0 ? [
                                                                                        {
                                                                                            label: 'Capital Expenses',
                                                                                            value: '-' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(year.capitalExpenses || 0)
                                                                                        }
                                                                                    ] : [],
                                                                                    {
                                                                                        label: '--- Total Expenses ---',
                                                                                        value: '-' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(annualCareCosts + livingExpenses + tax + (year.capitalExpenses || 0))
                                                                                    },
                                                                                    {
                                                                                        label: '--- NET CASHFLOW ---',
                                                                                        value: (netCashflow >= 0 ? '+' : '') + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(netCashflow)
                                                                                    }
                                                                                ];
                                                                                const scaled = [
                                                                                    ...base,
                                                                                    ...$9847d752f8df838f$export$dbe2017ac6e90e6c(year, year.cashFlow || 0, netCashflow, (0, $f94e45ac645ae232$export$3dc27271f5d5c629))
                                                                                ];
                                                                                /*
                                 * "Surplus directed to ANZ" beneath a NEGATIVE net cashflow
                                 * (owner-caught, 2026-08-27: first three years of a do-nothing
                                 * projection).
                                 *
                                 * Not a calculation error - the closing net worth is right, and the
                                 * money does leave the bank. The two lines are struck on different
                                 * bases. Aged care is drawn from the bank MONTHLY by
                                 * agedCareCostPlugin, so cashflowPlugin deliberately settles the
                                 * year without it (see its own notes) and the figure it routes is
                                 * income less living costs - genuinely a surplus. The Net Cashflow
                                 * directly above INCLUDES care, so it is negative. The reader sees
                                 * a shortfall and is told there is a surplus.
                                 *
                                 * Relabelled here rather than in the engine because this is the one
                                 * place both figures are in hand, and the engine's routing is
                                 * correct about what it describes. Care did come out of that
                                 * account - monthly, which is exactly why no deficit waterfall ran.
                                 */ const routing = year.cashflowRoutingLine;
                                                                                const misreadsAsSurplus = routing && netCashflow < 0 && /^Surplus directed to$/.test(String(routing.label));
                                                                                const routingLine = misreadsAsSurplus ? {
                                                                                    ...routing,
                                                                                    label: 'Care drawn monthly from'
                                                                                } : routing;
                                                                                return routingLine ? [
                                                                                    ...scaled,
                                                                                    {
                                                                                        label: '---',
                                                                                        value: ''
                                                                                    },
                                                                                    {
                                                                                        ...routingLine
                                                                                    }
                                                                                ] : scaled;
                                                                            })(), index),
                                                                            children: [
                                                                                netCashflow >= 0 ? '+' : '',
                                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(deflateAmount(netCashflow, index))
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        className: "px-4 py-3 whitespace-nowrap text-sm text-slate-900 relative",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bea2c523253f544$export$2e2bcd8739ae039), {
                                                                            className: `font-mono ${moneyClass(index, '')}`,
                                                                            title: "Net Worth (Closing) Breakdown",
                                                                            data: deflateRows(year.netWorthBreakdown ? year.netWorthBreakdown.map((item)=>({
                                                                                    label: item.label,
                                                                                    value: item.value
                                                                                })) : [
                                                                                {
                                                                                    label: '--- OPENING POSITION ---',
                                                                                    value: ''
                                                                                },
                                                                                {
                                                                                    label: 'Opening Net Worth',
                                                                                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(openingBalance)
                                                                                },
                                                                                {
                                                                                    label: '--- GROWTH & INCOME ---',
                                                                                    value: ''
                                                                                },
                                                                                ...fallbackInvLines,
                                                                                {
                                                                                    label: 'Rental Income',
                                                                                    value: '+' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(rentalIncome)
                                                                                },
                                                                                {
                                                                                    label: 'Age Pension',
                                                                                    value: '+' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(agePension)
                                                                                },
                                                                                {
                                                                                    label: '--- EXPENSES ---',
                                                                                    value: ''
                                                                                },
                                                                                {
                                                                                    label: 'Aged Care Costs',
                                                                                    value: '-' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(annualCareCosts)
                                                                                },
                                                                                {
                                                                                    label: 'Living Expenses',
                                                                                    value: '-' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(livingExpenses)
                                                                                },
                                                                                {
                                                                                    label: 'Tax',
                                                                                    value: '-' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(tax)
                                                                                },
                                                                                {
                                                                                    label: '--- NET CHANGE ---',
                                                                                    value: (closingBalance - openingBalance >= 0 ? '+' : '') + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(closingBalance - openingBalance)
                                                                                },
                                                                                {
                                                                                    label: '--- CLOSING NET WORTH ---',
                                                                                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(closingBalance)
                                                                                }
                                                                            ], index),
                                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(deflateAmount(closingBalance, index))
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        className: "px-2 py-3 text-right align-middle w-10",
                                                                        children: year.breakdown && year.breakdown.trim() ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            className: "inline-flex items-center justify-center rounded-md p-1 text-slate-400 hover:text-slate-700 hover:bg-slate-200/70 transition-colors",
                                                                            onClick: ()=>toggleBreakdown(index),
                                                                            "aria-expanded": !!breakdownExpanded[index],
                                                                            "aria-controls": `projection-breakdown-${index}`,
                                                                            "aria-label": breakdownExpanded[index] ? `Hide calculation breakdown for ${year.fyLabel || `Year ${index + 1}`}` : `Show calculation breakdown for ${year.fyLabel || `Year ${index + 1}`}`,
                                                                            title: breakdownExpanded[index] ? 'Hide calculation breakdown' : 'Show calculation breakdown (detailed, illustrative)',
                                                                            children: breakdownExpanded[index] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                                                className: "h-4 w-4 shrink-0",
                                                                                "aria-hidden": true
                                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                                                                className: "h-4 w-4 shrink-0",
                                                                                "aria-hidden": true
                                                                            })
                                                                        }) : null
                                                                    })
                                                                ]
                                                            }),
                                                            year.breakdown && year.breakdown.trim() && breakdownExpanded[index] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                                className: "border-b border-slate-100 bg-slate-50/40",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    colSpan: showCostColumn ? 7 : 6,
                                                                    className: "p-0",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        id: `projection-breakdown-${index}`,
                                                                        role: "region",
                                                                        "aria-label": `Calculation breakdown for ${year.fyLabel || `Year ${index + 1}`}`,
                                                                        className: `${(0, $18ef4d8ebb42032f$export$c2f4692642028b8d)} max-h-96 overflow-y-auto px-4 py-3`,
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: renderBreakdownHtml(year.breakdown, index)
                                                                        }
                                                                    })
                                                                })
                                                            }) : null
                                                        ]
                                                    }, `proj-row-${index}`);
                                                })
                                            })
                                        ]
                                    })
                                }) : /* On a phone held upright, one card per year: the year, then four figures in two rows (owner-approved
                 mock-up, 25 Oct 2026). The same figures as the table, from the same helper; the chevron opens the
                 same month-by-month breakdown. */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ol", {
                                    className: "m-0 list-none space-y-3 p-0",
                                    "data-testid": "projections-year-cards",
                                    children: projections.map((year, index)=>{
                                        const f = rowFigures(index);
                                        const hasBreakdown = !!(year.breakdown && year.breakdown.trim());
                                        const opened = $9847d752f8df838f$export$8acc397fcdf9fb8c(year.periodStart);
                                        const figure = (label, value, tone)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "m-0 text-xs text-slate-500",
                                                        children: label
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: `m-0 text-base font-semibold tabular-nums ${moneyClass(index, tone)}`,
                                                        children: value
                                                    })
                                                ]
                                            });
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            className: "rounded-xl border border-slate-200 bg-white px-4 py-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    className: "flex w-full items-baseline justify-between gap-2 text-left disabled:cursor-default",
                                                    onClick: ()=>hasBreakdown && toggleBreakdown(index),
                                                    disabled: !hasBreakdown,
                                                    "aria-expanded": hasBreakdown ? !!breakdownExpanded[index] : undefined,
                                                    "aria-controls": hasBreakdown ? `projection-breakdown-card-${index}` : undefined,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-[15px] font-bold text-slate-900",
                                                            children: [
                                                                yearName(year, index),
                                                                year.isPartialFy && opened ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "ml-1 text-xs font-normal text-slate-500",
                                                                    children: [
                                                                        "from ",
                                                                        opened
                                                                    ]
                                                                }) : null
                                                            ]
                                                        }),
                                                        hasBreakdown ? breakdownExpanded[index] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4 shrink-0 text-slate-400",
                                                            "aria-hidden": true
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4 shrink-0 text-slate-400",
                                                            "aria-hidden": true
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "mt-2 grid grid-cols-2 gap-x-4 gap-y-2",
                                                    children: [
                                                        figure('Age Pension', `${f.agePension > 0 ? '+' : ''}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(deflateAmount(f.agePension, index))}`, f.agePension > 0 ? 'text-green-700' : 'text-slate-600'),
                                                        showCostColumn ? figure(costHeading, `-${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(deflateAmount(f.annualCareCosts, index))}`, 'text-red-700') : figure('Owned at the start', (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(deflateAmount(f.openingBalance, index)), 'text-slate-900'),
                                                        figure('In, less out', `${f.netCashflow >= 0 ? '+' : ''}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(deflateAmount(f.netCashflow, index))}`, f.netCashflow >= 0 ? 'text-green-700' : 'text-red-700'),
                                                        figure('Owned at the end', (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(deflateAmount(f.closingBalance, index)), 'text-slate-900')
                                                    ]
                                                }),
                                                hasBreakdown && breakdownExpanded[index] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    id: `projection-breakdown-card-${index}`,
                                                    role: "region",
                                                    "aria-label": `Calculation breakdown for ${yearName(year, index)}`,
                                                    className: `${(0, $18ef4d8ebb42032f$export$c2f4692642028b8d)} mt-3 max-h-96 overflow-y-auto border-t border-slate-100 pt-3`,
                                                    dangerouslySetInnerHTML: {
                                                        __html: renderBreakdownHtml(year.breakdown, index)
                                                    }
                                                }) : null
                                            ]
                                        }, `proj-card-${index}`);
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-[13px] leading-relaxed text-slate-500",
                                    "data-testid": "projections-compared-over",
                                    children: (0, $c3eba85390498a43$export$be94b03447321f96)(comparedOverYears ?? projections.length)
                                })
                            ]
                        })
                    }),
                    isReloading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute inset-0 z-10 flex items-start justify-center bg-white/70 pt-16",
                        role: "status",
                        "aria-live": "polite",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 shadow-md",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8796e625a2ec43cf$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4 shrink-0 animate-pulse text-slate-500",
                                    "aria-hidden": true
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "text-sm font-medium text-slate-700",
                                    children: [
                                        "Recalculating by ",
                                        periodNoun,
                                        "\u2026"
                                    ]
                                })
                            ]
                        })
                    }) : null
                ]
            })
        ]
    });
};
const $9847d752f8df838f$export$f89de71a2c9ebacb = ({ title: title, subtitle: subtitle, actions: actions, onClose: onClose, titleId: titleId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "px-4 sm:px-6 pt-5 sm:pt-6 bg-white",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-start justify-between gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                id: titleId,
                                className: "text-xl sm:text-2xl font-bold tracking-tight text-brand-navy",
                                "data-testid": "year-by-year-title",
                                children: title
                            }),
                            subtitle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1 text-sm text-slate-500",
                                children: subtitle
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex shrink-0 items-center gap-2",
                        children: [
                            actions,
                            onClose ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onClose,
                                className: "rounded-lg p-2 text-slate-500 hover:text-slate-800 hover:bg-slate-100 transition-colors",
                                "aria-label": "Close",
                                title: "Close",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                    className: "h-6 w-6",
                                    "aria-hidden": true
                                })
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-4 h-px w-full bg-brand-navy",
                "aria-hidden": true,
                "data-testid": "year-by-year-rule"
            })
        ]
    });
function $9847d752f8df838f$export$8223046eaabd582d(years) {
    const n = Math.max(1, Math.round(years));
    return `Year by year, for about ${n} ${n === 1 ? 'year' : 'years'}`;
}
/**
 * The overlay every module opens for a plan's year-by-year figures: the title block around the shared
 * {@link ProjectionsView}. The aged care suggestion engine's window embeds the view directly inside its own
 * tabbed window instead, with the same title block.
 */ const $9847d752f8df838f$var$ProjectionsModal = (props)=>{
    const { onClose: onClose, title: title, subtitle: subtitle, ...viewProps } = props;
    // Escape closes it, and so does a click on the backdrop; focus returns to whatever opened it
    // (defect 2, 17 Oct 2026: keyboard users were stuck, and every later click hit the overlay).
    (0, $acw62.useEffect)(()=>{
        const opener = document.activeElement;
        const onKey = (e)=>{
            if (e.key === 'Escape') {
                e.stopPropagation();
                onClose();
            }
        };
        document.addEventListener('keydown', onKey);
        return ()=>{
            document.removeEventListener('keydown', onKey);
            opener?.focus?.();
        };
    }, [
        onClose
    ]);
    const years = viewProps.comparedOverYears ?? viewProps.projections.length;
    const heading = title?.trim() || 'Year by year';
    const line = subtitle ?? (title?.trim() ? $9847d752f8df838f$export$8223046eaabd582d(years) : `For about ${Math.max(1, Math.round(years))} ${Math.round(years) === 1 ? 'year' : 'years'}`);
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-2 sm:p-4",
        onClick: onClose,
        role: "presentation",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white rounded-2xl shadow-2xl w-full max-w-screen-2xl max-h-[94vh] sm:max-h-[90vh] flex flex-col overflow-hidden border border-slate-200/80",
            onClick: (e)=>e.stopPropagation(),
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "year-by-year-title",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9847d752f8df838f$export$f89de71a2c9ebacb, {
                    title: heading,
                    subtitle: line,
                    onClose: onClose,
                    titleId: "year-by-year-title"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9847d752f8df838f$export$2d0b9ca88b9f5e66, {
                    ...viewProps
                })
            ]
        })
    }), document.body);
};
var $9847d752f8df838f$export$2e2bcd8739ae039 = $9847d752f8df838f$var$ProjectionsModal;









var $7ed81d1f360bfd38$exports = {};
$7ed81d1f360bfd38$exports = import.meta.resolve("hSx42");


const $482dbb064a59e381$var$soaBookletScriptUrl = new URL($7ed81d1f360bfd38$exports).href;
const $482dbb064a59e381$export$f7856bca3f4078fd = {
    retirement_village: 'Your retirement village strategy',
    downsizer: 'Your downsizing strategy',
    granny_flat: 'Your granny flat strategy',
    cashflow_pension: 'Your cashflow and Age Pension strategy'
};
const $482dbb064a59e381$export$2cc26ffae1a467f8 = {
    retirement_village: 'Retirement village',
    downsizer: 'Downsizer',
    granny_flat: 'Granny flat',
    cashflow_pension: 'Cashflow & pension'
};
function $482dbb064a59e381$export$4cf11838cdc2a8a8(value) {
    return String(value ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
const $482dbb064a59e381$var$text = (v)=>String(v ?? '').trim();
const $482dbb064a59e381$var$num = (v)=>{
    const n = typeof v === 'number' ? v : parseFloat(String(v ?? '').replace(/[$,\s]/g, ''));
    return Number.isFinite(n) ? n : 0;
};
const $482dbb064a59e381$var$prettify = (key)=>key.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/_/g, ' ').replace(/^./, (c)=>c.toUpperCase());
function $482dbb064a59e381$export$75477e21c4edfb09(iso) {
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });
}
const $482dbb064a59e381$export$ae6a5ab41f356242 = (clause)=>{
    const t = clause.trim().replace(/\s+/g, ' ');
    if (!t) return '';
    const capped = t.charAt(0).toUpperCase() + t.slice(1);
    return /[.!?]$/.test(capped) ? capped : `${capped}.`;
};
const $482dbb064a59e381$var$toDisplay = (v)=>{
    if (v === null || v === undefined || v === '') return "\u2014";
    if (typeof v === 'boolean') return v ? 'Yes' : 'No';
    if (typeof v === 'number') return Number.isFinite(v) ? v.toLocaleString('en-AU') : "\u2014";
    if (Array.isArray(v)) return v.length ? v.map($482dbb064a59e381$var$toDisplay).join(', ') : "\u2014";
    if (typeof v === 'object') return $482dbb064a59e381$export$4cf11838cdc2a8a8(JSON.stringify(v));
    return $482dbb064a59e381$export$4cf11838cdc2a8a8(String(v));
};
function $482dbb064a59e381$var$flattenObject(value, prefix = '') {
    if (value === null || value === undefined) return prefix ? [
        {
            key: prefix,
            value: "\u2014"
        }
    ] : [];
    if (Array.isArray(value)) return value.flatMap((item, i)=>$482dbb064a59e381$var$flattenObject(item, `${prefix}[${i}]`));
    if (typeof value === 'object') return Object.entries(value).filter(([k])=>!k.startsWith('__') && k !== 'firmAssumptions').flatMap(([k, v])=>$482dbb064a59e381$var$flattenObject(v, prefix ? `${prefix}.${k}` : k));
    return [
        {
            key: prefix,
            value: String(value)
        }
    ];
}
const $482dbb064a59e381$var$GOAL_LABELS = {
    home_care: 'Access care at home',
    aged_care: 'Move into residential aged care',
    downsize_home: 'Downsize the family home',
    retirement_village: 'Move to a retirement village',
    granny_flat: 'Set up a granny flat arrangement',
    meet_costs: 'Meet the costs',
    maximise_support: 'Maximise government support',
    preserve_assets: 'Preserve assets for the family',
    funding_guidance: 'Guidance on funding options'
};
const $482dbb064a59e381$var$numOf = (v)=>{
    const x = typeof v === 'number' ? v : parseFloat(String(v ?? ''));
    return Number.isFinite(x) ? x : 0;
};
const $482dbb064a59e381$var$linesOf = (v)=>Array.isArray(v) && v.length > 0 ? v.filter((l)=>l && typeof l === 'object').map((l)=>({
            label: String(l.label ?? ''),
            value: typeof l.value === 'number' ? l.value : String(l.value ?? '')
        })) : null;
function $482dbb064a59e381$export$998b1d0a26b4d727(list, years, opts = {}) {
    return (list || []).slice(0, Math.max(years, 1)).map((raw, i)=>{
        const r = raw || {};
        const partial = r.isPartialFy === true;
        const pensionAnnual = $482dbb064a59e381$var$numOf(r.socialSecurity);
        const pension = $482dbb064a59e381$var$numOf(r.agePensionPaidForPeriod ?? r.socialSecurityForPartialPeriod ?? r.socialSecurity);
        const cashflow = $482dbb064a59e381$var$numOf(r.cashFlowForPartialPeriod ?? r.netCashflow ?? r.cashFlow);
        const netWorth = $482dbb064a59e381$var$numOf(r.netWorth);
        const moduleCost = opts.moduleCost ? opts.moduleCost(r, i) : null;
        const pensionTip = $482dbb064a59e381$var$linesOf(r.socialSecurityBreakdown) ?? [
            {
                label: 'Age Pension (annual rate)',
                value: pensionAnnual
            }
        ];
        if (partial && Math.abs(pension - pensionAnnual) > 1) pensionTip.push({
            label: '---',
            value: ''
        }, {
            label: 'Paid across this part year',
            value: pension
        });
        const investment = $482dbb064a59e381$var$numOf(r.investmentIncomeForPartialPeriod ?? r.investmentIncome);
        const rent = $482dbb064a59e381$var$numOf(r.rentalIncome);
        const living = $482dbb064a59e381$var$numOf(r.livingExpensesForPartialPeriod ?? r.livingExpenses);
        const tax = $482dbb064a59e381$var$numOf(r.taxForPartialPeriod ?? r.tax);
        const capital = $482dbb064a59e381$var$numOf(r.capitalExpenses);
        const costLabel = opts.moduleCostLabel || 'Module cost';
        const cashflowTip = $482dbb064a59e381$var$linesOf(r.cashFlowBreakdown) ?? [
            {
                label: '--- INCOME ---',
                value: ''
            },
            {
                label: 'Age Pension',
                value: pension
            },
            {
                label: 'Investment income',
                value: investment
            },
            ...rent > 0 ? [
                {
                    label: 'Rental income',
                    value: rent
                }
            ] : [],
            {
                label: '--- EXPENSES ---',
                value: ''
            },
            ...moduleCost != null && moduleCost !== 0 ? [
                {
                    label: costLabel,
                    value: -moduleCost
                }
            ] : [],
            {
                label: 'Living expenses',
                value: -living
            },
            ...tax !== 0 ? [
                {
                    label: 'Tax',
                    value: -tax
                }
            ] : [],
            ...capital > 0 ? [
                {
                    label: 'Capital expenses',
                    value: -capital
                }
            ] : [],
            {
                label: '--- NET CASHFLOW ---',
                value: cashflow
            }
        ];
        const routing = r.cashflowRoutingLine;
        if (routing && typeof routing === 'object' && routing.label) cashflowTip.push({
            label: '---',
            value: ''
        }, {
            label: String(routing.label),
            value: String(routing.value ?? '')
        });
        let netWorthTip = $482dbb064a59e381$var$linesOf(r.netWorthBreakdown);
        if (!netWorthTip) {
            netWorthTip = [];
            const home = r.home;
            if (home && $482dbb064a59e381$var$numOf(home.value) > 0) netWorthTip.push({
                label: String(home.description || 'Family home'),
                value: $482dbb064a59e381$var$numOf(home.value)
            });
            const assets = r.assets || {};
            for (const [type, rows] of Object.entries(assets)){
                if (!Array.isArray(rows)) continue;
                const total = rows.reduce((t, a)=>t + $482dbb064a59e381$var$numOf(a?.value ?? a?.balance), 0);
                if (total > 0) netWorthTip.push({
                    label: $482dbb064a59e381$var$prettify(type),
                    value: total
                });
            }
            const liabilities = r.liabilities || {};
            const owed = Object.values(liabilities).reduce((t, rows)=>t + (Array.isArray(rows) ? rows.reduce((u, l)=>u + $482dbb064a59e381$var$numOf(l?.balance), 0) : 0), 0);
            if (owed > 0) netWorthTip.push({
                label: 'Less: debts',
                value: -owed
            });
            netWorthTip.push({
                label: '=== NET WORTH ===',
                value: netWorth
            });
        }
        const moduleCostTip = moduleCost == null ? undefined : $482dbb064a59e381$var$linesOf(r.agedCareBreakdown) ?? [
            {
                label: costLabel,
                value: moduleCost
            }
        ];
        return {
            label: r.fyLabel ? String(r.fyLabel) : `Year ${i + 1}`,
            pension: pension,
            moduleCost: moduleCost,
            cashflow: cashflow,
            netWorth: netWorth,
            ...partial ? {
                partial: true,
                periodStart: r.periodStart ? String(r.periodStart) : undefined
            } : {},
            tips: {
                pension: pensionTip,
                cashflow: cashflowTip,
                netWorth: netWorthTip,
                ...moduleCostTip ? {
                    moduleCost: moduleCostTip
                } : {}
            }
        };
    });
}
function $482dbb064a59e381$export$df893918412205e2(factFind, opts) {
    const fd = factFind || {};
    const isCouple = fd.adviceFor === 'couple';
    const age = (dob)=>{
        if (!dob) return null;
        const d = new Date(String(dob));
        if (Number.isNaN(d.getTime())) return null;
        const now = new Date();
        let a = now.getFullYear() - d.getFullYear();
        if (now.getMonth() < d.getMonth() || now.getMonth() === d.getMonth() && now.getDate() < d.getDate()) a -= 1;
        return a;
    };
    const attribution = (0, $92fb3c34dca71663$export$174185a301570ae7)();
    const structureAppendix = (0, $f70ff3a065f941e2$export$7a9a83c1f9700f91)(fd, {
        strategySource: opts.strategySource
    });
    const prefix = {
        retirement_village: 'RV',
        downsizer: 'DZ',
        granny_flat: 'GF',
        cashflow_pension: 'CP'
    }[opts.kind];
    const completer = $482dbb064a59e381$var$text(fd.completer);
    const completerName = [
        $482dbb064a59e381$var$text(fd.completerFirstName),
        $482dbb064a59e381$var$text(fd.completerLastName)
    ].filter(Boolean).join(' ');
    return {
        documentKind: opts.kind,
        reportId: `${prefix}-${Date.now().toString(36).toUpperCase()}`,
        generatedAt: new Date().toISOString(),
        strategySource: opts.strategySource,
        customisedFrom: opts.strategySource === 'manual_control' && opts.customisedFrom ? opts.customisedFrom : null,
        adviceAttributionLine: attribution?.line ?? null,
        adviceAttributionIncomplete: attribution ? attribution.complete === false : false,
        clientName: $482dbb064a59e381$var$text(fd.client?.firstName) || 'Client',
        partnerName: isCouple ? $482dbb064a59e381$var$text(fd.partner?.firstName) : '',
        clientAge: age(fd.client?.dob),
        partnerAge: isCouple ? age(fd.partner?.dob) : null,
        isCouple: isCouple,
        completerDisplay: completer && completer !== 'client' ? completerName : '',
        completerRelationship: completer && completer !== 'client' ? $482dbb064a59e381$var$text(fd.completerRelationship) : '',
        // Only a key with a goal label is a goal: the same record carries on/off flags (rvPrimerSeen,
        // sahSetupSeen, …) that were printed as goals (24 Oct 2026).
        goals: Object.entries(fd.goals || {}).filter(([key, on])=>on === true && $482dbb064a59e381$var$GOAL_LABELS[key]).map(([key])=>$482dbb064a59e381$var$GOAL_LABELS[key]),
        situation: (0, $8ea663173c1a6588$export$b49cd4ac4688f9b9)(fd),
        strategyRisks: (0, $203e38d6e6c434f4$export$124603ee0434ece5)(opts.riskKinds, opts.riskSpecifics),
        ratesReviewNotice: (0, $d92bca4a6da5b591$export$83e0daeeac89884f)().notice ?? null,
        annualLivingExpenses: $482dbb064a59e381$var$num(fd.expenses?.livingExpenses),
        assetRows: Object.entries(fd.assets || {}).flatMap(([assetType, assets])=>(assets || []).map((asset)=>({
                    assetType: $482dbb064a59e381$var$prettify(assetType),
                    description: $482dbb064a59e381$var$text(asset.description) || 'Unnamed asset',
                    value: $482dbb064a59e381$var$num(asset.value),
                    ...(0, $061bee36071dd9d5$export$53e371969067f999)(assetType, asset)
                }))),
        factFindSections: (0, $02a659cad5e2280d$export$70de02dda17e369e)(fd),
        allFactFindRows: $482dbb064a59e381$var$flattenObject(fd),
        structureAppendixHtml: structureAppendix ? (0, $f70ff3a065f941e2$export$ef316658362fb04e)(structureAppendix, (0, $f94e45ac645ae232$export$3dc27271f5d5c629)) : '',
        assumptionSections: (0, $13910bc1e93fb74e$export$8d1b1c5d08b3c488)()
    };
}
/** The appendix groups a module's reader needs open; the rest stay collapsed. */ const $482dbb064a59e381$var$OPEN_ASSUMPTIONS = {
    retirement_village: /How the Plans|Social Security|Asset & Market|Superannuation/i,
    downsizer: /How the Plans|Social Security|Tax|Asset & Market|Superannuation/i,
    granny_flat: /How the Plans|Social Security|Asset & Market|Superannuation/i,
    cashflow_pension: /How the Plans|Social Security|Tax|Asset & Market|Superannuation/i
};
/* ─── The document ───────────────────────────────────────────────────────────────────────────── */ const $482dbb064a59e381$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(n);
const $482dbb064a59e381$var$delta = (after, before, upIsGood = true)=>{
    const d = after - before;
    if (Math.abs(d) < 1) return '<span class="muted">no change</span>';
    const good = upIsGood ? d > 0 : d < 0;
    return `<span class="${good ? 'age-pos' : 'age-neg'}">${d > 0 ? '+' : "\u2212"}${$482dbb064a59e381$var$money(Math.abs(d))}</span>`;
};
function $482dbb064a59e381$var$kpi(label, value, baseline, upIsGood, baselineName) {
    const d = value - baseline;
    const cls = Math.abs(d) < 1 ? 'kpi' : (upIsGood ? d > 0 : d < 0) ? 'kpi kpi--gain' : 'kpi kpi--warn';
    return `<div class="${cls}"><div class="label">${label}</div><div class="value">${$482dbb064a59e381$var$money(value)}</div><div class="tiny muted" style="margin-top:4px">${$482dbb064a59e381$export$4cf11838cdc2a8a8(baselineName)}: ${$482dbb064a59e381$var$money(baseline)} \xb7 ${$482dbb064a59e381$var$delta(value, baseline, upIsGood)}</div></div>`;
}
const $482dbb064a59e381$var$section = (title, body)=>({
        title: title,
        html: `<section class="page"><div class="card">\n<div class="h2">${title}</div>\n${body}\n</div></section>`
    });
function $482dbb064a59e381$export$f4681787750c522d(s) {
    const coverA = (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1559827260-dc66d52bef19', 1920, 1080);
    const coverB = (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1506905925346-21bda4d32df4', 1920, 1080);
    const names = `${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.clientName)}${s.partnerName ? ` &amp; ${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.partnerName)}` : ''}`;
    const you = s.isCouple ? 'you both' : 'you';
    const baselineWord = s.baseline.name.toLowerCase();
    // Claiming, or reporting, the pension change the plan rests on (owner, 3 Oct 2026).
    const pension = (0, $b82b108d4741f18d$export$fdc5fe41a9ca9852)(s.headline.pension, s.baseline.pension);
    const implications = pension ? [
        pension.implication,
        ...s.implications
    ] : s.implications;
    const nextSteps = pension ? [
        ...s.nextSteps,
        pension.nextStep
    ] : s.nextSteps;
    const ratesNotice = s.ratesReviewNotice ? `<li><strong>Rates and thresholds</strong> \u{2014} ${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.ratesReviewNotice)}</li>` : '';
    const attribution = s.adviceAttributionLine ? `${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.adviceAttributionLine)}${s.adviceAttributionIncomplete ? " <strong>Your firm profile is incomplete \u2014 finish it in Settings before issuing this to a client.</strong>" : ''}` : "AgedCareWise Pty Ltd (Demo AFSL 401234) \u2014 ensure this block matches your licensee\u2019s approved wording before client issue.";
    const goalsBlock = s.goals.length ? `<ul class="goalsList">${s.goals.map((g)=>`<li>${$482dbb064a59e381$export$4cf11838cdc2a8a8(g)}</li>`).join('')}</ul>` : '<p class="muted">No goals were ticked in the profile, so this advice is built on the module you chose and the figures you gave.</p>';
    const altCards = s.alternatives.map((a)=>`<div class="opt-card${a.selected ? ' opt-card--selected' : ''}">
<div class="opt-card-head">${a.badges.map((b)=>`<span class="opt-tag">${$482dbb064a59e381$export$4cf11838cdc2a8a8(b)}</span>`).join('')}
<span class="opt-card-status">${a.selected ? '<span class="pill-selected">Your choice</span>' : '<span class="pill-not-selected">Considered</span>'}</span></div>
<h4 class="opt-title">${$482dbb064a59e381$export$4cf11838cdc2a8a8(a.name)}</h4>
<div class="opt-card-main"><p class="opt-narr">${$482dbb064a59e381$export$4cf11838cdc2a8a8(a.description)}</p>
<div class="opt-metrics">
<div class="opt-metric-line"><span>Estate after ${s.legacyYears} years</span><strong>${$482dbb064a59e381$var$money(a.estate)}</strong></div>
<div class="opt-metric-line"><span>Age Pension a year</span><strong>${$482dbb064a59e381$var$money(a.pension)}</strong></div>
<div class="opt-metric-line"><span>Cashflow a year</span><strong>${$482dbb064a59e381$var$money(a.cashflow)}</strong></div>
</div></div></div>`).join('');
    /*
     * THE FIGURES EXPLAIN THEMSELVES (owner, 3 Oct 2026). Every number in the projection table
     * carries its working on hover — the engine's own breakdown, as the app's projection table shows
     * it — with no "i" icon: the dotted underline is the affordance, and the cell takes focus so a
     * keyboard or a tap opens it. Print shows the figures alone.
     */ const tipValue = (v)=>{
        if (typeof v === 'number') return `${v < 0 ? "\u2212" : ''}${$482dbb064a59e381$var$money(Math.abs(v))}`;
        return $482dbb064a59e381$export$4cf11838cdc2a8a8(v);
    };
    const tipLines = (lines)=>(lines || []).map((l)=>{
            const label = String(l.label || '');
            if (/^---$/.test(label.trim())) return '<div class="tip-rule"></div>';
            const heading = /^(---|===)/.test(label);
            return `<div class="tip-row${heading ? ' tip-row--head' : ''}"><span class="tip-lbl">${$482dbb064a59e381$export$4cf11838cdc2a8a8(label.replace(/^[-=\s]+|[-=\s]+$/g, ''))}</span><span class="tip-val">${l.value === '' ? '' : tipValue(l.value)}</span></div>`;
        }).join('');
    // The figure is the trigger, on hover, focus or tap (owner, 24 Oct 2026).
    let tipSeq = 0;
    const cell = (valueHtml, title, lines, up)=>{
        if (!lines || !lines.length) return valueHtml;
        const id = `soa-cell-tip-${++tipSeq}`;
        return `<span class="soa-cell" tabindex="0" role="button" aria-describedby="${id}">${valueHtml}<span class="soa-cell-tip${up ? ' up' : ''}" id="${id}" role="tooltip"><strong>${$482dbb064a59e381$export$4cf11838cdc2a8a8(title)}</strong>${tipLines(lines)}</span></span>`;
    };
    const projRows = s.projections.map((r, i)=>{
        const up = i >= Math.ceil(s.projections.length / 2);
        const yearCell = `${$482dbb064a59e381$export$4cf11838cdc2a8a8(r.label)}${r.partial ? `<span class="tiny muted" style="display:block;font-weight:400">${r.periodStart ? `from ${$482dbb064a59e381$export$4cf11838cdc2a8a8((0, $9847d752f8df838f$export$8acc397fcdf9fb8c)(r.periodStart))} ` : ''}(part year)</span>` : ''}`;
        return `<tr class="proj-tr-data${i % 2 ? ' proj-zebra' : ''}"><td class="proj-year">${yearCell}</td><td class="td-num">${cell($482dbb064a59e381$var$money(r.pension), "Age Pension \u2014 how it was worked out", r.tips?.pension, up)}</td>${s.moduleCostLabel ? `<td class="td-num">${r.moduleCost == null ? "\u2014" : cell($482dbb064a59e381$var$money(r.moduleCost), `${s.moduleCostLabel} \u{2014} how it was worked out`, r.tips?.moduleCost, up)}</td>` : ''}<td class="td-num ${r.cashflow < 0 ? 'age-neg' : ''}">${cell($482dbb064a59e381$var$money(r.cashflow), "Cashflow \u2014 money in less money out", r.tips?.cashflow, up)}</td><td class="td-num">${cell($482dbb064a59e381$var$money(r.netWorth), 'Net worth at the end of the year', r.tips?.netWorth, up)}</td></tr>`;
    }).join('');
    const calendarNote = s.periodMode === 'calendar_year' ? 'The rows are calendar years (January to December), as chosen in the app.' : 'The rows are financial years (July to June), as chosen in the app.';
    const partYearNote = s.projections.some((r)=>r.partial) ? ' The first row runs from the start date to the end of that year, so it is a part year: its figures cover only those months.' : '';
    const charts = (0, $8ea663173c1a6588$export$6534c8cb884ee17d)({
        idPrefix: 'soa-proj',
        planName: s.selectedStrategyName,
        plan: s.projections,
        baselineName: s.baseline.name,
        baseline: s.baselineProjections
    });
    const estateDrivers = s.estateDrivers.length ? `<div class="h3">What moves the estate</div>
<p class="small muted">Both figures are projected over the same ${s.legacyYears} years \u{2014} this plan against ${$482dbb064a59e381$export$4cf11838cdc2a8a8(baselineWord)} \u{2014} so they can be compared directly. One driver per line.</p>
<ul class="soa-drivers">${s.estateDrivers.map((d)=>`<li><span>${$482dbb064a59e381$export$4cf11838cdc2a8a8(d.text)}</span>${d.amount != null && d.amount > 0 ? `<strong class="${d.sign}">${d.sign === 'minus' ? "\u2212" : d.sign === 'plus' ? '+' : ''}${$482dbb064a59e381$var$money(d.amount)}${d.perYear ? ' a year' : ''}</strong>` : `<strong class="${d.sign}">${d.sign === 'minus' ? 'lower' : d.sign === 'plus' ? 'higher' : "\u2014"}</strong>`}</li>`).join('')}</ul>` : '';
    const motiveBlock = s.motiveNote ? `<div class="callout callout--blue" style="margin-top:14px"><p class="callout-title">A lifestyle decision, not only a financial one</p><p class="small" style="margin:0">${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.motiveNote)}</p></div>` : '';
    const pages = [];
    pages.push($482dbb064a59e381$var$section('Executive summary', `
<p class="lede">${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.decisionIntro)}</p>
<p>${s.strategySource === 'manual_control' && s.customisedFrom ? `<strong>How this plan was made:</strong> you started from the suggested plan <strong>\u{201C}${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.customisedFrom)}\u{201D}</strong> and changed it yourself, into <strong>${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.selectedStrategyName)}</strong>. This Statement of Advice follows that plan through to its projected outcomes.` : s.strategySource === 'manual_control' ? `<strong>How this plan was made:</strong> you built <strong>${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.selectedStrategyName)}</strong> yourself. This Statement of Advice follows that plan through to its projected outcomes.` : `<strong>How this plan was made:</strong> AgedCareWise found this plan by testing <strong>${s.totalEvaluated}</strong> ways of doing this, each measured against <strong>${$482dbb064a59e381$export$4cf11838cdc2a8a8(baselineWord)}</strong>. You chose <strong>${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.selectedStrategyName)}</strong>, and this Statement of Advice follows that plan through to its projected outcomes.`}</p>
<div class="callout callout--blue">
<p class="callout-title">Our advice, in one line</p>
<p class="oneLine">${$482dbb064a59e381$export$4cf11838cdc2a8a8($482dbb064a59e381$export$ae6a5ab41f356242(s.inOneLine))}</p>
</div>
<div class="h3">What it means for ${you}</div>
<p class="small muted">The three figures that matter, each against ${$482dbb064a59e381$export$4cf11838cdc2a8a8(baselineWord)}. The year-by-year path is in the projection section.</p>
<div class="grid3">
${$482dbb064a59e381$var$kpi('Age Pension a year', s.headline.pension, s.baseline.pension, true, s.baseline.name)}
${$482dbb064a59e381$var$kpi('Cashflow a year', s.headline.cashflow, s.baseline.cashflow, true, s.baseline.name)}
${$482dbb064a59e381$var$kpi(`Estate after ${s.legacyYears} years`, s.headline.estate, s.baseline.estate, true, s.baseline.name)}
</div>
<div class="h3">What you told us you are trying to achieve</div>
${goalsBlock}
<div class="h3">In this document</div>
<div id="soa-toc-slot"></div>`));
    pages.push($482dbb064a59e381$var$section('Scope of advice', `
<p>This section sets clear boundaries: what this advice covers, what it does not, and where you still need a specialist (for example a solicitor or a tax agent).</p>
<div class="scope-grid">
<div class="scope-in"><h4>In scope</h4><ul>${s.scope.inScope.map((l)=>`<li>${$482dbb064a59e381$export$4cf11838cdc2a8a8(l)}</li>`).join('')}
<li>How the years are shown: ${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.projectionConvention)}</li></ul></div>
<div class="scope-out"><h4>Out of scope</h4><ul>${s.scope.outOfScope.map((l)=>`<li>${$482dbb064a59e381$export$4cf11838cdc2a8a8(l)}</li>`).join('')}
<li>Specific financial product advice \u{2014} recommending a particular fund, insurer, lender or security.</li>
<li>Tax, legal or estate implementation \u{2014} capital gains tax calculations, trust structuring, or drafting Wills and powers of attorney.</li>
<li>Product providers' fees, break fees, exit fees and surrender terms, which must be confirmed with each provider before you act.</li></ul></div>
</div>
<p class="small muted">If your circumstances fall outside these boundaries, update the profile or seek a qualified specialist before acting.</p>`));
    pages.push($482dbb064a59e381$var$section('Your situation today', `
<p class="lede">This advice is based on what ${you} told us. If anything here is wrong or has changed, the advice may not suit ${you}: update the profile and we will re-run it.</p>
<p class="small muted">The four numbers are ${$482dbb064a59e381$export$4cf11838cdc2a8a8(baselineWord)} \u{2014} the position every strategy in this document is measured against.</p>
${(0, $8ea663173c1a6588$export$b23e227b9b89e73c)(s.situation, {
        ...s.baseline
    }, s.legacyYears)}
<p class="small muted" style="margin-top:12px">The full list of what you entered, and the rates we applied, is in the appendices at the end of this document.</p>`));
    if (s.modulePage) pages.push($482dbb064a59e381$var$section($482dbb064a59e381$export$4cf11838cdc2a8a8(s.modulePage.title), `
<p class="lede">${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.modulePage.intro)}</p>
<table><tbody>${s.modulePage.rows.map((r)=>`<tr><td>${$482dbb064a59e381$export$4cf11838cdc2a8a8(r.label)}${r.note ? `<div class="tiny muted">${$482dbb064a59e381$export$4cf11838cdc2a8a8(r.note)}</div>` : ''}</td><td class="td-num" style="text-align:right;font-weight:700">${$482dbb064a59e381$var$money(r.amount)}</td></tr>`).join('')}</tbody></table>
${s.modulePage.footnote ? `<p class="small muted">${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.modulePage.footnote)}</p>` : ''}`));
    pages.push($482dbb064a59e381$var$section('What we recommend', `
<p class="lede"><strong>${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.selectedStrategyName)}.</strong> ${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.selectedStrategyDescription)}</p>
<div class="h3">The pieces of the plan</div>
<ul class="pieces">${s.pieces.map((p)=>`<li class="piece"><p class="piece-name">${$482dbb064a59e381$export$4cf11838cdc2a8a8(p.name)}${p.amount != null && p.amount > 0 ? `<span class="piece-amt">${$482dbb064a59e381$var$money(p.amount)}${p.perYear ? ' a year' : ''}</span>` : ''}</p><p class="piece-what">${$482dbb064a59e381$export$4cf11838cdc2a8a8(p.what)}</p></li>`).join('')}</ul>
${s.moneyFlow.length ? `<div class="h3">Where the money goes</div><ul class="flow">${s.moneyFlow.map((r)=>`<li><span>${$482dbb064a59e381$export$4cf11838cdc2a8a8(r.label)}${r.note ? `<div class="tiny muted">${$482dbb064a59e381$export$4cf11838cdc2a8a8(r.note)}</div>` : ''}</span><strong>${$482dbb064a59e381$var$money(r.amount)}</strong></li>`).join('')}</ul>` : ''}
<div class="h3">What this strategy does</div>
<ul class="riskList">${s.inBrief.map((c)=>`<li>${$482dbb064a59e381$export$4cf11838cdc2a8a8($482dbb064a59e381$export$ae6a5ab41f356242(c))}</li>`).join('')}</ul>`));
    if (s.guaranteedIncome) pages.push($482dbb064a59e381$var$section('Guaranteed income for life', (0, $66827b1304244a1d$export$5f47fbab513e00f4)(s.guaranteedIncome)));
    pages.push($482dbb064a59e381$var$section(`Why this advice fits ${you}`, `
<p class="lede">We compared every plan on the three things ${you} asked about \u{2014} the Age Pension, the money left each year, and what is left to the family \u{2014} against ${$482dbb064a59e381$export$4cf11838cdc2a8a8(baselineWord)}.</p>
<table><thead><tr><th></th><th>${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.baseline.name)}</th><th>${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.selectedStrategyName)}</th><th>Change</th></tr></thead><tbody>
<tr><td>Age Pension a year</td><td>${$482dbb064a59e381$var$money(s.baseline.pension)}</td><td><strong>${$482dbb064a59e381$var$money(s.headline.pension)}</strong></td><td>${$482dbb064a59e381$var$delta(s.headline.pension, s.baseline.pension)}</td></tr>
<tr><td>Cashflow a year</td><td>${$482dbb064a59e381$var$money(s.baseline.cashflow)}</td><td><strong>${$482dbb064a59e381$var$money(s.headline.cashflow)}</strong></td><td>${$482dbb064a59e381$var$delta(s.headline.cashflow, s.baseline.cashflow)}</td></tr>
<tr><td>Estate after ${s.legacyYears} years</td><td>${$482dbb064a59e381$var$money(s.baseline.estate)}</td><td><strong>${$482dbb064a59e381$var$money(s.headline.estate)}</strong></td><td>${$482dbb064a59e381$var$delta(s.headline.estate, s.baseline.estate)}</td></tr>
</tbody></table>
<ul class="riskList" style="margin-top:14px">${s.whyItFits.map((w)=>`<li>${$482dbb064a59e381$export$4cf11838cdc2a8a8(w)}</li>`).join('')}</ul>
${estateDrivers}
${motiveBlock}`));
    if (implications.length) pages.push($482dbb064a59e381$var$section('Implications of this advice', `
<p class="lede">Before you act on any part of this plan, these are the practical points to know \u{2014} including the assumptions the figures rest on, which you can change in the app and re-run.</p>
<div class="imp-grid">${implications.map((i)=>`<div class="imp-card"><p class="imp-title">${$482dbb064a59e381$export$4cf11838cdc2a8a8(i.title)}</p><p class="imp-lead">${$482dbb064a59e381$export$4cf11838cdc2a8a8(i.lead)}</p><p class="imp-body">${$482dbb064a59e381$export$4cf11838cdc2a8a8(i.body)}</p></div>`).join('')}</div>`));
    if (s.replacements.length) pages.push($482dbb064a59e381$var$section('If this advice replaces one investment with another', `
<p class="lede">Where the plan sells or draws on something you hold to buy something else, the law asks us to spell out what that costs, what changes, and what you give up.</p>
<table><thead><tr><th>From</th><th>To</th><th>What it costs</th><th>What changes</th><th>What you give up</th></tr></thead><tbody>
${s.replacements.map((r)=>`<tr><td>${$482dbb064a59e381$export$4cf11838cdc2a8a8(r.from)}</td><td>${$482dbb064a59e381$export$4cf11838cdc2a8a8(r.to)}</td><td>${$482dbb064a59e381$export$4cf11838cdc2a8a8(r.charges)}</td><td>${$482dbb064a59e381$export$4cf11838cdc2a8a8(r.consequences)}</td><td>${$482dbb064a59e381$export$4cf11838cdc2a8a8(r.lost)}</td></tr>`).join('')}
</tbody></table>
<p class="small muted">Product fees, exit fees and surrender terms are set by each provider and are not modelled here; confirm them with the provider before acting.</p>`));
    /*
     * The three cards are the comparison the law asks for; the full list of everything modelled is
     * kept for the record but folded away (owner, 3 Oct 2026: 34 rows is a laundry list, and the
     * cashflow module can run to hundreds).
     */ pages.push($482dbb064a59e381$var$section('Alternative strategies considered', `
<p class="lede">We modelled ${s.totalEvaluated} ways of doing this. These are the ones that led on each goal, beside the one you chose, so you can see what you would be trading.</p>
<div class="opt-grid">${altCards}</div>
${s.allEvaluated.length > 1 ? `<details class="factSection soa-all-strategies" data-print-closed><summary><strong>Every strategy modelled (${s.allEvaluated.length})</strong> <span class="small muted">\u{2014} open to compare them all; sort by any column. The benchmark stays at the top; what-ifs are listed separately and are not recommendations.</span></summary>
${(0, $8ea663173c1a6588$export$6b235b65b4fb4ca7)(s.allEvaluated, s.legacyYears, s.baseline)}</details>` : ''}`));
    pages.push($482dbb064a59e381$var$section('Projection outlook', `
<p class="muted small">Year by year for <strong>${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.selectedStrategyName)}</strong>${s.baselineProjections.length ? ` against <strong>${$482dbb064a59e381$export$4cf11838cdc2a8a8(baselineWord)}</strong>` : ''}. ${$482dbb064a59e381$export$4cf11838cdc2a8a8(calendarNote)}${$482dbb064a59e381$export$4cf11838cdc2a8a8(partYearNote)} Hover over a year in the chart for its figures.</p>
${charts}
<div class="h3">The figures</div>
<p class="small muted screen-only">Hover over any figure, or tap it, to see how it was worked out.</p>
<table class="table-proj"><thead><tr><th>Year</th><th>Age Pension</th>${s.moduleCostLabel ? `<th>${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.moduleCostLabel)}</th>` : ''}<th>Cashflow</th><th>Net worth</th></tr></thead><tbody>${projRows}</tbody></table>
<p class="tiny muted">Net worth is everything owned less everything owed at the end of each year. A negative cashflow is drawn from savings, which is why net worth can fall even while the pension rises. These are illustrations on the assumptions in the appendix, not forecasts.</p>`));
    if (s.strategyRisks.sections.length) pages.push($482dbb064a59e381$var$section('What could go wrong with this strategy', `
<p class="lede">Every plan has trade-offs. These are the ones that matter for the strategy recommended here, as they were shown to you when you chose it. None of them means the plan is wrong; they are the points to be comfortable with before you act.</p>
${s.strategyRisks.forYou.length ? `<div class="callout callout--amber"><p class="callout-title">For ${you} specifically</p><ul class="riskList">${s.strategyRisks.forYou.map((p)=>`<li><strong>${$482dbb064a59e381$export$4cf11838cdc2a8a8(p.lead)}</strong> ${$482dbb064a59e381$export$4cf11838cdc2a8a8(p.body)}</li>`).join('')}</ul></div>` : ''}
${s.strategyRisks.sections.map((sec)=>`<div class="h3">${$482dbb064a59e381$export$4cf11838cdc2a8a8(sec.title)}</div><ul class="riskList">${sec.points.map((p)=>`<li><strong>${$482dbb064a59e381$export$4cf11838cdc2a8a8(p.lead)}</strong> ${$482dbb064a59e381$export$4cf11838cdc2a8a8(p.body)}</li>`).join('')}</ul>`).join('')}`));
    pages.push($482dbb064a59e381$var$section('Risks &amp; limitations', `
<ul class="riskList">
${ratesNotice}<li><strong>Legislation and policy</strong> \u{2014} Age Pension, superannuation, aged care and state property rules can change, which can shift these outcomes.</li>
<li><strong>Modelling versus reality</strong> \u{2014} the figures depend on assumptions about returns, fees, growth and timing, listed in the appendix. Real outcomes will differ.</li>
<li><strong>Information gaps</strong> \u{2014} if the profile is incomplete or out of date, this advice may not suit you. Update it and re-run the analysis when anything material changes.</li>
<li><strong>Timing</strong> \u{2014} sale dates, settlement, Centrelink reassessment and tax-year boundaries can all differ from the model's timing and create part-year differences.</li>
<li><strong>Tax and legal</strong> \u{2014} capital gains tax and estate outcomes should be confirmed with a registered tax agent or solicitor before you sell assets or sign anything. Where stamp duty is shown it is estimated from the state's published scale with no concessions applied.</li>
</ul>`));
    pages.push($482dbb064a59e381$var$section('Fees &amp; disclosures', `
<p><strong>Who is giving this advice:</strong> ${attribution}</p>
<p><strong>Advice fee:</strong> Initial fee <strong>$450 plus GST</strong>. <strong>No ongoing advice fee</strong> and <strong>no separate implementation fee</strong> is charged for this digital pathway.</p>
<p><strong>Other costs:</strong> Village operators, lenders, insurers and investment products charge their own fees, disclosed in their contracts, PDS or platform schedules.</p>
<p><strong>Commissions and benefits:</strong> We receive no commission, referral payment or other benefit from any village, lender, insurer, product issuer or agent in connection with this advice.</p>
<p><strong>Conflicts of interest:</strong> AgedCareWise does <strong>not</strong> provide specific financial <em>product</em> advice. Recommendations are <strong>strategic</strong> and illustrated through the engine's assumptions. Where the plan draws on particular assets, that ordering reflects <strong>liquidity, growth and tax assumptions you supplied</strong> \u{2014} not a commission or conflict tied to a product issuer. On that basis, <strong>no conflicts are disclosed</strong> in relation to this advice.</p>
<p><strong>Complaints:</strong> Contact AgedCareWise using the details on your account or correspondence. If a complaint cannot be resolved, you may refer the matter to the Australian Financial Complaints Authority (AFCA) where eligible.</p>`));
    pages.push($482dbb064a59e381$var$section('Next steps', `
<ul class="riskList">${nextSteps.map((n)=>`<li>${$482dbb064a59e381$export$4cf11838cdc2a8a8(n)}</li>`).join('')}
<li><strong>Re-run the analysis</strong> whenever something significant changes, so the pension, cashflow and estate figures stay current.</li></ul>`));
    pages.push($482dbb064a59e381$var$section("Appendix A \u2014 what you told us", `
<p><strong>Client age:</strong> ${s.clientAge ?? "\u2014"}${s.partnerName ? ` | <strong>Partner age:</strong> ${s.partnerAge ?? "\u2014"}` : ''} | <strong>Living expenses:</strong> ${$482dbb064a59e381$var$money(s.annualLivingExpenses)} a year</p>
<div class="h3">Your assets and the rates applied to each</div>
<table><thead><tr><th>Asset type</th><th>Description</th><th>Value</th><th>Income %</th><th>Growth %</th><th>Client's own figures</th></tr></thead><tbody>
${s.assetRows.map((row)=>`<tr><td>${$482dbb064a59e381$export$4cf11838cdc2a8a8(row.assetType)}</td><td>${$482dbb064a59e381$export$4cf11838cdc2a8a8(row.description)}${row.basis ? `<div class="tiny muted">${$482dbb064a59e381$export$4cf11838cdc2a8a8(row.basis)}</div>` : ''}</td><td>${$482dbb064a59e381$var$money(row.value)}</td><td>${row.incomeRate.toFixed(2)}%</td><td>${row.growthRate.toFixed(2)}%</td><td>${row.overridden ? 'Yes' : 'No'}</td></tr>`).join('')}
</tbody></table>
<p class="tiny muted">Income % is what the model applied. For an investment property it is the yield the recorded rent represents \u{2014} the projections use the rent and expense dollars recorded, not an assumed yield.</p>
${s.structureAppendixHtml || ''}
<div class="h3">Structured fact-find responses</div>
${s.factFindSections.map((sec)=>`<details class="factSection"><summary><strong>${$482dbb064a59e381$export$4cf11838cdc2a8a8(sec.title)}</strong></summary><div>${sec.rows.map((row)=>`<div class="factRow"><div class="factLabel">${$482dbb064a59e381$export$4cf11838cdc2a8a8(row.label)}</div><div>${$482dbb064a59e381$var$toDisplay(row.value)}</div></div>`).join('')}</div></details>`).join('')}`));
    // The raw field dump ("technical full snapshot") is not for the client (owner, 3 Oct 2026); the
    // advice register seals the file the document was built from, and that is the audit record.
    pages.push($482dbb064a59e381$var$section("Appendix B \u2014 the rates and assumptions we applied", `
<p class="lede">Every figure in this document rests on these. Year 1 uses the legislated rates and thresholds; later years index them at the projection inflation rate. The groups most relevant to this advice are open; the rest are here for completeness.</p>
${(0, $8ea663173c1a6588$export$5f05ccad41218e23)(s.assumptionSections, $482dbb064a59e381$var$OPEN_ASSUMPTIONS[s.documentKind])}`));
    const toc = (0, $8ea663173c1a6588$export$ae39401b8f7dcdc4)(pages.map((p)=>p.title.replace(/&amp;/g, '&')));
    const body = pages.map((p, i)=>i === 0 ? p.html.replace('<div id="soa-toc-slot"></div>', toc).replace('<section class="page">', '<section class="page active">') : p.html).join('\n\n');
    return `<!DOCTYPE html><html lang="en-AU"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">
<title>Statement of Advice \u{2014} ${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.clientName)}</title>
<style>
:root{--ink:#0f172a;--muted:#64748b;--line:#e2e8f0;--card:#fff;--accent:#2563eb;--accent2:#4f46e5;--warn-bg:#fff7ed;--warn-border:#fdba74;--warn-ink:#9a3412;--radius:16px;--shadow:0 14px 40px rgba(15,23,42,.08)}
body{margin:0;font-family:Inter,Segoe UI,system-ui,sans-serif;background:var(--ink);color:var(--ink);line-height:1.55}
.cover{min-height:100vh;display:flex;align-items:center;justify-content:center;position:relative;overflow:hidden}
.cover::before{content:'';position:absolute;inset:0;background-image:url('${coverA}');background-size:cover;background-position:center;opacity:.38;animation:moveA 28s ease-in-out infinite}
.cover::after{content:'';position:absolute;inset:0;background-image:url('${coverB}');background-size:cover;background-position:center;opacity:.22;animation:moveB 34s ease-in-out infinite}
.coverShade{position:absolute;inset:0;background:radial-gradient(120% 80% at 30% 20%,rgba(37,99,235,.45),rgba(15,23,42,.88))}
.coverBox{position:relative;z-index:1;max-width:1040px;width:88%;background:rgba(255,255,255,.12);border:1px solid rgba(255,255,255,.35);border-radius:28px;padding:40px 36px;color:#fff;backdrop-filter:blur(8px);box-shadow:0 24px 80px rgba(0,0,0,.35)}
.coverKicker{font-size:12px;letter-spacing:.22em;text-transform:uppercase;opacity:.9}
.coverTitle{font-size:clamp(36px,6vw,58px);line-height:1.05;font-weight:900;margin:10px 0 8px}
.clientNames{font-size:clamp(22px,3.5vw,32px);font-weight:700}
.meta{display:flex;flex-wrap:wrap;gap:8px;margin-top:18px}
.meta span{font-size:11px;padding:8px 12px;border-radius:999px;background:rgba(255,255,255,.16);border:1px solid rgba(255,255,255,.4)}
.openBtn{margin-top:26px;padding:14px 22px;border-radius:14px;border:none;font-weight:800;cursor:pointer;background:#fff;color:var(--ink);font-size:15px;box-shadow:0 8px 24px rgba(0,0,0,.2);transition:transform .15s ease}
.openBtn:hover{transform:translateY(-2px)}
.book{background:#f8fafc;max-width:1200px;margin:0 auto;padding:28px 20px 48px;scroll-margin-top:0;min-height:100vh}
#soa-document{scroll-margin-top:0}
.topNav{position:sticky;top:0;background:rgba(255,255,255,.92);border:1px solid var(--line);border-radius:14px;padding:10px 12px;display:flex;justify-content:space-between;align-items:center;z-index:40;backdrop-filter:blur(10px);box-shadow:var(--shadow);margin-bottom:18px}
.topNav .buttons{display:flex;gap:8px;flex-wrap:wrap}
.topNav button{padding:9px 14px;min-width:90px;border:1px solid #c7d2fe;background:#fff;border-radius:10px;cursor:pointer;font-weight:700;font-size:13px;color:var(--ink)}
.topNav button:hover{border-color:var(--accent);color:var(--accent)}
.pager{font-size:12px;font-weight:700;color:var(--muted)}
.topNav .navEnd{display:flex;align-items:center;gap:12px;flex-wrap:wrap;justify-content:flex-end}
.topNav .printBtn{border-color:var(--navy,#001E7A);color:var(--navy,#001E7A)}
.page{display:none;animation:fadeIn .35s ease}
.page.active{display:block}
@keyframes fadeIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}
.card{background:var(--card);border:1px solid var(--line);border-radius:var(--radius);padding:26px 24px;margin-top:14px;box-shadow:var(--shadow);position:relative;overflow:visible}
.card::before{content:'';position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,#6366f1,#3b82f6);opacity:.9}
.h2{font-size:26px;font-weight:900;margin:0 0 12px;letter-spacing:-.02em}
.h3{font-size:17px;font-weight:800;margin:22px 0 10px;color:#1e293b}
.lede{font-size:16px;margin:10px 0 14px}
.muted{color:var(--muted)}.small{font-size:13px}.tiny{font-size:12px}
.goalsList{margin:8px 0 16px;padding-left:20px}
.goalsList li{margin:6px 0}
.grid3{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px}
.kpi{border:1px solid var(--line);border-radius:12px;padding:14px 12px}
.label{font-size:11px;color:var(--muted);text-transform:uppercase;letter-spacing:.06em;font-weight:700}
.value{font-size:24px;font-weight:900;margin-top:4px}
.callout{border-radius:14px;padding:16px 18px;margin:16px 0}
.callout-title{font-weight:800;margin:0 0 8px;font-size:15px}
.oneLine{font-size:20px;font-weight:800;line-height:1.35;margin:6px 0 14px;color:#1e293b}
.pieces{list-style:none;margin:8px 0 0;padding:0;display:grid;grid-template-columns:repeat(auto-fit,minmax(260px,1fr));gap:10px}
.piece{border:1px solid var(--line);border-radius:12px;padding:12px 14px}
.piece-name{font-weight:800;font-size:14px;margin:0 0 4px}
.piece-amt{color:var(--accent);font-weight:800;margin-left:6px}
.piece-what{font-size:13px;color:#475569;margin:0}
.flow{margin:10px 0 0;padding:0;list-style:none}
.flow li{display:flex;justify-content:space-between;gap:12px;padding:9px 0;border-bottom:1px solid #f1f5f9;font-size:14px}
.flow li strong{white-space:nowrap}
.age-pos{color:#16a34a}.age-neg{color:#dc2626}
.imp-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(260px,1fr));gap:12px;margin-top:10px}
.imp-card{border-radius:12px;padding:14px}
.imp-title{font-size:14px;font-weight:800;margin:0 0 8px}
.imp-lead{font-size:13px;color:#0f172a;margin:0 0 6px}
.imp-body{font-size:13px;color:#334155;margin:0}
.table-proj{font-variant-numeric:tabular-nums}
.table-proj .td-num{white-space:nowrap;position:relative}
.proj-year{white-space:nowrap;font-weight:700;color:#1f2937}
.soa-cell{position:relative;display:inline-block;cursor:help;text-decoration:underline dotted #94a3b8;text-decoration-thickness:1.5px;text-underline-offset:4px;outline:none}
.soa-cell:hover,.soa-cell:focus-visible{text-decoration-color:#2563eb}
.soa-cell-tip{position:absolute;left:50%;top:26px;transform:translateX(-50%);width:max-content;min-width:240px;max-width:min(360px,90vw);padding:12px 14px;border-radius:12px;border:0;background:#0F2A4A;color:#fff;box-shadow:0 14px 34px rgba(15,42,74,.35);font-size:12px;line-height:1.35;display:none;z-index:60;text-align:left;font-weight:400;white-space:normal;cursor:auto}
.soa-cell-tip::before{content:"";position:absolute;top:-5px;left:50%;width:10px;height:10px;background:#0F2A4A;transform:translateX(-50%) rotate(45deg)}
.soa-cell-tip.up{top:auto;bottom:26px}
.soa-cell-tip.up::before{top:auto;bottom:-5px}
/* The last column's bubble hangs to the left of its figure so it never runs off the card. */
.table-proj td:last-child .soa-cell-tip{left:auto;right:0;transform:none}
.table-proj td:last-child .soa-cell-tip::before{left:auto;right:14px;transform:rotate(45deg)}
.soa-cell-tip strong{display:block;color:#7dd3fc;margin-bottom:8px;font-size:13px}
.soa-cell-tip .tip-row{display:flex;justify-content:space-between;align-items:baseline;gap:12px;padding:2px 0}
.soa-cell-tip .tip-lbl{flex:1 1 auto;min-width:0;white-space:normal;overflow-wrap:anywhere}
.soa-cell-tip .tip-row--head{margin-top:4px;color:#cbd5e1;font-weight:700;letter-spacing:.04em;text-transform:uppercase;font-size:10.5px}
.soa-cell-tip .tip-lbl{color:#cbd5e1}
.soa-cell-tip .tip-val{font-variant-numeric:tabular-nums;white-space:nowrap;font-weight:700}
.soa-cell-tip .tip-rule{border-top:1px solid rgba(148,163,184,.35);margin:5px 0}
.soa-cell:hover .soa-cell-tip,.soa-cell:focus .soa-cell-tip,.soa-cell:focus-within .soa-cell-tip,.soa-cell.is-open .soa-cell-tip{display:block}
.soa-all-strategies>summary{cursor:pointer}
.scope-grid{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-top:12px}
.scope-in h4,.scope-out h4{margin:0 0 8px;font-size:13px;text-transform:uppercase;letter-spacing:.06em}
.scope-in ul,.scope-out ul{margin:0;padding-left:18px;font-size:14px}
.opt-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:14px;margin-top:14px;align-items:stretch}
.opt-card{border-radius:14px;padding:16px;display:flex;flex-direction:column;min-height:100%;box-sizing:border-box}
.opt-card-head{display:flex;flex-direction:column;align-items:flex-start;gap:8px;margin-bottom:8px;width:100%}
.opt-card-head .opt-tag{display:inline-block;font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:.08em;padding:4px 8px;border-radius:999px}
.pill-not-selected{font-size:10px;font-weight:800;padding:4px 10px;border-radius:999px}
.pill-selected{font-size:10px;font-weight:800;padding:4px 10px;border-radius:999px}
.opt-title{font-size:16px;margin:0 0 10px;font-weight:800;line-height:1.25}
.opt-card-main{flex:1 1 auto;display:flex;flex-direction:column;min-height:0}
.opt-narr{font-size:14px;color:#475569;margin:0;flex:1 1 auto;line-height:1.45}
.opt-metrics{margin-top:auto;padding-top:14px;border-top:1px solid #e2e8f0;display:grid;grid-template-columns:1fr;gap:8px;font-size:14px}
.opt-metric-line{display:flex;justify-content:space-between;align-items:baseline;gap:12px}
.opt-metric-line strong{font-size:20px;line-height:1.2;white-space:nowrap}
.riskList{margin:0;padding-left:20px}
.riskList li{margin:10px 0}
table{width:100%;border-collapse:collapse;font-size:14px}
th,td{padding:11px 10px;border-bottom:1px solid var(--line);text-align:left}
th{font-weight:800;font-size:12px;text-transform:uppercase;letter-spacing:.04em}
details{margin:10px 0;border-radius:12px;padding:12px}
.factSection{margin-top:8px}.factRow{display:grid;grid-template-columns:minmax(0,320px) 1fr;padding:10px 8px;border-bottom:1px solid #f1f5f9;gap:12px}.factLabel{font-weight:700;color:#334155;font-size:13px}
pre{white-space:pre-wrap;background:var(--ink);color:#e2e8f0;padding:14px;border-radius:10px;max-height:280px;overflow:auto;font-size:11px}
@keyframes moveA{0%,100%{transform:scale(1) translate(0,0)}50%{transform:scale(1.09) translate(-14px,-12px)}}
@keyframes moveB{0%,100%{transform:scale(1) translate(0,0)}50%{transform:scale(1.06) translate(16px,14px)}}
@media (max-width:1020px){.grid3{grid-template-columns:1fr}.opt-grid{grid-template-columns:1fr}.scope-grid{grid-template-columns:1fr}}
@media (max-width:640px){.factRow{grid-template-columns:1fr}}
@media print{
  @page{size:A4 portrait;margin:12mm}
  body{background:#fff !important;color:#000 !important}
  .cover{min-height:auto !important;page-break-after:always}
  .cover::before,.cover::after,.coverShade{display:none !important}
  .coverBox{background:#fff !important;color:#000 !important;border:1px solid #e5e7eb !important;box-shadow:none !important;backdrop-filter:none !important}
  .openBtn{display:none !important}
  .book{max-width:none !important;margin:0 !important;padding:0 !important;background:#fff !important}
  .topNav,.pager,.buttons{display:none !important}
  .page,.page.active{display:block !important;animation:none !important;break-inside:avoid-page;page-break-inside:avoid;margin:0 0 10mm 0}
  .card{box-shadow:none !important;border:1px solid #d1d5db !important;break-inside:avoid-page;page-break-inside:avoid;background:#fff !important}
  details{border:1px solid #d1d5db !important;background:#fff !important}
  table{font-size:11px !important}
  th,td{padding:6px 6px !important}
  .soa-cell{text-decoration:none !important}
  .soa-cell-tip{display:none !important}
  .soa-all-strategies[open]>summary~*{display:block}
}
${0, $8ea663173c1a6588$export$a7aa337a60127637}
</style></head><body>
<section class="cover"><div class="coverShade"></div><div class="coverBox">
<div class="coverKicker">Statement of advice</div>
<div class="coverTitle">${$482dbb064a59e381$export$4cf11838cdc2a8a8($482dbb064a59e381$export$f7856bca3f4078fd[s.documentKind])}</div>
<div class="clientNames">${names}</div>
<div class="meta">
${s.adviceAttributionLine ? `<span>${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.adviceAttributionLine)}</span>` : '<span>AgedCareWise Pty Ltd</span><span>AFSL 401234 (Demo)</span><span>ABN 12 345 678 901 (Demo)</span>'}
<span>Report ${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.reportId)}</span><span>${$482dbb064a59e381$export$75477e21c4edfb09(s.generatedAt)}</span>
<span>Source: ${s.strategySource === 'manual_control' ? 'MC (Manual Control)' : 'SE (Suggestion Engine)'}</span>
${s.completerDisplay ? `<span>Completed by: ${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.completerDisplay)}${s.completerRelationship ? ` (${$482dbb064a59e381$export$4cf11838cdc2a8a8(s.completerRelationship)})` : ''}</span>` : ''}
</div>
<button type="button" class="openBtn" onclick="openBooklet()">Begin reading your advice</button>
<p class="muted" style="margin-top:14px;font-size:13px;opacity:.85">Opens your Statement of Advice below \u{2014} use <strong>Next</strong> / <strong>Previous</strong> to move through each section, or the contents list to jump to one.</p>
</div></section>
<div class="book" id="soa-document">
<div class="topNav">
  <div class="buttons">
    <button type="button" onclick="prevPage()">Previous</button>
    <button type="button" onclick="nextPage()">Next</button>
    <button type="button" data-goto="0">Contents</button>
  </div>
  <div class="navEnd"><button type="button" class="printBtn" data-print>Print or save as PDF</button><div class="pager" id="pager"></div></div>
</div>

${body}

</div>
<script src="${$482dbb064a59e381$var$soaBookletScriptUrl}"></script>
</body></html>`;
}
function $482dbb064a59e381$export$bedc55c6dae3ee6a(snapshot) {
    const html = $482dbb064a59e381$export$f4681787750c522d(snapshot);
    const blob = new Blob([
        html
    ], {
        type: 'text/html;charset=utf-8'
    });
    const url = URL.createObjectURL(blob);
    const safeName = snapshot.clientName.replace(/[^a-zA-Z0-9]/g, '_');
    const label = {
        retirement_village: 'RetirementVillage',
        downsizer: 'Downsizer',
        granny_flat: 'GrannyFlat',
        cashflow_pension: 'CashflowPension'
    }[snapshot.documentKind];
    const tab = window.open('', '_blank');
    if (tab) {
        tab.document.open();
        tab.document.write(html);
        tab.document.close();
    } else {
        const openLink = document.createElement('a');
        openLink.href = url;
        openLink.target = '_blank';
        openLink.rel = 'noopener noreferrer';
        document.body.appendChild(openLink);
        openLink.click();
        document.body.removeChild(openLink);
    }
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = `Digital_SOA_${label}_${safeName}_${snapshot.generatedAt.slice(0, 10)}.html`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    setTimeout(()=>URL.revokeObjectURL(url), 30000);
}
function $482dbb064a59e381$export$caf941bdb2b0342e(kinds, moneyFlow) {
    const rows = [];
    const amount = (re)=>moneyFlow.filter((r)=>re.test(r.label)).reduce((t, r)=>t + r.amount, 0);
    const soldHome = kinds.includes('sellHome');
    const from = soldHome ? 'Your home, once sold' : 'Your savings and investments';
    const fromCharges = soldHome ? 'Agent and legal fees on the sale (included in the figures), and capital gains tax on any investments sold.' : 'Capital gains tax on any shares or managed funds sold to raise the money.';
    if (kinds.includes('annuityNil') || kinds.includes('annuityReturned') || kinds.includes('annuityGuaranteed')) {
        const amt = amount(/annuity/i);
        rows.push({
            from: `${from}${amt ? ` (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(amt)})` : ''}`,
            to: 'A lifetime annuity',
            charges: `${fromCharges} The insurer's pricing is built into the income rate; there is no separate fee.`,
            consequences: 'Centrelink counts 60% of the purchase price (30% later) and 60% of the payments as income, which usually lifts the pension.',
            lost: kinds.includes('annuityNil') ? 'Access to the capital, and anything for your estate from it. The income is fixed at purchase.' : 'Easy access to the capital. What comes back winds down over time, and the income is fixed at purchase.'
        });
    }
    if (kinds.includes('investmentProperty')) {
        const amt = amount(/property/i);
        rows.push({
            from: `${from}${amt ? ` (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(amt)})` : ''}`,
            to: 'An investment property',
            charges: `${fromCharges} Stamp duty, legal fees and, later, agent fees to sell.`,
            consequences: 'The property is counted as an asset and the rent as income for the Age Pension; rent is taxable.',
            lost: 'The ability to sell part of the money quickly, and the diversification of spreading it across several investments.'
        });
    }
    if (kinds.includes('shares')) {
        const amt = amount(/shares|managed/i);
        rows.push({
            from: `${from}${amt ? ` (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(amt)})` : ''}`,
            to: 'Shares or managed funds',
            charges: `${fromCharges} Brokerage or fund fees apply, set by the platform or fund.`,
            consequences: 'The balance is counted as an asset and income is deemed on it for the Age Pension.',
            lost: 'The certainty of a bank balance: the value moves with markets.'
        });
    }
    if (kinds.includes('superContribution') || kinds.includes('accountBasedPension')) {
        const amt = amount(/super|pension/i);
        rows.push({
            from: `${from}${amt ? ` (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(amt)})` : ''}`,
            to: kinds.includes('accountBasedPension') ? 'Super, then an account-based pension' : 'Super',
            charges: `${fromCharges} The fund's administration and investment fees apply, set by the fund.`,
            consequences: 'Over pension age the balance is counted and deemed; inside super, earnings are taxed concessionally or not at all.',
            lost: 'Unlimited access: minimum pension payments apply, and super rules can change.'
        });
    }
    if (kinds.includes('investmentBond')) rows.push({
        from: from,
        to: 'An investment bond',
        charges: `${fromCharges} The bond's fees apply, set by the issuer.`,
        consequences: 'Counted as an asset and deemed for the Age Pension; earnings are taxed inside the bond at 30%.',
        lost: 'Some of the tax benefit if you withdraw within ten years.'
    });
    if (kinds.includes('funeralBond')) rows.push({
        from: from,
        to: 'A funeral bond',
        charges: `${fromCharges} The bond's fees apply, set by the issuer.`,
        consequences: 'Up to the allowable limit is exempt from the Age Pension assets test.',
        lost: 'Any use of the money other than a funeral.'
    });
    return rows;
}
const $482dbb064a59e381$export$472dfc9f05c9ea81 = [
    'How the plan you chose changes your Age Pension, your yearly cashflow and what is left to the family, measured against staying as you are.',
    'A comparison of every plan the engine modelled on your figures, using the assumptions in the appendix.',
    "Illustrative projections of pension, cashflow and net worth year by year \u2014 not forecasts of actual future balances."
];
const $482dbb064a59e381$export$b33080f9829eee85 = [
    'Choosing or endorsing a particular village, builder, lender, insurer or agent.',
    'Medical, care-needs or aged care placement decisions.',
    'Foreign assets, complex business structures, or anything not captured in your profile.'
];
const $482dbb064a59e381$export$b104535f5280d9cf = 'A defined benefit pension recorded in your profile is modelled as paid, assessed and taxed; the decision to take one, or to commute one, is not.';
function $482dbb064a59e381$export$c6a118b4246f3a25(factFind) {
    const items = factFind?.income?.otherIncomes || [];
    return Array.isArray(items) && items.some((i)=>(0, $f94c75e8792c4be0$export$ecbf3b113ae95cba)(i));
}
function $482dbb064a59e381$export$b73d600a5ab2902f(factFind) {
    return $482dbb064a59e381$export$c6a118b4246f3a25(factFind) ? [
        ...$482dbb064a59e381$export$b33080f9829eee85,
        $482dbb064a59e381$export$b104535f5280d9cf
    ] : [
        ...$482dbb064a59e381$export$b33080f9829eee85
    ];
}
/* ─── Plain-words plan pieces by part, for the modules without their own piece builder ──────── */ const $482dbb064a59e381$var$PIECE_WORDS = {
    sellHome: {
        name: 'Selling the family home',
        what: 'The home is exempt from the Age Pension test; the money from selling it is not, so what you do with it next decides the pension.'
    },
    sellInvestmentProperty: {
        name: 'Selling an investment property',
        what: 'Capital gains tax may apply; the rent stops and the money is counted wherever it goes next.'
    },
    rentHome: {
        name: 'Keeping the home and renting it out',
        what: 'The rent is counted as income and is taxable; after a time the home itself can be counted as an asset.'
    },
    investmentProperty: {
        name: 'Buying an investment property',
        what: 'Counted as an asset, with the net rent counted as income. Stamp duty is paid on the way in.'
    },
    shares: {
        name: 'Investing in shares or managed funds',
        what: 'Counted as an asset; Centrelink deems a set income on the balance whether or not it is earned.'
    },
    investmentBond: {
        name: 'An investment bond',
        what: 'Counted and deemed like other investments; earnings are taxed inside the bond and withdrawals are tax-free after ten years.'
    },
    superContribution: {
        name: 'Putting money into super',
        what: 'Money goes into super as a downsizer contribution (up to $300,000 each from selling a home owned 10 years or more, from age 55) or as an after-tax contribution within the yearly limits. Earnings are taxed at no more than 15%, and nothing once it pays a pension; over pension age the balance is counted and deemed.'
    },
    accountBasedPension: {
        name: 'Starting an account-based pension',
        what: 'Pays you a regular income from super, with minimum amounts each year; the balance is counted and deemed.'
    },
    annuityNil: {
        name: 'A lifetime annuity (nothing back on death)',
        what: 'Guaranteed income for life. Centrelink counts 60% of the price as an asset and 60% of the payments as income.'
    },
    annuityReturned: {
        name: 'A lifetime annuity (capital returned)',
        what: 'Guaranteed income for life with a winding-down amount back on death. Counted at 60% for the assets test.'
    },
    annuityGuaranteed: {
        name: 'An annuity that returns the full amount on death',
        what: 'Part annuity, part insurance. The insurance part is counted at what you paid, the annuity part at 60%.'
    },
    funeralBond: {
        name: 'A funeral bond',
        what: 'Money set aside for a funeral. Up to the allowable limit is exempt from the assets test.'
    },
    gift: {
        name: 'A gift to family',
        what: 'Up to $10,000 a year ($30,000 over five years) stops being counted; anything above still counts for five years.'
    },
    clearDebt: {
        name: 'Paying off debt',
        what: 'Money used to clear a debt is no longer counted as an asset, and the repayments stop.'
    },
    fromSavings: {
        name: 'Paying from savings',
        what: 'Bank accounts and term deposits are drawn first, then investments; what is used stops being counted.'
    },
    villageEntry: {
        name: 'The village entry contribution',
        what: 'Paid to the operator when you move in and refunded, less the departure fee, when you leave. Not counted as an asset.'
    },
    grannyFlat: {
        name: 'The granny flat right',
        what: 'What you pay for the right to live there. Up to the reasonable value is exempt; above it counts as a gift.'
    },
    transferHome: {
        name: 'Transferring the home',
        what: 'The home becomes theirs; value given above a reasonable amount can count as a gift for five years.'
    },
    reverseMortgage: {
        name: 'A reverse mortgage',
        what: 'Borrowing against the home with no repayments; interest is added to the loan and it is repaid when the home is sold.'
    },
    heas: {
        name: 'The Home Equity Access Scheme',
        what: 'A government loan against the home, paid fortnightly, repaid with interest when the home is sold.'
    },
    renovate: {
        name: 'Spending on the home',
        what: 'Money moved into the home leaves the Age Pension count, because the home is exempt.'
    },
    stayPut: {
        name: 'Changing nothing',
        what: 'Everything stays as it is today.'
    }
};
function $482dbb064a59e381$export$11e6b3c860abae6f(kinds, amounts = {}) {
    const seen = new Set();
    return kinds.filter((k)=>seen.has(k) ? false : (seen.add(k), true)).flatMap((k)=>{
        const w = $482dbb064a59e381$var$PIECE_WORDS[k];
        return w ? [
            {
                name: w.name,
                what: w.what,
                amount: amounts[k] ?? null
            }
        ] : [];
    });
}
function $482dbb064a59e381$export$64ada78711707257(headline, baseline, years) {
    const out = [];
    const say = (label, a, b, upIsGood, suffix)=>{
        const d = a - b;
        if (Math.abs(d) < 1) {
            out.push(`${label} is unchanged${suffix}.`);
            return;
        }
        const better = upIsGood ? d > 0 : d < 0;
        out.push(`${label} is ${better ? 'better' : 'worse'} by ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(d))}${suffix} than ${baseline.name.toLowerCase()}.`);
    };
    say('The Age Pension', headline.pension, baseline.pension, true, ' a year');
    say('Cashflow', headline.cashflow, baseline.cashflow, true, ' a year');
    say(`The estate after ${years} years`, headline.estate, baseline.estate, true, '');
    if (headline.cashflow < 0) out.push(`Cashflow is still short by ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(headline.cashflow))} a year, which the projections draw from savings.`);
    return out;
}


/** The funding source name used for the deposit, so the scan and the sentence cannot disagree. */ const $02a659cad5e2280d$var$RAD_SOURCE = 'the refundable accommodation deposit';
// DraftFactFind is structurally compatible with FactFind (formDraft.ts); the shared
// calc-engine fns below defensively coerce internally regardless (factFindTypes.ts header).
const $02a659cad5e2280d$var$asFactFind = (factFind)=>factFind;

// Served as a same-origin <script src> in the popup HTML below rather than inlined, so the popup
// (which inherits this app's CSP — window.open('') + document.write and the blob: fallback both
// count as CSP-inheriting navigations) doesn't need 'unsafe-inline'/a content hash in script-src.
const $02a659cad5e2280d$var$soaBookletScriptUrl = new URL($7ed81d1f360bfd38$exports).href;
const $02a659cad5e2280d$var$GOAL_LABELS = {
    home_care: 'Access home care support',
    aged_care: 'Move into residential aged care',
    downsize_home: 'Downsize the family home',
    retirement_village: 'Move to a retirement village',
    granny_flat: 'Explore granny flat arrangements',
    meet_costs: 'Meet care costs',
    maximise_support: 'Maximise government support',
    preserve_assets: 'Preserve assets for inheritance',
    funding_guidance: 'Guidance on funding options'
};
const $02a659cad5e2280d$var$LIVING_ARRANGEMENT_GOAL_KEYS = new Set([
    'home_care',
    'aged_care',
    'retirement_village',
    'granny_flat'
]);
/* The funding order only — see futureLifeEventUtils. A broader strip put two different strategies
   under one name, which in a Statement of Advice is worse than clutter. */ const $02a659cad5e2280d$var$stripFundingSuffix = (name = '')=>(0, $eb4adc50b37e37f7$export$1384c6fc4de1c498)(name);
const $02a659cad5e2280d$var$ASSET_IMPLICATION_TEMPLATES = {
    bankAccounts: 'Using cash from bank accounts immediately reduces your liquid emergency buffer and may reduce interest income. Keep enough short-term liquidity for ongoing fees and unexpected costs.',
    termDeposits: 'Breaking a term deposit early can trigger break costs, reduced interest, or repricing by the provider. Confirm break conditions with the institution before implementation.',
    shares: 'Selling shares can crystallise capital gains or losses and changes your future dividend/growth profile. Transaction costs and timing can materially affect net proceeds.',
    accountBasedPensions: 'Drawing from an account-based pension reduces the pension balance available for future income and may alter minimum-drawdown and Centrelink outcomes over time.',
    superannuation: 'Commuting or withdrawing super changes retirement-phase balances and future income capacity. Tax treatment depends on age, component mix, and payment type.',
    investmentProperty: 'Selling investment property can trigger CGT, selling costs, and potential changes to rental income assumptions. Final tax outcomes depend on ownership and cost-base records.',
    annuities: 'Commuting or exiting annuity-style products may trigger surrender adjustments or provider-imposed exit terms. Confirm product conditions before proceeding.',
    other: 'Selling non-standard assets can involve valuation, tax, and transaction complexity. Check legal and tax consequences before actioning the strategy.'
};
function $02a659cad5e2280d$var$toNumber(value) {
    const parsed = parseFloat(String(value));
    return Number.isFinite(parsed) ? parsed : 0;
}
function $02a659cad5e2280d$var$sanitizeText(value) {
    return String(value || '').replace(/Ã¢â‚¬â€œ|â€“/g, '-').replace(/Ã¢â‚¬â€”|â€”/g, '-').replace(/Ã¢â‚¬â„¢|â€™/g, "'").replace(/Ã¢â‚¬Å“|Ã¢â‚¬Â|â€œ|â€/g, '"').replace(/Ã‚/g, '').trim();
}
/**
 * Escape text that came from a FIRM for a template that is assembled as a string.
 *
 * The attribution line is built from names the firm typed — licensee, practice, adviser — and this
 * document is concatenated HTML rather than rendered by React, so nothing else stands between those
 * values and the page. sanitizeText next door repairs mojibake; it does not make markup inert.
 */ function $02a659cad5e2280d$var$escapeHtml(value) {
    return String(value ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
/** A field key as a label: `home_care_for` and `annuityAppetite` both read "Home Care For" / "Annuity Appetite". */ function $02a659cad5e2280d$var$prettify(text) {
    const words = String(text || '').replace(/([A-Z])/g, ' $1').split(/[_\s]+/).filter(Boolean);
    return $02a659cad5e2280d$var$sanitizeText(words.map((w)=>w.charAt(0).toUpperCase() + w.slice(1)).join(' '));
}
function $02a659cad5e2280d$var$formatDateOnly(dateValue) {
    return new Date(dateValue).toLocaleDateString('en-AU', {
        year: 'numeric',
        month: 'long',
        day: '2-digit'
    });
}
function $02a659cad5e2280d$export$57a9131fd362a631(value) {
    if (value === null || value === undefined || value === '') return 'Not provided';
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    const text = String(value);
    if (/^[a-z][a-z0-9_ ]*$/i.test(text) && !/^\d/.test(text)) {
        const spaced = text.replace(/_/g, ' ');
        return $02a659cad5e2280d$var$sanitizeText(spaced.charAt(0).toUpperCase() + spaced.slice(1));
    }
    return $02a659cad5e2280d$var$sanitizeText(text);
}
function $02a659cad5e2280d$var$flattenObject(value, prefix = '') {
    if (value === null || value === undefined) return [];
    if (Array.isArray(value)) return value.flatMap((item, idx)=>$02a659cad5e2280d$var$flattenObject(item, `${prefix}[${idx}]`));
    if (typeof value === 'object') return Object.entries(value).flatMap(([key, nested])=>$02a659cad5e2280d$var$flattenObject(nested, prefix ? `${prefix}.${key}` : key));
    return [
        {
            key: prefix,
            value: String(value)
        }
    ];
}
function $02a659cad5e2280d$var$parseMoneyish(value) {
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    return parseFloat(String(value ?? '').replace(/[$,]/g, '')) || 0;
}
function $02a659cad5e2280d$var$classifyPensionLevel(annualPension, annualMaximum) {
    const amount = Number(annualPension) || 0;
    const max = Number(annualMaximum) || 0;
    if (amount <= 0) return 'not currently receiving Age Pension';
    if (max > 0 && amount >= max * 0.95) return 'receiving close to the full Age Pension';
    return 'receiving a part Age Pension';
}
const $02a659cad5e2280d$var$HEALTH_STATUS_LABELS = {
    good: 'good overall health',
    fair: 'fair health (some support needs)',
    poor: 'poorer health (significant support needs)'
};
function $02a659cad5e2280d$var$healthStatusLabel(status) {
    if (!status) return 'health status not specified';
    return $02a659cad5e2280d$var$HEALTH_STATUS_LABELS[String(status).toLowerCase()] || $02a659cad5e2280d$var$sanitizeText(String(status));
}
function $02a659cad5e2280d$var$ynUnsureLabel(v) {
    if (v === true || v === 'yes') return 'Yes';
    if (v === false || v === 'no') return 'No';
    if (v === 'unsure') return 'Unsure';
    return $02a659cad5e2280d$export$57a9131fd362a631(v);
}
function $02a659cad5e2280d$var$ynRecordLabel(v) {
    if (v === undefined || v === null || v === '') return 'Not recorded in fact-find';
    return $02a659cad5e2280d$var$ynUnsureLabel(v);
}
function $02a659cad5e2280d$export$8e29f3a7af07ac8(projectionsData, formatMoney, headlineShortfall) {
    if (!projectionsData || projectionsData.length === 0) return null;
    const year1Cashflow = projectionsData[0]?.cashFlow ?? projectionsData[0]?.cashflow ?? 0;
    const isYear1Surplus = year1Cashflow > 0;
    const yearBreakdown = [];
    let firstDeficitYear = null;
    let firstDeficitAmount = 0;
    let hasDeficitYears = false;
    for(let i = 0; i < projectionsData.length; i++){
        const projection = projectionsData[i];
        const year = projection?.year ?? i + 1;
        const cashflow = projection?.cashFlow ?? projection?.cashflow ?? 0;
        const isDeficit = cashflow < 0;
        const deficitAmount = isDeficit ? Math.abs(cashflow) : 0;
        const bankBalance = (projection?.assets?.bankAccounts || []).reduce((sum, acc)=>sum + (parseFloat(String(acc.value)) || 0), 0);
        const abpBalance = (projection?.assets?.accountBasedPensions || []).reduce((sum, abp)=>sum + (parseFloat(String(abp.value)) || 0), 0);
        const sharesBalance = (projection?.assets?.shares || []).reduce((sum, share)=>sum + (parseFloat(String(share.value)) || 0), 0);
        const drawdownBreakdown = projection?.drawdownBreakdown || [];
        const fundingSources = drawdownBreakdown.filter((item)=>$02a659cad5e2280d$var$parseMoneyish(item.value) > 0).map((item)=>item.label);
        let primaryFundingSource = null;
        if (isDeficit && fundingSources.length > 0) primaryFundingSource = fundingSources[0];
        else if (isDeficit && fundingSources.length === 0) {
            if (bankBalance > 0) primaryFundingSource = 'Bank Account';
            else if (abpBalance > 0) primaryFundingSource = 'Account-Based Pensions';
            else if (sharesBalance > 0) primaryFundingSource = 'Shares';
        }
        yearBreakdown.push({
            year: year,
            cashflow: cashflow,
            isDeficit: isDeficit,
            deficitAmount: deficitAmount,
            bankBalance: bankBalance,
            abpBalance: abpBalance,
            sharesBalance: sharesBalance,
            fundingSources: fundingSources,
            primaryFundingSource: primaryFundingSource
        });
        if (isDeficit && firstDeficitYear === null) {
            firstDeficitYear = year;
            firstDeficitAmount = deficitAmount;
            hasDeficitYears = true;
        }
    }
    /*
     * The table's first year is its own figure: it may start part-way through the financial year (the day
     * care begins), so its yearly rate differs a little from the typical full year the summary quotes.
     */ const headline = headlineShortfall != null && headlineShortfall > 0 ? headlineShortfall : null;
    const firstYearDiffers = headline != null && firstDeficitYear === 1 && Math.abs(Math.round(headline) - Math.round(firstDeficitAmount)) >= 1;
    const firstRow = projectionsData[0];
    const startWords = (()=>{
        const iso = typeof firstRow?.periodStart === 'string' ? firstRow.periodStart.slice(0, 10) : '';
        const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (!m || !firstRow?.isPartialFy) return null;
        return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])).toLocaleDateString('en-AU', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    })();
    const firstYearNote = firstYearDiffers ? startWords ? `The first year in the year-by-year table starts on ${startWords}, so its figure (about ${formatMoney(firstDeficitAmount)} a year) is a little different.` : `The first year in the year-by-year table is worked out on that year's own figures, so its shortfall (about ${formatMoney(firstDeficitAmount)}) is a little different.` : null;
    const buildDetailedNarrative = ()=>{
        if (!hasDeficitYears) return null;
        const narrative = [];
        let currentFundingSource = null;
        const transitionPoints = [];
        for(let i = 0; i < yearBreakdown.length; i++){
            const breakdown = yearBreakdown[i];
            if (breakdown.isDeficit) {
                const funding = breakdown.primaryFundingSource;
                if (currentFundingSource !== funding) {
                    if (currentFundingSource !== null) transitionPoints.push({
                        year: breakdown.year,
                        from: currentFundingSource,
                        to: funding
                    });
                    currentFundingSource = funding;
                }
            }
        }
        if (transitionPoints.length > 0) {
            narrative.push(firstYearDiffers ? firstYearNote : `Year ${firstDeficitYear} begins with a deficit of ${formatMoney(firstDeficitAmount)}.`);
            transitionPoints.forEach((transition, idx)=>{
                if (idx === 0 && transition.year === firstDeficitYear) narrative.push(`The deficit is initially funded from your ${transition.to}.`);
                else narrative.push(`From year ${transition.year}, funding shifts from ${transition.from} to ${transition.to}.`);
            });
        } else if (firstDeficitYear != null) {
            narrative.push(`From year ${firstDeficitYear}, the model shows an annual shortfall of about ${formatMoney(firstDeficitYear === 1 && headline != null ? headline : firstDeficitAmount)}, met from liquid assets in the order shown in the projection funding breakdown.`);
            if (firstYearNote) narrative.push(firstYearNote);
        }
        return narrative.length > 0 ? narrative.join(' ') : null;
    };
    return {
        year1Cashflow: year1Cashflow,
        isYear1Surplus: isYear1Surplus,
        firstDeficitYear: firstDeficitYear,
        firstDeficitAmount: firstDeficitAmount,
        hasDeficitYears: hasDeficitYears,
        yearBreakdown: yearBreakdown,
        detailedNarrative: buildDetailedNarrative()
    };
}
/**
 * Mirrors AgedCareInsightPanel.getDeficitFundingExplanation for SOA export.
 */ function $02a659cad5e2280d$var$getDeficitFundingExplanationForSOA(cashFlowValue, projectionsToUse, formatMoney) {
    if (cashFlowValue >= 0 || !projectionsToUse?.length) return null;
    const targetProjection = projectionsToUse[0];
    const drawdownBreakdown = targetProjection?.drawdownBreakdown || [];
    const deficitAmount = Math.abs(cashFlowValue);
    if (drawdownBreakdown.length === 0) return `The model funds this shortfall (${formatMoney(deficitAmount)} per year) from liquid assets in order: bank accounts first, then account-based pensions, then listed shares.`;
    const firstAsset = drawdownBreakdown[0];
    const firstLabel = (firstAsset.label || '').toLowerCase();
    if (firstLabel.includes('bank') || firstLabel.includes('acc')) {
        let yearBankDepletes = null;
        let nextAsset = null;
        for(let i = 0; i < projectionsToUse.length; i++){
            const yearData = projectionsToUse[i];
            let totalBank = 0;
            if (yearData?.assets?.bankAccounts?.length) yearData.assets.bankAccounts.forEach((acc)=>{
                totalBank += parseFloat(String(acc.value)) || 0;
            });
            if (totalBank < 1000 && yearBankDepletes === null) {
                yearBankDepletes = yearData.year ?? i + 1;
                const breakdown = yearData.drawdownBreakdown || [];
                for (const item of breakdown){
                    const normalized = (item.label || '').toLowerCase();
                    const amount = $02a659cad5e2280d$var$parseMoneyish(item.value);
                    if (amount > 0) {
                        if (normalized.includes('account-based pension') || normalized.includes('abp')) {
                            nextAsset = item.label || 'account-based pensions';
                            break;
                        }
                        if (normalized.includes('share')) {
                            nextAsset = item.label || 'shares';
                            break;
                        }
                        if ((0, $0fe89e03b6df746e$export$b82101157bcb6ca6)(item)) {
                            nextAsset = $02a659cad5e2280d$var$RAD_SOURCE;
                            break;
                        }
                        if ((0, $0fe89e03b6df746e$export$7b2b094d6d51893)(item)) {
                            nextAsset = 'borrowing against the home';
                            break;
                        }
                    }
                }
                break;
            }
        }
        if (yearBankDepletes != null) {
            if (!nextAsset) {
                const startIndex = Math.max(0, yearBankDepletes - 1);
                for(let i = startIndex; i < projectionsToUse.length; i++){
                    const yearData = projectionsToUse[i];
                    const breakdown = yearData?.drawdownBreakdown || [];
                    for (const item of breakdown){
                        const normalized = (item.label || '').toLowerCase();
                        const amount = $02a659cad5e2280d$var$parseMoneyish(item.value);
                        if (amount > 0 && !normalized.includes('bank') && !normalized.includes('acc')) {
                            if (normalized.includes('account-based pension') || normalized.includes('abp')) {
                                nextAsset = item.label || 'account-based pensions';
                                break;
                            }
                            if (normalized.includes('share')) {
                                nextAsset = item.label || 'shares';
                                break;
                            }
                            if ((0, $0fe89e03b6df746e$export$b82101157bcb6ca6)(item)) {
                                nextAsset = $02a659cad5e2280d$var$RAD_SOURCE;
                                break;
                            }
                            if ((0, $0fe89e03b6df746e$export$7b2b094d6d51893)(item)) {
                                nextAsset = 'borrowing against the home';
                                break;
                            }
                            if (!nextAsset) nextAsset = item.label || null;
                        }
                    }
                    if (nextAsset) break;
                }
            }
            if (nextAsset) {
                if (nextAsset === $02a659cad5e2280d$var$RAD_SOURCE) return `The model uses your bank account first to cover the ${formatMoney(deficitAmount)} annual shortfall. Bank cash is projected to fall below a nominal buffer by year ${yearBankDepletes}; from that point the care fees are drawn from your refundable accommodation deposit. Each dollar drawn reduces the amount refunded when care ends and increases the daily accommodation payment, which is charged on the unpaid part of the room at the maximum permissible interest rate. Only fees owed to the provider are drawn this way; living expenses are not.`;
                if ((0, $0fe89e03b6df746e$export$7b2b094d6d51893)({
                    label: nextAsset
                })) return `The model uses your bank account first to cover the ${formatMoney(deficitAmount)} annual shortfall. Bank cash is projected to fall below a nominal buffer by year ${yearBankDepletes}; after that, the shortfall is met by borrowing against the home through a reverse mortgage at about ${0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279}% p.a. Nothing is repaid, so interest is added to the balance each year and it compounds until the home is sold.`;
                return `The model uses your bank account first to cover the ${formatMoney(deficitAmount)} annual shortfall. Bank cash is projected to fall below a nominal buffer by year ${yearBankDepletes}; from that point the shortfall is met from ${nextAsset}.`;
            }
            let hasOtherAssets = false;
            const startIdx = Math.max(0, (yearBankDepletes || 1) - 1);
            for(let i = startIdx; i < projectionsToUse.length; i++){
                const yearData = projectionsToUse[i];
                if (yearData?.assets?.accountBasedPensions?.length) {
                    const totalABP = yearData.assets.accountBasedPensions.reduce((s, a)=>s + (parseFloat(String(a.value)) || 0), 0);
                    if (totalABP > 1000) {
                        hasOtherAssets = true;
                        break;
                    }
                }
                if (yearData?.assets?.shares?.length) {
                    const totalShares = yearData.assets.shares.reduce((s, sh)=>s + (parseFloat(String(sh.value)) || 0), 0);
                    if (totalShares > 1000) {
                        hasOtherAssets = true;
                        break;
                    }
                }
                const breakdown = yearData?.drawdownBreakdown || [];
                for (const item of breakdown){
                    const normalized = (item.label || '').toLowerCase();
                    const amount = $02a659cad5e2280d$var$parseMoneyish(item.value);
                    if (amount > 0 && !normalized.includes('bank') && !normalized.includes('acc')) {
                        hasOtherAssets = true;
                        break;
                    }
                }
                if (hasOtherAssets) break;
            }
            if (hasOtherAssets) return `The model uses your bank account first for the ${formatMoney(deficitAmount)} shortfall. By year ${yearBankDepletes} bank balances are projected to be largely exhausted; ongoing deficits are then met from other liquid assets (typically account-based pensions, then shares) in the order modelled in the year-by-year drawdown detail.`;
            return `The model uses your bank account for the ${formatMoney(deficitAmount)} shortfall; by year ${yearBankDepletes} bank cash is largely exhausted and the projection shows insufficient other liquidity to fully fund the deficit \u{2014} revisit assumptions or funding options in AgedCareWise.`;
        }
        return `The model meets the ${formatMoney(deficitAmount)} annual shortfall from your bank account across the projection horizon.`;
    }
    if (firstLabel.includes('account-based pension') || firstLabel.includes('abp')) return `The model meets the ${formatMoney(deficitAmount)} annual shortfall primarily from account-based pensions.`;
    if (firstLabel.includes('share')) return `The model meets the ${formatMoney(deficitAmount)} annual shortfall primarily from listed shares (drawdowns).`;
    if ((0, $0fe89e03b6df746e$export$b82101157bcb6ca6)(drawdownBreakdown[0])) return `The model meets the ${formatMoney(deficitAmount)} shortfall primarily by drawing care fees from the refundable accommodation deposit, which reduces the refund when care ends and increases the daily accommodation payment on the amount drawn.`;
    if ((0, $0fe89e03b6df746e$export$7b2b094d6d51893)(drawdownBreakdown[0])) {
        if (drawdownBreakdown.length === 1) return `The model meets the ${formatMoney(deficitAmount)} shortfall by borrowing against the home through a reverse mortgage at about ${0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279}% p.a.; nothing is repaid, so the balance compounds until the home is sold.`;
        const otherAssets = drawdownBreakdown.filter((d)=>!(0, $0fe89e03b6df746e$export$7b2b094d6d51893)(d)).map((d)=>d.label).join(', then ');
        return `The model meets the ${formatMoney(deficitAmount)} shortfall from ${otherAssets} first; if those sources are exhausted, remaining gaps are funded by borrowing against the home through a reverse mortgage (about ${0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279}% p.a., no repayments) as modelled.`;
    }
    const hasHeloc = drawdownBreakdown.some((d)=>(0, $0fe89e03b6df746e$export$7b2b094d6d51893)(d));
    if (hasHeloc) {
        const nonHelocAssets = drawdownBreakdown.filter((d)=>!(0, $0fe89e03b6df746e$export$7b2b094d6d51893)(d)).map((d)=>d.label);
        let explanation = `Liquid assets are drawn in this order: ${nonHelocAssets.join(', then ')}`;
        explanation += `. If those sources are insufficient, the model may borrow against the home through a reverse mortgage at about ${0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279}% p.a.; nothing is repaid, so the balance compounds until the home is sold.`;
        return explanation;
    }
    return `The model allocates the ${formatMoney(deficitAmount)} shortfall across: ${drawdownBreakdown.map((d)=>d.label).join(', then ')}.`;
}
function $02a659cad5e2280d$var$buildProjectionFootnote(cashflowAnalysis, annualCashflow, formatMoney) {
    if (!cashflowAnalysis) {
        if (annualCashflow >= 0) return `Annual cashflow is positive (${formatMoney(annualCashflow)}). Surpluses in the model are retained inside the balance sheet (higher bank or investment balances unless otherwise drawn for RAD or other cash needs in that year).`;
        return `Cashflow is projected to be negative in the selected strategy; see the funding explanation and year-by-year projection details.`;
    }
    if (cashflowAnalysis.isYear1Surplus && !cashflowAnalysis.hasDeficitYears) return `Projections show a surplus each year. Those surpluses accumulate in the assets modelled (unless consumed by one-off costs such as RAD funding in an earlier year).`;
    if (cashflowAnalysis.isYear1Surplus && cashflowAnalysis.hasDeficitYears) return `You start with a surplus of ${formatMoney(cashflowAnalysis.year1Cashflow)} in the first projection year (Comparison Yr1 when the app uses financial-year rows); the model later shows a shortfall from projection year ${cashflowAnalysis.firstDeficitYear} of about ${formatMoney(cashflowAnalysis.firstDeficitAmount)} per year unless assumptions change.`;
    if (!cashflowAnalysis.isYear1Surplus && cashflowAnalysis.hasDeficitYears) return `The modelled household cashflow is in deficit from the first projection year; funding is sourced as described above and in each year\u{2019}s drawdown breakdown.`;
    return '';
}
function $02a659cad5e2280d$var$acatStatusLabel(status) {
    const map = {
        yes: "Yes \u2014 assessment completed",
        no: 'No',
        in_progress: 'In progress'
    };
    return map[String(status)] || $02a659cad5e2280d$export$57a9131fd362a631(status);
}
function $02a659cad5e2280d$var$buildAcatFactRows(personData, personLabel) {
    if (!personData) return [];
    const rows = [
        {
            label: `${personLabel} \u{2014} Aged care needs assessment completed?`,
            value: $02a659cad5e2280d$var$acatStatusLabel(personData.status)
        }
    ];
    if (personData.status !== 'yes') return rows;
    rows.push({
        label: `${personLabel} \u{2014} Home Care Package in place, approved or on the waiting list at 12 Sep 2024`,
        value: personData.hcpBeforeSep2024 === 'unsure' ? "Not sure \u2014 standard rules assumed (usually the higher fees)" : $02a659cad5e2280d$export$57a9131fd362a631(personData.hcpBeforeSep2024)
    });
    if (personData.hcpBeforeSep2024 === 'yes') {
        rows.push({
            label: `${personLabel} \u{2014} Residential fee arrangements`,
            value: "1 July 2014 (no worse off) \u2014 means-tested care fee unless opted in"
        });
        if (Number(personData.priorCareContributionsPaid) > 0) rows.push({
            label: `${personLabel} \u{2014} Care contributions already paid`,
            value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(personData.priorCareContributionsPaid))
        });
        rows.push({
            label: `${personLabel} \u{2014} Previous HCP contribution category`,
            value: personData.hcpCategory === 'A' ? 'No income-tested care fee was payable' : personData.hcpCategory === 'B' ? 'An income-tested care fee was payable' : $02a659cad5e2280d$export$57a9131fd362a631(personData.hcpCategory)
        });
        if (personData.hcpCategory === 'B' && personData.previousITCF != null) rows.push({
            label: `${personLabel} \u{2014} Previous income-tested care fee (daily)`,
            value: `$${personData.previousITCF}`
        });
    }
    const levelKey = personData.homeCareLevel;
    const levelLabel = levelKey && (0, $c220d08b55e5dd64$export$bfae9591cc0d7897)[levelKey] ? (0, $c220d08b55e5dd64$export$bfae9591cc0d7897)[levelKey].label : $02a659cad5e2280d$export$57a9131fd362a631(levelKey);
    const transitioned = !!(levelKey && (0, $c220d08b55e5dd64$export$bfae9591cc0d7897)[levelKey]?.transitional);
    rows.push({
        label: `${personLabel} \u{2014} ${transitioned ? 'Home care funding level (transitioned package)' : 'Approved Support at Home classification'}`,
        value: levelLabel || 'Not specified'
    });
    const rec = personData.recommendation || {};
    const approved = [];
    if (rec.residential) approved.push('Approved for residential aged care');
    if (rec.respite) approved.push('Approved for residential respite care');
    rows.push({
        label: `${personLabel} \u{2014} Care approvals selected`,
        value: approved.length ? approved.join('; ') : 'None selected'
    });
    return rows.filter((row)=>row.value !== undefined && row.value !== null && row.value !== '' && row.value !== 'Not provided');
}
function $02a659cad5e2280d$export$70de02dda17e369e(factFind = {}) {
    const sections = [];
    const addSection = (title, rows)=>{
        const filtered = rows.filter((row)=>row.value !== undefined && row.value !== null && row.value !== '');
        if (filtered.length > 0) sections.push({
            title: title,
            rows: filtered
        });
    };
    // willReduceExpensesAfterCare/reducedLivingExpensesAfterCare are legacy/planned fields not in
    // FactFindExpenses (shared/src/calculation/factFindTypes.ts) — same "no current writer" pattern
    // documented there for a few other fields; kept here defensively for any older saved profile.
    const expensesLegacy = factFind.expenses || {};
    addSection('Client and Partner Details', [
        {
            label: 'Advice For',
            value: factFind.adviceFor
        },
        {
            label: 'Client Name',
            value: `${factFind.client?.firstName || ''} ${factFind.client?.lastName || ''}`.trim()
        },
        {
            label: 'Client Date of Birth',
            value: factFind.client?.dob
        },
        {
            label: 'Client Health Status',
            value: factFind.client?.healthStatus
        },
        {
            label: 'Client Private Health Insurance',
            value: factFind.client?.phi
        },
        {
            label: 'Partner Name',
            value: `${factFind.partner?.firstName || ''} ${factFind.partner?.lastName || ''}`.trim()
        },
        {
            label: 'Partner Date of Birth',
            value: factFind.partner?.dob
        },
        {
            label: 'Partner Health Status',
            value: factFind.partner?.healthStatus
        },
        {
            label: 'Partner Private Health Insurance',
            value: factFind.partner?.phi
        }
    ]);
    addSection('Application Completion Details', [
        {
            label: 'Completed By',
            value: factFind.completer || 'client'
        },
        {
            label: 'Completer First Name',
            value: factFind.completerFirstName
        },
        {
            label: 'Completer Last Name',
            value: factFind.completerLastName
        },
        {
            label: 'Completer Relationship',
            value: factFind.completerRelationship
        }
    ]);
    // A goal reads by its name on the profile; the context questions beside it read by their key.
    addSection('Goals and Family Context', Object.entries(factFind.goals || {}).map(([key, value])=>({
            label: $02a659cad5e2280d$var$GOAL_LABELS[key] || $02a659cad5e2280d$var$prettify(key),
            value: value
        })));
    addSection('Home and Property Inputs', [
        {
            label: 'Home Value',
            value: factFind.home?.value
        },
        {
            label: 'Estimated Rent (Weekly)',
            value: factFind.home?.likelyRent
        },
        {
            label: 'Estimated Rental Expenses (Annual)',
            value: factFind.home?.likelyExpenses
        },
        {
            label: 'Home Growth Rate',
            value: factFind.home?.homeGrowthRate
        },
        {
            label: 'Current Residency',
            value: factFind.home?.currentResidency
        },
        {
            label: 'Land Size (>2 hectares)',
            value: factFind.home?.landSizeValue || factFind.home?.landSize
        },
        {
            label: 'Separate Titles',
            value: factFind.home?.separateTitlesValue || factFind.home?.separateTitles
        },
        {
            label: 'Primary Production Use',
            value: factFind.home?.primaryProductionUse
        },
        {
            label: 'Business Use',
            value: factFind.home?.businessUse
        },
        {
            label: 'Protected Person',
            value: factFind.home?.protectedPerson
        }
    ]);
    addSection('Expenses, Capital and Gifting Inputs', [
        {
            label: 'Annual Living Expenses',
            value: factFind.expenses?.livingExpenses
        },
        {
            label: 'Will Reduce Expenses After Care',
            value: expensesLegacy.willReduceExpensesAfterCare
        },
        {
            label: 'Reduced Living Expenses After Care',
            value: expensesLegacy.reducedLivingExpensesAfterCare
        },
        {
            label: 'Expense Mode',
            value: factFind.expenses?.expenseMode
        },
        {
            label: 'Capital Expenses Entered',
            value: (factFind.expenses?.capitalExpenses || []).length > 0 ? 'Yes' : 'No'
        },
        {
            label: 'Gifts History Entered',
            value: Object.keys(factFind.giftsHistory || {}).length > 0 ? 'Yes' : 'No'
        }
    ]);
    const clientName = `${factFind.client?.firstName || 'Client'}`.trim() || 'Primary applicant';
    const partnerName = `${factFind.partner?.firstName || 'Partner'}`.trim() || 'Partner';
    addSection('Care Need Inputs (aged care needs assessment)', [
        ...$02a659cad5e2280d$var$buildAcatFactRows(factFind.careNeeds?.clientAcat, clientName),
        ...$02a659cad5e2280d$var$buildAcatFactRows(factFind.careNeeds?.partnerAcat, partnerName)
    ]);
    return sections;
}
function $02a659cad5e2280d$var$extractRadFundingRows(radFunding = {}, factFind = {}) {
    return Object.entries(radFunding || {}).flatMap(([assetType, liquidations])=>{
        const items = Array.isArray(liquidations) ? liquidations : liquidations ? [
            liquidations
        ] : [];
        return items.map((liq)=>{
            const sourceAsset = (factFind?.assets?.[assetType] || []).find((asset)=>asset.id === liq.id);
            return {
                source: $02a659cad5e2280d$var$sanitizeText(sourceAsset?.description || liq.source || `${$02a659cad5e2280d$var$prettify(assetType)} Asset`),
                amount: $02a659cad5e2280d$var$toNumber(liq.amount)
            };
        });
    });
}
/**
 * Optional SOA cards aligned with the Suggestion Engine: partner-later lens and Lower RAD near-best (baseline).
 * Copy is fixed (D2C-safe) so the document stands alone without adviser “reason not taken” fields.
 */ function $02a659cad5e2280d$var$buildConditionalOptimalCardsForSoa({ allScenarios: allScenarios, coupleValidation: coupleValidation, agedCareCosts: agedCareCosts, legacyHorizonYears: legacyHorizonYears, selectedStrategy: selectedStrategy, factFind: factFind, formatCurrency: formatMoney }) {
    if (!Array.isArray(allScenarios) || allScenarios.length === 0) return [];
    const selNorm = $02a659cad5e2280d$var$stripFundingSuffix(selectedStrategy?.name || '');
    const cards = [];
    const cv = coupleValidation || {};
    const horizonYears = legacyHorizonYears || 5;
    if (cv.enablePartnerFutureEvent && parseFloat(String(cv.partnerFutureRoomPrice)) > 0) {
        const partnerEntryYear = parseInt(String(cv.partnerEntryYear), 10) || 3;
        const partnerFutureRoomPrice = parseFloat(String(cv.partnerFutureRoomPrice)) || 0;
        const originalEntrantAliveAtPartnerEntry = !!cv.originalEntrantAliveAtPartnerEntry;
        const scored = allScenarios.map((strategy)=>{
            const result = (0, $eb4adc50b37e37f7$export$9ac41d7814ff2d5c)({
                strategy: strategy,
                legacyYears: horizonYears,
                partnerEntryYear: partnerEntryYear,
                partnerRoomPrice: partnerFutureRoomPrice,
                originalEntrantAliveAtEvent: originalEntrantAliveAtPartnerEntry,
                baseAgedCareCosts: strategy.strategySpecificAgedCareCosts || agedCareCosts
            });
            if (!result) return null;
            return {
                strategy: strategy,
                result: result,
                adjustedLegacy: result.adjustedLegacy,
                radPaid: (0, $eb4adc50b37e37f7$export$ad99f664ac5b1922)(strategy)
            };
        }).filter((row)=>row !== null);
        if (scored.length > 0) {
            const maxAdjustedLegacy = scored.reduce((m, row)=>Math.max(m, row.adjustedLegacy), -Infinity);
            const bandUsd = (0, $af797c9747431756$export$340a7c95a5102e15);
            const threshold = maxAdjustedLegacy - bandUsd;
            const nearBest = scored.filter((row)=>row.adjustedLegacy >= threshold);
            const topAdjustedRow = scored.reduce((best, row)=>row.adjustedLegacy > best.adjustedLegacy ? row : best, scored[0]);
            const pickedRow = nearBest.reduce((best, row)=>{
                if (row.radPaid < best.radPaid) return row;
                if (row.radPaid === best.radPaid && row.adjustedLegacy > best.adjustedLegacy) return row;
                return best;
            }, nearBest[0]);
            const usedLowerRadTieBreak = pickedRow.strategy?.name !== topAdjustedRow.strategy?.name;
            const st = pickedRow.strategy;
            const clientFirstName = $02a659cad5e2280d$var$sanitizeText(factFind?.client?.firstName || '').trim() || 'the client';
            const partnerFirstName = $02a659cad5e2280d$var$sanitizeText(factFind?.partner?.firstName || '').trim() || 'your partner';
            const clientAlivePhrase = originalEntrantAliveAtPartnerEntry ? 'still living in residential aged care' : 'having passed away';
            cards.push({
                cardKind: 'partner_later',
                objectiveLabel: usedLowerRadTieBreak ? "Optimal Legacy (Partner Later) \u2014 lower RAD option" : 'Optimal Legacy (Partner Later Scenario)',
                name: $02a659cad5e2280d$var$sanitizeText($02a659cad5e2280d$var$stripFundingSuffix(st.name)),
                narrative: `This strategy considers ${partnerFirstName} entering residential aged care in year ${partnerEntryYear} at a room price of ${formatMoney(partnerFutureRoomPrice)}, with ${clientFirstName} modelled as ${clientAlivePhrase} at that time. ` + `The tool estimates extra aged care costs from that year onward and subtracts them from each strategy's baseline projected legacy to rank outcomes. ` + `Where several strategies finish within ${formatMoney(bandUsd)} of the best future-aware projected legacy, this card shows the one with the lowest estimated RAD paid. ` + `Year 1 cashflow and Age Pension below use baseline (Comparison Yr1) figures for that strategy\u{2014}they are not re-run under this future-event path. Illustrative only.`,
                legacy: pickedRow.adjustedLegacy,
                legacyMetricLabel: 'Legacy (future-event scenario)',
                cashflow: st.snapshot?.netCashflow ?? 0,
                pension: st.snapshot?.pension ?? 0,
                selected: selNorm === $02a659cad5e2280d$var$stripFundingSuffix(st.name),
                fundingRows: $02a659cad5e2280d$var$extractRadFundingRows(st.radFunding, factFind)
            });
        }
    }
    // The second plan, only for a real trade-off (planChoiceRule.ts, owner 20 Oct 2026) — the screen's rule.
    const scenarioField = allScenarios;
    const pickedLower = (0, $5a094123650e8adb$export$ab51b61210e311f4)(scenarioField, (0, $5a094123650e8adb$export$3ef36734776b870)(scenarioField, (0, $eb4adc50b37e37f7$export$6628235dfd682022)), (0, $eb4adc50b37e37f7$export$6628235dfd682022), (a, b)=>a.name === b.name);
    if (pickedLower?.strategy) {
        const st = pickedLower.strategy;
        const lowerSelected = selNorm === $02a659cad5e2280d$var$stripFundingSuffix(st.name);
        const lowerRadCore = `This option is shown beside the plan that leaves the most because it is a real trade-off. ${(0, $5a094123650e8adb$export$a104569a4d958475)(pickedLower, formatMoney)} ` + `It is shown so the choice is yours to weigh, not as a better result. `;
        const lowerRadClosing = lowerSelected ? `In your case, you selected this strategy for this Statement of Advice.` : `In your case, you have not selected this strategy.`;
        cards.push({
            cardKind: 'lower_rad',
            objectiveLabel: (0, $5a094123650e8adb$export$a1a7ae9e29edd48c),
            name: $02a659cad5e2280d$var$sanitizeText($02a659cad5e2280d$var$stripFundingSuffix(st.name)),
            narrative: `${lowerRadCore}${lowerRadClosing}`,
            legacy: Number(st.snapshot?.legacyValue) || 0,
            legacyMetricLabel: 'Legacy (modelled)',
            cashflow: Number(st.snapshot?.netCashflow) || 0,
            pension: Number(st.snapshot?.pension) || 0,
            selected: lowerSelected,
            fundingRows: $02a659cad5e2280d$var$extractRadFundingRows(st.radFunding, factFind)
        });
    }
    return cards;
}
async function $02a659cad5e2280d$export$8b925970c458dc89({ selectedStrategy: selectedStrategy, factFind: factFind, agedCareCosts: agedCareCosts, analysis: analysis, coupleValidation: coupleValidation = {}, reportAudience: reportAudience = 'direct_client', strategySource: strategySource = 'suggestion_engine', customisedFrom: customisedFrom = null, manualAlternativeStrategies: manualAlternativeStrategies = [], projectionPeriodMode: projectionPeriodMode, adviceAttributionLine: adviceAttributionLine, adviceAttributionIncomplete: adviceAttributionIncomplete }) {
    if (!selectedStrategy) return null;
    const baseline = await $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind || {});
    const allScenarios = analysis?.allSimulatedStrategies || analysis?.strategies || [];
    const projections = selectedStrategy.projections || [];
    // Falls back to the strategy's own run options, so a caller that says nothing still gets a document
    // describing the calendar its rows were genuinely cut on rather than an assumed one.
    // Entry and the funding sale are separate dated events, and the gap between them is modelled —
    // proceeds sit in the bank earning deemed income until the deposit is paid. The document has to
    // report the dates that were actually chosen, not assume the two coincide.
    const strategyRunOptions = selectedStrategy.strategyOptions || {};
    const careStartDate = typeof strategyRunOptions.careStartDate === 'string' ? strategyRunOptions.careStartDate : '';
    const radFundingDate = typeof strategyRunOptions.radFundingDate === 'string' ? strategyRunOptions.radFundingDate : '';
    // Whether the provider lets fees be drawn from the deposit, as answered on the costs form. Absent
    // on strategies from before the question existed, which ran on the usual arrangement ('fees').
    const radDrawdown = strategyRunOptions.radDrawdown === 'dap' || strategyRunOptions.radDrawdown === 'none' ? strategyRunOptions.radDrawdown : 'fees';
    // The fee arrangements the run was priced on. The profile decides (no-worse-off principle); the
    // run's options can only record an opt-in. Resolved by the engine's own function so the document
    // cannot say one thing and the fees another.
    const coveredByNoWorseOff = (0, $5a5496da6ce58554$export$4a48561f28024b31)(factFind);
    const residentialFeeArrangements = coveredByNoWorseOff && strategyRunOptions.residentialFeeArrangements !== '2025' ? '2014' : '2025';
    const rowPeriodMode = projectionPeriodMode ?? selectedStrategy.strategyOptions?.projectionPeriodMode ?? 'financial_year';
    // Falls back to whichever firm is signed in when the caller did not say. See
    // adviceAttribution.ts for why that lives in a module value rather than a prop.
    const currentAttribution = (0, $92fb3c34dca71663$export$174185a301570ae7)();
    const attributionLine = adviceAttributionLine ?? currentAttribution?.line;
    const attributionIncomplete = adviceAttributionIncomplete ?? currentAttribution?.complete === false;
    const reportId = `CC-DSOA-${Date.now()}`;
    const generatedAt = new Date().toISOString();
    // Actual RAD paid = funding NET of CGT on any assets sold to fund it (Option A). The SE strategy carries
    // this as radPaidNet (same figure its projection/DAP use); fall back to the gross funding sum for other
    // sources. Using the gross here previously OVERSTATED the RAD and UNDERSTATED the DAP on the unpaid balance.
    const grossRadFunding = Object.values(selectedStrategy.radFunding || {}).flatMap((items)=>Array.isArray(items) ? items : items ? [
            items
        ] : []).reduce((sum, row)=>sum + $02a659cad5e2280d$var$toNumber(row.amount), 0);
    const totalRadPaid = Number.isFinite(selectedStrategy.radPaidNet) ? selectedStrategy.radPaidNet : grossRadFunding;
    const roomCost = $02a659cad5e2280d$var$toNumber(agedCareCosts?.radAmount);
    const remainingForDap = Math.max(0, roomCost - totalRadPaid);
    const mpir = (0, $815d7df20c36742b$export$36c4ec5f3f340aef).MPIR;
    const safeFactFind = factFind || {};
    const modellerResidencyOverrides = (0, $8eecd0af141b9afb$export$5f0bb1b091776594)($02a659cad5e2280d$var$asFactFind(safeFactFind));
    const pensionScenarioOptions = {
        ...selectedStrategy?.strategyOptions || {},
        ...selectedStrategy?.scenarioConfig || {},
        ...modellerResidencyOverrides
    };
    const baselineUsesIllnessSeparated = (0, $8eecd0af141b9afb$export$9b95c99516118f10)($02a659cad5e2280d$var$asFactFind(safeFactFind), {});
    const modelUsesIllnessSeparated = (0, $8eecd0af141b9afb$export$9b95c99516118f10)($02a659cad5e2280d$var$asFactFind(safeFactFind), pensionScenarioOptions);
    const illnessSeparatedAppliesInSoa = safeFactFind.adviceFor === 'couple' && modelUsesIllnessSeparated;
    const illnessSeparatedDiffersFromBaseline = safeFactFind.adviceFor === 'couple' && baselineUsesIllnessSeparated !== modelUsesIllnessSeparated;
    const baselineAnnualPension = baseline.socialSecurity || baseline.agePension || 0;
    const selectedAnnualPension = selectedStrategy.snapshot?.pension || 0;
    const pensionDeltaFromBaseline = selectedAnnualPension - baselineAnnualPension;
    const localClientFirstName = $02a659cad5e2280d$var$sanitizeText(safeFactFind.client?.firstName || 'the client');
    const localPartnerFirstName = $02a659cad5e2280d$var$sanitizeText(safeFactFind.partner?.firstName || '');
    const localIsCoupleAdvice = safeFactFind.adviceFor === 'couple' && localPartnerFirstName;
    const agedCareFor = safeFactFind?.goals?.aged_care_for;
    const enteringCarePersonName = (()=>{
        if (agedCareFor === 'partner') return localPartnerFirstName || 'your partner';
        if (agedCareFor === 'both') return localIsCoupleAdvice && localPartnerFirstName ? `${localClientFirstName} and ${localPartnerFirstName}` : localClientFirstName;
        return localClientFirstName;
    })();
    const baselinePensionMax = (()=>{
        if (safeFactFind?.adviceFor !== 'couple') return (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single;
        return baselineUsesIllnessSeparated ? (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single * 2 : (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).couple;
    })();
    const selectedPensionMax = (()=>{
        if (safeFactFind?.adviceFor !== 'couple') return (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single;
        return modelUsesIllnessSeparated ? (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single * 2 : (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).couple;
    })();
    const baselinePensionStatus = $02a659cad5e2280d$var$classifyPensionLevel(baselineAnnualPension, baselinePensionMax);
    const selectedPensionStatus = $02a659cad5e2280d$var$classifyPensionLevel(selectedAnnualPension, selectedPensionMax);
    const recommendedNarrative = $02a659cad5e2280d$var$sanitizeText(selectedStrategy.context || selectedStrategy.description || 'Recommended strategy based on current modelling.');
    const topThree = allScenarios.slice().sort((a, b)=>(b.snapshot?.legacyValue || 0) - (a.snapshot?.legacyValue || 0)).slice(0, 3).map((strategy)=>({
            name: $02a659cad5e2280d$var$sanitizeText(strategy.name),
            legacy: strategy.snapshot?.legacyValue || strategy.outputs?.legacyEstimate || 0,
            cashflow: strategy.snapshot?.netCashflow || strategy.cashFlow || strategy.cashflow || 0,
            pension: strategy.snapshot?.pension || strategy.agePension || strategy.estimatedAgePension || 0,
            selected: strategy.name === selectedStrategy.name
        }));
    const optimalStrategyCards = (analysis?.recommendedOptimalStrategies || []).filter((row)=>row?.strategy).slice(0, 3).map((row)=>{
        const st = row.strategy;
        return {
            objectiveLabel: $02a659cad5e2280d$var$sanitizeText(row.label),
            name: $02a659cad5e2280d$var$sanitizeText($02a659cad5e2280d$var$stripFundingSuffix(st.name)),
            narrative: $02a659cad5e2280d$var$sanitizeText(st.context || st.description || ''),
            legacy: st.snapshot?.legacyValue || st.outputs?.legacyEstimate || 0,
            cashflow: st.snapshot?.netCashflow || st.cashFlow || st.cashflow || 0,
            pension: st.snapshot?.pension || st.agePension || st.estimatedAgePension || 0,
            selected: st.name === selectedStrategy.name,
            fundingRows: $02a659cad5e2280d$var$extractRadFundingRows(st.radFunding, factFind),
            horizonWarning: (0, $3d096644ffaac9d7$export$bcf3d26e8114b217)(st, factFind)
        };
    });
    const manualCards = (manualAlternativeStrategies || []).slice(0, 6).map((st, idx)=>({
            objectiveLabel: `Modelled strategy ${idx + 1}`,
            name: $02a659cad5e2280d$var$sanitizeText($02a659cad5e2280d$var$stripFundingSuffix(st.name || `Strategy ${idx + 1}`)),
            narrative: $02a659cad5e2280d$var$sanitizeText(st.context || st.description || 'Saved during adviser manual-control modelling.'),
            legacy: st.snapshot?.legacyValue || st.outputs?.legacyEstimate || 0,
            cashflow: st.snapshot?.netCashflow || st.outputs?.cashFlow || st.cashFlow || st.cashflow || 0,
            pension: st.snapshot?.pension || st.outputs?.agePension || st.agePension || st.estimatedAgePension || 0,
            selected: $02a659cad5e2280d$var$stripFundingSuffix(st.name || '') === $02a659cad5e2280d$var$stripFundingSuffix(selectedStrategy?.name || ''),
            fundingRows: $02a659cad5e2280d$var$extractRadFundingRows(st.radFunding || st.inputs?.radFunding, factFind)
        }));
    const displayOptimalCards = strategySource === 'manual_control' ? manualCards.length > 0 ? manualCards : [
        {
            objectiveLabel: 'Selected manual strategy',
            name: $02a659cad5e2280d$var$sanitizeText($02a659cad5e2280d$var$stripFundingSuffix(selectedStrategy?.name || 'Manual strategy')),
            narrative: 'Selected by adviser from manual control modelling.',
            legacy: selectedStrategy.snapshot?.legacyValue || 0,
            cashflow: selectedStrategy.snapshot?.netCashflow || 0,
            pension: selectedStrategy.snapshot?.pension || 0,
            selected: true,
            fundingRows: $02a659cad5e2280d$var$extractRadFundingRows(selectedStrategy.radFunding, factFind)
        }
    ] : optimalStrategyCards.length > 0 ? optimalStrategyCards : topThree.map((row, idx)=>({
            objectiveLabel: [
                'Strongest projected estate',
                'Cashflow-led outcome',
                'Age Pension-led outcome'
            ][idx] || 'Modelling highlight',
            name: $02a659cad5e2280d$var$sanitizeText($02a659cad5e2280d$var$stripFundingSuffix(row.name)),
            narrative: row.selected ? recommendedNarrative : 'Alternative mix of RAD/DAP, home and asset funding assumptions.',
            legacy: row.legacy,
            cashflow: row.cashflow,
            pension: row.pension,
            selected: row.selected,
            fundingRows: []
        }));
    const legacyHorizonYears = parseInt(String(safeFactFind.goals?.legacyYears), 10) || 5;
    // The situation page's fourth tile: the household staying where it is, no care, over the same
    // horizon (owner, 9 Oct 2026). Null where someone is already in care or the run fails.
    const stayPutLegacy = await (0, $02192dd5d748995e$export$57587e83662dca06)(factFind, legacyHorizonYears, {
        ...projectionPeriodMode ? {
            projectionPeriodMode: projectionPeriodMode
        } : {}
    });
    // The Age Pension page's home treatment, from the arrangement the person entering care is in.
    const careEntrantKey = agedCareFor === 'partner' ? 'partner' : 'client';
    const careEntrantArrangement = (careEntrantKey === 'partner' ? safeFactFind.partner?.currentResidency : safeFactFind.client?.currentResidency) || 'own_home';
    const stayingPartnerArrangement = (careEntrantKey === 'partner' ? safeFactFind.client?.currentResidency : safeFactFind.partner?.currentResidency) || 'own_home';
    const partnerStaysHome = !!localIsCoupleAdvice && agedCareFor !== 'both' && stayingPartnerArrangement !== 'aged_care';
    const homeRuleParagraph = (0, $2411d79164c394f6$export$499ee20196e78962)({
        arrangement: careEntrantArrangement,
        name: $02a659cad5e2280d$var$sanitizeText(careEntrantKey === 'partner' ? localPartnerFirstName || 'your partner' : localClientFirstName),
        partnerName: $02a659cad5e2280d$var$sanitizeText((careEntrantKey === 'partner' ? localClientFirstName : localPartnerFirstName) || ''),
        partnerStays: partnerStaysHome,
        partnerArrangement: stayingPartnerArrangement
    });
    const conditionalOptimalCards = strategySource === 'suggestion_engine' ? $02a659cad5e2280d$var$buildConditionalOptimalCardsForSoa({
        allScenarios: allScenarios,
        coupleValidation: coupleValidation,
        agedCareCosts: agedCareCosts,
        legacyHorizonYears: legacyHorizonYears,
        selectedStrategy: selectedStrategy,
        factFind: safeFactFind,
        formatCurrency: $f94e45ac645ae232$export$3dc27271f5d5c629
    }) : [];
    const selectedGoalKeys = Object.entries(safeFactFind.goals || {}).filter(([key, val])=>val && !key.endsWith('_for') && $02a659cad5e2280d$var$GOAL_LABELS[key]).map(([key])=>key);
    const statedGoals = selectedGoalKeys.map((key)=>$02a659cad5e2280d$var$GOAL_LABELS[key]);
    const inScopeGoalKeys = selectedGoalKeys.filter((key)=>!$02a659cad5e2280d$var$LIVING_ARRANGEMENT_GOAL_KEYS.has(key) || key === 'aged_care');
    const outOfScopeGoalKeys = selectedGoalKeys.filter((key)=>$02a659cad5e2280d$var$LIVING_ARRANGEMENT_GOAL_KEYS.has(key) && key !== 'aged_care');
    if (!inScopeGoalKeys.includes('aged_care')) inScopeGoalKeys.unshift('aged_care');
    const inScopeGoals = inScopeGoalKeys.map((key)=>$02a659cad5e2280d$var$GOAL_LABELS[key]).filter(Boolean);
    const outOfScopeGoals = outOfScopeGoalKeys.map((key)=>$02a659cad5e2280d$var$GOAL_LABELS[key]).filter(Boolean);
    const scenarioHints = [];
    const g = safeFactFind.goals || {};
    if (g.downsize_home) scenarioHints.push('downsizing the home');
    if (g.granny_flat) scenarioHints.push('granny flat arrangements');
    if (g.retirement_village) scenarioHints.push('retirement village pathways');
    if (g.home_care) scenarioHints.push('home care package transitions');
    if ((coupleValidation?.downsizeNewHomeValue || 0) > 0) scenarioHints.push('partner downsizing alternatives');
    if (coupleValidation?.partnerAnnualRent) scenarioHints.push('partner rental assumptions');
    const totalScenariosCount = analysis?.totalScenarios || allScenarios.length || 0;
    const scenarioExplainer = strategySource === 'manual_control' ? `This advice references <strong>${manualCards.length || totalScenariosCount || 1}</strong> plans built by hand and saved for comparison.` : `We compared <strong>${totalScenariosCount}</strong> strategy combinations, including different ways to use the family home (keep, rent, sell or downsize where relevant), RAD and DAP mixes, and how assets could fund care\u{2014}aligned with your fact-find and the options you told us matter${scenarioHints.length ? ` (for example: ${scenarioHints.join(', ')})` : ''}.`;
    const doNothingStrategy = allScenarios.find((s)=>String(s.name || '').trim().toLowerCase() === 'do nothing');
    let pathComparison = null;
    if (doNothingStrategy?.snapshot && selectedStrategy?.snapshot) {
        const sel = selectedStrategy.snapshot;
        const dn = doNothingStrategy.snapshot;
        pathComparison = {
            legacyDelta: (sel.legacyValue || 0) - (dn.legacyValue || 0),
            pensionDelta: (sel.pension || 0) - (dn.pension || 0),
            cashflowDelta: (sel.netCashflow || 0) - (dn.netCashflow || 0),
            /** Positive => selected strategy has higher modelled aged care fees than "do nothing" */ careFeeDeltaVsDoNothing: (sel.totalAgedCareCosts || 0) - (dn.totalAgedCareCosts || 0),
            // Both sides, so the document can show doing nothing beside this plan (owner, 24 Oct 2026).
            plan: {
                legacy: sel.legacyValue || 0,
                pension: sel.pension || 0,
                cashflow: sel.netCashflow || 0,
                careFees: sel.totalAgedCareCosts || 0
            },
            doNothing: {
                legacy: dn.legacyValue || 0,
                pension: dn.pension || 0,
                cashflow: dn.netCashflow || 0,
                careFees: dn.totalAgedCareCosts || 0
            }
        };
    }
    const annualCashflow = selectedStrategy.snapshot?.netCashflow || selectedStrategy.cashFlow || selectedStrategy.cashflow || 0;
    const cashflowIsNegative = annualCashflow < 0;
    const cashflowAnalysis = $02a659cad5e2280d$export$8e29f3a7af07ac8(projections, (0, $f94e45ac645ae232$export$3dc27271f5d5c629), annualCashflow < 0 ? -annualCashflow : null);
    let deficitFundingNarrative = '';
    if (cashflowIsNegative) {
        const baseExplain = $02a659cad5e2280d$var$getDeficitFundingExplanationForSOA(annualCashflow, projections, (0, $f94e45ac645ae232$export$3dc27271f5d5c629));
        const layered = cashflowAnalysis?.detailedNarrative;
        const parts = [];
        if (baseExplain) parts.push(baseExplain);
        if (layered && layered !== baseExplain) parts.push(layered);
        deficitFundingNarrative = parts.join(' ');
    }
    /*
     * HOW LONG THE MONEY LASTS — the same helper, over the same rows and horizon, that the plan
     * summary panel uses on screen, so the document cannot answer the question differently from
     * the screen it was generated from (the "one runway, quoted twice" rule in AgedCareAnalyser).
     */ const fundingRunway = cashflowIsNegative && projections.length ? (0, $0fe89e03b6df746e$export$464558962ff4a811)(projections, projections.length) : null;
    const projectionSurplusDeficitNote = $02a659cad5e2280d$var$buildProjectionFootnote(cashflowAnalysis, annualCashflow, (0, $f94e45ac645ae232$export$3dc27271f5d5c629));
    const enrichedProjections = projections.map((p, i)=>({
            year: p.year ?? i + 1,
            fyLabel: p.fyLabel,
            isPartialFy: p.isPartialFy,
            fyFullYearView: p.fyFullYearView,
            cashFlow: p.cashFlow ?? p.cashflow ?? 0,
            netWorth: p.netWorth ?? 0,
            assets: p.assets || {},
            netWorthBreakdown: p.netWorthBreakdown || [],
            pension: p.socialSecurity ?? p.pension ?? 0,
            careAnnual: p.annualCareCost ?? 0,
            cashBreakdown: p.cashFlowBreakdown || [],
            careBreakdown: p.agedCareBreakdown || [],
            pensionBreakdown: p.socialSecurityBreakdown || [],
            drawdownBreakdown: p.drawdownBreakdown || [],
            cashflowRoutingLine: p.cashflowRoutingLine ?? undefined
        }));
    const strategyOpeningNetWorth = selectedStrategy.snapshot != null && selectedStrategy.snapshot.netWorth != null && selectedStrategy.snapshot.netWorth !== '' ? $02a659cad5e2280d$var$toNumber(selectedStrategy.snapshot.netWorth) : $02a659cad5e2280d$var$toNumber(baseline.netWorth);
    const openingNetWorthTipRows = $02a659cad5e2280d$var$buildOpeningNetWorthBreakdownLines(projections[0], strategyOpeningNetWorth, safeFactFind);
    // Use the same scenario structures as the app deep-dive:
    // - do-nothing from `analysis.strategies`
    // - selected strategy from the selected strategy payload
    const doNothing = analysis?.strategies?.find((s)=>String(s?.name || '').trim().toLowerCase() === 'do nothing') || allScenarios.find((s)=>String(s?.name || '').trim().toLowerCase() === 'do nothing');
    const selectedScenarioForOpportunity = selectedStrategy;
    const selectedSnap = selectedStrategy?.snapshot || {};
    const doNothingSnap = doNothing?.snapshot || {};
    const investmentEarningsLost = doNothing ? $02a659cad5e2280d$var$estimateInvestmentEarningsLikeApp(selectedScenarioForOpportunity, doNothing) : 0;
    let careCostsSaved = $02a659cad5e2280d$var$toNumber(doNothingSnap.totalAgedCareCosts) - $02a659cad5e2280d$var$toNumber(selectedSnap.totalAgedCareCosts);
    // If the snapshot care costs look identical, the app falls back to estimating DAP savings from RAD.
    if (careCostsSaved === 0 && $02a659cad5e2280d$var$toNumber(selectedScenarioForOpportunity?.radAmount) > 0) careCostsSaved = $02a659cad5e2280d$var$toNumber(selectedScenarioForOpportunity?.radAmount) * mpir;
    const opportunityCost = doNothing ? {
        investmentEarningsLost: investmentEarningsLost,
        agePensionImpact: $02a659cad5e2280d$var$toNumber(selectedSnap.pension) - $02a659cad5e2280d$var$toNumber(doNothingSnap.pension),
        careCostsSaved: careCostsSaved,
        estateImpact: $02a659cad5e2280d$var$toNumber(selectedSnap.legacyValue) - $02a659cad5e2280d$var$toNumber(doNothingSnap.legacyValue)
    } : null;
    const clientFirstName = $02a659cad5e2280d$var$sanitizeText(safeFactFind.client?.firstName || 'the client');
    const partnerFirstName = $02a659cad5e2280d$var$sanitizeText(safeFactFind.partner?.firstName || '');
    const isCoupleAdvice = safeFactFind.adviceFor === 'couple' && partnerFirstName;
    const completerIsApplicant = !safeFactFind.completer || safeFactFind.completer === 'client';
    const completerRelationship = $02a659cad5e2280d$var$sanitizeText(safeFactFind.completerRelationship || '');
    const completerRelationshipLower = completerRelationship ? `${completerRelationship.charAt(0).toLowerCase()}${completerRelationship.slice(1)}` : '';
    const familyEstate = safeFactFind.family || {};
    const clientFullName = $02a659cad5e2280d$var$sanitizeText(`${safeFactFind.client?.firstName || ''} ${safeFactFind.client?.lastName || ''}`.trim() || 'the client');
    const partnerLastName = $02a659cad5e2280d$var$sanitizeText(safeFactFind.partner?.lastName || '');
    const partnerFullName = partnerFirstName && partnerLastName ? `${partnerFirstName} ${partnerLastName}`.trim() : partnerFirstName || '';
    const clientAgeNum = (0, $5589d9476399db47$export$8ada184d5eef4694)(safeFactFind.client?.dob);
    const clientAgeStr = clientAgeNum != null && !Number.isNaN(Number(clientAgeNum)) ? String(clientAgeNum) : null;
    const partnerAgeNum = partnerFullName ? (0, $5589d9476399db47$export$8ada184d5eef4694)(safeFactFind.partner?.dob) : null;
    const partnerAgeStr = partnerAgeNum != null && !Number.isNaN(Number(partnerAgeNum)) ? String(partnerAgeNum) : null;
    const executiveSummaryOpeningParts = [];
    if (isCoupleAdvice && partnerFullName) executiveSummaryOpeningParts.push(`<p class="lede">This Statement of Advice has been prepared for <strong>${clientFullName}</strong>${clientAgeStr ? ` (aged ${clientAgeStr})` : ''} and <strong>${$02a659cad5e2280d$var$sanitizeText(partnerFullName)}</strong>${partnerAgeStr ? ` (aged ${partnerAgeStr})` : ''}.</p>`);
    else executiveSummaryOpeningParts.push(`<p class="lede">This Statement of Advice has been prepared for <strong>${clientFullName}</strong>${clientAgeStr ? ` (aged ${clientAgeStr})` : ''}.</p>`);
    if (!completerIsApplicant) {
        const completerFullName = $02a659cad5e2280d$var$sanitizeText(`${safeFactFind.completerFirstName || ''} ${safeFactFind.completerLastName || ''}`.trim());
        const behalf = isCoupleAdvice ? 'the clients named above' : 'the client named above';
        if (completerFullName) {
            const relFragment = completerRelationship ? ` (${clientFirstName}'s ${completerRelationshipLower})` : '';
            executiveSummaryOpeningParts.push(`<p class="lede">It was completed using information provided by <strong>${completerFullName}</strong>${relFragment}, on behalf of ${behalf}.</p>`);
        } else executiveSummaryOpeningParts.push(`<p class="lede">It was completed on behalf of ${isCoupleAdvice ? 'the clients' : 'the client'} named above.</p>`);
    }
    const executiveSummaryOpeningHtml = executiveSummaryOpeningParts.join('');
    const clientAgeForSituation = (0, $5589d9476399db47$export$8ada184d5eef4694)(safeFactFind.client?.dob);
    const ageFragment = clientAgeForSituation != null && !Number.isNaN(Number(clientAgeForSituation)) ? ` at age <strong>${clientAgeForSituation}</strong>` : '';
    /*
     * WHAT WAS DONE WITH THE HEALTH ANSWER (owner, 23 Sep 2026). This document used to print the
     * answer as a bare fact and stop. It now says what the answer was used for — or that nothing was,
     * where it was left blank — so the reader is never left to wonder whether a relevant circumstance
     * was considered.
     */ const horizons = (0, $3d096644ffaac9d7$export$5d20a1bac737ae13)(safeFactFind);
    const clientHealthRaw = String(safeFactFind.client?.healthStatus ?? '').trim();
    const horizonConsequence = !clientHealthRaw ? ` No health status was recorded, so no judgement about time horizon was made on it; age alone was considered.` : horizons.client.healthConsidered ? ` Age and this health answer were taken into account: strategies that need several years or more to pay for themselves were flagged rather than recommended.` : ` Age and this health answer were taken into account when judging which strategies had the time they need.`;
    const careRecipientProfile = `<strong>${clientFirstName}</strong> is entering, or preparing to enter, residential aged care${ageFragment}, and reports <strong>${$02a659cad5e2280d$var$healthStatusLabel(safeFactFind.client?.healthStatus)}</strong>.${horizonConsequence}`;
    // A strategy that would have won a ranking but was set aside is said here, in the document,
    // exactly as it is said on screen (owner, 23 Sep 2026: call it out, never promote it).
    const setAsides = analysis?.horizonSetAside ?? [];
    const horizonSetAsideHtml = setAsides.length ? `<div class="callout callout--amber"><p class="callout-title">Set aside because of age and health</p>${setAsides.map((sa)=>`<p><strong>${$02a659cad5e2280d$var$sanitizeText($02a659cad5e2280d$var$stripFundingSuffix(sa.strategy?.name || ''))}</strong> would give ${sa.metric === 'legacy' ? 'a larger estate' : sa.metric === 'cashflow' ? 'a higher cashflow' : 'a higher Age Pension'} than the ${$02a659cad5e2280d$var$sanitizeText(sa.label)} strategy above, but it was not recommended: ${$02a659cad5e2280d$var$sanitizeText(sa.warning)}</p>`).join('')}</div>` : '';
    const partnerContextParagraphs = [];
    if (isCoupleAdvice && partnerFirstName) {
        const partnerHealth = $02a659cad5e2280d$var$healthStatusLabel(safeFactFind.partner?.healthStatus);
        partnerContextParagraphs.push(`<p class="lede"><strong>${partnerFirstName}</strong>'s health was recorded as <strong>${partnerHealth}</strong>. Where the family home is retained, the model uses the living arrangement and cost settings you entered (including whether the partner remains in the home). The home is treated as exempt for the assets test while the partner remains a continuing occupant.</p>`);
        const partnerExtraBits = [];
        if ((coupleValidation?.downsizeNewHomeValue || 0) > 0 || g.downsize_home) partnerExtraBits.push('The comparison also included scenarios where the partner downsizes or changes living arrangements while aged care funding is implemented.');
        const homeRentalModelled = Boolean(selectedStrategy?.scenarioConfig?.rentHome || selectedStrategy?.snapshot?.homeStatus === 'Rent Home');
        if (homeRentalModelled) partnerExtraBits.push('Renting the family home was included in the comparison set, so housing-cost assumptions were adjusted for that pathway.');
        if (partnerExtraBits.length) partnerContextParagraphs.push(`<p class="lede">${partnerExtraBits.join(' ')}</p>`);
    }
    const partnerContextHtml = partnerContextParagraphs.join('');
    // The box itself sits with the alternatives (owner, 9 Oct 2026: the executive summary is not the
    // place to argue an annuity); the summary keeps one line saying something was set aside and where.
    const horizonSetAsideNote = setAsides.length ? (0, $2411d79164c394f6$export$de39401204a3b4c)(setAsides.length) : '';
    const wideExplorationClause = totalScenariosCount > 80 ? `<p class="lede">Even where you had a preferred direction (for example keeping the home), AgedCareWise still tested a broad range of combinations - including RAD/DAP mixes and, where enabled, renting or downsizing - so you could see the trade-offs in pension, cashflow and estate outcomes before deciding.</p>` : '';
    const radFundingRows = Object.entries(selectedStrategy.radFunding || {}).flatMap(([assetType, liquidations])=>{
        const items = Array.isArray(liquidations) ? liquidations : liquidations ? [
            liquidations
        ] : [];
        return items.map((liq)=>{
            const sourceAsset = (factFind?.assets?.[assetType] || []).find((asset)=>asset.id === liq.id);
            return {
                assetTypeKey: assetType,
                assetId: liq.id,
                assetType: $02a659cad5e2280d$var$prettify(assetType),
                source: $02a659cad5e2280d$var$sanitizeText(sourceAsset?.description || liq.source || `${$02a659cad5e2280d$var$prettify(assetType)} Asset`),
                amount: $02a659cad5e2280d$var$toNumber(liq.amount)
            };
        });
    });
    /*
     * Money the plan puts to the deposit that was never sold at entry (owner-caught, 9 Oct 2026: the
     * funding list "does not include proceeds from the retirement village"): a village's exit payment
     * and the refund of a current room's deposit. Listed FIRST wherever the funding is listed — these
     * come before anything is sold — and kept apart from `radFundingRows`, which the CGT working reads.
     */ const radFundingPrelude = (()=>{
        const out = [];
        const veRow = selectedStrategy.villageExit;
        const veManual = selectedStrategy.inputs?.villageExit;
        const ve = veRow && veRow.refundDate ? veRow : veManual && veManual.refundDate ? veManual : null;
        const fromVillage = Number(ve?.fromVillage) || 0;
        if (ve && fromVillage > 0) out.push({
            assetType: 'Retirement village',
            source: ve.paidAtMove ? 'Exit payment for the village unit, paid at the move' : `Exit payment for the village unit, when it is paid (${(0, $511dfa7ed5ad5c31$export$6a00304d19569a72)({
                refundDate: String(ve.refundDate)
            })})`,
            amount: fromVillage
        });
        const fmRow = selectedStrategy.facilityMove;
        const fmManual = selectedStrategy.inputs?.facilityMove;
        const fromRefund = fmRow && !fmRow.stayPut ? Number(fmRow.fromRefund) || 0 : fmManual && (Number(fmManual.newRoomPrice) || 0) > 0 ? Math.min(Number(fmManual.refundToday) || 0, Math.min(Number(fmManual.newRoomPrice) || 0, Number(fmManual.radTarget) || 0)) : 0;
        if (fromRefund > 0) out.push({
            assetType: 'Current room',
            source: 'Refund of the deposit on the current room',
            amount: fromRefund
        });
        return out;
    })();
    // The CGT this strategy's RAD funding actually triggers, recomputed from the funding map itself.
    // It used to be read from `factFind.cgtOnRadFunding`, a sidecar that NOTHING in the codebase ever
    // writes — so it was always 0 and every piece of CGT commentary below (the per-asset cgtLine and
    // the "Tax validation required" card) silently never rendered, in a document whose whole purpose is
    // disclosure. `computeRadFundingTotals` is the same helper the RAD funding UI uses, so the figure
    // here matches what the adviser saw on screen.
    const radFundingCgtTotal = (0, $85f2560fc9a239a0$export$e98193fa2b9f521b)(factFind, Object.fromEntries(radFundingRows.map((row)=>[
            `${row.assetTypeKey}-${row.assetId}`,
            row.amount
        ])), selectedStrategy?.strategyOptions?.cgtOverrides || {}).shareCgtTotal;
    // CGT inputs we had to ASSUME for an asset this strategy sells (missing cost base / acquisition
    // month). Gated on the realised assets themselves rather than on the CGT total: an assumption still
    // has to be disclosed even where it happens to produce nil tax.
    const realisedCgtRefs = radFundingRows.map((row)=>({
            assetType: row.assetTypeKey,
            assetId: row.assetId
        }));
    const sellIpDetails = selectedStrategy?.strategyOptions?.investmentPropertyDetails;
    if (selectedStrategy?.strategyOptions?.sellInvestmentProperty && sellIpDetails?.selectedPropertyId != null) realisedCgtRefs.push({
        assetType: 'investmentProperty',
        assetId: sellIpDetails.selectedPropertyId
    });
    const cgtAssumptionDisclosure = (0, $2fa27b08acd205b2$export$d3be57634d2c161d)((0, $2fa27b08acd205b2$export$8dad3974ca6e3fc9)(factFind?.assets, realisedCgtRefs));
    const adviceImplications = $02a659cad5e2280d$export$5321cadb6c472b3e({
        radFundingRows: radFundingRows,
        radFundingCgtTotal: radFundingCgtTotal,
        cgtAssumptionDisclosure: cgtAssumptionDisclosure,
        // The engine reports the terms it built the annuity on; the SOA states them.
        annuityTerms: selectedStrategy?.annuityTerms || null,
        clientFirstName: safeFactFind.client?.firstName,
        partnerFirstName: safeFactFind.adviceFor === 'couple' ? safeFactFind.partner?.firstName : undefined
    }).map((item)=>{
        if (item.title.toLowerCase().includes('account based pensions') && ((0, $5589d9476399db47$export$8ada184d5eef4694)(safeFactFind.client?.dob) || 0) >= 60) return {
            ...item,
            body: `${item.body} Because the member is over age 60 in this case, pension withdrawals are generally tax free (subject to product and legislative rules).`
        };
        if (item.title.toLowerCase().includes('bank accounts')) {
            const bankTotal = (safeFactFind?.assets?.bankAccounts || []).reduce((sum, a)=>sum + $02a659cad5e2280d$var$toNumber(a?.value), 0);
            const bankSold = radFundingRows.filter((r)=>r.assetTypeKey === 'bankAccounts').reduce((sum, r)=>sum + $02a659cad5e2280d$var$toNumber(r.amount), 0);
            const retained = Math.max(0, bankTotal - bankSold);
            return {
                ...item,
                body: `${item.body} We have retained approximately <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(retained)}</strong> in bank cash as an emergency buffer; this may reduce over time where ongoing deficits are projected.`
            };
        }
        return item;
    });
    /*
     * Claiming, or reporting, the pension change the plan rests on (owner, 3 Oct 2026). For aged
     * care the order matters too: claim the pension first, then the means assessment is the SA485.
     */ const pensionNote = (0, $b82b108d4741f18d$export$fdc5fe41a9ca9852)(selectedAnnualPension, baselineAnnualPension, {
        meansAssessment: 'residential'
    });
    const plainHtml = (t)=>t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    if (pensionNote) adviceImplications.unshift({
        title: plainHtml(pensionNote.implication.title),
        lead: plainHtml(pensionNote.implication.lead),
        body: plainHtml(pensionNote.implication.body)
    });
    const pensionNextStep = pensionNote ? plainHtml(pensionNote.nextStep) : null;
    const assetRows = Object.entries(factFind?.assets || {}).flatMap(([assetType, assets])=>(assets || []).map((asset)=>{
            const figures = (0, $061bee36071dd9d5$export$53e371969067f999)(assetType, asset);
            const { incomeRate: incomeRate, growthRate: growthRate } = figures;
            return {
                assetType: $02a659cad5e2280d$var$prettify(assetType),
                description: $02a659cad5e2280d$var$sanitizeText(asset.description || 'Unnamed Asset'),
                value: $02a659cad5e2280d$var$toNumber(asset.value),
                basis: figures.basis,
                incomeRate: incomeRate,
                growthRate: growthRate,
                overridden: figures.overridden
            };
        }));
    /*
     * ASSUMPTIONS THE CLIENT CHANGED.
     *
     * A client may set the growth or income rate on an asset, as Moneysmart's planner lets them. The
     * document then has to say three things plainly: which figures are theirs, that they are not our
     * recommendation, and what the choice is worth — this plan at their rates against the same plan at
     * ours. Named as the CLIENT's decision whoever typed it: a referring firm cannot be seen to have
     * chosen an assumption on advice that is AgedCareWise's, and for an adviser firm the adviser's own
     * attribution is already on the cover (owner direction, 2026-09-12).
     */ const rateOverrides = (0, $2cee3e5f0555e7bc$export$40fbafa413a26149)(factFind);
    const describeRun = (rows)=>{
        if (!rows || !rows.length) return null;
        const funding = (0, $0fe89e03b6df746e$export$693cc3146baa3244)(rows);
        const last = rows[rows.length - 1];
        return {
            years: rows.length,
            savingsLast: funding.fundedFullPlan || funding.bankDepletesYear == null ? `the full ${rows.length}-year plan` : `about Year ${funding.bankDepletesYear}`,
            estate: (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(last) ?? 0
        };
    };
    const assumptionsChanged = rateOverrides.length ? {
        clientName: $02a659cad5e2280d$var$sanitizeText(`${factFind?.client?.firstName || ''} ${factFind?.client?.lastName || ''}`.trim() || 'the client'),
        anyAbove: (0, $2cee3e5f0555e7bc$export$46052f49dde64127)(rateOverrides),
        rows: rateOverrides.map((o)=>({
                asset: `${$02a659cad5e2280d$var$prettify(o.assetType)} \u{2014} ${$02a659cad5e2280d$var$sanitizeText(o.description)}`,
                measure: o.measure === 'growth' ? 'Growth' : 'Income',
                defaultPct: o.defaultPct,
                chosenPct: o.chosenPct
            })),
        chosen: describeRun(projections),
        atDefaults: describeRun(selectedStrategy.atDefaultRatesProjections)
    } : null;
    const calcCosts = await $55a1d8a64f1e5dfa$export$fb677777baef0897({
        factFind: safeFactFind,
        financials: baseline,
        radInput: roomCost,
        radPaid: totalRadPaid,
        overallStrategy: {
            rentHome: Boolean(selectedStrategy?.scenarioConfig?.rentHome || selectedStrategy?.snapshot?.homeStatus === 'Rent Home'),
            downsizeHome: Boolean(selectedStrategy?.scenarioConfig?.downsizeHome || selectedStrategy?.snapshot?.homeStatus === 'Downsize'),
            residentialFeeArrangements: // So the fee table prices the rules the strategy actually ran on (an opted-in run must not show the 2014 fee).
            residentialFeeArrangements
        },
        extraServiceFeeInput: $02a659cad5e2280d$var$toNumber(agedCareCosts?.extraServiceFeeInput || 0)
    });
    const feeArrangementsComparison = coveredByNoWorseOff ? {
        arrangements: residentialFeeArrangements,
        personName: $02a659cad5e2280d$var$sanitizeText(enteringCarePersonName || `${factFind?.client?.firstName || ''} ${factFind?.client?.lastName || ''}`.trim() || 'the client'),
        chosen: describeRun(projections),
        optedIn: describeRun(selectedStrategy.optInProjections)
    } : null;
    const structureAppendix = (0, $f70ff3a065f941e2$export$7a9a83c1f9700f91)(safeFactFind, {
        selectedStrategy: selectedStrategy,
        strategySource: strategySource
    });
    const structureAppendixHtml = (0, $f70ff3a065f941e2$export$ef316658362fb04e)(structureAppendix, (0, $f94e45ac645ae232$export$3dc27271f5d5c629));
    /*
     * THE GUARANTEED INCOME SECTION (guaranteed income review R1–R4, 21 Oct 2026; mock-up screen 5): for a plan
     * with a guaranteed income, the year-by-year table of what the family receives (the same figures as the
     * plan card), the best plan tested without one, the assumptions in plain words, the client's dated answers
     * and — for income only — the confirmation word for word. Frozen as data; rendered with the shared words.
     */ const guaranteedIncome = (()=>{
        const engineLever = (0, $09575c4cc12d1d84$export$e45920170ff81bed)(selectedStrategy);
        const manualRecord = selectedStrategy.strategyOptions?.annuityRecord;
        const manualAmount = Number(manualRecord?.purchaseAmount) || 0;
        const lever = engineLever ?? (manualAmount > 0 ? {
            amount: manualAmount,
            kind: (0, $8665f80549f60a1b$export$3ab75b1250c8af22)(manualRecord),
            incomeOnly: false,
            incomeAYear: Number(manualRecord?.annualPayment) || null
        } : null);
        if (!lever) return null;
        const base = engineLever ? (0, $09575c4cc12d1d84$export$b99ec4908215d8cd)(selectedStrategy, allScenarios) : null;
        const noAnnuity = allScenarios.filter((s)=>!(0, $09575c4cc12d1d84$export$e45920170ff81bed)(s) && s.snapshot).sort((a, b)=>$02a659cad5e2280d$var$toNumber(b.snapshot?.legacyValue) - $02a659cad5e2280d$var$toNumber(a.snapshot?.legacyValue))[0];
        const terms = selectedStrategy.annuityTerms || null;
        const built = (0, $66827b1304244a1d$export$11aaa304d9182b)({
            factFind: safeFactFind,
            personName: enteringCarePersonName,
            amount: lever.amount,
            kind: lever.kind,
            incomeAYear: lever.incomeAYear,
            quoted: Number(selectedStrategy.meansTestStrategy?.incomeOverride) > 0,
            rows: projections,
            compareRows: base?.projections || null,
            compareNote: base?.projections?.length ? (0, $09575c4cc12d1d84$export$1fb588cae1b9e959)(lever.amount) : null,
            horizonYears: legacyHorizonYears,
            plan: {
                estate: $02a659cad5e2280d$var$toNumber(selectedStrategy.snapshot?.legacyValue),
                pension: $02a659cad5e2280d$var$toNumber(selectedStrategy.snapshot?.pension),
                cashflow: $02a659cad5e2280d$var$toNumber(selectedStrategy.snapshot?.netCashflow)
            },
            alternative: noAnnuity ? {
                name: $02a659cad5e2280d$var$sanitizeText((0, $eb4adc50b37e37f7$export$d2deef8f2a8f76eb)(noAnnuity.name || '')),
                estate: $02a659cad5e2280d$var$toNumber(noAnnuity.snapshot?.legacyValue),
                pension: $02a659cad5e2280d$var$toNumber(noAnnuity.snapshot?.pension),
                cashflow: $02a659cad5e2280d$var$toNumber(noAnnuity.snapshot?.netCashflow)
            } : null
        });
        return built ? {
            ...built,
            rateExtrapolated: terms?.rateExtrapolated === true
        } : null;
    })();
    return {
        guaranteedIncome: guaranteedIncome,
        reportId: reportId,
        generatedAt: generatedAt,
        adviceAttributionLine: attributionLine,
        adviceAttributionIncomplete: attributionIncomplete,
        audience: reportAudience,
        clientName: `${factFind?.client?.firstName || 'Client'} ${factFind?.client?.lastName || ''}`.trim(),
        partnerName: factFind?.partner?.firstName && factFind?.partner?.lastName ? `${factFind.partner.firstName} ${factFind.partner.lastName}` : '',
        completerDisplay: factFind?.completer && factFind.completer !== 'client' ? `${factFind.completerFirstName || ''} ${factFind.completerLastName || ''}`.trim() || $02a659cad5e2280d$var$sanitizeText(factFind.completer) : '',
        completerRelationship: $02a659cad5e2280d$var$sanitizeText(factFind?.completerRelationship || ''),
        completerIsApplicant: completerIsApplicant,
        executiveSummaryOpeningHtml: executiveSummaryOpeningHtml,
        careRecipientProfile: careRecipientProfile,
        partnerContextHtml: partnerContextHtml,
        horizonSetAsideHtml: horizonSetAsideHtml,
        horizonSetAsideNote: horizonSetAsideNote,
        radFundingPrelude: radFundingPrelude,
        homeRuleParagraph: homeRuleParagraph,
        wideExplorationClause: wideExplorationClause,
        selectedStrategyName: $02a659cad5e2280d$var$sanitizeText((0, $eb4adc50b37e37f7$export$d2deef8f2a8f76eb)(selectedStrategy.name, totalRadPaid, roomCost)),
        selectedStrategyNarrative: recommendedNarrative,
        totalScenarios: analysis?.totalScenarios || allScenarios.length || 0,
        roomCost: roomCost,
        radPaid: totalRadPaid,
        estimatedDapAnnual: remainingForDap * mpir,
        /** The second room, where both of a couple enter care (7 Oct 2026). */ /** Leaving a retirement village (8 Oct 2026): what the village pays, when, and what of it goes to the room. */ villageExit: (()=>{
            const row = selectedStrategy.villageExit;
            const manual = selectedStrategy.inputs?.villageExit;
            const optPerson = selectedStrategy.strategyOptions?.villageExit?.person;
            const person = (manual?.person ?? optPerson) === 'partner' ? 'partner' : 'client';
            const name = $02a659cad5e2280d$var$sanitizeText((person === 'partner' ? safeFactFind.partner?.firstName : safeFactFind.client?.firstName) || 'the client');
            const refundMonths = (leave, refund)=>leave && refund ? Math.max(0, Math.round((new Date(refund).getTime() - new Date(leave).getTime()) / (30.44 * 86400000))) : 0;
            const roomPrice = Number(selectedStrategy.radRoomPrice) || Number(selectedStrategy.inputs?.radInput) || 0;
            if (row && row.refundDate) return (0, $511dfa7ed5ad5c31$export$ff6c9524331ef263)({
                name: name,
                leaveLabel: row.leaveDate ? (0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(row.leaveDate) : 'the coming weeks',
                entitlement: Number(row.entitlement) || 0,
                refundMonths: refundMonths(row.leaveDate, row.refundDate),
                refundDate: row.refundDate,
                roomPrice: roomPrice,
                deposit: totalRadPaid,
                fromVillage: Number(row.fromVillage) || 0,
                fromSavings: Number(row.fromSavings) || 0,
                soldPhrase: (0, $e5cae8423a439bf1$export$83ba4f4a49e92f66)((0, $e5cae8423a439bf1$export$8f80043cee83ba5d)(safeFactFind, selectedStrategy.radFundingManualKeys), (0, $f94e45ac645ae232$export$3dc27271f5d5c629)),
                toBank: Number(row.toBank) || 0,
                interim: row.interim ?? null,
                feesAfterLeaving: row.feesAfterLeaving ?? null,
                paidAtMove: !!row.paidAtMove,
                dapPerDay: Number(selectedStrategy.strategySpecificAgedCareCosts?.dailyAccommodationPayment) || 0
            });
            if (manual && manual.refundDate) {
                const fromVillage = Number(manual.fromVillage) || 0;
                return (0, $511dfa7ed5ad5c31$export$ff6c9524331ef263)({
                    name: name,
                    leaveLabel: manual.leaveDate ? (0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(manual.leaveDate) : 'the coming weeks',
                    entitlement: Number(manual.entitlement) || 0,
                    refundMonths: Number(manual.refundMonths) || refundMonths(manual.leaveDate, manual.refundDate),
                    refundDate: manual.refundDate,
                    roomPrice: roomPrice,
                    deposit: totalRadPaid,
                    fromVillage: fromVillage,
                    fromSavings: Math.max(0, totalRadPaid - fromVillage),
                    soldPhrase: (0, $e5cae8423a439bf1$export$83ba4f4a49e92f66)((0, $e5cae8423a439bf1$export$8f80043cee83ba5d)(safeFactFind, selectedStrategy.inputs?.radFunding), (0, $f94e45ac645ae232$export$3dc27271f5d5c629)),
                    toBank: Number(manual.toBank) || 0,
                    interim: manual.interim ?? null,
                    feesAfterLeaving: manual.feesAfterLeaving ?? null,
                    paidAtMove: !!manual.paidAtMove,
                    dapPerDay: (Number(selectedStrategy.outputs?.estimatedDapAnnual) || 0) / 365 || Number(selectedStrategy.inputs?.estimatedDapDaily) || 0
                });
            }
            return null;
        })(),
        /** A change of home (8 Oct 2026): what the plan does with it, in one paragraph — or that it stays put. */ facilityMove: (()=>{
            const row = selectedStrategy.facilityMove;
            const manual = selectedStrategy.inputs?.facilityMove;
            const person = manual?.person === 'partner' ? 'partner' : 'client';
            const name = $02a659cad5e2280d$var$sanitizeText((person === 'partner' ? safeFactFind.partner?.firstName : safeFactFind.client?.firstName) || 'the client');
            const stayRecord = person === 'partner' ? safeFactFind.partner?.careStay : safeFactFind.client?.careStay;
            const facilityName = $02a659cad5e2280d$var$sanitizeText(String(manual?.facilityName || stayRecord?.facilityName || ''));
            if (row) {
                if (row.stayPut) return `${name} stays at ${facilityName || 'the current home'}: the deposit held stays where it is and nothing is sold.`;
                const deposit = (Number(row.fromRefund) || 0) + (Number(row.fromSale) || 0);
                return (0, $b073c6d711dafa37$export$1059590aefc83273)({
                    name: name,
                    facilityName: facilityName,
                    moveLabel: row.moveDate ? (0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(row.moveDate) : 'the coming weeks',
                    newRoomPrice: Number(row.newRoomPrice) || 0,
                    deposit: deposit,
                    fromRefund: Number(row.fromRefund) || 0,
                    fromSale: Number(row.fromSale) || 0,
                    soldPhrase: (0, $e5cae8423a439bf1$export$83ba4f4a49e92f66)((0, $e5cae8423a439bf1$export$8f80043cee83ba5d)(safeFactFind, selectedStrategy.radFundingManualKeys), (0, $f94e45ac645ae232$export$3dc27271f5d5c629)),
                    dapPerDay: Number(selectedStrategy.strategySpecificAgedCareCosts?.dailyAccommodationPayment) || 0,
                    grandfathered: !!row.grandfathered,
                    retentionDaysTaken: 0
                });
            }
            if (manual && (Number(manual.newRoomPrice) || 0) > 0) {
                const deposit = Math.min(Number(manual.newRoomPrice) || 0, Number(manual.radTarget) || 0);
                const fromRefund = Math.min(Number(manual.refundToday) || 0, deposit);
                return (0, $b073c6d711dafa37$export$1059590aefc83273)({
                    name: name,
                    facilityName: facilityName,
                    moveLabel: manual.moveDate ? (0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(manual.moveDate) : 'the coming weeks',
                    newRoomPrice: Number(manual.newRoomPrice) || 0,
                    deposit: deposit,
                    fromRefund: fromRefund,
                    fromSale: Math.max(0, deposit - fromRefund),
                    soldPhrase: (0, $e5cae8423a439bf1$export$83ba4f4a49e92f66)((0, $e5cae8423a439bf1$export$8f80043cee83ba5d)(safeFactFind, selectedStrategy.inputs?.radFunding), (0, $f94e45ac645ae232$export$3dc27271f5d5c629)),
                    dapPerDay: (Number(selectedStrategy.outputs?.estimatedDapAnnual) || 0) / 365 || Number(selectedStrategy.inputs?.estimatedDapDaily) || 0,
                    grandfathered: !!manual.grandfathered,
                    retentionDaysTaken: Number(manual.retentionDaysTaken) || 0
                });
            }
            return null;
        })(),
        secondRoom: (()=>{
            const sr = selectedStrategy.secondRoom ?? (selectedStrategy.inputs?.secondRoom && selectedStrategy.inputs.secondRoom.roomPrice > 0 ? {
                person: selectedStrategy.inputs.secondRoom.person ?? 'partner',
                roomPrice: selectedStrategy.inputs.secondRoom.roomPrice,
                radPaid: selectedStrategy.inputs.secondRoom.radPaid,
                agedCareCosts: undefined
            } : null);
            if (!sr || !(Number(sr.roomPrice) > 0)) return null;
            const names = (0, $b8d3cfe4c156722e$export$24ee473c3b86ae0)(safeFactFind, sr.person === 'client' ? 'client' : 'partner', {
                first: 'the first to move in',
                second: 'the partner'
            });
            const name = names.secondName;
            // The second stage, where the second person enters later: an engine row carries it as
            // `phaseTwo`; a manual plan in its saved outputs.
            const p2 = (selectedStrategy.phaseTwo ?? selectedStrategy.outputs?.phaseTwo) || null;
            const firstDaily = Number(selectedStrategy.strategySpecificAgedCareCosts?.totalDailyCost) || (Number(selectedStrategy.outputs?.agedCareCost) || 0) / 365;
            const phaseLine = p2 && p2.fromDate && typeof p2.householdDailyCost === 'number' ? (0, $b8d3cfe4c156722e$export$72e32d04cedd8a9d)({
                firstName: $02a659cad5e2280d$var$sanitizeText(names.firstName),
                secondName: $02a659cad5e2280d$var$sanitizeText(name),
                fromLabel: (0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(p2.fromDate)
            }, firstDaily, p2.householdDailyCost) : null;
            return {
                name: $02a659cad5e2280d$var$sanitizeText(name),
                roomPrice: Number(sr.roomPrice) || 0,
                radPaid: Number(sr.radPaid) || 0,
                dailyTotal: sr.agedCareCosts?.totalDailyCost ?? null,
                phaseLine: phaseLine
            };
        })(),
        annualPension: selectedStrategy.snapshot?.pension || 0,
        annualCashflow: annualCashflow,
        projectedLegacy: selectedStrategy.snapshot?.legacyValue || selectedStrategy.outputs?.legacyEstimate || Number(selectedStrategy.projectedEstateValue) || 0,
        baseline: {
            netWorth: baseline.netWorth || 0,
            cashflow: baseline.cashFlow || 0,
            pension: baselineAnnualPension
        },
        strategyOpeningNetWorth: strategyOpeningNetWorth,
        openingNetWorthTipRows: openingNetWorthTipRows,
        illnessSeparatedAppliesInSoa: illnessSeparatedAppliesInSoa,
        illnessSeparatedDiffersFromBaseline: illnessSeparatedDiffersFromBaseline,
        baselineUsesIllnessSeparated: baselineUsesIllnessSeparated,
        modelUsesIllnessSeparated: modelUsesIllnessSeparated,
        baselinePensionStatus: baselinePensionStatus,
        selectedPensionStatus: selectedPensionStatus,
        pensionDeltaFromBaseline: pensionDeltaFromBaseline,
        enteringCarePersonName: enteringCarePersonName,
        fees: {
            basicDailyFee: $02a659cad5e2280d$var$toNumber(calcCosts?.basicDailyFee),
            dailyNCCC: $02a659cad5e2280d$var$toNumber(calcCosts?.dailyNCCC),
            dailyHSC: $02a659cad5e2280d$var$toNumber(calcCosts?.dailyHSC),
            dailyMTCF: $02a659cad5e2280d$var$toNumber(calcCosts?.dailyMTCF),
            feeArrangements: calcCosts?.feeArrangements === '2014' ? '2014' : '2025',
            dailyExtraServiceFee: $02a659cad5e2280d$var$toNumber(calcCosts?.dailyExtraServiceFee)
        },
        feeArrangementsComparison: feeArrangementsComparison,
        recommendations: (analysis?.recommendedOptimalStrategies || []).map((row)=>({
                label: $02a659cad5e2280d$var$sanitizeText(row.label),
                name: $02a659cad5e2280d$var$sanitizeText($02a659cad5e2280d$var$stripFundingSuffix(row.strategy?.name || 'Recommended strategy'))
            })),
        optimalStrategyCardsPrimary: displayOptimalCards,
        optimalStrategyCardsConditional: conditionalOptimalCards,
        hasConditionalStrategyCards: conditionalOptimalCards.length > 0,
        /** @deprecated Combined list for callers that expect a single array; prefer primary + conditional. */ optimalStrategyCards: [
            ...displayOptimalCards,
            ...conditionalOptimalCards
        ],
        strategySource: strategySource,
        customisedFrom: strategySource === 'manual_control' && customisedFrom ? $02a659cad5e2280d$var$sanitizeText(customisedFrom) : null,
        scenarioExplainer: scenarioExplainer,
        statedGoals: statedGoals,
        inScopeGoals: inScopeGoals,
        outOfScopeGoals: outOfScopeGoals,
        pathComparison: pathComparison,
        opportunityCost: opportunityCost,
        cashflowIsNegative: cashflowIsNegative,
        deficitFundingNarrative: deficitFundingNarrative,
        fundingRunway: fundingRunway,
        projectionSurplusDeficitNote: projectionSurplusDeficitNote,
        cashflowAnalysisSummary: cashflowAnalysis ? {
            year1Cashflow: cashflowAnalysis.year1Cashflow,
            firstDeficitYear: cashflowAnalysis.firstDeficitYear,
            firstDeficitAmount: cashflowAnalysis.firstDeficitAmount,
            hasDeficitYears: cashflowAnalysis.hasDeficitYears,
            isYear1Surplus: cashflowAnalysis.isYear1Surplus
        } : null,
        projectionPeriodMode: rowPeriodMode,
        careStartDate: careStartDate,
        radFundingDate: radFundingDate,
        radDrawdown: radDrawdown,
        enrichedProjections: enrichedProjections,
        topThree: topThree,
        radFundingRows: radFundingRows,
        adviceImplications: adviceImplications,
        pensionNextStep: pensionNextStep,
        // The same "What could go wrong" list the card shows (strategyRisks.ts), so the document
        // and the screen cannot disagree about the risks of the chosen strategy.
        strategyRisks: (0, $203e38d6e6c434f4$export$124603ee0434ece5)((0, $203e38d6e6c434f4$export$ebadbd3592b8b5e6)(selectedStrategy), {
            horizonWarning: (0, $3d096644ffaac9d7$export$bcf3d26e8114b217)(selectedStrategy, factFind)
        }),
        projections: projections,
        assetRows: assetRows,
        // The shared document pieces (features/advice/soaKit.ts, 3 Oct 2026): the position as
        // entered, the do-nothing run's year-by-year for the charts, and the Assumptions page as
        // it stood when the document was generated, for the appendix.
        situation: (0, $8ea663173c1a6588$export$b49cd4ac4688f9b9)(factFind),
        legacyHorizonYears: legacyHorizonYears,
        doNothingLegacy: doNothing ? $02a659cad5e2280d$var$toNumber(doNothingSnap.legacyValue) : null,
        doNothingCashflow: doNothing ? $02a659cad5e2280d$var$toNumber(doNothingSnap.netCashflow) : null,
        doNothingPension: doNothing ? $02a659cad5e2280d$var$toNumber(doNothingSnap.pension) : null,
        stayPutLegacy: stayPutLegacy,
        baselineProjections: (doNothing?.projections || []).map((p, i)=>({
                label: $02a659cad5e2280d$var$sanitizeText(String(p.fyLabel || `Year ${p.year ?? i + 1}`)),
                pension: $02a659cad5e2280d$var$toNumber(p.socialSecurity ?? p.pension),
                cashflow: $02a659cad5e2280d$var$toNumber(p.cashFlow ?? p.cashflow),
                netWorth: $02a659cad5e2280d$var$toNumber(p.netWorth)
            })),
        // The same Comparison Yr1 Age Pension lines for doing nothing, beside this plan's (owner, 24 Oct 2026).
        baselinePensionBreakdown: doNothing?.projections?.[0]?.socialSecurityBreakdown || [],
        assumptionSections: (0, $13910bc1e93fb74e$export$8d1b1c5d08b3c488)(),
        assumptionsChanged: assumptionsChanged,
        allFactFindRows: $02a659cad5e2280d$var$flattenObject(factFind || {}),
        familyEstate: familyEstate,
        estateRisk: familyEstate.clientWill === 'no' || familyEstate.partnerWill === 'no' || familyEstate.clientEpoa === 'no' || familyEstate.partnerEpoa === 'no' || factFind?.goals?.hasWill === false || String(factFind?.goals?.estatePlanning || '').toLowerCase() === 'no',
        annualLivingExpenses: $02a659cad5e2280d$var$toNumber(factFind?.expenses?.livingExpenses),
        adjustedLivingExpenses: $02a659cad5e2280d$var$toNumber((0, $1b5ad53cec30af73$export$df3d7258e77c9184)(agedCareCosts?.scenarioLivingExpenses, factFind?.expenses?.livingExpenses)),
        clientAge: (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind?.client?.dob) ?? 'N/A',
        partnerAge: factFind?.partner?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner.dob) ?? 'N/A' : 'N/A',
        isCoupleAdvice: isCoupleAdvice,
        hasDefinedBenefitPension: (0, $482dbb064a59e381$export$c6a118b4246f3a25)(factFind),
        factFindSections: $02a659cad5e2280d$export$70de02dda17e369e(factFind || {}),
        structureAppendix: structureAppendix,
        structureAppendixHtml: structureAppendixHtml
    };
}
/**
 * The "Assumptions you changed" box — nothing where the client left every rate alone.
 *
 * Not a footnote. A rate the client raised is the one input on the document that is theirs rather
 * than ours, so it gets its own table, a sentence in plain words saying whose decision it was, and
 * the consequence in dollars from the same plan run at our rates. The comparison is only offered
 * where the engine actually produced that run; an older saved strategy without one is not guessed at.
 */ function $02a659cad5e2280d$var$buildAssumptionsChangedHtml(snapshot) {
    const changed = snapshot.assumptionsChanged;
    if (!changed) return '';
    const pct = (v)=>`${v.toFixed(2)}%`;
    const rows = changed.rows.map((r)=>`<tr><td>${r.asset}</td><td>${r.measure}</td><td>${pct(r.defaultPct)}</td><td><strong>${pct(r.chosenPct)}</strong></td><td>${r.chosenPct > r.defaultPct ? 'Higher' : 'Lower'}</td></tr>`).join('');
    const comparison = changed.chosen && changed.atDefaults ? `<p><strong>What the difference is worth.</strong> This plan, at the rates ${changed.clientName} chose: savings last ${changed.chosen.savingsLast}, and the estimated estate at the end of the ${changed.chosen.years}-year plan is <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(changed.chosen.estate)}</strong>. The same plan \u{2014} the same assets sold, in the same order, the same deposit and the same borrowing \u{2014} at AgedCareWise's default rates: savings last ${changed.atDefaults.savingsLast}, and the estimated estate is <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(changed.atDefaults.estate)}</strong>.</p>` : `<p class="small muted">A comparison of this plan at AgedCareWise's default rates was not available for this document.</p>`;
    return `
<div class="h3">Assumptions you changed</div>
<table><thead><tr><th>Asset</th><th>Rate</th><th>AgedCareWise default</th><th>Rate chosen</th><th></th></tr></thead><tbody>${rows}</tbody></table>
<p>These rates were chosen by <strong>${changed.clientName}</strong>. They are ${changed.anyAbove ? 'higher than' : 'different from'} the rates AgedCareWise uses by default and are <strong>not our recommendation</strong>. The projections in this document run on them.</p>
${changed.anyAbove ? `<p><strong>The risk.</strong> A projection is only as reliable as the assumptions behind it. Higher returns are not free: an asset expected to earn more is usually one whose returns swing more from year to year, and a run of poor years early in aged care \u{2014} when fees are being paid every day \u{2014} cannot be made up later. If the returns turn out lower than assumed, savings run out sooner and the estate is smaller than shown here.</p>` : ''}
${comparison}`;
}
function $02a659cad5e2280d$export$db5e86b8c848ffee(planLines, baselineLines) {
    const pool = new Map();
    for (const r of baselineLines || []){
        const key = String(r?.label || '').trim();
        if (!pool.has(key)) pool.set(key, []);
        pool.get(key).push(String(r?.value ?? ''));
    }
    return (planLines || []).map((r)=>{
        const list = pool.get(String(r?.label || '').trim());
        return list && list.length ? list.shift() : null;
    });
}
/**
 * The model's Comparison Yr1 pension lines — the evidence behind the Age Pension section, couple or single.
 * With the do-nothing run's same lines in a "No plan" column beside them, and a dot on each line the plan
 * moves, so the reader sees why the pension changes (owner, 24 Oct 2026).
 */ function $02a659cad5e2280d$var$pensionBreakdownDetailsHtml(snapshot) {
    const planLines = snapshot.enrichedProjections?.[0]?.pensionBreakdown || [];
    const baselineLines = snapshot.baselinePensionBreakdown || [];
    const withBaseline = baselineLines.length > 0;
    const cols = withBaseline ? 3 : 2;
    const baselineValues = withBaseline ? $02a659cad5e2280d$export$db5e86b8c848ffee(planLines, baselineLines) : [];
    return `<details>
<summary><strong>Breakdown (Comparison Yr1 projection only)</strong> \u{2014} Evidence of how the model calculated Age Pension</summary>
<p class="small muted">The lines below are the model's Comparison Yr1 social security calculation breakdown for this selected strategy.${withBaseline ? ' The No plan column is the same calculation if nothing changes; a blue dot marks each line the plan moves.' : ''}</p>
<table class="pb-table">
<thead><tr><th>Calculation line</th>${withBaseline ? '<th class="pb-num">No plan</th>' : ''}<th class="pb-num pb-plan">This plan</th></tr></thead>
<tbody>
${planLines.length > 0 ? planLines.map((row, i)=>{
        const label = $02a659cad5e2280d$var$sanitizeText(String(row?.label || 'Line'));
        const value = $02a659cad5e2280d$var$sanitizeText(String(row?.value ?? ''));
        const isSeparator = label.startsWith('---');
        if (isSeparator) return `<tr><td colspan="${cols}"><strong>${label.replace(/---/g, '').trim() || 'Section'}</strong></td></tr>`;
        if (!withBaseline) return `<tr><td>${label}</td><td class="pb-num pb-plan">${value || "\u2014"}</td></tr>`;
        const raw = baselineValues[i];
        const before = raw == null ? '' : $02a659cad5e2280d$var$sanitizeText(raw);
        const moved = raw != null && before.trim() !== value.trim();
        return `<tr><td>${moved ? '<span class="pb-dot" title="Changes with the plan" aria-label="Changes with the plan"></span>' : ''}${label}</td><td class="pb-num">${before || "\u2014"}</td><td class="pb-num pb-plan">${value || "\u2014"}</td></tr>`;
    }).join('') : `<tr><td colspan="${cols}">Comparison Yr1 pension breakdown was not attached in this export payload.</td></tr>`}
</tbody>
</table>
</details>`;
}
function $02a659cad5e2280d$export$4a508eeca5997a18(pc) {
    if (!pc) return '';
    const plan = pc.plan;
    const dn = pc.doNothing;
    const side = (o, k)=>o && Number.isFinite(Number(o[k])) ? Number(o[k]) : null;
    return (0, $8ea663173c1a6588$export$19dae3d6ce96af14)([
        {
            measure: 'estate',
            label: 'Left to the family',
            doNothing: side(dn, 'legacy'),
            plan: side(plan, 'legacy'),
            delta: Number(pc.legacyDelta) || 0
        },
        {
            measure: 'pension',
            label: 'Age Pension, a year',
            doNothing: side(dn, 'pension'),
            plan: side(plan, 'pension'),
            delta: Number(pc.pensionDelta) || 0
        },
        {
            measure: 'cashflow',
            label: 'Each year, after costs',
            doNothing: side(dn, 'cashflow'),
            plan: side(plan, 'cashflow'),
            delta: Number(pc.cashflowDelta) || 0
        },
        {
            measure: 'fees',
            label: 'Aged care fees, a year',
            doNothing: side(dn, 'careFees'),
            plan: side(plan, 'careFees'),
            delta: Number(pc.careFeeDeltaVsDoNothing) || 0
        }
    ], 'Paying daily');
}
function $02a659cad5e2280d$export$79abd5af043a4a00(lostPerYear) {
    const n = Math.round(Number(lostPerYear) || 0);
    if (n === 0) return 'No change';
    return `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(n))} ${n > 0 ? 'less' : 'more'}`;
}
function $02a659cad5e2280d$var$formatDeltaCurrency(delta) {
    const n = Number(delta) || 0;
    const abs = (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(n));
    if (n > 0) return `+${abs}`;
    if (n < 0) return `\u{2212}${abs}`;
    return abs;
}
/**
 * Opening net worth tooltip lines — matches {@link ProjectionsModal} `createAssetBreakdown`:
 * prefer year-1 projection row assets/home/liabilities; fall back to fact-find asset listing.
 */ function $02a659cad5e2280d$var$buildOpeningNetWorthBreakdownLines(projectionRow, openingNetWorth, fallbackFactFind) {
    const lines = [];
    const row = projectionRow;
    const pushTotal = ()=>{
        lines.push({
            label: '=== TOTAL NET WORTH ===',
            value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(openingNetWorth)
        });
    };
    if (row && (row.assets || row.home)) {
        if (row.home && parseFloat(String(row.home.value)) > 0) lines.push({
            label: $02a659cad5e2280d$var$sanitizeText(row.home.description || 'Family Home'),
            value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(parseFloat(String(row.home.value)) || 0)
        });
        if (row.assets && typeof row.assets === 'object') Object.entries(row.assets).forEach(([assetType, assetList])=>{
            if (!Array.isArray(assetList)) return;
            assetList.forEach((asset)=>{
                let v = parseFloat(String(asset.value)) || 0;
                if (asset.type === 'annuities' && asset.residualValue != null && asset.residualValue !== '') v = parseFloat(String(asset.residualValue)) || 0;
                if (v > 0) lines.push({
                    label: $02a659cad5e2280d$var$sanitizeText(asset.description || asset.name || `${$02a659cad5e2280d$var$prettify(assetType)} asset`),
                    value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(v)
                });
            });
        });
        let totalLiabilities = 0;
        Object.values(row.liabilities || {}).forEach((list)=>{
            (list || []).forEach((l)=>{
                totalLiabilities += parseFloat(String(l.balance)) || 0;
            });
        });
        if (totalLiabilities > 0) lines.push({
            label: 'Less: Liabilities',
            value: `-${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(totalLiabilities)}`
        });
        if (lines.length > 0) {
            pushTotal();
            return lines;
        }
    }
    const fd = fallbackFactFind || {};
    if (fd.home?.value && parseFloat(String(fd.home.value)) > 0) lines.push({
        label: 'Family Home',
        value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(parseFloat(String(fd.home.value)) || 0)
    });
    (0, $bfa4518c9dced417$export$e18ad1b53d14ba76).forEach((type)=>{
        const assetList = fd.assets?.[type.id];
        if (!type.isLiquid || !assetList) return;
        assetList.forEach((asset, index)=>{
            const rawValue = asset.balance != null ? asset.balance : asset.value;
            const numeric = rawValue || 0;
            if (numeric > 0) lines.push({
                label: $02a659cad5e2280d$var$sanitizeText(`${asset.name || asset.description || type.name} ${index + 1}`),
                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(numeric)
            });
        });
    });
    const radPaidAssets = fd.assets?.radPaid;
    if (radPaidAssets && radPaidAssets.length > 0) radPaidAssets.forEach((rad, index)=>{
        const val = parseFloat(String(rad.value)) || 0;
        if (val > 0) lines.push({
            label: `RAD Paid ${index + 1}`,
            value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(val)
        });
    });
    if (lines.length > 0) {
        pushTotal();
        return lines;
    }
    return [
        {
            label: 'Total net worth (opening)',
            value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(openingNetWorth)
        }
    ];
}
/**
 * Care entry and the funding sale, as dated by THIS strategy.
 *
 * They are separate acts and the engine models the gap between them — proceeds sit in the bank earning
 * deemed income until the deposit is paid. Saying a sale happens "on the entry date" under a strategy
 * that sells three months earlier misdescribes the client's own advice, and hides the months where the
 * money is assessable.
 */ function $02a659cad5e2280d$var$careAndSaleTimingSentence(snapshot) {
    return $02a659cad5e2280d$var$careTimingSentence(snapshot);
}
/**
 * The provider agreement the drawdown rows rest on. Stated because it is a fact the client has to
 * confirm with the home, not something the model can know: the accommodation payment may always be
 * drawn from the deposit, the other fees only where the provider has agreed in writing.
 */ function $02a659cad5e2280d$var$depositArrangementSentence(snapshot) {
    switch(snapshot.radDrawdown){
        case 'none':
            return 'The arrangement modelled does not allow any fees to be drawn from the refundable accommodation deposit; once savings run low the plan borrows against the home instead.';
        case 'dap':
            return 'Under the arrangement modelled only the daily accommodation payment may be drawn from the refundable accommodation deposit; other fees are met from savings, then by borrowing against the home.';
        default:
            return "Under the arrangement modelled, care fees may be drawn from the refundable accommodation deposit once savings run low \u2014 the daily accommodation payment as of right, the other fees by written agreement with the provider. Each dollar drawn reduces the refund at the end of care and increases the daily accommodation payment.";
    }
}
/**
 * Which fee rules the resident is on, and what the other choice would be worth — only for a resident
 * the profile puts under the no-worse-off principle. The election to opt in cannot be undone, so
 * the document states both the rules modelled and the whole-of-horizon comparison the engine ran.
 */ function $02a659cad5e2280d$var$feeArrangementsParagraph(snapshot) {
    const c = snapshot.feeArrangementsComparison;
    if (!c) return '';
    const who = c.personName;
    if (c.arrangements === '2025') return `<p><strong>Fee arrangements.</strong> Because a Home Care Package was in place or approved for ${who} on 12 September 2024, the 'no worse off' principle would put ${who} on the 1 July 2014 fee arrangements (a means-tested care fee) on entering care. <strong>This plan is modelled as opting in to the 1 November 2025 fee arrangements</strong> \u{2014} the hotelling and non-clinical care contributions. Opting in is an election made to the provider and <strong>cannot be reversed</strong>; obtain advice before making it.</p>`;
    const comparison = c.chosen && c.optedIn ? ` <strong>What opting in would be worth:</strong> on these rules, savings last ${c.chosen.savingsLast} and the estimated estate at the end of the ${c.chosen.years}-year plan is <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(c.chosen.estate)}</strong>; the same plan opted in to the 1 November 2025 rules gives savings lasting ${c.optedIn.savingsLast} and an estate of <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(c.optedIn.estate)}</strong> \u{2014} ${c.optedIn.estate >= c.chosen.estate ? `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(c.optedIn.estate - c.chosen.estate)} more` : `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(c.chosen.estate - c.optedIn.estate)} less`}.` : '';
    return `<p><strong>Fee arrangements.</strong> Because a Home Care Package was in place or approved for ${who} on 12 September 2024, the 'no worse off' principle puts ${who} on the <strong>1 July 2014 fee arrangements</strong>: a means-tested care fee (capped each year of care and over a lifetime, with fees already paid under the package counting towards the lifetime cap) instead of the hotelling and non-clinical care contributions. Accommodation is on the 1 November 2025 arrangements either way, so deposit retention and DAP indexation still apply. ${who} may opt in to the 1 November 2025 fee arrangements at any time, but the election cannot be reversed.${comparison}</p>`;
}
function $02a659cad5e2280d$var$careTimingSentence(snapshot) {
    const careStartOn = (0, $876c355975468a36$export$489a569037cfef1b)(snapshot.careStartDate);
    const radFundingOn = (0, $876c355975468a36$export$489a569037cfef1b)(snapshot.radFundingDate);
    if (!careStartOn) return "Where a future care start date is set, care fees and deposit funding are modelled from that date \u2014 nothing is charged before entry.";
    const sellsBeforeEntry = radFundingOn != null && radFundingOn < careStartOn;
    return `Residential care is modelled as beginning on ${(0, $876c355975468a36$export$322b36d80aef60ca)(careStartOn)}; fees are charged from that date and nothing is charged before entry.` + (sellsBeforeEntry ? ` Assets nominated to fund the accommodation deposit are sold earlier, on ${(0, $876c355975468a36$export$322b36d80aef60ca)(radFundingOn)}, and the proceeds are held in the bank \u{2014} deemed and means-tested \u{2014} until the deposit is paid.` : ' Assets nominated to fund the accommodation deposit are sold on that same date.');
}
function $02a659cad5e2280d$var$buildProjectionTableBodyFromSnapshot(snapshot) {
    const rows = snapshot.enrichedProjections || [];
    if (rows.length === 0) return '<tr><td colspan="7">No year-by-year projections were attached to this strategy export.</td></tr>';
    const tipBubble = (id, title, rowsForTip, emptyText = 'Breakdown not available for this year.')=>{
        const items = (rowsForTip || []).filter((r)=>r && (r.label || r.value !== undefined));
        const content = items.length ? `<div class="tip-grid">${items.map((r)=>{
            const label = $02a659cad5e2280d$var$sanitizeText(r.label || 'Line');
            if (label.startsWith('---')) return '<div style="border-top:1px solid rgba(148,163,184,.35);margin:5px 0"></div>';
            const raw = r.value;
            const n = $02a659cad5e2280d$var$parseMoneyish(raw);
            const hasMoneySign = typeof raw === 'string' && raw.includes('$');
            const isPercent = typeof raw === 'string' && raw.includes('%');
            const displayVal = isPercent ? $02a659cad5e2280d$var$sanitizeText(String(raw)) : hasMoneySign || Math.abs(n) > 0 ? `${n >= 0 ? '+' : '-'}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(n))}` : $02a659cad5e2280d$var$sanitizeText(String(raw ?? ''));
            return `<div class="tip-row"><span class="tip-lbl">${label}:</span><span class="tip-val">${displayVal}</span></div>`;
        }).join('')}</div>` : `<div class="small muted">${emptyText}</div>`;
        return `<span class="cc-tip" id="${id}" role="tooltip"><strong>${$02a659cad5e2280d$var$sanitizeText(title)}</strong>${content}</span>`;
    };
    // No "i" button: the figure itself opens its working, on hover, focus or tap (owner, 24 Oct 2026).
    let tipSeq = 0;
    const withTip = (valueHtml, title, rowsForTip, emptyText)=>{
        const id = `cc-tip-${++tipSeq}`;
        return `<span class="metric-cell" tabindex="0" role="button" aria-describedby="${id}">${valueHtml}${tipBubble(id, title, rowsForTip, emptyText)}</span>`;
    };
    const openingNw = Number(snapshot.strategyOpeningNetWorth ?? snapshot.baseline?.netWorth ?? 0);
    const openingTipRows = snapshot.openingNetWorthTipRows?.length > 0 ? snapshot.openingNetWorthTipRows : $02a659cad5e2280d$var$buildOpeningNetWorthBreakdownLines(snapshot.projections?.[0], openingNw, {});
    // Wording follows the calendar the rows were actually cut on — see the snapshot's own note.
    const period = (0, $48fd3f316ae581a6$export$f15392dd2f17ee04)(snapshot.projectionPeriodMode);
    const fyBlendExtras = [];
    const row0 = rows[0];
    // Only meaningful under financial-year rows: the blend day-weights across 1 July–30 June
    // (computeYearOneFullAustralianFyBlend), so beneath calendar rows it would describe a period this
    // table never shows. Suppressed rather than relabelled — the figures really are FY figures.
    const fy = period.differsFromTaxYear ? undefined : row0?.fyFullYearView;
    const b = fy?.blended;
    if (fy && b) {
        const basePrePension = fy.baselineProjectionRow?.socialSecurity ?? 0;
        const basePostPension = fy.strategyProjectionRow?.socialSecurity ?? 0;
        const basePreCare = fy.baselineProjectionRow?.annualCareCost ?? 0;
        const basePostCare = fy.strategyProjectionRow?.annualCareCost ?? 0;
        const fyOpening = fy.netWorthOpening ?? openingNw;
        const stratClosing = Number(row0?.netWorth ?? 0);
        fyBlendExtras.push(`<tr class="proj-tr-fy-wrap"><td colspan="7" class="proj-fy-cell">
<details class="soa-fy-details">
<summary class="soa-fy-summary">Show full <strong>${$02a659cad5e2280d$var$sanitizeText(fy.fyLabel || 'financial year')}</strong> row <span class="soa-fy-est">(estimate)</span></summary>
<div class="soa-fy-inner-wrap">
<p class="small muted soa-fy-lede">Separate estimate: combines before- and after-strategy positions within the financial year (saved profile from 1 July to the day before the strategy start, then your modelled strategy to 30 June; day-weighted). Illustrative only.</p>
<table class="table-proj table-proj-fy">
<tbody><tr class="proj-tr-fy-data">
<td class="proj-year"><span class="block">${$02a659cad5e2280d$var$sanitizeText(fy.fyLabel || '')} (estimate)</span><span class="small muted block">Full financial year blend</span></td>
<td class="td-num">${withTip((0, $f94e45ac645ae232$export$3dc27271f5d5c629)(fyOpening), 'Opening net worth (FY estimate)', [
            {
                label: 'Current file (fact-find)',
                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(fyOpening)
            },
            {
                label: 'Note',
                value: 'Comparison Yr1 uses your strategy-path opening when that differs from your saved profile.'
            }
        ])}</td>
<td class="td-num age-pos">${withTip(`${(b.socialSecurity ?? 0) >= 0 ? '+' : ''}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(b.socialSecurity ?? 0)}`, 'Age Pension (FY estimate)', [
            {
                label: 'Blended annual rate (day-weighted)',
                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(b.socialSecurity ?? 0)
            },
            {
                label: 'Pre-strategy (p.a.)',
                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(basePrePension)
            },
            {
                label: 'Post-strategy (p.a.)',
                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(basePostPension)
            }
        ])}</td>
<td class="td-num age-neg">${withTip(`-${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(b.annualCareCost ?? 0)}`, 'Aged care costs (FY estimate)', [
            {
                label: 'Blended annual cost (day-weighted)',
                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(b.annualCareCost ?? 0)
            },
            {
                label: 'Pre-strategy (p.a.)',
                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(basePreCare)
            },
            {
                label: 'Post-strategy (p.a.)',
                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(basePostCare)
            },
            {
                label: 'Pre-strategy vs post-strategy',
                value: 'Pre-strategy uses your saved profile before residential aged-care optimisation. Post-strategy matches Comparison Yr1.'
            }
        ])}</td>
<td class="td-num ${(b.cashFlow ?? 0) >= 0 ? 'age-pos' : 'age-neg'}">${withTip(`${(b.cashFlow ?? 0) >= 0 ? '+' : ''}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(b.cashFlow ?? 0)}`, 'Net cashflow (FY estimate)', [
            {
                label: 'Blended net cashflow after care (p.a. equivalent)',
                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(b.cashFlow ?? 0)
            },
            {
                label: 'Tax component (net)',
                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(b.tax ?? 0)
            },
            {
                label: 'Living expenses (blend)',
                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(b.livingExpenses ?? 0)
            }
        ])}</td>
<td class="td-num">${withTip("\u2014", 'Closing net worth (full FY row)', [
            {
                label: 'Why no figure here',
                value: 'This row only shows day-blended pension, care costs and cashflow for the full financial year. Closing net worth is not rebuilt on that blended basis.'
            },
            {
                label: 'Strategy-path closing (Comparison Yr1)',
                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(stratClosing)
            }
        ])}</td>
<td class="td-num"><span class="metric-cell muted small">Illustrative blend</span></td>
</tr></tbody></table></div>
</details>
</td></tr>`);
    }
    const dataRows = rows.map((row, i)=>{
        const netWorthStart = i === 0 ? openingNw : Number(rows[i - 1]?.netWorth ?? 0);
        const netWorthEnd = Number(row.netWorth ?? 0);
        const startBreakdown = i === 0 ? openingTipRows : rows[i - 1]?.netWorthBreakdown || [];
        const endBreakdown = row.netWorthBreakdown || [];
        const yearCol = row.fyLabel && i === 0 ? `<div class="proj-year-stack"><strong class="proj-cmp-label">Comparison Yr1</strong><span class="small muted">${$02a659cad5e2280d$var$sanitizeText(row.fyLabel)}${row.isPartialFy ? ` \xb7 partial ${period.mode === 'calendar_year' ? 'year' : 'FY'}` : ''}</span></div>` : row.fyLabel ? `<div class="proj-year-stack">${$02a659cad5e2280d$var$sanitizeText(row.fyLabel)}${row.isPartialFy ? `<span class="small muted"> (partial ${period.mode === 'calendar_year' ? 'year' : 'FY'})</span>` : ''}</div>` : `Year ${row.year}`;
        const mainTr = `<tr class="proj-tr-data${i % 2 === 1 ? ' proj-zebra' : ''}">
<td class="proj-year">${yearCol}</td>
<td class="td-num">${withTip((0, $f94e45ac645ae232$export$3dc27271f5d5c629)(netWorthStart), 'Net Worth (Opening) Breakdown', startBreakdown)}</td>
<td class="td-num age-pos">${withTip(`+${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.pension)}`, 'Age Pension Breakdown', row.pensionBreakdown)}</td>
<td class="td-num age-neg">${withTip(`-${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.careAnnual)}`, 'Aged Care Costs Breakdown', row.careBreakdown)}</td>
<td class="td-num ${row.cashFlow >= 0 ? 'age-pos' : 'age-neg'}">${withTip(`${row.cashFlow >= 0 ? '+' : ''}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.cashFlow)}`, 'Net Cashflow Breakdown', row.cashBreakdown)}</td>
<td class="td-num">${withTip((0, $f94e45ac645ae232$export$3dc27271f5d5c629)(netWorthEnd), 'Net Worth (Closing) Breakdown', endBreakdown)}</td>
<td>${withTip($02a659cad5e2280d$export$9ca6fd868065a954(row), 'Surplus / Deficit Detail', row.cashFlow < 0 ? $02a659cad5e2280d$export$4c10ea709b72deea(row) : [
            {
                label: 'Treatment',
                value: 'Surplus retained and carried into next year balances.'
            }
        ])}</td>
</tr>`;
        if (i === 0 && fyBlendExtras.length) return `${mainTr}${fyBlendExtras.join('')}`;
        return mainTr;
    }).join('');
    return dataRows;
}
function $02a659cad5e2280d$export$5321cadb6c472b3e({ radFundingRows: radFundingRows, radFundingCgtTotal: radFundingCgtTotal, cgtAssumptionDisclosure: cgtAssumptionDisclosure, annuityTerms: annuityTerms, clientFirstName: clientFirstName, partnerFirstName: partnerFirstName }) {
    const grouped = {};
    (radFundingRows || []).forEach((row)=>{
        const key = row.assetTypeKey || 'other';
        if (!grouped[key]) grouped[key] = {
            amount: 0,
            assets: []
        };
        grouped[key].amount += $02a659cad5e2280d$var$toNumber(row.amount);
        grouped[key].assets.push(row.source);
    });
    const cgtTotal = $02a659cad5e2280d$var$toNumber(radFundingCgtTotal);
    const items = Object.entries(grouped).map(([assetTypeKey, data])=>{
        const template = $02a659cad5e2280d$var$ASSET_IMPLICATION_TEMPLATES[assetTypeKey] || $02a659cad5e2280d$var$ASSET_IMPLICATION_TEMPLATES.other;
        const sourceList = Array.from(new Set(data.assets)).slice(0, 3).join(', ');
        const hasCgt = assetTypeKey === 'shares' && cgtTotal > 0;
        const cgtLine = hasCgt ? `Estimated CGT from modelled RAD funding: <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(cgtTotal)}</strong>.` : '';
        return {
            title: `${$02a659cad5e2280d$var$prettify(assetTypeKey)} implications`,
            lead: `Modelled drawdown from this asset type: <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(data.amount)}</strong>${sourceList ? ` (${$02a659cad5e2280d$var$sanitizeText(sourceList)})` : ''}.`,
            body: template,
            cgtLine: cgtLine
        };
    });
    // Pushed rather than returned early: a strategy can sell an investment property without any RAD
    // liquidation, and the CGT-assumption disclosure below still has to reach the document in that case.
    if (items.length === 0) items.push({
        title: 'Implementation implications',
        lead: 'No upfront RAD liquidation was required in this strategy.',
        body: 'You should still validate product conditions, tax outcomes, and legal consequences before implementing any future drawdowns.'
    });
    /*
     * THE ANNUITY, IN FULL. Placed before the generic product-provider note because it is specific
     * to what was recommended, and because the terms are the part a family reads this document to
     * find out. Written as prose rather than a table: an SOA is read, not scanned.
     */ if (annuityTerms && $02a659cad5e2280d$var$toNumber(annuityTerms.purchaseAmount) > 0) {
        const purchase = $02a659cad5e2280d$var$toNumber(annuityTerms.purchaseAmount);
        const rcv = $02a659cad5e2280d$var$toNumber(annuityTerms.residualPercent);
        const ownerIsPartner = annuityTerms.owner === 'partner';
        const client = $02a659cad5e2280d$var$sanitizeText(clientFirstName || 'the applicant');
        const partner = $02a659cad5e2280d$var$sanitizeText(partnerFirstName || '');
        const owner = ownerIsPartner ? partner || 'the partner' : client;
        const survivor = ownerIsPartner ? client : partner;
        const income = $02a659cad5e2280d$var$toNumber(annuityTerms.annualPayment);
        const reversionary = !!annuityTerms.reversionary;
        const scheduleYears = annuityTerms.capitalAccessPeriodYears != null ? $02a659cad5e2280d$var$toNumber(annuityTerms.capitalAccessPeriodYears) || null : null;
        const sexKnownForWords = annuityTerms.lifeExpectancySexKnown == null ? null : !!annuityTerms.lifeExpectancySexKnown;
        /*
         * THE FULL-AMOUNT-BACK TYPE, THE INDEXATION AND THE RATE, AS THEY ARE (guaranteed income review, 21 Oct
         * 2026). This always used the money-back sentence, always said "not indexed" and always claimed 60% of
         * the price is counted — wrong for the annuity-and-life-cover type (only its income part is counted at
         * 60%; the cover is counted in full) and for the type that rises with prices.
         */ const isGuaranteed = annuityTerms.annuityType === 'guaranteed';
        const indexed = !!annuityTerms.indexed;
        const capitalSentence = isGuaranteed ? `It is a guaranteed income combined with life cover: <strong>the full ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(purchase)} goes back</strong> to ${owner}'s estate whenever ${owner} passes away. This is why the income is the lowest of the types.` : rcv >= 99.5 ? `${$02a659cad5e2280d$var$sanitizeText((0, $5ccd559ea4d04f2e$export$476ca360cf39c0a7)({
            residualPct: 100,
            periodYears: scheduleYears,
            sexKnown: sexKnownForWords,
            ownerName: owner,
            amountWords: `the purchase price of ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(purchase)}`
        }))} This is why the income is lower than a nil-residual annuity would pay.` : rcv <= 0.5 ? `<strong>Nothing is returned</strong> at the end \u{2014} the provider keeps the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(purchase)}. This is why the income is higher, and it means the annuity leaves nothing to the estate.` : $02a659cad5e2280d$var$sanitizeText((0, $5ccd559ea4d04f2e$export$476ca360cf39c0a7)({
            residualPct: rcv,
            periodYears: scheduleYears,
            sexKnown: sexKnownForWords,
            ownerName: owner,
            amountWords: `the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(purchase)}`
        }));
        const survivorSentence = survivor ? reversionary ? `The annuity is <strong>reversionary</strong>: if ${owner} dies first, the income continues to ${survivor} for the rest of their life.` : `The annuity is <strong>not reversionary</strong>: the income stops on ${owner}'s death and ${survivor} does not continue receiving it. Whether any money returns is a separate question, answered above.` : `The income stops on ${owner}'s death.`;
        items.push({
            title: 'Annuity terms',
            lead: `Modelled purchase: <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(purchase)}</strong> into ${isGuaranteed ? 'a lifetime guaranteed income with life cover' : 'a lifetime annuity'} owned by <strong>${owner}</strong>${income > 0 ? `, paying approximately <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(income)}</strong> a year` : ''}.`,
            body: `${capitalSentence} ${survivorSentence} ` + (indexed ? 'The payment is <strong>indexed</strong>: it rises with prices each year, which is why it starts lower. ' : "The payment is <strong>not indexed</strong> \u2014 it does not rise with inflation, so its buying power falls over time. ") + (isGuaranteed ? 'Centrelink counts only the income part at 60% in the assets test (30% after the first five years, or after age 85 if that is later) and 60% of the payments as income; the life cover is counted in full, so the pension and fee savings are smaller than with the other types. ' : "Centrelink counts 60% of the purchase price in the assets test for the first five years, or until age 85 if that is later, and 30% after that, and 60% of the payments as income. What it costs depends on the shape: with nothing coming back the capital is committed for life, and with capital returned the most that can be taken back falls each year to nothing. ") + (annuityTerms.rateExtrapolated === true ? "The rate is estimated from the published table \u2014 above age 75 the table is extended, so a written quote matters more. " : '') + `Figures use an indicative rate; obtain a written quote from the provider before implementing, as the actual rate determines whether this strategy remains the strongest.`
        });
    }
    const productTypes = [
        'accountBasedPensions',
        'superannuation',
        'annuities',
        'termDeposits'
    ];
    const hasProductTypes = Object.keys(grouped).some((k)=>productTypes.includes(k));
    if (hasProductTypes) items.push({
        title: 'Product provider checks',
        lead: 'Before implementation, confirm product-level terms with each provider.',
        body: 'Break costs, exit fees, market-value adjustments, adviser service terms, and processing windows are not modelled in AgedCareWise and can change your net outcomes.'
    });
    if (cgtTotal > 0) items.push({
        title: 'Tax validation required',
        lead: `The current modelling estimates CGT of <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(cgtTotal)}</strong> from asset sales used to fund RAD.`,
        body: 'This is an estimate only and should be validated with a registered tax adviser using actual cost-base records, ownership structure, and the final transaction date. Where no cost base was recorded for an asset, a cost base of 25% of its current value has been assumed (a conservative default). For gains realised on or after 1 July 2027, the legislated CGT reform applies (cost-base indexation in place of the 50% discount, and a 30% minimum tax that does not apply to Age Pension / income-support recipients).'
    });
    if (cgtAssumptionDisclosure) items.push({
        title: "Incomplete records \u2014 CGT inputs assumed",
        lead: 'Some capital gains tax figures in this advice rest on assumptions, because the underlying records were not supplied.',
        body: cgtAssumptionDisclosure
    });
    return items;
}
function $02a659cad5e2280d$export$4c10ea709b72deea(row) {
    const rows = row.drawdownBreakdown || [];
    if (rows.some((d)=>$02a659cad5e2280d$var$parseMoneyish(d?.value) > 0)) return rows;
    const routing = row.cashflowRoutingLine;
    if (routing && routing.value && /^Surplus directed to$/.test(String(routing.label))) return [
        {
            label: 'Care drawn monthly from',
            value: routing.value
        }
    ];
    return rows;
}
function $02a659cad5e2280d$export$9ca6fd868065a954(row) {
    const cashflow = $02a659cad5e2280d$var$toNumber(row.cashFlow);
    if (cashflow < 0) {
        const routed = $02a659cad5e2280d$export$4c10ea709b72deea(row);
        if (routed.length === 1 && routed[0]?.label === 'Care drawn monthly from') return `Deficit funded from ${$02a659cad5e2280d$var$sanitizeText(String(routed[0].value))}`;
        const contributingSources = (row.drawdownBreakdown || []).filter((d)=>$02a659cad5e2280d$var$parseMoneyish(d?.value) > 0).map((d)=>$02a659cad5e2280d$var$sanitizeText(d?.label || '')).filter(Boolean);
        if (contributingSources.length > 1) return `Deficit funded from ${contributingSources.length} accounts`;
        const source = contributingSources[0] || 'liquid assets';
        return `Deficit funded from ${source}`;
    }
    const preferred = (row.assets?.bankAccounts || []).find((a)=>$02a659cad5e2280d$var$toNumber(a?.value || a?.balance) > 0);
    if (preferred) return `Surplus directed to ${$02a659cad5e2280d$var$sanitizeText(preferred.description || preferred.name || 'Bank Account')}`;
    return 'Surplus retained in portfolio';
}
/** Matches Deep Dive Overall Opportunity Cost: Year 1 investment income from snapshots (do nothing − selected). */ function $02a659cad5e2280d$var$estimateInvestmentEarningsLikeApp(selectedScenario, doNothingScenario) {
    const selectedY1 = $02a659cad5e2280d$var$toNumber(selectedScenario?.snapshot?.investmentIncome);
    const doNothingY1 = $02a659cad5e2280d$var$toNumber(doNothingScenario?.snapshot?.investmentIncome);
    return doNothingY1 - selectedY1;
}
function $02a659cad5e2280d$var$superNomLabel(v) {
    if (v === 'binding') return 'Binding nomination';
    if (v === 'non_binding') return 'Non-binding nomination';
    if (v === 'none') return 'None in place';
    return $02a659cad5e2280d$export$57a9131fd362a631(v);
}
function $02a659cad5e2280d$var$buildEstatePlanningBodyHtml(snapshot) {
    const f = snapshot.familyEstate || {};
    const clientFirst = $02a659cad5e2280d$var$sanitizeText(snapshot.clientName.split(/\s+/)[0] || 'Client');
    const partnerFirst = snapshot.partnerName ? $02a659cad5e2280d$var$sanitizeText(snapshot.partnerName.split(/\s+/)[0]) : '';
    const clientCol = clientFirst;
    const partnerCol = partnerFirst || "\u2014";
    const missingWill = [
        'no',
        'unsure'
    ].includes(f.clientWill || '') || [
        'no',
        'unsure'
    ].includes(f.partnerWill || '');
    const missingEpoa = [
        'no',
        'unsure'
    ].includes(f.clientEpoa || '') || [
        'no',
        'unsure'
    ].includes(f.partnerEpoa || '');
    const showStatePicker = missingWill || missingEpoa;
    const picker = showStatePicker ? `<div class="state-picker card-inset">
<p class="small" style="margin-top:0"><strong>Estate planning legal pathways (by state/territory)</strong></p>
<label class="sel-label" for="estateStateSel">State or territory</label>
<select id="estateStateSel" class="sel-state">
<option value="">Select\u{2026}</option>
<option value="NSW">New South Wales</option>
<option value="VIC">Victoria</option>
<option value="QLD">Queensland</option>
<option value="WA">Western Australia</option>
<option value="SA">South Australia</option>
<option value="TAS">Tasmania</option>
<option value="NT">Northern Territory</option>
<option value="ACT">Australian Capital Territory</option>
</select>
<div id="estateStateLinks" class="state-links small"></div>
</div>` : '';
    const implications = [];
    const actions = [];
    if (missingWill) {
        implications.push('One or more Wills are missing or uncertain. If not resolved, intestacy rules may determine asset distribution rather than your intended outcomes.');
        actions.push('Arrange a solicitor appointment to prepare or validate Wills for each relevant person.');
    }
    if (missingEpoa) {
        implications.push('Without an EPOA, family members may need tribunal/court intervention to make financial decisions if capacity is lost.');
        actions.push('Put EPOA documents in place while capacity exists and provide copies to trusted family members.');
    }
    const missingSuperNoms = !f.clientSuperNom || f.clientSuperNom === 'none' || partnerFirst && (!f.partnerSuperNom || f.partnerSuperNom === 'none');
    if (missingSuperNoms) {
        implications.push('Missing super death benefit nominations can delay benefit payment and may leave final beneficiary decisions to trustee discretion.');
        actions.push('Update super death benefit nominations (binding where appropriate) and diarise renewal/review dates.');
    }
    if (f.complexDynamics === true || f.unevenAssistance === true) {
        implications.push('Complex family dynamics and/or unequal financial support may increase the risk of estate disputes without clear documentation.');
        actions.push('Record a clear statement of wishes and have your estate documents reviewed for challenge risk.');
    }
    if (f.childrenCount != null) implications.push(`Children/dependants noted in fact-find: ${$02a659cad5e2280d$var$sanitizeText(String(f.childrenCount))}.`);
    if (implications.length === 0) implications.push('No critical estate-planning gaps were detected from the current responses; ongoing review remains important.');
    // What this plan does to the estate in practice (owner, 9 Oct 2026: the actions box printed
    // empty where nothing was missing). Facts, beside the actions, whatever is or is not missing.
    const worthConsidering = (0, $2411d79164c394f6$export$3583f111d01ddb92)({
        radPaid: $02a659cad5e2280d$var$toNumber(snapshot.radPaid),
        leavesVillage: !!snapshot.villageExit,
        hasSuper: (snapshot.situation?.assetsByType || []).some((r)=>/super|account.based/i.test(String(r.type))),
        hasEpoa: f.clientEpoa === 'yes' && (!partnerFirst || f.partnerEpoa === 'yes'),
        planSells: snapshot.radFundingRows.length > 0,
        moneyWords: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)
    });
    const tableHtml = `
<table>
<thead><tr><th>Estate directive</th><th>${clientCol}</th><th>${partnerCol}</th></tr></thead>
<tbody>
<tr><td><strong>Will</strong></td><td>${$02a659cad5e2280d$var$ynRecordLabel(f.clientWill)}</td><td>${partnerFirst ? $02a659cad5e2280d$var$ynRecordLabel(f.partnerWill) : "\u2014"}</td></tr>
<tr><td><strong>Enduring Power of Attorney (EPOA)</strong></td><td>${$02a659cad5e2280d$var$ynRecordLabel(f.clientEpoa)}</td><td>${partnerFirst ? $02a659cad5e2280d$var$ynRecordLabel(f.partnerEpoa) : "\u2014"}</td></tr>
<tr><td><strong>Advanced Care Directive (ACD)</strong></td><td>${$02a659cad5e2280d$var$ynRecordLabel(f.clientAcd)}</td><td>${partnerFirst ? $02a659cad5e2280d$var$ynRecordLabel(f.partnerAcd) : "\u2014"}</td></tr>
<tr><td><strong>Super death benefit nomination</strong></td><td>${$02a659cad5e2280d$var$superNomLabel(f.clientSuperNom)}</td><td>${partnerFirst ? $02a659cad5e2280d$var$superNomLabel(f.partnerSuperNom) : "\u2014"}</td></tr>
</tbody>
</table>`;
    const legalHtml = '<div class="callout callout--slate"><p class="callout-title">Legal note</p><p><strong>This Statement of Advice is not legal advice.</strong> It does not prepare Wills, powers of attorney, binding death benefit nominations, or trusts. A qualified solicitor should draft or amend those documents.</p></div>';
    const implicationsHtml = `<div class="callout callout--slate"><p class="callout-title">Implications from your responses</p><ul class="riskList">${implications.map((x)=>`<li>${x}</li>`).join('')}</ul></div>`;
    const actionsHtml = actions.length ? `<div class="callout callout--amber"><p class="callout-title">Recommended actions</p><ul class="riskList">${actions.map((x)=>`<li>${x}</li>`).join('')}</ul></div>` : '';
    const worthConsideringHtml = `<div class="callout callout--slate"><p class="callout-title">Worth considering as the plan is carried out</p><ul class="riskList">${worthConsidering.map((x)=>`<li>${x}</li>`).join('')}</ul></div>`;
    return `${tableHtml}${implicationsHtml}${actionsHtml}${worthConsideringHtml}${picker}${legalHtml}`;
}
/** Back from the snapshot's escaped text to plain words, for the kit's pieces that escape for themselves. */ function $02a659cad5e2280d$var$plainText(value) {
    return String(value ?? '').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'");
}
function $02a659cad5e2280d$var$buildHtml(snapshot) {
    const period = (0, $48fd3f316ae581a6$export$f15392dd2f17ee04)(snapshot.projectionPeriodMode);
    const careTimingSentence = $02a659cad5e2280d$var$careAndSaleTimingSentence(snapshot);
    // The staleness safeguard's third and most important surface: this document is emailed, printed
    // and read weeks after the session that produced it, so the notice must travel INSIDE it. Same
    // single date as the build tripwire and the Assumptions page — refresh the tables, move
    // RATES_REVIEW_BY, and all three go quiet together.
    const ratesReview = (0, $d92bca4a6da5b591$export$83e0daeeac89884f)();
    const ratesReviewNoticeHtml = ratesReview.notice ? `<li><strong>Rates currency</strong> \u{2014} ${$02a659cad5e2280d$var$sanitizeText(ratesReview.notice)}</li>` : '';
    const mountainA = (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1559827260-dc66d52bef19', 1920, 1080);
    const mountainB = (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1506905925346-21bda4d32df4', 1920, 1080);
    const primaryStrategyCards = Array.isArray(snapshot.optimalStrategyCardsPrimary) && snapshot.optimalStrategyCardsPrimary.length > 0 ? snapshot.optimalStrategyCardsPrimary : snapshot.optimalStrategyCards || [];
    const conditionalStrategyCards = Array.isArray(snapshot.optimalStrategyCardsConditional) ? snapshot.optimalStrategyCardsConditional : [];
    const renderOptCardHtml = (card)=>{
        const legacyLabel = card.legacyMetricLabel || 'Legacy (modelled)';
        const statusPill = card.selected ? '<span class="pill-selected">Your selection</span>' : '<span class="pill-not-selected">Shown for comparison \u2014 not selected</span>';
        const kindClass = card.cardKind === 'partner_later' || card.cardKind === 'lower_rad' ? 'opt-card--conditional' : '';
        return `
<div class="opt-card ${card.selected ? 'opt-card--selected' : ''} ${kindClass}">
  <div class="opt-card-head">
    <div class="opt-tag">${card.objectiveLabel}</div>
    <div class="opt-card-status">${statusPill}</div>
  </div>
  <h3 class="opt-title">${card.name}</h3>
  <div class="opt-card-main">
    <p class="opt-narr">${card.narrative || 'Outcome driven by your fact-find and the funding mix modelled for this objective.'}</p>
    ${card.horizonWarning ? `<div class="callout callout--amber"><p class="callout-title">Worth knowing</p><p>${$02a659cad5e2280d$var$sanitizeText(card.horizonWarning)}</p></div>` : ''}
    <div class="opt-metrics">
      <div class="opt-metric-line"><span class="muted small">${legacyLabel}</span><strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(card.legacy)}</strong></div>
      <div class="opt-metric-line"><span class="muted small">Cashflow / year</span><strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(card.cashflow)}</strong></div>
      <div class="opt-metric-line"><span class="muted small">Age Pension / year</span><strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(card.pension)}</strong></div>
    </div>
  </div>
  <details class="opt-funding">
    <summary>How this strategy funds the RAD</summary>
    ${card.fundingRows && card.fundingRows.length > 0 ? `<ul class="tip-ul">${card.fundingRows.map((row)=>`<li><strong>${row.source}:</strong> ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.amount)}</li>`).join('')}</ul>` : '<p class="small muted">No dedicated RAD drawdown was required in this strategy.</p>'}
  </details>
</div>`;
    };
    const primaryCardsHtml = primaryStrategyCards.map(renderOptCardHtml).join('');
    const conditionalCardsHtml = conditionalStrategyCards.map(renderOptCardHtml).join('');
    const alternativeStrategiesLead = snapshot.strategySource === 'manual_control' ? `You confirmed <strong>${snapshot.selectedStrategyName}</strong> as your preferred strategy. The cards below show the manual strategies saved in your modelling session for side-by-side comparison.` : conditionalStrategyCards.length > 0 ? `You confirmed <strong>${snapshot.selectedStrategyName}</strong> as your preferred strategy. The first row compares baseline objectives (projected legacy, cashflow, and Age Pension). Where applicable, a second row documents optional comparison scenarios from your modelling session\u{2014}each labelled so it is clear what was illustrated and whether it was your selection.` : `You confirmed <strong>${snapshot.selectedStrategyName}</strong> as your preferred strategy. The three cards below show the strongest alternatives by objective (legacy, cashflow, and Age Pension) so the trade-offs are clear and documented.`;
    const alternativeStrategiesGrids = conditionalStrategyCards.length > 0 ? `<div class="opt-section">
<div class="opt-section-label">Baseline objective comparison</div>
<div class="opt-grid">${primaryCardsHtml}</div>
</div>
<div class="callout callout--slate opt-conditional-intro">
<p class="callout-title">Additional comparison scenarios</p>
<p class="small" style="margin:0">These optional cards mirror lenses available in AgedCareWise (for example a partner entering care later, or a lower-RAD option when baseline legacy outcomes are close). Your confirmed strategy is marked <strong>Your selection</strong> on the relevant card. Any other card in this section is labelled <strong>Shown for comparison \u{2014} not selected</strong> so it is clear what was presented in the tool.</p>
</div>
<div class="opt-section">
<div class="opt-section-label">Additional scenarios (optional lenses)</div>
<div class="opt-grid opt-grid--2">${conditionalCardsHtml}</div>
</div>` : `<div class="opt-grid">${primaryCardsHtml}</div>`;
    const hasOutOfScopeGoals = (snapshot.outOfScopeGoals || []).length > 0;
    const outOfScopeSet = new Set(snapshot.outOfScopeGoals || []);
    const goalsBlock = (snapshot.statedGoals || []).length > 0 ? `<ul class="goalsList">${snapshot.statedGoals.map((g)=>`<li>${g}${outOfScopeSet.has(g) ? ' <span class="muted small">(not covered by this SOA)</span>' : ''}</li>`).join('')}</ul>` : '<p class="lede muted">Where you did not tick structured goals in the fact-find, this advice still reflects your financial inputs and the strategy mix we modelled.</p>';
    const outOfScopeGoalScopeLine = hasOutOfScopeGoals ? `<li>Living arrangement goals recorded in your fact-find but not selected as the advice pathway in this document (${snapshot.outOfScopeGoals.map((g)=>$02a659cad5e2280d$var$sanitizeText(g)).join(', ')}).</li>` : '';
    const moduleSpecificScopeLine = hasOutOfScopeGoals ? '<li>For goals marked as not covered in this SOA, re-run modelling in the relevant module and produce a module-specific SOA when available.</li>' : '';
    const mixedHouseholdScopeLine = hasOutOfScopeGoals && snapshot.isCoupleAdvice && (snapshot.outOfScopeGoals || []).includes('Access home care support') ? '<li>Where one partner may enter residential aged care and the other may remain at home with Support at Home services, complete pathway-specific modelling in the Support at Home module and issue a separate module-specific SOA when that pathway is available.</li>' : '';
    const pathCompareBlock = snapshot.pathComparison ? `<div class="callout callout--blue">
<p class="callout-title">Compared to a \u{201C}do nothing\u{201D} scenario (same room price, same expense profile)</p>
<p>This is a like-for-like comparison: both your selected strategy and the do-nothing baseline use the same room price and expense settings. The differences shown are from the funding choices, not from changing the underlying care assumptions.</p>
<p class="small muted">Figures below are model outputs only; they are not guarantees of future balances or entitlements.</p>
${$02a659cad5e2280d$export$4a508eeca5997a18(snapshot.pathComparison)}
</div>` : '<p class="muted">A comparable \u201Cdo nothing\u201D baseline was not in this modelling run, so numeric comparisons to that benchmark are not shown.</p>';
    const deficitFundingCallout = snapshot.cashflowIsNegative && snapshot.deficitFundingNarrative ? `<div class="callout callout--amber"><p class="callout-title">How the cashflow shortfall is funded in the model</p><p>A cashflow deficit means the assets are not generating sufficient income to meet expenses. It only becomes problematic if liquid assets become insufficient to meet those costs.</p><p>${snapshot.deficitFundingNarrative}</p>${snapshot.fundingRunway ? `<p><strong>How long the money lasts:</strong> ${$02a659cad5e2280d$var$sanitizeText(snapshot.fundingRunway.headline)} \u{2014} ${$02a659cad5e2280d$var$sanitizeText(snapshot.fundingRunway.basis.toLowerCase())}${snapshot.fundingRunway.flag ? ` ${$02a659cad5e2280d$var$sanitizeText(snapshot.fundingRunway.flag)}` : ''}</p>` : ''}</div>` : snapshot.cashflowIsNegative ? '<div class="callout callout--amber"><p class="callout-title">Cashflow shortfall</p><p class="muted">The selected strategy shows a projected cashflow shortfall; detailed drawdown lines were not attached to this export.</p></div>' : '';
    const projectionTableBody = $02a659cad5e2280d$var$buildProjectionTableBodyFromSnapshot(snapshot);
    const projectionHowToReadHtml = `<details class="soa-proj-howto"><summary>How to read this</summary><div class="soa-proj-howto-body"><p class="small muted">These projections are <strong>illustrative only</strong>. They can change with the timing of your strategy, investment returns, and future threshold or rule changes.</p><p class="small muted" style="margin-top:10px"><strong>Comparison Yr1</strong> shows full-year rates for the first projection year \u{2014} a <strong>normalised year</strong>, the same basis as the Financial Impact panel \u{2014} so strategies can be compared like-for-like without the timing of events getting in the way. In real life, your first ${period.noun} is often only partly on the new strategy${period.differsFromTaxYear ? '' : ', which is why we show the optional full financial year below: a separate estimate that combines the before- and after-strategy positions within the year (day-weighted; illustrative only)'}. Where a future care start date is set, rates before that date reflect the position at home, and the year care begins blends the two.</p></div></details>`;
    const projectionDeficitContext = snapshot.cashflowAnalysisSummary?.hasDeficitYears ? `<div class="callout callout--blue">
<p class="callout-title">Interpreting modelled deficits</p>
<p>Some years show a cashflow deficit. This is common in aged care modelling and does not automatically mean the strategy fails. The key test is whether those shortfalls can be funded from available assets over time. In this model, the <strong>Surplus/Deficit</strong> column shows the planned funding path for each year.</p>
</div>` : '';
    const estateBodyHtml = $02a659cad5e2280d$var$buildEstatePlanningBodyHtml(snapshot);
    const invDelta = snapshot.opportunityCost ? Number(snapshot.opportunityCost.investmentEarningsLost) || 0 : 0;
    const opportunityCostInvKpiClass = invDelta > 0 ? 'kpi kpi--warn' : invDelta < 0 ? 'kpi kpi--gain' : 'kpi';
    const opportunityCostPanel = snapshot.opportunityCost ? `<div class="grid4">
<div class="${opportunityCostInvKpiClass}"><div class="label">Investment income, a year, against paying daily</div><div class="value">${$02a659cad5e2280d$export$79abd5af043a4a00(invDelta)}</div></div>
<div class="kpi"><div class="label">Age Pension impact / year</div><div class="value">${$02a659cad5e2280d$var$formatDeltaCurrency(snapshot.opportunityCost.agePensionImpact)}</div></div>
<div class="kpi"><div class="label">Care costs saved / year</div><div class="value">${$02a659cad5e2280d$var$formatDeltaCurrency(snapshot.opportunityCost.careCostsSaved)}</div></div>
<div class="kpi"><div class="label">Estate impact (modelled)</div><div class="value">${$02a659cad5e2280d$var$formatDeltaCurrency(snapshot.opportunityCost.estateImpact)}</div></div>
</div>
<p class="small muted" style="margin-top:10px">Investment income uses Comparison Yr1 totals from projections (same basis as the app\u{2019}s Yearly Projections).</p>` : '<p class="small muted">A comparable do-nothing run was not attached, so overall opportunity cost is not shown in this export.</p>';
    // The village's exit payment and a current room's refund come first (9 Oct 2026).
    const radFundingCards = [
        ...snapshot.radFundingPrelude,
        ...snapshot.radFundingRows
    ];
    const radFundingExecCards = radFundingCards.length > 0 ? `<div class="rad-card-grid">${radFundingCards.map((row)=>`<div class="rad-card">
<div class="rad-type">${row.assetType}</div>
<div class="rad-source">${row.source}</div>
<div class="rad-amount">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.amount)}</div>
</div>`).join('')}</div>` : '<p class="small muted">No dedicated asset liquidation was required for RAD funding in this strategy.</p>';
    const firstPensionLines = snapshot.enrichedProjections?.[0]?.pensionBreakdown || [];
    const thresholdRows = firstPensionLines.filter((x)=>/limit|threshold|test/i.test(String(x?.label || ''))).map((x)=>`<tr><td>${$02a659cad5e2280d$var$sanitizeText(String(x.label || 'Pension setting'))}</td><td>${$02a659cad5e2280d$var$sanitizeText(String(x.value ?? 'Not available'))}</td><td>Derived from the model's year-1 social security breakdown</td></tr>`).join('');
    const cashflowKpiClass = snapshot.cashflowIsNegative ? 'kpi kpi--warn' : 'kpi';
    return `<!doctype html><html><head><meta charset="utf-8"/><meta name="viewport" content="width=device-width,initial-scale=1"/>
<title>Statement of Advice - ${snapshot.clientName}</title>
<style>
:root{--ink:#0f172a;--muted:#64748b;--line:#e2e8f0;--card:#fff;--accent:#2563eb;--accent2:#4f46e5;--warn-bg:#fff7ed;--warn-border:#fdba74;--warn-ink:#9a3412;--radius:16px;--shadow:0 14px 40px rgba(15,23,42,.08)}
body{margin:0;font-family:Inter,Segoe UI,system-ui,sans-serif;background:var(--ink);color:var(--ink);line-height:1.55}
.cover{min-height:100vh;display:flex;align-items:center;justify-content:center;position:relative;overflow:hidden}
.cover::before{content:'';position:absolute;inset:0;background-image:url('${mountainA}');background-size:cover;background-position:center;opacity:.38;animation:moveA 28s ease-in-out infinite}
.cover::after{content:'';position:absolute;inset:0;background-image:url('${mountainB}');background-size:cover;background-position:center;opacity:.22;animation:moveB 34s ease-in-out infinite}
.coverShade{position:absolute;inset:0;background:radial-gradient(120% 80% at 30% 20%,rgba(37,99,235,.45),rgba(15,23,42,.88))}
.coverBox{position:relative;z-index:1;max-width:1040px;width:88%;background:rgba(255,255,255,.12);border:1px solid rgba(255,255,255,.35);border-radius:28px;padding:40px 36px;color:#fff;backdrop-filter:blur(8px);box-shadow:0 24px 80px rgba(0,0,0,.35)}
.coverKicker{font-size:12px;letter-spacing:.22em;text-transform:uppercase;opacity:.9}
.coverTitle{font-size:clamp(36px,6vw,58px);line-height:1.05;font-weight:900;margin:10px 0 8px}
.clientNames{font-size:clamp(22px,3.5vw,32px);font-weight:700}
.meta{display:flex;flex-wrap:wrap;gap:8px;margin-top:18px}
.meta span{font-size:11px;padding:8px 12px;border-radius:999px;background:rgba(255,255,255,.16);border:1px solid rgba(255,255,255,.4)}
.openBtn{margin-top:26px;padding:14px 22px;border-radius:14px;border:none;font-weight:800;cursor:pointer;background:#fff;color:var(--ink);font-size:15px;box-shadow:0 8px 24px rgba(0,0,0,.2);transition:transform .15s ease}
.openBtn:hover{transform:translateY(-2px)}
.book{background:linear-gradient(180deg,#eef2ff 0%,#f8fafc 18%);max-width:1200px;margin:0 auto;padding:28px 20px 48px;scroll-margin-top:0;min-height:100vh}
#soa-document{scroll-margin-top:0}
.topNav{position:sticky;top:0;background:rgba(255,255,255,.92);border:1px solid var(--line);border-radius:14px;padding:10px 12px;display:flex;justify-content:space-between;align-items:center;z-index:40;backdrop-filter:blur(10px);box-shadow:var(--shadow);margin-bottom:18px}
.topNav .buttons{display:flex;gap:8px;flex-wrap:wrap}
.topNav button{padding:9px 14px;min-width:90px;border:1px solid #c7d2fe;background:linear-gradient(180deg,#fff,#f1f5ff);border-radius:10px;cursor:pointer;font-weight:700;font-size:13px;color:var(--ink)}
.topNav button:hover{border-color:var(--accent);color:var(--accent)}
.pager{font-size:12px;font-weight:700;color:var(--muted)}
.topNav .navEnd{display:flex;align-items:center;gap:12px;flex-wrap:wrap;justify-content:flex-end}
.topNav .printBtn{border-color:var(--navy,#001E7A);color:var(--navy,#001E7A)}
.page{display:none;animation:fadeIn .35s ease}
.page.active{display:block}
@keyframes fadeIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}
.card{background:var(--card);border:1px solid var(--line);border-radius:var(--radius);padding:26px 24px;margin-top:14px;box-shadow:var(--shadow);position:relative;overflow:visible}
.card::before{content:'';position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,#6366f1,#3b82f6);opacity:.9}
.h2{font-size:26px;font-weight:900;margin:0 0 12px;letter-spacing:-.02em}
.h3{font-size:17px;font-weight:800;margin:22px 0 10px;color:#1e293b}
.lede{font-size:16px;margin:10px 0 14px}
.muted{color:var(--muted)}.small{font-size:13px}.tiny{font-size:12px}
.goalsList{margin:8px 0 16px;padding-left:20px}
.goalsList li{margin:6px 0}
.grid4{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:12px}
.kpi{background:linear-gradient(180deg,#f8fafc,#fff);border:1px solid var(--line);border-radius:12px;padding:14px 12px}
.kpi--warn{background:var(--warn-bg);border-color:var(--warn-border)}
.kpi--warn .value{color:var(--warn-ink)}
.kpi--gain{background:#ecfdf5;border-color:#a7f3d0}
.kpi--gain .value{color:#047857}
.label{font-size:11px;color:var(--muted);text-transform:uppercase;letter-spacing:.06em;font-weight:700}
.value{font-size:24px;font-weight:900;margin-top:4px}
.callout{border-radius:14px;padding:16px 18px;margin:16px 0}
.callout--blue{background:#eff6ff;border:1px solid #bfdbfe}
.callout--amber{background:#fffbeb;border:1px solid #fcd34d}
.callout--slate{background:#f8fafc;border:1px solid #e2e8f0}
.callout-title{font-weight:800;margin:0 0 8px;font-size:15px}
.card-inset{background:#fff;border:1px dashed #cbd5e1;border-radius:12px;padding:14px 16px;margin:14px 0}
.state-picker .sel-label{display:block;font-size:12px;font-weight:700;margin-bottom:6px;color:#475569}
.sel-state{width:100%;max-width:320px;padding:10px 12px;border-radius:10px;border:1px solid var(--line);font-size:14px;background:#fff}
.state-links{margin-top:10px;line-height:1.6}
.state-links a{color:var(--accent);font-weight:700}
.estate-alert{background:#fef2f2;border-left:4px solid #f87171;padding:12px 14px;border-radius:0 10px 10px 0}
.tip-ul{margin:8px 0 2px 16px;padding:0;color:#334155;line-height:1.45;max-height:220px;overflow:auto}
.td-num{vertical-align:top;min-width:120px}
.proj-year{white-space:nowrap;font-weight:700;color:#1f2937}
/* The figure is the trigger: a faint dotted underline, the working opens under it on hover, focus or tap (owner, 24 Oct 2026). */
.metric-cell{position:relative;display:inline-block;cursor:help;text-decoration:underline dotted #94a3b8;text-decoration-thickness:1.5px;text-underline-offset:4px;outline:none}
.metric-cell:hover,.metric-cell:focus-visible{text-decoration-color:#2563eb}
.cc-tip{position:absolute;left:50%;top:calc(100% + 10px);transform:translateX(-50%);width:max-content;min-width:240px;max-width:min(360px,90vw);padding:12px 14px;border-radius:12px;border:0;background:#0F2A4A;color:#fff;box-shadow:0 14px 34px rgba(15,42,74,.35);font-size:12px;line-height:1.35;font-weight:400;display:none;z-index:60;text-align:left;white-space:normal;cursor:auto}
.cc-tip::before{content:"";position:absolute;top:-5px;left:50%;width:10px;height:10px;background:#0F2A4A;transform:translateX(-50%) rotate(45deg)}
.cc-tip.up{top:auto;bottom:calc(100% + 10px)}
.cc-tip.up::before{top:auto;bottom:-5px}
.cc-tip strong{display:block;color:#7dd3fc;margin-bottom:8px;font-size:13px}
/* Labels wrap, figures never do; the box sizes to its longest line (owner, 24 Oct 2026: figures spilled out). */
.tip-row{display:grid;grid-template-columns:minmax(0,1fr) auto;align-items:baseline;gap:12px;padding:2px 0}
.tip-lbl{color:#cbd5e1;min-width:0;overflow-wrap:anywhere}
.tip-val{color:#ffffff;font-weight:700;white-space:nowrap;text-align:right;font-variant-numeric:tabular-nums}
.table-proj td:last-child .cc-tip{left:auto;right:0;transform:none}
.table-proj td:last-child .cc-tip::before{left:auto;right:14px;transform:rotate(45deg)}
.metric-cell:hover .cc-tip,.metric-cell:focus .cc-tip,.metric-cell:focus-within .cc-tip,.metric-cell.is-open .cc-tip{display:block}
/* Age Pension breakdown: No plan beside This plan */
.pb-table .pb-num{text-align:right;white-space:nowrap;font-variant-numeric:tabular-nums}
.pb-table th.pb-plan{color:#001E7A;border-bottom:3px solid #001E7A}
.pb-table td.pb-plan{color:#001E7A;font-weight:700}
.pb-dot{display:inline-block;width:7px;height:7px;border-radius:999px;background:#2563eb;margin-right:7px;vertical-align:middle}
.age-pos{color:#16a34a}
.age-neg{color:#dc2626}
.rad-card-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:10px;margin:10px 0 14px}
.rad-card{border:1px solid var(--line);border-radius:12px;background:#fff;padding:12px}
.rad-type{font-size:10px;letter-spacing:.08em;text-transform:uppercase;font-weight:800;color:#64748b}
.rad-source{font-size:13px;font-weight:700;color:#0f172a;margin-top:4px}
.rad-amount{font-size:20px;font-weight:900;color:#2563eb;margin-top:6px}
.imp-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(260px,1fr));gap:12px;margin-top:10px}
.imp-card{border:1px solid #dbeafe;background:#f8fbff;border-radius:12px;padding:14px}
.imp-title{font-size:14px;font-weight:800;color:#1e3a8a;margin:0 0 8px}
.imp-lead{font-size:13px;color:#0f172a;margin:0 0 6px}
.imp-body{font-size:13px;color:#334155;margin:0}
.yr-badge{display:inline-block;background:linear-gradient(135deg,#4f46e5,#2563eb);color:#fff;font-size:11px;font-weight:900;padding:4px 10px;border-radius:999px}
.table-proj{font-variant-numeric:tabular-nums}
.table-proj .td-num{white-space:nowrap}
.table-proj tbody tr.proj-tr-data.proj-zebra{background:#fafafa}
.soa-proj-howto{margin:0 0 14px;border:1px solid var(--line);border-left:3px solid var(--accent);background:#fff;border-radius:0 12px 12px 0;padding:0;overflow:hidden}
.soa-proj-howto summary{cursor:pointer;font-weight:700;color:var(--ink);padding:12px 14px}
.soa-proj-howto-body{padding:0 14px 14px}
.soa-fy-details{border:1px solid var(--line);border-left:3px solid var(--accent);background:#fff;border-radius:0 10px 10px 0;margin:0;padding:0}
.soa-fy-summary{cursor:pointer;font-weight:600;color:var(--ink);padding:10px 12px}
.soa-fy-est{font-weight:400;color:var(--muted)}
.soa-fy-inner-wrap{padding:0 12px 12px}
.soa-fy-lede{margin:0 0 10px}
.table-proj-fy{width:100%;font-size:13px;margin-top:6px;border-collapse:collapse}
.table-proj-fy td{border-top:1px solid var(--line);vertical-align:top}
.proj-tr-fy-wrap td{border-bottom:none;padding:8px 0 12px;background:transparent !important}
.proj-tr-fy-data td{background:#f8fafc !important;border-bottom:1px solid var(--line)}
.block{display:block}
.proj-cmp-label{display:block;font-size:14px}
.proj-tabs{display:flex;gap:18px;border-bottom:1px solid #e5e7eb;margin:8px 0 14px}
.proj-tab{appearance:none;border:none;background:none;padding:10px 0;color:#6b7280;font-weight:600;font-size:14px;cursor:pointer;border-bottom:2px solid transparent}
.proj-tab.active{color:#2563eb;border-bottom-color:#3b82f6}
.proj-panel{display:none}
.proj-panel.active{display:block}
.section-ribbon{height:4px;border-radius:99px;background:linear-gradient(90deg,#4f46e5,#2563eb,#06b6d4);margin-bottom:16px}
.scope-grid{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-top:12px}
.scope-in{background:#ecfdf5;border:1px solid #6ee7b7;border-radius:12px;padding:14px}
.scope-out{background:#fef2f2;border:1px solid #fecaca;border-radius:12px;padding:14px}
.scope-in h4,.scope-out h4{margin:0 0 8px;font-size:13px;text-transform:uppercase;letter-spacing:.06em}
.scope-in ul,.scope-out ul{margin:0;padding-left:18px;font-size:14px}
.nav-dots{display:flex;gap:4px;align-items:center;margin-left:8px}
.nav-dot{width:6px;height:6px;border-radius:99px;background:#cbd5e1}
.nav-dot.on{background:var(--accent);box-shadow:0 0 0 2px rgba(37,99,235,.25)}
.opt-section{margin-top:6px}
.opt-section-label{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:.07em;color:#64748b;margin:18px 0 10px}
.opt-conditional-intro{margin-top:8px !important}
.opt-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:14px;margin-top:14px;align-items:stretch}
.opt-grid--2{grid-template-columns:repeat(2,minmax(0,1fr));gap:14px;margin-top:10px;align-items:stretch}
.opt-grid>.opt-card{height:100%}
.opt-card{border:1px solid var(--line);border-radius:14px;padding:16px;background:#fafafa;transition:box-shadow .2s,border-color .2s,transform .2s;display:flex;flex-direction:column;min-height:100%;box-sizing:border-box}
.opt-card:hover{box-shadow:var(--shadow);transform:translateY(-2px)}
.opt-card--selected{border-color:#818cf8;background:linear-gradient(160deg,#eef2ff,#fff);box-shadow:0 12px 36px rgba(79,70,229,.15)}
.opt-card--conditional{border-left:4px solid #0d9488;background:linear-gradient(152deg,#f0fdfa 0%,#fafafa 55%)}
.opt-card-head{display:flex;flex-direction:column;align-items:flex-start;gap:8px;margin-bottom:8px;width:100%}
.opt-card-head .opt-tag{display:inline-block;font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:.08em;color:var(--accent);background:#eff6ff;padding:4px 8px;border-radius:999px;max-width:100%}
.opt-card-status{display:block;width:100%}
.opt-card-status .pill-selected,.opt-card-status .pill-not-selected{display:inline-block;vertical-align:middle}
.pill-not-selected{font-size:10px;font-weight:800;background:#e2e8f0;color:#475569;padding:4px 10px;border-radius:999px;letter-spacing:.02em}
.opt-title{font-size:16px;margin:0 0 10px;font-weight:800;line-height:1.25}
.pill-selected{font-size:10px;font-weight:800;background:#22c55e;color:#fff;padding:4px 10px;border-radius:999px;letter-spacing:.02em}
.opt-card-main{flex:1 1 auto;display:flex;flex-direction:column;min-height:0}
.opt-narr{font-size:14px;color:#475569;margin:0 0 0;flex:1 1 auto;line-height:1.45}
.opt-metrics{margin-top:auto;padding-top:14px;border-top:1px solid #e2e8f0;flex-shrink:0;display:grid;grid-template-columns:1fr;gap:8px;font-size:14px}
.opt-metric-line{display:flex;justify-content:space-between;align-items:baseline;gap:12px}
.opt-metric-line strong{font-size:22px;line-height:1.2;white-space:nowrap}
.opt-funding{margin-top:10px;flex-shrink:0}
.opt-funding summary{cursor:pointer;font-weight:700;color:#334155}
.riskList{margin:0;padding-left:20px}
.riskList li{margin:10px 0}
table{width:100%;border-collapse:collapse;font-size:14px}
th,td{padding:11px 10px;border-bottom:1px solid var(--line);text-align:left}
th{background:#f1f5f9;font-weight:800;font-size:12px;text-transform:uppercase;letter-spacing:.04em;color:#475569}
details{margin:10px 0;border:1px solid var(--line);border-radius:12px;padding:12px;background:#fafafa}
details.inline-tip{margin:8px 0 0 0;padding:8px 10px}
.factSection{margin-top:8px}.factRow{display:grid;grid-template-columns:minmax(0,320px) 1fr;padding:10px 8px;border-bottom:1px solid #f1f5f9;gap:12px}.factLabel{font-weight:700;color:#334155;font-size:13px}
pre{white-space:pre-wrap;background:var(--ink);color:#e2e8f0;padding:14px;border-radius:10px;max-height:280px;overflow:auto;font-size:11px}
@keyframes moveA{0%,100%{transform:scale(1) translate(0,0)}50%{transform:scale(1.09) translate(-14px,-12px)}}
@keyframes moveB{0%,100%{transform:scale(1) translate(0,0)}50%{transform:scale(1.06) translate(16px,14px)}}
@media (max-width:1020px){.grid4{grid-template-columns:repeat(2,minmax(0,1fr))}.opt-grid,.opt-grid--2{grid-template-columns:1fr}.scope-grid{grid-template-columns:1fr}}
@media (max-width:640px){.grid4{grid-template-columns:1fr}.factRow{grid-template-columns:1fr}}
@media print{
  @page{size:A4 portrait;margin:12mm}
  body{background:#fff !important;color:#000 !important}
  .cover{min-height:auto !important;page-break-after:always}
  .cover::before,.cover::after,.coverShade{display:none !important}
  .coverBox{background:#fff !important;color:#000 !important;border:1px solid #e5e7eb !important;box-shadow:none !important;backdrop-filter:none !important}
  .openBtn{display:none !important}
  .book{max-width:none !important;margin:0 !important;padding:0 !important;background:#fff !important}
  .topNav,.nav-dots,.pager,.buttons{display:none !important}
  .page,.page.active{display:block !important;animation:none !important;break-inside:avoid-page;page-break-inside:avoid;margin:0 0 10mm 0}
  .card{box-shadow:none !important;border:1px solid #d1d5db !important;break-inside:avoid-page;page-break-inside:avoid;background:#fff !important}
  .proj-tabs{display:none !important}
  .proj-panel{display:block !important}
  .metric-cell .cc-tip{display:none !important}
  .metric-cell{text-decoration:none}
  details{border:1px solid #d1d5db !important;background:#fff !important}
  details[open] summary{margin-bottom:6px}
  table{font-size:11px !important}
  th,td{padding:6px 6px !important}
  a[href]:after{content:" (" attr(href) ")";font-size:10px;color:#6b7280}
}
${0, $8ea663173c1a6588$export$a7aa337a60127637}
</style></head><body>
<section class="cover"><div class="coverShade"></div><div class="coverBox">
<div class="coverKicker">Statement of advice</div>
<div class="coverTitle">Your aged care funding strategy</div>
<div class="clientNames">${snapshot.clientName}${snapshot.partnerName ? ` & ${snapshot.partnerName}` : ''}</div>
<div class="meta">
${snapshot.adviceAttributionLine ? `<span>${$02a659cad5e2280d$var$escapeHtml(snapshot.adviceAttributionLine)}</span>` : '<span>AgedCareWise Pty Ltd</span><span>AFSL 401234 (Demo)</span><span>ABN 12 345 678 901 (Demo)</span>'}
<span>Report ${snapshot.reportId}</span><span>${$02a659cad5e2280d$var$formatDateOnly(snapshot.generatedAt)}</span>
<span>Source: ${snapshot.strategySource === 'manual_control' ? 'MC (Manual Control)' : 'SE (Suggestion Engine)'}</span>
${snapshot.completerDisplay ? `<span>Completed by: ${snapshot.completerDisplay}${snapshot.completerRelationship ? ` (${snapshot.completerRelationship})` : ''}</span>` : ''}
</div>
<button type="button" class="openBtn" onclick="openBooklet()">Begin reading your advice</button>
<p class="muted" style="margin-top:14px;font-size:13px;opacity:.85">Opens your Statement of Advice below \u{2014} use <strong>Next</strong> / <strong>Previous</strong> to move through each section.</p>
</div></section>
<div class="book" id="soa-document">
<div class="topNav">
  <div class="buttons">
    <button type="button" onclick="prevPage()">Previous</button>
    <button type="button" onclick="nextPage()">Next</button>
    <button type="button" data-goto="0">Contents</button>
  </div>
  <div class="navEnd"><button type="button" class="printBtn" data-print>Print or save as PDF</button><div class="pager" id="pager"></div></div>
</div>

<section class="page active"><div class="card">
<div class="h2">Executive summary</div>
${snapshot.executiveSummaryOpeningHtml || ''}
<p class="lede">${snapshot.careRecipientProfile}</p>
${snapshot.partnerContextHtml || ''}
${snapshot.wideExplorationClause || ''}
<p class="lede">${snapshot.strategySource === 'manual_control' && snapshot.customisedFrom ? `<strong>How this plan was made:</strong> you started from the suggested plan <strong>\u{201C}${snapshot.customisedFrom}\u{201D}</strong> and changed it yourself, into <strong>${snapshot.selectedStrategyName}</strong>. This Statement of Advice follows that plan through to projected outcomes.` : snapshot.strategySource === 'manual_control' ? `<strong>How this plan was made:</strong> you built <strong>${snapshot.selectedStrategyName}</strong> yourself. This Statement of Advice follows that plan through to projected outcomes.` : `<strong>How this plan was made:</strong> AgedCareWise found this plan by testing <strong>${snapshot.totalScenarios}</strong> ways to pay for the room, each measured against paying daily (the room paid daily, nothing up front, nothing sold). You chose <strong>${snapshot.selectedStrategyName}</strong>, and this Statement of Advice follows that plan through to projected outcomes.`}</p>
<p>${snapshot.selectedStrategyNarrative}</p>
${snapshot.horizonSetAsideNote ? `<p class="lede">${snapshot.horizonSetAsideNote}</p>` : ''}
${snapshot.isCoupleAdvice && snapshot.illnessSeparatedAppliesInSoa ? `<div class="callout callout--blue">
<p class="callout-title">Age Pension Treatment</p>
<p>Before this advice, the baseline model shows you were <strong>${snapshot.baselinePensionStatus}</strong> at <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.baseline.pension)} p.a.</strong>.</p>
<p>Because <strong>${$02a659cad5e2280d$var$sanitizeText(snapshot.enteringCarePersonName)}</strong> is modelled as entering residential aged care, this strategy applies <strong>illness-separated couple</strong> Age Pension treatment in the scenario.</p>
<p>Under illness-separated treatment, Centrelink may apply <strong>different couple thresholds</strong> (including higher free areas/cut-offs than a standard-couple-at-home setting), so the Age Pension result can change even before RAD/DAP choices are considered.</p>
<p>For your selected strategy, the modelled Age Pension outcome is <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.annualPension)} p.a.</strong> (${snapshot.pensionDeltaFromBaseline >= 0 ? '+' : '-'}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(snapshot.pensionDeltaFromBaseline))} vs baseline), which is consistent with being <strong>${snapshot.selectedPensionStatus}</strong> in this model.</p>
<p class="small muted"><strong>Action required:</strong> Inform Services Australia when residential aged care commences and ask them to confirm the correct couple/illness-separated treatment on your record. Final entitlement is determined by Services Australia.</p>
</div>` : ''}

<div class="callout callout--slate">
<p class="callout-title">Accommodation price (anchor for the model)</p>
<p>The room price used for our financial modelling is <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.roomCost)}</strong> with your stated expenses when moving into aged care set at <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.adjustedLivingExpenses)} per year</strong>. This sets the do-nothing baseline, and all funding strategy options are then compared against that same baseline.</p>
</div>

<div class="h3">What you told us you are trying to achieve</div>
${goalsBlock}
<div class="h3">Snapshot of modelled outcomes</div>
<p>These are the headline results for your selected strategy. The projection section below shows what happens year by year.</p>

<div class="grid4">
<div class="kpi"><div class="label">Room price (accommodation)</div><div class="value">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.roomCost)}</div></div>
<div class="kpi"><div class="label">Projected legacy</div><div class="value">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.projectedLegacy)}</div></div>
<div class="kpi"><div class="label">Age Pension / year</div><div class="value">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.annualPension)}</div></div>
<div class="${cashflowKpiClass}"><div class="label">Cashflow / year</div><div class="value">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.annualCashflow)}</div></div>
</div>

${deficitFundingCallout}

<div class="h3">How the RAD is funded in this strategy</div>
<p class="small muted">${snapshot.radFundingPrelude.length ? 'The deposit is funded from the following, in this order: money the plan already has coming first, then what is sold at entry.' : 'At entry to care, the model funds the RAD from the following assets.'}</p>
${radFundingExecCards}

${pathCompareBlock}
<div class="h3">In this document</div>
<div id="soa-toc-slot"></div>
</div></section>

<section class="page"><div class="card">
<div class="h2">Scope of advice</div>
<p>This section sets clear boundaries for you: what this advice covers, what it does not, and where you still need specialist input (for example legal documents or tax implementation).</p>
<div class="scope-grid">
<div class="scope-in">
<h4>In scope</h4>
<ul>
<li>High-level pathways for funding <strong>residential aged care</strong> (RAD, DAP, hybrid) and how they interact with modelled assets, income, and Age Pension outcomes.</li>
<li>Scenario comparison across combinations you enabled (e.g. home retained, rented, downsized) and RAD/DAP mixes, using the assumptions in the appendix.</li>
<li>Illustrative <strong>cashflow, pension, care-fee and net-worth projections</strong> \u{2014} not forecasts of actual future balances.</li>
<li>Education on how means-tested care components are <strong>estimated</strong> in the tool (subject to formal assessment by Services Australia and the provider).</li>
<li>General <strong>estate planning guidance</strong> based on your stated estate position (for example Will/EPOA status and practical implications where documents are missing).</li>
<li><strong>How the years are shown:</strong> the numbers appear in two ways. The <strong>annual position</strong> (Comparison Year 1 in the strategy tables) is a normalised full year \u{2014} what a complete year looks like once this plan is in place \u{2014} so strategies can be compared without the effect of where we are in the financial year. The <strong>year-by-year projections</strong> (Projection Outlook) are the actual timeline: ${$02a659cad5e2280d$var$sanitizeText((0, $48fd3f316ae581a6$export$f2e75dede6de26ce)(snapshot.projectionPeriodMode))} ${$02a659cad5e2280d$var$sanitizeText(careTimingSentence)} Implementation timing can still vary in practice, which can create part-year differences in tax, pension and aged care results.</li>
</ul>
</div>
<div class="scope-out">
<h4>Out of scope</h4>
<ul>
${outOfScopeGoalScopeLine}
<li><strong>Specific financial product advice</strong> (e.g. recommending a particular super fund, insurance product, or security).</li>
<li>Tax, legal, or estate <strong>implementation</strong> advice \u{2014} including CGT calculations, trust structuring, or drafting Wills and powers of attorney.</li>
<li>Choosing or endorsing a <strong>particular aged care provider</strong> or room; fee quotes must come from the provider.</li>
<li>Product-provider <strong>break fees, exit fees, and surrender terms</strong> are not modelled and must be confirmed directly with providers before implementation.</li>
<li>Medical, aged care placement, or aged care needs assessment decision-making.</li>
<li>Foreign assets, complex business structures, or strategies not captured in your fact-find.${snapshot.hasDefinedBenefitPension ? ' A defined benefit pension recorded in your profile is modelled as paid, assessed and taxed; the decision to take one, or to commute one, is not.' : ''}</li>
${moduleSpecificScopeLine}
${mixedHouseholdScopeLine}
</ul>
</div>
</div>
<p class="small muted">If your circumstances fall outside these boundaries, update the fact-find or seek a qualified specialist before acting.</p>
</div></section>

${snapshot.situation ? `<section class="page"><div class="card">
<div class="h2">Your situation today</div>
<p class="lede">The position this advice starts from, as you entered it, before the move into care \u{2014} and what would be left to the family if you stayed where you are.</p>
${(0, $8ea663173c1a6588$export$b23e227b9b89e73c)(snapshot.situation, {
        // Every tile on this page is the household at home today; the estate tile is the same
        // household staying put. The in-care baseline is the bridge sentence (owner, 9 Oct 2026).
        name: snapshot.stayPutLegacy != null ? 'Staying where you are' : 'Paying daily',
        pension: snapshot.baseline.pension,
        cashflow: snapshot.baseline.cashflow,
        estate: snapshot.stayPutLegacy ?? snapshot.doNothingLegacy ?? snapshot.projectedLegacy,
        netWorth: snapshot.baseline.netWorth
    }, snapshot.legacyHorizonYears ?? 5, snapshot.stayPutLegacy != null && snapshot.doNothingLegacy != null && snapshot.doNothingCashflow != null ? (0, $2411d79164c394f6$export$aa645fc954db83c6)({
        cashflow: snapshot.doNothingCashflow,
        estate: snapshot.doNothingLegacy,
        years: snapshot.legacyHorizonYears ?? 5,
        moneyWords: (0, $f94e45ac645ae232$export$3dc27271f5d5c629),
        pension: snapshot.doNothingPension,
        pensionToday: snapshot.baseline.pension
    }) : null)}
</div></section>

` : ''}<section class="page"><div class="card">
<div class="h2">Accommodation &amp; daily care costs</div>

<div class="callout callout--slate">
<p class="callout-title">Your accommodation numbers (modelled)</p>
<div class="soa-figs">
<div class="soa-fig"><div class="label">Room price</div><div class="value">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.roomCost)}</div></div>
<div class="soa-fig soa-fig--key"><div class="label">RAD paid up front</div><div class="value">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.radPaid)}</div></div>
<div class="soa-fig"><div class="label">Daily payment (DAP), a year</div><div class="value">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.estimatedDapAnnual)}</div></div>
</div>
<p class="small muted">The deposit paid up front sets the rest: whatever is not paid up front is charged daily as the DAP.</p>
${snapshot.facilityMove ? `<p><strong>A change of home:</strong> ${snapshot.facilityMove}</p>` : ''}
${snapshot.villageExit ? `<p><strong>Leaving the village:</strong> ${snapshot.villageExit}</p>` : ''}
${snapshot.secondRoom ? `<p><strong>${snapshot.secondRoom.name}'s room:</strong> ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.secondRoom.roomPrice)} &nbsp;|&nbsp; <strong>RAD paid:</strong> ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.secondRoom.radPaid)}${snapshot.secondRoom.dailyTotal != null ? ` &nbsp;|&nbsp; <strong>Daily fees:</strong> ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.secondRoom.dailyTotal)} a day` : ''}.${snapshot.secondRoom.phaseLine ? ` ${snapshot.secondRoom.phaseLine}` : ''} Both of you are in care, so Services Australia assesses you as a couple living apart \u{2014} each paid the Age Pension at the single rate, and each room's fees worked out on half the household's income and assets.</p>` : ''}
</div>

<p><strong>RAD (Refundable Accommodation Deposit)</strong> is the lump sum option for the room. It is generally refunded when care ends, but your resident agreement can allow specific deductions. A common framework is retention up to <strong>2% p.a.</strong> of the RAD, capped over <strong>5 years</strong>, so the provider agreement should always be checked before signing.</p>
<p><strong>Drawing fees from the deposit.</strong> ${$02a659cad5e2280d$var$depositArrangementSentence(snapshot)}</p>
${$02a659cad5e2280d$var$feeArrangementsParagraph(snapshot)}
<p><strong>DAP (Daily Accommodation Payment)</strong> applies to any unpaid room balance. Think of this as <strong>rent on that unpaid amount</strong>: it is ongoing and <strong>not refundable</strong>. The amount is driven by the MPIR in force when the room is agreed.</p>
<p><strong>Hybrid</strong> simply means paying part of the room price as RAD and leaving part as DAP \u{2014} often used to balance liquidity with lower daily accommodation charges.</p>

<div class="h3">Means-tested daily fees</div>
${snapshot.fees.feeArrangements === '2014' ? `<p>On top of accommodation, residents pay a <strong>basic daily fee</strong> (capped, linked to pension benchmarks) and, on the <strong>1 July 2014 fee arrangements</strong> that apply here, one means-tested fee:</p>
<ul>
<li><strong>Means-tested care fee</strong> \u{2014} Services Australia adds an income-tested amount (50% of assessable income above the income free area) and an asset-tested amount (17.5%, 1% and 2% of successive slices of assessable assets, with the former home counted up to the home exemption cap), takes off the maximum accommodation supplement, and charges the result per day up to a daily maximum. It stops for the rest of a year of care once the annual cap is reached, and for good once the lifetime cap is reached; income-tested care fees already paid under a Home Care Package and Support at Home contributions count towards the lifetime cap.</li>
<li>The <strong>hotelling supplement contribution</strong> and <strong>non-clinical care contribution</strong> that residents on the 1 November 2025 arrangements pay <strong>do not apply</strong> on these arrangements.</li>
</ul>` : `<p>On top of accommodation, residents may pay a <strong>basic daily fee</strong> (capped, linked to pension benchmarks) and <strong>means-tested</strong> care contributions based on income and assets. In AgedCareWise\u{2019}s calculation lines you will see:</p>
<ul>
<li><strong>Non-clinical care contribution (NCCC)</strong> \u{2014} the income- and asset-tested contribution toward non-clinical care services, capped daily and by a lifetime amount and a four-year limit.</li>
<li><strong>Hotelling supplement contribution (HSC)</strong> \u{2014} the contribution toward everyday living costs (meals, cleaning, laundry, utilities) for residents whose means-tested amount exceeds the accommodation supplement, capped daily.</li>
</ul>`}
<p class="muted small">Final dollar outcomes are determined by Services Australia and your provider after formal assessment; the table below is an estimate from the inputs you supplied.</p>

<table><thead><tr><th>Component</th><th>Estimated daily (model)</th></tr></thead><tbody>
<tr><td>Basic daily fee</td><td>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.fees.basicDailyFee)}</td></tr>
${snapshot.fees.feeArrangements === '2014' ? `<tr><td>Means-tested care fee (1 July 2014 arrangements \u{2014} no worse off)</td><td>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.fees.dailyMTCF)}</td></tr>` : `<tr><td>Non-clinical care contribution (NCCC)</td><td>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.fees.dailyNCCC)}</td></tr>
<tr><td>Hotelling supplement contribution (HSC)</td><td>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.fees.dailyHSC)}</td></tr>`}
<tr><td>Extra service fee</td><td>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.fees.dailyExtraServiceFee)}</td></tr>
</tbody></table>

<div class="h3">Assets used to fund RAD (if any)</div>
<table><thead><tr><th>Asset type</th><th>Asset</th><th>Amount</th></tr></thead><tbody>
${radFundingCards.length > 0 ? radFundingCards.map((row)=>`<tr><td>${row.assetType}</td><td>${row.source}</td><td>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.amount)}</td></tr>`).join('') : '<tr><td colspan="3">No explicit drawdowns were required for RAD in this strategy.</td></tr>'}
</tbody></table>
</div></section>

<section class="page"><div class="card">
<div class="h2">Age Pension Treatment</div>
${snapshot.isCoupleAdvice ? `<p class="lede">This section explains how Age Pension couple thresholds were applied in this modelling and why your result may differ from a standard-couple snapshot.</p>
<div class="callout callout--slate">
<p><strong>Before advice (baseline):</strong> You were modelled as <strong>${snapshot.baselinePensionStatus}</strong> with Age Pension of <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.baseline.pension)} p.a.</strong> using <strong>${snapshot.baselineUsesIllnessSeparated ? 'illness-separated couple' : 'standard couple'}</strong> thresholds.</p>
<p><strong>Scenario assumption:</strong> With <strong>${$02a659cad5e2280d$var$sanitizeText(snapshot.enteringCarePersonName)}</strong> entering residential aged care, the selected strategy applies <strong>${snapshot.modelUsesIllnessSeparated ? 'illness-separated couple' : 'standard couple'}</strong> thresholds.</p>
<p><strong>What changes in rules:</strong> Illness-separated treatment can use a higher couple pension maximum and different income/asset free areas and cut-offs than standard-couple-at-home settings. This can change pension eligibility and payment rate.</p>
<p><strong>Your home:</strong> ${snapshot.homeRuleParagraph}</p>
<p><strong>Result in your recommendation:</strong> Modelled Age Pension is <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.annualPension)} p.a.</strong>, which is <strong>${snapshot.pensionDeltaFromBaseline >= 0 ? '+' : '-'}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(snapshot.pensionDeltaFromBaseline))}</strong> compared with baseline.</p>
<p><strong>What you need to do:</strong> Notify Services Australia when care starts and request confirmation that the correct illness-separated/couple treatment is applied to your case.</p>
<p class="small muted"><strong>Validation required:</strong> Final classification and entitlement are determined by Services Australia based on your actual circumstances and assessment timing.</p>
</div>
${$02a659cad5e2280d$var$pensionBreakdownDetailsHtml(snapshot)}` : `<p class="lede">This section explains how the Age Pension was assessed in this modelling, and how entering residential care changes the assessment for a single person.</p>
<div class="callout callout--slate">
<p><strong>Before advice (baseline):</strong> You were modelled as <strong>${snapshot.baselinePensionStatus}</strong> with Age Pension of <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.baseline.pension)} p.a.</strong> using <strong>single</strong> thresholds.</p>
<p><strong>Scenario assumption:</strong> With <strong>${$02a659cad5e2280d$var$sanitizeText(snapshot.enteringCarePersonName)}</strong> entering residential aged care, the selected strategy continues to apply <strong>single</strong> thresholds.</p>
<p><strong>What changes in rules:</strong> ${snapshot.homeRuleParagraph}</p>
<p><strong>Result in your recommendation:</strong> Modelled Age Pension is <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.annualPension)} p.a.</strong>, which is <strong>${snapshot.pensionDeltaFromBaseline >= 0 ? '+' : '-'}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(snapshot.pensionDeltaFromBaseline))}</strong> compared with baseline.</p>
<p><strong>What you need to do:</strong> Notify Services Australia when care starts, and again when the deposit is paid or the home is sold or rented, so the assessment is updated on the right dates.</p>
<p class="small muted"><strong>Validation required:</strong> Final entitlement is determined by Services Australia based on your actual circumstances and assessment timing.</p>
</div>
${$02a659cad5e2280d$var$pensionBreakdownDetailsHtml(snapshot)}`}
</div></section>

<section class="page"><div class="card">
<div class="h2">Implications of this advice</div>
<p class="lede">Because your selected strategy is funded through specific assets, this section highlights the key implementation implications before you action any transactions.</p>
<div class="imp-grid">
${(snapshot.adviceImplications || []).map((item)=>`<div class="imp-card">
<p class="imp-title">${item.title}</p>
<p class="imp-lead">${item.lead}</p>
<p class="imp-body">${item.body}</p>
${item.cgtLine ? `<p class="imp-body" style="margin-top:6px">${item.cgtLine} Confirm final tax with your registered tax adviser before acting.</p>` : ''}
</div>`).join('')}
</div>
</div></section>
${snapshot.guaranteedIncome ? `
<section class="page"><div class="card" data-soa-section="guaranteed-income">
<div class="h2">Guaranteed income for life</div>
${(0, $66827b1304244a1d$export$5f47fbab513e00f4)(snapshot.guaranteedIncome)}
${snapshot.guaranteedIncome.rateExtrapolated ? '<p class="small muted">The rate for this age is estimated from the published table: above age 75 the table is extended, so the written quote matters more.</p>' : ''}
</div></section>` : ''}

<section class="page"><div class="card">
<div class="h2">Alternative strategies considered</div>
<p class="lede">${snapshot.scenarioExplainer}</p>
<p>${alternativeStrategiesLead}</p>
${alternativeStrategiesGrids}
${snapshot.horizonSetAsideHtml || ''}
</div></section>

<section class="page"><div class="card">
<div class="h2">Projection outlook</div>
<p class="muted small">This mirrors the projection view from AgedCareWise for <strong>${snapshot.selectedStrategyName}</strong>.</p>
<div class="h3" style="margin-top:4px">${snapshot.selectedStrategyName}</div>
${projectionDeficitContext}
<div class="proj-tabs">
  <button type="button" class="proj-tab active" data-tab="yearlyProjections">Yearly Projections</button>
  <button type="button" class="proj-tab" data-tab="opportunityCost">Overall Opportunity Cost</button>
</div>
<div class="proj-panel active" data-panel="yearlyProjections">
  ${(0, $8ea663173c1a6588$export$6534c8cb884ee17d)({
        idPrefix: 'ac-proj',
        planName: $02a659cad5e2280d$var$plainText(snapshot.selectedStrategyName),
        plan: (snapshot.enrichedProjections || []).map((r)=>({
                label: $02a659cad5e2280d$var$plainText(String(r.fyLabel || `Year ${r.year}`)),
                pension: Number(r.pension) || 0,
                cashflow: Number(r.cashFlow) || 0,
                netWorth: Number(r.netWorth) || 0
            })),
        baselineName: 'Paying daily',
        baseline: (snapshot.baselineProjections || []).map((r)=>({
                ...r,
                label: $02a659cad5e2280d$var$plainText(r.label)
            }))
    })}
  <div class="h3" style="margin-top:18px">5-Year Projections</div>
  ${projectionHowToReadHtml}
  <table class="table-proj"><thead><tr>
  <th>Year</th>
  <th>Net Worth (Opening)</th>
  <th>Age Pension</th>
  <th>Aged Care Costs</th>
  <th>Net Cashflow</th>
  <th>Net Worth (Closing)</th>
  <th>Surplus/Deficit</th>
  </tr></thead><tbody>
  ${projectionTableBody}
  </tbody></table>
</div>
<div class="proj-panel" data-panel="opportunityCost">
  <div class="h3" style="margin-top:4px">Opportunity Cost Analysis</div>
  ${opportunityCostPanel}
</div>
</div></section>

<section class="page"><div class="card">
<div class="h2">Estate planning</div>
${estateBodyHtml}
</div></section>

<section class="page"><div class="card">
<div class="h2">Fees &amp; disclosures</div>
<p><strong>Advice fee:</strong> Initial fee <strong>$450 plus GST</strong>. <strong>No ongoing advice fee</strong> and <strong>no separate implementation fee</strong> is charged for this digital pathway.</p>
<p><strong>Other costs:</strong> Aged care providers charge accommodation and care amounts separately; superannuation and investment products carry fees disclosed in their PDS or platform schedules.</p>
<p><strong>Conflicts of interest:</strong> AgedCareWise does <strong>not</strong> provide specific financial <em>product</em> advice. Recommendations are <strong>strategic</strong> and illustrated through the engine\u{2019}s assumptions. Where the model shows drawdowns from particular assets, that ordering reflects <strong>liquidity, growth and tax assumptions you supplied</strong> \u{2014} not a commission or conflict tied to a product issuer. On that basis, <strong>no conflicts are disclosed</strong> in relation to this advice.</p>
<p><strong>Complaints:</strong> Contact AgedCareWise using the details on your account / correspondence. If a complaint cannot be resolved, you may refer the matter to the Australian Financial Complaints Authority (AFCA) where eligible.</p>
<p class="muted small">${snapshot.adviceAttributionLine ? `${$02a659cad5e2280d$var$escapeHtml(snapshot.adviceAttributionLine)}${snapshot.adviceAttributionIncomplete ? " <strong>Your firm profile is incomplete \u2014 finish it in Settings before issuing this to a client.</strong>" : ''}` : "AgedCareWise Pty Ltd (Demo AFSL 401234) \u2014 ensure this block matches your licensee\u2019s approved wording before client issue."}</p>
</div></section>

${snapshot.strategyRisks?.sections?.length ? `<section class="page"><div class="card">
<div class="h2">What could go wrong with this strategy</div>
<p class="lede">Every plan has trade-offs. These are the ones that matter for the strategy recommended here, as they were shown to you when you chose it.</p>
${snapshot.strategyRisks.forYou.length ? `<div class="h3">For you specifically</div><ul class="riskList">${snapshot.strategyRisks.forYou.map((p)=>`<li><strong>${$02a659cad5e2280d$var$escapeHtml(p.lead)}</strong> ${$02a659cad5e2280d$var$escapeHtml(p.body)}</li>`).join('')}</ul>` : ''}
${snapshot.strategyRisks.sections.map((s)=>`<div class="h3">${$02a659cad5e2280d$var$escapeHtml(s.title)}</div><ul class="riskList">${s.points.map((p)=>`<li><strong>${$02a659cad5e2280d$var$escapeHtml(p.lead)}</strong> ${$02a659cad5e2280d$var$escapeHtml(p.body)}</li>`).join('')}</ul>`).join('')}
</div></section>` : ''}

<section class="page"><div class="card">
<div class="h2">Risks &amp; limitations</div>
<ul class="riskList">
${ratesReviewNoticeHtml}<li><strong>Legislation &amp; policy</strong> \u{2014} aged care, superannuation, and social security rules can change, which may shift outcomes.</li>
<li><strong>Modelling vs reality</strong> \u{2014} figures depend on assumptions (returns, fees, timing of care, home decisions). Real-world outcomes will vary.</li>
${snapshot.assumptionsChanged ? `<li><strong>Assumptions you changed</strong> \u{2014} we note that ${snapshot.assumptionsChanged.clientName} has changed ${snapshot.assumptionsChanged.rows.length === 1 ? 'one of' : ''} our default growth and income rate assumptions (see <em>Assumptions you changed</em> in the appendix). This Statement of Advice is based on mathematical calculations that factor in asset income, growth and capital gains tax assumptions. Changes to those assumptions can have a material effect on the projections and on the strategies the system recommends; the appendix shows the same plan at AgedCareWise's default rates for comparison.</li>` : ''}
<li><strong>Provider-specific terms</strong> \u{2014} accommodation agreements, extra services, RAD refund timing, and any permissible retention amounts depend on your chosen provider\u{2019}s contract.</li>
<li><strong>Tax &amp; legal</strong> \u{2014} CGT and estate outcomes should be confirmed with a registered tax agent or solicitor where you implement asset sales or structural changes. Where a new home is bought, stamp duty is estimated from that state's published scale with no concessions applied, or not at all where no state was chosen; confirm the figure with your conveyancer.</li>
${snapshot.structureAppendix ? "<li><strong>Trusts &amp; companies</strong> \u2014 where structures are modelled, apportionment and entity-asset summaries are in the appendix. Care Companion does not advise on deed or constitution permissibility; entity funding in automatic suggestions follows your Strategy Analysis Setup choice (personal only vs include entity assets).</li>" : ''}
<li><strong>Timing alignment</strong> \u{2014} actual outcomes can differ where sale dates, provider start dates, Centrelink reassessment timing, or tax-year boundaries differ from the model\u{2019}s implementation timing.</li>
<li><strong>Information gaps</strong> \u{2014} incomplete fact-find data may skew results; update inputs and re-run strategies when material facts change.</li>
</ul>
</div></section>

<section class="page"><div class="card">
<div class="h2">Next steps</div>
<ul class="riskList">
<li>Work through the implementation checklist inside AgedCareWise (RAD payment timing, asset drawdowns, Services Australia updates) using this Statement of Advice as the reference.</li>
${snapshot.pensionNextStep ? `<li>${snapshot.pensionNextStep}</li>` : ''}
<li>Obtain, read, and only then sign the aged care provider\u{2019}s <strong>resident agreement</strong> \u{2014} confirm retention rules, extra services, and refund conditions in writing, and consider having your own solicitor review the agreement before you sign.</li>
<li><strong>Re-run modelling</strong> whenever there is a significant change in your circumstances so pension, DAP and liquidity stay current.</li>
<li>Where you sell assets or trigger CGT, confirm final tax outcomes with a <strong>registered tax agent</strong>.</li>
<li>Update Wills, EPOA, and super nominations with a <strong>solicitor</strong> if the fact-find highlighted gaps.</li>
</ul>
</div></section>

<section class="page"><div class="card">
<div class="h2">Appendix \u{2014} fact-find &amp; assumptions</div>
<p><strong>Client age:</strong> ${snapshot.clientAge}${snapshot.partnerName ? ` | <strong>Partner age:</strong> ${snapshot.partnerAge}` : ''}</p>
<p><strong>Living expenses (annual):</strong> ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.annualLivingExpenses)} | <strong>Adjusted in model:</strong> ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.adjustedLivingExpenses)}</p>
<div class="h3">Asset assumptions</div>
<table><thead><tr><th>Asset type</th><th>Description</th><th>Value</th><th>Income %</th><th>Growth %</th><th>Client's own figures</th></tr></thead><tbody>
${snapshot.assetRows.map((row)=>`<tr><td>${row.assetType}</td><td>${row.description}${row.basis ? `<div class="tiny muted">${row.basis}</div>` : ''}</td><td>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.value)}</td><td>${row.incomeRate.toFixed(2)}%</td><td>${row.growthRate.toFixed(2)}%</td><td>${row.overridden ? 'Yes' : 'No'}</td></tr>`).join('')}
</tbody></table>
<p class="tiny muted">Income % is what the model applied. For an investment property it is the yield the recorded rent represents \u{2014} the projections use the rent and expense dollars recorded for the property, not an assumed yield.</p>
${$02a659cad5e2280d$var$buildAssumptionsChangedHtml(snapshot)}
${snapshot.structureAppendixHtml || ''}
<div class="h3">Structured fact-find responses</div>
${snapshot.factFindSections.map((section)=>`
<details class="factSection"><summary><strong>${section.title}</strong></summary>
  <div>
    ${section.rows.map((row)=>`<div class="factRow"><div class="factLabel">${row.label}</div><div>${$02a659cad5e2280d$export$57a9131fd362a631(row.value)}</div></div>`).join('')}
  </div>
</details>`).join('')}
<details class="factSection"><summary><strong>Rates &amp; thresholds used</strong></summary>
<table><thead><tr><th>Rate / threshold</th><th>Value used</th><th>Notes</th></tr></thead><tbody>
<tr><td>MPIR (for DAP estimate)</td><td>${((0, $815d7df20c36742b$export$36c4ec5f3f340aef).MPIR * 100).toFixed(2)}%</td><td>Used to estimate DAP on unpaid room balance (${(0, $815d7df20c36742b$export$36c4ec5f3f340aef).mpiQuarterLabel || 'see Department of Health quarterly publication'})</td></tr>
<tr><td>Advice fee (initial)</td><td>$450 + GST</td><td>No ongoing or implementation fee in this pathway</td></tr>
${thresholdRows || '<tr><td>Age pension / social security thresholds</td><td>See projection tooltips</td><td>Threshold lines were not attached in this export payload</td></tr>'}
<tr><td>Aged care means-tested values</td><td>Derived by AgedCareWise engine</td><td>Provider and Services Australia outcomes may differ after formal assessment</td></tr>
</tbody></table>
</details>
<div class="h3">Tax, super, Age Pension, aged care and market assumptions</div>
<p class="small muted">Every rate and threshold the model used, as the Assumptions page showed them when this document was generated. Open a group to read it.</p>
${(0, $8ea663173c1a6588$export$5f05ccad41218e23)(snapshot.assumptionSections || (0, $13910bc1e93fb74e$export$8d1b1c5d08b3c488)(), /Aged Care|Social Security|Tax|How the Plans/i)}
</div></section>

</div>
<script src="${$02a659cad5e2280d$var$soaBookletScriptUrl}"></script>
</body></html>`;
}
function $02a659cad5e2280d$export$b78bc62a2cc2a880(snapshot) {
    return $02a659cad5e2280d$var$buildHtml(snapshot);
}
function $02a659cad5e2280d$export$eed5e3bcf209d966(snapshot) {
    if (!snapshot) return;
    const html = $02a659cad5e2280d$var$buildHtml(snapshot);
    const blob = new Blob([
        html
    ], {
        type: 'text/html;charset=utf-8'
    });
    const url = URL.createObjectURL(blob);
    const safeName = snapshot.clientName.replace(/[^a-zA-Z0-9]/g, '_');
    const tab = window.open('', '_blank');
    if (tab) {
        tab.document.open();
        tab.document.write(html);
        tab.document.close();
    } else {
        const openLink = document.createElement('a');
        openLink.href = url;
        openLink.target = '_blank';
        openLink.rel = 'noopener noreferrer';
        document.body.appendChild(openLink);
        openLink.click();
        document.body.removeChild(openLink);
    }
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = `Digital_SOA_${safeName}_${snapshot.generatedAt.slice(0, 10)}.html`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    setTimeout(()=>URL.revokeObjectURL(url), 30000);
}


const $30c9565ba55bece8$export$f1e397822f6c54ec = 'careCompanionReopenIntent';
const $30c9565ba55bece8$var$AgedCarePage = ({ setActivePage: setActivePage, factFind: factFind, setFactFind: setFactFind, strategyOptions: strategyOptions, setStrategyOptions: setStrategyOptions, legacyYears: legacyYears, setLegacyYears: setLegacyYears, selectedStrategy: selectedStrategy, setSelectedStrategy: setSelectedStrategy, coupleValidation: coupleValidation, setCoupleValidation: setCoupleValidation, savedStrategies: savedStrategies, setSavedStrategies: setSavedStrategies, savedCaseStudies: savedCaseStudies, setSavedCaseStudies: setSavedCaseStudies, isProfessionalJourney: isProfessionalJourney = false, professionalCaseId: professionalCaseId = null, onSoaGenerated: onSoaGenerated = null, onStrategySaved: onStrategySaved = null, AgedCareAnalyser: AgedCareAnalyser })=>{
    const plans = (0, $acw62.useMemo)(()=>(savedStrategies || []).filter((s)=>s?.type === 'aged_care'), [
        savedStrategies
    ]);
    // The chosen plan: the in-memory selection when there is one, else the plan the file marks as chosen
    // (the selection does not survive a reload; the mark does).
    const chosen = (0, $acw62.useMemo)(()=>{
        const sel = selectedStrategy;
        const bySelection = sel ? plans.find((p)=>sel.id != null && String(p.id) === String(sel.id) || p.strategy && sel.name && p.strategy.name === sel.name && !sel.id) ?? null : null;
        return bySelection ?? plans.find((p)=>p.chosen) ?? null;
    }, [
        plans,
        selectedStrategy
    ]);
    const documents = (0, $acw62.useMemo)(()=>(savedCaseStudies || []).filter((d)=>!professionalCaseId || !d.caseId || d.caseId === professionalCaseId), [
        savedCaseStudies,
        professionalCaseId
    ]);
    // A reopen token means "land on the plan"; otherwise plans on the file mean the landing.
    const [view, setView] = (0, $acw62.useState)(()=>{
        try {
            if (sessionStorage.getItem('careCompanionReopenStrategy') || sessionStorage.getItem('careCompanionModelAnotherHome') || sessionStorage.getItem('careCompanionStartFresh')) return 'analyser';
        } catch  {}
        return plans.length > 0 ? 'hub' : 'analyser';
    });
    const [guideOpen, setGuideOpen] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
    }, [
        view,
        guideOpen
    ]);
    // The guide, when open, is what AWise should talk about; the page beneath restores its own context on close.
    (0, $acw62.useEffect)(()=>{
        if (!guideOpen) return;
        const before = (0, $6067e4a24a943681$export$49a9c588fd4c5f9d)();
        (0, $6067e4a24a943681$export$62e91b0fed1d0d10)({
            screen: 'guide',
            note: ''
        });
        return ()=>(0, $6067e4a24a943681$export$62e91b0fed1d0d10)(before);
    }, [
        guideOpen
    ]);
    const openPlan = (plan, intent)=>{
        try {
            sessionStorage.setItem('careCompanionReopenStrategy', JSON.stringify(plan));
            if (intent) sessionStorage.setItem($30c9565ba55bece8$export$f1e397822f6c54ec, intent);
            else sessionStorage.removeItem($30c9565ba55bece8$export$f1e397822f6c54ec);
        } catch  {}
        setView('analyser');
    };
    const modelAnotherHome = (from)=>{
        try {
            sessionStorage.removeItem('careCompanionReopenStrategy');
            sessionStorage.setItem('careCompanionModelAnotherHome', JSON.stringify(from ?? {}));
        } catch  {}
        setView('analyser');
    };
    /** A new model from scratch: nothing carried over, and the setup questions asked again (AgedCareAnalyser). */ const startFresh = ()=>{
        try {
            sessionStorage.removeItem('careCompanionReopenStrategy');
            sessionStorage.removeItem('careCompanionModelAnotherHome');
            sessionStorage.removeItem($30c9565ba55bece8$export$f1e397822f6c54ec);
            sessionStorage.setItem('careCompanionStartFresh', '1');
        } catch  {}
        setView('analyser');
    };
    const openDocument = (doc)=>{
        const snapshot = doc.soaSnapshot;
        if (snapshot) {
            (0, $02a659cad5e2280d$export$eed5e3bcf209d966)(snapshot);
            return;
        }
        if (chosen) openPlan(chosen, 'document');
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            guideOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf6abaf7e99e19dd$export$2e2bcd8739ae039), {
                setActivePage: setActivePage,
                onContinue: ()=>setGuideOpen(false),
                onBack: ()=>setGuideOpen(false),
                backLabel: "Back to where you were",
                continueLabel: "Back to where you were",
                factFind: factFind
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: guideOpen ? 'hidden' : undefined,
                "aria-hidden": guideOpen || undefined,
                children: view === 'hub' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7673ace5c1b1942$export$2e2bcd8739ae039), {
                    factFind: factFind,
                    plans: plans,
                    chosen: chosen,
                    documents: documents,
                    onOpenPlan: openPlan,
                    onModelAnotherHome: modelAnotherHome,
                    onStartFresh: startFresh,
                    onOpenDocument: openDocument,
                    onReadGuide: ()=>setGuideOpen(true),
                    onAssumptions: ()=>setActivePage('AssumptionsPage'),
                    goHome: ()=>setActivePage('Dashboard')
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(AgedCareAnalyser, {
                    setActivePage: setActivePage,
                    factFind: factFind,
                    setFactFind: setFactFind,
                    strategyOptions: strategyOptions,
                    setStrategyOptions: setStrategyOptions,
                    onBack: ()=>setGuideOpen(true),
                    onBackToPlan: plans.length > 0 ? ()=>setView('hub') : undefined,
                    legacyYears: legacyYears,
                    setLegacyYears: setLegacyYears,
                    selectedStrategy: selectedStrategy,
                    setSelectedStrategy: setSelectedStrategy,
                    coupleValidation: coupleValidation,
                    setCoupleValidation: setCoupleValidation,
                    savedStrategies: savedStrategies,
                    setSavedStrategies: setSavedStrategies,
                    savedCaseStudies: savedCaseStudies,
                    setSavedCaseStudies: setSavedCaseStudies,
                    isProfessionalJourney: isProfessionalJourney,
                    professionalCaseId: professionalCaseId,
                    onSoaGenerated: onSoaGenerated,
                    onStrategySaved: onStrategySaved
                })
            })
        ]
    });
};
var $30c9565ba55bece8$export$2e2bcd8739ae039 = $30c9565ba55bece8$var$AgedCarePage;


/**
 * AgedCareAnalyser.js – main aged care funding analyser: strategy mode (rent/sell/downsize/equity),
 * RAD/DAP inputs, allocators (downsize, investment property, reverse mortgage, HEAS, RAD funding),
 * suggestion engine, financial impact panel, SOA, projections modal. Used by AgedCarePage; receives
 * factFind and strategy state from App.js.
 */ 





/**
 * The household's care cost where two people are in care (owner, 7 Oct 2026: step 3 "is only
 * baselining against one person"). The engine prices each room on its own schedule; everything a
 * reader sees as "what care costs" must add the two. One helper, so no screen adds them differently.
 *
 * The result keeps every field of the FIRST room's schedule (breakdowns, fee arrangements, the
 * room's own DAP for its own rows) and replaces only the household totals.
 */ function $bdfd96a4f4ac117d$export$4a7e3987a5ffaa21(first, second) {
    return (Number(first?.totalDailyCost) || 0) + (Number(second?.totalDailyCost) || 0);
}
function $bdfd96a4f4ac117d$export$89e252d57ea6f30b(first, second) {
    if (!second) return first;
    return {
        ...first,
        totalDailyCost: $bdfd96a4f4ac117d$export$4a7e3987a5ffaa21(first, second),
        dailyAccommodationPayment: (Number(first.dailyAccommodationPayment) || 0) + (Number(second.dailyAccommodationPayment) || 0),
        /** Set so a reader can tell a summed schedule from a single room's. */ householdOfTwo: true
    };
}
function $bdfd96a4f4ac117d$export$98225c4faadd11c0(costs, dailyPayment) {
    if (dailyPayment == null || !Number.isFinite(Number(dailyPayment))) return costs;
    const dap = Math.max(0, Number(dailyPayment) || 0);
    const total = (Number(costs.basicDailyFee) || 0) + dap + (Number(costs.dailyNCCC) || 0) + (Number(costs.dailyHSC) || 0) + (Number(costs.dailyMTCF) || 0) + (Number(costs.dailyExtraServiceFee) || 0);
    return {
        ...costs,
        dailyAccommodationPayment: dap,
        totalDailyCost: total
    };
}
function $bdfd96a4f4ac117d$export$86905c05d8e03be(strategy, fallback) {
    const first = strategy.strategySpecificAgedCareCosts || fallback || null;
    const second = strategy.secondRoom && !strategy.secondRoom.entersLater ? strategy.secondRoom.agedCareCosts : null;
    return $bdfd96a4f4ac117d$export$4a7e3987a5ffaa21(first, second);
}
function $bdfd96a4f4ac117d$export$d9a4203f6e9eec45(strategy) {
    const v = strategy.phaseTwo?.householdDailyCost;
    return typeof v === 'number' && Number.isFinite(v) ? v : null;
}







/**
 * A calculation call that did not come back — most often a 30-second timeout while the server is
 * busy ranking a few hundred strategies for the same client (owner-reported, 7 Oct 2026: an
 * "Unhandled Rejection" overlay after the Suggestion Engine finished). The figures already on screen
 * stay; the console says what was not refreshed; nothing is thrown at the page.
 */ const $85051d5377ce5db4$export$890bc823b29958a8 = (what)=>(err)=>{
        const message = err instanceof Error ? err.message : String(err);
        console.warn(`[aged care] ${what} was not refreshed: ${message}`);
    };



/**
 * Funding a SECOND resident's deposit from what the first one left (owner, 7 Oct 2026: both of a
 * couple into care, built properly).
 *
 * The first entrant's deposit is chosen asset by asset on the funding card, or by the engine's
 * funding-order candidates. The second room's deposit is not asked for the same way: a client
 * entering both of them at once has one pool of savings, and a second allocator over the same
 * assets would let the same dollar fund two rooms. So the second deposit is taken from what the
 * first plan LEFT, in the order the engine's own candidates use — bank, then term deposits, then
 * account-based pensions, then shares — never from anything held in a trust or company, and never
 * more than the asset still holds once the first deposit's claim on it is subtracted.
 */ 
const $0e15302c37df0d54$export$4220fd1788556935 = [
    'bankAccounts',
    'termDeposits',
    'accountBasedPensions',
    'shares'
];
function $0e15302c37df0d54$export$b097a93d3ede847(factFind, amount, alreadyClaimed = {}) {
    const radFunding = {};
    let remaining = Math.max(0, Number(amount) || 0);
    const claimed = (key)=>Math.max(0, Number(alreadyClaimed[key]) || 0);
    for (const type of $0e15302c37df0d54$export$4220fd1788556935){
        if (remaining <= 0) break;
        const list = factFind.assets?.[type] || [];
        for (const asset of list){
            if (remaining <= 0) break;
            if (asset.id == null || (0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(String(asset.ownership ?? ''))) continue;
            const key = `${type}-${asset.id}`;
            const available = Math.max(0, (Number(asset.value) || 0) - claimed(key));
            const take = Math.min(available, remaining);
            if (take <= 0) continue;
            radFunding[key] = take;
            remaining -= take;
        }
    }
    const funded = Math.max(0, (Number(amount) || 0) - remaining);
    return {
        radFunding: radFunding,
        funded: funded,
        shortfall: remaining
    };
}


/**
 * One room's three questions — price, extra services, start date — asked the same way for every
 * person entering care (owner, 7 Oct 2026: "shouldn't the questions be exactly the same?"). The
 * Analyser renders this once for a single entrant and once per person when both of a couple are
 * moving in, so the two rooms can never drift apart in wording or behaviour.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9ad14973a512851d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21 21-4.34-4.34",
            key: "14j7rj"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ]
];
const $9ad14973a512851d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("search", $9ad14973a512851d$export$3efd853dbb351e94);






const $d0cc0b7e25e28cd3$export$d56c1f6af3bd0580 = (annual, unit)=>{
    if (!annual) return '';
    if (unit === 'annual') return (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(annual);
    return '$' + (annual / 365).toLocaleString('en-AU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};


const $78960c4d92ac43b2$var$WhatsThis = ({ text: text })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
        text: text
    });
const $78960c4d92ac43b2$var$RoomInputs = ({ idSuffix: idSuffix = '', roomPrice: roomPrice, onRoomPrice: onRoomPrice, onFacilitySearch: onFacilitySearch, selectedFacility: selectedFacility, extraServiceAnnual: extraServiceAnnual, onExtraServiceAnnual: onExtraServiceAnnual, careStartDate: careStartDate, dateInputProps: dateInputProps, minDate: minDate, dateHelp: dateHelp, dateHint: dateHint, dateLabel: dateLabel = 'When is care expected to start?' })=>{
    // The unit the extra-service figure is typed in, and the in-progress keystrokes so a decimal
    // point survives typing. Homes quote per day, so that is the default.
    const [unit, setUnit] = (0, $acw62.useState)('daily');
    const [draft, setDraft] = (0, $acw62.useState)(null);
    // Two columns from a laptop up (the mock-up's step 1, 17 Oct 2026): price beside extras, start date beside what follows it.
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "grid grid-cols-1 gap-6 md:grid-cols-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        className: "block text-sm font-medium text-gray-700",
                        children: [
                            "Room price",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($78960c4d92ac43b2$var$WhatsThis, {
                                text: "The price of the room as advertised by the aged care home \u2014 the full lump sum it would cost to buy the room outright. You do not have to pay it as a lump sum: step 3 is where you choose how much of it to pay up front and how much to pay daily instead."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "text",
                                id: `room-price${idSuffix}`,
                                value: roomPrice > 0 ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(roomPrice) : '',
                                onChange: (e)=>onRoomPrice(parseFloat(String((0, $f94e45ac645ae232$export$dc5333890dfc7d0)(e.target.value))) || 0),
                                className: "flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
                                placeholder: "e.g. $500,000 \u2014 the whole room price"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: onFacilitySearch,
                                className: "px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-1 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                        size: 14
                                    }),
                                    "Find a home"
                                ]
                            })
                        ]
                    }),
                    selectedFacility && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-sm text-gray-600 bg-blue-50 p-2 rounded-lg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Selected:"
                            }),
                            " ",
                            selectedFacility.name,
                            ", ",
                            selectedFacility.suburb,
                            " - $",
                            selectedFacility.radPrice.toLocaleString()
                        ]
                    }),
                    roomPrice > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-xs text-slate-500",
                        children: [
                            "That is ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                className: "text-slate-700",
                                children: [
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(roomPrice * (0, $815d7df20c36742b$export$36c4ec5f3f340aef).MPIR / 365),
                                    " a day"
                                ]
                            }),
                            ' ',
                            "if the whole room were paid daily instead \u2014 the same room, quoted the other way. Homes must publish both, and My Aged Care asks for the daily figure."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        htmlFor: `extraServiceFee${idSuffix}`,
                        className: "block text-sm font-medium text-gray-700",
                        children: [
                            "Optional extra services",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($78960c4d92ac43b2$var$WhatsThis, {
                                text: "Some homes charge an extra fee for additional services \u2014 better meal choices, hairdressing, newspapers, outings. Homes normally quote this per day, so that is what this field expects; switch to per year if your quote is annual. Leave it at zero if there is no such fee."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "text",
                                id: `extraServiceFee${idSuffix}`,
                                name: `extraServiceFee${idSuffix}`,
                                value: draft ?? (0, $d0cc0b7e25e28cd3$export$d56c1f6af3bd0580)(extraServiceAnnual, unit),
                                onChange: (e)=>{
                                    setDraft(e.target.value);
                                    const typed = parseFloat(String((0, $f94e45ac645ae232$export$dc5333890dfc7d0)(e.target.value)));
                                    onExtraServiceAnnual(isNaN(typed) ? 0 : unit === 'daily' ? typed * 365 : typed);
                                },
                                onBlur: ()=>setDraft(null),
                                placeholder: unit === 'daily' ? 'e.g. $25.00' : 'e.g. $9,125',
                                className: "flex-1 min-w-0 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex rounded-lg border border-gray-300 overflow-hidden text-sm",
                                children: [
                                    'daily',
                                    'annual'
                                ].map((u)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        "aria-pressed": unit === u,
                                        onClick: ()=>{
                                            setDraft(null);
                                            setUnit(u);
                                        },
                                        className: `px-2.5 py-2 whitespace-nowrap transition-colors ${unit === u ? 'bg-blue-600 text-white font-semibold' : 'bg-white text-gray-600 hover:bg-gray-50'}`,
                                        children: u === 'daily' ? 'per day' : 'per year'
                                    }, u))
                            })
                        ]
                    }),
                    extraServiceAnnual > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-gray-500",
                        children: unit === 'daily' ? `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(extraServiceAnnual)} a year` : `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(extraServiceAnnual / 365)} a day`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        htmlFor: `care-start-date${idSuffix}`,
                        className: "block text-sm font-medium text-gray-700 mb-1",
                        children: [
                            dateLabel,
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($78960c4d92ac43b2$var$WhatsThis, {
                                text: dateHelp
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "date",
                        id: `care-start-date${idSuffix}`,
                        name: `careStartDate${idSuffix}`,
                        min: minDate,
                        ...dateInputProps,
                        className: "w-full px-3 py-2 border border-gray-300 rounded-lg"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-slate-500",
                        children: careStartDate ? dateHint.chosen : dateHint.blank
                    })
                ]
            })
        ]
    });
};
var $78960c4d92ac43b2$export$2e2bcd8739ae039 = $78960c4d92ac43b2$var$RoomInputs;



/**
 * What to say beside a cashflow shortfall in aged care (owner, 6 Oct 2026).
 *
 * A large negative number reads as alarming, and usually it is not: care tends to cost more than the
 * pension and other income pay, and most people meet the difference from savings. What matters is
 * whether the savings last. So the reassurance is only given when they do — measured against the
 * time the horizon rule plans the person's care on (their age and health, strategyHorizon.ts), the
 * same assumption the advice itself rests on. When they may not, it says so, and points to step 3.
 */ 


function $761eebfc891b9eea$export$2e354e42d669da07(projections) {
    const s = (0, $0fe89e03b6df746e$export$693cc3146baa3244)(projections);
    if (!s.hasData) return null;
    const runwayYears = s.hasDeficit ? s.borrowingStartsYear ?? s.moneyRunsOutYear ?? null : null;
    return {
        runwayYears: runwayYears,
        projectedYears: s.totalYears ?? 0
    };
}
function $761eebfc891b9eea$export$ee5aafeb340c75f8(ff) {
    const forWhom = ff?.goals?.aged_care_for;
    const couple = ff?.adviceFor === 'couple';
    const c = ff?.client || {};
    const p = ff?.partner || {};
    if (couple && forWhom === 'both') {
        const years = (0, $e36b043daf0f5d8d$export$ed3ccff4f05a72c7)({
            age: (0, $5589d9476399db47$export$8ada184d5eef4694)(c.dob),
            partnerAge: (0, $5589d9476399db47$export$8ada184d5eef4694)(p.dob),
            sex: c.sex,
            partnerSex: p.sex,
            healthStatus: String(c.healthStatus) === 'poor' || String(p.healthStatus) === 'poor' ? 'poor' : undefined
        });
        const name = [
            c.firstName,
            p.firstName
        ].filter(Boolean).join(' and ') || 'them';
        return years == null ? null : {
            years: years,
            name: name
        };
    }
    const person = couple && forWhom === 'partner' ? p : c;
    const years = (0, $e36b043daf0f5d8d$export$ed3ccff4f05a72c7)({
        age: (0, $5589d9476399db47$export$8ada184d5eef4694)(person.dob),
        healthStatus: person.healthStatus,
        sex: person.sex
    });
    return years == null ? null : {
        years: years,
        name: person.firstName || (person === p ? 'your partner' : 'you')
    };
}
const $761eebfc891b9eea$var$yrs = (n)=>`${n} ${n === 1 ? 'year' : 'years'}`;
const $761eebfc891b9eea$var$basis = (care)=>`we plan for about ${$761eebfc891b9eea$var$yrs(care.years)} of care, based on ${care.name === 'you' ? 'your' : `${care.name}'s`} age and health`;
function $761eebfc891b9eea$export$a3c504a65d7a0fe7(runway, care, opts = {}) {
    const normal = 'A gap like this is normal in aged care: care usually costs more than the pension and other income pays, so most people use their savings to cover the difference.';
    if (!runway || !care) return {
        lead: normal,
        verdict: 'What matters is that the savings last.',
        covered: null
    };
    if (runway.runwayYears != null) {
        if (runway.runwayYears >= care.years) return {
            lead: normal,
            verdict: opts.yearsAlreadySaid ? `That is long enough: ${$761eebfc891b9eea$var$basis(care)}.` : `The savings last about ${$761eebfc891b9eea$var$yrs(runway.runwayYears)}, which is long enough: ${$761eebfc891b9eea$var$basis(care)}.`,
            covered: true
        };
        return {
            lead: 'A gap like this is common in aged care, and savings usually cover it.',
            verdict: `${opts.yearsAlreadySaid ? 'That' : `Here they would last about ${$761eebfc891b9eea$var$yrs(runway.runwayYears)}, which`} may not be long enough: ${$761eebfc891b9eea$var$basis(care)}. Step 3 shows ways to make the savings go further.`,
            covered: false
        };
    }
    if (runway.projectedYears >= care.years) return {
        lead: normal,
        verdict: `The savings are still there after the ${$761eebfc891b9eea$var$yrs(runway.projectedYears)} projected, which is long enough: ${$761eebfc891b9eea$var$basis(care)}.`,
        covered: true
    };
    return {
        lead: normal,
        verdict: `The savings last at least the ${$761eebfc891b9eea$var$yrs(runway.projectedYears)} projected. What matters is that they last.`,
        covered: null
    };
}



var $acw62 = parcelRequire("acw62");
/**
 * Binding a `<input type="date">` to a CLAMPED value without the clamp fighting the keyboard.
 *
 * A date input emits a complete value on every keystroke of the year, so typing "2026" into a field
 * that already holds a day and month arrives as `0002-…`, then `0020-…`, then `0202-…`, and only
 * finally `2026-…`. The first three are real dates in the distant past. A clamp that rejects past
 * dates therefore returned '' three times on the way to a perfectly good answer — and because the
 * input was controlled, each '' wiped the whole field, day and month with it. Typing the year FIRST
 * looked like it worked only because the value stays incomplete, and so untouched by the clamp, until
 * the final segment is filled.
 *
 * The fix is to separate the DRAFT being typed from the COMMITTED value the engine reads. Every
 * keystroke updates the draft; only a complete date is put through the clamp and committed. On blur
 * the draft snaps to whatever was actually committed, so a rejected date visibly reverts rather than
 * sitting on screen looking accepted.
 */ 
var $acw62 = parcelRequire("acw62");
function $685be4cbbd7d2f79$export$8894268d0344e581(raw) {
    return /^\d{4}-\d{2}-\d{2}$/.test(raw);
}
function $685be4cbbd7d2f79$export$52e925614ff14a89(raw) {
    return raw === '' || $685be4cbbd7d2f79$export$8894268d0344e581(raw);
}
function $685be4cbbd7d2f79$export$1a2b950bdc1c1e93(committed, commit, clamp) {
    const [draft, setDraft] = (0, $acw62.useState)(committed);
    // The committed value also changes from OUTSIDE the field — restoring a saved strategy, or the
    // care date moving and dragging the RAD sale date back with it — and the draft has to follow.
    (0, $acw62.useEffect)(()=>setDraft(committed), [
        committed
    ]);
    return {
        value: draft,
        onChange: (e)=>{
            const raw = e.target.value;
            setDraft(raw);
            if ($685be4cbbd7d2f79$export$52e925614ff14a89(raw)) commit(clamp(raw));
        },
        onBlur: ()=>setDraft(committed)
    };
}








/**
 * The year-by-year net worth line of a projection, reduced to the few fields worth PERSISTING.
 *
 * A saved strategy has always carried `legacyEstimate` — the net worth of the FINAL projection row —
 * and nothing else from the walk. That answers "what is left to my estate?" and no other question
 * about time. "What will I be worth at the start of FY27/28?" is a question about a row in the middle,
 * and the row was thrown away the moment the strategy was saved.
 *
 * Re-running the engine to recover it is not an option for the surfaces that need it (see the header
 * of server/src/rest/ai/affordabilitySummary.ts): the run's inputs are live UI state, and a re-run
 * would answer a DIFFERENT question from the one on the user's screen while sounding just as certain.
 * So the walk's net worth line is saved with the strategy, at the moment it is struck, from the same
 * `projections` array `legacyEstimate` is already read out of.
 *
 * WHAT IS AND IS NOT KEPT. Only the balance-sheet date and the figure struck on it. Not the breakdown
 * rows, not the cashflow, not the HTML — a projection row is large, this is saved inside an encrypted
 * fact-find, and the whole schedule has to stay small enough that persisting it is uncontroversial.
 * Formatting is likewise NOT done here: numbers stay numbers and dates stay ISO, so a consumer that
 * needs them rendered (the AI affordability payload formats every figure as a string) can do so in its
 * own vocabulary, and one that needs to compute is not handed prose.
 */ /** The projection-row fields this reads. Structural, so both the engine's rows and the frontend's fit. */ const $a882fd27fa2c97d8$export$554b4f0d634246fb = 60;
const $a882fd27fa2c97d8$var$isFiniteNumber = (value)=>typeof value === 'number' && Number.isFinite(value);
function $a882fd27fa2c97d8$export$7386c6396507d94b(projections) {
    if (!Array.isArray(projections)) return [];
    return projections.slice(0, $a882fd27fa2c97d8$export$554b4f0d634246fb).flatMap((row, index)=>{
        if (!$a882fd27fa2c97d8$var$isFiniteNumber(row?.netWorth)) return [];
        const label = typeof row.fyLabel === 'string' && row.fyLabel ? row.fyLabel : `Year ${$a882fd27fa2c97d8$var$isFiniteNumber(row.year) ? row.year : index + 1}`;
        return [
            {
                period: label,
                asAt: typeof row.periodEnd === 'string' && row.periodEnd ? row.periodEnd : null,
                mode: typeof row.projectionPeriodMode === 'string' && row.projectionPeriodMode ? row.projectionPeriodMode : 'financial_year',
                partial: row.isPartialFy === true,
                netWorth: row.netWorth
            }
        ];
    });
}
/**
 * The calendar year a period CLOSES in, read out of its own label.
 *
 * Deliberately NOT read from `asAt`, even though that field is right there. `asAt` is an ISO instant
 * built from a local-midnight `Date` in whichever timezone ran the projection, so `2027-06-30` in
 * Sydney is stored as `2027-06-29T14:00:00Z`. Formatting or incrementing that from a server on a
 * different offset moves the date by a day — and every date this module deals in is a period boundary,
 * the one place a one-day slip silently becomes a one-YEAR slip. The label carries the same fact with
 * no timezone attached, so it is the safer source. `asAt` remains for consumers that want the instant.
 */ function $a882fd27fa2c97d8$var$closingYearOf(point) {
    if (point.mode === 'calendar_year') return /^\d{4}$/.test(point.period) ? Number(point.period) : null;
    if (point.mode !== 'financial_year') return null;
    const match = /^FY(\d{2})\/\d{2}$/.exec(point.period);
    // The FY opens in `2000 + a` and closes in the year after — which is how FY99/00 stays coherent
    // without a century special case.
    return match ? 2000 + Number(match[1]) + 1 : null;
}
const $a882fd27fa2c97d8$var$MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
function $a882fd27fa2c97d8$export$cf56161ea78ec5af(point) {
    const year = $a882fd27fa2c97d8$var$closingYearOf(point);
    if (year === null) return null;
    const [day, monthIndex] = point.mode === 'calendar_year' ? [
        31,
        11
    ] : [
        30,
        5
    ];
    return `${day} ${$a882fd27fa2c97d8$var$MONTH_NAMES[monthIndex]} ${year}`;
}
function $a882fd27fa2c97d8$export$1651676eeefc2fa2(point) {
    const closingYear = $a882fd27fa2c97d8$var$closingYearOf(point);
    if (closingYear === null) return null;
    if (point.mode === 'calendar_year') return String(closingYear + 1);
    const twoDigit = (year)=>String(year % 100).padStart(2, '0');
    return `FY${twoDigit(closingYear)}/${twoDigit(closingYear + 1)}`;
}


/**
 * Shared sessionStorage keys + events for saved strategies (used by Aged Care, SAH, Service Builder).
 * Keep this file free of Support-at-Home or Aged-Care feature imports so all modules can import it safely.
 */ const $f58ff7d3c4c676c4$export$685490c2fa387b9a = 'careCompanionStrategies';
const $f58ff7d3c4c676c4$export$c31575d0976c0a1 = 'careCompanionActiveHomeCareStrategyId';
const $f58ff7d3c4c676c4$export$f2d0abffc7f79a5c = 'careCompanionHomeCareStrategiesUpdated';
const $f58ff7d3c4c676c4$export$b81dc9baeb417304 = 'hc:';
const $f58ff7d3c4c676c4$export$6a1b0280c30a972e = 'ac:';
function $f58ff7d3c4c676c4$export$33b576d5d6fa435b() {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new Event($f58ff7d3c4c676c4$export$f2d0abffc7f79a5c));
}
function $f58ff7d3c4c676c4$export$b731185d32c620a3(strategyId) {
    if (typeof window === 'undefined') return;
    if (strategyId) window.sessionStorage.setItem($f58ff7d3c4c676c4$export$c31575d0976c0a1, strategyId);
    else window.sessionStorage.removeItem($f58ff7d3c4c676c4$export$c31575d0976c0a1);
}
function $f58ff7d3c4c676c4$export$816f75caf2488b34(kind, rawId) {
    if (kind === 'baseline' || !rawId) return 'baseline';
    if (kind === 'aged_care') return `${$f58ff7d3c4c676c4$export$6a1b0280c30a972e}${rawId}`;
    return `${$f58ff7d3c4c676c4$export$b81dc9baeb417304}${rawId}`;
}




/**
 * The three steps of the Aged Care Funding Analyser, as a progress strip.
 *
 * WHY THREE STEPS (owner's review with an actuary, September 2026: "this could be daunting to a
 * consumer — advisers would probably be ok"). The analyser used to arrive all at once: the inputs,
 * the walk-in story, the mode chooser and a fourteen-figure plan summary, before the client had done
 * anything. Nothing was wrong with any of it; it was the order. A client has three questions, in
 * order — what does care cost, what does that do to us, and what can we do about it — and the strip
 * puts the screen in that order. Every step is reachable at any time; the strip is a map, not a gate.
 *
 * The strip itself is the shared AnalyserSteps (24 Sep 2026), so every module's three steps look and
 * behave the same; this file only supplies Aged Care's words.
 */ 
parcelRequire("acw62");
/**
 * The three steps of a funding analyser, as a progress strip — one component for every module.
 *
 * WHY THREE STEPS (owner's review with an actuary, September 2026: "this could be daunting to a
 * consumer — advisers would probably be ok"). An analyser used to arrive all at once: the inputs,
 * the position, the mode chooser and a fourteen-figure plan summary, before the client had done
 * anything. Nothing was wrong with any of it; it was the order. A client has three questions, in
 * order — what does this cost, what does that do to us, and what can we do about it — and the
 * strip puts the screen in that order. Every step is reachable at any time; the strip is a map,
 * not a gate.
 *
 * Built for Aged Care on 22 Sep 2026 and lifted here on 24 Sep so the Retirement Village module
 * (and the others after it) walk the same spine with the same strip (owner: "try to get
 * harmonisation of the UI/UX"). The steps are numbered because they ARE a sequence: the second
 * cannot be read before the first has its figure, and the third is measured against the second.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8240f8fcfc513968$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
];
const $8240f8fcfc513968$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("check", $8240f8fcfc513968$export$3efd853dbb351e94);


const $724b7566e2d97e1f$var$AnalyserSteps = ({ step: step, onStep: onStep, steps: steps, ariaLabel: ariaLabel = 'Analyser steps' })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
        "aria-label": ariaLabel,
        className: "mt-6 flex flex-col gap-2 md:flex-row md:items-center md:gap-3",
        children: steps.map((s, i)=>{
            const n = i + 1;
            const active = n === step;
            const done = n < step;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>onStep(n),
                        "aria-current": active ? 'step' : undefined,
                        className: `flex flex-1 items-center gap-3 rounded-xl border-2 px-3.5 py-2.5 text-left transition-colors ${active ? 'border-blue-600 bg-blue-50 text-[#001E7A] shadow-sm' : done ? 'border-emerald-200 bg-white text-slate-800 hover:border-blue-300' : 'border-slate-200 bg-white text-slate-500 hover:border-blue-300'}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-[13px] font-bold ${active ? 'bg-blue-600 text-white' : done ? 'bg-emerald-500 text-white' : 'bg-slate-200 text-slate-600'}`,
                                "aria-hidden": true,
                                children: done ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                    size: 15,
                                    strokeWidth: 3
                                }) : n
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "flex min-w-0 flex-col leading-tight",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-[14px] font-bold",
                                        children: s.title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-[13px] text-slate-500",
                                        children: s.sub
                                    })
                                ]
                            })
                        ]
                    }),
                    i < steps.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                        size: 18,
                        className: "hidden shrink-0 text-slate-400 md:block",
                        "aria-hidden": true
                    })
                ]
            }, n);
        })
    });
var $724b7566e2d97e1f$export$2e2bcd8739ae039 = $724b7566e2d97e1f$var$AnalyserSteps;


const $dfd0dc18d9f6ba43$var$AgedCareSteps = ({ step: step, onStep: onStep, clientName: clientName, moving: moving = false })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $724b7566e2d97e1f$export$2e2bcd8739ae039), {
        step: step,
        onStep: onStep,
        steps: [
            // The client's three questions, in the client's words (UX review, 17 Oct 2026): what the
            // room costs, what that means for them, and the ways to pay for it.
            {
                title: moving ? 'The new home' : 'What the room costs',
                sub: moving ? 'Its room price and the move date' : 'Room price and start date'
            },
            {
                title: `What it means for ${clientName}`,
                sub: 'Four numbers, and the story behind them'
            },
            {
                title: 'Ways to pay for it',
                sub: 'Plans we tested, or build your own'
            }
        ]
    });
var $dfd0dc18d9f6ba43$export$2e2bcd8739ae039 = $dfd0dc18d9f6ba43$var$AgedCareSteps;


/**
 * Step 2 of the analyser: where the client stands with no plan, as four numbers and the story.
 *
 * THE NUMBERS ARE THE HEADLINE, THE STORY IS THE EXPLANATION. The plain-words note ("Where Joe
 * stands with no plan") is the clearest writing on the page and used to sit inside the inputs card,
 * below the fields, with the same figures repeated on the plan summary beside it. Here the four
 * numbers a client asks about come first — what care costs, the pension, what is left to find each
 * year, and what is left to the family — and the note follows, unchanged, to say why each is what it
 * is. No plan summary is shown on this step: this IS the baseline, and a rail restating it was one
 * more column saying the same thing.
 *
 * THREE CARDS, ONE WIDTH (owner, 22 Sep 2026: the note "looks a bit off" nested inside the tiles'
 * card). The numbers, the story and the money timeline are three sibling cards of the same width,
 * so nothing is a card inside a card.
 *
 * ONE SOURCE. The tiles read the same walk-in baseline the note reads (`useWalkInBaseline`) and the
 * same no-plan projection the plan summary measures every strategy against (`agedCareBaseline`),
 * so a figure here is the figure everywhere else.
 */ 




var $acw62 = parcelRequire("acw62");
/**
 * The years an estate figure is projected over, editable where the figure is shown.
 *
 * Owner, 25 September 2026: the village lets you change "after 5 years" on the walk-in tile and
 * watch the estate move; every module framed the same way should do the same. Nobody knows how long
 * care will be needed, so the useful question is how much the answer moves when the period changes —
 * and that is only asked if the control sits next to the number.
 *
 * One component so the control reads and behaves identically wherever it appears: the aged care and
 * village walk-in tiles, the Support at Home starting position, and the cashflow and Age Pension
 * position cards. The right-hand Financial Impact panel has carried its own "Project legacy over"
 * control since before this; this is the same idea, inline with the figure.
 */ 
parcelRequire("acw62");
const $f9873a6fbc9fd360$export$6c49baa4f9b58202 = 1;
const $f9873a6fbc9fd360$export$ff925971b671ba52 = 40;
function $f9873a6fbc9fd360$export$68741d4d7bc37a6d({ years: years, onChange: onChange, before: before = 'After', after: after = null, className: className = '', ariaLabel: ariaLabel = 'Years to project the estate over' }) {
    const value = Number(years) || 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: `inline-flex items-center gap-1 ${className}`,
        children: [
            before,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "number",
                min: $f9873a6fbc9fd360$export$6c49baa4f9b58202,
                max: $f9873a6fbc9fd360$export$ff925971b671ba52,
                value: value,
                onChange: (e)=>onChange(Math.max($f9873a6fbc9fd360$export$6c49baa4f9b58202, Math.min($f9873a6fbc9fd360$export$ff925971b671ba52, parseInt(e.target.value, 10) || $f9873a6fbc9fd360$export$6c49baa4f9b58202))),
                "aria-label": ariaLabel,
                className: "w-14 rounded-md border border-slate-300 px-1.5 py-0.5 text-center text-[13px] font-semibold text-slate-900"
            }),
            value === 1 ? 'year' : 'years',
            after
        ]
    });
}
var $f9873a6fbc9fd360$export$2e2bcd8739ae039 = $f9873a6fbc9fd360$export$68741d4d7bc37a6d;


/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b285ef0f6f9bf8bf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
            key: "1nclc0"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $b285ef0f6f9bf8bf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("eye", $b285ef0f6f9bf8bf$export$3efd853dbb351e94);


/**
 * "Where Michael stands with no plan" — the walk-in position, stated under the room price.
 *
 * WHY THIS EXISTS. The Aged Care Analyser used to be silent between entering a room price and
 * choosing a modelling mode; the explanation of the starting position lived only in the closable
 * Insight Panel. A client meeting (2026-08-20) showed what that costs: the reader closed the panel
 * in seconds and then could not work out what the system was doing. This note states the starting
 * position inline — the anchor every strategy is implicitly compared against — and it cannot be
 * closed. Owner-approved direction (v5 mock-up, 2026-08-24).
 *
 * CALCULATION DISCIPLINE: every figure comes from the real engines, and — critically — from the
 * IN-CARE assessment: `calculateFinancials` is called WITH the aged-care residency overrides, the
 * same frame the Cost Overview and Financial Impact panels use. The first cut called it without
 * them and quoted the today-at-home pension beside in-care fees — two frames in one sentence, and
 * the note disagreed with the rail by $7/day (owner caught it, 2026-08-24). The today figure is
 * still fetched, but only to SAY the bridge: "pension $X today → $Y once in care", which is also
 * what explains the before/after pair in the Financial Impact panel. The ONLY derived number is
 * the runway estimate (accessible savings ÷ yearly gap), straight-line arithmetic on engine
 * outputs, worded as "roughly … the projections show it precisely" so it can never be mistaken
 * for the projection engine's answer.
 */ 






var $acw62 = parcelRequire("acw62");


/** Shared narrative insight kit — one source of truth for the cross-module insight experience. */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b397e876e35a9277$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m18 15-6-6-6 6",
            key: "153udz"
        }
    ]
];
const $b397e876e35a9277$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-up", $b397e876e35a9277$export$3efd853dbb351e94);




var $1u0KT = parcelRequire("1u0KT");
/**
 * AgedCareWise AI (AWise) curated knowledge base.
 *
 * Authoritative, vetted definitions for the terms an LLM most often confuses. Rendered into both system
 * prompts (so the model grounds on OUR facts, not its sometimes-conflated training) and used by the
 * golden-Q&A tests (tests/awiseKnowledge.test.js) + the optional live eval (tests/awise/liveEval.test.js).
 *
 * Each concept carries `mustMention` (facts an accurate answer must include) and `notToBeConfusedWith`
 * (terms it must NOT be conflated with). Update when legislation changes — figures are indexed.
 *
 * `short` is a one-sentence, lay-person tooltip (distinct from the long `glossary` that grounds the LLM).
 * It is the single source for the narrative `JargonTerm` hover text — see `lookupGlossaryShort` below.
 */ 


/**
 * Dollar figures the glossary quotes are read from the constants the engine charges — never
 * hand-typed. They index every March and September; a typed figure sat at the March value for
 * a whole indexation before this was done.
 */ const $c79e495c2243b635$var$dollars = (n)=>{
    const decimals = Number.isInteger(n) ? 0 : 2;
    return '$' + n.toLocaleString('en-AU', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    });
};
const $c79e495c2243b635$var$HOME_CAP_TEXT = $c79e495c2243b635$var$dollars((0, $815d7df20c36742b$export$36c4ec5f3f340aef).homeExemptionCap);
const $c79e495c2243b635$export$f6c857cb22c9eb57 = Math.floor((0, $815d7df20c36742b$export$36c4ec5f3f340aef).homeExemptionCap).toLocaleString('en-AU');
/** The extra allowable amount (village and granny-flat homeowner test), from the one constant (8 Oct 2026). */ const $c79e495c2243b635$var$EAA_TEXT = $c79e495c2243b635$var$dollars((0, $1abe73eeef086faf$export$e2cf792e99a08354));
const $c79e495c2243b635$export$759c6c6c9d06ec2 = Math.floor((0, $1abe73eeef086faf$export$e2cf792e99a08354)).toLocaleString('en-AU');
const $c79e495c2243b635$var$LIFETIME_CAP_TEXT = $c79e495c2243b635$var$dollars((0, $c424aab2467b2598$export$c5fbc76332b2670f).standard);
const $c79e495c2243b635$var$NWOP_CAP_TEXT = $c79e495c2243b635$var$dollars((0, $c424aab2467b2598$export$c5fbc76332b2670f).nwop);
const $c79e495c2243b635$export$f69f5c996f5fd654 = `${Number(((0, $815d7df20c36742b$export$36c4ec5f3f340aef).MPIR * 100).toFixed(2))}%`;
const $c79e495c2243b635$export$b8e59c21370624d6 = [
    {
        id: 'granny-flat-reasonableness-test',
        term: 'Granny flat "reasonableness test"',
        glossary: 'a Centrelink valuation that applies to a GRANNY-FLAT arrangement (paying money or transferring assets to a family member for a lifetime right to live somewhere). The "reasonable value" of that lifetime right = the combined annual partnered Age Pension rate on the date the arrangement was established, multiplied by an age-based conversion factor (based on the person\'s age next birthday \u2014 the younger member if a couple). The value of the granny-flat interest is the GREATER of that reasonable value and the value of any property/construction provided. Only what the person paid (cash plus the value of any property transferred) ABOVE this value is treated as a gift (deprivation). Transferring property for the right is generally fair value, so on its own it is NOT a gift. This is SPECIFIC to granny flats and is NOT the $10,000/$30,000 gifting limits.',
        short: 'A Centrelink valuation of the lifetime right you buy in a granny-flat arrangement \u2014 only what you pay above its "reasonable value" counts as a gift.',
        mustMention: [
            'granny flat',
            'conversion factor',
            'pension rate'
        ],
        notToBeConfusedWith: [
            '$10,000 gifting limit',
            '$30,000 gifting limit'
        ]
    },
    {
        id: 'gifting-deprivation',
        term: 'Gifting / deprivation free areas',
        glossary: 'a SEPARATE, general rule (not the reasonableness test). A person can gift:\n\n- up to $10,000 per financial year, and\n- $30,000 over any rolling five financial years, without it counting.\n\nGifts above those free areas are "deprived assets," counted in the assets and income tests for five years from the gift. A granny-flat overpayment found by the reasonableness test then flows through these same free areas.',
        short: 'You can give away up to $10,000 a year (and $30,000 over any 5 years) before it counts; anything above is treated as still yours for 5 years.',
        mustMention: [
            '$10,000',
            '$30,000',
            'five'
        ],
        notToBeConfusedWith: [
            'reasonableness test'
        ]
    },
    {
        id: 'extra-allowable-amount',
        term: 'Extra Allowable Amount (EAA)',
        glossary: 'currently ' + $c79e495c2243b635$var$EAA_TEXT + " (indexed) \u2014 used for RETIREMENT VILLAGES and GRANNY FLATS to decide HOMEOWNER status. If the entry contribution / amount paid is ABOVE the EAA, the person is treated as a homeowner (lower asset limits, the amount is exempt); at or below it, a non-homeowner (higher asset limits, the amount is assessable, possible Rent Assistance).",
        short: 'A ' + $c79e495c2243b635$var$EAA_TEXT + ' threshold (indexed) that decides whether a retirement-village or granny-flat entry payment makes you a "homeowner" for the pension assets test.',
        mustMention: [
            $c79e495c2243b635$export$759c6c6c9d06ec2,
            'homeowner'
        ],
        notToBeConfusedWith: []
    },
    {
        id: 'rad-dap',
        term: 'RAD and DAP (residential aged care accommodation)',
        glossary: `the RAD (Refundable Accommodation Deposit) is a refundable lump-sum way to pay for your room. The DAP (Daily Accommodation Payment) is a daily, NON-REFUNDABLE charge on whatever part of the room you have not paid as a RAD, calculated at the government-set Maximum Permissible Interest Rate (MPIR) - currently ${$c79e495c2243b635$export$f69f5c996f5fd654} a year. So leaving room unpaid costs ${$c79e495c2243b635$export$f69f5c996f5fd654} a year on that amount and none of it comes back, while a RAD is refunded when care ends (less a 2% a year retention for the first five years) and is exempt from the Age Pension assets test. You can pay a RAD, a DAP, or any combination.`,
        short: `Two ways to pay for an aged-care room. The RAD is a refundable lump sum. The DAP is a daily, non-refundable charge on whatever you do not pay as a RAD, at the government rate of ${$c79e495c2243b635$export$f69f5c996f5fd654} a year - so an unpaid room costs ${$c79e495c2243b635$export$f69f5c996f5fd654} a year, and that money never comes back.`,
        mustMention: [
            'lump',
            'daily',
            'MPIR'
        ],
        notToBeConfusedWith: []
    },
    {
        id: 'mta-hsc-nccc',
        term: "Means-tested fees from 1 November 2025 (HSC and NCCC) \u2014 RESIDENTIAL care only",
        glossary: "RESIDENTIAL AGED CARE ONLY. From 1 November 2025 the means-tested amount drives two ongoing contributions for someone living in a residential aged care home: the Hotelling Supplement Contribution (HSC, toward everyday living costs) and the Non-Clinical Care Contribution (NCCC, toward non-clinical care). The NCCC replaces the old Means-Tested Care Fee and has a daily cap plus a lifetime cap (and a 4-year cap). The government fully funds clinical care. THESE DO NOT APPLY TO HOME CARE. A person receiving SUPPORT AT HOME pays none of the HSC, the NCCC or the Basic Daily Fee \u2014 Support at Home has its OWN contribution structure by service category (see `sah-contributions`). Never quote HSC, NCCC or the Basic Daily Fee in an answer about home care. The ONE genuine link is the LIFETIME CAP, which is combined across residential NCCC and Support at Home contributions, so amounts paid in one count toward the other.",
        short: "Residential-care only: from 1 Nov 2025, two means-tested contributions \u2014 the Hotelling Supplement Contribution (everyday living costs) and the Non-Clinical Care Contribution (non-clinical care). Neither applies to home care.",
        mustMention: [
            '1 November 2025',
            'non-clinical',
            'lifetime cap',
            'residential'
        ],
        notToBeConfusedWith: [
            'means-tested care fee (pre-Nov-2025)',
            'Support at Home contributions',
            'CHSP'
        ]
    },
    {
        /*
     * THE GAP THAT CAUSED THE WRONG ANSWER (owner-caught, 2026-08-28). Asked to compare CHSP with
     * Support at Home, AWise answered with the Basic Daily Fee, the HSC and the NCCC — all
     * RESIDENTIAL care fees that a home-care client never pays.
     *
     * It was not simply confused. There was no concept describing what Support at Home actually
     * costs, so the only "what you pay for aged care from 1 Nov 2025" entry in the knowledge base
     * was the residential one, and the model reached for the nearest thing it had. A glossary with
     * a hole in it does not produce "I don't know" — it produces the neighbouring answer.
     *
     * Rates mirror server/src/rest/calculation/supportAtHomeContributionEngine.ts (CONTRIBUTION_RATES)
     * and the lifetime caps in shared/src/calculation/supportAtHomeCalculations.ts, so the assistant
     * and the engine cannot disagree.
     */ id: 'sah-contributions',
        term: 'What you pay for Support at Home (participant contributions)',
        glossary: "HOME CARE, NOT RESIDENTIAL. Support at Home does NOT charge a Basic Daily Fee, a Hotelling Supplement Contribution or a Non-Clinical Care Contribution \u2014 those are residential aged care only. Instead the participant contributes a PERCENTAGE of the cost of each service, and the percentage depends on TWO things: which of three service categories the service falls into, and the person's means-tested category.\n\nThe three categories:\n- CLINICAL CARE (nursing, allied health, care management): the participant pays 0%. The government funds it in full for everyone, regardless of means.\n- INDEPENDENCE (personal care, respite, help with daily activities): 5% for a full pensioner, sliding 5-50% for a part pensioner, 50% for a self-funded retiree.\n- EVERYDAY LIVING (cleaning, meals, gardening, transport, home maintenance): 17.5% for a full pensioner, sliding 17.5-80% for a part pensioner, 80% for a self-funded retiree.\n\nSo the pattern is: clinical care free to everyone, and the further a service is from clinical need, the more the participant contributes. Contributions are a share of the SERVICES USED, not a flat daily fee \u2014 someone who uses less pays less.\n\nNO WORSE OFF PRINCIPLE: people who had a Home Care Package or were assessed as eligible before 13 September 2024 keep their old, generally lower arrangements (Category A pays 0%; Category B up to 25%).\n\nLIFETIME CAP: contributions count toward a lifetime cap that is COMBINED with the residential NCCC \u2014 " + $c79e495c2243b635$var$LIFETIME_CAP_TEXT + ' on standard rates, or ' + $c79e495c2243b635$var$NWOP_CAP_TEXT + ' under the No Worse Off Principle (indexed 20 March and 20 September). This shared cap is the ONLY real link between the home-care and residential fee systems.',
        short: "In Support at Home you pay a share of each service used: nothing for clinical care, 5-50% for independence services and 17.5-80% for everyday living, depending on your means \u2014 not a daily fee.",
        mustMention: [
            'clinical',
            'independence',
            'everyday living',
            '0%',
            'lifetime cap'
        ],
        notToBeConfusedWith: [
            'Basic Daily Fee',
            'HSC',
            'NCCC',
            'residential aged care',
            'CHSP'
        ]
    },
    {
        id: 'basic-daily-fee',
        term: 'Basic Daily Fee (BDF)',
        glossary: 'a standard fee everyone in residential aged care pays toward day-to-day living costs (meals, cleaning, laundry). It is set at 85% of the single basic Age Pension and everyone pays it regardless of means.',
        short: 'A standard residential-care fee everyone pays toward day-to-day living costs, set at 85% of the single basic Age Pension.',
        mustMention: [
            '85%',
            'everyone'
        ],
        notToBeConfusedWith: [
            'means-tested',
            'Support at Home contributions',
            'CHSP'
        ]
    },
    {
        id: 'deeming',
        term: 'Deeming',
        glossary: 'for the Age Pension income test, Centrelink "deems" your financial assets to earn a set rate of income rather than counting the actual return. A lower rate applies up to a threshold and a higher rate above it. It applies to financial investments (bank accounts, shares, super once you reach pension age), not to your home.',
        short: 'For the pension income test, Centrelink assumes your financial assets earn a set rate of income rather than counting what they actually earn.',
        mustMention: [
            'financial',
            'income test',
            'rate'
        ],
        notToBeConfusedWith: []
    },
    {
        id: 'illness-separated-couple',
        term: 'Illness-separated couple',
        glossary: 'when members of a couple must live apart (for example one enters residential aged care) because of illness or infirmity, Centrelink can assess them under more generous "illness-separated" thresholds and pay each the single rate, even though they are still a couple.',
        short: 'When a couple must live apart because of illness (e.g. one enters residential care), Centrelink can pay each the single rate and use more generous thresholds.',
        mustMention: [
            'live apart',
            'single rate'
        ],
        notToBeConfusedWith: []
    },
    {
        /*
     * OWNER-REQUESTED, 2026-08-28: "important that AWise is trained up on CHSP in the event it gets
     * asked questions."
     *
     * Three things an LLM reliably gets wrong here, each of which would mislead a client:
     *
     *   1. IT IS NOT MEANS TESTED. Every other cost in this app is — residential care, Support at
     *      Home, the Age Pension. The model's prior is overwhelmingly "aged care cost = means
     *      tested", and applying that here invents an income and assets test that does not exist.
     *   2. THE MERGE IS OFF. Training data through mid-2026 says CHSP folds into Support at Home
     *      from 1 July 2027. That was reversed on 20 August 2026 — CHSP is funded to 30 June 2029
     *      and the government has confirmed it stays STANDALONE.
     *   3. WE DO NOT MODEL IT, AND THAT IS NOT A GAP. There is no formula to model: fees are set by
     *      each provider. The assistant must say so rather than produce a number, which is the one
     *      failure that would actually cost a client money.
     */ id: 'chsp',
        term: 'Commonwealth Home Support Program (CHSP)',
        glossary: "ENTRY-LEVEL in-home aged care \u2014 the step below Support at Home. It funds individual services rather than a budget: domestic assistance, personal care, meals (including Meals on Wheels), transport, social support, home maintenance and modifications, allied health and respite. About 830,000 older Australians use it through around 1,300 providers.\n\nHOW IT IS FUNDED AND CHARGED (the part most often got wrong): CHSP is BLOCK FUNDED to the PROVIDER, not allocated as an individual budget to the person. There is NO MEANS TEST \u2014 no income test and no assets test. Each provider sets its own fees under the national CHSP Client Contribution Framework, based on a client's capacity to pay, and a person CANNOT be refused a service because they are unable to contribute. Because fees differ from provider to provider there is no formula, so AgedCareWise does NOT model CHSP contributions \u2014 say this plainly rather than estimating a figure.\n\nSTATUS: CHSP came under the Aged Care Act 2024 on 1 November 2025. On 20 August 2026 the Government extended CHSP funding to 30 JUNE 2029 and confirmed it will REMAIN A STANDALONE PROGRAM rather than being folded into Support at Home \u2014 reversing the earlier plan to merge it from 1 July 2027. Consultation on its long-term future (block funding, client contributions, integration with Support at Home) began in 2026, so contribution arrangements may change after that.\n\nA CHSP client is still well served by the rest of AgedCareWise: the Age Pension, downsizing, retirement village, granny flat and future residential care modelling all apply regardless of which home-care program they are on.",
        short: "Entry-level in-home support (cleaning, meals, transport, social support) \u2014 funded to providers, with no income or assets test; each provider sets its own fee.",
        mustMention: [
            'entry-level',
            'no means test',
            '830,000',
            '30 june 2029',
            'standalone'
        ],
        notToBeConfusedWith: [
            'Support at Home',
            'Home Care Packages',
            'means-tested care fee',
            'residential aged care'
        ]
    },
    {
        id: 'downsizer-contribution',
        term: 'Downsizer contribution (super)',
        glossary: 'people aged 55 or over can contribute up to $300,000 each ($600,000 a couple) from the proceeds of selling an eligible home into superannuation, outside the usual contribution caps. Note the money inside super still counts for the Age Pension means test once you reach pension age.',
        short: 'People aged 55+ can put up to $300,000 each ($600,000 a couple) from selling an eligible home into super, outside the usual contribution caps.',
        mustMention: [
            '55',
            '300,000',
            'super'
        ],
        notToBeConfusedWith: [
            'transfer balance cap'
        ]
    },
    {
        /*
     * The term appeared on five client-facing screens with no definition anywhere (2026-08-28), and
     * an LLM asked about it reaches for the wrong cap: it is NOT a limit on what you may hold in
     * super, NOT the contribution caps, and NOT the $3m Division 296 threshold. It caps only what
     * may be MOVED into the tax-free retirement phase.
     */ id: 'transfer-balance-cap',
        term: 'Transfer balance cap (TBC)',
        glossary: 'a LIFETIME limit on how much a person may move into a retirement-phase (tax-free) super pension. Earnings in retirement phase are taxed at 0%, which is why the amount going in is capped. The general cap is $2.1m from 1 July 2026 (it was $2.0m); a person\'s PERSONAL cap is between $1.6m and the general cap depending on when they first commenced a retirement-phase pension, and the ATO reports their usage as the "transfer balance account". It limits TRANSFERS IN, not growth: a pension that later grows beyond the cap does not breach it, and a downsizer contribution counts towards the cap only when it is used to commence a pension. Money that cannot be moved in stays in an ACCUMULATION account, where earnings are taxed at 15%.',
        short: "A lifetime limit (currently $2.1m) on how much you can move into a tax-free retirement pension \u2014 anything above it stays in accumulation super, taxed at 15%.",
        mustMention: [
            'retirement phase',
            'lifetime',
            'accumulation'
        ],
        notToBeConfusedWith: [
            'contribution caps',
            'Division 296',
            '$3 million',
            'total super balance'
        ]
    },
    {
        id: 'rent-assistance',
        term: 'Commonwealth Rent Assistance (CRA)',
        glossary: 'a supplementary payment on top of the Age Pension for NON-homeowners who pay private rent. It pays 75c for every $1 of rent above a minimum, up to a maximum. It is not paid to homeowners, in public housing, or usually when renting from a family member you live with, and it is not counted as income for the pension income test.',
        short: 'A supplementary payment on top of the Age Pension for non-homeowners who pay private rent.',
        mustMention: [
            'non-homeowner',
            'rent',
            'pension'
        ],
        notToBeConfusedWith: []
    },
    {
        id: 'protected-person',
        term: 'Protected person (aged care means test)',
        glossary: 'a real and important aged-care concept. When someone moves into residential aged care, their former home is EXCLUDED from the aged care means assessment while a "protected person" still lives in it. A protected person is:\n\n- the person\'s partner;\n- a dependent child;\n- a carer who has lived in the home for at least 2 years and is eligible for an Australian income support payment;\n- or a close relative who has lived in the home for at least 5 years and is eligible for an income support payment.\n\nIf there is NO protected person in the home, the former home is counted in the aged care means test, but only up to the home exemption cap (not full market value). This is aged-care-specific: the Age Pension assets test treats the former home under its own separate rules.',
        short: 'Someone (partner, dependent child, or an eligible long-term carer or close relative) whose living in your former home keeps it out of the aged care means test.',
        mustMention: [
            'partner',
            'dependent child',
            'carer',
            '2 years',
            '5 years',
            'income support'
        ],
        notToBeConfusedWith: [
            'Age Pension assets test treatment of the home'
        ]
    },
    {
        id: 'home-exemption-cap',
        term: 'Home exemption cap (aged care)',
        glossary: "when the former home IS counted in the residential aged care means test (because no protected person lives there), it is only counted up to a capped value \u2014 currently " + $c79e495c2243b635$var$HOME_CAP_TEXT + " (indexed with the Age Pension in March and September) \u2014 no matter how much the home is actually worth. The home is never counted at full market value for aged care fees. This cap is aged-care-only; it is not part of the Age Pension assets test.",
        short: "The most of your former home's value that can count in the aged care means test \u2014 currently " + $c79e495c2243b635$var$HOME_CAP_TEXT + " (indexed) \u2014 never the full market value.",
        mustMention: [
            $c79e495c2243b635$export$f6c857cb22c9eb57,
            'indexed',
            'means test'
        ],
        notToBeConfusedWith: [
            'Age Pension assets test'
        ]
    },
    {
        /*
     * EQUITY RELEASE, which AWise could not explain at all.
     *
     * Owner-raised, 2026-09-01, of a reverse mortgage strategy topping the cashflow ranking with
     * nothing on screen naming the product: the explainer "needs to clearly outline the
     * implications of this product type - its literally silent on this matter which is extremely
     * dangerous!" The knowledge base was silent too, so a client asking AWise what it was would
     * have got whatever the model happened to know.
     */ id: 'equity-release',
        term: 'Reverse mortgage and the Home Equity Access Scheme',
        glossary: 'a loan secured against your home that you make NO repayments on. The interest is added to the loan each year and the whole debt is repaid when the home is sold - usually on death or a permanent move into care.\n\nTWO KINDS. HOME EQUITY ACCESS SCHEME (HEAS) is the government\'s version, run by Services Australia, at a much lower rate than commercial lenders; it is paid as a fortnightly stream or lump sums, and the payments are NOT counted as income for the Age Pension. A COMMERCIAL REVERSE MORTGAGE is a lump sum or drawdown from a bank or specialist lender at a substantially higher rate - usually the only route to a large lump sum such as an accommodation deposit.\n\nTHE RISK IS THE COMPOUNDING, AND IT IS INVISIBLE IN CASHFLOW. Because nothing is repaid, interest is charged on interest, and NONE of it shows up in a yearly cashflow figure - there is no repayment to show. The cost appears only in what is left at the end, so a plan that looks comfortable year to year can be the most expensive one on the table. As a rule of thumb a debt roughly doubles every nine years at 8%, and every eighteen years at 4%.\n\nWHAT ELSE TO KNOW. The debt is settled out of the house, so it directly reduces the estate. A NO NEGATIVE EQUITY GUARANTEE is required by Australian law, so you can never owe more than the home is worth and the estate cannot be pursued for a shortfall - real protection, but it protects against the worst case, not against the cost. The home usually has to be SOLD to repay it, so a family wanting to keep it must find the money elsewhere. Anyone else living in the home should be named on the loan or their right to stay can end. Independent legal advice is a legal REQUIREMENT for a commercial reverse mortgage. For Centrelink the home stays exempt, but borrowed money sitting in the bank is counted and deemed - money paid straight into a RAD is exempt, which is why borrowing to pay a deposit can work where borrowing to hold cash does not.',
        short: 'A loan against your home with no repayments - the interest compounds and the debt is repaid when the house is sold. Because nothing is repaid, none of its cost appears in your cashflow; it all lands on the estate. The government\'s Home Equity Access Scheme is the cheaper version; a commercial reverse mortgage costs considerably more.',
        mustMention: [
            'no repayments',
            'compound',
            'estate'
        ],
        notToBeConfusedWith: [
            'downsizing'
        ]
    },
    {
        /*
     * WHAT AN ANNUITY IS, and what it costs you.
     *
     * AWise knew how a COUPLE could own one and how it was assessed, but not what the product was
     * or what is given up to get it — so a client meeting the concept for the first time inside a
     * six- or seven-figure recommendation could ask the obvious question and get the mechanics of
     * ownership back. Owner-raised, 2026-09-01: "an annuity will be a foreign concept."
     *
     * The risks carry the same weight as the benefits here deliberately. A guaranteed income is
     * genuinely attractive, and the thing being given up — permanent access to a large sum — is
     * exactly what a client will not think to ask about.
     */ id: 'annuity-what-it-is',
        term: 'Lifetime annuity (what it is, and the risks)',
        glossary: "a product you buy from an insurance company with a lump sum, which then pays you a set amount every year for the rest of your life (or for a fixed number of years, if you choose a fixed-term one instead). It is the closest thing to a private pension you can buy.\n\nWHY IT COMES UP HERE: Centrelink counts only 60% of what you paid as an asset for the first five years, or until age 85 if that is later, and 30% after that. Money in the bank is counted in full. So moving money into an annuity can lift the Age Pension, and can lower aged care or Support at Home contributions, because less is counted.\n\nWHAT YOU GIVE UP:\n- MOST OF THE MONEY IS NO LONGER WITHIN REACH. What you can get back depends on the type. An income-only (nil residual) annuity can never be cashed in. A money-back annuity can be, but only for a withdrawal value that falls each year to nothing, so the longer you hold it the less there is. If a large unexpected cost arrives \u2014 a care home deposit, a health crisis, helping a child \u2014 expect little or none of it to be available.\n- YOU MAY NOT GET BACK WHAT YOU PAID. On a nil-residual (nil RCV) annuity, if you die early the provider keeps the balance and your estate receives nothing. Living a long time is what makes it pay off.\n- INFLATION. A flat payment buys noticeably less after fifteen or twenty years. An indexed annuity solves that but starts lower.\n- FOR A COUPLE, WHETHER IT CONTINUES. If it is not reversionary and not jointly owned, the income STOPS when the owner dies and the survivor receives nothing from it. This is the term people most often miss.\n- YOU ARE RELYING ON THE PROVIDER. Payments depend on the insurer still being there in twenty or thirty years. They are regulated and must hold capital against exactly that, but it is not a government guarantee.\n\nRESIDUAL CAPITAL VALUE (RCV) is the share of the purchase price that comes back on death. A nil-RCV annuity pays the most and leaves nothing. A 100% RCV annuity pays less, and returns the full purchase price only if death is within the first half of your life expectancy; after that the amount falls each year, reaching nothing at life expectancy. That declining schedule is the condition for Centrelink counting only 60% of the annuity, so both versions are assessed the SAME (60%).\n\nFULL AMOUNT BACK, AT ANY TIME: some providers sell people in aged care, or receiving support at home, a guaranteed income for life combined with life cover. The whole amount goes back to the family whenever death comes, early or late. It pays the lowest income, and Centrelink counts only its income part at 60%; the life cover part is counted in full, so it does less for the pension and the fees than the other types.",
        short: "You hand an insurer a lump sum and they pay you a set income for life. Centrelink counts only 60% of what you paid (for the first five years, or until age 85 if that is later, and 30% after that), which can lift the Age Pension \u2014 but the capital is mostly out of reach (an income-only annuity returns nothing; a money-back one only a falling amount if cashed in or on an early death), the payment may not keep up with inflation, and unless it is reversionary or jointly owned the income stops when the owner dies.",
        mustMention: [
            '60%',
            'capital',
            'reversionary'
        ],
        notToBeConfusedWith: [
            'account-based pension'
        ]
    },
    {
        id: 'annuity-ownership',
        term: 'Annuity ownership (individual, reversionary or joint)',
        glossary: "how a couple can hold a lifetime annuity. THREE structures:\n\n- JOINT names \u2014 both own it; if one dies it keeps paying the survivor automatically. Only available when bought with ORDINARY (non-super) money.\n- ONE name + a REVERSIONARY nomination \u2014 owned by one person who nominates the other to keep receiving the income if the owner dies first; this is REQUIRED when bought with SUPER or account-based-pension money, because super cannot be jointly owned.\n- ONE name, no reversionary \u2014 payments stop on the owner's death (highest income while alive; suits a single person).\n\nFor a COUPLE the Age Pension and aged-care means tests are the SAME whichever you choose (a couple is assessed on half the combined assets and income regardless of whose name it is in), so the choice is driven by the funding source (super forces one-name + reversionary) and estate goals. Putting a one-name annuity in the OLDER partner's name can bring forward the assets-test step-down (from counting 60% of the purchase price to 30%), and a reversionary passes that earlier step-down date to the survivor. The provider will ask who owns it when a quote is requested.",
        short: 'How a couple holds an annuity: jointly (both own it), or in one name with a reversionary nomination so it continues to the partner. Super money must be one-name + reversionary; ordinary money can be either, and it doesn\'t change the means test.',
        mustMention: [
            'reversionary',
            'joint',
            'super'
        ],
        notToBeConfusedWith: []
    },
    {
        id: 'capital-gains-tax',
        term: 'Capital gains tax (CGT)',
        glossary: "not a separate tax \u2014 the PROFIT on selling an investment asset is added to the owner's taxable income in the year of sale and taxed at their marginal rate. The profit is the sale price minus the cost base (what was paid for it plus buying, selling and improvement costs).\n\n- Held for at least 12 months? Individuals only include HALF the gain (the 50% CGT discount).\n- Jointly owned? The gain splits between the owners, each taxed at their own rate.\n- Owned by a company or trust? That structure's tax rules apply instead.\n- The family home is generally exempt, and assets bought before 20 September 1985 are pre-CGT (no CGT at all).\n\nAgedCareWise shows an ESTIMATE \u2014 the exact figure depends on the person's full tax return for that year and should be confirmed with their accountant.",
        short: "Tax on the profit when an investment is sold: the gain (sale price minus cost base) is added to taxable income \u2014 usually halved if held over 12 months \u2014 and taxed at each owner's marginal rate. The figure shown is an estimate; an accountant confirms the exact amount.",
        mustMention: [
            'cost base',
            '50% CGT discount',
            'marginal rate'
        ],
        notToBeConfusedWith: [
            'stamp duty',
            'selling costs'
        ]
    },
    {
        id: 'home-sale-proceeds-exemption',
        term: 'Home sale proceeds exemption (24-month rule)',
        glossary: "when a principal home is sold and the person INTENDS to use some of the proceeds to buy (or build) a new home, that portion is EXEMPT from the Age Pension assets test for up to 24 months from the sale (extendable to 36 months for delays outside their control, such as building delays).\n\n- During the exemption the set-aside money is only counted under the income test, and at the LOWER deeming rate.\n- Once the new home is bought it becomes the exempt principal home and this rule ends.\n- Only the portion intended for the new home is covered \u2014 proceeds intended for anything else are counted normally.\n\nServices Australia should be told within 14 days of the sale.",
        short: 'Money from selling the home that is set aside to buy the next one stays exempt from the assets test for up to 24 months (36 with delays outside your control), and is deemed at the lower rate meanwhile.',
        mustMention: [
            '24 months',
            'deeming',
            'principal home'
        ],
        notToBeConfusedWith: [
            'the downsizer contribution',
            'the aged care former-home exemption'
        ]
    },
    {
        id: 'rv-entry-contribution',
        term: 'Entry contribution (retirement village)',
        glossary: "the lump sum paid to move into a retirement village unit \u2014 often structured as an interest-free loan or a licence to occupy rather than buying the property. How much of it comes back on leaving depends entirely on the CONTRACT (most commonly the amount less the deferred management fee and any reinstatement costs, sometimes plus a share of capital gain).\n\nFor Centrelink, the entry contribution is compared with the Extra Allowable Amount (" + $c79e495c2243b635$var$EAA_TEXT + "): pay MORE and the resident is a homeowner with the contribution exempt from the assets test; pay that much or LESS and they are a non-homeowner \u2014 the contribution is counted as an asset (not deemed), the higher non-homeowner asset limits apply, and Rent Assistance may be payable on the ongoing fees.",
        short: 'The lump sum paid to move into a village unit. Above ' + $c79e495c2243b635$var$EAA_TEXT + ": treated as a homeowner and the amount is exempt. At or below: non-homeowner \u2014 the amount is counted, but higher asset limits and possibly Rent Assistance apply.",
        mustMention: [
            'Extra Allowable Amount',
            'homeowner',
            'Rent Assistance'
        ],
        notToBeConfusedWith: [
            'a RAD (residential aged care)',
            'strata purchase'
        ]
    },
    {
        id: 'account-based-pension',
        term: 'Account-based pension (super pension)',
        glossary: 'your super, switched on as a regular income. Once you have reached preservation age and retired you can move super from the accumulation account into an account-based pension: the money stays invested and stays yours, but its investment earnings become tax free, and you draw a regular income from it (at least a minimum each year, set by your age). You can take out more, or a lump sum, whenever you like.\n\nFor Centrelink the balance is counted in full as an asset and deemed to earn income, whatever it actually pays. Only what fits under the transfer balance cap can be moved in.',
        short: 'Super switched on as a regular income: the money stays invested and yours, its earnings become tax free, and you draw from it as you need. Counted in full by Centrelink and deemed.',
        mustMention: [
            'tax free',
            'deemed',
            'transfer balance cap'
        ],
        notToBeConfusedWith: [
            'lifetime annuity'
        ]
    },
    {
        id: 'shares-managed-funds',
        term: 'Shares and managed funds',
        glossary: "money invested in a spread of companies, either directly (shares) or through a fund a manager runs for you (managed funds, ETFs). It can be sold at any time, usually within days, so it stays accessible \u2014 the opposite of an annuity \u2014 and over the long run it has grown faster than cash, with ups and downs along the way.\n\nFor Centrelink the value is counted in full as an asset and deemed to earn a set rate of income, whatever it actually pays in dividends. Selling can trigger capital gains tax.",
        short: 'Money invested in companies, directly or through a fund. Accessible any time, grows over the long run with ups and downs; counted in full by Centrelink and deemed.',
        mustMention: [
            'deemed',
            'capital gains tax',
            'accessible'
        ],
        notToBeConfusedWith: [
            'lifetime annuity'
        ]
    },
    {
        id: 'investment-property',
        term: 'Investment property (rented out)',
        glossary: "a property you own and rent to someone else. The rent, less the costs of owning it (rates, insurance, maintenance, agent fees), is income; the property itself is expected to grow in value over time but cannot be sold quickly or in part.\n\nFor Centrelink the property is counted in full as an asset at its market value, and the net rent counts in the income test \u2014 it is not deemed. Buying one costs stamp duty and selling one can trigger capital gains tax, and both come out of your money.",
        short: 'A property you rent out. Counted in full as an asset; the rent after costs counts as income. Stamp duty to buy, capital gains tax when sold.',
        mustMention: [
            'stamp duty',
            'capital gains tax',
            'net rent'
        ],
        notToBeConfusedWith: [
            'the family home'
        ]
    },
    {
        id: 'funeral-bond',
        term: 'Funeral bond',
        glossary: 'money set aside to pay for a funeral, held by a friendly society or life insurer. It can only be used for the funeral, and only when the time comes. Within the allowable limit (a set amount per person, indexed each July) it is exempt from the Age Pension assets test and not deemed, which is why it appears as a means-test strategy.\n\nIt is not a savings account: the money is locked, the return is modest, and anything above the limit is counted as an ordinary asset.',
        short: 'Money set aside for a funeral with a friendly society or insurer. Within the limit it is exempt from the assets test and not deemed; it can only be used for the funeral.',
        mustMention: [
            'exempt',
            'limit',
            'funeral'
        ],
        notToBeConfusedWith: [
            'pre-paid funeral',
            'gifting'
        ]
    },
    {
        id: 'deferred-management-fee',
        term: 'Deferred management fee (DMF)',
        glossary: "the exit fee most retirement village contracts charge \u2014 deferred because nothing is paid while living there; it is deducted from the entry contribution when the resident leaves. Typically it accrues as a PERCENTAGE PER YEAR of the entry price (or, in some contracts, the resale value) \u2014 for example 3% a year \u2014 and stops accruing after a CAP, commonly 5 to 10 years.\n\nContracts differ widely: some also deduct reinstatement or refurbishment costs, and some share any capital gain on resale with the resident. The DMF is why the amount returned to the resident (or their estate) is usually well below the amount paid in \u2014 always read the contract, and get legal advice before signing.",
        short: "The exit fee a village deducts from the entry money when you leave \u2014 usually a percentage per year of residence, capped after a set number of years. It is why less comes back than went in.",
        mustMention: [
            'percentage per year',
            'cap',
            'exit'
        ],
        notToBeConfusedWith: [
            'the 2% a year RAD retention (aged care)',
            'ongoing service fees'
        ]
    }
];
function $c79e495c2243b635$export$37a8fb3a3ffc9c34() {
    const lines = $c79e495c2243b635$export$b8e59c21370624d6.map((c)=>`- ${c.term}: ${c.glossary}`);
    return "KEY CONCEPTS \u2014 authoritative definitions for terms that are commonly confused. Use these definitions exactly and do NOT confuse them with one another:\n\n" + lines.join('\n\n') + '\n\nIf asked about the "reasonableness test", explain the granny-flat valuation above \u2014 do NOT answer with the $10k/$30k gifting limits (that is the separate gifting rule).' + '\n\nThis list is NOT the limit of your knowledge. You are an expert on Australian aged care, retirement living, Age Pension and social security, superannuation, tax and estate matters. For any genuine concept in those areas that is not listed above (for example a term the user has just seen on an AgedCareWise screen), answer confidently and accurately from official Australian sources. NEVER tell the user that a real concept from these areas "is not a known term" or does not exist merely because it is not in this list. If you are genuinely unsure a term exists, say what it most likely refers to and point to the official source, rather than denying it.';
}
/**
 * Aliases that resolve a term (acronym or full name) used in narratives back to a concept id.
 * Keys are matched case-insensitively after trimming. The concept's own `term` is always matched too.
 */ const $c79e495c2243b635$var$GLOSSARY_ALIASES = {
    rad: 'rad-dap',
    'refundable accommodation deposit': 'rad-dap',
    dap: 'rad-dap',
    'daily accommodation payment': 'rad-dap',
    mpir: 'rad-dap',
    'maximum permissible interest rate': 'rad-dap',
    hsc: 'mta-hsc-nccc',
    'hotelling supplement contribution': 'mta-hsc-nccc',
    nccc: 'mta-hsc-nccc',
    'non-clinical care contribution': 'mta-hsc-nccc',
    bdf: 'basic-daily-fee',
    'basic daily fee': 'basic-daily-fee',
    eaa: 'extra-allowable-amount',
    'extra allowable amount': 'extra-allowable-amount',
    deeming: 'deeming',
    deemed: 'deeming',
    'deemed income': 'deeming',
    'illness-separated': 'illness-separated-couple',
    'illness separated': 'illness-separated-couple',
    downsizer: 'downsizer-contribution',
    'downsizer contribution': 'downsizer-contribution',
    'support at home contributions': 'sah-contributions',
    'support at home fees': 'sah-contributions',
    'home care contributions': 'sah-contributions',
    'home care fees': 'sah-contributions',
    'clinical care': 'sah-contributions',
    independence: 'sah-contributions',
    'everyday living': 'sah-contributions',
    chsp: 'chsp',
    'commonwealth home support': 'chsp',
    'commonwealth home support program': 'chsp',
    'commonwealth home support programme': 'chsp',
    'entry-level support': 'chsp',
    'entry level support': 'chsp',
    'entry-level home care': 'chsp',
    tbc: 'transfer-balance-cap',
    'transfer balance cap': 'transfer-balance-cap',
    'transfer balance account': 'transfer-balance-cap',
    'retirement phase': 'transfer-balance-cap',
    cra: 'rent-assistance',
    'rent assistance': 'rent-assistance',
    'commonwealth rent assistance': 'rent-assistance',
    gifting: 'gifting-deprivation',
    deprivation: 'gifting-deprivation',
    'reasonableness test': 'granny-flat-reasonableness-test',
    'protected person': 'protected-person',
    'protected persons': 'protected-person',
    'home exemption cap': 'home-exemption-cap',
    'home exemption': 'home-exemption-cap',
    reversionary: 'annuity-ownership',
    'reversionary annuity': 'annuity-ownership',
    'reversionary beneficiary': 'annuity-ownership',
    'annuity ownership': 'annuity-ownership',
    'joint ownership': 'annuity-ownership',
    cgt: 'capital-gains-tax',
    'capital gains tax': 'capital-gains-tax',
    'capital gains': 'capital-gains-tax',
    '24-month rule': 'home-sale-proceeds-exemption',
    'home sale proceeds exemption': 'home-sale-proceeds-exemption',
    'home-sale proceeds exemption': 'home-sale-proceeds-exemption',
    'entry contribution': 'rv-entry-contribution',
    'entry fee': 'rv-entry-contribution',
    'account-based pension': 'account-based-pension',
    'account based pension': 'account-based-pension',
    'super pension': 'account-based-pension',
    abp: 'account-based-pension',
    'shares and managed funds': 'shares-managed-funds',
    'managed funds': 'shares-managed-funds',
    shares: 'shares-managed-funds',
    'investment property': 'investment-property',
    'funeral bond': 'funeral-bond',
    'lifetime annuity': 'annuity-what-it-is',
    annuity: 'annuity-what-it-is',
    'reverse mortgage': 'equity-release',
    heas: 'equity-release',
    'home equity access scheme': 'equity-release',
    dmf: 'deferred-management-fee',
    'deferred management fee': 'deferred-management-fee'
};
const $c79e495c2243b635$var$normaliseTerm = (term)=>String(term || '').trim().toLowerCase();
function $c79e495c2243b635$export$c928564c70d3b3f(term) {
    const key = $c79e495c2243b635$var$normaliseTerm(term);
    if (!key) return null;
    const id = $c79e495c2243b635$var$GLOSSARY_ALIASES[key];
    if (id) return $c79e495c2243b635$export$b8e59c21370624d6.find((c)=>c.id === id) || null;
    return $c79e495c2243b635$export$b8e59c21370624d6.find((c)=>$c79e495c2243b635$var$normaliseTerm(c.term) === key) || null;
}
function $c79e495c2243b635$export$522b6ee8c9e1e75c(term) {
    const concept = $c79e495c2243b635$export$c928564c70d3b3f(term);
    return concept ? concept.short || concept.glossary : null;
}
var $c79e495c2243b635$export$2e2bcd8739ae039 = $c79e495c2243b635$export$b8e59c21370624d6;


// One-time "meet your adviser" intro. Shown on the FIRST insight panel the user opens in a session
// (any module), then suppressed everywhere else via this sessionStorage flag — so it doesn't repeat
// when they move between Aged Care, Support at Home and Retirement Village.
const $357e6188006bbf96$var$ADVISER_INTRO_FLAG = 'awiseAdviserIntroSeen';
const $357e6188006bbf96$var$readIntroSeen = ()=>{
    try {
        return typeof window !== 'undefined' && window.sessionStorage?.getItem($357e6188006bbf96$var$ADVISER_INTRO_FLAG) === '1';
    } catch  {
        return true; // if storage is unavailable, don't block the panel with an intro
    }
};
function $357e6188006bbf96$export$2e58bf066eef6dcd() {
    try {
        window.sessionStorage?.removeItem($357e6188006bbf96$var$ADVISER_INTRO_FLAG);
    } catch  {}
}
/** The shared first-run greeting from AWise, the digital adviser. */ function $357e6188006bbf96$var$AdviserIntro({ onDismiss: onDismiss, userName: userName }) {
    const greeting = userName && userName !== 'there' ? `Hi ${userName}, I'm AWise` : "Hi, I'm AWise";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-3 flex items-center gap-2.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                        icon: (0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039),
                        tone: "brand",
                        variant: "solid",
                        size: "sm"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "m-0 text-[15px] font-semibold text-slate-900",
                        children: greeting
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mb-2 text-sm leading-relaxed text-slate-600",
                children: "I'm your digital adviser. As you explore options and make changes, I'll explain what's happening and why."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mb-4 text-sm leading-relaxed text-slate-600",
                children: "You can move me around, close or reopen me whenever you like."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                onClick: onDismiss,
                variant: "brand",
                fullWidth: true,
                children: "Got it \u2014 let's go"
            })
        ]
    });
}
/**
 * Shared "What's happening?" narrative panel — ONE component used by every module
 * (Aged Care, Support at Home, Retirement Village), in both manual and suggestion-engine modes,
 * so the voice and look are identical everywhere. See docs/UI_UX_HERO_PATH_AUDIT.md (X3b).
 *
 * Exports:
 *   NarrativePanel       the draggable, dockable shell (move-around preserved)
 *   NarrativeCard        the standard insight card (drop-in for the old per-module StrategyCard)
 *   NarrativeCollapsible expandable detail block (drop-in for the old InsightCollapsible)
 *   NarrativeBeat        a single story beat: bold takeaway + plain-language body
 *   JargonTerm           inline term with a plain-language explanation on hover
 */ const $357e6188006bbf96$var$DRAG_PANEL_RESERVE = 16; // keep a sliver on-screen when dragged to the edge
/**
 * A phone, at the same 768px line SmallScreenNotice draws — so the two pieces of phone-specific
 * behaviour in the app agree about what a phone is. Tablets and laptops are on the other side of
 * it and keep the floating, draggable panel exactly as it was.
 */ const $357e6188006bbf96$var$PHONE_QUERY = '(max-width: 767px)';
const $357e6188006bbf96$var$phoneMatches = ()=>typeof window !== 'undefined' && window.matchMedia($357e6188006bbf96$var$PHONE_QUERY).matches;
const $357e6188006bbf96$var$useIsPhone = ()=>{
    const [isPhone, setIsPhone] = (0, $acw62.useState)($357e6188006bbf96$var$phoneMatches);
    (0, $acw62.useEffect)(()=>{
        if (typeof window === 'undefined') return undefined;
        const mq = window.matchMedia($357e6188006bbf96$var$PHONE_QUERY);
        const onChange = (e)=>setIsPhone(e.matches);
        mq.addEventListener('change', onChange);
        setIsPhone(mq.matches);
        return ()=>mq.removeEventListener('change', onChange);
    }, []);
    return isPhone;
};
function $357e6188006bbf96$export$e6f4a6221f530693({ title: title = "What's happening?", markUrl: markUrl, width: width = 360, initialPos: initialPos = {
    x: 60,
    y: 120
}, userName: userName, onBackToDashboard: onBackToDashboard, children: children }) {
    const isPhone = $357e6188006bbf96$var$useIsPhone();
    // Open on arrival on a tablet or laptop, exactly as before. On a phone it starts as the
    // "Show insights" chip instead: the screen is the scarce resource there, and an overlay that
    // opens itself across the content is a poor greeting — particularly right after the
    // small-screen notice has said this section is a squeeze. Read once, at mount, so resizing
    // never overrides what the reader has since chosen.
    const [showPanel, setShowPanel] = (0, $acw62.useState)(()=>!$357e6188006bbf96$var$phoneMatches());
    const [showIntro, setShowIntro] = (0, $acw62.useState)(()=>!$357e6188006bbf96$var$readIntroSeen());
    const [pos, setPos] = (0, $acw62.useState)(initialPos);
    const [isDragging, setIsDragging] = (0, $acw62.useState)(false);
    const dragRef = (0, $acw62.useRef)(null);
    const dismissIntro = ()=>{
        try {
            window.sessionStorage?.setItem($357e6188006bbf96$var$ADVISER_INTRO_FLAG, '1');
        } catch  {}
        setShowIntro(false);
    };
    /** Keeps the panel on screen: the same clamp the drag uses, so both agree. */ const clampToViewport = (nx, ny)=>({
            x: Math.max(0, Math.min(window.innerWidth - (width - $357e6188006bbf96$var$DRAG_PANEL_RESERVE), nx)),
            y: Math.max(0, Math.min(window.innerHeight - 200, ny))
        });
    // POINTER events, not mouse events. Dragging was `mousedown`/`mousemove`, which a touchscreen
    // never fires for a drag gesture — so on an iPad the panel could not be moved at all, and
    // trying just scrolled the page behind it (adviser question, 2026-08-19). Pointer events cover
    // mouse, touch and pen through one path; `touch-none` on the handle below stops the browser
    // claiming the gesture for scrolling before it reaches us.
    const handlePointerDown = (e)=>{
        if (e.pointerType === 'mouse' && e.button !== 0) return; // left button only
        const rect = e.currentTarget.getBoundingClientRect();
        dragRef.current = {
            offsetX: e.clientX - rect.left,
            offsetY: e.clientY - rect.top
        };
        setIsDragging(true);
    };
    (0, $acw62.useEffect)(()=>{
        if (!isDragging) return undefined;
        const move = (e)=>{
            if (!dragRef.current) return;
            setPos(clampToViewport(e.clientX - dragRef.current.offsetX, e.clientY - dragRef.current.offsetY));
        };
        const up = ()=>{
            setIsDragging(false);
            dragRef.current = null;
        };
        document.addEventListener('pointermove', move);
        document.addEventListener('pointerup', up);
        // A touch drag interrupted by the system (a call, a gesture taking over) ends as a cancel
        // and never as an up; without this the panel would stay stuck to the finger.
        document.addEventListener('pointercancel', up);
        return ()=>{
            document.removeEventListener('pointermove', move);
            document.removeEventListener('pointerup', up);
            document.removeEventListener('pointercancel', up);
        };
    }, [
        isDragging,
        width
    ]);
    // On arrival as well as on drag: the default position (60px in, 360px wide) hangs about 30px
    // off the right edge of a narrow screen, so the panel opened partly out of view.
    (0, $acw62.useEffect)(()=>{
        setPos((p)=>clampToViewport(p.x, p.y));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        width
    ]);
    // Rotating an iPad, or any other viewport change, can leave a panel parked near an edge
    // stranded off screen — with no way back short of closing and reopening it. Re-clamp instead.
    (0, $acw62.useEffect)(()=>{
        const onResize = ()=>setPos((p)=>clampToViewport(p.x, p.y));
        window.addEventListener('resize', onResize);
        window.addEventListener('orientationchange', onResize);
        return ()=>{
            window.removeEventListener('resize', onResize);
            window.removeEventListener('orientationchange', onResize);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        width
    ]);
    if (!showPanel) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: ()=>setShowPanel(true),
        className: "fixed top-5 left-5 z-[10000] flex items-center gap-2 rounded-xl bg-brand-navy px-4 py-3 text-sm font-semibold text-white shadow-cardlg hover:bg-brand-ink transition-colors",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e57d6b071418ede9$export$2e2bcd8739ae039), {
                size: 16
            }),
            " Show insights"
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `fixed z-[10000] flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-cardlg${isPhone ? ' inset-x-2 bottom-2' : ''}`,
        /* A phone gets a bottom sheet: full width less a margin, anchored low, its own scroll.
               A floating window is a desktop idea — once it fills the screen there is nowhere to
               drag it to, and the gesture only fights the scrolling of its own content. Tablets
               and laptops keep the positioned, resizable-by-drag window unchanged. */ style: isPhone ? {
            maxHeight: '70vh'
        } : {
            left: pos.x,
            top: pos.y,
            width: width,
            maxHeight: '80vh'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `flex ${isPhone ? '' : 'cursor-move touch-none '}select-none items-center justify-between gap-2 bg-brand-navy px-4 py-3 text-white`,
                onPointerDown: isPhone ? undefined : handlePointerDown,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            markUrl && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: markUrl,
                                alt: "",
                                width: 18,
                                height: 18,
                                className: "block rounded-sm brightness-0 invert"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-[15px] font-bold",
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setShowPanel(false),
                        title: "Close",
                        className: "text-xl leading-none text-white/70 transition-colors hover:text-white",
                        children: "\xd7"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex-1 overflow-y-auto bg-canvas p-4 text-[15px] text-slate-700",
                children: showIntro ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($357e6188006bbf96$var$AdviserIntro, {
                    onDismiss: dismissIntro,
                    userName: userName
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        children,
                        onBackToDashboard && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: onBackToDashboard,
                            className: "mt-4 w-full rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-blue-700 transition-colors hover:bg-slate-50",
                            children: "\u2190 Back to Dashboard"
                        })
                    ]
                })
            })
        ]
    });
}
function $357e6188006bbf96$export$ff9e664ccbebf953({ title: title, icon: Icon, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mb-4 rounded-2xl border border-slate-200/70 bg-white p-4 shadow-card",
        children: [
            title && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-3 flex items-center gap-2.5 border-b border-slate-100 pb-3",
                children: [
                    Icon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                        icon: Icon,
                        tone: "brand",
                        variant: "solid",
                        size: "sm"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "m-0 text-[15px] font-semibold text-slate-900",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "space-y-1.5 text-sm leading-relaxed text-slate-600",
                children: children
            })
        ]
    });
}
function $357e6188006bbf96$export$41e53a8038f36a94({ title: title, children: children, defaultOpen: defaultOpen = false }) {
    const [open, setOpen] = (0, $acw62.useState)(defaultOpen);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mb-3 overflow-hidden rounded-xl border border-slate-200 bg-white",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: ()=>setOpen((v)=>!v),
                "aria-expanded": open,
                className: "flex w-full items-center justify-between gap-2.5 bg-slate-50 px-3.5 py-3 text-left transition-colors hover:bg-slate-100",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-[15px] font-semibold leading-snug text-slate-900",
                        children: title
                    }),
                    open ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                        size: 18,
                        className: "flex-shrink-0 text-slate-500"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                        size: 18,
                        className: "flex-shrink-0 text-slate-500"
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "px-3.5 pb-3.5 pt-1 text-sm leading-relaxed text-slate-600",
                children: children
            })
        ]
    });
}
function $357e6188006bbf96$export$fd6314980c95f7b9({ lead: lead, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mb-3 last:mb-0",
        children: [
            lead && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mb-1 font-semibold text-slate-900",
                children: lead
            }),
            children && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-sm leading-relaxed text-slate-600",
                children: children
            })
        ]
    });
}
function $357e6188006bbf96$export$18c1070e2827c601({ term: term, children: children, expandAs: expandAs = 'inline', label: label }) {
    /*
     * TAP to expand, not hover. This was a `title` tooltip, which has two failures the owner's
     * client meetings surfaced (2026-08-24): it does not exist on a tablet — and advisers demo this
     * product on iPads — and even on desktop nothing invites the hover, so the explanation may as
     * well not be there. A tap opens the one-sentence explanation IN PLACE, directly under the
     * sentence that used the term; a second tap closes it. The glossary content is unchanged — the
     * single vetted source in awiseKnowledgeBase stays the single source.
     *
     * Rendered as <button> + block <span>, both valid inside a <p>, so every existing call site
     * keeps working without markup changes.
     */ const [open, setOpen] = (0, $acw62.useState)(false);
    const [fullOpen, setFullOpen] = (0, $acw62.useState)(false);
    const explanation = typeof children === 'string' ? children : (0, $c79e495c2243b635$export$522b6ee8c9e1e75c)(term) || undefined;
    /*
     * TWO TIERS (owner request, 2026-08-24). The inline box works for a sentence; it does not work
     * for a concept that genuinely needs a paragraph. So: the inline box always shows the SHORT
     * explanation, and when the vetted glossary holds a materially longer one, the box offers
     * "Read the full explanation", which opens a centred pop-up. Same single content source
     * (awiseKnowledgeBase) for both tiers - nothing is written twice.
     */ const concept = (0, $c79e495c2243b635$export$c928564c70d3b3f)(term);
    const fullText = concept?.glossary && explanation && concept.glossary.length > explanation.length + 120 ? concept.glossary : null;
    if (!explanation) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: term
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: ()=>setOpen((o)=>!o),
                "aria-expanded": open,
                title: explanation,
                style: {
                    fontFamily: 'inherit',
                    fontSize: 'inherit',
                    lineHeight: 'inherit'
                },
                className: "inline border-0 bg-transparent p-0 text-left font-semibold text-blue-700 underline decoration-dotted decoration-blue-400 underline-offset-2 cursor-pointer hover:text-blue-900 focus-visible:ring-2 focus-visible:ring-blue-500 rounded-sm",
                children: label ?? term
            }),
            open && expandAs === 'inline' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "mt-1.5 mb-1 block whitespace-pre-line rounded-lg border border-blue-100 bg-white px-3 py-2 text-xs leading-relaxed text-slate-700",
                children: [
                    explanation,
                    fullText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setFullOpen(true),
                        className: "mt-1 block border-0 bg-transparent p-0 text-left text-xs font-semibold text-blue-700 underline underline-offset-2 cursor-pointer hover:text-blue-900",
                        children: "Read the full explanation"
                    })
                ]
            }),
            open && expandAs === 'dialog' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($357e6188006bbf96$var$GlossaryDialog, {
                title: concept?.term || term,
                body: fullText || explanation,
                onClose: ()=>setOpen(false)
            }),
            fullOpen && fullText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($357e6188006bbf96$var$GlossaryDialog, {
                title: concept?.term || term,
                body: fullText,
                onClose: ()=>setFullOpen(false)
            })
        ]
    });
}
/**
 * The vetted glossary is written for an LLM as much as for a screen: it carries "LABEL:" headings
 * in capitals and "- " bullets whose first words are shouted. Read straight off the file it looked
 * like a dump (owner, 24 Sep 2026: "this looks terrible"). This renders each block as a reader
 * expects: a heading in sentence case, a paragraph, or a list whose lead words are bold rather
 * than capitalised. The text itself is untouched — one source, two readers.
 */ const $357e6188006bbf96$var$sentenceCase = (shout)=>{
    const t = shout.trim();
    if (!t) return t;
    const lower = t.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1).replace(/\brcv\b/g, 'RCV').replace(/\bcentrelink\b/g, 'Centrelink').replace(/\bage pension\b/g, 'Age Pension');
};
const $357e6188006bbf96$var$isShouted = (t)=>/^[A-Z0-9 ,'()\/&-]{4,}$/.test(t.trim()) && /[A-Z]/.test(t);
function $357e6188006bbf96$var$GlossaryLine({ text: text }) {
    // "SHOUTED LEAD. The rest." → bold lead in sentence case, then the rest as written.
    const m = /^([A-Z][A-Z0-9 ,'()\/&-]{3,}?)([.:])\s+(.*)$/s.exec(text.trim());
    if (m && $357e6188006bbf96$var$isShouted(m[1])) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "font-semibold text-slate-900",
                children: [
                    $357e6188006bbf96$var$sentenceCase(m[1]),
                    m[2] === ':' ? ':' : '.'
                ]
            }),
            " ",
            m[3]
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: text
    });
}
function $357e6188006bbf96$var$GlossaryBlock({ block: block }) {
    const lines = block.split('\n').map((l)=>l.trim()).filter(Boolean);
    if (lines.length === 0) return null;
    // A heading on its own line ("WHAT YOU GIVE UP:") followed by bullets.
    const headingOnly = lines.length > 1 && /^[A-Z0-9 ,'()\/&-]+:$/.test(lines[0]) && lines.slice(1).every((l)=>l.startsWith('- '));
    const items = (headingOnly ? lines.slice(1) : lines).filter((l)=>l.startsWith('- '));
    const isList = items.length > 0 && items.length === (headingOnly ? lines.length - 1 : lines.length);
    if (isList) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            headingOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mb-1 text-sm font-bold text-slate-900",
                children: $357e6188006bbf96$var$sentenceCase(lines[0].replace(/:$/, ''))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "list-disc space-y-1.5 pl-5 text-sm leading-relaxed text-slate-700",
                children: items.map((l, j)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($357e6188006bbf96$var$GlossaryLine, {
                            text: l.slice(2)
                        })
                    }, j))
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "text-sm leading-relaxed text-slate-700",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($357e6188006bbf96$var$GlossaryLine, {
            text: lines.join(' ')
        })
    });
}
/**
 * The full-explanation pop-up. Rendered through a portal so a JargonTerm sitting inside a <p>
 * never nests a <div> in a paragraph (invalid HTML the browser silently "repairs" by splitting
 * the paragraph). Closes on the X, the backdrop, or Escape.
 */ function $357e6188006bbf96$var$GlossaryDialog({ title: title, body: body, onClose: onClose }) {
    (0, $acw62.useEffect)(()=>{
        const onKey = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4",
        onClick: onClose,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": title,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "w-full max-w-lg rounded-2xl bg-white shadow-2xl border border-slate-200",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-start justify-between gap-4 border-b border-slate-100 px-5 py-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "text-base font-bold text-slate-900",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: onClose,
                            "aria-label": "Close",
                            className: "shrink-0 rounded-md border-0 bg-transparent px-1.5 text-lg leading-none text-slate-400 cursor-pointer hover:text-slate-700 focus-visible:ring-2 focus-visible:ring-blue-500",
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "max-h-[65vh] overflow-y-auto px-5 py-4 space-y-3",
                    children: body.split(/\n\s*\n/).map((block, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($357e6188006bbf96$var$GlossaryBlock, {
                            block: block
                        }, i))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "border-t border-slate-100 px-5 py-3 text-right",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onClose,
                        className: "rounded-lg border border-slate-200 bg-white px-4 py-1.5 text-sm font-semibold text-slate-700 cursor-pointer hover:bg-slate-50",
                        children: "Close"
                    })
                })
            ]
        })
    }), document.body);
}
var $357e6188006bbf96$export$2e2bcd8739ae039 = $357e6188006bbf96$export$e6f4a6221f530693;



parcelRequire("acw62");

function $48a09045085ee578$export$a9d733491268e7f7({ icon: icon, title: title, children: children, className: className = '' }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-2 flex items-center gap-2.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                        icon: icon,
                        tone: "brand",
                        variant: "solid",
                        size: "sm"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "m-0 text-sm font-bold text-slate-900",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-sm leading-relaxed text-slate-600",
                children: children
            })
        ]
    });
}
var $48a09045085ee578$export$2e2bcd8739ae039 = $48a09045085ee578$export$a9d733491268e7f7;



parcelRequire("acw62");

const $540e416751b71a57$var$signed = (n)=>`${n >= 0 ? '+' : "\u2212"}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(n))}`;
function $540e416751b71a57$export$d4a6c86da3f7f911({ rows: rows = [], total: total }) {
    const amtClass = (n, kind)=>kind === 'change' ? n >= 0 ? 'text-emerald-600' : 'text-rose-600' : n >= 0 ? 'text-teal-700' : 'text-rose-600';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-1 overflow-hidden rounded-xl border border-slate-200",
        children: [
            rows.map((r, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: `flex items-start justify-between gap-3 px-3 py-2 ${i > 0 ? 'border-t border-slate-100' : ''}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "text-[12.5px] leading-tight text-slate-700",
                            children: [
                                r.label,
                                r.sub && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "mt-0.5 block text-[10.5px] font-normal text-slate-400",
                                    children: r.sub
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: `whitespace-nowrap text-[12.5px] font-bold ${amtClass(r.amount, r.kind)}`,
                            children: r.kind === 'change' ? $540e416751b71a57$var$signed(r.amount) : (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(r.amount)
                        })
                    ]
                }, i)),
            total && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-start justify-between gap-3 border-t border-slate-200 bg-slate-50 px-3 py-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-[12.5px] font-bold leading-tight text-slate-900",
                        children: [
                            total.label,
                            total.sub && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "mt-0.5 block text-[10.5px] font-normal text-slate-400",
                                children: total.sub
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `whitespace-nowrap text-[12.5px] font-extrabold ${total.amount >= 0 ? 'text-teal-700' : 'text-rose-600'}`,
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(total.amount)
                    })
                ]
            })
        ]
    });
}
var $540e416751b71a57$export$2e2bcd8739ae039 = $540e416751b71a57$export$d4a6c86da3f7f911;




var $acw62 = parcelRequire("acw62");

function $6c05f3bca3803eec$export$7fbbcd423808f3d5({ headline: headline, coveredPct: coveredPct = 100, leftLabel: leftLabel, rightLabel: rightLabel, depleted: depleted = false, flag: flag, detail: detail }) {
    const [showDetail, setShowDetail] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            headline && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "m-0 text-sm leading-relaxed text-slate-600",
                children: headline
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-2.5 h-2.5 overflow-hidden rounded-md bg-slate-200",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "h-full rounded-md bg-blue-600 ",
                    style: {
                        width: `${Math.max(2, Math.min(100, coveredPct))}%`
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-1.5 flex items-center justify-between text-[13px] text-slate-500",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: leftLabel
                    }),
                    rightLabel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: depleted ? 'font-semibold text-slate-700' : 'inline-flex items-center gap-1 font-semibold text-emerald-700',
                        children: [
                            !depleted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                size: 13,
                                strokeWidth: 2.5
                            }),
                            rightLabel
                        ]
                    })
                ]
            }),
            flag && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-2.5 flex items-start gap-2 rounded-lg border border-slate-200 border-l-4 border-l-amber-500 bg-white px-2.5 py-2 text-[12px] leading-snug text-slate-600 shadow-card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                        size: 14,
                        className: "mt-0.5 flex-shrink-0 text-amber-500"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: flag
                    })
                ]
            }),
            detail && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setShowDetail((v)=>!v),
                        className: "mt-2.5 text-[12px] font-semibold text-brand-blue hover:underline",
                        children: showDetail ? 'Hide the year-by-year' : "Show the year-by-year \u203A"
                    }),
                    showDetail && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-2",
                        children: detail
                    })
                ]
            })
        ]
    });
}
var $6c05f3bca3803eec$export$2e2bcd8739ae039 = $6c05f3bca3803eec$export$7fbbcd423808f3d5;




/**
 * The shared visual language for "in plain words" explainers.
 *
 * DESIGN LINEAGE (owner feedback, 2026-08-24, twice). The first cut was blue-tinted slabs of
 * prose; the second was a plain white box with a grey micro-label — "old and tired" next to the
 * rest of the app. This version speaks the app's OWN design language, taken from the components
 * the owner already likes:
 *   • headings use GradientText — the same blue→teal treatment as "Financial Impact";
 *   • the surface is the ImpactMetric family: white, rounded-2xl, border-slate-200/70,
 *     shadow-card;
 *   • before→after movements follow ImpactMetric's exact grammar: muted before, arrow, big bold
 *     after, then a signed delta coloured by direction;
 *   • allocations are LEDGER rows (label left, money right, tabular) — the format of the
 *     downsize "Where every dollar goes" table the owner called the better one. Chips are kept
 *     ONLY for flows (Sell → RAD → DAP on the Suggestion Engine cards), where sequence is the
 *     information.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8cfbb48e2ab5e60a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15 10 5 5-5 5",
            key: "qqa56n"
        }
    ],
    [
        "path",
        {
            d: "M4 4v7a4 4 0 0 0 4 4h12",
            key: "z08zvw"
        }
    ]
];
const $8cfbb48e2ab5e60a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("corner-down-right", $8cfbb48e2ab5e60a$export$3efd853dbb351e94);




function $63f0f38d9f9fe7ac$export$28c8139bd562d0e({ eyebrow: eyebrow, children: children, className: className = '', collapsible: collapsible = false, defaultOpen: defaultOpen = true, beatLayout: beatLayout = 'boxes', headingStyle: headingStyle = 'gradient' }) {
    const [open, setOpen] = (0, $acw62.useState)(defaultOpen);
    const body = open || !collapsible ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f0f38d9f9fe7ac$var$BeatLayoutContext.Provider, {
        value: beatLayout,
        children: children
    }) : null;
    const heading = headingStyle === 'navy' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-brand-navy",
        children: eyebrow
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6288781efbc92679$export$2e2bcd8739ae039), {
        children: eyebrow
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `rounded-2xl border border-slate-200/70 bg-white p-5 shadow-card ${className}`,
        children: [
            eyebrow && (collapsible ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: ()=>setOpen((v)=>!v),
                "aria-expanded": open,
                className: `flex w-full items-center gap-2 text-left ${open ? 'mb-3' : ''}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "text-lg font-bold",
                        children: heading
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                        size: 18,
                        className: `ml-auto shrink-0 text-slate-400 transition-transform duration-200 ${open ? 'rotate-180' : ''}`,
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "sr-only",
                        children: open ? 'Hide' : 'Show'
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                className: "mb-3 text-lg font-bold",
                children: heading
            })),
            body
        ]
    });
}
/** Set by PlainWordsCard; read by every PlainWordsBeat inside it, however deep. */ const $63f0f38d9f9fe7ac$var$BeatLayoutContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext('boxes');
/**
 * One beat of a plain-words explanation: a dotted heading, then the prose in its own bordered box.
 *
 * The design the owner picked out of the layout mock-up (2026-08-26 — "you can use some of the
 * design principles from Understanding your plan to make this look much more professional"). It
 * replaces the pattern these cards used before, which was three or four bolded run-in labels
 * ("Care:", "Age Pension:", "The gap:") inside one block of prose — readable, but nothing to scan,
 * so an adviser hunting for the pension line had to read the lot.
 *
 * The dot and the box rail carry the beat's MEANING, and the tones are not decorative:
 *   neutral  a plain statement of fact
 *   info     an entitlement or a rule
 *   good/bad a movement in a direction
 *   warn     something to look at — kept scarce, so it still means that when it appears
 *
 * The heading words say the same thing on their own, so nothing is lost to a reader who cannot
 * separate the colours.
 */ const $63f0f38d9f9fe7ac$var$BEAT_TONES = {
    neutral: {
        dot: 'bg-slate-400',
        rail: 'border-l-slate-300'
    },
    info: {
        dot: 'bg-blue-500',
        rail: 'border-l-blue-500'
    },
    good: {
        dot: 'bg-emerald-500',
        rail: 'border-l-emerald-500'
    },
    warn: {
        dot: 'bg-amber-500',
        rail: 'border-l-amber-500'
    },
    bad: {
        dot: 'bg-rose-500',
        rail: 'border-l-rose-500'
    }
};
function $63f0f38d9f9fe7ac$export$97060599ed0e6525({ heading: heading, tone: tone = 'neutral', children: children }) {
    const { dot: dot, rail: rail } = $63f0f38d9f9fe7ac$var$BEAT_TONES[tone];
    const layout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($63f0f38d9f9fe7ac$var$BeatLayoutContext);
    if (layout === 'rows') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "grid grid-cols-1 gap-1 border-b border-slate-100 py-3.5 first:pt-0 last:border-0 last:pb-0 sm:grid-cols-[250px_1fr] sm:gap-6",
        "data-beat-tone": tone,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[14px] font-bold leading-snug text-brand-navy [text-wrap:balance]",
                children: heading
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-[14px] leading-relaxed text-slate-700",
                children: children
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "py-2.5 first:pt-0",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-2.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `h-[7px] w-[7px] shrink-0 rounded-full ${dot}`,
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-[15px] font-bold tracking-tight text-blue-600",
                        children: heading
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "h-px flex-1 bg-slate-200 ",
                        "aria-hidden": "true"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `ml-[17px] mt-2 rounded-lg border border-slate-200 border-l-[3px] ${rail} bg-white px-3.5 py-3 text-[13.5px] leading-relaxed text-slate-600`,
                children: children
            })
        ]
    });
}
function $63f0f38d9f9fe7ac$export$36b8132fbfd1058f({ heading: heading, tone: tone = 'info', children: children }) {
    const { rail: rail } = $63f0f38d9f9fe7ac$var$BEAT_TONES[tone];
    const headingTone = {
        neutral: 'text-slate-700',
        info: 'text-blue-700',
        good: 'text-emerald-700',
        warn: 'text-amber-800',
        bad: 'text-rose-700'
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `mt-2 rounded-lg border border-slate-200 border-l-[3px] ${rail} bg-slate-50/70 px-3 py-2.5 text-[13px] leading-relaxed text-slate-600`,
        children: [
            heading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: `font-semibold ${headingTone[tone]} mb-1`,
                children: heading
            }),
            children
        ]
    });
}
/*
 * White chips, colour as accent only (owner, 2026-08-24: pastel infills "look old"). The app's
 * own stat tiles are white surfaces whose colour lives in text and icons - chips follow suit:
 * a coloured dot and coloured sub-text carry the meaning, the box stays white.
 */ const $63f0f38d9f9fe7ac$var$CHIP_TONES = {
    sold: {
        dot: 'bg-slate-400',
        sub: 'text-slate-500'
    },
    good: {
        dot: 'bg-emerald-500',
        sub: 'text-emerald-700'
    },
    warn: {
        dot: 'bg-amber-500',
        sub: 'text-amber-700'
    },
    neutral: {
        dot: 'bg-slate-300',
        sub: 'text-slate-500'
    }
};
function $63f0f38d9f9fe7ac$export$9c139f18dfc312b8({ steps: steps }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-wrap items-center gap-y-2",
        children: steps.map((step, i)=>{
            const tone = $63f0f38d9f9fe7ac$var$CHIP_TONES[step.tone || 'neutral'];
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                children: [
                    i > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                        size: 16,
                        className: "mx-1 shrink-0 text-slate-300",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "inline-flex flex-col rounded-lg border border-slate-200 bg-white px-2.5 py-1.5 leading-tight shadow-sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "flex items-center gap-1.5 text-sm font-bold tabular-nums text-slate-900",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: `h-1.5 w-1.5 shrink-0 rounded-full ${tone.dot}`,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(step.amount),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-xs font-medium text-slate-500",
                                        children: step.label
                                    })
                                ]
                            }),
                            step.sub && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `pl-3 text-[11px] font-medium ${tone.sub}`,
                                children: step.sub
                            })
                        ]
                    })
                ]
            }, i);
        })
    });
}
function $63f0f38d9f9fe7ac$export$1d00d22da2d536d8({ tone: tone = 'good', children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `ml-1.5 inline-flex items-center rounded px-1.5 py-0.5 align-middle text-[10px] font-semibold uppercase tracking-wide ${tone === 'good' ? 'bg-emerald-100 text-emerald-800' : 'bg-amber-100 text-amber-800'}`,
        children: children
    });
}
function $63f0f38d9f9fe7ac$export$53af4e9987d1078a({ label: label, amount: amount, negative: negative = false, bold: bold = false, muted: muted = false, indent: indent = false, divider: divider = false, chip: chip, chipTone: chipTone = 'good' }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `flex items-baseline justify-between gap-3 py-1 ${divider ? 'mt-1 border-t border-slate-200 pt-1.5' : ''}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: `flex min-w-0 items-baseline text-sm ${bold ? 'font-bold text-slate-900' : muted ? 'text-slate-500' : 'text-slate-700'} ${indent ? 'pl-4' : ''}`,
                children: [
                    indent && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8cfbb48e2ab5e60a$export$2e2bcd8739ae039), {
                        size: 12,
                        className: "mr-1.5 shrink-0 self-center text-slate-300",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "min-w-0",
                        children: label
                    }),
                    chip && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63f0f38d9f9fe7ac$export$1d00d22da2d536d8, {
                        tone: chipTone,
                        children: chip
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: `shrink-0 text-sm tabular-nums ${bold ? 'font-bold text-slate-900' : muted ? 'text-slate-500' : 'font-semibold text-slate-800'}`,
                children: negative ? `\u{2212}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(amount)}` : (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(amount)
            })
        ]
    });
}
function $63f0f38d9f9fe7ac$export$721778c36dbce7e7({ lead: lead, drivers: drivers, closing: closing }) {
    const tone = (sign)=>sign === 'plus' ? {
            dot: 'bg-emerald-500',
            text: 'text-emerald-700',
            mark: '+'
        } : sign === 'minus' ? {
            dot: 'bg-rose-400',
            text: 'text-rose-700',
            mark: "\u2212"
        } : {
            dot: 'bg-slate-400',
            text: 'text-slate-700',
            mark: ''
        };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: lead
            }),
            drivers.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-2 font-semibold text-slate-800",
                        children: "What moves it"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        className: "mt-1 space-y-1",
                        children: drivers.map((d, i)=>{
                            const t = tone(d.sign);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                className: "flex items-start gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: `mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full ${t.dot}`,
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            d.text,
                                            d.amount != null && Number.isFinite(d.amount) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: `ml-2 whitespace-nowrap font-semibold tabular-nums ${t.text}`,
                                                children: [
                                                    t.mark,
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(d.amount)),
                                                    d.suffix ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "ml-1 text-[11px] font-medium text-slate-500",
                                                        children: d.suffix
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }),
            closing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-slate-600",
                children: closing
            })
        ]
    });
}
function $63f0f38d9f9fe7ac$export$e95813558e26ce51({ label: label, before: before, after: after, suffix: suffix = '/yr', preferLower: preferLower = false, children: children, variant: variant = 'inline', why: why }) {
    const difference = after - before;
    const isFlat = Math.round(difference) === 0;
    const isPositive = difference >= 0;
    const isGood = preferLower ? !isPositive : isPositive;
    const Icon = isPositive ? (0, $c9921f4f81a419f0$export$2e2bcd8739ae039) : (0, $e71d8988c230db1b$export$2e2bcd8739ae039);
    const deltaColour = isFlat ? 'text-slate-400' : isGood ? 'text-emerald-600' : 'text-rose-600';
    if (variant === 'expanded') {
        /*
         * The dot encodes DIRECTION, matching the green/red the impact rows already use — and
         * neutral is SLATE, never amber. Amber means "check this" elsewhere in the app, and "no
         * change" is not a warning: on the Age Pension row it is the most reassuring line on the
         * page ("paying a RAD does not cost you pension"). The heading words carry the meaning on
         * their own, so nothing is lost to a reader who cannot separate red from green.
         */ const dot = isFlat ? 'bg-slate-400' : isGood ? 'bg-emerald-500' : 'bg-rose-500';
        const rail = isFlat ? 'border-l-slate-400' : isGood ? 'border-l-emerald-500' : 'border-l-rose-500';
        const movement = isFlat ? 'no change' : `${isGood ? 'better' : 'worse'} by ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(difference))}`;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "py-3 first:pt-0",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center gap-2.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: `h-[7px] w-[7px] shrink-0 rounded-full ${dot}`,
                            "aria-hidden": "true"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "text-[15px] font-bold tracking-tight text-blue-600",
                            children: [
                                label,
                                " \u2014 ",
                                movement
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "h-px flex-1 bg-slate-200 ",
                            "aria-hidden": "true"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "ml-[17px] mt-1.5 flex flex-wrap items-baseline gap-x-2 gap-y-0.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-sm tabular-nums text-slate-400",
                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(before)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                            size: 13,
                            className: "shrink-0 self-center text-slate-300",
                            "aria-hidden": "true"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "text-lg font-bold tabular-nums text-slate-900",
                            children: [
                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(after),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "ml-0.5 text-xs font-medium text-slate-500",
                                    children: suffix
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: `inline-flex items-center gap-1 text-sm font-semibold tabular-nums ${deltaColour}`,
                            children: [
                                !isFlat && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                    size: 14,
                                    className: "shrink-0",
                                    "aria-hidden": "true"
                                }),
                                isFlat ? 'no change' : `${isPositive ? '+' : "\u2212"}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(difference))}`
                            ]
                        })
                    ]
                }),
                why && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: `ml-[17px] mt-2 rounded-lg border border-slate-200 border-l-[3px] ${rail} bg-white px-3.5 py-3 text-[13.5px] leading-relaxed text-slate-600`,
                    children: why
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "py-2 first:pt-0",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-xs font-semibold uppercase tracking-wide text-slate-500",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-0.5 flex flex-wrap items-baseline gap-x-2 gap-y-0.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-sm text-slate-400 tabular-nums",
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(before)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                        size: 13,
                        className: "shrink-0 self-center text-slate-300",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-lg font-bold text-slate-900 tabular-nums",
                        children: [
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(after),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ml-0.5 text-xs font-medium text-slate-500",
                                children: suffix
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: `inline-flex items-center gap-1 text-sm font-semibold tabular-nums ${deltaColour}`,
                        children: [
                            !isFlat && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                size: 14,
                                className: "shrink-0",
                                "aria-hidden": "true"
                            }),
                            isFlat ? 'no change' : `${isPositive ? '+' : "\u2212"}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(difference))}`
                        ]
                    }),
                    children && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-sm",
                        children: children
                    })
                ]
            })
        ]
    });
}


/**
 * "Age Pension today — what sets it": which means test is setting the pension, and what would
 * have to move to lift it. One component, every module (owner, 24 Sep 2026: "I think this could be
 * handy across the board for all modules").
 *
 * READ FROM THE ENGINE'S OWN BREAKDOWN, NOT RECOMPUTED. The Age Pension assessment
 * (server/src/rest/calculation/assessment/agePension.ts) emits the rows a reader needs: the
 * counted assets, the counted income, the pension under each test, the full‑pension limits and
 * which test won ("Determined By"). Reading those rows means this note is always in the same frame
 * as the figure beside it — in care, at home, illness‑separated or not — and can never disagree
 * with it. The only arithmetic here is the taper for the worked examples, from the same constant
 * the engine uses.
 *
 * Two beats, the Support at Home pattern: the test that binds, said in one line with the reason
 * behind a dotted term; then what could change it — the full pension and a smaller lift as sizes
 * of shift, folded behind a tap because it is a lot of words — or, where the income test binds or
 * the pension is out of reach, that fact stated plainly instead of a false promise.
 */ 
parcelRequire("acw62");




const $eec331ce661055d2$var$money = (v)=>{
    if (typeof v === 'number') return Number.isFinite(v) ? v : null;
    const n = parseFloat(String(v ?? '').replace(/[$,\s]/g, '').replace(/^\((.*)\)$/, '-$1'));
    return Number.isFinite(n) ? n : null;
};
function $eec331ce661055d2$export$d318875bf548d09(breakdown, pension, isCouple) {
    if (!Array.isArray(breakdown) || breakdown.length === 0) return null;
    const rows = breakdown.filter((r)=>r && typeof r.label === 'string');
    const find = (label, nth = 0)=>rows.filter((r)=>r.label === label)[nth];
    const under = rows.filter((r)=>r.label === 'Pension under this test');
    if (under.length < 2) return null;
    const assetTestPension = $eec331ce661055d2$var$money(under[0].value);
    const incomeTestPension = $eec331ce661055d2$var$money(under[1].value);
    const assessableAssets = ($eec331ce661055d2$var$money(find('Your Assets')?.value) ?? 0) + ($eec331ce661055d2$var$money(find('Deprived Assets')?.value) ?? 0);
    const assessableIncome = $eec331ce661055d2$var$money(find('Total Assessable Income')?.value) ?? 0;
    const assetFullLimit = $eec331ce661055d2$var$money(find('Full Pension Limit', 0)?.value);
    if (assetTestPension == null || incomeTestPension == null) return null;
    const determinedRow = String(find('Determined By')?.value ?? '');
    const determinedBy = /asset/i.test(determinedRow) ? 'asset' : /income/i.test(determinedRow) ? 'income' : null;
    const illnessSeparated = String(find('Couple treatment')?.value ?? '') === 'Illness separated';
    const maxRate = !isCouple ? (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single : illnessSeparated ? (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single * 2 : (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).couple;
    const current = Number(pension) || 0;
    const assetBinds = determinedBy === 'asset' || determinedBy == null && assetTestPension < incomeTestPension;
    let shiftForFullPension = null;
    let shiftForQuarterLift = null;
    let fullOutOfReach = false;
    if (assetBinds && assetFullLimit != null) {
        shiftForFullPension = Math.max(0, assessableAssets - assetFullLimit);
        fullOutOfReach = shiftForFullPension > assessableAssets;
        const target = Math.min(maxRate, current * 1.25);
        if (target > current + 1 && (0, $1abe73eeef086faf$export$6ca758cf677ce6c5) > 0) {
            const requiredAssets = assetFullLimit + (maxRate - target) / (0, $1abe73eeef086faf$export$6ca758cf677ce6c5) * 1000;
            const shift = Math.max(0, assessableAssets - requiredAssets);
            if (shift > 0 && shift < shiftForFullPension) shiftForQuarterLift = {
                shift: shift,
                pension: target
            };
        }
    }
    const atFullPension = current > 0 && Math.abs(current - maxRate) <= Math.max(150, maxRate * 0.002);
    return {
        pension: current,
        assessableAssets: assessableAssets,
        assessableIncome: assessableIncome,
        assetTestPension: assetTestPension,
        incomeTestPension: incomeTestPension,
        determinedBy: determinedBy ?? (assetBinds ? 'asset' : 'income'),
        assetFullLimit: assetFullLimit,
        illnessSeparated: illnessSeparated,
        maxRate: maxRate,
        shiftForFullPension: shiftForFullPension,
        shiftForQuarterLift: shiftForQuarterLift,
        atFullPension: atFullPension,
        fullOutOfReach: fullOutOfReach
    };
}
function $eec331ce661055d2$export$836922263996c16c({ financials: financials, isCouple: isCouple, name: name, alsoMoves: alsoMoves, whereNext: whereNext = 'The strategies in step 3', careDepositRelevant: careDepositRelevant = false }) {
    const pos = $eec331ce661055d2$export$d318875bf548d09(financials?.socialSecurityBreakdown, financials?.socialSecurity, isCouple);
    if (!pos) return null;
    const assetBinds = pos.determinedBy === 'asset';
    // "John and Kerry are", "Robin is"; "Chris'" for a name ending in s (the household voice, 21 Oct 2026).
    const possessive = name === 'you' ? 'your' : /s$/i.test(name) ? `${name}'` : `${name}'s`;
    const nameAre = name === 'you' ? 'You are' : `${name} ${name.includes(' and ') ? 'are' : 'is'}`;
    const bindingWhy = assetBinds ? `Both tests are worked out and the LOWER answer wins. Here the assets test gives ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pos.assetTestPension)} a year and the income test ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pos.incomeTestPension)}, so the assets test sets the pension. Every $1,000 of counted assets above the full-pension limit of ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pos.assetFullLimit ?? 0)} takes ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$6ca758cf677ce6c5))} a year off it \u{2014} which is why lowering what Centrelink counts is what lifts it.` : `Both tests are worked out and the LOWER answer wins. Here the income test gives ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pos.incomeTestPension)} a year against the assets test's ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pos.assetTestPension)}, so the income test sets the pension. Shifting assets alone will not lift it; the income Centrelink counts \u{2014} deemed income on financial assets, rent, pensions \u{2014} is what would have to fall.`;
    const examples = assetBinds && pos.shiftForFullPension != null && pos.shiftForFullPension > 0 && !pos.fullOutOfReach ? [
        `\u{2022} The full pension: Centrelink counting about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pos.shiftForFullPension)} less \u{2192} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pos.maxRate)} a year (up ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pos.maxRate - pos.pension)}).`,
        ...pos.shiftForQuarterLift ? [
            `\u{2022} A quarter more: counting about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pos.shiftForQuarterLift.shift)} less \u{2192} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pos.shiftForQuarterLift.pension)} a year (up ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pos.shiftForQuarterLift.pension - pos.pension)}).`
        ] : []
    ].join('\n') : '';
    const stepsText = examples ? `These are worked examples, not recommendations \u{2014} they show how much less Centrelink would need to count:
${examples}\nMoney Centrelink doesn't count, or counts only in part: ${careDepositRelevant ? 'a refundable accommodation deposit, ' : ''}a guaranteed income for life (60% counted), a funeral bond, a gift within the yearly limit, or simply money spent. ${whereNext} are how that actually happens.` : '';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$97060599ed0e6525), {
                tone: "info",
                heading: "Age Pension today \u2014 what sets it",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "font-semibold text-slate-900",
                        children: [
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pos.pension),
                            "/yr"
                        ]
                    }),
                    ". Centrelink counts",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pos.assessableAssets)
                    }),
                    " of assets and",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "font-semibold text-slate-900",
                        children: [
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pos.assessableIncome),
                            "/yr"
                        ]
                    }),
                    " of income \u2014 and it's the ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: assetBinds ? 'assets test' : 'income test'
                    }),
                    ' ',
                    "setting the pension ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                        term: "(why does that matter?)",
                        children: bindingWhy
                    }),
                    pos.illnessSeparated && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " Assessed as an ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                term: "illness-separated couple"
                            }),
                            ", so each is paid at the higher single rate."
                        ]
                    })
                ]
            }),
            pos.atFullPension ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$97060599ed0e6525), {
                tone: "good",
                heading: "Already at the full pension",
                children: [
                    nameAre,
                    " already at the full pension \u2014 nothing to gain there, so ",
                    whereNext.toLowerCase(),
                    " are about",
                    ' ',
                    alsoMoves ?? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: "cashflow and the estate"
                    }),
                    "."
                ]
            }) : assetBinds && pos.fullOutOfReach ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$97060599ed0e6525), {
                tone: "neutral",
                heading: "The full pension is out of reach",
                children: [
                    "It would take shifting more than ",
                    possessive,
                    " counted assets. A partial lift is still possible \u2014 every",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: "$1,000"
                    }),
                    " less that Centrelink counts is worth",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$6ca758cf677ce6c5))
                    }),
                    " a year",
                    alsoMoves ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " \u2014 and it ",
                            alsoMoves
                        ]
                    }) : null,
                    "."
                ]
            }) : assetBinds && pos.shiftForFullPension != null && pos.shiftForFullPension > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$97060599ed0e6525), {
                tone: "good",
                heading: "Room to move",
                children: [
                    "Centrelink doesn't count every dollar the same way. Moving money into things it counts less, or not at all,",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: "lifts the Age Pension"
                    }),
                    alsoMoves ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " and ",
                            alsoMoves
                        ]
                    }) : null,
                    ". If Centrelink counted about",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pos.shiftForFullPension)
                    }),
                    " less, the full pension would be paid.",
                    stepsText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                term: "(what shifting assets could do \u203A)",
                                children: stepsText
                            })
                        ]
                    })
                ]
            }) : !assetBinds ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$97060599ed0e6525), {
                tone: "neutral",
                heading: "The income test is what limits the pension",
                children: [
                    "Because the income test is what's limiting the pension, reducing assets alone won't lift it \u2014 what matters here is ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: "counted income"
                    }),
                    ": deemed income on financial assets, rent, and other pensions. ",
                    whereNext,
                    " that lower counted income are the ones to look at",
                    alsoMoves ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            ", though shifting assets still ",
                            alsoMoves
                        ]
                    }) : null,
                    "."
                ]
            }) : null
        ]
    });
}
var $eec331ce661055d2$export$2e2bcd8739ae039 = $eec331ce661055d2$export$836922263996c16c;



function $eb51a4b4880423a2$export$5159918eb0e0db45(input) {
    const gap = input.cashFlowBeforeCare - input.yearlyCare;
    if (gap >= 0) return {
        text: `Income would cover everything with ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(gap)} a year to spare.`,
        runwayYears: null,
        surplus: true
    };
    const shortfall = -gap;
    if (input.accessibleSavings <= 0) return {
        text: `Income covers all but ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(shortfall)} a year, and there are no accessible savings to draw on \u{2014} the projections below show how that gap would be met.`,
        runwayYears: null,
        surplus: false
    };
    /*
     * THE PROJECTION'S ANSWER, NEVER OUR OWN DIVISION (owner-caught on production, 2026-09-10).
     *
     * This used to be `accessible savings ÷ yearly gap`, hedged as "roughly … the projections show
     * it precisely". That hedge was written when the note was the only thing on screen answering
     * the question. It no longer is: the plan summary panel now states the same thing from the real
     * projection, a few centimetres away. On a live client the two read:
     *
     *     this note — "about $700,000 would cover that for roughly 12 years"
     *     the panel  — "Savings last about 10 years"
     *
     * for the SAME untouched walk-in position. Straight-line division cannot see investment growth,
     * the pension moving once in care, care fees changing, or account-based pension minimums — so it
     * was always going to drift from the projection. "Roughly" does not rescue a number that is
     * contradicted on the same screen; it just makes the tool look like it cannot add up, which is
     * the worst of the two readings a client can take.
     *
     * So the note now QUOTES the projection. Where the projection has not answered yet, it says
     * nothing about years rather than inventing a second figure to fill the gap.
     */ const runwayYears = input.projectedRunwayYears ?? null;
    /*
     * DO NOT BLAME CARE FOR A SHORTFALL THAT WAS ALREADY THERE.
     *
     * Recovered from the retired insight panel, which guarded this with `preCareCashFlow >= 0`. A
     * client whose cashflow was already negative before care begins would otherwise read that the
     * care fees created the gap — which is false, and once a reader catches one false statement they
     * are right to distrust everything under it.
     *
     * `cashFlowBeforeCare` is the same figure the beats above are built from, so the two can never
     * disagree about whether the gap pre-dates the move.
     */ const alreadyShort = input.cashFlowBeforeCare < 0;
    const opening = alreadyShort ? `Income already falls short before any care costs, and the fees add to that \u{2014} the gap becomes ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(shortfall)} a year` : `Income covers all but ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(shortfall)} a year`;
    const savings = `the accessible savings of about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(input.accessibleSavings)}`;
    return {
        text: runwayYears == null ? `${opening} \u{2014} ${savings} are what would cover it. The projections show how long that lasts.` : `${opening} \u{2014} ${savings} would cover that for about ${runwayYears} ${runwayYears === 1 ? 'year' : 'years'}, the same figure shown under "How long the money lasts".`,
        runwayYears: runwayYears,
        surplus: false
    };
}
function $eb51a4b4880423a2$export$ecd2bf5d59b66061(factFind) {
    const assets = factFind.assets || {};
    const sum = (list)=>(list || []).reduce((total, item)=>total + (parseFloat(String(item?.value)) || 0), 0);
    return sum(assets.bankAccounts) + sum(assets.termDeposits) + sum(assets.shares) + sum(assets.accountBasedPensions);
}
function $eb51a4b4880423a2$export$9ada56fd292651b8(factFind, radInput, extraServiceFeeInput = 0, /**
     * Living costs the client has adjusted for life in care, from "Confirm your living needs".
     *
     * WHY IT HAS TO REACH HERE (owner-reported, 2026-08-31). The baseline was computed from the
     * fact-find's ORIGINAL living expenses, so changing the adjusted figure moved the plan summary's
     * cashflow and left the walk-in note's "The gap — what it leaves" quoting the old number. Two
     * figures about the same thing, on the same screen, disagreeing.
     *
     * It belongs in the baseline, not only in the strategies: the adjusted figure is what this
     * client will actually spend in care whether or not they adopt a plan, so it is part of doing
     * nothing. Undefined means "not adjusted" and the fact-find's own figure stands.
     */ scenarioLivingExpenses, /** The second room, where both of a couple enter care: priced beside the first, no deposit. */ secondRoom = null, /** Someone in care now: priced on their current room and deposit, with the daily payment they actually pay. */ existingStay = null) {
    const [costs, setCosts] = (0, $acw62.useState)(null);
    const [secondCosts, setSecondCosts] = (0, $acw62.useState)(null);
    const [careFinancials, setCareFinancials] = (0, $acw62.useState)(null);
    const [todayFinancials, setTodayFinancials] = (0, $acw62.useState)(null);
    /** The second stage, where the second person enters later (carePhases.ts); null otherwise. */ const [phase2, setPhase2] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!(radInput > 0) && !existingStay) {
            setCosts(null);
            return;
        }
        let cancelled = false;
        const modellerResidency = (0, $8eecd0af141b9afb$export$5f0bb1b091776594)(factFind);
        // The fact-find every figure below is computed from — the client's own, with living costs
        // replaced by the adjusted figure where they have given one.
        const adjusted = Number(scenarioLivingExpenses);
        const basis = Number.isFinite(adjusted) && adjusted > 0 ? {
            ...factFind,
            expenses: {
                ...factFind.expenses || {},
                livingExpenses: adjusted
            }
        } : factFind;
        const second = secondRoom && secondRoom.roomPrice > 0 ? secondRoom : null;
        const later = !!second && !!second.entersLater;
        // Where the second person enters LATER, the first stage has them still at home: the home
        // exempt from the aged care means test, the couple illness-separated from the first entry.
        const secondKey = second?.person === 'client' ? 'clientResidencyOverride' : 'partnerResidencyOverride';
        const secondRecorded = (second?.person === 'client' ? factFind.client?.currentResidency : factFind.partner?.currentResidency) || 'own_home';
        const firstResidency = later ? {
            ...modellerResidency,
            [secondKey]: secondRecorded
        } : modellerResidency;
        // THREE assessments, used for different jobs. The IN-CARE one (the first stage's residency
        // applied -- the same frame as the Cost Overview and Financial Impact panels) drives every
        // figure: fees, pension, gap. The TODAY one exists only so the pension line can say the
        // bridge. The BOTH-IN-CARE one is the second stage, struck only where there is one.
        // The second stage's living costs, where the plan gives a figure for once both are in care.
        const basisBoth = later && second?.livingExpensesOnceBoth != null && second.livingExpensesOnceBoth > 0 ? {
            ...basis,
            expenses: {
                ...basis.expenses || {},
                livingExpenses: second.livingExpensesOnceBoth
            }
        } : basis;
        Promise.all([
            $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(basis, firstResidency),
            $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(basis),
            later ? $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(basisBoth, modellerResidency) : Promise.resolve(null)
        ]).then(([inCare, today, both])=>{
            if (cancelled) return;
            setCareFinancials(inCare);
            setTodayFinancials(today);
            const bothFin = both ?? inCare;
            const firstResident = second ? second.person === 'client' ? 'partner' : 'client' : undefined;
            return Promise.all([
                $55a1d8a64f1e5dfa$export$fb677777baef0897({
                    factFind: basis,
                    financials: inCare,
                    // Staying put: the current room and the deposit held, not the new room and nothing paid.
                    radInput: existingStay ? existingStay.roomPrice : radInput,
                    radPaid: existingStay ? existingStay.refundToday : 0,
                    overallStrategy: {
                        ...firstResidency
                    },
                    extraServiceFeeInput: existingStay ? 0 : extraServiceFeeInput,
                    ...firstResident ? {
                        resident: firstResident
                    } : existingStay ? {
                        resident: existingStay.person
                    } : {}
                }).then((c)=>existingStay ? (0, $bdfd96a4f4ac117d$export$98225c4faadd11c0)(c, existingStay.dailyPayment) : c),
                second ? $55a1d8a64f1e5dfa$export$fb677777baef0897({
                    factFind: basis,
                    financials: bothFin,
                    radInput: second.roomPrice,
                    radPaid: 0,
                    overallStrategy: {
                        ...modellerResidency
                    },
                    extraServiceFeeInput: second.extraServiceAnnual ?? 0,
                    resident: second.person
                }) : Promise.resolve(null),
                later ? $55a1d8a64f1e5dfa$export$fb677777baef0897({
                    factFind: basis,
                    financials: bothFin,
                    radInput: radInput,
                    radPaid: 0,
                    overallStrategy: {
                        ...modellerResidency
                    },
                    extraServiceFeeInput: extraServiceFeeInput,
                    resident: firstResident
                }) : Promise.resolve(null)
            ]).then(([c, c2, c1b])=>{
                if (cancelled) return;
                setCosts(c);
                setSecondCosts(c2 ?? null);
                setPhase2(later && c1b ? {
                    fromDate: second.careStartDate || '',
                    financials: bothFin,
                    firstCosts: c1b,
                    secondCosts: c2 ?? null
                } : null);
            });
        }).catch((0, $85051d5377ce5db4$export$890bc823b29958a8)('the walk-in position'));
        return ()=>{
            cancelled = true;
        };
    // The second room is keyed on its fields, not the object: the Analyser builds it afresh each render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        factFind,
        radInput,
        extraServiceFeeInput,
        scenarioLivingExpenses,
        secondRoom?.person,
        secondRoom?.roomPrice,
        secondRoom?.careStartDate,
        secondRoom?.extraServiceAnnual,
        secondRoom?.entersLater,
        secondRoom?.livingExpensesOnceBoth,
        existingStay?.person,
        existingStay?.roomPrice,
        existingStay?.refundToday,
        existingStay?.dailyPayment
    ]);
    return {
        costs: costs,
        secondCosts: secondCosts,
        careFinancials: careFinancials,
        todayFinancials: todayFinancials,
        phase2: phase2
    };
}
const $eb51a4b4880423a2$var$RESIDENCY_LABELS = {
    renting: 'renting',
    with_family: 'living with family',
    retirement_village: 'living in a retirement village'
};
const $eb51a4b4880423a2$var$WalkInPositionNote = ({ factFind: factFind, radInput: radInput, extraServiceFeeInput: extraServiceFeeInput = 0, scenarioLivingExpenses: scenarioLivingExpenses, projectedRunwayYears: projectedRunwayYears = null, runwayFacts: runwayFacts = null, secondRoom: secondRoom = null, existingStay: existingStay = null, villageExit: villageExit = null })=>{
    const { costs: costs, secondCosts: secondCosts, careFinancials: careFinancials, todayFinancials: todayFinancials, phase2: phase2 } = $eb51a4b4880423a2$export$9ada56fd292651b8(factFind, radInput, extraServiceFeeInput, scenarioLivingExpenses, secondRoom, existingStay);
    if (!(radInput > 0) && !existingStay || !costs || !careFinancials || !todayFinancials) return null;
    const financials = careFinancials;
    const goals = factFind.goals || {};
    const partnerEntering = goals.aged_care_for === 'partner';
    // Both entering (7 Oct 2026): two rooms, nobody staying in the home, and the couple assessed as
    // living apart. Every sentence below that names who stays at home is skipped.
    const bothEntering = factFind.adviceFor === 'couple' && goals.aged_care_for === 'both' && !!secondRoom && secondRoom.roomPrice > 0;
    const { firstName: firstName, secondName: secondName } = (0, $b8d3cfe4c156722e$export$24ee473c3b86ae0)(factFind, secondRoom?.person, {
        first: 'they',
        second: 'their partner'
    });
    const enteringName = bothEntering ? `${firstName} and ${secondName}` : (partnerEntering ? factFind.partner?.firstName : factFind.client?.firstName) || 'they';
    const enteringAre = bothEntering ? 'are' : 'is';
    const stayingName = factFind.adviceFor === 'couple' && !bothEntering ? (partnerEntering ? factFind.client?.firstName : factFind.partner?.firstName) || 'their partner' : null;
    // The first stage's figures. With the second person entering later, their room is not in it:
    // the second stage (phase2) is quoted beside each beat instead.
    const firstDaily = costs.totalDailyCost || 0;
    const secondInFirstStage = bothEntering && !phase2;
    const secondDaily = secondInFirstStage ? secondCosts?.totalDailyCost || 0 : 0;
    const dailyTotal = firstDaily + secondDaily;
    const dailyDap = (costs.dailyAccommodationPayment || 0) + (secondInFirstStage ? secondCosts?.dailyAccommodationPayment || 0 : 0);
    const phaseNames = {
        firstName: firstName,
        secondName: secondName,
        fromLabel: (0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(phase2?.fromDate || secondRoom?.careStartDate || '')
    };
    const phaseTwoDaily = phase2 ? (phase2.firstCosts.totalDailyCost || 0) + (phase2.secondCosts?.totalDailyCost || 0) : 0;
    const phaseTwoDap = phase2 ? (phase2.firstCosts.dailyAccommodationPayment || 0) + (phase2.secondCosts?.dailyAccommodationPayment || 0) : 0;
    const phaseTwoGap = phase2 ? (phase2.financials.cashFlow || 0) - phaseTwoDaily * 365 : 0;
    const careBeat = phase2 ? (0, $b8d3cfe4c156722e$export$c84e6db632ec436a)(phaseNames, {
        firstDaily: firstDaily,
        phaseTwoFirstDaily: phase2.firstCosts.totalDailyCost || 0,
        secondDaily: phase2.secondCosts?.totalDailyCost || 0
    }) : null;
    const yearlyCare = dailyTotal * 365;
    const pension = financials.socialSecurity || 0;
    const pensionToday = todayFinancials.socialSecurity || 0;
    const pensionRises = Math.round(pension) > Math.round(pensionToday);
    const pensionFalls = Math.round(pension) < Math.round(pensionToday);
    /*
     * THE DOT SAYS WHAT THE MOVEMENT MEANS FOR THE CLIENT (owner, 22 Sep 2026: "if it goes up should
     * we colour code that to green?"). Green when the pension rises, amber when it falls, plain slate
     * when it does not move — the same three-colour code the "What this strategy does" sentence uses,
     * so one rule holds across the page. Never rose: red is for errors. The gap beat follows the same
     * rule — amber for a shortfall, green in the rare case income covers everything. Care and living
     * costs stay slate: a cost is a fact, not good or bad news.
     */ const pensionTone = pensionRises ? 'good' : pensionFalls ? 'warn' : 'neutral';
    /*
     * Asked in the IN-CARE frame, not today's. This note describes the position once care starts,
     * and the illness-separated assessment is usually the biggest driver of the pension jump it
     * quotes — but with empty options the check asked "are they illness-separated TODAY?" (both
     * still at home: no) and the sentence silently vanished, leaving the jump unexplained
     * (owner-caught, 2026-08-25). Same residency overrides as every figure in this note.
     */ const illnessSeparated = factFind.adviceFor === 'couple' && (0, $8eecd0af141b9afb$export$9b95c99516118f10)(factFind, (0, $8eecd0af141b9afb$export$5f0bb1b091776594)(factFind));
    const homeExemptViaPartner = !bothEntering && (0, $8eecd0af141b9afb$export$6a0c2f6602682b05)(factFind, {});
    /*
     * DATA-HYGIENE FLAG (owner-caught, 2026-08-24). A couple's file said the at-home partner was
     * "renting" while the household owned a $2.8m family home; every in-care figure followed the
     * recorded answer and the owner read the result as a calculation bug. The engine now retains
     * homeowner status regardless (SSA s 11A former-home rule, F-AC11), but the aged care means
     * test still rightly depends on whether a protected person LIVES in the home — so an answer
     * that contradicts owning a home is worth a visible question, right where the numbers appear.
     */ const stayingResidency = partnerEntering ? factFind.client?.currentResidency : factFind.partner?.currentResidency;
    const stayingNotAtHome = factFind.adviceFor === 'couple' && !bothEntering && (parseFloat(String(factFind.home?.value)) || 0) > 0 && !!stayingResidency && stayingResidency !== 'own_home' && stayingResidency !== 'aged_care';
    const adjustedLiving = Number(scenarioLivingExpenses) || 0;
    const originalLiving = parseFloat(String(factFind.expenses?.livingExpenses ?? '')) || 0;
    const gapLine = $eb51a4b4880423a2$export$5159918eb0e0db45({
        cashFlowBeforeCare: financials.cashFlow || 0,
        yearlyCare: yearlyCare,
        accessibleSavings: $eb51a4b4880423a2$export$ecd2bf5d59b66061(factFind),
        projectedRunwayYears: projectedRunwayYears
    });
    /*
     * "Don't panic" — but only where it is true (owner, 6 Oct 2026). A shortfall met from savings is
     * normal in care; whether it is fine depends on the savings lasting as long as the care is
     * planned for (shortfallOutlook.ts). Nothing is said when there are no savings to draw on: that
     * case already has its own sentence and is not one to reassure about.
     */ const outlook = !gapLine.surplus && $eb51a4b4880423a2$export$ecd2bf5d59b66061(factFind) > 0 ? (0, $761eebfc891b9eea$export$a3c504a65d7a0fe7)(runwayFacts ?? (projectedRunwayYears != null ? {
        runwayYears: projectedRunwayYears,
        projectedYears: projectedRunwayYears
    } : null), (0, $761eebfc891b9eea$export$ee5aafeb340c75f8)(factFind), {
        yearsAlreadySaid: gapLine.runwayYears != null
    }) : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$28c8139bd562d0e), {
        eyebrow: existingStay ? `Where ${enteringName} stands by staying at ${existingStay.facilityName || 'the current home'}` : `Where ${enteringName} ${bothEntering ? 'stand' : 'stands'} with no plan`,
        className: "mt-5",
        // Read once, then in the way for the rest of the session — it sits between the room
        // price and every control below it (owner, 2026-08-26). Open by default: this is the
        // position every strategy underneath is measured against.
        collapsible: true,
        // The mock-up's table (UX review, 17 Oct 2026): each beat a row, heading left, words right.
        beatLayout: "rows",
        headingStyle: "navy",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$97060599ed0e6525), {
                tone: "neutral",
                heading: "Care \u2014 what it would cost",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: existingStay ? 'Staying put' : 'With no plan in place'
                    }),
                    " \u2014 ",
                    existingStay ? `the current room, the deposit already held, and ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(existingStay.dailyPayment)} a day on the rest of it` : `nothing paid up front, nothing sold or restructured${villageExit ? (0, $511dfa7ed5ad5c31$export$65f8669d24e0c145)(villageExit) : ''}`,
                    " \u2014 ",
                    careBeat ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            careBeat.untilThen,
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold text-slate-900",
                                children: careBeat.fromThen
                            }),
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold",
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(phaseTwoDap)
                            }),
                            " of the two-room figure is the ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                term: "DAP"
                            }),
                            " charged on the unpaid rooms"
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "it would cost ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "font-semibold text-slate-900",
                                children: [
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dailyTotal),
                                    " a day"
                                ]
                            }),
                            ' ',
                            "(",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(yearlyCare),
                            "/yr)",
                            secondInFirstStage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    " for the two rooms together \u2014 ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(firstDaily),
                                    " a day for ",
                                    firstName,
                                    "'s and ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(secondDaily),
                                    " a day for ",
                                    secondName,
                                    "'s"
                                ]
                            }),
                            " \u2014 ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold",
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dailyDap)
                            }),
                            " of that is the ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                term: "DAP"
                            }),
                            " charged on the unpaid ",
                            secondInFirstStage ? 'rooms' : 'room'
                        ]
                    }),
                    ", which works like rent: none of it comes back.",
                    ' ',
                    "The rest is the basic daily fee and the means-tested contributions. They start the day care begins and are charged whether the room is paid as a lump sum or daily.",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: "Step 3 shows ways to reduce these costs."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$97060599ed0e6525), {
                tone: pensionTone,
                heading: pensionRises ? "Age Pension \u2014 it rises once care starts" : "Age Pension \u2014 what would be paid",
                children: [
                    pensionRises ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-slate-500",
                                children: [
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pensionToday),
                                    "/yr today"
                                ]
                            }),
                            " \u2192",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "font-semibold text-slate-900",
                                children: [
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pension),
                                    "/yr once in care"
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "font-semibold text-slate-900",
                        children: [
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pension),
                            "/yr"
                        ]
                    }),
                    illnessSeparated && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " \u2014 ",
                            pensionRises ? 'it rises because they would be assessed as' : 'assessed as',
                            " an",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                term: "illness-separated couple"
                            }),
                            ": each is paid at the higher single rate, and the means tests apply more generous thresholds"
                        ]
                    }),
                    '.',
                    homeExemptViaPartner && stayingName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " Because ",
                            stayingName,
                            " stays in the home as a ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                term: "protected person"
                            }),
                            ", the home is exempt from the aged care means test."
                        ]
                    }),
                    bothEntering && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " With nobody left living in the family home, it counts in the aged care means test",
                            secondRoom?.careStartDate ? ` from the day ${secondName} moves in; until then it is exempt because ${secondName} is still living there` : '',
                            " \u2014 only up to the capped home value, and it stays exempt for the Age Pension for two years."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eec331ce661055d2$export$836922263996c16c), {
                financials: financials,
                isCouple: factFind.adviceFor === 'couple',
                name: enteringName,
                alsoMoves: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: "lowers the means-tested care fees at the same time"
                }),
                whereNext: "The strategies in step 3",
                careDepositRelevant: true
            }),
            adjustedLiving > 0 && Math.round(adjustedLiving) !== Math.round(originalLiving) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$97060599ed0e6525), {
                tone: "neutral",
                heading: "Your living costs \u2014 updated",
                children: [
                    "You've set living costs to ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(adjustedLiving)
                    }),
                    " a year for once",
                    ' ',
                    enteringName,
                    " ",
                    enteringAre,
                    " in care, instead of ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(originalLiving),
                    ". Everything on this page now uses that figure \u2014 including the \u201Cno plan\u201D position above, which is what every strategy gets compared against.",
                    phase2 && secondRoom?.livingExpensesOnceBoth != null && Math.round(secondRoom.livingExpensesOnceBoth) !== Math.round(adjustedLiving) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " ",
                            (0, $b8d3cfe4c156722e$export$16b931c1d501c85b)(phaseNames, secondRoom.livingExpensesOnceBoth)
                        ]
                    })
                ]
            }),
            phase2 && secondRoom?.livingExpensesOnceBoth != null && Math.round(secondRoom.livingExpensesOnceBoth) !== Math.round(adjustedLiving) && !(adjustedLiving > 0 && Math.round(adjustedLiving) !== Math.round(originalLiving)) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$97060599ed0e6525), {
                tone: "neutral",
                heading: "Your living costs \u2014 from the second stage",
                children: [
                    (0, $b8d3cfe4c156722e$export$16b931c1d501c85b)(phaseNames, secondRoom.livingExpensesOnceBoth),
                    " Until then they are ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(adjustedLiving || originalLiving),
                    " a year."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$97060599ed0e6525), {
                tone: gapLine.surplus ? 'good' : outlook?.covered === false ? 'warn' : 'neutral',
                heading: "The gap \u2014 what it leaves",
                children: [
                    outlook && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            outlook.lead,
                            " "
                        ]
                    }),
                    gapLine.text,
                    phase2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " ",
                            (0, $b8d3cfe4c156722e$export$d32c6b1cf9147a3b)(phaseNames, phaseTwoGap)
                        ]
                    }),
                    outlook?.verdict && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " ",
                            outlook.verdict
                        ]
                    }),
                    outlook?.covered !== false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold text-slate-900",
                                children: "Step 3 shows the ways to move these numbers."
                            })
                        ]
                    })
                ]
            }),
            stayingNotAtHome && stayingName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-2 rounded-lg border border-slate-200/70 border-l-4 border-l-amber-500 bg-white px-3 py-2 text-xs leading-relaxed text-amber-900 shadow-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "Check one thing:"
                    }),
                    " the profile records ",
                    stayingName,
                    " as",
                    ' ',
                    $eb51a4b4880423a2$var$RESIDENCY_LABELS[String(stayingResidency)] || 'not living in the family home',
                    ", so the modelling treats the home as having no ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                        term: "protected person"
                    }),
                    " in it \u2014 which raises the aged care means test. If ",
                    stayingName,
                    " actually lives in the family home, update Living Arrangements in the Client Profile first."
                ]
            })
        ]
    });
};
var $eb51a4b4880423a2$export$2e2bcd8739ae039 = $eb51a4b4880423a2$var$WalkInPositionNote;




/**
 * THE MONEY, IN THE ORDER IT IS SPENT (owner, 22 Sep 2026: "it just grouped the savings as a lump
 * sum … this should be client specific"; and on the rail: "specifically call out when the bank
 * account runs out before moving to the next asset").
 *
 * Each pool the client holds, named as they named it, and the projected year it runs low; then the
 * year everything is gone. Read off the projection rows the runway is struck on, so the years agree
 * with the headline above them. Two shapes from one derivation: a list for step 2 (`buildMoneySequence`)
 * and one brief sentence for the plan summary rail (`moneySequenceSentence`), so the two never tell
 * different stories.
 */ 
parcelRequire("acw62");

const $f15268380bf00a12$var$sumPool = (list)=>(list || []).reduce((t, a)=>t + (parseFloat(String(a?.value ?? 0)) || 0), 0);
/**
 * Account names, with whose they are when two share a name (owner, 24 Oct 2026: "MLC ABP, MLC ABP"). Only
 * accounts that still hold money: one a plan has already emptied is not where the gap comes from (owner,
 * 24 Oct 2026: "why do you still reference Matthew's ABP when it's been used up?").
 */ function $f15268380bf00a12$var$namesOf(list, factFind) {
    const named = (list || []).filter((a)=>a.description && (parseFloat(String(a.value ?? 0)) || 0) >= 1000);
    const count = (d)=>named.filter((a)=>a.description === d).length;
    const whose = (o)=>(o === 'client' ? factFind?.client?.firstName : o === 'partner' ? factFind?.partner?.firstName : o === 'joint' ? 'joint' : '') || '';
    return named.map((a)=>{
        const w = count(String(a.description)) > 1 ? whose(a.ownership) : '';
        return w ? `${a.description} (${w === 'joint' ? 'joint' : `${w}'s`})` : String(a.description);
    }).join(', ');
}
function $f15268380bf00a12$var$poolsOf(rows, factFind) {
    const assets = factFind.assets || {};
    const make = (key, plural, singularVerb)=>{
        const list = assets[key];
        /*
         * A pool the PLAN has already spent — the pension drawn to pay the deposit — is not a pool
         * the shortfall is met from, and must not read as "runs out in year 1, so it goes first"
         * (owner-caught, 18 Oct 2026: "the bank account goes first but the explanation is
         * referencing the ABP"). The first projection row is the position with the plan in place:
         * a pool that is already empty there is left out of the order altogether.
         */ const opening = rows.length ? $f15268380bf00a12$var$sumPool(rows[0]?.assets?.[key]) : $f15268380bf00a12$var$sumPool(list);
        if (opening < 1000) return null;
        const row = rows.find((r, i)=>i > 0 && $f15268380bf00a12$var$sumPool(r.assets?.[key]) < 1000);
        return {
            key: key,
            plural: plural,
            singularVerb: singularVerb,
            today: $f15268380bf00a12$var$sumPool(list),
            names: $f15268380bf00a12$var$namesOf(list, factFind),
            year: row ? Number(row.year) || rows.indexOf(row) + 1 : null
        };
    };
    return [
        make('bankAccounts', 'the everyday accounts', false),
        make('accountBasedPensions', 'the account-based pension', true),
        make('shares', 'the shares', false)
    ].filter((p)=>p != null && p.today > 1000)// In the order the engine empties them; a pool that never empties sits last.
    .sort((a, b)=>(a.year ?? 1e9) - (b.year ?? 1e9));
}
const $f15268380bf00a12$var$cap = (s)=>s.charAt(0).toUpperCase() + s.slice(1);
const $f15268380bf00a12$var$withNamesAt = (todayWord)=>(p)=>`${p.plural} (${p.names ? `${p.names}, ` : ''}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(p.today))} ${todayWord})`;
function $f15268380bf00a12$export$e2001a5314704be0(rows, factFind, runway, opts = {}) {
    if (!rows.length) return [];
    const withNames = $f15268380bf00a12$var$withNamesAt(opts.todayWord || 'today');
    const pools = $f15268380bf00a12$var$poolsOf(rows, factFind);
    const out = [];
    pools.forEach((p, i)=>{
        const next = pools[i + 1];
        if (i === 0) out.push({
            from: 'From year 1',
            text: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "The gap comes out of ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: withNames(p)
                    }),
                    "."
                ]
            })
        });
        // The last pool running low IS the savings running out: one line, not two, for that year.
        const isTheEnd = !next && runway?.exhaustedYear != null && p.year === runway.exhaustedYear;
        if (p.year != null && !isTheEnd) out.push({
            from: `Year ${p.year}`,
            text: next ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: $f15268380bf00a12$var$cap(p.plural)
                    }),
                    " run",
                    p.singularVerb ? 's' : '',
                    " low;",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: withNames(next)
                    }),
                    " carr",
                    next.singularVerb ? 'ies' : 'y',
                    " it from here."
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: $f15268380bf00a12$var$cap(p.plural)
                    }),
                    " run",
                    p.singularVerb ? 's' : '',
                    " low."
                ]
            })
        });
    });
    if (runway?.radDrawStartsYear != null) out.push({
        from: `Year ${runway.radDrawStartsYear}`,
        text: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: "The care fees are drawn from the refundable accommodation deposit, which reduces the refund when care ends and raises the daily accommodation payment."
        })
    });
    if (runway?.exhaustedYear != null) out.push({
        from: `Year ${runway.exhaustedYear}`,
        text: runway.borrowingStartsYear != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: "The savings are gone. From here the plan borrows against the home \u2014 nothing is repaid (assumes a reverse mortgage), so the debt grows until the home is sold, and it reduces what is left to the family."
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: "The savings are gone, and there is nothing accessible left to cover the shortfall \u2014 worth planning another source."
        })
    });
    else if (runway && !runway.depleted) out.push({
        from: 'Beyond',
        text: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: "The savings are not exhausted within the years tested."
        })
    });
    return out;
}
const $f15268380bf00a12$export$904f4cafbfb66613 = 'The early years are the ones to plan for.';
function $f15268380bf00a12$export$3a165bcffcec8b16(runway) {
    const home = runway.borrowingStartsYear != null ? ', including any borrowing against the home,' : '';
    return `${runway.basis} This shows how far the money would stretch, not how long care will last. Many stays are much shorter, so the later years${home} may never arrive.`;
}
function $f15268380bf00a12$export$a8b285fb41fa4254(runway) {
    return `${$f15268380bf00a12$export$3a165bcffcec8b16(runway)} ${$f15268380bf00a12$export$904f4cafbfb66613}`;
}
function $f15268380bf00a12$export$35d5d608b1d0d7ec({ runway: runway, className: className = '' }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        className: `text-[13px] leading-relaxed text-slate-500 ${className}`,
        children: [
            $f15268380bf00a12$export$3a165bcffcec8b16(runway),
            " ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "font-semibold text-slate-700",
                children: $f15268380bf00a12$export$904f4cafbfb66613
            })
        ]
    });
}
function $f15268380bf00a12$export$2c0b92fbaefb8de7(rows, factFind, runway) {
    if (!rows.length || !runway) return null;
    const pools = $f15268380bf00a12$var$poolsOf(rows, factFind);
    if (!pools.length) return null;
    const clauses = [];
    pools.forEach((p, i)=>{
        const next = pools[i + 1];
        const isTheEnd = !next && runway.exhaustedYear != null && p.year === runway.exhaustedYear;
        if (p.year == null || isTheEnd) return;
        clauses.push(`${$f15268380bf00a12$var$cap(p.plural)} run${p.singularVerb ? 's' : ''} low around year ${p.year}${next ? `, then ${next.plural} carr${next.singularVerb ? 'ies' : 'y'} it` : ''}`);
    });
    if (runway.radDrawStartsYear != null) clauses.push(`from about year ${runway.radDrawStartsYear} the care fees are drawn from the refundable accommodation deposit, which reduces the refund at the end and raises the daily accommodation payment`);
    if (runway.exhaustedYear != null) clauses.push(runway.borrowingStartsYear != null ? `the savings are gone around year ${runway.exhaustedYear}, and from there the plan borrows against the home (assumes a reverse mortgage) \u{2014} a debt that grows until the home is sold` : `the savings are gone around year ${runway.exhaustedYear}, and there is nothing accessible left to cover the shortfall`);
    else if (!runway.depleted) clauses.push('the savings are not exhausted within the years tested');
    if (!clauses.length) return null;
    return clauses.map((c, i)=>i === 0 ? c : c.charAt(0).toLowerCase() + c.slice(1)).join('; ') + '.';
}
function $f15268380bf00a12$export$5607313da658fe63(rows, factFind, runway, deposit) {
    if (!rows.length || !runway || !runway.depleted && !runway.bankDepletesYear && runway.coveredPct === 100 && !runway.flag && runway.headline.startsWith('Cashflow stays positive')) return null;
    const pools = $f15268380bf00a12$var$poolsOf(rows, factFind);
    if (!pools.length) return null;
    const steps = pools.map((p, i)=>{
        const prev = pools[i - 1];
        if (i === 0) return p.plural;
        return `then ${p.plural}${prev?.year != null ? ` from about year ${prev.year}` : ''}`;
    });
    const order = steps.length === 1 ? `The shortfall comes out of ${steps[0]}.` : `The shortfall is met in this order: ${steps.join(', ')}.`;
    const later = steps.length > 1 ? ' In practice care usually ends well before the later steps are reached' : ' In practice care usually ends well before the savings are';
    const refund = deposit.refund > 0 ? `${later} \u{2014} and when it does, the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(deposit.refund))} deposit comes back to ${deposit.refundTo}, which is why it sits in the estate figure.` : `${later}${steps.length > 1 ? '.' : ' gone.'}`;
    return `${order}${refund}`;
}




const $85ecae58379d0a08$var$CARD = 'rounded-2xl border border-white/80 bg-white/60 p-6 shadow-lg shadow-gray-200/50 backdrop-blur-xl';
const $85ecae58379d0a08$var$Tile = ({ label: label, value: value, unit: unit, caption: caption, tone: tone, onFigureClick: onFigureClick, figureTooltip: figureTooltip, figureOpen: figureOpen })=>{
    const rule = {
        cost: 'bg-slate-500',
        good: 'bg-emerald-400',
        bad: 'bg-rose-400',
        family: 'bg-[#0290F5]'
    }[tone];
    const figure = {
        cost: 'text-slate-900',
        good: 'text-emerald-700',
        bad: 'text-rose-700',
        family: 'text-slate-900'
    }[tone];
    const figureNode = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: `text-[28px] font-bold leading-none tabular-nums tracking-tight ${figure}`,
        children: [
            value,
            unit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "ml-1 text-[13px] font-semibold text-slate-500",
                children: unit
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `relative overflow-hidden rounded-xl border bg-white px-4 pb-4 pt-5 shadow-card ${figureOpen ? 'border-blue-400 ring-2 ring-blue-100' : 'border-slate-200'}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: `absolute inset-x-0 top-0 h-1 ${rule}`,
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[13px] font-semibold text-slate-600",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-1.5",
                children: onFigureClick ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c0ea688f7c20200$export$2e2bcd8739ae039), {
                    title: "Daily cost \u2014 how it is made up",
                    data: figureTooltip,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onFigureClick,
                        "aria-expanded": !!figureOpen,
                        className: "inline-block cursor-pointer rounded-sm text-left underline decoration-dotted decoration-slate-400 underline-offset-4 hover:decoration-blue-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500",
                        children: figureNode
                    })
                }) : figureNode
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-[13px] leading-snug text-slate-600",
                children: caption
            })
        ]
    });
};
const $85ecae58379d0a08$var$WalkInHero = ({ factFind: factFind, radInput: radInput, secondRoom: secondRoom = null, existingStay: existingStay = null, villageExit: villageExit = null, extraServiceFeeInput: extraServiceFeeInput, scenarioLivingExpenses: scenarioLivingExpenses, agedCareBaseline: agedCareBaseline, runway: runway, legacyYears: legacyYears, onLegacyYearsChange: onLegacyYearsChange, onBack: onBack, onNext: onNext, onReadGuide: onReadGuide, onAssumptions: onAssumptions, onShowProjections: onShowProjections })=>{
    const { costs: costs, secondCosts: secondCosts, careFinancials: careFinancials, todayFinancials: todayFinancials, phase2: phase2 } = (0, $eb51a4b4880423a2$export$9ada56fd292651b8)(factFind, radInput, extraServiceFeeInput, scenarioLivingExpenses, secondRoom, existingStay);
    const [costOpen, setCostOpen] = (0, $acw62.useState)(false);
    /** "Change" on the left-to-the-family tile reveals the years box in place. */ const [editYears, setEditYears] = (0, $acw62.useState)(false);
    const goals = factFind.goals || {};
    const bothEntering = factFind.adviceFor === 'couple' && goals.aged_care_for === 'both' && !!secondRoom && secondRoom.roomPrice > 0;
    const names = (0, $b8d3cfe4c156722e$export$24ee473c3b86ae0)(factFind, secondRoom?.person);
    const enteringName = bothEntering ? `${names.firstName} and ${names.secondName}` : (goals.aged_care_for === 'partner' ? factFind.partner?.firstName : factFind.client?.firstName) || 'the client';
    const ready = (radInput > 0 || !!existingStay) && !!costs && !!careFinancials && !!todayFinancials;
    // Both rooms together, where both enter together: the figure the household actually faces. A
    // second person entering LATER is the second stage (phase2), shown as its own row beneath.
    const dailyTotal = ready ? (costs.totalDailyCost || 0) + (bothEntering && !phase2 ? secondCosts?.totalDailyCost || 0 : 0) : 0;
    const phaseNames = {
        ...names,
        fromLabel: (0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(phase2?.fromDate || '')
    };
    const phaseTwoDaily = phase2 ? (phase2.firstCosts.totalDailyCost || 0) + (phase2.secondCosts?.totalDailyCost || 0) : 0;
    const phaseTwoPension = phase2 ? phase2.financials.socialSecurity || 0 : 0;
    const phaseTwoGap = phase2 ? (phase2.financials.cashFlow || 0) - phaseTwoDaily * 365 : 0;
    const yearlyCare = dailyTotal * 365;
    const pension = ready ? careFinancials.socialSecurity || 0 : 0;
    const pensionToday = ready ? todayFinancials.socialSecurity || 0 : 0;
    const gap = ready ? (careFinancials.cashFlow || 0) - yearlyCare : 0;
    const legacy = agedCareBaseline.legacyValue;
    const years = Number(legacyYears) || 0;
    const pensionCaption = Math.round(pension) > Math.round(pensionToday) ? `Up from ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pensionToday)} today, once care starts.` : Math.round(pension) < Math.round(pensionToday) ? `Down from ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pensionToday)} today, once care starts.` : 'The same as today.';
    // The daily cost, line by line — the same lines and the same calculation tooltips the plan
    // summary's cost block carries, so the figure a client taps here is the one an adviser reads there.
    const c = ready ? costs : null;
    const costLines = c ? [
        {
            label: 'Basic daily fee',
            value: c.basicDailyFee || 0,
            breakdown: c.calculationBreakdowns?.bdf
        },
        {
            label: 'Paying for the room day by day (DAP)',
            value: c.dailyAccommodationPayment || 0,
            breakdown: c.calculationBreakdowns?.dap
        },
        ...c.feeArrangements === '2014' ? [
            {
                label: 'Means-tested care fee (no worse off)',
                value: c.dailyMTCF || 0,
                breakdown: c.calculationBreakdowns?.mtcf
            }
        ] : [
            {
                label: 'Care contribution (NCCC)',
                value: c.dailyNCCC || 0,
                breakdown: c.calculationBreakdowns?.nccc
            },
            {
                label: 'Everyday living contribution (HSC)',
                value: c.dailyHSC || 0,
                breakdown: c.calculationBreakdowns?.hsc
            }
        ],
        ...c.dailyExtraServiceFee ? [
            {
                label: 'Optional extra services',
                value: c.dailyExtraServiceFee
            }
        ] : []
    ] : [];
    const costTooltip = costLines.map((l)=>({
            label: l.label,
            value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(l.value)
        }));
    const sequence = (0, $acw62.useMemo)(()=>(0, $f15268380bf00a12$export$e2001a5314704be0)(agedCareBaseline.runwayProjections || [], factFind, runway), [
        agedCareBaseline.runwayProjections,
        factFind,
        runway
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $85ecae58379d0a08$var$CARD,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[11px] font-bold uppercase tracking-[0.1em] text-slate-400",
                        children: [
                            "Step 2 of 3",
                            existingStay ? '' : " \xb7 if nothing were paid up front and nothing sold"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "mt-1 text-[22px] font-bold leading-tight tracking-tight text-slate-900",
                        children: existingStay ? (0, $b073c6d711dafa37$export$38d95bea694c356c)(existingStay) : 'Four numbers tell the story. Each one is explained beneath.'
                    }),
                    existingStay && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-1 text-[14px] text-slate-600",
                        "data-testid": "stay-put-intro",
                        children: (0, $b073c6d711dafa37$export$7f4e2411605a6b31)({
                            name: enteringName,
                            facilityName: existingStay.facilityName
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1 text-[14px] text-slate-600",
                        children: [
                            "This is the starting point every plan in step 3 is measured against \u2014 we call it",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold text-slate-800",
                                children: existingStay ? 'staying put' : 'paying daily'
                            }),
                            ": ",
                            existingStay ? 'the current room and deposit kept, and nothing else changed' : 'the room paid daily, nothing paid up front and nothing sold',
                            "."
                        ]
                    }),
                    ready && phase2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-3 rounded-lg border-l-4 border-blue-500 bg-white px-3 py-2 text-[13px] leading-relaxed text-slate-700",
                        "data-testid": "phases-intro",
                        children: (0, $b8d3cfe4c156722e$export$20f15f6261f594de)(phaseNames)
                    }),
                    !ready ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-5 rounded-xl border border-dashed border-slate-300 bg-slate-50/80 px-4 py-6 text-center text-[14px] text-slate-600",
                        children: existingStay ? "Working out the stay-put position\u2026" : 'Enter the room price in step 1 and the four numbers appear here.'
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($85ecae58379d0a08$var$Tile, {
                                        label: "Care would cost",
                                        value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(dailyTotal)),
                                        unit: "a day",
                                        caption: phase2 ? `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(yearlyCare))} a year. ${(0, $b8d3cfe4c156722e$export$af3a013ca5b458b2)(phaseNames)}` : `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(yearlyCare))} a year, from the day care begins.`,
                                        tone: "cost",
                                        onFigureClick: ()=>setCostOpen((v)=>!v),
                                        figureTooltip: costTooltip,
                                        figureOpen: costOpen
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($85ecae58379d0a08$var$Tile, {
                                        label: `${enteringName}'s Age Pension`,
                                        value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pension),
                                        unit: "a year",
                                        caption: pensionCaption,
                                        tone: "good"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($85ecae58379d0a08$var$Tile, {
                                        label: gap < 0 ? 'Each year, short by' : 'Left over each year',
                                        value: `${gap < 0 ? '' : '+'}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(gap)))}`,
                                        caption: gap < 0 ? 'After the pension and other income. Met from savings.' : 'After care and living costs are paid.',
                                        tone: gap < 0 ? 'bad' : 'good'
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($85ecae58379d0a08$var$Tile, {
                                        label: "Left to the family",
                                        value: legacy != null ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(legacy)) : "\u2014",
                                        caption: legacy != null ? /* The mock-up's line (17 Oct 2026): the horizon as a suggestion in words, with
                                           "Change" opening the number — not a box in the middle of the sentence. */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                "After about ",
                                                years,
                                                " ",
                                                years === 1 ? 'year' : 'years',
                                                " \u2014 ",
                                                enteringName,
                                                "'s age and health suggest that.",
                                                onLegacyYearsChange ? editYears ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "mt-1 block",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9873a6fbc9fd360$export$68741d4d7bc37a6d), {
                                                        years: years,
                                                        onChange: onLegacyYearsChange,
                                                        after: ": everything owned, less everything owed."
                                                    })
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>setEditYears(true),
                                                            className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                                            children: "Change"
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        }) : 'Not available: the no-plan projection could not be run.',
                                        tone: "family"
                                    })
                                ]
                            }),
                            phase2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-4",
                                "data-testid": "phase-two-row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-[11px] font-bold uppercase tracking-[0.1em] text-slate-400",
                                        children: (0, $b8d3cfe4c156722e$export$a2b7e2699cfc74be)(phaseNames)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-2 grid grid-cols-1 gap-4 sm:grid-cols-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($85ecae58379d0a08$var$Tile, {
                                                label: "Care would cost",
                                                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(phaseTwoDaily)),
                                                unit: "a day",
                                                caption: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(phaseTwoDaily * 365))} a year for both rooms, once ${phaseNames.secondName} moves in.`,
                                                tone: "cost"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($85ecae58379d0a08$var$Tile, {
                                                label: `${enteringName}'s Age Pension`,
                                                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(phaseTwoPension),
                                                unit: "a year",
                                                caption: Math.round(phaseTwoPension) === Math.round(pension) ? 'The same as in the first stage.' : `From ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pension)} in the first stage.`,
                                                tone: "good"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($85ecae58379d0a08$var$Tile, {
                                                label: phaseTwoGap < 0 ? 'Each year, short by' : 'Left over each year',
                                                value: `${phaseTwoGap < 0 ? '' : '+'}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(phaseTwoGap)))}`,
                                                caption: phaseTwoGap < 0 ? 'After the pension and other income, with both rooms paid for.' : 'After both rooms and living costs are paid.',
                                                tone: phaseTwoGap < 0 ? 'bad' : 'good'
                                            })
                                        ]
                                    })
                                ]
                            }),
                            costOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-3 rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-card",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-[11px] font-bold uppercase tracking-[0.09em] text-slate-400",
                                        children: [
                                            "How the ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(dailyTotal)),
                                            " a day is made up"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-2 divide-y divide-slate-100",
                                        children: [
                                            costLines.map((l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-center justify-between gap-4 py-2 text-[14px]",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c0ea688f7c20200$export$2e2bcd8739ae039), {
                                                            title: `${l.label} Calculation`,
                                                            data: l.breakdown,
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: `text-slate-600 ${l.breakdown ? 'cursor-help underline decoration-dotted decoration-slate-400 underline-offset-2' : ''}`,
                                                                children: l.label
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "font-semibold tabular-nums text-slate-900",
                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(l.value)
                                                        })
                                                    ]
                                                }, l.label)),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center justify-between gap-4 py-2 text-[14px]",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-semibold text-slate-900",
                                                        children: "Total each day"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold tabular-nums text-slate-900",
                                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dailyTotal)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mt-2 text-[13px] text-slate-500",
                                        children: "Hover a line for the calculation behind it. Step 3 shows ways to reduce these costs."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-3 text-[13px] text-slate-500",
                                children: [
                                    "Figures use the rates in force from ",
                                    (0, $1abe73eeef086faf$export$946308c675ba021d).agePension,
                                    ". The",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: onAssumptions,
                                        className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                        children: "Assumptions"
                                    }),
                                    ' ',
                                    "page lists every one, with its source and date."
                                ]
                            })
                        ]
                    })
                ]
            }),
            ready && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $85ecae58379d0a08$var$CARD,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "-mt-5",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb51a4b4880423a2$export$2e2bcd8739ae039), {
                        factFind: factFind,
                        radInput: radInput,
                        secondRoom: secondRoom,
                        existingStay: existingStay,
                        villageExit: villageExit,
                        extraServiceFeeInput: extraServiceFeeInput,
                        scenarioLivingExpenses: scenarioLivingExpenses,
                        projectedRunwayYears: runway?.exhaustedYear ?? null,
                        runwayFacts: (0, $761eebfc891b9eea$export$2e354e42d669da07)(agedCareBaseline.runwayProjections)
                    })
                })
            }),
            ready && runway && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $85ecae58379d0a08$var$CARD,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[11px] font-bold uppercase tracking-[0.09em] text-slate-400",
                        children: "How long the money lasts"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-2",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c05f3bca3803eec$export$7fbbcd423808f3d5), {
                            headline: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-[18px] font-bold leading-tight tracking-tight text-slate-900",
                                children: runway.headline
                            }),
                            coveredPct: runway.coveredPct,
                            leftLabel: runway.leftLabel,
                            rightLabel: runway.rightLabel,
                            depleted: runway.depleted
                        })
                    }),
                    sequence.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ol", {
                        className: "mt-4 grid grid-cols-[7.5rem_minmax(0,1fr)] gap-x-3 gap-y-2",
                        children: sequence.map((e, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        className: "list-none",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "inline-flex w-full justify-center rounded-md bg-slate-100 px-2 py-1 text-[12px] font-bold uppercase tracking-wide text-slate-600",
                                            children: e.from
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        className: "list-none pt-0.5 text-[14px] leading-relaxed text-slate-600",
                                        children: e.text
                                    })
                                ]
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f15268380bf00a12$export$35d5d608b1d0d7ec), {
                        runway: runway,
                        className: "mt-3 ml-[8.25rem] max-w-3xl"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onShowProjections,
                        className: "mt-3 inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-[13px] font-semibold text-blue-700 hover:border-blue-300 hover:bg-blue-50",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                size: 15
                            }),
                            " See the projections, year by year"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: onBack,
                                className: "inline-flex h-11 items-center gap-2 rounded-lg border border-slate-300 bg-white px-5 text-[14px] font-semibold text-slate-700 shadow-sm hover:bg-slate-50",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                        size: 16
                                    }),
                                    " Change the room or start date"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: onReadGuide,
                                className: "inline-flex items-center gap-1.5 text-[13px] font-semibold text-blue-700 hover:text-blue-900",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                        size: 15
                                    }),
                                    " Read the full guide to aged care fees"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onNext,
                        disabled: !ready,
                        className: "inline-flex h-11 items-center gap-2 rounded-lg bg-blue-600 hover:bg-blue-700 px-5 text-[14px] font-semibold text-white shadow-sm disabled:opacity-50",
                        children: [
                            "Show me ways to pay for it ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                size: 16
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $85ecae58379d0a08$export$2e2bcd8739ae039 = $85ecae58379d0a08$var$WalkInHero;


/**
 * The plan summary's cost block, folded (owner, 22 Sep 2026): one number always — the daily cost and
 * its yearly figure — and the fee lines behind "See how it is made up". The lines keep their
 * calculation tooltips (an adviser hovers a line for the working behind it), which is the part that
 * must never go missing when the block is folded.
 */ 

var $acw62 = parcelRequire("acw62");


const $9c0142643c4b04c6$var$CostOverviewDisclosure = ({ dailyTotal: dailyTotal, children: children, defaultOpen: defaultOpen = false, note: note })=>{
    const [open, setOpen] = (0, $acw62.useState)(defaultOpen);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-gray-800 text-white rounded-xl p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-start justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-gray-400 text-[13px] leading-snug",
                        children: [
                            "Your estimated",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            "daily cost"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-right",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-3xl font-bold text-white leading-none",
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dailyTotal)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-gray-300 font-semibold text-[13px] mt-1",
                                children: [
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((dailyTotal || 0) * 365),
                                    " / year"
                                ]
                            })
                        ]
                    })
                ]
            }),
            note && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-[13px] leading-snug text-sky-200",
                "data-testid": "cost-phase-two",
                children: note
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: ()=>setOpen((v)=>!v),
                "aria-expanded": open,
                className: "mt-3 flex w-full items-center justify-between gap-2 rounded-lg border border-white/15 px-3 py-2 text-[13px] font-semibold text-sky-200 hover:bg-white/5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: open ? 'Hide how it is made up' : 'See how it is made up'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                        size: 16,
                        className: `transition-transform ${open ? 'rotate-180' : ''}`
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 space-y-3 border-t border-white/15 pt-3",
                children: [
                    children,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[13px] text-gray-400",
                        children: "Hover a line for the calculation behind it."
                    })
                ]
            })
        ]
    });
};
var $9c0142643c4b04c6$export$2e2bcd8739ae039 = $9c0142643c4b04c6$var$CostOverviewDisclosure;




/**
 * WHERE THE MONEY COMES FROM, ACCOUNT BY ACCOUNT, AND WHY IN THAT ORDER (owner, 18 Oct 2026: "I want it
 * clearly stated when the bank account runs out and then which asset and so on … when will the house
 * come into play … if you had two ABPs do we explain which one first and why … shares last because we
 * pay CGT").
 *
 * The order is the projection engine's own, read from its plugins (server/src/rest/calculation/plugins):
 *   bank accounts, in the order listed (order 10) → account-based pensions, in the order listed (11)
 *   → accumulation super from age 60 (11, after pensions) → shares, last, because a sale realises CGT
 *   and must cover its own tax (12) → the care fees drawn from the refundable deposit (13) → borrowing
 *   against the home (14).
 * The years come from the projection rows: each account's balance per year, so "runs low around year 4"
 * is the engine's figure, not a guess. An account the plan itself emptied (drawn for the deposit) is
 * named as such and left out of the order (see moneySequence.poolsOf).
 *
 * Two shapes from one derivation: a short summary for the Explain this line, and the full story behind
 * "see the order, and why" — so the card stays light and the detail is there for whoever wants it.
 */ 

var $acw62 = parcelRequire("acw62");



const $2ddaae90639b5011$var$POOL_ORDER = [
    'bankAccounts',
    'accountBasedPensions',
    'superannuation',
    'shares'
];
const $2ddaae90639b5011$var$num = (v)=>parseFloat(String(v ?? 0)) || 0;
const $2ddaae90639b5011$var$GROUP_WORDS = {
    bankAccounts: {
        one: 'the everyday account',
        many: 'the everyday accounts'
    },
    accountBasedPensions: {
        one: 'the account-based pension',
        many: 'the account-based pensions'
    },
    superannuation: {
        one: 'the super',
        many: 'the super'
    },
    shares: {
        one: 'the shares',
        many: 'the shares'
    }
};
/** Why the engine reaches for this kind of money at this point in the order. */ const $2ddaae90639b5011$var$WHY = {
    bankAccounts: 'Cash goes first: there is nothing to sell, nothing to apply for, and no tax on taking it out.',
    accountBasedPensions: "A pension\u2019s regular payments are already counted as income above; drawing more is simply a bigger payment, tax-free after 60, with nothing to sell. Where there is more than one, the one expected to earn the least is drawn first, so the money left invested is the money growing fastest.",
    superannuation: 'Super is tax-free from age 60 and can be drawn without selling anything, so it is used before the shares.',
    shares: 'Shares come last: selling them realises capital gains tax, and each sale has to cover its own tax bill as well as the shortfall.'
};
const $2ddaae90639b5011$export$5096cef44f38ca5d = 'A pension started before 1 January 2015 is drawn last, whatever it earns: Centrelink still counts its income the older, kinder way, and every dollar taken out of it raises the income counted, while a newer pension drawn instead lowers it. Once emptied, the older treatment is gone for good.';
/**
 * The account's name as the client would say it. A couple's "MLC" and "MLC" (his and hers) become
 * "Colin's MLC" and "Shelly's MLC" from the record's ownership; a joint account or a single client's
 * keeps the plain description. A description that already carries the name is left alone.
 */ function $2ddaae90639b5011$var$accountName(a, key, factFind) {
    const desc = String(a?.description || '').trim() || $2ddaae90639b5011$var$GROUP_WORDS[key].one.replace(/^the /, '');
    if (factFind.adviceFor !== 'couple') return desc;
    const owner = a?.ownership === 'partner' ? factFind.partner?.firstName : a?.ownership === 'client' ? factFind.client?.firstName : null;
    if (!owner) return desc;
    return desc.toLowerCase().includes(String(owner).toLowerCase()) ? desc : `${owner}'s ${desc}`;
}
function $2ddaae90639b5011$export$8a9ac258bf505ff7(rows, factFind) {
    const assets = factFind.assets || {};
    const out = [];
    for (const key of $2ddaae90639b5011$var$POOL_ORDER){
        const list = assets[key] || [];
        /*
         * In the order the engine draws them (F.46, 21 Oct 2026): pensions started before 1 January 2015 last
         * (22 Oct 2026), otherwise pensions earning least first, ties in file
         * order (abpPlugin.abpDrawOrder). The index into the projection rows stays the file index.
         */ const onFile = (a)=>!(a?.growthRate == null || a.growthRate === '' || !Number.isFinite(Number(a.growthRate)));
        const rateOf = (a)=>onFile(a) ? Number(a.growthRate) : (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703).balanced.pensionNetPct;
        const order = list.map((a, i)=>({
                a: a,
                i: i
            }));
        const oldOf = (a)=>a?.commencementDateOption === 'pre-2015' ? 1 : 0;
        if (key === 'accountBasedPensions') order.sort((x, y)=>oldOf(x.a) - oldOf(y.a) || rateOf(x.a) - rateOf(y.a) || x.i - y.i);
        order.forEach(({ a: a, i: i })=>{
            const before = $2ddaae90639b5011$var$num(a?.value);
            if (before < 1000) return;
            const opening = rows.length ? $2ddaae90639b5011$var$num(rows[0]?.assets?.[key]?.[i]?.value) : before;
            const lowRow = rows.find((r, ri)=>ri > 0 && $2ddaae90639b5011$var$num(r.assets?.[key]?.[i]?.value) < 1000);
            out.push({
                key: key,
                name: $2ddaae90639b5011$var$accountName(a, key, factFind),
                opening: opening,
                before: before,
                lowYear: lowRow ? Number(lowRow.year) || rows.indexOf(lowRow) + 1 : null,
                spentByPlan: opening < 1000,
                ...key === 'accountBasedPensions' ? {
                    rate: {
                        pct: rateOf(a),
                        source: onFile(a) ? 'file' : 'assumed'
                    },
                    pre2015: oldOf(a) === 1
                } : {}
            });
        });
    }
    return out;
}
function $2ddaae90639b5011$export$f7d99c6894b71e52(rate) {
    if (!rate) return '';
    const pct = `${Number(rate.pct.toFixed(2))}%`;
    return rate.source === 'file' ? `expected to earn ${pct} a year after fees (the figure on the file)` : `assumed to earn ${pct} a year after fees (our Balanced assumption \u{2014} no figure was entered for this fund)`;
}
function $2ddaae90639b5011$export$bdea18f456fd84b({ rows: rows, factFind: factFind, runway: runway, deposit: deposit, horizonYears: horizonYears, enteringName: enteringName, spentOn: spentOn = 'the deposit' }) {
    if (!rows.length) return null;
    const all = $2ddaae90639b5011$export$8a9ac258bf505ff7(rows, factFind);
    const spent = all.filter((a)=>a.spentByPlan);
    const live = all.filter((a)=>!a.spentByPlan);
    const testedYears = rows.length;
    const steps = [];
    const yearWord = (y)=>`year ${y}`;
    const pensionsLive = live.filter((a)=>a.key === 'accountBasedPensions').length;
    // The accounts, in the engine's order, each with the year it runs low.
    let prevLow = 1;
    live.forEach((a, i)=>{
        const fromYear = i === 0 ? 1 : prevLow;
        // "after the deposit" in aged care; the module's own word elsewhere ("after the entry payment").
        const after = a.opening + 0.5 < a.before ? ` (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(a.opening))} after ${spentOn})` : ` (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(a.opening))})`;
        const lastsWords = a.lowYear != null ? `runs low around ${yearWord(a.lowYear)}` : `lasts beyond the ${testedYears} years tested`;
        steps.push({
            from: fromYear == null ? 'Then' : i === 0 ? 'From year 1' : `From about ${yearWord(fromYear)}`,
            title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "text-slate-900",
                        children: a.name
                    }),
                    after,
                    a.rate ? `, ${$2ddaae90639b5011$export$f7d99c6894b71e52(a.rate)},` : '',
                    " covers the shortfall and ",
                    lastsWords,
                    "."
                ]
            }),
            why: i === 0 || live[i - 1].key !== a.key ? `${$2ddaae90639b5011$var$WHY[a.key]}${a.key === 'accountBasedPensions' && pensionsLive > 1 && live.some((x)=>x.pre2015) && live.some((x)=>x.key === 'accountBasedPensions' && !x.pre2015) ? ` ${$2ddaae90639b5011$export$5096cef44f38ca5d}` : ''}${a.key === 'accountBasedPensions' && pensionsLive > 1 ? " The order rests on the rates shown: if a fund is likely to earn more or less than that, the order, and what is left at the end, can change \u2014 so check them with the fund." : ''}` : undefined,
            tone: 'money'
        });
        prevLow = a.lowYear;
    });
    if (runway?.radDrawStartsYear != null) steps.push({
        from: `From about ${yearWord(runway.radDrawStartsYear)}`,
        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                "The care fees are drawn from the ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "refundable deposit itself"
                }),
                ". Each dollar drawn reduces what comes back",
                deposit.refundTo ? ` to ${deposit.refundTo}` : '',
                " when care ends, and raises the daily room fee."
            ]
        }),
        tone: 'deposit'
    });
    const homeYear = runway?.borrowingStartsYear ?? null;
    if (homeYear != null) {
        // The rate lives on the runway summary, not the copy type; read it when a caller passed it through.
        const rateVal = runway?.borrowingRate;
        const rate = rateVal != null ? ` at about ${rateVal}% a year` : '';
        steps.push({
            from: `From about ${yearWord(homeYear)}`,
            title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "text-slate-900",
                        children: "This is when the house comes into play."
                    }),
                    " The plan borrows against the home",
                    rate,
                    " (modelled as a reverse mortgage); nothing is repaid until the home is sold, so the debt grows and reduces what is left to the family."
                ]
            }),
            tone: 'home'
        });
    } else if (runway?.exhaustedYear != null) steps.push({
        from: `From about ${yearWord(runway.exhaustedYear)}`,
        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: "The savings are gone and nothing accessible is left to cover the shortfall \u2014 worth planning another source."
        }),
        tone: 'end'
    });
    else steps.push({
        from: 'The house',
        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                "The home is ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "not needed"
                }),
                " within the ",
                horizonYears,
                " ",
                horizonYears === 1 ? 'year' : 'years',
                " we plan for",
                testedYears > horizonYears ? `, nor within the ${testedYears} years tested` : '',
                "."
            ]
        }),
        tone: 'home'
    });
    // The summary: first account and when it runs low, what carries it next, and the house.
    const first = live[0];
    const second = live[1];
    const parts = [];
    const radYear = runway?.radDrawStartsYear ?? null;
    if (first) {
        // What carries it after the first account: the next account, or the deposit itself.
        // Nothing after an account that lasts the years tested is drawn, so nothing after it is named — as the card's
        // line (runwayCardLine) says it (live check, 22 Oct 2026: "ANZ … lasts beyond" on the card, "then John's MLC" here).
        const next = first.lowYear == null ? `, which lasts beyond the ${testedYears} ${testedYears === 1 ? 'year' : 'years'} tested` : second ? `; then ${second.name}${live.length > 2 && second.lowYear != null ? ', and so on' : ''}` : radYear != null ? `; then the care fees come out of the deposit itself` : '';
        parts.push(`The gap comes out of ${first.name} first${first.lowYear != null ? `, which runs low around year ${first.lowYear}` : ''}${next}.`);
    } else if (radYear != null) parts.push('With no savings account left to draw on, the care fees come out of the deposit itself.');
    else parts.push('There is no accessible savings account to meet the gap from.');
    // The deposit's turn is said even when borrowing follows it (25 Oct 2026: the card went from the shares straight
    // to "borrows against the home", while the hand-built rail, on the same projection, drew on the deposit first).
    const depositTurn = radYear != null ? `From about year ${radYear} the care fees come out of the deposit itself, which reduces the refund when care ends.` : '';
    if (depositTurn && first && second) parts.push(depositTurn);
    if (homeYear != null) parts.push(`From about year ${homeYear} the plan borrows against the home.`);
    else if (runway?.exhaustedYear != null) parts.push(`The savings are gone around year ${runway.exhaustedYear}.`);
    else parts.push(`The home is not needed within the ${horizonYears} years we plan for.`);
    if (!first && !second) parts.push(`${enteringName}'s pension and other income are what there is.`);
    // Stop at the first account that lasts the years tested: nothing after it is drawn (live check, 22 Oct 2026).
    const lastsAt = live.findIndex((a)=>a.lowYear == null);
    const drawn = lastsAt >= 0 ? live.slice(0, lastsAt + 1) : live;
    const orderLine = drawn.map((a, i)=>`${i === 0 ? '' : 'then '}${a.name}${i === 0 ? ' first' : ''}, which ${a.lowYear != null ? `runs low around year ${a.lowYear}` : `${/s$/i.test(a.name) && !/'s /.test(a.name) ? 'last' : 'lasts'} beyond the ${testedYears} ${testedYears === 1 ? 'year' : 'years'} tested`}`).join('; ');
    const thenLine = [
        depositTurn,
        homeYear != null ? `From about year ${homeYear} the plan borrows against the home.` : runway?.exhaustedYear != null ? `The savings are gone around year ${runway.exhaustedYear}.` : ''
    ].filter(Boolean).join(' ');
    return {
        summary: parts.join(' '),
        steps: steps,
        spent: spent,
        spentOn: spentOn,
        testedYears: testedYears,
        orderLine: orderLine,
        thenLine: thenLine
    };
}
const $2ddaae90639b5011$var$TONE = {
    money: 'bg-brand-navy',
    deposit: 'bg-amber-500',
    home: 'bg-brand-navy',
    end: 'bg-rose-500'
};
const $2ddaae90639b5011$export$1a915263dc5391f1 = ({ story: story, testId: testId = 'money-story' })=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        "data-testid": testId,
        children: [
            story.summary,
            ' ',
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: ()=>setOpen((o)=>!o),
                "aria-expanded": open,
                className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-[3px] hover:decoration-brand-navy",
                "data-testid": `${testId}-toggle`,
                children: open ? "hide the order \u2039" : "see the order, and why \u203A"
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                className: "mt-3 space-y-2.5 border-l-2 border-slate-200 pl-4",
                "data-testid": `${testId}-steps`,
                children: [
                    story.steps.map((s, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: `absolute -left-[23px] top-1.5 h-2.5 w-2.5 rounded-full ring-2 ring-white ${$2ddaae90639b5011$var$TONE[s.tone]}`,
                                    "aria-hidden": true
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-[12.5px] font-semibold text-slate-500",
                                    children: s.from
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-[14px] leading-relaxed text-slate-700",
                                    children: s.title
                                }),
                                s.why && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mt-0.5 text-[12.5px] leading-relaxed text-slate-500",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold text-slate-600",
                                            children: "Why this order:"
                                        }),
                                        " ",
                                        s.why
                                    ]
                                })
                            ]
                        }, i)),
                    story.spent.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "absolute -left-[23px] top-1.5 h-2.5 w-2.5 rounded-full bg-slate-300 ring-2 ring-white",
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-[12.5px] leading-relaxed text-slate-500",
                                children: [
                                    story.spent.map((a)=>a.name).join(' and '),
                                    " went into ",
                                    story.spentOn,
                                    ", so ",
                                    story.spent.length > 1 ? 'they are' : 'it is',
                                    " not here",
                                    story.spentOn === 'the deposit' ? " \u2014 that money comes back as the refund when care ends" : '',
                                    "."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $2ddaae90639b5011$export$2e2bcd8739ae039 = $2ddaae90639b5011$export$1a915263dc5391f1;
function $2ddaae90639b5011$export$7526d1fcb4423629(i) {
    const rows = i.rows || [];
    const s = (0, $0fe89e03b6df746e$export$693cc3146baa3244)(rows);
    if (!s.hasData) return null;
    if (!s.hasDeficit) return `it doesn't \u{2014} income covers the costs in each of the ${s.totalYears ?? rows.length} years tested, so no savings are drawn.`;
    const runway = (0, $0fe89e03b6df746e$export$464558962ff4a811)(rows, rows.length);
    const story = $2ddaae90639b5011$export$bdea18f456fd84b({
        rows: rows,
        factFind: i.factFind,
        runway: runway,
        deposit: i.deposit ?? {
            paid: 0,
            refundTo: ''
        },
        horizonYears: i.horizonYears,
        enteringName: i.enteringName || 'they',
        spentOn: i.spentOn
    });
    if (!story) return null;
    const lead = (s.firstDeficitYear ?? 1) > 1 ? `income covers the costs until about year ${s.firstDeficitYear}; from then each year's shortfall comes out of ` : `each year's shortfall comes out of `;
    const order = story.orderLine ? `${lead}${story.orderLine}.` : 'there is no savings account to meet the shortfall from.';
    // A shortfall that stops says so, so the line never reads "each year" against a card that is in surplus from
    // then on (25 Oct 2026). Only when every later year is covered.
    const flowOf = (r)=>Number(r.cashFlow ?? r.netCashflow) || 0;
    const lastShortAt = rows.reduce((last, r, idx)=>flowOf(r) < 0 ? idx : last, -1);
    const coveredAgain = lastShortAt >= 0 && lastShortAt < rows.length - 1 ? `From about year ${Number(rows[lastShortAt + 1].year) || lastShortAt + 2} income covers the costs again.` : '';
    return [
        order,
        story.thenLine,
        coveredAgain
    ].filter(Boolean).join(' ');
}
function $2ddaae90639b5011$export$30c8cd38763344a6(rows) {
    const pools = [
        'bankAccounts',
        'accountBasedPensions',
        'superannuation',
        'shares'
    ];
    return (rows || []).map((r)=>{
        const assets = r?.assets || {};
        const drawdown = (r?.drawdownBreakdown || []).filter((d)=>d && (d.tag === 'rad' || d.tag === 'borrowing' || /refundable accommodation deposit|borrow|reverse mortgage/i.test(String(d.label || ''))));
        const heloc = r?.liabilities?.helocDebt;
        return {
            year: r?.year,
            cashFlow: r?.cashFlow ?? r?.netCashflow,
            ...Number(r?.unfundedShortfall) > 0 ? {
                unfundedShortfall: r.unfundedShortfall
            } : {},
            assets: Object.fromEntries(pools.map((k)=>[
                    k,
                    (assets[k] || []).map((a)=>({
                            value: Number(a?.value) || 0
                        }))
                ])),
            ...drawdown.length ? {
                drawdownBreakdown: drawdown.map((d)=>({
                        tag: d.tag,
                        label: d.label
                    }))
            } : {},
            ...heloc && heloc[0]?.interestRate != null ? {
                liabilities: {
                    helocDebt: [
                        {
                            interestRate: heloc[0].interestRate
                        }
                    ]
                }
            } : {},
            investmentIncome: r?.investmentIncome,
            tax: r?.tax
        };
    });
}



// Aged Care Suggestion Engine Panel – strategy list, Deep Dive, SOA; generates and compares funding strategies (legacy/cashflow/pension).
// Formerly EnhancedSuggestionEngineUI; renamed from EnhancedSuggestionEngineUI for clearer UI naming.
// Add CSS animations for smooth transitions and simple bar charts

/**
 * The opening paragraph an engine row's explanation needs where the deposit is paid from money the
 * plan already has coming — a retirement village's exit payment, or the refund of a current room's
 * deposit — rather than from anything sold (owner-caught, 9 Oct 2026: "Explain this" on
 * "Pay 100% RAD ($750,000, all from the village money)" opened empty, because nothing was sold and
 * the explanation treated that as "nothing decided"). Built exactly as the advice document builds
 * it from the same row, so the two say the same thing.
 */ 




const $9662e9f9d2150a64$var$monthsBetween = (from, to)=>from && to ? Math.max(0, Math.round((new Date(to).getTime() - new Date(from).getTime()) / (30.44 * 86400000))) : 0;
const $9662e9f9d2150a64$var$firstNameOf = (factFind, person)=>(person === 'partner' ? factFind.partner?.firstName : factFind.client?.firstName) || 'the client';
function $9662e9f9d2150a64$export$885bb9fc52427225(row, factFind) {
    if (!row) return {
        villageExit: null,
        facilityMove: null
    };
    const opts = row.strategyOptions || {};
    const dapPerDay = Number(row.strategySpecificAgedCareCosts?.dailyAccommodationPayment) || 0;
    const soldPhrase = (0, $e5cae8423a439bf1$export$83ba4f4a49e92f66)((0, $e5cae8423a439bf1$export$8f80043cee83ba5d)(factFind, row.radFundingManualKeys), (0, $f94e45ac645ae232$export$3dc27271f5d5c629));
    const ve = row.villageExit;
    const villageExit = ve && ve.refundDate ? (0, $511dfa7ed5ad5c31$export$ff6c9524331ef263)({
        name: $9662e9f9d2150a64$var$firstNameOf(factFind, opts.villageExit?.person),
        leaveLabel: ve.leaveDate ? (0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(ve.leaveDate) : 'the coming weeks',
        entitlement: Number(ve.entitlement) || 0,
        refundMonths: $9662e9f9d2150a64$var$monthsBetween(ve.leaveDate, ve.refundDate),
        refundDate: ve.refundDate,
        roomPrice: Number(row.radRoomPrice) || 0,
        deposit: Number(row.radPaidNet) || 0,
        fromVillage: Number(ve.fromVillage) || 0,
        fromSavings: Number(ve.fromSavings) || 0,
        soldPhrase: soldPhrase,
        toBank: Number(ve.toBank) || 0,
        interim: ve.interim ?? null,
        feesAfterLeaving: ve.feesAfterLeaving ?? null,
        paidAtMove: !!ve.paidAtMove,
        dapPerDay: dapPerDay
    }) : null;
    const fm = row.facilityMove;
    const person = opts.facilityMove?.person;
    const stay = person === 'partner' ? factFind.partner : factFind.client;
    const facilityName = String(stay?.careStay?.facilityName || '');
    const facilityMove = fm ? fm.stayPut ? `${$9662e9f9d2150a64$var$firstNameOf(factFind, person)} stays at ${facilityName || 'the current home'}: the deposit held stays where it is and nothing is sold.` : (0, $b073c6d711dafa37$export$1059590aefc83273)({
        name: $9662e9f9d2150a64$var$firstNameOf(factFind, person),
        facilityName: facilityName,
        moveLabel: fm.moveDate ? (0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(fm.moveDate) : 'the coming weeks',
        newRoomPrice: Number(fm.newRoomPrice) || 0,
        deposit: (Number(fm.fromRefund) || 0) + (Number(fm.fromSale) || 0),
        fromRefund: Number(fm.fromRefund) || 0,
        fromSale: Number(fm.fromSale) || 0,
        soldPhrase: soldPhrase,
        dapPerDay: dapPerDay,
        grandfathered: !!fm.grandfathered,
        retentionDaysTaken: 0
    }) : null;
    return {
        villageExit: villageExit,
        facilityMove: facilityMove
    };
}


/**
 * How the Suggestion Engine opens (owner, 15 Oct 2026).
 *
 * The first time a scenario is modelled — or whenever a new one is run — the engine shows its
 * "thinking" screen for at least {@link THINKING_FLOOR_MS}: it really is simulating hundreds of
 * options, and showing that work is part of the experience. Re-opening a plan that was already
 * modelled and saved is different: the adviser just wants it back on screen, so the floor is nil and
 * a quiet "opening your saved plan" note stands in for the illustration while the figures are rebuilt.
 *
 * The decision is taken ONCE, when the panel mounts; after the first run completes the panel is back
 * on the thinking opening, so a re-run with new settings or a new horizon still shows the work.
 */ const $bedf4d8bceb97e40$export$c61cb0293c29bf46 = 3500;
function $bedf4d8bceb97e40$export$48c324a44172b224(input) {
    return input.reopenedSavedStrategyId ? 'quiet' : 'thinking';
}
function $bedf4d8bceb97e40$export$e6d3518762ff09ea(opening) {
    return opening === 'quiet' ? 0 : $bedf4d8bceb97e40$export$c61cb0293c29bf46;
}
function $bedf4d8bceb97e40$export$4b840ac15005a10(opening, startedAt, now) {
    return Math.max(0, $bedf4d8bceb97e40$export$e6d3518762ff09ea(opening) - (now - startedAt));
}



/**
 * The Suggestion Engine's last few runs of this session, kept by their inputs (owner, 15 Oct 2026).
 *
 * Every run evaluates hundreds of scenarios server-side, which takes seconds. Re-opening a saved plan
 * mounts the panel afresh and would run them all again for the same answer; with the inputs
 * unchanged the answer is the same, so it is handed back at once. Anything that changes an input —
 * the profile, the room price, the living expenses, the settings, the horizon — changes the key and
 * runs again. The cache is in memory only: a page reload starts empty, and nothing is ever written to
 * the saved plan (see the 413 on save, 9 Oct 2026).
 */ const $89e0a70e9279225f$var$MAX_ENTRIES = 3;
const $89e0a70e9279225f$var$entries = new Map();
function $89e0a70e9279225f$export$112fde6d0b2d177(inputs) {
    return JSON.stringify(inputs);
}
function $89e0a70e9279225f$export$d95b93b0908b1b1c(key) {
    const hit = $89e0a70e9279225f$var$entries.get(key);
    if (hit === undefined) return undefined;
    // Most recently used goes to the back, so the oldest is what falls off.
    $89e0a70e9279225f$var$entries.delete(key);
    $89e0a70e9279225f$var$entries.set(key, hit);
    return hit;
}
function $89e0a70e9279225f$export$ea3160f3f5c8dcb1(key, value) {
    $89e0a70e9279225f$var$entries.delete(key);
    $89e0a70e9279225f$var$entries.set(key, value);
    while($89e0a70e9279225f$var$entries.size > $89e0a70e9279225f$var$MAX_ENTRIES){
        const oldest = $89e0a70e9279225f$var$entries.keys().next().value;
        if (oldest === undefined) break;
        $89e0a70e9279225f$var$entries.delete(oldest);
    }
    return value;
}
function $89e0a70e9279225f$export$ec20ecf22bc6bd50() {
    return $89e0a70e9279225f$var$entries.size;
}
function $89e0a70e9279225f$export$88966d71c3de9d82() {
    $89e0a70e9279225f$var$entries.clear();
}



/**
 * The key the engine's candidate generator de-duplicates deposit levels on (owner-caught, 9 Oct 2026).
 *
 * Two levels that would PAY the same deposit are one candidate: a client with $455,000 fundable
 * against a $700,000 room funds $455,000 at "65%" and at every level above it, and eight copies of
 * one plan under different names is what the key prevents. It used to be the amount SOLD from
 * savings. A village's exit payment (or a current room's refund) tops a level up without selling
 * anything, so for a resident whose $750,000 payout covered a $750,000 room, every level sold $0,
 * every level keyed the same, and only "Pay 10% RAD" survived: the 100% row, the best estate by far,
 * was never run. The key is now the deposit the level actually pays.
 */ function $8fc2dd99af09008b$export$c2d7325b99935b19(input) {
    const level = Math.max(0, Number(input.level) || 0);
    const funded = Math.max(0, Number(input.fundedTotal) || 0);
    const topUp = Math.max(0, Number(input.topUp) || 0);
    const paid = Math.min(level, funded + topUp);
    return `${input.orderLabel}:${Math.round(paid)}`;
}








var $acw62 = parcelRequire("acw62");


/**
 * "Would you consider locking money away for a guaranteed income for life?" — asked once, before
 * any module's Suggestion Engine runs, in words a client can answer without knowing what an annuity
 * is (owner, 24-25 September 2026).
 *
 * WHY IT IS A GATE AND NOT A DISCLOSURE. The answer is an INPUT to the modelling: "no" means no
 * annuity candidate is generated at all, in any module (annuityPreference.ts). Asking after the
 * ranking would mean reshuffling the field on the answer, which is the failure the new-money
 * question was built to avoid — so this follows the same shape as NewMoneyProfileGate, and the two
 * sit side by side.
 *
 * WHERE IT APPEARS. In the modules with no Strategy Analysis Setup of their own: Support at Home,
 * the granny flat, the downsizer, and cashflow and Age Pension. The village and aged care ask the
 * same questions inside their setup pop-over instead, and write the same answer, so a client is
 * only ever asked once.
 *
 * The caller owns the gating condition — only where the run would actually offer an annuity, only
 * while unanswered — and the two exits: onAnswer saves to the client record, onSkip models both
 * versions without recording an answer, so the question is offered again next time.
 */ 
parcelRequire("acw62");

/*
 * A GRID, NOT A WRAPPING ROW (owner, 27 Sep 2026). Each button used to be as wide as its own label,
 * so answers to one question came out at different sizes and the wordiest looked like the
 * recommended one. The column count must be a literal class name: Tailwind builds from source text
 * and never emits an interpolated `grid-cols-${n}`.
 */ const $5266def67111b10e$var$CHOICE_COLUMNS = {
    1: 'sm:grid-cols-1',
    2: 'sm:grid-cols-2',
    3: 'sm:grid-cols-3',
    4: 'sm:grid-cols-2'
};
const $5266def67111b10e$var$Choice = ({ options: options, onPick: onPick, ariaLabel: ariaLabel })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `mt-3 grid grid-cols-1 ${$5266def67111b10e$var$CHOICE_COLUMNS[options.length] || 'sm:grid-cols-3'} gap-2`,
        role: "group",
        "aria-label": ariaLabel,
        children: options.map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: ()=>onPick(o.id),
                className: "px-3 py-2 rounded-lg border border-slate-300 bg-white text-sm font-medium text-slate-700 hover:border-blue-500 hover:text-blue-700 transition-colors",
                children: o.label
            }, o.id))
    });
/*
 * THE SAME THREE ANSWERS AS EVERY OTHER SCREEN (guaranteed income review, 21 Oct 2026; GuaranteedIncomeQuestions
 * and the mock-up docs/ux-review/annuities/): money back (suggested), the most income even if nothing goes back
 * (income only, tested only on request), or no. Each is written as back / all / none with the date it was
 * given (the third argument to onAnswer). The old two-step "should any of it come back?" with "Show me
 * whichever works best" tested every type, income only included, for anyone who did not say no.
 */ const $5266def67111b10e$var$today = ()=>{
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
const $5266def67111b10e$var$AnnuityPreferenceGate = ({ onAnswer: onAnswer, onSkip: onSkip, contextLine: contextLine, guaranteeWindow: guaranteeWindow = null, offerGuaranteed: offerGuaranteed = false })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-3 rounded-xl bg-white border border-slate-200/70 border-l-4 border-l-blue-500 p-4 shadow-sm",
        "data-testid": "annuity-preference-gate",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-sm font-semibold text-gray-900",
                children: "One question before I model your options"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-sm text-slate-700 mt-1.5",
                children: [
                    contextLine || "Some of the options I\u2019ll compare put part of your money into a guaranteed income.",
                    ' ',
                    "A ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "guaranteed income for life"
                    }),
                    " (often called a lifetime annuity) is bought from a life insurer with a lump sum, and pays a set income every year for as long as you live. Centrelink counts only part of the money, which can lift the Age Pension",
                    offerGuaranteed ? ' and lower the care fees' : '',
                    ". The money is hard to get back out once it\u2019s paid, and depending on the type the family may get all of it, some of it or none of it back",
                    guaranteeWindow ? ` (with money back in the early years, ${guaranteeWindow})` : '',
                    ". Setting one up takes more than a form:",
                    ' ',
                    "you get a quote from the insurer, then apply.",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "Would you consider putting part of your money into one?"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5266def67111b10e$var$Choice, {
                ariaLabel: "Would you consider a guaranteed income for life",
                options: [
                    {
                        id: 'back',
                        label: offerGuaranteed ? 'Yes, if the money goes back to the family (suggested; includes the type that pays the full amount back at any time)' : 'Yes, if the money goes back to the family (suggested)'
                    },
                    {
                        id: 'all',
                        label: 'Yes, and the most income, even if nothing goes back'
                    },
                    {
                        id: 'none',
                        label: 'No, keep all the money within reach'
                    }
                ],
                onPick: (id)=>{
                    if (id === 'none') onAnswer('none', 'back', $5266def67111b10e$var$today());
                    else onAnswer('yes', id, $5266def67111b10e$var$today());
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-xs text-slate-500",
                children: "Saying yes doesn\u2019t buy anything: a plan uses one only if it does better with it. Income only is tested only if you ask for it, and a plan that uses it can\u2019t be chosen until you confirm you understand that nothing comes back."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 pt-3 border-t border-slate-200 flex items-center justify-between gap-3 flex-wrap",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-slate-500",
                        children: "Your answer is saved to the client profile, so you'll only be asked once \u2014 and you can change it any time."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        size: "sm",
                        onClick: onSkip,
                        children: "Skip \u2014 test the money-back types for now"
                    })
                ]
            })
        ]
    });
};
var $5266def67111b10e$export$2e2bcd8739ae039 = $5266def67111b10e$var$AnnuityPreferenceGate;



/**
 * The "Best estate, cashflow covered" tab when its leader IS the best estate outright.
 *
 * Owner, 24 Sep 2026: "you don't need to show the massive tile with all the output. You can simply
 * say really neatly 'same result as best estate — no plan leaves more' and just keep it nice and
 * neat at that." So: one small card, no figures, and a pointer to the tab that has them.
 */ 
parcelRequire("acw62");

/**
 * "Best estate with cashflow covered" — the goal advisers actually decide with, as one rule for
 * every module (owner, 24 Sep 2026: "I'd be going with the strategy that allows me to optimise my
 * estate whilst achieving my cashflow goals").
 *
 * WHY A FOURTH GOAL. "Best cashflow" as a pure ranking always rewards the plan that converts the
 * most capital into income — which is exactly the nil-residual lifetime annuity — and "best estate"
 * alone can crown a plan the household cannot live on. The question a family asks is "which plan
 * leaves the most, given that we still have to pay the bills". This answers it.
 *
 * THE THREE-STEP RULE (agreed with the owner, 24 Sep 2026), so the chip is never blank and never
 * quietly becomes "best cashflow":
 *   1. COVERED — among the strategies whose yearly cashflow meets the target (zero, or the surplus
 *      the client set), the best estate.
 *   2. CARRIED — if none does (common in aged care, where a daily payment on the room nearly always
 *      leaves a shortfall), among the strategies whose shortfall the savings carry for the WHOLE
 *      projection period, the best estate. The same runway the plan summary shows: a plan that runs
 *      the money out inside the period is not covered in any sense a family would accept.
 *   3. LONGEST — if nothing survives even that, the strategy that lasts longest, badged as such
 *      rather than presented as a recommendation. The card says which case applies.
 *
 * Reads only what every engine already puts on a strategy: the year-1 cashflow in its snapshot and
 * its projection rows (`unfundedShortfall`, the engine's own "the money has run out" flag). No
 * figure is re-derived.
 */ 

const $400a08a42b233386$export$920ad41b346ae01a = 'Optimal Legacy (Cashflow Covered)';
const $400a08a42b233386$var$cashflowOf = (s)=>{
    const snap = s.snapshot || {};
    const v = snap.netCashflow ?? snap.cashflow ?? snap.cashFlow;
    return Number.isFinite(Number(v)) ? Number(v) : -Infinity;
};
const $400a08a42b233386$var$legacyOf = (s)=>{
    const v = Number(s.snapshot?.legacyValue);
    return Number.isFinite(v) ? v : -Infinity;
};
const $400a08a42b233386$var$runsOutYearOf = (s)=>{
    const rows = Array.isArray(s.projections) ? s.projections : [];
    if (rows.length === 0) return null;
    const summary = (0, $0fe89e03b6df746e$export$693cc3146baa3244)(rows);
    return summary.moneyRunsOutYear ?? null;
};
const $400a08a42b233386$var$bestLegacy = (pool)=>pool.reduce((best, s)=>best == null || $400a08a42b233386$var$legacyOf(s) > $400a08a42b233386$var$legacyOf(best) ? s : best, null);
function $400a08a42b233386$export$db04dcb0634643af(eligible, options = {}) {
    const target = Number(options.cashflowTarget) || 0;
    const field = eligible.filter((s)=>!!s?.name);
    if (field.length === 0) return null;
    // A near-tie on the estate is a tie, led by the plan that asks less (planChoiceRule.ts, 20 Oct 2026).
    const best = (pool)=>options.readings ? (0, $5a094123650e8adb$export$3ef36734776b870)(pool, options.readings) : $400a08a42b233386$var$bestLegacy(pool);
    // 1. Covered.
    const covered = field.filter((s)=>$400a08a42b233386$var$cashflowOf(s) >= target);
    const c = best(covered);
    if (c) return {
        strategy: c,
        verdict: {
            basis: 'covered',
            cashflow: $400a08a42b233386$var$cashflowOf(c),
            runsOutYear: $400a08a42b233386$var$runsOutYearOf(c)
        }
    };
    // 2. Carried: the shortfall lasts the whole period. Needs projection rows to say so.
    const carried = field.filter((s)=>Array.isArray(s.projections) && s.projections.length > 0 && $400a08a42b233386$var$runsOutYearOf(s) == null);
    const k = best(carried);
    if (k) return {
        strategy: k,
        verdict: {
            basis: 'carried',
            cashflow: $400a08a42b233386$var$cashflowOf(k),
            runsOutYear: null
        }
    };
    // 3. Longest: the money runs out in every plan; the latest year wins, estate breaking ties.
    const withYear = field.map((s)=>({
            s: s,
            year: $400a08a42b233386$var$runsOutYearOf(s)
        }));
    const longest = withYear.reduce((best, cur)=>{
        if (best == null) return cur;
        const by = best.year ?? Number.POSITIVE_INFINITY;
        const cy = cur.year ?? Number.POSITIVE_INFINITY;
        if (cy > by) return cur;
        if (cy === by && $400a08a42b233386$var$legacyOf(cur.s) > $400a08a42b233386$var$legacyOf(best.s)) return cur;
        return best;
    }, null);
    if (!longest) return null;
    return {
        strategy: longest.s,
        verdict: {
            basis: 'longest',
            cashflow: $400a08a42b233386$var$cashflowOf(longest.s),
            runsOutYear: longest.year
        }
    };
}
function $400a08a42b233386$export$455fad9aa8ff9328(v, horizonYears, formatCurrency) {
    if (v.basis === 'covered') return v.cashflow > 0 ? `Cashflow covered: ${formatCurrency(v.cashflow)} a year to spare.` : 'Cashflow covered.';
    if (v.basis === 'carried') return `Shortfall of ${formatCurrency(Math.abs(v.cashflow))} a year, carried by savings for the full ${horizonYears} years.`;
    return `No strategy keeps the money going for the full ${horizonYears} years \u{2014} this one lasts longest${v.runsOutYear != null ? ` (to year ${v.runsOutYear})` : ''}. Shown so you can see the least damaging option, not as a recommendation.`;
}
const $400a08a42b233386$export$8d25e363f6ae69ae = 'Best estate, cashflow covered';
const $400a08a42b233386$export$8a102fa4742ce4ac = 'Best estate';
const $400a08a42b233386$export$900f9fe722d67fa2 = {
    [$400a08a42b233386$export$920ad41b346ae01a]: $400a08a42b233386$export$8d25e363f6ae69ae,
    'Optimal Legacy': $400a08a42b233386$export$8a102fa4742ce4ac,
    'Optimal Cashflow': 'Best cashflow',
    'Optimal Age Pension': 'Best Age Pension',
    // The second card beside the estate leader (planChoiceRule.ts NEAR_BEST_LABEL → SECOND_PLAN_CHIP).
    'Near-best alternative': (0, $5a094123650e8adb$export$a1a7ae9e29edd48c)
};
const $400a08a42b233386$export$da83f84a5a007a8a = (label)=>$400a08a42b233386$export$900f9fe722d67fa2[String(label ?? '')] ?? String(label ?? '');
function $400a08a42b233386$export$b8b8a2cedd92aa3a(recommended) {
    const list = recommended || [];
    const covered = list.find((r)=>r.label === $400a08a42b233386$export$920ad41b346ae01a)?.strategy?.name;
    const estate = list.find((r)=>r.label === 'Optimal Legacy')?.strategy?.name;
    return !!covered && !!estate && covered === estate;
}
const $400a08a42b233386$export$c87d3e52dbdf8a81 = "Same result as Best estate \u2014 no plan leaves more.";


function $fb8e182bba3c591c$export$5a27702133c2149a({ onShowBestEstate: onShowBestEstate }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-start gap-3 rounded-xl border border-slate-200/70 border-l-4 border-l-emerald-500 bg-white px-4 py-3.5 shadow-sm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                size: 20,
                className: "mt-0.5 shrink-0 text-emerald-600",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "min-w-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[15px] font-semibold text-slate-900",
                        children: (0, $400a08a42b233386$export$c87d3e52dbdf8a81)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-0.5 text-sm text-slate-600",
                        children: [
                            "The plan that leaves the most also pays its way, so there is nothing separate to show here.",
                            ' ',
                            onShowBestEstate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onShowBestEstate,
                                className: "font-semibold text-blue-700 underline underline-offset-2 hover:text-blue-900",
                                children: "See it under Best estate"
                            }) : 'See it under Best estate.'
                        ]
                    })
                ]
            })
        ]
    });
}
var $fb8e182bba3c591c$export$2e2bcd8739ae039 = $fb8e182bba3c591c$export$5a27702133c2149a;





/**
 * "Your plan, in plain words" — ONE reconciliation for the WHOLE manual-control plan
 * (owner direction, 2026-08-24). Each strategy section keeps its own numbers (CGT boxes, the
 * "Where every dollar goes" ledger); this card is the INTERPRETATION LAYER — sentences for people
 * who don't understand the numbers above, never a restatement of them. An earlier cut rendered the
 * money as a second ledger and the owner rightly called it a duplicate: if a reader wanted the
 * table, it is right there above. What only this card gives them is the story ("the room is paid
 * in full, so no DAP is charged on it; the pension doesn't move because both destinations are
 * exempt") and the before→after movements with their whys.
 *
 * PRESENTATION: the app's own design language (gradient heading, ImpactMetric surface — see
 * PlainWords.tsx). Pension and cashflow are ShiftRows in ImpactMetric's exact before→after
 * grammar with a tappable "(why?)" naming this plan's ACTUAL drivers.
 *
 * CALCULATION DISCIPLINE — every figure is quoted from a source already on screen, never re-derived:
 *   • Property CGT / net proceeds: the SAME shared functions as the allocator's CGT box, with the
 *     same `details` (including the accountant override).
 *   • Share/bank funding: `computeRadFundingTotals` — the SAME function the analyser's `radPaid`
 *     uses, so the sentences quote exactly what the engine was given.
 *   • DAP: `agedCareCosts.dailyAccommodationPayment` — the rail's own figure.
 *   • "with this plan" pension & cashflow: `simulatedFinancials`, with care costs netted off using
 *     the IDENTICAL arithmetic as FinancialImpactPanel (cashFlow − totalDailyCost×365).
 *   • "with no plan": the shared `useWalkInBaseline` hook — the same computation the walk-in note
 *     at the top of the page quotes.
 * The walk-in-note frame bug (owner caught two frames in one sentence, 2026-08-24) is why this
 * discipline exists. Do not add a number here that is not one of these sources.
 */ 




var $acw62 = parcelRequire("acw62");
/**
 * "EXPLAIN THIS" AS AGED CARE TELLS IT, FOR EVERY MODULE (owner, 22 Oct 2026: "the UI for the explain this does not
 * match the updates that were carried out for aged care … all modules use consistent UI").
 *
 * Numbered lines — each says what is done and what that does to the numbers — then the "=" line: what is left to the
 * family after the horizon, against the benchmark. The navy numerals, hairlines and heavy rule are aged care's
 * (StrategyPlanRecap told="causeEffect") and support at home's (SahCauseEffect). The money story (which account pays
 * each year's shortfall, and when it runs low) belongs inside the "Put together" line, passed in by the caller.
 * Anything after the ledger (the pieces of the plan, the family panel, debts) is passed as children.
 */ 
parcelRequire("acw62");

/**
 * "WHAT THIS IS AND HOW IT WORKS" — the top of every module's Explain this (owner, 24 Oct 2026: "it doesnt
 * actually explain what it is, how it works. I feel like there should be a deeper dive explanation of what this
 * solution actually is").
 *
 * One small block for each piece of the plan: its plain name and what it is, always shown; how it works and what
 * is worth knowing behind one fold, open when the plan has a single piece. The words are the central library's
 * (features/advice/leverExplainers.ts), keyed by the same plan-piece kinds "What could go wrong" reads, so every
 * module explains a piece the same way. Doing nothing has no block, and nothing renders without a piece.
 */ 
parcelRequire("acw62");
/**
 * WHAT EACH PIECE OF A PLAN IS, AND HOW IT WORKS — the one plain-words source for every module's
 * "Explain this" (owner, 24 Oct 2026: "when i clicked on the Explain this, it doesnt actually explain what
 * it is, how it works. I feel like there should be a deeper dive explanation of what this solution
 * actually is").
 *
 * Keyed by the plan-piece kinds every module already reads its plans into for "What could go wrong"
 * (RiskKind, strategy/strategyRisks.ts), so a module explains a plan with the same list it warns about.
 * Each entry: a plain title; what it is (one or two sentences); how it works (three or four short
 * points); and what is worth knowing (the limits and costs, two or three points). The risks themselves
 * stay in "What could go wrong"; this says what the thing is.
 *
 * Figures come from the app's own constants, never typed in, so a rate change moves the words with it.
 * Support at Home's card and advice-document voice (sahStrategyExplainers.ts) reads its "what it is",
 * "how it works" and "worth knowing" from here where the two describe the same thing.
 */ 


const $bc58a42a9518691f$var$annuityCounting = 'Centrelink counts 60% of the price for the first five years, or until age 85 if that is later, and 30% after that. Of each payment, 60% counts as income.';
const $bc58a42a9518691f$export$42b49ca3282407b9 = {
    heas: {
        title: 'The Home Equity Access Scheme',
        what: "The government\u2019s own version of a reverse mortgage: a loan against the home, paid out as regular fortnightly amounts (or a lump sum) on top of the Age Pension, while you keep living there.",
        how: [
            'You apply to Services Australia; the loan is secured against the home.',
            `Nothing is repaid month to month. Interest, at the government\u{2019}s rate (currently ${(0, $eb5ee2a9aeb43da8$export$253d5eafce412b21)}% a year), is added to the loan.`,
            'The payments are not counted as income for the Age Pension, so taking them does not reduce it.',
            'The loan and its interest are repaid when the home is sold, usually from the estate. You can stop, start or repay at any time.'
        ],
        worthKnowing: [
            'It is still a loan: the interest compounds, so what the home leaves to the family falls the longer it runs.',
            "The Age Pension and the scheme\u2019s payments together are capped at 150% of the maximum pension.",
            'You can never owe more than the home is worth.'
        ]
    },
    reverseMortgage: {
        title: 'A reverse mortgage',
        what: 'A loan from a bank or lender against the home, paid as a lump sum or in drawdowns, while you keep living there. Nothing is repaid while you live in the home.',
        how: [
            'The lender pays the money out; the loan is secured against the home.',
            'Interest is added to the loan each month instead of being paid.',
            'The loan and its interest are repaid when the home is sold, usually from the estate.',
            'Money from the loan counts as an asset while it sits in the bank.'
        ],
        worthKnowing: [
            "Interest compounds on a growing balance, and lenders\u2019 rates are higher than the government scheme\u2019s.",
            'You can never owe more than the home is worth (the no-negative-equity rule).',
            'Terms differ between lenders and need comparing.'
        ]
    },
    gift: {
        title: 'A gift to family',
        what: 'Money given to family now, so it stops being yours and stops counting for the Age Pension and, where care is means-tested, what you pay for it.',
        how: [
            `Up to ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))} a year, and no more than ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9cd36ea38af5a5f3))} over five years, stops counting straight away.`,
            'Anything above those limits still counts as yours for five years from the gift.',
            'Once given, the money belongs to the person who received it.'
        ],
        worthKnowing: [
            'It cannot be taken back if you need it later.',
            "A gift is the family\u2019s inheritance received early, so it is no longer in the estate."
        ]
    },
    funeralBond: {
        title: 'A funeral bond',
        what: 'Money set aside with a friendly society or insurer that can only be used to pay for the funeral.',
        how: [
            `Up to ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$aca3edb7cd7a3f17))} each is left out of the assets test, and its earnings are not counted as income.`,
            'The bond is paid out to the funeral director, or to the estate to cover the funeral.',
            'A couple can each have one.'
        ],
        worthKnowing: [
            'The money cannot be used for anything else.',
            'An amount above the limit is counted in full.'
        ]
    },
    annuityNil: {
        title: 'A lifetime income (lifetime annuity)',
        what: 'A lump sum handed to an insurer in return for an income paid for the rest of your life, however long that is.',
        how: [
            'You choose the amount; the insurer sets the income from your age and its rates.',
            'The income is paid regularly for life, on top of the Age Pension.',
            $bc58a42a9518691f$var$annuityCounting,
            'Nothing comes back to the family when you die.'
        ],
        worthKnowing: [
            'Most of the money stops being available to spend once it is handed over.',
            'Its value depends on how long you live: a short life returns less than was paid.'
        ]
    },
    annuityIndexed: {
        title: 'A lifetime income that rises with inflation',
        what: 'A lifetime annuity whose income goes up each year with prices, so it keeps its buying power.',
        how: [
            'A lump sum is handed to an insurer for an income paid for life.',
            'The income starts lower than a fixed one, then rises each year with inflation.',
            $bc58a42a9518691f$var$annuityCounting
        ],
        worthKnowing: [
            'Most of the money stops being available to spend once it is handed over.',
            'It takes some years for the rising income to catch up with a fixed one.'
        ]
    },
    annuityReturned: {
        title: 'A lifetime income with money back',
        what: 'A lifetime annuity that also returns part of the price to the family if you die in the early years.',
        how: [
            'A lump sum is handed to an insurer for an income paid for life.',
            'For about the first half of your life expectancy, the full price comes back to the family at death; after that, a falling amount, then nothing.',
            $bc58a42a9518691f$var$annuityCounting
        ],
        worthKnowing: [
            'The income is a little lower than one with no money back.',
            'The money-back amount can be drawn out for a while, but it falls each year to nothing.'
        ]
    },
    annuityGuaranteed: {
        title: 'A guaranteed income with the full amount back',
        what: 'A lifetime income combined with life cover, so the full amount goes back to the family whenever death comes.',
        how: [
            'Part of the money buys a lifetime income; the rest pays for life cover.',
            'The income is paid for life, on top of the Age Pension.',
            'At death the full amount goes back to the family.',
            'Only the income part gets the lifetime-income treatment; the life cover is counted in full.'
        ],
        worthKnowing: [
            'The income is lower than a plain lifetime annuity of the same price.',
            'The insurer sets who can buy it, by age and health.'
        ]
    },
    clearDebt: {
        title: 'Paying off a debt',
        what: 'Using savings to clear a loan or credit card, so its repayments and interest stop.',
        how: [
            'The repayment comes out of savings; the debt and its repayments disappear.',
            'Less money is counted for the Age Pension and, where care is means-tested, what you pay for it.',
            "The interest saved is a sure return, equal to the loan\u2019s rate."
        ],
        worthKnowing: [
            'The money is gone from savings, so enough must stay in the bank for emergencies.',
            "Where a loan\u2019s rate is low, keeping the money invested can leave more."
        ]
    },
    renovate: {
        title: 'Spending on the home',
        what: 'Money moved from savings into the home you live in, by improving it or buying a dearer one. The home you live in is left out of the Age Pension assets test.',
        how: [
            'The money leaves the bank, where it was counted, and becomes home value, which is not.',
            'Less counted can mean more Age Pension and, where care is means-tested, less to pay for it.',
            "The value stays in the family\u2019s hands, in the house."
        ],
        worthKnowing: [
            'Money in the home cannot be spent day to day; it comes back only if the home is sold or borrowed against.',
            'Work on a home does not always add its full cost to what the home is worth.'
        ]
    },
    sellHome: {
        title: 'Selling the family home',
        what: 'The home is sold and the money used for what comes next: a new home, a room or unit, and what is left over.',
        how: [
            'Selling costs come off the sale price first.',
            'Money spent on a new home you live in stays out of the assets test.',
            'Money left over is counted in full, unless it goes into super under the downsizer rule.'
        ],
        worthKnowing: [
            'Selling and moving cost money and effort that does not come back.',
            'More counted money can mean less Age Pension, even with more cash to hand.'
        ]
    },
    sellAndRent: {
        title: 'Selling and renting instead',
        what: 'The home is sold and no new home is bought; the money is kept and rent is paid from it.',
        how: [
            'The whole sale, after costs, becomes money Centrelink counts.',
            'Renters are assessed as non-homeowners, who have higher asset limits.',
            'Rent is paid each year from savings and the Age Pension.'
        ],
        worthKnowing: [
            'Rent rises over time and is never recovered.',
            'There is no home left for the family; the estate is what the savings leave.'
        ]
    },
    rentHome: {
        title: 'Keeping the home and renting it out',
        what: 'The home is kept and let to tenants while care or the new arrangement is paid for another way.',
        how: [
            'The rent, after costs, counts as income for the Age Pension and is taxed.',
            'For the first two years after leaving, the home is still treated as the home and not counted; after that it counts as an asset.',
            "The home stays in the family\u2019s hands."
        ],
        worthKnowing: [
            'Rent can stop between tenants while rates, insurance and repairs go on.',
            'Selling later may bring capital gains tax.'
        ]
    },
    rentFormerHome: {
        title: 'Renting out the former home',
        what: 'The old home is kept and let to tenants after the move.',
        how: [
            'The rent, after costs, counts as income for the Age Pension and is taxed.',
            'The former home is counted as an asset once it is no longer the home.',
            "It stays in the family\u2019s hands and can be sold later."
        ],
        worthKnowing: [
            'Rent can stop between tenants while the costs go on.',
            'A later sale may bring capital gains tax.'
        ]
    },
    keepHomeInCare: {
        title: 'Keeping the home',
        what: 'The home is kept, not sold or let, while care is paid for from other money.',
        how: [
            'The home stays out of the assets test for two years after leaving it, or while a partner or protected person still lives there.',
            'For aged care fees, its value is counted only up to a capped amount.',
            "It stays in the family\u2019s hands."
        ],
        worthKnowing: [
            'An empty home still costs rates, insurance and upkeep.',
            'After two years it starts counting in full for the Age Pension.'
        ]
    },
    sellInvestmentProperty: {
        title: 'Selling an investment property',
        what: 'A property owned to rent out is sold, and the money used for the plan.',
        how: [
            'Selling costs and any capital gains tax come off the sale first.',
            'The rent stops counting as income.',
            'What is left is counted as money in the bank, or pays for the room or unit.'
        ],
        worthKnowing: [
            'The rent income is gone.',
            'Capital gains tax can be large on a property held a long time.'
        ]
    },
    transferHome: {
        title: 'Signing the home over for the right to live there',
        what: 'The home is transferred to family in return for a lifelong right to keep living there (a granny flat right).',
        how: [
            'The home leaves your name; in return you hold the right to live in it for life.',
            'Centrelink takes the home at face value: its value is the price of the right, and none of it is a gift, whatever it is worth. Only cash given on top is tested.',
            "If the home is worth more than Centrelink\u2019s homeowner line, you stay homeowners for the Age Pension and the right is not counted; at or below it, you are not homeowners and the right counts as an asset."
        ],
        worthKnowing: [
            'The home belongs to the family from then on, including if they sell, separate or go bankrupt.',
            'Stamp duty may be payable on the transfer, usually by the family member; it is not included in these figures.',
            'Leaving within five years can lead Centrelink to look at the transfer again as a gift.',
            'A written agreement drawn up by a solicitor protects everyone.'
        ]
    },
    grannyFlat: {
        title: 'A granny flat right',
        what: "A lifelong right to live in a family member\u2019s home, paid for with cash, by paying for a build there, or by signing your home over.",
        how: [
            'You pay for the right to live there for the rest of your life.',
            'Paying for a build, or signing your home over, is taken at face value: never a gift on its own, whatever it costs.',
            "Cash is tested against Centrelink\u2019s limit for your age: up to it, nothing is a gift; anything above it (or above the build or home it comes on top of) counts as a gift for five years.",
            "Give more than Centrelink\u2019s homeowner line and you stay homeowners, with the right not counted; give less, and the right counts as an asset."
        ],
        worthKnowing: [
            'The money, the build or the home belongs to the family once it is handed over.',
            'A written agreement drawn up by a solicitor protects everyone if circumstances change.'
        ]
    },
    grannyFlatBuild: {
        title: 'Paying for a build at their home',
        what: "You pay to build or extend your own accommodation at a family member\u2019s home, in return for a lifelong right to live there.",
        how: [
            'You pay the builder; the building becomes part of their property.',
            'Centrelink takes the cost of the build at face value: it is the price of the right, never a gift on its own, whatever it costs.',
            "Any cash given on top is tested: above the greater of the build and Centrelink\u2019s limit for your age, it is a gift for five years.",
            "Give more than Centrelink\u2019s homeowner line in all and you stay homeowners, with the right not counted; give less, and the right counts as an asset."
        ],
        worthKnowing: [
            'Approvals, delays and over-runs are common; keep the contract and invoices.',
            'The building belongs to the family member, exposed to their divorce, debts or death.',
            'A written agreement drawn up by a solicitor protects everyone.'
        ]
    },
    keepHomeEmpty: {
        title: 'Keeping your home, empty',
        what: 'Your home is kept as it is after you move, with no one living in it.',
        how: [
            'It stops being exempt from the day you move: Centrelink counts it in full as an asset.',
            'It earns nothing, but it is still yours, and it keeps growing in value.'
        ],
        worthKnowing: [
            'Rates, insurance and upkeep go on; they are not in these figures unless entered.',
            'It usually lowers the Age Pension more than anything else in the plan.'
        ]
    },
    moveInOnly: {
        title: 'Moving in with family, with nothing paid',
        what: "You move into a family member\u2019s home without paying for a right to live there.",
        how: [
            'No money changes hands, so nothing is counted as a gift.',
            'Your own money stays yours and is counted as before, and a home you keep stops being exempt the day you move: it is counted from then.'
        ],
        worthKnowing: [
            'There is no legal right to stay if circumstances change.'
        ]
    },
    villageEntry: {
        title: 'A retirement village unit',
        what: 'You pay an entry contribution for the right to live in a village unit, plus ongoing fees, and part of the entry contribution is kept by the village when you leave.',
        how: [
            'The entry contribution is paid up front, often from selling the home.',
            "Monthly fees cover the village\u2019s running costs.",
            'When you leave, the village keeps a departure fee, which grows with each year you stay, and refunds the rest.',
            "Whether the entry contribution counts as an asset depends on its size against Centrelink\u2019s threshold."
        ],
        worthKnowing: [
            'The refund can take months to arrive after leaving.',
            'Contracts differ a lot between villages; the contract decides what comes back.'
        ]
    },
    radPaid: {
        title: 'Paying the room deposit (RAD)',
        what: "A refundable accommodation deposit: the room\u2019s price, paid up front, which comes back when care ends.",
        how: [
            'The deposit is paid to the home, from savings or the sale of the home.',
            'It is not counted in the Age Pension assets test, though it is counted for the aged care means test.',
            'Paying it means no daily payment on the part paid.',
            'When care ends it is refunded, less 2% a year kept by the home for the first five years and anything drawn from it.'
        ],
        worthKnowing: [
            'Money in the deposit earns nothing and cannot be spent.',
            'Fees can be drawn from the deposit, but that lowers the refund and raises the daily payment.'
        ]
    },
    dap: {
        title: 'The daily payment for the room (DAP)',
        what: "A daily accommodation payment: a charge for the part of the room\u2019s price not paid up front, like interest at the government\u2019s set rate.",
        how: [
            'It is charged each day on the unpaid part of the room price.',
            'The rate is set by the government and changes each quarter.',
            'It can be paid each month, or drawn from a deposit.'
        ],
        worthKnowing: [
            'It never comes back.',
            'Money not used for a deposit stays yours and can be invested or spent.'
        ]
    },
    fromSavings: {
        title: 'Paying from savings',
        what: 'The cost is paid from bank accounts, term deposits, super pensions or shares.',
        how: [
            'The accounts named in the plan are drawn down, in the order shown.',
            'Money that was counted by Centrelink becomes a deposit or payment that may not be.',
            'Less money is left earning interest.'
        ],
        worthKnowing: [
            'Enough must stay in the bank for emergencies.',
            'Selling shares can bring capital gains tax.'
        ]
    },
    superContribution: {
        title: 'Putting money into super',
        what: 'Savings moved into super, where the earnings are taxed less, or not at all once it pays a pension.',
        how: [
            `From selling the home, each person aged 55 or over can put in up to ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$42edd27decf8c272))} under the downsizer rule.`,
            `Otherwise, up to ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$e5af7a7374b9aef3))} a year can go in after tax, while the age and balance rules allow.`,
            'Inside super, earnings are taxed at no more than 15%, and nothing once it pays a pension.'
        ],
        worthKnowing: [
            'Once you are over Age Pension age, super counts for the Age Pension like other savings.',
            'Money in super can be taken out, but there are rules on how.'
        ]
    },
    accountBasedPension: {
        title: 'An account-based pension',
        what: 'Super turned into a regular income, paid from your own account.',
        how: [
            'You choose how much to draw, above a yearly minimum set by your age.',
            'Earnings inside the account are not taxed, and payments from age 60 are tax-free.',
            'It counts for the Age Pension like other savings.'
        ],
        worthKnowing: [
            'The income lasts only as long as the balance does.',
            'The balance moves with the investments.'
        ]
    },
    investmentBond: {
        title: 'An investment bond',
        what: 'An investment that pays its own tax inside, so nothing goes on your tax return, and becomes tax-free after ten years.',
        how: [
            'Tax of 30% is paid inside the bond on its earnings.',
            'After ten years, what comes out is tax-free.',
            'Centrelink counts it like the savings it replaces.'
        ],
        worthKnowing: [
            'Taking money out before ten years can cost some of the tax benefit.',
            'Its value moves with the investments.'
        ]
    },
    shares: {
        title: 'Shares or managed funds',
        what: 'Money invested in a spread of shares or funds, which can be sold at any time.',
        how: [
            'It is counted in full as an asset.',
            'Centrelink deems it to earn a set rate, whatever it actually pays.',
            'Dividends and growth are taxed.'
        ],
        worthKnowing: [
            'Values move, sometimes sharply.',
            'Selling can bring capital gains tax.'
        ]
    },
    investmentProperty: {
        title: 'An investment property',
        what: 'A property bought or kept to rent out.',
        how: [
            'It is counted in full as an asset.',
            'The rent, after costs, counts as income and is taxed.'
        ],
        worthKnowing: [
            'It cannot be sold in part, and selling takes time and money.',
            'Rent can stop while the costs go on.'
        ]
    }
};
function $bc58a42a9518691f$export$f5f5affae75a2533(kinds) {
    const seen = new Set();
    const out = [];
    for (const k of kinds){
        if (!k || seen.has(k)) continue;
        seen.add(k);
        const explainer = $bc58a42a9518691f$export$42b49ca3282407b9[k];
        if (explainer) out.push({
            kind: k,
            explainer: explainer
        });
    }
    return out;
}


function $6edaae094c27058f$export$c20faa40d0e6b131({ kinds: kinds, className: className = '' }) {
    const items = (0, $bc58a42a9518691f$export$f5f5affae75a2533)(kinds);
    if (items.length === 0) return null;
    const single = items.length === 1;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: className,
        "data-testid": "lever-explainers",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mb-3 flex items-center gap-3 text-[12.5px] font-semibold text-brand-navy",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "shrink-0",
                        children: "What this is and how it works"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "h-px flex-1 bg-slate-200",
                        "aria-hidden": true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "space-y-3",
                children: items.map(({ kind: kind, explainer: explainer })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "rounded-xl border border-slate-200 bg-white px-4 py-3",
                        "data-testid": `lever-explainer-${kind}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[14px] font-semibold text-brand-navy",
                                children: explainer.title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1 text-[13.5px] leading-relaxed text-slate-700",
                                children: explainer.what
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                                className: "group mt-2",
                                open: single,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("summary", {
                                        className: "cursor-pointer list-none text-[13px] font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900 [&::-webkit-details-marker]:hidden",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "group-open:hidden",
                                                children: "How it works, and what to know"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "hidden group-open:inline",
                                                children: "Hide how it works"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-2 grid gap-3 sm:grid-cols-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-[12.5px] font-semibold text-slate-900",
                                                        children: "How it works"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                        className: "mt-1 list-disc space-y-1 pl-5 text-[13px] leading-relaxed text-slate-700",
                                                        children: explainer.how.map((h)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: h
                                                            }, h))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-[12.5px] font-semibold text-slate-900",
                                                        children: "Worth knowing"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                        className: "mt-1 list-disc space-y-1 pl-5 text-[13px] leading-relaxed text-slate-700",
                                                        children: explainer.worthKnowing.map((w)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: w
                                                            }, w))
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, kind))
            })
        ]
    });
}



const $4800816561106c2d$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(n)));
const $4800816561106c2d$export$8400747e4d4d02ee = ({ n: n })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "mt-0.5 grid h-7 w-7 place-items-center rounded-full bg-brand-navy text-[13px] font-bold tabular-nums text-white",
        "data-testid": "ledger-step-number",
        children: n
    });
const $4800816561106c2d$export$ee12a877b5edba4b = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "pt-0.5 text-[20px] font-bold text-brand-navy",
        children: "="
    });
const $4800816561106c2d$export$5354fc7cb2207caf = ({ from: from, to: to, unit: unit = '', better: better = null })=>{
    const diff = to - from;
    const marked = better != null && Math.abs(diff) >= 1;
    const good = better === 'up' ? diff > 0 : diff < 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            "from ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "font-semibold tabular-nums text-brand-navy",
                children: $4800816561106c2d$var$money(from)
            }),
            " to ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "font-semibold tabular-nums text-brand-navy",
                children: $4800816561106c2d$var$money(to)
            }),
            unit,
            marked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: `whitespace-nowrap font-bold tabular-nums ${good ? 'text-emerald-700' : 'text-rose-700'}`,
                        "data-testid": "ledger-change",
                        children: [
                            diff < 0 ? "\u25BC" : "\u25B2",
                            " ",
                            $4800816561106c2d$var$money(diff)
                        ]
                    })
                ]
            })
        ]
    });
};
const $4800816561106c2d$export$8dd54625d22f0463 = ({ change: change, text: text })=>change ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            " ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4800816561106c2d$export$5354fc7cb2207caf, {
                from: change.from,
                to: change.to,
                unit: change.unit,
                better: change.better
            }),
            change.after
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: text
    });
const $4800816561106c2d$export$48017952956cd475 = ({ horizonYears: horizonYears, estate: estate, baseEstate: baseEstate = null, baseWord: baseWord, children: children })=>{
    const d = baseEstate != null ? estate - baseEstate : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "m-0 text-[15px] text-slate-600",
                children: [
                    "After about ",
                    horizonYears,
                    " ",
                    horizonYears === 1 ? 'year' : 'years',
                    " the family is left"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "m-0 text-[30px] font-extrabold leading-tight tabular-nums text-brand-navy",
                "data-testid": "ledger-result-amount",
                children: $4800816561106c2d$var$money(estate)
            }),
            d != null && Math.abs(d) >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: `mt-1.5 inline-block rounded-full px-3 py-0.5 text-[13.5px] font-bold ${d >= 0 ? 'bg-emerald-50 text-emerald-700' : 'bg-rose-50 text-rose-700'}`,
                "data-testid": "ledger-result-tag",
                children: [
                    $4800816561106c2d$var$money(d),
                    " ",
                    d >= 0 ? 'more' : 'less',
                    " than ",
                    baseWord
                ]
            }),
            d != null && Math.abs(d) < 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "mt-1.5 inline-block rounded-full bg-slate-100 px-3 py-0.5 text-[13.5px] font-bold text-slate-700",
                "data-testid": "ledger-result-tag",
                children: [
                    "the same as ",
                    baseWord
                ]
            }),
            children && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-2 text-[15px] leading-relaxed text-slate-700",
                children: children
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-[13px] leading-relaxed text-slate-500",
                "data-testid": "ledger-compared-over",
                children: (0, $c3eba85390498a43$export$be94b03447321f96)(horizonYears)
            })
        ]
    });
};
const $4800816561106c2d$export$d053159fb36403b3 = ({ lines: lines, estate: estate, baseEstate: baseEstate = null, horizonYears: horizonYears, baseWord: baseWord, testId: testId = 'cause-effect', children: children, leverKinds: leverKinds = [] })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6edaae094c27058f$export$c20faa40d0e6b131), {
                kinds: leverKinds,
                className: "mb-5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                className: "m-0 list-none p-0",
                children: [
                    lines.map((l, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            className: `grid grid-cols-[2.25rem_1fr] gap-x-2 border-b border-slate-200 py-4 text-[15px] leading-relaxed text-slate-700 ${i === 0 ? 'pt-0' : ''}`,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4800816561106c2d$export$8400747e4d4d02ee, {
                                    n: i + 1
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: l
                                })
                            ]
                        }, i)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        className: "grid grid-cols-[2.25rem_1fr] gap-x-2 border-t-2 border-brand-navy py-4 text-[15px] leading-relaxed text-slate-700",
                        "data-testid": `${testId}-result`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4800816561106c2d$export$ee12a877b5edba4b, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4800816561106c2d$export$48017952956cd475, {
                                horizonYears: horizonYears,
                                estate: estate,
                                baseEstate: baseEstate,
                                baseWord: baseWord
                            })
                        ]
                    })
                ]
            }),
            children,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-5 text-[12.5px] leading-relaxed text-slate-500",
                children: "Projections depend on the assumptions shown \u2014 returns, inflation and today's rules \u2014 and are illustrations, not guarantees."
            })
        ]
    });
};
function $4800816561106c2d$export$4be361d56ef6ce0f(i) {
    const base = i.baseCashflow != null ? ` (${i.baseWord}, ${i.baseCashflow < 0 ? `${$4800816561106c2d$var$money(i.baseCashflow)} short` : `${$4800816561106c2d$var$money(i.baseCashflow)} to spare`})` : '';
    return i.cashflow >= 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                className: "text-slate-900",
                children: [
                    "Put together, ",
                    i.they,
                    " have ",
                    $4800816561106c2d$var$money(i.cashflow),
                    " a year to spare"
                ]
            }),
            base,
            ".",
            i.moneyStory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " ",
                    i.moneyStory
                ]
            }) : null
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                className: "text-slate-900",
                children: [
                    "Put together, ",
                    i.they,
                    " are ",
                    $4800816561106c2d$var$money(i.cashflow),
                    " a year short"
                ]
            }),
            ", met from savings",
            base,
            ".",
            i.moneyStory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " ",
                    i.moneyStory
                ]
            }) : null
        ]
    });
}
var $4800816561106c2d$export$2e2bcd8739ae039 = $4800816561106c2d$export$d053159fb36403b3;



/**
 * The "In brief" line, shared by every module.
 *
 * WHY IT IS SHARED (owner, 2026-08-31, on discovering the In Brief improvements had landed in Aged
 * Care only). Five modules each hand-rolled `clauses: string[]` and joined them into one grey
 * sentence. The wording had already drifted between them, and any improvement had to be made five
 * times — so it wasn't. Aged Care is the benchmark for UI across this app; this is that benchmark
 * expressed once.
 *
 * WHAT IT DOES NOT DO: flatten the modules. Each has its own story to tell first — a downsize frees
 * capital, a village entry pays a contribution, an aged care plan leaves part of a room unpaid — and
 * those clauses stay local. What is shared is the THREE CLAUSES EVERY MODULE ENDS WITH (the Age
 * Pension, cashflow, and the estate) plus the rendering, because those are the figures a client
 * scans for and they should look and read the same wherever they appear.
 */ 

var $acw62 = parcelRequire("acw62");

/** The text with each `emphasis` substring set in bold; plain text when there is none. */ function $77fab72f16be36e5$var$withEmphasis(text, emphasis) {
    const parts = (emphasis || []).filter((e)=>e && text.includes(e));
    if (parts.length === 0) return text;
    const re = new RegExp(`(${parts.map((e)=>e.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'g');
    return text.split(re).map((piece, i)=>parts.includes(piece) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
            className: "text-slate-800",
            children: piece
        }, i) : piece);
}
function $77fab72f16be36e5$export$188f8646230c48f(delta, reason = '') {
    const flat = Math.round(delta) === 0;
    return {
        term: 'the Age Pension',
        tone: flat ? 'neutral' : delta > 0 ? 'good' : 'bad',
        text: flat ? 'the Age Pension does not move' : `the Age Pension ${delta > 0 ? 'rises' : 'falls'} by ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(delta))} a year${reason}`
    };
}
function $77fab72f16be36e5$export$32179680de3fc4e3(delta, after) {
    const caveat = after != null && after < 0 ? `, though it is still short by ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(after))} a year` : undefined;
    return {
        term: 'cashflow',
        tone: delta > 0 ? 'good' : 'bad',
        text: `cashflow is ${delta > 0 ? 'better' : 'worse'} by ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(delta))} a year`,
        caveat: caveat,
        // The shortfall is the figure the client must not miss, so it is bold as well as plain slate.
        emphasis: after != null && after < 0 ? [
            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(after))
        ] : undefined
    };
}
function $77fab72f16be36e5$export$ca3c952791480bf6(delta, years) {
    const flat = Math.round(delta) === 0;
    const period = `${years} ${years === 1 ? 'year' : 'years'}`;
    return {
        term: 'the estate',
        tone: flat ? 'neutral' : delta > 0 ? 'good' : 'bad',
        text: flat ? `the estate is unchanged after ${period}` : `the estate ends ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(delta))} ${delta > 0 ? 'ahead' : 'behind'} after ${period}`
    };
}
function $77fab72f16be36e5$export$b3ed29c9fd98e367(text, emphasis) {
    return {
        text: text,
        tone: 'neutral',
        emphasis: emphasis
    };
}
function $77fab72f16be36e5$export$f24d825672d9bf01({ clauses: clauses }) {
    const toneClass = {
        good: 'text-emerald-700 font-semibold',
        bad: 'text-amber-700 font-semibold',
        neutral: 'text-slate-600'
    };
    const usable = clauses.filter(Boolean);
    if (usable.length === 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: usable.map((clause, i)=>{
            const hasTerm = !!clause.term && clause.text.startsWith(clause.term);
            const body = hasTerm ? clause.text.slice(clause.term.length) : clause.text;
            const lead = i === 0 ? '' : i === usable.length - 1 ? ' and ' : ', ';
            const cap = (t)=>i === 0 ? `${t.charAt(0).toUpperCase()}${t.slice(1)}` : t;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                children: [
                    lead,
                    hasTerm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-slate-800",
                                children: cap(clause.term)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: toneClass[clause.tone],
                                children: $77fab72f16be36e5$var$withEmphasis(body, clause.emphasis)
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: toneClass[clause.tone],
                        children: $77fab72f16be36e5$var$withEmphasis(cap(body), clause.emphasis)
                    }),
                    clause.caveat && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-slate-600",
                        children: $77fab72f16be36e5$var$withEmphasis(clause.caveat, clause.emphasis)
                    }),
                    i === usable.length - 1 ? '.' : ''
                ]
            }, i);
        })
    });
}
function $77fab72f16be36e5$export$ccf7eddc6e06c4d6(clauses) {
    const texts = clauses.filter(Boolean).map((c)=>`${c.text}${c.caveat || ''}`);
    if (texts.length === 0) return null;
    const joined = texts.length > 1 ? `${texts.slice(0, -1).join(', ')} and ${texts[texts.length - 1]}` : texts[0];
    return `${joined.charAt(0).toUpperCase()}${joined.slice(1)}.`;
}



/**
 * What an annuity IS, and what terms this particular one is modelled on.
 *
 * OWNER-RAISED, 2026-09-01, on a Retirement Village strategy that committed $1,525,000 to a lifetime
 * annuity: "is this a 100% RCV annuity or a 0% annuity, who owns the annuity (Client 1 or client 2),
 * is it reversionary etc... this is critical."
 *
 * It was critical and it was invisible. The Suggestion Engine sets the residual capital value
 * explicitly (both variants are modelled and named), but says nothing about the rest — and the
 * engine's defaults are consequential:
 *
 *   OWNER          `rvAnnuityOwner || 'client'` — Applicant 1. Their age drives the threshold day,
 *                  the point at which the assets-test rate drops from 60% to 30%.
 *   REVERSIONARY   FALSE. For a couple that means the INCOME stops when the owner dies. Whether any
 *                  MONEY comes back is a different term — residual capital — and the two must be
 *                  said together or the sentence is false. See `deathSentence` below.
 *   INDEXATION     FALSE. The payment is flat for life, so its buying power falls every year.
 *
 * A default the client cannot see is a decision made on their behalf. This component states all four
 * terms wherever an annuity is proposed, and links to a plain-words explanation of what an annuity
 * is, because for most clients it is a foreign concept being met for the first time inside a
 * six- or seven-figure recommendation.
 *
 * Shared because the same gap exists wherever an annuity can be proposed — Aged Care, Support at
 * Home, the Downsizer, the Granny Flat and Cashflow & Age Pension all offer one.
 */ 

var $acw62 = parcelRequire("acw62");


var $1u0KT = parcelRequire("1u0KT");



const $b6421482343679f4$export$7aa01bacec2b375e = "Estimated from the published table \u2014 above age 75 the table is extended, so a written quote matters more.";
function $b6421482343679f4$export$9f9fb1aea9338121({ purchaseAmount: purchaseAmount, residualPercent: residualPercent, ownerName: ownerName, partnerName: partnerName, reversionary: reversionary = false, indexed: indexed = false, termYears: termYears = null, deferralYears: deferralYears = null, annuityType: annuityType = 'lifetime', annualPayment: annualPayment = null, quote: quote = null, className: className = '', capitalAccessPeriodYears: capitalAccessPeriodYears = null, lifeExpectancySexKnown: lifeExpectancySexKnown = null, rateExtrapolated: rateExtrapolated = null }) {
    const [explain, setExplain] = (0, $acw62.useState)(false);
    const [showDetail, setShowDetail] = (0, $acw62.useState)(false);
    const rcv = Math.max(0, Math.min(100, Number(residualPercent) || 0));
    const isCouple = !!partnerName;
    const owner = ownerName || 'you';
    const amount = purchaseAmount ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(purchaseAmount) : 'the purchase price';
    const isLifetime = annuityType !== 'fixedTerm';
    /*
     * THE FULL-AMOUNT-BACK TYPE IS NOT A PLAIN LIFETIME ANNUITY (guaranteed income review, 21 Oct 2026). It is a
     * guaranteed income combined with life cover: the full amount goes back to the family whenever death comes,
     * and Centrelink counts only the income part at 60% — the life cover is counted in full. It was told with
     * the money-back sentence, which tapers, and the 60% claim, which it does not earn.
     */ const isGuaranteed = annuityType === 'guaranteed';
    const deferral = isLifetime ? Math.max(0, Math.round(Number(deferralYears) || 0)) : 0;
    const term = !isLifetime ? Math.max(0, Math.round(Number(termYears) || 0)) : 0;
    const forHowLong = isLifetime ? `${deferral > 0 ? `from year ${deferral + 1}, ` : ''}for as long as ${owner} lives` : `for ${term > 0 ? `${term} years` : 'a set number of years'}`;
    /*
     * WHAT COMES BACK, AND TO WHOM — the sentence the first version got wrong.
     *
     * OWNER-CAUGHT, 2026-09-01: "it reads as though as soon as the client dies, she gets nothing —
     * she ceases to receive the income but if its 100% capital back, she gets the lump sum."
     *
     * Exactly right, and the old wording was flatly false on a capital-returned annuity: it said the
     * survivor "receives nothing from it" while $500,000 was on its way back to the estate. The two
     * terms are not independent — REVERSIONARY decides whether the INCOME continues, RESIDUAL CAPITAL
     * decides whether the MONEY comes back — and stating either without the other misleads. They are
     * written as one sentence now, because that is the only way to say it truthfully.
     */ const capitalBack = rcv >= 99.5 ? 'full' : rcv <= 0.5 ? 'none' : 'part';
    const stops = `When ${owner} dies the payments stop${isCouple ? `, and ${partnerName} does not continue receiving them` : ''}`;
    /*
     * WHAT COMES BACK FOLLOWS THE CAPITAL ACCESS SCHEDULE (25 Sep 2026). "Returned to the estate" full
     * stop was a promise no lifetime annuity makes: the full amount comes back only if death is within
     * the first half of life expectancy, then less, then nothing — the condition for the 60% treatment.
     * One shared sentence (annuityWords.ts) says so on every screen.
     */ const backWords = isLifetime ? (0, $5ccd559ea4d04f2e$export$476ca360cf39c0a7)({
        residualPct: rcv,
        periodYears: capitalAccessPeriodYears,
        sexKnown: lifeExpectancySexKnown,
        ownerName: owner,
        amountWords: purchaseAmount ? `the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(purchaseAmount)}` : null
    }) : capitalBack === 'full' ? `the ${amount} comes back at the end of the term` : capitalBack === 'none' ? `nothing is returned at the end of the term: the capital came back through the payments` : `${rcv}% of the ${amount} comes back at the end of the term`;
    const deathSentence = isGuaranteed ? `${stops}, and the full ${amount} goes back to the family whenever ${owner} passes away, through the life cover.` : reversionary && isCouple ? `If ${owner} dies first, the payments continue to ${partnerName} for the rest of their life.` : capitalBack === 'none' ? `${stops}, and nothing is returned: the provider keeps the ${amount}.` : `${stops}. ${isLifetime ? backWords : `And ${backWords}.`}`;
    /*
     * ONE SENTENCE FIRST, the detail underneath (owner, 2026-09-01: "right now its daunting").
     *
     * Four labelled terms in a row is a specification, not an explanation — it asks a reader who has
     * never met the product to assemble the meaning themselves. The plain sentence carries the whole
     * answer; the terms stay one tap away for the reader who wants to check them.
     */ return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `rounded-xl border border-slate-200 bg-white p-4 ${className}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[11px] font-semibold uppercase tracking-wide text-slate-500",
                        children: "About this annuity"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1.5 text-sm leading-relaxed text-slate-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold text-slate-900",
                                children: amount
                            }),
                            " goes into a",
                            ' ',
                            isGuaranteed ? 'guaranteed income for life combined with life cover' : `${isLifetime ? deferral > 0 ? 'deferred lifetime' : 'lifetime' : 'fixed-term'} annuity`,
                            " in",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "font-semibold text-slate-900",
                                children: [
                                    owner,
                                    "'s name"
                                ]
                            }),
                            annualPayment ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    ", paying about",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "font-semibold text-slate-900",
                                        children: [
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(annualPayment),
                                            " a year"
                                        ]
                                    }),
                                    ' ',
                                    forHowLong
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    ", paying an income ",
                                    forHowLong
                                ]
                            }),
                            ". ",
                            deathSentence,
                            deferral > 0 && ` Nothing is paid for the first ${deferral} years; Centrelink counts 60% of the purchase price from the day it is bought and none of the income until the payments begin.`,
                            !isLifetime && term > 0 && term <= 5 && ' A term of five years or less is treated like a term deposit: the value is deemed and the payments are not counted.',
                            isGuaranteed && ' Centrelink counts only the income part at 60% (30% later); the life cover is counted in full, so the pension and fee savings are smaller than with the other types.'
                        ]
                    }),
                    rateExtrapolated && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-1.5 text-[12.5px] leading-relaxed text-slate-600",
                        "data-testid": "annuity-rate-extrapolated",
                        children: $b6421482343679f4$export$7aa01bacec2b375e
                    }),
                    !indexed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-1.5 text-sm leading-relaxed text-slate-600",
                        children: "The payment never changes \u2014 it does not rise with inflation, so it buys less each year."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-[12px] font-semibold",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setExplain(true),
                                className: "text-blue-600 underline decoration-blue-600/40 underline-offset-2 hover:text-blue-700",
                                children: "What is an annuity, and what are the risks?"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setShowDetail((v)=>!v),
                                "aria-expanded": showDetail,
                                className: "text-slate-500 hover:text-slate-700",
                                children: showDetail ? 'Hide the terms' : 'See the terms'
                            })
                        ]
                    }),
                    showDetail && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                        className: "mt-3 grid grid-cols-[auto_1fr] gap-x-3 gap-y-1.5 border-t border-slate-100 pt-3 text-[12px] leading-relaxed",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                className: "font-semibold text-slate-700",
                                children: "Owner"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                                className: "text-slate-600",
                                children: [
                                    owner,
                                    isCouple && " \u2014 their age sets when the assets-test rate drops from 60% to 30%"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                className: "font-semibold text-slate-700",
                                children: "Capital returned"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                className: "text-slate-600",
                                children: isGuaranteed ? "the full amount, at any time, through the life cover \u2014 which is why the income is the lowest" : capitalBack === 'none' ? "nil \u2014 the provider keeps the capital, which is why the income is higher" : `${rcv}%${capitalBack === 'full' ? ', which is why the income is lower' : ''}. ${backWords}`
                            }),
                            isCouple && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                        className: "font-semibold text-slate-700",
                                        children: "Reversionary"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                        className: "text-slate-600",
                                        children: reversionary ? `yes \u{2014} the income continues to ${partnerName}` : `no \u{2014} the income stops with ${owner}`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                className: "font-semibold text-slate-700",
                                children: "Indexed"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                className: "text-slate-600",
                                children: indexed ? "yes \u2014 the payment rises each year" : "no \u2014 the payment never changes"
                            }),
                            !isLifetime && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                        className: "font-semibold text-slate-700",
                                        children: "Term"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                        className: "text-slate-600",
                                        children: "a fixed number of years, not for life"
                                    })
                                ]
                            })
                        ]
                    }),
                    quote
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b6421482343679f4$export$6b9e287d1f1718d4, {
                open: explain,
                onClose: ()=>setExplain(false)
            })
        ]
    });
}
function $b6421482343679f4$export$d05c00195a7db941({ terms: terms, factFind: factFind, quote: quote = null, className: className = '' }) {
    if (!terms || !(Number(terms.purchaseAmount) > 0)) return null;
    const clientName = factFind?.client?.firstName || 'you';
    const partnerName = factFind?.adviceFor === 'couple' ? factFind?.partner?.firstName || 'your partner' : null;
    const ownerIsPartner = terms.owner === 'partner';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b6421482343679f4$export$9f9fb1aea9338121, {
        className: className,
        purchaseAmount: Number(terms.purchaseAmount) || 0,
        residualPercent: Number(terms.residualPercent) || 0,
        ownerName: ownerIsPartner ? partnerName || 'your partner' : clientName,
        /* Whoever is NOT the owner is the one whose position depends on these terms. */ partnerName: ownerIsPartner ? clientName : partnerName,
        reversionary: !!terms.reversionary,
        indexed: !!terms.indexed,
        annuityType: String(terms.annuityType || 'lifetime'),
        annualPayment: Number(terms.annualPayment) || null,
        termYears: Number(terms.termYears) || null,
        deferralYears: Number(terms.deferralYears) || null,
        capitalAccessPeriodYears: terms.capitalAccessPeriodYears != null ? Number(terms.capitalAccessPeriodYears) || null : null,
        lifeExpectancySexKnown: terms.lifeExpectancySexKnown == null ? null : !!terms.lifeExpectancySexKnown,
        rateExtrapolated: terms.rateExtrapolated === true,
        quote: quote
    });
}
function $b6421482343679f4$export$624bbc9c6c5928({ draft: draft, onDraft: onDraft, committed: committed, onCommit: onCommit, className: className = '', scope: scope = null }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `mt-3 border-t border-slate-100 pt-3 ${className}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[12px] text-slate-600",
                "data-testid": "annuity-quote-scope",
                children: scope ?? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: "Have a quote from a provider? Enter the yearly income they offered and every option is re-compared on your number instead of ours."
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-2 flex flex-wrap items-end gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "w-44",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                            label: "Quoted income ($/yr)",
                            value: draft,
                            onChange: (v)=>onDraft(v ?? '')
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        size: "sm",
                        disabled: draft === '' || Number(draft) <= 0,
                        onClick: ()=>onCommit(Number(draft) || null),
                        children: "Re-model on this quote"
                    }),
                    committed != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        size: "sm",
                        onClick: ()=>{
                            onCommit(null);
                            onDraft('');
                        },
                        children: "Back to indicative"
                    })
                ]
            })
        ]
    });
}
function $b6421482343679f4$export$6b9e287d1f1718d4({ open: open, onClose: onClose }) {
    (0, $acw62.useEffect)(()=>{
        if (!open) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', onKey);
        const previous = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return ()=>{
            document.removeEventListener('keydown', onKey);
            document.body.style.overflow = previous;
        };
    }, [
        open,
        onClose
    ]);
    if (!open || typeof document === 'undefined') return null;
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/* z-70, because this opens from inside "Understanding your plan", which is itself a modal. */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 z-[70] flex items-start justify-center overflow-y-auto bg-brand-ink/55 p-4 sm:p-6",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "annuity-explainer-title",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "my-4 w-full max-w-2xl rounded-2xl border border-slate-200/70 bg-white p-6 shadow-cardlg sm:p-7",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mb-4 flex items-start justify-between gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    id: "annuity-explainer-title",
                                    className: "text-[23px] font-bold leading-tight",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-brand-navy ",
                                        children: "What is an annuity?"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-0.5 text-sm text-slate-600",
                                    children: "A guaranteed income, bought with a lump sum."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: onClose,
                            "aria-label": "Close",
                            className: "mt-1 shrink-0 rounded-lg p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-600",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 20,
                                strokeWidth: 2.4
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "space-y-3 text-[14.5px] leading-relaxed text-slate-700",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "You hand a lump sum to an insurance company. In return they pay you a set amount every year \u2014 for the rest of your life, or for a fixed number of years if you choose that instead. It is the closest thing to a private pension you can buy."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Why it comes up in this tool."
                                }),
                                " Centrelink counts a lifetime annuity differently from money in the bank: only ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "60% of what you paid"
                                }),
                                " is counted in the assets test (for the first five years, or until age 85 if that is later, and 30% after that). Money in the bank is counted in full. So moving money into an annuity can lift the Age Pension \u2014 sometimes substantially."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "rounded-xl border border-slate-200 border-l-4 border-l-slate-400 bg-white p-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mb-1.5 font-bold text-slate-900",
                                    children: "Two separate questions, often confused"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    className: "list-disc space-y-1.5 pl-5 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Does the income continue?"
                                                }),
                                                " That is what ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                                    children: "reversionary"
                                                }),
                                                " means. A reversionary annuity keeps paying the surviving partner; a non-reversionary one stops."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Does the money come back?"
                                                }),
                                                " That is the ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                                    children: "residual capital value"
                                                }),
                                                ". At nil the provider keeps it. At 100% the purchase price comes back to the estate if you die within the first half of your life expectancy; after that the amount falls each year, and nothing comes back beyond it. That is the most the rules allow while Centrelink still counts only 60% of the annuity. Some providers also sell, to people in aged care, a guaranteed income combined with life cover that pays the full amount back at any time: it pays the least income, and Centrelink counts only its income part at 60% \u2014 the life cover is counted in full."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "They are independent. An annuity can stop paying on death and still return every dollar \u2014 and one that keeps paying the survivor may leave nothing at the end."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-500 bg-white p-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mb-1.5 font-bold text-slate-900",
                                    children: "What you give up"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    className: "list-disc space-y-1.5 pl-5 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Most of the money stops being available."
                                                }),
                                                " This is the big one, and how far it goes depends on the shape you choose. With nothing coming back you cannot change your mind at all: there is no cash-out value. With capital returned you can take some of it back, but the most allowed falls each year to nothing, what the provider pays is usually less than that maximum, and cashing out ends the income for good. Either way, treat it as money you will not have for a large unexpected cost."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "You may not get back what you paid."
                                                }),
                                                " On a nil-residual annuity, if you die early the provider keeps the balance and your estate receives nothing from it. Living a long time is what makes it pay off; dying early is what makes it not."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Inflation, unless you pay for protection."
                                                }),
                                                " A flat payment buys noticeably less after fifteen or twenty years. An indexed annuity solves this but starts lower."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "For a couple, whether it continues."
                                                }),
                                                " If it is not",
                                                ' ',
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                                    children: "reversionary"
                                                }),
                                                ", the income stops when the owner dies. This is the term people most often miss."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "You are relying on the provider."
                                                }),
                                                " Payments depend on the insurer still being there in twenty or thirty years. They are regulated and required to hold capital against exactly that, but it is not a government guarantee."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "rounded-xl border border-slate-200 border-l-4 border-l-emerald-600 bg-white p-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mb-1.5 font-bold text-slate-900",
                                    children: "What you get"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    className: "list-disc space-y-1.5 pl-5 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Certainty."
                                                }),
                                                " An income that arrives whatever markets do and however long you live."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "A better means-test outcome"
                                                }),
                                                " than the same money sitting in the bank."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "No decisions to make."
                                                }),
                                                " Nothing to manage, rebalance or worry about."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-sm text-slate-600",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "How you would actually buy one."
                                }),
                                " A handful of insurers sell them. You, or an adviser, ask for a quote on the amount, the owner and the options above; the rate they come back with is what decides whether this is worth doing. The figures here use an indicative rate \u2014 enter a real quote where the tool offers and every option is re-modelled on your number, not ours."
                            ]
                        })
                    ]
                })
            ]
        })
    }), document.body);
}
var $b6421482343679f4$export$2e2bcd8739ae039 = $b6421482343679f4$export$9f9fb1aea9338121;



/**
 * What borrowing against the home actually does — stated wherever a strategy does it.
 *
 * OWNER-RAISED, 2026-09-01, of a card titled "Borrow $800k against the home for 100% of the room,
 * keep the home" sitting under Optimal Cashflow:
 *
 *   "At first I was looking at the cashflow to see the loan repayments and it wasn't until I clicked
 *    on 'Explain this' that I realised that this is a reverse mortgage. Where a reverse mortgage is
 *    used this should be called out in the title. Also the explainer needs to clearly outline the
 *    implications of this product type — it's literally silent on this matter which is extremely
 *    dangerous!"
 *
 * All of that was true. THREE separate failures compounded:
 *
 *   1. The title never said "reverse mortgage". It said "borrow against the home", which reads like
 *      an ordinary loan.
 *   2. THERE ARE NO REPAYMENTS, so nothing appeared in the cashflow — and the absence of a cost line
 *      is exactly what made the strategy top the cashflow ranking. A reader looking for the cost of
 *      the loan finds nothing, and the natural conclusion is that there isn't one.
 *   3. The candidate builder wrote a careful `equityReleaseRationale` for every one of these
 *      strategies explaining the compounding and the trade-off — and NOTHING RENDERED IT. It was
 *      written and thrown away.
 *
 * The interest is real, it compounds at roughly 8% with nothing paid along the way, and it is
 * settled out of the house. This component says so, with the projected debt rather than a warning in
 * the abstract, because the figure is what makes it concrete.
 */ 

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


const $680e2cea6da0f2e4$var$LABEL = {
    reverseMortgage: 'reverse mortgage',
    heas: 'Home Equity Access Scheme loan'
};
function $680e2cea6da0f2e4$export$45232555cfe21303({ kind: kind, loanAmount: loanAmount, interestRate: interestRate, projectedBalance: projectedBalance, years: years, homeValue: homeValue, className: className = '' }) {
    const [explain, setExplain] = (0, $acw62.useState)(false);
    const borrowed = Math.max(0, Number(loanAmount) || 0);
    if (!(borrowed > 0)) return null;
    const rate = Number(interestRate) || 0;
    const grown = Math.max(0, Number(projectedBalance) || 0);
    const horizon = Math.max(0, Number(years) || 0);
    const interestAdded = grown > borrowed ? grown - borrowed : 0;
    const home = Math.max(0, Number(homeValue) || 0);
    const shareOfHome = home > 0 && grown > 0 ? Math.round(grown / home * 100) : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white p-4 ${className}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[11px] font-semibold uppercase tracking-wide text-amber-800",
                        children: "This plan borrows against the home"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1.5 text-sm leading-relaxed text-slate-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold text-slate-900",
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(borrowed)
                            }),
                            " is drawn against the family home as a ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold text-slate-900",
                                children: $680e2cea6da0f2e4$var$LABEL[kind]
                            }),
                            rate > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    " at ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "font-semibold text-slate-900",
                                        children: [
                                            rate,
                                            "% a year"
                                        ]
                                    })
                                ]
                            }),
                            ".",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold text-slate-900",
                                children: "Nothing is repaid along the way"
                            }),
                            " \u2014 which is why no loan repayment appears in the cashflow above. The interest is added to the loan each year and the whole debt is settled out of the house."
                        ]
                    }),
                    interestAdded > 0 && horizon > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 text-sm leading-relaxed text-slate-700",
                        children: [
                            "Over ",
                            horizon,
                            " ",
                            horizon === 1 ? 'year' : 'years',
                            " the debt grows from",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold text-slate-900",
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(borrowed)
                            }),
                            " to",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold text-slate-900",
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(grown)
                            }),
                            " \u2014",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "font-semibold text-slate-900",
                                children: [
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(interestAdded),
                                    " of interest"
                                ]
                            }),
                            ' ',
                            "that comes out of the estate",
                            shareOfHome != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    ", or about ",
                                    shareOfHome,
                                    "% of the home's value today"
                                ]
                            }),
                            ". It keeps compounding for as long as the loan runs, so a longer stay costs considerably more."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>setExplain(true),
                        className: "mt-2.5 text-[12px] font-semibold text-blue-700 underline decoration-blue-700/40 underline-offset-2 hover:text-blue-900",
                        children: [
                            "What is a ",
                            $680e2cea6da0f2e4$var$LABEL[kind],
                            ", and what are the risks?"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($680e2cea6da0f2e4$export$b39a59da2e911546, {
                kind: kind,
                open: explain,
                onClose: ()=>setExplain(false)
            })
        ]
    });
}
function $680e2cea6da0f2e4$export$b39a59da2e911546({ kind: kind, open: open, onClose: onClose }) {
    (0, $acw62.useEffect)(()=>{
        if (!open) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', onKey);
        const previous = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return ()=>{
            document.removeEventListener('keydown', onKey);
            document.body.style.overflow = previous;
        };
    }, [
        open,
        onClose
    ]);
    if (!open || typeof document === 'undefined') return null;
    const isHeas = kind === 'heas';
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/* z-70: this opens from inside "Understanding your plan", which is itself a modal. */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 z-[70] flex items-start justify-center overflow-y-auto bg-brand-ink/55 p-4 sm:p-6",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "equity-release-title",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "my-4 w-full max-w-2xl rounded-2xl border border-slate-200/70 bg-white p-6 shadow-cardlg sm:p-7",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mb-4 flex items-start justify-between gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    id: "equity-release-title",
                                    className: "text-[23px] font-bold leading-tight",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-brand-navy ",
                                        children: isHeas ? 'What is the Home Equity Access Scheme?' : 'What is a reverse mortgage?'
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-0.5 text-sm text-gray-600",
                                    children: isHeas ? 'A government loan against your home, repaid from your estate.' : 'A loan against your home that you never make repayments on.'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: onClose,
                            "aria-label": "Close",
                            className: "mt-1 shrink-0 rounded-lg p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-600",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 20,
                                strokeWidth: 2.4
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "space-y-3 text-[15px] leading-relaxed text-gray-700",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: isHeas ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "The Home Equity Access Scheme is a ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "government loan"
                                    }),
                                    " secured against your home. Services Australia pays you a regular amount (or a lump sum), you make no repayments, and the loan plus interest is repaid when the home is sold or from your estate. The rate is well below a commercial reverse mortgage, which is what makes it worth modelling first."
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "A reverse mortgage is a loan secured against your home. You receive the money now and",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "make no repayments at all"
                                    }),
                                    ". Each year the interest is added to what you owe, and the whole debt is repaid when the home is sold \u2014 usually when you die or move into care permanently."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white p-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mb-1.5 font-bold text-gray-800",
                                    children: "The part that is easy to miss"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "No repayments does not mean no cost."
                                        }),
                                        " Because nothing is paid along the way, the interest is charged on the interest. ",
                                        isHeas ? 'At around 4% a debt roughly doubles every eighteen years.' : 'At around 8% a debt roughly doubles every nine years.',
                                        ' ',
                                        "None of that appears in your yearly cashflow \u2014 it appears in what is left at the end. A plan that looks comfortable year to year can still be the most expensive one on the table."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "rounded-xl border border-slate-200 bg-slate-50/70 p-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mb-1.5 font-bold text-gray-800",
                                    children: "What you should know"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    className: "list-disc space-y-1.5 pl-5 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "It comes out of the house."
                                                }),
                                                " The debt is settled from the sale proceeds, so it directly reduces what your family inherits \u2014 and it grows every year the loan runs."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "You cannot owe more than the home is worth."
                                                }),
                                                " Australian law requires a",
                                                ' ',
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                                    children: "no negative equity guarantee"
                                                }),
                                                " on ",
                                                isHeas ? 'this scheme' : 'reverse mortgages',
                                                ", so neither you nor your estate can be pursued for a shortfall. This is a genuine protection \u2014 but it protects against the worst case, not against the cost."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "The home usually has to be sold to repay it."
                                                }),
                                                " If you want the house kept in the family, someone has to find the money to clear the loan first."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Anyone else living there."
                                                }),
                                                " A partner or family member in the home needs to be named on the loan, or their right to stay can end when yours does. Check this before signing anything."
                                            ]
                                        }),
                                        !isHeas && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Rates and fees."
                                                }),
                                                " The rate is usually variable, so the debt can grow faster than modelled here. There are establishment, valuation and legal costs, and sometimes ongoing fees."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Centrelink."
                                                }),
                                                " The home is exempt, but borrowed money that simply sits in the bank is counted and deemed. Money that goes straight into an accommodation deposit is exempt, which is what this strategy relies on."
                                            ]
                                        }),
                                        !isHeas && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "You must get independent legal advice."
                                                }),
                                                " That is a legal requirement for a reverse mortgage in Australia, not a formality \u2014 take it seriously and take it early."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "rounded-xl border border-emerald-200 bg-white p-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mb-1.5 font-bold text-gray-800",
                                    children: "Why it can still be the right answer"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    className: "list-disc space-y-1.5 pl-5 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "The home is kept."
                                                }),
                                                " Nobody has to sell in a hurry, and the property keeps growing in value \u2014 which can outrun the interest."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "It pays a refundable deposit."
                                                }),
                                                " Money in an accommodation deposit is exempt from the Age Pension assets test, removes that much daily accommodation payment, and is refunded when care ends."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "It buys time."
                                                }),
                                                " Sometimes the choice is between borrowing and selling the family home in the middle of a health crisis."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-slate-600",
                            children: "Whether this leaves the family ahead depends on the room price, the interest rate, how fast the home grows in value, and how long the stay is. Those are exactly what the projection here compares \u2014 change the length of stay and watch which strategy wins."
                        })
                    ]
                })
            ]
        })
    }), document.body);
}
var $680e2cea6da0f2e4$export$2e2bcd8739ae039 = $680e2cea6da0f2e4$export$45232555cfe21303;




/**
 * PlanPieces — "the pieces of this plan, in plain words".
 *
 * Owner, 24 Sep 2026: "when you select explain this, it actually doesn't explain the strategy (i.e.
 * we reference into super — downsizer contribution) but we don't actually explain what this is
 * anywhere — this would be foreign concept to many clients … think about how this is explained in
 * a way that is as easy as possible, doesn't create too much visual load on the screen."
 *
 * So: one row per piece the plan is made of. Each row is the piece's everyday name, the amount
 * where there is one, and ONE short line saying what it is and what the means tests do with it.
 * Nothing else is on the row. Where the vetted glossary (awiseKnowledgeBase) holds a fuller
 * explanation, the row ends with a dotted "what's this?" that opens it in the centred pop-up — the
 * same device the rest of the app uses — so the depth is there for the reader who wants it and
 * costs the others nothing.
 *
 * The rows are DATA, built by each module from the strategy it is explaining (rvPlanPieces.ts for
 * the village), so the same card can sit in every module's "Understanding your plan".
 */ 
parcelRequire("acw62");



function $c1f2b2692daf0da1$export$d520641036c1ebe9({ pieces: pieces, className: className = '', plain: plain = false }) {
    const rows = pieces.filter((p)=>p && p.name && p.what);
    if (rows.length === 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: plain ? `pt-1 ${className}` : `rounded-2xl border border-slate-200/70 bg-white p-5 shadow-card ${className}`,
        children: [
            plain ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mb-3 flex items-center gap-3 text-[12.5px] font-semibold text-brand-navy",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "shrink-0",
                        children: "The pieces of this plan, and how the means tests treat each"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "h-px flex-1 bg-slate-200",
                        "aria-hidden": true
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "text-lg font-bold",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-brand-navy",
                            children: "The pieces of this plan"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-0.5 mb-3 text-xs text-slate-500",
                        children: "What each part is, in plain words, and how the means tests treat it."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "divide-y divide-slate-100",
                children: rows.map((p)=>{
                    const hasGlossary = !!p.glossaryTerm && !!(0, $c79e495c2243b635$export$522b6ee8c9e1e75c)(p.glossaryTerm);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        className: "py-2.5 first:pt-0 last:pb-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-baseline justify-between gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-[14px] font-semibold text-slate-900",
                                        children: p.name
                                    }),
                                    p.amount != null && Number.isFinite(p.amount) && p.amount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "shrink-0 text-[14px] font-semibold tabular-nums text-slate-900",
                                        children: [
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(p.amount),
                                            p.amountSuffix ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "ml-1 text-[11px] font-medium text-slate-500",
                                                children: p.amountSuffix
                                            }) : null
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-0.5 text-[13px] leading-relaxed text-slate-600",
                                children: [
                                    p.what,
                                    hasGlossary && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                                term: p.glossaryTerm,
                                                expandAs: "dialog",
                                                label: "what's this?"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, p.key);
                })
            })
        ]
    });
}
var $c1f2b2692daf0da1$export$2e2bcd8739ae039 = $c1f2b2692daf0da1$export$d520641036c1ebe9;








/** Each plan piece's kind, for "What this is and how it works" (the annuity's shape is read where it is built). */ const $a258b04930632a82$var$PIECE_KIND = {
    rad: 'radPaid',
    dap: 'dap',
    savings: 'fromSavings',
    'sell-home': 'sellHome',
    downsizer: 'superContribution',
    'ip-downsizer': 'superContribution',
    ip: 'investmentProperty',
    shares: 'shares',
    'sell-ip': 'sellInvestmentProperty',
    'rent-home': 'rentHome',
    rm: 'reverseMortgage',
    heas: 'heas',
    gift: 'gift',
    bond: 'funeralBond',
    debt: 'clearDebt'
};
function $a258b04930632a82$export$95126b4dbebd7863(input) {
    const clauses = [
        /*
         * NOT "nothing is charged daily" (owner-caught, 2026-08-26). Paying the room in full stops
         * the DAP and nothing else: the basic daily fee, the care contribution and the hotelling
         * supplement all continue, and on the very screen this sentence appears the Cost Overview
         * was still showing $196 a day. Naming the one fee that stops is the whole point.
         */ $a258b04930632a82$var$roomClause(input)
    ];
    if (input.pensionDelta != null) clauses.push((0, $77fab72f16be36e5$export$188f8646230c48f)(input.pensionDelta));
    if (input.cashflowDelta != null && Math.round(input.cashflowDelta) !== 0) clauses.push((0, $77fab72f16be36e5$export$32179680de3fc4e3)(input.cashflowDelta, input.cashflowAfter));
    if (input.legacyDelta != null) clauses.push((0, $77fab72f16be36e5$export$ca3c952791480bf6)(input.legacyDelta, input.legacyYears));
    return clauses;
}
/** The room clause: the year's care cost as a whole, and the DAP's share of it, both in bold. */ function $a258b04930632a82$var$roomClause(input) {
    const care = input.careAnnual != null && input.careAnnual > 0 ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(input.careAnnual)) : null;
    const dap = (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(input.dapAnnual));
    if (input.roomFullyPaid) return care ? (0, $77fab72f16be36e5$export$b3ed29c9fd98e367)(`the room is paid in full, so the daily accommodation payment stops \u{2014} the other care fees continue at ${care} a year`, [
        care
    ]) : (0, $77fab72f16be36e5$export$b3ed29c9fd98e367)("the room is paid in full, so the daily accommodation payment stops \u2014 the other care fees continue");
    return care ? (0, $77fab72f16be36e5$export$b3ed29c9fd98e367)(`care costs ${care} a year, of which ${dap} is the daily fee on the part of the room not paid up front`, [
        care,
        dap
    ]) : (0, $77fab72f16be36e5$export$b3ed29c9fd98e367)(`${dap} a year is still charged for the unpaid part of the room as a DAP`, [
        dap
    ]);
}
function $a258b04930632a82$export$613c60f3cbf9e0ea(input) {
    return (0, $77fab72f16be36e5$export$ccf7eddc6e06c4d6)($a258b04930632a82$export$95126b4dbebd7863(input)) || '';
}
function $a258b04930632a82$export$dbec3ed92c831629(input) {
    const unpaidRoom = Math.max(0, input.radInput - input.radPaidTotal);
    // Directions compare ROUNDED dollars: a 40-cent drift between two engine runs must read as
    // "holds", never as a rise or fall the client then asks their adviser to explain.
    const moved = (before, after)=>Math.round(after) - Math.round(before);
    const pension = moved(input.pensionDoNothing, input.pensionWithPlan);
    const cashflow = moved(input.cashflowDoNothing, input.cashflowWithPlan);
    return {
        unpaidRoom: unpaidRoom,
        dapAnnual: input.dapDaily * 365,
        roomFullyPaid: unpaidRoom < 1,
        pensionDirection: pension > 0 ? 'rises' : pension < 0 ? 'falls' : 'holds',
        cashflowDirection: cashflow > 0 ? 'improves' : cashflow < 0 ? 'worsens' : 'holds'
    };
}
const $a258b04930632a82$var$ASSET_TYPE_FALLBACKS = {
    bankAccounts: 'bank savings',
    termDeposits: 'a term deposit',
    shares: 'shares',
    accountBasedPensions: 'an account-based pension',
    superannuation: 'super'
};
const $a258b04930632a82$var$StrategyPlanRecap = ({ factFind: factFind, overallStrategy: overallStrategy, investmentPropertyDetails: investmentPropertyDetails, downsizeDetails: downsizeDetails, reverseMortgageDetails: reverseMortgageDetails, radFunding: radFunding, cgtOverrides: cgtOverrides, radInput: radInput, radPaid: radPaid, agedCareCosts: agedCareCosts, simulatedFinancials: simulatedFinancials, extraServiceFeeInput: extraServiceFeeInput = 0, annuityFromSaleProceeds: annuityFromSaleProceeds = 0, eyebrow: eyebrow = 'Your plan summary', strategyInputs: strategyInputs, sharedBaseline: sharedBaseline = null, planRunway: planRunway = null, moneyOrder: moneyOrder = null, moneyStory: moneyStory = null, secondRoom: secondRoom = null, phaseTwo: phaseTwo = null, facilityMove: facilityMove = null, villageExit: villageExit = null, baselineLegacy: baselineLegacy = null, planLegacy: planLegacy = null, legacyYears: legacyYears = 5, heasDetails: heasDetails = null, debtPayoffPlan: debtPayoffPlan = null, otherStrategies: otherStrategies = null, annuityRecord: annuityRecord = null, engineAnnuityTerms: engineAnnuityTerms = null, equityRelease: equityRelease = null, annuityQuoteControl: annuityQuoteControl = null, told: told = 'summary', causeEffectFacts: causeEffectFacts = null })=>{
    const baseline = (0, $eb51a4b4880423a2$export$9ada56fd292651b8)(factFind, radInput, extraServiceFeeInput);
    /*
     * RENTING THE FAMILY HOME — a whole strategy the summary used to omit.
     *
     * It matters twice over: the net rent is assessable income for BOTH the Age Pension income test
     * and the aged care means test, and the home keeps its two-year assets-test exemption for the
     * pension while being counted (to the cap) for care fees. A summary that skips it cannot explain
     * its own pension figure — which is exactly how a correct result came to carry a wrong reason.
     */ const clearedDebtsForWhy = Object.values(debtPayoffPlan?.payments || {}).reduce((sum, amount)=>sum + (Number(amount) || 0), 0);
    const rentsHome = overallStrategy?.rentHome === true;
    const weeklyRent = Math.max(0, Number(strategyInputs?.rentAmount) || 0);
    const annualRent = weeklyRent * 52;
    const rentExpenses = Math.max(0, Number(strategyInputs?.rentExpenses) || 0);
    const netAnnualRent = Math.max(0, annualRent - rentExpenses);
    const partnerWeeklyRent = Math.max(0, Number(strategyInputs?.partnerRent) || 0);
    const partnerAnnualRent = partnerWeeklyRent * 52;
    // ---- Investment property sale (same resolution + shared functions as the allocator's box) ----
    const ipActive = !!overallStrategy.sellInvestmentProperty;
    const selectedProperty = ipActive ? factFind.assets?.investmentProperty?.find((p)=>p.id === investmentPropertyDetails.selectedPropertyId) || factFind.assets?.investmentProperty?.[0] : undefined;
    const rawTaxSummary = selectedProperty ? (0, $a764bc0f6f904854$export$f70460bedec8e810)(factFind, selectedProperty, investmentPropertyDetails) : null;
    const ipTax = (0, $a764bc0f6f904854$export$1436ab50c5990307)(rawTaxSummary, investmentPropertyDetails.cgtOverrideTotal);
    const ipNetProceeds = ipTax?.netProceeds ?? 0;
    const ipCgt = ipTax?.estimatedCGT ?? 0;
    const ip = {
        toRoom: ipActive ? Number(investmentPropertyDetails.radAllocation) || 0 : 0,
        newHome: ipActive ? Number(investmentPropertyDetails.newHomePurchasePrice) || 0 : 0,
        downsizer: ipActive ? Number(investmentPropertyDetails.downsizerContribution) || 0 : 0,
        gifting: ipActive ? Number(investmentPropertyDetails.giftingAmount) || 0 : 0,
        funeralBond: ipActive ? Number(investmentPropertyDetails.funeralBondPurchase) || 0 : 0
    };
    // Same allocation list as the IP allocator's own unallocated figure.
    const ipLeftover = ipActive ? Math.max(0, ipNetProceeds - (ip.toRoom + ip.newHome + ip.downsizer + ip.gifting + ip.funeralBond)) : 0;
    // ---- Liquid-asset funding ("Paying for the room") — same function as the analyser's radPaid ----
    const funding = (0, $bd80071df75c742b$export$e98193fa2b9f521b)(factFind, radFunding, cgtOverrides);
    const liquidRows = Object.entries(funding.byKey).filter(([, entry])=>entry.gross > 0).map(([key, entry])=>{
        const parsed = (0, $bd80071df75c742b$export$eb5d467aa7d657c6)(key);
        const located = parsed ? (0, $bd80071df75c742b$export$f59ccf8b394d8480)(factFind, parsed.assetType, parsed.assetId) : null;
        const label = located?.asset?.description || (parsed ? $a258b04930632a82$var$ASSET_TYPE_FALLBACKS[parsed.assetType] : null) || 'savings';
        return {
            key: key,
            label: label,
            ...entry
        };
    });
    /*
     * The downsize, told IN FULL — every destination, not just the room money. An earlier cut showed
     * only the RAD; the owner ran a plan whose visible destinations (RAD, new home) were both exempt
     * while the leftover proceeds sat in the bank being deemed, and a correct engine result read as
     * a bug. A pension movement can only be explained by naming the money that stays COUNTABLE. The
     * field list mirrors the analyser's simulatedFactFind downsize branch exactly.
     */ const dz = {
        salePrice: parseFloat(String(downsizeDetails.salePrice)) || 0,
        sellingCosts: parseFloat(String(downsizeDetails.sellingCosts)) || 0,
        toRoom: parseFloat(String(downsizeDetails.radAllocation)) || 0,
        newHome: parseFloat(String(downsizeDetails.newHomePurchasePrice)) || 0,
        downsizer: (parseFloat(String(downsizeDetails.downsizerContribution)) || 0) + (parseFloat(String(downsizeDetails.partnerDownsizerContribution)) || 0),
        gifting: parseFloat(String(downsizeDetails.giftingAmount)) || 0,
        funeralBond: parseFloat(String(downsizeDetails.funeralBondPurchase)) || 0,
        newInvestmentProperty: parseFloat(String(downsizeDetails.purchaseInvestmentProperty)) || 0,
        newShares: parseFloat(String(downsizeDetails.purchaseShares)) || 0
    };
    const dzActive = !!overallStrategy.downsizeHome;
    const dzNetProceeds = dzActive ? Math.max(0, dz.salePrice - dz.sellingCosts) : 0;
    const dzAllocated = dz.toRoom + dz.newHome + dz.downsizer + dz.gifting + dz.funeralBond + dz.newInvestmentProperty + dz.newShares;
    // The analyser routes an annuity bought "from sale proceeds" out of the leftover bank pool
    // before it lands — mirror that, or this leftover would overstate what stays deemed.
    const dzLeftover = dzActive ? Math.max(0, dzNetProceeds - dzAllocated - (annuityFromSaleProceeds || 0)) : 0;
    const stayingName = factFind.adviceFor === 'couple' ? (factFind.goals?.aged_care_for === 'partner' ? factFind.client?.firstName : factFind.partner?.firstName) || null : null;
    /*
     * A LOADING STATE, because the blank was being read as broken (owner-reported, 2026-08-31:
     * "Understanding your plan is only showing the title and nothing else").
     *
     * `useWalkInBaseline` makes two API round-trips, and until BOTH land `baseline.costs` and
     * `baseline.careFinancials` are null. This returned null for the whole of that window — so the
     * explanation modal opened with a title and an empty white box, then filled in a beat later.
     * Nothing was wrong; it simply had nothing to say yet and did not say so.
     *
     * The two cases are separated: with no room price there is genuinely nothing to explain and
     * rendering nothing is right. Waiting for figures is different, and says so.
     */ if (!(radInput > 0)) return null;
    if (!baseline.costs || !baseline.careFinancials) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "rounded-xl border border-slate-200 bg-slate-50/60 p-5",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            className: "text-sm text-slate-500",
            children: "Working out what this plan does\u2026"
        })
    });
    const rmToRoom = overallStrategy.reverseMortgage && reverseMortgageDetails.useForRad && reverseMortgageDetails.loanStructure === 'lump_sum' ? parseFloat(String(reverseMortgageDetails.loanAmount)) || 0 : 0;
    const hasDownsizeGroup = dzActive && dzNetProceeds > 0;
    const hasIpGroup = ipActive && !!selectedProperty && ipNetProceeds > 0;
    const hasLiquidGroup = liquidRows.length > 0 || rmToRoom > 0;
    /*
     * A PLAN THAT PAYS NO DEPOSIT STILL HAS AN EXPLANATION, and this returned null for every one of
     * them.
     *
     * OWNER-CAUGHT, 2026-09-01, on "Pay the DAP + $500k lifetime annuity": "Explain this for the
     * annuity strategy is missing the rest of the breakdown that would otherwise be shown." The
     * modal opened with a title, the annuity box, and nothing else.
     *
     * The three groups above all ask WHERE THE DEPOSIT MONEY CAME FROM. Paying the daily fee instead
     * is a deliberate strategy - it keeps every dollar liquid and pays for the room like rent - so
     * there is no funding source to narrate, and the guard read that as "nothing to explain". It is
     * the opposite: the whole point of the plan is what the client KEPT, and the pension, cashflow
     * and estate rows below are exactly as meaningful. Only the funding paragraphs are missing, and
     * `story` simply has one fewer paragraph.
     *
     * The guard stays for the genuinely empty case: no deposit, no daily fee, no lever - nothing has
     * been decided yet.
     */ const paysDailyFee = radInput > (Number(radPaid) || 0) + 1;
    const hasMeansTestLever = !!otherStrategies?.annuity || !!otherStrategies?.gifting || !!otherStrategies?.funeralBonds;
    // A deposit paid wholly from money already coming — a village's exit payment, a current room's
    // refund — sells nothing and pays no daily fee, and is still a plan to explain (owner-caught,
    // 9 Oct 2026: the modal opened empty on "Pay 100% RAD ($750,000, all from the village money)").
    const paidFromMoneyComing = !!villageExit || !!facilityMove;
    if (!hasDownsizeGroup && !hasIpGroup && !hasLiquidGroup && !paysDailyFee && !hasMeansTestLever && !paidFromMoneyComing) return null;
    // "With no plan" = the walk-in baseline (matches the note at the top of the page).
    // "With this plan" = the same arithmetic the Financial Impact panel uses (matches it exactly).
    /*
     * ONE BASELINE. These figures come from the analyser's shared `agedCareBaseline` whenever it has
     * resolved, and fall back to this component's own hook only if it has not.
     *
     * Aged care used to compute the no-plan position TWICE — once here (via useWalkInBaseline) and
     * once in the analyser for the Financial Impact panel. Same intent, two code paths, and they
     * disagreed the moment one changed: the panel showed a baseline cashflow of $24,414 while this
     * summary showed −$73,235 for the same plan on the same screen, because only one of them netted
     * off the baseline's own care fees. Two computations of one number will always drift; the fix is
     * to have one.
     */ const pensionDoNothing = sharedBaseline?.pension ?? (baseline.careFinancials.socialSecurity || 0);
    const pensionWithPlan = simulatedFinancials.socialSecurity || 0;
    const cashflowDoNothing = sharedBaseline?.cashFlowAfterCare ?? (baseline.careFinancials.cashFlow || 0) - (baseline.costs.totalDailyCost || 0) * 365;
    const cashflowWithPlan = (simulatedFinancials.cashFlow || 0) - (agedCareCosts.totalDailyCost || 0) * 365;
    const dapDaily = agedCareCosts.dailyAccommodationPayment || 0;
    const figures = $a258b04930632a82$export$dbec3ed92c831629({
        radInput: radInput,
        radPaidTotal: radPaid,
        dapDaily: dapDaily,
        pensionDoNothing: pensionDoNothing,
        pensionWithPlan: pensionWithPlan,
        cashflowDoNothing: cashflowDoNothing,
        cashflowWithPlan: cashflowWithPlan
    });
    const totalGifting = ip.gifting + (dzActive ? dz.gifting : 0);
    const giftExcess = Math.max(0, totalGifting - (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0));
    const totalLeftover = dzLeftover + ipLeftover;
    /*
     * The whys name this plan's ACTUAL drivers — the same figures the sections above show — so the
     * explanation and the numbers can never tell different stories. Generic cause-lists are what
     * made a correct result read as a bug (owner feedback, 2026-08-24 twice: the exempt-downsize
     * phantom fall, and "any rent stops" said to a client who sold no rented asset).
     */ const countable = [];
    /*
     * Rent first, because when it is on it is usually the whole answer — and it was the case that
     * exposed this list as incomplete. A client who funded the RAD from the bank and let the home
     * out sold nothing at all, so every entry below stayed empty and the summary fell through to a
     * sentence about selling assets. The RAD is exempt; the rent is not; that is the story.
     */ if (rentsHome && netAnnualRent > 0) countable.push(`${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(netAnnualRent)} a year of net rent from the family home (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(annualRent)} of rent less ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(rentExpenses)} of expenses), which the income test counts`);
    if (dzLeftover > 0) countable.push(`${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dzLeftover)} of home-sale money left in the bank`);
    if (ipLeftover > 0) countable.push(`${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(ipLeftover)} of property-sale money left in the bank`);
    if (dzActive && dz.downsizer > 0) countable.push(`${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dz.downsizer)} of downsizer contributions in super (counted from pension age)`);
    if (dzActive && dz.newShares > 0) countable.push(`${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dz.newShares)} of new shares`);
    if (dzActive && dz.newInvestmentProperty > 0) countable.push(`the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dz.newInvestmentProperty)} new investment property`);
    const pensionWhy = figures.pensionDirection === 'rises' ? `Centrelink counted the assets being sold in full \u{2014} their value in the assets test and any rent or earnings in the income test. Money paid as a RAD is exempt from the assets test, so moving value into the RAD usually lifts the pension. The plan's Age Pension number shows the same before-and-after.` : figures.pensionDirection === 'falls' ? countable.length > 0 ? `The RAD and any new family home are exempt \u{2014} what moves the pension is what stays countable: ${countable.join('; ')}.${rentsHome && netAnnualRent > 0 ? ' Note the money used to pay the RAD is not what caused this: a RAD is exempt from the assets test, so paying it does not reduce the pension. It is the rent that does.' : ' Centrelink counts it in the assets test and deems income on the financial part.'} The plan's Age Pension number shows the same before-and-after.` : `Nothing in this plan obviously moves what the means tests count, yet the pension has changed \u{2014} press "why?" on the plan's Age Pension number for the line that moved, rather than relying on this summary.` : `Both sides of this plan sit in things Centrelink treats the same way as before, so nothing here changes what the means tests count. The plan's Age Pension number shows the same before-and-after.`;
    /*
     * WHY THE ESTATE MOVED — named, quantified, and in a lay reader's terms.
     *
     * Owner-caught (2026-08-26): a plan that sold the home, paid the whole room and bought a cheaper
     * house showed the estate $163,528 WORSE than doing nothing, and the explanation said nothing
     * useful. The adviser's own reaction — "I'm not clear on this because the DAP is the higher
     * interest rate" — is exactly right and exactly the point: paying the room up front DOES save the
     * daily fee, so the reader is owed the other side of the ledger.
     *
     * The two costs that are easy to miss, because neither appears as a fee:
     *   1. SELLING COSTS leave immediately and never return.
     *   2. A RAD DOES NOT GROW. It is refunded at the amount paid — the engine excludes `radPaid`
     *      from asset growth for exactly this reason. Money moved out of a home (which rises with
     *      property values) into a deposit that stands still costs the estate that forgone growth,
     *      every year it sits there. Nothing on the screen says "fee", so nobody sees it.
     * Both are quoted from figures already on this page; the netting off is the projection's job.
     */ const sellingCostsPaid = dzActive ? Math.max(0, Number(downsizeDetails.sellingCosts) || 0) : 0;
    const parkedInRad = Math.min(radPaid, radInput);
    /**
     * Did the deposit come out of the HOME, or out of savings? It changes what growth was given up —
     * property growth in one case, investment return in the other — and saying the wrong one to a
     * client who never touched their home is worse than saying nothing.
     */ const radFundedFromHomeSale = dzActive && (Number(downsizeDetails.radAllocation) || 0) > 0;
    const baselineDapAnnualForWhy = (baseline.costs.dailyAccommodationPayment || 0) * 365;
    /*
     * WHAT MOVES THE ESTATE, AS A LIST (owner, 24 Sep 2026: "aged care is still one massive block
     * of text"). One line per driver, the amount beside it where the model has one. The mechanism
     * of each is unchanged from the sentences this replaces — see the notes on the RAD line:
     * the provider retains 2% a year for the first five years (radPlugin.ts models exactly that),
     * and the growth given up is property growth only when the deposit came out of a home sale.
     */ const legacyDrivers = [];
    if (sellingCostsPaid > 0) legacyDrivers.push({
        text: 'The selling cost leaves straight away and never comes back',
        amount: sellingCostsPaid,
        sign: 'minus'
    });
    if (parkedInRad > 0) legacyDrivers.push({
        text: `The ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(parkedInRad)} paid as a RAD comes back when care ends, less the 2% a year the provider retains for the first five years, and it does NOT grow while it sits there \u{2014} ${radFundedFromHomeSale ? 'money that was in a home rising with property values is now standing still' : 'money that was invested and earning is now standing still'}, so the estate gives up that growth for every year it sits there`,
        sign: 'minus'
    });
    if (figures.roomFullyPaid && baselineDapAnnualForWhy > 0) legacyDrivers.push({
        text: "Paying the room up front removes the daily fee, pulling the other way \u2014 which is why the cashflow above improves",
        amount: baselineDapAnnualForWhy,
        suffix: 'a year',
        sign: 'plus'
    });
    else if (figures.unpaidRoom > 0) {
        const dapAnnualNow = dapDaily * 365;
        if (parkedInRad > 0 && baselineDapAnnualForWhy > dapAnnualNow + 0.5) legacyDrivers.push({
            text: `Paying ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(parkedInRad)} up front cuts the daily fee from ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(baselineDapAnnualForWhy)} to ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dapAnnualNow)} a year, pulling the other way`,
            amount: baselineDapAnnualForWhy - dapAnnualNow,
            suffix: 'a year',
            sign: 'plus'
        });
        else legacyDrivers.push({
            text: `The ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(figures.unpaidRoom)} of room left unpaid is charged as a daily fee and never comes back`,
            amount: dapAnnualNow,
            suffix: 'a year',
            sign: 'minus'
        });
    }
    if (rentsHome && netAnnualRent > 0) legacyDrivers.push({
        text: 'The home is kept, and keeps both its rent and its property growth',
        amount: netAnnualRent,
        suffix: 'a year',
        sign: 'plus'
    });
    if (totalGifting > 0) legacyDrivers.push({
        text: 'Gifted, so it has left the estate altogether',
        amount: totalGifting,
        sign: 'minus'
    });
    if (clearedDebtsForWhy > 0) legacyDrivers.push({
        text: 'Debt cleared is money out of the estate now, against interest that never accrues',
        amount: clearedDebtsForWhy,
        sign: 'neutral'
    });
    if (Math.max(0, Number(heasDetails?.lumpSum) || 0) > 0 || Math.max(0, Number(heasDetails?.fortnightlyPayment) || 0) > 0) legacyDrivers.push({
        text: 'The Home Equity Access Scheme loan compounds against the home and is repaid out of the estate',
        sign: 'minus'
    });
    const legacyWhy = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$721778c36dbce7e7), {
        lead: `What is projected to be left after ${legacyYears} ${legacyYears === 1 ? 'year' : 'years'}, measured against paying daily \u{2014} the whole room paid as a daily fee, nothing paid up front and nothing sold. The care is happening either way, so this isolates what the plan itself does to the estate.`,
        drivers: legacyDrivers,
        closing: "Projections depend on the return, inflation, property-growth and length-of-stay assumptions behind them, so treat the direction as the message rather than the exact figure."
    });
    const baselineDapAnnual = (baseline.costs.dailyAccommodationPayment || 0) * 365;
    const cashflowDrivers = [];
    // Rent moves cashflow in both directions at once, and a summary that names only one of them
    // misleads: the home earns, and the partner's new rent spends.
    if (rentsHome && netAnnualRent > 0) cashflowDrivers.push(`the family home brings in ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(netAnnualRent)} a year of net rent`);
    if (rentsHome && partnerAnnualRent > 0) cashflowDrivers.push(`${factFind?.partner?.firstName || 'the partner'} pays ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(partnerAnnualRent)} a year in rent elsewhere`);
    if (figures.roomFullyPaid && baselineDapAnnual > 0) cashflowDrivers.push(`with no plan, ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(baselineDapAnnual)} a year of DAP would be charged on the unpaid room \u{2014} this plan pays the room in full, so that charge disappears`);
    else if (baselineDapAnnual - figures.dapAnnual > 1) cashflowDrivers.push(`the DAP shrinks from ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(baselineDapAnnual)} to ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(figures.dapAnnual)} a year because more of the room is paid up front`);
    if (figures.pensionDirection !== 'holds') cashflowDrivers.push(`the Age Pension ${figures.pensionDirection === 'rises' ? 'is higher' : 'is lower'} (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pensionDoNothing)} \u{2192} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pensionWithPlan)} a year)`);
    if (hasIpGroup && (parseFloat(String(selectedProperty?.rent)) || 0) > 0) cashflowDrivers.push(`the rent from ${selectedProperty?.description || 'the investment property'} stops with the sale`);
    const cashflowWhy = `This is a full year of money in, minus living costs and care fees \u{2014} the same figure as the plan's "each year, short by" number.` + (cashflowDrivers.length > 0 ? ` What changes it against paying daily: ${cashflowDrivers.join('; ')}.` : '') + // A plan that still leaves a shortfall: normal in care, and fine if the savings last (owner, 6 Oct 2026).
    (cashflowWithPlan != null && cashflowWithPlan < 0 ? (()=>{
        const o = (0, $761eebfc891b9eea$export$a3c504a65d7a0fe7)(planRunway, (0, $761eebfc891b9eea$export$ee5aafeb340c75f8)(factFind));
        return ` ${o.lead}${o.verdict ? ` ${o.verdict}` : ''}`;
    })() : '');
    // ---- The story: sentences that INTERPRET the numbers above, never restate them as a table ----
    const liquidPhrase = liquidRows.map((row)=>`${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.net)} from ${row.label}${row.cgt > 0 ? ' (after estimated capital gains tax)' : ''}`).join(' and ');
    const story = [];
    if (hasDownsizeGroup) story.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        children: [
            "Selling the family home frees up ",
            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dzNetProceeds),
            " after costs.",
            dz.toRoom > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dz.toRoom),
                    " of it goes to the room as a ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                        term: "RAD"
                    }),
                    " \u2014 money that comes back later and that Centrelink doesn't count."
                ]
            }),
            dz.newHome > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dz.newHome),
                    " buys the new home",
                    stayingName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " for ",
                            stayingName
                        ]
                    }) : null,
                    " \u2014 also not counted."
                ]
            }),
            dz.downsizer > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dz.downsizer),
                    " goes into super as a ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                        term: "downsizer contribution"
                    }),
                    " \u2014 Centrelink does count this at pension age."
                ]
            }),
            dz.newShares > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dz.newShares),
                    " buys shares, which Centrelink counts and ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                        term: "deems",
                        children: 'Centrelink assumes financial assets earn a set rate of income (deeming) and counts that income in the pension income test, whatever they actually earn.'
                    }),
                    " income on."
                ]
            }),
            dz.newInvestmentProperty > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dz.newInvestmentProperty),
                    " buys an investment property, which is fully counted."
                ]
            }),
            dz.funeralBond > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dz.funeralBond),
                    " goes into a funeral bond (exempt within the limit)."
                ]
            }),
            dz.gifting > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dz.gifting),
                    " is gifted."
                ]
            }),
            annuityFromSaleProceeds > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(annuityFromSaleProceeds),
                    " buys the lifetime annuity set up under Other Strategies."
                ]
            })
        ]
    }, "dz"));
    if (hasIpGroup) story.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        children: [
            "Selling ",
            selectedProperty?.description || 'the investment property',
            " frees up ",
            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(ipNetProceeds),
            ipCgt > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " after selling costs and an estimated ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(ipCgt),
                    " in ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                        term: "capital gains tax"
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: " after selling costs, with no capital gains tax expected"
            }),
            ip.toRoom > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "; ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(ip.toRoom),
                    " of it goes to the room"
                ]
            }),
            ip.newHome > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    ", ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(ip.newHome),
                    " buys a new home"
                ]
            }),
            ip.gifting > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    ", ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(ip.gifting),
                    " is gifted"
                ]
            }),
            "."
        ]
    }, "ip"));
    /*
     * THE LOAN, TOLD FIRST AND IN FULL.
     *
     * The story previously carried one clause — "borrowed against the home ... the interest builds up
     * until the home is sold" — buried mid-paragraph among the funding sentences. For an $800,000
     * loan compounding at 8% with no repayments, that is not enough, and the owner reasonably read
     * the whole screen without realising which product they were looking at.
     */ if (equityRelease && Number(equityRelease.loanAmount) > 0) story.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $680e2cea6da0f2e4$export$45232555cfe21303), {
        kind: equityRelease.kind === 'heas' ? 'heas' : 'reverseMortgage',
        loanAmount: Number(equityRelease.loanAmount) || 0,
        interestRate: Number(equityRelease.interestRate) || null,
        projectedBalance: Number(equityRelease.projectedBalance) || null,
        years: Number(equityRelease.years) || null,
        homeValue: Number(factFind?.home?.value) || null
    }, "equity-release"));
    if (liquidPhrase || rmToRoom > 0) story.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        children: [
            liquidPhrase && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    hasDownsizeGroup || hasIpGroup ? 'On top of that, ' : '',
                    liquidPhrase,
                    " ",
                    liquidRows.length > 1 ? 'are' : 'is',
                    " paid towards the room."
                ]
            }),
            rmToRoom > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(rmToRoom),
                    " of that borrowing goes to the room."
                ]
            })
        ]
    }, "liq"));
    if (facilityMove) story.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        "data-testid": "recap-move",
        children: facilityMove
    }, "move"));
    if (villageExit) story.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        "data-testid": "recap-village",
        children: villageExit
    }, "village"));
    story.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        children: [
            figures.roomFullyPaid ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "Together that pays the whole ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(radInput),
                    " room price up front, so no",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                        term: "DAP"
                    }),
                    " is charged on the room. The basic daily fee and the means-tested care fees still apply. The ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                        term: "RAD"
                    }),
                    " is returned when care ends, less 2% a year for the first five years."
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "Together that pays ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.min(radPaid, radInput)),
                    " of the ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(radInput),
                    " room price up front (refunded later, less 2% a year for five years). The unpaid",
                    ' ',
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(figures.unpaidRoom),
                    " is charged as a ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                        term: "DAP"
                    }),
                    dapDaily > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " of ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dapDaily),
                            " a day"
                        ]
                    }) : null,
                    " \u2014 that part works like rent and never comes back."
                ]
            }),
            secondRoom && secondRoom.roomPrice > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    ' ',
                    "That is ",
                    secondRoom.leadName ? `${secondRoom.leadName}'s` : 'the first',
                    " room. ",
                    secondRoom.name,
                    "'s room is paid the same way:",
                    ' ',
                    secondRoom.radPaid > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(secondRoom.radPaid),
                            " of its ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(secondRoom.roomPrice),
                            " price up front",
                            secondRoom.funding && secondRoom.funding.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    " \u2014 ",
                                    (0, $e5cae8423a439bf1$export$83ba4f4a49e92f66)(secondRoom.funding, (0, $f94e45ac645ae232$export$3dc27271f5d5c629)),
                                    ", from what is left after the first deposit",
                                    secondRoom.paidFromLabel ? `, taken when ${secondRoom.name} moves in, ${secondRoom.paidFromLabel}` : ''
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: ", from what is left after the first deposit"
                            }),
                            "; the unpaid ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.max(0, secondRoom.roomPrice - secondRoom.radPaid)),
                            " is charged as a ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                term: "DAP"
                            }),
                            "."
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "nothing up front, so its whole ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(secondRoom.roomPrice),
                            " price is charged as a ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                term: "DAP"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            totalLeftover > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    ' ',
                    "The ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(totalLeftover),
                    " left over stays in the bank, where Centrelink counts it and",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                        term: "deems",
                        children: 'Centrelink assumes this money earns a set rate of income (deeming) and counts that income in the pension income test, whatever it actually earns.'
                    }),
                    " income on it \u2014 this is often what moves the pension."
                ]
            })
        ]
    }, "room"));
    /*
     * The rental strategy, said out loud. It is two decisions, and both belong in the summary: what
     * the home now earns, and what the partner now pays to live elsewhere. Each carries its own
     * means-test consequence, and they pull in opposite directions on cashflow.
     */ if (rentsHome && (annualRent > 0 || partnerAnnualRent > 0)) story.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        children: [
            annualRent > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "The family home is ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: "kept and rented out"
                    }),
                    " at",
                    ' ',
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(weeklyRent),
                    " a week \u2014 ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(annualRent),
                    " a year, less",
                    ' ',
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(rentExpenses),
                    " of expenses, so",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(netAnnualRent)
                    }),
                    " of net rent. That rent is ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: "assessable income"
                    }),
                    " for both the Age Pension income test and the aged care means test. The home itself keeps its",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: "two-year exemption"
                    }),
                    " from the pension assets test, and is counted for care fees up to the capped value."
                ]
            }),
            partnerAnnualRent > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    annualRent > 0 ? ' ' : '',
                    factFind?.partner?.firstName || 'The partner',
                    " pays",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "font-semibold text-slate-900",
                        children: [
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(partnerWeeklyRent),
                            " a week"
                        ]
                    }),
                    ' ',
                    "(",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(partnerAnnualRent),
                    " a year) to rent elsewhere, which comes straight off the household's cashflow \u2014 and may attract Rent Assistance."
                ]
            })
        ]
    }, "rent"));
    /*
     * EVERY LEVER GETS A SENTENCE. A coverage audit (owner-caught, 2026-08-26: "I'm anxious you don't
     * have explainers for every strategy option") found four that produced NO commentary at all —
     * the Home Equity Access Scheme, equity release generally, clearing debts, and any gifting,
     * funeral bond or annuity chosen OUTSIDE a property sale. A plan can be summarised without
     * mentioning what it actually does, and the client would never know the omission was there.
     */ const heasLumpSum = Math.max(0, Number(heasDetails?.lumpSum) || 0);
    const heasFortnightly = Math.max(0, Number(heasDetails?.fortnightlyPayment) || 0);
    if (overallStrategy?.heas && (heasLumpSum > 0 || heasFortnightly > 0)) story.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        children: [
            "The ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "font-semibold text-slate-900",
                children: "Home Equity Access Scheme"
            }),
            " is used to draw",
            heasLumpSum > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " a ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(heasLumpSum),
                    " lump sum"
                ]
            }) : null,
            heasLumpSum > 0 && heasFortnightly > 0 ? ' and' : '',
            heasFortnightly > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(heasFortnightly),
                    " a fortnight"
                ]
            }) : null,
            " against the home. It is a government loan, so nothing is repaid along the way \u2014 but interest compounds against the property and the debt grows every year it runs, which comes out of the estate at the end."
        ]
    }, "heas"));
    const clearedDebts = Object.values(debtPayoffPlan?.payments || {}).reduce((sum, amount)=>sum + (Number(amount) || 0), 0);
    if (clearedDebts > 0) story.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "font-semibold text-slate-900",
                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(clearedDebts)
            }),
            " of debt is cleared. The interest stops and the repayments leave the cashflow, and because the money spent is no longer a counted asset it can lift the Age Pension too \u2014 but it is money the rest of the plan cannot use, which is the trade-off worth weighing."
        ]
    }, "debt"));
    /*
     * PAYING THE ROOM AS A DAILY FEE is a strategy, and the summary had no sentence for it.
     *
     * Every paragraph above narrates where deposit money came from. When no deposit is paid there is
     * nothing to narrate, and the summary opened straight into the pension and cashflow rows with no
     * account of the plan at all (owner, 2026-09-01). What the client did is keep their capital and
     * rent the room - which has real consequences in both directions, and they belong first.
     */ // The order the money is used — only where there is a shortfall to fund (owner, 15 Oct 2026).
    if (moneyOrder && cashflowWithPlan != null && cashflowWithPlan < 0) story.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        "data-testid": "recap-money-order",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "font-semibold text-slate-900",
                children: "Where the shortfall comes from."
            }),
            " ",
            moneyOrder
        ]
    }, "money-order"));
    if (story.length === 0 && radInput > (Number(radPaid) || 0) + 1) {
        const unpaid = Math.max(0, radInput - (Number(radPaid) || 0));
        story.unshift(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            children: [
                "No ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                    term: "RAD"
                }),
                " is paid up front. The",
                ' ',
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "font-semibold text-slate-900",
                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(unpaid)
                }),
                " of room price left unpaid is charged as a ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                    term: "DAP"
                }),
                " \u2014 a daily fee, like rent, which does not come back. In exchange every dollar stays where it is: available if it is needed, and still earning."
            ]
        }, "dap-route"));
    }
    // Standalone Other Strategies — the ones NOT funded from a property sale, which the sale
    // paragraphs above would otherwise be the only place they were mentioned.
    const standaloneAnnuity = otherStrategies?.annuity && annuityFromSaleProceeds <= 0 ? Math.max(0, Number(annuityRecord?.purchaseAmount) || 0) : 0;
    if (standaloneAnnuity > 0) {
        story.push(annuityRecord?.annuityType === 'guaranteed' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "font-semibold text-slate-900",
                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(standaloneAnnuity)
                }),
                " buys a guaranteed income for life combined with life cover, which pays the full amount back to the family whenever death comes. Only the income part counts at 60% in the assets test (30% later); the life cover is counted in full, so it does less for the pension and the fees than the other types."
            ]
        }, "annuity") : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "font-semibold text-slate-900",
                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(standaloneAnnuity)
                }),
                " buys a lifetime annuity. Only 60% of the purchase price counts in the assets test (for the first five years, or until age 85 if that is later, and 30% after that), which is what can lift the pension. What it costs depends on the shape: with nothing coming back the capital is committed for life, and with capital returned some can be taken back, falling each year to nothing."
            ]
        }, "annuity"));
        story.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6421482343679f4$export$9f9fb1aea9338121), {
            className: "mt-1",
            purchaseAmount: standaloneAnnuity,
            residualPercent: Math.round(Math.max(0, Math.min(1, Number(annuityRecord?.residualCapital) || 0)) * 100),
            ownerName: annuityRecord?.owner === 'partner' ? factFind?.partner?.firstName || 'your partner' : factFind?.client?.firstName || 'you',
            partnerName: factFind?.adviceFor === 'couple' ? annuityRecord?.owner === 'partner' ? factFind?.client?.firstName || 'you' : factFind?.partner?.firstName || 'your partner' : null,
            reversionary: !!annuityRecord?.reversionary,
            indexed: !!annuityRecord?.indexation,
            annuityType: String(annuityRecord?.annuityType || 'lifetime'),
            annualPayment: Number(annuityRecord?.annualPayment) || null
        }, "annuity-terms"));
    } else if (engineAnnuityTerms && Number(engineAnnuityTerms.purchaseAmount) > 0) {
        /*
         * THE ENGINE'S ANNUITY, told as part of the same story.
         *
         * It used to be rendered by the panel AFTER this card, which is how the owner came to see a
         * modal containing one small box and nothing else. Inside the story it reads as one plan
         * with one explanation, which is what "Understanding your plan" is for.
         */ story.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "font-semibold text-slate-900",
                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(engineAnnuityTerms.purchaseAmount))
                }),
                ' ',
                engineAnnuityTerms.annuityType === 'guaranteed' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: "buys a guaranteed income for life combined with life cover, which pays the full amount back to the family whenever death comes. Only the income part counts at 60% in the assets test (30% later), and 60% of the payments count as income; the life cover is counted in full, so the pension and fee savings are smaller than with the other types."
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: "buys a lifetime annuity. Only 60% of the purchase price counts in the assets test (for the first five years, or until age 85 if that is later, and 30% after that), and only 60% of the payments count as income \u2014 which is what lifts the pension and lowers the care fees. What it costs depends on the shape chosen below."
                })
            ]
        }, "annuity-se"));
        story.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6421482343679f4$export$d05c00195a7db941), {
            className: "mt-1",
            terms: engineAnnuityTerms,
            factFind: factFind,
            quote: annuityQuoteControl
        }, "annuity-se-terms"));
        /*
         * BUYING AN ANNUITY WHILE THE ROOM IS UNPAID IS BORROWING AT THE MPIR TO INVEST BELOW IT.
         *
         * OWNER-RAISED, 2026-09-01: "its using the liquid assets to acquire this annuity which in
         * turn triggers the DAP which is effectively interest at circa 8% so seeing this option in
         * the current market I'm scratching my head."
         *
         * The arithmetic backs the instinct. Every dollar not paid as a deposit is charged the DAP at
         * the MPIR, and none of it comes back; the same dollar in a lifetime annuity earns the
         * annuity rate, which for an older client with full residual capital is far below it. Paying
         * the deposit instead is cheaper on both sides of the means test as well: a RAD is entirely
         * exempt from the Age Pension assets test where an annuity is 60% counted, and it is refunded
         * apart from the 2% a year retention.
         *
         * The engine still models it, and it can still rank well on ESTATE because that retention is
         * a real cost and full residual capital preserves the annuity's value. But a client cannot
         * weigh any of that from a ranking, so the two rates are put side by side here. Shown only
         * when room is actually left unpaid — where the deposit is paid in full there is no borrowing
         * to compare against.
         */ const annuityRate = Number(engineAnnuityTerms.annualPayment) > 0 ? Number(engineAnnuityTerms.annualPayment) / Number(engineAnnuityTerms.purchaseAmount) * 100 : null;
        if (radInput > (Number(radPaid) || 0) + 1 && annuityRate != null) story.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            className: "rounded-lg border border-slate-200 border-l-4 border-l-amber-400 bg-white py-2 pl-3 pr-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "font-semibold text-slate-900",
                    children: "Worth weighing carefully."
                }),
                ' ',
                "Part of the room is left unpaid, and unpaid room is charged at",
                ' ',
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "font-semibold text-slate-900",
                    children: [
                        (0, $c79e495c2243b635$export$f69f5c996f5fd654),
                        " a year"
                    ]
                }),
                " \u2014 money that never comes back. This annuity pays about",
                ' ',
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "font-semibold text-slate-900",
                    children: [
                        annuityRate.toFixed(1),
                        "% a year"
                    ]
                }),
                ". Putting the same money into the deposit instead would stop the ",
                (0, $c79e495c2243b635$export$f69f5c996f5fd654),
                " charge, is fully exempt from the Age Pension assets test where an annuity is only 40% exempt (60% of it is counted), and is refunded when care ends apart from 2% a year for the first five years."
            ]
        }, "annuity-carry"));
    }
    /*
     * THE PIECES OF THIS PLAN, in plain words (owner, 24 Sep 2026): one row per piece, what it is
     * and what the means tests do with it, built from the same figures the summary narrates.
     */ const planPieces = [];
    if (radPaid > 0) planPieces.push({
        key: 'rad',
        name: 'Refundable accommodation deposit (RAD)',
        amount: radPaid,
        what: 'Paid up front for the room. It comes back when care ends, less 2% a year for the first five years, and it is not counted in the Age Pension assets test.',
        glossaryTerm: 'rad'
    });
    if (secondRoom && secondRoom.roomPrice > 0) planPieces.push({
        key: 'secondRoom',
        name: `${secondRoom.name}'s room`,
        amount: secondRoom.radPaid,
        what: `A room of ${secondRoom.name}'s own, priced at ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(secondRoom.roomPrice)}. ${secondRoom.radPaid > 0 ? `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(secondRoom.radPaid)} is paid up front from what the first deposit leaves; the rest is paid daily.` : 'Nothing is paid up front; the whole room is paid daily.'}${secondRoom.dailyTotal != null ? ` ${secondRoom.name}'s fees come to about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(secondRoom.dailyTotal)} a day.` : ''}${phaseTwo ? ` ${(0, $b8d3cfe4c156722e$export$72e32d04cedd8a9d)(phaseTwo.names, phaseTwo.firstDaily, phaseTwo.phaseTwoDaily)}` : ''} You are assessed as a couple living apart, each at the single pension rate.`,
        glossaryTerm: 'rad'
    });
    if (figures.unpaidRoom > 0) planPieces.push({
        key: 'dap',
        name: 'Daily accommodation payment (DAP)',
        amount: figures.dapAnnual,
        amountSuffix: 'a year',
        what: `Interest-style rent on the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(figures.unpaidRoom)} of the room not paid up front, charged daily at the government's set rate. It never comes back.`,
        glossaryTerm: 'dap'
    });
    const liquidPaid = liquidRows.reduce((sum, row)=>sum + (Number(row.gross) || 0), 0);
    if (liquidPaid > 0) planPieces.push({
        key: 'savings',
        name: 'Paid from savings',
        amount: liquidPaid,
        what: 'The deposit comes out of bank accounts, term deposits, super pensions or shares. Money that was counted by Centrelink becomes a deposit that is not.',
        glossaryTerm: 'deeming'
    });
    if (dzActive && dz.salePrice > 0) planPieces.push({
        key: 'sell-home',
        name: 'Sell the family home',
        amount: dz.salePrice,
        what: `The home is sold; after ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dz.sellingCosts)} of selling costs the money pays for the room and funds what follows. Whatever is not spent on the room or a new home becomes money Centrelink counts.`
    });
    if (dzActive && dz.newHome > 0) planPieces.push({
        key: 'new-home',
        name: 'Buy the next home',
        amount: dz.newHome,
        what: 'The new home is the principal residence, so it is exempt from the assets test up to the home exemption cap while it is lived in.',
        glossaryTerm: 'home exemption cap'
    });
    if (dzActive && dz.downsizer > 0) planPieces.push({
        key: 'downsizer',
        name: 'Downsizer contribution into super',
        amount: dz.downsizer,
        what: 'A special rule lets each person aged 55 or over put up to $300,000 from selling their home into super, on top of the usual limits. Inside super the earnings are taxed at no more than 15%.',
        glossaryTerm: 'downsizer contribution'
    });
    if (dzActive && dz.newInvestmentProperty > 0) planPieces.push({
        key: 'ip',
        name: 'Investment property',
        amount: dz.newInvestmentProperty,
        what: 'A property bought to rent out. Counted in full as an asset, and the rent after expenses counts as income.',
        glossaryTerm: 'investment property'
    });
    if (dzActive && dz.newShares > 0) planPieces.push({
        key: 'shares',
        name: 'Shares / managed funds',
        amount: dz.newShares,
        what: 'Invested in a spread of shares and funds you can sell at any time. Counted in full as an asset, and deemed to earn income whatever it actually pays.',
        glossaryTerm: 'shares and managed funds'
    });
    if (ipActive && ipNetProceeds > 0) planPieces.push({
        key: 'sell-ip',
        name: 'Sell an investment property',
        amount: ipNetProceeds,
        what: 'The property is sold; after selling costs and capital gains tax, the proceeds pay for the room. Its rent stops counting as income.',
        glossaryTerm: 'capital gains tax'
    });
    if (ipActive && ip.downsizer > 0) planPieces.push({
        key: 'ip-downsizer',
        name: 'Downsizer contribution into super',
        amount: ip.downsizer,
        what: 'Money from the sale moved into super under the downsizer rule, where earnings are taxed at no more than 15%.',
        glossaryTerm: 'downsizer contribution'
    });
    if (rentsHome) planPieces.push({
        key: 'rent-home',
        name: 'Keep the home and rent it out',
        amount: netAnnualRent,
        amountSuffix: 'a year',
        what: 'The home is let while care is paid for another way. The rent counts as income; the home stays exempt for two years, then is counted.',
        glossaryTerm: 'home exemption cap'
    });
    if (overallStrategy?.reverseMortgage) planPieces.push({
        key: 'rm',
        name: 'Reverse mortgage',
        amount: rmToRoom > 0 ? rmToRoom : Math.max(0, Number(equityRelease?.loanAmount) || 0),
        what: 'A loan against the home with no repayments. The interest is added to the loan and the whole amount is repaid from the estate when the home is sold. Not counted as an asset.',
        glossaryTerm: 'reverse mortgage'
    });
    if (overallStrategy?.heas && (heasLumpSum > 0 || heasFortnightly > 0)) planPieces.push({
        key: 'heas',
        name: 'Home Equity Access Scheme',
        amount: heasLumpSum > 0 ? heasLumpSum : heasFortnightly * 26,
        amountSuffix: heasLumpSum > 0 ? undefined : 'a year',
        what: 'A government loan against the home, paid as a lump sum or fortnightly, at a lower rate than a bank charges. The debt is repaid from the estate.',
        glossaryTerm: 'heas'
    });
    const annuityPurchase = annuityFromSaleProceeds > 0 ? annuityFromSaleProceeds : standaloneAnnuity;
    let annuityKind = 'annuityNil';
    if (annuityPurchase > 0) {
        const residual = engineAnnuityTerms?.residual != null ? Number(engineAnnuityTerms.residual) : Number(annuityRecord?.residualCapital) || 0;
        const period = engineAnnuityTerms?.capitalAccessPeriodYears != null ? Number(engineAnnuityTerms.capitalAccessPeriodYears) || null : annuityRecord?.capitalAccessPeriodYears ?? null;
        const sexKnown = engineAnnuityTerms?.lifeExpectancySexKnown != null ? !!engineAnnuityTerms.lifeExpectancySexKnown : annuityRecord?.lifeExpectancySexKnown ?? null;
        const fullBack = (engineAnnuityTerms?.annuityType ?? annuityRecord?.annuityType) === 'guaranteed';
        annuityKind = fullBack ? 'annuityGuaranteed' : residual > 0 ? 'annuityReturned' : 'annuityNil';
        planPieces.push(fullBack ? {
            key: 'annuity',
            name: 'Guaranteed income with the full amount back',
            amount: annuityPurchase,
            what: 'A lump sum handed to an insurer for a guaranteed income for life, combined with life cover: the full amount goes back to the family whenever death comes. Only the income part counts at 60% in the assets test; the life cover is counted in full.',
            glossaryTerm: 'lifetime annuity'
        } : {
            key: 'annuity',
            name: 'Lifetime annuity',
            amount: annuityPurchase,
            what: `A lump sum handed to an insurer in return for a guaranteed income for life. Only 60% of it counts in the assets test. ${residual > 0 ? (0, $5ccd559ea4d04f2e$export$476ca360cf39c0a7)({
                residualPct: Math.round(residual * 100),
                periodYears: period,
                sexKnown: sexKnown
            }) : 'Nothing of the purchase price comes back on death.'}`,
            glossaryTerm: 'lifetime annuity'
        });
    }
    if (totalGifting > 0) planPieces.push({
        key: 'gift',
        name: 'Gift to family',
        amount: totalGifting,
        what: 'Money given away. Up to $10,000 a year ($30,000 over five years) leaves the means tests straight away; anything above that is still counted for five years.',
        glossaryTerm: 'gifting'
    });
    const bondTotal = (dzActive ? dz.funeralBond : 0) + (ipActive ? ip.funeralBond : 0);
    if (bondTotal > 0) planPieces.push({
        key: 'bond',
        name: 'Funeral bond',
        amount: bondTotal,
        what: 'Money set aside for a funeral with a friendly society or insurer. Within the limit it is exempt from the assets test, and it can only be used for the funeral.',
        glossaryTerm: 'funeral bond'
    });
    if (clearedDebtsForWhy > 0) planPieces.push({
        key: 'debt',
        name: 'Debts paid off',
        amount: clearedDebtsForWhy,
        what: 'Loans cleared from savings before the room is paid for. Less money is counted, and no more interest is paid.'
    });
    /*
     * CAUSE → EFFECT (the owner's "Explain this", 17 Oct 2026). Each line says what the plan does
     * and what that does to the numbers, in this client's figures; a result line says what is left
     * against doing nothing; the pieces follow. Every figure is the one computed above.
     */ if (told === 'causeEffect') {
        const facts = causeEffectFacts || {};
        const who = facts.enteringName || factFind?.client?.firstName || 'the client';
        const possessive = /s$/i.test(who) ? `${who}'` : `${who}'s`;
        const baseDapDaily = facts.baselineDapDaily ?? (baseline.costs.dailyAccommodationPayment || 0);
        const baseCareAnnual = facts.baselineCareAnnual ?? (baseline.costs.totalDailyCost || 0) * 365;
        const planCareAnnual = (agedCareCosts.totalDailyCost || 0) * 365;
        const paidTotal = Math.min(Number(radPaid) || 0, radInput);
        const money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
        const lines = [];
        // 1. What is paid for the room, and what that does to the fees.
        if (paidTotal > 0.5) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            children: [
                figures.roomFullyPaid ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                            children: [
                                "You pay the whole ",
                                money(radInput),
                                " room up front",
                                liquidPhrase ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        " \u2014 ",
                                        liquidPhrase
                                    ]
                                }) : null,
                                ", so there is no daily room fee at all"
                            ]
                        }),
                        baseDapDaily > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                " (it would be ",
                                money(baseDapDaily),
                                " a day)"
                            ]
                        }) : null,
                        ".",
                        baseCareAnnual > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                " Care costs drop ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$5354fc7cb2207caf), {
                                    from: baseCareAnnual,
                                    to: planCareAnnual,
                                    unit: " a year",
                                    better: "down"
                                }),
                                "."
                            ]
                        }) : null
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                            children: [
                                "You pay ",
                                money(paidTotal),
                                " of the room up front",
                                liquidPhrase ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        " \u2014 ",
                                        liquidPhrase
                                    ]
                                }) : null,
                                ", so the daily room fee is charged on ",
                                money(figures.unpaidRoom),
                                " instead of ",
                                money(radInput),
                                "."
                            ]
                        }),
                        baseDapDaily > 0 && dapDaily > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                " That fee falls ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$5354fc7cb2207caf), {
                                    from: baseDapDaily,
                                    to: dapDaily,
                                    unit: " a day",
                                    better: "down"
                                })
                            ]
                        }) : null,
                        baseCareAnnual > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                baseDapDaily > 0 && dapDaily > 0 ? ', and' : '',
                                " care costs drop ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$5354fc7cb2207caf), {
                                    from: baseCareAnnual,
                                    to: planCareAnnual,
                                    unit: " a year",
                                    better: "down"
                                })
                            ]
                        }) : null,
                        "."
                    ]
                }),
                totalLeftover > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        " The ",
                        money(totalLeftover),
                        " left over stays in the bank, where Centrelink counts it and deems income on it."
                    ]
                })
            ]
        }, "room"));
        else lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                    children: [
                        "You pay nothing up front, so the whole ",
                        money(radInput),
                        " room is charged daily",
                        dapDaily > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                ", at ",
                                money(dapDaily),
                                " a day"
                            ]
                        }) : null,
                        "."
                    ]
                }),
                ' ',
                "That part works like rent and never comes back; in exchange every dollar stays where it is \u2014 available if it is needed, and still earning."
            ]
        }, "room"));
        // The other things the plan does — a sale, a loan, rent, an annuity, debts cleared — each
        // as its own line, in the words the summary already uses.
        const folded = new Set([
            'room',
            'liq',
            'dap-route',
            'money-order'
        ]);
        story.forEach((node)=>{
            const key = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(node) ? String(node.key ?? '') : '';
            if (folded.has(key)) return;
            lines.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(node) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(node, {
                key: `do-${key}`
            }) : node);
        });
        // 2. The pension.
        const pensionLine = figures.pensionDirection === 'rises' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                    children: [
                        paidTotal > 0.5 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "That ",
                                money(paidTotal),
                                " no longer counts as an asset for the Age Pension, so"
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: "Less is counted by the means tests, so"
                        }),
                        " ",
                        possessive,
                        " pension rises"
                    ]
                }),
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$5354fc7cb2207caf), {
                    from: pensionDoNothing,
                    to: pensionWithPlan,
                    unit: " a year",
                    better: "up"
                }),
                ".",
                facts.illnessSeparated ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        " (",
                        who,
                        " is assessed as part of an illness-separated couple, so each is paid at the higher single rate.)"
                    ]
                }) : null
            ]
        }) : figures.pensionDirection === 'falls' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                    children: [
                        possessive,
                        " pension falls"
                    ]
                }),
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$5354fc7cb2207caf), {
                    from: pensionDoNothing,
                    to: pensionWithPlan,
                    unit: " a year",
                    better: "up"
                }),
                ". ",
                pensionWhy
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                    children: [
                        possessive,
                        " pension stays at ",
                        money(pensionWithPlan),
                        " a year."
                    ]
                }),
                " ",
                pensionWhy
            ]
        });
        lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            children: pensionLine
        }, "pension"));
        // 3. What the money gives up by being in the deposit.
        const invBefore = facts.baselineInvestmentIncome;
        const invAfter = facts.planInvestmentIncome;
        if (invBefore != null && invAfter != null && Math.abs(Math.round(invAfter) - Math.round(invBefore)) >= 1) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            children: invAfter < invBefore ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "Less money stays invested, so investment income falls"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$5354fc7cb2207caf), {
                        from: invBefore,
                        to: invAfter,
                        unit: " a year",
                        better: "up"
                    }),
                    ". That is the cost of the plan",
                    paidTotal > 0.5 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " \u2014 along with the ",
                            money(paidTotal),
                            " being out of reach while ",
                            who,
                            " is in care"
                        ]
                    }) : null,
                    "."
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "More money stays invested, so investment income rises"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$5354fc7cb2207caf), {
                        from: invBefore,
                        to: invAfter,
                        unit: " a year",
                        better: "up"
                    }),
                    "."
                ]
            })
        }, "invest"));
        // 4. Put together: the gap, and what pays for it.
        const outlook = cashflowWithPlan != null && cashflowWithPlan < 0 ? (0, $761eebfc891b9eea$export$a3c504a65d7a0fe7)(planRunway, (0, $761eebfc891b9eea$export$ee5aafeb340c75f8)(factFind)) : null;
        lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            children: [
                cashflowWithPlan != null && cashflowWithPlan < 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                            children: [
                                "Put together, income still falls ",
                                money(Math.abs(cashflowWithPlan)),
                                " a year short"
                            ]
                        }),
                        " (paying daily, ",
                        cashflowDoNothing < 0 ? `${money(Math.abs(cashflowDoNothing))} short` : `${money(cashflowDoNothing)} to spare`,
                        ")."
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                            children: [
                                "Put together, income now covers the costs with ",
                                money(Math.abs(cashflowWithPlan ?? 0)),
                                " a year to spare"
                            ]
                        }),
                        " (paying daily, ",
                        cashflowDoNothing < 0 ? `${money(Math.abs(cashflowDoNothing))} a year short` : `${money(cashflowDoNothing)} to spare`,
                        ")."
                    ]
                }),
                moneyStory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        " ",
                        moneyStory
                    ]
                }) : moneyOrder ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        " ",
                        moneyOrder
                    ]
                }) : null,
                outlook && !moneyStory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        " ",
                        outlook.lead,
                        outlook.verdict ? ` ${outlook.verdict}` : ''
                    ]
                }) : null
            ]
        }, "gap"));
        // What each piece IS, above what it does (owner, 24 Oct 2026: "it doesnt actually explain what it is, how it works").
        const leverKinds = planPieces.map((p)=>p.key === 'annuity' ? annuityKind : $a258b04930632a82$var$PIECE_KIND[p.key]);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-5",
            "data-testid": "explain-cause-effect",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6edaae094c27058f$export$c20faa40d0e6b131), {
                    kinds: leverKinds
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                    className: "divide-y divide-slate-200",
                    children: [
                        lines.map((line, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                className: "grid grid-cols-[2.25rem_minmax(0,1fr)] gap-x-2 py-4 first:pt-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$8400747e4d4d02ee), {
                                        n: i + 1
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "min-w-0 text-[15px] leading-relaxed text-slate-700 [&_p]:m-0 [&_strong]:text-slate-900",
                                        children: line
                                    })
                                ]
                            }, i)),
                        baselineLegacy != null && planLegacy != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            className: "grid grid-cols-[2.25rem_minmax(0,1fr)] gap-x-2 border-t-2 !border-t-brand-navy py-4",
                            "data-testid": "explain-result",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$ee12a877b5edba4b), {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "min-w-0",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$48017952956cd475), {
                                        horizonYears: legacyYears,
                                        estate: planLegacy,
                                        baseEstate: baselineLegacy,
                                        baseWord: (0, $1a5a24a0286ded56$export$6ad898e84f176684).word,
                                        children: paidTotal > 0.5 && (moneyStory || !/comes back/i.test(moneyOrder || '')) || planLegacy < baselineLegacy ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                paidTotal > 0.5 && (moneyStory || !/comes back/i.test(moneyOrder || '')) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        "The deposit comes back",
                                                        stayingName ? ` to ${stayingName}` : '',
                                                        " when care ends, less what the home keeps (2% a year for up to five years \u2014 never more than 10%), which is why it sits in that figure."
                                                    ]
                                                }),
                                                planLegacy < baselineLegacy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: " That is the price of what this plan buys elsewhere: weigh it against the cashflow and pension it delivers."
                                                })
                                            ]
                                        }) : null
                                    })
                                })
                            ]
                        })
                    ]
                }),
                giftExcess > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "rounded-lg border border-slate-200/70 border-l-4 border-l-amber-500 bg-white px-3 py-2 text-sm leading-relaxed text-slate-700 shadow-sm",
                    children: [
                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(totalGifting),
                        " of the proceeds is gifted \u2014 the ",
                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(giftExcess),
                        " above the yearly free area still counts for five years under the ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                            term: "deprivation"
                        }),
                        " rules."
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1f2b2692daf0da1$export$d520641036c1ebe9), {
                    plain: true,
                    pieces: planPieces
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-[12px] leading-relaxed text-slate-500",
                    children: "Projections depend on the return, inflation, property-growth and length-of-stay assumptions behind them, so treat the direction as the message rather than the exact figure."
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$28c8139bd562d0e), {
                eyebrow: eyebrow,
                className: "mt-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "space-y-1.5 text-sm leading-relaxed text-slate-700",
                        children: story
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3 border-t border-slate-100 pt-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$e95813558e26ce51), {
                                variant: "expanded",
                                label: "Age Pension",
                                before: pensionDoNothing,
                                after: pensionWithPlan,
                                why: pensionWhy
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$e95813558e26ce51), {
                                variant: "expanded",
                                label: "Cashflow after care costs",
                                before: cashflowDoNothing,
                                after: cashflowWithPlan,
                                why: cashflowWhy
                            }),
                            baselineLegacy != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$e95813558e26ce51), {
                                variant: "expanded",
                                label: `Estate after ${legacyYears} ${legacyYears === 1 ? 'year' : 'years'}`,
                                before: baselineLegacy,
                                after: planLegacy ?? baselineLegacy,
                                suffix: "",
                                why: legacyWhy
                            })
                        ]
                    }),
                    baselineLegacy != null && planLegacy != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 text-xs leading-relaxed text-slate-600",
                        children: [
                            "Projections cannot be guaranteed, but over ",
                            legacyYears,
                            " ",
                            legacyYears === 1 ? 'year' : 'years',
                            " this plan is projected to leave",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold text-slate-900",
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(planLegacy - baselineLegacy)))
                            }),
                            ' ',
                            planLegacy >= baselineLegacy ? 'more' : 'less',
                            " to the estate than paying daily \u2014 simply paying the",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                term: "DAP"
                            }),
                            " on the whole room.",
                            planLegacy < baselineLegacy ? ' That is the price of what this plan buys elsewhere: weigh it against the cashflow and pension it delivers.' : ''
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-1 text-[11px] text-slate-400",
                        children: '"With no plan" is the doing-nothing position; "with this plan" matches the numbers on the plan.'
                    }),
                    giftExcess > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 rounded-lg border border-slate-200/70 border-l-4 border-l-amber-500 bg-white px-3 py-2 text-sm leading-relaxed text-slate-700 shadow-sm",
                        children: [
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(totalGifting),
                            " of the proceeds is gifted \u2014 the ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(giftExcess),
                            " above the yearly free area still counts for five years under the ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                term: "deprivation"
                            }),
                            " rules."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1f2b2692daf0da1$export$d520641036c1ebe9), {
                className: "mt-4",
                pieces: planPieces
            })
        ]
    });
};
var $a258b04930632a82$export$2e2bcd8739ae039 = $a258b04930632a82$var$StrategyPlanRecap;



/**
 * "Understanding your plan" / "Explain this" — the full plain-words explanation, on its own surface.
 *
 * WHY A MODAL AND NOT AN EXPANDER. The plan summary panel carries one or two sentences and must
 * always fit the screen; the full recap runs to several paragraphs plus a before→after row and a
 * reason for each of pension, cashflow and estate. An expander that long would put the scrolling
 * back inside the panel, which is the problem the panel exists to remove (owner, 2026-08-26:
 * "im having to scroll both up and down the screen to see what the hell is going on").
 *
 * Two headings (UX review, 17 Oct 2026): the modules keep "Understanding your plan"; the aged care
 * engine passes an eyebrow ("Explain this"), the plan's own words as the title, and an intro line.
 * The mock-up's eyebrow said "the way an adviser would say it"; the owner struck it on 18 Oct 2026
 * because the client-facing app must never speak of advisers. Navy, not the teal gradient, so it
 * reads as the same page and not a banner. The chrome itself is DialogShell, shared by every pop-over.
 *
 * This component is chrome ONLY. Everything inside it is the recap, unchanged and still the single
 * place that reconciles the plan in words.
 */ 
parcelRequire("acw62");
/**
 * The one dialog chrome (owner, 18 Oct 2026: "make them look really professional"; and on the first
 * attempt, "the pastel infills look old"). Every pop-over in the module — a figure's why, Explain
 * this, What could go wrong, the comparisons, the questions — wears this, so the reader meets one
 * surface, not five.
 *
 * WHAT IT IS NOT. No coloured chips, no caps eyebrow, no gradient bar, no tinted header wash, no
 * boxed cards inside: those are the template tells the owner rejected. The design is typographic —
 * a quiet one-line context above, a large navy title, one intro line, a hairline, then the content
 * set like a ledger (hairline rows, tabular figures, a heavier rule above the total). Colour is
 * reserved for meaning: navy for structure, rose and emerald only on a signed figure, amber only as
 * a thin rail beside what is about this client. Escape closes; the backdrop closes.
 */ 

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

const $1c6c21ec44833357$var$SIZE = {
    md: 'max-w-[680px]',
    lg: 'max-w-3xl',
    xl: 'max-w-5xl'
};
const $1c6c21ec44833357$export$cb63b5f03a3ae2c6 = ({ children: children, className: className = '' })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        className: `flex items-center gap-3 text-[12.5px] font-semibold text-brand-navy ${className}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "shrink-0",
                children: children
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "h-px flex-1 bg-slate-200",
                "aria-hidden": true
            })
        ]
    });
const $1c6c21ec44833357$var$DialogShell = ({ titleId: titleId, title: title, eyebrow: eyebrow, intro: intro, back: back = null, onClose: onClose, footer: footer, children: children, size: size = 'md', testId: testId, closeRef: closeRef, zIndex: zIndex = 50, flush: flush = false })=>{
    (0, $acw62.useEffect)(()=>{
        const onKey = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', onKey);
        return ()=>document.removeEventListener('keydown', onKey);
    }, [
        onClose
    ]);
    const z = zIndex === 70 ? 'z-[70]' : zIndex === 60 ? 'z-[60]' : 'z-50';
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `fixed inset-0 ${z} flex items-start justify-center overflow-y-auto bg-[#0F2A4A]/55 p-4 backdrop-blur-[3px] sm:p-8`,
        onClick: (e)=>{
            if (e.target === e.currentTarget) onClose();
        },
        role: "presentation",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": titleId,
            "data-testid": testId,
            className: `my-auto flex w-full ${$1c6c21ec44833357$var$SIZE[size]} max-h-[calc(100vh-4rem)] flex-col overflow-hidden rounded-xl bg-white shadow-[0_32px_80px_-24px_rgba(0,30,122,0.45),0_2px_6px_rgba(15,42,74,0.08)]`,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "relative shrink-0 border-b border-slate-200 px-8 pb-5 pt-7 pr-16",
                    children: [
                        back ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            onClick: back.onClick,
                            className: "mb-2 inline-flex items-center gap-1 text-[13.5px] font-semibold text-brand-navy hover:underline",
                            "data-testid": "figure-back",
                            children: [
                                "\u2039 ",
                                back.label
                            ]
                        }) : eyebrow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mb-2 text-[13.5px] leading-snug text-slate-500",
                            children: eyebrow
                        }) : null,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            id: titleId,
                            className: "text-[26px] font-bold leading-[1.15] tracking-[-0.01em] text-brand-navy",
                            children: title
                        }),
                        intro && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mt-2.5 max-w-[64ch] text-[15px] leading-relaxed text-slate-600",
                            children: intro
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            ref: closeRef,
                            onClick: onClose,
                            "aria-label": "Close",
                            className: "absolute right-6 top-6 grid h-9 w-9 place-items-center rounded-md text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-900",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 20,
                                strokeWidth: 1.75,
                                "aria-hidden": true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: `min-h-0 flex-1 overflow-y-auto ${flush ? '' : 'px-8 py-6'}`,
                    children: children
                }),
                footer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex shrink-0 flex-wrap items-center justify-end gap-3 border-t border-slate-200 px-8 py-4",
                    children: footer
                })
            ]
        })
    }), document.body);
};
var $1c6c21ec44833357$export$2e2bcd8739ae039 = $1c6c21ec44833357$var$DialogShell;


const $12084f898a868747$var$PlanExplanationModal = ({ strategyName: strategyName, onClose: onClose, children: children, footer: footer, eyebrow: eyebrow = null, title: title = 'Understanding your plan', intro: intro = null })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
        titleId: "plan-explanation-heading",
        testId: "plan-explanation",
        eyebrow: eyebrow ?? undefined,
        title: title,
        intro: intro ?? (strategyName && strategyName !== title ? strategyName : null),
        onClose: onClose,
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "[&>*]:mt-0",
            children: children
        })
    });
var $12084f898a868747$export$2e2bcd8739ae039 = $12084f898a868747$var$PlanExplanationModal;


/**
 * "What could go wrong" — the risks of one strategy, on its own surface.
 *
 * Opened from the card's button (owner, 2 Oct 2026). It reads the single risk list in
 * src/strategy/strategyRisks.ts, the same list the Statement of Advice prints, so the screen and the
 * document cannot disagree. Nothing is recorded about it being opened.
 *
 * THE LAYOUT IS THE POINT. The owner's brief: if it looks like a wall of bland text the client won't
 * focus. So: what is about THIS client comes first, in amber, because it is the part they cannot get
 * anywhere else; then one block per part of the plan, each point a bold claim with its own icon and
 * one sentence of why. Short lines, generous space, no paragraphs.
 */ 
parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $beb58fc2118025b6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ],
    [
        "path",
        {
            d: "M8 14h.01",
            key: "6423bh"
        }
    ],
    [
        "path",
        {
            d: "M12 14h.01",
            key: "1etili"
        }
    ],
    [
        "path",
        {
            d: "M16 14h.01",
            key: "1gbofw"
        }
    ],
    [
        "path",
        {
            d: "M8 18h.01",
            key: "lrp35t"
        }
    ],
    [
        "path",
        {
            d: "M12 18h.01",
            key: "mhygvu"
        }
    ],
    [
        "path",
        {
            d: "M16 18h.01",
            key: "kzsmim"
        }
    ]
];
const $beb58fc2118025b6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("calendar-days", $beb58fc2118025b6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $200392fae49ddb7e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 6v6l4 2",
            key: "mmk7yg"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
];
const $200392fae49ddb7e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("clock", $200392fae49ddb7e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $64d93451351598d0$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m18 5-2.414-2.414A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2",
            key: "142zxg"
        }
    ],
    [
        "path",
        {
            d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
            key: "2t3380"
        }
    ],
    [
        "path",
        {
            d: "M8 18h1",
            key: "13wk12"
        }
    ]
];
const $64d93451351598d0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("file-pen-line", $64d93451351598d0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0c90bba72fbdd9e9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
            key: "c3ymky"
        }
    ]
];
const $0c90bba72fbdd9e9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("heart", $0c90bba72fbdd9e9$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e20ffdae2aa9b33f$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "11",
            x: "3",
            y: "11",
            rx: "2",
            ry: "2",
            key: "1w4ew1"
        }
    ],
    [
        "path",
        {
            d: "M7 11V7a5 5 0 0 1 10 0v4",
            key: "fwvmzm"
        }
    ]
];
const $e20ffdae2aa9b33f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("lock", $e20ffdae2aa9b33f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7b97e024910b40ff$export$3efd853dbb351e94 = [
    [
        "line",
        {
            x1: "19",
            x2: "5",
            y1: "5",
            y2: "19",
            key: "1x9vlm"
        }
    ],
    [
        "circle",
        {
            cx: "6.5",
            cy: "6.5",
            r: "2.5",
            key: "4mh3h7"
        }
    ],
    [
        "circle",
        {
            cx: "17.5",
            cy: "17.5",
            r: "2.5",
            key: "1mdrzq"
        }
    ]
];
const $7b97e024910b40ff$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("percent", $7b97e024910b40ff$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cab856bf30f1b37f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
            key: "q3az6g"
        }
    ],
    [
        "path",
        {
            d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8",
            key: "1h4pet"
        }
    ],
    [
        "path",
        {
            d: "M12 17.5v-11",
            key: "1jc1ny"
        }
    ]
];
const $cab856bf30f1b37f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("receipt", $cab856bf30f1b37f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6b98cc9f5dadc552$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m17 2 4 4-4 4",
            key: "nntrym"
        }
    ],
    [
        "path",
        {
            d: "M3 11v-1a4 4 0 0 1 4-4h14",
            key: "84bu3i"
        }
    ],
    [
        "path",
        {
            d: "m7 22-4-4 4-4",
            key: "1wqhfi"
        }
    ],
    [
        "path",
        {
            d: "M21 13v1a4 4 0 0 1-4 4H3",
            key: "1rx37r"
        }
    ]
];
const $6b98cc9f5dadc552$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("repeat", $6b98cc9f5dadc552$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $888d8be60abebd94$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z",
            key: "cbrjhi"
        }
    ]
];
const $888d8be60abebd94$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("wrench", $888d8be60abebd94$export$3efd853dbb351e94);





const $5757b380cc124794$var$ICONS = {
    lock: (0, $e20ffdae2aa9b33f$export$2e2bcd8739ae039),
    receipt: (0, $cab856bf30f1b37f$export$2e2bcd8739ae039),
    home: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
    landmark: (0, $05565f19ab398c04$export$2e2bcd8739ae039),
    trendDown: (0, $e71d8988c230db1b$export$2e2bcd8739ae039),
    clock: (0, $200392fae49ddb7e$export$2e2bcd8739ae039),
    heart: (0, $0c90bba72fbdd9e9$export$2e2bcd8739ae039),
    percent: (0, $7b97e024910b40ff$export$2e2bcd8739ae039),
    users: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
    fileSignature: (0, $64d93451351598d0$export$2e2bcd8739ae039),
    repeat: (0, $6b98cc9f5dadc552$export$2e2bcd8739ae039),
    coins: (0, $9ec88f95add56de8$export$2e2bcd8739ae039),
    shield: (0, $e325251f2797f6cf$export$2e2bcd8739ae039),
    calendar: (0, $beb58fc2118025b6$export$2e2bcd8739ae039),
    wrench: (0, $888d8be60abebd94$export$2e2bcd8739ae039),
    alert: (0, $00824d397ec63c04$export$2e2bcd8739ae039)
};
const $5757b380cc124794$var$Point = ({ point: point, tone: tone, voice: voice })=>{
    const Icon = $5757b380cc124794$var$ICONS[point.icon];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
        className: "flex gap-3.5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: `mt-[3px] shrink-0 ${tone === 'amber' ? 'text-amber-600' : 'text-slate-400'}`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                    size: 17,
                    strokeWidth: 1.75,
                    "aria-hidden": true
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[14.5px] leading-relaxed text-slate-700",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: (0, $5d864ab5b3ee155d$export$ad89789727bbada3)(point.lead, voice)
                    }),
                    " ",
                    (0, $5d864ab5b3ee155d$export$ad89789727bbada3)(point.body, voice)
                ]
            })
        ]
    });
};
/** A voice from the older `possessive` prop, for callers not yet passing one. */ function $5757b380cc124794$var$voiceOf(possessive) {
    if (possessive === 'your' || !(0, $5d864ab5b3ee155d$export$879d88d360a0f068)()) return {
        you: true,
        names: 'you',
        Names: 'You',
        possessive: 'your',
        Possessive: 'Your',
        they: 'you',
        They: 'You',
        them: 'you',
        their: 'your',
        Their: 'Your',
        are: 'are',
        have: 'have',
        s: '',
        couple: false
    };
    const names = possessive.replace(/'s?$/, '');
    const plural = names.includes(' and ');
    return {
        you: false,
        names: names,
        Names: names,
        possessive: possessive,
        Possessive: possessive,
        they: 'they',
        They: 'They',
        them: 'them',
        their: 'their',
        Their: 'Their',
        are: plural ? 'are' : 'is',
        have: plural ? 'have' : 'has',
        s: plural ? '' : 's',
        couple: plural
    };
}
/** The risks, on the shared dialog chrome: amber accent, the client's own points first. */ const $5757b380cc124794$var$StrategyRisksPanel = ({ strategyName: strategyName, risks: risks, onClose: onClose, possessive: possessive = 'your', voice: given })=>{
    const voice = given ?? $5757b380cc124794$var$voiceOf(possessive);
    const total = risks.forYou.length + risks.sections.reduce((n, s)=>n + s.points.length, 0);
    const you = voice.names;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
        titleId: "strategy-risks-heading",
        testId: "strategy-risks",
        eyebrow: strategyName,
        title: "What could go wrong",
        intro: total > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                "Every plan has trade-offs. These are the ",
                total,
                " that matter for this one, so ",
                you,
                " can choose with ",
                voice.their,
                " eyes open. The same points are set out in the advice document."
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: "Nothing in this plan stands out as a particular risk. The general points are set out in the advice document."
        }),
        onClose: onClose,
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "mr-auto text-xs leading-relaxed text-slate-500",
                    children: [
                        "None of this means the plan is wrong. It means ",
                        you,
                        " should be comfortable with each point before choosing it."
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                    onClick: onClose,
                    variant: "primary",
                    size: "sm",
                    className: "shrink-0",
                    children: "Got it"
                })
            ]
        }),
        children: [
            risks.forYou.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "mb-7 border-l-[3px] border-amber-500 pl-5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                        className: "mb-3 text-[12.5px] font-semibold text-amber-800",
                        children: [
                            "For ",
                            you,
                            " specifically"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        className: "space-y-3.5",
                        children: risks.forYou.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5757b380cc124794$var$Point, {
                                point: p,
                                tone: "amber",
                                voice: voice
                            }, p.lead))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "space-y-7",
                children: risks.sections.map((section)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$cb63b5f03a3ae2c6), {
                                className: "mb-3.5",
                                children: (0, $5d864ab5b3ee155d$export$ad89789727bbada3)(section.title, voice)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "space-y-3.5",
                                children: section.points.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5757b380cc124794$var$Point, {
                                        point: p,
                                        tone: "slate",
                                        voice: voice
                                    }, p.lead))
                            })
                        ]
                    }, section.kind))
            })
        ]
    });
};
var $5757b380cc124794$export$2e2bcd8739ae039 = $5757b380cc124794$var$StrategyRisksPanel;





var $1u0KT = parcelRequire("1u0KT");


/**
 * Debt Strategy — clearing a client's debts as part of the plan, funded from the same assets as the RAD.
 *
 * WHY IT SITS ABOVE RAD FUNDING. Money spent retiring a debt is money that cannot pay a deposit, so the
 * page reads in the order the money moves: decide the debts, then see what is left to fund the room.
 * The engine runs the two in that same order (`debtPayoffPlugin` at order 3, the RAD sale at 4), so the
 * screen and the projection agree about who claims a contested dollar first.
 *
 * WHY THE POOL IS SHARED. A dollar can pay a deposit or retire a debt, not both, and the whole advice
 * is in that competition. So both cards allocate against the same asset list and each slider's ceiling
 * is what the OTHER card has left of it (`reservedByAsset`). Nothing has to be reconciled afterwards
 * because nothing can be double-allocated in the first place.
 *
 * WHY IT IS HIDDEN WHEN THERE IS NO DEBT. It would otherwise be a permanent empty card on the busiest
 * screen in the product, and an invitation to wonder what was missed.
 *
 * WHAT THIS DELIBERATELY DOES NOT DO is tell the adviser whether to clear the debt. It shows the
 * interest being paid and what the debt is secured against — the two facts that decide it — and leaves
 * the answer to the comparison, because the answer genuinely varies: an unsecured debt is dear and
 * counts against the assets test in full, a mortgage over an investment property already nets off that
 * property's assessed value, and one over an exempt family home does nothing for the means test at all.
 * The Suggestion Engine models both ways and ranks them; here the adviser models it themselves.
 */ 

var $acw62 = parcelRequire("acw62");



/**
 * Phase 1c — entity-linked liabilities and structure warnings.
 */ 



const $3bf9a60a18bad06d$var$LIQUID_ASSET_TYPES = new Set((0, $bfa4518c9dced417$export$e18ad1b53d14ba76).filter((t)=>t.isLiquid).map((t)=>t.id));
function $3bf9a60a18bad06d$export$cdbab4fc15bcd079(liability, factFind) {
    if ((0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(liability.ownership)) {
        const id = (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(liability.ownership);
        return id && id !== '__unsure__' ? id : null;
    }
    if (liability.type !== 'mortgages') return null;
    if (liability.assetLink === 'home' || liability.assetLink === 'none') {
        if (factFind.home?.ownership === 'other_entity' && factFind.home?.entityId) return factFind.home.entityId;
        return null;
    }
    const prop = (factFind.assets?.investmentProperty || []).find((p)=>String(p.id) === String(liability.assetLink));
    if (prop && (0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(prop.ownership)) return (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(prop.ownership);
    return null;
}
function $3bf9a60a18bad06d$export$ec9081b12e34149d(liability, factFind) {
    return $3bf9a60a18bad06d$export$cdbab4fc15bcd079(liability, factFind) != null;
}
function $3bf9a60a18bad06d$export$b9bd8a3a3a6e780a(factFind, { individualOnly: individualOnly = false, isPartnered: isPartnered = false } = {}) {
    const options = [
        {
            value: 'client',
            label: factFind.client?.firstName || 'Applicant 1'
        }
    ];
    if (isPartnered) {
        options.push({
            value: 'partner',
            label: factFind.partner?.firstName || 'Applicant 2'
        });
        if (!individualOnly) options.push({
            value: 'joint',
            label: 'Joint'
        });
    }
    (factFind.structures || []).forEach((structure)=>{
        options.push({
            value: (0, $1773fcf9595c5c0a$export$66d936c41d42a933)(structure.id ?? ''),
            label: structure.name?.trim() || 'Unnamed arrangement'
        });
    });
    return options;
}
function $3bf9a60a18bad06d$export$513b229c1d6f572a(typeId) {
    return $3bf9a60a18bad06d$var$LIQUID_ASSET_TYPES.has(typeId);
}
function $3bf9a60a18bad06d$export$78f08a6997809e06(factFind) {
    const warnings = [];
    const structures = factFind.structures || [];
    if (!structures.length) return warnings;
    const { possessive: possessive } = (0, $7af19dec1ba96a5f$export$5d44334005555b21)(factFind);
    (factFind.assets?.investmentProperty || []).forEach((prop)=>{
        if (!(0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(prop.ownership)) return;
        const entityId = (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(prop.ownership);
        const label = prop.description || 'Investment property';
        const balance = prop.value || 0;
        if (balance <= 0) return;
        const mortgages = factFind.liabilities?.mortgages || [];
        const hasEntityLoan = mortgages.some((m)=>$3bf9a60a18bad06d$export$cdbab4fc15bcd079(m, factFind) === entityId);
        const hasPersonalLoanOnAsset = mortgages.some((m)=>String(m.assetLink) === String(prop.id) && !(0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(m.ownership) && $3bf9a60a18bad06d$export$cdbab4fc15bcd079(m, factFind) !== entityId);
        if (!hasEntityLoan && !hasPersonalLoanOnAsset) warnings.push(`${label} is held in a trust or company but no loan is recorded against that arrangement. Add the mortgage under Ownership for that trust/company, or net worth and pension estimates may overstate ${possessive} position.`);
        else if (hasPersonalLoanOnAsset) warnings.push(`${label} is held in a trust or company but the linked mortgage is in a personal name. For accurate figures, set the loan Ownership to the same trust or company.`);
    });
    return warnings;
}


/**
 * Paying a debt out as a strategy: which debts are cleared, from which assets, and what the balance
 * sheet looks like afterwards.
 *
 * WHY THIS IS A STRATEGY AND NOT BOOKKEEPING. An unsecured debt does not reduce assessable assets, but
 * the cash sitting against it does. So clearing a $50,000 personal loan with $50,000 of cash leaves net
 * worth unmoved and takes $50,000 straight out of the assets test — worth several thousand a year of
 * Age Pension, plus the interest no longer paid, for a client who looks no poorer on paper. A secured
 * mortgage is a different case again: one over an investment property already nets off that property's
 * assessed value, so clearing it moves the means test barely at all, while one over an EXEMPT family
 * home is doing nothing for the means test and is a straight win to clear. None of that can be decided
 * by a rule of thumb — it has to be modelled both ways and compared, which is what this makes possible.
 *
 * IT DRAWS ON THE SAME ASSETS AS THE RAD, deliberately. A dollar can pay a deposit or retire a debt, not
 * both, and the whole advice is in that competition. So `funding` is the same shape the RAD allocator
 * uses and is liquidated by the same {@link liquidateRadFundingAssets}: one arithmetic, one clamp, one
 * CGT treatment. The UI is responsible for not allocating the same dollar twice; the engine clamps per
 * asset regardless and says so when it raised less than was asked for.
 *
 * CLEARING A DEBT OUTRIGHT needs no help from this module: the loan-repayment plugin reads each
 * liability's balance live and stops servicing one that reaches zero, so the instalments stop from the
 * next period on, at the client's own cadence.
 *
 * A PARTIAL PAYOFF has to decide what happens to the repayment, and {@link DebtPayoff.repaymentBasis}
 * is that decision. Keeping the instalment (the default) retires the smaller balance sooner and saves
 * interest; lowering it frees cashflow now and costs more interest over the life of the loan. Neither
 * wins universally — a client paying aged care fees may need the cashflow more than the saving — so
 * both are modelled and the suggestion engine ranks them. Until this option existed the product always
 * lowered the repayment, not by decision but because auto-calculate re-derived the instalment from the
 * reduced balance and nobody had considered the case.
 *
 * WHEN IT HAPPENS is the caller's choice, exactly as with the RAD: `debtPayoffPlugin` performs it on a
 * date inside the projection, while {@link applyDebtPayoffToFactFind} performs it at the origin for
 * callers that bake strategies into a fact-find before projecting (the suggestion engine, and the
 * frontend's before/after simulation).
 */ 

function $5a6326d9013f181c$export$9228d27a9c805655(category, liabilityId) {
    return `${category}::${liabilityId}`;
}
function $5a6326d9013f181c$export$3af2fc381bc8d0aa(key) {
    const separator = key.indexOf('::');
    if (separator <= 0) return null;
    const category = key.slice(0, separator);
    const liabilityId = key.slice(separator + 2);
    return liabilityId ? {
        category: category,
        liabilityId: liabilityId
    } : null;
}
function $5a6326d9013f181c$export$6e2ff360057e85e5(factFind, payoff) {
    const payments = payoff?.payments;
    if (!payments) return [];
    const targets = [];
    for (const [key, requested] of Object.entries(payments)){
        const parsed = $5a6326d9013f181c$export$3af2fc381bc8d0aa(key);
        if (!parsed) continue;
        const asked = Math.max(0, Number(requested) || 0);
        if (asked <= 0) continue;
        const list = factFind.liabilities?.[parsed.category];
        if (!list) continue;
        const index = list.findIndex((item)=>String(item?.id ?? '') === parsed.liabilityId);
        if (index < 0) continue;
        const liability = list[index];
        const outstanding = Math.max(0, Number(liability.balance) || 0);
        const amount = Math.min(asked, outstanding);
        if (amount <= 0) continue;
        targets.push({
            key: key,
            category: parsed.category,
            index: index,
            liability: liability,
            outstanding: outstanding,
            amount: amount
        });
    }
    return targets;
}
function $5a6326d9013f181c$export$c72b94f50a29864c(factFind, payoff) {
    return $5a6326d9013f181c$export$6e2ff360057e85e5(factFind, payoff).reduce((sum, target)=>sum + target.amount, 0);
}
/**
 * Holds a partly-repaid debt's instalment where it was, so the smaller balance clears SOONER rather
 * than the repayment falling.
 *
 * The mechanism is deliberately one the engine already has rather than a new rule: the liability is
 * switched to a MANUAL repayment carrying the instalment it was being paid at. Every later year then
 * reads that fixed figure instead of re-deriving a smaller one from the reduced balance, and the
 * repayment plugin's existing cap — an instalment is never larger than what is still owed plus that
 * period's interest — lands the final payment exactly on zero and stops. Nothing else has to know the
 * option exists.
 *
 * `outstandingBefore` is the balance as it stood BEFORE this payoff, because that is what the client's
 * current instalment was derived from. Passed in rather than read off the liability, which the caller
 * is about to reduce.
 *
 * Two cases are left alone. A debt cleared outright has no instalment to freeze, and writing one would
 * leave a repayment schedule attached to a zero balance. A debt already on a MANUAL repayment is
 * already frozen — its instalment never re-derived in the first place — so there is nothing to do.
 */ function $5a6326d9013f181c$var$freezeRepaymentAtCurrentInstalment(liability, outstandingBefore, remaining) {
    if (remaining <= 0) return;
    if (liability.repaymentCalculation !== 'auto') return;
    const rate = Number(liability.interestRate) || 0;
    const term = Number(liability.loanTerm) || 0;
    // Without a rate and a term there was never a derived instalment to hold on to; the engine would
    // have been using `repayments` already, which is frozen by definition.
    if (outstandingBefore <= 0 || rate <= 0 || term <= 0) return;
    const instalment = (0, $c9ee841cca8af175$export$1fcf7232357bf4d8)(outstandingBefore, rate, term, String(liability.frequency || 'monthly'), String(liability.loanType || 'pi'));
    if (!(instalment > 0)) return;
    liability.repaymentCalculation = 'manual';
    liability.repayments = instalment;
}
function $5a6326d9013f181c$export$6b0c927e631c7be1(factFind, payoff) {
    // Defaulting to keeping the repayment because that is what lenders do unless asked otherwise. The
    // product used to lower it — not by decision, but because auto-calculate re-derived the instalment
    // from the smaller balance and nobody had thought about the case.
    const keepsRepayment = (payoff?.repaymentBasis ?? 'keep_repayment') === 'keep_repayment';
    const paidOff = [];
    for (const target of $5a6326d9013f181c$export$6e2ff360057e85e5(factFind, payoff)){
        const remaining = target.outstanding - target.amount;
        if (keepsRepayment) $5a6326d9013f181c$var$freezeRepaymentAtCurrentInstalment(target.liability, target.outstanding, remaining);
        target.liability.balance = remaining;
        paidOff.push({
            description: String(target.liability.description || 'debt'),
            paid: target.amount,
            remaining: remaining,
            // Rounded, so a debt left owing a fraction of a cent by floating-point arithmetic still
            // reads — and is described — as cleared.
            clearedInFull: Math.round(remaining) <= 0
        });
    }
    return paidOff;
}
/**
 * Moves `amount` into the client's primary bank account (negative to take it out), creating one if
 * there is none.
 *
 * A deliberately small mirror of the engine's own `routeSurplusToBank`, which lives in a server plugin
 * this package cannot reach. Kept to the same choice of account — the first listed — so the origin-time
 * path and the dated one put the money in the same place.
 */ function $5a6326d9013f181c$var$moveThroughPrimaryBank(factFind, amount) {
    if (amount === 0) return;
    const bankAccounts = factFind.assets?.bankAccounts;
    if (bankAccounts && bankAccounts.length > 0) {
        bankAccounts[0].value = (Number(bankAccounts[0].value) || 0) + amount;
        return;
    }
    if (!factFind.assets) factFind.assets = {};
    if (!factFind.assets.bankAccounts) factFind.assets.bankAccounts = [];
    factFind.assets.bankAccounts.push({
        id: 'auto-debt-payoff',
        type: 'bankAccounts',
        description: 'Surplus Cash',
        value: amount,
        income: 0,
        incomeRate: 2,
        growthRate: 0,
        ownership: 'client'
    });
}
function $5a6326d9013f181c$export$525e306199c9748e(factFind, payoff, cgtOverrides = {}) {
    const modified = structuredClone(factFind);
    if (!payoff) return {
        factFind: modified,
        proceeds: 0,
        paidOff: [],
        totalPaid: 0
    };
    // Priced against the caller's original, which `structuredClone` has just detached — the same rule
    // the RAD sale follows, so two liquidations in one pass are each priced off what the client really
    // held rather than off what the earlier one left behind.
    const proceeds = (0, $b71b41b8944942d4$export$37e3e9e9ea12b9ea)(modified, payoff.funding, cgtOverrides, factFind);
    $5a6326d9013f181c$var$moveThroughPrimaryBank(modified, proceeds);
    const paidOff = $5a6326d9013f181c$export$6b0c927e631c7be1(modified, payoff);
    const totalPaid = paidOff.reduce((sum, row)=>sum + row.paid, 0);
    $5a6326d9013f181c$var$moveThroughPrimaryBank(modified, -totalPaid);
    return {
        factFind: modified,
        proceeds: proceeds,
        paidOff: paidOff,
        totalPaid: totalPaid
    };
}



function $35f2741dc40fa45c$export$403bb596c20e48(factFind) {
    const debts = [];
    for (const [category, list] of Object.entries(factFind.liabilities || {}))for (const liability of list || []){
        if (!liability?.id) continue;
        if (liability.type === 'reverse_mortgage') continue;
        const balance = Number(liability.balance) || 0;
        if (balance <= 0) continue;
        const interestRate = (0, $55a6490f14a54563$export$7d8ffbf26dcfd37b)(liability, category);
        const paidInFull = (0, $55a6490f14a54563$export$b0f8a46bdf3c210d)(liability, category) && (0, $55a6490f14a54563$export$ee09c2c29b17798e)(liability) === 'full';
        const isMortgage = category === 'mortgages' || liability.type === 'mortgages';
        const assetLink = String(liability.assetLink || '');
        debts.push({
            key: (0, $5a6326d9013f181c$export$9228d27a9c805655)(category, liability.id),
            description: String(liability.description || 'Debt'),
            balance: balance,
            interestRate: interestRate,
            annualInterest: balance * (interestRate / 100),
            annualRepayment: (0, $66c36853b590c88a$export$e10cf1ee911e064f)(liability),
            ...paidInFull ? {
                paidInFull: true
            } : {},
            securedAgainst: !isMortgage || !assetLink || assetLink === 'none' ? null : assetLink === 'home' ? 'home' : 'investmentProperty'
        });
    }
    return debts;
}
/**
 * The line under each debt: what holding it costs, and where that cost lands in the means test.
 *
 * Kept to facts rather than a recommendation. An adviser reading "$4,500 a year in interest, and the
 * cash held against it counts in full" has what they need to decide; being told the answer would be
 * wrong as often as it was right.
 */ function $35f2741dc40fa45c$var$debtContextLine(debt) {
    const interest = debt.paidInFull ? 'It is paid off in full each month, so it costs no interest.' : debt.interestRate > 0 ? `Holding it costs about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(debt.annualInterest))} a year in interest at ${debt.interestRate}%.` : "No interest rate recorded, so no interest cost is modelled \u2014 add one on the Liabilities step to compare properly.";
    // The means-test half, which is what makes this a strategy rather than budgeting.
    const meansTest = debt.securedAgainst === 'investmentProperty' ? " It is secured against an investment property, whose assessed value is already reduced by this debt \u2014 so clearing it moves the means test far less than an unsecured debt would." : debt.securedAgainst === 'home' ? ' It is secured against the family home. While that home is exempt, the debt is doing nothing for the means test, so clearing it with assessable cash reduces assessable assets in full.' : " It does not reduce assessable assets, but the cash held against it does \u2014 so clearing it reduces assessable assets in full.";
    return `${interest}${meansTest}`;
}
const $35f2741dc40fa45c$var$DebtPayoffStrategy = ({ factFind: factFind, debtPayments: debtPayments, setDebtPayments: setDebtPayments, debtFunding: debtFunding, setDebtFunding: setDebtFunding, repaymentBasis: repaymentBasis = 'keep_repayment', setRepaymentBasis: setRepaymentBasis, reservedByAsset: reservedByAsset = {}, reservedFor: reservedFor, competingUseNote: competingUseNote = 'The money comes from the same assets that fund the accommodation deposit, so what you spend here reduces what is left to fund the room.', variant: variant = 'card', heading: heading = 'Debts' })=>{
    const debts = (0, $acw62.useMemo)(()=>$35f2741dc40fa45c$export$403bb596c20e48(factFind), [
        factFind.liabilities
    ]);
    const liquidAssets = (0, $acw62.useMemo)(()=>(0, $bd80071df75c742b$export$a6f66b42cac1f673)(factFind), [
        factFind.assets
    ]);
    // The card does not exist for a client with no debt. Checked here rather than by the caller so the
    // rule lives with the card it governs.
    if (debts.length === 0) return null;
    const totalToRepay = debts.reduce((sum, debt)=>sum + (debtPayments[debt.key] || 0), 0);
    const totalFunded = Object.values(debtFunding).reduce((sum, amount)=>sum + (Number(amount) || 0), 0);
    // Gross, not net: share CGT is struck when the sale actually happens, so this is deliberately the
    // headline "raised" figure and the engine reports the shortfall if tax eats into it.
    const stillToFund = Math.max(0, totalToRepay - totalFunded);
    // Whether the repayment question can change anything at all — it only bites where a debt is part
    // paid and still being serviced afterwards.
    const hasPartialPayoff = debts.some((debt)=>{
        const allocated = debtPayments[debt.key] || 0;
        return allocated > 0 && allocated < debt.balance;
    });
    const repaymentsFreed = debts.filter((debt)=>(debtPayments[debt.key] || 0) >= debt.balance).reduce((sum, debt)=>sum + debt.annualRepayment, 0);
    /**
     * Spreads `amount` across the client's liquid assets, cash first, respecting what the deposit has
     * already claimed of each.
     *
     * Cash first because it is the obvious source and carries no CGT and no disposal decision — an
     * adviser paying out a loan reaches for the bank account, and having to build that by hand every
     * time was the friction. Everything it produces stays adjustable: this sets a starting point, it
     * does not lock anything.
     */ const spreadAcrossAssets = (amount)=>{
        const cashFirst = [
            ...liquidAssets
        ].sort((a, b)=>Number(b.typeId === 'bankAccounts') - Number(a.typeId === 'bankAccounts'));
        const spread = {};
        let left = amount;
        for (const asset of cashFirst){
            if (left <= 0) break;
            const room = Math.max(0, (parseFloat(String(asset.value)) || 0) - (reservedByAsset[asset.assetId] || 0));
            const take = Math.min(left, room);
            if (take <= 0) continue;
            spread[asset.assetId] = take;
            left -= take;
        }
        return spread;
    };
    /**
     * Changing what is repaid re-funds it automatically.
     *
     * The card previously left funding at zero until it was allocated by hand, so the commonest action
     * — "pay this out" — produced a card that said the repayment would come from cash while every
     * asset slider sat untouched at its opening balance. The two halves disagreed on screen. Setting a
     * default is what makes the sliders mean what the totals say.
     */ const changePayment = (key, balance, raw)=>{
        const value = Math.min(Math.max(0, parseFloat(String(raw)) || 0), balance);
        const nextPayments = {
            ...debtPayments,
            [key]: value
        };
        setDebtPayments(nextPayments);
        const nextTotal = debts.reduce((sum, debt)=>sum + (nextPayments[debt.key] || 0), 0);
        setDebtFunding(spreadAcrossAssets(nextTotal));
    };
    /**
     * A funding slider is capped at what is still NEEDED as well as at what the asset holds — so the
     * pool cannot be over-drawn for a $50,000 debt just because a $150,000 account exists. Moving one
     * slider down leaves the shortfall for another to pick up, which is the point of being able to
     * change them at all.
     */ const changeFunding = (assetId, availableHere, raw)=>{
        const asked = Math.max(0, parseFloat(String(raw)) || 0);
        const fundedElsewhere = Object.entries(debtFunding).filter(([key])=>key !== assetId).reduce((sum, [, amount])=>sum + (Number(amount) || 0), 0);
        const roomLeftToFund = Math.max(0, totalToRepay - fundedElsewhere);
        setDebtFunding((prev)=>({
                ...prev,
                [assetId]: Math.min(asked, availableHere, roomLeftToFund)
            }));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: variant === 'section' ? 'mt-5 border-t border-slate-200 pt-4' : 'bg-white rounded-xl shadow-md p-6 mb-6',
        "data-testid": "debts-section",
        children: [
            variant === 'section' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[13px] font-bold text-brand-navy mb-1",
                children: heading
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "text-xl font-bold text-gray-800 mb-1",
                children: heading
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-sm text-gray-600 mb-2",
                children: [
                    "Clear some or all of ",
                    factFind.client?.firstName || 'the client',
                    "'s debts as part of this plan.",
                    ' ',
                    competingUseNote
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-sm text-gray-600 mb-5",
                children: [
                    "Clearing a debt does not change",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "your net worth"
                    }),
                    " \u2014 the cash goes and so does what you owed. What it changes is",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "the amount assessed for the Age Pension and aged care means tests"
                    }),
                    ", because the cash was counted and the debt mostly was not. That is why the figures beside this can move while your net worth stands still."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "space-y-5",
                children: debts.map((debt)=>{
                    // A card paid off in full each month is a monthly bill, not a decision (strategy/debtsToTest.ts,
                    // 26 Oct 2026): named, with nothing to move.
                    if (debt.paidInFull) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "border border-slate-200 rounded-lg p-4",
                        "data-testid": "debt-paid-in-full",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-baseline justify-between gap-3 flex-wrap",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-semibold text-gray-800",
                                        children: debt.description
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(debt.balance),
                                            " this month"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-gray-700 mt-2",
                                children: "Paid off in full each month \u2014 nothing to decide."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-xs text-gray-500 mt-1",
                                children: "It costs no interest, and the spending is already in the living costs, so it isn't part of the plan."
                            })
                        ]
                    }, debt.key);
                    const allocated = debtPayments[debt.key] || 0;
                    const clearsInFull = allocated >= debt.balance;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "border border-slate-200 rounded-lg p-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-baseline justify-between gap-3 flex-wrap",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-semibold text-gray-800",
                                        children: debt.description
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(debt.balance),
                                            " owing",
                                            debt.interestRate > 0 ? ` at ${debt.interestRate}%` : ''
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-2 mt-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "range",
                                        min: "0",
                                        max: debt.balance,
                                        value: allocated,
                                        onChange: (e)=>changePayment(debt.key, debt.balance, e.target.value),
                                        "aria-label": `Amount to repay off ${debt.description}`,
                                        className: "w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-teal-600"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "w-36",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                            value: allocated || 0,
                                            onChange: (v)=>changePayment(debt.key, debt.balance, v),
                                            placeholder: "0",
                                            className: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>changePayment(debt.key, debt.balance, clearsInFull ? 0 : debt.balance),
                                        className: `px-3 py-2 text-sm font-semibold rounded-lg whitespace-nowrap transition-colors ${clearsInFull ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`,
                                        children: clearsInFull ? 'Paying out' : 'Pay out'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-xs text-gray-500 mt-2",
                                children: $35f2741dc40fa45c$var$debtContextLine(debt)
                            }),
                            allocated > 0 && !clearsInFull && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-xs text-gray-600 mt-1",
                                children: [
                                    "Part payment: ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(debt.balance - allocated),
                                    " stays owing and is still serviced."
                                ]
                            })
                        ]
                    }, debt.key);
                })
            }),
            hasPartialPayoff && setRepaymentBasis && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: "mt-5 flex items-start gap-3 p-3 bg-slate-50 border border-slate-200 rounded-lg cursor-pointer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "checkbox",
                        checked: repaymentBasis === 'keep_repayment',
                        onChange: (e)=>setRepaymentBasis(e.target.checked ? 'keep_repayment' : 'lower_repayment'),
                        className: "mt-0.5 h-4 w-4 accent-teal-600"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-sm text-gray-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold",
                                children: "Keep the repayment the same and clear the debt sooner"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "block text-xs text-gray-500 mt-0.5",
                                children: repaymentBasis === 'keep_repayment' ? 'What most lenders do unless asked otherwise. The balance is retired earlier and less interest is paid.' : "Unticked: the repayment is lowered over the remaining term instead. That frees cashflow now and costs more interest overall \u2014 which can be the better trade when care fees are tight."
                            })
                        ]
                    })
                ]
            }),
            totalToRepay > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "font-semibold text-gray-800 mb-1",
                        children: "Funded from"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-xs text-gray-500 mb-3",
                        children: [
                            "Cash is used first by default. Lower a slider to draw on a different asset instead \u2014 each one stops at ",
                            reservedFor ? `whatever ${reservedFor} has left of it` : 'what it holds',
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "space-y-4",
                        children: liquidAssets.map((asset)=>{
                            const assetValue = parseFloat(String(asset.value)) || 0;
                            const reserved = reservedByAsset[asset.assetId] || 0;
                            const availableHere = Math.max(0, assetValue - reserved);
                            const allocated = debtFunding[asset.assetId] || 0;
                            // The slider stops at whatever is smaller: what this asset holds, or what
                            // is still needed. Selling $150,000 to repay a $50,000 debt is not a
                            // position anyone means to model, and the handler refuses it either way —
                            // this is what stops the TRACK offering it in the first place.
                            const fundedElsewhere = totalFunded - allocated;
                            const sliderMax = Math.min(availableHere, Math.max(0, totalToRepay - fundedElsewhere));
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "block text-sm font-medium text-gray-700",
                                        children: asset.description || asset.typeName
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "range",
                                                min: "0",
                                                max: sliderMax,
                                                value: allocated,
                                                onChange: (e)=>changeFunding(asset.assetId, availableHere, e.target.value),
                                                "aria-label": `Amount of ${asset.description || asset.typeName} to sell for debt repayment`,
                                                className: "w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-teal-600"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-36",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                    value: allocated || 0,
                                                    onChange: (v)=>changeFunding(asset.assetId, availableHere, v),
                                                    placeholder: "0",
                                                    className: ""
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "text-xs text-gray-500 mt-1",
                                        children: [
                                            "Available: ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(availableHere),
                                            reserved > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "text-gray-400",
                                                children: [
                                                    ' ',
                                                    "(",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(reserved),
                                                    " allocated to the deposit)"
                                                ]
                                            }),
                                            sliderMax < availableHere && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "text-gray-400",
                                                children: [
                                                    ' ',
                                                    "\xb7 capped at the ",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(totalToRepay),
                                                    " being repaid"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, asset.assetId);
                        })
                    })
                ]
            }),
            totalToRepay > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-5 pt-4 border-t border-slate-200 space-y-1 text-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Total debt repaid:"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold",
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(totalToRepay)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Raised from assets:"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold",
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(totalFunded)
                            })
                        ]
                    }),
                    repaymentsFreed > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-between text-teal-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Repayments no longer paid:"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "font-semibold",
                                children: [
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(repaymentsFreed)),
                                    " a year"
                                ]
                            })
                        ]
                    }),
                    stillToFund > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-amber-700 text-xs pt-1",
                        children: [
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(stillToFund),
                            " of this repayment is not covered by selling an asset. It comes out of the cash on hand, and anything still short is drawn from savings during the year, like any other cost."
                        ]
                    })
                ]
            })
        ]
    });
};
var $35f2741dc40fa45c$export$2e2bcd8739ae039 = $35f2741dc40fa45c$var$DebtPayoffStrategy;


/**
 * WHICH DEBTS THE ENGINES TEST CLEARING — one rule for all six modules (owner, 26 Oct 2026).
 *
 * Until then every module tested clearing the debts only once they added up to $5,000, on the reasoning
 * that a smaller payoff moves the Age Pension by too little to change a ranking (the assets-test taper on
 * $5,000 is about $390 a year). That counted the pension and forgot the interest: a $4,000 card at 21%
 * costs about $840 a year, more than twice that, and clearing it from a bank account earning a few per
 * cent almost always wins — yet no card ever said so.
 *
 * So, now:
 *  - A credit card paid off in full every month is NOT a debt to decide about. It costs no interest and
 *    next month brings a new balance paid from the same account; "clearing" it would only make the cash
 *    Centrelink counts look permanently smaller, a pension gain that never happens. It stays counted as
 *    owed (a month's bill) in today's figures and the projection (creditCards.ts), but no plan clears it.
 *  - A debt that costs interest (a card on the minimum, a set amount or "not sure"; a personal loan; a
 *    mortgage with a rate) is ALWAYS tested, whatever its size.
 *  - A debt that costs no interest (0%, interest-free) is tested only when such debts reach
 *    ZERO_INTEREST_DEBT_FLOOR together, because the Age Pension is then the only gain.
 *
 * The engines keep their existing twins (every plan, also with these debts cleared), so a client with a
 * small interest-bearing card costs the same to analyse as one with a large debt already did.
 */ const $485d903040fc3504$export$fe12727427ec68c1 = 5000;
function $485d903040fc3504$export$718566aeb53e1efe(debts) {
    const decidable = debts.filter((d)=>!d.paidInFull && d.balance > 0);
    const interestFree = decidable.filter((d)=>!(d.interestRate > 0));
    const interestFreeTotal = interestFree.reduce((sum, d)=>sum + d.balance, 0);
    return interestFreeTotal >= $485d903040fc3504$export$fe12727427ec68c1 ? decidable : decidable.filter((d)=>d.interestRate > 0);
}
function $485d903040fc3504$export$6944ed359535e638(debts) {
    return debts.filter((d)=>d.paidInFull && d.balance > 0);
}
function $485d903040fc3504$export$8a770cd4c4b536eb(debts) {
    const cards = $485d903040fc3504$export$6944ed359535e638(debts);
    if (cards.length === 0) return null;
    const names = cards.map((c)=>String(c.description || 'credit card').trim() || 'credit card');
    const list = names.length === 1 ? names[0] : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
    return cards.length === 1 ? `The ${list} is paid off in full each month, so it costs no interest and isn't part of the plan.` : `The ${list} are paid off in full each month, so they cost no interest and aren't part of the plan.`;
}





/**
 * The just-in-time "how would new money be invested?" question — ONE card, rendered identically by
 * every module's suggestion engine.
 *
 * The answer is an INPUT to the modelling (invest strategies price at it), so each module shows
 * this BEFORE its engine runs, not as a disclosure after a ranking that would reshuffle on the
 * answer. The caller owns the gating condition (only when the run would actually invest money,
 * only while unanswered) and the two exits:
 *   - onAnswer(profile): save to the client record (goals.newMoneyInvestmentProfile) — asked at
 *     most once, ever, across every module;
 *   - onSkip(): run at Conservative WITHOUT recording an answer, so the question re-offers next
 *     time. "Chose Conservative" and "never answered" are different provenance.
 */ 
parcelRequire("acw62");


const $1a08e2ea281a6041$var$NewMoneyProfileGate = ({ onAnswer: onAnswer, onSkip: onSkip, contextLine: contextLine })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-3 rounded-xl bg-white border border-slate-200/70 border-l-4 border-l-blue-500 p-4 shadow-sm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-sm font-semibold text-gray-900",
                children: "One quick question before I model your options"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-sm text-slate-700 mt-1.5",
                children: [
                    contextLine || "Some of the strategies I\u2019ll compare invest money that gets freed up \u2014 for example after selling your home.",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "How would that money be invested?"
                    }),
                    " Pick the approach that feels right; if you're not sure, skip and I'll assume Conservative, the most cautious option."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-3 flex flex-wrap gap-2",
                children: (0, $0f2c0a6799fe36da$export$56315028e4277c0c).map((id)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>onAnswer(id),
                        className: "px-3 py-1.5 rounded-lg border border-slate-300 bg-white text-sm font-medium text-slate-700 hover:border-blue-500 hover:text-blue-700 transition-colors",
                        children: (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[id].label
                    }, id))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 pt-3 border-t border-slate-200 flex items-center justify-between gap-3 flex-wrap",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-slate-500",
                        children: "Your choice is saved to the client profile, so you'll only be asked once \u2014 and you can change it there any time."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        size: "sm",
                        onClick: onSkip,
                        children: "Skip \u2014 assume Conservative for now"
                    })
                ]
            })
        ]
    });
var $1a08e2ea281a6041$export$2e2bcd8739ae039 = $1a08e2ea281a6041$var$NewMoneyProfileGate;


/**
 * The strategy card's Annual Snapshot — six figures, each carrying its own explanation.
 *
 * WHY THIS EXISTS. The six numbers had hover tooltips with the calculation, but the PLAIN-WORDS
 * explanation of each figure lived only in the closable Insight Panel — and a client who closed it
 * (2026-08-20) had no way back to "why is the pension higher here?". Owner's direction (2026-08-24):
 * combine the two — a tap opens the WHY in client-friendly words, with the CALCULATION one layer
 * deeper for whoever wants to audit the arithmetic. The hover tooltips went on 18 Oct 2026 (owner: two copies of the same
 * rows); the tap layer is the one path, and it works on the iPads advisers demo on.
 *
 * The words are TRANSPOSED from the Insight Panel's own vetted narratives (illness-separated
 * couple, the basic daily fee, the deposit trade) — not new content. The calculation layer renders
 * the SAME breakdown arrays the tooltips show (`agePensionBreakdown`, `agedCareBreakdown`,
 * `taxBreakdown`), so the two layers can never disagree.
 *
 * Frame discipline (learned the hard way on the walk-in note, 2026-08-24): every number quoted in
 * a why is this card's own snapshot figure. No second assessment frame is ever mixed in.
 */ 


var $acw62 = parcelRequire("acw62");



/**
 * The line under a tile: the walk-in figure and the change, coloured by whether the move is good —
 * up is good for money in, down is good for money out.
 */ const $723f95d7e9f568b1$var$WalkIn = ({ value: value, baseline: baseline, upIsGood: upIsGood })=>{
    if (baseline == null) return null;
    const d = value - baseline;
    const flat = Math.round(d) === 0;
    const good = upIsGood ? d > 0 : d < 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        className: "mt-1 text-[13px] tabular-nums text-slate-500",
        children: [
            "walk-in ",
            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(baseline),
            " \xb7",
            ' ',
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: `font-semibold ${flat ? 'text-slate-400' : good ? 'text-emerald-700' : 'text-rose-700'}`,
                children: flat ? 'no change' : `${d > 0 ? '+' : '\u2212'}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(d))}`
            })
        ]
    });
};
function $723f95d7e9f568b1$export$531f4fd3a5e7a379(snapshot) {
    return [
        {
            label: 'Daily Cost',
            value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round((Number(snapshot.totalAgedCareCosts) || 0) / 365))
        },
        {
            label: 'Annual Cost',
            value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(snapshot.totalAgedCareCosts) || 0)
        },
        {
            label: '--- Breakdown ---',
            value: ''
        },
        ...snapshot.agedCareBreakdown || []
    ];
}
function $723f95d7e9f568b1$export$fc6e499ea9fff926(key, ctx) {
    switch(key){
        case 'pension':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "Money paid as a room deposit is ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "exempt from the assets test"
                    }),
                    ", so the assets Centrelink counts fall by whatever this strategy pays up front \u2014 that is why the pension can rise.",
                    ctx.isCouple && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " And when one partner enters residential care, Centrelink assesses you as an",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                term: "illness-separated couple"
                            }),
                            " \u2014 higher thresholds than a couple at home, so a higher figure than the Dashboard shows is expected here."
                        ]
                    })
                ]
            });
        case 'invest':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "What the money ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "not"
                    }),
                    " used for the deposit keeps earning. A bigger deposit cuts this line but lifts the pension and shrinks the daily room charge \u2014 that is the trade every card on this page is weighing."
                ]
            });
        case 'living':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: "Your adjusted living expenses from the top of this page. The same figure sits in every card, so the cards differ only by strategy \u2014 never by lifestyle assumptions."
            });
        case 'care':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "The ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                        term: "basic daily fee"
                    }),
                    " applies to everyone \u2014 it is 85% of the single Age Pension and covers meals, cleaning, laundry and utilities. The means assessment can add the",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                        term: "Hotelling Supplement Contribution"
                    }),
                    " and the ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                        term: "NCCC"
                    }),
                    ". The accommodation charge applies only to the part of the room this strategy leaves unpaid \u2014 it is the one fee a deposit changes.",
                    ctx.protectedPersonHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " The means-tested care contribution is kept down here because a",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                term: "protected person"
                            }),
                            " lives in the home, keeping it out of the means test."
                        ]
                    })
                ]
            });
        case 'tax':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: "At these income levels the seniors tax offsets usually reduce tax to little or nothing, and a figure shown as a refund means franking credits came back. The calculation shows exactly how this figure was struck."
            });
        case 'cf':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: "Money in (the pension and investment income) minus money out (care and living costs). When it is negative, the gap is drawn from savings \u2014 the note under these tiles says when they run low and what pays for care after that."
            });
    }
}
const $723f95d7e9f568b1$var$AnnualSnapshot = ({ strategy: strategy, agedCareCosts: agedCareCosts, factFind: factFind, baseline: baseline = null, openRequest: openRequest = null })=>{
    const [openTile, setOpenTile] = (0, $acw62.useState)(null);
    const [showCalc, setShowCalc] = (0, $acw62.useState)(false);
    /** The cashflow pop-over has a second page — how the tax is worked out — reached from its tax line. */ const [taxPage, setTaxPage] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!openRequest) return;
        setOpenTile(openRequest.tile);
        setShowCalc(true);
        setTaxPage(false);
    }, [
        openRequest
    ]);
    const snapshot = strategy.snapshot || {};
    const netCashflow = Number(snapshot.netCashflow ?? 0);
    const taxPayable = Number(snapshot.taxPayable ?? 0);
    // An entered $0 is $0 (livingExpenses.ts; owner-caught 9 Oct 2026: the tile read "$25,000" on a card whose cashflow used $0).
    const livingExpenses = (0, $1b5ad53cec30af73$export$6be0003f148d19de)(snapshot.livingExpenses) ?? (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(agedCareCosts.scenarioLivingExpenses, factFind.expenses?.livingExpenses);
    const investmentIncomeGross = (Number(snapshot.abpIncome) || 0) + (Number(snapshot.rentalIncome) || 0) + (Number(snapshot.otherInvestmentIncome) || 0);
    /*
     * RENTAL EXPENSES (owner: "this is important", 2026-09-22). A strategy that rents the family home
     * earns the rent inside investment income but pays the expenses out of it, and the expenses had
     * no tile — so the six tiles were that amount apart from the net. The tile now shows the income
     * NET of the rental expenses and says so, and the calculation lists both, so the tiles add up.
     */ const rentalExpenses = Number(snapshot.rentalExpenses) || 0;
    const investmentIncome = investmentIncomeGross - rentalExpenses;
    const isCouple = factFind.adviceFor === 'couple';
    const protectedPersonHome = (0, $8d8b97815ba787de$export$a4f0fcc41e754c67)(factFind, {});
    const hasPartiallyLiquidatedABP = !!strategy.radFunding && Object.values(strategy.radFunding).some((liquidations)=>Array.isArray(liquidations) ? liquidations.some((l)=>l?.assetType === 'accountBasedPensions' && (parseFloat(String(l?.amount)) || 0) > 0) : liquidations?.assetType === 'accountBasedPensions' && (parseFloat(String(liquidations?.amount)) || 0) > 0);
    // In the client's words (UX review, 17 Oct 2026): money in, then money out, then what is left — the
    // same seven figures the engine returns, relabelled. The tax line's sign says what it is.
    const cashflowRows = [
        {
            label: '--- Money in ---',
            value: ''
        },
        {
            label: 'Age Pension',
            value: '+' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(snapshot.pension) || 0)
        },
        {
            label: 'Income from the account-based pensions',
            value: '+' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(snapshot.abpIncome) || 0)
        },
        {
            label: 'Other investment income',
            value: '+' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(snapshot.otherInvestmentIncome) || 0)
        },
        ...rentalExpenses > 0 ? [
            {
                label: 'Less: rental expenses',
                value: '-' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(rentalExpenses)
            }
        ] : [],
        ...taxPayable < 0 ? [
            {
                label: 'Tax refund (franking credits come back)',
                value: '+' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(taxPayable))
            }
        ] : [],
        {
            label: '--- Money out ---',
            value: ''
        },
        {
            label: 'Care costs',
            value: '-' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(snapshot.totalAgedCareCosts) || 0)
        },
        {
            label: 'Living costs at home',
            value: '-' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(snapshot.livingExpenses) || 0)
        },
        ...taxPayable > 0 ? [
            {
                label: 'Tax',
                value: '-' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(taxPayable)
            }
        ] : [],
        ...taxPayable === 0 ? [
            {
                label: 'Tax',
                value: '$0'
            }
        ] : [],
        {
            label: netCashflow >= 0 ? 'Left over each year' : 'Each year, short by',
            value: (netCashflow >= 0 ? '+' : '') + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(netCashflow)
        }
    ];
    const careRows = $723f95d7e9f568b1$export$531f4fd3a5e7a379(snapshot);
    /** The calculation layer per tile — the exact same rows the hover tooltip shows. */ const calcRows = {
        pension: snapshot.agePensionBreakdown || [
            {
                label: 'No breakdown available for this card.',
                value: ''
            }
        ],
        invest: [
            {
                label: 'ABP Income',
                value: '+' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(snapshot.abpIncome) || 0)
            },
            {
                label: 'Rental Income',
                value: '+' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(snapshot.rentalIncome) || 0)
            },
            {
                label: 'Other Investment Income',
                value: '+' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(snapshot.otherInvestmentIncome) || 0)
            },
            {
                label: 'Total',
                value: '+' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(investmentIncome)
            }
        ],
        living: [
            {
                label: 'Adjusted annual living expenses (set at the top of this page)',
                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(livingExpenses)
            }
        ],
        care: careRows,
        tax: snapshot.taxBreakdown || [
            {
                label: 'No tax payable.',
                value: ''
            }
        ],
        cf: cashflowRows
    };
    const whyFor = (key)=>$723f95d7e9f568b1$export$fc6e499ea9fff926(key, {
            isCouple: isCouple,
            protectedPersonHome: protectedPersonHome
        });
    const toggleTile = (key)=>{
        setShowCalc(false);
        setOpenTile((current)=>current === key ? null : key);
    };
    /*
     * TILES THAT SHOW THEIR DIRECTION (owner, 2026-09-01: "this screen looks very bla").
     *
     * Six identical grey boxes made money coming IN look exactly like money going OUT, so the reader
     * had to parse a plus or minus sign on every figure to work out which was which. The tint and the
     * top rule now carry the direction, the figure is set larger in tabular numerals so the column
     * scans down, and the NET result - the one figure that answers "can this be afforded" - is set
     * apart from its six inputs rather than being the sixth identical box.
     *
     * Colour is never the only signal: the sign stays on every figure, and the labels are unchanged.
     */ const TONES = {
        // White tiles (owner, 22 Sep 2026): the coloured rule and the coloured figure already say what
        // each tile means; a pastel fill said it a third time and six of them read as a patchwork.
        in: {
            base: 'bg-white border-slate-200',
            rule: 'bg-emerald-400',
            value: 'text-emerald-700'
        },
        out: {
            base: 'bg-white border-slate-200',
            rule: 'bg-rose-400',
            value: 'text-rose-700'
        },
        net: {
            base: 'bg-white border-slate-200',
            rule: 'bg-blue-500',
            value: 'text-slate-900'
        }
    };
    const tileClass = (key, tone = 'in')=>`relative overflow-hidden rounded-xl border p-3 pt-3.5 text-center cursor-pointer transition-all ` + `hover:-translate-y-px hover:shadow-sm ${TONES[tone].base} ` + `${openTile === key ? 'ring-2 ring-blue-500 ring-offset-1' : ''}`;
    const Rule = ({ tone: tone })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            "aria-hidden": "true",
            className: `absolute inset-x-0 top-0 h-1 ${TONES[tone].rule}`
        });
    const valueClass = (tone)=>`mt-0.5 text-[19px] font-bold tabular-nums leading-tight ${TONES[tone].value}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mb-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-baseline justify-between gap-3 flex-wrap mb-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "text-lg font-semibold text-gray-800",
                        children: "Annual Snapshot"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-[13px] text-gray-500",
                        children: "A normalised year"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mb-3 text-[13px] text-gray-500",
                children: [
                    "A full 12 months with this plan in place, so every strategy compares like for like. It is not the first financial year, which starts today and is shorter \u2014 ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "Explain this"
                    }),
                    " has the year-by-year figures. ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "Tap any tile for its why."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-2 md:grid-cols-3 gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: tileClass('pension', 'in'),
                        onClick: ()=>toggleTile('pension'),
                        role: "button",
                        tabIndex: 0,
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                toggleTile('pension');
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mb-1 text-sm font-medium text-gray-600",
                                children: "Est. Age Pension"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Rule, {
                                tone: "in"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                                className: valueClass('in'),
                                children: [
                                    "+ ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(snapshot.pension) || 0)
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($723f95d7e9f568b1$var$WalkIn, {
                                value: Number(snapshot.pension) || 0,
                                baseline: baseline?.pension,
                                upIsGood: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: tileClass('invest', 'in'),
                        onClick: ()=>toggleTile('invest'),
                        role: "button",
                        tabIndex: 0,
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                toggleTile('invest');
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-sm font-medium text-gray-600 mb-1",
                                children: "Investment Income"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Rule, {
                                tone: "in"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                                className: valueClass('in'),
                                children: [
                                    "+ ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(investmentIncome)
                                ]
                            }),
                            rentalExpenses > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-1 text-[13px] text-gray-500",
                                children: [
                                    "after ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(rentalExpenses),
                                    " of rental expenses"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($723f95d7e9f568b1$var$WalkIn, {
                                value: investmentIncome,
                                baseline: baseline?.investmentIncome,
                                upIsGood: true
                            }),
                            hasPartiallyLiquidatedABP && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-xs text-gray-500 mt-1 italic",
                                children: "* ABP income recalculated based on minimum drawdown for remaining balance"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: tileClass('living', 'out'),
                        onClick: ()=>toggleTile('living'),
                        role: "button",
                        tabIndex: 0,
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                toggleTile('living');
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-sm font-medium text-gray-600 mb-1",
                                children: "Living Expenses"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Rule, {
                                tone: "out"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                                className: valueClass('out'),
                                children: [
                                    "- ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(livingExpenses)
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($723f95d7e9f568b1$var$WalkIn, {
                                value: livingExpenses,
                                baseline: baseline?.livingExpenses,
                                upIsGood: false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: tileClass('care', 'out'),
                        onClick: ()=>toggleTile('care'),
                        role: "button",
                        tabIndex: 0,
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                toggleTile('care');
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mb-1 text-sm font-medium text-gray-600",
                                children: "Total Aged Care Costs"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Rule, {
                                tone: "out"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                                className: valueClass('out'),
                                children: [
                                    "- ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(snapshot.totalAgedCareCosts) || 0)
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($723f95d7e9f568b1$var$WalkIn, {
                                value: Number(snapshot.totalAgedCareCosts) || 0,
                                baseline: baseline?.careCosts,
                                upIsGood: false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: tileClass('tax', taxPayable < 0 ? 'in' : 'out'),
                        onClick: ()=>toggleTile('tax'),
                        role: "button",
                        tabIndex: 0,
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                toggleTile('tax');
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mb-1 text-sm font-medium text-gray-600",
                                children: "Income Tax"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Rule, {
                                tone: taxPayable < 0 ? 'in' : 'out'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                                className: valueClass(taxPayable < 0 ? 'in' : 'out'),
                                children: [
                                    taxPayable < 0 ? '+' : '-',
                                    " ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(taxPayable)),
                                    taxPayable < 0 ? ' (refund)' : ''
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($723f95d7e9f568b1$var$WalkIn, {
                                value: taxPayable,
                                baseline: baseline?.taxPayable,
                                upIsGood: false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: tileClass('cf', 'net'),
                        onClick: ()=>toggleTile('cf'),
                        role: "button",
                        tabIndex: 0,
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                toggleTile('cf');
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mb-1 text-sm font-medium text-gray-600",
                                children: "Net Annual Cashflow"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Rule, {
                                tone: "net"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                className: `mt-0.5 text-[22px] font-bold tabular-nums leading-tight ${netCashflow >= 0 ? 'text-emerald-700' : 'text-rose-700'}`,
                                children: (netCashflow >= 0 ? '+' : '') + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(netCashflow)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-0.5 text-[13px] font-medium text-slate-500",
                                children: netCashflow >= 0 ? 'a year left over' : 'a year short'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($723f95d7e9f568b1$var$WalkIn, {
                                value: netCashflow,
                                baseline: baseline?.netCashflow,
                                upIsGood: true
                            })
                        ]
                    })
                ]
            }),
            openTile && /* White with a blue rail, not a pastel fill (owner, 17 Oct 2026). */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 rounded-xl border border-slate-200 border-l-4 border-l-blue-500 bg-white px-4 py-3 shadow-card",
                "data-testid": `snapshot-why-${openTile}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-start justify-between gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm leading-relaxed text-slate-700",
                                children: taxPage && openTile === 'cf' ? whyFor('tax') : whyFor(openTile)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    setShowCalc(false);
                                    setTaxPage(false);
                                    setOpenTile(null);
                                },
                                "aria-label": "Close",
                                className: "shrink-0 rounded-md border border-slate-200 bg-white px-2 py-0.5 text-xs font-semibold text-slate-600 hover:bg-slate-50",
                                children: "Close"
                            })
                        ]
                    }),
                    showCalc ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-2 rounded-lg border border-slate-200 bg-white px-3 py-2",
                        children: [
                            taxPage && openTile === 'cf' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            setTaxPage(false);
                                        },
                                        className: "mb-1 border-0 bg-transparent p-0 text-xs font-semibold text-blue-700 underline decoration-dotted underline-offset-2 cursor-pointer hover:text-blue-900",
                                        children: "\u2039 Back to the cashflow"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1",
                                        children: "How the tax is worked out"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1",
                                children: "The calculation"
                            }),
                            (taxPage && openTile === 'cf' ? calcRows.tax : calcRows[openTile]).map((row, index)=>{
                                const isTaxLine = openTile === 'cf' && !taxPage && /^tax\b/i.test(String(row.label));
                                const isHeading = String(row.label).startsWith('---');
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: `flex justify-between gap-4 py-0.5 text-xs ${isHeading ? 'mt-1.5 border-t border-slate-100 pt-1.5' : ''}`,
                                    children: [
                                        isHeading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-[11px] font-semibold uppercase tracking-wide text-slate-500",
                                            children: String(row.label).replace(/-/g, '').trim()
                                        }) : isTaxLine ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            onClick: (e)=>{
                                                e.stopPropagation();
                                                setTaxPage(true);
                                            },
                                            className: "border-0 bg-transparent p-0 text-left text-xs font-semibold text-blue-700 underline decoration-dotted underline-offset-2 cursor-pointer hover:text-blue-900",
                                            children: [
                                                row.label,
                                                " \u2014 see how it is worked out \u203A"
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-slate-600",
                                            children: row.label
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold text-slate-900 tabular-nums",
                                            children: String(row.value ?? '')
                                        })
                                    ]
                                }, `${row.label}-${index}`);
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    setShowCalc(false);
                                    setTaxPage(false);
                                },
                                className: "mt-2 border-0 bg-transparent p-0 text-xs font-semibold text-blue-700 underline decoration-dotted underline-offset-2 cursor-pointer hover:text-blue-900",
                                children: "\u2039 Hide the calculation"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: (e)=>{
                            e.stopPropagation();
                            setShowCalc(true);
                        },
                        className: "mt-1.5 border-0 bg-transparent p-0 text-xs font-semibold text-blue-700 underline decoration-dotted underline-offset-2 cursor-pointer hover:text-blue-900",
                        children: "Show the calculation \u203A"
                    })
                ]
            })
        ]
    });
};
var $723f95d7e9f568b1$export$2e2bcd8739ae039 = $723f95d7e9f568b1$var$AnnualSnapshot;


/**
 * The four numbers from step 2, as a strip across the top of step 3 (UX review, 17 Oct 2026).
 *
 * STRIP, NOT RAIL (owner decision, 17 Oct 2026). In engine mode the right-hand rail repeated step 2's
 * position in different words beside every plan. The same four figures, once, across the top, with
 * the words step 2 used, so a plan's "+$61,507 vs doing nothing" has its comparison in view without a
 * second column. Manual Control keeps its rail: there the figures move as each slider is dragged.
 */ 
parcelRequire("acw62");

const $ac9505651d2e4510$var$Cell = ({ label: label, value: value, unit: unit, note: note, tone: tone = 'neutral', large: large = false })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `${large ? 'px-5 py-5' : 'px-4 py-3.5'} first:pl-5 last:pr-5 border-slate-200 md:border-l md:first:border-l-0`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: `${large ? 'text-[13px]' : 'text-[12px]'} font-semibold text-slate-500`,
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: `mt-0.5 ${large ? 'text-[28px]' : 'text-[22px]'} font-bold leading-none tabular-nums tracking-tight ${tone === 'good' ? 'text-emerald-700' : tone === 'bad' ? 'text-rose-700' : 'text-slate-900'}`,
                children: [
                    value,
                    unit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ml-1 text-[12px] font-semibold text-slate-500",
                        children: unit
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-1 text-[12px] text-slate-500",
                children: note
            })
        ]
    });
const $ac9505651d2e4510$var$DoNothingStrip = ({ careDaily: careDaily, careAnnual: careAnnual, enteringName: enteringName, pension: pension, pensionToday: pensionToday = null, cashflowAfterCare: cashflowAfterCare, legacy: legacy, horizonYears: horizonYears, onWhyYears: onWhyYears, costCell: costCell = null, pensionLabel: pensionLabel, pensionNoteText: pensionNoteText, cashflowNotes: cashflowNotes, caption: caption, large: large = false })=>{
    const short = cashflowAfterCare < 0;
    const pensionNote = pensionToday != null && Math.round(pensionToday) !== Math.round(pension) ? `${Math.round(pension) > Math.round(pensionToday) ? 'up' : 'down'} from ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(pensionToday))} once care starts` : 'once care starts';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "do-nothing-strip",
        children: [
            caption !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[13px] text-slate-500",
                children: caption ?? "Compared with paying daily \u2014 the four numbers from step 2"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `${caption !== null ? 'mt-2' : ''} grid grid-cols-1 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-card sm:grid-cols-2 md:grid-cols-4`,
                children: [
                    costCell ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ac9505651d2e4510$var$Cell, {
                        large: large,
                        label: costCell.label,
                        value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(costCell.value)),
                        unit: costCell.unit,
                        note: costCell.note
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ac9505651d2e4510$var$Cell, {
                        large: large,
                        label: "Care would cost",
                        value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(careDaily)),
                        unit: "a day",
                        note: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(careAnnual))} a year`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ac9505651d2e4510$var$Cell, {
                        large: large,
                        label: pensionLabel ?? `${enteringName}'s Age Pension`,
                        value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(pension)),
                        unit: "a year",
                        note: pensionNoteText ?? pensionNote
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ac9505651d2e4510$var$Cell, {
                        large: large,
                        label: short ? 'Each year, short by' : 'Left over each year',
                        value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(cashflowAfterCare))),
                        note: short ? cashflowNotes?.short ?? 'met from savings' : cashflowNotes?.over ?? 'after care and living costs',
                        tone: short ? 'bad' : 'good'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ac9505651d2e4510$var$Cell, {
                        large: large,
                        label: "Left to the family",
                        value: legacy != null ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(legacy)) : "\u2014",
                        note: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "after about ",
                                horizonYears,
                                " ",
                                horizonYears === 1 ? 'year' : 'years',
                                onWhyYears && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        " \xb7 ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            onClick: onWhyYears,
                                            className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                            children: [
                                                "why ",
                                                horizonYears,
                                                "?"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $ac9505651d2e4510$export$2e2bcd8739ae039 = $ac9505651d2e4510$var$DoNothingStrip;


/**
 * "Where the $32,006 comes from" — the cashflow pop-over the owner agreed to (UX review, 17 Oct 2026).
 *
 * Money in, then money out, over a full year with the plan in place, each line with one sub-line
 * saying where it comes from; the tax line opens a second page, "How the tax is worked out", with a
 * column per person and a way back. Every figure is the strategy's own snapshot — the same seven the
 * engine returns and the Annual Snapshot tiles show — relabelled, never recomputed.
 */ 

var $acw62 = parcelRequire("acw62");



const $07d43762e3724db0$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(Math.abs(n)));
const $07d43762e3724db0$var$signed = (n)=>n < 0 ? `\u{2212}${$07d43762e3724db0$var$money(n)}` : `+${$07d43762e3724db0$var$money(n)}`;
const $07d43762e3724db0$var$Row = ({ label: label, sub: sub, value: value, bold: bold = false, why: why, onWhy: onWhy })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `flex items-start justify-between gap-6 ${bold ? 'mt-1 border-t-2 border-brand-navy pt-3.5 pb-1' : 'border-b border-slate-100 py-3'}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "min-w-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: `${bold ? 'text-[16px] font-bold text-brand-navy' : 'text-[15px] text-slate-800'}`,
                        children: label
                    }),
                    sub && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-0.5 text-[13px] leading-relaxed text-slate-500",
                        children: [
                            sub,
                            why && onWhy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: onWhy,
                                        className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-[3px] hover:decoration-brand-navy",
                                        children: "why?"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: `shrink-0 tabular-nums ${bold ? 'text-[18px] font-bold text-brand-navy' : 'text-[15px] font-semibold text-slate-900'}`,
                children: value
            })
        ]
    });
const $07d43762e3724db0$var$Section = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$cb63b5f03a3ae2c6), {
        className: "mt-6 first:mt-0",
        children: children
    });
function $07d43762e3724db0$var$taxLinesFor(rows, showAll) {
    const out = [];
    const val = (v)=>String(v ?? '');
    const isZero = (v)=>/^\$?0(\.00)?$/.test(val(v).replace(/[−-]/g, '').trim());
    for (const r of rows){
        const l = String(r.label || '').trim();
        if (/^- /.test(l)) {
            out.push({
                label: l.replace(/^- /, ''),
                value: val(r.value),
                indent: true
            });
            continue;
        }
        if (/^salary/i.test(l)) {
            out.push({
                label: 'Salary',
                value: val(r.value),
                adviserOnly: isZero(r.value)
            });
            continue;
        }
        if (/assessable investment income/i.test(l)) {
            out.push({
                label: 'Income that is taxed',
                sub: 'Interest, dividends and rent, after the account-based pensions, which are tax-free at this age',
                value: val(r.value)
            });
            continue;
        }
        if (/^less: deductions/i.test(l)) {
            out.push({
                label: 'Deductions',
                value: val(r.value),
                adviserOnly: isZero(r.value)
            });
            continue;
        }
        if (/total taxable income/i.test(l)) {
            out.push({
                label: 'Taxable income',
                value: val(r.value),
                adviserOnly: true
            });
            continue;
        }
        if (/marginal tax rate/i.test(l)) {
            out.push({
                label: 'Marginal tax rate',
                value: val(r.value),
                adviserOnly: true
            });
            continue;
        }
        if (/gross tax payable/i.test(l)) {
            out.push({
                label: 'Tax on that',
                sub: isZero(r.value) ? 'Under the tax-free threshold once the seniors offset applies, so nothing' : undefined,
                value: val(r.value)
            });
            continue;
        }
        if (/medicare levy/i.test(l)) {
            out.push({
                label: 'Medicare levy',
                value: val(r.value)
            });
            continue;
        }
        if (/franking credits/i.test(l)) {
            out.push({
                label: 'Franking credits',
                sub: "Tax the companies already paid on the dividends \u2014 it comes back",
                value: val(r.value).replace(/^-/, '+')
            });
            continue;
        }
        if (/net tax payable/i.test(l)) {
            const neg = /^-/.test(val(r.value));
            out.push({
                label: neg ? 'Refund' : 'Tax to pay',
                value: val(r.value).replace(/^-/, ''),
                bold: true
            });
            continue;
        }
        out.push({
            label: l,
            value: val(r.value),
            adviserOnly: true
        });
    }
    return out.filter((t)=>showAll || !t.adviserOnly);
}
/** Split the engine's one breakdown list into a column per person ("JOHN'S TAX" headings). */ function $07d43762e3724db0$var$taxColumns(rows) {
    const cols = [];
    for (const r of rows || []){
        const l = String(r.label || '').trim();
        // The engine marks each person with a heading row — "--- John's Tax ---" or "JOHN'S TAX" — and no value.
        const m = l.match(/^-*\s*(.+?)['’]s tax\s*-*$/i);
        if (m && String(r.value ?? '') === '') {
            cols.push({
                name: m[1].trim(),
                rows: []
            });
            continue;
        }
        if (/^-{2,}/.test(l) && String(r.value ?? '') === '') {
            cols.push({
                name: l.replace(/-/g, '').trim(),
                rows: []
            });
            continue;
        }
        if (!cols.length) cols.push({
            name: '',
            rows: []
        });
        cols[cols.length - 1].rows.push(r);
    }
    return cols;
}
const $07d43762e3724db0$var$CashflowBreakdownModal = ({ planTitle: planTitle, snapshot: snapshot, baseline: baseline, deposit: deposit, fundingLines: fundingLines, abpNames: abpNames, enteringName: enteringName, stayingName: stayingName, people: people, initialPage: initialPage = 'cashflow', pensionWhy: pensionWhy, pensionRows: pensionRows, careWhy: careWhy, careRows: careRows, onDeepDive: onDeepDive, onClose: onClose })=>{
    /*
     * ONE pop-over, several pages (owner, 18 Oct 2026: "I prefer where it opens up the pop-up right
     * there for you"). A "why?" on the card opens the figure's own page; a "why?" inside the
     * cashflow goes to that page with a way back; nothing sends the reader down to "Show the detail".
     */ const [page, setPageOnly] = (0, $acw62.useState)(initialPage);
    // Where the reader came from, so Back always returns one step, whatever the route taken.
    const [trail, setTrail] = (0, $acw62.useState)([]);
    const setPage = (next)=>{
        setTrail((t)=>[
                ...t,
                page
            ]);
        setPageOnly(next);
    };
    const goBack = ()=>{
        const prev = trail[trail.length - 1];
        if (prev == null) return;
        setTrail((t)=>t.slice(0, -1));
        setPageOnly(prev);
    };
    const canGoBack = trail.length > 0;
    const taxPage = page === 'tax';
    const setTaxPage = (on)=>on ? setPage('tax') : goBack();
    const pageName = (p)=>p === 'pension' ? `${enteringName}'s Age Pension` : p === 'care' ? 'the care costs' : p === 'tax' ? 'the tax' : `where the ${$07d43762e3724db0$var$money(net)} comes from`;
    const [adviserView, setAdviserView] = (0, $acw62.useState)(false);
    const pension = Number(snapshot.pension) || 0;
    const abp = Number(snapshot.abpIncome) || 0;
    const other = (Number(snapshot.otherInvestmentIncome) || 0) + (Number(snapshot.rentalIncome) || 0);
    const rentalExpenses = Number(snapshot.rentalExpenses) || 0;
    const tax = Number(snapshot.taxPayable) || 0;
    const care = Number(snapshot.totalAgedCareCosts) || 0;
    const living = Number(snapshot.livingExpenses) || 0;
    const net = Number(snapshot.netCashflow) || 0;
    const short = net < 0;
    const headline = short ? `Each year, short by ${$07d43762e3724db0$var$money(net)}` : `Left over each year: ${$07d43762e3724db0$var$money(net)}`;
    const abpFunding = fundingLines.filter((l)=>abpNames.some((n)=>n && l.label.toLowerCase().includes(n.toLowerCase())));
    const abpToDeposit = abpFunding.reduce((s, l)=>s + l.amount, 0);
    const pensionDelta = baseline ? pension - baseline.pension : null;
    const closes = baseline && baseline.netCashflow < 0 && short ? Math.max(0, Math.abs(baseline.netCashflow) - Math.abs(net)) : null;
    const cols = $07d43762e3724db0$var$taxColumns(snapshot.taxBreakdown);
    const title = page === 'tax' ? 'How the tax is worked out' : page === 'pension' ? `Why ${enteringName}'s Age Pension is ${$07d43762e3724db0$var$money(pension)}` : page === 'care' ? `Why care costs ${$07d43762e3724db0$var$money(care)} a year` : short ? `Where the ${$07d43762e3724db0$var$money(net)} comes from` : `Where the ${$07d43762e3724db0$var$money(net)} left over comes from`;
    const intro = page === 'tax' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            people.length > 1 ? `Each of ${people.map((p)=>p.firstName).join(' and ')} is taxed on their own share. ` : '',
            "At these income levels the seniors tax offset usually brings tax to nothing, and a refund means franking credits on the shares came back."
        ]
    }) : page === 'pension' ? pensionWhy : page === 'care' ? careWhy : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            "Money in, less money out, over a full year with this plan in place. ",
            short ? 'When it is short, the gap comes out of savings.' : 'What is left over stays in the bank.'
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
        titleId: "cashflow-breakdown-heading",
        testId: "cashflow-breakdown",
        zIndex: 60,
        eyebrow: planTitle,
        back: canGoBack ? {
            label: `Back to ${pageName(trail[trail.length - 1])}`,
            onClick: goBack
        } : null,
        title: title,
        intro: intro,
        onClose: onClose,
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                onDeepDive && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: onDeepDive,
                    className: "mr-auto text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy",
                    "data-testid": "figure-year-by-year",
                    children: "See the year-by-year figures"
                }),
                canGoBack && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                    type: "button",
                    variant: "secondary",
                    onClick: goBack,
                    children: "\u2039 Back"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                    type: "button",
                    variant: "primary",
                    onClick: onClose,
                    children: "Got it"
                })
            ]
        }),
        children: page === 'pension' || page === 'care' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            "data-testid": `figure-${page}-page`,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$cb63b5f03a3ae2c6), {
                    children: "The calculation"
                }),
                (page === 'pension' ? pensionRows : careRows).map((row, i)=>{
                    const l = String(row.label ?? '');
                    const isHeading = l.startsWith('---');
                    const indent = /^- /.test(l);
                    return isHeading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$cb63b5f03a3ae2c6), {
                        className: "mt-6",
                        children: l.replace(/-/g, '').trim()
                    }, i) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `flex items-start justify-between gap-6 border-b border-slate-100 py-2.5 ${indent ? 'pl-5' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `text-[14.5px] ${indent ? 'text-slate-500' : 'text-slate-800'}`,
                                children: l.replace(/^- /, '')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `shrink-0 text-[14.5px] tabular-nums ${indent ? 'font-medium text-slate-600' : 'font-semibold text-slate-900'}`,
                                children: String(row.value ?? '')
                            })
                        ]
                    }, i);
                }),
                page === 'pension' && baseline && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "mt-4 text-[13px] leading-relaxed text-slate-600",
                    children: [
                        "Paying daily, ",
                        enteringName,
                        "'s pension would be ",
                        $07d43762e3724db0$var$money(baseline.pension),
                        " a year",
                        pensionDelta != null && Math.round(pensionDelta) !== 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                " \u2014 this plan ",
                                pensionDelta > 0 ? 'lifts' : 'lowers',
                                " it by ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: $07d43762e3724db0$var$money(pensionDelta)
                                })
                            ]
                        }) : null,
                        "."
                    ]
                }),
                page === 'care' && deposit.dapAnnual > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "mt-4 text-[13px] leading-relaxed text-slate-600",
                    children: [
                        $07d43762e3724db0$var$money(deposit.dapAnnual),
                        " of this is the daily room fee on the ",
                        $07d43762e3724db0$var$money(deposit.unpaid),
                        " of the room not paid up front; the rest is charged whatever is decided about the room."
                    ]
                }),
                !trail.includes('cashflow') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "mt-3 text-[13px]",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>setPage('cashflow'),
                        className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-[3px] hover:decoration-brand-navy",
                        children: [
                            "See the whole year \u2014 where the ",
                            $07d43762e3724db0$var$money(net),
                            " ",
                            short ? 'shortfall' : 'left over',
                            " comes from \u203A"
                        ]
                    })
                })
            ]
        }) : !taxPage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07d43762e3724db0$var$Section, {
                    children: "Money in"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07d43762e3724db0$var$Row, {
                    label: `${enteringName}'s Age Pension`,
                    value: $07d43762e3724db0$var$money(pension),
                    why: true,
                    onWhy: ()=>setPage('pension'),
                    sub: pensionDelta != null && Math.round(pensionDelta) > 0 && deposit.paid > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "Higher than paying daily because the ",
                            $07d43762e3724db0$var$money(deposit.paid),
                            " deposit isn't counted as an asset."
                        ]
                    }) : pensionDelta != null && Math.round(pensionDelta) < 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "Lower than paying daily by ",
                            $07d43762e3724db0$var$money(pensionDelta),
                            " a year."
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: "The same as paying daily."
                    })
                }),
                abp > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07d43762e3724db0$var$Row, {
                    label: "Income from the account-based pensions",
                    value: $07d43762e3724db0$var$money(abp),
                    sub: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            abpNames.length ? abpNames.join(' and ') : 'The super pensions',
                            abpToDeposit > 0 ? `, after ${$07d43762e3724db0$var$money(abpToDeposit)} went to the deposit` : ''
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07d43762e3724db0$var$Row, {
                    label: "Other investment income",
                    value: $07d43762e3724db0$var$money(other),
                    sub: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "Interest, dividends and any rent",
                            rentalExpenses > 0 ? ` \u{2014} before ${$07d43762e3724db0$var$money(rentalExpenses)} of rental expenses, below` : ''
                        ]
                    })
                }),
                rentalExpenses > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07d43762e3724db0$var$Row, {
                    label: "Less: rental expenses",
                    value: `\u{2212}${$07d43762e3724db0$var$money(rentalExpenses)}`,
                    sub: "Rates, insurance and upkeep on the home that is let out"
                }),
                tax < 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07d43762e3724db0$var$Row, {
                    label: "Tax",
                    value: `+${$07d43762e3724db0$var$money(tax)}`,
                    sub: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "A refund \u2014 franking credits on the shares come back. ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setTaxPage(true),
                                className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-[3px] hover:decoration-brand-navy",
                                "data-testid": "cashflow-tax-link",
                                children: "See how the tax is worked out \u203A"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07d43762e3724db0$var$Section, {
                    children: "Money out"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07d43762e3724db0$var$Row, {
                    label: "Care costs",
                    value: `\u{2212}${$07d43762e3724db0$var$money(care)}`,
                    why: true,
                    onWhy: ()=>setPage('care'),
                    sub: deposit.dapAnnual > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            $07d43762e3724db0$var$money(deposit.dapAnnual),
                            " of it is the daily room fee on the ",
                            $07d43762e3724db0$var$money(deposit.unpaid),
                            " not paid up front."
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: "The basic daily fee and the means-tested contributions; no daily room fee, because the room is paid in full."
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07d43762e3724db0$var$Row, {
                    label: "Living costs at home",
                    value: `\u{2212}${$07d43762e3724db0$var$money(living)}`,
                    sub: stayingName ? `What ${stayingName} spends, as you entered on step 1` : 'As you entered on step 1'
                }),
                tax > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07d43762e3724db0$var$Row, {
                    label: "Tax",
                    value: `\u{2212}${$07d43762e3724db0$var$money(tax)}`,
                    sub: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "Tax on the household's income. ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setTaxPage(true),
                                className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-[3px] hover:decoration-brand-navy",
                                "data-testid": "cashflow-tax-link",
                                children: "See how the tax is worked out \u203A"
                            })
                        ]
                    })
                }),
                tax === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07d43762e3724db0$var$Row, {
                    label: "Tax",
                    value: "$0",
                    sub: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "Nothing to pay at these income levels. ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setTaxPage(true),
                                className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-[3px] hover:decoration-brand-navy",
                                "data-testid": "cashflow-tax-link",
                                children: "See how it is worked out \u203A"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07d43762e3724db0$var$Row, {
                    bold: true,
                    label: short ? 'Each year, short by' : 'Left over each year',
                    value: $07d43762e3724db0$var$signed(net)
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "mt-4 text-[13px] leading-relaxed text-slate-600",
                    children: [
                        baseline && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                baseline.netCashflow < 0 ? `Paying daily, it is short by ${$07d43762e3724db0$var$money(baseline.netCashflow)}` : `Paying daily, it has ${$07d43762e3724db0$var$money(baseline.netCashflow)} to spare`,
                                closes != null && closes > 0 ? `, so this plan closes ${$07d43762e3724db0$var$money(closes)} of the gap` : short && baseline.netCashflow < 0 && Math.abs(net) > Math.abs(baseline.netCashflow) ? `, so this plan widens the gap by ${$07d43762e3724db0$var$money(Math.abs(net) - Math.abs(baseline.netCashflow))}` : '',
                                ". "
                            ]
                        }),
                        "A full 12 months with the plan in place, so every plan compares like for like; the first year is shorter and is shown in the year-by-year figures."
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            "data-testid": "cashflow-tax-page",
            children: [
                cols.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "mt-4 text-[14px] text-slate-600",
                    children: "No tax is payable on these figures."
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: `mt-2 grid grid-cols-1 gap-6 ${cols.length > 1 ? 'sm:grid-cols-2' : ''}`,
                    children: cols.map((c, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                c.name && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$cb63b5f03a3ae2c6), {
                                    children: c.name
                                }),
                                $07d43762e3724db0$var$taxLinesFor(c.rows, adviserView).map((t, j)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: `flex items-start justify-between gap-3 ${t.bold ? 'mt-1 border-t-2 border-brand-navy pt-3 pb-1' : 'border-b border-slate-100 py-2.5'} ${t.indent ? 'pl-5' : ''}`,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: `text-[14px] ${t.bold ? 'font-bold text-brand-navy' : t.indent ? 'text-slate-500' : 'text-slate-800'}`,
                                                        children: t.label
                                                    }),
                                                    t.sub && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "mt-0.5 text-[12px] leading-relaxed text-slate-500",
                                                        children: t.sub
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: `shrink-0 tabular-nums ${t.bold ? 'text-[15px] font-bold text-brand-navy' : t.indent ? 'text-[14px] font-medium text-slate-600' : 'text-[14px] font-semibold text-slate-900'}`,
                                                children: t.value
                                            })
                                        ]
                                    }, j))
                            ]
                        }, `${c.name}-${i}`))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "mt-4 text-[13px] leading-relaxed text-slate-600",
                    children: [
                        "Together, ",
                        tax < 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "a ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                    children: [
                                        $07d43762e3724db0$var$money(tax),
                                        " refund"
                                    ]
                                })
                            ]
                        }) : tax > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: $07d43762e3724db0$var$money(tax)
                                }),
                                " of tax"
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: "nothing to pay"
                        }),
                        ' \u2014 the "Tax" line in the cashflow. The account-based pensions are tax-free at this age, so they don\'t appear.',
                        ' ',
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>setAdviserView((v)=>!v),
                            className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-[3px] hover:decoration-brand-navy",
                            children: adviserView ? 'Hide the nil lines' : 'Show every line (adviser view)'
                        })
                    ]
                })
            ]
        })
    });
};
var $07d43762e3724db0$export$2e2bcd8739ae039 = $07d43762e3724db0$var$CashflowBreakdownModal;



/**
 * Plans side by side — one table for every comparison (owner, 18 Oct 2026: "it still feels a bit
 * bland"). Used by "All the plans, side by side" on step 3 and "Two homes, side by side" on Home.
 *
 * What makes it read: a soft header band; the headline column (left to the family) set large in
 * navy with its gain against doing nothing beneath; a small emerald mark on the best value in each
 * column, so the eye can scan down for "best"; a thin amber bar under "tied up in the deposit" so
 * the trade-off is visible, not just read; the doing-nothing row muted and labelled; the chosen row
 * with its green rail and chip; a hover on every row that opens. White throughout, colour as accent
 * (no pastel infills — owner, 15 Oct 2026).
 */ 
parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $279cc4372d444b30$export$4c880e59a39ba9d2 = '(max-width: 639px)';
function $279cc4372d444b30$export$94c6a3b6d2027942() {
    const supported = typeof window !== 'undefined' && typeof window.matchMedia === 'function';
    const [narrow, setNarrow] = (0, $acw62.useState)(()=>supported ? window.matchMedia($279cc4372d444b30$export$4c880e59a39ba9d2).matches : false);
    (0, $acw62.useEffect)(()=>{
        if (!supported) return undefined;
        const mq = window.matchMedia($279cc4372d444b30$export$4c880e59a39ba9d2);
        const onChange = ()=>setNarrow(mq.matches);
        mq.addEventListener?.('change', onChange);
        return ()=>mq.removeEventListener?.('change', onChange);
    }, [
        supported
    ]);
    return narrow;
}


const $1d8e44526b4d2fe9$var$BestMark = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "ml-1.5 inline-block h-2 w-2 translate-y-[-1px] rounded-full bg-emerald-500 align-middle",
        "aria-label": "best in this column",
        title: "Best in this column"
    });
const $1d8e44526b4d2fe9$var$ComparisonTable = ({ columns: columns, rows: rows, firstHeading: firstHeading = 'Plan', testId: testId, legend: legend = true })=>{
    // The best value per column, judged over the plans only (never doing nothing).
    const best = {};
    const maxAbs = {};
    for (const c of columns){
        const vals = rows.filter((r)=>!r.baseline).map((r)=>r.cells[c.key]?.value).filter((v)=>v != null && Number.isFinite(v));
        best[c.key] = c.best && vals.length > 1 ? c.best === 'max' ? Math.max(...vals) : Math.min(...vals) : null;
        maxAbs[c.key] = Math.max(0, ...rows.map((r)=>Math.abs(r.cells[c.key]?.value ?? 0)));
    }
    const anyBest = columns.some((c)=>best[c.key] != null);
    const narrow = (0, $279cc4372d444b30$export$94c6a3b6d2027942)();
    const isBestCell = (r, c)=>{
        const cell = r.cells[c.key];
        return !r.baseline && best[c.key] != null && cell?.value != null && Math.round(cell.value) === Math.round(best[c.key]);
    };
    /*
     * ON A PHONE: one card per plan (owner-approved polish, 25 Oct 2026). The table's plan names
     * wrapped a word a line and two columns fell off the screen; a card shows the name, the chosen
     * or comparison mark, and every column's figure in two rows. Laptop and iPad keep the table.
     */ if (narrow) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-3",
        "data-testid": testId,
        children: [
            rows.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    onClick: r.onOpen,
                    className: `rounded-xl border bg-white px-4 py-3.5 ${r.chosen ? 'border-emerald-500' : 'border-slate-200'} ${r.onOpen ? 'cursor-pointer' : ''}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: `${r.baseline ? 'text-slate-600' : 'font-semibold text-slate-900'}`,
                                    children: r.title
                                }),
                                r.chosen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "inline-flex items-center gap-1 text-[11.5px] font-semibold text-emerald-700",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                            size: 13,
                                            strokeWidth: 2,
                                            "aria-hidden": true
                                        }),
                                        "Chosen"
                                    ]
                                }),
                                r.baseline && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-[11.5px] font-semibold text-slate-500",
                                    children: "the comparison"
                                })
                            ]
                        }),
                        r.subtitle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mt-0.5 text-[12px] text-slate-500",
                            children: r.subtitle
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dl", {
                            className: "mt-3 grid grid-cols-2 gap-x-4 gap-y-2.5",
                            children: columns.map((c)=>{
                                const cell = r.cells[c.key];
                                if (!cell) return null;
                                const toneClass = cell.tone === 'good' ? 'text-emerald-700' : cell.tone === 'bad' ? 'text-rose-700' : r.baseline ? 'text-slate-600' : 'text-slate-900';
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: c.text ? 'col-span-2' : '',
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                            className: "text-[12px] text-slate-500",
                                            children: c.label
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                                            className: `tabular-nums ${c.text ? 'text-[13px] text-slate-600' : c.headline ? 'text-[16px] font-bold text-brand-navy' : `font-semibold ${toneClass}`}`,
                                            children: [
                                                c.text ? cell.display : cell.display ?? (cell.value != null ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(cell.value)) : "\u2014"),
                                                !c.text && isBestCell(r, c) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1d8e44526b4d2fe9$var$BestMark, {}),
                                                cell.sub && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "block text-[12px] font-semibold",
                                                    children: cell.sub
                                                })
                                            ]
                                        })
                                    ]
                                }, c.key);
                            })
                        })
                    ]
                }, r.key)),
            legend && anyBest && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[12px] text-slate-500",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "mr-1 inline-block h-2 w-2 rounded-full bg-emerald-500 align-middle",
                        "aria-hidden": true
                    }),
                    " the best figure in that column, among the plans."
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "overflow-hidden rounded-xl border border-slate-200",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                className: "w-full border-collapse text-[14px]",
                "data-testid": testId,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "border-b border-slate-200 text-left text-[12.5px] font-semibold text-slate-500",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    className: "px-4 py-3",
                                    children: firstHeading
                                }),
                                columns.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: `px-3 py-3 ${c.text ? '' : 'text-right'}`,
                                        children: c.label
                                    }, c.key))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                        className: "divide-y divide-slate-100",
                        children: rows.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                onClick: r.onOpen,
                                className: `${r.onOpen ? 'cursor-pointer hover:bg-blue-50/40' : ''} transition-colors ${r.baseline ? 'bg-slate-50/50' : 'bg-white'}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        className: `px-4 py-3.5 align-top ${r.chosen ? 'shadow-[inset_4px_0_0_#059669]' : ''}`,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex flex-wrap items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: `${r.baseline ? 'text-slate-600' : 'font-semibold text-slate-900'}`,
                                                        children: r.title
                                                    }),
                                                    r.chosen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "inline-flex items-center gap-1 text-[11.5px] font-semibold text-emerald-700",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                                                size: 13,
                                                                strokeWidth: 2,
                                                                "aria-hidden": true
                                                            }),
                                                            "Chosen"
                                                        ]
                                                    }),
                                                    r.baseline && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-[11.5px] font-semibold text-slate-500",
                                                        children: "the comparison"
                                                    })
                                                ]
                                            }),
                                            r.subtitle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-0.5 text-[12px] text-slate-500",
                                                children: r.subtitle
                                            })
                                        ]
                                    }),
                                    columns.map((c)=>{
                                        const cell = r.cells[c.key];
                                        if (!cell) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "px-3 py-3.5"
                                        }, c.key);
                                        const isBest = !r.baseline && best[c.key] != null && cell.value != null && Math.round(cell.value) === Math.round(best[c.key]);
                                        const toneClass = cell.tone === 'good' ? 'text-emerald-700' : cell.tone === 'bad' ? 'text-rose-700' : r.baseline ? 'text-slate-600' : 'text-slate-900';
                                        const pct = c.bar && maxAbs[c.key] > 0 && cell.value != null ? Math.max(2, Math.min(100, Math.abs(cell.value) / maxAbs[c.key] * 100)) : null;
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: `px-3 py-3.5 align-top ${c.text ? 'text-slate-600' : 'text-right tabular-nums'}`,
                                            children: c.text ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: cell.display
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: `${c.headline ? r.baseline ? 'text-[16px] font-semibold text-slate-600' : 'text-[17px] font-bold text-brand-navy' : `font-semibold ${toneClass}`}`,
                                                        children: cell.display ?? (cell.value != null ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(cell.value)) : "\u2014")
                                                    }),
                                                    isBest && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1d8e44526b4d2fe9$var$BestMark, {}),
                                                    cell.sub && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "block whitespace-nowrap text-[12px] font-semibold",
                                                        children: cell.sub
                                                    }),
                                                    pct != null && !r.baseline && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mt-1.5 ml-auto block h-1 w-20 overflow-hidden rounded-full bg-slate-100",
                                                        "aria-hidden": true,
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: `block h-full rounded-full ${c.bar === 'emerald' ? 'bg-emerald-500' : 'bg-amber-500'}`,
                                                            style: {
                                                                width: `${pct}%`
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        }, c.key);
                                    })
                                ]
                            }, r.key))
                    })
                ]
            }),
            legend && anyBest && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "border-t border-slate-100 bg-white px-4 py-2 text-[12px] text-slate-500",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "mr-1 inline-block h-2 w-2 rounded-full bg-emerald-500 align-middle",
                        "aria-hidden": true
                    }),
                    " the best figure in that column, among the plans."
                ]
            })
        ]
    });
};
var $1d8e44526b4d2fe9$export$2e2bcd8739ae039 = $1d8e44526b4d2fe9$var$ComparisonTable;




/**
 * "What matters most to John and Kerry?" — the four goals as one control (UX review, 17 Oct 2026).
 *
 * The same four goals the owner ruled on (24 Sep 2026), in the same order, with a plain sub-line under
 * each so a family member can pick one without knowing what "optimised for" means. Presentation only:
 * choosing a goal never re-runs the engine, it chooses which of the ranked rows to show.
 *
 * The "…and income covers the costs" goal is engine logic, not copy: for a self-funded client it picks a
 * different plan. When no plan meets it, as for most families, it is shown dimmed with "Same as 'Leave
 * the most' for John" rather than hidden (owner, 17 Oct 2026: clients almost always dip into savings).
 */ 
parcelRequire("acw62");
const $54f65c4595e0c798$var$EngineGoalControl = ({ value: value, onChange: onChange, household: household, enteringName: enteringName, horizonYears: horizonYears, coveredSameAsBest: coveredSameAsBest, waysTested: waysTested, shown: shown, testedFor: testedFor = 'to pay for the room', closingNote: closingNote, subs: subs, bestCovers: bestCovers = false, countLine: countLine, baselineWord: baselineWord = 'paying daily' })=>{
    const yrs = `${horizonYears} ${horizonYears === 1 ? 'year' : 'years'}`;
    const options = [
        {
            id: 'legacy',
            label: 'Leave the most to the family',
            sub: subs?.legacy ?? `Biggest estate after about ${yrs}`
        },
        {
            id: 'covered',
            label: "\u2026and income covers the costs",
            sub: subs?.covered ?? (coveredSameAsBest ? `Same as "Leave the most" for ${enteringName}` : 'Pays its way without savings'),
            dim: coveredSameAsBest
        },
        {
            id: 'cashflow',
            label: 'Most left over each year',
            sub: subs?.cashflow ?? 'Easiest cashflow'
        },
        {
            id: 'pension',
            label: 'Highest Age Pension',
            sub: subs?.pension ?? 'Most government support'
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "engine-goal-control",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                className: "text-[22px] font-bold leading-tight tracking-tight text-slate-900",
                children: [
                    "What matters most to ",
                    household,
                    "?"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-1 text-[14px] text-slate-600",
                children: [
                    "We tested ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                        className: "text-slate-800",
                        children: [
                            waysTested.toLocaleString(),
                            " ways"
                        ]
                    }),
                    " ",
                    testedFor,
                    ".",
                    ' ',
                    countLine ?? (shown === 1 ? 'One fits this goal best.' : shown === 0 ? `None beats ${baselineWord} on this goal.` : `${shown === 2 ? 'Two' : shown} fit this goal best.`),
                    coveredSameAsBest && bestCovers && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: ' The plan that leaves the most also covers each year\'s costs from income, so "income covers the costs" gives the same plan here.'
                    }),
                    coveredSameAsBest && !bestCovers && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: ' No plan covers each year\'s costs from income alone \u2014 most families use some savings \u2014 so "income covers the costs" gives the same plan as "Leave the most" here.'
                    }),
                    ' ',
                    closingNote ?? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: "Each card says when the savings would run out; many people's care ends well before that day."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-3 grid grid-cols-1 gap-1.5 rounded-xl border border-slate-300 bg-white p-1.5 shadow-card sm:grid-cols-2 lg:grid-cols-4",
                role: "radiogroup",
                "aria-label": "What matters most",
                children: options.map((o)=>{
                    const on = value === o.id;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        role: "radio",
                        "aria-checked": on,
                        onClick: ()=>onChange(o.id),
                        className: `rounded-lg px-4 py-3 text-left transition-colors ${on ? 'bg-brand-navy text-white' : 'text-slate-700 hover:bg-slate-50'} ${o.dim && !on ? 'opacity-60' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "block text-[14px] font-bold leading-snug",
                                children: o.label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `block text-[12px] leading-snug ${on ? 'text-blue-100' : 'text-slate-500'}`,
                                children: o.sub
                            })
                        ]
                    }, o.id);
                })
            })
        ]
    });
};
var $54f65c4595e0c798$export$2e2bcd8739ae039 = $54f65c4595e0c798$var$EngineGoalControl;


/**
 * A tested plan, in three layers (UX review, 17 Oct 2026; owner: "make this screen look world class").
 *
 *   1. The decision — a name in everyday words, one big number ("left to the family after about 5
 *      years"), the gain against doing nothing, and two bars: how much more than doing nothing, and
 *      how much is tied up in the deposit. The trade-off between two plans is visible without scrolling.
 *   2. The three numbers a family asks about — care costs, the Age Pension, each year's shortfall —
 *      each against doing nothing, each with a "why?" that opens its breakdown.
 *   3. When the money runs out, the plan in three short lines, and the three buttons the owner ruled
 *      on (2 Oct 2026): Explain this / What could go wrong / Choose this plan.
 *
 * Everything else the card used to show — the allocation grid, the money flow, the six-tile snapshot
 * with its pop-overs, the funding note — is still here, behind "Show the detail". Nothing is removed
 * (an adviser reads it; the Statement of Advice is built from it); it is no longer the first thing a
 * son or daughter has to read. The figures are the engine row's own, quoted; this file computes nothing.
 */ 
parcelRequire("acw62");


const $b383720e6b5df564$var$Bar = ({ label: label, pct: pct, value: value, tone: tone })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "grid grid-cols-[104px_minmax(0,1fr)_auto] items-center gap-2 text-[13px] sm:grid-cols-[150px_minmax(0,1fr)_auto] sm:gap-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-slate-600",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "h-2 overflow-hidden rounded-full bg-slate-100",
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: `block h-full rounded-full ${tone === 'good' ? 'bg-emerald-500' : tone === 'bad' ? 'bg-rose-500' : 'bg-amber-500'}`,
                    style: {
                        width: `${Math.max(3, Math.min(100, pct))}%`
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: `font-bold tabular-nums ${tone === 'good' ? 'text-emerald-700' : 'text-slate-900'}`,
                children: value
            })
        ]
    });
const $b383720e6b5df564$var$EnginePlanCard = ({ chip: chip, chipTone: chipTone = 'neutral', title: title, sub: sub, legacy: legacy, legacyDelta: legacyDelta, horizonYears: horizonYears, bars: bars, numbers: numbers, runline: runline, worthKnowing: worthKnowing, lines: lines, chosen: chosen, onExplain: onExplain, onRisks: onRisks, onChoose: onChoose, chooseLabel: chooseLabel, detail: detail, detailOpen: detailOpen, onToggleDetail: onToggleDetail, chosenStrip: chosenStrip, notices: notices, whyShown: whyShown, testId: testId, tiedUpLabel: tiedUpLabel = 'Tied up in the deposit', detailHint: detailHint = 'where the deposit comes from, the yearly figures and every calculation', extraAction: extraAction, hideEmptyTiedUp: hideEmptyTiedUp = false, linesBulleted: linesBulleted = false, baselineWord: baselineWord = 'doing nothing', deltaNote: deltaNote, aligned: aligned = false, beforeChoose: beforeChoose, chooseHeld: chooseHeld = false, familyPanel: familyPanel, legacyCaption: legacyCaption, lessLabel: lessLabel })=>{
    const yrs = `${horizonYears} ${horizonYears === 1 ? 'year' : 'years'}`;
    // Under the buttons: the chosen strip, an extra action, the detail.
    const below = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            chosen && chosenStrip,
            extraAction,
            detail && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-4 border-t border-slate-200 pt-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onToggleDetail,
                        "aria-expanded": detailOpen,
                        className: "text-left text-[13px] font-semibold text-blue-700 hover:text-blue-900",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "inline-flex items-center gap-1.5 whitespace-nowrap",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                        size: 15,
                                        className: `transition-transform ${detailOpen ? 'rotate-180' : ''}`
                                    }),
                                    " ",
                                    detailOpen ? 'Hide the detail' : 'Show the detail'
                                ]
                            }),
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "font-normal text-slate-500",
                                children: [
                                    "\u2014 ",
                                    detailHint
                                ]
                            })
                        ]
                    }),
                    detailOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-4",
                        children: detail
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": testId,
        className: `${aligned ? 'row-span-4 grid grid-rows-subgrid gap-0' : 'flex flex-col'} overflow-hidden rounded-2xl border bg-white shadow-card ${chosen ? 'border-emerald-500 ring-1 ring-emerald-200' : 'border-slate-200'}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    notices,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-5 pb-0",
                        children: [
                            chip && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `text-[12.5px] font-semibold ${chipTone === 'blue' ? 'text-brand-navy' : 'text-slate-500'}`,
                                children: chip
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "mt-2 text-[20px] font-bold leading-snug tracking-tight text-slate-900",
                                children: title
                            }),
                            sub && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1 text-[13px] leading-relaxed text-slate-600",
                                children: sub
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: `mt-4 ${whyShown ? 'grid grid-cols-1 gap-3 sm:grid-cols-[auto_minmax(0,1fr)] sm:items-start sm:gap-5' : ''}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-[36px] font-bold leading-none tabular-nums tracking-tight text-brand-navy",
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(legacy))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-1 text-[13px] text-slate-600",
                                                children: legacyCaption ?? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        "left to the family after about ",
                                                        yrs
                                                    ]
                                                })
                                            }),
                                            deltaNote ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-0.5 text-[13px] font-bold text-brand-navy",
                                                children: deltaNote
                                            }) : legacyDelta != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: `mt-0.5 text-[13px] font-bold tabular-nums ${legacyDelta >= 0 ? 'text-emerald-700' : 'text-rose-700'}`,
                                                children: [
                                                    legacyDelta >= 0 ? '+' : "\u2212",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(legacyDelta))),
                                                    " vs ",
                                                    baselineWord
                                                ]
                                            })
                                        ]
                                    }),
                                    whyShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "rounded-lg border border-slate-200 border-l-4 border-l-blue-500 bg-white px-3.5 py-2.5 text-[13px] leading-relaxed text-slate-700",
                                        "data-testid": "trade-off-note",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                className: "text-slate-900",
                                                children: "Why it is shown:"
                                            }),
                                            " ",
                                            whyShown
                                        ]
                                    })
                                ]
                            }),
                            bars && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-4 space-y-2",
                                children: [
                                    legacyDelta != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b383720e6b5df564$var$Bar, {
                                        label: legacyDelta >= 0 ? `More than ${baselineWord}` : lessLabel ?? `Less than ${baselineWord}`,
                                        pct: bars.gainPct,
                                        value: `${legacyDelta >= 0 ? '+' : "\u2212"}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(legacyDelta)))}`,
                                        tone: legacyDelta >= 0 ? 'good' : 'bad'
                                    }),
                                    (bars.tiedUp > 0 || !hideEmptyTiedUp) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b383720e6b5df564$var$Bar, {
                                        label: tiedUpLabel,
                                        pct: bars.tiedUpPct,
                                        value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(bars.tiedUp)),
                                        tone: "amber"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-4 divide-y divide-slate-100 border-y border-slate-200 bg-slate-50/70 self-start w-full",
                children: numbers.map((n)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "px-5 py-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[12px] font-semibold text-slate-500",
                                children: n.label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: `mt-0.5 text-[20px] font-bold leading-none tabular-nums ${n.tone === 'good' ? 'text-emerald-700' : n.tone === 'bad' ? 'text-rose-700' : 'text-slate-900'}`,
                                children: [
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n.value)),
                                    n.unit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "ml-1 text-[12px] font-medium text-slate-500",
                                        children: n.unit
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-1 text-[12px] text-slate-500",
                                children: [
                                    n.vs,
                                    n.onWhy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            " \xb7 ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: n.onWhy,
                                                className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                                children: "why?"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, n.label))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `flex flex-1 flex-col ${aligned ? 'px-5 pt-5' : 'p-5'}`,
                children: [
                    runline && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-[13px] leading-relaxed text-slate-700",
                        children: runline
                    }),
                    worthKnowing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-3 space-y-1.5 rounded-lg border border-slate-200 border-l-4 border-l-amber-400 bg-white py-2 pl-3 pr-2 text-[13px] leading-relaxed text-slate-700",
                        children: worthKnowing
                    }),
                    lines.length > 0 && (linesBulleted ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        className: "mt-3 list-disc space-y-1.5 pl-5 text-[13px] leading-relaxed text-slate-700",
                        children: lines.map((l, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: l
                            }, i))
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ol", {
                        className: "mt-3 list-decimal space-y-1.5 pl-5 text-[13px] leading-relaxed text-slate-700",
                        children: lines.map((l, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: l
                            }, i))
                    })),
                    familyPanel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-4",
                        children: familyPanel
                    }),
                    beforeChoose && !chosen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-4",
                        children: beforeChoose
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-auto flex flex-wrap gap-2 pt-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: onExplain,
                                className: "inline-flex min-w-[8.5rem] flex-1 items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-[13px] font-semibold text-slate-800 hover:border-blue-300 hover:bg-blue-50",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                        size: 15
                                    }),
                                    " Explain this"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: onRisks,
                                className: "inline-flex min-w-[8.5rem] flex-1 items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-[13px] font-semibold text-slate-800 hover:border-blue-300 hover:bg-blue-50",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4666dd9ae485baaf$export$2e2bcd8739ae039), {
                                        size: 15
                                    }),
                                    " What could go wrong"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: chooseHeld && !chosen ? undefined : onChoose,
                                disabled: chooseHeld && !chosen,
                                "aria-pressed": chosen,
                                "data-testid": "plan-card-choose",
                                className: `inline-flex min-w-[8.5rem] flex-1 items-center justify-center gap-1.5 rounded-lg px-3 py-2.5 text-[13px] font-semibold ${chosen ? 'border border-emerald-500 bg-white text-emerald-800' : chooseHeld ? 'cursor-not-allowed bg-blue-600 text-white opacity-50' : 'bg-blue-600 text-white hover:bg-blue-700'}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                        size: 15
                                    }),
                                    " ",
                                    chosen ? "Chosen \u2713" : chooseLabel
                                ]
                            })
                        ]
                    }),
                    !aligned && below
                ]
            }),
            aligned && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "px-5 pb-5",
                children: below
            })
        ]
    });
};
var $b383720e6b5df564$export$2e2bcd8739ae039 = $b383720e6b5df564$var$EnginePlanCard;




/**
 * The questions that change the answer — ONE set, asked twice (UX review, 17 Oct 2026, version A).
 *
 * Step 3 asks them inline before the plans run, pre-filled with what we would suggest and why;
 * "Things that change the answer" under the plans reopens the same five. Each question is in the
 * reader's words with the suggested value and the reason, so a family member can accept every
 * suggestion and press on without understanding any of it, and an adviser can change any of them.
 *
 * The engine inputs do not change: the answers map onto the analyser's setup bag
 * (coupleValidation) and the engine's settings through the adapters at the foot of this file.
 */ 
parcelRequire("acw62");

/**
 * StampDutyFields — the state the new home is in, and the duty on buying it, as an estimate the
 * client can overwrite.
 *
 * Owner, 23 Sep 2026: "rather than just use a default rate are you able to have a stamp duty
 * calculator in the back-end … show the 'Estimated result' and allow them to override." So: pick the
 * state, the duty fills in from that state's own scale for the new home's price, and the figure stays
 * editable. Whenever the state or the price changes the estimate is struck again, which overwrites
 * an edited figure — a deliberate simplicity, said in the helper text.
 *
 * No state, no guess: with the state blank the duty is blank, the helper says why, and the model
 * charges nothing for duty. The same rule the health question follows.
 *
 * One component, so the Strategy Analysis Setup modal, the engine's settings, Manual Control and the
 * Downsizer module ask the question in the same words and fill it from the same calculator.
 */ 

var $acw62 = parcelRequire("acw62");

/**
 * stampDuty.ts — the duty on buying a home, from the schedules in constants/stampDuty.ts.
 *
 * One function, used by the Strategy Analysis Setup modal, Manual Control and the Downsizer module to
 * pre-fill an ESTIMATE the client can overwrite. Where no state is chosen it returns null, never a
 * guess: a blank is said out loud on every screen and in the advice document, in the same way a
 * blank health answer is (owner, 23 Sep 2026).
 */ /**
 * stampDuty.ts — transfer (stamp) duty on the purchase of a home, by state and territory.
 *
 * WHY (owner, 23 Sep 2026). A downsize books the new home at its price and nothing was taken off for
 * the duty on buying it, so every downsize understated the changeover — the owner had been carrying
 * the duty in his head. Rather than a flat percentage, each jurisdiction's own scale is here, so the
 * app can put an ESTIMATE in front of the client that they can overwrite from a conveyancer's quote.
 *
 * WHAT IS MODELLED. The scale an owner-occupier pays on a residential purchase: where a jurisdiction
 * has a principal-place-of-residence or "home" scale (VIC, QLD, ACT), that is the one used, because
 * the new home is the partner's home. Where it has only a general residential scale (NSW, WA, TAS,
 * SA, NT), that. No pensioner, seniors, first-home or downsizer CONCESSIONS are applied (owner:
 * "concessions can be added later"), and no foreign-purchaser surcharge. The figure is therefore the
 * conservative one for most clients, and it is labelled an estimate wherever it appears.
 *
 * "$X per $100 or part thereof" is applied on the exact value rather than rounded up to the next
 * $100 — an understatement of under $6 on an estimate that will be overwritten by a quote.
 *
 * PROVENANCE. Each schedule records the page it was read from and the date that page stated, in the
 * manner of ratesAndThresholds.ts. SA, NT and the ACT were confirmed on 21 October 2026 (village
 * review): SA against RevenueSA's rate page, NT against the Territory Revenue Office's own calculator
 * at six values, the ACT against its rate page (which still shows the 2025-26 tables). NSW indexes its
 * thresholds annually on 1 July; VIC, QLD, WA and TAS scales are fixed by legislation and change rarely.
 *
 * AN INVESTMENT PROPERTY (owner, 21 Oct 2026). A home to live in keeps the owner-occupier scale; a
 * property bought to rent out pays the general rates where a state has different ones: Victoria's
 * general scale from $0 (no principal-place-of-residence rates), Queensland's transfer duty rates (no
 * home concession) and the ACT's non-owner-occupier table. Elsewhere one scale serves both.
 */ const $669f0c9987a611db$export$2f609b1773ce8fef = [
    {
        code: 'NSW',
        name: 'New South Wales'
    },
    {
        code: 'VIC',
        name: 'Victoria'
    },
    {
        code: 'QLD',
        name: 'Queensland'
    },
    {
        code: 'SA',
        name: 'South Australia'
    },
    {
        code: 'WA',
        name: 'Western Australia'
    },
    {
        code: 'TAS',
        name: 'Tasmania'
    },
    {
        code: 'ACT',
        name: 'Australian Capital Territory'
    },
    {
        code: 'NT',
        name: 'Northern Territory'
    }
];
const $669f0c9987a611db$export$fa78cd89cb539f5 = {
    NSW: {
        state: 'NSW',
        scale: 'Transfer duty, standard rates 2026-27 (thresholds indexed annually on 1 July)',
        minimum: 20,
        bands: [
            {
                from: 0,
                base: 0,
                rate: 0.0125
            },
            {
                from: 18000,
                base: 225,
                rate: 0.015
            },
            {
                from: 38000,
                base: 525,
                rate: 0.0175
            },
            {
                from: 103000,
                base: 1662,
                rate: 0.035
            },
            {
                from: 387000,
                base: 11602,
                rate: 0.045
            },
            {
                from: 1290000,
                base: 52237,
                rate: 0.055
            },
            // Premium duty on residential land above the premium threshold.
            {
                from: 3870000,
                base: 194137,
                rate: 0.07
            }
        ],
        source: {
            url: 'https://www.revenue.nsw.gov.au/taxes-duties-levies-royalties/transfer-duty/understanding-transfer-duty/calculate-transfer-duty',
            stated: 'page last updated 19 August 2026; 2026/27 thresholds',
            verified: true
        }
    },
    VIC: {
        state: 'VIC',
        scale: 'Land transfer duty, principal place of residence rates to $550,000, general rates above',
        bands: [
            {
                from: 0,
                base: 0,
                rate: 0.014
            },
            {
                from: 25000,
                base: 350,
                rate: 0.024
            },
            {
                from: 130000,
                base: 2870,
                rate: 0.05
            },
            {
                from: 440000,
                base: 18370,
                rate: 0.06
            }
        ],
        generalAbove: {
            above: 550000,
            bands: [
                {
                    from: 0,
                    base: 0,
                    rate: 0.014
                },
                {
                    from: 25000,
                    base: 350,
                    rate: 0.024
                },
                {
                    from: 130000,
                    base: 2870,
                    rate: 0.06
                },
                {
                    from: 960000,
                    base: 0,
                    rate: 0.055,
                    flatOnWhole: true
                },
                {
                    from: 2000000,
                    base: 110000,
                    rate: 0.065
                }
            ]
        },
        investor: {
            scale: 'Land transfer duty, general rates (not a principal place of residence)',
            bands: [
                {
                    from: 0,
                    base: 0,
                    rate: 0.014
                },
                {
                    from: 25000,
                    base: 350,
                    rate: 0.024
                },
                {
                    from: 130000,
                    base: 2870,
                    rate: 0.06
                },
                {
                    from: 960000,
                    base: 0,
                    rate: 0.055,
                    flatOnWhole: true
                },
                {
                    from: 2000000,
                    base: 110000,
                    rate: 0.065
                }
            ],
            source: {
                url: 'https://www.sro.vic.gov.au/sites/default/files/duties_nonppr_rates_2021.csv',
                stated: 'general (non-PPR) rates from 1 July 2021, read 21 October 2026'
            }
        },
        source: {
            url: 'https://www.sro.vic.gov.au/about-us/rates-and-statistics/current-rates/land-transfer-duty-principal-place-residence-current-rates',
            stated: 'pages last updated 10 July 2026; PPR scale from 6 May 2008, general scale from 1 July 2021',
            verified: true
        }
    },
    QLD: {
        state: 'QLD',
        scale: 'Transfer duty, home concession rates (the buyer will live in the home)',
        bands: [
            {
                from: 0,
                base: 0,
                rate: 0.01
            },
            {
                from: 350000,
                base: 3500,
                rate: 0.035
            },
            {
                from: 540000,
                base: 10150,
                rate: 0.045
            },
            {
                from: 1000000,
                base: 30850,
                rate: 0.0575
            }
        ],
        investor: {
            scale: 'Transfer duty rates (no home concession)',
            bands: [
                {
                    from: 0,
                    base: 0,
                    rate: 0
                },
                {
                    from: 5000,
                    base: 0,
                    rate: 0.015
                },
                {
                    from: 75000,
                    base: 1050,
                    rate: 0.035
                },
                {
                    from: 540000,
                    base: 17325,
                    rate: 0.045
                },
                {
                    from: 1000000,
                    base: 38025,
                    rate: 0.0575
                }
            ],
            source: {
                url: 'https://qro.qld.gov.au/duties/transfer-duty/calculate/rates/',
                stated: 'page last updated 25 June 2026, read 21 October 2026'
            }
        },
        source: {
            url: 'https://qro.qld.gov.au/duties/transfer-duty/calculate/home-concession-rates/',
            stated: 'page last updated 31 July 2026',
            verified: true,
            note: 'The home concession is the standard owner-occupier scale, not a pensioner concession; QRO states there is no additional concession for seniors.'
        }
    },
    SA: {
        state: 'SA',
        scale: 'Stamp duty on conveyances, residential',
        bands: [
            {
                from: 0,
                base: 0,
                rate: 0.01
            },
            {
                from: 12000,
                base: 120,
                rate: 0.02
            },
            {
                from: 30000,
                base: 480,
                rate: 0.03
            },
            {
                from: 50000,
                base: 1080,
                rate: 0.035
            },
            {
                from: 100000,
                base: 2830,
                rate: 0.04
            },
            {
                from: 200000,
                base: 6830,
                rate: 0.0425
            },
            {
                from: 250000,
                base: 8955,
                rate: 0.0475
            },
            {
                from: 300000,
                base: 11330,
                rate: 0.05
            },
            {
                from: 500000,
                base: 21330,
                rate: 0.055
            }
        ],
        source: {
            url: 'https://revenuesa.sa.gov.au/stampduty/rate-of-stamp-duty',
            stated: 'confirmed against RevenueSA\'s rate page on 21 October 2026 (the page shows no date); every band matches',
            verified: true
        }
    },
    WA: {
        state: 'WA',
        scale: 'Transfer duty, general (residential) rate',
        bands: [
            {
                from: 0,
                base: 0,
                rate: 0.019
            },
            {
                from: 120000,
                base: 2280,
                rate: 0.0285
            },
            {
                from: 150000,
                base: 3135,
                rate: 0.038
            },
            {
                from: 360000,
                base: 11115,
                rate: 0.0475
            },
            {
                from: 725000,
                base: 28453,
                rate: 0.0515
            }
        ],
        source: {
            url: 'https://www.wa.gov.au/organisation/department-of-treasury-and-finance/transfer-duty-assessment',
            stated: 'page last updated 30 July 2026',
            verified: true
        }
    },
    TAS: {
        state: 'TAS',
        scale: 'Property transfer duty, standard scale (from 21 October 2013)',
        minimum: 50,
        bands: [
            {
                from: 0,
                base: 50,
                rate: 0
            },
            {
                from: 3000,
                base: 50,
                rate: 0.0175
            },
            {
                from: 25000,
                base: 435,
                rate: 0.0225
            },
            {
                from: 75000,
                base: 1560,
                rate: 0.035
            },
            {
                from: 200000,
                base: 5935,
                rate: 0.04
            },
            {
                from: 375000,
                base: 12935,
                rate: 0.0425
            },
            {
                from: 725000,
                base: 27810,
                rate: 0.045
            }
        ],
        source: {
            url: 'https://www.sro.tas.gov.au/property-transfer-duties/rates-of-duty',
            stated: 'page last updated 14 June 2022; scale effective 21 October 2013',
            verified: true
        }
    },
    ACT: {
        state: 'ACT',
        scale: 'Conveyance duty, owner-occupier, non-commercial property, 2025-26 (indexed 1 July)',
        bands: [
            {
                from: 0,
                base: 0,
                rate: 0.0028
            },
            {
                from: 260000,
                base: 728,
                rate: 0.022
            },
            {
                from: 300000,
                base: 1608,
                rate: 0.034
            },
            {
                from: 500000,
                base: 8408,
                rate: 0.0432
            },
            {
                from: 750000,
                base: 19208,
                rate: 0.059
            },
            {
                from: 1000000,
                base: 33958,
                rate: 0.064
            },
            {
                from: 1455000,
                base: 0,
                rate: 0.0454,
                flatOnWhole: true
            }
        ],
        investor: {
            scale: 'Conveyance duty, non-owner-occupier, non-commercial property',
            bands: [
                {
                    from: 0,
                    base: 0,
                    rate: 0.012
                },
                {
                    from: 200000,
                    base: 2400,
                    rate: 0.022
                },
                {
                    from: 300000,
                    base: 4600,
                    rate: 0.034
                },
                {
                    from: 500000,
                    base: 11400,
                    rate: 0.0432
                },
                {
                    from: 750000,
                    base: 22200,
                    rate: 0.059
                },
                {
                    from: 1000000,
                    base: 36950,
                    rate: 0.064
                },
                {
                    from: 1455000,
                    base: 0,
                    rate: 0.0454,
                    flatOnWhole: true
                }
            ],
            source: {
                url: 'https://www.revenue.act.gov.au/rates-and-property-charges/conveyance-duty-stamp-duty/conveyance-duty-for-non-commercial-property',
                stated: 'transactions on or after 1 July 2025, as shown on 21 October 2026'
            }
        },
        source: {
            url: 'https://www.revenue.act.gov.au/rates-and-property-charges/conveyance-duty-stamp-duty/conveyance-duty-for-non-commercial-property',
            stated: 'transactions on or after 1 July 2025, confirmed 21 October 2026; the page states the owner-occupier rates are unchanged and shows no 2026-27 table',
            verified: true
        }
    },
    NT: {
        state: 'NT',
        scale: 'Stamp duty on conveyances: formula to $525,000, flat rates above',
        formulaBelow: {
            threshold: 525000,
            a: 0.06571441,
            b: 15
        },
        bands: [
            {
                from: 525000,
                base: 0,
                rate: 0.0495,
                flatOnWhole: true
            },
            {
                from: 3000000,
                base: 0,
                rate: 0.0575,
                flatOnWhole: true
            },
            {
                from: 5000000,
                base: 0,
                rate: 0.0595,
                flatOnWhole: true
            }
        ],
        source: {
            url: 'https://nt.gov.au/property/buying-and-selling-a-home/settle-the-sale/stamp-duty-buying-or-selling-a-home/conveyance-calculator',
            stated: "confirmed 21 October 2026 against the Territory Revenue Office calculator: $300,000 \u2192 $10,414.25, $500,000 \u2192 $23,928.60, $525,000 \u2192 $25,987.50, $800,000 \u2192 $39,600, $3.5m \u2192 $201,250, $6m \u2192 $357,000",
            verified: true
        }
    }
};
const $669f0c9987a611db$export$9fc195cb961f08b0 = {
    readOn: '21 October 2026',
    unverified: []
};


function $30ff538d4b47bf21$export$96fdbeb3c760993a(value) {
    return typeof value === 'string' && value in (0, $669f0c9987a611db$export$fa78cd89cb539f5);
}
function $30ff538d4b47bf21$var$dutyFromBands(bands, value) {
    let band = bands[0];
    for (const b of bands)if (value > b.from) band = b;
    if (band.flatOnWhole) return band.rate * value;
    return band.base + band.rate * (value - band.from);
}
function $30ff538d4b47bf21$export$765ba460decf7858(state, price, use = 'home') {
    if (!$30ff538d4b47bf21$export$96fdbeb3c760993a(state)) return null;
    const value = typeof price === 'number' ? price : parseFloat(String(price ?? ''));
    if (!Number.isFinite(value) || value <= 0) return null;
    const schedule = (0, $669f0c9987a611db$export$fa78cd89cb539f5)[state];
    let duty;
    if (use === 'investment' && schedule.investor) duty = $30ff538d4b47bf21$var$dutyFromBands(schedule.investor.bands, value);
    else if (schedule.formulaBelow && value <= schedule.formulaBelow.threshold) {
        const v = value / 1000;
        duty = schedule.formulaBelow.a * v * v + schedule.formulaBelow.b * v;
    } else if (schedule.generalAbove && value > schedule.generalAbove.above) duty = $30ff538d4b47bf21$var$dutyFromBands(schedule.generalAbove.bands, value);
    else duty = $30ff538d4b47bf21$var$dutyFromBands(schedule.bands, value);
    if (schedule.minimum != null) duty = Math.max(schedule.minimum, duty);
    return Math.round(duty);
}
function $30ff538d4b47bf21$export$be7ef09ba9b335a2(state, budget, use = 'home') {
    const total = typeof budget === 'number' ? budget : parseFloat(String(budget ?? ''));
    if (!Number.isFinite(total) || total <= 0) return {
        price: 0,
        duty: 0
    };
    if (!$30ff538d4b47bf21$export$96fdbeb3c760993a(state)) return {
        price: Math.round(total),
        duty: 0
    };
    let price = total;
    for(let i = 0; i < 12; i++){
        const duty = $30ff538d4b47bf21$export$765ba460decf7858(state, price, use) ?? 0;
        const next = total - duty;
        if (Math.abs(next - price) < 0.5) {
            price = next;
            break;
        }
        price = next;
    }
    price = Math.max(0, Math.round(price));
    let duty = $30ff538d4b47bf21$export$765ba460decf7858(state, price, use) ?? 0;
    // Never over the budget, to the dollar.
    while(price > 0 && price + duty > total){
        price -= 1;
        duty = $30ff538d4b47bf21$export$765ba460decf7858(state, price, use) ?? 0;
    }
    return {
        price: price,
        duty: duty
    };
}
function $30ff538d4b47bf21$export$86620b0c37a467de(state, use = 'home') {
    if (!$30ff538d4b47bf21$export$96fdbeb3c760993a(state)) return null;
    const s = (0, $669f0c9987a611db$export$fa78cd89cb539f5)[state];
    const scale = use === 'investment' && s.investor ? s.investor.scale : s.scale;
    return `${scale}. No concessions applied; an estimate to overwrite from a conveyancer's quote.`;
}


const $89d49377c5c902f9$var$StampDutyFields = ({ state: state, onStateChange: onStateChange, newHomePrice: newHomePrice, duty: duty, onDutyChange: onDutyChange, fieldClassName: fieldClassName = '', labelClassName: labelClassName = 'block text-sm font-medium text-gray-700 mb-1', selectClassName: selectClassName = 'w-full px-4 py-2 border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500', subject: subject = 'the new home', use: use = 'home' })=>{
    const price = typeof newHomePrice === 'number' ? newHomePrice : parseFloat(String(newHomePrice ?? '')) || 0;
    const estimate = (0, $30ff538d4b47bf21$export$765ba460decf7858)(state, price, use);
    // Re-struck whenever the state or the price changes. That overwrites a hand-typed figure, on
    // purpose: the alternative — remembering an override across a change of state — would keep a
    // Queensland quote on a Victorian home.
    (0, $acw62.useEffect)(()=>{
        if (estimate == null) return;
        const current = typeof duty === 'number' ? duty : parseFloat(String(duty ?? '')) || 0;
        if (current !== estimate) onDutyChange(estimate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        state,
        price,
        use
    ]);
    const chosen = (0, $30ff538d4b47bf21$export$96fdbeb3c760993a)(state) ? (0, $669f0c9987a611db$export$2f609b1773ce8fef).find((s)=>s.code === state) : undefined;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: fieldClassName,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        className: labelClassName,
                        children: [
                            "State of ",
                            subject
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                        value: chosen ? chosen.code : '',
                        onChange: (e)=>onStateChange(e.target.value),
                        className: selectClassName,
                        "aria-label": `State of ${subject}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: "",
                                children: "Select a state\u2026"
                            }),
                            (0, $669f0c9987a611db$export$2f609b1773ce8fef).map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: s.code,
                                    children: s.name
                                }, s.code))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-gray-500 mt-1",
                        children: "Each state charges stamp duty on its own scale."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: fieldClassName,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        label: "Stamp duty (estimate)",
                        name: "stampDuty",
                        value: chosen ? duty ?? '' : '',
                        onChange: (v)=>onDutyChange(v ?? 0),
                        placeholder: chosen ? 'Estimated' : 'Choose a state first',
                        disabled: !chosen,
                        className: ""
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-gray-500 mt-1",
                        children: chosen ? `On ${chosen.name}'s ${use === 'investment' ? 'rates for an investment property' : 'standard scale for a home to live in'}, no concessions. Type over it if you have a quote.` : `Choose a state above and we will estimate the duty on ${subject}. Until then, none is charged.`
                    })
                ]
            })
        ]
    });
};
var $89d49377c5c902f9$export$2e2bcd8739ae039 = $89d49377c5c902f9$var$StampDutyFields;






/**
 * THE GUARANTEED-INCOME QUESTIONS, ONE COMPONENT FOR EVERY MODULE (owner, 21 Oct 2026 — the guaranteed income
 * review and the agreed mock-up, docs/ux-review/annuities/ screens 1 and 2).
 *
 * "Clients don't know these products, so context and clarity is key" (owner). So the plain explanation is
 * always on the screen, directly under the question, never behind a link (the question leads since 22 Oct
 * 2026, so the box reads as part of it and not of the question before). Then three answers:
 *   "Yes, if the money goes back to the family" (suggested)  → appetite 'yes', residual 'back'
 *   "Yes, and the most income, even if nothing goes back"    → appetite 'yes', residual 'all'
 *   "No, keep all the money within reach"                     → appetite 'none'
 * and, unless the answer is no, "At most, how much could go into it?": 10%, 25% (suggested), 50% of the money
 * that could be invested, or another amount in dollars or as a share. The answers belong to the CLIENT
 * (annuityPreference.ts), are read by every module, and are dated for the record (`annuityAnsweredOn`),
 * which the advice document prints.
 *
 * No product or provider is named: each type is described by what the family receives.
 */ 

var $acw62 = parcelRequire("acw62");


/**
 * THE PIECES EVERY STEP 3 QUESTIONS SCREEN SHARES (owner-approved colour polish, mock-up version 3, 23 Oct 2026):
 * a navy number circle before each question, the title in navy, one "suggested" marker, and a quiet line under
 * the heading for anyone who would rather build the plan themselves. One file, so all six modules stay alike.
 */ 
parcelRequire("acw62");
const $d7fa4e176455787d$export$e31d0dd4160de6d = ({ n: n })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "inline-grid h-[26px] w-[26px] shrink-0 place-items-center rounded-full bg-brand-navy text-[13px] font-bold text-white",
        "aria-hidden": "true",
        "data-testid": "question-number",
        children: n
    });
const $d7fa4e176455787d$export$d5095ecb707035a = ({ n: n, children: children, as: Tag = 'h4', className: className = '' })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(Tag, {
        className: `flex items-start gap-2.5 text-[15px] font-semibold text-brand-navy ${className}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d7fa4e176455787d$export$e31d0dd4160de6d, {
                n: n
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "min-w-0 pt-[2px]",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "sr-only",
                        children: [
                            n,
                            ". "
                        ]
                    }),
                    children
                ]
            })
        ]
    });
const $d7fa4e176455787d$export$3aadc268e27143e6 = ({ className: className = 'ml-2' })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `inline-block whitespace-nowrap rounded-full border border-emerald-600/60 px-2 align-middle text-[11px] font-bold leading-[18px] text-emerald-700 ${className}`,
        "data-testid": "suggested-tag",
        children: "suggested"
    });
const $d7fa4e176455787d$export$b506d3545e935872 = ({ onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        className: "mt-1.5 text-[13.5px] text-slate-600",
        "data-testid": testId,
        children: [
            "Rather set the numbers yourself?",
            ' ',
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onClick,
                className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy",
                children: "Build a plan yourself"
            }),
            ' ',
            "and skip these questions."
        ]
    });



const $f92088f7258458cc$var$today = ()=>{
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
function $f92088f7258458cc$export$f32c2343f8508197(factFind) {
    const p = (0, $ff5de4128b46b139$export$636a9065c3f862c1)(factFind);
    if (p.appetite === 'none') return 'none';
    return p.residual === 'all' || p.residual === 'nil' ? 'all' : 'back';
}
function $f92088f7258458cc$export$59466c2e1cf66776(answer) {
    return answer === 'none' ? {
        annuityAppetite: 'none',
        annuityAnsweredOn: $f92088f7258458cc$var$today()
    } : {
        annuityAppetite: 'yes',
        annuityResidual: answer,
        annuityAnsweredOn: $f92088f7258458cc$var$today()
    };
}
const $f92088f7258458cc$var$Radio = ({ name: name, checked: checked, onSelect: onSelect, title: title, body: body, suggested: suggested, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
        className: `grid cursor-pointer grid-cols-[18px_1fr] items-start gap-x-3 gap-y-0.5 rounded-xl border bg-white px-3.5 py-3 ${checked ? 'border-blue-600 ring-2 ring-blue-100' : 'border-slate-200'}`,
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "radio",
                name: name,
                checked: checked,
                onChange: onSelect,
                className: "mt-1 h-4 w-4 accent-blue-600"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "text-[14px] font-semibold text-slate-900",
                children: [
                    title,
                    suggested && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d7fa4e176455787d$export$3aadc268e27143e6), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "col-start-2 text-[13.5px] text-slate-600",
                children: body
            })
        ]
    });
const $f92088f7258458cc$export$b30880333d8bfec9 = ({ factFind: factFind, onGoals: onGoals, personName: personName, investable: investable, investableLead: investableLead, investableMadeOf: investableMadeOf, investableNote: investableNote, inCare: inCare = false, fromHomeSale: fromHomeSale = false, idPrefix: idPrefix = 'gi', number: number })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    /*
     * TWO PEOPLE IN THE WORDS (owner, 22 Oct 2026: "should this read, would you consider…?"). The household
     * decides and the money is theirs, so the question, the share and the record speak to the household; the
     * income is paid to one person (the one going into care, where the screen names them), so what the
     * insurer pays and what happens when that person dies are said about them.
     */ const who = personName || v.names;
    const paidToOther = !!personName && v.couple;
    const answer = $f92088f7258458cc$export$f32c2343f8508197(factFind);
    const ceiling = (0, $ff5de4128b46b139$export$e46e91ebc7373b0a)(factFind);
    const [typesOpen, setTypesOpen] = (0, $acw62.useState)(false);
    /*
     * OPEN UNTIL ANSWERED, THEN TWO LINES (owner, 22 Oct 2026, to lighten the screen). A client meeting the question
     * for the first time always sees the whole explanation. Once an answer is on the file it folds to the warning
     * (the line that matters if the client dies early, so it never folds away) and a link that reopens the rest.
     * Decided when the question appears, so answering it never folds it away under the reader.
     */ const [explainOpen, setExplainOpen] = (0, $acw62.useState)(()=>!(0, $ff5de4128b46b139$export$636a9065c3f862c1)(factFind).answered);
    const [otherOpen, setOtherOpen] = (0, $acw62.useState)(ceiling.amount != null || ceiling.pct != null && ![
        10,
        25,
        50
    ].includes(ceiling.pct));
    const [otherText, setOtherText] = (0, $acw62.useState)(ceiling.amount != null ? String(Math.round(ceiling.amount)) : ceiling.pct != null && ![
        10,
        25,
        50
    ].includes(ceiling.pct) ? `${ceiling.pct}%` : '');
    const inv = Math.max(0, Math.round(investable));
    const pick = (pct)=>{
        setOtherOpen(false);
        onGoals({
            annuityShareCapPct: pct,
            annuityShareCapAmount: undefined,
            annuityAnsweredOn: $f92088f7258458cc$var$today()
        });
    };
    const applyOther = (raw)=>{
        setOtherText(raw);
        const t = raw.trim();
        if (!t) return;
        if (t.endsWith('%')) {
            const pct = Math.max(0, Math.min(100, parseFloat(t)));
            if (Number.isFinite(pct) && pct > 0) onGoals({
                annuityShareCapPct: pct,
                annuityShareCapAmount: undefined,
                annuityAnsweredOn: $f92088f7258458cc$var$today()
            });
            return;
        }
        const dollars = parseFloat(t.replace(/[$,\s]/g, ''));
        if (Number.isFinite(dollars) && dollars > 0) onGoals({
            annuityShareCapAmount: Math.round(dollars),
            annuityShareCapPct: undefined,
            annuityAnsweredOn: $f92088f7258458cc$var$today()
        });
    };
    const chosenPct = ceiling.amount == null ? ceiling.pct ?? (0, $ff5de4128b46b139$export$918497a7c667b06f) : null;
    const seg = (on)=>`rounded-lg border px-3.5 py-2 text-[13.5px] font-semibold ${on ? 'border-blue-600 bg-blue-50 text-brand-navy' : 'border-slate-300 bg-white text-slate-700 hover:border-blue-300'}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-4",
        "data-testid": `${idPrefix}-guaranteed-income`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-2",
                children: [
                    number != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d7fa4e176455787d$export$d5095ecb707035a), {
                        n: number,
                        as: "p",
                        children: [
                            "Would ",
                            v.names,
                            " consider putting part of ",
                            v.their,
                            " money into a guaranteed income for life",
                            paidToOther ? `, paid to ${personName}` : '',
                            "?"
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[15px] font-semibold text-slate-900",
                        children: [
                            "Would ",
                            v.names,
                            " consider putting part of ",
                            v.their,
                            " money into a guaranteed income for life",
                            paidToOther ? `, paid to ${personName}` : '',
                            "?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "space-y-2 rounded-xl border border-slate-200 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700",
                        "data-testid": `${idPrefix}-gi-explain`,
                        "data-open": explainOpen ? 'true' : 'false',
                        children: !explainOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    "data-testid": `${idPrefix}-gi-warning`,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            className: "text-slate-900",
                                            children: "Worth remembering:"
                                        }),
                                        " the money is hard to get back out, and depending on the type the family may get all, some or none of it back when ",
                                        who,
                                        " ",
                                        personName ? 'passes' : v.you ? 'pass' : `pass${v.s ? 'es' : ''}`,
                                        " away."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setExplainOpen(true),
                                    "aria-expanded": false,
                                    className: "text-[13px] font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                    "data-testid": `${idPrefix}-gi-explain-open`,
                                    children: "What it is and why it can help \u203A"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            className: "text-slate-900",
                                            children: "What it is:"
                                        }),
                                        " a guaranteed income for life (often called a lifetime annuity) is bought from a life insurer with a lump sum. In return, the insurer pays ",
                                        who,
                                        " a set income every year for as long as ",
                                        personName ? `${personName} lives` : v.you ? 'you live' : `${v.they} live`,
                                        ", however long that is.",
                                        paidToOther ? ` It would be in ${personName}'s name, as the one going into care.` : ''
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            className: "text-slate-900",
                                            children: "Why it can help:"
                                        }),
                                        " Centrelink counts only part of the money, so it can lift the Age Pension",
                                        inCare ? ` and lower what ${who} ${personName ? 'pays' : v.you ? 'pay' : `pay${v.s}`} towards care` : '',
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            className: "text-slate-900",
                                            children: "What it costs:"
                                        }),
                                        " the money is hard to get back out once it's paid. And depending on the type, the family may get all of it, some of it or none of it back when ",
                                        who,
                                        " ",
                                        personName ? 'passes' : v.you ? 'pass' : `pass${v.s ? 'es' : ''}`,
                                        " away. We show exactly which, plan by plan."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setTypesOpen((o)=>!o),
                                    "aria-expanded": typesOpen,
                                    className: "text-[13px] font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                    "data-testid": `${idPrefix}-gi-types-toggle`,
                                    children: typesOpen ? 'Hide the types' : 'More about the types'
                                }),
                                typesOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-2 border-t border-slate-100 pt-2 text-[13.5px]",
                                    "data-testid": `${idPrefix}-gi-types`,
                                    children: [
                                        inCare && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    className: "text-slate-900",
                                                    children: "Full amount back, at any time."
                                                }),
                                                " A guaranteed income combined with life cover, sold by some providers to people in aged care. The lowest income, but the whole amount goes to the family whenever ",
                                                who,
                                                " passes away. It does less for the pension and fees, because the life cover part is counted in full."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    className: "text-slate-900",
                                                    children: "Money back in the early years."
                                                }),
                                                " More income. The whole amount goes to the family if ",
                                                who,
                                                " passes away in about the first half of ",
                                                personName ? 'their' : v.their,
                                                " life expectancy, then a smaller amount, falling to nothing."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    className: "text-slate-900",
                                                    children: "Income only."
                                                }),
                                                " The most income. Nothing goes to the family, even if ",
                                                who,
                                                " passes away soon after buying it. Tested only if ",
                                                v.names,
                                                " ",
                                                v.you ? 'ask' : `ask${v.s}`,
                                                " for it."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    className: "text-slate-900",
                                                    children: "Saying yes doesn't buy anything."
                                                }),
                                                " It only lets us include a guaranteed income when we test plans for ",
                                                v.names,
                                                ". A plan uses one only if that plan does better with it. Nothing is bought until ",
                                                v.names,
                                                " ",
                                                v.have,
                                                " a written quote from the insurer and ",
                                                v.you || !v.s ? 'decide' : 'decides',
                                                " to go ahead."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "space-y-2",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f92088f7258458cc$var$Radio, {
                            name: `${idPrefix}-gi-answer`,
                            checked: answer === 'back',
                            onSelect: ()=>onGoals($f92088f7258458cc$export$59466c2e1cf66776('back')),
                            suggested: true,
                            testId: `${idPrefix}-gi-back`,
                            title: "Yes, if the money goes back to the family",
                            body: `We test the types that pay the money back to the family if ${who} ${personName ? 'passes' : v.you ? 'pass' : `pass${v.s ? 'es' : ''}`} away${inCare ? ', including one that pays the full amount back at any time' : ''}.`
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f92088f7258458cc$var$Radio, {
                            name: `${idPrefix}-gi-answer`,
                            checked: answer === 'all',
                            onSelect: ()=>onGoals($f92088f7258458cc$export$59466c2e1cf66776('all')),
                            testId: `${idPrefix}-gi-all`,
                            title: `Yes, and ${v.you ? 'you want' : `${v.names} want${v.s}`} the most income, even if nothing goes back`,
                            body: `We also test income-only types. They pay the most, but the money is not returned to the family. If a plan uses one, we will ask ${v.you ? 'you' : v.names} to confirm ${v.you ? 'you understand' : `${v.they} understand`} before it can be chosen.`
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f92088f7258458cc$var$Radio, {
                            name: `${idPrefix}-gi-answer`,
                            checked: answer === 'none',
                            onSelect: ()=>onGoals($f92088f7258458cc$export$59466c2e1cf66776('none')),
                            testId: `${idPrefix}-gi-none`,
                            title: "No, keep all the money within reach",
                            body: "No plan will use a guaranteed income."
                        })
                    ]
                })
            }),
            answer !== 'none' && /* Part of the question above, not a question of its own: set under it, unnumbered (23 Oct 2026). */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-2 border-l-2 border-slate-200 pl-4",
                "data-testid": `${idPrefix}-gi-share`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[15px] font-semibold text-slate-900",
                        children: "At most, how much could go into it?"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[13.5px] leading-relaxed text-slate-600",
                        children: [
                            investableLead,
                            ", ",
                            v.names,
                            " ",
                            v.have,
                            " about ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                className: "text-slate-900",
                                children: [
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(inv),
                                    " in savings and investments"
                                ]
                            }),
                            ": ",
                            v.possessive,
                            " ",
                            investableMadeOf,
                            ". ",
                            investableNote ? `${investableNote} ` : '',
                            fromHomeSale ? '' : `${v.Their} home isn\u{2019}t part of this. `,
                            "Money in a guaranteed income is hard to get back out, even the types that pay the family later, so we suggest keeping most of it within reach",
                            inCare ? ' for rising fees, more care' : ' for rising costs',
                            " or the unexpected."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap gap-2",
                        children: [
                            [
                                10,
                                25,
                                50
                            ].map((pct)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>pick(pct),
                                    className: seg(!otherOpen && chosenPct === pct),
                                    "data-testid": `${idPrefix}-gi-share-${pct}`,
                                    children: [
                                        pct,
                                        "% \xb7 up to ",
                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(inv * pct / 100)),
                                        pct === (0, $ff5de4128b46b139$export$918497a7c667b06f) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d7fa4e176455787d$export$3aadc268e27143e6), {
                                            className: "ml-1.5"
                                        }) : null
                                    ]
                                }, pct)),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: `${seg(otherOpen)} inline-flex items-center gap-2`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setOtherOpen(true),
                                        "data-testid": `${idPrefix}-gi-share-other`,
                                        children: "Another amount"
                                    }),
                                    otherOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        inputMode: "decimal",
                                        value: otherText,
                                        placeholder: "$ or %",
                                        onChange: (e)=>applyOther(e.target.value),
                                        className: "w-28 rounded-md border border-slate-300 px-2 py-1 text-[13.5px] font-normal text-slate-900",
                                        "aria-label": "Another amount, in dollars or as a percentage",
                                        "data-testid": `${idPrefix}-gi-share-other-input`
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[13px] text-slate-600",
                        children: [
                            "The plans never put in more than this. ",
                            v.Possessive,
                            " answer, and the date ",
                            v.you ? 'you gave it' : 'it was given',
                            ", are kept on the file and printed in the advice document.",
                            ceiling.answeredOn ? ` Last answered on ${ceiling.answeredOn}.` : ''
                        ]
                    })
                ]
            })
        ]
    });
};
var $f92088f7258458cc$export$2e2bcd8739ae039 = $f92088f7258458cc$export$b30880333d8bfec9;




const $ef4d0d82ab48599b$var$MADE_OF_WORDS = {
    bankAccounts: 'bank accounts',
    termDeposits: 'term deposits',
    shares: 'shares',
    accountBasedPensions: 'account-based pension'
};
function $ef4d0d82ab48599b$export$1bb55a1f37679989(factFind, emergencyFund, roomDeposit) {
    // An empty answer is the engine's own figure (live review, 22 Oct 2026: "the $0 kept for emergencies").
    const ef = Number(emergencyFund) > 0 ? Number(emergencyFund) : (0, $c549af0b979cab3f$export$75615f10e26bc58f)(factFind);
    const assets = (0, $c549af0b979cab3f$export$889ca99f7e02900c)(factFind, ef);
    const total = assets.reduce((t, a)=>t + (Number(a.value) || 0), 0);
    const deposit = Math.max(0, Number(roomDeposit) || 0);
    const kinds = [
        ...new Set(assets.map((a)=>$ef4d0d82ab48599b$var$MADE_OF_WORDS[a.type] || null).filter((x)=>!!x))
    ];
    const madeOf = kinds.length === 0 ? 'savings and investments' : kinds.length === 1 ? kinds[0] : `${kinds.slice(0, -1).join(', ')} and ${kinds[kinds.length - 1]}`;
    const emergency = (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(ef);
    return deposit > 0 ? {
        investable: Math.max(0, total - deposit),
        lead: `After the room deposit and the ${emergency} kept for emergencies`,
        madeOf: madeOf
    } : {
        investable: total,
        lead: `Before anything is paid towards the room, and after the ${emergency} kept for emergencies`,
        madeOf: madeOf
    };
}
const $ef4d0d82ab48599b$export$edd3a4620d1471aa = 'A plan that pays some of the room up front leaves less, and the share is then of what is left.';
/** The whole-dollar box the mock-up draws: "$50,000", typed freely, kept as a number. */ const $ef4d0d82ab48599b$var$MoneyBox = ({ id: id, value: value, onChange: onChange, className: className = '' })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
        id: id,
        type: "text",
        inputMode: "numeric",
        value: value > 0 ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(value) : '',
        onChange: (e)=>onChange(Math.max(0, parseFloat(String((0, $f94e45ac645ae232$export$dc5333890dfc7d0)(e.target.value))) || 0)),
        placeholder: "$0",
        className: `rounded-lg border border-slate-300 px-3 py-2 text-[15px] font-semibold tabular-nums text-slate-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 ${className}`
    });
const $ef4d0d82ab48599b$var$Radio = ({ name: name, checked: checked, onSelect: onSelect, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
        className: "inline-flex cursor-pointer items-center gap-2 text-[14px] text-slate-800",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "radio",
                name: name,
                checked: checked,
                onChange: onSelect,
                className: "h-4 w-4 accent-blue-600"
            }),
            children
        ]
    });
/** Numbered, as every module's questions are (owner, 23 Oct 2026: aged care's were the only ones without). */ const $ef4d0d82ab48599b$var$Question = ({ n: n, label: label, children: children, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d7fa4e176455787d$export$d5095ecb707035a), {
                n: n,
                as: "p",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-2",
                children: children
            })
        ]
    });
const $ef4d0d82ab48599b$var$Hint = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "mt-1.5 text-[13px] leading-relaxed text-slate-600",
        children: children
    });
const $ef4d0d82ab48599b$export$4c34171f7b09781d = ({ value: value, onChange: onChange, factFind: factFind, scenarioLivingExpenses: scenarioLivingExpenses, idPrefix: idPrefix = 'eq' })=>{
    const set = (patch)=>onChange({
            ...value,
            ...patch
        });
    const goals = factFind.goals || {};
    const isCouple = factFind.adviceFor === 'couple';
    const bothInCare = isCouple && goals.aged_care_for === 'both';
    const partnerEntering = goals.aged_care_for === 'partner';
    const entering = partnerEntering ? factFind.partner : factFind.client;
    const staying = partnerEntering ? factFind.client : factFind.partner;
    const enteringName = String(entering?.firstName || 'the person entering care').trim();
    const stayingName = isCouple ? String(staying?.firstName || 'your partner').trim() : null;
    const age = entering?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(entering.dob) : null;
    const health = String(entering?.healthStatus || '').trim().toLowerCase();
    const suggestedYears = (0, $761eebfc891b9eea$export$ee5aafeb340c75f8)(factFind)?.years ?? 5;
    const sixMonths = Math.round((Number(scenarioLivingExpenses) || 0) / 2);
    const suggestedEmergency = Math.max((0, $5941a0d5c38ddae8$export$ff3e96665dc0c2f8), sixMonths);
    const hasHome = (Number(factFind.home?.value) || 0) > 0;
    const hasStructures = (factFind.structures || []).length > 0;
    const thisYear = new Date().getFullYear();
    // The question reads the client's answer with any change made here on top, until the screen submits.
    const factFindWithAnswer = value.annuityGoals ? {
        ...factFind,
        goals: {
            ...factFind.goals || {},
            ...value.annuityGoals
        }
    } : factFind;
    /*
     * BEFORE THE ROOM IS PAID (owner, 22 Oct 2026: "$0 … presupposes we will definitely pay the money as a RAD").
     * The plans test paying none, half, three quarters or all of the room up front, and a guaranteed income is
     * sized as a share of what each leaves (agedCareMeansTestCandidates: the headroom on each base). So the
     * figure is the money before anything goes to the room, and the note says a deposit leaves less.
     */ const investable = $ef4d0d82ab48599b$export$1bb55a1f37679989(factFind, value.emergencyFund);
    const yearsId = `${idPrefix}-years`;
    const emergencyId = `${idPrefix}-emergency`;
    // Numbered in the order shown; EngineSetupInline's "Five things…" counts the same questions.
    let asked = 0;
    const next = ()=>{
        asked += 1;
        return asked;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-6",
        "data-testid": "engine-questions",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ef4d0d82ab48599b$var$Question, {
                n: next(),
                label: "How many years of care should we plan for?",
                testId: `${idPrefix}-q-years`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                id: yearsId,
                                type: "number",
                                min: 1,
                                max: 10,
                                value: value.years,
                                onChange: (e)=>set({
                                        years: Math.min(10, Math.max(1, parseInt(e.target.value, 10) || 1))
                                    }),
                                className: "w-24 rounded-lg border border-slate-300 px-3 py-2 text-[15px] font-semibold text-slate-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                htmlFor: yearsId,
                                className: "text-[13px] text-slate-600",
                                children: "years"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ef4d0d82ab48599b$var$Hint, {
                        children: [
                            "We suggest ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                className: "text-slate-800",
                                children: [
                                    "about ",
                                    suggestedYears
                                ]
                            }),
                            ", based on ",
                            enteringName,
                            "'s age",
                            age ? ` (${age})` : '',
                            " and health",
                            health ? ` (recorded as ${health})` : '',
                            '. Nobody knows how long care will be needed. The "left to the family" figures use this, and you can change it later to see whether the answer changes.'
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ef4d0d82ab48599b$var$Question, {
                n: next(),
                label: "How much should stay in the bank for emergencies?",
                testId: `${idPrefix}-q-emergency`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef4d0d82ab48599b$var$MoneyBox, {
                        id: emergencyId,
                        value: value.emergencyFund,
                        onChange: (n)=>set({
                                emergencyFund: n
                            }),
                        className: "w-40"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ef4d0d82ab48599b$var$Hint, {
                        children: [
                            "The plans will not spend this on the deposit. We suggest the greater of six months' living costs (",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(sixMonths),
                            ") or ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $5941a0d5c38ddae8$export$ff3e96665dc0c2f8)),
                            Math.round(value.emergencyFund) !== suggestedEmergency && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    " \u2014 ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>set({
                                                emergencyFund: suggestedEmergency
                                            }),
                                        className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                        children: [
                                            "use ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(suggestedEmergency)
                                        ]
                                    })
                                ]
                            }),
                            "."
                        ]
                    })
                ]
            }),
            hasHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ef4d0d82ab48599b$var$Question, {
                n: next(),
                label: "What happens to the family home?",
                testId: `${idPrefix}-q-home`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mb-2 text-[13px] leading-relaxed text-slate-600",
                        children: bothInCare ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "With ",
                                enteringName,
                                " and ",
                                stayingName,
                                " both in care, nobody is left living in the family home. Keeping it is always tested; say whether renting it out or selling it should be tested too."
                            ]
                        }) : isCouple ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "When ",
                                enteringName,
                                " moves into care, ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                    className: "text-slate-800",
                                    children: [
                                        stayingName,
                                        " stays in the family home"
                                    ]
                                }),
                                ". Keeping it is always tested; say whether renting it out or selling it should be tested too, so you can see the trade-off."
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "With ",
                                enteringName,
                                " in care, the family home can be kept, let out, or sold. Keeping it is always tested; say whether renting it out or selling it should be tested too."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        "data-testid": `${idPrefix}-home-choice`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef4d0d82ab48599b$var$Radio, {
                                name: `${idPrefix}-home`,
                                checked: value.testRentingHome && !value.testSellingHome,
                                onSelect: ()=>set({
                                        testRentingHome: true,
                                        testSellingHome: false
                                    }),
                                children: "Keep it \u2014 also test renting it out"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef4d0d82ab48599b$var$Radio, {
                                name: `${idPrefix}-home`,
                                checked: !value.testRentingHome,
                                onSelect: ()=>set({
                                        testRentingHome: false,
                                        testSellingHome: false
                                    }),
                                children: "Keep it, and don't rent it out"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef4d0d82ab48599b$var$Radio, {
                                name: `${idPrefix}-home`,
                                checked: value.testRentingHome && value.testSellingHome,
                                onSelect: ()=>set({
                                        testRentingHome: true,
                                        testSellingHome: true
                                    }),
                                children: isCouple && !bothInCare ? `${stayingName} stays \u{2014} compare keeping, renting out and selling` : 'Compare keeping, renting it out and selling'
                            })
                        ]
                    }),
                    value.testSellingHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                        className: "mt-3 rounded-xl border border-slate-200 bg-slate-50/60 px-4 py-3",
                        "data-testid": `${idPrefix}-sale-details`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("summary", {
                                className: "cursor-pointer text-[13px] font-semibold text-blue-700",
                                children: "Price the sale \u2014 rough numbers are fine"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-3 grid grid-cols-1 gap-4 sm:grid-cols-2",
                                children: [
                                    !bothInCare && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                htmlFor: `${idPrefix}-newhome`,
                                                className: "block text-[13px] font-semibold text-slate-800",
                                                children: [
                                                    "New home value, if ",
                                                    stayingName ? `${stayingName} downsizes` : 'downsizing'
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef4d0d82ab48599b$var$MoneyBox, {
                                                id: `${idPrefix}-newhome`,
                                                value: value.newHomeValue,
                                                onChange: (n)=>set({
                                                        newHomeValue: n
                                                    }),
                                                className: "mt-1 w-full"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-1 text-[12px] text-slate-500",
                                                children: "What a smaller home nearby would cost."
                                            })
                                        ]
                                    }),
                                    !bothInCare && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $89d49377c5c902f9$export$2e2bcd8739ae039), {
                                        state: value.newHomeState,
                                        onStateChange: (v)=>set({
                                                newHomeState: v
                                            }),
                                        newHomePrice: value.newHomeValue,
                                        duty: value.stampDuty,
                                        onDutyChange: (v)=>set({
                                                stampDuty: v
                                            }),
                                        labelClassName: "block text-[13px] font-semibold text-slate-800"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: `${idPrefix}-selling`,
                                                className: "block text-[13px] font-semibold text-slate-800",
                                                children: "Selling costs"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef4d0d82ab48599b$var$MoneyBox, {
                                                id: `${idPrefix}-selling`,
                                                value: value.sellingCosts,
                                                onChange: (n)=>set({
                                                        sellingCosts: n
                                                    }),
                                                className: "mt-1 w-full"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-1 text-[12px] text-slate-500",
                                                children: "Agent, legal and moving costs, in dollars."
                                            })
                                        ]
                                    }),
                                    isCouple && !bothInCare && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                htmlFor: `${idPrefix}-rent`,
                                                className: "block text-[13px] font-semibold text-slate-800",
                                                children: [
                                                    "Rent a year, if ",
                                                    stayingName,
                                                    " rents elsewhere"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef4d0d82ab48599b$var$MoneyBox, {
                                                id: `${idPrefix}-rent`,
                                                value: value.partnerAnnualRent,
                                                onChange: (n)=>set({
                                                        partnerAnnualRent: n
                                                    }),
                                                className: "mt-1 w-full"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-1 text-[12px] text-slate-500",
                                                children: [
                                                    "Used when the home is let out and ",
                                                    stayingName,
                                                    " lives elsewhere."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            isCouple && !bothInCare && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ef4d0d82ab48599b$var$Question, {
                n: next(),
                label: `If ${stayingName} later needs care too`,
                testId: `${idPrefix}-q-partner`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-x-6 gap-y-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef4d0d82ab48599b$var$Radio, {
                                name: `${idPrefix}-partner`,
                                checked: !value.partnerLater,
                                onSelect: ()=>set({
                                        partnerLater: false
                                    }),
                                children: "Don't model this"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ef4d0d82ab48599b$var$Radio, {
                                name: `${idPrefix}-partner`,
                                checked: value.partnerLater,
                                onSelect: ()=>set({
                                        partnerLater: true
                                    }),
                                children: [
                                    "Model ",
                                    stayingName,
                                    " entering care in \u2026"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "number",
                                "aria-label": `Year ${stayingName} enters care`,
                                min: thisYear,
                                max: thisYear + Math.max(1, value.years) - 1,
                                value: thisYear + Math.max(1, value.partnerEntryYear) - 1,
                                onChange: (e)=>{
                                    const y = parseInt(e.target.value, 10);
                                    if (!Number.isFinite(y)) return;
                                    set({
                                        partnerLater: true,
                                        partnerEntryYear: Math.min(Math.max(1, value.years), Math.max(1, y - thisYear + 1))
                                    });
                                },
                                className: "w-24 rounded-lg border border-slate-300 px-3 py-2 text-[15px] font-semibold text-slate-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                            })
                        ]
                    }),
                    value.partnerLater && value.partnerEntryYear > value.years && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 rounded-lg border border-slate-200 border-l-4 border-l-amber-400 bg-white px-3 py-2 text-[13px] leading-relaxed text-slate-700",
                        "data-testid": `${idPrefix}-partner-beyond`,
                        children: [
                            thisYear + value.partnerEntryYear - 1,
                            " is after the ",
                            value.years,
                            " ",
                            value.years === 1 ? 'year' : 'years',
                            " we plan for, so it would not change these plans. Pick an earlier year, or plan for more years above."
                        ]
                    }),
                    value.partnerLater && value.partnerEntryYear <= value.years && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ef4d0d82ab48599b$var$Hint, {
                        children: [
                            "Within the ",
                            value.years,
                            " years we plan for. A plan that still looks best once ",
                            stayingName,
                            " is in care too is shown as its own card."
                        ]
                    }),
                    value.partnerLater && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3 grid grid-cols-1 gap-4 rounded-xl border border-slate-200 bg-slate-50/60 px-4 py-3 sm:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        htmlFor: `${idPrefix}-partner-room`,
                                        className: "block text-[13px] font-semibold text-slate-800",
                                        children: [
                                            stayingName,
                                            "'s room price"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef4d0d82ab48599b$var$MoneyBox, {
                                        id: `${idPrefix}-partner-room`,
                                        value: value.partnerFutureRoomPrice,
                                        onChange: (n)=>set({
                                                partnerFutureRoomPrice: n
                                            }),
                                        className: "mt-1 w-full"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-1 text-[12px] text-slate-500",
                                        children: [
                                            "The room ",
                                            stayingName,
                                            " would take; the same price as ",
                                            enteringName,
                                            "'s unless you know otherwise."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-[13px] font-semibold text-slate-800",
                                        children: [
                                            "Is ",
                                            enteringName,
                                            " still in care then?"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-2 flex flex-wrap gap-x-5 gap-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef4d0d82ab48599b$var$Radio, {
                                                name: `${idPrefix}-alive`,
                                                checked: value.originalEntrantAlive,
                                                onSelect: ()=>set({
                                                        originalEntrantAlive: true
                                                    }),
                                                children: "Yes \u2014 two rooms at once"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ef4d0d82ab48599b$var$Radio, {
                                                name: `${idPrefix}-alive`,
                                                checked: !value.originalEntrantAlive,
                                                onSelect: ()=>set({
                                                        originalEntrantAlive: false
                                                    }),
                                                children: [
                                                    "No \u2014 ",
                                                    enteringName,
                                                    "'s deposit has come back"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "border-t border-slate-200 pt-6",
                "data-testid": `${idPrefix}-q-annuity`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f92088f7258458cc$export$2e2bcd8739ae039), {
                    number: next(),
                    factFind: factFindWithAnswer,
                    onGoals: (patch)=>set({
                            annuityGoals: {
                                ...value.annuityGoals || {},
                                ...patch
                            }
                        }),
                    personName: bothInCare || !entering?.firstName || !isCouple && (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind).you ? undefined : enteringName,
                    investable: investable.investable,
                    investableLead: investable.lead,
                    investableMadeOf: investable.madeOf,
                    investableNote: $ef4d0d82ab48599b$export$edd3a4620d1471aa,
                    inCare: true,
                    idPrefix: idPrefix
                })
            }),
            hasStructures && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ef4d0d82ab48599b$var$Question, {
                n: next(),
                label: "Money held in a family trust or company \u2014 may the plans use it for the deposit?",
                testId: `${idPrefix}-q-structures`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap gap-x-6 gap-y-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef4d0d82ab48599b$var$Radio, {
                                name: `${idPrefix}-structures`,
                                checked: value.structureFunding === 'include',
                                onSelect: ()=>set({
                                        structureFunding: 'include'
                                    }),
                                children: "Yes \u2014 test it"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef4d0d82ab48599b$var$Radio, {
                                name: `${idPrefix}-structures`,
                                checked: value.structureFunding !== 'include',
                                onSelect: ()=>set({
                                        structureFunding: 'exclude'
                                    }),
                                children: "No \u2014 personal money only"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef4d0d82ab48599b$var$Hint, {
                        children: "Either way, what the trust or company holds still counts for the pension and the care fees."
                    })
                ]
            })
        ]
    });
};
const $ef4d0d82ab48599b$var$num = (v, fallback)=>{
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : fallback;
};
function $ef4d0d82ab48599b$export$d0d86935f5605894(factFind) {
    const home = Number(factFind.home?.value) || 0;
    return home > 0 ? Math.round(home * 0.7) : 250000;
}
function $ef4d0d82ab48599b$export$36edbd5e51ac2135(bag, factFind, legacyYears, scenarioLivingExpenses, defaultPartnerRoomPrice) {
    const b = bag || {};
    const sixMonths = Math.round((Number(scenarioLivingExpenses) || 0) / 2);
    // A first visit tests selling the home (the setup pop-over's "explore all possibilities" default);
    // a later visit keeps whatever was answered.
    const answered = b.suggestionEngineSetupComplete === true;
    const testSellingHome = answered ? (Number(b.downsizeNewHomeValue) || 0) > 0 : b.exploreAlternatives !== false;
    return {
        years: $ef4d0d82ab48599b$export$ed24a42c7b9762af(factFind, legacyYears, answered),
        emergencyFund: b.emergencyFund != null && Number.isFinite(Number(b.emergencyFund)) ? Number(b.emergencyFund) : Math.max((0, $5941a0d5c38ddae8$export$ff3e96665dc0c2f8), sixMonths),
        testSellingHome: testSellingHome,
        testRentingHome: b.testRentingHome !== false,
        newHomeValue: $ef4d0d82ab48599b$var$num(b.downsizeNewHomeValue, $ef4d0d82ab48599b$export$d0d86935f5605894(factFind)),
        newHomeState: typeof b.newHomeState === 'string' ? b.newHomeState : undefined,
        stampDuty: Number(b.stampDuty) || undefined,
        sellingCosts: Number(b.sellingCosts) || 0,
        partnerAnnualRent: $ef4d0d82ab48599b$var$num(b.partnerAnnualRent, 40000),
        partnerLater: b.enablePartnerFutureEvent === true,
        partnerEntryYear: $ef4d0d82ab48599b$var$num(b.partnerEntryYear, 3),
        partnerFutureRoomPrice: $ef4d0d82ab48599b$var$num(b.partnerFutureRoomPrice, defaultPartnerRoomPrice || 500000),
        originalEntrantAlive: b.originalEntrantAliveAtPartnerEntry !== false,
        annuityGoals: null,
        structureFunding: factFind.structureFundingInSuggestions || 'exclude'
    };
}
function $ef4d0d82ab48599b$export$ed24a42c7b9762af(factFind, legacyYears, answered) {
    const suggested = (0, $761eebfc891b9eea$export$ee5aafeb340c75f8)(factFind)?.years;
    const raw = !answered && suggested != null && suggested > 0 ? suggested : Number(legacyYears) || 5;
    return Math.min(10, Math.max(1, Math.round(raw)));
}
function $ef4d0d82ab48599b$export$fd1af63bea4d2346(bag, a) {
    return {
        ...bag || {},
        exploreAlternatives: a.testSellingHome,
        testRentingHome: a.testRentingHome,
        downsizeNewHomeValue: a.testSellingHome ? a.newHomeValue : 0,
        sellingCosts: a.sellingCosts,
        stampDuty: a.stampDuty,
        newHomeState: a.newHomeState,
        partnerAnnualRent: a.partnerAnnualRent,
        enablePartnerFutureEvent: a.partnerLater,
        partnerEntryYear: a.partnerEntryYear,
        partnerFutureRoomPrice: a.partnerFutureRoomPrice,
        originalEntrantAliveAtPartnerEntry: a.originalEntrantAlive,
        emergencyFund: a.emergencyFund,
        suggestionEngineSetupComplete: true
    };
}
function $ef4d0d82ab48599b$export$e4e6d65a6e40c2df(a, factFind) {
    if (a.annuityGoals && Object.keys(a.annuityGoals).length > 0) return a.annuityGoals;
    /*
     * GOING ON WITH THE SUGGESTED ANSWER IS AN ANSWER (owner, 22 Oct 2026: "Show me the plans" did nothing).
     * The plans wait for an answer on the file (AgedCareAnalyser engineSetupDone), but a client who accepted
     * the suggested "Yes, if the money goes back" wrote nothing, so the button returned to the same form.
     * On a file never answered, the suggestion shown is written, dated for the record. An answer already on
     * the file, from any module, is still never overwritten.
     */ if (factFind && !(0, $ff5de4128b46b139$export$636a9065c3f862c1)(factFind).answered) return (0, $f92088f7258458cc$export$59466c2e1cf66776)('back');
    return null;
}
function $ef4d0d82ab48599b$export$2b1431c7169bf55c(s, factFind, testSellingHome) {
    return {
        years: Math.min(10, Math.max(1, Math.round(Number(s.legacyYears) || 5))),
        emergencyFund: Number(s.emergencyFund) || 0,
        testSellingHome: testSellingHome,
        testRentingHome: s.testRentingHome !== false,
        newHomeValue: $ef4d0d82ab48599b$var$num(s.newHomeValue, $ef4d0d82ab48599b$export$d0d86935f5605894(factFind)),
        newHomeState: s.newHomeState,
        stampDuty: Number(s.stampDuty) || undefined,
        sellingCosts: Number(s.sellingCosts) || 0,
        partnerAnnualRent: $ef4d0d82ab48599b$var$num(s.annualRentCost, 40000),
        partnerLater: s.enablePartnerFutureEvent === true,
        partnerEntryYear: $ef4d0d82ab48599b$var$num(s.partnerEntryYear, 3),
        partnerFutureRoomPrice: $ef4d0d82ab48599b$var$num(s.partnerFutureRoomPrice, 500000),
        originalEntrantAlive: s.originalEntrantAliveAtPartnerEntry !== false,
        annuityGoals: null,
        structureFunding: s.structureFundingInSuggestions || factFind.structureFundingInSuggestions || 'exclude'
    };
}
function $ef4d0d82ab48599b$export$e299b9743dccb5c7(s, a) {
    return {
        ...s,
        legacyYears: a.years,
        emergencyFund: a.emergencyFund,
        // The engine tests selling the home only while a new-home value is set (downsizeEnabled).
        newHomeValue: a.testSellingHome ? a.newHomeValue : 0,
        testRentingHome: a.testRentingHome,
        annualRentCost: a.partnerAnnualRent,
        sellingCosts: a.sellingCosts,
        stampDuty: a.stampDuty,
        newHomeState: a.newHomeState,
        enablePartnerFutureEvent: a.partnerLater,
        partnerEntryYear: a.partnerEntryYear,
        partnerFutureRoomPrice: a.partnerFutureRoomPrice,
        originalEntrantAliveAtPartnerEntry: a.originalEntrantAlive,
        structureFundingInSuggestions: a.structureFunding
    };
}
var $ef4d0d82ab48599b$export$2e2bcd8739ae039 = $ef4d0d82ab48599b$export$4c34171f7b09781d;




/**
 * The just-in-time Transfer Balance Cap question — shown only when the $1.6m screen trips for a
 * person (transferBalanceCap.ts `tbcQuestionNeededFor`): large pension balances AND a strategy
 * about to model commencing a new pension. Most files never see it.
 *
 * Answering records the ATO figure on the person (asked once, ever). Skipping lets the tool
 * estimate cap usage from current pension balances — the estimate and its limitation are stated in
 * the SOA assumptions. Either way the engine splits any commencement at the cap, so no strategy
 * can recommend more than the law allows.
 */ 

var $acw62 = parcelRequire("acw62");



const $216ea083fe16cb8b$var$TransferCapGate = ({ name: name, onAnswer: onAnswer, onSkip: onSkip })=>{
    const [amount, setAmount] = (0, $acw62.useState)('');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-3 rounded-xl bg-white border border-slate-200/70 border-l-4 border-l-blue-500 p-4 shadow-sm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-sm font-semibold text-gray-900",
                children: [
                    "One more thing \u2014 ",
                    name,
                    "'s pension cap"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-sm text-slate-700 mt-1.5",
                children: [
                    "Super held in a retirement pension pays ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "no tax at all"
                    }),
                    " on its earnings, so the government limits how much any one person may move into one over their lifetime \u2014 currently",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$807e93be6ec93c1b))
                    }),
                    ". That limit is called the",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "transfer balance cap"
                    }),
                    ", and ",
                    name,
                    "'s balances are large enough that it may now cap how much more can go in. Roughly how much has ",
                    name,
                    " moved into retirement-phase pensions over their lifetime? The ATO shows this in myGov as the ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "\u201Ctransfer balance account\u201D"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 flex items-end gap-3 flex-wrap",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "w-56",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                            label: "Lifetime amount moved into pensions ($)",
                            value: amount,
                            onChange: (v)=>setAmount(v ?? '')
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        size: "sm",
                        disabled: amount === '',
                        onClick: ()=>amount !== '' && onAnswer(Number(amount)),
                        children: "Save & continue"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        size: "sm",
                        onClick: onSkip,
                        children: "Not sure \u2014 estimate from current pension balances"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-xs text-slate-500 mt-2.5",
                children: "Saved to the client profile, so you'll only be asked once. If estimated, the assumption is stated in the Statement of Advice."
            })
        ]
    });
};
var $216ea083fe16cb8b$export$2e2bcd8739ae039 = $216ea083fe16cb8b$var$TransferCapGate;















/**
 * AgedCareSuggestionEngineDeepDive.js
 * Deep Dive modal for the Aged Care Suggestion Engine: opportunity cost, yearly projections, asset breakdown.
 * Extracted from AgedCareSuggestionEnginePanel.js for maintainability.
 */ 

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");








/**
 * Apply aged care downsize strategy options to factFind (manual control + suggestion engine).
 * Ported verbatim from frontend/src/calculations/agedCareDownsizeFactFind.js.
 */ 
function $01e8695f34f9363c$export$e4323f936f13d681(factFind, strategyOptions = {}) {
    if (!strategyOptions.downsizeHome || !strategyOptions.downsizeDetails) return factFind;
    const downsizeDetails = strategyOptions.downsizeDetails;
    const modified = structuredClone(factFind);
    if (!modified.assets) modified.assets = {};
    if (!modified.home) modified.home = {};
    const originalHomeValue = factFind.home?.value || 0;
    const sellingCosts = strategyOptions.sellingCosts || 0;
    // The duty on the new home, recorded with the downsize details it belongs to (23 Sep 2026).
    const stampDuty = Number(downsizeDetails?.stampDuty) || 0;
    const netProceeds = Math.max(0, originalHomeValue - sellingCosts - stampDuty);
    modified.home.value = (downsizeDetails.newHomePurchasePrice || 0) > 0 ? downsizeDetails.newHomePurchasePrice : 0;
    const existingRadPaid = (modified.assets.radPaid || []).reduce((sum, asset)=>sum + (asset.value || 0), 0);
    const totalRadPaid = existingRadPaid + (downsizeDetails.radAllocation || 0);
    if (totalRadPaid > 0) modified.assets.radPaid = [
        {
            id: 'rad-paid',
            description: 'RAD Paid',
            value: totalRadPaid,
            ownership: 'client'
        }
    ];
    (0, $f1228be62b68f76b$export$a72a115b20fefbbf)(modified.assets, factFind, downsizeDetails, {
        idPrefix: 'downsizer-contrib',
        partnerIdPrefix: 'partner-downsizer-contrib'
    });
    const totalAllocated = (downsizeDetails.radAllocation || 0) + (downsizeDetails.newHomePurchasePrice || 0) + (downsizeDetails.downsizerContribution || 0) + (downsizeDetails.partnerDownsizerContribution || 0);
    const unallocatedProceeds = netProceeds - totalAllocated;
    if (unallocatedProceeds > 0) {
        if (!modified.assets.bankAccounts) modified.assets.bankAccounts = [];
        if (modified.assets.bankAccounts.length > 0) {
            const first = modified.assets.bankAccounts[0];
            first.value = (first.value || 0) + unallocatedProceeds;
        } else modified.assets.bankAccounts.push({
            id: 'downsize-proceeds',
            type: 'bankAccounts',
            description: 'Downsize Proceeds',
            value: unallocatedProceeds,
            ownership: 'client',
            incomeRate: 2,
            growthRate: 0
        });
    }
    return modified;
}


function $0cb88ddfaf289d37$export$41406651e0538b82({ selectedScenario: selectedScenario, factFind: factFind, agedCareCosts: agedCareCosts, legacyYears: legacyYears, analysis: analysis, activeTab: activeTab, setActiveTab: setActiveTab, onSelectStrategy: onSelectStrategy, onClose: onClose, applyRadFundingToFactFind: applyRadFundingToFactFind, careStartDate: careStartDate, radDrawdown: radDrawdown, residentialFeeArrangements: residentialFeeArrangements, beforeContent: beforeContent = null, selectHeld: selectHeld = false, isChosen: isChosen = false }) {
    // Escape closes the window, as the X and a click outside it do (owner-approved mock-up, 25 Oct 2026).
    (0, $acw62.useEffect)(()=>{
        const onKey = (e)=>{
            if (e.key === 'Escape') {
                e.stopPropagation();
                onClose();
            }
        };
        document.addEventListener('keydown', onKey);
        return ()=>document.removeEventListener('keydown', onKey);
    }, [
        onClose
    ]);
    // The plan's name as its card says it, not the engine's ("Pay 100% RAD, Keep Home (Bank -> ABP …)").
    const plainTitle = (0, $95e43332fd84eec4$export$f973c372d76f95c8)(selectedScenario, factFind, (0, $eb4adc50b37e37f7$export$d2deef8f2a8f76eb)(selectedScenario.name)).title;
    // Who is moving in, for "against paying the room daily": the person the aged care goal is for.
    const careFor = String(factFind?.goals?.aged_care_for || 'client');
    const firstName = (who)=>String(factFind?.[who]?.firstName || '').trim();
    const movingIn = careFor === 'both' ? [
        firstName('client'),
        firstName('partner')
    ].filter(Boolean).join(' and ') || 'them' : firstName(careFor === 'partner' ? 'partner' : 'client') || 'them';
    const [year1OpeningBalance, setYear1OpeningBalance] = (0, $acw62.useState)(0);
    // Post-downsize, post-RAD-funding factFind for Year 1 — computed once here (downsizing now runs
    // server-side) and reused below wherever the render body needs "opening state for Year 1", instead
    // of recomputing it synchronously inline (which can't await a network call).
    const [year1ModifiedFactFind, setYear1ModifiedFactFind] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        // DraftFactFind is structurally compatible with FactFind/StrategyOptions
        // (see types/formDraft.ts); the shared calc-engine fn defensively coerces internally
        // regardless, and its own return type is `any` (agedCareDownsizeFactFind.ts).
        const baseFactFind = selectedScenario.strategyOptions?.downsizeHome ? (0, $01e8695f34f9363c$export$e4323f936f13d681)(factFind, selectedScenario.strategyOptions) : factFind;
        const modifiedFactFind = applyRadFundingToFactFind(baseFactFind, selectedScenario);
        setYear1ModifiedFactFind(modifiedFactFind);
        $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(modifiedFactFind, {}, 0).then((financials)=>{
            if (!cancelled) setYear1OpeningBalance(financials.netWorth || 0);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        selectedScenario,
        factFind,
        applyRadFundingToFactFind
    ]);
    /*
     * THE YEAR TOGGLE, BY RE-RUNNING THIS ONE CANDIDATE (owner, 23 Sep 2026).
     *
     * The deep dive used to hide the financial/calendar toggle, and the reason given — that it had no
     * re-run pathway — was wrong: it is the same engine. What is true, and what decides the design, is
     * that the fact-find a candidate was PROJECTED from is derived on the server (the scenario
     * applied, the downsize applied, the means-test lever applied) and never sent here. Rebuilding it
     * on this side would produce a plausible set of rows for a subtly DIFFERENT plan — the worst kind
     * of wrong, because nothing on screen would say so.
     *
     * So the re-run goes back through the engine's own entry point with this one scenario in the
     * array. One derivation, no second implementation to drift. `agedCare.test.ts` pins that a
     * single-scenario run reproduces the row the whole field produced, which is what lets the reader
     * trust that this is the candidate that was ranked.
     */ const [modalPeriodMode, setModalPeriodMode] = (0, $acw62.useState)((0, $4f50ab660c01dd64$export$1e222c2c280e2a28));
    const [calendarYearProjections, setCalendarYearProjections] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (modalPeriodMode !== 'calendar_year' || activeTab !== 'yearlyProjections') {
            setCalendarYearProjections(null);
            return undefined;
        }
        let cancelled = false;
        setCalendarYearProjections(null);
        // The scenario as the engine takes it — the same fields it was generated with, read back off
        // the row it produced.
        const scenario = {
            name: selectedScenario.name,
            radFunding: selectedScenario.radFunding ?? {},
            strategyOptions: selectedScenario.strategyOptions ?? {},
            ...selectedScenario.groupKey ? {
                groupKey: selectedScenario.groupKey
            } : {},
            ...selectedScenario.fundingOrderLabel ? {
                fundingOrderLabel: selectedScenario.fundingOrderLabel
            } : {},
            ...selectedScenario.meansTestStrategy ? {
                meansTestStrategy: selectedScenario.meansTestStrategy
            } : {}
        };
        $55a1d8a64f1e5dfa$export$4a966bd6278b0c87(factFind, agedCareCosts ?? {}, [
            scenario
        ], legacyYears, careStartDate, radDrawdown, residentialFeeArrangements, 'calendar_year').then((rows)=>{
            if (cancelled) return;
            const first = Array.isArray(rows) ? rows[0] : undefined;
            setCalendarYearProjections(first?.projections ?? []);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        modalPeriodMode,
        activeTab,
        selectedScenario,
        factFind,
        agedCareCosts,
        legacyYears,
        careStartDate,
        radDrawdown,
        residentialFeeArrangements
    ]);
    /**
     * Rendered into `document.body`, and this is the whole reason the modal was still boxed in after
     * being widened.
     *
     * `position: fixed` is relative to the VIEWPORT only while no ancestor establishes a containing
     * block — and `transform`, `filter` and `backdrop-filter` all do. This modal renders inside the
     * shared `Card`, which carries `backdrop-blur-xl`, so `fixed inset-0` was resolving against the
     * card's box rather than the screen: the overlay could never be wider than the column it sat in,
     * whatever max-width it was given. Manual Control's projections modal is not inside a Card, which
     * is why the identical markup behaves differently there.
     *
     * A portal removes the dependency entirely rather than relying on no future ancestor introducing
     * one. The Save Warning modal in the sibling panel already does this.
     */ return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-2 sm:p-4",
        onClick: onClose,
        role: "presentation",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white rounded-2xl shadow-2xl w-full max-w-screen-2xl max-h-[94vh] sm:max-h-[90vh] flex flex-col overflow-hidden border border-slate-200/80",
            onClick: (e)=>e.stopPropagation(),
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "deep-dive-title",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9847d752f8df838f$export$f89de71a2c9ebacb), {
                    titleId: "deep-dive-title",
                    title: plainTitle,
                    subtitle: `${(0, $9847d752f8df838f$export$8223046eaabd582d)(legacyYears)} in care${isChosen ? " \xb7 the plan chosen" : ''}`,
                    onClose: onClose,
                    actions: isChosen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "inline-flex h-9 items-center rounded-lg border border-emerald-600 px-3.5 text-sm font-semibold text-emerald-700",
                        "data-testid": "deep-dive-chosen",
                        children: "Chosen \u2713"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        type: "button",
                        size: "sm",
                        variant: "primary",
                        onClick: ()=>{
                            if (!selectHeld) onSelectStrategy();
                        },
                        disabled: selectHeld,
                        title: selectHeld ? 'Tick the confirmation below first' : undefined,
                        "data-testid": "deep-dive-choose",
                        children: "Choose this plan"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "p-6 flex-1 min-h-0 overflow-y-auto",
                    children: [
                        beforeContent && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "mb-6 space-y-3",
                            children: beforeContent
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "border-b border-gray-200 mb-6",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                                className: "-mb-px flex space-x-8",
                                children: [
                                    'yearlyProjections',
                                    'opportunityCost'
                                ].map((tab)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>setActiveTab(tab),
                                        className: `py-2 px-1 border-b-2 font-medium text-sm ${activeTab === tab ? 'border-blue-600 text-blue-700' : 'border-transparent text-slate-500 hover:text-slate-800 hover:border-slate-300'}`,
                                        children: [
                                            tab === 'opportunityCost' && 'What this plan changes',
                                            tab === 'yearlyProjections' && 'Year by year'
                                        ]
                                    }, tab))
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-6 transition-all duration-300 ease-in-out",
                            children: [
                                activeTab === 'opportunityCost' && (()=>{
                                    const doNothingScenario = analysis?.strategies?.find((s)=>s.name === 'Do Nothing');
                                    if (!doNothingScenario) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-slate-600",
                                        children: "There is no figure for paying the room daily to compare against."
                                    });
                                    const num = (v)=>{
                                        const n = typeof v === 'number' ? v : parseFloat(String(v));
                                        return Number.isFinite(n) ? n : 0;
                                    };
                                    // THE figure: what is left to the family after the horizon under this plan, against
                                    // paying the room daily with nothing sold. Everything else on this tab is a yearly
                                    // DRIVER of it.
                                    const planEstate = num(selectedScenario.snapshot?.legacyValue);
                                    const baseEstate = num(doNothingScenario.snapshot?.legacyValue);
                                    const legacyDelta = planEstate - baseEstate;
                                    // One sign convention throughout: positive = better off under this plan. Care costs are
                                    // therefore the SAVING (paying daily minus this plan).
                                    const pensionChange = num(selectedScenario.snapshot?.pension) - num(doNothingScenario.snapshot?.pension);
                                    const careSaving = num(doNothingScenario.snapshot?.totalAgedCareCosts) - num(selectedScenario.snapshot?.totalAgedCareCosts);
                                    const incomeChange = num(selectedScenario.snapshot?.investmentIncome) - num(doNothingScenario.snapshot?.investmentIncome);
                                    const same = (v)=>Math.round(v) === 0;
                                    // Each panel says in one plain sentence why its figure moved (owner-approved mock-up).
                                    const drivers = [
                                        {
                                            key: 'pension',
                                            title: 'Age Pension',
                                            period: 'per year',
                                            why: same(pensionChange) ? 'The pension is the same either way.' : pensionChange > 0 ? 'The deposit is not counted in the means tests, so the pension rises.' : 'More is counted in the means tests under this plan, so the pension falls.',
                                            value: pensionChange
                                        },
                                        {
                                            key: 'care',
                                            title: 'Aged care costs',
                                            period: 'per year',
                                            why: same(careSaving) ? 'Care costs are the same either way.' : careSaving > 0 ? 'Paying the room up front means less, or no, daily room fee.' : 'Care costs more each year under this plan.',
                                            value: careSaving
                                        },
                                        {
                                            key: 'investment',
                                            title: 'Investment income',
                                            period: 'per year (Year 1)',
                                            why: same(incomeChange) ? 'Investment income is the same either way.' : incomeChange < 0 ? 'The money paid as the deposit stops earning. This is what the pension and care savings cost.' : 'More is left invested under this plan, so it earns more.',
                                            value: incomeChange
                                        }
                                    ];
                                    // White panels; the figure keeps its colour, so a gain still reads green and a cost red.
                                    const valueTone = (v)=>same(v) ? 'text-slate-700' : v > 0 ? 'text-emerald-700' : 'text-red-700';
                                    const signed = (v)=>`${v >= 0 ? '+' : ''}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(v)}`;
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-6 animate-fadeIn",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "text-center mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        className: "text-2xl font-bold text-brand-navy mb-2",
                                                        children: "What this plan changes, against paying the room daily"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-slate-600",
                                                        children: [
                                                            "Each figure compares this plan with ",
                                                            movingIn,
                                                            " moving in and paying the whole room daily, nothing sold."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "rounded-2xl border border-slate-200 bg-white p-6 text-center sm:p-8",
                                                "data-testid": "deep-dive-estate",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h5", {
                                                        className: "text-lg font-bold text-slate-900",
                                                        children: [
                                                            "Left to the family after about ",
                                                            legacyYears,
                                                            " ",
                                                            legacyYears === 1 ? 'year' : 'years'
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: `text-4xl font-bold mt-2 tabular-nums ${valueTone(legacyDelta)}`,
                                                        children: signed(legacyDelta)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-sm text-slate-600 mt-3",
                                                        children: [
                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(planEstate),
                                                            " against ",
                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(baseEstate),
                                                            " if the room were paid daily. This one figure adds up every yearly effect below."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6",
                                                children: drivers.map((driver)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "rounded-2xl border border-slate-200 bg-white p-6",
                                                        "data-testid": `deep-dive-driver-${driver.key}`,
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex flex-col items-center text-center h-full",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                                    className: "text-lg font-bold text-slate-900 leading-tight mb-2",
                                                                    children: driver.title
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "text-sm text-slate-600 mb-4 leading-relaxed",
                                                                    children: driver.why
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "mt-auto",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                            className: `text-3xl font-bold mb-1 tabular-nums ${valueTone(driver.value)}`,
                                                                            children: signed(driver.value)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                            className: "text-sm text-slate-500 font-medium",
                                                                            children: driver.period
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }, driver.key))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "rounded-xl border border-slate-200 bg-white p-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                        className: "text-lg font-semibold text-slate-900 mb-4 text-center",
                                                        children: "Where the differences come from"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "divide-y divide-slate-200",
                                                        children: [
                                                            {
                                                                name: 'Age Pension, a year',
                                                                doNothing: num(doNothingScenario.snapshot?.pension),
                                                                selected: num(selectedScenario.snapshot?.pension),
                                                                betterWhenHigher: true
                                                            },
                                                            {
                                                                name: 'Aged care costs, a year',
                                                                doNothing: num(doNothingScenario.snapshot?.totalAgedCareCosts),
                                                                selected: num(selectedScenario.snapshot?.totalAgedCareCosts),
                                                                betterWhenHigher: false
                                                            },
                                                            {
                                                                name: 'Investment income, first year',
                                                                doNothing: num(doNothingScenario.snapshot?.investmentIncome),
                                                                selected: num(selectedScenario.snapshot?.investmentIncome),
                                                                betterWhenHigher: true
                                                            },
                                                            {
                                                                name: `Left to the family after about ${legacyYears} years`,
                                                                doNothing: baseEstate,
                                                                selected: planEstate,
                                                                betterWhenHigher: true
                                                            }
                                                        ].map((row)=>{
                                                            const advantage = row.betterWhenHigher ? row.selected - row.doNothing : row.doNothing - row.selected;
                                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "grid grid-cols-1 sm:grid-cols-4 gap-2 items-center py-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "text-sm font-semibold text-slate-800",
                                                                        children: row.name
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "text-center",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                className: "text-xs text-slate-500",
                                                                                children: "Paying daily"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                className: "text-base font-bold text-slate-800 tabular-nums",
                                                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.doNothing)
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "text-center",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                className: "text-xs text-slate-500",
                                                                                children: "This plan"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                className: "text-base font-bold text-brand-navy tabular-nums",
                                                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.selected)
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "text-center",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                className: "text-xs text-slate-500",
                                                                                children: row.betterWhenHigher ? 'Difference' : 'Saving'
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                className: `text-base font-bold tabular-nums ${valueTone(advantage)}`,
                                                                                children: signed(advantage)
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }, row.name);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-xs text-slate-500 mt-4",
                                                        children: [
                                                            "Yearly figures are first-year rates. The ",
                                                            legacyYears,
                                                            "-year figure will not equal the yearly differences multiplied out: balances compound, the Age Pension and care fees are reassessed each year as assets change, and one-off effects (like capital gains tax on assets sold) land once."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-[13px] text-slate-500 mt-2",
                                                        "data-testid": "deep-dive-compared-over",
                                                        children: (0, $c3eba85390498a43$export$be94b03447321f96)(legacyYears)
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                })(),
                                activeTab === 'yearlyProjections' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "animate-fadeIn -mx-6",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9847d752f8df838f$export$2d0b9ca88b9f5e66), {
                                        projections: modalPeriodMode === 'calendar_year' && calendarYearProjections ? calendarYearProjections : selectedScenario.projections ?? [],
                                        onPeriodModeChange: setModalPeriodMode,
                                        isReloading: modalPeriodMode === 'calendar_year' && !calendarYearProjections,
                                        agedCareCosts: selectedScenario.strategySpecificAgedCareCosts ?? agedCareCosts,
                                        factFind: year1ModifiedFactFind ?? factFind,
                                        currentFinancials: {
                                            netWorth: year1OpeningBalance
                                        },
                                        comparedOverYears: legacyYears
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }), document.body);
}



const $acf6b0d85046d3ca$var$LABELS = {
    bankAccounts: 'Bank accounts',
    accountBasedPensions: 'Account-based pensions',
    shares: 'Shares',
    familyHome: 'Family home'
};
function $acf6b0d85046d3ca$export$1aaf3a58e4fe820d(radFunding) {
    if (!radFunding || typeof radFunding !== 'object') return null;
    const data = [];
    Object.entries(radFunding).forEach(([type, liquidations])=>{
        const list = Array.isArray(liquidations) ? liquidations : liquidations ? [
            liquidations
        ] : [];
        const total = list.reduce((sum, l)=>sum + (l?.amount || 0), 0);
        if (total > 0) data.push({
            label: $acf6b0d85046d3ca$var$LABELS[type] || type,
            value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(total)
        });
    });
    return data.length ? data : null;
}





/**
 * The three means-test strategies the Aged Care Suggestion Engine never considered.
 *
 * WHAT WAS MISSING. The engine varied the deposit nineteen ways and permuted the funding order
 * across asset types — and never once tried the levers an Australian adviser reaches for first in a
 * residential care case. A client sitting on $900,000 of cash was shown twenty ways to split it
 * between a deposit and a daily payment, and no way at all to reduce what the means test counts.
 *
 * All three act on the ASSESSMENT rather than on the care setting, which is why they belong in every
 * module and are applied by the shared appliers in
 * server/src/rest/calculation/suggestionEngine/meansTestStrategies.ts:
 *
 *   LIFETIME ANNUITY — 60% of the purchase price is assessed as an asset (30% from the threshold
 *   day) and 60% of the payments as income. Moving $300,000 out of the bank therefore removes
 *   $120,000 from the assets test while adding only a fraction of the payment to the income test.
 *   Both the Age Pension and the means-tested care fee fall. The trade-off is liquidity: the capital
 *   is committed for life, so this suits a resident whose care is settled and not one who may need
 *   the money back. Proven end-to-end against this engine in
 *   server/tests/rest/calculation/annuityInAgedCareMeansTest.test.ts.
 *
 *   FUNERAL BONDS — exempt from the assets test up to the published limit, per person, and the money
 *   is spent on something most families buy regardless. The cleanest lever and the smallest: the
 *   limit caps how far it can move the assessment.
 *
 *   GIFTING — a gift within the yearly free area leaves the assessment immediately. Above it, the
 *   excess is still counted, and deemed to earn income, for five years under the deprivation rules
 *   even though the money is gone. So the candidates here stay INSIDE the free area: an engine that
 *   ranked a deliberately-deprived gift highly would be recommending a five-year penalty it has no
 *   way of knowing the family wants.
 *
 * WHY THESE AMOUNTS. Each lever is offered at a few sizes rather than one, because the right size
 * depends on where the client sits against the thresholds — and the engine's job is to find that,
 * not to assume it. Amounts that the client cannot fund, or that are too small to move a fee, are
 * filtered out here so they never become a card promising something it cannot deliver.
 */ 


/**
 * HOW MUCH A TESTED PLAN PUTS INTO A GUARANTEED INCOME — the one rule for every module (owner, 21 Oct 2026:
 * the village review's decision 11, applied across the board; docs/ux-review/modules/README.md).
 *
 * Up to the share of the invested money the client allows (a quarter by default), and — where it would lift
 * the Age Pension — the amount that lifts it most, as a plan of its own (shared/src/calculation/annuitySizing.ts).
 * The assets Centrelink counts after the move are estimated here only to SIZE that plan: the money being
 * invested, plus the savings, pensions, shares and investment properties already held, plus super once
 * someone has reached Age Pension age. The projection decides whether the plan actually does better.
 */ /**
 * HOW MUCH A PLAN PUTS INTO A GUARANTEED INCOME (owner, 21 Oct 2026 — the village review's decision 11,
 * applied to every module).
 *
 * The client is asked only whether they would consider one; the engine works out how much. It tests:
 *   1. up to a quarter of the money it invests (the share the client can change), never "all in";
 *   2. where it would lift the Age Pension, the amount that lifts it most — the amount that brings the
 *      assets Centrelink counts down to the full-pension limit, since only 60% of an annuity's price is
 *      counted (Social Security Guide 4.9.3.30), so each dollar moved takes 40 cents out of the count.
 * The second is offered only when it differs from the first by a meaningful amount and when, after it,
 * the counted assets would fall below the cut-off (otherwise no Age Pension is paid either way). Whether
 * the income test is what limits the pension is left to the projection: a candidate that does not lift
 * it simply does not lead.
 */ 
const $60f8985666f089ef$export$edf5afe562e8e0ed = 0.6;
const $60f8985666f089ef$export$666bafa13456685a = 25000;
function $60f8985666f089ef$export$e45eadfb3c01bdba(i) {
    if (!i.ages.some((a)=>a != null && a >= (0, $1abe73eeef086faf$export$5b6998cba7880742))) return null;
    const limits = (i.isCouple ? (0, $1abe73eeef086faf$export$9a84fd450010fb2e).couple : (0, $1abe73eeef086faf$export$9a84fd450010fb2e).single)[i.homeowner ? 'homeowner' : 'nonHomeowner'];
    const assets = Math.max(0, i.assessableAssets);
    const investable = Math.max(0, i.investable);
    if (assets <= limits.full) return null;
    const removedPerDollar = 1 - $60f8985666f089ef$export$edf5afe562e8e0ed;
    const needed = (assets - limits.full) / removedPerDollar;
    const amount = Math.min(investable, needed);
    // Still at or above the cut-off afterwards: no pension either way.
    if (assets - amount * removedPerDollar >= limits.cutoff) return null;
    const rounded = Math.floor(amount / 1000) * 1000;
    return rounded >= $60f8985666f089ef$export$666bafa13456685a ? rounded : null;
}
function $60f8985666f089ef$export$3059fa4fec6b5d22(investable, capPct, pensionMax, capAmount) {
    const byShare = Math.round(Math.max(0, investable) * (Math.max(0, Math.min(100, capPct)) / 100));
    // The client's ceiling: a share, or a dollar amount they gave (owner, 21 Oct 2026, decision D3).
    const capped = capAmount != null && capAmount > 0 ? Math.min(Math.max(0, investable), Math.round(capAmount)) : byShare;
    const out = [];
    if (capped >= $60f8985666f089ef$export$666bafa13456685a) out.push(capped);
    // The amount that lifts the Age Pension most is held to the same ceiling: tested only when it is below it.
    const pm = pensionMax != null ? Math.min(pensionMax, capped) : null;
    if (pm != null && pm >= $60f8985666f089ef$export$666bafa13456685a && out.every((a)=>Math.abs(a - pm) > Math.max(10000, a * 0.1))) out.push(pm);
    return out.sort((a, b)=>a - b);
}





/**
 * Shared funding-mechanism comparison helpers for the Suggestion Engines.
 *
 * The whole point of a Suggestion Engine is to look at the realistic ways to fund a cash outlay and let the
 * projected outcome decide — accounting for liquidation costs (CGT on shares) AND the return you give up on
 * each asset. A pensioner should usually draw a tax-free account-based pension (ABP) before selling shares and
 * realising CGT — but not always (preserving a tax-free, compounding ABP can win when the CGT is small). So we
 * generate BOTH paths as candidates and let the engine rank them, rather than hard-coding a single draw order.
 *
 * Used by the granny-flat, retirement-village and downsizer modules. Funding maps use the same `type-id` → gross
 * amount shape the manual asset pickers / liquidateChosenAssets use.
 */ 

const $70f4a8eac5c2154b$export$d68619ef49f0d534 = (factFind, type)=>(factFind?.assets?.[type] || []).reduce((s, a)=>s + (a.value || 0), 0);
function $70f4a8eac5c2154b$export$c0f19f0b2aa7e069(factFind, target, typeOrder, reserve = 0) {
    let remaining = target || 0;
    const map = {};
    (typeOrder || []).forEach((type)=>{
        if (remaining <= 0) return;
        const assets = factFind?.assets?.[type] || [];
        if (type === 'bankAccounts' && reserve > 0) {
            // Keep an emergency reserve in the bank — only the amount above the reserve is available to draw.
            const totalBank = assets.reduce((s, a)=>s + (a.value || 0), 0);
            let avail = Math.max(0, totalBank - reserve);
            assets.forEach((a)=>{
                if (remaining <= 0 || avail <= 0) return;
                const val = a.value || 0;
                const take = Math.min(val, remaining, avail);
                if (take > 0) {
                    map[`${type}-${a.id}`] = Math.round(take);
                    remaining -= take;
                    avail -= take;
                }
            });
            return;
        }
        assets.forEach((a)=>{
            if (remaining <= 0) return;
            const val = a.value || 0;
            const take = Math.min(val, remaining);
            if (take > 0) {
                map[`${type}-${a.id}`] = Math.round(take);
                remaining -= take;
            }
        });
    });
    return map;
}
/*
 * EVERY WAY TO DRAW IT, TESTED (village review decision 10, owner 21 Oct 2026: "this is important and its an
 * expectation… which account based pension do you sell down… we look at all the strategy combinations").
 * Previously at most two ways were tried (pension before shares, or shares before pension) and two pensions
 * were drawn in file order. Now spare cash goes first (the bank above the emergency money, then term
 * deposits), then every order of pensions and shares is tried, and within it every order of the pensions
 * themselves, so a couple's two pensions with different balances and growth are each tried first. Orders that draw exactly the same
 * amounts from the same accounts are one way, not several, so the list holds only real differences; the
 * projection of each decides. The usual order comes first: bank, term deposits, the pension earning least
 * (the engine's own rule for a shortfall, F.46), shares.
 */ const $70f4a8eac5c2154b$var$LIQUID_KINDS = [
    'bankAccounts',
    'termDeposits',
    'accountBasedPensions',
    'shares'
];
const $70f4a8eac5c2154b$export$2fe4aaad6ad1c64a = 24;
/** Above this many pensions, only the usual pension order is tried (4 pensions would be 24 orders each). */ const $70f4a8eac5c2154b$var$MAX_PENSIONS_PERMUTED = 3;
function $70f4a8eac5c2154b$var$permutations(arr) {
    if (arr.length <= 1) return [
        arr.slice()
    ];
    const out = [];
    arr.forEach((x, i)=>{
        $70f4a8eac5c2154b$var$permutations([
            ...arr.slice(0, i),
            ...arr.slice(i + 1)
        ]).forEach((p)=>out.push([
                x,
                ...p
            ]));
    });
    return out;
}
/** A pension started before 1 January 2015 keeps its old income-test treatment, so it is drawn last (abpPlugin.abpDrawOrder). */ const $70f4a8eac5c2154b$var$pensionOld = (a)=>a.commencementDateOption === 'pre-2015' ? 1 : 0;
/** The rate a pension is grown at in the projection: its own, or the Balanced preset when unset. */ function $70f4a8eac5c2154b$var$pensionRate(a) {
    const r = a.growthRate;
    return r == null || r === '' || !Number.isFinite(Number(r)) ? (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703).balanced.pensionNetPct : Number(r);
}
function $70f4a8eac5c2154b$var$drawSteps(steps, target, reserve, bankTotal) {
    let remaining = target || 0;
    let bankRoom = Math.max(0, bankTotal - reserve);
    const map = {};
    const drawn = [];
    steps.forEach((s)=>{
        if (remaining <= 0) return;
        let take = Math.min(Number(s.asset.value) || 0, remaining);
        if (s.type === 'bankAccounts') {
            take = Math.min(take, bankRoom);
            bankRoom -= take;
        }
        take = Math.round(take);
        if (take > 0) {
            map[`${s.type}-${s.asset.id}`] = take;
            remaining -= take;
            drawn.push(s);
        }
    });
    return {
        map: map,
        raised: (target || 0) - Math.max(0, remaining),
        drawn: drawn
    };
}
const $70f4a8eac5c2154b$var$KIND_WORD = {
    bankAccounts: 'the bank',
    termDeposits: 'term deposits',
    accountBasedPensions: 'the pension',
    shares: 'shares'
};
function $70f4a8eac5c2154b$var$drawWords(drawn, pensionCount, factFind) {
    const parts = [];
    drawn.forEach((s)=>{
        const word = s.type === 'accountBasedPensions' && pensionCount > 1 ? (0, $e850825c00b15be4$export$87285386e0429fb5)(s.asset, factFind, 'a pension') : $70f4a8eac5c2154b$var$KIND_WORD[s.type] || s.type;
        if (parts[parts.length - 1] !== word) parts.push(word);
    });
    return parts.length <= 1 ? parts.join('') : `${parts.slice(0, -1).join(', ')} then ${parts[parts.length - 1]}`;
}
function $70f4a8eac5c2154b$export$78a43ea1192852fa(factFind, target, reserve = 0) {
    const assets = factFind?.assets || {};
    const bankTotal = $70f4a8eac5c2154b$export$d68619ef49f0d534(factFind, 'bankAccounts');
    const held = (k)=>(k === 'bankAccounts' ? bankTotal - reserve : $70f4a8eac5c2154b$export$d68619ef49f0d534(factFind, k)) > 0;
    const kinds = $70f4a8eac5c2154b$var$LIQUID_KINDS.filter(held);
    const pensions = (assets.accountBasedPensions || []).filter((a)=>(Number(a.value) || 0) > 0).map((a, i)=>({
            a: a,
            i: i
        })).sort((x, y)=>$70f4a8eac5c2154b$var$pensionOld(x.a) - $70f4a8eac5c2154b$var$pensionOld(y.a) || $70f4a8eac5c2154b$var$pensionRate(x.a) - $70f4a8eac5c2154b$var$pensionRate(y.a) || x.i - y.i).map((x)=>x.a);
    const pensionOrders = pensions.length > 1 && pensions.length <= $70f4a8eac5c2154b$var$MAX_PENSIONS_PERMUTED ? $70f4a8eac5c2154b$var$permutations(pensions) : [
        pensions
    ];
    const steps = (kindOrder, pensionOrder)=>kindOrder.flatMap((k)=>k === 'accountBasedPensions' ? pensionOrder.map((asset)=>({
                    type: k,
                    asset: asset
                })) : (assets[k] || []).map((asset)=>({
                    type: k,
                    asset: asset
                })));
    const usual = $70f4a8eac5c2154b$var$drawSteps(steps([
        ...$70f4a8eac5c2154b$var$LIQUID_KINDS
    ], pensions), target, reserve, bankTotal);
    const seen = new Set();
    const sigOf = (m)=>Object.keys(m).sort().map((k)=>`${k}:${m[k]}`).join('|');
    const ways = [];
    // Spare cash goes first, always: spending it costs no tax and gives up the least return, so a plan that
    // sells shares or spends a pension while spare cash sits idle is never the better one. Every order of
    // what comes after it is tried.
    const cashKinds = kinds.filter((k)=>k === 'bankAccounts' || k === 'termDeposits');
    const restKinds = kinds.filter((k)=>k !== 'bankAccounts' && k !== 'termDeposits');
    for (const restOrder of $70f4a8eac5c2154b$var$permutations([
        ...restKinds
    ])){
        const kindOrder = [
            ...cashKinds,
            ...restOrder
        ];
        for (const pensionOrder of pensionOrders){
            const r = $70f4a8eac5c2154b$var$drawSteps(steps(kindOrder, pensionOrder), target, reserve, bankTotal);
            if (r.raised < (target || 0) - 1) continue;
            const sig = sigOf(r.map);
            if (seen.has(sig)) continue;
            seen.add(sig);
            ways.push({
                map: r.map,
                drawn: r.drawn,
                sig: sig
            });
        }
    }
    if (ways.length === 0) return [
        {
            key: '',
            nameSuffix: '',
            note: '',
            funding: usual.map
        }
    ];
    // The usual order leads when it raises the whole amount.
    const usualSig = sigOf(usual.map);
    ways.sort((a, b)=>Number(b.sig === usualSig) - Number(a.sig === usualSig));
    const kept = ways.slice(0, $70f4a8eac5c2154b$export$2fe4aaad6ad1c64a);
    if (kept.length === 1) return [
        {
            key: '',
            nameSuffix: '',
            note: '',
            funding: kept[0].map
        }
    ];
    const leadCount = {};
    return kept.map((w)=>{
        const firstAbp = w.drawn.findIndex((s)=>s.type === 'accountBasedPensions');
        const firstShares = w.drawn.findIndex((s)=>s.type === 'shares');
        const lead = firstAbp >= 0 && (firstShares < 0 || firstAbp < firstShares) ? 'abp' : firstShares >= 0 ? 'shares' : '';
        const n = leadCount[lead] = (leadCount[lead] || 0) + 1;
        const key = lead === 'abp' ? n === 1 ? '-abp' : `-${n}-abp` : lead === 'shares' ? n === 1 ? '-shares' : `-${n}-shares` : n === 1 ? '-bank' : `-${n}-bank`;
        // Owners' names on a couple's same-named pensions: "MLC then MLC" named two different plans alike.
        const words = $70f4a8eac5c2154b$var$drawWords(w.drawn, pensions.length, factFind);
        const sellsShares = firstShares >= 0;
        return {
            key: key,
            nameSuffix: ` \u{2014} from ${words}`,
            note: `Drawn from ${words}.${sellsShares ? ' Selling shares can mean capital gains tax; a pension can be drawn tax-free from 60.' : ''}`,
            funding: w.map
        };
    });
}


function $cb76d0656284f28b$export$4dc6c2d1b2b95e25(factFind, i) {
    if (!(i.capPct > 0) || !(i.investable > 0)) return [];
    const isCouple = factFind?.adviceFor === 'couple';
    const clientAge = factFind?.client?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client.dob) : null;
    const partnerAge = isCouple && factFind?.partner?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner.dob) : null;
    const counted = i.investable + [
        'bankAccounts',
        'termDeposits',
        'shares',
        'accountBasedPensions',
        'investmentProperty'
    ].reduce((t, k)=>t + (0, $70f4a8eac5c2154b$export$d68619ef49f0d534)(factFind, k), 0) + ([
        clientAge,
        partnerAge
    ].some((x)=>x != null && x >= (0, $1abe73eeef086faf$export$5b6998cba7880742)) ? (0, $70f4a8eac5c2154b$export$d68619ef49f0d534)(factFind, 'superannuation') : 0) + Math.max(0, i.extraCounted || 0) - Math.max(0, i.lessCounted || 0);
    const pensionMax = (0, $60f8985666f089ef$export$e45eadfb3c01bdba)({
        assessableAssets: counted,
        isCouple: isCouple,
        homeowner: i.homeowner,
        investable: i.investable,
        ages: [
            clientAge,
            partnerAge
        ]
    });
    const ceiling = (0, $ff5de4128b46b139$export$e46e91ebc7373b0a)(factFind, i.capPct);
    const pct = ceiling.pct ?? i.capPct;
    const capped = ceiling.amount != null ? Math.min(i.investable, Math.round(ceiling.amount)) : Math.round(i.investable * (Math.min(100, pct) / 100));
    return (0, $60f8985666f089ef$export$3059fa4fec6b5d22)(i.investable, pct, pensionMax, ceiling.amount).map((amount)=>({
            amount: amount,
            pensionMax: pensionMax != null && amount === pensionMax && amount !== capped,
            sharePct: Math.round(amount / i.investable * 100)
        }));
}
function $cb76d0656284f28b$export$839894935fc4f467(size, money) {
    return size.pensionMax ? `${money(size.amount)}, the amount that lifts the Age Pension most` : money(size.amount);
}


const $a412ceea866cc849$export$9b0b7aeb7e7f5008 = 50000;
const $a412ceea866cc849$export$fbe1109620f85b07 = 25;
/**
 * The two annuities worth putting side by side, because they are the ends of a real trade-off.
 *
 * Centrelink assesses a lifetime annuity at 60% of its purchase price WHATEVER its residual capital
 * value — RCV changes the payment rate, not the assets-test treatment. So both of these deliver the
 * same means-test relief, and they differ in what happens to the capital:
 *
 *   NIL RCV — the highest income, and nothing left for the estate. Right for a client who needs the
 *   income and is not planning around what they leave behind.
 *
 *   FULL RCV — a lower income, and the capital preserved for the estate. Right for a family weighing
 *   care costs against the inheritance, which in this module is most of them.
 *
 * Offering only nil RCV, which is what the engine did, meant every annuity candidate lost the legacy
 * ranking by its full purchase price on day one: the strategy was not being weighed, it was being
 * disqualified. Naming both lets the ranking decide rather than the default.
 */ const $a412ceea866cc849$var$ANNUITY_RCV_VARIANTS = [
    {
        residualCapital: 0,
        label: 'nil residual',
        note: 'This version pays the most income and leaves nothing of the purchase price to the estate.'
    },
    /*
     * RISING WITH INFLATION (15 Oct 2026): the nil-residual shape with the payment indexed to CPI each
     * year — Challenger's indexed Liquid Lifetime, UniSuper's Lifetime Income. It starts lower (the
     * sheet's own indexed table prices it) and overtakes the flat payment as the years pass; Centrelink
     * assesses it exactly as the plain shape. Product-agnostic, like the other three.
     */ {
        residualCapital: 0,
        indexation: true,
        label: 'rising with inflation',
        note: 'This version starts with a lower income that rises with inflation every year, and leaves nothing of the purchase price to the estate.'
    },
    {
        residualCapital: 1,
        label: 'capital returned',
        note: "This version pays less income, and the purchase price comes back to the estate if death is within the first half of life expectancy, less after that, and nothing beyond it \u2014 the most the rules allow while Centrelink still counts only 60% either way."
    },
    /*
     * THE GUARANTEED SHAPE (27 Sep 2026): an annuity and a life policy bought together, so the full
     * amount comes back to the estate whenever death comes. It pays the least income of the three
     * and, because most of the money buys the policy, earns far less assets-test relief — only the
     * annuity half is counted at 60%. It is offered only where the client is in, or entering,
     * government-subsidised aged care, which in this module is nearly everyone.
     */ {
        residualCapital: 1,
        annuityType: 'guaranteed',
        label: 'full amount guaranteed',
        note: "This version pays the least income, and the full purchase price comes back to the estate whenever death comes \u2014 a lifetime annuity and a life policy bought together. Only the annuity half earns the 60% assets-test treatment; the policy is counted at what it cost."
    }
];
/** Funeral bond sizes tried. The published limit is the ceiling, per person. */ const $a412ceea866cc849$var$FUNERAL_BOND_AMOUNTS = [
    (0, $1abe73eeef086faf$export$aca3edb7cd7a3f17) / 2,
    (0, $1abe73eeef086faf$export$aca3edb7cd7a3f17)
];
/**
 * A liquidation plan across the client's own liquid assets, cheapest-to-touch first.
 *
 * Bank before pension before shares: the bank account is already cash (no tax event, no income
 * forgone beyond interest), an account-based pension draw is tax-free at these ages, and selling
 * shares can realise capital gains. The emergency reserve is already deducted from the bank row by
 * `collectLiquidAssetsForSuggestionRad`, so a strategy can never spend the buffer.
 */ function $a412ceea866cc849$var$planFunding(assets, amount) {
    const order = [
        'bankAccounts',
        'termDeposits',
        'accountBasedPensions',
        'shares'
    ];
    const sorted = [
        ...assets
    ].sort((a, b)=>{
        const ai = order.indexOf(a.type);
        const bi = order.indexOf(b.type);
        return (ai === -1 ? order.length : ai) - (bi === -1 ? order.length : bi);
    });
    const plan = [];
    let remaining = amount;
    for (const asset of sorted){
        if (remaining <= 0) break;
        const take = Math.min(remaining, asset.value);
        if (take <= 0) continue;
        plan.push({
            type: asset.type,
            id: asset.id,
            amountToTake: take
        });
        remaining -= take;
    }
    return remaining > 0.5 ? [] : plan; // Cannot fund it in full → not a candidate.
}
const $a412ceea866cc849$var$totalAvailable = (assets)=>assets.reduce((sum, a)=>sum + a.value, 0);
/**
 * How much liquid money a scenario has already committed to the deposit.
 *
 * WITHOUT THIS, EVERY COMBINATION DOUBLE-SPENDS. A "Pay 100% RAD" scenario has already earmarked the
 * client's cash for the room; layering a $300,000 annuity on top would produce a candidate that
 * spends the same dollars twice, and the applier — which liquidates whatever it can find — would
 * quietly fund only part of it while the card kept the name. The means-test lever therefore only
 * gets what the deposit leaves behind.
 */ function $a412ceea866cc849$var$committedToRad(scenario) {
    return Object.values(scenario.radFunding ?? {}).flatMap((entries)=>Array.isArray(entries) ? entries : entries ? [
            entries
        ] : []).reduce((sum, entry)=>sum + (Number(entry.amount) || 0), 0);
}
function $a412ceea866cc849$export$ecaf526bdee0a081(a) {
    if (a?.annuityType === 'guaranteed') return 'fullBack';
    const r = a?.residualCapital != null ? Number(a.residualCapital) : Number(a?.residualPercent) / 100;
    if (Number.isFinite(r) && r > 0) return 'moneyBack';
    return a?.indexation === true || a?.indexed === true ? 'incomeOnlyRising' : 'incomeOnly';
}
const $a412ceea866cc849$export$4586a273a3098464 = {
    fullBack: 'the guaranteed income that pays the full amount back',
    moneyBack: 'the guaranteed income with money back in the early years',
    incomeOnly: 'the income-only guaranteed income',
    incomeOnlyRising: 'the income-only guaranteed income that rises with prices'
};
function $a412ceea866cc849$export$2ee327201b9e82a1(quote, kind, purchaseAmount) {
    if (quote == null) return null;
    // An unscoped number (older callers) still reaches every candidate, as before.
    if (typeof quote === 'number') return quote > 0 ? quote : null;
    if (!(quote.income > 0) || !(quote.amount > 0) || quote.kind !== kind) return null;
    return Math.round(quote.income * (purchaseAmount / quote.amount));
}
function $a412ceea866cc849$export$24e42428102d57ed(scenarios, factFind, /**
     * A provider's quoted annual income, where the client has one.
     *
     * Threaded into every annuity candidate rather than applied to the winner afterwards: a real
     * quote can change WHICH strategy wins, and a ranking done on our indicative rate would then be
     * the wrong ranking (owner, 2026-09-01).
     */ annuityIncomeOverride = null) {
    const assets = (0, $c549af0b979cab3f$export$889ca99f7e02900c)(factFind);
    if (assets.length === 0) return;
    const liquid = $a412ceea866cc849$var$totalAvailable(assets);
    if (liquid <= 0) return;
    const isPartnered = factFind.adviceFor === 'couple';
    /*
     * The scenarios worth building on: doing nothing (so the lever's own effect is visible against
     * the baseline) and the deposit levels an adviser would actually recommend. Not every level —
     * see the doc comment above.
     */ /*
     * ANCHORED AT THE START ONLY. A generated name carries a funding-order suffix whenever the
     * client has more than one way to raise the money — "Pay 50% RAD, Keep Home (Bank -> Shares)" —
     * so a pattern anchored at the END matched almost nothing, and the levers were built for a
     * handful of clients and silently skipped for everyone else. Caught by counting the candidates
     * that actually reached the engine, not by reading the code.
     *
     * One base per deposit level is enough: the levers act on the assessment, so which funding
     * PERMUTATION raised the deposit does not change what an annuity then does. Taking the first of
     * each keeps the candidate count sane.
     */ const seenLevels = new Set();
    const bases = scenarios.filter((s)=>{
        const name = s.name || '';
        if (name === 'Do Nothing') return true;
        // ", Keep Home" is absent where the client has no home (9 Oct 2026).
        const match = /^Pay (50|75|100)% RAD(?:, Keep Home)?/.exec(name);
        if (!match) return false;
        if (seenLevels.has(match[1])) return false;
        seenLevels.add(match[1]);
        return true;
    });
    if (bases.length === 0) return;
    const layered = [];
    for (const base of bases){
        const headroom = Math.max(0, liquid - $a412ceea866cc849$var$committedToRad(base));
        if (headroom <= 0) continue;
        // Rebuild the available list net of what the deposit has already taken, so the funding plan
        // for the lever cannot draw the same dollars twice.
        const spent = $a412ceea866cc849$var$committedToRad(base);
        let toDeduct = spent;
        const remainingAssets = [];
        for (const asset of assets){
            const take = Math.min(toDeduct, asset.value);
            toDeduct -= take;
            const left = asset.value - take;
            if (left > 0) remainingAssets.push({
                ...asset,
                value: left
            });
        }
        const add = (suffix, strategy)=>{
            layered.push({
                ...base,
                name: `${base.name} + ${suffix}`,
                /*
                 * A group collapses to its best-by-legacy member, so a groupKey shared by two
                 * candidates HIDES one of them. Keyed by the whole spec, not just the lever type:
                 * keyed by type alone, all eight annuity candidates on a base — four sizes times two
                 * residual-capital variants — collapsed to one, which threw away the very trade-off
                 * they exist to show.
                 */ // Every type its own slot (guaranteed income review E7, 21 Oct 2026): keyed without the type and the
                // indexation, income only hid the rising version, and money back and the full-amount-back type hid
                // each other, so the client might never see the type that protects the family.
                groupKey: `${base.groupKey ?? base.name}-${strategy.type}-${strategy.purchaseAmount ?? strategy.amount ?? 0}-${strategy.residualCapital ?? ''}-${strategy.annuityType ?? ''}-${strategy.indexation ? 'indexed' : ''}`,
                meansTestStrategy: strategy
            });
        };
        // The client's own answer decides whether an annuity is offered at all, and which versions.
        const annuityPreference = (0, $ff5de4128b46b139$export$636a9065c3f862c1)(factFind);
        /*
         * WHOSE ANNUITY (guaranteed income review E8, 21 Oct 2026): the person going into care. It was always the
         * client on the file, so where the partner was the one entering care it was priced, means-tested and
         * judged on age and health on the spouse staying at home. Both entering: the client, as before.
         */ const forWhom = factFind.goals?.aged_care_for;
        const annuityOwner = isPartnered && forWhom === 'partner' ? 'partner' : 'client';
        // A paid deposit is not counted for the Age Pension, so what it spends leaves the count too.
        const sizes = (0, $cb76d0656284f28b$export$4dc6c2d1b2b95e25)(factFind, {
            investable: headroom,
            capPct: $a412ceea866cc849$export$fbe1109620f85b07,
            homeowner: Number(factFind?.home?.value) > 0,
            lessCounted: headroom + spent
        });
        for (const size of sizes){
            const purchaseAmount = size.pensionMax ? size.amount : Math.floor(size.amount / 10000) * 10000;
            if (purchaseAmount < $a412ceea866cc849$export$9b0b7aeb7e7f5008) continue;
            if (purchaseAmount > headroom) continue;
            const fundingSources = $a412ceea866cc849$var$planFunding(remainingAssets, purchaseAmount);
            if (fundingSources.length === 0) continue;
            for (const variant of $a412ceea866cc849$var$ANNUITY_RCV_VARIANTS){
                const allowed = variant.annuityType === 'guaranteed' ? (0, $ff5de4128b46b139$export$623904c9366cf5a0)(annuityPreference, factFind, annuityOwner) : (0, $ff5de4128b46b139$export$b8876d0a37b8526a)(annuityPreference, variant.residualCapital);
                if (!allowed) continue;
                add(`$${Math.round(purchaseAmount / 1000)}k lifetime annuity (${variant.label}${size.pensionMax ? ', the amount that lifts the Age Pension most' : ''})`, {
                    type: 'annuity',
                    purchaseAmount: purchaseAmount,
                    residualCapital: variant.residualCapital,
                    ...variant.annuityType ? {
                        annuityType: variant.annuityType
                    } : {},
                    ...variant.indexation ? {
                        indexation: true
                    } : {},
                    ownership: annuityOwner,
                    incomeOverride: $a412ceea866cc849$export$2ee327201b9e82a1(annuityIncomeOverride, $a412ceea866cc849$export$ecaf526bdee0a081({
                        annuityType: variant.annuityType,
                        residualCapital: variant.residualCapital,
                        indexation: variant.indexation
                    }), purchaseAmount),
                    fundingSources: fundingSources,
                    rationale: variant.annuityType === 'guaranteed' ? "A guaranteed income for life combined with life cover. Only the income part is counted at 60% for the Age Pension and the aged care means test; the life cover is counted in full, so the pension and fee savings are smaller. " + `The money is hard to get back out. ${variant.note}` : "Centrelink counts only 60% of what a lifetime annuity costs as an asset, and 60% of its payments as income, so this takes about 40 cents in every dollar out of both the Age Pension test and the aged care means test. " + `The money is hard to get back out. ${variant.note}`
                });
            }
        }
        for (const perPerson of $a412ceea866cc849$var$FUNERAL_BOND_AMOUNTS){
            const amount = Math.round(isPartnered ? perPerson * 2 : perPerson);
            if (amount > headroom) continue;
            const fundingSources = $a412ceea866cc849$var$planFunding(remainingAssets, amount);
            if (fundingSources.length === 0) continue;
            add(`$${Math.round(amount / 1000)}k funeral bond${isPartnered ? 's' : ''}`, {
                type: 'funeralBonds',
                amount: amount,
                ownership: 'client',
                fundingSources: fundingSources,
                rationale: `A funeral bond is exempt from the assets test up to $${(0, $1abe73eeef086faf$export$aca3edb7cd7a3f17).toLocaleString('en-AU')} per person, ` + 'so this money stops being counted while still being spent on something the family would arrange anyway.'
            });
        }
        /*
         * Gifting stays INSIDE the yearly free area. Above it the excess is counted, and deemed, for
         * five years under the deprivation rules — a real cost the engine cannot weigh against a
         * family's own reasons for making the gift, so it does not recommend one.
         */ const giftAmount = (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0);
        if (giftAmount <= headroom) {
            const fundingSources = $a412ceea866cc849$var$planFunding(remainingAssets, giftAmount);
            if (fundingSources.length > 0) add(`$${Math.round(giftAmount / 1000)}k gift within the free area`, {
                type: 'gifting',
                amount: giftAmount,
                ownership: 'client',
                fundingSources: fundingSources,
                rationale: `Gifts up to $${(0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0).toLocaleString('en-AU')} a year leave the means test straight away. ` + "Anything above that is still counted, and still deemed to earn income, for five years \u2014 so this stays " + 'inside the free area.'
            });
        }
    }
    scenarios.push(...layered);
}


/**
 * Funding care WITHOUT selling the home — the two ways, and the engine offered neither.
 *
 * WHAT WAS MISSING. Every aged care candidate that needed more money than the client had liquid
 * either sold the home, rented it, or simply paid a smaller deposit. Borrowing against the home was
 * never on the table, although Manual Control has offered it all along and the projection engine has
 * always modelled both schemes.
 *
 * That is a large hole in a module whose hardest question is usually "do we have to sell Mum's
 * house?". Families who want to keep the property — because a protected person lives there, because
 * the market is poor, because it is the family home — were shown no way to do it beyond paying the
 * daily fee out of a shrinking bank account.
 *
 * THE TWO SCHEMES, and they are not interchangeable:
 *
 *   HOME EQUITY ACCESS SCHEME (HEAS) — the government's own scheme, at a materially lower rate than
 *   any commercial product. Paid as a fortnightly stream, capped at 150% of the maximum pension
 *   rate, and the payments are NOT income for the pension. For a resident paying a daily fee out of
 *   cashflow it is almost always the cheaper of the two, and it is the one advisers reach for first.
 *   It cannot, however, produce a lump sum for a deposit.
 *
 *   REVERSE MORTGAGE — commercial, dearer, and the only one of the two that can raise a LUMP SUM.
 *   That is what makes it the option when the goal is to pay a refundable deposit rather than a
 *   daily fee: the deposit removes the daily accommodation payment, is refunded to the estate, and
 *   is exempt from the pension assets test, so borrowing to pay it can leave the family ahead even
 *   after the interest. Whether it actually does is precisely what a ranking is for.
 *
 * BOTH COMPOUND, AND NEITHER IS FREE. Nothing is repaid along the way, so the debt grows every year
 * against a house that may or may not grow faster, and it comes out of the estate at the end. The
 * candidates exist so that trade-off is priced rather than guessed at — not because borrowing is
 * usually right.
 */ 
const $5f1bad8aa5c68d3b$export$191b62d36067420e = 3.95;
const $5f1bad8aa5c68d3b$export$2103673d310c90e4 = 8.0;
/**
 * How much of the home a lender will advance, by age. Reverse mortgage lending is age-banded because
 * the loan is repaid from the estate: the older the borrower, the shorter the expected term and the
 * more a lender will release. Roughly the industry rule of thumb — 15% at 60, rising a point a year.
 */ function $5f1bad8aa5c68d3b$var$maxLoanToValue(age) {
    if (!(age > 0)) return 0.2;
    return Math.min(0.45, Math.max(0.15, 0.15 + (age - 60) * 0.01));
}
/** Fractions of the maximum advance tried, so the ranking can find the least borrowing that works. */ const $5f1bad8aa5c68d3b$var$LOAN_FRACTIONS = [
    0.5,
    1
];
/**
 * HEAS payment levels tried, as a share of the scheme's cap.
 *
 * The cap is 150% of the maximum pension rate combined (pension plus HEAS), so the most the scheme
 * can add to a full pensioner is 50% of the maximum rate. Modelling the cap and half of it is enough
 * to show the shape without a projection per dollar.
 */ const $5f1bad8aa5c68d3b$var$HEAS_FRACTIONS = [
    0.5,
    1
];
const $5f1bad8aa5c68d3b$var$FORTNIGHTS_PER_YEAR = 26;
const $5f1bad8aa5c68d3b$var$ageOf = (dob)=>{
    if (!dob) return 0;
    const born = new Date(dob);
    if (Number.isNaN(born.getTime())) return 0;
    const now = new Date();
    let age = now.getFullYear() - born.getFullYear();
    const m = now.getMonth() - born.getMonth();
    if (m < 0 || m === 0 && now.getDate() < born.getDate()) age -= 1;
    return age;
};
function $5f1bad8aa5c68d3b$export$7e7dbcee136ab855(scenarios, factFind, context) {
    const homeValue = Number(factFind?.home?.value) || 0;
    if (homeValue <= 0) return;
    const { radAmount: radAmount, otherAnnualFees: otherAnnualFees, MPIR: MPIR, scenarioLivingExpenses: scenarioLivingExpenses } = context;
    const isCouple = factFind?.adviceFor === 'couple';
    const clientAge = $5f1bad8aa5c68d3b$var$ageOf(factFind?.client?.dob);
    const partnerAge = $5f1bad8aa5c68d3b$var$ageOf(factFind?.partner?.dob);
    // A lender prices on the YOUNGER borrower — the loan runs until the last of them leaves.
    const lendingAge = isCouple && partnerAge > 0 ? Math.min(clientAge, partnerAge) : clientAge;
    const living = scenarioLivingExpenses ?? factFind.expenses?.livingExpenses;
    /*
     * HEAS — a fortnightly stream against the daily fees, with the home kept.
     *
     * The cap is on the COMBINED pension plus HEAS at 150% of the maximum rate, so what the scheme
     * can add depends on what pension is already being paid. Using 50% of the maximum rate as the
     * ceiling is the full-pensioner case and understates nothing for anyone else: a part pensioner
     * can draw more, so a candidate built on this figure is conservative in the safe direction.
     */ const maxRateAnnual = isCouple ? Number((0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).couple ?? 0) : Number((0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single ?? 0);
    const heasCeilingAnnual = maxRateAnnual * 0.5;
    if (heasCeilingAnnual > 0) for (const fraction of $5f1bad8aa5c68d3b$var$HEAS_FRACTIONS){
        const annual = Math.round(heasCeilingAnnual * fraction);
        const perFortnight = Math.round(annual / $5f1bad8aa5c68d3b$var$FORTNIGHTS_PER_YEAR);
        if (perFortnight <= 0) continue;
        scenarios.push({
            /* Named in full for the same reason: "HEAS" is an acronym, not a description. */ name: `Home Equity Access Scheme loan: $${perFortnight.toLocaleString()}/fortnight against the home, pay the DAP, keep the home`,
            radFunding: {},
            groupKey: `heas-${Math.round(fraction * 100)}`,
            fundingOrderLabel: 'Home Equity Access Scheme',
            strategyOptions: {
                annualDap: radAmount * MPIR + otherAnnualFees,
                rentHome: false,
                downsizeHome: false,
                scenarioLivingExpenses: living,
                accessHomeEquity: true,
                heas: true,
                heasDetails: {
                    paymentAmount: perFortnight,
                    paymentFrequency: 'fortnightly',
                    interestRate: $5f1bad8aa5c68d3b$export$191b62d36067420e
                }
            },
            equityReleaseRationale: `The government's Home Equity Access Scheme pays a fortnightly amount against the home at ` + `${$5f1bad8aa5c68d3b$export$191b62d36067420e}% \u{2014} far below a commercial reverse mortgage \u{2014} and the payments are not counted as ` + `income for the Age Pension. The home is kept. Nothing is repaid along the way, so the debt grows each ` + `year and comes out of the estate when the house is sold.`
        });
    }
    /*
     * REVERSE MORTGAGE — a lump sum, pointed at the deposit.
     *
     * `useForRad` is what makes this worth modelling rather than just being expensive debt: whatever
     * the deposit absorbs is exempt from the pension assets test AND removes that much daily
     * accommodation payment AND is refunded to the estate. The interest still compounds against it,
     * which is exactly the comparison the ranking exists to make.
     */ const maxLoan = Math.floor(homeValue * $5f1bad8aa5c68d3b$var$maxLoanToValue(lendingAge));
    if (maxLoan >= 50000 && radAmount > 0) for (const fraction of $5f1bad8aa5c68d3b$var$LOAN_FRACTIONS){
        const loanAmount = Math.min(radAmount, Math.round(maxLoan * fraction));
        if (loanAmount < 50000) continue;
        const radCovered = Math.min(loanAmount, radAmount);
        const pctOfRoom = Math.round(radCovered / radAmount * 100);
        scenarios.push({
            /*
                 * NAME THE PRODUCT (owner, 2026-09-01: "where a reverse mortgage is used this should
                 * be called out in the title").
                 *
                 * It read "Borrow $800k against the home for 100% of the room, keep the home", which
                 * describes an ordinary loan. A reverse mortgage is not an ordinary loan - there are
                 * no repayments, the interest compounds untouched, and it is settled out of the
                 * house. A reader who does not know which product they are looking at cannot know
                 * which questions to ask about it.
                 */ name: `Reverse mortgage: borrow ${`$${Math.round(loanAmount / 1000)}k`} against the home for ${pctOfRoom}% of the room, keep the home`,
            radFunding: {},
            groupKey: `reverse-mortgage-${pctOfRoom}`,
            fundingOrderLabel: 'Reverse mortgage',
            strategyOptions: {
                annualDap: Math.max(0, radAmount - radCovered) * MPIR + otherAnnualFees,
                rentHome: false,
                downsizeHome: false,
                scenarioLivingExpenses: living,
                accessHomeEquity: true,
                reverseMortgage: true,
                radInput: radAmount,
                reverseMortgageDetails: {
                    loanAmount: loanAmount,
                    loanPercentage: Math.round(loanAmount / homeValue * 100),
                    interestRate: $5f1bad8aa5c68d3b$export$2103673d310c90e4,
                    loanStructure: 'lump_sum',
                    regularPaymentAmount: 0,
                    regularPaymentFrequency: 'fortnightly',
                    establishmentFees: 0,
                    useForRad: true
                }
            },
            equityReleaseRationale: `Borrowing against the home pays a refundable deposit without selling it. The deposit removes that much ` + `daily accommodation payment, is exempt from the Age Pension assets test, and is refunded when care ends. ` + `Against that, the loan compounds at ${$5f1bad8aa5c68d3b$export$2103673d310c90e4}% with nothing repaid along the way, ` + `and is settled from the house \u{2014} so whether this leaves the family ahead depends on the room price, the ` + `rates and how long the stay is.`
        });
    }
}





/**
 * DEBTS THE PLAN LEAVES IN PLACE, AND WHY — one note for every module's "Explain this" (owner, 22 Oct 2026: "where
 * debts exist but are not paid off, the why … is something a human auditor would want to understand. Right now
 * without this context it looks like it hasn't been addressed").
 *
 * Every module now tests each plan twice: as it is, and with the debts paid off from the savings it leaves (aged
 * care's debt twins, the village/downsizing/granny flat/cashflow "-clear-debt" twins, support at home's "and clear
 * the debts"). So the note can say, with the figures, what paying the debts off would have done to this plan:
 *   - the plan pays them off: what, and that the repayments and interest stop;
 *   - it keeps them and the twin was tested: the twin's estate, cashflow and Age Pension against this plan's;
 *   - no twin: the debts are under the floor, or the plan leaves too little to clear them as well;
 *   - a plan built by hand, or a chosen plan opened away from the tested list: where paying off is tested.
 * Nothing here decides anything; it reports what the projections already found.
 */ 
parcelRequire("acw62");




const $fe4e1ee5e30419ba$export$8590e75f86c7d73 = (0, $485d903040fc3504$export$fe12727427ec68c1);
function $fe4e1ee5e30419ba$export$6c8328762efe12d3(factFind) {
    const out = [];
    for (const [category, list] of Object.entries(factFind?.liabilities || {})){
        if (!Array.isArray(list)) continue;
        for (const l of list){
            if (!l || l.type === 'reverse_mortgage' || category === 'reverseMortgages') continue;
            const balance = Number(l.balance ?? l.value) || 0;
            if (!(balance > 0)) continue;
            const paidInFull = (0, $55a6490f14a54563$export$b0f8a46bdf3c210d)(l, category) && (0, $55a6490f14a54563$export$ee09c2c29b17798e)(l) === 'full';
            out.push({
                description: String(l.description || 'debt').trim(),
                balance: balance,
                interestRate: (0, $55a6490f14a54563$export$7d8ffbf26dcfd37b)(l, category),
                ...paidInFull ? {
                    paidInFull: true
                } : {}
            });
        }
    }
    return out;
}
function $fe4e1ee5e30419ba$export$abbf1dec1caebd5a(factFind) {
    return (0, $485d903040fc3504$export$718566aeb53e1efe)($fe4e1ee5e30419ba$export$6c8328762efe12d3(factFind)).reduce((t, d)=>t + d.balance, 0);
}
const $fe4e1ee5e30419ba$var$signed = (n)=>`${n >= 0 ? '+' : "\u2212"}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(n)))}`;
function $fe4e1ee5e30419ba$export$828e4e226107240a(i) {
    const words = $fe4e1ee5e30419ba$var$debtsInPlanSentences(i);
    // A card paid off in full each month is a monthly bill, not a decision (debtsToTest.ts): one line says so.
    const monthly = (0, $485d903040fc3504$export$8a770cd4c4b536eb)($fe4e1ee5e30419ba$export$6c8328762efe12d3(i.factFind));
    if (!words) return monthly ? [
        monthly
    ] : null;
    return monthly ? [
        ...words,
        monthly
    ] : words;
}
function $fe4e1ee5e30419ba$var$debtsInPlanSentences(i) {
    const debts = $fe4e1ee5e30419ba$export$6c8328762efe12d3(i.factFind).filter((d)=>!d.paidInFull);
    if (!debts.length) return null;
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(i.factFind);
    const total = debts.reduce((t, d)=>t + d.balance, 0);
    const list = debts.map((d)=>`${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(d.balance)} on the ${d.description}`).join(debts.length > 2 ? ', ' : ' and ');
    const many = debts.length > 1;
    const it = many ? 'them' : 'it';
    const theDebts = many ? 'the debts' : 'the debt';
    const owe = `${v.Names} ${v.you ? 'owe' : `owe${v.s}`} ${list}.`;
    const cleared = Math.max(0, Number(i.clearedAmount) || 0);
    if (cleared >= total - 1) return [
        owe,
        `This plan pays ${debts.length > 1 ? 'them' : 'it'} off from savings. The repayments and the interest stop, and the money used is no longer in the bank.`
    ];
    if (cleared > 0) return [
        owe,
        `This plan pays ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(cleared)} of it off from savings, and keeps the rest. The repayments and interest on what is paid off stop.`
    ];
    if (i.context === 'manual') return [
        owe,
        `This plan keeps ${debts.length > 1 ? 'them' : 'it'}. Paying ${debts.length > 1 ? 'them' : 'it'} off can be added to a plan built by hand, and the plans we tested try each plan with the debts paid off too.`
    ];
    if (i.twin && i.plan) {
        const years = i.years ? ` after ${i.years} ${i.years === 1 ? 'year' : 'years'}` : '';
        const dEstate = i.twin.estate - i.plan.estate;
        const dCash = i.twin.cashflow - i.plan.cashflow;
        const dPension = i.twin.pension - i.plan.pension;
        const verdict = dEstate < -1 ? `So keeping ${theDebts} leaves more to the family.` : dEstate > 1 ? `Paying ${it} off leaves more to the family; that version is among the plans tested and can be chosen instead.` : 'Either way, what is left to the family is about the same.';
        return [
            owe,
            `This plan keeps ${debts.length > 1 ? 'them' : 'it'}. We also tested the same plan with ${debts.length > 1 ? 'the debts' : 'the debt'} paid off from savings. Against this plan, that version leaves ${Math.abs(dEstate) < 1 ? 'the same' : $fe4e1ee5e30419ba$var$signed(dEstate)} to the family${years}, ${Math.abs(dCash) < 1 ? 'the same' : `${$fe4e1ee5e30419ba$var$signed(dCash)} a year`} to spend and ${Math.abs(dPension) < 1 ? 'the same Age Pension' : `${$fe4e1ee5e30419ba$var$signed(dPension)} a year of Age Pension`}.`,
            verdict
        ];
    }
    if ((0, $485d903040fc3504$export$718566aeb53e1efe)(debts).length === 0) return [
        owe,
        `This plan keeps ${debts.length > 1 ? 'them' : 'it'}. ${many ? 'They cost' : 'It costs'} no interest, and interest-free debts under ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)($fe4e1ee5e30419ba$export$8590e75f86c7d73)} in total are not tested paid off beside each plan; paying ${debts.length > 1 ? 'them' : 'it'} from savings would barely move these figures.`
    ];
    if (i.context === 'chosen') return [
        owe,
        `This plan keeps ${it}. The plans we tested try each plan with ${theDebts} paid off from savings as well; the version that pays ${it} off is shown there, where it could be funded.`
    ];
    return [
        owe,
        `This plan keeps ${it}. It was not tested with ${theDebts} paid off as well: what it leaves in savings, after the money kept for emergencies, does not cover ${it}.`
    ];
}
const $fe4e1ee5e30419ba$export$884a253c2f6e4eb4 = (props)=>{
    const words = $fe4e1ee5e30419ba$export$828e4e226107240a(props);
    if (!words) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-5 rounded-xl border border-slate-200 border-l-4 border-l-slate-400 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700",
        "data-testid": "debts-in-plan",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "font-bold text-slate-900",
                children: "Debts"
            }),
            words.map((w, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "mt-1",
                    children: w
                }, i))
        ]
    });
};
var $fe4e1ee5e30419ba$export$2e2bcd8739ae039 = $fe4e1ee5e30419ba$export$884a253c2f6e4eb4;


/**
 * CAPITAL GAINS TAX ON A HOME KEPT AND RENTED OUT — said in every "Explain this" for such a plan, whatever the years
 * planned (owner, 22 Oct 2026: "even if they still model only for 5 years the clients need to be aware of this.
 * Ultimately the projection period is just a period.. we dont know how long the clients will realistically live").
 *
 * The estate figure already nets the tax (estateCgtOnRentedHome): nil while the home has been let six years or less,
 * then the share of the gain beyond six years. This note says the rule, and whether the years planned reach it.
 */ 
parcelRequire("acw62");
function $6a8295193c5be8a0$export$797fdf7318f00319(horizonYears, they = 'they') {
    const within = horizonYears <= 6;
    return [
        'While the home is let, it stays free of capital gains tax for up to six years from when it is first rented out, as long as no other home is treated as the main residence. After six years, part of the gain is taxed when it is sold, including when the family sells it after a death.',
        within ? `The ${horizonYears} ${horizonYears === 1 ? 'year' : 'years'} planned are inside the six, so the figure left to the family has no tax taken off for it. But nobody knows how long ${they} will live or need care: if the home is still let after six years, some of the gain will be taxed, and the longer it is let the more of it is.` : `The ${horizonYears} years planned go past the six, so the figure left to the family already takes off the tax on the part of the gain beyond six years. The longer the home is let, the more of the gain is taxed.`
    ];
}
const $6a8295193c5be8a0$export$317551fdc057bc96 = ({ horizonYears: horizonYears, they: they = 'they', testId: testId = 'rented-home-cgt' })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-5 rounded-xl border border-slate-200 border-l-4 border-l-slate-400 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "font-bold text-slate-900",
                children: "Capital gains tax on the home"
            }),
            $6a8295193c5be8a0$export$797fdf7318f00319(horizonYears, they).map((w, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "mt-1",
                    children: w
                }, i))
        ]
    });
var $6a8295193c5be8a0$export$2e2bcd8739ae039 = $6a8295193c5be8a0$export$317551fdc057bc96;


/**
 * A PLAN SET ASIDE, OPENED AS ITS OWN CARD (owner, 23 Oct 2026: "See it anyway" opened the year-by-year
 * projections, not the plan). The note says why the plan was set aside; its link opens the plan's card
 * right beneath it, the same card the leading plans have, with Explain this, What could go wrong and Choose.
 * The plan is never promoted: it shows only when asked for, and "Hide it" folds it away again.
 */ 

var $acw62 = parcelRequire("acw62");
const $8dcabb024256f5a9$var$SetAsideReveal = ({ note: note, renderCard: renderCard, className: className, linkClassName: linkClassName = 'font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4', testId: testId })=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    const link = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        type: "button",
        onClick: ()=>setOpen((o)=>!o),
        "aria-expanded": open,
        className: linkClassName,
        "data-testid": `${testId}-toggle`,
        children: open ? 'Hide it' : 'See it anyway'
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: className,
                "data-testid": testId,
                children: note(link)
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": `${testId}-card`,
                children: renderCard()
            })
        ]
    });
};
var $8dcabb024256f5a9$export$2e2bcd8739ae039 = $8dcabb024256f5a9$var$SetAsideReveal;


/**
 * The chosen plan's action line — the ONE "Get the advice document" on a step-3 screen, in every
 * module (owner, 26 Oct 2026: "so long as it's consistent across the modules").
 *
 * It sits on the chosen card, where the plan was just chosen and where the reader is looking; the
 * "You've chosen …" banner above keeps its sentence but no button, so the screen has one door. When
 * the chosen plan is not among the cards shown for the goal, the plans view puts this line above the
 * cards instead, so the door is never lost.
 */ 
parcelRequire("acw62");
const $2194d8b5de21e3ff$var$link = 'font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900';
function $2194d8b5de21e3ff$export$4df4eb62309771d0({ possessiveFile: possessiveFile, onAdvice: onAdvice, onCustomise: onCustomise, extra: extra, busy: busy = false, offCard: offCard = false, testId: testId = 'chosen-plan-strip' }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-3 flex flex-wrap items-center gap-x-3 gap-y-2 rounded-lg border border-slate-200/70 border-l-4 border-l-emerald-500 bg-white px-3 py-2.5 text-[13px] text-slate-700 shadow-sm",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "min-w-[160px] flex-1",
                children: offCard ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "The chosen plan is saved with ",
                        possessiveFile,
                        " file. It isn't one of the plans shown for this goal."
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Saved with ",
                        possessiveFile,
                        " file."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onAdvice,
                disabled: busy,
                "aria-busy": busy,
                className: "inline-flex items-center gap-1.5 rounded-lg bg-blue-600 px-3.5 py-2 text-[13px] font-semibold text-white hover:bg-blue-700 disabled:opacity-60",
                "data-testid": "chosen-plan-advice",
                children: "Get the advice document \u2192"
            }),
            extra,
            onCustomise && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onCustomise,
                className: $2194d8b5de21e3ff$var$link,
                children: "Customise this plan"
            })
        ]
    });
}
var $2194d8b5de21e3ff$export$2e2bcd8739ae039 = $2194d8b5de21e3ff$export$4df4eb62309771d0;


const $ca941a2ef5e688c5$var$animationStyles = `
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .animate-fadeIn {
    animation: fadeIn 0.3s ease-in-out;
  }
  
  /* Simple Bar Chart Styles */
  .bar-chart {
    display: flex;
    align-items: end;
    height: 220px;
    gap: 30px;
    padding: 20px 30px;
    justify-content: space-around;
    background: #f9fafb;
    border-radius: 8px;
    margin: 10px 0;
  }
  
  .bar-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    gap: 8px;
    max-width: 140px;
    min-width: 120px;
  }
  
  .bar-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    width: 100%;
    margin-bottom: 8px;
  }
  
  .bar {
    width: 40px;
    border-radius: 4px 4px 0 0;
    transition: height 0.3s ease-in-out;
    position: relative;
    min-height: 4px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  .bar-keep {
    background-color: #10b981;
  }
  
  .bar-pay {
    background-color: #3b82f6;
  }
  
  .bar-income-lost {
    background-color: #ef4444;
  }
  
  .bar-benefits-gained {
    background-color: #10b981;
  }
  
  .bar-label {
    font-size: 11px;
    color: #6b7280;
    text-align: center;
    font-weight: 500;
  }
  
  .bar-value {
    font-size: 10px;
    color: #374151;
    font-weight: 600;
    margin-top: 4px;
  }
  
  .mini-bar-chart {
    display: flex;
    align-items: end;
    height: 100px;
    gap: 20px;
    padding: 10px 20px;
    justify-content: center;
    background: #f9fafb;
    border-radius: 6px;
    margin: 10px 0;
  }
  
  .mini-bar {
    width: 35px;
    border-radius: 3px 3px 0 0;
    transition: height 0.3s ease-in-out;
    position: relative;
    min-height: 3px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  }
  
  .mini-bar-label {
    font-size: 9px;
    color: #6b7280;
    text-align: center;
    font-weight: 500;
    margin-top: 4px;
  }
  
  .mini-bar-value {
    font-size: 8px;
    color: #374151;
    font-weight: 600;
    margin-top: 2px;
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .bar-chart {
      height: 180px;
      gap: 20px;
      padding: 15px 20px;
    }
    
    .bar-group {
      max-width: 100px;
      min-width: 80px;
    }
    
    .bar {
      width: 35px;
    }
    
    .bar-label {
      font-size: 10px;
    }
    
    .bar-value {
      font-size: 9px;
    }
    
    .mini-bar-chart {
      height: 80px;
      gap: 15px;
      padding: 8px 15px;
    }
    
    .mini-bar {
      width: 30px;
    }
    
    .mini-bar-label {
      font-size: 8px;
    }
    
    .mini-bar-value {
      font-size: 7px;
    }
  }
  
  @media (max-width: 480px) {
    .bar-chart {
      height: 160px;
      gap: 15px;
      padding: 10px 15px;
    }
    
    .bar-group {
      max-width: 80px;
      min-width: 70px;
    }
    
    .bar-label {
      font-size: 9px;
    }
    
    .bar-value {
      font-size: 8px;
    }
  }
`;
// Inject styles
if (typeof document !== 'undefined') {
    const styleSheet = document.createElement('style');
    styleSheet.textContent = $ca941a2ef5e688c5$var$animationStyles;
    document.head.appendChild(styleSheet);
}
const $ca941a2ef5e688c5$var$CalculationTooltip = ({ title: title, data: data, children: children, valueLayout: valueLayout = 'inline' })=>{
    const [show, setShow] = (0, $acw62.useState)(false);
    const [position, setPosition] = (0, $acw62.useState)('bottom');
    const wrapperRef = (0, $acw62.useRef)(null);
    const tooltipRef = (0, $acw62.useRef)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        if (show && wrapperRef.current && tooltipRef.current) {
            const wrapperRect = wrapperRef.current.getBoundingClientRect();
            const tooltipRect = tooltipRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - wrapperRect.bottom;
            const spaceAbove = wrapperRect.top;
            const spaceRight = window.innerWidth - wrapperRect.right;
            const spaceLeft = wrapperRect.left;
            // Prefer below, but if not enough space, show above
            if (spaceBelow < tooltipRect.height + 16 && spaceAbove > tooltipRect.height + 16) setPosition('top');
            else setPosition('bottom');
            // If not enough space to the right, shift left
            if (spaceRight < tooltipRect.width / 2) tooltipRef.current.style.left = `${window.innerWidth - tooltipRect.width - 16}px`;
            // If not enough space to the left, shift right
            if (spaceLeft < tooltipRect.width / 2) tooltipRef.current.style.left = `16px`;
        }
    }, [
        show
    ]);
    const [coords, setCoords] = (0, $acw62.useState)({
        top: 0,
        left: 0
    });
    (0, $acw62.useEffect)(()=>{
        if (show && wrapperRef.current && tooltipRef.current) {
            const rect = wrapperRef.current.getBoundingClientRect();
            const tooltipHeight = tooltipRef.current.offsetHeight || 180;
            const spaceBelow = window.innerHeight - rect.bottom;
            const spaceAbove = rect.top;
            let newPosition = position;
            // If not enough space below, show above
            if (spaceBelow < tooltipHeight + 16 && spaceAbove > tooltipHeight + 16) newPosition = 'top';
            else newPosition = 'bottom';
            setPosition(newPosition);
            setCoords({
                top: newPosition === 'top' ? rect.top - tooltipHeight - 16 : rect.bottom + 16,
                left: rect.left + rect.width / 2
            });
        }
    }, [
        show
    ]);
    // Hooks above run every render; only branch on the data shape after they're declared.
    if (!Array.isArray(data)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative",
        ref: wrapperRef,
        onMouseEnter: ()=>setShow(true),
        onMouseLeave: ()=>setShow(false),
        children: [
            children,
            show && typeof window !== 'undefined' && window.document && /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                ref: tooltipRef,
                style: {
                    position: 'fixed',
                    top: coords.top,
                    left: coords.left,
                    transform: 'translateX(-50%)',
                    zIndex: 10001,
                    width: valueLayout === 'stacked' ? 'min(28rem, 92vw)' : '340px',
                    maxWidth: '92vw',
                    pointerEvents: 'auto'
                },
                className: "p-4 bg-gray-800 text-white text-xs rounded-lg shadow-lg",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "font-bold text-sm mb-3 text-blue-300",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: valueLayout === 'stacked' ? 'space-y-3' : 'space-y-1',
                        children: data.map((item, index)=>{
                            let displayValue = item.value;
                            if (typeof displayValue === 'number' && !isNaN(displayValue)) displayValue = Math.round(displayValue).toLocaleString();
                            if (item.label.startsWith('---')) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                className: "border-gray-600 my-2"
                            }, `hr-${item.label}-${index}`);
                            if (valueLayout === 'stacked') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-left border-b border-gray-600/80 pb-3 last:border-0 last:pb-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-blue-200 font-semibold text-xs uppercase tracking-wide mb-1.5",
                                        children: item.label
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-gray-100 leading-relaxed text-[13px] whitespace-pre-line",
                                        children: displayValue
                                    })
                                ]
                            }, `row-${item.label}-${index}`);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-between gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-gray-400 shrink-0",
                                        children: [
                                            item.label,
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-mono font-semibold text-right break-words",
                                        children: displayValue
                                    })
                                ]
                            }, `row-${item.label}-${index}`);
                        })
                    })
                ]
            }), document.body)
        ]
    });
};
// AgedCareSuggestionEngineDeepDive.tsx's own prop interface isn't exported (internal to that module),
// and this panel's Strategy/AnalysisResult types are a slightly different (but structurally
// equivalent) loose shape from that file's DeepDiveScenario/DeepDiveAnalysis — widen the reference
// here rather than duplicating/exporting an interface just for this call site.
const $ca941a2ef5e688c5$var$DeepDiveModal = (0, $0cb88ddfaf289d37$export$41406651e0538b82);
const $ca941a2ef5e688c5$export$6b2690718f11a010 = (s)=>!!s?.facilityMove?.stayPut || !!s?.stayPut;
// DraftFactFind is structurally compatible with FactFind (formDraft.ts); the shared
// calc-engine fns below defensively coerce internally regardless (factFindTypes.ts header).
const $ca941a2ef5e688c5$var$asFactFind = (factFind)=>factFind;
/** Match displayed suggestion-engine cards when the same strategy name appears more than once (e.g. optimal vs lower RAD). */ function $ca941a2ef5e688c5$var$strategyCardSelectionKey(s) {
    if (!s?.name) return '';
    return [
        String(s.name),
        s.isLowerRadNearBestCard ? '1' : '0',
        s.isFutureEventOverlayCard ? '1' : '0',
        s.groupKey != null ? String(s.groupKey) : ''
    ].join('\0');
}
// Settings Form Component — "Things that change the answer": the SAME questions the inline setup asks
// before the plans run (EngineQuestions, UX review 17 Oct 2026), so there is one set of inputs, not a
// setup pop-over plus a settings dialog. The answers map back onto the engine's settings unchanged.
const $ca941a2ef5e688c5$var$SettingsForm = ({ currentSettings: currentSettings, onSave: onSave, onCancel: onCancel, factFind: factFind, scenarioLivingExpenses: scenarioLivingExpenses = 0, roomDeposit: roomDeposit })=>{
    const [answers, setAnswers] = (0, $acw62.useState)(()=>(0, $ef4d0d82ab48599b$export$2b1431c7169bf55c)(currentSettings, factFind, (Number(currentSettings.newHomeValue) || 0) > 0));
    const hasStructures = (factFind?.structures || []).length > 0;
    const handleSave = ()=>{
        const next = (0, $ef4d0d82ab48599b$export$e299b9743dccb5c7)(currentSettings, answers);
        onSave({
            ...next,
            ...hasStructures ? {
                structureFundingInSuggestions: answers.structureFunding
            } : {
                structureFundingInSuggestions: undefined
            },
            annuityGoals: (0, $ef4d0d82ab48599b$export$e4e6d65a6e40c2df)(answers, factFind)
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef4d0d82ab48599b$export$2e2bcd8739ae039), {
                value: answers,
                onChange: setAnswers,
                factFind: factFind,
                scenarioLivingExpenses: parseFloat(String(scenarioLivingExpenses)) || 0,
                idPrefix: "settings",
                roomDeposit: roomDeposit
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex justify-end space-x-3 pt-4 border-t border-gray-200",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onCancel,
                        className: "px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: handleSave,
                        className: "px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors font-semibold",
                        children: "Update the plans"
                    })
                ]
            })
        ]
    });
};
const $ca941a2ef5e688c5$export$3e437fcf33a6adaf = (isCouple)=>isCouple ? 'Estate focus; optional lower-RAD + partner-later rows when enabled.' : 'Estate focus; an optional lower-RAD row appears when a similar estate can be reached with less paid up front.';
const $ca941a2ef5e688c5$var$AgedCareSuggestionEnginePanel = ({ factFind: factFind, setFactFind: setFactFind, agedCareCosts: agedCareCosts, goals: goals = {}, onStrategySelect: onStrategySelect, selectedStrategy: selectedStrategy, legacyYears: legacyYears = 5, coupleValidation: coupleValidation = {
    downsizeNewHomeValue: 500000,
    partnerAnnualRent: 40000
}, onScenarioSaved: onScenarioSaved, onNavigateToDashboard: onNavigateToDashboard, onBuildYourOwn: onBuildYourOwn, homeName: homeName = '', openOnArrival: openOnArrival = null, onOpenedOnArrival: onOpenedOnArrival, onDoNothingRow: onDoNothingRow, onChosenPlanRetested: onChosenPlanRetested, onChosenPlanMissing: onChosenPlanMissing, inputsSettling: inputsSettling = false, strategyOptions: // Declared on the props but previously unread here. Now the source of the care start date every
// candidate is projected against — see `careStartDateFromStrategyOptions`.
strategyOptions, agedCareBaseline: /*
     * The no-plan baseline, computed once by the analyser and passed down rather than rebuilt here.
     * "Explain this" reconciles a strategy AGAINST it, and a second computation of the same
     * benchmark is exactly how the panel and the summary came to disagree by $97,649 once before.
     */ agedCareBaseline = null, reopenedSavedStrategyId: reopenedSavedStrategyId = null, selectedPlanRunwayRows: selectedPlanRunwayRows = null })=>{
    // What every card here is compared with, in this module's words (25 Oct 2026): paying daily, or staying put for a change of home.
    const bench = (0, $1a5a24a0286ded56$export$b3949d624101f360)('agedCare', {
        facilityMove: !!$ca941a2ef5e688c5$var$facilityMoveFromStrategyOptions(strategyOptions)
    });
    // Decided once, at mount; back to 'thinking' after the first run so re-runs show the work.
    const openingRef = (0, $acw62.useRef)((0, $bedf4d8bceb97e40$export$48c324a44172b224)({
        reopenedSavedStrategyId: reopenedSavedStrategyId
    }));
    /** Which strategy's plain-words explanation is open, if any. */ const [explainStrategy, setExplainStrategy] = (0, $acw62.useState)(null);
    // "What could go wrong" for one card (StrategyRisksPanel; the list is strategyRisks.ts).
    const [riskStrategy, setRiskStrategy] = (0, $acw62.useState)(null);
    /**
     * The walk-in position under every snapshot tile — the SAME no-plan baseline this page's rail
     * measures against, read once, so a card can say "$64,360, up $15,678" without the rail having
     * to repeat the plan beside it (owner, 2026-09-22). Null when the baseline could not be run, in
     * which case the tiles simply show the plan's figures.
     */ const snapshotBaseline = (0, $acw62.useMemo)(()=>{
        const fin = agedCareBaseline?.financials;
        if (!fin) return null;
        const livingRow = fin.cashFlowBreakdown?.find((r)=>typeof r.label === 'string' && r.label.includes('Living Expenses'));
        const costs = agedCareBaseline?.agedCareCosts;
        const secondCosts = agedCareBaseline?.secondAgedCareCosts;
        return {
            pension: Number(agedCareBaseline?.pension) || 0,
            investmentIncome: Number(fin.investmentIncome) || 0,
            livingExpenses: livingRow && typeof livingRow.value === 'number' ? Math.abs(livingRow.value) : Number(factFind?.expenses?.livingExpenses) || 0,
            // The first year: the second room only where both enter together (the baseline's second stage is its own figure).
            careCosts: (0, $bdfd96a4f4ac117d$export$4a7e3987a5ffaa21)(costs, agedCareBaseline?.secondEntersLater ? null : secondCosts) * 365,
            taxPayable: Number(fin.netTax) || 0,
            netCashflow: Number(agedCareBaseline?.cashFlowAfterCare) || 0
        };
    }, [
        agedCareBaseline,
        factFind
    ]);
    // Shared with the digital SOA (see futureLifeEventUtils) so the card headline and the SOA never disagree.
    const getDisplayStrategyName = (name = '', radPaidNet = null, roomPrice = null, secondRoom = null, move = null, village = null)=>(0, $eb4adc50b37e37f7$export$d2deef8f2a8f76eb)(name, radPaidNet, roomPrice, secondRoom, move, village);
    /** Leaving a village, as the row records it, for the name. */ const villageOf = (row)=>{
        const ve = row?.villageExit;
        return ve ? {
            fromVillage: Number(ve.fromVillage) || 0
        } : null;
    };
    /** A change of home, as the row records it, for the name. */ const moveOf = (row)=>{
        const mv = row?.facilityMove;
        return mv ? {
            stayPut: !!mv.stayPut,
            fromRefund: Number(mv.fromRefund) || 0
        } : null;
    };
    /** The second room a row carries, where both of a couple are in care, for the name and the words. */ const secondRoomOf = (row)=>{
        const sr = row?.secondRoom;
        if (!sr || !((Number(sr.roomPrice) || 0) > 0)) return null;
        const names = (0, $b8d3cfe4c156722e$export$24ee473c3b86ae0)(factFind, sr.person);
        return {
            radPaid: Number(sr.radPaid) || 0,
            roomPrice: Number(sr.roomPrice) || 0,
            name: names.secondName,
            leadName: names.firstName
        };
    };
    /** The second room a row carries, in full, for the allocation grid and the card's strip. */ const secondRoomRowOf = (row)=>row?.secondRoom ?? null;
    const partnerDisplayName = (0, $acw62.useMemo)(()=>(factFind?.partner?.firstName || '').trim() || 'your partner', [
        factFind?.partner?.firstName
    ]);
    const clientDisplayName = (0, $acw62.useMemo)(()=>(factFind?.client?.firstName || '').trim() || 'the person entering care first', [
        factFind?.client?.firstName
    ]);
    const [analysis, setAnalysis] = (0, $acw62.useState)(null);
    // The run's own no-plan row, up to the analyser (see the prop). Null again when the analysis clears.
    (0, $acw62.useEffect)(()=>{
        const rows = (analysis?.allSimulatedStrategies?.length ? analysis.allSimulatedStrategies : analysis?.strategies) || [];
        const row = rows.find((s)=>/^(do nothing|stay put)$/i.test(String(s?.name || '').trim())) || null;
        onDoNothingRow?.(row);
        return ()=>{
            onDoNothingRow?.(null);
        };
    }, [
        analysis,
        onDoNothingRow
    ]);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [deepDiveModal, setDeepDiveModal] = (0, $acw62.useState)(false);
    const [selectedScenario, setSelectedScenario] = (0, $acw62.useState)(null);
    const [activeTab, setActiveTab] = (0, $acw62.useState)('yearlyProjections');
    /** The advice document is being written (its snapshot builds asynchronously): one press, one document. */ const [documentBusy, setDocumentBusy] = (0, $acw62.useState)(false);
    /** Side-by-side of recommendation leaders only (legacy / cashflow / pension + optional lower RAD + future event) — not the full simulation list. */ const [showGoalLeadersModal, setShowGoalLeadersModal] = (0, $acw62.useState)(false);
    /** "Show everything tested" inside the comparison — opened directly from the ways-on row too (owner, 18 Oct 2026). */ const [everythingTestedOpen, setEverythingTestedOpen] = (0, $acw62.useState)(false);
    /* Escape closes whichever of this panel's own dialogs is open. */ (0, $acw62.useEffect)(()=>{
        const onKey = (e)=>{
            if (e.key !== 'Escape') return;
            setShowGoalLeadersModal(false);
            setShowSettingsModal(false);
            setShowAssumptionsModal(false);
        };
        document.addEventListener('keydown', onKey);
        return ()=>document.removeEventListener('keydown', onKey);
    }, []);
    /* Open what the landing asked for, once the chosen plan's row is in the run. Above the early
       returns further down, like every hook here. */ (0, $acw62.useEffect)(()=>{
        if (!openOnArrival || !analysis?.strategies?.length) return;
        const inner = selectedStrategy?.strategy ?? selectedStrategy;
        const key = inner?.name != null ? $ca941a2ef5e688c5$var$strategyCardSelectionKey(inner) : null;
        const rows = [
            ...(analysis.recommendedOptimalStrategies || []).map((r)=>r.strategy).filter(Boolean),
            ...analysis.strategies
        ];
        const card = key ? rows.find((s)=>s && $ca941a2ef5e688c5$var$strategyCardSelectionKey(s) === key) ?? null : null;
        if (openOnArrival === 'compare') setShowGoalLeadersModal(true);
        else if (!card) return;
        else if (openOnArrival === 'explain') setExplainStrategy(card);
        else if (openOnArrival === 'risks') setRiskStrategy(card);
        else if (openOnArrival === 'document') window.setTimeout(()=>document.querySelector('[data-testid="chosen-plan-advice"]')?.scrollIntoView({
                block: 'center',
                behavior: 'smooth'
            }), 300);
        else if (openOnArrival === 'detail') setDetailOpenKey($ca941a2ef5e688c5$var$strategyCardSelectionKey(card));
        else if (openOnArrival === 'build') onBuildYourOwn?.(card);
        onOpenedOnArrival?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        openOnArrival,
        analysis
    ]);
    const [allStrategiesSortBy, setAllStrategiesSortBy] = (0, $acw62.useState)('legacy');
    /*
     * A REAL QUOTE, and the draft being typed, kept apart.
     *
     * Only the committed value re-runs the engine - typing a digit must not fire an analysis per
     * keystroke. Same split the village module uses.
     */ const [acAnnuityQuote, setAcAnnuityQuote] = (0, $acw62.useState)(null);
    const [acAnnuityQuoteDraft, setAcAnnuityQuoteDraft] = (0, $acw62.useState)('');
    const [showAssumptionsModal, setShowAssumptionsModal] = (0, $acw62.useState)(false);
    const [showSettingsModal, setShowSettingsModal] = (0, $acw62.useState)(false);
    /** User-facing filter: which single objective to surface first. 'all' uses the same card set as legacy (v1). */ const [optimisationFocus, setOptimisationFocus] = (0, $acw62.useState)(()=>{
        const g = goals?.agedCareSuggestionFocus;
        if (g === 'cashflow' || g === 'pension' || g === 'legacy' || g === 'all' || g === 'covered') return g;
        // Best estate leads (owner, 24 Sep 2026: "Best estate, then Best estate cashflow covered…").
        return 'legacy';
    });
    /** Which card has "Show the detail" open, and which of its snapshot tiles a "why?" asked for. */ const [detailOpenKey, setDetailOpenKey] = (0, $acw62.useState)(null);
    const [tileRequest, setTileRequest] = (0, $acw62.useState)(null);
    const openTile = (cardKey, tile)=>{
        setDetailOpenKey(cardKey);
        setTileRequest({
            cardKey: cardKey,
            tile: tile,
            nonce: Date.now()
        });
    };
    /** "Where the $32,006 comes from" — the cashflow pop-over for one card (UX review, 17 Oct 2026). */ const [cashflowFor, setCashflowFor] = (0, $acw62.useState)(null);
    const [currentSettings, setCurrentSettings] = (0, $acw62.useState)({
        legacyYears: legacyYears || 5,
        emergencyFund: (0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind),
        // Alternative Scenario Parameters (from original setup)
        newHomeValue: Math.round((parseFloat(String(factFind?.home?.value)) || 0) * 0.7) || 250000,
        annualRentCost: 40000,
        sellingCosts: 0,
        // Partner living arrangement (for couples)
        partnerLivingArrangement: 'remain_in_home',
        // Future life event (optional): partner enters residential care later.
        enablePartnerFutureEvent: factFind?.adviceFor === 'couple',
        partnerEntryYear: 3,
        partnerFutureRoomPrice: parseFloat(String(agedCareCosts?.radAmount)) || 500000,
        originalEntrantAliveAtPartnerEntry: true
    });
    const [progress, setProgress] = (0, $acw62.useState)({
        current: 0,
        total: 0
    });
    // Keep Suggestion Engine settings aligned with Strategy Analysis Setup (coupleValidation)
    (0, $acw62.useEffect)(()=>{
        if (!coupleValidation) return;
        setCurrentSettings((prev)=>({
                ...prev,
                enablePartnerFutureEvent: coupleValidation.enablePartnerFutureEvent !== undefined ? coupleValidation.enablePartnerFutureEvent : prev.enablePartnerFutureEvent,
                partnerEntryYear: coupleValidation.partnerEntryYear ?? prev.partnerEntryYear,
                partnerFutureRoomPrice: (coupleValidation.partnerFutureRoomPrice || 0) > 0 ? coupleValidation.partnerFutureRoomPrice : prev.partnerFutureRoomPrice,
                originalEntrantAliveAtPartnerEntry: coupleValidation.originalEntrantAliveAtPartnerEntry !== undefined ? coupleValidation.originalEntrantAliveAtPartnerEntry : prev.originalEntrantAliveAtPartnerEntry,
                newHomeValue: coupleValidation.downsizeNewHomeValue ?? prev.newHomeValue,
                annualRentCost: coupleValidation.partnerAnnualRent ?? prev.annualRentCost,
                sellingCosts: coupleValidation.sellingCosts ?? prev.sellingCosts,
                emergencyFund: coupleValidation.emergencyFund ?? prev.emergencyFund
            }));
    }, [
        coupleValidation
    ]);
    // Keep the "analysing" UI on screen for at least the opening's floor, even when the simulation
    // finishes quickly. We really are running hundreds of scenarios, and showing that work is part
    // of the experience — without a floor it can flash past in a fraction of a second. A re-opened
    // saved plan has no floor (engineOpening.ts), and once any run completes the panel is back on
    // the thinking opening.
    const stopLoadingAfterMinDelay = (startedAt)=>{
        const remaining = (0, $bedf4d8bceb97e40$export$4b840ac15005a10)(openingRef.current, startedAt, Date.now());
        setTimeout(()=>{
            setLoading(false);
            openingRef.current = 'thinking';
        }, remaining);
    };
    /**
     * The just-in-time "how would new money be invested?" gate. The aged care engine explores
     * downsize scenarios (booking downsizer contributions into super / a pension) whenever a
     * target home value is in play — which the default settings provide — so the question is
     * asked BEFORE the engine prices anything, same rules as the village module: answering saves
     * to the profile (asked once, ever, across all modules); skipping runs at Conservative
     * without recording an answer.
     *
     * It is only reached by flows that never open the Strategy Analysis Setup modal (a single
     * client with no structures), because that modal now carries the same question among the
     * run's other inputs. Completing the setup counts as having been asked: its default option,
     * "Not sure — assume Conservative", is a legitimate answer that deliberately records nothing,
     * so testing `hasAnsweredNewMoneyProfile` alone put the interim screen back in front of every
     * adviser who left the dropdown alone — the exact screen moving the question was meant to
     * remove.
     */ const [newMoneySkipped, setNewMoneySkipped] = (0, $acw62.useState)(false);
    /*
     * THE ANNUITY WILLINGNESS QUESTION (owner, 25 Sep 2026). The Strategy Analysis Setup asks it,
     * but that pop-over only opens for some flows — a single client with no structures never sees
     * it — so the gate stands in, exactly as the new-money question does, and suppresses itself
     * once an answer is recorded anywhere.
     */ const [annuityPrefSkipped, setAnnuityPrefSkipped] = (0, $acw62.useState)(false);
    const acNeedsAnnuityAnswer = !(0, $ff5de4128b46b139$export$636a9065c3f862c1)(factFind).answered && !annuityPrefSkipped;
    // The gate's three answers (back / all / none), dated, merged into the client's goals.
    const answerAnnuityPreference = (appetite, residual, answeredOn)=>{
        if (setFactFind) setFactFind((prev)=>({
                ...prev,
                goals: {
                    ...prev.goals || {},
                    annuityAppetite: appetite,
                    annuityResidual: residual,
                    ...answeredOn ? {
                        annuityAnsweredOn: answeredOn
                    } : {}
                }
            }));
        else setAnnuityPrefSkipped(true);
    };
    const acRunWouldInvest = (Number(coupleValidation?.downsizeNewHomeValue) || 0) > 0;
    const acNewMoneyAskedInSetup = !!coupleValidation?.suggestionEngineSetupComplete;
    const acNeedsNewMoneyAnswer = acRunWouldInvest && !(0, $0f2c0a6799fe36da$export$848647f164f42923)(factFind) && !newMoneySkipped && !acNewMoneyAskedInSetup;
    const answerNewMoneyProfile = (id)=>{
        if (setFactFind) setFactFind((prev)=>({
                ...prev,
                goals: {
                    ...prev.goals || {},
                    newMoneyInvestmentProfile: id
                }
            }));
        else setNewMoneySkipped(true);
    };
    // The Transfer Balance Cap question, chained after the new-money one: the downsize scenarios
    // can commence a pension from the downsizer contribution, so when a person's balances trip the
    // $1.6m screen the ATO figure is asked for before pricing (transferBalanceCap.ts). Skipping
    // estimates from current pension balances; the engine splits at the cap either way.
    const [tbcSkipped, setTbcSkipped] = (0, $acw62.useState)(false);
    const tbcPersonNeedingAnswer = !tbcSkipped && acRunWouldInvest ? (0, $4f5a997f1c0139af$export$7bf826dbcbb0ddc)(factFind, 'client') ? 'client' : factFind?.adviceFor === 'couple' && (0, $4f5a997f1c0139af$export$7bf826dbcbb0ddc)(factFind, 'partner') ? 'partner' : null : null;
    const acNeedsTbcAnswer = !acNeedsNewMoneyAnswer && tbcPersonNeedingAnswer !== null;
    const answerTbc = (amount)=>{
        if (setFactFind && tbcPersonNeedingAnswer) {
            const key = tbcPersonNeedingAnswer;
            setFactFind((prev)=>({
                    ...prev,
                    [key]: {
                        ...prev[key] || {},
                        transferBalanceUsed: amount
                    }
                }));
        } else setTbcSkipped(true);
    };
    /*
     * The profile as the run sees it: a change to the income-only confirmation alone (ticked beside a card's
     * Choose button) is a record, not an input, so it must not re-run hundreds of scenarios and reshuffle the
     * cards under the reader's cursor (guaranteed income review E5, 21 Oct 2026).
     */ const runFactFindKey = (0, $acw62.useMemo)(()=>{
        const g = {
            ...factFind?.goals || {}
        };
        delete g.incomeOnlyConfirmation;
        return JSON.stringify({
            ...factFind,
            goals: g
        });
    }, [
        factFind
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const runFactFind = (0, $acw62.useMemo)(()=>factFind, [
        runFactFindKey
    ]);
    /*
     * ONE RUN PER CHANGE THAT MATTERS (26 Oct 2026: opening a saved plan sent the whole analysis three times,
     * ~2 minutes and 1.3 GB). The fees handed in are recomputed in steps as the analyser restores its state,
     * each a new object, and each re-ran several hundred scenarios. The run now keys on what it actually
     * reads — the profile, the room and the fee figures the candidates are built from, the living costs,
     * the settings — waits while the analyser is still working those out, and skips a key it has run.
     */ const runInputsKey = (0, $acw62.useMemo)(()=>{
        const g = {
            ...goals || {}
        };
        delete g.incomeOnlyConfirmation;
        const c = agedCareCosts || {};
        const move = $ca941a2ef5e688c5$var$facilityMoveFromStrategyOptions(strategyOptions);
        return JSON.stringify([
            runFactFindKey,
            move ? c : [
                c.radAmount,
                c.basicDailyFee,
                c.dailyHSC,
                c.dailyMTCF,
                c.dailyExtraServiceFee,
                c.scenarioLivingExpenses
            ],
            g,
            legacyYears,
            coupleValidation,
            acNeedsNewMoneyAnswer,
            acNeedsTbcAnswer,
            acAnnuityQuote,
            $ca941a2ef5e688c5$var$careStartDateFromStrategyOptions(strategyOptions),
            $ca941a2ef5e688c5$var$radDrawdownFromStrategyOptions(strategyOptions),
            $ca941a2ef5e688c5$var$feeArrangementsFromStrategyOptions(strategyOptions),
            $ca941a2ef5e688c5$var$secondRoomFromStrategyOptions(strategyOptions),
            move,
            $ca941a2ef5e688c5$var$villageExitFromStrategyOptions(strategyOptions)
        ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        runFactFindKey,
        agedCareCosts,
        goals,
        legacyYears,
        coupleValidation,
        acNeedsNewMoneyAnswer,
        acNeedsTbcAnswer,
        acAnnuityQuote,
        strategyOptions
    ]);
    const lastRunKeyRef = (0, $acw62.useRef)(null);
    const runSeqRef = (0, $acw62.useRef)(0);
    // Run analysis when data changes
    (0, $acw62.useEffect)(()=>{
        if (acNeedsNewMoneyAnswer || acNeedsTbcAnswer) {
            setLoading(false);
            return;
        }
        if (inputsSettling) {
            if (lastRunKeyRef.current !== runInputsKey) setLoading(true);
            return;
        }
        if (lastRunKeyRef.current === runInputsKey) return;
        if (factFind && agedCareCosts) {
            lastRunKeyRef.current = runInputsKey;
            const runSeq = runSeqRef.current += 1;
            setLoading(true);
            const analysisStartedAt = Date.now();
            const runAnalysis = async ()=>{
                try {
                    // Yield one tick so React can paint the loader BEFORE the analysis runs.
                    // The simulation is synchronous and blocks the main thread (~1s+), so without
                    // this the previous screen freezes and the loader only flashes at the very end.
                    await new Promise((resolve)=>setTimeout(resolve, 50));
                    // Debug: Log what agedCareCosts contains
                    // Extract adjusted living expenses from agedCareCosts.
                    // Future-life-event inputs must match Strategy Analysis Setup (coupleValidation): the gear modal
                    // merges these in runAnalysisWithSettings, but the initial/re-run effect previously did not,
                    // so future-aware scoring and disclosure never activated until a settings save.
                    const defaultPartnerRoom = parseFloat(String(agedCareCosts?.radAmount)) || 500000;
                    const adjustedGoals = {
                        ...goals,
                        adjustedLivingExpenses: (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(agedCareCosts.scenarioLivingExpenses, factFind.expenses?.livingExpenses),
                        enablePartnerFutureEvent: coupleValidation?.enablePartnerFutureEvent !== undefined ? coupleValidation.enablePartnerFutureEvent : goals.enablePartnerFutureEvent ?? factFind?.adviceFor === 'couple',
                        partnerEntryYear: coupleValidation?.partnerEntryYear ?? goals.partnerEntryYear ?? 3,
                        partnerFutureRoomPrice: (coupleValidation?.partnerFutureRoomPrice || 0) > 0 ? coupleValidation.partnerFutureRoomPrice : (Number(goals.partnerFutureRoomPrice) || 0) > 0 ? goals.partnerFutureRoomPrice : defaultPartnerRoom,
                        originalEntrantAliveAtPartnerEntry: coupleValidation?.originalEntrantAliveAtPartnerEntry !== undefined ? coupleValidation.originalEntrantAliveAtPartnerEntry : goals.originalEntrantAliveAtPartnerEntry ?? true
                    };
                    // INTEGRATED APPROACH: Generate scenarios and call manual control directly with progress tracking
                    // Downsize is included when parent passes exploreAlternatives/downsizeNewHomeValue, or after user sets it in settings and clicks Save & Re-optimise
                    const results = await $ca941a2ef5e688c5$var$generateScenariosAndCallManualControl(factFind, agedCareCosts, adjustedGoals, legacyYears, coupleValidation, setProgress, // The entry date the adviser set on the Analyser, so the ranked candidates are
                    // projected against the same case the manual strategy is.
                    $ca941a2ef5e688c5$var$careStartDateFromStrategyOptions(strategyOptions), acAnnuityQuote, $ca941a2ef5e688c5$var$radDrawdownFromStrategyOptions(strategyOptions), $ca941a2ef5e688c5$var$feeArrangementsFromStrategyOptions(strategyOptions), $ca941a2ef5e688c5$var$secondRoomFromStrategyOptions(strategyOptions), $ca941a2ef5e688c5$var$facilityMoveFromStrategyOptions(strategyOptions), $ca941a2ef5e688c5$var$villageExitFromStrategyOptions(strategyOptions));
                    // A later run has started: this one's answer is for inputs no longer on screen.
                    if (runSeq !== runSeqRef.current) return;
                    setAnalysis(results);
                    setError(null);
                } catch (err) {
                    if (runSeq !== runSeqRef.current) return;
                    console.error('Error in analyzeFundingStrategies:', err);
                    // A failed run may be tried again for the same inputs.
                    lastRunKeyRef.current = null;
                    setError(err instanceof Error ? err.message : String(err));
                } finally{
                    if (runSeq === runSeqRef.current) stopLoadingAfterMinDelay(analysisStartedAt);
                }
            };
            runAnalysis();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        runInputsKey,
        inputsSettling
    ]);
    /** The record a chosen plan is saved as: its row, its figures, the doing-nothing figures it was measured against. */ const savedRecordFor = (strategy)=>{
        // The row's own costs (after the deposit), both rooms where it carries a second one; the
        // base costs where the row has none.
        const annualAgedCareCost = (0, $bdfd96a4f4ac117d$export$86905c05d8e03be)(strategy, agedCareCosts) * 365;
        // Audit trail for SOA: what was recommended vs what the client selected
        const recommendedList = analysis?.recommendedOptimalStrategies || [];
        const recommendedOptimalStrategies = recommendedList.map((ro)=>({
                label: ro.label,
                name: ro.strategy?.name
            }));
        const clientSelectedIsAlternative = recommendedList.length > 0 && !recommendedList.some((ro)=>ro.strategy?.name === strategy.name);
        const savedStrategy = {
            id: `strategy-${Date.now()}`,
            name: strategy.name,
            type: 'aged_care',
            source: 'suggestion_engine',
            strategy: strategy,
            createdAt: new Date().toISOString(),
            recommendedOptimalStrategies: recommendedOptimalStrategies,
            clientSelectedIsAlternative: clientSelectedIsAlternative,
            /* The plan in the client's words, the home it was modelled for, and the doing-nothing
               figures it was measured against — so Home and the Aged care landing can show "+$61,507
               vs doing nothing" without re-running anything (UX review, 17 Oct 2026). */ displayName: (0, $95e43332fd84eec4$export$f973c372d76f95c8)(strategy, factFind, getDisplayStrategyName(strategy.name, strategy.radPaidNet, strategy.radRoomPrice, secondRoomOf(strategy), moveOf(strategy), villageOf(strategy))).title,
            homeName: homeName || null,
            // The one plan on the file that is chosen (the analyser unmarks the others). Survives a reload,
            // which the in-memory selection does not, so Home and the landing know which plan is real.
            chosen: true,
            baseline: agedCareBaseline && agedCareBaseline.pension != null ? {
                legacyValue: agedCareBaseline.legacyValue ?? null,
                pension: Number(agedCareBaseline.pension) || 0,
                cashFlowAfterCare: Number(agedCareBaseline.cashFlowAfterCare) || 0,
                careCosts: snapshotBaseline?.careCosts ?? null
            } : null,
            outputs: {
                agedCareCost: annualAgedCareCost,
                agePension: strategy.snapshot?.pension || strategy.agePension || strategy.estimatedAgePension || 0,
                cashFlow: strategy.snapshot?.netCashflow ?? strategy.snapshot?.cashFlow ?? strategy.cashFlow ?? strategy.cashflow ?? 0,
                legacyEstimate: strategy.isFutureEventOverlayCard && strategy.futureAdjustedLegacy != null ? strategy.futureAdjustedLegacy : strategy.snapshot?.legacyValue || strategy.legacyValue || strategy.projectedEstateValue || 0,
                roomCost: agedCareCosts.radAmount || 0,
                livingExpenses: strategy.snapshot?.livingExpenses ?? (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(agedCareCosts.scenarioLivingExpenses, factFind.expenses?.livingExpenses) // Save adjusted living expenses
            },
            inputs: {
                scenarioLivingExpenses: (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(agedCareCosts.scenarioLivingExpenses, factFind.expenses?.livingExpenses),
                legacyYears: currentSettings.legacyYears,
                radInput: agedCareCosts.radAmount || 0
            }
        };
        return savedStrategy;
    };
    // The saved record is what the advice document is written from, so it carries the plan in full.
    const saveSelectedStrategy = async (lightOrFull)=>{
        const strategy = await $ca941a2ef5e688c5$export$54bb052a44b0c2ec(lightOrFull);
        const savedStrategy = savedRecordFor(strategy);
        // Save to session storage
        const existingStrategies = JSON.parse(sessionStorage.getItem('careCompanionStrategies') || '[]');
        const updatedStrategies = [
            ...existingStrategies,
            savedStrategy
        ];
        sessionStorage.setItem('careCompanionStrategies', JSON.stringify(updatedStrategies));
        (0, $f58ff7d3c4c676c4$export$b731185d32c620a3)((0, $f58ff7d3c4c676c4$export$816f75caf2488b34)('aged_care', savedStrategy.id));
        (0, $f58ff7d3c4c676c4$export$33b576d5d6fa435b)();
        // Notify parent component
        if (onStrategySelect) onStrategySelect(savedStrategy);
    };
    /*
     * THE CHOSEN PLAN'S SAVED FIGURES FOLLOW ITS RE-TEST (25 Oct 2026). Home and the plan page show the
     * figures saved when the plan was chosen; the card shows this run's. When the rules or the day moved
     * between the two, the same plan read $3,286,281 on Home and $3,285,977 on its card. Each run that
     * finds the chosen plan again (same plan, same room, same deposit) hands its fresh record up, and the
     * analyser rewrites the chosen record where a figure changed — so every screen reads one source.
     */ (0, $acw62.useEffect)(()=>{
        if (!analysis || !onChosenPlanRetested) return;
        const chosen = selectedStrategy?.strategy ?? selectedStrategy;
        if (!chosen?.name) return;
        const key = $ca941a2ef5e688c5$var$strategyCardSelectionKey(chosen);
        const room = Number(chosen.radRoomPrice) || 0;
        const pool = [
            ...analysis.strategies || [],
            ...(analysis.recommendedOptimalStrategies || []).map((r)=>r.strategy).filter(Boolean)
        ];
        const row = pool.find((s)=>$ca941a2ef5e688c5$var$strategyCardSelectionKey(s) === key && Math.abs((Number(s.radRoomPrice) || 0) - room) < 1 && Math.abs((Number(s.radPaidNet) || 0) - (Number(chosen.radPaidNet) || 0)) < 1);
        if (row) {
            $ca941a2ef5e688c5$export$54bb052a44b0c2ec(row).then((full)=>onChosenPlanRetested(savedRecordFor(full)));
            return;
        }
        // Not found, on the room it was chosen for: not a run for another home, which has its own plans.
        const pricedRoom = Number(agedCareCosts?.radAmount) || 0;
        const everyRow = [
            ...pool,
            ...analysis.allSimulatedStrategies || []
        ];
        if (room > 0 && Math.abs(pricedRoom - room) < 1 && !everyRow.some((s)=>$ca941a2ef5e688c5$var$strategyCardSelectionKey(s) === key)) onChosenPlanMissing?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        analysis
    ]);
    const handleDeepDive = (strategy)=>{
        setSelectedScenario(strategy);
        setDeepDiveModal(true);
        // The year-by-year window shows each year's working; a light row is fetched in full and swapped in.
        if (strategy.lite) $ca941a2ef5e688c5$export$54bb052a44b0c2ec({
            ...strategy
        }).then((full)=>setSelectedScenario((current)=>current && current.name === full.name ? full : current));
    };
    // Straight to the questions: re-testing keeps a chosen plan chosen when its row still exists, so the
    // "Save Current Strategy?" interstitial asked about a loss that does not happen (UX review, 17 Oct 2026).
    const handleSettingsClick = ()=>{
        setShowSettingsModal(true);
    };
    const handleSettingsSave = (newSettings)=>{
        const { structureFundingInSuggestions: nextStructureFunding, annuityGoals: annuityGoals, ...engineSettings } = newSettings;
        // The annuity answer lives on the client's goals (every module reads it there); the run below
        // sees it through the same override the structures answer uses.
        const goalsOverride = annuityGoals ? {
            goals: {
                ...factFind?.goals || {},
                ...annuityGoals
            }
        } : {};
        if (setFactFind && (nextStructureFunding != null || annuityGoals)) setFactFind((prev)=>({
                ...prev,
                ...nextStructureFunding != null ? {
                    structureFundingInSuggestions: nextStructureFunding
                } : {},
                ...annuityGoals ? {
                    goals: {
                        ...prev.goals || {},
                        ...annuityGoals
                    }
                } : {}
            }));
        setCurrentSettings(engineSettings);
        setShowSettingsModal(false);
        setAnalysis(null);
        setLoading(true);
        setTimeout(()=>{
            runAnalysisWithSettings(engineSettings, {
                ...nextStructureFunding != null ? {
                    structureFundingInSuggestions: nextStructureFunding
                } : {},
                ...goalsOverride
            });
        }, 100);
    };
    const runAnalysisWithSettings = async (settings, formDataOverrides = {})=>{
        const settingsAnalysisStartedAt = Date.now();
        try {
            // Yield so the loader paints before the synchronous, main-thread-blocking analysis.
            await new Promise((resolve)=>setTimeout(resolve, 50));
            const updatedFactFind = {
                ...factFind,
                ...formDataOverrides,
                emergencyFund: settings.emergencyFund
            };
            // Create updated goals that include the simplified settings
            const adjustedGoals = {
                ...goals,
                adjustedLivingExpenses: (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(agedCareCosts.scenarioLivingExpenses, updatedFactFind.expenses?.livingExpenses),
                emergencyFund: settings.emergencyFund,
                // Alternative scenario parameters
                newHomeValue: settings.newHomeValue,
                annualRentCost: settings.annualRentCost,
                // Partner living arrangement
                partnerLivingArrangement: settings.partnerLivingArrangement,
                // Future event assumptions
                enablePartnerFutureEvent: settings.enablePartnerFutureEvent,
                partnerEntryYear: settings.partnerEntryYear,
                partnerFutureRoomPrice: settings.partnerFutureRoomPrice,
                originalEntrantAliveAtPartnerEntry: settings.originalEntrantAliveAtPartnerEntry
            };
            // Include downsize when "New home value (if downsizing)" is set; pass selling costs $ for downsize.
            // Downsize is now driven purely off downsizeNewHomeValue (see downsizeEnabled), not a magic string.
            const effectiveCoupleValidation = Number(settings.newHomeValue) > 0 ? {
                ...coupleValidation,
                downsizeNewHomeValue: Number(settings.newHomeValue),
                sellingCosts: parseFloat(String(settings.sellingCosts)) || 0,
                stampDuty: Number(settings.stampDuty) || 0,
                newHomeState: settings.newHomeState
            } : {
                ...coupleValidation,
                sellingCosts: parseFloat(String(settings.sellingCosts)) || 0
            };
            const result = await $ca941a2ef5e688c5$var$generateScenariosAndCallManualControl(updatedFactFind, agedCareCosts, adjustedGoals, settings.legacyYears, effectiveCoupleValidation, null, $ca941a2ef5e688c5$var$careStartDateFromStrategyOptions(strategyOptions), null, $ca941a2ef5e688c5$var$radDrawdownFromStrategyOptions(strategyOptions), $ca941a2ef5e688c5$var$feeArrangementsFromStrategyOptions(strategyOptions), $ca941a2ef5e688c5$var$secondRoomFromStrategyOptions(strategyOptions), $ca941a2ef5e688c5$var$facilityMoveFromStrategyOptions(strategyOptions), $ca941a2ef5e688c5$var$villageExitFromStrategyOptions(strategyOptions));
            setAnalysis(result);
        } catch (error) {
            console.error('Error re-running analysis:', error);
            setError('Failed to re-optimise with new settings');
        } finally{
            stopLoadingAfterMinDelay(settingsAnalysisStartedAt);
        }
    };
    // Keep this memo before early-return branches below to preserve hook order.
    // Primary recommendations use baseline legacy; optional fourth card shows the best strategy
    // under future-event-adjusted legacy when partner-later assumptions are enabled.
    const futureEventOptimalStrategy = (0, $acw62.useMemo)(()=>{
        if (!currentSettings.enablePartnerFutureEvent) return null;
        if (!analysis?.strategies?.length) return null;
        const partnerEntryYear = parseInt(String(currentSettings.partnerEntryYear), 10) || 3;
        const partnerFutureRoomPrice = parseFloat(String(currentSettings.partnerFutureRoomPrice)) || 0;
        const originalEntrantAliveAtPartnerEntry = !!currentSettings.originalEntrantAliveAtPartnerEntry;
        if (partnerFutureRoomPrice <= 0) return null;
        const horizonYears = currentSettings.legacyYears || legacyYears || 5;
        const scored = analysis.strategies.map((strategy)=>{
            const result = (0, $eb4adc50b37e37f7$export$9ac41d7814ff2d5c)({
                strategy: strategy,
                legacyYears: horizonYears,
                partnerEntryYear: partnerEntryYear,
                partnerRoomPrice: partnerFutureRoomPrice,
                originalEntrantAliveAtEvent: originalEntrantAliveAtPartnerEntry,
                baseAgedCareCosts: strategy.strategySpecificAgedCareCosts || agedCareCosts
            });
            if (!result) return null;
            return {
                strategy: strategy,
                result: result,
                adjustedLegacy: result.adjustedLegacy,
                radPaid: (0, $eb4adc50b37e37f7$export$ad99f664ac5b1922)(strategy)
            };
        }).filter((row)=>row !== null);
        if (scored.length === 0) return null;
        // Primary: highest future-adjusted legacy. Tie-break (within band): lowest estimated RAD paid.
        const maxAdjustedLegacy = scored.reduce((m, row)=>Math.max(m, row.adjustedLegacy), -Infinity);
        if (!Number.isFinite(maxAdjustedLegacy)) return null;
        const bandUsd = (0, $af797c9747431756$export$340a7c95a5102e15);
        const threshold = maxAdjustedLegacy - bandUsd;
        const nearBest = scored.filter((row)=>row.adjustedLegacy >= threshold);
        const topAdjustedRow = scored.reduce((best, row)=>row.adjustedLegacy > best.adjustedLegacy ? row : best, scored[0]);
        const pickedRow = nearBest.reduce((best, row)=>{
            if (row.radPaid < best.radPaid) return row;
            if (row.radPaid === best.radPaid && row.adjustedLegacy > best.adjustedLegacy) return row;
            return best;
        }, nearBest[0]);
        const usedLowerRadTieBreak = pickedRow.strategy?.name !== topAdjustedRow.strategy?.name;
        return {
            ...pickedRow.strategy,
            isFutureEventOverlayCard: true,
            name: `${pickedRow.strategy.name} (Partner enters later)`,
            recommendationLabels: [
                usedLowerRadTieBreak ? "Optimal Legacy (Partner Later) \u2014 lower RAD option" : 'Optimal Legacy (Partner Later Scenario)'
            ],
            futureEventAssumptions: pickedRow.result.assumptions,
            futureAdjustedLegacy: pickedRow.adjustedLegacy,
            futureEventAdjustmentDelta: pickedRow.result.adjustmentDelta,
            futureEventMeta: {
                bandUsd: bandUsd,
                baselineLegacy: pickedRow.result.baselineLegacy,
                maxAdjustedLegacy: maxAdjustedLegacy,
                selectedAdjustedLegacy: pickedRow.adjustedLegacy,
                topAdjustedStrategyName: topAdjustedRow.strategy?.name,
                selectedStrategyName: pickedRow.strategy?.name,
                radPaidSelected: pickedRow.radPaid,
                radPaidTopAdjusted: topAdjustedRow.radPaid,
                usedLowerRadTieBreak: usedLowerRadTieBreak
            }
        };
    }, [
        analysis,
        agedCareCosts,
        currentSettings,
        legacyYears
    ]);
    const showFutureEventFourthCard = !!futureEventOptimalStrategy;
    const lowerRadNearBestStrategy = (0, $acw62.useMemo)(()=>{
        if (!analysis?.strategies?.length) return null;
        /*
         * THE SECOND CARD, ONLY FOR A REAL TRADE-OFF (owner, 20 Oct 2026: "$5k difference for $771 LESS"
         * is not a choice). The rule is planChoiceRule.ts, the same in every module: close enough to the
         * estate leader to weigh, and clearly better on something else — much less money moved, more to
         * spare each year, or no irreversible step where the leader takes one.
         *
         * THE SAME FIELD AS THE LEADERS (owner-caught, 9 Oct 2026): a strategy the horizon rule set aside
         * can never fill this slot.
         */ const eligible = analysis.strategies.filter((s)=>!(0, $3d096644ffaac9d7$export$97adbbb576405d0e)(s, factFind) && !$ca941a2ef5e688c5$export$6b2690718f11a010(s));
        const leadName = (analysis.recommendedOptimalStrategies || []).find((r)=>r.label === 'Optimal Legacy')?.strategy?.name;
        const lead = eligible.find((s)=>s.name === leadName) ?? null;
        const second = (0, $5a094123650e8adb$export$ab51b61210e311f4)(eligible, lead, (0, $eb4adc50b37e37f7$export$6628235dfd682022), (a, b)=>a.name === b.name);
        if (!second) return null;
        return {
            ...second.strategy,
            isLowerRadNearBestCard: true,
            recommendationLabels: [
                (0, $5a094123650e8adb$export$a1a7ae9e29edd48c)
            ],
            lowerRadNearBestMeta: {
                line: (0, $5a094123650e8adb$export$a104569a4d958475)(second, (0, $f94e45ac645ae232$export$3dc27271f5d5c629)),
                chip: (0, $5a094123650e8adb$export$8d9f0aa086032e89)(second)
            }
        };
    }, [
        analysis,
        factFind
    ]);
    const showLowerRadNearBestCard = !!lowerRadNearBestStrategy;
    if (acNeedsNewMoneyAnswer) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "max-w-3xl mx-auto mt-6",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a08e2ea281a6041$export$2e2bcd8739ae039), {
            onAnswer: answerNewMoneyProfile,
            onSkip: ()=>setNewMoneySkipped(true),
            contextLine: "Some of the strategies I'll compare invest money that gets freed up \u2014 for example if downsizing the home is modelled alongside the aged care move."
        })
    });
    if (acNeedsAnnuityAnswer) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "max-w-3xl mx-auto mt-6",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5266def67111b10e$export$2e2bcd8739ae039), {
            offerGuaranteed: (0, $d08210caeacdc75a$export$7095ab72ebd46272)(factFind),
            guaranteeWindow: (0, $5ccd559ea4d04f2e$export$2dfd0dacdd6d7571)({
                age: factFind?.client?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client.dob) : null,
                sex: factFind?.client?.sex,
                partnerAge: factFind?.adviceFor === 'couple' && factFind?.partner?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner.dob) : null,
                partnerSex: factFind?.partner?.sex,
                ownerName: factFind?.client?.firstName,
                partnerName: factFind?.partner?.firstName
            }),
            onAnswer: answerAnnuityPreference,
            onSkip: ()=>setAnnuityPrefSkipped(true),
            contextLine: "Some of the strategies I'll compare move savings into a guaranteed income to lower the care fees."
        })
    });
    if (acNeedsTbcAnswer) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "max-w-3xl mx-auto mt-6",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $216ea083fe16cb8b$export$2e2bcd8739ae039), {
            name: (tbcPersonNeedingAnswer === 'partner' ? factFind?.partner?.firstName : factFind?.client?.firstName) || 'this person',
            onAnswer: answerTbc,
            onSkip: ()=>setTbcSkipped(true)
        })
    });
    const waitingForAnalysis = factFind && agedCareCosts && !analysis && !error;
    if ((loading || waitingForAnalysis) && openingRef.current === 'quiet') // A saved plan coming back: no illustration, no floor — just a moment while its figures are rebuilt.
    // In place, not a fixed overlay: inside the Card a fixed overlay was trapped by its backdrop filter
    // and filled only the card, so a reader saw a grey box rather than a page (17 Oct 2026).
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex min-h-[280px] items-center justify-center",
        "data-testid": "engine-quiet-opening",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex items-center gap-3 rounded-xl bg-white border border-slate-200 shadow-card px-5 py-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "animate-spin rounded-full h-5 w-5 border-2 border-blue-200 border-t-blue-600"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-sm text-slate-700",
                    children: "Opening your saved plan\u2026"
                })
            ]
        })
    });
    if (loading || waitingForAnalysis) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex min-h-[420px] items-center justify-center",
        "data-testid": "engine-thinking",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-center max-w-lg px-6",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mb-8 flex justify-center",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                        width: "240",
                        height: "140",
                        viewBox: "0 0 240 140",
                        fill: "none",
                        className: "text-blue-600/90",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                                    id: "barGrad",
                                    x1: "0",
                                    y1: "1",
                                    x2: "0",
                                    y2: "0",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                            offset: "0%",
                                            stopColor: "currentColor",
                                            stopOpacity: "0.3"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                            offset: "100%",
                                            stopColor: "currentColor",
                                            stopOpacity: "0.9"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "40",
                                y: "70",
                                width: "28",
                                height: "50",
                                rx: "4",
                                fill: "url(#barGrad)",
                                className: "animate-pulse",
                                style: {
                                    animationDuration: '1.5s'
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "80",
                                y: "50",
                                width: "28",
                                height: "70",
                                rx: "4",
                                fill: "url(#barGrad)",
                                className: "animate-pulse",
                                style: {
                                    animationDuration: '1.5s',
                                    animationDelay: '0.2s'
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "120",
                                y: "35",
                                width: "28",
                                height: "85",
                                rx: "4",
                                fill: "url(#barGrad)",
                                className: "animate-pulse",
                                style: {
                                    animationDuration: '1.5s',
                                    animationDelay: '0.4s'
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "160",
                                y: "55",
                                width: "28",
                                height: "65",
                                rx: "4",
                                fill: "url(#barGrad)",
                                className: "animate-pulse",
                                style: {
                                    animationDuration: '1.5s',
                                    animationDelay: '0.6s'
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "200",
                                y: "25",
                                width: "28",
                                height: "95",
                                rx: "4",
                                fill: "url(#barGrad)",
                                className: "animate-pulse",
                                style: {
                                    animationDuration: '1.5s',
                                    animationDelay: '0.8s'
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M 48 95 Q 88 75 128 60 T 208 45",
                                stroke: "currentColor",
                                strokeWidth: "2.5",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                fill: "none",
                                opacity: "0.7",
                                strokeDasharray: "6 4",
                                className: "animate-pulse",
                                style: {
                                    animationDuration: '2s'
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    className: "text-xl font-bold text-gray-800 mb-2",
                    children: analysis ? 'Re-optimising with new settings...' : 'Optimising your funding strategies'
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-gray-600 mb-6",
                    children: "We're working through a large number of simulated options - this may take a few minutes."
                }),
                progress.total > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-sm text-blue-700 font-medium",
                    children: [
                        "Running scenario ",
                        progress.current,
                        " of ",
                        progress.total
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mt-6 flex justify-center",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "animate-spin rounded-full h-10 w-10 border-2 border-blue-200 border-t-blue-600"
                    })
                })
            ]
        })
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "bg-white border border-slate-200/70 border-l-4 border-red-400 rounded-lg p-6",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex items-center",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                    className: "h-5 w-5 text-red-600 mr-3"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "text-lg font-medium text-red-800",
                            children: "Analysis Error"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-red-600 mt-1",
                            children: error
                        })
                    ]
                })
            ]
        })
    });
    if (!analysis || !analysis.strategies || analysis.strategies.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-center p-8",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $27f56d6cfb7d79f8$export$2e2bcd8739ae039), {
                className: "h-12 w-12 text-gray-400 mx-auto mb-4"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "text-lg font-medium text-gray-900 mb-2",
                children: (Number(agedCareCosts?.radAmount) || 0) > 0 ? 'No plans could be tested' : 'The room price is needed first'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-gray-600",
                children: (Number(agedCareCosts?.radAmount) || 0) > 0 ? 'Something on the file stopped the plans being tested. Check the figures on steps 1 and 2, then try again.' : 'Every plan is a way of paying for the room, so we test them once its price is in. Enter it on step 1, "What the room costs".'
            })
        ]
    });
    // Top 3 recommended strategies (Optimal Legacy, Optimal Cashflow, Optimal Age Pension); fallback to first 3 if no recommended list
    const recommended = analysis.recommendedOptimalStrategies || [];
    const topStrategies = (()=>{
        if (recommended.length === 0) return analysis.strategies.slice(0, 3);
        // Collapse duplicate strategies and keep all recommendation labels as badges.
        const byStrategyName = new Map();
        recommended.forEach((row)=>{
            const name = row?.strategy?.name;
            if (!name || !row?.strategy) return;
            if (!byStrategyName.has(name)) {
                byStrategyName.set(name, {
                    ...row.strategy,
                    recommendationLabels: [
                        row.label
                    ]
                });
                return;
            }
            const existing = byStrategyName.get(name);
            const labels = existing.recommendationLabels || [];
            if (row.label && !labels.includes(row.label)) labels.push(row.label);
            byStrategyName.set(name, {
                ...existing,
                recommendationLabels: labels
            });
        });
        const uniqueRecommended = Array.from(byStrategyName.values());
        if (uniqueRecommended.length >= 3) return uniqueRecommended.slice(0, 3);
        const used = new Set(uniqueRecommended.map((s)=>s.name));
        const fillers = analysis.strategies.filter((s)=>!used.has(s.name)).slice(0, 3 - uniqueRecommended.length);
        return [
            ...uniqueRecommended,
            ...fillers
        ];
    })();
    // Goal-first display (v1): legacy + "all goals" surface = Optimal Legacy + optional Lower RAD + optional future-event card;
    // cashflow / pension = single primary card only (no Lower RAD / future-event extras — keeps non-legacy views light).
    const effectiveOptimisationSurface = optimisationFocus === 'all' ? 'legacy' : optimisationFocus;
    const displayedGoalStrategies = (()=>{
        const rec = analysis.recommendedOptimalStrategies || [];
        const enrich = (label)=>{
            const row = rec.find((r)=>r.label === label);
            if (!row?.strategy?.name) return null;
            const merged = topStrategies.find((s)=>s.name === row.strategy.name);
            return merged || row.strategy;
        };
        if (effectiveOptimisationSurface === 'covered') {
            // The same plan as Best estate is said in one line, not shown twice (owner, 24 Sep 2026).
            if ((0, $400a08a42b233386$export$b8b8a2cedd92aa3a)(rec)) return [];
            const s = enrich((0, $400a08a42b233386$export$920ad41b346ae01a));
            return s ? [
                s
            ] : topStrategies[0] ? [
                topStrategies[0]
            ] : [];
        }
        if (effectiveOptimisationSurface === 'cashflow') {
            const s = enrich('Optimal Cashflow');
            return s ? [
                s
            ] : topStrategies[0] ? [
                topStrategies[0]
            ] : [];
        }
        if (effectiveOptimisationSurface === 'pension') {
            // No plan pays an Age Pension: no card, and the line below says why (owner, 20 Oct 2026).
            const s = enrich('Optimal Age Pension');
            return s ? [
                s
            ] : [];
        }
        const out = [];
        const leg = enrich('Optimal Legacy');
        if (leg) out.push(leg);
        if (showLowerRadNearBestCard && lowerRadNearBestStrategy) out.push(lowerRadNearBestStrategy);
        if (showFutureEventFourthCard && futureEventOptimalStrategy) out.push(futureEventOptimalStrategy);
        if (out.length) return out;
        return [
            ...topStrategies,
            ...showFutureEventFourthCard ? [
                futureEventOptimalStrategy
            ] : [],
            ...showLowerRadNearBestCard ? [
                lowerRadNearBestStrategy
            ] : []
        ].filter(Boolean);
    })();
    /* The words the step-3 screen speaks in (UX review, 17 Oct 2026): who is entering care, who the
       plans are for, how many ways were tested, and the scale the two bars on every card share. */ const enteringName = goals?.aged_care_for === 'partner' ? partnerDisplayName : clientDisplayName;
    // Who the plans are for, in the reader's voice: "you" for the client, "John and Kerry" for an adviser (21 Oct 2026).
    const voice = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    /** Whether choosing this row must wait for the client's income-only confirmation for its amount (E5). */ const incomeOnlyHeldFor = (row)=>{
        const lever = (0, $09575c4cc12d1d84$export$e45920170ff81bed)(row);
        return !!lever && (0, $5eae79c7e46ed27e$export$655f124668ce439a)(factFind, lever.incomeOnly, lever.amount);
    };
    const waysTested = analysis.totalScenarios || analysis.allSimulatedStrategies?.length || analysis.strategies.length;
    const cardLegacyOf = (s)=>s.isFutureEventOverlayCard && s.futureAdjustedLegacy != null ? Number(s.futureAdjustedLegacy) : Number(s.snapshot?.legacyValue) || 0;
    const cardGainMax = Math.max(1, ...displayedGoalStrategies.map((s)=>Math.abs(cardLegacyOf(s) - (agedCareBaseline?.legacyValue ?? cardLegacyOf(s)))));
    const cardDepositMax = Math.max(1, ...displayedGoalStrategies.map((s)=>Math.max(0, Number(s.radPaidNet) || 0)));
    const innerSelectedStrategyForHighlight = selectedStrategy?.strategy ?? selectedStrategy;
    let suggestionEngineCardHighlightKey = innerSelectedStrategyForHighlight?.name != null ? $ca941a2ef5e688c5$var$strategyCardSelectionKey(innerSelectedStrategyForHighlight) : null;
    /*
     * A plan chosen for ANOTHER room never reads as chosen here (owner's journey 2, 17 Oct 2026): the
     * same engine name at a different room price is a different plan. Its room is remembered for the
     * caution above the cards.
     */ const chosenRoomPrice = Number(innerSelectedStrategyForHighlight?.radRoomPrice) || 0;
    const thisRoomPrice = Number(agedCareCosts?.radAmount) || 0;
    const chosenForOtherRoom = chosenRoomPrice > 0 && thisRoomPrice > 0 && Math.abs(chosenRoomPrice - thisRoomPrice) > 1 ? chosenRoomPrice : null;
    if (chosenForOtherRoom != null) suggestionEngineCardHighlightKey = null;
    if (suggestionEngineCardHighlightKey && !displayedGoalStrategies.some((s)=>$ca941a2ef5e688c5$var$strategyCardSelectionKey(s) === suggestionEngineCardHighlightKey)) suggestionEngineCardHighlightKey = null;
    // Rows for "Compare all strategies": goal-type leaders + optional cards only (not all simulated scenarios).
    const goalComparisonRows = (()=>{
        const rec = analysis.recommendedOptimalStrategies || [];
        const enrich = (label)=>{
            const row = rec.find((r)=>r.label === label);
            if (!row?.strategy?.name) return null;
            const merged = topStrategies.find((s)=>s.name === row.strategy.name);
            return merged || row.strategy;
        };
        const rows = [];
        const cov = enrich((0, $400a08a42b233386$export$920ad41b346ae01a));
        if (cov) rows.push({
            goalLabel: (0, $400a08a42b233386$export$8d25e363f6ae69ae),
            strategy: cov
        });
        const leg = enrich('Optimal Legacy');
        if (leg) rows.push({
            goalLabel: (0, $400a08a42b233386$export$8a102fa4742ce4ac),
            strategy: leg
        });
        const cf = enrich('Optimal Cashflow');
        if (cf) rows.push({
            goalLabel: 'Best cashflow',
            strategy: cf
        });
        const pen = enrich('Optimal Age Pension');
        if (pen) rows.push({
            goalLabel: 'Best pension',
            strategy: pen
        });
        if (showLowerRadNearBestCard && lowerRadNearBestStrategy) rows.push({
            goalLabel: (0, $5a094123650e8adb$export$a1a7ae9e29edd48c),
            strategy: lowerRadNearBestStrategy
        });
        if (showFutureEventFourthCard && futureEventOptimalStrategy) rows.push({
            goalLabel: 'Partner enters later (scenario)',
            strategy: futureEventOptimalStrategy
        });
        return rows;
    })();
    const tableStrategies = (()=>{
        const base = analysis?.allSimulatedStrategies || analysis?.strategies || [];
        const sorted = [
            ...base
        ];
        if (allStrategiesSortBy === 'cashflow') sorted.sort((a, b)=>(b.snapshot?.netCashflow ?? -Infinity) - (a.snapshot?.netCashflow ?? -Infinity));
        else if (allStrategiesSortBy === 'pension') sorted.sort((a, b)=>(b.snapshot?.pension ?? -Infinity) - (a.snapshot?.pension ?? -Infinity));
        else sorted.sort((a, b)=>(b.snapshot?.legacyValue ?? -Infinity) - (a.snapshot?.legacyValue ?? -Infinity));
        return sorted;
    })();
    /*
     * THE ADVICE DOCUMENT OPENS STRAIGHT AWAY (owner, 24 Oct 2026). A "Generate Statement of Advice" page
     * used to sit between the button and the document, left over from a PDF-or-digital choice long gone;
     * every other module opens it at once. It opens in a new tab, a copy downloads, and the draft is saved
     * with the file.
     */ const openAdviceDocument = async (lightOrFull)=>{
        if (documentBusy) return;
        setDocumentBusy(true);
        try {
            const strategy = await $ca941a2ef5e688c5$export$54bb052a44b0c2ec(lightOrFull);
            // buildAgedCareDigitalSOASnapshot's own param interface isn't exported (it's an
            // internal detail of that module) — cast via its own inferred parameter type
            // rather than duplicating/exporting an interface just for this call site.
            const snapshot = await (0, $02a659cad5e2280d$export$8b925970c458dc89)({
                selectedStrategy: strategy,
                factFind: factFind,
                agedCareCosts: agedCareCosts,
                analysis: analysis,
                coupleValidation: coupleValidation,
                reportAudience: 'direct_client'
            });
            (0, $02a659cad5e2280d$export$eed5e3bcf209d966)(snapshot);
            const savedSoaScenario = {
                id: `soa-${Date.now()}`,
                // The plan in plain words (25 Oct 2026); "SE" is kept only as data (soaSource), never shown.
                name: (0, $95e43332fd84eec4$export$f973c372d76f95c8)(strategy, factFind, getDisplayStrategyName(strategy.name, strategy.radPaidNet ?? null, Number(strategy.radRoomPrice) || null, secondRoomOf(strategy), moveOf(strategy), villageOf(strategy))).title,
                createdAt: new Date().toISOString(),
                soaSource: 'SE',
                soaDeliveryStatus: 'draft',
                isCurrentForCase: true,
                outputs: {
                    agedCareCost: (0, $bdfd96a4f4ac117d$export$86905c05d8e03be)(strategy, agedCareCosts) * 365,
                    agePension: strategy.snapshot?.pension || 0,
                    cashFlow: strategy.snapshot?.netCashflow || 0,
                    legacyEstimate: strategy.isFutureEventOverlayCard && strategy.futureAdjustedLegacy != null ? strategy.futureAdjustedLegacy : strategy.snapshot?.legacyValue ?? 0
                },
                soaSnapshot: snapshot
            };
            onScenarioSaved?.(savedSoaScenario);
        } finally{
            setDocumentBusy(false);
        }
    };
    /*
     * ONE CARD, DRAWN ONE WAY: the leading plans, and a set-aside plan opened with "See it anyway" (owner,
     * 23 Oct 2026: that link opened the year-by-year projections instead of the plan).
     */ const renderEngineCard = (strategy, index)=>{
        const cardKey = $ca941a2ef5e688c5$var$strategyCardSelectionKey(strategy);
        const isChosen = suggestionEngineCardHighlightKey != null && cardKey === suggestionEngineCardHighlightKey;
        const legacyHere = cardLegacyOf(strategy);
        const baseLegacy = agedCareBaseline?.legacyValue ?? null;
        const legacyDelta = baseLegacy != null ? legacyHere - baseLegacy : null;
        const paidHere = Math.max(0, Number(strategy.radPaidNet) || 0);
        const cardCosts = strategy.strategySpecificAgedCareCosts || {};
        const dapHere = Number(cardCosts.dailyAccommodationPayment) || 0;
        const baseCosts = agedCareBaseline?.agedCareCosts || {};
        const baseDap = Number(baseCosts.dailyAccommodationPayment) || 0;
        const careHere = Number(strategy.snapshot?.totalAgedCareCosts) || 0;
        const pensionHere = Number(strategy.snapshot?.pension) || 0;
        const pensionDelta = snapshotBaseline ? pensionHere - snapshotBaseline.pension : null;
        const cfHere = Number(strategy.snapshot?.netCashflow) || 0;
        const runway = (0, $0fe89e03b6df746e$export$437127b6aedd5958)(strategy.projections ?? []);
        const words = (0, $95e43332fd84eec4$export$f973c372d76f95c8)(strategy, factFind, getDisplayStrategyName(strategy.name, strategy.radPaidNet, strategy.radRoomPrice, secondRoomOf(strategy), moveOf(strategy), villageOf(strategy)));
        const labels = (strategy.recommendationLabels || [
            strategy.recommendedLabel || strategy.optimisationLabel
        ]).filter(Boolean);
        // The chip says what the card is (planChoiceRule.ts): "Leaves the most" only on the plan that does.
        const estateLead = (analysis.recommendedOptimalStrategies || []).find((r)=>r.label === 'Optimal Legacy');
        const leadException = estateLead?.lead && estateLead.strategy?.name === strategy.name && !strategy.isLowerRadNearBestCard && !strategy.isFutureEventOverlayCard ? estateLead.lead : null;
        const chip = strategy.isLowerRadNearBestCard ? strategy.lowerRadNearBestMeta?.chip ?? (0, $5a094123650e8adb$export$a1a7ae9e29edd48c) : strategy.isFutureEventOverlayCard ? `If ${partnerDisplayName} enters care later` : labels.includes('Optimal Legacy') ? (0, $5a094123650e8adb$export$a035dca5f387c63d)(leadException) : labels.includes((0, $400a08a42b233386$export$920ad41b346ae01a)) ? 'Income covers the costs' : labels.includes('Optimal Cashflow') ? 'Most left over each year' : labels.includes('Optimal Age Pension') ? 'Highest Age Pension' : labels[0] ? (0, $400a08a42b233386$export$da83f84a5a007a8a)(labels[0]) : null;
        const fundingLines = (0, $e5cae8423a439bf1$export$8f80043cee83ba5d)(factFind, (0, $c549af0b979cab3f$export$9ca4abb860f88bf9)(strategy.radFunding || {}));
        const soldPhrase = (0, $e5cae8423a439bf1$export$83ba4f4a49e92f66)(fundingLines, (0, $f94e45ac645ae232$export$3dc27271f5d5c629));
        const lines = [];
        if (paidHere > 0.5) {
            lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    soldPhrase ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-slate-900",
                                children: soldPhrase.charAt(0).toUpperCase() + soldPhrase.slice(1)
                            }),
                            " ",
                            fundingLines.length > 1 ? 'pay' : 'pays',
                            " the deposit."
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "The deposit of ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-slate-900",
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(paidHere))
                            }),
                            " is paid up front."
                        ]
                    }),
                    ' ',
                    "It comes back when care ends, less what the home keeps \u2014 2% a year for up to five years, so never more than 10%."
                ]
            }));
            lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "Paying ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(paidHere)),
                    " up front",
                    baseDap > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                className: "text-slate-900",
                                children: [
                                    "cuts the daily room fee from ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(baseDap)),
                                    " to ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(dapHere)),
                                    " a day"
                                ]
                            })
                        ]
                    }) : null,
                    pensionDelta != null && Math.round(pensionDelta) !== 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            baseDap > 0 ? ' and ' : ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                className: "text-slate-900",
                                children: [
                                    pensionDelta > 0 ? 'lifts' : 'lowers',
                                    " the Age Pension by ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(pensionDelta))),
                                    " a year"
                                ]
                            }),
                            pensionDelta > 0 ? ", because deposit money isn\u2019t counted in the assets test" : ''
                        ]
                    }) : null,
                    "."
                ]
            }));
        } else lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                "Nothing is paid up front; the whole room is charged daily, like rent",
                dapHere > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        " \u2014 ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                            className: "text-slate-900",
                            children: [
                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(dapHere)),
                                " a day"
                            ]
                        })
                    ]
                }) : null,
                "."
            ]
        }));
        lines.push(cfHere < 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                "Income still falls ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                    className: "text-slate-900",
                    children: [
                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(cfHere))),
                        " a year short"
                    ]
                }),
                "; savings cover it. Care usually ends well before the savings do."
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                "Income covers the costs, with ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                    className: "text-slate-900",
                    children: [
                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(cfHere)),
                        " a year"
                    ]
                }),
                " to spare."
            ]
        }));
        // A plan that leaves the family WORSE off than doing nothing says so in its own line — any
        // plan, not only a reverse mortgage (owner, 18 Oct 2026). A better cashflow or pension must
        // never read as the whole story when the estate pays for it.
        if (legacyDelta != null && Math.round(legacyDelta) < 0) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
            "data-testid": "card-estate-worse",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-rose-700",
                    children: "Important:"
                }),
                " what you leave your family would be ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                    className: "text-rose-700",
                    children: [
                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(legacyDelta))),
                        " less"
                    ]
                }),
                " than ",
                bench.word,
                " after about ",
                currentSettings.legacyYears,
                " ",
                currentSettings.legacyYears === 1 ? 'year' : 'years',
                ". That is the price of what this plan buys elsewhere."
            ]
        }));
        // A home kept and let: the six-year capital gains tax rule, as every module says it (22 Oct 2026).
        if (strategy.strategyOptions?.rentHome) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
            "data-testid": "card-rented-home-cgt",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "Worth knowing:"
                }),
                " ",
                (0, $203e38d6e6c434f4$export$b96695c1a4aaa70d)
            ]
        }));
        if (leadException) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
            "data-testid": "lead-exception-note",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "Why it comes first:"
                }),
                " ",
                (0, $5a094123650e8adb$export$27f705a6fa40271e)(leadException, (0, $f94e45ac645ae232$export$3dc27271f5d5c629))
            ]
        }));
        // Why a second card is shown sits beside its figures (EnginePlanCard whyShown), as in every module (23 Oct 2026).
        const whyShown = strategy.isLowerRadNearBestCard && strategy.lowerRadNearBestMeta ? strategy.lowerRadNearBestMeta.line : null;
        const horizonNote = (0, $3d096644ffaac9d7$export$bcf3d26e8114b217)(strategy, factFind);
        const futureNotice = strategy.isFutureEventOverlayCard && strategy.futureEventAssumptions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "border-b border-slate-200 bg-white px-5 py-3 text-[13px] text-slate-700",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "font-semibold text-slate-900",
                    children: [
                        "If ",
                        partnerDisplayName,
                        " enters care in year ",
                        strategy.futureEventAssumptions.partnerEntryYear,
                        " (room ",
                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(strategy.futureEventAssumptions.partnerRoomPrice),
                        ")"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "mt-0.5 text-slate-600",
                    children: [
                        clientDisplayName,
                        " is modelled as ",
                        strategy.futureEventAssumptions.originalEntrantAliveAtEvent ? 'still living' : 'having passed away',
                        " at that time; about ",
                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(strategy.futureEventAssumptions.additionalAnnualCareCost),
                        " a year of extra care cost from then on. An illustration beside the main plan, not a recommendation."
                    ]
                })
            ]
        }) : null;
        const detailNode = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-6",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mb-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-baseline justify-between gap-3 flex-wrap mb-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                    className: "text-lg font-semibold text-gray-800",
                                    children: secondRoomOf(strategy) ? `Allocation to ${secondRoomOf(strategy).leadName}'s room` : 'Allocation to RAD'
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-xs text-gray-500",
                                    children: "Your balances today"
                                })
                            ]
                        }),
                        (()=>{
                            const mv = strategy.facilityMove;
                            if (!mv) return null;
                            return mv.stayPut ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-slate-700 mb-3",
                                "data-testid": "card-stay-put",
                                children: "Nothing changes: the current deposit stays where it is and nothing is sold."
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-slate-700 mb-3",
                                "data-testid": "card-refund-first",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(mv.fromRefund || 0))
                                    }),
                                    " comes from the refund of the current deposit first; the balances below show only what is sold on top of it."
                                ]
                            });
                        })(),
                        (()=>{
                            const ve = strategy.villageExit;
                            if (!ve) return null;
                            const fromVillage = Number(ve.fromVillage) || 0;
                            const by = ve.paidAtMove ? ' (at the move)' : ve.refundDate ? ` (by ${(0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(ve.refundDate)})` : '';
                            if (fromVillage <= 0.5) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-slate-700 mb-3",
                                "data-testid": "card-village-bank",
                                children: [
                                    "The village's ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(Number(ve.toBank) || 0)),
                                    " exit payment goes to the bank when it arrives",
                                    by,
                                    "; nothing of it goes to the room."
                                ]
                            });
                            const perDayVillage = Number(ve.interim?.perDay) || 0;
                            const waitTotal = Number(ve.interim?.total) || 0;
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-slate-700 mb-3",
                                "data-testid": "card-village-refund",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(fromVillage))
                                    }),
                                    " comes from the village's exit payment when it arrives",
                                    by,
                                    waitTotal > 0.5 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            "; until then $",
                                            (Math.round(perDayVillage * 100) / 100).toFixed(2),
                                            " a day is charged on that part of the room (about ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(waitTotal)),
                                            " in all)"
                                        ]
                                    }) : null,
                                    ". The balances below show only what is sold at entry."
                                ]
                            });
                        })(),
                        $ca941a2ef5e688c5$var$debtPayoffFundingLine(strategy, factFind) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-sm text-teal-700 mb-3",
                            children: [
                                "Separately, ",
                                $ca941a2ef5e688c5$var$debtPayoffFundingLine(strategy, factFind),
                                " is used to clear debt",
                                $ca941a2ef5e688c5$var$careStartDateFromStrategyOptions(strategyOptions) ? ' on the entry date' : '',
                                " \u2014 after the balances shown here."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-2 gap-3",
                            children: strategy.assetAllocation?.filter((asset)=>{
                                /*
                         * A ROW FOR AN ACCOUNT THAT DOES NOT EXIST IS PURE NOISE.
                         *
                         * The generator walks every asset type the fact-find can hold, so
                         * an empty placeholder rendered as "Shares / Managed Funds - $0
                         * kept - No balance - Untouched": four pieces of furniture around
                         * nothing, sitting beside the rows that matter (owner, 2026-09-01,
                         * on this screen looking "very bla").
                         */ const kept = Math.max(0, parseFloat(String(asset.remainingAmount)) || 0);
                                const used = Math.max(0, parseFloat(String(asset.liquidatedAmount)) || 0);
                                return kept + used > 0;
                            }).map((asset, assetIndex)=>{
                                const keptAmount = Math.max(0, parseFloat(String(asset.remainingAmount)) || 0);
                                const soldAmount = Math.max(0, parseFloat(String(asset.liquidatedAmount)) || 0);
                                const opening = keptAmount + soldAmount;
                                const soldShare = opening > 0 ? Math.round(soldAmount / opening * 100) : 0;
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "rounded-xl border border-slate-200 bg-white p-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex items-baseline justify-between gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "min-w-0 truncate text-sm font-semibold text-slate-800",
                                                    children: asset.assetName
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "shrink-0 text-sm font-bold tabular-nums text-slate-900",
                                                    children: [
                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(keptAmount),
                                                        ' ',
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-[11px] font-medium text-slate-500",
                                                            children: "kept"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "mt-2 h-1.5 w-full overflow-hidden rounded-full bg-slate-100",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: `h-full rounded-full ${soldShare >= 100 ? 'bg-rose-500' : soldShare > 0 ? 'bg-amber-500' : 'bg-emerald-500'}`,
                                                style: {
                                                    width: `${soldShare > 0 ? Math.max(4, soldShare) : 100}%`
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mt-1.5 flex items-baseline justify-between gap-2 text-[11.5px]",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-slate-500",
                                                    children: opening > 0 ? `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(opening)} today` : 'No balance'
                                                }),
                                                soldAmount > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "font-semibold text-rose-700 tabular-nums",
                                                    children: [
                                                        "-",
                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(soldAmount),
                                                        " used (",
                                                        soldShare,
                                                        "%)"
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "font-semibold text-emerald-700",
                                                    children: "Untouched"
                                                })
                                            ]
                                        })
                                    ]
                                }, assetIndex);
                            })
                        }),
                        (()=>{
                            const sr = secondRoomRowOf(strategy);
                            if (!sr || !((Number(sr.roomPrice) || 0) > 0)) return null;
                            const names = (0, $b8d3cfe4c156722e$export$24ee473c3b86ae0)(factFind, sr.person);
                            const lines = (0, $e5cae8423a439bf1$export$8f80043cee83ba5d)(factFind, sr.radFunding);
                            const funded = lines.reduce((t, l)=>t + l.amount, 0);
                            const when = sr.entersLater && sr.careStartDate ? `taken when ${names.secondName} moves in, ${(0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(sr.careStartDate)}` : 'taken with the first deposit';
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-4",
                                "data-testid": "second-room-allocation",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-baseline justify-between gap-3 flex-wrap mb-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                className: "text-lg font-semibold text-gray-800",
                                                children: [
                                                    "Allocation to ",
                                                    names.secondName,
                                                    "'s room"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "text-xs text-gray-500",
                                                children: [
                                                    "From what is left after ",
                                                    names.firstName,
                                                    "'s deposit \u2014 ",
                                                    when
                                                ]
                                            })
                                        ]
                                    }),
                                    lines.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-sm text-slate-600",
                                        children: [
                                            "Nothing is paid up front for ",
                                            names.secondName,
                                            "'s room; the whole ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(sr.roomPrice) || 0),
                                            " is paid daily."
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "grid grid-cols-1 md:grid-cols-2 gap-3",
                                        children: lines.map((l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "rounded-xl border border-slate-200 bg-white p-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex items-baseline justify-between gap-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-sm font-semibold text-gray-800",
                                                                children: l.label
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "text-sm font-bold tabular-nums text-rose-700",
                                                                children: [
                                                                    "-",
                                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(l.amount),
                                                                    " used"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "mt-1 text-xs text-slate-500",
                                                        children: [
                                                            "After ",
                                                            names.firstName,
                                                            "'s deposit has come out of it."
                                                        ]
                                                    })
                                                ]
                                            }, l.key))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-2 text-sm text-slate-700",
                                        children: [
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(funded),
                                            " paid up front for ",
                                            names.secondName,
                                            "'s ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(sr.roomPrice) || 0),
                                            " room",
                                            funded + 0.5 < (Number(sr.roomPrice) || 0) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    " \u2014 the unpaid ",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((Number(sr.roomPrice) || 0) - funded),
                                                    " is charged daily as a DAP."
                                                ]
                                            }) : '.'
                                        ]
                                    })
                                ]
                            });
                        })()
                    ]
                }),
                (()=>{
                    const sold = (strategy.assetAllocation || []).filter((a)=>(parseFloat(String(a.liquidatedAmount)) || 0) > 0);
                    const roomPrice = Number(strategy.radRoomPrice) || 0;
                    const radPaidHere = Number(strategy.radPaidNet) || 0;
                    const unpaidRoom = Math.max(0, roomPrice - radPaidHere);
                    const cardCosts = strategy.strategySpecificAgedCareCosts || {};
                    const cardDap = Number(cardCosts.dailyAccommodationPayment) || 0;
                    if (!(roomPrice > 0)) return null;
                    /*
     * The CGT the engine already deducted (radPaidNet is NET of it) but never showed
     * (owner, 2026-08-24). Rebuilt from the card's own funding map with the SAME shared
     * functions the engine ran - flatten to manual keys, total with
     * computeRadFundingTotals, detail with calculateSharePartialDisposalTax - so the
     * figure here equals the deduction to the cent.
     */ const manualKeys = (0, $c549af0b979cab3f$export$9ca4abb860f88bf9)(strategy.radFunding || {});
                    const fundingTotals = (0, $bd80071df75c742b$export$e98193fa2b9f521b)(factFind, manualKeys, {});
                    const cgtRows = Object.entries(fundingTotals.byKey).filter(([, e])=>e.cgt > 0).map(([key, e])=>{
                        const parsed = (0, $85f2560fc9a239a0$export$eb5d467aa7d657c6)(key);
                        const located = parsed ? (0, $bd80071df75c742b$export$f59ccf8b394d8480)(factFind, parsed.assetType, parsed.assetId) : null;
                        const asset = located?.asset;
                        const summary = asset ? (0, $a764bc0f6f904854$export$bb01b201c6492ed7)(factFind, asset, e.gross, {
                            trustDisposal: 'distribute'
                        }) : null;
                        return {
                            label: asset?.description || 'shares',
                            gross: e.gross,
                            cgt: e.cgt,
                            net: e.net,
                            summary: summary
                        };
                    });
                    const totalCgt = cgtRows.reduce((t, r)=>t + r.cgt, 0);
                    const cgtExplain = cgtRows.map((r)=>{
                        const gain = r.summary?.capitalGain;
                        const assessable = r.summary?.assessableCapitalGain;
                        return `${r.label}: selling ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(r.gross)} realises an estimated capital gain of ` + `${gain != null ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(gain) : 'n/a'}; after the 50% discount, ` + `${assessable != null ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(assessable) : 'half'} is taxable, giving estimated tax of ` + `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(r.cgt)} \u{2014} so ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(r.net)} reaches the deposit.`;
                    }).join(' ') + ` Worked out from the recorded cost base (or the standard assumption where none is recorded) at each owner's marginal rate \u{2014} the same estimate Manual Control's funding panel shows. An accountant can confirm the exact amount.`;
                    /*
     * TRIMMED (owner, 18 Oct 2026: "is it a bit duplicated?"). The card's three layers and
     * "Explain this" already say what the plan does, so only what is said NOWHERE else
     * stays here: the second stage where a partner enters later, and the capital gains tax
     * the engine deducted on the way to the deposit.
     */ const costs = strategy.strategySpecificAgedCareCosts;
                    const secondRoomRow = strategy.secondRoom;
                    const phaseTwo = strategy.phaseTwo;
                    const phaseTwoDaily = (0, $bdfd96a4f4ac117d$export$d9a4203f6e9eec45)({
                        phaseTwo: phaseTwo
                    });
                    const phaseNames = {
                        ...(0, $b8d3cfe4c156722e$export$24ee473c3b86ae0)(factFind, secondRoomRow?.person),
                        fromLabel: (0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(phaseTwo?.fromDate || '')
                    };
                    /* Both of a couple in care: each room's deposit and unpaid part, as chips, because the
       card's one line cannot carry two rooms (owner, 7 Oct 2026). One room needs no chips —
       the card's sub-line already says "65% of the room as a deposit; $280,000 paid daily". */ const flow = (()=>{
                        const sr = secondRoomRowOf(strategy);
                        if (!sr || !((Number(sr.roomPrice) || 0) > 0)) return [];
                        const names = (0, $b8d3cfe4c156722e$export$24ee473c3b86ae0)(factFind, sr.person);
                        const price = Number(sr.roomPrice) || 0;
                        const paid = Math.min(price, Number(sr.radPaid) || 0);
                        const unpaid = Math.max(0, price - paid);
                        const dap = Number(sr.agedCareCosts?.dailyAccommodationPayment) || 0;
                        const paidWhen = sr.entersLater && sr.careStartDate ? `, paid ${(0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(sr.careStartDate)}` : '';
                        return [
                            {
                                amount: radPaidHere,
                                label: 'RAD',
                                sub: unpaidRoom > 0.5 ? `refundable ${String.fromCharCode(0xb7)} ${Math.round(radPaidHere / roomPrice * 100)}% of room` : 'refundable ' + String.fromCharCode(0xb7) + ' room paid in full',
                                tone: 'good'
                            },
                            ...unpaidRoom > 0.5 ? [
                                {
                                    amount: unpaidRoom,
                                    label: 'unpaid',
                                    sub: cardDap > 0 ? `DAP ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(cardDap)}/day ${String.fromCharCode(0xb7)} like rent` : 'charged daily, like rent',
                                    tone: 'warn'
                                }
                            ] : [],
                            ...paid > 0.5 ? [
                                {
                                    amount: paid,
                                    label: `RAD ${String.fromCharCode(0xb7)} ${names.secondName}'s room`,
                                    sub: `refundable ${String.fromCharCode(0xb7)} ${Math.round(paid / price * 100)}% of room${paidWhen}`,
                                    tone: 'good'
                                }
                            ] : [],
                            ...unpaid > 0.5 ? [
                                {
                                    amount: unpaid,
                                    label: `unpaid ${String.fromCharCode(0xb7)} ${names.secondName}'s room`,
                                    sub: dap > 0 ? `DAP ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dap)}/day ${String.fromCharCode(0xb7)} like rent` : 'charged daily, like rent',
                                    tone: 'warn'
                                }
                            ] : []
                        ];
                    })();
                    if (flow.length === 0 && phaseTwoDaily == null && !(sold.length > 0 && totalCgt > 0)) return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-6 space-y-2 text-[13px] leading-relaxed text-slate-600",
                        "data-testid": "card-detail-notes",
                        children: [
                            flow.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$9c139f18dfc312b8), {
                                steps: flow
                            }),
                            phaseTwoDaily != null && costs && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    "data-testid": "card-phase-two",
                                    children: (0, $b8d3cfe4c156722e$export$72e32d04cedd8a9d)(phaseNames, Number(costs.totalDailyCost) || 0, phaseTwoDaily)
                                })
                            }),
                            sold.length > 0 && totalCgt > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "Funded by the sales shown above \u2014 an estimated",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-semibold text-slate-700",
                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(totalCgt)
                                    }),
                                    " in",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                        term: "capital gains tax"
                                    }),
                                    " is deducted before the money reaches the deposit (",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                        term: "how is it worked out?",
                                        children: cgtExplain
                                    }),
                                    ")."
                                ]
                            })
                        ]
                    });
                })(),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $723f95d7e9f568b1$export$2e2bcd8739ae039), {
                    strategy: strategy,
                    agedCareCosts: agedCareCosts,
                    factFind: factFind,
                    baseline: snapshotBaseline,
                    openRequest: tileRequest && tileRequest.cardKey === cardKey ? {
                        tile: tileRequest.tile,
                        nonce: tileRequest.nonce
                    } : null
                })
            ]
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b383720e6b5df564$export$2e2bcd8739ae039), {
            testId: `engine-plan-card-${index}`,
            chip: chip,
            whyShown: whyShown,
            chipTone: strategy.isLowerRadNearBestCard ? 'neutral' : 'blue',
            title: words.title,
            sub: words.sub || undefined,
            legacy: legacyHere,
            legacyDelta: legacyDelta,
            horizonYears: currentSettings.legacyYears,
            baselineWord: bench.word,
            bars: {
                gainPct: legacyDelta != null ? Math.abs(legacyDelta) / cardGainMax * 100 : 0,
                tiedUp: paidHere,
                tiedUpPct: paidHere / cardDepositMax * 100
            },
            numbers: [
                {
                    label: 'Care costs',
                    value: careHere,
                    unit: 'a year',
                    vs: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            dapHere > 0 ? `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(dapHere * 365))} of it is the daily room fee \xb7 ` : '',
                            bench.word,
                            " ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(snapshotBaseline?.careCosts ?? 0))
                        ]
                    }),
                    onWhy: ()=>setCashflowFor({
                            row: strategy,
                            page: 'care'
                        })
                },
                {
                    label: `${enteringName}'s Age Pension`,
                    value: pensionHere,
                    unit: 'a year',
                    tone: pensionDelta != null && pensionDelta > 0 ? 'good' : 'neutral',
                    vs: pensionDelta != null && Math.round(pensionDelta) !== 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: pensionDelta > 0 ? 'text-emerald-700 font-semibold' : 'text-rose-700 font-semibold',
                        children: [
                            pensionDelta > 0 ? '+' : "\u2212",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(pensionDelta))),
                            " a year",
                            pensionDelta > 0 ? " \u2014 deposit money isn\u2019t counted" : ''
                        ]
                    }) : `the same as ${bench.word}`,
                    onWhy: ()=>setCashflowFor({
                            row: strategy,
                            page: 'pension'
                        })
                },
                {
                    label: cfHere < 0 ? 'Each year, short by' : 'Left over each year',
                    value: Math.abs(cfHere),
                    tone: cfHere < 0 ? 'neutral' : 'good',
                    vs: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            snapshotBaseline ? `was ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(snapshotBaseline.netCashflow)))} ${bench.after}` : '',
                            cfHere < 0 ? " \xb7 met from savings" : ''
                        ]
                    }),
                    onWhy: ()=>setCashflowFor({
                            row: strategy,
                            page: 'cashflow'
                        })
                }
            ],
            runline: (()=>{
                // Every account in the order it is drawn, then the deposit or borrowing — the line every
                // module's card now gives (owner, 22 Oct 2026). The older headline stays as a fallback.
                const ff = strategy.originalFactFind || factFind;
                const forWhom = ff.goals?.aged_care_for;
                const refundTo = ff.adviceFor === 'couple' && forWhom !== 'both' ? (forWhom === 'partner' ? ff.client?.firstName : ff.partner?.firstName) || 'your partner' : 'the estate';
                const line = (0, $2ddaae90639b5011$export$7526d1fcb4423629)({
                    rows: strategy.projections ?? [],
                    factFind: ff,
                    horizonYears: Number(currentSettings.legacyYears) || 5,
                    enteringName: enteringName,
                    deposit: {
                        paid: Number(strategy.radPaidNet) || 0,
                        refundTo: refundTo
                    }
                });
                if (line) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "text-slate-900",
                            children: "When the money runs out:"
                        }),
                        " ",
                        line
                    ]
                });
                return runway ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "text-slate-900",
                            children: "When the money runs out:"
                        }),
                        " ",
                        runway.headline,
                        runway.flag ? ` ${runway.flag}` : ''
                    ]
                }) : null;
            })(),
            worthKnowing: (()=>{
                /* ON THE CARD, not only inside "Explain this" (owner, 2026-09-01: "it wasn't until I
                       clicked on 'Explain this' that I realised that this is a reverse mortgage"). A loan
                       with no repayments puts nothing in the cashflow number above, which is exactly
                       what makes it invisible; the one line that has to reach a reader who never opens
                       the explanation is that there IS a cost and where it went. */ const er = strategy.equityRelease;
                const loan = er && Number(er.loanAmount) > 0 ? er : null;
                const grown = loan ? Number(loan.projectedBalance) || 0 : 0;
                const drawn = loan ? Number(loan.loanAmount) || 0 : 0;
                const yrs = loan ? Number(loan.years) || 0 : 0;
                // A debt this plan clears, said on the card (the rebuild had dropped the old card's
                // "Clears …" line; owner, 18 Oct 2026). Where it comes from is in "Show the detail".
                const cleared = $ca941a2ef5e688c5$var$debtsClearedBy(strategy);
                const clearedFrom = cleared ? $ca941a2ef5e688c5$var$debtPayoffFundingLine(strategy, factFind) : null;
                if (!horizonNote && !loan && !cleared) return null;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        cleared && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            "data-testid": "card-clears-debt",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "font-semibold",
                                    children: [
                                        "Clears the ",
                                        cleared
                                    ]
                                }),
                                clearedFrom ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        " with ",
                                        clearedFrom
                                    ]
                                }) : null,
                                $ca941a2ef5e688c5$var$clearedDebtsCarryInterest(strategy, factFind) ? ', so the interest on it stops.' : ', so it is no longer owed.'
                            ]
                        }),
                        horizonNote && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "font-semibold",
                                    children: "Worth knowing:"
                                }),
                                " ",
                                horizonNote
                            ]
                        }),
                        loan && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "font-semibold",
                                    children: [
                                        "This is a ",
                                        loan.kind === 'heas' ? 'Home Equity Access Scheme loan' : 'reverse mortgage',
                                        "."
                                    ]
                                }),
                                ' ',
                                "There are no repayments, so none of its cost appears in the cashflow below.",
                                grown > drawn && yrs > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        " The debt compounds from ",
                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(drawn),
                                        " to ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold",
                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(grown)
                                        }),
                                        " over ",
                                        yrs,
                                        " ",
                                        yrs === 1 ? 'year' : 'years',
                                        " and is settled out of the house."
                                    ]
                                }),
                                ' ',
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "font-semibold",
                                    children: "Explain this"
                                }),
                                " sets out how it works and what to watch."
                            ]
                        })
                    ]
                });
            })(),
            lines: lines,
            // What the family receives from the guaranteed income at the start, middle and end
            // (guaranteed income review E4; mock-up screens 3 and 4).
            familyPanel: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09575c4cc12d1d84$export$47f38349b07e923a), {
                row: strategy,
                evaluated: analysis.allSimulatedStrategies || analysis.strategies,
                factFind: factFind,
                personName: enteringName,
                horizonYears: currentSettings.legacyYears,
                testId: `engine-plan-card-${index}-family`
            }),
            // Income only is held until the client confirms it, for this amount (E5; mock-up screen 4).
            beforeChoose: (()=>{
                const lever = (0, $09575c4cc12d1d84$export$e45920170ff81bed)(strategy);
                if (!lever?.incomeOnly) return null;
                const confirm = (0, $5eae79c7e46ed27e$export$415ddf94c95c9134)(setFactFind);
                return confirm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$4538b371a206da0c), {
                    factFind: factFind,
                    amount: lever.amount,
                    onChange: confirm,
                    testId: `engine-plan-card-${index}-income-only`
                }) : null;
            })(),
            chooseHeld: incomeOnlyHeldFor(strategy),
            chosen: isChosen,
            onExplain: ()=>setExplainStrategy(strategy),
            onRisks: ()=>setRiskStrategy(strategy),
            onChoose: ()=>{
                if (!incomeOnlyHeldFor(strategy)) saveSelectedStrategy(strategy);
            },
            chooseLabel: suggestionEngineCardHighlightKey != null ? 'Choose this instead' : 'Choose this plan',
            detail: detailNode,
            detailOpen: detailOpenKey === cardKey,
            onToggleDetail: ()=>setDetailOpenKey((k)=>k === cardKey ? null : cardKey),
            notices: futureNotice,
            // The ONE "Get the advice document" on this screen sits here, where the plan was just
            // chosen (owner, 26 Oct 2026); the banner above keeps its sentence but not a button.
            chosenStrip: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2194d8b5de21e3ff$export$4df4eb62309771d0), {
                possessiveFile: voice.possessive,
                onAdvice: ()=>{
                    openAdviceDocument(strategy);
                },
                busy: documentBusy,
                onCustomise: onBuildYourOwn ? ()=>onBuildYourOwn(strategy) : null
            })
        }, `${strategy.name}-${index}`);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-6",
        children: [
            explainStrategy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $12084f898a868747$export$2e2bcd8739ae039), {
                eyebrow: "Explain this",
                title: (0, $95e43332fd84eec4$export$f973c372d76f95c8)(explainStrategy, factFind, getDisplayStrategyName(explainStrategy.name, explainStrategy.radPaidNet, explainStrategy.radRoomPrice, secondRoomOf(explainStrategy), moveOf(explainStrategy), villageOf(explainStrategy))).title,
                intro: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Each line says what you do, and what that does to the numbers. ",
                        bench.sentence
                    ]
                }),
                onClose: ()=>setExplainStrategy(null),
                footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                    variant: "secondary",
                    size: "sm",
                    onClick: ()=>{
                        const s = explainStrategy;
                        setExplainStrategy(null);
                        handleDeepDive(s);
                    },
                    children: "See the year-by-year figures"
                }),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a258b04930632a82$export$2e2bcd8739ae039), {
                        eyebrow: null,
                        told: "causeEffect",
                        causeEffectFacts: {
                            baselineCareAnnual: snapshotBaseline?.careCosts ?? null,
                            baselineDapDaily: Number(agedCareBaseline?.agedCareCosts?.dailyAccommodationPayment) || null,
                            baselineInvestmentIncome: snapshotBaseline?.investmentIncome ?? null,
                            planInvestmentIncome: explainStrategy.snapshot?.investmentIncome != null ? Number(explainStrategy.snapshot.investmentIncome) - (Number(explainStrategy.snapshot.rentalExpenses) || 0) : null,
                            enteringName: enteringName,
                            illnessSeparated: factFind?.adviceFor === 'couple' && (0, $8eecd0af141b9afb$export$9b95c99516118f10)(factFind, (0, $8eecd0af141b9afb$export$5f0bb1b091776594)(factFind))
                        },
                        factFind: explainStrategy.originalFactFind || factFind,
                        overallStrategy: explainStrategy.strategyOptions || {},
                        strategyInputs: explainStrategy.strategyOptions || {},
                        downsizeDetails: explainStrategy.strategyOptions?.downsizeDetails || {},
                        investmentPropertyDetails: explainStrategy.strategyOptions?.investmentPropertyDetails || {},
                        reverseMortgageDetails: explainStrategy.strategyOptions?.reverseMortgageDetails || null,
                        heasDetails: explainStrategy.strategyOptions?.heasDetails || null,
                        otherStrategies: explainStrategy.strategyOptions?.otherStrategies || null,
                        ...(0, $9662e9f9d2150a64$export$885bb9fc52427225)(explainStrategy, explainStrategy.originalFactFind || factFind),
                        annuityRecord: explainStrategy.strategyOptions?.annuityRecord || null,
                        debtPayoffPlan: explainStrategy.strategyOptions?.debtPayoff || null,
                        // The flattened `type-id` keys, not the engine's nested shape — the recap
                        // reads the Manual Control form. Converted server-side by the engine's own
                        // helper so both surfaces name the same funding assets.
                        radFunding: explainStrategy.radFundingManualKeys || {},
                        cgtOverrides: explainStrategy.strategyOptions?.cgtOverrides || {},
                        radInput: Number(explainStrategy.radRoomPrice) || 0,
                        radPaid: Number(explainStrategy.radPaidNet) || 0,
                        secondRoom: (()=>{
                            const sr = explainStrategy.secondRoom;
                            return sr ? {
                                name: (0, $b8d3cfe4c156722e$export$24ee473c3b86ae0)(factFind, sr.person).secondName,
                                leadName: (0, $b8d3cfe4c156722e$export$24ee473c3b86ae0)(factFind, sr.person).firstName,
                                roomPrice: sr.roomPrice,
                                radPaid: sr.radPaid,
                                dailyTotal: sr.agedCareCosts?.totalDailyCost ?? null,
                                funding: (0, $e5cae8423a439bf1$export$8f80043cee83ba5d)(factFind, sr.radFunding),
                                paidFromLabel: sr.entersLater && sr.careStartDate ? (0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(sr.careStartDate) : undefined
                            } : null;
                        })(),
                        agedCareCosts: explainStrategy.strategySpecificAgedCareCosts || {},
                        simulatedFinancials: explainStrategy.strategyFinancials || {},
                        extraServiceFeeInput: 0,
                        // ONE baseline for the cards and the explanation — passed down, never rebuilt.
                        sharedBaseline: agedCareBaseline?.financials ? {
                            pension: agedCareBaseline.pension,
                            cashFlowAfterCare: agedCareBaseline.cashFlowAfterCare
                        } : null,
                        planRunway: (0, $761eebfc891b9eea$export$2e354e42d669da07)(explainStrategy.projections),
                        ...(()=>{
                            // The selected card reads the rail's long-run rows; any other card, its own plan-period rows.
                            const isSelected = !!selectedStrategy && selectedStrategy.id != null && selectedStrategy.id === explainStrategy.id;
                            const rows = isSelected && selectedPlanRunwayRows?.length ? selectedPlanRunwayRows : explainStrategy.projections ?? [];
                            const runway = (0, $0fe89e03b6df746e$export$464558962ff4a811)(rows, rows.length);
                            const ff = explainStrategy.originalFactFind || factFind;
                            const forWhom = ff.goals?.aged_care_for;
                            const refundTo = ff.adviceFor === 'couple' && forWhom !== 'both' ? (forWhom === 'partner' ? ff.client?.firstName : ff.partner?.firstName) || 'your partner' : 'the estate';
                            const paid = Number(explainStrategy.radPaidNet) || 0;
                            // The story, account by account, with the engine's order and why (owner, 18 Oct 2026).
                            // Only where a year falls short, as every other module: on a plan with money to spare there is no
                            // gap to draw, so no order to tell (consistency audit, 22 Oct 2026).
                            const story = (0, $0fe89e03b6df746e$export$693cc3146baa3244)(rows).hasDeficit ? (0, $2ddaae90639b5011$export$bdea18f456fd84b)({
                                rows: rows,
                                factFind: ff,
                                runway: runway,
                                deposit: {
                                    paid: paid,
                                    refundTo: refundTo
                                },
                                horizonYears: Number(legacyYears) || 5,
                                enteringName: enteringName
                            }) : null;
                            return {
                                moneyOrder: (0, $f15268380bf00a12$export$5607313da658fe63)(rows, ff, runway, {
                                    refund: paid,
                                    refundTo: refundTo
                                }),
                                moneyStory: story ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ddaae90639b5011$export$1a915263dc5391f1), {
                                    story: story
                                }) : null
                            };
                        })(),
                        baselineLegacy: agedCareBaseline?.legacyValue ?? null,
                        planLegacy: Array.isArray(explainStrategy.projections) && explainStrategy.projections.length > 0 ? explainStrategy.projections[explainStrategy.projections.length - 1]?.netWorth ?? null : null,
                        legacyYears: legacyYears,
                        /*
                         * The engine's annuity terms, told INSIDE the story rather than bolted on
                         * after it. Rendered alongside the recap, the modal showed one small box and
                         * nothing else whenever the recap had nothing to say (owner, 2026-09-01).
                         */ engineAnnuityTerms: explainStrategy.annuityTerms,
                        equityRelease: explainStrategy.equityRelease,
                        /*
                         * ENTER THE REAL QUOTE (owner, 2026-09-01: the Suggestion Engine "doesn't
                         * provide the ability to enter the actual quote"). Committing one re-runs
                         * the whole analysis, because a real rate can change which strategy wins -
                         * relabelling this one card would leave the ranking built on our rate.
                         */ annuityQuoteControl: (()=>{
                            /* A quote belongs to THIS plan's type and amount (guaranteed income review M5): other
                               amounts of the same type are scaled from it; other types stay on our estimate. */ const lever = explainStrategy.meansTestStrategy;
                            const terms = explainStrategy.annuityTerms;
                            const amount = Number(terms?.purchaseAmount) || Number(lever?.purchaseAmount) || 0;
                            const kind = (0, $a412ceea866cc849$export$ecaf526bdee0a081)(lever);
                            const scope = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "Have a quote from a provider? Enter the yearly income they offered for ",
                                    (0, $a412ceea866cc849$export$4586a273a3098464)[kind],
                                    " of ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(amount),
                                    ". The plans with this type are re-compared on your number, scaled to their amount; the other types stay on our estimate.",
                                    acAnnuityQuote && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            " The quote in use: ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(acAnnuityQuote.income),
                                            " a year for ",
                                            (0, $a412ceea866cc849$export$4586a273a3098464)[acAnnuityQuote.kind],
                                            " of ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(acAnnuityQuote.amount),
                                            "."
                                        ]
                                    })
                                ]
                            });
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6421482343679f4$export$624bbc9c6c5928), {
                                draft: acAnnuityQuoteDraft,
                                onDraft: setAcAnnuityQuoteDraft,
                                committed: acAnnuityQuote ? acAnnuityQuote.income : null,
                                scope: scope,
                                onCommit: (next)=>{
                                    setAcAnnuityQuote(next != null && next > 0 && amount > 0 ? {
                                        income: next,
                                        kind: kind,
                                        amount: amount
                                    } : null);
                                    setExplainStrategy(null);
                                }
                            });
                        })()
                    }),
                    (()=>{
                        // The debts this plan keeps, and what the same plan with them paid off did (C.AC.4's twins:
                        // "<plan> + Clear Debt", or "+ Pay Down Debt (keep repayments)" where it cannot all be cleared).
                        const all = analysis?.allSimulatedStrategies || analysis?.strategies || [];
                        const name = String(explainStrategy.name || '');
                        const twin = all.find((s)=>s.name === `${name} + Clear Debt`) ?? all.find((s)=>s.name === `${name} + Pay Down Debt (keep repayments)`) ?? null;
                        const payments = explainStrategy.strategyOptions?.debtPayoff?.payments || {};
                        const fig = (s)=>({
                                estate: Number(s.snapshot?.legacyValue) || 0,
                                pension: Number(s.snapshot?.pension) || 0,
                                cashflow: Number(s.snapshot?.netCashflow) || 0
                            });
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe4e1ee5e30419ba$export$2e2bcd8739ae039), {
                            factFind: factFind,
                            clearedAmount: Object.values(payments).reduce((t, x)=>t + (Number(x) || 0), 0),
                            plan: fig(explainStrategy),
                            twin: twin ? fig(twin) : null,
                            years: legacyYears,
                            context: "tested"
                        });
                    })(),
                    explainStrategy.strategyOptions?.rentHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a8295193c5be8a0$export$2e2bcd8739ae039), {
                        horizonYears: Number(legacyYears) || 5,
                        they: (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind).they
                    })
                ]
            }),
            (factFind?.structures || []).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "p-4 rounded-lg border border-slate-200/70 border-l-4 border-amber-400 bg-white text-sm text-amber-950 space-y-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "font-semibold",
                        children: "Trusts and companies in strategy suggestions"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: (0, $bd80071df75c742b$export$40bc5139f87a7b00)(factFind) ? 'Automatic suggestions may use trust or company liquid assets and whole property sales. Pension and care fee estimates always include your structures.' : 'Automatic suggestions use personal assets only. Trust and company assets still count toward pension and care fee estimates.'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs",
                        children: "Change this in Strategy Analysis Setup (when entering the Suggestion Engine) or via the settings gear above."
                    })
                ]
            }),
            showAssumptionsModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                titleId: "engine-assumptions-heading",
                testId: "engine-assumptions-dialog",
                eyebrow: "How the plans are tested",
                title: "What the engine assumes",
                onClose: ()=>setShowAssumptionsModal(false),
                footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                    type: "button",
                    variant: "primary",
                    onClick: ()=>setShowAssumptionsModal(false),
                    children: "Got it"
                }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "space-y-4 text-sm text-slate-700",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-slate-600",
                            children: "The Suggestion Engine uses the following assumptions. For scenarios that fall outside these, use Manual Control."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                            className: "list-disc list-inside space-y-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Funding optimisation:"
                                        }),
                                        ' For each scenario (e.g. "Pay 50% RAD, Keep Home"), we test every possible order of drawing down from your liquid assets (bank, account-based pensions, shares). We then select the outcome that gives the best projected estate value (legacy) for that scenario. So the strategy shown is the optimal funding mix we found, not a single fixed path.'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Downsize residual:"
                                        }),
                                        " When modelling a downsize, surplus from the sale (after the new home purchase) is allocated to the RAD and/or the bank by default. Eligible clients (55+) may also model max downsizer contributions to super, or commencing an account-based pension at minimum drawdown where age-eligible (60+). Other growth assets (e.g. shares, investment properties) are not used for the residual because in aged care we face longevity risk and volatility. If you want to model allocating the residual to shares or property, use the Manual Control section."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "RAD levels:"
                                        }),
                                        " Strategies are tested across a range of RAD levels (e.g. 10% to 100% of the room price). Each level shows the outcome if that amount is paid as a Refundable Accommodation Deposit."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Selling costs & new home value:"
                                        }),
                                        " Downsize scenarios use the selling costs and new home value you entered in settings (or in Manual Control). Net proceeds = sale price - selling costs; surplus = net proceeds - new home cost."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Emergency fund & legacy years:"
                                        }),
                                        ' Settings such as emergency fund protection and the projection period (legacy years) apply to all strategies. Change these under "Things that change the answer".'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Income, growth & cost base:"
                                        }),
                                        " Projected results factor in the income rates, growth rates and any applicable cost base (e.g. for shares or investment property) entered in the fact find. If these assumptions differ in practice, the optimised result may be impacted."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Annuities are modelled, with a caution:"
                                        }),
                                        " The Suggestion Engine does test buying a guaranteed income for life (a lifetime annuity) \u2014 layered on top of a deposit, never instead of one, and never more than the share of the savings the client allowed. It tests the types that pay the money back to the family: money back in the early years and, for someone in aged care, the type that pays the full amount back at any time. Income only (level, or rising with prices) is tested only when the client asked for the most income even if nothing goes back, and a plan using it can't be chosen until the client confirms they understand that. Weigh it carefully in residential care: length of stay is typically 2\u20135 years, an annuity is priced on standard life expectancy, and the capital is committed for life. A ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "RAD is usually the stronger lever"
                                        }),
                                        " \u2014 it is fully exempt from the Age Pension assets test and it is refunded \u2014 so an annuity is generally only worth considering for money left over after the deposit you are comfortable paying. Where one is proposed, the card states who owns it, what comes back and whether the income continues to a surviving partner."
                                    ]
                                }),
                                (0, $5a094123650e8adb$export$fb0a335889dd79d0).map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                children: [
                                                    r.label,
                                                    ":"
                                                ]
                                            }),
                                            " ",
                                            r.text
                                        ]
                                    }, r.label))
                            ]
                        })
                    ]
                })
            }),
            (()=>{
                if (!suggestionEngineCardHighlightKey) return null;
                const chosenRow = displayedGoalStrategies.find((s)=>$ca941a2ef5e688c5$var$strategyCardSelectionKey(s) === suggestionEngineCardHighlightKey);
                if (!chosenRow) return null;
                const title = (0, $95e43332fd84eec4$export$f973c372d76f95c8)(chosenRow, factFind, getDisplayStrategyName(chosenRow.name, chosenRow.radPaidNet, chosenRow.radRoomPrice, secondRoomOf(chosenRow), moveOf(chosenRow), villageOf(chosenRow))).title;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 border-l-4 border-l-emerald-500 bg-white px-5 py-4 shadow-card",
                    "data-testid": "chosen-plan-banner",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "shrink-0 text-emerald-600",
                            "aria-hidden": true,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                size: 26,
                                strokeWidth: 1.75
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "min-w-[240px] flex-1 text-[14px] leading-relaxed text-slate-700",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                    className: "text-slate-900",
                                    children: [
                                        "You've chosen \"",
                                        title,
                                        '".'
                                    ]
                                }),
                                " It's saved with ",
                                voice.possessive,
                                " file. The next step is the advice document \u2014 the written record of this plan: what it assumes, what it costs each year, and what could go wrong. It's the document to keep."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex flex-wrap items-center gap-3",
                            children: onBuildYourOwn && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>onBuildYourOwn(chosenRow),
                                className: "text-[13px] font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                children: "Customise this plan"
                            })
                        })
                    ]
                });
            })(),
            (()=>{
                const costs = agedCareBaseline?.agedCareCosts || {};
                const secondCosts = agedCareBaseline?.secondEntersLater ? null : agedCareBaseline?.secondAgedCareCosts;
                const daily = (0, $bdfd96a4f4ac117d$export$4a7e3987a5ffaa21)(costs, secondCosts);
                if (!agedCareBaseline || agedCareBaseline.pension == null) return null;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac9505651d2e4510$export$2e2bcd8739ae039), {
                    careDaily: daily,
                    careAnnual: daily * 365,
                    enteringName: enteringName,
                    pension: Number(agedCareBaseline.pension) || 0,
                    cashflowAfterCare: Number(agedCareBaseline.cashFlowAfterCare) || 0,
                    legacy: agedCareBaseline.legacyValue ?? null,
                    horizonYears: currentSettings.legacyYears,
                    onWhyYears: ()=>setShowSettingsModal(true)
                });
            })(),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54f65c4595e0c798$export$2e2bcd8739ae039), {
                value: effectiveOptimisationSurface === 'covered' || effectiveOptimisationSurface === 'cashflow' || effectiveOptimisationSurface === 'pension' ? effectiveOptimisationSurface : 'legacy',
                onChange: (id)=>setOptimisationFocus(id),
                household: voice.names,
                enteringName: enteringName,
                horizonYears: currentSettings.legacyYears,
                coveredSameAsBest: (0, $400a08a42b233386$export$b8b8a2cedd92aa3a)(analysis?.recommendedOptimalStrategies),
                waysTested: waysTested,
                shown: Math.max(1, displayedGoalStrategies.length)
            }),
            effectiveOptimisationSurface === 'covered' && (0, $400a08a42b233386$export$b8b8a2cedd92aa3a)(analysis?.recommendedOptimalStrategies) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fb8e182bba3c591c$export$5a27702133c2149a), {
                onShowBestEstate: ()=>setOptimisationFocus('legacy')
            }),
            (analysis.horizonSetAside ?? []).filter((sa)=>sa.metric === effectiveOptimisationSurface).map((sa)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8dcabb024256f5a9$export$2e2bcd8739ae039), {
                    testId: "engine-set-aside",
                    className: "rounded-lg border border-slate-200 bg-white shadow-sm border-l-4 border-l-amber-400 pl-4 pr-4 py-3 text-sm text-slate-800 space-y-1.5",
                    linkClassName: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                    note: (link)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "font-semibold text-slate-900 leading-snug",
                                    children: "One strategy was set aside."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-slate-600 leading-relaxed",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold text-slate-800",
                                            children: getDisplayStrategyName(sa.strategy.name)
                                        }),
                                        " would give a",
                                        sa.metric === 'legacy' ? ' larger estate' : sa.metric === 'cashflow' ? ' higher cashflow' : ' higher Age Pension',
                                        ", but it needs more time than",
                                        ' ',
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                            term: "age and health",
                                            expandAs: "dialog",
                                            children: sa.warning
                                        }),
                                        " support, so it is not recommended.",
                                        ' ',
                                        link
                                    ]
                                })
                            ]
                        }),
                    renderCard: ()=>renderEngineCard(sa.strategy, 'set-aside')
                }, `set-aside-${sa.label}`)),
            chosenForOtherRoom != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700 shadow-card",
                "data-testid": "another-home-caution",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "text-slate-900",
                        children: "A different room price changes which plan is best,"
                    }),
                    " so the plans are re-tested from scratch for this home. Nothing here is chosen until you choose it; ",
                    voice.possessive,
                    " plan for the ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(chosenForOtherRoom)),
                    " room stays chosen unless you choose one of these instead. Once a plan for this home is chosen, the two homes can be compared side by side from Home."
                ]
            }),
            currentSettings.enablePartnerFutureEvent && !futureEventOptimalStrategy && effectiveOptimisationSurface === 'legacy' && (parseInt(String(currentSettings.partnerEntryYear), 10) || 3) > (currentSettings.legacyYears || legacyYears || 5) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700 shadow-card",
                "data-testid": "partner-later-beyond-horizon",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                        className: "text-slate-900",
                        children: [
                            partnerDisplayName,
                            " entering care in ",
                            new Date().getFullYear() + (parseInt(String(currentSettings.partnerEntryYear), 10) || 3) - 1,
                            " is after the ",
                            currentSettings.legacyYears || legacyYears || 5,
                            " years these plans look ahead,"
                        ]
                    }),
                    ' so no plan here is affected by it and no "',
                    partnerDisplayName,
                    ' enters later" card is shown. Pick an earlier year or plan for more years in "Things that change the answer".'
                ]
            }),
            effectiveOptimisationSurface === 'pension' && displayedGoalStrategies.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700 shadow-card",
                "data-testid": "no-pension-leader",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "text-slate-900",
                        children: "No plan tested pays an Age Pension."
                    }),
                    " The assets counted stay above the cut-off in every one, so there is no pension to improve. That is a finding, not a gap; choose another goal above to see the plans."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: displayedGoalStrategies.length > 1 ? `grid grid-cols-1 gap-5 xl:grid-cols-2 ${detailOpenKey ? 'items-start' : 'items-stretch'}` : 'space-y-4',
                "data-testid": "engine-plan-cards",
                children: displayedGoalStrategies.map((strategy, index)=>renderEngineCard(strategy, index))
            }),
            analysis.strategies && analysis.strategies.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-2 flex flex-wrap items-center justify-center gap-3",
                "data-testid": "engine-ways-on",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        type: "button",
                        onClick: ()=>{
                            setEverythingTestedOpen(false);
                            setShowGoalLeadersModal(true);
                        },
                        variant: "secondary",
                        children: [
                            "Compare all ",
                            goalComparisonRows.length,
                            " plans side by side"
                        ]
                    }),
                    tableStrategies.length > goalComparisonRows.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        type: "button",
                        onClick: ()=>{
                            setEverythingTestedOpen(true);
                            setShowGoalLeadersModal(true);
                        },
                        variant: "secondary",
                        "data-testid": "engine-all-ways-tested",
                        children: [
                            "All ",
                            tableStrategies.length,
                            " ways tested"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        type: "button",
                        onClick: handleSettingsClick,
                        variant: "secondary",
                        children: "Things that change the answer"
                    }),
                    onBuildYourOwn && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>onBuildYourOwn(null),
                        className: "text-[13px] font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                        children: "Prefer to set the numbers yourself? Build a plan \u2192"
                    })
                ]
            }),
            analysis.strategies && analysis.strategies.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-center text-[13px] text-slate-500",
                "data-testid": "all-plans-open-line",
                children: (0, $5a094123650e8adb$export$af182f21f972ef03)(tableStrategies.length)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-center text-[13px] text-slate-500",
                children: [
                    "Figures use the rates in force from ",
                    (0, $1abe73eeef086faf$export$946308c675ba021d).agePension,
                    " and are projections, not guarantees.",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setShowAssumptionsModal(true),
                        className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                        children: "What the engine assumes"
                    }),
                    "."
                ]
            }),
            showGoalLeadersModal && analysis.strategies && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                titleId: "compare-plans-heading",
                testId: "compare-plans-dialog",
                size: "xl",
                eyebrow: `The best plan for each goal, and ${bench.word}`,
                title: "All the plans, side by side",
                intro: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Figures are for about ",
                        currentSettings.legacyYears,
                        " ",
                        currentSettings.legacyYears === 1 ? 'year' : 'years',
                        " in care. Tap a plan to see it year by year."
                    ]
                }),
                onClose: ()=>setShowGoalLeadersModal(false),
                footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                    type: "button",
                    onClick: ()=>setShowGoalLeadersModal(false),
                    variant: "primary",
                    children: "Close"
                }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        goalComparisonRows.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "py-10 text-center text-sm text-slate-600",
                            children: "No goal comparison rows are available for this analysis run."
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d8e44526b4d2fe9$export$2e2bcd8739ae039), {
                            testId: "compare-plans-table",
                            columns: [
                                {
                                    key: 'bestFor',
                                    label: 'Best for',
                                    text: true
                                },
                                {
                                    key: 'legacy',
                                    label: 'Left to the family',
                                    best: 'max',
                                    headline: true
                                },
                                {
                                    key: 'cf',
                                    label: 'Each year, short by',
                                    best: 'max'
                                },
                                {
                                    key: 'pension',
                                    label: 'Age Pension a year',
                                    best: 'max'
                                },
                                {
                                    key: 'deposit',
                                    label: 'Tied up in the deposit',
                                    bar: 'amber'
                                }
                            ],
                            rows: (()=>{
                                const out = [];
                                if (agedCareBaseline && agedCareBaseline.pension != null) {
                                    const bcf = agedCareBaseline.cashFlowAfterCare ?? 0;
                                    out.push({
                                        key: 'doing-nothing',
                                        baseline: true,
                                        title: bench.word === 'paying daily' ? "Paying daily \u2014 nothing up front, nothing sold" : "Staying put \u2014 the current room",
                                        cells: {
                                            bestFor: {
                                                value: null,
                                                display: ''
                                            },
                                            legacy: {
                                                value: agedCareBaseline.legacyValue ?? null
                                            },
                                            cf: {
                                                value: bcf,
                                                display: bcf < 0 ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(bcf))) : `+${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(bcf))}`,
                                                tone: bcf < 0 ? 'bad' : 'good'
                                            },
                                            pension: {
                                                value: Number(agedCareBaseline.pension) || 0
                                            },
                                            deposit: {
                                                value: 0,
                                                display: '$0'
                                            }
                                        }
                                    });
                                }
                                // One row per distinct plan, every goal it wins named on it.
                                const byName = new Map();
                                goalComparisonRows.forEach(({ goalLabel: goalLabel, strategy: strategy })=>{
                                    const key = strategy.name + (strategy.isFutureEventOverlayCard ? '|future' : '');
                                    const label = goalLabel === (0, $400a08a42b233386$export$8a102fa4742ce4ac) ? (0, $5a094123650e8adb$export$a035dca5f387c63d)((analysis.recommendedOptimalStrategies || []).find((r)=>r.label === 'Optimal Legacy')?.lead) : goalLabel === (0, $400a08a42b233386$export$8d25e363f6ae69ae) ? 'Income covers the costs' : goalLabel === 'Best cashflow' ? 'Most left over each year' : goalLabel === 'Best pension' ? 'Highest Age Pension' : goalLabel;
                                    const have = byName.get(key);
                                    if (have) have.goals.push(label);
                                    else byName.set(key, {
                                        strategy: strategy,
                                        goals: [
                                            label
                                        ]
                                    });
                                });
                                const baseLegacy = agedCareBaseline?.legacyValue ?? null;
                                Array.from(byName.values()).forEach(({ strategy: strategy, goals: g }, idx)=>{
                                    const chosenRow = suggestionEngineCardHighlightKey != null && $ca941a2ef5e688c5$var$strategyCardSelectionKey(strategy) === suggestionEngineCardHighlightKey;
                                    const legacyHere = cardLegacyOf(strategy);
                                    const delta = baseLegacy != null ? legacyHere - baseLegacy : null;
                                    const cf = Number(strategy.snapshot?.netCashflow ?? 0);
                                    const w = (0, $95e43332fd84eec4$export$f973c372d76f95c8)(strategy, factFind, getDisplayStrategyName(strategy.name, strategy.radPaidNet, strategy.radRoomPrice, secondRoomOf(strategy), moveOf(strategy), villageOf(strategy)));
                                    const paid = Math.round(Math.max(0, Number(strategy.radPaidNet) || 0));
                                    const borrowed = !!strategy.equityRelease?.loanAmount;
                                    out.push({
                                        key: `${strategy.name}-${idx}`,
                                        chosen: chosenRow,
                                        title: w.title,
                                        onOpen: ()=>{
                                            setShowGoalLeadersModal(false);
                                            handleDeepDive(strategy);
                                        },
                                        cells: {
                                            bestFor: {
                                                value: null,
                                                display: g.join(" \xb7 ")
                                            },
                                            legacy: {
                                                value: legacyHere,
                                                sub: delta != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: delta >= 0 ? 'text-emerald-700' : 'text-rose-700',
                                                    children: [
                                                        delta >= 0 ? '+' : "\u2212",
                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(delta))),
                                                        " ",
                                                        bench.vs
                                                    ]
                                                }) : undefined
                                            },
                                            cf: {
                                                value: cf,
                                                display: cf < 0 ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(cf))) : `+${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(cf))}`,
                                                tone: cf < 0 ? 'neutral' : 'good'
                                            },
                                            pension: {
                                                value: Math.round(Number(strategy.snapshot?.pension ?? 0))
                                            },
                                            deposit: {
                                                value: paid,
                                                display: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(paid)}${borrowed ? ' (borrowed)' : ''}`
                                            }
                                        }
                                    });
                                });
                                return out;
                            })()
                        }),
                        (0, $400a08a42b233386$export$b8b8a2cedd92aa3a)(analysis?.recommendedOptimalStrategies) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mt-3 text-[13px] text-slate-500",
                            children: '"Leaves the most" and "income covers the costs" point to the same plan here, so it is listed once.'
                        }),
                        tableStrategies.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                            className: "mt-5 border-t border-slate-200",
                            "data-testid": "show-everything-tested",
                            open: everythingTestedOpen,
                            onToggle: (e)=>setEverythingTestedOpen(e.currentTarget.open),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("summary", {
                                    className: "cursor-pointer list-none py-3 text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy",
                                    children: [
                                        "Show everything tested \u2014 all ",
                                        tableStrategies.length,
                                        " ways, ranked by",
                                        ' ',
                                        allStrategiesSortBy === 'cashflow' ? 'what is left over each year' : allStrategiesSortBy === 'pension' ? 'the Age Pension' : 'what is left to the family',
                                        " \u203A"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "border-t border-slate-200 px-4 py-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mb-2 flex flex-wrap items-center gap-2 text-[13px] text-slate-600",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    htmlFor: "all-plans-sort",
                                                    children: "Rank by"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    id: "all-plans-sort",
                                                    value: allStrategiesSortBy,
                                                    onChange: (e)=>setAllStrategiesSortBy(e.target.value),
                                                    className: "rounded-lg border border-slate-300 bg-white px-2 py-1 text-[13px]",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "legacy",
                                                            children: "Left to the family"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "cashflow",
                                                            children: "Left over each year"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "pension",
                                                            children: "Age Pension"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-slate-500",
                                                    children: "Tap a row to see it year by year. Under each plan, in small type, is the engine's own name for it, so an adviser can match it to the advice document."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                            className: "w-full border-collapse text-[13px]",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "text-left text-[11px] font-semibold uppercase tracking-wide text-slate-500",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "border-b border-slate-200 py-2 pr-3",
                                                                children: "Plan"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "border-b border-slate-200 py-2 pr-3 text-right",
                                                                children: "Left to the family"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "border-b border-slate-200 py-2 pr-3 text-right",
                                                                children: "Left over each year"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "border-b border-slate-200 py-2 text-right",
                                                                children: "Age Pension"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                    children: tableStrategies.map((s, idx)=>{
                                                        const isDownsize = s.strategyOptions?.downsizeHome || s.name && s.name.startsWith('Downsize');
                                                        const downsizeTooltipData = isDownsize ? $ca941a2ef5e688c5$var$getDownsizeStrategyTooltipData(factFind, s) : null;
                                                        const radTooltipData = !downsizeTooltipData ? (0, $acf6b0d85046d3ca$export$1aaf3a58e4fe820d)(s.radFunding) : null;
                                                        const tooltipData = downsizeTooltipData || radTooltipData;
                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            onClick: ()=>{
                                                                setShowGoalLeadersModal(false);
                                                                handleDeepDive(s);
                                                            },
                                                            className: "cursor-pointer border-b border-slate-100 hover:bg-blue-50/40",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                    className: "py-2 pr-3 text-slate-800",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "block font-medium text-slate-900",
                                                                            children: (0, $95e43332fd84eec4$export$f973c372d76f95c8)(s, factFind, getDisplayStrategyName(s.name, s.radPaidNet, s.radRoomPrice, secondRoomOf(s), moveOf(s), villageOf(s))).title
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "block text-[11.5px] text-slate-500",
                                                                            children: tooltipData ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca941a2ef5e688c5$var$CalculationTooltip, {
                                                                                title: downsizeTooltipData ? 'How this strategy is funded' : 'RAD funded from',
                                                                                data: tooltipData,
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    className: "cursor-help",
                                                                                    children: s.name
                                                                                })
                                                                            }) : s.name
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "py-2 pr-3 text-right tabular-nums",
                                                                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(s.snapshot?.legacyValue ?? 0)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "py-2 pr-3 text-right tabular-nums",
                                                                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(s.snapshot?.netCashflow ?? 0)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "py-2 text-right tabular-nums",
                                                                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(s.snapshot?.pension ?? 0)
                                                                })
                                                            ]
                                                        }, `${s.name}-${idx}`);
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            cashflowFor && (()=>{
                const row = cashflowFor.row;
                const paid = Math.max(0, Number(row.radPaidNet) || 0);
                const room = Number(row.radRoomPrice) || 0;
                const dapDaily = Number(row.strategySpecificAgedCareCosts?.dailyAccommodationPayment) || 0;
                const partnerEntering = goals?.aged_care_for === 'partner';
                const stayingName = factFind?.adviceFor === 'couple' ? partnerEntering ? clientDisplayName : partnerDisplayName : null;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07d43762e3724db0$export$2e2bcd8739ae039), {
                    planTitle: (0, $95e43332fd84eec4$export$f973c372d76f95c8)(row, factFind, getDisplayStrategyName(row.name, row.radPaidNet, row.radRoomPrice, secondRoomOf(row), moveOf(row), villageOf(row))).title,
                    snapshot: row.snapshot || {},
                    baseline: snapshotBaseline ? {
                        pension: snapshotBaseline.pension,
                        netCashflow: snapshotBaseline.netCashflow
                    } : null,
                    deposit: {
                        paid: paid,
                        unpaid: Math.max(0, room - paid),
                        dapAnnual: dapDaily * 365
                    },
                    fundingLines: (0, $e5cae8423a439bf1$export$8f80043cee83ba5d)(factFind, row.radFundingManualKeys || {}),
                    abpNames: (factFind?.assets?.accountBasedPensions || []).map((a)=>String(a.description || '').trim()).filter(Boolean),
                    enteringName: enteringName,
                    stayingName: stayingName,
                    people: factFind?.adviceFor === 'couple' ? [
                        {
                            firstName: clientDisplayName
                        },
                        {
                            firstName: partnerDisplayName
                        }
                    ] : [
                        {
                            firstName: clientDisplayName
                        }
                    ],
                    initialPage: cashflowFor.page,
                    pensionWhy: (0, $723f95d7e9f568b1$export$fc6e499ea9fff926)('pension', {
                        isCouple: factFind?.adviceFor === 'couple',
                        protectedPersonHome: (0, $8d8b97815ba787de$export$a4f0fcc41e754c67)(factFind, {})
                    }),
                    pensionRows: row.snapshot?.agePensionBreakdown || [
                        {
                            label: 'No breakdown available for this plan.',
                            value: ''
                        }
                    ],
                    careWhy: (0, $723f95d7e9f568b1$export$fc6e499ea9fff926)('care', {
                        isCouple: factFind?.adviceFor === 'couple',
                        protectedPersonHome: (0, $8d8b97815ba787de$export$a4f0fcc41e754c67)(factFind, {})
                    }),
                    careRows: (0, $723f95d7e9f568b1$export$531f4fd3a5e7a379)(row.snapshot || {}),
                    onDeepDive: ()=>{
                        setCashflowFor(null);
                        handleDeepDive(row);
                    },
                    onClose: ()=>setCashflowFor(null)
                });
            })(),
            riskStrategy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5757b380cc124794$export$2e2bcd8739ae039), {
                voice: (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind),
                strategyName: (0, $95e43332fd84eec4$export$f973c372d76f95c8)(riskStrategy, factFind, getDisplayStrategyName(riskStrategy.name, riskStrategy.radPaidNet, riskStrategy.radRoomPrice, secondRoomOf(riskStrategy), moveOf(riskStrategy), villageOf(riskStrategy))).title,
                onClose: ()=>setRiskStrategy(null),
                risks: (0, $203e38d6e6c434f4$export$124603ee0434ece5)((0, $203e38d6e6c434f4$export$ebadbd3592b8b5e6)(riskStrategy), {
                    horizonWarning: (0, $3d096644ffaac9d7$export$bcf3d26e8114b217)(riskStrategy, factFind)
                })
            }),
            deepDiveModal && selectedScenario && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca941a2ef5e688c5$var$DeepDiveModal, {
                selectedScenario: selectedScenario,
                isChosen: suggestionEngineCardHighlightKey != null && $ca941a2ef5e688c5$var$strategyCardSelectionKey(selectedScenario) === suggestionEngineCardHighlightKey,
                factFind: factFind,
                agedCareCosts: agedCareCosts,
                legacyYears: legacyYears,
                analysis: analysis,
                activeTab: activeTab,
                setActiveTab: setActiveTab,
                onSelectStrategy: ()=>{
                    if (incomeOnlyHeldFor(selectedScenario)) return;
                    saveSelectedStrategy(selectedScenario);
                    setDeepDiveModal(false);
                },
                selectHeld: incomeOnlyHeldFor(selectedScenario),
                beforeContent: (()=>{
                    const lever = (0, $09575c4cc12d1d84$export$e45920170ff81bed)(selectedScenario);
                    if (!lever) return null;
                    const confirm = (0, $5eae79c7e46ed27e$export$415ddf94c95c9134)(setFactFind);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09575c4cc12d1d84$export$47f38349b07e923a), {
                                row: selectedScenario,
                                evaluated: analysis?.allSimulatedStrategies || analysis?.strategies,
                                factFind: factFind,
                                personName: enteringName,
                                horizonYears: currentSettings.legacyYears,
                                testId: "deep-dive-family"
                            }),
                            lever.incomeOnly && confirm && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$4538b371a206da0c), {
                                factFind: factFind,
                                amount: lever.amount,
                                onChange: confirm,
                                testId: "deep-dive-income-only"
                            })
                        ]
                    });
                })(),
                onClose: ()=>setDeepDiveModal(false),
                applyRadFundingToFactFind: $ca941a2ef5e688c5$var$applyRadFundingToFactFind,
                careStartDate: $ca941a2ef5e688c5$var$careStartDateFromStrategyOptions(strategyOptions),
                radDrawdown: $ca941a2ef5e688c5$var$radDrawdownFromStrategyOptions(strategyOptions),
                residentialFeeArrangements: $ca941a2ef5e688c5$var$feeArrangementsFromStrategyOptions(strategyOptions)
            }),
            showSettingsModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                titleId: "engine-settings-heading",
                testId: "engine-settings-dialog",
                size: "lg",
                eyebrow: "Your answers",
                title: "Things that change the answer",
                intro: "Change any of these and we re-test every way to pay. Your chosen plan stays chosen if it still exists.",
                onClose: ()=>setShowSettingsModal(false),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca941a2ef5e688c5$var$SettingsForm, {
                        currentSettings: currentSettings,
                        onSave: handleSettingsSave,
                        onCancel: ()=>setShowSettingsModal(false),
                        factFind: factFind,
                        scenarioLivingExpenses: (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(agedCareCosts?.scenarioLivingExpenses, factFind?.expenses?.livingExpenses),
                        roomDeposit: Number(agedCareCosts?.radAmount) || 0
                    })
                })
            })
        ]
    });
};
/**
 * The nominated care start date off the shared strategy options, or `undefined` if none was set.
 *
 * Read defensively because `strategyOptions` is a loose bag on this panel's props — a date that failed
 * to be a `YYYY-MM-DD` string is treated as no date at all, which is the same "care is already under
 * way" the engine assumes for an absent one.
 */ /** The second room the Analyser set, where both of a couple are entering care — priced in every candidate. */ function $ca941a2ef5e688c5$var$secondRoomFromStrategyOptions(strategyOptions) {
    const v = strategyOptions?.secondRoom;
    if (!v || !(Number(v.roomPrice) > 0) || v.person !== 'client' && v.person !== 'partner') return null;
    return {
        person: v.person,
        roomPrice: Number(v.roomPrice),
        ...v.careStartDate ? {
            careStartDate: v.careStartDate
        } : {},
        ...v.extraServiceAnnual ? {
            extraServiceAnnual: Number(v.extraServiceAnnual)
        } : {},
        entersLater: !!v.entersLater
    };
}
function $ca941a2ef5e688c5$var$facilityMoveFromStrategyOptions(strategyOptions) {
    const v = strategyOptions?.facilityMove;
    if (!v || !(Number(v.newRoomPrice) > 0) || !v.moveDate) return null;
    return v;
}
function $ca941a2ef5e688c5$var$villageExitFromStrategyOptions(strategyOptions) {
    const v = strategyOptions?.villageExit;
    if (!v || !(Number(v.entitlement) > 0) || !v.leaveDate || !v.refundDate) return null;
    return v;
}
function $ca941a2ef5e688c5$var$careStartDateFromStrategyOptions(strategyOptions) {
    const value = strategyOptions?.careStartDate;
    return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) ? value : undefined;
}
/**
 * Whether the provider lets fees be drawn from the deposit, as answered on the Analyser's costs form.
 * Read the same defensive way as the entry date; anything unrecognised is "not answered", which the
 * engine treats as the usual written agreement ('fees').
 */ /** The fee arrangements the Analyser chose for a no-worse-off resident, if any — read the same way as the deposit arrangement. */ function $ca941a2ef5e688c5$var$feeArrangementsFromStrategyOptions(strategyOptions) {
    const value = strategyOptions?.residentialFeeArrangements;
    return value === '2014' || value === '2025' ? value : undefined;
}
function $ca941a2ef5e688c5$var$radDrawdownFromStrategyOptions(strategyOptions) {
    const value = strategyOptions?.radDrawdown;
    return value === 'fees' || value === 'dap' || value === 'none' ? value : undefined;
}
/** Each light run's inputs, by the id its rows carry (`liteRun`); as many as the analysis cache keeps. */ const $ca941a2ef5e688c5$var$acRuns = new Map();
let $ca941a2ef5e688c5$var$acRunSeq = 0;
function $ca941a2ef5e688c5$var$rememberAcRun(context) {
    const id = `ac-run-${Date.now().toString(36)}-${$ca941a2ef5e688c5$var$acRunSeq += 1}`;
    $ca941a2ef5e688c5$var$acRuns.set(id, context);
    while($ca941a2ef5e688c5$var$acRuns.size > 8)$ca941a2ef5e688c5$var$acRuns.delete($ca941a2ef5e688c5$var$acRuns.keys().next().value);
    return id;
}
async function $ca941a2ef5e688c5$export$54bb052a44b0c2ec(row) {
    const r = row;
    if (!r || r.lite !== true) return row;
    const run = $ca941a2ef5e688c5$var$acRuns.get(String(r.liteRun ?? ''));
    if (!run) return row;
    const name = String(r.name ?? '');
    const scenario = run.scenarios.get(name) ?? {
        name: name,
        radFunding: r.radFunding ?? {},
        strategyOptions: r.strategyOptions ?? {},
        ...r.groupKey ? {
            groupKey: r.groupKey
        } : {},
        ...r.fundingOrderLabel ? {
            fundingOrderLabel: r.fundingOrderLabel
        } : {},
        ...r.meansTestStrategy ? {
            meansTestStrategy: r.meansTestStrategy
        } : {}
    };
    const [factFind, agedCareCosts, legacyYears, careStartDate, radDrawdown, feeArrangements, secondRoom, facilityMove, villageExit] = run.args;
    const rows = await $55a1d8a64f1e5dfa$export$4a966bd6278b0c87(factFind, agedCareCosts, [
        scenario
    ], legacyYears, careStartDate, radDrawdown, feeArrangements, undefined, secondRoom, facilityMove, villageExit);
    const full = Array.isArray(rows) ? rows[0] : undefined;
    if (!full) return row;
    Object.assign(r, {
        projections: full.projections,
        atDefaultRatesProjections: full.atDefaultRatesProjections ?? null,
        optInProjections: full.optInProjections ?? null,
        lite: false
    });
    return row;
}
async function $ca941a2ef5e688c5$var$generateScenariosAndCallManualControl(factFind, agedCareCosts, goals, legacyYears, coupleValidation, setProgressCallback = null, /**
     * When the client moves into care (`YYYY-MM-DD`), or absent for care already under way — the same
     * date the Aged Care Analyser's "when does care start?" control sets.
     *
     * Applied to every scenario alike, because it describes the case rather than any one funding
     * strategy: candidates that assumed different entry dates would be ranked against each other on
     * different sets of years.
     */ careStartDate, /** A provider's quoted annual annuity income, for one type and amount (scaled to other amounts of that type). */ annuityIncomeOverride = null, /** Whether fees may be drawn from the deposit — a fact about the case, applied to every candidate. */ radDrawdown, /** `'2025'` = a no-worse-off resident opting in to the 1 November 2025 fee arrangements; likewise a fact about the case. */ residentialFeeArrangements, /** The second room, where both of a couple are entering care; every candidate prices it. */ secondRoom = null, /** A change of home: every candidate but "stay put" moves on its date. */ facilityMove = null, /** Leaving a retirement village: the exit payment pays the room first when it arrives. */ villageExit = null) {
    // The same inputs give the same answer: a run this session already did is handed straight back,
    // which is what makes re-opening a saved plan immediate (engineAnalysisCache.ts).
    const cacheKey = (0, $89e0a70e9279225f$export$112fde6d0b2d177)([
        factFind,
        agedCareCosts,
        goals,
        legacyYears,
        coupleValidation,
        careStartDate,
        annuityIncomeOverride,
        radDrawdown,
        residentialFeeArrangements,
        secondRoom,
        facilityMove,
        villageExit
    ]);
    const remembered = (0, $89e0a70e9279225f$export$d95b93b0908b1b1c)(cacheKey);
    if (remembered) {
        if (setProgressCallback) setProgressCallback({
            current: remembered.strategies.length,
            total: remembered.strategies.length
        });
        return remembered;
    }
    // Generate scenarios from the original factFind (evaluateAgedCareRadFundingScenarios below runs
    // server-side over the network, so factFind is only ever read here, never mutated in place).
    const scenarios = $ca941a2ef5e688c5$var$generateScenarios(factFind, agedCareCosts, coupleValidation, annuityIncomeOverride, secondRoom, facilityMove, villageExit);
    // Update total scenarios for progress tracking
    if (setProgressCallback) setProgressCallback({
        current: 0,
        total: scenarios.length
    });
    const futureEventConfig = {
        // The "partner later" overlay is the old approximation of a second room; with the second
        // room modelled in the engine itself (7 Oct 2026) it is switched off.
        enabled: !!goals?.enablePartnerFutureEvent && !secondRoom,
        partnerEntryYear: parseInt(String(goals?.partnerEntryYear), 10) || 3,
        partnerRoomPrice: parseFloat(String(goals?.partnerFutureRoomPrice)) || 0,
        originalEntrantAliveAtEvent: !!goals?.originalEntrantAliveAtPartnerEntry
    };
    // One request evaluates every scenario against the engine server-side (see
    // server/src/rest/calculation/suggestionEngine/agedCare.ts) instead of one request per scenario
    // (previously up to ~150-300 scenarios).
    // Light rows (26 Oct 2026): every figure but the year's HTML working and full-year blend, which
    // `fullStrategyRow` fetches for the one plan that is opened, chosen or written up.
    const liteRows = await $55a1d8a64f1e5dfa$export$4a966bd6278b0c87(factFind, agedCareCosts, scenarios, legacyYears, facilityMove ? undefined : careStartDate, radDrawdown, residentialFeeArrangements, undefined, secondRoom, facilityMove, villageExit, true);
    const liteRun = $ca941a2ef5e688c5$var$rememberAcRun({
        args: [
            factFind,
            agedCareCosts,
            legacyYears,
            facilityMove ? undefined : careStartDate,
            radDrawdown,
            residentialFeeArrangements,
            secondRoom,
            facilityMove,
            villageExit
        ],
        scenarios: new Map(scenarios.map((s)=>[
                String(s.name ?? ''),
                s
            ]))
    });
    const evaluatedStrategies = (Array.isArray(liteRows) ? liteRows : []).map((row)=>row.lite ? {
            ...row,
            liteRun: liteRun
        } : row);
    if (setProgressCallback) setProgressCallback({
        current: scenarios.length,
        total: scenarios.length
    });
    // The future-life-event overlay is a pure heuristic on top of the already-evaluated
    // strategy.snapshot/.name/.radFunding (no re-projection needed), so it stays a client-side
    // post-processing step, unchanged from the original per-scenario loop.
    const strategies = evaluatedStrategies.map((strategyRow)=>{
        if (futureEventConfig.enabled && futureEventConfig.partnerRoomPrice > 0) {
            const futureEventResult = (0, $eb4adc50b37e37f7$export$9ac41d7814ff2d5c)({
                strategy: strategyRow,
                legacyYears: legacyYears,
                partnerEntryYear: futureEventConfig.partnerEntryYear,
                partnerRoomPrice: futureEventConfig.partnerRoomPrice,
                originalEntrantAliveAtEvent: futureEventConfig.originalEntrantAliveAtEvent,
                baseAgedCareCosts: strategyRow.strategySpecificAgedCareCosts || agedCareCosts
            });
            if (futureEventResult) return {
                ...strategyRow,
                futureAdjustedLegacy: futureEventResult.adjustedLegacy,
                futureEventAdjustmentDelta: futureEventResult.adjustmentDelta,
                futureEventAssumptions: futureEventResult.assumptions
            };
        }
        return strategyRow;
    });
    // Primary ranking and "Analyse more" legacy sort use baseline projected estate.
    // Future-event-adjusted legacy is computed per strategy for the optional fourth card only.
    const getBaselineLegacyRankingValue = (strategy)=>strategy?.snapshot?.legacyValue || 0;
    // Keep full list for "Analyse more" (all simulated strategies), sorted by baseline legacy
    const allSimulatedStrategies = [
        ...strategies
    ].sort((a, b)=>getBaselineLegacyRankingValue(b) - getBaselineLegacyRankingValue(a));
    // Phase 2: Keep only the best funding order per scenario group (by legacy value) for top cards & recommendations
    const byGroup = {};
    const ungrouped = [];
    strategies.forEach((s)=>{
        if (s.groupKey) {
            const key = String(s.groupKey);
            if (!byGroup[key]) byGroup[key] = [];
            byGroup[key].push(s);
        } else ungrouped.push(s);
    });
    const bestPerGroup = Object.values(byGroup).map((group)=>group.reduce((best, s)=>getBaselineLegacyRankingValue(s) > getBaselineLegacyRankingValue(best) ? s : best));
    /*
     * Strip the FUNDING ORDER and nothing else. This was "any trailing parenthesised group", which
     * also removed the annuity's residual-capital variant and the debt-repayment basis — leaving two
     * genuinely different strategies under one name, one showing a $200,000 larger estate than the
     * other (seen in the compare-all table, 2026-08-27). It mutates `s.name`, so the collision
     * followed the strategy everywhere, including into the SOA.
     */ bestPerGroup.forEach((s)=>{
        s.name = (0, $eb4adc50b37e37f7$export$1384c6fc4de1c498)(s.name || '');
    });
    strategies.length = 0;
    strategies.push(...ungrouped, ...bestPerGroup);
    // Rank strategies by baseline legacy (today's projection); future-aware winner is the optional fourth card.
    strategies.sort((a, b)=>getBaselineLegacyRankingValue(b) - getBaselineLegacyRankingValue(a));
    // === MARK OPTIMAL STRATEGY (no duplicate entry) ===
    // Label the top strategy so the UI can show "Age Pension Optimised" / "Cashflow Maximised" as a badge
    // while keeping the strategy approach (e.g. "Pay 40% RAD, Keep Home") as the main title.
    try {
        if (strategies.length > 0) {
            let bestPensionStrategy = null;
            let bestCashflowStrategy = null;
            strategies.forEach((s)=>{
                if (!bestPensionStrategy || (s.snapshot?.pension || 0) > (bestPensionStrategy.snapshot?.pension || 0)) bestPensionStrategy = s;
                if (!bestCashflowStrategy || (s.snapshot?.netCashflow || -Infinity) > (bestCashflowStrategy.snapshot?.netCashflow || -Infinity)) bestCashflowStrategy = s;
            });
            const hasPensionEligibility = (bestPensionStrategy?.snapshot?.pension || 0) > 0;
            const base = hasPensionEligibility ? bestPensionStrategy : bestCashflowStrategy;
            const optimisationLabel = hasPensionEligibility ? 'Age Pension Optimised' : 'Cashflow Maximised';
            if (base) base.optimisationLabel = optimisationLabel;
        }
    } catch (e) {
        console.warn('Optimisation label assignment skipped due to error:', e);
    }
    // Deduplicate by name (keep first = highest legacy) so we never show duplicate strategy tiles
    const seenNames = new Set();
    const deduped = strategies.filter((s)=>{
        if (seenNames.has(s.name || '')) return false;
        seenNames.add(s.name || '');
        return true;
    });
    strategies.length = 0;
    strategies.push(...deduped);
    // === RECOMMENDED OPTIMAL STRATEGIES (top 3: legacy, cashflow, age pension; no duplicates; pension fallback) ===
    const recommendedOptimalStrategies = [];
    const horizonSetAside = [];
    if (strategies.length > 0) {
        // Use the full simulated set for cashflow/pension optimisation so recommendations
        // align with the "All modelled strategies" table.
        const fullUniverse = allSimulatedStrategies && allSimulatedStrategies.length > 0 ? allSimulatedStrategies : strategies;
        /*
         * A STRATEGY THAT NEEDS MORE TIME THAN THE CLIENT HAS IS NEVER CROWNED (owner, 23 Sep 2026:
         * "I definitely don't think we should promote it as the best result"). It stays in the field,
         * costed and openable, with its warning on the card; it just cannot be a leader. Where one
         * would have won, that is recorded below and disclosed, so nothing is hidden either.
         *
         * Only the LEADERS are judged here. The full field is untouched, so no figure moves.
         */ const flagged = (s)=>(0, $3d096644ffaac9d7$export$97adbbb576405d0e)(s, factFind);
        /*
         * STAYING PUT IS THE COMPARISON, NEVER A LEADER (25 Oct 2026). When the client is moving to another home,
         * "Stay put" is what every plan is measured against — as staying put is in the granny flat, village and
         * downsizing modules — so it can never be crowned the best way to make the move they have decided on.
         */ const movers = strategies.filter((s)=>!$ca941a2ef5e688c5$export$6b2690718f11a010(s));
        const moversUniverse = fullUniverse.filter((s)=>!$ca941a2ef5e688c5$export$6b2690718f11a010(s));
        const eligibleStrategies = movers.filter((s)=>!flagged(s));
        const recommendationUniverse = moversUniverse.filter((s)=>!flagged(s));
        // A near-tie on the estate is a tie, led by the plan that asks less (planChoiceRule.ts, owner 20 Oct 2026).
        const acReadings = (0, $eb4adc50b37e37f7$export$6628235dfd682022);
        const bestLegacy = (0, $5a094123650e8adb$export$3ef36734776b870)(eligibleStrategies.length ? eligibleStrategies : movers.length ? movers : strategies, acReadings) ?? movers[0] ?? strategies[0];
        const bestCashflow = (recommendationUniverse.length ? recommendationUniverse : moversUniverse.length ? moversUniverse : fullUniverse).reduce((best, s)=>(s.snapshot?.netCashflow ?? -Infinity) > (best?.snapshot?.netCashflow ?? -Infinity) ? s : best);
        const bestPension = (recommendationUniverse.length ? recommendationUniverse : moversUniverse.length ? moversUniverse : fullUniverse).reduce((best, s)=>(s.snapshot?.pension ?? 0) > (best?.snapshot?.pension ?? 0) ? s : best);
        // The set-asides: a flagged strategy that beats the chosen leader on that ranking's metric.
        const metricOf = {
            legacy: (s)=>Number(s.snapshot?.legacyValue ?? -Infinity),
            cashflow: (s)=>Number(s.snapshot?.netCashflow ?? -Infinity),
            pension: (s)=>Number(s.snapshot?.pension ?? 0)
        };
        const setAsideFor = (label, metric, leader)=>{
            const bestFlagged = moversUniverse.filter(flagged).reduce((b, s)=>b == null || metricOf[metric](s) > metricOf[metric](b) ? s : b, null);
            if (!bestFlagged || !leader || metricOf[metric](bestFlagged) <= metricOf[metric](leader)) return;
            const warning = (0, $3d096644ffaac9d7$export$bcf3d26e8114b217)(bestFlagged, factFind);
            if (warning) horizonSetAside.push({
                label: label,
                strategy: bestFlagged,
                warning: warning,
                metric: metric
            });
        };
        setAsideFor('Optimal Legacy', 'legacy', bestLegacy);
        setAsideFor('Optimal Cashflow', 'cashflow', bestCashflow);
        setAsideFor('Optimal Age Pension', 'pension', bestPension);
        const hasPensionEligibility = (bestPension?.snapshot?.pension ?? 0) > 0;
        const used = new Set();
        const add = (strategy, label)=>{
            if (!strategy || used.has(strategy.name)) return false;
            used.add(strategy.name);
            recommendedOptimalStrategies.push({
                label: label,
                strategy: strategy
            });
            return true;
        };
        if (add(bestLegacy, 'Optimal Legacy')) {
            const ex = (0, $5a094123650e8adb$export$db12984b57d6f833)(eligibleStrategies.length ? eligibleStrategies : movers, bestLegacy, acReadings);
            if (ex) recommendedOptimalStrategies[recommendedOptimalStrategies.length - 1].lead = ex;
        }
        if (!add(bestCashflow, 'Optimal Cashflow')) {
            const nextCashflow = recommendationUniverse.filter((s)=>!used.has(s.name)).reduce((best, s)=>(s.snapshot?.netCashflow ?? -Infinity) > (best?.snapshot?.netCashflow ?? -Infinity) ? s : best, null);
            // If the best cashflow strategy is already used (same as legacy), keep it as
            // "Optimal Cashflow" unless an alternative is at least as good.
            if (nextCashflow && (nextCashflow.snapshot?.netCashflow ?? -Infinity) >= (bestCashflow?.snapshot?.netCashflow ?? -Infinity)) add(nextCashflow, 'Optimal Cashflow');
            else if (bestCashflow) recommendedOptimalStrategies.push({
                label: 'Optimal Cashflow',
                strategy: bestCashflow
            });
        }
        if (hasPensionEligibility) {
            if (!add(bestPension, 'Optimal Age Pension')) {
                const nextPension = recommendationUniverse.filter((s)=>!used.has(s.name)).reduce((best, s)=>(s.snapshot?.pension ?? 0) > (best?.snapshot?.pension ?? 0) ? s : best, null);
                if (nextPension) add(nextPension, 'Optimal Age Pension');
            }
        }
        // No plan pays an Age Pension: the goal has no leader and says so, rather than badging the
        // next-best estate as the pension's best (owner, 20 Oct 2026).
        /*
         * THE FOURTH GOAL, FIRST (owner, 24 Sep 2026): the best estate among the plans that pay the
         * bills; failing that, whose shortfall the savings carry for the whole period; failing that,
         * the one that lasts longest, badged as such. In care a daily payment on the room nearly
         * always leaves a shortfall, so the second case is the common one here — and it is the
         * question the family is actually asking. A flagged strategy cannot be crowned here either.
         */ const covered = (0, $400a08a42b233386$export$db04dcb0634643af)(recommendationUniverse.length ? recommendationUniverse : moversUniverse, {
            cashflowTarget: 0,
            readings: acReadings
        });
        if (covered) recommendedOptimalStrategies.unshift({
            label: (0, $400a08a42b233386$export$920ad41b346ae01a),
            strategy: covered.strategy,
            cashflowCovered: covered.verdict
        });
    }
    // Check for 70% RAD strategies specifically
    const seventyPercentStrategies = strategies.filter((s)=>(s.name || '').includes('70% RAD'));
    if (seventyPercentStrategies.length > 0) ;
    else console.warn("\xc3\xa2\xc5\xa1\xc2\xa0\xc3\xaf\xc2\xb8\xc2\x8f NO 70% RAD STRATEGIES FOUND IN RESULTS! Checking all strategy names...");
    const result = {
        strategies: strategies,
        allSimulatedStrategies: allSimulatedStrategies,
        totalScenarios: scenarios.length,
        processedScenarios: strategies.length,
        recommendedOptimalStrategies: recommendedOptimalStrategies,
        horizonSetAside: horizonSetAside,
        futureEventV2: futureEventConfig.enabled ? {
            enabled: true,
            rankingMetric: 'baseline_legacy',
            fourthCardMetric: 'future_adjusted_legacy',
            assumptions: {
                partnerEntryYear: futureEventConfig.partnerEntryYear,
                partnerRoomPrice: futureEventConfig.partnerRoomPrice,
                originalEntrantAliveAtEvent: futureEventConfig.originalEntrantAliveAtEvent
            }
        } : {
            enabled: false,
            rankingMetric: 'legacy',
            assumptions: null
        }
    };
    return (0, $89e0a70e9279225f$export$ea3160f3f5c8dcb1)(cacheKey, result);
}
// Generate scenarios directly in UI
/**
 * The RAD levels a debt-payoff twin is generated for ON THE LEVER VARIANTS (an annuity, funeral bonds,
 * a gift, a property sale). The PLAIN candidates are paired at every level — see `appendDebtPayoffScenarios`.
 *
 * THE CAP THAT HID THE ANSWER (owner-caught, 18 Oct 2026: "a credit card debt of $15K at 15% — how come
 * the system did not suggest this get paid off first?"). Until then every twin was confined to these five
 * levels, on the reasoning that the payoff decision barely interacts with the RAD percentage. The
 * decision does not; the RANKING does. On that client the twin beat its base at every paired level (50%:
 * +$3,804 estate, +$6,052 a year cashflow) — and lost the ranking to the unpaired 70% base, which won on
 * the deposit level alone, so no card ever said "clear the debt". The modelling was right and the
 * candidate set could not show it. The plain candidates now carry a twin at every level; the lever
 * variants keep this spread, because pairing every lever at every level would double the set again.
 */ const $ca941a2ef5e688c5$var$DEBT_PAYOFF_PAIRED_RAD_LEVELS = [
    0,
    25,
    50,
    75,
    100
];
/**
 * Debts worth generating a payoff candidate for (strategy/debtsToTest.ts, 26 Oct 2026): never a card paid off
 * in full each month; any debt that costs interest, whatever its size; interest-free debts from $5,000.
 */ function $ca941a2ef5e688c5$var$materialDebtsForSuggestionEngine(factFind) {
    return (0, $485d903040fc3504$export$718566aeb53e1efe)((0, $35f2741dc40fa45c$export$403bb596c20e48)(factFind));
}
/**
 * Pairs a spread of the generated scenarios with a twin that also clears the client's debts.
 *
 * The engine is given both worlds and its existing ranking picks — there is no debt-specific rule, and
 * deliberately so. "Should this be paid off?" is answered by the same legacy-and-cashflow comparison
 * that answers every other question here, which means there is no second rulebook to keep in step with
 * the first. It also means the answer can differ per client, which it genuinely does: an unsecured debt
 * counts against the assets test in full, a mortgage over an investment property is already netted off
 * that property, and one over an exempt home does nothing for the means test at all.
 *
 * Funded from the client's own cash first and only then from other liquid assets, so a payoff candidate
 * does not gratuitously trigger CGT that would make it lose for the wrong reason.
 */ function $ca941a2ef5e688c5$var$appendDebtPayoffScenarios(scenarios, factFind) {
    const debts = $ca941a2ef5e688c5$var$materialDebtsForSuggestionEngine(factFind);
    if (debts.length === 0) return;
    const payments = Object.fromEntries(debts.map((debt)=>[
            debt.key,
            debt.balance
        ]));
    const totalToClear = debts.reduce((sum, debt)=>sum + debt.balance, 0);
    const liquid = (0, $bd80071df75c742b$export$a6f66b42cac1f673)(factFind);
    // Cash first — it carries no CGT and no disposal decision.
    const ordered = [
        ...liquid
    ].sort((a, b)=>Number(b.typeId === 'bankAccounts') - Number(a.typeId === 'bankAccounts'));
    const paired = scenarios.filter((scenario)=>{
        const name = String(scenario.name || '');
        const match = /Pay (\d+)% RAD/.exec(name);
        if (!match) return name === 'Do Nothing';
        // A plain candidate (no " + lever" suffix) at EVERY level, so the twin always sits beside the level
        // that wins; a lever variant only at the spread (see DEBT_PAYOFF_PAIRED_RAD_LEVELS).
        const isLeverVariant = / \+ /.test(name);
        return !isLeverVariant || $ca941a2ef5e688c5$var$DEBT_PAYOFF_PAIRED_RAD_LEVELS.includes(Number(match[1]));
    });
    for (const base of paired){
        /**
         * What THIS candidate's deposit has already claimed of each asset.
         *
         * The bug this fixes, and it invalidated every paired RAD candidate. The payoff's funding used
         * to be computed once from raw balances and attached to all of them, so a "Pay 60% RAD + Clear
         * Debt" candidate allocated the same bank account twice. The engine clears debt at order 3 and
         * sells for the deposit at order 4, so the debt claimed first and the DEPOSIT WAS STARVED —
         * that candidate quietly paid a smaller RAD than its own name promised, and scored accordingly.
         *
         * Only the no-RAD pairing was unaffected, because it allocates nothing. Which is exactly why
         * "Do Nothing + Clear Debt" kept winning: it was the one paired candidate not being sabotaged.
         *
         * The pool is shared, so the payoff now spends only what the deposit left — the same rule the
         * Manual Control cards enforce with their sliders.
         */ const claimedByRad = (0, $c549af0b979cab3f$export$9ca4abb860f88bf9)(base.radFunding ?? {});
        const funding = {};
        let stillToRaise = totalToClear;
        for (const asset of ordered){
            if (stillToRaise <= 0) break;
            const room = Math.max(0, (Number(asset.value) || 0) - (Number(claimedByRad[asset.assetId]) || 0));
            const take = Math.min(stillToRaise, room);
            if (take <= 0) continue;
            funding[asset.assetId] = take;
            stillToRaise -= take;
        }
        // This candidate's deposit has taken everything: there is nothing left to clear a debt with, so
        // there is no choice to model. Skipped rather than generated as a payoff that cannot happen.
        const affordable = Object.values(funding).reduce((sum, amount)=>sum + amount, 0);
        if (affordable <= 0) continue;
        /**
         * The payoff variants worth modelling for this candidate.
         *
         * Where the whole debt can be funded from what is left, one variant: clear it. The repayment
         * basis is moot, because a debt cleared outright has no repayment left to decide about.
         *
         * Where it cannot, the payoff is necessarily PARTIAL — and then the basis is a real fork with
         * no universal winner, so both are modelled and the ranking picks.
         */ const canClearInFull = affordable >= totalToClear - 0.5;
        const partial = {};
        if (!canClearInFull) {
            let left = affordable;
            for (const debt of debts){
                if (left <= 0) break;
                const take = Math.min(left, debt.balance);
                partial[debt.key] = take;
                left -= take;
            }
        }
        const variants = canClearInFull ? [
            {
                suffix: '+ Clear Debt',
                payoff: {
                    payments: payments,
                    funding: funding
                }
            }
        ] : [
            {
                suffix: '+ Pay Down Debt (keep repayments)',
                payoff: {
                    payments: partial,
                    funding: funding,
                    repaymentBasis: 'keep_repayment'
                }
            },
            {
                suffix: '+ Pay Down Debt (lower repayments)',
                payoff: {
                    payments: partial,
                    funding: funding,
                    repaymentBasis: 'lower_repayment'
                }
            }
        ];
        for (const variant of variants)scenarios.push({
            ...base,
            name: `${base.name} ${variant.suffix}`,
            strategyOptions: {
                ...base.strategyOptions,
                debtPayoff: variant.payoff
            }
        });
    }
}
/**
 * "$50,000 from AMP BANK" — the assets this strategy sells to clear debt, or null where it clears none.
 *
 * The "Allocation to RAD" grid beside this is exactly what its heading says: money going to the
 * accommodation deposit. A debt payoff is not that, so it does not appear there — which left an adviser
 * looking at "AMP BANK — Kept: $150,000" on a card whose own badge said it cleared a $50,000 debt, with
 * nothing on screen reconciling the two. The projection was right the whole time; the card just never
 * mentioned the second withdrawal.
 */ function $ca941a2ef5e688c5$var$debtPayoffFundingLine(strategy, factFind) {
    const funding = strategy.strategyOptions?.debtPayoff?.funding;
    if (!funding) return null;
    const parts = [];
    for (const [key, amount] of Object.entries(funding)){
        const value = Number(amount) || 0;
        if (value <= 0) continue;
        const parsed = (0, $85f2560fc9a239a0$export$eb5d467aa7d657c6)(key);
        const asset = parsed ? (factFind.assets?.[parsed.assetType] || []).find((row)=>String(row?.id ?? '') === String(parsed.assetId)) : null;
        parts.push(`${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(value))} from ${asset?.description || parsed?.assetType || 'your assets'}`);
    }
    if (parts.length === 0) return null;
    return parts.length === 1 ? parts[0] : `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}`;
}
/**
 * "the Personal Loan ($50,000)" — what this strategy pays out, or null where it pays out nothing.
 *
 * Read off the strategy's own options rather than a flag set at generation time, so a candidate that
 * reached the card by any route still describes itself correctly.
 */ /**
 * Whether any debt this plan clears was costing interest. A card paid off in full each month costs
 * none (creditCards.ts), so clearing it must not claim "the interest on it stops".
 */ function $ca941a2ef5e688c5$var$clearedDebtsCarryInterest(strategy, factFind) {
    const payments = strategy.strategyOptions?.debtPayoff?.payments || {};
    return Object.keys(payments).some((key)=>{
        const parsed = (0, $5a6326d9013f181c$export$3af2fc381bc8d0aa)(key);
        if (!parsed) return true;
        const liability = (factFind.liabilities?.[parsed.category] || []).find((l)=>String(l?.id) === parsed.liabilityId);
        return !liability || (0, $55a6490f14a54563$export$7d8ffbf26dcfd37b)(liability, parsed.category) > 0;
    });
}
function $ca941a2ef5e688c5$var$debtsClearedBy(strategy) {
    const payments = strategy.strategyOptions?.debtPayoff?.payments;
    if (!payments) return null;
    const total = Object.values(payments).reduce((sum, amount)=>sum + (Number(amount) || 0), 0);
    if (total <= 0) return null;
    const count = Object.keys(payments).length;
    const basis = strategy.strategyOptions?.debtPayoff?.repaymentBasis;
    // Named only where the strategy carries it AND the name says this is a pay-DOWN, since the basis is
    // meaningless once a debt is cleared outright.
    const note = /Pay Down Debt/.test(String(strategy.name || '')) && basis ? basis === 'lower_repayment' ? ', lowering the repayment' : ', keeping the repayment' : '';
    return `${count === 1 ? 'debt' : `${count} debts`} totalling ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(total))}${note}`;
}
function $ca941a2ef5e688c5$var$generateScenarios(factFind, agedCareCosts, cleanCoupleValidation = {
    partnerAnnualRent: 40000
}, /** A provider's quoted annual annuity income, where the client has entered one (for one type and amount). */ annuityIncomeOverride = null, /** The second room, where both of a couple enter care: each candidate pays the same share of it up front. */ secondRoom = null, /** A change of home: "stay put" is the comparison; the refund of the current deposit funds the new room first. */ facilityMove = null, /** Leaving a village: the exit payment funds the room first when it arrives; only the rest is sold at entry. */ villageExit = null) {
    const scenarios = [];
    const rentAllowed = cleanCoupleValidation.testRentingHome !== false;
    const secondTargetFor = (percentage)=>secondRoom ? {
            secondRadTarget: Math.round(secondRoom.roomPrice * (percentage / 100))
        } : {};
    const radAmount = Number(agedCareCosts && agedCareCosts.radAmount ? agedCareCosts.radAmount : 500000); // Use actual room cost from agedCareCosts
    // Baseline scenario (Do Nothing) - Full DAP + Daily Fees
    // DAP = Room Cost * MPIR + Daily Fees (MPIR updated quarterly)
    const MPIR = (0, $815d7df20c36742b$export$36c4ec5f3f340aef).MPIR;
    const doNothingDap = radAmount * MPIR + Number(agedCareCosts && agedCareCosts.basicDailyFee ? agedCareCosts.basicDailyFee : 70) * 365 + Number(agedCareCosts && agedCareCosts.dailyHSC !== undefined ? agedCareCosts.dailyHSC : 0) * 365 + Number(agedCareCosts?.dailyMTCF ?? 0) * 365;
    scenarios.push({
        name: facilityMove ? 'Stay put' : "Do Nothing",
        ...facilityMove ? {
            stayPut: true
        } : {},
        radFunding: {},
        ...secondTargetFor(0),
        strategyOptions: {
            annualDap: facilityMove ? facilityMove.currentDapAnnual : doNothingDap,
            rentHome: false,
            downsizeHome: false,
            scenarioLivingExpenses: (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(agedCareCosts.scenarioLivingExpenses, factFind.expenses?.livingExpenses)
        }
    });
    // Comprehensive RAD testing: 10% to 100% in 5% increments
    // This ensures we find the actuarially optimal RAD level
    const radPercentages = [
        10,
        15,
        20,
        25,
        30,
        35,
        40,
        45,
        50,
        55,
        60,
        65,
        70,
        75,
        80,
        85,
        90,
        95,
        100
    ];
    /**
     * Funding order + the total the variant can ACTUALLY raise, so a level whose request exceeds the
     * client's fundable assets is recognised as a duplicate of the level where the cap first bit.
     *
     * Without this, a client with $455,000 fundable against a $700,000 room generated "Pay 65%" through
     * "Pay 100%" as EIGHT candidates that all fund $455,000 — identical projections wearing different
     * names. The table showed rows with the same estate to the dollar (which an adviser rightly read as
     * a bug), the ranking evaluated the same strategy eight times, and a card could claim a percentage
     * it does not pay.
     */ const seenFundedTotals = new Set();
    for (const percentage of radPercentages){
        const radAmountForThisLevel = radAmount * (percentage / 100);
        const dapAmount = (radAmount - radAmountForThisLevel) * MPIR + Number(agedCareCosts && agedCareCosts.basicDailyFee ? agedCareCosts.basicDailyFee : 70) * 365 + Number(agedCareCosts && agedCareCosts.dailyHSC !== undefined ? agedCareCosts.dailyHSC : 0) * 365 + Number(agedCareCosts?.dailyMTCF ?? 0) * 365;
        // Phase 2: All funding order permutations for true optimisation
        // A change of home: only what the refund of the current deposit does not cover is sold.
        const toRaise = facilityMove ? Math.max(0, radAmountForThisLevel - facilityMove.refundToday) : villageExit ? Math.max(0, radAmountForThisLevel - villageExit.entitlement) : radAmountForThisLevel;
        const fundingVariants = toRaise > 0 ? $ca941a2ef5e688c5$var$generateAllFundingOrderStrategies(factFind, toRaise) : [
            {
                radFunding: {},
                orderLabel: facilityMove ? 'Refund only' : 'Village money only'
            }
        ];
        for(let i = 0; i < fundingVariants.length; i++){
            const { radFunding: radFunding, orderLabel: orderLabel } = fundingVariants[i];
            const fundedTotal = Object.values(radFunding ?? {}).flatMap((entries)=>Array.isArray(entries) ? entries : entries ? [
                    entries
                ] : []).reduce((sum, entry)=>sum + (Number(entry.amount) || 0), 0);
            // Keeps the FIRST level that PAYS a given deposit — the lowest percentage, which is the one
            // whose name still tells the truth about what is paid. Keyed on the deposit, not the savings
            // sold: a village payout or a current room's refund tops a level up without a sale
            // (radLevelKey.ts; owner-caught, 9 Oct 2026).
            const topUp = facilityMove ? Math.max(0, Number(facilityMove.refundToday) || 0) : villageExit ? Math.max(0, Number(villageExit.entitlement) || 0) : 0;
            const fundedKey = (0, $8fc2dd99af09008b$export$c2d7325b99935b19)({
                orderLabel: orderLabel,
                level: radAmountForThisLevel,
                fundedTotal: fundedTotal,
                topUp: topUp
            });
            if (seenFundedTotals.has(fundedKey)) continue;
            seenFundedTotals.add(fundedKey);
            const strategySuffix = fundingVariants.length > 1 ? ` (${orderLabel})` : '';
            const groupKeyKeep = `${percentage}-Keep`;
            const groupKeyRent = `${percentage}-Rent`;
            // "Keep Home" only where there is a home to keep: a village or granny-flat resident, or a
            // renter, has none, and the words misled (owner-caught, 9 Oct 2026).
            const keepHomeLabel = (0, $d1b9bbc5238c0548$export$2f999b99c41ee933)(factFind) ? ', Keep Home' : '';
            // Keep Home scenario
            scenarios.push({
                name: `Pay ${percentage}% RAD${keepHomeLabel}${strategySuffix}`,
                radFunding: radFunding,
                ...secondTargetFor(percentage),
                groupKey: groupKeyKeep,
                fundingOrderLabel: orderLabel,
                strategyOptions: {
                    annualDap: dapAmount,
                    rentHome: false,
                    downsizeHome: false,
                    scenarioLivingExpenses: (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(agedCareCosts.scenarioLivingExpenses, factFind.expenses?.livingExpenses)
                }
            });
            // Rent Home scenario — only where there is a home to let (householdPosition.ts). A renter,
            // a village resident or someone living with family used to get candidates renting out a
            // home that does not exist, at $1,000 a week (owner's review, 7 Oct 2026).
            if (!(0, $d1b9bbc5238c0548$export$98f904391e5edbc2)(factFind)) continue;
            // "Keep it, and don't rent it out" (owner, 25 Oct 2026): a decision, so no rent-out plan is tested.
            if (!rentAllowed) continue;
            const rentAmount = factFind.home?.likelyRent || 1000;
            const rentExpenses = factFind.home?.likelyExpenses || 10000;
            const scenarioLivingExpenses = (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(agedCareCosts.scenarioLivingExpenses, factFind.expenses?.livingExpenses) + (parseFloat(String(cleanCoupleValidation.partnerAnnualRent)) || 0);
            scenarios.push({
                name: `Pay ${percentage}% RAD, Rent Home${strategySuffix}`,
                radFunding: radFunding,
                ...secondTargetFor(percentage),
                groupKey: groupKeyRent,
                fundingOrderLabel: orderLabel,
                strategyOptions: {
                    annualDap: dapAmount,
                    rentHome: true,
                    downsizeHome: false,
                    scenarioLivingExpenses: scenarioLivingExpenses,
                    rentAmount: rentAmount,
                    rentExpenses: rentExpenses
                }
            });
        }
    }
    // Comprehensive downsizing scenarios - All RAD levels tested with downsizing
    // Include when downsizeNewHomeValue is set (e.g. from suggestion engine settings)
    /*
     * BOTH IN CARE TOGETHER (owner, 7 Oct 2026): nobody will live in a new home, so "downsize" is
     * not a strategy for them - SELLING the home is. The same block runs with no new home (the
     * whole net proceeds are the surplus), named "Sell home", and without the "rent the home"
     * twins: there is no longer a home to let. Keep and rent-out candidates still run as before.
     * Where the second person enters LATER the home still houses them, so downsizing stays.
     */ const saleOnly = factFind.goals?.aged_care_for === 'both' && !!secondRoom && !secondRoom.entersLater;
    const saleLabel = saleOnly ? 'Sell home' : 'Downsize';
    const downsizedHomeValue = saleOnly ? 0 : cleanCoupleValidation.downsizeNewHomeValue || 250000;
    const downsizeEnabled = saleOnly ? parseFloat(String(factFind.home?.value || 0)) > 0 : (cleanCoupleValidation.downsizeNewHomeValue || 0) > 0 && downsizedHomeValue > 0;
    if (downsizeEnabled) {
        const originalHomeValue = parseFloat(String(factFind.home?.value || 0));
        const sellingCosts = parseFloat(String(cleanCoupleValidation.sellingCosts)) || 0;
        // The duty on the new home is a sunk cost of the changeover like the selling costs, so it
        // comes off before the surplus is sized (owner, 23 Sep 2026). Zero where no state was chosen.
        const stampDuty = saleOnly ? 0 : parseFloat(String(cleanCoupleValidation.stampDuty)) || 0;
        const newHomeState = saleOnly ? undefined : typeof cleanCoupleValidation.newHomeState === 'string' ? cleanCoupleValidation.newHomeState : undefined;
        const netProceeds = Math.max(0, originalHomeValue - sellingCosts - stampDuty);
        const surplusFromDownsize = Math.max(0, netProceeds - downsizedHomeValue); // Money left over after buying new home Ã¢â€ â€™ assume goes to RAD first
        for (const percentage of radPercentages){
            const radAmountForThisLevel = radAmount * (percentage / 100);
            const dapAmount = (radAmount - radAmountForThisLevel) * MPIR + Number(agedCareCosts && agedCareCosts.basicDailyFee ? agedCareCosts.basicDailyFee : 70) * 365 + Number(agedCareCosts && agedCareCosts.dailyHSC !== undefined ? agedCareCosts.dailyHSC : 0) * 365 + Number(agedCareCosts?.dailyMTCF ?? 0) * 365;
            // Surplus from downsize goes to RAD first; shortfall funded from other assets (same sell-down options as non-downsize)
            const radAllocationFromSurplus = Math.min(surplusFromDownsize, radAmountForThisLevel);
            const shortfall = Math.max(0, radAmountForThisLevel - radAllocationFromSurplus);
            const fundingVariantsDownsize = shortfall > 0 ? $ca941a2ef5e688c5$var$generateAllFundingOrderStrategies(factFind, shortfall) : [
                {
                    radFunding: {},
                    orderLabel: 'Surplus only'
                }
            ];
            for(let i = 0; i < fundingVariantsDownsize.length; i++){
                const { radFunding: radFunding, orderLabel: orderLabel } = fundingVariantsDownsize[i];
                const strategySuffix = fundingVariantsDownsize.length > 1 ? ` (${orderLabel})` : '';
                const groupKeyDownKeep = `D${percentage}-Keep`;
                const groupKeyDownRent = `D${percentage}-Rent`;
                const downsizeDetails = {
                    newHomePurchasePrice: downsizedHomeValue,
                    radAllocation: radAllocationFromSurplus,
                    ...stampDuty > 0 ? {
                        stampDuty: stampDuty
                    } : {},
                    ...newHomeState ? {
                        newHomeState: newHomeState
                    } : {}
                };
                const strategyOptionsWithSellingCost = {
                    sellingCosts: sellingCosts
                };
                scenarios.push({
                    name: `${saleLabel} + ${percentage}% RAD${strategySuffix}`,
                    radFunding: radFunding,
                    groupKey: groupKeyDownKeep,
                    fundingOrderLabel: orderLabel,
                    strategyOptions: {
                        annualDap: dapAmount,
                        rentHome: false,
                        downsizeHome: true,
                        downsizeDetails: downsizeDetails,
                        sellingCosts: strategyOptionsWithSellingCost.sellingCosts,
                        scenarioLivingExpenses: (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(agedCareCosts.scenarioLivingExpenses, factFind.expenses?.livingExpenses)
                    }
                });
                if (!saleOnly && rentAllowed) scenarios.push({
                    name: `${saleLabel} + ${percentage}% RAD, Rent Home${strategySuffix}`,
                    radFunding: radFunding,
                    groupKey: groupKeyDownRent,
                    fundingOrderLabel: orderLabel,
                    strategyOptions: {
                        annualDap: dapAmount,
                        rentHome: true,
                        downsizeHome: true,
                        downsizeDetails: downsizeDetails,
                        sellingCosts: strategyOptionsWithSellingCost.sellingCosts,
                        scenarioLivingExpenses: (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(agedCareCosts.scenarioLivingExpenses, factFind.expenses?.livingExpenses) + (parseFloat(String(cleanCoupleValidation.partnerAnnualRent)) || 0),
                        rentAmount: factFind.home?.likelyRent || 1000,
                        rentExpenses: factFind.home?.likelyExpenses || 10000
                    }
                });
                const surplusAfterRad = Math.max(0, surplusFromDownsize - radAllocationFromSurplus);
                const clientAge = (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client?.dob) || 0;
                const partnerAge = factFind?.adviceFor === 'couple' ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner?.dob) || 0 : 0;
                const buildDownsizerDetails = (commenceIncomeStream)=>{
                    let remaining = surplusAfterRad;
                    let downsizerContribution = 0;
                    let partnerDownsizerContribution = 0;
                    if (clientAge >= (0, $f1228be62b68f76b$export$fd180c62865277a2)) {
                        downsizerContribution = Math.min((0, $1abe73eeef086faf$export$42edd27decf8c272), remaining);
                        remaining -= downsizerContribution;
                    }
                    if (factFind?.adviceFor === 'couple' && partnerAge >= (0, $f1228be62b68f76b$export$fd180c62865277a2)) partnerDownsizerContribution = Math.min((0, $1abe73eeef086faf$export$42edd27decf8c272), remaining);
                    if (downsizerContribution + partnerDownsizerContribution < 10000) return null;
                    return {
                        newHomePurchasePrice: downsizedHomeValue,
                        radAllocation: radAllocationFromSurplus,
                        downsizerContribution: downsizerContribution,
                        partnerDownsizerContribution: partnerDownsizerContribution,
                        commenceIncomeStream: commenceIncomeStream === true,
                        ...stampDuty > 0 ? {
                            stampDuty: stampDuty
                        } : {},
                        ...newHomeState ? {
                            newHomeState: newHomeState
                        } : {}
                    };
                };
                const downsizerSuperDetails = (0, $f1228be62b68f76b$export$323aae9f0aa61406)($ca941a2ef5e688c5$var$asFactFind(factFind), 'client') || factFind?.adviceFor === 'couple' && (0, $f1228be62b68f76b$export$323aae9f0aa61406)($ca941a2ef5e688c5$var$asFactFind(factFind), 'partner') ? buildDownsizerDetails(false) : null;
                if (downsizerSuperDetails) {
                    const suffixDownsizer = `${strategySuffix} + max downsizer`;
                    scenarios.push({
                        name: `${saleLabel} + ${percentage}% RAD${suffixDownsizer}`,
                        radFunding: radFunding,
                        groupKey: `${groupKeyDownKeep}-DS`,
                        fundingOrderLabel: orderLabel,
                        strategyOptions: {
                            annualDap: dapAmount,
                            rentHome: false,
                            downsizeHome: true,
                            downsizeDetails: downsizerSuperDetails,
                            sellingCosts: strategyOptionsWithSellingCost.sellingCosts,
                            scenarioLivingExpenses: (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(agedCareCosts.scenarioLivingExpenses, factFind.expenses?.livingExpenses)
                        }
                    });
                    if (!saleOnly && rentAllowed) scenarios.push({
                        name: `${saleLabel} + ${percentage}% RAD, Rent Home${suffixDownsizer}`,
                        radFunding: radFunding,
                        groupKey: `${groupKeyDownRent}-DS`,
                        fundingOrderLabel: orderLabel,
                        strategyOptions: {
                            annualDap: dapAmount,
                            rentHome: true,
                            downsizeHome: true,
                            downsizeDetails: downsizerSuperDetails,
                            sellingCosts: strategyOptionsWithSellingCost.sellingCosts,
                            scenarioLivingExpenses: (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(agedCareCosts.scenarioLivingExpenses, factFind.expenses?.livingExpenses) + (parseFloat(String(cleanCoupleValidation.partnerAnnualRent)) || 0),
                            rentAmount: factFind.home?.likelyRent || 1000,
                            rentExpenses: factFind.home?.likelyExpenses || 10000
                        }
                    });
                }
                const downsizerAbpDetails = (0, $f1228be62b68f76b$export$d1b692f4d3924fcd)($ca941a2ef5e688c5$var$asFactFind(factFind), 'client') || factFind?.adviceFor === 'couple' && (0, $f1228be62b68f76b$export$d1b692f4d3924fcd)($ca941a2ef5e688c5$var$asFactFind(factFind), 'partner') ? buildDownsizerDetails(true) : null;
                if (downsizerAbpDetails) {
                    const suffixAbp = `${strategySuffix} + downsizer ABP`;
                    scenarios.push({
                        name: `${saleLabel} + ${percentage}% RAD${suffixAbp}`,
                        radFunding: radFunding,
                        groupKey: `${groupKeyDownKeep}-ABP`,
                        fundingOrderLabel: orderLabel,
                        strategyOptions: {
                            annualDap: dapAmount,
                            rentHome: false,
                            downsizeHome: true,
                            downsizeDetails: downsizerAbpDetails,
                            sellingCosts: strategyOptionsWithSellingCost.sellingCosts,
                            scenarioLivingExpenses: (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(agedCareCosts.scenarioLivingExpenses, factFind.expenses?.livingExpenses)
                        }
                    });
                    if (!saleOnly && rentAllowed) scenarios.push({
                        name: `${saleLabel} + ${percentage}% RAD, Rent Home${suffixAbp}`,
                        radFunding: radFunding,
                        groupKey: `${groupKeyDownRent}-ABP`,
                        fundingOrderLabel: orderLabel,
                        strategyOptions: {
                            annualDap: dapAmount,
                            rentHome: true,
                            downsizeHome: true,
                            downsizeDetails: downsizerAbpDetails,
                            sellingCosts: strategyOptionsWithSellingCost.sellingCosts,
                            scenarioLivingExpenses: (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(agedCareCosts.scenarioLivingExpenses, factFind.expenses?.livingExpenses) + (parseFloat(String(cleanCoupleValidation.partnerAnnualRent)) || 0),
                            rentAmount: factFind.home?.likelyRent || 1000,
                            rentExpenses: factFind.home?.likelyExpenses || 10000
                        }
                    });
                }
            }
        }
    }
    (0, $c549af0b979cab3f$export$7956e291fd2a25ef)(scenarios, factFind, {
        radAmount: radAmount,
        agedCareCosts: agedCareCosts,
        cleanCoupleValidation: cleanCoupleValidation,
        MPIR: MPIR
    });
    /*
     * Borrowing against the home, for the families who do not want to sell it. The engine could
     * only ever answer "sell it, rent it, or pay a smaller deposit" — see
     * agedCareEquityReleaseCandidates.ts for the two schemes and why they are not interchangeable.
     */ (0, $5f1bad8aa5c68d3b$export$7e7dbcee136ab855)(scenarios, factFind, {
        radAmount: radAmount,
        otherAnnualFees: Number(agedCareCosts && agedCareCosts.basicDailyFee ? agedCareCosts.basicDailyFee : 70) * 365 + Number(agedCareCosts && agedCareCosts.dailyHSC !== undefined ? agedCareCosts.dailyHSC : 0) * 365 + Number(agedCareCosts?.dailyMTCF ?? 0) * 365,
        MPIR: MPIR,
        scenarioLivingExpenses: (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(agedCareCosts.scenarioLivingExpenses, factFind.expenses?.livingExpenses)
    });
    /*
     * The three means-test levers, layered onto the deposit levels above. These are what an adviser
     * reaches for first in a residential care case and the engine had none of them — see
     * agedCareMeansTestCandidates.ts for what each one does and why the amounts are what they are.
     */ (0, $a412ceea866cc849$export$24e42428102d57ed)(scenarios, factFind, annuityIncomeOverride);
    // Last, so every scenario above is available to pair against.
    $ca941a2ef5e688c5$var$appendDebtPayoffScenarios(scenarios, factFind);
    // The row's target, where money arriving later (a refund, the village's payment) tops it up.
    if (facilityMove || villageExit) for (const s of scenarios){
        if (s.stayPut) continue;
        const m = /(\d+)%\s+RAD/i.exec(s.name || '');
        if (m) s.radTarget = Math.round(radAmount * (Number(m[1]) / 100));
    }
    return scenarios;
}
function $ca941a2ef5e688c5$var$calculateRadFundingForAmount(factFind, amount) {
    return (0, $c549af0b979cab3f$export$216ee3b40248ecf0)(factFind, amount);
}
/**
 * Generate multiple RAD funding strategies for actuarial optimisation
 * Tests different asset combinations to maximize final net worth
 * @param {Object} factFind - Client's form data with assets and constraints
 * @param {number} amount - Total RAD amount to fund
 * @returns {Array} Array of radFunding objects representing different funding strategies
 */ function $ca941a2ef5e688c5$var$generateSmartRadFundingStrategies(factFind, amount) {
    const strategies = [];
    const EMERGENCY_FUND_LIMIT = 50000; // $50K emergency fund protection
    // Collect available assets with their characteristics
    const availableAssets = [];
    // Bank accounts
    if (factFind.assets?.bankAccounts) factFind.assets.bankAccounts.forEach((asset)=>{
        const value = parseFloat(String(asset.value)) || 0;
        const growthRate = parseFloat(String(asset.growthRate)) || 2;
        const incomeRate = parseFloat(String(asset.incomeRate)) || 2;
        const available = Math.max(0, value - EMERGENCY_FUND_LIMIT); // Protect emergency fund
        if (available > 0) availableAssets.push({
            type: 'bankAccounts',
            id: asset.id,
            description: asset.description,
            value: available,
            growthRate: growthRate,
            incomeRate: incomeRate,
            fullValue: value
        });
    });
    // Account-based pensions
    if (factFind.assets?.accountBasedPensions) factFind.assets.accountBasedPensions.forEach((asset)=>{
        const value = parseFloat(String(asset.value)) || 0;
        const growthRate = parseFloat(String(asset.growthRate)) || 5;
        const incomeRate = 0; // Income is based on minimum drawdown rules
        if (value > 0) availableAssets.push({
            type: 'accountBasedPensions',
            id: asset.id,
            description: asset.description,
            value: value,
            growthRate: growthRate,
            incomeRate: incomeRate,
            fullValue: value
        });
    });
    // Shares
    if (factFind.assets?.shares) factFind.assets.shares.forEach((asset)=>{
        const value = parseFloat(String(asset.value)) || 0;
        const growthRate = parseFloat(String(asset.growthRate)) || 5;
        const incomeRate = parseFloat(String(asset.incomeRate)) || 4;
        if (value > 0) availableAssets.push({
            type: 'shares',
            id: asset.id,
            description: asset.description,
            value: value,
            growthRate: growthRate,
            incomeRate: incomeRate,
            fullValue: value
        });
    });
    // Single strategy: Bank accounts, then ABPs, then shares (optimal order considering CGT and growth)
    // Bank accounts have no CGT and minimal growth impact
    // ABPs provide income and are tax-free
    // Shares have CGT and moderate growth
    const optimalSort = [
        ...availableAssets
    ].sort((a, b)=>{
        // Prioritize bank accounts first (no CGT, minimal income/growth impact)
        if (a.type === 'bankAccounts' && b.type !== 'bankAccounts') return -1;
        if (b.type === 'bankAccounts' && a.type !== 'bankAccounts') return 1;
        // Then ABPs (tax-free, income-bearing) - liquidate lowest growth first to preserve higher growth
        if (a.type === 'accountBasedPensions' && b.type !== 'accountBasedPensions') return -1;
        if (b.type === 'accountBasedPensions' && a.type !== 'accountBasedPensions') return 1;
        if (a.type === 'accountBasedPensions' && b.type === 'accountBasedPensions') // Within ABPs, liquidate lowest growth first
        return a.growthRate - b.growthRate;
        // Then shares (last resort due to CGT)
        return 0;
    });
    const optimalStrategy = $ca941a2ef5e688c5$var$generateSingleFundingStrategy(optimalSort, amount, 'Optimal');
    if (optimalStrategy) strategies.push(optimalStrategy);
    // Fallback: If no strategies generated, return original simple approach
    if (strategies.length === 0) return [
        $ca941a2ef5e688c5$var$calculateRadFundingForAmount(factFind, amount)
    ];
    return strategies;
}
/**
 * Generate a single funding strategy from sorted assets
 * @param {Array} sortedAssets - Assets sorted by priority
 * @param {number} amount - Total amount to fund
 * @param {string} strategyName - Name of the strategy
 * @returns {Object|null} radFunding object or null if can't fund
 */ function $ca941a2ef5e688c5$var$generateSingleFundingStrategy(sortedAssets, amount, strategyName) {
    const radFunding = {};
    let remainingAmount = amount;
    for (const asset of sortedAssets){
        if (remainingAmount <= 0) break;
        const liquidateAmount = Math.min(remainingAmount, asset.value);
        if (liquidateAmount > 0) {
            if (!radFunding[asset.type]) radFunding[asset.type] = [];
            radFunding[asset.type].push({
                id: asset.id,
                amount: liquidateAmount,
                strategyName: strategyName
            });
            remainingAmount -= liquidateAmount;
        }
    }
    // Return null if we couldn't fund the full amount
    if (remainingAmount > 1000) return null;
    return radFunding;
}
/**
 * Phase 2: Generate all funding strategies by trying every order of the client's asset types.
 * Used for full optimisation (accuracy over speed).
 * @returns {Array<{ radFunding: Object, orderLabel: string }>}
 */ function $ca941a2ef5e688c5$var$generateAllFundingOrderStrategies(factFind, amount) {
    return (0, $c549af0b979cab3f$export$22a1348e28f91bce)(factFind, amount);
}
/** Apply scenario RAD + optional entity IP sale (respects structure funding gate via collected assets). */ function $ca941a2ef5e688c5$var$applyRadFundingToFactFind(factFind, scenarioOrRadFunding) {
    const scenario = scenarioOrRadFunding?.strategyOptions != null || scenarioOrRadFunding?.name != null ? scenarioOrRadFunding : {
        radFunding: scenarioOrRadFunding || {},
        strategyOptions: {}
    };
    return (0, $c549af0b979cab3f$export$587074b1f55c5662)(factFind, scenario);
}
// Build tooltip data for a downsize strategy in the "All modelled strategies" table - explains exactly what the system does
function $ca941a2ef5e688c5$var$getDownsizeStrategyTooltipData(factFind, strategy) {
    const opts = strategy.strategyOptions;
    if (!opts?.downsizeHome || !opts?.downsizeDetails) return null;
    const dd = opts.downsizeDetails;
    const salePrice = parseFloat(String(factFind?.home?.value || 0));
    const sellingCost = parseFloat(String(opts.sellingCosts)) || 0;
    const stampDuty = parseFloat(String(dd.stampDuty)) || 0;
    const netProceeds = Math.max(0, salePrice - sellingCost - stampDuty);
    const newHomeCost = parseFloat(String(dd.newHomePurchasePrice)) || 0;
    const toRAD = parseFloat(String(dd.radAllocation)) || 0;
    const clientDownsizer = parseFloat(String(dd.downsizerContribution)) || 0;
    const partnerDownsizer = parseFloat(String(dd.partnerDownsizerContribution)) || 0;
    const surplus = Math.max(0, netProceeds - newHomeCost);
    const remainderToBank = Math.max(0, surplus - toRAD - clientDownsizer - partnerDownsizer);
    const data = [
        {
            label: '--- Downsize: what the system does ---',
            value: ''
        },
        {
            label: 'Sale price (current home)',
            value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(salePrice)
        },
        {
            label: 'Less: Selling costs',
            value: '-' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(sellingCost)
        },
        // Its own line, so a reader sees the changeover's second sunk cost — or sees that it was not
        // estimated, which is as important (owner, 23 Sep 2026).
        ...newHomeCost > 0 ? [
            stampDuty > 0 ? {
                label: 'Less: Stamp duty on new home',
                value: '-' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(stampDuty)
            } : {
                label: 'Stamp duty on new home',
                value: "not estimated \u2014 no state chosen"
            }
        ] : [],
        {
            label: 'Net proceeds',
            value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(netProceeds)
        },
        {
            label: 'Less: New home cost',
            value: '-' + (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(newHomeCost)
        },
        {
            label: 'Surplus (to RAD or bank)',
            value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(surplus)
        },
        {
            label: 'Amount to RAD (from surplus)',
            value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(toRAD)
        }
    ];
    if (clientDownsizer > 0) data.push({
        label: dd.commenceIncomeStream ? 'Client downsizer to ABP' : 'Client downsizer to super',
        value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(clientDownsizer)
    });
    if (partnerDownsizer > 0) data.push({
        label: dd.commenceIncomeStream ? 'Partner downsizer to ABP' : 'Partner downsizer to super',
        value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(partnerDownsizer)
    });
    data.push({
        label: 'Remainder to bank',
        value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(remainderToBank)
    });
    const otherSellDowns = (0, $acf6b0d85046d3ca$export$1aaf3a58e4fe820d)(strategy.radFunding);
    if (otherSellDowns && otherSellDowns.length > 0) {
        data.push({
            label: '--- Other sell downs (shortfall) ---',
            value: ''
        });
        otherSellDowns.forEach((ro)=>data.push({
                label: ro.label,
                value: ro.value
            }));
    }
    return data;
}
var $ca941a2ef5e688c5$export$2e2bcd8739ae039 = $ca941a2ef5e688c5$var$AgedCareSuggestionEnginePanel;




/**
 * DownsizeStrategyAllocator.js – allocate sale proceeds from downsizing (RAD, new home, downsizer, gifts, etc.).
 * Used by AgedCareAnalyser. Props: factFind, details, setDetails, radRoomCost (optional modelled room / RAD cap for slider + input cap).
 */ 

var $acw62 = parcelRequire("acw62");





/**
 * "Downsizer Rules & Insights" — the eligibility and consequence panel that sits beside every
 * downsizer-contribution input, in every module.
 *
 * WHY THIS IS SHARED. It began as an inline block copy-pasted between the two Aged Care allocators,
 * and was missing entirely from Retirement Village and the Downsizer module (owner-caught,
 * 2026-08-26: "in aged care we include the hyperlink that explains the strategy and the eligibility
 * criteria — this should be here too"). A rules panel that exists in two of five places is worse
 * than none, because the client learns the rules only if they happened to enter through the right
 * door. One component, one set of words.
 *
 * THE CENTRELINK LINE IS AGE-AWARE, AND THAT IS THE POINT. The original stated flatly that the
 * contribution counts as an asset for the Age Pension and may reduce entitlements. That is
 * true only when the contributing member has REACHED Age Pension age. Below it, accumulation super
 * is exempt from BOTH means tests — verified against the engine, which returns early for
 * `superannuation` owned by a member under `PENSION_AGE` (assessableMeans.ts) and re-tests age every
 * projection year. On a real age-gap couple the difference is not academic:
 *
 *     $800k in the bank                          pension $11,114/yr   assets counted $800,000
 *     $500k into the YOUNGER (63) member's super pension $23,535/yr   assets counted $300,000
 *     $500k into the OLDER  (68) member's super  pension $11,114/yr   assets counted $800,000
 *
 * So whose name the contribution goes into can be worth more than $12,000 a year until the younger
 * member reaches Age Pension age — and the panel now says so, at the moment the adviser is choosing
 * between the two inputs.
 */ 

var $acw62 = parcelRequire("acw62");



const $b75d5c6eae88a43d$var$ATO_URL = 'https://www.ato.gov.au/individuals/super/growing-your-super/adding-to-your-super/downsizer-contributions-for-individuals/';
/**
 * When this person reaches Age Pension age, as a month and year ("March 2030") — the date the
 * exemption ends. Said as a DATE rather than "when they turn 67" because a date is something an
 * adviser can plan a review around, and because it makes the benefit's end concrete rather than
 * abstract. `PENSION_AGE` is a flat 67, which is correct for everyone it can apply to here: anyone
 * currently under 67 was born after 1959, and 67 is the Age Pension age for every birthdate from
 * 1 January 1957 onwards.
 */ function $b75d5c6eae88a43d$var$pensionAgeDateOf(dob) {
    const born = new Date(dob);
    if (Number.isNaN(born.getTime())) return null;
    const reaches = new Date(born.getFullYear() + (0, $1abe73eeef086faf$export$5b6998cba7880742), born.getMonth(), born.getDate());
    return reaches.toLocaleDateString('en-AU', {
        month: 'long',
        year: 'numeric'
    });
}
const $b75d5c6eae88a43d$var$DownsizerRulesAndInsights = ({ factFind: factFind, className: className = '' })=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    const isCouple = factFind?.adviceFor === 'couple';
    const clientAge = (0, $f1228be62b68f76b$export$52c4b531b4b88390)(factFind, 'client');
    const partnerAge = isCouple ? (0, $f1228be62b68f76b$export$52c4b531b4b88390)(factFind, 'partner') : null;
    const clientName = factFind?.client?.firstName || 'you';
    const partnerName = factFind?.partner?.firstName || 'your partner';
    // Who, if anyone, is still under Age Pension age — the whole basis of the exemption below.
    const clientUnder = clientAge != null && clientAge < (0, $1abe73eeef086faf$export$5b6998cba7880742);
    const partnerUnder = partnerAge != null && partnerAge < (0, $1abe73eeef086faf$export$5b6998cba7880742);
    const youngerName = partnerUnder && !clientUnder ? partnerName : clientUnder && !partnerUnder ? clientName : null;
    const bothUnder = clientUnder && partnerUnder;
    const anyUnder = clientUnder || partnerUnder;
    // The allocation rule the strategy generators use, read here so the words and the split agree.
    const preference = (0, $f1228be62b68f76b$export$308a4644edfb910)(factFind);
    const preferredFirstName = preference.preferred === 'partner' ? partnerName : preference.preferred === 'client' ? clientName : null;
    const preferredDob = preference.preferred === 'partner' ? factFind?.partner?.dob : preference.preferred === 'client' ? factFind?.client?.dob : null;
    /*
     * THE NUDGE IS NOT BEHIND THE TAP. The rules below are reference material an adviser opens when
     * they want it; this one line is the opposite — the thing they will not think to look for, and
     * the single most valuable fact on the panel. It states WHOSE account to fill and until when,
     * using the SAME rule the strategy generators allocate by (downsizerExemptionPreference), so a
     * Suggestion Engine card can never split one way while this explains another.
     *
     * Deliberately no dollar figure here. The proposal called for one, but a separately computed
     * "worth about $X/yr" would sit inches from the Financial Impact panel's own before/after and
     * could disagree with it. The panel already prices the choice the moment the adviser makes it;
     * this says which choice to make and why.
     */ const exemptionEnds = preferredDob ? $b75d5c6eae88a43d$var$pensionAgeDateOf(preferredDob) : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `mt-2 ${className}`,
        children: [
            preference.preferred && preferredFirstName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mb-2 rounded-lg border border-slate-200/70 border-l-4 border-l-emerald-500 bg-white px-3 py-2 text-xs leading-relaxed text-slate-700 shadow-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "font-semibold text-slate-900",
                        children: [
                            "Put this in ",
                            preferredFirstName,
                            "'s name."
                        ]
                    }),
                    ' ',
                    "They are under Age Pension age (",
                    (0, $1abe73eeef086faf$export$5b6998cba7880742),
                    "), so super held in their accumulation account is not counted in the assets test and not deemed for the income test",
                    exemptionEnds ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " \u2014 until ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold text-slate-900",
                                children: exemptionEnds
                            })
                        ]
                    }) : '',
                    ". The same money in the other name is counted straight away.",
                    preference.preferredAge != null && preference.preferredAge < 60 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " Note it also can't be drawn on for cashflow until ",
                            preferredFirstName,
                            " turns 60."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: "text-blue-600 text-xs underline",
                onClick: ()=>setOpen((v)=>!v),
                children: open ? 'Hide Downsizer Rules & Insights' : 'Show Downsizer Rules & Insights'
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-2 space-y-2 rounded-r-lg border-l-4 border-blue-400 bg-white p-3 text-xs text-blue-900",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Eligibility:"
                            }),
                            " the contributing person must be ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "55 or older"
                            }),
                            " at the time of the contribution (there is no upper age limit and no work test). The home must have been owned for at least 10 years and have been a main residence for at least part of that time."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Contribution limit:"
                            }),
                            " up to",
                            ' ',
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$42edd27decf8c272)),
                            " per person",
                            isCouple ? ` (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$42edd27decf8c272) * 2)} for a couple)` : '',
                            ", and never more than the actual sale proceeds. Both members of a couple can contribute from the same sale, even if only one of them owned the home."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Timeframe:"
                            }),
                            " generally within ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "90 days of settlement"
                            }),
                            ", and it is a once-only opportunity \u2014 a downsizer contribution can only be made in relation to one home sale."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Contribution caps:"
                            }),
                            " a downsizer contribution does ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "not"
                            }),
                            " count towards the concessional or non-concessional caps, and it can be made even when the total super balance is already large. That makes it available where ordinary contributions are not."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Income stream:"
                            }),
                            " the contribution can be left in accumulation, or used to start an account-based pension, where earnings are tax-free. Because they are tax-free, there is a lifetime limit on how much anyone can move in \u2014 the ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "transfer balance cap"
                            }),
                            ", currently ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$807e93be6ec93c1b)),
                            ". This tool applies it for you: anything above the remaining cap stays in accumulation, taxed at 15%."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "rounded border-l-2 border-blue-500 bg-white/70 px-2 py-1.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Age Pension:"
                            }),
                            ' ',
                            !anyUnder ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "because ",
                                    isCouple ? 'both of you have' : `${clientName} has`,
                                    " reached Age Pension age (",
                                    (0, $1abe73eeef086faf$export$5b6998cba7880742),
                                    "), money moved into super is still ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "counted"
                                    }),
                                    " in the assets test and deemed for the income test \u2014 the same as leaving it in the bank. The reason to contribute here is tax and estate planning, not the pension."
                                ]
                            }) : bothUnder ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "because you are both under Age Pension age (",
                                    (0, $1abe73eeef086faf$export$5b6998cba7880742),
                                    "), super held in",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "accumulation"
                                    }),
                                    " is exempt from the assets and income tests until you reach it \u2014 so contributing can lift the pension you become entitled to, right up to that point. Starting an income stream ends the exemption."
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "whose name it goes into matters here."
                                    }),
                                    " ",
                                    youngerName,
                                    " is still under Age Pension age (",
                                    (0, $1abe73eeef086faf$export$5b6998cba7880742),
                                    "), so super held in their",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "accumulation"
                                    }),
                                    " account is exempt from the assets and income tests until they reach it. The same money in the older person's name is counted straight away. The exemption ends the day ",
                                    youngerName,
                                    " reaches Age Pension age, and it is lost sooner if the money is used to start an income stream."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Access:"
                            }),
                            " money contributed to super is generally preserved until a condition of release is met, so treat it as locked away \u2014 a real trade-off if cash may be needed for care or accommodation costs."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: $b75d5c6eae88a43d$var$ATO_URL,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "text-blue-700 underline",
                            children: "More info: ATO Downsizer Contribution"
                        })
                    })
                ]
            })
        ]
    });
};
var $b75d5c6eae88a43d$export$2e2bcd8739ae039 = $b75d5c6eae88a43d$var$DownsizerRulesAndInsights;


/**
 * strategyExplainers.ts — the single source of the plain-English "what's this?" copy for the
 * strategy allocators (Manual Control across every module: Aged Care, Retirement Village,
 * Support at Home, downsizing).
 *
 * Why this file exists (owner, 2026-10-02): several strategy tooltips led straight into the
 * technical limit — "Up to $300,000 per person (55+)." — without first saying what the strategy
 * IS. The copy was also duplicated inline across five allocators, so it had drifted (three
 * different wordings of the gifting note alone). Each explainer now lives here ONCE: a plain-words
 * sentence on what the move is, then the limit/rule. Consumer-first — plain words, low jargon
 * (see the standing consumer-first presentation challenge), the limit kept as the second clause.
 *
 * Every string is a function so the limit constants are read lazily and the import stays safe to
 * use from any allocator without an eval-order cycle.
 */ 

const $8849d61d9af733fb$export$209aa12337df7b2c = 'You must be 55 or over to make a downsizer contribution.';
const $8849d61d9af733fb$export$229126c85a7ec674 = {
    /** Contribute sale proceeds to super. `isEligible` false → the age rule instead of the pitch. */ downsizerToSuper: (isEligible)=>isEligible ? `Move some of the money from selling your home into super, where earnings are taxed lightly \u{2014} 15%, or nothing once it's paying you a pension. Up to ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$42edd27decf8c272))} per person (55+).` : $8849d61d9af733fb$export$209aa12337df7b2c,
    /** The same move on the partner's share of the sale. */ partnerDownsizerToSuper: (isEligible)=>isEligible ? `Your partner can do the same with their share of the sale \u{2014} money into super, where earnings are taxed lightly. Up to ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$42edd27decf8c272))} each (55+).` : $8849d61d9af733fb$export$209aa12337df7b2c,
    /** Give money to family or friends. */ giftToLovedOnes: ()=>`Give some of the money to family or friends. Centrelink still counts anything above the limits as yours for five years, so large gifts may not lift your pension. Free area: ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))} a year, or ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9cd36ea38af5a5f3))} over any five years.`,
    /** Prepay funeral costs through a funeral bond. */ funeralBond: ()=>`Set money aside now to prepay funeral costs. It's locked away for that purpose, and in return Centrelink leaves it out of the assets test \u{2014} up to ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$aca3edb7cd7a3f17))} per person \u{2014} which can lift your pension.`,
    /** Turn a lump sum into guaranteed income. */ buyAnnuity: ()=>`Turn a lump sum into guaranteed income, for life or a set term. Centrelink counts only part of the value, which can lift your pension \u{2014} useful when you want predictable income rather than relying only on market returns.`,
    /** Invest in shares / managed funds. */ buyShares: ()=>`Invest the money in shares or managed funds. It aims for higher long-term growth than cash, but returns aren't guaranteed. Centrelink counts it and deems an income from it.`,
    /** Buy an investment property. */ buyInvestmentProperty: ()=>`Buy an investment property with the money. The property counts as an asset and the net rent (after expenses) is counted as income. Expenses like rates, insurance and maintenance are generally tax-deductible \u{2014} enter them below.`,
    /** Pay the retirement village entry fee from the sale. */ villageEntryFee: ()=>`Use sale proceeds to pay the retirement village entry fee (capped at the entry fee amount above).`,
    /*
     * What to do with the money a sale leaves, in the village's "what should happen to the money" question
     * (owner, 22 Oct 2026: "clients aren't going to know what this necessarily is"). Each says what it is, what
     * Centrelink and tax do with it, and what it costs in access.
     */ /** A downsizer contribution, drawn as an account-based pension. */ superPensionFromSale: ()=>`From age 55, each person can put up to ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$42edd27decf8c272))} from selling a home they have owned for 10 years or more into super, without the usual limits on putting money in (it must go in within 90 days of settlement). The plans then start an account-based pension with it: a super account that pays a regular income, at least a set minimum each year and more whenever you ask, while the rest stays invested. From 60 the payments are tax-free and the earnings inside it are not taxed. Centrelink counts the balance and deems an income from it, just as it would money in the bank, so the gain is in tax and returns rather than the Age Pension. The money can still be taken out, and what is left goes to whoever you nominate.`,
    /** Money invested in their own names, as the investment choice says. */ investInOwnNames: ()=>`The money is invested in your own names, in shares or managed funds, on the investment choice below. It aims to grow faster than cash, but returns go up and down and are not guaranteed. Centrelink counts it and deems an income from it; the income it actually earns is taxed at your own rate. It can be sold when you need the money, though selling at a gain can mean capital gains tax.`,
    /** An investment property bought outright from what the sale leaves. */ investmentPropertyFromSale: ()=>`A property bought outright to rent out, from the money left after the move, with the stamp duty in the state you choose. Centrelink counts the property's value, and the rent after expenses as income; the rent is taxed at your own rate, and the costs of owning it (rates, insurance, repairs, the agent) come out of it. It cannot be sold a little at a time when money is needed, and selling it later can mean capital gains tax.`,
    /** Pay down an existing loan with the proceeds. */ payDownLoan: ()=>`Use the money to pay down a loan you already have, cutting the interest you pay.`
};


function $ae9bedce5dc0c4a9$var$DownsizeStrategyAllocator({ factFind: factFind, details: details, setDetails: setDetails, radRoomCost: radRoomCost = 0 }) {
    // The duty on the new home comes off the proceeds beside the selling costs (23 Sep 2026).
    const netProceeds = (Number(details.salePrice) || 0) - (Number(details.sellingCosts) || 0) - (Number(details.stampDuty) || 0);
    const radCap = Math.max(0, Number(radRoomCost) || 0);
    const radSliderMax = radCap > 0 ? Math.min(netProceeds, radCap) : netProceeds;
    const handleDetailChange = (field, value)=>{
        if (field === 'radAllocation') {
            const num = value === '' || value === undefined ? 0 : Number(value);
            const capped = Number.isFinite(num) ? Math.min(Math.max(0, num), radSliderMax) : 0;
            setDetails((prev)=>({
                    ...prev,
                    radAllocation: capped
                }));
            return;
        }
        // The state is the one field that is a word, not a figure (owner-caught, 23 Sep 2026: the
        // select "always reverts" — 'NSW' had been parsed to 0).
        if (field === 'newHomeState') {
            setDetails((prev)=>({
                    ...prev,
                    newHomeState: String(value ?? '')
                }));
            return;
        }
        setDetails((prev)=>({
                ...prev,
                [field]: parseFloat(String(value)) || 0
            }));
    };
    (0, $acw62.useEffect)(()=>{
        setDetails((prev)=>{
            const r = Number(prev.radAllocation) || 0;
            if (r <= radSliderMax) return prev;
            return {
                ...prev,
                radAllocation: radSliderMax
            };
        });
    }, [
        radSliderMax,
        setDetails
    ]);
    const totalAllocated = (Number(details.radAllocation) || 0) + (Number(details.newHomePurchasePrice) || 0) + (Number(details.downsizerContribution) || 0) + (Number(details.partnerDownsizerContribution) || 0) + (Number(details.giftingAmount) || 0) + (Number(details.funeralBondPurchase) || 0) + (Number(details.purchaseInvestmentProperty) || 0) + (Number(details.purchaseShares) || 0);
    const unallocatedProceeds = netProceeds - totalAllocated;
    const clientAge = (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client?.dob);
    const isDownsizerEligible = (clientAge ?? 0) >= 55;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-4 p-4 bg-gray-50 rounded-lg border space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "font-semibold text-lg",
                        children: "1. Calculate Net Proceeds"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 sm:grid-cols-2 2xl:grid-cols-3 gap-4 mt-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                label: "Sale Price of Home",
                                name: "salePrice",
                                value: details.salePrice || '',
                                onChange: (v)=>handleDetailChange('salePrice', v)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                label: "Selling Costs",
                                name: "sellingCosts",
                                value: details.sellingCosts || '',
                                onChange: (v)=>handleDetailChange('sellingCosts', v)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "block text-sm font-medium text-gray-700 mb-1",
                                        children: "Net Proceeds"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "w-full px-4 py-2 bg-gray-200 border border-gray-300 rounded-lg font-bold",
                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(netProceeds)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "font-semibold text-lg",
                        children: "2. Allocate the Proceeds"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-2 p-3 bg-white border-l-4 border-blue-400 rounded-r-lg text-sm flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    className: "text-blue-700",
                                    children: "Unallocated Proceeds:"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: `font-bold text-lg ${unallocatedProceeds < 0 ? 'text-red-600' : 'text-green-600'}`,
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(unallocatedProceeds)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-4 space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                                icon: (0, $8474226e5f2f9b18$export$2e2bcd8739ae039),
                                label: "Fund the RAD",
                                name: "radAllocation",
                                value: details.radAllocation,
                                onChange: handleDetailChange,
                                max: radSliderMax
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                                icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
                                label: "Purchase New Home",
                                name: "newHomePurchasePrice",
                                value: details.newHomePurchasePrice,
                                onChange: handleDetailChange,
                                max: netProceeds
                            }),
                            (Number(details.newHomePurchasePrice) || 0) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 gap-4 rounded-lg border border-slate-200 bg-white p-3",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $89d49377c5c902f9$export$2e2bcd8739ae039), {
                                    state: details.newHomeState,
                                    onStateChange: (v)=>handleDetailChange('newHomeState', v),
                                    newHomePrice: details.newHomePurchasePrice,
                                    duty: details.stampDuty,
                                    onDutyChange: (v)=>handleDetailChange('stampDuty', v)
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                                icon: (0, $33b542e8915cec79$export$2e2bcd8739ae039),
                                label: "Downsizer Contribution",
                                name: "downsizerContribution",
                                value: details.downsizerContribution,
                                onChange: handleDetailChange,
                                max: (0, $1abe73eeef086faf$export$42edd27decf8c272),
                                disabled: !isDownsizerEligible,
                                tooltip: (0, $8849d61d9af733fb$export$229126c85a7ec674).downsizerToSuper(isDownsizerEligible)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b75d5c6eae88a43d$export$2e2bcd8739ae039), {
                                factFind: factFind
                            }),
                            factFind.adviceFor === 'couple' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                                    icon: (0, $33b542e8915cec79$export$2e2bcd8739ae039),
                                    label: "Partner's Downsizer Contribution",
                                    name: "partnerDownsizerContribution",
                                    value: details.partnerDownsizerContribution,
                                    onChange: handleDetailChange,
                                    max: (0, $1abe73eeef086faf$export$42edd27decf8c272),
                                    disabled: !isDownsizerEligible,
                                    tooltip: (0, $8849d61d9af733fb$export$229126c85a7ec674).partnerDownsizerToSuper(isDownsizerEligible)
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-2 flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "checkbox",
                                        id: "commenceIncomeStream",
                                        checked: !!details.commenceIncomeStream,
                                        onChange: (e)=>setDetails((prev)=>({
                                                    ...prev,
                                                    commenceIncomeStream: e.target.checked
                                                }))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "commenceIncomeStream",
                                        className: "text-sm",
                                        children: "Commence an income stream from downsizer contribution"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                                icon: (0, $8474226e5f2f9b18$export$2e2bcd8739ae039),
                                label: "Buy Investment Property",
                                name: "purchaseInvestmentProperty",
                                value: details.purchaseInvestmentProperty,
                                onChange: handleDetailChange,
                                max: netProceeds,
                                tooltip: (0, $8849d61d9af733fb$export$229126c85a7ec674).buyInvestmentProperty()
                            }),
                            (Number(details.purchaseInvestmentProperty) || 0) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "ml-6 pl-4 border-l-2 border-gray-200 space-y-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                        label: "Assumed annual rental income ($)",
                                        name: "investmentPropertyRent",
                                        value: details.investmentPropertyRent ?? '',
                                        onChange: (v)=>handleDetailChange('investmentPropertyRent', v)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                        label: "Assumed annual expenses ($)",
                                        name: "investmentPropertyExpenses",
                                        value: details.investmentPropertyExpenses ?? '',
                                        onChange: (v)=>handleDetailChange('investmentPropertyExpenses', v)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-xs text-gray-600",
                                        children: "Investment property expenses (e.g. rates, insurance, maintenance) are generally tax deductible."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                                icon: (0, $c9921f4f81a419f0$export$2e2bcd8739ae039),
                                label: "Buy shares",
                                name: "purchaseShares",
                                value: details.purchaseShares,
                                onChange: handleDetailChange,
                                max: netProceeds,
                                tooltip: (0, $8849d61d9af733fb$export$229126c85a7ec674).buyShares()
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                                icon: (0, $6315759428919b56$export$2e2bcd8739ae039),
                                label: "Gift to Loved Ones",
                                name: "giftingAmount",
                                value: details.giftingAmount,
                                onChange: handleDetailChange,
                                max: netProceeds,
                                tooltip: (0, $8849d61d9af733fb$export$229126c85a7ec674).giftToLovedOnes()
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                                icon: (0, $e325251f2797f6cf$export$2e2bcd8739ae039),
                                label: "Purchase Funeral Bond",
                                name: "funeralBondPurchase",
                                value: details.funeralBondPurchase,
                                onChange: handleDetailChange,
                                max: (0, $1abe73eeef086faf$export$aca3edb7cd7a3f17),
                                tooltip: (0, $8849d61d9af733fb$export$229126c85a7ec674).funeralBond()
                            })
                        ]
                    })
                ]
            }),
            netProceeds > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "font-semibold text-lg",
                        children: "3. Where every dollar goes"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-2 rounded-lg border border-slate-200 bg-white px-4 py-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ae9bedce5dc0c4a9$var$FlowRow, {
                                label: "Sale of the home",
                                amount: Number(details.salePrice) || 0
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ae9bedce5dc0c4a9$var$FlowRow, {
                                label: "Selling costs",
                                amount: -(Number(details.sellingCosts) || 0)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ae9bedce5dc0c4a9$var$FlowRow, {
                                label: "Net proceeds",
                                amount: netProceeds,
                                bold: true,
                                divider: true
                            }),
                            $ae9bedce5dc0c4a9$var$ledgerRows(details).map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ae9bedce5dc0c4a9$var$FlowRow, {
                                    label: row.label,
                                    amount: -row.amount,
                                    chip: row.chip,
                                    chipTone: row.tone,
                                    note: row.note
                                }, row.label)),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ae9bedce5dc0c4a9$var$FlowRow, {
                                label: "Remainder \u2014 stays in the bank as Unallocated Sale Proceeds",
                                amount: unallocatedProceeds,
                                bold: true,
                                divider: true,
                                chip: unallocatedProceeds > 0 ? 'deemed & counted' : undefined,
                                chipTone: "amber"
                            }),
                            unallocatedProceeds < 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-2 text-xs font-semibold text-red-600",
                                children: [
                                    "Allocated ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(-unallocatedProceeds),
                                    " more than the sale frees up \u2014 reduce an allocation above."
                                ]
                            }),
                            unallocatedProceeds > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-2 text-xs text-gray-500",
                                children: "Anything left unallocated sits in the bank, where it is deemed and counted by both the Age Pension and aged care means tests. The exempt destinations above shelter more of it."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/** One line of the money-flow ledger. */ function $ae9bedce5dc0c4a9$var$FlowRow({ label: label, amount: amount, bold: bold = false, divider: divider = false, chip: chip, chipTone: chipTone, note: note }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: divider ? 'border-t border-slate-200 pt-1.5 mt-1.5' : '',
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-baseline justify-between gap-3 py-0.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: `text-sm ${bold ? 'font-bold text-slate-900' : 'text-slate-600'}`,
                        children: [
                            label,
                            chip && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `ml-2 align-middle rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${chipTone === 'green' ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'}`,
                                children: chip
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `text-sm tabular-nums ${bold ? 'font-bold text-slate-900' : 'font-semibold text-slate-700'}`,
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(amount)
                    })
                ]
            }),
            note && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-xs text-amber-700 -mt-0.5 pb-1",
                children: note
            })
        ]
    });
}
/** The non-zero destinations, each with its means-test consequence. */ function $ae9bedce5dc0c4a9$var$ledgerRows(details) {
    const rows = [];
    const add = (amount, label, chip, tone, note)=>{
        const value = Number(amount) || 0;
        if (value > 0) rows.push({
            label: label,
            amount: value,
            chip: chip,
            tone: tone,
            note: note
        });
    };
    add(details.radAllocation, 'Fund the RAD (refundable room deposit)', 'exempt from assets test', 'green');
    add(details.newHomePurchasePrice, 'Purchase new home (new principal residence)', 'exempt', 'green');
    add(details.downsizerContribution, 'Downsizer contribution to super', 'counted once in pension phase', 'amber');
    add(details.partnerDownsizerContribution, "Partner's downsizer contribution", 'counted once in pension phase', 'amber');
    add(details.purchaseInvestmentProperty, 'Buy investment property', 'fully counted, both tests', 'amber');
    add(details.purchaseShares, 'Buy shares', 'counted & deemed', 'amber');
    const gift = Number(details.giftingAmount) || 0;
    add(details.giftingAmount, 'Gift to loved ones', gift > (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0) ? 'partly still counted' : 'within free area', gift > (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0) ? 'amber' : 'green', gift > (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0) ? `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(gift - (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))} is beyond the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))} yearly free area \u{2014} Centrelink still counts it for 5 years (deprivation).` : undefined);
    add(details.funeralBondPurchase, 'Funeral bond', 'exempt up to the limit', 'green');
    return rows;
}
var $ae9bedce5dc0c4a9$export$2e2bcd8739ae039 = $ae9bedce5dc0c4a9$var$DownsizeStrategyAllocator;


/**
 * InvestmentPropertyStrategyAllocator.js – allocate sale proceeds from selling an investment property (CGT, RAD, new home, downsizer, etc.).
 * Used by AgedCareAnalyser. Props: factFind, details, setDetails, radRoomCost (optional room / RAD cap for Fund the RAD slider).
 * CGT uses assessable income + assessable capital gain for marginal rate in year of sale (Section 11 fix).
 */ 

var $acw62 = parcelRequire("acw62");








/**
 * Shared CGT estimate panel with optional accountant override (RAD share sales + IP sale).
 */ 

var $acw62 = parcelRequire("acw62");





function $e778a6a28982486d$export$45781c28beddd168({ factFind: factFind, taxSummary: taxSummary, overrideValue: overrideValue, onOverrideChange: onOverrideChange, entityId: entityId = null, asset: asset = null, showNetProceedsLine: showNetProceedsLine = false, saleAmount: saleAmount = null, netProceedsLabel: netProceedsLabel = 'Net toward RAD (after estimated CGT)' }) {
    const [editingOverride, setEditingOverride] = (0, $acw62.useState)(false);
    const [draftOverride, setDraftOverride] = (0, $acw62.useState)('');
    if (!taxSummary) return null;
    const effective = (0, $a764bc0f6f904854$export$1436ab50c5990307)(taxSummary, overrideValue);
    const isPreCGT = effective.isPreCGT ?? false;
    const capitalGain = effective.capitalGain ?? 0;
    const assessableCapitalGain = effective.assessableCapitalGain ?? 0;
    const capitalGainsTax = effective.estimatedCGT ?? 0;
    const calculatedCgt = effective.calculatedCGT ?? capitalGainsTax;
    const isOverridden = effective.isOverridden ?? false;
    const entityDisposalWarning = effective.entityDisposalWarning || effective.warning;
    const isPartnered = factFind?.adviceFor === 'couple';
    const clientName = factFind?.client?.firstName?.trim() || 'Client';
    const partnerName = factFind?.partner?.firstName?.trim() || 'Partner';
    const showApportionedTaxSplit = !isPreCGT && (effective.clientEstimatedCgt != null || effective.partnerEstimatedCgt != null) && ((effective.clientEstimatedCgt ?? 0) > 0 || (effective.partnerEstimatedCgt ?? 0) > 0) && !isOverridden;
    const netAfterTax = showNetProceedsLine && saleAmount != null ? Math.max(0, parseFloat(String(saleAmount)) || 0) - capitalGainsTax : effective.netProceeds;
    const openOverrideEditor = ()=>{
        const current = (0, $a764bc0f6f904854$export$2778f99280b2ce68)(overrideValue);
        setDraftOverride(current != null ? String(current) : String(Math.round(calculatedCgt)));
        setEditingOverride(true);
    };
    const applyOverride = ()=>{
        const parsed = (0, $a764bc0f6f904854$export$2778f99280b2ce68)(draftOverride);
        onOverrideChange?.(parsed);
        setEditingOverride(false);
    };
    const clearOverride = ()=>{
        onOverrideChange?.(null);
        setEditingOverride(false);
        setDraftOverride('');
    };
    const showEntityPanels = asset && (0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(asset.ownership);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "p-3 bg-white border border-slate-200 border-l-4 border-l-amber-400 rounded-r-lg text-sm",
                children: [
                    isPreCGT ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-amber-700",
                                        children: "Capital Gain:"
                                    }),
                                    " Not applicable (Pre-CGT asset)"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-amber-700",
                                        children: "Capital Gains Tax:"
                                    }),
                                    " $0"
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-amber-700",
                                        children: "Capital Gain:"
                                    }),
                                    ' ',
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(capitalGain)
                                ]
                            }),
                            effective.taxMethod === 'personal_marginal' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-amber-700",
                                        children: "Assessable Capital Gain:"
                                    }),
                                    ' ',
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(assessableCapitalGain),
                                    " (50% discount)"
                                ]
                            }),
                            effective.taxMethod === 'trust_distribute' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-amber-700",
                                        children: "Gain counted for tax (after 50% discount):"
                                    }),
                                    ' ',
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(assessableCapitalGain)
                                ]
                            }),
                            effective.taxMethod === 'company_rate' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-amber-700",
                                        children: "Tax:"
                                    }),
                                    " Company rate on full gain (no 50% CGT discount)"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-x-2 gap-y-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                className: "text-amber-700",
                                                children: isOverridden ? 'Tax (accountant override):' : 'Estimated tax (total):'
                                            }),
                                            ' ',
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(capitalGainsTax)
                                        ]
                                    }),
                                    !isPreCGT && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: openOverrideEditor,
                                        className: "inline-flex items-center gap-1 text-xs font-medium text-slate-700 underline hover:text-slate-900",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                                size: 12
                                            }),
                                            isOverridden ? 'Edit override' : 'Override tax estimate'
                                        ]
                                    })
                                ]
                            }),
                            isOverridden && calculatedCgt !== capitalGainsTax && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-xs text-slate-700 mt-1",
                                children: [
                                    "Calculated estimate was ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(calculatedCgt),
                                    "."
                                ]
                            }),
                            showApportionedTaxSplit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1 text-yellow-900",
                                children: isPartnered && (effective.clientEstimatedCgt ?? 0) > 0 && (effective.partnerEstimatedCgt ?? 0) > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        "Split ",
                                        effective.apportionmentClientPct,
                                        "% /",
                                        ' ',
                                        effective.apportionmentPartnerPct,
                                        "% (Centrelink on trust card):",
                                        ' ',
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-medium",
                                            children: clientName
                                        }),
                                        " ~",
                                        ' ',
                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(effective.clientEstimatedCgt),
                                        ",",
                                        ' ',
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-medium",
                                            children: partnerName
                                        }),
                                        " ~",
                                        ' ',
                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(effective.partnerEstimatedCgt)
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "font-medium",
                                            children: [
                                                clientName,
                                                ":"
                                            ]
                                        }),
                                        " ~",
                                        ' ',
                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(effective.clientEstimatedCgt)
                                    ]
                                })
                            }),
                            showNetProceedsLine && Number(saleAmount) > 0 && !isPreCGT && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-2 pt-2 border-t border-yellow-200",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: "text-amber-700",
                                        children: [
                                            netProceedsLabel,
                                            ":"
                                        ]
                                    }),
                                    ' ',
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(netAfterTax)
                                ]
                            })
                        ]
                    }),
                    editingOverride && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3 pt-3 border-t border-yellow-200 space-y-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-xs text-yellow-900",
                                children: "Enter the total CGT your accountant advised for this disposal."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap items-end gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "w-40",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "block text-xs font-medium text-yellow-900 mb-1",
                                                children: "Total tax ($)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                value: draftOverride,
                                                onChange: (v)=>setDraftOverride(v === undefined ? '' : String(v)),
                                                placeholder: "0"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: applyOverride,
                                        className: "px-3 py-1.5 text-xs font-semibold rounded bg-yellow-700 text-white hover:bg-yellow-800",
                                        children: "Apply"
                                    }),
                                    isOverridden && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: clearOverride,
                                        className: "inline-flex items-center gap-1 px-2 py-1.5 text-xs font-medium text-yellow-900 hover:underline",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6e669e1fd7e7ff8$export$2e2bcd8739ae039), {
                                                size: 12
                                            }),
                                            "Reset to calculated"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setEditingOverride(false),
                                        className: "px-2 py-1.5 text-xs text-slate-700 hover:underline",
                                        children: "Cancel"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            entityDisposalWarning && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "p-3 bg-white border border-slate-200 border-l-4 border-l-amber-400 rounded-r-lg text-sm text-slate-700",
                children: entityDisposalWarning
            }),
            showEntityPanels && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "p-3 bg-orange-50 border-l-4 border-orange-400 rounded-r-lg text-sm text-orange-900",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: entityId && effective.taxMethod === 'trust_distribute' ? isPartnered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-medium",
                                children: "Family trust:"
                            }),
                            " We assume the gain is paid to ",
                            clientName,
                            " (",
                            effective.apportionmentClientPct,
                            "%) and",
                            ' ',
                            partnerName,
                            " (",
                            effective.apportionmentPartnerPct,
                            "%) \u2014 same as Centrelink on your trust card. The trust may pay other",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-medium",
                                children: "beneficiaries"
                            }),
                            " (e.g. adult children) instead, which would change the tax. Pension and care fees still use your Centrelink %.",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-medium",
                                children: "Confirm with your accountant prior to implementing this strategy."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-medium",
                                children: "Family trust:"
                            }),
                            " Tax assumes the gain goes to ",
                            clientName,
                            " per your Centrelink % on the trust card. The trust may pay other beneficiaries instead.",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-medium",
                                children: "Confirm with your accountant prior to implementing this strategy."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-medium",
                                children: "Trust or company:"
                            }),
                            " Sale tax is estimated differently than for your own name.",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-medium",
                                children: "Confirm with your accountant prior to implementing this strategy."
                            })
                        ]
                    })
                })
            })
        ]
    });
}




function $e089f32d871d5f03$var$InvestmentPropertyStrategyAllocator({ factFind: factFind, details: details, setDetails: setDetails, radRoomCost: radRoomCost = 0 }) {
    const selectedProperty = factFind.assets?.investmentProperty?.find((p)=>p.id === details.selectedPropertyId) || factFind.assets?.investmentProperty?.[0];
    // DraftFactFind is structurally compatible with FactFind/FactFindAsset (see
    // types/formDraft.ts); the shared calc-engine fn defensively parseFloat/coerces internally
    // regardless (see factFindTypes.ts header), so this cast is safe.
    const rawTaxSummary = selectedProperty ? (0, $a764bc0f6f904854$export$f70460bedec8e810)(factFind, selectedProperty, details) : null;
    const taxSummary = (0, $a764bc0f6f904854$export$1436ab50c5990307)(rawTaxSummary, details.cgtOverrideTotal);
    const salePrice = taxSummary?.salePrice ?? (Number(details.salePrice) || parseFloat(String(selectedProperty?.value)) || 0);
    const sellingCosts = taxSummary?.sellingCosts ?? salePrice * 0.025;
    const isPreCGT = taxSummary?.isPreCGT ?? false;
    const netProceeds = taxSummary?.netProceeds ?? salePrice - sellingCosts - (taxSummary?.estimatedCGT ?? 0);
    const radCap = Math.max(0, Number(radRoomCost) || 0);
    const radSliderMax = radCap > 0 ? Math.min(netProceeds, radCap) : netProceeds;
    const handleDetailChange = (field, value)=>{
        if (field === 'radAllocation') {
            const num = value ?? 0;
            const capped = Number.isFinite(num) ? Math.min(Math.max(0, num), radSliderMax) : 0;
            setDetails((prev)=>({
                    ...prev,
                    radAllocation: capped
                }));
            return;
        }
        if (field === 'costBase') {
            setDetails((prev)=>({
                    ...prev,
                    costBase: value
                }));
            return;
        }
        setDetails((prev)=>({
                ...prev,
                [field]: value || 0
            }));
    };
    const handleCgtOverrideChange = (value)=>{
        setDetails((prev)=>({
                ...prev,
                cgtOverrideTotal: value == null ? undefined : value
            }));
    };
    (0, $acw62.useEffect)(()=>{
        setDetails((prev)=>{
            const r = Number(prev.radAllocation) || 0;
            if (r <= radSliderMax) return prev;
            return {
                ...prev,
                radAllocation: radSliderMax
            };
        });
    }, [
        radSliderMax,
        setDetails
    ]);
    const totalAllocated = (Number(details.radAllocation) || 0) + (Number(details.newHomePurchasePrice) || 0) + (Number(details.downsizerContribution) || 0) + (Number(details.giftingAmount) || 0) + (Number(details.funeralBondPurchase) || 0);
    const unallocatedProceeds = netProceeds - totalAllocated;
    const clientAge = (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client?.dob);
    const isDownsizerEligible = (clientAge ?? 0) >= 55;
    const entityId = selectedProperty && (0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(selectedProperty.ownership) ? (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(selectedProperty.ownership) : null;
    const entityStructure = entityId ? (factFind.structures || []).find((s)=>s.id === entityId) : null;
    const proceedsToEntityPool = selectedProperty && (0, $bda3664ae16bcdb0$export$c11662d6bbf785af)(factFind, selectedProperty);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-4 p-4 bg-gray-50 rounded-lg border space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "font-semibold text-lg",
                        children: "1. Select Investment Property"
                    }),
                    factFind.assets?.investmentProperty && factFind.assets.investmentProperty.length > 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-1",
                                children: "Property to Sell"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                value: details.selectedPropertyId || factFind.assets?.investmentProperty?.[0]?.id,
                                onChange: (e)=>{
                                    const selectedId = e.target.value;
                                    const selectedProp = factFind.assets?.investmentProperty?.find((p)=>p.id === selectedId);
                                    const costBaseValue = selectedProp?.costBase;
                                    const salePriceValue = Number(selectedProp?.value) || 0;
                                    const sellingCostsValue = salePriceValue * 0.025;
                                    setDetails((prev)=>({
                                            ...prev,
                                            selectedPropertyId: selectedId,
                                            salePrice: salePriceValue,
                                            costBase: costBaseValue,
                                            sellingCosts: sellingCostsValue
                                        }));
                                },
                                className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
                                children: factFind.assets?.investmentProperty?.map((property)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                        value: property.id,
                                        children: [
                                            property.description || `Investment Property ${property.id}`,
                                            " - ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(parseFloat(String(property.value)) || 0)
                                        ]
                                    }, property.id))
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-2 p-3 bg-white border-l-4 border-blue-400 rounded-r-lg text-sm",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    className: "text-blue-700",
                                    children: "Selected Property:"
                                }),
                                " ",
                                selectedProperty?.description || 'Investment Property',
                                " - ",
                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(parseFloat(String(selectedProperty?.value)) || 0)
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "font-semibold text-lg",
                        children: "2. Calculate Net Proceeds"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                label: "Sale Price",
                                name: "salePrice",
                                value: details.salePrice || '',
                                onChange: (v)=>handleDetailChange('salePrice', v)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                label: "Cost Base",
                                name: "costBase",
                                value: details.costBase || '',
                                onChange: (v)=>handleDetailChange('costBase', v),
                                placeholder: isPreCGT ? 'N/A Pre CGT' : ''
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                label: "Selling Costs",
                                name: "sellingCosts",
                                value: details.sellingCosts || '',
                                onChange: (v)=>handleDetailChange('sellingCosts', v)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "block text-sm font-medium text-gray-700 mb-1",
                                        children: "Net Proceeds"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "w-full px-4 py-2 bg-gray-200 border border-gray-300 rounded-lg font-bold",
                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(netProceeds)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-2",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e778a6a28982486d$export$45781c28beddd168), {
                            factFind: factFind,
                            taxSummary: rawTaxSummary,
                            overrideValue: details.cgtOverrideTotal,
                            onOverrideChange: handleCgtOverrideChange,
                            entityId: entityId,
                            asset: selectedProperty
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "font-semibold text-lg",
                        children: "3. Allocate the Proceeds"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-2 p-3 bg-white border-l-4 border-blue-400 rounded-r-lg text-sm flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-blue-700",
                                        children: "Unallocated Proceeds:"
                                    }),
                                    proceedsToEntityPool && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "block text-xs font-normal text-blue-800 mt-1",
                                        children: [
                                            "Credited to ",
                                            entityStructure?.name?.trim() || 'structure',
                                            " cash (entity pool), not personal bank"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: `font-bold text-lg ${unallocatedProceeds < 0 ? 'text-red-600' : 'text-green-600'}`,
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(unallocatedProceeds)
                            })
                        ]
                    }),
                    proceedsToEntityPool && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-2 text-xs text-slate-700 bg-white border border-slate-200 border-l-4 border-l-amber-400 rounded-lg p-3",
                        children: (0, $bd80071df75c742b$export$ec9c57e3c77471a1)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-4 space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                                icon: (0, $8474226e5f2f9b18$export$2e2bcd8739ae039),
                                label: "Fund the RAD",
                                name: "radAllocation",
                                value: details.radAllocation,
                                onChange: handleDetailChange,
                                max: radSliderMax
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                                icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
                                label: "Purchase New Home",
                                name: "newHomePurchasePrice",
                                value: details.newHomePurchasePrice,
                                onChange: handleDetailChange,
                                max: netProceeds
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                                icon: (0, $33b542e8915cec79$export$2e2bcd8739ae039),
                                label: "Downsizer Contribution",
                                name: "downsizerContribution",
                                value: details.downsizerContribution,
                                onChange: handleDetailChange,
                                max: (0, $1abe73eeef086faf$export$42edd27decf8c272),
                                disabled: !isDownsizerEligible,
                                tooltip: (0, $8849d61d9af733fb$export$229126c85a7ec674).downsizerToSuper(isDownsizerEligible)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b75d5c6eae88a43d$export$2e2bcd8739ae039), {
                                factFind: factFind
                            }),
                            factFind.adviceFor === 'couple' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                                    icon: (0, $33b542e8915cec79$export$2e2bcd8739ae039),
                                    label: "Partner's Downsizer Contribution",
                                    name: "partnerDownsizerContribution",
                                    value: details.partnerDownsizerContribution,
                                    onChange: handleDetailChange,
                                    max: (0, $1abe73eeef086faf$export$42edd27decf8c272),
                                    disabled: !isDownsizerEligible,
                                    tooltip: (0, $8849d61d9af733fb$export$229126c85a7ec674).partnerDownsizerToSuper(isDownsizerEligible)
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-2 flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "checkbox",
                                        id: "commenceIncomeStreamInv",
                                        checked: !!details.commenceIncomeStream,
                                        onChange: (e)=>setDetails((prev)=>({
                                                    ...prev,
                                                    commenceIncomeStream: e.target.checked
                                                }))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "commenceIncomeStreamInv",
                                        className: "text-sm",
                                        children: "Commence an income stream from downsizer contribution"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                                icon: (0, $6315759428919b56$export$2e2bcd8739ae039),
                                label: "Gift to Loved Ones",
                                name: "giftingAmount",
                                value: details.giftingAmount,
                                onChange: handleDetailChange,
                                max: netProceeds,
                                tooltip: (0, $8849d61d9af733fb$export$229126c85a7ec674).giftToLovedOnes()
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                                icon: (0, $e325251f2797f6cf$export$2e2bcd8739ae039),
                                label: "Purchase Funeral Bond",
                                name: "funeralBondPurchase",
                                value: details.funeralBondPurchase,
                                onChange: handleDetailChange,
                                max: (0, $1abe73eeef086faf$export$aca3edb7cd7a3f17),
                                tooltip: (0, $8849d61d9af733fb$export$229126c85a7ec674).funeralBond()
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $e089f32d871d5f03$export$2e2bcd8739ae039 = $e089f32d871d5f03$var$InvestmentPropertyStrategyAllocator;









/**
 * The hand-built plan's main actions, at the foot of the right-hand rail (owner, 25 Oct 2026).
 *
 * Aged care and Support at Home used to put the plan built by hand in a full card under all the controls, which
 * nobody saw without scrolling past every slider, while the rail beside them already moved with each change. The
 * card went; the rail is the one place for the result, so the actions it carried come here: Choose (and Save,
 * where the module keeps plans without choosing them), the "before you choose" tick, and the links that follow a
 * choice. Styled as the village, downsizing, granny flat and cashflow rails already are.
 */ 
parcelRequire("acw62");
const $8605a89eee7277e8$var$RailPlanActions = ({ chosen: chosen, anotherChosen: anotherChosen = false, canChoose: canChoose, onChoose: onChoose, onSave: onSave, beforeChoose: beforeChoose, possessiveFile: possessiveFile, onAdvice: onAdvice, extra: extra, testId: testId = 'rail-plan-actions' })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": testId,
        children: [
            beforeChoose && !chosen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mb-3",
                children: beforeChoose
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: onSave && !chosen ? 'grid grid-cols-2 gap-2' : '',
                children: [
                    onSave && !chosen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: canChoose ? onSave : undefined,
                        disabled: !canChoose,
                        className: `w-full rounded-lg border px-3 py-2.5 text-[14px] font-semibold ${canChoose ? 'border-slate-300 bg-white text-slate-800 hover:border-blue-300' : 'cursor-not-allowed border-slate-200 bg-slate-100 text-slate-400'}`,
                        "data-testid": `${testId}-save`,
                        children: "Save this plan"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: canChoose && !chosen ? onChoose : undefined,
                        disabled: !canChoose && !chosen,
                        "aria-pressed": chosen,
                        className: `w-full rounded-lg px-3 py-2.5 text-[14px] font-semibold ${chosen ? 'border border-emerald-500 bg-white text-emerald-800' : canChoose ? 'bg-blue-600 text-white hover:bg-blue-700' : 'cursor-not-allowed bg-slate-200 text-slate-500'}`,
                        "data-testid": `${testId}-choose`,
                        children: chosen ? "Chosen \u2713" : anotherChosen ? 'Choose this instead' : 'Choose this plan'
                    })
                ]
            }),
            chosen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-2 text-[13px] text-slate-600",
                children: [
                    possessiveFile ? `Saved with ${possessiveFile} file.` : 'Saved.',
                    onAdvice && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onAdvice,
                                className: "ml-1 inline-flex items-center gap-1.5 rounded-lg bg-blue-600 px-3.5 py-2 text-[13px] font-semibold text-white hover:bg-blue-700",
                                "data-testid": `${testId}-advice`,
                                children: "Get the advice document \u2192"
                            })
                        ]
                    })
                ]
            }),
            extra
        ]
    });
var $8605a89eee7277e8$export$2e2bcd8739ae039 = $8605a89eee7277e8$var$RailPlanActions;


/**
 * What each strategy input DOES, said directly beneath the input.
 *
 * SHARED ACROSS MODULES. Gifting, funeral bonds, annuities and equity release are means-test
 * levers, not aged care ones — they act on the assessment, so the same note is right wherever the
 * lever is offered. Aged Care and Support at Home both use these.
 *
 * WHY THESE EXIST. Every one of these consequences was explained only inside the floating
 * "What's happening" insight panel. So a client could type $200,000 into the gifting box, or
 * $30,000 into a funeral bond, and read nothing at all about what it costs them — unless they
 * happened to open a panel somewhere else on the screen and scroll to the right card.
 *
 * The app already had the better pattern in exactly one place: enter a share sale to fund a deposit
 * and the capital gains tax appears under that asset, at the moment it becomes true. Owner
 * direction, 2026-08-28 — do that everywhere, and retire the floating panel.
 *
 * THE RULE THESE FOLLOW. A note here says what becomes true because of the number in the field above
 * it. What the whole plan does to the client's position belongs in the plan summary, and saying it
 * in both places is how the insight panels came to repeat everything twice.
 */ 
parcelRequire("acw62");




function $5251f2fd5a52d9c7$export$27d5013e22d977ca({ giftingAmount: giftingAmount, giftsHistory: giftsHistory }) {
    if (!(giftingAmount > 0)) return null;
    // What is already deprived from gifts made in earlier years, and what this gift adds on top.
    const before = (0, $171a6d8ba8937a5f$export$6f9e3cf7d82eb9f9)(giftsHistory, {});
    const after = (0, $171a6d8ba8937a5f$export$6f9e3cf7d82eb9f9)(giftsHistory, {
        otherStrategies: {
            gifting: true,
            giftingAmount: giftingAmount
        }
    });
    const added = Math.max(0, after - before);
    const leavesTheTest = Math.max(0, giftingAmount - added);
    if (added <= 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$36b8132fbfd1058f), {
        tone: "good",
        heading: "This gift leaves the means test straight away",
        children: [
            "All ",
            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(giftingAmount),
            " is within the free area, so Centrelink stops counting it now. The money is gone from the estate too \u2014 that is the cost of the improvement."
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$36b8132fbfd1058f), {
        tone: "warn",
        heading: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(added)} of this is still counted for five years`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "Only ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(leavesTheTest),
                    " leaves the means test now. The other",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(added)
                    }),
                    " is treated as",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "deprived"
                    }),
                    ": Centrelink goes on counting it as your asset, and deeming it to earn income, for five years from the date you give it away \u2014 even though the money has gone."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-1.5",
                children: [
                    "The free areas are ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0)),
                    " in a financial year and",
                    ' ',
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9cd36ea38af5a5f3)),
                    " across any five years. Gifting more than that costs the capital immediately and buys nothing for five years."
                ]
            })
        ]
    });
}
function $5251f2fd5a52d9c7$export$5eceda842173bd5({ amount: amount, isCouple: isCouple = false }) {
    if (!(amount > 0)) return null;
    const exemptCap = (0, $1abe73eeef086faf$export$aca3edb7cd7a3f17) * (isCouple ? 2 : 1);
    const excess = Math.max(0, amount - exemptCap);
    if (excess <= 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$36b8132fbfd1058f), {
        tone: "good",
        heading: "All of this is exempt from the assets test",
        children: [
            "A funeral bond is not counted, up to ",
            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$aca3edb7cd7a3f17)),
            " per person",
            isCouple ? " \u2014 one bond each" : '',
            ". The money is still there for the family; Centrelink simply stops counting it, which can lift the Age Pension and lower the means-tested care fee."
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$36b8132fbfd1058f), {
        tone: "warn",
        heading: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(excess)} of this is not exempt`,
        children: [
            "Only ",
            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(exemptCap),
            " is exempt",
            isCouple ? ' (one bond each)' : '',
            ". The remaining",
            ' ',
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(excess)
            }),
            " is counted in the assets test like any other asset \u2014 so it is locked into a funeral bond without buying any means-test benefit."
        ]
    });
}
function $5251f2fd5a52d9c7$export$c1d13bc22d751693({ loanAmount: loanAmount, interestRate: interestRate, years: years = 5, useForRad: useForRad = false }) {
    if (!(loanAmount > 0)) return null;
    const rate = (Number(interestRate) || 0) / 100;
    const owedLater = loanAmount * (1 + rate) ** years;
    const interest = owedLater - loanAmount;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$36b8132fbfd1058f), {
        tone: "warn",
        heading: `Nothing is repaid, so this grows to about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(owedLater)} in ${years} years`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "Borrowing ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(loanAmount),
                    " at ",
                    interestRate,
                    "% with no repayments adds roughly",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(interest)
                    }),
                    " of interest over ",
                    years,
                    " years. The debt is settled from the house, so it comes out of what is left to the family."
                ]
            }),
            useForRad && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-1.5",
                children: "Against that: the money pays a refundable deposit, which removes that much daily accommodation payment and is refunded when care ends. Whether borrowing leaves the family ahead depends on the room price and how long the stay is \u2014 the projections settle it."
            })
        ]
    });
}
function $5251f2fd5a52d9c7$export$eb9068fa2f8e69f7({ paymentAmount: paymentAmount, paymentFrequency: paymentFrequency = 'fortnightly', interestRate: interestRate, years: years = 5 }) {
    if (!(paymentAmount > 0)) return null;
    const perYear = paymentAmount * (paymentFrequency === 'monthly' ? 12 : 26);
    const rate = (Number(interestRate) || 0) / 100;
    // Drawn steadily rather than as a lump, so each year's draw compounds for the years remaining.
    let owed = 0;
    for(let y = 0; y < years; y += 1)owed = (owed + perYear) * (1 + rate);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$36b8132fbfd1058f), {
        tone: "info",
        heading: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(perYear)} a year, growing to about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(owed)} owed in ${years} years`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "The Home Equity Access Scheme is the government's own, at ",
                    interestRate,
                    "% \u2014 well below a commercial reverse mortgage \u2014 and the payments are",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "not counted as income"
                    }),
                    " for the Age Pension. The home is kept."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-1.5",
                children: "Nothing is repaid along the way, so the debt compounds and is settled from the house. You can stop or reduce the payments at any time."
            })
        ]
    });
}





/**
 * Step 3, before the plans run — the questions that change the answer, inline (version A, owner
 * decision 17 Oct 2026, retiring the 22 Sep "keep the setup pop-over" ruling).
 *
 * The same five questions "Things that change the answer" reopens under the plans (EngineQuestions),
 * drawn where the plans will appear, pre-filled with the suggested answer and the reason. The
 * answers land in the analyser's setup bag (coupleValidation), the annuity answer on the client's
 * goals, and the horizon in the analyser — the engine inputs are unchanged.
 */ 

var $acw62 = parcelRequire("acw62");




const $62a77aaf0618af65$var$EngineSetupInline = ({ factFind: factFind, setFactFind: setFactFind, coupleValidation: coupleValidation, setCoupleValidation: setCoupleValidation, scenarioLivingExpenses: scenarioLivingExpenses, defaultPartnerRoomPrice: defaultPartnerRoomPrice, roomDeposit: roomDeposit, legacyYears: legacyYears, onLegacyYears: onLegacyYears, enteringName: enteringName, onDone: onDone, onBuildYourOwn: onBuildYourOwn })=>{
    const [answers, setAnswers] = (0, $acw62.useState)(()=>(0, $ef4d0d82ab48599b$export$36edbd5e51ac2135)(coupleValidation, factFind, legacyYears, scenarioLivingExpenses, defaultPartnerRoomPrice));
    // "You" for the client, "John and Kerry" for an adviser (householdVoice, 21 Oct 2026).
    const household = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind).names;
    const questionCount = 2 + ((Number(factFind.home?.value) || 0) > 0 ? 1 : 0) + (factFind.adviceFor === 'couple' && factFind.goals?.aged_care_for !== 'both' ? 1 : 0) + 1 + ((factFind.structures || []).length > 0 ? 1 : 0);
    const words = [
        '',
        'One',
        'Two',
        'Three',
        'Four',
        'Five',
        'Six'
    ][questionCount] || String(questionCount);
    // Only a guaranteed income answer given here is written: the client's earlier answer, from any module, is
    // never overwritten by a default (guaranteed income review, 21 Oct 2026).
    const writeAnnuityGoals = ()=>{
        const annuityGoals = (0, $ef4d0d82ab48599b$export$e4e6d65a6e40c2df)(answers, factFind);
        if (annuityGoals) setFactFind((prev)=>({
                ...prev,
                goals: {
                    ...prev.goals || {},
                    ...annuityGoals
                }
            }));
    };
    const submit = ()=>{
        setCoupleValidation((0, $ef4d0d82ab48599b$export$fd1af63bea4d2346)(coupleValidation, answers));
        setFactFind((prev)=>({
                ...prev,
                ...(prev.structures || []).length > 0 && answers.structureFunding ? {
                    structureFundingInSuggestions: answers.structureFunding
                } : {}
            }));
        writeAnnuityGoals();
        onLegacyYears(answers.years);
        onDone();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
            "data-testid": "engine-setup-inline",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-[11px] font-bold uppercase tracking-[0.1em] text-slate-500",
                    children: "Before we test the ways to pay"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                    className: "mt-1 text-[22px] font-bold leading-snug tracking-tight text-slate-900",
                    children: [
                        words,
                        " things change the answer. We've filled in what we'd suggest \u2014 change any of them, or just go on."
                    ]
                }),
                onBuildYourOwn && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d7fa4e176455787d$export$b506d3545e935872), {
                    onClick: ()=>{
                        writeAnnuityGoals();
                        onBuildYourOwn(null);
                    },
                    testId: "engine-setup-build-own-top"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mt-6",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef4d0d82ab48599b$export$2e2bcd8739ae039), {
                        value: answers,
                        onChange: setAnswers,
                        factFind: factFind,
                        scenarioLivingExpenses: scenarioLivingExpenses,
                        idPrefix: "setup",
                        roomDeposit: roomDeposit
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mt-6 flex flex-wrap items-center justify-between gap-4 border-t border-slate-200 pt-5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-[13px] text-slate-600",
                            children: [
                                "We'll test a few hundred ways to pay for the room and show the ones that best fit what matters to ",
                                household,
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-3",
                            children: [
                                onBuildYourOwn && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>{
                                        writeAnnuityGoals();
                                        onBuildYourOwn(null);
                                    },
                                    className: "inline-flex items-center gap-2 rounded-xl border border-slate-300 bg-white px-5 py-3 text-[15px] font-semibold text-slate-800 hover:border-blue-300 hover:bg-blue-50",
                                    "data-testid": "engine-setup-build-own",
                                    children: "Build a plan yourself instead"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    onClick: submit,
                                    className: "inline-flex items-center gap-2 rounded-xl bg-blue-600 hover:bg-blue-700 px-5 py-3 text-[15px] font-semibold text-white shadow-md ",
                                    "data-testid": "engine-setup-continue",
                                    children: [
                                        "Show me the plans ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                            size: 16
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $62a77aaf0618af65$export$2e2bcd8739ae039 = $62a77aaf0618af65$var$EngineSetupInline;


/**
 * The four fees, in a minute — the primer at the top of step 1 (UX review, 17 Oct 2026).
 *
 * THE GUIDE IS A LINK, NOT A GATE. "Understanding Aged Care Costs" used to stand in front of every
 * route into the module, including a saved plan. It is good content in the way. So: the first time a
 * client reaches step 1 the primer is open — the room, the basic daily fee, the two means-tested
 * contributions, extras — and after that it collapses to one line they can reopen any time; the full
 * guide stays one click away from every step; every figure that uses a term explains it in the same
 * sentence; and "what's this?" goes to the glossary.
 *
 * THE RULE FOR TERMS (owner, 17 Oct 2026): plain words first, the full name once, the acronym in
 * brackets, and the sentence must make sense with the bracket removed. RAD and DAP are kept, in bold,
 * because the home's quote and the Services Australia letter say them and they recur on every screen;
 * HSC and NCCC follow the everyday names with their full names (owner, 22 Oct 2026).
 *
 * ADAPTS TO THE CLIENT'S RULE SET: a resident on the 1 July 2014 arrangements (the no-worse-off
 * principle) is never shown a fee that is not on their own fee schedule.
 */ 

var $acw62 = parcelRequire("acw62");




/**
 * THE "IN A MINUTE" CARDS, ONE LOOK (owner, 23 Oct 2026: a dash of colour on today's layouts, mock-up v3). Each
 * module keeps its own words and layout; this is what they share: the navy rail down the card, the gradient book
 * chip and navy title, the point names and the one key figure in navy (the figure no larger than the text around
 * it), and one fold control, "Hide" / "Show", in every module.
 */ 
parcelRequire("acw62");


const $e1e942361049df06$export$10832a06bd6966f8 = 'border-l-4 border-l-brand-navy';
const $e1e942361049df06$export$60f4f4563d451e62 = 'text-brand-navy';
const $e1e942361049df06$export$2231117efb2a2550 = 'font-semibold text-brand-navy';
const $e1e942361049df06$export$bcecce3ef3521aa7 = 'shrink-0 rounded-full border border-slate-300 bg-white px-3 py-1 text-[12.5px] font-semibold text-slate-600 hover:border-slate-400 hover:text-slate-900';
const $e1e942361049df06$export$304bcf6dae7e6314 = (open)=>open ? 'Hide' : 'Show';
const $e1e942361049df06$export$d82443bde6f8860 = ({ children: children, as: Tag = 'h2' })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "flex min-w-0 items-center gap-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                icon: (0, $e1cfd183b457f6f1$export$2e2bcd8739ae039),
                tone: "brand",
                variant: "solid",
                size: "sm"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Tag, {
                className: "text-[19px] font-bold text-brand-navy",
                children: children
            })
        ]
    });
const $e1e942361049df06$export$eb5dff254945ec0e = ({ title: title, open: open, onToggle: onToggle, aside: aside = null, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-wrap items-center justify-between gap-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e1e942361049df06$export$d82443bde6f8860, {
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "flex flex-wrap items-center gap-x-4 gap-y-1",
                children: [
                    !open && aside,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onToggle,
                        "aria-expanded": open,
                        className: $e1e942361049df06$export$bcecce3ef3521aa7,
                        "data-testid": testId,
                        children: $e1e942361049df06$export$304bcf6dae7e6314(open)
                    })
                ]
            })
        ]
    });
var $e1e942361049df06$export$2e2bcd8739ae039 = $e1e942361049df06$export$eb5dff254945ec0e;


// The fee in force, to the cent, from the rates file — it moves when the rates are updated (owner, 22 Oct 2026).
const $e08c2354759a67b1$var$dailyFee = `$${(0, $815d7df20c36742b$export$36c4ec5f3f340aef).basicDailyFeeDaily.toLocaleString('en-AU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
})}`;
const $e08c2354759a67b1$var$SEEN_KEY = 'acw.agedCareFeesPrimerSeen';
const $e08c2354759a67b1$var$AgedCareFeesPrimer = ({ oldRules: oldRules = false, onReadGuide: onReadGuide })=>{
    const [open, setOpen] = (0, $acw62.useState)(()=>{
        try {
            return sessionStorage.getItem($e08c2354759a67b1$var$SEEN_KEY) !== '1';
        } catch  {
            return true;
        }
    });
    const toggle = ()=>{
        setOpen((v)=>!v);
        try {
            sessionStorage.setItem($e08c2354759a67b1$var$SEEN_KEY, '1');
        } catch  {}
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
        open: open,
        className: `group rounded-2xl border border-slate-200 ${(0, $e1e942361049df06$export$10832a06bd6966f8)} bg-white shadow-card`,
        "data-testid": "fees-primer",
        onToggle: (e)=>{
            if (e.target.open !== open) toggle();
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("summary", {
                className: "flex cursor-pointer list-none items-center gap-3 px-5 py-3.5 [&::-webkit-details-marker]:hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1e942361049df06$export$d82443bde6f8860), {
                        as: "span",
                        children: open ? 'New to aged care fees? The four fees, in a minute' : "How the fees work \u2014 the four fees, in a minute"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `ml-auto ${(0, $e1e942361049df06$export$bcecce3ef3521aa7)}`,
                        children: (0, $e1e942361049df06$export$304bcf6dae7e6314)(open)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid gap-2.5 px-5 pb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($e08c2354759a67b1$var$Line, {
                        term: "The room",
                        children: [
                            "Every home sets a price for its room. You can pay it up front as a refundable deposit \u2014 a ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Refundable Accommodation Deposit (RAD)"
                            }),
                            ", which comes back when care ends \u2014 or pay it daily, like rent \u2014 a ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Daily Accommodation Payment (DAP)"
                            }),
                            ", which never comes back \u2014 or a mix. Step 3 is where you choose how much of each."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($e08c2354759a67b1$var$Line, {
                        term: "The basic daily fee",
                        children: [
                            "Everyone pays it. It covers meals, cleaning, laundry and the like, and is set by government at ",
                            Math.round((0, $815d7df20c36742b$export$36c4ec5f3f340aef).basicDailyFeeRate * 100),
                            "% of the single Age Pension. It is currently ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                className: (0, $e1e942361049df06$export$2231117efb2a2550),
                                children: [
                                    $e08c2354759a67b1$var$dailyFee,
                                    " a day"
                                ]
                            }),
                            " (about ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $815d7df20c36742b$export$36c4ec5f3f340aef).basicDailyFeeDaily * 365),
                            " a year)."
                        ]
                    }),
                    oldRules ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e08c2354759a67b1$var$Line, {
                        term: "A means-tested care fee",
                        children: 'Because a home care package was in place on 12 September 2024, the "no worse off" rule keeps this person on the 1 July 2014 arrangements: one means-tested care fee, capped each year and over a lifetime, instead of the two contributions newer residents pay. We work it out for you.'
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($e08c2354759a67b1$var$Line, {
                        term: "Two means-tested contributions",
                        children: [
                            "An ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "everyday living contribution"
                            }),
                            " \u2014 on the fee schedule, the Hotelling Supplement Contribution (HSC) \u2014 and a ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "care contribution"
                            }),
                            " \u2014 the Non-Clinical Care Contribution (NCCC). Whether they are paid, and how much, depends on income and assets; both are capped, and we work them out for you."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e08c2354759a67b1$var$Line, {
                        term: "Extras",
                        children: "Some homes charge for optional extras \u2014 a bigger room, a wine list. Only if you choose them."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1 text-[13px] text-slate-500",
                        children: [
                            "You don't need to understand how any of this is calculated; we do that, with the rates in force from ",
                            (0, $1abe73eeef086faf$export$946308c675ba021d).agePension,
                            ".",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: onReadGuide,
                                className: "inline-flex items-center gap-1 font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                        size: 14
                                    }),
                                    " Read the full guide to aged care fees"
                                ]
                            }),
                            ' ',
                            "if you want the detail."
                        ]
                    })
                ]
            })
        ]
    });
};
const $e08c2354759a67b1$var$Line = ({ term: term, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "grid grid-cols-1 gap-1 border-t border-slate-100 pt-2.5 text-[14px] leading-relaxed text-slate-700 md:grid-cols-[200px_minmax(0,1fr)] md:gap-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: `font-bold ${(0, $e1e942361049df06$export$60f4f4563d451e62)}`,
                children: term
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: children
            })
        ]
    });
var $e08c2354759a67b1$export$2e2bcd8739ae039 = $e08c2354759a67b1$var$AgedCareFeesPrimer;



/**
 * "Customise this plan" — a tested aged care plan, in Manual Control's own terms.
 *
 * Before 25 Oct 2026 only the deposit funding carried over, so a plan that also cleared a debt opened
 * with the debt card at $0 and the hand-built figures disagreed with the card the client had just read
 * (short $43,248 against $37,548 on a $15,000 credit card). The debt payoff, its funding and its
 * repayment basis now come across in the same key spaces the engine used (`debtPayoffKey` for the
 * debts, `type-id` for the assets), and a plan that lets the home brings its rent with it.
 *
 * EVERY PART OF THE PLAN (owner, 25 Oct 2026: "Customise this plan" copies the suggested plan and lets
 * them make edits). The home sold or downsized (its sale, the new home, the downsizer contribution),
 * an investment property sold, a reverse mortgage or the Home Equity Access Scheme, the guaranteed
 * income for life, funeral bonds or a gift, and the deposit's drawdown arrangement now come across
 * too, each into the field Manual Control itself keeps it in, so the hand-built figures open equal to
 * the card's. Where the engine funded a lever from two accounts, Manual Control's single "paid from"
 * takes the one that paid most (see `sourceKey`).
 */ 
const $9a6ecfa64a75463a$var$positive = (bag)=>Object.fromEntries(Object.entries(bag || {}).map(([k, v])=>[
            k,
            Number(v) || 0
        ]).filter(([, v])=>v > 0));
const $9a6ecfa64a75463a$var$num = (v)=>v == null || v === '' || !Number.isFinite(Number(v)) ? undefined : Number(v);
/** Manual Control's single "paid from" for a lever the engine funded from a list of accounts: the largest. */ function $9a6ecfa64a75463a$var$sourceKey(sources) {
    const list = Array.isArray(sources) ? sources : [];
    const top = [
        ...list
    ].filter((s)=>s && s.type && s.id != null).sort((a, b)=>(Number(b.amountToTake) || 0) - (Number(a.amountToTake) || 0))[0];
    return top ? {
        key: `${String(top.type)}-${String(top.id)}`,
        type: String(top.type),
        id: String(top.id)
    } : null;
}
function $9a6ecfa64a75463a$var$leversOf(opts, meansTest, ctx) {
    const downsize = opts.downsizeHome === true;
    const sellIp = opts.sellInvestmentProperty === true && !!opts.investmentPropertyDetails;
    const rm = opts.reverseMortgage === true && !!opts.reverseMortgageDetails;
    const heas = opts.heas === true && !!opts.heasDetails;
    const homeValue = Number(ctx.homeValue) || 0;
    const sellingCosts = $9a6ecfa64a75463a$var$num(opts.sellingCosts);
    const type = meansTest?.type;
    const src = $9a6ecfa64a75463a$var$sourceKey(meansTest?.fundingSources);
    const amountOf = (k)=>Math.max(0, Number(meansTest?.[k]) || 0);
    let annuityRecord = null;
    if (type === 'annuity' && amountOf('purchaseAmount') > 0) {
        const owner = meansTest?.ownership === 'partner' ? 'partner' : meansTest?.ownership === 'joint' ? 'joint' : 'client';
        const guaranteed = meansTest?.annuityType === 'guaranteed';
        annuityRecord = {
            id: 'aged-care-annuity',
            annuityType: guaranteed ? 'guaranteed' : 'lifetime',
            purchaseAmount: amountOf('purchaseAmount'),
            residualCapital: guaranteed ? 1 : Math.max(0, Math.min(1, Number(meansTest?.residualCapital) || 0)),
            owner: owner,
            fundingSource: src ? {
                id: src.key,
                type: src.type,
                assetId: src.id,
                label: src.type,
                ownership: owner === 'joint' ? 'joint' : owner
            } : {
                id: 'bank-default',
                type: 'bank',
                assetId: null,
                label: 'Bank accounts / cash',
                ownership: ctx.isCouple ? 'joint' : 'client'
            },
            indexation: meansTest?.indexation === true,
            reversionary: false,
            // Priced on the person who owns it, as the engine prices it.
            age: owner === 'partner' ? ctx.partnerAge ?? null : ctx.clientAge ?? null,
            partnerAge: ctx.isCouple ? owner === 'partner' ? ctx.clientAge ?? null : ctx.partnerAge ?? null : null,
            ...$9a6ecfa64a75463a$var$num(meansTest?.incomeOverride) ? {
                incomeOverride: $9a6ecfa64a75463a$var$num(meansTest?.incomeOverride)
            } : {}
        };
    }
    const drawdown = opts.radDrawdown;
    return {
        overallStrategy: {
            rentHome: opts.rentHome === true,
            downsizeHome: downsize,
            accessHomeEquity: rm || heas || opts.accessHomeEquity === true,
            reverseMortgage: rm,
            heas: heas,
            sellInvestmentProperty: sellIp
        },
        strategyInputs: {
            ...opts.rentHome === true && $9a6ecfa64a75463a$var$num(opts.rentAmount) != null ? {
                rentAmount: $9a6ecfa64a75463a$var$num(opts.rentAmount)
            } : {},
            ...opts.rentHome === true && $9a6ecfa64a75463a$var$num(opts.rentExpenses) != null ? {
                rentExpenses: $9a6ecfa64a75463a$var$num(opts.rentExpenses)
            } : {}
        },
        downsizeDetails: downsize ? {
            // The engine sells the home at its value and carries the selling costs beside the details.
            salePrice: homeValue,
            ...sellingCosts != null ? {
                sellingCosts: sellingCosts
            } : {},
            ...opts.downsizeDetails || {}
        } : null,
        investmentPropertyDetails: sellIp ? {
            ...opts.investmentPropertyDetails
        } : null,
        reverseMortgageDetails: rm ? {
            ...opts.reverseMortgageDetails
        } : null,
        heasDetails: heas ? {
            ...opts.heasDetails
        } : null,
        otherStrategies: {
            gifting: type === 'gifting' && amountOf('amount') > 0,
            giftingAmount: type === 'gifting' ? amountOf('amount') : 0,
            giftingSource: type === 'gifting' && src ? src.key : 'bankAccounts',
            funeralBonds: type === 'funeralBonds' && amountOf('amount') > 0,
            funeralBondAmount: type === 'funeralBonds' ? amountOf('amount') : 0,
            funeralBondSource: type === 'funeralBonds' && src ? src.key : 'bankAccounts',
            annuity: !!annuityRecord
        },
        annuityRecord: annuityRecord,
        radDrawdown: drawdown === 'fees' || drawdown === 'dap' || drawdown === 'none' ? drawdown : null,
        scenarioLivingExpenses: $9a6ecfa64a75463a$var$num(opts.scenarioLivingExpenses) ?? null
    };
}
function $9a6ecfa64a75463a$export$fe486fe4085be145(row, ctx = {}) {
    const r = row || {};
    const opts = r.strategyOptions || {};
    const payoff = opts.debtPayoff || null;
    const keepsOrLets = opts.downsizeHome !== true && !opts.sellInvestmentProperty && !opts.reverseMortgage && !opts.heas;
    return {
        radFunding: r.radFunding ? (0, $c549af0b979cab3f$export$9ca4abb860f88bf9)(r.radFunding) : {},
        debtPayments: $9a6ecfa64a75463a$var$positive(payoff?.payments),
        debtFunding: $9a6ecfa64a75463a$var$positive(payoff?.funding),
        debtRepaymentBasis: payoff?.repaymentBasis === 'lower_repayment' ? 'lower_repayment' : 'keep_repayment',
        home: !row || !keepsOrLets || typeof opts.rentHome !== 'boolean' ? null : opts.rentHome ? {
            rentHome: true,
            ...Number(opts.rentAmount) > 0 ? {
                rentAmount: Number(opts.rentAmount)
            } : {},
            ...Number(opts.rentExpenses) >= 0 && opts.rentExpenses != null ? {
                rentExpenses: Number(opts.rentExpenses)
            } : {}
        } : {
            rentHome: false
        },
        levers: row ? $9a6ecfa64a75463a$var$leversOf(opts, r.meansTestStrategy || null, ctx) : null
    };
}



/**
 * ReverseMortgageStrategyAllocator.tsx – reverse mortgage details (loan amount, LVR, interest, structure, equity impact).
 * Used by AgedCareAnalyser in App.js. Props: factFind, details, setDetails, legacyYears (optional).
 */ 

var $acw62 = parcelRequire("acw62");





// The deeming figures in the help text come from the live rate table, so an indexation cannot leave
// the screen quoting last year's (it did, for two indexations).
const $61659eb07ec5d982$var$deemingLowerPct = `${((0, $1abe73eeef086faf$export$7ccf16e55e6cf86b) * 100).toFixed(2)}%`;
const $61659eb07ec5d982$var$deemingUpperPct = `${((0, $1abe73eeef086faf$export$fe9b80c24d06bb6b) * 100).toFixed(2)}%`;
function $61659eb07ec5d982$var$ReverseMortgageStrategyAllocator({ factFind: factFind, details: details, setDetails: setDetails, legacyYears: legacyYearsProp }) {
    const [isEducationExpanded, setIsEducationExpanded] = (0, $acw62.useState)(false);
    const legacyYears = legacyYearsProp ?? 5;
    const handleDetailChange = (field, value)=>{
        if (field === 'loanPercentage') {
            const roundedPercentage = Math.round(parseFloat(value) || 0);
            const homeValue = parseFloat(String(factFind.home?.value)) || 0;
            const loanAmount = homeValue * (roundedPercentage / 100);
            setDetails((prev)=>({
                    ...prev,
                    loanPercentage: roundedPercentage,
                    loanAmount: loanAmount
                }));
        } else if (field === 'loanAmount') {
            const num = value === '' || value === undefined ? 0 : Number(value);
            const loanAmount = Number.isFinite(num) ? Math.max(0, num) : 0;
            const homeValue = parseFloat(String(factFind.home?.value)) || 0;
            setDetails((prev)=>{
                const next = {
                    ...prev,
                    loanAmount: loanAmount
                };
                if (homeValue > 0) next.loanPercentage = Math.round(loanAmount / homeValue * 100);
                return next;
            });
        } else if (field === 'establishmentFees' || field === 'regularPaymentAmount') {
            const num = value === '' || value === undefined ? 0 : Number(value);
            const n = Number.isFinite(num) ? Math.max(0, num) : 0;
            setDetails((prev)=>({
                    ...prev,
                    [field]: n
                }));
        } else if (field === 'interestRate') setDetails((prev)=>({
                ...prev,
                [field]: parseFloat(value) || 0
            }));
        else setDetails((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    const homeValue = parseFloat(String(factFind.home?.value)) || 0;
    const clientAge = (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client?.dob) ?? 0;
    const partnerAge = factFind.adviceFor === 'couple' ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner?.dob) : null;
    const youngestAge = partnerAge ? Math.min(clientAge, partnerAge) : clientAge;
    const getMaxLVR = (age)=>{
        if (age >= 80) return 50;
        if (age >= 75) return 45;
        if (age >= 70) return 40;
        if (age >= 65) return 30;
        if (age >= 60) return 20;
        return 15;
    };
    const maxLVR = getMaxLVR(youngestAge);
    const maxLoanAmount = homeValue * (maxLVR / 100);
    const currentLoanAmount = Number(details.loanAmount) || 0;
    const currentLoanPercentage = Number(details.loanPercentage) || 0;
    const exceedsLimit = currentLoanPercentage > maxLVR;
    const homeGrowthRate = parseFloat(String(factFind.home?.homeGrowthRate)) || 5;
    const initialLoanBalance = currentLoanAmount || 0;
    const interestRate = parseFloat(String(details.interestRate)) || (0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279);
    let projectedHomeValueWithRM = homeValue;
    let projectedLoanBalance = initialLoanBalance;
    for(let year = 1; year <= legacyYears; year++){
        projectedHomeValueWithRM = projectedHomeValueWithRM * (1 + homeGrowthRate / 100);
        projectedLoanBalance = projectedLoanBalance * (1 + interestRate / 100);
        if (details.loanStructure === 'regular_payments' && year >= 1) {
            const paymentAmount = parseFloat(String(details.regularPaymentAmount)) || 0;
            const frequency = details.regularPaymentFrequency || 'fortnightly';
            const annualPayment = frequency === 'fortnightly' ? paymentAmount * 26 : paymentAmount * 12;
            projectedLoanBalance += annualPayment;
        }
    }
    let projectedHomeValueNoRM = homeValue;
    for(let year = 1; year <= legacyYears; year++)projectedHomeValueNoRM = projectedHomeValueNoRM * (1 + homeGrowthRate / 100);
    const projectedEquityWithRM = Math.max(0, projectedHomeValueWithRM - projectedLoanBalance);
    const projectedEquityNoRM = projectedHomeValueNoRM;
    const equityDifference = projectedEquityNoRM - projectedEquityWithRM;
    const equityPercentageOwned = initialLoanBalance > 0 ? projectedEquityWithRM / projectedHomeValueWithRM * 100 : 100;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-4 p-4 bg-gray-50 rounded-lg border space-y-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                className: "font-semibold text-lg",
                children: "Reverse Mortgage Details"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border border-gray-200 rounded-lg overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: ()=>setIsEducationExpanded(!isEducationExpanded),
                        className: "w-full p-4 bg-white border border-slate-200 transition-all duration-200 flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h5", {
                                className: "font-semibold text-gray-900 flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                        className: "w-5 h-5 text-blue-600"
                                    }),
                                    "What is a Reverse Mortgage?"
                                ]
                            }),
                            isEducationExpanded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-gray-600 transform rotate-180 transition-transform"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-gray-600 transition-transform"
                            })
                        ]
                    }),
                    isEducationExpanded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "p-4 bg-white border-t border-gray-200 space-y-3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-sm text-gray-700 space-y-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        "A ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "reverse mortgage"
                                        }),
                                        " is a loan that allows you to access the equity in your home without making regular repayments. Instead, interest compounds on the loan balance, and the loan is typically repaid when you sell the home, move into aged care, or pass away."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-semibold mb-2",
                                            children: "Loan Structure Options:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "space-y-3 pl-4 border-l-2 border-blue-200",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "font-medium text-blue-700",
                                                            children: "1. Lump Sum"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-xs text-gray-600 mt-1",
                                                            children: "You receive the full loan amount upfront. This gives you immediate access to cash, which can be used for large expenses like paying a RAD deposit. The entire loan amount immediately starts accruing compound interest, so your loan balance grows faster from the start."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "font-medium text-blue-700",
                                                            children: "2. Regular Payments"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-xs text-gray-600 mt-1",
                                                            children: "You receive regular payments (fortnightly or monthly) over time. This provides a steady income stream but may be more expensive as the loan balance accumulates with each payment. Each payment increases your loan balance, which then compounds with interest."
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "How it works:"
                                        }),
                                        " The loan balance grows over time due to compound interest, which means your home equity (the difference between your home's value and the loan balance) decreases over time."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-4 p-3 bg-white border border-blue-200 rounded-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-semibold text-blue-900 mb-2",
                                            children: "Impact on Age Pension:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-xs text-gray-700 mb-2",
                                            children: [
                                                "When you receive reverse mortgage proceeds (lump sum or regular payments), these funds are added to your assessable assets for the Age Pension means test. The loan proceeds are subject to deeming rules, which means Centrelink assumes they earn income at prescribed rates (currently ",
                                                $61659eb07ec5d982$var$deemingLowerPct,
                                                " for the first ",
                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$63f1528eb9e21fc5).single),
                                                "for singles or ",
                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$63f1528eb9e21fc5).couple),
                                                " for pensioner couples, and ",
                                                $61659eb07ec5d982$var$deemingUpperPct,
                                                " above those thresholds). This deemed income is included in the Age Pension income test, which can reduce or eliminate your Age Pension entitlement."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-xs text-gray-700",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Important:"
                                                }),
                                                " If you use the loan proceeds to pay a RAD (Refundable Accommodation Deposit), the RAD is exempt from the Age Pension assets test, so this may minimise the impact on your pension. However, if the proceeds remain in your bank account or other investments, they will be fully assessable."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-3 p-3 bg-white border border-blue-200 rounded-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-semibold text-blue-900 mb-2",
                                            children: "Impact on Aged Care Assessment:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-xs text-gray-700 mb-2",
                                            children: "For aged care cost calculations, reverse mortgage proceeds are treated as assessable assets:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                            className: "text-xs text-gray-700 list-disc list-inside space-y-1 mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "HSC (Hotelling Supplement Contribution):"
                                                        }),
                                                        " If loan proceeds increase your assessable assets, this may increase your HSC contribution. The HSC is calculated based on your Means Tested Amount (MTA), which considers both your income and assets. Higher assets mean a higher MTA, potentially increasing your HSC."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "NCCC (Needs-Based Care Contribution):"
                                                        }),
                                                        " Similar to HSC, if reverse mortgage proceeds increase your assessable assets, this may increase your NCCC. The NCCC is also calculated based on your MTA, so higher assets can result in higher care contributions."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-xs text-gray-700",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Strategy consideration:"
                                                }),
                                                " Using reverse mortgage proceeds to pay a RAD can be beneficial because: (1) The RAD is exempt from the Age Pension assets test, and (2) The RAD reduces your DAP (Daily Accommodation Payment), which may offset increased HSC/NCCC costs."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mt-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Key considerations:"
                                        }),
                                        " Reverse mortgages can provide access to funds for living expenses, home modifications, or aged care costs, but they reduce the equity available for your estate or future needs. The loan must be repaid when the property is sold or you move permanently."
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            exceedsLimit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "p-3 bg-red-50 border-l-4 border-red-400 rounded-r-lg text-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-red-700 font-semibold",
                        children: [
                            "\u26A0\uFE0F Warning: Your loan amount exceeds typical lender limits for your age (",
                            youngestAge,
                            ")."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-red-600 mt-1 text-xs",
                        children: [
                            "Most lenders restrict reverse mortgages to a maximum of ",
                            maxLVR,
                            "% of home value (",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(maxLoanAmount),
                            ") based on the youngest borrower's age. Consider consulting a financial adviser."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Loan Amount ($)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                value: details.loanAmount ?? '',
                                onChange: (v)=>handleDetailChange('loanAmount', String(v)),
                                placeholder: "0",
                                className: ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2",
                                children: [
                                    "Loan Percentage (%)",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                        text: "This shows what percentage of your home's current value the loan amount represents. For example, if your home is worth $3,000,000 and you borrow $500,000, that's 17% of your home value."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "number",
                                value: Math.round(Number(details.loanPercentage) || 0),
                                onChange: (e)=>handleDetailChange('loanPercentage', e.target.value),
                                className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent",
                                placeholder: "0",
                                max: maxLVR
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Interest Rate (% p.a.)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "number",
                                step: "0.1",
                                value: details.interestRate || (0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279),
                                onChange: (e)=>handleDetailChange('interestRate', e.target.value),
                                className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Loan Structure"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: details.loanStructure || 'lump_sum',
                                onChange: (e)=>handleDetailChange('loanStructure', e.target.value),
                                className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "lump_sum",
                                        children: "Lump Sum"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "regular_payments",
                                        children: "Regular Payments"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            details.loanStructure === 'regular_payments' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Payment Amount ($)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                value: details.regularPaymentAmount ?? '',
                                onChange: (v)=>handleDetailChange('regularPaymentAmount', String(v)),
                                placeholder: "0",
                                className: ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Payment Frequency"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: details.regularPaymentFrequency || 'fortnightly',
                                onChange: (e)=>handleDetailChange('regularPaymentFrequency', e.target.value),
                                className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "fortnightly",
                                        children: "Fortnightly"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "monthly",
                                        children: "Monthly"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2",
                        children: [
                            "Establishment Fees ($)",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                text: "One-time fees charged by the lender to set up the reverse mortgage. These fees are typically deducted from the loan proceeds, reducing the net amount you receive. Common fees include application fees, valuation fees, and legal fees."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        value: details.establishmentFees ?? '',
                        onChange: (v)=>handleDetailChange('establishmentFees', String(v)),
                        placeholder: "0",
                        className: ""
                    })
                ]
            }),
            details.loanStructure === 'lump_sum' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "p-4 bg-white border-2 border-blue-400 rounded-lg shadow-sm",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-start gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "checkbox",
                            id: "useReverseMortgageForRad",
                            checked: details.useForRad || false,
                            onChange: (e)=>setDetails((prev)=>({
                                        ...prev,
                                        useForRad: e.target.checked
                                    })),
                            className: "h-6 w-6 rounded border-2 border-blue-600 text-blue-600 focus:ring-blue-500 mt-0.5 flex-shrink-0"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "useReverseMortgageForRad",
                                    className: "text-base font-bold text-blue-900 cursor-pointer block mb-1",
                                    children: "Use this loan amount to fund the RAD?"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-gray-700",
                                    children: "If checked, the loan amount will be allocated to pay the Refundable Accommodation Deposit (RAD), reducing your Daily Accommodation Payment (DAP). Any remaining loan amount after RAD payment will go to your bank account."
                                })
                            ]
                        })
                    ]
                })
            }),
            initialLoanBalance > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                        className: "font-semibold text-gray-900 text-lg",
                        children: "Impact on Home Equity"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "p-4 bg-white border-2 border-blue-200 rounded-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h6", {
                                        className: "font-semibold text-blue-900 mb-3 flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e71d8988c230db1b$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4"
                                            }),
                                            "With Reverse Mortgage"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center justify-between mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-sm text-gray-700",
                                                        children: "Home Equity Ownership"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-lg font-bold text-blue-700",
                                                        children: [
                                                            equityPercentageOwned.toFixed(1),
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-full bg-gray-200 rounded-full h-6 overflow-hidden",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "bg-blue-600 h-6 flex items-center justify-end pr-2 transition-all duration-500",
                                                    style: {
                                                        width: `${Math.min(100, equityPercentageOwned)}%`
                                                    },
                                                    children: equityPercentageOwned > 15 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-xs font-semibold text-white",
                                                        children: [
                                                            equityPercentageOwned.toFixed(1),
                                                            "%"
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-2 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-600",
                                                        children: "Projected Home Value:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-medium",
                                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(projectedHomeValueWithRM)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-600",
                                                        children: "Loan Balance:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "font-medium text-red-600",
                                                        children: [
                                                            "-",
                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(projectedLoanBalance)
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between pt-2 border-t border-blue-200",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-semibold text-gray-900",
                                                        children: "Your Equity:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold text-blue-700",
                                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(projectedEquityWithRM)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "p-4 bg-white border-2 border-green-200 rounded-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h6", {
                                        className: "font-semibold text-green-900 mb-3 flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4"
                                            }),
                                            "Without Reverse Mortgage"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center justify-between mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-sm text-gray-700",
                                                        children: "Home Equity Ownership"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-lg font-bold text-green-700",
                                                        children: "100%"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-full bg-gray-200 rounded-full h-6 overflow-hidden",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "bg-emerald-600 h-6 flex items-center justify-end pr-2",
                                                    style: {
                                                        width: '100%'
                                                    },
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-xs font-semibold text-white",
                                                        children: "100%"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-2 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-600",
                                                        children: "Projected Home Value:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-medium",
                                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(projectedHomeValueNoRM)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-600",
                                                        children: "Loan Balance:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-medium text-gray-400",
                                                        children: "$0"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between pt-2 border-t border-green-200",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-semibold text-gray-900",
                                                        children: "Your Equity:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold text-green-700",
                                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(projectedEquityNoRM)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-4 bg-gray-50 border border-gray-300 rounded-lg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center justify-between mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "font-semibold text-gray-900",
                                        children: [
                                            "Equity Impact After ",
                                            legacyYears,
                                            " Years:"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-lg font-bold text-red-600",
                                        children: [
                                            "-",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(equityDifference)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-gray-600 mb-3",
                                children: [
                                    "By taking out a reverse mortgage, your home equity will be ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(equityDifference),
                                            " less"
                                        ]
                                    }),
                                    " after ",
                                    legacyYears,
                                    " years compared to not taking the loan."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-2 gap-4 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-gray-600",
                                                children: "With Reverse Mortgage:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-semibold text-blue-700 ml-2",
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(projectedEquityWithRM)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-gray-600",
                                                children: "Without Reverse Mortgage:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-semibold text-green-700 ml-2",
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(projectedEquityNoRM)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-xs text-gray-500 mt-3",
                                children: [
                                    "Note: This projection assumes home growth at ",
                                    homeGrowthRate,
                                    "% p.a. and loan interest at ",
                                    interestRate,
                                    '% p.a. Actual results may vary. Use the "View Projections" button for a detailed analysis including all assets.'
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-4 bg-gray-50 border-l-4 border-gray-400 rounded-r-lg text-sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "font-semibold text-gray-900 mb-2",
                                children: "Additional Considerations:"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                className: "list-disc list-inside space-y-1 text-gray-700",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "Compound interest will erode your home equity over time"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "Loan balance grows faster as you age"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "May reduce equity available for aged care accommodation payments"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "Limited flexibility to move or refinance"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "Loan proceeds may be assessable for Age Pension assets test"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $61659eb07ec5d982$export$2e2bcd8739ae039 = $61659eb07ec5d982$var$ReverseMortgageStrategyAllocator;


/**
 * HEASStrategyAllocator.tsx – Home Equity Access Scheme details (payment amount, frequency, equity impact).
 * Used by AgedCareAnalyser in App.js. Props: factFind, details, setDetails, legacyYears (optional).
 */ 

var $acw62 = parcelRequire("acw62");




function $4b4d65f6d87c2260$var$HEASStrategyAllocator({ factFind: factFind, details: details, setDetails: setDetails, legacyYears: legacyYearsProp }) {
    const [isEducationExpanded, setIsEducationExpanded] = (0, $acw62.useState)(false);
    const legacyYears = legacyYearsProp ?? 5;
    const handleDetailChange = (field, value)=>{
        if (field === 'paymentAmount') {
            const num = value === '' || value === undefined ? 0 : Number(value);
            setDetails((prev)=>({
                    ...prev,
                    paymentAmount: Number.isFinite(num) ? Math.max(0, num) : 0
                }));
        } else setDetails((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    const [isOnAgePension, setIsOnAgePension] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind).then((financials)=>{
            if (!cancelled) setIsOnAgePension((Number(financials.socialSecurity) || 0) > 0);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind
    ]);
    const relationshipStatus = factFind.adviceFor === 'couple' ? 'couple' : 'single';
    const maxPensionRate = (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0)[relationshipStatus] || (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single;
    const maxHEASPayment = maxPensionRate * 1.5;
    const maxHEASPaymentFortnightly = maxPensionRate / 26 * 1.5;
    const annualPaymentAmount = details.paymentFrequency === 'fortnightly' ? (Number(details.paymentAmount) || 0) * 26 : (Number(details.paymentAmount) || 0) * 12;
    const homeValue = parseFloat(String(factFind.home?.value)) || 0;
    const homeGrowthRate = parseFloat(String(factFind.home?.homeGrowthRate)) || 5;
    const interestRate = parseFloat(String(details.interestRate)) || 3.95;
    let projectedHomeValueWithHEAS = homeValue;
    let projectedHEASLoanBalance = 0;
    for(let year = 1; year <= legacyYears; year++){
        projectedHomeValueWithHEAS = projectedHomeValueWithHEAS * (1 + homeGrowthRate / 100);
        projectedHEASLoanBalance = projectedHEASLoanBalance * (1 + interestRate / 100);
        projectedHEASLoanBalance += annualPaymentAmount;
    }
    let projectedHomeValueNoHEAS = homeValue;
    for(let year = 1; year <= legacyYears; year++)projectedHomeValueNoHEAS = projectedHomeValueNoHEAS * (1 + homeGrowthRate / 100);
    const projectedEquityWithHEAS = Math.max(0, projectedHomeValueWithHEAS - projectedHEASLoanBalance);
    const projectedEquityNoHEAS = projectedHomeValueNoHEAS;
    const equityDifference = projectedEquityNoHEAS - projectedEquityWithHEAS;
    const equityPercentageOwned = annualPaymentAmount > 0 ? projectedEquityWithHEAS / projectedHomeValueWithHEAS * 100 : 100;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-4 p-4 bg-gray-50 rounded-lg border space-y-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                className: "font-semibold text-lg",
                children: "Home Equity Access Scheme (HEAS) Details"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border border-gray-200 rounded-lg overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: ()=>setIsEducationExpanded(!isEducationExpanded),
                        className: "w-full p-4 bg-white border border-slate-200 transition-all duration-200 flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h5", {
                                className: "font-semibold text-gray-900 flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                        className: "w-5 h-5 text-blue-600"
                                    }),
                                    "What is HEAS?"
                                ]
                            }),
                            isEducationExpanded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-gray-600 transform rotate-180 transition-transform"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-gray-600 transition-transform"
                            })
                        ]
                    }),
                    isEducationExpanded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "p-4 bg-white border-t border-gray-200 space-y-3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-sm text-gray-700 space-y-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        "The ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Home Equity Access Scheme (HEAS)"
                                        }),
                                        " is a government program that allows Age Pension recipients to access equity in their home through a loan scheme. Unlike commercial reverse mortgages, HEAS is administered by Services Australia (Centrelink) and offers a lower interest rate (currently ",
                                        details.interestRate,
                                        "% p.a.) and specific eligibility requirements."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "p-3 bg-white border border-blue-200 rounded-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-semibold text-blue-900 mb-2",
                                            children: "Key Differences from Commercial Reverse Mortgages:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                            className: "text-xs text-gray-700 space-y-2 list-disc list-inside",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Lower interest rate:"
                                                        }),
                                                        " HEAS charges ",
                                                        details.interestRate,
                                                        "% p.a. (government-set), compared to typically 6-8%+ for commercial reverse mortgages."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Age Pension requirement:"
                                                        }),
                                                        " You must be receiving or eligible for Age Pension to access HEAS."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Dollar-for-dollar reduction:"
                                                        }),
                                                        " HEAS payments reduce your Age Pension dollar-for-dollar, meaning you receive the payment but your pension is reduced by the same amount."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Payment flexibility:"
                                                        }),
                                                        " You can start and stop HEAS payments as needed, providing more control over your cash flow."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Maximum payment:"
                                                        }),
                                                        " HEAS is limited to 150% of the maximum Age Pension rate (currently ",
                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(maxHEASPayment),
                                                        " per year)."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Government-backed:"
                                                        }),
                                                        " HEAS is administered by Services Australia, providing security and transparency."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "How it works:"
                                        }),
                                        " You receive regular payments (fortnightly or monthly) from the government, which are added to a loan secured against your home. The loan balance compounds at ",
                                        details.interestRate,
                                        "% p.a. and reduces your home equity over time. Your Age Pension is reduced by the exact amount of each payment, so you're essentially borrowing against your home equity rather than receiving additional income."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-4 p-3 bg-white border border-blue-200 rounded-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-semibold text-blue-900 mb-2",
                                            children: "Impact on Age Pension:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-xs text-gray-700 mb-2",
                                            children: [
                                                "HEAS payments reduce your Age Pension dollar-for-dollar",
                                                annualPaymentAmount > 0 ? `. This means if you receive ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(annualPaymentAmount)} per year from HEAS, your Age Pension will be reduced by ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(annualPaymentAmount)} per year.` : '',
                                                " While this may seem counterintuitive, HEAS can still be beneficial because:"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                            className: "text-xs text-gray-700 space-y-1 list-disc list-inside",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "You receive the payment immediately (rather than waiting for pension payments)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        "The loan balance grows at a lower rate (",
                                                        details.interestRate,
                                                        "% p.a.) than many commercial options"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "You maintain control over when and how much you draw"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "HEAS payments are not assessable for Age Pension means test (they're treated as a loan, not income)"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-3 p-3 bg-white border border-blue-200 rounded-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-semibold text-blue-900 mb-2",
                                            children: "Impact on Aged Care Assessment:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-xs text-gray-700 mb-2",
                                            children: "HEAS payments are treated as assessable income for aged care cost calculations:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                            className: "text-xs text-gray-700 list-disc list-inside space-y-1 mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "HSC (Hotelling Supplement Contribution):"
                                                        }),
                                                        " HEAS payments increase your assessable income, which may increase your HSC contribution. The HSC is calculated based on your Means Tested Amount (MTA), which considers both income and assets."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "NCCC (Needs-Based Care Contribution):"
                                                        }),
                                                        " Similar to HSC, HEAS payments as assessable income may increase your NCCC, as it's also calculated based on your MTA."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-xs text-gray-700",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Note:"
                                                }),
                                                " The HEAS loan balance itself is a liability secured against your home, but the regular payments you receive are treated as income for means testing purposes."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Key considerations:"
                                        }),
                                        " HEAS can provide access to home equity for Age Pension recipients, but it reduces your home equity over time through compound interest. The loan must be repaid when the property is sold or you move permanently. You can start and stop payments as needed, providing flexibility in managing your cash flow."
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            !isOnAgePension && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "p-3 bg-red-50 border-l-4 border-red-400 rounded-r-lg text-sm",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-red-800 font-semibold",
                    children: "\u26A0\uFE0F Eligibility Requirement: You must be receiving Age Pension or be eligible for Age Pension to access HEAS."
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "p-3 bg-white border-l-4 border-blue-400 rounded-r-lg text-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-blue-700",
                                children: "Maximum Available:"
                            }),
                            " ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(maxHEASPaymentFortnightly),
                            " per fortnight (",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(maxHEASPayment),
                            " per year) - 150% of maximum Age Pension rate"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-blue-700",
                                children: "Interest Rate:"
                            }),
                            " ",
                            details.interestRate,
                            "% p.a. (compound) - Government-set rate"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Payment Amount ($)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "number",
                                value: details.paymentAmount || '',
                                onChange: (e)=>handleDetailChange('paymentAmount', e.target.value),
                                className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent",
                                placeholder: "0",
                                max: details.paymentFrequency === 'fortnightly' ? maxHEASPaymentFortnightly : maxHEASPayment / 12
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-xs text-gray-500 mt-1",
                                children: [
                                    "Max: ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(details.paymentFrequency === 'fortnightly' ? maxHEASPaymentFortnightly : maxHEASPayment / 12),
                                    " per ",
                                    details.paymentFrequency === 'fortnightly' ? 'fortnight' : 'month'
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Payment Frequency"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: details.paymentFrequency || 'fortnightly',
                                onChange: (e)=>handleDetailChange('paymentFrequency', e.target.value),
                                className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "fortnightly",
                                        children: "Fortnightly"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "monthly",
                                        children: "Monthly"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "p-3 bg-white border-l-4 border-green-400 rounded-r-lg text-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-green-700",
                                children: "Annual Payment:"
                            }),
                            " ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(annualPaymentAmount)
                        ]
                    }),
                    isOnAgePension && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-green-700",
                                children: "Age Pension Impact:"
                            }),
                            " Your Age Pension will be reduced by ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(annualPaymentAmount),
                            " per year (dollar-for-dollar reduction)"
                        ]
                    })
                ]
            }),
            annualPaymentAmount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                        className: "font-semibold text-gray-900 text-lg",
                        children: "Impact on Home Equity"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "p-4 bg-white border-2 border-blue-200 rounded-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h6", {
                                        className: "font-semibold text-blue-900 mb-3 flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e71d8988c230db1b$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4"
                                            }),
                                            "With HEAS"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center justify-between mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-sm text-gray-700",
                                                        children: "Home Equity Ownership"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-lg font-bold text-blue-700",
                                                        children: [
                                                            equityPercentageOwned.toFixed(1),
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-full bg-gray-200 rounded-full h-6 overflow-hidden",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "bg-blue-600 h-6 flex items-center justify-end pr-2 transition-all duration-500",
                                                    style: {
                                                        width: `${Math.min(100, equityPercentageOwned)}%`
                                                    },
                                                    children: equityPercentageOwned > 15 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-xs font-semibold text-white",
                                                        children: [
                                                            equityPercentageOwned.toFixed(1),
                                                            "%"
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-2 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-600",
                                                        children: "Projected Home Value:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-medium",
                                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(projectedHomeValueWithHEAS)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-600",
                                                        children: "HEAS Loan Balance:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "font-medium text-red-600",
                                                        children: [
                                                            "-",
                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(projectedHEASLoanBalance)
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between pt-2 border-t border-blue-200",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-semibold text-gray-900",
                                                        children: "Your Equity:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold text-blue-700",
                                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(projectedEquityWithHEAS)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "p-4 bg-white border-2 border-green-200 rounded-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h6", {
                                        className: "font-semibold text-green-900 mb-3 flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4"
                                            }),
                                            "Without HEAS"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center justify-between mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-sm text-gray-700",
                                                        children: "Home Equity Ownership"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-lg font-bold text-green-700",
                                                        children: "100%"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-full bg-gray-200 rounded-full h-6 overflow-hidden",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "bg-emerald-600 h-6 flex items-center justify-end pr-2",
                                                    style: {
                                                        width: '100%'
                                                    },
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-xs font-semibold text-white",
                                                        children: "100%"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-2 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-600",
                                                        children: "Projected Home Value:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-medium",
                                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(projectedHomeValueNoHEAS)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-600",
                                                        children: "HEAS Loan Balance:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-medium text-gray-400",
                                                        children: "$0"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between pt-2 border-t border-green-200",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-semibold text-gray-900",
                                                        children: "Your Equity:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold text-green-700",
                                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(projectedEquityNoHEAS)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-4 bg-gray-50 border border-gray-300 rounded-lg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center justify-between mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "font-semibold text-gray-900",
                                        children: [
                                            "Equity Impact After ",
                                            legacyYears,
                                            " Years:"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-lg font-bold text-red-600",
                                        children: [
                                            "-",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(equityDifference)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-gray-600 mb-3",
                                children: [
                                    "By accessing HEAS, your home equity will be ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(equityDifference),
                                            " less"
                                        ]
                                    }),
                                    " after ",
                                    legacyYears,
                                    " years compared to not accessing the scheme."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-2 gap-4 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-gray-600",
                                                children: "With HEAS:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-semibold text-blue-700 ml-2",
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(projectedEquityWithHEAS)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-gray-600",
                                                children: "Without HEAS:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-semibold text-green-700 ml-2",
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(projectedEquityNoHEAS)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-xs text-gray-500 mt-3",
                                children: [
                                    "Note: This projection assumes home growth at ",
                                    homeGrowthRate,
                                    "% p.a. and HEAS interest at ",
                                    interestRate,
                                    '% p.a. Actual results may vary. Use the "View Projections" button for a detailed analysis including all assets.'
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-4 bg-gray-50 border-l-4 border-gray-400 rounded-r-lg text-sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "font-semibold text-gray-900 mb-2",
                                children: "Additional Considerations:"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                className: "list-disc list-inside space-y-1 text-gray-700",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "HEAS payments reduce Age Pension dollar-for-dollar"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        children: [
                                            "Interest compounds at ",
                                            details.interestRate,
                                            "% p.a., reducing your estate value"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "Home must remain your principal residence"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "You can start and stop payments as needed"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "Lower interest rate than commercial reverse mortgages"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "HEAS payments are assessable income for aged care cost calculations (HSC and NCCC)"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $4b4d65f6d87c2260$export$2e2bcd8739ae039 = $4b4d65f6d87c2260$var$HEASStrategyAllocator;





var $acw62 = parcelRequire("acw62");


const $a47f01df2d11b1bc$var$FinancialImpactPanel = ({ before: before, after: after, agedCareCosts: agedCareCosts, legacyYears: legacyYears, setLegacyYears: setLegacyYears, onViewProjections: onViewProjections, projections: projections, cashFlowAfterValue: cashFlowAfterValue, cashFlowBeforeValue: cashFlowBeforeValue, cashFlowBreakdownOverride: cashFlowBreakdownOverride, pensionBreakdownOverride: pensionBreakdownOverride, netWorthAfterValue: netWorthAfterValue, netWorthBreakdownOverride: netWorthBreakdownOverride, legacyEstimateOverride: legacyEstimateOverride, legacyBaselineValue: legacyBaselineValue = null, baselineLabel: baselineLabel, legacyBreakdownOverride: legacyBreakdownOverride, embedded: embedded = false, baselineOnly: baselineOnly = false, legacyTitle: legacyTitle = "What's left to the family", working: working = false })=>{
    /** Whether the "Annual Position vs View Projections" explanation is open. Collapsed by default. */ const [basisExplainerOpen, setBasisExplainerOpen] = (0, $acw62.useState)(false);
    const annualAgedCareCost = agedCareCosts?.totalDailyCost ? agedCareCosts.totalDailyCost * 365 : 0;
    const afterCashFlowWithCareCosts = cashFlowAfterValue != null ? cashFlowAfterValue : after.cashFlow - annualAgedCareCost;
    const cashFlowBreakdownWithCare = (0, $acw62.useMemo)(()=>{
        if (cashFlowBreakdownOverride) return cashFlowBreakdownOverride;
        if (!after.cashFlowBreakdown) return [];
        if (!annualAgedCareCost) return after.cashFlowBreakdown;
        return [
            ...after.cashFlowBreakdown,
            {
                label: '--- Aged Care Costs ---',
                value: ''
            },
            {
                label: 'Less: Annual Care Fees',
                value: -annualAgedCareCost
            }
        ];
    }, [
        after.cashFlowBreakdown,
        annualAgedCareCost,
        cashFlowBreakdownOverride
    ]);
    const legacyEstimate = (0, $acw62.useMemo)(()=>{
        if (legacyEstimateOverride != null) return legacyEstimateOverride;
        if (!projections || projections.length === 0) return after.netWorth;
        const lastYear = projections[projections.length - 1];
        // Net of the tax on selling the investment properties (support/estateCgt.ts, 21 Oct 2026).
        return (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(lastYear) ?? after.netWorth;
    }, [
        projections,
        after.netWorth,
        legacyEstimateOverride
    ]);
    const pensionAfter = after.socialSecurity ?? 0;
    const pensionBreakdown = pensionBreakdownOverride ?? after.socialSecurityBreakdown;
    const netWorthAfter = netWorthAfterValue != null ? netWorthAfterValue : after.netWorth;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: embedded ? '' : 'mt-6 pt-6 border-t border-gray-200',
        children: [
            embedded ? // Embedded: the panel above already carries the heading and names the baseline, so
            // only the projection-period input survives — on its own line, because at this
            // pane's width (~391px at 100% zoom) a heading and a control cannot share a row.
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-2 mb-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        htmlFor: "legacyYears",
                        className: "text-[13px] font-medium text-slate-600",
                        children: "Project legacy over"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "number",
                        id: "legacyYears",
                        value: legacyYears,
                        onChange: (e)=>setLegacyYears(parseInt(e.target.value) || 0),
                        className: "w-16 px-2 py-1 border border-gray-300 rounded-lg text-[13px]"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-[13px] text-slate-600",
                        children: "years"
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex justify-between items-center mb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "text-2xl font-bold",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6288781efbc92679$export$2e2bcd8739ae039), {
                            children: "Financial Impact"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                htmlFor: "legacyYears",
                                className: "text-sm font-medium",
                                children: "Project Legacy Over"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "number",
                                id: "legacyYears",
                                value: legacyYears,
                                onChange: (e)=>setLegacyYears(parseInt(e.target.value) || 0),
                                className: "w-20 px-2 py-1 border border-gray-300 rounded-lg"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-sm",
                                children: "years"
                            })
                        ]
                    })
                ]
            }),
            baselineLabel && !embedded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mb-3 rounded-lg border border-slate-200/70 border-l-4 border-l-blue-500 bg-white px-3 py-2 text-xs leading-relaxed text-slate-700",
                children: [
                    "Every figure below is measured against",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: baselineLabel
                    }),
                    " \u2014 what this household's position would be if no strategy were put in place. The grey figure in each tile is that baseline; the bold figure is this plan."
                ]
            }),
            working ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[13px] text-slate-500",
                role: "status",
                "aria-live": "polite",
                "data-testid": "financial-impact-working",
                children: "Working it out\u2026"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-baseline justify-between mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                        className: embedded ? 'text-[11px] font-bold uppercase tracking-[0.09em] text-slate-400' : 'text-sm font-semibold text-gray-500',
                                        children: "Annual Position"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setBasisExplainerOpen((open)=>!open),
                                        "aria-expanded": basisExplainerOpen,
                                        className: "text-[13px] text-blue-600 hover:text-blue-800 underline",
                                        children: "Annual Position vs View Projections"
                                    })
                                ]
                            }),
                            basisExplainerOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mb-3 rounded-lg border border-slate-200 bg-slate-50/70 px-3 py-2.5 text-left",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-[13px] text-slate-600 leading-relaxed",
                                        children: [
                                            "The figures below are a ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "normalised year"
                                            }),
                                            " \u2014 not a financial or calendar year. They show what your Age Pension and cash flow would look like over 12 months if your whole plan were in place today, so you can see the strategy's impact without the timing of events getting in the way."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-[13px] text-slate-600 leading-relaxed mt-1.5",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "View Projections"
                                            }),
                                            " shows the timing: year-by-year estimates on a financial or calendar-year basis, including the year your plan starts \u2014 which blends part of the old position and part of the new."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: embedded ? '' : 'grid grid-cols-1 2xl:grid-cols-2 gap-4 text-center',
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $40c3129e5e42aeff$export$2e2bcd8739ae039), {
                                        layout: embedded ? 'row' : 'card',
                                        title: "Age Pension (p.a.)",
                                        subtitle: "estimated entitlement, over a year",
                                        beforeValue: baselineOnly ? null : before.socialSecurity ?? 0,
                                        afterValue: pensionAfter,
                                        breakdown: pensionBreakdown
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $40c3129e5e42aeff$export$2e2bcd8739ae039), {
                                        layout: embedded ? 'row' : 'card',
                                        title: "Cash Flow (p.a.)",
                                        subtitle: "money in, less money out, over a year",
                                        beforeValue: baselineOnly ? null : cashFlowBeforeValue != null ? cashFlowBeforeValue : before.cashFlow,
                                        afterValue: afterCashFlowWithCareCosts,
                                        breakdown: cashFlowBreakdownWithCare
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                className: `mb-2 ${embedded ? 'text-[11px] font-bold uppercase tracking-[0.09em] text-slate-400' : 'text-sm font-semibold text-gray-500'}`,
                                children: "Wealth Position"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: embedded ? '' : 'grid grid-cols-1 2xl:grid-cols-2 gap-4 text-center',
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $40c3129e5e42aeff$export$2e2bcd8739ae039), {
                                        layout: embedded ? 'row' : 'card',
                                        title: "Net Worth (Today)",
                                        subtitle: "everything owned, less everything owed",
                                        beforeValue: baselineOnly ? null : before.netWorth,
                                        afterValue: netWorthAfter,
                                        breakdown: netWorthBreakdownOverride ?? undefined
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $40c3129e5e42aeff$export$2e2bcd8739ae039), {
                                        layout: embedded ? 'row' : 'card',
                                        // The client's name for it first, the technical name beside it — the same words
                                        // the walk-in tiles and the strategy cards use (owner, 2026-09-22).
                                        title: legacyTitle,
                                        subtitle: legacyBaselineValue != null && !baselineOnly ? `the legacy estimate after ${legacyYears} ${legacyYears === 1 ? 'year' : 'years'}, against ${baselineLabel || 'doing nothing'}` : `the legacy estimate: what would be left after ${legacyYears} ${legacyYears === 1 ? 'year' : 'years'}`,
                                        beforeValue: baselineOnly ? null : legacyBaselineValue ?? before.netWorth,
                                        afterValue: legacyEstimate,
                                        isLegacy: !baselineOnly && legacyBaselineValue == null,
                                        // The caption NAMES this module's own benchmark. Hardcoding "vs staying
                                        // put" put a Retirement Village phrase on an Aged Care plan, where staying
                                        // put is not an option and the benchmark is entering care with no plan.
                                        legacyCaption: legacyBaselineValue != null && !baselineOnly ? `vs ${baselineLabel || 'doing nothing'}` : undefined,
                                        breakdown: legacyBreakdownOverride ?? undefined
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !embedded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-4 flex justify-end",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    onClick: onViewProjections,
                    className: "flex items-center gap-2 text-sm font-semibold text-blue-600 hover:text-blue-800",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                            size: 16
                        }),
                        " View Projections"
                    ]
                })
            })
        ]
    });
};
var $a47f01df2d11b1bc$export$2e2bcd8739ae039 = $a47f01df2d11b1bc$var$FinancialImpactPanel;


/**
 * "Your plan summary" — the aged care module's right pane, as ONE panel.
 *
 * WHY THIS EXISTS. This is the second major step away from the dismissible Insight Panel. The first
 * moved the walk-in position inline (WalkInPositionNote); this one gathers what a client actually
 * has to read together into a single surface that never moves:
 *
 *     what care costs  →  what it does to the position  →  why  →  the projections
 *
 * The rail used to hold two separate cards — Cost Overview, then Financial Impact — with the
 * plain-words narrative somewhere further down the page entirely. Owner, 2026-08-26, working at
 * 100% zoom: "this is really hard to navigate, im having to scroll both up and down the screen to
 * see what the hell is going on - its terrible." Cause on the left, effect on the right, and the
 * explanation somewhere else again, so every input change meant hunting for what moved.
 *
 * The owner's own design, and it is better than the alternative that was proposed (a sticky strip of
 * three figures across the top): a strip steals vertical height — the scarcest thing at 100% — and
 * still leaves the narrative far from the numbers it explains.
 *
 * WHAT THIS COMPONENT IS NOT. It computes nothing. Every figure is passed in, already derived by the
 * callers that owned them before — agedCareBaseline.ts for the benchmark, agedCareCostsEngine for
 * the fees, FinancialImpactPanel for the four tiles, StrategyPlanRecap for the narrative. That is
 * deliberate and it is the safety property of this change: the two-baselines class of bug (a panel
 * and a summary each deriving the same number their own way, disagreeing by $97,649, with neither
 * half's unit test able to see it) is designed out by there being one panel, not by being tested for.
 *
 * LAYOUT. This pane is ~391px at the owner's 100% zoom (1330px viewport) and ~595px at 1920. Nothing
 * in here may subdivide on a `md:`/`lg:` prefix: those measure the VIEWPORT, not this pane. See
 * agedCareResponsiveLayout.test.ts.
 */ 
parcelRequire("acw62");

const $7abf945a7ae3f4e9$export$ac0a90c1034a0d37 = ({ testId: testId = 'working-it-out' })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "text-[13px] text-slate-500",
        role: "status",
        "aria-live": "polite",
        "data-testid": testId,
        children: "Working it out\u2026"
    });
const $7abf945a7ae3f4e9$var$PlanSummaryPanel = ({ strategyName: strategyName, baselineLabel: baselineLabel, costOverview: costOverview, costOverviewLabel: costOverviewLabel = 'What care costs', financialImpact: financialImpact, inBrief: inBrief, onReadFullExplanation: onReadFullExplanation, onWhatCouldGoWrong: onWhatCouldGoWrong, onViewProjections: onViewProjections, liquidity: liquidity, noStrategyHeading: noStrategyHeading = 'Nothing set yet', noStrategyNote: noStrategyNote, actions: actions, working: working = false })=>/*
     * THE PANEL MUST FIT THE SCREEN, or `sticky` cannot help it.
     *
     * A sticky element TALLER than the viewport does not pin its top — the browser scrolls it until
     * its bottom edge arrives, so working further down the page (the funding sliders, say) carried
     * the heading and "In brief" off the top and the reader had to scroll back up to see what their
     * own change had done (owner, 2026-08-27, at 80% zoom).
     *
     * So the panel is capped to the viewport and split: the heading and "In brief" — the answer —
     * never move, and the supporting detail scrolls inside. `100vh` is the right unit even though
     * the app scrolls an inner region, because the shell is h-screen and this pane is measured
     * against the same window. The 8rem covers the page header and the sticky offset above it.
     */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-white rounded-2xl border border-slate-200/70 shadow-card overflow-hidden xl:flex xl:flex-col xl:max-h-[calc(100vh-8rem)]",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "shrink-0 px-5 pt-4 pb-3 border-b border-slate-200/80 bg-white",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[11px] font-bold uppercase tracking-[0.1em] text-slate-400",
                        children: "Your plan summary"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-lg font-bold tracking-tight text-slate-900 leading-snug",
                        children: strategyName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-brand-navy",
                            children: strategyName
                        }) : noStrategyHeading
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-1 text-[13px] text-slate-500 leading-relaxed",
                        children: strategyName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "Compared with ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "font-semibold text-slate-700",
                                    children: baselineLabel || 'changing nothing'
                                }),
                                ". The grey figure is that comparison; the bold figure is this plan."
                            ]
                        }) : noStrategyNote ?? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: "These are the figures with nothing changed. Set a plan on the left and each figure here shows the difference it makes."
                        })
                    })
                ]
            }),
            (inBrief || working && strategyName) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "shrink-0 px-5 pt-4 pb-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[11px] font-bold uppercase tracking-[0.09em] text-slate-400 mb-2",
                        children: "In brief"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "rounded-lg bg-slate-50 border border-slate-200/70 border-l-[3px] border-l-blue-500 px-3 py-2.5 text-[13px] leading-relaxed text-slate-700",
                        children: working ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7abf945a7ae3f4e9$export$ac0a90c1034a0d37, {
                            testId: "plan-summary-working-brief"
                        }) : inBrief
                    }),
                    onReadFullExplanation && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onReadFullExplanation,
                        className: "mt-2 w-full flex items-center justify-between gap-2 rounded-lg border border-slate-200 px-3 py-2 text-[13px] font-semibold text-blue-700 hover:bg-blue-50 hover:border-blue-300 transition-colors",
                        children: [
                            "Read the full explanation",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                "aria-hidden": true,
                                className: "text-blue-400",
                                children: "\u2192"
                            })
                        ]
                    }),
                    onWhatCouldGoWrong && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onWhatCouldGoWrong,
                        className: "mt-2 w-full flex items-center justify-between gap-2 rounded-lg border border-slate-200 px-3 py-2 text-[13px] font-semibold text-blue-700 hover:bg-blue-50 hover:border-blue-300 transition-colors",
                        "data-testid": "plan-summary-risks",
                        children: [
                            "What could go wrong",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                "aria-hidden": true,
                                className: "text-blue-400",
                                children: "\u2192"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "px-5 py-4 space-y-5 xl:min-h-0 xl:overflow-y-auto",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[11px] font-bold uppercase tracking-[0.09em] text-slate-400 mb-2",
                                children: costOverviewLabel
                            }),
                            working ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7abf945a7ae3f4e9$export$ac0a90c1034a0d37, {
                                testId: "plan-summary-working-costs"
                            }) : costOverview
                        ]
                    }),
                    liquidity && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[11px] font-bold uppercase tracking-[0.09em] text-slate-400 mb-2",
                                children: "How long the money lasts"
                            }),
                            working ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7abf945a7ae3f4e9$export$ac0a90c1034a0d37, {
                                testId: "plan-summary-working-runway"
                            }) : liquidity
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        children: financialImpact
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onViewProjections,
                        className: "w-full flex items-center justify-between gap-2 rounded-lg border border-slate-200 px-3 py-2.5 text-[13px] font-semibold text-blue-700 hover:bg-blue-50 hover:border-blue-300 transition-colors",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                        size: 15,
                                        "aria-hidden": true
                                    }),
                                    " See the projections"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                "aria-hidden": true,
                                className: "text-blue-400",
                                children: "\u2192"
                            })
                        ]
                    })
                ]
            }),
            actions && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "shrink-0 border-t border-slate-200/80 px-5 py-3",
                "data-testid": "plan-summary-actions",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("fieldset", {
                    disabled: working,
                    className: working ? 'opacity-60' : undefined,
                    children: actions
                })
            })
        ]
    });
var $7abf945a7ae3f4e9$export$2e2bcd8739ae039 = $7abf945a7ae3f4e9$var$PlanSummaryPanel;




var $acw62 = parcelRequire("acw62");







// DisposalCgtEstimatePanel.tsx is outside this migration slice's file list (typed by a concurrent
// agent) — its untyped destructured-props signature currently infers each prop's type from its
// default value alone (e.g. `entityId = null` → `null`), which rejects the real string/number
// values this file passes. Widen the reference locally rather than editing that file.
const $a2c71e058b0c397b$var$CgtEstimatePanel = (0, $e778a6a28982486d$export$45781c28beddd168);
function $a2c71e058b0c397b$var$RadFundingAssetSlider({ asset: asset, saleAmount: saleAmount, onFundingChange: onFundingChange, reserved: reserved = 0, factFind: factFind }) {
    // What is left of this asset AFTER the debt payoff's claim on it. A dollar can retire a debt or pay
    // a deposit, not both, so the two cards net off here rather than being reconciled afterwards.
    const available = Math.max(0, (parseFloat(String(asset.value)) || 0) - reserved);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: "block text-sm font-medium text-gray-700",
                children: [
                    (0, $e850825c00b15be4$export$87285386e0429fb5)(asset, factFind, asset.typeName),
                    asset.typeId === 'shares' && asset.costBase ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "block text-xs font-normal text-gray-500",
                        children: "Amount to sell (capital gains tax comes off what reaches the deposit)"
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "range",
                        min: "0",
                        max: available,
                        value: saleAmount,
                        onChange: (e)=>onFundingChange(asset.assetId, e.target.value),
                        className: "w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-600"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "w-36",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                            value: saleAmount || 0,
                            onChange: (v)=>onFundingChange(asset.assetId, v),
                            placeholder: "0",
                            className: ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-xs text-gray-500 mt-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            "Available: ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(available)
                        ]
                    }),
                    reserved > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-gray-400",
                        children: [
                            " (",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(reserved),
                            " allocated to debt repayment)"
                        ]
                    })
                ]
            })
        ]
    });
}
function $a2c71e058b0c397b$var$RadFundingShareCgtPanel({ factFind: factFind, asset: asset, saleAmount: saleAmount, entityId: entityId, cgtOverrides: cgtOverrides, onCgtOverrideChange: onCgtOverrideChange }) {
    if (!saleAmount || saleAmount <= 0 || !asset.costBase) return null;
    // DraftFactFind is structurally compatible with FactFind/FactFindAsset
    // (formDraft.ts); the shared calc-engine fn defensively coerces internally regardless
    // (factFindTypes.ts header), so this cast mirrors entityFundingUtils.ts's own.
    const taxSummary = (0, $a764bc0f6f904854$export$bb01b201c6492ed7)(factFind, asset, saleAmount, {
        trustDisposal: 'distribute'
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a2c71e058b0c397b$var$CgtEstimatePanel, {
        factFind: factFind,
        taxSummary: taxSummary,
        overrideValue: cgtOverrides?.[asset.assetId],
        onOverrideChange: (value)=>onCgtOverrideChange(asset.assetId, value),
        entityId: entityId,
        asset: asset,
        showNetProceedsLine: true,
        saleAmount: saleAmount,
        netProceedsLabel: "Towards the deposit (after estimated capital gains tax)"
    });
}
const $a2c71e058b0c397b$var$RadFundingStrategy = ({ factFind: factFind, radPaid: radPaid, radInput: radInput, radFunding: radFunding, setRadFunding: setRadFunding, cgtOverrides: cgtOverrides = {}, setCgtOverrides: setCgtOverrides, strategyMode: strategyMode, reservedByAsset: reservedByAsset = {}, saleTimingSlot: saleTimingSlot = null })=>{
    const personalLiquidAssets = (0, $acw62.useMemo)(()=>(0, $bd80071df75c742b$export$a6f66b42cac1f673)(factFind), [
        factFind.assets
    ]);
    const entityLiquidGroups = (0, $acw62.useMemo)(()=>(0, $bd80071df75c742b$export$9a49e698901c6550)(factFind), [
        factFind.assets,
        factFind.structures
    ]);
    const fundingTotals = (0, $acw62.useMemo)(()=>(0, $bd80071df75c742b$export$e98193fa2b9f521b)(factFind, radFunding, cgtOverrides), [
        factFind,
        radFunding,
        cgtOverrides
    ]);
    const entityRadGrossAllocated = (0, $acw62.useMemo)(()=>(0, $bd80071df75c742b$export$797d34a55dccdf21)(radFunding, entityLiquidGroups), [
        radFunding,
        entityLiquidGroups
    ]);
    const otherRadPaid = Math.max(0, (parseFloat(String(radPaid)) || 0) - fundingTotals.netTotal);
    const handleFundingChange = (assetId, rawValue)=>{
        const value = parseFloat(String(rawValue)) || 0;
        const newFunding = {
            ...radFunding,
            [assetId]: value
        };
        const projected = (0, $bd80071df75c742b$export$e98193fa2b9f521b)(factFind, newFunding, cgtOverrides);
        if (projected.netTotal + otherRadPaid > radInput) return;
        setRadFunding(newFunding);
        if (value <= 0 && setCgtOverrides) setCgtOverrides((prev)=>{
            if (prev[assetId] == null) return prev;
            const next = {
                ...prev
            };
            delete next[assetId];
            return next;
        });
    };
    const handleCgtOverrideChange = (assetId, value)=>{
        if (!setCgtOverrides) return;
        const newOverrides = {
            ...cgtOverrides
        };
        if (value == null) delete newOverrides[assetId];
        else newOverrides[assetId] = value;
        const projected = (0, $bd80071df75c742b$export$e98193fa2b9f521b)(factFind, radFunding, newOverrides);
        if (projected.netTotal + otherRadPaid > radInput) return;
        setCgtOverrides(newOverrides);
    };
    const remainingToFund = radInput - radPaid;
    const totalCash = (factFind.assets?.bankAccounts || []).filter((a)=>!String(a.ownership || '').startsWith('entity:')).reduce((sum, a)=>sum + (parseFloat(String(a.value)) || 0), 0);
    const cashAllocated = (factFind.assets?.bankAccounts || []).filter((a)=>!String(a.ownership || '').startsWith('entity:')).reduce((sum, a)=>sum + (radFunding[`bankAccounts-${a.id}`] || 0), 0);
    const remainingCash = totalCash - cashAllocated;
    const futureCapitalExpenses = (factFind.expenses?.capitalExpenses || []).reduce((sum, exp)=>sum + (parseFloat(String(exp.amount)) || 0), 0);
    // Rule of thumb: keep at least 6 months of expenses (or the floor) as an emergency fund. The client can still
    // choose to spend below this — it's a warning, not a block.
    const recommendedEmergencyFund = (0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind);
    const liquidityShortfall = recommendedEmergencyFund + futureCapitalExpenses - remainingCash;
    const hasStructures = (factFind.structures || []).length > 0;
    const hasShareLiquidation = fundingTotals.shareCgtTotal > 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "text-xl font-bold text-gray-800 mb-4",
                children: "Paying for the room"
            }),
            strategyMode === 'manual' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-gray-600 mb-4",
                        children: "You can pay for the room as a lump sum, as a daily payment, or as a mix of the two. Move a slider to pay part of it up front from that asset; leave everything at zero to pay for the room daily instead. Where shares are sold, estimated capital gains tax comes out before the money reaches the room deposit."
                    }),
                    fundingTotals.netTotal === 0 && otherRadPaid === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mb-4 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-sm text-slate-700",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Nothing paid up front."
                                }),
                                " The whole room price is being paid as a daily payment. That is a valid strategy \u2014 you can leave this as it is."
                            ]
                        })
                    }),
                    personalLiquidAssets.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-4",
                        children: [
                            hasStructures && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                className: "text-sm font-semibold text-gray-700",
                                children: "Your personal assets"
                            }),
                            personalLiquidAssets.map((asset)=>{
                                const saleAmount = radFunding[asset.assetId] || 0;
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a2c71e058b0c397b$var$RadFundingAssetSlider, {
                                            asset: asset,
                                            saleAmount: saleAmount,
                                            onFundingChange: handleFundingChange,
                                            reserved: reservedByAsset[asset.assetId] || 0,
                                            factFind: factFind
                                        }),
                                        asset.typeId === 'shares' && saleAmount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a2c71e058b0c397b$var$RadFundingShareCgtPanel, {
                                            factFind: factFind,
                                            asset: asset,
                                            saleAmount: saleAmount,
                                            cgtOverrides: cgtOverrides,
                                            onCgtOverrideChange: handleCgtOverrideChange
                                        })
                                    ]
                                }, asset.assetId);
                            })
                        ]
                    }),
                    entityLiquidGroups.map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mt-6 pt-4 border-t space-y-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                            className: "text-sm font-semibold text-gray-800",
                                            children: group.entityName
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-xs text-gray-500",
                                            children: group.structureTypeLabel
                                        })
                                    ]
                                }),
                                group.assets.map((asset)=>{
                                    const saleAmount = radFunding[asset.assetId] || 0;
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a2c71e058b0c397b$var$RadFundingAssetSlider, {
                                                asset: asset,
                                                saleAmount: saleAmount,
                                                onFundingChange: handleFundingChange,
                                                reserved: reservedByAsset[asset.assetId] || 0,
                                                factFind: factFind
                                            }),
                                            asset.typeId === 'shares' && saleAmount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a2c71e058b0c397b$var$RadFundingShareCgtPanel, {
                                                factFind: factFind,
                                                asset: asset,
                                                saleAmount: saleAmount,
                                                entityId: group.entityId,
                                                cgtOverrides: cgtOverrides,
                                                onCgtOverrideChange: handleCgtOverrideChange
                                            })
                                        ]
                                    }, asset.assetId);
                                })
                            ]
                        }, group.entityId)),
                    entityRadGrossAllocated > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-4 p-3 bg-white border border-slate-200 border-l-4 border-l-amber-400 rounded-r-lg text-sm text-slate-700",
                        children: (0, $bd80071df75c742b$export$ec9c57e3c77471a1)
                    }),
                    personalLiquidAssets.length === 0 && entityLiquidGroups.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-gray-500 italic",
                        children: "No savings or investments on the file that could pay part of the room up front."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-6 pt-4 border-t space-y-2",
                        children: [
                            hasShareLiquidation && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-between text-sm text-gray-600",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Shares and funds sold (before tax)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Object.entries(fundingTotals.byKey).filter(([k])=>k.startsWith('shares-')).reduce((s, [, e])=>s + e.gross, 0))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-between font-bold",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Paid up front (after tax on shares sold):"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: fundingTotals.netTotal > radInput ? 'text-red-500' : '',
                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(fundingTotals.netTotal)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-between font-bold pt-2 border-t border-gray-200",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Still paid daily:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(remainingToFund)
                                    })
                                ]
                            })
                        ]
                    }),
                    saleTimingSlot && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-4",
                        children: saleTimingSlot
                    }),
                    liquidityShortfall > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-4 p-3 bg-white border border-slate-200 border-l-4 border-l-amber-400 rounded-r-lg text-sm space-y-2",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    className: "text-amber-800",
                                    children: "Heads-up:"
                                }),
                                " This leaves only ",
                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(remainingCash),
                                " in personal cash. As a rule of thumb, it's wise to keep a minimum emergency fund of about ",
                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(recommendedEmergencyFund),
                                " (the greater of ~6 months of living expenses or ",
                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(50000),
                                ")",
                                futureCapitalExpenses > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        ", plus your known future expenses (",
                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(futureCapitalExpenses),
                                        ")"
                                    ]
                                }) : '',
                                " \u2014 and this strategy doesn't. It's your call: you can proceed if you're comfortable with a smaller buffer."
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $a2c71e058b0c397b$export$2e2bcd8739ae039 = $a2c71e058b0c397b$var$RadFundingStrategy;


/**
 * The aged care BASELINE — "enters care, pays the full DAP, makes no strategic decisions" — computed
 * once, in one place, for every surface that compares against it.
 *
 * WHY THIS EXISTS (owner direction, 2026-08-26). Aged care is not a lifestyle choice. The client is
 * entering residential care whatever we advise, so the honest question is never "how does this
 * compare with life at home" — it is "what did our advice add on top of the care that was happening
 * anyway". Measuring strategies against today's at-home position credits every recommendation with
 * the care event itself: on a real couple that is a $15,376 Age Pension rise and an $82,273 cashflow
 * fall which no strategy caused and none can avoid.
 *
 * TWO BASES, DELIBERATELY. The Financial Impact panel is not one thing:
 *   - Age Pension and Cash Flow are a NORMALISED year — "what would 12 months look like if the plan
 *     were in place today", timing stripped out on purpose. Their baseline must be struck the same
 *     way, with `calculateFinancials`, or the delta stops being strategy-only.
 *   - The estate is the last row of a real PROJECTION, timing-aware and respecting the care start
 *     date. Its baseline must be a projection too, run over the same years with the same care date.
 * Using the projection's year one for the annual tiles would look obvious and be wrong: it blends
 * part-year timing into figures whose whole purpose is to have none.
 *
 * THE TRAP THIS MODULE EXISTS TO CLOSE. Two facts about aged care travel in places that make them
 * easy to drop when building a "no strategy" position, and dropping either is silent:
 *
 *   1. WHO IS IN CARE is passed as *strategy options* (`clientResidencyOverride` /
 *      `partnerResidencyOverride`, from `agedCareEntrantResidencyOverrides`), in the same object
 *      as the strategies themselves. Strip the strategies naively and the residency goes with them —
 *      the couple is then assessed as two people living at home, the illness-separated treatment
 *      never fires, and the baseline pension is understated by thousands. Every strategy then
 *      inherits that gap as a phantom improvement.
 *   2. THE FACT-FIND ITSELF IS MUTATED by the strategy (`simulatedFactFind` has the home already
 *      sold, the RAD already paid, downsizer contributions already made). A baseline built on it is
 *      not a baseline — it keeps the strategy's balance sheet and drops only its options.
 *
 * The pre-existing SOA "Do Nothing" fell into BOTH: it ran `simulatedFactFind` with no residency
 * override while charging full care fees, i.e. it assessed the couple as living at home and billed
 * them for a nursing home at the same time. This module takes the ORIGINAL fact-find and carries the
 * residency override explicitly, so neither can happen again.
 */ 




const $12e551cf654c2507$export$db879e1f4069b800 = {
    financials: null,
    cashFlowAfterCare: null,
    pension: null,
    todayFinancials: null,
    projections: [],
    runwayProjections: [],
    legacyValue: null,
    agedCareCosts: null
};
function $12e551cf654c2507$export$4581e8ea18cb7f11(factFind, scenarioLivingExpenses, extras = {}) {
    return {
        // NOT a strategy — a fact about the household, and the reason the couple is assessed as
        // illness-separated. Carried explicitly so it can never be stripped with the strategies.
        ...(0, $8eecd0af141b9afb$export$5f0bb1b091776594)(factFind),
        scenarioLivingExpenses: scenarioLivingExpenses,
        rentHome: false,
        downsizeHome: false,
        accessHomeEquity: false,
        reverseMortgage: false,
        heas: false,
        downsizeDetails: {},
        radFunding: {},
        reverseMortgageDetails: null,
        heasDetails: null,
        otherStrategies: {
            gifting: false,
            funeralBonds: false,
            annuity: false
        },
        annuityRecord: null,
        inflationAssumptionPct: (0, $1abe73eeef086faf$export$e51ae1118d375fce),
        investmentPropertySaleSummary: null,
        ...extras
    };
}
async function $12e551cf654c2507$export$ee1360f3529a7951(input) {
    const { factFind: factFind, legacyYears: legacyYears, scenarioLivingExpenses: scenarioLivingExpenses, projectionPeriodMode: projectionPeriodMode, runwayYears: runwayYears, secondRoom: secondRoom, existingStay: existingStay, villageExit: villageExit } = input;
    // Staying put: the current room and deposit are the baseline, and care is under way (no entry date).
    const radInput = existingStay ? existingStay.roomPrice : input.radInput;
    const careStartDate = existingStay ? undefined : input.careStartDate;
    if (!factFind) return $12e551cf654c2507$export$db879e1f4069b800;
    try {
        const doNothingOptions = $12e551cf654c2507$export$4581e8ea18cb7f11(factFind, scenarioLivingExpenses, {
            ...projectionPeriodMode ? {
                projectionPeriodMode: projectionPeriodMode
            } : {},
            // A village unit paid out at the move: the interest is sold from entry (8 Oct 2026).
            ...villageExit?.paidAtMove && villageExit.entitlement > 0 ? {
                villageInterestSold: true
            } : {},
            // Same timeline as the strategy: a baseline that enters care today cannot be compared
            // with a strategy that enters in two years — every delta would carry the difference.
            ...careStartDate ? {
                careStartDate: careStartDate
            } : {}
        });
        const secondRoomActive = !!secondRoom && secondRoom.roomPrice > 0;
        // The household as it is today, at home. Used ONLY for the walk-in note's bridge sentence.
        const todayFinancials = await $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind);
        // The household IN CARE with no plan, on the adjusted living costs: the NORMALISED basis the
        // annual tiles' "after" is struck on. The fee schedules below are struck on it too — the
        // means-tested fees read the in-care income (the illness-separated pension) and assets, and
        // the home's exemption reads who is left living in it. Striking them on today's at-home
        // position priced the rail a few dollars a day apart from step 2 (owner-caught, 7 Oct 2026).
        // Where the second person enters LATER, the normalised year is the FIRST stage — the other
        // still at home (the home exempt, the pension illness-separated) — and the second stage is
        // struck beside it (carePhases.ts). The projection runs the whole timeline either way.
        const later = secondRoomActive && !!secondRoom.entersLater;
        const residencyBoth = (0, $8eecd0af141b9afb$export$5f0bb1b091776594)(factFind);
        const secondKey = secondRoom?.person === 'client' ? 'clientResidencyOverride' : 'partnerResidencyOverride';
        const secondRecorded = (secondRoom?.person === 'client' ? factFind.client?.currentResidency : factFind.partner?.currentResidency) || 'own_home';
        const residencyInCare = later ? {
            ...residencyBoth,
            [secondKey]: secondRecorded
        } : residencyBoth;
        const financials = await $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind, {
            ...doNothingOptions,
            ...residencyInCare
        });
        // The second stage's living costs, where the plan gives a figure for once both are in care.
        const livingOnceBoth = later && typeof secondRoom.livingExpensesOnceBoth === 'number' && secondRoom.livingExpensesOnceBoth > 0 ? secondRoom.livingExpensesOnceBoth : null;
        const financialsBoth = later ? await $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind, {
            ...doNothingOptions,
            ...livingOnceBoth != null ? {
                scenarioLivingExpenses: livingOnceBoth
            } : {}
        }) : financials;
        // Struck on the ORIGINAL fact-find, with care costs the client has not acted on: no RAD, so
        // the whole room price is charged as a daily payment. That is what making no decision costs.
        const agedCareCostsStruck = await $55a1d8a64f1e5dfa$export$fb677777baef0897({
            factFind: factFind,
            financials: financials,
            radInput: radInput,
            extraServiceFeeInput: 0,
            radPaid: existingStay ? existingStay.refundToday : 0,
            overallStrategy: {
                rentHome: false,
                downsizeHome: false,
                accessHomeEquity: false,
                reverseMortgage: false,
                heas: false,
                ...residencyInCare
            },
            // Whose schedule this is, where two people are in care (their own DAP in their own means).
            ...secondRoomActive ? {
                resident: secondRoom.person === 'client' ? 'partner' : 'client'
            } : {},
            ...existingStay ? {
                resident: existingStay.person
            } : {}
        });
        // The home someone is in now charges the daily payment their agreement fixed, not today's.
        const agedCareCosts = existingStay ? (0, $bdfd96a4f4ac117d$export$98225c4faadd11c0)(agedCareCostsStruck, existingStay.dailyPayment) : agedCareCostsStruck;
        // The second room, likewise undecided: the whole price paid daily (7 Oct 2026).
        const secondAgedCareCosts = secondRoomActive ? await $55a1d8a64f1e5dfa$export$fb677777baef0897({
            factFind: factFind,
            financials: financialsBoth,
            radInput: secondRoom.roomPrice,
            extraServiceFeeInput: 0,
            radPaid: 0,
            overallStrategy: {
                rentHome: false,
                downsizeHome: false,
                accessHomeEquity: false,
                reverseMortgage: false,
                heas: false,
                ...residencyBoth
            },
            resident: secondRoom.person
        }) : null;
        // The first room once both are in care — the second stage's first-room schedule.
        const firstOnceBoth = later ? await $55a1d8a64f1e5dfa$export$fb677777baef0897({
            factFind: factFind,
            financials: financialsBoth,
            radInput: radInput,
            extraServiceFeeInput: 0,
            radPaid: 0,
            overallStrategy: {
                rentHome: false,
                downsizeHome: false,
                accessHomeEquity: false,
                reverseMortgage: false,
                heas: false,
                ...residencyBoth
            },
            resident: secondRoom.person === 'client' ? 'partner' : 'client'
        }) : null;
        if (villageExit && villageExit.entitlement > 0) doNothingOptions.villageExit = {
            ...villageExit,
            radAllocation: 0,
            interimDailyPayment: 0
        };
        if (secondAgedCareCosts) doNothingOptions.secondResident = {
            person: secondRoom.person,
            ...secondRoom.careStartDate ? {
                careStartDate: secondRoom.careStartDate
            } : {},
            radFunding: {},
            agedCareCosts: secondAgedCareCosts,
            ...livingOnceBoth != null ? {
                livingExpensesOnceBoth: livingOnceBoth
            } : {}
        };
        const [projections, runwayProjections] = await Promise.all([
            // PROJECTION basis — matches the estate's "after".
            $55a1d8a64f1e5dfa$export$75699a59a86ef1ab(factFind, doNothingOptions, {
                ...agedCareCosts,
                scenarioLivingExpenses: scenarioLivingExpenses
            }, legacyYears),
            // RUNWAY basis — the same run over the long horizon, when a caller wants it.
            runwayYears && runwayYears > legacyYears ? $55a1d8a64f1e5dfa$export$75699a59a86ef1ab(factFind, doNothingOptions, {
                ...agedCareCosts,
                scenarioLivingExpenses: scenarioLivingExpenses
            }, runwayYears) : Promise.resolve([])
        ]);
        const rows = Array.isArray(projections) ? projections : [];
        const last = rows[legacyYears - 1] ?? rows[rows.length - 1];
        const legacyValue = (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(last);
        // The care fees this baseline actually incurs, netted off here so that every surface quoting
        // "cashflow with no plan" quotes the same number. See the field docs.
        // The normalised year: both rooms where both enter together; the first room alone where the
        // second person enters later (their stage is `phase2`).
        const baselineAnnualCare = ((Number(agedCareCosts?.totalDailyCost) || 0) + (later ? 0 : Number(secondAgedCareCosts?.totalDailyCost) || 0)) * 365;
        const cashFlowAfterCare = (Number(financials?.cashFlow) || 0) - baselineAnnualCare;
        const phaseTwoAnnualCare = later ? ((Number(firstOnceBoth?.totalDailyCost) || 0) + (Number(secondAgedCareCosts?.totalDailyCost) || 0)) * 365 : 0;
        const phase2 = later && firstOnceBoth ? {
            fromDate: secondRoom.careStartDate || '',
            financials: financialsBoth,
            agedCareCosts: firstOnceBoth,
            secondAgedCareCosts: secondAgedCareCosts,
            cashFlowAfterCare: (Number(financialsBoth?.cashFlow) || 0) - phaseTwoAnnualCare,
            pension: Number(financialsBoth?.socialSecurity) || 0
        } : null;
        return {
            financials: financials,
            cashFlowAfterCare: cashFlowAfterCare,
            pension: Number(financials?.socialSecurity) || 0,
            todayFinancials: todayFinancials,
            projections: rows,
            runwayProjections: Array.isArray(runwayProjections) ? runwayProjections : [],
            legacyValue: legacyValue,
            agedCareCosts: agedCareCosts,
            secondAgedCareCosts: secondAgedCareCosts,
            secondEntersLater: later,
            phase2: phase2
        };
    } catch (err) {
        /*
         * NEVER SWALLOW THIS SILENTLY (owner-caught, 2026-08-27).
         *
         * The bare `catch {}` this replaces was written to honour the rule above — no baseline, no
         * claim. The rule is right; the wiring defeated it. When this returns EMPTY the estate tile
         * does not say nothing: FinancialImpactPanel falls back to `before.netWorth`, captions it
         * "vs today", and reports a five-year projection against TODAY'S net worth. That is the
         * exact comparison the baseline work existed to remove — it credits a strategy with growth
         * that would have happened anyway — and it looks entirely plausible on screen.
         *
         * The owner hit it from the other end: the Suggestion Engine's best legacy read WORSE than
         * the panel's "do nothing", because the panel's figure was never a do-nothing at all. With
         * no log line there was nothing to find, which is how a failed computation passed for an
         * answer. Callers still get EMPTY; the failure is now visible to whoever has to explain it.
         */ // A warning, not console.error: in development console.error takes over the whole screen with the error
        // overlay, which the owner met reopening a plan while the server restarted (22 Oct 2026). Still logged.
        console.warn('[agedCareBaseline] baseline failed \u2014 estate comparisons will fall back to "vs today"', err);
        return $12e551cf654c2507$export$db879e1f4069b800;
    }
}




/**
 * The manual aged care plan, applied to the client's profile: the position once the plan is in
 * place (owner, 3 Oct 2026). Moved out of AgedCareAnalyser's memo, unchanged, so the Action Plan can
 * fill the means-assessment forms from the same position the analyser shows, for a plan saved
 * earlier, without the page open.
 *
 * Downsizing first (it makes the cash), then the investment property sale, the reverse mortgage,
 * the annuity, gifting and funeral bonds, then the RAD funding and the debt payoff. The last two are
 * skipped when `deferToEngine` is set: with a day to sell on, the projection does them that day,
 * and this is the CURRENT position until then.
 */ 


/**
 * What a home sale leaves once the adviser has allocated it — and, deliberately, nothing else.
 *
 * WHY THIS IS ITS OWN FUNCTION, AND WHY ITS SIGNATURE IS NARROW (owner-caught, 25 September 2026).
 * The aged care analyser used to work this out inline and then subtract an annuity's purchase price
 * from the answer "so we don't double-count" — while the annuity applier withdrew the same amount
 * from the same account a moment later, and a third deduction followed as a "safety net". A
 * $190,000 annuity cost the household $380,000 of assets.
 *
 * This function is handed the sale allocation and NOTHING about any strategy funded out of the
 * proceeds afterwards. It cannot subtract an annuity because it cannot see one. That is a stronger
 * guarantee than a test: the fault cannot be reintroduced here without changing the signature,
 * which is a far louder change than editing a line.
 *
 * Money spent out of the proceeds after this point — an annuity, a gift, a bond — leaves through
 * the applier that owns it, once. See `applyAnnuityWithDraw` in annuityStrategies.ts.
 */ /** The sale, and the destinations the allocator on screen offers for it. Every field optional: a half-filled form is normal. */ const $d3aae77d985b9410$var$num = (v)=>{
    const n = typeof v === 'number' ? v : parseFloat(String(v ?? ''));
    return Number.isFinite(n) ? n : 0;
};
function $d3aae77d985b9410$export$f0562ea3a87026d(allocation) {
    return $d3aae77d985b9410$var$num(allocation?.salePrice) - $d3aae77d985b9410$var$num(allocation?.sellingCosts) - $d3aae77d985b9410$var$num(allocation?.stampDuty);
}
function $d3aae77d985b9410$export$2701b2ef32cde4a3(allocation) {
    return $d3aae77d985b9410$var$num(allocation?.radAllocation) + $d3aae77d985b9410$var$num(allocation?.newHomePurchasePrice) + $d3aae77d985b9410$var$num(allocation?.downsizerContribution) + $d3aae77d985b9410$var$num(allocation?.partnerDownsizerContribution) + $d3aae77d985b9410$var$num(allocation?.giftingAmount) + $d3aae77d985b9410$var$num(allocation?.funeralBondPurchase) + $d3aae77d985b9410$var$num(allocation?.purchaseInvestmentProperty) + $d3aae77d985b9410$var$num(allocation?.purchaseShares);
}
function $d3aae77d985b9410$export$d9b5e9387fa6e732(allocation) {
    return $d3aae77d985b9410$export$f0562ea3a87026d(allocation) - $d3aae77d985b9410$export$2701b2ef32cde4a3(allocation);
}






const $9c5c211308401e85$var$asFactFind = (data)=>data;
function $9c5c211308401e85$export$ec16a23ddd681f35(debtPayments, debtFunding, repaymentBasis) {
    const payments = Object.fromEntries(Object.entries(debtPayments || {}).filter(([, amount])=>(Number(amount) || 0) > 0));
    if (Object.keys(payments).length === 0) return null;
    const funding = Object.fromEntries(Object.entries(debtFunding || {}).filter(([, amount])=>(Number(amount) || 0) > 0));
    return {
        payments: payments,
        funding: funding,
        repaymentBasis: repaymentBasis
    };
}
function $9c5c211308401e85$export$4a20ccd66ad56fc(factFind, inputs) {
    const { scenarioLivingExpenses: scenarioLivingExpenses, overallStrategy: overallStrategy, downsizeDetails: downsizeDetails, investmentPropertyDetails: investmentPropertyDetails, reverseMortgageDetails: reverseMortgageDetails, otherStrategies: otherStrategies, annuityRecord: annuityRecord, radFunding: radFunding, secondRadFunding: secondRadFunding, cgtOverrides: cgtOverrides, debtPayoffPlan: debtPayoffPlan, existingStay: existingStay } = inputs;
    const radLiquidationDeferredToEngine = inputs.deferToEngine;
    /** What the annuity drew from each liquid asset, so the funding picker can offer it back. */ let annuityDrawnFrom = {};
    // Loosely typed on purpose: extensive downstream mutation of data.assets/home/expenses across
    // this whole memo assumes they're always present (guaranteed by INITIAL_FACT_FIND's shape),
    // matching this function's prior JSON-clone-derived `any` typing.
    let data = structuredClone(factFind);
    data.expenses.livingExpenses = scenarioLivingExpenses;
    // 1. Handle downsizing first, as it generates the cash pool
    if (overallStrategy.downsizeHome) {
        /*
         * The duty on the home being bought is netted off exactly as the allocator on screen does,
         * so the two never disagree about what is left to allocate (23 Sep 2026).
         *
         * `unallocatedSaleProceeds` is handed the sale allocation and NOTHING about any strategy
         * funded out of the proceeds afterwards, so it cannot subtract one — which is how this
         * arithmetic came to be wrong in the first place (owner-caught, 25 Sep 2026). See the note
         * on that function.
         */ const unallocatedProceeds = (0, $d3aae77d985b9410$export$d9b5e9387fa6e732)(downsizeDetails);
        // Remove original home
        data.home.value = 0;
        // Add new home if purchased
        if ((Number(downsizeDetails.newHomePurchasePrice) || 0) > 0) data.home.value = downsizeDetails.newHomePurchasePrice;
        // Add RAD Paid as an asset (if not already tracked)
        if ((Number(downsizeDetails.radAllocation) || 0) > 0) {
            if (!data.assets.radPaid) data.assets.radPaid = [];
            data.assets.radPaid = [
                {
                    id: 'rad-paid',
                    type: 'radPaid',
                    description: 'RAD Paid',
                    value: downsizeDetails.radAllocation,
                    ownership: 'client'
                }
            ];
        }
        /*
         * THE PROCEEDS GO IN AT THEIR FULL VALUE, and the annuity is withdrawn from them ONCE,
         * lower down, by `applyAnnuityToFactFind`.
         *
         * OWNER-CAUGHT, 25 September 2026. This used to subtract the annuity's purchase price here
         * "so we don't double-count" — but the applier then withdrew the SAME amount from the SAME
         * account, and a third deduction followed as a "safety net". On the owner's plan
         * ($194,713 of unallocated proceeds, a $190,000 annuity) this account was created holding
         * $4,713; the applier drained that and took the remaining $185,287 from the first bank
         * account; and the picker then offered anz with $14,713 and no proceeds row at all. The
         * household gave up $380,000 of assets to buy a $190,000 annuity, which understates the
         * assets test, overstates the Age Pension and understates the means-tested care fee.
         * One withdrawal, in one place, is the only arrangement that cannot drift again.
         */ const saleProceedsForBank = unallocatedProceeds;
        if (saleProceedsForBank > 0) {
            if (!data.assets.bankAccounts) data.assets.bankAccounts = [];
            const defaultIncomeRate = data.assets.bankAccounts && data.assets.bankAccounts.length > 0 ? data.assets.bankAccounts[0].incomeRate || 2 : 2;
            data.assets.bankAccounts.push({
                id: 'downsize-proceeds',
                type: 'bankAccounts',
                description: 'Unallocated Sale Proceeds',
                value: saleProceedsForBank,
                ownership: 'joint',
                incomeRate: defaultIncomeRate,
                growthRate: 0
            });
        }
        (0, $f1228be62b68f76b$export$a72a115b20fefbbf)(data.assets, $9c5c211308401e85$var$asFactFind(factFind), downsizeDetails, {
            idPrefix: 'downsizer-contrib',
            assetId: 'downsizer-contrib',
            partnerAssetId: 'partner-downsizer-contrib'
        });
        // Add funeral bond
        if ((Number(downsizeDetails.funeralBondPurchase) || 0) > 0) {
            if (!data.assets.funeralBonds) data.assets.funeralBonds = [];
            data.assets.funeralBonds.push({
                id: 'downsize-fbond',
                type: 'funeralBonds',
                description: 'Funeral Bond from Proceeds',
                value: downsizeDetails.funeralBondPurchase,
                ownership: 'client'
            });
        }
        // Add investment property from proceeds
        if ((Number(downsizeDetails.purchaseInvestmentProperty) || 0) > 0) {
            if (!data.assets.investmentProperty) data.assets.investmentProperty = [];
            data.assets.investmentProperty.push({
                id: 'downsize-inv-prop',
                type: 'investmentProperty',
                description: 'Investment property (from downsize)',
                value: downsizeDetails.purchaseInvestmentProperty,
                ownership: 'client',
                rent: Number(downsizeDetails.investmentPropertyRent) || 0,
                expenses: Number(downsizeDetails.investmentPropertyExpenses) || 0,
                growthRate: 5,
                costBase: downsizeDetails.purchaseInvestmentProperty,
                acquisitionDate: 'post'
            });
        }
        // Add shares from proceeds
        if ((Number(downsizeDetails.purchaseShares) || 0) > 0) {
            if (!data.assets.shares) data.assets.shares = [];
            data.assets.shares.push({
                id: 'downsize-shares',
                type: 'shares',
                description: 'Shares (from downsize)',
                value: downsizeDetails.purchaseShares,
                ownership: 'client',
                incomeRate: 4,
                growthRate: 5,
                costBase: downsizeDetails.purchaseShares,
                frankingCredit: 70,
                reinvest: false
            });
        }
    }
    // 1b. Handle investment property sale (entity proceeds → entity pool when trust/company-owned)
    if (overallStrategy.sellInvestmentProperty && investmentPropertyDetails) (0, $bda3664ae16bcdb0$export$968f08311f735e7a)(data, factFind, investmentPropertyDetails);
    // 2. Handle Reverse Mortgage (before RAD funding to allow RAD allocation)
    if (overallStrategy.reverseMortgage && reverseMortgageDetails) {
        const rmDetails = reverseMortgageDetails;
        const loanAmount = parseFloat(String(rmDetails.loanAmount)) || 0;
        const establishmentFees = parseFloat(String(rmDetails.establishmentFees)) || 0;
        const netProceeds = Math.max(0, loanAmount - establishmentFees);
        // Handle lump sum - adds funds immediately
        if (rmDetails.loanStructure === 'lump_sum' && netProceeds > 0) // If useForRad is checked, allocate to RAD (handled in RAD funding section)
        // Otherwise, add to bank account
        {
            if (!rmDetails.useForRad) {
                if (!data.assets.bankAccounts) data.assets.bankAccounts = [];
                // Find first bank account or create new one
                if (data.assets.bankAccounts.length > 0) {
                    const firstBankAccount = data.assets.bankAccounts[0];
                    firstBankAccount.value = parseFloat(String(firstBankAccount.value)) + netProceeds;
                } else data.assets.bankAccounts.push({
                    id: 'reverse-mortgage-proceeds',
                    type: 'bankAccounts',
                    description: 'Reverse Mortgage Proceeds',
                    value: netProceeds,
                    ownership: 'client',
                    // Interest, not capital growth — see bankPlugin.ts's DEFAULT_BANK_GROWTH_RATE_PERCENT.
                    // `earningsRate` is read by nothing; `incomeRate` is what incomeAssessment.ts assesses.
                    incomeRate: 2,
                    growthRate: 0
                });
            }
        }
    // Note: Regular payments are handled in projections (they accumulate over time)
    }
    // 2.5. Handle Other Strategies (gifting, funeral bonds, annuity) - BEFORE RAD funding
    // This ensures assets are deducted before RAD allocation
    // Apply annuity strategy if selected
    if (otherStrategies.annuity && annuityRecord) {
        // Only apply if purchase amount is set
        if (!annuityRecord.purchaseAmount || Number(annuityRecord.purchaseAmount) <= 0) ;
        else // Build annuity impact first to get calculated values (including residualValue)
        try {
            // Map funding source from assetId format to type format for buildAnnuityImpact
            const mappedAnnuityRecord = {
                ...annuityRecord
            };
            // Ensure required fields are present
            if (!mappedAnnuityRecord.age) {
                if (factFind?.client?.dob) mappedAnnuityRecord.age = (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client?.dob);
            }
            // Set partnerAge if owner is joint OR if reversionary is checked (reversionary requires partner age for joint-life calculation)
            // This affects the income rate calculation (joint discount applies when partnerAge is set)
            if ((mappedAnnuityRecord.owner === 'joint' || mappedAnnuityRecord.reversionary) && !mappedAnnuityRecord.partnerAge && factFind?.partner?.dob) mappedAnnuityRecord.partnerAge = (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner.dob);
            // Ensure age is valid before proceeding - if not, skip annuity application
            if (mappedAnnuityRecord.age && mappedAnnuityRecord.age > 0) {
                // Ensure we have the ID from annuityRecord so we can replace the existing annuity
                if (annuityRecord.id) mappedAnnuityRecord.id = annuityRecord.id;
                if (annuityRecord.fundingSource && typeof annuityRecord.fundingSource === 'object') {
                    // If fundingSource is an object with id like "bankAccounts-123", extract the type
                    const sourceId = annuityRecord.fundingSource.id || '';
                    if (sourceId.includes('-')) {
                        const parts = sourceId.split('-');
                        const assetType = parts[0];
                        // Map to expected type format
                        if (assetType === 'bankAccounts') mappedAnnuityRecord.fundingSource = {
                            ...annuityRecord.fundingSource,
                            type: 'bank'
                        };
                        else if (assetType === 'accountBasedPensions') mappedAnnuityRecord.fundingSource = {
                            ...annuityRecord.fundingSource,
                            type: 'abp'
                        };
                        else if (assetType === 'superannuation') mappedAnnuityRecord.fundingSource = {
                            ...annuityRecord.fundingSource,
                            type: 'super'
                        };
                        else mappedAnnuityRecord.fundingSource = {
                            ...annuityRecord.fundingSource,
                            type: assetType
                        };
                    }
                }
                const annuityRecordForCalculation = (0, $f7f7b62814c3b615$export$fb67395f10ad20c9)(data, mappedAnnuityRecord);
                if (annuityRecordForCalculation && !annuityRecordForCalculation.warnings) {
                    // Ensure fundingSource is properly mapped for applyAnnuityToFactFind
                    if (annuityRecordForCalculation.fundingSource && typeof annuityRecordForCalculation.fundingSource === 'object') {
                        const sourceId = annuityRecordForCalculation.fundingSource.id || '';
                        if (sourceId.includes('-')) {
                            const parts = sourceId.split('-');
                            const assetType = parts[0];
                            const assetId = parts.slice(1).join('-');
                            if (assetType === 'bankAccounts') annuityRecordForCalculation.fundingSourceType = 'bank';
                            else if (assetType === 'accountBasedPensions') annuityRecordForCalculation.fundingSourceType = 'abp';
                            else if (assetType === 'superannuation') annuityRecordForCalculation.fundingSourceType = 'super';
                            else annuityRecordForCalculation.fundingSourceType = assetType;
                            annuityRecordForCalculation.fundingSourceId = assetId;
                        }
                    }
                    /*
                     * ONE WITHDRAWAL, AND A RECORD OF WHERE IT CAME FROM.
                     *
                     * `applyAnnuityToFactFind` is the single place the purchase leaves the assets.
                     * The "safety net" that used to follow it took the same amount a second time
                     * from the proceeds account — see the note where those proceeds are added.
                     *
                     * What each asset gave up is measured here, either side of the call, and
                     * carried out of this memo so the funding picker can offer it back. The
                     * picker answers "what could this annuity be bought with", and the money the
                     * annuity is already using belongs in that answer; without it the list shrank
                     * as the client typed (owner-caught, 25 September 2026).
                     */ const annuityApplied = (0, $f7f7b62814c3b615$export$2be9eb0e3e9661dd)(data, annuityRecordForCalculation);
                    data = annuityApplied.factFind;
                    annuityDrawnFrom = annuityApplied.drawnFrom;
                    const newAnnuity = data.assets?.annuities?.find((a)=>a.id === annuityRecordForCalculation.id);
                    // CRITICAL: Verify the annuity was added correctly
                    if (!newAnnuity) {
                        console.error('ERROR: Annuity was not found in assets after applyAnnuityToFactFind!');
                        console.error('All annuities in data:', data.assets?.annuities);
                    } else if (newAnnuity.annualPayment !== annuityRecordForCalculation.annualPayment) console.error('ERROR: Annuity annualPayment mismatch!', {
                        expected: annuityRecordForCalculation.annualPayment,
                        actual: newAnnuity.annualPayment
                    });
                }
            }
        } catch (error) {
            console.error('Error building annuity impact for factFind application:', error);
        // Don't apply annuity if there's an error - let user fix the configuration first
        }
    }
    // Apply gifting strategy if selected
    if (otherStrategies.gifting && (Number(otherStrategies.giftingAmount) || 0) > 0) {
        const giftingAmount = parseFloat(String(otherStrategies.giftingAmount)) || 0;
        const sourceIdentifier = otherStrategies.giftingSource || 'bankAccounts';
        // Parse assetId format: "type-assetId" or legacy "type"
        let sourceType, targetAssetId;
        if (sourceIdentifier.includes('-')) {
            const parts = sourceIdentifier.split('-');
            sourceType = parts[0];
            targetAssetId = parts.slice(1).join('-'); // Rejoin in case asset.id contains dashes
        } else {
            sourceType = sourceIdentifier;
            targetAssetId = null; // Will deduct from all assets of this type
        }
        // Handle legacy 'bank' mapping
        if (sourceType === 'bank') sourceType = 'bankAccounts';
        // Deduct from source asset(s)
        if (data.assets[sourceType] && data.assets[sourceType].length > 0) {
            let remaining = giftingAmount;
            // If specific asset ID provided, find and deduct from that asset only
            if (targetAssetId) {
                const assetIndex = data.assets[sourceType].findIndex((asset)=>asset.id === targetAssetId);
                if (assetIndex >= 0) {
                    const asset = data.assets[sourceType][assetIndex];
                    const currentValue = parseFloat(String(asset.value || asset.balance || 0)) || 0;
                    const deduction = Math.min(remaining, currentValue);
                    // Update value (handle both value and balance properties)
                    if (asset.balance !== undefined) asset.balance = Math.max(0, currentValue - deduction);
                    else asset.value = Math.max(0, currentValue - deduction);
                    remaining -= deduction;
                    // Remove asset if fully depleted
                    const newValue = parseFloat(String(asset.value || asset.balance || 0)) || 0;
                    if (newValue <= 0) data.assets[sourceType].splice(assetIndex, 1);
                }
            } else // Legacy: deduct from all assets of this type
            for(let i = 0; i < data.assets[sourceType].length && remaining > 0; i++){
                const asset = data.assets[sourceType][i];
                const currentValue = parseFloat(String(asset.value || asset.balance || 0)) || 0;
                const deduction = Math.min(remaining, currentValue);
                // Update value (handle both value and balance properties)
                if (asset.balance !== undefined) asset.balance = Math.max(0, currentValue - deduction);
                else asset.value = Math.max(0, currentValue - deduction);
                remaining -= deduction;
                // Remove asset if fully depleted
                const newValue = parseFloat(String(asset.value || asset.balance || 0)) || 0;
                if (newValue <= 0) {
                    data.assets[sourceType].splice(i, 1);
                    i--; // Adjust index after removal
                }
            }
        }
    }
    // Apply funeral bonds strategy if selected
    if (otherStrategies.funeralBonds && (Number(otherStrategies.funeralBondAmount) || 0) > 0) {
        const funeralBondAmount = parseFloat(String(otherStrategies.funeralBondAmount)) || 0;
        const sourceIdentifier = otherStrategies.funeralBondSource || 'bankAccounts';
        // Parse assetId format: "type-assetId" or legacy "type"
        let sourceType, targetAssetId;
        if (sourceIdentifier.includes('-')) {
            const parts = sourceIdentifier.split('-');
            sourceType = parts[0];
            targetAssetId = parts.slice(1).join('-'); // Rejoin in case asset.id contains dashes
        } else {
            sourceType = sourceIdentifier;
            targetAssetId = null; // Will deduct from all assets of this type
        }
        // Handle legacy 'bank' mapping
        if (sourceType === 'bank') sourceType = 'bankAccounts';
        // Deduct from source asset(s)
        if (data.assets[sourceType] && data.assets[sourceType].length > 0) {
            let remaining = funeralBondAmount;
            // If specific asset ID provided, find and deduct from that asset only
            if (targetAssetId) {
                const assetIndex = data.assets[sourceType].findIndex((asset)=>asset.id === targetAssetId);
                if (assetIndex >= 0) {
                    const asset = data.assets[sourceType][assetIndex];
                    const currentValue = parseFloat(String(asset.value || asset.balance || 0)) || 0;
                    const deduction = Math.min(remaining, currentValue);
                    // Update value (handle both value and balance properties)
                    if (asset.balance !== undefined) asset.balance = Math.max(0, currentValue - deduction);
                    else asset.value = Math.max(0, currentValue - deduction);
                    remaining -= deduction;
                    // Remove asset if fully depleted
                    const newValue = parseFloat(String(asset.value || asset.balance || 0)) || 0;
                    if (newValue <= 0) data.assets[sourceType].splice(assetIndex, 1);
                }
            } else // Legacy: deduct from all assets of this type
            for(let i = 0; i < data.assets[sourceType].length && remaining > 0; i++){
                const asset = data.assets[sourceType][i];
                const currentValue = parseFloat(String(asset.value || asset.balance || 0)) || 0;
                const deduction = Math.min(remaining, currentValue);
                // Update value (handle both value and balance properties)
                if (asset.balance !== undefined) asset.balance = Math.max(0, currentValue - deduction);
                else asset.value = Math.max(0, currentValue - deduction);
                remaining -= deduction;
                // Remove asset if fully depleted
                const newValue = parseFloat(String(asset.value || asset.balance || 0)) || 0;
                if (newValue <= 0) {
                    data.assets[sourceType].splice(i, 1);
                    i--; // Adjust index after removal
                }
            }
            // Add funeral bond asset (exempt from asset test)
            if (!data.assets.funeralBonds) data.assets.funeralBonds = [];
            data.assets.funeralBonds.push({
                id: `other-strategy-fbond-${Date.now()}`,
                type: 'funeralBonds',
                description: 'Funeral Bond (Other Strategy)',
                value: funeralBondAmount,
                ownership: 'client',
                incomeRate: 0,
                growthRate: 0
            });
        }
    }
    // 3. Handle RAD funding from existing assets AND reverse mortgage.
    //
    // Skipped whenever there is a day to sell ON — a nominated sale date, or the entry date standing in
    // for one (`effectiveRadFundingDate`). The engine then owns the liquidation and performs it that
    // day (see `radPlugin`), so doing it here as well would sell the portfolio twice. It is also the
    // honest CURRENT position — assets the client has not sold yet should not show as sold in the
    // before/after snapshot, the insight panels or the SOA, all of which read this.
    //
    // Only a blank entry date falls through to here, and there it is right: care is already under way,
    // so the sale happens at the start of the projection, which is the same thing.
    let totalRadPaid = 0;
    const radFundingDeferredToEngine = radLiquidationDeferredToEngine;
    // The second room's deposit (both of a couple entering care) is sold from the same balance
    // sheet, after the first — the `net` of it is that room's deposit, not this one's.
    const depositSales = [
        [
            radFunding,
            true
        ],
        [
            secondRadFunding || {},
            false
        ]
    ];
    if (!radFundingDeferredToEngine) depositSales.forEach(([bag, firstRoom])=>Object.entries(bag).forEach(([assetKey, amount])=>{
            const parsed = (0, $bd80071df75c742b$export$eb5d467aa7d657c6)(assetKey);
            if (!parsed) return;
            const { gross: gross, net: net } = (0, $bd80071df75c742b$export$351785600ef65fdf)(factFind, assetKey, amount, cgtOverrides);
            if (gross <= 0) return;
            const located = (0, $bd80071df75c742b$export$f59ccf8b394d8480)(data, parsed.assetType, parsed.assetId);
            if (!located) return;
            const originalValue = parseFloat(String(located.asset.value)) || 0;
            const merged = {
                ...located.asset,
                value: originalValue - gross
            };
            if (parsed.assetType === 'accountBasedPensions' && gross > 0) // DraftAsset is structurally compatible with FactFindAsset (see types/formDraft.ts); the
            // shared calc-engine fn defensively coerces internally regardless, so this cast is safe
            // (see factFindTypes.ts header comment).
            (0, $e0f54937e270d5ff$export$399e556d15149d82)(merged, data, 1);
            data.assets[parsed.assetType][located.index] = merged;
            if (firstRoom) totalRadPaid += net;
        }));
    // Add reverse mortgage to RAD if useForRad is checked (only available for lump sum).
    // Deferred alongside the asset sales: it funds the same deposit, on the same day.
    if (!radFundingDeferredToEngine && overallStrategy.reverseMortgage && reverseMortgageDetails?.useForRad && reverseMortgageDetails.loanStructure === 'lump_sum') {
        const rmLoanAmount = parseFloat(String(reverseMortgageDetails.loanAmount)) || 0;
        const rmEstablishmentFees = parseFloat(String(reverseMortgageDetails.establishmentFees)) || 0;
        const rmNetProceeds = Math.max(0, rmLoanAmount - rmEstablishmentFees);
        totalRadPaid += rmNetProceeds;
    }
    // 3b. Debt payoff, on exactly the same contract as the RAD sale above: skipped whenever there is a
    // day to do it on, because `debtPayoffPlugin` then owns the event and doing it here as well would
    // clear the debt twice and sell the funding assets twice. Both branches read the same
    // `effectiveRadFundingDate`, so they cannot disagree.
    //
    // When it DOES apply here, it matters: the Financial Impact panel reads this fact-find for its
    // normalised year, and a plan that retires a debt must not show the client still servicing it.
    if (!radFundingDeferredToEngine && debtPayoffPlan) data = (0, $5a6326d9013f181c$export$525e306199c9748e)(data, debtPayoffPlan, cgtOverrides).factFind;
    // 3b. Someone in care now: the deposit they hold, as the run opens.
    if (existingStay && existingStay.refundToday > 0) {
        if (!data.assets.radPaid) data.assets.radPaid = [];
        const already = data.assets.radPaid.some((r)=>(r.ownership ?? 'client') === existingStay.person);
        if (!already) data.assets.radPaid.push({
            id: 'radPaid',
            type: 'radPaid',
            description: 'RAD Paid',
            value: existingStay.refundToday,
            income: 0,
            growthRate: 0,
            ownership: existingStay.person,
            __radRetentionDaysTaken: existingStay.retentionDaysTaken,
            ...existingStay.grandfathered ? {
                __noRetention: true
            } : {}
        });
    }
    // 4. Add RAD asset if any RAD was paid
    if (totalRadPaid > 0) {
        if (!data.assets.radPaid) data.assets.radPaid = [];
        // Check if RAD asset already exists (from downsize or investment property)
        const existingRadIndex = data.assets.radPaid.findIndex((a)=>a.id === 'rad-deposit');
        if (existingRadIndex > -1) {
            // Update existing RAD asset
            const existingRadValue = parseFloat(String(data.assets.radPaid[existingRadIndex].value)) || 0;
            data.assets.radPaid[existingRadIndex].value = existingRadValue + totalRadPaid;
        } else // Create new RAD asset
        data.assets.radPaid.push({
            id: 'rad-deposit',
            type: 'radPaid',
            description: 'RAD Deposit',
            value: totalRadPaid,
            ownership: 'client',
            growthRate: 0 // RAD doesn't grow, but may have retention
        });
    }
    return {
        data: data,
        annuityDrawnFrom: annuityDrawnFrom
    };
}





var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3c35b0991cad9668$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 3h6v6",
            key: "1q9fwt"
        }
    ],
    [
        "path",
        {
            d: "M10 14 21 3",
            key: "gplh6r"
        }
    ],
    [
        "path",
        {
            d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
            key: "a6xqqp"
        }
    ]
];
const $3c35b0991cad9668$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("external-link", $3c35b0991cad9668$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c978075baab28645$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
            key: "1r0f0z"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "10",
            r: "3",
            key: "ilqhr7"
        }
    ]
];
const $c978075baab28645$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("map-pin", $c978075baab28645$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $04b006b04b8c21eb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
            key: "r04s7s"
        }
    ]
];
const $04b006b04b8c21eb$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("star", $04b006b04b8c21eb$export$3efd853dbb351e94);


const $5aa88897538e91ba$var$FacilitySearchModal = ({ facilities: facilities, onSelect: onSelect, onClose: onClose })=>{
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)('');
    const [maxDistance, setMaxDistance] = (0, $acw62.useState)(10);
    const [sortBy, setSortBy] = (0, $acw62.useState)('distance');
    const [showResults, setShowResults] = (0, $acw62.useState)(false);
    const filteredFacilities = facilities.filter((facility)=>facility.distance <= maxDistance).sort((a, b)=>{
        switch(sortBy){
            case 'price':
                return a.radPrice - b.radPrice;
            case 'rating':
                return b.rating - a.rating;
            default:
                return a.distance - b.distance;
        }
    });
    const handleSearch = ()=>{
        if (searchTerm.trim()) setShowResults(true);
    };
    const handleBackToSearch = ()=>{
        setShowResults(false);
        setSearchTerm('');
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white rounded-xl shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-hidden",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex justify-between items-center p-6 border-b border-gray-200",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "text-2xl font-bold text-gray-900",
                                    children: showResults ? `Homes near ${searchTerm}` : 'Find a home'
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-1 text-[13px] text-slate-500",
                                    "data-testid": "facility-search-sample-note",
                                    children: "Example homes only, to show how the search will work. Use the room price from the home's own quote or My Aged Care."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: onClose,
                            className: "text-gray-400 hover:text-gray-600 transition-all duration-300 hover:scale-110",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 24
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "p-6",
                    children: !showResults ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-gray-600 mb-6",
                                    children: "Enter your suburb or area to find nearby aged care facilities"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "max-w-md mx-auto space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "block text-sm font-medium text-gray-700 mb-2",
                                                children: "Suburb or Area"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "text",
                                                value: searchTerm,
                                                onChange: (e)=>setSearchTerm(e.target.value),
                                                onKeyPress: (e)=>e.key === 'Enter' && handleSearch(),
                                                placeholder: "e.g., Croydon, Five Dock, Campsie...",
                                                className: "w-full px-4 py-3 text-lg border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "block text-sm font-medium text-gray-700 mb-2",
                                                children: [
                                                    "Max Distance: ",
                                                    maxDistance,
                                                    "km"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "range",
                                                min: "1",
                                                max: "20",
                                                value: maxDistance,
                                                onChange: (e)=>setMaxDistance(parseInt(e.target.value)),
                                                className: "w-full"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: handleSearch,
                                        disabled: !searchTerm.trim(),
                                        className: "w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all duration-300 disabled:bg-gray-300 disabled:cursor-not-allowed text-lg font-semibold hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2",
                                        children: "Search homes"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        onClick: handleBackToSearch,
                                        className: "flex items-center gap-2 text-blue-600 hover:text-blue-800 transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                                size: 20
                                            }),
                                            "Back to Search"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "text-sm font-medium text-gray-700",
                                                children: "Sort By:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: sortBy,
                                                onChange: (e)=>setSortBy(e.target.value),
                                                className: "px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "distance",
                                                        children: "Distance"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "price",
                                                        children: "RAD Price"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "rating",
                                                        children: "Rating"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "space-y-4 max-h-96 overflow-y-auto",
                                children: filteredFacilities.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-center py-8 text-gray-500",
                                    children: "No facilities found matching your criteria."
                                }) : filteredFacilities.map((facility)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "border border-gray-200 rounded-xl p-4 md:p-5 hover:border-blue-300 hover:shadow-md transition-all",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-col md:flex-row gap-5",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "shrink-0 w-full md:w-[min(100%,280px)] md:max-w-[280px]",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "aspect-[4/3] rounded-xl overflow-hidden bg-slate-100 ring-1 ring-slate-200/80",
                                                            children: facility.images?.[0] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                src: facility.images[0],
                                                                alt: facility.name,
                                                                className: "w-full h-full object-cover"
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "w-full h-full flex items-center justify-center text-sm text-slate-400",
                                                                children: "No photo"
                                                            })
                                                        }),
                                                        facility.images && facility.images.length > 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "flex gap-1.5 mt-2",
                                                            children: facility.images.slice(1, 4).map((image, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                    src: image,
                                                                    alt: `${facility.name} view ${index + 2}`,
                                                                    className: "h-14 min-w-0 flex-1 object-cover rounded-lg border border-slate-200"
                                                                }, index))
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex-1 min-w-0 flex flex-col lg:flex-row gap-4 lg:gap-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex-1 min-w-0",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                    className: "text-xl font-bold text-gray-900 leading-tight",
                                                                    children: facility.name
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                    className: "text-gray-600 mt-0.5",
                                                                    children: [
                                                                        facility.suburb,
                                                                        ", ",
                                                                        facility.state
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "flex flex-wrap items-center gap-x-4 gap-y-1 mt-3 text-sm text-slate-600",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "inline-flex items-center gap-1.5",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c978075baab28645$export$2e2bcd8739ae039), {
                                                                                    size: 15,
                                                                                    className: "text-sky-600 shrink-0",
                                                                                    "aria-hidden": true
                                                                                }),
                                                                                facility.distance,
                                                                                "km away"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "inline-flex items-center gap-1.5",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04b006b04b8c21eb$export$2e2bcd8739ae039), {
                                                                                    size: 15,
                                                                                    className: "text-amber-500 shrink-0",
                                                                                    "aria-hidden": true
                                                                                }),
                                                                                facility.rating,
                                                                                "/5"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "inline-flex items-center gap-1.5 font-medium text-slate-800",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                                                                                    size: 15,
                                                                                    className: "text-emerald-600 shrink-0",
                                                                                    "aria-hidden": true
                                                                                }),
                                                                                "$",
                                                                                facility.radPrice.toLocaleString()
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "mt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-xs font-semibold uppercase tracking-wide text-slate-500",
                                                                            children: "Care levels"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "text-sm text-gray-800 mt-0.5",
                                                                            children: facility.careLevels.join(', ')
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "mt-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-xs font-semibold uppercase tracking-wide text-slate-500",
                                                                            children: "Amenities"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "text-sm text-gray-800 mt-0.5",
                                                                            children: facility.amenities.join(', ')
                                                                        })
                                                                    ]
                                                                }),
                                                                facility.websiteUrl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                    href: facility.websiteUrl,
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    className: "mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-blue-600 hover:text-blue-800",
                                                                    onClick: (e)=>e.stopPropagation(),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                                            size: 14,
                                                                            "aria-hidden": true
                                                                        }),
                                                                        "Visit website",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-xs font-normal text-gray-500",
                                                                            children: "(demo URL)"
                                                                        })
                                                                    ]
                                                                }) : null
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "shrink-0 flex lg:flex-col justify-end lg:justify-center gap-2 lg:w-36",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                onClick: ()=>onSelect(facility),
                                                                className: "w-full lg:w-auto px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-all duration-300 font-semibold shadow-sm hover:shadow focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2",
                                                                children: "Select"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, facility.id))
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $5aa88897538e91ba$export$2e2bcd8739ae039 = $5aa88897538e91ba$var$FacilitySearchModal;


/**
 * CoupleValidationModal – Strategy analysis setup for couples: explore alternatives, downsize/rent params, emergency fund.
 * Used by Aged Care flow before suggestion engine. Saves to coupleValidation and can trigger onValidationComplete.
 */ 

var $acw62 = parcelRequire("acw62");








/**
 * Suggestion engine only — include/exclude entity assets in automatic funding suggestions.
 * Spec §9.1.2, Appendix A.6. Shown in Strategy Analysis Setup (not Client Profile Step 5).
 */ 
parcelRequire("acw62");

function $b389a33824abab17$export$bfd0f3f79aa7026b({ value: value, onChange: onChange, compact: compact = false }) {
    const selected = value || 'exclude';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: compact ? 'space-y-3' : 'bg-white border border-amber-200 rounded-xl p-5 shadow-sm space-y-3',
        children: [
            !compact && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-lg font-semibold text-amber-950 mb-1",
                        children: "Trusts and companies in strategy suggestions"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-sm text-slate-600",
                        children: [
                            "We always use these arrangements for Age Pension and care fee estimates. This only affects",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "automatic strategy suggestions"
                            }),
                            " \u2014 not manual control."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                className: "space-y-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                        className: "text-sm font-medium text-gray-800 mb-2",
                        children: "Do you want us to include assets held in trusts or companies when suggesting ways to pay for care?"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        className: `flex items-start gap-3 p-3 rounded-lg border-2 cursor-pointer transition-all ${selected === 'exclude' ? 'border-amber-500 bg-white ring-2 ring-amber-200' : 'border-gray-200 bg-white hover:border-amber-300'}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "radio",
                                name: "structureFundingInSuggestions",
                                value: "exclude",
                                checked: selected === 'exclude',
                                onChange: ()=>onChange('exclude'),
                                className: "h-4 w-4 text-amber-600 border-gray-300 focus:ring-amber-500 mt-1"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-sm text-gray-800",
                                children: "No \u2014 suggest funding from personal assets only"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        className: `flex items-start gap-3 p-3 rounded-lg border-2 cursor-pointer transition-all ${selected === 'include' ? 'border-amber-500 bg-white ring-2 ring-amber-200' : 'border-gray-200 bg-white hover:border-amber-300'}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "radio",
                                name: "structureFundingInSuggestions",
                                value: "include",
                                checked: selected === 'include',
                                onChange: ()=>onChange('include'),
                                className: "h-4 w-4 text-amber-600 border-gray-300 focus:ring-amber-500 mt-1"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-sm text-gray-800",
                                children: "Yes \u2014 you may suggest using trust or company assets"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-xs text-slate-700",
                children: (0, $bd80071df75c742b$export$ec9c57e3c77471a1)
            })
        ]
    });
}


// Default the downsized-home value to ~70% of the current home — a realistic "downsize but
// stay in the area" assumption that scales to each client (rather than a flat figure).
// Falls back to the user's saved value once they've set one.
const $c2c0deaff316e027$var$resolveDownsizeNewHomeValue = (coupleValidation, factFind)=>{
    const currentHomeValue = factFind?.home?.value || 0;
    const default70 = currentHomeValue > 0 ? Math.round(currentHomeValue * 0.7) : undefined;
    return coupleValidation.downsizeNewHomeValue ?? default70;
};
const $c2c0deaff316e027$var$defaultFutureFields = (coupleValidation, defaultPartnerRoomPrice)=>({
        enablePartnerFutureEvent: coupleValidation.enablePartnerFutureEvent ?? false,
        partnerEntryYear: coupleValidation.partnerEntryYear ?? 3,
        partnerFutureRoomPrice: Number(coupleValidation.partnerFutureRoomPrice) > 0 ? coupleValidation.partnerFutureRoomPrice : defaultPartnerRoomPrice || 500000,
        originalEntrantAliveAtPartnerEntry: coupleValidation.originalEntrantAliveAtPartnerEntry ?? true
    });
const $c2c0deaff316e027$var$CoupleValidationModal = ({ isOpen: isOpen, onClose: onClose, coupleValidation: coupleValidation, setCoupleValidation: setCoupleValidation, factFind: factFind, setFactFind: setFactFind, scenarioLivingExpenses: scenarioLivingExpenses, onValidationComplete: onValidationComplete, defaultPartnerRoomPrice: defaultPartnerRoomPrice = 0, inline: inline = false, inlineHeading: inlineHeading = 'A few things change the answer.', extraTop: extraTop = null, continueLabel: continueLabel = 'Continue to Analysis' })=>{
    const [localValidation, setLocalValidation] = (0, $acw62.useState)(()=>({
            ...coupleValidation,
            ...$c2c0deaff316e027$var$defaultFutureFields(coupleValidation, defaultPartnerRoomPrice),
            downsizeNewHomeValue: $c2c0deaff316e027$var$resolveDownsizeNewHomeValue(coupleValidation, factFind)
        }));
    const [structureFundingInSuggestions, setStructureFundingInSuggestions] = (0, $acw62.useState)(()=>factFind?.structureFundingInSuggestions || 'exclude');
    /*
     * THE ANNUITY WILLINGNESS QUESTION (owner, 24-25 Sep 2026), asked here because aged care has a
     * Strategy Analysis Setup of its own — the modules without one ask it as a gate instead
     * (AnnuityPreferenceGate). Same answer, same client record, asked once.
     *
     * Since 21 Oct 2026 (guaranteed income review) it is the ONE question component every module uses
     * (GuaranteedIncomeQuestions: three answers and the share), and only an answer given here is written on
     * save — the client's earlier answer is never overwritten by what this pop-over happened to show.
     */ const [annuityGoals, setAnnuityGoals] = (0, $acw62.useState)(null);
    const isCouple = factFind?.adviceFor === 'couple';
    // The question reads the client's answer with any change made here on top, until save.
    const factFindWithAnswer = annuityGoals ? {
        ...factFind,
        goals: {
            ...factFind?.goals || {},
            ...annuityGoals
        }
    } : factFind;
    const annuityInvestable = (0, $ef4d0d82ab48599b$export$1bb55a1f37679989)(factFind, Number(localValidation.emergencyFund) || 0);
    const annuityForWhom = factFind?.goals?.aged_care_for;
    const annuityPerson = (annuityForWhom === 'partner' ? factFind?.partner?.firstName : factFind?.client?.firstName) || '';
    const annuityPersonName = annuityForWhom === 'both' || !annuityPerson || !isCouple && (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind).you ? undefined : annuityPerson;
    const hasStructures = (factFind?.structures || []).length > 0;
    const hasHome = (factFind?.home?.value || 0) > 0;
    const showCoupleSetup = isCouple && hasHome;
    /** Both of the couple entering care: the home is sold, not downsized, and there is nobody to house. */ const bothInCare = isCouple && factFind?.goals?.aged_care_for === 'both';
    const partnerFirst = (factFind?.partner?.firstName || '').trim();
    const clientFirst = (factFind?.client?.firstName || '').trim();
    const partnerName = partnerFirst || 'your partner';
    const clientName = clientFirst || 'the person entering care first';
    (0, $acw62.useEffect)(()=>{
        if (!isOpen) return;
        setLocalValidation({
            ...coupleValidation,
            ...$c2c0deaff316e027$var$defaultFutureFields(coupleValidation, defaultPartnerRoomPrice),
            downsizeNewHomeValue: $c2c0deaff316e027$var$resolveDownsizeNewHomeValue(coupleValidation, factFind)
        });
        setStructureFundingInSuggestions(factFind?.structureFundingInSuggestions || 'exclude');
        setAnnuityGoals(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen,
        coupleValidation,
        defaultPartnerRoomPrice,
        factFind?.structureFundingInSuggestions,
        factFind?.home?.value
    ]);
    const handleSave = ()=>{
        const toSave = {
            ...localValidation,
            suggestionEngineSetupComplete: true
        };
        if (toSave.enablePartnerFutureEvent && (!toSave.partnerFutureRoomPrice || Number(toSave.partnerFutureRoomPrice) <= 0)) toSave.partnerFutureRoomPrice = defaultPartnerRoomPrice > 0 ? defaultPartnerRoomPrice : 500000;
        if (setFactFind) setFactFind((prev)=>({
                ...prev,
                ...hasStructures ? {
                    structureFundingInSuggestions: structureFundingInSuggestions
                } : {},
                ...annuityGoals ? {
                    goals: {
                        ...prev.goals || {},
                        ...annuityGoals
                    }
                } : {}
            }));
        setCoupleValidation(toSave);
        onClose();
        // Automatically proceed to suggestion engine after validation
        if (onValidationComplete) setTimeout(()=>{
            onValidationComplete();
        }, 100);
    };
    const handleCancel = ()=>{
        setLocalValidation({
            ...coupleValidation,
            ...$c2c0deaff316e027$var$defaultFutureFields(coupleValidation, defaultPartnerRoomPrice)
        });
        onClose();
    };
    /*
     * The questions themselves, built once and rendered the same way in both modes.
     */ const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            showCoupleSetup && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bg-white border border-blue-200 rounded-xl p-5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-start gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "p-2 bg-blue-100 rounded-lg",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                        className: "w-5 h-5 text-blue-600",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 2,
                                            d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: "text-lg font-semibold text-blue-800 mb-2",
                                            children: "Your Current Preference"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "bg-white rounded-lg p-3 border border-blue-200",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-blue-700 font-medium",
                                                        children: [
                                                            factFind.partner?.livingArrangement === 'remainHome' && 'Partner remains in family home',
                                                            factFind.partner?.livingArrangement === 'downsize' && 'Sell home & downsize',
                                                            factFind.partner?.livingArrangement === 'rent' && 'Sell home & rent elsewhere',
                                                            !factFind.partner?.livingArrangement && 'Partner remains in family home'
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "px-2 py-1 bg-blue-100 text-blue-700 text-xs font-semibold rounded-full",
                                                        children: "\u2713 Confirmed"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-blue-600 text-sm mt-2",
                                            children: "This preference will always be included in our analysis"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white border border-blue-200 rounded-xl p-5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-start gap-3 mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "p-2 bg-blue-100 rounded-lg",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                            className: "w-5 h-5 text-blue-600",
                                            fill: "none",
                                            stroke: "currentColor",
                                            viewBox: "0 0 24 24",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                strokeWidth: 2,
                                                d: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-lg font-bold text-blue-800 mb-2",
                                                children: "Would you like us to explore additional options?"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-blue-700 leading-relaxed",
                                                children: "We'll always model your preferred arrangement, but we can also explore alternative scenarios to see if they might provide better financial outcomes. This gives you a complete picture of all possibilities."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: `flex items-start gap-3 p-3 rounded-lg border-2 cursor-pointer transition-all duration-200 ${localValidation.exploreAlternatives === false ? 'border-blue-500 bg-blue-50 shadow-md' : 'border-gray-200 bg-white hover:border-blue-300 hover:bg-blue-50'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "radio",
                                                name: "exploreAlternatives",
                                                value: "no",
                                                checked: localValidation.exploreAlternatives === false,
                                                onChange: ()=>setLocalValidation((prev)=>({
                                                            ...prev,
                                                            exploreAlternatives: false
                                                        })),
                                                className: "h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500 mt-1"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "font-semibold text-gray-800 mb-1",
                                                        children: "Focus on my preference only"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "text-gray-600 text-sm",
                                                        children: "Model only your stated arrangement to keep the analysis focused"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: `flex items-start gap-3 p-3 rounded-lg border-2 cursor-pointer transition-all duration-200 ${localValidation.exploreAlternatives === true ? 'border-blue-500 bg-blue-50 shadow-md' : 'border-gray-200 bg-white hover:border-blue-300 hover:bg-blue-50'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "radio",
                                                name: "exploreAlternatives",
                                                value: "yes",
                                                checked: localValidation.exploreAlternatives === true,
                                                onChange: ()=>setLocalValidation((prev)=>({
                                                            ...prev,
                                                            exploreAlternatives: true
                                                        })),
                                                className: "h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500 mt-1"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "font-semibold text-gray-800 mb-1",
                                                        children: "Explore all possibilities"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "text-gray-600 text-sm",
                                                        children: "Include your preference plus alternative scenarios for comprehensive analysis"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    localValidation.exploreAlternatives === true && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white border border-blue-200 rounded-xl p-5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-start gap-3 mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "p-2 bg-blue-100 rounded-lg",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                            className: "w-5 h-5 text-blue-600",
                                            fill: "none",
                                            stroke: "currentColor",
                                            viewBox: "0 0 24 24",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                strokeWidth: 2,
                                                d: "M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-lg font-semibold text-blue-800 mb-1",
                                                children: "What happens to the family home"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-blue-700 text-sm",
                                                children: bothInCare ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        "With ",
                                                        clientName,
                                                        " and ",
                                                        partnerName,
                                                        " both in care, nobody is left living in the family home. We model keeping it, letting it out, and selling it \u2014 the selling costs below price the sale. Rough numbers are fine."
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        "When ",
                                                        clientName,
                                                        " moves into care, ",
                                                        partnerName,
                                                        " stays in the family home \u2014 unless it is sold or let out. We model all three; these figures price the last two. Rough numbers are fine."
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                                children: [
                                    !bothInCare && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-white rounded-lg p-3 border border-blue-200",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                label: "New home value (if downsizing)",
                                                value: localValidation.downsizeNewHomeValue ?? '',
                                                onChange: (v)=>setLocalValidation((prev)=>({
                                                            ...prev,
                                                            downsizeNewHomeValue: v ?? 0
                                                        })),
                                                placeholder: "Estimated downsized home value",
                                                className: ""
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-xs text-gray-500 mt-1",
                                                children: "Defaults to ~70% of your current home value \u2014 adjust as needed"
                                            })
                                        ]
                                    }),
                                    !bothInCare && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $89d49377c5c902f9$export$2e2bcd8739ae039), {
                                        state: typeof localValidation.newHomeState === 'string' ? localValidation.newHomeState : '',
                                        onStateChange: (v)=>setLocalValidation((prev)=>({
                                                    ...prev,
                                                    newHomeState: v
                                                })),
                                        newHomePrice: localValidation.downsizeNewHomeValue,
                                        duty: typeof localValidation.stampDuty === 'number' ? localValidation.stampDuty : '',
                                        onDutyChange: (v)=>setLocalValidation((prev)=>({
                                                    ...prev,
                                                    stampDuty: v
                                                })),
                                        fieldClassName: "bg-white rounded-lg p-3 border border-blue-200"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-white rounded-lg p-3 border border-blue-200",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                label: "Selling costs ($)",
                                                value: localValidation.sellingCosts ?? '',
                                                onChange: (v)=>setLocalValidation((prev)=>({
                                                            ...prev,
                                                            sellingCosts: v
                                                        })),
                                                placeholder: "e.g. 75000",
                                                className: ""
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-xs text-gray-500 mt-1",
                                                children: "Estimated selling costs in dollars"
                                            })
                                        ]
                                    }),
                                    !bothInCare && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "bg-white rounded-lg p-3 border border-blue-200",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                            label: `Annual rent cost (if ${partnerName} rents elsewhere)`,
                                            value: localValidation.partnerAnnualRent ?? '',
                                            onChange: (v)=>setLocalValidation((prev)=>({
                                                        ...prev,
                                                        partnerAnnualRent: v ?? 0
                                                    })),
                                            placeholder: "20000",
                                            className: ""
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            hasStructures && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b389a33824abab17$export$bfd0f3f79aa7026b), {
                value: structureFundingInSuggestions,
                onChange: setStructureFundingInSuggestions
            }),
            isCouple && factFind?.goals?.aged_care_for !== 'both' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white border border-violet-200 rounded-xl p-5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-start justify-between gap-3 mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-start gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "p-2 bg-violet-100 rounded-lg",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                            className: "w-5 h-5 text-violet-700",
                                            fill: "none",
                                            stroke: "currentColor",
                                            viewBox: "0 0 24 24",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                strokeWidth: 2,
                                                d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-lg font-semibold text-violet-950 mb-1",
                                                children: "Future life events (optional)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-violet-900/90 text-sm",
                                                children: [
                                                    "If ",
                                                    partnerName,
                                                    " may move into residential aged care later, you can model approximate timing and a second room price. This adds a conditional scenario in the Suggestion Engine \u2014 it does not replace your baseline analysis."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setLocalValidation((prev)=>({
                                            ...prev,
                                            enablePartnerFutureEvent: !prev.enablePartnerFutureEvent
                                        })),
                                className: `shrink-0 px-3 py-1.5 rounded-lg text-sm font-semibold transition-colors ${localValidation.enablePartnerFutureEvent ? 'bg-violet-700 text-white hover:bg-violet-800' : 'bg-white text-violet-900 border border-violet-300 hover:bg-violet-50'}`,
                                children: localValidation.enablePartnerFutureEvent ? 'Enabled' : 'Disabled'
                            })
                        ]
                    }),
                    localValidation.enablePartnerFutureEvent && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "bg-white rounded-lg p-3 border border-violet-100",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "grid grid-cols-1 gap-4 sm:grid-cols-2 sm:items-start",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex min-w-0 flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                    className: "mb-2 block text-sm font-medium text-gray-700",
                                                    children: [
                                                        "Approximate year ",
                                                        partnerName,
                                                        " enters care"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "mb-2 min-h-[2.5rem] text-xs leading-snug text-gray-500",
                                                    children: "Projection year from today (1 = first year; aligns with your projection horizon)."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "number",
                                                    min: 1,
                                                    max: 10,
                                                    value: localValidation.partnerEntryYear ?? 3,
                                                    onChange: (e)=>setLocalValidation((prev)=>({
                                                                ...prev,
                                                                partnerEntryYear: Math.max(1, parseInt(e.target.value, 10) || 1)
                                                            })),
                                                    className: "w-full rounded-lg border border-gray-300 px-3 py-2"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex min-w-0 flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                    className: "mb-2 block text-sm font-medium text-gray-700",
                                                    children: [
                                                        "Second room price for ",
                                                        partnerName,
                                                        " ($)"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "mb-2 min-h-[2.5rem] text-xs leading-snug text-gray-500",
                                                    children: "Defaults to the current facility accommodation price if left blank when saving."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                    label: "",
                                                    value: localValidation.partnerFutureRoomPrice ?? '',
                                                    onChange: (v)=>setLocalValidation((prev)=>({
                                                                ...prev,
                                                                partnerFutureRoomPrice: v ?? 0
                                                            })),
                                                    placeholder: "e.g. facility accommodation price",
                                                    className: ""
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white rounded-lg p-3 border border-violet-100",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "block text-sm font-medium text-gray-800 mb-1",
                                        children: [
                                            clientName,
                                            " at ",
                                            partnerName,
                                            "'s entry date"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-xs text-gray-600 mb-2",
                                        children: [
                                            "Affects whether an earlier refundable deposit is assumed available to fund ",
                                            partnerName,
                                            "'s room in this illustration."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                                        className: "text-xs text-gray-600 group mb-5",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("summary", {
                                                className: "cursor-pointer text-violet-700 font-medium list-none flex items-center gap-1 pb-1",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "underline decoration-violet-300 underline-offset-2 group-open:no-underline",
                                                    children: "Why we ask"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-2 mb-1 leading-relaxed text-gray-600 border-l-2 border-violet-200 pl-3",
                                                children: [
                                                    "A refundable accommodation deposit stays linked to the resident who paid it until their arrangement ends. Here, if ",
                                                    clientName,
                                                    " is still living when ",
                                                    partnerName,
                                                    " enters care, we do not assume that deposit is available for ",
                                                    partnerName,
                                                    "'s admission. If ",
                                                    clientName,
                                                    " has died before ",
                                                    partnerName,
                                                    " enters care, this model assumes any refundable amount still due back may reduce funding needed for ",
                                                    partnerName,
                                                    "'s room. In practice, timing, provider agreements, and estate matters vary \u2014 this is a simple illustration only, not a guarantee. Always confirm details with your aged care provider."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-2 grid w-full grid-cols-2 gap-3 pt-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setLocalValidation((prev)=>({
                                                            ...prev,
                                                            originalEntrantAliveAtPartnerEntry: true
                                                        })),
                                                className: `py-2.5 px-3 rounded-lg border text-sm font-medium text-center min-h-[42px] ${localValidation.originalEntrantAliveAtPartnerEntry ? 'bg-violet-100 text-violet-900 border-violet-300 shadow-sm' : 'bg-white text-gray-600 border-gray-200 hover:bg-gray-50'}`,
                                                children: "Still alive"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setLocalValidation((prev)=>({
                                                            ...prev,
                                                            originalEntrantAliveAtPartnerEntry: false
                                                        })),
                                                className: `py-2.5 px-3 rounded-lg border text-sm font-medium text-center min-h-[42px] ${!localValidation.originalEntrantAliveAtPartnerEntry ? 'bg-violet-100 text-violet-900 border-violet-300 shadow-sm' : 'bg-white text-gray-600 border-gray-200 hover:bg-gray-50'}`,
                                                children: "Has passed"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white border border-green-200 rounded-xl p-5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-start gap-3 mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "p-2 bg-green-100 rounded-lg",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    className: "w-5 h-5 text-green-600",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: 2,
                                        d: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-lg font-semibold text-green-800 mb-1",
                                        children: "How much should stay in the bank for emergencies?"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-green-700 text-sm",
                                        children: "The plans will not spend this on the deposit."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white rounded-lg p-4 border border-green-200",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "relative mb-3",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                    label: "Emergency Fund Amount ($)",
                                    value: localValidation.emergencyFund ?? '',
                                    onChange: (v)=>setLocalValidation((prev)=>({
                                                ...prev,
                                                emergencyFund: v ?? 0
                                            })),
                                    placeholder: "50000",
                                    className: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "rounded-lg border border-green-200 bg-white p-3 mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center justify-between mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm font-semibold text-green-800",
                                                children: "Recommended guidance:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-lg font-bold text-green-700",
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.max((0, $5941a0d5c38ddae8$export$ff3e96665dc0c2f8), (scenarioLivingExpenses || 0) / 2))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-xs text-green-600",
                                        children: [
                                            "The greater of ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "6 months of your adjusted living expenses"
                                            }),
                                            " (",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(scenarioLivingExpenses || 0),
                                            " \xf7 2) or ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $5941a0d5c38ddae8$export$ff3e96665dc0c2f8))
                                            }),
                                            " \u2014 a retiree's emergencies tend to be lumpy one-off costs. You can keep a higher amount if you prefer a larger buffer."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>{
                                    const guidance = Math.max((0, $5941a0d5c38ddae8$export$ff3e96665dc0c2f8), (scenarioLivingExpenses || 0) / 2);
                                    setLocalValidation((prev)=>({
                                            ...prev,
                                            emergencyFund: guidance
                                        }));
                                },
                                className: "w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-semibold",
                                children: "Use this amount"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white border border-slate-200 rounded-xl p-5",
                "data-testid": "setup-guaranteed-income",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-lg font-semibold text-slate-900 mb-3",
                        children: "Guaranteed income for life"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f92088f7258458cc$export$2e2bcd8739ae039), {
                        factFind: factFindWithAnswer,
                        onGoals: (patch)=>setAnnuityGoals((prev)=>({
                                    ...prev || {},
                                    ...patch
                                })),
                        personName: annuityPersonName,
                        investable: annuityInvestable.investable,
                        investableLead: annuityInvestable.lead,
                        investableMadeOf: annuityInvestable.madeOf,
                        investableNote: (0, $ef4d0d82ab48599b$export$edd3a4620d1471aa),
                        inCare: true,
                        idPrefix: "cv"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-gray-500 mt-2",
                        children: "Setting one up takes a quote from the insurer, and then an application. Saved to the client profile and used by every module, so you'll only be asked once."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white border border-blue-200 rounded-xl p-5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-start gap-3 mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "p-2 bg-blue-100 rounded-lg",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    className: "w-5 h-5 text-blue-600",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: 2,
                                        d: "M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-lg font-semibold text-blue-800 mb-1",
                                        children: "Investing freed-up money"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-blue-700 text-sm",
                                        children: "Some strategies free up money \u2014 selling or downsizing the home, for example. How would that money be invested?"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white rounded-lg p-4 border border-blue-200",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-1",
                                htmlFor: "new-money-profile",
                                children: "Investment approach"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                id: "new-money-profile",
                                className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
                                value: factFind?.goals?.newMoneyInvestmentProfile || '',
                                onChange: (e)=>{
                                    const value = e.target.value;
                                    if (!setFactFind) return;
                                    setFactFind((prev)=>{
                                        const goals = {
                                            ...prev.goals || {}
                                        };
                                        if (value) goals.newMoneyInvestmentProfile = value;
                                        else delete goals.newMoneyInvestmentProfile;
                                        return {
                                            ...prev,
                                            goals: goals
                                        };
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "Not sure \u2014 assume Conservative (most cautious)"
                                    }),
                                    (0, $0f2c0a6799fe36da$export$56315028e4277c0c).map((id)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: id,
                                            children: (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[id].label
                                        }, id))
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-xs text-gray-500 mt-2",
                                children: "Saved to the client profile, so you'll only be asked once. Left unanswered, strategies that invest are priced conservatively and the results say so."
                            })
                        ]
                    })
                ]
            })
        ]
    });
    if (!isOpen) return null;
    /*
     * INLINE (version A, owner decision 17 Oct 2026): the same questions, asked where the plans will
     * appear, on the first visit to step 3 — no pop-over, no "Continue to Analysis". A reader can accept
     * every suggested answer and press "Show me the plans" without understanding any of it.
     */ if (inline) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
        "data-testid": "engine-setup-inline",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[11px] font-bold uppercase tracking-[0.1em] text-slate-400",
                children: "Before we test the ways to pay"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "mt-1 text-[22px] font-bold leading-tight tracking-tight text-slate-900",
                children: inlineHeading
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-1 text-[14px] text-slate-600",
                children: "We've filled in what we'd suggest, and why. Change any of them, or just go on \u2014 the plans appear on the next screen."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-5 space-y-5",
                children: [
                    extraTop,
                    content
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-6 flex flex-wrap items-center justify-between gap-3 border-t border-slate-200 pt-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-[13px] text-slate-500",
                        children: "We'll test a few hundred ways to pay for the room and show the ones that best fit what matters to you."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: handleSave,
                        className: "inline-flex h-11 items-center gap-2 rounded-lg bg-blue-600 hover:bg-blue-700 px-5 text-[14px] font-semibold text-white shadow-sm ",
                        children: [
                            continueLabel,
                            " \u2192"
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white rounded-2xl shadow-xl max-w-2xl w-full max-h-[85vh] overflow-hidden",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "bg-brand-navy text-white p-6 relative overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "absolute inset-0 bg-black opacity-10"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "relative z-10",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-between items-start",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "p-2 bg-white bg-opacity-20 rounded-xl backdrop-blur-sm",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                    className: "w-6 h-6",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    viewBox: "0 0 24 24",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round",
                                                        strokeWidth: 2,
                                                        d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                        className: "text-2xl font-bold mb-1",
                                                        children: "Strategy Analysis Setup"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-blue-100",
                                                        children: "Let's explore the best funding options for your situation"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: handleCancel,
                                        className: "text-white hover:text-blue-200 text-2xl leading-none transition-colors p-1 hover:bg-white hover:bg-opacity-10 rounded-full",
                                        children: "\xd7"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "p-6 overflow-y-auto max-h-[calc(85vh-180px)]",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "space-y-6",
                        children: content
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex justify-end gap-3 p-6 border-t border-gray-200 bg-gray-50",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: handleCancel,
                            className: "px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-all duration-200 font-semibold",
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: handleSave,
                            className: "px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-all duration-200 font-semibold shadow-md hover:shadow-lg",
                            children: continueLabel
                        })
                    ]
                })
            ]
        })
    });
};
var $c2c0deaff316e027$export$2e2bcd8739ae039 = $c2c0deaff316e027$var$CoupleValidationModal;


/**
 * MentalCapacityProcessModal – state-specific guardianship and administration process information.
 * Used from Client Profile when user needs guidance on mental capacity and legal documentation.
 */ 

var $acw62 = parcelRequire("acw62");

const $2b22d82a0ef1a336$var$MentalCapacityProcessModal = ({ onClose: onClose })=>{
    const [selectedState, setSelectedState] = (0, $acw62.useState)('');
    const stateProcesses = {
        'NSW': {
            tribunal: 'NSW Civil and Administrative Tribunal (NCAT)',
            process: 'Apply for guardianship and/or financial management orders through NCAT. You will need medical evidence confirming lack of capacity, an application form, and supporting documentation. The tribunal will review your application and may hold a hearing.',
            timeline: 'Typically 3-6 months from application to order',
            costs: 'Application fees apply (may be waived in hardship cases). Legal representation recommended but not mandatory.',
            website: 'https://www.ncat.nsw.gov.au/',
            contact: '1300 006 228'
        },
        'VIC': {
            tribunal: 'Victorian Civil and Administrative Tribunal (VCAT)',
            process: 'Apply for guardianship and/or administration orders through VCAT. Requires medical assessments, application forms, and evidence of the need for an order. The tribunal will assess whether the person needs a guardian/administrator.',
            timeline: 'Generally 2-4 months from application to hearing',
            costs: 'Application fees apply. You may need to pay for medical assessments. Legal costs vary.',
            website: 'https://www.vcat.vic.gov.au/',
            contact: '1300 018 228'
        },
        'QLD': {
            tribunal: 'Queensland Civil and Administrative Tribunal (QCAT)',
            process: 'Apply for guardianship and/or administration orders. Medical evidence is essential. QCAT will assess if the person has impaired capacity and whether an order is necessary to protect their interests.',
            timeline: 'Usually 3-5 months from application',
            costs: 'Application fees apply. Medical assessment costs and potential legal fees.',
            website: 'https://www.qcat.qld.gov.au/',
            contact: '1300 753 228'
        },
        'WA': {
            tribunal: 'State Administrative Tribunal (SAT)',
            process: 'Apply for guardianship and/or administration orders through SAT. Requires medical reports, application documentation, and evidence that an order is needed.',
            timeline: 'Approximately 3-6 months',
            costs: 'Application fees and potential costs for medical assessments and legal representation.',
            website: 'https://www.sat.justice.wa.gov.au/',
            contact: '(08) 9219 3111'
        },
        'SA': {
            tribunal: 'South Australian Civil and Administrative Tribunal (SACAT)',
            process: 'Apply for guardianship and/or administration orders. Medical evidence confirming lack of capacity is required. SACAT will determine if orders are necessary and appropriate.',
            timeline: 'Typically 2-4 months',
            costs: 'Application fees apply. Medical assessment and potential legal costs.',
            website: 'https://www.sacat.sa.gov.au/',
            contact: '1800 723 767'
        },
        'TAS': {
            tribunal: 'Tasmanian Civil and Administrative Tribunal (TASCAT)',
            process: 'Apply for guardianship and/or administration orders through TASCAT. Medical evidence and application forms required. The tribunal will assess the need for orders.',
            timeline: 'Generally 2-4 months',
            costs: 'Fees may apply. Medical assessment costs and potential legal fees.',
            website: 'https://www.tascat.tas.gov.au/',
            contact: '(03) 6165 7517'
        },
        'ACT': {
            tribunal: 'ACT Civil and Administrative Tribunal (ACAT)',
            process: 'Apply for guardianship and/or management orders. Medical assessments are essential. ACAT will review the application and make orders if appropriate.',
            timeline: 'Typically 2-4 months',
            costs: 'Application fees apply. Medical assessment costs and potential legal fees.',
            website: 'https://www.acat.act.gov.au/',
            contact: '(02) 6207 1740'
        },
        'NT': {
            tribunal: 'Northern Territory Civil and Administrative Tribunal (NTCAT)',
            process: 'Apply for guardianship and/or administration orders through NTCAT. Medical evidence confirming impaired capacity is required. The tribunal will assess the application.',
            timeline: 'Generally 2-4 months',
            costs: 'Fees may apply. Medical assessment and potential legal costs.',
            website: 'https://ntcat.nt.gov.au/',
            contact: '(08) 8999 0064'
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center justify-between p-6 border-b border-gray-200",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "text-2xl font-bold text-gray-900",
                                    children: "Mental Capacity & Legal Documentation Process"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-gray-600 mt-1",
                                    children: "State-specific information for guardianship and administration orders"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: onClose,
                            className: "text-gray-400 hover:text-gray-600 transition-all duration-300 hover:scale-110",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 24
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex-1 overflow-y-auto p-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mb-6",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-2",
                                    children: "Select your state or territory:"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                    value: selectedState,
                                    onChange: (e)=>setSelectedState(e.target.value),
                                    className: "w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "",
                                            children: "Choose a state or territory..."
                                        }),
                                        Object.keys(stateProcesses).map((state)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: state,
                                                children: state
                                            }, state))
                                    ]
                                })
                            ]
                        }),
                        selectedState && stateProcesses[selectedState] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white border-l-4 border-blue-400 p-6 rounded-r-lg",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                    className: "text-xl font-bold text-gray-900 mb-4",
                                    children: [
                                        selectedState,
                                        " - Guardianship & Administration Process"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                    className: "font-semibold text-gray-800 mb-2",
                                                    children: "Tribunal:"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-gray-700",
                                                    children: stateProcesses[selectedState].tribunal
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                    className: "font-semibold text-gray-800 mb-2",
                                                    children: "Application Process:"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-gray-700",
                                                    children: stateProcesses[selectedState].process
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                    className: "font-semibold text-gray-800 mb-2",
                                                    children: "Typical Timeline:"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-gray-700",
                                                    children: stateProcesses[selectedState].timeline
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                    className: "font-semibold text-gray-800 mb-2",
                                                    children: "Costs:"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-gray-700",
                                                    children: stateProcesses[selectedState].costs
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "border-t border-blue-200 pt-4 mt-4",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                    className: "font-semibold text-gray-800 mb-2",
                                                    children: "Important Next Steps:"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                    className: "list-disc list-inside space-y-2 text-gray-700",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            children: "Gather medical evidence confirming lack of mental capacity (from GP, geriatrician, or psychiatrist)"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            children: "Contact the tribunal to obtain application forms and understand requirements"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            children: "Consider consulting with a solicitor specializing in elder law and guardianship"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            children: "Prepare supporting documentation demonstrating the need for orders"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            children: "Submit application and attend any required hearings"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "bg-white p-4 rounded-lg border border-blue-200 mt-4",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                    className: "font-semibold text-gray-800 mb-2",
                                                    children: "Contact Information:"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-gray-700 mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Website:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                            href: stateProcesses[selectedState].website,
                                                            target: "_blank",
                                                            rel: "noopener noreferrer",
                                                            className: "text-blue-600 hover:underline",
                                                            children: stateProcesses[selectedState].website
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-gray-700",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Phone:"
                                                        }),
                                                        " ",
                                                        stateProcesses[selectedState].contact
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        !selectedState && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "bg-gray-50 border border-gray-200 p-6 rounded-lg text-center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-600",
                                children: "Please select your state or territory to view specific information about the guardianship and administration process."
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mt-6 p-4 bg-white border border-slate-200 border-l-4 border-l-amber-400 rounded-r-lg",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                    className: "font-semibold text-amber-800 mb-2",
                                    children: "\u26A0\uFE0F Important Considerations:"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    className: "list-disc list-inside space-y-1 text-slate-700 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "This process can be lengthy, stressful, and costly for families"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "If the person still has capacity, they should create a Will and EPOA immediately"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Legal advice is strongly recommended before applying to tribunals"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Each state has specific requirements and processes - this is general information only"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Consider seeking support from elder law solicitors or advocacy services"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "border-t border-gray-200 p-4 flex justify-end",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: onClose,
                        className: "px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors",
                        children: "Close"
                    })
                })
            ]
        })
    });
};
var $2b22d82a0ef1a336$export$2e2bcd8739ae039 = $2b22d82a0ef1a336$var$MentalCapacityProcessModal;









var $acw62 = parcelRequire("acw62");


/**
 * THE ANNUITY CHOICE, AS THREE QUESTIONS ANSWERED TOGETHER.
 *
 * Owner's standing challenge, 24 Sep 2026: the app is sold direct to consumers and gives personal
 * advice, so being technically right is only half the job — the client has to be able to follow it.
 *
 * The annuity screen used to ask one question, "how much do you want back?", on a slider whose label
 * ("Leave some money to your family at the end?") read as "at the end of your life". For a client in
 * residential care, whose actual worry is living a long time, that label appeared to answer the worry
 * and answered the opposite: the money comes back in full only if death comes SOON. Meanwhile the
 * third question a client always asks — what if I need it back? — was answered nowhere, and two
 * screens answered it wrongly by saying the money was locked away for good.
 *
 * So the choice is now three cards, each answering all three questions at once:
 *
 *      What do I get?            What does my family get?        What if I need it back?
 *
 * Two of the three are shapes we price from the published rate sheet and model end to end. The
 * third, the full guarantee, is shown but never modelled on a guess — see below.
 *
 * WHY THE THIRD CARD CANNOT BE MODELLED WITHOUT A QUOTE. No single annuity pays the whole amount to
 * the estate whenever death comes: the capital access schedule is what buys the 60% assets-test
 * treatment, and a product paying 100% for life would be counted in full. Providers build this shape
 * as TWO things bought together — a schedule-compliant annuity and a life policy that tops up
 * whatever the annuity would not return. The income can be read off the published table, because the
 * pair is priced as one product. The MEANS TEST cannot: it depends on how the premium splits between
 * the two parts, which only the provider prices, and the insurance half is counted at the greater of
 * the premium paid and its surrender value. So this card shows the income, states the guarantee, and
 * asks for a quote rather than inventing a split. It is never ranked against the other two.
 */ 

var $acw62 = parcelRequire("acw62");




const $57db4ad05023a38c$var$toneClass = {
    income: 'text-blue-700',
    estate: 'text-violet-700',
    access: 'text-slate-800',
    none: 'text-rose-700'
};
const $57db4ad05023a38c$var$AnnuityShapeChoice = ({ purchaseAmount: purchaseAmount, age: age, sex: sex, partnerAge: partnerAge = null, joint: joint = false, indexation: indexation = false, periodYears: periodYears, residualPercent: residualPercent, onChange: onChange, ownerName: ownerName, bothLives: bothLives = null, showGuaranteed: showGuaranteed = false, wantsGuarantee: wantsGuarantee = false, onGuaranteeChange: onGuaranteeChange, onWantQuote: onWantQuote })=>{
    if (!(purchaseAmount > 0) || age == null || !(age > 0)) return null;
    const priceAt = (residual)=>(0, $d697a0cc78e06dde$export$9ad772f55a285440)({
            age: age,
            sex: sex,
            indexation: indexation,
            residualCapital: residual,
            partnerAge: joint ? partnerAge : null
        });
    const nil = priceAt(0);
    const full = priceAt(1);
    const guaranteed = (0, $d697a0cc78e06dde$export$841b99c047c4e0d)({
        age: age,
        sex: sex
    });
    const halfLabel = periodYears ? Number.isInteger(periodYears / 2) ? String(periodYears / 2) : `${Math.floor(periodYears / 2)}\xbd` : null;
    const owner = (ownerName || 'you').trim() || 'you';
    const dies = owner === 'you' ? 'you die' : `${owner} dies`;
    /*
     * THE COLUMN HEADINGS CARRY THE WHOLE DISTINCTION.
     *
     * Owner, 26 Sep 2026, having picked "pay the highest income now" and then seen "the full amount
     * guaranteed to your family, whenever you die" still on offer: "it reads a bit contradictory."
     * It is not contradictory — the income stopping and the capital returning are different things,
     * and the shape that stops the income while guaranteeing the capital is exactly what the market
     * sells for aged care. But nothing on the screen said so. "Income" and "If Joe dies" sat in the
     * same row as though they were alternatives.
     *
     * So the headings now say which is which: the income is what arrives WHILE THE OWNER IS ALIVE,
     * and the death column is a LUMP SUM, not a continuation of payments.
     */ const incomeLabel = 'Income while alive';
    const deathLabel = bothLives ? `Lump sum once ${bothLives} have both died` : owner === 'you' ? 'Lump sum when you die' : `Lump sum when ${owner} dies`;
    const cards = [
        {
            key: 'highestIncome',
            title: 'The highest income',
            selectable: true,
            dimensions: [
                {
                    label: incomeLabel,
                    value: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(purchaseAmount * nil.rate)}/yr`,
                    tone: 'income'
                },
                {
                    label: deathLabel,
                    value: 'nothing',
                    tone: 'none'
                },
                {
                    label: 'If you need it back',
                    value: 'nothing',
                    tone: 'none'
                }
            ]
        },
        {
            key: 'moneyBack',
            title: 'Money back if things change, or if you die early',
            selectable: true,
            dimensions: [
                {
                    label: incomeLabel,
                    value: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(purchaseAmount * full.rate)}/yr`,
                    tone: 'income'
                },
                {
                    label: deathLabel,
                    /*
                     * "for 3½ yrs" read as "this much a year, for three and a half years", which is
                     * the opposite of what it means. It is one payment, made only if death falls
                     * inside that window. Owner-caught on the live screen, 26 Sep 2026.
                     */ value: halfLabel ? `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(purchaseAmount)} if within ${halfLabel} yrs` : (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(purchaseAmount),
                    tone: 'estate'
                },
                /*
                 * "up to $100,000" was true only TODAY (owner-caught, 27 Sep 2026). The cash-out cap
                 * falls in a straight line to nothing over the schedule period, which the table
                 * underneath showed while the card implied a standing figure. A card that has to be
                 * corrected by the table below it is worse than no card.
                 */ {
                    label: 'If you need it back',
                    value: periodYears ? `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(purchaseAmount)} now, nil by ${periodYears} yrs` : `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(purchaseAmount)} now, falling each year`,
                    tone: 'access'
                }
            ]
        }
    ];
    if (showGuaranteed) /*
         * OWNER ON THE LIVE SCREEN, 25 Sep 2026: "when I tried to change 'what matters most to you',
         * it won't let me select 'the full amount guaranteed'." It was deliberately inert, because
         * we cannot model its means test without a quote — but an inert card sitting in a row of
         * selectable ones just reads as broken. It is selectable now: choosing it opens the quote
         * panel and says plainly that the plan cannot be compared until the quote is in. Selecting
         * it does not change the modelled annuity, so nothing is ever ranked on invented numbers.
         */ cards.push({
        key: 'guaranteed',
        title: 'The full amount guaranteed to your family, whenever you die',
        selectable: true,
        note: 'An annuity and a life policy bought together. Only the provider prices the split, so choosing this asks you for their quote.',
        dimensions: [
            {
                label: incomeLabel,
                value: guaranteed.extrapolated ? 'needs a quote' : `about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(purchaseAmount * guaranteed.rate)}/yr`,
                tone: 'income'
            },
            {
                label: deathLabel,
                value: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(purchaseAmount)} always`,
                tone: 'estate'
            },
            {
                label: 'If you need it back',
                value: "some \u2014 your quote states it",
                tone: 'access'
            }
        ]
    });
    const selected = wantsGuarantee ? 'guaranteed' : residualPercent <= 0 ? 'highestIncome' : 'moneyBack';
    const schedule = (0, $5ccd559ea4d04f2e$export$661c19f614fd3b28)({
        purchaseAmount: purchaseAmount,
        residualPct: residualPercent,
        periodYears: periodYears
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "space-y-2",
                children: cards.map((card)=>{
                    const isSelected = selected === card.key;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        "aria-pressed": card.selectable ? isSelected : undefined,
                        onClick: ()=>{
                            if (card.key === 'highestIncome') {
                                onGuaranteeChange?.(false);
                                onChange(0);
                            } else if (card.key === 'moneyBack') {
                                onGuaranteeChange?.(false);
                                onChange(100);
                            } else {
                                onGuaranteeChange?.(true);
                                onWantQuote?.();
                            }
                        },
                        className: `w-full text-left rounded-lg px-3 py-2.5 transition-colors ${isSelected ? 'border-2 border-blue-600 bg-white' : 'border border-slate-200 bg-white hover:bg-slate-50'}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: `text-[12.5px] font-bold mb-1.5 ${isSelected ? 'text-blue-900' : 'text-slate-900'}`,
                                children: card.title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "grid grid-cols-3 gap-2",
                                children: card.dimensions.map((d)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-[9.5px] uppercase tracking-wide font-bold text-slate-500",
                                                children: d.label
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: `text-[13px] font-bold ${$57db4ad05023a38c$var$toneClass[d.tone]}`,
                                                children: d.value
                                            })
                                        ]
                                    }, d.label))
                            }),
                            card.note && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1.5 text-[10.5px] leading-relaxed text-slate-500",
                                children: card.note
                            })
                        ]
                    }, card.key);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[10.5px] leading-relaxed text-slate-500",
                children: [
                    "The lump sum goes to whoever is nominated as beneficiary, or to the estate if nobody is. Income is ",
                    indexation ? "the first year\u2019s payment, rising with prices after that" : 'the same every year',
                    ", from ",
                    nil.extrapolated ? 'an estimate based on the published rates, which stop at age 75' : 'the published rates',
                    ". A quote will differ."
                ]
            }),
            selected === 'guaranteed' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-lg border border-slate-200 border-l-4 border-l-violet-500 bg-white px-3 py-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[11.5px] font-semibold text-slate-800 mb-1",
                        children: "What the guarantee changes"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[11px] leading-relaxed text-slate-600",
                        children: [
                            "Nothing tapers. Your family receives the full ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(purchaseAmount)
                            }),
                            " whenever death comes \u2014 in year two or in year thirty. That is what the life policy is for, and it is the whole difference between this option and the one above, where the lump sum falls to nothing",
                            periodYears ? ` after ${periodYears} years` : ' by the end of the period',
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-1.5 text-[11px] leading-relaxed text-slate-600",
                        children: "The cash-out value does still fall. We cannot put a figure on it the way we can for the other two, because it depends on how the provider splits your money between the annuity and the policy. Their quote states it."
                    })
                ]
            }) : schedule.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                className: "rounded-lg border border-slate-200 border-l-4 border-l-slate-300 bg-white px-3 py-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("summary", {
                        className: "text-[11.5px] font-medium text-blue-700 cursor-pointer list-none",
                        children: "See what those two figures do year by year"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-2 grid grid-cols-3 gap-x-3 gap-y-1 text-[11.5px] text-slate-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-[9.5px] uppercase tracking-wide font-bold text-slate-500",
                                children: "Year"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-[9.5px] uppercase tracking-wide font-bold text-slate-500 text-right",
                                children: deathLabel
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-[9.5px] uppercase tracking-wide font-bold text-slate-500 text-right",
                                children: "If cashed out"
                            }),
                            schedule.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: row.yearsElapsed === 0 ? 'Now' : row.yearsElapsed === periodYears ? `${(0, $5ccd559ea4d04f2e$export$46d1eb5f72e59f31)(row.yearsElapsed)} onward` : (0, $5ccd559ea4d04f2e$export$46d1eb5f72e59f31)(row.yearsElapsed)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: `text-right font-bold ${row.onDeath > 0 ? 'text-slate-900' : 'text-rose-700'}`,
                                            children: row.onDeath > 0 ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.onDeath) : 'nothing'
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: `text-right font-bold ${row.ifCashedOut > 0 ? 'text-slate-900' : 'text-rose-700'}`,
                                            children: row.ifCashedOut > 0 ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.ifCashedOut) : 'nothing'
                                        })
                                    ]
                                }, row.yearsElapsed))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-1.5 text-[11px] leading-relaxed text-slate-600",
                        children: (0, $5ccd559ea4d04f2e$export$3d6c3509706680fc)({
                            residualPct: residualPercent,
                            periodYears: periodYears,
                            ownerName: ownerName
                        })
                    })
                ]
            })
        ]
    });
};
var $57db4ad05023a38c$export$2e2bcd8739ae039 = $57db4ad05023a38c$var$AnnuityShapeChoice;






var $1u0KT = parcelRequire("1u0KT");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c00fae44777e2393$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3",
            key: "1u773s"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const $c00fae44777e2393$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-question-mark", $c00fae44777e2393$export$3efd853dbb351e94);







function $6a72ca5744dce23c$export$d21ef85416618e5a(factFind, amount, investable, personName) {
    const inv = Math.max(0, Number(investable) || 0);
    const a = Math.max(0, Number(amount) || 0);
    if (!(inv > 0) || !(a > 0)) return null;
    const ceiling = (0, $ff5de4128b46b139$export$e46e91ebc7373b0a)(factFind);
    if (a <= (0, $ff5de4128b46b139$export$19a5715b59108050)(ceiling, inv) + 1) return null;
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const has = personName ? `${personName} has` : v.you ? 'you have' : `${v.names} ${v.have}`;
    const share = Math.round(a / inv * 100);
    const suggest = ceiling.amount != null ? `${personName || (v.you ? 'You' : v.Names)} said no more than ${$6a72ca5744dce23c$var$formatMoney(ceiling.amount)}` : ceiling.answered ? `${personName || (v.you ? 'You' : v.Names)} said no more than ${ceiling.pct}%` : `We suggest no more than ${ceiling.pct ?? (0, $ff5de4128b46b139$export$918497a7c667b06f)}%`;
    return `This puts ${share}% of what ${has} into a guaranteed income. ${suggest}, so most of the money stays within reach.`;
}
const $6a72ca5744dce23c$var$formatMoney = (n)=>`$${Math.round(n).toLocaleString('en-AU')}`;
const $6a72ca5744dce23c$export$c57570017839ab6d = ({ factFind: factFind, amount: amount, investable: investable, personName: personName })=>{
    const words = $6a72ca5744dce23c$export$d21ef85416618e5a(factFind, amount, investable, personName);
    if (!words) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "rounded-lg border border-slate-200 border-l-4 border-l-amber-400 bg-white px-3 py-2 text-[12px] leading-relaxed text-slate-700",
        "data-testid": "annuity-ceiling-caution",
        children: words
    });
};
const $6a72ca5744dce23c$var$InfoIcon = ({ text: text, children: children })=>{
    const [show, setShow] = (0, $acw62.useState)(false);
    const iconRef = (0, $acw62.useRef)(null);
    const [coords, setCoords] = (0, $acw62.useState)({
        top: 0,
        left: 0
    });
    (0, $acw62.useEffect)(()=>{
        if (show && iconRef.current) {
            const rect = iconRef.current.getBoundingClientRect();
            setCoords({
                top: rect.top - 40,
                left: rect.left + rect.width / 2
            });
        }
    }, [
        show
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        ref: iconRef,
        className: "relative inline-block ml-1 align-middle",
        onMouseEnter: ()=>setShow(true),
        onMouseLeave: ()=>setShow(false),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c00fae44777e2393$export$2e2bcd8739ae039), {
                size: 15,
                className: "text-slate-400 cursor-pointer"
            }),
            show && typeof window !== 'undefined' && window.document && /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    position: 'fixed',
                    top: coords.top,
                    left: coords.left,
                    transform: 'translate(-50%, -100%)',
                    zIndex: 10001,
                    width: 'max-content',
                    maxWidth: '300px',
                    pointerEvents: 'auto'
                },
                className: "p-3 bg-slate-900 text-white text-xs leading-relaxed rounded-lg shadow-lg text-left",
                children: typeof text === 'string' ? text : children
            }), document.body)
        ]
    });
};
// Tightened, lay-friendly, de-duplicated content (one fact stated once; precision in tooltips).
const $6a72ca5744dce23c$var$typeInfo = {
    lifetime: {
        word: 'income-for-life',
        oneLiner: 'Pays you a guaranteed income for the rest of your life. Because Centrelink counts only part of it, it can also lift your Age Pension.',
        get: [
            "Income you can\u2019t outlive",
            'A higher Age Pension (less is counted)',
            'No worry about share markets'
        ],
        giveUp: [
            'Getting the lump sum back',
            'Growth on that money',
            'Flexibility for a big future cost'
        ],
        pension: 'Centrelink counts 60% of what you put in as an asset for the first five years, or until age 85 if that is later, and 30% after that. It counts 60% of each payment as income.',
        goodFit: [
            "You\u2019re near or just over the pension assets limit",
            'You want a guaranteed income you can rely on',
            'You worry about running your savings down'
        ],
        notWorth: [
            "You\u2019re already on the full Age Pension",
            "You\u2019re well above the limit as a self-funded retiree",
            'You may need a large lump sum later (like a care room deposit)'
        ]
    },
    fixedTerm: {
        word: 'set-term',
        oneLiner: 'Pays you a guaranteed income for a set number of years you choose. At the end, you get back the amount you chose to keep.',
        get: [
            'Predictable income for a set period',
            'You choose how much comes back at the end',
            'Useful if you plan to sell an asset later'
        ],
        giveUp: [
            'Income stops when the term ends',
            'No growth on that money',
            'Less of the pension concession a lifetime annuity gets'
        ],
        pension: 'Centrelink counts the actual value, which reduces over the term if you take back less than 100%. For terms over 5 years only the income portion is counted; for 5 years or less, deeming rates apply.',
        goodFit: [
            'You have a timeframe in mind (such as waiting to sell your home)',
            'You want your capital returned at the end',
            'You want assessed assets to reduce over time'
        ],
        notWorth: [
            'You want income protection for life',
            "You\u2019re well below the assets limit",
            'You choose 100% back (the full value is counted the whole term)'
        ]
    }
};
const $6a72ca5744dce23c$var$providerLinks = [
    {
        name: 'Challenger',
        url: 'https://www.challenger.com.au'
    },
    {
        name: 'Generation Life',
        url: 'https://www.genlife.com.au'
    }
];
const $6a72ca5744dce23c$export$69797182cc224f5a = 1;
const $6a72ca5744dce23c$var$AnnuityStrategyConfigurator = ({ factFind: factFind, annuityDetails: annuityDetails, setAnnuityDetails: setAnnuityDetails, annuitySummary: annuitySummary, annuityWarnings: annuityWarnings, fundingSources: fundingSources, formatCurrency: formatCurrency, clientAge: clientAge, partnerAge: partnerAge, hideAmount: hideAmount = false, onIncomeOnlyUnderstoodChange: onIncomeOnlyUnderstoodChange, incomeOnlyUnderstood: incomeOnlyUnderstood, ceilingInvestable: ceilingInvestable, ceilingFactFind: ceilingFactFind })=>{
    const isCouple = factFind?.adviceFor === 'couple';
    const availableOptions = fundingSources && fundingSources.length > 0 ? fundingSources : [
        {
            id: 'bank-default',
            type: 'bank',
            assetId: null,
            label: 'Bank accounts / cash',
            ownership: isCouple ? 'joint' : 'client'
        }
    ];
    // Hooks run on every render, so this sits ABOVE the early return below (React's rules of hooks).
    const [showAnnuityExplainer, setShowAnnuityExplainer] = (0, $acw62.useState)(false);
    // Opened from the full-guarantee card, which cannot be modelled until a quote is entered.
    const [quoteOpen, setQuoteOpen] = (0, $acw62.useState)(false);
    /*
     * THE GUARANTEE IS THE ANNUITY TYPE, NOT A SCREEN FLAG (27 Sep 2026, owner-caught). This was
     * `useState(false)`: selecting the third card highlighted it, opened the quote panel, and
     * changed nothing the engine could see, so the figures beneath the card belonged to a different
     * shape and nothing reached the projection. It now sets `annuityType: 'guaranteed'` on the
     * record, which `buildAnnuityImpact` prices off the published table and splits between the
     * annuity and the life policy from Challenger's own calculator. Choosing one of the plain cards
     * sets it back to a lifetime annuity with whatever residual the client had.
     */ const wantsGuarantee = annuityDetails?.annuityType === 'guaranteed';
    const setWantsGuarantee = (wants)=>setAnnuityDetails((prev)=>({
                ...prev,
                annuityType: wants ? 'guaranteed' : 'lifetime',
                residualCapital: wants ? 1 : prev.residualCapital ?? $6a72ca5744dce23c$export$69797182cc224f5a,
                termYears: null,
                deferralYears: wants ? 0 : prev.deferralYears
            }));
    /** The provider block, so the estimate badge can take the client straight to it. */ const quoteRef = (0, $acw62.useRef)(null);
    /** A quote already typed keeps the block open - a client's own figures must never be hidden. */ const hasQuote = annuityDetails?.incomeOverride != null || annuityDetails?.assessableIncomeOverride != null || annuityDetails?.assessableAssetOverride != null;
    if (!annuityDetails) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-sm text-slate-600 p-4",
        children: "Annuity configuration not initialized."
    });
    const type = annuityDetails.annuityType === 'fixedTerm' ? 'fixedTerm' : 'lifetime';
    const info = $6a72ca5744dce23c$var$typeInfo[type];
    const isGuaranteedShape = annuityDetails.annuityType === 'guaranteed';
    const currentFundingId = annuityDetails.fundingSource?.id || availableOptions[0].id;
    const residualPercent = Math.round((annuityDetails.residualCapital || 0) * 100);
    // Adviser-optimal structuring: when a couple wants continuation, run it reversionary with the
    // OLDER partner as primary owner (the survivor inherits the earlier drop to 30% asset assessment).
    const olderOwner = partnerAge != null && partnerAge > (clientAge ?? 0) ? 'partner' : 'client';
    // Continuation comes from a reversionary nomination OR joint ownership (joint pays the survivor without a nomination).
    const continuation = annuityDetails.reversionary || annuityDetails.owner === 'joint' ? 'continue' : 'highest';
    const recommendedOwner = olderOwner;
    // Funding super/ABP money can only be held in one name (super isn't jointly owned) → forces a reversionary structure.
    const isSuperSource = (()=>{
        const opt = availableOptions.find((o)=>o.id === currentFundingId) || availableOptions[0];
        return /super|account-based pension|allocated pension|abp/i.test(`${opt?.label || ''} ${opt?.type || ''}`);
    })();
    const clientName = factFind?.client?.firstName || 'You';
    const partnerName = factFind?.partner?.firstName || 'your partner';
    const rawOwner = annuityDetails.owner || recommendedOwner;
    // Joint isn't valid with super money, or with "highest income now" (which stops on death).
    const ownerKey = rawOwner === 'joint' && (isSuperSource || continuation === 'highest') ? recommendedOwner : rawOwner;
    const ownerName = ownerKey === 'partner' ? partnerName : clientName;
    const otherName = ownerKey === 'partner' ? clientName : partnerName;
    const ownershipShort = (0, $c79e495c2243b635$export$522b6ee8c9e1e75c)('annuity ownership');
    const handleFundingSourceChange = (event)=>{
        const option = availableOptions.find((item)=>item.id === event.target.value);
        if (!option) return;
        const optionIsSuper = /super|account-based pension|allocated pension|abp/i.test(`${option.label || ''} ${option.type || ''}`);
        setAnnuityDetails((prev)=>{
            const next = {
                ...prev,
                fundingSource: option
            };
            // Super can't be jointly owned — move to a single-owner reversionary structure.
            if (optionIsSuper && prev.owner === 'joint') {
                next.owner = recommendedOwner;
                next.reversionary = true;
                next.partnerAge = partnerAge ?? prev.partnerAge ?? null;
            }
            return next;
        });
    };
    const handleTypeChange = (nextType)=>{
        setAnnuityDetails((prev)=>({
                ...prev,
                // A guaranteed shape IS income for life; clicking that card again keeps the guarantee.
                annuityType: nextType === 'lifetime' && prev.annuityType === 'guaranteed' ? 'guaranteed' : nextType,
                residualCapital: nextType === 'lifetime' ? prev.residualCapital ?? $6a72ca5744dce23c$export$69797182cc224f5a : prev.residualCapital ?? 0,
                termYears: nextType === 'fixedTerm' ? prev.termYears || 10 : null
            }));
    };
    const handleNumberChange = (field)=>(event)=>{
            const value = parseFloat(event.target.value);
            setAnnuityDetails((prev)=>({
                    ...prev,
                    [field]: Number.isNaN(value) ? 0 : value
                }));
        };
    const handleResidualChange = (event)=>{
        const value = parseFloat(event.target.value);
        const normalised = Number.isNaN(value) ? 0 : Math.min(Math.max(value / 100, 0), 1);
        setAnnuityDetails((prev)=>({
                ...prev,
                residualCapital: normalised
            }));
    };
    const setContinuation = (mode)=>{
        if (mode === 'continue') setAnnuityDetails((prev)=>{
            const keepJoint = prev.owner === 'joint' && !isSuperSource;
            return {
                ...prev,
                reversionary: keepJoint ? false : true,
                partnerAge: partnerAge ?? prev.partnerAge ?? null,
                owner: keepJoint ? 'joint' : prev.owner && prev.owner !== 'joint' ? prev.owner : recommendedOwner
            };
        });
        else setAnnuityDetails((prev)=>({
                ...prev,
                reversionary: false,
                partnerAge: null,
                owner: prev.owner && prev.owner !== 'joint' ? prev.owner : recommendedOwner
            }));
    };
    const setOwner = (key)=>{
        if (key === 'joint') setAnnuityDetails((prev)=>({
                ...prev,
                owner: 'joint',
                reversionary: false,
                partnerAge: partnerAge ?? prev.partnerAge ?? null
            }));
        else setAnnuityDetails((prev)=>({
                ...prev,
                owner: key,
                reversionary: continuation === 'continue',
                partnerAge: continuation === 'continue' ? partnerAge ?? prev.partnerAge ?? null : null
            }));
    };
    // Outcome figures (honest: no benefit shown when nothing is freed from the asset test).
    const purchaseAmount = parseFloat(String(annuityDetails.purchaseAmount)) || 0;
    const assessableAsset = annuitySummary?.assessableAsset ?? null;
    /*
     * The two halves of a guaranteed shape, for the screen. Off the engine's summary where the
     * parent has run it; reconstructed from the same table otherwise, so the note under the card
     * never waits on a round trip to say where the money went.
     */ const guaranteedSlices = (()=>{
        if (!isGuaranteedShape || !(purchaseAmount > 0)) return null;
        const fromSummary = annuitySummary;
        if (fromSummary?.annuitySlice != null && fromSummary?.insuranceSlice != null) return {
            annuity: fromSummary.annuitySlice,
            insurance: fromSummary.insuranceSlice,
            clamped: !!fromSummary.splitClamped
        };
        const ownerForSplit = annuityDetails.owner === 'partner' ? 'partner' : 'client';
        const dob = ownerForSplit === 'partner' ? factFind?.partner?.dob : factFind?.client?.dob;
        const sex = ownerForSplit === 'partner' ? factFind?.partner?.sex : factFind?.client?.sex;
        const age = dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(dob) : null;
        if (age == null) return null;
        const split = (0, $d08210caeacdc75a$export$3568d8429413a44e)(age, sex === 'male' ? 'male' : sex === 'female' ? 'female' : null);
        return {
            annuity: purchaseAmount * split.annuity,
            insurance: purchaseAmount * split.insurance,
            clamped: split.clamped
        };
    })();
    const assetBenefit = annuitySummary && purchaseAmount > 0 && assessableAsset != null ? Math.max(0, purchaseAmount - assessableAsset) : 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-6 border-t border-slate-200 pt-6 space-y-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: ()=>setShowAnnuityExplainer(true),
                className: "text-[12px] font-semibold text-blue-600 underline decoration-blue-600/40 underline-offset-2 hover:text-blue-700",
                children: "What is an annuity, and what are the risks?"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6421482343679f4$export$6b9e287d1f1718d4), {
                open: showAnnuityExplainer,
                onClose: ()=>setShowAnnuityExplainer(false)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[12px] font-semibold text-slate-700 mb-1.5",
                        children: "What kind of income do you want?"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "grid grid-cols-2 gap-2",
                        children: [
                            {
                                id: 'lifetime',
                                title: 'Income for life',
                                sub: 'Paid until you (or your partner) die'
                            },
                            {
                                id: 'fixedTerm',
                                title: 'For a set number of years',
                                sub: 'Paid for a term you choose'
                            }
                        ].map((opt)=>{
                            const active = type === opt.id;
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>handleTypeChange(opt.id),
                                className: `text-left rounded-xl p-2.5 bg-white transition-colors ${active ? 'border-2 border-blue-600' : 'border border-slate-300 hover:border-blue-400'}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "block text-[13px] font-semibold text-slate-900",
                                        children: opt.title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "block text-[11px] text-slate-500",
                                        children: opt.sub
                                    })
                                ]
                            }, opt.id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                className: "group rounded-xl border border-slate-200 bg-white",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("summary", {
                        className: "flex items-center justify-between gap-2 px-3 py-2.5 cursor-pointer list-none",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "flex items-center gap-2 text-[12px] font-semibold text-slate-800",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "grid place-items-center w-6 h-6 rounded-md bg-slate-100 text-slate-600 text-xs shrink-0",
                                        children: "?"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "How an ",
                                            info.word,
                                            " annuity works, and whether it suits you"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                className: "w-4 h-4 text-slate-400 transition-transform group-open:rotate-180 shrink-0",
                                viewBox: "0 0 20 20",
                                fill: "currentColor",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M5.2 7.5 10 12l4.8-4.5"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "px-3 pb-3 pt-1 border-t border-slate-200 text-[11.5px] text-slate-600 space-y-2.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: info.oneLiner
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-2 gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-[11px] font-semibold text-emerald-700 mb-0.5",
                                                children: "What you get"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                className: "space-y-0.5 list-disc list-inside marker:text-slate-300",
                                                children: info.get.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                        children: item
                                                    }, item))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-[11px] font-semibold text-amber-700 mb-0.5",
                                                children: "What you give up"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                className: "space-y-0.5 list-disc list-inside marker:text-slate-300",
                                                children: info.giveUp.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                        children: item
                                                    }, item))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                                className: "group/inner",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("summary", {
                                        className: "text-[11.5px] font-medium text-blue-700 cursor-pointer list-none",
                                        children: "How it affects your pension"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mt-1 rounded-lg bg-white border border-slate-200 border-l-4 border-l-blue-500 px-3 py-2",
                                        children: info.pension
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "rounded-lg bg-white border border-slate-200 border-l-4 border-l-emerald-500 px-2.5 py-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-[11px] font-semibold text-slate-800 mb-1",
                                        children: "Often a good fit if\u2026"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                        className: "space-y-0.5 list-disc list-inside marker:text-slate-300",
                                        children: info.goodFit.map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: i
                                            }, i))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "rounded-lg bg-white border border-slate-200 border-l-4 border-l-amber-500 px-2.5 py-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-[11px] font-semibold text-slate-800 mb-1",
                                        children: "Probably not worth it if\u2026"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                        className: "space-y-0.5 list-disc list-inside marker:text-slate-300",
                                        children: info.notWorth.map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: i
                                            }, i))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[11px] text-slate-500",
                                children: "A common guide is to keep an annuity to about a third of your savings, so the rest stays flexible."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-xl border border-slate-200 bg-slate-50 p-3 space-y-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[12px] font-semibold text-slate-700",
                        children: "Set it up"
                    }),
                    !hideAmount && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        label: "How much do you want to put in?",
                        value: annuityDetails.purchaseAmount ?? '',
                        onChange: (v)=>setAnnuityDetails((prev)=>({
                                    ...prev,
                                    purchaseAmount: v ?? 0
                                })),
                        placeholder: "$0",
                        className: "bg-white rounded-lg"
                    }),
                    ceilingInvestable != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6a72ca5744dce23c$export$c57570017839ab6d, {
                        factFind: ceilingFactFind ?? factFind,
                        amount: purchaseAmount,
                        investable: ceilingInvestable
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "flex items-center gap-1 text-[12px] font-medium text-slate-700 mb-1",
                                children: [
                                    "Where will the money come from?",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6a72ca5744dce23c$var$InfoIcon, {
                                        text: "You\u2019re moving an existing asset into guaranteed income. We list your savings and what\u2019s available in each."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                value: currentFundingId,
                                onChange: handleFundingSourceChange,
                                className: "w-full px-2 py-2 text-sm border border-slate-300 rounded-lg bg-white focus:ring-1 focus:ring-blue-500 focus:border-blue-500",
                                children: availableOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: option.id,
                                        children: option.label
                                    }, option.id))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[11px] text-slate-500 mt-1",
                                children: "Moving money out of cash or shares is what can lift your pension."
                            })
                        ]
                    }),
                    type === 'fixedTerm' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-[12px] font-medium text-slate-700 mb-1",
                                children: "For how many years?"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "number",
                                min: "1",
                                value: annuityDetails.termYears || '',
                                onChange: handleNumberChange('termYears'),
                                className: "w-full px-3 py-2 text-sm border border-slate-300 rounded-lg bg-white focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[11px] text-slate-500 mt-1",
                                children: Number(annuityDetails.termYears) > 0 && Number(annuityDetails.termYears) <= 5 ? "Five years or less: Centrelink treats it like a term deposit \u2014 the value is deemed and the payments are not counted." : 'More than five years: the value counted falls as capital comes back, and only the income portion of each payment counts.'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                        open: Number(annuityDetails.deferralYears) > 0 || !!annuityDetails.indexation,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("summary", {
                                className: "text-[11.5px] font-medium text-blue-700 cursor-pointer list-none",
                                children: "More options: start later, or rise with prices"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-2 space-y-3",
                                children: [
                                    type === 'lifetime' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "block text-[12px] font-medium text-slate-700 mb-1",
                                                children: [
                                                    "Start the payments later? (years to wait)",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6a72ca5744dce23c$var$InfoIcon, {
                                                        text: "A deferred lifetime annuity: you buy it now and the payments start after the number of years you choose. It pays more when it starts, because the provider holds the money longer. Centrelink counts 60% of the purchase price from the day you buy, and none of the income until the payments begin. Enter 0 for payments that start straight away."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "number",
                                                min: "0",
                                                max: "20",
                                                value: annuityDetails.deferralYears || '',
                                                placeholder: "0",
                                                onChange: handleNumberChange('deferralYears'),
                                                className: "w-full px-3 py-2 text-sm border border-slate-300 rounded-lg bg-white focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                                            }),
                                            Number(annuityDetails.deferralYears) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-[11px] text-slate-500 mt-1",
                                                children: [
                                                    "No income for ",
                                                    Number(annuityDetails.deferralYears),
                                                    " years, then a higher payment for life. Our figure is indicative \u2014 a provider's quote will differ."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "flex items-start gap-2 text-[12px] text-slate-700",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                className: "mt-0.5",
                                                checked: !!annuityDetails.indexation,
                                                onChange: (e)=>setAnnuityDetails((prev)=>({
                                                            ...prev,
                                                            indexation: e.target.checked
                                                        }))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "Increase the payments each year to keep up with prices",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6a72ca5744dce23c$var$InfoIcon, {
                                                        text: "Payments rise over time so they hold their value. They start lower and grow later."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-xl border border-slate-200 bg-slate-50 p-3 space-y-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[12px] font-semibold text-slate-700",
                                children: "What happens when you die"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[11.5px] leading-relaxed text-slate-600 mt-0.5",
                                children: isCouple ? "Two separate things, and you choose each one. The payments either stop or keep going to the survivor. And a lump sum either comes back to your family or it doesn\u2019t \u2014 where the payments continue, that lump sum waits until you have both died." : "The payments are for your lifetime, so they stop. What can still come back is a lump sum \u2014 that is the choice below."
                            })
                        ]
                    }),
                    isCouple && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[11.5px] font-semibold text-slate-800",
                        children: [
                            "1. Do the payments keep going to ",
                            otherName,
                            "?"
                        ]
                    }),
                    isCouple && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: `flex items-start gap-2 rounded-lg bg-white p-2.5 cursor-pointer ${continuation === 'continue' ? 'border-2 border-blue-600' : 'border border-slate-300'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "radio",
                                                name: "annuity-continuation",
                                                className: "mt-0.5",
                                                checked: continuation === 'continue',
                                                onChange: ()=>setContinuation('continue')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "text-[12px] text-slate-700",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-semibold text-slate-900",
                                                        children: "Keep paying the survivor for life"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "ml-1 text-[10px] font-semibold text-emerald-700 bg-emerald-50 px-1.5 py-0.5 rounded",
                                                        children: "Recommended"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "block text-[11px] text-slate-500",
                                                        children: "A little less income now, but it\u2019s secure for whoever lives longer."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: `flex items-start gap-2 rounded-lg bg-white p-2.5 cursor-pointer ${continuation === 'highest' ? 'border-2 border-blue-600' : 'border border-slate-300'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "radio",
                                                name: "annuity-continuation",
                                                className: "mt-0.5",
                                                checked: continuation === 'highest',
                                                onChange: ()=>setContinuation('highest')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "text-[12px] text-slate-700",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-semibold text-slate-900",
                                                        children: "Pay the highest income now"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "block text-[11px] text-slate-500",
                                                        children: "More income while you\u2019re alive, but payments stop on death."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "flex items-center gap-1 text-[12px] font-medium text-slate-700 mb-1",
                                        children: [
                                            "Whose name is it in?",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6a72ca5744dce23c$var$InfoIcon, {
                                                text: ownershipShort
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex flex-wrap gap-2",
                                        children: (continuation === 'continue' && !isSuperSource ? [
                                            'client',
                                            'partner',
                                            'joint'
                                        ] : [
                                            'client',
                                            'partner'
                                        ]).map((key)=>{
                                            const label = key === 'joint' ? 'Joint' : key === 'partner' ? partnerName : clientName;
                                            const active = ownerKey === key;
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>setOwner(key),
                                                className: `px-3 py-1.5 text-[12px] rounded-lg bg-white ${active ? 'border-2 border-blue-600 font-semibold' : 'border border-slate-300'}`,
                                                children: [
                                                    label,
                                                    key === recommendedOwner ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "ml-1 text-[10px] font-semibold text-emerald-700",
                                                        children: "\xb7 suggested"
                                                    }) : null
                                                ]
                                            }, key);
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-[11px] text-slate-600 mt-1.5",
                                        children: continuation === 'highest' ? `In ${ownerName}\u{2019}s name \u{2014} payments stop on death.` : ownerKey === 'joint' ? "Owned jointly \u2014 the income continues to whoever lives longer." : `In ${ownerName}\u{2019}s name, continuing to ${otherName} if ${ownerName} passes first (a reversionary annuity).${isSuperSource ? ' Super can only be held in one name, which is why.' : ''}`
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-[11px] text-slate-600 mt-1.5",
                                        children: [
                                            "It makes no difference to your pension or your care fees \u2014 you\u2019re assessed as a couple either way \u2014 so we\u2019ve suggested the one that works best",
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                                term: "(why this one?)",
                                                children: `The counted share drops from 60% to 30% once the owner has held it five years and is 85 or over. ${recommendedOwner === 'partner' ? partnerName : clientName} is the older of the two, so in their name that drop comes sooner \u{2014} less counted, sooner. And with the survivor option on, the earlier date is kept even if they pass away first. Nothing else changes: the income, the care fees and the couple assessment are the same whichever name it's in.`
                                            }),
                                            ". Change it if you like."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (()=>{
                        /*
                     * THE CHOICE, AND THE FINE CONTROL BEHIND IT.
                     *
                     * Three cards answer what a client actually weighs — the income, what the family
                     * gets, and what happens if the money is needed back. The slider is the same
                     * question again in percentage form, so it now sits behind a disclosure: the two
                     * ends are the only shapes providers quote, and the owner's note was that seeing
                     * the choice three times over (cards, then slider, then a sentence repeating
                     * both) is what made the page feel daunting.
                     */ const clientAge = factFind?.client?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client.dob) : null;
                        const partnerAgeNow = isCouple && factFind?.partner?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner.dob) : null;
                        const ownerAge = ownerKey === 'partner' ? partnerAgeNow : clientAge;
                        const otherAge = ownerKey === 'partner' ? clientAge : partnerAgeNow;
                        const ownerSex = ownerKey === 'partner' ? factFind?.partner?.sex : factFind?.client?.sex;
                        /*
                     * WHOSE DEATH PAYS THE LUMP SUM. Challenger's Liquid Lifetime PDS: "The
                     * applicable death benefit is only payable after the death of ALL PERSONS
                     * included as part of the investment." So on a reversionary or jointly owned
                     * annuity nothing is paid to the estate until BOTH have died — which is also why
                     * the capital access schedule runs on the longer of the two lives. The screen
                     * used to name the owner alone, which promised a couple a lump sum years before
                     * the product would pay one. `isCouple` guards it, because `continuation` keeps
                     * its default for a single client and must not make them read as a couple.
                     */ const jointLife = isCouple && (ownerKey === 'joint' || continuation !== 'highest');
                        const period = (0, $5ccd559ea4d04f2e$export$22f90741645fc6a8)({
                            age: ownerAge,
                            sex: ownerSex,
                            partnerAge: otherAge,
                            partnerSex: ownerKey === 'partner' ? factFind?.client?.sex : factFind?.partner?.sex,
                            joint: jointLife
                        });
                        const periodYears = period?.periodYears ?? null;
                        const whose = jointLife ? 'the survivor' : ownerName;
                        // Who has to die before the estate sees anything, in words for the card heading.
                        const lastToDie = jointLife ? `${ownerName} and ${otherName}` : null;
                        const isLifetime = annuityDetails.annuityType !== 'fixedTerm';
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-[11.5px] font-semibold text-slate-800",
                                    children: isCouple ? '2. What comes back to your family as a lump sum?' : 'What comes back to your family as a lump sum?'
                                }),
                                isLifetime && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57db4ad05023a38c$export$2e2bcd8739ae039), {
                                    purchaseAmount: purchaseAmount,
                                    age: ownerAge,
                                    sex: ownerSex,
                                    partnerAge: otherAge,
                                    joint: jointLife,
                                    indexation: !!annuityDetails.indexation,
                                    periodYears: periodYears,
                                    residualPercent: residualPercent,
                                    onChange: (pct)=>setAnnuityDetails((prev)=>({
                                                ...prev,
                                                residualCapital: pct / 100
                                            })),
                                    ownerName: whose,
                                    bothLives: lastToDie,
                                    showGuaranteed: (0, $d08210caeacdc75a$export$7095ab72ebd46272)(factFind, ownerKey === 'joint' ? 'joint' : ownerKey),
                                    wantsGuarantee: wantsGuarantee,
                                    onGuaranteeChange: setWantsGuarantee,
                                    onWantQuote: ()=>setQuoteOpen(true)
                                }),
                                onIncomeOnlyUnderstoodChange && (0, $5eae79c7e46ed27e$export$3c8a471078a7436)(annuityDetails) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$61c5566b790f51c4), {
                                    factFind: factFind,
                                    amount: purchaseAmount,
                                    onChange: onIncomeOnlyUnderstoodChange,
                                    checked: incomeOnlyUnderstood
                                }),
                                isLifetime && wantsGuarantee && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "rounded-lg border border-slate-200 border-l-4 border-l-violet-500 bg-white px-3 py-2.5",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-[12px] font-semibold text-slate-800 mb-0.5",
                                            children: "Modelled as an annuity and a life policy together"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-[11.5px] leading-relaxed text-slate-600",
                                            children: guaranteedSlices ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    "Of your ",
                                                    formatCurrency(purchaseAmount),
                                                    ", about ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: formatCurrency(guaranteedSlices.annuity)
                                                    }),
                                                    " buys the annuity and ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: formatCurrency(guaranteedSlices.insurance)
                                                    }),
                                                    " buys the policy that tops up what the annuity would not return. That split is an estimate only and cannot be guaranteed",
                                                    guaranteedSlices.clamped ? " \u2014 your age is outside the range it covers, so the nearest age is used" : '',
                                                    ". A provider quote is required."
                                                ]
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: "The split between the annuity and the policy is an estimate only and cannot be guaranteed. A provider quote is required."
                                            })
                                        })
                                    ]
                                }),
                                !isGuaranteedShape && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                                    open: !isLifetime,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("summary", {
                                            className: "text-[11.5px] font-medium text-blue-700 cursor-pointer list-none",
                                            children: isLifetime ? 'Set an exact percentage instead' : 'How much comes back at the end of the term?'
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mt-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                    className: "flex items-center gap-1 text-[12px] font-medium text-slate-700 mb-1",
                                                    children: [
                                                        isLifetime ? (0, $5ccd559ea4d04f2e$export$60e5f05f6afbd91)({
                                                            periodYears: periodYears,
                                                            ownerName: whose
                                                        }) : 'How much of the purchase price comes back?',
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6a72ca5744dce23c$var$InfoIcon, {
                                                            text: (0, $5ccd559ea4d04f2e$export$e4f6931f22c5a3e9)({
                                                                residualPct: residualPercent,
                                                                periodYears: periodYears
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-center gap-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            type: "range",
                                                            min: "0",
                                                            max: "100",
                                                            value: residualPercent,
                                                            onChange: handleResidualChange,
                                                            className: "flex-1 accent-blue-600"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "w-16 shrink-0",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                min: "0",
                                                                max: "100",
                                                                value: residualPercent,
                                                                onChange: handleResidualChange,
                                                                className: "w-full px-2 py-1.5 text-sm text-right border border-slate-300 rounded-lg bg-white focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-sm text-slate-500",
                                                            children: "%"
                                                        })
                                                    ]
                                                }),
                                                isLifetime && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "mt-1.5 text-[11px] leading-relaxed text-slate-600",
                                                    children: (0, $5ccd559ea4d04f2e$export$476ca360cf39c0a7)({
                                                        residualPct: residualPercent,
                                                        periodYears: periodYears,
                                                        sexKnown: period?.sexKnown ?? null,
                                                        ownerName: whose
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        });
                    })()
                ]
            }),
            annuitySummary && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-xl border border-slate-200 bg-white p-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-start justify-between gap-3 mb-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-[12px] font-semibold text-slate-800",
                                        children: "What this means for you"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-[10.5px] text-slate-500 mt-0.5",
                                        children: type === 'fixedTerm' ? 'For the set-term annuity above.' : wantsGuarantee ? "For \u201Cthe full amount guaranteed to your family, whenever you die\u201D." : `For \u{201C}${residualPercent > 0 ? 'money back if things change, or if you die early' : 'the highest income'}\u{201D}.`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>{
                                    setQuoteOpen(true);
                                    window.setTimeout(()=>quoteRef.current?.scrollIntoView({
                                            behavior: 'smooth',
                                            block: 'center'
                                        }), 0);
                                },
                                className: `shrink-0 rounded-full border px-2.5 py-1 text-[10.5px] font-semibold ${hasQuote ? 'border-emerald-300 bg-white text-emerald-700 hover:bg-emerald-50' : 'border-amber-300 bg-white text-amber-700 hover:bg-amber-50'}`,
                                children: hasQuote ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        "From your provider\u2019s quote \u2014 ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "underline",
                                            children: "change it"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        "This is an estimate only \u2014 ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "underline",
                                            children: "get a quote"
                                        }),
                                        " to confirm"
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-2 gap-2 mb-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "rounded-lg border border-slate-200 border-l-4 border-l-blue-500 px-2.5 py-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-[10px] uppercase tracking-wide text-slate-500 font-semibold",
                                        children: "Guaranteed income"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-base font-bold text-blue-700",
                                        children: [
                                            formatCurrency(annuitySummary.annualPayment),
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-[11px] font-medium text-slate-500",
                                                children: "/yr"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "rounded-lg border border-slate-200 border-l-4 border-l-emerald-500 px-2.5 py-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-[10px] uppercase tracking-wide text-slate-500 font-semibold",
                                        children: "Cuts assessed assets by"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-base font-bold text-emerald-700",
                                        children: formatCurrency(assetBenefit)
                                    })
                                ]
                            })
                        ]
                    }),
                    assetBenefit > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[11.5px] text-slate-600",
                        children: [
                            "Centrelink counts only ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: formatCurrency(assessableAsset)
                            }),
                            " of your ",
                            formatCurrency(purchaseAmount),
                            " \u2014 ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    formatCurrency(assetBenefit),
                                    " less"
                                ]
                            }),
                            " than leaving it where it is, which can lift your Age Pension."
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[11.5px] text-slate-600",
                        children: "This doesn\u2019t change what Centrelink counts for you right now, but it still gives you a guaranteed income."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                        className: "group/calc mt-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("summary", {
                                className: "text-[11.5px] font-medium text-blue-700 cursor-pointer list-none",
                                children: "How is this worked out?"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-1.5 rounded-lg bg-white border border-slate-200 border-l-4 border-l-slate-300 px-3 py-2 text-[11px] leading-relaxed text-slate-600 space-y-1.5",
                                children: [
                                    isGuaranteedShape && guaranteedSlices ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "Counted as an asset:"
                                            }),
                                            " ",
                                            formatCurrency(assessableAsset ?? 0),
                                            " \u2014 60% of the ",
                                            formatCurrency(guaranteedSlices.annuity),
                                            " annuity half, plus the whole ",
                                            formatCurrency(guaranteedSlices.insurance),
                                            " policy half. Centrelink counts a life policy at the greater of what you paid and its cash-in value, and early on that is what you paid. That is why the guarantee buys far less assets-test relief than a plain annuity."
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "Counted as an asset:"
                                            }),
                                            " ",
                                            formatCurrency(assessableAsset ?? 0),
                                            type === 'lifetime' ? " \u2014 60% of what you put in." : " \u2014 this reduces over the term if you take back less than 100%."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "Counted as income:"
                                            }),
                                            " ",
                                            formatCurrency(annuitySummary.assessableIncome ?? 0),
                                            " a year",
                                            type === 'lifetime' ? ', which is 60% of the payments' : '',
                                            ". Both the Age Pension and the means-tested care fee follow."
                                        ]
                                    }),
                                    type === 'lifetime' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "It gets better later:"
                                            }),
                                            " the counted share ",
                                            isGuaranteedShape ? 'of the annuity half ' : '',
                                            "drops from 60% to 30% at the threshold day \u2014 the later of age 85 and five years from now."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "The cost:"
                                            }),
                                            ' ',
                                            isGuaranteedShape ? 'the least income of the three shapes, and most of the money buys insurance rather than the annuity, so the assets-test saving is small. What you get for it is certainty: the full amount to your family whenever you die.' : residualPercent > 0 ? "a lower income, and the money stops being freely available \u2014 some can be taken back, falling each year to nothing." : 'the capital is committed for life. There is no cash-out value and nothing comes back to the estate; that is what buys the higher income.'
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Based on the current rules for annuities started on or after 1 July 2019."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (annuityWarnings?.length ?? 0) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "rounded-xl bg-white border border-slate-200 border-l-4 border-l-amber-500 px-3 py-2.5 text-xs text-slate-700 space-y-1",
                children: annuityWarnings?.map((warning)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: warning
                    }, warning))
            }),
            (quoteOpen || hasQuote) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                ref: quoteRef,
                className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-500 bg-white p-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-start justify-between gap-3 mb-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[12px] font-semibold text-slate-800",
                                children: "A specialist provider can confirm the exact income"
                            }),
                            !hasQuote && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setQuoteOpen(false),
                                className: "shrink-0 text-[11px] font-medium text-slate-500 hover:text-slate-700",
                                children: "Close"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[11.5px] text-slate-600 mb-2",
                        children: "Enter their quote below and every figure above is re-modelled on their numbers instead of ours."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-wrap gap-2 mb-2",
                        children: $6a72ca5744dce23c$var$providerLinks.map((link)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                href: link.url,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "px-2.5 py-1 bg-white border border-slate-300 rounded-full text-[11px] text-blue-700 font-semibold hover:bg-slate-50 transition-colors",
                                children: [
                                    "Visit ",
                                    link.name
                                ]
                            }, link.name))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 sm:grid-cols-3 gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                label: "Annual income",
                                value: annuityDetails.incomeOverride ?? '',
                                onChange: (v)=>setAnnuityDetails((prev)=>({
                                            ...prev,
                                            incomeOverride: v ?? null
                                        })),
                                placeholder: "From quote",
                                className: ""
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                label: "Income counted",
                                value: annuityDetails.assessableIncomeOverride ?? '',
                                onChange: (v)=>setAnnuityDetails((prev)=>({
                                            ...prev,
                                            assessableIncomeOverride: v ?? null
                                        })),
                                placeholder: "Optional",
                                className: ""
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                label: "Asset counted",
                                value: annuityDetails.assessableAssetOverride ?? '',
                                onChange: (v)=>setAnnuityDetails((prev)=>({
                                            ...prev,
                                            assessableAssetOverride: v ?? null
                                        })),
                                placeholder: "Optional",
                                className: ""
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-xl bg-white border border-slate-200 border-l-4 border-l-amber-500 px-3 py-2.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[12px] font-semibold text-slate-800 mb-0.5 flex items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                className: "w-4 h-4 text-amber-600"
                            }),
                            " Worth knowing before you commit"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[11.5px] text-slate-600",
                        children: [
                            isGuaranteedShape ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: "Your family gets the full amount back whenever you die, so the risk on that side is gone. What you give up is income \u2014 this shape pays the least of the three \u2014 and most of your money is buying insurance, so Centrelink still counts most of it. A cash-in value exists but the provider\u2019s quote states it."
                            }) : residualPercent <= 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "This shape pays the most, and it is the one that really is locked in: there is no cash-out value and nothing comes back to your family. People often live ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "2\u20135 years"
                                    }),
                                    " in residential care, so passing away early can mean losing what is left in it."
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: "You can take money back, but not all of it and not forever \u2014 the most allowed falls each year to nothing, and cashing out ends the income. What the provider actually pays is usually less than that maximum."
                            }),
                            annuityDetails.annuityType === 'fixedTerm' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    " With a ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "set-term"
                                    }),
                                    " annuity the income also stops when the term ends."
                                ]
                            }),
                            isCouple && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: " Keeping the payments going to your partner avoids the risk of an early death ending the income."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $6a72ca5744dce23c$export$2e2bcd8739ae039 = $6a72ca5744dce23c$var$AnnuityStrategyConfigurator;





/**
 * The app's notices — in place of the browser's alert() and confirm() (owner, 16 Oct 2026: "old and
 * tired"). One host, mounted once at the app root; two calls anything can make without React in scope:
 *
 *   notify('Reminder sent to Kevin.')                      → a toast, top right, gone in a few seconds
 *   notify({ title, message, tone, link })                 → a toast that stays while it carries a link
 *   await confirmAction('Remove Helen from the firm?')     → a dialog; true on confirm, false otherwise
 *
 * A string to notify() is read for its tone: a request to the user ("Please…", "Add at least…") is a
 * caution, news of something done ("sent", "saved", "connected") is a success, the rest is information.
 * The look follows the InsightCard idiom — white, a slate outline, colour on the rail and the icon only.
 */ 

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $68d48ea6a6653ccd$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "14",
            height: "14",
            x: "8",
            y: "8",
            rx: "2",
            ry: "2",
            key: "17jyea"
        }
    ],
    [
        "path",
        {
            d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
            key: "zix9uf"
        }
    ]
];
const $68d48ea6a6653ccd$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("copy", $68d48ea6a6653ccd$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $839eea37a960d2b1$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m15 9-6 6",
            key: "1uzhvr"
        }
    ],
    [
        "path",
        {
            d: "m9 9 6 6",
            key: "z0biqf"
        }
    ]
];
const $839eea37a960d2b1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-x", $839eea37a960d2b1$export$3efd853dbb351e94);


const $8e1e84c918e07c84$var$state = {
    notices: [],
    confirm: null
};
const $8e1e84c918e07c84$var$listeners = new Set();
const $8e1e84c918e07c84$var$emit = ()=>$8e1e84c918e07c84$var$listeners.forEach((l)=>l());
let $8e1e84c918e07c84$var$seq = 0;
function $8e1e84c918e07c84$var$toneOf(text) {
    if (/^(please|add at least|choose|select|enter)\b|exceeds|could not|couldn't|not valid|no outstanding|not been|isn't switched on|is not switched on/i.test(text)) return 'warning';
    if (/\b(sent|saved|connected|created|copied|done|updated)\b/i.test(text)) return 'success';
    return 'info';
}
const $8e1e84c918e07c84$var$DEFAULT_MS = {
    success: 5000,
    info: 6000,
    warning: 8000,
    error: 10000
};
function $8e1e84c918e07c84$export$5e14cdade93d6f7b(input) {
    const n = typeof input === 'string' ? {
        title: input,
        tone: $8e1e84c918e07c84$var$toneOf(input)
    } : input;
    const tone = n.tone ?? (n.title ? $8e1e84c918e07c84$var$toneOf(n.title) : 'info');
    const id = $8e1e84c918e07c84$var$seq += 1;
    const duration = n.duration ?? (n.link ? 0 : $8e1e84c918e07c84$var$DEFAULT_MS[tone]);
    $8e1e84c918e07c84$var$state.notices = [
        ...$8e1e84c918e07c84$var$state.notices,
        {
            id: id,
            tone: tone,
            title: n.title,
            message: n.message,
            link: n.link,
            duration: duration
        }
    ];
    $8e1e84c918e07c84$var$emit();
    return id;
}
function $8e1e84c918e07c84$export$48fd8a13e574f010(id) {
    $8e1e84c918e07c84$var$state.notices = $8e1e84c918e07c84$var$state.notices.filter((n)=>n.id !== id);
    $8e1e84c918e07c84$var$emit();
}
function $8e1e84c918e07c84$export$71edf76f07903b9c(input) {
    const c = typeof input === 'string' ? {
        message: input
    } : input;
    // One question at a time: a second asker gets "no" rather than a dialog over a dialog.
    if ($8e1e84c918e07c84$var$state.confirm) return Promise.resolve(false);
    return new Promise((resolve)=>{
        $8e1e84c918e07c84$var$state.confirm = {
            title: c.title ?? 'Please confirm',
            message: c.message,
            confirmLabel: c.confirmLabel ?? 'Confirm',
            cancelLabel: c.cancelLabel ?? 'Cancel',
            danger: !!c.danger || /\b(remove|delete|suspend|revoke|turn off|leave)\b/i.test(c.message),
            resolve: resolve
        };
        $8e1e84c918e07c84$var$emit();
    });
}
function $8e1e84c918e07c84$export$2c76b2ff58472420() {
    return $8e1e84c918e07c84$var$state;
}
function $8e1e84c918e07c84$export$37073c0095d546c() {
    $8e1e84c918e07c84$var$state.notices = [];
    $8e1e84c918e07c84$var$state.confirm = null;
    $8e1e84c918e07c84$var$emit();
}
function $8e1e84c918e07c84$var$useNoticeState() {
    const [, bump] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        const l = ()=>bump((n)=>n + 1);
        $8e1e84c918e07c84$var$listeners.add(l);
        return ()=>{
            $8e1e84c918e07c84$var$listeners.delete(l);
        };
    }, []);
    return $8e1e84c918e07c84$var$state;
}
const $8e1e84c918e07c84$var$TONE = {
    success: {
        rail: 'border-l-emerald-500',
        icon: 'text-emerald-600',
        Icon: (0, $f36710bd138be5d0$export$2e2bcd8739ae039)
    },
    info: {
        rail: 'border-l-blue-500',
        icon: 'text-blue-600',
        Icon: (0, $e52b122f04c04d7d$export$2e2bcd8739ae039)
    },
    warning: {
        rail: 'border-l-amber-500',
        icon: 'text-amber-600',
        Icon: (0, $00824d397ec63c04$export$2e2bcd8739ae039)
    },
    error: {
        rail: 'border-l-rose-500',
        icon: 'text-rose-600',
        Icon: (0, $839eea37a960d2b1$export$2e2bcd8739ae039)
    }
};
const $8e1e84c918e07c84$var$Toast = ({ notice: notice })=>{
    const { rail: rail, icon: icon, Icon: Icon } = $8e1e84c918e07c84$var$TONE[notice.tone];
    const [copied, setCopied] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!notice.duration) return undefined;
        const t = setTimeout(()=>$8e1e84c918e07c84$export$48fd8a13e574f010(notice.id), notice.duration);
        return ()=>clearTimeout(t);
    }, [
        notice.id,
        notice.duration
    ]);
    const copy = async ()=>{
        try {
            await navigator.clipboard.writeText(notice.link.url);
            setCopied(true);
            setTimeout(()=>setCopied(false), 2000);
        } catch  {}
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `pointer-events-auto w-full max-w-md bg-white rounded-2xl border border-slate-200 border-l-4 ${rail} shadow-[0_12px_28px_-8px_rgba(16,24,40,0.22)] p-4 flex items-start gap-3 animate-[noticeIn_.22s_ease-out]`,
        role: notice.tone === 'error' ? 'alert' : 'status',
        "data-testid": "app-notice",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                size: 20,
                className: `mt-0.5 shrink-0 ${icon}`,
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "min-w-0 flex-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm font-semibold text-slate-900 leading-snug",
                        children: notice.title
                    }),
                    notice.message && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-1 text-sm text-slate-600 leading-relaxed",
                        children: notice.message
                    }),
                    notice.link && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3",
                        children: [
                            notice.link.label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[11px] font-semibold tracking-wide uppercase text-slate-500 mb-1",
                                children: notice.link.label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-stretch gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        readOnly: true,
                                        value: notice.link.url,
                                        onFocus: (e)=>e.currentTarget.select(),
                                        className: "min-w-0 flex-1 rounded-lg border border-slate-200 bg-slate-50 px-2.5 py-1.5 text-[12px] font-mono text-slate-700",
                                        "aria-label": "Link"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: copy,
                                        className: "shrink-0 inline-flex items-center gap-1.5 rounded-lg bg-blue-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-blue-700",
                                        children: [
                                            copied ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                                size: 14,
                                                "aria-hidden": true
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
                                                size: 14,
                                                "aria-hidden": true
                                            }),
                                            copied ? 'Copied' : 'Copy link'
                                        ]
                                    })
                                ]
                            }),
                            notice.link.note && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1.5 text-[12px] text-slate-500",
                                children: notice.link.note
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: ()=>$8e1e84c918e07c84$export$48fd8a13e574f010(notice.id),
                className: "shrink-0 -mr-1 -mt-1 p-1 rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-600",
                "aria-label": "Dismiss",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                    size: 16
                })
            })
        ]
    });
};
const $8e1e84c918e07c84$var$ConfirmDialog = ({ pending: pending })=>{
    const confirmRef = (0, $acw62.useRef)(null);
    const answer = (ok)=>{
        $8e1e84c918e07c84$var$state.confirm = null;
        $8e1e84c918e07c84$var$emit();
        pending.resolve(ok);
    };
    (0, $acw62.useEffect)(()=>{
        confirmRef.current?.focus();
        const onKey = (e)=>{
            if (e.key === 'Escape') answer(false);
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 z-[10050] flex items-center justify-center bg-slate-900/40 backdrop-blur-sm p-4",
        onClick: ()=>answer(false),
        role: "presentation",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 animate-[noticeIn_.2s_ease-out]",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "app-confirm-title",
            onClick: (e)=>e.stopPropagation(),
            "data-testid": "app-confirm",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-start gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: `shrink-0 w-10 h-10 rounded-xl flex items-center justify-center ${pending.danger ? 'bg-rose-50 text-rose-600' : 'bg-blue-50 text-blue-600'}`,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                size: 20,
                                "aria-hidden": true
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "min-w-0 flex-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "app-confirm-title",
                                    className: "text-base font-bold text-slate-900",
                                    children: pending.title
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-1.5 text-sm text-slate-600 leading-relaxed",
                                    children: pending.message
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mt-5 flex justify-end gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>answer(false),
                            className: "rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50",
                            children: pending.cancelLabel
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            ref: confirmRef,
                            type: "button",
                            onClick: ()=>answer(true),
                            className: `rounded-lg px-4 py-2 text-sm font-semibold text-white ${pending.danger ? 'bg-rose-600 hover:bg-rose-700' : 'bg-blue-600 hover:bg-blue-700'}`,
                            children: pending.confirmLabel
                        })
                    ]
                })
            ]
        })
    });
};
const $8e1e84c918e07c84$export$6238edd9774d82aa = ()=>{
    const s = $8e1e84c918e07c84$var$useNoticeState();
    if (typeof document === 'undefined') return null;
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("style", {
                children: `@keyframes noticeIn { from { opacity: 0; transform: translateY(-6px) scale(.98); } to { opacity: 1; transform: none; } }`
            }),
            s.notices.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed top-4 right-4 z-[10040] flex flex-col gap-3 w-[min(28rem,calc(100vw-2rem))] pointer-events-none",
                "aria-live": "polite",
                children: s.notices.map((n)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8e1e84c918e07c84$var$Toast, {
                        notice: n
                    }, n.id))
            }),
            s.confirm && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8e1e84c918e07c84$var$ConfirmDialog, {
                pending: s.confirm
            })
        ]
    }), document.body);
};







/**
 * Is the hand-built plan's side panel showing figures for the inputs on screen, or still working them out?
 *
 * WHY (owner-seen, 25 Oct 2026). The panel's figures come from several calculations that run one after another —
 * the position, then the fees struck on it, then the projections struck on those, and the comparison beside them.
 * Each lands when it lands, so for 10–25 seconds after a change the panel mixed the new figures with the old ones:
 * "Customise this plan" first said the estate was unchanged and the savings lasted ten years, then settled on
 * +$122,016 and five; a blank Support at Home plan first read "+$748,771 vs today" before its real comparison
 * arrived. A figure that is about to change is worse than no figure, so while anything is in flight the panel says
 * "Working it out…" instead.
 *
 * HOW. Every calculation the panel reads is passed through `track`. The panel is working while any of them is in
 * flight, and for a short settle after the last one lands — because the next step of the chain (fees after the
 * position, projections after the fees) only starts once React has rendered the previous result, and a gap of a
 * frame or two must not flash the half-finished figures.
 */ 
var $acw62 = parcelRequire("acw62");
const $a8ad6b8c257d1221$export$f0c494886fc5490 = 300;
function $a8ad6b8c257d1221$export$e7048a6a7a16d600({ onWorking: onWorking, settleMs: settleMs = $a8ad6b8c257d1221$export$f0c494886fc5490, setTimer: setTimer = (fn, ms)=>setTimeout(fn, ms), clearTimer: clearTimer = (h)=>clearTimeout(h) }) {
    let count = 0;
    let timer = null;
    const cancelSettle = ()=>{
        if (timer != null) clearTimer(timer);
        timer = null;
    };
    const scheduleSettle = ()=>{
        cancelSettle();
        timer = setTimer(()=>{
            timer = null;
            if (count === 0) onWorking(false);
        }, settleMs);
    };
    scheduleSettle();
    return {
        track (promise) {
            count += 1;
            cancelSettle();
            onWorking(true);
            const done = ()=>{
                count = Math.max(0, count - 1);
                if (count === 0) scheduleSettle();
            };
            promise.then(done, done);
            return promise;
        },
        inFlight: ()=>count,
        dispose: cancelSettle,
        kick: ()=>{
            if (count === 0) scheduleSettle();
        }
    };
}
function $a8ad6b8c257d1221$export$66e981b52ef0ad9f(settleMs = $a8ad6b8c257d1221$export$f0c494886fc5490) {
    const [working, setWorking] = (0, $acw62.useState)(true);
    const ref = (0, $acw62.useRef)(null);
    if (!ref.current) ref.current = $a8ad6b8c257d1221$export$e7048a6a7a16d600({
        onWorking: setWorking,
        settleMs: settleMs
    });
    (0, $acw62.useEffect)(()=>{
        ref.current?.kick();
        return ()=>ref.current?.dispose();
    }, []);
    const track = (0, $acw62.useCallback)((promise)=>ref.current.track(promise), []);
    return {
        track: track,
        working: working
    };
}



/**
 * ONE HELP DEVICE (owner, 2026-09-22: "I've never really liked the question mark — it makes the
 * screen look messy"). A field's guidance used to sit behind a grey question-mark icon; it is now a
 * dotted "what's this?" that opens the same words in place, the gesture every dotted term on the
 * page already teaches. Numbers with a breakdown open it on hover of the figure or its label; words
 * open on the dotted term. No icons.
 */ const $39641e97aa80005f$var$WhatsThis = ({ text: text })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
        text: text
    });
/**
 * How far ahead "how long the money lasts" is tested — deliberately NOT the Project Legacy Over
 * period. See the runway projection effect below for why that distinction matters.
 */ const $39641e97aa80005f$var$RUNWAY_HORIZON_YEARS = 25;
const $39641e97aa80005f$var$EMPTY_SECOND_ROOM = {
    roomPrice: 0,
    careStartDate: '',
    extraServiceAnnual: 0
};
// DraftFactFind is structurally compatible with FactFind (see types/formDraft.ts);
// the shared calc-engine fns defensively parseFloat/coerce internally regardless (see
// factFindTypes.ts header), so this cast is safe. Used at the handful of call sites below that
// invoke shared calc-engine helpers directly (bypassing the calculationApi.ts REST boundary that
// normally does this coercion).
const $39641e97aa80005f$var$asFactFind = (data)=>data;
const $39641e97aa80005f$var$AGED_CARE_HOME_EXEMPTION_CAP = (0, $815d7df20c36742b$export$36c4ec5f3f340aef).homeExemptionCap;
const $39641e97aa80005f$var$RAD_DRAWDOWN_OPTIONS = [
    {
        value: 'fees',
        label: "Yes \u2014 all fees (most homes agree to this)"
    },
    {
        value: 'dap',
        label: 'Only the accommodation payment (the legal minimum)'
    },
    {
        value: 'none',
        label: 'No'
    }
];
const $39641e97aa80005f$var$convertManualRadFundingForSnapshot = (radFunding = {})=>{
    const converted = {};
    Object.entries(radFunding || {}).forEach(([key, rawAmount])=>{
        const amount = parseFloat(String(rawAmount)) || 0;
        if (amount <= 0) return;
        const parsed = (0, $bd80071df75c742b$export$eb5d467aa7d657c6)(key);
        if (!parsed) return;
        if (!converted[parsed.assetType]) converted[parsed.assetType] = [];
        converted[parsed.assetType].push({
            id: parsed.assetId,
            amount: amount
        });
    });
    return converted;
};
/** Saved outputs.cashFlow; if legacy save used wrong field (0), recover from nested SE snapshot. */ const $39641e97aa80005f$var$getDisplayCashFlowForSavedStrategy = (s)=>{
    const o = s?.outputs?.cashFlow;
    if (o != null && o !== 0) return Number(o);
    const strategySnapshot = s?.strategy?.snapshot;
    const fromSnap = strategySnapshot?.netCashflow ?? strategySnapshot?.cashFlow;
    if (fromSnap != null && fromSnap !== 0) return Number(fromSnap);
    return Number(o ?? fromSnap ?? 0);
};
const $39641e97aa80005f$var$toMonthValue = (d)=>`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
/** `YYYY-MM-DD` for a Date, in local time — the shape an `<input type="date">` reads and writes. */ const $39641e97aa80005f$var$toDateValue = (d)=>`${$39641e97aa80005f$var$toMonthValue(d)}-${String(d.getDate()).padStart(2, '0')}`;
/**
 * Normalise a nominated care start date: a day-precise `YYYY-MM-DD` in the future, or '' for "care is
 * starting now".
 *
 * There is no upper bound any more, and that is the point of the change this belongs to. Entry used to
 * be capped at 12 months out because the entry date WAS the projection anchor — the run began at
 * admission, so the years in between would have gone silently unmodelled. Now the projection starts
 * today and entry is an event inside it, so those years are projected like any other and a date five
 * years out is as modellable as one five months out.
 *
 * Today or earlier collapses to '' rather than deferring by a negative amount: a client entering now is
 * exactly what a blank field means to the engine.
 */ const $39641e97aa80005f$var$clampCareStartDate = (raw)=>{
    const value = typeof raw === 'string' ? raw.trim() : '';
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return '';
    const now = new Date();
    return value <= $39641e97aa80005f$var$toDateValue(now) ? '' : value;
};
/**
 * Read a care start date off a saved strategy's inputs, accepting the `careEntryMonth` (`YYYY-MM`) that
 * strategies saved before entry became day-precise carry instead.
 *
 * Those older strategies mean the 1st of the month they name, which is what the month value was
 * converted to when it was fed to the projection anchor.
 */ /**
 * Normalise a nominated RAD sale date: a future `YYYY-MM-DD` on or before the move-in date, or '' for
 * "sold now, as part of entering care".
 *
 * Bounded above by the care date because a deposit cannot be funded by a sale that has not happened —
 * the engine would bank the proceeds after it had already tried to pay out of them. Selling ON the day
 * is allowed, and is the ordinary case; selling earlier is the one worth modelling.
 */ const $39641e97aa80005f$var$clampRadFundingDate = (raw, careStart)=>{
    const value = typeof raw === 'string' ? raw.trim() : '';
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return '';
    if (value <= $39641e97aa80005f$var$toDateValue(new Date())) return '';
    if (careStart && value > careStart) return careStart;
    return value;
};
const $39641e97aa80005f$var$careStartDateFromSavedInputs = (inputs)=>{
    if (typeof inputs.careStartDate === 'string' && inputs.careStartDate) return $39641e97aa80005f$var$clampCareStartDate(inputs.careStartDate);
    const legacyMonth = typeof inputs.careEntryMonth === 'string' ? inputs.careEntryMonth.trim() : '';
    return /^\d{4}-\d{2}$/.test(legacyMonth) ? $39641e97aa80005f$var$clampCareStartDate(`${legacyMonth}-01`) : '';
};
function $39641e97aa80005f$export$e92c3d4dc4ff4528(strategy) {
    const inputs = strategy.inputs ?? {};
    return {
        roomPrice: Number(inputs.radInput) || Number(strategy.outputs?.roomCost) || 0,
        careStartDate: typeof inputs.careStartDate === 'string' ? inputs.careStartDate : '',
        legacyYears: typeof inputs.legacyYears === 'number' ? inputs.legacyYears : null,
        radDrawdown: inputs.radDrawdown || 'fees',
        residentialFeeArrangements: inputs.residentialFeeArrangements ?? null
    };
}
function $39641e97aa80005f$export$96193217a145b7ec(strategies) {
    if (strategies.length < 2) return [];
    const bases = strategies.map($39641e97aa80005f$export$e92c3d4dc4ff4528);
    const differs = (pick)=>new Set(bases.map(pick)).size > 1;
    const differences = [];
    if (differs((b)=>b.roomPrice)) differences.push('room price');
    if (differs((b)=>b.careStartDate)) differences.push('care start date');
    if (differs((b)=>b.radDrawdown)) differences.push('whether fees are drawn from the deposit');
    if (differs((b)=>b.residentialFeeArrangements)) differences.push('which fee arrangements apply (no worse off vs opted in)');
    // A missing horizon counts as different from a recorded one: "not recorded" is not "the same".
    if (differs((b)=>b.legacyYears)) differences.push('projection length');
    return differences;
}
const $39641e97aa80005f$var$AgedCareAnalyser = ({ setActivePage: setActivePage, factFind: factFind, setFactFind: setFactFind, onBack: onBack, onBackToPlan: onBackToPlan, legacyYears: legacyYears, selectedStrategy: selectedStrategy, setSelectedStrategy: setSelectedStrategy, coupleValidation: coupleValidation, setCoupleValidation: setCoupleValidation, savedStrategies: savedStrategies, setSavedStrategies: setSavedStrategies, savedCaseStudies: savedCaseStudies, setSavedCaseStudies: setSavedCaseStudies, strategyOptions: strategyOptions, setStrategyOptions: setStrategyOptions, isProfessionalJourney: isProfessionalJourney = false, professionalCaseId: professionalCaseId = null, onSoaGenerated: onSoaGenerated = null, onStrategySaved: onStrategySaved = null })=>{
    // State for user inputs specific to this page
    const [radInput, setRadInput] = (0, $acw62.useState)(0);
    /** The home's name, so each home's plan can be told apart on Home (UX review, 17 Oct 2026). */ const [homeName, setHomeName] = (0, $acw62.useState)('');
    /** Show the funding sliders even though a strategy already covers the whole room. */ const [showFundingAnyway, setShowFundingAnyway] = (0, $acw62.useState)(false);
    /**
     * Nominated residential care start date (`YYYY-MM-DD`), '' = care is starting now.
     *
     * Passed to the engine as `strategyOptions.careStartDate`, and deliberately NOT as the projection
     * anchor. It used to be both: setting the anchor to the entry month made the projection BEGIN at
     * admission, so nothing between today and entry was modelled and legacy estimates for different
     * entry dates covered different horizons. The projection now always starts from today, and this
     * says when care fees begin inside it.
     */ const [careStartDate, setCareStartDate] = (0, $acw62.useState)('');
    /**
     * Whether the home may take its fees out of the deposit. A fact about the provider agreement, not
     * a strategy: it is asked once, here, and both the manual plan and every ranked candidate run on
     * it. Defaults to the usual arrangement — a home must allow the accommodation payment to be drawn
     * and most agree to the rest in writing — so a plan modelled before the question is asked is the
     * plan most clients will actually get.
     */ const [radDrawdown, setRadDrawdown] = (0, $acw62.useState)('fees');
    /*
     * A resident the profile puts under the no-worse-off principle is on the 1 July 2014 fee
     * arrangements (the means-tested care fee) unless they opt in to the 1 November 2025 rules — an
     * election that cannot be undone, so the screen models it only when asked. Resolved from the
     * profile by the same function the fee engine uses (residentialFeeArrangements.ts).
     */ const [optInToNovember2025Fees, setOptInToNovember2025Fees] = (0, $acw62.useState)(false);
    const coveredByNoWorseOff = (0, $acw62.useMemo)(()=>(0, $5a5496da6ce58554$export$4a48561f28024b31)(factFind), [
        factFind
    ]);
    const residentialFeeArrangements = coveredByNoWorseOff ? optInToNovember2025Fees ? '2025' : '2014' : undefined;
    /**
     * When the RAD funding assets are SOLD (`YYYY-MM-DD`), '' = sold now.
     *
     * Passed to the engine as `strategyOptions.radFundingDate`, which is also what tells it to do the
     * selling. Setting it therefore changes what `simulatedFactFind` below builds: a sale that has not
     * happened yet must not appear in the client's CURRENT position, only in the projection, on its day.
     *
     * Separate from {@link careStartDate} because selling and moving in are separate acts. The gap is
     * the point — proceeds sit in the bank, deemed and means-tested, until the deposit is paid.
     */ const [radFundingDate, setRadFundingDate] = (0, $acw62.useState)('');
    /**
     * THE SECOND ROOM, where both of a couple are entering care (owner, 7 Oct 2026: "both into care,
     * built the right way"). The first entrant is the client (the run's existing machinery); the
     * partner is the second resident, with their own room, entry date and deposit. Their deposit is
     * funded from what the first room's funding leaves (shared/.../secondDeposit.ts), so one dollar
     * cannot pay for two rooms, and the engine prices the pair as a couple living apart.
     */ const bothEntering = factFind.adviceFor === 'couple' && factFind.goals?.aged_care_for === 'both';
    /**
     * WHOEVER MOVES IN FIRST LEADS (owner, 7 Oct 2026: "isn't the system just smart enough to pick it
     * up based on date?"). The engine's first entrant is the person with the earlier date; the other
     * is the second resident. The two rooms' inputs swap roles when the dates say so (below), and
     * every name on the page follows the role, not the profile's client/partner slot.
     */ const [leadPerson, setLeadPerson] = (0, $acw62.useState)('client');
    const secondPerson = leadPerson === 'client' ? 'partner' : 'client';
    const secondKey = secondPerson === 'client' ? 'clientResidencyOverride' : 'partnerResidencyOverride';
    const secondRecorded = (secondPerson === 'client' ? factFind.client?.currentResidency : factFind.partner?.currentResidency) || 'own_home';
    /**
     * A CHANGE OF HOME (owner, 7 Oct 2026). The person is in care now (the profile's stay): the page
     * prices a move to a new home against STAYING PUT. Their deposit's refundable balance today is
     * what the new room's deposit is paid from first; its retention standing, and whether any applies
     * at all, follow from when they moved in.
     */ const moverPerson = factFind.adviceFor === 'couple' && factFind.goals?.aged_care_for === 'partner' ? 'partner' : 'client';
    const moverRecord = moverPerson === 'partner' ? factFind.partner : factFind.client;
    const moverStay = moverRecord?.currentResidency === 'aged_care' && moverRecord?.careStay && (Number(moverRecord.careStay.roomPrice) || 0) > 0 && !bothEntering ? moverRecord.careStay : null;
    const isMover = !!moverStay;
    const moverGrandfathered = isMover && (0, $5a5496da6ce58554$export$388e9988095daada)($39641e97aa80005f$var$asFactFind(factFind), moverPerson);
    const moverDeposit = (0, $acw62.useMemo)(()=>moverStay ? (0, $7902ca900a473358$export$9a209edac0ea183f)(Number(moverStay.radPaid) || 0, moverStay.entryDate, new Date(), moverGrandfathered) : {
            balance: 0,
            retained: 0,
            retentionDaysTaken: 0
        }, [
        moverStay,
        moverGrandfathered
    ]);
    const existingStay = (0, $acw62.useMemo)(()=>moverStay ? {
            person: moverPerson,
            facilityName: String(moverStay.facilityName || ''),
            roomPrice: Number(moverStay.roomPrice) || 0,
            refundToday: moverDeposit.balance,
            dailyPayment: Number(moverStay.dailyPayment) || 0
        } : null, [
        moverStay,
        moverPerson,
        moverDeposit.balance
    ]);
    const currentHomeFacts = moverStay ? {
        name: moverRecord?.firstName || 'the client',
        facilityName: String(moverStay.facilityName || ''),
        roomPrice: Number(moverStay.roomPrice) || 0,
        paid: Number(moverStay.radPaid) || 0,
        refundToday: moverDeposit.balance,
        retained: moverDeposit.retained,
        dailyPayment: Number(moverStay.dailyPayment) || 0,
        entryLabel: moverStay.entryDate ? (0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(moverStay.entryDate) : '',
        grandfathered: moverGrandfathered
    } : null;
    const [secondRoom, setSecondRoom] = (0, $acw62.useState)($39641e97aa80005f$var$EMPTY_SECOND_ROOM);
    const secondRoomActive = bothEntering && secondRoom.roomPrice > 0;
    const { firstName: firstName, secondName: secondName } = (0, $b8d3cfe4c156722e$export$24ee473c3b86ae0)(factFind, secondPerson, {
        first: 'you',
        second: 'your partner'
    });
    /** Which room the facility search fills. */ const [facilityTarget, setFacilityTarget] = (0, $acw62.useState)('first');
    const [selectedSecondFacility, setSelectedSecondFacility] = (0, $acw62.useState)(null);
    /** The second person enters after the first: the first's schedule is struck with them still at home. */ const secondEntersLater = secondRoomActive && (0, $b8d3cfe4c156722e$export$b3b2f82762b8c7c4)(careStartDate, secondRoom.careStartDate);
    const phaseNames = {
        firstName: firstName,
        secondName: secondName,
        fromLabel: (0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(secondRoom.careStartDate)
    };
    (0, $acw62.useEffect)(()=>{
        if (!bothEntering) return;
        // The second slot's date is EARLIER than the first's (a blank first date is "now"): that
        // person moves in first, so the engine's first entrant must be them. The two rooms' inputs
        // change SLOTS; nothing on screen moves — each block is bound to its person, whichever slot
        // holds their room (owner, 7 Oct 2026: "who asked for that?"). Only a date the browser has
        // finished typing counts: a native date input reports "0002-01-01" half-way through "2029".
        if (!(0, $b8d3cfe4c156722e$export$a4442bb413fc20b4)(careStartDate, secondRoom.careStartDate)) return;
        const wasFirst = {
            roomPrice: radInput,
            careStartDate: careStartDate,
            extraServiceAnnual: extraServiceFeeInput,
            facility: selectedFacility
        };
        setRadInput(secondRoom.roomPrice);
        setCareStartDate(secondRoom.careStartDate);
        setRadFundingDate((current)=>$39641e97aa80005f$var$clampRadFundingDate(current, secondRoom.careStartDate));
        setExtraServiceFeeInput(secondRoom.extraServiceAnnual);
        setSelectedFacility(selectedSecondFacility);
        setSecondRoom({
            roomPrice: wasFirst.roomPrice,
            careStartDate: wasFirst.careStartDate,
            extraServiceAnnual: wasFirst.extraServiceAnnual
        });
        setSelectedSecondFacility(wasFirst.facility);
        setLeadPerson((p)=>p === 'client' ? 'partner' : 'client');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        bothEntering,
        careStartDate,
        secondRoom.careStartDate
    ]);
    /** The aged care strategies the comparison table lists, and what they disagree about. */ const comparedAgedCareStrategies = (0, $acw62.useMemo)(()=>savedStrategies.filter((s)=>s.type === 'aged_care'), [
        savedStrategies
    ]);
    const comparedBasisDifferences = (0, $acw62.useMemo)(()=>$39641e97aa80005f$export$96193217a145b7ec(comparedAgedCareStrategies), [
        comparedAgedCareStrategies
    ]);
    /** Whether the optional "sell earlier" date has been asked for. Collapsed to a stated default until then. */ const [showRadFundingDate, setShowRadFundingDate] = (0, $acw62.useState)(false);
    /** Typing-safe bindings for the two date inputs — see useClampedDateField for why they are needed. */ const careStartDateField = (0, $685be4cbbd7d2f79$export$1a2b950bdc1c1e93)(careStartDate, (next)=>{
        setCareStartDate(next);
        // Re-clamped against the new entry date — and cleared with it, so a sale date cannot survive
        // out of sight once its control is hidden.
        setRadFundingDate((current)=>$39641e97aa80005f$var$clampRadFundingDate(current, next));
    }, $39641e97aa80005f$var$clampCareStartDate);
    const radFundingDateField = (0, $685be4cbbd7d2f79$export$1a2b950bdc1c1e93)(radFundingDate, setRadFundingDate, (raw)=>$39641e97aa80005f$var$clampRadFundingDate(raw, careStartDate));
    /**
     * The day the funding assets are actually sold: the nominated date, or failing that the day care
     * starts — which is what the screen has always said happens.
     *
     * Until this existed, leaving the sale date blank did NOT mean "sold on the entry date". It meant
     * the sale was baked into the fact-find before the projection began, i.e. sold TODAY, whatever
     * entry date had been entered. The care FEES correctly waited for the entry date while the funding
     * jumped the gun, so a client entering care in four months had their RAD counted as an exempt asset
     * from day one and their Age Pension lifted for four months that had not happened yet. Entering a
     * December date produced, to the dollar, the same cash as entering care tomorrow.
     *
     * With an entry date set, the engine now owns the liquidation in every case (`radPlugin` registers
     * its sale and deposit phases off this), and the "sell earlier" control simply moves the day it
     * happens. Blank entry date still means care is already under way, where selling at the start of
     * the projection IS selling on the entry date.
     */ const effectiveRadFundingDate = radFundingDate || careStartDate;
    /**
     * Whether the ENGINE performs the asset sale and the debt payoff, rather than the fact-find
     * arriving with them already applied. True whenever there is a day to do them on.
     *
     * Hoisted out of `simulatedFactFind` because the Financial Impact panel needs it too — for the
     * opposite reason, see `factFindForImpactPanel`.
     */ const radLiquidationDeferredToEngine = !!effectiveRadFundingDate || isMover;
    const [extraServiceFeeInput, setExtraServiceFeeInput] = (0, $acw62.useState)(0);
    const [radFunding, setRadFunding] = (0, $acw62.useState)({});
    /**
     * The Debt Strategy card's two allocations: how much of each debt to clear, and which assets pay
     * for it. Separate bags rather than one, because they are answers to different questions — and the
     * funding one shares its `type-id` key space with `radFunding` so the two cards can net off against
     * each other asset by asset.
     */ const [debtPayments, setDebtPayments] = (0, $acw62.useState)({});
    const [debtFunding, setDebtFunding] = (0, $acw62.useState)({});
    /**
     * What a PART payment does to the repayment. Defaults to keeping it — which is what lenders do
     * unless asked otherwise, and retires the debt sooner. Only bites on a partial payoff.
     */ const [debtRepaymentBasis, setDebtRepaymentBasis] = (0, $acw62.useState)('keep_repayment');
    /** Per RAD funding asset key — accountant CGT override ($ total). */ const [cgtOverrides, setCgtOverrides] = (0, $acw62.useState)({});
    const [localLegacyYears, setLocalLegacyYears] = (0, $acw62.useState)(Number(legacyYears) || (0, $77d0522707ddb581$export$39a105507aa40371));
    const [showValidationModal, setShowValidationModal] = (0, $acw62.useState)(false);
    const [overallStrategy, setOverallStrategy] = (0, $acw62.useState)({
        rentHome: false,
        downsizeHome: false,
        accessHomeEquity: false,
        reverseMortgage: false,
        heas: false
    });
    /** Highlights which saved aged care row was last opened or selected from the Suggestion Engine. */ const [activeSavedStrategyId, setActiveSavedStrategyId] = (0, $acw62.useState)(null);
    /**
     * Set while a saved Suggestion Engine plan is being re-opened, so the panel opens quietly instead
     * of "thinking" (engineOpening.ts). Cleared whenever a mode is chosen afresh.
     */ const [reopenedEngineStrategyId, setReopenedEngineStrategyId] = (0, $acw62.useState)(null);
    /** The tested plan a hand-built plan was customised from ("Customise this plan"), by its plain title; null for a blank start. */ const [customisedFrom, setCustomisedFrom] = (0, $acw62.useState)(null);
    /** What the landing asked to open on arrival at the reopened plan (consumed once by the panel). */ const [reopenIntent, setReopenIntent] = (0, $acw62.useState)(null);
    /** A new model from scratch asks the setup questions again, even on a file that has answered them. */ const [askSetupAgain, setAskSetupAgain] = (0, $acw62.useState)(false);
    const [scenarioLivingExpenses, setScenarioLivingExpenses] = (0, $acw62.useState)(Number(factFind.expenses?.livingExpenses) || 0);
    /**
     * Living costs ONCE BOTH ARE IN CARE, where the second person enters later (owner, 7 Oct 2026).
     * Null = the same as the adjusted figure above; asked only in the staggered case, and applied by
     * the engine from the second entry (carePhases.ts).
     */ const [phaseTwoLivingExpenses, setPhaseTwoLivingExpenses] = (0, $acw62.useState)(null);
    /** The second stage's living costs a year, where the second person enters later; null otherwise. */ const livingOnceBoth = secondEntersLater ? phaseTwoLivingExpenses ?? (Number(scenarioLivingExpenses) || 0) : null;
    const [downsizeDetails, setDownsizeDetails] = (0, $acw62.useState)({
        salePrice: factFind.home?.value || 0,
        sellingCosts: (Number(factFind.home?.value) || 0) * 0.025,
        radAllocation: 0,
        newHomePurchasePrice: 0,
        downsizerContribution: 0,
        partnerDownsizerContribution: 0,
        commenceIncomeStream: false,
        giftingAmount: 0,
        funeralBondPurchase: 0,
        purchaseInvestmentProperty: 0,
        investmentPropertyRent: 0,
        investmentPropertyExpenses: 0,
        purchaseShares: 0
    });
    const [investmentPropertyDetails, setInvestmentPropertyDetails] = (0, $acw62.useState)({
        selectedPropertyId: factFind.assets?.investmentProperty?.[0]?.id ?? undefined,
        salePrice: factFind.assets?.investmentProperty?.[0]?.value || 0,
        sellingCosts: (Number(factFind.assets?.investmentProperty?.[0]?.value) || 0) * 0.025,
        costBase: factFind.assets?.investmentProperty?.[0]?.costBase,
        radAllocation: 0,
        newHomePurchasePrice: 0,
        downsizerContribution: 0,
        partnerDownsizerContribution: 0,
        commenceIncomeStream: false,
        giftingAmount: 0,
        funeralBondPurchase: 0
    });
    const [reverseMortgageDetails, setReverseMortgageDetails] = (0, $acw62.useState)({
        loanAmount: 0,
        loanPercentage: 0,
        interestRate: (0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279),
        loanStructure: 'lump_sum',
        regularPaymentAmount: 0,
        regularPaymentFrequency: 'fortnightly',
        establishmentFees: 0,
        useForRad: false // Checkbox: Use loan amount to fund RAD
    });
    const [heasDetails, setHeasDetails] = (0, $acw62.useState)({
        paymentAmount: 0,
        paymentFrequency: 'fortnightly',
        interestRate: 3.95 // Default HEAS rate (will be updated periodically)
    });
    const [strategyInputs, setStrategyInputs] = (0, $acw62.useState)({
        rentAmount: factFind.home?.likelyRent || 0,
        rentExpenses: factFind.home?.likelyExpenses || 0,
        partnerRent: 0
    });
    // Other Strategies state
    const [showOtherStrategies, setShowOtherStrategies] = (0, $acw62.useState)(false); // Collapsed by default
    const [otherStrategies, setOtherStrategies] = (0, $acw62.useState)({
        gifting: false,
        giftingAmount: 0,
        giftingSource: 'bankAccounts',
        funeralBonds: false,
        funeralBondAmount: 0,
        funeralBondSource: 'bankAccounts',
        annuity: false
    });
    const [annuityRecord, setAnnuityRecord] = (0, $acw62.useState)(null);
    // Initialize annuity function
    const initializeAnnuityRecord = ()=>{
        const isCouple = factFind?.adviceFor === 'couple';
        const owner = isCouple ? 'joint' : 'client';
        /*
         * A NEW HAND-BUILT GUARANTEED INCOME STARTS AS THE FULL-AMOUNT-BACK TYPE where the person may buy it
         * (guaranteed income review M1, 21 Oct 2026): in aged care that is nearly everyone, and it is the type
         * that never leaves the family short. Otherwise money back, as before. Saved plans keep their type.
         */ const fullBack = (0, $d08210caeacdc75a$export$7095ab72ebd46272)(factFind, owner);
        return {
            id: 'aged-care-annuity',
            annuityType: fullBack ? 'guaranteed' : 'lifetime',
            purchaseAmount: 0,
            // See DEFAULT_NEW_ANNUITY_RESIDUAL — capital preserved unless the client chooses otherwise.
            residualCapital: fullBack ? 1 : (0, $6a72ca5744dce23c$export$69797182cc224f5a),
            owner: owner,
            fundingSource: {
                id: 'bank-default',
                type: 'bank',
                assetId: null,
                label: 'Bank accounts / cash',
                ownership: isCouple ? 'joint' : 'client'
            },
            indexation: false,
            reversionary: false,
            age: factFind?.client?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client?.dob) : null,
            partnerAge: isCouple && factFind?.partner?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner.dob) : null
        };
    };
    const [showProjections, setShowProjections] = (0, $acw62.useState)(false);
    /** "Understanding your plan" — the full plain-words recap, opened from the plan summary panel. */ const [showPlanExplanation, setShowPlanExplanation] = (0, $acw62.useState)(false);
    const [showManualRisks, setShowManualRisks] = (0, $acw62.useState)(false);
    // The tested plans ARE step 3 (owner decision, 17 Oct 2026); Manual Control is reached by a link.
    const [strategyMode, setStrategyMode] = (0, $acw62.useState)('optimised');
    /**
     * Whether a way of modelling has been CHOSEN on step 3 (owner-caught, 9 Oct 2026). Step 3 used to
     * open silently in Manual Control, whose default plan puts a village payout to the room, so the plan
     * summary read "Pay the room in full" before the adviser had chosen anything. Until a mode is chosen
     * (or a saved plan reopened) the rail is the walk-in position and neither mode is highlighted.
     */ const [strategyModeChosen, setStrategyModeChosen] = (0, $acw62.useState)(true);
    /*
     * THE THREE STEPS (owner's review, September 2026). 1: what care costs. 2: what it means, as
     * four numbers and the plain-words note. 3: the ways to close the gap — the mode chooser and
     * everything after it, exactly as before, with the plan summary rail. The rail is shown ONLY on
     * step 3: on step 2 the page IS the baseline, and a rail restating it was a second column
     * saying the same thing. Every step is reachable at any time from the strip.
     */ // Both entering: the page is about the two of them, and says so wherever it names who is moving.
    const enteringFirstName = bothEntering ? `${(0, $b8d3cfe4c156722e$export$24ee473c3b86ae0)(factFind, secondPerson).firstName} and ${(0, $b8d3cfe4c156722e$export$24ee473c3b86ae0)(factFind, secondPerson).secondName}` : (factFind.goals?.aged_care_for === 'partner' ? factFind.partner?.firstName : factFind.client?.firstName) || 'the client';
    const [step, setStep] = (0, $acw62.useState)(1);
    /**
     * Which position the projections modal shows. Step 2's "See the projections" opens the WALK-IN
     * projection over the legacy horizon (owner, 22 Sep 2026: "this should show the projections for
     * the default period which is 5 years"); the rail's button on step 3 opens the plan's, as before.
     */ const [projectionsSource, setProjectionsSource] = (0, $acw62.useState)('plan');
    const goToStep = (next)=>{
        setStep(next);
        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
    };
    const [showFacilitySearch, setShowFacilitySearch] = (0, $acw62.useState)(false);
    const [selectedFacility, setSelectedFacility] = (0, $acw62.useState)(null);
    /** The second slot's three questions — the same component as the first slot's. */ const secondRoomInputs = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78960c4d92ac43b2$export$2e2bcd8739ae039), {
        idSuffix: "-second",
        roomPrice: secondRoom.roomPrice,
        onRoomPrice: (v)=>setSecondRoom((r)=>({
                    ...r,
                    roomPrice: v
                })),
        onFacilitySearch: ()=>{
            setFacilityTarget('second');
            setShowFacilitySearch(true);
        },
        selectedFacility: selectedSecondFacility,
        extraServiceAnnual: secondRoom.extraServiceAnnual,
        onExtraServiceAnnual: (v)=>setSecondRoom((r)=>({
                    ...r,
                    extraServiceAnnual: v
                })),
        careStartDate: secondRoom.careStartDate,
        dateInputProps: {
            value: secondRoom.careStartDate,
            onChange: (e)=>setSecondRoom((r)=>({
                        ...r,
                        careStartDate: e.target.value
                    }))
        },
        minDate: $39641e97aa80005f$var$toDateValue(new Date()),
        dateHelp: `Leave this blank if ${secondName} moves in at the same time as ${firstName}. With a later date, ${secondName} is modelled at home until then \u{2014} the family home stays exempt and the pension is paid at the illness-separated rate \u{2014} and their fees begin on the day you choose. An earlier date than ${firstName}'s makes ${secondName} the first to move in.`,
        dateHint: {
            blank: careStartDate ? `Leave blank if ${secondName} moves in with ${firstName} in ${(0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(careStartDate)}.` : `Leave blank if ${secondName} moves in with ${firstName} now.`,
            chosen: `${secondName}'s fees begin on this date.`
        }
    });
    /** The first room's three questions — rendered alone for one entrant, under a heading when both enter. */ const firstRoomInputs = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78960c4d92ac43b2$export$2e2bcd8739ae039), {
        roomPrice: radInput,
        onRoomPrice: setRadInput,
        onFacilitySearch: ()=>{
            setFacilityTarget('first');
            setShowFacilitySearch(true);
        },
        selectedFacility: selectedFacility,
        extraServiceAnnual: extraServiceFeeInput,
        onExtraServiceAnnual: setExtraServiceFeeInput,
        careStartDate: careStartDate,
        dateInputProps: careStartDateField,
        minDate: $39641e97aa80005f$var$toDateValue(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1)),
        dateLabel: isMover ? 'When is the move?' : undefined,
        dateHelp: isMover ? "Leave this blank if the move is straight away. With a future date, the current home's fees and deposit run until then; on the day of the move the deposit comes back and goes to the new room, and the new home's fees begin." : "Leave this blank if care is starting now, or if you're not sure yet \u2014 we'll model it from today. With a future date, we show life at home as it is until then, and care costs only begin on the day you choose.",
        dateHint: isMover ? {
            blank: 'Leave blank if the move is straight away, or pick a future date.',
            chosen: 'The move happens on this date: the deposit comes back and the new home\'s fees begin.'
        } : {
            blank: 'Leave blank if care is starting now, or pick a future date.',
            chosen: 'Care costs begin on this date. The projection still starts today, so the lead-up is modelled too.'
        }
    });
    // For progressive disclosure
    const [showStrategyOptions, setShowStrategyOptions] = (0, $acw62.useState)(false);
    const [showCompareModal, setShowCompareModal] = (0, $acw62.useState)(false);
    const [resetTrigger, setResetTrigger] = (0, $acw62.useState)(0);
    // Mock facility data with demo pricing and Sydney suburb-based locations
    const mockFacilities = [
        {
            id: 1,
            name: "Sunrise Aged Care",
            suburb: "Croydon",
            state: "NSW",
            radPrice: 500000,
            dailyFees: {
                basic: 70,
                dap: 68,
                nccc: 0,
                hsc: 13,
                extraServices: 0
            },
            distance: 1.2,
            rating: 4.2,
            careLevels: [
                "Low Care",
                "High Care"
            ],
            amenities: [
                "Garden",
                "Library",
                "Chapel"
            ],
            websiteUrl: 'https://example.org/carecompanion-demo/facilities/sunrise-aged-care',
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1559027615-cd4628902d4a', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1586023492125-27b2c045efd7', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1560448204-e02f11c3d0e2', 300, 200)
            ]
        },
        {
            id: 2,
            name: "Garden View Retirement Village",
            suburb: "Five Dock",
            state: "NSW",
            radPrice: 850000,
            dailyFees: {
                basic: 70,
                dap: 116,
                nccc: 0,
                hsc: 13,
                extraServices: 15
            },
            distance: 2.1,
            rating: 4.5,
            careLevels: [
                "Low Care",
                "High Care",
                "Dementia Care"
            ],
            amenities: [
                "Swimming Pool",
                "Gym",
                "Cafe"
            ],
            websiteUrl: 'https://example.org/carecompanion-demo/facilities/garden-view-retirement-village',
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1571896349842-33c89424de2d', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1564013799919-ab600027ffc6', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1582407947304-fd86f028f716', 300, 200)
            ]
        },
        {
            id: 3,
            name: "Heritage Manor",
            suburb: "Campsie",
            state: "NSW",
            radPrice: 780000,
            dailyFees: {
                basic: 70,
                dap: 107,
                nccc: 0,
                hsc: 13,
                extraServices: 0
            },
            distance: 3.4,
            rating: 3.8,
            careLevels: [
                "Low Care",
                "High Care"
            ],
            amenities: [
                "Garden",
                "Library"
            ],
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1512917774080-9991f1c4c750', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1560448204-603b3fc33ddc', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1564013799919-ab600027ffc6', 300, 200)
            ]
        },
        {
            id: 4,
            name: "Riverside Care Centre",
            suburb: "Burwood",
            state: "NSW",
            radPrice: 650000,
            dailyFees: {
                basic: 70,
                dap: 89,
                nccc: 0,
                hsc: 13,
                extraServices: 8
            },
            distance: 4.7,
            rating: 4.0,
            careLevels: [
                "Low Care",
                "High Care",
                "Palliative Care"
            ],
            amenities: [
                "Water Views",
                "Garden",
                "Chapel"
            ],
            websiteUrl: 'https://example.org/carecompanion-demo/facilities/riverside-care-centre',
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1564013799919-ab600027ffc6', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1582407947304-fd86f028f716', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1571896349842-33c89424de2d', 300, 200)
            ]
        },
        {
            id: 5,
            name: "Mountain View Aged Care",
            suburb: "Ashfield",
            state: "NSW",
            radPrice: 420000,
            dailyFees: {
                basic: 70,
                dap: 58,
                nccc: 0,
                hsc: 13,
                extraServices: 0
            },
            distance: 6.2,
            rating: 4.3,
            careLevels: [
                "Low Care",
                "High Care"
            ],
            amenities: [
                "Mountain Views",
                "Garden",
                "Library"
            ],
            websiteUrl: 'https://example.org/carecompanion-demo/facilities/mountain-view-aged-care',
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1559027615-cd4628902d4a', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1586023492125-27b2c045efd7', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1560448204-e02f11c3d0e2', 300, 200)
            ]
        },
        {
            id: 6,
            name: "Carlton Gardens Care",
            suburb: "Croydon",
            state: "NSW",
            radPrice: 720000,
            dailyFees: {
                basic: 70,
                dap: 99,
                nccc: 0,
                hsc: 13,
                extraServices: 12
            },
            distance: 1.8,
            rating: 4.1,
            careLevels: [
                "Low Care",
                "High Care",
                "Dementia Care"
            ],
            amenities: [
                "City Views",
                "Garden",
                "Library",
                "Cafe"
            ],
            websiteUrl: 'https://example.org/carecompanion-demo/facilities/carlton-gardens-care',
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1512917774080-9991f1c4c750', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1560448204-603b3fc33ddc', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1564013799919-ab600027ffc6', 300, 200)
            ]
        }
    ];
    // Check for strategy to reopen from Dashboard
    (0, $acw62.useEffect)(()=>{
        const strategyToReopen = sessionStorage.getItem('careCompanionReopenStrategy');
        /*
         * "MODEL ANOTHER HOME" (UX review, 17 Oct 2026): the client's details, living costs and setup
         * answers are carried over from a saved plan and only the room is new. Same token idea as a
         * reopen, but it lands on step 1 with the room price cleared and nothing chosen for it.
         */ const anotherHomeFrom = sessionStorage.getItem('careCompanionModelAnotherHome');
        /*
         * "START A NEW MODEL FROM SCRATCH" (owner, 19 Oct 2026: starting again was hard to find, and he
         * may want to change the strategy assumptions too). Nothing is carried over from a saved plan:
         * step 1 opens empty, and step 3 asks the questions that change the answer again, pre-filled
         * with the last answers so any of them can be changed.
         */ const startFresh = sessionStorage.getItem('careCompanionStartFresh');
        if (startFresh) {
            sessionStorage.removeItem('careCompanionStartFresh');
            setAskSetupAgain(true);
        }
        if (strategyToReopen) try {
            const strategy = JSON.parse(strategyToReopen);
            reopenStrategy(strategy);
            // "Build a plan yourself" from the plan page: the plan's room, living costs and start date,
            // and a blank plan (25 Oct 2026). Applied after the reopen, so its reset wins.
            if (sessionStorage.getItem('careCompanionReopenIntent') === 'build-new') onBuildYourOwn(null);
            // The landing's buttons say what to open on arrival — Explain this, the risks, the
            // comparison or the advice document — once the plans are on screen.
            const intent = sessionStorage.getItem('careCompanionReopenIntent');
            if (intent === 'explain' || intent === 'risks' || intent === 'compare' || intent === 'document' || intent === 'detail' || intent === 'build') setReopenIntent(intent);
            else if (intent === 'room') setStep(1);
            sessionStorage.removeItem('careCompanionReopenIntent');
            // Clear the stored strategy
            sessionStorage.removeItem('careCompanionReopenStrategy');
        } catch (error) {
            console.error('Error parsing strategy to reopen:', error);
            sessionStorage.removeItem('careCompanionReopenStrategy');
        }
        else if (anotherHomeFrom) {
            try {
                const from = JSON.parse(anotherHomeFrom);
                if (from?.inputs?.scenarioLivingExpenses != null) setScenarioLivingExpenses(Number(from.inputs.scenarioLivingExpenses) || 0);
                if (from?.inputs?.legacyYears) setLocalLegacyYears(Number(from.inputs.legacyYears) || (0, $77d0522707ddb581$export$39a105507aa40371));
            } catch (error) {
                console.error('Error reading the plan to model another home from:', error);
            }
            sessionStorage.removeItem('careCompanionModelAnotherHome');
            // Step 3 asks the questions again, filled in from the file, so the choice between our plans and
            // building one yourself comes before any run (owner, 20 Oct 2026: it went straight to optimising).
            setAskSetupAgain(true);
            setRadInput(0);
            setSelectedFacility(null);
            setStrategyModeChosen(true);
            setStrategyMode('optimised');
            setShowStrategyOptions(false);
            setStep(1);
        } else // If no strategy to reopen, clear selectedStrategy to ensure fresh start
        // This handles the case when navigating from Dashboard "Next Steps" (not reopening)
        setSelectedStrategy(null);
    }, [
        setSelectedStrategy
    ]);
    // Trigger reset when resetTrigger changes
    (0, $acw62.useEffect)(()=>{
        if (resetTrigger > 0) resetManualControlToBaseline();
    }, [
        resetTrigger
    ]);
    /*
     * INCOME ONLY NEEDS THE CLIENT'S TICK (owner, 21 Oct 2026): a hand-built plan whose annuity returns
     * nothing cannot be saved until the client has ticked that nothing comes back. See IncomeOnlyTick.tsx.
     */ const manualIncomeOnly = !!otherStrategies.annuity && (0, $5eae79c7e46ed27e$export$3c8a471078a7436)(annuityRecord);
    const manualIncomeOnlyHeld = (0, $5eae79c7e46ed27e$export$655f124668ce439a)(factFind, manualIncomeOnly, Number(annuityRecord?.purchaseAmount) || 0);
    const setIncomeOnlyUnderstood = (0, $5eae79c7e46ed27e$export$415ddf94c95c9134)(setFactFind);
    /*
     * WHICH HAND-BUILT PLAN IS CHOSEN (25 Oct 2026). "Choose this plan" leaves the levers where they are, so the rail
     * says "Chosen ✓" while they still describe the plan that was chosen, and offers the choice again the moment one
     * moves.
     */ const manualPlanSig = JSON.stringify([
        radInput,
        extraServiceFeeInput,
        radFunding,
        debtPayments,
        debtFunding,
        cgtOverrides,
        overallStrategy,
        strategyInputs,
        downsizeDetails,
        investmentPropertyDetails,
        reverseMortgageDetails,
        heasDetails,
        otherStrategies,
        annuityRecord,
        careStartDate,
        radDrawdown,
        localLegacyYears,
        scenarioLivingExpenses
    ]);
    const [manualChosenSig, setManualChosenSig] = (0, $acw62.useState)(null);
    const manualIsChosen = manualChosenSig != null && manualChosenSig === manualPlanSig;
    const anotherAgedCarePlanChosen = !manualIsChosen && savedStrategies.some((p)=>p.type === 'aged_care' && p.chosen);
    // Strategy management functions
    /*
     * SAVE / CHOOSE A PLAN BUILT BY HAND (owner, 25 Oct 2026). Both sit at the foot of the rail now, where the plan's
     * figures are. The plan is named in the same words as the rail heading — the plain words a tested plan gets —
     * rather than a typed name. "Choose this plan" makes it the one chosen plan on the file (the others unmarked, as
     * a tested plan's choice does) and leaves the levers where they are; "Save this plan" keeps it beside the others
     * and clears the screen for the next one, as before.
     */ const saveStrategy = (strategyName, opts = {})=>{
        if (manualIncomeOnlyHeld) return;
        const strategy = {
            id: `strategy-${Date.now()}`,
            name: strategyName,
            displayName: strategyName,
            type: 'aged_care',
            ...opts.choose ? {
                chosen: true
            } : {},
            /*
             * WHO BUILT THIS PLAN. The suggestion engine already stamps its own saves with
             * source: 'suggestion_engine'; this path — an adviser setting the levers by hand — stamped
             * nothing, so on the dashboard the two were indistinguishable. That matters when an adviser
             * comes back weeks later to a list of plans and has to know which ones they reasoned their
             * way to and which the engine proposed.
             *
             * Plans saved before this carry no source at all, and the dashboard shows them no badge
             * rather than guessing one.
             */ source: 'manual_control',
            // Built by the client from a tested plan ("Customise this plan"): the advice document says so.
            ...customisedFrom ? {
                customisedFrom: customisedFrom
            } : {},
            inputs: {
                radInput: radInput,
                extraServiceFeeInput: extraServiceFeeInput,
                radFunding: radFunding,
                debtPayments: // The Debt Strategy card's two allocations, saved beside the RAD's so a reopened
                // strategy models the same plan it was saved as. Without these a strategy that cleared
                // a $50,000 loan would silently reopen as one that did not.
                debtPayments,
                debtFunding: debtFunding,
                debtRepaymentBasis: debtRepaymentBasis,
                cgtOverrides: cgtOverrides,
                overallStrategy: overallStrategy,
                strategyInputs: strategyInputs,
                downsizeDetails: downsizeDetails,
                investmentPropertyDetails: // The investment property sale, so the plan's position can be rebuilt away from this
                // page (the Action Plan's after-the-plan forms). Plans saved before 3 Oct 2026 lack it.
                investmentPropertyDetails,
                reverseMortgageDetails: reverseMortgageDetails,
                heasDetails: heasDetails,
                scenarioLivingExpenses: scenarioLivingExpenses,
                otherStrategies: otherStrategies,
                annuityRecord: annuityRecord,
                careStartDate: careStartDate,
                radFundingDate: radFundingDate,
                radDrawdown: radDrawdown,
                // The second room, where both are entering care (null otherwise), so a reopened plan has it.
                secondRoom: bothEntering ? {
                    ...secondRoom,
                    person: secondPerson,
                    radPaid: secondFunding?.funded ?? 0
                } : null,
                leadPerson: leadPerson,
                // A change of home (8 Oct 2026): the home left, the refund, and what the move pays.
                facilityMove: isMover && currentHomeFacts ? {
                    person: moverPerson,
                    moveDate: careStartDate || (0, $b8d3cfe4c156722e$export$cea9846d43ecc40e)(),
                    facilityName: currentHomeFacts.facilityName,
                    currentRoomPrice: currentHomeFacts.roomPrice,
                    paid: currentHomeFacts.paid,
                    refundToday: moverDeposit.balance,
                    retained: moverDeposit.retained,
                    retentionDaysTaken: moverDeposit.retentionDaysTaken,
                    grandfathered: moverGrandfathered,
                    newRoomPrice: radInput,
                    radTarget: radPaid
                } : null,
                // Leaving a village (8 Oct 2026): what the village pays, when, and what of it goes to the room.
                villageExit: villageExit ? {
                    person: villagePerson,
                    leaveDate: villageLeaveDate,
                    refundDate: villageRefundDate,
                    paidAtMove: villagePaidAtMove,
                    refundMonths: villageExit.refundMonths,
                    entitlement: villageExit.entitlement,
                    departureFee: villageExit.departureFee,
                    reinstatement: villageExit.reinstatement,
                    fromVillage: radPaidBreakdown.fromVillage,
                    toBank: Math.max(0, villageExit.entitlement - radPaidBreakdown.fromVillage),
                    interim: villageInterim,
                    feesAfterLeaving: villageFees
                } : null,
                phaseTwoLivingExpenses: phaseTwoLivingExpenses,
                ...residentialFeeArrangements ? {
                    residentialFeeArrangements: residentialFeeArrangements
                } : {},
                // Recorded so a saved strategy can say what horizon its legacy estimate was struck over.
                // Without it the comparison table put a 10-year legacy beside a 5-year one with nothing
                // to distinguish them — and the default horizon itself changed on 2026-08-06, so a
                // client's own saved strategies can straddle the change. Strategies saved before this
                // carry no `legacyYears`; the table says "not recorded" rather than guessing.
                legacyYears: localLegacyYears
            },
            outputs: {
                agedCareCost: (householdAgedCareCosts.totalDailyCost || 0) * 365,
                // The second stage, where the second person enters later (carePhases.ts).
                phaseTwo: phaseTwoHousehold && phaseTwo ? {
                    fromDate: secondRoom.careStartDate,
                    agedCareCost: (phaseTwoHousehold.totalDailyCost || 0) * 365,
                    householdDailyCost: phaseTwoHousehold.totalDailyCost || 0,
                    cashFlow: (phaseTwo.financials.cashFlow || 0) - (phaseTwoHousehold.totalDailyCost || 0) * 365,
                    agePension: phaseTwo.financials.socialSecurity || 0,
                    ...livingOnceBoth != null ? {
                        livingExpenses: livingOnceBoth
                    } : {}
                } : null,
                agePension: simulatedFinancials.socialSecurity || 0,
                cashFlow: simulatedFinancials.cashFlow - (householdAgedCareCosts.totalDailyCost || 0) * 365,
                legacyEstimate: (projections && projections.length > 0 ? (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(projections[projections.length - 1]) : 0) || 0,
                roomCost: radInput,
                radPaid: // The deposit itself (not the assets sold for it), for the screens that link to this plan.
                radPaid,
                // The whole net worth line, not just its last row. `legacyEstimate` above is the final
                // year and answers only "what is left at the end"; a client asking what they will be
                // worth in a particular year is asking about a row in the middle, which used to be
                // discarded here. See shared/src/calculation/netWorthSchedule.ts.
                netWorthSchedule: (0, $a882fd27fa2c97d8$export$7386c6396507d94b)(projections)
            },
            createdAt: new Date().toISOString()
        };
        const newStrategies = [
            ...opts.choose ? savedStrategies.map((p)=>p.type === 'aged_care' && p.chosen ? {
                    ...p,
                    chosen: false
                } : p) : savedStrategies,
            strategy
        ];
        setSavedStrategies(newStrategies);
        setActiveSavedStrategyId(strategy.id);
        sessionStorage.setItem('careCompanionStrategies', JSON.stringify(newStrategies));
        // sessionStorage is the working copy; this is what gets it onto the server for a real client.
        onStrategySaved?.(strategy);
        (0, $f58ff7d3c4c676c4$export$b731185d32c620a3)((0, $f58ff7d3c4c676c4$export$816f75caf2488b34)('aged_care', strategy.id));
        (0, $f58ff7d3c4c676c4$export$33b576d5d6fa435b)();
        if (opts.choose) {
            // The chosen plan is now this one: the page reads the mark, not an engine row still held in memory.
            setSelectedStrategy(null);
            setManualChosenSig(manualPlanSig);
            return;
        }
        // Trigger reset using state change
        setResetTrigger((prev)=>prev + 1);
    };
    const openManualControlDigitalSOA = async ()=>{
        /**
         * The reader's chosen calendar is a MODELLING choice, not a display filter — the engine opens,
         * grows and settles on the period it reports — so an SOA produced while calendar years are
         * selected must be built from a calendar-year RUN, not financial-year rows wearing calendar
         * headings. Run here rather than kept in state: generating an SOA is an explicit act, and this
         * spares every page load a second engine call for a document nobody may ask for.
         *
         * Uses the identical inputs the financial-year run used, so the only difference between the two
         * documents is the calendar the reader asked for.
         */ const soaPeriodMode = (0, $4f50ab660c01dd64$export$1e222c2c280e2a28)();
        const soaProjections = soaPeriodMode === 'calendar_year' ? await $55a1d8a64f1e5dfa$export$75699a59a86ef1ab(simulatedFactFind, {
            ...projectionStrategyOptions,
            projectionPeriodMode: 'calendar_year'
        }, agedCareCosts, localLegacyYears, {
            debug: false
        }) : projections;
        /*
         * THE SAME PLAN AT OUR RATES, where the client set a rate of their own. The SOA reports a
         * client-chosen rate as their decision and shows what it is worth — this exact plan, on the
         * same applied balance sheet, with nothing changed but the rates. See assetRateOverrides.ts.
         */ const atDefaultRatesProjections = (0, $2cee3e5f0555e7bc$export$d0c209ebea676c25)(factFind) ? await $55a1d8a64f1e5dfa$export$75699a59a86ef1ab((0, $2cee3e5f0555e7bc$export$d2d5e7cb7f9df3f)(simulatedFactFind), soaPeriodMode === 'calendar_year' ? {
            ...projectionStrategyOptions,
            projectionPeriodMode: 'calendar_year'
        } : projectionStrategyOptions, agedCareCosts, localLegacyYears, {
            debug: false
        }) : null;
        const manualSavedStrategies = savedStrategies.filter((s)=>s.type === 'aged_care' && s.source !== 'suggestion_engine');
        const describeManualStrategy = ()=>{
            const radPct = radInput > 0 ? Math.round(radPaid / radInput * 100) : 0;
            const homeAction = overallStrategy.downsizeHome ? 'Downsize Home' : overallStrategy.rentHome ? 'Rent Home' : overallStrategy.reverseMortgage ? 'Reverse Mortgage' : overallStrategy.heas ? 'HEAS' : 'Keep Home';
            return `Pay ${radPct}% RAD, ${homeAction}`;
        };
        const selectedName = describeManualStrategy();
        const convertedRadFunding = $39641e97aa80005f$var$convertManualRadFundingForSnapshot(radFunding);
        const firstYear = soaProjections?.[0] || {};
        const currentManualStrategy = {
            id: `manual-current-${Date.now()}`,
            name: selectedName,
            projections: soaProjections || [],
            radFunding: convertedRadFunding,
            strategyOptions: {
                ...overallStrategy,
                ...strategyInputs,
                downsizeDetails: downsizeDetails,
                radDrawdown: radDrawdown,
                otherStrategies: otherStrategies,
                annuityRecord: otherStrategies.annuity ? annuityRecord : null
            },
            atDefaultRatesProjections: atDefaultRatesProjections,
            snapshot: {
                legacyValue: soaProjections && soaProjections.length > 0 ? (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(soaProjections[soaProjections.length - 1]) ?? 0 : 0,
                netCashflow: simulatedFinancials.cashFlow - (householdAgedCareCosts.totalDailyCost || 0) * 365,
                pension: simulatedFinancials.socialSecurity ?? firstYear.socialSecurity ?? 0,
                totalAgedCareCosts: (householdAgedCareCosts.totalDailyCost || 0) * 365,
                livingExpenses: scenarioLivingExpenses || 0,
                taxPayable: simulatedFinancials.taxPayable ?? firstYear.taxPayable ?? 0
            },
            context: `Selected by adviser from manual control modelling (${selectedName}).`
        };
        const savedAlternatives = manualSavedStrategies.map((s)=>({
                id: s.id,
                name: s.name,
                projections: [],
                radFunding: $39641e97aa80005f$var$convertManualRadFundingForSnapshot(s.inputs?.radFunding || {}),
                strategyOptions: s.inputs?.overallStrategy || {},
                snapshot: {
                    legacyValue: s.outputs?.legacyEstimate || 0,
                    netCashflow: s.outputs?.cashFlow || 0,
                    pension: s.outputs?.agePension || 0,
                    totalAgedCareCosts: s.outputs?.agedCareCost || 0,
                    livingExpenses: (0, $1b5ad53cec30af73$export$df3d7258e77c9184)(s.inputs?.scenarioLivingExpenses, factFind.expenses?.livingExpenses),
                    taxPayable: 0
                },
                context: 'Alternative manual strategy saved during adviser modelling.'
            }));
        const normalizeName = (name = '')=>String(name).toLowerCase().replace(/[^a-z0-9]/g, '');
        const isNearlyEqual = (a, b, tolerance = 1)=>Math.abs((Number(a) || 0) - (Number(b) || 0)) <= tolerance;
        const dedupedAlternatives = savedAlternatives.filter((s)=>{
            const sameName = normalizeName(s.name) === normalizeName(currentManualStrategy.name);
            const sameOutcome = isNearlyEqual(s.snapshot?.legacyValue, currentManualStrategy.snapshot?.legacyValue) && isNearlyEqual(s.snapshot?.netCashflow, currentManualStrategy.snapshot?.netCashflow) && isNearlyEqual(s.snapshot?.pension, currentManualStrategy.snapshot?.pension);
            return !(sameName || sameOutcome);
        });
        const allManualScenarios = [
            currentManualStrategy,
            ...dedupedAlternatives
        ];
        /*
         * The SOA baseline, from the SAME definition the screen uses (agedCareBaseline.ts) — so the
         * document and the panel can never quote different improvement figures for one plan.
         *
         * It previously built these options inline and fell into both halves of the trap that module
         * exists to close: it carried no residency override, so the couple was assessed as two people
         * living at home while being charged full nursing-home fees, and the illness-separated
         * treatment never fired — understating the baseline pension and crediting every strategy with
         * the difference. It also ran on `simulatedFactFind`, i.e. the strategy's own balance sheet.
         * Both are fixed below: original fact-find, residency carried explicitly.
         */ const doNothingStrategyOptions = (0, $12e551cf654c2507$export$4581e8ea18cb7f11)(factFind, scenarioLivingExpenses, {
            ...careStartDate ? {
                careStartDate: careStartDate
            } : {}
        });
        const doNothingAgedCareCosts = await $55a1d8a64f1e5dfa$export$fb677777baef0897({
            factFind: factFind,
            financials: initialFinancials,
            radInput: radInput,
            extraServiceFeeInput: 0,
            radPaid: 0,
            overallStrategy: {
                rentHome: false,
                downsizeHome: false,
                accessHomeEquity: false,
                reverseMortgage: false,
                heas: false
            }
        });
        const doNothingProjections = await $55a1d8a64f1e5dfa$export$75699a59a86ef1ab(// The ORIGINAL fact-find. Running the strategy's mutated one made the "do nothing"
        // baseline inherit the home already sold and the RAD already paid — every balance-sheet
        // consequence of the strategy, with only its options removed.
        factFind, // Same calendar as the strategy above: comparing a calendar-year strategy against a
        // financial-year baseline would put a timing artefact into every delta in the document.
        // The second room, undecided too, where both are entering care.
        {
            ...doNothingStrategyOptions,
            projectionPeriodMode: soaPeriodMode,
            ...baselineSecondCosts ? {
                secondResident: {
                    person: secondPerson,
                    ...secondRoom.careStartDate ? {
                        careStartDate: secondRoom.careStartDate
                    } : {},
                    radFunding: {},
                    agedCareCosts: baselineSecondCosts
                }
            } : {}
        }, {
            ...doNothingAgedCareCosts,
            scenarioLivingExpenses: scenarioLivingExpenses
        }, localLegacyYears);
        const doNothingFirstYear = doNothingProjections?.[0] || {};
        const doNothingStrategy = {
            id: `manual-do-nothing-${Date.now()}`,
            name: 'Do Nothing',
            projections: doNothingProjections || [],
            radFunding: {},
            strategyOptions: doNothingStrategyOptions,
            snapshot: {
                legacyValue: doNothingProjections?.length > 0 ? (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(doNothingProjections[doNothingProjections.length - 1]) ?? 0 : 0,
                netCashflow: (doNothingFirstYear.totalIncome || 0) - (doNothingFirstYear.totalExpenses || 0),
                pension: doNothingFirstYear.socialSecurity || 0,
                totalAgedCareCosts: (0, $bdfd96a4f4ac117d$export$4a7e3987a5ffaa21)(doNothingAgedCareCosts, baselineSecondCosts) * 365,
                livingExpenses: scenarioLivingExpenses || 0,
                taxPayable: doNothingFirstYear.taxPayable || 0
            },
            context: 'Do nothing baseline: no strategy actions and no RAD lump sum contribution.'
        };
        const analysisForSoa = {
            totalScenarios: allManualScenarios.length + 1,
            strategies: [
                doNothingStrategy,
                ...allManualScenarios
            ],
            allSimulatedStrategies: [
                doNothingStrategy,
                ...allManualScenarios
            ],
            recommendedOptimalStrategies: []
        };
        // buildAgedCareDigitalSOASnapshot's SoaScenario/SoaAnalysis param types (owned by a concurrent
        // typing pass on AgedCareSuggestionEngineDigitalSOAAttachment.tsx) aren't exported, so the
        // locally-built snapshot bags here (structurally close but not identical) are cast at this
        // one boundary rather than duplicating their internal shape.
        const snapshot = await (0, $02a659cad5e2280d$export$8b925970c458dc89)({
            selectedStrategy: currentManualStrategy,
            factFind: factFind,
            agedCareCosts: {
                ...agedCareCosts,
                radAmount: radInput,
                scenarioLivingExpenses: scenarioLivingExpenses
            },
            analysis: analysisForSoa,
            coupleValidation: coupleValidation,
            reportAudience: 'professional',
            strategySource: 'manual_control',
            customisedFrom: currentManualStrategy?.customisedFrom ?? customisedFrom,
            manualAlternativeStrategies: allManualScenarios,
            projectionPeriodMode: soaPeriodMode
        });
        (0, $02a659cad5e2280d$export$eed5e3bcf209d966)(snapshot);
        const savedSoaScenario = {
            id: `soa-${Date.now()}`,
            name: `MC | ${currentManualStrategy.name}`,
            createdAt: new Date().toISOString(),
            soaSource: 'MC',
            caseId: professionalCaseId || null,
            soaDeliveryStatus: 'draft',
            isCurrentForCase: true,
            outputs: {
                agedCareCost: (householdAgedCareCosts.totalDailyCost || 0) * 365,
                // The second stage, where the second person enters later (carePhases.ts).
                phaseTwo: phaseTwoHousehold && phaseTwo ? {
                    fromDate: secondRoom.careStartDate,
                    agedCareCost: (phaseTwoHousehold.totalDailyCost || 0) * 365,
                    householdDailyCost: phaseTwoHousehold.totalDailyCost || 0,
                    cashFlow: (phaseTwo.financials.cashFlow || 0) - (phaseTwoHousehold.totalDailyCost || 0) * 365,
                    agePension: phaseTwo.financials.socialSecurity || 0,
                    ...livingOnceBoth != null ? {
                        livingExpenses: livingOnceBoth
                    } : {}
                } : null,
                agePension: currentManualStrategy.snapshot.pension || 0,
                cashFlow: currentManualStrategy.snapshot.netCashflow || 0,
                legacyEstimate: currentManualStrategy.snapshot.legacyValue || 0
            },
            soaSnapshot: snapshot
        };
        const newCaseStudies = [
            ...savedCaseStudies.map((item)=>professionalCaseId && item.caseId === professionalCaseId ? {
                    ...item,
                    isCurrentForCase: false
                } : item),
            savedSoaScenario
        ];
        setSavedCaseStudies(newCaseStudies);
        sessionStorage.setItem('careCompanionCaseStudies', JSON.stringify(newCaseStudies));
        sessionStorage.setItem('careCompanionScenarios', JSON.stringify(newCaseStudies));
        onSoaGenerated?.(savedSoaScenario);
    };
    const resetManualControlToBaseline = ()=>{
        // Keep RAD and living expenses - don't reset these core values
        // setRadInput(0); // Don't reset - keep current RAD value
        // setScenarioLivingExpenses(factFind.expenses?.livingExpenses || 0); // Don't reset - keep current living expenses
        // Reset only the strategy-specific inputs
        setExtraServiceFeeInput(0);
        // Care start date is KEPT, like the room price and living expenses above it. When someone
        // enters a date and saves a strategy, they are almost always about to model a second way of
        // funding the SAME move — clearing it made them re-enter the same date for every scenario,
        // and (worse) a strategy saved without noticing came out anchored to "care starts now",
        // which is a different projection rather than a blank field.
        //
        // The SALE date does still clear: it belongs to the funding plan being cleared below, not to
        // the move. With `radFunding` emptied there is nothing left to sell, so keeping it would
        // leave a date attached to a sale that no longer exists.
        setRadFundingDate('');
        setRadFunding({});
        setDebtPayments({});
        setDebtFunding({});
        setDebtRepaymentBasis('keep_repayment');
        setCgtOverrides({});
        // The years the plans are compared over are KEPT too (25 Oct 2026): they are a setup answer, like
        // the living costs, and a blank plan or a customised one is compared over the same years as the
        // tested plans. Resetting them here made "Customise this plan" open on a different horizon.
        setOverallStrategy({
            rentHome: false,
            downsizeHome: false,
            accessHomeEquity: false,
            reverseMortgage: false,
            heas: false
        });
        setStrategyInputs({
            rentAmount: factFind.home?.likelyRent || 0,
            rentExpenses: factFind.home?.likelyExpenses || 0,
            partnerRent: 0
        });
        setDownsizeDetails({
            salePrice: factFind.home?.value || 0,
            sellingCosts: (Number(factFind.home?.value) || 0) * 0.025,
            radAllocation: 0,
            newHomePurchasePrice: 0,
            downsizerContribution: 0,
            giftingAmount: 0,
            funeralBondPurchase: 0
        });
        setReverseMortgageDetails({
            loanAmount: 0,
            loanPercentage: 0,
            interestRate: (0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279),
            loanStructure: 'lump_sum',
            regularPaymentAmount: 0,
            regularPaymentFrequency: 'fortnightly',
            establishmentFees: 0,
            useForRad: false
        });
        setHeasDetails({
            paymentAmount: 0,
            paymentFrequency: 'fortnightly',
            interestRate: 3.95
        });
        // Reset Other Strategies
        setOtherStrategies({
            gifting: false,
            giftingAmount: 0,
            giftingSource: 'bankAccounts',
            funeralBonds: false,
            funeralBondAmount: 0,
            funeralBondSource: 'bankAccounts',
            annuity: false
        });
        setAnnuityRecord(null);
        setShowOtherStrategies(false);
        setCustomisedFrom(null);
        setShowProjections(false);
        setShowCompareModal(false);
        setShowStrategyOptions(true);
        setStrategyMode('manual');
    };
    const reopenStrategy = (strategy)=>{
        // Handle different strategy structures
        if (strategy.source === 'suggestion_engine') {
            // Restore inputs so facility price and cost context match when strategy was saved (avoids $0 and wrong optimal on reopen)
            const roomCost = strategy.outputs?.roomCost;
            if (roomCost != null && !isNaN(parseFloat(String(roomCost)))) setRadInput(parseFloat(String(roomCost)));
            if (strategy.inputs?.scenarioLivingExpenses != null) setScenarioLivingExpenses(strategy.inputs.scenarioLivingExpenses);
            if (strategy.homeName) setHomeName(String(strategy.homeName));
            if (strategy.inputs?.legacyYears) setLocalLegacyYears(Number(strategy.inputs.legacyYears) || (0, $77d0522707ddb581$export$39a105507aa40371));
            setStrategyModeChosen(true);
            setStrategyMode('optimised');
            setShowStrategyOptions(true);
            /*
             * Opening a saved plan is not choosing it (owner's journey 2, 17 Oct 2026): a plan saved
             * for another home and "not chosen" on Home must open as not chosen, with the chosen plan
             * for the other room left in place. Only the chosen plan — or the one already selected —
             * becomes the selection on reopen.
             */ const row = strategy.strategy ?? null;
            const current = selectedStrategy;
            const sameAsSelected = !!(row && current && String(current.name) === String(row.name) && Math.abs((Number(current.radRoomPrice) || 0) - (Number(row.radRoomPrice) || 0)) < 1 && Math.abs((Number(current.radPaidNet) || 0) - (Number(row.radPaidNet) || 0)) < 1);
            const isChosen = !!strategy.chosen || sameAsSelected;
            if (isChosen) setSelectedStrategy(row);
            else if (!current) {
                // After a reload the selection is empty although a plan is chosen on file; restore it
                // so the plans for this other room can say which room's plan stays chosen.
                const chosenOnFile = (savedStrategies || []).find((p)=>p.chosen && p.strategy);
                if (chosenOnFile?.strategy) setSelectedStrategy(chosenOnFile.strategy);
            }
            setActiveSavedStrategyId(strategy.id);
            setReopenedEngineStrategyId(strategy.id ?? null);
            // A reopened plan lands ON the plan, not on an empty step 1 (UX review, 17 Oct 2026) — and
            // not on the setup questions either: a plan that exists was set up when it was made.
            if (!coupleValidation.suggestionEngineSetupComplete) setCoupleValidation({
                ...coupleValidation,
                suggestionEngineSetupComplete: true
            });
            setStep(3);
            return;
        }
        // For Manual Control strategies, restore the strategy inputs
        const inputs = strategy.inputs || {};
        setRadInput(inputs.radInput || 0);
        // Re-clamped on restore: a strategy saved months ago may carry an entry date that has since
        // arrived, which collapses to "care is starting now". Strategies saved before entry became
        // day-precise carry `careEntryMonth` instead, and are read as the 1st of that month.
        const restoredCareStart = $39641e97aa80005f$var$careStartDateFromSavedInputs(inputs);
        setCareStartDate(restoredCareStart);
        // Re-clamped against the restored entry date, not just against today: a sale date that has
        // arrived, or that now sits after the move, collapses to "sold now".
        setRadFundingDate($39641e97aa80005f$var$clampRadFundingDate(inputs.radFundingDate, restoredCareStart));
        setRadDrawdown(inputs.radDrawdown || 'fees');
        setSecondRoom(inputs.secondRoom ? {
            roomPrice: Number(inputs.secondRoom.roomPrice) || 0,
            careStartDate: inputs.secondRoom.careStartDate || '',
            extraServiceAnnual: Number(inputs.secondRoom.extraServiceAnnual) || 0
        } : $39641e97aa80005f$var$EMPTY_SECOND_ROOM);
        setLeadPerson(inputs.leadPerson === 'partner' ? 'partner' : 'client');
        setPhaseTwoLivingExpenses(typeof inputs.phaseTwoLivingExpenses === 'number' ? inputs.phaseTwoLivingExpenses : null);
        setOptInToNovember2025Fees(inputs.residentialFeeArrangements === '2025');
        setExtraServiceFeeInput(inputs.extraServiceFeeInput || 0);
        setRadFunding(inputs.radFunding || {});
        setDebtPayments(inputs.debtPayments || {});
        setDebtFunding(inputs.debtFunding || {});
        setDebtRepaymentBasis(inputs.debtRepaymentBasis || 'keep_repayment');
        setCgtOverrides(inputs.cgtOverrides || {});
        setOverallStrategy(inputs.overallStrategy || {
            rentHome: false,
            downsizeHome: false,
            accessHomeEquity: false,
            reverseMortgage: false,
            heas: false
        });
        setStrategyInputs(inputs.strategyInputs || {
            rentAmount: factFind.home?.likelyRent || 0,
            rentExpenses: factFind.home?.likelyExpenses || 0,
            partnerRent: 0
        });
        setDownsizeDetails(inputs.downsizeDetails || {
            salePrice: factFind.home?.value || 0,
            sellingCosts: (Number(factFind.home?.value) || 0) * 0.025,
            radAllocation: 0,
            newHomePurchasePrice: 0,
            downsizerContribution: 0,
            partnerDownsizerContribution: 0,
            giftingAmount: 0,
            funeralBondPurchase: 0,
            purchaseInvestmentProperty: 0,
            investmentPropertyRent: 0,
            investmentPropertyExpenses: 0,
            purchaseShares: 0
        });
        setReverseMortgageDetails(inputs.reverseMortgageDetails || {
            loanAmount: 0,
            loanPercentage: 0,
            interestRate: (0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279),
            loanStructure: 'lump_sum',
            regularPaymentAmount: 0,
            regularPaymentFrequency: 'fortnightly',
            establishmentFees: 0,
            useForRad: false
        });
        setHeasDetails(inputs.heasDetails || {
            paymentAmount: 0,
            paymentFrequency: 'fortnightly',
            interestRate: 3.95
        });
        setScenarioLivingExpenses((0, $1b5ad53cec30af73$export$df3d7258e77c9184)(inputs.scenarioLivingExpenses, factFind.expenses?.livingExpenses));
        // Restore Other Strategies
        setOtherStrategies(inputs.otherStrategies || {
            gifting: false,
            giftingAmount: 0,
            giftingSource: 'bankAccounts',
            funeralBonds: false,
            funeralBondAmount: 0,
            funeralBondSource: 'bankAccounts',
            annuity: false
        });
        setAnnuityRecord(inputs.annuityRecord || null);
        if (inputs.otherStrategies?.annuity || inputs.annuityRecord) setShowOtherStrategies(true); // Expand if strategy was saved
        // Ensure Manual Control is active
        setStrategyModeChosen(true);
        setStrategyMode('manual');
        setShowStrategyOptions(true);
        setActiveSavedStrategyId(strategy.id);
        setStep(3);
    };
    /**
     * LEAVING A RETIREMENT VILLAGE (owner, 7 Oct 2026). The entering person lives in a village and the
     * unit is sold back on leaving (a single resident's always; a couple's where both go, or the
     * profile says so). The village pays the exit entitlement — the entry contribution less the
     * departure fee, reinstatement and the operator's share of any gain — on the state's timeline,
     * MONTHS after the move. So: the interest counts as their home until the refund; the part of the
     * room the village money will pay is charged daily until it arrives; and from the refund the
     * person is a non-homeowner with cash. The projection does all of it (villageExitPlugin).
     */ const villagePerson = moverPerson;
    const villageSells = !isMover && (0, $4633117ee929ec27$export$21c4a7ba859ac116)($39641e97aa80005f$var$asFactFind(factFind), villagePerson, bothEntering);
    const villageLeaveDate = (0, $b8d3cfe4c156722e$export$dcba8ccb2c57a554)(careStartDate) ? careStartDate : (0, $b8d3cfe4c156722e$export$cea9846d43ecc40e)();
    const villageExit = (0, $acw62.useMemo)(()=>villageSells ? (0, $4633117ee929ec27$export$3da79be84c8bf9e7)($39641e97aa80005f$var$asFactFind(factFind), villageLeaveDate) : null, [
        villageSells,
        factFind,
        villageLeaveDate
    ]);
    /**
     * WHEN THE UNIT IS PAID OUT (owner, 8 Oct 2026, for consistency with the village and granny flat
     * modules): "later", on the state's timeline, is the default here — in a care move the home
     * charges the daily payment from day one, so the conservative case is the one to show unless the
     * adviser knows the sale is settled. "At the move" pays the entitlement on the entry day: no
     * wait, no fees after leaving, and the interest is sold from entry.
     */ const [villagePaidAtMove, setVillagePaidAtMove] = (0, $acw62.useState)(false);
    const villageRefundDate = villageExit ? villagePaidAtMove ? villageLeaveDate : villageExit.refundDate : villageLeaveDate;
    const villageAtMoveOptions = (0, $acw62.useMemo)(()=>villagePaidAtMove && villageExit ? {
            villageInterestSold: true
        } : {}, [
        villagePaidAtMove,
        villageExit
    ]);
    /** The funding card's choice: the village money tops the room up when it arrives (on by default). */ const [useVillageRefundForRoom, setUseVillageRefundForRoom] = (0, $acw62.useState)(true);
    const villageFacts = (0, $acw62.useMemo)(()=>villageExit ? {
            name: (villagePerson === 'partner' ? factFind.partner?.firstName : factFind.client?.firstName) || 'the client',
            ...villageExit,
            refundDate: villageRefundDate
        } : null, [
        villageExit,
        villagePerson,
        factFind.client?.firstName,
        factFind.partner?.firstName,
        villageRefundDate
    ]);
    const radPaidBreakdown = (0, $acw62.useMemo)(()=>{
        const { netTotal: fromLiquidAssets } = (0, $bd80071df75c742b$export$e98193fa2b9f521b)(factFind, radFunding, cgtOverrides);
        // GATED ON THE STRATEGY TOGGLES. These allocations survive in state when a strategy is
        // switched off (so flipping it back on restores the sliders), but money from a strategy
        // that is OFF is not being paid: before this gate, a downsize test left its $700k
        // radAllocation counting as "paid" after the toggle was off - the rail showed DAP $0 on a
        // room nothing was funding, while the financials (which do gate on the toggles) told the
        // other story (owner-caught, 2026-08-24). simulatedFactFind gates the same way.
        const fromDownsize = overallStrategy.downsizeHome ? parseFloat(String(downsizeDetails.radAllocation)) || 0 : 0;
        const fromInvestmentProperty = overallStrategy.sellInvestmentProperty ? investmentPropertyDetails.radAllocation || 0 : 0;
        const fromReverseMortgage = overallStrategy.reverseMortgage && reverseMortgageDetails.useForRad && reverseMortgageDetails.loanStructure === 'lump_sum' ? parseFloat(String(reverseMortgageDetails.loanAmount)) || 0 : 0;
        // A change of home: the refund of the current deposit goes to the new room before anything is sold.
        const fromRefund = isMover ? moverDeposit.balance : 0;
        const fromOther = fromDownsize + fromInvestmentProperty + fromReverseMortgage + fromRefund;
        // Leaving a village: the exit payment tops the room up when it arrives — only what savings and
        // the strategies leave unpaid, and only up to what the village pays. Nothing of it at entry.
        const fromVillage = villageExit && useVillageRefundForRoom ? Math.max(0, Math.min(villageExit.entitlement, radInput - fromLiquidAssets - fromOther)) : 0;
        return {
            fromLiquidAssets: fromLiquidAssets,
            fromRefund: fromRefund,
            fromVillage: fromVillage,
            fromStrategies: fromOther + fromVillage,
            total: fromLiquidAssets + fromOther + fromVillage
        };
    }, [
        factFind,
        radFunding,
        cgtOverrides,
        downsizeDetails.radAllocation,
        investmentPropertyDetails.radAllocation,
        overallStrategy.downsizeHome,
        overallStrategy.sellInvestmentProperty,
        overallStrategy.reverseMortgage,
        reverseMortgageDetails,
        isMover,
        moverDeposit.balance,
        villageExit,
        useVillageRefundForRoom,
        radInput
    ]);
    const radPaid = radPaidBreakdown.total;
    /** The deposit paid AT ENTRY: the village's part arrives later (unless paid at the move), and the means are assessed on this. */ const radPaidAtEntry = radPaid - (villagePaidAtMove ? 0 : radPaidBreakdown.fromVillage);
    /** What the wait for the village money costs: the daily payment on its share of the room until it arrives. */ const villageInterim = (0, $acw62.useMemo)(()=>villageExit ? (0, $4633117ee929ec27$export$4248c5b777a2c251)(radPaidBreakdown.fromVillage, villageLeaveDate, villageRefundDate, (0, $815d7df20c36742b$export$36c4ec5f3f340aef).MPIR) : null, [
        villageExit,
        radPaidBreakdown.fromVillage,
        villageLeaveDate,
        villageRefundDate
    ]);
    /** The old unit's fees after leaving, on the state's rule, for the days of the wait (8 Oct 2026). */ const villageFees = (0, $acw62.useMemo)(()=>villageExit ? (0, $4633117ee929ec27$export$de22c25de5484f31)(factFind.retirementVillage, villageLeaveDate, villageRefundDate) : null, [
        villageExit,
        factFind.retirementVillage,
        villageLeaveDate,
        villageRefundDate
    ]);
    /** The projection's plan for the village: leave, be paid, put this much to the room, pay the fees after leaving. */ const villageExitPlan = (0, $acw62.useMemo)(()=>villageExit ? {
            person: villagePerson,
            leaveDate: villageLeaveDate,
            refundDate: villageRefundDate,
            entitlement: villageExit.entitlement,
            radAllocation: radPaidBreakdown.fromVillage,
            interimDailyPayment: villageInterim?.perDay ?? 0,
            ...villageFees && villageFees.total > 0 ? {
                feesAfterLeaving: villageFees
            } : {}
        } : null, [
        villageExit,
        villagePerson,
        villageLeaveDate,
        villageRefundDate,
        radPaidBreakdown.fromVillage,
        villageInterim,
        villageFees
    ]);
    /**
     * The second room pays the SAME SHARE up front as the first (owner, 7 Oct 2026: "the clients
     * don't know what they should be paying"): one decision on the funding card covers both rooms,
     * exactly as every Suggestion Engine candidate does. Funded from what the first deposit leaves.
     */ const secondRadTarget = secondRoomActive && radInput > 0 ? Math.round(secondRoom.roomPrice * Math.min(1, radPaid / radInput)) : 0;
    const secondFunding = (0, $acw62.useMemo)(()=>secondRoomActive ? (0, $0e15302c37df0d54$export$b097a93d3ede847)($39641e97aa80005f$var$asFactFind(factFind), secondRadTarget, radFunding) : null, [
        secondRoomActive,
        factFind,
        secondRadTarget,
        radFunding
    ]);
    /*
     * When a strategy above (downsize / property sale / borrowing) already covers the whole room
     * price and nothing is drawn from savings, the funding sliders are pure noise: every control in
     * the section would rightly sit at zero. Collapse it to one line saying WHY it is quiet, with an
     * explicit way back in — never remove a section silently (owner direction, 2026-08-24).
     */ const roomCoveredByStrategies = radInput > 0 && radPaidBreakdown.fromLiquidAssets === 0 && radPaidBreakdown.fromStrategies >= radInput - 0.5;
    /**
     * Is anything actually being SOLD to fund the deposit?
     *
     * Gates the sale-date control below, which otherwise appeared the moment a care date was entered —
     * asking when the assets would be sold of clients who had allocated nothing to a lump sum at all,
     * and were simply paying the daily fee. That reads as the tool having decided something will be
     * sold, which is not a small thing to imply to someone deciding how to fund their parent's care.
     *
     * Cash is not sold: money already in a bank account is paid across on the day, so there is no sale
     * date to nominate and nothing the timing could change. A share parcel, an investment property or
     * the family home is a disposal — the proceeds sit in the bank until the deposit is paid (deemed,
     * and counted in the assets test) and the CGT falls on the day of sale. That is what the control is
     * for, and it is only worth showing to the people it can actually help.
     *
     * A reverse mortgage is drawn, not sold, so it is not counted here either.
     */ const radFundedBySellingAssets = (0, $acw62.useMemo)(()=>(0, $bd80071df75c742b$export$c125a47c6f30fb0d)(radFunding, {
            home: overallStrategy.downsizeHome ? downsizeDetails.radAllocation : 0,
            investmentProperty: overallStrategy.sellInvestmentProperty ? investmentPropertyDetails.radAllocation : 0
        }), [
        radFunding,
        downsizeDetails.radAllocation,
        investmentPropertyDetails.radAllocation,
        overallStrategy.downsizeHome,
        overallStrategy.sellInvestmentProperty
    ]);
    // A sale date must not survive the sale it belonged to. Switch the funding to cash and the control
    // above disappears — but the date would keep feeding the engine, deferring a sale that no longer
    // exists, with nothing on screen to show for it. Same rule already applied when the care date is
    // cleared; this is the other way the control can vanish.
    (0, $acw62.useEffect)(()=>{
        if (!radFundedBySellingAssets && radFundingDate) setRadFundingDate('');
    }, [
        radFundedBySellingAssets,
        radFundingDate
    ]);
    /**
     * The optional "sell before care starts?" control, rendered inside the RAD Funding card beneath
     * its totals — see RadFundingStrategy's `saleTimingSlot`. It is a consequence of the funding
     * plan, so it belongs where that plan is made rather than beside the care date it depends on.
     *
     * "The assets are sold when care starts" is a statement of what the model does, and was not always
     * one: until `effectiveRadFundingDate` existed it described behaviour the app only performed if you
     * ALSO filled in the date below, and the sentence appeared solely in the case where it was false.
     * The sentence was made true rather than softened to fit — see `effectiveRadFundingDate`.
     */ const saleTimingSlot = careStartDate && radFundedBySellingAssets ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "space-y-2",
        children: !showRadFundingDate && !radFundingDate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            className: "text-sm text-slate-600",
            children: [
                "The assets are sold when care starts.",
                ' ',
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: ()=>setShowRadFundingDate(true),
                    className: "text-blue-600 hover:text-blue-800 underline font-medium",
                    children: "Sell earlier instead"
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    htmlFor: "rad-funding-date",
                    className: "block text-sm font-medium text-gray-700 mb-1",
                    children: [
                        "Sell the assets before care starts?",
                        ' ',
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($39641e97aa80005f$var$WhatsThis, {
                            text: "Optional. Leave blank to sell on the day care starts, which is what most people do. Choosing an earlier date models selling ahead of the move: the proceeds sit in the bank until the deposit is paid, where they are deemed and counted in the assets test, which can reduce the Age Pension in the meantime. Capital gains tax is calculated on the sale date, so holding an asset past twelve months to qualify for the CGT discount shows up here."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "date",
                    id: "rad-funding-date",
                    name: "radFundingDate",
                    min: $39641e97aa80005f$var$toDateValue(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1)),
                    max: careStartDate,
                    ...radFundingDateField,
                    className: "w-full px-3 py-2 border border-gray-300 rounded-lg"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-xs text-slate-500",
                    children: radFundingDate ? 'Assets are sold on this date and the proceeds held in the bank until the deposit is paid on entry.' : "Leave blank and they'll be sold on the day care starts \u2014 no need to guess how long a sale takes."
                })
            ]
        })
    }) : null;
    const [initialFinancials, setInitialFinancials] = (0, $acw62.useState)({
        netWorth: 0,
        cashFlow: 0
    });
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind).then((r)=>{
            if (!cancelled) setInitialFinancials(r);
        }).catch((0, $85051d5377ce5db4$export$890bc823b29958a8)('the position today'));
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind
    ]);
    // Single source of truth: annuity is funded from (home) sale proceeds so we don't double-count in projections.
    const isAnnuityFundedFromSaleProceeds = (record)=>{
        if (!record?.purchaseAmount) return false;
        const fs = record.fundingSource;
        if (fs == null) return false;
        if (typeof fs === 'string') return String(fs).toLowerCase().includes('downsize-proceeds');
        if (typeof fs === 'object') {
            const id = fs.id != null && String(fs.id) || '';
            const assetId = fs.assetId != null && String(fs.assetId) || '';
            const label = fs.label != null && String(fs.label).toLowerCase() || '';
            if (id === 'bankAccounts-downsize-proceeds' || assetId === 'downsize-proceeds') return true;
            if (label.includes('unallocated sale') || label.includes('sale proceeds')) return true;
        }
        return false;
    };
    /**
    * The debt payoff as the engine takes it, or null when nothing is allocated.
    *
    * Null rather than an empty bag so every consumer can test it with a single truthiness check, and so
    * a client with no debt sends no `debtPayoff` at all rather than an empty one the engine would have
    * to recognise as a no-op.
    */ const debtPayoffPlan = (0, $acw62.useMemo)(()=>{
        const payments = Object.fromEntries(Object.entries(debtPayments).filter(([, amount])=>(Number(amount) || 0) > 0));
        if (Object.keys(payments).length === 0) return null;
        const funding = Object.fromEntries(Object.entries(debtFunding).filter(([, amount])=>(Number(amount) || 0) > 0));
        return {
            payments: payments,
            funding: funding,
            repaymentBasis: debtRepaymentBasis
        };
    }, [
        debtPayments,
        debtFunding,
        debtRepaymentBasis
    ]);
    /**
    * What each card has claimed of each asset, for the OTHER card's ceiling.
    *
    * This is the whole shared-pool mechanism: neither slider can be moved past what its sibling has
    * left, so the same dollar cannot fund a deposit and retire a debt. Doing it here, in the one place
    * that holds both bags, is what stops the two cards needing to know about each other.
    */ const reservedForRad = (0, $acw62.useMemo)(()=>Object.fromEntries(Object.entries(radFunding).map(([key, amount])=>[
                key,
                Number(amount) || 0
            ])), [
        radFunding
    ]);
    const reservedForDebt = (0, $acw62.useMemo)(()=>Object.fromEntries(Object.entries(debtFunding).map(([key, amount])=>[
                key,
                Number(amount) || 0
            ])), [
        debtFunding
    ]);
    const simulatedResult = (0, $acw62.useMemo)(()=>(0, $9c5c211308401e85$export$4a20ccd66ad56fc)(factFind, {
            scenarioLivingExpenses: scenarioLivingExpenses,
            overallStrategy: overallStrategy,
            downsizeDetails: downsizeDetails,
            investmentPropertyDetails: investmentPropertyDetails,
            reverseMortgageDetails: reverseMortgageDetails,
            otherStrategies: otherStrategies,
            annuityRecord: annuityRecord,
            radFunding: radFunding,
            cgtOverrides: cgtOverrides,
            debtPayoffPlan: debtPayoffPlan,
            ...secondFunding ? {
                secondRadFunding: secondFunding.radFunding
            } : {},
            ...existingStay ? {
                existingStay: {
                    person: moverPerson,
                    refundToday: moverDeposit.balance,
                    retentionDaysTaken: moverDeposit.retentionDaysTaken,
                    grandfathered: moverGrandfathered
                }
            } : {},
            deferToEngine: radLiquidationDeferredToEngine
        }), [
        factFind,
        radFunding,
        radFundingDate,
        careStartDate,
        cgtOverrides,
        overallStrategy,
        strategyInputs,
        downsizeDetails,
        scenarioLivingExpenses,
        reverseMortgageDetails,
        otherStrategies,
        annuityRecord,
        investmentPropertyDetails,
        debtPayoffPlan,
        secondFunding,
        existingStay,
        moverPerson,
        moverDeposit,
        moverGrandfathered
    ]);
    const simulatedFactFind = simulatedResult.data;
    /** What this annuity has already drawn from each liquid asset — offered back by the funding picker. */ const annuityDrawnFrom = simulatedResult.annuityDrawnFrom;
    /**
     * The position the Financial Impact panel describes, which is NOT the engine's opening position.
     *
     * The panel shows a normalised year — "what a full year looks like once this plan is in place", in
     * its own words — so once the plan is in place the debt is gone, whenever the payoff is dated.
     * `simulatedFactFind` deliberately leaves a dated payoff to the engine (doing both would sell the
     * funding assets twice and clear the debt twice), which is right for a PROJECTION and wrong for
     * this panel: it left an adviser clearing a $50,000 loan and watching every figure sit still.
     *
     * So the panel gets its own copy with the payoff applied. Only ever the payoff, and only when the
     * simulation skipped it — this is not a second place where strategies are assembled.
     */ /**
     * The no-plan baseline every figure on this page is measured against — "enters care, pays the
     * full DAP, makes no strategic decisions" (owner direction, 2026-08-26).
     *
     * Aged care is a requirement, not a choice, so comparing strategies with life at home credits
     * every recommendation with the care event itself. See agedCareBaseline.ts for the two bases and
     * for the two ways this is easy to get silently wrong.
     */ /*
     * WORKING IT OUT (25 Oct 2026). The rail's figures arrive from a chain of calculations; while any is in flight the
     * rail says so instead of mixing new figures with old ones (utils/calcTracker.ts). Two counts: the benchmark, and
     * the plan built by hand — the walk-in rail waits only for the first.
     */ const { track: trackBaseline, working: baselineWorking } = (0, $a8ad6b8c257d1221$export$66e981b52ef0ad9f)();
    const { track: trackPlan, working: planWorking } = (0, $a8ad6b8c257d1221$export$66e981b52ef0ad9f)();
    // The two the Suggestion Engine's run reads (the position, then the fees struck on it): it waits for
    // them to settle, so a plan opening runs the analysis once, not once per step (26 Oct 2026).
    const { track: trackEngineInputs, working: engineInputsWorking } = (0, $a8ad6b8c257d1221$export$66e981b52ef0ad9f)(600);
    const [liveAgedCareBaseline, setAgedCareBaseline] = (0, $acw62.useState)((0, $12e551cf654c2507$export$db879e1f4069b800));
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        trackBaseline((0, $12e551cf654c2507$export$ee1360f3529a7951)({
            factFind: factFind,
            radInput: radInput,
            legacyYears: localLegacyYears,
            scenarioLivingExpenses: scenarioLivingExpenses,
            careStartDate: careStartDate,
            runwayYears: $39641e97aa80005f$var$RUNWAY_HORIZON_YEARS,
            ...secondRoomActive ? {
                secondRoom: {
                    person: secondPerson,
                    roomPrice: secondRoom.roomPrice,
                    careStartDate: secondRoom.careStartDate || undefined,
                    entersLater: secondEntersLater,
                    ...livingOnceBoth != null ? {
                        livingExpensesOnceBoth: livingOnceBoth
                    } : {}
                }
            } : {},
            ...existingStay ? {
                existingStay: {
                    person: existingStay.person,
                    roomPrice: existingStay.roomPrice,
                    refundToday: existingStay.refundToday,
                    dailyPayment: existingStay.dailyPayment
                }
            } : {},
            // Leaving a village with no plan: the exit payment is banked when it arrives.
            ...villageExit ? {
                villageExit: {
                    person: villagePerson,
                    leaveDate: villageLeaveDate,
                    refundDate: villageRefundDate,
                    entitlement: villageExit.entitlement,
                    ...villagePaidAtMove ? {
                        paidAtMove: true
                    } : {},
                    ...villageFees && villageFees.total > 0 ? {
                        feesAfterLeaving: villageFees
                    } : {}
                }
            } : {}
        })).then((baseline)=>{
            if (!cancelled) setAgedCareBaseline(baseline);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind,
        radInput,
        localLegacyYears,
        scenarioLivingExpenses,
        careStartDate,
        secondRoomActive,
        secondPerson,
        secondRoom.roomPrice,
        secondRoom.careStartDate,
        secondEntersLater,
        livingOnceBoth,
        existingStay,
        villageExit,
        villagePerson,
        villageLeaveDate,
        villageFees,
        villageRefundDate,
        villagePaidAtMove
    ]);
    /*
     * ONE BENCHMARK WHILE THE ENGINE'S CARDS ARE ON SCREEN (owner-caught, 9 Oct 2026). The engine's
     * "Do Nothing" row and the walk-in baseline above are the same run by definition — same room,
     * same dates, same village payout, same horizon — and in every reproduction they agree to the
     * dollar. On the owner's screen they did not: a card read "$82,080 behind" a walk-in estate its
     * own run never produced, and the rail quoted that figure beside the cards. Whatever state the
     * browser was in, the cards must be measured against the no-plan row of THEIR run, and the rail
     * must show that same row. So, in engine mode, while the engine's row describes the inputs on
     * screen (room, entry date, village payout, horizon), it IS the baseline: its financials, its
     * first-year pension and cashflow, its projection and its estate. The live baseline carries on
     * underneath (the runway, the second stage, today's position) and takes over the moment any
     * input moves away from what the engine ran. A disagreement is logged so it can be found.
     */ const [engineDoNothingRow, setEngineDoNothingRow] = (0, $acw62.useState)(null);
    const agedCareBaseline = (0, $acw62.useMemo)(()=>{
        const row = engineDoNothingRow;
        if (strategyMode !== 'optimised' || !row || !liveAgedCareBaseline.financials) return liveAgedCareBaseline;
        // The second room and a change of home have their own stages; the live baseline carries those.
        if (secondRoomActive || existingStay) return liveAgedCareBaseline;
        const sameRoom = Math.round(Number(row.radRoomPrice) || 0) === Math.round(Number(radInput) || 0);
        const rowDate = typeof row.strategyOptions?.careStartDate === 'string' ? row.strategyOptions.careStartDate : '';
        const sameDate = rowDate === ((0, $b8d3cfe4c156722e$export$dcba8ccb2c57a554)(careStartDate) ? careStartDate : '');
        const rowVillage = row.villageExit || null;
        const sameVillage = villageExit ? !!rowVillage && rowVillage.refundDate === villageRefundDate && !!rowVillage.paidAtMove === villagePaidAtMove : !rowVillage;
        const rows = Array.isArray(row.projections) ? row.projections : [];
        const sameHorizon = rows.length === localLegacyYears;
        if (!sameRoom || !sameDate || !sameVillage || !sameHorizon || !row.strategyFinancials || !row.strategySpecificAgedCareCosts) return liveAgedCareBaseline;
        const legacy = Number(row.snapshot?.legacyValue);
        if (Number.isFinite(legacy) && liveAgedCareBaseline.legacyValue != null && Math.abs(legacy - liveAgedCareBaseline.legacyValue) > 1) console.warn('[AgedCareAnalyser] the walk-in baseline and the engine\'s "Do Nothing" row disagree', {
            live: liveAgedCareBaseline.legacyValue,
            engine: legacy
        });
        return {
            ...liveAgedCareBaseline,
            financials: row.strategyFinancials,
            pension: Number(row.snapshot?.pension) || 0,
            cashFlowAfterCare: Number(row.snapshot?.netCashflow) || 0,
            legacyValue: Number.isFinite(legacy) ? legacy : liveAgedCareBaseline.legacyValue,
            projections: rows,
            agedCareCosts: row.strategySpecificAgedCareCosts
        };
    }, [
        strategyMode,
        engineDoNothingRow,
        liveAgedCareBaseline,
        secondRoomActive,
        existingStay,
        radInput,
        careStartDate,
        villageExit,
        villageRefundDate,
        villagePaidAtMove,
        localLegacyYears
    ]);
    const factFindForImpactPanel = (0, $acw62.useMemo)(()=>{
        let ff = simulatedFactFind;
        // A change of home: the panel's "after" is after the move — the refund back, the nominated
        // assets sold, the new deposit paid (the projection does it on the move day).
        if (isMover) ff = (0, $7902ca900a473358$export$f0b7a61c305d05db)($39641e97aa80005f$var$asFactFind(ff), {
            person: moverPerson,
            refundToday: moverDeposit.balance,
            radTarget: radPaid,
            radFunding: radFunding,
            cgtOverrides: cgtOverrides
        }).factFind;
        if (!debtPayoffPlan || !radLiquidationDeferredToEngine) return ff;
        return (0, $5a6326d9013f181c$export$525e306199c9748e)(ff, debtPayoffPlan, cgtOverrides).factFind;
    }, [
        simulatedFactFind,
        debtPayoffPlan,
        radLiquidationDeferredToEngine,
        cgtOverrides,
        isMover,
        moverPerson,
        moverDeposit.balance,
        radPaid,
        radFunding
    ]);
    // Perform calculations based on factFind and local state
    const [simulatedFinancials, setSimulatedFinancials] = (0, $acw62.useState)({
        netWorth: 0,
        cashFlow: 0
    });
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        const modellerResidency = (0, $8eecd0af141b9afb$export$5f0bb1b091776594)($39641e97aa80005f$var$asFactFind(factFind));
        // The FIRST stage where the second person enters later: the other still at home.
        trackPlan(trackEngineInputs($55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFindForImpactPanel, {
            ...overallStrategy,
            ...strategyInputs,
            ...secondEntersLater ? {
                ...modellerResidency,
                [secondKey]: secondRecorded
            } : modellerResidency,
            ...villageAtMoveOptions,
            downsizeDetails: downsizeDetails,
            radFunding: radFunding,
            cgtOverrides: cgtOverrides,
            radInput: radInput,
            reverseMortgageDetails: overallStrategy.reverseMortgage ? reverseMortgageDetails : null,
            heasDetails: overallStrategy.heas ? heasDetails : null
        }))).then((baseFinancials)=>{
            if (!cancelled) setSimulatedFinancials(baseFinancials);
        }).catch((0, $85051d5377ce5db4$export$890bc823b29958a8)('the position under this plan'));
        return ()=>{
            cancelled = true;
        };
    // Investment property sale: CGT is in net proceeds pool (Option A) — no separate cashflow line.
    }, [
        villageAtMoveOptions,
        factFindForImpactPanel,
        overallStrategy,
        strategyInputs,
        downsizeDetails,
        radFunding,
        cgtOverrides,
        reverseMortgageDetails,
        heasDetails,
        otherStrategies,
        annuityRecord,
        factFind,
        factFind.adviceFor,
        factFind.goals,
        investmentPropertyDetails,
        secondEntersLater,
        secondKey,
        secondRecorded
    ]);
    const [agedCareCosts, setAgedCareCosts] = (0, $acw62.useState)({});
    /** The second room's schedule, where both are entering care; null otherwise. */ const [secondAgedCareCosts, setSecondAgedCareCosts] = (0, $acw62.useState)(null);
    /** The second stage, where the second person enters later: the household once both are in care, and the first room's schedule then. */ const [phaseTwo, setPhaseTwo] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        const modellerResidency = (0, $8eecd0af141b9afb$export$5f0bb1b091776594)($39641e97aa80005f$var$asFactFind(factFind));
        const secondRadPaid = secondFunding?.funded ?? 0;
        // Where the second person enters later, `simulatedFinancials` is the FIRST stage (the other
        // still at home: the home exempt, the pension illness-separated) and the first room's
        // schedule is struck on it. The second room, and the first room once both are in care, are
        // struck on the household as it stands then (carePhases.ts).
        const firstOverrides = {
            ...secondEntersLater ? {
                ...modellerResidency,
                [secondKey]: secondRecorded
            } : modellerResidency,
            ...villageAtMoveOptions
        };
        const planOpts = {
            ...overallStrategy,
            ...strategyInputs,
            downsizeDetails: downsizeDetails,
            radFunding: radFunding,
            cgtOverrides: cgtOverrides,
            radInput: radInput,
            reverseMortgageDetails: overallStrategy.reverseMortgage ? reverseMortgageDetails : null,
            heasDetails: overallStrategy.heas ? heasDetails : null
        };
        trackPlan(trackEngineInputs($55a1d8a64f1e5dfa$export$fb677777baef0897({
            factFind: factFind,
            financials: simulatedFinancials,
            radInput: radInput,
            radPaid: radPaid,
            // The means are assessed on the deposit paid at entry: the village's part is still the
            // village interest then (held, and assessed as it is) — not cash paid twice.
            radPaidHousehold: radPaidAtEntry + (secondRoomActive && !secondEntersLater ? secondRadPaid : 0),
            overallStrategy: {
                ...overallStrategy,
                ...firstOverrides
            },
            extraServiceFeeInput: extraServiceFeeInput,
            formatCurrency: true,
            ...secondRoomActive ? {
                resident: leadPerson
            } : {}
        }))).then((costs)=>{
            if (!cancelled) setAgedCareCosts({
                ...costs,
                scenarioLivingExpenses: scenarioLivingExpenses
            });
        }).catch((0, $85051d5377ce5db4$export$890bc823b29958a8)('the fees for the first room'));
        if (secondRoomActive) {
            const financialsBoth = secondEntersLater ? $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFindForImpactPanel, {
                ...planOpts,
                ...modellerResidency,
                ...livingOnceBoth != null ? {
                    scenarioLivingExpenses: livingOnceBoth
                } : {}
            }) : Promise.resolve(simulatedFinancials);
            trackPlan(financialsBoth.then((both)=>Promise.all([
                    $55a1d8a64f1e5dfa$export$fb677777baef0897({
                        factFind: factFind,
                        financials: both,
                        radInput: secondRoom.roomPrice,
                        radPaid: secondRadPaid,
                        radPaidHousehold: radPaid + secondRadPaid,
                        overallStrategy: {
                            ...overallStrategy,
                            ...modellerResidency
                        },
                        extraServiceFeeInput: secondRoom.extraServiceAnnual,
                        formatCurrency: true,
                        resident: secondPerson
                    }),
                    secondEntersLater ? $55a1d8a64f1e5dfa$export$fb677777baef0897({
                        factFind: factFind,
                        financials: both,
                        radInput: radInput,
                        radPaid: radPaid,
                        radPaidHousehold: radPaid + secondRadPaid,
                        overallStrategy: {
                            ...overallStrategy,
                            ...modellerResidency
                        },
                        extraServiceFeeInput: extraServiceFeeInput,
                        formatCurrency: true,
                        resident: leadPerson
                    }) : Promise.resolve(null)
                ]).then(([second, firstOnceBoth])=>{
                    if (cancelled) return;
                    setSecondAgedCareCosts(second);
                    setPhaseTwo(firstOnceBoth ? {
                        financials: both,
                        firstCosts: firstOnceBoth
                    } : null);
                }))).catch((0, $85051d5377ce5db4$export$890bc823b29958a8)('the fees for the second room'));
        } else {
            setSecondAgedCareCosts(null);
            setPhaseTwo(null);
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        villageAtMoveOptions,
        radPaidAtEntry,
        simulatedFinancials,
        factFindForImpactPanel,
        radInput,
        extraServiceFeeInput,
        radPaid,
        factFind,
        factFind.goals,
        overallStrategy,
        strategyInputs,
        downsizeDetails,
        radFunding,
        cgtOverrides,
        reverseMortgageDetails,
        heasDetails,
        scenarioLivingExpenses,
        secondRoomActive,
        secondRoom.roomPrice,
        secondRoom.extraServiceAnnual,
        secondFunding,
        secondEntersLater,
        leadPerson,
        secondKey,
        secondRecorded,
        livingOnceBoth
    ]);
    /**
     * What the household pays for care — both rooms where both are in care. The engine keeps each
     * room's schedule apart (the projection runs them side by side); every figure a reader sees as
     * "what care costs" adds them here, and nowhere else (householdCareCosts.ts).
     */ const householdAgedCareCosts = (0, $acw62.useMemo)(()=>(0, $bdfd96a4f4ac117d$export$89e252d57ea6f30b)(agedCareCosts, secondRoomActive && !secondEntersLater ? secondAgedCareCosts : null), [
        agedCareCosts,
        secondRoomActive,
        secondEntersLater,
        secondAgedCareCosts
    ]);
    /** The plan's second stage, where the second person enters later: both rooms from then. */ const phaseTwoHousehold = (0, $acw62.useMemo)(()=>secondEntersLater && phaseTwo ? (0, $bdfd96a4f4ac117d$export$89e252d57ea6f30b)(phaseTwo.firstCosts, secondAgedCareCosts) : null, [
        secondEntersLater,
        phaseTwo,
        secondAgedCareCosts
    ]);
    /** The no-plan second room IN THE FIRST YEAR, for the baseline's own totals: none where it enters later. */ const baselineSecondCosts = secondRoomActive && !secondEntersLater ? agedCareBaseline.secondAgedCareCosts ?? secondAgedCareCosts : null;
    /** Staying put: the current home's schedule, with the daily payment the resident actually pays (a mover's baseline, and the run's opening schedule). */ const [stayPutCosts, setStayPutCosts] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!existingStay) {
            setStayPutCosts(null);
            return;
        }
        let cancelled = false;
        const modellerResidency = (0, $8eecd0af141b9afb$export$5f0bb1b091776594)($39641e97aa80005f$var$asFactFind(factFind));
        $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind, {
            ...modellerResidency,
            scenarioLivingExpenses: scenarioLivingExpenses
        }).then((fin)=>$55a1d8a64f1e5dfa$export$fb677777baef0897({
                factFind: factFind,
                financials: fin,
                radInput: existingStay.roomPrice,
                radPaid: existingStay.refundToday,
                overallStrategy: {
                    ...modellerResidency
                },
                extraServiceFeeInput: 0,
                formatCurrency: true,
                resident: existingStay.person
            })).then((costs)=>{
            if (!cancelled) setStayPutCosts((0, $bdfd96a4f4ac117d$export$98225c4faadd11c0)({
                ...costs,
                scenarioLivingExpenses: scenarioLivingExpenses
            }, existingStay.dailyPayment));
        }).catch((0, $85051d5377ce5db4$export$890bc823b29958a8)('the stay-put fees'));
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind,
        existingStay,
        scenarioLivingExpenses
    ]);
    /** The schedule the projection OPENS on: the current home for a mover (the move swaps it), the plan's room otherwise. */ const runSchedule = isMover && stayPutCosts ? stayPutCosts : agedCareCosts;
    /** What the projection is told about the second resident — null unless both are entering. */ const secondResidentPlan = (0, $acw62.useMemo)(()=>secondRoomActive && secondAgedCareCosts && secondFunding ? {
            person: secondPerson,
            ...secondRoom.careStartDate ? {
                careStartDate: secondRoom.careStartDate
            } : {},
            radFunding: secondFunding.radFunding,
            agedCareCosts: secondAgedCareCosts,
            ...livingOnceBoth != null ? {
                livingExpensesOnceBoth: livingOnceBoth
            } : {}
        } : null, [
        secondRoomActive,
        secondAgedCareCosts,
        secondFunding,
        secondRoom.careStartDate,
        secondPerson,
        livingOnceBoth
    ]);
    // Update parent strategyOptions when local state changes
    (0, $acw62.useEffect)(()=>{
        const updatedStrategyOptions = {
            ...overallStrategy,
            ...strategyInputs,
            ...(0, $8eecd0af141b9afb$export$5f0bb1b091776594)($39641e97aa80005f$var$asFactFind(factFind)),
            downsizeDetails: downsizeDetails,
            scenarioLivingExpenses: scenarioLivingExpenses,
            radFunding: radFunding,
            cgtOverrides: cgtOverrides,
            radInput: radInput,
            extraServiceFeeInput: extraServiceFeeInput,
            // Surfaced so consumers of the parent strategyOptions (e.g. the SOA) see the same entry date
            // the projections ran with. No anchor override goes with it: the projection starts today.
            ...careStartDate ? {
                careStartDate: careStartDate
            } : {},
            radDrawdown: // The deposit arrangement travels the same way: the Suggestion Engine reads it off these
            // options so its candidates draw on the deposit under the same agreement the manual plan does.
            radDrawdown,
            // The fee arrangements travel the same way, so the Suggestion Engine prices its candidates
            // on the rules the manual plan is on (and can show what opting in would be worth).
            ...residentialFeeArrangements ? {
                residentialFeeArrangements: residentialFeeArrangements
            } : {},
            // The second room, likewise: the Suggestion Engine prices it in every candidate.
            ...secondRoomActive ? {
                secondRoom: {
                    person: secondPerson,
                    roomPrice: secondRoom.roomPrice,
                    ...secondRoom.careStartDate ? {
                        careStartDate: secondRoom.careStartDate
                    } : {},
                    extraServiceAnnual: secondRoom.extraServiceAnnual
                }
            } : {},
            ...secondResidentPlan ? {
                secondResident: secondResidentPlan
            } : {}
        };
        setStrategyOptions(updatedStrategyOptions);
    }, [
        overallStrategy,
        strategyInputs,
        downsizeDetails,
        scenarioLivingExpenses,
        radFunding,
        cgtOverrides,
        radInput,
        extraServiceFeeInput,
        careStartDate,
        radDrawdown,
        residentialFeeArrangements,
        factFind,
        setStrategyOptions,
        secondRoomActive,
        secondRoom,
        secondResidentPlan
    ]);
    // Investment property sale: estimated CGT and net proceeds for insight panel (matches InvestmentPropertyStrategyAllocator / Section 11)
    const investmentPropertySaleSummary = (0, $acw62.useMemo)(()=>{
        if (!overallStrategy.sellInvestmentProperty || !investmentPropertyDetails) return null;
        const summary = (0, $a764bc0f6f904854$export$777cdddf3f231419)($39641e97aa80005f$var$asFactFind(factFind), investmentPropertyDetails);
        if (!summary) return null;
        const { estimatedCGT: estimatedCGT, netProceeds: netProceeds, salePrice: salePrice, sellingCosts: sellingCosts, isPreCGT: isPreCGT } = summary;
        return {
            estimatedCGT: estimatedCGT,
            netProceeds: netProceeds,
            salePrice: salePrice,
            sellingCosts: sellingCosts,
            isPreCGT: isPreCGT
        };
    }, [
        overallStrategy.sellInvestmentProperty,
        investmentPropertyDetails,
        factFind
    ]);
    const projectionStrategyOptions = (0, $acw62.useMemo)(()=>{
        const modellerResidency = (0, $8eecd0af141b9afb$export$5f0bb1b091776594)($39641e97aa80005f$var$asFactFind(factFind));
        return {
            ...overallStrategy,
            ...strategyInputs,
            ...modellerResidency,
            downsizeDetails: downsizeDetails,
            scenarioLivingExpenses: scenarioLivingExpenses,
            radFunding: radFunding,
            cgtOverrides: cgtOverrides,
            radInput: radInput,
            reverseMortgageDetails: overallStrategy.reverseMortgage ? reverseMortgageDetails : null,
            heasDetails: overallStrategy.heas ? heasDetails : null,
            otherStrategies: otherStrategies,
            annuityRecord: otherStrategies.annuity ? annuityRecord : null,
            inflationAssumptionPct: (0, $1abe73eeef086faf$export$e51ae1118d375fce),
            investmentPropertySaleSummary: investmentPropertySaleSummary || null,
            // A future entry date defers the CARE COSTS, not the projection: the run still starts from
            // today, so the years before entry are modelled (the client at home, on their own living
            // expenses, paying nothing for care) and the legacy horizon is the same length whatever
            // entry date is chosen. Blank = care is already under way.
            ...careStartDate ? {
                careStartDate: careStartDate
            } : {},
            radDrawdown: radDrawdown,
            ...residentialFeeArrangements ? {
                residentialFeeArrangements: residentialFeeArrangements
            } : {},
            // Hands the liquidation to the engine, which sells on this day and holds the proceeds in
            // the bank until the deposit is paid on entry. Defaults to the entry date rather than being
            // absent, so a blank "sell earlier" field means what the screen says it means. It is only
            // sent when `simulatedFactFind` has correspondingly NOT applied the sale itself — both read
            // `effectiveRadFundingDate` precisely so they cannot disagree.
            ...effectiveRadFundingDate ? {
                radFundingDate: effectiveRadFundingDate
            } : {},
            // The Debt Strategy card's plan. Sent ONLY with a date — the same contract the RAD sale
            // follows: a date means the engine owns the event, no date means the fact-find arrived with
            // it already applied. `simulatedFactFind` reads the same `effectiveRadFundingDate`, so the
            // two can never both do it (which would clear the debt twice) or both skip it.
            ...debtPayoffPlan && effectiveRadFundingDate ? {
                debtPayoff: {
                    ...debtPayoffPlan,
                    date: effectiveRadFundingDate
                }
            } : {},
            // The second resident: their own entry, deposit and schedule, run beside the first.
            ...secondResidentPlan ? {
                secondResident: secondResidentPlan
            } : {},
            // A change of home: no entry date (care is under way); the move is dated instead.
            ...isMover ? {
                careStartDate: undefined,
                radFundingDate: undefined,
                facilityMove: {
                    person: moverPerson,
                    moveDate: careStartDate || (0, $b8d3cfe4c156722e$export$cea9846d43ecc40e)(),
                    agedCareCosts: agedCareCosts,
                    radTarget: radPaid,
                    radFunding: radFunding,
                    grandfathered: moverGrandfathered
                }
            } : {},
            // Leaving a village: the exit payment on its date, and what of it goes to the room.
            ...villageExitPlan ? {
                villageExit: villageExitPlan
            } : {}
        };
    }, [
        isMover,
        moverPerson,
        moverGrandfathered,
        radPaid,
        radFunding,
        agedCareCosts,
        careStartDate,
        villageExitPlan,
        secondResidentPlan,
        debtPayoffPlan,
        overallStrategy,
        strategyInputs,
        downsizeDetails,
        scenarioLivingExpenses,
        radFunding,
        cgtOverrides,
        radInput,
        reverseMortgageDetails,
        heasDetails,
        otherStrategies,
        annuityRecord,
        factFind,
        investmentPropertySaleSummary,
        careStartDate,
        radFundingDate,
        radDrawdown,
        residentialFeeArrangements
    ]);
    const [projections, setProjections] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        trackPlan($55a1d8a64f1e5dfa$export$75699a59a86ef1ab(simulatedFactFind, projectionStrategyOptions, runSchedule, localLegacyYears, {
            debug: false
        })).then((proj)=>{
            if (!cancelled) setProjections(proj);
        }).catch((0, $85051d5377ce5db4$export$890bc823b29958a8)('the projection'));
        return ()=>{
            cancelled = true;
        };
    }, [
        simulatedFactFind,
        agedCareCosts,
        localLegacyYears,
        projectionStrategyOptions
    ]);
    /*
     * A SECOND, LONGER run, for "how long the money lasts" only.
     *
     * "When does the money run out" is an unbounded question and must not be chained to the Project
     * Legacy Over control, which the reader set for a different purpose — the estate. Asked over the
     * default five years the funding helper can only ever answer "lasts your full 5-year plan", and
     * it says that for a household whose savings actually run low in year 13. That is not a missing
     * number, it is a falsely comforting one, which is worse.
     *
     * The engine already knows the answer: every projection row carries `unfundedShortfall` ("the
     * first year this turns positive is the year the client's money runs out"), and summariseFunding
     * turns the drawdown rows into the year the bank runs low and the year borrowing starts. Until
     * now nothing on any screen read either.
     *
     * The cost is one extra engine call, so it is gated on there being a room price to model at all.
     */ const [runwayProjections, setRunwayProjections] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        if (!(Number(radInput) > 0)) {
            setRunwayProjections([]);
            return undefined;
        }
        let cancelled = false;
        trackPlan($55a1d8a64f1e5dfa$export$75699a59a86ef1ab(simulatedFactFind, projectionStrategyOptions, runSchedule, $39641e97aa80005f$var$RUNWAY_HORIZON_YEARS, {
            debug: false
        })).then((proj)=>{
            if (!cancelled) setRunwayProjections(proj);
        }).catch((0, $85051d5377ce5db4$export$890bc823b29958a8)('the projection'));
        return ()=>{
            cancelled = true;
        };
    }, [
        simulatedFactFind,
        agedCareCosts,
        projectionStrategyOptions,
        radInput
    ]);
    /* The runway itself is struck further down, once the panel's source plan is known — see
       `panelRunwayRows`. Only the long-horizon projection it may draw on is fetched here. */ /**
     * The projections modal can be switched to CALENDAR-year rows (1 January → 31 December) instead
     * of financial-year ones. That is a different engine run — the periods are cut differently and
     * the engine's plugin phases execute in a rotated order — so it is fetched separately and only
     * on demand, leaving the financial-year `projections` above (which the SOA, the impact panel and
     * the suggestion engine all read) untouched.
     *
     * The mode is the MODAL's sticky preference, so we seed from the same store it reads (rather than
     * always starting at financial year) and the modal opens showing rows already cut the user's way.
     */ const [modalPeriodMode, setModalPeriodMode] = (0, $acw62.useState)((0, $4f50ab660c01dd64$export$1e222c2c280e2a28));
    const [calendarYearProjections, setCalendarYearProjections] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (modalPeriodMode !== 'calendar_year') {
            setCalendarYearProjections(null);
            return;
        }
        // Only while the modal is open: with the mode now remembered across sessions, a stored
        // 'calendar_year' would otherwise fire this second full engine run on every page load,
        // whether or not the projections modal is ever opened.
        if (!showProjections) return;
        let cancelled = false;
        // Cleared first so an input change (a different strategy, say) re-shows the hourglass rather
        // than leaving the previous run's calendar rows on screen as if they were current.
        setCalendarYearProjections(null);
        $55a1d8a64f1e5dfa$export$75699a59a86ef1ab(simulatedFactFind, {
            ...projectionStrategyOptions,
            projectionPeriodMode: 'calendar_year'
        }, runSchedule, localLegacyYears, {
            debug: false
        }).then((proj)=>{
            if (!cancelled) setCalendarYearProjections(proj);
        }).catch((0, $85051d5377ce5db4$export$890bc823b29958a8)('the projection'));
        return ()=>{
            cancelled = true;
        };
    }, [
        showProjections,
        modalPeriodMode,
        simulatedFactFind,
        agedCareCosts,
        localLegacyYears,
        projectionStrategyOptions
    ]);
    // Memoised so these heavy pure calcs don't re-run on every render — notably when selecting a
    // suggestion-engine strategy (which changes selectedStrategy/savedStrategies but NOT these
    // inputs), so the Insight Panel updates without re-running calculateFinancials/buildAnnuityImpact.
    // Purely a performance optimisation — identical inputs produce identical output.
    const [insightPanelNetWorth, setInsightPanelNetWorth] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        $55a1d8a64f1e5dfa$export$463f0620dd36e1f8({
            ...factFind,
            expenses: {
                ...factFind.expenses,
                livingExpenses: scenarioLivingExpenses
            }
        }, {
            ...strategyOptions,
            ...(0, $8eecd0af141b9afb$export$5f0bb1b091776594)($39641e97aa80005f$var$asFactFind(factFind))
        }).then((r)=>{
            if (!cancelled) setInsightPanelNetWorth(r?.netWorth);
        }).catch((0, $85051d5377ce5db4$export$890bc823b29958a8)('the comparison position'));
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind,
        scenarioLivingExpenses,
        strategyOptions
    ]);
    const insightPanelAnnuityRecord = (0, $acw62.useMemo)(()=>{
        if (!otherStrategies.annuity || !annuityRecord || !annuityRecord.purchaseAmount || Number(annuityRecord.purchaseAmount) <= 0) return null;
        try {
            const mappedAnnuityRecord = {
                ...annuityRecord
            };
            if (!mappedAnnuityRecord.age && factFind?.client?.dob) mappedAnnuityRecord.age = (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client?.dob);
            if (mappedAnnuityRecord.age && mappedAnnuityRecord.age > 0) return (0, $f7f7b62814c3b615$export$fb67395f10ad20c9)($39641e97aa80005f$var$asFactFind(factFind), mappedAnnuityRecord);
        } catch (error) {
            console.error('Error building annuity for Insight Panel:', error);
        }
        return null;
    }, [
        otherStrategies.annuity,
        annuityRecord,
        factFind
    ]);
    // Stable object identity for the Suggestion Engine panel's agedCareCosts prop. Without this the
    // inline {...} object got a new reference on EVERY render, so the SE panel's analysis useEffect
    // (deps include agedCareCosts) re-ran the full strategy analysis on unrelated re-renders —
    // notably when selecting a strategy — causing a multi-second lag. Now it only changes when the
    // costs actually change, so analysis still re-runs when it should, but not on select.
    const suggestionEngineAgedCareCosts = (0, $acw62.useMemo)(()=>({
            ...agedCareCosts,
            radAmount: radInput,
            scenarioLivingExpenses: scenarioLivingExpenses
        }), [
        agedCareCosts,
        radInput,
        scenarioLivingExpenses
    ]);
    /**
     * What the Suggestion Engine reads from the case (and nothing more): the entry date, whether fees
     * may be drawn from the deposit, the fee arrangements, and the second room where both of a couple
     * are entering care. Until 7 Oct 2026 only the entry date reached it — the second room, the
     * drawdown choice and the fee arrangements were put on the page-level bag that this panel never
     * received, so every candidate was priced on one room (owner-caught).
     */ const suggestionEngineStrategyOptions = (0, $acw62.useMemo)(()=>({
            ...careStartDate ? {
                careStartDate: careStartDate
            } : {},
            radDrawdown: radDrawdown,
            ...residentialFeeArrangements ? {
                residentialFeeArrangements: residentialFeeArrangements
            } : {},
            ...secondRoomActive ? {
                secondRoom: {
                    person: secondPerson,
                    roomPrice: secondRoom.roomPrice,
                    ...secondRoom.careStartDate ? {
                        careStartDate: secondRoom.careStartDate
                    } : {},
                    extraServiceAnnual: secondRoom.extraServiceAnnual,
                    entersLater: secondEntersLater,
                    ...livingOnceBoth != null ? {
                        livingExpensesOnceBoth: livingOnceBoth
                    } : {}
                }
            } : {},
            // A change of home: every candidate but "stay put" moves on this date and pays the new
            // room from the refund first; the run opens in the current home on its schedule.
            ...isMover && existingStay && stayPutCosts ? {
                facilityMove: {
                    person: moverPerson,
                    moveDate: careStartDate || (0, $b8d3cfe4c156722e$export$cea9846d43ecc40e)(),
                    newRoomPrice: radInput,
                    extraServiceAnnual: extraServiceFeeInput,
                    refundToday: moverDeposit.balance,
                    currentRoomPrice: existingStay.roomPrice,
                    currentDapAnnual: existingStay.dailyPayment * 365,
                    grandfathered: moverGrandfathered,
                    currentSchedule: stayPutCosts
                }
            } : {},
            // Leaving a village: every candidate puts the exit payment to the room first when it arrives.
            ...villageExit ? {
                villageExit: {
                    person: villagePerson,
                    leaveDate: villageLeaveDate,
                    refundDate: villageRefundDate,
                    entitlement: villageExit.entitlement,
                    ...villagePaidAtMove ? {
                        paidAtMove: true
                    } : {},
                    ...villageFees && villageFees.total > 0 ? {
                        feesAfterLeaving: villageFees
                    } : {}
                }
            } : {}
        }), [
        careStartDate,
        radDrawdown,
        residentialFeeArrangements,
        secondRoomActive,
        secondPerson,
        secondRoom.roomPrice,
        secondRoom.careStartDate,
        secondRoom.extraServiceAnnual,
        secondEntersLater,
        livingOnceBoth,
        isMover,
        existingStay,
        stayPutCosts,
        moverPerson,
        radInput,
        extraServiceFeeInput,
        moverDeposit.balance,
        moverGrandfathered,
        villageExit,
        villagePerson,
        villageLeaveDate,
        villageFees,
        villageRefundDate,
        villagePaidAtMove
    ]);
    /**
     * The plain-words recap, built once here and rendered inside "Understanding your plan".
     *
     * It is the SAME component with the SAME props it had when it sat inline on the page — only its
     * position changed. Kept as a node rather than mounted twice: it runs its own baseline lookup,
     * and two mounts would mean two sets of engine calls for one answer.
     */ const planRecapNode = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a258b04930632a82$export$2e2bcd8739ae039), {
        /*
             * THE SAME TELLING AS THE ENGINE'S CARDS (owner, 18 Oct 2026: Manual Control's "Read the
             * full explanation" looked different from the engine's Explain this — "should this be the
             * same look and feel?"). One plan, one explanation: the numbered cause→effect lines, the
             * doing-nothing figures beside this plan's, the money story account by account, the result
             * under the total rule. The facts come from the same baseline the rail reads.
             */ told: "causeEffect",
        causeEffectFacts: {
            baselineCareAnnual: (0, $bdfd96a4f4ac117d$export$4a7e3987a5ffaa21)(agedCareBaseline.agedCareCosts ?? null, agedCareBaseline.secondEntersLater ? null : baselineSecondCosts) * 365,
            baselineDapDaily: Number(agedCareBaseline.agedCareCosts?.dailyAccommodationPayment) || null,
            baselineInvestmentIncome: agedCareBaseline.financials?.investmentIncome ?? null,
            planInvestmentIncome: simulatedFinancials.investmentIncome != null ? Number(simulatedFinancials.investmentIncome) - (Number(simulatedFinancials.rentalExpenses) || 0) : null,
            enteringName: enteringFirstName,
            illnessSeparated: factFind.adviceFor === 'couple' && (0, $8eecd0af141b9afb$export$9b95c99516118f10)($39641e97aa80005f$var$asFactFind(factFind), (0, $8eecd0af141b9afb$export$5f0bb1b091776594)($39641e97aa80005f$var$asFactFind(factFind)))
        },
        ...(()=>{
            // Where the shortfall comes from, account by account, off the plan's own long-run rows (as the engine's cards do).
            const rows = runwayProjections || [];
            const runway = (0, $0fe89e03b6df746e$export$464558962ff4a811)(rows, rows.length);
            const forWhom = factFind.goals?.aged_care_for;
            const refundTo = factFind.adviceFor === 'couple' && forWhom !== 'both' ? (forWhom === 'partner' ? factFind.client?.firstName : factFind.partner?.firstName) || 'your partner' : 'the estate';
            const paid = Math.min(Number(radPaid) || 0, Number(radInput) || 0);
            // Only where a year falls short, as every other module (consistency audit, 22 Oct 2026).
            const story = (0, $0fe89e03b6df746e$export$693cc3146baa3244)(rows).hasDeficit ? (0, $2ddaae90639b5011$export$bdea18f456fd84b)({
                rows: rows,
                factFind: factFind,
                runway: runway,
                deposit: {
                    paid: paid,
                    refundTo: refundTo
                },
                horizonYears: localLegacyYears,
                enteringName: enteringFirstName
            }) : null;
            return {
                moneyOrder: (0, $f15268380bf00a12$export$5607313da658fe63)(rows, factFind, runway, {
                    refund: paid,
                    refundTo: refundTo
                }),
                moneyStory: story ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ddaae90639b5011$export$1a915263dc5391f1), {
                    story: story
                }) : null
            };
        })(),
        factFind: factFind,
        overallStrategy: overallStrategy,
        investmentPropertyDetails: investmentPropertyDetails,
        downsizeDetails: downsizeDetails,
        reverseMortgageDetails: reverseMortgageDetails,
        radFunding: radFunding,
        cgtOverrides: cgtOverrides,
        radInput: radInput,
        radPaid: radPaid,
        agedCareCosts: householdAgedCareCosts,
        simulatedFinancials: simulatedFinancials,
        strategyInputs: strategyInputs,
        // No heading: "Understanding your plan" titles the modal and "Your plan summary" heads
        // the panel beside it, so the agreed default would appear three times on one screen.
        eyebrow: null,
        // ONE baseline for the summary and the panel — see StrategyPlanRecap.
        sharedBaseline: agedCareBaseline.financials ? {
            pension: agedCareBaseline.pension,
            cashFlowAfterCare: agedCareBaseline.cashFlowAfterCare
        } : null,
        planRunway: (0, $761eebfc891b9eea$export$2e354e42d669da07)(runwayProjections),
        baselineLegacy: agedCareBaseline.legacyValue,
        planLegacy: projections.length > 0 ? (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(projections[projections.length - 1]) : null,
        legacyYears: localLegacyYears,
        heasDetails: overallStrategy.heas ? heasDetails : null,
        debtPayoffPlan: debtPayoffPlan,
        otherStrategies: otherStrategies,
        annuityRecord: annuityRecord,
        extraServiceFeeInput: extraServiceFeeInput,
        secondRoom: secondRoomActive ? {
            name: secondName,
            leadName: firstName,
            roomPrice: secondRoom.roomPrice,
            radPaid: secondFunding?.funded ?? 0,
            dailyTotal: secondAgedCareCosts?.totalDailyCost ?? null,
            funding: (0, $e5cae8423a439bf1$export$8f80043cee83ba5d)(factFind, secondFunding?.radFunding),
            paidFromLabel: secondEntersLater ? phaseNames.fromLabel : undefined
        } : null,
        phaseTwo: phaseTwoHousehold ? {
            names: phaseNames,
            firstDaily: agedCareCosts.totalDailyCost || 0,
            phaseTwoDaily: phaseTwoHousehold.totalDailyCost || 0
        } : null,
        facilityMove: isMover && currentHomeFacts ? (0, $b073c6d711dafa37$export$1059590aefc83273)({
            name: currentHomeFacts.name,
            facilityName: currentHomeFacts.facilityName,
            moveLabel: careStartDate ? (0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(careStartDate) : 'the coming weeks',
            newRoomPrice: radInput,
            deposit: Math.min(radInput, radPaid),
            fromRefund: Math.min(moverDeposit.balance, Math.min(radInput, radPaid)),
            fromSale: Math.max(0, Math.min(radInput, radPaid) - Math.min(moverDeposit.balance, Math.min(radInput, radPaid))),
            soldPhrase: (0, $e5cae8423a439bf1$export$83ba4f4a49e92f66)((0, $e5cae8423a439bf1$export$8f80043cee83ba5d)(factFind, radFunding), (0, $f94e45ac645ae232$export$3dc27271f5d5c629)),
            dapPerDay: Number(agedCareCosts.dailyAccommodationPayment) || 0,
            grandfathered: moverGrandfathered,
            retentionDaysTaken: moverDeposit.retentionDaysTaken
        }) : null,
        villageExit: villageFacts ? (0, $511dfa7ed5ad5c31$export$ff6c9524331ef263)({
            name: villageFacts.name,
            leaveLabel: careStartDate ? (0, $b8d3cfe4c156722e$export$e009b8a64eefbb66)(careStartDate) : 'the coming weeks',
            entitlement: villageFacts.entitlement,
            refundMonths: villageFacts.refundMonths,
            refundDate: villageFacts.refundDate,
            roomPrice: radInput,
            deposit: Math.min(radInput, radPaid),
            fromVillage: radPaidBreakdown.fromVillage,
            fromSavings: Math.max(0, Math.min(radInput, radPaid) - radPaidBreakdown.fromVillage),
            soldPhrase: (0, $e5cae8423a439bf1$export$83ba4f4a49e92f66)((0, $e5cae8423a439bf1$export$8f80043cee83ba5d)(factFind, radFunding), (0, $f94e45ac645ae232$export$3dc27271f5d5c629)),
            toBank: Math.max(0, villageFacts.entitlement - radPaidBreakdown.fromVillage),
            interim: villageInterim,
            feesAfterLeaving: villageFees,
            paidAtMove: villagePaidAtMove,
            dapPerDay: Number(agedCareCosts.dailyAccommodationPayment) || 0
        }) : null,
        annuityFromSaleProceeds: otherStrategies.annuity && isAnnuityFundedFromSaleProceeds(annuityRecord) ? parseFloat(String(annuityRecord?.purchaseAmount)) || 0 : 0
    });
    /**
     * The panel's "In brief" line.
     *
     * Built from figures ALREADY ON SCREEN in the panel's own tiles — the baseline and the plan,
     * subtracted exactly as the tiles subtract them — so the sentence cannot disagree with the
     * numbers directly above it. Nothing here re-reads the fact-find, and the cashflow subtraction
     * is the same `cashFlow − totalDailyCost×365` that FinancialImpactPanel applies.
     */ /*
     * IN SUGGESTION ENGINE MODE THE RAIL IS THE WALK-IN POSITION, ALWAYS (owner, 2026-09-22).
     *
     * Each card already carries everything the rail used to repeat for a selected plan — its figures
     * with the walk-in figure and the change under each tile, Explain this, Deep Dive with the
     * projections, and the advice document. Two places for one plan was the duplication the review
     * kept finding. So the rail now holds the one thing the cards do not: doing nothing, for
     * comparison, unblurred and labelled, and it never changes while the reader selects and
     * reselects. (The earlier design blurred it while browsing and swapped it to the selected plan on
     * Select; the blur read as a fault, and the swap made the rail and the card say the same thing
     * twice. If the walk-in rail proves too much on screen, the blur is the fallback — owner.)
     *
     * Manual Control is unchanged: there is no card, so the rail is the plan, with the baseline in
     * grey beside each figure.
     */ const railIsWalkIn = strategyMode === 'optimised' || !strategyModeChosen;
    /** The rail's figures are still being worked out: the benchmark always; the hand-built plan in Manual Control. */ const railWorking = baselineWorking || !railIsWalkIn && planWorking;
    /** The rail is Manual Control's; in engine mode the strip across the top carries the baseline (17 Oct 2026). */ const railShown = strategyMode === 'manual' && showStrategyOptions;
    /* What AWise can see: the screen, and the facts already on it (never anything it should compute). */ (0, $acw62.useEffect)(()=>{
        const screen = step === 1 ? 'step-1' : step === 2 ? 'step-2' : railShown ? 'manual' : 'step-3';
        const facts = [];
        if (homeName) facts.push(`Home: ${homeName}.`);
        if (radInput > 0) facts.push(`Room price ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(radInput)} (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(radInput * (0, $815d7df20c36742b$export$36c4ec5f3f340aef).MPIR / 365)} a day if the whole room were paid daily).`);
        facts.push(`Living costs once ${enteringFirstName} is in care: ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(scenarioLivingExpenses) || 0)} a year.`);
        if (step >= 2 && agedCareBaseline.pension != null) {
            const daily = Number(agedCareBaseline.agedCareCosts?.totalDailyCost) || 0;
            facts.push(`Paying daily (nothing paid up front, nothing sold): care would cost ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(daily))} a day (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(daily * 365))} a year); ${enteringFirstName}'s Age Pension ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(agedCareBaseline.pension))} a year once care starts; each year ${(agedCareBaseline.cashFlowAfterCare ?? 0) < 0 ? 'short by' : 'left over'} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(agedCareBaseline.cashFlowAfterCare ?? 0)))}; left to the family after about ${localLegacyYears} years ${agedCareBaseline.legacyValue != null ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(agedCareBaseline.legacyValue)) : 'not available'}.`);
        }
        // The selection is the engine row itself: its figures live on `snapshot`, and its name is said
        // in the same words the card uses ("Pay $520,000 up front, keep the home"), never the engine's.
        const chosen = selectedStrategy;
        if (step === 3 && chosen) {
            const s = chosen.snapshot || {};
            const title = (0, $95e43332fd84eec4$export$f973c372d76f95c8)(chosen, factFind, String(chosen.name || 'the chosen plan')).title;
            const sameRoom = !(Number(chosen.radRoomPrice) > 0 && radInput > 0 && Math.abs(Number(chosen.radRoomPrice) - radInput) > 1);
            facts.push(`The chosen plan${sameRoom ? '' : ` (for the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(Number(chosen.radRoomPrice)))} room, not this one)`}: ${title}${s.legacyValue != null ? ` \u{2014} left to the family ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(s.legacyValue))}` : ''}${s.totalAgedCareCosts != null ? `, care ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(s.totalAgedCareCosts))} a year` : ''}${s.pension != null ? `, Age Pension ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(s.pension))} a year` : ''}${s.netCashflow != null ? `, each year ${s.netCashflow < 0 ? 'short by' : 'left over'} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(s.netCashflow)))}` : ''}.`);
        }
        (0, $6067e4a24a943681$export$62e91b0fed1d0d10)({
            screen: screen,
            note: facts.join(' ')
        });
        return ()=>(0, $6067e4a24a943681$export$62e91b0fed1d0d10)(null);
    }, [
        step,
        railShown,
        homeName,
        radInput,
        scenarioLivingExpenses,
        agedCareBaseline,
        localLegacyYears,
        selectedStrategy,
        enteringFirstName
    ]);
    /**
     * The first visit to step 3 asks the questions that change the answer, inline (version A). Done once
     * the setup has been completed on this file — the same flag the pop-over used to set.
     */ /*
     * Set up means THIS file answered the questions: the flag in the setup bag AND the lifetime-income
     * answer on the file's own goals. The bag is app-level state and, before 18 Oct 2026, kept the
     * flag from the previous file — so a brand-new client skipped the questions and met the old
     * annuity gate instead (owner-caught). A file the flag leaked onto, and was then saved with, still
     * has no annuity answer, so it is asked the questions here, once.
     */ const engineSetupDone = !askSetupAgain && !!coupleValidation.suggestionEngineSetupComplete && (0, $ff5de4128b46b139$export$636a9065c3f862c1)(factFind).answered;
    /**
     * TWO DOORS INTO MANUAL CONTROL (owner, 25 Oct 2026).
     *
     * "Build a plan yourself" (no row) opens a BLANK plan — reset exactly as after a save: the room
     * price, living costs and start date kept, everything the plan does cleared. It used to open on
     * whatever was last there, so a client who had customised a plan and gone back saw that plan again.
     *
     * "Customise this plan" (a row) copies the tested plan in, every part of it (acBuildOnSeed.ts): the
     * deposit funding, the debt payoff, the home kept, let, sold or borrowed against, an investment
     * property sold, the guaranteed income, funeral bonds or a gift, and the deposit's drawdown — so the
     * hand-built figures open equal to the card's. What is saved from it is the client's own plan, and
     * records the plan it started from (`customisedFrom`).
     */ const onBuildYourOwn = (row)=>{
        setReopenedEngineStrategyId(null);
        resetManualControlToBaseline();
        if (row) {
            const seed = (0, $9a6ecfa64a75463a$export$fe486fe4085be145)(row, {
                clientAge: factFind?.client?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client.dob) : null,
                partnerAge: factFind?.adviceFor === 'couple' && factFind?.partner?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner.dob) : null,
                isCouple: factFind?.adviceFor === 'couple',
                homeValue: Number(factFind.home?.value) || 0
            });
            setRadFunding(seed.radFunding);
            setDebtPayments(seed.debtPayments);
            setDebtFunding(seed.debtFunding);
            setDebtRepaymentBasis(seed.debtRepaymentBasis);
            const l = seed.levers;
            if (l) {
                setOverallStrategy(l.overallStrategy);
                if (Object.keys(l.strategyInputs).length) setStrategyInputs((s)=>({
                        ...s,
                        ...l.strategyInputs
                    }));
                if (l.downsizeDetails) setDownsizeDetails((d)=>({
                        ...d,
                        ...l.downsizeDetails
                    }));
                if (l.investmentPropertyDetails) setInvestmentPropertyDetails((d)=>({
                        ...d,
                        ...l.investmentPropertyDetails
                    }));
                if (l.reverseMortgageDetails) setReverseMortgageDetails((d)=>({
                        ...d,
                        ...l.reverseMortgageDetails
                    }));
                if (l.heasDetails) setHeasDetails((d)=>({
                        ...d,
                        ...l.heasDetails
                    }));
                setOtherStrategies(l.otherStrategies);
                setAnnuityRecord(l.annuityRecord);
                if (l.annuityRecord || l.otherStrategies.gifting || l.otherStrategies.funeralBonds) setShowOtherStrategies(true);
                if (l.radDrawdown) setRadDrawdown(l.radDrawdown);
                if (l.scenarioLivingExpenses != null) setScenarioLivingExpenses(l.scenarioLivingExpenses);
            }
            setCustomisedFrom((0, $95e43332fd84eec4$export$f973c372d76f95c8)(row, factFind, String(row.name || 'the suggested plan')).title);
        } else setCustomisedFrom(null);
        setStrategyModeChosen(true);
        setStrategyMode('manual');
        setShowStrategyOptions(true);
        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
    };
    /*
     * The rail no longer reads the selected engine strategy at all (the block that unwrapped the
     * saved-strategy envelope and priced the selected row lived here until 2026-09-22). In engine
     * mode the rail is the walk-in position; the card the client selected is where that plan is
     * priced, explained and taken to the advice document. A panel that named one plan and priced
     * another was the worst failure this screen had; a panel that names no plan cannot have it.
     */ // The rail's one source per mode: the walk-in position in engine mode (the baseline this page
    // measures every card against; the current position only if that could not be computed), the
    // modelled plan in Manual Control.
    const panelFirstCosts = railIsWalkIn ? agedCareBaseline.agedCareCosts ?? agedCareCosts : agedCareCosts;
    /** The second room's schedule in the same mode, where both are in care; null otherwise. */ const panelSecondCosts = secondRoomActive && !secondEntersLater ? railIsWalkIn ? baselineSecondCosts : secondAgedCareCosts : null;
    /** The second stage on the rail, where the second person enters later: each room's schedule from then. */ const panelPhaseTwo = !secondEntersLater ? null : railIsWalkIn ? agedCareBaseline.phase2 ? {
        firstCosts: agedCareBaseline.phase2.agedCareCosts,
        secondCosts: agedCareBaseline.phase2.secondAgedCareCosts
    } : null : phaseTwo ? {
        firstCosts: phaseTwo.firstCosts,
        secondCosts: secondAgedCareCosts
    } : null;
    const panelPhaseTwoDaily = panelPhaseTwo ? (0, $bdfd96a4f4ac117d$export$4a7e3987a5ffaa21)(panelPhaseTwo.firstCosts, panelPhaseTwo.secondCosts) : 0;
    // The household's totals (both rooms) over the first room's fields, so every tile, sentence and
    // breakdown on the rail describes what the two of them pay.
    const panelCosts = (0, $bdfd96a4f4ac117d$export$89e252d57ea6f30b)(panelFirstCosts, panelSecondCosts);
    /** One room's fee rows, as the cost disclosure lists them — the same rows for either room. */ const feeRows = (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a40d28b08feb5cc$export$2e2bcd8739ae039), {
                    label: "Basic Daily Fee",
                    value: c.basicDailyFee,
                    breakdown: c.calculationBreakdowns?.bdf
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a40d28b08feb5cc$export$2e2bcd8739ae039), {
                    label: "Accommodation (DAP)",
                    value: c.dailyAccommodationPayment,
                    breakdown: c.calculationBreakdowns?.dap
                }),
                c.feeArrangements === '2014' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a40d28b08feb5cc$export$2e2bcd8739ae039), {
                    label: "Means-tested care fee (no worse off)",
                    value: c.dailyMTCF,
                    breakdown: c.calculationBreakdowns?.mtcf
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a40d28b08feb5cc$export$2e2bcd8739ae039), {
                            label: "Care Contribution (NCCC)",
                            value: c.dailyNCCC,
                            breakdown: c.calculationBreakdowns?.nccc
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a40d28b08feb5cc$export$2e2bcd8739ae039), {
                            label: "Hotelling Supplement Contribution (HSC)",
                            value: c.dailyHSC,
                            breakdown: c.calculationBreakdowns?.hsc
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a40d28b08feb5cc$export$2e2bcd8739ae039), {
                    label: "Optional Extra Services",
                    value: c.dailyExtraServiceFee
                })
            ]
        });
    const panelFinancials = railIsWalkIn ? agedCareBaseline.financials ?? simulatedFinancials : simulatedFinancials;
    const panelProjections = railIsWalkIn && agedCareBaseline.projections.length ? agedCareBaseline.projections : projections;
    /**
     * What the plan summary is describing, in the client's words — or null when it is describing
     * nothing yet, in which case the panel says so and shows the walk-in position.
     *
     * Built from the strategy flags that are actually ON rather than from a stored label, so it
     * cannot drift from what is being modelled. A panel headed with a name that no longer matches
     * the numbers underneath it would be worse than one with no name at all.
     */ const planSummaryStrategyName = (0, $acw62.useMemo)(()=>{
        /*
         * THE NAME AND THE FIGURES COME FROM ONE SOURCE (owner-reported, 2026-08-31; settled
         * 2026-09-22). Twice this rail named a selected engine strategy while pricing something else.
         * It now never names one: in engine mode it is the walk-in position and the card carries the
         * plan, so the name and every figure switch on the one flag above.
         */ // Engine mode: the rail is the walk-in position and names no plan — the card names it.
        if (railIsWalkIn) return null;
        // In the card's order and words — the deposit, then the home, then the rest (25 Oct 2026):
        // "Pay $817,600 up front, keep the home, clear the debt".
        const parts = [];
        if (radPaid > 0.5) parts.push(radPaid >= (Number(radInput) || 0) - 0.5 ? 'Pay the whole room up front' : `Pay ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(radPaid)} up front`);
        const homeMove = overallStrategy.downsizeHome || overallStrategy.rentHome || overallStrategy.reverseMortgage || overallStrategy.heas;
        if (overallStrategy.downsizeHome) parts.push('Sell the family home');
        if (overallStrategy.rentHome) parts.push('Rent out the home');
        if (overallStrategy.reverseMortgage) parts.push('Take a reverse mortgage');
        if (overallStrategy.heas) parts.push('Use the Home Equity Access Scheme');
        if (!homeMove && radPaid > 0.5 && (Number(factFind.home?.value) || 0) > 0) parts.push('Keep the home');
        // NAME THE AMOUNT (owner, 2026-08-31): a $50,000 and a $450,000 deposit are different plans.
        /*
         * THE OTHER STRATEGIES COUNT AS A PLAN TOO (seen on screen, 2026-08-28).
         *
         * This read only the property and room levers, so a client who entered a $200,000 gift and a
         * $30,000 funeral bond was shown a panel headed "No plan yet — the walk-in position" and
         * told "this IS the baseline" — directly above tiles reporting a $12,190 Age Pension rise
         * and a $197,982 fall in the estate, both caused by the plan the heading said did not exist.
         *
         * A panel cannot report the effects of a plan and deny there is one. These three move the
         * means test as surely as selling the home does; they were simply added to the module later
         * than the naming was written.
         */ const giftingAmount = Number(otherStrategies.giftingAmount) || 0;
        if (otherStrategies.gifting && giftingAmount > 0) parts.push('Gift to loved ones');
        const funeralBondAmount = Number(otherStrategies.funeralBondAmount) || 0;
        if (otherStrategies.funeralBonds && funeralBondAmount > 0) parts.push('Buy a funeral bond');
        if (otherStrategies.annuity && (Number(annuityRecord?.purchaseAmount) || 0) > 0) parts.push('Buy a lifetime annuity');
        if (debtPayoffPlan) parts.push('Clear the debt');
        if (!parts.length) return null;
        const [lead, ...rest] = parts;
        return rest.length ? `${lead}, ${rest.map((p)=>p.charAt(0).toLowerCase() + p.slice(1)).join(', ')}` : lead;
    }, [
        strategyMode,
        selectedStrategy,
        overallStrategy,
        radPaid,
        radInput,
        otherStrategies,
        annuityRecord,
        debtPayoffPlan
    ]);
    /*
     * The runway runs on the SELECTED strategy's own projections when there is one, which are the
     * plan-period rows the card's funding note also reads — so the two cannot disagree about when
     * the money runs out. The horizon is stated either way, so a five-year answer is never mistaken
     * for a twenty-five-year one.
     */ // In engine mode the rail is the walk-in position, so it reads the same 25-year no-plan rows
    // step 2 reads — the two runways are then one runway, and can never quote different years.
    const panelRunwayRows = railIsWalkIn && agedCareBaseline.runwayProjections.length ? agedCareBaseline.runwayProjections : runwayProjections;
    const panelRunwayYears = $39641e97aa80005f$var$RUNWAY_HORIZON_YEARS;
    const runway = (0, $acw62.useMemo)(()=>(0, $0fe89e03b6df746e$export$464558962ff4a811)(panelRunwayRows, panelRunwayYears), [
        panelRunwayRows,
        panelRunwayYears
    ]);
    /**
     * The rail's runway note, in step 2's words: which account runs low when, what takes over, and
     * when the savings are gone — read off the rows the rail's runway is struck on. Borrowing against
     * the home is the last clause, not the headline (owner, 22 Sep 2026: "at the client's age that's
     * highly unlikely to happen"). The generic flag is the fallback only when no pool can be named.
     */ // A hand-built plan says it in the engine card's words (runwayCardLine), off its own rows — the same accounts by
    // name, the deposit's turn, then the home (25 Oct 2026: the card and the hand-built rail told two stories for one
    // plan). The walk-in keeps step 2's sentence.
    const railRunwayFlag = (0, $acw62.useMemo)(()=>{
        const rows = panelRunwayRows || [];
        if (!railIsWalkIn && rows.length) {
            const line = (0, $2ddaae90639b5011$export$7526d1fcb4423629)({
                rows: rows,
                factFind: factFind,
                horizonYears: panelRunwayYears,
                enteringName: enteringFirstName
            });
            if (line) return line.charAt(0).toUpperCase() + line.slice(1);
        }
        return (0, $f15268380bf00a12$export$2c0b92fbaefb8de7)(rows, railIsWalkIn ? factFind : simulatedFactFind, runway);
    }, [
        panelRunwayRows,
        panelRunwayYears,
        railIsWalkIn,
        factFind,
        simulatedFactFind,
        runway,
        enteringFirstName
    ]);
    /** Step 2's runway: the no-plan projection over the runway horizon, whatever is switched on in step 3. */ const walkInRunway = (0, $acw62.useMemo)(()=>agedCareBaseline.runwayProjections.length ? (0, $0fe89e03b6df746e$export$464558962ff4a811)(agedCareBaseline.runwayProjections, $39641e97aa80005f$var$RUNWAY_HORIZON_YEARS) : null, [
        agedCareBaseline.runwayProjections
    ]);
    const planInBrief = (0, $acw62.useMemo)(()=>{
        const basePension = agedCareBaseline.pension;
        const baseCashFlow = agedCareBaseline.cashFlowAfterCare;
        // No baseline, no sentence. A "difference" quoted against a benchmark we could not compute
        // is the exact failure this module spent a week removing — say nothing instead.
        if (!planSummaryStrategyName || basePension == null || baseCashFlow == null) return null;
        const planLegacy = panelProjections.length > 0 ? (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(panelProjections[panelProjections.length - 1]) : null;
        const dailyDap = Number(panelCosts?.dailyAccommodationPayment) || 0;
        // The plan's own annual cashflow AFTER care fees — the level, which the In Brief now states
        // alongside the movement so "better by X" cannot be mistaken for "comfortable".
        const cashflowAfter = (panelFinancials?.cashFlow ?? 0) - (Number(panelCosts?.totalDailyCost) || 0) * 365;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77fab72f16be36e5$export$f24d825672d9bf01), {
            clauses: (0, $a258b04930632a82$export$95126b4dbebd7863)({
                roomFullyPaid: dailyDap <= 0.005,
                dapAnnual: dailyDap * 365,
                careAnnual: (Number(panelCosts?.totalDailyCost) || 0) * 365,
                pensionDelta: (panelFinancials?.socialSecurity ?? 0) - basePension,
                cashflowDelta: cashflowAfter - baseCashFlow,
                cashflowAfter: cashflowAfter,
                legacyDelta: planLegacy != null && agedCareBaseline.legacyValue != null ? planLegacy - agedCareBaseline.legacyValue : null,
                legacyYears: Number(localLegacyYears) || 0
            })
        });
    }, [
        planSummaryStrategyName,
        agedCareBaseline,
        panelProjections,
        panelCosts,
        panelFinancials,
        localLegacyYears
    ]);
    /*
     * WIDTH AND BREAKPOINT (owner-reported 2026-08-26: "when the screen resolution is set to 100%
     * some fields dont work well").
     *
     * The old pair was `max-w-7xl` (1280px) with the two-pane split on `xl:` — which is ALSO 1280px.
     * So the second column appeared at exactly the width the container stopped growing, and it
     * appeared far too early: at a 1280px viewport the sidebar (256px) and page padding (64px) take
     * 320px before the grid sees anything, leaving 960px. Split two-thirds, that is a 619px working
     * column, which is what was squeezing the inputs.
     *
     * The fix is NOT to delay the split — that was the first attempt, and owner screenshots killed
     * it: a 1920 screen at 100% zoom is about a 1330px viewport, so a 2xl (1536px) split meant the
     * plan summary simply never appeared at the resolution the product is actually used at. It only
     * returned at 75% zoom. Withholding the panel from everyone at 100% is a worse bug than the one
     * being fixed.
     *
     * So the split stays at `xl:` and the fix goes where the problem actually was — the grids INSIDE
     * each pane, which now wait for `2xl:` before subdividing. The panes and their contents move on
     * different breakpoints on purpose:
     *
     *   xl  (1280px+) two panes, 60/40 rather than 67/33 — the right pane carries the plan summary.
     *   2xl (1536px+) the panes are finally wide enough for their grids to go multi-column.
     *
     * Between the two, every field simply runs the full width of its pane, which always reads well.
     * The container also runs to 1520px so a 1920 screen is used rather than letterboxed at 1280.
     */ return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-[1520px] mx-auto",
        children: [
            showManualRisks && (()=>{
                // The plan built by hand, read the way the tested plans' risks are (riskKindsFromAgedCareStrategy): the share
                // of the room paid up front, the home kept, let or sold, a guaranteed income, debts paid off.
                const pct = Number(radInput) > 0 ? Math.round((Number(radPaid) || 0) / Number(radInput) * 100) : 0;
                const kinds = (0, $203e38d6e6c434f4$export$ebadbd3592b8b5e6)({
                    name: `Pay ${pct}% RAD`,
                    meansTestStrategy: otherStrategies.annuity ? {
                        type: 'annuity'
                    } : null,
                    strategyOptions: {
                        rentHome: !!overallStrategy.rentHome,
                        downsizeHome: !!overallStrategy.downsizeHome,
                        debtPayoff: debtPayoffPlan || undefined
                    }
                });
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5757b380cc124794$export$2e2bcd8739ae039), {
                    strategyName: planSummaryStrategyName || 'Your plan',
                    voice: (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind),
                    onClose: ()=>setShowManualRisks(false),
                    risks: (0, $203e38d6e6c434f4$export$124603ee0434ece5)(kinds)
                });
            })(),
            showPlanExplanation && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $12084f898a868747$export$2e2bcd8739ae039), {
                eyebrow: "Explain this",
                title: planSummaryStrategyName || 'Your plan',
                intro: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Each line says what you do, and what that does to the numbers. ",
                        (0, $1a5a24a0286ded56$export$6ad898e84f176684).sentence
                    ]
                }),
                onClose: ()=>setShowPlanExplanation(false),
                footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                    variant: "secondary",
                    size: "sm",
                    onClick: ()=>{
                        setShowPlanExplanation(false);
                        setShowProjections(true);
                    },
                    children: "See the year-by-year figures"
                }),
                children: [
                    planRecapNode,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe4e1ee5e30419ba$export$2e2bcd8739ae039), {
                        factFind: factFind,
                        clearedAmount: Object.values(debtPayoffPlan?.payments || {}).reduce((t, x)=>t + (Number(x) || 0), 0),
                        years: legacyYears,
                        context: strategyMode === 'optimised' ? 'chosen' : 'manual'
                    }),
                    overallStrategy.rentHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a8295193c5be8a0$export$2e2bcd8739ae039), {
                        horizonYears: Number(legacyYears) || 5,
                        they: (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind).they
                    })
                ]
            }),
            showProjections && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9847d752f8df838f$export$2e2bcd8739ae039), {
                onClose: ()=>{
                    setShowProjections(false);
                    setProjectionsSource('plan');
                },
                // The plan's plain name (25 Oct 2026); the comparison's own name for the walk-in position.
                title: projectionsSource === 'walkIn' ? "Paying daily \u2014 nothing up front, nothing sold" : planSummaryStrategyName || 'The plan you built',
                comparedOverYears: Number(localLegacyYears) || undefined,
                // Until the calendar-year run lands the financial-year rows stay on screen, under
                // the modal's hourglass, rather than the charts and table emptying out.
                projections: projectionsSource === 'walkIn' ? agedCareBaseline.projections : modalPeriodMode === 'calendar_year' && calendarYearProjections ? calendarYearProjections : projections,
                onPeriodModeChange: setModalPeriodMode,
                isReloading: projectionsSource === 'plan' && modalPeriodMode === 'calendar_year' && !calendarYearProjections,
                agedCareCosts: projectionsSource === 'walkIn' ? agedCareBaseline.agedCareCosts ?? agedCareCosts : agedCareCosts,
                strategy: {
                    radAmount: projectionsSource === 'walkIn' ? 0 : radPaid
                },
                factFind: projectionsSource === 'walkIn' ? factFind : simulatedFactFind,
                initialFinancials: initialFinancials,
                currentFinancials: projectionsSource === 'walkIn' ? agedCareBaseline.financials ?? simulatedFinancials : simulatedFinancials
            }),
            showFacilitySearch && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5aa88897538e91ba$export$2e2bcd8739ae039), {
                facilities: mockFacilities,
                onSelect: (facility)=>{
                    if (facilityTarget === 'second') {
                        setSelectedSecondFacility(facility);
                        setSecondRoom((r)=>({
                                ...r,
                                roomPrice: facility.radPrice
                            }));
                    } else {
                        setSelectedFacility(facility);
                        setRadInput(facility.radPrice);
                    }
                    setShowFacilitySearch(false);
                },
                onClose: ()=>setShowFacilitySearch(false)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mb-2 text-[13px] text-slate-500",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setActivePage('Dashboard'),
                        className: "underline decoration-dotted underline-offset-2 hover:text-slate-800",
                        children: "Home"
                    }),
                    " \u203A ",
                    onBackToPlan ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onBackToPlan,
                        className: "underline decoration-dotted underline-offset-2 hover:text-slate-800",
                        children: "Aged care"
                    }) : 'Aged care',
                    " \u203A ",
                    step === 1 ? 'What the room costs' : step === 2 ? `What it means for ${enteringFirstName}` : 'Ways to pay for it'
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "mb-2 text-[32px] font-bold leading-tight tracking-tight text-brand-navy",
                children: isMover ? `${enteringFirstName}'s move to a new home` : `Paying for ${enteringFirstName}'s care`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-lg text-gray-600 max-w-4xl",
                children: isMover ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Three short steps: what the new home costs, what the move means for ",
                        enteringFirstName,
                        ", and the ways to pay for it."
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Three short steps: what the room costs, what it means for ",
                        enteringFirstName,
                        ", and the ways to pay for it."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dfd0dc18d9f6ba43$export$2e2bcd8739ae039), {
                step: step,
                onStep: goToStep,
                clientName: enteringFirstName,
                moving: isMover
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: step === 3 && railShown ? 'mt-8 grid grid-cols-1 xl:grid-cols-5 gap-8 items-start' : 'mt-8',
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: step === 3 && railShown ? 'xl:col-span-3 space-y-6' : 'space-y-6',
                        children: [
                            step === 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    !isMover && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e08c2354759a67b1$export$2e2bcd8739ae039), {
                                        oldRules: coveredByNoWorseOff && !optInToNovember2025Fees,
                                        onReadGuide: onBack
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                                        children: [
                                            currentHomeFacts && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mb-5 rounded-xl border border-slate-200 border-l-4 border-l-slate-500 bg-slate-50/70 p-4",
                                                "data-testid": "current-home",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-[11px] font-bold uppercase tracking-[0.1em] text-slate-500",
                                                        children: [
                                                            "Where ",
                                                            currentHomeFacts.name,
                                                            " is now"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "mt-1 text-sm leading-relaxed text-slate-700",
                                                        children: (0, $b073c6d711dafa37$export$acc51e3093881ff8)(currentHomeFacts)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "mt-1 text-xs text-slate-500",
                                                        children: "These details come from the Client Profile (Living Arrangements). Change them there if they are not right."
                                                    })
                                                ]
                                            }),
                                            villageFacts && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mb-5 rounded-xl border border-slate-200 border-l-4 border-l-slate-500 bg-slate-50/70 p-4",
                                                "data-testid": "village-now",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-[11px] font-bold uppercase tracking-[0.1em] text-slate-500",
                                                        children: [
                                                            "Where ",
                                                            villageFacts.name,
                                                            " is now"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "mt-1 text-sm leading-relaxed text-slate-700",
                                                        children: (0, $511dfa7ed5ad5c31$export$a942ace38e89697f)(villageFacts)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "mt-1 text-xs text-slate-500",
                                                        children: "The village's terms come from the Client Profile (Living Arrangements). Change them there if they are not right."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-xl font-bold text-gray-800 mb-1",
                                                children: isMover ? 'The new home' : 'The room'
                                            }),
                                            !isMover && !bothEntering && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mb-4 text-sm text-slate-600",
                                                children: "Enter the price the home quoted, and the home's name so you can tell the plans apart later. How much of the price is paid up front, and how much daily, is worked out in step 3."
                                            }),
                                            (isMover || bothEntering) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "mb-3"
                                            }),
                                            !isMover && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mb-5 space-y-2 2xl:max-w-[calc(50%-0.75rem)]",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        htmlFor: "home-name",
                                                        className: "block text-sm font-medium text-gray-700",
                                                        children: "Home"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "text",
                                                        id: "home-name",
                                                        value: homeName || selectedFacility?.name || '',
                                                        onChange: (e)=>setHomeName(e.target.value),
                                                        placeholder: "e.g. Lakeside Gardens",
                                                        className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs text-slate-500",
                                                        children: "Shown on the saved plan and the advice document. Leave it blank and the plan is named by its room price."
                                                    })
                                                ]
                                            }),
                                            bothEntering ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "mb-4 text-sm leading-relaxed text-slate-600",
                                                        "data-testid": "both-rooms-intro",
                                                        children: "Both of you are moving into care, so each of you has a room of your own, with its own price and fees. Centrelink assesses you as a couple living apart, each at the single pension rate. How much of each room is paid up front is worked out in step 3 \u2014 the same share for both rooms."
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "space-y-6",
                                                        children: [
                                                            'client',
                                                            'partner'
                                                        ].map((person)=>{
                                                            const slot = person === leadPerson ? 'first' : 'second';
                                                            const name = (person === 'client' ? factFind.client?.firstName : factFind.partner?.firstName) || (person === 'client' ? 'the client' : 'their partner');
                                                            const subtitle = !secondEntersLater ? "Both move in together \u2014 give one of you a later start date if they move in later." : slot === 'first' ? 'Moves in first.' : `Moves in from ${phaseNames.fromLabel}.`;
                                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "rounded-xl border border-slate-200 border-l-4 border-l-blue-600 bg-white p-4",
                                                                "data-testid": `room-${person}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                                        className: "text-base font-bold text-gray-800",
                                                                        children: [
                                                                            name,
                                                                            "'s room"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        className: "mb-4 text-xs text-slate-500",
                                                                        children: subtitle
                                                                    }),
                                                                    slot === 'first' ? firstRoomInputs : secondRoomInputs
                                                                ]
                                                            }, person);
                                                        })
                                                    })
                                                ]
                                            }) : firstRoomInputs,
                                            (radInput > 0 || coveredByNoWorseOff) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mt-6 grid grid-cols-1 2xl:grid-cols-2 gap-6",
                                                children: [
                                                    radInput > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "space-y-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                htmlFor: "rad-drawdown",
                                                                className: "block text-sm font-medium text-gray-700 mb-1",
                                                                children: [
                                                                    bothEntering ? 'Can the homes take their fees out of your deposits?' : 'Can the home take its fees out of your deposit?',
                                                                    ' ',
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($39641e97aa80005f$var$WhatsThis, {
                                                                        text: "When you pay a refundable deposit (RAD), the aged-care home holds that money and refunds it when you leave. Instead of paying every fee out of your bank account, you can ask the home to take some fees out of the deposit. The home must allow this for the daily accommodation payment, and most homes will agree to it for the other fees too if you ask in writing. Each dollar taken out slightly reduces your refund and slightly increases the daily accommodation payment, because the home is now holding less of your money. This only matters once your savings run low \u2014 until then, fees are paid from cashflow as normal."
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                                id: "rad-drawdown",
                                                                name: "radDrawdown",
                                                                value: radDrawdown,
                                                                onChange: (e)=>setRadDrawdown(e.target.value),
                                                                className: "w-full px-3 py-2 border border-gray-300 rounded-lg bg-white",
                                                                children: $39641e97aa80005f$var$RAD_DRAWDOWN_OPTIONS.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: opt.value,
                                                                        children: opt.label
                                                                    }, opt.value))
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-xs text-slate-500",
                                                                children: radDrawdown === 'none' ? 'Once savings run low the plan borrows against the home instead of drawing on the deposit.' : radDrawdown === 'dap' ? 'Only the daily accommodation payment is drawn from the deposit; other fees come from savings, then the home.' : 'Once savings run low, care fees are drawn from the deposit before the plan borrows against the home.'
                                                            })
                                                        ]
                                                    }),
                                                    coveredByNoWorseOff && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "space-y-2",
                                                        "data-testid": "fee-arrangements-choice",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                htmlFor: "fee-arrangements",
                                                                className: "block text-sm font-medium text-gray-700 mb-1",
                                                                children: [
                                                                    "Which fee rules apply in care?",
                                                                    ' ',
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($39641e97aa80005f$var$WhatsThis, {
                                                                        text: "Because a Home Care Package was in place (or approved) on 12 September 2024, the Department's 'no worse off' principle puts this person on the 1 July 2014 fee arrangements when they enter a home: a means-tested care fee instead of the hotelling and non-clinical care contributions, with an annual cap and a lifetime cap. They may opt in to the 1 November 2025 rules at any time, but cannot go back. Accommodation is on the 2025 rules either way."
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                id: "fee-arrangements",
                                                                name: "residentialFeeArrangements",
                                                                value: optInToNovember2025Fees ? '2025' : '2014',
                                                                onChange: (e)=>setOptInToNovember2025Fees(e.target.value === '2025'),
                                                                className: "w-full px-3 py-2 border border-gray-300 rounded-lg bg-white",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "2014",
                                                                        children: "Stay on the 1 July 2014 rules \u2014 means-tested care fee (no worse off)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "2025",
                                                                        children: "Opt in to the 1 November 2025 rules \u2014 hotelling and non-clinical care contributions"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-xs text-slate-500",
                                                                children: optInToNovember2025Fees ? 'Modelled as having opted in to the 1 November 2025 fee arrangements. This election cannot be reversed once made.' : 'The means-tested care fee applies, capped each year and over a lifetime. The strategies below also show what opting in would be worth.'
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                                className: "text-xl font-bold text-gray-800 mb-1",
                                                children: [
                                                    "Living costs once ",
                                                    enteringFirstName,
                                                    " is in care"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-sm text-gray-600 mb-4",
                                                children: [
                                                    "You told us the household spends ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                        children: [
                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(factFind.expenses?.livingExpenses),
                                                            " a year"
                                                        ]
                                                    }),
                                                    " now. Once ",
                                                    enteringFirstName,
                                                    " is in care that usually changes \u2014 the home covers ",
                                                    enteringFirstName,
                                                    "'s meals and bills. This figure is added to the care fees to work out what is left each year."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                label: secondEntersLater ? `Living costs a year, once ${enteringFirstName} is in care \u{2014} until ${phaseNames.fromLabel}` : `Living costs a year, once ${enteringFirstName} is in care`,
                                                name: "scenarioLivingExpenses",
                                                value: scenarioLivingExpenses,
                                                onChange: (v)=>setScenarioLivingExpenses(v ?? 0)
                                            }),
                                            secondEntersLater && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mt-4 rounded-xl border border-slate-200 border-l-4 border-l-blue-600 bg-white p-4",
                                                "data-testid": "living-phase-two",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "mb-3 text-sm leading-relaxed text-slate-600",
                                                        children: (0, $b8d3cfe4c156722e$export$53bd112132b420ae)(phaseNames)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                        label: `Annual living expenses from ${phaseNames.fromLabel}, with both in care ($)`,
                                                        name: "phaseTwoLivingExpenses",
                                                        value: phaseTwoLivingExpenses ?? scenarioLivingExpenses,
                                                        onChange: (v)=>setPhaseTwoLivingExpenses(v == null ? null : v)
                                                    }),
                                                    phaseTwoLivingExpenses != null && Math.round(phaseTwoLivingExpenses) !== Math.round(Number(scenarioLivingExpenses) || 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>setPhaseTwoLivingExpenses(null),
                                                        className: "mt-2 text-xs font-semibold text-blue-700 underline underline-offset-2 hover:text-blue-900",
                                                        children: [
                                                            "Same as before ",
                                                            phaseNames.fromLabel
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-wrap items-center justify-between gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                onClick: onBack,
                                                className: "inline-flex items-center gap-1.5 text-[13px] font-semibold text-blue-700 hover:text-blue-900",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                                        size: 15
                                                    }),
                                                    " New to aged care fees? Read the guide"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>goToStep(2),
                                                disabled: !(radInput > 0),
                                                className: "inline-flex h-11 items-center gap-2 rounded-lg bg-blue-600 px-5 text-[14px] font-semibold text-white shadow-sm hover:bg-blue-700 disabled:opacity-50",
                                                children: [
                                                    "See what this means for ",
                                                    enteringFirstName,
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                        size: 16
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            step === 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $85ecae58379d0a08$export$2e2bcd8739ae039), {
                                factFind: factFind,
                                radInput: radInput,
                                secondRoom: secondRoomActive ? {
                                    person: secondPerson,
                                    roomPrice: secondRoom.roomPrice,
                                    careStartDate: secondRoom.careStartDate || undefined,
                                    extraServiceAnnual: secondRoom.extraServiceAnnual,
                                    entersLater: secondEntersLater,
                                    ...livingOnceBoth != null ? {
                                        livingExpensesOnceBoth: livingOnceBoth
                                    } : {}
                                } : null,
                                existingStay: existingStay,
                                villageExit: villageFacts ? {
                                    entitlement: villageFacts.entitlement,
                                    refundDate: villageFacts.refundDate
                                } : null,
                                extraServiceFeeInput: extraServiceFeeInput,
                                scenarioLivingExpenses: Number(scenarioLivingExpenses) || 0,
                                agedCareBaseline: agedCareBaseline,
                                runway: walkInRunway,
                                legacyYears: Number(localLegacyYears) || 0,
                                onLegacyYearsChange: setLocalLegacyYears,
                                onBack: ()=>goToStep(1),
                                onNext: ()=>goToStep(3),
                                onReadGuide: onBack,
                                // The page is registered as 'AssumptionsPage' (App.tsx); 'Assumptions' opened "coming soon" (defect 3, 17 Oct 2026).
                                onAssumptions: ()=>setActivePage('AssumptionsPage'),
                                onShowProjections: ()=>{
                                    setProjectionsSource('walkIn');
                                    setShowProjections(true);
                                }
                            }),
                            step === 3 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    strategyMode === 'manual' && showStrategyOptions && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-card",
                                                "data-testid": "manual-control-banner",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-[14px] text-slate-700",
                                                        children: customisedFrom ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "font-semibold text-slate-900",
                                                                    children: [
                                                                        "Customising \u201C",
                                                                        customisedFrom,
                                                                        "\u201D."
                                                                    ]
                                                                }),
                                                                " Change anything; the figures on the right move as you do."
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "font-semibold text-slate-900",
                                                                    children: "Building a plan yourself."
                                                                }),
                                                                " Set what is sold and what is paid up front; the figures on the right move as you do."
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex flex-wrap items-center gap-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                onClick: ()=>onBuildYourOwn(null),
                                                                className: "text-[13px] font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                                                "data-testid": "manual-clear-start-again",
                                                                children: "Clear and start again"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                onClick: ()=>{
                                                                    setStrategyMode('optimised');
                                                                    setShowStrategyOptions(false);
                                                                    (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
                                                                },
                                                                className: "inline-flex items-center gap-1.5 text-[13px] font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                                                children: "\u2039 Back to the tested plans"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                        className: "text-xl font-bold text-gray-800 mb-4",
                                                        children: "Your home"
                                                    }),
                                                    (0, $d1b9bbc5238c0548$export$2f999b99c41ee933)($39641e97aa80005f$var$asFactFind(factFind)) || factFind.assets?.investmentProperty && factFind.assets.investmentProperty.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                                                                children: [
                                                                    (0, $d1b9bbc5238c0548$export$2f999b99c41ee933)($39641e97aa80005f$var$asFactFind(factFind)) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                                                                label: "Rent the family home",
                                                                                name: "rentHome",
                                                                                checked: overallStrategy.rentHome,
                                                                                onChange: (n, v)=>setOverallStrategy((s)=>({
                                                                                            ...s,
                                                                                            [n]: v,
                                                                                            downsizeHome: false,
                                                                                            accessHomeEquity: false,
                                                                                            reverseMortgage: false,
                                                                                            heas: false
                                                                                        }))
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                                                                label: "Sell/Downsize the family home",
                                                                                name: "downsizeHome",
                                                                                checked: overallStrategy.downsizeHome,
                                                                                onChange: (n, v)=>setOverallStrategy((s)=>({
                                                                                            ...s,
                                                                                            [n]: v,
                                                                                            rentHome: false,
                                                                                            accessHomeEquity: false,
                                                                                            reverseMortgage: false,
                                                                                            heas: false
                                                                                        }))
                                                                            })
                                                                        ]
                                                                    }),
                                                                    factFind.assets?.investmentProperty && factFind.assets.investmentProperty.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                                                        label: "Sell Investment Property",
                                                                        name: "sellInvestmentProperty",
                                                                        checked: overallStrategy.sellInvestmentProperty,
                                                                        onChange: (n, v)=>setOverallStrategy((s)=>({
                                                                                    ...s,
                                                                                    [n]: v
                                                                                }))
                                                                    })
                                                                ]
                                                            }),
                                                            (0, $d1b9bbc5238c0548$export$2f999b99c41ee933)($39641e97aa80005f$var$asFactFind(factFind)) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "border-t border-gray-200 pt-4 mt-4",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                                                                label: "Access Home Equity",
                                                                                name: "accessHomeEquity",
                                                                                checked: overallStrategy.accessHomeEquity,
                                                                                onChange: (n, v)=>setOverallStrategy((s)=>({
                                                                                            ...s,
                                                                                            [n]: v,
                                                                                            rentHome: false,
                                                                                            downsizeHome: false
                                                                                        }))
                                                                            }),
                                                                            overallStrategy.accessHomeEquity && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                className: "mt-4 ml-6 space-y-3",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                                                                        label: "Reverse Mortgage",
                                                                                        name: "reverseMortgage",
                                                                                        checked: overallStrategy.reverseMortgage,
                                                                                        onChange: (n, v)=>setOverallStrategy((s)=>({
                                                                                                    ...s,
                                                                                                    [n]: v,
                                                                                                    heas: false
                                                                                                }))
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                                                                        label: "Home Equity Access Scheme (HEAS)",
                                                                                        name: "heas",
                                                                                        checked: overallStrategy.heas,
                                                                                        onChange: (n, v)=>setOverallStrategy((s)=>({
                                                                                                    ...s,
                                                                                                    [n]: v,
                                                                                                    reverseMortgage: false
                                                                                                }))
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    (overallStrategy.reverseMortgage || overallStrategy.heas) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "mt-4 p-4 bg-white border border-slate-200 border-l-4 border-l-blue-400 rounded-r-lg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "text-sm text-gray-800 font-semibold mb-2 flex items-center gap-2",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                                                                        className: "w-4 h-4 text-blue-600"
                                                                                    }),
                                                                                    "Important Disclaimer"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                className: "text-xs text-gray-700",
                                                                                children: "This is strategic advice only - we do not endorse or recommend any reverse mortgage provider & you will need to do your own research on these providers and their product features. This calculator is for educational and illustrative purposes only and does not constitute financial product advice. You should seek independent financial advice before taking out a reverse mortgage or accessing HEAS."
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "p-4 bg-white border border-slate-200 border-l-4 border-l-amber-400 rounded text-slate-700 text-sm",
                                                        children: "Property strategies are only available if you own your home or have an investment property."
                                                    }),
                                                    overallStrategy.rentHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mt-4 p-4 bg-gray-50 rounded-lg border space-y-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                                className: "font-semibold",
                                                                children: "Rental Strategy Assumptions"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                                label: "Weekly Rent from Home ($)",
                                                                name: "rentAmount",
                                                                value: strategyInputs.rentAmount,
                                                                onChange: (v)=>setStrategyInputs((s)=>({
                                                                            ...s,
                                                                            rentAmount: v
                                                                        }))
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                                label: "Annual Expenses for Home ($)",
                                                                name: "rentExpenses",
                                                                value: strategyInputs.rentExpenses,
                                                                onChange: (v)=>setStrategyInputs((s)=>({
                                                                            ...s,
                                                                            rentExpenses: v
                                                                        }))
                                                            }),
                                                            factFind.adviceFor === 'couple' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                                label: "Partner's Weekly Rent ($)",
                                                                name: "partnerRent",
                                                                value: strategyInputs.partnerRent,
                                                                onChange: (v)=>setStrategyInputs((s)=>({
                                                                            ...s,
                                                                            partnerRent: v
                                                                        }))
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "mt-2 p-3 bg-white border border-slate-200 border-l-4 border-l-blue-400 rounded-r-lg text-sm",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                className: "text-blue-700",
                                                                                children: "For Aged Care Fees:"
                                                                            }),
                                                                            " The home's value is included in the means test, but capped at ",
                                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($39641e97aa80005f$var$AGED_CARE_HOME_EXEMPTION_CAP),
                                                                            ". The net rental income is also included."
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                        className: "mt-2",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                className: "text-blue-700",
                                                                                children: "For Age Pension:"
                                                                            }),
                                                                            " The home is exempt from the assets test for 2 years, but the net rental income is included in the income test."
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    overallStrategy.downsizeHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae9bedce5dc0c4a9$export$2e2bcd8739ae039), {
                                                                factFind: factFind,
                                                                details: downsizeDetails,
                                                                setDetails: setDownsizeDetails,
                                                                radRoomCost: radInput
                                                            }),
                                                            (()=>{
                                                                const flag = (0, $3d096644ffaac9d7$export$39ef93267b18d7d1)({
                                                                    factFind: factFind,
                                                                    sellsHome: true,
                                                                    newHomePrice: downsizeDetails?.newHomePurchasePrice
                                                                });
                                                                return flag ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                    className: "mt-2 rounded-lg border border-slate-200 border-l-4 border-l-amber-400 bg-white py-2 pl-3 pr-2 text-[13px] leading-relaxed text-slate-700",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "font-semibold",
                                                                            children: "Worth knowing:"
                                                                        }),
                                                                        " ",
                                                                        flag.warning
                                                                    ]
                                                                }) : null;
                                                            })()
                                                        ]
                                                    }),
                                                    overallStrategy.sellInvestmentProperty && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e089f32d871d5f03$export$2e2bcd8739ae039), {
                                                        factFind: factFind,
                                                        details: investmentPropertyDetails,
                                                        setDetails: setInvestmentPropertyDetails,
                                                        radRoomCost: radInput
                                                    }),
                                                    overallStrategy.reverseMortgage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61659eb07ec5d982$export$2e2bcd8739ae039), {
                                                                factFind: factFind,
                                                                details: reverseMortgageDetails,
                                                                setDetails: setReverseMortgageDetails,
                                                                legacyYears: localLegacyYears
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5251f2fd5a52d9c7$export$c1d13bc22d751693), {
                                                                loanAmount: Number(reverseMortgageDetails?.loanAmount) || 0,
                                                                interestRate: Number(reverseMortgageDetails?.interestRate) || 0,
                                                                years: Number(localLegacyYears) || 5,
                                                                useForRad: !!reverseMortgageDetails?.useForRad
                                                            })
                                                        ]
                                                    }),
                                                    overallStrategy.heas && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b4d65f6d87c2260$export$2e2bcd8739ae039), {
                                                                factFind: factFind,
                                                                details: heasDetails,
                                                                setDetails: setHeasDetails,
                                                                legacyYears: localLegacyYears
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5251f2fd5a52d9c7$export$eb9068fa2f8e69f7), {
                                                                paymentAmount: Number(heasDetails?.paymentAmount) || 0,
                                                                paymentFrequency: String(heasDetails?.paymentFrequency || 'fortnightly'),
                                                                interestRate: Number(heasDetails?.interestRate) || 0,
                                                                years: Number(localLegacyYears) || 5
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35f2741dc40fa45c$export$2e2bcd8739ae039), {
                                                factFind: factFind,
                                                debtPayments: debtPayments,
                                                setDebtPayments: setDebtPayments,
                                                debtFunding: debtFunding,
                                                setDebtFunding: setDebtFunding,
                                                repaymentBasis: debtRepaymentBasis,
                                                setRepaymentBasis: setDebtRepaymentBasis,
                                                reservedByAsset: reservedForRad,
                                                reservedFor: "the accommodation deposit"
                                            }),
                                            roomCoveredByStrategies && !showFundingAnyway ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-start justify-between gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                    className: "text-xl font-bold text-gray-800",
                                                                    children: bothEntering ? `Paying for ${firstName}'s room` : isMover ? 'Paying for the new room' : 'Paying for the room'
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "mt-1 text-sm leading-relaxed text-slate-600",
                                                                    children: isMover && currentHomeFacts ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                        children: [
                                                                            "Fully covered \u2014 the ",
                                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(currentHomeFacts.refundToday)),
                                                                            " refund of the current deposit",
                                                                            radPaidBreakdown.fromStrategies - radPaidBreakdown.fromRefund > 0.5 ? ' and the strategy above' : '',
                                                                            " already ",
                                                                            radPaidBreakdown.fromStrategies - radPaidBreakdown.fromRefund > 0.5 ? 'pay' : 'pays',
                                                                            " the whole ",
                                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(radInput),
                                                                            " room price, so nothing needs to come from savings."
                                                                        ]
                                                                    }) : villageFacts && villageInterim && radPaidBreakdown.fromVillage > 0.5 && radPaidBreakdown.fromStrategies - radPaidBreakdown.fromVillage < 0.5 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        "data-testid": "village-covered",
                                                                        children: (0, $511dfa7ed5ad5c31$export$482a9965b8c56d4f)(villageFacts, radPaidBreakdown.fromVillage, villageInterim, radInput, villagePaidAtMove)
                                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                        children: [
                                                                            "Fully covered \u2014 the strategy above already pays the whole",
                                                                            ' ',
                                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(radInput),
                                                                            " room price, so nothing needs to come from savings."
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>setShowFundingAnyway(true),
                                                            className: "shrink-0 text-sm font-semibold text-blue-700 underline underline-offset-2 hover:text-blue-900",
                                                            children: "Pay part from savings instead"
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                                                children: [
                                                    isMover && currentHomeFacts && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "mb-4 rounded-lg border border-slate-200 border-l-4 border-l-blue-600 bg-white px-3 py-2 text-sm leading-relaxed text-slate-700",
                                                        "data-testid": "refund-first",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "The current deposit comes back first."
                                                            }),
                                                            " ",
                                                            (0, $b073c6d711dafa37$export$e2520199cd7ec4c6)(currentHomeFacts)
                                                        ]
                                                    }),
                                                    villageFacts && villageInterim && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mb-4 rounded-lg border border-slate-200 border-l-4 border-l-blue-600 bg-white px-3 py-2 text-sm leading-relaxed text-slate-700",
                                                        "data-testid": "village-refund",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "mb-2",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "When will the unit be paid out?"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "mb-2 flex flex-wrap gap-2",
                                                                role: "radiogroup",
                                                                "aria-label": "When the unit is paid out",
                                                                "data-testid": "village-paid-when",
                                                                children: [
                                                                    [
                                                                        'later',
                                                                        `Later \u{2014} up to ${villageExit?.refundMonths ?? 12} months after leaving`
                                                                    ],
                                                                    [
                                                                        'move',
                                                                        'At the move'
                                                                    ]
                                                                ].map(([id, label])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        role: "radio",
                                                                        "aria-checked": villagePaidAtMove === (id === 'move'),
                                                                        onClick: ()=>setVillagePaidAtMove(id === 'move'),
                                                                        className: `rounded-lg border px-3 py-1.5 text-xs font-semibold ${villagePaidAtMove === (id === 'move') ? 'border-blue-600 bg-blue-50 text-blue-800' : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300'}`,
                                                                        children: label
                                                                    }, id))
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                children: [
                                                                    villagePaidAtMove ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: "The village money is paid at the move."
                                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: "The village money comes later."
                                                                    }),
                                                                    " ",
                                                                    (0, $511dfa7ed5ad5c31$export$67cce8e1892a5f73)(villageFacts, radPaidBreakdown.fromVillage, villageInterim, useVillageRefundForRoom, villagePaidAtMove),
                                                                    !villagePaidAtMove && villageFees && villageFees.total > 0.5 ? ` ${(0, $511dfa7ed5ad5c31$export$eabd2e17c6ad2b74)(villageFees)}` : '',
                                                                    villagePaidAtMove ? '' : ` ${(0, $511dfa7ed5ad5c31$export$ae142e1c7d0c747a)({
                                                                        refundMonths: villageFacts.refundMonths,
                                                                        interim: villageInterim,
                                                                        feesAfterLeaving: villageFees
                                                                    })}`
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                className: "mt-2 flex items-center gap-2 text-xs text-slate-600",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        type: "checkbox",
                                                                        checked: useVillageRefundForRoom,
                                                                        onChange: (e)=>setUseVillageRefundForRoom(e.target.checked)
                                                                    }),
                                                                    "Use the village's exit payment to pay the rest of the room when it arrives"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c71e058b0c397b$export$2e2bcd8739ae039), {
                                                        saleTimingSlot: saleTimingSlot,
                                                        factFind: factFind,
                                                        radPaid: radPaid,
                                                        radInput: radInput,
                                                        radFunding: radFunding,
                                                        setRadFunding: setRadFunding,
                                                        cgtOverrides: cgtOverrides,
                                                        setCgtOverrides: setCgtOverrides,
                                                        strategyMode: strategyMode,
                                                        reservedByAsset: reservedForDebt
                                                    }),
                                                    secondRoomActive && secondFunding && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "mt-4 rounded-lg border border-slate-200 border-l-4 border-l-blue-600 bg-white px-3 py-2 text-sm leading-relaxed text-slate-700",
                                                        "data-testid": "second-room-share",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                children: [
                                                                    secondName,
                                                                    "'s room follows the same share."
                                                                ]
                                                            }),
                                                            " ",
                                                            radInput > 0 ? Math.round(Math.min(1, radPaid / radInput) * 100) : 0,
                                                            "% of it is paid up front \u2014 ",
                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(secondFunding.funded),
                                                            " \u2014 taken from what is left after ",
                                                            firstName,
                                                            "'s deposit (the bank first, then term deposits, pension accounts and shares), so the same money cannot pay for both rooms.",
                                                            ' ',
                                                            secondFunding.shortfall > 0.5 ? `Only ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(secondFunding.funded)} can be raised; the rest of ${secondName}'s room is paid daily.` : `The rest of ${secondName}'s room is paid daily.`
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        onClick: ()=>setShowOtherStrategies(!showOtherStrategies),
                                                        className: "w-full flex items-center justify-between text-left",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                className: "text-xl font-bold text-gray-800",
                                                                children: "Other options"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                                className: `w-5 h-5 text-gray-400 transition-transform ${showOtherStrategies ? 'rotate-180' : ''}`
                                                            })
                                                        ]
                                                    }),
                                                    showOtherStrategies && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mt-4 space-y-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-sm text-gray-600 mb-4",
                                                                children: "Optional strategies to reduce ongoing costs and boost Age Pension. These work alongside your RAD funding strategy above."
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                                                        label: "Gifting to Family",
                                                                        name: "gifting",
                                                                        checked: otherStrategies.gifting,
                                                                        onChange: (n, v)=>setOtherStrategies((s)=>({
                                                                                    ...s,
                                                                                    [n]: v
                                                                                }))
                                                                    }),
                                                                    (()=>{
                                                                        const hasFuneralBonds = factFind.assets?.funeralBonds && factFind.assets.funeralBonds.length > 0 && factFind.assets.funeralBonds.some((fb)=>parseFloat(String(fb.value || 0)) > 0);
                                                                        if (hasFuneralBonds) return null;
                                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                                                            label: "Funeral Bonds",
                                                                            name: "funeralBonds",
                                                                            checked: otherStrategies.funeralBonds,
                                                                            onChange: (n, v)=>setOtherStrategies((s)=>({
                                                                                        ...s,
                                                                                        [n]: v
                                                                                    }))
                                                                        });
                                                                    })()
                                                                ]
                                                            }),
                                                            otherStrategies.gifting && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "mt-4 p-4 bg-gray-50 rounded-lg border space-y-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                                        className: "font-semibold",
                                                                        children: "Gifting Strategy Details"
                                                                    }),
                                                                    (()=>{
                                                                        const giftsHistory = factFind.giftsHistory || {};
                                                                        if (!giftsHistory.hasGifted) return null;
                                                                        let totalGifted = 0;
                                                                        Object.keys(giftsHistory).forEach((key)=>{
                                                                            if (key.startsWith('year')) totalGifted += parseFloat(String(giftsHistory[key] || 0)) || 0;
                                                                        });
                                                                        const asOf = new Date();
                                                                        // The draft giftsHistory bag is structurally compatible with FactFindGiftsHistory
                                                                        // (see types/formDraft.ts); calculateDeprivedAssets defensively parses internally
                                                                        // regardless, so this cast is safe.
                                                                        const giftsHistoryForCalc = giftsHistory;
                                                                        const historicalDeprived = (0, $171a6d8ba8937a5f$export$6f9e3cf7d82eb9f9)(giftsHistoryForCalc, {}, asOf);
                                                                        const planAmt = parseFloat(String(otherStrategies.giftingAmount)) || 0;
                                                                        const provisionalDeprived = planAmt > 0 ? (0, $171a6d8ba8937a5f$export$6f9e3cf7d82eb9f9)(giftsHistoryForCalc, {
                                                                            otherStrategies: {
                                                                                gifting: true,
                                                                                giftingAmount: planAmt
                                                                            }
                                                                        }, asOf) : historicalDeprived;
                                                                        const incrementalDeprived = Math.max(0, provisionalDeprived - historicalDeprived);
                                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                            className: "p-4 bg-slate-50 rounded-xl border border-slate-200 shadow-sm",
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                className: "flex items-start gap-3",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                        className: "flex-shrink-0 w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center",
                                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                                                                            className: "w-4 h-4 text-blue-600"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                        className: "flex-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                                className: "text-sm font-semibold text-gray-900 mb-2",
                                                                                                children: "Previous Gifting Detected"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                                className: "space-y-1.5 text-sm text-gray-700",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                        children: [
                                                                                                            "You entered ",
                                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                                                className: "text-gray-900",
                                                                                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(totalGifted)
                                                                                                            }),
                                                                                                            " in FY buckets (Client Profile)."
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                        children: [
                                                                                                            "Free areas used in this model: ",
                                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))
                                                                                                            }),
                                                                                                            " per financial year and ",
                                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9cd36ea38af5a5f3))
                                                                                                            }),
                                                                                                            " over any rolling five financial years (combined limits for singles and couples)."
                                                                                                        ]
                                                                                                    }),
                                                                                                    historicalDeprived > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                        className: "text-sm text-gray-800 font-medium mt-2 pt-2 border-t border-blue-200",
                                                                                                        children: [
                                                                                                            "About ",
                                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(historicalDeprived)
                                                                                                            }),
                                                                                                            " is included as deprived assets in the pension estimate (asset test / deeming)."
                                                                                                        ]
                                                                                                    }),
                                                                                                    incrementalDeprived > 0 && planAmt > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                        className: "text-sm text-gray-800 font-medium mt-2 pt-2 border-t border-blue-200",
                                                                                                        children: [
                                                                                                            "If you proceed with this gift, the model adds about ",
                                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(incrementalDeprived)
                                                                                                            }),
                                                                                                            " more deprived assets for the assessment snapshot."
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        });
                                                                    })(),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "space-y-3",
                                                                        children: (()=>{
                                                                            // Build funding source options with balances - include all liquid asset types
                                                                            // NOTE: For "Other Strategies", we need to show funds BEFORE RAD allocations
                                                                            // because Other Strategies are applied BEFORE RAD in simulatedFactFind
                                                                            const buildFundingSourceOptions = ()=>{
                                                                                const options = [];
                                                                                // Get all liquid asset types from ASSET_TYPES
                                                                                const liquidAssetTypes = (0, $77d0522707ddb581$export$e18ad1b53d14ba76).filter((assetType)=>assetType.isLiquid).map((assetType)=>assetType.id);
                                                                                liquidAssetTypes.forEach((type)=>{
                                                                                    // Use original factFind (before RAD) for available funds calculation
                                                                                    // because Other Strategies are applied before RAD
                                                                                    if (factFind.assets && factFind.assets[type]) factFind.assets[type].forEach((asset, _idx)=>{
                                                                                        const assetId = `${type}-${asset.id}`;
                                                                                        // Don't subtract RAD allocations - Other Strategies are applied before RAD
                                                                                        const assetValue = parseFloat(String(asset.value || asset.balance || 0)) || 0;
                                                                                        // But we need to subtract any amounts already allocated by Other Strategies in current strategy
                                                                                        // Check if this asset was used for gifting or funeral bonds in current strategy
                                                                                        let otherStrategyAllocation = 0;
                                                                                        if (otherStrategies.gifting && otherStrategies.giftingSource === assetId) otherStrategyAllocation += parseFloat(String(Number(otherStrategies.giftingAmount) || 0));
                                                                                        if (otherStrategies.funeralBonds && otherStrategies.funeralBondSource === assetId) otherStrategyAllocation += parseFloat(String(Number(otherStrategies.funeralBondAmount) || 0));
                                                                                        const available = Math.max(0, assetValue - otherStrategyAllocation);
                                                                                        if (available > 0) {
                                                                                            const ownership = asset.ownership || 'client';
                                                                                            const ownershipLabel = ownership === 'joint' ? 'Joint' : ownership === 'partner' ? factFind?.partner?.firstName || 'Partner' : factFind?.client?.firstName || 'Client';
                                                                                            const assetName = asset.description || asset.name || (0, $77d0522707ddb581$export$e18ad1b53d14ba76).find((at)=>at.id === type)?.name || type;
                                                                                            options.push({
                                                                                                value: assetId,
                                                                                                label: `${assetName} (${ownershipLabel}) - ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(available)} available`
                                                                                            });
                                                                                        }
                                                                                    });
                                                                                });
                                                                                // If no specific assets, show generic option
                                                                                if (options.length === 0) {
                                                                                    // Calculate total available from all bank accounts (before RAD)
                                                                                    let totalBank = 0;
                                                                                    if (factFind.assets?.bankAccounts) totalBank = factFind.assets.bankAccounts.reduce((sum, acc)=>{
                                                                                        return sum + (parseFloat(String(acc.value || 0)) || 0);
                                                                                    }, 0);
                                                                                    options.push({
                                                                                        value: 'bankAccounts',
                                                                                        label: `Bank Accounts / Cash - ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(totalBank)} available`
                                                                                    });
                                                                                }
                                                                                return options;
                                                                            };
                                                                            const fundingOptions = buildFundingSourceOptions();
                                                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                                                        label: "Gifting Amount ($)",
                                                                                        name: "giftingAmount",
                                                                                        value: otherStrategies.giftingAmount,
                                                                                        onChange: (v)=>{
                                                                                            setOtherStrategies((s)=>({
                                                                                                    ...s,
                                                                                                    giftingAmount: v ?? 0
                                                                                                }));
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5251f2fd5a52d9c7$export$27d5013e22d977ca), {
                                                                                        giftingAmount: Number(otherStrategies.giftingAmount) || 0,
                                                                                        giftsHistory: factFind.giftsHistory
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                                                        label: "Funding Source",
                                                                                        name: "giftingSource",
                                                                                        value: otherStrategies.giftingSource,
                                                                                        onChange: (n, v)=>setOtherStrategies((s)=>({
                                                                                                    ...s,
                                                                                                    [n]: v
                                                                                                })),
                                                                                        children: fundingOptions.map((opt, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                                value: opt.value,
                                                                                                children: opt.label
                                                                                            }, `gifting-${opt.value}-${idx}`))
                                                                                    })
                                                                                ]
                                                                            });
                                                                        })()
                                                                    })
                                                                ]
                                                            }),
                                                            otherStrategies.funeralBonds && (()=>{
                                                                const hasFuneralBonds = factFind.assets?.funeralBonds && factFind.assets.funeralBonds.length > 0 && factFind.assets.funeralBonds.some((fb)=>parseFloat(String(fb.value || 0)) > 0);
                                                                if (hasFuneralBonds) return null;
                                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "mt-4 p-4 bg-gray-50 rounded-lg border space-y-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                                            className: "font-semibold",
                                                                            children: "Funeral Bonds Strategy Details"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                            className: "space-y-3",
                                                                            children: (()=>{
                                                                                // Build funding source options with balances - include all liquid asset types
                                                                                // NOTE: For "Other Strategies", we need to show funds BEFORE RAD allocations
                                                                                // because Other Strategies are applied BEFORE RAD in simulatedFactFind
                                                                                const buildFundingSourceOptions = ()=>{
                                                                                    const options = [];
                                                                                    // Get all liquid asset types from ASSET_TYPES
                                                                                    const liquidAssetTypes = (0, $77d0522707ddb581$export$e18ad1b53d14ba76).filter((assetType)=>assetType.isLiquid).map((assetType)=>assetType.id);
                                                                                    liquidAssetTypes.forEach((type)=>{
                                                                                        // Use original factFind (before RAD) for available funds calculation
                                                                                        // because Other Strategies are applied before RAD
                                                                                        if (factFind.assets && factFind.assets[type]) factFind.assets[type].forEach((asset, _idx)=>{
                                                                                            const assetId = `${type}-${asset.id}`;
                                                                                            // Don't subtract RAD allocations - Other Strategies are applied before RAD
                                                                                            const assetValue = parseFloat(String(asset.value || asset.balance || 0)) || 0;
                                                                                            // But we need to subtract any amounts already allocated by Other Strategies in current strategy
                                                                                            // Check if this asset was used for gifting or funeral bonds in current strategy
                                                                                            let otherStrategyAllocation = 0;
                                                                                            if (otherStrategies.gifting && otherStrategies.giftingSource === assetId) otherStrategyAllocation += parseFloat(String(Number(otherStrategies.giftingAmount) || 0));
                                                                                            if (otherStrategies.funeralBonds && otherStrategies.funeralBondSource === assetId) otherStrategyAllocation += parseFloat(String(Number(otherStrategies.funeralBondAmount) || 0));
                                                                                            const available = Math.max(0, assetValue - otherStrategyAllocation);
                                                                                            if (available > 0) {
                                                                                                const ownership = asset.ownership || 'client';
                                                                                                const ownershipLabel = ownership === 'joint' ? 'Joint' : ownership === 'partner' ? factFind?.partner?.firstName || 'Partner' : factFind?.client?.firstName || 'Client';
                                                                                                const assetName = asset.description || asset.name || (0, $77d0522707ddb581$export$e18ad1b53d14ba76).find((at)=>at.id === type)?.name || type;
                                                                                                options.push({
                                                                                                    value: assetId,
                                                                                                    label: `${assetName} (${ownershipLabel}) - ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(available)} available`
                                                                                                });
                                                                                            }
                                                                                        });
                                                                                    });
                                                                                    // If no specific assets, show generic option
                                                                                    if (options.length === 0) {
                                                                                        // Calculate total available from all bank accounts (before RAD)
                                                                                        let totalBank = 0;
                                                                                        if (factFind.assets?.bankAccounts) totalBank = factFind.assets.bankAccounts.reduce((sum, acc)=>{
                                                                                            return sum + (parseFloat(String(acc.value || 0)) || 0);
                                                                                        }, 0);
                                                                                        options.push({
                                                                                            value: 'bankAccounts',
                                                                                            label: `Bank Accounts / Cash - ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(totalBank)} available`
                                                                                        });
                                                                                    }
                                                                                    return options;
                                                                                };
                                                                                const fundingOptions = buildFundingSourceOptions();
                                                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                                                            label: "Funeral Bond Amount ($)",
                                                                                            name: "funeralBondAmount",
                                                                                            value: otherStrategies.funeralBondAmount,
                                                                                            onChange: (v)=>{
                                                                                                setOtherStrategies((s)=>({
                                                                                                        ...s,
                                                                                                        funeralBondAmount: v ?? 0
                                                                                                    }));
                                                                                            }
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5251f2fd5a52d9c7$export$5eceda842173bd5), {
                                                                                            amount: Number(otherStrategies.funeralBondAmount) || 0,
                                                                                            isCouple: factFind.adviceFor === 'couple'
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                                                            label: "Funding Source",
                                                                                            name: "funeralBondSource",
                                                                                            value: otherStrategies.funeralBondSource,
                                                                                            onChange: (n, v)=>setOtherStrategies((s)=>({
                                                                                                        ...s,
                                                                                                        [n]: v
                                                                                                    })),
                                                                                            children: fundingOptions.map((opt, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                                    value: opt.value,
                                                                                                    children: opt.label
                                                                                                }, `funeral-${opt.value}-${idx}`))
                                                                                        })
                                                                                    ]
                                                                                });
                                                                            })()
                                                                        })
                                                                    ]
                                                                });
                                                            })(),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "flex items-center gap-2",
                                                                    children: [
                                                                        "Lifetime Annuity",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                                                            className: "w-4 h-4 text-amber-600"
                                                                        })
                                                                    ]
                                                                }),
                                                                name: "annuity",
                                                                checked: otherStrategies.annuity,
                                                                onChange: (n, v)=>{
                                                                    setOtherStrategies((s)=>({
                                                                            ...s,
                                                                            [n]: v
                                                                        }));
                                                                    if (v && !annuityRecord) // Initialize annuity when checked
                                                                    setAnnuityRecord(initializeAnnuityRecord());
                                                                    else if (!v) // Clear annuity when unchecked
                                                                    setAnnuityRecord(null);
                                                                }
                                                            }),
                                                            otherStrategies.annuity && annuityRecord && (()=>{
                                                                const flag = (0, $3d096644ffaac9d7$export$2a10947020c112ea)({
                                                                    factFind: factFind,
                                                                    residualCapital: annuityRecord.residualCapital,
                                                                    owner: annuityRecord.owner,
                                                                    annuityType: annuityRecord.annuityType,
                                                                    indexation: annuityRecord.indexation
                                                                });
                                                                return flag ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                    className: "mt-2 rounded-lg border border-slate-200 border-l-4 border-l-amber-400 bg-white py-2 pl-3 pr-2 text-[13px] leading-relaxed text-slate-700",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "font-semibold",
                                                                            children: "Worth knowing:"
                                                                        }),
                                                                        " ",
                                                                        flag.warning
                                                                    ]
                                                                }) : null;
                                                            })(),
                                                            otherStrategies.annuity && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "mt-4 p-4 bg-slate-50 rounded-lg border border-slate-200 space-y-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                                        className: "font-semibold",
                                                                        children: "Annuity Strategy Details"
                                                                    }),
                                                                    annuityRecord ? (()=>{
                                                                        const isCouple = factFind?.adviceFor === 'couple';
                                                                        const clientName = factFind?.client?.firstName || 'Client';
                                                                        const partnerName = factFind?.partner?.firstName || 'Partner';
                                                                        const ownershipLabel = (ownership)=>{
                                                                            if (!ownership) return '';
                                                                            if (ownership === 'joint') return 'Joint';
                                                                            if (ownership === 'partner') return partnerName;
                                                                            return clientName;
                                                                        };
                                                                        const fundingSources = [];
                                                                        // Get all liquid asset types from ASSET_TYPES
                                                                        const liquidAssetTypes = (0, $77d0522707ddb581$export$e18ad1b53d14ba76).filter((assetType)=>assetType.isLiquid).map((assetType)=>assetType.id);
                                                                        liquidAssetTypes.forEach((assetType)=>{
                                                                            if (simulatedFactFind.assets && simulatedFactFind.assets[assetType]) simulatedFactFind.assets[assetType].forEach((asset)=>{
                                                                                const assetId = `${assetType}-${asset.id}`;
                                                                                const radAllocated = radFunding[assetId] || 0;
                                                                                const assetValue = parseFloat(String(asset.value || asset.balance || 0)) || 0;
                                                                                /*
                                                                 * Offer back what THIS annuity has already taken from this asset.
                                                                 * The question is "what could the annuity be bought with", and the
                                                                 * money it is already using is part of the answer. Read from the
                                                                 * simulation rather than re-derived, so the two cannot disagree
                                                                 * (owner-caught, 25 Sep 2026: entering an amount made the proceeds
                                                                 * row vanish and the bank row collapse).
                                                                 */ const drawnByThisAnnuity = annuityDrawnFrom[assetId] || 0;
                                                                                const available = (0, $f7f7b62814c3b615$export$c21193cd9e9c34e8)(assetValue, drawnByThisAnnuity, radAllocated);
                                                                                if (available > 0) {
                                                                                    const ownership = asset.ownership || 'client';
                                                                                    const assetName = asset.description || asset.name || (0, $77d0522707ddb581$export$e18ad1b53d14ba76).find((at)=>at.id === assetType)?.name || assetType;
                                                                                    // Map asset type for annuity configurator (it expects 'bank' not 'bankAccounts')
                                                                                    const mappedType = assetType === 'bankAccounts' ? 'bank' : assetType;
                                                                                    fundingSources.push({
                                                                                        id: assetId,
                                                                                        type: mappedType,
                                                                                        assetId: asset.id,
                                                                                        label: `${assetName} (${ownershipLabel(ownership)}) - ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(available)} available`,
                                                                                        ownership: ownership,
                                                                                        available: available
                                                                                    });
                                                                                }
                                                                            });
                                                                        });
                                                                        // Default to bank if no sources
                                                                        if (fundingSources.length === 0) fundingSources.push({
                                                                            id: 'bank-default',
                                                                            type: 'bank',
                                                                            assetId: null,
                                                                            label: 'Bank accounts / cash',
                                                                            ownership: isCouple ? 'joint' : 'client',
                                                                            available: 0
                                                                        });
                                                                        // Calculate annuity impact for summary display
                                                                        const annuityRecordForCalculation = (()=>{
                                                                            try {
                                                                                if (!annuityRecord || !annuityRecord.purchaseAmount || Number(annuityRecord.purchaseAmount) <= 0) return null;
                                                                                return (0, $f7f7b62814c3b615$export$fb67395f10ad20c9)($39641e97aa80005f$var$asFactFind(factFind), annuityRecord);
                                                                            } catch (error) {
                                                                                console.error('Error building annuity impact', error);
                                                                                return null;
                                                                            }
                                                                        })();
                                                                        // Calculate annuity summary for display
                                                                        const annuitySummary = annuityRecordForCalculation ? (0, $f7f7b62814c3b615$export$fc6c67b5fdf45998)(annuityRecordForCalculation) : null;
                                                                        // Calculate annuity warnings
                                                                        const annuityWarnings = (()=>{
                                                                            if (!annuityRecord || !annuityRecord.purchaseAmount || Number(annuityRecord.purchaseAmount) <= 0) return [];
                                                                            const warnings = [];
                                                                            // Add any specific warnings here if needed
                                                                            return warnings;
                                                                        })();
                                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a72ca5744dce23c$export$2e2bcd8739ae039), {
                                                                                    factFind: simulatedFactFind,
                                                                                    // AnnuityRecordState (this file) is a superset of AnnuityDetails (extra bookkeeping
                                                                                    // fields: id, age, fundingSourceType/Id) — safe structural cast both ways.
                                                                                    annuityDetails: annuityRecord,
                                                                                    setAnnuityDetails: setAnnuityRecord,
                                                                                    annuitySummary: annuitySummary,
                                                                                    annuityWarnings: annuityWarnings,
                                                                                    fundingSources: fundingSources,
                                                                                    formatCurrency: (0, $f94e45ac645ae232$export$3dc27271f5d5c629),
                                                                                    clientAge: factFind?.client?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client?.dob) : null,
                                                                                    partnerAge: isCouple && factFind?.partner?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner.dob) : null,
                                                                                    onIncomeOnlyUnderstoodChange: setIncomeOnlyUnderstood
                                                                                }),
                                                                                (()=>{
                                                                                    /*
                                                                 * ABOVE THE CLIENT'S CEILING, ONE PLAIN CAUTION (guaranteed income review M3,
                                                                 * 21 Oct 2026). Not a block: a hand-built plan may go further than the tested
                                                                 * ones, but the reader is told how far, against the share they allowed.
                                                                 */ const amount = Number(annuityRecord?.purchaseAmount) || 0;
                                                                                    if (!(amount > 0)) return null;
                                                                                    const depositPaid = Object.values(radFunding || {}).reduce((t, v)=>t + (Number(v) || 0), 0);
                                                                                    const emergency = Number(coupleValidation?.emergencyFund) || (0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind);
                                                                                    // The money the annuity could come from: what the plans could invest, plus what this annuity already took.
                                                                                    const investable = (0, $ef4d0d82ab48599b$export$1bb55a1f37679989)(factFind, emergency, depositPaid).investable;
                                                                                    const ceiling = (0, $ff5de4128b46b139$export$e46e91ebc7373b0a)(factFind);
                                                                                    const limit = (0, $ff5de4128b46b139$export$19a5715b59108050)(ceiling, investable);
                                                                                    if (!(investable > 0) || amount <= limit + 0.5) return null;
                                                                                    const pct = Math.round(amount / investable * 100);
                                                                                    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
                                                                                    const who = v.you ? 'what you have' : `what ${enteringFirstName || v.names} has`;
                                                                                    const suggested = ceiling.amount != null ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(ceiling.amount)) : `${ceiling.pct ?? 25}%`;
                                                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                        className: "rounded-lg border border-slate-200 border-l-4 border-l-amber-400 bg-white py-2 pl-3 pr-2 text-[13px] leading-relaxed text-slate-700",
                                                                                        "data-testid": "ac-manual-annuity-ceiling",
                                                                                        children: [
                                                                                            "This puts ",
                                                                                            Math.min(pct, 100),
                                                                                            "% of ",
                                                                                            who,
                                                                                            " into a guaranteed income. We suggest no more than ",
                                                                                            suggested,
                                                                                            ", so most of the money stays within reach."
                                                                                        ]
                                                                                    });
                                                                                })(),
                                                                                (()=>{
                                                                                    // What the family receives from it at the start, middle and end (E4/M4). No comparison:
                                                                                    // a hand-built plan has no twin without the annuity.
                                                                                    const amount = Number(annuityRecord?.purchaseAmount) || 0;
                                                                                    if (!(amount > 0) || !projections.length) return null;
                                                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
                                                                                        factFind: factFind,
                                                                                        personName: enteringFirstName || (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind).names,
                                                                                        amount: amount,
                                                                                        kind: (0, $8665f80549f60a1b$export$3ab75b1250c8af22)(annuityRecord),
                                                                                        incomeAYear: Number(annuitySummary?.annualPayment) || null,
                                                                                        rows: projections,
                                                                                        horizonYears: Number(localLegacyYears) || 5,
                                                                                        testId: "ac-manual-annuity-family"
                                                                                    });
                                                                                })()
                                                                            ]
                                                                        });
                                                                    })() : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        className: "text-sm text-gray-500",
                                                                        children: "Annuity configuration not initialized."
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            savedStrategies.filter((s)=>s.type === 'aged_care').length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                        className: "text-xl font-bold text-gray-800 mb-3",
                                                        children: "Saved plans"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "space-y-3",
                                                        "data-testid": "ac-saved-plans",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "space-y-1",
                                                                children: savedStrategies.filter((s)=>s.type === 'aged_care').map((strategy)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: `flex items-center justify-between gap-3 text-[13px] rounded-lg px-3 py-2 transition-colors ${activeSavedStrategyId === strategy.id ? 'bg-white ring-2 ring-blue-500 border border-blue-500 shadow-sm' : 'border border-slate-200 text-slate-700'}`,
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                className: "text-slate-700",
                                                                                children: [
                                                                                    (0, $95e43332fd84eec4$export$6cc0d9545ae1511e)(strategy, factFind),
                                                                                    strategy.chosen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                        className: "ml-2 font-semibold text-emerald-700",
                                                                                        children: "Chosen"
                                                                                    }) : null
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                onClick: ()=>reopenStrategy(strategy),
                                                                                className: "shrink-0 text-blue-700 hover:text-blue-900 underline font-semibold",
                                                                                children: "Reopen"
                                                                            })
                                                                        ]
                                                                    }, strategy.id))
                                                            }),
                                                            savedStrategies.filter((s)=>s.type === 'aged_care').length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                onClick: ()=>setShowCompareModal(true),
                                                                className: "w-full rounded-lg border border-slate-300 bg-white px-4 py-2 font-semibold text-slate-800 hover:border-blue-300 transition-colors",
                                                                children: [
                                                                    "Compare the saved plans (",
                                                                    savedStrategies.filter((s)=>s.type === 'aged_care').length,
                                                                    ")"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    strategyMode === 'optimised' && !engineSetupDone && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62a77aaf0618af65$export$2e2bcd8739ae039), {
                                        factFind: factFind,
                                        setFactFind: setFactFind,
                                        coupleValidation: coupleValidation,
                                        setCoupleValidation: setCoupleValidation,
                                        scenarioLivingExpenses: Number(scenarioLivingExpenses) || 0,
                                        defaultPartnerRoomPrice: parseFloat(String(radInput)) || 0,
                                        roomDeposit: parseFloat(String(radInput)) || 0,
                                        legacyYears: Number(localLegacyYears) || (0, $77d0522707ddb581$export$39a105507aa40371),
                                        onLegacyYears: setLocalLegacyYears,
                                        enteringName: enteringFirstName,
                                        onDone: ()=>{
                                            setAskSetupAgain(false);
                                            setStrategyModeChosen(true);
                                            setStrategyMode('optimised');
                                            setShowStrategyOptions(false);
                                        },
                                        onBuildYourOwn: onBuildYourOwn
                                    }),
                                    strategyMode === 'optimised' && engineSetupDone && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca941a2ef5e688c5$export$2e2bcd8739ae039), {
                                                onBuildYourOwn: onBuildYourOwn,
                                                homeName: homeName || selectedFacility?.name || '',
                                                openOnArrival: reopenIntent,
                                                onOpenedOnArrival: ()=>setReopenIntent(null),
                                                factFind: factFind,
                                                setFactFind: setFactFind,
                                                agedCareCosts: suggestionEngineAgedCareCosts,
                                                goals: factFind.goals,
                                                // The SAME no-plan baseline this page's own panel measures against,
                                                // so "Explain this" on a card reconciles to the same benchmark
                                                // rather than computing a second one of its own.
                                                agedCareBaseline: agedCareBaseline,
                                                onDoNothingRow: setEngineDoNothingRow,
                                                onChosenPlanRetested: (fresh)=>{
                                                    const next = (0, $78a369bbf1e0d995$export$d5bd7fb56baea936)(savedStrategies, fresh);
                                                    if (!next) return;
                                                    setSavedStrategies(next);
                                                    try {
                                                        sessionStorage.setItem('careCompanionStrategies', JSON.stringify(next.filter((p)=>p.type === 'aged_care')));
                                                    } catch  {}
                                                },
                                                inputsSettling: engineInputsWorking,
                                                onChosenPlanMissing: ()=>{
                                                    const next = (0, $78a369bbf1e0d995$export$d20c84e2101d7d8a)(savedStrategies, 'aged_care', (0, $78a369bbf1e0d995$export$a2028cac13d6740f));
                                                    if (!next) return;
                                                    setSavedStrategies(next);
                                                    try {
                                                        sessionStorage.setItem('careCompanionStrategies', JSON.stringify(next.filter((p)=>p.type === 'aged_care')));
                                                    } catch  {}
                                                },
                                                reopenedSavedStrategyId: reopenedEngineStrategyId,
                                                selectedPlanRunwayRows: railIsWalkIn ? null : panelRunwayRows,
                                                // AgedCareSuggestionEnginePanel.tsx's own `Strategy` type (owned by a concurrent
                                                // typing pass on that file) is close to but not identical to this file's
                                                // EvaluatedStrategy (e.g. no `id`/`source` named fields — those live behind its
                                                // index signature); cast at this one boundary rather than chasing the two
                                                // shapes into exact parity.
                                                onStrategySelect: (strategy)=>{
                                                    const s = strategy;
                                                    setActiveSavedStrategyId(s.id ?? null);
                                                    (0, $acw62.startTransition)(()=>{
                                                        setSelectedStrategy(s);
                                                    });
                                                    if (s.source === 'suggestion_engine') {
                                                        // One chosen aged care plan on the file at a time (UX review, 17 Oct 2026).
                                                        const newStrategies = [
                                                            ...savedStrategies.map((p)=>p.type === 'aged_care' && p.chosen ? {
                                                                    ...p,
                                                                    chosen: false
                                                                } : p),
                                                            s
                                                        ];
                                                        setSavedStrategies(newStrategies);
                                                        try {
                                                            sessionStorage.setItem('careCompanionStrategies', JSON.stringify(newStrategies.filter((p)=>p.type === 'aged_care')));
                                                        } catch  {}
                                                    }
                                                },
                                                selectedStrategy: selectedStrategy,
                                                legacyYears: localLegacyYears,
                                                // AgedCareSuggestionEnginePanel.tsx (not yet typed — owned by a concurrent typing
                                                // pass) has no prop annotation, so TS infers this prop's shape from its own
                                                // default value literal instead of accepting the real CoupleValidationState.
                                                coupleValidation: coupleValidation,
                                                onScenarioSaved: (scenario)=>{
                                                    const scenarioWithCase = {
                                                        ...scenario,
                                                        caseId: professionalCaseId || scenario.caseId || null,
                                                        soaDeliveryStatus: scenario.soaDeliveryStatus || 'draft',
                                                        isCurrentForCase: true
                                                    };
                                                    // Add scenario to saved case studies
                                                    const newCaseStudies = [
                                                        ...savedCaseStudies.map((item)=>scenarioWithCase.caseId && item.caseId === scenarioWithCase.caseId ? {
                                                                ...item,
                                                                isCurrentForCase: false
                                                            } : item),
                                                        scenarioWithCase
                                                    ];
                                                    setSavedCaseStudies(newCaseStudies);
                                                    // Save to both keys for consistency (AgedCareSuggestionEnginePanel uses careCompanionScenarios)
                                                    sessionStorage.setItem('careCompanionCaseStudies', JSON.stringify(newCaseStudies));
                                                    sessionStorage.setItem('careCompanionScenarios', JSON.stringify(newCaseStudies));
                                                    onSoaGenerated?.(scenarioWithCase);
                                                },
                                                onNavigateToDashboard: ()=>{
                                                    setActivePage('Dashboard');
                                                },
                                                // The facts of the case every candidate is priced on — the entry
                                                // date, the deposit-drawdown choice, the fee arrangements and the
                                                // second room. Memoised: the panel re-runs its analysis on a click,
                                                // not on every render of this page.
                                                strategyOptions: suggestionEngineStrategyOptions
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    step === 3 && railShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "xl:col-span-2 space-y-3 xl:sticky xl:top-8",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "space-y-6 transition-all duration-300",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7abf945a7ae3f4e9$export$2e2bcd8739ae039), {
                                working: railWorking,
                                strategyName: planSummaryStrategyName,
                                baselineLabel: agedCareBaseline.financials ? (0, $1a5a24a0286ded56$export$6ad898e84f176684).word : undefined,
                                // Engine mode: say what the rail is and where the plan lives.
                                noStrategyHeading: railIsWalkIn ? 'Paying daily, nothing sold' : "Nothing set yet \u2014 the room paid daily",
                                noStrategyNote: railIsWalkIn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold text-slate-700",
                                            children: "For comparison"
                                        }),
                                        " while you choose. Each plan carries its own figures \u2014",
                                        ' ',
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold text-slate-700",
                                            children: "Choose"
                                        }),
                                        " one, then",
                                        ' ',
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold text-slate-700",
                                            children: "Explain this"
                                        }),
                                        " on the card."
                                    ]
                                }) : undefined,
                                inBrief: planInBrief,
                                onReadFullExplanation: planSummaryStrategyName ? ()=>setShowPlanExplanation(true) : null,
                                onWhatCouldGoWrong: planSummaryStrategyName && !railIsWalkIn ? ()=>setShowManualRisks(true) : null,
                                // Save / Choose, where the plan's figures are (owner, 25 Oct 2026). Manual Control only.
                                actions: planSummaryStrategyName && !railIsWalkIn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8605a89eee7277e8$export$2e2bcd8739ae039), {
                                    testId: "ac-manual",
                                    chosen: manualIsChosen,
                                    anotherChosen: anotherAgedCarePlanChosen,
                                    canChoose: !manualIncomeOnlyHeld,
                                    onChoose: ()=>saveStrategy(planSummaryStrategyName, {
                                            choose: true
                                        }),
                                    onSave: ()=>{
                                        saveStrategy(planSummaryStrategyName);
                                        (0, $8e1e84c918e07c84$export$5e14cdade93d6f7b)('Saved. The screen is clear for the next plan.');
                                    },
                                    beforeChoose: manualIncomeOnly && setIncomeOnlyUnderstood ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$4538b371a206da0c), {
                                        factFind: factFind,
                                        amount: Number(annuityRecord?.purchaseAmount) || 0,
                                        onChange: setIncomeOnlyUnderstood,
                                        action: "saving"
                                    }) : null,
                                    possessiveFile: (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind).possessive,
                                    onAdvice: ()=>{
                                        openManualControlDigitalSOA();
                                    }
                                }) : null,
                                onViewProjections: ()=>{
                                    setProjectionsSource(railIsWalkIn ? 'walkIn' : 'plan');
                                    setShowProjections(true);
                                },
                                liquidity: runway && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-lg font-bold leading-tight tracking-tight text-slate-900",
                                            children: runway.headline
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "mt-2",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c05f3bca3803eec$export$7fbbcd423808f3d5), {
                                                coveredPct: runway.coveredPct,
                                                leftLabel: runway.leftLabel,
                                                rightLabel: runway.rightLabel,
                                                depleted: runway.depleted,
                                                flag: railRunwayFlag ?? runway.flag
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f15268380bf00a12$export$35d5d608b1d0d7ec), {
                                            runway: runway,
                                            className: "mt-1.5"
                                        })
                                    ]
                                }),
                                costOverview: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0142643c4b04c6$export$2e2bcd8739ae039), {
                                    dailyTotal: panelCosts.totalDailyCost || 0,
                                    note: panelPhaseTwo ? (0, $b8d3cfe4c156722e$export$d1629cfae6946451)(phaseNames, panelPhaseTwoDaily) : undefined,
                                    children: panelPhaseTwo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "pt-1 text-[11px] font-bold uppercase tracking-wide text-gray-300",
                                                children: [
                                                    "Until ",
                                                    phaseNames.fromLabel,
                                                    " \u2014 ",
                                                    firstName,
                                                    "'s room, ",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(panelFirstCosts.totalDailyCost || 0),
                                                    " a day"
                                                ]
                                            }),
                                            feeRows(panelFirstCosts),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "pt-3 text-[11px] font-bold uppercase tracking-wide text-gray-300",
                                                children: [
                                                    "From ",
                                                    phaseNames.fromLabel,
                                                    " \u2014 ",
                                                    firstName,
                                                    "'s room, ",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(panelPhaseTwo.firstCosts.totalDailyCost || 0),
                                                    " a day"
                                                ]
                                            }),
                                            feeRows(panelPhaseTwo.firstCosts),
                                            panelPhaseTwo.secondCosts && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "pt-3 text-[11px] font-bold uppercase tracking-wide text-gray-300",
                                                        children: [
                                                            "From ",
                                                            phaseNames.fromLabel,
                                                            " \u2014 ",
                                                            secondName,
                                                            "'s room, ",
                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(panelPhaseTwo.secondCosts.totalDailyCost || 0),
                                                            " a day"
                                                        ]
                                                    }),
                                                    feeRows(panelPhaseTwo.secondCosts)
                                                ]
                                            })
                                        ]
                                    }) : panelSecondCosts ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "pt-1 text-[11px] font-bold uppercase tracking-wide text-gray-300",
                                                children: [
                                                    firstName,
                                                    "'s room \u2014 ",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(panelFirstCosts.totalDailyCost || 0),
                                                    " a day"
                                                ]
                                            }),
                                            feeRows(panelFirstCosts),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "pt-3 text-[11px] font-bold uppercase tracking-wide text-gray-300",
                                                children: [
                                                    secondName,
                                                    "'s room \u2014 ",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(panelSecondCosts.totalDailyCost || 0),
                                                    " a day"
                                                ]
                                            }),
                                            feeRows(panelSecondCosts)
                                        ]
                                    }) : feeRows(panelFirstCosts)
                                }),
                                financialImpact: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a47f01df2d11b1bc$export$2e2bcd8739ae039), {
                                    embedded: true,
                                    working: railWorking,
                                    baselineOnly: railIsWalkIn,
                                    // Measured against ENTERING CARE WITH NO PLAN, not against life at home:
                                    // the care is happening either way, so the panel prices the advice rather
                                    // than the diagnosis. Falls back to today's position only if the baseline
                                    // could not be computed — better a stated comparison than a wrong one.
                                    before: agedCareBaseline.financials ?? initialFinancials,
                                    // Net of the BASELINE's own care fees. Without this the tile compared a
                                    // figure gross of the DAP with one net of it — a $97,649 gap on one real
                                    // plan, and it disagreed with the summary directly below.
                                    cashFlowBeforeValue: agedCareBaseline.cashFlowAfterCare,
                                    baselineLabel: agedCareBaseline.financials ? (0, $1a5a24a0286ded56$export$6ad898e84f176684).word : undefined,
                                    // The SELECTED plan's own figures — the engine strategy's when one is
                                    // chosen, otherwise Manual Control's. Never a mix: the tiles, the cost
                                    // block and the heading all read from the same source.
                                    after: panelFinancials,
                                    legacyBaselineValue: agedCareBaseline.legacyValue,
                                    agedCareCosts: panelCosts,
                                    legacyYears: localLegacyYears,
                                    setLegacyYears: setLocalLegacyYears,
                                    radPaid: radPaid,
                                    onViewProjections: ()=>{
                                        setProjectionsSource(railIsWalkIn ? 'walkIn' : 'plan');
                                        setShowProjections(true);
                                    },
                                    projections: panelProjections
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2c0deaff316e027$export$2e2bcd8739ae039), {
                isOpen: showValidationModal,
                onClose: ()=>setShowValidationModal(false),
                coupleValidation: coupleValidation,
                setCoupleValidation: setCoupleValidation,
                factFind: factFind,
                setFactFind: setFactFind,
                scenarioLivingExpenses: scenarioLivingExpenses,
                defaultPartnerRoomPrice: parseFloat(String(radInput)) || 0,
                onValidationComplete: ()=>{
                    setStrategyModeChosen(true);
                    setStrategyMode('optimised');
                    setShowStrategyOptions(false);
                }
            }),
            showCompareModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "bg-white rounded-2xl shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-hidden flex flex-col border border-slate-200/80",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "px-6 pt-6 pb-4 border-b border-slate-100 bg-white",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-start justify-between gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                    className: "text-2xl md:text-3xl font-bold tracking-tight",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6288781efbc92679$export$2e2bcd8739ae039), {
                                                        children: "Strategy Comparison"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-sm text-slate-600 mt-1.5",
                                                    children: "Side-by-side view of saved aged care strategies (model outputs)."
                                                }),
                                                comparedBasisDifferences.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    role: "status",
                                                    className: "mt-3 border-l-4 border-amber-400 pl-3 py-1 text-sm text-slate-700",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            className: "font-semibold",
                                                            children: "Not a like-for-like comparison."
                                                        }),
                                                        ' ',
                                                        "These strategies were modelled on a different ",
                                                        comparedBasisDifferences.join(', '),
                                                        ", so the figures below are not directly comparable. Check the basis columns before drawing a conclusion."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setShowCompareModal(false),
                                            className: "shrink-0 rounded-lg p-2 text-slate-500 hover:text-slate-800 hover:bg-slate-100 transition-colors text-2xl leading-none",
                                            "aria-label": "Close",
                                            children: "\xd7"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "h-1 w-full rounded-full bg-brand-navy mt-4",
                                    "aria-hidden": true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "overflow-auto flex-1 px-6 py-5",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "rounded-xl border border-slate-200 overflow-x-auto shadow-sm",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    className: "w-full text-sm border-collapse",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "bg-slate-100 text-slate-800",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-3 py-2.5 text-left font-semibold border-b border-slate-200/90",
                                                        children: "Strategy name"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-3 py-2.5 text-right font-semibold border-b border-slate-200/90",
                                                        children: "Room price"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-3 py-2.5 text-center font-semibold border-b border-slate-200/90",
                                                        children: "Care starts"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-3 py-2.5 text-center font-semibold border-b border-slate-200/90",
                                                        children: "Projected over"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-3 py-2.5 text-right font-semibold border-b border-slate-200/90",
                                                        children: "Daily care cost"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-3 py-2.5 text-right font-semibold border-b border-slate-200/90",
                                                        children: "Age pension"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-3 py-2.5 text-right font-semibold border-b border-slate-200/90",
                                                        children: "Cash flow"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-3 py-2.5 text-right font-semibold border-b border-slate-200/90",
                                                        children: "Legacy estimate"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-3 py-2.5 text-center font-semibold border-b border-slate-200/90",
                                                        children: "Created"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                            children: [
                                                agedCareBaseline.pension != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    className: "border-b border-slate-200 bg-slate-100/70",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "px-3 py-2.5 font-semibold text-slate-800",
                                                            children: [
                                                                "Paying daily, nothing sold",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "ml-2 rounded-full bg-slate-200 px-2 py-0.5 text-[11px] font-semibold text-slate-600",
                                                                    children: "The comparison"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-3 py-2.5 text-right tabular-nums text-slate-700",
                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(radInput) || 0)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-3 py-2.5 text-center text-slate-500",
                                                            children: "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-3 py-2.5 text-center text-slate-700 whitespace-nowrap",
                                                            children: `${Number(localLegacyYears) || 0} years`
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-3 py-2.5 text-right tabular-nums text-slate-800",
                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $bdfd96a4f4ac117d$export$4a7e3987a5ffaa21)(agedCareBaseline.agedCareCosts ?? agedCareCosts, baselineSecondCosts))
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-3 py-2.5 text-right tabular-nums text-slate-800",
                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(agedCareBaseline.pension)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: `px-4 py-3 text-right tabular-nums font-medium ${(agedCareBaseline.cashFlowAfterCare ?? 0) < 0 ? 'text-rose-700' : 'text-emerald-700'}`,
                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(agedCareBaseline.cashFlowAfterCare ?? 0)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-3 py-2.5 text-right tabular-nums text-slate-800",
                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(agedCareBaseline.legacyValue ?? 0)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-3 py-2.5 text-center text-slate-500",
                                                            children: "\u2014"
                                                        })
                                                    ]
                                                }),
                                                comparedAgedCareStrategies.map((strategy, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: `border-b border-slate-100 last:border-b-0 transition-colors hover:bg-sky-50/50 ${index % 2 === 0 ? 'bg-white' : 'bg-slate-50/60'}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "px-3 py-2.5 font-medium text-slate-900",
                                                                children: strategy.name
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "px-3 py-2.5 text-right tabular-nums text-slate-700",
                                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($39641e97aa80005f$export$e92c3d4dc4ff4528(strategy).roomPrice)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "px-3 py-2.5 text-center text-slate-700 whitespace-nowrap",
                                                                children: $39641e97aa80005f$export$e92c3d4dc4ff4528(strategy).careStartDate ? new Date($39641e97aa80005f$export$e92c3d4dc4ff4528(strategy).careStartDate).toLocaleDateString('en-AU') : 'Now'
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "px-3 py-2.5 text-center text-slate-700 whitespace-nowrap",
                                                                children: $39641e97aa80005f$export$e92c3d4dc4ff4528(strategy).legacyYears ? `${$39641e97aa80005f$export$e92c3d4dc4ff4528(strategy).legacyYears} years` : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-slate-400 italic",
                                                                    children: "not recorded"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "px-3 py-2.5 text-right tabular-nums text-slate-800",
                                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((strategy.outputs?.agedCareCost || 0) / 365)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "px-3 py-2.5 text-right tabular-nums text-slate-800",
                                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(strategy.outputs?.agePension)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: `px-4 py-3 text-right tabular-nums font-medium ${$39641e97aa80005f$var$getDisplayCashFlowForSavedStrategy(strategy) < 0 ? 'text-rose-700' : 'text-emerald-700'}`,
                                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($39641e97aa80005f$var$getDisplayCashFlowForSavedStrategy(strategy))
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "px-3 py-2.5 text-right tabular-nums text-slate-800",
                                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(strategy.outputs?.legacyEstimate)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "px-3 py-2.5 text-center text-slate-600",
                                                                children: strategy.createdAt ? new Date(strategy.createdAt).toLocaleDateString() : ''
                                                            })
                                                        ]
                                                    }, strategy.id))
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "px-6 py-4 border-t border-slate-100 bg-slate-50/50 flex justify-end",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setShowCompareModal(false),
                                className: "px-5 py-2.5 rounded-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 shadow-sm transition-all",
                                children: "Close"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $39641e97aa80005f$export$2e2bcd8739ae039 = $39641e97aa80005f$var$AgedCareAnalyser;



/**
 * The Strategy Analysis Setup answers a client file starts with — ONE place, because the bag is
 * app-level state and has to be put back whenever the file changes.
 *
 * Owner-caught, 18 Oct 2026: a new client file skipped the questions that change the answer and went
 * straight to the old annuity gate, because `suggestionEngineSetupComplete` set on the PREVIOUS file
 * was still true. The flag (and every other answer here) belongs to a file, not to the browser tab.
 */ const $87baeb3af1e4d5de$export$518cba37263e96a7 = {
    // exploreAlternatives is intentionally absent (undefined) = "not set" so the setup asks
    // null = "not set" so the setup can default it to ~70% of the actual home value
    downsizeNewHomeValue: null,
    partnerAnnualRent: 20000,
    sellingCosts: 0,
    emergencyFund: 0,
    // Optional future life event (partner enters residential care later) — captured in the setup
    enablePartnerFutureEvent: false,
    partnerEntryYear: 3,
    partnerFutureRoomPrice: 0,
    originalEntrantAliveAtPartnerEntry: true
};
function $87baeb3af1e4d5de$export$8c4af9c383a44b94() {
    return {
        ...$87baeb3af1e4d5de$export$518cba37263e96a7
    };
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5415d98bde6b29f1$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "8",
            y2: "12",
            key: "1pkeuh"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12.01",
            y1: "16",
            y2: "16",
            key: "4dfq90"
        }
    ]
];
const $5415d98bde6b29f1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-alert", $5415d98bde6b29f1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4b66c39b6083b2b9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 12h16",
            key: "1lakjw"
        }
    ],
    [
        "path",
        {
            d: "M4 18h16",
            key: "19g7jn"
        }
    ],
    [
        "path",
        {
            d: "M4 6h16",
            key: "1o0s65"
        }
    ]
];
const $4b66c39b6083b2b9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("menu", $4b66c39b6083b2b9$export$3efd853dbb351e94);




/**
 * ProgramOverviewSection.js – Support at Home "Program Overview" tab content.
 * Explains Support at Home, 8 classifications, contribution rates, and key features.
 * Used by SupportAtHomePage.js.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $88e75a6fb6edc067$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
            key: "169zse"
        }
    ]
];
const $88e75a6fb6edc067$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("activity", $88e75a6fb6edc067$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $224502d93617e0e1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z",
            key: "1b4qmf"
        }
    ],
    [
        "path",
        {
            d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2",
            key: "i71pzd"
        }
    ],
    [
        "path",
        {
            d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2",
            key: "10jefs"
        }
    ],
    [
        "path",
        {
            d: "M10 6h4",
            key: "1itunk"
        }
    ],
    [
        "path",
        {
            d: "M10 10h4",
            key: "tcdvrf"
        }
    ],
    [
        "path",
        {
            d: "M10 14h4",
            key: "kelpxr"
        }
    ],
    [
        "path",
        {
            d: "M10 18h4",
            key: "1ulq68"
        }
    ]
];
const $224502d93617e0e1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("building-2", $224502d93617e0e1$export$3efd853dbb351e94);




/*
 * THE FORK INSTEAD OF THE DEAD END (owner-approved, 2026-08-28).
 *
 * A client who has not been assessed reaches this module and can go no further: Support at Home
 * costs depend on a classification they do not have. Until now the page simply stopped there, and
 * since the client has already PAID by this point, stopping reads as "I got nothing for my money".
 *
 * It is also the wrong conclusion. Someone on entry-level support is at the START of the journey,
 * not the end — they still have the home, the pension and every decision ahead of them, so they
 * have MORE to gain from the rest of the app than someone already in residential care, who has the
 * fewest moves left. This panel says so and hands them the door.
 *
 * Deliberately only on this tab. Interrupting someone who has chosen to explore a what-if on
 * Contributions or Service Builder with "here is other stuff" is nagging, not helping.
 */ /*
 * THE PAGE KEYS MUST MATCH App.tsx's SWITCH, which falls through to a "coming soon" placeholder for
 * anything it does not recognise. The first cut used 'AgedCareAnalyser' and 'DownsizerPage' —
 * neither exists — so three of the four tiles led to a dead placeholder page (owner-caught on the
 * built screen, 2026-08-28). The live cases are: Dashboard, Client Profile, AgedCarePage,
 * AssumptionsPage, HomeCarePage, RetirementVillagePage, GrannyFlatPage, DownsizingPage.
 *
 * The Age Pension tile points at the DASHBOARD deliberately: that is the only screen holding a
 * calculated Age Pension figure with its means-test breakdown. It is the thinnest of the four, and
 * the gap a dedicated cashflow/pension view would fill.
 */ const $00292876521e52b4$var$WHILE_YOU_WAIT = [
    {
        page: 'CashflowPensionPage',
        icon: (0, $05565f19ab398c04$export$2e2bcd8739ae039),
        title: 'Check your cashflow and Age Pension',
        blurb: 'Where you stand now, how each figure is worked out, and what support at home costs you.'
    },
    {
        page: 'DownsizingPage',
        icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
        title: 'Model a downsize',
        blurb: "Including the pension trap \u2014 and when buying dearer beats buying cheaper."
    },
    {
        page: 'RetirementVillagePage',
        icon: (0, $224502d93617e0e1$export$2e2bcd8739ae039),
        title: 'Retirement village or granny flat',
        blurb: 'What the entry contribution does to your pension and your estate.'
    },
    {
        page: 'AgedCarePage',
        icon: (0, $95e9e50748ea8ef2$export$2e2bcd8739ae039),
        title: 'Plan ahead for residential care',
        blurb: "Room costs and the means-tested fee, before you\u2019re deciding under pressure."
    }
];
const $00292876521e52b4$var$WhileYouWaitPanel = ({ onNavigate: onNavigate })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6bc32c6ef2e03125$export$2e2bcd8739ae039), {
        tone: "info",
        heading: "While you wait for an assessment, here\u2019s what we can do today",
        icon: (0, $88e75a6fb6edc067$export$2e2bcd8739ae039),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-sm text-gray-700 mb-3",
                children: "None of these depend on a care assessment \u2014 and each one is worth more the earlier you look at it."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid grid-cols-1 sm:grid-cols-2 gap-2.5",
                children: $00292876521e52b4$var$WHILE_YOU_WAIT.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>onNavigate(item.page),
                        className: "flex items-start gap-3 rounded-xl border border-slate-200/90 bg-white p-3.5 text-left transition-shadow hover:shadow-md",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                icon: item.icon,
                                tone: "brand",
                                variant: "solid",
                                size: "sm"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "block text-sm font-bold text-gray-800",
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "block text-xs text-slate-500 leading-relaxed",
                                        children: item.blurb
                                    })
                                ]
                            })
                        ]
                    }, item.title))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[13px] text-slate-500 mt-3.5",
                children: "We\u2019ll pick Support at Home back up the moment you have an assessment \u2014 nothing you enter now is lost."
            })
        ]
    });
const $00292876521e52b4$var$ProgramOverviewSection = ({ awaitingAssessment: awaitingAssessment = false, onNavigate: onNavigate })=>{
    const [expandedSection, setExpandedSection] = (0, $acw62.useState)(null);
    const formatCurrency = (value)=>{
        return new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white/60 backdrop-blur-xl border border-white rounded-2xl shadow-lg shadow-gray-200/50 p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-start gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                            icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
                            tone: "brand",
                            variant: "solid",
                            size: "lg"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                    className: "text-xl font-bold text-gray-900 mb-2",
                                    children: "What is Support at Home?"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-gray-700 leading-relaxed",
                                    children: "Support at Home is the Australian Government's new aged care program that provides flexible, personalised support to help you continue living in your own home. Replacing Home Care Packages from 1 November 2025, it offers 8 funding classifications to match your care needs, from basic support (Level 1) to high care requirements (Level 8)."
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white/60 backdrop-blur-xl border border-white rounded-2xl shadow-lg shadow-gray-200/50 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: ()=>setExpandedSection(expandedSection === 'classifications' ? null : 'classifications'),
                        className: "w-full p-6 text-left flex items-center justify-between hover:bg-blue-50 transition-colors",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                        icon: (0, $27f56d6cfb7d79f8$export$2e2bcd8739ae039),
                                        tone: "brand",
                                        variant: "soft",
                                        size: "md"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-xl font-bold text-gray-800",
                                        children: "8 Classifications Explained"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: `w-6 h-6 text-gray-500 transition-transform duration-300 ${expandedSection === 'classifications' ? 'rotate-180' : ''}`
                            })
                        ]
                    }),
                    expandedSection === 'classifications' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "px-6 pb-6 pl-22",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "p-4 bg-white border-l-4 border-blue-400 rounded-r-lg",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-gray-700 mb-4",
                                    children: "Your classification determines your annual budget. Higher classifications provide more funding for additional services and support."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "grid grid-cols-1 md:grid-cols-2 gap-3",
                                    children: Object.entries((0, $c220d08b55e5dd64$export$bfae9591cc0d7897)).filter(([, value])=>!value.transitional).map(([key, value])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "border border-gray-200 rounded-lg p-4 hover:border-blue-300 transition-colors bg-white hover:shadow-md",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-start justify-between mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "font-semibold text-gray-900 text-sm",
                                                            children: value.label
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "font-bold text-blue-600 ml-2",
                                                            children: formatCurrency(value.budget)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-xs text-gray-600 leading-relaxed mb-2",
                                                    children: value.description
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "text-xs text-gray-500 font-medium",
                                                    children: [
                                                        Math.round(value.budget / 4).toLocaleString('en-AU', {
                                                            style: 'currency',
                                                            currency: 'AUD',
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        }),
                                                        " per quarter"
                                                    ]
                                                })
                                            ]
                                        }, key))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white/60 backdrop-blur-xl border border-white rounded-2xl shadow-lg shadow-gray-200/50 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: ()=>setExpandedSection(expandedSection === 'contributions' ? null : 'contributions'),
                        className: "w-full p-6 text-left flex items-center justify-between hover:bg-blue-50 transition-colors",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                        icon: (0, $52885985d1db6c06$export$2e2bcd8739ae039),
                                        tone: "brand",
                                        variant: "soft",
                                        size: "md"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-xl font-bold text-gray-800",
                                        children: "How Participant Contributions Work"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: `w-6 h-6 text-gray-500 transition-transform duration-300 ${expandedSection === 'contributions' ? 'rotate-180' : ''}`
                            })
                        ]
                    }),
                    expandedSection === 'contributions' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "px-6 pb-6 pl-22",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "p-4 bg-white border-l-4 border-blue-400 rounded-r-lg space-y-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-gray-700",
                                    children: "From 1 November 2025, participants contribute towards the cost of some services based on their income and assets. The government covers the remainder."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "grid grid-cols-1 md:grid-cols-3 gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "border-2 border-blue-300 bg-white rounded-lg p-4",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                    className: "font-bold text-gray-900 mb-2",
                                                    children: "Clinical Care"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-sm text-gray-600 mb-3",
                                                    children: "Nursing, physiotherapy, personal care (fully funded from 1 Oct 2026)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "text-2xl font-bold text-gray-900",
                                                    children: "0%"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "text-xs text-gray-600 mt-1",
                                                    children: "Government funded"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "border-2 border-green-300 bg-white rounded-lg p-4",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                    className: "font-bold text-gray-900 mb-2",
                                                    children: "Independence"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-sm text-gray-600 mb-3",
                                                    children: "Social support, transport, respite"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "text-2xl font-bold text-gray-900",
                                                    children: "Varies"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "text-xs text-gray-600 mt-1",
                                                    children: "5-50% based on pension"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "border-2 border-teal-300 bg-white rounded-lg p-4",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                    className: "font-bold text-gray-900 mb-2",
                                                    children: "Everyday Living"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-sm text-gray-600 mb-3",
                                                    children: "Cleaning, gardening, meals"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "text-2xl font-bold text-gray-900",
                                                    children: "Varies"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "text-xs text-gray-600 mt-1",
                                                    children: "17.5-80% based on pension"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "bg-white border border-blue-200 rounded-lg p-4 mt-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h5", {
                                            className: "font-bold text-blue-900 mb-2 flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                                    size: 18
                                                }),
                                                " Contribution Rates by Pension Status"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "overflow-x-auto",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                                className: "w-full text-sm",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            className: "border-b border-blue-200",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                    className: "text-left py-2 px-3 font-semibold text-blue-900",
                                                                    children: "Pension Status"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                    className: "text-center py-2 px-3 font-semibold text-blue-900",
                                                                    children: "Clinical"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                    className: "text-center py-2 px-3 font-semibold text-blue-900",
                                                                    children: "Independence"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                    className: "text-center py-2 px-3 font-semibold text-blue-900",
                                                                    children: "Everyday"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                className: "border-b border-blue-100",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        className: "py-2 px-3",
                                                                        children: "Full Pensioner"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        className: "text-center py-2 px-3",
                                                                        children: "0%"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        className: "text-center py-2 px-3",
                                                                        children: "5%"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        className: "text-center py-2 px-3",
                                                                        children: "17.5%"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                className: "border-b border-blue-100",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        className: "py-2 px-3",
                                                                        children: "Part Pensioner/CSHC"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        className: "text-center py-2 px-3",
                                                                        children: "0%"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        className: "text-center py-2 px-3",
                                                                        children: "5-50%"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        className: "text-center py-2 px-3",
                                                                        children: "17.5-80%"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        className: "py-2 px-3",
                                                                        children: "Self-Funded Retiree"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        className: "text-center py-2 px-3",
                                                                        children: "0%"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        className: "text-center py-2 px-3",
                                                                        children: "50%"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        className: "text-center py-2 px-3",
                                                                        children: "80%"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bg-white/60 backdrop-blur-xl border border-white rounded-2xl shadow-lg shadow-gray-200/50 p-6 hover:shadow-xl transition-shadow",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-start gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                    icon: (0, $e325251f2797f6cf$export$2e2bcd8739ae039),
                                    tone: "brand",
                                    variant: "solid",
                                    size: "md"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                            className: "font-bold text-gray-900 mb-2",
                                            children: "Lifetime Cap"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-700",
                                            children: "Once you've contributed $130,000 towards your care, you'll never pay fees again."
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bg-white/60 backdrop-blur-xl border border-white rounded-2xl shadow-lg shadow-gray-200/50 p-6 hover:shadow-xl transition-shadow",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-start gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                    icon: (0, $200392fae49ddb7e$export$2e2bcd8739ae039),
                                    tone: "brand",
                                    variant: "solid",
                                    size: "md"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                            className: "font-bold text-gray-900 mb-2",
                                            children: "Quarterly Budgets"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-700",
                                            children: "Your budget is split into 4 equal quarters and managed by Services Australia."
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bg-white/60 backdrop-blur-xl border border-white rounded-2xl shadow-lg shadow-gray-200/50 p-6 hover:shadow-xl transition-shadow",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-start gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                    icon: (0, $c9921f4f81a419f0$export$2e2bcd8739ae039),
                                    tone: "brand",
                                    variant: "solid",
                                    size: "md"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                            className: "font-bold text-gray-900 mb-2",
                                            children: "Accrual Benefits"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-700",
                                            children: "Save up to $1,000 or 10% of your quarterly budget (whichever is higher) for unplanned needs."
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bg-white/60 backdrop-blur-xl border border-white rounded-2xl shadow-lg shadow-gray-200/50 p-6 hover:shadow-xl transition-shadow",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-start gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                    icon: (0, $adb270212de20834$export$2e2bcd8739ae039),
                                    tone: "brand",
                                    variant: "solid",
                                    size: "md"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                            className: "font-bold text-gray-900 mb-2",
                                            children: "Monthly Statements"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-700",
                                            children: "Your provider will issue itemised monthly statements showing budget usage."
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            awaitingAssessment && onNavigate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($00292876521e52b4$var$WhileYouWaitPanel, {
                onNavigate: onNavigate
            })
        ]
    });
};
var $00292876521e52b4$export$2e2bcd8739ae039 = $00292876521e52b4$var$ProgramOverviewSection;


/**
 * What an aged care assessment actually decides — and why one of the two answers is not something
 * we can cost.
 *
 * WHY THIS EXISTS (owner, 2026-08-28). The app had nothing to say about the Commonwealth Home
 * Support Program, the entry-level program roughly 830,000 older Australians actually use. A client
 * who has not been assessed was told only that we could not find their Support at Home
 * classification, and invited to pick one.
 *
 * THE LINE THIS COMPONENT HOLDS. CHSP has NO MEANS TEST — no income test, no assets test — and each
 * provider sets its own fees. There is therefore no formula to model, and we must not invent one:
 * a number we produced would be a guess wearing the costume of an answer. So this explains, and
 * deliberately does not calculate. The honest reason is stated to the client rather than hidden,
 * because "we don't model this, and here is why" is evidence that our other numbers are real.
 *
 * WHAT IT DELIBERATELY DOES NOT DO. It does not predict which way a given client will fall. The
 * owner's first instinct was to infer the likely outcome from the health question — "you told us
 * you're in good health, so you may only need CHSP". Good general health does not mean low care
 * needs (a fall, mobility, cognition and isolation all drive needs up while someone still reports
 * good health), and a wrong guess in the app's voice could talk a client out of an assessment they
 * would have qualified for. Explaining both outcomes is more useful and cannot misfire.
 *
 * Facts sourced from the Department of Health, Disability and Ageing; the CHSP extension to
 * 30 June 2029 and the confirmation that it stays standalone were announced 20 August 2026. The
 * same facts are in the AWise knowledge base (awiseKnowledgeBase.ts, concept `chsp`) so the
 * assistant and the screens cannot disagree.
 */ 

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


/** The two outcomes, in the client's words. Shared by the fork panel and the comparison table. */ const $02b552f3b0af8007$var$PATHS = {
    chsp: {
        title: 'Entry-level support (CHSP)',
        who: "Help around the home \u2014 cleaning, meals, transport, social support",
        points: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "Fees are ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "set by each provider"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    children: "No income or assets test"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: "Nobody is refused a service for being unable to pay"
            })
        ]
    },
    sah: {
        title: "Support at Home (Levels 1\u20138)",
        who: 'An ongoing budget for assessed, continuing care needs',
        points: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "You get an ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "individual yearly budget"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "Your contribution ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "is means tested"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: "This is the one we can model for you"
            })
        ]
    }
};
const $02b552f3b0af8007$var$PathCard = ({ path: path, accent: accent })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `rounded-xl border border-slate-200/90 bg-white p-4 border-t-[3px] ${accent}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                className: "text-[15px] font-bold text-gray-800 mb-0.5",
                children: path.title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-xs text-slate-500 mb-2.5",
                children: path.who
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "list-disc pl-4 space-y-0.5 text-[13.5px] text-gray-700 leading-relaxed",
                children: path.points.map((point, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: point
                    }, i))
            })
        ]
    });
function $02b552f3b0af8007$export$4dc872a89ff11540({ who: who, onCompare: onCompare, className: className = '' }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6bc32c6ef2e03125$export$2e2bcd8739ae039), {
        tone: "info",
        heading: "What the assessment decides",
        icon: (0, $e52b122f04c04d7d$export$2e2bcd8739ae039),
        className: className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-sm text-gray-700 leading-relaxed mb-3",
                children: [
                    "An assessment sorts ",
                    who ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: who
                    }) : 'people',
                    " onto ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "one of two paths"
                    }),
                    ", and they cost very different things:"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($02b552f3b0af8007$var$PathCard, {
                        path: $02b552f3b0af8007$var$PATHS.chsp,
                        accent: "border-t-emerald-400"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($02b552f3b0af8007$var$PathCard, {
                        path: $02b552f3b0af8007$var$PATHS.sah,
                        accent: "border-t-brand-blue"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-sm text-gray-700 mt-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onCompare,
                        className: "font-semibold text-blue-600 underline decoration-blue-600/40 underline-offset-2 hover:text-blue-700",
                        children: "See a full comparison"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-slate-500",
                        children: [
                            ' ',
                            "\xb7 We can't know which ",
                            who || 'you',
                            " would be assessed for \u2014 only the assessment decides that."
                        ]
                    })
                ]
            })
        ]
    });
}
const $02b552f3b0af8007$var$ROWS = [
    {
        label: "Who it's for",
        chsp: "Lower needs \u2014 help to keep managing at home",
        sah: 'Assessed, ongoing care needs'
    },
    {
        label: 'What you get',
        chsp: 'Individual services: cleaning, meals, transport, social support, minor home maintenance',
        sah: 'A yearly budget you spend across care, independence and everyday living services'
    },
    {
        label: "How it's funded",
        chsp: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                "Government funds the ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                    children: "provider"
                }),
                " directly"
            ]
        }),
        sah: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                "Government allocates a budget to ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                    children: "you"
                }),
                ", at Levels 1\u20138"
            ]
        })
    },
    {
        label: 'Is it means tested?',
        chsp: "No \u2014 no income test, no assets test",
        sah: "Yes \u2014 your contribution depends on your income and assets",
        key: true
    },
    {
        label: 'What you pay',
        chsp: "A fee set by each provider, based on what you can afford. You cannot be refused a service because you can\u2019t pay.",
        sah: 'A contribution that varies by service type and your means-tested category'
    },
    {
        label: 'Can AgedCareWise model it?',
        /*
         * Unusual on a client-facing table, and kept deliberately. It answers the question the
         * reader is already forming, and giving the REASON turns a limitation into evidence that we
         * do not make numbers up.
         */ chsp: "No \u2014 and that\u2019s not a gap. There\u2019s no formula: fees differ provider to provider, so any figure we produced would be a guess.",
        sah: "Yes \u2014 this is what the module is built for",
        key: true
    },
    {
        label: 'How long does it run?',
        chsp: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                "Funded to ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    children: "30 June 2029"
                }),
                ", and the government has confirmed it stays a standalone program"
            ]
        }),
        sah: "Ongoing \u2014 replaced Home Care Packages on 1 November 2025"
    }
];
function $02b552f3b0af8007$export$7753eabeacd6f0b2({ open: open, onClose: onClose }) {
    // Escape closes, and the page behind does not scroll while it is open.
    (0, $acw62.useEffect)(()=>{
        if (!open) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', onKey);
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return ()=>{
            document.removeEventListener('keydown', onKey);
            document.body.style.overflow = previousOverflow;
        };
    }, [
        open,
        onClose
    ]);
    if (!open || typeof document === 'undefined') return null;
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 z-[60] flex items-start justify-center overflow-y-auto bg-brand-ink/55 p-4 sm:p-6",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "chsp-compare-title",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "my-4 w-full max-w-3xl rounded-2xl border border-slate-200/70 bg-white p-6 shadow-cardlg sm:p-7",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mb-4 flex items-start justify-between gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    id: "chsp-compare-title",
                                    className: "text-[23px] font-bold leading-tight",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-brand-navy ",
                                        children: "Entry-level support vs Support at Home"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-0.5 text-sm text-gray-600",
                                    children: "The two things an assessment can decide \u2014 and what each costs you."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: onClose,
                            "aria-label": "Close comparison",
                            className: "mt-1 shrink-0 rounded-lg p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-600",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 20,
                                strokeWidth: 2.4
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "w-full min-w-[600px] table-fixed border-collapse text-sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("colgroup", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                        className: "w-[26%]"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                        className: "w-[37%]"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                        className: "w-[37%]"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "border-b-2 border-slate-200 px-3 py-3"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "border-b-2 border-slate-200 px-3 py-3 text-left text-xs font-bold uppercase tracking-wider text-slate-500",
                                            children: "Entry-level support (CHSP)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "border-b-2 border-slate-200 px-3 py-3 text-left text-xs font-bold uppercase tracking-wider text-slate-500",
                                            children: "Support at Home"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: $02b552f3b0af8007$var$ROWS.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: row.key ? 'bg-blue-50' : '',
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                scope: "row",
                                                className: `w-[26%] border-b border-slate-200 px-3 py-3 text-left align-top font-bold text-gray-800 ${row.key ? '' : 'bg-slate-50/60'}`,
                                                children: row.label
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: `border-b border-slate-200 px-3 py-3 align-top leading-relaxed ${row.key ? 'font-bold text-brand-navy' : 'text-gray-700'}`,
                                                children: row.chsp
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: `border-b border-slate-200 px-3 py-3 align-top leading-relaxed ${row.key ? 'font-bold text-brand-navy' : 'text-gray-700'}`,
                                                children: row.sah
                                            })
                                        ]
                                    }, row.label))
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bc32c6ef2e03125$export$2e2bcd8739ae039), {
                    tone: "positive",
                    icon: (0, $f36710bd138be5d0$export$2e2bcd8739ae039),
                    className: "mt-5",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-sm text-gray-700 leading-relaxed",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "If entry-level support is where you land, that's good news financially."
                            }),
                            ' ',
                            "There's no means test, so nothing about your income or assets changes what you pay \u2014 and the planning we do elsewhere in AgedCareWise still applies in full."
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "mt-3.5 text-[11.5px] text-slate-400",
                    children: "Source: Department of Health, Disability and Ageing \u2014 CHSP extended to 30 June 2029 (announced 20 August 2026)."
                })
            ]
        })
    }), document.body);
}
var $02b552f3b0af8007$export$2e2bcd8739ae039 = $02b552f3b0af8007$export$4dc872a89ff11540;


/** Resolved URL for the AgedCareWise symbol (from Gemini Logo Image Final.png). */ var $b1114c6b5d59958c$exports = {};
$b1114c6b5d59958c$exports = import.meta.resolve("hDYtD");


const $fa6d1caa5fe64367$export$6c23acffafc6aa0a = new URL($b1114c6b5d59958c$exports).href;



parcelRequire("acw62");
const $421c0497858a4b09$var$AgedCareWiseLogo = ({ className: className = 'h-20 w-auto', showText: showText = true, variant: variant = 'full' })=>{
    const suffix = variant === 'symbol' ? '-symbol' : '-full';
    const navyId = 'agedCareGradient' + suffix;
    const tealId = 'wiseGradient' + suffix;
    const gradients = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("defs", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                id: navyId,
                x1: "0%",
                y1: "0%",
                x2: "100%",
                y2: "0%",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: "0%",
                        stopColor: "#001E7A"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: "100%",
                        stopColor: "#0F52E0"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                id: tealId,
                x1: "0%",
                y1: "0%",
                x2: "100%",
                y2: "0%",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: "0%",
                        stopColor: "#0290F5"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: "100%",
                        stopColor: "#1EC8FF"
                    })
                ]
            })
        ]
    });
    if (variant === 'symbol') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 380 36",
            className: "h-full w-auto",
            "aria-hidden": "true",
            children: [
                gradients,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("text", {
                    x: "0",
                    y: "28",
                    fontSize: "24",
                    fontWeight: "800",
                    fontFamily: "'Inter', 'Segoe UI', sans-serif",
                    letterSpacing: "-0.8",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tspan", {
                            fill: 'url(#' + navyId + ')',
                            children: "AgedCare"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tspan", {
                            fill: 'url(#' + tealId + ')',
                            children: "Wise"
                        })
                    ]
                })
            ]
        })
    });
    return(// min-w-0 + max-w-full: on a phone the wordmark shrinks to the room it has (left-aligned)
    // instead of forcing the whole page to scroll sideways.
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: 'flex items-center min-w-0 max-w-full ' + className,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 400 48",
            preserveAspectRatio: "xMinYMid meet",
            className: "h-full w-auto max-w-full",
            role: "img",
            "aria-label": "AgedCareWise",
            children: [
                gradients,
                showText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("text", {
                    x: "0",
                    y: "38",
                    fontSize: "32",
                    fontWeight: "800",
                    fontFamily: "'Inter', 'Segoe UI', sans-serif",
                    letterSpacing: "-1.0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tspan", {
                            fill: 'url(#' + navyId + ')',
                            children: "AgedCare"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tspan", {
                            fill: 'url(#' + tealId + ')',
                            children: "Wise"
                        })
                    ]
                })
            ]
        })
    }));
};
var $421c0497858a4b09$export$2e2bcd8739ae039 = $421c0497858a4b09$var$AgedCareWiseLogo;



parcelRequire("acw62");
const $e2c4379c8d623235$var$SIZE_CLASS = {
    sm: 'text-sm',
    base: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl'
};
const $e2c4379c8d623235$var$VARIANT_CLASS = {
    brand: {
        a: 'text-[#001E7A]',
        wise: 'text-[#0290F5]'
    },
    onDark: {
        a: 'text-white',
        wise: 'text-sky-200'
    }
};
function $e2c4379c8d623235$export$2e2bcd8739ae039({ className: className = '', size: size = 'lg', variant: variant = 'brand', as: Tag = 'span', ...rest }) {
    const sizeClass = $e2c4379c8d623235$var$SIZE_CLASS[size] || $e2c4379c8d623235$var$SIZE_CLASS.lg;
    const colours = $e2c4379c8d623235$var$VARIANT_CLASS[variant] || $e2c4379c8d623235$var$VARIANT_CLASS.brand;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(Tag, {
        className: `font-bold tracking-tight ${sizeClass} ${className}`.trim(),
        ...rest,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: colours.a,
                children: "A"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: colours.wise,
                children: "Wise"
            })
        ]
    });
}



parcelRequire("acw62");
const $3504415ad7167981$var$UserAvatar = ({ initials: initials, color1: color1, color2: color2 })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "w-14 h-14 rounded-full border-2 border-white shadow-md flex-shrink-0",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: "0 0 100 100",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        id: `grad-${initials || '?'}`,
                        x1: "0%",
                        y1: "0%",
                        x2: "100%",
                        y2: "100%",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "0%",
                                style: {
                                    stopColor: color1,
                                    stopOpacity: 1
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "100%",
                                style: {
                                    stopColor: color2,
                                    stopOpacity: 1
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "50",
                    cy: "50",
                    r: "50",
                    fill: `url(#grad-${initials || '?'})`
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                    x: "50",
                    y: "50",
                    textAnchor: "middle",
                    dy: ".3em",
                    fill: "white",
                    fontSize: "40",
                    fontWeight: "bold",
                    children: initials || '?'
                })
            ]
        })
    });
var $3504415ad7167981$export$2e2bcd8739ae039 = $3504415ad7167981$var$UserAvatar;



parcelRequire("acw62");
const $d735a46f6c8532a3$var$MyAgedCareOfficialLogo = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "w-12 h-12 flex-shrink-0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                    viewBox: "0 0 100 60",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                                id: "logoGrad",
                                x1: "0%",
                                y1: "0%",
                                x2: "100%",
                                y2: "100%",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                        offset: "0%",
                                        stopColor: "#63b3ed"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                        offset: "100%",
                                        stopColor: "#4fd1c5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            fill: "url(#logoGrad)",
                            d: "M36.8,35.4c-6.8,0-12.3-5.5-12.3-12.3S30,10.8,36.8,10.8s12.3,5.5,12.3,12.3C49.1,29.3,44.3,35.4,36.8,35.4z M63.2,49.2c-6.8,0-12.3-5.5-12.3-12.3c0-6.8,5.5-12.3,12.3-12.3s12.3,5.5,12.3,12.3C75.5,43.7,70,49.2,63.2,49.2z M49.4,42.4c-2.9,2.9-6.8,4.5-10.9,4.5c-4.1,0-8-1.6-10.9-4.5c-2.9-2.9-4.5-6.8-4.5-10.9c0-2.9,0.8-5.6,2.2-8H25c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7h2.5c1.8,4.4,5.7,7.6,10.4,8.5c-0.2,0.5-0.3,1-0.3,1.5c0,2.4,1.9,4.3,4.3,4.3s4.3-1.9,4.3-4.3c0-0.5-0.1-1-0.3-1.5c4.7-0.9,8.6-4.1,10.4-8.5h2.5c4.8,0,8.7,3.9,8.7,8.7c0-4.8-3.9-8.7-8.7-8.7h-1.1c1.4,2.4,2.2,5.1,2.2,8C60.3,35.6,55.9,40.1,49.4,42.4z"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "font-bold text-xl text-[#5A2A82]",
                children: "myagedcare"
            })
        ]
    });
var $d735a46f6c8532a3$export$2e2bcd8739ae039 = $d735a46f6c8532a3$var$MyAgedCareOfficialLogo;



parcelRequire("acw62");

const $73bacbfa279634e3$export$63641d97ed9ac2e9 = 'https://www.myagedcare.gov.au/assessment/apply-online';
const $73bacbfa279634e3$var$MY_AGED_CARE_PORTAL_URL = 'https://www.myagedcare.gov.au/';
/**
 * Compact secondary action — opens My Aged Care (apply or portal) in a new tab.
 */ const $73bacbfa279634e3$var$MyAgedCareApplyLink = ({ status: status = 'no', className: className = '' })=>{
    const isInProgress = status === 'in_progress';
    const url = isInProgress ? $73bacbfa279634e3$var$MY_AGED_CARE_PORTAL_URL : $73bacbfa279634e3$export$63641d97ed9ac2e9;
    const label = isInProgress ? 'Check on My Aged Care' : 'Apply via My Aged Care';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: ()=>window.open(url, '_blank', 'noopener,noreferrer'),
        className: `inline-flex shrink-0 items-center gap-1.5 rounded-md border border-gray-200 bg-white px-3 py-1.5 text-xs font-medium text-gray-600 shadow-sm transition-colors hover:border-[#5A2A82]/25 hover:bg-gray-50 hover:text-[#5A2A82] ${className}`,
        "aria-label": `${label} (opens My Aged Care in a new tab)`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                size: 12,
                className: "shrink-0 opacity-60",
                "aria-hidden": true
            })
        ]
    });
};
var $73bacbfa279634e3$export$2e2bcd8739ae039 = $73bacbfa279634e3$var$MyAgedCareApplyLink;




/**
 * ContributionsSection.js – Support at Home "Your Contributions" tab content.
 * Contribution rates, calculation breakdown, example service package, cashflow impact.
 * Used by SupportAtHomePage.js.
 */ 

var $acw62 = parcelRequire("acw62");






// Contributions Section
const $3f5d3aca8a0d692e$var$ContributionsSection = ({ factFind: factFind, setFactFind: setFactFind })=>{
    const isPartnered = factFind?.adviceFor === 'couple';
    // Get participant type from fact-find data
    const clientHcpStatus = factFind?.careNeeds?.clientAcat?.hcpBeforeSep2024 || 'no';
    const defaultParticipantType = clientHcpStatus === 'yes' ? 'nwop' : 'standard';
    const defaultNwopCategory = factFind?.careNeeds?.clientAcat?.hcpCategory || null;
    const defaultPreviousITCF = Number(factFind?.careNeeds?.clientAcat?.previousITCF) || 0;
    const [participantType] = (0, $acw62.useState)(defaultParticipantType);
    const [nwopCategory] = (0, $acw62.useState)(defaultNwopCategory);
    const [meansDisclosed] = (0, $acw62.useState)(true);
    const [previousITCF] = (0, $acw62.useState)(defaultPreviousITCF);
    const [showCalculationDetails, setShowCalculationDetails] = (0, $acw62.useState)(false);
    const [showExampleServicePackage, setShowExampleServicePackage] = (0, $acw62.useState)(false);
    // ── Assessment-letter override ────────────────────────────────────────────────────────────────
    // The client's REAL rates come from a Services Australia assessment, which can differ from the
    // model. The adviser can record the official rates; they live on the fact-find (so they persist
    // and flow into every calculation via the contribution engine) with who/when/source captured.
    const activeOverride = factFind?.sahContributionRateOverride;
    const [showOverrideForm, setShowOverrideForm] = (0, $acw62.useState)(false);
    const [overrideIndependencePct, setOverrideIndependencePct] = (0, $acw62.useState)('');
    const [overrideEverydayPct, setOverrideEverydayPct] = (0, $acw62.useState)('');
    const [overrideSource, setOverrideSource] = (0, $acw62.useState)('');
    const [overrideError, setOverrideError] = (0, $acw62.useState)('');
    const saveOverride = ()=>{
        if (!setFactFind) return;
        const indep = parseFloat(overrideIndependencePct);
        const edl = parseFloat(overrideEverydayPct);
        if (!Number.isFinite(indep) || indep < 0 || indep > 100 || !Number.isFinite(edl) || edl < 0 || edl > 100) {
            setOverrideError('Enter both rates as percentages between 0 and 100.');
            return;
        }
        if (!overrideSource.trim()) {
            // Mandatory for compliance: an override without provenance is indistinguishable from a typo.
            setOverrideError('Record where these rates came from (e.g. "Services Australia assessment letter dated 12 August 2026").');
            return;
        }
        setOverrideError('');
        setFactFind((prev)=>({
                ...prev,
                sahContributionRateOverride: {
                    independence: indep / 100,
                    everydayLiving: edl / 100,
                    source: overrideSource.trim(),
                    overriddenAt: new Date().toISOString(),
                    modelledIndependenceAtOverride: contributionData?.modelledContributionRates?.independence ?? contributionData?.contributionRates?.independence,
                    modelledEverydayLivingAtOverride: contributionData?.modelledContributionRates?.everydayLiving ?? contributionData?.contributionRates?.everydayLiving,
                    modelledPensionStatusAtOverride: contributionData?.pensionStatus
                }
            }));
        setShowOverrideForm(false);
    };
    const removeOverride = ()=>{
        if (!setFactFind) return;
        setFactFind((prev)=>{
            const next = {
                ...prev
            };
            delete next.sahContributionRateOverride;
            return next;
        });
        setShowOverrideForm(false);
    };
    // Calculate financial position and contributions
    const [financials, setFinancials] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind).then((r)=>{
            if (!cancelled) setFinancials(r);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind
    ]);
    const [individualContributions, setIndividualContributions] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!financials) {
            setIndividualContributions(null);
            return undefined;
        }
        let cancelled = false;
        $55a1d8a64f1e5dfa$export$3fe0e13ec85e5380(factFind, financials, participantType, nwopCategory, meansDisclosed, previousITCF).then((r)=>{
            if (!cancelled) setIndividualContributions(r);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind,
        financials,
        participantType,
        nwopCategory,
        meansDisclosed,
        previousITCF
    ]);
    // For display, use combined contribution for couples, client for singles
    const contributionData = individualContributions ? isPartnered ? individualContributions.combined || individualContributions.client : individualContributions.client : null;
    const hasAgedCareGoal = Boolean(factFind?.goals?.aged_care);
    const showIllnessSeparatedPreview = isPartnered && hasAgedCareGoal && !contributionData?.illnessSeparatedApplied;
    const [illnessSeparatedPreview, setIllnessSeparatedPreview] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!showIllnessSeparatedPreview || !financials) {
            setIllnessSeparatedPreview(null);
            return undefined;
        }
        let cancelled = false;
        $55a1d8a64f1e5dfa$export$3fe0e13ec85e5380(factFind, financials, participantType, nwopCategory, meansDisclosed, previousITCF, 0.5, {
            forceIllnessSeparated: true
        }).then((r)=>{
            if (!cancelled) setIllnessSeparatedPreview(r);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        showIllnessSeparatedPreview,
        factFind,
        financials,
        participantType,
        nwopCategory,
        meansDisclosed,
        previousITCF
    ]);
    const illnessSeparatedPreviewData = illnessSeparatedPreview ? illnessSeparatedPreview.combined || illnessSeparatedPreview.client : null;
    // Debug: Verify service contributions sum to total
    if (contributionData && contributionData.contributionAmounts) {
        const sumOfServices = (contributionData.contributionAmounts.clinical || 0) + (contributionData.contributionAmounts.independence || 0) + (contributionData.contributionAmounts.everydayLiving || 0);
        const total = contributionData.contributionAmounts.totalAnnual || 0;
        if (Math.abs(sumOfServices - total) > 1) console.warn("\xe2\u0161\xa0\xef\xb8\x8f Service contributions do not sum to total:", {
            clinical: contributionData.contributionAmounts.clinical,
            independence: contributionData.contributionAmounts.independence,
            everydayLiving: contributionData.contributionAmounts.everydayLiving,
            sumOfServices: sumOfServices,
            total: total,
            budgetTotal: contributionData.budget?.total
        });
    }
    const formatCurrency = (value)=>{
        return new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(value || 0);
    };
    const formatPercent = (value)=>{
        return `${((value || 0) * 100).toFixed(1)}%`;
    };
    if (!financials || !contributionData) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "space-y-6 text-sm text-gray-500",
        children: "Loading your contribution position\u2026"
    });
    // Calculate years until lifetime cap (simplified - assumes constant annual contribution)
    const yearsToCap = (0, $c424aab2467b2598$export$7fb415e878d63867)(contributionData.contributionAmounts.totalAnnual, 0, participantType);
    // Build personalized breakdowns for display
    const buildAssessableIncomeBreakdown = ()=>{
        const breakdown = [];
        if (financials.assessableIncomeFromPensions) breakdown.push([
            'Age Pension',
            financials.assessableIncomeFromPensions
        ]);
        if (financials.deemedIncome) breakdown.push([
            'Deemed Investment Income',
            financials.deemedIncome
        ]);
        if (financials.netRentalIncomeForPension) breakdown.push([
            'Net Rental Income',
            financials.netRentalIncomeForPension
        ]);
        if (financials.otherAssessableIncome) breakdown.push([
            'Other Income',
            financials.otherAssessableIncome
        ]);
        return breakdown;
    };
    const assessableIncomeBreakdown = buildAssessableIncomeBreakdown();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-6",
        children: [
            participantType === 'nwop' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white border border-slate-200/70 border-l-4 border-blue-500 rounded-lg p-4 shadow-sm",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-start gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                            size: 20,
                            className: "text-blue-600 flex-shrink-0 mt-0.5"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-sm text-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "font-bold mb-1 text-blue-900",
                                    children: "No Worse Off Principle Participant"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-gray-700",
                                    children: [
                                        "Based on your response in Step 3, you were in receipt of (or approved for) a Home Care Package on 12 September 2024. Your contribution rates are calculated under the Department's 'no worse off' principle: nothing if you paid no income-tested care fee under your package; otherwise a rate between 0% and 25% that depends on your ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "income only"
                                        }),
                                        "(assets play no part), and never more per fortnight than the income-tested care fee you paid before. The lifetime cap is the package cap (",
                                        (0, $c424aab2467b2598$export$c5fbc76332b2670f).nwop.toLocaleString('en-AU', {
                                            style: 'currency',
                                            currency: 'AUD'
                                        }),
                                        ", indexed each March and September), and fees already paid under your package count towards it."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-slate-50 border border-slate-200 rounded-lg p-4 shadow-sm",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-start gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                            size: 20,
                            className: "text-slate-600 flex-shrink-0 mt-0.5"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-sm text-gray-800",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "font-semibold text-gray-900 mb-1",
                                    children: "How we set \u201Cfull pension / part pension / self-funded\u201D for your co-contribution estimate"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-gray-700 leading-relaxed",
                                    children: [
                                        "Services Australia does not send us your official pension outcome. This tool looks at the ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Age Pension amount calculated from your answers here"
                                        }),
                                        " and uses that to pick the right ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "contribution-rate band"
                                        }),
                                        " (full pensioner, part pensioner, or self-funded). Your ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "real"
                                        }),
                                        " home-care co-contribution is decided after government assessment \u2014 it may be different from what you see here."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-gray-700 mb-4",
                                children: [
                                    "Based on your financial position, we have estimated the following ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-gray-900",
                                        children: "Contribution Rates"
                                    }),
                                    ":"
                                ]
                            }),
                            showIllnessSeparatedPreview && illnessSeparatedPreviewData && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-xs text-gray-600 bg-slate-50 border border-slate-200 rounded-lg p-3",
                                children: [
                                    "If you are later assessed by Services Australia as an ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "illness-separated couple"
                                    }),
                                    ", your estimated rates could change to:",
                                    ' ',
                                    "Clinical ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: formatPercent(illnessSeparatedPreviewData.contributionRates.clinical)
                                    }),
                                    ",",
                                    ' ',
                                    "Independence ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: formatPercent(illnessSeparatedPreviewData.contributionRates.independence)
                                    }),
                                    ",",
                                    ' ',
                                    "Everyday Living ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: formatPercent(illnessSeparatedPreviewData.contributionRates.everydayLiving)
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-3 gap-4 mb-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white border border-gray-200 rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-start gap-3 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                                icon: (0, $e325251f2797f6cf$export$2e2bcd8739ae039),
                                                tone: "brand",
                                                variant: "solid",
                                                size: "md"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                        className: "font-bold text-gray-900",
                                                        children: "Clinical Care"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs text-gray-600",
                                                        children: "Nursing, physio, OT, personal care"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-3xl font-bold text-blue-600 mb-2",
                                        children: formatPercent(contributionData.contributionRates.clinical)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-sm text-gray-700",
                                        children: "Contribution Rate"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white border border-gray-200 rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-start gap-3 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                                icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
                                                tone: "emerald",
                                                variant: "solid",
                                                size: "md"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                        className: "font-bold text-gray-900",
                                                        children: "Independence"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs text-gray-600",
                                                        children: "Social support, transport, respite"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-3xl font-bold text-green-600 mb-2",
                                        children: formatPercent(contributionData.contributionRates.independence)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-sm text-gray-700",
                                        children: "Contribution Rate"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white border border-gray-200 rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-start gap-3 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                                icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
                                                tone: "amber",
                                                variant: "solid",
                                                size: "md"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                        className: "font-bold text-gray-900",
                                                        children: "Everyday Living"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs text-gray-600",
                                                        children: "Cleaning, gardening, meals"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-3xl font-bold text-orange-600 mb-2",
                                        children: formatPercent(contributionData.contributionRates.everydayLiving)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-sm text-gray-700",
                                        children: "Contribution Rate"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-lg border border-gray-200 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: ()=>setShowCalculationDetails(!showCalculationDetails),
                        className: "w-full p-4 flex items-center justify-between hover:bg-gray-50 transition-colors",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-gray-700 font-medium",
                                children: "Show how your contribution is calculated"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: `w-5 h-5 text-gray-400 transition-transform ${showCalculationDetails ? 'rotate-180' : ''}`
                            })
                        ]
                    }),
                    showCalculationDetails && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "px-6 pb-6 pt-4 border-t border-gray-200",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mb-8 pb-8 border-b border-gray-200",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h5", {
                                        className: "text-lg font-bold text-gray-900 mb-4 flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "flex items-center justify-center w-8 h-8 rounded-full bg-brand-navy text-white font-bold text-sm shadow-sm",
                                                children: "1"
                                            }),
                                            "Your Assessable Income"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "bg-gray-50 rounded-xl p-5 mb-3 border border-gray-200",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "space-y-3",
                                            children: [
                                                assessableIncomeBreakdown.map(([label, amount], idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex justify-between items-center text-sm",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "text-gray-600",
                                                                children: [
                                                                    label,
                                                                    ":"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-bold text-gray-900",
                                                                children: formatCurrency(amount)
                                                            })
                                                        ]
                                                    }, idx)),
                                                (financials.totalAssessableIncome || 0) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex justify-between items-center text-base font-bold pt-3 border-t-2 border-gray-300 mt-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-gray-900",
                                                            children: "Total Assessable Income:"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-blue-600",
                                                            children: formatCurrency(financials.totalAssessableIncome)
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-start gap-2 text-xs text-gray-600 bg-slate-50 p-3 rounded-lg border border-slate-200",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                                size: 14,
                                                className: "text-blue-500 flex-shrink-0 mt-0.5"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        className: "text-gray-900",
                                                        children: "How deeming works:"
                                                    }),
                                                    " Financial investments are 'deemed' to earn income at set rates (",
                                                    ((0, $1abe73eeef086faf$export$7ccf16e55e6cf86b) * 100).toFixed(2),
                                                    "% on the first ",
                                                    formatCurrency((0, $1abe73eeef086faf$export$63f1528eb9e21fc5).single),
                                                    " for singles, ",
                                                    formatCurrency((0, $1abe73eeef086faf$export$63f1528eb9e21fc5).couple),
                                                    " for pensioner couples, then ",
                                                    ((0, $1abe73eeef086faf$export$fe9b80c24d06bb6b) * 100).toFixed(2),
                                                    "% above). This deemed income is included in assessable income, even if your actual returns are different."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mb-8 pb-8 border-b border-gray-200",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h5", {
                                        className: "text-lg font-bold text-gray-900 mb-4 flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "flex items-center justify-center w-8 h-8 rounded-full bg-brand-navy text-white font-bold text-sm shadow-sm",
                                                children: "2"
                                            }),
                                            "Your Assessable Assets"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-gray-50 rounded-xl p-5 mb-3 border border-gray-200",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "text-sm mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "font-semibold text-gray-600 mb-2",
                                                        children: isPartnered ? 'Combined Household Assets:' : 'Total Assets:'
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "text-3xl font-bold text-green-600",
                                                        children: formatCurrency(financials.assessableAssets)
                                                    })
                                                ]
                                            }),
                                            isPartnered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "text-xs text-gray-600 mb-2 bg-white rounded-lg p-3 border border-gray-300 mt-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        className: "text-gray-900",
                                                        children: "Individual Assessment:"
                                                    }),
                                                    " Combined household assets split 50/50 for individual contribution calculations",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mt-2 grid grid-cols-2 gap-3 text-gray-700",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "font-semibold",
                                                                children: [
                                                                    factFind?.client?.firstName || 'Client',
                                                                    ": ",
                                                                    formatCurrency((financials.assessableAssets || 0) / 2)
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "font-semibold",
                                                                children: [
                                                                    factFind?.partner?.firstName || 'Partner',
                                                                    ": ",
                                                                    formatCurrency((financials.assessableAssets || 0) / 2)
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "text-xs text-gray-600 pt-3 border-t border-gray-300 mt-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        className: "text-gray-900",
                                                        children: "What's excluded:"
                                                    }),
                                                    " Your principal home, personal effects, funeral bonds, and prepaid funeral plans."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-start gap-2 text-xs text-gray-600 bg-slate-50 p-3 rounded-lg border border-slate-200",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                                size: 14,
                                                className: "text-green-500 flex-shrink-0 mt-0.5"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "Your contribution rate is based on ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        className: "text-gray-900",
                                                        children: "whichever produces the higher rate"
                                                    }),
                                                    " - your assessable income or assessable assets position."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h5", {
                                        className: "text-lg font-bold text-gray-900 mb-4 flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "flex items-center justify-center w-8 h-8 rounded-full bg-brand-navy text-white font-bold text-sm shadow-sm",
                                                children: "3"
                                            }),
                                            "Your Contribution Rate Brackets"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-white rounded-xl p-5 border border-slate-200/70",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: `inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-bold mb-2 shadow-sm ${contributionData.pensionStatus === 'fullPensioner' ? 'bg-green-500 text-white' : contributionData.pensionStatus === 'partPensioner' ? 'bg-yellow-500 text-white' : 'bg-orange-500 text-white'}`,
                                                children: [
                                                    "Status: ",
                                                    contributionData.pensionStatus === 'fullPensioner' ? 'Full Pensioner' : contributionData.pensionStatus === 'partPensioner' ? 'Part Pensioner / CSHC Holder' : 'Self-Funded Retiree'
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-xs text-gray-600 mb-4",
                                                children: [
                                                    "Label is based on your ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "modelled"
                                                    }),
                                                    " pension in this tool, not on a Centrelink letter."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "grid grid-cols-1 md:grid-cols-3 gap-4 text-sm",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "bg-slate-50 rounded-xl p-4 shadow-sm border border-slate-200",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "font-semibold text-gray-600 mb-1 text-xs uppercase tracking-wide",
                                                                children: "Clinical Care"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "text-2xl font-bold text-blue-600",
                                                                children: formatPercent(contributionData.contributionRates.clinical)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "bg-slate-50 rounded-xl p-4 shadow-sm border border-slate-200",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "font-semibold text-gray-600 mb-1 text-xs uppercase tracking-wide",
                                                                children: "Independence"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "text-2xl font-bold text-green-600",
                                                                children: formatPercent(contributionData.contributionRates.independence)
                                                            }),
                                                            contributionData.ratesManuallyOverridden ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "text-xs mt-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "inline-block px-1.5 py-0.5 rounded bg-purple-100 text-purple-800 font-semibold",
                                                                        children: "From official assessment"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                        className: "block text-gray-500 mt-0.5",
                                                                        children: [
                                                                            "Modelled: ",
                                                                            formatPercent(contributionData.modelledContributionRates?.independence)
                                                                        ]
                                                                    })
                                                                ]
                                                            }) : contributionData.participantType === 'nwop' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "text-xs text-gray-500 mt-1",
                                                                children: "No worse off: 0\u201325%, income only"
                                                            }) : contributionData.pensionStatus === 'partPensioner' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "text-xs text-gray-500 mt-1",
                                                                children: "Range: 5-50%"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "bg-slate-50 rounded-xl p-4 shadow-sm border border-slate-200",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "font-semibold text-gray-600 mb-1 text-xs uppercase tracking-wide",
                                                                children: "Everyday Living"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "text-2xl font-bold text-orange-600",
                                                                children: formatPercent(contributionData.contributionRates.everydayLiving)
                                                            }),
                                                            contributionData.ratesManuallyOverridden ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "text-xs mt-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "inline-block px-1.5 py-0.5 rounded bg-purple-100 text-purple-800 font-semibold",
                                                                        children: "From official assessment"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                        className: "block text-gray-500 mt-0.5",
                                                                        children: [
                                                                            "Modelled: ",
                                                                            formatPercent(contributionData.modelledContributionRates?.everydayLiving)
                                                                        ]
                                                                    })
                                                                ]
                                                            }) : contributionData.participantType === 'nwop' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "text-xs text-gray-500 mt-1",
                                                                children: "No worse off: 0\u201325%, income only"
                                                            }) : contributionData.pensionStatus === 'partPensioner' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "text-xs text-gray-500 mt-1",
                                                                children: "Range: 17.5-80%"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    contributionData.participantType === 'nwop' && !contributionData.ratesManuallyOverridden && (()=>{
                                        const nwopCategory = contributionData.nwopCategory === 'A' ? 'A' : 'B';
                                        const income = Number(contributionData.assessableIncome ?? financials.totalAssessableIncome ?? 0);
                                        const incomeMin = contributionData.thresholds.incomeMin;
                                        const incomeMax = contributionData.thresholds.incomeMax;
                                        const step1 = Math.round(Math.max(0, income - incomeMin) * 0.5);
                                        const step2 = Math.round(Math.max(0, incomeMax - incomeMin) * 0.5);
                                        const step3 = step2 > 0 ? Math.min(100, step1 / step2 * 100) : 0;
                                        const positionPct = Math.min(100, Math.max(0, (income - incomeMin) / Math.max(1, incomeMax - incomeMin) * 100));
                                        const rate = contributionData.contributionRates.independence;
                                        const annualCap = contributionData.contributionRates.annualCap;
                                        const fortnightlyCap = annualCap != null ? annualCap / 26 : null;
                                        const previousFeeDaily = fortnightlyCap != null ? fortnightlyCap / 14 : null;
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "mt-4 bg-white border border-slate-200/70 border-l-4 border-blue-500 rounded-lg p-4",
                                            "data-testid": "nwop-walkthrough",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-start gap-2 mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "text-sm text-blue-900 flex-1 min-w-0",
                                                        children: nwopCategory === 'A' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "Why you pay nothing."
                                                                }),
                                                                " Under your Home Care Package you were assessed as not having to pay an income-tested care fee. The Department's 'no worse off' principle keeps it that way for as long as you are in Support at Home \u2014 even if you are reassessed into a higher classification. Your assets and income do not change this."
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "How your 'no worse off' rate is worked out."
                                                                }),
                                                                " Because you paid an income-tested care fee under your package, you now pay a reduced rate that depends on your ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "income only"
                                                                }),
                                                                " \u2014 your assets play no part \u2014 and never more than the fee you paid before.",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "mt-3 space-y-3",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "rounded-xl p-4 border text-xs shadow-sm bg-white border-blue-300 ring-1 ring-blue-200",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                    className: "text-xs font-semibold text-gray-700 uppercase tracking-wide mb-2",
                                                                                    children: "Step 1 \u2014 where your income sits"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                    className: "flex items-center justify-between mb-2",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                                            className: "text-gray-900",
                                                                                            children: [
                                                                                                "Your assessable income: ",
                                                                                                formatCurrency(income)
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                            className: "text-gray-600",
                                                                                            children: [
                                                                                                positionPct.toFixed(1),
                                                                                                "% of the way from ",
                                                                                                formatCurrency(incomeMin),
                                                                                                " to ",
                                                                                                formatCurrency(incomeMax)
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                    className: "h-2 rounded-full bg-slate-200 overflow-hidden",
                                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                        className: "h-2 rounded-full bg-blue-500",
                                                                                        style: {
                                                                                            width: `${positionPct}%`
                                                                                        }
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "bg-white rounded-xl p-4 border border-slate-200/70 border-l-4 border-amber-400 text-xs shadow-sm",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                    className: "text-xs font-semibold text-gray-700 uppercase tracking-wide mb-1.5",
                                                                                    children: "Step 2 \u2014 the arithmetic (Services Australia's method)"
                                                                                }),
                                                                                contributionData.pensionStatus === 'fullPensioner' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                    className: "text-gray-800",
                                                                                    children: [
                                                                                        "As a full pensioner your 'no worse off' rate is ",
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                            className: "text-purple-700 text-sm",
                                                                                            children: "0%"
                                                                                        }),
                                                                                        " on both Independence and Everyday Living."
                                                                                    ]
                                                                                }) : contributionData.pensionStatus === 'selfFunded' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                    className: "text-gray-800",
                                                                                    children: [
                                                                                        "As a self-funded retiree your 'no worse off' rate is the maximum, ",
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                            className: "text-purple-700 text-sm",
                                                                                            children: "25%"
                                                                                        }),
                                                                                        " on both Independence and Everyday Living (the standard rates would be 50% and 80%)."
                                                                                    ]
                                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                    className: "space-y-1 text-gray-800",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                            children: [
                                                                                                "(",
                                                                                                formatCurrency(income),
                                                                                                " \u2212 ",
                                                                                                formatCurrency(incomeMin),
                                                                                                ") \xd7 50% = ",
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                                    children: formatCurrency(step1)
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                            children: [
                                                                                                "(",
                                                                                                formatCurrency(incomeMax),
                                                                                                " \u2212 ",
                                                                                                formatCurrency(incomeMin),
                                                                                                ") \xd7 50% = ",
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                                    children: formatCurrency(step2)
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                            children: [
                                                                                                formatCurrency(step1),
                                                                                                " \xf7 ",
                                                                                                formatCurrency(step2),
                                                                                                " = ",
                                                                                                step3.toFixed(2),
                                                                                                "% of the way \u2192 \xd7 25% = ",
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                                    className: "text-purple-700 text-sm",
                                                                                                    children: formatPercent(rate)
                                                                                                }),
                                                                                                " on both Independence and Everyday Living"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                    className: "text-gray-600 mt-2",
                                                                                    children: "Clinical Care is always 0% \u2014 fully government funded."
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "bg-slate-50 rounded-xl p-4 border border-slate-200 text-xs shadow-sm",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                    className: "text-xs font-semibold text-gray-700 uppercase tracking-wide mb-1.5",
                                                                                    children: "Step 3 \u2014 the ceiling"
                                                                                }),
                                                                                fortnightlyCap != null && previousFeeDaily != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                    className: "text-gray-800",
                                                                                    children: [
                                                                                        "You never pay more than your previous income-tested care fee: ",
                                                                                        formatCurrency(previousFeeDaily),
                                                                                        " a day, so",
                                                                                        ' ',
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                                            children: [
                                                                                                formatCurrency(fortnightlyCap),
                                                                                                " a fortnight"
                                                                                            ]
                                                                                        }),
                                                                                        " (",
                                                                                        formatCurrency(annualCap ?? 0),
                                                                                        " a year).",
                                                                                        contributionData.nwopCapApplied ? ` This year the ceiling applies: without it your contributions would be ${formatCurrency(contributionData.uncappedAnnualContribution ?? 0)}.` : ' Your contributions this year are below it.'
                                                                                    ]
                                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                    className: "text-gray-800",
                                                                                    children: "You never pay more per fortnight than the income-tested care fee you paid before. Record that fee (per day) in Step 3 of your profile and this tool will apply the ceiling."
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        });
                                    })(),
                                    contributionData.pensionStatus === 'partPensioner' && contributionData.participantType !== 'nwop' && (()=>{
                                        const pct = (value, min, max)=>Math.min(100, Math.max(0, (value - min) / (max - min) * 100));
                                        const incomePct = pct(financials.totalAssessableIncome || 0, contributionData.thresholds.incomeMin, contributionData.thresholds.incomeMax);
                                        const assetPct = pct(financials.assessableAssets || 0, contributionData.thresholds.assetMin, contributionData.thresholds.assetMax);
                                        const assetsWin = assetPct >= incomePct;
                                        const winnerPct = assetsWin ? assetPct : incomePct;
                                        const winnerLabel = assetsWin ? 'assets' : 'income';
                                        // Self-check: only show the band arithmetic when it actually reproduces
                                        // the engine's rates (standard part-pensioner bands). NWOP categories and
                                        // special cases use different bands — for them the formula would be a lie,
                                        // so the step falls back to stating the modelled rates alone.
                                        const reproduces = (minRate, maxRate, engineRate)=>Math.abs(minRate + winnerPct / 100 * (maxRate - minRate) - (Number(engineRate) || 0)) < 0.0015;
                                        const bandsMatch = reproduces(0.05, 0.50, contributionData.contributionRates.independence) && reproduces(0.175, 0.80, contributionData.contributionRates.everydayLiving);
                                        const positionBar = (label, value, min, max, position, wins, barColor)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: `rounded-xl p-4 border text-xs shadow-sm ${wins ? 'bg-white border-blue-300 ring-1 ring-blue-200' : 'bg-slate-50 border-slate-200'}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex items-center justify-between mb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                className: "text-gray-900",
                                                                children: [
                                                                    label,
                                                                    ": ",
                                                                    formatCurrency(value)
                                                                ]
                                                            }),
                                                            wins && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "px-2 py-0.5 rounded-full bg-blue-100 text-blue-800 font-semibold",
                                                                children: "sets your rate"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "relative h-3 rounded-full bg-gray-200 overflow-hidden",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: `absolute inset-y-0 left-0 rounded-full ${barColor}`,
                                                            style: {
                                                                width: `${Math.max(2, position)}%`
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex justify-between mt-1 text-gray-500",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                children: [
                                                                    formatCurrency(min),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "block text-[10px]",
                                                                        children: "full-pension threshold"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c0ea688f7c20200$export$2e2bcd8739ae039), {
                                                                title: `${label} \u{2014} how the position is calculated`,
                                                                data: [
                                                                    {
                                                                        label: label,
                                                                        value: formatCurrency(value)
                                                                    },
                                                                    {
                                                                        label: 'Less the full-pension threshold',
                                                                        value: `\u{2212} ${formatCurrency(min)}`
                                                                    },
                                                                    {
                                                                        label: 'Your position in the band',
                                                                        value: formatCurrency(value - min)
                                                                    },
                                                                    {
                                                                        label: "Band width (self-funded \u2212 full-pension)",
                                                                        value: formatCurrency(max - min)
                                                                    },
                                                                    {
                                                                        label: `${formatCurrency(Math.max(0, value - min))} \xf7 ${formatCurrency(max - min)}`,
                                                                        value: `${position.toFixed(1)}% of the way`,
                                                                        emphasis: true
                                                                    }
                                                                ],
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "font-bold text-gray-800 border-b border-dotted border-gray-400 cursor-help",
                                                                    children: [
                                                                        position.toFixed(1),
                                                                        "% of the way"
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "text-right",
                                                                children: [
                                                                    formatCurrency(max),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "block text-[10px]",
                                                                        children: "self-funded threshold"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            });
                                        const formulaLine = (category, minRate, maxRate, engineRate)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-gray-800 mb-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: category
                                                    }),
                                                    " runs from ",
                                                    formatPercent(minRate),
                                                    " (full pensioner) to ",
                                                    formatPercent(maxRate),
                                                    " (self-funded). You're ",
                                                    winnerPct.toFixed(1),
                                                    "% of the way, so:",
                                                    ' ',
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "whitespace-nowrap",
                                                        children: [
                                                            formatPercent(minRate),
                                                            " + ",
                                                            winnerPct.toFixed(1),
                                                            "% \xd7 ",
                                                            formatPercent(maxRate - minRate)
                                                        ]
                                                    }),
                                                    ' ',
                                                    "= ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        className: "text-purple-700 text-sm",
                                                        children: formatPercent(engineRate)
                                                    })
                                                ]
                                            });
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "mt-4 bg-white border border-slate-200/70 border-l-4 border-blue-500 rounded-lg p-4",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-start gap-2 mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "text-sm text-blue-900 flex-1 min-w-0",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "How your part-pension rates are worked out."
                                                            }),
                                                            " As a part pensioner your rates sit between the full-pensioner minimum and the self-funded maximum. Three steps decide exactly where:",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "mt-3 space-y-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                className: "text-xs font-semibold text-gray-700 uppercase tracking-wide mb-2",
                                                                                children: "Step 1 \u2014 where you sit in the part-pension band"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                className: "space-y-2",
                                                                                children: [
                                                                                    positionBar('Your income', financials.totalAssessableIncome || 0, contributionData.thresholds.incomeMin, contributionData.thresholds.incomeMax, incomePct, !assetsWin, 'bg-blue-500'),
                                                                                    positionBar('Your assets', financials.assessableAssets || 0, contributionData.thresholds.assetMin, contributionData.thresholds.assetMax, assetPct, assetsWin, 'bg-green-500')
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "bg-slate-50 rounded-xl p-4 border border-slate-200 text-xs shadow-sm",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                className: "text-xs font-semibold text-gray-700 uppercase tracking-wide mb-1.5",
                                                                                children: "Step 2 \u2014 which one counts"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "text-gray-800",
                                                                                children: [
                                                                                    "Whichever position is further along sets your rate \u2014 for you, that's your ",
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                        children: winnerLabel
                                                                                    }),
                                                                                    " (",
                                                                                    winnerPct.toFixed(1),
                                                                                    "% of the way).",
                                                                                    ' ',
                                                                                    "That also means strategies that reduce your assessable ",
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                        children: winnerLabel
                                                                                    }),
                                                                                    " are the ones that can lower these rates."
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "bg-white rounded-xl p-4 border border-slate-200/70 border-l-4 border-amber-400 text-xs shadow-sm",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                className: "text-xs font-semibold text-gray-700 uppercase tracking-wide mb-1.5",
                                                                                children: "Step 3 \u2014 the arithmetic"
                                                                            }),
                                                                            bandsMatch ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                                children: [
                                                                                    formulaLine('Independence', 0.05, 0.50, contributionData.contributionRates.independence),
                                                                                    formulaLine('Everyday Living', 0.175, 0.80, contributionData.contributionRates.everydayLiving)
                                                                                ]
                                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "text-gray-800 mb-1.5",
                                                                                children: [
                                                                                    "Applying your position to your contribution bands gives",
                                                                                    ' ',
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                        className: "text-purple-700 text-sm",
                                                                                        children: formatPercent(contributionData.contributionRates.independence)
                                                                                    }),
                                                                                    " for Independence and",
                                                                                    ' ',
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                        className: "text-purple-700 text-sm",
                                                                                        children: formatPercent(contributionData.contributionRates.everydayLiving)
                                                                                    }),
                                                                                    " for Everyday Living."
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "text-gray-600 mt-2",
                                                                                children: [
                                                                                    "Clinical Care is always ",
                                                                                    formatPercent(contributionData.contributionRates.clinical),
                                                                                    " \u2014 fully government funded at every means level."
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        });
                                    })(),
                                    setFactFind && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-4 bg-white border border-slate-200/70 border-l-4 border-purple-400 rounded-lg p-4 text-sm",
                                        children: activeOverride && contributionData.ratesManuallyOverridden ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "flex items-center gap-2 mb-2",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "px-2 py-0.5 rounded-full bg-purple-100 text-purple-800 text-xs font-semibold",
                                                        children: "Rates manually overridden"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-gray-800 mb-1",
                                                    children: [
                                                        "Using official rates: ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: formatPercent(activeOverride.independence)
                                                        }),
                                                        " Independence,",
                                                        ' ',
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: formatPercent(activeOverride.everydayLiving)
                                                        }),
                                                        " Everyday Living",
                                                        ' ',
                                                        "(modelled at the time: ",
                                                        formatPercent(activeOverride.modelledIndependenceAtOverride),
                                                        " / ",
                                                        formatPercent(activeOverride.modelledEverydayLivingAtOverride),
                                                        ")."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-xs text-gray-600 mb-2",
                                                    children: [
                                                        "Source: ",
                                                        activeOverride.source || "\u2014",
                                                        " \xb7 Recorded ",
                                                        activeOverride.overriddenAt ? new Date(activeOverride.overriddenAt).toLocaleDateString('en-AU') : "\u2014"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-xs text-gray-600 mb-3",
                                                    children: "These official rates are used everywhere \u2014 the budget, both modelling modes and the suggestion engine. If your finances change materially, Services Australia may reassess; update or remove the override when a new letter arrives."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: removeOverride,
                                                    className: "px-3 py-1.5 text-xs font-semibold rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50",
                                                    children: "Remove override (back to modelled rates)"
                                                })
                                            ]
                                        }) : showOverrideForm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "font-semibold text-gray-900 mb-2",
                                                    children: "Enter the rates from your assessment letter"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "grid grid-cols-1 md:grid-cols-2 gap-3 mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    htmlFor: "ov-indep",
                                                                    className: "block text-xs font-semibold text-gray-700 mb-1",
                                                                    children: "Independence rate (%)"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    id: "ov-indep",
                                                                    type: "number",
                                                                    min: "0",
                                                                    max: "100",
                                                                    step: "0.1",
                                                                    value: overrideIndependencePct,
                                                                    onChange: (e)=>setOverrideIndependencePct(e.target.value),
                                                                    className: "w-full px-3 py-2 border border-gray-300 rounded-lg",
                                                                    placeholder: `Modelled: ${formatPercent(contributionData.contributionRates.independence)}`
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    htmlFor: "ov-edl",
                                                                    className: "block text-xs font-semibold text-gray-700 mb-1",
                                                                    children: "Everyday Living rate (%)"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    id: "ov-edl",
                                                                    type: "number",
                                                                    min: "0",
                                                                    max: "100",
                                                                    step: "0.1",
                                                                    value: overrideEverydayPct,
                                                                    onChange: (e)=>setOverrideEverydayPct(e.target.value),
                                                                    className: "w-full px-3 py-2 border border-gray-300 rounded-lg",
                                                                    placeholder: `Modelled: ${formatPercent(contributionData.contributionRates.everydayLiving)}`
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            htmlFor: "ov-source",
                                                            className: "block text-xs font-semibold text-gray-700 mb-1",
                                                            children: "Where did these rates come from? (required)"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            id: "ov-source",
                                                            type: "text",
                                                            value: overrideSource,
                                                            onChange: (e)=>setOverrideSource(e.target.value),
                                                            className: "w-full px-3 py-2 border border-gray-300 rounded-lg",
                                                            placeholder: 'e.g. "Services Australia assessment letter dated 12 August 2026"'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-xs text-gray-600 mb-2",
                                                    children: "Clinical Care stays 0% \u2014 it is fully government funded for everyone. The date, source and the modelled rates at this moment are recorded with the override for compliance."
                                                }),
                                                overrideError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-xs text-red-600 mb-2",
                                                    children: overrideError
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: saveOverride,
                                                            className: "px-3 py-1.5 text-xs font-semibold rounded-md bg-purple-600 text-white hover:bg-purple-700",
                                                            children: "Use these official rates"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>{
                                                                setShowOverrideForm(false);
                                                                setOverrideError('');
                                                            },
                                                            className: "px-3 py-1.5 text-xs font-semibold rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50",
                                                            children: "Cancel"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex items-start justify-between gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-gray-700 text-xs",
                                                    children: "Been assessed by Services Australia? If your letter shows different rates, you can use the official figures instead of these modelled ones."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>setShowOverrideForm(true),
                                                    className: "shrink-0 px-3 py-1.5 text-xs font-semibold rounded-md border border-purple-300 text-purple-700 hover:bg-purple-50",
                                                    children: "Enter official rates"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: ()=>setShowExampleServicePackage(!showExampleServicePackage),
                        className: "w-full flex items-center justify-between p-4 bg-gray-50 hover:bg-gray-100 rounded-lg border border-gray-200 transition-colors",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                        className: "w-5 h-5 text-gray-500"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-sm font-semibold text-gray-700",
                                        children: [
                                            "Example Service Package (Click to ",
                                            showExampleServicePackage ? 'hide' : 'view',
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            showExampleServicePackage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-gray-500"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-gray-500"
                            })
                        ]
                    }),
                    showExampleServicePackage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-4 bg-white/60 backdrop-blur-xl border border-white rounded-2xl shadow-lg shadow-gray-200/50 p-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d137e5221e5cfba5$export$2e2bcd8739ae039), {
                                                tone: "warning",
                                                children: "EXAMPLE ONLY"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-xs text-gray-600 italic",
                                                children: "This is a hypothetical example. Your actual service package and contributions will be determined by your individual needs and financial position."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "bg-slate-50 border-l-4 border-blue-400 rounded-lg p-4",
                                        children: (()=>{
                                            const clientAcatLevel = factFind?.careNeeds?.clientAcat?.homeCareLevel;
                                            const levelName = clientAcatLevel && (0, $c220d08b55e5dd64$export$bfae9591cc0d7897)[clientAcatLevel]?.label || 'Support at Home - Classification 6';
                                            if (isPartnered && contributionData.budget.client > 0 && contributionData.budget.partner > 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-sm text-gray-700",
                                                children: [
                                                    "Based on an assumed service distribution whereby you require ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "40% Clinical Care, 35% Independence Services and 25% Everyday Living"
                                                    }),
                                                    ", this is how much you would pay based on a ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                        children: [
                                                            "combined service package of ",
                                                            formatCurrency(contributionData.budget.total),
                                                            " per year"
                                                        ]
                                                    }),
                                                    " (",
                                                    factFind?.client?.firstName || 'John',
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: formatCurrency(contributionData.budget.client)
                                                    }),
                                                    ", ",
                                                    factFind?.partner?.firstName || 'Kim',
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: formatCurrency(contributionData.budget.partner)
                                                    }),
                                                    ")."
                                                ]
                                            });
                                            else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-sm text-gray-700",
                                                children: [
                                                    "Based on an assumed service distribution whereby you require ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "40% Clinical Care, 35% Independence Services, and 25% Everyday Living"
                                                    }),
                                                    ", this is how much you would pay based on your ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: levelName
                                                    }),
                                                    " which has a total funding package of ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: formatCurrency(contributionData.budget.total)
                                                    }),
                                                    " per year."
                                                ]
                                            });
                                        })()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-3 gap-3 mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-gray-50 border border-gray-200 rounded-lg p-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "text-xs font-medium text-gray-600 mb-1",
                                                children: "Clinical"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "text-xl font-bold text-gray-900",
                                                children: formatCurrency(contributionData.contributionAmounts.clinical)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "text-xs text-gray-500 mt-1",
                                                children: [
                                                    formatPercent(contributionData.contributionRates.clinical),
                                                    " rate"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-gray-50 border border-gray-200 rounded-lg p-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "text-xs font-medium text-gray-600 mb-1",
                                                children: "Independence"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "text-xl font-bold text-gray-900",
                                                children: formatCurrency(contributionData.contributionAmounts.independence)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "text-xs text-gray-500 mt-1",
                                                children: [
                                                    formatPercent(contributionData.contributionRates.independence),
                                                    " rate"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-gray-50 border border-gray-200 rounded-lg p-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "text-xs font-medium text-gray-600 mb-1",
                                                children: "Everyday Living"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "text-xl font-bold text-gray-900",
                                                children: formatCurrency(contributionData.contributionAmounts.everydayLiving)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "text-xs text-gray-500 mt-1",
                                                children: [
                                                    formatPercent(contributionData.contributionRates.everydayLiving),
                                                    " rate"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-gray-50 border border-gray-300 rounded-lg p-5 mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center justify-between mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-base font-semibold text-gray-700",
                                                children: "Total Annual Contribution:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-3xl font-bold text-gray-900",
                                                children: formatCurrency(contributionData.contributionAmounts.totalAnnual)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "text-sm text-gray-600 text-right",
                                        children: [
                                            formatCurrency(contributionData.contributionAmounts.totalAnnual / 12),
                                            " per month"
                                        ]
                                    }),
                                    contributionData.nwopCapApplied && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-2 text-xs text-blue-900 bg-white border border-blue-200 rounded-lg px-3 py-2",
                                        children: [
                                            "Capped at your previous income-tested care fee (",
                                            formatCurrency((contributionData.contributionRates.annualCap ?? 0) / 26),
                                            " a fortnight) under the 'no worse off' principle. Without the cap this year's contributions would be ",
                                            formatCurrency(contributionData.uncappedAnnualContribution ?? 0),
                                            "."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white/50 rounded-lg p-5 border border-gray-200",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                        className: "text-base font-bold text-gray-900 mb-4 flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4 text-gray-600"
                                            }),
                                            "Impact on Your ",
                                            isPartnered ? 'Household' : '',
                                            " Annual Cashflow"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between items-center bg-gray-50 rounded-lg p-3 border border-gray-200",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-sm font-medium text-gray-700",
                                                        children: "Your Current Annual Cashflow:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-lg font-bold text-gray-900",
                                                        children: formatCurrency(financials.cashFlow || 0)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between items-center bg-gray-50 rounded-lg p-3 border border-gray-200",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-sm font-medium text-gray-700",
                                                        children: "Less: Support at Home Contribution:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-lg font-bold text-red-600",
                                                        children: [
                                                            "-",
                                                            formatCurrency(contributionData.contributionAmounts.totalAnnual)
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "pt-3 border-t-2 border-gray-300 bg-gray-50 rounded-lg p-3 border border-gray-200",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex justify-between items-center mb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-sm font-semibold text-gray-900",
                                                                children: "Your Net Annual Cashflow:"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: `text-xl font-bold ${(financials.cashFlow || 0) - contributionData.contributionAmounts.totalAnnual >= 0 ? 'text-green-600' : 'text-red-600'}`,
                                                                children: formatCurrency((financials.cashFlow || 0) - contributionData.contributionAmounts.totalAnnual)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "text-xs text-gray-600 mt-3 pt-3 border-t border-gray-200",
                                                        children: [
                                                            isPartnered ? "This assumes the combined household example service package is paid from your current household income sources." : "This assumes the example service package is paid from your current income sources.",
                                                            contributionData.contributionAmounts.totalAnnual > (financials.cashFlow || 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "block mt-2 text-red-600 font-medium",
                                                                children: "\xe2\u0161\xa0\xef\xb8\x8f Your cashflow may need adjustment to cover these costs."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            yearsToCap && !isPartnered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-4 bg-white/50 rounded-lg p-4 border border-gray-200",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center justify-between mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm font-semibold text-gray-700",
                                                children: "Lifetime Cap:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-xl font-bold text-gray-900",
                                                children: formatCurrency(contributionData.lifetimeCap)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "text-xs text-gray-600",
                                        children: [
                                            "At this contribution level, you would reach the lifetime cap in approximately ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                className: "text-gray-900",
                                                children: [
                                                    yearsToCap,
                                                    " ",
                                                    yearsToCap === 1 ? 'year' : 'years'
                                                ]
                                            }),
                                            ", after which you'd pay no more fees for Support at Home services."
                                        ]
                                    })
                                ]
                            }),
                            yearsToCap && isPartnered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-4 bg-white/50 rounded-lg p-4 border border-gray-200",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center justify-between mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm font-semibold text-gray-700",
                                                children: "Lifetime Cap (per person):"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-xl font-bold text-gray-900",
                                                children: formatCurrency(contributionData.lifetimeCap)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "text-xs text-gray-600",
                                        children: [
                                            "Combined household cap: ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                className: "text-gray-900",
                                                children: formatCurrency(contributionData.lifetimeCap * 2)
                                            }),
                                            " \u2013 At this combined contribution level, you would reach the lifetime cap in approximately ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                className: "text-gray-900",
                                                children: [
                                                    yearsToCap,
                                                    " ",
                                                    yearsToCap === 1 ? 'year' : 'years'
                                                ]
                                            }),
                                            ", after which you'd pay no more fees for Support at Home services."
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white border border-slate-200/70 border-l-4 border-blue-500 rounded-lg p-5 shadow-sm",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-start gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e57d6b071418ede9$export$2e2bcd8739ae039), {
                            className: "w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "font-bold text-blue-900 mb-2",
                                    children: "Next: what care do you actually need?"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-sm text-gray-800",
                                    children: [
                                        "The rates above are percentages \u2014 what they cost depends on the services in your plan. Click",
                                        ' ',
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: '"Next"'
                                        }),
                                        " to build the service plan, and you will see the real dollars rather than an illustrative package. After that, ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Optimise Your Plan"
                                        }),
                                        " looks at whether those rates themselves can be lowered: some clients see real reductions through careful planning, others find their rates cannot be moved much."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $3f5d3aca8a0d692e$export$2e2bcd8739ae039 = $3f5d3aca8a0d692e$var$ContributionsSection;


/**
 * StrategiesSection.js - Support at Home "Optimise Your Plan" / strategies tab.
 * Manual and suggestion strategies, projections modal, aged care integration.
 */ 

/**
 * IS THE CHOSEN SUPPORT AT HOME PLAN STILL FOR THIS HOUSEHOLD? (25 Oct 2026)
 *
 * A plan chosen with both at home ("Spend $416,000 on the home…", $4,379,840) stayed on Home as the chosen plan,
 * at that figure, after John's aged care plan was carried in — when the plans tested for the household as it is
 * now did not include it at all. The household a plan was priced on is the aged care plan carried with it (none,
 * or which one); that is recorded when it is chosen (`inputs.householdFingerprint`, the same key the plans page
 * checks its own run against) and compared here with the household now, so Home, the plan page and step 3 say the
 * same thing without re-testing anything.
 */ /**
 * The household and options every Support at home figure is priced on — ONE place (rebuild M3,
 * 19 Oct 2026), so step 2's four numbers, step 1's money panel and the engine's plans cannot be
 * priced on different households.
 *
 *  - Step 1's question "Is Colin moving into aged care?" (goals.sahAgedCareMove). "Yes": the person
 *    moving has no Support at home services priced, and the chosen aged care plan is included — its
 *    room deposit paid, its living costs, its residency (illness-separated), and its yearly fees
 *    charged (pack B.SAH.6). "No" or "Not sure": both at home, as today.
 *  - The support start date rides the same options bag (the aged care "entry timing belongs to the
 *    case" rule).
 *
 * THE WHOLE AGED CARE PLAN (owner, 24 Oct 2026: "carry the whole aged care plan into Support at Home
 * ... ultimately it's their reality"). The household is priced as it stands once the chosen aged care
 * plan has been carried out — the same rebuild the forms use for "the position after the plan"
 * (features/forms/planPosition.ts): the deposit paid, and every other piece of that plan too (a home
 * or property sold, gifts, a funeral bond, an annuity, debts cleared, a second room). Until then only
 * the deposit was applied. The deposit-only path stays as the fallback when the plan cannot be rebuilt.
 */ 

/**
 * Which position a pre-filled form is filled from: the client as they stand TODAY, or as they will
 * stand once a saved plan has been carried out (owner, 3 Oct 2026).
 *
 * "When we fill in the SA457, is this based on the current position or post strategy? ... allow the
 * user to do either in the event it was time critical (they were going to put mum/dad in immediately
 * and then restructure some assets after)." So every pre-filled Services Australia form offers both:
 *
 *   - today's position, to lodge now — and report each change within 14 days as the plan is done;
 *   - the position after a saved plan, to lodge once the changes are made — never before, because
 *     Services Australia assesses what you own and earn on the day it decides.
 *
 * No module saves the after-the-plan profile itself; each saves the plan's inputs. So the position is
 * rebuilt here with the SAME code each module models the plan with — its own applier, or the
 * engine's over the calculation API — so the form and the plan's figures cannot describe two
 * different households.
 */ 



/**
 * A manual Support at Home plan, applied to the client's profile: the position once the plan is in
 * place. Moved out of StrategiesSection's memo, unchanged, so the Action Plan can fill the SA456 from
 * the same position for a plan saved earlier (owner, 3 Oct 2026).
 *
 * Funeral bonds, gifting, the home (downsize, renovate or upgrade), a reverse mortgage, the linked
 * aged care deposit and living expenses, then the annuity. HEAS deliberately changes nothing here.
 */ 


/**
 * SupportAtHomeHelpers.js – Shared constants and helpers for Support at Home flow.
 * Used by SupportAtHomePage, StrategiesSection, and ServiceBuilderSection.
 */ 

/**
 * Re-exported from the shared calculation, not reimplemented.
 *
 * The downsize mutator moved to `shared/src/calculation/support/downsizeEvent.ts` so the projection
 * engine can execute it on a DATED day against live balances (`downsizeEventPlugin`). This wrapper
 * keeps the original call signature — callers pass a DraftFactFind and get one back — so the Support
 * at Home and Downsizer modules did not have to change.
 */ /**
 * The downsize, as one applyable event: sell the home, buy the new one, make the contributions and
 * gifts, deploy the residue, bank the rest.
 *
 * THE one implementation, moved here from the frontend's `supportAtHomeFactFindMutators.tsx` so the
 * PROJECTION ENGINE can perform it on a dated day against live balances — the same journey the RAD
 * funding sale made. The frontend re-exports this function, so the Support at Home and Downsizer
 * modules keep calling exactly what they always called; only the module it lives in moved.
 *
 * A NOTE ON PRICES UNDER DEFERRAL. `details.salePrice` and `details.newHomePurchasePrice` are the
 * adviser's entered figures and are used AS ENTERED whenever the event happens — the engine does not
 * grow them to the event date. That is deliberate: an adviser modelling a sale two years out enters
 * the price they expect to achieve then, and silently indexing their number would second-guess it.
 * The step this can create in net worth (selling above or below the home's carried value) is real
 * economics, not an error.
 */ 




/**
 * Sells the client's chosen assets to cover a buy-up shortfall — the same arithmetic the RAD funding
 * sale uses (same key parsing, same CGT resolution, same per-asset clamp), ported with the mutator so
 * the engine can reach it.
 */ function $7d7b7fd5809c11f4$var$liquidateChosenAssetsForDownsize(factFind, fundingMap, cgtOverrides = {}) {
    const modified = structuredClone(factFind);
    if (!fundingMap) return {
        factFind: modified,
        net: 0,
        gross: 0,
        cgt: 0
    };
    let net = 0, gross = 0, cgt = 0;
    Object.entries(fundingMap).forEach(([assetKey, amount])=>{
        const parsed = (0, $85f2560fc9a239a0$export$eb5d467aa7d657c6)(assetKey);
        if (!parsed) return;
        const entry = (0, $85f2560fc9a239a0$export$351785600ef65fdf)(factFind, assetKey, amount, cgtOverrides);
        if (entry.gross <= 0) return;
        const located = (0, $85f2560fc9a239a0$export$f59ccf8b394d8480)(modified, parsed.assetType, parsed.assetId);
        if (!located) return;
        located.asset.value = (located.asset.value || 0) - entry.gross;
        if (parsed.assetType === 'accountBasedPensions') (0, $e0f54937e270d5ff$export$399e556d15149d82)(located.asset, modified, 1);
        net += entry.net;
        gross += entry.gross;
        cgt += entry.cgt;
    });
    return {
        factFind: modified,
        net: net,
        gross: gross,
        cgt: cgt
    };
}
function $7d7b7fd5809c11f4$export$14c0efde6a220065(factFind, details = {}, eventDate = new Date()) {
    const modified = structuredClone(factFind);
    const currentHomeValue = Number(factFind.home?.value) || 0;
    const salePrice = Number(details.salePrice ?? currentHomeValue) || currentHomeValue;
    const sellingCosts = Number(details.sellingCosts) || 0;
    // Duty on the new home comes off the proceeds like the selling costs do — a sunk cost of the
    // changeover that the model never charged before 23 Sep 2026 (the owner had been carrying it in
    // his head). Zero where no state was chosen: no state, no guess.
    const stampDuty = Number(details.stampDuty) || 0;
    let remainingProceeds = Math.max(0, salePrice - sellingCosts - stampDuty);
    if (!modified.assets) modified.assets = {};
    const newHomePurchase = Math.max(0, Number(details.newHomePurchasePrice) || 0);
    if (modified.home) modified.home.value = newHomePurchase > 0 ? newHomePurchase : 0;
    else if (newHomePurchase > 0) modified.home = {
        value: newHomePurchase
    };
    remainingProceeds -= newHomePurchase;
    /*
     * SELL AND RENT (2 Oct 2026). A plan that buys no new home and says so becomes a renting
     * household: both members are non-homeowners from the day of sale (the higher assets-test
     * limit, and Rent Assistance on the rent they now pay), and the rent is charged from then
     * on — as the household's housing cost (assessment/expenses.ts `calculateHousingCosts`, which
     * reads `rent.rentAmount` for a renting household and escalates it with CPI; until 8 Oct 2026
     * a year of it was added to living expenses instead, which double-charged it once housing
     * costs became a line of their own).
     * Before this the engine zeroed the home and left the residency, the thresholds and the
     * budget as they were, so renting cost nothing and paid no assistance (owner-caught).
     *
     * Gated on `rentInstead`, never on a nil price alone: the Support at Home engine's downsize
     * candidates have always carried a target price and must not change meaning.
     */ const rentPerWeek = details.rentInstead === true ? Math.max(0, Number(details.rentPerWeek) || 0) : 0;
    if (details.rentInstead === true && newHomePurchase <= 0) {
        if (modified.client) modified.client.currentResidency = 'renting';
        if (factFind.adviceFor === 'couple' && modified.partner) modified.partner.currentResidency = 'renting';
        if (rentPerWeek > 0) modified.rent = {
            ...modified.rent || {},
            rentAmount: rentPerWeek,
            landlordType: modified.rent?.landlordType || 'private',
            sharedAccommodation: modified.rent?.sharedAccommodation ?? false
        };
    }
    // "Buying up": the new home costs MORE than the net sale proceeds — fund the gap from the client's
    // chosen assets, then the bank, so the exempt home never rises without an asset being spent.
    if (remainingProceeds < 0) {
        let shortfall = -remainingProceeds;
        remainingProceeds = 0;
        const buyUpFunding = details.buyUpFunding;
        if (buyUpFunding && Object.keys(buyUpFunding).length > 0) {
            const liq = $7d7b7fd5809c11f4$var$liquidateChosenAssetsForDownsize(modified, buyUpFunding, details.buyUpCgtOverrides || {});
            modified.assets = liq.factFind.assets;
            const cover = Math.min(liq.net, shortfall);
            shortfall -= cover;
            remainingProceeds += Math.max(0, liq.net - cover);
        }
        if (shortfall > 0) (0, $85f2560fc9a239a0$export$e820d52c8da26912)(modified.assets, shortfall);
    }
    const addedAssets = Array.isArray(details.addedAssets) ? details.addedAssets : [];
    addedAssets.forEach((asset)=>{
        const assetType = String(asset.type || 'bankAccounts');
        const assetValue = Math.max(0, Number(asset.value) || 0);
        if (assetValue <= 0) return;
        remainingProceeds -= assetValue;
        if (!modified.assets[assetType]) modified.assets[assetType] = [];
        const payload = {
            id: asset.id || `downsize-${assetType}-${Math.random().toString(36).slice(2, 10)}`,
            type: assetType,
            description: asset.description || 'Downsize Allocation',
            value: assetValue,
            ownership: asset.ownership || (factFind.adviceFor === 'couple' ? 'joint' : 'client')
        };
        if (asset.incomeRate !== undefined && asset.incomeRate !== '') payload.incomeRate = Number(asset.incomeRate) || 0;
        if (asset.growthRate !== undefined && asset.growthRate !== '') payload.growthRate = Number(asset.growthRate) || 0;
        if (asset.frankingCredit !== undefined && asset.frankingCredit !== '') payload.frankingCredit = Number(asset.frankingCredit) || 0;
        if (asset.costBase !== undefined && asset.costBase !== '') payload.costBase = Number(asset.costBase) || 0;
        modified.assets[assetType].push(payload);
    });
    const clientDownsizer = Math.max(0, Number(details.downsizerContribution) || 0);
    const partnerDownsizer = Math.max(0, Number(details.partnerDownsizerContribution) || 0);
    (0, $f1228be62b68f76b$export$a72a115b20fefbbf)(modified.assets, factFind, details, {
        assetId: 'downsizer-client',
        partnerAssetId: 'downsizer-partner'
    });
    remainingProceeds -= clientDownsizer + partnerDownsizer;
    const giftingAmount = Math.max(0, Number(details.giftingAmount) || 0);
    if (giftingAmount > 0) {
        // The financial year the EVENT falls in — a deferred downsize's gift is made when the money
        // exists to give, and the deprivation clock runs from there.
        // Dated to the event, so the five years run from that day (24 Oct 2026).
        (0, $171a6d8ba8937a5f$export$653e7b96a80afaf8)(modified, giftingAmount, eventDate);
        remainingProceeds -= giftingAmount;
    }
    /*
     * FUNERAL BONDS FROM THE PROCEEDS.
     *
     * `DownsizeDetails` has declared this field all along and nothing on the downsize path read it,
     * so a plan that allocated money to a bond quietly left it in the bank — counted, deemed, and
     * reported as though the allocation had happened. Found while adding it as a Suggestion Engine
     * candidate (2026-08-27): the candidate would have been a silent no-op.
     *
     * It matters here more than almost anywhere: the downsizing trap IS that the home was exempt and
     * the money it becomes is not, and a funeral bond is the cheapest way to put part of that money
     * back outside the assets test. The same treatment the village and entity-IP-sale paths have
     * always given it.
     *
     * The published per-person limit is NOT enforced here. That is deliberate and matches gifting
     * above: this function executes what the plan says, and the callers that build a plan are where
     * the limit belongs — the engine reporting a bond larger than the exemption as fully exempt
     * would be a different bug, and one for the assessment to catch, not this.
     */ const funeralBondPurchase = Math.max(0, Number(details.funeralBondPurchase) || 0);
    if (funeralBondPurchase > 0) {
        if (!modified.assets) modified.assets = {};
        if (!modified.assets.funeralBonds) modified.assets.funeralBonds = [];
        modified.assets.funeralBonds.push({
            id: 'downsize-funeral-bond',
            type: 'funeralBonds',
            description: 'Funeral bond (from home sale)',
            value: funeralBondPurchase,
            ownership: factFind.adviceFor === 'couple' ? 'joint' : 'client',
            income: 0,
            growthRate: 0
        });
        remainingProceeds -= funeralBondPurchase;
    }
    const debtRepayment = Math.max(0, Number(details.debtRepayment) || 0);
    const selectedDebtKey = details.selectedDebtKey;
    if (debtRepayment > 0 && selectedDebtKey && modified.liabilities) {
        const [liabilityType, liabilityId] = selectedDebtKey.split(':');
        const liabilityList = modified.liabilities[liabilityType];
        if (Array.isArray(liabilityList)) {
            const target = liabilityList.find((item)=>String(item.id) === String(liabilityId));
            if (target) {
                const currentBalance = Math.max(0, target.balance ?? target.value ?? 0);
                const newBalance = Math.max(0, currentBalance - debtRepayment);
                if (target.balance !== undefined) target.balance = newBalance;
                else target.value = newBalance;
            }
        }
        remainingProceeds -= debtRepayment;
    }
    if (details.deployment) {
        const deployed = (0, $86923a7f40531161$export$efee12160933bebf)(modified, details.deployment, {
            factFind: factFind,
            idPrefix: 'downsize-deploy',
            defaultOwnership: factFind.adviceFor === 'couple' ? 'joint' : 'client'
        });
        remainingProceeds -= deployed;
    }
    let surplusToBank = 0;
    if (remainingProceeds > 0) {
        surplusToBank = remainingProceeds;
        if (!modified.assets) modified.assets = {};
        if (!modified.assets.bankAccounts) modified.assets.bankAccounts = [];
        if (modified.assets.bankAccounts.length > 0) {
            const first = modified.assets.bankAccounts[0];
            first.value = (Number(first.value) || 0) + remainingProceeds;
        } else modified.assets.bankAccounts.push({
            id: 'downsize-surplus',
            type: 'bankAccounts',
            description: 'Downsize Surplus',
            value: remainingProceeds,
            ownership: factFind.adviceFor === 'couple' ? 'joint' : 'client',
            incomeRate: 2,
            growthRate: 0
        });
    }
    return {
        factFind: modified,
        salePrice: salePrice,
        sellingCosts: sellingCosts,
        newHomePurchase: newHomePurchase,
        stampDuty: stampDuty,
        surplusToBank: surplusToBank,
        rentPerWeek: rentPerWeek
    };
}


const $41978d8498e37f65$export$e9de74ff7fc60a05 = (factFind, details = {})=>(0, $7d7b7fd5809c11f4$export$14c0efde6a220065)(factFind, details).factFind;





const $a1c4193edeff7c3c$export$42edd27decf8c272 = 300000;
const $a1c4193edeff7c3c$export$74909d8cea0fb99b = (asset, saleAmount, beforeFinancials)=>{
    const value = parseFloat(String(asset.value)) || 0;
    if (!value || saleAmount <= 0) return 0;
    // `taxContext` comes from calculateFinancials; the fallback covers a payload predating it.
    const taxContext = beforeFinancials?.taxContext ?? (0, $1fbcfc2df3ed29e9$export$ccfe146b55a752dd)(beforeFinancials?.clientAssessableIncome || 0, beforeFinancials?.partnerAssessableIncome || 0, asset.ownership === 'joint' || asset.ownership === 'partner');
    // DraftAsset is structurally compatible with FactFindAsset (see types/formDraft.ts); the shared
    // calc-engine fn defensively coerces internally regardless, so this cast is safe (see
    // factFindTypes.ts header comment).
    return (0, $1fbcfc2df3ed29e9$export$c06c916a0ca433d3)({
        taxContext: taxContext,
        asset: asset,
        salePrice: saleAmount,
        // Brokerage on a share sale is immaterial at this level of estimate.
        sellingCosts: 0,
        originalAssetValue: value
    }).estimatedCGT;
};
/**
 * Sells the nominated funding assets for a renovate/upgrade and returns what they actually raised.
 *
 * WHAT IS RAISED, NOT WHAT WAS ASKED (25 Oct 2026). A source's request is capped at what the account
 * holds now, and a source that is no longer there — an account the linked aged care plan has already
 * spent on its deposit — raises nothing. The old code counted the request in full either way, so a
 * plan funded from accounts the deposit had emptied added the whole renovation to the home while
 * taking almost nothing out: net worth rose by money nobody had (+$375,000 on a $416,000 renovation).
 */ const $a1c4193edeff7c3c$var$sellFundingSources = (modified, fundingSources, need, beforeFinancials)=>{
    let raised = 0;
    for (const funding of fundingSources){
        if (raised >= need) break;
        const amount = parseFloat(String(funding.amount)) || 0;
        if (amount <= 0) continue;
        const assetList = modified.assets?.[funding.assetType];
        if (!assetList || !Array.isArray(assetList)) continue;
        const asset = assetList.find((a)=>String(a.id) === String(funding.assetId));
        if (!asset) continue;
        const assetValue = parseFloat(String(asset.value)) || 0;
        // Nothing is sold beyond what the work still needs, so an over-full allocation loses nothing.
        const saleAmount = Math.min(amount, assetValue, need - raised);
        if (saleAmount <= 0) continue;
        if ([
            'shares',
            'investmentProperty'
        ].includes(funding.assetType) && asset.costBase) {
            const cgt = $a1c4193edeff7c3c$export$74909d8cea0fb99b(asset, saleAmount, beforeFinancials);
            (0, $bd80071df75c742b$export$ade9707014c4664e)(modified.assets, cgt, asset.ownership);
        }
        const newValue = Math.max(0, assetValue - saleAmount);
        if (newValue > 0) asset.value = newValue;
        else assetList.splice(assetList.indexOf(asset), 1);
        raised += saleAmount;
    }
    return raised;
};
/**
 * Takes what the named sources did not cover from the bank — the personal account first, then the
 * others — and returns what it could take. Never more than the accounts hold, so nothing is spent
 * that is not there.
 */ const $a1c4193edeff7c3c$var$takeFromBanks = (modified, amount)=>{
    const want = Math.max(0, amount);
    const banks = modified.assets?.bankAccounts;
    if (want <= 0 || !Array.isArray(banks) || banks.length === 0) return 0;
    const personal = (0, $bd80071df75c742b$export$ff72348c3c269e0f)(modified.assets);
    const order = personal ? [
        personal,
        ...banks.filter((b)=>b !== personal)
    ] : [
        ...banks
    ];
    let taken = 0;
    for (const bank of order){
        if (taken >= want) break;
        const held = Math.max(0, parseFloat(String(bank.value)) || 0);
        const take = Math.min(held, want - taken);
        bank.value = held - take;
        taken += take;
    }
    return taken;
};
const $a1c4193edeff7c3c$export$1749088a1c3f6df1 = (factFind, details, beforeFinancials = {})=>{
    const modified = structuredClone(factFind);
    const renovationAmount = parseFloat(String(details.renovationAmount)) || 0;
    if (renovationAmount <= 0) return modified;
    const raised = $a1c4193edeff7c3c$var$sellFundingSources(modified, details.fundingSources || [], renovationAmount, beforeFinancials);
    const spent = raised + $a1c4193edeff7c3c$var$takeFromBanks(modified, renovationAmount - raised);
    if (modified.home) {
        const currentHomeValue = parseFloat(String(modified.home.value)) || 0;
        modified.home.value = currentHomeValue + spent;
    } else modified.home = {
        value: spent
    };
    return modified;
};
const $a1c4193edeff7c3c$export$93b8ecbdf35897d9 = (factFind, details, beforeFinancials = {})=>{
    const modified = structuredClone(factFind);
    const currentHomeValue = parseFloat(String(details.currentHomeValue || factFind.home?.value)) || 0;
    const newHomePurchasePrice = parseFloat(String(details.newHomePurchasePrice)) || 0;
    const sellingCosts = parseFloat(String(details.sellingCosts)) || 0;
    if (newHomePurchasePrice <= currentHomeValue) return modified;
    const netProceedsFromSale = Math.max(0, currentHomeValue - sellingCosts);
    const additionalFundsNeeded = newHomePurchasePrice - netProceedsFromSale;
    if (additionalFundsNeeded <= 0) {
        if (modified.home) modified.home.value = newHomePurchasePrice;
        else modified.home = {
            value: newHomePurchasePrice
        };
        const surplus = Math.abs(additionalFundsNeeded);
        if (surplus > 0 && modified.assets?.bankAccounts && modified.assets.bankAccounts.length > 0) {
            const firstBankAccount = modified.assets.bankAccounts[0];
            const currentBalance = parseFloat(String(firstBankAccount.value)) || 0;
            firstBankAccount.value = currentBalance + surplus;
        }
        return modified;
    }
    const raised = $a1c4193edeff7c3c$var$sellFundingSources(modified, details.fundingSources || [], additionalFundsNeeded, beforeFinancials);
    const added = raised + $a1c4193edeff7c3c$var$takeFromBanks(modified, additionalFundsNeeded - raised);
    const paid = netProceedsFromSale + added;
    if (modified.home) modified.home.value = paid;
    else modified.home = {
        value: paid
    };
    return modified;
};
const $a1c4193edeff7c3c$export$1d4431839363ff69 = [
    // Property getters throughout so a licensee's capital market assumptions apply at use time.
    {
        id: 'bankAccounts',
        label: 'Bank account',
        defaults: {
            get incomeRate () {
                return (0, $0f2c0a6799fe36da$export$b037eefb915b86ec).bankIncomePct;
            },
            growthRate: 0
        }
    },
    {
        id: 'termDeposits',
        label: 'Term deposit',
        defaults: {
            get incomeRate () {
                return (0, $0f2c0a6799fe36da$export$b037eefb915b86ec).termDepositIncomePct;
            },
            growthRate: 0
        }
    },
    {
        id: 'shares',
        label: 'Shares / Managed funds',
        defaults: {
            get incomeRate () {
                return (0, $0f2c0a6799fe36da$export$b037eefb915b86ec).sharesIncomePct;
            },
            get growthRate () {
                return (0, $0f2c0a6799fe36da$export$b037eefb915b86ec).sharesGrowthPct;
            },
            get frankingCredit () {
                return (0, $0f2c0a6799fe36da$export$b037eefb915b86ec).sharesFrankingPct;
            }
        }
    },
    // Balanced presets from the one published table — property getters so the rate is read at USE
    // time and a licensee's own capital market assumptions apply (see investmentProfiles.ts).
    {
        id: 'superannuation',
        label: 'Superannuation',
        defaults: {
            incomeRate: 0,
            get growthRate () {
                return (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703).balanced.accumulationNetPct;
            }
        }
    },
    {
        id: 'accountBasedPensions',
        label: 'Account-based pension',
        defaults: {
            incomeRate: 0,
            get growthRate () {
                return (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703).balanced.pensionNetPct;
            }
        }
    },
    {
        id: 'investmentProperty',
        label: 'Investment property',
        defaults: {
            get incomeRate () {
                return (0, $0f2c0a6799fe36da$export$b037eefb915b86ec).propertyYieldPct;
            },
            get growthRate () {
                return (0, $0f2c0a6799fe36da$export$b037eefb915b86ec).propertyGrowthPct;
            }
        }
    },
    {
        id: 'personalAssets',
        label: 'Personal asset',
        defaults: {
            incomeRate: 0,
            growthRate: 0
        }
    },
    {
        id: 'other',
        label: 'Other asset',
        defaults: {
            incomeRate: 0,
            growthRate: 0
        }
    }
];




function $d89d3f0f7a42703f$export$e852251532541c4f(factFind, inputs) {
    const { manualStrategies: manualStrategies, propertyStrategy: propertyStrategy, downsizeDetails: downsizeDetails, renovateDetails: renovateDetails, upgradeDetails: upgradeDetails, overallStrategy: overallStrategy, reverseMortgageDetails: reverseMortgageDetails, selectedAgedCareIntegration: selectedAgedCareIntegration, selectedFundingStrategy: selectedFundingStrategy, annuityRecordForCalculation: annuityRecordForCalculation, beforeFinancials: beforeFinancials } = inputs;
    let optimizedFactFind = structuredClone(factFind);
    // Helper to reduce asset value based on source
    const reduceAssetValue = (assetList, amountToReduce)=>{
        let remaining = Number(amountToReduce) || 0;
        for (const asset of assetList){
            if (remaining <= 0) break;
            const currentValue = parseFloat(String(asset.value)) || 0;
            const reduction = Math.min(currentValue, remaining);
            asset.value = currentValue - reduction;
            remaining -= reduction;
        }
    };
    // Apply funeral bonds (add to exempt assets AND reduce source asset)
    if (Number(manualStrategies.funeralBonds) > 0) {
        if (!optimizedFactFind.assets) optimizedFactFind.assets = {};
        if (!optimizedFactFind.assets.funeralBonds) optimizedFactFind.assets.funeralBonds = [];
        optimizedFactFind.assets.funeralBonds.push({
            id: 'opt-funeral-bond',
            type: 'funeralBonds',
            description: 'Optimised Funeral Bond',
            value: Number(manualStrategies.funeralBonds) || 0,
            ownership: 'client'
        });
        if (manualStrategies.funeralSource === 'bank' && optimizedFactFind.assets.bankAccounts) reduceAssetValue(optimizedFactFind.assets.bankAccounts, manualStrategies.funeralBonds);
        else if (manualStrategies.funeralSource === 'abp' && optimizedFactFind.assets.accountBasedPensions) reduceAssetValue(optimizedFactFind.assets.accountBasedPensions, manualStrategies.funeralBonds);
        else if (manualStrategies.funeralSource === 'shares' && optimizedFactFind.assets.shares) reduceAssetValue(optimizedFactFind.assets.shares, manualStrategies.funeralBonds);
    }
    // Apply gifting: add to giftsHistory AND reduce source asset
    if (Number(manualStrategies.gifting) > 0) {
        // Dated to today (24 Oct 2026). It was keyed by the CALENDAR year, which put an October gift in
        // the previous financial year; the five years now run from the day.
        (0, $171a6d8ba8937a5f$export$653e7b96a80afaf8)(optimizedFactFind, Number(manualStrategies.gifting), new Date());
        if (manualStrategies.giftingSource === 'bank' && optimizedFactFind.assets?.bankAccounts) reduceAssetValue(optimizedFactFind.assets.bankAccounts, manualStrategies.gifting);
        else if (manualStrategies.giftingSource === 'abp' && optimizedFactFind.assets?.accountBasedPensions) reduceAssetValue(optimizedFactFind.assets.accountBasedPensions, manualStrategies.gifting);
        else if (manualStrategies.giftingSource === 'shares' && optimizedFactFind.assets?.shares) reduceAssetValue(optimizedFactFind.assets.shares, manualStrategies.gifting);
    }
    // Apply downsizing changes if selected. applyDownsizeToFactFind wants the strict (number-only)
    // supportAtHomeStrategyFunding.ts DownsizeDetails; downsizeDetails here is the wider Draft shape
    // edited via CurrencyInput (number | string mid-edit), so the cast mirrors the Draft->strict
    // pattern used throughout this migration (see factFindTypes.ts header comment).
    if (propertyStrategy === 'downsize') optimizedFactFind = (0, $41978d8498e37f65$export$e9de74ff7fc60a05)(optimizedFactFind, downsizeDetails);
    // Apply renovate strategy if selected
    if (propertyStrategy === 'renovate' && Number(renovateDetails.renovationAmount) > 0) optimizedFactFind = (0, $a1c4193edeff7c3c$export$1749088a1c3f6df1)(optimizedFactFind, renovateDetails, beforeFinancials ?? undefined);
    // Apply upgrade strategy if selected
    if (propertyStrategy === 'upgrade' && Number(upgradeDetails.newHomePurchasePrice) > 0) optimizedFactFind = (0, $a1c4193edeff7c3c$export$93b8ecbdf35897d9)(optimizedFactFind, upgradeDetails, beforeFinancials ?? undefined);
    // Apply reverse mortgage strategy
    if ((overallStrategy.reverseMortgage || propertyStrategy === 'reverseMortgage') && reverseMortgageDetails) {
        const rmDetails = reverseMortgageDetails;
        const loanAmount = parseFloat(String(rmDetails.loanAmount)) || 0;
        const establishmentFees = parseFloat(String(rmDetails.establishmentFees)) || 0;
        const netProceeds = Math.max(0, loanAmount - establishmentFees);
        if (rmDetails.loanStructure === 'lump_sum' && netProceeds > 0) {
            if (!optimizedFactFind.assets) optimizedFactFind.assets = {};
            if (!optimizedFactFind.assets.bankAccounts) optimizedFactFind.assets.bankAccounts = [];
            if (optimizedFactFind.assets.bankAccounts.length > 0) {
                const firstBankAccount = optimizedFactFind.assets.bankAccounts[0];
                const currentBalance = parseFloat(String(firstBankAccount.value)) || 0;
                firstBankAccount.value = currentBalance + netProceeds;
            } else optimizedFactFind.assets.bankAccounts.push({
                id: 'reverse-mortgage-proceeds',
                type: 'bankAccounts',
                description: 'Reverse Mortgage Proceeds',
                value: netProceeds,
                ownership: 'client',
                // Interest, not capital growth — see bankPlugin.ts's DEFAULT_BANK_GROWTH_RATE_PERCENT.
                incomeRate: 2,
                growthRate: 0
            });
        }
        // Add reverse mortgage as a liability (reduces net worth, but NO repayments - interest compounds)
        // Reverse mortgage doesn't require repayments - the loan compounds against home equity
        if (loanAmount > 0) {
            if (!optimizedFactFind.liabilities) optimizedFactFind.liabilities = {};
            if (!optimizedFactFind.liabilities.loans) optimizedFactFind.liabilities.loans = [];
            // Check if reverse mortgage liability already exists
            const rmLiability = optimizedFactFind.liabilities.loans.find((l)=>l.id === 'reverse-mortgage');
            if (rmLiability) {
                rmLiability.balance = loanAmount;
                rmLiability.interestRate = Number(rmDetails.interestRate) || (0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279);
                // NO repayments field - reverse mortgage doesn't require repayments
                rmLiability.repayments = 0;
                rmLiability.excludeFromCashflow = true; // Flag to exclude from cashflow calculations
            } else optimizedFactFind.liabilities.loans.push({
                id: 'reverse-mortgage',
                type: 'reverse_mortgage',
                description: 'Reverse Mortgage',
                balance: loanAmount,
                interestRate: Number(rmDetails.interestRate) || (0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279),
                repayments: 0,
                excludeFromCashflow: true // Flag to exclude from cashflow calculations
            });
        }
    }
    // HEAS deliberately makes NO balance-sheet change here. Starting it moves no asset: payments
    // arrive fortnightly over time, the loan starts at zero, and the payments are not
    // means-tested income. Both `afterFinancials` (calculateFinancials) and the projections
    // receive `heas`/`heasDetails` in their strategy options, which is where it is modelled.
    // (An earlier version deducted a year of payments from the bank account on day one — a
    // phantom withdrawal that inflated the pension and understated the estate.)
    if (selectedAgedCareIntegration?.radFunding) optimizedFactFind = (0, $87af0cc4cc4e8984$export$8a0c5ad907f77392)(optimizedFactFind, selectedAgedCareIntegration.radFunding);
    if (selectedAgedCareIntegration?.livingExpenses !== undefined && selectedAgedCareIntegration?.livingExpenses !== null) optimizedFactFind.expenses = {
        ...optimizedFactFind.expenses,
        livingExpenses: selectedAgedCareIntegration.livingExpenses
    };
    if (selectedFundingStrategy === 'annuity' && annuityRecordForCalculation) optimizedFactFind = (0, $f7f7b62814c3b615$export$3e335727e573fe15)(optimizedFactFind, annuityRecordForCalculation);
    $d89d3f0f7a42703f$var$alignAbpDrawsWithEngine(factFind, optimizedFactFind);
    return {
        optimizedFactFind: optimizedFactFind,
        agedCareAnnualCost: selectedAgedCareIntegration?.annualCost || 0
    };
}
/**
 * A PENSION ACCOUNT THE PLAN DRAWS ON IS PAID AT THE MINIMUM AFTERWARDS — the engine's rule
 * (liquidateFundingSources → markAbpFundedAcquisitionAfterLiquidation), applied here so a plan built by
 * hand and the same plan from the engine give the same figures (19 Oct 2026, caught live: "Spend
 * $250,000 on the home" left $16,558 a year by hand and $9,604 from the engine, because the hand path
 * kept Colin's nominated $X a year on a balance $100,000 smaller). Untouched accounts keep the draw on
 * the file, as the engine keeps them.
 */ function $d89d3f0f7a42703f$var$alignAbpDrawsWithEngine(original, planned) {
    const before = new Map((original?.assets?.accountBasedPensions || []).map((a)=>[
            String(a.id),
            Number(a.value ?? a.balance ?? 0)
        ]));
    const after = planned?.assets?.accountBasedPensions || [];
    if (!after.length) return;
    (0, $e0f54937e270d5ff$export$a6df0512b6a05b11)(planned);
    after.forEach((asset)=>{
        if (asset.__abpFundedAcquisition === true) return;
        const was = before.get(String(asset.id));
        const now = Number(asset.value ?? 0);
        if (was != null && now > 0 && now < was - 0.5) (0, $e0f54937e270d5ff$export$399e556d15149d82)(asset, planned, 1);
    });
}


/**
 * Support at Home Strategy Applicator
 *
 * Applies strategies to factFind to create modified scenarios for evaluation.
 * Always uses deep copying to prevent side effects.
 */ 


/**
 * Shared funding, gifting, and liability helpers for Support at Home suggestion engine.
 */ 







const $6737c18204fae40a$export$712e36f61d726ad1 = 50000;
const $6737c18204fae40a$var$FUNDING_LEDGER_KEY = '__sahStrategyFundingLedger';
function $6737c18204fae40a$export$98f4e3a617197818(factFind) {
    return factFind?.[$6737c18204fae40a$var$FUNDING_LEDGER_KEY] || [];
}
function $6737c18204fae40a$export$a9ee6423b82244fd(factFind, ledger) {
    if (!factFind) return factFind;
    factFind[$6737c18204fae40a$var$FUNDING_LEDGER_KEY] = ledger || [];
    return factFind;
}
function $6737c18204fae40a$export$dec85b53b81008f4(factFind) {
    if (!factFind) return factFind;
    const clone = structuredClone(factFind);
    delete clone[$6737c18204fae40a$var$FUNDING_LEDGER_KEY];
    return clone;
}
function $6737c18204fae40a$export$e8a9d16a3c6a5e34(factFind) {
    const items = [];
    Object.entries(factFind?.liabilities || {}).forEach(([type, list])=>{
        (list || []).forEach((liability)=>{
            const balance = liability.balance ?? liability.value ?? 0;
            if (balance > 0) items.push({
                key: `${type}:${liability.id}`,
                type: type,
                id: liability.id,
                description: liability.description || type,
                balance: balance,
                interestRate: (0, $55a6490f14a54563$export$7d8ffbf26dcfd37b)(liability, type),
                ...(0, $55a6490f14a54563$export$b0f8a46bdf3c210d)(liability, type) && (0, $55a6490f14a54563$export$ee09c2c29b17798e)(liability) === 'full' ? {
                    paidInFull: true
                } : {}
            });
        });
    });
    return items.sort((a, b)=>b.interestRate - a.interestRate || b.balance - a.balance);
}
function $6737c18204fae40a$export$eab989c41b911b05(factFind) {
    const listed = $6737c18204fae40a$export$e8a9d16a3c6a5e34(factFind).filter((l)=>{
        const item = ((factFind?.liabilities || {})[l.type] || []).find((x)=>String(x?.id) === String(l.id));
        return item?.type !== 'reverse_mortgage' && l.type !== 'reverseMortgages';
    });
    return (0, $485d903040fc3504$export$718566aeb53e1efe)(listed);
}
function $6737c18204fae40a$export$b58be10a7d609cb0(factFind, asOfDate = new Date()) {
    const giftsHistory = factFind?.giftsHistory || {};
    const currentFyEnd = (0, $171a6d8ba8937a5f$export$9e47c78a2ac7c305)(asOfDate);
    const byFy = (0, $171a6d8ba8937a5f$export$57a934492fb10c62)(giftsHistory, {});
    const giftedThisFy = byFy.get(currentFyEnd) || 0;
    const annualRemaining = Math.max(0, (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0) - giftedThisFy);
    let fiveYearTotal = 0;
    for(let fy = currentFyEnd - 4; fy <= currentFyEnd; fy++)fiveYearTotal += byFy.get(fy) || 0;
    const fiveYearRemaining = Math.max(0, (0, $1abe73eeef086faf$export$9cd36ea38af5a5f3) - fiveYearTotal);
    return Math.min(annualRemaining, fiveYearRemaining);
}
function $6737c18204fae40a$export$f9e748cce633a586(factFind, amount, asOfDate = new Date()) {
    const giftAmount = Math.max(0, amount || 0);
    if (giftAmount <= 0) return factFind;
    // Dated, so the five years run from the day it is given (24 Oct 2026).
    (0, $171a6d8ba8937a5f$export$653e7b96a80afaf8)(factFind, giftAmount, asOfDate);
    return factFind;
}
function $6737c18204fae40a$export$1d4f5f28dc785735(factFind, fundingSources, options = {}) {
    const { preserveBankEmergencyFund: preserveBankEmergencyFund = true, emergencyFundReserve: emergencyFundReserve = $6737c18204fae40a$export$712e36f61d726ad1 } = options;
    // markAbpFundedAcquisitionAfterLiquidation/initializeAbpProjectionNomineesOnFactFind are the real
    // calc-engine functions (shared/src/calculation/abpProjectionUtils.ts), strictly typed against
    // FactFind/FactFindAsset (plain `number` money fields). By the point they're called here the
    // asset/factFind values being touched have already been coerced to real numbers below, so the cast is
    // safe — TS just can't see that through the wider Draft (`number | string`) declaration.
    (0, $e0f54937e270d5ff$export$a6df0512b6a05b11)(factFind);
    const ledger = [];
    let totalLiquidated = 0;
    let totalCgt = 0;
    (fundingSources || []).forEach((source)=>{
        const take = Math.max(0, source.amountToTake || 0);
        if (take <= 0 || !factFind.assets?.[source.type]) return;
        const asset = factFind.assets[source.type]?.find((a)=>String(a.id) === String(source.id));
        if (!asset) return;
        let currentValue = asset.value ?? asset.balance ?? 0;
        if (source.type === 'bankAccounts' && preserveBankEmergencyFund) currentValue = Math.max(0, currentValue - emergencyFundReserve);
        const deduct = Math.min(take, currentValue);
        if (deduct <= 0) return;
        // CGT: selling shares is a CGT event whatever the proceeds fund (gifting, funeral bond, debt repayment,
        // annuity). Compute it on the gross sale (before mutating the holding) and debit it from the bank pool so
        // the projection reflects the tax cost — previously this path omitted CGT entirely.
        if (source.type === 'shares') {
            const entry = (0, $bd80071df75c742b$export$351785600ef65fdf)(factFind, `shares-${asset.id}`, deduct, {});
            if (entry?.cgt > 0) {
                totalCgt += entry.cgt;
                (0, $bd80071df75c742b$export$ade9707014c4664e)(factFind.assets, entry.cgt, asset.ownership);
                ledger.push({
                    label: 'Capital gains tax (on share sale)',
                    assetType: 'cgt',
                    amount: entry.cgt,
                    action: 'cgt'
                });
            }
        }
        const rawValue = asset.value ?? asset.balance ?? 0;
        const newRaw = Math.max(0, rawValue - deduct);
        if (asset.value !== undefined) asset.value = newRaw;
        else if (asset.balance !== undefined) asset.balance = newRaw;
        if (source.type === 'accountBasedPensions' && newRaw > 0) (0, $e0f54937e270d5ff$export$399e556d15149d82)(asset, factFind, 1);
        if (newRaw <= 0) {
            const idx = factFind.assets[source.type]?.indexOf(asset) ?? -1;
            if (idx > -1) factFind.assets[source.type]?.splice(idx, 1);
        }
        totalLiquidated += deduct;
        ledger.push({
            label: String(asset.description || asset.name || source.type),
            assetType: source.type,
            amount: deduct,
            action: 'liquidated'
        });
    });
    return {
        totalLiquidated: totalLiquidated,
        ledger: ledger,
        cgt: totalCgt
    };
}
function $6737c18204fae40a$export$8f060289ee84cde9(factFind) {
    const clientAge = factFind?.client?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client.dob) ?? 0 : 0;
    const partnerAge = factFind?.partner?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner.dob) ?? 0 : 0;
    if (factFind?.adviceFor === 'couple') return clientAge >= 55 || partnerAge >= 55;
    return clientAge >= 55;
}
function $6737c18204fae40a$export$6f896b09251df0c4(factFind, scenario) {
    const currentHomeValue = factFind.home?.value || 0;
    const salePrice = scenario.salePrice ?? currentHomeValue * 0.975;
    const sellingCosts = scenario.sellingCosts ?? Math.max(0, currentHomeValue - salePrice);
    const newHomePurchasePrice = scenario.newHomePurchasePrice ?? scenario.newHomeValue ?? 0;
    let remainingAfterHome = Math.max(0, salePrice - sellingCosts - newHomePurchasePrice);
    const details = {
        salePrice: salePrice,
        sellingCosts: sellingCosts,
        newHomePurchasePrice: newHomePurchasePrice,
        downsizerContribution: 0,
        partnerDownsizerContribution: 0,
        giftingAmount: 0,
        debtRepayment: 0,
        selectedDebtKey: scenario.selectedDebtKey || null,
        addedAssets: [],
        commenceIncomeStream: scenario.commenceIncomeStream === true
    };
    if (scenario.useDownsizer && $6737c18204fae40a$export$8f060289ee84cde9(factFind)) {
        // Age-aware: fills whichever member's accumulation super is exempt from the means tests
        // (under Age Pension age) first, and keeps the scenario's own per-person ceilings on top.
        // See allocateDownsizerContribution — one rule, shared with RV and the Downsizer module.
        const allocation = (0, $f1228be62b68f76b$export$6373eb0865b1a234)(factFind, remainingAfterHome, {
            client: scenario.clientDownsizerAmount,
            partner: scenario.partnerDownsizerAmount
        });
        details.downsizerContribution = allocation.client;
        details.partnerDownsizerContribution = allocation.partner;
        remainingAfterHome -= allocation.client + allocation.partner;
    }
    if (scenario.repayDebt && scenario.selectedDebtKey && (scenario.debtRepayment ?? 0) > 0) {
        details.debtRepayment = Math.min(scenario.debtRepayment ?? 0, remainingAfterHome);
        details.selectedDebtKey = scenario.selectedDebtKey;
        remainingAfterHome -= details.debtRepayment;
    }
    return details;
}


/**
 * Support at Home suggestion engine — entity funding gate (Phase 2).
 * Mirrors aged care `suggestionEngineFunding.js` liquid pool rules for SAH strategies.
 */ 





function $3894d1f80ae86060$export$ec743f8ff1b409c2(factFind, emergencyFundReserve = (0, $6737c18204fae40a$export$712e36f61d726ad1)) {
    const assets = [];
    (factFind.assets?.bankAccounts || []).forEach((account)=>{
        if (!(0, $bd80071df75c742b$export$6b7e895f645efa6c)(factFind, account)) return;
        const value = account.value || 0;
        if (value > 0) assets.push({
            type: 'bankAccounts',
            id: account.id,
            description: account.description || 'Bank Account',
            value: value,
            available: Math.max(0, value - emergencyFundReserve),
            priority: 1
        });
    });
    (factFind.assets?.accountBasedPensions || []).forEach((abp)=>{
        if (!(0, $bd80071df75c742b$export$6b7e895f645efa6c)(factFind, abp)) return;
        const value = abp.value || 0;
        if (value > 0) assets.push({
            type: 'accountBasedPensions',
            id: abp.id,
            description: abp.description || 'Account-Based Pension',
            value: value,
            available: value * 0.5,
            priority: 2
        });
    });
    (factFind.assets?.shares || []).forEach((share)=>{
        if (!(0, $bd80071df75c742b$export$6b7e895f645efa6c)(factFind, share)) return;
        const value = share.value || 0;
        if (value > 0) assets.push({
            type: 'shares',
            id: share.id,
            description: share.description || 'Shares',
            value: value,
            available: value,
            priority: 3
        });
    });
    (factFind.assets?.termDeposits || []).forEach((td)=>{
        if (!(0, $bd80071df75c742b$export$6b7e895f645efa6c)(factFind, td)) return;
        const value = td.value || 0;
        if (value > 0) assets.push({
            type: 'termDeposits',
            id: td.id,
            description: td.description || 'Term deposit',
            value: value,
            available: value,
            priority: 2
        });
    });
    return assets.sort((a, b)=>a.priority - b.priority);
}
function $3894d1f80ae86060$export$563b27691ba66f5a(factFind, property) {
    const salePrice = property.value || 0;
    return {
        selectedPropertyId: property.id,
        salePrice: salePrice,
        sellingCosts: salePrice * 0.025,
        costBase: property.costBase,
        radAllocation: 0,
        newHomePurchasePrice: 0,
        downsizerContribution: 0,
        partnerDownsizerContribution: 0,
        giftingAmount: 0,
        funeralBondPurchase: 0
    };
}
function $3894d1f80ae86060$export$7219869b3d9469c6(factFind) {
    const strategies = [];
    const entityIps = (0, $c549af0b979cab3f$export$3b6b9af778b0e124)(factFind);
    if (!entityIps.length) return strategies;
    entityIps.forEach((property)=>{
        const entityId = (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(property.ownership);
        const structure = (factFind.structures || []).find((s)=>s.id === entityId);
        const propLabel = property.description?.trim() || structure?.name?.trim() || 'entity investment property';
        const details = $3894d1f80ae86060$export$563b27691ba66f5a(factFind, property);
        // DraftFactFind is structurally compatible with FactFind (see
        // types/formDraft.ts); the shared calc-engine fn defensively parseFloat/coerces internally
        // regardless, so this cast is safe (see factFindTypes.ts header).
        const summary = (0, $a764bc0f6f904854$export$777cdddf3f231419)(factFind, details);
        const netProceeds = summary?.netProceeds ?? 0;
        if (netProceeds <= 0) return;
        strategies.push({
            type: 'sellEntityInvestmentProperty',
            investmentPropertyDetails: details,
            structureFundingIncluded: true,
            groupKey: `entity-ip-sale-${property.id}`,
            name: `Sell ${propLabel} (entity pool)`,
            description: `Sell entity-owned investment property; estimated net $${Math.round(netProceeds).toLocaleString()} to entity liquid pool after CGT`
        });
    });
    return strategies;
}
function $3894d1f80ae86060$export$a93ae680e4ad3267(factFind, baselineFactFind, details) {
    return (0, $bda3664ae16bcdb0$export$968f08311f735e7a)(factFind, baselineFactFind, details);
}



const $1a3577d7101fe882$var$MIN_ANNUITY_PURCHASE = 50000;
function $1a3577d7101fe882$export$2130d11e4b2e7a7(factFind, strategy) {
    const modified = structuredClone(factFind);
    switch(strategy.type){
        case 'doNothing':
            return modified;
        /*
         * Several levers at once — the client-side mirror of the evaluator's own `combination` case
         * (server/src/rest/calculation/suggestionEngine/supportAtHome.ts), kept in step so a strategy
         * the engine ranked applies the same way when a screen applies it.
         *
         * The appliers compose without help: each liquidates from the fact-find it is handed, so step
         * two sees the assets step one already spent and a combination can never fund itself twice.
         * The funding ledger does NOT compose — each applier replaces it — so the lines are collected
         * after every step, or the summary would credit only whichever lever ran last.
         */ case 'combination':
            {
                let working = modified;
                const ledger = [];
                for (const step of strategy.steps || []){
                    working = $1a3577d7101fe882$export$2130d11e4b2e7a7(working, step);
                    ledger.push(...(0, $6737c18204fae40a$export$98f4e3a617197818)(working));
                }
                return (0, $6737c18204fae40a$export$a9ee6423b82244fd)(working, ledger);
            }
        case 'gifting':
            return $1a3577d7101fe882$var$applyGiftingToFactFind(modified, strategy);
        case 'funeralBonds':
            return $1a3577d7101fe882$var$applyFuneralBondToFactFind(modified, strategy);
        case 'annuity':
            return $1a3577d7101fe882$var$applyAnnuityStrategy(modified, strategy);
        case 'increaseHomeEquity':
        case 'renovate':
            return $1a3577d7101fe882$var$applyIncreaseHomeEquityToFactFind(modified, strategy);
        case 'downsize':
            return $1a3577d7101fe882$var$applyDownsizeStrategy(modified, strategy);
        case 'upgrade':
            return $1a3577d7101fe882$var$applyIncreaseHomeEquityToFactFind(modified, {
                ...strategy,
                equityAmount: strategy.additionalFundsNeeded ?? strategy.equityAmount ?? strategy.renovationAmount
            });
        case 'debtRepayment':
            return $1a3577d7101fe882$var$applyDebtRepaymentToFactFind(modified, strategy);
        case 'reverseMortgage':
            return $1a3577d7101fe882$var$applyReverseMortgageToFactFind(modified, strategy);
        case 'heas':
            return $1a3577d7101fe882$var$applyHeasToFactFind(modified, strategy);
        case 'sellEntityInvestmentProperty':
            return $1a3577d7101fe882$var$applySellEntityInvestmentPropertyStrategy(factFind, modified, strategy);
        default:
            console.warn('Unknown strategy type:', strategy.type);
            return modified;
    }
}
function $1a3577d7101fe882$var$applyGiftingToFactFind(factFind, strategy) {
    const requested = Math.max(0, strategy.amount || 0);
    if (requested <= 0) return factFind;
    const fundingSources = strategy.fundingSources || $1a3577d7101fe882$var$buildSingleSourceFunding(strategy);
    const { totalLiquidated: totalLiquidated, ledger: ledger } = (0, $6737c18204fae40a$export$1d4f5f28dc785735)(factFind, fundingSources);
    const actualGift = Math.min(requested, totalLiquidated);
    if (actualGift <= 0) return (0, $6737c18204fae40a$export$a9ee6423b82244fd)(factFind, ledger);
    (0, $6737c18204fae40a$export$f9e748cce633a586)(factFind, actualGift);
    ledger.push({
        label: 'Gift to family',
        amount: actualGift,
        action: 'gifted'
    });
    return (0, $6737c18204fae40a$export$a9ee6423b82244fd)(factFind, ledger);
}
function $1a3577d7101fe882$var$applyFuneralBondToFactFind(factFind, strategy) {
    const requested = Math.max(0, strategy.amount || 0);
    if (requested <= 0) return factFind;
    const fundingSources = strategy.fundingSources || $1a3577d7101fe882$var$buildSingleSourceFunding(strategy);
    const { totalLiquidated: totalLiquidated, ledger: ledger } = (0, $6737c18204fae40a$export$1d4f5f28dc785735)(factFind, fundingSources);
    const actualPurchase = Math.min(requested, totalLiquidated);
    if (actualPurchase <= 0) return (0, $6737c18204fae40a$export$a9ee6423b82244fd)(factFind, ledger);
    if (!factFind.assets) factFind.assets = {};
    const existingBond = factFind.assets.funeralBonds?.find((b)=>b.ownership === (strategy.ownership || 'client'));
    if (!factFind.assets.funeralBonds) factFind.assets.funeralBonds = [];
    if (existingBond) existingBond.value = (existingBond.value || 0) + actualPurchase;
    else factFind.assets.funeralBonds.push({
        id: `funeral-bond-${Date.now()}`,
        description: 'Prepaid Funeral Bond',
        value: actualPurchase,
        ownership: strategy.ownership || 'client',
        income: 0,
        growthRate: 0
    });
    ledger.push({
        label: 'Funeral bond purchase',
        amount: actualPurchase,
        action: 'purchased'
    });
    return (0, $6737c18204fae40a$export$a9ee6423b82244fd)(factFind, ledger);
}
function $1a3577d7101fe882$var$addAnnuityAssetToFactFind(factFind, annuityRecord) {
    if (!factFind.assets) factFind.assets = {};
    const annuityAsset = (0, $f7f7b62814c3b615$export$5dc1cd0ab6cd8d79)(annuityRecord, {
        ownership: annuityRecord.owner || 'client'
    });
    const annuities = (factFind.assets.annuities || []).filter((a)=>a.id !== annuityRecord.id);
    annuities.push(annuityAsset);
    factFind.assets.annuities = annuities;
    return factFind;
}
function $1a3577d7101fe882$var$applyAnnuityStrategy(factFind, strategy) {
    const requested = Math.max(0, strategy.purchaseAmount || 0);
    const fundingSources = strategy.fundingSources || $1a3577d7101fe882$var$buildSingleSourceFunding(strategy);
    const { totalLiquidated: totalLiquidated, ledger: ledger } = (0, $6737c18204fae40a$export$1d4f5f28dc785735)(factFind, fundingSources);
    const actualPurchase = Math.min(requested || totalLiquidated, totalLiquidated);
    if (actualPurchase < $1a3577d7101fe882$var$MIN_ANNUITY_PURCHASE) return (0, $6737c18204fae40a$export$a9ee6423b82244fd)(factFind, ledger);
    const ownerAge = factFind?.client?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client.dob) ?? 70 : 70;
    const partnerAge = factFind?.partner?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner.dob) : null;
    // buildAnnuityImpact is the real (strict) calc-engine function — factFind's money fields are
    // guaranteed real numbers by this point (post-liquidation), so the Draft->strict cast is safe.
    const annuityRecord = (0, $f7f7b62814c3b615$export$fb67395f10ad20c9)(factFind, {
        id: strategy.id || `annuity-se-${Date.now()}`,
        annuityType: 'lifetime',
        purchaseAmount: actualPurchase,
        fundingSource: 'pre-liquidated',
        age: ownerAge,
        partnerAge: partnerAge,
        indexation: false,
        /* A CHOICE, NOT A CONSTANT. Centrelink counts a lifetime annuity at 60% of purchase price
           whatever its RCV, but net worth values it at its RESIDUAL — so a nil-RCV candidate loses
           the legacy ranking by the whole purchase price. Defaulting to 0 keeps every existing
           caller's behaviour; the generator now offers both ends. Mirrors the server applier. */ residualCapital: Number.isFinite(Number(strategy.residualCapital)) ? Number(strategy.residualCapital) : 0,
        owner: strategy.ownership || 'client',
        reversionary: false
    });
    if (!annuityRecord?.purchaseAmount) return (0, $6737c18204fae40a$export$a9ee6423b82244fd)(factFind, ledger);
    $1a3577d7101fe882$var$addAnnuityAssetToFactFind(factFind, annuityRecord);
    ledger.push({
        label: 'Lifetime annuity',
        amount: actualPurchase,
        action: 'purchased',
        assetType: 'annuities'
    });
    return (0, $6737c18204fae40a$export$a9ee6423b82244fd)(factFind, ledger);
}
function $1a3577d7101fe882$var$applyIncreaseHomeEquityToFactFind(factFind, strategy) {
    const equityAmount = Math.max(0, (strategy.equityAmount ?? strategy.renovationAmount ?? strategy.additionalFundsNeeded) || 0);
    if (equityAmount <= 0) return factFind;
    const fundingSources = strategy.fundingSources || $1a3577d7101fe882$var$buildSingleSourceFunding(strategy);
    const { totalLiquidated: totalLiquidated, ledger: ledger } = (0, $6737c18204fae40a$export$1d4f5f28dc785735)(factFind, fundingSources);
    const applied = Math.min(equityAmount, totalLiquidated);
    if (applied <= 0) return (0, $6737c18204fae40a$export$a9ee6423b82244fd)(factFind, ledger);
    if (!factFind.home) factFind.home = {};
    const currentHomeValue = factFind.home.value || 0;
    factFind.home.value = currentHomeValue + applied;
    ledger.push({
        label: 'Home equity uplift',
        amount: applied,
        action: 'capitalised'
    });
    return (0, $6737c18204fae40a$export$a9ee6423b82244fd)(factFind, ledger);
}
function $1a3577d7101fe882$var$applySellEntityInvestmentPropertyStrategy(baselineFactFind, factFind, strategy) {
    const details = strategy.investmentPropertyDetails;
    if (!details) return factFind;
    const result = (0, $3894d1f80ae86060$export$a93ae680e4ad3267)(factFind, baselineFactFind, details);
    const ledger = [
        {
            label: strategy.name || 'Entity investment property sale',
            amount: parseFloat(String(details.salePrice)) || 0,
            action: 'sold',
            assetType: 'investmentProperty'
        }
    ];
    return (0, $6737c18204fae40a$export$a9ee6423b82244fd)(result, ledger);
}
function $1a3577d7101fe882$var$applyDownsizeStrategy(factFind, strategy) {
    const details = strategy.downsizeDetails || (0, $6737c18204fae40a$export$6f896b09251df0c4)(factFind, strategy);
    const result = (0, $41978d8498e37f65$export$e9de74ff7fc60a05)(factFind, details);
    const ledger = [
        {
            label: 'Family home',
            amount: factFind.home?.value || 0,
            action: 'downsized',
            assetType: 'home'
        }
    ];
    if (details.downsizerContribution > 0) ledger.push({
        label: details.commenceIncomeStream ? 'Client downsizer to ABP' : 'Client downsizer to super',
        amount: details.downsizerContribution,
        action: 'contributed'
    });
    if (details.partnerDownsizerContribution > 0) ledger.push({
        label: details.commenceIncomeStream ? 'Partner downsizer to ABP' : 'Partner downsizer to super',
        amount: details.partnerDownsizerContribution,
        action: 'contributed'
    });
    if (details.debtRepayment > 0) ledger.push({
        label: 'Debt repayment from proceeds',
        amount: details.debtRepayment,
        action: 'repaid'
    });
    return (0, $6737c18204fae40a$export$a9ee6423b82244fd)(result, ledger);
}
function $1a3577d7101fe882$var$applyDebtRepaymentToFactFind(factFind, strategy) {
    const requested = Math.max(0, strategy.repaymentAmount || 0);
    const liabilityKey = strategy.liabilityKey || strategy.selectedDebtKey;
    if (requested <= 0 || !liabilityKey) return factFind;
    const fundingSources = strategy.fundingSources || $1a3577d7101fe882$var$buildSingleSourceFunding(strategy);
    const { totalLiquidated: totalLiquidated, ledger: ledger } = (0, $6737c18204fae40a$export$1d4f5f28dc785735)(factFind, fundingSources);
    const repay = Math.min(requested, totalLiquidated);
    if (repay <= 0) return (0, $6737c18204fae40a$export$a9ee6423b82244fd)(factFind, ledger);
    const [liabilityType, liabilityId] = liabilityKey.split(':');
    const liabilityList = factFind.liabilities?.[liabilityType];
    if (Array.isArray(liabilityList)) {
        const target = liabilityList.find((item)=>String(item.id) === String(liabilityId));
        if (target) {
            const currentBalance = Math.max(0, target.balance ?? target.value ?? 0);
            const newBalance = Math.max(0, currentBalance - repay);
            if (target.balance !== undefined) target.balance = newBalance;
            else target.value = newBalance;
            ledger.push({
                label: target.description || 'Debt repayment',
                amount: repay,
                action: 'repaid',
                assetType: 'liabilities'
            });
        }
    }
    return (0, $6737c18204fae40a$export$a9ee6423b82244fd)(factFind, ledger);
}
function $1a3577d7101fe882$var$buildSingleSourceFunding(strategy) {
    const amount = (strategy.amount ?? strategy.purchaseAmount ?? strategy.renovationAmount ?? strategy.repaymentAmount) || 0;
    if (!strategy.assetType || !strategy.assetId || amount <= 0) return [];
    return [
        {
            type: strategy.assetType,
            id: strategy.assetId,
            amountToTake: amount
        }
    ];
}
function $1a3577d7101fe882$var$applyReverseMortgageToFactFind(factFind, strategy) {
    const loanAmount = strategy.loanAmount || 0;
    const establishmentFees = strategy.establishmentFees || 0;
    const netProceeds = Math.max(0, loanAmount - establishmentFees);
    if (!factFind.assets) factFind.assets = {};
    if (strategy.loanStructure !== 'regular_payments' && netProceeds > 0) {
        if (!factFind.assets.bankAccounts) factFind.assets.bankAccounts = [];
        if (factFind.assets.bankAccounts.length > 0) {
            const first = factFind.assets.bankAccounts[0];
            first.value = (first.value || 0) + netProceeds;
        } else factFind.assets.bankAccounts.push({
            id: 'reverse-mortgage-proceeds',
            type: 'bankAccounts',
            description: 'Reverse Mortgage Proceeds',
            value: netProceeds,
            ownership: 'client',
            // Interest, not capital growth — see bankPlugin.ts's DEFAULT_BANK_GROWTH_RATE_PERCENT.
            incomeRate: 2,
            growthRate: 0
        });
    }
    if (loanAmount > 0) {
        factFind.liabilities = factFind.liabilities || {};
        factFind.liabilities.loans = factFind.liabilities.loans || [];
        const existing = factFind.liabilities.loans.find((l)=>l.id === 'reverse-mortgage');
        const liability = {
            id: 'reverse-mortgage',
            type: 'reverse_mortgage',
            description: 'Reverse Mortgage',
            balance: loanAmount,
            interestRate: strategy.interestRate || (0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279),
            repayments: 0,
            excludeFromCashflow: true
        };
        if (existing) Object.assign(existing, liability);
        else factFind.liabilities.loans.push(liability);
    }
    return factFind;
}
function $1a3577d7101fe882$var$applyHeasToFactFind(factFind, _strategy) {
    // Starting HEAS changes NOTHING on the day-one balance sheet: payments arrive fortnightly over
    // time, the loan starts at zero and accrues as they do, and the payments are not means-tested
    // income — all modelled by the projection layer via heas strategy options. This used to deduct
    // a year of payments from the first bank account (a phantom withdrawal that inflated the
    // pension and understated the estate); fixed 2026-08-14 alongside the server evaluator — the
    // two must stay in lockstep or saved strategies re-materialise on different balance sheets.
    return factFind;
}
function $1a3577d7101fe882$export$96160e16d1d8ed50(factFind, strategies) {
    if (strategies.length === 0) return structuredClone(factFind);
    let modified = factFind;
    strategies.forEach((strategy)=>{
        modified = $1a3577d7101fe882$export$2130d11e4b2e7a7(modified, strategy);
    });
    return modified;
}





/**
 * What this module can propose — the means-test levers that do NOT involve moving house.
 *
 * THE BOUNDARY, and it is deliberate. Selling, downsizing, a retirement village and a granny flat
 * each already have a module with their own explainers, timing rules and traps. Reimplementing any
 * of them here would give the app five places that model a home sale, and they would drift. So this
 * engine owns the levers that leave the client exactly where they are, and the module links out for
 * the moves.
 *
 * Every amount here is SIZED FROM WHAT THE CLIENT ACTUALLY HAS. A candidate proposing a $300,000
 * annuity to someone with $80,000 in the bank is not a strategy, and an engine that generates one
 * has to be second-guessed by the reader — which defeats the point of it.
 */ 



/**
 * A PROVIDER'S QUOTE BELONGS TO ONE TYPE AND ONE AMOUNT (owner, 21 Oct 2026 — the guaranteed income review M5).
 *
 * A quote is for a type of guaranteed income (income only, money back, or the full amount back at any time)
 * and an amount. Before this, a quote entered on one plan's card replaced our estimate on EVERY plan with a
 * guaranteed income, so a quote for an income-only annuity was applied to the money-back and full-amount-back
 * plans too (their incomes are much lower), and the field was re-ranked on incomes nobody had been offered.
 *
 * Now: a plan of the same type uses the quote, scaled pro rata to its own amount (a $200,000 plan on a
 * $100,000 quote of $6,000 a year uses $12,000); a plan of another type keeps our estimate from the
 * published rates. Used by the village, downsizing and granny flat generators.
 */ /** The type of guaranteed income a quote is for. */ function $da24031d156d6acb$export$f7e5360546f2cc73(annuityType, residualPercent) {
    if (annuityType === 'guaranteed') return 'guaranteed';
    if (annuityType === 'fixedTerm') return 'fixedTerm';
    return Math.round(Number(residualPercent) || 0) > 0 ? 'returned' : 'nil';
}
function $da24031d156d6acb$export$792bf827cea0133b(quote) {
    return quote && Number(quote.income) > 0 && Number(quote.amount) > 0 ? quote : null;
}
function $da24031d156d6acb$export$2ee327201b9e82a1(quote, annuityType, residualPercent, amount) {
    const q = $da24031d156d6acb$export$792bf827cea0133b(quote);
    const a = Number(amount) || 0;
    if (!q || !(a > 0)) return undefined;
    if ($da24031d156d6acb$export$f7e5360546f2cc73(annuityType, residualPercent) !== q.shape) return undefined;
    return Math.round(q.income * a / q.amount);
}
function $da24031d156d6acb$export$79acf22478b89287(shape) {
    switch(shape){
        case 'guaranteed':
            return 'full amount back at any time';
        case 'returned':
            return 'money back in the early years';
        case 'fixedTerm':
            return 'a set term';
        default:
            return 'income only';
    }
}
function $da24031d156d6acb$export$3c59a0c7e65b683b(quote, money) {
    const q = $da24031d156d6acb$export$792bf827cea0133b(quote);
    if (!q) return null;
    return `This quote is ${money(q.income)} a year for ${money(q.amount)}, ${$da24031d156d6acb$export$79acf22478b89287(q.shape)}. Plans with the same type use it, scaled to their amount; plans with another type keep our estimate.`;
}



/**
 * Cashflow & Age Pension — the projection layer.
 *
 * WHAT THIS MODULE IS FOR (owner, 2026-08-28). Every other module in the app projects AROUND an
 * event: a move into care, a village entry, a downsize, a granny flat. This one projects a client
 * who does none of those things — they stay where they are, and the only thing that changes is what
 * they spend and how their money is arranged.
 *
 * It exists because of the Commonwealth Home Support Program. CHSP has NO MEANS TEST, so unlike
 * Support at Home there is no contribution for us to calculate — the provider sets the fee and the
 * client is told what it is. That inverts the usual job: the care cost stops being an OUTPUT we
 * compute and becomes an INPUT the client gives us. What we can then answer is the question they
 * actually have, which was never "what does CHSP cost" (they get a bill) but "can I afford this,
 * for how long, and is there anything I can do to be better off?"
 *
 * DELIBERATELY GENERAL, NARROWLY EXPOSED. Nothing here knows about CHSP, Support at Home, or how the
 * client arrived. The cost is just a recurring expense with a label. That is the owner's positioning
 * call: build it general so it can be opened from anywhere later, but for now reach it through one
 * door — the Support at Home overview — while the product decides how broad it wants to be.
 *
 * HOW A "NO EVENT" PROJECTION IS EXPRESSED, and why it is not a hack. `careStartDate` is set beyond
 * the horizon. The engine already treats that as a supported state: `careStartYearFor` returns 0,
 * documented as "never, within this run", and `careFractionOfPeriod` returns 0 for every period, so
 * no care fee is charged and none of the entry clocks (the RAD retention window, the former-home
 * exemption) ever start. Verified empirically before this module was written — a 10-year run charges
 * no care costs and pays the Age Pension on ordinary at-home rules.
 */ 






/**
 * A care date far enough out that no projected period can contain it.
 *
 * Not "no date at all": a null `careStartDate` means "already in care as the run opens", which is
 * the legacy reading and the opposite of what this module models. The date has to be present and
 * unreachable.
 */ const $2663acaa6cb9dd5e$var$NEVER = '2199-01-01';
/** The fee schedule for a client who never enters residential care — every rate nil. */ const $2663acaa6cb9dd5e$var$noCareCosts = (scenarioLivingExpenses)=>({
        totalDailyCost: 0,
        dailyAccommodationPayment: 0,
        basicDailyFee: 0,
        dailyNCCC: 0,
        dailyHSC: 0,
        dailyExtraServiceFee: 0,
        scenarioLivingExpenses: scenarioLivingExpenses
    });
function $2663acaa6cb9dd5e$export$c1a956b025b1ed40(factFind, supportCost) {
    const base = parseFloat(String(factFind?.expenses?.livingExpenses ?? '')) || 0;
    return base + Math.max(0, supportCost?.annual || 0);
}
async function $2663acaa6cb9dd5e$export$78ad5907e1d0a084(factFind, options = {}) {
    const legacyYears = options.legacyYears || 10;
    const scenarioLivingExpenses = $2663acaa6cb9dd5e$export$c1a956b025b1ed40(factFind, options.supportCost);
    const simulated = {
        ...factFind,
        expenses: {
            ...factFind.expenses || {},
            livingExpenses: scenarioLivingExpenses
        }
    };
    const result = await $55a1d8a64f1e5dfa$export$75699a59a86ef1ab(simulated, {
        scenarioLivingExpenses: scenarioLivingExpenses,
        careStartDate: $2663acaa6cb9dd5e$var$NEVER,
        ...options.inflationAssumptionPct != null ? {
            inflationAssumptionPct: options.inflationAssumptionPct
        } : {}
    }, $2663acaa6cb9dd5e$var$noCareCosts(scenarioLivingExpenses), legacyYears);
    return result || [];
}
function $2663acaa6cb9dd5e$export$bb519fac30b1105e(years) {
    if (!years?.length) return null;
    const first = years[0];
    const last = years[years.length - 1];
    /*
     * The runway. `unfundedShortfall` is the engine's own signal that a year's plan could not be
     * paid for out of income plus drawdown — the honest answer to "how long does this last?", and
     * far more useful to a client than a net-worth line that quietly goes to zero.
     */ const shortfall = years.find((y)=>(Number(y.unfundedShortfall) || 0) > 0);
    return {
        agePension: Number(first.socialSecurity) || 0,
        cashFlow: Number(first.cashFlow) || 0,
        netWorth: Number(first.netWorth) || 0,
        estate: (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(last) ?? 0,
        shortfallYear: shortfall ? Number(shortfall.year) : null,
        livingExpenses: Number(first.livingExpenses) || 0,
        totalIncome: (Number(first.investmentIncome) || 0) + (Number(first.abpIncome) || 0) + (Number(first.rentalIncome) || 0) + (Number(first.socialSecurity) || 0)
    };
}
async function $2663acaa6cb9dd5e$export$21f373618f5de5bc(factFind, supportCost, legacyYears = 10) {
    const [without, withCost] = await Promise.all([
        $2663acaa6cb9dd5e$export$78ad5907e1d0a084(factFind, {
            legacyYears: legacyYears
        }),
        $2663acaa6cb9dd5e$export$78ad5907e1d0a084(factFind, {
            legacyYears: legacyYears,
            supportCost: supportCost
        })
    ]);
    const a = $2663acaa6cb9dd5e$export$bb519fac30b1105e(without);
    const b = $2663acaa6cb9dd5e$export$bb519fac30b1105e(withCost);
    if (!a || !b) return null;
    return {
        without: a,
        with: b,
        estateChange: b.estate - a.estate,
        cashFlowChange: b.cashFlow - a.cashFlow,
        pensionChange: b.agePension - a.agePension
    };
}
const $2663acaa6cb9dd5e$export$8471fcc462280406 = {
    funeralBond: 0,
    gift: 0,
    annuity: 0,
    debtRepayment: 0
};
const $2663acaa6cb9dd5e$export$4c6420527ec5a824 = (allocation, key)=>Math.max(0, Number(allocation[key]) || 0);
const $2663acaa6cb9dd5e$export$8a567aa13eab014b = {
    /*
     * Capital preserved, like every other module's Manual Control — see
     * DEFAULT_NEW_ANNUITY_RESIDUAL in SupportAtHomeAnnuityConfigurator.tsx for why the default is
     * the option that does NOT commit the client's money permanently. The means test is identical
     * either way, so the default costs nothing and the client still chooses.
     */ residualCapital: 1,
    owner: 'client',
    reversionary: false,
    indexation: false,
    incomeOverride: null
};
function $2663acaa6cb9dd5e$export$a6b5e1b0a97dc6ff(factFind) {
    const assets = factFind?.assets || {};
    const collect = (type)=>(assets[type] || []).filter((row)=>row?.id && (parseFloat(String(row?.value ?? '')) || 0) > 0).map((row)=>({
                type: type,
                id: String(row.id),
                // Display name: a couple's two accounts of one name gain their owners' names (assetDisplayName).
                description: (0, $e850825c00b15be4$export$87285386e0429fb5)(row, factFind, type),
                value: parseFloat(String(row.value)) || 0
            }));
    return [
        ...collect('bankAccounts'),
        ...collect('termDeposits'),
        ...collect('shares')
    ];
}
function $2663acaa6cb9dd5e$export$c81b76ce53c83adf(factFind) {
    return $2663acaa6cb9dd5e$export$a6b5e1b0a97dc6ff(factFind).reduce((sum, s)=>sum + s.value, 0);
}
function $2663acaa6cb9dd5e$export$cdf8b234292e0c72(allocation) {
    return $2663acaa6cb9dd5e$export$4c6420527ec5a824(allocation, 'funeralBond') + $2663acaa6cb9dd5e$export$4c6420527ec5a824(allocation, 'gift') + $2663acaa6cb9dd5e$export$4c6420527ec5a824(allocation, 'annuity') + $2663acaa6cb9dd5e$export$4c6420527ec5a824(allocation, 'debtRepayment') + $2663acaa6cb9dd5e$export$4c6420527ec5a824(allocation, 'superContribution') + $2663acaa6cb9dd5e$export$4c6420527ec5a824(allocation, 'investmentBond');
}
function $2663acaa6cb9dd5e$export$bc295484d84d1d5d(sources, amount) {
    const plan = [];
    let remaining = Math.max(0, amount);
    for (const source of sources){
        if (remaining <= 0) break;
        const take = Math.min(source.value, remaining);
        if (take > 0) plan.push({
            type: source.type,
            id: source.id,
            amountToTake: take
        });
        remaining -= take;
    }
    return plan;
}
const $2663acaa6cb9dd5e$export$bcc8e45d2598fb47 = 'careCompanionReopenCashflowStrategy';
const $2663acaa6cb9dd5e$var$num = (v)=>{
    const x = typeof v === 'number' ? v : parseFloat(String(v ?? ''));
    return Number.isFinite(x) ? x : null;
};
function $2663acaa6cb9dd5e$export$65cd5313ae403f79(saved) {
    if (!saved || typeof saved !== 'object') return null;
    const s = saved;
    if (s.type && s.type !== 'cashflow_pension') return null;
    const inputs = s.inputs || {};
    const mode = (inputs.source || s.source) === 'manual' ? 'manual' : 'optimised';
    const alloc = inputs.allocation && typeof inputs.allocation === 'object' ? {
        ...$2663acaa6cb9dd5e$export$8471fcc462280406,
        ...Object.fromEntries(Object.entries(inputs.allocation).map(([k, v])=>[
                k,
                $2663acaa6cb9dd5e$var$num(v) ?? 0
            ]))
    } : null;
    const quote = $2663acaa6cb9dd5e$var$num(inputs.candidate?.annuity?.incomeOverride);
    return {
        name: String(s.name || ''),
        mode: mode,
        allocation: mode === 'manual' ? alloc : null,
        annuityTerms: inputs.annuityTerms && typeof inputs.annuityTerms === 'object' ? {
            ...$2663acaa6cb9dd5e$export$8a567aa13eab014b,
            ...inputs.annuityTerms
        } : null,
        engineOptionId: mode === 'manual' ? null : inputs.engineOptionId ?? inputs.engineStrategyId ?? null,
        supportCostAnnual: Math.max(0, $2663acaa6cb9dd5e$var$num(inputs.supportCostAnnual ?? inputs.planContext?.supportCostAnnual) ?? 0),
        supportCostLabel: inputs.supportCostLabel ? String(inputs.supportCostLabel) : null,
        legacyYears: $2663acaa6cb9dd5e$var$num(inputs.legacyYears ?? inputs.planContext?.legacyYears),
        annuityQuote: mode === 'manual' ? null : quote && quote > 0 ? quote : null,
        // The quote was entered on the chosen option, so it is for that option's type and amount.
        annuityQuoteFor: mode === 'manual' || !(quote && quote > 0) || !($2663acaa6cb9dd5e$var$num(inputs.candidate?.annuity?.purchaseAmount) > 0) ? null : {
            shape: (0, $da24031d156d6acb$export$f7e5360546f2cc73)(inputs.candidate.annuity.annuityType, Math.round(($2663acaa6cb9dd5e$var$num(inputs.candidate.annuity.residualCapital) ?? 0) * 100)),
            amount: $2663acaa6cb9dd5e$var$num(inputs.candidate.annuity.purchaseAmount)
        },
        card: inputs.card && typeof inputs.card === 'object' ? inputs.card : null,
        createdAt: s.createdAt ? String(s.createdAt) : null,
        chosen: s.chosen === true,
        id: s.id != null ? String(s.id) : null,
        soaPreparedAt: s.soaPreparedAt ? String(s.soaPreparedAt) : null
    };
}
function $2663acaa6cb9dd5e$export$9ca6d4362a508002() {
    try {
        if (typeof window === 'undefined') return null;
        const raw = sessionStorage.getItem($2663acaa6cb9dd5e$export$bcc8e45d2598fb47);
        return raw ? $2663acaa6cb9dd5e$export$65cd5313ae403f79(JSON.parse(raw)) : null;
    } catch  {
        return null;
    }
}
function $2663acaa6cb9dd5e$export$d9e7ffb0b289bb15(factFind) {
    const debts = [];
    const liabilities = factFind?.liabilities || {};
    for (const [category, list] of Object.entries(liabilities)){
        if (!Array.isArray(list)) continue;
        for (const liability of list){
            if (!liability?.id || liability.type === 'reverse_mortgage') continue;
            const balance = parseFloat(String(liability.balance ?? '')) || 0;
            if (balance <= 0) continue;
            // A card paid off in full each month is a monthly bill, not a debt to repay (strategy/debtsToTest.ts).
            if ((0, $55a6490f14a54563$export$b0f8a46bdf3c210d)(liability, category) && (0, $55a6490f14a54563$export$ee09c2c29b17798e)(liability) === 'full') continue;
            debts.push({
                key: (0, $5a6326d9013f181c$export$9228d27a9c805655)(category, liability.id),
                description: String(liability.description || 'Debt'),
                balance: balance,
                interestRate: (0, $55a6490f14a54563$export$7d8ffbf26dcfd37b)(liability, category)
            });
        }
    }
    return debts;
}
/** What each source still holds once a funding plan has drawn on it. */ function $2663acaa6cb9dd5e$var$remainingAfter(sources, plan) {
    return sources.map((s)=>{
        const taken = plan.filter((p)=>p.type === s.type && p.id === s.id).reduce((sum, p)=>sum + p.amountToTake, 0);
        return {
            ...s,
            value: Math.max(0, s.value - taken)
        };
    }).filter((s)=>s.value > 0);
}
function $2663acaa6cb9dd5e$export$400f52df6f5fa614(factFind, amount, sources) {
    const debts = $2663acaa6cb9dd5e$export$d9e7ffb0b289bb15(factFind).sort((a, b)=>b.interestRate - a.interestRate);
    const available = sources.reduce((sum, s)=>sum + s.value, 0);
    let remaining = Math.min(Math.max(0, Number(amount) || 0), debts.reduce((sum, d)=>sum + d.balance, 0), available);
    if (remaining <= 0) return null;
    const total = remaining;
    const payments = {};
    for (const debt of debts){
        if (remaining <= 0) break;
        const pay = Math.min(debt.balance, remaining);
        payments[debt.key] = pay;
        remaining -= pay;
    }
    const funding = {};
    for (const source of $2663acaa6cb9dd5e$export$bc295484d84d1d5d(sources, total))funding[`${source.type}-${source.id}`] = source.amountToTake;
    return {
        payments: payments,
        funding: funding,
        repaymentBasis: 'keep_repayment'
    };
}
function $2663acaa6cb9dd5e$export$f9c2275cb7305f03(allocation, annuityTerms, sources, factFind) {
    /*
     * "OFF YOUR DEBT" USED TO REPAY NOTHING (found 18 Oct 2026). The amount was added to the funding
     * plan, but no `debtPayoff` was built, and the engine liquidates only the slice each lever takes —
     * so the debt, its interest and its repayments carried on as if nothing had been entered.
     *
     * Now the levers' own funding (gift, bond, annuity — the slices the engine takes in that order)
     * is drawn first, and the debt repayment is funded from what the same sources have left, as a
     * `debtPayoff` in the shared shape (support/debtPayoff.ts): payments keyed "<category>::<id>"
     * against the liabilities on the file, funding keyed "<assetType>-<assetId>". The engine applies
     * it at the start of the projection: the assets are drawn, the balance falls, and the repayment
     * plugin stops servicing a debt that reaches zero.
     */ const superAmount = $2663acaa6cb9dd5e$export$4c6420527ec5a824(allocation, 'superContribution');
    const bondAmount = $2663acaa6cb9dd5e$export$4c6420527ec5a824(allocation, 'investmentBond');
    /*
     * After-tax super is split between a couple the way the tested plans split it (the person whose super
     * Centrelink does not yet count first, else whoever has room), so a tested plan built on by hand runs the
     * same contribution. Single, or no file: all of it to the client.
     */ const superSplit = superAmount > 0 ? factFind ? (0, $996111778bb35e70$export$38069100974264d)(factFind, superAmount) : {
        client: superAmount,
        partner: 0,
        preferred: null
    } : null;
    // Only what super can take is drawn for it; the rest stays in the bank, as the engine would leave it.
    const superFunded = superSplit ? superSplit.client + superSplit.partner : 0;
    const leverTotal = Math.max(0, allocation.funeralBond) + Math.max(0, allocation.gift) + Math.max(0, allocation.annuity) + superFunded + bondAmount;
    const plan = $2663acaa6cb9dd5e$export$bc295484d84d1d5d(sources, leverTotal);
    const debtPayoff = factFind ? $2663acaa6cb9dd5e$export$400f52df6f5fa614(factFind, allocation.debtRepayment, $2663acaa6cb9dd5e$var$remainingAfter(sources, plan)) : null;
    return {
        ...debtPayoff ? {
            debtPayoff: debtPayoff
        } : {},
        id: 'cp-manual',
        name: 'Your plan',
        description: 'The allocation you have entered above.',
        ...allocation.funeralBond > 0 ? {
            funeralBondPurchase: allocation.funeralBond
        } : {},
        ...allocation.gift > 0 ? {
            giftingAmount: allocation.gift
        } : {},
        ...superSplit && superSplit.client + superSplit.partner > 0 ? {
            superContribution: {
                client: superSplit.client,
                partner: superSplit.partner,
                commenceIncomeStream: superSplit.preferred == null
            }
        } : {},
        ...bondAmount > 0 ? {
            investmentBond: bondAmount
        } : {},
        ...allocation.annuity > 0 ? {
            annuity: {
                purchaseAmount: allocation.annuity,
                annuityType: annuityTerms.annuityType === 'guaranteed' ? 'guaranteed' : 'lifetime',
                ownership: annuityTerms.owner,
                residualCapital: annuityTerms.residualCapital,
                reversionary: annuityTerms.reversionary,
                indexation: annuityTerms.indexation,
                incomeOverride: annuityTerms.incomeOverride
            }
        } : {},
        fundingSources: plan
    };
}
const $2663acaa6cb9dd5e$var$CASHFLOW_GOAL_KEYS = [
    'cpEmergencyReserve',
    'cpLevers'
];
function $2663acaa6cb9dd5e$export$650f0b37276dc44d(setFactFind) {
    if (!setFactFind) return undefined;
    return (patch)=>setFactFind((prev)=>{
            const goals = {
                ...prev?.goals || {}
            };
            for (const key of $2663acaa6cb9dd5e$var$CASHFLOW_GOAL_KEYS)if (key in (patch || {})) goals[key] = patch[key];
            return {
                ...prev,
                goals: goals
            };
        });
}
/** The goals keys the guaranteed-income question writes (GuaranteedIncomeQuestions), and only those. */ const $2663acaa6cb9dd5e$var$GUARANTEED_INCOME_GOAL_KEYS = [
    'annuityAppetite',
    'annuityResidual',
    'annuityShareCapPct',
    'annuityShareCapAmount',
    'annuityAnsweredOn'
];
function $2663acaa6cb9dd5e$export$53527fb30548f6a8(setFactFind) {
    if (!setFactFind) return undefined;
    return (patch)=>setFactFind((prev)=>{
            const goals = {
                ...prev?.goals || {}
            };
            for (const key of $2663acaa6cb9dd5e$var$GUARANTEED_INCOME_GOAL_KEYS)if (key in (patch || {})) goals[key] = patch[key];
            return {
                ...prev,
                goals: goals
            };
        });
}



const $cc855f77b4e7e2d7$var$amountOf = (v)=>Math.max(0, parseFloat(String(v ?? '')) || 0);
/**
 * Cash and near-cash the client could actually move — not the house, not their super pension.
 *
 * Returned as SOURCES, not a total, because the shared levers need to be told which asset pays.
 * Given only an amount they liquidate nothing and apply nothing (see cashflowPension.ts's
 * applyCandidate), which produces a ranking of identical candidates rather than an error.
 *
 * Bank accounts first: spending cash costs nothing, whereas selling shares can crystallise CGT that
 * this module does not model and should not silently incur.
 */ function $cc855f77b4e7e2d7$var$liquidSources(factFind) {
    const assets = factFind?.assets || {};
    const collect = (type)=>(assets[type] || []).filter((row)=>row?.id && $cc855f77b4e7e2d7$var$amountOf(row?.value) > 0).map((row)=>({
                type: type,
                id: String(row.id),
                value: $cc855f77b4e7e2d7$var$amountOf(row.value)
            }));
    return [
        ...collect('bankAccounts'),
        ...collect('termDeposits'),
        ...collect('shares')
    ];
}
function $cc855f77b4e7e2d7$var$liquidAssets(factFind) {
    return $cc855f77b4e7e2d7$var$liquidSources(factFind).reduce((sum, source)=>sum + source.value, 0);
}
/**
 * Draw `amount` across the available sources, largest-first within the bank-before-shares order.
 *
 * Keeps the emergency reserve intact by only ever being called with a committable amount.
 */ function $cc855f77b4e7e2d7$var$fundingFor(sources, amount) {
    const plan = [];
    let remaining = amount;
    for (const source of sources){
        if (remaining <= 0) break;
        const take = Math.min(source.value, remaining);
        if (take <= 0) continue;
        plan.push({
            type: source.type,
            id: source.id,
            amountToTake: take
        });
        remaining -= take;
    }
    return plan;
}
function $cc855f77b4e7e2d7$var$isCouple(factFind) {
    return factFind?.adviceFor === 'couple';
}
const $cc855f77b4e7e2d7$export$bd01c53d266fa90 = 50000;
const $cc855f77b4e7e2d7$export$da06e6e0ac437362 = [
    'bond',
    'gift',
    'tax'
];
function $cc855f77b4e7e2d7$export$c44200ae02a0feac(factFind) {
    const v = factFind?.goals?.cpEmergencyReserve;
    const n = v === '' || v == null ? NaN : Number(v);
    return Number.isFinite(n) && n >= 0 ? n : $cc855f77b4e7e2d7$export$bd01c53d266fa90;
}
function $cc855f77b4e7e2d7$export$fa523d4ac46927e8(factFind) {
    const raw = factFind?.goals?.cpLevers;
    if (typeof raw !== 'string') return [
        ...$cc855f77b4e7e2d7$export$da06e6e0ac437362
    ];
    return raw.split(',').map((x)=>x.trim()).filter((x)=>$cc855f77b4e7e2d7$export$da06e6e0ac437362.includes(x));
}
/** What is available to commit, after keeping the reserve back. */ function $cc855f77b4e7e2d7$var$committable(factFind) {
    return Math.max(0, $cc855f77b4e7e2d7$var$liquidAssets(factFind) - $cc855f77b4e7e2d7$export$c44200ae02a0feac(factFind));
}
function $cc855f77b4e7e2d7$export$54e72ca193834515(factFind) {
    const sources = $cc855f77b4e7e2d7$var$liquidSources(factFind);
    const has = (type)=>sources.some((s)=>s.type === type);
    const parts = [
        has('bankAccounts') ? 'bank accounts' : null,
        has('termDeposits') ? 'term deposits' : null,
        has('shares') ? 'shares' : null
    ].filter(Boolean);
    const madeOf = parts.length <= 1 ? parts[0] || 'savings' : `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}`;
    return {
        amount: $cc855f77b4e7e2d7$var$committable(factFind),
        reserve: $cc855f77b4e7e2d7$export$c44200ae02a0feac(factFind),
        madeOf: madeOf
    };
}
function $cc855f77b4e7e2d7$export$1ae058badd5eea31(factFind, /**
     * A provider's quote, where the client has one.
     *
     * Threaded into the annuity candidates rather than applied to the winner afterwards: a real
     * quote can change WHICH option wins, and a ranking struck on our indicative rate would then be
     * the wrong ranking (owner, 2026-09-01).
     *
     * A QUOTE BELONGS TO ONE TYPE AND ONE AMOUNT (owner, 21 Oct 2026 — the guaranteed income review M5;
     * annuityQuote.ts). Candidates of the same type use it scaled to their own amount; the other types keep
     * our estimate. It used to replace the income on every annuity candidate, whatever its type.
     */ annuityQuote = null) {
    const candidates = [
        {
            /*
             * THE BENCHMARK, and it is always first. Everything else is stated relative to it. An
             * engine with no do-nothing option ranks actions only against each other, so a strategy
             * that leaves the family worse off can still be crowned "best" — the exact defect the
             * Downsizer engine was caught with (2026-08-26).
             */ id: 'cp-nothing',
            name: 'Change nothing',
            description: 'Your position as it stands, projected over the same period. Every option below is measured against this.',
            changeNothing: true
        }
    ];
    const sources = $cc855f77b4e7e2d7$var$liquidSources(factFind);
    const available = $cc855f77b4e7e2d7$var$committable(factFind);
    const people = $cc855f77b4e7e2d7$var$isCouple(factFind) ? 2 : 1;
    const levers = $cc855f77b4e7e2d7$export$fa523d4ac46927e8(factFind);
    const bondsOk = levers.includes('bond');
    const giftOk = levers.includes('gift');
    const taxOk = levers.includes('tax');
    /*
     * FUNERAL BONDS — the cleanest of the levers and the smallest. Fully exempt up to the published
     * limit per person, and the money buys something most families pay for anyway. Sized at the
     * limit exactly: below it leaves exemption unused, above it is counted like any other asset, so
     * proposing more would be proposing a cost with no benefit.
     */ const bondTotal = (0, $1abe73eeef086faf$export$aca3edb7cd7a3f17) * people;
    if (bondsOk && available >= bondTotal) candidates.push({
        id: 'cp-funeral-bond',
        name: `Funeral bond${people > 1 ? 's' : ''} \u{2014} ${people > 1 ? 'one each' : 'up to the exempt limit'}`,
        description: `Move ${people > 1 ? 'up to the exempt limit each' : 'up to the exempt limit'} into a funeral bond. It stops counting for the assets test entirely, and it pays for something your family would otherwise fund from the estate.`,
        funeralBondPurchase: bondTotal,
        fundingSources: $cc855f77b4e7e2d7$var$fundingFor(sources, bondTotal)
    });
    /*
     * GIFTING — within the yearly free area only. Above it the excess is still counted, and still
     * deemed to earn income, for five years under the deprivation rules: the money has gone but the
     * means test has not noticed. The engine cannot weigh that five-year cost against a family's own
     * reasons for a larger gift, so it does not try.
     */ if (giftOk && available >= (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0)) candidates.push({
        id: 'cp-gift',
        name: 'Gift within the yearly free area',
        description: "Give away up to the yearly free area. Inside that limit it leaves the assets test straight away \u2014 above it, the excess is still counted for five years even though the money is gone.",
        giftingAmount: (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0),
        fundingSources: $cc855f77b4e7e2d7$var$fundingFor(sources, (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))
    });
    /* Both together, where there is enough to do both without breaking the reserve. */ if (bondsOk && giftOk && available >= bondTotal + (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0)) candidates.push({
        id: 'cp-bond-and-gift',
        name: 'Funeral bond and a gift',
        description: "Both of the above together \u2014 the largest reduction available without committing capital for life.",
        funeralBondPurchase: bondTotal,
        giftingAmount: (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0),
        fundingSources: $cc855f77b4e7e2d7$var$fundingFor(sources, bondTotal + (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))
    });
    /*
     * LIFETIME ANNUITY — the biggest lever and the one with the sharpest trade-off. Only 60% of the
     * purchase price counts as an asset, so it moves far more than a bond can, but the capital is
     * committed for life and cannot be recovered. Offered only where a meaningful amount is
     * available after the reserve; below that the loss of access buys too little to justify itself.
     */ /*
     * HOW MUCH (owner, 21 Oct 2026 — the village review's decision 11, every module; annuitySizes.ts): up to a
     * quarter of what is available, and — where it would lift the Age Pension — the amount that lifts it most,
     * as a plan of its own. Previously half of what was available, up to $400,000.
     */ const MIN_ANNUITY = 50000;
    const sizes = (0, $cb76d0656284f28b$export$4dc6c2d1b2b95e25)(factFind, {
        investable: available,
        capPct: 25,
        homeowner: Number(factFind?.home?.value) > 0,
        lessCounted: available
    });
    for (const size of sizes){
        if (size.amount < MIN_ANNUITY) continue;
        const rounded = size.pensionMax ? size.amount : Math.floor(size.amount / 10000) * 10000;
        const tail = size.pensionMax ? '-max' : '';
        const sizeName = size.pensionMax ? ', the amount that lifts the Age Pension most' : '';
        /*
         * BOTH ENDS OF THE RESIDUAL-CAPITAL TRADE-OFF.
         *
         * Centrelink assesses a lifetime annuity at 60% of its purchase price WHATEVER its residual
         * capital value — RCV changes the payment rate, not the assets-test treatment. But net worth
         * values an annuity at its RESIDUAL (assessment/netWorth.ts, deliberately), so offering only
         * the nil-RCV version meant every annuity option here lost the estate comparison by its full
         * purchase price on day one. It was ruled out before the comparison started, in a module
         * whose whole purpose is comparing the estate cost of improving cashflow and pension.
         *
         * Every other module offers both. This one was built after that fix went in and inherited
         * the original single-variant shape.
         */ const annuityMeansTest = 'Only 60% of what you pay counts in the assets test, so it moves more than any other option here';
        const cpAnnuityPreference = (0, $ff5de4128b46b139$export$636a9065c3f862c1)(factFind);
        if ((0, $ff5de4128b46b139$export$b8876d0a37b8526a)(cpAnnuityPreference, 0)) candidates.push({
            id: `cp-annuity${tail}`,
            name: `Lifetime annuity (nil residual${sizeName})`,
            description: `Buy a lifetime income stream. ${annuityMeansTest} \u{2014} but the money is committed for life and cannot be taken back. This version pays the most income and leaves nothing of the purchase price to your estate.`,
            annuity: {
                purchaseAmount: rounded,
                annuityType: 'lifetime',
                ownership: 'client',
                residualCapital: 0,
                incomeOverride: (0, $da24031d156d6acb$export$2ee327201b9e82a1)(annuityQuote, 'lifetime', 0, rounded) ?? null
            },
            fundingSources: $cc855f77b4e7e2d7$var$fundingFor(sources, rounded)
        });
        if ((0, $ff5de4128b46b139$export$b8876d0a37b8526a)(cpAnnuityPreference, 1)) candidates.push({
            id: `cp-annuity${tail}-rcv`,
            name: `Lifetime annuity (capital returned${sizeName})`,
            description: `The same annuity, but with the purchase price coming back to the estate on an early death \u{2014} in full within the first half of life expectancy, less after that \u{2014} rather than kept by the provider. It pays less income, and Centrelink still counts only 60% either way.`,
            annuity: {
                purchaseAmount: rounded,
                annuityType: 'lifetime',
                ownership: 'client',
                residualCapital: 1,
                incomeOverride: (0, $da24031d156d6acb$export$2ee327201b9e82a1)(annuityQuote, 'lifetime', 100, rounded) ?? null
            },
            fundingSources: $cc855f77b4e7e2d7$var$fundingFor(sources, rounded)
        });
        if ((0, $ff5de4128b46b139$export$623904c9366cf5a0)(cpAnnuityPreference, factFind)) candidates.push({
            id: `cp-annuity${tail}-guaranteed`,
            name: `Lifetime annuity (full amount guaranteed${sizeName})`,
            description: `A lifetime annuity and a life policy bought together, so the full purchase price comes back to your estate whenever death comes. It pays the least income of the three, and only the annuity half earns the 60% assets-test treatment; the policy is counted at what it cost.`,
            annuity: {
                purchaseAmount: rounded,
                annuityType: 'guaranteed',
                ownership: 'client',
                residualCapital: 1,
                incomeOverride: (0, $da24031d156d6acb$export$2ee327201b9e82a1)(annuityQuote, 'guaranteed', 100, rounded) ?? null
            },
            fundingSources: $cc855f77b4e7e2d7$var$fundingFor(sources, rounded)
        });
    }
    /*
     * AFTER-TAX SUPER (F.6) AND AN INVESTMENT BOND (F.5) — 17 Sep 2026.
     *
     * Neither moves the means test on its own — accumulation super for someone over Age Pension age,
     * a pension, and a bond are all counted and deemed like the cash they replace. What they change
     * is TAX: 15% (or nil in a pension) or the bond's 30% inside, instead of the client's own rate on
     * the same earnings. The exception is worth the most: a couple with one member under Age Pension
     * age, whose accumulation super Centrelink does not count until they reach it.
     *
     * Logic-based: super only where the person may contribute (under 75, room under the balance
     * bands); the bond only where they may not — offering both to the same person would rank a
     * 30% tax rate against a 15% one and call it a choice.
     */ if (taxOk && available >= MIN_ANNUITY) {
        const ff = factFind;
        const superRoom = (0, $996111778bb35e70$export$3156faa588d94c0c)(ff);
        if (superRoom.total > 0) {
            const ncc = (0, $996111778bb35e70$export$38069100974264d)(ff, Math.round(available / 10000) * 10000);
            const total = ncc.client + ncc.partner;
            if (total >= MIN_ANNUITY) candidates.push({
                id: 'cp-super-after-tax',
                name: 'Move savings into super (after-tax contribution)',
                description: `Contribute ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(total)} of your savings to super after tax${ncc.preferred ? ` \u{2014} ${ncc.preferred === 'client' ? factFind?.client?.firstName || 'the client' : factFind?.partner?.firstName || 'the partner'} first, whose accumulation super is not counted by Centrelink until Age Pension age` : ', where the earnings are taxed at 15% (nil once it pays a pension) instead of at your own rate'}. Capped at what each of you may contribute now; the money stays yours and can be drawn on.`,
                superContribution: {
                    client: ncc.client,
                    partner: ncc.partner,
                    commenceIncomeStream: ncc.preferred == null
                },
                fundingSources: $cc855f77b4e7e2d7$var$fundingFor(sources, total)
            });
        } else {
            const bondAmount = Math.round(Math.min(available * 0.5, 400000) / 10000) * 10000;
            if (bondAmount >= MIN_ANNUITY) candidates.push({
                id: 'cp-invest-bond',
                name: 'Move savings into an investment bond',
                description: `Put ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(bondAmount)} of your savings into an investment bond \u{2014} the tax-paid home for money super can no longer take. It pays its own tax inside (30%) and nothing on your tax return; after ten years withdrawals are tax-free. Centrelink counts it in full and deems it, like the cash it replaces, so this is about tax, not the pension. Best left alone for ten years.`,
                investmentBond: bondAmount,
                fundingSources: $cc855f77b4e7e2d7$var$fundingFor(sources, bondAmount)
            });
        }
    }
    candidates.push(...$cc855f77b4e7e2d7$var$clearDebtTwins(factFind, candidates, sources));
    return candidates;
}
const $cc855f77b4e7e2d7$export$ce2540e139b53588 = (0, $485d903040fc3504$export$fe12727427ec68c1);
/**
 * EVERY PLAN, ALSO WITH THE DEBTS CLEARED (owner, 22 Oct 2026: "every module needs to test paying it off").
 *
 * Paying off a debt was only possible by hand here. Now, as in the village, downsizing and granny flat, each
 * plan has a twin that does the same and then pays off every debt (not a reverse mortgage), dearest first, from
 * what the plan leaves, keeping the emergency money in the bank; "change nothing" has one too, "pay off the
 * debts" on its own. The same `debtPayoff` the hand-built plan uses, so the server needs nothing new. A plan that
 * cannot also clear the debts gets no twin.
 */ function $cc855f77b4e7e2d7$var$clearDebtTwins(factFind, candidates, sources) {
    // Which debts: strategy/debtsToTest.ts (any interest-bearing debt, whatever its size; interest-free debts from
    // CP_DEBT_TWIN_FLOOR; a card paid off monthly is never listed), the rule every module uses (26 Oct 2026).
    const debts = (0, $485d903040fc3504$export$718566aeb53e1efe)((0, $2663acaa6cb9dd5e$export$d9e7ffb0b289bb15)(factFind));
    const total = debts.reduce((t, d)=>t + d.balance, 0);
    if (debts.length === 0) return [];
    const reserve = $cc855f77b4e7e2d7$export$c44200ae02a0feac(factFind);
    const twins = [];
    for (const c of candidates){
        if (c.debtPayoff) continue;
        // What this plan leaves of each account, with the emergency money held back in the bank.
        let keep = reserve;
        const left = sources.map((s)=>{
            const taken = (c.fundingSources || []).filter((f)=>f.type === s.type && f.id === s.id).reduce((t, f)=>t + f.amountToTake, 0);
            let value = Math.max(0, s.value - taken);
            if (s.type === 'bankAccounts' && keep > 0) {
                const held = Math.min(keep, value);
                value -= held;
                keep -= held;
            }
            return {
                ...s,
                value: value
            };
        }).filter((s)=>s.value > 0);
        if (keep > 0) // The emergency money could not all stay in the bank: hold the rest back from the other accounts too.
        for (const s of left){
            const held = Math.min(keep, s.value);
            s.value -= held;
            keep -= held;
        }
        if (left.reduce((t, s)=>t + s.value, 0) + 0.5 < total) continue;
        const debtPayoff = (0, $2663acaa6cb9dd5e$export$400f52df6f5fa614)(factFind, total, left.filter((s)=>s.value > 0));
        if (!debtPayoff) continue;
        twins.push(c.changeNothing ? {
            id: 'cp-clear-debt',
            name: 'Pay off the debts',
            description: `Pay off ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(total)} of debts from savings, dearest first, keeping the emergency money in the bank.`,
            debtPayoff: debtPayoff
        } : {
            ...c,
            id: `${c.id}-clear-debt`,
            name: `${c.name}, and clear the debts`,
            description: `${c.description} Then pay off ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(total)} of debts from what is left, keeping the emergency money in the bank.`,
            debtPayoff: debtPayoff
        });
    }
    return twins;
}



const $13d137e110a3aed6$var$PLAN_TYPE_WORDS = {
    aged_care: 'Aged care',
    home_care: 'Support at Home',
    retirement_village: 'Retirement village',
    downsizer: 'Downsizing',
    granny_flat: 'Granny flat',
    cashflow_pension: 'Cashflow and Age Pension'
};
function $13d137e110a3aed6$export$c6aafd8353c81df(plan) {
    const kind = $13d137e110a3aed6$var$PLAN_TYPE_WORDS[plan.type] || 'Plan';
    const when = plan.createdAt ? new Date(plan.createdAt) : null;
    const date = when && !Number.isNaN(when.getTime()) ? ` (saved ${when.toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    })})` : '';
    return `${kind}: ${plan.name || 'unnamed plan'}${date}`;
}
function $13d137e110a3aed6$export$4917af9b05941375(saved, types) {
    return (saved || []).filter((p)=>p && types.includes(String(p.type))).slice().sort((a, b)=>String(b.createdAt || '').localeCompare(String(a.createdAt || '')));
}
const $13d137e110a3aed6$export$a35afb9ef2d5331d = {
    aged_care: 'aged_care',
    home_care: 'home_care',
    retirement_village: 'retirement_village',
    downsize_home: 'downsizer',
    granny_flat: 'granny_flat'
};
const $13d137e110a3aed6$var$n = (v)=>{
    const x = typeof v === 'number' ? v : parseFloat(String(v ?? ''));
    return Number.isFinite(x) ? x : 0;
};
function $13d137e110a3aed6$export$1ff437c72df79ba6(plan) {
    const inputs = plan.inputs || {};
    const facts = {};
    if (plan.type === 'aged_care') {
        facts.enteringCare = true;
        const engine = plan.strategy?.strategyOptions;
        if (engine?.rentHome) facts.homeRented = {
            perWeek: $13d137e110a3aed6$var$n(engine.rentAmount),
            expensesPerYear: $13d137e110a3aed6$var$n(engine.rentExpenses)
        };
        else if (inputs.overallStrategy?.rentHome) facts.homeRented = {
            perWeek: $13d137e110a3aed6$var$n(inputs.strategyInputs?.rentAmount),
            expensesPerYear: $13d137e110a3aed6$var$n(inputs.strategyInputs?.rentExpenses)
        };
    }
    if (plan.type === 'retirement_village') {
        const rentHome = inputs.rentHome ?? inputs.rvOverallStrategy?.rentHome ?? inputs.fundFrom === 'rent_home';
        if (rentHome && inputs.rentDetails) facts.homeRented = {
            perWeek: $13d137e110a3aed6$var$n(inputs.rentDetails.rentAmount),
            expensesPerYear: $13d137e110a3aed6$var$n(inputs.rentDetails.rentExpenses)
        };
    }
    return facts;
}
const $13d137e110a3aed6$var$asFactFind = (ff)=>ff;
const $13d137e110a3aed6$var$asDraft = (ff)=>ff;
/** Keys an applier adds for its own bookkeeping, which are not part of anyone's profile. */ function $13d137e110a3aed6$var$withoutBookkeeping(ff) {
    const out = {
        ...ff
    };
    for (const k of Object.keys(out))if (k.startsWith('__') && k !== '__appState' && k !== '__appData') delete out[k];
    return out;
}
async function $13d137e110a3aed6$export$81e3be860652ae70(ff, plan) {
    try {
        const r = await $13d137e110a3aed6$var$rebuild(ff, plan);
        if (!r.ok) return r;
        return {
            ...r,
            factFind: $13d137e110a3aed6$var$withoutBookkeeping(r.factFind),
            facts: $13d137e110a3aed6$export$1ff437c72df79ba6(plan)
        };
    } catch  {
        return {
            ok: false,
            reason: "This plan could not be rebuilt just now. Use today\u2019s position, or open the module and save the plan again."
        };
    }
}
function $13d137e110a3aed6$export$44afb2aa71941e43(ff, inputs) {
    const sr = inputs.secondRoom;
    const amount = Math.min(Number(sr?.radPaid) || 0, Number(sr?.roomPrice) || 0);
    if (!sr || !(amount > 0)) return {};
    return {
        secondRadFunding: (0, $0e15302c37df0d54$export$b097a93d3ede847)(ff, amount, inputs.radFunding || {}).radFunding
    };
}
async function $13d137e110a3aed6$var$rebuild(ff, plan) {
    const inputs = plan.inputs || {};
    const caveats = [];
    switch(plan.type){
        case 'aged_care':
            {
                const row = plan.strategy;
                if (row && (row.radFunding || row.strategyOptions || row.meansTestStrategy)) {
                    // The engine's own "at entry" balance sheet: the one its fees were assessed on. Where
                    // both of a couple enter care, the row's second room goes too, so its deposit has left.
                    const scenario = {
                        radFunding: row.radFunding || {},
                        strategyOptions: row.strategyOptions || {},
                        meansTestStrategy: row.meansTestStrategy,
                        ...row.secondRoom ? {
                            secondRoom: row.secondRoom
                        } : {}
                    };
                    return {
                        ok: true,
                        factFind: $13d137e110a3aed6$var$asDraft(await $55a1d8a64f1e5dfa$export$525fe6203be9cb4(ff, scenario)),
                        caveats: caveats
                    };
                }
                if (plan.source === 'suggestion_engine') return {
                    ok: false,
                    reason: 'This plan was saved before plans recorded their details. Select it again in the aged care module to use it here.'
                };
                if (inputs.overallStrategy?.sellInvestmentProperty && !inputs.investmentPropertyDetails) caveats.push('The investment property sale is not included: this plan was saved before its details were recorded. Save it again in the aged care module to include it.');
                const { data: data } = (0, $9c5c211308401e85$export$4a20ccd66ad56fc)(ff, {
                    scenarioLivingExpenses: inputs.scenarioLivingExpenses ?? ff?.expenses?.livingExpenses,
                    overallStrategy: inputs.overallStrategy || {},
                    downsizeDetails: inputs.downsizeDetails || {},
                    investmentPropertyDetails: inputs.investmentPropertyDetails || null,
                    reverseMortgageDetails: inputs.reverseMortgageDetails || null,
                    otherStrategies: inputs.otherStrategies || {},
                    annuityRecord: inputs.annuityRecord || null,
                    radFunding: inputs.radFunding || {},
                    ...$13d137e110a3aed6$export$44afb2aa71941e43(ff, inputs),
                    cgtOverrides: inputs.cgtOverrides || {},
                    debtPayoffPlan: (0, $9c5c211308401e85$export$ec16a23ddd681f35)(inputs.debtPayments, inputs.debtFunding, inputs.debtRepaymentBasis),
                    // After the plan: the deposit paid and the debt cleared, whatever day they fall on.
                    // A change of home sells on the move day (the engine's job), so the simulation leaves the
                    // sale to be applied with the move below.
                    deferToEngine: !!inputs.facilityMove
                });
                // A change of home (8 Oct 2026): after the plan the move has happened — the deposit held
                // (from the profile) refunded, the nominated assets sold, the new deposit paid.
                const mv = inputs.facilityMove;
                if (mv && (Number(mv.radTarget) || 0) >= 0 && inputs.facilityMove) {
                    const opened = (0, $7902ca900a473358$export$2a6399fb2105ee37)(data);
                    const held = (opened.assets?.radPaid || []).filter((r)=>(r.ownership ?? 'client') === (mv.person ?? 'client')).reduce((t, r)=>t + (Number(r.value) || 0), 0);
                    const moved = (0, $7902ca900a473358$export$f0b7a61c305d05db)(opened, {
                        person: mv.person ?? 'client',
                        refundToday: held,
                        radTarget: Number(mv.radTarget) || 0,
                        radFunding: inputs.radFunding || {},
                        cgtOverrides: inputs.cgtOverrides || {}
                    }).factFind;
                    return {
                        ok: true,
                        factFind: $13d137e110a3aed6$var$asDraft(moved),
                        caveats: caveats
                    };
                }
                return {
                    ok: true,
                    factFind: $13d137e110a3aed6$var$asDraft(data),
                    caveats: caveats
                };
            }
        case 'home_care':
            {
                if (inputs.seConfig) return {
                    ok: true,
                    factFind: (0, $1a3577d7101fe882$export$2130d11e4b2e7a7)(ff, inputs.seConfig),
                    caveats: caveats
                };
                if (inputs.selectedFundingStrategy === 'annuity' && !inputs.annuityRecordForCalculation) caveats.push('The annuity is not included: this plan was saved before its details were recorded. Save it again in the Support at Home module to include it.');
                const beforeFinancials = await $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(ff);
                const { optimizedFactFind: optimizedFactFind } = (0, $d89d3f0f7a42703f$export$e852251532541c4f)(ff, {
                    manualStrategies: {
                        gifting: inputs.gifting ?? 0,
                        funeralBonds: inputs.funeralBonds ?? 0,
                        giftingSource: inputs.giftingSource,
                        funeralSource: inputs.funeralSource
                    },
                    propertyStrategy: inputs.propertyStrategy,
                    downsizeDetails: inputs.downsizeDetails || {},
                    renovateDetails: inputs.renovateDetails || {},
                    upgradeDetails: inputs.upgradeDetails || {},
                    overallStrategy: inputs.overallStrategy || {},
                    reverseMortgageDetails: inputs.reverseMortgageDetails || null,
                    // A linked residential stay is the partner's care, not this assessment's position.
                    selectedAgedCareIntegration: null,
                    selectedFundingStrategy: inputs.selectedFundingStrategy,
                    annuityRecordForCalculation: inputs.annuityRecordForCalculation || null,
                    beforeFinancials: beforeFinancials
                });
                return {
                    ok: true,
                    factFind: optimizedFactFind,
                    caveats: caveats
                };
            }
        case 'retirement_village':
            {
                const villageInputs = inputs.villageInputs || {};
                const fundFrom = inputs.fundFrom || 'liquid';
                const rentHome = !!(inputs.rentHome ?? inputs.rvOverallStrategy?.rentHome);
                const rvStrategy = {
                    fundFrom: fundFrom,
                    rentHome: rentHome,
                    sellHomeDetails: fundFrom === 'sell_home' ? inputs.sellHomeDetails : undefined,
                    rentDetails: rentHome ? inputs.rentDetails : undefined,
                    entryFeeFunding: inputs.entryFeeFundingProvenance?.resolvedAllocation ?? inputs.entryFeeFunding ?? inputs.entryFeeFundingOverride,
                    entryFeeCgtOverrides: inputs.entryFeeCgtOverrides,
                    investmentPropertyDetails: fundFrom === 'investment_property' ? inputs.rvInvestmentPropertyDetails ?? inputs.investmentPropertyDetails : undefined,
                    otherStrategies: inputs.otherStrategies,
                    annuityRecord: inputs.annuityRecord
                };
                let out = (0, $d6349ba6b2bbee8e$export$51ca4b84e58af4b9)($13d137e110a3aed6$var$asFactFind(ff), rvStrategy, villageInputs).factFind;
                if (inputs.debtPayoff) out = (0, $5a6326d9013f181c$export$525e306199c9748e)(out, inputs.debtPayoff, {}).factFind;
                return {
                    ok: true,
                    factFind: $13d137e110a3aed6$var$asDraft(out),
                    caveats: caveats
                };
            }
        case 'downsizer':
            {
                if (!inputs.details) return {
                    ok: false,
                    reason: 'This plan has no sale details recorded. Open the downsizing module and save it again.'
                };
                let out = (0, $41978d8498e37f65$export$e9de74ff7fc60a05)(ff, inputs.details);
                if (inputs.debtPayoff) out = (0, $5a6326d9013f181c$export$525e306199c9748e)(out, inputs.debtPayoff, {}).factFind;
                return {
                    ok: true,
                    factFind: $13d137e110a3aed6$var$asDraft(out),
                    caveats: caveats
                };
            }
        case 'granny_flat':
            if (!inputs.gf) return {
                ok: false,
                reason: 'This plan has no arrangement recorded. Open the granny flat module and select it again.'
            };
            return {
                ok: true,
                factFind: $13d137e110a3aed6$var$asDraft(await $55a1d8a64f1e5dfa$export$a4daa50757e2f837(ff, inputs.gf)),
                caveats: caveats
            };
        case 'cashflow_pension':
            {
                let candidate = inputs.candidate;
                if (!candidate && inputs.source === 'manual' && inputs.allocation) {
                    candidate = (0, $2663acaa6cb9dd5e$export$f9c2275cb7305f03)({
                        ...(0, $2663acaa6cb9dd5e$export$8471fcc462280406),
                        ...inputs.allocation
                    }, (0, $2663acaa6cb9dd5e$export$8a567aa13eab014b), (0, $2663acaa6cb9dd5e$export$a6b5e1b0a97dc6ff)(ff), ff);
                    if (Number(inputs.allocation.annuity) > 0) caveats.push('The annuity is rebuilt on the default terms: this plan was saved before its terms were recorded.');
                }
                if (!candidate && inputs.engineOptionId) candidate = (0, $cc855f77b4e7e2d7$export$1ae058badd5eea31)(ff, null).find((c)=>c.id === inputs.engineOptionId) || null;
                if (!candidate) return {
                    ok: false,
                    reason: 'This plan could not be rebuilt. Open the cashflow module and save it again.'
                };
                return {
                    ok: true,
                    factFind: $13d137e110a3aed6$var$asDraft(await $55a1d8a64f1e5dfa$export$b7160ddedb3f53b2(ff, candidate)),
                    caveats: caveats
                };
            }
        default:
            return {
                ok: false,
                reason: 'This kind of plan does not change what the form asks.'
            };
    }
}
function $13d137e110a3aed6$export$4215b55f44adb313(plan) {
    const v = Number(plan?.outputs?.agePension);
    return Number.isFinite(v) ? v : 0;
}


function $5ea55f03cd2af1e4$export$12c4b1871639c9ac(factFind) {
    const a = factFind?.goals?.sahAgedCareMove;
    return a === 'yes' || a === 'no' || a === 'unsure' ? a : null;
}
function $5ea55f03cd2af1e4$export$2205ffc60cf2c238(factFind) {
    if (factFind?.adviceFor !== 'couple') return null;
    const g = factFind?.goals || {};
    if (!g.aged_care) return null;
    return g.aged_care_for === 'partner' ? 'partner' : g.aged_care_for === 'client' ? 'client' : null;
}
function $5ea55f03cd2af1e4$export$fe04ad50cd2b5dad(plan, factFind) {
    if ($5ea55f03cd2af1e4$export$12c4b1871639c9ac(factFind) !== 'yes') return plan;
    const who = $5ea55f03cd2af1e4$export$2205ffc60cf2c238(factFind);
    return who ? {
        ...plan,
        [who]: {}
    } : plan;
}
function $5ea55f03cd2af1e4$export$b164904e0d858bed(saved) {
    const list = (saved || []).filter((s)=>s?.type === 'aged_care');
    return list.find((s)=>s.chosen) ?? (list.length === 1 ? list[0] : null);
}
function $5ea55f03cd2af1e4$export$6d4a478abfb618cb(integration, factFind) {
    if (!integration) return {};
    const from = integration.strategyOptions || {};
    const overrides = {
        ...from.clientResidencyOverride ? {
            clientResidencyOverride: from.clientResidencyOverride
        } : {},
        ...from.partnerResidencyOverride ? {
            partnerResidencyOverride: from.partnerResidencyOverride
        } : {}
    };
    return Object.keys(overrides).length ? overrides : (0, $8eecd0af141b9afb$export$7b84565bbb0eef12)(factFind);
}
function $5ea55f03cd2af1e4$export$7fa4cd25cd8ca863(args) {
    // A past date is "already receiving support" — the same collapse Optimise makes (sahStartDate.test.ts).
    const future = args.supportStartDate && args.supportStartDate >= new Date().toISOString().slice(0, 10) ? args.supportStartDate : '';
    const timing = future ? {
        careStartDate: future
    } : {};
    if (!args.linked) return Object.keys(timing).length > 0 ? {
        strategyOptions: timing
    } : {};
    const fees = Number(args.linked.annualCost) || 0;
    return {
        strategyOptions: {
            ...args.overrides,
            ...timing,
            ...fees > 0 ? {
                linkedAgedCareAnnualCost: fees
            } : {}
        }
    };
}
async function $5ea55f03cd2af1e4$export$52b55e2d4cc3fb71(factFind, linkedRecord) {
    if (!linkedRecord) return {
        factFind: null,
        caveats: []
    };
    const r = await (0, $13d137e110a3aed6$export$81e3be860652ae70)(factFind, linkedRecord);
    return r.ok ? {
        factFind: r.factFind,
        caveats: r.caveats
    } : {
        factFind: null,
        caveats: [],
        reason: r.reason
    };
}
function $5ea55f03cd2af1e4$export$696453b4446851c9(factFind, linked, structureFunding, positioned) {
    let ff = structuredClone(linked && positioned ? positioned : factFind);
    if (structureFunding && (factFind?.structures || []).length > 0) ff.structureFundingInSuggestions = structureFunding;
    if (linked) {
        if (linked.radFunding && !positioned) ff = (0, $87af0cc4cc4e8984$export$8a0c5ad907f77392)(ff, linked.radFunding);
        if (linked.livingExpenses !== undefined && linked.livingExpenses !== null) ff.expenses = {
            ...ff.expenses || {},
            livingExpenses: linked.livingExpenses
        };
    }
    return ff;
}
function $5ea55f03cd2af1e4$export$a5165c78061d54fc(args) {
    const linkedRecord = $5ea55f03cd2af1e4$export$12c4b1871639c9ac(args.factFind) === 'yes' ? $5ea55f03cd2af1e4$export$b164904e0d858bed(args.savedStrategies) : null;
    const linked = linkedRecord ? (0, $87af0cc4cc4e8984$export$2fdaec60121ed226)(linkedRecord) : null;
    const overrides = $5ea55f03cd2af1e4$export$6d4a478abfb618cb(linked, args.factFind);
    const ctx = $5ea55f03cd2af1e4$export$7fa4cd25cd8ca863({
        supportStartDate: args.supportStartDate,
        linked: linked,
        overrides: overrides
    });
    return {
        linked: linked,
        linkedRecord: linkedRecord,
        baselineFactFind: $5ea55f03cd2af1e4$export$696453b4446851c9(args.factFind, linked, args.factFind?.structureFundingInSuggestions, args.positioned),
        evaluationOptions: {
            strategyOptions: ctx.strategyOptions || {},
            contributionOptions: ctx
        }
    };
}
async function $5ea55f03cd2af1e4$export$816274d728d58b8d(factFind, record) {
    if (!record) return null;
    const details = (0, $87af0cc4cc4e8984$export$2fdaec60121ed226)(record);
    const pos = await $5ea55f03cd2af1e4$export$52b55e2d4cc3fb71(factFind, record);
    return {
        record: record,
        details: details,
        before: factFind,
        after: $5ea55f03cd2af1e4$export$696453b4446851c9(factFind, details, undefined, pos.factFind),
        whole: !!pos.factFind,
        caveats: pos.caveats,
        reason: pos.reason
    };
}
function $5ea55f03cd2af1e4$export$6f755083936d6e5c(args) {
    const fees = Number(args.linkedFeesAYear) || 0;
    if (fees <= 0) return {
        options: args.options,
        costs: args.costs
    };
    const sah = Number(args.supportAtHomeAYear) || 0;
    return {
        options: {
            ...args.options,
            linkedAgedCareAnnualCost: fees,
            integratedAgedCareCost: sah + fees
        },
        costs: {
            ...args.costs,
            totalDailyCost: sah / 365
        }
    };
}



const $2eb5e3232a8b6136$export$ef78d200e1ff7453 = (agedCarePlanId)=>JSON.stringify([
        'whole-aged-care-plan',
        agedCarePlanId
    ]);
/** Plans chosen before 24 Oct carried only the deposit of a linked aged care plan, never the whole plan. */ const $2eb5e3232a8b6136$var$BEFORE_WHOLE_PLAN = 'before-whole-plan';
function $2eb5e3232a8b6136$export$87903b39a9be0490(factFind, savedStrategies) {
    const ac = (0, $5ea55f03cd2af1e4$export$12c4b1871639c9ac)(factFind) === 'yes' ? (0, $5ea55f03cd2af1e4$export$b164904e0d858bed)(savedStrategies) : null;
    return $2eb5e3232a8b6136$export$ef78d200e1ff7453(ac?.id != null ? String(ac.id) : null);
}
function $2eb5e3232a8b6136$export$7bef8f28695964f0(plan) {
    const inputs = plan?.inputs || {};
    if (typeof inputs.householdFingerprint === 'string') return inputs.householdFingerprint;
    return inputs.agedCareContext === 'linked' ? $2eb5e3232a8b6136$var$BEFORE_WHOLE_PLAN : $2eb5e3232a8b6136$export$ef78d200e1ff7453(null);
}
const $2eb5e3232a8b6136$var$carried = (fingerprint)=>{
    try {
        const v = JSON.parse(fingerprint);
        return Array.isArray(v) && v[1] != null ? String(v[1]) : null;
    } catch  {
        return fingerprint === $2eb5e3232a8b6136$var$BEFORE_WHOLE_PLAN ? $2eb5e3232a8b6136$var$BEFORE_WHOLE_PLAN : null;
    }
};
function $2eb5e3232a8b6136$export$bc9892722f29f4ff(plan, factFind, savedStrategies) {
    if (!plan) return null;
    const then = $2eb5e3232a8b6136$export$7bef8f28695964f0(plan);
    const now = $2eb5e3232a8b6136$export$87903b39a9be0490(factFind, savedStrategies);
    if (then !== now) {
        const who = (0, $5ea55f03cd2af1e4$export$2205ffc60cf2c238)(factFind);
        const name = String((who === 'partner' ? factFind?.partner?.firstName : factFind?.client?.firstName) || '').trim();
        const whose = name ? `${name}'s` : 'the';
        const wasCarried = $2eb5e3232a8b6136$var$carried(then);
        const isCarried = $2eb5e3232a8b6136$var$carried(now);
        if (isCarried && (!wasCarried || wasCarried === $2eb5e3232a8b6136$var$BEFORE_WHOLE_PLAN)) return `Chosen before ${whose} aged care plan was carried in, so its figures are out of date \u{2014} open it to choose again.`;
        if (!isCarried) return `Chosen with ${whose} aged care plan carried in, which no longer applies, so its figures are out of date \u{2014} open it to choose again.`;
        return `Chosen with a different aged care plan for ${name || 'the move'}, so its figures are out of date \u{2014} open it to choose again.`;
    }
    return (0, $78a369bbf1e0d995$export$f4ec6e978b61cc57)(plan)?.reason ?? null;
}



var $acw62 = parcelRequire("acw62");







// Utility functions for calculating service plan costs
// Can be used by both ServiceBuilderSection and SupportAtHomeSuggestionEngine
/**
 * supportAtHomeServices.js – Support at Home service catalogue aligned to the
 * official Support at Home Service List (Australian Government Department of Health and Aged Care).
 * Source: Support at Home program handbook / service list (health.gov.au).
 * Structure follows the Department’s breakdown: each service type and sub-type listed in the
 * official list is included (no items removed). Used by SupportAtHomePage and ServiceBuilderSection.
 *
 * Bot / external updates: This file is the single source of truth for service names, units, and
 * indicative pricing. To refresh from department data, update the SUPPORT_AT_HOME_SERVICES object:
 * each service has id, name, unit, medianPrice, range { lower, upper }, description, keywords.
 * Keep id stable for existing plans; add new services or adjust name/medianPrice/range as needed.
 */ const $25e9acc02c907060$export$a3b71735b810a98c = {
    clinical: {
        label: 'Clinical Care',
        contribution: 0,
        services: [
            // Personal care sits in CLINICAL SUPPORTS, not Independence, from 1 October 2026: the Government
            // fully funds showering, dressing, continence support, help with eating/hygiene and assistance with
            // self-administering medication — no participant contribution at any means level. Announced by the
            // Dept of Health, Disability and Ageing ("Personal care to be fully funded under Support at Home",
            // health.gov.au, 2026); definition and scope unchanged, only the contribution category moved. This
            // product launches after that date, so the rule is applied outright rather than as a dated boundary —
            // a deliberate simplification: pre-October testing shows personal care free a few weeks early, and no
            // production client is ever charged the old way.
            {
                id: 'personal_care',
                name: 'Personal Care',
                unit: 'Hour',
                medianPrice: 100,
                range: {
                    lower: 85,
                    upper: 115
                },
                description: 'Assistance with self-care and activities of daily living; self-administration of medication; non-clinical continence management; attendant care for mobility, eating and hygiene.',
                keywords: [
                    'showering',
                    'bathing',
                    'dressing',
                    'grooming',
                    'toilet',
                    'hygiene',
                    'medication',
                    'continence'
                ]
            },
            // Nursing care (Department lists: Registered nurse, Enrolled nurse, Nursing assistant, Nursing care consumables)
            {
                id: 'nursing_registered',
                name: 'Registered Nurse',
                unit: 'Hour',
                medianPrice: 160,
                range: {
                    lower: 144,
                    upper: 186
                },
                description: 'Registered nurse: assessing, treating and monitoring clinical conditions; administration of medications; wound care, continence management (clinical) and management of skin integrity; education; specialist service linkage.',
                keywords: [
                    'nurse',
                    'nursing',
                    'wound',
                    'medication',
                    'health',
                    'clinical'
                ]
            },
            {
                id: 'nursing_enrolled',
                name: 'Enrolled Nurse',
                unit: 'Hour',
                medianPrice: 140,
                range: {
                    lower: 120,
                    upper: 163
                },
                description: 'Enrolled nurse providing supervised clinical care and support under the direction of a registered nurse.',
                keywords: [
                    'nurse',
                    'nursing'
                ]
            },
            {
                id: 'nursing_assistant',
                name: 'Nursing Assistant',
                unit: 'Hour',
                medianPrice: 110,
                range: {
                    lower: 92,
                    upper: 143
                },
                description: 'Nursing assistant providing nursing support and basic care tasks under nursing supervision.',
                keywords: [
                    'nursing',
                    'assistant',
                    'aide'
                ]
            },
            // Allied health and other therapeutic services (Department lists each profession)
            {
                id: 'allied_occupational',
                name: 'Occupational Therapist',
                unit: 'Hour',
                medianPrice: 200,
                range: {
                    lower: 174,
                    upper: 220
                },
                description: 'Occupational therapy to improve daily living skills, mobility aids, home safety assessments, and independence. Part of allied health and other therapeutic services.',
                keywords: [
                    'occupational therapy',
                    'OT',
                    'daily living',
                    'mobility aids',
                    'safety'
                ]
            },
            {
                id: 'allied_physio',
                name: 'Physiotherapist',
                unit: 'Hour',
                medianPrice: 185,
                range: {
                    lower: 160,
                    upper: 210
                },
                description: 'Physiotherapy to improve mobility, strength, balance, and manage pain through exercise and manual therapy. Part of allied health and other therapeutic services.',
                keywords: [
                    'physio',
                    'physiotherapy',
                    'mobility',
                    'exercise',
                    'pain',
                    'strength',
                    'balance'
                ]
            },
            {
                id: 'allied_dietitian',
                name: 'Dietitian or Nutritionist',
                unit: 'Hour',
                medianPrice: 200,
                range: {
                    lower: 165,
                    upper: 219
                },
                description: 'Nutritional assessment and dietary advice to support health and manage medical conditions. Part of allied health and other therapeutic services.',
                keywords: [
                    'dietitian',
                    'nutrition',
                    'diet',
                    'eating',
                    'food advice'
                ]
            },
            {
                id: 'allied_podiatrist',
                name: 'Podiatrist',
                unit: 'Hour',
                medianPrice: 180,
                range: {
                    lower: 153,
                    upper: 208
                },
                description: 'Foot care and podiatry including nail cutting, wound care, mobility assessments, and foot health. Part of allied health and other therapeutic services.',
                keywords: [
                    'podiatrist',
                    'feet',
                    'foot care',
                    'nail cutting',
                    'wound'
                ]
            },
            {
                id: 'allied_speech',
                name: 'Speech Pathologist',
                unit: 'Hour',
                medianPrice: 208,
                range: {
                    lower: 187,
                    upper: 236
                },
                description: 'Speech and communication therapy, swallowing assessments, and support for communication difficulties. Part of allied health and other therapeutic services.',
                keywords: [
                    'speech',
                    'communication',
                    'swallowing',
                    'speech therapy'
                ]
            },
            {
                id: 'allied_psychologist',
                name: 'Psychologist',
                unit: 'Hour',
                medianPrice: 228,
                range: {
                    lower: 210,
                    upper: 250
                },
                description: 'Psychological support, counselling, and mental health services. Part of allied health and other therapeutic services.',
                keywords: [
                    'psychologist',
                    'counselling',
                    'mental health',
                    'support'
                ]
            },
            {
                id: 'allied_social_worker',
                name: 'Social Worker',
                unit: 'Hour',
                medianPrice: 200,
                range: {
                    lower: 163,
                    upper: 238
                },
                description: 'Social work support including counselling, advocacy, resource linking, and emotional support. Part of allied health and other therapeutic services.',
                keywords: [
                    'social worker',
                    'counselling',
                    'support',
                    'advocacy'
                ]
            },
            {
                id: 'allied_exercise',
                name: 'Exercise Physiologist',
                unit: 'Hour',
                medianPrice: 190,
                range: {
                    lower: 165,
                    upper: 219
                },
                description: 'Exercise programs to manage chronic conditions, improve fitness, and support rehabilitation. Part of allied health and other therapeutic services.',
                keywords: [
                    'exercise',
                    'fitness',
                    'rehabilitation',
                    'physiology'
                ]
            },
            {
                id: 'allied_assistant',
                name: 'Allied Health Therapy Assistant',
                unit: 'Hour',
                medianPrice: 122,
                range: {
                    lower: 105,
                    upper: 167
                },
                description: 'Assistant providing support with therapy programs under the direction of allied health professionals. Part of allied health and other therapeutic services.',
                keywords: [
                    'therapy',
                    'assistant',
                    'aide'
                ]
            },
            {
                id: 'allied_counsellor',
                name: 'Counsellor or Psychotherapist',
                unit: 'Hour',
                medianPrice: 180,
                range: {
                    lower: 150,
                    upper: 220
                },
                description: 'Counselling or psychotherapy to support mental and emotional wellbeing. Part of allied health and other therapeutic services.',
                keywords: [
                    'counsellor',
                    'psychotherapist',
                    'counselling',
                    'therapy'
                ]
            },
            {
                id: 'allied_music_therapist',
                name: 'Music Therapist',
                unit: 'Hour',
                medianPrice: 165,
                range: {
                    lower: 140,
                    upper: 195
                },
                description: 'Music therapy to support physical, functional and cognitive abilities. Part of allied health and other therapeutic services.',
                keywords: [
                    'music',
                    'therapy',
                    'music therapy'
                ]
            },
            {
                id: 'allied_atsi_practitioner',
                name: 'Aboriginal and Torres Strait Islander Health Practitioner',
                unit: 'Hour',
                medianPrice: 175,
                range: {
                    lower: 150,
                    upper: 205
                },
                description: 'Aboriginal and Torres Strait Islander health practitioner delivering culturally safe allied health and therapeutic services. Part of allied health and other therapeutic services.',
                keywords: [
                    'ATSI',
                    'Aboriginal',
                    'Torres Strait Islander',
                    'health practitioner'
                ]
            },
            {
                id: 'allied_atsi_worker',
                name: 'Aboriginal and Torres Strait Islander Health Worker',
                unit: 'Hour',
                medianPrice: 155,
                range: {
                    lower: 130,
                    upper: 185
                },
                description: 'Aboriginal and Torres Strait Islander health worker supporting delivery of allied health and therapeutic services. Part of allied health and other therapeutic services.',
                keywords: [
                    'ATSI',
                    'Aboriginal',
                    'Torres Strait Islander',
                    'health worker'
                ]
            },
            // Nutrition (separate service type in the official list)
            {
                id: 'nutrition',
                name: 'Nutrition (Prescribed)',
                unit: 'Item',
                medianPrice: 45,
                range: {
                    lower: 25,
                    upper: 80
                },
                description: 'Prescribed supplementary dietary products (enteral and oral) and aids required for conditions related to functional decline or impairment. Separate from allied health dietitian services.',
                keywords: [
                    'nutrition',
                    'supplementary',
                    'dietary',
                    'enteral',
                    'prescribed'
                ]
            },
            // Care management
            {
                id: 'care_management',
                name: 'Care Management',
                unit: 'Hour',
                medianPrice: 120,
                range: {
                    lower: 80,
                    upper: 150
                },
                description: 'Home support care management: care planning, service coordination, monitoring and review, advocacy, and support and education to ensure aged care services contribute to overall wellbeing.',
                keywords: [
                    'care management',
                    'coordination',
                    'planning',
                    'case management'
                ]
            },
            // Restorative care management
            {
                id: 'restorative_care_management',
                name: 'Restorative Care Management',
                unit: 'Hour',
                medianPrice: 130,
                range: {
                    lower: 90,
                    upper: 165
                },
                description: 'Home support restorative care management. Specialist coordination for older people on the time-limited Restorative Care Pathway, delivered by clinically qualified care partners.',
                keywords: [
                    'restorative',
                    'care management',
                    'pathway',
                    'coordination'
                ]
            }
        ]
    },
    independence: {
        label: 'Independence Services',
        contribution: 0,
        services: [
            {
                id: 'social_support_community_engagement',
                name: 'Social Support and Community Engagement',
                unit: 'Hour',
                medianPrice: 99,
                range: {
                    lower: 82,
                    upper: 110
                },
                description: 'Group or individual social support, accompanied activities, cultural support, digital education and support, and assistance to maintain personal affairs. Supports social connection and participation in community life.',
                keywords: [
                    'companionship',
                    'social',
                    'outings',
                    'community',
                    'activities',
                    'cultural',
                    'digital'
                ]
            },
            // Therapeutic services for independent living (Department lists: Acupuncturist, Chiropractor, Diversional therapist, Remedial masseuse, Art therapist, Osteopath)
            {
                id: 'therapeutic_independent_living',
                name: 'Therapeutic Services for Independent Living',
                unit: 'Hour',
                medianPrice: 165,
                range: {
                    lower: 140,
                    upper: 220
                },
                description: 'Evidence-based support from accredited practitioners (e.g. acupuncturist, chiropractor, diversional therapist, art therapist, osteopath) to manage social, mental and physical wellbeing and support independence at home.',
                keywords: [
                    'therapeutic',
                    'independent living',
                    'acupuncture',
                    'chiropractor',
                    'diversional',
                    'osteopath'
                ]
            },
            {
                id: 'remedial_massage',
                name: 'Remedial Massage',
                unit: 'Hour',
                medianPrice: 150,
                range: {
                    lower: 134,
                    upper: 206
                },
                description: 'Remedial massage by an accredited therapist, where included in a prescribed allied health treatment plan to address functional decline. Listed under Therapeutic services for independent living in the official list.',
                keywords: [
                    'massage',
                    'remedial',
                    'pain',
                    'relief',
                    'mobility'
                ]
            },
            {
                id: 'respite',
                name: 'Respite Care',
                unit: 'Hour',
                medianPrice: 99,
                range: {
                    lower: 82,
                    upper: 110
                },
                description: 'Supervision and assistance by someone other than the usual informal carer, on an individual or group basis, in the home or community.',
                keywords: [
                    'respite',
                    'break',
                    'carer',
                    'support'
                ]
            },
            {
                id: 'transport',
                name: 'Transport',
                unit: 'Trip',
                medianPrice: 85,
                range: {
                    lower: 70,
                    upper: 112
                },
                description: 'Direct transport (driver and vehicle) or indirect transport (e.g. taxi or rideshare vouchers) to connect you with usual activities.',
                keywords: [
                    'transport',
                    'ride',
                    'car',
                    'taxi',
                    'appointments',
                    'shopping'
                ]
            },
            {
                id: 'assistive_technology_home_modifications',
                name: 'Assistive Technology and Home Modifications',
                unit: 'Item',
                medianPrice: 0,
                range: {
                    lower: 0,
                    upper: 0
                },
                description: 'Assistive technology and home modifications on the approved list, including wrap-around services, maintenance and repair. Funded via the AT-HM scheme; pricing is item-specific.',
                keywords: [
                    'assistive technology',
                    'home modifications',
                    'AT-HM',
                    'equipment',
                    'modifications'
                ]
            }
        ]
    },
    everyday: {
        label: 'Everyday Living Services',
        contribution: 0,
        services: [
            {
                id: 'domestic_assistance',
                name: 'Domestic Assistance',
                unit: 'Hour',
                medianPrice: 97,
                range: {
                    lower: 82,
                    upper: 110
                },
                description: 'General house cleaning, laundry services and shopping assistance. Includes essential light cleaning (mopping, vacuuming, washing dishes), laundering and ironing, and accompanied or unaccompanied shopping.',
                keywords: [
                    'cleaning',
                    'vacuuming',
                    'laundry',
                    'housekeeping',
                    'shopping',
                    'domestic'
                ]
            },
            {
                id: 'home_maintenance',
                name: 'Home Maintenance and Repairs',
                unit: 'Hour',
                medianPrice: 103,
                range: {
                    lower: 95,
                    upper: 109
                },
                description: 'Essential light gardening (e.g. lawn mowing, pruning, yard clearance for safe access) and essential minor repairs and maintenance for safety (e.g. cleaning gutters, replacing lightbulbs, repairing door handles).',
                keywords: [
                    'maintenance',
                    'repairs',
                    'gardening',
                    'lawn',
                    'mowing',
                    'gutter',
                    'home'
                ]
            },
            {
                id: 'meal_preparation',
                name: 'Meal Preparation',
                unit: 'Hour',
                medianPrice: 97,
                range: {
                    lower: 82,
                    upper: 110
                },
                description: 'Support to prepare meals in the home.',
                keywords: [
                    'cooking',
                    'meal prep',
                    'food',
                    'preparation',
                    'kitchen'
                ]
            },
            {
                id: 'meal_delivery',
                name: 'Meal Delivery',
                unit: 'Meal',
                medianPrice: 85,
                range: {
                    lower: 70,
                    upper: 120
                },
                description: 'Pre-prepared meals delivered to your home.',
                keywords: [
                    'meals',
                    'delivery',
                    'food delivery',
                    'prepared meals'
                ]
            }
        ]
    }
};



const $08809b7a4fc47e27$export$436317f0a4e6f4d7 = (quantity, freqType)=>{
    if (!quantity || quantity <= 0) return 0;
    switch(freqType){
        case 'daily':
            return quantity * 365 / 12; // 365 days a year
        case 'weekly':
            return quantity * 52 / 12; // 52 weeks a year (was 4 a month, 8% short)
        case 'monthly':
            return quantity;
        default:
            return quantity;
    }
};
const $08809b7a4fc47e27$export$4ddb2093d9f00d95 = (factFind)=>{
    const of = (acat)=>{
        const a = acat;
        if (a?.status !== 'yes' || !a?.homeCareLevel) return null;
        const b = (0, $c220d08b55e5dd64$export$36fcde3ddb6f0194)(a.homeCareLevel);
        return b > 0 ? b : null;
    };
    return {
        client: of(factFind?.careNeeds?.clientAcat),
        partner: of(factFind?.careNeeds?.partnerAcat)
    };
};
const $08809b7a4fc47e27$export$8fa8d1fdeea775a9 = (selectedServices, contributionRates = {}, isPartnered = false, budgets = {})=>{
    if (!selectedServices || !selectedServices.client && !selectedServices.partner) return {
        totalAnnual: 0,
        clinical: 0,
        independence: 0,
        everyday: 0,
        hasServicePlan: false,
        privateExcess: 0,
        contribution: {
            clinical: 0,
            independence: 0,
            everyday: 0,
            funded: 0,
            total: 0
        }
    };
    let totalClinical = 0;
    let totalIndependence = 0;
    let totalEveryday = 0;
    let fundedIndependence = 0;
    let fundedEveryday = 0;
    let privateExcess = 0;
    // Calculate for both client and partner if partnered
    const personsToCalculate = isPartnered ? [
        'client',
        'partner'
    ] : [
        'client'
    ];
    personsToCalculate.forEach((person)=>{
        const personServices = selectedServices[person] || {};
        let clinical = 0;
        let independence = 0;
        let everyday = 0;
        Object.entries(personServices).forEach(([serviceId, data])=>{
            if (!data || !data.quantity || Number(data.quantity) <= 0) return;
            const monthlyQuantity = $08809b7a4fc47e27$export$436317f0a4e6f4d7(Number(data.quantity), data.frequency || 'monthly');
            // Find service in each category
            Object.values((0, $25e9acc02c907060$export$a3b71735b810a98c)).forEach((category)=>{
                const service = category.services.find((s)=>s.id === serviceId);
                if (service) {
                    const cost = service.medianPrice * monthlyQuantity * 12; // Convert to annual
                    if (category.label === 'Clinical Care') clinical += cost;
                    else if (category.label === 'Independence Services') independence += cost;
                    else if (category.label === 'Everyday Living Services') everyday += cost;
                }
            });
        });
        const personTotal = clinical + independence + everyday;
        const budget = Number(budgets?.[person]);
        const fundedShare = Number.isFinite(budget) && budget > 0 && personTotal > budget ? budget / personTotal : 1;
        totalClinical += clinical;
        totalIndependence += independence;
        totalEveryday += everyday;
        fundedIndependence += independence * fundedShare;
        fundedEveryday += everyday * fundedShare;
        privateExcess += personTotal * (1 - fundedShare);
    });
    const total = totalClinical + totalIndependence + totalEveryday;
    // Clinical care carries no contribution.
    const independenceContribution = fundedIndependence * (contributionRates.independence || 0);
    const everydayContribution = fundedEveryday * (contributionRates.everydayLiving || 0);
    const uncappedContribution = independenceContribution + everydayContribution;
    // The no-worse-off fortnightly cap, carried on the rates (supportAtHomeContributionEngine): a year's
    // contributions never exceed the previous income-tested care fee. Scaled across the categories.
    // `null`/absent means no ceiling — Number(null) is 0, which is not "no cap", so test for presence first.
    // It caps the CONTRIBUTION only: services bought privately above the budget are not contributions.
    const annualCap = contributionRates.annualCap == null ? null : Number(contributionRates.annualCap);
    const capScale = annualCap != null && Number.isFinite(annualCap) && annualCap >= 0 && uncappedContribution > annualCap ? annualCap / uncappedContribution : 1;
    const fundedContribution = uncappedContribution * capScale;
    return {
        totalAnnual: total,
        clinical: totalClinical,
        independence: totalIndependence,
        everyday: totalEveryday,
        hasServicePlan: total > 0,
        privateExcess: privateExcess,
        contribution: {
            clinical: 0,
            independence: independenceContribution * capScale,
            everyday: everydayContribution * capScale,
            funded: fundedContribution,
            total: fundedContribution + privateExcess
        }
    };
};
const $08809b7a4fc47e27$var$CURRENT_PLAN_KEY = 'careCompanionCurrentServicePlan';
const $08809b7a4fc47e27$var$CURRENT_PLAN_META_KEY = 'careCompanionCurrentServicePlanMeta';
/**
 * Set when the reader CHOSE to model with no service plan (owner-caught 2026-08-27, and again
 * 2026-09-24). Clearing the current plan alone was not a choice the resolution could see: with the
 * current plan gone it fell straight through to the newest saved plan, so "No service plan" snapped
 * back to "Service Plan A" the moment it was picked — and it could only ever be picked when a saved
 * plan existed, which is exactly when the fallback fires. The flag outranks every fallback until a
 * plan is loaded or built again.
 */ const $08809b7a4fc47e27$var$NO_PLAN_KEY = 'careCompanionNoServicePlan';
/** A {client, partner} bag — as opposed to a flat map of services. */ const $08809b7a4fc47e27$var$looksLikeCoupleBag = (v)=>Boolean(v) && typeof v === 'object' && ('client' in v || 'partner' in v);
const $08809b7a4fc47e27$export$1b6e63322feb93af = (services)=>{
    if (!services || typeof services !== 'object') return {
        client: {},
        partner: {}
    };
    const bag = services;
    if (bag.client || bag.partner) {
        if ($08809b7a4fc47e27$var$looksLikeCoupleBag(bag.client)) return {
            client: bag.client.client || {},
            partner: bag.client.partner || bag.partner || {}
        };
        return {
            client: bag.client || {},
            partner: bag.partner || {}
        };
    }
    return {
        client: services,
        partner: {}
    };
};
const $08809b7a4fc47e27$export$7b53d3d51c369de2 = ()=>{
    try {
        if (typeof window === 'undefined') return [];
        const stored = sessionStorage.getItem('careCompanionStrategies');
        if (!stored) return [];
        const parsed = JSON.parse(stored);
        if (!Array.isArray(parsed)) return [];
        return parsed.filter((s)=>s?.type === 'home_care' && s?.inputs?.services).sort((a, b)=>new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime()).map((s)=>({
                id: String(s.id ?? ''),
                name: String(s.name || 'saved plan'),
                plan: $08809b7a4fc47e27$export$1b6e63322feb93af(s.inputs?.services)
            }));
    } catch  {
        return [];
    }
};
const $08809b7a4fc47e27$export$5a09e0563ccbb36b = (plan)=>[
        'client',
        'partner'
    ].some((side)=>Object.values(plan?.[side] || {}).some((d)=>Number(d?.quantity) > 0));
const $08809b7a4fc47e27$export$bbfb111507c2e420 = (plans)=>plans.filter((p)=>$08809b7a4fc47e27$export$5a09e0563ccbb36b(p.plan));
const $08809b7a4fc47e27$export$90df44a7e3e2c0ee = (input)=>({
        id: `strategy-${Date.now()}`,
        name: input.name.trim(),
        type: 'home_care',
        inputs: {
            services: {
                client: input.services.client || {},
                partner: input.services.partner || {}
            }
        },
        outputs: input.outputs,
        createdAt: new Date().toISOString()
    });
const $08809b7a4fc47e27$export$1016adb776409d6 = (plan, basedOnName)=>{
    if (typeof window === 'undefined') return;
    try {
        sessionStorage.setItem($08809b7a4fc47e27$var$CURRENT_PLAN_KEY, JSON.stringify(plan));
        sessionStorage.removeItem($08809b7a4fc47e27$var$NO_PLAN_KEY);
        if (basedOnName) sessionStorage.setItem($08809b7a4fc47e27$var$CURRENT_PLAN_META_KEY, JSON.stringify({
            basedOnName: basedOnName
        }));
        else sessionStorage.removeItem($08809b7a4fc47e27$var$CURRENT_PLAN_META_KEY);
    } catch  {}
};
const $08809b7a4fc47e27$export$fbf5e96f5cc7576c = ()=>{
    if (typeof window === 'undefined') return;
    try {
        sessionStorage.removeItem($08809b7a4fc47e27$var$CURRENT_PLAN_KEY);
        sessionStorage.removeItem($08809b7a4fc47e27$var$CURRENT_PLAN_META_KEY);
        // The choice itself, so the saved-plan and profile fallbacks do not quietly undo it.
        sessionStorage.setItem($08809b7a4fc47e27$var$NO_PLAN_KEY, '1');
    } catch  {}
};
const $08809b7a4fc47e27$export$e7fb1dd0076c542d = ()=>{
    if (typeof window === 'undefined') return;
    try {
        sessionStorage.removeItem($08809b7a4fc47e27$var$NO_PLAN_KEY);
    } catch  {}
};
const $08809b7a4fc47e27$export$457ec44eb7e93e92 = ()=>{
    if (typeof window === 'undefined') return;
    try {
        sessionStorage.removeItem($08809b7a4fc47e27$var$CURRENT_PLAN_META_KEY);
    } catch  {}
};
const $08809b7a4fc47e27$export$d30ccc0e9b37d265 = ()=>{
    const none = {
        plan: {
            client: {},
            partner: {}
        },
        source: {
            kind: 'none'
        }
    };
    try {
        if (typeof window === 'undefined') return none;
        const currentPlan = sessionStorage.getItem($08809b7a4fc47e27$var$CURRENT_PLAN_KEY);
        if (currentPlan) {
            const parsed = JSON.parse(currentPlan);
            if (parsed && (parsed.client || parsed.partner)) {
                let basedOnName;
                try {
                    const meta = sessionStorage.getItem($08809b7a4fc47e27$var$CURRENT_PLAN_META_KEY);
                    basedOnName = meta ? String(JSON.parse(meta)?.basedOnName || '') || undefined : undefined;
                } catch  {
                    basedOnName = undefined;
                }
                return {
                    plan: parsed,
                    source: {
                        kind: 'current',
                        basedOnName: basedOnName
                    }
                };
            }
        }
        // Chosen none: said so, and nothing below is consulted.
        if (sessionStorage.getItem($08809b7a4fc47e27$var$NO_PLAN_KEY)) return {
            ...none,
            source: {
                kind: 'none',
                chosen: true
            }
        };
        const stored = sessionStorage.getItem('careCompanionStrategies');
        if (stored) {
            const parsed = JSON.parse(stored);
            const servicePlans = Array.isArray(parsed) ? parsed.filter((strategy)=>strategy?.type === 'home_care' && strategy?.inputs?.services) : [];
            if (servicePlans.length > 0) {
                const mostRecent = servicePlans.sort((a, b)=>new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime())[0];
                if (mostRecent.inputs?.services) {
                    const source = {
                        kind: 'saved',
                        name: String(mostRecent.name || 'saved plan'),
                        savedCount: servicePlans.length
                    };
                    if (mostRecent.inputs.services.client || mostRecent.inputs.services.partner) return {
                        plan: mostRecent.inputs.services,
                        source: source
                    };
                    return {
                        plan: {
                            client: mostRecent.inputs.services,
                            partner: {}
                        },
                        source: source
                    };
                }
            }
        }
        const restorePlan = sessionStorage.getItem('careCompanionRestoreServicePlan');
        if (restorePlan) {
            const strategy = JSON.parse(restorePlan);
            if (strategy?.inputs?.services) {
                const source = {
                    kind: 'restore',
                    name: String(strategy.name || 'reopened plan')
                };
                if (strategy.inputs.services.client || strategy.inputs.services.partner) return {
                    plan: strategy.inputs.services,
                    source: source
                };
                return {
                    plan: {
                        client: strategy.inputs.services,
                        partner: {}
                    },
                    source: source
                };
            }
        }
    } catch  {
        return none;
    }
    return none;
};
const $08809b7a4fc47e27$export$ccf1a1f8e00c427e = ()=>{
    try {
        if (typeof window === 'undefined') return {
            client: {},
            partner: {}
        };
        // First, try to get current service plan (most up-to-date)
        const currentPlan = sessionStorage.getItem('careCompanionCurrentServicePlan');
        if (currentPlan) {
            const parsed = JSON.parse(currentPlan);
            if (parsed && (parsed.client || parsed.partner)) return parsed;
        }
        // The reader chose "no service plan": that is the answer (see getServicePlanWithSource).
        if (sessionStorage.getItem($08809b7a4fc47e27$var$NO_PLAN_KEY)) return {
            client: {},
            partner: {}
        };
        // Try to get from saved strategies (most recent)
        const stored = sessionStorage.getItem('careCompanionStrategies');
        if (stored) {
            const parsed = JSON.parse(stored);
            const servicePlans = Array.isArray(parsed) ? parsed.filter((strategy)=>strategy?.type === 'home_care' && strategy?.inputs?.services) : [];
            // Get the most recent service plan
            if (servicePlans.length > 0) {
                const mostRecent = servicePlans.sort((a, b)=>new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime())[0];
                if (mostRecent.inputs?.services) {
                    // Handle both single and couple formats
                    if (mostRecent.inputs.services.client || mostRecent.inputs.services.partner) return mostRecent.inputs.services;
                    else return {
                        client: mostRecent.inputs.services,
                        partner: {}
                    };
                }
            }
        }
        // Fallback: try to get from restore service plan
        const restorePlan = sessionStorage.getItem('careCompanionRestoreServicePlan');
        if (restorePlan) {
            const strategy = JSON.parse(restorePlan);
            if (strategy?.inputs?.services) {
                if (strategy.inputs.services.client || strategy.inputs.services.partner) return strategy.inputs.services;
                else return {
                    client: strategy.inputs.services,
                    partner: {}
                };
            }
        }
    } catch (error) {
        console.error('Error getting service plan from storage:', error);
    }
    return {
        client: {},
        partner: {}
    };
};




/**
 * Shared property strategy allocator UI for Support at Home.
 * Used by StrategiesSection and ServiceBuilderSection.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dbde4c3396582d11$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
];
const $dbde4c3396582d11$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("plus", $dbde4c3396582d11$export$3efd853dbb351e94);










// Simple InfoIcon Component
const $c310d81356fecc7e$var$InfoIcon = ({ text: text })=>{
    const [show, setShow] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "relative inline-block ml-1 align-middle",
        onMouseEnter: ()=>setShow(true),
        onMouseLeave: ()=>setShow(false),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c00fae44777e2393$export$2e2bcd8739ae039), {
                size: 16,
                className: "text-gray-500 cursor-pointer"
            }),
            show && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute left-0 bottom-full mb-2 p-3 bg-gray-800 text-white text-xs rounded-lg shadow-lg z-50 whitespace-pre-line",
                style: {
                    width: '320px'
                },
                children: text
            })
        ]
    });
};
function $c310d81356fecc7e$export$921ecbe2f83772b9(factFind, details) {
    const homeValue = parseFloat(String(factFind.home?.value)) || 0;
    const salePrice = parseFloat(String(details?.salePrice ?? homeValue)) || homeValue;
    const sellingCosts = parseFloat(String(details?.sellingCosts)) || 0;
    const netProceeds = Math.max(0, salePrice - sellingCosts);
    const baseKeys = [
        'newHomePurchasePrice',
        'downsizerContribution',
        'partnerDownsizerContribution',
        'giftingAmount',
        'debtRepayment'
    ];
    const baseTotal = baseKeys.reduce((sum, key)=>sum + (parseFloat(String(details?.[key])) || 0), 0);
    const assetTotal = (details?.addedAssets || []).reduce((sum, asset)=>sum + (parseFloat(String(asset.value)) || 0), 0);
    return Math.max(0, netProceeds - (baseTotal + assetTotal));
}
const $c310d81356fecc7e$var$SupportAllocationInput = ({ icon: Icon, label: label, field: field, value: value, max: max, onChange: onChange, tooltip: tooltip, disabled: disabled })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: "block text-sm font-medium text-gray-700 flex items-center gap-2",
                children: [
                    Icon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                        size: 16,
                        className: "text-gray-600"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: label
                    }),
                    tooltip && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c310d81356fecc7e$var$InfoIcon, {
                        text: tooltip
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "range",
                        min: "0",
                        max: Math.max(0, Math.floor(Number(max) || 0)),
                        step: "1000",
                        value: value || 0,
                        onChange: (e)=>onChange(field, e.target.value),
                        className: "flex-1 h-2 bg-gray-200 rounded-full appearance-none accent-blue-600 disabled:opacity-50",
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "w-32",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                            value: value === '' ? '' : value,
                            onChange: (v)=>onChange(field, v),
                            placeholder: "0",
                            disabled: disabled,
                            className: ""
                        })
                    })
                ]
            })
        ]
    });
function $c310d81356fecc7e$export$8098031801c7a587({ factFind: factFind, details: details, setDetails: setDetails }) {
    const [showAssetForm, setShowAssetForm] = (0, $acw62.useState)(false);
    const [newAsset, setNewAsset] = (0, $acw62.useState)(()=>({
            type: '',
            description: '',
            value: '',
            incomeRate: '',
            growthRate: '',
            ownership: factFind?.adviceFor === 'couple' ? 'joint' : 'client',
            frankingCredit: ''
        }));
    const formatCurrencyLocal = (value)=>new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(Number(value) || 0);
    const homeValue = parseFloat(String(factFind.home?.value)) || 0;
    const salePrice = parseFloat(String(details.salePrice ?? homeValue)) || homeValue;
    const sellingCosts = parseFloat(String(details.sellingCosts)) || 0;
    const netProceeds = Math.max(0, salePrice - sellingCosts);
    const addedAssets = Array.isArray(details.addedAssets) ? details.addedAssets : [];
    const sumAllocations = (input)=>{
        const baseKeys = [
            'newHomePurchasePrice',
            'downsizerContribution',
            'partnerDownsizerContribution',
            'giftingAmount',
            'debtRepayment'
        ];
        const baseTotal = baseKeys.reduce((sum, key)=>sum + (parseFloat(String(input?.[key])) || 0), 0);
        const assetTotal = (input?.addedAssets || []).reduce((sum, asset)=>sum + (parseFloat(String(asset.value)) || 0), 0);
        return baseTotal + assetTotal;
    };
    const totalAllocated = sumAllocations(details);
    const unallocatedProceeds = netProceeds - totalAllocated;
    const liabilityOptions = (0, $acw62.useMemo)(()=>{
        if (!factFind?.liabilities) return [];
        const options = [];
        Object.entries(factFind.liabilities).forEach(([type, items])=>{
            if (!Array.isArray(items)) return;
            items.forEach((item)=>{
                const balance = Math.max(0, item.balance || item.value || 0);
                if (balance > 0) options.push({
                    key: `${type}:${item.id}`,
                    label: `${item.description || 'Debt'} (${formatCurrencyLocal(balance)})`,
                    balance: balance
                });
            });
        });
        return options;
    }, [
        factFind?.liabilities
    ]);
    (0, $acw62.useEffect)(()=>{
        if (liabilityOptions.length > 0 && !details.selectedDebtKey) setDetails((prev)=>({
                ...prev,
                selectedDebtKey: liabilityOptions[0].key
            }));
    }, [
        liabilityOptions,
        details.selectedDebtKey,
        setDetails
    ]);
    const selectedDebt = liabilityOptions.find((option)=>option.key === details.selectedDebtKey) || null;
    const handleAllocationChange = (field, rawValue)=>{
        const numeric = Math.max(0, parseFloat(String(rawValue)) || 0);
        const detailsWithoutField = {
            ...details,
            [field]: 0
        };
        const otherAllocated = sumAllocations(detailsWithoutField);
        const available = Math.max(0, netProceeds - otherAllocated);
        let capped = Math.min(numeric, available);
        if (field === 'downsizerContribution' || field === 'partnerDownsizerContribution') capped = Math.min(capped, (0, $a1c4193edeff7c3c$export$42edd27decf8c272));
        if (field === 'debtRepayment' && selectedDebt) capped = Math.min(capped, selectedDebt.balance);
        setDetails((prev)=>({
                ...prev,
                [field]: Number.isNaN(capped) ? 0 : capped
            }));
    };
    const handleBasicChange = (field, value)=>{
        setDetails((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    const resetAssetForm = ()=>{
        setNewAsset({
            type: '',
            description: '',
            value: '',
            incomeRate: '',
            growthRate: '',
            ownership: factFind?.adviceFor === 'couple' ? 'joint' : 'client',
            frankingCredit: ''
        });
    };
    const nonAssetAllocation = [
        'newHomePurchasePrice',
        'downsizerContribution',
        'partnerDownsizerContribution',
        'giftingAmount',
        'debtRepayment'
    ].reduce((sum, key)=>sum + (parseFloat(String(details[key])) || 0), 0);
    const existingAssetTotal = addedAssets.reduce((sum, asset)=>sum + (parseFloat(String(asset.value)) || 0), 0);
    const availableForNewAsset = Math.max(0, netProceeds - nonAssetAllocation - existingAssetTotal);
    const handleAddAsset = ()=>{
        if (!newAsset.type) {
            (0, $8e1e84c918e07c84$export$5e14cdade93d6f7b)('Please select an asset type.');
            return;
        }
        const assetValue = Math.max(0, parseFloat(String(newAsset.value)) || 0);
        if (assetValue <= 0) {
            (0, $8e1e84c918e07c84$export$5e14cdade93d6f7b)('Please enter a positive amount for the asset.');
            return;
        }
        if (assetValue > availableForNewAsset) {
            (0, $8e1e84c918e07c84$export$5e14cdade93d6f7b)('The amount exceeds the available proceeds.');
            return;
        }
        const config = (0, $a1c4193edeff7c3c$export$1d4431839363ff69).find((opt)=>opt.id === newAsset.type);
        const defaults = config?.defaults || {
            incomeRate: '',
            growthRate: '',
            frankingCredit: ''
        };
        const assetId = `downsize-asset-${Date.now()}`;
        setDetails((prev)=>({
                ...prev,
                addedAssets: [
                    ...prev.addedAssets || [],
                    {
                        id: assetId,
                        type: newAsset.type,
                        description: newAsset.description || config?.label || 'Allocated investment',
                        value: assetValue,
                        ownership: newAsset.ownership || (factFind?.adviceFor === 'couple' ? 'joint' : 'client'),
                        incomeRate: newAsset.incomeRate || defaults.incomeRate || '',
                        growthRate: newAsset.growthRate || defaults.growthRate || '',
                        frankingCredit: newAsset.frankingCredit || defaults.frankingCredit || ''
                    }
                ]
            }));
        resetAssetForm();
        setShowAssetForm(false);
    };
    const removeAsset = (id)=>{
        setDetails((prev)=>({
                ...prev,
                addedAssets: (prev.addedAssets || []).filter((asset)=>asset.id !== id)
            }));
    };
    const ownershipOptions = factFind?.adviceFor === 'couple' ? [
        {
            value: 'joint',
            label: 'Joint'
        },
        {
            value: 'client',
            label: factFind?.client?.firstName || 'Client'
        },
        {
            value: 'partner',
            label: factFind?.partner?.firstName || 'Partner'
        }
    ] : [
        {
            value: 'client',
            label: factFind?.client?.firstName || 'Client'
        }
    ];
    const clientAge = (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client?.dob);
    const isDownsizerEligible = (clientAge || 0) >= 55;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-4 p-4 bg-gray-50 rounded-lg border space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                        className: "font-semibold text-gray-900 text-base mb-2",
                        children: "Transaction assumptions"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid gap-4 md:grid-cols-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                        label: "Sale price",
                                        value: details.salePrice === '' ? '' : details.salePrice ?? '',
                                        onChange: (v)=>handleBasicChange('salePrice', v),
                                        className: ""
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-xs text-gray-500 mt-1",
                                        children: [
                                            "Current home value is ",
                                            formatCurrencyLocal(homeValue),
                                            "."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                        label: "Selling costs",
                                        value: details.sellingCosts === '' ? '' : details.sellingCosts ?? '',
                                        onChange: (v)=>handleBasicChange('sellingCosts', v),
                                        className: ""
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-xs text-gray-500 mt-1",
                                        children: "Agent fees, legal costs, staging, etc."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "block text-sm font-medium text-gray-700 mb-1",
                                        children: "Net proceeds"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "px-3 py-2 border border-blue-200 bg-white rounded-lg font-semibold text-blue-700",
                                        children: formatCurrencyLocal(netProceeds)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                        className: "font-semibold text-gray-900 text-base mb-2",
                        children: "Allocate the proceeds"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-2 p-3 bg-white border-l-4 border-blue-400 rounded-r-lg text-sm flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    className: "text-blue-700",
                                    children: "Unallocated Proceeds:"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: `font-bold text-lg ${unallocatedProceeds < 0 ? 'text-red-600' : 'text-green-600'}`,
                                children: formatCurrencyLocal(unallocatedProceeds)
                            })
                        ]
                    }),
                    unallocatedProceeds > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 rounded-lg border border-slate-200/70 border-l-4 border-l-amber-500 bg-white px-3 py-2 text-xs leading-relaxed text-slate-700 shadow-sm",
                        children: [
                            "Until it's reallocated, this ",
                            formatCurrencyLocal(unallocatedProceeds),
                            " sits in the bank \u2014 where the home was exempt, bank money is ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold",
                                children: "counted in the assets test and deemed to earn income"
                            }),
                            ". That is what moves the Age Pension and the contribution rates on the right",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                term: "(the full chain)",
                                children: `The home is exempt from the means tests; money in the bank is not. The sale converts exempt value into counted value: the unallocated ${formatCurrencyLocal(unallocatedProceeds)} is added to assessable assets, and deeming assumes it earns income for the income test. If that pushes past the pension cut-off, the Age Pension stops entirely \u{2014} and with no pension, the household is assessed as fully self-funded, which carries the highest Support at Home contribution rates. Allocating the money below \u{2014} a new home, downsizer super contributions, gifts within limits \u{2014} moves it back out of the counted pile.`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-4 space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c310d81356fecc7e$var$SupportAllocationInput, {
                                icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
                                label: "Purchase new home",
                                field: "newHomePurchasePrice",
                                value: details.newHomePurchasePrice || 0,
                                max: netProceeds,
                                onChange: handleAllocationChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c310d81356fecc7e$var$SupportAllocationInput, {
                                icon: (0, $33b542e8915cec79$export$2e2bcd8739ae039),
                                label: "Downsizer contribution",
                                field: "downsizerContribution",
                                value: details.downsizerContribution || 0,
                                max: Math.min((0, $a1c4193edeff7c3c$export$42edd27decf8c272), netProceeds),
                                onChange: handleAllocationChange,
                                tooltip: (0, $8849d61d9af733fb$export$229126c85a7ec674).downsizerToSuper(isDownsizerEligible),
                                disabled: !isDownsizerEligible
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setDetails((prev)=>({
                                                    ...prev,
                                                    showDownsizerInfo: !prev.showDownsizerInfo
                                                })),
                                        className: "text-xs text-blue-600 underline",
                                        children: details.showDownsizerInfo ? 'Hide downsizer explainer' : 'Learn about downsizer contribution'
                                    }),
                                    details.showDownsizerInfo && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-3 space-y-2 text-xs bg-white border border-blue-200 rounded-lg p-3 text-blue-900",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-semibold text-blue-800",
                                                        children: "What is it?"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            "Allows eligible homeowners aged 55+ to contribute up to ",
                                                            formatCurrencyLocal((0, $a1c4193edeff7c3c$export$42edd27decf8c272)),
                                                            " (each) from sale proceeds into super without impacting contribution caps."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-semibold text-blue-800",
                                                        children: "Benefits"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                        className: "list-disc list-inside space-y-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: "Moves funds into the tax-effective super environment."
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: "No contribution cap or work test restrictions."
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: "Can commence a new income stream once in pension phase."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-semibold text-blue-800",
                                                        children: "Eligibility"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                        className: "list-disc list-inside space-y-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: "Age 55+ at the time of contribution."
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: "Home owned for 10+ years and eligible for CGT main residence exemption."
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: "Contribution generally made within 90 days of settlement."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-semibold text-blue-800",
                                                        children: "Considerations/Risks"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                        className: "list-disc list-inside space-y-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: "Counts as an assessable asset for the Age Pension."
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: "Contribution is irreversible \u2014 retain sufficient cash reserves."
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: "Seek personal financial advice before proceeding."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: "https://www.ato.gov.au/individuals/super/growing-your-super/adding-to-your-super/downsizer-contributions-for-individuals/",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    className: "text-blue-700 underline",
                                                    children: "More information from the ATO"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            factFind?.adviceFor === 'couple' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c310d81356fecc7e$var$SupportAllocationInput, {
                                icon: (0, $33b542e8915cec79$export$2e2bcd8739ae039),
                                label: "Partner downsizer contribution",
                                field: "partnerDownsizerContribution",
                                value: details.partnerDownsizerContribution || 0,
                                max: Math.min((0, $a1c4193edeff7c3c$export$42edd27decf8c272), netProceeds),
                                onChange: handleAllocationChange,
                                tooltip: (0, $8849d61d9af733fb$export$229126c85a7ec674).partnerDownsizerToSuper(isDownsizerEligible),
                                disabled: !isDownsizerEligible
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "checkbox",
                                        id: "commenceIncomeStream",
                                        checked: !!details.commenceIncomeStream,
                                        onChange: (e)=>setDetails((prev)=>({
                                                    ...prev,
                                                    commenceIncomeStream: e.target.checked
                                                }))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "commenceIncomeStream",
                                        className: "text-sm text-gray-700",
                                        children: "Commence an income stream from downsizer contribution"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c310d81356fecc7e$var$SupportAllocationInput, {
                                icon: (0, $6315759428919b56$export$2e2bcd8739ae039),
                                label: "Gift to loved ones",
                                field: "giftingAmount",
                                value: details.giftingAmount || 0,
                                max: netProceeds,
                                onChange: handleAllocationChange,
                                tooltip: (0, $8849d61d9af733fb$export$229126c85a7ec674).giftToLovedOnes()
                            }),
                            liabilityOptions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "block text-sm font-medium text-gray-700",
                                        children: "Repay debt"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                        value: details.selectedDebtKey || '',
                                        onChange: (e)=>setDetails((prev)=>({
                                                    ...prev,
                                                    selectedDebtKey: e.target.value,
                                                    debtRepayment: 0
                                                })),
                                        className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm",
                                        children: liabilityOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: option.key,
                                                children: option.label
                                            }, option.key))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c310d81356fecc7e$var$SupportAllocationInput, {
                                        icon: (0, $e325251f2797f6cf$export$2e2bcd8739ae039),
                                        label: "Amount to repay",
                                        field: "debtRepayment",
                                        value: details.debtRepayment || 0,
                                        max: selectedDebt ? Math.min(selectedDebt.balance, netProceeds) : 0,
                                        onChange: handleAllocationChange,
                                        tooltip: (0, $8849d61d9af733fb$export$229126c85a7ec674).payDownLoan()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "border border-dashed border-blue-300 rounded-lg p-4 bg-white space-y-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                className: "font-semibold text-gray-900 text-sm",
                                                children: "Add financial & personal assets"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setShowAssetForm((prev)=>!prev),
                                                className: "text-sm text-blue-600 underline",
                                                children: showAssetForm ? 'Cancel' : 'Add asset'
                                            })
                                        ]
                                    }),
                                    showAssetForm && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "grid grid-cols-1 md:grid-cols-2 gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        className: "block text-xs font-medium text-gray-600 mb-1",
                                                        children: "Asset type"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        value: newAsset.type,
                                                        onChange: (e)=>{
                                                            const type = e.target.value;
                                                            const defaults = (0, $a1c4193edeff7c3c$export$1d4431839363ff69).find((opt)=>opt.id === type)?.defaults || {
                                                                incomeRate: 0,
                                                                growthRate: 0,
                                                                frankingCredit: 0
                                                            };
                                                            setNewAsset((prev)=>({
                                                                    ...prev,
                                                                    type: type,
                                                                    incomeRate: defaults.incomeRate || prev.incomeRate,
                                                                    growthRate: defaults.growthRate || prev.growthRate,
                                                                    frankingCredit: defaults.frankingCredit || prev.frankingCredit
                                                                }));
                                                        },
                                                        className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "",
                                                                children: "Select asset type..."
                                                            }),
                                                            (0, $a1c4193edeff7c3c$export$1d4431839363ff69).map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: option.id,
                                                                    children: option.label
                                                                }, option.id))
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        className: "block text-xs font-medium text-gray-600 mb-1",
                                                        children: "Description"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "text",
                                                        value: newAsset.description,
                                                        onChange: (e)=>setNewAsset((prev)=>({
                                                                    ...prev,
                                                                    description: e.target.value
                                                                })),
                                                        className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm",
                                                        placeholder: "e.g. Australian shares portfolio"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                        label: "Amount allocated",
                                                        value: newAsset.value === '' ? '' : newAsset.value,
                                                        onChange: (v)=>setNewAsset((prev)=>({
                                                                    ...prev,
                                                                    value: v ?? ''
                                                                })),
                                                        className: "text-sm",
                                                        placeholder: "0"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-[11px] text-gray-500 mt-1",
                                                        children: [
                                                            "Available: ",
                                                            formatCurrencyLocal(availableForNewAsset)
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        className: "block text-xs font-medium text-gray-600 mb-1",
                                                        children: "Ownership"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                        value: newAsset.ownership,
                                                        onChange: (e)=>setNewAsset((prev)=>({
                                                                    ...prev,
                                                                    ownership: e.target.value
                                                                })),
                                                        className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm",
                                                        children: ownershipOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: option.value,
                                                                children: option.label
                                                            }, option.value))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        className: "block text-xs font-medium text-gray-600 mb-1",
                                                        children: "Income rate (% p.a.)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "number",
                                                        value: newAsset.incomeRate,
                                                        onChange: (e)=>setNewAsset((prev)=>({
                                                                    ...prev,
                                                                    incomeRate: e.target.value
                                                                })),
                                                        className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm",
                                                        placeholder: "e.g. 4"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        className: "block text-xs font-medium text-gray-600 mb-1",
                                                        children: "Growth rate (% p.a.)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "number",
                                                        value: newAsset.growthRate,
                                                        onChange: (e)=>setNewAsset((prev)=>({
                                                                    ...prev,
                                                                    growthRate: e.target.value
                                                                })),
                                                        className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm",
                                                        placeholder: "e.g. 5"
                                                    })
                                                ]
                                            }),
                                            newAsset.type === 'shares' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        className: "block text-xs font-medium text-gray-600 mb-1",
                                                        children: "Franking credit (%)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "number",
                                                        value: newAsset.frankingCredit,
                                                        onChange: (e)=>setNewAsset((prev)=>({
                                                                    ...prev,
                                                                    frankingCredit: e.target.value
                                                                })),
                                                        className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm",
                                                        placeholder: "e.g. 70"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "md:col-span-2 flex justify-end gap-2 mt-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: resetAssetForm,
                                                        className: "px-3 py-1 text-sm text-gray-600 hover:text-gray-900 underline",
                                                        children: "Reset"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: handleAddAsset,
                                                        className: "px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition-colors",
                                                        children: "Add asset"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    addedAssets.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "space-y-3",
                                        children: addedAssets.map((asset)=>{
                                            const config = (0, $a1c4193edeff7c3c$export$1d4431839363ff69).find((opt)=>opt.id === asset.type);
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "p-3 bg-white rounded-lg border border-blue-200",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-start justify-between gap-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                    className: "font-semibold text-gray-900 text-sm",
                                                                    children: [
                                                                        config?.label || 'Asset',
                                                                        " \u2014 ",
                                                                        asset.description
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                    className: "text-xs text-gray-600 mt-1",
                                                                    children: [
                                                                        "Ownership: ",
                                                                        ownershipOptions.find((option)=>option.value === asset.ownership)?.label || asset.ownership
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                    className: "text-xs text-gray-600",
                                                                    children: [
                                                                        "Income ",
                                                                        asset.incomeRate || '0',
                                                                        "% p.a. | Growth ",
                                                                        asset.growthRate || '0',
                                                                        "% p.a.",
                                                                        asset.frankingCredit ? ` | Franking ${asset.frankingCredit}%` : ''
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex items-center gap-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "font-bold text-blue-700",
                                                                    children: formatCurrencyLocal(parseFloat(String(asset.value)) || 0)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: ()=>removeAsset(asset.id),
                                                                    className: "p-1 rounded-full bg-white text-gray-500 hover:text-red-600 hover:bg-red-50",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                                        size: 16
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, asset.id);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-1 text-xs text-gray-500",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    children: "Any surplus is automatically added to your bank account balance for ongoing cashflow modelling."
                })
            })
        ]
    });
}
function $c310d81356fecc7e$export$e19b2ab69dc18268({ factFind: factFind, details: details, setDetails: setDetails, legacyYears: legacyYearsProp }) {
    const [isEducationExpanded, setIsEducationExpanded] = (0, $acw62.useState)(false);
    const legacyYears = legacyYearsProp ?? 5;
    const formatCurrency = (value)=>{
        return new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(Number(value) || 0);
    };
    const handleDetailChange = (field, value)=>{
        if (field === 'loanPercentage') {
            const roundedPercentage = Math.round(parseFloat(String(value)) || 0);
            setDetails((prev)=>({
                    ...prev,
                    [field]: roundedPercentage
                }));
            const homeValue = parseFloat(String(factFind.home?.value)) || 0;
            const loanAmount = homeValue * roundedPercentage / 100;
            setDetails((prev)=>({
                    ...prev,
                    loanAmount: loanAmount
                }));
        } else if (field === 'loanAmount') {
            setDetails((prev)=>({
                    ...prev,
                    [field]: parseFloat(String(value)) || 0
                }));
            const homeValue = parseFloat(String(factFind.home?.value)) || 0;
            if (homeValue > 0) {
                const loanPercentage = Math.round((parseFloat(String(value)) || 0) / homeValue * 100);
                setDetails((prev)=>({
                        ...prev,
                        loanPercentage: loanPercentage
                    }));
            }
        } else if (field === 'interestRate') setDetails((prev)=>({
                ...prev,
                [field]: parseFloat(String(value)) || 0
            }));
        else setDetails((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    const homeValue = parseFloat(String(factFind.home?.value)) || 0;
    const clientAge = (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client?.dob) || 0;
    const partnerAge = factFind.adviceFor === 'couple' ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner?.dob) : null;
    const youngestAge = partnerAge ? Math.min(clientAge, partnerAge) : clientAge;
    const getMaxLVR = (age)=>{
        if (age >= 80) return 50;
        if (age >= 75) return 45;
        if (age >= 70) return 40;
        if (age >= 65) return 30;
        if (age >= 60) return 20;
        return 15;
    };
    const maxLVR = getMaxLVR(youngestAge);
    const maxLoanAmount = homeValue * (maxLVR / 100);
    const currentLoanAmount = Number(details.loanAmount) || 0;
    const currentLoanPercentage = Number(details.loanPercentage) || 0;
    const exceedsLimit = currentLoanPercentage > maxLVR;
    const homeGrowthRate = parseFloat(String(factFind.home?.homeGrowthRate)) || 5;
    const initialLoanBalance = currentLoanAmount || 0;
    const interestRate = parseFloat(String(details.interestRate)) || (0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279);
    let projectedHomeValueWithRM = homeValue;
    let projectedLoanBalance = initialLoanBalance;
    for(let year = 1; year <= legacyYears; year++){
        projectedHomeValueWithRM = projectedHomeValueWithRM * (1 + homeGrowthRate / 100);
        projectedLoanBalance = projectedLoanBalance * (1 + interestRate / 100);
        if (details.loanStructure === 'regular_payments' && year >= 1) {
            const paymentAmount = parseFloat(String(details.regularPaymentAmount)) || 0;
            const frequency = details.regularPaymentFrequency || 'fortnightly';
            const annualPayment = frequency === 'fortnightly' ? paymentAmount * 26 : paymentAmount * 12;
            projectedLoanBalance += annualPayment;
        }
    }
    let projectedHomeValueNoRM = homeValue;
    for(let year = 1; year <= legacyYears; year++)projectedHomeValueNoRM = projectedHomeValueNoRM * (1 + homeGrowthRate / 100);
    const projectedEquityWithRM = Math.max(0, projectedHomeValueWithRM - projectedLoanBalance);
    const projectedEquityNoRM = projectedHomeValueNoRM;
    const equityDifference = projectedEquityNoRM - projectedEquityWithRM;
    const equityPercentageOwned = initialLoanBalance > 0 ? projectedEquityWithRM / projectedHomeValueWithRM * 100 : 100;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-4 p-4 bg-gray-50 rounded-lg border space-y-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                className: "font-semibold text-lg",
                children: "Reverse Mortgage Details"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border border-gray-200 rounded-lg overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: ()=>setIsEducationExpanded(!isEducationExpanded),
                        className: "w-full p-4 bg-white border border-slate-200 transition-all duration-200 flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h5", {
                                className: "font-semibold text-gray-900 flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                        className: "w-5 h-5 text-blue-600"
                                    }),
                                    "What is a Reverse Mortgage?"
                                ]
                            }),
                            isEducationExpanded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-gray-600 transform rotate-180 transition-transform"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-gray-600 transition-transform"
                            })
                        ]
                    }),
                    isEducationExpanded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "p-4 bg-white border-t border-gray-200 space-y-3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-sm text-gray-700 space-y-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        "A ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "reverse mortgage"
                                        }),
                                        " is a loan that allows you to access the equity in your home without making regular repayments. Instead, interest compounds on the loan balance, and the loan is typically repaid when you sell the home, move into aged care, or pass away."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-semibold mb-2",
                                            children: "Loan Structure Options:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "space-y-3 pl-4 border-l-2 border-blue-200",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "font-medium text-blue-700",
                                                            children: "1. Lump Sum"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-xs text-gray-600 mt-1",
                                                            children: "You receive the full loan amount upfront. This gives you immediate access to cash for expenses or investments. The entire loan amount immediately starts accruing compound interest."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "font-medium text-blue-700",
                                                            children: "2. Regular Payments"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-xs text-gray-600 mt-1",
                                                            children: "You receive regular payments (fortnightly or monthly) over time. This provides a steady income stream but may be more expensive as the loan balance accumulates with each payment."
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-4 p-3 bg-white border border-blue-200 rounded-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-semibold text-blue-900 mb-2",
                                            children: "Impact on Age Pension:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-xs text-gray-700 mb-2",
                                            children: "When you receive reverse mortgage proceeds, these funds are added to your assessable assets for the Age Pension means test. The loan proceeds are subject to deeming rules, which means Centrelink assumes they earn income at prescribed rates."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-3 p-3 bg-white border border-blue-200 rounded-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-semibold text-blue-900 mb-2",
                                            children: "Impact on Support at Home Contributions:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-xs text-gray-700 mb-2",
                                            children: "Reverse mortgage proceeds are treated as assessable assets for Support at Home contribution calculations. Higher assets may increase your contribution rate, which could offset some of the benefits of accessing the equity."
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            exceedsLimit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "p-3 bg-red-50 border-l-4 border-red-400 rounded-r-lg text-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-red-700 font-semibold",
                        children: [
                            "\xe2\u0161\xa0\xef\xb8\x8f Warning: Your loan amount exceeds typical lender limits for your age (",
                            youngestAge,
                            ")."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-red-600 mt-1 text-xs",
                        children: [
                            "Most lenders restrict reverse mortgages to a maximum of ",
                            maxLVR,
                            "% of home value (",
                            formatCurrency(maxLoanAmount),
                            ") based on the youngest borrower's age."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                            label: "Loan Amount ($)",
                            value: details.loanAmount ?? '',
                            onChange: (v)=>handleDetailChange('loanAmount', v),
                            placeholder: "0",
                            className: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2",
                                children: [
                                    "Loan Percentage (%)",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c310d81356fecc7e$var$InfoIcon, {
                                        text: "This shows what percentage of your home's current value the loan amount represents."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "number",
                                value: Math.round(Number(details.loanPercentage) || 0),
                                onChange: (e)=>handleDetailChange('loanPercentage', e.target.value),
                                className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent",
                                placeholder: "0",
                                max: maxLVR
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Interest Rate (% p.a.)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "number",
                                step: "0.1",
                                value: details.interestRate || (0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279),
                                onChange: (e)=>handleDetailChange('interestRate', e.target.value),
                                className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Loan Structure"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: details.loanStructure || 'lump_sum',
                                onChange: (e)=>handleDetailChange('loanStructure', e.target.value),
                                className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "lump_sum",
                                        children: "Lump Sum"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "regular_payments",
                                        children: "Regular Payments"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            details.loanStructure === 'regular_payments' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                            label: "Payment Amount ($)",
                            value: details.regularPaymentAmount ?? '',
                            onChange: (v)=>handleDetailChange('regularPaymentAmount', v),
                            placeholder: "0",
                            className: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Payment Frequency"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: details.regularPaymentFrequency || 'fortnightly',
                                onChange: (e)=>handleDetailChange('regularPaymentFrequency', e.target.value),
                                className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "fortnightly",
                                        children: "Fortnightly"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "monthly",
                                        children: "Monthly"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            className: "block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2",
                            children: [
                                "Establishment Fees ($)",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c310d81356fecc7e$var$InfoIcon, {
                                    text: "One-time fees charged by the lender to set up the reverse mortgage."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                            value: details.establishmentFees ?? '',
                            onChange: (v)=>handleDetailChange('establishmentFees', v),
                            placeholder: "0",
                            className: ""
                        })
                    ]
                })
            }),
            initialLoanBalance > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                        className: "font-semibold text-gray-900 text-lg",
                        children: "Impact on Home Equity"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "p-4 bg-white border-2 border-blue-200 rounded-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h6", {
                                        className: "font-semibold text-blue-900 mb-3 flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e71d8988c230db1b$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4"
                                            }),
                                            "With Reverse Mortgage"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center justify-between mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-sm text-gray-700",
                                                        children: "Home Equity Ownership"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-lg font-bold text-blue-700",
                                                        children: [
                                                            equityPercentageOwned.toFixed(1),
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-full bg-gray-200 rounded-full h-6 overflow-hidden",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "bg-blue-600 h-6 flex items-center justify-end pr-2 transition-all duration-500",
                                                    style: {
                                                        width: `${Math.min(100, equityPercentageOwned)}%`
                                                    },
                                                    children: equityPercentageOwned > 15 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-xs font-semibold text-white",
                                                        children: [
                                                            equityPercentageOwned.toFixed(1),
                                                            "%"
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-2 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-600",
                                                        children: "Projected Home Value:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-medium",
                                                        children: formatCurrency(projectedHomeValueWithRM)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-600",
                                                        children: "Loan Balance:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "font-medium text-red-600",
                                                        children: [
                                                            "-",
                                                            formatCurrency(projectedLoanBalance)
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between pt-2 border-t border-blue-200",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-semibold text-gray-900",
                                                        children: "Your Equity:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold text-blue-700",
                                                        children: formatCurrency(projectedEquityWithRM)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "p-4 bg-white border-2 border-green-200 rounded-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h6", {
                                        className: "font-semibold text-green-900 mb-3 flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4"
                                            }),
                                            "Without Reverse Mortgage"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center justify-between mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-sm text-gray-700",
                                                        children: "Home Equity Ownership"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-lg font-bold text-green-700",
                                                        children: "100%"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-full bg-gray-200 rounded-full h-6 overflow-hidden",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "bg-emerald-600 h-6 flex items-center justify-end pr-2",
                                                    style: {
                                                        width: '100%'
                                                    },
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-xs font-semibold text-white",
                                                        children: "100%"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-2 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-600",
                                                        children: "Projected Home Value:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-medium",
                                                        children: formatCurrency(projectedHomeValueNoRM)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-600",
                                                        children: "Loan Balance:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-medium text-gray-400",
                                                        children: "$0"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between pt-2 border-t border-green-200",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-semibold text-gray-900",
                                                        children: "Your Equity:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold text-green-700",
                                                        children: formatCurrency(projectedEquityNoRM)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-4 bg-gray-50 border border-gray-300 rounded-lg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center justify-between mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "font-semibold text-gray-900",
                                        children: [
                                            "Equity Impact After ",
                                            legacyYears,
                                            " Years:"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-lg font-bold text-red-600",
                                        children: [
                                            "-",
                                            formatCurrency(equityDifference)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-gray-600 mb-3",
                                children: [
                                    "By taking out a reverse mortgage, your home equity will be ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            formatCurrency(equityDifference),
                                            " less"
                                        ]
                                    }),
                                    " after ",
                                    legacyYears,
                                    " years compared to not taking the loan."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-2 gap-4 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-gray-600",
                                                children: "With Reverse Mortgage:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-semibold text-blue-700 ml-2",
                                                children: formatCurrency(projectedEquityWithRM)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-gray-600",
                                                children: "Without Reverse Mortgage:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-semibold text-green-700 ml-2",
                                                children: formatCurrency(projectedEquityNoRM)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-xs text-gray-500 mt-3",
                                children: [
                                    "Note: This projection assumes home growth at ",
                                    homeGrowthRate,
                                    "% p.a. and loan interest at ",
                                    interestRate,
                                    '% p.a. Actual results may vary. Use the "View Projections" button for a detailed analysis including all assets.'
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-4 bg-gray-50 border-l-4 border-gray-400 rounded-r-lg text-sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "font-semibold text-gray-900 mb-2",
                                children: "Additional Considerations:"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                className: "list-disc list-inside space-y-1 text-gray-700",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "Compound interest will erode your home equity over time"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "Loan balance grows faster as you age"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "Limited flexibility to move or refinance"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "Loan proceeds may be assessable for Age Pension and Support at Home contribution calculations"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $c310d81356fecc7e$export$f3b4e44bb85b922c({ factFind: factFind, details: details, setDetails: setDetails, legacyYears: legacyYearsProp }) {
    const [isEducationExpanded, setIsEducationExpanded] = (0, $acw62.useState)(false);
    const legacyYears = legacyYearsProp ?? 5;
    const formatCurrency = (value)=>{
        return new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(Number(value) || 0);
    };
    const handleDetailChange = (field, value)=>{
        setDetails((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    const [isOnAgePension, setIsOnAgePension] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind).then((financials)=>{
            if (!cancelled) setIsOnAgePension((Number(financials?.socialSecurity) || 0) > 0);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind
    ]);
    const relationshipStatus = factFind.adviceFor === 'couple' ? 'couple' : 'single';
    const maxPensionRate = (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0)[relationshipStatus] || (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single;
    const maxHEASPayment = maxPensionRate * 1.5;
    const maxHEASPaymentFortnightly = maxPensionRate / 26 * 1.5;
    const annualPaymentAmount = details.paymentFrequency === 'fortnightly' ? (Number(details.paymentAmount) || 0) * 26 : (Number(details.paymentAmount) || 0) * 12;
    const homeValue = parseFloat(String(factFind.home?.value)) || 0;
    const homeGrowthRate = parseFloat(String(factFind.home?.homeGrowthRate)) || 5;
    const interestRate = parseFloat(String(details.interestRate)) || 3.95;
    let projectedHomeValueWithHEAS = homeValue;
    let projectedHEASLoanBalance = 0;
    for(let year = 1; year <= legacyYears; year++){
        projectedHomeValueWithHEAS = projectedHomeValueWithHEAS * (1 + homeGrowthRate / 100);
        projectedHEASLoanBalance = projectedHEASLoanBalance * (1 + interestRate / 100);
        projectedHEASLoanBalance += annualPaymentAmount;
    }
    let projectedHomeValueNoHEAS = homeValue;
    for(let year = 1; year <= legacyYears; year++)projectedHomeValueNoHEAS = projectedHomeValueNoHEAS * (1 + homeGrowthRate / 100);
    const projectedEquityWithHEAS = Math.max(0, projectedHomeValueWithHEAS - projectedHEASLoanBalance);
    const projectedEquityNoHEAS = projectedHomeValueNoHEAS;
    const equityDifference = projectedEquityNoHEAS - projectedEquityWithHEAS;
    const equityPercentageOwned = annualPaymentAmount > 0 ? projectedEquityWithHEAS / projectedHomeValueWithHEAS * 100 : 100;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-4 p-4 bg-gray-50 rounded-lg border space-y-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                className: "font-semibold text-lg",
                children: "Home Equity Access Scheme (HEAS) Details"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border border-gray-200 rounded-lg overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: ()=>setIsEducationExpanded(!isEducationExpanded),
                        className: "w-full p-4 bg-white border border-slate-200 transition-all duration-200 flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h5", {
                                className: "font-semibold text-gray-900 flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                        className: "w-5 h-5 text-blue-600"
                                    }),
                                    "What is HEAS?"
                                ]
                            }),
                            isEducationExpanded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-gray-600 transform rotate-180 transition-transform"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-gray-600 transition-transform"
                            })
                        ]
                    }),
                    isEducationExpanded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "p-4 bg-white border-t border-gray-200 space-y-3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-sm text-gray-700 space-y-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        "The ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Home Equity Access Scheme (HEAS)"
                                        }),
                                        " is a government program that allows Age Pension recipients to access equity in their home through a loan scheme. Unlike commercial reverse mortgages, HEAS is administered by Services Australia (Centrelink) and offers a lower interest rate (currently ",
                                        details.interestRate,
                                        "% p.a.) and specific eligibility requirements."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "p-3 bg-white border border-blue-200 rounded-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-semibold text-blue-900 mb-2",
                                            children: "Key Differences from Commercial Reverse Mortgages:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                            className: "text-xs text-gray-700 space-y-2 list-disc list-inside",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Lower interest rate:"
                                                        }),
                                                        " HEAS charges ",
                                                        details.interestRate,
                                                        "% p.a. (government-set), compared to typically 6-8%+ for commercial reverse mortgages."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Age Pension requirement:"
                                                        }),
                                                        " You must be receiving or eligible for Age Pension to access HEAS."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Dollar-for-dollar reduction:"
                                                        }),
                                                        " HEAS payments reduce your Age Pension dollar-for-dollar."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Payment flexibility:"
                                                        }),
                                                        " You can start and stop HEAS payments as needed."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Maximum payment:"
                                                        }),
                                                        " HEAS is limited to 150% of the maximum Age Pension rate (currently ",
                                                        formatCurrency(maxHEASPayment),
                                                        " per year)."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-4 p-3 bg-white border border-blue-200 rounded-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-semibold text-blue-900 mb-2",
                                            children: "Impact on Age Pension:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-xs text-gray-700 mb-2",
                                            children: [
                                                "HEAS payments reduce your Age Pension dollar-for-dollar",
                                                annualPaymentAmount > 0 ? `. This means if you receive ${formatCurrency(annualPaymentAmount)} per year from HEAS, your Age Pension will be reduced by ${formatCurrency(annualPaymentAmount)} per year.` : '',
                                                " While this may seem counterintuitive, HEAS can still be beneficial because:"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                            className: "text-xs text-gray-700 space-y-1 list-disc list-inside",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "You receive the payment immediately"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    children: [
                                                        "The loan balance grows at a lower rate (",
                                                        details.interestRate,
                                                        "% p.a.) than commercial options"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "You maintain control over when and how much you draw"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-3 p-3 bg-white border border-blue-200 rounded-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-semibold text-blue-900 mb-2",
                                            children: "Impact on Support at Home Contributions:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-xs text-gray-700 mb-2",
                                            children: "HEAS payments are treated as assessable income for Support at Home contribution calculations. This may increase your contribution rate, which could offset some of the benefits of accessing the equity."
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            !isOnAgePension && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "p-3 bg-red-50 border-l-4 border-red-400 rounded-r-lg text-sm",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-red-800 font-semibold",
                    children: "\xe2\u0161\xa0\xef\xb8\x8f Eligibility Requirement: You must be receiving Age Pension or be eligible for Age Pension to access HEAS."
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "p-3 bg-white border-l-4 border-blue-400 rounded-r-lg text-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-blue-700",
                                children: "Maximum Available:"
                            }),
                            " ",
                            formatCurrency(maxHEASPaymentFortnightly),
                            " per fortnight (",
                            formatCurrency(maxHEASPayment),
                            " per year) - 150% of maximum Age Pension rate"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-blue-700",
                                children: "Interest Rate:"
                            }),
                            " ",
                            details.interestRate,
                            "% p.a. (compound) - Government-set rate"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                label: "Payment Amount ($)",
                                value: details.paymentAmount ?? '',
                                onChange: (v)=>handleDetailChange('paymentAmount', v),
                                placeholder: "0",
                                className: ""
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-xs text-gray-500 mt-1",
                                children: [
                                    "Max: ",
                                    formatCurrency(details.paymentFrequency === 'fortnightly' ? maxHEASPaymentFortnightly : maxHEASPayment / 12),
                                    " per ",
                                    details.paymentFrequency === 'fortnightly' ? 'fortnight' : 'month'
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Payment Frequency"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: details.paymentFrequency || 'fortnightly',
                                onChange: (e)=>handleDetailChange('paymentFrequency', e.target.value),
                                className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "fortnightly",
                                        children: "Fortnightly"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "monthly",
                                        children: "Monthly"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "p-3 bg-white border-l-4 border-green-400 rounded-r-lg text-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-green-700",
                                children: "Annual Payment:"
                            }),
                            " ",
                            formatCurrency(annualPaymentAmount)
                        ]
                    }),
                    isOnAgePension && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-green-700",
                                children: "Age Pension Impact:"
                            }),
                            " Your Age Pension will be reduced by ",
                            formatCurrency(annualPaymentAmount),
                            " per year (dollar-for-dollar reduction)"
                        ]
                    })
                ]
            }),
            annualPaymentAmount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                        className: "font-semibold text-gray-900 text-lg",
                        children: "Impact on Home Equity"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "p-4 bg-white border-2 border-blue-200 rounded-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h6", {
                                        className: "font-semibold text-blue-900 mb-3 flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e71d8988c230db1b$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4"
                                            }),
                                            "With HEAS"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center justify-between mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-sm text-gray-700",
                                                        children: "Home Equity Ownership"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-lg font-bold text-blue-700",
                                                        children: [
                                                            equityPercentageOwned.toFixed(1),
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-full bg-gray-200 rounded-full h-6 overflow-hidden",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "bg-blue-600 h-6 flex items-center justify-end pr-2 transition-all duration-500",
                                                    style: {
                                                        width: `${Math.min(100, equityPercentageOwned)}%`
                                                    },
                                                    children: equityPercentageOwned > 15 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-xs font-semibold text-white",
                                                        children: [
                                                            equityPercentageOwned.toFixed(1),
                                                            "%"
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-2 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-600",
                                                        children: "Projected Home Value:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-medium",
                                                        children: formatCurrency(projectedHomeValueWithHEAS)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-600",
                                                        children: "HEAS Loan Balance:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "font-medium text-red-600",
                                                        children: [
                                                            "-",
                                                            formatCurrency(projectedHEASLoanBalance)
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between pt-2 border-t border-blue-200",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-semibold text-gray-900",
                                                        children: "Your Equity:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold text-blue-700",
                                                        children: formatCurrency(projectedEquityWithHEAS)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "p-4 bg-white border-2 border-green-200 rounded-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h6", {
                                        className: "font-semibold text-green-900 mb-3 flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4"
                                            }),
                                            "Without HEAS"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center justify-between mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-sm text-gray-700",
                                                        children: "Home Equity Ownership"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-lg font-bold text-green-700",
                                                        children: "100%"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-full bg-gray-200 rounded-full h-6 overflow-hidden",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "bg-emerald-600 h-6 flex items-center justify-end pr-2",
                                                    style: {
                                                        width: '100%'
                                                    },
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-xs font-semibold text-white",
                                                        children: "100%"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-2 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-600",
                                                        children: "Projected Home Value:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-medium",
                                                        children: formatCurrency(projectedHomeValueNoHEAS)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-600",
                                                        children: "HEAS Loan Balance:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-medium text-gray-400",
                                                        children: "$0"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between pt-2 border-t border-green-200",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-semibold text-gray-900",
                                                        children: "Your Equity:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold text-green-700",
                                                        children: formatCurrency(projectedEquityNoHEAS)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-4 bg-gray-50 border border-gray-300 rounded-lg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center justify-between mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "font-semibold text-gray-900",
                                        children: [
                                            "Equity Impact After ",
                                            legacyYears,
                                            " Years:"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-lg font-bold text-red-600",
                                        children: [
                                            "-",
                                            formatCurrency(equityDifference)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-gray-600 mb-3",
                                children: [
                                    "By taking out HEAS, your home equity will be ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            formatCurrency(equityDifference),
                                            " less"
                                        ]
                                    }),
                                    " after ",
                                    legacyYears,
                                    " years compared to not taking the loan."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-2 gap-4 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-gray-600",
                                                children: "With HEAS:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-semibold text-blue-700 ml-2",
                                                children: formatCurrency(projectedEquityWithHEAS)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-gray-600",
                                                children: "Without HEAS:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-semibold text-green-700 ml-2",
                                                children: formatCurrency(projectedEquityNoHEAS)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-xs text-gray-500 mt-3",
                                children: [
                                    "Note: This projection assumes home growth at ",
                                    homeGrowthRate,
                                    "% p.a. and loan interest at ",
                                    interestRate,
                                    '% p.a. Actual results may vary. Use the "View Projections" button for a detailed analysis including all assets.'
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-4 bg-gray-50 border-l-4 border-gray-400 rounded-r-lg text-sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "font-semibold text-gray-900 mb-2",
                                children: "Additional Considerations:"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                className: "list-disc list-inside space-y-1 text-gray-700",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "HEAS payments reduce your Age Pension dollar-for-dollar"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "Compound interest will erode your home equity over time"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "Loan balance grows at a lower rate than commercial reverse mortgages"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "HEAS payments may be assessable for Support at Home contribution calculations"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $c310d81356fecc7e$export$9dc03ebf37a655a({ factFind: factFind, details: details, setDetails: setDetails, beforeFinancials: beforeFinancials }) {
    const formatCurrency = (value)=>{
        return new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(Number(value) || 0);
    };
    const handleDetailChange = (field, value)=>{
        setDetails((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    const renovationAmount = parseFloat(String(details.renovationAmount)) || 0;
    const currentHomeValue = parseFloat(String(factFind.home?.value)) || 0;
    const fundingSources = details.fundingSources || [];
    // Calculate available assets for funding (including ABPs)
    const availableAssets = [];
    (factFind.assets?.bankAccounts || []).forEach((account)=>{
        const value = parseFloat(String(account.value)) || 0;
        if (value > 0) availableAssets.push({
            id: account.id,
            type: 'bankAccounts',
            label: (0, $e850825c00b15be4$export$87285386e0429fb5)(account, factFind, 'Bank account'),
            value: value,
            ownership: account.ownership || 'client'
        });
    });
    (factFind.assets?.accountBasedPensions || []).forEach((abp)=>{
        const value = parseFloat(String(abp.value)) || 0;
        if (value > 0) availableAssets.push({
            id: abp.id,
            type: 'accountBasedPensions',
            label: (0, $e850825c00b15be4$export$87285386e0429fb5)(abp, factFind, 'Account-based pension'),
            value: value,
            ownership: abp.ownership || 'client'
        });
    });
    (factFind.assets?.shares || []).forEach((share)=>{
        const value = parseFloat(String(share.value)) || 0;
        if (value > 0) availableAssets.push({
            id: share.id,
            type: 'shares',
            label: (0, $e850825c00b15be4$export$87285386e0429fb5)(share, factFind, 'Shares / managed fund'),
            value: value,
            ownership: share.ownership || 'client',
            costBase: parseFloat(String(share.costBase)) || 0
        });
    });
    (factFind.assets?.investmentProperty || []).forEach((property)=>{
        const value = parseFloat(String(property.value)) || 0;
        if (value > 0) availableAssets.push({
            id: property.id,
            type: 'investmentProperty',
            label: (0, $e850825c00b15be4$export$87285386e0429fb5)(property, factFind, 'Investment property'),
            value: value,
            ownership: property.ownership || 'client',
            costBase: parseFloat(String(property.costBase)) || 0
        });
    });
    // Get assets already selected for funding
    const selectedAssetIds = fundingSources.map((f)=>`${f.assetType}-${f.assetId}`);
    const availableAssetsForSelection = availableAssets.filter((asset)=>!selectedAssetIds.includes(`${asset.type}-${asset.id}`));
    // Calculate total allocated and CGT
    let totalAllocated = 0;
    let cgtTotal = 0;
    fundingSources.forEach((funding)=>{
        const amount = parseFloat(String(funding.amount)) || 0;
        const asset = availableAssets.find((a)=>String(a.id) === String(funding.assetId) && a.type === funding.assetType);
        // Only what the account still holds counts (25 Oct 2026): an account a linked aged care plan has
        // already spent raises nothing, and the calculation takes the rest from the bank.
        totalAllocated += asset ? Math.min(amount, asset.value) : 0;
        if (asset && asset.costBase && [
            'shares',
            'investmentProperty'
        ].includes(asset.type)) {
            const saleAmount = Math.min(amount, asset.value);
            cgtTotal += (0, $a1c4193edeff7c3c$export$74909d8cea0fb99b)(asset, saleAmount, beforeFinancials);
        }
    });
    const netCost = renovationAmount + cgtTotal;
    const newHomeValue = currentHomeValue + renovationAmount;
    const assessableAssetReduction = renovationAmount;
    const remainingNeeded = Math.max(0, renovationAmount - totalAllocated);
    const addFundingSource = ()=>{
        if (availableAssetsForSelection.length === 0) return;
        const newSource = {
            assetId: availableAssetsForSelection[0].id,
            assetType: availableAssetsForSelection[0].type,
            amount: 0
        };
        handleDetailChange('fundingSources', [
            ...fundingSources,
            newSource
        ]);
    };
    const removeFundingSource = (index)=>{
        const updated = fundingSources.filter((_, i)=>i !== index);
        handleDetailChange('fundingSources', updated);
    };
    const updateFundingSource = (index, field, value)=>{
        const updated = [
            ...fundingSources
        ];
        updated[index] = {
            ...updated[index],
            [field]: value
        };
        handleDetailChange('fundingSources', updated);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-6 space-y-4 border-t border-gray-200 pt-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white border-l-4 border-blue-500 rounded-r-lg p-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-sm text-blue-900",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "How this works:"
                        }),
                        " Spending money on home renovations converts assessable assets (cash, shares, ABPs, etc.) into exempt home equity. The home is fully exempt from the Age Pension asset test, so this strategy can help you qualify for or increase Age Pension."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                            label: "Renovation Amount",
                            value: details.renovationAmount ?? '',
                            onChange: (v)=>handleDetailChange('renovationAmount', v),
                            placeholder: "0",
                            className: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center justify-between mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "block text-sm font-medium text-gray-700",
                                        children: "Source of Funds"
                                    }),
                                    availableAssetsForSelection.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: addFundingSource,
                                        className: "text-xs text-blue-600 hover:text-blue-800 flex items-center gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                                className: "w-3 h-3"
                                            }),
                                            "Add asset"
                                        ]
                                    })
                                ]
                            }),
                            fundingSources.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                onChange: (e)=>{
                                    if (e.target.value) {
                                        const [assetType, assetId] = e.target.value.split('-');
                                        const selected = availableAssets.find((a)=>a.id === assetId && a.type === assetType);
                                        if (selected) handleDetailChange('fundingSources', [
                                            {
                                                assetId: selected.id,
                                                assetType: selected.type,
                                                amount: 0
                                            }
                                        ]);
                                    }
                                },
                                className: "w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "Select an asset to fund from..."
                                    }),
                                    availableAssets.map((asset)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                            value: `${asset.type}-${asset.id}`,
                                            children: [
                                                asset.label,
                                                " \u2013 ",
                                                formatCurrency(asset.value)
                                            ]
                                        }, `${asset.type}-${asset.id}`))
                                ]
                            }),
                            fundingSources.map((funding, index)=>{
                                const asset = availableAssets.find((a)=>String(a.id) === String(funding.assetId) && a.type === funding.assetType);
                                const availableForThisAsset = asset ? parseFloat(String(asset.value)) || 0 : 0;
                                const allocatedToThisAsset = parseFloat(String(funding.amount)) || 0;
                                const remainingForThisAsset = availableForThisAsset - allocatedToThisAsset;
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mb-3 p-3 border border-gray-200 rounded-lg bg-gray-50",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex items-center justify-between mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-sm font-medium text-gray-700",
                                                    children: asset ? asset.label : "An account no longer held \u2014 this part is taken from the bank"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>removeFundingSource(index),
                                                    className: "text-red-600 hover:text-red-800",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                        className: "w-4 h-4"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "text-xs text-gray-500 mb-2",
                                            children: [
                                                "Available: ",
                                                formatCurrency(availableForThisAsset)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                            value: funding.amount ?? '',
                                            onChange: (v)=>updateFundingSource(index, 'amount', v ?? 0),
                                            placeholder: "0",
                                            className: ""
                                        }),
                                        remainingForThisAsset > 0 && remainingNeeded > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>updateFundingSource(index, 'amount', Math.min(remainingForThisAsset, remainingNeeded + allocatedToThisAsset)),
                                            className: "mt-1 text-xs text-blue-600 hover:text-blue-800",
                                            children: [
                                                "Use remaining needed (",
                                                formatCurrency(Math.min(remainingForThisAsset, remainingNeeded)),
                                                ")"
                                            ]
                                        })
                                    ]
                                }, index);
                            }),
                            fundingSources.length > 0 && availableAssetsForSelection.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: addFundingSource,
                                className: "w-full mt-2 px-4 py-2 border-2 border-dashed border-gray-300 rounded-lg text-sm text-gray-600 hover:border-blue-400 hover:text-blue-600 flex items-center justify-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        className: "w-4 h-4"
                                    }),
                                    "Add another asset"
                                ]
                            }),
                            remainingNeeded > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-2 text-sm text-slate-700 bg-white border border-slate-200 border-l-4 border-l-amber-400 rounded p-2",
                                children: [
                                    "Remaining needed: ",
                                    formatCurrency(remainingNeeded)
                                ]
                            }),
                            totalAllocated > renovationAmount && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-2 text-sm text-red-700 bg-red-50 border border-red-200 rounded p-2",
                                children: [
                                    "Total allocated (",
                                    formatCurrency(totalAllocated),
                                    ") exceeds renovation amount (",
                                    formatCurrency(renovationAmount),
                                    ")"
                                ]
                            })
                        ]
                    }),
                    renovationAmount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-sm text-gray-600",
                                        children: "Renovation Cost:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-semibold",
                                        children: formatCurrency(renovationAmount)
                                    })
                                ]
                            }),
                            cgtTotal > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-between text-red-600",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-sm",
                                        children: "Capital Gains Tax:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "font-semibold",
                                        children: [
                                            "-",
                                            formatCurrency(cgtTotal)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-between pt-2 border-t border-gray-300",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-sm font-semibold text-gray-900",
                                        children: "Total Cost:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-bold text-gray-900",
                                        children: formatCurrency(netCost)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-3 pt-3 border-t border-gray-300",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex justify-between mb-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm text-gray-600",
                                                children: "New Home Value:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-semibold text-green-600",
                                                children: formatCurrency(newHomeValue)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm text-gray-600",
                                                children: "Assessable Asset Reduction:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-semibold text-blue-600",
                                                children: formatCurrency(assessableAssetReduction)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $c310d81356fecc7e$export$6c56a95ed2b3736d({ factFind: factFind, details: details, setDetails: setDetails, beforeFinancials: beforeFinancials }) {
    const formatCurrency = (value)=>{
        return new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(Number(value) || 0);
    };
    const handleDetailChange = (field, value)=>{
        setDetails((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    const currentHomeValue = parseFloat(String(details.currentHomeValue || factFind.home?.value)) || 0;
    const newHomePurchasePrice = parseFloat(String(details.newHomePurchasePrice)) || 0;
    const sellingCosts = parseFloat(String(details.sellingCosts)) || 0;
    const fundingSources = details.fundingSources || [];
    const netProceedsFromSale = Math.max(0, currentHomeValue - sellingCosts);
    const additionalFundsNeeded = Math.max(0, newHomePurchasePrice - netProceedsFromSale);
    // Calculate available assets for funding (including ABPs)
    const availableAssets = [];
    (factFind.assets?.bankAccounts || []).forEach((account)=>{
        const value = parseFloat(String(account.value)) || 0;
        if (value > 0) availableAssets.push({
            id: account.id,
            type: 'bankAccounts',
            label: (0, $e850825c00b15be4$export$87285386e0429fb5)(account, factFind, 'Bank account'),
            value: value,
            ownership: account.ownership || 'client'
        });
    });
    (factFind.assets?.accountBasedPensions || []).forEach((abp)=>{
        const value = parseFloat(String(abp.value)) || 0;
        if (value > 0) availableAssets.push({
            id: abp.id,
            type: 'accountBasedPensions',
            label: (0, $e850825c00b15be4$export$87285386e0429fb5)(abp, factFind, 'Account-based pension'),
            value: value,
            ownership: abp.ownership || 'client'
        });
    });
    (factFind.assets?.shares || []).forEach((share)=>{
        const value = parseFloat(String(share.value)) || 0;
        if (value > 0) availableAssets.push({
            id: share.id,
            type: 'shares',
            label: (0, $e850825c00b15be4$export$87285386e0429fb5)(share, factFind, 'Shares / managed fund'),
            value: value,
            ownership: share.ownership || 'client',
            costBase: parseFloat(String(share.costBase)) || 0
        });
    });
    (factFind.assets?.investmentProperty || []).forEach((property)=>{
        const value = parseFloat(String(property.value)) || 0;
        if (value > 0) availableAssets.push({
            id: property.id,
            type: 'investmentProperty',
            label: (0, $e850825c00b15be4$export$87285386e0429fb5)(property, factFind, 'Investment property'),
            value: value,
            ownership: property.ownership || 'client',
            costBase: parseFloat(String(property.costBase)) || 0
        });
    });
    // Get assets already selected for funding
    const selectedAssetIds = fundingSources.map((f)=>`${f.assetType}-${f.assetId}`);
    const availableAssetsForSelection = availableAssets.filter((asset)=>!selectedAssetIds.includes(`${asset.type}-${asset.id}`));
    // Calculate total allocated and CGT
    let totalAllocated = 0;
    let cgtTotal = 0;
    fundingSources.forEach((funding)=>{
        const amount = parseFloat(String(funding.amount)) || 0;
        const asset = availableAssets.find((a)=>String(a.id) === String(funding.assetId) && a.type === funding.assetType);
        // Only what the account still holds counts (25 Oct 2026): an account a linked aged care plan has
        // already spent raises nothing, and the calculation takes the rest from the bank.
        totalAllocated += asset ? Math.min(amount, asset.value) : 0;
        if (asset && asset.costBase && [
            'shares',
            'investmentProperty'
        ].includes(asset.type)) {
            const saleAmount = Math.min(amount, asset.value);
            cgtTotal += (0, $a1c4193edeff7c3c$export$74909d8cea0fb99b)(asset, saleAmount, beforeFinancials);
        }
    });
    const totalCost = additionalFundsNeeded + cgtTotal;
    const assessableAssetReduction = additionalFundsNeeded;
    const remainingNeeded = Math.max(0, additionalFundsNeeded - totalAllocated);
    const addFundingSource = ()=>{
        if (availableAssetsForSelection.length === 0) return;
        const newSource = {
            assetId: availableAssetsForSelection[0].id,
            assetType: availableAssetsForSelection[0].type,
            amount: 0
        };
        handleDetailChange('fundingSources', [
            ...fundingSources,
            newSource
        ]);
    };
    const removeFundingSource = (index)=>{
        const updated = fundingSources.filter((_, i)=>i !== index);
        handleDetailChange('fundingSources', updated);
    };
    const updateFundingSource = (index, field, value)=>{
        const updated = [
            ...fundingSources
        ];
        updated[index] = {
            ...updated[index],
            [field]: value
        };
        handleDetailChange('fundingSources', updated);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-6 space-y-4 border-t border-gray-200 pt-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white border-l-4 border-blue-500 rounded-r-lg p-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-sm text-blue-900",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "How this works:"
                        }),
                        " Buying a more expensive home converts assessable assets (cash, shares, ABPs, etc.) into exempt home equity. The home is fully exempt from the Age Pension asset test, so this strategy can help you qualify for or increase Age Pension."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                            label: "Current Home Value",
                            value: details.currentHomeValue ?? currentHomeValue ?? '',
                            onChange: (v)=>handleDetailChange('currentHomeValue', v),
                            placeholder: "0",
                            className: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                            label: "New Home Purchase Price",
                            value: details.newHomePurchasePrice ?? '',
                            onChange: (v)=>handleDetailChange('newHomePurchasePrice', v),
                            placeholder: "0",
                            className: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                            label: "Selling Costs (e.g., agent fees, legal)",
                            value: details.sellingCosts ?? '',
                            onChange: (v)=>handleDetailChange('sellingCosts', v),
                            placeholder: "0",
                            className: ""
                        })
                    }),
                    newHomePurchasePrice > currentHomeValue && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center justify-between mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "block text-sm font-medium text-gray-700",
                                                children: "Source of Additional Funds"
                                            }),
                                            availableAssetsForSelection.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                onClick: addFundingSource,
                                                className: "text-xs text-blue-600 hover:text-blue-800 flex items-center gap-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                                        className: "w-3 h-3"
                                                    }),
                                                    "Add asset"
                                                ]
                                            })
                                        ]
                                    }),
                                    fundingSources.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        onChange: (e)=>{
                                            if (e.target.value) {
                                                const [assetType, assetId] = e.target.value.split('-');
                                                const selected = availableAssets.find((a)=>a.id === assetId && a.type === assetType);
                                                if (selected) handleDetailChange('fundingSources', [
                                                    {
                                                        assetId: selected.id,
                                                        assetType: selected.type,
                                                        amount: 0
                                                    }
                                                ]);
                                            }
                                        },
                                        className: "w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Select an asset to fund from..."
                                            }),
                                            availableAssets.map((asset)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                                    value: `${asset.type}-${asset.id}`,
                                                    children: [
                                                        asset.label,
                                                        " \u2013 ",
                                                        formatCurrency(asset.value)
                                                    ]
                                                }, `${asset.type}-${asset.id}`))
                                        ]
                                    }),
                                    fundingSources.map((funding, index)=>{
                                        const asset = availableAssets.find((a)=>String(a.id) === String(funding.assetId) && a.type === funding.assetType);
                                        const availableForThisAsset = asset ? parseFloat(String(asset.value)) || 0 : 0;
                                        const allocatedToThisAsset = parseFloat(String(funding.amount)) || 0;
                                        const remainingForThisAsset = availableForThisAsset - allocatedToThisAsset;
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mb-3 p-3 border border-gray-200 rounded-lg bg-gray-50",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-center justify-between mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-sm font-medium text-gray-700",
                                                            children: asset ? asset.label : "An account no longer held \u2014 this part is taken from the bank"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>removeFundingSource(index),
                                                            className: "text-red-600 hover:text-red-800",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                                className: "w-4 h-4"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "text-xs text-gray-500 mb-2",
                                                    children: [
                                                        "Available: ",
                                                        formatCurrency(availableForThisAsset)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                    value: funding.amount ?? '',
                                                    onChange: (v)=>updateFundingSource(index, 'amount', v ?? 0),
                                                    placeholder: "0",
                                                    className: ""
                                                }),
                                                remainingForThisAsset > 0 && remainingNeeded > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    onClick: ()=>updateFundingSource(index, 'amount', Math.min(remainingForThisAsset, remainingNeeded + allocatedToThisAsset)),
                                                    className: "mt-1 text-xs text-blue-600 hover:text-blue-800",
                                                    children: [
                                                        "Use remaining needed (",
                                                        formatCurrency(Math.min(remainingForThisAsset, remainingNeeded)),
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        }, index);
                                    }),
                                    fundingSources.length > 0 && availableAssetsForSelection.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: addFundingSource,
                                        className: "w-full mt-2 px-4 py-2 border-2 border-dashed border-gray-300 rounded-lg text-sm text-gray-600 hover:border-blue-400 hover:text-blue-600 flex items-center justify-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4"
                                            }),
                                            "Add another asset"
                                        ]
                                    }),
                                    remainingNeeded > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-2 text-sm text-slate-700 bg-white border border-slate-200 border-l-4 border-l-amber-400 rounded p-2",
                                        children: [
                                            "Remaining needed: ",
                                            formatCurrency(remainingNeeded)
                                        ]
                                    }),
                                    totalAllocated > additionalFundsNeeded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-2 text-sm text-red-700 bg-red-50 border border-red-200 rounded p-2",
                                        children: [
                                            "Total allocated (",
                                            formatCurrency(totalAllocated),
                                            ") exceeds additional funds needed (",
                                            formatCurrency(additionalFundsNeeded),
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm text-gray-600",
                                                children: "Net Proceeds from Sale:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-semibold",
                                                children: formatCurrency(netProceedsFromSale)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm text-gray-600",
                                                children: "Additional Funds Needed:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-semibold",
                                                children: formatCurrency(additionalFundsNeeded)
                                            })
                                        ]
                                    }),
                                    cgtTotal > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex justify-between text-red-600",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm",
                                                children: "Capital Gains Tax:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "font-semibold",
                                                children: [
                                                    "-",
                                                    formatCurrency(cgtTotal)
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex justify-between pt-2 border-t border-gray-300",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm font-semibold text-gray-900",
                                                children: "Total Additional Cost:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-bold text-gray-900",
                                                children: formatCurrency(totalCost)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-3 pt-3 border-t border-gray-300",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-sm text-gray-600",
                                                        children: "New Home Value:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-semibold text-green-600",
                                                        children: formatCurrency(newHomePurchasePrice)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-sm text-gray-600",
                                                        children: "Assessable Asset Reduction:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-semibold text-blue-600",
                                                        children: formatCurrency(assessableAssetReduction)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    newHomePurchasePrice <= currentHomeValue && newHomePurchasePrice > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bg-white border border-slate-200 border-l-4 border-l-amber-400 rounded-r-lg p-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-sm text-slate-700",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Note:"
                                }),
                                " The new home price must be higher than your current home value for this to be an upgrade strategy."
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




/**
 * Shared helpers for Support at Home insight copy and “near maximum” Age Pension logic.
 * Keeps illness‑separated max (2 × single) aligned with calculateFinancials.
 */ 

function $ffc52726733f6151$export$577870b8d1aaf3bd(value) {
    if (value == null || value === '') return null;
    const n = parseFloat(String(value).replace(/[^0-9.-]/g, ''));
    return Number.isFinite(n) ? n : null;
}
function $ffc52726733f6151$export$cbe6d18275b5e5f9(breakdown) {
    if (!Array.isArray(breakdown)) return false;
    const row = breakdown.find((b)=>b.label === 'Couple treatment');
    return row?.value === 'Illness separated';
}
function $ffc52726733f6151$export$cf0463a6434d3bec(factFind, beforeFinancials, afterFinancials, agedCareScenarioLinked = false) {
    if (factFind?.adviceFor !== 'couple') return false;
    const afterBreakdown = afterFinancials?.socialSecurityBreakdown;
    const beforeBreakdown = beforeFinancials?.socialSecurityBreakdown;
    if (Array.isArray(afterBreakdown) || Array.isArray(beforeBreakdown)) return $ffc52726733f6151$export$cbe6d18275b5e5f9(afterBreakdown) || $ffc52726733f6151$export$cbe6d18275b5e5f9(beforeBreakdown);
    if (!agedCareScenarioLinked) return false;
    // DraftFactFind is structurally compatible with FactFind (see
    // types/formDraft.ts); the shared calc-engine fns defensively coerce internally regardless,
    // so this cast is safe (see factFindTypes.ts header comment).
    const strictFactFind = factFind;
    return Boolean((0, $8eecd0af141b9afb$export$9b95c99516118f10)(strictFactFind, (0, $8eecd0af141b9afb$export$7b84565bbb0eef12)(strictFactFind)));
}
function $ffc52726733f6151$export$87707962409e24c6(isCouple, illnessSeparated) {
    if (!isCouple) return (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single;
    if (illnessSeparated) return (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single * 2;
    return (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).couple;
}
function $ffc52726733f6151$var$extractPensionUnderTests(breakdown) {
    if (!Array.isArray(breakdown)) return null;
    const under = breakdown.filter((b)=>b.label === 'Pension under this test');
    if (under.length < 2) return null;
    const assetTestPension = $ffc52726733f6151$export$577870b8d1aaf3bd(under[0].value);
    const incomeTestPension = $ffc52726733f6151$export$577870b8d1aaf3bd(under[1].value);
    if (assetTestPension == null || incomeTestPension == null) return null;
    const determinedBy = breakdown.find((b)=>b.label === 'Determined By')?.value ?? null;
    return {
        assetTestPension: assetTestPension,
        incomeTestPension: incomeTestPension,
        determinedBy: determinedBy
    };
}
function $ffc52726733f6151$export$e356b268d970b858(breakdown, maxCombinedRate) {
    const derived = $ffc52726733f6151$var$extractPensionUnderTests(breakdown);
    if (!derived || !maxCombinedRate || maxCombinedRate <= 0) return 'genericNearMax';
    const { assetTestPension: assetTestPension, incomeTestPension: incomeTestPension, determinedBy: determinedBy } = derived;
    const tol = Math.max(150, maxCombinedRate * 0.002);
    if (Math.abs(assetTestPension - incomeTestPension) <= tol) return 'atTrueMaximum';
    if (determinedBy === 'Income Test' && assetTestPension > incomeTestPension + tol) return 'incomeTestLimited';
    if (determinedBy === 'Asset Test' && incomeTestPension > assetTestPension + tol) return 'assetTestLimited';
    return 'genericNearMax';
}
function $ffc52726733f6151$export$5092ed2c4c8fd32(input) {
    const { assessableAssets: assessableAssets, assessableIncome: assessableIncome, currentPension: currentPension, isCouple: isCouple, isHomeowner: isHomeowner, illnessSeparatedForPension: illnessSeparatedForPension } = input;
    const relationshipStatus = isCouple ? 'couple' : 'single';
    const pensionRate = isCouple && illnessSeparatedForPension ? (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single * 2 : (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0)[relationshipStatus];
    // Asset test thresholds (illness-separated: higher full/nil bands)
    const assetLimits = !isCouple ? isHomeowner ? (0, $1abe73eeef086faf$export$9a84fd450010fb2e).single.homeowner : (0, $1abe73eeef086faf$export$9a84fd450010fb2e).single.nonHomeowner : illnessSeparatedForPension ? isHomeowner ? (0, $1abe73eeef086faf$export$9a84fd450010fb2e).coupleIllnessSeparated.homeowner : (0, $1abe73eeef086faf$export$9a84fd450010fb2e).coupleIllnessSeparated.nonHomeowner : isHomeowner ? (0, $1abe73eeef086faf$export$9a84fd450010fb2e).couple.homeowner : (0, $1abe73eeef086faf$export$9a84fd450010fb2e).couple.nonHomeowner;
    const assetLowerLimit = assetLimits.full;
    const assetUpperLimit = assetLimits.cutoff;
    let pensionFromAssetTest = pensionRate;
    if (assessableAssets > assetUpperLimit) pensionFromAssetTest = 0;
    else if (assessableAssets > assetLowerLimit) {
        const excessAssets = assessableAssets - assetLowerLimit;
        const reduction = excessAssets / 1000 * (0, $1abe73eeef086faf$export$6ca758cf677ce6c5);
        pensionFromAssetTest = Math.max(0, pensionRate - reduction);
    }
    const incomeLowerLimit = (0, $1abe73eeef086faf$export$704950d172afcdf8)[relationshipStatus];
    let pensionFromIncomeTest = pensionRate;
    if (assessableIncome > incomeLowerLimit) {
        const excessIncome = assessableIncome - incomeLowerLimit;
        const reduction = excessIncome * (0, $1abe73eeef086faf$export$d0c93f26057d6047);
        pensionFromIncomeTest = Math.max(0, pensionRate - reduction);
    }
    const determiningTest = pensionFromAssetTest < pensionFromIncomeTest ? 'asset' : 'income';
    const isAssetTestLimiting = determiningTest === 'asset';
    const targets = [];
    if (isAssetTestLimiting) {
        const reductionForFullPension = Math.max(0, assessableAssets - assetLowerLimit);
        const fullPensionAchievable = reductionForFullPension <= assessableAssets;
        targets.push({
            label: 'Full Pension',
            kind: 'full',
            targetPension: pensionRate,
            reductionNeeded: reductionForFullPension,
            achievable: fullPensionAchievable,
            currentPension: currentPension,
            increase: pensionRate - currentPension
        });
        [
            0.25,
            0.5,
            0.75
        ].forEach((percent)=>{
            const targetPension = Math.min(pensionRate, currentPension * (1 + percent));
            const pensionIncrease = targetPension - currentPension;
            // Work backwards: assets = lowerLimit + ((pensionRate - pension) / taper) * 1000
            const requiredAssets = assetLowerLimit + (pensionRate - targetPension) / (0, $1abe73eeef086faf$export$6ca758cf677ce6c5) * 1000;
            const reductionNeeded = Math.max(0, assessableAssets - requiredAssets);
            const achievable = reductionNeeded <= assessableAssets && targetPension <= pensionRate;
            targets.push({
                label: `Increase by ${Math.round(percent * 100)}%`,
                kind: 'increase',
                targetPension: targetPension,
                reductionNeeded: reductionNeeded,
                achievable: achievable,
                currentPension: currentPension,
                increase: pensionIncrease
            });
        });
    } else targets.push({
        label: 'Full Pension',
        kind: 'full',
        targetPension: pensionRate,
        reductionNeeded: null,
        achievable: false,
        currentPension: currentPension,
        increase: pensionRate - currentPension,
        note: 'Income test is limiting - asset restructuring will not increase Age Pension'
    });
    return {
        currentPension: currentPension,
        currentAssets: assessableAssets,
        currentIncome: assessableIncome,
        determiningTest: determiningTest,
        isAssetTestLimiting: isAssetTestLimiting,
        pensionFromAssetTest: pensionFromAssetTest,
        pensionFromIncomeTest: pensionFromIncomeTest,
        targets: targets,
        assetLowerLimit: assetLowerLimit,
        assetUpperLimit: assetUpperLimit
    };
}


/**
 * A Support at home plan in everyday words — the card title, the line under it, and what the means
 * tests do with it (Support at home rebuild, 19 Oct 2026; the review's vocabulary table:
 * "Increase home equity ($250,000)" → "Spend $250,000 on the home", "Purchase $250,000 Annuity (nil
 * residual)" → "Buy a $250,000 lifetime income for Colin").
 *
 * Read from the engine candidate's own config — the same fields the evaluator applied — so the words
 * can never describe a different plan from the figures beside them. Accounts are named the way the
 * client would say them: a couple's two "MLC" accounts are "Colin's MLC" and "Shelly's MLC".
 */ 
const $f7f18ba87194b6fe$var$money = (n)=>`$${Math.round(Number(n) || 0).toLocaleString('en-AU')}`;
const $f7f18ba87194b6fe$var$KIND_WORD = {
    bankAccounts: 'account',
    accountBasedPensions: 'pension',
    shares: 'shares',
    termDeposits: 'term deposit',
    managedFunds: 'managed fund'
};
function $f7f18ba87194b6fe$export$3464ecd68a907088(source, factFind) {
    const list = factFind?.assets?.[String(source.type)] || [];
    const asset = list.find((a)=>String(a?.id) === String(source.id));
    const desc = String(source.description || asset?.description || '').trim() || 'savings';
    const kind = $f7f18ba87194b6fe$var$KIND_WORD[String(source.type)] || '';
    // "CBA Acc" is already an account; don't make it "CBA Acc account".
    const alreadySaid = kind === 'account' ? /\bacc(ount|t)?\b/i.test(desc) : desc.toLowerCase().includes(kind);
    const withKind = kind && !alreadySaid ? `${desc} ${kind}` : desc;
    const isCouple = factFind?.adviceFor === 'couple';
    const owner = isCouple && asset?.ownership === 'client' ? factFind?.client?.firstName : isCouple && asset?.ownership === 'partner' ? factFind?.partner?.firstName : null;
    if (owner && !withKind.toLowerCase().includes(String(owner).toLowerCase())) return `${owner}'s ${withKind}`;
    return `the ${withKind}`;
}
function $f7f18ba87194b6fe$export$c74117914526c5e0(config, factFind) {
    const parts = (config.fundingSources || []).filter((s)=>Number(s.amountToTake) > 0).map((s)=>`${$f7f18ba87194b6fe$var$money(s.amountToTake)} of ${$f7f18ba87194b6fe$export$3464ecd68a907088(s, factFind)}`);
    if (!parts.length) return '';
    const joined = parts.length === 1 ? parts[0] : `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}`;
    return `Paid from ${joined}.`;
}
const $f7f18ba87194b6fe$var$firstName = (factFind, ownership)=>{
    if (ownership === 'partner' && factFind?.partner?.firstName) return String(factFind.partner.firstName);
    return String(factFind?.client?.firstName || 'you');
};
/** One piece's title, lower-cased after the first so pieces can be joined into one sentence. */ function $f7f18ba87194b6fe$var$pieceTitle(c, factFind) {
    const isCouple = factFind?.adviceFor === 'couple';
    switch(c.type){
        case 'gifting':
            return `Give ${$f7f18ba87194b6fe$var$money(c.amount)} to family`;
        case 'funeralBonds':
            return isCouple ? `Prepay both funerals with ${$f7f18ba87194b6fe$var$money(c.amount)} of funeral bonds` : `Prepay the funeral with a ${$f7f18ba87194b6fe$var$money(c.amount)} funeral bond`;
        case 'annuity':
            {
                const who = $f7f18ba87194b6fe$var$firstName(factFind, c.ownership);
                return `Buy a ${$f7f18ba87194b6fe$var$money(c.purchaseAmount)} lifetime income for ${who}`;
            }
        case 'upgrade':
            // A plan built by hand names the dearer home it moves to.
            if (c.newHomeValue != null && c.equityAmount == null) return `Sell and buy a dearer ${$f7f18ba87194b6fe$var$money(c.newHomeValue)} home`;
            return `Spend ${$f7f18ba87194b6fe$var$money(c.equityAmount ?? c.renovationAmount)} on the home`;
        case 'increaseHomeEquity':
        case 'renovate':
            return `Spend ${$f7f18ba87194b6fe$var$money(c.equityAmount ?? c.renovationAmount)} on the home`;
        case 'downsize':
            {
                const d = c.downsizeDetails || {};
                const base = `Sell and buy a ${$f7f18ba87194b6fe$var$money(c.newHomeValue)} home`;
                if (d.repayDebt) return `${base}, and pay off a debt`;
                if (d.useDownsizer && d.commenceIncomeStream) return `${base}, and start a pension with the downsizer money`;
                if (d.useDownsizer) return `${base}, and put the downsizer amount into super`;
                return base;
            }
        case 'debtRepayment':
            {
                const what = String(c.liabilityDescription || 'the debt').trim();
                const full = !/partial/i.test(String(c.name || ''));
                return full ? `Pay off the ${what}` : `Pay half of the ${what}`;
            }
        case 'reverseMortgage':
            return `Borrow ${$f7f18ba87194b6fe$var$money(c.loanAmount)} against the home`;
        case 'heas':
            return `Take ${$f7f18ba87194b6fe$var$money(c.paymentAmount)} a ${c.paymentFrequency === 'monthly' ? 'month' : 'fortnight'} from the Home Equity Access Scheme`;
        case 'sellEntityInvestmentProperty':
            return String(c.name || 'Sell the investment property').replace(/\s*\(entity pool\)\s*$/i, '');
        default:
            return String(c.name || 'This plan');
    }
}
function $f7f18ba87194b6fe$var$pieceTreatment(c) {
    switch(c.type){
        case 'gifting':
            return 'Gifts within the yearly free limits stop being counted; anything above them still counts for five years.';
        case 'funeralBonds':
            return 'A funeral bond up to the allowed amount is not counted in either means test.';
        // The assessment in full, and what comes back (owner, 20 Oct 2026: "60% for the first years" was too loose).
        case 'annuity':
            {
                const counted = 'Centrelink counts 60% of the price for the first five years, or until age 85 if that is later, and 30% after that, and 60% of each payment as income';
                if (/guaranteed/i.test(String(c.name || ''))) return `${counted}; the full price comes back to the estate whenever death comes.`;
                return c.residualCapital === 1 ? `${counted}; the full price comes back to the estate for the first half of the life expectancy period, then a falling amount.` : `${counted}; nothing comes back to the estate.`;
            }
        case 'increaseHomeEquity':
        case 'renovate':
        case 'upgrade':
            // Saved with the chosen plan and read in either voice, so it names nobody (owner, 21 Oct 2026).
            return 'The home lived in is left out of both means tests, so the money spent on it stops being counted.';
        case 'downsize':
            return 'The money left after buying the new home is counted in full, unless it goes into super or a pension.';
        case 'debtRepayment':
            return 'Less cash is counted, and the repayments and interest stop.';
        case 'reverseMortgage':
            return 'The loan money is counted while it sits in the bank; the loan and its interest are repaid from the home when it is sold.';
        case 'heas':
            return 'The payments are not counted as income; the loan and its interest are repaid from the home when it is sold.';
        default:
            return null;
    }
}
function $f7f18ba87194b6fe$export$caaafd80ea6c3706(config) {
    const c = config || {};
    const steps = c.type === 'combination' && Array.isArray(c.steps) ? c.steps : [
        c
    ];
    const kinds = [];
    for (const s of steps)switch(s.type){
        case 'gifting':
            kinds.push('gift');
            break;
        case 'funeralBonds':
            kinds.push('funeralBond');
            break;
        case 'annuity':
            {
                const name = String(s.name || '').toLowerCase();
                kinds.push(s.annuityType === 'guaranteed' || name.includes('guaranteed') ? 'annuityGuaranteed' : (Number(s.residualCapital) || 0) > 0 || name.includes('capital returned') ? 'annuityReturned' : 'annuityNil');
                break;
            }
        case 'increaseHomeEquity':
        case 'renovate':
        case 'upgrade':
            kinds.push('renovate');
            break;
        case 'downsize':
            {
                const d = s.downsizeDetails || {};
                kinds.push('sellHome');
                if (d.useDownsizer) kinds.push('superContribution');
                if (d.useDownsizer && d.commenceIncomeStream) kinds.push('accountBasedPension');
                if (d.repayDebt) kinds.push('clearDebt');
                break;
            }
        case 'debtRepayment':
            kinds.push('clearDebt');
            break;
        case 'reverseMortgage':
            kinds.push('reverseMortgage');
            break;
        case 'heas':
            kinds.push('heas');
            break;
        case 'sellEntityInvestmentProperty':
            kinds.push('sellInvestmentProperty');
            break;
        default:
            break;
    }
    return kinds;
}
function $f7f18ba87194b6fe$export$743d9d8d57ca17a8(config, factFind, fallbackName) {
    const c = config || {};
    if (c.type === 'combination' && Array.isArray(c.steps) && c.steps.length > 0) {
        const titles = c.steps.map((s)=>$f7f18ba87194b6fe$var$pieceTitle(s, factFind));
        const title = titles.map((t, i)=>i === 0 ? t : t.charAt(0).toLowerCase() + t.slice(1)).join(titles.length > 2 ? ', ' : ' and ');
        const finalTitle = titles.length > 2 ? title.replace(/, ([^,]*)$/, ', and $1') : title;
        const funding = c.steps.map((s)=>$f7f18ba87194b6fe$export$c74117914526c5e0(s, factFind)).filter(Boolean)[0] || '';
        const treatment = c.steps.map($f7f18ba87194b6fe$var$pieceTreatment).filter((t)=>Boolean(t));
        return {
            title: finalTitle,
            sub: funding,
            treatment: treatment
        };
    }
    if (!c.type || c.type === 'doNothing') return {
        title: fallbackName || 'Keep things as they are',
        sub: '',
        treatment: []
    };
    const treatment = $f7f18ba87194b6fe$var$pieceTreatment(c);
    const funding = $f7f18ba87194b6fe$export$c74117914526c5e0(c, factFind);
    const extra = c.type === 'annuity' ? c.annuityType === 'guaranteed' ? `The full amount comes back to the estate whenever ${$f7f18ba87194b6fe$var$firstName(factFind, c.ownership)} dies.` : c.residualCapital === 1 ? `Money comes back to the estate on an early death.` : `It pays while ${$f7f18ba87194b6fe$var$firstName(factFind, c.ownership)} lives; nothing comes back.` : '';
    return {
        title: $f7f18ba87194b6fe$var$pieceTitle(c, factFind),
        sub: [
            funding,
            extra
        ].filter(Boolean).join(' '),
        treatment: treatment ? [
            treatment
        ] : []
    };
}
function $f7f18ba87194b6fe$export$e0e75d1fdb5f788f(allocation, factFind) {
    const rows = Array.isArray(allocation) ? allocation : [];
    return rows.filter((r)=>r.assetType === 'accountBasedPensions' && Number(r.liquidatedAmount) > 0 && r.drawBefore != null).map((r)=>({
            name: $f7f18ba87194b6fe$export$3464ecd68a907088({
                type: 'accountBasedPensions',
                id: r.id,
                description: String(r.assetName || '')
            }, factFind),
            taken: Number(r.liquidatedAmount) || 0,
            before: Number(r.drawBefore) || 0,
            after: Number(r.drawAfter) || 0,
            closed: Number(r.remainingAmount) <= 0
        }));
}
function $f7f18ba87194b6fe$export$86fd7ba8b86f4a5e(original, planned) {
    const after = new Map((planned?.assets?.accountBasedPensions || []).map((a)=>[
            String(a.id),
            a
        ]));
    return (original?.assets?.accountBasedPensions || []).map((a)=>{
        const now = after.get(String(a.id));
        const was = Number(a.value) || 0;
        const left = now ? Number(now.value) || 0 : 0;
        return {
            name: $f7f18ba87194b6fe$export$3464ecd68a907088({
                type: 'accountBasedPensions',
                id: a.id,
                description: a.description
            }, original),
            taken: was - left,
            before: Number(a.income) || 0,
            after: now ? Number(now.income) || 0 : 0,
            closed: left <= 0
        };
    }).filter((c)=>c.taken >= 1);
}
/**
 * The plain-words line for each pension account the plan draws on (owner, 19 Oct 2026: keep the rule,
 * "the explainer should clearly outline what the system's done so it's clear to the user"). The rule:
 * once money is taken out, the account pays only the legal minimum each year; any year the income falls
 * short, the gap comes from savings in the settlement order (pack B.SU, B.PE.6).
 */ const $f7f18ba87194b6fe$var$SHORTFALL_ORDER = 'Any year the income then falls short, the gap is taken from savings in a set order: the bank accounts first, then the pension accounts, then super, then shares.';
function $f7f18ba87194b6fe$export$29c4d395a04f1ae(changes) {
    return changes.map((c)=>{
        const name = c.name.charAt(0).toUpperCase() + c.name.slice(1);
        if (c.closed) return {
            lead: `${name} is used up by the plan,`,
            body: `so the ${$f7f18ba87194b6fe$var$money(c.before)} a year it paid stops. ${$f7f18ba87194b6fe$var$SHORTFALL_ORDER}`
        };
        if (c.after >= c.before - 1) return {
            lead: `${name} keeps paying the legal minimum,`,
            body: `which on the balance left after ${$f7f18ba87194b6fe$var$money(c.taken)} comes out is ${$f7f18ba87194b6fe$var$money(c.after)} a year (it was ${$f7f18ba87194b6fe$var$money(c.before)}). ${$f7f18ba87194b6fe$var$SHORTFALL_ORDER}`
        };
        return {
            lead: `${name} drops to the legal minimum:`,
            body: `${$f7f18ba87194b6fe$var$money(c.taken)} comes out of it, so from then on it pays ${$f7f18ba87194b6fe$var$money(c.after)} a year instead of ${$f7f18ba87194b6fe$var$money(c.before)}. ${$f7f18ba87194b6fe$var$SHORTFALL_ORDER}`
        };
    });
}
const $f7f18ba87194b6fe$export$e7a4425e176e1876 = (factFind)=>(0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind).names;


/**
 * The chosen Support at home plan, as the plan page and Home read it (rebuild M2, 19 Oct 2026).
 *
 * When a plan is chosen — tested or built by hand — its card is stored on the record: the figures the
 * card showed, the figures the support alone gave at the time, the plan in words, what happens to each
 * pension account it draws on, and its risk kinds. The plan page shows and explains the plan from
 * this, so what the family reads there is exactly what they chose, with no re-run in between.
 */ 
function $b2a376f07fa94da4$export$5414d0f4d2450da0(card) {
    const slim = (f)=>f ? {
            ...f,
            pensionRows: [],
            cashFlowBreakdown: null
        } : null;
    return {
        ...card,
        plan: slim(card.plan),
        baseline: slim(card.baseline)
    };
}
function $b2a376f07fa94da4$export$7502afc44cd7bedc(list) {
    const hit = (list || []).find((s)=>s?.type === 'home_care' && s.chosen === true && s.inputs?.card);
    return hit ?? null;
}
function $b2a376f07fa94da4$export$6dd7380fe87e178c() {
    try {
        const raw = typeof window !== 'undefined' ? window.sessionStorage.getItem((0, $f58ff7d3c4c676c4$export$685490c2fa387b9a)) : null;
        const list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? $b2a376f07fa94da4$export$7502afc44cd7bedc(list) : null;
    } catch  {
        return null;
    }
}
const $b2a376f07fa94da4$export$23aa2da4fbf35540 = 'careCompanionSahStartFresh';
const $b2a376f07fa94da4$export$c2a82114dfa84ddf = 'careCompanionSahHubIntent';
function $b2a376f07fa94da4$export$f1a0b038e6da6256(intent) {
    try {
        if (intent) window.sessionStorage.setItem($b2a376f07fa94da4$export$c2a82114dfa84ddf, JSON.stringify(intent));
        else window.sessionStorage.removeItem($b2a376f07fa94da4$export$c2a82114dfa84ddf);
    } catch  {}
}
function $b2a376f07fa94da4$export$bad8c6138a257ba6() {
    try {
        const raw = window.sessionStorage.getItem($b2a376f07fa94da4$export$c2a82114dfa84ddf);
        window.sessionStorage.removeItem($b2a376f07fa94da4$export$c2a82114dfa84ddf);
        return raw ? JSON.parse(raw) : null;
    } catch  {
        return null;
    }
}




/**
 * The household once the chosen aged care plan has been carried out (owner, 24 Oct 2026: carry the whole
 * aged care plan into Support at Home). Rebuilt over the calculation API with the aged care module's own
 * code (sahLinkedPosition → features/forms/planPosition.ts), so a screen waits for it (`ready`) before it
 * prices anything — never the deposit-only household first and the real one a moment later.
 */ 
var $acw62 = parcelRequire("acw62");

/** What the position depends on: the plan, and the parts of the profile a plan changes. */ const $1daac60e43adbfd2$var$positionKey = (factFind, linkedRecord)=>{
    if (!linkedRecord) return 'none';
    const f = factFind || {};
    return JSON.stringify([
        linkedRecord,
        f.adviceFor,
        f.client,
        f.partner,
        f.home,
        f.assets,
        f.liabilities,
        f.income,
        f.expenses,
        f.structures
    ]);
};
function $1daac60e43adbfd2$export$a8613b2591a1f51b(factFind, linkedRecord) {
    const key = $1daac60e43adbfd2$var$positionKey(factFind, linkedRecord);
    const [state, setState] = (0, $acw62.useState)({
        positioned: null,
        caveats: [],
        ready: !linkedRecord,
        key: linkedRecord ? '' : 'none'
    });
    (0, $acw62.useEffect)(()=>{
        if (!linkedRecord) {
            setState({
                positioned: null,
                caveats: [],
                ready: true,
                key: key
            });
            return undefined;
        }
        let cancelled = false;
        setState((s)=>({
                ...s,
                ready: false
            }));
        const timer = setTimeout(()=>{
            (0, $5ea55f03cd2af1e4$export$52b55e2d4cc3fb71)(factFind, linkedRecord).then((r)=>{
                if (!cancelled) setState({
                    positioned: r.factFind,
                    caveats: r.caveats,
                    reason: r.reason,
                    ready: true,
                    key: key
                });
            }).catch(()=>{
                if (!cancelled) setState({
                    positioned: null,
                    caveats: [],
                    reason: 'The aged care plan could not be rebuilt just now, so only its deposit is applied.',
                    ready: true,
                    key: key
                });
            });
        }, 250);
        return ()=>{
            cancelled = true;
            clearTimeout(timer);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        key
    ]);
    // A result for an older plan or profile is not this one's.
    return {
        positioned: state.positioned,
        caveats: state.caveats,
        reason: state.reason,
        ready: state.ready && state.key === key
    };
}
function $1daac60e43adbfd2$export$30bb3bcf0a6c6a50(factFind, savedStrategies) {
    const record = (0, $acw62.useMemo)(()=>(0, $5ea55f03cd2af1e4$export$12c4b1871639c9ac)(factFind) === 'yes' ? (0, $5ea55f03cd2af1e4$export$b164904e0d858bed)(savedStrategies) : null, [
        factFind,
        savedStrategies
    ]);
    const position = $1daac60e43adbfd2$export$a8613b2591a1f51b(factFind, record);
    return (0, $acw62.useMemo)(()=>{
        if (!record || !position.ready) return null;
        const ctx = (0, $5ea55f03cd2af1e4$export$a5165c78061d54fc)({
            factFind: factFind,
            savedStrategies: savedStrategies,
            positioned: position.positioned
        });
        return {
            record: record,
            details: ctx.linked,
            before: factFind,
            after: ctx.baselineFactFind,
            whole: !!position.positioned,
            caveats: position.caveats,
            reason: position.reason
        };
    }, [
        record,
        position,
        factFind,
        savedStrategies
    ]);
}



/**
 * "If care needs increase" (rebuild M4, 19 Oct 2026; review decision 7, the mock-up's j1-08b; pack
 * B.SAH.7). Two things that often happen later, each tested with the plan's choices still in place,
 * against the support alone under the same change: the person's needs step up a classification, and they
 * move into residential care. For the person whose aged care is on file first; a default year 3 the
 * family can change; information only — it never changes which plan leads.
 *
 * Priced on the same household and options as the plan's card (sahEngineContext.ts). A plan built by
 * hand sends its own position (`planFactFind`) and is tested as "change nothing further".
 */ 

var $acw62 = parcelRequire("acw62");









const $16690ef87f6b41eb$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(n)));
const $16690ef87f6b41eb$var$yearWords = (cf)=>cf < 0 ? `short ${$16690ef87f6b41eb$var$money(cf)}` : `${$16690ef87f6b41eb$var$money(cf)} to spare`;
const $16690ef87f6b41eb$var$classWords = (level)=>{
    const label = level ? String((0, $c220d08b55e5dd64$export$bfae9591cc0d7897)[level]?.label || '') : '';
    return label.match(/classification\s*(\d+)/i)?.[1] ?? '';
};
const $16690ef87f6b41eb$var$Pair = ({ label: label, sub: sub, plan: plan, nothing: nothing, bold: bold = false })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `flex items-start justify-between gap-6 ${bold ? 'mt-1 border-t-2 border-brand-navy pt-3.5' : 'border-b border-slate-100 py-3'}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "min-w-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: bold ? 'text-[16px] font-bold text-brand-navy' : 'text-[15px] text-slate-800',
                        children: label
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-0.5 text-[13px] text-slate-500",
                        children: sub ?? "with this plan \xb7 with the support alone"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: `shrink-0 text-right tabular-nums ${bold ? 'text-[17px] font-bold text-brand-navy' : 'text-[15px] font-semibold text-slate-900'}`,
                children: [
                    plan,
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-normal text-slate-400",
                        children: "\xb7"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-normal text-slate-500",
                        children: nothing
                    })
                ]
            })
        ]
    });
const $16690ef87f6b41eb$var$SahCareUpDialog = ({ factFind: factFind, setFactFind: setFactFind, servicePlan: servicePlan, years: years, supportStartDate: supportStartDate, savedStrategies: savedStrategies, planTitle: planTitle, strategyConfig: strategyConfig, planFactFind: planFactFind = null, onClose: onClose })=>{
    // Already moving (step 1: "Yes"): the move is in every figure, so the step up is for the one at home.
    const alreadyMoving = (0, $5ea55f03cd2af1e4$export$12c4b1871639c9ac)(factFind) === 'yes';
    const entering = (0, $5ea55f03cd2af1e4$export$2205ffc60cf2c238)(factFind) ?? 'client';
    const person = alreadyMoving ? entering === 'client' ? 'partner' : 'client' : entering;
    const other = person === 'client' ? 'partner' : 'client';
    const name = (k)=>String((k === 'client' ? factFind?.client?.firstName : factFind?.partner?.firstName) || (k === 'client' ? 'the client' : 'the partner'));
    const isCouple = factFind?.adviceFor === 'couple';
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const savedYear = Number(factFind?.goals?.sahCareUpYear) || 3;
    const [year, setYearState] = (0, $acw62.useState)(Math.max(1, Math.min(years, savedYear)));
    const setYear = (y)=>{
        setYearState(y);
        setFactFind?.((prev)=>({
                ...prev,
                goals: {
                    ...prev?.goals || {},
                    sahCareUpYear: y
                }
            }));
    };
    // Already moving: priced on the whole aged care plan carried out, as steps 1 and 2 are (24 Oct 2026).
    const position = (0, $1daac60e43adbfd2$export$a8613b2591a1f51b)(factFind, alreadyMoving ? (0, $5ea55f03cd2af1e4$export$b164904e0d858bed)(savedStrategies) : null);
    const ctx = (0, $acw62.useMemo)(()=>(0, $5ea55f03cd2af1e4$export$a5165c78061d54fc)({
            factFind: factFind,
            savedStrategies: savedStrategies,
            supportStartDate: supportStartDate,
            positioned: position.positioned
        }), [
        factFind,
        savedStrategies,
        supportStartDate,
        position.positioned
    ]);
    const linked = (0, $acw62.useMemo)(()=>{
        const record = (0, $5ea55f03cd2af1e4$export$b164904e0d858bed)(savedStrategies);
        const d = record ? (0, $87af0cc4cc4e8984$export$2fdaec60121ed226)(record) : null;
        if (!d) return null;
        return {
            radFunding: d.radFunding || null,
            radPaid: Number(d.radPaid) || 0,
            annualCost: Number(d.annualCost) || 0,
            livingExpenses: d.livingExpenses ?? null,
            residencyOverrides: (0, $5ea55f03cd2af1e4$export$6d4a478abfb618cb)(d, factFind)
        };
    }, [
        savedStrategies,
        factFind
    ]);
    const [result, setResult] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        setResult(null);
        setError(null);
        if (!position.ready) return ()=>{
            cancelled = true;
        };
        $55a1d8a64f1e5dfa$export$6b5b0c38f513b6f3({
            factFind: ctx.baselineFactFind,
            servicePlan: (0, $5ea55f03cd2af1e4$export$fe04ad50cd2b5dad)(servicePlan, factFind),
            legacyYears: years,
            strategyConfig: strategyConfig ?? {
                type: 'doNothing',
                name: 'Do Nothing'
            },
            event: {
                person: person,
                year: year
            },
            linked: alreadyMoving ? null : linked,
            evaluationOptions: ctx.evaluationOptions,
            // Sent only for a plan built by hand: the request schema checks it as a household.
            ...planFactFind ? {
                planFactFind: planFactFind
            } : {}
        }).then((r)=>{
            if (!cancelled) setResult(r);
        }).catch(()=>{
            if (!cancelled) setError('These tests could not be run just now.');
        });
        return ()=>{
            cancelled = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        year,
        position.ready,
        position.positioned
    ]);
    const s = result?.stepUp;
    const personHasServices = Object.values((0, $5ea55f03cd2af1e4$export$fe04ad50cd2b5dad)(servicePlan, factFind)?.[person] || {}).some((d)=>Number(d?.quantity) > 0);
    const m = result?.move;
    const yearPicker = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
        className: "ml-1 inline-flex items-center gap-1 text-[13px]",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "sr-only",
                children: "The year"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                value: year,
                onChange: (e)=>setYear(Number(e.target.value)),
                className: "rounded border border-slate-300 bg-white px-1.5 py-0.5 text-[13px]",
                "data-testid": "sah-careup-year",
                children: Array.from({
                    length: years
                }, (_v, i)=>i + 1).map((y)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                        value: y,
                        children: [
                            "year ",
                            y
                        ]
                    }, y))
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
        titleId: "sah-careup-heading",
        testId: "sah-careup",
        eyebrow: planTitle,
        title: "If care needs increase",
        intro: "Two things that often happen later. Each is tested with this plan's choices still in place, against the support alone under the same change. The year can be changed.",
        onClose: onClose,
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
            type: "button",
            variant: "primary",
            onClick: onClose,
            children: "Got it"
        }),
        children: [
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[14px] text-rose-700",
                role: "alert",
                children: error
            }),
            !result && !error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[14px] text-slate-600",
                children: "Running the two tests\u2026"
            }),
            result && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        "data-testid": "sah-careup-stepup",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1c6c21ec44833357$export$cb63b5f03a3ae2c6), {
                                children: [
                                    name(person),
                                    "'s needs step up in ",
                                    yearPicker
                                ]
                            }),
                            s?.plan?.applicable && !personHasServices ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-2 text-[14px] text-slate-600",
                                "data-testid": "sah-careup-no-services",
                                children: [
                                    name(person),
                                    " has no services in the plan yet, so a step up changes nothing here. Add ",
                                    name(person),
                                    "'s services on step 1 and this test prices the bigger classification."
                                ]
                            }) : s?.plan?.applicable ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-2 text-[13px] leading-relaxed text-slate-600",
                                        children: [
                                            "Classification ",
                                            $16690ef87f6b41eb$var$classWords(s.plan.from),
                                            " to ",
                                            $16690ef87f6b41eb$var$classWords(s.plan.to),
                                            ": a budget of ",
                                            $16690ef87f6b41eb$var$money(s.plan.newBudget),
                                            " a year, services scaled up to match it, the same contribution rates, and anything above the budget at full price. Their yearly cost goes from ",
                                            $16690ef87f6b41eb$var$money(s.plan.yearlyBefore),
                                            " to ",
                                            $16690ef87f6b41eb$var$money(s.plan.yearlyAfter),
                                            " with this plan."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($16690ef87f6b41eb$var$Pair, {
                                        label: "Each year after the change",
                                        plan: $16690ef87f6b41eb$var$yearWords(s.plan.cashflowAfter),
                                        nothing: $16690ef87f6b41eb$var$yearWords(s.doNothing.cashflowAfter)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($16690ef87f6b41eb$var$Pair, {
                                        label: `Left to the family after ${years} years`,
                                        plan: $16690ef87f6b41eb$var$money(s.plan.legacy),
                                        nothing: $16690ef87f6b41eb$var$money(s.doNothing.legacy)
                                    }),
                                    s.plan.lifetimeLimitYear != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-2 text-[13px] text-slate-600",
                                        children: [
                                            "The lifetime limit on contributions is reached in year ",
                                            s.plan.lifetimeLimitYear,
                                            "; after that they pay only for services above the budget."
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-2 text-[14px] text-slate-600",
                                children: s?.plan?.reason === 'highest' ? `${name(person)} is already at the highest classification, so there is no step up to test.` : `${name(person)} has no classification recorded, so a step up cannot be priced.`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        "data-testid": "sah-careup-move",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$cb63b5f03a3ae2c6), {
                                children: alreadyMoving ? `${name(entering)}'s move into residential care` : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        name(person),
                                        " moves into residential care in ",
                                        yearPicker
                                    ]
                                })
                            }),
                            alreadyMoving ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-2 text-[14px] text-slate-600",
                                children: [
                                    name(entering),
                                    "'s move is already in every figure (step 1 says ",
                                    name(entering),
                                    " is moving), so there is nothing further to test here."
                                ]
                            }) : m?.plan?.applicable ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-2 text-[13px] leading-relaxed text-slate-600",
                                        children: [
                                            "Priced on ",
                                            name(person),
                                            "'s chosen aged care plan: its deposit, living costs and yearly fees",
                                            isCouple ? `, with ${name(other)} staying at home with support and the two of ${v.them} assessed as an illness-separated couple from the move` : '',
                                            "."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($16690ef87f6b41eb$var$Pair, {
                                        label: `Can ${v.they} pay the room deposit without selling anything?`,
                                        sub: `${$16690ef87f6b41eb$var$money(m.plan.cashAtMove)} in the bank at the move, against a ${$16690ef87f6b41eb$var$money(m.plan.deposit)} deposit. With the support alone: ${$16690ef87f6b41eb$var$money(m.doNothing.cashAtMove)}.`,
                                        plan: m.plan.canPayFromCash ? 'Yes' : 'No',
                                        nothing: m.doNothing.canPayFromCash ? 'yes' : 'no'
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($16690ef87f6b41eb$var$Pair, {
                                        label: "Each year after the move",
                                        plan: $16690ef87f6b41eb$var$yearWords(m.plan.cashflowAfter),
                                        nothing: $16690ef87f6b41eb$var$yearWords(m.doNothing.cashflowAfter)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($16690ef87f6b41eb$var$Pair, {
                                        bold: true,
                                        label: `Left to the family after ${years} years`,
                                        plan: $16690ef87f6b41eb$var$money(m.plan.legacy),
                                        nothing: $16690ef87f6b41eb$var$money(m.doNothing.legacy)
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-2 text-[14px] text-slate-600",
                                children: [
                                    "Choose ",
                                    name(person),
                                    "'s aged care plan first; this test is priced on its room, deposit and fees."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[13px] text-slate-500",
                        children: "This is for information. It does not change which plan leads."
                    })
                ]
            })
        ]
    });
};
var $16690ef87f6b41eb$export$2e2bcd8739ae039 = $16690ef87f6b41eb$var$SahCareUpDialog;



/**
 * Step 3's plans — Support at home on the aged care spine (rebuild, 19 Oct 2026; the agreed mock-up's
 * plans screen, j1-plans).
 *
 *  - The chosen-plan banner, when one is chosen.
 *  - The four numbers from step 2 as a strip, the comparison every card is read against.
 *  - "What matters most to Colin and Shelly?" — the four goals; choosing one never re-runs the engine.
 *  - The cards RANKED BY THE GOAL SELECTED (owner, 18 Oct 2026: the mock-up first showed the
 *    pension and cashflow leaders under "best estate"). Where another goal is led by a different
 *    plan, one line says so and switches to it.
 *  - Each card: the plan in words, the estate figure, their contribution / Age Pension / each year with
 *    "why?", the rate change on the card face (decision 4, 19 Oct: paying less for the care IS the
 *    rates falling), Explain this / What could go wrong / Choose this plan, and the old detail behind
 *    "Show the detail".
 *  - The ways on: compare, every way tested, things that change the answer, build a plan yourself.
 *
 * Presentation only. Every figure is the engine row's own.
 */ 

var $acw62 = parcelRequire("acw62");







const $f8ee565b442c040e$export$40de0448f2611c56 = 'Near-best alternative';
const $f8ee565b442c040e$var$DO_NOTHING_NAME = 'Do Nothing';
function $f8ee565b442c040e$var$isBaselineStrategy(strategy) {
    return strategy?.name === $f8ee565b442c040e$var$DO_NOTHING_NAME || strategy?.config?.type === 'doNothing';
}
function $f8ee565b442c040e$var$getNetCashflow(strategy) {
    const s = strategy?.snapshot;
    return s?.netCashflow ?? s?.cashflow ?? s?.cashFlow ?? -Infinity;
}
function $f8ee565b442c040e$var$getPension(strategy) {
    const s = strategy?.snapshot;
    return s?.pension ?? s?.agePension ?? 0;
}
function $f8ee565b442c040e$var$getLegacyValue(strategy) {
    return strategy?.snapshot?.legacyValue ?? -Infinity;
}
function $f8ee565b442c040e$export$b0fdc0ae401721a1(strategy, doNothingStrategy, dimension) {
    if (!doNothingStrategy?.snapshot || $f8ee565b442c040e$var$isBaselineStrategy(strategy)) return false;
    const s = strategy?.snapshot || {};
    if (dimension === 'legacy') {
        if (typeof s.legacyImprovement === 'number') return s.legacyImprovement > 0;
        return $f8ee565b442c040e$var$getLegacyValue(strategy) > $f8ee565b442c040e$var$getLegacyValue(doNothingStrategy);
    }
    if (dimension === 'cashflow') {
        if (typeof s.cashflowImprovement === 'number') return s.cashflowImprovement > 0;
        return $f8ee565b442c040e$var$getNetCashflow(strategy) > $f8ee565b442c040e$var$getNetCashflow(doNothingStrategy);
    }
    if (dimension === 'pension') // Goal leader = highest modelled Age Pension (absolute), not marginal increase only.
    return $f8ee565b442c040e$var$getPension(strategy) > $f8ee565b442c040e$var$getPension(doNothingStrategy);
    return true;
}
function $f8ee565b442c040e$export$3140a3b98e6384f2(strategies, doNothingStrategy = null, options = {}) {
    const universe = (strategies || []).filter((s)=>!$f8ee565b442c040e$var$isBaselineStrategy(s));
    if (universe.length === 0) return [];
    const legacyPool = doNothingStrategy ? universe.filter((s)=>$f8ee565b442c040e$export$b0fdc0ae401721a1(s, doNothingStrategy, 'legacy')) : universe;
    const cashflowPool = doNothingStrategy ? universe.filter((s)=>$f8ee565b442c040e$export$b0fdc0ae401721a1(s, doNothingStrategy, 'cashflow')) : universe;
    const pensionPool = doNothingStrategy ? universe.filter((s)=>$f8ee565b442c040e$export$b0fdc0ae401721a1(s, doNothingStrategy, 'pension')) : universe;
    const byLegacy = [
        ...doNothingStrategy ? legacyPool : universe
    ].sort((a, b)=>$f8ee565b442c040e$var$getLegacyValue(b) - $f8ee565b442c040e$var$getLegacyValue(a));
    // A near-tie is a tie: the plan that asks less leads it (planChoiceRule.ts, owner 20 Oct 2026).
    const bestLegacy = options.readings ? (0, $5a094123650e8adb$export$3ef36734776b870)(byLegacy, options.readings) : byLegacy[0];
    const cashflowUniverse = doNothingStrategy ? cashflowPool : universe;
    const bestCashflow = cashflowUniverse.length ? cashflowUniverse.reduce(// A tie (within a dollar) goes to the plan that leaves more (owner's file, 22 Oct 2026).
    (best, s)=>$f8ee565b442c040e$var$getNetCashflow(s) > $f8ee565b442c040e$var$getNetCashflow(best) + 1 || Math.abs($f8ee565b442c040e$var$getNetCashflow(s) - $f8ee565b442c040e$var$getNetCashflow(best)) < 1 && $f8ee565b442c040e$var$getLegacyValue(s) > $f8ee565b442c040e$var$getLegacyValue(best) + 1 ? s : best, cashflowUniverse[0]) : null;
    const pensionUniverse = doNothingStrategy ? pensionPool : universe;
    const bestPension = pensionUniverse.length ? pensionUniverse.reduce(// A tie (within a dollar) goes to the plan that leaves more: the same pension with the credit card also
    // paid off and more left to the family was beaten by list order (owner's file, 22 Oct 2026).
    (best, s)=>$f8ee565b442c040e$var$getPension(s) > $f8ee565b442c040e$var$getPension(best) + 1 || Math.abs($f8ee565b442c040e$var$getPension(s) - $f8ee565b442c040e$var$getPension(best)) < 1 && $f8ee565b442c040e$var$getLegacyValue(s) > $f8ee565b442c040e$var$getLegacyValue(best) + 1 ? s : best, pensionUniverse[0]) : null;
    const recommended = [];
    const add = (strategy, label, requireBeat = true)=>{
        if (!strategy?.name) return false;
        if (recommended.some((r)=>r.label === label)) return false;
        if (requireBeat && doNothingStrategy) {
            const dim = label.includes('Cashflow') ? 'cashflow' : label.includes('Pension') ? 'pension' : 'legacy';
            if (!$f8ee565b442c040e$export$b0fdc0ae401721a1(strategy, doNothingStrategy, dim)) return false;
        }
        recommended.push({
            label: label,
            strategy: strategy
        });
        return true;
    };
    /*
     * THE FOURTH GOAL, FIRST (owner, 24 Sep 2026): the best estate among the plans that still pay
     * the bills — or, failing that, whose shortfall the savings carry for the whole period — or,
     * failing that, the one that lasts longest, badged as such. It is the default chip in every
     * module, so it is ranked before the others and never has to beat do-nothing to exist: a client
     * who has decided to move still needs to know which plan carries them, even if none beats
     * staying put on the estate.
     */ const covered = (0, $400a08a42b233386$export$db04dcb0634643af)(universe, {
        cashflowTarget: options.cashflowTarget,
        readings: options.readings
    });
    if (covered?.strategy?.name) recommended.push({
        label: (0, $400a08a42b233386$export$920ad41b346ae01a),
        strategy: covered.strategy,
        cashflowCovered: covered.verdict
    });
    if (bestLegacy && add(bestLegacy, 'Optimal Legacy') && options.readings) {
        const ex = (0, $5a094123650e8adb$export$db12984b57d6f833)(byLegacy, bestLegacy, options.readings);
        if (ex) recommended[recommended.length - 1].lead = ex;
    }
    if (bestCashflow) add(bestCashflow, 'Optimal Cashflow');
    /*
     * The Age Pension goal has a leader only when a plan pays one. The next-best estate used to be put
     * under it when none did — a runner-up badged as the pension's best (it never passed the gate, but
     * aged care's copy did). With no pension, the goal says so instead (owner, 20 Oct 2026).
     */ if (bestPension && $f8ee565b442c040e$var$getPension(bestPension) > 0) add(bestPension, 'Optimal Age Pension');
    // A second card beside the estate leader, only for a real trade-off (planChoiceRule.ts).
    if (options.readings && bestLegacy) {
        const second = (0, $5a094123650e8adb$export$ab51b61210e311f4)(byLegacy, bestLegacy, options.readings, (a, b)=>a.name === b.name);
        if (second?.strategy?.name) recommended.push({
            label: $f8ee565b442c040e$export$40de0448f2611c56,
            strategy: second.strategy,
            second: second
        });
    }
    return recommended;
}
function $f8ee565b442c040e$export$ca5137fb416189aa(strategies, recommendedOptimalStrategies) {
    const labelsByName = new Map();
    (recommendedOptimalStrategies || []).forEach(({ label: label, strategy: strategy })=>{
        if (!strategy?.name || !label) return;
        const existing = labelsByName.get(strategy.name) || [];
        if (!existing.includes(label)) existing.push(label);
        labelsByName.set(strategy.name, existing);
    });
    return (strategies || []).map((s)=>({
            ...s,
            recommendationLabels: s.name && labelsByName.get(s.name)?.length ? labelsByName.get(s.name) : s.recommendationLabels
        }));
}
function $f8ee565b442c040e$export$cf9821b188ee27f0(recommendedOptimalStrategies, surface) {
    const label = surface === 'cashflow' ? 'Optimal Cashflow' : surface === 'pension' ? 'Optimal Age Pension' : surface === 'covered' ? (0, $400a08a42b233386$export$920ad41b346ae01a) : 'Optimal Legacy';
    return (recommendedOptimalStrategies || []).find((r)=>r.label === label && r.strategy?.name) ?? null;
}
function $f8ee565b442c040e$export$64e432c7e60d26e3(recommendedOptimalStrategies) {
    const byStrategyName = new Map();
    (recommendedOptimalStrategies || []).forEach((row)=>{
        const name = row?.strategy?.name;
        if (!name || !row.strategy) return;
        if (!byStrategyName.has(name)) {
            byStrategyName.set(name, {
                ...row.strategy,
                recommendationLabels: [
                    row.label
                ]
            });
            return;
        }
        const existing = byStrategyName.get(name);
        const labels = existing?.recommendationLabels || [];
        if (row.label && !labels.includes(row.label)) labels.push(row.label);
        byStrategyName.set(name, {
            ...existing,
            recommendationLabels: labels
        });
    });
    return Array.from(byStrategyName.values());
}




/**
 * What each Support at Home strategy IS, how it works, and what to weigh up — the ONE authoritative
 * narrative library, keyed by the engine's `config.type`.
 *
 * Two voices, one truth:
 *  - `what` / `how` / `consider` — the client-facing voice, rendered live in the insight panel when
 *    a suggestion-engine card is selected;
 *  - `soa` — the formal advice-document voice (benefits / risks / suitability), rendered in the
 *    Statement of Advice.
 * They live in one record per strategy so the screen and the SOA can never tell the client
 * different stories. The mechanics must match what the engine actually models (see
 * server/src/rest/calculation/suggestionEngine/supportAtHome.ts); if a strategy's modelling
 * changes, its explanation changes with it — and a test pins this library against the engine's
 * authoritative type list, so a new strategy type cannot ship without narrative.
 */ 


const $f6fa0c4ae572e255$export$db6db87c4063fbb3 = {
    doNothing: {
        what: "Keep everything as it is \u2014 no restructuring, no borrowing, no gifts. This is the baseline every other option is measured against.",
        how: [
            'Your Age Pension, contribution rates and cash flow stay exactly as they are today.',
            "It ranks well when your position is already strong \u2014 sometimes the honest answer is that the clever options don\u2019t beat it."
        ],
        consider: [
            "If your cash flow is negative, changing nothing means drawing down savings each year \u2014 check how long they last in the projections."
        ],
        soa: {
            description: 'Retain the current financial position without restructuring assets, borrowing against the home, or gifting. This baseline is the benchmark against which every alternative strategy in this document was measured.',
            benefits: [
                'No transaction costs, no loss of liquidity and no irreversible commitments.',
                'Your position remains fully flexible for future decisions, including future care needs.'
            ],
            risks: [
                'If annual cash flow is negative, savings are drawn down each year; the projections in this document show how the position evolves.',
                'Opportunities to improve Age Pension entitlement or reduce contribution rates remain unused.'
            ],
            suitability: 'Appropriate where the existing position already meets your income and estate objectives, or where the modelled benefit of the alternatives does not justify their costs and risks.'
        }
    },
    gifting: {
        what: "Give money to family now, within Centrelink\u2019s allowed limits, so it stops counting against your Age Pension.",
        how: [
            'Centrelink allows gifts of up to $10,000 per financial year (and $30,000 over five years) without penalty.',
            'The gifted amount leaves your assessable assets, which can lift your Age Pension and lower your contribution rates.'
        ],
        consider: [
            "You lose access to this money permanently \u2014 it\u2019s a real gift, not an accounting move.",
            "Anything above the limits is treated as a \u201Cdeprived asset\u201D and still counted against you for five years.",
            'Your estate is smaller by the gifted amount (though the family receives it earlier instead).'
        ],
        soa: {
            description: "Gift capital to family members within Centrelink\u2019s allowable disposal limits ($10,000 per financial year, $30,000 over a rolling five-year period), reducing assessable assets and deemed income.",
            benefits: [
                'Reduces assessable assets immediately, which can increase Age Pension entitlement and lower Support at Home contribution rates.',
                'Brings forward an intended bequest, allowing family to benefit while you can see it.'
            ],
            risks: [
                "Gifted funds are permanently inaccessible to you \u2014 this cannot be unwound if your circumstances change.",
                'Amounts above the allowable limits are assessed as deprived assets for five years from the date of the gift, delivering no means-test benefit.',
                'Your estate is reduced by the amount gifted.'
            ],
            suitability: 'Suited to clients with surplus liquid assets, a genuine intention to benefit family, and sufficient remaining reserves for contingencies including future care costs.'
        }
    },
    funeralBonds: {
        what: "Set money aside in a funeral bond \u2014 an investment Centrelink exempts from the assets test, up to the allowable limit.",
        how: [
            'The bond amount leaves your assessable assets, which can lift your Age Pension and lower your contribution rates.',
            'It also quietly pre-funds a real future cost.'
        ],
        consider: [
            "The money is locked until it\u2019s needed for funeral expenses \u2014 you can\u2019t draw it back out.",
            `Only amounts up to the allowable limit (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$aca3edb7cd7a3f17))} per person) are exempt.`
        ],
        soa: {
            description: 'Invest in a funeral bond up to the allowable exempt limit. The bond is excluded from the Centrelink assets test and pre-funds funeral expenses.',
            benefits: [
                'Reduces assessable assets within the exempt limit, which can increase Age Pension entitlement and lower contribution rates.',
                "Pre-funds a certain future expense, removing it from the estate\u2019s future obligations."
            ],
            risks: [
                'Funds are locked until required for funeral expenses and cannot be redeemed for other purposes.',
                'Only amounts up to the allowable limit per person are exempt; contributions above it gain no means-test benefit.',
                'Investment returns within funeral bonds are generally modest.'
            ],
            suitability: 'Suited to clients who intend to pre-fund funeral costs in any case and hold sufficient liquid reserves for other needs.'
        }
    },
    annuity: {
        what: 'Convert a lump sum into a lifetime income stream. Centrelink assesses only 60% of the purchase price as an asset (for the first five years, or until age 85 if that is later, and 30% after that), so your assessable assets fall while you keep receiving the money as income.',
        how: [
            'The purchase price leaves your investments; regular annuity payments arrive for life.',
            'The 40% asset-test discount can lift your Age Pension and lower your contribution rates.',
            'Only a portion of each payment counts as income under the income test.'
        ],
        consider: [
            "The purchase is generally irreversible \u2014 you trade access to the lump sum for the income.",
            "Your estate is usually lower: depending on the product, what\u2019s left for the family can be much less than the unspent lump sum would have been.",
            "Product terms (indexation, death benefits, withdrawal values) vary a lot \u2014 the model uses standard assumptions."
        ],
        soa: {
            description: 'Purchase a lifetime annuity with a portion of investible assets. Under current rules only 60% of the purchase price is assessed under the assets test (for the first five years, or until age 85 if that is later, and 30% after that), and only a portion of each payment is assessed as income.',
            benefits: [
                'Immediate 40% assets-test discount on the purchase price, which can increase Age Pension entitlement and lower contribution rates.',
                'Guaranteed income for life, independent of market performance.',
                'Concessional income-test treatment of payments.'
            ],
            risks: [
                'The purchase is generally irreversible; access to the capital is exchanged for the income stream.',
                "Estate value is typically reduced \u2014 death benefits vary by product and can be substantially less than the unspent capital would have been.",
                'Product features (indexation, guarantee periods, withdrawal values) vary between providers; the modelling uses standard assumptions and the chosen product must be assessed on its own terms.'
            ],
            suitability: 'Suited to clients seeking certainty of income and improved means-test outcomes who can commit capital permanently, with sufficient assets retained outside the annuity for liquidity.'
        }
    },
    renovate: {
        what: 'Spend savings improving the home you live in. Your home is exempt from the assets test, so money moved into it stops counting against your Age Pension.',
        how: [
            'The renovation amount leaves your bank account (assessable) and becomes home value (exempt).',
            'Lower assessable assets can lift your Age Pension and lower your contribution rates.',
            "You keep the value \u2014 it\u2019s in the house rather than the bank."
        ],
        consider: [
            "The money is no longer easy to reach: money in the home can\u2019t be spent day to day, and comes back only if the home is sold or borrowed against.",
            "A renovation doesn\u2019t always add its full cost to the home\u2019s market value."
        ],
        soa: {
            description: 'Apply liquid capital to improvements to the principal home. The principal home is exempt from the assets test, so capital moved into it ceases to be assessable.',
            benefits: [
                'Reduces assessable assets, which can increase Age Pension entitlement and lower contribution rates.',
                "Value is retained within your estate, in the home, and the improvements may also support remaining at home longer \u2014 the core objective of Support at Home."
            ],
            risks: [
                'Liquidity is permanently reduced; home equity cannot fund day-to-day expenses without borrowing or selling.',
                'Renovations do not reliably add their full cost to market value.',
                'If residential aged care is later required, means-tested treatment of the home differs and should be re-modelled at that time.'
            ],
            suitability: 'Suited to homeowners intending to remain at home long-term, with improvements that genuinely serve that goal, and sufficient liquidity retained for contingencies.'
        }
    },
    upgrade: {
        what: 'Sell your current home and buy a more expensive one, moving savings into the exempt family home.',
        how: [
            'The extra purchase cost leaves your assessable assets and becomes exempt home value.',
            'Lower assessable assets can lift your Age Pension and lower your contribution rates.'
        ],
        consider: [
            'Buying, selling and moving costs are real money gone.',
            'More of your wealth is tied up in one illiquid asset.'
        ],
        soa: {
            description: 'Sell the current principal home and purchase a more valuable one, converting assessable capital into exempt principal-home value.',
            benefits: [
                'Reduces assessable assets, which can increase Age Pension entitlement and lower contribution rates.',
                'Wealth is retained in the estate, in the new home.'
            ],
            risks: [
                'Transaction costs (agent fees, stamp duty, moving) are permanent losses.',
                'Concentration of wealth in a single illiquid asset increases exposure to the property market and reduces financial flexibility.',
                'The disruption of moving is material at older ages.'
            ],
            suitability: 'Suited to clients already intending to move, where the new home better serves long-term needs, and liquidity after the transaction remains adequate.'
        }
    },
    downsize: {
        what: 'Sell your home and buy a cheaper one, freeing up equity as cash.',
        how: [
            'The difference between the sale and the new home lands in your bank account, boosting your available money and income.',
            "Surplus proceeds become assessable and are deemed to earn income \u2014 so this usually REDUCES Age Pension while it improves cash on hand."
        ],
        consider: [
            "A lower Age Pension can also mean HIGHER Support at Home contribution rates \u2014 the model shows the net effect.",
            "Downsizer super contributions can shelter some proceeds, but super is assessable again once you\u2019re over pension age.",
            'Selling and moving costs, and the upheaval of moving, are part of the price.'
        ],
        soa: {
            description: 'Sell the principal home and purchase a lower-value property, releasing home equity as accessible capital.',
            benefits: [
                'Substantially improves liquidity and investment income, strengthening capacity to fund care and living costs.',
                'A home better matched to current needs can itself support remaining at home longer.'
            ],
            risks: [
                "Surplus proceeds become assessable and deemed, which typically reduces Age Pension entitlement and can raise Support at Home contribution rates \u2014 the modelling in this document shows the net effect.",
                'Downsizer superannuation contributions shelter proceeds only while under Age Pension age; superannuation is assessable once over it.',
                'Transaction and moving costs are permanent losses, and relocation is disruptive.'
            ],
            suitability: 'Suited to clients whose current home no longer fits their needs or whose liquidity is insufficient to fund care sustainably, and who accept the means-test consequences quantified in this document.'
        }
    },
    debtRepayment: {
        what: "Use savings to clear a debt. Money you use to pay off a loan is spent, but the loan\u2019s interest stops and your assessable assets fall.",
        how: [
            'The repayment leaves your bank account; the loan (and its repayments) disappear from your cash flow.',
            'Lower assessable assets can lift your Age Pension and lower your contribution rates.'
        ],
        consider: [
            "The money is gone from your accessible savings \u2014 make sure enough liquidity remains for emergencies.",
            "This wins when the loan\u2019s interest rate is high relative to what your savings earn \u2014 the ranking already weighs that."
        ],
        soa: {
            description: 'Apply liquid capital to extinguish an existing debt, removing its interest cost and repayments from cash flow while reducing assessable assets.',
            benefits: [
                "Immediate cash-flow improvement equal to the former repayments; a guaranteed after-tax \u201Creturn\u201D equal to the loan\u2019s interest rate.",
                'Reduces assessable assets, which can increase Age Pension entitlement and lower contribution rates.'
            ],
            risks: [
                'Liquidity is reduced by the repayment amount; sufficient reserves must remain for contingencies.',
                "Where the loan rate is low relative to investment returns, repayment can modestly reduce long-run wealth \u2014 the comparison in this document quantifies the trade for your actual loan."
            ],
            suitability: 'Suited to clients carrying debt at interest rates above their realistic investment return, with liquid assets comfortably exceeding the repayment.'
        }
    },
    reverseMortgage: {
        // The client voice is the central library's (owner, 24 Oct 2026: one explanation of each piece, everywhere).
        what: (0, $bc58a42a9518691f$export$42b49ca3282407b9).reverseMortgage.what,
        how: (0, $bc58a42a9518691f$export$42b49ca3282407b9).reverseMortgage.how,
        consider: (0, $bc58a42a9518691f$export$42b49ca3282407b9).reverseMortgage.worthKnowing,
        soa: {
            description: 'Establish a commercial reverse mortgage against the principal home, drawing a lump sum (or scheduled drawdowns) with no servicing obligation; interest capitalises and the loan is repaid when the home is sold or from the estate.',
            benefits: [
                'Unlocks home equity as accessible funds without selling or moving.',
                'No repayment obligation during the loan; statutory no-negative-equity protection applies.'
            ],
            risks: [
                "Interest compounds on a growing balance, materially reducing home equity and estate value over time \u2014 quantified in the projections in this document.",
                'Lump-sum proceeds held in financial assets are assessable and deemed, which can reduce Age Pension entitlement.',
                'Commercial interest rates are significantly higher than the government scheme (HEAS); product terms vary and require independent comparison.'
            ],
            suitability: 'Suited to clients needing a larger or more flexible draw than HEAS permits, who accept the compounding cost to the estate and have considered HEAS first.'
        }
    },
    heas: {
        // The client voice is the central library's (owner, 24 Oct 2026: one explanation of each piece, everywhere).
        what: (0, $bc58a42a9518691f$export$42b49ca3282407b9).heas.what,
        how: (0, $bc58a42a9518691f$export$42b49ca3282407b9).heas.how,
        consider: (0, $bc58a42a9518691f$export$42b49ca3282407b9).heas.worthKnowing,
        soa: {
            description: "Access the government\u2019s Home Equity Access Scheme, receiving regular fortnightly payments secured against the principal home at the scheme\u2019s interest rate (currently 3.95% p.a., compounding fortnightly).",
            benefits: [
                'Supplements income at the lowest available home-equity borrowing rate, with government administration.',
                'Payments are not assessed as income for the Age Pension means test and do not affect pension entitlement.',
                'Fully flexible: payments can be stopped, started or repaid at any time, with statutory no-negative-equity protection.'
            ],
            risks: [
                "Interest compounds against home equity, reducing the estate over time \u2014 the projections in this document quantify this for the modelled payment level.",
                'Combined Age Pension and HEAS payments are capped at 150% of the maximum pension rate, limiting the achievable draw.',
                "The scheme\u2019s interest rate is variable and set by the government; it may change."
            ],
            suitability: 'Suited to homeowners needing a modest, regular income supplement who wish to remain at home, accept a gradual reduction in estate value, and value flexibility and consumer protection over the larger sums available commercially.'
        }
    }
};
// The engine emits `increaseHomeEquity` as an alias of renovate (same modelling, generated name
// "Increase home equity ($X)") — both must resolve or that card gets no explanation.
$f6fa0c4ae572e255$export$db6db87c4063fbb3.increaseHomeEquity = $f6fa0c4ae572e255$export$db6db87c4063fbb3.renovate;



/**
 * Support at home's two plan dialogs, the same telling for an engine plan and a plan built by hand
 * (owner, 19 Oct 2026: Manual Control must share the engine's look and feel — "this was an omission
 * when you built the aged care module initially").
 *
 *  - SahCauseEffect: "Explain this" — numbered lines of what they do and what that does to the
 *    numbers, against the support alone, then the result under the navy rule. The aged care ledger.
 *  - SahFigurePopover: every "why?" on a card — one pop-over with pages (their contribution, the Age
 *    Pension, where the year's money goes), a Back that returns one step, and the year-by-year link.
 *
 * Both read a plain figures object, so neither knows whether the plan came from the engine.
 */ 

var $acw62 = parcelRequire("acw62");





/**
 * THE PLAN CARD'S CASHFLOW TILES ADD UP TO ITS NET (Support at home review, 18 Oct 2026).
 *
 * The card showed six tiles — Age Pension, investment income, living costs, the contribution, tax and
 * the net — and they added to $22,846 against a stated $2,277. Two things were missing:
 *
 *  - lines with no tile: rental expenses and loan repayments (and capital expenses, housing costs and
 *    the like when a file has them), which the engine's own breakdown lists;
 *  - the in-year movement. The net is the money the year actually paid, and the Age Pension in it is
 *    re-assessed every fortnight, while the tile shows the rate the year opened on.
 *
 * `cashflowNotOnTiles` is what the tiles leave out; `otherCashflowLines` itemises it from the engine's
 * breakdown, and names whatever is left as the change through the year, so the lines always close.
 */ function $5f877c9e754d58f9$export$8ef2fc8db3a6ec52(snapshot) {
    if (!snapshot) return 0;
    const tiles = (snapshot.pension || snapshot.agePension || 0) + (snapshot.abpIncome || 0) + (snapshot.rentalIncome || 0) + (snapshot.otherInvestmentIncome || 0) - (snapshot.livingExpenses || 0) - (snapshot.totalSupportAtHomeCosts || 0) - (snapshot.taxPayable ?? 0);
    return (snapshot.cashflow || 0) - tiles;
}
/** Lines the tiles already carry: income, the Age Pension, living costs, the care cost and tax. */ const $5f877c9e754d58f9$var$COVERED_BY_TILES = /^(Interest|Dividends|Rent \(property\)|Trust & Company|Other Investment|Investment Income|ABP Income|Age Pension|Less: Living Expenses|Less: Aged Care Costs|Less: .*Tax$|Add: .*Tax Refund$)/;
function $5f877c9e754d58f9$export$5ff6d8d52e3ad2be(breakdown, other) {
    const rows = [];
    if (Array.isArray(breakdown)) for (const line of breakdown){
        const value = Number(line?.value);
        if (line?.note || !line?.label || !Number.isFinite(value) || Math.abs(value) < 1) continue;
        if ($5f877c9e754d58f9$var$COVERED_BY_TILES.test(line.label)) continue;
        rows.push({
            label: line.label.replace(/^(Less|Add): /, ''),
            value: value
        });
    }
    const listed = rows.reduce((t, r)=>t + r.value, 0);
    const movement = other - listed;
    if (Math.abs(movement) >= 1) rows.push({
        label: 'Change through the year (what was paid, against the opening rates above)',
        value: movement
    });
    return rows;
}



const $ca9b5cdfbd99e645$var$num = (v)=>Number.isFinite(Number(v)) ? Number(v) : 0;
function $ca9b5cdfbd99e645$export$122bd92e883ab7c1(s) {
    const snap = s || {};
    const rates = snap.contributionRates;
    const b = snap.supportAtHomeCostsBreakdown;
    return {
        contribution: $ca9b5cdfbd99e645$var$num(snap.totalSupportAtHomeCosts),
        pension: $ca9b5cdfbd99e645$var$num(snap.pension ?? snap.agePension),
        cashflow: $ca9b5cdfbd99e645$var$num(snap.netCashflow ?? snap.cashflow),
        legacy: $ca9b5cdfbd99e645$var$num(snap.legacyValue),
        investmentIncome: $ca9b5cdfbd99e645$var$num(snap.abpIncome) + $ca9b5cdfbd99e645$var$num(snap.otherInvestmentIncome) + $ca9b5cdfbd99e645$var$num(snap.rentalIncome),
        rates: rates ? {
            independence: $ca9b5cdfbd99e645$var$num(rates.independence),
            everydayLiving: $ca9b5cdfbd99e645$var$num(rates.everydayLiving)
        } : null,
        breakdown: b ? {
            clinical: $ca9b5cdfbd99e645$var$num(b.clinical),
            independence: $ca9b5cdfbd99e645$var$num(b.independence),
            everydayLiving: $ca9b5cdfbd99e645$var$num(b.everydayLiving),
            independenceContribution: $ca9b5cdfbd99e645$var$num(b.independenceContribution),
            everydayContribution: $ca9b5cdfbd99e645$var$num(b.everydayContribution),
            privateExcess: $ca9b5cdfbd99e645$var$num(b.privateExcess)
        } : null,
        livingExpenses: $ca9b5cdfbd99e645$var$num(snap.livingExpenses),
        taxPayable: $ca9b5cdfbd99e645$var$num(snap.taxPayable),
        pensionRows: snap.agePensionBreakdown || [],
        cashFlowBreakdown: snap.cashFlowBreakdown
    };
}
const $ca9b5cdfbd99e645$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(n)));
const $ca9b5cdfbd99e645$var$pct = (r)=>`${+(r * 100).toFixed(1)}%`;
const $ca9b5cdfbd99e645$export$68e00db93a37b932 = ({ doSentence: doSentence, treatment: treatment, plan: plan, baseline: baseline, horizonYears: horizonYears, possessive: possessive = 'their', they: they = 'they', drawLines: drawLines = [], moneyStory: moneyStory = null, debtsNote: debtsNote = null, leverKinds: leverKinds = [] })=>{
    const lines = [];
    lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                className: "text-slate-900",
                children: doSentence
            }),
            treatment[0] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " ",
                    treatment[0]
                ]
            }) : null
        ]
    }));
    // The pension accounts it draws on drop to the minimum draw — said, not left to be discovered.
    drawLines.forEach((l)=>lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
            "data-testid": "sah-cause-effect-abp",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: l.lead
                }),
                " ",
                l.body
            ]
        })));
    if (baseline) {
        const dp = plan.pension - baseline.pension;
        lines.push(Math.abs(dp) < 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                className: "text-slate-900",
                children: [
                    $ca9b5cdfbd99e645$var$cap(possessive),
                    " Age Pension stays at ",
                    $ca9b5cdfbd99e645$var$money(plan.pension),
                    " a year."
                ]
            })
        }) : dp > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                    className: "text-slate-900",
                    children: [
                        "Less is counted, so ",
                        possessive,
                        " Age Pension rises"
                    ]
                }),
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$5354fc7cb2207caf), {
                    from: baseline.pension,
                    to: plan.pension,
                    unit: " a year",
                    better: "up"
                }),
                "."
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                    className: "text-slate-900",
                    children: [
                        "More is counted, so ",
                        possessive,
                        " Age Pension falls"
                    ]
                }),
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$5354fc7cb2207caf), {
                    from: baseline.pension,
                    to: plan.pension,
                    unit: " a year",
                    better: "up"
                }),
                "."
            ]
        }));
        const rb = baseline.rates, rp = plan.rates;
        const ratesMoved = rb && rp && (Math.abs(rp.independence - rb.independence) > 0.0005 || Math.abs(rp.everydayLiving - rb.everydayLiving) > 0.0005);
        const dc = plan.contribution - baseline.contribution;
        // Rates that move with no contribution to show (none paid either way) said nothing true: "falls from $0 to $0"
        // (owner-caught, 23 Oct 2026). Then the line is left out; where the contribution holds, it says so.
        const noContribution = baseline.contribution < 1 && plan.contribution < 1;
        if (ratesMoved && rb && rp && !noContribution) {
            const down = rp.independence + rp.everydayLiving < rb.independence + rb.everydayLiving;
            lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                        className: "text-slate-900",
                        children: [
                            "The same assessment ",
                            down ? 'lowers' : 'raises',
                            " ",
                            possessive,
                            " contribution for each hour"
                        ]
                    }),
                    " \u2014 getting out and about ",
                    $ca9b5cdfbd99e645$var$pct(rb.independence),
                    " \u2192 ",
                    $ca9b5cdfbd99e645$var$pct(rp.independence),
                    ", help around the house ",
                    $ca9b5cdfbd99e645$var$pct(rb.everydayLiving),
                    " \u2192 ",
                    $ca9b5cdfbd99e645$var$pct(rp.everydayLiving),
                    " \u2014 ",
                    Math.abs(dc) >= 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "so ",
                            possessive,
                            " contribution ",
                            dc <= 0 ? 'falls' : 'rises',
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$5354fc7cb2207caf), {
                                from: baseline.contribution,
                                to: plan.contribution,
                                unit: " a year",
                                better: "down"
                            }),
                            "."
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "but ",
                            possessive,
                            " contribution stays at ",
                            $ca9b5cdfbd99e645$var$money(plan.contribution),
                            " a year."
                        ]
                    })
                ]
            }));
        } else if (ratesMoved && noContribution) ;
        else if (Math.abs(dc) >= 1) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                    className: "text-slate-900",
                    children: [
                        $ca9b5cdfbd99e645$var$cap(possessive),
                        " contribution ",
                        dc < 0 ? 'falls' : 'rises'
                    ]
                }),
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$5354fc7cb2207caf), {
                    from: baseline.contribution,
                    to: plan.contribution,
                    unit: " a year",
                    better: "down"
                }),
                "."
            ]
        }));
        else lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                    className: "text-slate-900",
                    children: [
                        $ca9b5cdfbd99e645$var$cap(possessive),
                        " contribution stays at ",
                        $ca9b5cdfbd99e645$var$money(plan.contribution),
                        " a year"
                    ]
                }),
                " \u2014 the rates for each hour do not move."
            ]
        }));
        const di = plan.investmentIncome - baseline.investmentIncome;
        if (Math.abs(di) >= 100) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: di < 0 ? 'Less money stays invested, so investment income falls' : 'More money is invested, so investment income rises'
                }),
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$5354fc7cb2207caf), {
                    from: baseline.investmentIncome,
                    to: plan.investmentIncome,
                    unit: " a year",
                    better: "up"
                }),
                ".",
                di < 0 ? ' That is the cost of the plan.' : ''
            ]
        }));
        const baseShort = baseline.cashflow < 0;
        lines.push(plan.cashflow >= 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                    className: "text-slate-900",
                    children: [
                        "Put together, ",
                        they,
                        " have ",
                        $ca9b5cdfbd99e645$var$money(plan.cashflow),
                        " a year to spare"
                    ]
                }),
                " (with the support alone, ",
                baseShort ? `${$ca9b5cdfbd99e645$var$money(baseline.cashflow)} short` : `${$ca9b5cdfbd99e645$var$money(baseline.cashflow)} to spare`,
                ").",
                moneyStory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        " ",
                        moneyStory
                    ]
                }) : null
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                    className: "text-slate-900",
                    children: [
                        "Put together, ",
                        they,
                        " are ",
                        $ca9b5cdfbd99e645$var$money(plan.cashflow),
                        " a year short"
                    ]
                }),
                ", met from savings (with the support alone, ",
                baseShort ? `${$ca9b5cdfbd99e645$var$money(baseline.cashflow)} short` : `${$ca9b5cdfbd99e645$var$money(baseline.cashflow)} to spare`,
                ").",
                moneyStory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        " ",
                        moneyStory
                    ]
                }) : null
            ]
        }));
    } else if (moneyStory) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: moneyStory
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "sah-cause-effect",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6edaae094c27058f$export$c20faa40d0e6b131), {
                kinds: leverKinds,
                className: "mb-5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                className: "m-0 list-none p-0",
                children: [
                    lines.map((l, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            className: `grid grid-cols-[2.25rem_1fr] gap-x-2 border-b border-slate-200 py-4 text-[15px] leading-relaxed text-slate-700 ${i === 0 ? 'pt-0' : ''}`,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$8400747e4d4d02ee), {
                                    n: i + 1
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: l
                                })
                            ]
                        }, i)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        className: "grid grid-cols-[2.25rem_1fr] gap-x-2 border-t-2 border-brand-navy py-4 text-[15px] leading-relaxed text-slate-700",
                        "data-testid": "sah-cause-effect-result",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$ee12a877b5edba4b), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$48017952956cd475), {
                                horizonYears: horizonYears,
                                estate: plan.legacy,
                                baseEstate: baseline ? baseline.legacy : null,
                                baseWord: (0, $1a5a24a0286ded56$export$c9c6ca79dc334e31).word
                            })
                        ]
                    })
                ]
            }),
            treatment.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$cb63b5f03a3ae2c6), {
                        className: "mt-6",
                        children: "The pieces of this plan, and how the means tests treat each"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        className: "mt-2 space-y-2 text-[14px] leading-relaxed text-slate-700",
                        children: treatment.map((t, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                className: "border-b border-slate-100 pb-2",
                                children: t
                            }, i))
                    })
                ]
            }),
            debtsNote
        ]
    });
};
const $ca9b5cdfbd99e645$var$cap = (s)=>s.charAt(0).toUpperCase() + s.slice(1);
const $ca9b5cdfbd99e645$var$Row = ({ label: label, sub: sub, value: value, bold: bold = false, onWhy: onWhy })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `flex items-start justify-between gap-6 ${bold ? 'mt-1 border-t-2 border-brand-navy pb-1 pt-3.5' : 'border-b border-slate-100 py-3'}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "min-w-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: bold ? 'text-[16px] font-bold text-brand-navy' : 'text-[15px] text-slate-800',
                        children: label
                    }),
                    (sub || onWhy) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-0.5 text-[13px] leading-relaxed text-slate-500",
                        children: [
                            sub,
                            onWhy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: onWhy,
                                        className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-[3px] hover:decoration-brand-navy",
                                        children: "why?"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: `shrink-0 tabular-nums ${bold ? 'text-[18px] font-bold text-brand-navy' : 'text-[15px] font-semibold text-slate-900'}`,
                children: value
            })
        ]
    });
const $ca9b5cdfbd99e645$export$e203066bca492ea1 = ({ planTitle: planTitle, plan: plan, baseline: baseline, initialPage: initialPage, pensionWhy: pensionWhy, possessive: possessive = 'their', they: they = 'they', them: them = 'them', onYearByYear: onYearByYear, onClose: onClose })=>{
    const [page, setPageOnly] = (0, $acw62.useState)(initialPage);
    const [trail, setTrail] = (0, $acw62.useState)([]);
    const setPage = (next)=>{
        setTrail((t)=>[
                ...t,
                page
            ]);
        setPageOnly(next);
    };
    const goBack = ()=>{
        const prev = trail[trail.length - 1];
        if (prev == null) return;
        setTrail((t)=>t.slice(0, -1));
        setPageOnly(prev);
    };
    const pageName = (p)=>p === 'pension' ? 'the Age Pension' : p === 'contribution' ? `${possessive} contribution` : 'the year';
    const b = plan.breakdown;
    const r = plan.rates;
    const title = page === 'contribution' ? `Why ${possessive} contribution is ${$ca9b5cdfbd99e645$var$money(plan.contribution)} a year` : page === 'pension' ? `Why ${possessive} Age Pension is ${$ca9b5cdfbd99e645$var$money(plan.pension)} a year` : plan.cashflow < 0 ? `Where the ${$ca9b5cdfbd99e645$var$money(plan.cashflow)} shortfall comes from` : `Where the ${$ca9b5cdfbd99e645$var$money(plan.cashflow)} left over comes from`;
    const intro = page === 'contribution' ? `Each service costs what the provider charges. What ${they} pay is a percentage of each hour, set by the means test, on the services within the budget; anything above the budget is paid at full price.` : page === 'pension' ? pensionWhy : 'Money in, less money out, over a full year with this plan in place. When it is short, the gap comes out of savings.';
    const other = (0, $5f877c9e754d58f9$export$8ef2fc8db3a6ec52)({
        pension: plan.pension,
        otherInvestmentIncome: plan.investmentIncome,
        livingExpenses: plan.livingExpenses,
        totalSupportAtHomeCosts: plan.contribution,
        taxPayable: plan.taxPayable,
        cashflow: plan.cashflow
    });
    const otherRows = Math.abs(other) >= 1 ? (0, $5f877c9e754d58f9$export$5ff6d8d52e3ad2be)(plan.cashFlowBreakdown, other) : [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
        titleId: "sah-figure-heading",
        testId: "sah-figure-popover",
        zIndex: 60,
        eyebrow: planTitle,
        back: trail.length ? {
            label: `Back to ${pageName(trail[trail.length - 1])}`,
            onClick: goBack
        } : null,
        title: title,
        intro: intro,
        onClose: onClose,
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                onYearByYear && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: onYearByYear,
                    className: "mr-auto text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy",
                    "data-testid": "sah-figure-year-by-year",
                    children: "See the year-by-year figures"
                }),
                trail.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                    type: "button",
                    variant: "secondary",
                    onClick: goBack,
                    children: "\u2039 Back"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                    type: "button",
                    variant: "primary",
                    onClick: onClose,
                    children: "Got it"
                })
            ]
        }),
        children: [
            page === 'contribution' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                "data-testid": "sah-figure-contribution",
                children: [
                    b ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1c6c21ec44833357$export$cb63b5f03a3ae2c6), {
                                children: [
                                    "Free to ",
                                    them,
                                    " within the budget"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca9b5cdfbd99e645$var$Row, {
                                label: "Nursing and personal care",
                                sub: `${$ca9b5cdfbd99e645$var$money(b.clinical)} of services`,
                                value: "$0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$cb63b5f03a3ae2c6), {
                                className: "mt-6",
                                children: "Getting out and about"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca9b5cdfbd99e645$var$Row, {
                                label: "Social support, transport and similar",
                                sub: r ? `${$ca9b5cdfbd99e645$var$money(b.independence)} of services at ${$ca9b5cdfbd99e645$var$pct(r.independence)} of each hour${baseline?.rates ? ` (with the support alone, ${$ca9b5cdfbd99e645$var$pct(baseline.rates.independence)})` : ''}` : `${$ca9b5cdfbd99e645$var$money(b.independence)} of services`,
                                value: $ca9b5cdfbd99e645$var$money(b.independenceContribution)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$cb63b5f03a3ae2c6), {
                                className: "mt-6",
                                children: "Help around the house"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca9b5cdfbd99e645$var$Row, {
                                label: "Cleaning, meals and similar",
                                sub: r ? `${$ca9b5cdfbd99e645$var$money(b.everydayLiving)} of services at ${$ca9b5cdfbd99e645$var$pct(r.everydayLiving)} of each hour${baseline?.rates ? ` (with the support alone, ${$ca9b5cdfbd99e645$var$pct(baseline.rates.everydayLiving)})` : ''}` : `${$ca9b5cdfbd99e645$var$money(b.everydayLiving)} of services`,
                                value: $ca9b5cdfbd99e645$var$money(b.everydayContribution)
                            }),
                            b.privateExcess >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$cb63b5f03a3ae2c6), {
                                        className: "mt-6",
                                        children: "Above the budget"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca9b5cdfbd99e645$var$Row, {
                                        label: "Paid at full price",
                                        sub: "Services beyond each person's yearly budget are bought privately; the rates above apply only within the budget.",
                                        value: $ca9b5cdfbd99e645$var$money(b.privateExcess)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca9b5cdfbd99e645$var$Row, {
                                label: `${$ca9b5cdfbd99e645$var$cap(possessive)} contribution, a year`,
                                value: $ca9b5cdfbd99e645$var$money(plan.contribution),
                                bold: true
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca9b5cdfbd99e645$var$Row, {
                        label: `${$ca9b5cdfbd99e645$var$cap(possessive)} contribution, a year`,
                        value: $ca9b5cdfbd99e645$var$money(plan.contribution),
                        bold: true
                    }),
                    baseline && Math.abs(baseline.contribution - plan.contribution) >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-4 text-[13px] text-slate-500",
                        children: [
                            "With the support alone, ",
                            possessive,
                            " contribution is ",
                            $ca9b5cdfbd99e645$var$money(baseline.contribution),
                            ", so this plan ",
                            plan.contribution < baseline.contribution ? 'saves' : 'costs',
                            " ",
                            $ca9b5cdfbd99e645$var$money(baseline.contribution - plan.contribution),
                            " a year.",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setPage('pension'),
                                className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-[3px]",
                                children: "Why the rates are what they are"
                            })
                        ]
                    })
                ]
            }),
            page === 'pension' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                "data-testid": "sah-figure-pension",
                children: [
                    (plan.pensionRows || []).filter((row)=>row && row.label).map((row, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca9b5cdfbd99e645$var$Row, {
                            label: String(row.label).replace(/^-+\s*|\s*-+$/g, ''),
                            value: typeof row.value === 'number' ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.value) : String(row.value ?? '')
                        }, i)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca9b5cdfbd99e645$var$Row, {
                        label: `${$ca9b5cdfbd99e645$var$cap(possessive)} Age Pension, a year`,
                        value: $ca9b5cdfbd99e645$var$money(plan.pension),
                        bold: true
                    }),
                    baseline && Math.abs(baseline.pension - plan.pension) >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-4 text-[13px] text-slate-500",
                        children: [
                            "With the support alone, it is ",
                            $ca9b5cdfbd99e645$var$money(baseline.pension),
                            " a year."
                        ]
                    })
                ]
            }),
            page === 'cashflow' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                "data-testid": "sah-figure-cashflow",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$cb63b5f03a3ae2c6), {
                        children: "Money in"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca9b5cdfbd99e645$var$Row, {
                        label: "Age Pension",
                        value: $ca9b5cdfbd99e645$var$money(plan.pension),
                        onWhy: ()=>setPage('pension')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca9b5cdfbd99e645$var$Row, {
                        label: "Investment income",
                        sub: "Interest, dividends, rent and account-based pensions",
                        value: $ca9b5cdfbd99e645$var$money(plan.investmentIncome)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$cb63b5f03a3ae2c6), {
                        className: "mt-6",
                        children: "Money out"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca9b5cdfbd99e645$var$Row, {
                        label: "Living costs",
                        value: `\u{2212}${$ca9b5cdfbd99e645$var$money(plan.livingExpenses)}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca9b5cdfbd99e645$var$Row, {
                        label: `${$ca9b5cdfbd99e645$var$cap(possessive)} contribution to the support`,
                        value: `\u{2212}${$ca9b5cdfbd99e645$var$money(plan.contribution)}`,
                        onWhy: ()=>setPage('contribution')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca9b5cdfbd99e645$var$Row, {
                        label: plan.taxPayable < 0 ? 'Tax refund' : 'Income tax',
                        value: `${plan.taxPayable < 0 ? '+' : "\u2212"}${$ca9b5cdfbd99e645$var$money(plan.taxPayable)}`
                    }),
                    otherRows.map((row, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca9b5cdfbd99e645$var$Row, {
                            label: row.label,
                            value: `${row.value < 0 ? "\u2212" : '+'}${$ca9b5cdfbd99e645$var$money(row.value)}`
                        }, i)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca9b5cdfbd99e645$var$Row, {
                        label: plan.cashflow < 0 ? 'Each year, short by' : 'Left over each year',
                        value: $ca9b5cdfbd99e645$var$money(plan.cashflow),
                        bold: true
                    }),
                    baseline && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-4 text-[13px] text-slate-500",
                        children: [
                            "With the support alone, ",
                            baseline.cashflow < 0 ? `${they} are ${$ca9b5cdfbd99e645$var$money(baseline.cashflow)} short` : `${they} have ${$ca9b5cdfbd99e645$var$money(baseline.cashflow)} to spare`,
                            " each year."
                        ]
                    })
                ]
            })
        ]
    });
};






const $854c582fbab4f7c2$var$GOAL_CHIP = {
    'Optimal Legacy': 'Leaves the most',
    [(0, $400a08a42b233386$export$920ad41b346ae01a)]: 'Income covers the costs',
    'Optimal Cashflow': 'Most left over each year',
    'Optimal Age Pension': 'Highest Age Pension',
    [(0, $f8ee565b442c040e$export$40de0448f2611c56)]: (0, $5a094123650e8adb$export$a1a7ae9e29edd48c)
};
const $854c582fbab4f7c2$var$pct = (r)=>`${+(r * 100).toFixed(1)}%`;
function $854c582fbab4f7c2$export$b086ef70c5d0268c(config) {
    const c = config || {};
    const of = (x)=>Number(x.equityAmount ?? x.renovationAmount ?? x.purchaseAmount ?? x.amount ?? x.repaymentAmount ?? x.loanAmount ?? 0) || 0;
    switch(c.type){
        case 'increaseHomeEquity':
        case 'renovate':
        case 'upgrade':
            return {
                amount: of(c),
                label: 'Moved into the home'
            };
        case 'annuity':
            return {
                amount: of(c),
                label: 'Locked into the income'
            };
        case 'gifting':
            return {
                amount: of(c),
                label: 'Given away'
            };
        case 'funeralBonds':
            return {
                amount: of(c),
                label: 'Put into funeral bonds'
            };
        case 'debtRepayment':
            return {
                amount: of(c),
                label: 'Used to clear the debt'
            };
        case 'reverseMortgage':
            return {
                amount: of(c),
                label: 'Borrowed against the home'
            };
        case 'downsize':
            return {
                amount: Number(c.newHomeValue) || 0,
                label: 'Put into the new home'
            };
        case 'heas':
            return {
                amount: (Number(c.paymentAmount) || 0) * (c.paymentFrequency === 'monthly' ? 12 : 26),
                label: 'Borrowed each year'
            };
        case 'combination':
            return {
                amount: (c.steps || []).reduce((t, s)=>t + of(s), 0),
                label: 'Money moved'
            };
        default:
            return {
                amount: 0,
                label: 'Money moved'
            };
    }
}
const $854c582fbab4f7c2$export$3fdf7c379e6d9dd8 = ({ possessiveFile: possessiveFile, factFind: factFind, they: they = 'they', Their: Their = 'Their', fig: fig, base: base, title: title, sub: sub, chip: chip, moved: moved, scale: scale, horizonYears: horizonYears, projections: projections, planType: planType, chosen: chosen, anotherChosen: anotherChosen, onExplain: onExplain, onRisks: onRisks, onChoose: onChoose, onWhy: onWhy, onAdvice: onAdvice, onBuildOn: onBuildOn, onCareUp: onCareUp, detail: detail, detailOpen: detailOpen = false, onToggleDetail: onToggleDetail, testId: testId = 'sah-plan-card', chooseDisabled: chooseDisabled = false, tradeOffNote: tradeOffNote = null, beforeChoose: beforeChoose, chooseHeld: chooseHeld = false, familyPanel: familyPanel })=>{
    const legacyDelta = base ? fig.legacy - base.legacy : null;
    const maxGain = scale?.maxGain ?? Math.max(1, Math.abs(legacyDelta ?? 0));
    const maxMoved = scale?.maxMoved ?? Math.max(1, moved.amount);
    const rateLine = fig.rates && base?.rates && (Math.abs(fig.rates.independence - base.rates.independence) > 0.0005 || Math.abs(fig.rates.everydayLiving - base.rates.everydayLiving) > 0.0005) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            Their,
            " contribution for each hour ",
            fig.rates.independence + fig.rates.everydayLiving < base.rates.independence + base.rates.everydayLiving ? 'falls' : 'rises',
            ": getting out and about ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                children: [
                    $854c582fbab4f7c2$var$pct(base.rates.independence),
                    " \u2192 ",
                    $854c582fbab4f7c2$var$pct(fig.rates.independence)
                ]
            }),
            ", help around the house ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                children: [
                    $854c582fbab4f7c2$var$pct(base.rates.everydayLiving),
                    " \u2192 ",
                    $854c582fbab4f7c2$var$pct(fig.rates.everydayLiving)
                ]
            }),
            "."
        ]
    }) : null;
    const incomeLine = base && Math.abs(fig.investmentIncome - base.investmentIncome) >= 100 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            "Investment income ",
            fig.investmentIncome < base.investmentIncome ? 'falls' : 'rises',
            " from ",
            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(base.investmentIncome)),
            " to ",
            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(fig.investmentIncome)),
            " a year",
            fig.investmentIncome < base.investmentIncome ? " \u2014 the cost of the plan" : '',
            "."
        ]
    }) : null;
    const runway = projections && projections.length ? (0, $0fe89e03b6df746e$export$464558962ff4a811)(projections, horizonYears) : null;
    // Every account in the order it is drawn, as every module's card says it (owner, 22 Oct 2026).
    const runLine = factFind && projections && projections.length ? (0, $2ddaae90639b5011$export$7526d1fcb4423629)({
        rows: projections,
        factFind: factFind,
        horizonYears: horizonYears,
        spentOn: 'the plan'
    }) : null;
    const explainer = (0, $f6fa0c4ae572e255$export$db6db87c4063fbb3)[planType];
    const pensionDelta = base ? fig.pension - base.pension : 0;
    const numbers = [
        {
            label: `${Their} contribution to the support`,
            value: fig.contribution,
            unit: 'a year',
            vs: base ? `the support alone ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(base.contribution))}` : '',
            onWhy: ()=>onWhy('contribution')
        },
        {
            label: 'Age Pension',
            value: fig.pension,
            unit: 'a year',
            vs: base && Math.abs(pensionDelta) >= 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: pensionDelta > 0 ? 'font-bold text-emerald-700' : 'font-bold text-rose-700',
                        children: [
                            pensionDelta > 0 ? '+' : "\u2212",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(pensionDelta))),
                            " a year"
                        ]
                    }),
                    " vs the support alone"
                ]
            }) : 'the same as the support alone',
            tone: pensionDelta > 0 ? 'good' : 'neutral',
            onWhy: ()=>onWhy('pension')
        },
        {
            label: fig.cashflow < 0 ? 'Each year, short by' : 'Left over each year',
            value: Math.abs(fig.cashflow),
            vs: base ? base.cashflow < 0 ? `was short ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(base.cashflow)))} with the support alone` : `with the support alone, ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(base.cashflow))} to spare` : '',
            tone: fig.cashflow >= 0 ? 'good' : 'neutral',
            onWhy: ()=>onWhy('cashflow')
        }
    ];
    // A hand-built plan leads on nothing (owner, 25 Oct 2026: it read "leads on built by you"): its own words.
    const worse = legacyDelta != null && legacyDelta < -1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                className: "text-rose-700",
                children: "Important:"
            }),
            " what ",
            they,
            " leave the family would be ",
            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(legacyDelta))),
            " less than the support alone.",
            chip === 'Built by you' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " This is the plan ",
                    they,
                    " built; weigh that against what it does each year."
                ]
            }) : chip ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " It is shown because it leads on ",
                    chip.toLowerCase(),
                    "; weigh that against what it does each year."
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: " Weigh that against what it does each year."
            })
        ]
    }) : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b383720e6b5df564$export$2e2bcd8739ae039), {
        testId: testId,
        whyShown: tradeOffNote || null,
        chip: chip,
        chipTone: "blue",
        title: title,
        sub: sub,
        legacy: fig.legacy,
        legacyDelta: legacyDelta,
        horizonYears: horizonYears,
        bars: legacyDelta != null ? {
            gainPct: Math.abs(legacyDelta) / maxGain * 100,
            tiedUp: moved.amount,
            tiedUpPct: moved.amount / maxMoved * 100
        } : null,
        tiedUpLabel: moved.label,
        hideEmptyTiedUp: true,
        linesBulleted: true,
        numbers: numbers,
        runline: runway || familyPanel ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                runLine ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "text-slate-900",
                            children: "When the money runs out:"
                        }),
                        " ",
                        runLine
                    ]
                }) : runway && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "text-slate-900",
                            children: "When the money runs out:"
                        }),
                        " ",
                        runway.headline.charAt(0).toLowerCase() + runway.headline.slice(1),
                        runway.flag ? `. ${runway.flag}` : '.'
                    ]
                }),
                familyPanel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: runway ? 'mt-3' : '',
                    children: familyPanel
                })
            ]
        }) : null,
        worthKnowing: worse || (explainer?.consider?.[0] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "Worth knowing:"
                }),
                " ",
                explainer.consider[0]
            ]
        }) : null),
        lines: [
            rateLine,
            incomeLine
        ].filter(Boolean),
        chosen: chosen,
        onExplain: onExplain,
        onRisks: onRisks,
        onChoose: chooseDisabled || chooseHeld ? ()=>undefined : onChoose,
        beforeChoose: beforeChoose,
        chooseHeld: chooseHeld,
        chooseLabel: anotherChosen ? 'Choose this instead' : 'Choose this plan',
        chosenStrip: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2194d8b5de21e3ff$export$4df4eb62309771d0), {
            possessiveFile: possessiveFile,
            onAdvice: onAdvice,
            onCustomise: onBuildOn ?? null
        }),
        extraAction: onCareUp ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            type: "button",
            onClick: onCareUp,
            className: "mt-3 self-start text-[13px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy",
            "data-testid": "sah-care-up-open",
            children: "If care needs increase"
        }) : null,
        detail: detail,
        detailOpen: detailOpen,
        onToggleDetail: onToggleDetail ?? (()=>undefined),
        detailHint: "where the money comes from, the yearly figures and every calculation"
    });
};
const $854c582fbab4f7c2$var$SahPlansView = ({ factFind: factFind, doNothing: doNothing, recommended: recommended, strategies: strategies, waysTested: waysTested, horizonYears: horizonYears, focus: focus, onFocus: onFocus, chosenName: chosenName, onChoose: onChoose, onExplain: onExplain, onRisks: onRisks, onWhy: onWhy, onCareUp: onCareUp, renderDetail: renderDetail, onCompare: onCompare, onAllWays: onAllWays, onSettings: onSettings, onBuildYourOwn: onBuildYourOwn, onAdvice: onAdvice, notices: notices, guaranteedIncomeFor: guaranteedIncomeFor })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const [openDetail, setOpenDetail] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const base = doNothing?.snapshot ? (0, $ca9b5cdfbd99e645$export$122bd92e883ab7c1)(doNothing.snapshot) : null;
    const fullRow = (r)=>{
        if (!r?.strategy?.name) return null;
        return strategies.find((s)=>s.name === r.strategy.name) || r.strategy;
    };
    const coveredSame = (0, $400a08a42b233386$export$b8b8a2cedd92aa3a)(recommended);
    const effective = focus === 'covered' && coveredSame ? 'legacy' : focus;
    const leader = fullRow((0, $f8ee565b442c040e$export$cf9821b188ee27f0)(recommended, effective));
    const labelsFor = (row)=>recommended.filter((r)=>r.strategy?.name && r.strategy.name === row.name).map((r)=>String(r.label));
    // A second card beside the estate leader, only for a real trade-off (planChoiceRule.ts, owner 20 Oct 2026).
    const secondEntry = effective === 'legacy' ? recommended.find((r)=>r.label === (0, $f8ee565b442c040e$export$40de0448f2611c56) && r.second) ?? null : null;
    const secondRow = secondEntry ? fullRow(secondEntry) : null;
    // The estate leader, when it is not the plan that leaves the most, says so on its chip (rule 2).
    const estateEntry = recommended.find((r)=>r.label === 'Optimal Legacy') ?? null;
    const chipFor = (l)=>l === 'Optimal Legacy' ? (0, $5a094123650e8adb$export$a035dca5f387c63d)(estateEntry?.lead) : l === (0, $f8ee565b442c040e$export$40de0448f2611c56) && secondEntry?.second ? (0, $5a094123650e8adb$export$8d9f0aa086032e89)(secondEntry.second) : $854c582fbab4f7c2$var$GOAL_CHIP[l];
    const shown = leader ? [
        leader,
        ...secondRow && secondRow.name !== leader.name ? [
            secondRow
        ] : []
    ] : [];
    const goalWords = (g)=>g === 'cashflow' ? 'Most left over each year' : g === 'pension' ? 'The highest Age Pension' : 'Leaving the most to the family';
    // Another goal led by a different plan: one line pointing to it (the mock-up's "only one plan leads").
    const others = [
        'legacy',
        'cashflow',
        'pension'
    ].filter((g)=>g !== effective).map((g)=>({
            g: g,
            row: fullRow((0, $f8ee565b442c040e$export$cf9821b188ee27f0)(recommended, g))
        })).filter((x)=>!!x.row && !shown.some((s)=>s.name === x.row.name));
    const chosenRow = chosenName ? strategies.find((s)=>s.name === chosenName) || null : null;
    const chosenTitle = chosenRow ? (0, $f7f18ba87194b6fe$export$743d9d8d57ca17a8)(chosenRow.config, factFind, chosenRow.name).title : null;
    const yrs = `${horizonYears} ${horizonYears === 1 ? 'year' : 'years'}`;
    const maxGain = Math.max(1, ...shown.map((s)=>Math.abs((Number(s.snapshot?.legacyValue) || 0) - (base?.legacy ?? 0))));
    const maxMoved = Math.max(1, ...shown.map((s)=>$854c582fbab4f7c2$export$b086ef70c5d0268c(s.config).amount));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-6",
        "data-testid": "sah-plans",
        children: [
            chosenRow && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                "data-testid": "sah-chosen-banner",
                className: "flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 border-l-4 border-l-emerald-500 bg-white px-5 py-4 shadow-card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-[26px] leading-none text-emerald-500",
                        "aria-hidden": true,
                        children: "\u2713"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "min-w-0 flex-1 text-[14px] leading-relaxed text-slate-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                className: "text-slate-900",
                                children: [
                                    "You've chosen \u201C",
                                    chosenTitle,
                                    "\u201D."
                                ]
                            }),
                            " It's saved with ",
                            v.possessive,
                            " file, with the services it was priced on. The next step is the advice document \u2014 the written record of this plan: what it assumes, what it costs each year, and what could go wrong."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>onBuildYourOwn(chosenRow),
                        className: "text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy",
                        children: "Customise this plan"
                    })
                ]
            }),
            notices,
            base && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac9505651d2e4510$export$2e2bcd8739ae039), {
                caption: "Compared with the support alone \u2014 the four numbers from step 2",
                careDaily: 0,
                careAnnual: 0,
                enteringName: v.names,
                costCell: {
                    label: `${v.Their} contribution`,
                    value: base.contribution,
                    unit: 'a year',
                    note: 'to the support, with nothing else changed'
                },
                pensionLabel: "Age Pension",
                pensionNoteText: v.couple ? `a year, the two of ${v.them}` : 'a year',
                pension: base.pension,
                cashflowAfterCare: base.cashflow,
                cashflowNotes: {
                    short: 'met from savings',
                    over: 'after the support and living costs'
                },
                legacy: base.legacy,
                horizonYears: horizonYears,
                onWhyYears: onSettings
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54f65c4595e0c798$export$2e2bcd8739ae039), {
                baselineWord: (0, $1a5a24a0286ded56$export$c9c6ca79dc334e31).word,
                value: focus,
                onChange: onFocus,
                household: v.names,
                enteringName: v.names,
                horizonYears: horizonYears,
                coveredSameAsBest: coveredSame,
                bestCovers: coveredSame && Number(fullRow((0, $f8ee565b442c040e$export$cf9821b188ee27f0)(recommended, 'legacy'))?.snapshot?.netCashflow ?? fullRow((0, $f8ee565b442c040e$export$cf9821b188ee27f0)(recommended, 'legacy'))?.snapshot?.cashflow ?? -1) >= 0,
                waysTested: waysTested,
                shown: shown.length,
                testedFor: "to pay for the support",
                closingNote: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Each card says when the savings would run out, and how much it lowers what ",
                        v.they,
                        " pay for each hour."
                    ]
                }),
                subs: {
                    covered: coveredSame ? 'Same plan as "Leave the most"' : 'Pays its way without savings'
                }
            }),
            shown.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
                "data-testid": "sah-no-leader",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-[19px] font-bold text-slate-900",
                        children: "No plan does better than the support alone on this goal"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 text-[14px] leading-relaxed text-slate-700",
                        children: [
                            "Every way tested would cost more than it adds here, so keeping things as they are is the best result for this goal.",
                            others.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: " Another goal has a plan that helps \u2014 switch the goal above to see it."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `grid grid-cols-1 items-start gap-5 ${shown.length > 1 ? 'lg:grid-cols-2' : ''}`,
                "data-testid": "sah-plan-cards",
                children: [
                    chosenRow && !shown.some((s)=>s.name === chosenRow.name) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: shown.length > 1 ? 'lg:col-span-2' : '',
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2194d8b5de21e3ff$export$4df4eb62309771d0), {
                            possessiveFile: v.possessive,
                            onAdvice: onAdvice,
                            offCard: true,
                            testId: "chosen-plan-off-card"
                        })
                    }),
                    shown.map((row)=>{
                        const fig = (0, $ca9b5cdfbd99e645$export$122bd92e883ab7c1)(row.snapshot);
                        const words = (0, $f7f18ba87194b6fe$export$743d9d8d57ca17a8)(row.config, factFind, row.name);
                        const chip = labelsFor(row).map(chipFor).filter(Boolean).join(" \xb7 ") || null;
                        const isChosen = chosenName != null && row.name === chosenName;
                        const gi = guaranteedIncomeFor?.(row) ?? null;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($854c582fbab4f7c2$export$3fdf7c379e6d9dd8, {
                            factFind: factFind,
                            possessiveFile: v.possessive,
                            they: v.they,
                            Their: v.Their,
                            fig: fig,
                            base: base,
                            title: words.title,
                            sub: words.sub,
                            chip: chip,
                            moved: $854c582fbab4f7c2$export$b086ef70c5d0268c(row.config),
                            scale: {
                                maxGain: maxGain,
                                maxMoved: maxMoved
                            },
                            horizonYears: horizonYears,
                            projections: row.projections,
                            planType: String(row.config?.type || ''),
                            chosen: isChosen,
                            anotherChosen: chosenName != null && !isChosen,
                            onExplain: ()=>onExplain(row),
                            onRisks: ()=>onRisks(row),
                            onChoose: ()=>onChoose(row),
                            onWhy: (page)=>onWhy(row, page),
                            onAdvice: onAdvice,
                            onBuildOn: ()=>onBuildYourOwn(row),
                            onCareUp: onCareUp ? ()=>onCareUp(row) : undefined,
                            detail: renderDetail(row),
                            detailOpen: openDetail === row.name,
                            onToggleDetail: ()=>setOpenDetail((d)=>d === row.name ? null : String(row.name)),
                            tradeOffNote: secondEntry?.second && row === secondRow ? (0, $5a094123650e8adb$export$a104569a4d958475)(secondEntry.second, (0, $f94e45ac645ae232$export$3dc27271f5d5c629)) : estateEntry?.lead && row.name === estateEntry.strategy?.name ? (0, $5a094123650e8adb$export$27f705a6fa40271e)(estateEntry.lead, (0, $f94e45ac645ae232$export$3dc27271f5d5c629)) : null,
                            familyPanel: gi?.familyPanel,
                            beforeChoose: gi?.beforeChoose,
                            chooseHeld: !!gi?.chooseHeld && !isChosen
                        }, String(row.name));
                    }),
                    shown.length > 0 && others.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "rounded-2xl border border-slate-200 bg-white p-5 shadow-card",
                        "data-testid": "sah-other-leaders",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-[17px] font-bold text-slate-900",
                                children: others.length === 1 ? ({
                                    cashflow: 'If more to live on each year matters most',
                                    pension: 'If the Age Pension matters most',
                                    legacy: 'If leaving the most to the family matters most'
                                })[others[0].g] : 'Where a different plan does better'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1 text-[13px] text-slate-500",
                                children: others.length === 1 ? 'The plan on the left is the best for every other goal.' : 'The plan on the left is the best for the goal chosen above.'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "mt-2 space-y-3 text-[14px] leading-relaxed text-slate-700",
                                children: others.map(({ g: g, row: row })=>{
                                    const fig = (0, $ca9b5cdfbd99e645$export$122bd92e883ab7c1)(row.snapshot);
                                    const here = shown[0] ? (0, $ca9b5cdfbd99e645$export$122bd92e883ab7c1)(shown[0].snapshot) : null;
                                    const t = (0, $f7f18ba87194b6fe$export$743d9d8d57ca17a8)(row.config, factFind, row.name).title;
                                    const dl = base ? fig.legacy - base.legacy : 0;
                                    const cf = (n)=>n >= 0 ? `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n))} a year to spare` : `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(n)))} a year short`;
                                    const fact = g === 'cashflow' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            cf(fig.cashflow),
                                            here ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    ", against ",
                                                    cf(here.cashflow),
                                                    " with the plan on the left"
                                                ]
                                            }) : null
                                        ]
                                    }) : g === 'pension' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(fig.pension)),
                                            " a year of Age Pension",
                                            here ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    ", against ",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(here.pension))
                                                ]
                                            }) : null
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(fig.legacy)),
                                            " left to the family",
                                            here ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    ", against ",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(here.legacy))
                                                ]
                                            }) : null
                                        ]
                                    });
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        children: [
                                            others.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                className: "text-slate-900",
                                                children: [
                                                    goalWords(g),
                                                    ": "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                className: "text-slate-900",
                                                children: t
                                            }),
                                            " gives ",
                                            fact,
                                            ".",
                                            base && Math.abs(dl) >= 1 && g !== 'legacy' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    " But it leaves the family ",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(dl))),
                                                    " ",
                                                    dl >= 0 ? 'more' : 'less',
                                                    " than the support alone."
                                                ]
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>onFocus(g),
                                                className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                                children: "See that plan"
                                            })
                                        ]
                                    }, g);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-3",
                "data-testid": "sah-ways-on",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onCompare,
                        className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                        children: "Compare the plans side by side"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onAllWays,
                        className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                        children: [
                            "All ",
                            waysTested.toLocaleString(),
                            " ways tested"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onSettings,
                        className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                        children: "Things that change the answer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>onBuildYourOwn(null),
                        className: "text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy",
                        "data-testid": "sah-build-your-own",
                        children: "Prefer to set the numbers yourself? Build a plan \u2192"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[13px] text-slate-500",
                "data-testid": "all-plans-open-line",
                children: (0, $5a094123650e8adb$export$af182f21f972ef03)(waysTested)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] text-slate-500",
                children: [
                    "Figures use the rates in force today and are projections over ",
                    yrs,
                    ", not guarantees."
                ]
            })
        ]
    });
};
var $854c582fbab4f7c2$export$2e2bcd8739ae039 = $854c582fbab4f7c2$var$SahPlansView;










/**
 * THE GUARANTEED INCOME IN A SUPPORT AT HOME PLAN (owner, 21 Oct 2026 — the guaranteed income review and the
 * agreed mock-up, docs/ux-review/annuities/ screens 3–6).
 *
 * One reading of "which guaranteed income does this plan buy, how much, for whom and of what type" for the
 * plan cards (the family panel and the income-only confirmation), the hand-built plan and the advice
 * document, so the three cannot describe different products.
 */ 

const $dd66c4f756bb6b40$var$ownerOf = (v)=>v === 'partner' ? 'partner' : v === 'joint' ? 'joint' : 'client';
function $dd66c4f756bb6b40$var$fromAnnuity(a, only) {
    const amount = Number(a?.purchaseAmount) || 0;
    if (!a || !(amount > 0)) return null;
    const annuityType = String(a.annuityType || 'lifetime');
    const residualCapital = Number.isFinite(Number(a.residualCapital)) ? Number(a.residualCapital) : 0;
    return {
        amount: amount,
        annuityType: annuityType,
        residualCapital: residualCapital,
        owner: $dd66c4f756bb6b40$var$ownerOf(a.ownership ?? a.owner),
        kind: (0, $8665f80549f60a1b$export$3ab75b1250c8af22)({
            annuityType: annuityType,
            residualCapital: residualCapital
        }),
        incomeOnly: (0, $5eae79c7e46ed27e$export$3c8a471078a7436)({
            purchaseAmount: amount,
            annuityType: annuityType,
            residualCapital: residualCapital
        }),
        only: only
    };
}
function $dd66c4f756bb6b40$export$39e91763b583ca80(config) {
    if (!config) return null;
    const steps = config.type === 'combination' ? config.steps || [] : [
        config
    ];
    const a = steps.find((s)=>s?.type === 'annuity');
    return a ? $dd66c4f756bb6b40$var$fromAnnuity(a, steps.length === 1) : null;
}
function $dd66c4f756bb6b40$export$c49e25d370aaca5c(record, only) {
    return $dd66c4f756bb6b40$var$fromAnnuity(record, only);
}
function $dd66c4f756bb6b40$export$b2f4bd9ebed41c37(factFind, owner) {
    const c = factFind?.client?.firstName || 'the client';
    const p = factFind?.partner?.firstName || 'the partner';
    if (owner === 'partner') return p;
    if (owner === 'joint' && factFind?.adviceFor === 'couple') return `${c} and ${p}`;
    return c;
}
function $dd66c4f756bb6b40$export$75e3f249f9924fd2(rows, factFind) {
    const first = (rows || [])[0];
    const list = first?.assets?.annuities || [];
    const onFile = new Set((factFind?.assets?.annuities || []).map((a)=>String(a?.id)));
    const total = list.filter((a)=>!onFile.has(String(a?.id))).reduce((t, a)=>t + (Number(a?.annualPayment) || 0), 0);
    return total > 0 ? total : null;
}
const $dd66c4f756bb6b40$export$ea81c21b74f64dcc = 'the same plan without it, the money left in savings';








/**
 * Downsize sale economics and purchase-price candidates for Support at Home suggestion engine.
 * Mirrors Aged Care Strategy Analysis Setup (optional new home value + selling costs).
 */ const $ea856d0766f9093e$var$DEFAULT_SELLING_COST_RATE = 0.025;
function $ea856d0766f9093e$export$89e90a1d8b2e24c0(currentHomeValue, propertySettings = {}) {
    const homeValue = Math.max(0, currentHomeValue);
    const userSellingCosts = propertySettings.downsizeSellingCosts ?? propertySettings.sellingCosts;
    if (typeof userSellingCosts === 'number' && Number.isFinite(userSellingCosts) && userSellingCosts > 0) return {
        salePrice: homeValue,
        sellingCosts: userSellingCosts,
        usesCustomSellingCosts: true
    };
    return {
        salePrice: homeValue * (1 - $ea856d0766f9093e$var$DEFAULT_SELLING_COST_RATE),
        sellingCosts: homeValue * $ea856d0766f9093e$var$DEFAULT_SELLING_COST_RATE,
        usesCustomSellingCosts: false
    };
}
function $ea856d0766f9093e$export$3ea0a82cc525a565(currentHomeValue, propertySettings = {}) {
    const homeValue = Math.max(0, currentHomeValue);
    if (homeValue <= 0) return [];
    const userPrice = propertySettings.downsizeNewHomeValue ?? propertySettings.newHomeValue;
    if (typeof userPrice === 'number' && Number.isFinite(userPrice) && userPrice > 0) {
        const capped = Math.min(userPrice, homeValue - 1);
        return capped > 0 ? [
            capped
        ] : [];
    }
    return [
        0.5,
        0.6,
        0.7,
        0.8
    ].map((ratio)=>homeValue * ratio).filter((price)=>price > 0 && price < homeValue);
}
function $ea856d0766f9093e$export$cc31c83de42a47d(factFind, propertySettings = {}) {
    if (!propertySettings?.downsize) return [];
    const homeValue = Math.max(0, factFind?.home?.value || 0);
    const lines = [];
    const userPrice = propertySettings.downsizeNewHomeValue ?? propertySettings.newHomeValue;
    const { sellingCosts: sellingCosts, usesCustomSellingCosts: usesCustomSellingCosts } = $ea856d0766f9093e$export$89e90a1d8b2e24c0(homeValue, propertySettings);
    if (typeof userPrice === 'number' && Number.isFinite(userPrice) && userPrice > 0) lines.push(`Downsize target purchase price: $${Math.round(userPrice).toLocaleString()} (entered in Strategy Analysis Setup).`);
    else lines.push('Downsize purchase prices default to 50%, 60%, 70%, and 80% of current home value when no target price is entered.');
    if (usesCustomSellingCosts) lines.push(`Downsize selling costs: $${Math.round(sellingCosts).toLocaleString()} (entered in Strategy Analysis Setup).`);
    else lines.push(`Downsize selling costs default to ${($ea856d0766f9093e$var$DEFAULT_SELLING_COST_RATE * 100).toFixed(1)}% of current home value unless estimated selling costs are entered.`);
    return lines;
}






// Gifting limit (Centrelink rules)
const $e4aa20091e5d9c16$var$GIFTING_5_YEAR_LIMIT = 30000; // $30,000 over 5 years
// Funeral bond exempt limit
/*
 * ONE FUNERAL BOND LIMIT, FROM THE RATES FILE.
 *
 * This was a local `const FUNERAL_BOND_EXEMPT_LIMIT = 15000`, shadowing the published figure of
 * $15,750 that the assessment itself uses. So the engine sized its funeral bond candidates $750 per
 * person short of the exemption, and the screen told the client a limit the assessment disagreed
 * with. A rate that lives in two places will eventually differ in two places — this one already did.
 */ const $e4aa20091e5d9c16$var$FUNERAL_BOND_EXEMPT_LIMIT = (0, $1abe73eeef086faf$export$aca3edb7cd7a3f17);
function $e4aa20091e5d9c16$export$367eaf68e2370e55(factFind, problemStatement, reserve) {
    const strategies = [];
    // Check if gifting is relevant
    if (!problemStatement.strategyRelevance.gifting.relevant) return strategies; // Return empty array - strategy is not relevant
    // Get available liquid assets (bank accounts, ABPs, shares)
    const availableAssets = $e4aa20091e5d9c16$var$getSahAvailableAssets(factFind, reserve);
    if (availableAssets.length === 0) return strategies; // No assets to gift
    // Test different gifting amounts
    // If full pension but NWOP Category B, test smaller amounts
    // If part/self-funded, test larger amounts to maximize pension gain
    const pensionStatus = problemStatement.pensionOptimization.status;
    let amountsToTest = [];
    if (pensionStatus === 'full') // If full pension, still test small amounts in case it helps with contribution rates
    amountsToTest = [
        5000,
        10000
    ]; // Test smaller amounts
    else if (pensionStatus === 'part') // Part pension - test incremental amounts
    amountsToTest = [
        5000,
        10000,
        15000,
        20000,
        30000
    ]; // Within 5-year limit
    else // Self-funded - test larger amounts to maximize pension qualification
    amountsToTest = [
        10000,
        20000,
        30000
    ]; // Test up to 5-year limit
    const remainingGiftingCapacity = (0, $6737c18204fae40a$export$b58be10a7d609cb0)(factFind);
    // Filter amounts based on available assets and Centrelink gifting capacity (profile + limits)
    const totalAvailable = availableAssets.reduce((sum, asset)=>sum + asset.available, 0);
    const maxGiftingAvailable = Math.max(0, totalAvailable - (reserve ?? (0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind)));
    amountsToTest = amountsToTest.filter((amount)=>amount <= maxGiftingAvailable && amount <= $e4aa20091e5d9c16$var$GIFTING_5_YEAR_LIMIT && amount <= remainingGiftingCapacity);
    // Generate strategies for each amount
    amountsToTest.forEach((amount)=>{
        // Find optimal asset source (prefer bank accounts, then ABPs, then shares)
        const assetSource = $e4aa20091e5d9c16$var$findOptimalAssetSource(availableAssets, amount);
        if (assetSource) strategies.push({
            type: 'gifting',
            amount: amount,
            assetType: assetSource.type,
            assetId: assetSource.id,
            assetDescription: assetSource.description,
            fundingSources: assetSource.fundingSources,
            name: `Gift $${amount.toLocaleString()} to Family`,
            description: `Gift $${amount.toLocaleString()} within Centrelink gifting limits to reduce assessable assets`
        });
    });
    return strategies;
}
function $e4aa20091e5d9c16$export$7a81cb11f4bdf617(factFind, problemStatement, reserve) {
    const strategies = [];
    // Check if funeral bonds are relevant
    if (!problemStatement.strategyRelevance.funeralBonds.relevant) return strategies; // Return empty array - strategy is not relevant
    // Get available liquid assets
    const availableAssets = $e4aa20091e5d9c16$var$getSahAvailableAssets(factFind, reserve);
    if (availableAssets.length === 0) return strategies;
    // Calculate current funeral bonds to determine remaining exempt capacity
    const currentFuneralBonds = $e4aa20091e5d9c16$var$calculateCurrentFuneralBonds(factFind);
    const isPartnered = factFind?.adviceFor === 'couple';
    const exemptLimit = isPartnered ? $e4aa20091e5d9c16$var$FUNERAL_BOND_EXEMPT_LIMIT * 2 : $e4aa20091e5d9c16$var$FUNERAL_BOND_EXEMPT_LIMIT;
    const remainingExempt = Math.max(0, exemptLimit - currentFuneralBonds);
    if (remainingExempt <= 0) return strategies; // Already at exempt limit
    /*
     * Purchase amounts tried, per person. The top of the list is the EXEMPTION itself, not a
     * round number near it: hard-coded at 15000 the engine stopped $750 per person short of
     * the limit it was trying to fill, so it could never propose the amount that uses the
     * strategy fully.
     */ const amountsToTest = [
        5000,
        10000,
        $e4aa20091e5d9c16$var$FUNERAL_BOND_EXEMPT_LIMIT
    ];
    // Filter amounts based on available exempt capacity and assets
    const totalAvailable = availableAssets.reduce((sum, asset)=>sum + asset.available, 0);
    const emergencyFundReserve = 50000;
    const maxAvailable = Math.max(0, totalAvailable - emergencyFundReserve);
    amountsToTest.forEach((amount)=>{
        // Calculate total amount (for couples, can do per person or combined)
        let totalAmount = amount;
        if (isPartnered) {
            // For couples, could do $15K per person = $30K total
            const perPersonAmount = Math.min(amount, remainingExempt / 2);
            totalAmount = perPersonAmount * 2;
        } else totalAmount = Math.min(amount, remainingExempt);
        // Cap at available funds
        totalAmount = Math.min(totalAmount, maxAvailable);
        totalAmount = Math.min(totalAmount, remainingExempt);
        if (totalAmount >= 5000) {
            const assetSource = $e4aa20091e5d9c16$var$findOptimalAssetSource(availableAssets, totalAmount);
            if (assetSource) strategies.push({
                type: 'funeralBonds',
                amount: totalAmount,
                perPersonAmount: isPartnered ? totalAmount / 2 : totalAmount,
                assetType: assetSource.type,
                assetId: assetSource.id,
                assetDescription: assetSource.description,
                fundingSources: assetSource.fundingSources,
                name: `Purchase $${totalAmount.toLocaleString()} Funeral Bonds`,
                description: `Purchase prepaid funeral bonds (exempt asset) to reduce assessable assets by $${totalAmount.toLocaleString()}`
            });
        }
    });
    return strategies;
}
function $e4aa20091e5d9c16$export$b7a0d0e4c68718fd(factFind, _problemStatement, reserve) {
    const strategies = [];
    // Annuities are always relevant - they can help with pension, cashflow, and legacy
    // We'll generate a range of annuity strategies
    // The actual annuity calculations will be done using buildAnnuityImpact() from AnnuityStrategies.js
    const availableAssets = $e4aa20091e5d9c16$var$getSahAvailableAssets(factFind, reserve);
    if (availableAssets.length === 0) return strategies;
    const maxAvailable = $e4aa20091e5d9c16$export$8a06018655d03e9e(factFind, reserve).amount;
    /*
     * HOW MUCH (owner, 21 Oct 2026 — the village review's decision 11, every module; annuitySizes.ts): up to a
     * quarter of what is available, and — where it would lift the Age Pension — the amount that lifts it most,
     * as a plan of its own. Previously a grid from $50,000 to $500,000, whatever the client held.
     */ const sizes = (0, $cb76d0656284f28b$export$4dc6c2d1b2b95e25)(factFind, {
        investable: maxAvailable,
        capPct: 25,
        homeowner: Number(factFind.home?.value) > 0,
        lessCounted: maxAvailable
    });
    const amountsToTest = sizes.map((size)=>({
            amount: size.pensionMax ? size.amount : Math.floor(size.amount / 10000) * 10000,
            pensionMax: size.pensionMax
        })).filter(({ amount: amount })=>amount >= 50000 && amount <= maxAvailable);
    /*
     * RESIDUAL CAPITAL IS A CHOICE, AND IT WAS NEVER OFFERED.
     *
     * The comment here used to say the annuity's type, RCV and indexation "will be optimised in the
     * evaluator". They were not: the evaluator hard-coded a lifetime annuity with nil residual, so
     * that was the only annuity this engine could ever propose.
     *
     * It matters because Centrelink assesses a lifetime annuity at 60% of its purchase price
     * whichever residual it carries — provided the death benefit stays inside the capital access
     * schedule (annuityStrategies.ts) — while net worth values one at that scheduled death benefit
     * (a nil-RCV annuity really does leave nothing behind). So every annuity candidate lost the
     * legacy ranking by its full purchase price on day one. It was not being weighed against the
     * alternatives; it was being disqualified before the comparison started.
     *
     * Both ends are now offered so the ranking decides.
     *
     * THE MONEY-BACK TYPES FROM THE $50,000 MINIMUM (owner, 21 Oct 2026 — the guaranteed income review).
     * They used to start at $100,000, when income only was built for everyone and the money-back types were
     * the extra candidates. Income only is now the opt-in one (annuityPreference.ts), so with the floor at
     * $100,000 a household whose quarter is under that would get no guaranteed-income plan at all. The
     * types that return the money now start where any guaranteed income starts: the provider minimum.
     */ const RCV_VARIANT_FLOOR = 50000;
    // The client's own answer decides whether an annuity is offered at all, and which versions.
    const annuityPreference = (0, $ff5de4128b46b139$export$636a9065c3f862c1)(factFind);
    amountsToTest.forEach(({ amount: amount, pensionMax: pensionMax })=>{
        const sizeName = pensionMax ? ', the amount that lifts the Age Pension most' : '';
        const assetSource = $e4aa20091e5d9c16$var$findOptimalAssetSource(availableAssets, amount);
        if (!assetSource) return;
        const common = {
            type: 'annuity',
            purchaseAmount: amount,
            assetType: assetSource.type,
            assetId: assetSource.id,
            fundingSources: assetSource.fundingSources
        };
        if ((0, $ff5de4128b46b139$export$b8876d0a37b8526a)(annuityPreference, 0)) strategies.push({
            ...common,
            residualCapital: 0,
            name: `Purchase $${amount.toLocaleString()} Annuity (nil residual${sizeName})`,
            description: 'Purchase a lifetime annuity to reduce assessable assets and provide guaranteed income. This version pays the most income and leaves nothing of the purchase price to the estate.'
        });
        if (amount >= RCV_VARIANT_FLOOR && (0, $ff5de4128b46b139$export$b8876d0a37b8526a)(annuityPreference, 1)) strategies.push({
            ...common,
            residualCapital: 1,
            name: `Purchase $${amount.toLocaleString()} Annuity (capital returned${sizeName})`,
            description: "The same annuity, but with the purchase price coming back to the estate on an early death \u2014 in full within the first half of life expectancy, less after that \u2014 rather than kept by the provider. It pays less income, and Centrelink still counts only 60% either way."
        });
        // The guaranteed shape: the full amount to the estate whenever death comes, at the least
        // income and with far less assets-test relief. Support at Home IS government-subsidised
        // aged care, so its clients qualify for it.
        if (amount >= RCV_VARIANT_FLOOR && (0, $ff5de4128b46b139$export$623904c9366cf5a0)(annuityPreference, factFind)) strategies.push({
            ...common,
            residualCapital: 1,
            annuityType: 'guaranteed',
            name: `Purchase $${amount.toLocaleString()} Annuity (full amount guaranteed${sizeName})`,
            description: 'A lifetime annuity and a life policy bought together, so the full purchase price comes back to the estate whenever death comes. It pays the least income of the three, and only the annuity half earns the 60% assets-test treatment; the policy is counted at what it cost.'
        });
    });
    return strategies;
}
function $e4aa20091e5d9c16$export$cfe54d95cd93699b(factFind, _problemStatement, propertySettings = {}, reserve) {
    const strategies = [];
    const currentHomeValue = factFind.home?.value || 0;
    if (currentHomeValue <= 0) return strategies; // No home to work with
    const increaseHomeEquityEnabled = propertySettings.increaseHomeEquity || propertySettings.renovate || propertySettings.upgrade;
    // Increase exempt home equity: renovate in place or buy up — same modelling (liquid assets → home value 1:1)
    if (increaseHomeEquityEnabled) {
        const availableAssets = $e4aa20091e5d9c16$var$getSahAvailableAssets(factFind, reserve);
        const totalAvailable = availableAssets.reduce((sum, asset)=>sum + asset.available, 0);
        const emergencyFundReserve = 50000;
        const maxAvailable = Math.max(0, totalAvailable - emergencyFundReserve);
        const minLiquidityRequired = emergencyFundReserve + 20000;
        const maxEquityAmount = Math.max(0, totalAvailable - minLiquidityRequired);
        const equityAmountCandidates = new Set();
        [
            20000,
            50000,
            100000,
            150000,
            200000
        ].forEach((a)=>{
            if (a <= maxAvailable && a <= maxEquityAmount) equityAmountCandidates.add(a);
        });
        [
            1.1,
            1.2,
            1.3,
            1.5
        ].forEach((ratio)=>{
            const amount = Math.round(currentHomeValue * (ratio - 1));
            if (amount > 0 && amount <= maxAvailable && amount <= maxEquityAmount) equityAmountCandidates.add(amount);
        });
        [
            ...equityAmountCandidates
        ].sort((a, b)=>a - b).forEach((amount)=>{
            const assetSource = $e4aa20091e5d9c16$var$findOptimalAssetSource(availableAssets, amount);
            if (!assetSource) return;
            const remainingLiquidity = totalAvailable - amount;
            if (remainingLiquidity < minLiquidityRequired) return;
            const newHomeValue = currentHomeValue + amount;
            const strategyConfig = {
                type: 'increaseHomeEquity',
                equityAmount: amount,
                renovationAmount: amount,
                currentHomeValue: currentHomeValue,
                newHomeValue: newHomeValue,
                assetType: assetSource.type,
                assetId: assetSource.id,
                name: `Increase home equity ($${amount.toLocaleString()})`,
                description: `Convert $${amount.toLocaleString()} of liquid assets into exempt home equity (renovate in place or buy a more expensive home \u{2014} modelled as $1 for $1 value uplift)`
            };
            if (assetSource.fundingSources && Array.isArray(assetSource.fundingSources)) strategyConfig.fundingSources = assetSource.fundingSources;
            strategies.push(strategyConfig);
        });
    }
    // Downsize: sell home, purchase smaller property, allocate proceeds (bank / downsizer / debt)
    if (propertySettings.downsize) {
        const liabilities = (0, $6737c18204fae40a$export$eab989c41b911b05)(factFind);
        // canCommenceAbpFromDownsizer is the real (strict) calc-engine function; factFind's money
        // fields being read here (client/partner dob) are plain strings either way, so the cast is safe.
        const downsizerEligible = (0, $6737c18204fae40a$export$8f060289ee84cde9)(factFind);
        const { salePrice: salePrice, sellingCosts: sellingCosts } = (0, $ea856d0766f9093e$export$89e90a1d8b2e24c0)(currentHomeValue, propertySettings);
        const purchasePrices = (0, $ea856d0766f9093e$export$3ea0a82cc525a565)(currentHomeValue, propertySettings);
        purchasePrices.forEach((newHomePurchasePrice)=>{
            const netProceeds = Math.max(0, salePrice - sellingCosts - newHomePurchasePrice);
            if (netProceeds <= 0) return;
            const baseScenario = {
                salePrice: salePrice,
                sellingCosts: sellingCosts,
                newHomePurchasePrice: newHomePurchasePrice
            };
            const surplusDetails = (0, $6737c18204fae40a$export$6f896b09251df0c4)(factFind, {
                ...baseScenario,
                useDownsizer: false
            });
            strategies.push({
                type: 'downsize',
                downsizeDetails: surplusDetails,
                currentHomeValue: currentHomeValue,
                newHomeValue: newHomePurchasePrice,
                name: `Downsize to $${newHomePurchasePrice.toLocaleString()} (surplus to cash)`,
                description: `Sell home and purchase smaller property; surplus $${netProceeds.toLocaleString()} to liquid assets`
            });
            if (downsizerEligible) {
                const downsizerDetails = (0, $6737c18204fae40a$export$6f896b09251df0c4)(factFind, {
                    ...baseScenario,
                    useDownsizer: true
                });
                strategies.push({
                    type: 'downsize',
                    downsizeDetails: downsizerDetails,
                    currentHomeValue: currentHomeValue,
                    newHomeValue: newHomePurchasePrice,
                    name: `Downsize to $${newHomePurchasePrice.toLocaleString()} (with downsizer)`,
                    description: `Downsize and contribute eligible proceeds to super via downsizer rules`
                });
                if ((0, $f1228be62b68f76b$export$d1b692f4d3924fcd)(factFind, 'client') || factFind?.adviceFor === 'couple' && (0, $f1228be62b68f76b$export$d1b692f4d3924fcd)(factFind, 'partner')) {
                    const abpDetails = (0, $6737c18204fae40a$export$6f896b09251df0c4)(factFind, {
                        ...baseScenario,
                        useDownsizer: true,
                        commenceIncomeStream: true
                    });
                    strategies.push({
                        type: 'downsize',
                        downsizeDetails: abpDetails,
                        currentHomeValue: currentHomeValue,
                        newHomeValue: newHomePurchasePrice,
                        name: `Downsize to $${newHomePurchasePrice.toLocaleString()} (downsizer to ABP)`,
                        description: `Downsize, contribute via downsizer rules, and commence account-based pension income where age-eligible (60+)`
                    });
                }
            }
            liabilities.forEach((liability)=>{
                const repayAmount = Math.min(liability.balance, netProceeds);
                if (repayAmount < 1000) return;
                const debtDetails = (0, $6737c18204fae40a$export$6f896b09251df0c4)(factFind, {
                    ...baseScenario,
                    useDownsizer: false,
                    repayDebt: true,
                    selectedDebtKey: liability.key,
                    debtRepayment: repayAmount
                });
                strategies.push({
                    type: 'downsize',
                    downsizeDetails: debtDetails,
                    currentHomeValue: currentHomeValue,
                    newHomeValue: newHomePurchasePrice,
                    name: `Downsize to $${newHomePurchasePrice.toLocaleString()} (repay ${liability.description})`,
                    description: `Downsize and apply $${repayAmount.toLocaleString()} of proceeds to ${liability.description}`
                });
            });
        });
    }
    // Reverse mortgage: lump-sum equity release at conservative LVR steps
    if (propertySettings.reverseMortgage) {
        const clientAge = (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client?.dob) || 65;
        const partnerAge = factFind?.adviceFor === 'couple' ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner?.dob) : null;
        const youngestAge = partnerAge ? Math.min(clientAge, partnerAge) : clientAge;
        const getMaxLVR = (age)=>{
            if (age >= 80) return 50;
            if (age >= 75) return 45;
            if (age >= 70) return 40;
            if (age >= 65) return 30;
            if (age >= 60) return 20;
            return 15;
        };
        const maxLVR = getMaxLVR(youngestAge);
        const maxLoanAmount = currentHomeValue * (maxLVR / 100);
        // Cap at 75% of age-based capacity — full drawdown rarely optimal vs home strategies and compounds debt heavily.
        [
            0.25,
            0.5,
            0.75
        ].forEach((ratio)=>{
            const loanAmount = Math.round(maxLoanAmount * ratio);
            if (loanAmount >= 50000) strategies.push({
                type: 'reverseMortgage',
                loanAmount: loanAmount,
                loanPercentage: Math.round(loanAmount / currentHomeValue * 100),
                interestRate: (0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279),
                loanStructure: 'lump_sum',
                establishmentFees: 0,
                name: `Reverse Mortgage ($${loanAmount.toLocaleString()} lump sum)`,
                description: `Access ${Math.round(ratio * 100)}% of age-based reverse mortgage capacity as assessable liquid assets`
            });
        });
    }
    // HEAS: test fortnightly payment steps up to a conservative cap
    if (propertySettings.heas) {
        const clientAge = (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client?.dob) || 67;
        const partnerAge = factFind?.adviceFor === 'couple' ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner?.dob) : null;
        const referenceAge = partnerAge ? Math.min(clientAge, partnerAge) : clientAge;
        const maxFortnightly = referenceAge >= 80 ? 1500 : referenceAge >= 75 ? 1200 : 1000;
        [
            250,
            500,
            750,
            1000
        ].filter((amt)=>amt <= maxFortnightly).forEach((paymentAmount)=>{
            strategies.push({
                type: 'heas',
                paymentAmount: paymentAmount,
                paymentFrequency: 'fortnightly',
                interestRate: 3.95,
                name: `HEAS ($${paymentAmount.toLocaleString()}/fortnight)`,
                description: 'Home Equity Access Scheme payments to supplement income (modelled against liquid assets)'
            });
        });
    }
    return strategies;
}
function $e4aa20091e5d9c16$export$dbb49eb4efdb716a(factFind, _problemStatement, reserve) {
    const strategies = [];
    const liabilities = (0, $6737c18204fae40a$export$eab989c41b911b05)(factFind);
    if (liabilities.length === 0) return strategies;
    const availableAssets = $e4aa20091e5d9c16$var$getSahAvailableAssets(factFind, reserve);
    if (availableAssets.length === 0) return strategies;
    liabilities.forEach((liability)=>{
        const fullSource = $e4aa20091e5d9c16$var$findOptimalAssetSource(availableAssets, liability.balance);
        if (fullSource) strategies.push({
            type: 'debtRepayment',
            liabilityKey: liability.key,
            repaymentAmount: liability.balance,
            liabilityDescription: liability.description,
            interestRate: liability.interestRate,
            fundingSources: fullSource.fundingSources,
            name: `Pay off ${liability.description} ($${liability.balance.toLocaleString()})`,
            description: `Liquidate assessable assets to fully repay ${liability.description} (balance $${liability.balance.toLocaleString()})`
        });
        const partialAmount = Math.round(liability.balance * 0.5);
        if (partialAmount >= 5000 && partialAmount < liability.balance) {
            const partialSource = $e4aa20091e5d9c16$var$findOptimalAssetSource(availableAssets, partialAmount);
            if (partialSource) strategies.push({
                type: 'debtRepayment',
                liabilityKey: liability.key,
                repaymentAmount: partialAmount,
                liabilityDescription: liability.description,
                interestRate: liability.interestRate,
                fundingSources: partialSource.fundingSources,
                name: `Partial repay ${liability.description} ($${partialAmount.toLocaleString()})`,
                description: `Repay 50% of ${liability.description} from liquid assets`
            });
        }
    });
    return strategies;
}
/**
 * Get available liquid assets for strategy funding
 */ function $e4aa20091e5d9c16$var$getSahAvailableAssets(factFind, reserve) {
    return (0, $3894d1f80ae86060$export$ec743f8ff1b409c2)(factFind, reserve ?? (0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind));
}
/** A buffer the annuity plans leave untouched on top of the emergency money (unchanged since the engine was built). */ const $e4aa20091e5d9c16$var$SAH_ANNUITY_CUSHION = 50000;
function $e4aa20091e5d9c16$export$8a06018655d03e9e(factFind, reserve) {
    const assets = $e4aa20091e5d9c16$var$getSahAvailableAssets(factFind, reserve).filter((a)=>a.available > 0);
    const total = assets.reduce((sum, asset)=>sum + asset.available, 0);
    const has = (type)=>assets.some((a)=>a.type === type);
    const parts = [
        has('bankAccounts') ? 'bank accounts' : null,
        has('termDeposits') ? 'term deposits' : null,
        has('shares') ? 'shares' : null,
        has('accountBasedPensions') ? 'part of the account-based pension' : null
    ].filter(Boolean);
    const madeOf = parts.length <= 1 ? parts[0] || 'savings' : `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}`;
    return {
        amount: Math.max(0, total - $e4aa20091e5d9c16$var$SAH_ANNUITY_CUSHION),
        madeOf: madeOf
    };
}
/**
 * Find optimal asset sources for a given amount (may return multiple assets)
 */ function $e4aa20091e5d9c16$var$findOptimalAssetSource(availableAssets, amount) {
    const fundingSources = [];
    let remainingAmount = amount;
    // Sort by priority (most liquid first)
    const sortedAssets = [
        ...availableAssets
    ].sort((a, b)=>a.priority - b.priority);
    // Try to fund from multiple assets. `asset.available` is already net of the recommended emergency reserve
    // (applied upstream in collectLiquidAssetsForSahSuggestions), so no second deduction is needed here.
    for (const asset of sortedAssets){
        if (remainingAmount <= 0) break;
        const availableFromAsset = asset.available;
        if (availableFromAsset > 0) {
            const amountToTake = Math.min(remainingAmount, availableFromAsset);
            fundingSources.push({
                ...asset,
                amountToTake: amountToTake,
                originalValue: asset.value
            });
            remainingAmount -= amountToTake;
        }
    }
    // If we couldn't fund the full amount, return null (strategy not viable)
    if (remainingAmount > 0) return null;
    // Return the first asset (for backward compatibility) but include all funding sources
    if (fundingSources.length > 0) return {
        ...fundingSources[0],
        fundingSources: fundingSources,
        totalAmount: amount
    };
    return null;
}
/**
 * Calculate current funeral bonds in factFind
 */ function $e4aa20091e5d9c16$var$calculateCurrentFuneralBonds(factFind) {
    const funeralBonds = factFind.assets?.funeralBonds || [];
    return funeralBonds.reduce((sum, bond)=>{
        return sum + (bond.value || 0);
    }, 0);
}
function $e4aa20091e5d9c16$export$53ab77308e46da54(singles) {
    const combos = [];
    /** The largest candidate of a type — the one with the most room to move the assessment. */ const largestOf = (type)=>{
        const ofType = singles.filter((s)=>s.type === type);
        if (ofType.length === 0) return null;
        const size = (s)=>Number(s.purchaseAmount ?? s.amount ?? 0);
        return ofType.reduce((best, s)=>size(s) > size(best) ? s : best);
    };
    const gift = largestOf('gifting');
    const bond = largestOf('funeralBonds');
    const annuity = largestOf('annuity');
    /** Applied in this order for the reason in the doc comment: certain and cheap first. */ const ORDER = [
        'gifting',
        'funeralBonds',
        'annuity',
        'downsize'
    ];
    const build = (steps, name, description)=>{
        const present = steps.filter(Boolean);
        if (present.length < 2) return;
        const ordered = [
            ...present
        ].sort((a, b)=>ORDER.indexOf(a.type) - ORDER.indexOf(b.type));
        combos.push({
            type: 'combination',
            steps: ordered,
            name: name,
            description: description,
            groupKey: `combination-${ordered.map((s)=>s.type).join('-')}`
        });
    };
    const money = (s)=>`$${Number(s?.purchaseAmount ?? s?.amount ?? 0).toLocaleString()}`;
    if (gift && bond) build([
        gift,
        bond
    ], `Gift ${money(gift)} and buy ${money(bond)} of funeral bonds`, 'Two small moves that stack: the gift leaves the assessment outright, the bond becomes exempt. Together they take more out of what Centrelink counts than either does alone.');
    if (gift && annuity) build([
        gift,
        annuity
    ], `Gift ${money(gift)} and buy a ${money(annuity)} annuity`, 'The gift leaves the assessment outright; the annuity is then counted at only 60% of what it costs. The annuity does the heavy lifting and the gift clears the last of the threshold.');
    if (bond && annuity) build([
        bond,
        annuity
    ], `Buy ${money(bond)} of funeral bonds and a ${money(annuity)} annuity`, 'The bond is exempt and the annuity is counted at 60%, so between them a large share of the assessable pool stops being counted in full.');
    if (gift && bond && annuity) build([
        gift,
        bond,
        annuity
    ], `Gift ${money(gift)}, buy ${money(bond)} of funeral bonds and a ${money(annuity)} annuity`, 'All three asset-reduction levers together. Each takes a different slice out of what Centrelink counts, and the contribution rates fall with the total.');
    /*
     * The downsize is what CREATES the cash the small levers then use, so it is worth pairing even
     * though the downsize family already varies its own options. Only the largest downsize is
     * paired: the others differ in the new home price, which changes how much cash there is, not
     * what a gift or a bond then does with it.
     */ const downsize = largestOf('downsize');
    if (downsize) {
        if (bond) build([
            downsize,
            bond
        ], `${downsize.name}, and buy ${money(bond)} of funeral bonds`, 'The sale frees up cash that Centrelink then counts in full. Moving part of it into a funeral bond makes that part exempt again, which is the simplest way to soften the downsizing trap.');
        if (gift) build([
            downsize,
            gift
        ], `${downsize.name}, and gift ${money(gift)}`, 'The sale frees up cash that Centrelink then counts in full. Gifting part of it within the yearly free area takes that part out of the assessment straight away.');
    }
    return combos;
}
const $e4aa20091e5d9c16$export$3248810e94763dc6 = (0, $485d903040fc3504$export$fe12727427ec68c1);
/** The steps a candidate is made of (a combination's, or itself). */ const $e4aa20091e5d9c16$var$stepsOf = (c)=>c.type === 'combination' && Array.isArray(c.steps) ? c.steps : [
        c
    ];
function $e4aa20091e5d9c16$export$d52088fa735491dc(candidates, factFind, reserve) {
    // Which debts: strategy/debtsToTest.ts (never a card paid off monthly; any interest-bearing debt, whatever its
    // size; interest-free debts from SAH_DEBT_TWIN_FLOOR), the rule every module uses (26 Oct 2026).
    const debts = (0, $6737c18204fae40a$export$eab989c41b911b05)(factFind);
    if (debts.length === 0) return [];
    const assets = $e4aa20091e5d9c16$var$getSahAvailableAssets(factFind, reserve);
    if (assets.length === 0) return [];
    const twins = [];
    for (const c of candidates){
        const steps = $e4aa20091e5d9c16$var$stepsOf(c);
        // Debt already in the plan (on its own, in a combination, or repaid from a downsize) is not doubled.
        if (steps.some((s)=>s.type === 'debtRepayment' || s.type === 'doNothing' || s.type === 'downsize' && s.downsizeDetails?.repayDebt)) continue;
        // What this plan leaves of each account.
        const used = new Map();
        for (const st of steps)for (const f of st.fundingSources || [])used.set(`${f.type}-${f.id}`, (used.get(`${f.type}-${f.id}`) || 0) + (Number(f.amountToTake) || 0));
        const left = assets.map((a)=>({
                ...a,
                available: Math.max(0, a.available - (used.get(`${a.type}-${a.id}`) || 0))
            }));
        const debtSteps = [];
        let ok = true;
        for (const d of debts){
            const source = $e4aa20091e5d9c16$var$findOptimalAssetSource(left, d.balance);
            if (!source) {
                ok = false;
                break;
            }
            for (const f of source.fundingSources){
                const a = left.find((x)=>x.type === f.type && String(x.id) === String(f.id));
                if (a) a.available = Math.max(0, a.available - (Number(f.amountToTake) || 0));
            }
            debtSteps.push({
                type: 'debtRepayment',
                liabilityKey: d.key,
                repaymentAmount: d.balance,
                liabilityDescription: d.description,
                interestRate: d.interestRate,
                fundingSources: source.fundingSources,
                name: `Pay off ${d.description} ($${d.balance.toLocaleString()})`,
                description: `Repay ${d.description} in full from savings the plan leaves untouched`
            });
        }
        if (!ok || debtSteps.length === 0) continue;
        twins.push({
            type: 'combination',
            // The plan first, as it stands, then the debts from what it leaves.
            steps: [
                ...steps,
                ...debtSteps
            ],
            name: `${c.name || 'This plan'}, and clear the debts`,
            description: `${c.description || ''} The debts are then paid off from savings the plan leaves untouched.`.trim(),
            groupKey: `${String(c.groupKey ?? c.name ?? c.type)}-clear-debt`,
            clearsDebt: true
        });
    }
    return twins;
}
function $e4aa20091e5d9c16$export$931e02ce02c6f432(factFind, problemStatement, strategySettings) {
    const allStrategies = [];
    // Generate gifting strategies (if enabled and relevant)
    if (strategySettings.includeGifting) {
        const giftingStrategies = $e4aa20091e5d9c16$export$367eaf68e2370e55(factFind, problemStatement, strategySettings.emergencyReserve);
        allStrategies.push(...giftingStrategies);
    }
    // Generate funeral bond strategies (if enabled and relevant)
    if (strategySettings.includeFuneralBonds) {
        const funeralBondStrategies = $e4aa20091e5d9c16$export$7a81cb11f4bdf617(factFind, problemStatement, strategySettings.emergencyReserve);
        allStrategies.push(...funeralBondStrategies);
    }
    // Generate annuity strategies (if enabled)
    if (strategySettings.includeAnnuities) {
        const annuityStrategies = $e4aa20091e5d9c16$export$b7a0d0e4c68718fd(factFind, problemStatement, strategySettings.emergencyReserve);
        allStrategies.push(...annuityStrategies);
    }
    // Generate property strategies (if enabled)
    if (strategySettings.includePropertyStrategies) {
        const propertyStrategies = $e4aa20091e5d9c16$export$cfe54d95cd93699b(factFind, problemStatement, strategySettings.propertyStrategies || {}, strategySettings.emergencyReserve);
        allStrategies.push(...propertyStrategies);
    }
    // Debt repayment (when liabilities exist; enabled by default)
    if (strategySettings.includeDebtRepayment !== false) {
        const debtStrategies = $e4aa20091e5d9c16$export$dbb49eb4efdb716a(factFind, problemStatement, strategySettings.emergencyReserve);
        allStrategies.push(...debtStrategies);
    }
    // Whole entity IP sale (include gate only; independent of property-strategy toggles). Cast: the
    // (separately-typed) EntityIpSaleStrategy shape has no index signature, but structurally satisfies
    // StrategyCandidate's known fields (type/name/description/investmentPropertyDetails/...).
    allStrategies.push(...(0, $3894d1f80ae86060$export$7219869b3d9469c6)(factFind));
    // Last, so every single-lever candidate above is available to combine. See
    // generateCombinationStrategies for which combinations are built and why only those.
    allStrategies.push(...$e4aa20091e5d9c16$export$53ab77308e46da54(allStrategies));
    // Every plan also tried with the debts cleared, unless the client switched debt repayment off.
    if (strategySettings.includeDebtRepayment !== false) allStrategies.push(...$e4aa20091e5d9c16$export$d52088fa735491dc(allStrategies, factFind, strategySettings.emergencyReserve));
    return allStrategies;
}





/**
 * Support at Home — Digital Statement of Advice.
 *
 * The SAH twin of AgedCareSuggestionEngineDigitalSOAAttachment.tsx, deliberately mirroring its
 * shape: a flat, serialisable SNAPSHOT built once (buildSupportAtHomeDigitalSOASnapshot), a pure
 * HTML renderer over it (buildHtml — exported for tests), and open/download plumbing
 * (openSupportAtHomeDigitalSOAAttachment). The snapshot is persisted onto the saved strategy
 * (`soaSnapshot`) so the document can be reopened exactly as generated.
 *
 * Two structural differences from the aged care version, both deliberate:
 *  - it is built from a SAVED home-care strategy (either mode), not live screen state — the
 *    document always matches something on file;
 *  - the strategy narrative (what it is / benefits / risks / suitability) comes from
 *    sahStrategyExplainers.ts, the same library the insight panel renders — screen and SOA can
 *    never tell the client different stories.
 *
 * RAD/room-price sections are replaced by what matters for home care: the contribution-rate
 * assessment (including any Services Australia assessment-letter override, disclosed with its
 * provenance) and the service plan the modelling used.
 */ 















/**
 * "With Matthew moving into aged care" (owner, 24 Oct 2026: "it should clearly call this out — with
 * Matthew moving into aged care, the following assets were used, and this is what's left over ... a
 * client shouldn't in theory need to open up the financial modelling to try and work out whether it's
 * been done correctly or not").
 *
 * Read off the two households the figures use — the profile as entered, and the household once the
 * chosen aged care plan has been carried out (useSahBaseline's linkedCare) — so it says what the
 * modelling did, not what it was meant to do. One derivation (`linkedCareStory`) for step 2, the plan
 * page and the advice document.
 */ 
parcelRequire("acw62");



const $a109d47f19f08f50$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(Math.abs(n)));
/** Plain names for the asset groups, as a client would say them. */ const $a109d47f19f08f50$var$GROUP_WORDS = {
    bankAccounts: 'Bank account',
    termDeposits: 'Term deposit',
    shares: 'Shares',
    investmentBonds: 'Investment bond',
    superannuation: 'Super',
    accountBasedPensions: 'Account-based pension',
    annuities: 'Lifetime income (annuity)',
    funeralBonds: 'Funeral bond',
    prepaidFuneral: 'Prepaid funeral',
    loansToOthers: 'Money lent to family',
    personalAssets: 'Car and contents',
    investmentProperty: 'Investment property',
    other: 'Other'
};
/** Groups that are not savings the household draws on, or are the deposit itself. */ const $a109d47f19f08f50$var$NOT_LEFT = new Set([
    'radPaid',
    'personalAssets'
]);
const $a109d47f19f08f50$var$num = (v)=>parseFloat(String(v ?? 0)) || 0;
function $a109d47f19f08f50$var$itemsOf(ff, names) {
    const assets = ff?.assets || {};
    const raw = [];
    // Matched before and after by group, name and owner (and the nth of those), not by position: a plan
    // can drop a sold asset from the list.
    const seen = new Map();
    for (const [group, list] of Object.entries(assets)){
        if (!Array.isArray(list)) continue;
        list.forEach((r)=>{
            const base = String(r?.description || $a109d47f19f08f50$var$GROUP_WORDS[group] || group).trim();
            const id = `${group}|${base}|${r?.ownership ?? ''}`;
            const nth = seen.get(id) || 0;
            seen.set(id, nth + 1);
            raw.push({
                key: `${id}|${nth}`,
                label: base,
                group: group,
                value: $a109d47f19f08f50$var$num(r?.value)
            });
        });
    }
    // Two accounts with the same name say whose they are (owner, 22 Oct 2026: "MLC ABP, MLC ABP").
    const counts = new Map();
    raw.forEach((it)=>counts.set(it.label, (counts.get(it.label) || 0) + 1));
    return raw.map((it)=>{
        if ((counts.get(it.label) || 0) < 2) return it;
        const own = it.key.split('|')[2];
        const who = own === 'client' ? names.client : own === 'partner' ? names.partner : own === 'joint' ? 'joint' : '';
        return who ? {
            ...it,
            label: `${it.label} (${who === 'joint' ? 'joint' : `${who}'s`})`
        } : it;
    });
}
const $a109d47f19f08f50$var$debtsOf = (ff)=>Object.values(ff?.liabilities || {}).flatMap((list)=>Array.isArray(list) ? list : []).reduce((t, r)=>t + $a109d47f19f08f50$var$num(r.balance ?? r.value), 0);
function $a109d47f19f08f50$export$f59d8746d20e5371(lc) {
    const ff = lc.before;
    const names = {
        client: String(ff?.client?.firstName || 'the client'),
        partner: String(ff?.partner?.firstName || 'the partner')
    };
    const entering = (0, $5ea55f03cd2af1e4$export$2205ffc60cf2c238)(ff);
    const enteringName = entering === 'partner' ? names.partner : names.client;
    const stayingName = entering === 'partner' ? names.client : names.partner;
    const before = $a109d47f19f08f50$var$itemsOf(lc.before, names);
    const after = $a109d47f19f08f50$var$itemsOf(lc.after, names);
    const afterByKey = new Map(after.map((a)=>[
            a.key,
            a
        ]));
    const beforeKeys = new Set(before.map((b)=>b.key));
    const deposit = after.filter((a)=>a.group === 'radPaid').reduce((t, a)=>t + a.value, 0) - before.filter((b)=>b.group === 'radPaid').reduce((t, b)=>t + b.value, 0);
    const used = before.filter((b)=>b.group !== 'radPaid').map((b)=>({
            label: b.label,
            before: b.value,
            after: afterByKey.get(b.key)?.value ?? 0
        })).filter((r)=>r.before - r.after >= 1);
    const added = after.filter((a)=>a.group !== 'radPaid' && !beforeKeys.has(a.key) && a.value >= 1).map((a)=>({
            label: a.label,
            value: a.value
        }));
    const left = after.filter((a)=>!$a109d47f19f08f50$var$NOT_LEFT.has(a.group) && a.value >= 1).map((a)=>({
            label: a.label,
            value: a.value
        }));
    const homeBefore = $a109d47f19f08f50$var$num(lc.before?.home?.value);
    const homeAfter = $a109d47f19f08f50$var$num(lc.after?.home?.value);
    return {
        enteringName: enteringName,
        stayingName: stayingName,
        planTitle: (0, $95e43332fd84eec4$export$6cc0d9545ae1511e)(lc.record, ff),
        whole: lc.whole,
        reason: lc.reason,
        caveats: lc.caveats,
        deposit: Math.max(0, deposit),
        used: used,
        added: added,
        debtsCleared: Math.max(0, $a109d47f19f08f50$var$debtsOf(lc.before) - $a109d47f19f08f50$var$debtsOf(lc.after)),
        homeSold: homeBefore > 0 && homeAfter < 1,
        fees: Number(lc.details?.annualCost) || 0,
        living: lc.details?.livingExpenses != null ? Number(lc.details.livingExpenses) : null,
        left: left,
        leftTotal: left.reduce((t, l)=>t + l.value, 0)
    };
}
const $a109d47f19f08f50$export$73c5c6d74b068b0e = (enteringName)=>`The room deposit is not spent: it is refunded when ${enteringName} leaves care, less anything drawn from it for fees, and until then it still counts in what is left to the family.`;
const $a109d47f19f08f50$var$Line = ({ label: label, value: value, strong: strong, sub: sub })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-baseline justify-between gap-4 py-1.5 text-[14px]",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: strong ? 'font-semibold text-slate-900' : 'text-slate-700',
                children: [
                    label,
                    sub && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "block text-[12.5px] font-normal text-slate-500",
                        children: sub
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: `shrink-0 tabular-nums ${strong ? 'font-bold text-brand-navy' : 'text-slate-800'}`,
                children: value
            })
        ]
    });
function $a109d47f19f08f50$export$c58a16d65aeb138a({ linkedCare: linkedCare, testId: testId = 'sah-linked-care', refundNote: refundNote = true }) {
    const s = $a109d47f19f08f50$export$f59d8746d20e5371(linkedCare);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[15px] leading-relaxed text-slate-700",
                children: [
                    "These figures include ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                        className: "text-slate-900",
                        children: [
                            s.enteringName,
                            "'s chosen aged care plan"
                        ]
                    }),
                    ", \u201C",
                    s.planTitle,
                    "\u201D,",
                    s.whole ? ' carried out in full: everything below has already happened before any Support at home plan is tested.' : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " with only its room deposit, fees and living costs: ",
                            s.reason || 'the rest of the plan could not be rebuilt just now.'
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 grid gap-x-8 gap-y-4 md:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[13px] font-semibold text-brand-navy",
                                children: "What the aged care plan uses"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-1 divide-y divide-slate-100 border-y border-slate-100",
                                children: [
                                    s.deposit >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a109d47f19f08f50$var$Line, {
                                        strong: true,
                                        label: "Room deposit (RAD) paid",
                                        value: $a109d47f19f08f50$var$money(s.deposit)
                                    }),
                                    s.used.map((u)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a109d47f19f08f50$var$Line, {
                                            label: u.label,
                                            value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    $a109d47f19f08f50$var$money(u.before),
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-slate-400",
                                                        children: "\u2192"
                                                    }),
                                                    " ",
                                                    $a109d47f19f08f50$var$money(u.after)
                                                ]
                                            })
                                        }, u.label)),
                                    s.added.map((a)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a109d47f19f08f50$var$Line, {
                                            label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    a.label,
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-slate-500",
                                                        children: "(new)"
                                                    })
                                                ]
                                            }),
                                            value: $a109d47f19f08f50$var$money(a.value)
                                        }, a.label)),
                                    s.debtsCleared >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a109d47f19f08f50$var$Line, {
                                        label: "Debts paid off",
                                        value: $a109d47f19f08f50$var$money(s.debtsCleared)
                                    }),
                                    s.homeSold && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a109d47f19f08f50$var$Line, {
                                        label: "The home",
                                        value: "sold"
                                    }),
                                    s.fees >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a109d47f19f08f50$var$Line, {
                                        label: "Yearly care fees",
                                        sub: "daily fee, means-tested fee and any daily accommodation payment, paid from the household each year",
                                        value: `${$a109d47f19f08f50$var$money(s.fees)} a year`
                                    }),
                                    s.living != null && s.living >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a109d47f19f08f50$var$Line, {
                                        label: `Living costs at home for ${s.stayingName}`,
                                        value: `${$a109d47f19f08f50$var$money(s.living)} a year`
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-[13px] font-semibold text-brand-navy",
                                children: [
                                    "What is left for ",
                                    s.stayingName,
                                    " at home"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-1 divide-y divide-slate-100 border-y border-slate-100",
                                children: [
                                    s.left.map((l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a109d47f19f08f50$var$Line, {
                                            label: l.label,
                                            value: $a109d47f19f08f50$var$money(l.value)
                                        }, l.label)),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a109d47f19f08f50$var$Line, {
                                        strong: true,
                                        label: "Savings left",
                                        value: $a109d47f19f08f50$var$money(s.leftTotal)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            refundNote && s.deposit >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-3 text-[13.5px] leading-relaxed text-slate-600",
                children: $a109d47f19f08f50$export$73c5c6d74b068b0e(s.enteringName)
            }),
            s.caveats.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "mt-2 text-[13px] text-slate-500",
                    children: c
                }, c))
        ]
    });
}






/*
 * THE GUARANTEED INCOME SECTION (owner, 21 Oct 2026 — the guaranteed income review R1–R4, mock-up screen 5).
 * A plan with a guaranteed income gets its own section: the words for its type, the income and where the
 * figure came from (the published rates' date and whether they are stale, or a quote), what the family
 * receives year by year if the person passes away, the best plan tested without one, the assumptions in plain
 * words (the figures assume the person lives the whole period), the client's dated answers, and for income
 * only the confirmation word for word. Built by the shared section (features/advice/soaGuaranteedIncome.ts).
 */ function $39348679b8be0d72$var$sahStrategyAnnuityOf(strategy) {
    const inputs = strategy?.inputs || {};
    const seConfig = inputs.seConfig;
    if (seConfig) return (0, $dd66c4f756bb6b40$export$39e91763b583ca80)(seConfig);
    if (inputs.selectedFundingStrategy !== 'annuity') return null;
    const record = inputs.annuityRecordForCalculation || inputs.annuityRecord;
    // The only piece: no gift, bond, property move or debt set beside it.
    const others = Number(inputs.gifting) > 0 || Number(inputs.funeralBonds) > 0 || !!inputs.propertyStrategy && inputs.propertyStrategy !== 'none' || Object.values(inputs.debtPayments || {}).some((v)=>Number(v) > 0);
    return (0, $dd66c4f756bb6b40$export$c49e25d370aaca5c)(record, !others);
}
function $39348679b8be0d72$export$4e6ff46ddc24b76(params) {
    const a = $39348679b8be0d72$var$sahStrategyAnnuityOf(params.strategy);
    if (!a) return null;
    const list = params.analysisStrategies || [];
    const doNothing = list.find((s)=>s.config?.type === 'doNothing') || null;
    const outputs = params.strategy.outputs || {};
    const figures = (s)=>({
            estate: $39348679b8be0d72$var$toNumber(s.projectedEstateValue ?? s.snapshot?.legacyValue),
            pension: $39348679b8be0d72$var$toNumber(s.snapshot?.pension),
            cashflow: $39348679b8be0d72$var$toNumber(s.snapshot?.netCashflow ?? s.snapshot?.cashflow)
        });
    // The best plan tested WITHOUT a guaranteed income (the support alone among them), by what it leaves the family.
    const without = list.filter((s)=>!(0, $dd66c4f756bb6b40$export$39e91763b583ca80)(s.config) && (s.snapshot != null || s.projectedEstateValue != null));
    const best = without.reduce((b, s)=>!b || figures(s).estate > figures(b).estate ? s : b, null);
    const record = (params.strategy.inputs || {}).annuityRecord;
    return (0, $66827b1304244a1d$export$11aaa304d9182b)({
        factFind: params.factFind,
        personName: (0, $dd66c4f756bb6b40$export$b2f4bd9ebed41c37)(params.factFind, a.owner),
        amount: a.amount,
        kind: a.kind,
        incomeAYear: (0, $dd66c4f756bb6b40$export$75e3f249f9924fd2)(params.rows, params.factFind),
        quoted: record?.incomeOverride != null && Number(record.incomeOverride) > 0,
        rows: params.rows,
        compareRows: a.only ? doNothing?.projections || null : null,
        compareNote: a.only ? (0, $dd66c4f756bb6b40$export$ea81c21b74f64dcc) : null,
        horizonYears: params.horizonYears,
        plan: {
            estate: $39348679b8be0d72$var$toNumber(outputs.legacyEstimate),
            pension: $39348679b8be0d72$var$toNumber(outputs.agePension),
            cashflow: $39348679b8be0d72$var$toNumber(outputs.cashFlow)
        },
        alternative: best ? {
            name: $39348679b8be0d72$var$sanitizeText(best.name || 'The support alone'),
            ...figures(best)
        } : null
    });
}

// Served as a same-origin <script src> in the popup HTML rather than inlined, so the popup doesn't
// need 'unsafe-inline' in script-src — same pattern (and same runtime) as the aged care SOA.
const $39348679b8be0d72$var$soaBookletScriptUrl = new URL($7ed81d1f360bfd38$exports).href;
// ── small helpers (mirroring the aged care attachment's private ones) ───────────────────────────
function $39348679b8be0d72$var$toNumber(value) {
    const parsed = parseFloat(String(value));
    return Number.isFinite(parsed) ? parsed : 0;
}
function $39348679b8be0d72$var$sanitizeText(value) {
    return String(value || '').replace(/Ã¢â‚¬â€œ|â€“/g, '-').replace(/Ã¢â‚¬â€”|â€”/g, '-').replace(/Ã¢â‚¬â„¢|â€™/g, "'").replace(/Ã¢â‚¬Å“|Ã¢â‚¬Â|â€œ|â€/g, '"').replace(/Ã‚/g, '').trim();
}
function $39348679b8be0d72$var$formatDateOnly(dateValue) {
    return new Date(dateValue).toLocaleDateString('en-AU', {
        year: 'numeric',
        month: 'long',
        day: '2-digit'
    });
}
function $39348679b8be0d72$var$pct(value) {
    return `${((Number(value) || 0) * 100).toFixed(1)}%`;
}
/** Default income/growth rates per asset type — mirrors the aged care SOA's appendix table. */ /** A field key as a label: `home_care_for` and `annuityAppetite` both read "Home Care For" / "Annuity Appetite". */ function $39348679b8be0d72$var$prettify(text) {
    const words = String(text || '').replace(/([A-Z])/g, ' $1').split(/[_\s]+/).filter(Boolean);
    return $39348679b8be0d72$var$sanitizeText(words.map((w)=>w.charAt(0).toUpperCase() + w.slice(1)).join(' '));
}
function $39348679b8be0d72$export$57a9131fd362a631(value) {
    if (value === null || value === undefined || value === '') return 'Not provided';
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    const text = String(value);
    if (/^[a-z][a-z0-9_ ]*$/i.test(text) && !/^\d/.test(text)) {
        const spaced = text.replace(/_/g, ' ');
        return $39348679b8be0d72$var$sanitizeText(spaced.charAt(0).toUpperCase() + spaced.slice(1));
    }
    return $39348679b8be0d72$var$sanitizeText(text);
}
function $39348679b8be0d72$var$flattenObject(value, prefix = '') {
    if (value === null || value === undefined) return [];
    if (Array.isArray(value)) return value.flatMap((item, idx)=>$39348679b8be0d72$var$flattenObject(item, `${prefix}[${idx}]`));
    if (typeof value === 'object') return Object.entries(value).flatMap(([key, nested])=>$39348679b8be0d72$var$flattenObject(nested, prefix ? `${prefix}.${key}` : key));
    return [
        {
            key: prefix,
            value: String(value)
        }
    ];
}
const $39348679b8be0d72$var$GOAL_LABELS = {
    home_care: 'Access home care support',
    aged_care: 'Move into residential aged care',
    downsize_home: 'Downsize the family home',
    retirement_village: 'Move to a retirement village',
    granny_flat: 'Explore granny flat arrangements',
    meet_costs: 'Meet care costs',
    maximise_support: 'Maximise government support',
    preserve_assets: 'Preserve assets for inheritance',
    funding_guidance: 'Guidance on funding options'
};
function $39348679b8be0d72$var$servicePlanSideRows(side) {
    const rows = [];
    if (!side) return rows;
    const catalogue = Object.values((0, $25e9acc02c907060$export$a3b71735b810a98c)).flatMap((c)=>c.services.map((s)=>({
                ...s,
                category: c.label
            })));
    Object.entries(side).forEach(([serviceId, allocation])=>{
        const quantity = Number(allocation?.quantity) || 0;
        if (quantity <= 0) return;
        const frequency = allocation?.frequency || 'monthly';
        const entry = catalogue.find((s)=>s.id === serviceId);
        // 365 days and 52 weeks a year — the cost engine's convention since 19 Oct 2026 (was ×30 / ×4 a month).
        const perMonth = frequency === 'daily' ? quantity * 365 / 12 : frequency === 'weekly' ? quantity * 52 / 12 : quantity;
        rows.push({
            name: entry?.name || serviceId,
            detail: `${quantity}/${frequency === 'daily' ? 'day' : frequency === 'weekly' ? 'week' : 'month'} \xb7 ${entry?.category || ''}`,
            annual: (entry?.medianPrice || 0) * perMonth * 12
        });
    });
    return rows.sort((a, b)=>b.annual - a.annual);
}
function $39348679b8be0d72$export$69394aa6d059d3a8(strategy) {
    const inputs = strategy?.inputs || {};
    const seConfig = inputs.seConfig;
    const seType = seConfig?.type;
    // A combination is explained step by step (owner's test, 24 Oct 2026: "Spend $416,000 on the home and
    // pay off the credit card" was printed as "makes no changes to your position (do nothing)").
    if (seType === 'combination') {
        const stepTypes = (seConfig?.steps || []).map((s)=>String(s?.type || '')).filter((t)=>(0, $f6fa0c4ae572e255$export$db6db87c4063fbb3)[t]);
        return [
            ...new Set(stepTypes)
        ];
    }
    if (seType) return (0, $f6fa0c4ae572e255$export$db6db87c4063fbb3)[seType] ? [
        seType
    ] : [];
    const types = [];
    if ($39348679b8be0d72$var$toNumber(inputs.gifting) > 0) types.push('gifting');
    if ($39348679b8be0d72$var$toNumber(inputs.funeralBonds) > 0) types.push('funeralBonds');
    const property = String(inputs.propertyStrategy || 'none');
    if (property !== 'none' && (0, $f6fa0c4ae572e255$export$db6db87c4063fbb3)[property]) types.push(property);
    if (inputs.selectedFundingStrategy === 'annuity' && inputs.annuityRecord) types.push('annuity');
    const overall = inputs.overallStrategy || {};
    if (overall.reverseMortgage && !types.includes('reverseMortgage')) types.push('reverseMortgage');
    if (overall.heas && !types.includes('heas')) types.push('heas');
    return types;
}
async function $39348679b8be0d72$export$87f72c2469f493ab(params) {
    const { selectedStrategy: selectedStrategy, factFind: factFind } = params;
    if (!selectedStrategy || !factFind) return null;
    // Baseline (do nothing) position, fetched fresh — the same discipline as the aged care builder.
    const baselineFinancials = await $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind);
    const baselineContributions = await $55a1d8a64f1e5dfa$export$3fe0e13ec85e5380(factFind, baselineFinancials, 'standard', null, true, 0, 0.5, {});
    const isCouple = factFind?.adviceFor === 'couple';
    const baselineBranch = (isCouple ? baselineContributions?.combined : baselineContributions?.client) || {};
    const outputs = selectedStrategy.outputs || {};
    const strategyRates = outputs.contributionRates || baselineBranch.contributionRates || {};
    const override = factFind.sahContributionRateOverride || null;
    const clientRows = $39348679b8be0d72$var$servicePlanSideRows(params.servicePlan?.client);
    const partnerRows = isCouple ? $39348679b8be0d72$var$servicePlanSideRows(params.servicePlan?.partner) : [];
    const narrativeTypes = $39348679b8be0d72$export$69394aa6d059d3a8(selectedStrategy);
    const projections = (params.projections || []).map((row, index)=>({
            label: $39348679b8be0d72$var$sanitizeText(row.fyLabel || `Year ${index + 1}`),
            pension: $39348679b8be0d72$var$toNumber(row.socialSecurity),
            sahCost: $39348679b8be0d72$var$toNumber(row.annualCareCostForPartialPeriod ?? row.annualCareCost),
            cashflow: $39348679b8be0d72$var$toNumber(row.cashFlow ?? row.cashflow),
            netWorth: $39348679b8be0d72$var$toNumber(row.netWorth)
        }));
    const alternatives = (params.analysis?.strategies || []).map((s)=>({
            name: $39348679b8be0d72$var$sanitizeText(s.name || 'Strategy'),
            type: String(s.config?.type || ''),
            legacy: $39348679b8be0d72$var$toNumber(s.projectedEstateValue ?? s.snapshot?.legacyValue),
            cashflow: $39348679b8be0d72$var$toNumber(s.snapshot?.netCashflow ?? s.snapshot?.cashflow),
            pension: $39348679b8be0d72$var$toNumber(s.snapshot?.pension),
            selected: $39348679b8be0d72$var$sanitizeText(s.name || '') === $39348679b8be0d72$var$sanitizeText(selectedStrategy.name || '')
        }));
    const structureAppendix = (0, $f70ff3a065f941e2$export$7a9a83c1f9700f91)(factFind, {
        strategySource: params.strategySource
    });
    // The do-nothing legacy, when the analysis carried it — the exec summary's estate comparison.
    const doNothingAlt = (params.analysis?.strategies || []).find((s)=>s.config?.type === 'doNothing');
    /*
     * ONE YEARLY CASHFLOW, AFTER THE CONTRIBUTION (owner's test, 24 Oct 2026: the summary said -$6,026 a
     * year while the plan card and the alternatives page said -$20,086 for the same plan). An engine plan
     * is saved with the cashflow before what they pay for the services; the engine's own snapshot carries
     * it after, as the card shows, and its do-nothing run does the same. Both sides are taken from there,
     * so "Each year, after costs" is after costs on both.
     */ const engineNet = Number(outputs.seSnapshot?.netCashflow);
    const doNothingNet = Number(doNothingAlt?.snapshot?.netCashflow);
    const netFromEngine = Number.isFinite(engineNet) && Number.isFinite(doNothingNet);
    const baselineLegacy = doNothingAlt ? $39348679b8be0d72$var$toNumber(doNothingAlt.projectedEstateValue ?? doNothingAlt.snapshot?.legacyValue) : null;
    // After-strategy assessable position, from the saved strategy's own financials when carried.
    const outputsFinancials = outputs.financials || {};
    const assetRows = Object.entries(factFind?.assets || {}).flatMap(([assetType, assets])=>(assets || []).map((asset)=>({
                assetType: $39348679b8be0d72$var$prettify(assetType),
                description: $39348679b8be0d72$var$sanitizeText(asset.description || 'Unnamed Asset'),
                value: $39348679b8be0d72$var$toNumber(asset.value),
                // The figures the MODEL used — for a property that is the recorded rent and expenses,
                // never an assumed yield. See shared/src/calculation/assetAssumptionRows.ts.
                ...(0, $061bee36071dd9d5$export$53e371969067f999)(assetType, asset)
            })));
    // Only the ticked goals: the goals object also carries settings (legacyYears, dzMotive, …) and on/off
    // flags (dzPrimerSeen, sahSetupSeen, …), so only a key with a goal label is a goal (24 Oct 2026: "Rv
    // Primer Seen" was printed among the client's goals).
    const goals = Object.entries(factFind?.goals || {}).filter(([key, on])=>on === true && $39348679b8be0d72$var$GOAL_LABELS[key]).map(([key])=>$39348679b8be0d72$var$GOAL_LABELS[key]);
    return {
        documentKind: 'support_at_home',
        reportId: `SAH-${Date.now().toString(36).toUpperCase()}`,
        generatedAt: new Date().toISOString(),
        strategySource: params.strategySource,
        // A hand-built plan that began as a tested one ("Customise this plan", 25 Oct 2026): that plan's title.
        customisedFrom: params.strategySource === 'manual_control' && selectedStrategy.customisedFrom ? $39348679b8be0d72$var$sanitizeText(selectedStrategy.customisedFrom) : null,
        clientName: $39348679b8be0d72$var$sanitizeText(factFind?.client?.firstName || 'Client'),
        partnerName: isCouple ? $39348679b8be0d72$var$sanitizeText(factFind?.partner?.firstName || '') : '',
        clientAge: factFind?.client?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client.dob) : null,
        completerDisplay: $39348679b8be0d72$var$sanitizeText(factFind?.completerFirstName || ''),
        goals: goals,
        selectedStrategyName: $39348679b8be0d72$var$sanitizeText(selectedStrategy.name || 'Selected strategy'),
        narrativeTypes: narrativeTypes,
        // The same "What could go wrong" list the card shows (strategyRisks.ts), so the document and
        // the screen cannot disagree about the risks of the chosen strategy.
        strategyRisks: (0, $203e38d6e6c434f4$export$124603ee0434ece5)(narrativeTypes.flatMap((type)=>(0, $203e38d6e6c434f4$export$e1aeab26ad581b54)(type, String(selectedStrategy.name || '')))),
        // Disclose when the modelling was run against a LINKED aged care scenario (one partner
        // modelled in residential care — illness-separated pension treatment may apply).
        agedCareLinked: (selectedStrategy.inputs || {}).agedCareContext === 'linked',
        // What the partner's aged care plan did, in the words step 2 and the plan page use (24 Oct 2026).
        linkedCare: params.linkedCare ? (0, $a109d47f19f08f50$export$f59d8746d20e5371)(params.linkedCare) : null,
        // Headline outcomes — from the SAVED strategy's own outputs.
        annualPension: $39348679b8be0d72$var$toNumber(outputs.agePension),
        annualContribution: $39348679b8be0d72$var$toNumber(outputs.annualContribution),
        annualCashflow: netFromEngine ? engineNet : $39348679b8be0d72$var$toNumber(outputs.cashFlow),
        projectedLegacy: $39348679b8be0d72$var$toNumber(outputs.legacyEstimate),
        baseline: {
            pension: $39348679b8be0d72$var$toNumber(baselineFinancials.socialSecurity),
            // Net of the baseline contribution when the strategy's own cashflow is: StrategiesSection
            // saves the panel's figure, which nets the service plan's share the way the Service
            // Builder does, and says so in `cashFlowBasis`. A strategy saved before that carries the
            // gross figure and is compared gross — never net against gross.
            cashflow: netFromEngine ? doNothingNet : $39348679b8be0d72$var$toNumber(baselineFinancials.cashFlow) - (outputs.cashFlowBasis === 'net_of_service_plan' ? $39348679b8be0d72$var$toNumber(baselineBranch?.contributionAmounts?.totalAnnual) : 0),
            assessableAssets: $39348679b8be0d72$var$toNumber(baselineFinancials.assessableAssets),
            assessableIncome: $39348679b8be0d72$var$toNumber(baselineFinancials.totalAssessableIncome),
            pensionStatus: String(baselineBranch.pensionStatus || ''),
            // What they pay on THESE services the support alone, as the plan's own figure is (the engine's
            // totalSupportAtHomeCosts). The assessment's whole-budget figure is a different number: it showed
            // $10,297 the support alone against the app's $19,105, and called a $4,660 saving a $4,149 rise (24 Oct 2026).
            contribution: Number.isFinite(Number(doNothingAlt?.snapshot?.totalSupportAtHomeCosts)) ? Number(doNothingAlt?.snapshot?.totalSupportAtHomeCosts) : $39348679b8be0d72$var$toNumber(baselineBranch?.contributionAmounts?.totalAnnual),
            contributionRates: {
                clinical: $39348679b8be0d72$var$toNumber(baselineBranch?.contributionRates?.clinical),
                independence: $39348679b8be0d72$var$toNumber(baselineBranch?.contributionRates?.independence),
                everydayLiving: $39348679b8be0d72$var$toNumber(baselineBranch?.contributionRates?.everydayLiving)
            },
            legacy: baselineLegacy
        },
        // The means-test machinery behind the rates — drives the "show the workings" expandable.
        thresholds: {
            incomeMin: $39348679b8be0d72$var$toNumber(baselineBranch?.thresholds?.incomeMin),
            incomeMax: $39348679b8be0d72$var$toNumber(baselineBranch?.thresholds?.incomeMax),
            assetMin: $39348679b8be0d72$var$toNumber(baselineBranch?.thresholds?.assetMin),
            assetMax: $39348679b8be0d72$var$toNumber(baselineBranch?.thresholds?.assetMax)
        },
        afterStrategy: {
            assessableAssets: $39348679b8be0d72$var$toNumber(outputsFinancials.assessableAssets),
            assessableIncome: $39348679b8be0d72$var$toNumber(outputsFinancials.totalAssessableIncome)
        },
        contributionRates: {
            clinical: $39348679b8be0d72$var$toNumber(strategyRates.clinical),
            independence: $39348679b8be0d72$var$toNumber(strategyRates.independence),
            everydayLiving: $39348679b8be0d72$var$toNumber(strategyRates.everydayLiving)
        },
        // Whether the Department's 'no worse off' principle covers the person receiving services (a Home
        // Care Package on 12 Sep 2024) — read from the profile, the same answer the contribution engine uses.
        noWorseOff: (()=>{
            const acat = factFind?.careNeeds?.clientAcat;
            if (acat?.hcpBeforeSep2024 !== 'yes') return null;
            return {
                paidNoFee: acat.hcpCategory === 'A',
                previousFeeDaily: Math.max(0, Number(acat.previousITCF) || 0)
            };
        })(),
        rateOverride: override ? {
            independence: $39348679b8be0d72$var$toNumber(override.independence),
            everydayLiving: $39348679b8be0d72$var$toNumber(override.everydayLiving),
            source: $39348679b8be0d72$var$sanitizeText(override.source),
            overriddenAt: String(override.overriddenAt || ''),
            modelledIndependence: $39348679b8be0d72$var$toNumber(override.modelledIndependenceAtOverride),
            modelledEverydayLiving: $39348679b8be0d72$var$toNumber(override.modelledEverydayLivingAtOverride)
        } : null,
        servicePlan: {
            clientRows: clientRows,
            partnerRows: partnerRows,
            grossAnnual: [
                ...clientRows,
                ...partnerRows
            ].reduce((sum, r)=>sum + r.annual, 0),
            isEstimated: Boolean(params.servicePlanIsEstimated ?? (clientRows.length === 0 && partnerRows.length === 0)),
            // Each person's yearly budget from their classification (null until assessed): what the
            // services are measured against, and what above it is paid in full (24 Oct 2026).
            budgets: (0, $08809b7a4fc47e27$export$4ddb2093d9f00d95)(factFind),
            description: $39348679b8be0d72$var$sanitizeText(params.servicePlanDescription || '')
        },
        alternatives: alternatives,
        totalEvaluated: params.analysis?.totalEvaluated ?? params.analysis?.strategies?.length ?? 0,
        projections: projections,
        projectionConvention: $39348679b8be0d72$var$sanitizeText((0, $48fd3f316ae581a6$export$f2e75dede6de26ce)('financial_year') || ''),
        ratesReviewNotice: (()=>{
            const status = (0, $d92bca4a6da5b591$export$83e0daeeac89884f)();
            return $39348679b8be0d72$var$sanitizeText(status?.message || '');
        })(),
        structureAppendixHtml: structureAppendix ? (0, $f70ff3a065f941e2$export$ef316658362fb04e)(structureAppendix, (0, $f94e45ac645ae232$export$3dc27271f5d5c629)) : '',
        // Full input disclosure — the SAME walker as the aged care SOA, so the structured-inputs
        // appendix is identical across both documents.
        annualLivingExpenses: $39348679b8be0d72$var$toNumber(factFind?.expenses?.livingExpenses),
        assetRows: assetRows,
        factFindSections: (0, $02a659cad5e2280d$export$70de02dda17e369e)(factFind),
        allFactFindRows: $39348679b8be0d72$var$flattenObject(factFind || {}),
        // The shared document pieces (features/advice/soaKit.ts, 3 Oct 2026): the position as
        // entered, the do-nothing run's year-by-year for the charts, and the Assumptions page as
        // it stood when the document was generated, for the appendix.
        situation: (0, $8ea663173c1a6588$export$b49cd4ac4688f9b9)(factFind),
        // The module's own horizon (goals.sahLegacyYears, default 10 as on the Support at Home page), not the
        // general legacyYears: the situation page labelled the 10-year estate "After 5 years" (24 Oct 2026).
        legacyYears: Number(factFind?.goals?.sahLegacyYears) || 10,
        baselineProjections: (doNothingAlt?.projections || []).map((row, index)=>({
                label: $39348679b8be0d72$var$sanitizeText(row.fyLabel || `Year ${index + 1}`),
                pension: $39348679b8be0d72$var$toNumber(row.socialSecurity),
                cashflow: $39348679b8be0d72$var$toNumber(row.cashFlow ?? row.cashflow),
                netWorth: $39348679b8be0d72$var$toNumber(row.netWorth)
            })),
        assumptionSections: (0, $13910bc1e93fb74e$export$8d1b1c5d08b3c488)(),
        guaranteedIncome: $39348679b8be0d72$export$4e6ff46ddc24b76({
            strategy: selectedStrategy,
            factFind: factFind,
            rows: params.projections || [],
            analysisStrategies: params.analysis?.strategies?.length ? params.analysis.strategies : params.doNothingRows?.length ? [
                {
                    name: 'The support alone',
                    config: {
                        type: 'doNothing'
                    },
                    projections: params.doNothingRows
                }
            ] : null,
            horizonYears: parseInt(String((selectedStrategy.inputs || {}).legacyYears ?? factFind?.goals?.sahLegacyYears), 10) || (params.projections || []).length || 10
        })
    };
}
// ── HTML ────────────────────────────────────────────────────────────────────────────────────────
function $39348679b8be0d72$var$narrativeSectionHtml(type) {
    const explainer = (0, $f6fa0c4ae572e255$export$db6db87c4063fbb3)[type];
    if (!explainer) return '';
    const { soa: soa } = explainer;
    return `
<div class="card-inset">
<p class="lede" style="margin-top:0">${soa.description}</p>
<div class="h3" style="margin-top:12px">Benefits</div>
<ul class="riskList">${soa.benefits.map((b)=>`<li>${b}</li>`).join('')}</ul>
<div class="h3">Risks and trade-offs</div>
<ul class="riskList">${soa.risks.map((r)=>`<li>${r}</li>`).join('')}</ul>
<div class="h3">Suitability</div>
<p>${soa.suitability}</p>
</div>`;
}
/** "With Matthew moving into aged care": what the partner's aged care plan used and what is left (24 Oct 2026). */ function $39348679b8be0d72$var$linkedCareHtml(s) {
    const esc = (t)=>t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const row = (label, value, strong = false)=>`<tr><td>${strong ? `<strong>${esc(label)}</strong>` : esc(label)}</td><td class="td-num">${strong ? `<strong>${value}</strong>` : value}</td></tr>`;
    const used = [
        ...s.deposit >= 1 ? [
            row('Room deposit (RAD) paid', (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(s.deposit)), true)
        ] : [],
        ...s.used.map((u)=>row(u.label, `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(u.before))} \u{2192} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(u.after))}`)),
        ...s.added.map((a)=>row(`${a.label} (new)`, (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(a.value)))),
        ...s.debtsCleared >= 1 ? [
            row('Debts paid off', (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(s.debtsCleared)))
        ] : [],
        ...s.homeSold ? [
            row('The home', 'sold')
        ] : [],
        ...s.fees >= 1 ? [
            row('Yearly care fees (daily fee, means-tested fee and any daily accommodation payment)', `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(s.fees))} a year`)
        ] : [],
        ...s.living != null && s.living >= 1 ? [
            row(`Living costs at home for ${s.stayingName}`, `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(s.living))} a year`)
        ] : []
    ].join('');
    const left = [
        ...s.left.map((l)=>row(l.label, (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(l.value)))),
        row('Savings left', (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(s.leftTotal)), true)
    ].join('');
    return `<div class="h3">With ${esc(s.enteringName)} moving into aged care</div>
<p>These figures include ${esc(s.enteringName)}'s chosen aged care plan, &ldquo;${esc(s.planTitle)}&rdquo;, ${s.whole ? 'carried out in full: everything below has already happened before any Support at Home strategy is tested.' : `with only its room deposit, fees and living costs: ${esc(s.reason || 'the rest of the plan could not be rebuilt.')}`} Centrelink's <strong>illness-separated couple</strong> treatment is applied; Services Australia determines the actual treatment, so tell them when residential care begins.</p>
<table><thead><tr><th>What the aged care plan uses</th><th class="td-num">Amount</th></tr></thead><tbody>${used}</tbody></table>
<table style="margin-top:10px"><thead><tr><th>What is left for ${esc(s.stayingName)} at home</th><th class="td-num">Balance</th></tr></thead><tbody>${left}</tbody></table>
${s.deposit >= 1 ? `<p class="small muted" style="margin-top:8px">${esc((0, $a109d47f19f08f50$export$73c5c6d74b068b0e)(s.enteringName))}</p>` : ''}
${s.caveats.map((c)=>`<p class="small muted">${esc(c)}</p>`).join('')}`;
}
function $39348679b8be0d72$var$servicePlanTableHtml(label, rows, showLabel) {
    if (!rows.length) return '';
    return `
${showLabel ? `<div class="h3">${label}</div>` : ''}
<table><thead><tr><th>Service</th><th>Frequency &amp; category</th><th>Indicative gross cost</th></tr></thead>
<tbody>${rows.map((r)=>`<tr><td>${r.name}</td><td>${r.detail}</td><td class="td-num">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(r.annual)}/yr</td></tr>`).join('')}</tbody></table>`;
}
/**
 * Each person's services against their yearly budget (owner's test, 24 Oct 2026: John's plan was $10,931
 * over his Classification 4 budget, the app said so, and the document never mentioned a budget). Within
 * the budget the contribution rates apply; above it the services are paid in full. Budgets are per
 * person and cannot be shared. A document saved before budgets were carried has none, and shows nothing.
 */ /** What sits above the budgets across the household, paid in full (0 when no budget is known). */ function $39348679b8be0d72$var$servicePlanOverBudget(snapshot) {
    const budgets = snapshot.servicePlan.budgets;
    if (!budgets || snapshot.servicePlan.isEstimated) return 0;
    const over = (rows, budget)=>{
        const total = rows.reduce((sum, r)=>sum + r.annual, 0);
        return budget && total > budget ? total - budget : 0;
    };
    return over(snapshot.servicePlan.clientRows, budgets.client) + (snapshot.partnerName ? over(snapshot.servicePlan.partnerRows, budgets.partner) : 0);
}
function $39348679b8be0d72$var$servicePlanBudgetsHtml(snapshot) {
    const budgets = snapshot.servicePlan.budgets;
    if (!budgets || snapshot.servicePlan.isEstimated) return '';
    const people = [
        {
            name: snapshot.clientName,
            budget: budgets.client,
            total: snapshot.servicePlan.clientRows.reduce((sum, r)=>sum + r.annual, 0)
        },
        ...snapshot.partnerName ? [
            {
                name: snapshot.partnerName,
                budget: budgets.partner,
                total: snapshot.servicePlan.partnerRows.reduce((sum, r)=>sum + r.annual, 0)
            }
        ] : []
    ].filter((p)=>p.total > 0);
    if (!people.length || people.every((p)=>!p.budget)) return '';
    const anyOver = people.some((p)=>p.budget && p.total > p.budget);
    return `
<div class="h3">Against each person's yearly budget</div>
<table><thead><tr><th>Person</th><th class="td-num">Yearly budget</th><th class="td-num">Services a year</th><th class="td-num">Within the budget</th><th class="td-num">Above it, paid in full</th></tr></thead>
<tbody>${people.map((p)=>p.budget ? `<tr><td>${p.name}</td><td class="td-num">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(p.budget)}</td><td class="td-num">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(p.total)}</td><td class="td-num">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.min(p.total, p.budget))}</td><td class="td-num">${p.total > p.budget ? `<strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(p.total - p.budget)}</strong>` : (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(0)}</td></tr>` : `<tr><td>${p.name}</td><td class="td-num">Not assessed yet</td><td class="td-num">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(p.total)}</td><td colspan="2">No budget limit applied until the assessment</td></tr>`).join('')}</tbody></table>
<p class="small muted" style="margin-top:8px">The yearly budget comes from each person's classification and cannot be shared between you. Within it, you pay your contribution on each hour (the rates above); the government pays the rest.${anyOver ? ' Services above a person\'s budget are bought privately, at the provider\'s full price.' : ''}</p>`;
}
/**
 * The 'no worse off' workings — Services Australia's four steps on income alone, or why nothing is
 * payable — in place of the income-and-assets walkthrough, which describes a calculation that is
 * not this client's. Mirrors the contributions screen (ContributionsSection.tsx).
 */ function $39348679b8be0d72$var$noWorseOffWorkings(snapshot, income, incomeMin, incomeMax) {
    const n = snapshot.noWorseOff;
    if (!n) return '';
    const pctOf = (v)=>`${(v * 100).toFixed(2)}%`;
    if (n.paidNoFee) return `<p class="small"><strong>Why nothing is payable.</strong> No income-tested care fee was payable under the Home Care Package, so under the 'no worse off' principle no contributions are payable under Support at Home \u{2014} whatever the assessable income and assets, and even after a reassessment into a higher classification.</p>`;
    const status = snapshot.baseline.pensionStatus;
    const step1 = Math.round(Math.max(0, income - incomeMin) * 0.5);
    const step2 = Math.round(Math.max(0, incomeMax - incomeMin) * 0.5);
    const step3 = step2 > 0 ? Math.min(100, step1 / step2 * 100) : 0;
    const arithmetic = status === 'fullPensioner' ? `<p class="small"><strong>Step 2 \u{2014} the rate.</strong> As a full pensioner the 'no worse off' rate is <strong>0%</strong> on both Independence and Everyday Living.</p>` : status === 'selfFunded' ? `<p class="small"><strong>Step 2 \u{2014} the rate.</strong> As a self-funded retiree the 'no worse off' rate is the maximum, <strong>25%</strong> on both Independence and Everyday Living (the standard rates would be 50% and 80%).</p>` : `<p class="small"><strong>Step 2 \u{2014} the arithmetic (Services Australia's method).</strong> (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(income)} \u{2212} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(incomeMin)}) \xd7 50% = ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(step1)}; (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(incomeMax)} \u{2212} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(incomeMin)}) \xd7 50% = ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(step2)}; ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(step1)} \xf7 ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(step2)} = ${step3.toFixed(2)}% of the way \u{2192} \xd7 25% = <strong>${pctOf(snapshot.contributionRates.independence)}</strong> on both Independence and Everyday Living.</p>`;
    const ceiling = n.previousFeeDaily > 0 ? `<p class="small"><strong>Step 3 \u{2014} the ceiling.</strong> Contributions never exceed the previous income-tested care fee: ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(n.previousFeeDaily)} a day, <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(n.previousFeeDaily * 14)} a fortnight</strong> (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(n.previousFeeDaily * 364)} a year).</p>` : `<p class="small"><strong>Step 3 \u{2014} the ceiling.</strong> Contributions never exceed the income-tested care fee paid under the package; record that fee in the profile and the tool applies the ceiling.</p>`;
    return `<p class="small"><strong>Step 1 \u{2014} income only.</strong> Under the 'no worse off' principle the rate depends on assessable income alone \u{2014} <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(income)}</strong>, against the income free area (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(incomeMin)}) and the income limit (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(incomeMax)}). Assets play no part, so strategies that move assets do not change these rates.</p>
${arithmetic}
${ceiling}
<p class="small muted">Clinical Care is always ${pctOf(snapshot.contributionRates.clinical)} \u{2014} fully government funded at every means level.</p>`;
}
/** Back from the snapshot's escaped text to plain words, for the kit's pieces that escape for themselves. */ function $39348679b8be0d72$var$plainText(value) {
    return String(value ?? '').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'");
}
function $39348679b8be0d72$export$b71867531de1aafe(snapshot) {
    const coverA = (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1559827260-dc66d52bef19', 1920, 1080);
    const coverB = (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1506905925346-21bda4d32df4', 1920, 1080);
    const cashflowKpiClass = snapshot.annualCashflow < 0 ? 'kpi kpi--warn' : 'kpi kpi--gain';
    const goalsBlock = snapshot.goals.length ? `<ul class="goalsList">${snapshot.goals.map((g)=>`<li>${g}</li>`).join('')}</ul>` : '<p class="muted small">No specific goals were recorded in your profile.</p>';
    const overrideBlock = snapshot.rateOverride ? `<div class="callout callout--amber">
<p class="callout-title">Contribution rates entered from your official assessment</p>
<p>The contribution rates in this document are the OFFICIAL rates recorded from your Services Australia assessment
\u{2014} <strong>${$39348679b8be0d72$var$pct(snapshot.rateOverride.independence)}</strong> Independence and <strong>${$39348679b8be0d72$var$pct(snapshot.rateOverride.everydayLiving)}</strong> Everyday Living \u{2014}
rather than the tool's modelled rates (${$39348679b8be0d72$var$pct(snapshot.rateOverride.modelledIndependence)} / ${$39348679b8be0d72$var$pct(snapshot.rateOverride.modelledEverydayLiving)} at the time they were recorded).</p>
<p class="small">Source: ${snapshot.rateOverride.source || 'not recorded'}${snapshot.rateOverride.overriddenAt ? ` \xb7 Recorded ${$39348679b8be0d72$var$formatDateOnly(snapshot.rateOverride.overriddenAt)}` : ''}.
If your financial position changes materially, Services Australia may reassess these rates.</p>
</div>` : '';
    // The 'no worse off' principle, stated only for a client it covers — nobody else needs to read it.
    const noWorseOffBlock = snapshot.noWorseOff ? `<div class="callout">
<p class="callout-title">Your contribution rates are protected by the 'no worse off' principle</p>
<p>Because a Home Care Package was in place or approved for you on 12 September 2024, the Department's 'no worse off' principle applies to your Support at Home contributions.
${snapshot.noWorseOff.paidNoFee ? "You were assessed as not having to pay an income-tested care fee under your package, so you pay <strong>no contributions</strong> under Support at Home \u2014 even if you are reassessed into a higher classification." : `Because you paid an income-tested care fee under your package, your rates are the Department's reduced 'no worse off' rates: between 0% and 25%, based on your <strong>income only</strong> (your assets play no part), and never more per fortnight than the fee you paid before${snapshot.noWorseOff.previousFeeDaily > 0 ? ` (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.noWorseOff.previousFeeDaily)} a day, ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.noWorseOff.previousFeeDaily * 14)} a fortnight)` : ''}.`}
Your lifetime cap is the package cap (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $c424aab2467b2598$export$c5fbc76332b2670f).nwop)}, indexed each March and September), and fees already paid under your package count towards it.</p>
</div>` : '';
    // ── Executive summary: what we recommend, and the benefit against the current position ──────
    const baselineLegacyValue = snapshot.baseline.legacy ?? null;
    const legacyDelta = baselineLegacyValue !== null ? snapshot.projectedLegacy - baselineLegacyValue : null;
    const recommendationSummaryBlock = `<div class="callout callout--blue">
<p class="callout-title">What we recommend \u{2014} and what it does for you</p>
<p>${snapshot.narrativeTypes.length > 0 ? `We recommend <strong>${snapshot.selectedStrategyName}</strong>. ${snapshot.narrativeTypes.map((t)=>(0, $f6fa0c4ae572e255$export$db6db87c4063fbb3)[t]?.what || '').filter(Boolean).join(' ')}` : `The strongest course for your position is <strong>${snapshot.selectedStrategyName}</strong> \u{2014} keeping your current arrangements unchanged.`}</p>
<p style="margin-bottom:6px">Compared with the support alone (the same services, nothing else changed):</p>
${(0, $8ea663173c1a6588$export$19dae3d6ce96af14)([
        ...legacyDelta !== null ? [
            {
                measure: 'estate',
                label: 'Left to the family',
                doNothing: baselineLegacyValue,
                plan: snapshot.projectedLegacy,
                delta: legacyDelta
            }
        ] : [],
        {
            measure: 'pension',
            label: 'Age Pension, a year',
            doNothing: snapshot.baseline.pension,
            plan: snapshot.annualPension,
            delta: snapshot.annualPension - snapshot.baseline.pension
        },
        {
            measure: 'cashflow',
            label: 'Each year, after costs',
            doNothing: snapshot.baseline.cashflow,
            plan: snapshot.annualCashflow,
            delta: snapshot.annualCashflow - snapshot.baseline.cashflow
        },
        {
            measure: 'contribution',
            label: 'Support at Home contribution, a year',
            doNothing: snapshot.baseline.contribution || 0,
            plan: snapshot.annualContribution,
            delta: snapshot.annualContribution - (snapshot.baseline.contribution || 0)
        }
    ], 'The support alone')}
${legacyDelta !== null && Math.round(legacyDelta) < 0 ? '<p class="small muted" style="margin-bottom:0">Less to the family is the price of the benefits above, weighed in the Risks section.</p>' : ''}
</div>`;
    // ── Contribution workings: the same three-step arithmetic the contributions screen teaches ──
    // Defensive against snapshots persisted before these fields existed (soaSnapshot on a saved
    // strategy is reopened as-generated).
    const th = snapshot.thresholds || {
        incomeMin: 0,
        incomeMax: 0,
        assetMin: 0,
        assetMax: 0
    };
    const baselineRates = snapshot.baseline.contributionRates || {
        clinical: 0,
        independence: 0,
        everydayLiving: 0
    };
    const workingsAssets = snapshot.afterStrategy?.assessableAssets || snapshot.baseline.assessableAssets;
    const workingsIncome = snapshot.afterStrategy?.assessableIncome || snapshot.baseline.assessableIncome;
    const bandPct = (value, min, max)=>max > min ? Math.min(100, Math.max(0, (value - min) / (max - min) * 100)) : 0;
    const incomePosPct = bandPct(workingsIncome, th.incomeMin, th.incomeMax);
    const assetPosPct = bandPct(workingsAssets, th.assetMin, th.assetMax);
    const assetsBind = assetPosPct >= incomePosPct;
    const winnerPct = assetsBind ? assetPosPct : incomePosPct;
    // Only show the band formula when it reproduces the displayed rate (standard part-pensioner
    // bands) — same self-check as the contributions screen.
    const bandsReproduce = Math.abs(0.05 + winnerPct / 100 * 0.45 - snapshot.contributionRates.independence) < 0.0015 && Math.abs(0.175 + winnerPct / 100 * 0.625 - snapshot.contributionRates.everydayLiving) < 0.0015;
    const ratesChangedByStrategy = Math.abs(snapshot.contributionRates.independence - baselineRates.independence) > 0.0005 || Math.abs(snapshot.contributionRates.everydayLiving - baselineRates.everydayLiving) > 0.0005;
    const contributionWorkingsBlock = `
<p class="small" style="margin-top:12px"><strong>These rates are AFTER the recommended strategy is applied.</strong>${ratesChangedByStrategy ? ` Before it, your modelled rates were ${$39348679b8be0d72$var$pct(baselineRates.independence)} Independence and ${$39348679b8be0d72$var$pct(baselineRates.everydayLiving)} Everyday Living \u{2014} the strategy changes your means, and your rates with them.` : ' The strategy does not change your contribution rates.'}</p>
<details><summary><strong>Show the workings</strong></summary>
<div style="padding-top:8px">
${snapshot.rateOverride ? `<p class="small">Your rates are pinned to your official Services Australia assessment (see the disclosure above), so no sliding-scale arithmetic applies. The workings below show how the tool would otherwise model them.</p>` : ''}
${snapshot.noWorseOff ? $39348679b8be0d72$var$noWorseOffWorkings(snapshot, workingsIncome, th.incomeMin, th.incomeMax) : `<p class="small"><strong>Step 1 \u{2014} where you sit.</strong> Your assessable income of <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(workingsIncome)}</strong> is ${incomePosPct.toFixed(1)}% of the way between the full-pension threshold (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(th.incomeMin)}) and the self-funded threshold (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(th.incomeMax)}). Your assessable assets of <strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(workingsAssets)}</strong> are ${assetPosPct.toFixed(1)}% of the way between ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(th.assetMin)} and ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(th.assetMax)}.</p>
<p class="small"><strong>Step 2 \u{2014} which one counts.</strong> Whichever position is further along sets the rate \u{2014} here, your <strong>${assetsBind ? 'assets' : 'income'}</strong> (${winnerPct.toFixed(1)}% of the way).</p>
${bandsReproduce ? `<p class="small"><strong>Step 3 \u{2014} the arithmetic.</strong> Independence runs from 5% (full pensioner) to 50% (self-funded): 5% + ${winnerPct.toFixed(1)}% \xd7 45% = <strong>${$39348679b8be0d72$var$pct(snapshot.contributionRates.independence)}</strong>. Everyday Living runs from 17.5% to 80%: 17.5% + ${winnerPct.toFixed(1)}% \xd7 62.5% = <strong>${$39348679b8be0d72$var$pct(snapshot.contributionRates.everydayLiving)}</strong>.</p>` : `<p class="small"><strong>Step 3 \u{2014} the result.</strong> Applying your position to your contribution bands gives <strong>${$39348679b8be0d72$var$pct(snapshot.contributionRates.independence)}</strong> for Independence and <strong>${$39348679b8be0d72$var$pct(snapshot.contributionRates.everydayLiving)}</strong> for Everyday Living.</p>`}
<p class="small muted">Clinical Care is always ${$39348679b8be0d72$var$pct(snapshot.contributionRates.clinical)} \u{2014} fully government funded at every means level.</p>`}
</div>
</details>`;
    const narrativeBlocks = snapshot.narrativeTypes.map((type)=>{
        const title = (0, $f6fa0c4ae572e255$export$db6db87c4063fbb3)[type] ? type.replace(/([A-Z])/g, ' $1').replace(/^./, (s)=>s.toUpperCase()) : type;
        return `<div class="h3">${title}</div>${$39348679b8be0d72$var$narrativeSectionHtml(type)}`;
    }).join('');
    // ── Alternatives, structured like the aged care SOA: objective leaders first (strongest
    // projected estate / cashflow / Age Pension), the do-nothing baseline always present, and a
    // per-card drop-down for deeper analysis of each alternative. ──
    const alts = snapshot.alternatives;
    const doNothingBaseline = alts.find((a)=>a.type === 'doNothing') || null;
    const bestBy = (metric)=>alts.length ? alts.reduce((best, a)=>a[metric] > best[metric] ? a : best, alts[0]) : null;
    const leaders = [];
    const addLeader = (alt, objective)=>{
        if (!alt) return;
        const existing = leaders.find((l)=>l.alt.name === alt.name);
        if (existing) existing.objective += ` \xb7 ${objective}`;
        else leaders.push({
            alt: alt,
            objective: objective
        });
    };
    addLeader(bestBy('legacy'), 'Strongest projected estate');
    addLeader(bestBy('cashflow'), 'Strongest cashflow');
    addLeader(bestBy('pension'), 'Strongest Age Pension');
    addLeader(doNothingBaseline, 'Do-nothing baseline');
    const selectedAlt = alts.find((a)=>a.selected) || null;
    addLeader(selectedAlt, 'Your selection');
    const remaining = alts.filter((a)=>!leaders.some((l)=>l.alt.name === a.name)).slice(0, 6);
    const renderAltCard = (alt, objective)=>{
        const explainer = (0, $f6fa0c4ae572e255$export$db6db87c4063fbb3)[alt.type];
        const dn = doNothingBaseline;
        const deltas = dn && alt.name !== dn.name ? `<li><strong>Projected estate:</strong> ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(alt.legacy - dn.legacy))} ${alt.legacy >= dn.legacy ? 'higher' : 'lower'} than the support alone</li>
<li><strong>Cashflow:</strong> ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(alt.cashflow - dn.cashflow))}/yr ${alt.cashflow >= dn.cashflow ? 'better' : 'worse'}</li>
<li><strong>Age Pension:</strong> ${Math.round(alt.pension - dn.pension) === 0 ? 'unchanged' : `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(alt.pension - dn.pension))}/yr ${alt.pension >= dn.pension ? 'higher' : 'lower'}`}</li>` : '<li>This is the benchmark every other option is measured against.</li>';
        return `<div class="opt-card${alt.selected ? ' opt-card--selected' : ''}">
<div class="opt-card-head"><span class="opt-tag">${objective}</span>
<span class="opt-card-status">${alt.selected ? '<span class="pill-selected">Your selection</span>' : '<span class="pill-not-selected">Shown for comparison \u2014 not selected</span>'}</span></div>
<p class="opt-title">${alt.name}</p>
<div class="opt-card-main"><p class="opt-narr">${explainer?.what || ''}</p>
<div class="opt-metrics">
<div class="opt-metric-line"><span class="muted small">Projected estate</span><strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(alt.legacy)}</strong></div>
<div class="opt-metric-line"><span class="muted small">Cashflow / yr</span><strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(alt.cashflow)}</strong></div>
<div class="opt-metric-line"><span class="muted small">Age Pension / yr</span><strong>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(alt.pension)}</strong></div>
</div></div>
<details class="opt-funding"><summary>More about this strategy</summary>
<ul class="tip-ul">${deltas}</ul>
${explainer ? `<ul class="tip-ul">${explainer.consider.map((c)=>`<li>${c}</li>`).join('')}</ul>` : ''}
</details>
</div>`;
    };
    const alternativesGrid = alts.length ? `<div class="opt-section">
<div class="opt-section-label">Objective comparison \u{2014} strongest option per goal, and the baseline</div>
<div class="opt-grid">${leaders.map((l)=>renderAltCard(l.alt, l.objective)).join('')}</div>
</div>
${remaining.length ? `<div class="opt-section">
<div class="opt-section-label">Also evaluated</div>
<div class="opt-grid">${remaining.map((a)=>renderAltCard(a, a.type || 'strategy')).join('')}</div>
</div>` : ''}` : '<p class="muted">This document was generated from a manually constructed strategy; the suggestion engine\'s comparison set was not part of this run. The do-nothing baseline above remains the benchmark.</p>';
    const projectionRows = snapshot.projections.map((row, i)=>`<tr class="proj-tr-data${i % 2 ? ' proj-zebra' : ''}">
<td class="proj-year">${row.label}</td>
<td class="td-num">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.pension)}</td>
<td class="td-num">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.sahCost)}</td>
<td class="td-num${row.cashflow >= 0 ? ' age-pos' : ' age-neg'}">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.cashflow)}</td>
<td class="td-num">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.netWorth)}</td>
</tr>`).join('');
    return `<!doctype html><html><head><meta charset="utf-8"/><meta name="viewport" content="width=device-width,initial-scale=1"/>
<title>Statement of Advice - ${snapshot.clientName}</title>
<style>
:root{--ink:#0f172a;--muted:#64748b;--line:#e2e8f0;--card:#fff;--accent:#2563eb;--accent2:#4f46e5;--warn-bg:#fff7ed;--warn-border:#fdba74;--warn-ink:#9a3412;--radius:16px;--shadow:0 14px 40px rgba(15,23,42,.08)}
body{margin:0;font-family:Inter,Segoe UI,system-ui,sans-serif;background:var(--ink);color:var(--ink);line-height:1.55}
.cover{min-height:100vh;display:flex;align-items:center;justify-content:center;position:relative;overflow:hidden}
.cover::before{content:'';position:absolute;inset:0;background-image:url('${coverA}');background-size:cover;background-position:center;opacity:.38;animation:moveA 28s ease-in-out infinite}
.cover::after{content:'';position:absolute;inset:0;background-image:url('${coverB}');background-size:cover;background-position:center;opacity:.22;animation:moveB 34s ease-in-out infinite}
.coverShade{position:absolute;inset:0;background:radial-gradient(120% 80% at 30% 20%,rgba(37,99,235,.45),rgba(15,23,42,.88))}
.coverBox{position:relative;z-index:1;max-width:1040px;width:88%;background:rgba(255,255,255,.12);border:1px solid rgba(255,255,255,.35);border-radius:28px;padding:40px 36px;color:#fff;backdrop-filter:blur(8px);box-shadow:0 24px 80px rgba(0,0,0,.35)}
.coverKicker{font-size:12px;letter-spacing:.22em;text-transform:uppercase;opacity:.9}
.coverTitle{font-size:clamp(36px,6vw,58px);line-height:1.05;font-weight:900;margin:10px 0 8px}
.clientNames{font-size:clamp(22px,3.5vw,32px);font-weight:700}
.meta{display:flex;flex-wrap:wrap;gap:8px;margin-top:18px}
.meta span{font-size:11px;padding:8px 12px;border-radius:999px;background:rgba(255,255,255,.16);border:1px solid rgba(255,255,255,.4)}
.openBtn{margin-top:26px;padding:14px 22px;border-radius:14px;border:none;font-weight:800;cursor:pointer;background:#fff;color:var(--ink);font-size:15px;box-shadow:0 8px 24px rgba(0,0,0,.2);transition:transform .15s ease}
.openBtn:hover{transform:translateY(-2px)}
.book{background:linear-gradient(180deg,#eef2ff 0%,#f8fafc 18%);max-width:1200px;margin:0 auto;padding:28px 20px 48px;scroll-margin-top:0;min-height:100vh}
#soa-document{scroll-margin-top:0}
.topNav{position:sticky;top:0;background:rgba(255,255,255,.92);border:1px solid var(--line);border-radius:14px;padding:10px 12px;display:flex;justify-content:space-between;align-items:center;z-index:40;backdrop-filter:blur(10px);box-shadow:var(--shadow);margin-bottom:18px}
.topNav .buttons{display:flex;gap:8px;flex-wrap:wrap}
.topNav button{padding:9px 14px;min-width:90px;border:1px solid #c7d2fe;background:linear-gradient(180deg,#fff,#f1f5ff);border-radius:10px;cursor:pointer;font-weight:700;font-size:13px;color:var(--ink)}
.topNav button:hover{border-color:var(--accent);color:var(--accent)}
.pager{font-size:12px;font-weight:700;color:var(--muted)}
.topNav .navEnd{display:flex;align-items:center;gap:12px;flex-wrap:wrap;justify-content:flex-end}
.topNav .printBtn{border-color:var(--navy,#001E7A);color:var(--navy,#001E7A)}
.page{display:none;animation:fadeIn .35s ease}
.page.active{display:block}
@keyframes fadeIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}
.card{background:var(--card);border:1px solid var(--line);border-radius:var(--radius);padding:26px 24px;margin-top:14px;box-shadow:var(--shadow);position:relative;overflow:visible}
.card::before{content:'';position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,#6366f1,#3b82f6);opacity:.9}
.h2{font-size:26px;font-weight:900;margin:0 0 12px;letter-spacing:-.02em}
.h3{font-size:17px;font-weight:800;margin:22px 0 10px;color:#1e293b}
.lede{font-size:16px;margin:10px 0 14px}
.muted{color:var(--muted)}.small{font-size:13px}.tiny{font-size:12px}
.goalsList{margin:8px 0 16px;padding-left:20px}
.goalsList li{margin:6px 0}
.grid4{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:12px}
.kpi{background:linear-gradient(180deg,#f8fafc,#fff);border:1px solid var(--line);border-radius:12px;padding:14px 12px}
.kpi--warn{background:var(--warn-bg);border-color:var(--warn-border)}
.kpi--warn .value{color:var(--warn-ink)}
.kpi--gain{background:#ecfdf5;border-color:#a7f3d0}
.kpi--gain .value{color:#047857}
.label{font-size:11px;color:var(--muted);text-transform:uppercase;letter-spacing:.06em;font-weight:700}
.value{font-size:24px;font-weight:900;margin-top:4px}
.callout{border-radius:14px;padding:16px 18px;margin:16px 0}
.callout--blue{background:#eff6ff;border:1px solid #bfdbfe}
.callout--amber{background:#fffbeb;border:1px solid #fcd34d}
.callout--slate{background:#f8fafc;border:1px solid #e2e8f0}
.callout-title{font-weight:800;margin:0 0 8px;font-size:15px}
.card-inset{background:#fff;border:1px dashed #cbd5e1;border-radius:12px;padding:14px 16px;margin:14px 0}
.td-num{vertical-align:top;min-width:120px;white-space:nowrap}
.proj-year{white-space:nowrap;font-weight:700;color:#1f2937}
.age-pos{color:#16a34a}
.age-neg{color:#dc2626}
.table-proj{font-variant-numeric:tabular-nums}
.table-proj tbody tr.proj-tr-data.proj-zebra{background:#fafafa}
.section-ribbon{height:4px;border-radius:99px;background:linear-gradient(90deg,#4f46e5,#2563eb,#06b6d4);margin-bottom:16px}
.scope-grid{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-top:12px}
.scope-in{background:#ecfdf5;border:1px solid #6ee7b7;border-radius:12px;padding:14px}
.scope-out{background:#fef2f2;border:1px solid #fecaca;border-radius:12px;padding:14px}
.scope-in h4,.scope-out h4{margin:0 0 8px;font-size:13px;text-transform:uppercase;letter-spacing:.06em}
.scope-in ul,.scope-out ul{margin:0;padding-left:18px;font-size:14px}
.opt-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:14px;margin-top:14px;align-items:stretch}
.opt-grid>.opt-card{height:100%}
.opt-card{border:1px solid var(--line);border-radius:14px;padding:16px;background:#fafafa;transition:box-shadow .2s,border-color .2s,transform .2s;display:flex;flex-direction:column;min-height:100%;box-sizing:border-box}
.opt-card:hover{box-shadow:var(--shadow);transform:translateY(-2px)}
.opt-card--selected{border-color:#818cf8;background:linear-gradient(160deg,#eef2ff,#fff);box-shadow:0 12px 36px rgba(79,70,229,.15)}
.opt-card-head{display:flex;flex-direction:column;align-items:flex-start;gap:8px;margin-bottom:8px;width:100%}
.opt-card-head .opt-tag{display:inline-block;font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:.08em;color:var(--accent);background:#eff6ff;padding:4px 8px;border-radius:999px;max-width:100%}
.opt-card-status{display:block;width:100%}
.pill-not-selected{font-size:10px;font-weight:800;background:#e2e8f0;color:#475569;padding:4px 10px;border-radius:999px;letter-spacing:.02em}
.opt-title{font-size:16px;margin:0 0 10px;font-weight:800;line-height:1.25}
.pill-selected{font-size:10px;font-weight:800;background:#22c55e;color:#fff;padding:4px 10px;border-radius:999px;letter-spacing:.02em}
.opt-card-main{flex:1 1 auto;display:flex;flex-direction:column;min-height:0}
.opt-narr{font-size:14px;color:#475569;margin:0 0 0;flex:1 1 auto;line-height:1.45}
.opt-metrics{margin-top:auto;padding-top:14px;border-top:1px solid #e2e8f0;flex-shrink:0;display:grid;grid-template-columns:1fr;gap:8px;font-size:14px}
.opt-metric-line{display:flex;justify-content:space-between;align-items:baseline;gap:12px}
.opt-metric-line strong{font-size:18px;line-height:1.2;white-space:nowrap}
.opt-section{margin-top:6px}
.opt-section-label{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:.07em;color:#64748b;margin:18px 0 10px}
.opt-grid--2{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px;margin-top:10px;align-items:stretch}
.opt-funding{margin-top:10px;flex-shrink:0}
.opt-funding summary{cursor:pointer;font-weight:700;color:#334155}
.tip-ul{margin:8px 0 2px 16px;padding:0;color:#334155;line-height:1.45;max-height:220px;overflow:auto}
.riskList{margin:0;padding-left:20px}
.riskList li{margin:10px 0}
table{width:100%;border-collapse:collapse;font-size:14px}
th,td{padding:11px 10px;border-bottom:1px solid var(--line);text-align:left}
th{background:#f1f5f9;font-weight:800;font-size:12px;text-transform:uppercase;letter-spacing:.04em;color:#475569}
details{margin:10px 0;border:1px solid var(--line);border-radius:12px;padding:12px;background:#fafafa}
.factSection{margin-top:8px}.factRow{display:grid;grid-template-columns:minmax(0,320px) 1fr;padding:10px 8px;border-bottom:1px solid #f1f5f9;gap:12px}.factLabel{font-weight:700;color:#334155;font-size:13px}
@keyframes moveA{0%,100%{transform:scale(1) translate(0,0)}50%{transform:scale(1.09) translate(-14px,-12px)}}
@keyframes moveB{0%,100%{transform:scale(1) translate(0,0)}50%{transform:scale(1.06) translate(16px,14px)}}
@media (max-width:1020px){.grid4{grid-template-columns:repeat(2,minmax(0,1fr))}.opt-grid{grid-template-columns:1fr}.scope-grid{grid-template-columns:1fr}}
@media (max-width:640px){.grid4{grid-template-columns:1fr}.factRow{grid-template-columns:1fr}}
@media print{
  @page{size:A4 portrait;margin:12mm}
  body{background:#fff !important;color:#000 !important}
  .cover{min-height:auto !important;page-break-after:always}
  .cover::before,.cover::after,.coverShade{display:none !important}
  .coverBox{background:#fff !important;color:#000 !important;border:1px solid #e5e7eb !important;box-shadow:none !important;backdrop-filter:none !important}
  .openBtn{display:none !important}
  .book{max-width:none !important;margin:0 !important;padding:0 !important;background:#fff !important}
  .topNav,.pager,.buttons{display:none !important}
  .page,.page.active{display:block !important;animation:none !important;break-inside:avoid-page;page-break-inside:avoid;margin:0 0 10mm 0}
  .card{box-shadow:none !important;border:1px solid #d1d5db !important;break-inside:avoid-page;page-break-inside:avoid;background:#fff !important}
  details{border:1px solid #d1d5db !important;background:#fff !important}
  table{font-size:11px !important}
  th,td{padding:6px 6px !important}
}
${0, $8ea663173c1a6588$export$a7aa337a60127637}
</style></head><body>
<section class="cover"><div class="coverShade"></div><div class="coverBox">
<div class="coverKicker">Statement of advice</div>
<div class="coverTitle">Your Support at Home strategy</div>
<div class="clientNames">${snapshot.clientName}${snapshot.partnerName ? ` & ${snapshot.partnerName}` : ''}</div>
<div class="meta">
${(()=>{
        const a = (0, $92fb3c34dca71663$export$174185a301570ae7)();
        // Same rule as the aged-care document: the firm's own attribution when we know it, and the
        // placeholder that says "(Demo)" out loud when we do not.
        return a ? `<span>${String(a.line).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')}</span>` : '<span>AgedCareWise Pty Ltd</span><span>AFSL 401234 (Demo)</span><span>ABN 12 345 678 901 (Demo)</span>';
    })()}
<span>Report ${snapshot.reportId}</span><span>${$39348679b8be0d72$var$formatDateOnly(snapshot.generatedAt)}</span>
<span>Source: ${snapshot.strategySource === 'manual_control' ? 'MC (Manual Control)' : 'SE (Suggestion Engine)'}</span>
${snapshot.completerDisplay ? `<span>Completed by: ${snapshot.completerDisplay}</span>` : ''}
</div>
<button type="button" class="openBtn" onclick="openBooklet()">Begin reading your advice</button>
<p class="muted" style="margin-top:14px;font-size:13px;opacity:.85">Opens your Statement of Advice below \u{2014} use <strong>Next</strong> / <strong>Previous</strong> to move through each section.</p>
</div></section>
<div class="book" id="soa-document">
<div class="topNav">
  <div class="buttons">
    <button type="button" onclick="prevPage()">Previous</button>
    <button type="button" onclick="nextPage()">Next</button>
    <button type="button" data-goto="0">Contents</button>
  </div>
  <div class="navEnd"><button type="button" class="printBtn" data-print>Print or save as PDF</button><div class="pager" id="pager"></div></div>
</div>

<section class="page active"><div class="card">
<div class="h2">Executive summary</div>
<p class="lede">This Statement of Advice covers strategies to fund <strong>Support at Home</strong> services \u{2014} care delivered in your own home \u{2014} and their effect on your Age Pension, your contribution rates, your cash flow and your estate.</p>
<p class="lede">${snapshot.strategySource === 'manual_control' && snapshot.customisedFrom ? `<strong>How this plan was made:</strong> you started from the suggested plan <strong>\u{201C}${snapshot.customisedFrom}\u{201D}</strong> and changed it yourself, into <strong>${snapshot.selectedStrategyName}</strong>. This document follows that plan through to projected outcomes.` : snapshot.strategySource === 'manual_control' ? `<strong>How this plan was made:</strong> you built <strong>${snapshot.selectedStrategyName}</strong> yourself. This document follows that plan through to projected outcomes.` : `<strong>How this plan was made:</strong> AgedCareWise found this plan by testing <strong>${snapshot.totalEvaluated}</strong> ways to pay for the support, each measured against the support alone (the same services, nothing else changed). You chose <strong>${snapshot.selectedStrategyName}</strong>, and this document follows that plan through to projected outcomes.`}</p>
<div class="h3">What you told us you are trying to achieve</div>
${goalsBlock}
<div class="h3">Snapshot of modelled outcomes</div>
<div class="grid4">
<div class="kpi"><div class="label">Age Pension / year</div><div class="value">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.annualPension)}</div></div>
<div class="kpi"><div class="label">Support at Home contribution / year</div><div class="value">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.annualContribution)}</div></div>
<div class="${cashflowKpiClass}"><div class="label">Cashflow / year</div><div class="value">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.annualCashflow)}</div></div>
<div class="kpi"><div class="label">Projected estate</div><div class="value">${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.projectedLegacy)}</div></div>
</div>
${recommendationSummaryBlock}
${snapshot.linkedCare ? $39348679b8be0d72$var$linkedCareHtml(snapshot.linkedCare) : snapshot.agedCareLinked ? `<div class="callout callout--blue">
<p class="callout-title">Linked aged care scenario</p>
<p class="small">This analysis was run with a linked aged care scenario \u{2014} one partner is modelled as entering residential care, so the household figures include that scenario's accommodation and care costs, and Centrelink's <strong>illness-separated couple</strong> Age Pension treatment may apply. Services Australia determines the actual treatment; inform them when residential care commences.</p>
</div>` : ''}
${overrideBlock}${noWorseOffBlock}
<div class="h3">In this document</div>
<div id="soa-toc-slot"></div>
</div></section>

<section class="page"><div class="card">
<div class="h2">Scope of advice</div>
<p>This section sets clear boundaries: what this advice covers, what it does not, and where you still need specialist input.</p>
<div class="scope-grid">
<div class="scope-in">
<h4>In scope</h4>
<ul>
<li>Strategies to fund <strong>Support at Home</strong> services and improve your position \u{2014} asset restructuring, home-equity access and debt strategies \u{2014} and how they interact with your Age Pension and contribution rates.</li>
<li>Illustrative <strong>cashflow, pension, contribution and net-worth projections</strong> \u{2014} not forecasts of actual future balances.</li>
<li>Education on how Support at Home contribution rates are <strong>estimated</strong> in this tool (final rates are set by Services Australia's assessment).</li>
</ul>
</div>
<div class="scope-out">
<h4>Out of scope</h4>
<ul>
<li>Residential aged care advice (covered by a separate aged care Statement of Advice where applicable).</li>
<li>Legal documents (Wills, powers of attorney), tax return preparation, and product selection for specific annuity or reverse-mortgage providers.</li>
<li>Confirmation of government entitlements \u{2014} Services Australia determines actual Age Pension and contribution outcomes.</li>
</ul>
</div>
</div>
</div></section>

${snapshot.situation ? `<section class="page"><div class="card">
<div class="h2">Your situation today</div>
<p class="lede">The position this advice starts from, as you entered it, before any strategy \u{2014} and what is left to the family if nothing changes.</p>
${(0, $8ea663173c1a6588$export$b23e227b9b89e73c)(snapshot.situation, {
        name: 'The support alone',
        pension: snapshot.baseline.pension,
        cashflow: snapshot.baseline.cashflow,
        estate: snapshot.baseline.legacy ?? snapshot.projectedLegacy
    }, snapshot.legacyYears ?? 5)}
</div></section>

` : ''}<section class="page"><div class="card">
<div class="h2">Your contribution assessment</div>
<p class="lede">Support at Home services are charged across three categories. Clinical care is fully government funded for everyone; your means determine what you contribute to the other two.</p>
<table><thead><tr><th>Category</th><th>Your rate</th><th>What it covers</th></tr></thead><tbody>
<tr><td>Clinical Care</td><td class="td-num">${$39348679b8be0d72$var$pct(snapshot.contributionRates.clinical)}</td><td>Nursing, physiotherapy, personal care (fully funded from 1 Oct 2026)</td></tr>
<tr><td>Independence</td><td class="td-num">${$39348679b8be0d72$var$pct(snapshot.contributionRates.independence)}</td><td>Social support, transport, respite</td></tr>
<tr><td>Everyday Living</td><td class="td-num">${$39348679b8be0d72$var$pct(snapshot.contributionRates.everydayLiving)}</td><td>Cleaning, gardening, meals</td></tr>
</tbody></table>
${overrideBlock || `<p class="small muted" style="margin-top:12px">These rates are modelled from your means. Your real co-contribution is decided by Services Australia's assessment and may differ.</p>`}
${contributionWorkingsBlock}
</div></section>

<section class="page"><div class="card">
<div class="h2">Your service plan</div>
${snapshot.servicePlan.isEstimated ? `<div class="callout callout--amber"><p class="callout-title">Illustrative package</p><p>${snapshot.servicePlan.description || 'No service plan was selected, so the modelling used a documented illustrative service mix. Build your actual plan in the Service Builder for costs based on your assessed services.'}</p></div>` : `<p class="lede">The modelling in this document is costed against the following services (indicative gross costs at median catalogue prices \u{2014} your out-of-pocket contribution applies your rates above).</p>`}
${$39348679b8be0d72$var$servicePlanTableHtml(snapshot.clientName, snapshot.servicePlan.clientRows, Boolean(snapshot.partnerName))}
${$39348679b8be0d72$var$servicePlanTableHtml(snapshot.partnerName || 'Partner', snapshot.servicePlan.partnerRows, Boolean(snapshot.partnerName))}
${$39348679b8be0d72$var$servicePlanBudgetsHtml(snapshot)}
${snapshot.servicePlan.grossAnnual > 0 ? `<p class="small" style="margin-top:10px"><strong>Total gross services: ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.servicePlan.grossAnnual)}/yr.</strong> Your modelled contribution is ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.annualContribution)}/yr${$39348679b8be0d72$var$servicePlanOverBudget(snapshot) >= 1 ? `, including ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)($39348679b8be0d72$var$servicePlanOverBudget(snapshot))} of services above a budget, paid in full` : ''}; the government funds the rest.</p>` : ''}
</div></section>

<section class="page"><div class="card">
<div class="h2">The recommended strategy</div>
<p class="lede"><strong>${snapshot.selectedStrategyName}</strong></p>
${narrativeBlocks || '<p class="muted">This strategy makes no changes to your position (do nothing) \u2014 it is the baseline the alternatives were measured against.</p>'}
${snapshot.strategyRisks?.sections?.length ? `<div class="h3">What could go wrong with this strategy</div>
<p class="muted">Every plan has trade-offs. These are the ones that matter for the strategy recommended here, as they were shown to you when you chose it.</p>
${snapshot.strategyRisks.sections.map((s)=>`<div class="h3" style="font-size:13px">${s.title}</div><ul class="riskList">${s.points.map((p)=>`<li><strong>${p.lead}</strong> ${p.body}</li>`).join('')}</ul>`).join('')}` : ''}
<div class="callout callout--slate">
<p class="callout-title">Measured against the support alone</p>
<p>Age Pension ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.annualPension)}/yr (baseline ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.baseline.pension)}/yr) \xb7 Cashflow ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.annualCashflow)}/yr (baseline ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.baseline.cashflow)}/yr) \xb7 Projected estate ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.projectedLegacy)}.</p>
</div>
</div></section>
${snapshot.guaranteedIncome ? `
<section class="page" data-section="guaranteed-income"><div class="card">
<div class="h2">Guaranteed income for life</div>
${(0, $66827b1304244a1d$export$5f47fbab513e00f4)(snapshot.guaranteedIncome)}
</div></section>
` : ''}
<section class="page"><div class="card">
<div class="h2">Alternative strategies considered</div>
<p class="lede">${snapshot.strategySource === 'manual_control' ? 'This strategy was constructed manually. The numbers above are measured against the do-nothing baseline.' : `The engine evaluated ${snapshot.totalEvaluated} strategies against your actual position. The leading options are shown below; the projected estate on each card is the comparison.`}</p>
${alternativesGrid}
</div></section>

<section class="page"><div class="card">
<div class="h2">Projection outlook</div>
<p class="lede">Year-by-year modelled outcomes for the selected strategy${(snapshot.baselineProjections || []).length ? ', against the support alone' : ''}. ${snapshot.projectionConvention} Hover over a year for its figures.</p>
${(0, $8ea663173c1a6588$export$6534c8cb884ee17d)({
        idPrefix: 'sah-proj',
        planName: $39348679b8be0d72$var$plainText(snapshot.selectedStrategyName),
        plan: snapshot.projections.map((r)=>({
                label: $39348679b8be0d72$var$plainText(r.label),
                pension: r.pension,
                cashflow: r.cashflow,
                netWorth: r.netWorth
            })),
        baselineName: 'The support alone',
        baseline: (snapshot.baselineProjections || []).map((r)=>({
                ...r,
                label: $39348679b8be0d72$var$plainText(r.label)
            }))
    })}
<div class="h3" style="margin-top:18px">Year by year</div>
${snapshot.projections.length ? `<table class="table-proj"><thead><tr><th>Year</th><th>Age Pension</th><th>Support at Home costs</th><th>Cashflow</th><th>Net worth</th></tr></thead><tbody>${projectionRows}</tbody></table>` : '<p class="muted">Projection rows were not available when this document was generated.</p>'}
</div></section>

<section class="page"><div class="card">
<div class="h2">Fees &amp; disclosures</div>
<table><thead><tr><th>Item</th><th>Amount</th><th>Notes</th></tr></thead><tbody>
<tr><td>Advice fee (initial)</td><td>$450 + GST</td><td>No ongoing or implementation fee in this pathway</td></tr>
<tr><td>Commissions</td><td>None</td><td>AgedCareWise receives no commissions or product payments in relation to this advice</td></tr>
</tbody></table>
<div class="callout callout--slate">
<p class="callout-title">Important disclosures</p>
<p class="small">This document illustrates modelled outcomes using the assumptions in the appendix; it is not a guarantee of future outcomes. Support at Home contribution rates and Age Pension entitlements are determined by Services Australia \u{2014} modelled figures are estimates until formally assessed. Where a strategy involves a financial product (annuity, reverse mortgage), the modelled outcome uses standard assumptions and the actual product's terms govern; obtain and compare the product's current disclosure documents before implementing.</p>
</div>
</div></section>

<section class="page"><div class="card">
<div class="h2">Risks &amp; limitations</div>
<ul class="riskList">
<li><strong>Modelling, not prophecy:</strong> projections use the assumptions in the appendix; actual investment returns, indexation and legislation will differ.</li>
<li><strong>Assessment risk:</strong> your contribution rates and Age Pension are determined by Services Australia. Modelled figures \u{2014} and even officially assessed rates \u{2014} change when your circumstances change.</li>
<li><strong>Strategy-specific risks:</strong> each recommended strategy's own risks are stated in its section above and form part of this advice.</li>
<li><strong>Liquidity:</strong> strategies that convert accessible savings into exempt or illiquid forms reduce your buffer for unexpected costs, including future care needs.</li>
<li><strong>Product terms:</strong> where a strategy involves a product (annuity, reverse mortgage), the modelled outcome uses standard assumptions; the actual product's terms govern.</li>
</ul>
${snapshot.ratesReviewNotice ? `<div class="callout callout--amber"><p class="callout-title">Rates review</p><p>${snapshot.ratesReviewNotice}</p></div>` : ''}
</div></section>

<section class="page"><div class="card">
<div class="h2">Next steps</div>
${$39348679b8be0d72$var$pensionNextStepsHtml(snapshot.annualPension, snapshot.baseline.pension)}
<ul class="riskList">
<li>Review this document with your family or trusted adviser.</li>
<li>Confirm your Support at Home assessment and contribution rates with Services Australia; if you receive an assessment letter, your adviser can record the official rates in the tool.</li>
<li>Build or refine your service plan in the Service Builder so costs reflect your actual assessed services.</li>
<li>Before implementing any product-based strategy (annuity, reverse mortgage, HEAS), obtain the product's current terms and compare providers.</li>
<li>Revisit this advice when circumstances change materially \u{2014} health, family, markets or legislation.</li>
</ul>
</div></section>

<section class="page"><div class="card">
<div class="h2">Appendix \u{2014} fact-find &amp; assumptions</div>
<p><strong>Client age:</strong> ${snapshot.clientAge ?? 'Not provided'}${snapshot.partnerName ? ` | <strong>Partner:</strong> ${snapshot.partnerName}` : ''}</p>
<p><strong>Living expenses (annual):</strong> ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.annualLivingExpenses || 0)}</p>
<div class="h3">Position at generation</div>
<div class="factSection">
<div class="factRow"><div class="factLabel">Assessable income (modelled)</div><div>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.baseline.assessableIncome)}/yr</div></div>
<div class="factRow"><div class="factLabel">Assessable assets (modelled)</div><div>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.baseline.assessableAssets)}</div></div>
<div class="factRow"><div class="factLabel">Age Pension before this strategy</div><div>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.baseline.pension)}/yr</div></div>
<div class="factRow"><div class="factLabel">Cashflow before this strategy</div><div>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.baseline.cashflow)}/yr</div></div>
</div>
<div class="h3">Asset assumptions</div>
<table><thead><tr><th>Asset type</th><th>Description</th><th>Value</th><th>Income %</th><th>Growth %</th><th>Client's own figures</th></tr></thead><tbody>
${(snapshot.assetRows || []).map((row)=>`<tr><td>${row.assetType}</td><td>${row.description}${row.basis ? `<div class="tiny muted">${row.basis}</div>` : ''}</td><td>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.value)}</td><td>${row.incomeRate.toFixed(2)}%</td><td>${row.growthRate.toFixed(2)}%</td><td>${row.overridden ? 'Yes' : 'No'}</td></tr>`).join('')}
</tbody></table>
<p class="tiny muted">Income % is what the model applied. For an investment property it is the yield the recorded rent represents \u{2014} the projections use the rent and expense dollars recorded for the property, not an assumed yield.</p>
${snapshot.structureAppendixHtml || ''}
<div class="h3">Structured fact-find responses</div>
${(snapshot.factFindSections || []).map((section)=>`
<details class="factSection"><summary><strong>${section.title}</strong></summary>
  <div>
    ${section.rows.map((row)=>`<div class="factRow"><div class="factLabel">${row.label}</div><div>${$39348679b8be0d72$export$57a9131fd362a631(row.value)}</div></div>`).join('')}
  </div>
</details>`).join('')}
<details class="factSection"><summary><strong>Rates &amp; thresholds used</strong></summary>
<table><thead><tr><th>Rate / threshold</th><th>Value used</th><th>Notes</th></tr></thead><tbody>
<tr><td>Clinical Care contribution</td><td>0%</td><td>Fully government funded at every means level (personal care included from 1 Oct 2026)</td></tr>
${snapshot.noWorseOff ? `<tr><td>Independence contribution band ('no worse off')</td><td>${snapshot.noWorseOff.paidNoFee ? '0%' : "0% \u2013 25%"}</td><td>${snapshot.noWorseOff.paidNoFee ? 'No income-tested care fee was payable under the package: no contributions' : "Full pensioner 0%, self-funded 25%; otherwise on income only (Services Australia\u2019s four-step method)"}</td></tr>
<tr><td>Everyday Living contribution band ('no worse off')</td><td>${snapshot.noWorseOff.paidNoFee ? '0%' : "0% \u2013 25%"}</td><td>Same basis as Independence</td></tr>
<tr><td>Income band (income free area \u{2192} income limit)</td><td>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(th.incomeMin)} \u{2013} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(th.incomeMax)}</td><td>The only thresholds the 'no worse off' rate uses; assets play no part</td></tr>
${snapshot.noWorseOff.previousFeeDaily > 0 ? `<tr><td>Fortnightly ceiling</td><td>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.noWorseOff.previousFeeDaily * 14)}</td><td>The previous income-tested care fee (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshot.noWorseOff.previousFeeDaily)} a day \xd7 14); contributions never exceed it</td></tr>` : ''}
<tr><td>Lifetime cap</td><td>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $c424aab2467b2598$export$c5fbc76332b2670f).nwop)}</td><td>The package cap, indexed; fees paid under the package count towards it</td></tr>` : `<tr><td>Independence contribution band</td><td>5% \u{2013} 50%</td><td>Full pensioner minimum to self-funded maximum; part pensioners slide between</td></tr>
<tr><td>Everyday Living contribution band</td><td>17.5% \u{2013} 80%</td><td>Full pensioner minimum to self-funded maximum; part pensioners slide between</td></tr>
<tr><td>Income band (full-pension \u{2192} self-funded)</td><td>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(th.incomeMin)} \u{2013} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(th.incomeMax)}</td><td>Assessable income thresholds used for the sliding scale</td></tr>
<tr><td>Asset band (full-pension \u{2192} self-funded)</td><td>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(th.assetMin)} \u{2013} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(th.assetMax)}</td><td>Assessable asset thresholds used for the sliding scale</td></tr>`}
<tr><td>Service prices</td><td>Median catalogue prices</td><td>Gross service costs; providers' actual prices vary</td></tr>
<tr><td>Deeming</td><td>Current deeming rates &amp; thresholds</td><td>Applied to financial assets for the income test</td></tr>
<tr><td>Pension transfer balance cap</td><td>${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$807e93be6ec93c1b))} per person (lifetime)</td><td>Where a strategy commences a pension, only the person's remaining cap is moved into it; any excess goes to accumulation super. Cap usage uses the ATO transfer balance account figure where recorded, otherwise it is estimated from current pension balances \u{2014} an estimate that can understate usage where a pension was commenced years ago and since drawn down.</td></tr>
<tr><td>Advice fee (initial)</td><td>$450 + GST</td><td>No ongoing or implementation fee in this pathway</td></tr>
</tbody></table>
</details>
<div class="h3">Tax, super, Age Pension, Support at Home and market assumptions</div>
<p class="small muted">Every rate and threshold the model used, as the Assumptions page showed them when this document was generated. Open a group to read it.</p>
${(0, $8ea663173c1a6588$export$5f05ccad41218e23)(snapshot.assumptionSections || (0, $13910bc1e93fb74e$export$8d1b1c5d08b3c488)(), /Support at Home|Social Security|Tax|How the Plans/i)}
<div class="h3">Conventions</div>
<p class="small">${snapshot.projectionConvention} Service costs use median catalogue prices; contribution dollars apply your modelled (or officially recorded) contribution rates.</p>
<p class="tiny muted" style="margin-top:16px">Report ${snapshot.reportId} \xb7 Generated ${$39348679b8be0d72$var$formatDateOnly(snapshot.generatedAt)} \xb7 Source: ${snapshot.strategySource === 'manual_control' ? 'Manual Control' : 'Suggestion Engine'} \xb7 This document is a modelling illustration prepared by AgedCareWise and does not replace formal assessment by Services Australia.</p>
</div></section>

</div>
<script src="${$39348679b8be0d72$var$soaBookletScriptUrl}"></script>
</body></html>`;
}
function $39348679b8be0d72$export$d13a73f2d338923d(snapshot) {
    if (!snapshot) return;
    const html = $39348679b8be0d72$export$b71867531de1aafe(snapshot);
    const blob = new Blob([
        html
    ], {
        type: 'text/html;charset=utf-8'
    });
    const url = URL.createObjectURL(blob);
    const safeName = snapshot.clientName.replace(/[^a-zA-Z0-9]/g, '_');
    const tab = window.open('', '_blank');
    if (tab) {
        tab.document.open();
        tab.document.write(html);
        tab.document.close();
    } else {
        const openLink = document.createElement('a');
        openLink.href = url;
        openLink.target = '_blank';
        openLink.rel = 'noopener noreferrer';
        document.body.appendChild(openLink);
        openLink.click();
        document.body.removeChild(openLink);
    }
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = `Digital_SOA_SupportAtHome_${safeName}_${snapshot.generatedAt.slice(0, 10)}.html`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    setTimeout(()=>URL.revokeObjectURL(url), 30000);
}
/** Claiming, or reporting, the pension change the plan rests on (owner, 3 Oct 2026): a call-out above the next steps. */ function $39348679b8be0d72$var$pensionNextStepsHtml(planPension, baselinePension) {
    const note = (0, $b82b108d4741f18d$export$fdc5fe41a9ca9852)(planPension, baselinePension, {
        meansAssessment: 'home'
    });
    if (!note) return '';
    const esc = (t)=>t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return `<div class="callout callout--amber"><p class="callout-title">${esc(note.implication.title)}</p><p><strong>${esc(note.implication.lead)}</strong> ${esc(note.implication.body)}</p><p><strong>Next step:</strong> ${esc(note.nextStep)}</p></div>`;
}




// Support at Home Suggestion Engine Panel – strategy comparison and optimisation for Support at Home funding.
// Renamed from SupportAtHomeSuggestionEngine for clarity (parallel to AgedCareSuggestionEnginePanel).


var $acw62 = parcelRequire("acw62");









/**
 * What happens to each asset on a Support at home plan, in words (review, 18 Oct 2026: "View Details"
 * printed the engine's codes — "partiallySold", "upgraded" — and "Liquidated" as a heading; a couple's
 * two accounts called "MLC" were shown as "MLC" twice, with no way to tell his from hers).
 */ const $2a669e0126fd3a3e$var$STATUS_WORDS = {
    sold: 'Sold in full',
    partiallySold: 'Partly sold',
    kept: 'Kept',
    new: 'New',
    upgraded: 'Moved to a dearer home',
    downsized: 'Moved to a cheaper home',
    repaid: 'Paid off',
    partiallyRepaid: 'Partly paid off',
    gifted: 'Given away'
};
function $2a669e0126fd3a3e$export$acfc0c5058edfc8(status) {
    const key = String(status ?? '');
    if ($2a669e0126fd3a3e$var$STATUS_WORDS[key]) return $2a669e0126fd3a3e$var$STATUS_WORDS[key];
    // An engine code this list has not met yet: split the camel case rather than print it raw.
    const spaced = key.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
    return spaced ? spaced[0].toUpperCase() + spaced.slice(1) : '';
}
function $2a669e0126fd3a3e$export$9555bc30b49fd2f2(asset, factFind) {
    const name = String(asset?.assetName || '').trim();
    if (!name || factFind?.adviceFor !== 'couple') return name;
    const owner = asset?.ownership === 'partner' ? factFind?.partner?.firstName : asset?.ownership === 'client' ? factFind?.client?.firstName : null;
    if (!owner) return name;
    return name.toLowerCase().includes(String(owner).toLowerCase()) ? name : `${owner}'s ${name}`;
}




/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3739d64fb7ddfae6$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "8",
            height: "4",
            x: "8",
            y: "2",
            rx: "1",
            ry: "1",
            key: "tgr4d6"
        }
    ],
    [
        "path",
        {
            d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
            key: "116196"
        }
    ],
    [
        "path",
        {
            d: "M12 11h4",
            key: "1jrz19"
        }
    ],
    [
        "path",
        {
            d: "M12 16h4",
            key: "n85exb"
        }
    ],
    [
        "path",
        {
            d: "M8 11h.01",
            key: "1dfujw"
        }
    ],
    [
        "path",
        {
            d: "M8 16h.01",
            key: "18s6g9"
        }
    ]
];
const $3739d64fb7ddfae6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("clipboard-list", $3739d64fb7ddfae6$export$3efd853dbb351e94);



var $1u0KT = parcelRequire("1u0KT");



/**
 * Support at Home Problem Identifier
 *
 * Analyzes baseline financial position to identify optimization opportunities
 * and determine which strategies are relevant for the client's situation.
 * This enables intelligent filtering to avoid wasting time on strategies that won't help.
 */ 
/**
 * Illustrative Support at Home service plan for the suggestion engine when the
 * user has not built a Service Plan in Service Builder.
 *
 * Purpose: Strategy comparison needs a consistent dollar cost of care so
 * contribution rates translate into contribution $, cashflow, and legacy impacts.
 * This is NOT a substitute for a formal assessment or a tailored service plan.
 */ /** One line item within a Service Builder plan side (client/partner): quantity of a service at a frequency. */ const $f5036bbfe52e7121$export$63ffd8a46e7b9f30 = {
    nursing_registered: {
        quantity: 1,
        frequency: 'monthly'
    },
    personal_care: {
        quantity: 6,
        frequency: 'weekly'
    },
    domestic_assistance: {
        quantity: 3,
        frequency: 'weekly'
    },
    social_support_community_engagement: {
        quantity: 2,
        frequency: 'weekly'
    },
    transport: {
        quantity: 4,
        frequency: 'monthly'
    },
    meal_delivery: {
        quantity: 8,
        frequency: 'monthly'
    }
};
const $f5036bbfe52e7121$export$9f8c1bb6232cda55 = 'Illustrative moderate package (not your actual plan): ~6 hrs personal care/week, ~3 hrs domestic/week, ~2 hrs social support/week, ~4 transport trips/month, ~8 meals/month, ~1 hr nursing/month. Dollar costs use median catalogue prices; your contribution $ uses your modelled contribution rates.';
function $f5036bbfe52e7121$export$aba30ca5ea57db9d(servicePlan) {
    if (!servicePlan) return false;
    const client = servicePlan.client || {};
    const partner = servicePlan.partner || {};
    const hasClient = Object.values(client).some((d)=>d && d.quantity > 0);
    const hasPartner = Object.values(partner).some((d)=>d && d.quantity > 0);
    return hasClient || hasPartner;
}
function $f5036bbfe52e7121$export$528f6df084e80c0b(servicePlan, isPartnered = false) {
    if ($f5036bbfe52e7121$export$aba30ca5ea57db9d(servicePlan)) return {
        plan: {
            client: servicePlan?.client || {},
            partner: isPartnered ? servicePlan?.partner || {} : {}
        },
        isEstimated: false,
        description: null
    };
    /*
     * No services chosen: nothing to price (owner's decision 2, 19 Oct 2026, enforced 20 Oct 2026 — the
     * engine's baseline charged the illustrative package below while step 1 priced the empty plan, so
     * "each year" read short by $29,071 against Home's $1,058 to spare). The package is kept only as a
     * named example; it is no longer substituted for an empty plan anywhere.
     */ return {
        plan: {
            client: {},
            partner: {}
        },
        isEstimated: false,
        description: null
    };
}


/**
 * Shared helpers for Support at Home suggestion engine projections and contributions.
 */ 
function $1c8db18e4a270f4c$export$4393c2f696910049(projection) {
    if (!projection) return 0;
    const value = projection.cashFlow ?? projection.cashflow;
    return Number.isFinite(value) ? value : 0;
}
function $1c8db18e4a270f4c$export$c47b14b2448970ec(contributions, isPartnered) {
    const branch = isPartnered ? contributions?.combined : contributions?.client;
    return branch?.contributionAmounts?.totalAnnual ?? branch?.totalAnnual ?? 0;
}
function $1c8db18e4a270f4c$export$db6efb5ba42bc35c(servicePlanCosts) {
    return servicePlanCosts?.contribution?.total ?? 0;
}
function $1c8db18e4a270f4c$export$6300bffc88d4a5ec(strategyConfig, servicePlanCosts, evaluationStrategyOptions = {}, livingExpenses = 0) {
    const integratedAgedCareCost = $1c8db18e4a270f4c$export$db6efb5ba42bc35c(servicePlanCosts);
    const options = {
        scenarioLivingExpenses: livingExpenses,
        integratedAgedCareCost: integratedAgedCareCost,
        ...evaluationStrategyOptions
    };
    if (strategyConfig?.type === 'reverseMortgage') {
        options.reverseMortgage = true;
        options.reverseMortgageDetails = {
            loanAmount: strategyConfig.loanAmount,
            interestRate: strategyConfig.interestRate ?? (0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279),
            loanStructure: strategyConfig.loanStructure || 'lump_sum',
            establishmentFees: strategyConfig.establishmentFees ?? 0,
            useForRad: false
        };
    }
    if (strategyConfig?.type === 'heas') {
        options.heas = true;
        options.heasDetails = {
            paymentAmount: strategyConfig.paymentAmount,
            paymentFrequency: strategyConfig.paymentFrequency || 'fortnightly',
            interestRate: strategyConfig.interestRate ?? 3.95
        };
    }
    return options;
}
function $1c8db18e4a270f4c$export$e00093e7660277b2(factFind, strategyConfig) {
    const data = structuredClone(factFind);
    if (strategyConfig?.type === 'reverseMortgage' && data.liabilities?.loans) data.liabilities.loans = data.liabilities.loans.filter((l)=>l.id !== 'reverse-mortgage' && l.type !== 'reverse_mortgage');
    return data;
}






async function $e7f7fd8599da7702$export$c04a983651e4920b(factFind, servicePlan = null, legacyYears = 5, evaluationOptions = {}) {
    // 1-4. Baseline financials/contributions/projections now computed server-side in one request
    // (server/src/rest/calculation/suggestionEngine/supportAtHome.ts's computeSupportAtHomeBaselineData,
    // which also feeds evaluateSupportAtHomeStrategies) — everything below (pension/contribution/
    // cashflow-opportunity analysis) is pure and stays local.
    const { baselineFinancials: baselineFinancials, baselineContributions: baselineContributions, baselineProjections: baselineProjections } = await $55a1d8a64f1e5dfa$export$2440fc29f5473353(factFind, servicePlan || {}, legacyYears, evaluationOptions);
    const isPartnered = factFind?.adviceFor === 'couple';
    const servicePlanResolution = (0, $f5036bbfe52e7121$export$528f6df084e80c0b)(servicePlan, isPartnered);
    // servicePlanCosts here is display-only (isEstimated/estimatedDescription for the UI) — the
    // dollar figures actually used for baselineProjections were already computed server-side above.
    const servicePlanCosts = {
        isEstimated: servicePlanResolution.isEstimated,
        estimatedDescription: servicePlanResolution.description
    };
    // 5. Analyze pension optimization potential
    const pensionOpportunity = $e7f7fd8599da7702$var$determinePensionOptimizationPotential(baselineFinancials, factFind);
    // 6. Analyze contribution rate optimization potential
    const contributionOpportunity = $e7f7fd8599da7702$var$determineContributionOptimizationPotential(baselineContributions, pensionOpportunity, factFind);
    // 7. Analyze cashflow position
    const cashflowOpportunity = $e7f7fd8599da7702$var$analyzeCashflowPosition(baselineProjections);
    // 8. Determine recommended focus
    const recommendedFocus = $e7f7fd8599da7702$var$determineRecommendedFocus(pensionOpportunity, contributionOpportunity, cashflowOpportunity);
    // 9. Generate problem statement
    const problemStatement = $e7f7fd8599da7702$var$generateProblemStatement(pensionOpportunity, contributionOpportunity, cashflowOpportunity, recommendedFocus);
    return {
        pensionOpportunity: pensionOpportunity,
        contributionOpportunity: contributionOpportunity,
        cashflowOpportunity: cashflowOpportunity,
        recommendedFocus: recommendedFocus,
        problemStatement: problemStatement,
        baselineFinancials: baselineFinancials,
        baselineContributions: baselineContributions,
        baselineProjections: baselineProjections,
        servicePlanCosts: servicePlanCosts,
        servicePlanResolution: servicePlanResolution
    };
}
/**
 * Determine pension optimization potential
 */ function $e7f7fd8599da7702$var$determinePensionOptimizationPotential(financials, factFind) {
    const isPartnered = factFind?.adviceFor === 'couple';
    const isHomeowner = (0, $d1b9bbc5238c0548$export$2f999b99c41ee933)(factFind);
    const maxPensionRate = isPartnered ? (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).couple : (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single;
    const agePension = Number(financials.socialSecurity) || 0;
    const pensionRatio = maxPensionRate > 0 ? agePension / maxPensionRate : 0;
    // Determine current pension status
    let pensionStatus;
    if (pensionRatio >= 0.95) pensionStatus = 'full';
    else if (pensionRatio > 0) pensionStatus = 'part';
    else pensionStatus = 'self-funded';
    // Calculate distance from full pension threshold
    const assetThreshold = isPartnered ? isHomeowner ? (0, $1abe73eeef086faf$export$9a84fd450010fb2e).couple.homeowner.full : (0, $1abe73eeef086faf$export$9a84fd450010fb2e).couple.nonHomeowner.full : isHomeowner ? (0, $1abe73eeef086faf$export$9a84fd450010fb2e).single.homeowner.full : (0, $1abe73eeef086faf$export$9a84fd450010fb2e).single.nonHomeowner.full;
    const assessableAssets = Number(financials.assessableAssets) || 0;
    const assetsAboveThreshold = Math.max(0, assessableAssets - assetThreshold);
    // Estimate potential pension gain (simplified - assumes asset reduction directly translates to pension increase)
    // Actual calculation would need to account for both asset and income tests
    let estimatedMaxPensionGain = 0;
    if (pensionStatus !== 'full' && assetsAboveThreshold > 0) {
        // Each $1,000 of assets above threshold reduces pension by $78/year
        // So reducing assets by $1,000 increases pension by $78/year (up to full pension)
        const maxReductionPossible = Math.min(assetsAboveThreshold, assessableAssets);
        const estimatedGainFromAssetReduction = maxReductionPossible / 1000 * (0, $1abe73eeef086faf$export$6ca758cf677ce6c5);
        estimatedMaxPensionGain = Math.min(estimatedGainFromAssetReduction, maxPensionRate - agePension);
    }
    return {
        status: pensionStatus,
        currentPension: agePension,
        maxPension: maxPensionRate,
        pensionRatio: pensionRatio,
        canImprovePension: pensionStatus !== 'full' && assetsAboveThreshold > 0,
        assetsAboveThreshold: assetsAboveThreshold,
        estimatedMaxPensionGain: estimatedMaxPensionGain,
        assessableAssets: assessableAssets,
        assetThreshold: assetThreshold
    };
}
/**
 * Determine contribution rate optimization potential
 */ function $e7f7fd8599da7702$var$determineContributionOptimizationPotential(contributions, pensionOpportunity, factFind) {
    const isPartnered = factFind?.adviceFor === 'couple';
    const contributionRates = isPartnered ? contributions?.combined?.contributionRates || {} : contributions?.client?.contributionRates || {};
    const annualContribution = (0, $1c8db18e4a270f4c$export$c47b14b2448970ec)(contributions, isPartnered);
    // If full pension, contribution rates are already at minimum (except NWOP Category B)
    // If part/self-funded, can potentially reduce rates via pension increase
    const canReduceViaPension = pensionOpportunity.canImprovePension;
    // Current rates
    const clinicalRate = contributionRates.clinical || 0;
    const independenceRate = contributionRates.independence || 0;
    const everydayLivingRate = contributionRates.everydayLiving || 0;
    // Are rates already at minimum?
    const ratesAtMinimum = clinicalRate === 0 && (independenceRate <= 0.05 || independenceRate === 0) && (everydayLivingRate <= 0.175 || everydayLivingRate === 0);
    return {
        currentRates: {
            clinical: clinicalRate,
            independence: independenceRate,
            everydayLiving: everydayLivingRate
        },
        annualContribution: annualContribution,
        canReduceViaPension: canReduceViaPension,
        ratesAtMinimum: ratesAtMinimum,
        optimizationPotential: canReduceViaPension && !ratesAtMinimum ? 'high' : ratesAtMinimum ? 'low' : 'medium'
    };
}
/**
 * Analyze cashflow position from projections
 */ function $e7f7fd8599da7702$var$analyzeCashflowPosition(projections) {
    if (!projections || projections.length === 0) return {
        year1Cashflow: 0,
        yearsToDeficit: null,
        cashflowOptimizationNeeded: false,
        averageCashflow: 0
    };
    /*
     * The STANDING cashflow, on the same basis as the starting position above it (review, 18 Oct 2026:
     * that said $1,058 before care less a $13,444 share, −$12,386, while this tile said −$11,909). The
     * row's own breakdown is the year at its opening rates; the row's total is what the year actually
     * paid, which moves as the means test is re-run. "Where you stand" is the first, so it is read from
     * the breakdown when the row has one. The deficit year below still reads the paid totals.
     */ const openingLines = Array.isArray(projections[0]?.cashFlowBreakdown) ? projections[0].cashFlowBreakdown : null;
    const openingSum = openingLines ? openingLines.reduce((t, l)=>l?.note || !Number.isFinite(Number(l?.value)) ? t : t + Number(l.value), 0) : null;
    const year1Cashflow = openingSum != null && openingLines.length > 0 ? openingSum : (0, $1c8db18e4a270f4c$export$4393c2f696910049)(projections[0]);
    // Find when cashflow goes negative (if at all)
    let yearsToDeficit = null;
    for(let i = 0; i < projections.length; i++)if ((0, $1c8db18e4a270f4c$export$4393c2f696910049)(projections[i]) < 0) {
        yearsToDeficit = i + 1;
        break;
    }
    const totalCashflow = projections.reduce((sum, p)=>sum + (0, $1c8db18e4a270f4c$export$4393c2f696910049)(p), 0);
    const averageCashflow = projections.length > 0 ? totalCashflow / projections.length : 0;
    // Cashflow optimization needed if:
    // - Year 1 is negative, OR
    // - Will go negative within 5 years
    const cashflowOptimizationNeeded = year1Cashflow < 0 || yearsToDeficit !== null && yearsToDeficit <= 5;
    return {
        year1Cashflow: year1Cashflow,
        yearsToDeficit: yearsToDeficit,
        cashflowOptimizationNeeded: cashflowOptimizationNeeded,
        averageCashflow: averageCashflow,
        allYearsPositive: yearsToDeficit === null
    };
}
/**
 * Determine recommended focus based on opportunities
 */ function $e7f7fd8599da7702$var$determineRecommendedFocus(pensionOpportunity, contributionOpportunity, cashflowOpportunity) {
    // If pension can be improved and contribution rates are high, focus on pension optimization
    if (pensionOpportunity.canImprovePension && contributionOpportunity.optimizationPotential === 'high') return 'pension_and_contributions';
    // If pension can be improved but rates are already low, focus on pension + cashflow
    if (pensionOpportunity.canImprovePension && contributionOpportunity.ratesAtMinimum) return 'pension_and_cashflow';
    // If pension is already maximized but cashflow is poor, focus on cashflow
    if (!pensionOpportunity.canImprovePension && cashflowOpportunity.cashflowOptimizationNeeded) return 'cashflow';
    // If pension is maximized and cashflow is good, focus on legacy preservation
    if (!pensionOpportunity.canImprovePension && !cashflowOpportunity.cashflowOptimizationNeeded) return 'legacy';
    // Default: balanced approach
    return 'balanced';
}
/**
 * Generate problem statement with strategy relevance
 */ function $e7f7fd8599da7702$var$generateProblemStatement(pensionOpportunity, contributionOpportunity, cashflowOpportunity, recommendedFocus) {
    const pensionStatus = pensionOpportunity.status;
    // Build summary
    let summary = '';
    if (pensionStatus === 'full') {
        summary = "You are currently receiving full Age Pension. Strategies focused on pension optimization (gifting, funeral bonds to increase pension) will not provide additional pension benefit. ";
        if (cashflowOpportunity.cashflowOptimizationNeeded) summary += "We recommend focusing on cashflow optimization and legacy preservation strategies.";
        else summary += "We recommend focusing on legacy preservation and maintaining sustainable cashflow.";
    } else if (pensionStatus === 'part') // Review, 18 Oct 2026: "could rise by approximately $35,958" beside a best plan worth $19,500, with
    // neither figure explained. The figure is a CEILING — the pension if counted assets fell all the
    // way to the full-pension limit — so it is called that, and the plans say what they really add.
    summary = `You receive a part Age Pension. If the assets Centrelink counts came down to the full-pension limit, it would be about $${Math.round(pensionOpportunity.estimatedMaxPensionGain).toLocaleString()} a year higher. That is the most it could rise, not what any one plan achieves; each plan below shows what it really adds. Counting fewer assets can also lower the Support at Home contribution rates.`;
    else summary = "You are currently self-funded (not receiving Age Pension). There is significant potential to qualify for Age Pension and reduce your Support at Home contribution rates through asset restructuring strategies.";
    // Determine strategy relevance
    const strategyRelevance = {
        gifting: {
            relevant: pensionStatus !== 'full' || contributionOpportunity.optimizationPotential !== 'low',
            reason: pensionStatus === 'full' ? "Will not increase pension (already full), but may still help with contribution rate optimization if you're in NWOP Category B" : "Can reduce assessable assets and potentially increase Age Pension entitlement"
        },
        funeralBonds: {
            relevant: pensionStatus !== 'full' || contributionOpportunity.optimizationPotential !== 'low',
            reason: pensionStatus === 'full' ? "Will not increase pension (already full), but may still be beneficial for funeral planning" : `Can reduce assessable assets (up to ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$aca3edb7cd7a3f17))} per person exempt) and potentially increase Age Pension`
        },
        annuities: {
            relevant: true,
            reason: pensionStatus === 'full' ? "Can provide guaranteed income to improve cashflow and preserve legacy value" : "Can reduce assessable assets (60% or 30% assessment) to increase pension, plus provide guaranteed income"
        },
        propertyStrategies: {
            relevant: true,
            reason: "Can optimize asset allocation, improve cashflow, and preserve estate value"
        },
        agedCareIntegration: {
            relevant: true,
            reason: "Helps prepare for potential future transition to residential aged care"
        }
    };
    // Identify irrelevant strategies
    const irrelevantStrategies = [];
    if (!strategyRelevance.gifting.relevant) irrelevantStrategies.push('gifting');
    if (!strategyRelevance.funeralBonds.relevant) irrelevantStrategies.push('funeralBonds');
    // Recommended strategies based on focus
    const recommendedStrategies = [];
    if (recommendedFocus === 'pension_and_contributions' || recommendedFocus === 'pension_and_cashflow') {
        if (strategyRelevance.gifting.relevant) recommendedStrategies.push('gifting');
        if (strategyRelevance.funeralBonds.relevant) recommendedStrategies.push('funeralBonds');
        recommendedStrategies.push('annuities');
    }
    if (recommendedFocus === 'cashflow' || recommendedFocus === 'legacy' || recommendedFocus === 'balanced') {
        recommendedStrategies.push('annuities');
        recommendedStrategies.push('propertyStrategies');
    }
    return {
        summary: summary,
        pensionOptimization: {
            status: pensionStatus,
            canImprove: pensionOpportunity.canImprovePension,
            currentPension: pensionOpportunity.currentPension,
            maxPension: pensionOpportunity.maxPension,
            estimatedMaxGain: pensionOpportunity.estimatedMaxPensionGain,
            reason: pensionStatus === 'full' ? "Already receiving maximum Age Pension entitlement" : `Can potentially increase pension by up to $${Math.round(pensionOpportunity.estimatedMaxPensionGain).toLocaleString()} per year`,
            recommendation: pensionStatus === 'full' ? "Focus on cashflow/legacy instead" : "Asset restructuring strategies can help increase pension"
        },
        contributionOptimization: {
            currentRates: contributionOpportunity.currentRates,
            annualContribution: contributionOpportunity.annualContribution,
            canReduceViaPension: contributionOpportunity.canReduceViaPension,
            ratesAtMinimum: contributionOpportunity.ratesAtMinimum,
            optimizationPotential: contributionOpportunity.optimizationPotential
        },
        cashflowPosition: {
            year1Cashflow: cashflowOpportunity.year1Cashflow,
            yearsToDeficit: cashflowOpportunity.yearsToDeficit,
            optimizationNeeded: cashflowOpportunity.cashflowOptimizationNeeded,
            status: cashflowOpportunity.allYearsPositive ? 'sustainable' : cashflowOpportunity.year1Cashflow < 0 ? 'deficit' : 'future_deficit'
        },
        recommendedFocus: recommendedFocus,
        strategyRelevance: strategyRelevance,
        irrelevantStrategies: irrelevantStrategies,
        recommendedStrategies: recommendedStrategies
    };
}
function $e7f7fd8599da7702$export$3d3dcd311a86b11c(problemStatement, enabledStrategies) {
    const filtered = {
        toSkip: [],
        toKeep: [],
        warnings: []
    };
    // Check each enabled strategy
    if (enabledStrategies.includeGifting && !problemStatement.strategyRelevance.gifting.relevant) {
        filtered.toSkip.push({
            strategy: 'gifting',
            reason: problemStatement.strategyRelevance.gifting.reason,
            suggested: problemStatement.recommendedStrategies
        });
        filtered.warnings.push({
            strategy: 'Gifting to Family',
            message: problemStatement.strategyRelevance.gifting.reason,
            severity: 'info'
        });
    } else if (enabledStrategies.includeGifting) filtered.toKeep.push('gifting');
    if (enabledStrategies.includeFuneralBonds && !problemStatement.strategyRelevance.funeralBonds.relevant) {
        filtered.toSkip.push({
            strategy: 'funeralBonds',
            reason: problemStatement.strategyRelevance.funeralBonds.reason,
            suggested: problemStatement.recommendedStrategies
        });
        filtered.warnings.push({
            strategy: 'Funeral Bonds',
            message: problemStatement.strategyRelevance.funeralBonds.reason,
            severity: 'info'
        });
    } else if (enabledStrategies.includeFuneralBonds) filtered.toKeep.push('funeralBonds');
    if (enabledStrategies.includeAnnuities) filtered.toKeep.push('annuities');
    if (enabledStrategies.includePropertyStrategies) filtered.toKeep.push('propertyStrategies');
    if (enabledStrategies.includeAgedCareIntegration) filtered.toKeep.push('agedCareIntegration');
    return filtered;
}


/**
 * Support at Home Strategy Evaluator
 *
 * Ranks already-evaluated strategies (from the server-side composite endpoint,
 * calculationApi.evaluateSupportAtHomeStrategies) by goal priority.
 */ function $21ed594a114149ac$export$ab96930334f9813c(strategy, goalPriority, _baselineAnalysis) {
    const s = strategy.snapshot || {};
    // Normalize values to prevent one metric from dominating
    const normalizeCashflow = (value)=>value / 10000; // $10K units
    const normalizePension = (value)=>value / 5000; // $5K units
    const normalizeContribution = (value)=>value / 5000; // $5K units
    const normalizeLegacy = (value)=>value / 50000; // $50K units
    if (goalPriority === 'cashflow') return normalizeCashflow(s.cashflowImprovement || 0) * 0.5 + normalizeContribution(s.contributionReduction || 0) * 0.3 + normalizePension(s.agePensionIncrease || 0) * 0.2;
    else if (goalPriority === 'pension') return normalizePension(s.agePensionIncrease || 0) * 0.5 + normalizeContribution(s.contributionReduction || 0) * 0.3 + (1 - (s.contributionRates?.everydayLiving || 0)) * 0.2 // Lower rate = higher score
    ;
    else if (goalPriority === 'estate') return normalizeLegacy(s.legacyImprovement || 0) * 0.5 + normalizeContribution(s.contributionReduction || 0) * 0.3 + normalizeCashflow(s.cashflowImprovement || 0) * 0.2;
    else // Balanced scoring (all goals equal)
    return normalizeCashflow(s.cashflowImprovement || 0) * 0.4 + normalizePension(s.agePensionIncrease || 0) * 0.3 + normalizeLegacy(s.legacyImprovement || 0) * 0.3;
}
function $21ed594a114149ac$export$cb7d99be370b6691(strategies, goalPriority, baselineAnalysis) {
    // Calculate scores for all strategies
    const strategiesWithScores = strategies.map((strategy)=>({
            ...strategy,
            score: $21ed594a114149ac$export$ab96930334f9813c(strategy, goalPriority, baselineAnalysis)
        }));
    // Filter out strategies that worsen key metrics without meaningful benefit
    const viableStrategies = strategiesWithScores.filter((strategy)=>{
        if (strategy.name === 'Do Nothing' || strategy.config?.type === 'doNothing') return true;
        const s = strategy.snapshot || {};
        // Get improvements (negative values mean worsening)
        const cashflowImprovement = s.cashflowImprovement || 0;
        const pensionIncrease = s.agePensionIncrease || 0;
        const contributionReduction = s.contributionReduction || 0;
        const legacyImprovement = s.legacyImprovement || 0;
        // Count improvements and deteriorations
        const improvements = [
            cashflowImprovement > 0,
            pensionIncrease > 0,
            contributionReduction > 0,
            legacyImprovement > 0
        ].filter(Boolean).length;
        const deteriorations = [
            cashflowImprovement < 0,
            pensionIncrease < 0,
            contributionReduction < 0,
            legacyImprovement < 0
        ].filter(Boolean).length;
        // Exclude strategies that:
        // 1. Worsen ALL key metrics (no improvement in any area)
        if (improvements === 0) return false;
        // 2. Worsen cashflow significantly (>$10K) without improving pension or contributions
        // AND only provide small legacy benefit (<$50K)
        if (cashflowImprovement < -10000 && pensionIncrease <= 0 && contributionReduction <= 0 && legacyImprovement < 50000) return false;
        // 3. Worsen multiple key metrics (2+) and only improve legacy slightly
        if (deteriorations >= 2 && improvements === 1 && legacyImprovement < 100000 && pensionIncrease <= 0 && contributionReduction <= 0) return false;
        // 4. Special case: If client is on full pension and minimum contribution rates,
        // renovate strategies should only be recommended if they significantly improve cashflow
        // (since they can't improve pension or contributions further)
        const isHomeEquityStrategy = [
            'increaseHomeEquity',
            'renovate',
            'upgrade'
        ].includes(String(strategy.config?.type));
        const isFullPension = baselineAnalysis?.problemStatement?.pensionOptimization?.status === 'full';
        const isMinContributions = baselineAnalysis?.problemStatement?.contributionOptimization?.ratesAtMinimum === true;
        if (isHomeEquityStrategy && isFullPension && isMinContributions) {
            // Only keep if cashflow improvement is significant (>$5K) OR legacy improvement is very large (>$200K)
            if (cashflowImprovement <= 5000 && legacyImprovement < 200000) return false;
        }
        // Keep strategies that have meaningful improvements
        return true;
    });
    // Sort by score (descending)
    viableStrategies.sort((a, b)=>(b.score || 0) - (a.score || 0));
    return viableStrategies;
}



/**
 * Support at Home suggestion engine – modelling assumptions and exclusions for disclosure.
 */ 



/*
 * ONE FUNERAL BOND LIMIT, FROM THE RATES FILE.
 *
 * This was a local `const FUNERAL_BOND_EXEMPT_LIMIT = 15000`, shadowing the published figure of
 * $15,750 that the assessment itself uses. So the engine sized its funeral bond candidates $750 per
 * person short of the exemption, and the screen told the client a limit the assessment disagreed
 * with. A rate that lives in two places will eventually differ in two places — this one already did.
 */ const $853d75b8a4c3c6c1$var$FUNERAL_BOND_EXEMPT_LIMIT = (0, $1abe73eeef086faf$export$aca3edb7cd7a3f17);
function $853d75b8a4c3c6c1$export$d5459457c23273a7({ factFind: factFind, strategySettings: strategySettings = {}, legacyYears: legacyYears = 5, emergencyFund: emergencyFund = (0, $6737c18204fae40a$export$712e36f61d726ad1), agedCareIntegrationApplied: agedCareIntegrationApplied = false, usesEstimatedServicePlan: usesEstimatedServicePlan = false, estimatedServicePlanDescription: estimatedServicePlanDescription = null }) {
    const isPartnered = factFind?.adviceFor === 'couple';
    const liabilities = (0, $6737c18204fae40a$export$e8a9d16a3c6a5e34)(factFind);
    const totalDebt = liabilities.reduce((sum, l)=>sum + l.balance, 0);
    const modelled = [
        {
            category: 'Scope',
            items: [
                'Each selected strategy is modelled individually against your current baseline (not combined multi-strategy portfolios).',
                `Projections run for ${legacyYears} year${legacyYears === 1 ? '' : 's'} using the same manual-control engine as the rest of the app.`,
                agedCareIntegrationApplied ? 'A linked aged care scenario has been applied to the baseline before comparing Support at Home options.' : 'Baseline uses your current Client Profile unless a linked aged care scenario is selected.',
                usesEstimatedServicePlan ? `Support at Home service costs use an illustrative service mix (not your Service Builder plan): ${estimatedServicePlanDescription || 'moderate personal care, domestic, social, transport and meals package at catalogue median prices.'}` : 'Support at Home service costs use your saved Service Builder plan at modelled contribution rates.'
            ]
        },
        {
            // The same rule and words in every module (planChoiceRule.ts, owner 20 Oct 2026).
            category: 'How the plans are chosen',
            items: (0, $5a094123650e8adb$export$fb0a335889dd79d0).map((r)=>`${r.label}: ${r.text}`)
        },
        {
            category: 'Liquidity & funding',
            items: [
                `$${emergencyFund.toLocaleString()} cash reserve is preserved on bank accounts when liquidating for gifting, annuities, funeral bonds, renovations, upgrades, and debt repayment.`,
                'Multi-asset funding is used where needed (bank accounts first, then account-based pensions up to 50% of balance, then shares).',
                'Capital gains tax on share or investment property sales uses a simplified marginal-rate estimate (50% CGT discount assumed where applicable).'
            ]
        },
        {
            category: 'Centrelink & gifting',
            items: [
                `Gifting strategies respect remaining capacity under $${(0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0).toLocaleString()} per financial year and $${(0, $1abe73eeef086faf$export$9cd36ea38af5a5f3).toLocaleString()} over five years, including gifts already recorded in your profile.`,
                'New strategy gifts are recorded in giftsHistory and flow through deprivation calculations.',
                `Funeral bond strategies respect the $${$853d75b8a4c3c6c1$var$FUNERAL_BOND_EXEMPT_LIMIT.toLocaleString()} per person exempt asset limit${isPartnered ? ' (combined for couples where applicable)' : ''}.`
            ]
        },
        {
            category: 'Property strategies',
            items: [
                ...(0, $ea856d0766f9093e$export$cc31c83de42a47d)(factFind, strategySettings.propertyStrategies || {}),
                'Downsize surplus allocated per scenario to bank, downsizer super (if age 55+), and/or debt repayment.',
                `Downsizer contributions capped at $${(0, $1abe73eeef086faf$export$42edd27decf8c272).toLocaleString()} per eligible person.`,
                'Where age-eligible (60+), downsizer scenarios may commence an account-based pension at legislative minimum drawdown; otherwise proceeds remain in accumulation super.',
                "Increase exempt home equity: liquid assets converted to principal home at $1 for $1 (renovate in place or buy up \u2014 same modelling in the suggestion engine; not a market valuation).",
                'Manual Control upgrade path may model sell/buy costs separately when configured there.',
                "Support at Home cashflow uses your modelled contribution dollars (contribution rates \xd7 illustrative or saved service plan), not gross provider catalogue fees.",
                'Reverse mortgage / HEAS: lump-sum proceeds add to liquid assets; loan balance compounds at the indicative rate in projections (matching Manual Control). HEAS payment drawdown uses indicative rates (not provider-specific quotes).'
            ]
        },
        {
            category: 'Annuities',
            items: [
                'Lifetime annuities use indicative actuarial rates; purchase amount equals actual funded liquidation (not an unfunded notional amount).',
                'Assessable income/asset treatment follows post-2019 lifetime annuity rules (60% income / 60% or 30% asset test).',
                'No indexation or residual capital value unless manually configured elsewhere.'
            ]
        }
    ];
    if (liabilities.length > 0 && strategySettings.includeDebtRepayment !== false) modelled.push({
        category: 'Debt repayment',
        items: [
            `Client liabilities totalling $${Math.round(totalDebt).toLocaleString()} were identified.`,
            'Debt repayment strategies liquidate assessable assets to reduce loan/mortgage balances; interest savings are reflected via reduced liability balances in projections.',
            'Downsize scenarios may also allocate sale proceeds to debt repayment before surplus cash or downsizer contributions.'
        ]
    });
    const excluded = [
        "Combined multi-strategy portfolios (e.g. gifting plus annuity in the same scenario) \u2014 each option is tested in isolation.",
        'Oct 2026 Support at Home contribution rule changes (not yet in production rates).',
        'Detailed living-arrangement fact-find variations beyond current profile / linked aged care context.',
        'Provider-specific annuity quotes, reverse mortgage product features, or HEAS eligibility assessments.',
        'Stamp duty, legal fees, and moving costs on property transactions beyond the 2.5% selling-cost assumption.',
        'Superannuation contribution cap breaches, Division 293 tax, or personal financial advice suitability assessment.',
        'Changes to legislation, deeming rates, or pension rates beyond current app constants.',
        'Tax advice on structured products, trust distributions, or complex ownership structures.'
    ];
    if (liabilities.length === 0) excluded.push("Debt repayment strategies \u2014 no liabilities with a positive balance were recorded in the Client Profile.");
    if (!strategySettings.includeGifting) excluded.push("Gifting strategies \u2014 not selected for this analysis run.");
    if (!strategySettings.includeAnnuities) excluded.push("Annuity strategies \u2014 not selected for this analysis run.");
    if (!strategySettings.includePropertyStrategies) excluded.push("Property strategies \u2014 not selected for this analysis run.");
    const enabledTypes = [];
    if (strategySettings.includeGifting) enabledTypes.push('gifting');
    if (strategySettings.includeFuneralBonds) enabledTypes.push('funeral bonds');
    if (strategySettings.includeAnnuities) enabledTypes.push('annuities');
    if (strategySettings.includeDebtRepayment !== false && liabilities.length > 0) enabledTypes.push('debt repayment');
    if (strategySettings.includePropertyStrategies) {
        const ps = strategySettings.propertyStrategies || {};
        if (ps.downsize) enabledTypes.push('downsize');
        if (ps.increaseHomeEquity || ps.renovate || ps.upgrade) enabledTypes.push('increase home equity');
        if (ps.reverseMortgage) enabledTypes.push('reverse mortgage');
        if (ps.heas) enabledTypes.push('HEAS');
    }
    return {
        modelled: modelled,
        excluded: excluded,
        summary: {
            legacyYears: legacyYears,
            emergencyFund: emergencyFund,
            totalDebt: totalDebt,
            liabilityCount: liabilities.length,
            enabledStrategyTypes: enabledTypes
        }
    };
}
function $853d75b8a4c3c6c1$export$e0006d39a63910c4(modellingAssumptions) {
    if (!modellingAssumptions) return [];
    const bullets = [];
    (modellingAssumptions.modelled || []).forEach((section)=>{
        (section.items || []).forEach((item)=>{
            bullets.push({
                category: section.category,
                text: item
            });
        });
    });
    (modellingAssumptions.excluded || []).forEach((item)=>{
        bullets.push({
            category: 'Not factored in',
            text: item
        });
    });
    return bullets;
}





/**
 * Support at Home suggestion engine — detailed projections modal with breakdown tooltips.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f998757746cce0d6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 3v16a2 2 0 0 0 2 2h16",
            key: "c24i48"
        }
    ],
    [
        "path",
        {
            d: "m19 9-5 5-4-4-3 3",
            key: "2osh9i"
        }
    ]
];
const $f998757746cce0d6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chart-line", $f998757746cce0d6$export$3efd853dbb351e94);








function $2d788b4d6c2de130$var$parseBreakdownValue(value) {
    if (typeof value === 'number') return value;
    if (typeof value === 'string') return Math.abs(parseFloat(value.replace(/[$,]/g, '')) || 0);
    return 0;
}
function $2d788b4d6c2de130$var$buildAgePensionTooltip(year) {
    if (year.socialSecurityBreakdown?.length) return year.socialSecurityBreakdown.map((item)=>({
            label: item.label,
            value: typeof item.value === 'number' ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(item.value) : String(item.value)
        }));
    if (year.financials?.socialSecurityBreakdown?.length) return year.financials.socialSecurityBreakdown.map((item)=>({
            label: item.label,
            value: typeof item.value === 'number' ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(item.value) : String(item.value)
        }));
    return [
        {
            label: 'Age Pension',
            value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(year.socialSecurity || 0)
        }
    ];
}
function $2d788b4d6c2de130$var$buildCashflowTooltip(year) {
    const rows = [];
    const breakdown = year.cashFlowBreakdown || year.financials?.cashFlowBreakdown;
    if (Array.isArray(breakdown)) breakdown.forEach((item)=>{
        const val = item.value;
        rows.push({
            label: item.label,
            value: typeof val === 'number' ? `${val >= 0 ? '+' : ''}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(val)}` : String(val)
        });
    });
    const sahCost = year.annualCareCost ?? year.annualCareCostForPartialPeriod ?? 0;
    if (sahCost > 0) {
        rows.push({
            label: '--- Support at Home ---',
            value: ''
        });
        if (year.agedCareBreakdown?.length) year.agedCareBreakdown.forEach((item)=>{
            rows.push({
                label: item.label,
                value: typeof item.value === 'string' ? item.value : (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($2d788b4d6c2de130$var$parseBreakdownValue(item.value))
            });
        });
        else rows.push({
            label: 'Less: Support at Home costs',
            value: `-${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(sahCost)}`
        });
    }
    const net = year.cashFlow ?? year.cashflow ?? 0;
    rows.push({
        label: '--- Net cashflow ---',
        value: ''
    });
    rows.push({
        label: 'Net cashflow',
        value: `${net >= 0 ? '+' : ''}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(net)}`
    });
    if (year.cashflowRoutingLine) {
        rows.push({
            label: '---',
            value: ''
        });
        rows.push({
            label: year.cashflowRoutingLine.label || 'Funding',
            value: String(year.cashflowRoutingLine.value ?? '')
        });
    }
    return rows.length ? rows : [
        {
            label: 'Net cashflow',
            value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(net)
        }
    ];
}
function $2d788b4d6c2de130$var$buildClosingNetWorthTooltip(year) {
    if (year.netWorthBreakdown?.length) return year.netWorthBreakdown.map((item)=>({
            label: item.label,
            value: typeof item.value === 'number' ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(item.value) : String(item.value)
        }));
    return [
        {
            label: 'Closing net worth',
            value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(year.netWorth || 0)
        }
    ];
}
function $2d788b4d6c2de130$var$buildInvestmentIncomeTooltip(year, yearIndex, strategy, factFind) {
    const openingAssets = yearIndex === 0 ? strategy.modifiedFactFind?.assets : strategy.projections?.[yearIndex - 1]?.assets;
    let abpIncome = 0;
    (openingAssets?.accountBasedPensions || []).forEach((asset)=>{
        const value = parseFloat(String(asset.value)) || 0;
        const ownerAge = asset.ownership === 'partner' && factFind?.partner?.dob ? ((0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner.dob) ?? 70) + yearIndex : factFind?.client?.dob ? ((0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client.dob) ?? 70) + yearIndex : 70;
        const nominated = parseFloat(String(asset.income)) || 0;
        abpIncome += Math.max(nominated, (0, $e0f54937e270d5ff$export$548fd6b682208d71)(value, ownerAge));
    });
    let otherIncome = 0;
    (openingAssets?.bankAccounts || []).forEach((asset)=>{
        const value = parseFloat(String(asset.value)) || 0;
        const rate = parseFloat(String(asset.incomeRate)) || 2;
        otherIncome += value * (rate / 100);
    });
    (openingAssets?.shares || []).forEach((asset)=>{
        const value = parseFloat(String(asset.value)) || 0;
        const rate = parseFloat(String(asset.incomeRate)) || 4;
        otherIncome += value * (rate / 100);
    });
    return [
        {
            label: 'ABP income (opening balances)',
            value: `+${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(abpIncome)}`
        },
        {
            label: 'Other investment income',
            value: `+${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(otherIncome)}`
        },
        {
            label: 'Total (projection)',
            value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(year.investmentIncome || 0)
        }
    ];
}
function $2d788b4d6c2de130$export$2e2bcd8739ae039({ strategy: strategy, factFind: factFind, onClose: onClose, estimatedServicePlanNote: estimatedServicePlanNote }) {
    const projections = (strategy?.projections || []).slice(0, 10);
    // The same shared engine view every module's projections use — charts, the monthly narrative
    // and per-figure tooltips — fed with THIS strategy's own projection rows.
    const [showFullProjections, setShowFullProjections] = (0, $acw62.useState)(false);
    // Escape closes the window, as the X and a click outside it do (owner-approved mock-up, 25 Oct 2026). While the
    // charts window is open on top, Escape is that window's.
    (0, $acw62.useEffect)(()=>{
        if (showFullProjections) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') {
                e.stopPropagation();
                onClose();
            }
        };
        document.addEventListener('keydown', onKey);
        return ()=>document.removeEventListener('keydown', onKey);
    }, [
        onClose,
        showFullProjections
    ]);
    const title = String(strategy?.name || '').trim() || 'Year by year';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-2 sm:p-4",
        onClick: onClose,
        role: "presentation",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-2xl shadow-2xl w-full max-w-6xl max-h-[90vh] overflow-y-auto border border-slate-200/80",
                onClick: (e)=>e.stopPropagation(),
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "sah-deep-dive-title",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "sticky top-0 z-10 bg-white",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9847d752f8df838f$export$f89de71a2c9ebacb), {
                                titleId: "sah-deep-dive-title",
                                title: title,
                                subtitle: projections.length > 0 ? (0, $9847d752f8df838f$export$8223046eaabd582d)(projections.length) : null,
                                onClose: onClose,
                                actions: projections.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>setShowFullProjections(true),
                                    className: "flex items-center gap-2 px-3 py-2 text-sm font-semibold text-blue-700 hover:text-blue-900 hover:bg-slate-50 rounded-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f998757746cce0d6$export$2e2bcd8739ae039), {
                                            className: "w-4 h-4",
                                            "aria-hidden": true
                                        }),
                                        " Charts and month by month"
                                    ]
                                }) : null
                            }),
                            estimatedServicePlanNote && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-xs text-slate-700 bg-white border border-slate-200 border-l-4 border-l-amber-400 rounded-lg px-3 py-2 mx-6 mt-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Service costs:"
                                    }),
                                    " ",
                                    estimatedServicePlanNote
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-6 space-y-6",
                        children: [
                            (strategy.assetAllocation?.length ?? 0) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-lg font-semibold text-brand-navy mb-4",
                                        children: "What is used"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "overflow-x-auto",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                            className: "min-w-full divide-y divide-gray-200 text-sm",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                    className: "bg-white",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "px-4 py-3 text-left text-xs font-semibold text-slate-600",
                                                                children: "What"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "px-4 py-3 text-right text-xs font-semibold text-slate-600",
                                                                children: "To begin with"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "px-4 py-3 text-right text-xs font-semibold text-slate-600",
                                                                children: "Used"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "px-4 py-3 text-right text-xs font-semibold text-slate-600",
                                                                children: "Left"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "px-4 py-3 text-center text-xs font-semibold text-slate-600",
                                                                children: "What happens"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                    className: "divide-y divide-gray-200",
                                                    children: (strategy.assetAllocation ?? []).map((asset, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "px-4 py-3",
                                                                    children: (0, $2a669e0126fd3a3e$export$9555bc30b49fd2f2)(asset, factFind)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "px-4 py-3 text-right",
                                                                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(asset.amount)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "px-4 py-3 text-right text-red-600",
                                                                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(asset.liquidatedAmount)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "px-4 py-3 text-right",
                                                                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(asset.remainingAmount)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "px-4 py-3 text-center",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "inline-flex px-2 py-0.5 text-xs font-semibold rounded-full bg-gray-100",
                                                                        children: (0, $2a669e0126fd3a3e$export$acfc0c5058edfc8)(asset.status)
                                                                    })
                                                                })
                                                            ]
                                                        }, `${asset.assetName}-${asset.status}-${idx}`))
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            projections.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-lg font-semibold text-brand-navy mb-2",
                                        children: "Year by year"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-xs text-gray-500 mb-4",
                                        children: "Hover an underlined figure to see how it is worked out."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "overflow-x-auto",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                            className: "min-w-full divide-y divide-gray-200 text-sm",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                    className: "bg-white",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "px-4 py-3 text-left text-xs font-semibold text-slate-600",
                                                                children: "Year"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "px-4 py-3 text-right text-xs font-semibold text-slate-600",
                                                                children: "Age Pension"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "px-4 py-3 text-right text-xs font-semibold text-slate-600",
                                                                children: "Investment income"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "px-4 py-3 text-right text-xs font-semibold text-slate-600",
                                                                children: "Support at home costs"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "px-4 py-3 text-right text-xs font-semibold text-slate-600",
                                                                children: "In, less out"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "px-4 py-3 text-right text-xs font-semibold text-slate-600",
                                                                children: "Owned at the end"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                    className: "divide-y divide-gray-200",
                                                    children: projections.map((year, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            className: index % 2 ? 'bg-gray-50/60' : '',
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "px-4 py-3 font-medium",
                                                                    children: year.fyLabel || `Year ${index + 1}`
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "px-4 py-3 text-right",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c0ea688f7c20200$export$2e2bcd8739ae039), {
                                                                        title: "Age Pension breakdown",
                                                                        data: $2d788b4d6c2de130$var$buildAgePensionTooltip(year),
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "border-b border-dotted border-gray-400 cursor-help",
                                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(year.socialSecurity || 0)
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "px-4 py-3 text-right",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c0ea688f7c20200$export$2e2bcd8739ae039), {
                                                                        title: "Investment income",
                                                                        data: $2d788b4d6c2de130$var$buildInvestmentIncomeTooltip(year, index, strategy, factFind),
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "border-b border-dotted border-gray-400 cursor-help",
                                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(year.investmentIncome || 0)
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "px-4 py-3 text-right text-red-600",
                                                                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(year.annualCareCost ?? 0)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: `px-4 py-3 text-right font-semibold ${(year.cashFlow ?? year.cashflow ?? 0) >= 0 ? 'text-green-700' : 'text-red-600'}`,
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c0ea688f7c20200$export$2e2bcd8739ae039), {
                                                                        title: "Net cashflow breakdown",
                                                                        data: $2d788b4d6c2de130$var$buildCashflowTooltip(year),
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "border-b border-dotted border-gray-400 cursor-help",
                                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(year.cashFlow ?? year.cashflow ?? 0)
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "px-4 py-3 text-right",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c0ea688f7c20200$export$2e2bcd8739ae039), {
                                                                        title: "Net Worth (closing)",
                                                                        data: $2d788b4d6c2de130$var$buildClosingNetWorthTooltip(year),
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "border-b border-dotted border-gray-400 cursor-help",
                                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(year.netWorth || 0)
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }, year.year ?? index))
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mt-3 text-[13px] leading-relaxed text-slate-500",
                                        "data-testid": "sah-deep-dive-compared-over",
                                        children: (0, $c3eba85390498a43$export$be94b03447321f96)(projections.length)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            showFullProjections && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9847d752f8df838f$export$2e2bcd8739ae039), {
                onClose: ()=>setShowFullProjections(false),
                projections: projections,
                factFind: strategy.modifiedFactFind ?? factFind,
                initialFinancials: strategy.financials ?? null,
                currentFinancials: strategy.financials ?? null,
                agedCareCosts: null,
                costLabel: "Support at Home Costs",
                title: title
            })
        ]
    });
}


/**
 * Persist and load Support at Home (home_care) saved strategies for Optimise Your Plan + Service Builder.
 */ 





function $dabe6813042a6e48$export$1ff5d2c58264060b() {
    if (typeof window === 'undefined') return [];
    try {
        const parsed = JSON.parse(window.sessionStorage.getItem((0, $f58ff7d3c4c676c4$export$685490c2fa387b9a)) || '[]');
        if (!Array.isArray(parsed)) return [];
        // Heal duplicates by (type, id), keeping the LAST occurrence — a strategy re-persisted with
        // more data (e.g. its soaSnapshot) supersedes the first write. Duplicate ids rendered as
        // React list keys are exactly the "two children with the same key" warning an adviser hit
        // after the SOA flow persisted a strategy twice through the old append-only persist.
        const byKey = new Map();
        for (const strategy of parsed)byKey.set(`${strategy?.type ?? ''}:${strategy?.id ?? ''}`, strategy);
        return Array.from(byKey.values());
    } catch  {
        return [];
    }
}
function $dabe6813042a6e48$export$181dd2d22327a6cc() {
    return $dabe6813042a6e48$export$1ff5d2c58264060b().filter((s)=>s?.type === 'home_care');
}
function $dabe6813042a6e48$export$96fa287c2962545c() {
    return $dabe6813042a6e48$export$1ff5d2c58264060b().filter((s)=>s?.type === 'aged_care');
}
function $dabe6813042a6e48$export$16dd31eaa6a518b3(selectionId) {
    if (!selectionId || selectionId === 'baseline') return {
        kind: 'baseline',
        rawId: null
    };
    if (selectionId.startsWith((0, $f58ff7d3c4c676c4$export$b81dc9baeb417304))) return {
        kind: 'home_care',
        rawId: selectionId.slice((0, $f58ff7d3c4c676c4$export$b81dc9baeb417304).length)
    };
    if (selectionId.startsWith((0, $f58ff7d3c4c676c4$export$6a1b0280c30a972e))) return {
        kind: 'aged_care',
        rawId: selectionId.slice((0, $f58ff7d3c4c676c4$export$6a1b0280c30a972e).length)
    };
    return {
        kind: 'home_care',
        rawId: selectionId
    };
}
function $dabe6813042a6e48$export$a51229379df5ae38(strategy) {
    if (!strategy?.name) return 'Unnamed aged care scenario';
    const sourceTag = strategy.source === 'suggestion_engine' ? " \xb7 Suggestion engine" : '';
    return `${strategy.name}${sourceTag}`;
}
function $dabe6813042a6e48$export$58144e0ab1913dc() {
    if (typeof window === 'undefined') return null;
    return window.sessionStorage.getItem((0, $f58ff7d3c4c676c4$export$c31575d0976c0a1));
}
function $dabe6813042a6e48$export$e66848783651d59b(strategy) {
    // UPSERT by (type, id), never append blindly: re-persisting a strategy (e.g. to attach its
    // soaSnapshot after generating the Digital SOA) must replace the record, not duplicate it.
    // Every caller saves an Optimise plan, and saving one is choosing it (module reviews, 18 Oct 2026:
    // Home could never say "Plan chosen" for Support at home, because nothing marked one chosen). The
    // others of the same type are un-chosen; plans of other modules are untouched.
    strategy = {
        ...strategy,
        chosen: true
    };
    const all = $dabe6813042a6e48$export$1ff5d2c58264060b().map((s)=>s?.type === strategy.type && String(s?.id) !== String(strategy.id) && s.chosen ? {
            ...s,
            chosen: false
        } : s);
    const index = all.findIndex((s)=>String(s?.id) === String(strategy.id) && s?.type === strategy.type);
    if (index >= 0) all[index] = strategy;
    else all.push(strategy);
    if (typeof window !== 'undefined') window.sessionStorage.setItem((0, $f58ff7d3c4c676c4$export$685490c2fa387b9a), JSON.stringify(all));
    (0, $f58ff7d3c4c676c4$export$b731185d32c620a3)((0, $f58ff7d3c4c676c4$export$816f75caf2488b34)('home_care', strategy.id));
    (0, $f58ff7d3c4c676c4$export$33b576d5d6fa435b)();
    return strategy;
}
function $dabe6813042a6e48$export$3a8f35d37820f4b2(reason) {
    const next = (0, $78a369bbf1e0d995$export$d20c84e2101d7d8a)($dabe6813042a6e48$export$1ff5d2c58264060b(), 'home_care', reason);
    if (!next || typeof window === 'undefined') return;
    window.sessionStorage.setItem((0, $f58ff7d3c4c676c4$export$685490c2fa387b9a), JSON.stringify(next));
    (0, $f58ff7d3c4c676c4$export$33b576d5d6fa435b)();
}
function $dabe6813042a6e48$export$39b79a26ebdccc68(homeCareStrategies = $dabe6813042a6e48$export$181dd2d22327a6cc(), agedCareStrategies = $dabe6813042a6e48$export$96fa287c2962545c()) {
    return $dabe6813042a6e48$export$4ce45399dc4592bf(homeCareStrategies, agedCareStrategies);
}
function $dabe6813042a6e48$export$4ce45399dc4592bf(homeCareStrategies = $dabe6813042a6e48$export$181dd2d22327a6cc(), agedCareStrategies = $dabe6813042a6e48$export$96fa287c2962545c()) {
    const activeId = $dabe6813042a6e48$export$58144e0ab1913dc();
    if (!activeId || activeId === 'baseline') return 'baseline';
    const parsed = $dabe6813042a6e48$export$16dd31eaa6a518b3(activeId);
    if (parsed.kind === 'aged_care' && agedCareStrategies.some((s)=>s.id === parsed.rawId)) return (0, $f58ff7d3c4c676c4$export$816f75caf2488b34)('aged_care', parsed.rawId);
    if (parsed.kind === 'home_care' && homeCareStrategies.some((s)=>s.id === parsed.rawId)) return (0, $f58ff7d3c4c676c4$export$816f75caf2488b34)('home_care', parsed.rawId);
    if (agedCareStrategies.some((s)=>s.id === activeId)) return (0, $f58ff7d3c4c676c4$export$816f75caf2488b34)('aged_care', activeId);
    if (homeCareStrategies.some((s)=>s.id === activeId)) return (0, $f58ff7d3c4c676c4$export$816f75caf2488b34)('home_care', activeId);
    return 'baseline';
}
async function $dabe6813042a6e48$export$b69ddb1b9b09e3dc(factFind, agedCareStrategy) {
    const integration = (0, $87af0cc4cc4e8984$export$2fdaec60121ed226)(agedCareStrategy);
    if (!integration) return $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind);
    let modifiedFactFind = structuredClone(factFind);
    if (integration.radFunding) modifiedFactFind = (0, $87af0cc4cc4e8984$export$8a0c5ad907f77392)(modifiedFactFind, integration.radFunding);
    if (integration.livingExpenses !== undefined && integration.livingExpenses !== null) modifiedFactFind.expenses = {
        ...modifiedFactFind.expenses,
        livingExpenses: integration.livingExpenses
    };
    const fromStrategy = integration.strategyOptions || {};
    const residencyOverrides = {
        ...fromStrategy.clientResidencyOverride ? {
            clientResidencyOverride: fromStrategy.clientResidencyOverride
        } : {},
        ...fromStrategy.partnerResidencyOverride ? {
            partnerResidencyOverride: fromStrategy.partnerResidencyOverride
        } : {}
    };
    const strategyOptionsPayload = {
        integratedAgedCareCost: integration.annualCost || 0,
        integratedAgedCareDetails: integration.annualCost > 0 ? integration : null,
        ...Object.keys(residencyOverrides).length > 0 ? residencyOverrides : (0, $8eecd0af141b9afb$export$7b84565bbb0eef12)(factFind)
    };
    return $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(modifiedFactFind, strategyOptionsPayload);
}
function $dabe6813042a6e48$export$eae099dd689a5529() {
    if (typeof window === 'undefined') return;
    window.sessionStorage.removeItem('careCompanionSelectedAgedCareStrategy');
}
function $dabe6813042a6e48$var$baselineHasManualAgedCareLink() {
    if (typeof window === 'undefined') return false;
    const s = window.sessionStorage.getItem('careCompanionSelectedAgedCareStrategy');
    return Boolean(s && s.trim() && s !== 'null');
}
// `integration` is deliberately loosely typed (not `AgedCareIntegrationDetails`): the only external
// caller (ServiceBuilderSection.tsx) resolves it through its own locally-declared, structurally
// looser `ServiceBuilderPosition` shape, so this stays permissive and narrows defensively instead.
function $dabe6813042a6e48$var$getResidencyOverridesFromIntegration(integration, factFind) {
    if (!integration || typeof integration !== 'object') return {};
    const fromStrategy = integration.strategyOptions || {};
    const linkedOverrides = {
        ...fromStrategy.clientResidencyOverride ? {
            clientResidencyOverride: fromStrategy.clientResidencyOverride
        } : {},
        ...fromStrategy.partnerResidencyOverride ? {
            partnerResidencyOverride: fromStrategy.partnerResidencyOverride
        } : {}
    };
    if (Object.keys(linkedOverrides).length > 0) return linkedOverrides;
    // DraftFactFind is structurally compatible with FactFind (see
    // types/formDraft.ts); the shared calc-engine fn defensively coerces internally regardless,
    // so this cast is safe (see factFindTypes.ts header comment).
    return (0, $8eecd0af141b9afb$export$7b84565bbb0eef12)(factFind);
}
async function $dabe6813042a6e48$export$145bb537a3c0088d(selectionId, factFind, homeCareStrategies = $dabe6813042a6e48$export$181dd2d22327a6cc(), agedCareStrategies = $dabe6813042a6e48$export$96fa287c2962545c()) {
    const { kind: kind, rawId: rawId } = $dabe6813042a6e48$export$16dd31eaa6a518b3(selectionId);
    const isPartnered = factFind?.adviceFor === 'couple';
    if (kind === 'baseline') {
        const hasLinkedAgedCare = isPartnered && $dabe6813042a6e48$var$baselineHasManualAgedCareLink();
        let integration = null;
        if (hasLinkedAgedCare && typeof window !== 'undefined') try {
            const stored = window.sessionStorage.getItem('careCompanionSelectedAgedCareStrategy');
            integration = stored ? (0, $87af0cc4cc4e8984$export$2fdaec60121ed226)(JSON.parse(stored)) : null;
        } catch  {
            integration = null;
        }
        const financials = hasLinkedAgedCare && integration ? await $dabe6813042a6e48$export$b69ddb1b9b09e3dc(factFind, integration.savedStrategy) : await $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind);
        return {
            kind: 'baseline',
            strategy: null,
            integration: integration,
            financials: financials,
            hasLinkedAgedCare: hasLinkedAgedCare
        };
    }
    if (kind === 'home_care') {
        const strategy = homeCareStrategies.find((s)=>s.id === rawId) || null;
        const hasLinkedAgedCare = $dabe6813042a6e48$export$7aeee18c6c487bd1(strategy);
        let integration = null;
        if (hasLinkedAgedCare && strategy?.inputs?.selectedAgedCareStrategyId) {
            const linked = agedCareStrategies.find((s)=>s.id === strategy.inputs?.selectedAgedCareStrategyId);
            integration = linked ? (0, $87af0cc4cc4e8984$export$2fdaec60121ed226)(linked) : null;
        }
        const financials = strategy?.outputs?.financials ? strategy.outputs.financials : integration ? await $dabe6813042a6e48$export$b69ddb1b9b09e3dc(factFind, integration.savedStrategy) : await $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind);
        return {
            kind: 'home_care',
            strategy: strategy,
            integration: integration,
            financials: financials,
            hasLinkedAgedCare: hasLinkedAgedCare
        };
    }
    const strategy = agedCareStrategies.find((s)=>s.id === rawId) || null;
    const integration = strategy ? (0, $87af0cc4cc4e8984$export$2fdaec60121ed226)(strategy) : null;
    const financials = strategy ? await $dabe6813042a6e48$export$b69ddb1b9b09e3dc(factFind, strategy) : await $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind);
    return {
        kind: 'aged_care',
        strategy: strategy,
        integration: integration,
        financials: financials,
        // Person in residential care — SAH package budget is not available for them (couple or single).
        hasLinkedAgedCare: Boolean(strategy)
    };
}
function $dabe6813042a6e48$export$4b8c0ffc2dd859a6(factFind, position) {
    if (!position?.hasLinkedAgedCare || factFind?.adviceFor !== 'couple') return {};
    const overrides = $dabe6813042a6e48$var$getResidencyOverridesFromIntegration(position.integration, factFind);
    return Object.keys(overrides).length > 0 ? {
        strategyOptions: overrides
    } : {};
}
function $dabe6813042a6e48$export$c9184770667dd1f9(strategy) {
    if (!strategy?.name) return 'Unnamed strategy';
    const sourceTag = strategy.source === 'suggestion_engine' ? " \xb7 Suggestion engine" : '';
    return `${strategy.name}${sourceTag}`;
}
function $dabe6813042a6e48$export$7aeee18c6c487bd1(strategy) {
    if (!strategy?.inputs?.selectedAgedCareStrategyId) return false;
    const ctx = strategy.inputs.agedCareContext;
    if (ctx === 'linked') return true;
    if (ctx === 'current') return false;
    // Legacy manual saves: selectedAgedCareStrategyId implies explicit manual integration.
    // Legacy SE saves may have picked up auto-selected AC id — treat as not linked unless flagged.
    if (strategy.source === 'suggestion_engine') return false;
    return true;
}
async function $dabe6813042a6e48$export$e42ac98ba12bf3d5({ factFind: factFind, evaluatedStrategy: evaluatedStrategy, name: name, selectedAgedCareIntegration: selectedAgedCareIntegration = null, agedCareResidencyOverrides: agedCareResidencyOverrides = {}, participantType: participantType, nwopCategory: nwopCategory, meansDisclosed: meansDisclosed, previousITCF: previousITCF, isPartnered: isPartnered, agedCareContext: agedCareContext = 'current' }) {
    const config = evaluatedStrategy?.config || evaluatedStrategy;
    const applyLinkedAgedCare = agedCareContext === 'linked' && selectedAgedCareIntegration;
    let modifiedFactFind = (0, $1a3577d7101fe882$export$2130d11e4b2e7a7)(factFind, config);
    if (applyLinkedAgedCare && selectedAgedCareIntegration?.radFunding) modifiedFactFind = (0, $87af0cc4cc4e8984$export$8a0c5ad907f77392)(modifiedFactFind, selectedAgedCareIntegration.radFunding);
    if (applyLinkedAgedCare && selectedAgedCareIntegration?.livingExpenses !== undefined && selectedAgedCareIntegration?.livingExpenses !== null) modifiedFactFind.expenses = {
        ...modifiedFactFind.expenses,
        livingExpenses: selectedAgedCareIntegration.livingExpenses
    };
    const agedCareAnnualCost = applyLinkedAgedCare ? selectedAgedCareIntegration?.annualCost || 0 : 0;
    const strategyOptionsPayload = {
        integratedAgedCareCost: agedCareAnnualCost,
        integratedAgedCareDetails: applyLinkedAgedCare && agedCareAnnualCost > 0 ? selectedAgedCareIntegration : null,
        ...applyLinkedAgedCare ? agedCareResidencyOverrides : {}
    };
    const financials = await $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(modifiedFactFind, strategyOptionsPayload);
    const contributions = await $55a1d8a64f1e5dfa$export$3fe0e13ec85e5380(modifiedFactFind, financials, participantType, nwopCategory, meansDisclosed, previousITCF, 0.5, {
        strategyOptions: agedCareResidencyOverrides
    });
    const contributionData = isPartnered ? contributions?.combined || contributions?.client : contributions?.client;
    const snap = evaluatedStrategy?.snapshot || {};
    return {
        id: `strategy-${Date.now()}`,
        name: name.trim(),
        type: 'home_care',
        source: 'suggestion_engine',
        inputs: {
            source: 'suggestion_engine',
            seConfig: config,
            agedCareContext: agedCareContext,
            selectedAgedCareStrategyId: applyLinkedAgedCare ? selectedAgedCareIntegration?.strategyId || selectedAgedCareIntegration?.id || null : null,
            strategyName: evaluatedStrategy.name
        },
        outputs: {
            // What they pay on THESE services — the figure the plan card shows (rebuild, 19 Oct 2026).
            // contributionAmounts.totalAnnual is the assessment's whole-budget figure, a different
            // number, which put two contributions on the plan page and the card for one plan.
            annualContribution: Number.isFinite(Number(snap.totalSupportAtHomeCosts)) ? Number(snap.totalSupportAtHomeCosts) : contributionData?.contributionAmounts?.totalAnnual ?? snap.contributionAmount ?? 0,
            agePension: financials?.socialSecurity ?? snap.pension ?? 0,
            cashFlow: financials?.cashFlow ?? snap.netCashflow ?? snap.cashflow ?? 0,
            legacyEstimate: snap.legacyValue ?? 0,
            financials: financials,
            contributionRates: contributionData?.contributionRates || {},
            seSnapshot: snap
        },
        createdAt: new Date().toISOString()
    };
}










/**
 * Full-screen analysing state for suggestion engines (Aged Care / Support at Home).
 * Portals to document.body so position:fixed is not clipped by parent layout/transform.
 */ 

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
const $81c96376e6bb9658$export$62c2999f746e345d = 5000;
function $81c96376e6bb9658$export$2e2bcd8739ae039({ title: title = 'Optimising your funding strategies', subtitle: subtitle = "We're working through a large number of simulated options - this may take a few minutes.", progress: progress = {
    current: 0,
    total: 0
}, progressLabel: progressLabel = 'Running strategy' }) {
    const gradientId = (0, $acw62.useId)().replace(/:/g, '');
    const loader = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 z-[200] flex items-center justify-center bg-white border border-slate-200 ",
        role: "dialog",
        "aria-modal": "true",
        "aria-busy": "true",
        "aria-label": title,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-center max-w-lg px-6 py-8",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mb-8 flex justify-center shrink-0",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                        width: "240",
                        height: "140",
                        viewBox: "0 0 240 140",
                        fill: "none",
                        className: "text-blue-600/90",
                        "aria-hidden": true,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                                    id: gradientId,
                                    x1: "0",
                                    y1: "1",
                                    x2: "0",
                                    y2: "0",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                            offset: "0%",
                                            stopColor: "currentColor",
                                            stopOpacity: "0.3"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                            offset: "100%",
                                            stopColor: "currentColor",
                                            stopOpacity: "0.9"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "40",
                                y: "70",
                                width: "28",
                                height: "50",
                                rx: "4",
                                fill: `url(#${gradientId})`,
                                className: "animate-pulse",
                                style: {
                                    animationDuration: '1.5s'
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "80",
                                y: "50",
                                width: "28",
                                height: "70",
                                rx: "4",
                                fill: `url(#${gradientId})`,
                                className: "animate-pulse",
                                style: {
                                    animationDuration: '1.5s',
                                    animationDelay: '0.2s'
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "120",
                                y: "35",
                                width: "28",
                                height: "85",
                                rx: "4",
                                fill: `url(#${gradientId})`,
                                className: "animate-pulse",
                                style: {
                                    animationDuration: '1.5s',
                                    animationDelay: '0.4s'
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "160",
                                y: "55",
                                width: "28",
                                height: "65",
                                rx: "4",
                                fill: `url(#${gradientId})`,
                                className: "animate-pulse",
                                style: {
                                    animationDuration: '1.5s',
                                    animationDelay: '0.6s'
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "200",
                                y: "25",
                                width: "28",
                                height: "95",
                                rx: "4",
                                fill: `url(#${gradientId})`,
                                className: "animate-pulse",
                                style: {
                                    animationDuration: '1.5s',
                                    animationDelay: '0.8s'
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M 48 95 Q 88 75 128 60 T 208 45",
                                stroke: "currentColor",
                                strokeWidth: "2.5",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                fill: "none",
                                opacity: "0.7",
                                strokeDasharray: "6 4",
                                className: "animate-pulse",
                                style: {
                                    animationDuration: '2s'
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    className: "text-xl font-bold text-gray-800 mb-2",
                    children: title
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-gray-600 mb-6",
                    children: subtitle
                }),
                progress.total > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-sm text-blue-700 font-medium",
                    children: [
                        progressLabel,
                        " ",
                        progress.current,
                        " of ",
                        progress.total
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mt-6 flex justify-center",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "animate-spin rounded-full h-10 w-10 border-2 border-blue-200 border-t-blue-600",
                        role: "status",
                        "aria-label": "Loading"
                    })
                })
            ]
        })
    });
    if (typeof document !== 'undefined' && document.body) return /*#__PURE__*/ (0, $1u0KT.createPortal)(loader, document.body);
    return loader;
}














/**
 * The questions asked before the Support at home plans run — inline the first time, and later under
 * "Things that change the answer" (Support at home rebuild, 19 Oct 2026; the agreed mock-up's
 * questions screen).
 *
 * Owner rulings built in:
 *  - "What's this?" on every question, so a family sees why it is asked (comment of 18 Oct).
 *  - The levers are listed by the means test they work on: the test that sets THIS household's Age
 *    Pension decides which come first. All stay ticked — nothing is hidden, and the engine still tests
 *    every way (decision 8, 19 Oct). "Ticking is not a decision."
 *  - Whether someone is moving into aged care is asked on step 1, not here.
 *  - "Build a plan yourself" is offered on this screen as well as under the plans.
 *  - 10 years, as every module but aged care (owner, 19 Oct 2026).
 */ 

var $acw62 = parcelRequire("acw62");






const $44d3c10f2c4813c3$export$9972779bf6ddd4f0 = [
    'home',
    'funeral',
    'gift',
    'debt',
    'property'
];
const $44d3c10f2c4813c3$var$WhatsThis = ({ children: children })=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            ' ',
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: ()=>setOpen((o)=>!o),
                "aria-expanded": open,
                className: "text-[12px] font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                children: "what's this?"
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "mt-1.5 block rounded-lg border border-slate-200 border-l-4 border-l-blue-500 bg-white px-3 py-2 text-[13px] font-normal leading-relaxed text-slate-700",
                children: children
            })
        ]
    });
};
/**
 * EVERY "WHAT'S THIS?" SAYS WHAT THE THING IS FIRST (owner, 20 Oct 2026: "You dont actually say what a
 * funeral bond is"; the investment note "reads poorly"). Then why it matters to them, then the catch —
 * each its own short line, never one dense paragraph.
 */ const $44d3c10f2c4813c3$var$Why = ({ lines: lines })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "block space-y-1.5",
        children: lines.map((l, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "block",
                children: l
            }, i))
    });
const $44d3c10f2c4813c3$var$b = (t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
        className: "text-slate-900",
        children: t
    });
/** Numbered, as every module's questions are (owner, 23 Oct 2026). */ const $44d3c10f2c4813c3$var$Question = ({ n: n, label: label, why: why, children: children, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": testId,
        className: "border-b border-slate-100 py-4 last:border-b-0",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d7fa4e176455787d$export$d5095ecb707035a), {
                n: n,
                as: "p",
                children: [
                    label,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($44d3c10f2c4813c3$var$WhatsThis, {
                        children: why
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-2",
                children: children
            })
        ]
    });
const $44d3c10f2c4813c3$var$Hint = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "mt-1.5 text-[13px] leading-relaxed text-slate-600",
        children: children
    });
const $44d3c10f2c4813c3$export$6fe4025a4076092f = ({ value: value, onChange: onChange, factFind: factFind, bindingTest: bindingTest, suggestedReserve: suggestedReserve, debtTotal: debtTotal, idPrefix: idPrefix = 'sahq', guaranteedIncome: guaranteedIncome })=>{
    const set = (patch)=>onChange({
            ...value,
            ...patch
        });
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const hasHome = (Number(factFind.home?.value) || 0) > 0;
    const testWords = bindingTest === 'income' ? 'the income test' : 'the assets test';
    const levers = [
        ...hasHome ? [
            {
                id: 'home',
                label: "Spending on the home \u2014 renovating or upgrading it",
                note: 'The home is not counted.',
                why: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($44d3c10f2c4813c3$var$Why, {
                    lines: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                $44d3c10f2c4813c3$var$b('What it is.'),
                                " Spending money on the home ",
                                v.they,
                                " live in: a renovation, or moving to a dearer home."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                $44d3c10f2c4813c3$var$b('Why it can help.'),
                                " Centrelink does not count the home ",
                                v.they,
                                " live in, for the Age Pension or for Support at home. Money moved into it stops being counted, which can lift the pension and lower what ",
                                v.they,
                                " pay for each hour of support."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                $44d3c10f2c4813c3$var$b('The catch.'),
                                " ",
                                v.They,
                                " only get the money back by selling the home."
                            ]
                        })
                    ]
                }),
                helpsUnder: [
                    'assets',
                    'income'
                ]
            }
        ] : [],
        {
            id: 'funeral',
            label: `Prepaying ${v.their} funerals with a funeral bond`,
            note: 'Not counted, up to a limit.',
            why: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($44d3c10f2c4813c3$var$Why, {
                lines: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            $44d3c10f2c4813c3$var$b('What it is.'),
                            " An investment that can only be used to pay for a funeral. ",
                            v.They,
                            " put money in now, it is invested, and it is paid out when ",
                            v.they,
                            " die to cover the funeral."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            $44d3c10f2c4813c3$var$b('Why it can help.'),
                            " Up to ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$aca3edb7cd7a3f17)),
                            " each is not counted by Centrelink, for the Age Pension or for Support at home. That can lift the pension and lower what ",
                            v.they,
                            " pay for support."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            $44d3c10f2c4813c3$var$b('The catch.'),
                            " The money cannot be taken out for anything else."
                        ]
                    })
                ]
            }),
            helpsUnder: [
                'assets',
                'income'
            ]
        },
        {
            id: 'gift',
            label: 'Giving money to family within the yearly free limits',
            note: 'Gifts above the limits still count for five years.',
            why: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($44d3c10f2c4813c3$var$Why, {
                lines: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            $44d3c10f2c4813c3$var$b('What it is.'),
                            " Giving money to family now, rather than leaving it in the estate."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            $44d3c10f2c4813c3$var$b('Why it can help.'),
                            " Centrelink stops counting up to ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0)),
                            " given away in a year, and up to ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9cd36ea38af5a5f3)),
                            " over five years. The limits are the same for a couple as for one person."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            $44d3c10f2c4813c3$var$b('The catch.'),
                            " Anything given above those limits is still counted as ",
                            v.you ? 'yours' : 'theirs',
                            " for five years. A gift cannot be taken back."
                        ]
                    })
                ]
            }),
            helpsUnder: [
                'assets',
                'income'
            ]
        },
        ...debtTotal > 0 ? [
            {
                id: 'debt',
                label: `Paying off the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(debtTotal)} of debt`,
                note: 'Less cash counted, and no more interest.',
                why: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($44d3c10f2c4813c3$var$Why, {
                    lines: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                $44d3c10f2c4813c3$var$b('What it is.'),
                                " Using savings to pay off the ",
                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(debtTotal),
                                " ",
                                v.they,
                                " owe."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                $44d3c10f2c4813c3$var$b('Why it can help.'),
                                " The money used is no longer counted by Centrelink, and the repayments and interest stop."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                $44d3c10f2c4813c3$var$b('The catch.'),
                                " It leaves less cash on hand."
                            ]
                        })
                    ]
                }),
                helpsUnder: [
                    'assets',
                    'income'
                ]
            }
        ] : [],
        ...hasHome ? [
            {
                id: 'property',
                label: 'Selling, renting out or borrowing against the home',
                note: `Selling or letting the home makes more of ${v.their} money counted.`,
                why: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($44d3c10f2c4813c3$var$Why, {
                    lines: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                $44d3c10f2c4813c3$var$b('What it is.'),
                                " Turning part of the home into money: selling it and buying a cheaper one, a reverse mortgage (a loan against the home, repaid when it is sold), or the government's Home Equity Access Scheme (regular payments, also a loan against the home)."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                $44d3c10f2c4813c3$var$b('Why it is less likely to help.'),
                                " The home is not counted by Centrelink, but money is. Moving value out of the home usually raises what is counted."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                $44d3c10f2c4813c3$var$b('Why we test it anyway.'),
                                " The money can still pay for the support, and for some families that matters more."
                            ]
                        })
                    ]
                }),
                helpsUnder: []
            }
        ] : []
    ];
    const test = bindingTest ?? 'assets';
    const likely = levers.filter((l)=>l.helpsUnder.includes(test));
    const lessLikely = levers.filter((l)=>!l.helpsUnder.includes(test));
    const Lever = ({ l: l })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
            className: "flex cursor-pointer items-start gap-2.5 py-1.5 text-[14px] text-slate-800",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "checkbox",
                    checked: value.levers[l.id] !== false,
                    onChange: (e)=>set({
                            levers: {
                                ...value.levers,
                                [l.id]: e.target.checked
                            }
                        }),
                    className: "mt-0.5 h-4 w-4 shrink-0 accent-blue-600",
                    "data-testid": `${idPrefix}-lever-${l.id}`
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        l.label,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($44d3c10f2c4813c3$var$WhatsThis, {
                            children: l.why
                        }),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-[13px] text-slate-500",
                            children: l.note
                        })
                    ]
                })
            ]
        });
    // Numbered in the order shown; the screen's "Five questions…" heading counts the same.
    let asked = 0;
    const next = ()=>{
        asked += 1;
        return asked;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "sah-questions",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($44d3c10f2c4813c3$var$Question, {
                n: next(),
                label: "How many years should we plan for?",
                testId: `${idPrefix}-q-years`,
                why: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($44d3c10f2c4813c3$var$Why, {
                    lines: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: "The plans are compared on what each leaves the family at the end of this period, so the period can change which plan comes out best."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: "Some ways pay back slowly, such as spending on the home. Others help from the first year, such as an income for life."
                        })
                    ]
                }),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                id: `${idPrefix}-years`,
                                type: "number",
                                min: 1,
                                max: 30,
                                value: value.years,
                                onChange: (e)=>set({
                                        years: Math.min(30, Math.max(1, parseInt(e.target.value, 10) || 1))
                                    }),
                                className: "w-24 rounded-lg border border-slate-300 px-3 py-2 text-[15px] font-semibold text-slate-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                htmlFor: `${idPrefix}-years`,
                                className: "text-[13px] text-slate-600",
                                children: "years"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($44d3c10f2c4813c3$var$Hint, {
                        children: "We plan for 10 years at home. Try a shorter or longer period to see how much the answer moves."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($44d3c10f2c4813c3$var$Question, {
                n: next(),
                label: "How much should stay in the bank for emergencies?",
                testId: `${idPrefix}-q-reserve`,
                why: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($44d3c10f2c4813c3$var$Why, {
                    lines: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                $44d3c10f2c4813c3$var$b('What it is.'),
                                " Money kept in the bank for the unexpected. We keep it back when we move ",
                                v.their,
                                " money, and draw on it only if a year runs short."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                $44d3c10f2c4813c3$var$b('Why it matters.'),
                                " Centrelink still counts it. The bigger the reserve, the less money is left for the ways below to work with."
                            ]
                        })
                    ]
                }),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        id: `${idPrefix}-reserve`,
                        type: "text",
                        inputMode: "numeric",
                        value: value.emergencyReserve > 0 ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(value.emergencyReserve) : '',
                        onChange: (e)=>set({
                                emergencyReserve: Math.max(0, parseFloat(String((0, $f94e45ac645ae232$export$dc5333890dfc7d0)(e.target.value))) || 0)
                            }),
                        placeholder: "$0",
                        className: "w-40 rounded-lg border border-slate-300 px-3 py-2 text-[15px] font-semibold tabular-nums text-slate-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($44d3c10f2c4813c3$var$Hint, {
                        children: [
                            "We suggest ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(suggestedReserve),
                            ": the greater of six months' living costs and $50,000",
                            Math.round(value.emergencyReserve) !== Math.round(suggestedReserve) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    " \u2014 ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>set({
                                                emergencyReserve: suggestedReserve
                                            }),
                                        className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                        children: [
                                            "use ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(suggestedReserve)
                                        ]
                                    })
                                ]
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($44d3c10f2c4813c3$var$Question, {
                n: next(),
                label: `Which of these would ${v.names} consider?`,
                testId: `${idPrefix}-q-levers`,
                why: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($44d3c10f2c4813c3$var$Why, {
                    lines: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: "Each of these moves money into something Centrelink counts less of, or not at all."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "Less counted can lift ",
                                v.their,
                                " Age Pension and lower what ",
                                v.they,
                                " pay for each hour of support."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: "Ticking one only lets us test it. It is not a decision to do it."
                        })
                    ]
                }),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mb-1 text-[13px] leading-relaxed text-slate-600",
                        children: bindingTest ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                v.Possessive,
                                " Age Pension is set by ",
                                testWords,
                                ", so the ways that lower ",
                                bindingTest === 'income' ? 'the income Centrelink counts' : 'what Centrelink counts',
                                " are listed first."
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: "The ways that lower what Centrelink counts are listed first."
                        })
                    }),
                    likely.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mb-0.5 mt-3 text-[13px] font-semibold text-brand-navy",
                                children: [
                                    "Most likely to help \u2014 they lower ",
                                    bindingTest === 'income' ? 'the income counted' : 'what is counted'
                                ]
                            }),
                            likely.map((l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Lever, {
                                    l: l
                                }, l.id))
                        ]
                    }),
                    lessLikely.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mb-0.5 mt-3 text-[13px] font-semibold text-brand-navy",
                                children: [
                                    "Less likely to help ",
                                    v.them,
                                    " \u2014 tested anyway"
                                ]
                            }),
                            lessLikely.map((l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Lever, {
                                    l: l
                                }, l.id))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($44d3c10f2c4813c3$var$Hint, {
                        children: "Ticking one is not a decision to do it \u2014 it only lets us test it. Nothing is hidden: every way is still tested."
                    })
                ]
            }),
            guaranteedIncome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": `${idPrefix}-q-guaranteed`,
                className: "border-b border-slate-100 py-4 last:border-b-0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f92088f7258458cc$export$2e2bcd8739ae039), {
                    number: next(),
                    factFind: factFind,
                    onGoals: guaranteedIncome.onGoals,
                    investable: guaranteedIncome.investable,
                    investableLead: "After the money kept for emergencies",
                    investableMadeOf: guaranteedIncome.madeOf,
                    inCare: true,
                    idPrefix: idPrefix
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($44d3c10f2c4813c3$var$Question, {
                n: next(),
                label: "How would money that is freed up be invested?",
                testId: `${idPrefix}-q-invest`,
                why: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($44d3c10f2c4813c3$var$Why, {
                    lines: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                $44d3c10f2c4813c3$var$b('Why we ask.'),
                                " Some plans free up money, for example selling the home and buying a cheaper one. We have to assume how that money would be invested, because that sets what it earns each year in the figures."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                $44d3c10f2c4813c3$var$b('The choices.'),
                                " A cautious choice assumes lower, steadier returns. A growth choice assumes higher returns that rise and fall more."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                $44d3c10f2c4813c3$var$b(`If ${v.they} are not sure,`),
                                " we assume the most cautious, so no plan looks better than it should. The Assumptions page shows what each choice is assumed to earn."
                            ]
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                    id: `${idPrefix}-new-money-profile`,
                    "aria-label": "How freed-up money would be invested",
                    value: value.investProfile,
                    onChange: (e)=>set({
                            investProfile: e.target.value
                        }),
                    className: "w-full max-w-md rounded-lg border border-slate-300 bg-white px-3 py-2 text-[14px] text-slate-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-500",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: "",
                            children: "Not sure \u2014 assume the most cautious"
                        }),
                        (0, $0f2c0a6799fe36da$export$56315028e4277c0c).map((id)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: id,
                                children: (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[id].label
                            }, id))
                    ]
                })
            })
        ]
    });
};
function $44d3c10f2c4813c3$export$f8e1e863e9a66308(a) {
    const on = (id)=>a.levers[id] !== false;
    return {
        includeGifting: on('gift'),
        includeFuneralBonds: on('funeral'),
        // The client's answer to the guaranteed-income question decides (annuityPreference.ts), not a tick here.
        includeAnnuities: true,
        includeDebtRepayment: on('debt'),
        includePropertyStrategies: on('home') || on('property'),
        emergencyReserve: a.emergencyReserve,
        propertyStrategies: {
            increaseHomeEquity: on('home'),
            downsize: on('property'),
            downsizeNewHomeValue: 0,
            downsizeSellingCosts: 0,
            reverseMortgage: on('property'),
            heas: on('property')
        }
    };
}
function $44d3c10f2c4813c3$export$7eb469eda8df2ec0(goals, suggestedReserve) {
    const g = goals || {};
    const off = String(g.sahLeversOff || '').split(',').map((s)=>s.trim()).filter(Boolean);
    const levers = Object.fromEntries($44d3c10f2c4813c3$export$9972779bf6ddd4f0.map((id)=>[
            id,
            !off.includes(id)
        ]));
    const years = Number(g.sahLegacyYears);
    const reserve = Number(g.sahEmergencyReserve);
    return {
        years: Number.isFinite(years) && years >= 1 ? years : 10,
        emergencyReserve: Number.isFinite(reserve) && reserve > 0 ? reserve : suggestedReserve,
        levers: levers,
        investProfile: String(g.newMoneyInvestmentProfile || '')
    };
}
function $44d3c10f2c4813c3$export$c5611676613b360(a) {
    const off = $44d3c10f2c4813c3$export$9972779bf6ddd4f0.filter((id)=>a.levers[id] === false).join(',');
    return {
        sahSetupSeen: true,
        sahLegacyYears: a.years,
        sahEmergencyReserve: Math.round(a.emergencyReserve),
        sahLeversOff: off,
        ...a.investProfile ? {
            newMoneyInvestmentProfile: a.investProfile
        } : {}
    };
}









/**
 * Support at home's debts, for "Explain this" (owner, 22 Oct 2026): what a plan pays off, and the same plan tested
 * with the debts cleared (SupportAtHomeStrategyGenerator.generateDebtClearTwins names its group "<plan>-clear-debt").
 */ function $afba33f9e18e15f2$export$52f9380165cafdac(config) {
    const c = config || {};
    const steps = c.type === 'combination' && Array.isArray(c.steps) ? c.steps : [
        c
    ];
    return steps.reduce((t, s)=>{
        if (s?.type === 'debtRepayment') return t + (Number(s.repaymentAmount) || 0);
        if (s?.type === 'downsize' && s.downsizeDetails?.repayDebt) return t + (Number(s.downsizeDetails.debtRepayment) || 0);
        return t;
    }, 0);
}
function $afba33f9e18e15f2$export$f9633f95e1988be(config) {
    const c = config || {};
    return `${String(c.groupKey ?? c.name ?? c.type)}-clear-debt`;
}
function $afba33f9e18e15f2$export$6877ffd4a8923a8a(row, rows) {
    if (!row?.config) return null;
    const key = $afba33f9e18e15f2$export$f9633f95e1988be(row.config);
    return rows.find((r)=>r !== row && String(r.config?.groupKey ?? '') === key) ?? null;
}


/**
 * WHAT THE OTHER MODULES ARE SHOWING, FOR AWISE (owner, 22 Oct 2026: asked in Support at home why the credit card
 * was not paid off, AWise gave a generic answer — it had no idea which screen or plans were in front of them).
 *
 * The aged care module has had this since 17 Oct (agedCareScreenContext.ts). This is the same tiny store for the
 * rest: each module's plans screen writes its page, a screen key (IN_APP_SCREEN_CONTEXT) and a note of facts
 * already on the screen — the plans shown, their figures, and the debts each keeps and why — and App.tsx reads it
 * when a message is sent. AWise quotes the facts; it never computes from them.
 */ 

let $a84adeeb3afb300d$var$current = null;
function $a84adeeb3afb300d$export$20e2bd13ba4752ab(next) {
    $a84adeeb3afb300d$var$current = next;
}
function $a84adeeb3afb300d$export$144de64fbfa9a324(page) {
    return $a84adeeb3afb300d$var$current && $a84adeeb3afb300d$var$current.page === page ? $a84adeeb3afb300d$var$current : null;
}
function $a84adeeb3afb300d$export$eae2400bf951c637(i) {
    const fig = (f)=>`left to the family ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.estate))} after ${i.years} years, ${f.cashflow < 0 ? `short ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(-f.cashflow))}` : `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.cashflow))} to spare`} a year, Age Pension ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(f.pension))} a year`;
    const lines = [];
    if (i.baseline) lines.push(`${i.baselineLabel || 'The comparison'}: ${fig(i.baseline)}.`);
    i.plans.forEach((p, n)=>{
        lines.push(`Plan ${n + 1}${p.label ? ` (${p.label})` : ''}: "${p.title}" \u{2014} ${fig(p.figures)}.`);
        const debts = (0, $fe4e1ee5e30419ba$export$828e4e226107240a)({
            factFind: i.factFind,
            clearedAmount: p.clearedAmount,
            plan: p.figures,
            twin: p.twin ?? null,
            years: i.years,
            context: 'tested'
        });
        if (debts) lines.push(`Debts in plan ${n + 1}: ${debts.join(' ')}`);
    });
    if (i.extra?.length) lines.push(...i.extra);
    return lines.join('\n');
}



// Calculation Tooltip Component (matching Aged Care)
const $f870b25d8dcbe02f$var$CalculationTooltip = ({ title: title, data: data, children: children })=>{
    const [show, setShow] = (0, $acw62.useState)(false);
    const [position, setPosition] = (0, $acw62.useState)('bottom');
    const wrapperRef = (0, $acw62.useRef)(null);
    const tooltipRef = (0, $acw62.useRef)(null);
    const [coords, setCoords] = (0, $acw62.useState)({
        top: 0,
        left: 0
    });
    (0, $acw62.useLayoutEffect)(()=>{
        if (show && wrapperRef.current && tooltipRef.current) {
            const rect = wrapperRef.current.getBoundingClientRect();
            const tooltipHeight = tooltipRef.current.offsetHeight || 180;
            const spaceBelow = window.innerHeight - rect.bottom;
            const spaceAbove = rect.top;
            let newPosition = position;
            if (spaceBelow < tooltipHeight + 16 && spaceAbove > tooltipHeight + 16) newPosition = 'top';
            else newPosition = 'bottom';
            setPosition(newPosition);
            setCoords({
                top: newPosition === 'top' ? rect.top - tooltipHeight - 16 : rect.bottom + 16,
                left: rect.left + rect.width / 2
            });
        }
    }, [
        show,
        position
    ]);
    if (!Array.isArray(data)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative",
        ref: wrapperRef,
        onMouseEnter: ()=>setShow(true),
        onMouseLeave: ()=>setShow(false),
        children: [
            children,
            show && typeof window !== 'undefined' && window.document && /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                ref: tooltipRef,
                style: {
                    position: 'fixed',
                    top: coords.top,
                    left: coords.left,
                    transform: 'translateX(-50%)',
                    zIndex: 10001,
                    width: '340px',
                    maxWidth: '90vw',
                    pointerEvents: 'auto'
                },
                className: "p-3 bg-gray-800 text-white text-xs rounded-lg shadow-lg",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "font-bold text-sm mb-2 text-blue-300",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "space-y-1",
                        children: data.map((item, index)=>{
                            let displayValue = item.value;
                            if (typeof displayValue === 'number' && !isNaN(displayValue)) displayValue = Math.round(displayValue).toLocaleString();
                            return item.label?.startsWith('---') ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                className: "border-gray-600 my-1"
                            }, `hr-${item.label}-${index}`) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-gray-400",
                                        children: [
                                            item.label,
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-mono font-semibold",
                                        children: displayValue
                                    })
                                ]
                            }, `row-${item.label}-${index}`);
                        })
                    })
                ]
            }), document.body)
        ]
    });
};
/** Support at home's readings for the plan-choice rule (planChoiceRule.ts, owner 20 Oct 2026). */ const $f870b25d8dcbe02f$var$sahReadings = {
    estate: (s)=>Number(s.snapshot?.legacyValue) || 0,
    moved: (s)=>(0, $854c582fbab4f7c2$export$b086ef70c5d0268c)(s.config).amount,
    cashflow: (s)=>Number(s.snapshot?.netCashflow ?? s.snapshot?.cashflow) || 0,
    kinds: (s)=>(0, $203e38d6e6c434f4$export$e1aeab26ad581b54)(s.config?.type, String(s.name || ''))
};
/** One person's side of a service plan as display rows: name, quantity, indicative annual cost. */ function $f870b25d8dcbe02f$var$servicePlanSideRows(side) {
    const rows = [];
    if (!side) return rows;
    const catalogue = Object.values((0, $25e9acc02c907060$export$a3b71735b810a98c)).flatMap((c)=>c.services.map((s)=>({
                ...s,
                category: c.label
            })));
    Object.entries(side).forEach(([serviceId, allocation])=>{
        const quantity = Number(allocation?.quantity) || 0;
        if (quantity <= 0) return;
        const frequency = allocation?.frequency || 'monthly';
        const entry = catalogue.find((s)=>s.id === serviceId);
        // Same convention as the cost engine: 365 days and 52 weeks a year (19 Oct 2026; was ×30 / ×4 a month).
        const perMonth = frequency === 'daily' ? quantity * 365 / 12 : frequency === 'weekly' ? quantity * 52 / 12 : quantity;
        const annual = (entry?.medianPrice || 0) * perMonth * 12;
        rows.push({
            id: serviceId,
            name: entry?.name || serviceId,
            detail: `${quantity}/${frequency === 'daily' ? 'day' : frequency === 'weekly' ? 'week' : 'month'} \xb7 ${entry?.category || ''}`,
            annual: annual
        });
    });
    return rows.sort((a, b)=>b.annual - a.annual);
}
/** Collapsed-by-default view of the service plan an analysis modelled — the services, how often,
 * and their indicative gross cost — so the numbers on the cards are never built on an invisible
 * plan. Renders the illustrative-package explanation when no real plan was in force. */ function $f870b25d8dcbe02f$var$ServicePlanSummaryCollapsible({ plan: plan, isEstimated: isEstimated, description: description, isPartnered: isPartnered, clientName: clientName, partnerName: partnerName }) {
    const [open, setOpen] = (0, $acw62.useState)(false);
    const clientRows = $f870b25d8dcbe02f$var$servicePlanSideRows(plan?.client);
    const partnerRows = isPartnered ? $f870b25d8dcbe02f$var$servicePlanSideRows(plan?.partner) : [];
    const total = [
        ...clientRows,
        ...partnerRows
    ].reduce((sum, r)=>sum + r.annual, 0);
    const fmt = (n)=>`$${Math.round(n).toLocaleString()}`;
    const renderSide = (label, rows)=>rows.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "mb-3",
            children: [
                isPartnered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-xs font-semibold text-gray-700 mb-1",
                    children: label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                    className: "space-y-1",
                    children: rows.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            className: "flex items-baseline justify-between gap-3 text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "text-gray-800",
                                    children: [
                                        r.name,
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "text-gray-500 text-xs",
                                            children: [
                                                "(",
                                                r.detail,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "font-medium text-gray-900 whitespace-nowrap",
                                    children: [
                                        fmt(r.annual),
                                        "/yr"
                                    ]
                                })
                            ]
                        }, r.id))
                })
            ]
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-white border border-gray-200 rounded-xl overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: ()=>setOpen(!open),
                className: "w-full flex items-center justify-between p-4 hover:bg-gray-50 transition-colors text-left",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3739d64fb7ddfae6$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-blue-600"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-sm font-semibold text-gray-900",
                                children: [
                                    "View service plan used in this analysis",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "ml-2 font-normal text-gray-500",
                                        children: isEstimated ? 'Illustrative package' : `Your plan \xb7 ${fmt(total)}/yr gross`
                                    })
                                ]
                            })
                        ]
                    }),
                    open ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                        className: "w-5 h-5 text-gray-500"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                        className: "w-5 h-5 text-gray-500"
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "px-4 pb-4 border-t border-gray-100 pt-3",
                children: [
                    isEstimated && description && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-slate-700 bg-white border border-slate-200 border-l-4 border-l-amber-400 rounded-lg px-3 py-2 mb-3",
                        children: description
                    }),
                    renderSide(clientName, clientRows),
                    renderSide(partnerName, partnerRows),
                    clientRows.length === 0 && partnerRows.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-gray-600",
                        children: "No services recorded in this plan."
                    }),
                    (clientRows.length > 0 || partnerRows.length > 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-gray-500 mt-2",
                        children: "Gross catalogue costs at indicative median prices \u2014 your out-of-pocket contribution depends on your contribution rates, shown in the panel on the right."
                    })
                ]
            })
        ]
    });
}
const $f870b25d8dcbe02f$var$SupportAtHomeSuggestionEnginePanel = ({ onSoaGenerated: onSoaGenerated, supportStartDate: supportStartDate = '', factFind: factFind, setFactFind: setFactFind, servicePlan: servicePlan = {
    client: {},
    partner: {}
}, goals: goals = {}, onStrategySelect: onStrategySelect, selectedStrategy: selectedStrategy, legacyYears: legacyYears = 5, onNavigateToDashboard: onNavigateToDashboard, autoOpenOnMount: autoOpenOnMount = false, onGoToServiceBuilder: onGoToServiceBuilder, selectedAgedCareIntegration: selectedAgedCareIntegration = null, showBaseline: showBaseline = false, setShowBaseline: setShowBaseline, homeCareSaveContext: homeCareSaveContext = null, onStrategySaved: onStrategySaved, onAnalysisStateChange: onAnalysisStateChange, onBuildYourOwn: onBuildYourOwn, openAdviceWhenReady: openAdviceWhenReady = false, openYearByYearWhenReady: openYearByYearWhenReady = false, onCareUp: onCareUp, onLegacyYearsChange: onLegacyYearsChange, bindingTest: bindingTest = null })=>{
    const [analysis, setAnalysis] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [isReoptimising, setIsReoptimising] = (0, $acw62.useState)(false);
    const [progress, setProgress] = (0, $acw62.useState)({
        current: 0,
        total: 0
    });
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        onAnalysisStateChange?.(loading);
    }, [
        loading,
        onAnalysisStateChange
    ]);
    const [showSettingsModal, setShowSettingsModal] = (0, $acw62.useState)(false);
    const [showGoalPrioritization, setShowGoalPrioritization] = (0, $acw62.useState)(false);
    const [goalPriority, setGoalPriority] = (0, $acw62.useState)(null); // 'cashflow', 'estate', 'pension', or null
    const [deepDiveModal, setDeepDiveModal] = (0, $acw62.useState)(false); // Deep dive modal state
    // "What could go wrong" for one card (StrategyRisksPanel).
    const [riskStrategy, setRiskStrategy] = (0, $acw62.useState)(null);
    /** The plan whose "If care needs increase" is open (rebuild M4). */ const [careUpRow, setCareUpRow] = (0, $acw62.useState)(null);
    const [selectedStrategyForDeepDive, setSelectedStrategyForDeepDive] = (0, $acw62.useState)(null); // Strategy for deep dive
    /*
     * THE ANSWERS DRIVE THE RUN (rebuild, 19 Oct 2026). The years, the reserve and the levers used to
     * be fixed here — 5 years and $50,000 whatever the client said — so the questions screen now owns
     * them, saved to the profile once answered (SahQuestions.goalsFromAnswers).
     */ const suggestedReserve = (0, $acw62.useMemo)(()=>(0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind), [
        factFind
    ]);
    const [answers, setAnswers] = (0, $acw62.useState)(()=>(0, $44d3c10f2c4813c3$export$7eb469eda8df2ec0)(factFind?.goals, (0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind)));
    const strategySettings = (0, $acw62.useMemo)(()=>(0, $44d3c10f2c4813c3$export$f8e1e863e9a66308)(answers), [
        answers
    ]);
    const currentSettings = (0, $acw62.useMemo)(()=>({
            legacyYears: answers.years,
            emergencyFund: answers.emergencyReserve
        }), [
        answers
    ]);
    const [questionsOpen, setQuestionsOpen] = (0, $acw62.useState)(false);
    const [explainRow, setExplainRow] = (0, $acw62.useState)(null);
    const [figureFor, setFigureFor] = (0, $acw62.useState)(null);
    /*
     * The chosen plan for THIS run, matched by the engine's own name, so returning to the plans marks
     * the card chosen. Read once from the saved Support at home plan that is chosen.
     */ const [chosenName, setChosenName] = (0, $acw62.useState)(()=>{
        const rec = (0, $dabe6813042a6e48$export$181dd2d22327a6cc)().find((s)=>s.chosen && s.source === 'suggestion_engine');
        return rec ? String((rec.inputs || {}).strategyName || '') || null : null;
    });
    /*
     * ...AND THE SERVICES IT WAS PRICED ON (owner-caught, 20 Oct 2026: a fresh run opened on "You've
     * chosen 'Spend $250,000 on the home'" when nothing had been chosen in it). A plan is the same plan
     * only for the same services — as aged care's chosen plan is only for the same room. With other
     * services nothing here reads as chosen, and the earlier plan is said to stay chosen until one is.
     */ const [chosenRecord, setChosenRecord] = (0, $acw62.useState)(()=>{
        const rec = (0, $dabe6813042a6e48$export$181dd2d22327a6cc)().find((s)=>s.chosen && s.source === 'suggestion_engine');
        if (!rec) return null;
        const inp = rec.inputs || {};
        return {
            fingerprint: typeof inp.servicePlanFingerprint === 'string' ? inp.servicePlanFingerprint : null,
            household: (0, $2eb5e3232a8b6136$export$7bef8f28695964f0)(rec),
            title: String(rec.displayName || rec.name || 'their earlier plan')
        };
    });
    const [chosenSaved, setChosenSaved] = (0, $acw62.useState)(null);
    const [showAnnuityExplainer, setShowAnnuityExplainer] = (0, $acw62.useState)(false);
    const [expandedExplanations, setExpandedExplanations] = (0, $acw62.useState)({
        gifting: false,
        funeralBonds: false,
        annuities: false,
        propertyStrategies: false
    });
    const [showModellingApproach, setShowModellingApproach] = (0, $acw62.useState)(false); // Collapsed by default
    const [showAssumptionsModal, setShowAssumptionsModal] = (0, $acw62.useState)(false);
    const [showAllStrategiesTable, setShowAllStrategiesTable] = (0, $acw62.useState)(false);
    const [showGoalLeadersModal, setShowGoalLeadersModal] = (0, $acw62.useState)(false);
    const [allStrategiesSortBy, setAllStrategiesSortBy] = (0, $acw62.useState)('legacy');
    /* Escape closes the topmost overlay (review, 18 Oct 2026: it closed neither "View Details" nor
       "Compare all strategies"). The details modal opens from the two tables, so it goes first. */ (0, $acw62.useEffect)(()=>{
        if (!deepDiveModal && !showGoalLeadersModal && !showAllStrategiesTable) return undefined;
        const onKey = (e)=>{
            if (e.key !== 'Escape') return;
            if (deepDiveModal) setDeepDiveModal(false);
            else if (showGoalLeadersModal) setShowGoalLeadersModal(false);
            else setShowAllStrategiesTable(false);
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        deepDiveModal,
        showGoalLeadersModal,
        showAllStrategiesTable
    ]);
    const [showSaveStrategyModal, setShowSaveStrategyModal] = (0, $acw62.useState)(false);
    const [strategyPendingSave, setStrategyPendingSave] = (0, $acw62.useState)(null);
    const [lastSavedStrategy, setLastSavedStrategy] = (0, $acw62.useState)(null);
    const [saveStrategyName, setSaveStrategyName] = (0, $acw62.useState)('');
    const [saveStrategyNameError, setSaveStrategyNameError] = (0, $acw62.useState)('');
    const [saveStrategySuccess, setSaveStrategySuccess] = (0, $acw62.useState)(false);
    const [optimisationFocus, setOptimisationFocus] = (0, $acw62.useState)(()=>{
        if (goals?.preserveInheritance && !goals?.meetCareCosts && !goals?.maximizeGovtSupport) return 'legacy';
        if (goals?.meetCareCosts && !goals?.preserveInheritance && !goals?.maximizeGovtSupport) return 'cashflow';
        if (goals?.maximizeGovtSupport && !goals?.preserveInheritance && !goals?.meetCareCosts) return 'pension';
        // Best estate leads (owner, 24 Sep 2026).
        return 'legacy';
    });
    const [availableAgedCareStrategies, setAvailableAgedCareStrategies] = (0, $acw62.useState)([]); // Available Aged Care strategies
    const [selectedAgedCareStrategyId, setSelectedAgedCareStrategyId] = (0, $acw62.useState)(null); // Selected Aged Care strategy ID
    // Step 1's answer decides it (sahEngineContext.ts): "Yes — X is moving" includes the chosen aged care plan.
    const [contributionContextMode, setContributionContextMode] = (0, $acw62.useState)(()=>(0, $5ea55f03cd2af1e4$export$12c4b1871639c9ac)(factFind) === 'yes' ? 'linked' : 'current');
    (0, $acw62.useEffect)(()=>{
        setContributionContextMode((0, $5ea55f03cd2af1e4$export$12c4b1871639c9ac)(factFind) === 'yes' ? 'linked' : 'current');
    }, [
        factFind?.goals?.sahAgedCareMove
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const hasStructures = (factFind?.structures || []).length > 0;
    const [structureFundingInSuggestions, setStructureFundingInSuggestions] = (0, $acw62.useState)(()=>factFind?.structureFundingInSuggestions || 'exclude');
    (0, $acw62.useEffect)(()=>{
        setStructureFundingInSuggestions(factFind?.structureFundingInSuggestions || 'exclude');
    }, [
        factFind?.structureFundingInSuggestions
    ]);
    const toggleExplanation = (strategyKey)=>{
        setExpandedExplanations((prev)=>({
                ...prev,
                [strategyKey]: !prev[strategyKey]
            }));
    };
    // Load available Aged Care strategies from sessionStorage
    (0, $acw62.useEffect)(()=>{
        if (typeof window !== 'undefined') try {
            const savedStrategies = JSON.parse(sessionStorage.getItem('careCompanionStrategies') || '[]');
            // Filter for aged care strategies
            const agedCareStrategies = savedStrategies.filter((s)=>s.type === 'aged_care');
            setAvailableAgedCareStrategies(agedCareStrategies);
            // If there's a selected strategy from parent (manual integration), use it
            if (selectedAgedCareIntegration && selectedAgedCareIntegration.id) setSelectedAgedCareStrategyId(selectedAgedCareIntegration.id);
        } catch (error) {
            console.error('Error loading Aged Care strategies:', error);
        }
    }, [
        selectedAgedCareIntegration
    ]);
    // Get selected Aged Care strategy details
    const selectedAgedCareStrategyForIntegration = (0, $acw62.useMemo)(()=>{
        if (!selectedAgedCareStrategyId) return null;
        const selectedId = String(selectedAgedCareStrategyId);
        return availableAgedCareStrategies.find((s)=>String(s.id) === selectedId) || null;
    }, [
        availableAgedCareStrategies,
        selectedAgedCareStrategyId
    ]);
    // Extract Aged Care integration details from selected strategy
    const effectiveAgedCareIntegration = (0, $acw62.useMemo)(()=>{
        if (selectedAgedCareStrategyForIntegration) return (0, $87af0cc4cc4e8984$export$2fdaec60121ed226)(selectedAgedCareStrategyForIntegration);
        // Fall back to prop if provided
        return selectedAgedCareIntegration;
    }, [
        selectedAgedCareStrategyForIntegration,
        selectedAgedCareIntegration
    ]);
    const isPartnered = factFind?.adviceFor === 'couple';
    // Debts a plan can decide about (never a card paid off monthly — strategy/debtsToTest.ts).
    const clientLiabilities = (0, $acw62.useMemo)(()=>(0, $6737c18204fae40a$export$eab989c41b911b05)(factFind), [
        factFind
    ]);
    const clientHasDebts = clientLiabilities.length > 0;
    const shouldOfferContributionContextSwitch = isPartnered && Boolean(factFind?.goals?.aged_care || effectiveAgedCareIntegration);
    const linkedResidencyOverrides = (0, $acw62.useMemo)(()=>(0, $5ea55f03cd2af1e4$export$6d4a478abfb618cb)(effectiveAgedCareIntegration ?? null, factFind), [
        effectiveAgedCareIntegration,
        factFind
    ]);
    // ONE builder for the options (sahEngineContext.ts), shared with steps 1 and 2: the support start
    // date rides the same bag as the residency overrides, and in the linked case the chosen aged care
    // plan's yearly fees are charged too (19 Oct 2026, pack B.SAH.6).
    const contributionContextOptions = (0, $acw62.useMemo)(()=>(0, $5ea55f03cd2af1e4$export$7fa4cd25cd8ca863)({
            supportStartDate: supportStartDate,
            linked: contributionContextMode === 'linked' ? effectiveAgedCareIntegration ?? null : null,
            overrides: linkedResidencyOverrides
        }), [
        contributionContextMode,
        linkedResidencyOverrides,
        supportStartDate,
        effectiveAgedCareIntegration
    ]);
    const applyLinkedAgedCareScenario = contributionContextMode === 'linked' && Boolean(effectiveAgedCareIntegration);
    // The household the plans are priced on, for the "tested on a different household" check (24 Oct 2026).
    const householdFingerprint = (0, $2eb5e3232a8b6136$export$ef78d200e1ff7453)(applyLinkedAgedCareScenario ? String(selectedAgedCareStrategyForIntegration?.id ?? effectiveAgedCareIntegration?.id ?? '') : null);
    const canSelectLinkedContext = Boolean(selectedAgedCareIntegration) || availableAgedCareStrategies.length > 0;
    const isLinkedContextUnavailable = contributionContextMode === 'linked' && Object.keys(linkedResidencyOverrides || {}).length === 0;
    (0, $acw62.useEffect)(()=>{
        if (selectedAgedCareIntegration?.id) setContributionContextMode('linked');
    }, [
        selectedAgedCareIntegration
    ]);
    // "Include the chosen aged care plan" means the CHOSEN one: picked for them, so the list only asks
    // when there is more than one saved and none is chosen (with one saved, it is that one).
    (0, $acw62.useEffect)(()=>{
        if (contributionContextMode !== 'linked' || selectedAgedCareStrategyId || availableAgedCareStrategies.length === 0) return;
        const chosen = availableAgedCareStrategies.find((s)=>s.chosen);
        const pick = chosen || (availableAgedCareStrategies.length === 1 ? availableAgedCareStrategies[0] : null);
        if (pick?.id != null) setSelectedAgedCareStrategyId(pick.id);
    }, [
        contributionContextMode,
        selectedAgedCareStrategyId,
        availableAgedCareStrategies
    ]);
    const openSaveStrategyModal = (strategy)=>{
        setStrategyPendingSave(strategy);
        setSaveStrategyName((strategy?.name || 'Suggested strategy').replace(/\s*\([^)]*\)\s*$/, '').trim());
        setSaveStrategyNameError('');
        setSaveStrategySuccess(false);
        setShowSaveStrategyModal(true);
        if (onStrategySelect) onStrategySelect(strategy);
    };
    const handleConfirmSaveStrategy = async ()=>{
        if (!strategyPendingSave || !homeCareSaveContext) return;
        const pendingAnnuity = (0, $dd66c4f756bb6b40$export$39e91763b583ca80)(strategyPendingSave.config);
        if (pendingAnnuity && (0, $5eae79c7e46ed27e$export$655f124668ce439a)(factFind, pendingAnnuity.incomeOnly, pendingAnnuity.amount)) {
            setSaveStrategyNameError("This plan\u2019s guaranteed income is the type where nothing comes back. Confirm that on its card before saving it.");
            return;
        }
        if (!saveStrategyName.trim()) {
            setSaveStrategyNameError('Please enter a strategy name');
            return;
        }
        setSaveStrategyNameError('');
        const linkedAgedCareForSave = contributionContextMode === 'linked' && effectiveAgedCareIntegration;
        const saved = await (0, $dabe6813042a6e48$export$e42ac98ba12bf3d5)({
            factFind: factFind,
            evaluatedStrategy: strategyPendingSave,
            name: saveStrategyName,
            selectedAgedCareIntegration: linkedAgedCareForSave ? effectiveAgedCareIntegration : null,
            agedCareResidencyOverrides: linkedAgedCareForSave ? linkedResidencyOverrides : {},
            participantType: homeCareSaveContext.participantType,
            nwopCategory: homeCareSaveContext.nwopCategory,
            meansDisclosed: homeCareSaveContext.meansDisclosed,
            previousITCF: Number(homeCareSaveContext.previousITCF) || 0,
            isPartnered: homeCareSaveContext.isPartnered,
            agedCareContext: linkedAgedCareForSave ? 'linked' : 'current'
        });
        (0, $dabe6813042a6e48$export$e66848783651d59b)(saved);
        onStrategySaved?.(saved);
        setLastSavedStrategy(saved);
        // No auto-close: the success state offers the Digital SOA (generated from the SAVED record,
        // so the document always matches something on file — same discipline as aged care).
        setSaveStrategySuccess(true);
    };
    const closeSaveStrategyModal = ()=>{
        setShowSaveStrategyModal(false);
        setStrategyPendingSave(null);
        setSaveStrategySuccess(false);
        setLastSavedStrategy(null);
    };
    /** Build and open the Digital SOA for the just-saved strategy, and persist the snapshot onto it
     * so the exact document can be reopened later. */ const openDigitalSoaForSavedStrategy = async (saved = lastSavedStrategy, pending = strategyPendingSave)=>{
        if (!saved) return;
        const snapshot = await (0, $39348679b8be0d72$export$87f72c2469f493ab)({
            selectedStrategy: saved,
            factFind: factFind,
            projections: pending?.projections ?? null,
            analysis: analysis ? {
                strategies: analysis.strategies,
                totalEvaluated: analysis.totalEvaluated
            } : null,
            servicePlan: servicePlanResolution.plan,
            servicePlanIsEstimated: servicePlanResolution.isEstimated,
            servicePlanDescription: servicePlanResolution.description,
            strategySource: 'suggestion_engine',
            linkedCare: applyLinkedAgedCareScenario ? await (0, $5ea55f03cd2af1e4$export$816274d728d58b8d)(factFind, selectedAgedCareStrategyForIntegration) : null
        });
        if (snapshot) {
            const document1 = {
                ...saved,
                soaSnapshot: snapshot
            };
            (0, $dabe6813042a6e48$export$e66848783651d59b)(document1);
            onSoaGenerated?.(document1);
            (0, $39348679b8be0d72$export$d13a73f2d338923d)(snapshot);
        }
        setDeferredSoa(null);
        closeSaveStrategyModal();
    };
    /* "Maybe later" no longer loses the offer (review, 18 Oct 2026: after it there was no way back to the
       advice document on the page). The saved plan and its projections are kept, and a line under the
       plans offers the document until it is opened. */ const [deferredSoa, setDeferredSoa] = (0, $acw62.useState)(null);
    const deferSoaForSavedStrategy = ()=>{
        if (lastSavedStrategy) setDeferredSoa({
            saved: lastSavedStrategy,
            pending: strategyPendingSave
        });
        closeSaveStrategyModal();
    };
    // Auto-open Strategy Analysis Setup when Suggestion Engine tab is first selected
    // — the FIRST time only (review, 18 Oct 2026: it opened again on every visit, minutes after it was
    // answered). Once answered, the plans run on arrival instead.
    (0, $acw62.useEffect)(()=>{
        if (!autoOpenOnMount) return;
        // Not yet answered: the questions show inline (no pop-over), and the plans run from there.
        // Answered already, including how freed-up money is invested — so the one-off gate is not shown again.
        if (factFind?.goals?.sahSetupSeen && !analysis) maybeRunAnalysis(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        autoOpenOnMount
    ]);
    // Check if all goals are selected
    (0, $acw62.useEffect)(()=>{
        const allGoalsSelected = goals.meetCareCosts && goals.preserveInheritance && goals.maximizeGovtSupport;
        if (allGoalsSelected && !goalPriority) setShowGoalPrioritization(true);
    }, [
        goals,
        goalPriority
    ]);
    // Format currency helper
    const formatCurrency = (value)=>{
        const num = Number(value);
        if (!value || isNaN(num)) return '$0';
        const roundedValue = Math.round(num);
        return `${roundedValue < 0 ? '-' : ''}$${Math.abs(roundedValue).toLocaleString()}`;
    };
    // Which service plan the engine models. Default: the current Service Builder plan (the
    // `servicePlan` prop, read from session storage by the parent). The user can instead pick one of
    // their SAVED service plans in Strategy Analysis Setup — choosing one also becomes the app-wide
    // "current plan" so the builder, insight panel and engine all agree on what's in force.
    const [servicePlanOverride, setServicePlanOverride] = (0, $acw62.useState)(null);
    const [servicePlanOverrideId, setServicePlanOverrideId] = (0, $acw62.useState)('');
    // With "Yes — X is moving into aged care" (step 1), X has no Support at home services priced.
    const effectiveServicePlan = (0, $acw62.useMemo)(()=>(0, $5ea55f03cd2af1e4$export$fe04ad50cd2b5dad)(servicePlanOverride ?? servicePlan, factFind), [
        servicePlanOverride,
        servicePlan,
        factFind
    ]);
    /** Saved home-care strategies that actually carry a service plan, normalised to {client, partner}. */ const savedServicePlans = (0, $acw62.useMemo)(()=>{
        const toSides = (services)=>services.client || services.partner ? {
                client: services.client || {},
                partner: services.partner || {}
            } : {
                client: services,
                partner: {}
            };
        const hasAny = (plan)=>[
                plan.client,
                plan.partner
            ].some((side)=>Object.values(side || {}).some((d)=>Number(d?.quantity) > 0));
        return (0, $dabe6813042a6e48$export$181dd2d22327a6cc)().filter((s)=>s?.inputs?.services).map((s)=>({
                id: String(s.id),
                name: s.name || 'Saved plan',
                plan: toSides(s.inputs.services)
            })).filter((entry)=>hasAny(entry.plan));
    }, []);
    const selectSavedServicePlan = (id)=>{
        setServicePlanOverrideId(id);
        const chosen = savedServicePlans.find((p)=>p.id === id) || null;
        setServicePlanOverride(chosen ? chosen.plan : null);
        if (chosen && typeof window !== 'undefined') try {
            sessionStorage.setItem('careCompanionCurrentServicePlan', JSON.stringify(chosen.plan));
        } catch  {}
    };
    // Service plan for modelling (user plan or documented illustrative mix)
    const servicePlanResolution = (0, $acw62.useMemo)(()=>{
        const isPartnered = factFind?.adviceFor === 'couple';
        return (0, $f5036bbfe52e7121$export$528f6df084e80c0b)(effectiveServicePlan, isPartnered);
    }, [
        effectiveServicePlan,
        factFind?.adviceFor
    ]);
    const [servicePlanCosts, setServicePlanCosts] = (0, $acw62.useState)({});
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (async ()=>{
            const baselineFinancials = await $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind, contributionContextOptions.strategyOptions || {});
            const baselineContributions = await $55a1d8a64f1e5dfa$export$3fe0e13ec85e5380(factFind, baselineFinancials, 'standard', null, true, 0, 0.5, contributionContextOptions);
            if (cancelled) return;
            const isPartnered = factFind?.adviceFor === 'couple';
            const contributionRates = isPartnered ? baselineContributions?.combined?.contributionRates || {} : baselineContributions?.client?.contributionRates || {};
            const costs = (0, $08809b7a4fc47e27$export$8fa8d1fdeea775a9)(servicePlanResolution.plan, contributionRates, isPartnered, (0, $08809b7a4fc47e27$export$4ddb2093d9f00d95)(factFind));
            setServicePlanCosts({
                ...costs,
                hasUserServicePlan: !servicePlanResolution.isEstimated,
                isEstimated: servicePlanResolution.isEstimated,
                estimatedDescription: servicePlanResolution.description
            });
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        servicePlanResolution,
        factFind,
        contributionContextOptions
    ]);
    /**
     * The just-in-time "how would new money be invested?" gate. Downsize strategies deploy the
     * freed-up money, so when the client has a home and no recorded answer the question is asked
     * BEFORE the engine prices anything — same rules as the village module (answering saves to
     * the profile and is asked once ever; skipping runs at Conservative without recording).
     */ const [showNewMoneyGate, setShowNewMoneyGate] = (0, $acw62.useState)(false);
    const [newMoneySkipped, setNewMoneySkipped] = (0, $acw62.useState)(false);
    /*
     * THE GUARANTEED-INCOME QUESTION (owner, 21 Oct 2026 — the guaranteed income review; mock-up screen 6). It is
     * asked on the questions screen (SahQuestions → GuaranteedIncomeQuestions), not as a gate before the run:
     * the explanation always on screen, three answers, and how much at most. "No" removes every guaranteed
     * income from this and every other module; the answer is the client's (annuityPreference.ts), written
     * straight to their goals and never overwritten with a default.
     */ const writeGuaranteedIncomeGoals = (patch)=>{
        if (setFactFind) setFactFind((prev)=>({
                ...prev,
                goals: {
                    ...prev.goals || {},
                    ...patch
                }
            }));
    };
    /** The money a guaranteed income could come from, as the plans size it (the same figure the question shows). */ const annuityInvestable = (0, $acw62.useMemo)(()=>(0, $e4aa20091e5d9c16$export$8a06018655d03e9e)(factFind, answers.emergencyReserve), [
        factFind,
        answers.emergencyReserve
    ]);
    /** The client's confirmation for a tested income-only plan (IncomeOnlyTick.tsx). */ const setIncomeOnlyConfirmed = (0, $5eae79c7e46ed27e$export$415ddf94c95c9134)(setFactFind);
    const [showTbcGate, setShowTbcGate] = (0, $acw62.useState)(false);
    const [tbcSkipped, setTbcSkipped] = (0, $acw62.useState)(false);
    const sahRunWouldInvest = (parseFloat(String(factFind?.home?.value ?? '')) || 0) > 0;
    // Chained after the new-money question: SAH's downsize strategies can commence a pension from
    // the downsizer contribution, so the $1.6m screen asks for the ATO cap figure before pricing.
    const tbcPersonNeedingAnswer = !tbcSkipped && sahRunWouldInvest ? (0, $4f5a997f1c0139af$export$7bf826dbcbb0ddc)(factFind, 'client') ? 'client' : factFind?.adviceFor === 'couple' && (0, $4f5a997f1c0139af$export$7bf826dbcbb0ddc)(factFind, 'partner') ? 'partner' : null : null;
    /**
     * @param askedInSetup - the caller has just shown the settings modal, which carries the
     * new-money question itself. Its default option ("Not sure — assume Conservative") is a
     * legitimate answer that deliberately records nothing, so gating on a RECORDED answer put the
     * interim screen back in front of every adviser who left the dropdown alone — the exact screen
     * moving the question into the setup was meant to remove. The gate below stays for any future
     * caller that runs without opening the modal.
     */ const maybeRunAnalysis = (askedInSetup = false)=>{
        if (!askedInSetup && sahRunWouldInvest && !(0, $0f2c0a6799fe36da$export$848647f164f42923)(factFind) && !newMoneySkipped) {
            setShowNewMoneyGate(true);
            return;
        }
        if (tbcPersonNeedingAnswer !== null) {
            setShowTbcGate(true);
            return;
        }
        runAnalysis();
    };
    const answerNewMoneyProfile = (id)=>{
        setShowNewMoneyGate(false);
        if (setFactFind) setFactFind((prev)=>({
                ...prev,
                goals: {
                    ...prev.goals || {},
                    newMoneyInvestmentProfile: id
                }
            }));
        if (tbcPersonNeedingAnswer !== null) {
            setShowTbcGate(true);
            return;
        }
        runAnalysis();
    };
    const skipNewMoneyProfile = ()=>{
        setShowNewMoneyGate(false);
        setNewMoneySkipped(true);
        if (tbcPersonNeedingAnswer !== null) {
            setShowTbcGate(true);
            return;
        }
        runAnalysis();
    };
    const answerTbc = (amount)=>{
        setShowTbcGate(false);
        if (setFactFind && tbcPersonNeedingAnswer) {
            const key = tbcPersonNeedingAnswer;
            setFactFind((prev)=>({
                    ...prev,
                    [key]: {
                        ...prev[key] || {},
                        transferBalanceUsed: amount
                    }
                }));
        }
        runAnalysis();
    };
    const skipTbc = ()=>{
        setShowTbcGate(false);
        setTbcSkipped(true);
        runAnalysis();
    };
    // Run intelligent modelling analysis
    const runAnalysis = async ()=>{
        setIsReoptimising(!!analysis);
        setLoading(true);
        setError(null);
        setProgress({
            current: 0,
            total: 0
        });
        const runWork = async ()=>{
            // STEP 0: the household priced — in the linked case the whole aged care plan carried out (owner,
            // 24 Oct 2026; the deposit alone if it cannot be rebuilt) and the plan's living costs
            // (sahEngineContext.ts, the same builder steps 1 and 2 use).
            const linkedRecordForRun = applyLinkedAgedCareScenario ? selectedAgedCareStrategyForIntegration : null;
            const positioned = linkedRecordForRun ? (await (0, $5ea55f03cd2af1e4$export$52b55e2d4cc3fb71)(factFind, linkedRecordForRun)).factFind : null;
            const baselineFactFind = (0, $5ea55f03cd2af1e4$export$696453b4446851c9)(factFind, applyLinkedAgedCareScenario ? effectiveAgedCareIntegration ?? null : null, hasStructures ? structureFundingInSuggestions : undefined, positioned);
            // STEP 1: Analyze baseline and identify problems (using Aged Care-adjusted factFind)
            const baselineAnalysis = await (0, $e7f7fd8599da7702$export$c04a983651e4920b)(baselineFactFind, effectiveServicePlan, currentSettings.legacyYears || legacyYears || 5, {
                strategyOptions: contributionContextOptions.strategyOptions || {},
                contributionOptions: contributionContextOptions
            });
            // STEP 2: Identify irrelevant strategies based on baseline analysis
            const strategyFiltering = (0, $e7f7fd8599da7702$export$3d3dcd311a86b11c)(baselineAnalysis.problemStatement, strategySettings);
            // STEP 3: Generate all relevant strategies (using Aged Care-adjusted factFind)
            const allStrategies = (0, $e4aa20091e5d9c16$export$931e02ce02c6f432)(baselineFactFind, baselineAnalysis.problemStatement, strategySettings);
            const evaluationOptions = {
                strategyOptions: contributionContextOptions.strategyOptions || {},
                contributionOptions: contributionContextOptions
            };
            setProgress({
                current: 0,
                total: allStrategies.length + 1
            });
            // STEP 4: Evaluate "Do Nothing" + every candidate strategy in ONE request (server-side
            // composite endpoint — see server/src/rest/calculation/suggestionEngine/supportAtHome.ts)
            // instead of one request per candidate.
            const baselineData = {
                baselineFinancials: baselineAnalysis.baselineFinancials,
                baselineContributions: baselineAnalysis.baselineContributions,
                baselineProjections: baselineAnalysis.baselineProjections
            };
            const [doNothingStrategy, ...evaluatedStrategies] = await $55a1d8a64f1e5dfa$export$7d4b40198f92b886(baselineFactFind, baselineData, effectiveServicePlan, currentSettings.legacyYears || legacyYears || 5, [
                {
                    type: 'doNothing',
                    name: 'Do Nothing'
                },
                ...allStrategies
            ], evaluationOptions);
            setProgress({
                current: allStrategies.length + 1,
                total: allStrategies.length + 1
            });
            // STEP 5: Rank strategies by goal priority (always include Do Nothing baseline). rankStrategies'
            // own BaselineAnalysis type is a loosely-typed subset shape (see SupportAtHomeStrategyEvaluator.ts);
            // baselineAnalysis here is the richer BaselineOpportunitiesResult, which is structurally a superset.
            const rankedOthers = (0, $21ed594a114149ac$export$cb7d99be370b6691)(evaluatedStrategies, goalPriority, baselineAnalysis);
            const recommendedOptimalStrategies = (0, $f8ee565b442c040e$export$3140a3b98e6384f2)(evaluatedStrategies, doNothingStrategy, {
                readings: $f870b25d8dcbe02f$var$sahReadings
            });
            const rankedStrategies = (0, $f8ee565b442c040e$export$ca5137fb416189aa)([
                doNothingStrategy,
                ...rankedOthers
            ], recommendedOptimalStrategies);
            // STEP 6: Store results
            const modellingAssumptions = (0, $853d75b8a4c3c6c1$export$d5459457c23273a7)({
                factFind: baselineFactFind,
                strategySettings: strategySettings,
                legacyYears: currentSettings.legacyYears || legacyYears || 5,
                emergencyFund: currentSettings.emergencyFund || 50000,
                agedCareIntegrationApplied: applyLinkedAgedCareScenario,
                usesEstimatedServicePlan: baselineAnalysis.servicePlanResolution?.isEstimated,
                estimatedServicePlanDescription: baselineAnalysis.servicePlanResolution?.description
            });
            return {
                payload: {
                    strategies: rankedStrategies,
                    recommendedOptimalStrategies: recommendedOptimalStrategies,
                    allEvaluatedStrategies: evaluatedStrategies,
                    doNothingStrategy: doNothingStrategy,
                    baseline: {
                        financials: baselineAnalysis.baselineFinancials,
                        contributions: baselineAnalysis.baselineContributions,
                        projections: baselineAnalysis.baselineProjections,
                        servicePlanCosts: baselineAnalysis.servicePlanCosts,
                        agedCareIntegrationApplied: applyLinkedAgedCareScenario,
                        // The exact plan this analysis modelled — for the snapshot's "view service
                        // plan" and for detecting that the plan changed after the run.
                        servicePlanUsed: baselineAnalysis.servicePlanResolution?.plan ?? null,
                        servicePlanIsEstimated: baselineAnalysis.servicePlanResolution?.isEstimated ?? true,
                        servicePlanDescription: baselineAnalysis.servicePlanResolution?.description ?? null
                    },
                    servicePlanFingerprint: JSON.stringify(effectiveServicePlan ?? {}),
                    householdFingerprint: householdFingerprint,
                    problemStatement: baselineAnalysis.problemStatement,
                    strategyFiltering: strategyFiltering,
                    modellingAssumptions: modellingAssumptions,
                    totalGenerated: allStrategies.length,
                    totalEvaluated: evaluatedStrategies.length
                },
                hasStrategies: rankedStrategies.length > 0
            };
        };
        try {
            // No minimum display time (owner, 20 Oct 2026: a saved plan should open at once). The loader
            // used to stay up for at least five seconds even when the results came straight back; the
            // engine's results are now kept (calculationApi), so it shows only while there is real work.
            const workResult = await runWork();
            if (workResult?.payload) setAnalysis(workResult.payload);
            // No intermediary "Analysis Complete" modal — the results render directly below,
            // exactly as the aged care module does after its analysis run.
            if (workResult && !workResult.hasStrategies) setError('No viable strategies found for your current situation. Please adjust your strategy settings or check your financial position.');
        } catch (err) {
            console.error('Error running Support at Home analysis:', err);
            setError('Failed to run analysis. Please try again.');
        } finally{
            setLoading(false);
            setIsReoptimising(false);
            setProgress({
                current: 0,
                total: 0
            });
        }
    };
    const recommendedOptimal = analysis?.recommendedOptimalStrategies || [];
    const effectiveOptimisationSurface = optimisationFocus === 'all' ? 'legacy' : optimisationFocus;
    const displayedGoalStrategies = (0, $acw62.useMemo)(()=>{
        if (!analysis?.strategies?.length) return [];
        // A goal leader only exists where a strategy BEATS "Do Nothing" on that goal
        // (goalLeaderFor returns null otherwise, and the empty state below says so honestly
        // with the do-nothing figures). Best legacy and All goals share the legacy surface —
        // single primary card, AC parity.
        // The same plan as Best estate is said in one line, not shown twice (owner, 24 Sep 2026).
        if (effectiveOptimisationSurface === 'covered' && (0, $400a08a42b233386$export$b8b8a2cedd92aa3a)(recommendedOptimal)) return [];
        const row = (0, $f8ee565b442c040e$export$cf9821b188ee27f0)(recommendedOptimal, effectiveOptimisationSurface);
        if (!row) return [];
        return [
            analysis.strategies.find((s)=>s.name === row.strategy.name) || row.strategy
        ];
    }, [
        analysis?.strategies,
        recommendedOptimal,
        effectiveOptimisationSurface
    ]);
    (0, $acw62.useEffect)(()=>{
        setShowAllStrategiesTable(false);
    }, [
        optimisationFocus
    ]);
    const goalComparisonRows = (0, $acw62.useMemo)(()=>{
        const enrich = (label)=>{
            const row = recommendedOptimal.find((r)=>r.label === label);
            if (!row?.strategy?.name) return null;
            return analysis?.strategies?.find((s)=>s.name === row.strategy.name) || row.strategy;
        };
        const rows = [];
        const cov = enrich((0, $400a08a42b233386$export$920ad41b346ae01a));
        if (cov) rows.push({
            goalLabel: (0, $400a08a42b233386$export$8d25e363f6ae69ae),
            strategy: cov
        });
        const leg = enrich('Optimal Legacy');
        if (leg) rows.push({
            goalLabel: (0, $400a08a42b233386$export$8a102fa4742ce4ac),
            strategy: leg
        });
        const cf = enrich('Optimal Cashflow');
        if (cf) rows.push({
            goalLabel: 'Best cashflow',
            strategy: cf
        });
        const pen = enrich('Optimal Age Pension');
        if (pen) rows.push({
            goalLabel: 'Best Age Pension',
            strategy: pen
        });
        return rows;
    }, [
        recommendedOptimal,
        analysis?.strategies
    ]);
    // AWise reads the plans on screen and what each does about the debts (owner, 22 Oct 2026).
    (0, $acw62.useEffect)(()=>{
        if (!goalComparisonRows.length) {
            (0, $a84adeeb3afb300d$export$20e2bd13ba4752ab)(null);
            return undefined;
        }
        const all = analysis?.allEvaluatedStrategies || analysis?.strategies || [];
        const fig = (row)=>{
            const f = (0, $ca9b5cdfbd99e645$export$122bd92e883ab7c1)(row.snapshot || {});
            return {
                estate: f.legacy,
                cashflow: f.cashflow,
                pension: f.pension
            };
        };
        const base = analysis?.doNothingStrategy?.snapshot ? fig(analysis.doNothingStrategy) : null;
        (0, $a84adeeb3afb300d$export$20e2bd13ba4752ab)({
            page: 'HomeCarePage',
            screen: 'support-at-home',
            note: (0, $a84adeeb3afb300d$export$eae2400bf951c637)({
                factFind: factFind,
                years: Number(answers.years) || 10,
                baseline: base,
                baselineLabel: 'The support alone (the same services, nothing else changed)',
                plans: goalComparisonRows.map((r)=>{
                    const twin = (0, $afba33f9e18e15f2$export$6877ffd4a8923a8a)(r.strategy, all);
                    return {
                        label: r.goalLabel,
                        title: (0, $f7f18ba87194b6fe$export$743d9d8d57ca17a8)(r.strategy.config, factFind, String(r.strategy.name || '')).title,
                        figures: fig(r.strategy),
                        clearedAmount: (0, $afba33f9e18e15f2$export$52f9380165cafdac)(r.strategy.config),
                        twin: twin ? fig(twin) : null
                    };
                })
            })
        });
        return ()=>(0, $a84adeeb3afb300d$export$20e2bd13ba4752ab)(null);
    }, [
        goalComparisonRows,
        analysis,
        factFind,
        answers.years
    ]);
    const tableStrategies = (0, $acw62.useMemo)(()=>{
        const base = (analysis?.allEvaluatedStrategies || analysis?.strategies || []).filter((s)=>s.name !== 'Do Nothing' && s.config?.type !== 'doNothing');
        const sorted = [
            ...base
        ];
        if (allStrategiesSortBy === 'cashflow') sorted.sort((a, b)=>(b.snapshot?.netCashflow ?? b.snapshot?.cashflow ?? -Infinity) - (a.snapshot?.netCashflow ?? a.snapshot?.cashflow ?? -Infinity));
        else if (allStrategiesSortBy === 'pension') sorted.sort((a, b)=>(b.snapshot?.pension ?? b.snapshot?.agePension ?? 0) - (a.snapshot?.pension ?? a.snapshot?.agePension ?? 0));
        else sorted.sort((a, b)=>(b.snapshot?.legacyValue ?? -Infinity) - (a.snapshot?.legacyValue ?? -Infinity));
        return sorted;
    }, [
        analysis,
        allStrategiesSortBy
    ]);
    const assumptionsModalBullets = (0, $acw62.useMemo)(()=>(0, $853d75b8a4c3c6c1$export$e0006d39a63910c4)(analysis?.modellingAssumptions), [
        analysis?.modellingAssumptions
    ]);
    const saSuggestionCardHighlightKey = (0, $acw62.useMemo)(()=>{
        const inner = selectedStrategy?.strategy ?? selectedStrategy;
        if (!inner?.name || !displayedGoalStrategies.length) return null;
        const k = String(inner.name);
        return displayedGoalStrategies.some((s)=>String(s.name) === k) ? k : null;
    }, [
        selectedStrategy,
        displayedGoalStrategies
    ]);
    /*
     * THE OLD CARD'S BODY, KEPT BEHIND "Show the detail" (rebuild, 19 Oct 2026). The card front is now
     * the aged care card (SahPlansView); everything this card used to show — the plain-words story,
     * the allocation, the rate changes, the annual snapshot with its pop-overs, the improvements, the
     * annuity and equity-release terms — is one tap away, as aged care does it.
     */ const renderStrategyDetail = (strategy)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            "data-testid": "sah-plan-detail",
            children: [
                (()=>{
                    const explainer = (0, $f6fa0c4ae572e255$export$db6db87c4063fbb3)[String(strategy.config?.type || '')];
                    if (!explainer) return strategy.config?.description ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-gray-600 mb-6",
                        children: strategy.config.description
                    }) : null;
                    /*
                 * Two additions the owner asked for (2026-08-25), both data-honest:
                 * the rates sentence only renders when THIS strategy's rates actually
                 * fall (quoting the same snapshot figures as the rates box below), and
                 * the risk line surfaces the strategy's own vetted first
                 * what-to-weigh-up point instead of boilerplate.
                 */ const ratesNow = strategy.snapshot?.contributionRates;
                    const ratesBase = strategy.snapshot?.baselineContributionRates;
                    const rateFell = (key)=>!!ratesNow && !!ratesBase && (ratesNow[key] ?? 0) < (ratesBase[key] ?? 0) - 0.0005;
                    const ratesImproved = rateFell('independence') || rateFell('everydayLiving');
                    const asPct = (v)=>`${((v ?? 0) * 100).toFixed(1)}%`;
                    const keyRisk = explainer.consider[0];
                    const moreToWeighUp = explainer.consider.slice(1).join(' ');
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$28c8139bd562d0e), {
                        eyebrow: "What this strategy does",
                        className: "mb-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm leading-relaxed text-slate-700",
                                children: [
                                    explainer.what,
                                    ratesImproved && ratesNow && ratesBase && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            ' ',
                                            "It also lowers the Support at Home contribution rates ",
                                            "\u2014",
                                            ' ',
                                            "independence ",
                                            asPct(ratesBase.independence),
                                            " ",
                                            "\u2192",
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-semibold text-slate-900",
                                                children: asPct(ratesNow.independence)
                                            }),
                                            ", everyday living ",
                                            asPct(ratesBase.everydayLiving),
                                            " ",
                                            "\u2192",
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-semibold text-slate-900",
                                                children: asPct(ratesNow.everydayLiving)
                                            }),
                                            ' ',
                                            "\u2014",
                                            " so every hour of service costs less (detailed below)."
                                        ]
                                    })
                                ]
                            }),
                            keyRisk && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-1.5 text-sm leading-relaxed text-slate-700",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-semibold text-amber-700",
                                        children: "Worth knowing:"
                                    }),
                                    " ",
                                    keyRisk
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-1.5 text-xs leading-relaxed text-slate-500",
                                children: [
                                    "Tap for the detail:",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                        term: "how it works",
                                        children: explainer.how.join(' ')
                                    }),
                                    moreToWeighUp && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            " \xb7 ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                                term: "more to weigh up",
                                                children: moreToWeighUp
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    });
                })(),
                strategy.assetAllocation && strategy.assetAllocation.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mb-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                            className: "text-lg font-semibold text-gray-800 mb-3",
                            children: "Asset Allocation"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-2 gap-3",
                            children: strategy.assetAllocation.map((asset, assetIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center justify-between p-3 bg-gray-50 rounded-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: `w-3 h-3 rounded-full mr-3 ${asset.status === 'sold' ? 'bg-red-500' : asset.status === 'partiallySold' ? 'bg-yellow-500' : asset.status === 'new' ? 'bg-blue-500' : asset.status === 'upgraded' ? 'bg-green-500' : 'bg-green-500'}`
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "font-medium text-gray-700",
                                                    children: (0, $2a669e0126fd3a3e$export$9555bc30b49fd2f2)(asset, factFind)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "ml-2 text-xs text-gray-500",
                                                    children: (0, $2a669e0126fd3a3e$export$acfc0c5058edfc8)(asset.status)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "text-right",
                                            children: [
                                                (asset.liquidatedAmount || 0) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "text-sm text-red-600 mb-1",
                                                    children: [
                                                        "Sold: -",
                                                        formatCurrency(asset.liquidatedAmount)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "font-semibold text-gray-900",
                                                    children: [
                                                        "Kept: ",
                                                        formatCurrency(asset.remainingAmount)
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, assetIndex))
                        })
                    ]
                }),
                strategy.snapshot?.contributionRates && strategy.snapshot?.baselineContributionRates && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mb-6 p-4 bg-white border border-slate-200/70 border-l-4 border-blue-500 rounded-lg",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                            className: "text-sm font-semibold text-gray-800 mb-3",
                            children: "Contribution Rate Changes"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "grid grid-cols-3 gap-4 text-xs",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "text-gray-600 mb-1",
                                            children: "Clinical"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "font-semibold",
                                            children: [
                                                ((strategy.snapshot.baselineContributionRates.clinical ?? 0) * 100).toFixed(1),
                                                "% \u2192 ",
                                                ((strategy.snapshot.contributionRates.clinical ?? 0) * 100).toFixed(1),
                                                "%"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `text-xs ${(strategy.snapshot.contributionRates.clinical || 0) < (strategy.snapshot.baselineContributionRates.clinical || 0) ? 'text-green-600' : 'text-gray-600'}`,
                                            children: (strategy.snapshot.contributionRates.clinical || 0) - (strategy.snapshot.baselineContributionRates.clinical || 0) !== 0 ? `${(strategy.snapshot.contributionRates.clinical || 0) - (strategy.snapshot.baselineContributionRates.clinical || 0) > 0 ? '+' : ''}${(((strategy.snapshot.contributionRates.clinical || 0) - (strategy.snapshot.baselineContributionRates.clinical || 0)) * 100).toFixed(1)}%` : 'No change'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "text-gray-600 mb-1",
                                            children: "Independence"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "font-semibold",
                                            children: [
                                                ((strategy.snapshot.baselineContributionRates.independence ?? 0) * 100).toFixed(1),
                                                "% \u2192 ",
                                                ((strategy.snapshot.contributionRates.independence ?? 0) * 100).toFixed(1),
                                                "%"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `text-xs ${(strategy.snapshot.contributionRates.independence || 0) < (strategy.snapshot.baselineContributionRates.independence || 0) ? 'text-green-600' : 'text-gray-600'}`,
                                            children: (strategy.snapshot.contributionRates.independence || 0) - (strategy.snapshot.baselineContributionRates.independence || 0) !== 0 ? `${(strategy.snapshot.contributionRates.independence || 0) - (strategy.snapshot.baselineContributionRates.independence || 0) > 0 ? '+' : ''}${(((strategy.snapshot.contributionRates.independence || 0) - (strategy.snapshot.baselineContributionRates.independence || 0)) * 100).toFixed(1)}%` : 'No change'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "text-gray-600 mb-1",
                                            children: "Everyday Living"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "font-semibold",
                                            children: [
                                                ((strategy.snapshot.baselineContributionRates.everydayLiving ?? 0) * 100).toFixed(1),
                                                "% \u2192 ",
                                                ((strategy.snapshot.contributionRates.everydayLiving ?? 0) * 100).toFixed(1),
                                                "%"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `text-xs ${(strategy.snapshot.contributionRates.everydayLiving || 0) < (strategy.snapshot.baselineContributionRates.everydayLiving || 0) ? 'text-green-600' : 'text-gray-600'}`,
                                            children: (strategy.snapshot.contributionRates.everydayLiving || 0) - (strategy.snapshot.baselineContributionRates.everydayLiving || 0) !== 0 ? `${(strategy.snapshot.contributionRates.everydayLiving || 0) - (strategy.snapshot.baselineContributionRates.everydayLiving || 0) > 0 ? '+' : ''}${(((strategy.snapshot.contributionRates.everydayLiving || 0) - (strategy.snapshot.baselineContributionRates.everydayLiving || 0)) * 100).toFixed(1)}%` : 'No change'
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mb-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-baseline justify-between gap-3 flex-wrap mb-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                    className: "text-lg font-semibold text-gray-800",
                                    children: "Annual Snapshot"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-xs text-gray-500",
                                    children: "A normalised year"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-xs text-gray-500 mb-3",
                            children: "A full 12 months with this plan in place, so every strategy compares like for like. It is not the first financial year, which starts today and is shorter."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "grid grid-cols-2 md:grid-cols-3 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-center p-3 bg-slate-50 rounded-lg relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f870b25d8dcbe02f$var$CalculationTooltip, {
                                            title: "Age Pension (p.a.) Breakdown",
                                            data: strategy.snapshot?.agePensionBreakdown || [],
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "text-sm text-gray-600 mb-1 flex items-center justify-center",
                                                children: [
                                                    "Est. Age Pension",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c00fae44777e2393$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4 ml-1 text-gray-400 cursor-help"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "font-medium text-green-600",
                                            children: [
                                                "+ ",
                                                formatCurrency(strategy.snapshot?.pension || strategy.snapshot?.agePension || 0)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-center p-3 bg-slate-50 rounded-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "text-sm text-gray-600 mb-1",
                                            children: "Investment Income"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "font-medium text-green-600",
                                            children: [
                                                "+ ",
                                                formatCurrency((strategy.snapshot?.abpIncome || 0) + (strategy.snapshot?.rentalIncome || 0) + (strategy.snapshot?.otherInvestmentIncome || 0))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-center p-3 bg-slate-50 rounded-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "text-sm text-gray-600 mb-1",
                                            children: "Living Expenses"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "font-medium text-red-600",
                                            children: [
                                                "- ",
                                                formatCurrency(strategy.snapshot?.livingExpenses || 0)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-center p-3 bg-slate-50 rounded-lg relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f870b25d8dcbe02f$var$CalculationTooltip, {
                                            title: "Support at Home contribution (your cost)",
                                            data: [
                                                {
                                                    label: 'Your annual contribution',
                                                    value: formatCurrency(strategy.snapshot?.totalSupportAtHomeCosts || 0)
                                                },
                                                {
                                                    label: 'Gross service fees (catalogue)',
                                                    value: formatCurrency(strategy.snapshot?.grossServicePlanCosts || strategy.snapshot?.supportAtHomeCostsBreakdown?.grossAnnual || 0)
                                                },
                                                {
                                                    label: '--- Gross by category ---',
                                                    value: ''
                                                },
                                                {
                                                    label: 'Clinical',
                                                    value: formatCurrency(strategy.snapshot?.supportAtHomeCostsBreakdown?.clinical || 0)
                                                },
                                                {
                                                    label: 'Independence',
                                                    value: formatCurrency(strategy.snapshot?.supportAtHomeCostsBreakdown?.independence || 0)
                                                },
                                                {
                                                    label: 'Everyday Living',
                                                    value: formatCurrency(strategy.snapshot?.supportAtHomeCostsBreakdown?.everydayLiving || 0)
                                                },
                                                {
                                                    label: '--- Your contribution ---',
                                                    value: ''
                                                },
                                                {
                                                    label: 'Independence contribution',
                                                    value: formatCurrency(strategy.snapshot?.supportAtHomeCostsBreakdown?.independenceContribution || 0)
                                                },
                                                {
                                                    label: 'Everyday living contribution',
                                                    value: formatCurrency(strategy.snapshot?.supportAtHomeCostsBreakdown?.everydayContribution || 0)
                                                },
                                                ...strategy.snapshot?.supportAtHomeCostsBreakdown?.privateExcess ? [
                                                    {
                                                        label: 'Above the budget, paid at full price',
                                                        value: formatCurrency((strategy.snapshot?.supportAtHomeCostsBreakdown).privateExcess || 0)
                                                    }
                                                ] : [],
                                                {
                                                    label: 'Change vs baseline',
                                                    value: formatCurrency(strategy.snapshot?.contributionReduction || 0)
                                                }
                                            ],
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "text-sm text-gray-600 mb-1 flex items-center justify-center",
                                                children: [
                                                    "SAH contribution",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c00fae44777e2393$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4 ml-1 text-gray-400 cursor-help"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "font-medium text-red-600",
                                            children: [
                                                "- ",
                                                formatCurrency(strategy.snapshot?.totalSupportAtHomeCosts || 0)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-center p-3 bg-slate-50 rounded-lg relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f870b25d8dcbe02f$var$CalculationTooltip, {
                                            title: "Tax Breakdown",
                                            data: strategy.snapshot?.taxBreakdown || [
                                                {
                                                    label: 'No tax payable.',
                                                    value: ''
                                                }
                                            ],
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "text-sm text-gray-600 mb-1 flex items-center justify-center",
                                                children: [
                                                    "Income Tax",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c00fae44777e2393$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4 ml-1 text-gray-400 cursor-help"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: `font-medium ${(strategy.snapshot?.taxPayable ?? 0) < 0 ? 'text-green-600' : 'text-red-600'}`,
                                            children: [
                                                (strategy.snapshot?.taxPayable ?? 0) < 0 ? '+' : '-',
                                                " ",
                                                formatCurrency(Math.abs(strategy.snapshot?.taxPayable ?? 0)),
                                                (strategy.snapshot?.taxPayable ?? 0) < 0 ? ' (refund)' : ''
                                            ]
                                        })
                                    ]
                                }),
                                (()=>{
                                    /* The tiles must add up to the net figure (review, 18 Oct 2026: six tiles added to
                           $22,846 against a stated $2,277). Rental expenses and loan repayments had no tile,
                           and the net is the money the year actually paid: the Age Pension in it is
                           re-assessed each fortnight, so it is not quite the opening rate on the tile. Both
                           are now shown, line by line, and the tiles close on the net. */ const other = (0, $5f877c9e754d58f9$export$8ef2fc8db3a6ec52)(strategy.snapshot);
                                    if (Math.abs(other) < 1) return null;
                                    const rows = (0, $5f877c9e754d58f9$export$5ff6d8d52e3ad2be)(strategy.snapshot?.cashFlowBreakdown, other);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "text-center p-3 bg-slate-50 rounded-lg relative",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f870b25d8dcbe02f$var$CalculationTooltip, {
                                                title: "Everything else in the year",
                                                data: rows.map((r)=>({
                                                        label: r.label,
                                                        value: formatCurrency(r.value)
                                                    })),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "text-sm text-gray-600 mb-1 flex items-center justify-center",
                                                    children: [
                                                        "Property costs, repayments and other",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c00fae44777e2393$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4 ml-1 text-gray-400 cursor-help"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: `font-medium ${other >= 0 ? 'text-green-600' : 'text-red-600'}`,
                                                children: [
                                                    other >= 0 ? '+' : '-',
                                                    " ",
                                                    formatCurrency(Math.abs(other))
                                                ]
                                            })
                                        ]
                                    });
                                })(),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-center p-3 bg-slate-50 rounded-lg relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f870b25d8dcbe02f$var$CalculationTooltip, {
                                            title: "Net Annual Cashflow Breakdown",
                                            data: (()=>{
                                                const other = (0, $5f877c9e754d58f9$export$8ef2fc8db3a6ec52)(strategy.snapshot);
                                                return [
                                                    {
                                                        label: 'Age Pension',
                                                        value: formatCurrency(strategy.snapshot?.pension || strategy.snapshot?.agePension || 0)
                                                    },
                                                    {
                                                        label: 'Investment Income',
                                                        value: formatCurrency((strategy.snapshot?.abpIncome || 0) + (strategy.snapshot?.rentalIncome || 0) + (strategy.snapshot?.otherInvestmentIncome || 0))
                                                    },
                                                    {
                                                        label: '--- Less ---',
                                                        value: ''
                                                    },
                                                    {
                                                        label: 'Living Expenses',
                                                        value: formatCurrency(strategy.snapshot?.livingExpenses || 0)
                                                    },
                                                    {
                                                        label: 'SAH contribution (your cost)',
                                                        value: formatCurrency(strategy.snapshot?.totalSupportAtHomeCosts || 0)
                                                    },
                                                    {
                                                        label: (strategy.snapshot?.taxPayable ?? 0) < 0 ? 'Income Tax (refund)' : 'Income Tax',
                                                        value: formatCurrency(Math.abs(strategy.snapshot?.taxPayable ?? 0))
                                                    },
                                                    ...Math.abs(other) >= 1 ? [
                                                        {
                                                            label: '--- Everything else ---',
                                                            value: ''
                                                        },
                                                        ...(0, $5f877c9e754d58f9$export$5ff6d8d52e3ad2be)(strategy.snapshot?.cashFlowBreakdown, other).map((r)=>({
                                                                label: r.label,
                                                                value: formatCurrency(r.value)
                                                            }))
                                                    ] : [],
                                                    {
                                                        label: '--- Result ---',
                                                        value: ''
                                                    },
                                                    {
                                                        label: 'Net Annual Cashflow',
                                                        value: formatCurrency(strategy.snapshot?.cashflow || 0)
                                                    }
                                                ];
                                            })(),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "text-sm text-gray-600 mb-1 flex items-center justify-center",
                                                children: [
                                                    "Net Cashflow",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c00fae44777e2393$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4 ml-1 text-gray-400 cursor-help"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `font-medium ${(strategy.snapshot?.cashflow || 0) >= 0 ? 'text-green-600' : 'text-red-600'}`,
                                            children: formatCurrency(strategy.snapshot?.cashflow || 0)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mb-6 p-4 bg-white rounded-lg border border-slate-200/70 border-l-4 border-blue-500",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                            className: "text-sm font-semibold text-gray-800 mb-3",
                            children: "Key Improvements vs Baseline"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "grid grid-cols-2 md:grid-cols-4 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-center",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "text-xs text-gray-600 mb-1",
                                            children: "Pension Increase"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: `text-lg font-semibold ${(strategy.snapshot?.agePensionIncrease || 0) > 0 ? 'text-green-700' : 'text-gray-700'}`,
                                            children: [
                                                formatCurrency(strategy.snapshot?.agePensionIncrease || 0),
                                                "/yr"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-center",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "text-xs text-gray-600 mb-1",
                                            children: "Contribution Reduction"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: `text-lg font-semibold ${(strategy.snapshot?.contributionReduction || 0) > 0 ? 'text-green-700' : 'text-gray-700'}`,
                                            children: [
                                                formatCurrency(strategy.snapshot?.contributionReduction || 0),
                                                "/yr"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-center",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "text-xs text-gray-600 mb-1",
                                            children: "Cashflow Improvement"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: `text-lg font-semibold ${(strategy.snapshot?.cashflowImprovement || 0) > 0 ? 'text-green-700' : 'text-red-700'}`,
                                            children: [
                                                formatCurrency(strategy.snapshot?.cashflowImprovement || 0),
                                                "/yr"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-center",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "text-xs text-gray-600 mb-1",
                                            children: "Legacy Improvement"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `text-lg font-semibold ${(strategy.snapshot?.legacyImprovement || 0) > 0 ? 'text-green-700' : 'text-gray-700'}`,
                                            children: formatCurrency(strategy.snapshot?.legacyImprovement || 0)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6421482343679f4$export$d05c00195a7db941), {
                    className: "mb-3",
                    terms: strategy.annuityTerms,
                    factFind: factFind
                }),
                (()=>{
                    const er = strategy.equityRelease;
                    if (!er || !(Number(er.loanAmount) > 0)) return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $680e2cea6da0f2e4$export$45232555cfe21303), {
                        className: "mb-3",
                        kind: er.kind === 'heas' ? 'heas' : 'reverseMortgage',
                        loanAmount: Number(er.loanAmount) || 0,
                        interestRate: Number(er.interestRate) || null,
                        projectedBalance: Number(er.projectedBalance) || null,
                        years: Number(er.years) || null,
                        homeValue: Number(factFind?.home?.value) || null
                    });
                })(),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            setSelectedStrategyForDeepDive(strategy);
                            setDeepDiveModal(true);
                        },
                        className: "text-[13px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy",
                        children: "See the year-by-year figures"
                    })
                })
            ]
        });
    /** The plan in words, for the card, the dialogs and the saved record. */ const wordsFor = (row)=>(0, $f7f18ba87194b6fe$export$743d9d8d57ca17a8)(row?.config, factFind, String(row?.name || ''));
    const household = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const baselineFigures = analysis?.doNothingStrategy?.snapshot ? (0, $ca9b5cdfbd99e645$export$122bd92e883ab7c1)(analysis.doNothingStrategy.snapshot) : null;
    const pensionWhyWords = (()=>{
        const ps = analysis?.problemStatement?.pensionOptimization;
        if (!ps) return 'The Age Pension is worked out under both the assets test and the income test; the lower result is paid.';
        if (ps.status === 'full') return `${household.Names} ${household.are} on the full Age Pension, so the plans cannot raise it further.`;
        return `The Age Pension is worked out under both the assets test and the income test, and the lower result is paid. Centrelink counts ${formatCurrency(Number(ps.assessableAssets) || 0)} of ${household.possessive} assets; each $1,000 less that is counted adds about $78 a year, until the income test takes over.`;
    })();
    /*
     * A TESTED PLAN WITH A GUARANTEED INCOME (owner, 21 Oct 2026 — the guaranteed income review E4/E5, mock-up
     * screens 3 and 4). Its card shows what the family receives from it at the start, middle and end of the
     * period, against the support alone where the guaranteed income is the plan's only piece (then the support alone IS
     * the same plan without it). An income-only one cannot be chosen until the client has confirmed, for this
     * amount, that nothing comes back (IncomeOnlyBeforeChoose; the record is printed in the advice document).
     */ const sahGuaranteedIncomeFor = (row)=>{
        const a = (0, $dd66c4f756bb6b40$export$39e91763b583ca80)(row.config);
        if (!a) return null;
        const rows = row.projections || [];
        const doNothingRows = analysis?.doNothingStrategy?.projections || [];
        const held = (0, $5eae79c7e46ed27e$export$655f124668ce439a)(factFind, a.incomeOnly, a.amount);
        return {
            familyPanel: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
                factFind: factFind,
                personName: (0, $dd66c4f756bb6b40$export$b2f4bd9ebed41c37)(factFind, a.owner),
                amount: a.amount,
                kind: a.kind,
                incomeAYear: (0, $dd66c4f756bb6b40$export$75e3f249f9924fd2)(rows, factFind),
                rows: rows,
                compareRows: a.only && doNothingRows.length ? doNothingRows : null,
                compareNote: a.only ? (0, $dd66c4f756bb6b40$export$ea81c21b74f64dcc) : null,
                horizonYears: answers.years,
                testId: "sah-annuity-family-panel"
            }),
            beforeChoose: a.incomeOnly && setIncomeOnlyConfirmed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$4538b371a206da0c), {
                factFind: factFind,
                amount: a.amount,
                onChange: setIncomeOnlyConfirmed
            }) : null,
            chooseHeld: held
        };
    };
    /** Choosing a plan saves it as THE chosen Support at home plan (saving is choosing). */ const choosePlan = async (row, opts = {})=>{
        if (!homeCareSaveContext) return;
        // Income only is held until the client has confirmed it for this amount (see sahGuaranteedIncomeFor).
        const plannedAnnuity = (0, $dd66c4f756bb6b40$export$39e91763b583ca80)(row.config);
        if (plannedAnnuity && (0, $5eae79c7e46ed27e$export$655f124668ce439a)(factFind, plannedAnnuity.incomeOnly, plannedAnnuity.amount)) return;
        const words = wordsFor(row);
        const linkedAgedCareForSave = contributionContextMode === 'linked' && effectiveAgedCareIntegration;
        const built = await (0, $dabe6813042a6e48$export$e42ac98ba12bf3d5)({
            factFind: factFind,
            evaluatedStrategy: row,
            name: words.title,
            selectedAgedCareIntegration: linkedAgedCareForSave ? effectiveAgedCareIntegration : null,
            agedCareResidencyOverrides: linkedAgedCareForSave ? linkedResidencyOverrides : {},
            participantType: homeCareSaveContext.participantType,
            nwopCategory: homeCareSaveContext.nwopCategory,
            meansDisclosed: homeCareSaveContext.meansDisclosed,
            previousITCF: Number(homeCareSaveContext.previousITCF) || 0,
            isPartnered: homeCareSaveContext.isPartnered,
            agedCareContext: linkedAgedCareForSave ? 'linked' : 'current'
        });
        // Choosing the same plan again replaces its record rather than adding another.
        const fingerprint = JSON.stringify(effectiveServicePlan ?? {});
        const previous = (0, $dabe6813042a6e48$export$181dd2d22327a6cc)().find((s)=>{
            const inp = s.inputs || {};
            return s.source === 'suggestion_engine' && inp.strategyName === row.name && inp.servicePlanFingerprint === fingerprint;
        });
        const saved = {
            ...built,
            ...previous ? {
                id: previous.id
            } : {},
            // A refresh keeps the day the plan was chosen; only its figures follow the new run.
            ...opts.refresh && previous ? {
                createdAt: previous.createdAt,
                retestedAt: new Date().toISOString()
            } : {},
            displayName: words.title,
            inputs: {
                ...built.inputs || {},
                engineStrategyId: row.name,
                servicePlanFingerprint: fingerprint,
                householdFingerprint: // The household it was priced on, so Home can tell when that household has changed (sahChosenStale.ts).
                householdFingerprint,
                legacyYears: answers.years,
                servicePlan: effectiveServicePlan,
                // The card as chosen — the plan page shows and explains it from this (sahChosenPlan.ts).
                card: (0, $b2a376f07fa94da4$export$5414d0f4d2450da0)({
                    plan: (0, $ca9b5cdfbd99e645$export$122bd92e883ab7c1)(row.snapshot || {}),
                    baseline: baselineFigures,
                    words: words,
                    drawLines: (0, $f7f18ba87194b6fe$export$29c4d395a04f1ae)((0, $f7f18ba87194b6fe$export$e0e75d1fdb5f788f)(row.assetAllocation, factFind)),
                    riskKinds: (0, $203e38d6e6c434f4$export$e1aeab26ad581b54)(row.config?.type, String(row.name || '')),
                    horizonYears: answers.years,
                    origin: 'engine',
                    engineConfig: row.config,
                    moved: (0, $854c582fbab4f7c2$export$b086ef70c5d0268c)(row.config).amount
                })
            },
            baseline: baselineFigures ? {
                legacyValue: baselineFigures.legacy,
                pension: baselineFigures.pension,
                cashFlow: baselineFigures.cashflow,
                contribution: baselineFigures.contribution
            } : null
        };
        (0, $dabe6813042a6e48$export$e66848783651d59b)(saved);
        onStrategySaved?.(saved);
        onStrategySelect?.(row);
        setChosenName(String(row.name));
        setChosenRecord({
            fingerprint: fingerprint,
            household: householdFingerprint,
            title: words.title
        });
        setChosenSaved({
            saved: saved,
            row: row
        });
    };
    /*
     * THE CHOSEN PLAN'S SAVED FIGURES FOLLOW ITS RE-TEST (25 Oct 2026). Home and the plan page read the
     * record saved when the plan was chosen; a plan chosen on 24 Oct read $4,379,840 there and $4,259,667 on
     * its card once the whole aged care plan was carried. A run that finds the chosen plan again, on the
     * same services, re-saves it (same record, same day chosen) where its figures moved.
     */ (0, $acw62.useEffect)(()=>{
        if (!analysis) return;
        const fingerprint = JSON.stringify(effectiveServicePlan ?? {});
        if ((analysis.servicePlanFingerprint ?? fingerprint) !== fingerprint) return;
        // Only a run on the household as it is now speaks for the chosen plan (25 Oct 2026).
        if (analysis.householdFingerprint !== householdFingerprint) return;
        const saved = (0, $dabe6813042a6e48$export$181dd2d22327a6cc)().find((s)=>s.chosen && s.source === 'suggestion_engine' && s.inputs?.servicePlanFingerprint === fingerprint);
        const name = saved?.inputs?.strategyName;
        if (!saved || name == null) return;
        // Chosen on another household: Home and the plan page already say so (sahChosenStale.ts); choosing again replaces it.
        if ((0, $2eb5e3232a8b6136$export$7bef8f28695964f0)(saved) !== householdFingerprint) return;
        const row = (analysis.allEvaluatedStrategies || analysis.strategies || []).find((s)=>s.name === name);
        if (!row) {
            (0, $dabe6813042a6e48$export$3a8f35d37820f4b2)((0, $78a369bbf1e0d995$export$a2028cac13d6740f));
            return;
        }
        const legacy = Number(row.snapshot?.legacyValue);
        const was = Number(saved.outputs?.legacyEstimate);
        if (!Number.isFinite(legacy) || Math.round(legacy) === Math.round(was) && !(0, $78a369bbf1e0d995$export$f4ec6e978b61cc57)(saved)) return;
        choosePlan(row, {
            refresh: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        analysis
    ]);
    /**
     * The chosen plan's advice document. Straight after choosing, the plan just chosen; on a later
     * visit (when that is gone) the chosen record on file and its row in this run (19 Oct 2026: the
     * banner's button did nothing after a reload).
     */ const openAdviceDocument = ()=>{
        const target = chosenSaved ?? (()=>{
            const saved = (0, $dabe6813042a6e48$export$181dd2d22327a6cc)().find((s)=>s.chosen && s.source === 'suggestion_engine');
            const all = analysis?.allEvaluatedStrategies || analysis?.strategies || [];
            const row = chosenName ? all.find((s)=>s.name === chosenName) : undefined;
            return saved && row ? {
                saved: saved,
                row: row
            } : null;
        })();
        if (!target) return;
        openDigitalSoaForSavedStrategy(target.saved, target.row);
    };
    // The chosen plan reads as chosen only in a run on the services it was priced on (see chosenRecord).
    const runFingerprint = analysis?.servicePlanFingerprint ?? JSON.stringify(effectiveServicePlan ?? {});
    const chosenSameServices = !!chosenName && chosenRecord?.fingerprint != null && chosenRecord.fingerprint === runFingerprint;
    // ...and on the household it was priced on (25 Oct 2026: a plan chosen with both at home is not chosen in a run
    // that carries John's aged care plan, even where a plan of the same name appears in it).
    const runHousehold = analysis?.householdFingerprint ?? householdFingerprint;
    const chosenHere = chosenSameServices && chosenRecord?.household === runHousehold ? chosenName : null;
    const chosenForOtherServices = chosenName && !chosenSameServices ? chosenRecord?.title ?? null : null;
    // Why the chosen plan is not here, when the services are the same: another household, or the run did not find it.
    const chosenOutOfDate = (()=>{
        if (!chosenName || !chosenSameServices || !analysis) return null;
        const rows = analysis.allEvaluatedStrategies || analysis.strategies || [];
        if (chosenHere && rows.some((s)=>s.name === chosenHere)) return null;
        const saved = (0, $dabe6813042a6e48$export$181dd2d22327a6cc)().find((s)=>s.chosen && s.source === 'suggestion_engine');
        const reason = chosenHere ? (0, $78a369bbf1e0d995$export$a2028cac13d6740f) : (0, $2eb5e3232a8b6136$export$bc9892722f29f4ff)(saved, factFind, (0, $dabe6813042a6e48$export$1ff5d2c58264060b)());
        return reason ? {
            title: chosenRecord?.title ?? '',
            reason: reason
        } : null;
    })();
    // The plan page asked for the advice document: open it once the plans are back.
    const adviceRequested = (0, $acw62.useRef)(openAdviceWhenReady);
    (0, $acw62.useEffect)(()=>{
        if (!adviceRequested.current || !analysis || !chosenName) return;
        adviceRequested.current = false;
        openAdviceDocument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        analysis,
        chosenName
    ]);
    // The plan page asked for the chosen plan's year-by-year figures: open them once the plans are back.
    const yearByYearRequested = (0, $acw62.useRef)(openYearByYearWhenReady);
    (0, $acw62.useEffect)(()=>{
        if (!yearByYearRequested.current || !analysis || !chosenName) return;
        yearByYearRequested.current = false;
        const row = (analysis.allEvaluatedStrategies || analysis.strategies || []).find((s)=>s.name === chosenName);
        if (!row) return;
        setSelectedStrategyForDeepDive(row);
        setDeepDiveModal(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        analysis,
        chosenName
    ]);
    /** The plans side by side: the support alone, then each goal's leader once. */ const compareRows = (()=>{
        const base = analysis?.doNothingStrategy;
        const leaders = goalComparisonRows.reduce((acc, r)=>{
            const hit = acc.find((x)=>x.strategy.name === r.strategy.name);
            if (hit) hit.goals.push(r.goalLabel);
            else acc.push({
                strategy: r.strategy,
                goals: [
                    r.goalLabel
                ]
            });
            return acc;
        }, []);
        const cell = (s)=>{
            const f = (0, $ca9b5cdfbd99e645$export$122bd92e883ab7c1)(s?.snapshot || {});
            return {
                f: f,
                moved: (0, $854c582fbab4f7c2$export$b086ef70c5d0268c)(s?.config).amount
            };
        };
        const baseCell = base ? cell(base) : null;
        const rows = [];
        if (base && baseCell) rows.push({
            key: 'do-nothing',
            baseline: true,
            title: "The support alone \u2014 the same services, nothing else changed",
            subtitle: 'the comparison',
            cells: {
                bestFor: {
                    value: null,
                    display: ''
                },
                legacy: {
                    value: baseCell.f.legacy
                },
                cf: {
                    value: baseCell.f.cashflow,
                    display: baseCell.f.cashflow < 0 ? `short ${formatCurrency(Math.abs(baseCell.f.cashflow))}` : formatCurrency(baseCell.f.cashflow),
                    tone: baseCell.f.cashflow < 0 ? 'bad' : 'good'
                },
                pension: {
                    value: baseCell.f.pension
                },
                contribution: {
                    value: baseCell.f.contribution
                },
                moved: {
                    value: 0
                }
            }
        });
        leaders.forEach(({ strategy: strategy, goals: goals })=>{
            const c = cell(strategy);
            const dl = baseCell ? c.f.legacy - baseCell.f.legacy : null;
            rows.push({
                key: String(strategy.name),
                chosen: chosenHere === strategy.name,
                title: wordsFor(strategy).title,
                onOpen: ()=>{
                    setShowGoalLeadersModal(false);
                    setExplainRow(strategy);
                },
                cells: {
                    bestFor: {
                        value: null,
                        display: goals.join(" \xb7 ")
                    },
                    legacy: {
                        value: c.f.legacy,
                        sub: dl != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: dl >= 0 ? 'text-emerald-700' : 'text-rose-700',
                            children: [
                                dl >= 0 ? '+' : "\u2212",
                                formatCurrency(Math.abs(Math.round(dl))),
                                " vs the support alone"
                            ]
                        }) : undefined
                    },
                    cf: {
                        value: c.f.cashflow,
                        display: c.f.cashflow < 0 ? `short ${formatCurrency(Math.abs(c.f.cashflow))}` : `+${formatCurrency(c.f.cashflow)}`,
                        tone: c.f.cashflow < 0 ? 'bad' : 'good'
                    },
                    pension: {
                        value: c.f.pension
                    },
                    contribution: {
                        value: c.f.contribution
                    },
                    moved: {
                        value: c.moved
                    }
                }
            });
        });
        /*
         * THE PLAN BUILT BY HAND, beside the tested ones (review, "what stays": "a self-built plan sits
         * beside the engine's plans, with the doing-nothing row"). The chosen one, else the newest, from its
         * stored card — only when it was priced on these same services, so the columns compare like with like.
         */ const handBuilt = (0, $dabe6813042a6e48$export$181dd2d22327a6cc)().filter((s)=>s.source === 'manual' && s.inputs?.card).filter((s)=>s.inputs.servicePlanFingerprint === JSON.stringify(effectiveServicePlan ?? {})).sort((a, b)=>Number(Boolean(b.chosen)) - Number(Boolean(a.chosen)) || String(b.createdAt || '').localeCompare(String(a.createdAt || '')))[0];
        const hbCard = handBuilt?.inputs?.card;
        if (handBuilt && hbCard) {
            const dl = baseCell ? hbCard.plan.legacy - baseCell.f.legacy : null;
            rows.push({
                key: 'hand-built',
                chosen: Boolean(handBuilt.chosen),
                title: hbCard.words.title,
                subtitle: 'built by you',
                cells: {
                    bestFor: {
                        value: null,
                        display: ''
                    },
                    legacy: {
                        value: hbCard.plan.legacy,
                        sub: dl != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: dl >= 0 ? 'text-emerald-700' : 'text-rose-700',
                            children: [
                                dl >= 0 ? '+' : "\u2212",
                                formatCurrency(Math.abs(Math.round(dl))),
                                " vs the support alone"
                            ]
                        }) : undefined
                    },
                    cf: {
                        value: hbCard.plan.cashflow,
                        display: hbCard.plan.cashflow < 0 ? `short ${formatCurrency(Math.abs(hbCard.plan.cashflow))}` : `+${formatCurrency(hbCard.plan.cashflow)}`,
                        tone: hbCard.plan.cashflow < 0 ? 'bad' : 'good'
                    },
                    pension: {
                        value: hbCard.plan.pension
                    },
                    contribution: {
                        value: hbCard.plan.contribution
                    },
                    moved: {
                        value: Number(hbCard.moved) || 0
                    }
                }
            });
        }
        return rows;
    })();
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $81c96376e6bb9658$export$2e2bcd8739ae039), {
        title: isReoptimising ? 'Testing the ways again with your new answers...' : `Testing the ways to help ${household.names}`,
        subtitle: "We're working through a large number of simulated options - this may take a minute.",
        progress: progress,
        progressLabel: "Testing way"
    });
    const setupSeen = Boolean(factFind?.goals?.sahSetupSeen);
    const saveAnswersAndRun = ()=>{
        if (setFactFind) setFactFind((prev)=>({
                ...prev,
                ...hasStructures ? {
                    structureFundingInSuggestions: structureFundingInSuggestions
                } : {},
                goals: {
                    ...prev?.goals || {},
                    ...(0, $44d3c10f2c4813c3$export$c5611676613b360)(answers)
                }
            }));
        onLegacyYearsChange?.(answers.years);
        setQuestionsOpen(false);
        maybeRunAnalysis(true);
    };
    const questionsNode = (idPrefix)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44d3c10f2c4813c3$export$6fe4025a4076092f), {
                    value: answers,
                    onChange: setAnswers,
                    factFind: factFind,
                    bindingTest: bindingTest,
                    suggestedReserve: suggestedReserve,
                    debtTotal: clientLiabilities.reduce((s, l)=>s + l.balance, 0),
                    idPrefix: idPrefix,
                    guaranteedIncome: {
                        onGoals: writeGuaranteedIncomeGoals,
                        investable: annuityInvestable.amount,
                        madeOf: annuityInvestable.madeOf
                    }
                }),
                hasStructures && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "border-t border-slate-100 py-4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b389a33824abab17$export$bfd0f3f79aa7026b), {
                        value: structureFundingInSuggestions,
                        onChange: setStructureFundingInSuggestions
                    })
                }),
                shouldOfferContributionContextSwitch && contributionContextMode === 'linked' && availableAgedCareStrategies.length > 1 && !availableAgedCareStrategies.some((s)=>s.chosen) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "border-t border-slate-100 py-4",
                    "data-testid": "sah-q-linked",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-[15px] font-semibold text-slate-900",
                            children: "Which aged care plan is included?"
                        }),
                        contributionContextMode === 'linked' && availableAgedCareStrategies.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                            value: selectedAgedCareStrategyId ? String(selectedAgedCareStrategyId) : '',
                            onChange: (e)=>setSelectedAgedCareStrategyId(e.target.value || null),
                            className: "mt-2 w-full max-w-md rounded-lg border border-slate-300 px-3 py-2 text-[14px]",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "",
                                    children: "Choose the aged care plan\u2026"
                                }),
                                availableAgedCareStrategies.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: String(s.id),
                                        children: String(s.displayName || s.name)
                                    }, s.id))
                            ]
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-6",
        children: [
            showNewMoneyGate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a08e2ea281a6041$export$2e2bcd8739ae039), {
                onAnswer: answerNewMoneyProfile,
                onSkip: skipNewMoneyProfile,
                contextLine: "Some of the strategies I'll compare invest money that gets freed up \u2014 for example if downsizing your home is modelled."
            }),
            showTbcGate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $216ea083fe16cb8b$export$2e2bcd8739ae039), {
                name: (tbcPersonNeedingAnswer === 'partner' ? factFind?.partner?.firstName : factFind?.client?.firstName) || 'this person',
                onAnswer: answerTbc,
                onSkip: skipTbc
            }),
            !analysis && !error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
                "data-testid": "sah-questions-inline",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-[22px] font-bold leading-tight tracking-tight text-slate-900",
                        children: setupSeen ? 'Ready to test the ways to help' : 'Five questions before we test the ways to help'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-1 max-w-[72ch] text-[14px] leading-relaxed text-slate-600",
                        children: 'Our suggestions are filled in. Change any of them and the plans change with them; you can come back to these at any time under "Things that change the answer".'
                    }),
                    onBuildYourOwn && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d7fa4e176455787d$export$b506d3545e935872), {
                        onClick: ()=>onBuildYourOwn(null),
                        testId: "sah-build-own-top"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-2",
                        children: questionsNode('sahq')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-4 flex flex-wrap items-center justify-between gap-3",
                        children: [
                            onBuildYourOwn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>onBuildYourOwn(null),
                                className: "rounded-lg border border-slate-300 bg-white px-5 py-2.5 text-[15px] font-semibold text-slate-800 hover:border-blue-300 hover:bg-blue-50",
                                "data-testid": "sah-setup-build-own",
                                children: "Build a plan yourself instead"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                type: "button",
                                variant: "primary",
                                size: "lg",
                                onClick: saveAnswersAndRun,
                                disabled: isLinkedContextUnavailable,
                                "data-testid": "sah-run-plans",
                                children: "Test the ways to help"
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-xl border border-slate-200 border-l-4 border-l-rose-500 bg-white p-4 text-[14px] text-slate-700",
                role: "alert",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "font-semibold text-slate-900",
                        children: error
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            setError(null);
                            setQuestionsOpen(true);
                        },
                        className: "mt-1 font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                        children: "Change the answers and try again"
                    })
                ]
            }),
            analysis && analysis.strategies && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $854c582fbab4f7c2$export$2e2bcd8739ae039), {
                factFind: factFind,
                doNothing: analysis.doNothingStrategy || null,
                recommended: recommendedOptimal,
                strategies: analysis.allEvaluatedStrategies || analysis.strategies,
                waysTested: analysis.totalEvaluated || tableStrategies.length,
                horizonYears: answers.years,
                focus: optimisationFocus === 'all' ? 'legacy' : optimisationFocus,
                onFocus: (f)=>setOptimisationFocus(f),
                chosenName: chosenHere,
                onChoose: (row)=>{
                    choosePlan(row);
                },
                onExplain: (row)=>setExplainRow(row),
                onRisks: (row)=>setRiskStrategy(row),
                onWhy: (row, page)=>setFigureFor({
                        row: row,
                        page: page
                    }),
                onCareUp: (row)=>setCareUpRow(row),
                renderDetail: (row)=>renderStrategyDetail(row),
                onCompare: ()=>setShowGoalLeadersModal(true),
                onAllWays: ()=>setShowAllStrategiesTable(true),
                onSettings: ()=>setQuestionsOpen(true),
                onBuildYourOwn: (row)=>onBuildYourOwn?.(row),
                onAdvice: openAdviceDocument,
                guaranteedIncomeFor: (row)=>sahGuaranteedIncomeFor(row),
                notices: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        chosenForOtherServices && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700",
                            "data-testid": "sah-chosen-other-services",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                    className: "text-slate-900",
                                    children: [
                                        "\u201C",
                                        chosenForOtherServices,
                                        "\u201D is still ",
                                        household.possessive,
                                        " chosen plan, priced on the services as they were then."
                                    ]
                                }),
                                " These plans are tested on the services as they are now, so nothing here is chosen until you choose it; the earlier plan stays chosen until you do."
                            ]
                        }),
                        chosenOutOfDate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700",
                            "data-testid": "sah-chosen-out-of-date",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                    className: "text-slate-900",
                                    children: [
                                        "\u201C",
                                        chosenOutOfDate.title,
                                        "\u201D is still ",
                                        household.possessive,
                                        " chosen plan."
                                    ]
                                }),
                                " ",
                                chosenOutOfDate.reason.replace(/ — open it to choose again\.$/, '.'),
                                " Nothing here is chosen until you choose a plan."
                            ]
                        }),
                        (analysis.householdFingerprint ?? (applyLinkedAgedCareScenario ? 'before-whole-plan' : householdFingerprint)) !== householdFingerprint && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] text-slate-700",
                            "data-testid": "sah-plans-stale-household",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            className: "text-slate-900",
                                            children: applyLinkedAgedCareScenario ? 'These plans were tested before the aged care plan was carried in.' : 'These plans were tested with the aged care plan carried in.'
                                        }),
                                        " The figures below are for the household as it was then."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                    type: "button",
                                    variant: "secondary",
                                    size: "sm",
                                    onClick: ()=>runAnalysis(),
                                    children: "Test the plans again"
                                })
                            ]
                        }),
                        analysis.servicePlanFingerprint !== undefined && analysis.servicePlanFingerprint !== JSON.stringify(effectiveServicePlan ?? {}) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] text-slate-700",
                            "data-testid": "sah-plans-stale",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            className: "text-slate-900",
                                            children: "The services have changed since these plans were tested."
                                        }),
                                        " The figures below are for the services as they were."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                    type: "button",
                                    variant: "secondary",
                                    size: "sm",
                                    onClick: ()=>runAnalysis(),
                                    children: "Test again with the new services"
                                })
                            ]
                        }),
                        applyLinkedAgedCareScenario && effectiveAgedCareIntegration && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "rounded-xl border border-slate-200 bg-white px-4 py-3 text-[14px] text-slate-700",
                            "data-testid": "sah-plans-linked",
                            children: [
                                "These plans start from the chosen aged care plan, ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                    className: "text-slate-900",
                                    children: [
                                        "\u201C",
                                        selectedAgedCareStrategyForIntegration ? (0, $95e43332fd84eec4$export$6cc0d9545ae1511e)(selectedAgedCareStrategyForIntegration, factFind) : String(effectiveAgedCareIntegration.displayName || effectiveAgedCareIntegration.name || 'the aged care plan'),
                                        "\u201D"
                                    ]
                                }),
                                ", carried out in full: its deposit and everything else it does, and its yearly fees. What it uses and what is left is on the step before."
                            ]
                        })
                    ]
                })
            }),
            deferredSoa && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-3 rounded-lg border border-slate-200 bg-white px-4 py-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-sm text-slate-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold text-slate-900",
                                children: deferredSoa.saved.name || 'Your plan'
                            }),
                            " is saved as your plan. The advice document is ready when you want it."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        type: "button",
                        variant: "secondary",
                        size: "sm",
                        onClick: ()=>{
                            openDigitalSoaForSavedStrategy(deferredSoa.saved, deferredSoa.pending);
                        },
                        children: "Open the advice document"
                    })
                ]
            }),
            questionsOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                titleId: "sah-questions-heading",
                testId: "sah-questions-dialog",
                eyebrow: `Support at home for ${household.names}`,
                title: "Things that change the answer",
                intro: "Change any answer and the plans are tested again.",
                onClose: ()=>setQuestionsOpen(false),
                size: "lg",
                footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                            type: "button",
                            variant: "secondary",
                            onClick: ()=>setQuestionsOpen(false),
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                            type: "button",
                            variant: "primary",
                            onClick: saveAnswersAndRun,
                            disabled: isLinkedContextUnavailable,
                            children: "Test the ways again"
                        })
                    ]
                }),
                children: questionsNode('sahqd')
            }),
            showAssumptionsModal && analysis?.modellingAssumptions && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                titleId: "sah-assumptions-heading",
                title: "What the tests assume",
                intro: "The plans are modelled on these assumptions.",
                onClose: ()=>setShowAssumptionsModal(false),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                    className: "list-disc space-y-2 pl-5 text-[14px] text-slate-700",
                    children: assumptionsModalBullets.map((bullet, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: bullet.category && bullet.category !== 'Not factored in' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            bullet.category,
                                            ":"
                                        ]
                                    }),
                                    " ",
                                    bullet.text
                                ]
                            }) : bullet.text
                        }, idx))
                })
            }),
            showAllStrategiesTable && tableStrategies.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                titleId: "sah-all-ways-heading",
                testId: "sah-all-ways",
                eyebrow: `Support at home for ${household.names}`,
                title: `All ${tableStrategies.length} ways tested`,
                intro: "Every way tested, ranked by the figure you choose. Open one to see it year by year.",
                onClose: ()=>setShowAllStrategiesTable(false),
                size: "xl",
                flush: true,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-2 px-6 pt-4 text-[13px] text-slate-600",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                htmlFor: "sah-all-ways-sort",
                                children: "Ranked by"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                id: "sah-all-ways-sort",
                                value: allStrategiesSortBy,
                                onChange: (e)=>setAllStrategiesSortBy(e.target.value),
                                className: "rounded-lg border border-slate-300 bg-white px-2 py-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "legacy",
                                        children: "What is left to the family"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "cashflow",
                                        children: "Left over each year"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "pension",
                                        children: "Age Pension"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "overflow-x-auto px-6 pb-6 pt-3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "w-full border-collapse text-[14px]",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "border-b border-slate-200 text-[12.5px] font-semibold text-slate-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "py-2.5 pr-3 text-left",
                                                children: "Plan"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-3 py-2.5 text-right",
                                                children: "Left to the family"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-3 py-2.5 text-right",
                                                children: "Each year"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-3 py-2.5 text-right",
                                                children: "Age Pension"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                className: "py-2.5 pl-3 text-right",
                                                children: [
                                                    household.Their,
                                                    " contribution"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                    children: [
                                        analysis?.doNothingStrategy?.snapshot && (()=>{
                                            const f = (0, $ca9b5cdfbd99e645$export$122bd92e883ab7c1)(analysis.doNothingStrategy.snapshot);
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-200 text-slate-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-3 pr-3",
                                                        children: "The support alone"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-3 py-3 text-right tabular-nums",
                                                        children: formatCurrency(f.legacy)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-3 py-3 text-right tabular-nums",
                                                        children: f.cashflow < 0 ? `short ${formatCurrency(Math.abs(f.cashflow))}` : formatCurrency(f.cashflow)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-3 py-3 text-right tabular-nums",
                                                        children: formatCurrency(f.pension)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-3 pl-3 text-right tabular-nums",
                                                        children: formatCurrency(f.contribution)
                                                    })
                                                ]
                                            });
                                        })(),
                                        tableStrategies.map((s, idx)=>{
                                            const f = (0, $ca9b5cdfbd99e645$export$122bd92e883ab7c1)(s.snapshot || {});
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                onClick: ()=>{
                                                    setShowAllStrategiesTable(false);
                                                    setSelectedStrategyForDeepDive(s);
                                                    setDeepDiveModal(true);
                                                },
                                                className: "cursor-pointer border-b border-slate-100 hover:bg-slate-50",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "py-3 pr-3 font-medium text-slate-900",
                                                        children: [
                                                            wordsFor(s).title,
                                                            chosenHere === s.name && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "ml-2 text-[12px] font-semibold text-emerald-700",
                                                                children: "\u2713 Chosen"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-3 py-3 text-right tabular-nums",
                                                        children: formatCurrency(f.legacy)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: `px-3 py-3 text-right tabular-nums ${f.cashflow < 0 ? 'text-rose-700' : 'text-emerald-700'}`,
                                                        children: f.cashflow < 0 ? `short ${formatCurrency(Math.abs(f.cashflow))}` : `+${formatCurrency(f.cashflow)}`
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-3 py-3 text-right tabular-nums",
                                                        children: formatCurrency(f.pension)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-3 pl-3 text-right tabular-nums",
                                                        children: formatCurrency(f.contribution)
                                                    })
                                                ]
                                            }, `${s.name}-${idx}`);
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            showGoalLeadersModal && compareRows.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                titleId: "sah-compare-heading",
                testId: "sah-compare",
                eyebrow: "The best plan for each goal, and the support alone",
                title: "All the plans, side by side",
                intro: `Figures are for about ${answers.years} years, with the services priced on step 1. Open a plan to see it explained.`,
                onClose: ()=>setShowGoalLeadersModal(false),
                size: "xl",
                footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    type: "button",
                    onClick: ()=>{
                        setShowGoalLeadersModal(false);
                        setShowAllStrategiesTable(true);
                    },
                    className: "mr-auto text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                    children: [
                        "Show everything tested \u2014 all ",
                        tableStrategies.length,
                        " ways \u203A"
                    ]
                }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d8e44526b4d2fe9$export$2e2bcd8739ae039), {
                    testId: "sah-compare-table",
                    firstHeading: "Plan",
                    columns: [
                        {
                            key: 'bestFor',
                            label: 'Best for',
                            text: true
                        },
                        {
                            key: 'legacy',
                            label: 'Left to the family',
                            best: 'max',
                            headline: true
                        },
                        {
                            key: 'cf',
                            label: 'Each year',
                            best: 'max'
                        },
                        {
                            key: 'pension',
                            label: 'Age Pension a year',
                            best: 'max'
                        },
                        {
                            key: 'contribution',
                            label: `${household.Their} contribution a year`,
                            best: 'min'
                        },
                        {
                            key: 'moved',
                            label: 'Money moved',
                            bar: 'amber'
                        }
                    ],
                    rows: compareRows
                })
            }),
            explainRow && (()=>{
                const words = wordsFor(explainRow);
                const plan = (0, $ca9b5cdfbd99e645$export$122bd92e883ab7c1)(explainRow.snapshot || {});
                const doSentence = `${words.title}${words.sub ? ` \u{2014} ${words.sub.replace(/^Paid from /, 'paid from ').replace(/\.$/, '')}` : ''}.`;
                // Where a short year is drawn from, account by account, off this plan's own rows (as aged care's cards).
                const storyRows = explainRow.projections || [];
                const story = (0, $0fe89e03b6df746e$export$693cc3146baa3244)(storyRows).hasDeficit ? (0, $2ddaae90639b5011$export$bdea18f456fd84b)({
                    rows: storyRows,
                    factFind: factFind,
                    runway: (0, $0fe89e03b6df746e$export$464558962ff4a811)(storyRows, storyRows.length),
                    deposit: {
                        paid: 0,
                        refundTo: ''
                    },
                    horizonYears: answers.years,
                    enteringName: factFind?.client?.firstName || 'The household',
                    spentOn: 'the plan'
                }) : null;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $12084f898a868747$export$2e2bcd8739ae039), {
                    eyebrow: "Explain this",
                    title: words.title,
                    intro: `Each line says what ${household.they} do, and what that does to the numbers. ${(0, $1a5a24a0286ded56$export$c9c6ca79dc334e31).sentence}`,
                    onClose: ()=>setExplainRow(null),
                    footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        type: "button",
                        variant: "secondary",
                        onClick: ()=>{
                            const row = explainRow;
                            setExplainRow(null);
                            setSelectedStrategyForDeepDive(row);
                            setDeepDiveModal(true);
                        },
                        children: "See the year-by-year figures"
                    }),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca9b5cdfbd99e645$export$68e00db93a37b932), {
                            doSentence: doSentence,
                            treatment: words.treatment,
                            plan: plan,
                            baseline: baselineFigures,
                            horizonYears: answers.years,
                            possessive: household.their,
                            they: household.they,
                            drawLines: (0, $f7f18ba87194b6fe$export$29c4d395a04f1ae)((0, $f7f18ba87194b6fe$export$e0e75d1fdb5f788f)(explainRow.assetAllocation, factFind)),
                            moneyStory: story ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ddaae90639b5011$export$1a915263dc5391f1), {
                                story: story,
                                testId: "sah-money-story"
                            }) : null,
                            leverKinds: (0, $f7f18ba87194b6fe$export$caaafd80ea6c3706)(explainRow.config)
                        }),
                        (()=>{
                            // The debts this plan keeps, and what the same plan with them paid off did (sahDebtTwinOf).
                            const twin = (0, $afba33f9e18e15f2$export$6877ffd4a8923a8a)(explainRow, analysis?.allEvaluatedStrategies || analysis?.strategies || []);
                            const twinFigures = twin ? (0, $ca9b5cdfbd99e645$export$122bd92e883ab7c1)(twin.snapshot || {}) : null;
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe4e1ee5e30419ba$export$2e2bcd8739ae039), {
                                factFind: factFind,
                                clearedAmount: (0, $afba33f9e18e15f2$export$52f9380165cafdac)(explainRow.config),
                                plan: {
                                    estate: plan.legacy,
                                    cashflow: plan.cashflow,
                                    pension: plan.pension
                                },
                                twin: twinFigures ? {
                                    estate: twinFigures.legacy,
                                    cashflow: twinFigures.cashflow,
                                    pension: twinFigures.pension
                                } : null,
                                years: answers.years,
                                context: "tested"
                            });
                        })()
                    ]
                });
            })(),
            figureFor && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca9b5cdfbd99e645$export$e203066bca492ea1), {
                planTitle: wordsFor(figureFor.row).title,
                plan: (0, $ca9b5cdfbd99e645$export$122bd92e883ab7c1)(figureFor.row.snapshot || {}),
                baseline: baselineFigures,
                initialPage: figureFor.page,
                possessive: household.their,
                they: household.they,
                them: household.them,
                pensionWhy: pensionWhyWords,
                onYearByYear: ()=>{
                    setSelectedStrategyForDeepDive(figureFor.row);
                    setDeepDiveModal(true);
                },
                onClose: ()=>setFigureFor(null)
            }),
            careUpRow && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $16690ef87f6b41eb$export$2e2bcd8739ae039), {
                factFind: factFind,
                setFactFind: setFactFind,
                servicePlan: effectiveServicePlan,
                years: answers.years,
                supportStartDate: supportStartDate,
                savedStrategies: availableAgedCareStrategies,
                planTitle: wordsFor(careUpRow).title,
                strategyConfig: careUpRow.config,
                onClose: ()=>setCareUpRow(null)
            }),
            riskStrategy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5757b380cc124794$export$2e2bcd8739ae039), {
                strategyName: wordsFor(riskStrategy).title,
                voice: household,
                onClose: ()=>setRiskStrategy(null),
                risks: (0, $203e38d6e6c434f4$export$124603ee0434ece5)((0, $203e38d6e6c434f4$export$e1aeab26ad581b54)(riskStrategy.config?.type, String(riskStrategy.name || '')))
            }),
            deepDiveModal && selectedStrategyForDeepDive && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2d788b4d6c2de130$export$2e2bcd8739ae039), {
                strategy: selectedStrategyForDeepDive,
                factFind: factFind,
                onClose: ()=>setDeepDiveModal(false),
                estimatedServicePlanNote: analysis?.baseline?.servicePlanCosts?.isEstimated ? analysis.baseline.servicePlanCosts.estimatedDescription : servicePlanCosts.isEstimated ? servicePlanCosts.estimatedDescription : null
            })
        ]
    });
};
var $f870b25d8dcbe02f$export$2e2bcd8739ae039 = $f870b25d8dcbe02f$var$SupportAtHomeSuggestionEnginePanel;






/**
 * "Where {name} stands today" — the Support at Home starting-position anchor, between the case
 * facts and the mode chooser (owner direction, 2026-08-25: the insight panel's opening story —
 * current position, which test binds, and the restructure targets — belongs on the page, as a
 * headline with the depth behind taps, not as a wall of text).
 *
 * This is the SAH sibling of the aged care module's walk-in note: the position every strategy
 * below is implicitly compared against, stated where the reader is, and it cannot be closed.
 *
 * CALCULATION DISCIPLINE — the figures are the section's own `beforeFinancials` (the same snapshot
 * the contribution panel and Financial Impact read), and the targets come from
 * `calculateSahOptimizationTargets` — the SAME function the insight panel calls, extracted so the
 * two surfaces share one computation and can never disagree.
 */ 


parcelRequire("acw62");





const $e917fb170bd7792b$var$SahStartingPosition = ({ factFind: factFind, before: before, runwayHeadline: runwayHeadline = null, runwayDetail: runwayDetail = null, startingLegacy: startingLegacy = null, legacyYears: legacyYears = 5, onLegacyYearsChange: onLegacyYearsChange, careContribution: careContribution = null })=>{
    if (!before) return null;
    /** Cashflow after the service plan's contribution — what the heading and its tone are judged on. */ const cashFlowNet = before.cashFlow == null ? null : before.cashFlow - (careContribution?.amount ?? 0);
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const name = v.names;
    const isAre = v.are;
    const isCouple = factFind?.adviceFor === 'couple';
    const isHomeowner = (0, $d1b9bbc5238c0548$export$2f999b99c41ee933)(factFind);
    /*
     * A village or granny-flat resident is assessed on the "special residence" rule, and the page
     * says so (owner, 7 Oct 2026: "have you tested a client living in a granny flat ... or a
     * retirement village"): below the extra allowable amount they are a non-homeowner and what they
     * paid is a counted asset (a village resident is also paid Rent Assistance on the fees); above
     * it they are a homeowner and it is exempt.
     */ const position = (0, $d1b9bbc5238c0548$export$bdceaa91a7a2e637)(factFind, {});
    const residencyNote = position.rvResident ? position.rvIsHomeowner ? `The retirement village entry contribution (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(position.rvEntryContribution)}) is above the extra allowable amount, so ${name} ${isAre} assessed as a homeowner and it is not counted.` : `The retirement village entry contribution (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(position.rvEntryContribution)}) is at or below the extra allowable amount, so ${name} ${isAre} assessed as a non-homeowner: it is counted as an asset, and Rent Assistance is paid on the village fees.` : position.grannyFlatResident ? position.grannyFlatIsHomeowner ? `The granny flat interest is above the extra allowable amount, so ${name} ${isAre} assessed as a homeowner and what was paid for it is not counted.` : `The granny flat interest is at or below the extra allowable amount, so ${name} ${isAre} assessed as a non-homeowner and what was paid for it is counted as an asset.` : null;
    const illnessSeparated = (0, $ffc52726733f6151$export$cf0463a6434d3bec)(factFind, before, undefined, false);
    const data = (0, $ffc52726733f6151$export$5092ed2c4c8fd32)({
        assessableAssets: before.assessableAssets || 0,
        assessableIncome: before.totalAssessableIncome || 0,
        currentPension: before.socialSecurity || 0,
        isCouple: isCouple,
        isHomeowner: isHomeowner,
        illnessSeparatedForPension: illnessSeparated
    });
    const pension = data.currentPension;
    const fullTarget = data.targets.find((t)=>t.kind === 'full');
    const atFullPension = data.isAssetTestLimiting && (fullTarget?.reductionNeeded ?? 0) < 1 && pension > 0;
    const bindingWhy = data.isAssetTestLimiting ? `Both means tests are worked out and the LOWER answer wins. Here the assets test gives ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(data.pensionFromAssetTest)} a year and the income test ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(data.pensionFromIncomeTest)}, so it's the assets test setting the pension. That matters for strategy: moves that reduce COUNTED ASSETS \u{2014} ${isHomeowner ? 'money into the exempt home, ' : ''}an annuity (only 60% counted), gifting within the free areas, funeral bonds \u{2014} are the ones that lift it. Income-side moves won't, until the assets test stops binding.` : `Both means tests are worked out and the LOWER answer wins. Here the income test gives ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(data.pensionFromIncomeTest)} a year against the assets test's ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(data.pensionFromAssetTest)}, so it's the INCOME test setting the pension. That matters for strategy: reducing counted assets alone won't lift it \u{2014} what counts is reducing assessable income (for example, an annuity's deduction amount, or restructuring income-producing investments).`;
    /*
     * Bullet-point examples of shifting the dial (owner copy pass, 2026-08-25: "smaller steps" was
     * confusing; these are worked examples, said as such). Rendered with line breaks - the jargon
     * expansion box is whitespace-pre-line.
     */ const stepTargets = data.targets.filter((t)=>t.kind === 'increase' && t.achievable && (t.reductionNeeded ?? 0) > 0);
    const shiftExamples = [
        ...fullTarget && fullTarget.achievable && (fullTarget.reductionNeeded ?? 0) > 0 ? [
            `\u2022 The full pension: shift about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(fullTarget.reductionNeeded || 0)} \u2192 ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(fullTarget.targetPension)} a year (up ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(fullTarget.increase)}).`
        ] : [],
        ...stepTargets.slice(0, 2).map((t)=>`\u2022 A ${t.label.replace('Increase by ', '')} lift: shift about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(t.reductionNeeded || 0)} \u2192 ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(t.targetPension)} a year (up ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(t.increase)}).`)
    ].join('\n');
    const stepsText = shiftExamples ? `These are worked examples from the assets-test taper, not recommendations \u2014 they show the size of shift needed:\n${shiftExamples}\nThe strategies below are how the shifting actually happens \u2014 and the same shifts lower the contribution rates.` : '';
    return(/*
         * ONE DESIGN LANGUAGE ACROSS THE MODULES (owner, 2026-08-27: "where Baldo stands today looks
         * and feels very different to the Aged Care module").
         *
         * This said the same kinds of thing as the Aged Care walk-in note — where the client stands,
         * and what the strategies below are for — but as bolded run-in prose, so there was nothing
         * to scan and no way to fold it away once read. It now uses the shared PlainWordsBeat and
         * the shared collapse, so the two modules read as one product.
         *
         * The tones carry meaning, exactly as they do in Aged Care: `info` for the assessment (a
         * rule, not a result), `good` where there is genuinely room to improve, `neutral` where
         * there is not. Nothing here is amber: none of these beats is a "look at this".
         */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$28c8139bd562d0e), {
        eyebrow: `Where ${v.names} stand${v.s} today`,
        className: "mb-0",
        collapsible: true,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$97060599ed0e6525), {
                tone: "info",
                heading: "Age Pension today \u2014 what sets it",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "font-semibold text-slate-900",
                        children: [
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pension),
                            "/yr"
                        ]
                    }),
                    ". Centrelink counts",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(data.currentAssets)
                    }),
                    " of assets and",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "font-semibold text-slate-900",
                        children: [
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(data.currentIncome),
                            "/yr"
                        ]
                    }),
                    " of income \u2014 and it's the ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: data.isAssetTestLimiting ? 'assets test' : 'income test'
                    }),
                    ' ',
                    "setting the pension ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                        term: "(why does that matter?)",
                        children: bindingWhy
                    }),
                    residencyNote && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " ",
                            residencyNote
                        ]
                    })
                ]
            }),
            atFullPension ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$97060599ed0e6525), {
                tone: "good",
                heading: "Already at the full pension",
                children: [
                    v.Names,
                    " ",
                    v.are,
                    " already at the full pension \u2014 nothing to gain there, so the strategies below are about ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: "lowering the contribution rates"
                    }),
                    " and improving cashflow."
                ]
            }) : data.isAssetTestLimiting && fullTarget && !fullTarget.achievable ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$97060599ed0e6525), {
                tone: "neutral",
                heading: "The pension is out of reach \u2014 the rates are not",
                children: [
                    "Realistically the pension is out of reach here \u2014 it would take shifting more than the counted assets. But shifting assets",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: "still lowers the contribution rates"
                    }),
                    ", so the strategies below are about paying less for care, cashflow and the estate."
                ]
            }) : data.isAssetTestLimiting && fullTarget && (fullTarget.reductionNeeded ?? 0) > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$97060599ed0e6525), {
                tone: "good",
                heading: "Room to move \u2014 the pension and the rates together",
                children: [
                    "Shifting counted assets",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: "lifts the Age Pension"
                    }),
                    " and",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: "lowers the Support at Home contribution rates"
                    }),
                    ' ',
                    "at the same time \u2014 the full pension is about",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(fullTarget.reductionNeeded || 0)
                    }),
                    ' ',
                    "of shifting away",
                    stepsText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                term: "(what shifting assets could do \u203A)",
                                children: stepsText
                            })
                        ]
                    })
                ]
            }) : !data.isAssetTestLimiting ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$97060599ed0e6525), {
                tone: "neutral",
                heading: "The income test is what limits the pension",
                children: [
                    "Because the income test is what's limiting the pension, reducing assets alone won't lift it \u2014 strategies that reduce ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: "counted income"
                    }),
                    " are what matter for the pension here (though reducing assets can still lower the",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: "contribution rates"
                    }),
                    ")."
                ]
            }) : null,
            (before.cashFlow != null || runwayHeadline) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$97060599ed0e6525), {
                tone: (cashFlowNet ?? 0) < 0 ? 'warn' : 'good',
                heading: (cashFlowNet ?? 0) < 0 ? "Cashflow today \u2014 income does not cover it" : "Cashflow today \u2014 income covers it",
                children: [
                    before.cashFlow != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "Money in, less money out, is",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold text-slate-900",
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(before.cashFlow)
                            }),
                            " a year before any care costs.",
                            ' '
                        ]
                    }),
                    careContribution && before.cashFlow != null && careContribution.amount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            careContribution.planName ? `\u{201C}${careContribution.planName}\u{201D}` : 'The service plan',
                            " costs",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold text-slate-900",
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(careContribution.amount)
                            }),
                            " a year in contributions, leaving",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold text-slate-900",
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(before.cashFlow - careContribution.amount)
                            }),
                            ".",
                            ' '
                        ]
                    }),
                    careContribution && before.cashFlow != null && careContribution.amount === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "At these rates ",
                            careContribution.planName ? `\u{201C}${careContribution.planName}\u{201D}` : 'the service plan',
                            " costs nothing in contributions, so that figure stands.",
                            ' '
                        ]
                    }),
                    runwayHeadline && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "font-semibold text-slate-900",
                                children: [
                                    runwayHeadline,
                                    "."
                                ]
                            }),
                            runwayDetail ? ` ${runwayDetail}` : ''
                        ]
                    })
                ]
            }),
            startingLegacy != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$97060599ed0e6525), {
                tone: "neutral",
                heading: onLegacyYearsChange ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9873a6fbc9fd360$export$68741d4d7bc37a6d), {
                    years: legacyYears,
                    onChange: onLegacyYearsChange,
                    before: "Estate after",
                    after: " \u2014 with no plan"
                }) : `Estate after ${legacyYears} ${legacyYears === 1 ? 'year' : 'years'} \u{2014} with no plan`,
                children: [
                    "On today's position and no strategy, the projection leaves",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(startingLegacy)
                    }),
                    ". That is the figure every strategy below is measured against, not today's net worth \u2014 the care is happening either way, so the comparison has to be with doing it unplanned."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-[11px] text-slate-400",
                children: "The same assessment sets the contribution rates shown on the right. The strategies below exist to move these numbers."
            })
        ]
    }));
};
var $e917fb170bd7792b$export$2e2bcd8739ae039 = $e917fb170bd7792b$var$SahStartingPosition;





/**
 * WHICH SERVICE PLAN a saved Support at Home strategy was priced against.
 *
 * WHY THIS EXISTS. A Support at Home strategy's headline dollar — "your share of care costs falls
 * to $3,929 a year" — is `budget x contribution rate`. Optimising moves the RATE; the Service
 * Builder sets the BUDGET. So a saved strategy's rates survive a change of services, and its
 * DOLLARS do not.
 *
 * Nothing recorded which plan a strategy had been priced against, so build → optimise → save → go
 * back and adjust the services left that saved figure quietly stale, with nothing on screen saying
 * so. Owner-flagged 2026-08-27 while deciding whether to put the Service Builder before Optimise —
 * and putting it first makes that path MORE common, not less, which is why this lands first.
 *
 * The basis is deliberately a summary, not the plan itself: what matters is whether the money has
 * moved, and a saved record should not carry a copy of a document that lives elsewhere. Two plans
 * with the same service count and the same annual value price identically, which is the only
 * question this has to answer.
 */ 
/**
 * Service Builder cost arithmetic, pure and testable.
 *
 * THE PROGRAM-RULES ASSUMPTION THIS ENCODES (owner question, 2026-08-25; recorded in the
 * legislation register): a Support at Home participant can buy services BEYOND their funded
 * package, privately, at FULL price. The government subsidy and the category contribution rates
 * (clinical 0%, independence %, everyday living %) apply only to services WITHIN the budget;
 * above it there is no subsidy and no contribution framework — the household simply pays the
 * provider's price. Before this split, the builder charged the contribution rate on EVERYTHING
 * selected, so an over-budget plan looked almost free ($59 of contribution on a plan $21k over
 * its package) and the projections missed the private cost entirely.
 *
 * FUNDED-SHARE ALLOCATION: which selected services are "the funded ones" is the participant's and
 * provider's choice, not something this model can know. The split is therefore PRO-RATA: the
 * package funds budget/total of the plan, and the contribution applies to that share of each
 * category. Simple, explainable, and neutral between categories.
 */ function $5fb3dd4f28b6f196$export$436317f0a4e6f4d7(quantity, freqType) {
    const numericQuantity = Number(quantity);
    if (!quantity || numericQuantity <= 0) return 0;
    switch(freqType){
        case 'daily':
            return numericQuantity * 365 / 12; // 365 days a year (was 30 a month)
        case 'weekly':
            return numericQuantity * 52 / 12; // 52 weeks a year (was 4 a month, 8% short)
        case 'monthly':
            return numericQuantity;
        default:
            return numericQuantity;
    }
}
function $5fb3dd4f28b6f196$export$f1798fc2c7adaf45(servicesMap, rates, catalog) {
    let totalClinical = 0;
    let totalIndependence = 0;
    let totalEveryday = 0;
    Object.entries(servicesMap || {}).forEach(([serviceId, data])=>{
        if (!data || !data.quantity || Number(data.quantity) <= 0) return;
        const monthlyQuantity = $5fb3dd4f28b6f196$export$436317f0a4e6f4d7(data.quantity, data.frequency || 'monthly');
        Object.values(catalog).forEach((category)=>{
            const service = category.services.find((s)=>s.id === serviceId);
            if (service) {
                const cost = service.medianPrice * monthlyQuantity * 12; // annual
                if (category.label === 'Clinical Care') totalClinical += cost;
                else if (category.label === 'Independence Services') totalIndependence += cost;
                else if (category.label === 'Everyday Living Services') totalEveryday += cost;
            }
        });
    });
    const independenceContribution = totalIndependence * (rates.independence || 0);
    const everydayContribution = totalEveryday * (rates.everydayLiving || 0);
    return {
        totalClinical: totalClinical,
        totalIndependence: totalIndependence,
        totalEveryday: totalEveryday,
        total: totalClinical + totalIndependence + totalEveryday,
        contribution: {
            clinical: 0,
            independence: independenceContribution,
            everyday: everydayContribution,
            total: independenceContribution + everydayContribution
        }
    };
}
function $5fb3dd4f28b6f196$export$566a243694983797(costs, budget) {
    const safeBudget = Math.max(0, budget || 0);
    const privateExcess = Math.max(0, costs.total - safeBudget);
    const fundedShare = costs.total > 0 ? Math.min(1, safeBudget / costs.total) : 0;
    const fundedContribution = costs.contribution.total * fundedShare;
    return {
        fundedContribution: fundedContribution,
        privateExcess: privateExcess,
        total: fundedContribution + privateExcess,
        fundedShare: fundedShare
    };
}


function $ef2004df8b6bc275$export$9adf410dad564b4(plan) {
    const sides = [
        plan?.client,
        plan?.partner
    ];
    return sides.reduce((acc, side)=>{
        const costs = (0, $5fb3dd4f28b6f196$export$f1798fc2c7adaf45)(side || {}, {}, (0, $25e9acc02c907060$export$a3b71735b810a98c));
        return {
            clinical: acc.clinical + (costs.totalClinical || 0),
            independence: acc.independence + (costs.totalIndependence || 0),
            everyday: acc.everyday + (costs.totalEveryday || 0)
        };
    }, {
        clinical: 0,
        independence: 0,
        everyday: 0
    });
}
const $ef2004df8b6bc275$var$countSide = (side)=>Object.values(side || {}).filter((d)=>d && Number(d.quantity) > 0).length;
const $ef2004df8b6bc275$var$valueSide = (side)=>(0, $5fb3dd4f28b6f196$export$f1798fc2c7adaf45)(side || {}, {}, (0, $25e9acc02c907060$export$a3b71735b810a98c)).total;
function $ef2004df8b6bc275$export$5985497ca15872b4(plan, isEstimated) {
    return {
        serviceCount: $ef2004df8b6bc275$var$countSide(plan?.client) + $ef2004df8b6bc275$var$countSide(plan?.partner),
        annualValue: Math.round($ef2004df8b6bc275$var$valueSide(plan?.client) + $ef2004df8b6bc275$var$valueSide(plan?.partner)),
        isEstimated: isEstimated
    };
}
function $ef2004df8b6bc275$export$8ec791c5a98e7b0b(saved, current) {
    if (!saved || !current) return false;
    // A dollar of rounding is not a change of plan; a service added or removed always is.
    return saved.serviceCount !== current.serviceCount || Math.abs(saved.annualValue - current.annualValue) > 1;
}
function $ef2004df8b6bc275$export$1994f7e9faf3aa57(saved, current) {
    if (!$ef2004df8b6bc275$export$8ec791c5a98e7b0b(saved, current)) return null;
    const from = saved;
    const to = current;
    const movedTo = to.isEstimated ? 'the illustrative package' : 'the current service plan';
    return `Priced against a service plan worth ${$ef2004df8b6bc275$var$formatDollars(from.annualValue)} a year (${from.serviceCount} ` + `${from.serviceCount === 1 ? 'service' : 'services'}). ${$ef2004df8b6bc275$var$capitalise(movedTo)} is now ` + `${$ef2004df8b6bc275$var$formatDollars(to.annualValue)} a year (${to.serviceCount} ${to.serviceCount === 1 ? 'service' : 'services'}), ` + `so the contribution figures below are out of date. The rates still hold \u{2014} it is the dollars they apply to that moved.`;
}
const $ef2004df8b6bc275$var$formatDollars = (n)=>`$${Math.round(n).toLocaleString('en-AU')}`;
const $ef2004df8b6bc275$var$capitalise = (s)=>s.charAt(0).toUpperCase() + s.slice(1);














/** Picker value for builder selections that were never saved as a named plan. */ const $d6188f49626b9d12$var$UNSAVED_PLAN_OPTION = '__unsaved__';
const $d6188f49626b9d12$var$StrategiesSection = ({ factFind: factFind, setFactFind: setFactFind, strategyMode: strategyMode = 'manual', setStrategyMode: setStrategyMode, onNavigateToBuilder: onNavigateToBuilder, onNavigateToDashboard: onNavigateToDashboard, supportStartDate: supportStartDate = '', onSoaGenerated: onSoaGenerated, onReopen: onReopen, stepped: stepped = false })=>{
    // Calculate participant type and other variables needed for contribution calculations
    const isPartnered = factFind?.adviceFor === 'couple';
    const defaultParticipantType = factFind?.careNeeds?.clientAcat?.status === 'yes' && factFind?.careNeeds?.clientAcat?.homeCareLevel ? isPartnered ? 'couple' : 'single' : isPartnered ? 'couple_partner' : 'single';
    const defaultNwopCategory = factFind?.careNeeds?.clientAcat?.nwopCategory || 'standard';
    const defaultPreviousITCF = factFind?.careNeeds?.clientAcat?.previousITCF || 0;
    const [participantType] = (0, $acw62.useState)(defaultParticipantType);
    const [nwopCategory] = (0, $acw62.useState)(defaultNwopCategory);
    const [meansDisclosed] = (0, $acw62.useState)(true);
    const [previousITCF] = (0, $acw62.useState)(defaultPreviousITCF);
    // Read restored strategy once at the top level (before useState calls)
    // Only restore if explicitly set (from Dashboard reopen), not from leftover sessionStorage
    const restoredStrategy = (()=>{
        try {
            const stored = typeof window !== 'undefined' ? sessionStorage.getItem('careCompanionRestoreHomeCareStrategy') : null;
            if (stored) {
                const strategy = JSON.parse(stored);
                // Only restore if this is a saved strategy (has an id), not just leftover state
                // This prevents restoring unsaved strategies from previous sessions
                if (strategy.id) {
                    sessionStorage.removeItem('careCompanionRestoreHomeCareStrategy');
                    return strategy;
                } else // Clear leftover unsaved strategy data
                sessionStorage.removeItem('careCompanionRestoreHomeCareStrategy');
            }
        } catch (error) {
            console.error('Error restoring home care strategy:', error);
            // Clear corrupted data
            if (typeof window !== 'undefined') sessionStorage.removeItem('careCompanionRestoreHomeCareStrategy');
        }
        return null;
    })();
    // NO MODE CHOOSER (owner, 19 Oct 2026, the aged care ruling of 17 Oct): the tested plans are this
    // step and Manual Control is a link under them. A self-built plan reopened from Home goes straight
    // to Manual Control (its levers are what was reopened); everything else opens on the tested plans.
    const restoredIsManual = Boolean(restoredStrategy && restoredStrategy.source !== 'suggestion_engine');
    const [internalStrategyMode, setInternalStrategyMode] = (0, $acw62.useState)(restoredIsManual ? 'manual' : strategyMode === 'manual' ? 'manual' : 'suggestion');
    const strategyModeSyncedRef = (0, $acw62.useRef)(false);
    /** Which Support at Home suggestion-engine card is visually selected (matches Aged Care behaviour). */ const [sahSeSelectedStrategy, setSahSeSelectedStrategy] = (0, $acw62.useState)(null);
    /** A just-saved manual strategy plus its projections as they stood at save time — the offer to
     * generate its Digital SOA (the save reset wipes the live state, so this is captured first). */ const [manualSoaOffer, setManualSoaOffer] = (0, $acw62.useState)(null);
    /** "Maybe later" was chosen: the offer folds to one line instead of disappearing. */ const [manualSoaDeferred, setManualSoaDeferred] = (0, $acw62.useState)(false);
    /**
     * "Get the advice document" for the plan built by hand. The record captured when it was chosen,
     * or — on a later visit, when that capture is gone — the chosen record on file for these same
     * levers, with the projection on screen now (it is the same plan, priced the same way).
     */ const openManualDigitalSoa = async ()=>{
        const fromFile = manualSoaOffer ? null : savedHomeCareStrategies.find(isChosenManualPlan);
        const offer = manualSoaOffer ?? (fromFile ? {
            strategy: fromFile,
            projections: (projectionsForModal || projections) ?? null
        } : null);
        if (!offer) return;
        const snapshot = await (0, $39348679b8be0d72$export$87f72c2469f493ab)({
            selectedStrategy: offer.strategy,
            factFind: factFind,
            projections: offer.projections,
            analysis: null,
            servicePlan: (0, $08809b7a4fc47e27$export$ccf1a1f8e00c427e)(),
            strategySource: 'manual_control',
            // With the support alone, for the guaranteed income's "the same plan without it" column (sahGuaranteedIncome.ts).
            doNothingRows: sahDoNothingRun.rows ?? null,
            // A partner's aged care plan carried into the figures, said in the document (24 Oct 2026).
            linkedCare: selectedAgedCareStrategy ? await (0, $5ea55f03cd2af1e4$export$816274d728d58b8d)(factFind, selectedAgedCareStrategy) : null
        });
        if (snapshot) {
            const document = {
                ...offer.strategy,
                soaSnapshot: snapshot
            };
            (0, $dabe6813042a6e48$export$e66848783651d59b)(document);
            onSoaGenerated?.(document);
            (0, $39348679b8be0d72$export$d13a73f2d338923d)(snapshot);
        }
        setManualSoaOffer(null);
    };
    /** When true in suggestion mode, unblur the right column and show fact-find baseline only (AC parity). */ const [showBaseline, setShowBaseline] = (0, $acw62.useState)(false);
    const [sahSeAnalyzing, setSahSeAnalyzing] = (0, $acw62.useState)(false);
    const [savedHomeCareStrategies, setSavedHomeCareStrategies] = (0, $acw62.useState)(()=>(0, $dabe6813042a6e48$export$181dd2d22327a6cc)());
    // Update internal state when prop changes
    // The first run tells the page which mode this mount opened in (a reopened self-built plan opens
    // Manual Control whatever the page held); later runs follow the page.
    (0, $acw62.useEffect)(()=>{
        if (!strategyModeSyncedRef.current) {
            strategyModeSyncedRef.current = true;
            if (setStrategyMode && strategyMode !== internalStrategyMode) setStrategyMode(internalStrategyMode);
            return;
        }
        if (strategyMode === 'manual' || strategyMode === 'suggestion') setInternalStrategyMode(strategyMode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        strategyMode
    ]);
    // Update parent when internal state changes (if setStrategyMode prop provided)
    const handleStrategyModeChange = (mode)=>{
        setInternalStrategyMode(mode);
        if (mode === 'manual') {
            setSahSeSelectedStrategy(null);
            setShowBaseline(false);
            setSahSeAnalyzing(false);
        }
        if (setStrategyMode) setStrategyMode(mode);
    };
    (0, $acw62.useEffect)(()=>{
        const refreshSavedStrategies = ()=>setSavedHomeCareStrategies((0, $dabe6813042a6e48$export$181dd2d22327a6cc)());
        refreshSavedStrategies();
        if (typeof window !== 'undefined') window.addEventListener((0, $f58ff7d3c4c676c4$export$f2d0abffc7f79a5c), refreshSavedStrategies);
        return ()=>{
            if (typeof window !== 'undefined') window.removeEventListener((0, $f58ff7d3c4c676c4$export$f2d0abffc7f79a5c), refreshSavedStrategies);
        };
    }, []);
    const [manualStrategies, setManualStrategies] = (0, $acw62.useState)(()=>{
        // Restore manual strategies from saved strategy
        if (restoredStrategy?.inputs) return {
            gifting: Number(restoredStrategy.inputs.gifting) || 0,
            funeralBonds: Number(restoredStrategy.inputs.funeralBonds) || 0,
            giftingSource: restoredStrategy.inputs.giftingSource || 'bank',
            funeralSource: restoredStrategy.inputs.funeralSource || 'bank'
        };
        return {
            gifting: 0,
            funeralBonds: 0,
            giftingSource: 'bank',
            funeralSource: 'bank'
        };
    });
    const [propertyStrategy, setPropertyStrategy] = (0, $acw62.useState)(restoredStrategy?.inputs?.propertyStrategy || 'none'); // 'none', 'downsize', 'renovate', 'upgrade', 'reverseMortgage', 'heas'
    const [annuityRecord, setAnnuityRecord] = (0, $acw62.useState)(restoredStrategy?.inputs?.annuityRecord || null);
    const [overallStrategy, setOverallStrategy] = (0, $acw62.useState)(restoredStrategy?.inputs?.overallStrategy || {});
    const [downsizeDetails, setDownsizeDetails] = (0, $acw62.useState)(()=>{
        if (restoredStrategy?.inputs?.downsizeDetails) return restoredStrategy.inputs.downsizeDetails;
        return {
            salePrice: factFind?.home?.value || 0,
            sellingCosts: (Number(factFind?.home?.value) || 0) * 0.025,
            newHomePurchasePrice: 0,
            downsizerContribution: 0,
            partnerDownsizerContribution: 0,
            giftingAmount: 0,
            funeralBondPurchase: 0,
            addedAssets: []
        };
    });
    const [renovateDetails, setRenovateDetails] = (0, $acw62.useState)(()=>{
        return restoredStrategy?.inputs?.renovateDetails || {
            renovationAmount: 0,
            fundingSources: []
        };
    });
    const [upgradeDetails, setUpgradeDetails] = (0, $acw62.useState)(()=>{
        if (restoredStrategy?.inputs?.upgradeDetails) return restoredStrategy.inputs.upgradeDetails;
        return {
            currentHomeValue: parseFloat(String(factFind.home?.value)) || 0,
            newHomePurchasePrice: 0,
            sellingCosts: 0,
            fundingSources: []
        };
    });
    const [reverseMortgageDetails, setReverseMortgageDetails] = (0, $acw62.useState)(()=>{
        return restoredStrategy?.inputs?.reverseMortgageDetails || {
            loanAmount: 0,
            loanPercentage: 0,
            interestRate: (0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279),
            loanStructure: 'lump_sum',
            regularPaymentAmount: 0,
            regularPaymentFrequency: 'fortnightly',
            establishmentFees: 0
        };
    });
    const [heasDetails, setHeasDetails] = (0, $acw62.useState)(()=>{
        return restoredStrategy?.inputs?.heasDetails || {
            paymentAmount: 0,
            paymentFrequency: 'fortnightly',
            interestRate: 3.95
        };
    });
    const [availableAgedCareStrategies, setAvailableAgedCareStrategies] = (0, $acw62.useState)([]);
    const [selectedAgedCareStrategyId, setSelectedAgedCareStrategyId] = (0, $acw62.useState)(restoredStrategy?.inputs?.selectedAgedCareStrategyId || null);
    const [selectedFundingStrategy, setSelectedFundingStrategy] = (0, $acw62.useState)(restoredStrategy?.inputs?.selectedFundingStrategy || null);
    // 10 years, as in downsizing, granny flat, the village and cashflow (owner, 19 Oct 2026: "10 years
    // makes sense"; aged care alone keeps its age-and-health horizon, being the outlier on life expectancy).
    const [legacyYears, setLegacyYears] = (0, $acw62.useState)(10);
    const [showProjectionsModal, setShowProjectionsModal] = (0, $acw62.useState)(false);
    const [resetTrigger, setResetTrigger] = (0, $acw62.useState)(0);
    const [showCompareModal, setShowCompareModal] = (0, $acw62.useState)(false);
    const [optimiseStrategyName, setOptimiseStrategyName] = (0, $acw62.useState)('');
    const [optimiseStrategyNameError, setOptimiseStrategyNameError] = (0, $acw62.useState)('');
    // Load saved aged care strategies for integration
    (0, $acw62.useEffect)(()=>{
        const refreshStrategies = ()=>{
            try {
                const stored = typeof window !== 'undefined' ? sessionStorage.getItem('careCompanionStrategies') : null;
                if (!stored) {
                    setAvailableAgedCareStrategies([]);
                    return;
                }
                const parsed = JSON.parse(stored);
                const agedCareList = Array.isArray(parsed) ? parsed.filter((strategy)=>strategy?.type === 'aged_care') : [];
                setAvailableAgedCareStrategies(agedCareList);
            } catch (error) {
                console.error('Error loading aged care strategies for integration:', error);
                setAvailableAgedCareStrategies([]);
            }
        };
        refreshStrategies();
        const handleStorage = (event)=>{
            if (!event || event.key === 'careCompanionStrategies') refreshStrategies();
        };
        if (typeof window !== 'undefined') window.addEventListener('storage', handleStorage);
        return ()=>{
            if (typeof window !== 'undefined') window.removeEventListener('storage', handleStorage);
        };
    }, []);
    // Step 1's "Yes — X is moving into aged care" includes the chosen aged care plan here too, unless
    // a plan built by hand already says which (sahEngineContext.ts). "No" leaves it out.
    (0, $acw62.useEffect)(()=>{
        if (restoredStrategy) return;
        const answer = (0, $5ea55f03cd2af1e4$export$12c4b1871639c9ac)(factFind);
        if (answer === 'yes' && !selectedAgedCareStrategyId) {
            const chosen = (0, $5ea55f03cd2af1e4$export$b164904e0d858bed)(availableAgedCareStrategies);
            if (chosen?.id != null) setSelectedAgedCareStrategyId(chosen.id);
        } else if (answer !== 'yes' && selectedAgedCareStrategyId && answer != null) setSelectedAgedCareStrategyId(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        availableAgedCareStrategies,
        factFind?.goals?.sahAgedCareMove
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!selectedAgedCareStrategyId) return;
        const exists = availableAgedCareStrategies.some((strategy)=>strategy.id === selectedAgedCareStrategyId);
        if (!exists) setSelectedAgedCareStrategyId(null);
    }, [
        availableAgedCareStrategies,
        selectedAgedCareStrategyId
    ]);
    const selectedAgedCareStrategy = (0, $acw62.useMemo)(()=>{
        if (!selectedAgedCareStrategyId) return null;
        return availableAgedCareStrategies.find((strategy)=>strategy.id === selectedAgedCareStrategyId) || null;
    }, [
        availableAgedCareStrategies,
        selectedAgedCareStrategyId
    ]);
    const selectedAgedCareIntegration = (0, $acw62.useMemo)(()=>{
        return (0, $87af0cc4cc4e8984$export$2fdaec60121ed226)(selectedAgedCareStrategy);
    }, [
        selectedAgedCareStrategy
    ]);
    /*
     * THE WHOLE AGED CARE PLAN, here as in the engine (owner, 24 Oct 2026; Manual Control parity). The
     * household a hand-built plan starts from is the linked aged care plan carried out — every piece of it,
     * its living costs — and the plan's own levers go on top. The deposit is then not paid a second time.
     * When the plan cannot be rebuilt, the deposit alone is applied, as before.
     */ const linkedPosition = (0, $1daac60e43adbfd2$export$a8613b2591a1f51b)(factFind, selectedAgedCareStrategy);
    /*
     * WORKING IT OUT (25 Oct 2026): the rail's figures come from a chain of calculations — the household after the
     * aged care plan, the position, the contributions, the projections and "doing nothing" beside them. While any is
     * in flight the rail says so instead of mixing new figures with old ones (utils/calcTracker.ts).
     */ const { track: trackSah, working: sahCalcWorking } = (0, $a8ad6b8c257d1221$export$66e981b52ef0ad9f)();
    const sahRailWorking = sahCalcWorking || !linkedPosition.ready;
    const householdFactFind = (0, $acw62.useMemo)(()=>selectedAgedCareIntegration && linkedPosition.positioned ? (0, $5ea55f03cd2af1e4$export$696453b4446851c9)(factFind, selectedAgedCareIntegration, undefined, linkedPosition.positioned) : factFind, [
        factFind,
        selectedAgedCareIntegration,
        linkedPosition.positioned
    ]);
    const integrationForPlan = (0, $acw62.useMemo)(()=>selectedAgedCareIntegration && linkedPosition.positioned ? {
            ...selectedAgedCareIntegration,
            radFunding: null
        } : selectedAgedCareIntegration, [
        selectedAgedCareIntegration,
        linkedPosition.positioned
    ]);
    const agedCareResidencyOverrides = (0, $acw62.useMemo)(()=>{
        if (!selectedAgedCareIntegration) return {};
        const fromLinkedStrategy = selectedAgedCareIntegration?.strategyOptions || {};
        const linkedOverrides = {
            ...fromLinkedStrategy?.clientResidencyOverride ? {
                clientResidencyOverride: fromLinkedStrategy.clientResidencyOverride
            } : {},
            ...fromLinkedStrategy?.partnerResidencyOverride ? {
                partnerResidencyOverride: fromLinkedStrategy.partnerResidencyOverride
            } : {}
        };
        if (Object.keys(linkedOverrides).length > 0) return linkedOverrides;
        return (0, $8eecd0af141b9afb$export$7b84565bbb0eef12)(factFind);
    }, [
        selectedAgedCareIntegration,
        factFind
    ]);
    /*
     * Who moves into care under the linked plan, and whether that makes the household an
     * illness-separated couple — derived from the SAME residency overrides the calculations run
     * with, so the words can never disagree with the figures (the aged care module's frame rule).
     */ const integrationSummary = (0, $acw62.useMemo)(()=>{
        if (!selectedAgedCareIntegration) return null;
        const overrides = selectedAgedCareIntegration?.strategyOptions || {};
        const partnerInCare = overrides.partnerResidencyOverride === 'aged_care';
        const clientInCare = overrides.clientResidencyOverride === 'aged_care' || !partnerInCare;
        const personName = (clientInCare ? factFind?.client?.firstName : factFind?.partner?.firstName) || (clientInCare ? 'the client' : 'their partner');
        const illnessSeparated = factFind?.adviceFor === 'couple' && (0, $8eecd0af141b9afb$export$9b95c99516118f10)(factFind, agedCareResidencyOverrides);
        return {
            name: String(selectedAgedCareStrategy?.name || 'aged care plan'),
            personName: personName,
            annualFees: Number(selectedAgedCareIntegration.annualCost) || 0,
            radPaid: Number(selectedAgedCareIntegration.radPaid) || 0,
            illnessSeparated: illnessSeparated
        };
    }, [
        selectedAgedCareIntegration,
        selectedAgedCareStrategy,
        factFind,
        agedCareResidencyOverrides
    ]);
    // Save selected strategy to sessionStorage so ServiceBuilderSection can access it
    (0, $acw62.useEffect)(()=>{
        if (selectedAgedCareStrategy && typeof window !== 'undefined') sessionStorage.setItem('careCompanionSelectedAgedCareStrategy', JSON.stringify(selectedAgedCareStrategy));
        else if (!selectedAgedCareStrategy && typeof window !== 'undefined') sessionStorage.removeItem('careCompanionSelectedAgedCareStrategy');
    }, [
        selectedAgedCareStrategy
    ]);
    const hasAgedCareStrategies = availableAgedCareStrategies.length > 0;
    // Calculate available annuity funding sources
    const availableAnnuityFundingSources = (0, $acw62.useMemo)(()=>{
        const sources = [];
        const formatter = new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
        const clientName = factFind?.client?.firstName || 'Client';
        const partnerName = factFind?.partner?.firstName || 'Partner';
        const ownershipLabel = (ownership)=>{
            if (!ownership) return '';
            if (ownership === 'joint') return 'Joint';
            if (ownership === 'partner') return partnerName;
            return clientName;
        };
        const pushSource = (type, asset, amount, fallbackLabel)=>{
            const numericAmount = parseFloat(String(amount)) || 0;
            if (numericAmount <= 0) return; // Only include sources with value
            const ownership = asset?.ownership || (factFind?.adviceFor === 'couple' ? 'joint' : 'client');
            const label = `${fallbackLabel}${ownership ? ` (${ownershipLabel(ownership)})` : ''} \u{2013} ${formatter.format(numericAmount)}`;
            sources.push({
                id: asset?.id ? `${type}-${asset.id}` : `${type}-${fallbackLabel}`,
                type: type,
                assetId: asset?.id ?? asset?.accountId ?? null,
                label: label,
                ownership: ownership
            });
        };
        // Use optimized factFind that includes property strategy + aged care integration changes (the
        // whole linked aged care plan, when it could be rebuilt).
        let formDataForFunding = householdFactFind;
        // Apply property strategies to factFind for funding source calculation
        if (propertyStrategy === 'downsize' && Number(downsizeDetails.salePrice) > 0) {
            const netProceeds = (parseFloat(String(downsizeDetails.salePrice)) || 0) - (parseFloat(String(downsizeDetails.sellingCosts)) || 0);
            const totalAllocated = (parseFloat(String(downsizeDetails.newHomePurchasePrice)) || 0) + (parseFloat(String(downsizeDetails.downsizerContribution)) || 0) + (parseFloat(String(downsizeDetails.partnerDownsizerContribution)) || 0) + (parseFloat(String(downsizeDetails.giftingAmount)) || 0) + (parseFloat(String(downsizeDetails.debtRepayment)) || 0);
            const unallocatedProceeds = netProceeds - totalAllocated;
            if (unallocatedProceeds > 0) sources.push({
                id: 'downsize-proceeds',
                type: 'bank',
                assetId: null,
                label: `Home Sale Proceeds \u{2013} ${formatter.format(unallocatedProceeds)}`,
                ownership: factFind?.adviceFor === 'couple' ? 'joint' : 'client'
            });
        }
        // Apply linked aged care strategy funding impacts (e.g. RAD payments)
        if (integrationForPlan?.radFunding) try {
            formDataForFunding = (0, $87af0cc4cc4e8984$export$8a0c5ad907f77392)(formDataForFunding, integrationForPlan.radFunding);
        } catch (error) {
            console.error('Error applying aged care RAD funding to annuity sources:', error);
        }
        (formDataForFunding.assets?.accountBasedPensions || []).forEach((pension)=>{
            const amount = pension.value ?? pension.balance ?? 0;
            pushSource('abp', pension, amount, pension.description || 'Account-based pension');
        });
        (formDataForFunding.assets?.superannuation || []).forEach((superItem)=>{
            pushSource('super', superItem, superItem.value, superItem.description || 'Superannuation');
        });
        (formDataForFunding.assets?.shares || []).forEach((share)=>{
            pushSource('shares', share, share.value, share.description || 'Shares / managed fund');
        });
        (formDataForFunding.assets?.bankAccounts || []).forEach((account)=>{
            pushSource('bank', account, account.value, account.description || 'Bank account');
        });
        return sources;
    }, [
        factFind,
        factFind?.adviceFor,
        factFind?.client?.firstName,
        factFind?.partner?.firstName,
        propertyStrategy,
        downsizeDetails,
        selectedAgedCareIntegration,
        householdFactFind,
        integrationForPlan
    ]);
    // Initialize annuity record with proper structure
    const initializeAnnuityRecord = ()=>{
        const isCouple = factFind?.adviceFor === 'couple';
        const owner = isCouple ? 'joint' : 'client';
        return {
            /*
             * A NEW GUARANTEED INCOME STARTS AS THE FULL AMOUNT BACK WHERE THE PERSON MAY BUY IT (owner, 21 Oct
             * 2026 — the guaranteed income review M1, mock-up screen 6: "Starts as full amount back where
             * eligible"). People receiving support at home are; otherwise money back. Never income only.
             */ annuityType: (0, $d08210caeacdc75a$export$7095ab72ebd46272)(factFind, owner) ? 'guaranteed' : 'lifetime',
            purchaseAmount: 0,
            // See DEFAULT_NEW_ANNUITY_RESIDUAL — capital preserved unless the client chooses otherwise.
            residualCapital: (0, $6a72ca5744dce23c$export$69797182cc224f5a),
            owner: owner,
            fundingSource: {
                id: 'bank-default',
                type: 'bank',
                assetId: null,
                label: 'Bank accounts / cash',
                ownership: isCouple ? 'joint' : 'client'
            },
            indexation: false,
            reversionary: false,
            age: factFind?.client?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client.dob) : null,
            partnerAge: isCouple && factFind?.partner?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner.dob) : null
        };
    };
    // Calculate annuity record for financial impact (from annuityDetails state). buildAnnuityImpact is the
    // real (strict) calc-engine function; the Draft factFind cast is safe (see factFindTypes.ts header comment).
    const annuityRecordForCalculation = (0, $acw62.useMemo)(()=>{
        if (!annuityRecord || !annuityRecord.purchaseAmount || Number(annuityRecord.purchaseAmount) <= 0) return null;
        try {
            return (0, $f7f7b62814c3b615$export$fb67395f10ad20c9)(factFind, annuityRecord);
        } catch (error) {
            console.error('Error building annuity impact', error);
            return null;
        }
    }, [
        annuityRecord,
        factFind
    ]);
    // Calculate annuity summary for display
    const annuitySummary = (0, $acw62.useMemo)(()=>{
        if (!annuityRecordForCalculation) return null;
        return (0, $f7f7b62814c3b615$export$fc6c67b5fdf45998)(annuityRecordForCalculation);
    }, [
        annuityRecordForCalculation
    ]);
    // Calculate annuity warnings
    const annuityWarnings = (0, $acw62.useMemo)(()=>{
        if (!annuityRecord || !annuityRecord.purchaseAmount || Number(annuityRecord.purchaseAmount) <= 0) return [];
        const warnings = [];
        const purchaseAmount = parseFloat(String(annuityRecord.purchaseAmount)) || 0;
        const selectedSource = availableAnnuityFundingSources.find((src)=>src.id === annuityRecord.fundingSource?.id);
        const sourceType = selectedSource?.type || annuityRecord.fundingSource?.type;
        const balanceForSource = ()=>{
            if (!sourceType) return Infinity;
            const matchId = selectedSource?.assetId;
            const totalOrMatch = (list)=>{
                if (!Array.isArray(list)) return 0;
                if (matchId === null || matchId === undefined) return list.reduce((sum, item)=>sum + (item.value ?? item.balance ?? 0), 0);
                const match = list.find((item)=>String(item.id ?? item.accountId) === String(matchId));
                return match ? match.value ?? match.balance ?? 0 : 0;
            };
            if (sourceType === 'bank') return totalOrMatch(factFind.assets?.bankAccounts);
            if (sourceType === 'shares') return totalOrMatch(factFind.assets?.shares);
            if (sourceType === 'abp') return totalOrMatch(factFind.assets?.accountBasedPensions);
            if (sourceType === 'super') return totalOrMatch(factFind.assets?.superannuation);
            return Infinity;
        };
        const availableBalance = balanceForSource();
        if (purchaseAmount > availableBalance) warnings.push('Purchase amount exceeds the available balance in the selected funding source.');
        if (!selectedSource) warnings.push('Please confirm a funding source for the annuity.');
        return warnings;
    }, [
        annuityRecord,
        availableAnnuityFundingSources,
        factFind.assets
    ]);
    // Update annuityRecord funding source when available sources change
    (0, $acw62.useEffect)(()=>{
        if (!annuityRecord || availableAnnuityFundingSources.length === 0) return;
        const fallbackSource = availableAnnuityFundingSources[0] || {
            id: 'bank-default',
            type: 'bank',
            assetId: null,
            label: 'Bank accounts / cash',
            ownership: factFind?.adviceFor === 'couple' ? 'joint' : 'client'
        };
        if (!annuityRecord.fundingSource || !availableAnnuityFundingSources.some((src)=>src.id === annuityRecord.fundingSource?.id)) setAnnuityRecord((prev)=>prev ? {
                ...prev,
                fundingSource: fallbackSource
            } : prev);
    }, [
        availableAnnuityFundingSources,
        annuityRecord,
        factFind?.adviceFor
    ]);
    // Update overallStrategy when propertyStrategy changes
    (0, $acw62.useEffect)(()=>{
        if (propertyStrategy === 'reverseMortgage') setOverallStrategy((prev)=>({
                ...prev,
                reverseMortgage: true,
                heas: false
            }));
        else if (propertyStrategy === 'heas') setOverallStrategy((prev)=>({
                ...prev,
                reverseMortgage: false,
                heas: true
            }));
        else setOverallStrategy((prev)=>({
                ...prev,
                reverseMortgage: false,
                heas: false
            }));
    }, [
        propertyStrategy
    ]);
    // Reset function to clear all strategies after saving. `keepLinkedCare` for a blank plan opened by
    // "Build a plan yourself" or "Clear and start again" (25 Oct 2026): the household stays as it is.
    const resetStrategiesToBaseline = (keepLinkedCare = false)=>{
        // Clear any leftover restore strategy from sessionStorage
        if (typeof window !== 'undefined') sessionStorage.removeItem('careCompanionRestoreHomeCareStrategy');
        // Reset manual strategies
        setManualStrategies({
            gifting: 0,
            funeralBonds: 0,
            giftingSource: 'bank',
            funeralSource: 'bank'
        });
        // Reset property strategy
        setPropertyStrategy('none');
        // Reset property strategy details
        setDownsizeDetails({
            salePrice: factFind?.home?.value || 0,
            sellingCosts: (Number(factFind?.home?.value) || 0) * 0.025,
            newHomePurchasePrice: 0,
            downsizerContribution: 0,
            partnerDownsizerContribution: 0,
            giftingAmount: 0,
            funeralBondPurchase: 0,
            addedAssets: []
        });
        setRenovateDetails({
            renovationAmount: 0,
            fundingSources: []
        });
        setUpgradeDetails({
            currentHomeValue: parseFloat(String(factFind?.home?.value)) || 0,
            newHomePurchasePrice: 0,
            sellingCosts: 0,
            fundingSources: []
        });
        setReverseMortgageDetails({
            loanAmount: 0,
            loanPercentage: 0,
            interestRate: (0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279),
            loanStructure: 'lump_sum',
            regularPaymentAmount: 0,
            regularPaymentFrequency: 'fortnightly',
            establishmentFees: 0
        });
        setHeasDetails({
            paymentAmount: 0,
            paymentFrequency: 'fortnightly',
            interestRate: 3.95
        });
        // Reset overall strategy flags
        setOverallStrategy({});
        // Reset funding strategies
        setSelectedFundingStrategy(null);
        setAnnuityRecord(null);
        // Reset aged care integration
        if (!keepLinkedCare) setSelectedAgedCareStrategyId(null);
        setManualSeededFrom(null);
    };
    // Trigger reset when resetTrigger changes
    (0, $acw62.useEffect)(()=>{
        if (resetTrigger > 0) resetStrategiesToBaseline();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        resetTrigger
    ]);
    // Calculate BEFORE baseline (original position) — with a partner moving into care, the household once
    // the aged care plan is carried out, on its residency and with its fees, as the engine's "doing
    // nothing" is (24 Oct 2026), so a hand-built plan is measured from the same place.
    const [beforeFinancials, setBeforeFinancials] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!factFind) {
            setBeforeFinancials(null);
            return undefined;
        }
        let cancelled = false;
        const linkedBefore = linkedPosition.positioned && selectedAgedCareIntegration ? {
            ...agedCareResidencyOverrides,
            integratedAgedCareCost: Number(selectedAgedCareIntegration.annualCost) || 0,
            integratedAgedCareDetails: integrationForPlan
        } : undefined;
        trackSah($55a1d8a64f1e5dfa$export$463f0620dd36e1f8(householdFactFind, linkedBefore)).then((r)=>{
            if (!cancelled) setBeforeFinancials(r);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind,
        householdFactFind,
        linkedPosition.positioned,
        selectedAgedCareIntegration,
        agedCareResidencyOverrides,
        integrationForPlan
    ]);
    /*
     * ONE service plan for BOTH modelling modes (owner-caught asymmetry, 2026-08-25): the
     * Suggestion Engine resolved a plan (Service Builder's current plan, else the newest saved
     * one, else an illustrative package) while Manual Control silently read only
     * factFind.servicePlan — and modelled ZERO service costs when it was empty. Both modes now
     * consume this resolution, and the case line above the mode chooser SAYS which plan is in
     * use, so building the service plan first or the strategy first both read sensibly. The
     * sections unmount on tab switch, so a mount-time read of storage is always current.
     */ /** Bumped when a plan is picked in-place below, so the resolution re-reads storage. */ const [planPickVersion, setPlanPickVersion] = (0, $acw62.useState)(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const allSavedServicePlans = (0, $acw62.useMemo)(()=>(0, $08809b7a4fc47e27$export$7b53d3d51c369de2)(), [
        planPickVersion
    ]);
    // Only plans with services are offered — an empty one resolves to "no plan", so picking it
    // snapped the control straight back (owner-caught, 2026-09-13). The empty ones are named below.
    const savedServicePlans = (0, $acw62.useMemo)(()=>(0, $08809b7a4fc47e27$export$bbfb111507c2e420)(allSavedServicePlans), [
        allSavedServicePlans
    ]);
    const emptySavedServicePlans = (0, $acw62.useMemo)(()=>allSavedServicePlans.filter((p)=>!savedServicePlans.includes(p)), [
        allSavedServicePlans,
        savedServicePlans
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const servicePlanResolution = (0, $acw62.useMemo)(()=>{
        const stored = (0, $08809b7a4fc47e27$export$d30ccc0e9b37d265)();
        if ((0, $f5036bbfe52e7121$export$aba30ca5ea57db9d)(stored.plan)) return {
            plan: stored.plan,
            origin: stored.source
        };
        /*
         * "NO SERVICE PLAN" MEANS NO SERVICE PLAN (owner-caught twice, 2026-08-27 and 2026-09-24).
         * Picking it cleared the session's current plan — and this resolution then fell through to
         * the newest saved plan, and failing that to the plan saved on the profile, so the picker
         * snapped back to "Service Plan A" the moment it was let go. The choice is recorded now
         * (`chosen`) and honoured here, before anything is restored. sahOptimiseServicePlanChoice
         * .test.ts and servicePlanStorage.test.ts hold it.
         */ if (stored.source.kind === 'none' && stored.source.chosen) return {
            plan: null,
            origin: stored.source
        };
        const fromFactFind = factFind?.servicePlan;
        if ((0, $f5036bbfe52e7121$export$aba30ca5ea57db9d)(fromFactFind)) return {
            plan: fromFactFind,
            origin: {
                kind: 'restore',
                name: 'the plan saved on the profile'
            }
        };
        return {
            plan: null,
            origin: {
                kind: 'none'
            }
        };
    }, [
        factFind,
        planPickVersion
    ]);
    // With "Yes — X is moving into aged care" (step 1), X has no Support at home services priced.
    const servicePlanSource = (0, $acw62.useMemo)(()=>servicePlanResolution.plan ? (0, $5ea55f03cd2af1e4$export$fe04ad50cd2b5dad)(servicePlanResolution.plan, factFind) : servicePlanResolution.plan, [
        servicePlanResolution,
        factFind
    ]);
    const resolvedServicePlan = (0, $acw62.useMemo)(()=>(0, $f5036bbfe52e7121$export$528f6df084e80c0b)(servicePlanSource, isPartnered), [
        servicePlanSource,
        isPartnered
    ]);
    /**
     * Which entry the service-plan picker should be showing.
     *
     * Derived from the resolution rather than held as its own state: the plan can change from the
     * Service Builder, from a restore, or from the picker itself, and a control with its own idea of
     * the answer would drift from the sentence beside it — which is exactly what it did while pinned
     * to "choose…".
     */ const selectedSavedPlanId = (0, $acw62.useMemo)(()=>{
        if (resolvedServicePlan.isEstimated) return '';
        const origin = servicePlanResolution.origin;
        const name = origin.kind === 'saved' ? origin.name : origin.kind === 'current' ? origin.basedOnName : origin.kind === 'restore' ? origin.name : undefined;
        const match = name ? savedServicePlans.find((p)=>p.name === name) : undefined;
        // A real plan with no saved counterpart is unsaved builder selections, not "none".
        return match ? match.id : $d6188f49626b9d12$var$UNSAVED_PLAN_OPTION;
    }, [
        resolvedServicePlan,
        servicePlanResolution,
        savedServicePlans
    ]);
    /**
     * The resolved plan WITH its real category split attached.
     *
     * supportAtHomeContributionEngine reads `serviceDistribution` to decide what each contribution
     * rate is charged on, and assumes 40/35/25 of the whole budget when there isn't one. The plan
     * this screen hands it is `{ client, partner }` — neither `serviceDistribution` nor `services` —
     * so that fallback fired even for a real, built plan, and Optimise quoted the assumed split
     * while the Service Builder priced the actual services. One plan, two answers (owner-caught,
     * 2026-08-27: $7,722 here against $0 there).
     *
     * Every call that prices contributions goes through this, so the two screens cannot disagree.
     */ const planForPricing = (0, $acw62.useMemo)(()=>({
            ...resolvedServicePlan.plan,
            serviceDistribution: (0, $ef2004df8b6bc275$export$9adf410dad564b4)(resolvedServicePlan.plan)
        }), [
        resolvedServicePlan
    ]);
    /**
     * The plan a strategy saved RIGHT NOW would be priced against.
     *
     * Stamped onto every saved strategy so a later change of services can be detected. A Support at
     * Home strategy's dollars are `budget x rate`: optimising moves the rate, the Service Builder
     * moves the budget, so the rates survive a service change and the dollars do not.
     */ const currentServicePlanBasis = (0, $acw62.useMemo)(()=>(0, $ef2004df8b6bc275$export$5985497ca15872b4)(resolvedServicePlan.plan, resolvedServicePlan.isEstimated), [
        resolvedServicePlan
    ]);
    /** How big the real plan is — so the case line can IDENTIFY it, not just gesture at it. */ const servicePlanStats = (0, $acw62.useMemo)(()=>{
        if (resolvedServicePlan.isEstimated) return null;
        const count = (side)=>Object.values(side || {}).filter((d)=>d && Number(d.quantity) > 0).length;
        const value = (side)=>(0, $5fb3dd4f28b6f196$export$f1798fc2c7adaf45)(side || {}, {}, (0, $25e9acc02c907060$export$a3b71735b810a98c)).total;
        return {
            serviceCount: count(resolvedServicePlan.plan.client) + count(resolvedServicePlan.plan.partner),
            annualValue: value(resolvedServicePlan.plan.client) + value(resolvedServicePlan.plan.partner)
        };
    }, [
        resolvedServicePlan
    ]);
    const [beforeContributions, setBeforeContributions] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!beforeFinancials) {
            setBeforeContributions(null);
            return undefined;
        }
        let cancelled = false;
        // Use the same participant type settings as the after calculation
        // The resolved plan (real or illustrative) rides on the fact-find copy, so before and
        // after are priced on the SAME services.
        const beforeFactFind = {
            ...householdFactFind,
            servicePlan: planForPricing
        };
        // On the residency the after call and the engine's baseline use (illness-separated with a partner
        // in care), so a plan that changes nothing is priced at the same rates as doing nothing.
        trackSah($55a1d8a64f1e5dfa$export$3fe0e13ec85e5380(beforeFactFind, beforeFinancials, participantType, nwopCategory, meansDisclosed, Number(previousITCF) || 0, 0.5, {
            strategyOptions: agedCareResidencyOverrides
        })).then((r)=>{
            if (!cancelled) setBeforeContributions(r);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        beforeFinancials,
        factFind,
        householdFactFind,
        participantType,
        nwopCategory,
        meansDisclosed,
        previousITCF,
        resolvedServicePlan,
        agedCareResidencyOverrides
    ]);
    const beforeContributionData = isPartnered ? beforeContributions?.combined || beforeContributions?.client : beforeContributions?.client;
    // Calculate optimized scenario with all strategies applied (sahPlanFactFind.ts)
    const optimizedScenario = (0, $acw62.useMemo)(()=>{
        if (!factFind) return null;
        return (0, $d89d3f0f7a42703f$export$e852251532541c4f)(householdFactFind, {
            manualStrategies: manualStrategies,
            propertyStrategy: propertyStrategy,
            downsizeDetails: downsizeDetails,
            renovateDetails: renovateDetails,
            upgradeDetails: upgradeDetails,
            overallStrategy: overallStrategy,
            reverseMortgageDetails: reverseMortgageDetails,
            selectedAgedCareIntegration: integrationForPlan,
            selectedFundingStrategy: selectedFundingStrategy,
            annuityRecordForCalculation: annuityRecordForCalculation,
            beforeFinancials: beforeFinancials
        });
    }, [
        factFind,
        householdFactFind,
        manualStrategies,
        propertyStrategy,
        downsizeDetails,
        renovateDetails,
        upgradeDetails,
        overallStrategy,
        reverseMortgageDetails,
        integrationForPlan,
        selectedFundingStrategy,
        annuityRecordForCalculation,
        beforeFinancials
    ]);
    const [afterFinancials, setAfterFinancials] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!optimizedScenario?.optimizedFactFind) {
            setAfterFinancials(null);
            return undefined;
        }
        const { optimizedFactFind: optimizedFactFind, agedCareAnnualCost: agedCareAnnualCost } = optimizedScenario;
        const strategyOptionsPayload = {
            reverseMortgage: overallStrategy.reverseMortgage,
            reverseMortgageDetails: overallStrategy.reverseMortgage ? reverseMortgageDetails : null,
            heas: overallStrategy.heas,
            heasDetails: overallStrategy.heas ? heasDetails : null,
            integratedAgedCareCost: agedCareAnnualCost,
            integratedAgedCareDetails: selectedAgedCareIntegration && agedCareAnnualCost > 0 ? selectedAgedCareIntegration : null,
            ...agedCareResidencyOverrides
        };
        if (selectedFundingStrategy === 'annuity' && annuityRecordForCalculation) strategyOptionsPayload.annuities = [
            annuityRecordForCalculation
        ];
        let cancelled = false;
        trackSah($55a1d8a64f1e5dfa$export$463f0620dd36e1f8(optimizedFactFind, strategyOptionsPayload)).then((r)=>{
            if (!cancelled) setAfterFinancials(r);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        optimizedScenario,
        overallStrategy,
        reverseMortgageDetails,
        heasDetails,
        selectedAgedCareIntegration,
        selectedFundingStrategy,
        annuityRecordForCalculation,
        agedCareResidencyOverrides
    ]);
    // Save optimized financials to sessionStorage only in manual mode (avoid SE/manual cross-leak to Service Builder)
    (0, $acw62.useEffect)(()=>{
        if (internalStrategyMode !== 'manual') return;
        if (typeof window !== 'undefined' && afterFinancials) try {
            sessionStorage.setItem('careCompanionOptimizedFinancials', JSON.stringify({
                financials: afterFinancials,
                timestamp: Date.now()
            }));
            // Dispatch custom event to notify other components (same tab) - use setTimeout to avoid render issues
            setTimeout(()=>{
                window.dispatchEvent(new Event('optimizedFinancialsUpdated'));
            }, 0);
        } catch (error) {
            console.error('Error saving optimized financials:', error);
        }
        else if (typeof window !== 'undefined' && !afterFinancials) // Clear if no strategies applied
        try {
            sessionStorage.removeItem('careCompanionOptimizedFinancials');
            setTimeout(()=>{
                window.dispatchEvent(new Event('optimizedFinancialsUpdated'));
            }, 0);
        } catch (error) {
            console.error('Error clearing optimized financials:', error);
        }
    }, [
        afterFinancials,
        internalStrategyMode
    ]);
    /**
     * Which means test sets the Age Pension today — 'assets', 'income', or null when neither reduces it.
     * The questions group the levers by it (decision 8: every lever stays ticked; the ones that work on
     * the binding test lead). The same computation as the starting position card.
     */ const sahBindingTest = (0, $acw62.useMemo)(()=>{
        if (!beforeFinancials) return null;
        const data = (0, $ffc52726733f6151$export$5092ed2c4c8fd32)({
            assessableAssets: Number(beforeFinancials.assessableAssets) || 0,
            assessableIncome: Number(beforeFinancials.totalAssessableIncome) || 0,
            currentPension: Number(beforeFinancials.socialSecurity) || 0,
            isCouple: isPartnered,
            isHomeowner: (0, $d1b9bbc5238c0548$export$2f999b99c41ee933)(factFind),
            illnessSeparatedForPension: (0, $ffc52726733f6151$export$cf0463a6434d3bec)(factFind, beforeFinancials, undefined, false)
        });
        if (Math.abs(data.pensionFromAssetTest - data.pensionFromIncomeTest) < 1) return null;
        return data.isAssetTestLimiting ? 'assets' : 'income';
    }, [
        beforeFinancials,
        factFind,
        isPartnered
    ]);
    /** The tested plan Manual Control was opened from, named in the banner ("Started from …"). */ const [manualSeededFrom, setManualSeededFrom] = (0, $acw62.useState)(null);
    /**
     * "Build a plan yourself" / "Customise this plan" (owner, 19 Oct 2026: Manual Control shares the
     * engine's look and feel; aged care made "your selection carries over" true on 17 Oct; the two doors
     * named 25 Oct 2026). Opens Manual Control with the levers set to the plan's pieces — the amounts
     * exactly, the money taken from the same kind of account. With no plan, it opens BLANK: every piece
     * cleared first, as after a save, so a plan customised earlier never reappears.
     */ const buildFromEnginePlan = (row)=>{
        resetStrategiesToBaseline(true);
        const config = row?.config ?? null;
        const steps = config ? config.type === 'combination' && Array.isArray(config.steps) ? config.steps : [
            config
        ] : [];
        const sourceKind = (step)=>{
            const sources = Array.isArray(step.fundingSources) ? step.fundingSources : [];
            const lead = [
                ...sources
            ].sort((a, b)=>(Number(b.amountToTake) || 0) - (Number(a.amountToTake) || 0))[0];
            const type = String(lead?.type ?? step.assetType ?? 'bankAccounts');
            return type === 'accountBasedPensions' ? 'abp' : type === 'shares' ? 'shares' : 'bank';
        };
        const fundingAsAllocations = (step)=>(Array.isArray(step.fundingSources) ? step.fundingSources : []).filter((s)=>s.id != null && s.type && (Number(s.amountToTake) || 0) > 0).map((s)=>({
                    assetId: s.id,
                    assetType: String(s.type),
                    amount: Math.round(Number(s.amountToTake) || 0)
                }));
        const nextManual = {
            gifting: 0,
            funeralBonds: 0,
            giftingSource: 'bank',
            funeralSource: 'bank'
        };
        let nextProperty = 'none';
        let nextAnnuity = null;
        const nextDebt = {};
        const nextDebtFunding = {};
        for (const step of steps){
            const t = step.type;
            if (t === 'gifting') {
                nextManual.gifting = Number(step.amount) || 0;
                nextManual.giftingSource = sourceKind(step);
            } else if (t === 'funeralBonds') {
                nextManual.funeralBonds = Number(step.amount) || 0;
                nextManual.funeralSource = sourceKind(step);
            } else if (t === 'annuity') {
                // The plan's own type (25 Oct 2026): a new record starts as the full-amount-back type where the
                // person may buy it, so a tested nil-residual income came across as the guaranteed shape.
                const lead = Array.isArray(step.fundingSources) ? [
                    ...step.fundingSources
                ].sort((a, b)=>(Number(b.amountToTake) || 0) - (Number(a.amountToTake) || 0))[0] : null;
                // The picker's own kinds and ids (`bank-<id>`), so the source is not swapped for its first one.
                const rawType = String(lead?.type ?? step.assetType ?? '');
                const srcType = {
                    bankAccounts: 'bank',
                    termDeposits: 'bank',
                    accountBasedPensions: 'abp',
                    superannuation: 'super',
                    shares: 'shares',
                    managedFunds: 'shares'
                }[rawType] ?? rawType;
                const srcId = lead?.id ?? step.assetId;
                const base = initializeAnnuityRecord();
                nextAnnuity = {
                    ...base,
                    annuityType: step.annuityType === 'guaranteed' ? 'guaranteed' : 'lifetime',
                    purchaseAmount: Number(step.purchaseAmount) || 0,
                    residualCapital: step.annuityType === 'guaranteed' ? 1 : Number(step.residualCapital) || 0,
                    indexation: step.indexation === true,
                    ...step.owner === 'client' || step.owner === 'partner' || step.owner === 'joint' ? {
                        owner: step.owner
                    } : {},
                    ...srcType && srcId != null ? {
                        fundingSource: {
                            id: `${srcType}-${String(srcId)}`,
                            type: srcType,
                            assetId: srcId,
                            label: srcType,
                            ownership: base.fundingSource?.ownership ?? 'client'
                        }
                    } : {}
                };
            } else if (t === 'increaseHomeEquity') {
                nextProperty = 'renovate';
                setRenovateDetails({
                    renovationAmount: Number(step.equityAmount ?? step.renovationAmount) || 0,
                    fundingSources: fundingAsAllocations(step)
                });
            } else if (t === 'downsize') {
                nextProperty = 'downsize';
                if (step.downsizeDetails) setDownsizeDetails(step.downsizeDetails);
            } else if (t === 'reverseMortgage') {
                nextProperty = 'reverseMortgage';
                setReverseMortgageDetails((prev)=>({
                        ...prev,
                        loanAmount: Number(step.loanAmount) || 0,
                        loanPercentage: Number(step.loanPercentage) || 0,
                        interestRate: Number(step.interestRate) || prev.interestRate,
                        loanStructure: 'lump_sum'
                    }));
            } else if (t === 'heas') {
                nextProperty = 'heas';
                setHeasDetails((prev)=>({
                        ...prev,
                        paymentAmount: Number(step.paymentAmount) || 0,
                        paymentFrequency: String(step.paymentFrequency || 'fortnightly'),
                        interestRate: Number(step.interestRate) || prev.interestRate
                    }));
            } else if (t === 'debtRepayment' && typeof step.liabilityKey === 'string') {
                // The engine keys a debt "<category>:<id>"; the payoff card keys it "<category>::<id>".
                const at = step.liabilityKey.indexOf(':');
                if (at > 0) nextDebt[`${step.liabilityKey.slice(0, at)}::${step.liabilityKey.slice(at + 1)}`] = Number(step.repaymentAmount) || 0;
                // ...paid from the same accounts the plan sells (25 Oct 2026), not whatever the bank holds.
                for (const a of fundingAsAllocations(step))nextDebtFunding[`${a.assetType}-${a.assetId}`] = (nextDebtFunding[`${a.assetType}-${a.assetId}`] || 0) + a.amount;
            }
        }
        setManualStrategies(nextManual);
        setPropertyStrategy(nextProperty);
        setOverallStrategy((prev)=>({
                ...prev,
                reverseMortgage: nextProperty === 'reverseMortgage',
                heas: nextProperty === 'heas'
            }));
        setSelectedFundingStrategy(nextAnnuity ? 'annuity' : null);
        setAnnuityRecord(nextAnnuity);
        setDebtPayments(nextDebt);
        setDebtFunding(nextDebtFunding);
        setDebtRepaymentBasis('keep_repayment');
        setManualSeededFrom(row ? (0, $f7f18ba87194b6fe$export$743d9d8d57ca17a8)(config, factFind, String(row.name ?? '')).title : null);
        handleStrategyModeChange('manual');
        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
    };
    /** What the plan page asked for when it opened this step (read once; sahChosenPlan.ts). */ const [hubIntent] = (0, $acw62.useState)(()=>(0, $b2a376f07fa94da4$export$bad8c6138a257ba6)());
    (0, $acw62.useEffect)(()=>{
        if (hubIntent?.kind === 'build') buildFromEnginePlan({
            config: hubIntent.config,
            name: hubIntent.name
        });
        else if (hubIntent?.kind === 'build-new') buildFromEnginePlan(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Check if any strategies are actually applied
    const hasStrategies = (0, $acw62.useMemo)(()=>{
        return Number(manualStrategies.gifting) > 0 || Number(manualStrategies.funeralBonds) > 0 || propertyStrategy !== 'none' || overallStrategy.reverseMortgage || overallStrategy.heas || Boolean(selectedAgedCareIntegration) || selectedFundingStrategy === 'annuity';
    }, [
        manualStrategies,
        propertyStrategy,
        overallStrategy,
        selectedAgedCareIntegration,
        selectedFundingStrategy
    ]);
    const [afterContributions, setAfterContributions] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        // If no strategies are applied, use beforeContributions (which matches ContributionsSection exactly)
        if (!hasStrategies && beforeContributions) {
            setAfterContributions(beforeContributions);
            return undefined;
        }
        if (!afterFinancials || !optimizedScenario?.optimizedFactFind) {
            setAfterContributions(null);
            return undefined;
        }
        const hasAcatLevel = factFind?.careNeeds?.clientAcat?.status === 'yes' && factFind?.careNeeds?.clientAcat?.homeCareLevel;
        const hasPartnerAcatLevel = factFind?.adviceFor === 'couple' && factFind?.careNeeds?.partnerAcat?.status === 'yes' && factFind?.careNeeds?.partnerAcat?.homeCareLevel;
        if (!hasAcatLevel && !hasPartnerAcatLevel) {
            setAfterContributions(null);
            return undefined;
        }
        // Strategies are applied - use optimizedFactFind (which has strategy changes)
        const baseFactFind = structuredClone(optimizedScenario.optimizedFactFind);
        // The SAME resolved plan as the before call and the Suggestion Engine.
        baseFactFind.servicePlan = planForPricing;
        let cancelled = false;
        trackSah($55a1d8a64f1e5dfa$export$3fe0e13ec85e5380(baseFactFind, afterFinancials, participantType, nwopCategory, meansDisclosed, Number(previousITCF) || 0, 0.5, {
            strategyOptions: agedCareResidencyOverrides
        })).then((r)=>{
            if (!cancelled) setAfterContributions(r);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        hasStrategies,
        beforeContributions,
        afterFinancials,
        optimizedScenario,
        factFind,
        participantType,
        nwopCategory,
        meansDisclosed,
        previousITCF,
        agedCareResidencyOverrides,
        resolvedServicePlan
    ]);
    // Get contribution data for display (needed for projections)
    const afterContributionData = isPartnered ? afterContributions?.combined || afterContributions?.client : afterContributions?.client;
    /*
     * A service plan priced the way the engine prices it (server calculateServicePlanCosts): the plan's
     * services at the assessed rates within each person's budget, plus anything above the budget at
     * full price (decision 3, 19 Oct 2026). The assessment's own `totalAnnual` charged the rates on the
     * whole plan, so an over-budget plan was charged less here than the engine charged the same plan.
     */ const servicePlanBudgets = (0, $acw62.useMemo)(()=>(0, $08809b7a4fc47e27$export$4ddb2093d9f00d95)(factFind), [
        factFind
    ]);
    const priceOnPlan = (rates)=>rates ? (0, $08809b7a4fc47e27$export$8fa8d1fdeea775a9)(resolvedServicePlan.plan, rates, isPartnered, servicePlanBudgets) : null;
    // Calculate projections for legacy estimate
    // Calculate combined care costs separately so it's available for the modal
    const combinedCareCosts = (0, $acw62.useMemo)(()=>{
        if (!afterContributionData) return null;
        // Check if services are actually selected (not just using example distribution)
        // A resolved plan (real or illustrative) is always present now — see resolvedServicePlan.
        const hasServicePlan = true;
        const hasBudget = (afterContributionData?.budget?.total ?? 0) > 0 && hasServicePlan;
        const annualContribution = hasBudget ? priceOnPlan(afterContributionData.contributionRates)?.contribution.total ?? 0 : 0;
        const agedCareAnnualCost = selectedAgedCareIntegration?.annualCost || 0;
        const supportAtHomeDaily = annualContribution / 365;
        const agedCareDaily = agedCareAnnualCost / 365;
        return {
            totalDailyCost: supportAtHomeDaily + agedCareDaily,
            supportAtHomeDailyCost: supportAtHomeDaily,
            agedCareDailyCost: agedCareDaily,
            supportAtHomeAnnualCost: annualContribution,
            agedCareAnnualCost: agedCareAnnualCost
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        afterContributionData,
        selectedAgedCareIntegration,
        factFind,
        resolvedServicePlan,
        servicePlanBudgets,
        isPartnered
    ]);
    /** Care costs for pre-strategy FY blend: profile financials + before optimisation contributions (no linked RAC annual from strategy integration). */ const combinedCareCostsBaseline = (0, $acw62.useMemo)(()=>{
        if (!beforeContributionData) return null;
        // A resolved plan (real or illustrative) is always present now — see resolvedServicePlan.
        const hasServicePlan = true;
        const hasBudget = (beforeContributionData?.budget?.total ?? 0) > 0 && hasServicePlan;
        const annualContribution = hasBudget ? priceOnPlan(beforeContributionData.contributionRates)?.contribution.total ?? 0 : 0;
        const agedCareAnnualCost = 0;
        const supportAtHomeDaily = annualContribution / 365;
        const agedCareDaily = agedCareAnnualCost / 365;
        return {
            totalDailyCost: supportAtHomeDaily + agedCareDaily,
            supportAtHomeDailyCost: supportAtHomeDaily,
            agedCareDailyCost: agedCareDaily,
            supportAtHomeAnnualCost: annualContribution,
            agedCareAnnualCost: agedCareAnnualCost
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        beforeContributionData,
        factFind,
        resolvedServicePlan,
        servicePlanBudgets,
        isPartnered
    ]);
    /**
     * The shared debt strategy — see the Aged Care module. Handed to the ENGINE via the projection
     * options; the engine performs the payoff at the projection's start (a lender takes the money any
     * day), the loan-repayment plugin stops servicing whatever is cleared, and the projections and
     * their charts reflect it without this page doing any arithmetic of its own.
     */ /**
     * When Support at Home services BEGIN (`YYYY-MM-DD`), blank = already receiving them.
     *
     * A fact about the case, not about any one strategy — so it is passed to the manual projection
     * AND down into the Suggestion Engine, where the server merges it over the baseline and every
     * candidate alike. Comparing strategies that assumed different start dates would compare nothing.
     *
     * The engine treats it exactly as the aged-care entry date treats care fees: nothing is charged
     * before the day. The stay-at-home side effects of that flag were audited before this was wired —
     * living expenses do not switch (no in-care figure is set) and the home-letting clock never starts
     * (rentHome is never set here) — so the date means "support costs start here" and nothing else.
     */ const supportStartInPast = supportStartDate !== '' && supportStartDate < new Date().toISOString().slice(0, 10);
    // Restored with the plan, so reopening a plan built by hand gives back the same plan (its fingerprint).
    const [debtPayments, setDebtPayments] = (0, $acw62.useState)(()=>restoredStrategy?.inputs?.debtPayments || {});
    // Where the payoff money comes from, and the repayment choice, are restored too (25 Oct 2026): without
    // them a reopened plan fell back to "cash first" and named a different account from the one chosen.
    const [debtFunding, setDebtFunding] = (0, $acw62.useState)(()=>restoredStrategy?.inputs?.debtFunding || {});
    const [debtRepaymentBasis, setDebtRepaymentBasis] = (0, $acw62.useState)(()=>restoredStrategy?.inputs?.debtRepaymentBasis === 'lower_repayment' ? 'lower_repayment' : 'keep_repayment');
    const debtPayoffPlan = (0, $acw62.useMemo)(()=>{
        const payments = Object.fromEntries(Object.entries(debtPayments).filter(([, amount])=>(Number(amount) || 0) > 0));
        if (Object.keys(payments).length === 0) return null;
        const funding = Object.fromEntries(Object.entries(debtFunding).filter(([, amount])=>(Number(amount) || 0) > 0));
        return {
            payments: payments,
            funding: funding,
            repaymentBasis: debtRepaymentBasis
        };
    }, [
        debtPayments,
        debtFunding,
        debtRepaymentBasis
    ]);
    const sahProjectionStrategyOptions = (0, $acw62.useMemo)(()=>{
        const strategyOptions = {
            reverseMortgage: overallStrategy.reverseMortgage,
            reverseMortgageDetails: overallStrategy.reverseMortgage ? reverseMortgageDetails : null,
            heas: overallStrategy.heas,
            heasDetails: overallStrategy.heas ? heasDetails : null,
            inflationAssumptionPct: 2.5,
            projectionPeriodMode: 'financial_year',
            ...agedCareResidencyOverrides
        };
        if (selectedAgedCareIntegration) {
            strategyOptions.integratedAgedCareDetails = selectedAgedCareIntegration;
            if (selectedAgedCareIntegration.livingExpenses !== undefined && selectedAgedCareIntegration.livingExpenses !== null) strategyOptions.scenarioLivingExpenses = selectedAgedCareIntegration.livingExpenses;
        }
        if (selectedFundingStrategy === 'annuity' && annuityRecordForCalculation) strategyOptions.annuities = [
            annuityRecordForCalculation
        ];
        if (debtPayoffPlan) strategyOptions.debtPayoff = debtPayoffPlan;
        // A past date means support is already under way, which is what a BLANK date means — sending
        // it would defer costs to a day already gone.
        if (supportStartDate && !supportStartInPast) strategyOptions.careStartDate = supportStartDate;
        return strategyOptions;
    }, [
        debtPayoffPlan,
        supportStartDate,
        supportStartInPast,
        overallStrategy.reverseMortgage,
        overallStrategy.heas,
        reverseMortgageDetails,
        heasDetails,
        agedCareResidencyOverrides,
        selectedAgedCareIntegration,
        selectedFundingStrategy,
        annuityRecordForCalculation
    ]);
    /*
     * A PARTNER'S AGED CARE FEES ARE CHARGED AS THE ENGINE CHARGES THEM (25 Oct 2026, pack B.SAH.6). The
     * engine charges the Support at home contribution plus the linked plan's yearly fees as one integrated
     * cost, held flat in real terms. This screen handed the same fees over as a bare daily total, which the
     * projection treats as a residential schedule: once the cash ran low it drew the fees from the room
     * deposit and charged the accommodation payment on what was drawn. So a hand-built plan that changed
     * nothing ended $78,894 below the engine's "doing nothing" on the same household. Both now run the
     * engine's way; with no aged care plan linked nothing changes.
     */ const linkedFeesAYear = selectedAgedCareIntegration ? Number(selectedAgedCareIntegration.annualCost) || 0 : 0;
    const planProjection = (0, $acw62.useMemo)(()=>combinedCareCosts ? (0, $5ea55f03cd2af1e4$export$6f755083936d6e5c)({
            options: sahProjectionStrategyOptions,
            costs: combinedCareCosts,
            supportAtHomeAYear: combinedCareCosts.supportAtHomeAnnualCost,
            linkedFeesAYear: linkedFeesAYear
        }) : null, [
        sahProjectionStrategyOptions,
        combinedCareCosts,
        linkedFeesAYear
    ]);
    const planProjectionOptions = planProjection?.options ?? sahProjectionStrategyOptions;
    const planProjectionCosts = planProjection?.costs ?? null;
    const [projections, setProjections] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!afterFinancials || !afterContributionData || !optimizedScenario?.optimizedFactFind || !planProjectionCosts) {
            setProjections(null);
            return undefined;
        }
        let cancelled = false;
        trackSah($55a1d8a64f1e5dfa$export$75699a59a86ef1ab(optimizedScenario.optimizedFactFind, planProjectionOptions, planProjectionCosts, legacyYears, {
            debug: false
        })).then((proj)=>{
            if (!cancelled) setProjections(proj);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        optimizedScenario,
        afterFinancials,
        afterContributionData,
        legacyYears,
        planProjectionOptions,
        planProjectionCosts
    ]);
    /*
     * THE FINANCIAL-YEAR / CALENDAR-YEAR TOGGLE (owner, 23 Sep 2026: present in Aged Care, missing
     * everywhere else). Not a display filter — the engine PROJECTS the year it REPORTS, so the rows
     * are cut again by a second run, which is exactly what the shared modal gates the toggle on.
     * Fetched only while the modal is open, so a remembered 'calendar_year' does not fire a second
     * run on every page load. The mode is the modal's own sticky preference, shared with Aged Care.
     */ const [modalPeriodMode, setModalPeriodMode] = (0, $acw62.useState)((0, $4f50ab660c01dd64$export$1e222c2c280e2a28));
    const [calendarYearProjections, setCalendarYearProjections] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (modalPeriodMode !== 'calendar_year') {
            setCalendarYearProjections(null);
            return undefined;
        }
        if (!showProjectionsModal) return undefined;
        if (!optimizedScenario?.optimizedFactFind || !planProjectionCosts) return undefined;
        let cancelled = false;
        setCalendarYearProjections(null);
        $55a1d8a64f1e5dfa$export$75699a59a86ef1ab(optimizedScenario.optimizedFactFind, {
            ...planProjectionOptions,
            projectionPeriodMode: 'calendar_year'
        }, planProjectionCosts, legacyYears, {
            debug: false
        }).then((proj)=>{
            if (!cancelled) setCalendarYearProjections(proj);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        showProjectionsModal,
        modalPeriodMode,
        optimizedScenario,
        planProjectionOptions,
        planProjectionCosts,
        legacyYears
    ]);
    /** Adds FY full-year pre/post blend on row 1 (same pattern as Aged Care ProjectionsModal). */ /*
     * The benchmark: this household RECEIVING THE SAME SERVICES with no financial strategy, projected
     * over the same period. Support at Home is a care requirement, so "do nothing" still pays for
     * care — which is why the baseline carries combinedCareCostsBaseline rather than zero costs.
     */ /*
     * THE SAME "DOING NOTHING" AS THE ENGINE'S (25 Oct 2026). It was run on the profile as entered — both
     * at home, before the aged care plan — while every plan here, and the engine's benchmark, start from
     * the household once that plan is carried out. It now runs on that household, with the engine's
     * options (supportAtHome.ts computeSupportAtHomeBaselineData): the living costs, the residency, the
     * support start date, and the contribution plus the aged care fees as one cost. A plan that changes
     * nothing therefore shows no change on any figure.
     */ // The engine's baseline household: the aged care plan carried out, or — where it cannot be rebuilt — its
    // deposit paid, as the plans here pay it (sahBaselineFactFind).
    const doNothingFactFind = (0, $acw62.useMemo)(()=>selectedAgedCareIntegration ? (0, $5ea55f03cd2af1e4$export$696453b4446851c9)(factFind, selectedAgedCareIntegration, undefined, linkedPosition.positioned) : factFind, [
        factFind,
        selectedAgedCareIntegration,
        linkedPosition.positioned
    ]);
    const doNothingProjection = (0, $acw62.useMemo)(()=>{
        if (!combinedCareCostsBaseline) return null;
        const timing = supportStartDate && !supportStartInPast ? {
            careStartDate: supportStartDate
        } : {};
        const base = linkedFeesAYear > 0 ? {
            scenarioLivingExpenses: Number(doNothingFactFind?.expenses?.livingExpenses) || 0,
            ...agedCareResidencyOverrides,
            ...timing
        } : timing;
        return (0, $5ea55f03cd2af1e4$export$6f755083936d6e5c)({
            options: base,
            costs: combinedCareCostsBaseline,
            supportAtHomeAYear: combinedCareCostsBaseline.supportAtHomeAnnualCost,
            linkedFeesAYear: linkedFeesAYear
        });
    }, [
        supportStartDate,
        supportStartInPast,
        linkedFeesAYear,
        doNothingFactFind,
        agedCareResidencyOverrides,
        combinedCareCostsBaseline
    ]);
    const sahDoNothingRun = (0, $db92cec86168e39f$export$2968cabee8db6131)(doNothingFactFind, legacyYears, {
        enabled: !!doNothingProjection,
        strategyOptions: doNothingProjection?.options,
        agedCareCosts: doNothingProjection?.costs ?? undefined,
        track: trackSah
    });
    const sahDoNothingLegacy = sahDoNothingRun.legacy;
    /** Year one of each projection — the engine's "each year" figure (getProjectionCashFlow on row 0). */ const sahDoNothingYear1 = sahDoNothingRun.rows?.[0] ?? null;
    const [projectionsForModal, setProjectionsForModal] = (0, $acw62.useState)(null);
    /**
     * How long the money lasts with NO strategy — the starting position's runway.
     *
     * Reads the same projection rows the panel does, through the same shared helper Aged Care uses,
     * so the anchor note and the panel cannot report different years. Null when there is nothing to
     * project yet, in which case the beat is simply omitted.
     */ const startingRunway = (0, $acw62.useMemo)(()=>(0, $0fe89e03b6df746e$export$464558962ff4a811)(projections, Number(legacyYears) || 5), [
        projections,
        legacyYears
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!projections?.length || !combinedCareCosts || !optimizedScenario?.optimizedFactFind) {
            setProjectionsForModal(projections);
            return undefined;
        }
        const mode = sahProjectionStrategyOptions.projectionPeriodMode ?? 'financial_year';
        if (mode === 'strategy_year') {
            setProjectionsForModal(projections);
            return undefined;
        }
        const baselineCosts = combinedCareCostsBaseline ?? {
            totalDailyCost: 0,
            supportAtHomeDailyCost: 0,
            agedCareDailyCost: 0,
            supportAtHomeAnnualCost: 0,
            agedCareAnnualCost: 0
        };
        let cancelled = false;
        $55a1d8a64f1e5dfa$export$ec33525b18058039({
            strategyOptions: sahProjectionStrategyOptions,
            // The household the plans start from (the aged care plan carried out), as the benchmark is.
            baselineFactFind: householdFactFind,
            strategyFactFind: optimizedScenario.optimizedFactFind,
            baselineCombinedCareCosts: baselineCosts,
            strategyCombinedCareCosts: combinedCareCosts,
            strategyYearOneProjection: projections[0],
            initialFinancials: beforeFinancials,
            currentFinancials: afterFinancials,
            legacyYears: legacyYears,
            options: {
                debug: false
            }
        }).then((fyView)=>{
            if (cancelled) return;
            setProjectionsForModal(projections.map((row, i)=>i === 0 ? {
                    ...row,
                    fyFullYearView: fyView
                } : row));
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        projections,
        combinedCareCosts,
        combinedCareCostsBaseline,
        optimizedScenario,
        factFind,
        householdFactFind,
        beforeFinancials,
        afterFinancials,
        legacyYears,
        sahProjectionStrategyOptions
    ]);
    // Calculate projected legacy from projections
    const projectedLegacy = (0, $acw62.useMemo)(()=>{
        if (!projections || projections.length === 0) return afterFinancials?.netWorth || 0;
        const lastYear = projections[projections.length - 1];
        return lastYear.netWorth || 0;
    }, [
        projections,
        afterFinancials
    ]);
    const formatCurrency = (value)=>{
        return new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(Number(value) || 0);
    };
    const formatPercent = (value)=>{
        return `${((value ?? 0) * 100).toFixed(1)}%`;
    };
    // CalculationTooltip is now defined at module level, accessible to both modal and StrategiesSection
    /*
     * Support at Home used its OWN copy of ImpactMetric — a different design that showed only the
     * AFTER figure with a delta beside it, never the baseline it was measured against. It is now the
     * shared component (owner-guided, 2026-08-26: build it correctly and make it scalable).
     *
     * Two things follow. The module stops looking like a different product from the other four, and
     * every improvement to the shared tile — the before-arrow-after grammar, the row alignment, the
     * named benchmark — reaches it without being rebuilt here. A private copy of a shared component
     * is how one module quietly falls behind and how the same fix comes to cost twice.
     */ const serviceCosts = null; // Will be calculated if needed
    // Prepare contribution rates with before/after data for Insight Panel
    const contributionRatesForInsight = {
        before: beforeContributionData?.contributionRates || {},
        after: afterContributionData?.contributionRates || {}
    };
    const isSuggestionMode = internalStrategyMode === 'suggestion';
    /**
     * What the plan summary is describing, in the client's words — or null when it is describing
     * nothing yet, in which case the panel says so and holds the starting position.
     *
     * Derived from the strategies actually switched ON, never a stored label, for the same reason
     * Aged Care does it that way: a panel headed with a name that no longer matches the figures
     * underneath it is worse than one with no name at all.
     */ const sahPlanSummaryName = (0, $acw62.useMemo)(()=>{
        if (isSuggestionMode) return sahSeSelectedStrategy?.name ?? null;
        const parts = [];
        /*
         * EVERY LEVER `hasStrategies` counts is named here (owner-caught, 2026-09-24: a $10,000 gift
         * moved every figure in the panel while its heading still read "No plan yet — the starting
         * position"). A heading that says nothing is happening over figures that have moved is the
         * one thing this panel must never do.
         */ if (Number(manualStrategies.gifting) > 0) parts.push(`Gift ${formatCurrency(Number(manualStrategies.gifting))}`);
        if (Number(manualStrategies.funeralBonds) > 0) parts.push(`Buy a funeral bond for ${formatCurrency(Number(manualStrategies.funeralBonds))}`);
        if (propertyStrategy === 'downsize') parts.push('Downsize the home');
        if (propertyStrategy === 'renovate') parts.push('Renovate the home');
        if (propertyStrategy === 'upgrade') parts.push('Upgrade the home');
        if (propertyStrategy === 'reverseMortgage') parts.push('Take a reverse mortgage');
        if (propertyStrategy === 'heas') parts.push('Use the Home Equity Access Scheme');
        if (annuityRecord) parts.push('Commence an annuity');
        if (selectedAgedCareStrategyId) parts.push('Link an aged care plan');
        if (!parts.length) return null;
        const [lead, ...rest] = parts;
        return rest.length ? `${lead}, ${rest.map((p)=>p.charAt(0).toLowerCase() + p.slice(1)).join(', ')}` : lead;
    }, [
        isSuggestionMode,
        sahSeSelectedStrategy,
        manualStrategies,
        propertyStrategy,
        annuityRecord,
        selectedAgedCareStrategyId
    ]);
    const panelContributionData = isSuggestionMode ? beforeContributionData : afterContributionData;
    const panelFinancials = isSuggestionMode ? beforeFinancials : afterFinancials;
    const impactAfterFinancials = isSuggestionMode ? beforeFinancials : afterFinancials;
    /*
     * The estate the summary shows in engine mode (review, 18 Oct 2026: picking "Suggestion Engine"
     * dropped it from $4,125,171 to $3,445,000, "−$680,171 vs no plan", with no plan chosen — the
     * $3,445,000 was today's net worth, not a projected estate). With a plan selected it is that
     * plan's projected estate; with none, it is the do-nothing estate, so the panel moves by nothing.
     */ const selectedSeLegacy = Number(sahSeSelectedStrategy?.snapshot?.legacyValue);
    const impactProjectedLegacy = isSuggestionMode ? Number.isFinite(selectedSeLegacy) && selectedSeLegacy > 0 ? selectedSeLegacy : sahDoNothingLegacy ?? projectedLegacy : projectedLegacy;
    const showContributionWas = !isSuggestionMode;
    /*
     * CASHFLOW NET OF THE SERVICE PLAN (owner-caught, 2026-09-24). The annual position's cashflow
     * is "money in, less money out" BEFORE any care costs — the standalone assessment never sees
     * the Support at Home contribution, which the projection charges as a monthly stream instead.
     * So with "Service Plan A" selected the panel still read $10,198 while the Service Builder, one
     * tab back, read $4,214 remaining after the $5,984 contribution: same client, same plan, two
     * cashflows. The panel now nets the plan's contribution the way the Service Builder does — the
     * share of care costs shown in the tile directly above it — before AND after, so the movement
     * between them is the strategy's alone, and year one of the projection and the annual position
     * finally agree. No service plan, no dollars: on the illustrative package the contribution is
     * not quoted (see sahInBrief), so the cashflow stays gross and the starting-position note says
     * "before any care costs" and stops there.
     */ const servicePlanName = (0, $acw62.useMemo)(()=>{
        const o = servicePlanResolution.origin;
        return o.kind === 'saved' ? o.name : o.kind === 'current' ? o.basedOnName ?? null : o.kind === 'restore' ? o.name : null;
    }, [
        servicePlanResolution
    ]);
    /*
     * THEIR CONTRIBUTION ON THIS SERVICE PLAN, priced by the engine's own arithmetic (19 Oct 2026):
     * the plan's services at the assessed rates, within each person's budget, plus anything above the
     * budget at full price (decision 3, pack B.SAH.3). The assessment's `totalAnnual` charged the rates
     * on the whole plan, so an over-budget plan read cheaper here than on the engine's card for the
     * same plan.
     */ const sahPlanCostsBefore = !resolvedServicePlan.isEstimated ? priceOnPlan(beforeContributionData?.contributionRates) : null;
    const sahPlanCostsAfter = !resolvedServicePlan.isEstimated ? priceOnPlan(panelContributionData?.contributionRates) : null;
    const sahContributionBefore = sahPlanCostsBefore ? sahPlanCostsBefore.contribution.total : null;
    const sahContributionAfter = sahPlanCostsAfter ? sahPlanCostsAfter.contribution.total : null;
    /*
     * Year one of the projection where there is one, as the engine quotes it (getProjectionCashFlow on
     * row 0; 19 Oct 2026: the yearly snapshot less the contribution read $715 short where the engine's
     * strip read $633 for the same doing-nothing). The snapshot figure stands in while the run loads.
     */ const year1CashFlow = (row)=>row && Number.isFinite(Number(row.cashFlow)) && row.cashFlow != null ? Number(row.cashFlow) : null;
    const sahCashFlowBefore = beforeFinancials?.cashFlow == null ? null : (!resolvedServicePlan.isEstimated ? year1CashFlow(sahDoNothingYear1) : null) ?? beforeFinancials.cashFlow - (sahContributionBefore ?? 0);
    const sahCashFlowAfter = impactAfterFinancials?.cashFlow == null ? null : isSuggestionMode ? sahCashFlowBefore : (!resolvedServicePlan.isEstimated && hasStrategies ? year1CashFlow(projections?.[0]) : !resolvedServicePlan.isEstimated ? year1CashFlow(sahDoNothingYear1) : null) ?? impactAfterFinancials.cashFlow - (sahContributionAfter ?? 0);
    const sahCashFlowBreakdown = (0, $acw62.useMemo)(()=>{
        const rows = impactAfterFinancials?.cashFlowBreakdown;
        if (!rows || sahContributionAfter == null) return null;
        return [
            ...rows,
            {
                label: '--- Support at Home ---',
                value: ''
            },
            {
                label: `Less: Your share of care costs${servicePlanName ? ` (${servicePlanName})` : ''}`,
                value: `-${formatCurrency(sahContributionAfter)}`
            }
        ];
    }, [
        impactAfterFinancials,
        sahContributionAfter,
        servicePlanName
    ]);
    /**
     * The panel's "In brief" — one sentence saying what the plan does, in the same grammar Aged
     * Care uses ("what it costs, then each figure that moved and by how much").
     *
     * Built ONLY from figures already rendered in the tiles directly beneath it, subtracted exactly
     * as the tiles subtract them, so the sentence cannot disagree with the numbers it summarises.
     * Nothing here re-reads the fact-find or calls an engine.
     *
     * The Support at Home difference from Aged Care is what leads: this module charges a SHARE of
     * each service rather than a room, so the client's own contribution is the cost that moves, and
     * it leads the sentence where the DAP leads Aged Care's.
     */ /*
     * ─── THE PLAN BUILT BY HAND, IN THE ENGINE'S TERMS (owner, 19 Oct 2026: Manual Control keeps the
     * engine's look and feel — the same card, Explain this, What could go wrong, buttons and words). ───
     *
     * The levers are described as the engine's pieces so the same words name them (sahPlanWords), and
     * the figures are gathered into the same shape the engine card reads (SahFigures). Every figure is
     * one already on this screen: the rail and the card cannot disagree.
     */ /** The loan against the home in a hand-built plan, off the same projection the card shows (closing balance from its last row). */ const manualEquityRelease = (()=>{
        const rows = projections || [];
        const last = rows[rows.length - 1] || {};
        if (propertyStrategy === 'reverseMortgage' && Number(reverseMortgageDetails.loanAmount) > 0) return {
            kind: 'reverseMortgage',
            loanAmount: Number(reverseMortgageDetails.loanAmount) || 0,
            interestRate: Number(reverseMortgageDetails.interestRate) || 0,
            projectedBalance: Number(last.reverseMortgageLoanBalance) || 0,
            years: rows.length
        };
        if (propertyStrategy === 'heas' && Number(heasDetails.paymentAmount) > 0) {
            const perYear = heasDetails.paymentFrequency === 'fortnightly' ? Number(heasDetails.paymentAmount) * 26 : Number(heasDetails.paymentAmount) * 12;
            return {
                kind: 'heas',
                loanAmount: Math.round(perYear * rows.length),
                interestRate: Number(heasDetails.interestRate) || 0,
                projectedBalance: Number(last.reverseMortgageLoanBalance) || 0,
                years: rows.length
            };
        }
        return null;
    })();
    const manualPieces = (0, $acw62.useMemo)(()=>{
        const pieces = [];
        if (Number(manualStrategies.gifting) > 0) pieces.push({
            type: 'gifting',
            amount: Number(manualStrategies.gifting)
        });
        if (Number(manualStrategies.funeralBonds) > 0) pieces.push({
            type: 'funeralBonds',
            amount: Number(manualStrategies.funeralBonds)
        });
        if (selectedFundingStrategy === 'annuity' && annuityRecord && Number(annuityRecord.purchaseAmount) > 0) {
            const residual = Number(annuityRecord.residualCapital) || 0;
            pieces.push({
                type: 'annuity',
                purchaseAmount: Number(annuityRecord.purchaseAmount),
                residualCapital: residual > 0 ? 1 : 0,
                annuityType: String(annuityRecord.annuityType || 'lifetime'),
                ownership: annuityRecord.owner === 'partner' ? 'partner' : 'client',
                name: residual > 0 ? 'annuity (capital returned)' : 'annuity (nil residual)'
            });
        }
        // The accounts chosen in the allocator, in the engine's terms, so the card says "Paid from …" too.
        const funded = (sources)=>(sources || []).filter((s)=>Number(s.amount) > 0).map((s)=>({
                    type: String(s.assetType),
                    id: s.assetId,
                    amountToTake: Number(s.amount)
                }));
        if (propertyStrategy === 'renovate' && Number(renovateDetails.renovationAmount) > 0) pieces.push({
            type: 'renovate',
            renovationAmount: Number(renovateDetails.renovationAmount),
            fundingSources: funded(renovateDetails.fundingSources)
        });
        if (propertyStrategy === 'upgrade' && Number(upgradeDetails.newHomePurchasePrice) > 0) pieces.push({
            type: 'upgrade',
            newHomeValue: Number(upgradeDetails.newHomePurchasePrice),
            fundingSources: funded(upgradeDetails.fundingSources)
        });
        if (propertyStrategy === 'downsize' && Number(downsizeDetails.newHomePurchasePrice) >= 0 && Number(downsizeDetails.salePrice) > 0) {
            const usesDownsizer = Number(downsizeDetails.downsizerContribution) > 0 || Number(downsizeDetails.partnerDownsizerContribution) > 0;
            pieces.push({
                type: 'downsize',
                newHomeValue: Number(downsizeDetails.newHomePurchasePrice) || 0,
                downsizeDetails: {
                    useDownsizer: usesDownsizer
                },
                name: usesDownsizer ? 'downsizer' : ''
            });
        }
        if (propertyStrategy === 'reverseMortgage' && Number(reverseMortgageDetails.loanAmount) > 0) pieces.push({
            type: 'reverseMortgage',
            loanAmount: Number(reverseMortgageDetails.loanAmount)
        });
        if (propertyStrategy === 'heas' && Number(heasDetails.paymentAmount) > 0) pieces.push({
            type: 'heas',
            paymentAmount: Number(heasDetails.paymentAmount),
            paymentFrequency: heasDetails.paymentFrequency
        });
        for (const [key, amount] of Object.entries(debtPayments)){
            if (!(Number(amount) > 0)) continue;
            const at = key.indexOf('::');
            const list = factFind?.liabilities?.[key.slice(0, at)] || [];
            const liability = list.find((l)=>String(l?.id) === key.slice(at + 2));
            const balance = Number(liability?.balance) || 0;
            pieces.push({
                type: 'debtRepayment',
                repaymentAmount: Number(amount),
                liabilityDescription: String(liability?.description || 'debt'),
                name: balance > 0 && Number(amount) < balance ? 'partial' : ''
            });
        }
        return pieces;
    }, [
        manualStrategies,
        selectedFundingStrategy,
        annuityRecord,
        propertyStrategy,
        renovateDetails,
        upgradeDetails,
        downsizeDetails,
        reverseMortgageDetails,
        heasDetails,
        debtPayments,
        factFind
    ]);
    const manualWords = (0, $acw62.useMemo)(()=>{
        const config = manualPieces.length > 1 ? {
            type: 'combination',
            steps: manualPieces
        } : manualPieces[0] ?? null;
        const words = (0, $f7f18ba87194b6fe$export$743d9d8d57ca17a8)(config, factFind);
        const linked = selectedAgedCareIntegration ? `Priced with the aged care plan "${String(selectedAgedCareStrategy?.displayName || selectedAgedCareStrategy?.name || 'chosen')}" for the one moving into care.` : '';
        if (!config && linked) return {
            title: 'Keep things as they are, with the aged care plan',
            sub: linked,
            treatment: []
        };
        // A gift or funeral bond is taken from a KIND of account here (not a named one, as the engine does).
        const kindWords = {
            bank: 'the bank accounts',
            abp: 'the account-based pensions',
            shares: 'the shares'
        };
        const fromKind = !words.sub ? [
            ...new Set([
                Number(manualStrategies.gifting) > 0 ? kindWords[String(manualStrategies.giftingSource)] : null,
                Number(manualStrategies.funeralBonds) > 0 ? kindWords[String(manualStrategies.funeralSource)] : null
            ].filter(Boolean))
        ] : [];
        const kindSentence = fromKind.length ? `Paid from ${fromKind.join(' and ')}.` : '';
        return {
            ...words,
            sub: [
                words.sub || kindSentence,
                linked
            ].filter(Boolean).join(' ')
        };
    }, [
        manualPieces,
        factFind,
        selectedAgedCareIntegration,
        selectedAgedCareStrategy,
        manualStrategies
    ]);
    /** One plan's figures in the shape the engine card and its dialogs read. */ const sahFiguresOf = (fin, costs, rates, legacy, year1)=>{
        if (!fin || !costs || legacy == null) return null;
        const contribution = costs.contribution.total;
        // The engine's snapshot: each year and investment income from year one of the projection,
        // the pension and tax from the yearly assessment (supportAtHome.ts, evaluate…Strategy).
        const y1Cash = year1CashFlow(year1);
        return {
            contribution: contribution,
            pension: Number(fin.socialSecurity) || 0,
            cashflow: y1Cash ?? (Number(fin.cashFlow) || 0) - contribution,
            legacy: legacy,
            investmentIncome: Number(year1?.investmentIncome) || Number(fin.investmentIncome) || 0,
            rates: rates ? {
                independence: Number(rates.independence) || 0,
                everydayLiving: Number(rates.everydayLiving) || 0
            } : null,
            breakdown: {
                clinical: costs.clinical,
                independence: costs.independence,
                everydayLiving: costs.everyday,
                independenceContribution: costs.contribution.independence,
                everydayContribution: costs.contribution.everyday,
                privateExcess: costs.privateExcess
            },
            livingExpenses: Number(factFind?.expenses?.livingExpenses) || 0,
            taxPayable: Number(fin.netTax) || 0,
            pensionRows: fin.socialSecurityBreakdown || [],
            cashFlowBreakdown: year1?.cashFlowBreakdown || fin.cashFlowBreakdown
        };
    };
    const manualBaseFigures = (0, $acw62.useMemo)(()=>sahFiguresOf(beforeFinancials, priceOnPlan(beforeContributionData?.contributionRates), beforeContributionData?.contributionRates, sahDoNothingLegacy ?? null, sahDoNothingYear1), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        beforeFinancials,
        beforeContributionData,
        sahDoNothingLegacy,
        sahDoNothingYear1,
        resolvedServicePlan,
        servicePlanBudgets,
        factFind
    ]);
    const manualFiguresReady = !hasStrategies || afterFinancials != null && afterContributionData != null && projections != null;
    const manualPlanFigures = (0, $acw62.useMemo)(()=>manualFiguresReady ? sahFiguresOf(afterFinancials, priceOnPlan(afterContributionData?.contributionRates), afterContributionData?.contributionRates, projectedLegacy, projections?.[0] ?? null) : null, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        manualFiguresReady,
        afterFinancials,
        afterContributionData,
        projectedLegacy,
        projections,
        resolvedServicePlan,
        servicePlanBudgets,
        factFind
    ]);
    /** The levers as a fingerprint, so choosing the same plan twice replaces it rather than adding one. */ const manualFingerprint = (0, $acw62.useMemo)(()=>JSON.stringify({
            manualPieces: manualPieces,
            linked: selectedAgedCareStrategyId || null,
            plan: currentServicePlanBasis
        }), [
        manualPieces,
        selectedAgedCareStrategyId,
        currentServicePlanBasis
    ]);
    /** The chosen record on file IS the plan on screen. */ const isChosenManualPlan = (s)=>{
        if (!s.chosen) return false;
        const inp = s.inputs || {};
        if (inp.manualFingerprint === manualFingerprint) return true;
        // "Customise this plan", unchanged: the same plan as the tested one chosen — same words, same figures.
        const c = inp.card;
        return !!(c?.plan && manualPlanFigures && c.words?.title === manualWords.title && Math.abs(c.plan.legacy - manualPlanFigures.legacy) < 1 && Math.abs(c.plan.contribution - manualPlanFigures.contribution) < 1);
    };
    const manualChosen = savedHomeCareStrategies.some(isChosenManualPlan);
    const anotherSahPlanChosen = !manualChosen && savedHomeCareStrategies.some((s)=>s.chosen);
    const [manualExplainOpen, setManualExplainOpen] = (0, $acw62.useState)(false);
    const [manualRisksOpen, setManualRisksOpen] = (0, $acw62.useState)(false);
    const [manualCareUpOpen, setManualCareUpOpen] = (0, $acw62.useState)(false);
    const [manualFigurePage, setManualFigurePage] = (0, $acw62.useState)(null);
    const sahWho = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const manualPensionWhy = sahBindingTest === 'assets' ? `The Age Pension is worked out under both the assets test and the income test, and the lower result is paid. Here the assets test sets it: Centrelink counts ${formatCurrency(Number(beforeFinancials?.assessableAssets) || 0)} of ${sahWho.possessive} assets today, and each $1,000 less that is counted adds about ${formatCurrency((0, $1abe73eeef086faf$export$6ca758cf677ce6c5))} a year, until the income test takes over.` : sahBindingTest === 'income' ? 'The Age Pension is worked out under both the assets test and the income test, and the lower result is paid. Here the income test sets it, so moving assets around changes it only where the income they are deemed to earn changes.' : 'The Age Pension is worked out under both the assets test and the income test; the lower result is paid.';
    /**
     * "Choose this plan" for a plan built by hand — the engine card's button, the engine card's record
     * (displayName, chosen, baseline), the same service plan stamp. Choosing the same levers again
     * replaces the earlier record rather than adding a second one.
     */ /*
     * INCOME ONLY NEEDS THE CLIENT'S TICK (owner, 21 Oct 2026): a hand-built plan whose annuity returns
     * nothing cannot be chosen until the client has ticked that nothing comes back. See IncomeOnlyTick.tsx.
     */ const manualIncomeOnly = selectedFundingStrategy === 'annuity' && (0, $5eae79c7e46ed27e$export$3c8a471078a7436)(annuityRecord);
    /** The hand-built plan's guaranteed income, for its family panel (sahGuaranteedIncome.ts). */ const manualAnnuity = selectedFundingStrategy === 'annuity' ? (0, $dd66c4f756bb6b40$export$c49e25d370aaca5c)(annuityRecord, manualPieces.length === 1) : null;
    const manualIncomeOnlyHeld = (0, $5eae79c7e46ed27e$export$655f124668ce439a)(factFind, manualIncomeOnly, Number(annuityRecord?.purchaseAmount) || 0);
    const setIncomeOnlyUnderstood = (0, $5eae79c7e46ed27e$export$415ddf94c95c9134)(setFactFind);
    const chooseManualPlan = ()=>{
        if (!manualPlanFigures) return;
        if (manualIncomeOnlyHeld) return;
        const earlier = savedHomeCareStrategies.find((s)=>s.inputs?.manualFingerprint === manualFingerprint);
        const strategy = {
            id: earlier?.id || `strategy-${Date.now()}`,
            name: manualWords.title,
            displayName: manualWords.title,
            type: 'home_care',
            source: 'manual',
            // Built by the client from a tested plan ("Customise this plan", 25 Oct 2026): the advice document says so.
            ...manualSeededFrom ? {
                customisedFrom: manualSeededFrom
            } : {},
            inputs: {
                source: 'manual',
                manualFingerprint: manualFingerprint,
                legacyYears: Number(legacyYears) || 10,
                gifting: manualStrategies.gifting,
                funeralBonds: manualStrategies.funeralBonds,
                giftingSource: manualStrategies.giftingSource,
                funeralSource: manualStrategies.funeralSource,
                propertyStrategy: propertyStrategy,
                downsizeDetails: propertyStrategy === 'downsize' ? downsizeDetails : null,
                renovateDetails: propertyStrategy === 'renovate' ? renovateDetails : null,
                upgradeDetails: propertyStrategy === 'upgrade' ? upgradeDetails : null,
                reverseMortgageDetails: overallStrategy.reverseMortgage || propertyStrategy === 'reverseMortgage' ? reverseMortgageDetails : null,
                heasDetails: overallStrategy.heas || propertyStrategy === 'heas' ? heasDetails : null,
                selectedFundingStrategy: selectedFundingStrategy,
                annuityRecord: selectedFundingStrategy === 'annuity' ? annuityRecord : null,
                // The record the annuity was applied with, so the plan's position can be rebuilt (Action Plan forms).
                annuityRecordForCalculation: selectedFundingStrategy === 'annuity' ? annuityRecordForCalculation : null,
                debtPayments: debtPayments,
                debtFunding: debtFunding,
                debtRepaymentBasis: debtRepaymentBasis,
                agedCareContext: selectedAgedCareStrategyId ? 'linked' : 'current',
                selectedAgedCareStrategyId: selectedAgedCareStrategyId || null,
                // The household it was priced on: the whole aged care plan carried in, or none (sahChosenStale.ts).
                householdFingerprint: (0, $2eb5e3232a8b6136$export$ef78d200e1ff7453)(selectedAgedCareStrategyId ? String(selectedAgedCareStrategyId) : null),
                overallStrategy: overallStrategy,
                servicePlan: resolvedServicePlan.plan,
                servicePlanFingerprint: JSON.stringify(servicePlanSource ?? {}),
                // The card as chosen — the plan page shows and explains it from this (sahChosenPlan.ts).
                card: (0, $b2a376f07fa94da4$export$5414d0f4d2450da0)({
                    plan: manualPlanFigures,
                    baseline: manualBaseFigures,
                    words: manualWords,
                    drawLines: (0, $f7f18ba87194b6fe$export$29c4d395a04f1ae)((0, $f7f18ba87194b6fe$export$86fd7ba8b86f4a5e)(factFind, optimizedScenario?.optimizedFactFind)),
                    riskKinds: manualPieces.flatMap((p)=>(0, $203e38d6e6c434f4$export$e1aeab26ad581b54)(String(p.type), String(p.name || ''))),
                    horizonYears: Number(legacyYears) || 10,
                    origin: 'manual',
                    moved: (0, $854c582fbab4f7c2$export$b086ef70c5d0268c)(manualPieces.length > 1 ? {
                        type: 'combination',
                        steps: manualPieces
                    } : manualPieces[0]).amount
                })
            },
            outputs: {
                // The card's own figures, so Home and the advice document quote what was chosen.
                annualContribution: manualPlanFigures.contribution,
                agePension: manualPlanFigures.pension,
                cashFlow: manualPlanFigures.cashflow,
                cashFlowBasis: 'net_of_service_plan',
                legacyEstimate: manualPlanFigures.legacy,
                netWorthSchedule: (0, $a882fd27fa2c97d8$export$7386c6396507d94b)(projections),
                financials: afterFinancials,
                contributionRates: afterContributionData?.contributionRates || {},
                servicePlanBasis: currentServicePlanBasis
            },
            baseline: manualBaseFigures ? {
                legacyValue: manualBaseFigures.legacy,
                pension: manualBaseFigures.pension,
                cashFlow: manualBaseFigures.cashflow,
                contribution: manualBaseFigures.contribution
            } : null,
            chosen: true,
            createdAt: earlier?.createdAt || new Date().toISOString()
        };
        (0, $dabe6813042a6e48$export$e66848783651d59b)(strategy);
        // What the advice document needs, captured as it stands now (Get the advice document).
        setManualSoaOffer({
            strategy: strategy,
            projections: (projectionsForModal || projections) ?? null
        });
        setManualSoaDeferred(true);
    };
    // The plan page asked for the advice document of a plan built by hand: open it once it is priced.
    const manualAdviceRequested = (0, $acw62.useRef)(hubIntent?.kind === 'document');
    (0, $acw62.useEffect)(()=>{
        if (!manualAdviceRequested.current || internalStrategyMode !== 'manual' || !manualPlanFigures || !manualChosen) return;
        manualAdviceRequested.current = false;
        openManualDigitalSoa();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        internalStrategyMode,
        manualPlanFigures,
        manualChosen
    ]);
    // The plan page asked for a hand-built plan's year-by-year figures: open them once it is priced.
    const manualYearByYearRequested = (0, $acw62.useRef)(hubIntent?.kind === 'yearByYear');
    (0, $acw62.useEffect)(()=>{
        if (!manualYearByYearRequested.current || internalStrategyMode !== 'manual' || !manualPlanFigures) return;
        manualYearByYearRequested.current = false;
        setShowProjectionsModal(true);
    }, [
        internalStrategyMode,
        manualPlanFigures
    ]);
    const sahInBrief = (0, $acw62.useMemo)(()=>{
        if (!sahPlanSummaryName) return null;
        const contribBefore = sahContributionBefore;
        const contribAfter = sahContributionAfter;
        const pensionDelta = (impactAfterFinancials?.socialSecurity ?? 0) - (beforeFinancials?.socialSecurity ?? 0);
        const cashflowDelta = (sahCashFlowAfter ?? 0) - (sahCashFlowBefore ?? 0);
        const legacyDelta = sahDoNothingLegacy != null && impactProjectedLegacy != null ? impactProjectedLegacy - sahDoNothingLegacy : null;
        const clauses = [];
        /*
         * NO DOLLARS WITHOUT A SERVICE PLAN. Out-of-pocket is budget x rate, and until a plan exists
         * the budget is the illustrative package's. Quoting "your share falls from $7,722 to $3,929"
         * against services nobody has chosen puts a placeholder in the sentence a client remembers.
         * The RATE movement is real either way, so that is what leads instead.
         */ if (resolvedServicePlan.isEstimated) {
            const rateBefore = beforeContributionData?.contributionRates?.everydayLiving;
            const rateAfter = afterContributionData?.contributionRates?.everydayLiving;
            if (rateBefore != null && rateAfter != null && rateBefore !== rateAfter) // A FALLING rate is good news here — the client pays a smaller share.
            clauses.push({
                tone: rateAfter < rateBefore ? 'good' : 'bad',
                text: `the everyday living rate ${rateAfter < rateBefore ? 'falls' : 'rises'} from ${(rateBefore * 100).toFixed(1)}% to ${(rateAfter * 100).toFixed(1)}% (the dollars follow once a service plan is built)`
            });
        } else if (contribBefore != null && contribAfter != null && Math.round(contribBefore - contribAfter) !== 0) {
            const down = contribAfter < contribBefore;
            clauses.push({
                term: 'your share of care costs',
                tone: down ? 'good' : 'bad',
                text: `your share of care costs ${down ? 'falls' : 'rises'} from ${formatCurrency(contribBefore)} to ${formatCurrency(contribAfter)} a year`
            });
        } else if (contribAfter != null) clauses.push((0, $77fab72f16be36e5$export$b3ed29c9fd98e367)(`your share of care costs stays at ${formatCurrency(contribAfter)} a year`));
        clauses.push((0, $77fab72f16be36e5$export$188f8646230c48f)(pensionDelta));
        if (Math.round(cashflowDelta) !== 0) clauses.push((0, $77fab72f16be36e5$export$32179680de3fc4e3)(cashflowDelta, sahCashFlowAfter));
        if (legacyDelta != null) clauses.push((0, $77fab72f16be36e5$export$ca3c952791480bf6)(legacyDelta, Number(legacyYears) || 0));
        if (!clauses.length) return null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77fab72f16be36e5$export$f24d825672d9bf01), {
            clauses: clauses
        });
    }, [
        sahPlanSummaryName,
        beforeContributionData,
        afterContributionData,
        impactAfterFinancials,
        beforeFinancials,
        sahDoNothingLegacy,
        impactProjectedLegacy,
        legacyYears,
        resolvedServicePlan,
        sahCashFlowAfter,
        sahCashFlowBefore,
        sahContributionBefore,
        sahContributionAfter
    ]);
    const rightColumnBlurred = isSuggestionMode && !showBaseline;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: isSuggestionMode ? 'space-y-6' : 'grid grid-cols-1 xl:grid-cols-5 gap-8 items-start',
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: isSuggestionMode ? 'space-y-6' : 'xl:col-span-3 space-y-6',
                        children: [
                            !sahSeAnalyzing && !stepped && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white rounded-xl border border-gray-200 px-6 py-4 shadow-sm flex flex-wrap items-center justify-between gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-sm text-slate-700",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-semibold text-slate-900",
                                                children: "Support services start:"
                                            }),
                                            ' ',
                                            supportStartDate && !supportStartInPast ? new Date(`${supportStartDate}T00:00:00`).toLocaleDateString('en-AU', {
                                                day: 'numeric',
                                                month: 'long',
                                                year: 'numeric'
                                            }) : 'from today',
                                            supportStartInPast && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "ml-2 text-xs text-amber-700",
                                                children: "A past date models as \u201Calready receiving support\u201D."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>onNavigateToBuilder?.(),
                                        className: "text-sm font-semibold text-blue-700 underline underline-offset-2 hover:text-blue-900",
                                        children: "Change it in Service Builder \u203A"
                                    })
                                ]
                            }),
                            !sahSeAnalyzing && !isSuggestionMode && !stepped && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e917fb170bd7792b$export$2e2bcd8739ae039), {
                                factFind: factFind,
                                before: beforeFinancials,
                                careContribution: sahContributionBefore != null ? {
                                    amount: sahContributionBefore,
                                    planName: servicePlanName
                                } : null,
                                runwayHeadline: startingRunway?.headline ?? null,
                                runwayDetail: startingRunway?.flag ?? null,
                                startingLegacy: sahDoNothingLegacy,
                                legacyYears: legacyYears,
                                onLegacyYearsChange: setLegacyYears
                            }),
                            !sahSeAnalyzing && !stepped && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$28c8139bd562d0e), {
                                eyebrow: resolvedServicePlan.isEstimated ? 'What these figures are priced on' : 'Your service plan',
                                className: "mb-0",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$97060599ed0e6525), {
                                    /* Amber earns its place only when the basis is a placeholder — that IS a
                               "check this". A real plan is a plain statement of fact. */ tone: resolvedServicePlan.isEstimated ? 'warn' : 'info',
                                    heading: resolvedServicePlan.isEstimated ? "No service plan built yet \u2014 an illustrative package is standing in" : 'Priced on the plan you built',
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex items-start justify-between gap-3 flex-wrap",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "min-w-0 leading-relaxed text-slate-700",
                                                    children: resolvedServicePlan.isEstimated ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-semibold text-slate-900",
                                                                children: "No service plan built yet"
                                                            }),
                                                            " \u2014 these figures use an illustrative typical package as the basis",
                                                            resolvedServicePlan.description && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                children: [
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                                                        term: "(what's in it?)",
                                                                        children: resolvedServicePlan.description
                                                                    })
                                                                ]
                                                            }),
                                                            "."
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            "These figures are priced on",
                                                            ' ',
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-semibold text-slate-900",
                                                                children: servicePlanResolution.origin.kind === 'current' ? servicePlanResolution.origin.basedOnName ? `the saved plan \u{201C}${servicePlanResolution.origin.basedOnName}\u{201D} (loaded in Service Builder)` : 'the services currently selected in Service Builder (not yet saved as a plan)' : servicePlanResolution.origin.kind === 'saved' ? `the saved plan \u201c${servicePlanResolution.origin.name}\u201d${servicePlanResolution.origin.savedCount > 1 ? ` (most recent of ${servicePlanResolution.origin.savedCount} saved)` : ''}` : servicePlanResolution.origin.kind === 'restore' ? servicePlanResolution.origin.name : 'the service plan built in Service Builder'
                                                            }),
                                                            servicePlanStats && servicePlanStats.serviceCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                children: [
                                                                    ' ',
                                                                    "\u2014 ",
                                                                    servicePlanStats.serviceCount,
                                                                    ' ',
                                                                    servicePlanStats.serviceCount === 1 ? 'service' : 'services',
                                                                    ", about",
                                                                    ' ',
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                        className: "font-semibold text-slate-900",
                                                                        children: [
                                                                            formatCurrency(servicePlanStats.annualValue),
                                                                            "/yr"
                                                                        ]
                                                                    }),
                                                                    ' ',
                                                                    "of care"
                                                                ]
                                                            }),
                                                            "."
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    onClick: onNavigateToBuilder,
                                                    className: "shrink-0 text-sm font-semibold text-blue-700 underline underline-offset-2 hover:text-blue-900",
                                                    children: [
                                                        resolvedServicePlan.isEstimated ? 'Build the service plan' : 'Change it in Service Builder',
                                                        " \u203A"
                                                    ]
                                                })
                                            ]
                                        }),
                                        emptySavedServicePlans.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "mt-2 text-xs text-amber-700",
                                            children: [
                                                emptySavedServicePlans.map((p)=>`\u{201C}${p.name}\u{201D}`).join(', '),
                                                ' ',
                                                emptySavedServicePlans.length === 1 ? 'has' : 'have',
                                                " no services in ",
                                                emptySavedServicePlans.length === 1 ? 'it' : 'them',
                                                ", so",
                                                ' ',
                                                emptySavedServicePlans.length === 1 ? 'it' : 'they',
                                                " can't be priced \u2014 open the Service Builder, add services and save again."
                                            ]
                                        }),
                                        savedServicePlans.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            className: "mt-2 flex flex-wrap items-center gap-2 text-xs text-slate-600",
                                            children: [
                                                "Service plan:",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                    value: selectedSavedPlanId,
                                                    onChange: (e)=>{
                                                        if (e.target.value === '') {
                                                            (0, $08809b7a4fc47e27$export$fbf5e96f5cc7576c)();
                                                            setPlanPickVersion((v)=>v + 1);
                                                            return;
                                                        }
                                                        const picked = savedServicePlans.find((p)=>p.id === e.target.value);
                                                        if (!picked) return;
                                                        (0, $08809b7a4fc47e27$export$1016adb776409d6)(picked.plan, picked.name);
                                                        setPlanPickVersion((v)=>v + 1);
                                                    },
                                                    className: "rounded-lg border border-gray-300 px-2 py-1 text-xs",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "",
                                                            children: "No service plan \u2014 my current position"
                                                        }),
                                                        savedServicePlans.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: p.id,
                                                                children: p.name
                                                            }, p.id)),
                                                        selectedSavedPlanId === $d6188f49626b9d12$var$UNSAVED_PLAN_OPTION && /* Selections exist in the builder that were never saved. Naming
                                           them keeps the control honest rather than showing "none". */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: $d6188f49626b9d12$var$UNSAVED_PLAN_OPTION,
                                                            children: "Services selected in Service Builder (not saved)"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "mt-1.5 text-xs leading-relaxed text-slate-500",
                                            children: [
                                                "You can optimise from here \u2014 the ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "font-medium text-slate-700",
                                                    children: "contribution rates"
                                                }),
                                                ' ',
                                                "below are set by the means assessment and hold whatever services are chosen. The",
                                                ' ',
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "font-medium text-slate-700",
                                                    children: "dollar amounts"
                                                }),
                                                " are the illustrative package's until a real plan is built, so build the service plan when you can and these figures re-price against it."
                                            ]
                                        })
                                    ]
                                })
                            }),
                            internalStrategyMode === 'manual' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-card",
                                "data-testid": "sah-manual-banner",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-[14px] text-slate-700",
                                        children: manualSeededFrom ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "font-semibold text-slate-900",
                                                    children: [
                                                        "Customising \u201C",
                                                        manualSeededFrom,
                                                        "\u201D."
                                                    ]
                                                }),
                                                ' ',
                                                "Change any piece; the figures on the right move as you do."
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "font-semibold text-slate-900",
                                                    children: "Building a plan yourself."
                                                }),
                                                ' ',
                                                "Set each piece; the figures on the right move as you do."
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-wrap items-center gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>buildFromEnginePlan(null),
                                                className: "text-[13px] font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                                "data-testid": "sah-clear-start-again",
                                                children: "Clear and start again"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>{
                                                    handleStrategyModeChange('suggestion');
                                                    (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
                                                },
                                                className: "inline-flex items-center gap-1.5 text-[13px] font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                                "data-testid": "sah-back-to-plans",
                                                children: "\u2039 Back to the tested plans"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            internalStrategyMode === 'suggestion' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f870b25d8dcbe02f$export$2e2bcd8739ae039), {
                                onSoaGenerated: onSoaGenerated,
                                supportStartDate: supportStartInPast ? '' : supportStartDate,
                                factFind: factFind,
                                setFactFind: setFactFind,
                                // getServicePlanFromStorage's StoredServicePlan is deliberately loose (JSON.parse'd
                                // from sessionStorage); SupportAtHomeServicePlan is the strict in-memory shape the
                                // panel expects — same runtime data, structurally-incompatible declared types.
                                servicePlan: servicePlanSource,
                                goals: factFind.goals || {},
                                onStrategySelect: (strategy)=>{
                                    setSahSeSelectedStrategy(strategy);
                                },
                                selectedStrategy: sahSeSelectedStrategy,
                                legacyYears: legacyYears,
                                onLegacyYearsChange: setLegacyYears,
                                bindingTest: sahBindingTest,
                                onBuildYourOwn: buildFromEnginePlan,
                                openAdviceWhenReady: hubIntent?.kind === 'document',
                                openYearByYearWhenReady: hubIntent?.kind === 'yearByYear',
                                onNavigateToDashboard: ()=>onNavigateToDashboard?.(),
                                autoOpenOnMount: true,
                                selectedAgedCareIntegration: selectedAgedCareIntegration,
                                onGoToServiceBuilder: onNavigateToBuilder,
                                showBaseline: showBaseline,
                                setShowBaseline: setShowBaseline,
                                homeCareSaveContext: {
                                    participantType: participantType,
                                    nwopCategory: nwopCategory,
                                    meansDisclosed: meansDisclosed,
                                    previousITCF: previousITCF,
                                    isPartnered: isPartnered
                                },
                                onAnalysisStateChange: setSahSeAnalyzing
                            }),
                            internalStrategyMode === 'manual' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-6",
                                children: [
                                    hasAgedCareStrategies && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-white rounded-xl border border-gray-200 p-6 shadow-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                className: "text-lg font-bold text-gray-900 mb-4 flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-blue-600"
                                                    }),
                                                    (()=>{
                                                        const e = (0, $5ea55f03cd2af1e4$export$2205ffc60cf2c238)(factFind);
                                                        const n = e ? String((e === 'client' ? factFind?.client?.firstName : factFind?.partner?.firstName) || '').trim() : '';
                                                        return n ? `${n}'s aged care plan` : 'The aged care plan';
                                                    })()
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-600 mb-4",
                                                children: "Choose a saved aged care plan to include the deposit it pays and its yearly fees in these figures. Everything below then follows it."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "space-y-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        className: "text-sm font-medium text-gray-700",
                                                        children: "Which aged care plan"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        value: selectedAgedCareStrategyId || '',
                                                        onChange: (event)=>setSelectedAgedCareStrategyId(event.target.value || null),
                                                        className: "w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "",
                                                                children: "None \u2014 leave aged care out"
                                                            }),
                                                            availableAgedCareStrategies.map((strategy)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                                                    value: strategy.id,
                                                                    children: [
                                                                        (0, $95e43332fd84eec4$export$6cc0d9545ae1511e)(strategy, factFind),
                                                                        " \u2013 care ",
                                                                        formatCurrency(strategy.outputs?.agedCareCost || 0),
                                                                        " a year"
                                                                    ]
                                                                }, strategy.id))
                                                        ]
                                                    })
                                                ]
                                            }),
                                            selectedAgedCareIntegration && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mt-4 bg-slate-50 border border-slate-200 rounded-lg p-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex flex-wrap gap-6 text-sm text-blue-900",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex-1 min-w-[160px]",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        className: "font-semibold text-blue-800",
                                                                        children: "Annual aged care fees"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        className: "text-xl font-bold",
                                                                        children: formatCurrency(selectedAgedCareIntegration.annualCost)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex-1 min-w-[160px]",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        className: "font-semibold text-blue-800",
                                                                        children: "RAD paid upfront"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        className: "text-xl font-bold",
                                                                        children: formatCurrency(selectedAgedCareIntegration.radPaid || 0)
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mt-4 text-xs text-blue-700 flex items-center gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                                                className: "w-4 h-4"
                                                            }),
                                                            "We automatically reduce the household assets by the RAD funding and subtract the ongoing daily fees from cashflow."
                                                        ]
                                                    }),
                                                    integrationSummary && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "mt-2 text-xs leading-relaxed text-blue-900",
                                                        children: [
                                                            "Linking this also changes the ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "Age Pension assessment"
                                                            }),
                                                            ": with",
                                                            ' ',
                                                            integrationSummary.personName,
                                                            " in residential care",
                                                            integrationSummary.illnessSeparated && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                children: [
                                                                    ", the household is assessed as an",
                                                                    ' ',
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                                                        term: "illness-separated couple"
                                                                    }),
                                                                    " \u2014 each paid at the higher single rate, with more generous thresholds"
                                                                ]
                                                            }),
                                                            integrationSummary.radPaid > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                children: [
                                                                    ", and the ",
                                                                    formatCurrency(integrationSummary.radPaid),
                                                                    " RAD is exempt from the pension assets test"
                                                                ]
                                                            }),
                                                            ". The Age Pension figure on the right already includes this."
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-white rounded-xl border border-gray-200 p-6 shadow-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                className: "text-lg font-bold text-gray-900 mb-4 flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6315759428919b56$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-blue-600"
                                                    }),
                                                    "Gifts"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-600 mb-4",
                                                children: "Centrelink allows you to gift up to $10,000 per year and $30,000 over a rolling 5-year period. Gifts within these thresholds are not included in your asset test."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex items-center gap-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                    label: "Annual Gifting Amount:",
                                                    value: manualStrategies.gifting ?? '',
                                                    onChange: (v)=>setManualStrategies({
                                                            ...manualStrategies,
                                                            gifting: v ?? 0
                                                        }),
                                                    className: "w-40"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5251f2fd5a52d9c7$export$27d5013e22d977ca), {
                                                giftingAmount: Number(manualStrategies.gifting) || 0,
                                                giftsHistory: factFind.giftsHistory
                                            }),
                                            Number(manualStrategies.gifting) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mt-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        className: "text-sm font-medium text-gray-700",
                                                        children: "Source of funds:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        value: manualStrategies.giftingSource,
                                                        onChange: (e)=>setManualStrategies({
                                                                ...manualStrategies,
                                                                giftingSource: e.target.value
                                                            }),
                                                        className: "mt-2 w-full px-3 py-2 border border-gray-300 rounded-lg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "bank",
                                                                children: "From Bank Account"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "abp",
                                                                children: "From Account-Based Pension"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "shares",
                                                                children: "From Shares Portfolio"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-white rounded-xl border border-gray-200 p-6 shadow-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                className: "text-lg font-bold text-gray-900 mb-4 flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-blue-600"
                                                    }),
                                                    "Funeral Bonds"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-sm text-gray-600 mb-4",
                                                children: [
                                                    "Funeral bonds are excluded from asset testing for both the Age Pension and Support at Home assessments \u2014 but only up to ",
                                                    formatCurrency((0, $1abe73eeef086faf$export$aca3edb7cd7a3f17)),
                                                    " per person (indexed each year). Above that the exemption is lost, so there is no strategy benefit in going higher."
                                                ]
                                            }),
                                            (()=>{
                                                /*
                                 * Capped at the household's REMAINING exemption headroom (owner-caught,
                                 * 2026-08-25): unlike gifting — where exceeding the free areas is a
                                 * legitimate choice the engine prices as deprivation — a bond above the
                                 * limit simply isn't exempt, so the input never offers a move with no
                                 * upside. Bonds already owned use up headroom first.
                                 */ const existingBonds = (factFind?.assets?.funeralBonds || []).reduce((sum, bond)=>sum + (parseFloat(String(bond?.value)) || 0), 0);
                                                const headroom = Math.max(0, (0, $1abe73eeef086faf$export$aca3edb7cd7a3f17) * (isPartnered ? 2 : 1) - existingBonds);
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "flex items-center gap-4",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                                label: "Additional Funeral Bond Purchase:",
                                                                value: manualStrategies.funeralBonds ?? '',
                                                                onChange: (v)=>setManualStrategies({
                                                                        ...manualStrategies,
                                                                        funeralBonds: Math.min(v ?? 0, headroom)
                                                                    }),
                                                                className: "w-40"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "mt-1 text-xs text-slate-500",
                                                            children: [
                                                                "Room left within the exemption: ",
                                                                formatCurrency(headroom),
                                                                existingBonds > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                    children: [
                                                                        " (",
                                                                        formatCurrency(existingBonds),
                                                                        " of bonds already held)"
                                                                    ]
                                                                }),
                                                                "."
                                                            ]
                                                        })
                                                    ]
                                                });
                                            })(),
                                            Number(manualStrategies.funeralBonds) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mt-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        className: "text-sm font-medium text-gray-700",
                                                        children: "Source of funds:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        value: manualStrategies.funeralSource,
                                                        onChange: (e)=>setManualStrategies({
                                                                ...manualStrategies,
                                                                funeralSource: e.target.value
                                                            }),
                                                        className: "mt-2 w-full px-3 py-2 border border-gray-300 rounded-lg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "bank",
                                                                children: "From Bank Account"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "abp",
                                                                children: "From Account-Based Pension"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "shares",
                                                                children: "From Shares Portfolio"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $d1b9bbc5238c0548$export$2f999b99c41ee933)(factFind) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-white rounded-xl border border-gray-200 p-6 shadow-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                className: "text-lg font-bold text-gray-900 mb-4 flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bee7e1f6335e67ab$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-blue-600"
                                                    }),
                                                    "Your home"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-600 mb-4",
                                                children: "Choose how you would like to release equity from your home. Select one option below to configure the details."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "grid gap-3 md:grid-cols-3 lg:grid-cols-5",
                                                children: [
                                                    {
                                                        id: 'downsize',
                                                        title: 'Downsize family home',
                                                        description: 'Sell current home, buy lower-cost property, redirect surplus capital.'
                                                    },
                                                    {
                                                        id: 'renovate',
                                                        title: 'Renovate home',
                                                        description: 'Home improvements convert assessable assets into exempt home equity.'
                                                    },
                                                    {
                                                        id: 'upgrade',
                                                        title: 'Upgrade home',
                                                        description: 'Buy more expensive home to convert assessable assets into exempt home equity.'
                                                    },
                                                    {
                                                        id: 'reverseMortgage',
                                                        title: 'Reverse mortgage',
                                                        description: 'Borrow against equity in home to fund needs.'
                                                    },
                                                    {
                                                        id: 'heas',
                                                        title: 'Home Equity Access Scheme',
                                                        description: 'Government program providing fortnightly payments secured on your home.'
                                                    }
                                                ].map((option)=>{
                                                    const isSelected = propertyStrategy === option.id;
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>setPropertyStrategy(option.id),
                                                        className: `text-left border rounded-lg p-4 transition-all duration-200 h-full flex flex-col ${isSelected ? 'border-blue-500 bg-blue-50 shadow-sm' : 'border-gray-200 hover:border-blue-300 hover:bg-blue-50/40'}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex items-start gap-2 mb-4 h-[4rem]",
                                                                children: [
                                                                    option.id === 'downsize' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bee7e1f6335e67ab$export$2e2bcd8739ae039), {
                                                                        className: "w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5"
                                                                    }),
                                                                    option.id === 'renovate' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $888d8be60abebd94$export$2e2bcd8739ae039), {
                                                                        className: "w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5"
                                                                    }),
                                                                    option.id === 'upgrade' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {
                                                                        className: "w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5"
                                                                    }),
                                                                    option.id === 'reverseMortgage' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e71d8988c230db1b$export$2e2bcd8739ae039), {
                                                                        className: "w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5"
                                                                    }),
                                                                    option.id === 'heas' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                                                        className: "w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "font-semibold text-gray-900 leading-tight",
                                                                        children: option.title
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-xs text-gray-600 leading-relaxed flex-grow mb-3",
                                                                children: option.description
                                                            }),
                                                            isSelected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "mt-auto text-xs font-medium text-blue-700 pt-2 border-t border-blue-200",
                                                                children: "Selected"
                                                            })
                                                        ]
                                                    }, option.id);
                                                })
                                            }),
                                            propertyStrategy !== 'none' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mt-3 text-xs text-gray-500",
                                                children: [
                                                    "Want to remove this strategy?",
                                                    ' ',
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>setPropertyStrategy('none'),
                                                        className: "text-blue-600 underline",
                                                        children: "Clear selection"
                                                    })
                                                ]
                                            }),
                                            propertyStrategy === 'none' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "mt-4 text-xs text-gray-500",
                                                children: "Select a property strategy to see the detailed inputs."
                                            })
                                        ]
                                    }),
                                    propertyStrategy && propertyStrategy !== 'none' && (0, $d1b9bbc5238c0548$export$2f999b99c41ee933)(factFind) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-white rounded-xl border border-gray-200 p-6 shadow-sm",
                                        children: [
                                            propertyStrategy === 'downsize' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c310d81356fecc7e$export$8098031801c7a587), {
                                                factFind: householdFactFind,
                                                details: downsizeDetails,
                                                setDetails: setDownsizeDetails
                                            }),
                                            propertyStrategy === 'reverseMortgage' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c310d81356fecc7e$export$e19b2ab69dc18268), {
                                                        factFind: householdFactFind,
                                                        details: reverseMortgageDetails,
                                                        setDetails: setReverseMortgageDetails,
                                                        legacyYears: legacyYears
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5251f2fd5a52d9c7$export$c1d13bc22d751693), {
                                                        loanAmount: Number(reverseMortgageDetails?.loanAmount) || 0,
                                                        interestRate: Number(reverseMortgageDetails?.interestRate) || 0,
                                                        years: Number(legacyYears) || 5
                                                    })
                                                ]
                                            }),
                                            propertyStrategy === 'heas' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c310d81356fecc7e$export$f3b4e44bb85b922c), {
                                                        factFind: householdFactFind,
                                                        details: heasDetails,
                                                        setDetails: setHeasDetails,
                                                        legacyYears: legacyYears
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5251f2fd5a52d9c7$export$eb9068fa2f8e69f7), {
                                                        paymentAmount: Number(heasDetails?.paymentAmount) || 0,
                                                        paymentFrequency: String(heasDetails?.paymentFrequency || 'fortnightly'),
                                                        interestRate: Number(heasDetails?.interestRate) || 0,
                                                        years: Number(legacyYears) || 5
                                                    })
                                                ]
                                            }),
                                            propertyStrategy === 'renovate' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c310d81356fecc7e$export$9dc03ebf37a655a), {
                                                factFind: householdFactFind,
                                                details: renovateDetails,
                                                setDetails: setRenovateDetails,
                                                beforeFinancials: beforeFinancials ?? undefined
                                            }),
                                            propertyStrategy === 'upgrade' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c310d81356fecc7e$export$6c56a95ed2b3736d), {
                                                factFind: householdFactFind,
                                                details: upgradeDetails,
                                                setDetails: setUpgradeDetails,
                                                beforeFinancials: beforeFinancials ?? undefined
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-white rounded-xl border border-gray-200 p-6 shadow-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                className: "text-lg font-bold text-gray-900 mb-3 flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-blue-600"
                                                    }),
                                                    "Other options"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-600 mb-4",
                                                children: "These optional strategies reshape your assets and income so you may qualify for more Age Pension support and reduce out-of-pocket care fees."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "grid gap-3 md:grid-cols-2",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    onClick: ()=>{
                                                        const newValue = selectedFundingStrategy === 'annuity' ? null : 'annuity';
                                                        setSelectedFundingStrategy(newValue);
                                                        if (newValue === 'annuity' && !annuityRecord) setAnnuityRecord(initializeAnnuityRecord());
                                                        else if (newValue === null) setAnnuityRecord(null);
                                                    },
                                                    className: `text-left border rounded-lg p-4 transition-all duration-200 ${selectedFundingStrategy === 'annuity' ? 'border-blue-500 bg-blue-50 shadow-sm' : 'border-gray-200 hover:border-blue-300 hover:bg-blue-50/40'}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex items-center gap-2 mb-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                                                    className: "w-5 h-5 text-blue-600"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "font-semibold text-gray-900",
                                                                    children: "Commence an annuity"
                                                                }),
                                                                selectedFundingStrategy === 'annuity' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d137e5221e5cfba5$export$2e2bcd8739ae039), {
                                                                    tone: "info",
                                                                    className: "ml-auto",
                                                                    children: "Selected"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-xs text-gray-600 mb-2",
                                                            children: "Convert savings into guaranteed income. May reduce assessable assets and help cover ongoing care costs."
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex gap-2 flex-wrap text-[11px]",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d137e5221e5cfba5$export$2e2bcd8739ae039), {
                                                                    tone: "info",
                                                                    children: "Age Pension Focus"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d137e5221e5cfba5$export$2e2bcd8739ae039), {
                                                                    tone: "neutral",
                                                                    children: "Cashflow Stability"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            selectedFundingStrategy === 'annuity' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "mt-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a72ca5744dce23c$export$2e2bcd8739ae039), {
                                                    factFind: optimizedScenario?.optimizedFactFind || factFind,
                                                    annuityDetails: annuityRecord,
                                                    setAnnuityDetails: (updater)=>setAnnuityRecord((prev)=>{
                                                            const base = prev ?? initializeAnnuityRecord();
                                                            return typeof updater === 'function' ? updater(base) : updater;
                                                        }),
                                                    annuitySummary: annuitySummary,
                                                    annuityWarnings: annuityWarnings,
                                                    fundingSources: availableAnnuityFundingSources,
                                                    formatCurrency: formatCurrency,
                                                    clientAge: factFind?.client?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client.dob) : null,
                                                    partnerAge: isPartnered && factFind?.partner?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner.dob) : null,
                                                    onIncomeOnlyUnderstoodChange: setIncomeOnlyUnderstood,
                                                    // Above the client's ceiling, a caution (not a block): the same money the tested plans size against.
                                                    ceilingInvestable: (0, $e4aa20091e5d9c16$export$8a06018655d03e9e)(factFind, Number(factFind?.goals?.sahEmergencyReserve) || undefined).amount,
                                                    ceilingFactFind: factFind
                                                })
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "mt-4 text-xs text-gray-500",
                                                children: "Select a strategy above to view the explainer and customise the details."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35f2741dc40fa45c$export$2e2bcd8739ae039), {
                                        factFind: householdFactFind,
                                        debtPayments: debtPayments,
                                        setDebtPayments: setDebtPayments,
                                        debtFunding: debtFunding,
                                        setDebtFunding: setDebtFunding,
                                        repaymentBasis: debtRepaymentBasis,
                                        setRepaymentBasis: setDebtRepaymentBasis,
                                        competingUseNote: "The money comes from the same assets that fund your care and living costs at home, so clearing a debt trades the ongoing repayments for a smaller buffer."
                                    }),
                                    hasStrategies && manualPlanFigures && (manualAnnuity || manualEquityRelease) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
                                        "data-testid": "sah-manual-plan-detail",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                className: "text-lg font-semibold text-gray-900 mb-3",
                                                children: manualEquityRelease && !manualAnnuity ? 'The loan against the home' : 'What the family gets back'
                                            }),
                                            manualEquityRelease && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $680e2cea6da0f2e4$export$45232555cfe21303), {
                                                className: "mb-3",
                                                kind: manualEquityRelease.kind,
                                                loanAmount: manualEquityRelease.loanAmount,
                                                interestRate: manualEquityRelease.interestRate || null,
                                                projectedBalance: manualEquityRelease.projectedBalance || null,
                                                years: manualEquityRelease.years || null,
                                                homeValue: Number(factFind?.home?.value) || null
                                            }),
                                            manualAnnuity && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
                                                factFind: factFind,
                                                personName: (0, $dd66c4f756bb6b40$export$b2f4bd9ebed41c37)(factFind, manualAnnuity.owner),
                                                amount: manualAnnuity.amount,
                                                kind: manualAnnuity.kind,
                                                incomeAYear: (0, $dd66c4f756bb6b40$export$75e3f249f9924fd2)(projections, factFind) ?? (Number(annuitySummary?.annualPayment) || null),
                                                rows: projections,
                                                // The support alone is the same plan without it only when the guaranteed income is the one piece set.
                                                compareRows: manualAnnuity.only && sahDoNothingRun.rows?.length ? sahDoNothingRun.rows : null,
                                                compareNote: manualAnnuity.only ? (0, $dd66c4f756bb6b40$export$ea81c21b74f64dcc) : null,
                                                horizonYears: Number(legacyYears) || 10,
                                                testId: "sah-manual-annuity-family-panel"
                                            })
                                        ]
                                    }),
                                    manualExplainOpen && manualPlanFigures && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $12084f898a868747$export$2e2bcd8739ae039), {
                                        eyebrow: "Explain this",
                                        title: manualWords.title,
                                        intro: `Each line says what ${sahWho.they} do, and what that does to the numbers. ${(0, $1a5a24a0286ded56$export$c9c6ca79dc334e31).sentence}`,
                                        onClose: ()=>setManualExplainOpen(false),
                                        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                            type: "button",
                                            variant: "secondary",
                                            onClick: ()=>{
                                                setManualExplainOpen(false);
                                                setShowProjectionsModal(true);
                                            },
                                            children: "See the year-by-year figures"
                                        }),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca9b5cdfbd99e645$export$68e00db93a37b932), {
                                            doSentence: `${manualWords.title}${manualWords.sub ? ` \u{2014} ${manualWords.sub.replace(/^Paid from /, 'paid from ').replace(/\.$/, '')}` : ''}.`,
                                            treatment: manualWords.treatment,
                                            leverKinds: (0, $f7f18ba87194b6fe$export$caaafd80ea6c3706)(manualPieces.length > 1 ? {
                                                type: 'combination',
                                                steps: manualPieces
                                            } : manualPieces[0]),
                                            plan: manualPlanFigures,
                                            baseline: manualBaseFigures,
                                            horizonYears: Number(legacyYears) || 10,
                                            possessive: sahWho.their,
                                            they: sahWho.they,
                                            drawLines: (0, $f7f18ba87194b6fe$export$29c4d395a04f1ae)((0, $f7f18ba87194b6fe$export$86fd7ba8b86f4a5e)(factFind, optimizedScenario?.optimizedFactFind)),
                                            debtsNote: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe4e1ee5e30419ba$export$2e2bcd8739ae039), {
                                                factFind: factFind,
                                                clearedAmount: (0, $afba33f9e18e15f2$export$52f9380165cafdac)(manualPieces.length > 1 ? {
                                                    type: 'combination',
                                                    steps: manualPieces
                                                } : manualPieces[0]),
                                                years: Number(legacyYears) || 10,
                                                context: "manual"
                                            }),
                                            moneyStory: (()=>{
                                                // Where a short year is drawn from, account by account, off the built plan's own rows.
                                                const rows = projections || [];
                                                const story = (0, $0fe89e03b6df746e$export$693cc3146baa3244)(rows).hasDeficit ? (0, $2ddaae90639b5011$export$bdea18f456fd84b)({
                                                    rows: rows,
                                                    factFind: factFind,
                                                    runway: (0, $0fe89e03b6df746e$export$464558962ff4a811)(rows, rows.length),
                                                    deposit: {
                                                        paid: 0,
                                                        refundTo: ''
                                                    },
                                                    horizonYears: Number(legacyYears) || 10,
                                                    enteringName: factFind?.client?.firstName || 'The household',
                                                    spentOn: 'the plan'
                                                }) : null;
                                                return story ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ddaae90639b5011$export$1a915263dc5391f1), {
                                                    story: story,
                                                    testId: "sah-money-story"
                                                }) : null;
                                            })()
                                        })
                                    }),
                                    manualFigurePage && manualPlanFigures && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca9b5cdfbd99e645$export$e203066bca492ea1), {
                                        planTitle: manualWords.title,
                                        plan: manualPlanFigures,
                                        baseline: manualBaseFigures,
                                        initialPage: manualFigurePage,
                                        possessive: sahWho.their,
                                        they: sahWho.they,
                                        them: sahWho.them,
                                        pensionWhy: manualPensionWhy,
                                        onYearByYear: ()=>{
                                            setManualFigurePage(null);
                                            setShowProjectionsModal(true);
                                        },
                                        onClose: ()=>setManualFigurePage(null)
                                    }),
                                    manualCareUpOpen && optimizedScenario?.optimizedFactFind && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $16690ef87f6b41eb$export$2e2bcd8739ae039), {
                                        factFind: factFind,
                                        setFactFind: setFactFind,
                                        servicePlan: servicePlanSource || {
                                            client: {},
                                            partner: {}
                                        },
                                        years: Number(legacyYears) || 10,
                                        supportStartDate: supportStartDate,
                                        savedStrategies: availableAgedCareStrategies,
                                        planTitle: manualWords.title,
                                        strategyConfig: null,
                                        planFactFind: optimizedScenario.optimizedFactFind,
                                        onClose: ()=>setManualCareUpOpen(false)
                                    }),
                                    manualRisksOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5757b380cc124794$export$2e2bcd8739ae039), {
                                        strategyName: manualWords.title,
                                        voice: sahWho,
                                        onClose: ()=>setManualRisksOpen(false),
                                        risks: (0, $203e38d6e6c434f4$export$124603ee0434ece5)(manualPieces.flatMap((p)=>(0, $203e38d6e6c434f4$export$e1aeab26ad581b54)(String(p.type), String(p.name || ''))))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: isSuggestionMode ? '' : 'xl:col-span-2 space-y-6 xl:sticky xl:top-8 xl:self-start',
                        children: [
                            !isSuggestionMode && /*
                  * ONE PANEL, the same artifact Aged Care uses (owner, 2026-08-27: "I want the
                  * UI/UX experience consistent across the modules").
                  *
                  * This rail held two cards that had drifted apart from the rest of the app: a
                  * blue/teal gradient block of three large contribution tiles, and — the bigger
                  * problem — a HAND-ROLLED copy of the Financial Impact panel, with its own heading,
                  * its own legacy-years control and its own tile grid. A copy cannot inherit a fix:
                  * the compact-row layout, the embedded chrome rules and the tile alignment work all
                  * landed in FinancialImpactPanel and never reached here.
                  *
                  * So the copy is gone and the shared component is used, inside the shared
                  * PlanSummaryPanel. The contribution RATES take the "what care costs" slot, which
                  * is what they are in this module — Support at Home charges a share of each service
                  * rather than a daily fee, so the rates are the price.
                  */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7abf945a7ae3f4e9$export$2e2bcd8739ae039), {
                                working: sahRailWorking,
                                // The card's own words for the plan, so the rail and the card name it the same way.
                                strategyName: sahPlanSummaryName ? manualPieces.length || selectedAgedCareIntegration ? manualWords.title : sahPlanSummaryName : null,
                                baselineLabel: sahDoNothingLegacy != null ? (0, $1a5a24a0286ded56$export$c9c6ca79dc334e31).word : undefined,
                                inBrief: sahInBrief,
                                /* The same cause-and-effect telling as the card's Explain this (one telling, as in aged care). */ onReadFullExplanation: sahPlanSummaryName && manualPlanFigures ? ()=>setManualExplainOpen(true) : undefined,
                                onWhatCouldGoWrong: hasStrategies && manualPlanFigures ? ()=>setManualRisksOpen(true) : undefined,
                                onViewProjections: ()=>setShowProjectionsModal(true),
                                /* The plan's actions, where its figures are (owner, 25 Oct 2026): the card under the controls went. */ actions: hasStrategies && manualPlanFigures ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8605a89eee7277e8$export$2e2bcd8739ae039), {
                                    testId: "sah-manual",
                                    chosen: manualChosen,
                                    anotherChosen: anotherSahPlanChosen,
                                    canChoose: !manualIncomeOnlyHeld,
                                    onChoose: chooseManualPlan,
                                    beforeChoose: manualIncomeOnly && setIncomeOnlyUnderstood ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$4538b371a206da0c), {
                                        factFind: factFind,
                                        amount: Number(annuityRecord?.purchaseAmount) || 0,
                                        onChange: setIncomeOnlyUnderstood
                                    }) : null,
                                    possessiveFile: sahWho.possessive,
                                    onAdvice: ()=>{
                                        openManualDigitalSoa();
                                    },
                                    // "If care needs increase" on a plan built by hand too; not for a loan against the home,
                                    // whose terms ride the run's options rather than the position.
                                    extra: propertyStrategy === 'reverseMortgage' || propertyStrategy === 'heas' ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setManualCareUpOpen(true),
                                        className: "mt-3 text-[13px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy",
                                        "data-testid": "sah-care-up-open",
                                        children: "If care needs increase"
                                    })
                                }) : undefined,
                                /*
                     * SAY WHAT THIS IS (owner-caught, 2026-08-27). Without a service plan these are
                     * not a baseline — they are the client's position today, and the illustrative
                     * package is standing in for services nobody has chosen. Calling that "the
                     * baseline" pointed the reader at a placeholder as the thing to beat.
                     *
                     * With a plan built, the no-strategy state IS the benchmark, exactly as it is in
                     * Aged Care, so the default wording returns.
                     */ noStrategyHeading: resolvedServicePlan.isEstimated ? "No service plan yet \u2014 your position today" : "No plan yet \u2014 the starting position",
                                noStrategyNote: resolvedServicePlan.isEstimated ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        "This is your ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold text-slate-700",
                                            children: "current position"
                                        }),
                                        ". Build the service plan and it becomes the plan every strategy here is measured against."
                                    ]
                                }) : undefined,
                                costOverview: panelContributionData ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "bg-gray-800 text-white rounded-xl p-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex items-start justify-between gap-3 mb-3 pb-3 border-b border-white/15",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-gray-400 text-xs leading-snug",
                                                    children: [
                                                        "Your share",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                        "of care costs"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "text-right",
                                                    children: resolvedServicePlan.isEstimated ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-lg font-bold text-white leading-tight",
                                                                children: "Needs a service plan"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                onClick: ()=>onNavigateToBuilder?.(),
                                                                className: "text-xs font-semibold text-blue-300 underline underline-offset-2 hover:text-blue-200",
                                                                children: "Build it in Service Builder \u203A"
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-3xl font-bold text-white leading-none",
                                                                children: formatCurrency(sahContributionAfter ?? 0)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-gray-300 font-semibold text-xs mt-1",
                                                                children: "a year"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "space-y-2.5",
                                            children: [
                                                [
                                                    'Clinical Care',
                                                    'clinical'
                                                ],
                                                [
                                                    'Independence',
                                                    'independence'
                                                ],
                                                [
                                                    'Everyday Living',
                                                    'everydayLiving'
                                                ]
                                            ].map(([label, key])=>{
                                                const now = panelContributionData.contributionRates?.[key] || 0;
                                                const was = beforeContributionData?.contributionRates?.[key];
                                                const moved = showContributionWas && was != null && was !== now;
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-baseline justify-between gap-3 text-sm",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-gray-300",
                                                            children: label
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-right",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "font-semibold text-white tabular-nums",
                                                                    children: formatPercent(now)
                                                                }),
                                                                moved && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "block text-[11px] text-gray-400 tabular-nums",
                                                                    children: [
                                                                        "was ",
                                                                        formatPercent(was)
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, key);
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}),
                                financialImpact: panelFinancials ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a47f01df2d11b1bc$export$2e2bcd8739ae039), {
                                    embedded: true,
                                    working: sahRailWorking,
                                    before: beforeFinancials,
                                    after: impactAfterFinancials,
                                    legacyYears: legacyYears,
                                    setLegacyYears: setLegacyYears,
                                    onViewProjections: ()=>setShowProjectionsModal(true),
                                    netWorthAfterValue: impactAfterFinancials?.netWorth ?? null,
                                    cashFlowBeforeValue: sahCashFlowBefore,
                                    cashFlowAfterValue: sahCashFlowAfter,
                                    cashFlowBreakdownOverride: sahCashFlowBreakdown,
                                    /* Measured against RECEIVING THE SERVICES WITH NO STRATEGY, projected
                               over the same years. Support at Home is a care requirement, not an
                               elective move, so the alternative is not "don't do it" — it is doing
                               it without a financial plan. Comparing with net worth TODAY credited
                               every strategy with growth that happens either way. */ legacyBaselineValue: sahDoNothingLegacy,
                                    legacyEstimateOverride: impactProjectedLegacy,
                                    baselineLabel: sahDoNothingLegacy != null ? (0, $1a5a24a0286ded56$export$c9c6ca79dc334e31).word : undefined
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {})
                            }),
                            showProjectionsModal && projections && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9847d752f8df838f$export$2e2bcd8739ae039), {
                                onClose: ()=>setShowProjectionsModal(false),
                                projections: modalPeriodMode === 'calendar_year' && calendarYearProjections ? calendarYearProjections : projectionsForModal || projections,
                                onPeriodModeChange: setModalPeriodMode,
                                isReloading: modalPeriodMode === 'calendar_year' && !calendarYearProjections,
                                factFind: factFind,
                                initialFinancials: beforeFinancials,
                                currentFinancials: afterFinancials,
                                agedCareCosts: combinedCareCosts || null,
                                costLabel: "Support at Home Costs",
                                title: hasStrategies ? manualWords.title : "The support alone \u2014 the same services, nothing else changed",
                                comparedOverYears: Number(legacyYears) || undefined
                            })
                        ]
                    })
                ]
            }),
            showCompareModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "bg-white rounded-2xl shadow-2xl max-w-6xl w-full max-h-[90vh] overflow-hidden flex flex-col border border-slate-200/80",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "px-6 pt-6 pb-4 border-b border-slate-100 bg-slate-50",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-start justify-between gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                    className: "text-2xl md:text-3xl font-bold tracking-tight",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6288781efbc92679$export$2e2bcd8739ae039), {
                                                        children: "Compare Home Care Strategies"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-sm text-slate-600 mt-1.5",
                                                    children: "Side-by-side view of saved Support at Home strategies (model outputs)."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setShowCompareModal(false),
                                            className: "shrink-0 rounded-lg p-2 text-slate-500 hover:text-slate-800 hover:bg-slate-100 transition-colors text-2xl leading-none",
                                            "aria-label": "Close",
                                            children: "\xd7"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "h-1 w-full rounded-full bg-brand-navy mt-4",
                                    "aria-hidden": true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "overflow-auto flex-1 px-6 py-5",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "rounded-xl border border-slate-200 overflow-hidden shadow-sm",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    className: "w-full text-sm border-collapse min-w-[720px]",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "bg-slate-100 text-slate-800",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-4 py-3 text-left font-semibold border-b border-slate-200/90",
                                                        children: "Strategy name"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-4 py-3 text-right font-semibold border-b border-slate-200/90 whitespace-nowrap",
                                                        children: "Age pension"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-4 py-3 text-right font-semibold border-b border-slate-200/90 whitespace-nowrap",
                                                        children: "Cash flow"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-4 py-3 text-right font-semibold border-b border-slate-200/90 whitespace-nowrap",
                                                        children: "Legacy estimate"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-4 py-3 text-right font-semibold border-b border-slate-200/90 whitespace-nowrap",
                                                        children: "Annual contribution"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-4 py-3 text-center font-semibold border-b border-slate-200/90 whitespace-nowrap",
                                                        children: "Clinical care"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-4 py-3 text-center font-semibold border-b border-slate-200/90 whitespace-nowrap",
                                                        children: "Independence"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-4 py-3 text-center font-semibold border-b border-slate-200/90 whitespace-nowrap",
                                                        children: "Everyday living"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-4 py-3 text-center font-semibold border-b border-slate-200/90 whitespace-nowrap",
                                                        children: "Created"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: savedHomeCareStrategies.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    colSpan: 9,
                                                    className: "px-4 py-8 text-center text-slate-500",
                                                    children: "No strategies saved yet. Save a strategy to compare."
                                                })
                                            }) : savedHomeCareStrategies.map((strategy, index)=>{
                                                const contributionRates = strategy.outputs?.contributionRates || {};
                                                const formatPercentModal = (value)=>{
                                                    if (!value && value !== 0) return 'N/A';
                                                    return `${(value * 100).toFixed(1)}%`;
                                                };
                                                const cf = Number(strategy.outputs?.cashFlow) || 0;
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    className: `border-b border-slate-100 last:border-b-0 transition-colors hover:bg-sky-50/50 ${index % 2 === 0 ? 'bg-white' : 'bg-slate-50/60'}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "px-4 py-3 font-medium text-slate-900 align-top",
                                                            children: [
                                                                strategy.name,
                                                                strategy.source === 'suggestion_engine' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "block text-xs font-normal text-slate-500",
                                                                    children: "Suggestion engine"
                                                                }) : null,
                                                                (()=>{
                                                                    const warning = (0, $ef2004df8b6bc275$export$1994f7e9faf3aa57)(strategy.outputs?.servicePlanBasis, currentServicePlanBasis);
                                                                    return warning ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "mt-1 block rounded border border-slate-200 border-l-4 border-l-amber-400 bg-white px-2 py-1 text-[11px] font-normal leading-snug text-slate-700",
                                                                        children: warning
                                                                    }) : null;
                                                                })()
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3 text-right tabular-nums text-slate-800",
                                                            children: formatCurrency(Number(strategy.outputs?.agePension) || 0)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: `px-4 py-3 text-right tabular-nums font-medium ${cf < 0 ? 'text-rose-700' : 'text-emerald-700'}`,
                                                            children: formatCurrency(cf)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3 text-right tabular-nums text-slate-800",
                                                            children: formatCurrency(Number(strategy.outputs?.legacyEstimate) || 0)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3 text-right tabular-nums text-slate-800",
                                                            children: formatCurrency(strategy.outputs?.annualContribution || 0)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3 text-center",
                                                            children: formatPercentModal(contributionRates.clinical)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3 text-center",
                                                            children: formatPercentModal(contributionRates.independence)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3 text-center",
                                                            children: formatPercentModal(contributionRates.everydayLiving)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3 text-center text-slate-600 align-top",
                                                            children: strategy.createdAt ? new Date(String(strategy.createdAt)).toLocaleDateString() : ''
                                                        })
                                                    ]
                                                }, strategy.id);
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "px-6 py-4 border-t border-slate-100 bg-slate-50/50 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-xs text-slate-500",
                                    children: "Select a strategy in Optimise Your Plan to view the explainer and customise details."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                    type: "button",
                                    onClick: ()=>setShowCompareModal(false),
                                    variant: "secondary",
                                    className: "shrink-0 self-end sm:self-auto",
                                    children: "Close"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $d6188f49626b9d12$export$2e2bcd8739ae039 = $d6188f49626b9d12$var$StrategiesSection;



/**
 * The Support at home landing once a plan is chosen — "Colin and Shelly's support at home plan"
 * (rebuild M2, 19 Oct 2026; the agreed mock-up's hub screen, j1-11). Aged care's AgedCareHub shape.
 *
 * One card for the chosen plan: its name in words, the big number against the support alone, the support
 * (each person's classification and services, their contribution) beside the money (Age Pension, each
 * year, the rate for each hour), then Explain this / What could go wrong / All the plans we tested.
 * Then the advice document and the next step, then a row of links. A breadcrumb so it is not taken
 * for Home.
 *
 * Since 22 Oct 2026 (owner: "Yes i want this all consistent") the card, the document and next step, "Model
 * something else" and the links are the shared pieces in components/strategy/ChosenPlanPage.tsx, so this
 * page and the other modules' plan pages cannot drift apart.
 *
 * Nothing here is computed except differences and the service totals: every money figure is the
 * chosen card's own (sahChosenPlan.ts), quoted with the doing-nothing figures it was measured against.
 */ 

var $acw62 = parcelRequire("acw62");


/**
 * THE CHOSEN-PLAN PAGE, IN PIECES EVERY MODULE SHARES (owner, 22 Oct 2026: "Yes i want this all consistent" — the
 * consistency audit found the village, downsizing, granny flat, cashflow and support at home plan pages each built
 * their own card, figures, buttons and links, and none had aged care's "Model something else").
 *
 * The shape is aged care's (AgedCareHub.tsx):
 *   - ChosenPlanCard: green outline; "Chosen plan" with the date; the plan's words; what is left to the family and the
 *     change against the benchmark; a strip of figures; the module's own body; three buttons (Explain this, What could
 *     go wrong, All the plans we tested →).
 *   - DocumentAndNextStep: the advice document and the next action, one card with two cells.
 *   - ModelSomethingElse: the other models the module can start, each saying what it keeps.
 *   - PlanPageLinks: the ways on, as links with icons (none of them is the next step).
 */ 
parcelRequire("acw62");


const $b200f9f0b001184e$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(n)));
const $b200f9f0b001184e$export$14ec62d97a734af3 = ({ chosenOn: chosenOn, builtByYou: builtByYou = false, title: title, sub: sub, estate: estate, years: years, estateDelta: estateDelta = null, baseWord: baseWord, figures: figures, children: children, onExplain: onExplain, onRisks: onRisks, onAllPlans: onAllPlans, testIdPrefix: testIdPrefix })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "overflow-hidden rounded-2xl border-2 border-emerald-500 bg-white shadow-card",
        "data-testid": `${testIdPrefix}-card`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-start justify-between gap-6 px-6 pt-5 pb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "min-w-[260px] flex-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "inline-flex items-center gap-1.5 text-[12.5px] font-semibold text-emerald-700",
                                "data-testid": `${testIdPrefix}-chosen-chip`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                        size: 15,
                                        strokeWidth: 2,
                                        "aria-hidden": true
                                    }),
                                    "Chosen plan",
                                    chosenOn ? `, ${chosenOn}` : '',
                                    builtByYou ? " \xb7 built by you" : ''
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "mt-2 text-[22px] font-bold leading-snug tracking-tight text-slate-900",
                                children: title
                            }),
                            sub && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1 text-[13px] leading-relaxed text-slate-600",
                                children: sub
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-right",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[36px] font-bold leading-none tabular-nums tracking-tight text-brand-navy",
                                children: $b200f9f0b001184e$var$money(estate)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-1 text-[13px] text-slate-600",
                                children: [
                                    "left to the family after about ",
                                    years,
                                    " ",
                                    years === 1 ? 'year' : 'years'
                                ]
                            }),
                            estateDelta != null && Math.abs(estateDelta) >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: `mt-0.5 text-[13px] font-bold tabular-nums ${estateDelta >= 0 ? 'text-emerald-700' : 'text-rose-700'}`,
                                children: [
                                    estateDelta >= 0 ? '+' : "\u2212",
                                    $b200f9f0b001184e$var$money(estateDelta),
                                    " vs ",
                                    baseWord
                                ]
                            })
                        ]
                    })
                ]
            }),
            figures.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `grid grid-cols-1 divide-y divide-slate-200 border-y border-slate-200 bg-slate-50/70 sm:divide-x sm:divide-y-0 ${figures.length >= 3 ? 'sm:grid-cols-3' : figures.length === 2 ? 'sm:grid-cols-2' : ''}`,
                children: figures.map((f)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "px-6 py-3.5",
                        "data-testid": f.testId,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[12px] font-semibold text-slate-500",
                                children: f.label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: `mt-0.5 text-[20px] font-bold leading-none tabular-nums ${f.tone === 'good' ? 'text-emerald-700' : 'text-slate-900'}`,
                                children: [
                                    f.value,
                                    f.unit ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "ml-1 text-[12px] font-medium text-slate-500",
                                        children: f.unit
                                    }) : null
                                ]
                            }),
                            f.note && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1 text-[12px] text-slate-500",
                                children: f.note
                            })
                        ]
                    }, f.label))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "px-6 py-4",
                children: [
                    children,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `${children ? 'mt-4 ' : ''}grid grid-cols-1 gap-2 sm:grid-cols-3`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: onExplain,
                                className: "inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3.5 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300 hover:bg-blue-50",
                                "data-testid": `${testIdPrefix}-explain`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                        size: 15
                                    }),
                                    " Explain this"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: onRisks,
                                className: "inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3.5 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300 hover:bg-blue-50",
                                "data-testid": `${testIdPrefix}-risks`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4666dd9ae485baaf$export$2e2bcd8739ae039), {
                                        size: 15
                                    }),
                                    " What could go wrong"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: onAllPlans,
                                className: "inline-flex items-center justify-center gap-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 px-3.5 py-2.5 text-[14px] font-semibold text-white shadow-md ",
                                "data-testid": `${testIdPrefix}-all-plans`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                                        size: 15
                                    }),
                                    " All the plans we tested \u2192"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
const $b200f9f0b001184e$export$402ee133f3748280 = ({ documentState: documentState, documentLine: documentLine, documentAction: documentAction, nextTitle: nextTitle, nextLine: nextLine, nextAction: nextAction })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "grid grid-cols-1 divide-y divide-slate-200 rounded-2xl border border-slate-200 bg-white shadow-card md:grid-cols-2 md:divide-x md:divide-y-0",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex gap-3 px-5 py-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-blue-50 text-blue-700",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                            size: 18
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-[15px] font-semibold text-slate-900",
                                children: [
                                    "Advice document \u2014 ",
                                    documentState
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-0.5 text-[13px] leading-relaxed text-slate-600",
                                children: [
                                    documentLine,
                                    " ",
                                    documentAction,
                                    "."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex gap-3 px-5 py-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-blue-600 text-[14px] font-bold text-white",
                        children: "1"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-[15px] font-semibold text-slate-900",
                                children: [
                                    "Next: ",
                                    nextTitle
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-0.5 text-[13px] leading-relaxed text-slate-600",
                                children: [
                                    nextLine,
                                    " ",
                                    nextAction,
                                    "."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
const $b200f9f0b001184e$export$9e6485da48da532f = ({ options: options, testId: testId = 'model-something-else' })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-card",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[15px] font-semibold text-slate-900",
                children: "Model something else"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-0.5 text-[13px] text-slate-600",
                children: "Each new model is saved as its own plan. This plan stays chosen until you choose another."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `mt-3 grid grid-cols-1 gap-3 ${options.length > 1 ? 'sm:grid-cols-2' : ''}`,
                children: options.map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col rounded-xl border border-slate-200 px-4 py-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[14px] font-semibold text-slate-900",
                                children: o.title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-0.5 flex-1 text-[13px] leading-relaxed text-slate-600",
                                children: o.body
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: o.onClick,
                                "data-testid": o.testId,
                                className: "mt-3 inline-flex items-center justify-center gap-1.5 self-start rounded-lg border border-slate-300 bg-white px-3.5 py-2 text-[13px] font-semibold text-slate-800 hover:border-blue-300 hover:bg-blue-50",
                                children: o.action
                            })
                        ]
                    }, o.title))
            })
        ]
    });
const $b200f9f0b001184e$export$29d0c084f57dd4ac = ({ links: links })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-wrap items-center gap-x-6 gap-y-2",
        children: links.map((l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: l.onClick,
                "data-testid": l.testId,
                className: "inline-flex items-center gap-1.5 text-[13px] font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                children: [
                    l.icon,
                    l.label
                ]
            }, l.label))
    });



















const $33f3aa36b8f27766$var$dateWords = (iso)=>iso ? new Date(iso).toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }) : null;
const $33f3aa36b8f27766$var$pct = (r)=>`${+(r * 100).toFixed(1)}%`;
const $33f3aa36b8f27766$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(n)));
const $33f3aa36b8f27766$var$countWords = [
    'none',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'ten'
];
const $33f3aa36b8f27766$var$Row = ({ label: label, value: value, sub: sub })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-baseline justify-between gap-4 border-b border-slate-100 py-2 text-[14px] last:border-b-0",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-slate-700",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "text-right tabular-nums",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-slate-900",
                        children: value
                    }),
                    sub ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ml-1.5 text-[12.5px] text-slate-500",
                        children: sub
                    }) : null
                ]
            })
        ]
    });
/** Each person's classification, budget and the services priced for them. */ function $33f3aa36b8f27766$var$supportRows(factFind, plan) {
    const people = [
        {
            key: 'client',
            name: String(factFind?.client?.firstName || 'You')
        }
    ];
    if (factFind?.adviceFor === 'couple') people.push({
        key: 'partner',
        name: String(factFind?.partner?.firstName || 'Partner')
    });
    return people.map(({ key: key, name: name })=>{
        const acat = factFind?.careNeeds?.[`${key}Acat`];
        const level = acat?.status === 'yes' ? acat.homeCareLevel : undefined;
        const label = level ? String((0, $c220d08b55e5dd64$export$bfae9591cc0d7897)[level]?.label || '') : '';
        const classification = label.match(/classification\s*\d+/i)?.[0]?.toLowerCase() || (label ? label.replace(/^Support at Home\s*-\s*/i, '') : 'not assessed');
        const side = plan?.[key] || {};
        const count = Object.values(side).filter((d)=>d && Number(d.quantity) > 0).length;
        const value = (0, $5fb3dd4f28b6f196$export$f1798fc2c7adaf45)(side, {}, (0, $25e9acc02c907060$export$a3b71735b810a98c)).total;
        const budget = level ? (0, $c220d08b55e5dd64$export$36fcde3ddb6f0194)(level) : 0;
        return {
            name: name,
            classification: classification,
            count: count,
            value: value,
            budget: budget,
            over: budget > 0 && value > budget ? value - budget : 0
        };
    });
}
const $33f3aa36b8f27766$var$SahHub = ({ factFind: factFind, plan: plan, currentServicePlan: currentServicePlan, supportStartDate: supportStartDate, savedStrategies: savedStrategies = [], onOpen: onOpen, goHome: goHome })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    // With a partner moving into care, what their aged care plan did, as step 2 says it (24 Oct 2026).
    const linkedCare = (0, $1daac60e43adbfd2$export$30bb3bcf0a6c6a50)(factFind, savedStrategies);
    const card = plan.inputs.card;
    const f = card.plan;
    const b = card.baseline;
    const years = card.horizonYears || Number(plan.inputs?.legacyYears) || 10;
    const legacyDelta = b ? f.legacy - b.legacy : null;
    const pensionDelta = b ? f.pension - b.pension : null;
    const priced = plan.inputs?.servicePlan || null;
    const rows = $33f3aa36b8f27766$var$supportRows(factFind, priced);
    // Compared as priced (a person moving into care has no services priced — sahEngineContext.ts).
    const servicesChanged = priced != null && currentServicePlan != null && JSON.stringify((0, $5ea55f03cd2af1e4$export$fe04ad50cd2b5dad)(currentServicePlan, factFind)) !== String(plan.inputs?.servicePlanFingerprint ?? JSON.stringify(priced));
    // Chosen on another household (or lost on a re-test): the figures below are the ones it was chosen on (25 Oct 2026).
    const outOfDate = (0, $2eb5e3232a8b6136$export$bc9892722f29f4ff)(plan, factFind, savedStrategies);
    const assessed = rows.some((r)=>r.classification !== 'not assessed');
    const nextStep = (0, $85ae9bb7b6ee4811$export$baed740720ec0ee1).home_care.steps[assessed ? 1 : 0];
    const start = supportStartDate ? $33f3aa36b8f27766$var$dateWords(`${supportStartDate}T00:00:00`) : null;
    const [explainOpen, setExplainOpen] = (0, $acw62.useState)(false);
    const [risksOpen, setRisksOpen] = (0, $acw62.useState)(false);
    const doSentence = `${card.words.title}${card.words.sub ? ` \u{2014} ${card.words.sub.replace(/^Paid from /, 'paid from ').replace(/\.$/, '')}` : ''}.`;
    const servicesLine = rows.map((r)=>`${r.name}'s ${r.count > 0 ? `${$33f3aa36b8f27766$var$countWords[r.count] ?? r.count} ${r.count === 1 ? 'service' : 'services'}` : 'none yet'}`).join(', ');
    const pensionNote = pensionDelta != null && Math.abs(pensionDelta) >= 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: pensionDelta > 0 ? 'text-emerald-700' : 'text-rose-700',
        children: [
            pensionDelta > 0 ? '+' : "\u2212",
            $33f3aa36b8f27766$var$money(pensionDelta),
            " vs the support alone"
        ]
    }) : b ? 'same as the support alone' : undefined;
    const contributionNote = b ? Math.abs(b.contribution - f.contribution) >= 1 ? `${$33f3aa36b8f27766$var$money(b.contribution)} with the support alone` : 'same as the support alone' : undefined;
    const cashflowNote = b ? b.cashflow < 0 ? `short ${$33f3aa36b8f27766$var$money(b.cashflow)} with the support alone` : `${$33f3aa36b8f27766$var$money(b.cashflow)} to spare with the support alone` : undefined;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mx-auto max-w-5xl",
        "data-testid": "sah-hub",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] text-slate-500",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: goHome,
                        className: "underline decoration-dotted underline-offset-2 hover:text-slate-800",
                        children: "Home"
                    }),
                    " \u203A Support at home"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                className: "mt-2 text-[32px] font-bold leading-tight tracking-tight text-brand-navy",
                children: [
                    v.Possessive,
                    " support at home plan"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-1 text-[15px] text-slate-600",
                children: [
                    "Support starting ",
                    start ?? 'now',
                    "; ",
                    servicesLine,
                    ".",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>onOpen('services'),
                        className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy",
                        children: "Change the services"
                    })
                ]
            }),
            outOfDate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-5 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] text-slate-700",
                "data-testid": "sah-hub-out-of-date",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-slate-900",
                                children: outOfDate.replace(/ — open it to choose again\.$/, '.')
                            }),
                            " The figures below are the ones it was chosen on",
                            plan.createdAt ? `, ${$33f3aa36b8f27766$var$dateWords(plan.createdAt)}` : '',
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>onOpen('plans'),
                        className: "rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-[13px] font-semibold text-slate-800 hover:border-blue-300",
                        children: "Choose a plan again"
                    })
                ]
            }) : servicesChanged && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-5 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] text-slate-700",
                "data-testid": "sah-hub-services-changed",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-slate-900",
                                children: "The services have changed since this plan was chosen."
                            }),
                            " The figures below are for the services it was priced on."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>onOpen('plans'),
                        className: "rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-[13px] font-semibold text-slate-800 hover:border-blue-300",
                        children: "Test the plans again"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-5",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b200f9f0b001184e$export$14ec62d97a734af3), {
                    testIdPrefix: "sah-hub",
                    chosenOn: $33f3aa36b8f27766$var$dateWords(plan.createdAt),
                    builtByYou: card.origin === 'manual',
                    title: card.words.title,
                    sub: card.words.sub || undefined,
                    estate: f.legacy,
                    years: years,
                    estateDelta: legacyDelta,
                    baseWord: (0, $1a5a24a0286ded56$export$c9c6ca79dc334e31).word,
                    figures: [
                        {
                            label: `${v.Possessive} contribution`,
                            value: $33f3aa36b8f27766$var$money(f.contribution),
                            unit: 'a year',
                            note: contributionNote,
                            testId: 'sah-hub-contribution'
                        },
                        {
                            label: 'Age Pension',
                            value: $33f3aa36b8f27766$var$money(f.pension),
                            unit: 'a year',
                            note: pensionNote,
                            testId: 'sah-hub-pension'
                        },
                        {
                            label: f.cashflow < 0 ? 'Each year, short by' : 'Left over each year',
                            value: $33f3aa36b8f27766$var$money(f.cashflow),
                            note: cashflowNote,
                            tone: f.cashflow >= 0 ? 'good' : 'plain',
                            testId: 'sah-hub-cashflow'
                        }
                    ],
                    onExplain: ()=>setExplainOpen(true),
                    onRisks: ()=>setRisksOpen(true),
                    onAllPlans: ()=>onOpen('plans'),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "text-[15px] font-bold text-brand-navy",
                            children: "The support"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mt-1.5",
                            "data-testid": "sah-hub-support",
                            children: [
                                rows.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($33f3aa36b8f27766$var$Row, {
                                        label: `${r.name} \xb7 ${r.classification}`,
                                        value: r.count > 0 ? `${$33f3aa36b8f27766$var$money(r.value)} of services a year` : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-normal text-slate-500",
                                            children: "none yet"
                                        }),
                                        sub: r.budget > 0 ? `budget ${$33f3aa36b8f27766$var$money(r.budget)}` : undefined
                                    }, r.name)),
                                f.rates && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($33f3aa36b8f27766$var$Row, {
                                    label: "Contribution for each hour",
                                    value: `${$33f3aa36b8f27766$var$pct(f.rates.independence)} and ${$33f3aa36b8f27766$var$pct(f.rates.everydayLiving)}`,
                                    sub: b?.rates && (Math.abs(b.rates.independence - f.rates.independence) > 0.0005 || Math.abs(b.rates.everydayLiving - f.rates.everydayLiving) > 0.0005) ? `was ${$33f3aa36b8f27766$var$pct(b.rates.independence)} and ${$33f3aa36b8f27766$var$pct(b.rates.everydayLiving)}` : undefined
                                })
                            ]
                        }),
                        rows.filter((r)=>r.over > 0).map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-2 text-[13px] text-slate-600",
                                "data-testid": "sah-hub-over-budget",
                                children: [
                                    r.name,
                                    "'s services are ",
                                    $33f3aa36b8f27766$var$money(r.over),
                                    " more than the budget; that part is paid at full price.",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>onOpen('services'),
                                        className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                        children: "Review the services"
                                    })
                                ]
                            }, r.name))
                    ]
                })
            }),
            linkedCare && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-card",
                "data-testid": "sah-hub-linked",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mb-2 text-[15px] font-bold text-brand-navy",
                        children: [
                            "With ",
                            (0, $a109d47f19f08f50$export$f59d8746d20e5371)(linkedCare).enteringName,
                            " moving into aged care"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a109d47f19f08f50$export$c58a16d65aeb138a), {
                        linkedCare: linkedCare
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b200f9f0b001184e$export$402ee133f3748280), {
                    documentState: plan.soaSnapshot ? 'prepared' : 'not prepared yet',
                    documentLine: "The written record of this plan: the services it was priced on, what it assumes, what it costs, what could go wrong.",
                    documentAction: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>onOpen('document'),
                        className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                        "data-testid": "sah-hub-document",
                        children: plan.soaSnapshot ? 'Open the advice document' : 'Get the advice document'
                    }),
                    nextTitle: (nextStep?.name ?? 'Contribution assessment').toLowerCase(),
                    nextLine: nextStep?.description,
                    nextAction: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: goHome,
                        className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                        "data-testid": "sah-hub-home",
                        children: "Full action plan on Home"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b200f9f0b001184e$export$9e6485da48da532f), {
                    testId: "sah-hub-model-something-else",
                    options: [
                        {
                            title: 'Change the services, same answers',
                            body: `Change ${v.their} services on step 1 and test the plans again, keeping ${v.their} answers to the setup questions.`,
                            action: 'Change the services',
                            onClick: ()=>onOpen('services'),
                            testId: 'sah-hub-change-services'
                        },
                        {
                            title: 'A new model from scratch',
                            body: 'Start again on step 1 with no services, and answer the setup questions afresh.',
                            action: 'Start a new model from scratch',
                            onClick: ()=>onOpen('fresh'),
                            testId: 'sah-hub-start-fresh'
                        }
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-5",
                "data-testid": "sah-hub-links",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b200f9f0b001184e$export$29d0c084f57dd4ac), {
                    links: [
                        {
                            label: 'All the plans we tested',
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e583651be68dae50$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            onClick: ()=>onOpen('plans')
                        },
                        // Two doors (owner, 25 Oct 2026): change this plan, or start a blank one.
                        {
                            label: card.origin === 'manual' ? 'Change the plan you built' : 'Customise this plan',
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $712d717556ef1508$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            onClick: ()=>onOpen('build'),
                            testId: 'sah-hub-build'
                        },
                        {
                            label: 'Build a plan yourself',
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $712d717556ef1508$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            onClick: ()=>onOpen('build-new'),
                            testId: 'sah-hub-build-new'
                        },
                        {
                            label: "How Support at home works \u2014 the guide",
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            onClick: ()=>onOpen('guide')
                        },
                        {
                            label: 'Rates and assumptions',
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            onClick: ()=>onOpen('assumptions')
                        }
                    ]
                })
            }),
            explainOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $12084f898a868747$export$2e2bcd8739ae039), {
                eyebrow: "Explain this",
                title: card.words.title,
                intro: `Each line says what ${v.they} do, and what that does to the numbers. ${(0, $1a5a24a0286ded56$export$c9c6ca79dc334e31).sentence}`,
                onClose: ()=>setExplainOpen(false),
                // The year-by-year figures, as on every other Explain this (owner, 19 Oct 2026: missing here).
                // The saved card keeps no projection rows, so the plans step opens them for this plan.
                footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: ()=>{
                        setExplainOpen(false);
                        onOpen('yearByYear');
                    },
                    className: "rounded-lg border border-slate-300 bg-white px-4 py-2 text-[14px] font-semibold text-slate-800 hover:border-blue-300 hover:bg-blue-50",
                    "data-testid": "sah-hub-year-by-year",
                    children: "See the year-by-year figures"
                }),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca9b5cdfbd99e645$export$68e00db93a37b932), {
                        doSentence: doSentence,
                        treatment: card.words.treatment,
                        plan: f,
                        baseline: b,
                        horizonYears: years,
                        possessive: v.their,
                        they: v.they,
                        drawLines: card.drawLines,
                        leverKinds: card.engineConfig ? (0, $f7f18ba87194b6fe$export$caaafd80ea6c3706)(card.engineConfig) : card.riskKinds
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe4e1ee5e30419ba$export$2e2bcd8739ae039), {
                        factFind: factFind,
                        clearedAmount: (0, $afba33f9e18e15f2$export$52f9380165cafdac)(card.engineConfig),
                        years: years,
                        context: card.origin === 'manual' ? 'manual' : 'chosen'
                    })
                ]
            }),
            risksOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5757b380cc124794$export$2e2bcd8739ae039), {
                strategyName: card.words.title,
                voice: v,
                onClose: ()=>setRisksOpen(false),
                risks: (0, $203e38d6e6c434f4$export$124603ee0434ece5)(card.riskKinds)
            })
        ]
    });
};
var $33f3aa36b8f27766$export$2e2bcd8739ae039 = $33f3aa36b8f27766$var$SahHub;





/**
 * Step 1 — "The support and its cost" (rebuild M3, 19 Oct 2026; the agreed mock-up's j1-02, revised for
 * the owner's decisions).
 *
 *  - "Support at home, in a minute": the rules in four lines, shown once, open any time.
 *  - "Is Colin moving into aged care?" — only where a partner's aged care is on file. The answer decides
 *    whose support is priced and whether the aged care plan is counted (sahEngineContext.ts).
 *  - Who the support is for: each person's classification and yearly budget, from the profile.
 *  - When support starts.
 *  - The services, one tab per person, STARTING EMPTY (decision 2: no illustrative package), grouped by
 *    who pays — free to them / their share of each hour getting out and about / of help around the
 *    house — with search to add, and each person's budget. Services above a budget are paid in full,
 *    privately (decision 3, pack B.SAH.3).
 *  - What this does to their money, live beside it: their contribution, the Age Pension, each year —
 *    the engine's own baseline (useSahBaseline), so these are step 2's numbers.
 */ 

var $acw62 = parcelRequire("acw62");









/**
 * "With this support and nothing else changed" — the four numbers steps 1 and 2 show (rebuild M3,
 * 19 Oct 2026), priced by THE ENGINE'S OWN baseline (computeSupportAtHomeBaselineData) on the same
 * household and options the plans use (sahEngineContext.ts). So step 2's numbers are the strip on
 * step 3 by construction, not by coincidence.
 *
 *  - their contribution: the service plan at the assessed rates, within each person's budget, with
 *    anything above it at full price (ServicePlanUtils calculateServicePlanCosts — the engine's split);
 *  - the Age Pension: the yearly assessment;
 *  - each year: year one of the projection (the engine's getProjectionCashFlow);
 *  - left to the family: the projection's row at the horizon.
 */ 

var $acw62 = parcelRequire("acw62");




function $442fff09aec5e55b$export$77ca36aac45f0c9(args) {
    const { factFind: factFind, servicePlan: servicePlan, years: years, supportStartDate: supportStartDate, savedStrategies: savedStrategies, extraStrategyOptions: extraStrategyOptions, debounceMs: debounceMs = 350 } = args;
    const priced = (0, $acw62.useMemo)(()=>(0, $5ea55f03cd2af1e4$export$fe04ad50cd2b5dad)(servicePlan, factFind), [
        servicePlan,
        factFind
    ]);
    const linkedRecord = (0, $acw62.useMemo)(()=>(0, $5ea55f03cd2af1e4$export$12c4b1871639c9ac)(factFind) === 'yes' ? (0, $5ea55f03cd2af1e4$export$b164904e0d858bed)(savedStrategies) : null, [
        factFind,
        savedStrategies
    ]);
    const position = (0, $1daac60e43adbfd2$export$a8613b2591a1f51b)(factFind, linkedRecord);
    // Nothing is priced until the aged care plan has been carried out, so no figure is shown on the wrong household.
    const enabled = (args.enabled ?? true) && position.ready;
    const ctx = (0, $acw62.useMemo)(()=>(0, $5ea55f03cd2af1e4$export$a5165c78061d54fc)({
            factFind: factFind,
            savedStrategies: savedStrategies,
            supportStartDate: supportStartDate,
            positioned: position.positioned
        }), [
        factFind,
        savedStrategies,
        supportStartDate,
        position.positioned
    ]);
    const linkedCare = (0, $acw62.useMemo)(()=>ctx.linkedRecord && position.ready ? {
            record: ctx.linkedRecord,
            details: ctx.linked,
            before: factFind,
            after: ctx.baselineFactFind,
            whole: !!position.positioned,
            caveats: position.caveats,
            reason: position.reason
        } : null, [
        ctx,
        factFind,
        position
    ]);
    // The household itself is part of the key: a change to the aged care plan or the profile re-prices.
    const key = JSON.stringify([
        enabled,
        priced,
        years,
        ctx.evaluationOptions,
        extraStrategyOptions ?? null,
        ctx.baselineFactFind
    ]);
    const [state, setState] = (0, $acw62.useState)({
        figures: null,
        loading: true,
        error: null
    });
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        if (!enabled) {
            setState({
                figures: null,
                loading: false,
                error: null
            });
            return undefined;
        }
        setState((s)=>({
                ...s,
                loading: true
            }));
        const timer = setTimeout(()=>{
            const strategyOptions = {
                ...ctx.evaluationOptions.strategyOptions || {},
                ...extraStrategyOptions || {}
            };
            const options = {
                strategyOptions: strategyOptions,
                contributionOptions: {
                    ...ctx.evaluationOptions.contributionOptions,
                    strategyOptions: strategyOptions
                }
            };
            $55a1d8a64f1e5dfa$export$2440fc29f5473353(ctx.baselineFactFind, priced, years, options).then((r)=>{
                if (cancelled) return;
                const isCouple = factFind?.adviceFor === 'couple';
                const branch = isCouple ? r.baselineContributions?.combined || r.baselineContributions?.client : r.baselineContributions?.client;
                const rates = branch?.contributionRates || {};
                const budgets = (0, $08809b7a4fc47e27$export$4ddb2093d9f00d95)(ctx.baselineFactFind);
                const costs = (0, $08809b7a4fc47e27$export$8fa8d1fdeea775a9)(priced, rates, isCouple, budgets);
                const one = (who)=>(0, $08809b7a4fc47e27$export$8fa8d1fdeea775a9)({
                        client: who === 'client' ? priced.client || {} : {},
                        partner: who === 'partner' ? priced.partner || {} : {}
                    }, rates, isCouple, budgets).contribution.total;
                const rows = r.baselineProjections || [];
                const atHorizon = rows[years - 1] ?? rows[rows.length - 1];
                const fin = r.baselineFinancials || {};
                setState({
                    loading: false,
                    error: null,
                    figures: {
                        contribution: costs.contribution.total,
                        pension: Number(fin.socialSecurity) || 0,
                        cashflow: Number(rows[0]?.cashFlow) || 0,
                        legacy: (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(atHorizon) ?? 0,
                        rates: {
                            independence: Number(rates.independence) || 0,
                            everydayLiving: Number(rates.everydayLiving) || 0
                        },
                        costs: costs,
                        perPerson: {
                            client: one('client'),
                            partner: isCouple ? one('partner') : 0
                        },
                        projections: rows,
                        financials: fin,
                        assessableAssets: Number(fin.assessableAssets) || 0,
                        assessableIncome: Number(fin.totalAssessableIncome) || 0
                    }
                });
            }).catch(()=>{
                if (!cancelled) setState({
                    figures: null,
                    loading: false,
                    error: 'The figures could not be worked out just now.'
                });
            });
        }, debounceMs);
        return ()=>{
            cancelled = true;
            clearTimeout(timer);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        key
    ]);
    return {
        ...state,
        loading: state.loading || !position.ready,
        linkedCare: linkedCare
    };
}






/**
 * A service's "what's this?" (owner, 22 Oct 2026: the browser's own tooltip "looks old and tired"): the app's help
 * card, floating over the list, with the service named at the top so the reader knows which one they opened.
 */ const $e77534e6102db193$var$ServiceHelp = ({ name: name, description: description })=>description ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
        label: "what's this?",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "block text-[13.5px] font-semibold text-slate-900",
                children: name
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "mt-1 block text-slate-600",
                children: description
            })
        ]
    }) : null;
const $e77534e6102db193$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(n)));
const $e77534e6102db193$var$pct = (r)=>`${+(r * 100).toFixed(1)}%`;
/** The catalogue, flattened: each service with its group. */ const $e77534e6102db193$var$CATALOGUE = Object.values((0, $25e9acc02c907060$export$a3b71735b810a98c)).flatMap((cat)=>cat.services.map((s)=>({
            ...s,
            group: cat.label === 'Clinical Care' ? 'free' : cat.label === 'Independence Services' ? 'independence' : 'everyday'
        })));
const $e77534e6102db193$var$SERVICE = new Map($e77534e6102db193$var$CATALOGUE.map((s)=>[
        s.id,
        s
    ]));
const $e77534e6102db193$var$UNIT_WORDS = {
    Hour: [
        'hour',
        'hours'
    ],
    Trip: [
        'trip',
        'trips'
    ],
    Meal: [
        'meal',
        'meals'
    ],
    Item: [
        'item',
        'items'
    ]
};
const $e77534e6102db193$var$unitWord = (unit, n)=>{
    const w = $e77534e6102db193$var$UNIT_WORDS[unit] || [
        unit.toLowerCase(),
        `${unit.toLowerCase()}s`
    ];
    return n === 1 ? w[0] : w[1];
};
const $e77534e6102db193$var$lineAnnual = (id, d)=>{
    const s = $e77534e6102db193$var$SERVICE.get(id);
    if (!s || !d || !(Number(d.quantity) > 0)) return 0;
    return s.medianPrice * (0, $08809b7a4fc47e27$export$436317f0a4e6f4d7)(Number(d.quantity), d.frequency || 'weekly') * 12;
};
const $e77534e6102db193$var$Rule = ({ title: title })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-[13px] font-semibold text-brand-navy",
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "h-px flex-1 bg-slate-200"
            })
        ]
    });
function $e77534e6102db193$export$19edcfe561d23918(pricedKeys, choice) {
    return pricedKeys.includes(choice) ? choice : pricedKeys[0] ?? choice;
}
const $e77534e6102db193$var$SahStep1 = ({ factFind: factFind, setFactFind: setFactFind, plan: plan, onPlanChange: onPlanChange, supportStartDate: supportStartDate, setSupportStartDate: setSupportStartDate, years: years, savedStrategies: savedStrategies, onReadGuide: onReadGuide, onNext: onNext, onOpenCashflow: onOpenCashflow })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const isCouple = factFind?.adviceFor === 'couple';
    const goals = factFind?.goals || {};
    const [primerOpen, setPrimerOpen] = (0, $acw62.useState)(!goals.sahPrimerSeen);
    const [chspOpen, setChspOpen] = (0, $acw62.useState)(false);
    const markPrimerSeen = ()=>{
        setPrimerOpen(false);
        if (!goals.sahPrimerSeen) setFactFind((prev)=>({
                ...prev,
                goals: {
                    ...prev?.goals || {},
                    sahPrimerSeen: true
                }
            }));
    };
    // The move question: only where a partner's aged care is on file.
    const entering = (0, $5ea55f03cd2af1e4$export$2205ffc60cf2c238)(factFind);
    const agedCarePlan = (0, $5ea55f03cd2af1e4$export$b164904e0d858bed)(savedStrategies);
    const name = (k)=>String((k === 'client' ? factFind?.client?.firstName : factFind?.partner?.firstName) || (k === 'client' ? 'You' : 'Partner'));
    const enteringName = entering ? name(entering) : '';
    const move = (0, $5ea55f03cd2af1e4$export$12c4b1871639c9ac)(factFind);
    const setMove = (a)=>setFactFind((prev)=>({
                ...prev,
                goals: {
                    ...prev?.goals || {},
                    sahAgedCareMove: a
                }
            }));
    // Who the support is for: the profile's answer, less a person moving into care.
    const people = [
        'client',
        'partner'
    ].filter((k)=>k === 'client' || isCouple).map((k)=>{
        const acat = factFind?.careNeeds?.[`${k}Acat`];
        const level = acat?.status === 'yes' ? acat.homeCareLevel : undefined;
        const label = level ? String((0, $c220d08b55e5dd64$export$bfae9591cc0d7897)[level]?.label || '') : '';
        const classification = label.match(/classification\s*\d+/i)?.[0]?.toLowerCase() || (label ? label.replace(/^Support at Home\s*-\s*/i, '').toLowerCase() : '');
        return {
            key: k,
            name: name(k),
            level: level,
            classification: classification,
            budget: level ? (0, $c220d08b55e5dd64$export$36fcde3ddb6f0194)(level) : 0,
            moving: move === 'yes' && entering === k
        };
    });
    const priced = people.filter((p)=>!p.moving);
    /*
     * THE CLASSIFICATION, ENTERED HERE (owner, 20 Oct 2026: "rather than having to go back into the client
     * profile"). Written to the profile's own fields (careNeeds.{client,partner}Acat), so the profile stays
     * the one record: the same two kinds of approval and the same level lists as its Goals step, and, for a
     * package carried over, the 12 September 2024 question that decides the no-worse-off rules.
     */ const [editing, setEditing] = (0, $acw62.useState)(null);
    const acatOf = (k)=>factFind?.careNeeds?.[`${k}Acat`] || {};
    const setAcat = (k, patch)=>setFactFind((prev)=>{
            const careNeeds = prev?.careNeeds || {};
            const current = careNeeds[`${k}Acat`] || {
                recommendation: {}
            };
            return {
                ...prev,
                careNeeds: {
                    ...careNeeds,
                    [`${k}Acat`]: {
                        ...current,
                        ...patch
                    }
                }
            };
        });
    const classificationForm = (k, personName)=>{
        const a = acatOf(k);
        const basis = a.levelBasis ?? (a.hcpBeforeSep2024 === 'yes' ? 'transitioned_hcp' : 'sah_classification');
        const keys = basis === 'transitioned_hcp' ? (0, $c220d08b55e5dd64$export$5e8d2d3fba9733e4) : (0, $c220d08b55e5dd64$export$712f07a1eb8135ac);
        const level = a.status === 'yes' ? a.homeCareLevel || '' : '';
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "mt-2 space-y-2 border-t border-slate-100 pt-2 text-[13px]",
            "data-testid": `sah-classification-form-${k}`,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    className: "flex items-start gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "radio",
                            name: `sah-basis-${k}`,
                            checked: basis === 'sah_classification',
                            onChange: ()=>setAcat(k, {
                                    levelBasis: 'sah_classification',
                                    ...level && !(0, $c220d08b55e5dd64$export$712f07a1eb8135ac).includes(level) ? {
                                        homeCareLevel: ''
                                    } : {}
                                }),
                            className: "mt-0.5 accent-blue-600"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "A Support at home classification (1\u20138), from an assessment since 1 November 2025"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    className: "flex items-start gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "radio",
                            name: `sah-basis-${k}`,
                            checked: basis === 'transitioned_hcp',
                            onChange: ()=>setAcat(k, {
                                    levelBasis: 'transitioned_hcp',
                                    ...level && !(0, $c220d08b55e5dd64$export$5e8d2d3fba9733e4).includes(level) ? {
                                        homeCareLevel: ''
                                    } : {}
                                }),
                            className: "mt-0.5 accent-blue-600"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "A Home Care Package (level 1\u20134) approved before 1 November 2025"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                    value: level,
                    onChange: (e)=>setAcat(k, e.target.value ? {
                            status: 'yes',
                            levelBasis: basis,
                            homeCareLevel: e.target.value
                        } : {
                            status: 'no',
                            homeCareLevel: ''
                        }),
                    "aria-label": `${personName}'s classification`,
                    className: "w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-[13px]",
                    "data-testid": `sah-classification-${k}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: "",
                            children: "Not assessed yet"
                        }),
                        keys.map((key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                value: key,
                                children: [
                                    (0, $c220d08b55e5dd64$export$bfae9591cc0d7897)[key].label,
                                    " \u2014 ",
                                    $e77534e6102db193$var$money((0, $c220d08b55e5dd64$export$bfae9591cc0d7897)[key].budget),
                                    " a year"
                                ]
                            }, key))
                    ]
                }),
                basis === 'transitioned_hcp' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-wrap items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-slate-600",
                            children: "Approved before 12 September 2024?"
                        }),
                        [
                            'yes',
                            'no',
                            'unsure'
                        ].map((ans)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "inline-flex items-center gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "radio",
                                        name: `sah-hcp-${k}`,
                                        checked: a.hcpBeforeSep2024 === ans,
                                        onChange: ()=>setAcat(k, {
                                                hcpBeforeSep2024: ans
                                            }),
                                        className: "accent-blue-600"
                                    }),
                                    ans === 'unsure' ? 'Not sure' : ans === 'yes' ? 'Yes' : 'No'
                                ]
                            }, ans)),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-slate-500",
                            children: "\u2014 if yes, the \u2018no worse off\u2019 rules apply to their contributions."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center justify-between gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-slate-500",
                            children: "Saved to the client profile."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>setEditing(null),
                            className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2",
                            children: "Done"
                        })
                    ]
                })
            ]
        });
    };
    const [tabChoice, setTab] = (0, $acw62.useState)(priced[0]?.key ?? 'client');
    /*
     * THE TAB ALWAYS SHOWS SOMEONE BEING PRICED (owner, 24 Oct 2026: after "Yes — Kevin is moving" there was no way
     * to add Mavis's services). The choice was set once, when the page opened, so answering the move question
     * afterwards left it on the person moving, and with one person priced there is no tab bar to switch. A choice
     * that is no longer priced falls to the first person who is; a single person moving keeps their own tab.
     */ const tab = $e77534e6102db193$export$19edcfe561d23918(priced.map((p)=>p.key), tabChoice);
    /** A second way into a person's services, from the insights (owner, 22 Oct 2026): their tab, brought into view. */ const servicesRef = (0, $acw62.useRef)(null);
    const openServicesFor = (key)=>{
        setTab(key);
        setQuery('');
        setFresh(null);
        servicesRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };
    const current = people.find((p)=>p.key === tab) ?? people[0];
    // The money, live.
    const { figures: b, loading: loading } = (0, $442fff09aec5e55b$export$77ca36aac45f0c9)({
        factFind: factFind,
        servicePlan: plan,
        years: years,
        supportStartDate: supportStartDate,
        savedStrategies: savedStrategies
    });
    const lastEdit = (0, $acw62.useRef)(null);
    const [lastChange, setLastChange] = (0, $acw62.useState)(null);
    const prevContribution = (0, $acw62.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!b || loading) return;
        if (lastEdit.current && lastEdit.current.before != null) {
            setLastChange({
                text: lastEdit.current.text,
                delta: b.contribution - lastEdit.current.before
            });
            lastEdit.current = null;
        }
        prevContribution.current = b.contribution;
    }, [
        b,
        loading
    ]);
    const side = plan[tab] || {};
    const setLine = (id, d, text)=>{
        lastEdit.current = {
            text: text,
            before: prevContribution.current
        };
        const nextSide = {
            ...side
        };
        if (d && d.quantity > 0) nextSide[id] = d;
        else delete nextSide[id];
        onPlanChange({
            ...plan,
            [tab]: nextSide
        });
    };
    const [query, setQuery] = (0, $acw62.useState)('');
    /** Browse by care type (owner, 19 Oct 2026: "In our original app we had it grouped into the different care types"). */ const [browseOpen, setBrowseOpen] = (0, $acw62.useState)({});
    const matches = (0, $acw62.useMemo)(()=>{
        const q = query.trim().toLowerCase();
        if (q.length < 2) return [];
        return $e77534e6102db193$var$CATALOGUE.filter((s)=>!side[s.id] && s.medianPrice > 0 && (s.name.toLowerCase().includes(q) || (s.keywords || []).some((k)=>k.toLowerCase().includes(q)))).slice(0, 8);
    }, [
        query,
        side
    ]);
    const rates = b?.rates;
    const groups = [
        // Free within the budget only: above it every service is paid in full (owner, 20 Oct 2026).
        {
            key: 'free',
            title: `Free to ${v.them} within the budget`,
            sub: 'nursing, personal care and therapy'
        },
        {
            key: 'independence',
            title: rates ? `${v.They} pay ${$e77534e6102db193$var$pct(rates.independence)} of each hour` : `${v.They} pay a share of each hour`,
            sub: 'getting out and about'
        },
        {
            key: 'everyday',
            title: rates ? `${v.They} pay ${$e77534e6102db193$var$pct(rates.everydayLiving)} of each hour` : `${v.They} pay a share of each hour`,
            sub: 'help around the house'
        }
    ];
    const lines = Object.entries(side).filter(([id, d])=>$e77534e6102db193$var$SERVICE.has(id) && d && Number(d.quantity) > 0);
    const personTotal = lines.reduce((t, [id, d])=>t + $e77534e6102db193$var$lineAnnual(id, d), 0);
    const over = current && current.budget > 0 && personTotal > current.budget ? personTotal - current.budget : 0;
    const other = priced.find((p)=>p.key !== tab);
    const otherTotal = other ? Object.entries(plan[other.key] || {}).reduce((t, [id, d])=>t + $e77534e6102db193$var$lineAnnual(id, d), 0) : 0;
    const otherRoom = other && other.budget > 0 ? Math.max(0, other.budget - otherTotal) : 0;
    const count = (k)=>Object.values(plan[k] || {}).filter((d)=>d && Number(d.quantity) > 0).length;
    /*
     * ONE PLACE TO CHANGE A SERVICE (owner, 24 Oct 2026: the plan and the list to add from showed the same
     * services twice, both editable, "it can almost look like some duplication"). The plan is the only list
     * that edits; the list to add from marks a chosen service "In the plan" and takes you to it. A service
     * just added lands in the plan and the page goes to it, which keeps the 20 Oct promise that you never
     * scroll back to set how much and how often. The adding part folds away once the plan has services.
     */ const [addOpen, setAddOpen] = (0, $acw62.useState)(false);
    const goToLine = (id)=>{
        const row = document.querySelector(`[data-testid="sah-line-${id}"]`);
        row?.scrollIntoView({
            block: 'center',
            behavior: 'smooth'
        });
        row?.querySelector('input')?.focus({
            preventScroll: true
        });
    };
    /*
     * THE SERVICE JUST ADDED STAYS MARKED (owner, 22 Oct 2026: "someone new or not that tech savvy could get lost").
     * Where it was added (the browse row, or the box under the search) it is outlined in blue with "Just added — set
     * how much and how often", and the cursor goes to its "how many" box. A steady mark, not a pulse: it stays until
     * they have changed it and moved on, removed it, pressed Done, or added another.
     */ const [fresh, setFresh] = (0, $acw62.useState)(null);
    const freshEdited = (0, $acw62.useRef)(false);
    const freshFocused = (0, $acw62.useRef)(null);
    const addService = (s)=>{
        const f = s.unit === 'Hour' ? 'weekly' : 'monthly';
        setLine(s.id, {
            quantity: 1,
            frequency: f
        }, `${s.name}, 1 ${$e77534e6102db193$var$unitWord(s.unit, 1)} a ${f === 'weekly' ? 'week' : 'month'}`);
        setFresh(s.id);
        freshEdited.current = false;
    };
    /** One service's line: how many, how often, its yearly cost, remove. The same control wherever it shows. */ const lineRow = (id, d)=>{
        const s = $e77534e6102db193$var$SERVICE.get(id);
        const qty = Number(d?.quantity) || 0;
        const freq = d?.frequency || 'weekly';
        const words = (q, f)=>`${s.name}, ${q} ${$e77534e6102db193$var$unitWord(s.unit, q)} a ${f === 'daily' ? 'day' : f === 'monthly' ? 'month' : 'week'}`;
        const isFresh = fresh === id;
        const edited = ()=>{
            if (isFresh) freshEdited.current = true;
        };
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: `grid grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-x-3 gap-y-1.5 py-2.5 text-[14px] sm:grid-cols-[minmax(0,1fr)_auto_auto_auto] sm:gap-y-3 ${isFresh ? '-mx-2 my-1 rounded-lg bg-blue-50/70 px-2 ring-2 ring-blue-500' : ''}`,
            "data-testid": `sah-line-${id}`,
            "data-fresh": isFresh ? 'true' : undefined,
            onBlur: (e)=>{
                if (isFresh && freshEdited.current && !e.currentTarget.contains(e.relatedTarget)) setFresh(null);
            },
            children: [
                isFresh && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "col-span-full -mb-1 text-[12.5px] font-semibold text-blue-800",
                    "data-testid": "sah-fresh-hint",
                    children: "Just added \u2014 set how much and how often."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "col-span-full min-w-0 text-slate-800 sm:col-span-1",
                    children: [
                        s.name,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e77534e6102db193$var$ServiceHelp, {
                            name: s.name,
                            description: s.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "inline-flex items-center gap-1.5 rounded-lg border border-slate-300 bg-white px-2 py-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "number",
                            min: 0,
                            step: 1,
                            value: qty,
                            onChange: (e)=>{
                                edited();
                                const q = Math.max(0, Math.round(Number(e.target.value) || 0));
                                setLine(id, {
                                    quantity: q,
                                    frequency: freq
                                }, words(q, freq));
                            },
                            ref: (el)=>{
                                // A service just added: the page goes to it in the plan, with the cursor in "how many".
                                if (el && isFresh && freshFocused.current !== id) {
                                    freshFocused.current = id;
                                    el.closest('[data-testid]')?.scrollIntoView({
                                        block: 'center',
                                        behavior: 'smooth'
                                    });
                                    el.focus({
                                        preventScroll: true
                                    });
                                    el.select();
                                }
                            },
                            "aria-label": `${s.name} \u{2014} how many`,
                            className: "w-12 border-0 bg-transparent p-0 text-right font-semibold tabular-nums focus:ring-0"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "text-slate-500",
                            children: [
                                $e77534e6102db193$var$unitWord(s.unit, qty),
                                " a"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                            value: freq,
                            onChange: (e)=>{
                                edited();
                                setLine(id, {
                                    quantity: qty,
                                    frequency: e.target.value
                                }, words(qty, e.target.value));
                            },
                            "aria-label": `${s.name} \u{2014} how often`,
                            className: "border-0 bg-transparent p-0 pr-5 text-slate-500 focus:ring-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "daily",
                                    children: "day"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "weekly",
                                    children: "week"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "monthly",
                                    children: "month"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "w-28 justify-self-end text-right tabular-nums text-slate-800",
                    children: [
                        $e77534e6102db193$var$money($e77534e6102db193$var$lineAnnual(id, d)),
                        " a year"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: ()=>{
                        setLine(id, null, `${s.name} removed`);
                        if (fresh === id) setFresh(null);
                    },
                    "aria-label": `Remove ${s.name}`,
                    className: "rounded p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-700",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                        size: 15
                    })
                })
            ]
        });
    };
    /*
     * THE INSIGHTS (owner, 19 Oct 2026: "look at the original apps insight panel for any cool insights").
     * The old panel's walkthrough copy is not carried over; its live insights are, in this module's words:
     * where the services sit by care type and the rate they pay on each; budget left unused and how little
     * of it carries over; and, for a couple, whose budget has room for shared help.
     */ const household = priced.map((p)=>{
        const side = Object.entries(plan[p.key] || {}).filter(([id, d])=>$e77534e6102db193$var$SERVICE.has(id) && d && Number(d.quantity) > 0);
        const byGroup = {
            free: 0,
            independence: 0,
            everyday: 0
        };
        for (const [id, d] of side)byGroup[$e77534e6102db193$var$SERVICE.get(id).group] += $e77534e6102db193$var$lineAnnual(id, d);
        const total = byGroup.free + byGroup.independence + byGroup.everyday;
        return {
            ...p,
            byGroup: byGroup,
            total: total,
            unused: p.budget > 0 ? Math.max(0, p.budget - total) : 0
        };
    });
    const split = household.reduce((t, p)=>({
            free: t.free + p.byGroup.free,
            independence: t.independence + p.byGroup.independence,
            everyday: t.everyday + p.byGroup.everyday
        }), {
        free: 0,
        independence: 0,
        everyday: 0
    });
    const splitTotal = split.free + split.independence + split.everyday;
    /** What carries into the next quarter: $1,000 or 10% of the quarterly budget, whichever is higher. */ const carryOver = (budget)=>Math.max(1000, budget / 4 * 0.1);
    const roomy = household.filter((p)=>p.budget > 0 && p.unused > 0).sort((a, z)=>z.unused - a.unused)[0];
    const tight = household.find((p)=>p.budget > 0 && p.total > p.budget * 0.9 && p.key !== roomy?.key);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-6",
        "data-testid": "sah-step1",
        children: [
            primerOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `rounded-2xl border border-slate-200 ${(0, $e1e942361049df06$export$10832a06bd6966f8)} bg-white p-6 shadow-card`,
                "data-testid": "sah-primer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1e942361049df06$export$eb5dff254945ec0e), {
                        title: "Support at home, in a minute",
                        open: true,
                        onToggle: markPrimerSeen
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3 grid grid-cols-1 gap-x-8 gap-y-3 text-[14px] leading-relaxed text-slate-700 md:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: (0, $e1e942361049df06$export$60f4f4563d451e62),
                                        children: "The government sets a yearly budget"
                                    }),
                                    " for each person from their assessment \u2014 the classification."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: (0, $e1e942361049df06$export$60f4f4563d451e62),
                                        children: [
                                            v.They,
                                            " pay a contribution towards each service"
                                        ]
                                    }),
                                    " \u2014 a share of each hour, set by the means test. Nursing and personal care are free; help to get out and about, and help around the house, are not."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: (0, $e1e942361049df06$export$60f4f4563d451e62),
                                        children: "Services above the budget are paid in full,"
                                    }),
                                    " privately, at the provider's price."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: (0, $e1e942361049df06$export$60f4f4563d451e62),
                                        children: "There is a lifetime limit."
                                    }),
                                    " Once a person has paid ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: (0, $e1e942361049df06$export$2231117efb2a2550),
                                        children: $e77534e6102db193$var$money((0, $c424aab2467b2598$export$c5fbc76332b2670f).standard)
                                    }),
                                    " in contributions, they pay nothing more."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-3 text-[13px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onReadGuide,
                                className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                children: "Read the full guide to Support at home"
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setChspOpen(true),
                                className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                children: "How it compares with entry-level support"
                            })
                        ]
                    })
                ]
            }) : // Folded: one slim row, the same header with "Show" (23 Oct 2026).
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `rounded-2xl border border-slate-200 ${(0, $e1e942361049df06$export$10832a06bd6966f8)} bg-white px-6 py-3 shadow-card`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1e942361049df06$export$eb5dff254945ec0e), {
                    title: "Support at home, in a minute",
                    open: false,
                    onToggle: ()=>setPrimerOpen(true),
                    testId: "sah-primer-open"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02b552f3b0af8007$export$7753eabeacd6f0b2), {
                open: chspOpen,
                onClose: ()=>setChspOpen(false)
            }),
            entering && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
                "data-testid": "sah-move-question",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: "text-[19px] font-bold text-brand-navy",
                        children: [
                            "Is ",
                            enteringName,
                            " moving into aged care?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1 text-[13px] text-slate-500",
                        children: [
                            agedCarePlan ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    enteringName,
                                    " has a residential care plan ",
                                    agedCarePlan.chosen ? 'chosen' : 'saved',
                                    ": ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: "text-slate-800",
                                        children: [
                                            "\u201C",
                                            (0, $95e43332fd84eec4$export$6cc0d9545ae1511e)(agedCarePlan, factFind),
                                            "\u201D"
                                        ]
                                    }),
                                    ". To use a different one, choose it in Aged care."
                                ]
                            }) : `An aged care move for ${enteringName} is one of the file's goals.`,
                            " The answer decides whose support we price here, and how the money side is worked out."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-3 space-y-2 text-[14px] text-slate-800",
                        children: [
                            [
                                'no',
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "No \u2014 both staying at home."
                                        }),
                                        " We price ",
                                        v.possessive,
                                        " support",
                                        isCouple ? `, each against ${v.their} own budget` : '',
                                        "."
                                    ]
                                })
                            ],
                            [
                                'yes',
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                            children: [
                                                "Yes \u2014 ",
                                                enteringName,
                                                " is moving."
                                            ]
                                        }),
                                        " We price ",
                                        name(entering === 'client' ? 'partner' : 'client'),
                                        "'s support only. ",
                                        agedCarePlan ? `${enteringName}'s aged care plan is carried out in full first \u{2014} its deposit and everything else it does, its living costs and yearly fees \u{2014} and the illness-separated rates apply.` : `Choose ${enteringName}'s aged care plan first so its costs can be counted.`
                                    ]
                                })
                            ],
                            [
                                'unsure',
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Not sure yet."
                                        }),
                                        " We price both at home, and every figure is a what-if until it is decided."
                                    ]
                                })
                            ]
                        ].map(([value, words])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "flex items-start gap-2.5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "radio",
                                        name: "sah-move",
                                        checked: (move ?? 'no') === value,
                                        onChange: ()=>setMove(value),
                                        disabled: value === 'yes' && !agedCarePlan,
                                        className: "mt-1 h-4 w-4 accent-blue-600",
                                        "data-testid": `sah-move-${value}`
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: words
                                    })
                                ]
                            }, value))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 items-start gap-5 xl:grid-cols-[minmax(0,1fr)_300px]",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-6 rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e77534e6102db193$var$Rule, {
                                        title: "Who the support is for"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: `mt-3 grid grid-cols-1 gap-3 ${people.length > 1 ? 'sm:grid-cols-2' : ''}`,
                                        children: people.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "rounded-xl border border-slate-200 px-4 py-3",
                                                "data-testid": `sah-who-${p.key}`,
                                                children: p.moving ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-[12.5px] font-semibold text-slate-500",
                                                            children: "Moving into aged care"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "mt-0.5 text-[15px] text-slate-800",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: p.name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-[13px] text-slate-500",
                                                            children: [
                                                                "No Support at home is priced for ",
                                                                p.name,
                                                                "."
                                                            ]
                                                        })
                                                    ]
                                                }) : p.level ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex items-baseline justify-between gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "text-[12.5px] font-semibold text-emerald-700",
                                                                    children: "\u2713 Assessed"
                                                                }),
                                                                editing !== p.key && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: ()=>setEditing(p.key),
                                                                    className: "text-[12.5px] font-semibold text-blue-700 underline decoration-dotted underline-offset-2",
                                                                    "data-testid": `sah-classification-change-${p.key}`,
                                                                    children: "Change"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "mt-0.5 text-[15px] text-slate-800",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: p.name
                                                                }),
                                                                " \xb7 ",
                                                                p.classification
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-[22px] font-bold tabular-nums text-brand-navy",
                                                            children: [
                                                                $e77534e6102db193$var$money(p.budget),
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-[13px] font-medium text-slate-500",
                                                                    children: "a year"
                                                                })
                                                            ]
                                                        }),
                                                        editing === p.key && classificationForm(p.key, p.name)
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-[12.5px] font-semibold text-slate-500",
                                                            children: "Not assessed yet"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "mt-0.5 text-[15px] text-slate-800",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: p.name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-[13px] text-slate-500",
                                                            children: "The budget comes from the assessment. Until then no budget limit is applied: every service is priced at the contribution rates."
                                                        }),
                                                        editing === p.key ? classificationForm(p.key, p.name) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>setEditing(p.key),
                                                            className: "mt-1.5 text-[13px] font-semibold text-blue-700 underline decoration-dotted underline-offset-2",
                                                            "data-testid": `sah-classification-enter-${p.key}`,
                                                            children: "Assessed already? Enter the classification"
                                                        })
                                                    ]
                                                })
                                            }, p.key))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-2 text-[13px] text-slate-500",
                                        children: [
                                            "From the profile",
                                            goals.home_care_for ? `'s answer to "Who is the goal for?"` : '',
                                            ". Budgets are paid quarterly and managed by Services Australia."
                                        ]
                                    }),
                                    onOpenCashflow && priced.length > 0 && priced.every((p)=>!p.level) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-3 text-[13px] leading-relaxed text-slate-700",
                                        "data-testid": "sah-cashflow-door",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                className: "text-slate-900",
                                                children: "Waiting on an assessment?"
                                            }),
                                            " Where ",
                                            v.possessive,
                                            " money stands today, how far it goes and what Age Pension is paid don't depend on one.",
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                onClick: onOpenCashflow,
                                                className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                                children: [
                                                    "See ",
                                                    v.possessive,
                                                    " cashflow and Age Pension"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e77534e6102db193$var$Rule, {
                                        title: "When does support start?"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-3 flex flex-wrap items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "date",
                                                value: supportStartDate,
                                                onChange: (e)=>setSupportStartDate(e.target.value),
                                                "aria-label": "When support starts",
                                                className: "rounded-lg border border-slate-300 bg-white px-3 py-2 text-[14px]",
                                                "data-testid": "sah-start-date"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-[13px] text-slate-500",
                                                children: supportStartDate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>setSupportStartDate(''),
                                                    className: "underline decoration-dotted underline-offset-2",
                                                    children: "Set back to now"
                                                }) : 'Now. Leave as it is if services have already begun, or pick a future date.'
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                ref: servicesRef,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e77534e6102db193$var$Rule, {
                                        title: "The services"
                                    }),
                                    priced.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-3 flex gap-1 border-b border-slate-200",
                                        role: "tablist",
                                        children: priced.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                role: "tab",
                                                "aria-selected": tab === p.key,
                                                onClick: ()=>{
                                                    setTab(p.key);
                                                    setQuery('');
                                                    setFresh(null);
                                                },
                                                className: `-mb-px border-b-2 px-3 py-2 text-[14px] ${tab === p.key ? 'border-brand-navy font-semibold text-brand-navy' : count(p.key) ? 'border-transparent text-slate-500 hover:text-slate-800' : 'border-transparent font-semibold text-blue-700 hover:text-blue-900'}`,
                                                "data-testid": `sah-tab-${p.key}`,
                                                children: [
                                                    p.name,
                                                    " \xb7 ",
                                                    count(p.key) ? `${count(p.key)} ${count(p.key) === 1 ? 'service' : 'services'}` : tab === p.key ? 'none yet' : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            "none yet \u2014 ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "underline decoration-dotted underline-offset-2",
                                                                children: "add services"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, p.key))
                                    }),
                                    current?.moving ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-3 text-[14px] text-slate-600",
                                        children: [
                                            current.name,
                                            " is moving into aged care, so no Support at home services are priced."
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            lines.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-3 text-[14px] text-slate-600",
                                                "data-testid": "sah-services-empty",
                                                children: [
                                                    "No services yet for ",
                                                    current?.name,
                                                    '. Add what the assessment recommended \u2014 search below by what is needed, for example "showering", "cleaning" or "physio".'
                                                ]
                                            }),
                                            lines.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mt-4",
                                                "data-testid": "sah-plan",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-[15px] font-bold text-brand-navy",
                                                        children: [
                                                            current?.name,
                                                            "'s plan"
                                                        ]
                                                    }),
                                                    groups.map((g)=>{
                                                        const inGroup = lines.filter(([id])=>$e77534e6102db193$var$SERVICE.get(id)?.group === g.key);
                                                        if (!inGroup.length) return null;
                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "mt-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                    className: "text-[13px] font-semibold text-brand-navy",
                                                                    children: [
                                                                        g.title,
                                                                        " ",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "font-normal text-slate-500",
                                                                            children: g.sub
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "mt-1 divide-y divide-slate-100 border-y border-slate-100",
                                                                    children: inGroup.map(([id, d])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                                            children: lineRow(id, d)
                                                                        }, id))
                                                                })
                                                            ]
                                                        }, g.key);
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mt-2 flex items-baseline justify-between border-t-2 border-slate-300 pt-2 text-[14px]",
                                                        "data-testid": "sah-plan-total",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "font-bold text-brand-navy",
                                                                children: [
                                                                    "Total for ",
                                                                    current?.name
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "mr-8 font-bold tabular-nums text-brand-navy",
                                                                children: [
                                                                    $e77534e6102db193$var$money(personTotal),
                                                                    " a year"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    current && current.budget > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mt-2",
                                                        "data-testid": "sah-budget",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex items-baseline justify-between gap-3 text-[13px]",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                        className: "text-slate-600",
                                                                        children: [
                                                                            "Budget ",
                                                                            $e77534e6102db193$var$money(current.budget),
                                                                            " a year"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: `mr-8 tabular-nums ${over > 0 ? 'font-semibold text-rose-700' : 'text-slate-600'}`,
                                                                        children: over > 0 ? `${$e77534e6102db193$var$money(over)} over \u{2014} paid in full` : `${$e77534e6102db193$var$money(current.budget - personTotal)} left`
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "relative mt-1.5 h-2 overflow-hidden rounded-full bg-slate-100",
                                                                "aria-hidden": true,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: `block h-full rounded-full ${over > 0 ? 'bg-brand-navy' : 'bg-blue-600'}`,
                                                                        style: {
                                                                            width: `${Math.min(100, personTotal / Math.max(personTotal, current.budget) * 100)}%`
                                                                        }
                                                                    }),
                                                                    over > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "absolute top-0 h-full w-0.5 bg-rose-500",
                                                                        style: {
                                                                            left: `${current.budget / personTotal * 100}%`
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            over > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "mt-3 rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] text-slate-700",
                                                                "data-testid": "sah-over-budget",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                        className: "text-slate-900",
                                                                        children: [
                                                                            $e77534e6102db193$var$money(over),
                                                                            " more than ",
                                                                            current.name,
                                                                            "'s budget."
                                                                        ]
                                                                    }),
                                                                    " Services above the budget are paid in full, privately.",
                                                                    other && otherRoom > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                        children: [
                                                                            " ",
                                                                            other.name,
                                                                            "'s budget has ",
                                                                            $e77534e6102db193$var$money(otherRoom),
                                                                            " unused, so some services could go under ",
                                                                            other.name,
                                                                            "'s name instead \u2014 or trim the plan."
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                                                        children: " Trim the plan, or ask the assessor whether a higher classification fits."
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            lines.length > 0 && !addOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>setAddOpen(true),
                                                className: "mt-5 inline-flex items-center gap-1.5 rounded-lg border border-blue-200 bg-white px-3 py-2 text-[14px] font-semibold text-blue-700 hover:bg-blue-50",
                                                "data-testid": "sah-add-open",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                                        size: 15,
                                                        "aria-hidden": true
                                                    }),
                                                    " Add another service"
                                                ]
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mt-5 rounded-xl border border-slate-200 bg-white p-4",
                                                "data-testid": "sah-add-panel",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex items-baseline justify-between gap-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                className: "text-[15px] font-bold text-brand-navy",
                                                                children: [
                                                                    "Add a service",
                                                                    priced.length > 1 ? ` for ${current?.name}` : ''
                                                                ]
                                                            }),
                                                            lines.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                onClick: ()=>{
                                                                    setAddOpen(false);
                                                                    setQuery('');
                                                                },
                                                                className: "shrink-0 text-[13px] font-semibold text-blue-700 underline decoration-dotted underline-offset-2",
                                                                "data-testid": "sah-add-close",
                                                                children: "Done adding"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "relative mt-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                                                size: 15,
                                                                className: "pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400",
                                                                "aria-hidden": true
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "search",
                                                                value: query,
                                                                onChange: (e)=>setQuery(e.target.value),
                                                                placeholder: 'Search \u2014 try "physio", "gardening", "showering"\u2026',
                                                                "aria-label": "Add a service",
                                                                className: "w-full rounded-xl border border-slate-300 bg-white py-2.5 pl-9 pr-3 text-[14px]",
                                                                "data-testid": "sah-service-search"
                                                            }),
                                                            matches.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                                className: "absolute z-20 mt-1 w-full overflow-hidden rounded-xl border border-slate-200 bg-white shadow-lg",
                                                                role: "listbox",
                                                                children: matches.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                            type: "button",
                                                                            onClick: ()=>{
                                                                                addService(s);
                                                                                setQuery('');
                                                                            },
                                                                            className: "flex w-full items-baseline justify-between gap-3 px-4 py-2.5 text-left text-[14px] hover:bg-blue-50",
                                                                            "data-testid": `sah-add-${s.id}`,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                    className: "text-slate-800",
                                                                                    children: [
                                                                                        s.name,
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: "text-[12px] text-slate-500",
                                                                                            children: s.group === 'free' ? `free to ${v.them}` : s.group === 'independence' ? 'getting out and about' : 'help around the house'
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                    className: "shrink-0 tabular-nums text-[13px] text-slate-500",
                                                                                    children: [
                                                                                        $e77534e6102db193$var$money(s.medianPrice),
                                                                                        " a ",
                                                                                        $e77534e6102db193$var$unitWord(s.unit, 1)
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, s.id))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mt-4",
                                                        "data-testid": "sah-browse",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-[13px] text-slate-500",
                                                                children: "Or browse every service by type:"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "mt-2 divide-y divide-slate-200 rounded-xl border border-slate-200",
                                                                children: groups.map((g)=>{
                                                                    const all = $e77534e6102db193$var$CATALOGUE.filter((s)=>s.group === g.key && s.medianPrice > 0);
                                                                    const available = all.filter((s)=>!side[s.id]);
                                                                    const open = browseOpen[g.key] ?? lines.length === 0;
                                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                                type: "button",
                                                                                onClick: ()=>setBrowseOpen((o)=>({
                                                                                            ...o,
                                                                                            [g.key]: !open
                                                                                        })),
                                                                                "aria-expanded": open,
                                                                                className: "flex w-full items-baseline justify-between gap-3 px-4 py-2.5 text-left hover:bg-slate-50",
                                                                                "data-testid": `sah-browse-${g.key}`,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                        className: "text-[14px] font-semibold text-slate-800",
                                                                                        children: g.sub[0].toUpperCase() + g.sub.slice(1)
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                        className: "shrink-0 text-[12.5px] text-slate-500",
                                                                                        children: [
                                                                                            all.length - available.length > 0 ? `${all.length - available.length} in the plan \xb7 ` : '',
                                                                                            all.length,
                                                                                            " services ",
                                                                                            open ? "\u25B4" : "\u25BE"
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                                                className: "divide-y divide-slate-100 border-t border-slate-100",
                                                                                children: [
                                                                                    all.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                                                            className: "flex items-center justify-between gap-3 px-4 py-2 text-[14px]",
                                                                                            "data-testid": `sah-browse-line-${s.id}`,
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                    className: "min-w-0 text-slate-800",
                                                                                                    children: [
                                                                                                        s.name,
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e77534e6102db193$var$ServiceHelp, {
                                                                                                            name: s.name,
                                                                                                            description: s.description
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                side[s.id] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                                                    type: "button",
                                                                                                    onClick: ()=>goToLine(s.id),
                                                                                                    className: "inline-flex shrink-0 items-center gap-1 text-[13px] font-semibold text-emerald-700 hover:text-emerald-900",
                                                                                                    "data-testid": `sah-browse-inplan-${s.id}`,
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                                                                                            size: 14,
                                                                                                            "aria-hidden": true
                                                                                                        }),
                                                                                                        " In the plan"
                                                                                                    ]
                                                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                    className: "flex shrink-0 items-center gap-3",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                            className: "tabular-nums text-[13px] text-slate-500",
                                                                                                            children: [
                                                                                                                "about ",
                                                                                                                $e77534e6102db193$var$money(s.medianPrice),
                                                                                                                " a ",
                                                                                                                $e77534e6102db193$var$unitWord(s.unit, 1)
                                                                                                            ]
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                                            type: "button",
                                                                                                            onClick: ()=>{
                                                                                                                setBrowseOpen((o)=>({
                                                                                                                        ...o,
                                                                                                                        [g.key]: true
                                                                                                                    }));
                                                                                                                addService(s);
                                                                                                            },
                                                                                                            className: "rounded-lg border border-slate-300 bg-white px-2.5 py-1 text-[13px] font-semibold text-slate-800 hover:border-blue-300 hover:bg-blue-50",
                                                                                                            "data-testid": `sah-browse-add-${s.id}`,
                                                                                                            children: "Add"
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }, s.id)),
                                                                                    g.key === 'independence' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                                        className: "px-4 py-2 text-[12.5px] text-slate-500",
                                                                                        children: "Equipment and home changes are funded separately (the assistive technology and home modifications scheme) and priced item by item, so they are not listed."
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }, g.key);
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "mt-1.5 text-[12.5px] text-slate-500",
                                                                children: "Prices are typical rates; the provider's own price list is what is charged."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("aside", {
                        className: "rounded-2xl border border-slate-200 bg-white p-5 shadow-card xl:sticky xl:top-6",
                        "data-testid": "sah-money-panel",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e77534e6102db193$var$Rule, {
                                title: `What this does to ${v.possessive} money`
                            }),
                            !b ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-3 text-[13px] text-slate-500",
                                children: "Working it out\u2026"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: `mt-2 ${loading ? 'opacity-60' : ''}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-start justify-between gap-3 border-b border-slate-100 py-2.5",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-[14px] text-slate-800",
                                                        children: [
                                                            v.Their,
                                                            " contribution"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-[12px] text-slate-500",
                                                        children: "a year, on these services"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-[15px] font-bold tabular-nums text-slate-900",
                                                children: $e77534e6102db193$var$money(b.contribution)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-start justify-between gap-3 border-b border-slate-100 py-2.5",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-[14px] text-slate-800",
                                                        children: "Age Pension"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-[12px] text-slate-500",
                                                        children: v.couple ? `a year, the two of ${v.them}` : 'a year'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-[15px] font-bold tabular-nums text-slate-900",
                                                children: $e77534e6102db193$var$money(b.pension)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-start justify-between gap-3 border-t-2 border-brand-navy pt-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-[15px] font-bold text-brand-navy",
                                                        children: "Each year"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-[12px] text-slate-500",
                                                        children: "money in, less money out and the contribution"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: `text-[15px] font-bold tabular-nums ${b.cashflow < 0 ? 'text-rose-700' : 'text-emerald-700'}`,
                                                children: b.cashflow < 0 ? `short ${$e77534e6102db193$var$money(b.cashflow)}` : `${$e77534e6102db193$var$money(b.cashflow)} to spare`
                                            })
                                        ]
                                    }),
                                    lastChange && Math.abs(lastChange.delta) >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4",
                                        "data-testid": "sah-last-change",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e77534e6102db193$var$Rule, {
                                                title: "Last change"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-2 text-[13px] leading-relaxed text-slate-700",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        className: "text-slate-900",
                                                        children: lastChange.text
                                                    }),
                                                    " \u2014 ",
                                                    lastChange.delta > 0 ? '+' : "\u2212",
                                                    $e77534e6102db193$var$money(lastChange.delta),
                                                    " a year to ",
                                                    v.their,
                                                    " contribution."
                                                ]
                                            })
                                        ]
                                    }),
                                    b.costs.privateExcess >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-4 text-[12.5px] leading-relaxed text-slate-500",
                                        children: [
                                            "Includes ",
                                            $e77534e6102db193$var$money(b.costs.privateExcess),
                                            " of services above a budget, paid in full."
                                        ]
                                    }),
                                    household.some((p)=>p.budget > 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4",
                                        "data-testid": "sah-budget-bars",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e77534e6102db193$var$Rule, {
                                                title: `${v.Their} budgets`
                                            }),
                                            household.filter((p)=>p.budget > 0).map((p)=>{
                                                const usedPct = Math.min(100, p.total / p.budget * 100);
                                                const overBy = Math.max(0, p.total - p.budget);
                                                const tip = overBy > 0 ? `${p.name}: ${$e77534e6102db193$var$money(p.total)} of services against a ${$e77534e6102db193$var$money(p.budget)} budget \u{2014} ${$e77534e6102db193$var$money(overBy)} over, paid in full` : `${p.name}: ${$e77534e6102db193$var$money(p.total)} used of ${$e77534e6102db193$var$money(p.budget)} \u{2014} ${$e77534e6102db193$var$money(p.unused)} left`;
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "mt-2.5",
                                                    title: tip,
                                                    "data-testid": `sah-budget-bar-${p.key}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex items-baseline justify-between gap-2 text-[13px]",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "font-semibold text-slate-800",
                                                                    children: p.name
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "tabular-nums text-slate-600",
                                                                    children: [
                                                                        $e77534e6102db193$var$money(p.total),
                                                                        " ",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "text-slate-400",
                                                                            children: [
                                                                                "of ",
                                                                                $e77534e6102db193$var$money(p.budget)
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "relative mt-1 h-2.5 overflow-hidden rounded-full bg-slate-100",
                                                            role: "img",
                                                            "aria-label": tip,
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: `block h-full rounded-full ${overBy > 0 ? 'bg-rose-600' : usedPct >= 90 ? 'bg-amber-500' : 'bg-blue-600'}`,
                                                                style: {
                                                                    width: `${usedPct}%`
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: `mt-0.5 text-[12px] ${overBy > 0 ? 'font-semibold text-rose-700' : 'text-slate-500'}`,
                                                            children: overBy > 0 ? `${$e77534e6102db193$var$money(overBy)} over \u{2014} paid in full` : `${$e77534e6102db193$var$money(p.unused)} left`
                                                        })
                                                    ]
                                                }, p.key);
                                            })
                                        ]
                                    }),
                                    splitTotal >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4",
                                        "data-testid": "sah-insight-split",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e77534e6102db193$var$Rule, {
                                                title: "Where the services sit"
                                            }),
                                            [
                                                [
                                                    'free',
                                                    `Free to ${v.them}`,
                                                    null
                                                ],
                                                [
                                                    'independence',
                                                    'Getting out and about',
                                                    rates ? `${v.they} pay ${$e77534e6102db193$var$pct(rates.independence)}` : null
                                                ],
                                                [
                                                    'everyday',
                                                    'Help around the house',
                                                    rates ? `${v.they} pay ${$e77534e6102db193$var$pct(rates.everydayLiving)}` : null
                                                ]
                                            ].filter(([k])=>split[k] >= 1).map(([k, label, rate])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-baseline justify-between gap-3 py-1.5 text-[13px]",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-slate-700",
                                                            children: [
                                                                label,
                                                                rate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "text-slate-500",
                                                                    children: [
                                                                        " \xb7 ",
                                                                        rate
                                                                    ]
                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-slate-500",
                                                                    children: " \xb7 nothing to pay within the budget"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "tabular-nums font-semibold text-slate-900",
                                                            children: $e77534e6102db193$var$money(split[k])
                                                        })
                                                    ]
                                                }, k)),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-1 text-[12.5px] leading-relaxed text-slate-500",
                                                children: [
                                                    "A year of services, before the budget. More of the plan in nursing, personal care and therapy costs ",
                                                    v.them,
                                                    " nothing extra."
                                                ]
                                            })
                                        ]
                                    }),
                                    household.some((p)=>p.budget > 0 && p.total >= 1 && p.unused > carryOver(p.budget) * 4) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4",
                                        "data-testid": "sah-insight-unused",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e77534e6102db193$var$Rule, {
                                                title: "Budget not used"
                                            }),
                                            household.filter((p)=>p.budget > 0 && p.total >= 1 && p.unused > carryOver(p.budget) * 4).map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "mt-2 text-[13px] leading-relaxed text-slate-700",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                            className: "text-slate-900",
                                                            children: [
                                                                $e77534e6102db193$var$money(p.unused),
                                                                " of ",
                                                                p.name,
                                                                "'s budget is unused."
                                                            ]
                                                        }),
                                                        " Only ",
                                                        $e77534e6102db193$var$money(carryOver(p.budget)),
                                                        " a quarter carries over (the higher of $1,000 or 10% of the quarterly budget); the rest is lost, not saved."
                                                    ]
                                                }, p.key))
                                        ]
                                    }),
                                    roomy && tight && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-4 text-[13px] leading-relaxed text-slate-700",
                                        "data-testid": "sah-insight-couple",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                className: "text-slate-900",
                                                children: [
                                                    roomy.name,
                                                    "'s budget has ",
                                                    $e77534e6102db193$var$money(roomy.unused),
                                                    " to spare"
                                                ]
                                            }),
                                            " and ",
                                            tight.name,
                                            "'s is nearly used. Help that serves ",
                                            v.them,
                                            " both, like cleaning or gardening, can go under ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>openServicesFor(roomy.key),
                                                className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                                "data-testid": "sah-insight-open-roomy",
                                                children: [
                                                    roomy.name,
                                                    "'s name"
                                                ]
                                            }),
                                            "."
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center justify-end gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: "https://www.myagedcare.gov.au/find-a-provider",
                        target: "_blank",
                        rel: "noreferrer",
                        className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                        children: "Find a provider"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        type: "button",
                        variant: "brand",
                        size: "lg",
                        onClick: onNext,
                        "data-testid": "sah-step1-next",
                        children: [
                            "See what this means for ",
                            v.names,
                            " \u2192"
                        ]
                    })
                ]
            })
        ]
    });
};
var $e77534e6102db193$export$2e2bcd8739ae039 = $e77534e6102db193$var$SahStep1;


/**
 * Step 2 — "What it means for them" (rebuild M3, 19 Oct 2026; the agreed mock-up's j1-03).
 *
 * The four numbers with this support and nothing else changed — the comparison every plan on step 3
 * is read against, priced by the engine's own baseline (useSahBaseline) so they are the strip there.
 * Then their contribution for each hour, which means test sets the Age Pension and what that means for
 * the ways to help, how long the money lasts (and each person's lifetime limit), and what the rates
 * would be if Centrelink assessed them as an illness-separated couple.
 */ 

var $acw62 = parcelRequire("acw62");





















const $d07c83ba5dd1bfce$var$pct = (r)=>`${+(r * 100).toFixed(1)}%`;
const $d07c83ba5dd1bfce$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(n)));
function $d07c83ba5dd1bfce$export$15e2917e59577d28(b, livingExpenses) {
    const y1 = b.projections[0] || {};
    return {
        contribution: b.contribution,
        pension: b.pension,
        cashflow: b.cashflow,
        legacy: b.legacy,
        investmentIncome: Number(y1.investmentIncome) || Number(b.financials.investmentIncome) || 0,
        rates: b.rates,
        breakdown: {
            clinical: b.costs.clinical,
            independence: b.costs.independence,
            everydayLiving: b.costs.everyday,
            independenceContribution: b.costs.contribution.independence,
            everydayContribution: b.costs.contribution.everyday,
            privateExcess: b.costs.privateExcess
        },
        livingExpenses: livingExpenses,
        taxPayable: Number(b.financials.netTax) || 0,
        pensionRows: b.financials.socialSecurityBreakdown || [],
        cashFlowBreakdown: y1.cashFlowBreakdown || b.financials.cashFlowBreakdown
    };
}
const $d07c83ba5dd1bfce$var$Why = ({ onClick: onClick, children: children = 'why?' })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        type: "button",
        onClick: onClick,
        className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
        children: children
    });
const $d07c83ba5dd1bfce$var$Section = ({ title: title, children: children, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "border-t border-slate-100 pt-5 first:border-t-0 first:pt-0",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "text-[15px] font-bold text-brand-navy",
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-2",
                children: children
            })
        ]
    });
const $d07c83ba5dd1bfce$var$SahStep2 = ({ factFind: factFind, servicePlan: servicePlan, years: years, supportStartDate: supportStartDate, savedStrategies: savedStrategies, onBack: onBack, onNext: onNext, onEnterLetterRates: onEnterLetterRates, onYearsChange: onYearsChange })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const isCouple = factFind?.adviceFor === 'couple';
    const { figures: b, loading: loading, error: error, linkedCare: linkedCare } = (0, $442fff09aec5e55b$export$77ca36aac45f0c9)({
        factFind: factFind,
        servicePlan: servicePlan,
        years: years,
        supportStartDate: supportStartDate,
        savedStrategies: savedStrategies
    });
    // With a partner moving into care, the household priced is the aged care plan carried out: the runway,
    // the living costs and the year-by-year read that household, not the profile as entered (24 Oct 2026).
    const household = linkedCare?.after ?? factFind;
    const linkedStory = (0, $acw62.useMemo)(()=>linkedCare ? (0, $a109d47f19f08f50$export$f59d8746d20e5371)(linkedCare) : null, [
        linkedCare
    ]);
    // The illness-separated rates, where a move into care would make them so and it is not already priced that way.
    const entering = (0, $5ea55f03cd2af1e4$export$2205ffc60cf2c238)(factFind);
    const separatedOverrides = (0, $acw62.useMemo)(()=>(0, $8eecd0af141b9afb$export$7b84565bbb0eef12)(factFind), [
        factFind
    ]);
    const showSeparated = isCouple && !!entering && (0, $5ea55f03cd2af1e4$export$12c4b1871639c9ac)(factFind) !== 'yes' && Object.keys(separatedOverrides).length > 0;
    const separated = (0, $442fff09aec5e55b$export$77ca36aac45f0c9)({
        factFind: factFind,
        servicePlan: servicePlan,
        years: years,
        supportStartDate: supportStartDate,
        savedStrategies: savedStrategies,
        extraStrategyOptions: separatedOverrides,
        enabled: showSeparated
    });
    const [page, setPage] = (0, $acw62.useState)(null);
    const [yearsOpen, setYearsOpen] = (0, $acw62.useState)(false);
    const [separatedOpen, setSeparatedOpen] = (0, $acw62.useState)(false);
    const living = Number(household?.expenses?.livingExpenses) || 0;
    const fig = b ? $d07c83ba5dd1bfce$export$15e2917e59577d28(b, living) : null;
    const servicesTotal = b ? b.costs.totalAnnual : 0;
    const pensionStory = (()=>{
        if (!b) return null;
        const data = (0, $ffc52726733f6151$export$5092ed2c4c8fd32)({
            assessableAssets: b.assessableAssets,
            assessableIncome: b.assessableIncome,
            currentPension: b.pension,
            isCouple: isCouple,
            isHomeowner: (0, $d1b9bbc5238c0548$export$2f999b99c41ee933)(factFind),
            illnessSeparatedForPension: (0, $ffc52726733f6151$export$cf0463a6434d3bec)(factFind, b.financials, undefined, false)
        });
        const full = Math.abs(data.pensionFromAssetTest - data.pensionFromIncomeTest) < 1;
        /*
         * On the full Age Pension the contribution rates are the full pensioner ones, the lowest there are (owner,
         * 24 Oct 2026: "wouldn't the lowest contribution rate already be reached, and as such step 3 will not
         * necessarily be able to optimise their situation further"). So neither can be improved; what a plan can
         * still change is the money each year and what is left to the family.
         */ if (full && b.pension > 0) return {
            lead: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    v.Names,
                    " ",
                    v.are,
                    " on the full Age Pension",
                    linkedStory ? `, with ${linkedStory.enteringName} in care` : '',
                    "."
                ]
            }),
            body: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "Neither means test reduces it, and ",
                    v.their,
                    " contribution rates are already the lowest they can be: ",
                    $d07c83ba5dd1bfce$var$pct(b.rates?.independence ?? 0),
                    " and ",
                    $d07c83ba5dd1bfce$var$pct(b.rates?.everydayLiving ?? 0),
                    ", the full pensioner rates."
                ]
            }),
            after: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "As a result, no plan can raise ",
                    v.their,
                    " pension or lower what ",
                    v.they,
                    " pay for each service. What the next step can still change is the money each year and what is left to the family",
                    (0, $d1b9bbc5238c0548$export$2f999b99c41ee933)(factFind) ? " \u2014 for example drawing an income from the home \u2014" : ',',
                    " and it may find that keeping things as they are is best."
                ]
            })
        };
        // Short paragraphs, full width (owner, 20 Oct 2026: one long block in a narrow column "looks crammed").
        if (data.isAssetTestLimiting) return {
            lead: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "For ",
                    v.names,
                    " it is the assets test, not the income test, that sets ",
                    v.couple ? v.their : v.possessive,
                    " Age Pension."
                ]
            }),
            body: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "Centrelink counts ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: $d07c83ba5dd1bfce$var$money(b.assessableAssets)
                    }),
                    " of ",
                    v.couple ? v.their : v.possessive,
                    " assets, and the assets test pays less than the income test would, so it is the one that applies: ",
                    $d07c83ba5dd1bfce$var$money(b.pension),
                    " a year. Each $1,000 less that is counted adds about ",
                    $d07c83ba5dd1bfce$var$money((0, $1abe73eeef086faf$export$6ca758cf677ce6c5)),
                    " a year to the pension, until the income test takes over."
                ]
            }),
            after: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "The same assessment sets ",
                    v.their,
                    " contribution rates. So the ways most likely to help are the ones that lower what is counted \u2014 spending on the home, a funeral bond, part of a lifetime income. Ways that only lower ",
                    v.their,
                    " income would do little here. That is what the next step tests first."
                ]
            })
        };
        return {
            lead: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "For ",
                    v.names,
                    " it is the income test, not the assets test, that sets ",
                    v.couple ? v.their : v.possessive,
                    " Age Pension."
                ]
            }),
            body: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "Centrelink counts ",
                    $d07c83ba5dd1bfce$var$money(b.assessableIncome),
                    " a year of income, including what ",
                    v.their,
                    " savings are deemed to earn, and the income test pays less than the assets test would: ",
                    $d07c83ba5dd1bfce$var$money(b.pension),
                    " a year."
                ]
            }),
            after: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "The same assessment sets ",
                    v.their,
                    " contribution rates. So the ways most likely to help are the ones that lower assessed income \u2014 for example a lifetime income, which is counted at less than its payments. Moving money into the home helps only through the income it would have been deemed to earn. That is what the next step tests first."
                ]
            })
        };
    })();
    const runway = b ? (0, $0fe89e03b6df746e$export$464558962ff4a811)(b.projections, years) : null;
    /* HOW LONG THE MONEY LASTS, in aged care's shape (owner, 20 Oct 2026: "a different UI to how it's been
       done in the aged care module, including the ability to see the year by year projections"): the
       runway bar, which account carries the gap and when, the horizon note, and the year-by-year figures. */ const sequence = (0, $acw62.useMemo)(()=>b ? (0, $f15268380bf00a12$export$e2001a5314704be0)(b.projections || [], household, runway, linkedCare ? {
            todayWord: 'after the aged care plan'
        } : {}) : [], [
        b,
        household,
        runway,
        linkedCare
    ]);
    const [projectionsOpen, setProjectionsOpen] = (0, $acw62.useState)(false);
    const hasGap = !!b && b.projections.some((r)=>Number(r.cashFlow) < 0);
    const caps = b ? [
        'client',
        'partner'
    ].filter((k)=>k === 'client' || isCouple).map((k)=>({
            name: String((k === 'client' ? factFind?.client?.firstName : factFind?.partner?.firstName) || (k === 'client' ? 'You' : 'Partner')),
            annual: b.perPerson[k]
        })).filter((p)=>p.annual > 0).map((p)=>({
            ...p,
            years: (0, $c424aab2467b2598$export$c5fbc76332b2670f).standard / p.annual
        })) : [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-6",
        "data-testid": "sah-step2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-[22px] font-bold leading-tight tracking-tight text-brand-navy",
                        children: "With this support and nothing else changed"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1 text-[14px] text-slate-600",
                        children: [
                            (0, $1a5a24a0286ded56$export$c9c6ca79dc334e31).sentence,
                            " Every plan on the next step is measured against these four numbers, which the cards call \u201C",
                            (0, $1a5a24a0286ded56$export$c9c6ca79dc334e31).word,
                            "\u201D."
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "rounded-xl border border-slate-200 border-l-4 border-l-rose-500 bg-white px-4 py-3 text-[14px] text-slate-700",
                role: "alert",
                children: error
            }),
            !b && !error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "rounded-xl border border-slate-200 bg-white px-4 py-6 text-[14px] text-slate-600",
                children: "Working out the four numbers\u2026"
            }),
            b && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: loading ? 'opacity-60 transition-opacity' : '',
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac9505651d2e4510$export$2e2bcd8739ae039), {
                        large: true,
                        caption: null,
                        careDaily: 0,
                        careAnnual: 0,
                        enteringName: v.names,
                        costCell: {
                            label: `${v.Their} contribution`,
                            value: b.contribution,
                            unit: 'a year',
                            note: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    servicesTotal > 0 ? `of ${$d07c83ba5dd1bfce$var$money(servicesTotal)} of services` : 'no services chosen yet',
                                    " \xb7 ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d07c83ba5dd1bfce$var$Why, {
                                        onClick: ()=>setPage('contribution')
                                    })
                                ]
                            })
                        },
                        pensionLabel: "Age Pension",
                        pensionNoteText: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                v.couple ? `a year, the two of ${v.them}` : 'a year',
                                " \xb7 ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d07c83ba5dd1bfce$var$Why, {
                                    onClick: ()=>setPage('pension')
                                })
                            ]
                        }),
                        pension: b.pension,
                        cashflowAfterCare: b.cashflow,
                        cashflowNotes: {
                            short: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "money in, less money out and ",
                                    v.their,
                                    " contribution \xb7 ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d07c83ba5dd1bfce$var$Why, {
                                        onClick: ()=>setPage('cashflow')
                                    })
                                ]
                            }),
                            over: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "money in, less money out and ",
                                    v.their,
                                    " contribution \xb7 ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d07c83ba5dd1bfce$var$Why, {
                                        onClick: ()=>setPage('cashflow')
                                    })
                                ]
                            })
                        },
                        legacy: b.legacy,
                        horizonYears: years,
                        onWhyYears: ()=>setYearsOpen(true)
                    }),
                    onYearsChange && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-2 text-[13px] text-slate-600",
                        "data-testid": "sah-step2-years",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9873a6fbc9fd360$export$68741d4d7bc37a6d), {
                            years: years,
                            onChange: onYearsChange,
                            before: "Planned over",
                            after: " \u2014 change it here; every plan on the next step is tested over the same span.",
                            ariaLabel: "Years to plan over"
                        })
                    })
                ]
            }),
            b && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-6 rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
                children: [
                    linkedCare && linkedStory && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d07c83ba5dd1bfce$var$Section, {
                        title: `With ${linkedStory.enteringName} moving into aged care`,
                        testId: "sah-step2-linked",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a109d47f19f08f50$export$c58a16d65aeb138a), {
                            linkedCare: linkedCare,
                            refundNote: false
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d07c83ba5dd1bfce$var$Section, {
                        title: `${v.Their} contribution for each hour`,
                        testId: "sah-step2-rates",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 overflow-hidden rounded-xl border border-slate-200 sm:grid-cols-3 sm:divide-x sm:divide-slate-200",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "px-4 py-3.5",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-[13px] text-slate-500",
                                                children: "Nursing and personal care"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-0.5 text-[22px] font-bold text-brand-navy",
                                                children: "Free"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-0.5 text-[12.5px] text-slate-500",
                                                children: "paid by the government, within each person's budget"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "px-4 py-3.5",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-[13px] text-slate-500",
                                                children: "Getting out and about"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-0.5 text-[22px] font-bold tabular-nums text-brand-navy",
                                                children: $d07c83ba5dd1bfce$var$pct(b.rates?.independence ?? 0)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-0.5 text-[12.5px] text-slate-500",
                                                children: "social support, transport"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "px-4 py-3.5",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-[13px] text-slate-500",
                                                children: "Help around the house"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-0.5 text-[22px] font-bold tabular-nums text-brand-navy",
                                                children: $d07c83ba5dd1bfce$var$pct(b.rates?.everydayLiving ?? 0)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-0.5 text-[12.5px] text-slate-500",
                                                children: "cleaning, meals"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-2 text-[13px] text-slate-500",
                                children: [
                                    "Set by Services Australia's means assessment. Have ",
                                    v.their,
                                    " letter, with rates that differ from these? ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d07c83ba5dd1bfce$var$Why, {
                                        onClick: onEnterLetterRates,
                                        children: "Enter the rates from the letter"
                                    })
                                ]
                            })
                        ]
                    }),
                    pensionStory && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d07c83ba5dd1bfce$var$Section, {
                        title: `Why ${v.their} contribution is what it is`,
                        testId: "sah-step2-why",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-[15px] leading-relaxed text-slate-700",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: pensionStory.lead
                                    }),
                                    " ",
                                    pensionStory.body
                                ]
                            }),
                            'after' in pensionStory && pensionStory.after && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-2 text-[15px] leading-relaxed text-slate-700",
                                children: pensionStory.after
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d07c83ba5dd1bfce$var$Section, {
                        title: "How long the money lasts",
                        testId: "sah-step2-runway",
                        children: [
                            runway ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c05f3bca3803eec$export$7fbbcd423808f3d5), {
                                headline: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-[18px] font-bold leading-tight tracking-tight text-slate-900",
                                    children: runway.headline
                                }),
                                coveredPct: runway.coveredPct,
                                leftLabel: runway.leftLabel,
                                rightLabel: runway.rightLabel,
                                depleted: runway.depleted
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[15px] text-slate-700",
                                children: b.cashflow < 0 ? `Short by ${$d07c83ba5dd1bfce$var$money(b.cashflow)} a year.` : `${$d07c83ba5dd1bfce$var$money(b.cashflow)} a year to spare.`
                            }),
                            hasGap && sequence.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ol", {
                                className: "mt-4 grid grid-cols-[7.5rem_minmax(0,1fr)] gap-x-3 gap-y-2",
                                "data-testid": "sah-step2-sequence",
                                children: sequence.map((e, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                className: "list-none",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "inline-flex w-full justify-center rounded-md bg-slate-100 px-2 py-1 text-[12px] font-bold uppercase tracking-wide text-slate-600",
                                                    children: e.from
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                className: "list-none pt-0.5 text-[14px] leading-relaxed text-slate-600",
                                                children: e.text
                                            })
                                        ]
                                    }, i))
                            }),
                            runway && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f15268380bf00a12$export$35d5d608b1d0d7ec), {
                                runway: runway,
                                className: "mt-3"
                            }),
                            linkedStory && linkedStory.deposit >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-3 text-[14px] leading-relaxed text-slate-600",
                                "data-testid": "sah-step2-rad-refund",
                                children: (0, $a109d47f19f08f50$export$73c5c6d74b068b0e)(linkedStory.enteringName)
                            }),
                            caps.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-3 text-[14px] leading-relaxed text-slate-600",
                                children: caps.map((c, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                        children: [
                                            i > 0 ? ' ' : '',
                                            c.name,
                                            "'s contributions would reach the ",
                                            $d07c83ba5dd1bfce$var$money((0, $c424aab2467b2598$export$c5fbc76332b2670f).standard),
                                            " lifetime limit ",
                                            c.years > 40 ? 'only after more than 40 years' : `in about ${Math.round(c.years)} ${Math.round(c.years) === 1 ? 'year' : 'years'}`,
                                            " at this rate."
                                        ]
                                    }, c.name))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>setProjectionsOpen(true),
                                className: "mt-3 inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-[13px] font-semibold text-blue-700 hover:border-blue-300 hover:bg-blue-50",
                                "data-testid": "sah-step2-year-by-year",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                        size: 15
                                    }),
                                    " See the projections, year by year"
                                ]
                            }),
                            showSeparated && separated.figures?.rates && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-3 rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] text-slate-700",
                                "data-testid": "sah-step2-separated",
                                children: [
                                    "If Centrelink assesses ",
                                    v.them,
                                    " as an illness-separated couple \u2014 for example when ",
                                    String((entering === 'partner' ? factFind?.partner?.firstName : factFind?.client?.firstName) || `one of ${v.them}`),
                                    " moves into care \u2014 ",
                                    v.their,
                                    " rates would be ",
                                    $d07c83ba5dd1bfce$var$pct(separated.figures.rates.independence),
                                    " and ",
                                    $d07c83ba5dd1bfce$var$pct(separated.figures.rates.everydayLiving),
                                    ".",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d07c83ba5dd1bfce$var$Why, {
                                        onClick: ()=>setSeparatedOpen(true),
                                        children: "What does that mean?"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onBack,
                        className: "text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy",
                        children: "\u2039 Change the services"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        type: "button",
                        variant: "brand",
                        size: "lg",
                        onClick: onNext,
                        "data-testid": "sah-step2-next",
                        children: [
                            "See ways to improve ",
                            v.their,
                            " position \u2192"
                        ]
                    })
                ]
            }),
            page && fig && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca9b5cdfbd99e645$export$e203066bca492ea1), {
                planTitle: "The support alone \u2014 the same services, nothing else changed",
                plan: fig,
                baseline: null,
                initialPage: page,
                possessive: v.their,
                they: v.they,
                them: v.them,
                pensionWhy: pensionStory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: pensionStory.lead
                }) : 'The Age Pension is worked out under both the assets test and the income test; the lower result is paid.',
                onClose: ()=>setPage(null)
            }),
            projectionsOpen && b && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2d788b4d6c2de130$export$2e2bcd8739ae039), {
                strategy: {
                    name: 'With these services, and nothing else changed',
                    projections: b.projections
                },
                factFind: household,
                onClose: ()=>setProjectionsOpen(false)
            }),
            yearsOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                titleId: "sah-years-heading",
                title: `Why about ${years} years?`,
                intro: "What is left to the family is projected over the years we plan for.",
                onClose: ()=>setYearsOpen(false),
                footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                    type: "button",
                    variant: "primary",
                    onClick: ()=>setYearsOpen(false),
                    children: "Got it"
                }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-[14px] leading-relaxed text-slate-700",
                    children: [
                        "We plan Support at home over ",
                        years,
                        " years: long enough for a plan's cost to show against what it saves, and the same span as the other living options. Change it under the four numbers; every plan is then tested over the new span."
                    ]
                })
            }),
            separatedOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                titleId: "sah-separated-heading",
                title: "An illness-separated couple",
                intro: "How Centrelink treats a couple when one of them cannot live at home.",
                onClose: ()=>setSeparatedOpen(false),
                footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                    type: "button",
                    variant: "primary",
                    onClick: ()=>setSeparatedOpen(false),
                    children: "Got it"
                }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-[14px] leading-relaxed text-slate-700",
                    children: [
                        "When one of a couple moves into care, Centrelink usually treats them as illness-separated: each is paid the single rate of Age Pension, assessed against the couple's limits. The same assessment sets the Support at home contribution rates, so they change too. If ",
                        String((entering === 'partner' ? factFind?.partner?.firstName : factFind?.client?.firstName) || 'one of them'),
                        ' is moving, answer "Yes" to the question on step 1 and every figure is priced that way.'
                    ]
                })
            })
        ]
    });
};
var $d07c83ba5dd1bfce$export$2e2bcd8739ae039 = $d07c83ba5dd1bfce$var$SahStep2;







function $b8484c25c6d1bce9$var$readSessionSaved() {
    try {
        const raw = typeof window !== 'undefined' ? window.sessionStorage.getItem((0, $f58ff7d3c4c676c4$export$685490c2fa387b9a)) : null;
        const list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list : [];
    } catch  {
        return [];
    }
}
/**
 * THE ONE ORDER this module is walked in. Tabs, Previous/Next and every label read from it.
 *
 * NEED BEFORE MONEY — the Service Builder comes before Optimise (owner direction, 2026-08-27).
 * Both orders "work", because the two are only weakly coupled and asymmetrically so: optimising
 * moves assets and income, which sets the contribution RATES, and those come from the means
 * assessment rather than from which services are chosen. The Service Builder sets the BUDGET those
 * rates apply to. Out-of-pocket is budget x rate.
 *
 * So optimising first never gave wrong ADVICE — whichever strategy wins on the illustrative package
 * still wins on the real one. It gave provisional DOLLARS at the moment a client is most
 * impressionable, and nobody re-checks "your share falls to $3,929 a year" after building their
 * services. It is also the right advice order: what care someone needs is a clinical question, not
 * a financial one.
 *
 * ONE ARRAY, because there were two. The tabs listed the order and the bottom Next/Back buttons
 * carried their own hardcoded copy of it, so reordering the tabs left the button still reading
 * "Next: Optimise Your Plan" on the Contributions screen while it navigated to the builder
 * (owner-caught immediately, 2026-08-27). A second source of the same sequence will always drift;
 * deriving prev/next by index cannot.
 */ const $b8484c25c6d1bce9$var$SECTION_FLOW = [
    {
        id: 'overview',
        label: 'Program Overview',
        icon: (0, $e1cfd183b457f6f1$export$2e2bcd8739ae039)
    },
    {
        id: 'contributions',
        label: 'Your Contributions',
        icon: (0, $27f56d6cfb7d79f8$export$2e2bcd8739ae039)
    },
    {
        id: 'builder',
        label: 'Service Builder',
        icon: (0, $4b66c39b6083b2b9$export$2e2bcd8739ae039),
        ownsFooterNav: true
    },
    {
        id: 'strategies',
        label: 'Optimise Your Plan',
        icon: (0, $e57d6b071418ede9$export$2e2bcd8739ae039)
    }
];
/** True when the section on screen supplies its own footer navigation. */ const $b8484c25c6d1bce9$var$sectionOwnsFooterNav = (id)=>$b8484c25c6d1bce9$var$SECTION_FLOW.some((s)=>s.id === id && s.ownsFooterNav === true);
/** The section before/after `id` in SECTION_FLOW, or null at either end. */ const $b8484c25c6d1bce9$var$stepFrom = (id, delta)=>{
    const at = $b8484c25c6d1bce9$var$SECTION_FLOW.findIndex((s)=>s.id === id);
    return $b8484c25c6d1bce9$var$SECTION_FLOW[at + delta] ?? null;
};
function $b8484c25c6d1bce9$export$34bfc538b5771cc7(prev) {
    // An unreadable session never deletes what is on file.
    let session;
    try {
        session = JSON.parse(sessionStorage.getItem((0, $f58ff7d3c4c676c4$export$685490c2fa387b9a)) || '[]');
    } catch  {
        return [
            ...prev || []
        ];
    }
    if (!Array.isArray(session)) return [
        ...prev || []
    ];
    const homeCare = session.filter((s)=>s && s.type === 'home_care');
    return [
        ...(prev || []).filter((s)=>s?.type !== 'home_care'),
        ...homeCare
    ];
}
const $b8484c25c6d1bce9$var$SupportAtHomePage = ({ setActivePage: setActivePage, factFind: factFind, setFactFind: setFactFind, onSoaGenerated: onSoaGenerated, setSavedStrategies: setSavedStrategies })=>{
    (0, $acw62.useEffect)(()=>{
        if (!setSavedStrategies) return undefined;
        const sync = ()=>setSavedStrategies((prev)=>$b8484c25c6d1bce9$export$34bfc538b5771cc7(prev));
        window.addEventListener((0, $f58ff7d3c4c676c4$export$f2d0abffc7f79a5c), sync);
        return ()=>{
            window.removeEventListener((0, $f58ff7d3c4c676c4$export$f2d0abffc7f79a5c), sync);
            sync();
        };
    }, [
        setSavedStrategies
    ]);
    /*
     * WHEN SUPPORT SERVICES START, owned here because two sections need it: the Service Builder ASKS
     * (it is a property of the service plan) and Optimise READS (it is the date the Suggestion Engine
     * projects every candidate from). One input, one value — asking twice is how two screens come to
     * disagree about the same fact.
     */ // Kept on the profile (goals.sahSupportStartDate) — it had been page state, lost on every reload.
    const supportStartDate = String(factFind?.goals?.sahSupportStartDate || '');
    const setSupportStartDate = (value)=>setFactFind((prev)=>({
                ...prev,
                goals: {
                    ...prev?.goals || {},
                    sahSupportStartDate: value
                }
            }));
    /*
     * THE CHOSEN PLAN, and the module opens on it (rebuild M2, 19 Oct 2026; aged care's hub rule of
     * 17 Oct): a family with a plan chosen lands on their plan, not on the guide.
     */ const [chosenPlan, setChosenPlan] = (0, $acw62.useState)(()=>(0, $b2a376f07fa94da4$export$6dd7380fe87e178c)());
    (0, $acw62.useEffect)(()=>{
        const refresh = ()=>setChosenPlan((0, $b2a376f07fa94da4$export$6dd7380fe87e178c)());
        window.addEventListener((0, $f58ff7d3c4c676c4$export$f2d0abffc7f79a5c), refresh);
        return ()=>window.removeEventListener((0, $f58ff7d3c4c676c4$export$f2d0abffc7f79a5c), refresh);
    }, []);
    /*
     * "START A NEW MODEL" FROM HOME (owner, 20 Oct 2026, as aged care's on 19 Oct): step 1 with no
     * services, support starting now, and the setup questions asked again on step 3. The chosen plan
     * keeps its own priced services, so it is untouched until another plan is chosen.
     */ const [startFresh] = (0, $acw62.useState)(()=>{
        try {
            return typeof window !== 'undefined' && !!sessionStorage.getItem((0, $b2a376f07fa94da4$export$23aa2da4fbf35540));
        } catch  {
            return false;
        }
    });
    const [currentSection, setCurrentSection] = (0, $acw62.useState)(()=>startFresh ? 'builder' : (0, $b2a376f07fa94da4$export$6dd7380fe87e178c)() ? 'hub' : 'builder');
    const [visitedStep2, setVisitedStep2] = (0, $acw62.useState)(false);
    /*
     * THE SERVICE PLAN, owned here for steps 1–3 (rebuild M3). The session's current plan (mirrored to
     * the profile) is the working copy, as before; every change is also written to the profile's
     * `servicePlan` with its category split, so the edit is saved by the autosave and the contribution
     * assessment prices the real categories rather than its 40/35/25 assumption.
     */ const [sahPlan, setSahPlan] = (0, $acw62.useState)(()=>{
        const p = (0, $08809b7a4fc47e27$export$d30ccc0e9b37d265)().plan;
        return {
            client: p?.client || {},
            partner: p?.partner || {}
        };
    });
    const changeSahPlan = (next)=>{
        setSahPlan(next);
        (0, $08809b7a4fc47e27$export$1016adb776409d6)(next);
        (0, $08809b7a4fc47e27$export$e7fb1dd0076c542d)();
        setFactFind((prev)=>({
                ...prev,
                servicePlan: {
                    services: next,
                    serviceDistribution: (0, $ef2004df8b6bc275$export$9adf410dad564b4)(next),
                    editedAt: new Date().toISOString()
                }
            }));
    };
    (0, $acw62.useEffect)(()=>{
        if (!startFresh) return;
        try {
            sessionStorage.removeItem((0, $b2a376f07fa94da4$export$23aa2da4fbf35540));
        } catch  {}
        changeSahPlan({
            client: {},
            partner: {}
        });
        setFactFind((prev)=>({
                ...prev,
                goals: {
                    ...prev?.goals || {},
                    sahSupportStartDate: '',
                    sahSetupSeen: false
                }
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const sahYears = Number(factFind?.goals?.sahLegacyYears) || 10;
    /** The saved plans the steps read (the chosen aged care plan for "Is X moving?"). */ const [sessionSaved, setSessionSaved] = (0, $acw62.useState)(()=>$b8484c25c6d1bce9$var$readSessionSaved());
    (0, $acw62.useEffect)(()=>{
        const refresh = ()=>setSessionSaved($b8484c25c6d1bce9$var$readSessionSaved());
        window.addEventListener((0, $f58ff7d3c4c676c4$export$f2d0abffc7f79a5c), refresh);
        return ()=>window.removeEventListener((0, $f58ff7d3c4c676c4$export$f2d0abffc7f79a5c), refresh);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (currentSection === 'hub' && !chosenPlan) setCurrentSection('overview');
    }, [
        currentSection,
        chosenPlan
    ]);
    // The tested plans ARE the Optimise step (owner, 19 Oct 2026, as in aged care on 17 Oct): there
    // is no mode chooser, and Manual Control is reached by "Build a plan yourself".
    const [strategyMode, setStrategyMode] = (0, $acw62.useState)('suggestion');
    /* Reopening a saved plan remounts Optimise, which reads the plan to restore as it mounts (review,
       18 Oct 2026: "Reopen" reloaded the whole browser page to get the same effect). */ const [strategiesMountKey, setStrategiesMountKey] = (0, $acw62.useState)(0);
    // Clear any leftover restore strategy on mount if not explicitly reopening
    (0, $acw62.useEffect)(()=>{
        // Check if we're explicitly reopening a strategy from Dashboard
        const reopenStrategy = typeof window !== 'undefined' ? sessionStorage.getItem('careCompanionReopenHomeCareStrategy') : null;
        if (!reopenStrategy) // No explicit reopen - clear any leftover restore strategy to prevent restoring unsaved strategies
        {
            if (typeof window !== 'undefined') {
                const leftover = sessionStorage.getItem('careCompanionRestoreHomeCareStrategy');
                if (leftover) try {
                    const strategy = JSON.parse(leftover);
                    // Only clear if it's not a saved strategy (no id means it's leftover unsaved state)
                    if (!strategy.id) sessionStorage.removeItem('careCompanionRestoreHomeCareStrategy');
                } catch  {
                    // Clear corrupted data
                    sessionStorage.removeItem('careCompanionRestoreHomeCareStrategy');
                }
            }
        }
    }, []);
    // Check for reopened home care strategy
    (0, $acw62.useEffect)(()=>{
        try {
            const stored = typeof window !== 'undefined' ? sessionStorage.getItem('careCompanionReopenHomeCareStrategy') : null;
            if (stored) {
                const strategy = JSON.parse(stored);
                // Clear the stored strategy so it doesn't reopen again
                sessionStorage.removeItem('careCompanionReopenHomeCareStrategy');
                // Check if this is a service plan (has inputs.services) or a strategy from Optimise Your Plan
                // Service plans have inputs.services, strategies have inputs.gifting/funeralBonds
                // Priority: Check for service plan first (more specific), then strategy
                const hasServicePlan = strategy.inputs?.services !== undefined && strategy.inputs?.services !== null && Object.keys(strategy.inputs.services || {}).length > 0;
                const hasStrategyInputs = strategy.inputs?.gifting !== undefined && strategy.inputs?.gifting !== null || strategy.inputs?.funeralBonds !== undefined && strategy.inputs?.funeralBonds !== null;
                if (hasServicePlan && !hasStrategyInputs) {
                    // Navigate to Service Builder section to restore the service plan
                    setCurrentSection('builder');
                    // Store it for ServiceBuilderSection to restore
                    sessionStorage.setItem('careCompanionRestoreServicePlan', JSON.stringify(strategy));
                } else if (hasStrategyInputs) {
                    // Navigate to strategies section to restore strategy state
                    setCurrentSection('strategies');
                    // Store it for StrategiesSection to access
                    sessionStorage.setItem('careCompanionRestoreHomeCareStrategy', JSON.stringify(strategy));
                } else {
                    // Default to strategies if unclear (most home_care items are strategies from Optimise Your Plan)
                    setCurrentSection('strategies');
                    sessionStorage.setItem('careCompanionRestoreHomeCareStrategy', JSON.stringify(strategy));
                }
            }
        } catch (error) {
            console.error('Error loading reopened home care strategy:', error);
        }
    }, []);
    // Scroll to top when section changes
    (0, $acw62.useEffect)(()=>{
        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
    }, [
        currentSection
    ]);
    // Check if this is a couple
    const isPartnered = factFind?.adviceFor === 'couple';
    // Get client's Support at Home level from ACAT assessment
    const getClientLevel = ()=>{
        const clientAcat = factFind?.careNeeds?.clientAcat;
        if (clientAcat?.status === 'yes' && clientAcat?.homeCareLevel) return (0, $c220d08b55e5dd64$export$bfae9591cc0d7897)[clientAcat.homeCareLevel] || null;
        return null;
    };
    // Get partner's Support at Home level from ACAT assessment
    const getPartnerLevel = ()=>{
        const partnerAcat = factFind?.careNeeds?.partnerAcat;
        if (partnerAcat?.status === 'yes' && partnerAcat?.homeCareLevel) return (0, $c220d08b55e5dd64$export$bfae9591cc0d7897)[partnerAcat.homeCareLevel] || null;
        return null;
    };
    const clientLevel = getClientLevel();
    const partnerLevel = getPartnerLevel();
    const [selectedLevel, setSelectedLevel] = (0, $acw62.useState)(clientLevel ? clientLevel.budget : null);
    const [selectedPartnerLevel, setSelectedPartnerLevel] = (0, $acw62.useState)(partnerLevel ? partnerLevel.budget : null);
    const [compareOpen, setCompareOpen] = (0, $acw62.useState)(false);
    /*
     * A GUESS IS NOT A CLASSIFICATION (owner-caught, 2026-08-28).
     *
     * This screen used to greet an unassessed client with "we couldn't find your classification —
     * please select your recommended level", and the moment they picked one it appeared under
     * "Your Support at Home Classification" beside a green tick, with a budget to the cent. Every
     * contribution figure downstream was then calculated from a number the client had guessed off a
     * dropdown, and `clientLevel || { budget: selectedLevel }` handed it to ContributionsSection in
     * the same slot as a real assessment — so nothing downstream could tell the two apart.
     *
     * The exploration itself is worth keeping: someone waiting on an assessment reasonably wants to
     * know what a level would cost. What had to go is calling it their classification. `exploring`
     * is that distinction, and it now travels with the figure to every tab that shows one.
     */ const clientExploring = !clientLevel && selectedLevel != null;
    const partnerExploring = !partnerLevel && selectedPartnerLevel != null;
    const exploring = clientExploring || partnerExploring;
    const clientName = factFind?.client?.firstName || 'You';
    const clientVerb = factFind?.client?.firstName ? "hasn\u2019t" : "haven\u2019t";
    const formatCurrency = (value)=>{
        return new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(value || 0);
    };
    /*
     * THE OPTIMISE SECTION IS THE ONLY TWO-PANE ONE, and it needs the benchmark's width to lay its
     * panes out the way Aged Care does: 1520px, giving a ~587px working pane and a ~391px plan
     * summary at the owner's 100% zoom (a ~1330px viewport). Capping it at 1152px squeezed both.
     *
     * The other sections stay at 1152px on purpose — they are single columns of reading, and prose
     * set 1520px wide is harder to read, not easier.
     */ /** The plan page's links, each into the step that does it. */ const openFromHub = (link)=>{
        const card = chosenPlan?.inputs?.card;
        if (link === 'services') {
            setCurrentSection('builder');
            return;
        }
        // "A new model from scratch" on the plan page (owner, 22 Oct 2026): Home's start-fresh, from here —
        // step 1 with no services, support starting now, the setup questions asked again. The chosen plan
        // keeps its own priced services, so it stays chosen until another is.
        if (link === 'fresh') {
            changeSahPlan({
                client: {},
                partner: {}
            });
            setFactFind((prev)=>({
                    ...prev,
                    goals: {
                        ...prev?.goals || {},
                        sahSupportStartDate: '',
                        sahSetupSeen: false
                    }
                }));
            setCurrentSection('builder');
            return;
        }
        if (link === 'guide') {
            setCurrentSection('overview');
            return;
        }
        if (link === 'assumptions') {
            setActivePage('AssumptionsPage');
            return;
        }
        if (link === 'plans') {
            setStrategyMode('suggestion');
            setStrategiesMountKey((k)=>k + 1);
            setCurrentSection('strategies');
            return;
        }
        if (link === 'document' && chosenPlan?.soaSnapshot) {
            (0, $39348679b8be0d72$export$d13a73f2d338923d)(chosenPlan.soaSnapshot);
            return;
        }
        // A plan built by hand is reopened with its own levers; a tested one is reached through the plans.
        const manual = card?.origin === 'manual';
        // "Build a plan yourself": a blank plan on the same services and household (25 Oct 2026).
        if (link === 'build-new') {
            (0, $b2a376f07fa94da4$export$f1a0b038e6da6256)({
                kind: 'build-new'
            });
            setStrategyMode('manual');
            setStrategiesMountKey((k)=>k + 1);
            setCurrentSection('strategies');
            return;
        }
        if (link === 'build' && !manual) (0, $b2a376f07fa94da4$export$f1a0b038e6da6256)({
            kind: 'build',
            config: card?.engineConfig,
            name: String(chosenPlan?.name || '')
        });
        if (link === 'document') (0, $b2a376f07fa94da4$export$f1a0b038e6da6256)({
            kind: 'document'
        });
        if (link === 'yearByYear') (0, $b2a376f07fa94da4$export$f1a0b038e6da6256)({
            kind: 'yearByYear'
        });
        if (manual && chosenPlan) try {
            sessionStorage.setItem('careCompanionRestoreHomeCareStrategy', JSON.stringify(chosenPlan));
        } catch  {}
        setStrategyMode(manual || link === 'build' ? 'manual' : 'suggestion');
        setStrategiesMountKey((k)=>k + 1);
        setCurrentSection('strategies');
    };
    if (currentSection === 'hub' && chosenPlan) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33f3aa36b8f27766$export$2e2bcd8739ae039), {
        factFind: factFind,
        plan: chosenPlan,
        currentServicePlan: (0, $08809b7a4fc47e27$export$d30ccc0e9b37d265)().plan ?? null,
        supportStartDate: supportStartDate,
        savedStrategies: sessionSaved,
        onOpen: openFromHub,
        goHome: ()=>setActivePage('Dashboard')
    });
    /*
     * THE THREE STEPS (rebuild M3, 19 Oct 2026; review decision 1, option B — aged care's spine). The four
     * tabs (overview, contributions, service builder, optimise) are now: 1 the support and its cost,
     * 2 what it means for them, 3 ways to improve their position. The guide is a link from step 1; the
     * official letter's rates (the contributions screen's override, kept for compliance) a link from step 2.
     */ const stepOf = (s)=>s === 'builder' ? 1 : s === 'contributions' ? 2 : s === 'strategies' ? 3 : null;
    const step = stepOf(currentSection);
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const pricedPlan = (0, $5ea55f03cd2af1e4$export$fe04ad50cd2b5dad)(sahPlan, factFind);
    const pricedServiceCount = [
        'client',
        'partner'
    ].reduce((n, k)=>n + Object.values(pricedPlan[k] || {}).filter((d)=>d && Number(d.quantity) > 0).length, 0);
    const pricedCount = [
        'client',
        'partner'
    ].reduce((n, k)=>n + Object.values(sahPlan[k] || {}).filter((d)=>d && Number(d.quantity) > 0).length, 0);
    const pricedValue = [
        'client',
        'partner'
    ].reduce((t, k)=>t + (0, $5fb3dd4f28b6f196$export$f1798fc2c7adaf45)(sahPlan[k] || {}, {}, (0, $25e9acc02c907060$export$a3b71735b810a98c)).total, 0);
    const steps = [
        {
            n: 1,
            section: 'builder',
            title: 'The support and its cost',
            sub: pricedCount ? `${pricedCount} ${pricedCount === 1 ? 'service' : 'services'} \xb7 ${formatCurrency(pricedValue)} a year` : 'Who, when, which services',
            done: pricedCount > 0
        },
        {
            n: 2,
            section: 'contributions',
            title: `What it means for ${v.them}`,
            sub: 'Four numbers, and why',
            done: visitedStep2
        },
        {
            n: 3,
            section: 'strategies',
            title: `Ways to improve ${v.their} position`,
            sub: chosenPlan ? 'Plan chosen' : 'Plans we tested, or build your own',
            done: !!chosenPlan
        }
    ];
    const stepName = step ? steps[step - 1].title : currentSection === 'overview' ? 'The guide' : currentSection === 'letter' ? 'Rates from the letter' : '';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: currentSection === 'strategies' ? 'max-w-[1520px] mx-auto' : 'max-w-6xl mx-auto',
        "data-testid": "sah-steps",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] text-slate-500",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setActivePage('Dashboard'),
                        className: "underline decoration-dotted underline-offset-2 hover:text-slate-800",
                        children: "Home"
                    }),
                    " \u203A ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setCurrentSection(chosenPlan ? 'hub' : 'builder'),
                        className: "underline decoration-dotted underline-offset-2 hover:text-slate-800",
                        children: "Support at home"
                    }),
                    stepName ? ` \u{203A} ${stepName}` : ''
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                className: "mt-2 text-[32px] font-bold leading-tight tracking-tight text-brand-navy",
                children: [
                    "Support at home for ",
                    v.names
                ]
            }),
            step === 1 && !chosenPlan && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-1 max-w-[72ch] text-[15px] text-slate-600",
                children: [
                    "Three short steps: the support ",
                    v.they,
                    " need and what it costs, what that means for ",
                    v.them,
                    ", and the ways to improve ",
                    v.their,
                    " position."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                className: "mt-4 grid grid-cols-1 gap-2 md:grid-cols-3",
                "aria-label": "Steps",
                "data-testid": "sah-step-tiles",
                children: steps.map((s)=>{
                    const on = step === s.n;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>{
                            if (s.n === 2) setVisitedStep2(true);
                            setCurrentSection(s.section);
                        },
                        "aria-current": on ? 'step' : undefined,
                        className: `flex items-center gap-3 rounded-xl border bg-white px-4 py-3 text-left transition-colors ${on ? 'border-blue-600 ring-1 ring-blue-600' : s.done ? 'border-emerald-300 hover:border-emerald-500' : 'border-slate-200 hover:border-blue-300'}`,
                        "data-testid": `sah-step-tile-${s.n}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `grid h-7 w-7 shrink-0 place-items-center rounded-full text-[13px] font-bold ${on ? 'bg-blue-600 text-white' : s.done ? 'bg-emerald-500 text-white' : 'bg-slate-100 text-slate-600'}`,
                                children: !on && s.done ? "\u2713" : s.n
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "block text-[14px] font-semibold text-slate-900",
                                        children: s.title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "block truncate text-[12.5px] text-slate-500",
                                        children: s.sub
                                    })
                                ]
                            })
                        ]
                    }, s.n);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-6",
                children: [
                    currentSection === 'builder' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e77534e6102db193$export$2e2bcd8739ae039), {
                        factFind: factFind,
                        setFactFind: setFactFind,
                        plan: sahPlan,
                        onPlanChange: changeSahPlan,
                        supportStartDate: supportStartDate,
                        setSupportStartDate: setSupportStartDate,
                        years: sahYears,
                        savedStrategies: sessionSaved,
                        onReadGuide: ()=>setCurrentSection('overview'),
                        onNext: ()=>{
                            setVisitedStep2(true);
                            setCurrentSection('contributions');
                        },
                        onOpenCashflow: ()=>setActivePage('CashflowPensionPage')
                    }),
                    currentSection === 'contributions' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d07c83ba5dd1bfce$export$2e2bcd8739ae039), {
                        factFind: factFind,
                        servicePlan: sahPlan,
                        years: sahYears,
                        supportStartDate: supportStartDate,
                        savedStrategies: sessionSaved,
                        onBack: ()=>setCurrentSection('builder'),
                        onNext: ()=>{
                            setStrategyMode('suggestion');
                            setCurrentSection('strategies');
                        },
                        onEnterLetterRates: ()=>setCurrentSection('letter'),
                        onYearsChange: (y)=>setFactFind((prev)=>({
                                    ...prev,
                                    goals: {
                                        ...prev?.goals || {},
                                        sahLegacyYears: y
                                    }
                                }))
                    }),
                    currentSection === 'strategies' && pricedServiceCount === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
                        "data-testid": "sah-step3-needs-services",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-[19px] font-bold text-brand-navy",
                                children: "Choose the services first"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-1 max-w-[72ch] text-[14px] leading-relaxed text-slate-700",
                                children: [
                                    "Every plan is priced on the support ",
                                    v.names,
                                    " need",
                                    v.s,
                                    ": what it costs, and what ",
                                    v.they,
                                    " pay towards it. Add the services on step 1 and the ways to improve ",
                                    v.their,
                                    " position are tested on them."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                type: "button",
                                variant: "brand",
                                onClick: ()=>setCurrentSection('builder'),
                                className: "mt-4",
                                children: "Go to step 1 \u2014 the support and its cost"
                            })
                        ]
                    }),
                    currentSection === 'strategies' && pricedServiceCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6188f49626b9d12$export$2e2bcd8739ae039), {
                        stepped: true,
                        onReopen: ()=>{
                            setStrategyMode('manual');
                            setStrategiesMountKey((k)=>k + 1);
                        },
                        onSoaGenerated: onSoaGenerated,
                        factFind: factFind,
                        setFactFind: setFactFind,
                        onNext: ()=>setActivePage('Dashboard'),
                        onBack: ()=>setCurrentSection('contributions'),
                        strategyMode: strategyMode,
                        setStrategyMode: (mode)=>setStrategyMode(mode),
                        onNavigateToBuilder: ()=>setCurrentSection('builder'),
                        onNavigateToDashboard: ()=>setActivePage('Dashboard'),
                        supportStartDate: supportStartDate
                    }, strategiesMountKey),
                    currentSection === 'overview' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setCurrentSection('builder'),
                        className: "mb-4 text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                        children: "\u2039 Back to the support and its cost"
                    }),
                    currentSection === 'overview' && !clientLevel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-4 mb-8",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6bc32c6ef2e03125$export$2e2bcd8739ae039), {
                                tone: "caution",
                                heading: `${clientName} ${clientVerb} been assessed yet`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mb-3",
                                        children: [
                                            "Support at Home costs depend on the level you're assessed at, so until that happens we can't tell you what you'd pay.",
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "An assessment may also find that entry-level support (CHSP) meets your needs"
                                            }),
                                            " \u2014 that program has no income or assets test, so there's nothing for us to model.",
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setCompareOpen(true),
                                                className: "font-semibold text-blue-600 underline decoration-blue-600/40 underline-offset-2 hover:text-blue-700",
                                                children: "How do the two compare?"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $73bacbfa279634e3$export$2e2bcd8739ae039), {
                                        status: "no"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6bc32c6ef2e03125$export$2e2bcd8739ae039), {
                                tone: "neutral",
                                heading: "Want to see the numbers anyway? Try a level",
                                icon: (0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mb-3",
                                        children: [
                                            "Pick a level to explore what it ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                                children: "would"
                                            }),
                                            " cost. This is a what-if, not your classification \u2014 we'll label it that way everywhere it appears."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: selectedLevel || '',
                                        onChange: (e)=>setSelectedLevel(e.target.value ? parseFloat(e.target.value) : null),
                                        "aria-label": "Explore a Support at Home level",
                                        className: "w-full px-4 py-3 border border-slate-300 rounded-lg bg-white focus:ring-2 focus:ring-brand-blue focus:border-brand-blue",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Choose a level to explore\u2026"
                                            }),
                                            Object.entries((0, $c220d08b55e5dd64$export$bfae9591cc0d7897)).filter(([, value])=>!value.transitional).map(([key, value])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                                    value: value.budget,
                                                    children: [
                                                        value.label,
                                                        " - ",
                                                        formatCurrency(value.budget),
                                                        " per year"
                                                    ]
                                                }, key))
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02b552f3b0af8007$export$7753eabeacd6f0b2), {
                        open: compareOpen,
                        onClose: ()=>setCompareOpen(false)
                    }),
                    currentSection === 'overview' && (clientLevel || selectedLevel || partnerLevel || selectedPartnerLevel) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-4 mb-8",
                        children: [
                            (clientLevel || selectedLevel) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: `bg-white/60 backdrop-blur-xl rounded-2xl shadow-lg shadow-gray-200/50 p-6 border ${clientLevel ? 'border-white' : 'border-dashed border-slate-300'}`,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-start gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                            icon: clientLevel ? (0, $e3f86240925e7a9e$export$2e2bcd8739ae039) : (0, $c00fae44777e2393$export$2e2bcd8739ae039),
                                            tone: clientLevel ? 'brand' : 'slate',
                                            variant: "solid",
                                            size: "lg"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex flex-wrap items-center gap-2.5 mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                            className: "text-lg font-bold text-gray-800",
                                                            children: clientExploring ? `If ${isPartnered ? factFind?.client?.firstName || 'they' : 'you'} ${isPartnered ? 'were' : 'were'} assessed at this level` : `${isPartnered ? `${factFind?.client?.firstName || 'Client'}'s` : 'Your'} Support at Home Classification`
                                                        }),
                                                        clientExploring && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "rounded-full bg-amber-50 px-2.5 py-1 text-[11px] font-bold tracking-wide text-amber-800",
                                                            children: "EXPLORING \u2014 NOT ASSESSED"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex flex-wrap items-center gap-3 mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-3xl font-bold text-brand-navy ",
                                                            children: clientLevel?.label || `Support at Home - Level ${Object.entries((0, $c220d08b55e5dd64$export$bfae9591cc0d7897)).find(([_, v])=>v.budget === selectedLevel)?.[0]?.replace('sah_level_', '') || ''}`
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-2xl font-bold text-gray-900",
                                                            children: formatCurrency(clientLevel?.budget || selectedLevel)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-sm text-gray-600",
                                                            children: "per year"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-sm text-gray-600 mt-2",
                                                    children: clientExploring ? "The budget at this level. The real level could be higher or lower \u2014 only an assessment decides it." : 'This budget is paid quarterly and managed by Services Australia.'
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            isPartnered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: `bg-white/60 backdrop-blur-xl rounded-2xl shadow-lg shadow-gray-200/50 p-6 border ${partnerLevel ? 'border-white' : 'border-dashed border-slate-300'}`,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-start gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                            icon: partnerLevel ? (0, $e3f86240925e7a9e$export$2e2bcd8739ae039) : (0, $c00fae44777e2393$export$2e2bcd8739ae039),
                                            tone: partnerLevel ? 'brand' : 'slate',
                                            variant: "solid",
                                            size: "lg"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex flex-wrap items-center gap-2.5 mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                            className: "text-lg font-bold text-gray-800",
                                                            children: partnerExploring ? `If ${factFind?.partner?.firstName || 'they'} were assessed at this level` : partnerLevel ? `${factFind?.partner?.firstName || 'Partner'}'s Support at Home Classification` : `${factFind?.partner?.firstName || 'Your partner'} hasn\u{2019}t been assessed yet`
                                                        }),
                                                        partnerExploring && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "rounded-full bg-amber-50 px-2.5 py-1 text-[11px] font-bold tracking-wide text-amber-800",
                                                            children: "EXPLORING \u2014 NOT ASSESSED"
                                                        })
                                                    ]
                                                }),
                                                partnerLevel || selectedPartnerLevel ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex flex-wrap items-center gap-3 mb-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-3xl font-bold text-brand-navy ",
                                                                    children: partnerLevel?.label || `Support at Home - Level ${Object.entries((0, $c220d08b55e5dd64$export$bfae9591cc0d7897)).find(([_, v])=>v.budget === selectedPartnerLevel)?.[0]?.replace('sah_level_', '') || ''}`
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-2xl font-bold text-gray-900",
                                                                    children: formatCurrency(partnerLevel?.budget || selectedPartnerLevel)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-sm text-gray-600",
                                                                    children: "per year"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-sm text-gray-600 mt-2",
                                                            children: partnerExploring ? "The budget at this level. The real level could be higher or lower \u2014 only an assessment decides it." : 'This budget is paid quarterly and managed by Services Australia.'
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-sm text-amber-700 mb-2 flex items-center gap-1.5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                                                    size: 15,
                                                                    className: "flex-shrink-0"
                                                                }),
                                                                "You can explore what a level would cost:"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                            value: selectedPartnerLevel || '',
                                                            onChange: (e)=>setSelectedPartnerLevel(e.target.value ? parseFloat(e.target.value) : null),
                                                            "aria-label": `Explore a Support at Home level for ${factFind?.partner?.firstName || 'partner'}`,
                                                            className: "w-full px-4 py-3 border border-slate-300 rounded-lg bg-white focus:ring-2 focus:ring-brand-blue focus:border-brand-blue",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "",
                                                                    children: "Choose a level to explore\u2026"
                                                                }),
                                                                Object.entries((0, $c220d08b55e5dd64$export$bfae9591cc0d7897)).map(([key, value])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                                                        value: value.budget,
                                                                        children: [
                                                                            value.label,
                                                                            " - ",
                                                                            formatCurrency(value.budget),
                                                                            " per year"
                                                                        ]
                                                                    }, key))
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    currentSection === 'overview' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00292876521e52b4$export$2e2bcd8739ae039), {
                        selectedLevel: selectedLevel,
                        clientLevel: clientLevel,
                        onNext: ()=>setCurrentSection('builder'),
                        awaitingAssessment: !clientLevel && !partnerLevel,
                        onNavigate: setActivePage
                    }),
                    currentSection === 'letter' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>setCurrentSection('contributions'),
                                className: "mb-4 text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                children: [
                                    "\u2039 Back to what it means for ",
                                    v.them
                                ]
                            }),
                            exploring && currentSection === 'letter' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mb-4 inline-flex rounded-full border border-amber-300 bg-white px-3 py-1 text-[12px] font-bold text-amber-800",
                                "data-testid": "sah-letter-whatif",
                                children: "WHAT-IF \u2014 priced on a level being explored, not an assessment"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f5d3aca8a0d692e$export$2e2bcd8739ae039), {
                                factFind: factFind,
                                setFactFind: setFactFind,
                                clientLevel: clientLevel || {
                                    budget: selectedLevel
                                },
                                onNext: ()=>setCurrentSection('contributions'),
                                onBack: ()=>setCurrentSection('contributions')
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $b8484c25c6d1bce9$export$2e2bcd8739ae039 = $b8484c25c6d1bce9$var$SupportAtHomePage;






var $acw62 = parcelRequire("acw62");

/**
 * Step 1 — the village and its contract (village rebuild, 21 Oct 2026; the agreed mock-up's j1-step1 and,
 * for a client with no home, j3-step1: the SAME screen, with two lines that differ).
 *
 * Top to bottom: why people move and what this works out (it is a lifestyle decision that often costs
 * money, so we price the move rather than ask whether it beats staying put); what matters most to them;
 * still deciding or decided; the primer, shown once; the village's name and state; the contract in the
 * order a disclosure statement sets it out; and what they would get back after 3, 5 and 10 years, worked
 * out as they type. Every answer is kept on the file (goals.rv*), so a return never resets it.
 */ 

var $acw62 = parcelRequire("acw62");





/**
 * "What the village costs" — the contract as entered, on the dark tile every module's plan summary
 * carries. It is the CONTRACT, not a plan: it appears the moment the figures are typed and it does
 * not change with the funding chosen (owner, 24 Sep 2026).
 *
 * THE DEPARTURE FEE AS A LADDER. "Years in village" used to do two jobs: set how much departure fee
 * had accrued, and tell the projection to sell the unit in that year and carry on with the client
 * living nowhere. The default is now "for the rest of my life" — no exit inside the projection, the
 * contract carried in net worth as the accrued entitlement — and the question the field was really
 * there to answer is answered here instead: what would come back if the client left after 3, 5 or
 * 10 years. With a set number of years chosen, that year's figure is shown and the tile says the
 * projection sells the unit then.
 */ 
parcelRequire("acw62");


const $a5e43ea76f631c99$export$25dd93d8f5828b47 = [
    3,
    5,
    10
];
function $a5e43ea76f631c99$export$92ec836666aacd49(villageInputs, years) {
    const exit = (0, $d6349ba6b2bbee8e$export$b0d4cd6d518ae318)(villageInputs.entryFee || 0, years, villageInputs.growthRatePct || 0, villageInputs.capitalGainShareToResident ?? 0.5, {
        dmfPctPerYear: villageInputs.dmfPctPerYear || 0,
        dmfCapYears: villageInputs.dmfCapYears || 0,
        dmfBasis: 'entry'
    }, villageInputs.reinstatementCap || 0);
    return {
        dmf: exit.dmfAmount,
        netToResident: exit.netToResident
    };
}
const $a5e43ea76f631c99$var$Row = ({ label: label, value: value, tone: tone })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex justify-between gap-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-gray-300",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: `font-semibold tabular-nums ${tone === 'good' ? 'text-green-400' : ''}`,
                children: value
            })
        ]
    });
const $a5e43ea76f631c99$var$RvVillageCostsTile = ({ villageInputs: villageInputs, annualOngoing: annualOngoing, children: children })=>{
    const entryFee = villageInputs.entryFee || 0;
    const forLife = !(villageInputs.yearsResidency > 0);
    const chosenYears = Math.max(1, Math.floor(villageInputs.yearsResidency || 0));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-gray-800 text-white rounded-xl p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a5e43ea76f631c99$var$Row, {
                        label: "Entry payment",
                        value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(entryFee)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a5e43ea76f631c99$var$Row, {
                        label: "Annual ongoing fees",
                        value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(annualOngoing)
                    }),
                    entryFee > 0 && (forLife ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "pt-3 border-t border-gray-600",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[11px] font-semibold uppercase tracking-wider text-gray-400 mb-2",
                                children: "If you left the village"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "space-y-1.5",
                                children: $a5e43ea76f631c99$export$25dd93d8f5828b47.map((y)=>{
                                    const e = $a5e43ea76f631c99$export$92ec836666aacd49(villageInputs, y);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex justify-between gap-3 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "text-gray-300",
                                                children: [
                                                    "after ",
                                                    y,
                                                    " years"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "tabular-nums",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-gray-400",
                                                        children: [
                                                            "fee ",
                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(e.dmf),
                                                            " \xb7 "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "font-semibold text-green-400",
                                                        children: [
                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(e.netToResident),
                                                            " back"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, y);
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-xs text-gray-400 mt-2",
                                children: "Modelled as staying for life: no sale is assumed, and what the contract is worth is carried in the estate."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a5e43ea76f631c99$var$Row, {
                                label: `Departure fee after ${chosenYears} ${chosenYears === 1 ? 'year' : 'years'} (est.)`,
                                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($a5e43ea76f631c99$export$92ec836666aacd49(villageInputs, chosenYears).dmf)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a5e43ea76f631c99$var$Row, {
                                label: "You get back (est.)",
                                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($a5e43ea76f631c99$export$92ec836666aacd49(villageInputs, chosenYears).netToResident),
                                tone: "good"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-xs text-gray-400 pt-1",
                                children: [
                                    "The projection sells the unit in year ",
                                    chosenYears,
                                    " and stops the fees. Where you live after that is not modelled."
                                ]
                            })
                        ]
                    }))
                ]
            }),
            children
        ]
    });
};
var $a5e43ea76f631c99$export$2e2bcd8739ae039 = $a5e43ea76f631c99$var$RvVillageCostsTile;


/**
 * The village module's shared words: the "what's this?" on each contract term, and the reasons people
 * move. One copy, read by step 1 and the older analyser, so the two can't drift.
 */ const $47cb8579212c1476$export$84d09caf62a6e1fe = {
    entryFee: "The one-off ingoing contribution or purchase price when you move in. Often set out in the village's disclosure statement.",
    ongoingFees: "Weekly or monthly recurrent fees for maintenance, services and shared facilities. The disclosure statement usually shows how and when these can increase.",
    ongoingFrequency: "Whether your recurrent fees are quoted weekly or monthly.",
    dmfPctPerYear: "The departure fee \u2014 also called the deferred management fee (DMF) \u2014 is typically a percentage of your entry payment (or the resale value) per year you stay. Common contracts run 2\u20133% per year; take the exact figure from your disclosure statement, as it varies widely.",
    dmfCapYears: "How many years the departure fee keeps accruing before it stops. For example, 3% per year capped at 10 years means a maximum of 30%. Leave 0 if your contract has no cap (the fee then accrues for your whole stay).",
    yearsResidency: "Most people move in to stay, so we assume no sale: the fees keep going and the value of the contract stays in the estate. The table below shows what you would get back if you left after 3, 5 or 10 years. Choose a set number of years only if you expect to move out; the unit is then sold in that year and the fees stop.",
    growthRatePct: "Assumed annual growth in the unit's value, used to estimate the resale price. We start with a conservative 3% \u2014 adjust it for the village's location and history. Your contract sets how any gain is shared.",
    capitalGainShare: "Your share of any capital gain when you leave (e.g. 50% means you and the operator split the gain). Check the disclosure statement.",
    reinstatementCap: "Cost to return the unit to its original condition (less fair wear and tear) when you leave. Sometimes capped in the contract."
};
const $47cb8579212c1476$export$87f74daf31da9fd0 = [
    {
        id: 'company',
        label: 'Company'
    },
    {
        id: 'safe',
        label: 'Feeling safe'
    },
    {
        id: 'upkeep',
        label: 'Less upkeep'
    },
    {
        id: 'help',
        label: 'Help close by'
    },
    {
        id: 'family',
        label: 'Nearer family'
    },
    {
        id: 'other',
        label: 'Something else'
    }
];
const $47cb8579212c1476$export$1c14447c2c2991eb = (v)=>String(v ?? '').split(',').map((x)=>x.trim()).filter(Boolean);
function $47cb8579212c1476$export$6667cb96c719af84(ids, other) {
    const words = ids.map((id)=>id === 'other' ? String(other || '').trim() : $47cb8579212c1476$export$87f74daf31da9fd0.find((r)=>r.id === id)?.label.toLowerCase() || '').filter(Boolean);
    if (words.length === 0) return '';
    if (words.length === 1) return words[0];
    return `${words.slice(0, -1).join(', ')} and ${words[words.length - 1]}`;
}



const $f7c01c2620d70182$var$card = 'rounded-2xl border border-slate-200 bg-white p-6 shadow-card';
const $f7c01c2620d70182$var$label = 'text-[13px] text-slate-600';
const $f7c01c2620d70182$var$input = 'rounded-lg border border-slate-300 bg-white px-3 py-2 text-[15px] font-semibold text-slate-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-500';
const $f7c01c2620d70182$var$RvStep1 = ({ factFind: factFind, setFactFind: setFactFind, villageInputs: villageInputs, setVillageInputs: setVillageInputs, villageEntryDate: villageEntryDate, setVillageEntryDate: setVillageEntryDate, villageEntryDateInPast: villageEntryDateInPast, onNext: onNext, onReadGuide: onReadGuide })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const goals = factFind?.goals || {};
    const setGoal = (patch)=>setFactFind?.((prev)=>({
                ...prev,
                goals: {
                    ...prev?.goals || {},
                    ...patch
                }
            }));
    const hasHome = (parseFloat(String(factFind?.home?.value ?? '')) || 0) > 0;
    const why = (0, $47cb8579212c1476$export$1c14447c2c2991eb)(goals.rvWhyMove);
    const toggleWhy = (id)=>setGoal({
            rvWhyMove: (why.includes(id) ? why.filter((x)=>x !== id) : [
                ...why,
                id
            ]).join(',')
        });
    const decided = goals.rvDecided === 'decided';
    const state = String(goals.rvState || '');
    const villageName = String(goals.rvVillageName || '');
    const rules = state ? (0, $cb0d223b5401e577$export$432ee5f70f8b1031)(state) : null;
    const forLife = !(villageInputs.yearsResidency > 0);
    const homeowner = villageInputs.entryFee > (0, $1abe73eeef086faf$export$e2cf792e99a08354);
    // The primer is shown once, then folds to one line that opens it again.
    const primerSeen = goals.rvPrimerSeen === true;
    const [primerOpen, setPrimerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(!primerSeen);
    (0, $acw62.useEffect)(()=>{
        if (!primerSeen) setGoal({
            rvPrimerSeen: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const set = (key, value)=>setVillageInputs((prev)=>({
                ...prev,
                [key]: value
            }));
    const ladderYears = forLife ? [
        ...(0, $a5e43ea76f631c99$export$25dd93d8f5828b47)
    ] : [
        villageInputs.yearsResidency
    ];
    // The guide links: under the open primer, beside "Show" when it is folded (23 Oct 2026).
    const primerLinks = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onReadGuide,
                className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                children: "Read the full guide"
            }),
            " \xb7 ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onReadGuide,
                className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                children: "Is a village right for you? The checklist"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        "data-testid": "rv-step1",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: `${$f7c01c2620d70182$var$card} border-l-4 border-l-brand-navy`,
                "data-testid": "rv-why-move",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-[19px] font-bold text-brand-navy",
                        children: "Why move, and what this works out"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 text-[15px] leading-relaxed text-slate-700",
                        children: [
                            "People move into a village for the way they want to live: company, feeling safe, less upkeep, help close by, being nearer family.",
                            ' ',
                            hasHome ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: "It is usually a lifestyle decision, and it often costs money: the family home is usually worth more than the unit, and the move can stop the Age Pension."
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "For someone who rents, a village can also mean ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "no more rent increases and no more moving at a landlord's say"
                                    }),
                                    ". It is usually a lifestyle decision, and it can cost money."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 text-[15px] leading-relaxed text-slate-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                className: "text-slate-900",
                                children: [
                                    "So we don't ask whether moving beats ",
                                    hasHome ? 'staying put' : 'renting on',
                                    "."
                                ]
                            }),
                            " We work out ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                className: "text-slate-900",
                                children: [
                                    "what the move costs ",
                                    v.them
                                ]
                            }),
                            ", whether ",
                            v.they,
                            " can ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-slate-900",
                                children: "afford it comfortably"
                            }),
                            " every year, and the ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-slate-900",
                                children: "best way to use what's left"
                            }),
                            " once ",
                            v.they,
                            "'ve moved."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-4 text-[14px] font-semibold text-slate-800",
                        children: [
                            "What matters most to ",
                            v.names,
                            " about moving? ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "font-normal text-slate-500",
                                children: [
                                    "Shown on ",
                                    v.possessive,
                                    " plan page and in the advice document."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-2 flex flex-wrap gap-2",
                        role: "group",
                        "aria-label": "What matters most about moving",
                        children: (0, $47cb8579212c1476$export$87f74daf31da9fd0).map((r)=>{
                            const on = why.includes(r.id);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                "aria-pressed": on,
                                onClick: ()=>toggleWhy(r.id),
                                "data-testid": `rv-why-${r.id}`,
                                className: `rounded-lg border px-3 py-1.5 text-[14px] ${on ? 'border-blue-600 font-semibold text-brand-navy' : 'border-slate-300 text-slate-700 hover:border-blue-300'}`,
                                children: [
                                    on ? "\u2713 " : '',
                                    r.label,
                                    r.id === 'other' && !on ? "\u2026" : ''
                                ]
                            }, r.id);
                        })
                    }),
                    why.includes('other') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "text",
                        value: String(goals.rvWhyMoveOther || ''),
                        onChange: (e)=>setGoal({
                                rvWhyMoveOther: e.target.value.slice(0, 200)
                            }),
                        placeholder: "In a few words",
                        "aria-label": "Another reason for moving",
                        className: `${$f7c01c2620d70182$var$input} mt-2 w-full max-w-md font-normal`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-4 text-[14px] font-semibold text-slate-800",
                        children: [
                            "Where ",
                            v.are,
                            " ",
                            v.names,
                            " with the decision?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-1 space-y-1",
                        role: "radiogroup",
                        "aria-label": "Where you are with the decision",
                        children: [
                            [
                                'deciding',
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Still deciding."
                                        }),
                                        " Show what moving costs ",
                                        v.them,
                                        " against ",
                                        hasHome ? 'staying put' : 'renting on',
                                        "."
                                    ]
                                })
                            ],
                            [
                                'decided',
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                            children: [
                                                v.you ? "You've" : `${v.Names} ${v.have}`,
                                                " decided to move."
                                            ]
                                        }),
                                        " Show the best ways to do it. ",
                                        hasHome ? 'Staying put' : 'Renting on',
                                        " is still shown, for reference."
                                    ]
                                })
                            ]
                        ].map(([id, text])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "flex cursor-pointer items-start gap-2 py-1 text-[14px] text-slate-700",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "radio",
                                        name: "rv-decided",
                                        checked: id === 'decided' ? decided : !decided,
                                        onChange: ()=>setGoal({
                                                rvDecided: id
                                            }),
                                        className: "mt-1 accent-blue-600",
                                        "data-testid": `rv-decided-${id}`
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: text
                                    })
                                ]
                            }, id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: `${$f7c01c2620d70182$var$card} ${(0, $e1e942361049df06$export$10832a06bd6966f8)}`,
                "data-testid": "rv-primer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1e942361049df06$export$eb5dff254945ec0e), {
                        title: "Retirement villages, in a minute",
                        open: primerOpen,
                        onToggle: ()=>setPrimerOpen((o)=>!o),
                        aside: primerLinks,
                        testId: "rv-primer-toggle"
                    }),
                    primerOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3 grid grid-cols-1 gap-x-7 gap-y-2 text-[14px] leading-relaxed text-slate-700 md:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: (0, $e1e942361049df06$export$60f4f4563d451e62),
                                        children: "You buy a contract, not a home."
                                    }),
                                    " You pay an entry payment to move in and ongoing fees while you live there."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: (0, $e1e942361049df06$export$60f4f4563d451e62),
                                        children: "When you leave, a departure fee comes out"
                                    }),
                                    " of what you get back, and it grows the longer you stay."
                                ]
                            }),
                            hasHome ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                className: (0, $e1e942361049df06$export$60f4f4563d451e62),
                                                children: [
                                                    "Above ",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$e2cf792e99a08354)),
                                                    ", Centrelink treats you as a homeowner"
                                                ]
                                            }),
                                            ", and the entry payment itself isn't counted."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                className: (0, $e1e942361049df06$export$60f4f4563d451e62),
                                                children: "Your old home stops being your home."
                                            }),
                                            " If you keep it, it counts for the Age Pension straight away: there is no two-year exemption for a village move (that applies to people moving into aged care). If you sell it, the money left after the entry payment counts instead."
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                className: (0, $e1e942361049df06$export$60f4f4563d451e62),
                                                children: [
                                                    "At ",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$e2cf792e99a08354)),
                                                    " or less, Centrelink treats you as not owning a home."
                                                ]
                                            }),
                                            " The entry payment counts as an asset, and Rent Assistance may be paid on the village fees."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                className: (0, $e1e942361049df06$export$60f4f4563d451e62),
                                                children: [
                                                    "Above ",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$e2cf792e99a08354)),
                                                    " you would be treated as a homeowner."
                                                ]
                                            }),
                                            " The entry payment isn't counted, but there is no Rent Assistance and a lower assets limit applies."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    primerOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-3 text-[13px] text-slate-500",
                        children: primerLinks
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: $f7c01c2620d70182$var$card,
                "data-testid": "rv-contract",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[12px] font-semibold text-brand-navy",
                        children: "The village"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-2 flex flex-wrap items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "text",
                                value: villageName,
                                onChange: (e)=>setGoal({
                                        rvVillageName: e.target.value.slice(0, 80)
                                    }),
                                placeholder: "The village's name",
                                "aria-label": "The village's name",
                                className: `${$f7c01c2620d70182$var$input} w-full max-w-sm`,
                                "data-testid": "rv-village-name"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-[13px] text-slate-500",
                                children: "Shown on the saved plan and the advice document."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3 flex flex-wrap items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                htmlFor: "rv-state",
                                className: `${$f7c01c2620d70182$var$label} w-40`,
                                children: "State"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                id: "rv-state",
                                value: state,
                                onChange: (e)=>setGoal({
                                        rvState: e.target.value
                                    }),
                                className: $f7c01c2620d70182$var$input,
                                "data-testid": "rv-state",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "Choose the state"
                                    }),
                                    (0, $cb0d223b5401e577$export$5c9ab6f574716f4e).map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: s.code,
                                            children: s.name
                                        }, s.code))
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-[13px] text-slate-500",
                                children: "Sets how long you wait for the refund and how long fees run after you leave."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-5 text-[12px] font-semibold text-brand-navy",
                        children: [
                            "The contract ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-normal text-slate-500",
                                children: "\u2014 from the disclosure statement"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-2 grid grid-cols-1 gap-x-7 gap-y-4 md:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: $f7c01c2620d70182$var$label,
                                        children: [
                                            "Entry payment ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                text: (0, $47cb8579212c1476$export$84d09caf62a6e1fe).entryFee
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                        value: villageInputs.entryFee ?? '',
                                        onChange: (x)=>set('entryFee', x ?? 0),
                                        className: "mt-1 w-40",
                                        ariaLabel: "Entry payment",
                                        id: "rv-entry-fee"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: $f7c01c2620d70182$var$label,
                                        children: [
                                            "Ongoing fees ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                text: (0, $47cb8579212c1476$export$84d09caf62a6e1fe).ongoingFees
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-1 flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                value: villageInputs.ongoingWeeklyOrMonthly ?? '',
                                                onChange: (x)=>set('ongoingWeeklyOrMonthly', x ?? 0),
                                                className: "w-32",
                                                ariaLabel: "Ongoing fees"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: villageInputs.ongoingFrequency,
                                                onChange: (e)=>set('ongoingFrequency', e.target.value),
                                                className: $f7c01c2620d70182$var$input,
                                                "aria-label": "How often the fees are charged",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "monthly",
                                                        children: "a month"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "weekly",
                                                        children: "a week"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: $f7c01c2620d70182$var$label,
                                        children: [
                                            "Departure fee ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                text: (0, $47cb8579212c1476$export$84d09caf62a6e1fe).dmfPctPerYear
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-1 flex flex-wrap items-center gap-2 text-[13px] text-slate-600",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "number",
                                                min: 0,
                                                step: 0.5,
                                                value: villageInputs.dmfPctPerYear,
                                                onChange: (e)=>set('dmfPctPerYear', parseFloat(e.target.value) || 0),
                                                className: `${$f7c01c2620d70182$var$input} w-20`,
                                                "aria-label": "Departure fee, percent a year"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "% a year, for up to"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "number",
                                                min: 0,
                                                value: villageInputs.dmfCapYears,
                                                onChange: (e)=>set('dmfCapYears', parseFloat(e.target.value) || 0),
                                                className: `${$f7c01c2620d70182$var$input} w-20`,
                                                "aria-label": "Departure fee cap, years"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "years"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: $f7c01c2620d70182$var$label,
                                        children: [
                                            v.Possessive,
                                            " share of any rise in the unit's value ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                text: (0, $47cb8579212c1476$export$84d09caf62a6e1fe).capitalGainShare
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-1 flex flex-wrap items-center gap-2 text-[13px] text-slate-600",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "number",
                                                min: 0,
                                                max: 100,
                                                value: Math.round((villageInputs.capitalGainShareToResident ?? 0) * 1000) / 10,
                                                onChange: (e)=>set('capitalGainShareToResident', Math.min(100, Math.max(0, parseFloat(e.target.value) || 0)) / 100),
                                                className: `${$f7c01c2620d70182$var$input} w-20`,
                                                "aria-label": "Share of any rise in value, percent"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "% with growth of"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "number",
                                                step: 0.5,
                                                value: villageInputs.growthRatePct,
                                                onChange: (e)=>set('growthRatePct', parseFloat(e.target.value) || 0),
                                                className: `${$f7c01c2620d70182$var$input} w-20`,
                                                "aria-label": "Unit value growth, percent a year"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "a year ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                        text: (0, $47cb8579212c1476$export$84d09caf62a6e1fe).growthRatePct
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: $f7c01c2620d70182$var$label,
                                        children: [
                                            "How long will ",
                                            v.names,
                                            " stay? ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                text: (0, $47cb8579212c1476$export$84d09caf62a6e1fe).yearsResidency
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-1 flex flex-wrap items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: forLife ? 'life' : 'years',
                                                onChange: (e)=>set('yearsResidency', e.target.value === 'life' ? 0 : Math.max(1, villageInputs.yearsResidency || 10)),
                                                className: $f7c01c2620d70182$var$input,
                                                "aria-label": "How long you will stay",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                                        value: "life",
                                                        children: [
                                                            "For the rest of ",
                                                            v.their,
                                                            " ",
                                                            v.couple ? 'lives' : 'life'
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "years",
                                                        children: "A set number of years"
                                                    })
                                                ]
                                            }),
                                            !forLife && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "number",
                                                min: 1,
                                                value: villageInputs.yearsResidency,
                                                onChange: (e)=>set('yearsResidency', Math.max(1, parseFloat(e.target.value) || 1)),
                                                className: `${$f7c01c2620d70182$var$input} w-20`,
                                                "aria-label": "Years before leaving"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        htmlFor: "rv-entry-date",
                                        className: $f7c01c2620d70182$var$label,
                                        children: [
                                            "When would ",
                                            v.names,
                                            " move in?"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        id: "rv-entry-date",
                                        type: "date",
                                        value: villageEntryDate,
                                        onChange: (e)=>setVillageEntryDate(e.target.value),
                                        className: `${$f7c01c2620d70182$var$input} mt-1 block font-normal`
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mt-1 text-[12px] text-slate-500",
                                        children: villageEntryDate ? villageEntryDateInPast ? 'A past date models as "moving in now".' : 'Life at home as it is until then, then the move.' : "Leave this blank to model the move from today \u2014 for anyone still exploring."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                        className: "mt-4 text-[13px] text-slate-600",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("summary", {
                                className: "cursor-pointer font-semibold text-brand-navy",
                                children: "More contract terms"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: $f7c01c2620d70182$var$label,
                                        children: [
                                            "Reinstatement cap ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                text: (0, $47cb8579212c1476$export$84d09caf62a6e1fe).reinstatementCap
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                        value: villageInputs.reinstatementCap ?? '',
                                        onChange: (x)=>set('reinstatementCap', x ?? 0),
                                        className: "mt-1 w-40",
                                        ariaLabel: "Reinstatement cap"
                                    })
                                ]
                            })
                        ]
                    }),
                    villageInputs.entryFee > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-5 text-[12px] font-semibold text-brand-navy",
                                children: [
                                    "What the contract means if ",
                                    v.they,
                                    " leave"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                className: "mt-1 w-full text-[14px]",
                                "data-testid": "rv-refund-ladder",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: ladderYears.map((y)=>{
                                        const e = (0, $a5e43ea76f631c99$export$92ec836666aacd49)(villageInputs, y);
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "border-b border-slate-100",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "py-2 text-slate-700",
                                                    children: [
                                                        "After ",
                                                        y,
                                                        " ",
                                                        y === 1 ? 'year' : 'years'
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "py-2 text-right tabular-nums text-slate-600",
                                                    children: [
                                                        "departure fee ",
                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(e.dmf))
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "py-2 text-right font-bold tabular-nums text-slate-900",
                                                    children: [
                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(e.netToResident)),
                                                        " back"
                                                    ]
                                                })
                                            ]
                                        }, y);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-2 text-[12.5px] text-slate-500",
                                children: [
                                    (villageInputs.capitalGainShareToResident ?? 0) > 0 ? `${v.Possessive} share of the unit's growth is included. ` : '',
                                    forLife ? 'Modelled as staying for life: the fees run on and the contract stays in the estate. ' : `The projection sells the unit in year ${villageInputs.yearsResidency}. `,
                                    rules ? `How long the refund takes depends on the contract; in ${(0, $cb0d223b5401e577$export$5c9ab6f574716f4e).find((s)=>s.code === state)?.name ?? state}, ${rules.buyback.summary.charAt(0).toLowerCase() + rules.buyback.summary.slice(1).replace(/\.$/, '')}.` : 'How long the refund takes depends on the state and the contract; choose the state above for its rule.'
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-1 text-[12.5px] text-slate-500",
                                children: [
                                    "At ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(villageInputs.entryFee),
                                    ", Centrelink treats ",
                                    v.them,
                                    " as ",
                                    homeowner ? 'homeowners: the entry payment itself is not counted' : 'not owning a home: the entry payment counts as an asset, and Rent Assistance may be paid on the fees',
                                    "."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-wrap items-center justify-end gap-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    type: "button",
                    onClick: onNext,
                    disabled: !(villageInputs.entryFee > 0),
                    "data-testid": "rv-step1-next",
                    className: "inline-flex h-11 items-center gap-2 rounded-lg bg-blue-600 hover:bg-blue-700 px-5 text-[14px] font-semibold text-white shadow-sm disabled:cursor-not-allowed disabled:opacity-50",
                    children: [
                        "See what this means for ",
                        v.them,
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                            size: 16
                        })
                    ]
                })
            })
        ]
    });
};
var $f7c01c2620d70182$export$2e2bcd8739ae039 = $f7c01c2620d70182$var$RvStep1;



/**
 * Which Suggestion Engine CARDS a module shows, and what each is badged as — one rule for every
 * module on the aged care spine (owner, 24 Sep 2026: "harmonisation of the UI/UX"; 2 Oct 2026:
 * the downsizer and granny flat listed every candidate, the village showed one card per goal).
 *
 * Lifted from the village page's `seCards` / `visibleSeCards`, unchanged in substance, so the
 * downsizer and granny flat analysers cannot grow their own version:
 *   - one card per goal leader, badged with the client-facing chip words;
 *   - a goal with no improver shows its best-of-field, badged "Best available …" and said to fall
 *     short of the baseline, so a client who has decided to move still sees the least costly route;
 *   - a selected strategy that leads nothing still gets a card ("Your selection"), or the click
 *     reads as ignored;
 *   - the chip filters by badge; "cashflow covered" that is the same plan as "Best estate" shows
 *     the one-line note instead of the same card twice.
 */ 


const $37a1f55bdc037774$export$7f338123a01e6e22 = [
    {
        id: 'legacy',
        label: (0, $400a08a42b233386$export$8a102fa4742ce4ac)
    },
    {
        id: 'covered',
        label: (0, $400a08a42b233386$export$8d25e363f6ae69ae)
    },
    {
        id: 'cashflow',
        label: 'Best cashflow'
    },
    {
        id: 'pension',
        label: 'Best Age Pension'
    }
];
function $37a1f55bdc037774$export$6fee30b7e476baa4(focus, baselineWord) {
    switch(focus){
        case 'covered':
            return `The best estate among the plans that still pay the bills \u{2014} or, where none does, whose shortfall the savings carry for the whole period. The card says which.`;
        case 'legacy':
            return `The strategy that leaves the most to the family after the projection period, against ${baselineWord}.`;
        case 'cashflow':
            return 'The strongest yearly cashflow from this run.';
        case 'pension':
            return 'The highest modelled Age Pension, where any strategy produces one.';
    }
}
/*
 * WORSE THAN STAYING PUT IS SAID — AS AWARENESS, NOT AS A MISTAKE (owner, 19 Oct 2026: "this is not a
 * shock and most of these decisions would be a lifestyle choice but … they need to be aware of this —
 * the positioning is not to make it sound like its a mistake"). The village review found the leading
 * card leaving $109,174 less than staying put under "Best available estate" with nothing saying so,
 * and every plan stopping the Age Pension with nothing saying that either.
 */ const $37a1f55bdc037774$var$GOAL_METRIC = {
    'Optimal Legacy': {
        friendly: 'estate',
        unit: 'in the estate',
        pick: (s)=>s.snapshot?.legacyValue ?? 0
    },
    'Optimal Cashflow': {
        friendly: 'cashflow',
        unit: 'a year in cashflow',
        pick: (s)=>s.snapshot?.netCashflow ?? 0
    },
    'Optimal Age Pension': {
        friendly: 'Age Pension',
        unit: 'a year in Age Pension',
        pick: (s)=>s.snapshot?.pension ?? 0
    }
};
function $37a1f55bdc037774$export$36bb4723017cc200(goalLabel, strategy, baseline, baselineWord, formatCurrency) {
    const m = $37a1f55bdc037774$var$GOAL_METRIC[goalLabel];
    if (!m || !baseline?.snapshot) return undefined;
    const gap = m.pick(baseline) - m.pick(strategy);
    if (!(gap >= 1)) return undefined;
    return `Leaves ${formatCurrency(gap)} less ${m.unit} than ${baselineWord} (${formatCurrency(m.pick(baseline))}). It is the closest of the options modelled on this goal, shown so the trade-off is clear when a move is wanted for other reasons.`;
}
function $37a1f55bdc037774$export$f93ff8d25d502159(movers, baseline, baselineWord, formatCurrency) {
    const base = baseline?.snapshot;
    if (!base || movers.length === 0) return null;
    const parts = [];
    const baseEstate = base.legacyValue ?? 0;
    if (movers.every((s)=>(s.snapshot?.legacyValue ?? 0) < baseEstate)) {
        const closest = Math.min(...movers.map((s)=>baseEstate - (s.snapshot?.legacyValue ?? 0)));
        parts.push(`Every option modelled leaves less in the estate than ${baselineWord}; the closest leaves ${formatCurrency(closest)} less.`);
    }
    const basePension = base.pension ?? 0;
    if (basePension > 0 && movers.every((s)=>(s.snapshot?.pension ?? 0) <= 0)) parts.push(`None of them keeps an Age Pension, which ${baselineWord} pays at ${formatCurrency(basePension)} a year.`);
    if (!parts.length) return null;
    return `${parts.join(' ')} A move like this is often made for the way of life rather than the money, so this is here to be weighed, not as a reason against it.`;
}
const $37a1f55bdc037774$var$keyOfRow = (s)=>String(s.id ?? s.name ?? '');
function $37a1f55bdc037774$export$fd1fff32319e093c(recommended, formatCurrency) {
    const row = (recommended || []).find((r)=>r.label === (0, $f8ee565b442c040e$export$40de0448f2611c56) && r.second);
    if (!row?.second) return null;
    return {
        key: $37a1f55bdc037774$var$keyOfRow(row.strategy),
        chip: (0, $5a094123650e8adb$export$8d9f0aa086032e89)(row.second),
        line: (0, $5a094123650e8adb$export$a104569a4d958475)(row.second, formatCurrency)
    };
}
function $37a1f55bdc037774$export$7e1712c96a3999b4(recommended, formatCurrency) {
    const row = (recommended || []).find((r)=>r.label === 'Optimal Legacy' && r.lead);
    if (!row?.lead) return null;
    return {
        key: $37a1f55bdc037774$var$keyOfRow(row.strategy),
        chip: (0, $5a094123650e8adb$export$a035dca5f387c63d)(row.lead),
        line: (0, $5a094123650e8adb$export$27f705a6fa40271e)(row.lead, formatCurrency)
    };
}
function $37a1f55bdc037774$export$c33ffdd7e2f8a65a(card, key, words, replaces) {
    if (!words || key !== words.key) return;
    card.badges = card.badges.map((b)=>b === replaces ? words.chip : b);
    if (!card.badges.includes(words.chip)) card.badges.unshift(words.chip);
    card.tradeOffNote = words.line;
}
const $37a1f55bdc037774$export$47bf00807fdc72f0 = (b)=>b === (0, $400a08a42b233386$export$8a102fa4742ce4ac) || b === 'Best available estate' || b === (0, $5a094123650e8adb$export$a1a7ae9e29edd48c) || /^(About the most|Leaves the most)/.test(b);
function $37a1f55bdc037774$export$1a43f8d6c205f841(input) {
    const { strategies: strategies, goalLeaders: goalLeaders, baseline: baseline, isBaseline: isBaseline, isSensitivity: isSensitivity = ()=>false, selectedId: selectedId, baselineWord: baselineWord, formatCurrency: formatCurrency, secondPlan: secondPlan = null, leadPlan: leadPlan = null } = input;
    const movers = strategies.filter((s)=>!isBaseline(s) && !isSensitivity(s));
    const out = [];
    const byId = new Map();
    const keyOf = (s)=>String(s.id ?? s.name ?? '');
    const push = (strategy, badges, belowBaseline)=>{
        const key = keyOf(strategy);
        const existing = byId.get(key);
        if (existing) {
            badges.forEach((b)=>{
                if (!existing.badges.includes(b)) existing.badges.push(b);
            });
            return;
        }
        const entry = {
            strategy: strategy,
            badges: [
                ...badges
            ],
            belowBaseline: belowBaseline
        };
        byId.set(key, entry);
        out.push(entry);
    };
    // A goal leader can still fall short of the baseline (it leads only the movers): say so on the card.
    goalLeaders.forEach((leader)=>{
        const labels = leader.recommendationLabels || [];
        const short = labels.map((l)=>$37a1f55bdc037774$export$36bb4723017cc200(l, leader, baseline, baselineWord, formatCurrency)).find(Boolean);
        push(leader, labels.map((l)=>(0, $400a08a42b233386$export$900f9fe722d67fa2)[l] || l), short);
        // The chip says what the card is, and the line why (planChoiceRule.ts): the second card's
        // trade-off, and the estate leader's when it is not the plan that leaves the most.
        const e = byId.get(keyOf(leader));
        if (e) {
            $37a1f55bdc037774$export$c33ffdd7e2f8a65a(e, keyOf(leader), secondPlan, (0, $5a094123650e8adb$export$a1a7ae9e29edd48c));
            $37a1f55bdc037774$export$c33ffdd7e2f8a65a(e, keyOf(leader), leadPlan, (0, $400a08a42b233386$export$8a102fa4742ce4ac));
        }
    });
    const base = baseline?.snapshot;
    const GOALS = [
        {
            label: 'Optimal Legacy',
            friendly: 'estate',
            pick: (s)=>s.snapshot?.legacyValue ?? 0,
            baseValue: base?.legacyValue ?? 0
        },
        {
            label: 'Optimal Cashflow',
            friendly: 'cashflow',
            pick: (s)=>s.snapshot?.netCashflow ?? 0,
            baseValue: base?.netCashflow ?? 0
        },
        {
            label: 'Optimal Age Pension',
            friendly: 'Age Pension',
            pick: (s)=>s.snapshot?.pension ?? 0,
            baseValue: base?.pension ?? 0
        }
    ];
    GOALS.forEach(({ label: label, friendly: friendly, pick: pick, baseValue: baseValue })=>{
        if (movers.length === 0) return;
        if (goalLeaders.some((l)=>(l.recommendationLabels || []).includes(label))) return;
        // Every option at nil pension is a finding, not a shortlist — the "what we modelled" note
        // says so, and a "best available $0" card would add nothing.
        if (label === 'Optimal Age Pension' && movers.every((s)=>(s.snapshot?.pension ?? 0) <= 0)) return;
        const best = movers.reduce((top, s)=>pick(s) > pick(top) ? s : top, movers[0]);
        push(best, [
            `Best available ${friendly}`
        ], $37a1f55bdc037774$export$36bb4723017cc200(label, best, baseline, baselineWord, formatCurrency) ?? `Does not beat ${baselineWord} (${formatCurrency(baseValue)}); the closest of the options modelled on this goal.`);
    });
    if (selectedId && !byId.has(String(selectedId))) {
        const chosen = movers.find((s)=>keyOf(s) === String(selectedId));
        if (chosen) push(chosen, [
            'Your selection'
        ]);
    }
    return out;
}
function $37a1f55bdc037774$export$16a0fc5a2fe6ecf6(cards, focus, coveredSameAsEstate) {
    // The same plan as Best estate is said in one line, not shown twice (owner, 24 Sep 2026).
    if (focus === 'covered' && coveredSameAsEstate) return [];
    const badgesFor = {
        covered: [
            (0, $400a08a42b233386$export$8d25e363f6ae69ae)
        ],
        legacy: [
            (0, $400a08a42b233386$export$8a102fa4742ce4ac),
            'Best available estate',
            (0, $5a094123650e8adb$export$a1a7ae9e29edd48c)
        ],
        cashflow: [
            'Best cashflow',
            'Best available cashflow'
        ],
        pension: [
            'Best Age Pension',
            'Best available Age Pension'
        ]
    };
    return cards.filter((c)=>c.badges.some((b)=>badgesFor[focus].includes(b) || focus === 'legacy' && $37a1f55bdc037774$export$47bf00807fdc72f0(b) || b === 'Your selection'));
}
function $37a1f55bdc037774$export$ec75f5ff06df55fe(focus, movers, baselineWord) {
    if (focus === 'pension' && movers.length > 0 && movers.every((s)=>(s.snapshot?.pension ?? 0) <= 0)) return "No option modelled produces any Age Pension \u2014 the assessable assets stay above the cut-off in every one, so there is no pension to improve. That is a finding, not a gap.";
    return `No option improved on ${baselineWord}, so nothing is recommended for this goal.`;
}




/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5473793717b51056$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m16 17 5-5-5-5",
            key: "1bji2h"
        }
    ],
    [
        "path",
        {
            d: "M21 12H9",
            key: "dn1m92"
        }
    ],
    [
        "path",
        {
            d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
            key: "1uf3rs"
        }
    ]
];
const $5473793717b51056$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("log-out", $5473793717b51056$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0811c1891b547863$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z",
            key: "7g6ntu"
        }
    ],
    [
        "path",
        {
            d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z",
            key: "ijws7r"
        }
    ],
    [
        "path",
        {
            d: "M7 21h10",
            key: "1b0cd5"
        }
    ],
    [
        "path",
        {
            d: "M12 3v18",
            key: "108xh3"
        }
    ],
    [
        "path",
        {
            d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2",
            key: "3gwbw2"
        }
    ]
];
const $0811c1891b547863$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("scale", $0811c1891b547863$export$3efd853dbb351e94);



/**
 * Retirement Village suggestion engine — generate & rank a curated set of funding/structuring strategies
 * for a chosen village (entry contribution + ongoing fees + exit terms are GIVEN; we optimise how to fund
 * and structure around them). Mirrors the Aged Care / Support at Home goal-leader pattern: each candidate is
 * evaluated with the same RV projection engine the manual path uses, then ranked into Best legacy / Best
 * cashflow / Best Age Pension via the shared `buildRecommendedOptimalStrategies`.
 *
 * A curated BASE set, then composable dimensions — the same shape as the aged care engine. The base
 * strategies are clearly-named, explainable answers to "how do we fund and structure this move" (only
 * those applicable to the client are generated: home present, investment property present, downsizer
 * age eligibility). Orthogonal decisions that combine with any of them — currently debt clearance —
 * are then PAIRED against every base move strategy rather than listed once, so "sell the home, start
 * a super pension AND clear the car loan" is a ranked candidate, not something the adviser has to
 * assemble by hand. The full universe and its exclusions are documented for actuarial review in
 * docs/actuarial-review/C_STRATEGIES.md — change one, change the other.
 */ 















/** A rounded dollar figure for a strategy NAME — "$1.5m", "$430k" — so a card says how big the
 *  commitment is without a nine-character number in its title. */ function $6d7411748a56fc80$var$formatRoughAmount(amount) {
    if (amount >= 1000000) return `$${(amount / 1000000).toFixed(amount >= 10000000 ? 0 : 1).replace(/\.0$/, '')}m`;
    if (amount >= 1000) return `$${Math.round(amount / 1000)}k`;
    return `$${Math.round(amount)}`;
}
const $6d7411748a56fc80$var$RV_RESIDUAL_ANSWERS = [
    'returned',
    'nil',
    'guaranteed',
    'both',
    'back',
    'all'
];
const $6d7411748a56fc80$export$cf7cc42462ce27c2 = 2;
function $6d7411748a56fc80$export$5acc911a5e5b7c18(factFind, setup) {
    const raw = Number(setup?.emergencyReserve);
    return setup?.emergencyReserve != null && Number.isFinite(raw) && raw >= 0 ? raw : (0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind);
}
function $6d7411748a56fc80$export$f18276a1042657ae(weeklyRent, vacancyWeeks) {
    const empty = Math.min(52, Math.max(0, Number.isFinite(Number(vacancyWeeks)) && vacancyWeeks != null ? Number(vacancyWeeks) : $6d7411748a56fc80$export$cf7cc42462ce27c2));
    return Math.round(weeklyRent * (52 - empty) / 52 * 100) / 100;
}
const $6d7411748a56fc80$export$2009e5318ded6ea0 = 25;
function $6d7411748a56fc80$export$c2a3d96da629285(setup) {
    const raw = Number(setup?.annuityShareCapPct);
    if (!Number.isFinite(raw) || setup?.annuityShareCapPct == null) return $6d7411748a56fc80$export$2009e5318ded6ea0;
    return Math.min(100, Math.max(0, raw));
}
function $6d7411748a56fc80$export$65f94a7151daf91a(factFind, fallbackState) {
    const goals = factFind?.goals || {};
    const saved = typeof goals.rvPurchaseState === 'string' && goals.rvPurchaseState.trim() !== '' ? goals.rvPurchaseState : null;
    // The willingness questions are the CLIENT's, shared with every other module (annuityPreference.ts).
    const preference = (0, $ff5de4128b46b139$export$636a9065c3f862c1)(factFind);
    return {
        purchaseState: saved ?? (fallbackState || goals.rvState || ''),
        annuityShareCapPct: goals.rvAnnuityShareCapPct != null && Number.isFinite(Number(goals.rvAnnuityShareCapPct)) ? Number(goals.rvAnnuityShareCapPct) : $6d7411748a56fc80$export$2009e5318ded6ea0,
        annuityAppetite: preference.appetite,
        annuityResidual: preference.residual,
        // ONE RULE FOR "COVERS THE COSTS" (owner, 23 Oct 2026): money in at least matches money out, as aged care has always used; no module asks for a margin.
        cashflowTarget: 0,
        oldUnitPaysAtMove: typeof goals.rvOldUnitPaysAtMove === 'boolean' ? goals.rvOldUnitPaysAtMove : true,
        homeRoute: goals.rvHomeRoute === 'keep' || goals.rvHomeRoute === 'sell' ? goals.rvHomeRoute : 'compare',
        rentPerWeek: Number.isFinite(Number(goals.rvRentPerWeek)) && goals.rvRentPerWeek != null ? Number(goals.rvRentPerWeek) : null,
        rentCosts: Number.isFinite(Number(goals.rvRentCosts)) && goals.rvRentCosts != null ? Number(goals.rvRentCosts) : null,
        vacancyWeeks: Number.isFinite(Number(goals.rvVacancyWeeks)) && goals.rvVacancyWeeks != null ? Number(goals.rvVacancyWeeks) : $6d7411748a56fc80$export$cf7cc42462ce27c2,
        emergencyReserve: Number.isFinite(Number(goals.rvEmergencyReserve)) && goals.rvEmergencyReserve != null ? Number(goals.rvEmergencyReserve) : null,
        residualUses: typeof goals.rvResidualUses === 'string' ? goals.rvResidualUses.split(',').map((x)=>x.trim()).filter((x)=>[
                'super',
                'invest',
                'property',
                'gift'
            ].includes(x)) : null
    };
}
function $6d7411748a56fc80$export$a8c959bf5420987a(factFind, villageInputs, setup = {}) {
    const entryFee = villageInputs?.entryFee || 0;
    /*
     * MOVING FROM ANOTHER VILLAGE (owner, 8 Oct 2026). Taken as paid at the move, the current unit's
     * payout funds the new contribution first: the funding test and the savings allocation below
     * are for the REST. Without this a $1,000,000 entry against $580,000 of savings produced no
     * candidate at all, though $520,000 was coming back from the old unit (owner-caught).
     */ const payoutAtMove = setup?.oldUnitPaysAtMove !== false && (0, $4633117ee929ec27$export$cb26bf32ff9b2b4d)(factFind) ? (0, $4633117ee929ec27$export$27943b3c73c6c12b)(factFind) : 0;
    const entryFromLiquid = Math.max(0, entryFee - payoutAtMove);
    /*
     * The plain-words annuity answers: "no" builds no annuity candidate at all; "yes" may narrow
     * the field to one residual version; "not sure" (the default) shows both at the cap.
     *
     * The SETUP's answer wins, and where it is silent the CLIENT RECORD is read — the same answer
     * every other module reads (annuityPreference.ts). Without that fallback a caller who did not
     * thread the setup through would have ignored a client who had said no (caught by
     * annuityPreference.test.ts, 25 Sep 2026).
     */ const saved = (0, $ff5de4128b46b139$export$636a9065c3f862c1)(factFind);
    const annuityAppetite = setup?.annuityAppetite === 'none' || setup?.annuityAppetite === 'yes' || setup?.annuityAppetite === 'unsure' ? setup.annuityAppetite : saved.appetite;
    const annuityCapPct = annuityAppetite === 'none' ? 0 : $6d7411748a56fc80$export$c2a3d96da629285(setup);
    const residualAnswer = setup?.annuityResidual && $6d7411748a56fc80$var$RV_RESIDUAL_ANSWERS.includes(setup.annuityResidual) ? setup.annuityResidual : saved.residual;
    /*
     * INCOME ONLY ONLY ON REQUEST (owner, 21 Oct 2026 — the guaranteed income review D1; annuityPreference.ts).
     * The answers read as one preference: "yes, if the money goes back" (the default, and "not sure") builds
     * money back, and the full amount back where the person may buy it (in or entering subsidised care);
     * "yes, the most income" adds income only. Before this, every client who didn't say no was shown
     * income-only plans.
     */ const preference = {
        appetite: annuityAppetite,
        residual: annuityAppetite !== 'yes' || residualAnswer === 'both' ? 'back' : residualAnswer,
        answered: true
    };
    const offerNil = (0, $ff5de4128b46b139$export$b8876d0a37b8526a)(preference, 0);
    const offerReturned = (0, $ff5de4128b46b139$export$b8876d0a37b8526a)(preference, 1);
    // The guaranteed shape is sold only to someone in, or entering, government-subsidised care.
    const offerGuaranteed = (0, $ff5de4128b46b139$export$623904c9366cf5a0)(preference, factFind);
    const purchaseState = (0, $30ff538d4b47bf21$export$96fdbeb3c760993a)(setup?.purchaseState) ? setup.purchaseState : undefined;
    /** The property a budget buys once its stamp duty is paid, with the rent struck on the PRICE. */ const propertyFor = (budget)=>{
        const bought = (0, $30ff538d4b47bf21$export$be7ef09ba9b335a2)(purchaseState, budget, 'investment');
        // The firm's yield, two weeks empty, the agent's 8% and 1% upkeep (investmentPropertyDefaults.ts).
        const f = (0, $6ee1c1106c00a64d$export$ad80a9624457bb5e)(bought.price);
        return {
            purchaseInvestmentProperty: bought.price,
            investmentPropertyStampDuty: bought.duty,
            investmentPropertyState: purchaseState,
            investmentPropertyRent: f.rent,
            investmentPropertyExpenses: f.expenses,
            investmentPropertyOwner: isCouple ? 'joint' : 'client'
        };
    };
    const dutyWords = (duty)=>purchaseState ? ` Stamp duty of ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(duty)} (${purchaseState}) comes out of the proceeds, so the property is sized to what is left.` : " Stamp duty is not modelled \u2014 no state was chosen for the purchase.";
    const hasHome = (factFind?.home?.value || 0) > 0;
    const homeValue = factFind?.home?.value || 0;
    const investmentProps = factFind?.assets?.investmentProperty || [];
    const hasIp = investmentProps.length > 0;
    const isCouple = factFind?.adviceFor === 'couple';
    const clientAge = factFind?.client?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client.dob) : null;
    const partnerAge = isCouple && factFind?.partner?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner.dob) : null;
    const downsizerEligible = clientAge != null && clientAge >= 55 || partnerAge != null && partnerAge >= 55;
    const candidates = [];
    // 0. Stay in the current home — the do-nothing baseline every move strategy is measured
    //    against (the same benchmark discipline as the aged care and Support at Home engines).
    //    Evaluated with the village zeroed out: no entry fee, no ongoing fees, no move.
    candidates.push({
        id: 'rv-stay-home',
        name: 'Stay in your current home',
        description: "No village move \u2014 life as it is today. This is the baseline every strategy below is measured against.",
        fundFrom: 'liquid',
        stayHome: true
    });
    // 1. Fund from savings (keep home as-is). Always available when savings can pay the whole contribution.
    //    EVERY WAY TO DRAW IT (decision 10, 21 Oct 2026): each distinct order of the accounts — and of a
    //    couple's pensions — is its own plan, and the projection decides (fundingMechanisms.buildFundingVariants).
    const reserve = $6d7411748a56fc80$export$5acc911a5e5b7c18(factFind, setup);
    const liquidVariants = (0, $70f4a8eac5c2154b$export$78a43ea1192852fa)(factFind, entryFromLiquid, reserve);
    const fundedByLiquid = (funding)=>Object.values(funding).reduce((sum, amount)=>sum + (amount || 0), 0);
    const canFundFromLiquid = liquidVariants.some((v)=>fundedByLiquid(v.funding) >= entryFromLiquid - 1);
    if (canFundFromLiquid) liquidVariants.forEach((v)=>{
        if (fundedByLiquid(v.funding) < entryFromLiquid - 1) return;
        candidates.push({
            id: `rv-liquid${v.key}`,
            name: `Fund from your savings${v.nameSuffix}`,
            description: `Pay the entry contribution from your savings${v.note ? ` (${v.note.replace(/\.$/, '').replace(/^Drawn/, 'drawn')})` : ''}, and keep your home as it is.`,
            fundFrom: 'liquid',
            entryFeeFundingOverride: v.funding
        });
    });
    if (hasHome) {
        // 2. Keep and rent the former home (income to cashflow; entry still funded from savings).
        //    Keeping the home means the entry contribution still has to come out of savings, so this
        //    is subject to the same all-or-nothing funding test as the plain savings candidates —
        //    this is the exact strategy that was topping the rankings on a $500k phantom.
        liquidVariants.forEach((v, i)=>{
            if (fundedByLiquid(v.funding) < entryFromLiquid - 1) return;
            candidates.push({
                // The usual draw keeps the plain id; each other way of drawing is a plan of its own (decision 10).
                id: i === 0 ? 'rv-liquid-rent' : `rv-liquid-rent${v.key}`,
                name: `Keep and rent your home${i === 0 ? '' : v.nameSuffix}`,
                description: 'Pay the entry contribution from your savings and rent out your former home for extra income.',
                fundFrom: 'liquid',
                // The same draw as the savings plans, so the money kept for emergencies is the client's
                // answer here too, and the card can name the accounts (village rebuild, 21 Oct 2026).
                entryFeeFundingOverride: v.funding,
                rentHome: true,
                rentDetails: {
                    rentAmount: $6d7411748a56fc80$export$f18276a1042657ae(setup?.rentPerWeek != null ? Number(setup.rentPerWeek) : Number(factFind?.home?.likelyRent) || 0, setup?.vacancyWeeks),
                    rentExpenses: setup?.rentCosts != null ? Number(setup.rentCosts) : Number(factFind?.home?.likelyExpenses) || 0,
                    partnerRent: 0
                }
            });
        });
        // 3. Sell the home to fund the move.
        const sellingCosts = Math.round(homeValue * 0.025);
        candidates.push({
            id: 'rv-sell-home',
            name: 'Sell your home',
            description: 'Sell the family home, use the proceeds for the entry contribution, and invest the rest.',
            fundFrom: 'sell_home',
            sellHomeDetails: {
                salePrice: homeValue,
                sellingCosts: sellingCosts,
                downsizerContribution: 0,
                partnerDownsizerContribution: 0,
                commenceIncomeStream: false,
                giftingAmount: 0,
                funeralBondPurchase: 0,
                purchaseAnnuity: 0,
                purchaseInvestmentProperty: 0,
                purchaseShares: 0
            }
        });
        const netAfterEntrySell = Math.max(0, homeValue - sellingCosts - entryFee);
        // 4. Sell the home, pay the entry fee, and invest the rest in shares / managed funds.
        if (netAfterEntrySell >= 50000) {
            candidates.push({
                id: 'rv-sell-home-invest',
                // Named for WHAT it buys. "Invest the rest" left an adviser asking "invest in what?",
                // which is the wrong question to be asking of a recommendation.
                name: 'Sell your home and invest in shares / managed funds',
                description: "Sell the home, pay the entry contribution, and put the freed-up money into a diversified share / managed-fund portfolio instead of the bank \u2014 aiming for higher long-term growth and income (still counted for the pension; returns aren't guaranteed).",
                fundFrom: 'sell_home',
                sellHomeDetails: {
                    salePrice: homeValue,
                    sellingCosts: sellingCosts,
                    downsizerContribution: 0,
                    partnerDownsizerContribution: 0,
                    commenceIncomeStream: false,
                    giftingAmount: 0,
                    funeralBondPurchase: 0,
                    purchaseAnnuity: 0,
                    purchaseInvestmentProperty: 0,
                    purchaseShares: netAfterEntrySell
                }
            });
            // 5. Sell the home, pay the entry fee, and buy an investment property for rental income.
            //    Yield and expense ratio from the published asset-class assumptions (a licensee's
            //    own figures where their firm has set them) — see investmentProfiles.ts. The stamp
            //    duty on the purchase comes out of the proceeds where a state was chosen (owner,
            //    24 Sep 2026); the property is what is left, and the rent is struck on that.
            const rvIp = propertyFor(netAfterEntrySell);
            candidates.push({
                id: 'rv-sell-home-property',
                name: 'Sell your home and buy an investment property',
                description: 'Sell the home, pay the entry contribution, and use the freed-up money to buy an investment property for rental income and potential growth. The property is an assessable asset and the net rent counts for the pension; it\'s less flexible than shares and has buying/selling costs.' + dutyWords(rvIp.investmentPropertyStampDuty),
                fundFrom: 'sell_home',
                sellHomeDetails: {
                    salePrice: homeValue,
                    sellingCosts: sellingCosts,
                    downsizerContribution: 0,
                    partnerDownsizerContribution: 0,
                    commenceIncomeStream: false,
                    giftingAmount: 0,
                    funeralBondPurchase: 0,
                    purchaseAnnuity: 0,
                    purchaseShares: 0,
                    ...rvIp
                }
            });
            // 6. Sell the home, pay the entry fee, and buy a lifetime annuity for guaranteed income —
            //    sized to the share of the freed-up money the setup allows (a quarter by default,
            //    changeable up to all of it), with the rest invested in shares / managed funds so
            //    it stays accessible. Committing every spare dollar to a lifetime annuity is a
            //    position few advisers would take, and modelled as the only size it kept winning
            //    the cashflow goal on the income alone (owner, 24 Sep 2026). Under $25,000 is too
            //    small to be worth modelling.
            /*
             * HOW MUCH (village review decision 11, 21 Oct 2026; annuitySizing.ts): up to the share the
             * client allows (a quarter by default), and — where it would lift the Age Pension — the amount
             * that lifts it most, as its own plan. Counted assets after the sale are estimated here only to
             * size that plan; the projection decides whether it actually does better.
             */ /*
             * One rule for every module (annuitySizes.ts, 21 Oct 2026): the client's own ceiling — a share or a
             * dollar amount, asked once — wins over the village's older share answer, and the amount that lifts
             * the Age Pension most is held to it too.
             */ const annuitySizes = annuityCapPct > 0 ? (0, $cb76d0656284f28b$export$4dc6c2d1b2b95e25)(factFind, {
                investable: netAfterEntrySell,
                capPct: annuityCapPct,
                homeowner: entryFee > (0, $1abe73eeef086faf$export$e2cf792e99a08354)
            }) : [];
            for (const size of annuitySizes){
                const annuityAmount = size.amount;
                const isPensionMax = size.pensionMax;
                const idTail = isPensionMax ? '-max' : '';
                const sharePct = size.sharePct;
                const annuityRest = Math.max(0, netAfterEntrySell - annuityAmount);
                const sizeWords = isPensionMax ? `${$6d7411748a56fc80$var$formatRoughAmount(annuityAmount)}, the amount that lifts the Age Pension most` : sharePct >= 100 ? `all ${$6d7411748a56fc80$var$formatRoughAmount(annuityAmount)}` : `${$6d7411748a56fc80$var$formatRoughAmount(annuityAmount)}, ${sharePct}% of what's freed up`;
                const restWords = annuityRest > 0 ? ' and invest the rest' : '';
                // Income only: built only when the client asked for the most income (annuityPreference.ts).
                if (offerNil) candidates.push({
                    id: `rv-sell-home-annuity${idTail}`,
                    name: `Sell your home, buy a lifetime annuity (${sizeWords})${restWords}`,
                    description: `Sell the home, pay the entry contribution, and convert ${sharePct >= 100 ? 'all' : `${sharePct}%`} of the freed-up money into a lifetime annuity \u{2014} guaranteed income for life, and only 60% of the purchase price counted in the assets test${annuityRest > 0 ? " \u2014 with the rest invested in shares / managed funds where it stays accessible" : ''}. Income only: the highest income, and nothing of the purchase price comes back to the family, even after an early death.`,
                    fundFrom: 'sell_home',
                    sellHomeDetails: {
                        salePrice: homeValue,
                        sellingCosts: sellingCosts,
                        downsizerContribution: 0,
                        partnerDownsizerContribution: 0,
                        commenceIncomeStream: false,
                        giftingAmount: 0,
                        funeralBondPurchase: 0,
                        purchaseInvestmentProperty: 0,
                        purchaseShares: annuityRest,
                        purchaseAnnuity: annuityAmount,
                        rvAnnuityType: 'lifetime',
                        rvAnnuityResidualPercent: 0
                    }
                });
                /*
                 * THE SAME ANNUITY WITH THE CAPITAL RETURNED — offering only the nil-residual version
                 * disqualified the strategy rather than weighing it.
                 *
                 * Centrelink assesses a lifetime annuity at 60% of its purchase price WHATEVER its
                 * residual capital value: RCV changes the payment rate, not the assets-test treatment.
                 * But net worth values an annuity at its RESIDUAL (assessment/netWorth.ts, deliberately —
                 * a nil-RCV annuity really does leave nothing behind), so the nil version lost the legacy
                 * ranking by its full purchase price on day one and could never win a comparison it was
                 * excluded from. Same fix as the Aged Care engine.
                 */ if (offerReturned) candidates.push({
                    id: `rv-sell-home-annuity-rcv${idTail}`,
                    name: `Sell your home, buy a lifetime annuity (${sizeWords}, capital returned)${restWords}`,
                    description: `The same annuity, but with the purchase price coming back to the estate on an early death \u{2014} in full within the first half of life expectancy, less after that \u{2014} rather than kept by the provider. It pays less income, and Centrelink still counts only 60% either way${annuityRest > 0 ? " \u2014 with the rest invested in shares / managed funds" : ''}.`,
                    fundFrom: 'sell_home',
                    sellHomeDetails: {
                        salePrice: homeValue,
                        sellingCosts: sellingCosts,
                        downsizerContribution: 0,
                        partnerDownsizerContribution: 0,
                        commenceIncomeStream: false,
                        giftingAmount: 0,
                        funeralBondPurchase: 0,
                        purchaseInvestmentProperty: 0,
                        purchaseShares: annuityRest,
                        purchaseAnnuity: annuityAmount,
                        rvAnnuityType: 'lifetime',
                        rvAnnuityResidualPercent: 100
                    }
                });
                if (offerGuaranteed) candidates.push({
                    id: `rv-sell-home-annuity-guaranteed${idTail}`,
                    name: `Sell your home, buy a lifetime annuity (${sizeWords}, full amount guaranteed)${restWords}`,
                    description: `A lifetime annuity and a life policy bought together, so the full purchase price comes back to the estate whenever death comes. It pays the least income of the three, and only the annuity half earns the 60% assets-test treatment; the policy is counted at what it cost${annuityRest > 0 ? " \u2014 with the rest invested in shares / managed funds" : ''}.`,
                    fundFrom: 'sell_home',
                    sellHomeDetails: {
                        salePrice: homeValue,
                        sellingCosts: sellingCosts,
                        downsizerContribution: 0,
                        partnerDownsizerContribution: 0,
                        commenceIncomeStream: false,
                        giftingAmount: 0,
                        funeralBondPurchase: 0,
                        purchaseInvestmentProperty: 0,
                        purchaseShares: annuityRest,
                        purchaseAnnuity: annuityAmount,
                        rvAnnuityType: 'guaranteed',
                        rvAnnuityResidualPercent: 100
                    }
                });
            }
        }
        // 7. Sell the home and top up super via the downsizer contribution (if age-eligible).
        if (downsizerEligible) {
            const netAfterEntry = Math.max(0, homeValue - sellingCosts - entryFee);
            // Age-aware: fills the member whose accumulation super is exempt from the means tests
            // (under Age Pension age) FIRST. Where neither or both are exempt this is the same even
            // split it always was — see allocateDownsizerContribution.
            const allocation = (0, $f1228be62b68f76b$export$6373eb0865b1a234)(factFind, netAfterEntry);
            const downsizer = allocation.client;
            const partnerDownsizer = allocation.partner;
            const preferredName = allocation.preferred === 'partner' ? factFind?.partner?.firstName || 'your partner' : allocation.preferred === 'client' ? factFind?.client?.firstName || 'you' : null;
            const preferenceNote = preferredName ? ` Weighted to ${preferredName}'s account first: while they are under Age Pension age, super held in their name is not counted in the assets or income tests.` : '';
            if (downsizer > 0) {
                candidates.push({
                    id: 'rv-sell-home-downsizer',
                    name: 'Sell your home and top up super',
                    description: `Sell the home, pay the entry contribution, then move freed-up money into super using the downsizer contribution (up to $300,000 each) \u{2014} often more tax-effective and pension-friendly.${preferenceNote}`,
                    fundFrom: 'sell_home',
                    sellHomeDetails: {
                        salePrice: homeValue,
                        sellingCosts: sellingCosts,
                        downsizerContribution: downsizer,
                        partnerDownsizerContribution: partnerDownsizer,
                        commenceIncomeStream: false,
                        giftingAmount: 0,
                        funeralBondPurchase: 0,
                        purchaseAnnuity: 0,
                        purchaseInvestmentProperty: 0,
                        purchaseShares: 0
                    }
                });
                // 7a. The same downsizer contribution, then STARTED as an account-based pension
                //     rather than left in accumulation. For a client already over preservation age
                //     this is usually the point of the exercise — earnings become tax free and the
                //     money is drawable — and it is a genuinely different projection, so it is
                //     ranked rather than assumed.
                candidates.push({
                    id: 'rv-sell-home-downsizer-abp',
                    name: 'Sell your home, top up super and start a pension from it',
                    description: "Sell the home, pay the entry contribution, move freed-up money into super using the downsizer contribution, then commence an account-based pension from it \u2014 investment earnings become tax free and the money is drawable as income, rather than sitting in accumulation phase.",
                    fundFrom: 'sell_home',
                    sellHomeDetails: {
                        salePrice: homeValue,
                        sellingCosts: sellingCosts,
                        downsizerContribution: downsizer,
                        partnerDownsizerContribution: partnerDownsizer,
                        commenceIncomeStream: true,
                        giftingAmount: 0,
                        funeralBondPurchase: 0,
                        purchaseAnnuity: 0,
                        purchaseInvestmentProperty: 0,
                        purchaseShares: 0
                    }
                });
                // 7b. Downsizer to the caps commenced as an ABP, and the remainder INVESTED in
                //     shares / managed funds rather than left in cash. Without this candidate the
                //     downsizer family is not comparable with "sell and invest": the plain
                //     downsizer strategies leave everything beyond the caps in a 2%-interest bank
                //     account, so they lose to a full share portfolio on asset allocation alone and
                //     the ranking says nothing about the super wrapper. This is the true
                //     apples-to-apples: the same portfolio, split between the pension wrapper and
                //     personal names — the tax treatment decides.
                const remainderAfterDownsizerAll = Math.max(0, netAfterEntry - downsizer - partnerDownsizer);
                if (remainderAfterDownsizerAll >= 50000) candidates.push({
                    id: 'rv-sell-home-downsizer-abp-invest',
                    name: 'Sell your home, start a super pension and invest the rest',
                    description: "Sell the home, pay the entry contribution, move what the downsizer caps allow into super and commence an account-based pension from it, and invest the remainder in shares / managed funds \u2014 the same growth portfolio as investing it all personally, but with part of it sheltered inside the pension's tax-free wrapper.",
                    fundFrom: 'sell_home',
                    sellHomeDetails: {
                        salePrice: homeValue,
                        sellingCosts: sellingCosts,
                        downsizerContribution: downsizer,
                        partnerDownsizerContribution: partnerDownsizer,
                        commenceIncomeStream: true,
                        giftingAmount: 0,
                        funeralBondPurchase: 0,
                        purchaseAnnuity: 0,
                        purchaseInvestmentProperty: 0,
                        purchaseShares: remainderAfterDownsizerAll
                    }
                });
                // 7b-ii. The same split, but the remainder buys an INVESTMENT PROPERTY rather than
                //     shares (owner-caught, 2026-08-26: "it never ran a scenario where it sold the
                //     home, put it in super, started a pension and then bought an investment
                //     property with an assumed rental return"). The field already paired the super
                //     pension with a share portfolio, and paired an investment property with a plain
                //     sale — but never the two together, which is a combination advisers genuinely
                //     recommend: the tax-free pension wrapper for what fits the caps, and a rental
                //     income stream for the rest. Rent and expenses use the same assumed yield the
                //     stand-alone investment-property candidate uses, so the two are comparable.
                if (remainderAfterDownsizerAll >= 50000) candidates.push({
                    id: 'rv-sell-home-downsizer-abp-ip',
                    name: 'Sell your home, start a super pension and buy an investment property',
                    description: "Sell the home, pay the entry contribution, move what the downsizer caps allow into super and commence an account-based pension from it, then buy an investment property with the remainder \u2014 a tax-free pension wrapper alongside rental income. The property is an assessable asset and its net rent counts for the pension, and it is far less flexible than shares if money is needed quickly.",
                    fundFrom: 'sell_home',
                    sellHomeDetails: {
                        salePrice: homeValue,
                        sellingCosts: sellingCosts,
                        downsizerContribution: downsizer,
                        partnerDownsizerContribution: partnerDownsizer,
                        commenceIncomeStream: true,
                        giftingAmount: 0,
                        funeralBondPurchase: 0,
                        purchaseAnnuity: 0,
                        ...propertyFor(remainderAfterDownsizerAll),
                        purchaseShares: 0
                    }
                });
                // 7c. Downsizer to the caps, and a lifetime annuity with what's left — the two
                //     pension-friendly conversions combined, when meaningful money remains beyond
                //     the super caps. The annuity is sized to the setup's share cap (of the whole
                //     amount freed, as for candidate 6) and the rest invested, so the combination
                //     is comparable with the stand-alone annuity rather than an all-in outlier.
                //     (7d below is the same with the downsizer commenced as an ABP.)
                const remainderAfterDownsizer = Math.max(0, netAfterEntry - downsizer - partnerDownsizer);
                // Held to the client's ceiling (a share or a dollar amount; annuityCeilingOf), of the whole amount freed.
                const downsizerAnnuity = annuityCapPct > 0 ? Math.min(remainderAfterDownsizer, (0, $ff5de4128b46b139$export$19a5715b59108050)((0, $ff5de4128b46b139$export$e46e91ebc7373b0a)(factFind, annuityCapPct), netAfterEntry)) : 0;
                /*
                 * WHICH TYPE (guaranteed income review, 21 Oct 2026). This pairing builds one guaranteed income, so it
                 * takes the client's suggested type: money back where allowed; income only only when that is all the
                 * client asked for; the full amount back where it is the only type left and the person may buy it.
                 * (It was income only for every client who didn't ask for money back.)
                 */ const downsizerAnnuityShape = offerReturned ? {
                    rvAnnuityType: 'lifetime',
                    rvAnnuityResidualPercent: 100
                } : offerNil ? {
                    rvAnnuityType: 'lifetime',
                    rvAnnuityResidualPercent: 0
                } : offerGuaranteed ? {
                    rvAnnuityType: 'guaranteed',
                    rvAnnuityResidualPercent: 100
                } : null;
                if (downsizerAnnuityShape && remainderAfterDownsizer >= 50000 && downsizerAnnuity >= 25000) {
                    const downsizerAnnuityRest = Math.max(0, remainderAfterDownsizer - downsizerAnnuity);
                    candidates.push({
                        id: 'rv-sell-home-downsizer-annuity',
                        name: 'Sell your home, top up super and buy an annuity',
                        description: `Sell the home, pay the entry contribution, move what the downsizer caps allow into super, and put ${$6d7411748a56fc80$var$formatRoughAmount(downsizerAnnuity)} of the remainder into a lifetime annuity \u{2014} combining the super tax shelter with guaranteed income and the annuity's 60% assets-test discount${downsizerAnnuityRest > 0 ? ', the rest invested in shares / managed funds' : ''}.`,
                        fundFrom: 'sell_home',
                        sellHomeDetails: {
                            salePrice: homeValue,
                            sellingCosts: sellingCosts,
                            downsizerContribution: downsizer,
                            partnerDownsizerContribution: partnerDownsizer,
                            commenceIncomeStream: false,
                            giftingAmount: 0,
                            funeralBondPurchase: 0,
                            purchaseAnnuity: downsizerAnnuity,
                            ...downsizerAnnuityShape,
                            purchaseInvestmentProperty: 0,
                            purchaseShares: downsizerAnnuityRest
                        }
                    });
                    // 7d. The same combination with the downsizer money STARTED as an account-based
                    //     pension — a guaranteed income floor from the annuity plus a tax-free,
                    //     drawable pension beside it. This is the shape many real adviser
                    //     recommendations take, so it is ranked rather than left for the adviser to
                    //     assemble by hand.
                    candidates.push({
                        id: 'rv-sell-home-downsizer-abp-annuity',
                        name: 'Sell your home, start a super pension and buy an annuity',
                        description: `Sell the home, pay the entry contribution, move what the downsizer caps allow into super and commence an account-based pension from it, and put ${$6d7411748a56fc80$var$formatRoughAmount(downsizerAnnuity)} of the remainder into a lifetime annuity \u{2014} guaranteed income for life with its 60% assets-test discount, plus tax-free investment earnings and drawable income from the pension${downsizerAnnuityRest > 0 ? ', the rest invested in shares / managed funds' : ''}.`,
                        fundFrom: 'sell_home',
                        sellHomeDetails: {
                            salePrice: homeValue,
                            sellingCosts: sellingCosts,
                            downsizerContribution: downsizer,
                            partnerDownsizerContribution: partnerDownsizer,
                            commenceIncomeStream: true,
                            giftingAmount: 0,
                            funeralBondPurchase: 0,
                            purchaseAnnuity: downsizerAnnuity,
                            ...downsizerAnnuityShape,
                            purchaseInvestmentProperty: 0,
                            purchaseShares: downsizerAnnuityRest
                        }
                    });
                }
            }
        }
    }
    // 8. Sell an investment property to fund the move (if one exists).
    if (hasIp) {
        const ip = investmentProps[0];
        candidates.push({
            id: 'rv-sell-ip',
            name: 'Sell an investment property',
            description: 'Sell an investment property and use the net proceeds (after selling costs and CGT) for the entry contribution.',
            fundFrom: 'investment_property',
            investmentPropertyDetails: {
                selectedPropertyId: ip?.id ?? null,
                entryFeeAllocation: entryFee,
                downsizerContribution: 0,
                partnerDownsizerContribution: 0,
                commenceIncomeStream: false,
                giftingAmount: 0,
                funeralBondPurchase: 0
            }
        });
    }
    /*
     * 8b. THE TWO MEANS-TEST LEVERS THE ENGINE HARD-CODED TO ZERO.
     *
     * Every candidate above sets `giftingAmount: 0` and `funeralBondPurchase: 0`. Both are
     * first-class Manual Control inputs and both act on the problem this module actually creates: a
     * village entry above the extra allowable amount makes the resident a HOMEOWNER, and whatever is
     * left of the sale proceeds is counted in full. A funeral bond takes part of that back outside
     * the assets test; a gift within the free area takes it out altogether.
     *
     * Offered only on the sell-home paths, because they are the ones that produce a residual to
     * allocate. A liquid-funded entry has already spent the savings on the contribution.
     *
     * Gifting stays INSIDE the yearly free area. Above it the excess is still counted, and still
     * deemed to earn income, for five years under the deprivation rules — which this module now
     * models correctly, and which is a real cost the engine cannot weigh against a family's own
     * reasons for a larger gift.
     */ if (hasHome && entryFee > 0) {
        // The same 2.5% agent/legal estimate the sell-home candidates above use.
        const sellingCosts = Math.round(homeValue * 0.025);
        const residualAfterEntry = Math.max(0, homeValue - sellingCosts - entryFee);
        const isCouple = factFind?.adviceFor === 'couple';
        const baseSellDetails = {
            salePrice: homeValue,
            sellingCosts: sellingCosts,
            downsizerContribution: 0,
            partnerDownsizerContribution: 0,
            commenceIncomeStream: false,
            giftingAmount: 0,
            funeralBondPurchase: 0,
            purchaseAnnuity: 0,
            purchaseInvestmentProperty: 0,
            purchaseShares: 0
        };
        const bondAmount = Math.min(residualAfterEntry, (0, $1abe73eeef086faf$export$aca3edb7cd7a3f17) * (isCouple ? 2 : 1));
        if (bondAmount > 0) candidates.push({
            id: 'rv-sell-home-funeral-bond',
            name: 'Sell your home and shelter part of the rest in a funeral bond',
            description: `Sell the home, pay the entry contribution, and put ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(bondAmount)} of what is left into a funeral bond${isCouple ? ' each' : ''} \u{2014} exempt from the assets test up to ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$aca3edb7cd7a3f17))} per person, so that part stops being counted. The remainder is invested.`,
            fundFrom: 'sell_home',
            sellHomeDetails: {
                ...baseSellDetails,
                funeralBondPurchase: bondAmount,
                purchaseShares: Math.max(0, residualAfterEntry - bondAmount)
            }
        });
        const giftAmount = Math.min(residualAfterEntry, (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0));
        if (giftAmount > 0) candidates.push({
            id: 'rv-sell-home-gift',
            name: 'Sell your home and gift within the free area',
            description: `Sell the home, pay the entry contribution, and gift ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(giftAmount)} of what is left to family. Gifts up to ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))} a year leave the means test straight away; anything above that is still counted, and still deemed, for five years \u{2014} so this stays inside the free area. The remainder is invested.`,
            fundFrom: 'sell_home',
            sellHomeDetails: {
                ...baseSellDetails,
                giftingAmount: giftAmount,
                purchaseShares: Math.max(0, residualAfterEntry - giftAmount)
            }
        });
    }
    // 9. Debt clearance — an orthogonal decision PAIRED against every move strategy above, the same
    //    pattern the aged care engine uses. Interest stops, the repayments leave the cashflow and
    //    assessable assets fall — but the money spent is money no other part of the plan can use,
    //    which is exactly the competition worth ranking rather than deciding by instinct. The engine
    //    draws the payoff from liquid assets in its own order, after the entry fee's own draw (the
    //    shared pool means a dollar cannot fund both). The stay-home baseline is left pure: it must
    //    stay indistinguishable from the client's life as it is, or nothing has a benchmark.
    //    (Aged care pairs only a spread of its RAD levels because its base set runs to hundreds;
    //    this base set is a dozen, so every move strategy gets its twin.)
    // Which debts (strategy/debtsToTest.ts, 26 Oct 2026): never a card paid off monthly; any debt that
    // costs interest, whatever its size; interest-free debts from $5,000.
    const debts = (0, $485d903040fc3504$export$718566aeb53e1efe)((0, $35f2741dc40fa45c$export$403bb596c20e48)(factFind));
    const totalDebt = debts.reduce((sum, d)=>sum + d.balance, 0);
    if (debts.length > 0) {
        const payments = Object.fromEntries(debts.map((d)=>[
                d.key,
                d.balance
            ]));
        const twins = candidates.filter((c)=>c.stayHome !== true).map((c)=>({
                ...c,
                id: `${c.id}-clear-debt`,
                name: `${c.name} + clear debts (${$6d7411748a56fc80$var$formatRoughAmount(totalDebt)})`,
                description: `${c.description} This version also clears your outstanding debts from liquid assets at the same time \u{2014} the interest stops and the repayments leave your cashflow, but the money spent is money the rest of the plan cannot use.`,
                debtPayoff: {
                    payments: payments,
                    repaymentBasis: 'keep_repayment'
                }
            }));
        candidates.push(...twins);
    }
    /*
     * FINAL GATE — nothing is offered that cannot pay the whole entry contribution.
     *
     * The liquid paths are already gated where they are generated (per variant, since one draw order
     * can fund where another falls short). This catches the PROPERTY paths, and expresses the rule
     * once for anything added later: a village ingoing contribution is a contractual price with no
     * right to part-pay it, so a plan that raises less than the full amount is not a strategy.
     *
     * Deliberately conservative on the investment-property path: it is measured on the GROSS value,
     * which can only over-state what the sale nets after costs and CGT. That direction is the safe
     * one — a candidate that grosses enough but nets slightly short is no longer able to flatter
     * itself, because the engine now strikes the exit entitlement on what was actually PAID
     * (VillageContract.entryFeePaid), so it simply ranks on its true, worse numbers instead of
     * winning on a phantom.
     */ let field = candidates;
    if (entryFee > 0) {
        const netSaleProceeds = hasHome ? homeValue - Math.round(homeValue * 0.025) : 0;
        const grossIpValue = hasIp ? investmentProps.reduce((max, p)=>Math.max(max, parseFloat(String(p?.value ?? '')) || 0), 0) : 0;
        field = candidates.filter((candidate)=>{
            if (candidate.stayHome === true) return true;
            if (candidate.fundFrom === 'sell_home') return netSaleProceeds >= entryFee - 1;
            if (candidate.fundFrom === 'investment_property') return grossIpValue >= entryFee - 1;
            return true;
        });
    }
    return $6d7411748a56fc80$export$c75c9651449fab4(field, setup);
}
function $6d7411748a56fc80$export$7a7338968b7c76b8(id) {
    const bare = id.replace(/-clear-debt$/, '');
    if (/downsizer/.test(bare)) return 'super';
    if (/-gift$/.test(bare)) return 'gift';
    if (/-property$|-ip$/.test(bare)) return 'property';
    if (/-invest$/.test(bare)) return 'invest';
    return null;
}
function $6d7411748a56fc80$export$c75c9651449fab4(field, setup) {
    const route = setup?.homeRoute ?? 'compare';
    const uses = setup?.residualUses;
    const keeps = (c)=>c.stayHome === true || c.fundFrom === 'liquid';
    const sells = (c)=>c.fundFrom === 'sell_home';
    let out = field.filter((c)=>{
        if (c.stayHome === true) return true;
        if (route === 'keep' && sells(c)) return false;
        if (route === 'sell' && c.fundFrom === 'liquid') return false;
        if (sells(c) && uses) {
            const use = $6d7411748a56fc80$export$7a7338968b7c76b8(String(c.id));
            if (use && !uses.includes(use)) return false;
        }
        return true;
    });
    if (route === 'keep' && !out.some((c)=>!c.stayHome && keeps(c))) out = [
        ...out,
        ...field.filter((c)=>sells(c) && (!uses || !$6d7411748a56fc80$export$7a7338968b7c76b8(String(c.id)) || uses.includes($6d7411748a56fc80$export$7a7338968b7c76b8(String(c.id))))).map((c)=>({
                ...c,
                onlyWayToFund: true
            }))
    ];
    return out;
}
async function $6d7411748a56fc80$export$9e49656695b3019f(factFind, villageInputs, options = {}) {
    const legacyYears = options.legacyYears || 5;
    let candidates = $6d7411748a56fc80$export$a8c959bf5420987a(factFind, villageInputs, options.setup || {});
    // A quoted income replaces the indicative rate BEFORE evaluation, on the plans of the SAME type, scaled to
    // each plan's amount; plans of another type keep our estimate (annuityQuote.ts).
    const quote = (0, $da24031d156d6acb$export$792bf827cea0133b)(options.annuityQuote);
    if (quote) candidates = candidates.map((candidate)=>{
        const details = candidate.sellHomeDetails;
        if (!details || !((details.purchaseAnnuity ?? 0) > 0)) return candidate;
        const quotedAnnuityIncome = (0, $da24031d156d6acb$export$2ee327201b9e82a1)(quote, details.rvAnnuityType, details.rvAnnuityResidualPercent, details.purchaseAnnuity);
        return quotedAnnuityIncome == null ? candidate : {
            ...candidate,
            sellHomeDetails: {
                ...details,
                rvAnnuityIncomeOverride: quotedAnnuityIncome
            }
        };
    });
    // One request evaluates every candidate against the engine server-side (see
    // server/src/rest/calculation/suggestionEngine/retirementVillage.ts) instead of one request per candidate.
    // The village inputs carry the payout choice to the server, where the moved balance sheet is built.
    const inputsForEngine = {
        ...villageInputs,
        oldUnitPaysAtMove: options.setup?.oldUnitPaysAtMove !== false
    };
    const strategies = await $55a1d8a64f1e5dfa$export$d1e9143ee86c38c3(factFind, inputsForEngine, candidates, legacyYears, options.villageEntryDate);
    // The stay-home evaluation is the do-nothing BASELINE: goal leaders are ranked among the real
    // move strategies, each measured against it — the same benchmark discipline as the other engines.
    const stayHome = strategies.find((s)=>s.id === 'rv-stay-home') || null;
    const moveStrategies = strategies.filter((s)=>s.id !== 'rv-stay-home');
    const recommended = (0, $f8ee565b442c040e$export$3140a3b98e6384f2)(moveStrategies, stayHome, {
        cashflowTarget: Number(options.setup?.cashflowTarget) || 0,
        readings: (0, $5a094123650e8adb$export$448a1f2525c95b5b)
    });
    return {
        strategies: strategies,
        recommended: recommended,
        stayHome: stayHome
    };
}









var $acw62 = parcelRequire("acw62");








function $056bec631a0e8ebc$var$EntryFeeAssetSlider({ asset: asset, saleAmount: saleAmount, onFundingChange: onFundingChange, netLine: netLine, reserved: reserved = 0, factFind: factFind }) {
    const assetValue = parseFloat(String(asset.value)) || 0;
    const available = Math.max(0, assetValue - reserved);
    // Typed amounts are clamped as well as dragged ones — the slider's `max` cannot police the
    // currency box beside it, and an over-allocation here would spend a dollar the debt card has.
    const changeClamped = (value)=>onFundingChange(asset.assetId, Math.min(Math.max(0, parseFloat(String(value)) || 0), available));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: "block text-sm font-medium text-gray-700",
                children: [
                    (0, $e850825c00b15be4$export$87285386e0429fb5)(asset, factFind, asset.typeName),
                    asset.typeId === 'shares' && asset.costBase ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "block text-xs font-normal text-gray-500",
                        children: "Amount to liquidate (CGT deducted before entry fee credited)"
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "range",
                        min: "0",
                        max: available,
                        value: saleAmount,
                        onChange: (e)=>changeClamped(e.target.value),
                        className: "w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-600"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "w-32",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                            value: saleAmount || 0,
                            onChange: (v)=>changeClamped(v),
                            placeholder: "0",
                            className: ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-xs text-gray-500 mt-1",
                children: netLine || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Available: ",
                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(available),
                        " \xb7 Allocated: ",
                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(saleAmount),
                        reserved > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "text-amber-700",
                            children: [
                                " \xb7 ",
                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(reserved),
                                " committed to clearing debt"
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function $056bec631a0e8ebc$var$EntryFeeShareCgtPanel({ factFind: factFind, asset: asset, saleAmount: saleAmount, entityId: entityId, cgtOverrides: cgtOverrides, onCgtOverrideChange: onCgtOverrideChange }) {
    if (!saleAmount || saleAmount <= 0 || !asset.costBase) return null;
    // The shared calc engine's Money fields are plain `number`; the live form state holds
    // numeric-input strings mid-edit (see frontend/src/types/formDraft.ts) — safe here because this
    // read-only estimate defensively parses (calculateSharePartialDisposalTax / parseFloat(String(x))).
    const taxSummary = (0, $a764bc0f6f904854$export$bb01b201c6492ed7)(factFind, asset, saleAmount, {
        trustDisposal: 'distribute'
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e778a6a28982486d$export$45781c28beddd168), {
        factFind: factFind,
        taxSummary: taxSummary,
        overrideValue: cgtOverrides?.[asset.assetId],
        onOverrideChange: (value)=>onCgtOverrideChange(asset.assetId, value),
        entityId: entityId,
        asset: asset,
        showNetProceedsLine: true,
        saleAmount: saleAmount,
        netProceedsLabel: "Net toward entry fee (after estimated CGT)"
    });
}
function $056bec631a0e8ebc$export$7dc7dbe3a0b92a06(factFind) {
    return [
        ...(0, $bd80071df75c742b$export$a6f66b42cac1f673)(factFind).map((a)=>a.assetId),
        ...(factFind?.assets?.investmentProperty || []).filter((ip)=>!(0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(ip.ownership)).map((ip)=>`investmentProperty-${ip.id}`),
        ...(0, $bd80071df75c742b$export$7baab1aa6768ed9)(factFind).flatMap((g)=>g.assets.map((a)=>a.assetId))
    ];
}
function $056bec631a0e8ebc$export$f609a2216aa879e7(factFind, entryFeeFunding, defaultAllocation) {
    const out = {};
    new Set($056bec631a0e8ebc$export$7dc7dbe3a0b92a06(factFind)).forEach((assetId)=>{
        out[assetId] = entryFeeFunding != null && assetId in entryFeeFunding ? Number(entryFeeFunding[assetId]) || 0 : Number(defaultAllocation?.[assetId]) || 0;
    });
    return out;
}
function $056bec631a0e8ebc$export$7ecf57148a92ad89(entryFeeFunding) {
    return Object.keys(entryFeeFunding || {}).length > 0;
}
function $056bec631a0e8ebc$export$2e2bcd8739ae039({ factFind: factFind, entryFee: entryFee, entryFeeFunding: entryFeeFunding, setEntryFeeFunding: setEntryFeeFunding, defaultAllocation: defaultAllocation, entryFeeCgtOverrides: entryFeeCgtOverrides = {}, setEntryFeeCgtOverrides: setEntryFeeCgtOverrides, reservedByAsset: reservedByAsset = {} }) {
    const personalLiquidAssets = (0, $acw62.useMemo)(()=>(0, $bd80071df75c742b$export$a6f66b42cac1f673)(factFind), [
        factFind?.assets
    ]);
    const personalInvestmentProperties = (0, $acw62.useMemo)(()=>{
        return (factFind?.assets?.investmentProperty || []).filter((ip)=>!(0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(ip.ownership)).map((ip)=>({
                ...ip,
                typeId: 'investmentProperty',
                typeName: 'Investment property',
                assetId: `investmentProperty-${ip.id}`,
                isInvestmentProperty: true
            }));
    }, [
        factFind?.assets?.investmentProperty
    ]);
    const entityAssetGroups = (0, $acw62.useMemo)(()=>(0, $bd80071df75c742b$export$7baab1aa6768ed9)(factFind), [
        factFind?.assets,
        factFind?.structures
    ]);
    const hasStructures = (factFind?.structures || []).length > 0;
    // The SAME resolution the page feeds the engine (see resolveRvEntryFeeFunding) — one function,
    // so what the client reads here and what gets modelled can never disagree again.
    const effectiveFunding = (0, $acw62.useMemo)(()=>$056bec631a0e8ebc$export$f609a2216aa879e7(factFind, entryFeeFunding, defaultAllocation), [
        factFind,
        entryFeeFunding,
        defaultAllocation
    ]);
    const fundingTotals = (0, $acw62.useMemo)(()=>(0, $d6349ba6b2bbee8e$export$d5119f51b5211c8b)(factFind, effectiveFunding, entryFeeCgtOverrides), [
        factFind,
        effectiveFunding,
        entryFeeCgtOverrides
    ]);
    const entityGrossAllocated = (0, $acw62.useMemo)(()=>(0, $bd80071df75c742b$export$797d34a55dccdf21)(effectiveFunding, entityAssetGroups), [
        effectiveFunding,
        entityAssetGroups
    ]);
    const entryFeeAmount = parseFloat(String(entryFee)) || 0;
    const remainingToFund = Math.max(0, entryFeeAmount - fundingTotals.netTotal);
    // Is the pre-fill still standing, and what is it quietly doing? Both drive the notice above the
    // sliders — the buffer it protects and the pension-before-shares preference it takes.
    const adviserAllocated = $056bec631a0e8ebc$export$7ecf57148a92ad89(entryFeeFunding);
    const bankTotal = personalLiquidAssets.filter((a)=>a.typeId === 'bankAccounts').reduce((sum, a)=>sum + (parseFloat(String(a.value)) || 0), 0);
    const bankDrawnByDefault = personalLiquidAssets.filter((a)=>a.typeId === 'bankAccounts').reduce((sum, a)=>sum + (Number(effectiveFunding[a.assetId]) || 0), 0);
    const liquidAvailable = personalLiquidAssets.filter((a)=>a.typeId !== 'investmentProperty').reduce((sum, a)=>sum + (parseFloat(String(a.value)) || 0), 0);
    const savingsCannotCover = entryFeeAmount > 0 && liquidAvailable < entryFeeAmount;
    /*
     * Only claim a buffer when the default actually left cash behind BECAUSE OF THE RESERVE RULE.
     *
     * When savings cannot cover the contribution there is now no default at all (the allocation is
     * left empty rather than pre-filled), so `bankTotal - bankDrawnByDefault` is the whole bank
     * balance — and the screen would explain a $700,000 "emergency buffer" that is really just money
     * nobody has allocated. A reason given for something that did not happen is worse than silence.
     */ const reserveKeptInCash = !adviserAllocated && !savingsCannotCover ? Math.max(0, Math.round(bankTotal - bankDrawnByDefault)) : 0;
    const defaultDrawsAbp = !adviserAllocated && personalLiquidAssets.some((a)=>a.typeId === 'accountBasedPensions' && (Number(effectiveFunding[a.assetId]) || 0) > 0);
    /*
     * The explainer must describe THIS client's balance sheet, not the generic draw order
     * (owner-caught, 2026-08-26: "this client did not have any shares but it references this in the
     * commentary — it needs to be logic based otherwise consumers will get confused"). A client with
     * no shares should never read a sentence about selling shares or about the CGT that would follow.
     */ const heldTypeIds = new Set(personalLiquidAssets.filter((a)=>(parseFloat(String(a.value)) || 0) > 0).map((a)=>a.typeId));
    const hasShares = heldTypeIds.has('shares');
    const DRAW_ORDER_LABELS = [
        [
            'bankAccounts',
            'bank accounts'
        ],
        [
            'termDeposits',
            'term deposits'
        ],
        [
            'accountBasedPensions',
            'account-based pensions'
        ],
        [
            'shares',
            'shares'
        ]
    ];
    const heldDrawOrder = DRAW_ORDER_LABELS.filter(([id])=>heldTypeIds.has(id)).map(([, label])=>label);
    /*
     * Can these savings cover the contribution AT ALL? (owner, 2026-08-26: "for this example where
     * the client has only $300k in liquid assets do you think the default starting point of selling
     * the assets is the right path when they will have to sell the home to fund it?" — no, it isn't.)
     *
     * The pre-fill still runs, because the engine has to fund the fee from something for the
     * projections to mean anything. What changes is what this box SAYS: proposing a draw order as a
     * "suggested starting point" implies a workable plan, and when the money is not there the honest
     * opening is that it is not there. Measured on liquid assets only — the property paths are a
     * different decision, made in Property strategy options.
     */ /*
     * WHAT THIS CLIENT COULD ACTUALLY SELL, named rather than gestured at.
     *
     * The message used to point at "Property strategy options above" and compare a village
     * contribution to an aged care room ("there is no pay-part-of-it-daily option the way an aged
     * care room has"). The owner cut that: it drags aged care into a conversation the client may
     * never have opened, and it explains the village rule by reference to a scheme they have not
     * asked about. The rule stands on its own — a village contribution is paid in full.
     *
     * Naming the routes they actually HOLD is more use than naming a section: a client with an
     * investment property and no intention of leaving their home should hear about the property
     * first, not be sent scrolling.
     */ const hasFamilyHome = (parseFloat(String(factFind?.home?.value ?? '')) || 0) > 0;
    const investmentProperties = factFind?.assets?.investmentProperty || [];
    const hasInvestmentProperty = investmentProperties.some((ip)=>(parseFloat(String(ip?.value ?? '')) || 0) > 0);
    const fundingRoutes = [
        hasFamilyHome ? 'selling or renting out the family home' : null,
        hasInvestmentProperty ? 'selling an investment property' : null
    ].filter(Boolean);
    const handleFundingChange = (assetId, value)=>{
        const numeric = parseFloat(String(value)) || 0;
        // A zero is KEPT, not deleted. Touching a slider records an intention, and "use nothing from
        // this account" is an intention — deleting the key made the asset untouched again, so the
        // per-asset merge handed back the default allocation and the slider sprang back to it.
        setEntryFeeFunding((prev)=>({
                ...prev,
                [assetId]: Math.max(0, numeric)
            }));
        if (numeric <= 0 && setEntryFeeCgtOverrides) setEntryFeeCgtOverrides((prev)=>{
            if (prev?.[assetId] == null) return prev;
            const next = {
                ...prev
            };
            delete next[assetId];
            return next;
        });
    };
    const handleCgtOverrideChange = (assetId, value)=>{
        if (!setEntryFeeCgtOverrides) return;
        setEntryFeeCgtOverrides((prev)=>{
            const next = {
                ...prev
            };
            if (value == null) delete next[assetId];
            else next[assetId] = value;
            return next;
        });
    };
    const renderAssetRow = (asset, entityId = null)=>{
        const saleAmount = effectiveFunding[asset.assetId] || 0;
        let netLine = null;
        if (asset.isInvestmentProperty && saleAmount > 0) {
            const available = parseFloat(String(asset.value)) || 0;
            const ipNet = (0, $d6349ba6b2bbee8e$export$2f966089c4f904da)(factFind, asset, Math.min(saleAmount, available));
            netLine = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    "Available: ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(available),
                    " \xb7 Sale amount: ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(saleAmount),
                    ' ',
                    "\u2192 Estimated CGT: ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(ipNet.cgt),
                    " \xb7 Net to entry fee:",
                    ' ',
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(ipNet.netProceeds)
                ]
            });
        }
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($056bec631a0e8ebc$var$EntryFeeAssetSlider, {
                    asset: asset,
                    saleAmount: saleAmount,
                    onFundingChange: handleFundingChange,
                    netLine: netLine,
                    reserved: Number(reservedByAsset[asset.assetId]) || 0,
                    factFind: factFind
                }),
                asset.typeId === 'shares' && saleAmount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($056bec631a0e8ebc$var$EntryFeeShareCgtPanel, {
                    factFind: factFind,
                    asset: asset,
                    saleAmount: saleAmount,
                    entityId: entityId,
                    cgtOverrides: entryFeeCgtOverrides,
                    onCgtOverrideChange: handleCgtOverrideChange
                })
            ]
        }, asset.assetId);
    };
    const hasShareLiquidation = fundingTotals.shareCgtTotal > 0;
    const hasAnyAssets = personalLiquidAssets.length > 0 || personalInvestmentProperties.length > 0 || entityAssetGroups.length > 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "text-xl font-bold text-gray-800 mb-4",
                children: "Entry fee from existing assets"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-sm text-gray-600 mb-4",
                children: "Allocate funds from your liquid assets or investment property to pay the village entry fee. For share sales, estimated CGT is deducted before the entry fee amount is credited."
            }),
            entryFeeAmount > 0 && (adviserAllocated ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-sm mb-4 rounded-lg bg-white border border-slate-200/70 border-l-4 border-l-emerald-500 px-3 py-2 text-slate-700 shadow-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "text-slate-900",
                        children: "You have set this allocation."
                    }),
                    " These are your figures, not the tool's defaults."
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `text-sm mb-4 rounded-lg bg-white border border-slate-200/70 border-l-4 px-3 py-2.5 text-slate-700 shadow-sm space-y-1.5 ${savingsCannotCover ? 'border-l-amber-500' : 'border-l-blue-500'}`,
                children: [
                    savingsCannotCover ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: "Your savings cannot cover the entry contribution."
                                    }),
                                    ' ',
                                    "They total ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(liquidAvailable),
                                    " against ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(entryFeeAmount),
                                    ", and a village entry contribution has to be paid in full.",
                                    fundingRoutes.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            " That means the money has to come from ",
                                            fundingRoutes.join(' or '),
                                            " \u2014 set that in",
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "Property strategy options"
                                            }),
                                            " above, and the sliders here will top it up."
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: " With no property to sell or rent, this move cannot be funded as entered \u2014 a lower entry contribution is the only thing that would change that."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1.5",
                                children: "The sliders below start at zero for that reason \u2014 there is nothing to allocate until the move can be funded."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "This is a suggested starting point, not a recommendation."
                            }),
                            " We have pre-filled a default draw order",
                            heldDrawOrder.length > 0 ? ` (${heldDrawOrder.join(" \u2192 ")})` : '',
                            " so the projections can run \u2014 the entry contribution has to be paid from something. Adjust any slider to make it your own decision."
                        ]
                    }),
                    reserveKeptInCash > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1.5",
                        children: [
                            "The default deliberately leaves ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(reserveKeptInCash)
                            }),
                            " in cash as an emergency buffer \u2014 six months of living expenses, or $50,000, whichever is greater \u2014 which is why your bank accounts are not drawn to zero."
                        ]
                    }),
                    defaultDrawsAbp && hasShares && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1.5",
                        children: [
                            "It also draws your ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "account-based pension before your shares"
                            }),
                            ", to avoid triggering ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "capital gains tax"
                            }),
                            " on a share sale. That is not automatically the better outcome: an account-based pension pays ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "tax-free investment earnings"
                            }),
                            " and drawing it down gives up that stream for good, while the CGT on shares is a one-off cost that the 50% discount may make smaller than it looks. It is a genuine trade-off, not a settled answer \u2014 move the sliders to take the other side, or run the ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Suggestion Engine"
                            }),
                            ", which models both and ranks them."
                        ]
                    }),
                    !savingsCannotCover && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setEntryFeeFunding({
                                ...effectiveFunding
                            }),
                        className: "mt-2.5 inline-flex items-center gap-2 rounded-md bg-blue-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-blue-700",
                        children: "Accept this allocation"
                    })
                ]
            })),
            !hasAnyAssets && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-sm text-gray-500 italic",
                children: "No fundable assets available in your fact-find."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: entryFeeAmount > 0 && !adviserAllocated ? 'rounded-xl border border-dashed border-slate-300 bg-slate-50/50 p-3' : '',
                children: [
                    personalLiquidAssets.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-4",
                        children: [
                            hasStructures && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                className: "text-sm font-semibold text-gray-700",
                                children: "Your personal assets"
                            }),
                            personalLiquidAssets.map((asset)=>renderAssetRow(asset))
                        ]
                    }),
                    personalInvestmentProperties.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `space-y-4 ${personalLiquidAssets.length > 0 ? 'mt-4' : ''}`,
                        children: [
                            hasStructures && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                className: "text-sm font-semibold text-gray-700",
                                children: "Personal investment property"
                            }),
                            personalInvestmentProperties.map((asset)=>renderAssetRow(asset))
                        ]
                    }),
                    entityAssetGroups.map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mt-6 pt-4 border-t space-y-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                            className: "text-sm font-semibold text-gray-800",
                                            children: group.entityName
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-xs text-gray-500",
                                            children: group.structureTypeLabel
                                        })
                                    ]
                                }),
                                group.assets.map((asset)=>renderAssetRow(asset, group.entityId))
                            ]
                        }, group.entityId))
                ]
            }),
            (entityGrossAllocated > 0 || entityAssetGroups.some((g)=>g.assets.some((a)=>a.isInvestmentProperty && (effectiveFunding[a.assetId] || 0) > 0))) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-4 p-3 rounded-lg bg-white border border-slate-200/70 border-l-4 border-l-amber-500 text-sm text-slate-700 shadow-sm",
                children: (0, $bd80071df75c742b$export$ec9c57e3c77471a1)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-6 pt-4 border-t space-y-2",
                children: [
                    hasShareLiquidation && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-between text-sm text-gray-600",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Share liquidations (gross)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Object.entries((0, $bd80071df75c742b$export$e98193fa2b9f521b)(factFind, Object.fromEntries(Object.entries(effectiveFunding).filter(([k])=>!k.startsWith('investmentProperty-'))), entryFeeCgtOverrides).byKey).filter(([k])=>k.startsWith('shares-')).reduce((s, [, e])=>s + e.gross, 0))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-between font-bold",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Total toward entry fee (net of CGT on shares):"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: fundingTotals.netTotal > entryFeeAmount ? 'text-red-500' : '',
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(fundingTotals.netTotal)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-between font-bold",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Remaining to fund:"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(remainingToFund)
                            })
                        ]
                    })
                ]
            })
        ]
    });
}












/**
 * The pieces a village plan is made of, as rows for PlanPiecesCard (owner, 24 Sep 2026: the
 * explainer named "downsizer contribution" and "account-based pension" without ever saying what
 * they are).
 *
 * Built from the same `sellHomeDetails` / funding route the engine projected, so a row can never
 * describe a piece the plan does not have. Every `what` line is two short sentences at most: what
 * the piece is, and what the means tests do with it. The vetted glossary carries the depth.
 */ 

const $b09eddbdc2b9438e$var$num = (v)=>{
    const n = parseFloat(String(v ?? ''));
    return Number.isFinite(n) ? n : 0;
};
function $b09eddbdc2b9438e$export$23826e09bab3c866(i) {
    const a = i.allocations || {};
    const you = i.clientName || 'you';
    const partner = i.partnerName || 'your partner';
    const pieces = [];
    // How the move is paid for.
    if (i.fundFrom === 'sell_home') {
        const sale = $b09eddbdc2b9438e$var$num(a.salePrice);
        pieces.push({
            key: 'sell-home',
            name: 'Sell the family home',
            amount: sale,
            what: 'The home is sold and, after selling costs, the money pays the entry contribution and funds the rest of the plan. Once sold, its value is money Centrelink counts.'
        });
    } else if (i.fundFrom === 'investment_property') pieces.push({
        key: 'sell-ip',
        name: 'Sell an investment property',
        what: 'The property is sold; after selling costs and capital gains tax, the proceeds pay the entry contribution. Its rent stops counting as income.',
        glossaryTerm: 'capital gains tax'
    });
    else if (i.rentHome) pieces.push({
        key: 'rent-home',
        name: 'Keep the home and rent it out',
        what: 'The entry contribution is paid from savings and the home is let. The rent counts as income, and the home is counted as an asset once the village unit is the main home.'
    });
    else pieces.push({
        key: 'savings',
        name: 'Pay from savings',
        what: 'The entry contribution comes out of bank accounts, term deposits, super pensions or shares, in that order unless you chose otherwise. Money spent on the village unit is not assessed.'
    });
    if (i.entryFee > 0) pieces.push({
        key: 'entry',
        name: 'Village entry contribution',
        amount: i.entryFee,
        what: 'What the village charges for the right to live there. Most of it comes back when you leave, less the departure fee, so it stays part of the estate while you are there.',
        glossaryTerm: 'entry contribution'
    });
    // Where the rest of the money goes.
    const dz = $b09eddbdc2b9438e$var$num(a.downsizerContribution);
    const pdz = $b09eddbdc2b9438e$var$num(a.partnerDownsizerContribution);
    if (dz > 0) pieces.push({
        key: 'downsizer-client',
        name: `Downsizer contribution into super (${you})`,
        amount: dz,
        what: 'A special rule lets each person aged 55 or over put up to $300,000 from selling their home into super, on top of the usual limits. Inside super the earnings are taxed at no more than 15%.',
        glossaryTerm: 'downsizer contribution'
    });
    if (pdz > 0) pieces.push({
        key: 'downsizer-partner',
        name: `Downsizer contribution into super (${partner})`,
        amount: pdz,
        what: 'The same rule, used for the second member of the couple. Super in accumulation is not counted by Centrelink while its owner is under Age Pension age.',
        glossaryTerm: 'downsizer contribution'
    });
    if (a.commenceIncomeStream === true && dz + pdz > 0) pieces.push({
        key: 'abp',
        name: 'Account-based pension',
        what: 'The super is switched on as a regular income you draw from, and its earnings become tax free. The balance stays yours: it is counted as an asset and deemed to earn income.',
        glossaryTerm: 'account-based pension'
    });
    const annuity = $b09eddbdc2b9438e$var$num(a.purchaseAnnuity);
    if (annuity > 0) {
        const residual = a.rvAnnuityResidualPercent != null ? $b09eddbdc2b9438e$var$num(a.rvAnnuityResidualPercent) : i.nilResidualAnnuity ? 0 : 0;
        const returned = residual >= 50;
        // Each type in its own words (guaranteed income review, 21 Oct 2026): the full-amount-back type is not the
        // money-back one, and is counted differently.
        const fullBack = String(a.rvAnnuityType) === 'guaranteed';
        pieces.push({
            key: 'annuity',
            name: 'Lifetime annuity',
            amount: annuity,
            what: fullBack ? 'A lump sum handed to an insurer in return for a guaranteed income for life, combined with life cover: the whole amount goes to the family whenever death comes. Centrelink counts the income part at 60% and the life cover in full.' : `A lump sum handed to an insurer in return for a guaranteed income for life. Only 60% of it counts in the assets test. ${returned ? (0, $5ccd559ea4d04f2e$export$476ca360cf39c0a7)({
                residualPct: residual,
                periodYears: i.annuityCapitalAccessPeriodYears ?? null,
                sexKnown: i.annuitySexKnown ?? null,
                ownerName: you
            }) : 'Income only: nothing of the purchase price comes back to the family, even after an early death.'}`,
            glossaryTerm: 'lifetime annuity'
        });
    }
    const shares = $b09eddbdc2b9438e$var$num(a.purchaseShares);
    if (shares > 0) pieces.push({
        key: 'shares',
        name: 'Shares / managed funds',
        amount: shares,
        what: 'Invested in a spread of shares and funds you can sell at any time. Counted in full as an asset, and deemed to earn income whatever it actually pays.',
        glossaryTerm: 'shares and managed funds'
    });
    const ip = $b09eddbdc2b9438e$var$num(a.purchaseInvestmentProperty);
    if (ip > 0) {
        const duty = $b09eddbdc2b9438e$var$num(a.investmentPropertyStampDuty);
        pieces.push({
            key: 'ip',
            name: 'Investment property',
            amount: ip,
            what: `A property bought to rent out. Counted in full as an asset, and the rent after expenses counts as income. ${duty > 0 ? `Stamp duty of ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(duty)} is paid on the purchase.` : 'Stamp duty is not modelled because no state was chosen.'}`,
            glossaryTerm: 'investment property'
        });
    }
    const gift = $b09eddbdc2b9438e$var$num(a.giftingAmount);
    if (gift > 0) pieces.push({
        key: 'gift',
        name: 'Gift to family',
        amount: gift,
        what: 'Money given away. Up to $10,000 a year ($30,000 over five years) leaves the means tests straight away; anything above that is still counted for five years.',
        glossaryTerm: 'gifting'
    });
    const bond = $b09eddbdc2b9438e$var$num(a.funeralBondPurchase);
    if (bond > 0) pieces.push({
        key: 'bond',
        name: 'Funeral bond',
        amount: bond,
        what: 'Money set aside for a funeral with a friendly society or insurer. Within the limit it is exempt from the assets test, and it can only be used for the funeral.',
        glossaryTerm: 'funeral bond'
    });
    return pieces;
}



/**
 * "EXPLAIN THIS" FOR A VILLAGE PLAN, AS AGED CARE TELLS IT (owner, 22 Oct 2026: "the UI for the explain this does
 * not match the updates that were carried out for aged care … all modules use consistent UI").
 *
 * The old "Your plan summary" card (RvPlanRecap — paragraphs, before/after rows and a "why" under each) is
 * replaced in the Explain dialog by aged care's ledger: numbered lines, each saying what is done and what that
 * does to the numbers, then "Put together" with the money story inside it, then the "=" line against staying
 * put (or, once the family has decided to move, against the best way to move — RvPlansView's rule).
 *
 * Presentation only. Every figure is one the page already holds: the plan's snapshot or the hand-built plan's
 * own figures, staying put's, the contract's departure fee (exitAfter), the rent on the candidate's inputs and
 * the investment income on the plan's first year in the village. Wording reused from RvPlanRecap where it was
 * right, in plain words; the household is "you" for the client and named for the adviser (householdVoice).
 */ 
parcelRequire("acw62");




const $12ed609b340a4036$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(n)));
const $12ed609b340a4036$var$B = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
        className: "text-slate-900",
        children: children
    });
const $12ed609b340a4036$var$cap = (s)=>s.charAt(0).toUpperCase() + s.slice(1);
function $12ed609b340a4036$export$279780a48d38fdab(rows, inVillage = true) {
    const list = rows || [];
    // The first year in the unit, as the card's snapshot reads it (a dated move's first row is the year before it).
    const row = (inVillage ? list.find((r)=>(Number(r?.annualVillageCost) || 0) > 0) : null) ?? list[0];
    const lines = (row?.financials?.cashFlowBreakdown || []).filter((l)=>l?.series === 'investment');
    if (!lines.length) return null;
    return lines.reduce((t, l)=>t + (Number(l.value) || 0), 0);
}
const $12ed609b340a4036$export$d233dcc96481b9ef = ({ voice: v, sub: sub, fundFrom: fundFrom, rentHome: rentHome, hasHome: hasHome, homeValue: homeValue, entryFee: entryFee, salePrice: salePrice = 0, rentWeekly: rentWeekly = 0, rentCosts: rentCosts = 0, shortfall: shortfall = 0, nilAnnuity: nilAnnuity = null, villageFeesAYear: villageFeesAYear, departureFee: departureFee, backAfter: backAfter, rentAssistance: rentAssistance = 0, plan: plan, stayPut: stayPut, benchmark: benchmark, horizonYears: horizonYears, moneyStory: moneyStory = null, children: children, leverKinds: leverKinds = [] })=>{
    const yrs = `${horizonYears} ${horizonYears === 1 ? 'year' : 'years'}`;
    const sells = fundFrom === 'sell_home';
    const keepsHome = hasHome && !sells;
    const rented = keepsHome && (rentHome || fundFrom === 'rent_home');
    const rentNet = Math.max(0, rentWeekly * 52 - rentCosts);
    const lines = [];
    // A hand-built plan that does not yet pay the whole entry payment says so first: everything after it assumes the move.
    if (Math.round(shortfall) > 0) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        "data-testid": "rv-cause-effect-unfunded",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($12ed609b340a4036$var$B, {
                children: "This plan is not paid for yet."
            }),
            " The savings chosen cover ",
            $12ed609b340a4036$var$money(Math.max(0, entryFee - shortfall)),
            " of the ",
            $12ed609b340a4036$var$money(entryFee),
            " entry payment, leaving ",
            $12ed609b340a4036$var$money(shortfall),
            " to find, and a village entry payment has to be paid in full. The lines below assume the move goes ahead."
        ]
    }));
    // 1. What is done, and how the entry payment is paid (the card's own sub-line says where it comes from).
    const doSentence = sells ? `${v.They} sell the home${salePrice > 0 ? ` for ${$12ed609b340a4036$var$money(salePrice)}` : ''} and move into the village.` : fundFrom === 'investment_property' ? `${v.They} sell the investment property and move into the village.` : rented ? `${v.They} keep the home, rent it out at ${$12ed609b340a4036$var$money(rentWeekly)} a week, and move into the village.` : keepsHome ? `${v.They} keep the home as it is and move into the village.` : `${v.They} pay the ${$12ed609b340a4036$var$money(entryFee)} entry payment and move into the village.`;
    // The card's sub-line repeats the rent; said once here, with what it brings in (live check, 22 Oct 2026).
    lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($12ed609b340a4036$var$B, {
                children: doSentence
            }),
            " ",
            (0, $5d864ab5b3ee155d$export$ad89789727bbada3)(rented ? sub.replace(/\s*The home is let at [^.]*\./i, '') : sub, v),
            rented && rentNet > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    " After the weeks it sits empty and ",
                    $12ed609b340a4036$var$money(rentCosts),
                    " a year of costs, the rent brings in about ",
                    $12ed609b340a4036$var$money(rentNet),
                    " a year."
                ]
            }) : null
        ]
    }));
    // 2. Homeowner or not: the Extra Allowable Amount decides it, and with it whether the entry payment is counted.
    const homeowner = entryFee > (0, $1abe73eeef086faf$export$e2cf792e99a08354);
    // A couple are both named, so the noun is plural (review, 18 Oct 2026: "treats John as a homeowner" on John and Kerry's file).
    const whoWord = v.couple ? homeowner ? 'homeowners' : 'non-homeowners' : homeowner ? 'a homeowner' : 'a non-homeowner';
    lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        "data-testid": "rv-cause-effect-eaa",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($12ed609b340a4036$var$B, {
                children: [
                    "The entry payment is ",
                    homeowner ? 'above' : 'at or below',
                    " ",
                    $12ed609b340a4036$var$money((0, $1abe73eeef086faf$export$e2cf792e99a08354)),
                    ", so Centrelink treats ",
                    v.names,
                    " as ",
                    whoWord,
                    "."
                ]
            }),
            ' ',
            "That figure, the Extra Allowable Amount, is the line Centrelink uses to decide whether a village unit counts as ",
            v.their,
            " home.",
            ' ',
            homeowner ? 'Above it, the entry payment itself is not counted, but the lower limits for homeowners apply to everything else.' : `At or below it, the entry payment is counted as an asset, but the higher limits for people without a home apply, and Rent Assistance may be paid on the village fees.`
        ]
    }));
    // 3. The home kept is counted straight away — the village has no two-year exemption.
    if (keepsHome) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($12ed609b340a4036$var$B, {
                children: [
                    "The home ",
                    v.they,
                    " keep is counted in full",
                    rented ? ', and the rent as income' : '',
                    "."
                ]
            }),
            " Once the unit is ",
            v.their,
            " home, the old one is an asset like any other: unlike moving into care, a village move has no two-year exemption."
        ]
    }));
    // A guaranteed income that returns nothing: the main reason the family is left less, said where it happens.
    if (nilAnnuity && nilAnnuity.amount > 0) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($12ed609b340a4036$var$B, {
                children: [
                    "The ",
                    $12ed609b340a4036$var$money(nilAnnuity.amount),
                    " guaranteed income returns nothing to the family"
                ]
            }),
            " when ",
            nilAnnuity.ownerName,
            " ",
            nilAnnuity.ownerName === 'you' ? 'die' : 'dies',
            ". That money leaves the estate the day it is bought, and it is most of the difference below."
        ]
    }));
    if (stayPut) {
        // 4. The Age Pension, before and after, and why.
        const dp = plan.pension - stayPut.pension;
        const why = rented ? 'the rented home and its rent are counted' : keepsHome ? 'the home is counted' : sells || fundFrom === 'investment_property' ? 'the sale money is counted, wherever it is put' : null;
        lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            "data-testid": "rv-cause-effect-pension",
            children: Math.abs(dp) < 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($12ed609b340a4036$var$B, {
                children: [
                    $12ed609b340a4036$var$cap(v.possessive),
                    " Age Pension stays at ",
                    $12ed609b340a4036$var$money(plan.pension),
                    " a year."
                ]
            }) : dp > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($12ed609b340a4036$var$B, {
                        children: [
                            "Less is counted, so ",
                            v.possessive,
                            " Age Pension rises"
                        ]
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$5354fc7cb2207caf), {
                        from: stayPut.pension,
                        to: plan.pension,
                        unit: " a year",
                        better: "up"
                    }),
                    "."
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($12ed609b340a4036$var$B, {
                        children: [
                            "More is counted, so ",
                            v.possessive,
                            " Age Pension ",
                            plan.pension < 1 ? 'stops' : 'falls'
                        ]
                    }),
                    " ",
                    plan.pension < 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "(it was ",
                            $12ed609b340a4036$var$money(stayPut.pension),
                            " a year)"
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$5354fc7cb2207caf), {
                        from: stayPut.pension,
                        to: plan.pension,
                        unit: " a year",
                        better: "up"
                    }),
                    why ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " \u2014 ",
                            why
                        ]
                    }) : null,
                    "."
                ]
            })
        }));
    }
    // 5. The village's costs: the fees every year, the departure fee when they leave.
    lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        "data-testid": "rv-cause-effect-fees",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($12ed609b340a4036$var$B, {
                children: villageFeesAYear > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "The village fees of ",
                        $12ed609b340a4036$var$money(villageFeesAYear),
                        " a year start"
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: "This village charges no ongoing fees"
                })
            }),
            villageFeesAYear > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    ", part of the money out every year",
                    rentAssistance > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "; ",
                            $12ed609b340a4036$var$money(rentAssistance),
                            " a year of Rent Assistance helps with them"
                        ]
                    }) : null,
                    "."
                ]
            }) : '.',
            ' ',
            departureFee > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "When ",
                    v.they,
                    " leave, the village keeps a departure fee from the entry payment, about ",
                    $12ed609b340a4036$var$money(departureFee),
                    " after ",
                    yrs,
                    " on this contract, and pays back about ",
                    $12ed609b340a4036$var$money(backAfter),
                    ". That fee is already taken off what the family is left."
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "This contract has no departure fee, so the entry payment comes back when ",
                    v.they,
                    " leave."
                ]
            })
        ]
    }));
    if (stayPut) {
        // 6. Investment income: the entry payment no longer earns; a sale's money or the rent may.
        if (plan.investmentIncome != null && stayPut.investmentIncome != null) {
            const di = plan.investmentIncome - stayPut.investmentIncome;
            if (Math.abs(di) >= 100) lines.push(di < 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($12ed609b340a4036$var$B, {
                        children: "Less money stays invested, so investment income falls"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$5354fc7cb2207caf), {
                        from: stayPut.investmentIncome,
                        to: plan.investmentIncome,
                        unit: " a year",
                        better: "up"
                    }),
                    ". The entry payment is money that no longer earns."
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($12ed609b340a4036$var$B, {
                        children: "Investment income rises"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$5354fc7cb2207caf), {
                        from: stayPut.investmentIncome,
                        to: plan.investmentIncome,
                        unit: " a year",
                        better: "up"
                    }),
                    rented ? " \u2014 the rent is part of it" : sells ? " \u2014 what is left of the sale is invested" : '',
                    "."
                ]
            }));
        }
        // 7. Put together, with the money story inside it when a year falls short.
        lines.push((0, $4800816561106c2d$export$4be361d56ef6ce0f)({
            cashflow: plan.cashflow,
            baseCashflow: stayPut.cashflow,
            they: v.they,
            baseWord: 'staying put',
            moneyStory: moneyStory
        }));
    } else if (moneyStory) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: moneyStory
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$d053159fb36403b3), {
        lines: lines,
        estate: plan.legacy,
        baseEstate: benchmark ? benchmark.legacy : null,
        horizonYears: horizonYears,
        baseWord: benchmark?.word ?? 'staying put',
        testId: "rv-cause-effect",
        leverKinds: leverKinds,
        children: children
    });
};
var $12ed609b340a4036$export$2e2bcd8739ae039 = $12ed609b340a4036$export$d233dcc96481b9ef;




/**
 * A Suggestion Engine strategy card for the village module, in the aged care card's anatomy.
 *
 * WHY (owner, 24 Sep 2026: "the suggestion engine results cards look and are positioned
 * differently … try to get harmonisation of the UI/UX"). Aged Care's card reads top to bottom:
 * what the plan is, WHAT IT DOES (the money flow and the plan in one sentence), the figures with
 * the baseline under each, then Explain / Deep dive / Select. The village card carried the same
 * facts in a different order and a different dress. Same order, same dress now.
 *
 * THE RAIL HOLDS STAYING PUT in engine mode, so this card is the only place a plan is described:
 * the in-brief sentence here is the SAME template Manual Control's rail uses (rvInBrief.tsx),
 * measured against the same staying-put baseline, and every figure under a tile says what staying
 * put gives and how far this plan moves it. Nothing here is re-derived: the strategy's own
 * snapshot and projections, and the baseline candidate's, quoted.
 *
 * WORTH KNOWING, ON THE CARD (owner, 24 Sep 2026: "you're going to get me sued if a client pleads
 * ignorance"). A lifetime annuity that returns nothing on death is said in amber on the card
 * itself, with the age-and-health warning the aged care cards carry — never only inside "Explain
 * this".
 */ 

parcelRequire("acw62");





/**
 * What a Suggestion Engine strategy actually DOES — the apportionment and the three levers, on the
 * card, against the baseline.
 *
 * OWNER-CAUGHT (2026-08-26): "it shows selling the home but it does not clearly provide details of
 * exactly how the balance is apportioned — it's very generic in its explanation and this is not good
 * enough. It should clearly explain the strategy and give context again against the levers of age
 * pension, cashflow, legacy against baseline."
 *
 * The card used to carry a paragraph of description and a one-line "How it's funded" that named only
 * the entry contribution. Selling an $800,000 home to pay an $800,000 entry contribution is a
 * complete story; selling a $2,000,000 home to pay it is not, and the missing $1.2m is the part the
 * adviser has to explain to the client. So this component answers two questions in order:
 *
 *   1. WHERE DOES THE MONEY GO — every dollar of the sale, from gross price down to what is left in
 *      the bank, as a ledger. The destinations come from the candidate's OWN inputs (the same object
 *      the engine projected), so the ledger and the projection can never describe different plans.
 *   2. WHAT DOES IT DO — Age Pension, cashflow and estate, each as baseline → this strategy with a
 *      driver-named reason. Every figure is the strategy's own snapshot or the baseline's, quoted;
 *      nothing here is re-derived.
 *
 * CALCULATION DISCIPLINE: this component performs NO financial modelling. It reads allocations the
 * adviser or the engine already chose and figures the engine already computed. The one arithmetic it
 * does is the remainder (proceeds less the named allocations), which is definitionally what is left.
 */ 

parcelRequire("acw62");



const $9a0b4b28118c1fc9$export$9383c96fcf8804f9 = (name, underPensionAge)=>underPensionAge === true ? `not counted while ${name} is under Age Pension age` : underPensionAge === false ? `counted \u{2014} ${name} is over Age Pension age` : 'counted unless the owner is under Age Pension age';
const $9a0b4b28118c1fc9$var$amountOf = (value)=>{
    const parsed = parseFloat(String(value ?? ''));
    return Number.isFinite(parsed) ? parsed : 0;
};
const $9a0b4b28118c1fc9$var$RvStrategyExplainer = ({ strategy: strategy, baseline: baseline, entryFee: entryFee, legacyYears: legacyYears, clientName: clientName = 'you', partnerName: partnerName = 'your partner', clientUnderPensionAge: clientUnderPensionAge, partnerUnderPensionAge: partnerUnderPensionAge })=>{
    const inputs = strategy?.inputs || {};
    const fundFrom = inputs.fundFrom || 'liquid';
    const details = inputs.sellHomeDetails || {};
    // ---- 1. Where the money goes -------------------------------------------------------------
    // Only a PROPERTY sale has a remainder worth itemising; a savings-funded move spends the entry
    // contribution out of accounts the "How it's funded" list already names one by one.
    const salePrice = $9a0b4b28118c1fc9$var$amountOf(details.salePrice);
    const sellingCosts = $9a0b4b28118c1fc9$var$amountOf(details.sellingCosts);
    const netProceeds = Math.max(0, salePrice - sellingCosts);
    const showLedger = fundFrom === 'sell_home' && netProceeds > 0;
    const allocations = showLedger ? [
        {
            label: 'Village entry contribution',
            amount: Math.min(entryFee, netProceeds),
            chip: 'refundable on exit, less the departure fee'
        },
        {
            label: `Into super \u{2014} downsizer contribution (${clientName})`,
            amount: $9a0b4b28118c1fc9$var$amountOf(details.downsizerContribution),
            chip: $9a0b4b28118c1fc9$export$9383c96fcf8804f9(clientName, clientUnderPensionAge)
        },
        {
            label: `Into super \u{2014} downsizer contribution (${partnerName})`,
            amount: $9a0b4b28118c1fc9$var$amountOf(details.partnerDownsizerContribution),
            chip: $9a0b4b28118c1fc9$export$9383c96fcf8804f9(partnerName, partnerUnderPensionAge)
        },
        {
            label: 'Lifetime annuity',
            amount: $9a0b4b28118c1fc9$var$amountOf(details.purchaseAnnuity),
            chip: 'only 60% counted in the assets test'
        },
        {
            label: 'Shares / managed funds',
            amount: $9a0b4b28118c1fc9$var$amountOf(details.purchaseShares),
            chip: 'counted and deemed'
        },
        {
            label: 'Investment property',
            amount: $9a0b4b28118c1fc9$var$amountOf(details.purchaseInvestmentProperty),
            chip: 'counted; rent is assessable'
        },
        {
            label: 'Stamp duty on the property',
            amount: $9a0b4b28118c1fc9$var$amountOf(details.purchaseInvestmentProperty) > 0 ? $9a0b4b28118c1fc9$var$amountOf(details.investmentPropertyStampDuty) : 0,
            chip: 'paid to the state; part of the cost base'
        },
        {
            label: 'Gift to family',
            amount: $9a0b4b28118c1fc9$var$amountOf(details.giftingAmount),
            chip: 'still counted for 5 years above the limits'
        },
        {
            label: 'Funeral bond',
            amount: $9a0b4b28118c1fc9$var$amountOf(details.funeralBondPurchase),
            chip: 'exempt within the limit'
        }
    ].filter((row)=>row.amount > 0) : [];
    const allocated = allocations.reduce((sum, row)=>sum + row.amount, 0);
    const remainder = Math.max(0, netProceeds - allocated);
    // ---- 2. What it does, against the baseline -----------------------------------------------
    const basePension = baseline?.snapshot?.pension ?? 0;
    const baseCashflow = baseline?.snapshot?.netCashflow ?? 0;
    const baseLegacy = baseline?.snapshot?.legacyValue ?? 0;
    const pension = strategy?.snapshot?.pension ?? 0;
    const cashflow = strategy?.snapshot?.netCashflow ?? 0;
    const legacy = strategy?.snapshot?.legacyValue ?? 0;
    const hasBaseline = !!baseline?.snapshot;
    /*
     * The reasons name THIS strategy's own drivers, from its own inputs — never a generic list of
     * everything that can move a pension. A cause the reader can check against the ledger above is
     * the difference between an explanation and a disclaimer.
     */ const pensionWhy = (()=>{
        if (fundFrom === 'sell_home') {
            const shelters = [
                $9a0b4b28118c1fc9$var$amountOf(details.downsizerContribution) + $9a0b4b28118c1fc9$var$amountOf(details.partnerDownsizerContribution) > 0 ? 'super' : null,
                $9a0b4b28118c1fc9$var$amountOf(details.purchaseAnnuity) > 0 ? 'an annuity (60% counted)' : null,
                $9a0b4b28118c1fc9$var$amountOf(details.funeralBondPurchase) > 0 ? 'a funeral bond' : null
            ].filter(Boolean);
            return `The home stops being an exempt asset and becomes money Centrelink counts. The entry contribution itself drops out of the assets test${shelters.length > 0 ? `, and ${shelters.join(' and ')} shelter part of the rest` : ''}${remainder > 0 ? `, but ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(remainder)} stays in the bank where it is counted and deemed` : ''}.`;
        }
        if (fundFrom === 'investment_property') return "Selling the investment property removes its rent from the income test, but turns its value into counted money \u2014 less whatever capital gains tax the sale triggers.";
        if (inputs.rentHome) return "The family home is kept, so it is counted in full once the village unit becomes the principal home \u2014 a village entry carries no two-year exemption. The rent is assessable income on top.";
        return 'Paying the entry contribution out of savings REDUCES counted assets, because money spent on the village unit is not assessed. Whatever the home does then decides the rest.';
    })();
    const cashflowWhy = (()=>{
        const parts = [];
        if (pension !== basePension) parts.push(`the Age Pension ${pension < basePension ? 'falls' : 'rises'} by ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(pension - basePension))}`);
        if ((strategy.annuityIncome ?? 0) > 0) parts.push(`the annuity pays ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(strategy.annuityIncome ?? 0)} a year for life`);
        if (inputs.rentHome) parts.push('rent comes in from the former home');
        if (fundFrom === 'sell_home' || fundFrom === 'investment_property') parts.push('the money that used to be property now earns investment income instead');
        parts.push('village fees are an ongoing cost either way');
        return `${parts.join('; ')}.`;
    })();
    const legacyWhy = `What is left after ${legacyYears} ${legacyYears === 1 ? 'year' : 'years'}, after the departure fee is taken from the entry contribution and the rest of the money has grown or been drawn on to cover any shortfall.`;
    if (!showLedger && !hasBaseline) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-3 space-y-3",
        children: [
            showLedger && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-lg border border-slate-200 bg-white p-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mb-1 text-[11px] font-semibold uppercase tracking-wide text-slate-500",
                        children: "Where the money goes"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$53af4e9987d1078a), {
                        label: "Sale of the home",
                        amount: salePrice
                    }),
                    sellingCosts > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$53af4e9987d1078a), {
                        label: "Selling costs",
                        amount: sellingCosts,
                        negative: true,
                        muted: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$53af4e9987d1078a), {
                        label: "Net proceeds",
                        amount: netProceeds,
                        bold: true,
                        divider: true
                    }),
                    allocations.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$53af4e9987d1078a), {
                            label: row.label,
                            amount: row.amount,
                            negative: true,
                            indent: true,
                            chip: row.chip,
                            chipTone: "good"
                        }, row.label)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$53af4e9987d1078a), {
                        label: "Left in the bank",
                        amount: remainder,
                        bold: true,
                        divider: true,
                        chip: remainder > 0 ? 'counted and deemed' : undefined,
                        chipTone: "warn"
                    }),
                    $9a0b4b28118c1fc9$var$amountOf(details.purchaseInvestmentProperty) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 text-xs leading-relaxed text-slate-600",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold text-slate-800",
                                children: "Investment property assumptions:"
                            }),
                            " rent of",
                            ' ',
                            (0, $0f2c0a6799fe36da$export$b037eefb915b86ec).propertyYieldPct,
                            "% of value a year (",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($9a0b4b28118c1fc9$var$amountOf(details.investmentPropertyRent)),
                            "),",
                            ' ',
                            (0, $6ee1c1106c00a64d$export$ccb8ef6339a33b59),
                            ", and growth of ",
                            (0, $0f2c0a6799fe36da$export$b037eefb915b86ec).propertyGrowthPct,
                            "% a year \u2014 the tool's standard assumptions.",
                            ' ',
                            $9a0b4b28118c1fc9$var$amountOf(details.investmentPropertyStampDuty) > 0 ? `Stamp duty of ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)($9a0b4b28118c1fc9$var$amountOf(details.investmentPropertyStampDuty))}${details.investmentPropertyState ? ` (${details.investmentPropertyState} scale, no concessions)` : ''} comes out of the proceeds and sits in the property's cost base.` : "Stamp duty on the purchase is not modelled \u2014 no state was chosen for the purchase."
                        ]
                    })
                ]
            }),
            hasBaseline && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-lg border border-slate-200 bg-white p-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mb-1 text-[11px] font-semibold uppercase tracking-wide text-slate-500",
                        children: "Against staying in your current home"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$e95813558e26ce51), {
                        label: "Age Pension",
                        before: basePension,
                        after: pension,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-xs text-slate-500",
                            children: "a year"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "-mt-1 mb-1 text-xs leading-relaxed text-slate-600",
                        children: pensionWhy
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$e95813558e26ce51), {
                        label: "Cashflow (year 1)",
                        before: baseCashflow,
                        after: cashflow
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "-mt-1 mb-1 text-xs leading-relaxed text-slate-600",
                        children: cashflowWhy
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$e95813558e26ce51), {
                        label: `Estate (year ${legacyYears})`,
                        before: baseLegacy,
                        after: legacy,
                        suffix: ""
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "-mt-1 text-xs leading-relaxed text-slate-600",
                        children: legacyWhy
                    })
                ]
            })
        ]
    });
};
var $9a0b4b28118c1fc9$export$2e2bcd8739ae039 = $9a0b4b28118c1fc9$var$RvStrategyExplainer;


/**
 * The village plan in one sentence — the SAME sentence on the plan summary rail (Manual Control)
 * and on every Suggestion Engine card, so the two surfaces cannot describe a plan differently.
 *
 * Built ONLY from figures already on the screen beside it, subtracted exactly as the tiles subtract
 * them. The village difference from Aged Care is what leads: the entry contribution has to be paid
 * in full and its FUNDING is the decision, so where the money comes from leads where the DAP leads
 * there. Everything is measured against STAYING PUT — the only honest benchmark for an elective
 * move (owner, 24 Sep 2026).
 *
 * TWO THINGS IT MUST NEVER LEAVE OUT (owner, 24 Sep 2026):
 *   - a sale that does not cover the contribution: "paid in full from selling the investment
 *     property" on $651,966 of proceeds against an $800,000 contribution was simply false. The
 *     sentence now says what the sale paid and what savings paid.
 *   - a lifetime annuity with nothing returned on death: the estate is worse off BECAUSE the
 *     capital is gone, and a summary that blamed growth and fees while never mentioning it ("a
 *     load of bullox … you're going to get me sued if a client pleads ignorance") is not a summary.
 */ 
parcelRequire("acw62");


const $7ed3a1547818f47b$var$SOURCE = {
    sell_home: 'selling the family home',
    investment_property: 'selling the investment property'
};
function $7ed3a1547818f47b$export$22a630b2ac5006f5(a) {
    return `the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(a.amount)} lifetime annuity returns nothing when ${a.ownerName} ${a.ownerName === 'you' ? 'die' : 'dies'} \u{2014} that money leaves the estate the day it is bought`;
}
function $7ed3a1547818f47b$export$358299c3c19123ce(i) {
    const shortfall = Math.round(i.shortfall ?? 0);
    if (shortfall > 0) return [
        {
            tone: 'bad',
            text: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(shortfall)} of the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(i.entryFee)} entry contribution still has to come ` + `from somewhere \u{2014} a village contribution has to be paid in full, so this is not yet a move that can go ahead. ` + `The figures below assume it is funded`
        }
    ];
    const clauses = [];
    if (i.entryFee > 0) {
        const source = $7ed3a1547818f47b$var$SOURCE[i.fundFrom];
        const fromSale = Math.round(i.fromSaleAmount ?? 0);
        const fromSavings = Math.round(i.fromSavingsAmount ?? 0);
        const kept = i.rentHome ? ', with the family home kept and rented out' : '';
        if (source && fromSavings > 0) clauses.push((0, $77fab72f16be36e5$export$b3ed29c9fd98e367)(`the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(i.entryFee)} entry contribution is paid in full: ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(fromSale)} from ${source} and ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(fromSavings)} from savings${kept}`));
        else clauses.push((0, $77fab72f16be36e5$export$b3ed29c9fd98e367)(`the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(i.entryFee)} entry contribution is paid in full from ${source ?? 'savings'}${kept}`));
    }
    if (i.annuity && i.annuity.amount > 0 && Math.round(i.annuity.residualPercent) === 0) clauses.push({
        tone: 'bad',
        text: $7ed3a1547818f47b$export$22a630b2ac5006f5(i.annuity)
    });
    clauses.push((0, $77fab72f16be36e5$export$188f8646230c48f)(i.pensionAfter - i.pensionBefore));
    const cashflowDelta = i.cashAfter - i.cashBefore;
    if (Math.round(cashflowDelta) !== 0) clauses.push((0, $77fab72f16be36e5$export$32179680de3fc4e3)(cashflowDelta, i.cashAfter));
    if (i.planLegacy != null && i.baseLegacy != null) {
        const legacyDelta = i.planLegacy - i.baseLegacy;
        // "ahead of staying put" — this module's baseline is named, which is clearer than "ahead".
        const e = (0, $77fab72f16be36e5$export$ca3c952791480bf6)(legacyDelta, Number(i.legacyYears) || 0);
        clauses.push(Math.round(legacyDelta) === 0 ? e : {
            ...e,
            text: e.text.replace(' ahead after', ' ahead of staying put after').replace(' behind after', ' behind staying put after')
        });
    }
    return clauses;
}
function $7ed3a1547818f47b$export$baf7acd040ea3369(props) {
    const clauses = $7ed3a1547818f47b$export$358299c3c19123ce(props);
    if (!clauses.length) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77fab72f16be36e5$export$f24d825672d9bf01), {
        clauses: clauses
    });
}



function $4852c06b0c4c15b4$export$6d4129e74a169c1e(strategy, factFind) {
    const terms = strategy.annuityTerms;
    const amount = Number(terms?.purchaseAmount) || 0;
    if (!(amount > 0)) return null;
    const owner = terms?.owner === 'partner' ? 'partner' : 'client';
    const ownerName = (owner === 'partner' ? factFind?.partner?.firstName : factFind?.client?.firstName) || 'you';
    return {
        amount: amount,
        residualPercent: Number(terms?.residualPercent) || 0,
        ownerName: ownerName
    };
}
function $4852c06b0c4c15b4$export$ee2616655543b3d(strategy, factFind) {
    const terms = strategy.annuityTerms;
    if (!(Number(terms?.purchaseAmount) > 0)) return null;
    const flag = (0, $3d096644ffaac9d7$export$2a10947020c112ea)({
        factFind: factFind,
        residualCapital: (Number(terms?.residualPercent) || 0) / 100,
        owner: terms?.owner
    });
    return flag?.warning ?? null;
}
function $4852c06b0c4c15b4$export$7a83655e7acf7684(strategy, factFind) {
    const inputs = strategy.inputs || {};
    const sale = inputs.sellHomeDetails;
    const duty = Number(inputs.investmentPropertyStampDuty) || (Number(sale?.purchaseInvestmentProperty) > 0 ? Number(sale?.investmentPropertyStampDuty) || 0 : 0);
    return {
        horizonWarning: $4852c06b0c4c15b4$export$ee2616655543b3d(strategy, factFind),
        stampDuty: duty > 0 ? duty : null
    };
}
/** The line under a tile: staying put's figure and the change, coloured by whether the move is good. */ const $4852c06b0c4c15b4$var$StayingPut = ({ value: value, baseline: baseline, upIsGood: upIsGood })=>{
    if (baseline == null) return null;
    const d = value - baseline;
    const flat = Math.round(d) === 0;
    const good = upIsGood ? d > 0 : d < 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        className: "mt-1 text-[13px] tabular-nums text-slate-500",
        children: [
            "staying put ",
            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(baseline),
            " \xb7",
            ' ',
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: `font-semibold ${flat ? 'text-slate-400' : good ? 'text-emerald-700' : 'text-rose-700'}`,
                children: flat ? 'no change' : `${d > 0 ? '+' : "\u2212"}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(d))}`
            })
        ]
    });
};
const $4852c06b0c4c15b4$var$Tile = ({ label: label, value: value, tone: tone, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[11px] font-semibold uppercase tracking-wide text-slate-500",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: `mt-1 text-[20px] font-bold leading-none tabular-nums ${tone === 'good' ? 'text-emerald-700' : tone === 'bad' ? 'text-rose-700' : 'text-slate-900'}`,
                children: value
            }),
            children
        ]
    });
const $4852c06b0c4c15b4$var$RvStrategyCard = ({ strategy: strategy, factFind: factFind, badges: badges, belowBaseline: belowBaseline, tradeOffNote: tradeOffNote, baseline: baseline, entryFee: entryFee, legacyYears: legacyYears, clientName: clientName, partnerName: partnerName, isSelected: isSelected, onSelect: onSelect, onExplain: onExplain, onRisks: onRisks, onGenerateSoa: onGenerateSoa, alternative: alternative = null, annuityBlock: annuityBlock, goalNote: goalNote = null, detailOnly: detailOnly = false })=>{
    const snap = strategy.snapshot || {};
    const base = baseline?.snapshot || {};
    const inputs = strategy.inputs || {};
    const fundFrom = String(inputs.fundFrom || 'liquid');
    const rentHome = !!inputs.rentHome || fundFrom === 'rent_home';
    const rows = strategy.projections || [];
    const planLegacy = snap.legacyValue ?? (rows.length ? (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(rows[Math.min(rows.length, Number(legacyYears) || rows.length) - 1]) : null);
    // The engine's own funding rows: on a property route the first is the sale, the second (if any)
    // is what savings paid — so the sentence and the "How it's funded" box say the same thing.
    const funding = strategy.fundingBreakdown || [];
    const isPropertyRoute = fundFrom === 'sell_home' || fundFrom === 'investment_property';
    const fromSale = isPropertyRoute ? Number(funding[0]?.amount) || 0 : null;
    const fromSavings = isPropertyRoute ? funding.filter((f)=>/savings/i.test(f.label)).reduce((s, f)=>s + (Number(f.amount) || 0), 0) : null;
    // Moving from another village: the current unit's payout is the first source (8 Oct 2026).
    const fromOldUnit = funding.filter((f)=>/current village unit/i.test(f.label)).reduce((s, f)=>s + (Number(f.amount) || 0), 0);
    const annuity = $4852c06b0c4c15b4$export$6d4129e74a169c1e(strategy, factFind);
    const nilResidual = annuity && Math.round(annuity.residualPercent) === 0 ? annuity : null;
    const horizonWarning = $4852c06b0c4c15b4$export$ee2616655543b3d(strategy, factFind);
    const flow = [];
    if (fundFrom === 'sell_home') flow.push({
        amount: Number(inputs.sellHomeDetails?.salePrice) || 0,
        label: 'home sold',
        sub: 'proceeds fund the move',
        tone: 'sold'
    });
    else if (fundFrom === 'investment_property') flow.push({
        amount: fromSale || entryFee,
        label: 'property sold',
        sub: 'net proceeds, after costs and CGT',
        tone: 'sold'
    });
    flow.push({
        amount: entryFee,
        label: 'entry contribution',
        sub: fromOldUnit > 0 ? `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(fromOldUnit)} of it from the current unit's payout, the rest from savings \xb7 refundable less the departure fee` : fromSavings && fromSavings > 0 ? `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(fromSavings)} of it from savings \xb7 refundable less the departure fee` : fundFrom === 'liquid' || fundFrom === 'rent_home' ? "from savings \xb7 refundable less the departure fee" : 'refundable less the departure fee',
        tone: 'good'
    });
    if (rentHome) flow.push({
        amount: (Number(inputs.rentDetails?.rentAmount) || 0) * 52,
        label: 'home kept, rented out',
        sub: 'rent a year, assessable',
        tone: 'good'
    });
    if (nilResidual) flow.push({
        amount: nilResidual.amount,
        label: 'lifetime annuity',
        sub: 'nothing returned on death',
        tone: 'warn'
    });
    const what = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$28c8139bd562d0e), {
        eyebrow: "What this strategy does",
        className: detailOnly ? '' : 'mt-3',
        children: [
            goalNote && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mb-2.5 rounded-lg border-l-4 border-blue-400 bg-white py-2 pl-3 pr-2 text-[13px] leading-relaxed text-blue-900",
                children: goalNote
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$9c139f18dfc312b8), {
                steps: flow.filter((s)=>s.amount > 0)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2.5 text-[13px] leading-relaxed text-slate-700",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed3a1547818f47b$export$baf7acd040ea3369), {
                    entryFee: entryFee,
                    fundFrom: fundFrom,
                    rentHome: rentHome,
                    fromSaleAmount: fromSale,
                    fromSavingsAmount: fromSavings,
                    pensionBefore: Number(base.pension) || 0,
                    pensionAfter: Number(snap.pension) || 0,
                    cashBefore: Number(base.netCashflow) || 0,
                    cashAfter: Number(snap.netCashflow) || 0,
                    planLegacy: planLegacy,
                    baseLegacy: base.legacyValue ?? null,
                    legacyYears: legacyYears,
                    annuity: annuity
                })
            }),
            (nilResidual || horizonWarning) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-2.5 rounded-lg border border-slate-200 border-l-4 border-l-amber-400 bg-white py-2 pl-3 pr-2 text-[13px] leading-relaxed text-slate-700",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold",
                        children: "Worth knowing:"
                    }),
                    ' ',
                    nilResidual && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "The estate ends behind staying put mainly because ",
                            (0, $7ed3a1547818f47b$export$22a630b2ac5006f5)(nilResidual),
                            ". The income is guaranteed for life; the capital is not coming back.",
                            ' '
                        ]
                    }),
                    horizonWarning
                ]
            }),
            alternative && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-2.5 rounded-lg border-l-4 border-blue-400 bg-white py-2 pl-3 pr-2 text-[13px] leading-relaxed text-blue-900",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold",
                        children: alternative.question
                    }),
                    " ",
                    alternative.answer
                ]
            }),
            funding.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 rounded-lg border border-slate-200 bg-slate-50 p-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[11px] font-semibold text-slate-500 uppercase tracking-wide mb-1",
                        children: "How it's funded"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        className: "text-sm text-slate-700 space-y-0.5",
                        children: funding.map((f, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                className: "flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: f.label
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-medium tabular-nums",
                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(f.amount)
                                    })
                                ]
                            }, i))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a0b4b28118c1fc9$export$2e2bcd8739ae039), {
                strategy: strategy,
                baseline: baseline ?? null,
                entryFee: entryFee,
                legacyYears: legacyYears,
                clientName: clientName,
                partnerName: partnerName,
                clientUnderPensionAge: !!factFind?.client?.dob && ((0, $5589d9476399db47$export$8ada184d5eef4694)(String(factFind?.client?.dob)) ?? 999) < (0, $1abe73eeef086faf$export$5b6998cba7880742),
                partnerUnderPensionAge: factFind?.adviceFor === 'couple' && !!factFind?.partner?.dob && ((0, $5589d9476399db47$export$8ada184d5eef4694)(String(factFind?.partner?.dob)) ?? 999) < (0, $1abe73eeef086faf$export$5b6998cba7880742)
            }),
            annuityBlock
        ]
    });
    if (detailOnly) return what;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `rounded-xl border border-l-4 p-4 shadow-sm transition-all ${isSelected ? 'border-blue-500 border-l-blue-600 bg-blue-50/40 ring-1 ring-blue-200' : belowBaseline ? 'border-slate-200 border-l-slate-400 bg-white' : 'border-slate-200 border-l-blue-500 bg-white'}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-wrap items-center gap-2 mb-1.5",
                children: badges.map((b)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d137e5221e5cfba5$export$2e2bcd8739ae039), {
                        tone: belowBaseline ? 'neutral' : 'info',
                        children: b
                    }, b))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                className: "text-lg font-semibold text-gray-900",
                children: strategy.name
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-sm text-gray-600 mt-1",
                children: strategy.description
            }),
            belowBaseline && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-1.5 rounded-lg border border-slate-200/70 border-l-4 border-l-amber-500 bg-white px-3 py-2 text-xs leading-relaxed text-slate-700",
                children: belowBaseline
            }),
            tradeOffNote && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-1.5 rounded-lg border border-slate-200/70 border-l-4 border-l-blue-500 bg-white px-3 py-2 text-[13px] leading-relaxed text-slate-700",
                "data-testid": "trade-off-note",
                children: tradeOffNote
            }),
            what,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 gap-3 mt-3 sm:grid-cols-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4852c06b0c4c15b4$var$Tile, {
                        label: "Age Pension",
                        value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(snap.pension) || 0),
                        tone: "neutral",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4852c06b0c4c15b4$var$StayingPut, {
                            value: Number(snap.pension) || 0,
                            baseline: base.pension,
                            upIsGood: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4852c06b0c4c15b4$var$Tile, {
                        label: "Cashflow (year 1)",
                        value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(snap.netCashflow) || 0),
                        tone: (Number(snap.netCashflow) || 0) < 0 ? 'bad' : 'good',
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4852c06b0c4c15b4$var$StayingPut, {
                            value: Number(snap.netCashflow) || 0,
                            baseline: base.netCashflow,
                            upIsGood: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4852c06b0c4c15b4$var$Tile, {
                        label: `Estate (year ${legacyYears})`,
                        value: planLegacy != null ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(planLegacy) : "\u2014",
                        tone: "neutral",
                        children: planLegacy != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4852c06b0c4c15b4$var$StayingPut, {
                            value: planLegacy,
                            baseline: base.legacyValue,
                            upIsGood: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-4 flex gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        onClick: onExplain,
                        variant: "secondary",
                        size: "sm",
                        icon: (0, $e1cfd183b457f6f1$export$2e2bcd8739ae039),
                        className: "flex-1",
                        children: "Explain this"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        onClick: onRisks,
                        variant: "secondary",
                        size: "sm",
                        icon: (0, $4666dd9ae485baaf$export$2e2bcd8739ae039),
                        className: "flex-1",
                        children: "What could go wrong"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        onClick: onSelect,
                        variant: "primary",
                        size: "sm",
                        icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
                        className: "flex-1",
                        children: isSelected ? "Selected \u2713" : 'Select Strategy'
                    })
                ]
            }),
            isSelected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 rounded-lg border border-slate-200/70 border-l-4 border-l-emerald-500 bg-white px-3 py-2 text-sm text-emerald-900 shadow-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "min-w-0 flex-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-semibold",
                                children: "This is your selected strategy."
                            }),
                            " It is saved with your file, and the advice document is written from it."
                        ]
                    }),
                    onGenerateSoa && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onGenerateSoa,
                        className: "inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-blue-600 px-3 py-1.5 text-xs font-semibold text-white transition hover:bg-blue-700",
                        children: "Generate your Statement of Advice \u2192"
                    })
                ]
            })
        ]
    });
};
var $4852c06b0c4c15b4$export$2e2bcd8739ae039 = $4852c06b0c4c15b4$var$RvStrategyCard;





/**
 * "PREFER SHARES TO PROPERTY?" — the one line a card carries when the same plan exists with the money
 * in the other kind of asset (owner, 2 Oct 2026).
 *
 * The engines model both: "sell the home and buy an investment property" and "sell the home and
 * invest in shares / managed funds" are separate candidates, scored on the same figures, and one of
 * them wins. Rather than claim they "come out about the same" — which is not always true: a property
 * pays stamp duty on day one and its rent is counted, shares are deemed — the card says the actual
 * gap, from the engine's own estate figures, and leaves the choice with the client. Only within a
 * small band does it say "about the same", because then it is.
 *
 * Pairs are found by candidate id, so a module need only name its ids here.
 */ const $835055d548f621e0$var$PAIRS = [
    [
        /-abp-ip(-clear-debt)?$/,
        '-abp-invest$1'
    ],
    [
        /-abp-invest(-clear-debt)?$/,
        '-abp-ip$1'
    ],
    [
        /^dz-(rent-)?invest-property(-clear-debt)?$/,
        'dz-$1invest$2'
    ],
    [
        /^dz-(rent-)?invest(-clear-debt)?$/,
        'dz-$1invest-property$2'
    ],
    [
        /-sell-home-property(-clear-debt)?$/,
        '-sell-home-invest$1'
    ],
    [
        /-sell-home-invest(-clear-debt)?$/,
        '-sell-home-property$1'
    ],
    [
        /^gf-sell-property(-clear-debt)?$/,
        'gf-sell-invest$1'
    ],
    [
        /^gf-sell-invest(-clear-debt)?$/,
        'gf-sell-property$1'
    ]
];
const $835055d548f621e0$var$isProperty = (id)=>/-abp-ip(-clear-debt)?$|invest-property|sell-home-property|gf-sell-property/.test(id);
function $835055d548f621e0$export$aa1106e43d23bb86(id) {
    for (const [re, to] of $835055d548f621e0$var$PAIRS){
        if (re.test(id)) return id.replace(re, to);
    }
    return null;
}
function $835055d548f621e0$export$8096a1e5a8250ea8(strategy, all, estateOf, years) {
    const id = String(strategy.id || '');
    const twinId = $835055d548f621e0$export$aa1106e43d23bb86(id);
    if (!twinId) return null;
    const twin = all.find((s)=>String(s.id || '') === twinId);
    if (!twin) return null;
    const mine = estateOf(strategy);
    const theirs = estateOf(twin);
    if (mine == null || theirs == null || !Number.isFinite(mine) || !Number.isFinite(theirs)) return null;
    const property = $835055d548f621e0$var$isProperty(id);
    const question = property ? 'Prefer shares or managed funds to property?' : 'Prefer property to shares?';
    const other = property ? 'with the money in shares or managed funds instead' : 'buying an investment property instead';
    const gap = theirs - mine;
    const band = Math.max(10000, Math.abs(mine) * 0.01);
    const money = `$${Math.round(Math.abs(gap)).toLocaleString('en-AU')}`;
    const horizon = `on the estate after ${years} years`;
    const answer = Math.abs(gap) <= band ? `The same plan ${other} comes out about the same ${horizon}. Pick whichever you're more comfortable holding.` : gap < 0 ? `The same plan ${other} comes out about ${money} behind ${horizon}. Pick whichever you're more comfortable holding.` : `The same plan ${other} comes out about ${money} ahead ${horizon}. It won a different goal, which is why it isn't this card.`;
    return {
        question: question,
        answer: answer
    };
}


/**
 * The retirement village Statement of Advice: the page's own figures, in the shared document's shape
 * (features/advice/moduleSoa.ts). Nothing is recomputed — the strategy's snapshot and projections,
 * the staying-put candidate's, the village cost summary and the plan pieces are quoted as the screen
 * shows them, so the document and the card can never disagree.
 */ 











/**
 * THE GUARANTEED INCOME ON A VILLAGE PLAN (owner, 21 Oct 2026 — the guaranteed income review E4/E5/M4 and the
 * agreed mock-up, docs/ux-review/annuities/ screens 3, 4 and 6).
 *
 * One reading of a tested plan's guaranteed income, shared by the plan cards (RvPlansView), "Every way we
 * tested", the chosen-plan page (RvHub) and the advice document (rvSoa.ts):
 *   - what it is: the amount, the type (what the family receives) and whose it is;
 *   - the plan to compare it with: the same sale with the money invested instead (`rv-sell-home-invest`, or
 *     the same super top-up's twin), so the family table's last column is the guaranteed income alone;
 *   - whether choosing it is held: income only needs the client's dated confirmation for that amount.
 */ 


function $91a0ac81d8d23067$export$32b560717abe61e8(row, factFind) {
    if (!row) return null;
    const terms = row.annuityTerms || null;
    const details = row.inputs?.sellHomeDetails || {};
    const amount = Number(terms?.purchaseAmount ?? details.purchaseAnnuity) || 0;
    if (!(amount > 0)) return null;
    const annuityType = String(terms?.annuityType ?? details.rvAnnuityType ?? 'lifetime');
    if (annuityType === 'fixedTerm') return null;
    const residualPercent = Number(terms?.residualPercent ?? details.rvAnnuityResidualPercent) || 0;
    const owner = String(terms?.owner ?? details.rvAnnuityOwner ?? 'client');
    const client = factFind?.client?.firstName || 'you';
    const partner = factFind?.adviceFor === 'couple' ? factFind?.partner?.firstName || 'your partner' : null;
    const personName = owner === 'partner' && partner ? partner : owner === 'joint' && partner ? `${client} and ${partner}` : client;
    const income = Number(row.annuityIncome);
    return {
        amount: amount,
        kind: (0, $8665f80549f60a1b$export$3ab75b1250c8af22)({
            annuityType: annuityType,
            annuityResidualPercent: residualPercent
        }),
        annuityType: annuityType,
        residualPercent: residualPercent,
        personName: personName,
        incomeAYear: Number.isFinite(income) && income > 0 ? income : null
    };
}
function $91a0ac81d8d23067$export$c241e21d61e3872b(row, strategies) {
    const id = String(row?.id || '');
    const debt = /-clear-debt$/.test(id) ? '-clear-debt' : '';
    const bare = id.replace(/-clear-debt$/, '');
    const pick = (target, note)=>{
        const found = strategies.find((s)=>String(s.id) === `${target}${debt}`);
        return found ? {
            row: found,
            note: note
        } : null;
    };
    if (/^rv-sell-home-annuity/.test(bare)) return pick('rv-sell-home-invest', 'the same sale, with the money invested instead');
    if (bare === 'rv-sell-home-downsizer-abp-annuity') return pick('rv-sell-home-downsizer-abp-invest', 'the same sale, with the money invested instead');
    if (bare === 'rv-sell-home-downsizer-annuity') return pick('rv-sell-home-downsizer', 'the same sale and super top-up, with the money left in the bank instead');
    return null;
}
function $91a0ac81d8d23067$export$e9940ef619b461f8(gi, factFind, rows, compare, horizonYears) {
    if (!gi) return null;
    const built = (0, $66827b1304244a1d$export$11aaa304d9182b)({
        factFind: factFind,
        personName: gi.personName,
        amount: gi.amount,
        kind: gi.kind,
        incomeAYear: gi.incomeAYear,
        rows: rows,
        compareRows: compare?.rows ?? null,
        compareNote: compare?.note ?? null,
        horizonYears: horizonYears,
        plan: {
            estate: 0,
            pension: 0,
            cashflow: 0
        }
    });
    return built ? {
        personName: gi.personName,
        amount: gi.amount,
        kind: gi.kind,
        incomeAYear: gi.incomeAYear,
        compareNote: built.compareNote,
        rows: built.rows
    } : null;
}
function $91a0ac81d8d23067$export$b263a858888cc4a2(row, factFind) {
    const gi = $91a0ac81d8d23067$export$32b560717abe61e8(row, factFind);
    return !!gi && gi.kind === 'incomeOnly' && (0, $5eae79c7e46ed27e$export$655f124668ce439a)(factFind, true, gi.amount);
}



/**
 * A tested village plan in everyday words — the card's title and the line under it (village rebuild,
 * the agreed mock-up's plans screen, owner 20–21 Oct 2026).
 *
 * The engine's names ("Sell your home, start a super pension and invest the rest") were written for an
 * adviser's list. The card says what happens to the home, where the entry payment comes from, and where
 * what is left goes — with the amounts and the accounts' own names ("the ANZ account, the MLC and Hub24
 * pensions"), from the candidate's inputs. Presentation only: nothing here is computed beyond sums.
 */ 

/**
 * WHERE "INVESTED" MONEY GOES, in the card's words (owner, 23 Oct 2026: "invest what is left — invest in what
 * exactly?", then: not "shares", an asset class of its own and growth, but a portfolio of managed funds at the
 * client's risk profile). A plan's invested money is priced on the client's answer to "how would money that is
 * freed up be invested?" (newMoneyProfileOf); with no answer the cautious Conservative mix is assumed, and the
 * words say so.
 *
 * The profiles are held as returns only (investmentProfiles.ts), not as asset splits, so each mix is described
 * in words, never in percentages the figures do not model.
 */ 
const $5fe2dfde2f334213$export$628f0722e98ae499 = {
    conservative: 'mostly cash and fixed interest, with a smaller part in shares and property, for steadier returns',
    moderately_conservative: 'more in cash and fixed interest than in shares and property',
    balanced: 'shares and property, and cash and fixed interest, in roughly even measure',
    growth: 'mostly shares and property, with some cash and fixed interest',
    high_growth: 'shares and property only, for the most growth and the biggest ups and downs'
};
/** The card's marker: the phrase investedWhereWords always contains, read by plansInvest. */ const $5fe2dfde2f334213$var$MARKER = 'portfolio of managed funds';
function $5fe2dfde2f334213$export$445db77df4ca8114(factFind) {
    const mix = (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[(0, $0f2c0a6799fe36da$export$580cfd0c6323bf7e)(factFind)].label.toLowerCase();
    return `in a ${mix} ${$5fe2dfde2f334213$var$MARKER}${(0, $0f2c0a6799fe36da$export$848647f164f42923)(factFind) ? '' : ' (assumed, as no investment choice was given)'}`;
}
function $5fe2dfde2f334213$export$4abd1e21404204e(cardSentence) {
    return String(cardSentence || '').includes($5fe2dfde2f334213$var$MARKER);
}
function $5fe2dfde2f334213$export$e8f6b2b9eb3eb02b(factFind) {
    const id = (0, $0f2c0a6799fe36da$export$580cfd0c6323bf7e)(factFind);
    const mix = (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[id].label.toLowerCase();
    return [
        `The plan assumes a ${mix} portfolio: ${$5fe2dfde2f334213$export$628f0722e98ae499[id]}.${(0, $0f2c0a6799fe36da$export$848647f164f42923)(factFind) ? '' : ' No investment choice is on the file, so the cautious mix is assumed; choosing one in step 3 changes the figures.'}`,
        "It is usually held as a diversified managed fund or a managed portfolio, set up through a financial adviser or an investment platform, including online (digital) portfolios. Fees differ between providers, and returns go up and down: the figures use the mix\u2019s long-run returns, which are not guaranteed."
    ];
}


const $7175ce4c598409db$var$num = (v)=>Number(v) || 0;
const $7175ce4c598409db$var$joinAnd = (xs)=>xs.length <= 1 ? xs[0] || '' : `${xs.slice(0, -1).join(', ')} and ${xs[xs.length - 1]}`;
const $7175ce4c598409db$var$KIND_WORDS = {
    bankAccounts: {
        one: 'account',
        many: 'accounts',
        plain: 'the bank account'
    },
    termDeposits: {
        one: 'term deposit',
        many: 'term deposits',
        plain: 'the term deposit'
    },
    accountBasedPensions: {
        one: 'pension',
        many: 'pensions',
        plain: 'the account-based pension'
    },
    shares: {
        one: 'shares',
        many: 'shares',
        plain: 'the shares'
    }
};
function $7175ce4c598409db$export$38a5317f7bc5870c(funding, factFind) {
    if (!funding) return '';
    const assets = factFind?.assets || {};
    const groups = [];
    for (const kind of [
        'bankAccounts',
        'termDeposits',
        'accountBasedPensions',
        'shares'
    ]){
        const names = [];
        let unnamed = 0;
        for (const [key, amount] of Object.entries(funding)){
            if (!($7175ce4c598409db$var$num(amount) > 0) || !key.startsWith(`${kind}-`)) continue;
            const id = key.slice(kind.length + 1);
            const asset = (assets[kind] || []).find((a)=>String(a?.id) === id);
            const desc = String(asset?.description || '').trim();
            if (desc && kind !== 'shares') names.push(desc);
            else unnamed += 1;
        }
        if (!names.length && !unnamed) continue;
        const w = $7175ce4c598409db$var$KIND_WORDS[kind];
        if (kind === 'shares') {
            groups.push('the shares');
            continue;
        }
        if (!names.length) {
            groups.push(unnamed > 1 ? `the ${w.many}` : w.plain);
            continue;
        }
        const list = names.length === 1 ? names[0] : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
        groups.push(`the ${list} ${names.length + unnamed > 1 ? w.many : w.one}`);
    }
    if (groups.length <= 1) return groups[0] || '';
    return `${groups.slice(0, -1).join(', ')} and ${groups[groups.length - 1]}`;
}
function $7175ce4c598409db$export$260d1042b8a534f2(funding, factFind, what = 'the entry payment') {
    if (!funding) return '';
    const assets = factFind?.assets || {};
    const parts = [];
    for (const [key, amount] of Object.entries(funding)){
        if (!($7175ce4c598409db$var$num(amount) > 0)) continue;
        const kind = Object.keys($7175ce4c598409db$var$KIND_WORDS).find((k)=>key.startsWith(`${k}-`));
        if (!kind) continue;
        const asset = (assets[kind] || []).find((a)=>String(a?.id) === key.slice(kind.length + 1));
        const desc = String(asset?.description || '').trim();
        const name = kind === 'shares' || !desc ? $7175ce4c598409db$var$KIND_WORDS[kind].plain : `the ${desc} ${$7175ce4c598409db$var$KIND_WORDS[kind].one}`;
        parts.push(`${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round($7175ce4c598409db$var$num(amount)))} from ${name}`);
    }
    if (!parts.length) return '';
    const [first, ...rest] = parts;
    const lead = first.replace(/ from /, ` of ${what} comes from `);
    return rest.length ? `${lead}, ${$7175ce4c598409db$var$joinAnd(rest)}` : lead;
}
/** What a sale's leftover is put to, as short phrases in the order the card says them. */ function $7175ce4c598409db$var$usesOf(d, factFind) {
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const clientName = factFind?.client?.firstName || 'you';
    const partnerName = factFind?.partner?.firstName || 'your partner';
    const pension = d.commenceIncomeStream === true;
    const ds = $7175ce4c598409db$var$num(d.downsizerContribution);
    const pds = $7175ce4c598409db$var$num(d.partnerDownsizerContribution);
    const short = [];
    const long = [];
    if (ds + pds > 0) {
        short.push(`move ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(ds + pds)} into super${pension ? ' pensions' : ''}`);
        const into = ds > 0 && pds > 0 ? `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(ds)} into ${clientName}'s super and ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pds)} into ${partnerName}'s, each as a downsizer contribution` : `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(ds + pds)} into ${ds > 0 ? clientName : partnerName}'s super as a downsizer contribution`;
        long.push(`${into}${pension ? ' drawn as a pension' : ' left to grow in super'}`);
    }
    const annuity = $7175ce4c598409db$var$num(d.purchaseAnnuity);
    if (annuity > 0) {
        // Each type said by what the family receives (guaranteed income review, 21 Oct 2026); no product named.
        const back = String(d.rvAnnuityType) === 'guaranteed' ? 'that pays the full amount back to the family at any time' : $7175ce4c598409db$var$num(d.rvAnnuityResidualPercent) > 0 ? 'that pays the money back to the family in the early years' : 'that pays the most income, with nothing back to the family';
        short.push(`put ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(annuity)} into a guaranteed income`);
        long.push(`${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(annuity)} into a guaranteed income for life ${back}`);
    }
    const ip = $7175ce4c598409db$var$num(d.purchaseInvestmentProperty);
    if (ip > 0) {
        short.push('buy an investment property');
        long.push(`${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(ip)} on an investment property${$7175ce4c598409db$var$num(d.investmentPropertyRent) > 0 ? `, rented for about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)($7175ce4c598409db$var$num(d.investmentPropertyRent))} a year` : ''}`);
    }
    const gift = $7175ce4c598409db$var$num(d.giftingAmount);
    if (gift > 0) {
        short.push(`give ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(gift)} to family`);
        long.push(`${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(gift)} given to family`);
    }
    const bond = $7175ce4c598409db$var$num(d.funeralBondPurchase);
    if (bond > 0) {
        short.push('put some in a funeral bond');
        long.push(`${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(bond)} into a funeral bond`);
    }
    const shares = $7175ce4c598409db$var$num(d.purchaseShares);
    if (shares > 0) {
        short.push(short.length ? 'invest the rest' : 'invest what is left');
        long.push(`${short.length > 1 ? 'the other ' : ''}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(shares)} invested ${(0, $5fe2dfde2f334213$export$445db77df4ca8114)(factFind)}${v.couple ? `, in ${v.you ? 'your' : 'their'} joint names` : ''}`);
    }
    return {
        short: short,
        long: long
    };
}
function $7175ce4c598409db$export$6078d665f40b52df(row, factFind, entryFee) {
    const inputs = row.inputs || {};
    const id = String(row.id || '');
    const fee = (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(entryFee));
    const fundFrom = String(inputs.fundFrom || 'liquid');
    const debts = /-clear-debt$/.test(id) ? ' Your debts are cleared at the same time.' : '';
    const debtsTitle = /-clear-debt$/.test(id) ? ', and clear the debts' : '';
    const funding = inputs.entryFeeFundingOverride || null;
    const fromOldUnit = (row.fundingBreakdown || []).filter((f)=>/current village unit/i.test(f.label)).reduce((s, f)=>s + $7175ce4c598409db$var$num(f.amount), 0);
    const oldUnitWords = fromOldUnit > 0 ? ` ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(fromOldUnit)} of it is the payout from the current village unit.` : '';
    const drawn = $7175ce4c598409db$export$260d1042b8a534f2(funding, factFind);
    const hasHome = $7175ce4c598409db$var$num(factFind?.home?.value) > 0;
    if (fundFrom === 'liquid') {
        const rented = inputs.rentHome === true;
        const rent = $7175ce4c598409db$var$num(inputs.rentDetails?.rentAmount);
        const title = rented ? `Keep the home and rent it out; pay the ${fee} from savings and investments${debtsTitle}` : hasHome ? `Keep the home as it is; pay the ${fee} from savings and investments${debtsTitle}` : `Pay the ${fee} from savings and investments${debtsTitle}`;
        const sub = `${drawn ? `${drawn.replace(/^./, (c)=>c.toUpperCase())}.` : 'The entry payment comes from savings.'}${oldUnitWords}${rented && rent > 0 ? ` The home is let at ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(rent))} a week, after the weeks it sits empty.` : ''}${debts}`;
        return {
            title: title,
            sub: sub.trim()
        };
    }
    if (fundFrom === 'investment_property') {
        const props = factFind?.assets?.investmentProperty || [];
        const sel = inputs.investmentPropertyDetails?.selectedPropertyId;
        const p = props.find((x)=>String(x?.id) === String(sel)) || props[0];
        const what = String(p?.description || p?.address || '').trim();
        return {
            title: `Sell the investment property${what ? ` (${what})` : ''} to pay the ${fee}${debtsTitle}`,
            sub: `The sale pays the entry payment, after selling costs and capital gains tax.${hasHome ? ' The home is kept as it is.' : ''}${oldUnitWords}${debts}`.trim()
        };
    }
    // Selling the home.
    const d = inputs.sellHomeDetails || {};
    const left = Math.max(0, $7175ce4c598409db$var$num(d.salePrice) - $7175ce4c598409db$var$num(d.sellingCosts) - entryFee);
    const { short: short, long: long } = $7175ce4c598409db$var$usesOf(d, factFind);
    const title = short.length ? `Sell the home, ${$7175ce4c598409db$var$joinAnd(short)}${debtsTitle}` : `Sell the home and keep what is left in the bank${debtsTitle}`;
    const sub = long.length ? `The sale pays the ${fee} entry payment. Of the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(left))} left: ${long.join('; ')}.${debts}` : `The sale pays the ${fee} entry payment. The ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(left))} left stays in the bank account.${debts}`;
    return {
        title: title,
        sub: sub
    };
}
function $7175ce4c598409db$export$c36f8e3f260bf4c5(entryFee) {
    return {
        amount: Math.max(0, entryFee),
        label: 'Paid into the village'
    };
}


const $98fc2fd674f4d688$var$n = (v)=>Number.isFinite(Number(v)) ? Number(v) : 0;
function $98fc2fd674f4d688$export$61954784371996c2(p) {
    const { strategy: strategy, factFind: factFind, summary: summary } = p;
    const id = String(strategy.id || '');
    const kinds = (0, $203e38d6e6c434f4$export$c301be208b2d16d)(id);
    const inputs = strategy.inputs || {};
    const fundFrom = String(inputs.fundFrom || 'liquid');
    const rentHome = !!inputs.rentHome || fundFrom === 'rent_home';
    const snap = strategy.snapshot || {};
    const base = p.baseline?.snapshot || {};
    const years = Number(p.legacyYears) || 5;
    const rows = strategy.projections || [];
    const planLegacy = snap.legacyValue ?? (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(rows[Math.min(rows.length, years) - 1]) ?? 0;
    const funding = strategy.fundingBreakdown || [];
    const isPropertyRoute = fundFrom === 'sell_home' || fundFrom === 'investment_property';
    const fromSale = isPropertyRoute ? $98fc2fd674f4d688$var$n(funding[0]?.amount) : null;
    const fromSavings = isPropertyRoute ? funding.filter((f)=>/savings/i.test(f.label)).reduce((t, f)=>t + $98fc2fd674f4d688$var$n(f.amount), 0) : null;
    const annuity = (0, $4852c06b0c4c15b4$export$6d4129e74a169c1e)(strategy, factFind);
    const gi = (0, $91a0ac81d8d23067$export$32b560717abe61e8)(strategy, factFind);
    const clientName = factFind?.client?.firstName || 'you';
    const partnerName = factFind?.partner?.firstName || 'your partner';
    const common = (0, $482dbb064a59e381$export$df893918412205e2)(factFind, {
        kind: 'retirement_village',
        strategySource: 'suggestion_engine',
        riskKinds: kinds,
        riskSpecifics: (0, $4852c06b0c4c15b4$export$7a83655e7acf7684)(strategy, factFind)
    });
    const headline = {
        pension: $98fc2fd674f4d688$var$n(snap.pension),
        cashflow: $98fc2fd674f4d688$var$n(snap.netCashflow),
        estate: $98fc2fd674f4d688$var$n(planLegacy)
    };
    const baseline = {
        name: 'Staying in your current home',
        pension: $98fc2fd674f4d688$var$n(base.pension),
        cashflow: $98fc2fd674f4d688$var$n(base.netCashflow),
        estate: $98fc2fd674f4d688$var$n(base.legacyValue)
    };
    // The engine's funding rows say what PAID the entry contribution; they are not a second payment.
    const paidFrom = funding.filter((f)=>$98fc2fd674f4d688$var$n(f.amount) > 0).map((f)=>`${f.label.replace(/^from /i, '').toLowerCase()} ${$98fc2fd674f4d688$var$formatMoney($98fc2fd674f4d688$var$n(f.amount))}`);
    const moneyFlow = [
        ...fundFrom === 'sell_home' ? [
            {
                label: 'Home sold',
                amount: $98fc2fd674f4d688$var$n(inputs.sellHomeDetails?.salePrice),
                note: 'the proceeds fund the move'
            }
        ] : [],
        {
            label: 'Village entry contribution',
            amount: summary.entryFee,
            note: `${paidFrom.length ? `paid from ${paidFrom.join(' and ')} \xb7 ` : ''}refundable when you leave, less the departure fee`
        },
        ...$98fc2fd674f4d688$var$n(inputs.sellHomeDetails?.purchaseShares) > 0 ? [
            {
                label: 'Shares or managed funds bought',
                amount: $98fc2fd674f4d688$var$n(inputs.sellHomeDetails?.purchaseShares)
            }
        ] : [],
        ...$98fc2fd674f4d688$var$n(inputs.sellHomeDetails?.purchaseInvestmentProperty) > 0 ? [
            {
                label: 'Investment property bought',
                amount: $98fc2fd674f4d688$var$n(inputs.sellHomeDetails?.purchaseInvestmentProperty),
                note: $98fc2fd674f4d688$var$n(inputs.investmentPropertyStampDuty) > 0 ? `plus ${$98fc2fd674f4d688$var$formatMoney($98fc2fd674f4d688$var$n(inputs.investmentPropertyStampDuty))} stamp duty` : undefined
            }
        ] : [],
        ...rentHome ? [
            {
                label: 'Rent from the home you keep',
                amount: $98fc2fd674f4d688$var$n(inputs.rentDetails?.rentAmount) * 52,
                note: 'a year, counted as income'
            }
        ] : []
    ].filter((r)=>r.amount > 0);
    const pieces = (0, $b09eddbdc2b9438e$export$23826e09bab3c866)({
        fundFrom: fundFrom,
        rentHome: rentHome,
        entryFee: summary.entryFee,
        allocations: inputs.sellHomeDetails ?? null,
        clientName: clientName,
        partnerName: partnerName,
        nilResidualAnnuity: !!annuity && Math.round(annuity.residualPercent) === 0
    }).map((piece)=>({
            name: piece.name,
            what: piece.what,
            amount: piece.amount ?? null,
            perYear: piece.amountSuffix === 'a year'
        }));
    const fromVillage = (0, $4633117ee929ec27$export$cb26bf32ff9b2b4d)(factFind) ? (()=>{
        const e = (0, $4633117ee929ec27$export$3da79be84c8bf9e7)(factFind, (0, $4633117ee929ec27$export$6005e8b092eea057)(new Date()));
        return e ? {
            ...e,
            feesAfterLeaving: (0, $4633117ee929ec27$export$de22c25de5484f31)(factFind.retirementVillage, (0, $4633117ee929ec27$export$6005e8b092eea057)(new Date()), e.refundDate)
        } : null;
    })() : null;
    const inBrief = (0, $7ed3a1547818f47b$export$358299c3c19123ce)({
        entryFee: summary.entryFee,
        fundFrom: fundFrom,
        rentHome: rentHome,
        fromSaleAmount: fromSale,
        fromSavingsAmount: fromSavings,
        pensionBefore: baseline.pension,
        pensionAfter: headline.pension,
        cashBefore: baseline.cashflow,
        cashAfter: headline.cashflow,
        planLegacy: headline.estate,
        baseLegacy: baseline.estate,
        legacyYears: years,
        annuity: annuity
    }).map((c)=>`${c.text}${c.caveat ? ` ${c.caveat}` : ''}`);
    const ladder = (0, $a5e43ea76f631c99$export$25dd93d8f5828b47).map((y)=>{
        const e = (0, $a5e43ea76f631c99$export$92ec836666aacd49)(p.villageInputs, y);
        return {
            label: `If you left after ${y} years \u{2014} back to you`,
            amount: e.netToResident,
            note: `after a departure fee of about ${$98fc2fd674f4d688$var$formatMoney(e.dmf)}`
        };
    });
    const alternatives = p.leaders.map(({ strategy: s, badges: badges })=>{
        const ss = s.snapshot || {};
        return {
            name: s.name || '',
            description: s.description || '',
            pension: $98fc2fd674f4d688$var$n(ss.pension),
            cashflow: $98fc2fd674f4d688$var$n(ss.netCashflow),
            estate: $98fc2fd674f4d688$var$n(ss.legacyValue),
            selected: s.id === strategy.id,
            badges: badges.map((0, $400a08a42b233386$export$da83f84a5a007a8a))
        };
    });
    if (!alternatives.some((a)=>a.selected)) alternatives.unshift({
        name: strategy.name || '',
        description: strategy.description || '',
        ...headline,
        selected: true,
        badges: []
    });
    const allEvaluated = p.all.filter((s)=>String(s.id) !== 'rv-stay-home' && !s.inputs?.stayHome).map((s)=>{
        const ss = s.snapshot || {};
        const badges = p.leaders.find((l)=>l.strategy.id === s.id)?.badges ?? [];
        return {
            name: s.name || '',
            description: s.description || '',
            pension: $98fc2fd674f4d688$var$n(ss.pension),
            cashflow: $98fc2fd674f4d688$var$n(ss.netCashflow),
            estate: $98fc2fd674f4d688$var$n(ss.legacyValue),
            selected: s.id === strategy.id,
            badges: badges.map((0, $400a08a42b233386$export$da83f84a5a007a8a))
        };
    });
    const projRows = (list)=>(0, $482dbb064a59e381$export$998b1d0a26b4d727)(list, years, {
            moduleCostLabel: 'Village fees',
            moduleCost: (row)=>$98fc2fd674f4d688$var$n(row.villageFees ?? row.annualVillageCost ?? row.annualCareCost) || summary.annualOngoing
        });
    const pensionDelta = Math.round(headline.pension - baseline.pension);
    const dmfAtHorizon = (0, $a5e43ea76f631c99$export$92ec836666aacd49)(p.villageInputs, p.villageInputs.yearsResidency > 0 ? Math.min(p.villageInputs.yearsResidency, years) : years).dmf;
    const estateDrivers = [
        ...dmfAtHorizon > 0 ? [
            {
                text: `The departure fee the contract has earned by year ${years} \u{2014} what comes back is the entry contribution less this`,
                amount: dmfAtHorizon,
                sign: 'minus'
            }
        ] : [],
        ...summary.annualOngoing > 0 ? [
            {
                text: 'Ongoing village fees, paid every year from income and savings',
                amount: summary.annualOngoing,
                perYear: true,
                sign: 'minus'
            }
        ] : [],
        ...fundFrom === 'sell_home' ? [
            {
                text: 'Selling costs on the home leave the estate on the day',
                amount: Math.round($98fc2fd674f4d688$var$n(inputs.sellHomeDetails?.salePrice) * 0.025),
                sign: 'minus'
            }
        ] : [],
        ...pensionDelta !== 0 ? [
            {
                text: `${pensionDelta > 0 ? 'More' : 'Less'} Age Pension, compounding over the ${years} years`,
                amount: Math.abs(pensionDelta),
                perYear: true,
                sign: pensionDelta > 0 ? 'plus' : 'minus'
            }
        ] : [],
        ...fundFrom === 'sell_home' ? [
            {
                text: 'The family home no longer grows in the background; the village unit grows on the contract\'s terms, and only your share of that comes back',
                sign: 'minus'
            }
        ] : [
            {
                text: 'The family home keeps growing in the background',
                sign: 'plus'
            }
        ],
        ...gi && gi.kind === 'incomeOnly' ? [
            {
                text: 'An income-only guaranteed income leaves nothing of its price to the family; its value is the income for life',
                sign: 'minus'
            }
        ] : []
    ];
    /*
     * THE GUARANTEED INCOME SECTION (guaranteed income review R1–R4, 21 Oct 2026; soaGuaranteedIncome.ts): the
     * words for its type, the year-by-year family table against the same sale with the money invested instead,
     * the best plan tested without one, the assumptions and rate date, the client's dated answers and, for
     * income only, the confirmation word for word.
     */ const compare = gi ? (0, $91a0ac81d8d23067$export$c241e21d61e3872b)(strategy, p.all) : null;
    const noAnnuity = p.all.filter((s)=>String(s.id) !== 'rv-stay-home' && !s.inputs?.stayHome && !(0, $91a0ac81d8d23067$export$32b560717abe61e8)(s, factFind));
    const bestWithout = noAnnuity.length ? noAnnuity.reduce((top, s)=>$98fc2fd674f4d688$var$n(s.snapshot?.legacyValue) > $98fc2fd674f4d688$var$n(top.snapshot?.legacyValue) ? s : top, noAnnuity[0]) : null;
    const guaranteedIncome = gi ? (0, $66827b1304244a1d$export$11aaa304d9182b)({
        factFind: factFind,
        personName: gi.personName,
        amount: gi.amount,
        kind: gi.kind,
        incomeAYear: gi.incomeAYear,
        quoted: $98fc2fd674f4d688$var$n(inputs.sellHomeDetails?.rvAnnuityIncomeOverride) > 0,
        rows: rows,
        compareRows: compare?.row.projections ?? null,
        compareNote: compare?.note ?? null,
        horizonYears: years,
        plan: headline,
        alternative: bestWithout ? {
            name: (0, $7175ce4c598409db$export$6078d665f40b52df)(bestWithout, factFind, summary.entryFee).title,
            estate: $98fc2fd674f4d688$var$n(bestWithout.snapshot?.legacyValue),
            pension: $98fc2fd674f4d688$var$n(bestWithout.snapshot?.pension),
            cashflow: $98fc2fd674f4d688$var$n(bestWithout.snapshot?.netCashflow)
        } : null
    }) : null;
    const motiveNote = headline.estate < baseline.estate - 1 ? `An estate that ends behind ${baseline.name.toLowerCase()} is the usual shape of a village move: the departure fee and the ongoing fees buy the community, the services and the security of the village, which the projection cannot count. The figures show what the move costs, so the decision is made with eyes open.` : null;
    return {
        ...common,
        decisionIntro: `${common.isCouple ? 'You are' : 'You are'} weighing a move into a retirement village with an entry contribution of ${$98fc2fd674f4d688$var$formatMoney(summary.entryFee)} and ongoing fees of about ${$98fc2fd674f4d688$var$formatMoney(summary.annualOngoing)} a year. This advice is about how to fund the move, and what each way of doing it does to your Age Pension, your yearly cashflow and what is left to the family.`,
        selectedStrategyName: strategy.name || 'Selected strategy',
        selectedStrategyDescription: strategy.description || '',
        inOneLine: $98fc2fd674f4d688$var$oneLine(fundFrom, rentHome, summary.entryFee, kinds),
        inBrief: fromVillage ? [
            ...inBrief,
            (0, $511dfa7ed5ad5c31$export$2bd5a1cd4f86f5f0)({
                name: clientName,
                ...fromVillage
            }, 'village')
        ] : inBrief,
        pieces: pieces,
        moneyFlow: moneyFlow,
        legacyYears: years,
        headline: headline,
        baseline: baseline,
        whyItFits: (0, $482dbb064a59e381$export$64ada78711707257)(headline, baseline, years),
        estateDrivers: estateDrivers,
        motiveNote: motiveNote,
        modulePage: {
            title: 'What the village costs',
            intro: 'The village contract has three money moments: what you pay to move in, what you pay while you live there, and what comes back when you leave. These are the figures this advice is built on.',
            rows: [
                {
                    label: 'Entry contribution',
                    amount: summary.entryFee,
                    note: 'paid when you move in'
                },
                {
                    label: 'Ongoing fees',
                    amount: summary.annualOngoing,
                    note: 'a year, for services and upkeep; they usually rise with costs'
                },
                ...ladder
            ],
            footnote: 'The departure fee and the resale share are set by the village contract. Your exit money usually arrives only when the unit is re-sold, which can take months. Compare contracts, not brochures, and get legal advice before signing.'
        },
        moduleCostLabel: 'Village fees',
        projectionConvention: 'Year 1 is the first full year after the move; each later year follows it.',
        alternatives: alternatives,
        allEvaluated: allEvaluated,
        totalEvaluated: allEvaluated.length,
        projections: projRows(rows),
        baselineProjections: projRows(p.baseline?.projections),
        replacements: (0, $482dbb064a59e381$export$caf941bdb2b0342e)(kinds, moneyFlow),
        implications: [
            {
                title: 'The departure fee grows every year you stay',
                lead: `About ${$98fc2fd674f4d688$var$formatMoney((0, $a5e43ea76f631c99$export$92ec836666aacd49)(p.villageInputs, 1).dmf)} after one year, ${$98fc2fd674f4d688$var$formatMoney((0, $a5e43ea76f631c99$export$92ec836666aacd49)(p.villageInputs, 5).dmf)} after five${p.villageInputs.dmfCapYears > 0 ? `, and capped after ${p.villageInputs.dmfCapYears} years` : ''}.`,
                body: "The projection carries the contract to the horizon on the terms you entered: the fee earned to that year is taken off the entry contribution in the estate. A different contract \u2014 a lower rate, a shorter cap, a different share of any capital gain \u2014 changes the estate figure directly; re-run the analysis on the contract you are offered."
            },
            ...annuity ? [
                {
                    title: 'The guaranteed income needs a written quote',
                    lead: `The ${$98fc2fd674f4d688$var$formatMoney(annuity.amount)} guaranteed income is priced on published rates.`,
                    body: 'The income shown is an estimate. Before buying, get a written quote from the insurer; the quote replaces our estimate, so re-run the analysis on the real figure.'
                }
            ] : [],
            ...fundFrom === 'sell_home' ? [
                {
                    title: 'The home sale comes first',
                    lead: 'The entry contribution is paid from the sale proceeds.',
                    body: 'Settlement timing matters: if the village wants payment before the home settles, bridging money or a deposit arrangement may be needed. Tell Services Australia when the home is sold.'
                }
            ] : [],
            ...rentHome ? [
                {
                    title: 'You become a landlord',
                    lead: 'The rent is income for Centrelink and for tax, and the home is counted as an asset from the day you move.',
                    body: 'Budget for vacancies, repairs, insurance and an agent. The main-residence exemption from capital gains tax runs for up to six years while the home is let; after that a sale can be taxed. Keep records for your tax return.'
                }
            ] : [],
            ...$98fc2fd674f4d688$var$n(inputs.sellHomeDetails?.purchaseInvestmentProperty) > 0 ? [
                {
                    title: 'The investment property rests on assumptions',
                    lead: `Bought for ${$98fc2fd674f4d688$var$formatMoney($98fc2fd674f4d688$var$n(inputs.sellHomeDetails?.purchaseInvestmentProperty))}${$98fc2fd674f4d688$var$n(inputs.investmentPropertyStampDuty) > 0 ? ` plus ${$98fc2fd674f4d688$var$formatMoney($98fc2fd674f4d688$var$n(inputs.investmentPropertyStampDuty))} stamp duty` : ''}, earning ${(0, $0f2c0a6799fe36da$export$b037eefb915b86ec).propertyYieldPct.toFixed(1)}% gross rent less ${(0, $6ee1c1106c00a64d$export$ccb8ef6339a33b59)}, and growing ${(0, $0f2c0a6799fe36da$export$b037eefb915b86ec).propertyGrowthPct.toFixed(1)}% a year.`,
                    body: `These are the tool\'s standard figures for a property that does not exist yet. In Manual Control you can enter the price, rent, expenses and growth of a property you are looking at, and the projections re-run on your figures. ${$98fc2fd674f4d688$var$n(inputs.sellHomeDetails?.ipLoanAmount) > 0 ? `A loan of ${$98fc2fd674f4d688$var$formatMoney($98fc2fd674f4d688$var$n(inputs.sellHomeDetails?.ipLoanAmount))} pays part of the price, repaid as principal and interest at ${$98fc2fd674f4d688$var$n(inputs.sellHomeDetails?.ipLoanRate) || 6.5}% over ${$98fc2fd674f4d688$var$n(inputs.sellHomeDetails?.ipLoanTermYears) || 25} years; the interest is deducted against the rent. ` : ''}A gain on an investment property is taxed when it is sold. The figure left to the family is after the capital gains tax that would be paid on selling it, estimated at the household\u{2019}s own tax rates; the property itself is carried at its value.`
                }
            ] : [],
            ...$98fc2fd674f4d688$var$n(inputs.sellHomeDetails?.purchaseShares) > 0 ? [
                {
                    title: 'Shares and managed funds are priced on your investment approach',
                    lead: 'The return assumed is the one recorded in your profile (Conservative where none is).',
                    body: 'Returns are not guaranteed and values move; a different approach changes the figures. You can change it in the client profile and re-run.'
                }
            ] : [],
            {
                title: 'Tell Services Australia',
                lead: 'A village move changes how you are assessed.',
                body: 'The entry contribution is usually not counted as an asset, and you may be treated as a homeowner or a non-homeowner depending on its size. Report the move and the amount within 14 days.'
            }
        ],
        scope: {
            inScope: [
                'How to fund a village entry contribution and the move itself, using the village figures you entered.',
                ...(0, $482dbb064a59e381$export$472dfc9f05c9ea81)
            ],
            outOfScope: [
                'Whether this particular village is a good one, or what its contract should say.',
                'How the state rules on departure fees and refund timing apply to your contract (summarised on the village page; confirm with a solicitor).',
                ...(0, $482dbb064a59e381$export$b73d600a5ab2902f)(factFind)
            ]
        },
        guaranteedIncome: guaranteedIncome,
        nextSteps: [
            "Ask the village for its disclosure statement and the full contract, and have a solicitor who knows retirement village law read it before you sign.",
            'Confirm in writing how the departure fee is worked out, when your exit money is paid, and what fees continue after you leave.',
            ...fundFrom === 'sell_home' ? [
                'Get two or three appraisals on the home and line up settlement with the village entry date.'
            ] : [],
            ...annuity ? [
                'Get a written quote for the guaranteed income from the insurer before buying, and re-run the analysis on it.'
            ] : [],
            'Tell Services Australia about the move and the entry contribution within 14 days of moving.',
            'Where you sell assets or trigger capital gains tax, confirm the tax with a registered tax agent before you act.'
        ]
    };
}
/** The whole plan as one sentence a client can repeat: how the entry contribution is paid, then what the rest does. */ function $98fc2fd674f4d688$var$oneLine(fundFrom, rentHome, entryFee, kinds) {
    const fee = $98fc2fd674f4d688$var$formatMoney(entryFee);
    const first = fundFrom === 'sell_home' ? `Sell the home and pay the ${fee} entry contribution from the proceeds` : fundFrom === 'investment_property' ? `Sell the investment property and pay the ${fee} entry contribution from the proceeds` : rentHome ? `Keep the home and rent it out, paying the ${fee} entry contribution from savings` : `Pay the ${fee} entry contribution from savings`;
    const rest = [];
    if (kinds.includes('investmentProperty')) rest.push('buy an investment property');
    if (kinds.includes('shares')) rest.push('invest in shares or managed funds');
    if (kinds.includes('superContribution')) rest.push('put money into super');
    if (kinds.includes('accountBasedPension')) rest.push('start an account-based pension');
    if (kinds.includes('annuityNil') || kinds.includes('annuityReturned') || kinds.includes('annuityGuaranteed')) rest.push('buy a lifetime annuity');
    if (kinds.includes('investmentBond')) rest.push('buy an investment bond');
    if (kinds.includes('funeralBond')) rest.push('set money aside in a funeral bond');
    if (kinds.includes('gift')) rest.push('gift within the free area');
    if (kinds.includes('clearDebt')) rest.push('pay off the debt');
    if (!rest.length) return `${first}.`;
    const list = rest.length === 1 ? rest[0] : `${rest.slice(0, -1).join(', ')} and ${rest[rest.length - 1]}`;
    return `${first}; with what is left, ${list}.`;
}
function $98fc2fd674f4d688$var$formatMoney(v) {
    return `$${Math.round(v).toLocaleString('en-AU')}`;
}



/**
 * Step 2 — what it means for them (village rebuild, 21 Oct 2026; the agreed mock-up's j1-step2).
 *
 * Staying put in four numbers, with "See the year-by-year figures, staying put" beneath: the baseline
 * every plan on step 3 is measured against. Then WHERE THEY START, worked out from the file: their
 * savings and investments against the entry payment plus the money kept for emergencies, so whether
 * keeping the home is possible at all, and how much is left to put to work if they sell. Then what the
 * move changes, and how long the money lasts staying put.
 *
 * ONE SOURCE, as before: the pension and cashflow are today's assessment (`todayFinancials`), the
 * estate and the runway the stay-put projection — the same run the engine's own baseline makes.
 */ 

var $acw62 = parcelRequire("acw62");












function $8c787e0b77f2f1be$export$d480843d1277b65b(factFind, entryFee, reserveOverride) {
    const num = (x)=>parseFloat(String(x ?? '')) || 0;
    const hasHome = num(factFind?.home?.value) > 0;
    const savings = (0, $bd80071df75c742b$export$a6f66b42cac1f673)(factFind).reduce((t, a)=>t + num(a.value), 0);
    const reserve = reserveOverride != null && reserveOverride >= 0 ? reserveOverride : (0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind);
    const savingsAfterEntry = savings - entryFee - reserve;
    const homeValue = num(factFind?.home?.value);
    const saleNet = hasHome ? Math.round(homeValue - homeValue * 0.025) : 0;
    const keepHome = !hasHome ? null : savingsAfterEntry < 0 ? 'no' : savingsAfterEntry < 50000 ? 'just' : 'yes';
    return {
        hasHome: hasHome,
        savings: savings,
        reserve: reserve,
        entryFee: entryFee,
        savingsAfterEntry: savingsAfterEntry,
        keepHome: keepHome,
        saleNet: saleNet,
        afterSale: Math.max(0, saleNet - entryFee)
    };
}
const $8c787e0b77f2f1be$var$card = 'rounded-2xl border border-slate-200 bg-white p-6 shadow-card';
const $8c787e0b77f2f1be$var$Tile = ({ label: label, value: value, unit: unit, caption: caption, tone: tone })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-xl border border-slate-200 bg-white px-4 py-4 shadow-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[12.5px] font-semibold text-slate-500",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: `mt-1 text-[26px] font-bold leading-none tabular-nums tracking-tight ${tone === 'good' ? 'text-emerald-700' : tone === 'bad' ? 'text-rose-700' : 'text-slate-900'}`,
                children: [
                    value,
                    unit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ml-1 text-[13px] font-semibold text-slate-500",
                        children: unit
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-[12.5px] leading-snug text-slate-500",
                children: caption
            })
        ]
    });
const $8c787e0b77f2f1be$var$RvStep2 = ({ factFind: factFind, todayFinancials: todayFinancials, stayPutLegacy: stayPutLegacy, runway: runway, legacyYears: legacyYears, villageInputs: villageInputs, annualOngoing: annualOngoing, reserve: reserve, onLegacyYearsChange: onLegacyYearsChange, onBack: onBack, onNext: onNext, onAssumptions: onAssumptions, onShowProjections: onShowProjections })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const ready = !!todayFinancials;
    const pension = todayFinancials?.socialSecurity ?? 0;
    const cashFlow = todayFinancials?.cashFlow ?? 0;
    const netWorth = todayFinancials?.netWorth ?? 0;
    const years = Number(legacyYears) || 0;
    const entryFee = villageInputs.entryFee || 0;
    const sp = $8c787e0b77f2f1be$export$d480843d1277b65b(factFind, entryFee, reserve);
    const stay = sp.hasHome ? 'staying put' : 'renting on';
    const [showWhy, setShowWhy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        "data-testid": "rv-step2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-[24px] font-bold tracking-tight text-brand-navy",
                        children: sp.hasHome ? `If ${v.names} stay${v.s} where ${v.they} are` : `If ${v.names} keep${v.s} renting`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1 text-[15px] text-slate-600",
                        children: [
                            "Every way of moving on the next step is measured against these four numbers, which the cards call \u201C",
                            (0, $1a5a24a0286ded56$export$b3949d624101f360)('village', {
                                rents: !sp.hasHome
                            }).word,
                            "\u201D."
                        ]
                    })
                ]
            }),
            !ready ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "rounded-xl border border-dashed border-slate-300 bg-white px-4 py-6 text-center text-[14px] text-slate-600",
                children: "Working out today's position\u2026"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4",
                        "data-testid": "rv-four-numbers",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c787e0b77f2f1be$var$Tile, {
                                label: "Age Pension",
                                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(pension)),
                                unit: "a year",
                                caption: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        v.couple ? 'the two of them' : 'a year',
                                        " \xb7 ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setShowWhy((o)=>!o),
                                            className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2",
                                            children: "why?"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c787e0b77f2f1be$var$Tile, {
                                label: cashFlow < 0 ? 'Short each year' : 'Left over each year',
                                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(cashFlow))),
                                tone: cashFlow < 0 ? 'bad' : 'good',
                                caption: cashFlow < 0 ? 'money in, less money out; met from savings' : 'money in, less money out'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c787e0b77f2f1be$var$Tile, {
                                label: `What ${v.they} own`,
                                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(netWorth)),
                                caption: `less what ${v.they} owe`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c787e0b77f2f1be$var$Tile, {
                                label: "Left to the family",
                                value: stayPutLegacy != null ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(stayPutLegacy)) : "\u2014",
                                caption: stayPutLegacy != null ? onLegacyYearsChange ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9873a6fbc9fd360$export$68741d4d7bc37a6d), {
                                    years: years,
                                    onChange: onLegacyYearsChange,
                                    after: ` ${stay}.`
                                }) : `after about ${years} years` : 'not available: the projection could not be run'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[14px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: onShowProjections,
                                className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                "data-testid": "rv-step2-year-by-year",
                                children: [
                                    "See the year-by-year figures, ",
                                    stay
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-slate-500",
                                children: [
                                    " \u2014 Age Pension, money in and out, and what ",
                                    v.they,
                                    " own, each year for about ",
                                    years,
                                    " years. Every plan on the next step is measured against these."
                                ]
                            })
                        ]
                    }),
                    showWhy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $8c787e0b77f2f1be$var$card,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$28c8139bd562d0e), {
                            eyebrow: `Why ${v.possessive} Age Pension is ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(pension))}`,
                            className: "-m-5 border-0 bg-transparent shadow-none",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eec331ce661055d2$export$836922263996c16c), {
                                careDepositRelevant: false,
                                financials: todayFinancials,
                                isCouple: factFind?.adviceFor === 'couple',
                                name: v.names,
                                alsoMoves: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: "changes what the village move costs the pension"
                                })
                            })
                        })
                    })
                ]
            }),
            entryFee > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $8c787e0b77f2f1be$var$card,
                "data-testid": "rv-starting-point",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[12px] font-semibold text-brand-navy",
                        children: [
                            "Where ",
                            v.they,
                            " start"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                        className: "mt-1 w-full text-[14px]",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                            children: [
                                !sp.hasHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    className: "border-b border-slate-100",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-2 text-slate-700",
                                            children: "No home to keep or sell"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-2 text-right text-slate-500",
                                            children: "the rent stops and the village fees start"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    className: "border-b border-slate-100",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-2 text-slate-700",
                                            children: "Savings and investments"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-2 text-right font-bold tabular-nums text-slate-900",
                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(sp.savings))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    className: "border-b border-slate-100",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                            className: "py-2 text-slate-700",
                                            children: [
                                                "Entry payment, plus ",
                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(sp.reserve)),
                                                " kept for emergencies"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-2 text-right tabular-nums text-slate-700",
                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(entryFee + sp.reserve))
                                        })
                                    ]
                                }),
                                sp.hasHome ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "border-b border-slate-100",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "py-2 font-semibold text-slate-900",
                                                    children: "Keeping the home and paying from savings and investments"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "py-2 text-right",
                                                    "data-testid": "rv-keep-home-verdict",
                                                    children: [
                                                        sp.keepHome === 'yes' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                                    className: "text-emerald-700",
                                                                    children: "Possible"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "text-slate-500",
                                                                    children: [
                                                                        "\u2014 ",
                                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(sp.savingsAfterEntry)),
                                                                        " left over"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        sp.keepHome === 'just' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                                    className: "text-amber-700",
                                                                    children: "Possible, just"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "text-slate-500",
                                                                    children: [
                                                                        "\u2014 ",
                                                                        sp.savingsAfterEntry < 1000 ? 'nothing left over' : `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(sp.savingsAfterEntry))} left over`
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        sp.keepHome === 'no' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                                    className: "text-rose-700",
                                                                    children: "Not without selling"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "text-slate-500",
                                                                    children: [
                                                                        "\u2014 ",
                                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(-sp.savingsAfterEntry)),
                                                                        " short"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "py-2 text-slate-700",
                                                    children: [
                                                        "If ",
                                                        v.they,
                                                        " sell the home: about ",
                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(sp.saleNet),
                                                        " after selling costs, less the entry payment"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "py-2 text-right font-bold tabular-nums text-slate-900",
                                                    children: [
                                                        "about ",
                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(sp.afterSale / 10000) * 10000),
                                                        " to put to work"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-2 font-semibold text-slate-900",
                                            children: "Left to put to work after the move"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-2 text-right font-bold tabular-nums text-slate-900",
                                            children: sp.savingsAfterEntry >= 0 ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(sp.savingsAfterEntry)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "text-rose-700",
                                                children: [
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(-sp.savingsAfterEntry)),
                                                    " short"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 text-[12.5px] text-slate-500",
                        children: [
                            "Worked out from ",
                            v.possessive,
                            " file."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-5 text-[12px] font-semibold text-brand-navy",
                        children: "What the move changes"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                        className: "mt-1 list-disc space-y-1.5 pl-5 text-[15px] text-slate-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                    className: "text-slate-900",
                                    children: [
                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(entryFee),
                                        " has to be paid on the day ",
                                        v.they,
                                        " move."
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: "text-slate-900",
                                        children: [
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(annualOngoing)),
                                            " a year in fees"
                                        ]
                                    }),
                                    ", from the day ",
                                    v.they,
                                    " move",
                                    sp.hasHome ? '' : ', and the rent stops',
                                    "."
                                ]
                            }),
                            sp.hasHome ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: "text-slate-900",
                                        children: [
                                            "The Age Pension changes, whichever way ",
                                            v.they,
                                            " fund it."
                                        ]
                                    }),
                                    " If ",
                                    v.they,
                                    " keep the home, it counts straight away and so does the rent. If ",
                                    v.they,
                                    " sell, the money left over counts. The next step shows what each way does to it."
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: "text-slate-900",
                                        children: [
                                            "The entry payment ",
                                            villageInputs.entryFee > (0, $1abe73eeef086faf$export$e2cf792e99a08354) ? 'is not counted' : 'counts as an asset'
                                        ]
                                    }),
                                    " for the Age Pension",
                                    villageInputs.entryFee > (0, $1abe73eeef086faf$export$e2cf792e99a08354) ? ', and there is no Rent Assistance' : ', and Rent Assistance may be paid on the fees',
                                    "."
                                ]
                            })
                        ]
                    }),
                    runway && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-5 text-[12px] font-semibold text-brand-navy",
                                children: [
                                    "How long the money lasts, ",
                                    stay
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c05f3bca3803eec$export$7fbbcd423808f3d5), {
                                    headline: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-[15px] text-slate-700",
                                        children: runway.headline
                                    }),
                                    coveredPct: runway.coveredPct,
                                    leftLabel: runway.leftLabel,
                                    rightLabel: runway.rightLabel,
                                    depleted: runway.depleted,
                                    flag: runway.flag
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] text-slate-500",
                children: [
                    "Figures use the rates in force from ",
                    (0, $1abe73eeef086faf$export$946308c675ba021d).agePension,
                    ". ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onAssumptions,
                        className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2",
                        children: "What the figures assume"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onBack,
                        className: "inline-flex items-center gap-1 text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                size: 15
                            }),
                            " Change the village or the contract"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onNext,
                        disabled: !ready,
                        "data-testid": "rv-step2-next",
                        className: "inline-flex h-11 items-center gap-2 rounded-lg bg-blue-600 hover:bg-blue-700 px-5 text-[14px] font-semibold text-white shadow-sm disabled:cursor-not-allowed disabled:opacity-50",
                        children: [
                            "See ways to fund the move and use what's left ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                size: 16
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $8c787e0b77f2f1be$export$2e2bcd8739ae039 = $8c787e0b77f2f1be$var$RvStep2;


/**
 * Step 3's choices — before the plans run, and again under "Things that change the answer" (village
 * rebuild; the agreed mock-up's j1-setup, j1-setup-sell and j3-setup; owner rulings 20–21 Oct 2026).
 *
 * WHAT WE ALREADY KNOW comes first, from the file and in plain words, with no "what if" logic on screen:
 * whether their savings and investments cover the entry payment and the money kept for emergencies
 * (if not, the home is named and every plan starts from selling it), and that no plan borrows.
 *
 * Then only the levers the client actually has:
 *   1. the home — keep and rent it, sell it, or compare — with the rent, its costs and the weeks it sits
 *      empty (two, suggested), and the check on land tax; asked only when keeping it is possible;
 *   2. the money kept for emergencies (not a yearly floor: their costs are on the file);
 *   3. whether they would consider a guaranteed income for life — the shared question (GuaranteedIncomeQuestions:
 *      the explanation on the screen, three answers and the share, 21 Oct 2026), the client's own answer;
 *   4. what to do with what's left after a sale, with the line that anything not put somewhere stays in
 *      the bank, and is tested too (decision 14).
 * The years are a default on one line. "Build a plan yourself instead" sits beside the run button.
 */ 

var $acw62 = parcelRequire("acw62");

















const $6dbbd81bf88b5930$var$num = (x, d = 0)=>x != null && x !== '' && Number.isFinite(Number(x)) ? Number(x) : d;
function $6dbbd81bf88b5930$export$1f8e14ba756735e8(factFind) {
    const g = factFind?.goals || {};
    const uses = typeof g.rvResidualUses === 'string' ? (0, $47cb8579212c1476$export$1c14447c2c2991eb)(g.rvResidualUses) : [
        'super',
        'invest'
    ];
    const appetite = (0, $ff5de4128b46b139$export$636a9065c3f862c1)(factFind).appetite;
    return {
        homeRoute: g.rvHomeRoute === 'keep' || g.rvHomeRoute === 'sell' ? g.rvHomeRoute : 'compare',
        rentPerWeek: $6dbbd81bf88b5930$var$num(g.rvRentPerWeek, $6dbbd81bf88b5930$var$num(factFind?.home?.likelyRent)),
        rentCosts: $6dbbd81bf88b5930$var$num(g.rvRentCosts, $6dbbd81bf88b5930$var$num(factFind?.home?.likelyExpenses)),
        vacancyWeeks: $6dbbd81bf88b5930$var$num(g.rvVacancyWeeks, (0, $6d7411748a56fc80$export$cf7cc42462ce27c2)),
        emergencyReserve: $6dbbd81bf88b5930$var$num(g.rvEmergencyReserve, (0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind)),
        annuity: appetite === 'none' ? 'none' : 'yes',
        guaranteedIncome: null,
        uses: uses,
        purchaseState: String(g.rvPurchaseState || g.rvState || ''),
        oldUnitPaysAtMove: g.rvOldUnitPaysAtMove !== false,
        investProfile: String(g.newMoneyInvestmentProfile || ''),
        years: $6dbbd81bf88b5930$var$num(g.rvLegacyYears, 10)
    };
}
function $6dbbd81bf88b5930$export$c3fcad8c1047c5ef(a) {
    return {
        rvHomeRoute: a.homeRoute,
        rvRentPerWeek: a.rentPerWeek,
        rvRentCosts: a.rentCosts,
        rvVacancyWeeks: a.vacancyWeeks,
        rvEmergencyReserve: a.emergencyReserve,
        ...a.guaranteedIncome || {},
        rvResidualUses: a.uses.join(','),
        rvPurchaseState: a.purchaseState,
        rvOldUnitPaysAtMove: a.oldUnitPaysAtMove,
        ...a.investProfile ? {
            newMoneyInvestmentProfile: a.investProfile
        } : {},
        rvLegacyYears: a.years
    };
}
const $6dbbd81bf88b5930$var$input = 'rounded-lg border border-slate-300 bg-white px-3 py-2 text-[15px] font-semibold text-slate-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-500';
const $6dbbd81bf88b5930$var$link = 'font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy';
const $6dbbd81bf88b5930$var$Why = ({ open: open, onToggle: onToggle, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            ' ',
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onToggle,
                "aria-expanded": open,
                className: "text-[12px] font-semibold text-blue-700 underline decoration-dotted underline-offset-2",
                children: "what's this?"
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "mt-1.5 block rounded-lg border border-slate-200 border-l-4 border-l-blue-500 bg-white px-3 py-2 text-[13px] font-normal leading-relaxed text-slate-700",
                children: children
            })
        ]
    });
const $6dbbd81bf88b5930$var$Radio = ({ name: name, checked: checked, onChange: onChange, children: children, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
        className: "flex cursor-pointer items-start gap-2 py-1 text-[14px] text-slate-700",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "radio",
                name: name,
                checked: checked,
                onChange: onChange,
                className: "mt-1 accent-blue-600",
                "data-testid": testId
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: children
            })
        ]
    });
const $6dbbd81bf88b5930$var$Tick = ({ checked: checked, onChange: onChange, children: children, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
        className: "flex cursor-pointer items-start gap-2 py-1 text-[14px] text-slate-700",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "checkbox",
                checked: checked,
                onChange: onChange,
                className: "mt-1 h-4 w-4 accent-blue-600",
                "data-testid": testId
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: children
            })
        ]
    });
/** One question, numbered by the caller; defined outside the screen so its inputs keep focus. */ const $6dbbd81bf88b5930$var$Q = ({ n: n, title: title, why: why, whyOpen: whyOpen = false, onWhy: onWhy, children: children, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-t border-slate-200 pt-4",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d7fa4e176455787d$export$d5095ecb707035a), {
                n: n,
                children: [
                    title,
                    why && onWhy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6dbbd81bf88b5930$var$Why, {
                        open: whyOpen,
                        onToggle: onWhy,
                        children: why
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-2",
                children: children
            })
        ]
    });
const $6dbbd81bf88b5930$var$RvQuestions = ({ factFind: factFind, entryFee: entryFee, firstRun: firstRun, onRun: onRun, onBuildYourOwn: onBuildYourOwn, onChangeUnit: onChangeUnit, onCancel: onCancel })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const [a, setA] = (0, $acw62.useState)(()=>$6dbbd81bf88b5930$export$1f8e14ba756735e8(factFind));
    const set = (patch)=>setA((prev)=>({
                ...prev,
                ...patch
            }));
    const [openWhy, setOpenWhy] = (0, $acw62.useState)(null);
    const toggleWhy = (id)=>setOpenWhy((o)=>o === id ? null : id);
    const sp = (0, $8c787e0b77f2f1be$export$d480843d1277b65b)(factFind, entryFee, a.emergencyReserve);
    const suggestedReserve = (0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind);
    const allInHome = sp.hasHome && sp.keepHome === 'no';
    const stuck = !sp.hasHome && sp.savingsAfterEntry < 0;
    const askHome = sp.hasHome && !allInHome;
    const clientAge = factFind?.client?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client.dob) : null;
    const partnerAge = factFind?.adviceFor === 'couple' && factFind?.partner?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner.dob) : null;
    const downsizerOk = clientAge != null && clientAge >= 55 || partnerAge != null && partnerAge >= 55;
    const selling = sp.hasHome && (allInHome || a.homeRoute !== 'keep');
    const currentVillage = (0, $acw62.useMemo)(()=>{
        const ff = factFind;
        if (!(0, $4633117ee929ec27$export$cb26bf32ff9b2b4d)(ff)) return null;
        const e = (0, $4633117ee929ec27$export$3da79be84c8bf9e7)(ff, (0, $4633117ee929ec27$export$6005e8b092eea057)(new Date()));
        return e ? {
            name: ff.client?.firstName || 'The client',
            ...e
        } : null;
    }, [
        factFind
    ]);
    // The client's guaranteed-income answers as this screen shows them: the file's, with any change made here.
    const giView = (0, $acw62.useMemo)(()=>a.guaranteedIncome ? {
            ...factFind,
            goals: {
                ...factFind?.goals || {},
                ...a.guaranteedIncome
            }
        } : factFind, [
        factFind,
        a.guaranteedIncome
    ]);
    const toggleUse = (u)=>set({
            uses: a.uses.includes(u) ? a.uses.filter((x)=>x !== u) : [
                ...a.uses,
                u
            ]
        });
    // Every question shown is counted, the current unit's payout too (owner-caught in the granny flat, 23 Oct 2026).
    const count = 2 + (currentVillage ? 1 : 0) + (askHome ? 1 : 0) + (selling ? 1 : 0);
    const countWord = [
        '',
        'One',
        'Two',
        'Three',
        'Four',
        'Five'
    ][count] || String(count);
    let qn = 0;
    const next = ()=>{
        qn += 1;
        return qn;
    };
    const whyProps = (id)=>({
            whyOpen: openWhy === id,
            onWhy: ()=>toggleWhy(id)
        });
    if (stuck) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
        "data-testid": "rv-cannot-fund",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "text-[20px] font-bold text-brand-navy",
                children: "This unit can't be paid for without borrowing"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-2 text-[15px] leading-relaxed text-slate-700",
                children: [
                    v.Possessive,
                    " savings and investments (",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(sp.savings)),
                    ") don't cover the ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(entryFee),
                    " entry payment and the ",
                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(sp.reserve)),
                    " kept for emergencies, and there is no home to sell. So no way of paying for it was found without borrowing."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-4 flex flex-wrap items-center gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onChangeUnit,
                        className: "rounded-lg bg-blue-600 px-4 py-2.5 text-[14px] font-semibold text-white hover:bg-blue-700",
                        children: "Change the unit"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onBuildYourOwn,
                        className: `text-[14px] ${$6dbbd81bf88b5930$var$link}`,
                        children: "Build a plan yourself"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
        "data-testid": "rv-questions",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                className: "text-[22px] font-bold text-brand-navy",
                children: [
                    countWord,
                    " choices that shape the plans"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-1 text-[15px] text-slate-600",
                children: [
                    "Everything else comes from ",
                    v.possessive,
                    " file. Our suggestions are filled in, and each can be changed later."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d7fa4e176455787d$export$b506d3545e935872), {
                onClick: onBuildYourOwn,
                testId: "rv-build-own-top"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-4 rounded-xl border border-slate-200 border-l-4 border-l-brand-navy bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700",
                "data-testid": "rv-what-we-know",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "text-slate-900",
                        children: "What we already know"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                        className: "mt-1.5 list-disc space-y-1 pl-5",
                        children: [
                            sp.hasHome && sp.keepHome === 'yes' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: "text-slate-900",
                                        children: [
                                            v.Possessive,
                                            " savings and investments (",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(sp.savings)),
                                            ") cover"
                                        ]
                                    }),
                                    " the ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(entryFee),
                                    " entry payment and the money kept for emergencies, so keeping the home is possible."
                                ]
                            }),
                            sp.hasHome && sp.keepHome === 'just' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: "text-slate-900",
                                        children: [
                                            v.Possessive,
                                            " savings and investments (",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(sp.savings)),
                                            ") only just cover"
                                        ]
                                    }),
                                    " the ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(entryFee),
                                    " entry payment and the money kept for emergencies. Keeping the home is possible, but tight."
                                ]
                            }),
                            allInHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                "data-testid": "rv-all-in-home",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: "text-slate-900",
                                        children: [
                                            v.Possessive,
                                            " savings and investments (",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(sp.savings)),
                                            ") don't cover the ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(entryFee),
                                            " entry payment"
                                        ]
                                    }),
                                    " and the money kept for emergencies. ",
                                    v.Possessive,
                                    " money is in the family home, so ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: "every way of moving starts by selling it"
                                    }),
                                    "."
                                ]
                            }),
                            selling && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: "text-slate-900",
                                        children: [
                                            "After selling and paying the entry payment, about ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(sp.afterSale / 10000) * 10000),
                                            " is left"
                                        ]
                                    }),
                                    " to put to work."
                                ]
                            }),
                            !sp.hasHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: "text-slate-900",
                                        children: [
                                            v.Possessive,
                                            " savings and investments (",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(sp.savings)),
                                            ") cover"
                                        ]
                                    }),
                                    " the ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(entryFee),
                                    " entry payment and the money kept for emergencies, ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: "text-slate-900",
                                        children: [
                                            "leaving about ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(sp.savingsAfterEntry / 10000) * 10000)
                                        ]
                                    }),
                                    ". The rent stops and the village fees start on the day ",
                                    v.they,
                                    " move."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: "No borrowing to pay for the move."
                                    }),
                                    " Banks rarely lend at ",
                                    v.their,
                                    " ages, so no plan borrows for the unit, and an investment property is tested only if it can be bought outright. If a plan that keeps the home ever runs out of savings, the figures cover the gap by borrowing against the home, and its card says from which year."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-4 space-y-4",
                children: [
                    currentVillage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6dbbd81bf88b5930$var$Q, {
                        n: next(),
                        title: "When will the current unit be paid out?",
                        testId: "rv-from-village",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6dbbd81bf88b5930$var$Radio, {
                                name: "rv-payout",
                                checked: a.oldUnitPaysAtMove,
                                onChange: ()=>set({
                                        oldUnitPaysAtMove: true
                                    }),
                                children: "At the move"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6dbbd81bf88b5930$var$Radio, {
                                name: "rv-payout",
                                checked: !a.oldUnitPaysAtMove,
                                onChange: ()=>set({
                                        oldUnitPaysAtMove: false
                                    }),
                                children: [
                                    "Later \u2014 up to ",
                                    currentVillage.refundMonths,
                                    " months after leaving"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1 text-[13px] text-slate-600",
                                children: (0, $511dfa7ed5ad5c31$export$2bd5a1cd4f86f5f0)(currentVillage, 'village', {
                                    atMove: a.oldUnitPaysAtMove
                                })
                            })
                        ]
                    }),
                    askHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6dbbd81bf88b5930$var$Q, {
                        n: next(),
                        title: "What would happen to the family home?",
                        testId: "rv-q-home",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6dbbd81bf88b5930$var$Radio, {
                                name: "rv-home",
                                checked: a.homeRoute === 'keep',
                                onChange: ()=>set({
                                        homeRoute: 'keep'
                                    }),
                                testId: "rv-home-keep",
                                children: "Keep it and rent it out"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6dbbd81bf88b5930$var$Radio, {
                                name: "rv-home",
                                checked: a.homeRoute === 'sell',
                                onChange: ()=>set({
                                        homeRoute: 'sell'
                                    }),
                                testId: "rv-home-sell",
                                children: "Sell it"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6dbbd81bf88b5930$var$Radio, {
                                name: "rv-home",
                                checked: a.homeRoute === 'compare',
                                onChange: ()=>set({
                                        homeRoute: 'compare'
                                    }),
                                testId: "rv-home-compare",
                                children: "Compare both"
                            }),
                            a.homeRoute !== 'sell' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-2 flex flex-wrap items-center gap-2 text-[13px] text-slate-600",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "If ",
                                                    v.they,
                                                    " rent it out:"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                value: a.rentPerWeek,
                                                onChange: (x)=>set({
                                                        rentPerWeek: x ?? 0
                                                    }),
                                                className: "w-28",
                                                ariaLabel: "Rent a week"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "a week, less"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                value: a.rentCosts,
                                                onChange: (x)=>set({
                                                        rentCosts: x ?? 0
                                                    }),
                                                className: "w-28",
                                                ariaLabel: "Yearly costs of the rented home"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "a year of costs, empty for"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "number",
                                                min: 0,
                                                max: 52,
                                                value: a.vacancyWeeks,
                                                onChange: (e)=>set({
                                                        vacancyWeeks: Math.min(52, Math.max(0, parseFloat(e.target.value) || 0))
                                                    }),
                                                className: `${$6dbbd81bf88b5930$var$input} w-16`,
                                                "aria-label": "Weeks a year without a tenant",
                                                "data-testid": "rv-vacancy-weeks"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "weeks a year",
                                                    a.vacancyWeeks === (0, $6d7411748a56fc80$export$cf7cc42462ce27c2) ? ', suggested' : ''
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-2 text-[13.5px] leading-relaxed text-slate-700",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                className: "text-slate-900",
                                                children: "Check the costs."
                                            }),
                                            " Include council rates, insurance, repairs, the agent's fee and ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                className: "text-slate-900",
                                                children: "land tax"
                                            }),
                                            ", which can apply once the home is no longer where ",
                                            v.they,
                                            " live and is often the largest. And ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                className: "text-slate-900",
                                                children: "allow for empty weeks"
                                            }),
                                            " between tenants: each one is ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(a.rentPerWeek)),
                                            " of rent lost while the costs go on."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6dbbd81bf88b5930$var$Q, {
                        n: next(),
                        title: "How much should stay in the bank for emergencies?",
                        ...whyProps('reserve'),
                        why: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "Money kept in the bank for the unexpected. We keep it back when we move ",
                                v.their,
                                " money, and draw on it only if a year runs short. Centrelink still counts it."
                            ]
                        }),
                        testId: "rv-q-reserve",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                        value: a.emergencyReserve,
                                        onChange: (x)=>set({
                                                emergencyReserve: Math.max(0, x ?? 0)
                                            }),
                                        className: "w-36",
                                        ariaLabel: "Money kept for emergencies"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-[13px] text-slate-500",
                                        children: [
                                            "We suggest ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(suggestedReserve),
                                            ": the greater of six months' living costs and $50,000.",
                                            Math.round(a.emergencyReserve) !== Math.round(suggestedReserve) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>set({
                                                                emergencyReserve: suggestedReserve
                                                            }),
                                                        className: $6dbbd81bf88b5930$var$link,
                                                        children: [
                                                            "Use ",
                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(suggestedReserve)
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-1.5 text-[13.5px] text-slate-700",
                                children: [
                                    "We keep it back when we move ",
                                    v.their,
                                    " money, and draw on it only if a year runs short. ",
                                    v.Possessive,
                                    " yearly costs are already on ",
                                    v.their,
                                    " file."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6dbbd81bf88b5930$var$Q, {
                        n: next(),
                        title: "A guaranteed income for life",
                        testId: "rv-q-annuity",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f92088f7258458cc$export$b30880333d8bfec9), {
                                fromHomeSale: selling,
                                factFind: giView,
                                onGoals: (patch)=>set({
                                        guaranteedIncome: {
                                            ...a.guaranteedIncome || {},
                                            ...patch
                                        },
                                        ...patch.annuityAppetite ? {
                                            annuity: patch.annuityAppetite === 'none' ? 'none' : 'yes'
                                        } : {}
                                    }),
                                investable: Math.max(0, selling ? sp.afterSale : sp.savingsAfterEntry),
                                investableLead: selling ? `After selling the home, paying the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(entryFee)} entry payment and keeping ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(sp.reserve))} for emergencies` : `After the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(entryFee)} entry payment and the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(sp.reserve))} kept for emergencies`,
                                investableMadeOf: selling ? 'money left from the sale, once the move is paid for' : 'bank accounts, term deposits, shares and account-based pensions left after the move',
                                inCare: (0, $d08210caeacdc75a$export$7095ab72ebd46272)(factFind),
                                idPrefix: "rv"
                            }),
                            a.annuity === 'yes' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-2 text-[13.5px] leading-relaxed text-slate-700",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: "We work out how much."
                                    }),
                                    " We test amounts up to that share. Where it would lift the Age Pension, we also test the amount that lifts it most, held to the same share."
                                ]
                            })
                        ]
                    }),
                    selling && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6dbbd81bf88b5930$var$Q, {
                        n: next(),
                        title: allInHome ? 'What should happen to the money left after the sale?' : `If ${v.they} sell, what should happen to the money left after the move?`,
                        testId: "rv-q-uses",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mb-1 text-[13.5px] text-slate-600",
                                children: [
                                    "About ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(sp.afterSale / 10000) * 10000),
                                    ". Tick what ",
                                    v.they,
                                    "'d consider; the plans try each one and mixes of them."
                                ]
                            }),
                            downsizerOk && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6dbbd81bf88b5930$var$Tick, {
                                checked: a.uses.includes('super'),
                                onChange: ()=>toggleUse('super'),
                                testId: "rv-use-super",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: "Super pensions"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                        text: (0, $8849d61d9af733fb$export$229126c85a7ec674).superPensionFromSale()
                                    }),
                                    " \u2014 up to $300,000 each as a downsizer contribution (the home must have been owned for 10 years or more), drawn as an account-based pension"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6dbbd81bf88b5930$var$Tick, {
                                checked: a.uses.includes('invest'),
                                onChange: ()=>toggleUse('invest'),
                                testId: "rv-use-invest",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: "Invest it"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                        text: (0, $8849d61d9af733fb$export$229126c85a7ec674).investInOwnNames()
                                    }),
                                    " \u2014 in ",
                                    v.their,
                                    " own names"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6dbbd81bf88b5930$var$Tick, {
                                checked: a.uses.includes('property'),
                                onChange: ()=>toggleUse('property'),
                                testId: "rv-use-property",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: "An investment property"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                        text: (0, $8849d61d9af733fb$export$229126c85a7ec674).investmentPropertyFromSale()
                                    }),
                                    ", bought outright from what is left, stamp duty included, in",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: a.purchaseState,
                                        onChange: (e)=>set({
                                                purchaseState: e.target.value
                                            }),
                                        className: "rounded border border-slate-300 px-2 py-0.5 text-[13px]",
                                        "aria-label": "The state the property would be in",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "choose the state"
                                            }),
                                            (0, $669f0c9987a611db$export$2f609b1773ce8fef).map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: s.code,
                                                    children: s.name
                                                }, s.code))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6dbbd81bf88b5930$var$Tick, {
                                checked: a.uses.includes('gift'),
                                onChange: ()=>toggleUse('gift'),
                                testId: "rv-use-gift",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: "Give some to family now"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                        text: (0, $8849d61d9af733fb$export$229126c85a7ec674).giftToLovedOnes()
                                    }),
                                    " \u2014 anything above $10,000 a year ($30,000 over five years) still counts for the Age Pension for five years"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-1.5 text-[13.5px] text-slate-700",
                                children: [
                                    "Anything ",
                                    v.they,
                                    " don't put somewhere stays in ",
                                    v.their,
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: "bank account"
                                    }),
                                    ", and we always test that too, so ",
                                    v.they,
                                    " can see what each choice adds."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-2 flex flex-wrap items-center gap-2 text-[13px] text-slate-600",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Money that is invested is assumed to go into"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: a.investProfile,
                                        onChange: (e)=>set({
                                                investProfile: e.target.value
                                            }),
                                        className: "rounded border border-slate-300 px-2 py-1 text-[13px]",
                                        "aria-label": "How money that is freed up is invested",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Not sure \u2014 assume the most cautious"
                                            }),
                                            (0, $0f2c0a6799fe36da$export$56315028e4277c0c).map((id)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: id,
                                                    children: (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[id].label
                                                }, id))
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-5 text-[13px] text-slate-500",
                children: [
                    "We plan for",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "number",
                        min: 1,
                        max: 30,
                        value: a.years,
                        onChange: (e)=>set({
                                years: Math.min(30, Math.max(1, parseInt(e.target.value, 10) || 1))
                            }),
                        className: "w-14 rounded border border-slate-300 px-1.5 py-0.5 text-center text-[13px] font-semibold text-slate-900",
                        "aria-label": "Years to plan for"
                    }),
                    " years."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-[14px] text-slate-700",
                        children: [
                            "Prefer to set the numbers yourself? ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onBuildYourOwn,
                                className: $6dbbd81bf88b5930$var$link,
                                "data-testid": "rv-build-own",
                                children: "Build a plan yourself instead"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex items-center gap-3",
                        children: [
                            !firstRun && onCancel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onCancel,
                                className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>onRun({
                                        ...a,
                                        homeRoute: allInHome ? 'sell' : a.homeRoute
                                    }),
                                className: "rounded-lg bg-blue-600 px-5 py-2.5 text-[15px] font-semibold text-white hover:bg-blue-700",
                                "data-testid": "rv-run",
                                children: firstRun ? 'Test the ways to fund it' : 'Test the ways again'
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $6dbbd81bf88b5930$export$2e2bcd8739ae039 = $6dbbd81bf88b5930$var$RvQuestions;


/**
 * Step 3's plans — the village on the aged care spine (rebuild, 21 Oct 2026; the agreed mock-up's
 * j1-plans, j1-decided and j1-ap screens).
 *
 *  - Staying put as a strip of the four numbers from step 2 — every card is read against it. When the
 *    client has decided to move (step 1), the strip is "for reference only" and the cards are compared
 *    with each other instead: "The most of the ways to move", "−$X vs the best way to move".
 *  - One line saying the price of the move, in the client's own reasons ("the company and the less
 *    upkeep you're moving for"), and whether the Age Pension survives any way of moving.
 *  - "What matters most to you?" — the four goals; choosing one never re-runs the engine. "Highest Age
 *    Pension" with no way of moving keeping any opens one plain explanation in place of the cards.
 *  - The cards side by side, aligned row by row (owner, 20 Oct 2026): the plan in words, the estate,
 *    Age Pension / Left over each year / Village fees (decision 4, 21 Oct 2026), when the money runs
 *    out, an "Important" or "Worth knowing" line, and the three buttons.
 *  - The ways on: compare, every way tested, things that change the answer, build a plan yourself.
 *
 * Presentation only. Every figure is the engine row's own.
 */ 

var $acw62 = parcelRequire("acw62");


















/**
 * WHERE A DIFFERENT PLAN DOES BETTER — one line per other goal, under the cards (owner, 22 Oct 2026: "why are you
 * putting the best cashflow card with the best legacy card … each section has a specific purpose").
 *
 * A goal shows its own leader, and a second card only for the plan choice rule's near-tie (planChoiceRule.ts:
 * nearly the same estate while locking less away or with a better cashflow). Any other goal led by a different plan
 * is pointed to here, as support at home has done since 20 Oct: which goal, that plan's figure against the plan on
 * screen, what it costs the family, and a link to its tab. Shared by the village, downsizing, granny flat and
 * cashflow & Age Pension.
 */ 
parcelRequire("acw62");

const $3c41b14da14ed8be$var$HEAD = {
    cashflow: 'If more to live on each year matters most',
    pension: 'If the Age Pension matters most',
    legacy: 'If leaving the most to the family matters most'
};
const $3c41b14da14ed8be$var$NAME = {
    cashflow: 'Most left over each year',
    pension: 'The highest Age Pension',
    legacy: 'Leaving the most to the family'
};
const $3c41b14da14ed8be$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
const $3c41b14da14ed8be$var$cf = (n)=>n >= 0 ? `${$3c41b14da14ed8be$var$money(n)} a year to spare` : `${$3c41b14da14ed8be$var$money(Math.abs(n))} a year short`;
const $3c41b14da14ed8be$var$OtherGoalLeaders = ({ others: others, here: here, baseLegacy: baseLegacy = null, baseWord: baseWord, onFocus: onFocus, testId: testId = 'other-goal-leaders' })=>{
    if (!others.length) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-2xl border border-slate-200 bg-white p-5 shadow-card",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "text-[17px] font-bold text-slate-900",
                children: others.length === 1 ? $3c41b14da14ed8be$var$HEAD[others[0].goal] : 'Where a different plan does better'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-1 text-[13px] text-slate-500",
                children: others.length === 1 ? 'The plan above is the best for every other goal.' : 'The plan above is the best for the goal chosen.'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "mt-2 space-y-3 text-[14px] leading-relaxed text-slate-700",
                children: others.map((o)=>{
                    const fact = o.goal === 'cashflow' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            $3c41b14da14ed8be$var$cf(o.cashflow),
                            here ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    ", against ",
                                    $3c41b14da14ed8be$var$cf(here.cashflow),
                                    " with the plan above"
                                ]
                            }) : null
                        ]
                    }) : o.goal === 'pension' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            $3c41b14da14ed8be$var$money(o.pension),
                            " a year of Age Pension",
                            here ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    ", against ",
                                    $3c41b14da14ed8be$var$money(here.pension)
                                ]
                            }) : null
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            $3c41b14da14ed8be$var$money(o.legacy),
                            " left to the family",
                            here ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    ", against ",
                                    $3c41b14da14ed8be$var$money(here.legacy)
                                ]
                            }) : null
                        ]
                    });
                    const dl = baseLegacy != null ? o.legacy - baseLegacy : 0;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            others.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                className: "text-slate-900",
                                children: [
                                    $3c41b14da14ed8be$var$NAME[o.goal],
                                    ": "
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-slate-900",
                                children: o.title
                            }),
                            " gives ",
                            fact,
                            ".",
                            baseLegacy != null && Math.abs(dl) >= 1 && o.goal !== 'legacy' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    " But it leaves the family ",
                                    $3c41b14da14ed8be$var$money(Math.abs(dl)),
                                    " ",
                                    dl >= 0 ? 'more' : 'less',
                                    " than ",
                                    baseWord,
                                    "."
                                ]
                            }),
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>onFocus(o.goal),
                                className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                children: "See that plan"
                            })
                        ]
                    }, o.goal);
                })
            })
        ]
    });
};
var $3c41b14da14ed8be$export$2e2bcd8739ae039 = $3c41b14da14ed8be$var$OtherGoalLeaders;






const $fff5f5b4635cb028$var$GOAL_CHIP = {
    'Optimal Legacy': 'Leaves the most',
    [(0, $400a08a42b233386$export$920ad41b346ae01a)]: 'Income covers the costs',
    'Optimal Cashflow': 'Most left over each year',
    'Optimal Age Pension': 'Highest Age Pension',
    [(0, $f8ee565b442c040e$export$40de0448f2611c56)]: (0, $5a094123650e8adb$export$a1a7ae9e29edd48c)
};
const $fff5f5b4635cb028$var$isMover = (s)=>s.id !== 'rv-stay-home' && !s.inputs?.stayHome;
const $fff5f5b4635cb028$var$legacyOf = (s)=>Number(s?.snapshot?.legacyValue) || 0;
const $fff5f5b4635cb028$var$pensionOf = (s)=>Number(s?.snapshot?.pension) || 0;
const $fff5f5b4635cb028$var$cashOf = (s)=>Number(s?.snapshot?.netCashflow) || 0;
const $fff5f5b4635cb028$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
const $fff5f5b4635cb028$var$signed = (n)=>`${n >= 0 ? '+' : "\u2212"}${$fff5f5b4635cb028$var$money(Math.abs(n))}`;
/** Why a plan's Age Pension differs from staying put, in four words. */ function $fff5f5b4635cb028$var$pensionReason(row) {
    const inputs = row.inputs || {};
    if (inputs.rentHome === true) return 'the rented home is counted';
    if (inputs.fundFrom === 'sell_home') return 'the sale money is counted';
    if (inputs.fundFrom === 'investment_property') return 'the sale money is counted';
    return null;
}
const $fff5f5b4635cb028$var$RvPlansView = ({ factFind: factFind, strategies: strategies, stayHome: stayHome, recommended: recommended, setAside: setAside, villageInputs: villageInputs, annualOngoing: annualOngoing, horizonYears: horizonYears, ownToday: ownToday, focus: focus, onFocus: onFocus, chosenId: chosenId, onChoose: onChoose, onExplain: onExplain, onRisks: onRisks, renderDetail: renderDetail, onAllWays: onAllWays, onChanges: onChanges, onBuildYourOwn: onBuildYourOwn, onAdvice: onAdvice, onChangeDecided: onChangeDecided, notices: notices, onIncomeOnly: onIncomeOnly })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const goals = factFind?.goals || {};
    const decided = goals.rvDecided === 'decided';
    const village = String(goals.rvVillageName || '').trim() || 'the village';
    const [openDetail, setOpenDetail] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [why, setWhy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [comparing, setComparing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const yrs = `${horizonYears} ${horizonYears === 1 ? 'year' : 'years'}`;
    const entryFee = Number(villageInputs.entryFee) || 0;
    const movers = strategies.filter($fff5f5b4635cb028$var$isMover);
    const byName = (name)=>strategies.find((s)=>s.name === name) ?? null;
    const fullRow = (r)=>r?.strategy?.name ? byName(r.strategy.name) || r.strategy : null;
    const coveredSame = (0, $400a08a42b233386$export$b8b8a2cedd92aa3a)(recommended);
    const effective = focus === 'covered' && coveredSame ? 'legacy' : focus;
    const base = stayHome?.snapshot ? stayHome : null;
    const bestMover = movers.length ? movers.reduce((top, s)=>$fff5f5b4635cb028$var$legacyOf(s) > $fff5f5b4635cb028$var$legacyOf(top) ? s : top, movers[0]) : null;
    const noPensionAnyWay = movers.length > 0 && movers.every((s)=>$fff5f5b4635cb028$var$pensionOf(s) < 1);
    const pensionStops = noPensionAnyWay && $fff5f5b4635cb028$var$pensionOf(base) >= 1;
    const leader = fullRow((0, $f8ee565b442c040e$export$cf9821b188ee27f0)(recommended, effective));
    const secondEntry = effective === 'legacy' ? recommended.find((r)=>r.label === (0, $f8ee565b442c040e$export$40de0448f2611c56) && r.second) ?? null : null;
    const secondRow = secondEntry ? fullRow(secondEntry) : null;
    const estateEntry = recommended.find((r)=>r.label === 'Optimal Legacy') ?? null;
    /*
     * ONE CARD PER GOAL, A SECOND ONLY WITH A PURPOSE (owner, 22 Oct 2026: "each section has a specific purpose … only
     * show the second card when there is a purpose to it"). The second card is the plan choice rule's near-tie beside
     * the estate leader (nearly the same estate, less locked away or a better cashflow — planChoiceRule.ts), as aged
     * care and support at home do. Another goal's leader is pointed to in one line under the cards (OtherGoalLeaders).
     */ const showPensionNote = effective === 'pension' && noPensionAnyWay;
    const shown = showPensionNote || !leader ? [] : [
        leader,
        ...secondRow && secondRow.name !== leader.name ? [
            secondRow
        ] : []
    ];
    const others = [
        'legacy',
        'cashflow',
        'pension'
    ].filter((g)=>g !== effective).map((g)=>({
            g: g,
            row: fullRow((0, $f8ee565b442c040e$export$cf9821b188ee27f0)(recommended, g))
        })).filter((x)=>!!x.row && !shown.some((s)=>s.name === x.row.name)).map((x)=>({
            goal: x.g,
            title: (0, $7175ce4c598409db$export$6078d665f40b52df)(x.row, factFind, entryFee).title,
            legacy: $fff5f5b4635cb028$var$legacyOf(x.row),
            cashflow: $fff5f5b4635cb028$var$cashOf(x.row),
            pension: $fff5f5b4635cb028$var$pensionOf(x.row)
        }));
    // “Income covers the costs” only on a plan that does: when none does, that goal falls back to the estate leader,
    // and the label on a plan that is short each year would contradict its own figures (review, 22 Oct 2026).
    const labelsFor = (row)=>recommended.filter((r)=>r.strategy?.name === row.name).map((r)=>String(r.label)).filter((l)=>l !== (0, $400a08a42b233386$export$920ad41b346ae01a) || (Number(row.snapshot?.netCashflow) || 0) >= 0);
    const chipFor = (l)=>l === 'Optimal Legacy' ? (0, $5a094123650e8adb$export$a035dca5f387c63d)(estateEntry?.lead) : l === (0, $f8ee565b442c040e$export$40de0448f2611c56) && secondEntry?.second ? (0, $5a094123650e8adb$export$8d9f0aa086032e89)(secondEntry.second) : $fff5f5b4635cb028$var$GOAL_CHIP[l];
    // What every card is measured against: staying put, or — decided to move — the best way to move.
    const against = decided ? bestMover : base;
    const againstWord = decided ? 'the best way to move' : (0, $1a5a24a0286ded56$export$b3949d624101f360)('village', {
        rents: (0, $1a5a24a0286ded56$export$71623450cbaee3cf)(factFind)
    }).word;
    const maxGain = Math.max(1, ...shown.map((s)=>Math.abs($fff5f5b4635cb028$var$legacyOf(s) - $fff5f5b4635cb028$var$legacyOf(against))));
    const { dmf: dmf } = (0, $a5e43ea76f631c99$export$92ec836666aacd49)(villageInputs, horizonYears);
    // The price of the move, in the client's reasons.
    const reasons = (0, $47cb8579212c1476$export$6667cb96c719af84)((0, $47cb8579212c1476$export$1c14447c2c2991eb)(goals.rvWhyMove), goals.rvWhyMoveOther);
    const cost = base && bestMover ? $fff5f5b4635cb028$var$legacyOf(base) - $fff5f5b4635cb028$var$legacyOf(bestMover) : 0;
    const homeValue = Number(factFind?.home?.value) || 0;
    const verdict = base && bestMover ? cost > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                children: [
                    "Moving to ",
                    village,
                    " costs ",
                    v.them,
                    " at least ",
                    $fff5f5b4635cb028$var$money(cost),
                    " over about ",
                    yrs,
                    ", against staying put."
                ]
            }),
            ' ',
            reasons && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "That is the price of the ",
                    reasons,
                    " ",
                    v.you ? "you're" : `${v.they} ${v.are}`,
                    " moving for. "
                ]
            }),
            homeValue > entryFee && entryFee > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "The family home is worth more than the unit",
                    pensionStops ? ',' : '.',
                    " "
                ]
            }),
            pensionStops && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    homeValue > entryFee && entryFee > 0 ? 'and' : '',
                    " ",
                    v.possessive,
                    " Age Pension stops in every way of moving. "
                ]
            }),
            "We tested ",
            strategies.length,
            " ways; below are the least costly, and the easiest to live on."
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                children: [
                    "Moving to ",
                    village,
                    " can leave the family ",
                    $fff5f5b4635cb028$var$money(-cost),
                    " more than staying put over about ",
                    yrs
                ]
            }),
            ", on the best way of doing it.",
            ' ',
            pensionStops && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    v.Possessive,
                    " Age Pension stops in every way of moving. "
                ]
            }),
            "We tested ",
            strategies.length,
            " ways; below are the strongest."
        ]
    }) : null;
    const goalSubs = {
        legacy: decided ? 'Of the ways to move' : cost > 0 ? 'Smallest cost against staying put' : `Biggest estate after about ${yrs}`,
        covered: coveredSame ? 'Same plan as "leave the most"' : 'Pays its way without savings',
        cashflow: 'Easiest cashflow',
        pension: noPensionAnyWay ? effective === 'pension' ? 'No way of moving keeps any' : "No way of moving keeps any \u2014 see why" : 'Most government support'
    };
    const card = (row)=>{
        const key = String(row.id ?? row.name);
        const words = (0, $7175ce4c598409db$export$6078d665f40b52df)(row, factFind, entryFee);
        const chip = labelsFor(row).map(chipFor).filter(Boolean).join(" \xb7 ") || null;
        const delta = against ? $fff5f5b4635cb028$var$legacyOf(row) - $fff5f5b4635cb028$var$legacyOf(against) : null;
        const isBestOfMoves = decided && bestMover && row.name === bestMover.name;
        const pDelta = base ? $fff5f5b4635cb028$var$pensionOf(row) - $fff5f5b4635cb028$var$pensionOf(base) : 0;
        const cDelta = base ? $fff5f5b4635cb028$var$cashOf(row) - $fff5f5b4635cb028$var$cashOf(base) : 0;
        const reason = $fff5f5b4635cb028$var$pensionReason(row);
        const numbers = [
            {
                label: 'Age Pension',
                value: $fff5f5b4635cb028$var$pensionOf(row),
                unit: 'a year',
                vs: base && Math.abs(pDelta) >= 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: `font-bold ${pDelta > 0 ? 'text-emerald-700' : 'text-rose-700'}`,
                            children: [
                                $fff5f5b4635cb028$var$signed(pDelta),
                                " a year"
                            ]
                        }),
                        reason && pDelta < 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                " \u2014 ",
                                reason
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: " vs staying put"
                        })
                    ]
                }) : 'the same as staying put',
                tone: pDelta > 0 ? 'good' : 'neutral',
                onWhy: ()=>setWhy({
                        row: row,
                        page: 'pension'
                    })
            },
            {
                label: $fff5f5b4635cb028$var$cashOf(row) < 0 ? 'Each year, short by' : 'Left over each year',
                value: Math.abs($fff5f5b4635cb028$var$cashOf(row)),
                vs: base ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: `font-bold ${cDelta >= 0 ? 'text-emerald-700' : 'text-rose-700'}`,
                            children: [
                                $fff5f5b4635cb028$var$signed(cDelta),
                                " a year"
                            ]
                        }),
                        " vs staying put (",
                        $fff5f5b4635cb028$var$cashOf(base) < 0 ? `short ${$fff5f5b4635cb028$var$money(-$fff5f5b4635cb028$var$cashOf(base))}` : `${$fff5f5b4635cb028$var$money($fff5f5b4635cb028$var$cashOf(base))} to spare`,
                        ")"
                    ]
                }) : '',
                tone: $fff5f5b4635cb028$var$cashOf(row) >= 0 ? cDelta > 0 ? 'good' : 'neutral' : 'neutral',
                onWhy: ()=>setWhy({
                        row: row,
                        page: 'cashflow'
                    })
            },
            {
                label: 'Village fees',
                value: annualOngoing,
                unit: 'a year',
                vs: dmf > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "departure fee ",
                        $fff5f5b4635cb028$var$money(dmf),
                        " if ",
                        v.they,
                        " left after ",
                        yrs
                    ]
                }) : 'no departure fee on this contract',
                onWhy: ()=>setWhy({
                        row: row,
                        page: 'fees'
                    })
            }
        ];
        /*
         * WHEN THE MONEY RUNS OUT, AS EVERY MODULE'S CARD SAYS IT (owner, 22 Oct 2026): income covers it, or every
         * account in the order it is drawn and when each runs low (runwayCardLine) — the village's own wording, and
         * its bank-account-only flag, are gone. The one village fact it does not say is kept: a plan that covers its
         * costs with almost nothing to spare (said under "Worth knowing" instead once the family has decided).
         */ const cashLeft = $fff5f5b4635cb028$var$cashOf(row);
        const runText = row.projections && row.projections.length ? (0, $2ddaae90639b5011$export$7526d1fcb4423629)({
            rows: row.projections,
            factFind: factFind,
            horizonYears: horizonYears,
            spentOn: 'the entry payment'
        }) : null;
        const runway = !runText && row.projections && row.projections.length ? (0, $0fe89e03b6df746e$export$464558962ff4a811)(row.projections, horizonYears) : null;
        const thin = !decided && cashLeft >= 0 && cashLeft < 2000 ? ` There is almost nothing to spare, though: ${$fff5f5b4635cb028$var$money(cashLeft)} a year.` : '';
        const runline = runText ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "When the money runs out:"
                }),
                " ",
                runText,
                thin
            ]
        }) : runway ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "When the money runs out:"
                }),
                " ",
                runway.headline,
                runway.flag ? ` ${runway.flag}` : '',
                thin
            ]
        }) : null;
        const rented = row.inputs?.rentHome === true;
        const annuity = (0, $4852c06b0c4c15b4$export$6d4129e74a169c1e)(row, factFind);
        const horizonWarning = (0, $4852c06b0c4c15b4$export$ee2616655543b3d)(row, factFind);
        const onlyWay = row.onlyWayToFund === true || row.inputs?.onlyWayToFund === true;
        const lines = [];
        if (onlyWay) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "The only way to fund this unit."
                }),
                " ",
                v.you ? 'You said' : `${v.Names} said`,
                " keep the home, but keeping it can't raise the ",
                $fff5f5b4635cb028$var$money(entryFee),
                ", so the plans that sell are shown."
            ]
        }));
        const baseDelta = base ? $fff5f5b4635cb028$var$legacyOf(row) - $fff5f5b4635cb028$var$legacyOf(base) : 0;
        if (!decided && baseDelta < -1) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-rose-700",
                    children: "Important:"
                }),
                " the move costs the family ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-rose-700",
                    children: $fff5f5b4635cb028$var$money(-baseDelta)
                }),
                " against staying put",
                $fff5f5b4635cb028$var$pensionOf(row) < 1 && $fff5f5b4635cb028$var$pensionOf(base) >= 1 ? ', and the Age Pension stops' : '',
                ".",
                rented ? ` It also depends on the rent and the costs being right \u{2014} check land tax. ${0, $203e38d6e6c434f4$export$b96695c1a4aaa70d}` : row.inputs?.fundFrom === 'sell_home' ? ' Selling costs, the departure fee and any lost pension all come out of the estate.' : ''
            ]
        }));
        else if (decided) {
            const parts = [];
            if (rented) parts.push('it depends on the rent and the costs being right, so check land tax', (0, $203e38d6e6c434f4$export$b96695c1a4aaa70d).replace(/\.$/, ''));
            if (cashLeft >= 0 && cashLeft < 2000) parts.push(`it leaves only ${$fff5f5b4635cb028$var$money(cashLeft)} a year to spare`);
            if (!isBestOfMoves && delta != null && delta < -1 && cashLeft >= 2000) parts.push(`it gives ${$fff5f5b4635cb028$var$money(cashLeft)} a year to live on, for ${$fff5f5b4635cb028$var$money(-delta)} less to the family than the best way to move`);
            if (parts.length) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "text-slate-900",
                        children: "Worth knowing:"
                    }),
                    " ",
                    parts.join('. ').replace(/^./, (c)=>c.toUpperCase()),
                    "."
                ]
            }));
        }
        if (annuity && Math.round(annuity.residualPercent) === 0) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "Worth knowing:"
                }),
                " the guaranteed income is income only. It pays the most for life, and nothing from it goes back to the family, even after an early death."
            ]
        }));
        if (horizonWarning) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: horizonWarning
        }));
        const isChosen = chosenId != null && row.id === chosenId;
        /*
         * WHAT THE FAMILY RECEIVES, IF DEATH COMES EARLY (guaranteed income review E4, 21 Oct 2026): on every plan
         * with a guaranteed income, against the same sale with the money invested instead. And income only can't
         * be chosen until the client has confirmed it for this amount (E5).
         */ const gi = (0, $91a0ac81d8d23067$export$32b560717abe61e8)(row, factFind);
        const compare = gi ? (0, $91a0ac81d8d23067$export$c241e21d61e3872b)(row, strategies) : null;
        const familyPanel = gi ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: runline ? 'mt-3' : '',
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
                factFind: factFind,
                personName: gi.personName,
                amount: gi.amount,
                kind: gi.kind,
                incomeAYear: gi.incomeAYear,
                rows: row.projections,
                compareRows: compare?.row.projections ?? null,
                compareNote: compare?.note ?? null,
                horizonYears: horizonYears,
                testId: "rv-annuity-family-panel"
            })
        }) : null;
        const incomeOnly = !!gi && gi.kind === 'incomeOnly';
        const tradeOff = secondEntry?.second && row === secondRow ? (0, $5a094123650e8adb$export$a104569a4d958475)(secondEntry.second, (0, $f94e45ac645ae232$export$3dc27271f5d5c629)) : estateEntry?.lead && row.name === estateEntry.strategy?.name ? (0, $5a094123650e8adb$export$27f705a6fa40271e)(estateEntry.lead, (0, $f94e45ac645ae232$export$3dc27271f5d5c629)) : null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b383720e6b5df564$export$2e2bcd8739ae039), {
            aligned: true,
            testId: "rv-plan-card",
            whyShown: tradeOff || null,
            chip: chip,
            chipTone: "blue",
            title: words.title,
            sub: words.sub,
            legacy: $fff5f5b4635cb028$var$legacyOf(row),
            legacyDelta: delta,
            horizonYears: horizonYears,
            baselineWord: againstWord,
            deltaNote: isBestOfMoves ? 'The most of the ways to move' : undefined,
            bars: delta != null ? {
                gainPct: Math.abs(delta) / maxGain * 100,
                tiedUp: entryFee,
                tiedUpPct: 100
            } : null,
            tiedUpLabel: "Paid into the village",
            numbers: numbers,
            runline: runline || familyPanel ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    runline,
                    familyPanel
                ]
            }) : null,
            worthKnowing: lines.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: lines.map((l, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: l
                    }, i))
            }) : null,
            lines: [],
            chosen: isChosen,
            beforeChoose: incomeOnly && onIncomeOnly ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$4538b371a206da0c), {
                factFind: factFind,
                amount: gi.amount,
                onChange: onIncomeOnly
            }) : undefined,
            chooseHeld: incomeOnly && (0, $91a0ac81d8d23067$export$b263a858888cc4a2)(row, factFind),
            onExplain: ()=>onExplain(row),
            onRisks: ()=>onRisks(row),
            onChoose: ()=>onChoose(row),
            chooseLabel: chosenId != null && !isChosen ? 'Choose this instead' : 'Choose this plan',
            chosenStrip: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2194d8b5de21e3ff$export$4df4eb62309771d0), {
                possessiveFile: v.possessive,
                onAdvice: onAdvice,
                onCustomise: ()=>onBuildYourOwn(row)
            }),
            detail: renderDetail(row),
            detailOpen: openDetail === key,
            onToggleDetail: ()=>setOpenDetail((d)=>d === key ? null : key),
            detailHint: "where the money comes from and every calculation"
        }, key);
    };
    const Strip = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            "data-testid": "rv-stay-put-strip",
            className: decided ? 'opacity-75' : '',
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-[13px] font-semibold text-slate-500",
                    children: decided ? "For reference only \u2014 staying put" : "Compared with staying put \u2014 the four numbers from step 2"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mt-2 grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-slate-200 bg-slate-200 shadow-card lg:grid-cols-4",
                    children: [
                        {
                            label: 'Age Pension',
                            value: $fff5f5b4635cb028$var$money($fff5f5b4635cb028$var$pensionOf(base)),
                            note: 'a year'
                        },
                        {
                            label: $fff5f5b4635cb028$var$cashOf(base) < 0 ? 'Short each year' : 'Left over each year',
                            value: $fff5f5b4635cb028$var$money(Math.abs($fff5f5b4635cb028$var$cashOf(base))),
                            note: 'money in, less money out',
                            tone: $fff5f5b4635cb028$var$cashOf(base) >= 0 ? 'text-emerald-700' : 'text-rose-700'
                        },
                        {
                            label: `What ${v.you ? 'you' : v.they} own`,
                            value: $fff5f5b4635cb028$var$money(ownToday),
                            note: 'today'
                        },
                        {
                            label: 'Left to the family',
                            value: $fff5f5b4635cb028$var$money($fff5f5b4635cb028$var$legacyOf(base)),
                            note: `after about ${yrs}`
                        }
                    ].map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white px-4 py-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-[12px] font-semibold text-slate-500",
                                    children: c.label
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: `mt-0.5 font-bold tabular-nums leading-tight ${decided ? 'text-[18px]' : 'text-[22px]'} ${c.tone || 'text-slate-900'}`,
                                    children: c.value
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-[12px] text-slate-500",
                                    children: c.note
                                })
                            ]
                        }, c.label))
                })
            ]
        });
    const waysOn = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-3",
                "data-testid": "rv-ways-on",
                children: [
                    shown.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setComparing(true),
                        className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                        "data-testid": "rv-compare",
                        children: "Compare the plans side by side"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onAllWays,
                        className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                        "data-testid": "rv-all-ways",
                        children: [
                            "All ",
                            strategies.length,
                            " ways tested"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onChanges,
                        className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                        "data-testid": "rv-changes",
                        children: "Things that change the answer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>onBuildYourOwn(null),
                        className: "text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy",
                        "data-testid": "rv-build-your-own",
                        children: "Prefer to set the numbers yourself? Build a plan \u2192"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[13px] text-slate-500",
                "data-testid": "all-plans-open-line",
                children: (0, $5a094123650e8adb$export$af182f21f972ef03)(strategies.length)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] text-slate-500",
                children: [
                    "Figures use the rates in force today and are projections over ",
                    yrs,
                    ", not guarantees."
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-6",
        "data-testid": "rv-plans",
        children: [
            notices,
            decided && verdict && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-xl border border-slate-200 border-l-4 border-l-brand-navy bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700 shadow-card",
                "data-testid": "rv-decided-line",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                        className: "text-slate-900",
                        children: [
                            v.Names,
                            " ",
                            v.have,
                            " decided to move"
                        ]
                    }),
                    ", so these are the best ways to do it, compared with each other.",
                    ' ',
                    cost > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "Moving costs ",
                            v.them,
                            " at least ",
                            $fff5f5b4635cb028$var$money(cost),
                            " over about ",
                            yrs,
                            " against staying put"
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "The best way of moving leaves ",
                            $fff5f5b4635cb028$var$money(-cost),
                            " more than staying put"
                        ]
                    }),
                    pensionStops ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            ", and ",
                            v.possessive,
                            " Age Pension stops"
                        ]
                    }) : null,
                    "; staying put is shown below for reference.",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onChangeDecided,
                        className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                        children: "Still deciding? Change it on step 1"
                    })
                ]
            }),
            base && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Strip, {}),
            !decided && verdict && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `rounded-xl border border-slate-200 border-l-4 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700 shadow-card ${cost > 0 ? 'border-l-rose-500' : 'border-l-emerald-500'}`,
                "data-testid": "rv-verdict",
                children: verdict
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54f65c4595e0c798$export$2e2bcd8739ae039), {
                value: focus,
                onChange: onFocus,
                household: v.names,
                enteringName: v.names,
                horizonYears: horizonYears,
                coveredSameAsBest: coveredSame,
                bestCovers: coveredSame && $fff5f5b4635cb028$var$cashOf(fullRow((0, $f8ee565b442c040e$export$cf9821b188ee27f0)(recommended, 'legacy'))) >= 0,
                waysTested: strategies.length,
                shown: shown.length,
                testedFor: "to fund the move",
                closingNote: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: "Each card says when the savings would run out, and what the village fees and the departure fee are."
                }),
                subs: goalSubs,
                countLine: showPensionNote ? 'No way of moving keeps any Age Pension.' : shown.length === 0 ? 'None leads on this goal.' : undefined
            }),
            showPensionNote ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-2xl border border-slate-200 border-l-4 border-l-brand-navy bg-white p-6 shadow-card",
                "data-testid": "rv-no-pension",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                        className: "text-[19px] font-bold text-slate-900",
                        children: [
                            "No way of moving keeps ",
                            v.possessive,
                            " Age Pension"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-2 text-[15px] leading-relaxed text-slate-700",
                        children: $fff5f5b4635cb028$var$pensionOf(base) >= 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "Staying put, ",
                                v.they,
                                " get",
                                v.s,
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                    children: [
                                        $fff5f5b4635cb028$var$money($fff5f5b4635cb028$var$pensionOf(base)),
                                        " a year"
                                    ]
                                }),
                                ". Once ",
                                v.they,
                                " move, Centrelink counts more of what ",
                                v.they,
                                " own than ",
                                v.couple ? 'a couple is' : 'one person is',
                                " allowed, whichever way ",
                                v.they,
                                " pay for the unit:"
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "Staying put, Centrelink already counts more than ",
                                v.couple ? 'a couple is' : 'one person is',
                                " allowed, and moving doesn't change that:"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                        className: "mt-2 list-disc space-y-1 pl-5 text-[15px] leading-relaxed text-slate-700",
                        children: [
                            homeValue > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            "If ",
                                            v.they,
                                            " keep the home and rent it out,"
                                        ]
                                    }),
                                    " the home counts in full, because it is no longer where ",
                                    v.they,
                                    " live, and the rent counts as income."
                                ]
                            }),
                            homeValue > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            "If ",
                                            v.they,
                                            " sell,"
                                        ]
                                    }),
                                    " the ",
                                    $fff5f5b4635cb028$var$money(Math.max(0, homeValue * 0.975 - entryFee)),
                                    " left after the entry payment counts, wherever it is put."
                                ]
                            }),
                            homeValue <= 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "The savings that are left after the entry payment, and any income from them, are counted."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-3 text-[15px] leading-relaxed text-slate-700",
                        children: "So this goal can't tell the plans apart. Choose one of the other three goals to compare them."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-4 flex flex-wrap gap-3",
                        children: [
                            bestMover && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>setWhy({
                                        row: bestMover,
                                        page: 'pension'
                                    }),
                                className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                                children: [
                                    "Why ",
                                    v.possessive,
                                    " Age Pension is $0"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>onFocus('legacy'),
                                className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                                children: "Compare the plans on another goal"
                            })
                        ]
                    })
                ]
            }) : shown.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
                "data-testid": "rv-no-leader",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-[19px] font-bold text-slate-900",
                        children: "No plan leads on this goal"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 text-[14px] leading-relaxed text-slate-700",
                        children: [
                            "Choose another goal above, or see all ",
                            strategies.length,
                            " ways tested."
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `grid grid-cols-1 gap-5 ${shown.length > 1 ? 'lg:grid-cols-2' : ''}`,
                "data-testid": "rv-plan-cards",
                children: [
                    chosenId != null && !shown.some((s)=>s.id === chosenId) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: shown.length > 1 ? 'lg:col-span-2' : '',
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2194d8b5de21e3ff$export$4df4eb62309771d0), {
                            possessiveFile: v.possessive,
                            onAdvice: onAdvice,
                            offCard: true,
                            testId: "chosen-plan-off-card"
                        })
                    }),
                    shown.map(card)
                ]
            }),
            shown.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c41b14da14ed8be$export$2e2bcd8739ae039), {
                others: others,
                here: {
                    legacy: $fff5f5b4635cb028$var$legacyOf(shown[0]),
                    cashflow: $fff5f5b4635cb028$var$cashOf(shown[0]),
                    pension: $fff5f5b4635cb028$var$pensionOf(shown[0])
                },
                baseLegacy: base ? $fff5f5b4635cb028$var$legacyOf(base) : null,
                baseWord: "staying put",
                onFocus: onFocus,
                testId: "rv-other-leaders"
            }),
            setAside.map((sa)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8dcabb024256f5a9$export$2e2bcd8739ae039), {
                    testId: "rv-set-aside",
                    className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700",
                    note: (link)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                setAside.length === 1 ? 'One plan was set aside: ' : '',
                                (0, $7175ce4c598409db$export$6078d665f40b52df)(sa.strategy, factFind, entryFee).title.replace(/^./, (c)=>c.toLowerCase()),
                                " would lead on ",
                                sa.labels.map((l)=>({
                                        'Optimal Legacy': 'the estate',
                                        'Optimal Cashflow': 'cashflow',
                                        'Optimal Age Pension': 'the Age Pension'
                                    })[l] || 'one goal').join(' and '),
                                ", but ",
                                sa.warning.replace(/^./, (c)=>c.toLowerCase()),
                                ' ',
                                link
                            ]
                        }),
                    renderCard: ()=>card(sa.strategy)
                }, String(sa.strategy.id ?? sa.strategy.name))),
            waysOn,
            comparing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                titleId: "rv-compare-title",
                title: "The plans side by side",
                eyebrow: `Over about ${yrs}`,
                onClose: ()=>setComparing(false),
                size: "xl",
                testId: "rv-compare-dialog",
                flush: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "min-w-full text-[14px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    className: "border-b border-slate-200 text-left text-[12px] font-semibold text-slate-500",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-5 py-3",
                                            children: " "
                                        }),
                                        base && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-5 py-3",
                                            children: "Staying put"
                                        }),
                                        shown.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3",
                                                children: (0, $7175ce4c598409db$export$6078d665f40b52df)(s, factFind, entryFee).title
                                            }, String(s.id)))
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                className: "tabular-nums",
                                children: [
                                    [
                                        {
                                            label: 'Left to the family',
                                            pick: $fff5f5b4635cb028$var$legacyOf
                                        },
                                        {
                                            label: 'Age Pension, a year',
                                            pick: $fff5f5b4635cb028$var$pensionOf
                                        },
                                        {
                                            label: 'Left over each year',
                                            pick: $fff5f5b4635cb028$var$cashOf
                                        }
                                    ].map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "border-b border-slate-100",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3 text-left font-semibold text-slate-700",
                                                    children: r.label
                                                }),
                                                base && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-5 py-3",
                                                    children: $fff5f5b4635cb028$var$money(r.pick(base))
                                                }),
                                                shown.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 font-semibold text-slate-900",
                                                        children: $fff5f5b4635cb028$var$money(r.pick(s))
                                                    }, String(s.id)))
                                            ]
                                        }, r.label)),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "border-b border-slate-100",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3 text-left font-semibold text-slate-700",
                                                children: "Village fees, a year"
                                            }),
                                            base && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-5 py-3",
                                                children: "\u2014"
                                            }),
                                            shown.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-5 py-3",
                                                    children: $fff5f5b4635cb028$var$money(annualOngoing)
                                                }, String(s.id)))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3 text-left font-semibold text-slate-700",
                                                children: "Paid into the village"
                                            }),
                                            base && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-5 py-3",
                                                children: "\u2014"
                                            }),
                                            shown.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-5 py-3",
                                                    children: $fff5f5b4635cb028$var$money(entryFee)
                                                }, String(s.id)))
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            why && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                titleId: "rv-why-title",
                eyebrow: (0, $7175ce4c598409db$export$6078d665f40b52df)(why.row, factFind, entryFee).title,
                title: why.page === 'pension' ? 'Why the Age Pension is what it is' : why.page === 'cashflow' ? 'Left over each year' : 'The village fees',
                onClose: ()=>setWhy(null),
                testId: "rv-why-dialog",
                children: [
                    why.page === 'pension' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-3 text-[14px] leading-relaxed text-slate-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "Staying put: ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            $fff5f5b4635cb028$var$money($fff5f5b4635cb028$var$pensionOf(base)),
                                            " a year"
                                        ]
                                    }),
                                    ". With this plan: ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            $fff5f5b4635cb028$var$money($fff5f5b4635cb028$var$pensionOf(why.row)),
                                            " a year"
                                        ]
                                    }),
                                    " in the first year.",
                                    $fff5f5b4635cb028$var$pensionReason(why.row) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            " The difference is mostly because ",
                                            $fff5f5b4635cb028$var$pensionReason(why.row),
                                            "."
                                        ]
                                    }) : null
                                ]
                            }),
                            (()=>{
                                // The plan's own first-year count, in plain words — not step 2's "today" panel, whose
                                // "room to move" examples are not advice to give on a plan.
                                const f = why.row.projections?.[0]?.financials;
                                const pos = (0, $eec331ce661055d2$export$d318875bf548d09)(f?.socialSecurityBreakdown, f?.socialSecurity, factFind?.adviceFor === 'couple');
                                if (!pos) return null;
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    "data-testid": "rv-why-pension-count",
                                    children: [
                                        "With this plan Centrelink counts ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: $fff5f5b4635cb028$var$money(pos.assessableAssets)
                                        }),
                                        " of assets and ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                            children: [
                                                $fff5f5b4635cb028$var$money(pos.assessableIncome),
                                                " a year"
                                            ]
                                        }),
                                        " of income.",
                                        ' ',
                                        "The ",
                                        pos.determinedBy === 'income' ? 'income' : 'assets',
                                        " test sets the pension: it gives ",
                                        $fff5f5b4635cb028$var$money(pos.determinedBy === 'income' ? pos.incomeTestPension : pos.assetTestPension),
                                        " a year, against ",
                                        $fff5f5b4635cb028$var$money(pos.determinedBy === 'income' ? pos.assetTestPension : pos.incomeTestPension),
                                        " on the other test, and the lower of the two is paid."
                                    ]
                                });
                            })()
                        ]
                    }),
                    why.page === 'cashflow' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-3 text-[14px] leading-relaxed text-slate-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "Money in, less money out, in the first year: ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: $fff5f5b4635cb028$var$cashOf(why.row) < 0 ? `short ${$fff5f5b4635cb028$var$money(-$fff5f5b4635cb028$var$cashOf(why.row))}` : `${$fff5f5b4635cb028$var$money($fff5f5b4635cb028$var$cashOf(why.row))} to spare`
                                    }),
                                    ". Staying put: ",
                                    $fff5f5b4635cb028$var$cashOf(base) < 0 ? `short ${$fff5f5b4635cb028$var$money(-$fff5f5b4635cb028$var$cashOf(base))}` : `${$fff5f5b4635cb028$var$money($fff5f5b4635cb028$var$cashOf(base))} to spare`,
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "The village fees of ",
                                    $fff5f5b4635cb028$var$money(annualOngoing),
                                    " a year are part of the money out. ",
                                    why.row.inputs?.rentHome === true ? 'The rent from the home, after its costs and the weeks it sits empty, is part of the money in.' : why.row.inputs?.fundFrom === 'sell_home' ? 'What the sale money earns, wherever it is put, is part of the money in.' : 'What the savings left after the entry payment earn is part of the money in.'
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Explain this sets out every line of it, year by year."
                            })
                        ]
                    }),
                    why.page === 'fees' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-3 text-[14px] leading-relaxed text-slate-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "The village charges ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            $fff5f5b4635cb028$var$money(annualOngoing),
                                            " a year"
                                        ]
                                    }),
                                    " for running the village \u2014 the same in every way of paying for the unit."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "When ",
                                    v.they,
                                    " leave, the village keeps a departure fee from the entry payment: about ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: $fff5f5b4635cb028$var$money(dmf)
                                    }),
                                    " after ",
                                    yrs,
                                    " on this contract. It is already counted in what each plan leaves the family."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $fff5f5b4635cb028$export$2e2bcd8739ae039 = $fff5f5b4635cb028$var$RvPlansView;


/**
 * The village plan page (rebuild M2, 21 Oct 2026; the agreed mock-up's j1-hub and j2-hub).
 *
 * Where the module opens once a plan is chosen: why they are moving and what it costs, the contract, the
 * chosen plan with its numbers against staying put, the advice document and the next step (legal advice on
 * the contract), the other models the family can start, and the ways on. Every figure is the chosen card's
 * own, as it was chosen.
 *
 * ON THE SHARED PIECES (owner, 22 Oct 2026: "Yes i want this all consistent"). The card, the document and next
 * step, "Model something else" and the links are the ones every module's plan page uses
 * (components/strategy/ChosenPlanPage.tsx), in aged care's shape: the village's own facts — the Age Pension,
 * what each year leaves over or is short by, and the village fees with what leaving would cost — are the
 * card's figure strip, not tables of their own.
 */ 
parcelRequire("acw62");




/**
 * The chosen village plan, as the plan page and Home read it (village rebuild M2, 21 Oct 2026 — the
 * Support at home pattern, sahChosenPlan.ts).
 *
 * ONE PLAN PER UNIT (owner, 20–21 Oct 2026). A family may model more than one village or unit; each keeps
 * one saved plan, keyed by the village's name and the entry payment, and one of them is the chosen plan.
 * Choosing another plan for the same unit replaces that unit's plan; choosing for another unit keeps the
 * first one saved and marks the new one chosen.
 *
 * The card the family chose is stored on the record — its figures, staying put's at the time, the plan in
 * words, the contract — so the plan page shows exactly what was chosen, with no re-run in between.
 */ /**
 * CHOOSING A PLAN, THE SAME WAY IN EVERY MODULE (module reviews, 18 Oct 2026).
 *
 * The village, downsizing, granny flat and cashflow modules saved a NEW record on every click of
 * "Select Strategy" — re-clicking "Selected ✓", or choosing again from the full list, each added one —
 * and never marked any as chosen, so Home and the menu could only ever say "N plans saved, none chosen".
 *
 * `withChosenPlan` is the one rule: choosing a plan replaces any earlier save of the SAME plan (same
 * type, same engine strategy id, or the same name for a hand-built one), un-chooses the rest of that
 * type, and adds the new record as the chosen one. Plans of other types are untouched — choosing a
 * village plan does not un-choose the aged care plan.
 */ const $7445cb9532643693$var$sameEnginePlan = (a, b)=>{
    const ida = a.inputs?.engineStrategyId;
    const idb = b.inputs?.engineStrategyId;
    if (ida != null && idb != null) return String(ida) === String(idb) && $7445cb9532643693$var$sameContext(a, b);
    return !!a.name && a.name === b.name && (a.source ?? '') === (b.source ?? '') && $7445cb9532643693$var$sameContext(a, b);
};
/** Two saves of the "same" plan for a DIFFERENT village, home or support cost are different plans. */ const $7445cb9532643693$var$sameContext = (a, b)=>JSON.stringify(a.inputs?.planContext ?? null) === JSON.stringify(b.inputs?.planContext ?? null);
function $7445cb9532643693$export$bda89f6290a6f044(prev, record) {
    const list = (prev || []).filter((p)=>!(p.type === record.type && $7445cb9532643693$var$sameEnginePlan(p, record)));
    return [
        ...list.map((p)=>p.type === record.type && p.chosen ? {
                ...p,
                chosen: false
            } : p),
        {
            ...record,
            chosen: true
        }
    ];
}
function $7445cb9532643693$export$2c767796580638af(plans, type) {
    return (plans || []).find((p)=>p.type === type && p.chosen === true) ?? null;
}


function $accc76cd2fa8edd9$export$5a65a0ca975061d(plan) {
    if (!plan || plan.source !== 'suggestion_engine') return null;
    const id = plan.inputs?.engineStrategyId;
    return typeof id === 'string' ? id : null;
}
const $accc76cd2fa8edd9$export$a8fb5c260af4d7d3 = '2026-10-22T07:38:26Z';
function $accc76cd2fa8edd9$export$2e71dc40067e1cea(plan) {
    const card = plan?.inputs?.card;
    if (!card?.runLine) return null;
    if (card.origin === 'manual') {
        const chosenAt = Date.parse(String(plan?.createdAt || ''));
        if (!Number.isFinite(chosenAt) || chosenAt < Date.parse($accc76cd2fa8edd9$export$a8fb5c260af4d7d3)) return null;
    }
    return card.runLine;
}
function $accc76cd2fa8edd9$export$a3fbef763ac12540(name, entryFee) {
    return `${String(name || '').trim().toLowerCase()}|${Math.round(Number(entryFee) || 0)}`;
}
function $accc76cd2fa8edd9$export$75afc4671887f877(prev, record) {
    const key = record.inputs?.unitKey;
    const others = (prev || []).filter((p)=>!(p.type === 'retirement_village' && key != null && p.inputs?.unitKey === key));
    return (0, $7445cb9532643693$export$bda89f6290a6f044)(others, record);
}
function $accc76cd2fa8edd9$export$d11c0ebb38aa6e79(list) {
    const hit = (list || []).find((s)=>s?.type === 'retirement_village' && s.chosen === true && s.inputs?.card);
    return hit ?? null;
}
function $accc76cd2fa8edd9$export$48ec0984e7b656be(list) {
    const withCard = (list || []).filter((s)=>s?.type === 'retirement_village' && s.inputs?.card);
    return [
        ...withCard
    ].sort((a, b)=>Number(b.chosen === true) - Number(a.chosen === true));
}
const $accc76cd2fa8edd9$export$1b00af1e78405459 = 'careCompanionRvStartFresh';
const $accc76cd2fa8edd9$export$9770b2ddd15762ac = 'careCompanionRvAnotherUnit';
function $accc76cd2fa8edd9$export$c525dcbecedbe929(key) {
    try {
        const v = window.sessionStorage.getItem(key);
        if (v) window.sessionStorage.removeItem(key);
        return !!v;
    } catch  {
        return false;
    }
}



/**
 * The plan page's line for a chosen plan whose figures are out of date (owner, 25 Oct 2026: the village, downsizing,
 * the granny flat and cashflow say so as aged care and Support at home do). Aged care's idiom: a white panel with a
 * slate outline and an amber rail (no pastel fill), the reason in plain words, and a way to choose again.
 */ 
parcelRequire("acw62");
function $e32778aa0d8016bc$export$582b8e8b67199c5d({ reason: reason, chosenOn: chosenOn = null, onChooseAgain: onChooseAgain, testId: testId = 'plan-out-of-date' }) {
    if (!reason) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] text-slate-700",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "text-slate-900",
                        children: reason.replace(/ — open it to choose again\.$/, '.')
                    }),
                    " The figures below are the ones it was chosen on",
                    chosenOn ? `, ${chosenOn}` : '',
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onChooseAgain,
                className: "rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-[13px] font-semibold text-slate-800 hover:border-blue-300",
                children: "Choose a plan again"
            })
        ]
    });
}



const $f295042478994e3b$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
const $f295042478994e3b$var$signed = (n)=>`${n >= 0 ? '+' : "\u2212"}${$f295042478994e3b$var$money(Math.abs(n))}`;
const $f295042478994e3b$var$dateWords = (iso)=>iso ? new Date(iso).toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }) : null;
const $f295042478994e3b$var$link = 'font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900';
const $f295042478994e3b$var$RvHub = ({ factFind: factFind, plan: plan, unitCount: unitCount, entryDate: entryDate, onChangeContract: onChangeContract, onAnotherUnit: onAnotherUnit, onStartFresh: onStartFresh, onAllPlans: onAllPlans, onExplain: onExplain, onRisks: onRisks, onAdvice: onAdvice, onBuild: onBuild, onBuildNew: onBuildNew, outOfDate: outOfDate = null, onGuide: onGuide, onAssumptions: onAssumptions, onHome: onHome })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const card = plan.inputs.card;
    const goals = factFind?.goals || {};
    const reasons = (0, $47cb8579212c1476$export$6667cb96c719af84)((0, $47cb8579212c1476$export$1c14447c2c2991eb)(goals.rvWhyMove), goals.rvWhyMoveOther);
    const base = card.baseline;
    const delta = base ? card.plan.legacy - base.legacy : null;
    const yrs = `${card.horizonYears} ${card.horizonYears === 1 ? 'year' : 'years'}`;
    const village = card.village.name || 'the village';
    const cash = (n)=>n < 0 ? `short ${$f295042478994e3b$var$money(-n)}` : `${$f295042478994e3b$var$money(n)} to spare`;
    const feesWords = card.village.fees > 0 ? `${$f295042478994e3b$var$money(card.village.fees)} a ${card.village.feesFrequency === 'weekly' ? 'week' : 'month'} in fees` : 'no ongoing fees';
    const when = entryDate ? `Moving on ${$f295042478994e3b$var$dateWords(entryDate)}` : 'Moving now';
    const pensionChange = base ? card.plan.pension - base.pension : null;
    const manual = card.origin === 'manual';
    // This plan's own runway line only — a hand-built card from before it could save one shows none (rvCardRunLine).
    const runLine = (0, $accc76cd2fa8edd9$export$2e71dc40067e1cea)(plan);
    // The strip: what the plan pays and leaves each year against staying put, and what the village costs
    // (aged care's rule: a cost or a shortfall stays plain; only money left over is green).
    const figures = [
        {
            label: 'Age Pension',
            value: $f295042478994e3b$var$money(card.plan.pension),
            unit: 'a year',
            note: pensionChange == null ? undefined : Math.abs(pensionChange) >= 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: `font-semibold ${pensionChange > 0 ? 'text-emerald-700' : 'text-rose-700'}`,
                children: [
                    $f295042478994e3b$var$signed(pensionChange),
                    " a year vs staying put"
                ]
            }) : 'the same as staying put',
            testId: 'rv-hub-pension'
        },
        {
            label: card.plan.cashflow < 0 ? 'Each year, short by' : 'Left over each year',
            value: $f295042478994e3b$var$money(Math.abs(card.plan.cashflow)),
            tone: card.plan.cashflow < 0 ? 'plain' : 'good',
            note: base ? `staying put: ${cash(base.cashflow)}` : undefined,
            testId: 'rv-hub-cashflow'
        },
        {
            label: 'Village fees',
            value: $f295042478994e3b$var$money(card.village.annualOngoing),
            unit: 'a year',
            note: `departure fee ${$f295042478994e3b$var$money(card.village.departureFee)} after ${yrs} \xb7 ${$f295042478994e3b$var$money(card.village.backAfter)} back`,
            testId: 'rv-hub-fees'
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mx-auto max-w-5xl space-y-4",
        "data-testid": "rv-hub",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[13px] text-slate-500",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onHome,
                                className: "underline decoration-dotted underline-offset-2 hover:text-slate-800",
                                children: "Home"
                            }),
                            " \u203A Retirement village"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                        className: "mt-2 text-[32px] font-bold leading-tight tracking-tight text-brand-navy",
                        "data-testid": "rv-hub-title",
                        children: [
                            v.you ? 'Your village plan' : `${v.Possessive} village plan`,
                            " \u2014 ",
                            village
                        ]
                    }),
                    (reasons || delta != null) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 text-[15px] leading-relaxed text-slate-900",
                        children: [
                            reasons && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            "Why ",
                                            v.you ? "you're" : `${v.they} ${v.are}`,
                                            " moving:"
                                        ]
                                    }),
                                    " ",
                                    reasons,
                                    ". "
                                ]
                            }),
                            delta != null && (delta < 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "The move costs the family ",
                                    $f295042478994e3b$var$money(-delta),
                                    " over about ",
                                    yrs,
                                    " against staying put",
                                    card.origin === 'engine' ? '; this is the plan chosen from the ways we tested.' : '.'
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "The move leaves the family ",
                                    $f295042478994e3b$var$money(delta),
                                    " more than staying put over about ",
                                    yrs,
                                    "."
                                ]
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1 text-[15px] text-slate-600",
                        children: [
                            when,
                            "; ",
                            $f295042478994e3b$var$money(card.village.entryFee),
                            " entry payment, ",
                            feesWords,
                            ".",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onChangeContract,
                                className: $f295042478994e3b$var$link,
                                "data-testid": "rv-hub-change-contract",
                                children: "Change these"
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onAnotherUnit,
                                className: $f295042478994e3b$var$link,
                                "data-testid": "rv-hub-another-unit",
                                children: "Model another village or unit"
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onStartFresh,
                                className: $f295042478994e3b$var$link,
                                "data-testid": "rv-hub-start-fresh-header",
                                children: "Start a new model from scratch"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e32778aa0d8016bc$export$582b8e8b67199c5d), {
                reason: outOfDate,
                onChooseAgain: onAllPlans,
                testId: "rv-hub-out-of-date"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b200f9f0b001184e$export$14ec62d97a734af3), {
                chosenOn: $f295042478994e3b$var$dateWords(plan.createdAt),
                builtByYou: manual,
                title: card.words.title,
                sub: card.words.sub,
                estate: card.plan.legacy,
                years: card.horizonYears,
                estateDelta: delta,
                baseWord: "staying put",
                figures: figures,
                onExplain: onExplain,
                onRisks: onRisks,
                onAllPlans: onAllPlans,
                testIdPrefix: "rv-hub",
                children: [
                    runLine && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[14px] leading-relaxed text-slate-800",
                        "data-testid": "rv-hub-runline",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-slate-900",
                                children: "When the money runs out:"
                            }),
                            " ",
                            runLine
                        ]
                    }),
                    card.rentNet > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: `${runLine ? 'mt-2 ' : ''}text-[14px] leading-relaxed text-slate-800`,
                        "data-testid": "rv-hub-rent",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-slate-900",
                                children: "Rent from the home:"
                            }),
                            " ",
                            $f295042478994e3b$var$money(card.rentNet),
                            " a year, after its costs."
                        ]
                    }),
                    card.family && card.family.rows.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: runLine || card.rentNet > 0 ? 'mt-4' : '',
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
                            factFind: factFind,
                            personName: card.family.personName,
                            amount: card.family.amount,
                            kind: card.family.kind,
                            incomeAYear: card.family.incomeAYear,
                            rows: null,
                            frozen: card.family.rows,
                            compareNote: card.family.compareNote,
                            horizonYears: card.horizonYears,
                            testId: "rv-hub-family-panel"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b200f9f0b001184e$export$402ee133f3748280), {
                documentState: plan.soaSnapshot ? 'prepared' : 'not prepared yet',
                documentLine: "The written record of this plan and this village's contract.",
                documentAction: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: onAdvice,
                    className: $f295042478994e3b$var$link,
                    "data-testid": "rv-hub-advice",
                    children: "Get the advice document"
                }),
                nextTitle: "legal advice on the contract",
                nextLine: "Take the disclosure statement to a solicitor before signing; a cooling-off period applies.",
                nextAction: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: onHome,
                    className: $f295042478994e3b$var$link,
                    "data-testid": "rv-hub-home",
                    children: "Full action plan on Home"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b200f9f0b001184e$export$9e6485da48da532f), {
                testId: "rv-hub-model-something-else",
                options: [
                    {
                        title: 'Another village or unit, same answers',
                        body: `Keeps ${v.possessive} answers to the questions and the plan settings. Only the village and its contract are new.${unitCount > 1 ? ` ${unitCount} villages or units modelled so far.` : ''}`,
                        action: 'Model another village or unit',
                        onClick: onAnotherUnit,
                        testId: 'rv-hub-another-unit-option'
                    },
                    {
                        title: 'A new model from scratch',
                        body: 'Starts again at step 1 with nothing carried over, and asks the questions again so you can change any of them.',
                        action: 'Start a new model from scratch',
                        onClick: onStartFresh,
                        testId: 'rv-hub-start-fresh'
                    }
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "pt-1",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b200f9f0b001184e$export$29d0c084f57dd4ac), {
                    links: [
                        {
                            label: 'Change the contract',
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            onClick: onChangeContract,
                            testId: 'rv-hub-link-contract'
                        },
                        {
                            label: 'All the plans we tested',
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e583651be68dae50$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            onClick: onAllPlans,
                            testId: 'rv-hub-link-all-plans'
                        },
                        // Two doors (owner, 25 Oct 2026): change this plan, or start a blank one.
                        {
                            label: manual ? 'Change the plan you built' : 'Customise this plan',
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $712d717556ef1508$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            onClick: onBuild,
                            testId: 'rv-hub-build'
                        },
                        ...onBuildNew ? [
                            {
                                label: 'Build a plan yourself',
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $712d717556ef1508$export$2e2bcd8739ae039), {
                                    size: 14
                                }),
                                onClick: onBuildNew,
                                testId: 'rv-hub-build-new'
                            }
                        ] : [],
                        {
                            label: "How villages work \u2014 the guide",
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            onClick: onGuide,
                            testId: 'rv-hub-guide'
                        },
                        {
                            label: 'Rates and assumptions',
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            onClick: onAssumptions,
                            testId: 'rv-hub-assumptions'
                        }
                    ]
                })
            })
        ]
    });
};
var $f295042478994e3b$export$2e2bcd8739ae039 = $f295042478994e3b$var$RvHub;


/**
 * "Build a plan yourself" — the village's ledger (rebuild M3, 21 Oct 2026; the agreed mock-up's j1-build
 * and the four set-ups dd-super, dd-annuity, dd-property, dd-gift).
 *
 * One picture of the money: where it comes from (the home, every account, each investment property, each
 * with one line on what using it does), where it goes in order (the village, the emergency money, then
 * what's left put to work), and "still to place" joining the two — anything not placed goes into the bank
 * account. Beside it, what the plan does, updating as it changes, and "Before you choose" for the two
 * things a client must confirm: owning the home for ten years (a downsizer contribution) and that nothing
 * comes back from an income-only annuity.
 *
 * Presentation over the page's Manual Control state: every input writes the same fields the projection
 * already reads (sellHomeDetails, entryFeeFunding, rentDetails, the investment-property sale, the other
 * strategies), so the figures are the engine's own.
 */ 

var $acw62 = parcelRequire("acw62");



/**
 * "How would this money be invested?" — asked where the money actually is.
 *
 * OWNER, 2026-08-28. This used to be a row at the top of Step 5 of the fact find: "If a strategy
 * frees up money, how would it be invested?" Their objection was that it introduces a concept that
 * may never apply, and they were right — the codebase had already written down the same rule in
 * three places ("asked just-in-time, never a mandatory fact-find step") and then asked it upfront
 * anyway.
 *
 * Two things were wrong with asking it there, and the second is the one that mattered:
 *
 *   1. IT IS UNANSWERABLE IN THE ABSTRACT. At fact-find time there is no strategy and no figure, so
 *      "if a strategy frees up money" asks the client to price a hypothetical.
 *   2. ANSWERING IT EARLY SILENCED THE BETTER QUESTION. Every module's just-in-time ask is gated on
 *      `!hasAnsweredNewMoneyProfile(factFind)`. A client who picked something at Step 5 to get past
 *      it was then never asked in context — where the prompt names the money it is about. The vague
 *      question did not merely sit unused; it switched off the good one.
 *
 * Removing it alone would have opened a real gap, which is why this component exists. MANUAL CONTROL
 * uses this profile but never asked for it: the allocators price allocated shares at it and show it
 * as a bare word on a button ("Invest the remainder — Conservative"), unexplained and unchangeable.
 * The only place a manual-only client could have changed it was the Step 5 row being removed.
 *
 * So the question now appears in both modes, and in both it appears next to a number: the engine
 * asks before it ranks, and this asks beside the allocation it prices.
 */ 
parcelRequire("acw62");


/*
 * THE UNANSWERED DEFAULT IS NOT `DEFAULT_INVESTMENT_PROFILE`. That constant is Balanced and belongs
 * to CLIENT-ENTERED super accounts, because Balanced is what most funds actually default to. Money
 * the TOOL proposes defaults to Conservative instead (NEW_MONEY_DEFAULT_PROFILE — an adviser
 * ruling), and a firm may override it again with its own capital market assumptions.
 *
 * Naming either constant here would have printed a word the engine disagrees with — the same
 * two-figures-one-thing shape this codebase keeps meeting. Asking the engine's own resolver with no
 * answer recorded returns exactly what it will use, firm override included.
 */ const $25ac2ec5abfb5852$var$unansweredDefault = ()=>(0, $0f2c0a6799fe36da$export$580cfd0c6323bf7e)(undefined);
function $25ac2ec5abfb5852$export$23e482971454dc30({ factFind: factFind, setFactFind: setFactFind, idPrefix: idPrefix = 'deploy', what: what = 'this money' }) {
    const answered = (0, $0f2c0a6799fe36da$export$848647f164f42923)(factFind);
    const current = (0, $0f2c0a6799fe36da$export$580cfd0c6323bf7e)(factFind);
    const fallback = $25ac2ec5abfb5852$var$unansweredDefault();
    const id = `${idPrefix}-new-money-profile`;
    const choose = (v)=>{
        if (!setFactFind) return;
        setFactFind((prev)=>{
            const goals = {
                ...prev.goals || {}
            };
            if (v) goals.newMoneyInvestmentProfile = v;
            else delete goals.newMoneyInvestmentProfile;
            return {
                ...prev,
                goals: goals
            };
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-3 rounded-lg border border-slate-200 bg-white px-3 py-2.5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        htmlFor: id,
                        className: "text-xs font-semibold text-slate-800 sm:flex-1",
                        children: [
                            "How is ",
                            what,
                            " invested?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "w-full sm:w-56",
                        children: setFactFind ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                            id: id,
                            name: id,
                            value: answered ? current : '',
                            onChange: (_n, v)=>choose(v),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "",
                                    children: `Not set \u{2014} assume ${(0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[fallback].label}`
                                }),
                                (0, $0f2c0a6799fe36da$export$56315028e4277c0c).map((pid)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: pid,
                                        children: (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[pid].label
                                    }, pid))
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-xs font-semibold text-slate-900",
                            children: (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[current].label
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-1.5 text-xs text-slate-600",
                children: answered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "We'll project this money on a ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[current].label
                        }),
                        " approach \u2014 here, and anywhere else a strategy invests for you."
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Left blank we assume ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[fallback].label
                        }),
                        ", the most cautious option, and say so wherever it applies. A higher-growth mix projects a bigger number, but the year-to-year swings are larger and nothing is guaranteed."
                    ]
                })
            })
        ]
    });
}
var $25ac2ec5abfb5852$export$2e2bcd8739ae039 = $25ac2ec5abfb5852$export$23e482971454dc30;













/**
 * Two tax consequences of a village funding choice, said where the choice is made.
 *
 * Both were explained only inside the floating "What's happening" panel. They are the parts of a
 * village move that bite somewhere other than where the decision is taken — one of them years
 * later — which is exactly why they are easy to miss and worth putting under the switch.
 *
 * The PENSION consequences of keeping or renting the former home are covered by
 * the plan summary's In brief and the engine cards above these, and deliberately not repeated:
 * that note's whole job is to correct the intuition about which lever moves the pension.
 */ 
parcelRequire("acw62");


function $f5ab3af26c11dd09$export$5d3c9135c9ed8866({ homeValue: homeValue }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$36b8132fbfd1058f), {
        tone: "info",
        heading: "Renting starts a six-year clock for capital gains tax",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "A former main residence can go on being treated as your main residence for CGT for up to",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "six years"
                    }),
                    " after you move out, as long as you do not treat another dwelling as your main residence in that time. Sell within the six years and the gain is generally exempt."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-1.5",
                children: [
                    "Sell later and only part of the gain is exempt \u2014 the rest is taxable, on a house",
                    homeValue > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " worth about ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(homeValue)
                            }),
                            " today"
                        ]
                    }) : null,
                    ". The election is made in the tax return for the year of sale. Worth confirming with the ATO or your accountant before the six years are up."
                ]
            })
        ]
    });
}
function $f5ab3af26c11dd09$export$79338cd264d71ddf() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$36b8132fbfd1058f), {
        tone: "warn",
        heading: "Capital gains tax comes off before the money reaches the village",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "Only the ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "net proceeds"
                    }),
                    " \u2014 after selling costs and capital gains tax \u2014 go toward the entry contribution. So a sale price is not what the village receives, and the shortfall shown above is measured on the net figure."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-1.5",
                children: [
                    "The tax reduces your net worth at settlement. It does ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "not"
                    }),
                    " show up as a Year 1 cashflow cost, because it never reaches your bank account \u2014 which is why the cashflow line will not appear to account for it."
                ]
            })
        ]
    });
}





/**
 * A HAND-BUILT GUARANTEED INCOME ABOVE THE CLIENT'S CEILING (owner, 21 Oct 2026 — the guaranteed income review
 * M3). A plan built by hand may put in more than the share the client gave (or the suggested quarter): it is
 * their plan, so this is a caution beside the amount, never a block.
 *
 *   "This puts N% of what {name} has into a guaranteed income. We suggest no more than 25%, so most of the
 *    money stays within reach."
 *
 * The suggestion is the client's own ceiling where they answered (annuityCeilingOf), else the suggested 25%.
 * White with an amber rail (no pastel infill: noPastelPanels.test.ts).
 */ 
parcelRequire("acw62");



function $307ed5693fe6d99c$export$d21ef85416618e5a(factFind, amount, investable, personName, moduleSharePct) {
    const a = Math.max(0, Number(amount) || 0);
    const inv = Math.max(0, Number(investable) || 0);
    if (!(a > 0) || !(inv > 0)) return null;
    const ceiling = (0, $ff5de4128b46b139$export$e46e91ebc7373b0a)(factFind, moduleSharePct);
    if (a <= (0, $ff5de4128b46b139$export$19a5715b59108050)(ceiling, inv) + 1) return null;
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const who = personName || (v.you ? 'you' : v.names);
    const has = personName ? 'has' : v.have;
    const pct = Math.round(a / inv * 100);
    const suggest = ceiling.amount != null ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(ceiling.amount)) : `${ceiling.pct}%`;
    return `This puts ${pct}% of what ${who} ${has} into a guaranteed income. We suggest no more than ${suggest}, so most of the money stays within reach.`;
}
const $307ed5693fe6d99c$export$c57570017839ab6d = ({ factFind: factFind, amount: amount, investable: investable, personName: personName, moduleSharePct: moduleSharePct, testId: testId = 'annuity-ceiling-caution' })=>{
    const words = $307ed5693fe6d99c$export$d21ef85416618e5a(factFind, amount, investable, personName, moduleSharePct);
    if (!words) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "mt-2 rounded-lg border border-slate-200 border-l-4 border-l-amber-400 bg-white px-3 py-2 text-[12.5px] leading-relaxed text-slate-700",
        "data-testid": testId,
        children: words
    });
};
var $307ed5693fe6d99c$export$2e2bcd8739ae039 = $307ed5693fe6d99c$export$c57570017839ab6d;





const $9c67b656ca11544c$var$num = (v)=>Number(v) || 0;
const $9c67b656ca11544c$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
const $9c67b656ca11544c$var$signed = (n)=>`${n >= 0 ? '+' : "\u2212"}${$9c67b656ca11544c$var$money(Math.abs(n))}`;
const $9c67b656ca11544c$var$cash = (n)=>n < 0 ? `short ${$9c67b656ca11544c$var$money(-n)}` : $9c67b656ca11544c$var$money(n);
const $9c67b656ca11544c$var$KIND_ORDER = [
    'bankAccounts',
    'termDeposits',
    'accountBasedPensions',
    'shares'
];
const $9c67b656ca11544c$var$KIND_LABEL = {
    bankAccounts: 'cash',
    termDeposits: 'term deposit',
    accountBasedPensions: 'pension',
    shares: 'shares'
};
const $9c67b656ca11544c$var$link = 'font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy';
const $9c67b656ca11544c$var$sec = 'mt-6 border-b border-slate-200 pb-1 text-[13px] font-bold text-brand-navy';
const $9c67b656ca11544c$var$card = 'rounded-2xl border border-slate-200 bg-white p-5 shadow-card';
/** A choice of two or three, as buttons. */ const $9c67b656ca11544c$var$Choice = ({ value: value, options: options, onChange: onChange, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-wrap gap-2",
        role: "radiogroup",
        "data-testid": testId,
        children: options.map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                role: "radio",
                "aria-checked": value === o.id,
                onClick: ()=>onChange(o.id),
                className: `rounded-lg border px-3 py-1.5 text-[13px] font-semibold ${value === o.id ? 'border-blue-600 bg-blue-50 text-brand-navy' : 'border-slate-300 bg-white text-slate-700 hover:border-blue-300'}`,
                children: [
                    value === o.id ? "\u2713 " : '',
                    o.label
                ]
            }, o.id))
    });
const $9c67b656ca11544c$var$HowItWorks = ({ how: how, good: good, watch: watch })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $9c67b656ca11544c$var$card,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[13px] font-bold text-brand-navy",
                children: "How it works"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-[14px] leading-relaxed text-slate-700",
                children: how
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-3 text-[14px] font-semibold text-slate-900",
                children: "Good for"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "mt-1 list-disc space-y-0.5 pl-5 text-[14px] text-slate-700",
                children: good.map((g)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: g
                    }, g))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-3 text-[14px] font-semibold text-slate-900",
                children: "Watch out for"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "mt-1 list-disc space-y-0.5 pl-5 text-[14px] text-slate-700",
                children: watch.map((g)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: g
                    }, g))
            })
        ]
    });
const $9c67b656ca11544c$var$RvBuildPlan = (p)=>{
    const { factFind: factFind, details: details, entryFee: entryFee, route: route } = p;
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const [dive, setDive] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const goals = factFind?.goals || {};
    const setGoal = (k, val)=>p.setFactFind?.((prev)=>({
                ...prev,
                goals: {
                    ...prev?.goals || {},
                    [k]: val
                }
            }));
    const isCouple = factFind?.adviceFor === 'couple';
    const clientName = factFind?.client?.firstName || (v.you ? 'You' : 'The client');
    const partnerName = factFind?.partner?.firstName || 'your partner';
    const clientAge = factFind?.client?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(String(factFind.client.dob)) : null;
    const partnerAge = isCouple && factFind?.partner?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(String(factFind.partner.dob)) : null;
    const hasHome = $9c67b656ca11544c$var$num(factFind?.home?.value) > 0;
    const assets = factFind?.assets || {};
    const sources = $9c67b656ca11544c$var$KIND_ORDER.flatMap((kind)=>(assets[kind] || []).filter((a)=>$9c67b656ca11544c$var$num(a.value) > 0).map((a)=>({
                kind: kind,
                key: `${kind}-${a.id}`,
                name: (0, $e850825c00b15be4$export$87285386e0429fb5)(a, factFind, $9c67b656ca11544c$var$KIND_LABEL[kind]),
                value: $9c67b656ca11544c$var$num(a.value)
            })));
    const ips = (assets.investmentProperty || []).filter((a)=>$9c67b656ca11544c$var$num(a.value) > 0);
    // The sale and what it leaves.
    const saleNet = route === 'sell' ? Math.max(0, $9c67b656ca11544c$var$num(details.salePrice) - $9c67b656ca11544c$var$num(details.sellingCosts)) : 0;
    const entryFromSale = Math.min(entryFee, saleNet);
    const duty = $9c67b656ca11544c$var$num(details.purchaseInvestmentProperty) > 0 ? $9c67b656ca11544c$var$num(details.investmentPropertyStampDuty) : 0;
    const ipLoan = $9c67b656ca11544c$var$num(details.purchaseInvestmentProperty) > 0 ? Math.min($9c67b656ca11544c$var$num(details.purchaseInvestmentProperty), $9c67b656ca11544c$var$num(details.ipLoanAmount)) : 0;
    const placed = route === 'sell' ? $9c67b656ca11544c$var$num(details.downsizerContribution) + $9c67b656ca11544c$var$num(details.partnerDownsizerContribution) + $9c67b656ca11544c$var$num(details.purchaseAnnuity) + $9c67b656ca11544c$var$num(details.purchaseInvestmentProperty) + duty - ipLoan + $9c67b656ca11544c$var$num(details.giftingAmount) + $9c67b656ca11544c$var$num(details.funeralBondPurchase) + $9c67b656ca11544c$var$num(details.purchaseShares) : 0;
    const totals = (0, $d6349ba6b2bbee8e$export$d5119f51b5211c8b)(factFind, p.funding, {});
    const liquidGross = Object.values(p.funding).reduce((t, a)=>t + $9c67b656ca11544c$var$num(a), 0);
    const entryCovered = entryFromSale + (p.ipSoldId ? Math.min(entryFee, p.ipNetFromSale) : 0) + totals.netTotal;
    const entryShort = Math.max(0, entryFee - entryCovered);
    const stillToPlace = route === 'sell' ? saleNet - entryFromSale - placed : 0;
    // Keeping the home: what savings pay for, beyond the entry payment, and what they can spare.
    const fromSavingsForUses = route !== 'sell' ? $9c67b656ca11544c$var$num(details.purchaseAnnuity) + $9c67b656ca11544c$var$num(details.purchaseInvestmentProperty) + duty - ipLoan + $9c67b656ca11544c$var$num(details.purchaseShares) : 0;
    const toPlace = saleNet + liquidGross;
    // The things that must be confirmed before choosing.
    const usesDownsizer = route === 'sell' && $9c67b656ca11544c$var$num(details.downsizerContribution) + $9c67b656ca11544c$var$num(details.partnerDownsizerContribution) > 0;
    const incomeOnly = (0, $5eae79c7e46ed27e$export$3c8a471078a7436)({
        purchaseAmount: details.purchaseAnnuity,
        annuityType: details.rvAnnuityType || 'lifetime',
        residualCapital: $9c67b656ca11544c$var$num(details.rvAnnuityResidualPercent) / 100
    });
    const tenYearsOk = !usesDownsizer || goals.rvOwned10Years === 'yes';
    /*
     * INCOME ONLY: THE CLIENT'S DATED CONFIRMATION FOR THIS AMOUNT (guaranteed income review E5/M2, 21 Oct 2026).
     * The shared record (goals.incomeOnlyConfirmation: amount, date, the words shown), printed in the advice
     * document; a different amount asks again. The old yes/no (`rvIncomeOnlyUnderstood`) stays in the schema for
     * old files but is no longer read as a confirmation.
     */ const incomeOnlyOk = !incomeOnly || (0, $5eae79c7e46ed27e$export$9ad5f972205b4f88)(factFind, $9c67b656ca11544c$var$num(details.purchaseAnnuity));
    const setIncomeOnly = (0, $5eae79c7e46ed27e$export$415ddf94c95c9134)(p.setFactFind);
    const savingsSpare = route !== 'sell' ? Math.max(0, sources.reduce((t, s)=>t + s.value - $9c67b656ca11544c$var$num(p.funding[s.key]), 0) - p.reserve) : 0;
    const savingsShort = Math.max(0, fromSavingsForUses - savingsSpare);
    const canChoose = tenYearsOk && incomeOnlyOk && entryShort < 1 && stillToPlace > -1 && savingsShort < 1 && !p.working;
    // While working, every figure reads "…" (never a mix of new and old) — the same as cashflow's panel.
    const eff = p.working ? {
        cashflow: null,
        baseCashflow: null,
        pension: null,
        basePension: null,
        legacy: null,
        baseLegacy: null
    } : p.effect;
    const sourceWords = (s)=>{
        const used = $9c67b656ca11544c$var$num(p.funding[s.key]);
        if (s.kind === 'bankAccounts') return `${used > 0 ? 'Used' : 'Kept'}. Using it costs no tax.${p.reserve > 0 ? ` The ${$9c67b656ca11544c$var$money(p.reserve)} for emergencies stays in the bank.` : ''}`;
        if (s.kind === 'termDeposits') return `${used > 0 ? 'Used' : 'Kept'}. No tax; a break fee is not modelled.`;
        if (s.kind === 'accountBasedPensions') return `${used > 0 ? 'Used' : 'Kept'}. Taking it out costs no tax, but its tax-free earnings and yearly payment stop for good.`;
        const one = (0, $d6349ba6b2bbee8e$export$d5119f51b5211c8b)(factFind, {
            [s.key]: used > 0 ? used : s.value
        }, {});
        return `${used > 0 ? 'Used' : 'Kept'}. Selling ${used > 0 ? 'it' : 'them'} would cost about ${$9c67b656ca11544c$var$money(one.shareCgtTotal)} of capital gains tax, and the dividends stop.`;
    };
    /*
     * A NEW GUARANTEED INCOME STARTS AS "MONEY BACK" (owner, 21 Oct 2026), lifetime, and for a couple paid on
     * to the survivor in the name the step-down favours; income only is a choice, with its own tick.
     */ const startingShape = (field, x)=>{
        if (field !== 'purchaseAnnuity' || $9c67b656ca11544c$var$num(details.purchaseAnnuity) > 0 || !($9c67b656ca11544c$var$num(x) > 0)) return {};
        const older = (clientAge ?? 0) >= (partnerAge ?? 0) ? 'client' : 'partner';
        const step = (a)=>Math.max(5, 85 - (a ?? 85));
        const owner = !isCouple ? 'client' : step(clientAge) < step(partnerAge) ? 'client' : step(partnerAge) < step(clientAge) ? 'partner' : older;
        // In or entering care (M1, 21 Oct 2026): the type that pays the full amount back at any time, which that
        // person may buy; otherwise money back.
        const fullBack = (0, $d08210caeacdc75a$export$7095ab72ebd46272)(factFind, owner);
        return {
            rvAnnuityType: fullBack ? 'guaranteed' : 'lifetime',
            rvAnnuityResidualPercent: 100,
            rvAnnuityOwner: owner,
            ...isCouple ? {
                rvAnnuityReversionary: true
            } : {}
        };
    };
    // What the family receives from the guaranteed income if death comes early (E4/M4): the plan's own rows; a
    // hand-built plan has no twin to compare with.
    const giAmount = $9c67b656ca11544c$var$num(details.purchaseAnnuity);
    const giType = String(details.rvAnnuityType || 'lifetime');
    const giPerson = details.rvAnnuityOwner === 'partner' && isCouple ? partnerName : details.rvAnnuityOwner === 'joint' && isCouple ? `${clientName} and ${partnerName}` : clientName;
    const familyPanel = giAmount > 0 && giType !== 'fixedTerm' && p.planRows && p.planRows.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
        factFind: factFind,
        personName: giPerson,
        amount: giAmount,
        kind: (0, $8665f80549f60a1b$export$3ab75b1250c8af22)({
            annuityType: giType,
            annuityResidualPercent: details.rvAnnuityResidualPercent
        }),
        rows: p.planRows,
        horizonYears: p.horizonYears,
        testId: "rv-build-family-panel"
    }) : null;
    const dest = (label, field, words, opts = {})=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
            className: "border-b border-slate-100",
            "data-testid": opts.testId,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                    className: "py-2 pr-3 text-[14px] text-slate-700",
                    children: [
                        label,
                        opts.dive && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                " \xb7 ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setDive(opts.dive),
                                    className: `${$9c67b656ca11544c$var$link} text-[13px]`,
                                    children: "set it up \u203A"
                                })
                            ]
                        }),
                        opts.note
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                    className: "py-2 text-right",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        value: $9c67b656ca11544c$var$num(details[field]),
                        onChange: (x)=>p.onDetails({
                                [field]: Math.max(0, Math.min(opts.max ?? Infinity, x ?? 0)),
                                ...startingShape(field, x)
                            }, `${words} ${$9c67b656ca11544c$var$money($9c67b656ca11544c$var$num(details[field]))} \u{2192} ${$9c67b656ca11544c$var$money(Math.max(0, x ?? 0))}`),
                        className: "ml-auto w-36",
                        ariaLabel: String(words)
                    })
                })
            ]
        });
    const effectPanel = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `${$9c67b656ca11544c$var$card} xl:sticky xl:top-8`,
        "data-testid": "rv-build-effect",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] font-bold text-brand-navy",
                children: [
                    "Effect on the plan ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-normal text-slate-500",
                        children: "\u2014 updates as you go"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                className: "mt-2 w-full text-[14px] tabular-nums",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "border-b border-slate-100",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "py-2 text-slate-600",
                                    children: "Left over each year"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-right",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            className: $9c67b656ca11544c$var$num(eff.cashflow) >= 0 ? 'text-emerald-700' : 'text-rose-700',
                                            children: eff.cashflow == null ? "\u2026" : $9c67b656ca11544c$var$cash(eff.cashflow)
                                        }),
                                        eff.cashflow != null && eff.baseCashflow != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: `text-[12.5px] ${eff.cashflow - eff.baseCashflow >= 0 ? 'text-emerald-700' : 'text-rose-700'}`,
                                                    children: [
                                                        $9c67b656ca11544c$var$signed(eff.cashflow - eff.baseCashflow),
                                                        " vs staying put \xb7 first year"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "border-b border-slate-100",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "py-2 text-slate-600",
                                    children: "Age Pension"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-right",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: eff.pension == null ? "\u2026" : $9c67b656ca11544c$var$money(eff.pension)
                                        }),
                                        eff.pension != null && eff.basePension != null && Math.abs(eff.pension - eff.basePension) >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: `text-[12.5px] ${eff.pension > eff.basePension ? 'text-emerald-700' : 'text-rose-700'}`,
                                                    children: [
                                                        $9c67b656ca11544c$var$signed(eff.pension - eff.basePension),
                                                        " vs staying put"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "border-b border-slate-100",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-slate-600",
                                    children: [
                                        "Left to the family, about ",
                                        p.horizonYears,
                                        " years"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-right",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: eff.legacy == null ? "\u2026" : $9c67b656ca11544c$var$money(eff.legacy)
                                        }),
                                        eff.legacy != null && eff.baseLegacy != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: `text-[12.5px] ${eff.legacy >= eff.baseLegacy ? 'text-emerald-700' : 'text-rose-700'}`,
                                                    children: [
                                                        $9c67b656ca11544c$var$signed(eff.legacy - eff.baseLegacy),
                                                        " vs staying put"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "py-2 text-slate-600",
                                    children: "Tax this year from selling"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-right",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: $9c67b656ca11544c$var$money(totals.cgtTotal)
                                        }),
                                        route === 'sell' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-[12.5px] text-slate-500",
                                                    children: "the home is free of capital gains tax"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            p.lastChange && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 border-t border-slate-200 pt-2 text-[13px] text-slate-700",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-slate-500",
                        children: "Last change"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: p.lastChange
                    })
                ]
            }),
            p.onYearByYear && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: p.onYearByYear,
                className: `mt-3 block text-[13px] ${$9c67b656ca11544c$var$link}`,
                "data-testid": "rv-build-year-by-year",
                children: "See the year-by-year figures for this plan"
            }),
            p.comparison,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 grid grid-cols-2 gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: p.onExplain,
                        className: "inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-[13px] font-semibold text-slate-800 hover:border-blue-300",
                        "data-testid": "rv-build-explain",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                size: 15
                            }),
                            " Explain this"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: p.onRisks,
                        className: "inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-[13px] font-semibold text-slate-800 hover:border-blue-300",
                        "data-testid": "rv-build-risks",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4666dd9ae485baaf$export$2e2bcd8739ae039), {
                                size: 15
                            }),
                            " What could go wrong"
                        ]
                    })
                ]
            }),
            usesDownsizer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 space-y-2 rounded-lg border border-slate-200 border-l-4 border-l-amber-400 bg-white px-3 py-2 text-[13px] text-slate-700",
                "data-testid": "rv-before-you-choose",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "text-slate-900",
                            children: "Before you choose:"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        className: "flex items-start gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "checkbox",
                                checked: goals.rvOwned10Years === 'yes',
                                onChange: (e)=>setGoal('rvOwned10Years', e.target.checked ? 'yes' : ''),
                                className: "mt-0.5",
                                "data-testid": "rv-tick-ten-years"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    "The downsizer contributions need ",
                                    v.them,
                                    " to have owned the home for 10 years or more. ",
                                    v.you ? 'We did.' : `${v.Names} did.`
                                ]
                            })
                        ]
                    })
                ]
            }),
            incomeOnly && setIncomeOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-3",
                "data-testid": "rv-before-you-choose-income-only",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$4538b371a206da0c), {
                    factFind: factFind,
                    amount: $9c67b656ca11544c$var$num(details.purchaseAnnuity),
                    onChange: setIncomeOnly
                })
            }),
            familyPanel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-3",
                children: familyPanel
            }),
            entryShort >= 1 && (()=>{
                // A $900 gap and a $500,000 one are not the same message (owner-caught, 26 Aug 2026).
                const sharesHeld = (assets.shares || []).reduce((t, a)=>t + $9c67b656ca11544c$var$num(a.value), 0);
                const isRoundingGap = sharesHeld > 0 && entryShort <= Math.max(20000, sharesHeld * 0.3);
                const hasInvestmentProperty = ips.length > 0;
                const fallbacks = [
                    hasHome && route !== 'sell' ? 'selling the family home' : null,
                    hasInvestmentProperty ? 'selling an investment property' : null
                ].filter(Boolean);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "mt-3 text-[13px] text-rose-700",
                    "data-testid": "rv-build-entry-short",
                    children: [
                        "The entry payment is ",
                        $9c67b656ca11544c$var$money(entryShort),
                        " short; a village entry payment can't be part-paid.",
                        ' ',
                        isRoundingGap ? 'A gap this size is usually capital gains tax: shares sold have to cover the tax too, so take a little more.' : fallbacks.length > 0 ? `Savings can't cover it; this move only works by ${fallbacks.join(' or ')}.` : 'Savings can\'t cover it, and there is no property to sell: this unit is out of reach on these numbers.'
                    ]
                });
            })(),
            savingsShort >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-3 text-[13px] text-rose-700",
                "data-testid": "rv-build-savings-short",
                children: [
                    "What savings pay for is ",
                    $9c67b656ca11544c$var$money(savingsShort),
                    " more than they can spare after the entry payment and the emergency money: take some off."
                ]
            }),
            stillToPlace < -1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-3 text-[13px] text-rose-700",
                children: [
                    $9c67b656ca11544c$var$money(-stillToPlace),
                    " more is placed than the sale leaves: take some off one of the uses."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: canChoose ? p.onChoose : undefined,
                disabled: !canChoose,
                "aria-pressed": p.chosen,
                className: `mt-3 w-full rounded-lg px-4 py-2.5 text-[14px] font-semibold ${p.chosen ? 'border border-emerald-500 bg-white text-emerald-800' : canChoose ? 'bg-blue-600 text-white hover:bg-blue-700' : 'cursor-not-allowed bg-slate-200 text-slate-500'}`,
                "data-testid": "rv-build-choose",
                children: p.chosen ? "Chosen \u2713" : 'Choose this plan'
            })
        ]
    });
    const nav = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-wrap gap-2 text-[13px]",
        "data-testid": "rv-dive-nav",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: ()=>setDive(null),
                className: "rounded-lg border border-slate-300 bg-white px-3 py-1.5 font-semibold text-slate-700 hover:border-blue-300",
                children: "\u2039 The whole plan"
            }),
            [
                [
                    'super',
                    'Downsizer to super'
                ],
                [
                    'annuity',
                    'Guaranteed income'
                ],
                [
                    'property',
                    'Investment property'
                ],
                [
                    'gift',
                    'Gift to family'
                ]
            ].map(([id, label])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: ()=>setDive(id),
                    className: `rounded-lg border px-3 py-1.5 font-semibold ${dive === id ? 'border-blue-600 bg-blue-50 text-brand-navy' : 'border-slate-300 bg-white text-slate-700 hover:border-blue-300'}`,
                    children: label
                }, id))
        ]
    });
    const header = (title, lead)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-[13px] text-slate-500",
                    children: [
                        "Retirement village \u203A ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: p.onBackToPlans,
                            className: "underline decoration-dotted underline-offset-2",
                            children: "Ways to fund the move"
                        }),
                        " \u203A ",
                        dive ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>setDive(null),
                            className: "underline decoration-dotted underline-offset-2",
                            children: "Build a plan yourself"
                        }) : 'Build a plan yourself'
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    className: "mt-2 text-[28px] font-bold leading-tight tracking-tight text-brand-navy",
                    "data-testid": dive ? `rv-dive-${dive}` : 'rv-build-title',
                    children: title
                }),
                lead && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "mt-1 text-[15px] leading-relaxed text-slate-600",
                    children: lead
                })
            ]
        });
    // ---------- the set-ups ----------
    if (dive === 'super' && route !== 'sell') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        children: [
            header('Downsizer contributions into super'),
            nav,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $9c67b656ca11544c$var$card,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-[14px] text-slate-700",
                    children: [
                        "A downsizer contribution is money from selling a home ",
                        v.they,
                        " have owned for 10 years or more. Choose \u201CSold\u201D for the family home on the whole plan to set it up."
                    ]
                })
            })
        ]
    });
    if (dive === 'super') {
        const people = [
            {
                who: 'client',
                name: clientName,
                age: clientAge,
                field: 'downsizerContribution',
                draw: 'downsizerDrawClient'
            },
            ...isCouple ? [
                {
                    who: 'partner',
                    name: partnerName,
                    age: partnerAge,
                    field: 'partnerDownsizerContribution',
                    draw: 'downsizerDrawPartner'
                }
            ] : []
        ];
        const pensionOk = people.every((x)=>(x.age ?? 0) >= 60 || $9c67b656ca11544c$var$num(details[x.field]) === 0);
        const minOf = (x)=>Math.round($9c67b656ca11544c$var$num(details[x.field]) * (0, $e0f54937e270d5ff$export$a7b4a1ff258d7449)(x.age));
        const income = details.commenceIncomeStream ? people.reduce((t, x)=>t + Math.max(minOf(x), Math.min($9c67b656ca11544c$var$num(details[x.field]), $9c67b656ca11544c$var$num(details[x.draw]))), 0) : 0;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-5",
            children: [
                header('Downsizer contributions into super'),
                nav,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid grid-cols-1 gap-5 xl:grid-cols-[1.35fr_1fr]",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: $9c67b656ca11544c$var$card,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                    className: "w-full text-[14px]",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                        children: people.map((x)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "py-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                children: [
                                                                    x.name,
                                                                    "'s super"
                                                                ]
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "text-slate-500",
                                                                children: [
                                                                    "up to ",
                                                                    $9c67b656ca11544c$var$money((0, $1abe73eeef086faf$export$42edd27decf8c272))
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2 text-right",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                            value: $9c67b656ca11544c$var$num(details[x.field]),
                                                            onChange: (n)=>p.onDetails({
                                                                    [x.field]: Math.max(0, Math.min((0, $1abe73eeef086faf$export$42edd27decf8c272), n ?? 0))
                                                                }, `${x.name}'s super ${$9c67b656ca11544c$var$money($9c67b656ca11544c$var$num(details[x.field]))} \u{2192} ${$9c67b656ca11544c$var$money(Math.min((0, $1abe73eeef086faf$export$42edd27decf8c272), n ?? 0))}`),
                                                            className: "ml-auto w-36",
                                                            ariaLabel: `${x.name}'s downsizer contribution`
                                                        })
                                                    })
                                                ]
                                            }, x.who))
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: $9c67b656ca11544c$var$sec,
                                    children: [
                                        "Can ",
                                        v.they,
                                        " use this strategy?"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mt-2 text-[14px] text-slate-700",
                                    children: [
                                        "To put money from selling ",
                                        v.their,
                                        " home into super this way, each person has to meet strict rules. We check what we can from the file; please confirm the rest."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                    className: "mt-2 w-full text-[14px]",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2",
                                                        children: "55 or over"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2 text-right",
                                                        children: people.map((x)=>`${(x.age ?? 0) >= 55 ? "\u2713" : "\u2717"} ${x.name} ${x.age ?? '?'}`).join(" \xb7 ")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "py-2",
                                                        children: [
                                                            v.you ? 'You' : v.Names,
                                                            " owned the home for 10 years or more ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-slate-500",
                                                                children: "\xb7 please confirm"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2 text-right",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                            value: goals.rvOwned10Years || '',
                                                            onChange: (e)=>setGoal('rvOwned10Years', e.target.value),
                                                            className: "rounded-lg border border-amber-400 px-2 py-1",
                                                            "aria-label": "Owned the home for 10 years or more",
                                                            "data-testid": "rv-owned-ten-years",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "",
                                                                    children: "Not confirmed"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "yes",
                                                                    children: "Yes"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "no",
                                                                    children: "No"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2",
                                                        children: "Paid in within 90 days of the sale settling"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2 text-right text-slate-600",
                                                        children: "a step in the action plan"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2",
                                                        children: "Room under the transfer balance cap"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2 text-right",
                                                        children: people.map((x)=>`${(0, $4f5a997f1c0139af$export$f55aec102ef92752)(factFind, x.who) >= $9c67b656ca11544c$var$num(details[x.field]) ? "\u2713" : "\u2717"} ${x.name}`).join(" \xb7 ")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mt-3",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b75d5c6eae88a43d$export$2e2bcd8739ae039), {
                                        factFind: factFind
                                    })
                                }),
                                goals.rvOwned10Years === 'no' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-2 text-[13px] text-rose-700",
                                    children: "Without 10 years of ownership a downsizer contribution isn't allowed; set these to $0."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mt-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-[13px] text-slate-700",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "The transfer balance cap"
                                        }),
                                        " is the most anyone can move into a retirement pension over their lifetime: ",
                                        $9c67b656ca11544c$var$money((0, $1abe73eeef086faf$export$807e93be6ec93c1b)),
                                        " each. Any amount above what is left of it stays in ordinary super."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: $9c67b656ca11544c$var$sec,
                                    children: "Turn it into a pension"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mt-2 text-[14px] text-slate-700",
                                    children: [
                                        "An ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "account-based pension"
                                        }),
                                        " turns super into an income. It pays at least a set share of the balance each year, its earnings are tax-free, and whatever is left on death goes to the estate or the person nominated. Left in ordinary super instead, the earnings are taxed at up to 15% and money is withdrawn as needed."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "mt-2 flex items-start gap-2 text-[14px]",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            checked: !!details.commenceIncomeStream,
                                            disabled: !pensionOk,
                                            onChange: (e)=>p.onDetails({
                                                    commenceIncomeStream: e.target.checked
                                                }, e.target.checked ? 'Started a pension from the downsizer money' : 'Left the downsizer money in super'),
                                            className: "mt-1",
                                            "data-testid": "rv-start-pension"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Start an account-based pension with it"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-slate-500",
                                                    children: "\u2014 each person must be 60 or over"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                details.commenceIncomeStream && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                            className: "mt-2 w-full text-[14px]",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                children: people.filter((x)=>$9c67b656ca11544c$var$num(details[x.field]) > 0).map((x)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "border-b border-slate-100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "py-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: x.name
                                                                    }),
                                                                    " draws each year ",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                        className: "text-slate-500",
                                                                        children: [
                                                                            "\xb7 at least ",
                                                                            $9c67b656ca11544c$var$money(minOf(x)),
                                                                            ", ",
                                                                            Math.round((0, $e0f54937e270d5ff$export$a7b4a1ff258d7449)(x.age) * 100),
                                                                            "% at ",
                                                                            x.age
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-2 text-right",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                                    value: $9c67b656ca11544c$var$num(details[x.draw]) > 0 ? $9c67b656ca11544c$var$num(details[x.draw]) : '',
                                                                    placeholder: `${$9c67b656ca11544c$var$money(minOf(x))} (the minimum)`,
                                                                    onChange: (n)=>p.onDetails({
                                                                            [x.draw]: Math.max(0, Math.min($9c67b656ca11544c$var$num(details[x.field]), n ?? 0))
                                                                        }, `${x.name}'s yearly draw \u{2192} ${$9c67b656ca11544c$var$money(Math.max(minOf(x), Math.min($9c67b656ca11544c$var$num(details[x.field]), n ?? 0)))}`),
                                                                    className: "ml-auto w-44",
                                                                    ariaLabel: `${x.name}'s yearly draw`,
                                                                    testId: `rv-draw-${x.who}`
                                                                })
                                                            })
                                                        ]
                                                    }, x.who))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "mt-1 text-[12.5px] text-slate-500",
                                            children: [
                                                "Each person has their own minimum, set by their age; it rises at 85, 90 and 95. Draw more if ",
                                                v.they,
                                                " want, never less."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: $9c67b656ca11544c$var$card,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-[13px] font-bold text-brand-navy",
                                            children: "What it does to the plan"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                            className: "mt-2 w-full text-[14px]",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                children: [
                                                    details.commenceIncomeStream && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "border-b border-slate-100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "py-2 text-slate-600",
                                                                children: [
                                                                    "Income from the pension",
                                                                    people.length > 1 ? 's' : ''
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "py-2 text-right",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: $9c67b656ca11544c$var$money(income)
                                                                    }),
                                                                    " a year"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "border-b border-slate-100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-2 text-slate-600",
                                                                children: "Counted by Centrelink"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-2 text-right",
                                                                children: "in full, and deemed"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-2 text-slate-600",
                                                                children: "Age Pension"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "py-2 text-right",
                                                                children: [
                                                                    eff.pension == null ? "\u2026" : $9c67b656ca11544c$var$money(eff.pension),
                                                                    " a year"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9c67b656ca11544c$var$HowItWorks, {
                                    how: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            "When a home owned for at least 10 years is sold, each person can put up to ",
                                            $9c67b656ca11544c$var$money((0, $1abe73eeef086faf$export$42edd27decf8c272)),
                                            " of the sale into super, whatever their age and even if they no longer work. That is a ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "downsizer contribution"
                                            }),
                                            ". Inside super the money is invested, and its earnings are taxed at no more than 15%. Turned into a pension, the earnings are tax-free and the money pays an income."
                                        ]
                                    }),
                                    good: [
                                        'Moving sale money somewhere its earnings are taxed less, or not at all',
                                        'A steady income from the pension',
                                        `Each person gets their own, up to ${$9c67b656ca11544c$var$money((0, $1abe73eeef086faf$export$42edd27decf8c272))}`
                                    ],
                                    watch: [
                                        'It must be paid in within 90 days of the sale settling',
                                        'Centrelink still counts it in full',
                                        'A pension must pay at least a minimum each year',
                                        'The value rises and falls with markets'
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    if (dive === 'annuity') {
        const amount = $9c67b656ca11544c$var$num(details.purchaseAnnuity);
        const owner = details.rvAnnuityOwner === 'partner' ? 'partner' : 'client';
        const ownerName = owner === 'partner' ? partnerName : clientName;
        const otherName = owner === 'partner' ? clientName : partnerName;
        const ownerAge = owner === 'partner' ? partnerAge : clientAge;
        // When Centrelink's count falls from 60% to 30%: the later of the owner's 85th birthday and five years.
        const stepDown = (age)=>Math.max(5, 85 - (age ?? 85));
        const cStep = stepDown(clientAge);
        const pStep = stepDown(partnerAge);
        const suggest = !isCouple ? 'client' : cStep < pStep ? 'client' : pStep < cStep ? 'partner' : (clientAge ?? 0) >= (partnerAge ?? 0) ? 'client' : 'partner';
        const suggestName = suggest === 'partner' ? partnerName : clientName;
        const whyWords = !isCouple ? null : cStep === pStep ? `Centrelink's count of an annuity falls from 60% to 30% at the later of the owner's 85th birthday and five years after buying it. For both of ${v.them} that is ${cStep} years from now, so either name works the same way. We suggest ${suggestName} only because ${suggest === 'client' ? clientName : partnerName} is the older.` : `Centrelink's count of an annuity falls from 60% to 30% at the later of the owner's 85th birthday and five years after buying it: ${cStep} years from now for ${clientName}, ${pStep} for ${partnerName}. In ${suggestName}'s name it falls sooner, so less is counted sooner.`;
        const residual = Math.round($9c67b656ca11544c$var$num(details.rvAnnuityResidualPercent));
        // The full-amount-back type is offered only to someone in, or entering, subsidised care (M1, 21 Oct 2026).
        const fullBackOffered = (0, $d08210caeacdc75a$export$7095ab72ebd46272)(factFind, owner);
        const shape = details.rvAnnuityType === 'guaranteed' ? 'guaranteed' : residual === 0 ? 'nil' : 'returned';
        const est = (res, idx = !!details.rvAnnuityIndexation, type = 'lifetime')=>{
            if (!(amount > 0)) return 0;
            try {
                const r = (0, $f7f7b62814c3b615$export$fb67395f10ad20c9)(factFind, {
                    annuityType: type,
                    purchaseAmount: amount,
                    age: ownerAge,
                    partnerAge: owner === 'partner' ? clientAge : partnerAge,
                    owner: owner,
                    residualCapital: res,
                    termYears: null,
                    indexation: type === 'guaranteed' ? false : idx,
                    reversionary: !!details.rvAnnuityReversionary && isCouple,
                    incomeOverride: null
                });
                return r && !r.warnings ? $9c67b656ca11544c$var$num((0, $f7f7b62814c3b615$export$fc6c67b5fdf45998)(r)?.annualPayment) : 0;
            } catch  {
                return 0;
            }
        };
        const nilIncome = est(0);
        const backIncome = est(1);
        const fullBackIncome = fullBackOffered || shape === 'guaranteed' ? est(1, false, 'guaranteed') : 0;
        const quoted = details.rvAnnuityIncomeOverride != null && (details.rvAnnuityQuoteShape ?? shape) === shape ? $9c67b656ca11544c$var$num(details.rvAnnuityIncomeOverride) : null;
        const income = quoted ?? (shape === 'nil' ? nilIncome : shape === 'guaranteed' ? fullBackIncome : backIncome);
        const flatStart = est(shape === 'nil' ? 0 : 1, false);
        const indexedStart = est(shape === 'nil' ? 0 : 1, true);
        // The money that could be invested: what is placed after the entry payment (a sale), or what savings can spare.
        const investable = route === 'sell' ? Math.max(0, saleNet - entryFromSale) : savingsSpare + fromSavingsForUses;
        const shapes = [
            ...fullBackOffered || shape === 'guaranteed' ? [
                [
                    'guaranteed',
                    'Full amount back, at any time',
                    fullBackIncome,
                    `${$9c67b656ca11544c$var$money(amount)}, whenever ${ownerName} passes away`,
                    'the life cover part, in full'
                ]
            ] : [],
            [
                'returned',
                'Money back',
                backIncome,
                `${$9c67b656ca11544c$var$money(amount)} if within the first years, falling to nil`,
                'the withdrawal value, falling to nil'
            ],
            [
                'nil',
                'Income only',
                nilIncome,
                'nothing',
                'nothing'
            ]
        ];
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-5",
            children: [
                header('Guaranteed income for life'),
                nav,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid grid-cols-1 gap-5 xl:grid-cols-[1.35fr_1fr]",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: $9c67b656ca11544c$var$card,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: $9c67b656ca11544c$var$sec,
                                    style: {
                                        marginTop: 0
                                    },
                                    children: "Set it up"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-[13px] font-semibold text-slate-600",
                                            children: "How much goes in"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                            value: amount,
                                            onChange: (n)=>p.onDetails({
                                                    purchaseAnnuity: Math.max(0, n ?? 0),
                                                    ...startingShape('purchaseAnnuity', n)
                                                }, `Guaranteed income ${$9c67b656ca11544c$var$money(amount)} \u{2192} ${$9c67b656ca11544c$var$money(Math.max(0, n ?? 0))}`),
                                            className: "mt-1 w-44",
                                            ariaLabel: "How much goes into the guaranteed income",
                                            testId: "rv-annuity-amount"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "mt-1 text-[12.5px] text-slate-500",
                                            children: [
                                                route === 'sell' ? 'From what\'s left of the sale.' : 'From savings, after the entry payment, keeping the emergency money.',
                                                " We suggest no more than ",
                                                $9c67b656ca11544c$var$money((0, $ff5de4128b46b139$export$19a5715b59108050)((0, $ff5de4128b46b139$export$e46e91ebc7373b0a)(factFind, $9c67b656ca11544c$var$num(factFind?.goals?.rvAnnuityShareCapPct) || null), investable)),
                                                " of the ",
                                                $9c67b656ca11544c$var$money(investable),
                                                " that could be invested, so most of ",
                                                v.their,
                                                " money stays within reach."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $307ed5693fe6d99c$export$c57570017839ab6d), {
                                            factFind: factFind,
                                            amount: amount,
                                            investable: investable,
                                            personName: isCouple ? null : ownerName,
                                            moduleSharePct: $9c67b656ca11544c$var$num(factFind?.goals?.rvAnnuityShareCapPct) || null,
                                            testId: "rv-annuity-ceiling-caution"
                                        })
                                    ]
                                }),
                                isCouple && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-[13px] font-semibold text-slate-600",
                                            children: "Whose name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "mt-1 flex flex-wrap items-center gap-3",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9c67b656ca11544c$var$Choice, {
                                                value: owner,
                                                options: [
                                                    {
                                                        id: 'client',
                                                        label: clientName
                                                    },
                                                    {
                                                        id: 'partner',
                                                        label: partnerName
                                                    }
                                                ],
                                                onChange: (id)=>p.onDetails({
                                                        rvAnnuityOwner: id
                                                    }, `The guaranteed income in ${id === 'partner' ? partnerName : clientName}'s name`),
                                                testId: "rv-annuity-owner"
                                            })
                                        }),
                                        whyWords && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "mt-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-[13px] text-slate-700",
                                            "data-testid": "rv-annuity-why-owner",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                    children: [
                                                        "Why ",
                                                        suggestName,
                                                        "?"
                                                    ]
                                                }),
                                                " ",
                                                whyWords
                                            ]
                                        })
                                    ]
                                }),
                                isCouple && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-[13px] font-semibold text-slate-600",
                                            children: [
                                                "When ",
                                                ownerName,
                                                " dies, keep paying ",
                                                otherName,
                                                " for life?"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "mt-1",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9c67b656ca11544c$var$Choice, {
                                                value: details.rvAnnuityReversionary ? 'yes' : 'no',
                                                options: [
                                                    {
                                                        id: 'yes',
                                                        label: `Yes, to ${otherName}`
                                                    },
                                                    {
                                                        id: 'no',
                                                        label: 'No, it stops'
                                                    }
                                                ],
                                                onChange: (id)=>p.onDetails({
                                                        rvAnnuityReversionary: id === 'yes'
                                                    }, id === 'yes' ? `The income carries on to ${otherName}` : 'The income stops on the owner\'s death'),
                                                testId: "rv-annuity-reversion"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "mt-1 text-[12.5px] text-slate-500",
                                            children: [
                                                "Recommended for a couple: without it, the income stops when ",
                                                ownerName,
                                                " dies, and ",
                                                otherName,
                                                " gets nothing more from it."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "mt-4 flex items-start gap-2 text-[14px]",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            checked: !!details.rvAnnuityIndexation,
                                            onChange: (e)=>p.onDetails({
                                                    rvAnnuityIndexation: e.target.checked
                                                }, e.target.checked ? 'The payments rise with prices' : 'Level payments'),
                                            className: "mt-1"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                "Increase the payments each year with prices ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "text-slate-500",
                                                    children: [
                                                        "\u2014 starts lower: ",
                                                        $9c67b656ca11544c$var$money(indexedStart),
                                                        " instead of ",
                                                        $9c67b656ca11544c$var$money(flatStart)
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: $9c67b656ca11544c$var$sec,
                                    children: [
                                        shapes.length === 3 ? 'Three' : 'Two',
                                        " ways to set it up"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    className: "mt-2 w-full text-[13px]",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "text-left text-slate-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "py-1",
                                                        children: "Type"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "py-1",
                                                        children: "Income while alive"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                        className: "py-1",
                                                        children: [
                                                            "If ",
                                                            ownerName,
                                                            " passes away"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                        className: "py-1",
                                                        children: [
                                                            "If ",
                                                            v.they,
                                                            " need it back"
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: shapes.map(([id, label, inc, death, back])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    className: `border-t border-slate-100 ${shape === id ? 'bg-blue-50/60' : ''}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "py-1.5",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                type: "button",
                                                                onClick: ()=>p.onDetails({
                                                                        rvAnnuityResidualPercent: id === 'nil' ? 0 : 100,
                                                                        rvAnnuityType: id === 'guaranteed' ? 'guaranteed' : 'lifetime',
                                                                        ...id === 'guaranteed' ? {
                                                                            rvAnnuityIndexation: false
                                                                        } : {}
                                                                    }, `The guaranteed income set to ${label.toLowerCase()}`),
                                                                className: "font-semibold text-brand-navy",
                                                                "data-testid": `rv-annuity-shape-${id}`,
                                                                children: [
                                                                    shape === id ? "\u25CF " : "\u25CB ",
                                                                    label
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "py-1.5",
                                                            children: [
                                                                $9c67b656ca11544c$var$money(inc),
                                                                " a year"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "py-1.5",
                                                            children: death
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "py-1.5",
                                                            children: back
                                                        })
                                                    ]
                                                }, id))
                                        })
                                    ]
                                }),
                                shape === 'guaranteed' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mt-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-[13px] text-slate-700",
                                    "data-testid": "rv-annuity-full-back",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Full amount back, the type chosen."
                                        }),
                                        " ",
                                        $9c67b656ca11544c$var$money(income),
                                        " a year for life. A guaranteed income combined with life cover: the whole ",
                                        $9c67b656ca11544c$var$money(amount),
                                        " goes to the family whenever ",
                                        ownerName,
                                        " passes away. It does less for the Age Pension, because the life cover part is counted in full."
                                    ]
                                }) : shape === 'returned' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mt-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-[13px] text-slate-700",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "Money back, the type chosen."
                                        }),
                                        " ",
                                        $9c67b656ca11544c$var$money(income),
                                        " a year for life. If ",
                                        ownerName,
                                        " passes away in about the first half of ",
                                        ownerName,
                                        "'s life expectancy, the family gets the full ",
                                        $9c67b656ca11544c$var$money(amount),
                                        " back; after that, a falling amount, down to nothing. If ",
                                        v.they,
                                        " need the money, it can be cashed in for an amount that falls each year to nothing."
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-2 space-y-2",
                                    "data-testid": "rv-annuity-income-only",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-[13px] text-slate-700",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Income only, the type chosen."
                                                }),
                                                " The highest income, ",
                                                $9c67b656ca11544c$var$money(income),
                                                " a year, for life."
                                            ]
                                        }),
                                        setIncomeOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$61c5566b790f51c4), {
                                            factFind: factFind,
                                            amount: amount,
                                            onChange: setIncomeOnly,
                                            testId: "rv-annuity-income-only-tick"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mt-2 text-[12.5px] text-slate-500",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "These incomes are estimates"
                                        }),
                                        " from published rates",
                                        (ownerAge ?? 0) >= 75 ? `, and at ${ownerName}'s age they are rougher still` : '',
                                        ". For exact figures, ask an annuity provider for a quote and enter it below."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-[13px] font-semibold text-slate-600",
                                            children: "Income from a quote"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mt-1 flex flex-wrap items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                    value: details.rvAnnuityIncomeOverride ?? '',
                                                    onChange: (n)=>p.onDetails({
                                                            rvAnnuityIncomeOverride: n == null || n <= 0 ? undefined : n,
                                                            rvAnnuityQuoteShape: shape
                                                        }, n ? `The quoted income ${$9c67b656ca11544c$var$money(n)} a year` : 'Back to our estimate'),
                                                    placeholder: "enter the quoted income",
                                                    className: "w-48",
                                                    ariaLabel: "Quoted income a year"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "text-[13px] text-slate-500",
                                                    children: [
                                                        "a year, for ",
                                                        shape === 'nil' ? 'income only' : shape === 'guaranteed' ? 'full amount back' : 'money back'
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "mt-1 text-[12.5px] text-slate-500",
                                            children: "A quote is for one way of setting it up; it replaces our estimate for that one."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: $9c67b656ca11544c$var$card,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-[13px] font-bold text-brand-navy",
                                            children: "What it does to the plan"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                            className: "mt-2 w-full text-[14px]",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "border-b border-slate-100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-2 text-slate-600",
                                                                children: "Guaranteed income"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "py-2 text-right",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: $9c67b656ca11544c$var$money(income)
                                                                    }),
                                                                    " a year"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "border-b border-slate-100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-2 text-slate-600",
                                                                children: "Counted as an asset by Centrelink"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "py-2 text-right",
                                                                children: [
                                                                    $9c67b656ca11544c$var$money(amount * 0.6),
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "text-slate-500",
                                                                        children: "60% for the first five years, or until age 85 if that is later, and 30% after that"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "border-b border-slate-100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-2 text-slate-600",
                                                                children: "Counted as income"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "py-2 text-right",
                                                                children: [
                                                                    $9c67b656ca11544c$var$money(income * 0.6),
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "text-slate-500",
                                                                        children: "60% of the payments"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-2 text-slate-600",
                                                                children: "Age Pension"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "py-2 text-right",
                                                                children: [
                                                                    eff.pension == null ? "\u2026" : $9c67b656ca11544c$var$money(eff.pension),
                                                                    " a year"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9c67b656ca11544c$var$HowItWorks, {
                                    how: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            "A lump sum is handed to an insurer, who pays a set income for as long as ",
                                            v.they,
                                            " live. This is called an ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "annuity"
                                            }),
                                            ". What comes back if the money is needed, or on death, depends on the type chosen."
                                        ]
                                    }),
                                    good: [
                                        'An income that doesn\'t depend on markets, for life',
                                        'Paying fixed costs such as the village fees'
                                    ],
                                    watch: [
                                        'Prices rising faster than the payments, unless they rise with prices',
                                        'Money that is hard to get back if plans change, such as a move into care',
                                        'A provider\'s quote can differ from our estimate'
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    if (dive === 'property') {
        const price = $9c67b656ca11544c$var$num(details.purchaseInvestmentProperty);
        const sugg = (0, $6ee1c1106c00a64d$export$ad80a9624457bb5e)(price);
        const weekly = details.ipWeeklyRent != null ? $9c67b656ca11544c$var$num(details.ipWeeklyRent) : Math.round(sugg.grossRent / 52);
        const vacancy = details.ipVacancyWeeks != null ? $9c67b656ca11544c$var$num(details.ipVacancyWeeks) : (0, $6ee1c1106c00a64d$export$faaf7ad57b31d035);
        const f = (0, $6ee1c1106c00a64d$export$ad80a9624457bb5e)(price, {
            weeklyRent: weekly,
            vacancyWeeks: vacancy,
            upkeep: details.ipUpkeep != null ? $9c67b656ca11544c$var$num(details.ipUpkeep) : null,
            otherCosts: $9c67b656ca11544c$var$num(details.ipRates) + $9c67b656ca11544c$var$num(details.ipInsurance) + $9c67b656ca11544c$var$num(details.ipLandTax) + $9c67b656ca11544c$var$num(details.ipStrata)
        });
        const agent = details.ipAgentFee != null ? $9c67b656ca11544c$var$num(details.ipAgentFee) : f.agentFee;
        const expenses = agent + f.upkeep + f.otherCosts;
        // Every change writes the rent and costs the projection reads.
        const write = (patch, words)=>{
            const next = {
                ...details,
                ...patch
            };
            const pr = $9c67b656ca11544c$var$num(next.purchaseInvestmentProperty);
            const s2 = (0, $6ee1c1106c00a64d$export$ad80a9624457bb5e)(pr);
            const wk = next.ipWeeklyRent != null ? $9c67b656ca11544c$var$num(next.ipWeeklyRent) : Math.round(s2.grossRent / 52);
            const fig = (0, $6ee1c1106c00a64d$export$ad80a9624457bb5e)(pr, {
                weeklyRent: wk,
                vacancyWeeks: next.ipVacancyWeeks != null ? $9c67b656ca11544c$var$num(next.ipVacancyWeeks) : (0, $6ee1c1106c00a64d$export$faaf7ad57b31d035),
                upkeep: next.ipUpkeep != null ? $9c67b656ca11544c$var$num(next.ipUpkeep) : null,
                otherCosts: $9c67b656ca11544c$var$num(next.ipRates) + $9c67b656ca11544c$var$num(next.ipInsurance) + $9c67b656ca11544c$var$num(next.ipLandTax) + $9c67b656ca11544c$var$num(next.ipStrata)
            });
            const ag = next.ipAgentFee != null ? $9c67b656ca11544c$var$num(next.ipAgentFee) : fig.agentFee;
            p.onDetails({
                ...patch,
                investmentPropertyRent: fig.rent,
                investmentPropertyExpenses: ag + fig.upkeep + fig.otherCosts
            }, words);
        };
        const cost = (label, field, value, suggested, enter = false)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                className: "border-b border-slate-100",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                        className: "py-2 text-[14px] text-slate-700",
                        children: label
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                        className: "py-2 text-right",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                value: details[field] != null ? $9c67b656ca11544c$var$num(details[field]) : enter ? '' : value,
                                onChange: (n)=>write({
                                        [field]: n == null ? undefined : Math.max(0, n)
                                    }, `${typeof label === 'string' ? label : 'A cost'} \u{2192} ${$9c67b656ca11544c$var$money(n ?? 0)}`),
                                placeholder: enter ? 'enter' : undefined,
                                className: `ml-auto w-32 ${enter && details[field] == null ? 'ring-1 ring-amber-400 rounded-lg' : ''}`,
                                ariaLabel: String(field)
                            }),
                            suggested && details[field] == null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ml-1 text-[11px] text-slate-500",
                                children: "suggested"
                            })
                        ]
                    })
                ]
            });
        const ownerNow = details.investmentPropertyOwner || (isCouple ? 'joint' : 'client');
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-5",
            children: [
                header('An investment property, bought outright', 'Every figure can be changed. Ours are suggestions until you do.'),
                nav,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid grid-cols-1 gap-5 xl:grid-cols-[1.35fr_1fr]",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: $9c67b656ca11544c$var$card,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: $9c67b656ca11544c$var$sec,
                                    style: {
                                        marginTop: 0
                                    },
                                    children: "Buying it"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-[13px] font-semibold text-slate-600",
                                            children: "Price"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                            value: price,
                                            onChange: (n)=>write({
                                                    purchaseInvestmentProperty: Math.max(0, n ?? 0)
                                                }, `Investment property ${$9c67b656ca11544c$var$money(price)} \u{2192} ${$9c67b656ca11544c$var$money(Math.max(0, n ?? 0))}`),
                                            className: "mt-1 w-44",
                                            ariaLabel: "Price of the investment property",
                                            testId: "rv-ip-price"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "mt-1 text-[12.5px] text-slate-500",
                                            children: route === 'sell' ? 'Paid from what\'s left of the sale of the home, after the entry payment. The most it can be is what\'s left.' : "Paid from savings, after the entry payment, keeping the emergency money \u2014 in the usual order: the bank, then term deposits, pensions and shares."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mt-3",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $89d49377c5c902f9$export$2e2bcd8739ae039), {
                                        subject: "the investment property",
                                        use: "investment",
                                        state: details.investmentPropertyState,
                                        onStateChange: (st)=>p.onDetails({
                                                investmentPropertyState: st,
                                                ...st ? {} : {
                                                    investmentPropertyStampDuty: 0
                                                }
                                            }, `Stamp duty state \u{2192} ${st || 'none'}`),
                                        newHomePrice: price,
                                        duty: details.investmentPropertyStampDuty,
                                        onDutyChange: (d)=>p.onDetails({
                                                investmentPropertyStampDuty: d
                                            }),
                                        fieldClassName: "max-w-xs"
                                    })
                                }),
                                isCouple && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-[13px] font-semibold text-slate-600",
                                            children: "Who owns it"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "mt-1",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9c67b656ca11544c$var$Choice, {
                                                value: ownerNow,
                                                options: [
                                                    {
                                                        id: 'client',
                                                        label: clientName
                                                    },
                                                    {
                                                        id: 'partner',
                                                        label: partnerName
                                                    },
                                                    {
                                                        id: 'joint',
                                                        label: 'Both'
                                                    }
                                                ],
                                                onChange: (id)=>p.onDetails({
                                                        investmentPropertyOwner: id
                                                    }, `The property in ${id === 'joint' ? 'both names' : `${id === 'partner' ? partnerName : clientName}'s name`}`),
                                                testId: "rv-ip-owner"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "mt-1 text-[12.5px] text-slate-500",
                                            children: "Sets whose income the rent is, for tax. For a couple, both is suggested."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: $9c67b656ca11544c$var$sec,
                                    children: "The rent"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-2 flex flex-wrap items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                            value: weekly,
                                            onChange: (n)=>write({
                                                    ipWeeklyRent: n == null ? undefined : Math.max(0, n)
                                                }, `Rent \u{2192} ${$9c67b656ca11544c$var$money(n ?? 0)} a week`),
                                            className: "w-32",
                                            ariaLabel: "Rent a week",
                                            testId: "rv-ip-rent"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "text-[13px] text-slate-500",
                                            children: [
                                                "a week (",
                                                $9c67b656ca11544c$var$money(weekly * 52),
                                                " a year)",
                                                details.ipWeeklyRent == null ? " \xb7 suggested at 3.5% of the price; replace it with an agent's appraisal" : ''
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-2 flex flex-wrap items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "number",
                                            min: 0,
                                            max: 52,
                                            value: vacancy,
                                            onChange: (e)=>write({
                                                    ipVacancyWeeks: Math.max(0, Math.min(52, parseFloat(e.target.value) || 0))
                                                }, `Weeks empty \u{2192} ${e.target.value}`),
                                            className: "w-20 rounded-lg border border-slate-300 px-2 py-1.5",
                                            "aria-label": "Weeks a year empty",
                                            "data-testid": "rv-ip-vacancy"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "text-[13px] text-slate-500",
                                            children: [
                                                "weeks a year empty \u2014 ",
                                                $9c67b656ca11544c$var$money(weekly * vacancy),
                                                " of rent lost a year. Between tenants the rent stops; the costs don't."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: $9c67b656ca11544c$var$sec,
                                    children: "The costs, each year"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                    className: "mt-2 w-full",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        children: [
                                            cost(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    "Agent's management fee ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-slate-500",
                                                        children: [
                                                            "\xb7 ",
                                                            (0, $6ee1c1106c00a64d$export$a7e68df0b44e69a1),
                                                            "% of the rent"
                                                        ]
                                                    })
                                                ]
                                            }), 'ipAgentFee', f.agentFee, true),
                                            cost(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    "Repairs and upkeep ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-slate-500",
                                                        children: [
                                                            "\xb7 ",
                                                            (0, $6ee1c1106c00a64d$export$aa7b942bbfbd31d3),
                                                            "% of the value"
                                                        ]
                                                    })
                                                ]
                                            }), 'ipUpkeep', sugg.upkeep, true),
                                            cost(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    "Council and water rates ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-slate-500",
                                                        children: "\xb7 from the council notice"
                                                    })
                                                ]
                                            }), 'ipRates', 0, false, true),
                                            cost('Landlord insurance', 'ipInsurance', 0, false, true),
                                            cost(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Land tax"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-slate-500",
                                                        children: "\xb7 from the state revenue office"
                                                    })
                                                ]
                                            }), 'ipLandTax', 0, false, true),
                                            cost(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    "Strata levies ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-slate-500",
                                                        children: "\xb7 if it is a unit"
                                                    })
                                                ]
                                            }), 'ipStrata', 0, false)
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: $9c67b656ca11544c$var$sec,
                                    children: "Growth"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mt-2 text-[14px] text-slate-700",
                                    children: [
                                        "Value growth ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                            children: [
                                                (0, $0f2c0a6799fe36da$export$b037eefb915b86ec).propertyGrowthPct,
                                                "% a year"
                                            ]
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-slate-500",
                                            children: "\u2014 our assumption for property values."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: $9c67b656ca11544c$var$sec,
                                    children: "Borrowing"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "mt-2 flex items-start gap-2 text-[14px]",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            checked: $9c67b656ca11544c$var$num(details.ipLoanAmount) > 0,
                                            onChange: (e)=>p.onDetails(e.target.checked ? {
                                                    ipLoanAmount: Math.round(price * 0.5),
                                                    ipLoanRate: details.ipLoanRate ?? 6.5,
                                                    ipLoanTermYears: details.ipLoanTermYears ?? 25
                                                } : {
                                                    ipLoanAmount: 0
                                                }, e.target.checked ? 'A loan towards the property' : 'No loan: bought outright'),
                                            className: "mt-1",
                                            "data-testid": "rv-ip-borrow"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                "A lender has agreed to finance it. ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "text-slate-500",
                                                    children: [
                                                        "Off unless ",
                                                        v.they,
                                                        " have: banks rarely lend at ",
                                                        v.their,
                                                        " ages, so no tested plan borrows."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                $9c67b656ca11544c$var$num(details.ipLoanAmount) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-2 grid grid-cols-1 gap-3 sm:grid-cols-3",
                                    "data-testid": "rv-ip-loan",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-[13px] font-semibold text-slate-600",
                                                    children: "Loan amount"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                    value: $9c67b656ca11544c$var$num(details.ipLoanAmount),
                                                    onChange: (n)=>p.onDetails({
                                                            ipLoanAmount: Math.max(0, Math.min(price, n ?? 0))
                                                        }, `Loan \u{2192} ${$9c67b656ca11544c$var$money(Math.min(price, n ?? 0))}`),
                                                    className: "mt-1",
                                                    ariaLabel: "Loan amount"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-[13px] font-semibold text-slate-600",
                                                    children: "Interest rate, % a year"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "number",
                                                    step: "0.05",
                                                    min: 0,
                                                    value: $9c67b656ca11544c$var$num(details.ipLoanRate) || 6.5,
                                                    onChange: (e)=>p.onDetails({
                                                            ipLoanRate: Math.max(0, parseFloat(e.target.value) || 0)
                                                        }, `Loan rate \u{2192} ${e.target.value}%`),
                                                    className: "mt-1 w-full rounded-lg border border-slate-300 px-3 py-2",
                                                    "aria-label": "Loan interest rate"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-[13px] font-semibold text-slate-600",
                                                    children: "Term, years"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "number",
                                                    min: 1,
                                                    max: 40,
                                                    value: $9c67b656ca11544c$var$num(details.ipLoanTermYears) || 25,
                                                    onChange: (e)=>p.onDetails({
                                                            ipLoanTermYears: Math.max(1, parseFloat(e.target.value) || 1)
                                                        }, `Loan term \u{2192} ${e.target.value} years`),
                                                    className: "mt-1 w-full rounded-lg border border-slate-300 px-3 py-2",
                                                    "aria-label": "Loan term in years"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-[12.5px] text-slate-500 sm:col-span-3",
                                            children: "Repaid as principal and interest each month; the interest is deducted against the rent for tax. Stated in the advice document."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: $9c67b656ca11544c$var$card,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-[13px] font-bold text-brand-navy",
                                            children: "What it does to the plan"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                            className: "mt-2 w-full text-[14px]",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "border-b border-slate-100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-2 text-slate-600",
                                                                children: "Takes from what's left"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "py-2 text-right",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: $9c67b656ca11544c$var$money(price + duty - ipLoan)
                                                                    }),
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                        className: "text-slate-500",
                                                                        children: [
                                                                            "price and duty",
                                                                            ipLoan > 0 ? `, less the ${$9c67b656ca11544c$var$money(ipLoan)} loan` : ''
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "border-b border-slate-100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-2 text-slate-600",
                                                                children: "Rent after costs and empty weeks"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "py-2 text-right",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        "data-testid": "rv-ip-net-rent",
                                                                        children: $9c67b656ca11544c$var$money(f.rent - expenses)
                                                                    }),
                                                                    " a year"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-2 text-slate-600",
                                                                children: "Age Pension"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "py-2 text-right",
                                                                children: [
                                                                    eff.pension == null ? "\u2026" : $9c67b656ca11544c$var$money(eff.pension),
                                                                    " a year"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9c67b656ca11544c$var$HowItWorks, {
                                    how: "A property is bought and rented out. The rent, less the costs, is income, and the property's value can grow. Centrelink counts the property in full as an asset and the rent after costs as income. Stamp duty is paid to buy it, and capital gains tax on any rise in value when it is sold.",
                                    good: [
                                        'Rental income and possible growth in value',
                                        'Spreading money across more than shares and cash'
                                    ],
                                    watch: [
                                        'Weeks without a tenant, while the costs go on',
                                        'Repairs, rates, insurance and land tax',
                                        'A fall in value',
                                        'Money that takes months to get out, and costs to sell'
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    if (dive === 'gift') {
        const amount = route === 'sell' ? $9c67b656ca11544c$var$num(details.giftingAmount) : $9c67b656ca11544c$var$num(p.other.giftingAmount);
        const set = (n)=>route === 'sell' ? p.onDetails({
                giftingAmount: n
            }, `Gift ${$9c67b656ca11544c$var$money(amount)} \u{2192} ${$9c67b656ca11544c$var$money(n)}`) : p.onOther({
                giftingAmount: n
            }, `Gift ${$9c67b656ca11544c$var$money(amount)} \u{2192} ${$9c67b656ca11544c$var$money(n)}`);
        const free = Math.min(amount, (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0));
        const history = factFind.giftsHistory;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-5",
            children: [
                header('A gift to family'),
                nav,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid grid-cols-1 gap-5 xl:grid-cols-[1.35fr_1fr]",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: $9c67b656ca11544c$var$card,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-[13px] font-semibold text-slate-600",
                                    children: "How much"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                    value: amount,
                                    onChange: (n)=>set(Math.max(0, n ?? 0)),
                                    className: "mt-1 w-44",
                                    ariaLabel: "How much to give",
                                    testId: "rv-gift-amount"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-1 text-[12.5px] text-slate-500",
                                    children: route === 'sell' ? 'From what\'s left of the sale.' : 'From savings.'
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-3 text-[13px] font-semibold text-slate-600",
                                    children: "To whom"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    value: String(details.giftTo || ''),
                                    onChange: (e)=>p.onDetails({
                                            giftTo: e.target.value
                                        }),
                                    placeholder: "e.g. the children",
                                    className: "mt-1 w-72 rounded-lg border border-slate-300 px-3 py-1.5 text-[14px]",
                                    "aria-label": "To whom"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-1 text-[12.5px] text-slate-500",
                                    children: "For the advice document only; it does not change the figures."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-3 text-[13px] font-semibold text-slate-600",
                                    children: "When"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-[14px] text-slate-700",
                                    children: "At the move"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-3 text-[13px] font-semibold text-slate-600",
                                    children: "Gifts already made"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-[14px] text-slate-700",
                                    children: history?.hasGifted ? 'Recorded on the profile; they count towards the same limits.' : history?.confirmedNone ? 'From the profile: none in the last five years.' : 'Not answered on the profile yet.'
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: $9c67b656ca11544c$var$sec,
                                    children: "How Centrelink counts it"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                    className: "mt-2 w-full text-[14px]",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2 text-slate-600",
                                                        children: "Leaves the means tests straight away"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "py-2 text-right",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: $9c67b656ca11544c$var$money(free)
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-slate-500",
                                                                children: "this year's free amount"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "py-2 text-slate-600",
                                                        children: [
                                                            "Still counted as ",
                                                            v.you ? 'yours' : 'theirs',
                                                            ", for five years"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2 text-right",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: $9c67b656ca11544c$var$money(amount - free)
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mt-2 text-[12.5px] text-slate-500",
                                    children: [
                                        "Free amounts: ",
                                        $9c67b656ca11544c$var$money((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0)),
                                        " a financial year, and no more than ",
                                        $9c67b656ca11544c$var$money((0, $1abe73eeef086faf$export$9cd36ea38af5a5f3)),
                                        " over any five. The same counting applies if either moves into residential care in that time."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: $9c67b656ca11544c$var$card,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-[13px] font-bold text-brand-navy",
                                            children: "What it does to the plan"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                            className: "mt-2 w-full text-[14px]",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "border-b border-slate-100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-2 text-slate-600",
                                                                children: "Left to the family"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "py-2 text-right",
                                                                children: [
                                                                    "falls by about ",
                                                                    $9c67b656ca11544c$var$money(amount),
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "text-slate-500",
                                                                        children: "\u2014 given now instead"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-2 text-slate-600",
                                                                children: "Investment income"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "py-2 text-right",
                                                                children: [
                                                                    "falls on the ",
                                                                    $9c67b656ca11544c$var$money(amount)
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        eff.pension != null && eff.pension < 1 && amount > free && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "mt-2 text-[13px] text-slate-700",
                                            children: [
                                                "The Age Pension is $0 here, so the gift changes nothing now. It matters later: if ",
                                                v.their,
                                                " money runs down, or one of ",
                                                v.them,
                                                " moves into residential care within five years, the ",
                                                $9c67b656ca11544c$var$money(amount - free),
                                                " still counts."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9c67b656ca11544c$var$HowItWorks, {
                                    how: `Money is given to family now, rather than left in the estate. Centrelink stops counting up to ${$9c67b656ca11544c$var$money((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))} given away in a financial year, and no more than ${$9c67b656ca11544c$var$money((0, $1abe73eeef086faf$export$9cd36ea38af5a5f3))} over five years. Anything above that is still counted as the giver's for five years.`,
                                    good: [
                                        'Helping family now, when it matters to them',
                                        'Within the limits, lowering what Centrelink counts'
                                    ],
                                    watch: [
                                        'A gift cannot be taken back',
                                        'Above the limits it is still counted for five years, including if care is needed',
                                        'Less left for their own costs later'
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    // ---------- the whole plan ----------
    const profile = (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[(0, $0f2c0a6799fe36da$export$580cfd0c6323bf7e)(factFind)]?.label || 'Conservative';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        "data-testid": "rv-build",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-x-6 gap-y-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: p.onBackToPlans,
                        className: "inline-flex items-center gap-1.5 text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                        "data-testid": "rv-back-to-plans",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                size: 16
                            }),
                            " Back to the plans we tested"
                        ]
                    }),
                    p.onClear && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: p.onClear,
                        className: "text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                        "data-testid": "rv-clear-start-again",
                        children: "Clear and start again"
                    })
                ]
            }),
            header(p.startedFrom ? 'Customise this plan' : 'Build a plan yourself', /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "One picture of ",
                    v.their,
                    " money: where it comes from, and where every dollar goes \u2014 the village first, then the emergency money, then what's left put to work.",
                    p.startedFrom ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " Customising ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    "\u201C",
                                    p.startedFrom,
                                    "\u201D"
                                ]
                            }),
                            "; change anything and the figures follow."
                        ]
                    }) : null
                ]
            })),
            p.startOptions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-2 text-[13px]",
                "data-testid": "rv-start-from",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-slate-500",
                        children: "Start from:"
                    }),
                    p.startOptions.map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            onClick: ()=>p.onStartFrom(o.id),
                            className: `rounded-lg border px-3 py-1.5 font-semibold ${p.startedFrom === o.label ? 'border-blue-600 bg-blue-50 text-brand-navy' : 'border-slate-300 bg-white text-slate-700 hover:border-blue-300'}`,
                            children: [
                                p.startedFrom === o.label ? "\u2713 " : '',
                                o.label
                            ]
                        }, o.id))
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 items-start gap-5 xl:grid-cols-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `${$9c67b656ca11544c$var$card} xl:col-span-2`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[13px] font-bold text-brand-navy",
                                children: "1 \xb7 Where the money comes from"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "overflow-x-auto",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    className: "mt-2 w-full min-w-[620px] text-[13.5px]",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "text-left text-[12px] text-slate-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "py-1.5",
                                                        children: "Source"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "py-1.5 text-right",
                                                        children: "Has"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "py-1.5 text-right",
                                                        children: "Use"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "py-1.5 pl-3",
                                                        children: "What using it does"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                            children: [
                                                hasHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    className: "border-t border-slate-100 align-top",
                                                    "data-testid": "rv-source-home",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "py-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "The family home"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                    value: route,
                                                                    onChange: (e)=>p.onRoute(e.target.value),
                                                                    className: "mt-1 rounded-lg border border-slate-300 px-2 py-1 text-[13px]",
                                                                    "aria-label": "What happens to the family home",
                                                                    "data-testid": "rv-home-route",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "sell",
                                                                            children: "Sold"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "rent",
                                                                            children: "Kept and rented out"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "keep",
                                                                            children: "Kept, not rented"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "py-2 text-right tabular-nums",
                                                            children: [
                                                                $9c67b656ca11544c$var$money($9c67b656ca11544c$var$num(details.salePrice) - $9c67b656ca11544c$var$num(details.sellingCosts)),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-[12px] text-slate-500",
                                                                    children: "after selling costs"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "py-2 text-right tabular-nums",
                                                            children: $9c67b656ca11544c$var$money(route === 'sell' ? saleNet : 0)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "py-2 pl-3 text-[12.5px] text-slate-700",
                                                            children: [
                                                                route === 'sell' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                    children: [
                                                                        "No tax: it is ",
                                                                        v.their,
                                                                        " home. Once sold, the money is counted for the Age Pension."
                                                                    ]
                                                                }),
                                                                route === 'rent' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                    children: [
                                                                        "Kept and let; it counts for the Age Pension straight away, and the rent counts as income.",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "mt-1 flex flex-wrap items-center gap-1.5",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                                                    value: p.rent.weekly,
                                                                                    onChange: (n)=>p.onRent({
                                                                                            weekly: Math.max(0, n ?? 0)
                                                                                        }),
                                                                                    className: "w-28",
                                                                                    ariaLabel: "Rent a week"
                                                                                }),
                                                                                " a week, less",
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                                                    value: p.rent.costs,
                                                                                    onChange: (n)=>p.onRent({
                                                                                            costs: Math.max(0, n ?? 0)
                                                                                        }),
                                                                                    className: "w-28",
                                                                                    ariaLabel: "Yearly costs of the rented home"
                                                                                }),
                                                                                " a year of costs, empty",
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                                    type: "number",
                                                                                    min: 0,
                                                                                    max: 52,
                                                                                    value: p.rent.vacancy,
                                                                                    onChange: (e)=>p.onRent({
                                                                                            vacancy: Math.max(0, Math.min(52, parseFloat(e.target.value) || 0))
                                                                                        }),
                                                                                    className: "w-16 rounded-lg border border-slate-300 px-2 py-1",
                                                                                    "aria-label": "Weeks a year empty"
                                                                                }),
                                                                                " weeks a year"
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                route === 'keep' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                                                    children: "Kept, not let: it counts for the Age Pension straight away."
                                                                }),
                                                                route === 'rent' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "mt-2",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f5ab3af26c11dd09$export$5d3c9135c9ed8866), {
                                                                        homeValue: $9c67b656ca11544c$var$num(factFind?.home?.value)
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                sources.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "border-t border-slate-100 align-top",
                                                        "data-testid": "rv-source",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "py-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: s.name
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "text-[12px] text-slate-500",
                                                                        children: $9c67b656ca11544c$var$KIND_LABEL[s.kind]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-2 text-right tabular-nums",
                                                                children: $9c67b656ca11544c$var$money(s.value)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-2 text-right",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                                    value: $9c67b656ca11544c$var$num(p.funding[s.key]),
                                                                    onChange: (n)=>p.onFunding(s.key, Math.max(0, Math.min(s.value - $9c67b656ca11544c$var$num(p.reservedByAsset?.[s.key]), n ?? 0))),
                                                                    className: "ml-auto w-32",
                                                                    ariaLabel: `Use from ${s.name}`
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "py-2 pl-3 text-[12.5px] text-slate-700",
                                                                children: [
                                                                    sourceWords(s),
                                                                    $9c67b656ca11544c$var$num(p.reservedByAsset?.[s.key]) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                        children: [
                                                                            " ",
                                                                            $9c67b656ca11544c$var$money($9c67b656ca11544c$var$num(p.reservedByAsset?.[s.key])),
                                                                            " of it is committed to clearing debt."
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, s.key)),
                                                ips.map((ip)=>{
                                                    const id = String(ip.id);
                                                    const on = p.ipSoldId === id;
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "border-t border-slate-100 align-top",
                                                        "data-testid": "rv-source-ip",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "py-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: String(ip.description || '').trim() || 'Investment property'
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "text-[12px] text-slate-500",
                                                                        children: "investment property"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-2 text-right tabular-nums",
                                                                children: $9c67b656ca11544c$var$money($9c67b656ca11544c$var$num(ip.value))
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-2 text-right",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                    className: "inline-flex items-center gap-1.5 text-[13px]",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                            type: "checkbox",
                                                                            checked: on,
                                                                            onChange: (e)=>p.onIpSell(e.target.checked ? id : null)
                                                                        }),
                                                                        " Sell it"
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "py-2 pl-3 text-[12.5px] text-slate-700",
                                                                children: [
                                                                    on ? `Sold: ${$9c67b656ca11544c$var$money(p.ipNetFromSale)} after selling costs and capital gains tax goes towards the entry payment; the rent stops.` : 'Kept. Selling it costs selling fees and capital gains tax on any gain, and the rent stops.',
                                                                    on && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "mt-2",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f5ab3af26c11dd09$export$79338cd264d71ddf), {})
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, id);
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-3 flex flex-wrap items-baseline justify-between gap-2 rounded-xl border border-slate-200 px-4 py-2.5 text-[14px]",
                                "data-testid": "rv-still-to-place",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                className: "text-brand-navy",
                                                children: [
                                                    "To place: ",
                                                    $9c67b656ca11544c$var$money(toPlace)
                                                ]
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-slate-500",
                                                children: route === 'sell' ? `from the sale${liquidGross > 0 ? ` and ${$9c67b656ca11544c$var$money(liquidGross)} from savings and investments` : '; nothing taken from savings and investments'}` : 'from savings and investments'
                                            })
                                        ]
                                    }),
                                    route === 'sell' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: stillToPlace < -1 ? 'text-rose-700' : 'text-emerald-700',
                                        children: [
                                            "Still to place: ",
                                            $9c67b656ca11544c$var$money(Math.max(0, stillToPlace)),
                                            stillToPlace >= -1 && stillToPlace < 1 ? " \u2713" : '',
                                            stillToPlace < -1 ? ` (over by ${$9c67b656ca11544c$var$money(-stillToPlace)})` : ''
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: entryShort >= 1 ? 'text-rose-700' : 'text-emerald-700',
                                        children: entryShort >= 1 ? `Entry payment short by ${$9c67b656ca11544c$var$money(entryShort)}` : "Entry payment covered \u2713"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-1 text-[13.5px] text-slate-700",
                                children: [
                                    "Any money ",
                                    v.you ? 'you don\'t' : `${v.they} don't`,
                                    " place goes into ",
                                    v.their,
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "bank account"
                                    }),
                                    "."
                                ]
                            }),
                            liquidGross > 0 && !(0, $056bec631a0e8ebc$export$7ecf57148a92ad89)(p.rawFunding || {}) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1 text-[12.5px] text-slate-500",
                                "data-testid": "rv-build-suggested-draw",
                                children: "The amounts taken from savings and investments are our suggested order (cash, then pensions, then shares, keeping the emergency money). This is a suggested starting point, not a recommendation: change any of them."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-5 text-[13px] font-bold text-brand-navy",
                                children: "2 \xb7 Where it goes, in this order"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                className: "mt-2 w-full",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "border-b border-slate-100",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "py-2 text-[14px]",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Village entry payment"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-slate-500",
                                                            children: [
                                                                "\u2014 paid on the day ",
                                                                v.they,
                                                                " move"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "py-2 text-right font-semibold tabular-nums",
                                                    children: $9c67b656ca11544c$var$money(entryFee)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "border-b border-slate-100",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "py-2 text-[14px]",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Emergency money"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-slate-500",
                                                            children: [
                                                                "\u2014 kept in the bank",
                                                                route === 'sell' ? ', not from the sale' : ''
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "py-2 text-right text-slate-500 tabular-nums",
                                                    children: [
                                                        $9c67b656ca11544c$var$money(p.reserve),
                                                        " held"
                                                    ]
                                                })
                                            ]
                                        }),
                                        route === 'sell' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                dest(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        clientName,
                                                        "'s super, downsizer contribution ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-slate-500",
                                                            children: [
                                                                "up to ",
                                                                $9c67b656ca11544c$var$money((0, $1abe73eeef086faf$export$42edd27decf8c272))
                                                            ]
                                                        })
                                                    ]
                                                }), 'downsizerContribution', `${clientName}'s super`, {
                                                    max: (0, $1abe73eeef086faf$export$42edd27decf8c272),
                                                    dive: 'super',
                                                    testId: 'rv-dest-super-client',
                                                    note: $9c67b656ca11544c$var$num(details.downsizerContribution) > 0 && goals.rvOwned10Years !== 'yes' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-[12.5px] font-semibold text-amber-700",
                                                        children: [
                                                            " \xb7 confirm ",
                                                            v.they,
                                                            " owned the home 10 years"
                                                        ]
                                                    }) : null
                                                }),
                                                isCouple && dest(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        partnerName,
                                                        "'s super, downsizer contribution ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-slate-500",
                                                            children: [
                                                                "up to ",
                                                                $9c67b656ca11544c$var$money((0, $1abe73eeef086faf$export$42edd27decf8c272))
                                                            ]
                                                        })
                                                    ]
                                                }), 'partnerDownsizerContribution', `${partnerName}'s super`, {
                                                    max: (0, $1abe73eeef086faf$export$42edd27decf8c272),
                                                    dive: 'super',
                                                    testId: 'rv-dest-super-partner',
                                                    note: $9c67b656ca11544c$var$num(details.partnerDownsizerContribution) > 0 && goals.rvOwned10Years !== 'yes' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-[12.5px] font-semibold text-amber-700",
                                                        children: [
                                                            " \xb7 confirm ",
                                                            v.they,
                                                            " owned the home 10 years"
                                                        ]
                                                    }) : null
                                                }),
                                                dest('Guaranteed income for life', 'purchaseAnnuity', 'Guaranteed income', {
                                                    dive: 'annuity',
                                                    testId: 'rv-dest-annuity'
                                                }),
                                                dest(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        "Investment property, bought outright",
                                                        duty > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-slate-500",
                                                            children: [
                                                                " \xb7 plus ",
                                                                $9c67b656ca11544c$var$money(duty),
                                                                " stamp duty"
                                                            ]
                                                        }) : null
                                                    ]
                                                }), 'purchaseInvestmentProperty', 'Investment property', {
                                                    dive: 'property',
                                                    testId: 'rv-dest-property'
                                                }),
                                                dest('Gift to family', 'giftingAmount', 'Gift', {
                                                    dive: 'gift',
                                                    testId: 'rv-dest-gift'
                                                }),
                                                dest(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        "Funeral bonds ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-slate-500",
                                                            children: [
                                                                "up to ",
                                                                $9c67b656ca11544c$var$money((0, $1abe73eeef086faf$export$aca3edb7cd7a3f17)),
                                                                " each, left out of the assets test"
                                                            ]
                                                        })
                                                    ]
                                                }), 'funeralBondPurchase', 'Funeral bonds', {
                                                    max: (0, $1abe73eeef086faf$export$aca3edb7cd7a3f17) * (isCouple ? 2 : 1)
                                                }),
                                                dest(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        "Invested",
                                                        isCouple ? ', joint names' : '',
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-slate-500",
                                                            children: [
                                                                "\xb7 ",
                                                                profile,
                                                                " mix"
                                                            ]
                                                        })
                                                    ]
                                                }), 'purchaseShares', 'Invested', {
                                                    testId: 'rv-dest-invested'
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "py-2 text-[14px]",
                                                            children: [
                                                                "Kept in the bank ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-slate-500",
                                                                    children: "earns 2%, no growth"
                                                                }),
                                                                stillToPlace >= 25000 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                    children: [
                                                                        " \xb7 ",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                            type: "button",
                                                                            onClick: ()=>p.onDetails({
                                                                                    purchaseShares: $9c67b656ca11544c$var$num(details.purchaseShares) + stillToPlace
                                                                                }, `Invested the ${$9c67b656ca11544c$var$money(stillToPlace)} left in the bank`),
                                                                            className: `${$9c67b656ca11544c$var$link} text-[13px]`,
                                                                            "data-testid": "rv-invest-remainder",
                                                                            children: [
                                                                                "invest it \u2014 ",
                                                                                profile
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "py-2 text-right tabular-nums text-slate-700",
                                                            "data-testid": "rv-dest-bank",
                                                            children: $9c67b656ca11544c$var$money(Math.max(0, stillToPlace))
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        route !== 'sell' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                dest('Guaranteed income for life', 'purchaseAnnuity', 'Guaranteed income', {
                                                    dive: 'annuity',
                                                    testId: 'rv-dest-annuity'
                                                }),
                                                dest(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        "Investment property, bought outright",
                                                        duty > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-slate-500",
                                                            children: [
                                                                " \xb7 plus ",
                                                                $9c67b656ca11544c$var$money(duty),
                                                                " stamp duty"
                                                            ]
                                                        }) : null
                                                    ]
                                                }), 'purchaseInvestmentProperty', 'Investment property', {
                                                    dive: 'property',
                                                    testId: 'rv-dest-property'
                                                }),
                                                dest(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        "Invested",
                                                        isCouple ? ', joint names' : '',
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-slate-500",
                                                            children: [
                                                                "\xb7 ",
                                                                profile,
                                                                " mix"
                                                            ]
                                                        })
                                                    ]
                                                }), 'purchaseShares', 'Invested', {
                                                    testId: 'rv-dest-invested'
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    className: "border-b border-slate-100",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "py-2 text-[14px]",
                                                            children: [
                                                                "Gift to family \xb7 ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: ()=>setDive('gift'),
                                                                    className: `${$9c67b656ca11544c$var$link} text-[13px]`,
                                                                    children: "set it up \u203A"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "py-2 text-right",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                                value: p.other.giftingAmount,
                                                                onChange: (n)=>p.onOther({
                                                                        giftingAmount: Math.max(0, n ?? 0)
                                                                    }, `Gift \u{2192} ${$9c67b656ca11544c$var$money(n ?? 0)}`),
                                                                className: "ml-auto w-36",
                                                                ariaLabel: "Gift to family"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    className: "border-b border-slate-100",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "py-2 text-[14px]",
                                                            children: [
                                                                "Funeral bonds ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "text-slate-500",
                                                                    children: [
                                                                        "up to ",
                                                                        $9c67b656ca11544c$var$money((0, $1abe73eeef086faf$export$aca3edb7cd7a3f17)),
                                                                        " each"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "py-2 text-right",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                                value: p.other.funeralBondAmount,
                                                                onChange: (n)=>p.onOther({
                                                                        funeralBondAmount: Math.max(0, Math.min((0, $1abe73eeef086faf$export$aca3edb7cd7a3f17) * (isCouple ? 2 : 1), n ?? 0))
                                                                    }, `Funeral bonds \u{2192} ${$9c67b656ca11544c$var$money(n ?? 0)}`),
                                                                className: "ml-auto w-36",
                                                                ariaLabel: "Funeral bonds"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "py-2 text-[13px] text-slate-700",
                                                        colSpan: 2,
                                                        "data-testid": "rv-savings-uses",
                                                        children: [
                                                            fromSavingsForUses > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                children: [
                                                                    "These take ",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: $9c67b656ca11544c$var$money(fromSavingsForUses)
                                                                    }),
                                                                    " from savings after the entry payment, keeping the ",
                                                                    $9c67b656ca11544c$var$money(p.reserve),
                                                                    " for emergencies",
                                                                    savingsShort >= 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                        className: "text-rose-700",
                                                                        children: [
                                                                            " \u2014 ",
                                                                            $9c67b656ca11544c$var$money(savingsShort),
                                                                            " more than savings can spare"
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                        children: [
                                                                            " (",
                                                                            $9c67b656ca11544c$var$money(savingsSpare),
                                                                            " to spare)"
                                                                        ]
                                                                    }),
                                                                    "."
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                children: [
                                                                    "Savings can also pay for a guaranteed income, a property or investing: ",
                                                                    $9c67b656ca11544c$var$money(savingsSpare),
                                                                    " to spare after the entry payment and the emergency money."
                                                                ]
                                                            }),
                                                            ' ',
                                                            "A downsizer contribution to super needs the home sold."
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            route === 'sell' && $9c67b656ca11544c$var$num(details.purchaseShares) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-3",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25ac2ec5abfb5852$export$23e482971454dc30), {
                                    factFind: factFind,
                                    setFactFind: p.setFactFind,
                                    idPrefix: "rv-build",
                                    what: "this money"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-3 text-[13px] text-slate-500",
                                children: [
                                    "Every dollar taken on the left goes somewhere on the right. Each thing ",
                                    v.they,
                                    " own is listed on the left, so ",
                                    v.you ? 'you choose' : `${v.they} choose`,
                                    " what to sell and how much."
                                ]
                            }),
                            p.debtCard,
                            route === 'sell' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-2 text-[13px] text-slate-700",
                                "data-testid": "rv-build-borrowing",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Borrowing:"
                                    }),
                                    " ",
                                    ipLoan > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            "a ",
                                            $9c67b656ca11544c$var$money(ipLoan),
                                            " loan towards the investment property."
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            "none. Banks rarely lend at ",
                                            v.their,
                                            " ages; if a lender has agreed to finance an investment property, switch it on in the property's set-up."
                                        ]
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setDive('property'),
                                        className: `${$9c67b656ca11544c$var$link} text-[13px]`,
                                        children: ipLoan > 0 ? "change it \u203A" : "set it up \u203A"
                                    })
                                ]
                            })
                        ]
                    }),
                    effectPanel
                ]
            })
        ]
    });
};
var $9c67b656ca11544c$export$2e2bcd8739ae039 = $9c67b656ca11544c$var$RvBuildPlan;

















/**
 * "Explain this": how the money a plan invests would be held (owner, 23 Oct 2026). Shown where the plan's card
 * says money is invested; the words are investedWhere.ts's, so the card and the note never disagree.
 */ 
parcelRequire("acw62");

const $cd95277538ec3233$export$de2bcaca032f78be = ({ factFind: factFind, testId: testId = 'how-it-is-invested' })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-5 rounded-xl border border-slate-200 border-l-4 border-l-slate-400 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "font-bold text-slate-900",
                children: "How the invested money would be held"
            }),
            (0, $5fe2dfde2f334213$export$e8f6b2b9eb3eb02b)(factFind).map((w, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "mt-1",
                    children: w
                }, i))
        ]
    });
var $cd95277538ec3233$export$2e2bcd8739ae039 = $cd95277538ec3233$export$de2bcaca032f78be;



const $7911ccd6eced4ff4$var$RV_EXPLAIN_SECTIONS = [
    {
        id: 'entry',
        icon: (0, $52885985d1db6c06$export$2e2bcd8739ae039),
        title: 'Entry payment',
        summary: "A one-off amount when you move in\u2014often called the ingoing contribution or purchase price. Many villages set this out in a disclosure statement.",
        details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            className: "text-gray-700 leading-relaxed",
            children: "The entry payment is your upfront cost to secure your unit. It can be a large sum and may be close to market value for long-term lease or purchase arrangements. Additional one-off fees (e.g. garage, parking) may apply. Get the village's disclosure statement for exact figures."
        }),
        applies: null
    },
    {
        id: 'ongoing',
        icon: (0, $1571f1c57333e026$export$2e2bcd8739ae039),
        title: 'Regular fees',
        summary: 'Weekly or monthly fees for services, maintenance and shared facilities. The disclosure statement usually shows how and when these can increase.',
        details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            className: "text-gray-700 leading-relaxed",
            children: "Recurrent charges are split among residents from the village's annual budget. They typically cover management, insurance, maintenance, communal facilities (pool, gym, gardens) and 24-hour emergency. Optional services (meals, cleaning, laundry) are usually itemised and only charged if used. Contracts must state how and when fees can increase (e.g. CPI, notice periods)."
        }),
        applies: null
    },
    {
        id: 'exit',
        icon: (0, $5473793717b51056$export$2e2bcd8739ae039),
        title: 'When you leave',
        summary: "A departure fee (deferred management fee) is usually taken from the amount you get back. You may also get a share of any increase in the unit's value.",
        details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            className: "text-gray-700 leading-relaxed",
            children: "The departure fee (DMF) is a major cost and is contract-specific\u2014it must be in the disclosure statement. It is often a percentage per year of residency with a cap (e.g. 2% per year, capped at 20% after 10 years). The percentage can apply to your entry payment or to the amount the next resident pays. Other exit costs can include reinstatement (returning the unit to original condition) and refurbishment. Your village's disclosure statement will spell out the exact rules."
        }),
        applies: null
    },
    {
        id: 'contract-right',
        icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
        title: 'Right to live there (no ownership)',
        summary: "You pay an entry amount and regular fees but don't own the unit. When you leave, you get back an amount (often when the unit is re-sold) after the departure fee and other deductions.",
        details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-gray-700 leading-relaxed space-y-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        "This is the most common arrangement \u2014 legally a ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "loan or licence"
                        }),
                        ": your entry payment buys a contractual right to occupy under your state's Retirement Villages Act, while the operator keeps title. Practical consequences worth knowing:"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                    className: "list-disc pl-5 space-y-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: "You can't borrow against the unit or sell it yourself \u2014 your money comes back through the contract, not a property sale."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                "Your exit entitlement is usually paid when the unit is ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "re-licensed to the next resident"
                                }),
                                ", so timing depends on how quickly the village re-sells. Some states guarantee payment after a set period \u2014 see the state protections further down this page."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: "Questions to ask before signing: who pays the regular fees between your leaving and the re-sale? Who sets the re-sale price and appoints the agent? What happens to your entitlement if the village is sold or the operator fails?"
                        })
                    ]
                })
            ]
        }),
        applies: null
    },
    {
        id: 'contract-own',
        icon: (0, $8474226e5f2f9b18$export$2e2bcd8739ae039),
        title: 'You own the unit',
        summary: 'For example strata or community title. You own the unit (sometimes with rules on resale). When you leave, you sell it or the village may buy it back; the departure fee and contract terms still apply.',
        details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-gray-700 leading-relaxed space-y-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "With strata or community title you hold real title \u2014 which changes the mechanics, not the economics:"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                    className: "list-disc pl-5 space-y-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                "You may pay ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "two sets of ongoing charges"
                                }),
                                ": strata levies for the building AND village fees for services \u2014 check what each covers."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: "Resale is often restricted to age-qualified buyers, which can slow the sale or soften the price compared with the open market; some contracts give the operator a buy-back right at a formula price."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: "Because you hold title, stamp duty usually applies on the way in \u2014 a real cost the loan/licence route avoids."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: "The departure fee still applies on exit in most ownership contracts \u2014 ownership does not escape the DMF."
                        })
                    ]
                })
            ]
        }),
        applies: null
    },
    {
        id: 'pension',
        icon: (0, $33b542e8915cec79$export$2e2bcd8739ae039),
        title: 'Age Pension impact',
        summary: `Services Australia uses your entry payment to decide homeowner status (threshold $${(0, $1abe73eeef086faf$export$e2cf792e99a08354).toLocaleString()}). Above = homeowner (entry not in assets); at or below = non-homeowner (entry counted, Rent Assistance possible).`,
        details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-gray-700 leading-relaxed space-y-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Why the classification matters more than it sounds \u2014 a worked example:"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                    className: "list-disc pl-5 space-y-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                "Entry payment $600,000, threshold $",
                                (0, $1abe73eeef086faf$export$e2cf792e99a08354).toLocaleString(),
                                ": you're a ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "homeowner"
                                }),
                                " \u2014 the $600,000 vanishes from the assets test entirely, but your remaining assets are then measured against the ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                    children: "lower"
                                }),
                                " homeowner thresholds."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                "Entry payment $200,000: you're a ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "non-homeowner"
                                }),
                                " \u2014 the $200,000 IS counted, but you get the ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                    children: "higher"
                                }),
                                " non-homeowner thresholds and may qualify for ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Rent Assistance"
                                }),
                                " on your regular fees, which can be worth thousands a year."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: "Money left over after the entry payment (say, from selling your home) becomes a financial asset \u2014 deemed for the income test and counted for the assets test. That's often the biggest pension effect of the whole move, and it's why the calculator models the entry payment and the leftover together rather than in isolation."
                        })
                    ]
                })
            ]
        }),
        applies: null
    },
    {
        id: 'legacy',
        icon: (0, $6315759428919b56$export$2e2bcd8739ae039),
        title: 'What you leave to family',
        summary: 'The amount you get back when you leave (after the departure fee and other costs) is often paid when the unit is sold. That amount affects what you can leave to your family.',
        details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-gray-700 leading-relaxed space-y-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Three things families are most often surprised by:"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                    className: "list-disc pl-5 space-y-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "The wait."
                                }),
                                " The exit entitlement is a contract debt owed by the operator, not a property your estate can sell \u2014 it's typically paid only when the unit re-sells, which can take months (some state Acts set a backstop period \u2014 see the state section below). Until then it may be earning nothing while regular fees, in some states, continue."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "The departure fee grows with time."
                                }),
                                ' A 3%-per-year DMF capped at 10 years means an estate loses far more after a 10-year stay than after a 3-year one \u2014 the "You get back (est.)" figure in the calculator shows exactly this for your inputs.'
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "The gain share cuts both ways."
                                }),
                                " If the contract gives you 50% of any capital gain, the other 50% never reaches your estate \u2014 and some contracts pass the resident a share of a capital ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                    children: "loss"
                                }),
                                " too."
                            ]
                        })
                    ]
                })
            ]
        }),
        applies: null
    }
];
/**
 * The one help device on a form field (owner, 22 and 24 Sep 2026): a dotted "what's this?" that
 * opens a small card over the page — never an icon, and never an in-place expansion, which pushed
 * this two-column form apart. The shared InfoIcon; the aged care analyser uses the same one.
 */ const $7911ccd6eced4ff4$var$WhatsThis = ({ text: text })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
        text: text
    });
/** The contract as kept on the file (goals.rv*), or null when step 1 has never been filled in. */ function $7911ccd6eced4ff4$var$villageInputsFromGoals(factFind) {
    const g = factFind?.goals || {};
    if (g.rvEntryFee == null) return null;
    const num = (x, d)=>Number.isFinite(Number(x)) ? Number(x) : d;
    return {
        entryFee: num(g.rvEntryFee, 0),
        ongoingWeeklyOrMonthly: num(g.rvFees, 0),
        ongoingFrequency: g.rvFeesFrequency === 'weekly' ? 'weekly' : 'monthly',
        dmfPctPerYear: num(g.rvDmfPct, 0),
        dmfCapYears: num(g.rvDmfCapYears, 0),
        yearsResidency: num(g.rvYearsResidency, 0),
        growthRatePct: num(g.rvGrowthPct, 3),
        capitalGainShareToResident: num(g.rvGainSharePct, 50) / 100,
        reinstatementCap: num(g.rvReinstatementCap, 0)
    };
}
function $7911ccd6eced4ff4$var$villageInputsToGoals(v) {
    return {
        rvEntryFee: v.entryFee || 0,
        rvFees: v.ongoingWeeklyOrMonthly || 0,
        rvFeesFrequency: v.ongoingFrequency,
        rvDmfPct: v.dmfPctPerYear || 0,
        rvDmfCapYears: v.dmfCapYears || 0,
        rvYearsResidency: v.yearsResidency || 0,
        rvGrowthPct: v.growthRatePct ?? 3,
        rvGainSharePct: Math.round((v.capitalGainShareToResident ?? 0.5) * 1000) / 10,
        rvReinstatementCap: v.reinstatementCap || 0
    };
}
/** Numeric-input strings (mid-edit draft values, incl. '') coerced to a real number — the same
 *  defensive `parseFloat(String(x))` idiom used at calc-engine read sites (see
 *  shared/src/calculation/factFindTypes.ts). */ const $7911ccd6eced4ff4$var$n = (v)=>parseFloat(String(v ?? '')) || 0;
/** "Is a village right for you?" — each point leads with the claim, then the detail. */ const $7911ccd6eced4ff4$var$RV_CHECKLIST_LOVES = [
    {
        icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
        lead: 'Community on your doorstep.',
        body: "Neighbours at a similar stage of life, clubs and activities, and someone to notice if you don't show up for coffee."
    },
    {
        icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
        lead: 'A secure, low-maintenance home.',
        body: 'No gutters, no lawns, and help on call if you want it.'
    },
    {
        icon: (0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039),
        lead: 'Money and energy freed up.',
        body: 'Moving out of a large family home can release both for the things you actually want to do.'
    }
];
const $7911ccd6eced4ff4$var$RV_CHECKLIST_WEIGH_UP = [
    {
        icon: (0, $64d93451351598d0$export$2e2bcd8739ae039),
        lead: "You're buying a contract, not just a home.",
        body: 'Leaving costs real money (the departure fee below), so a village suits people planning to stay.'
    },
    {
        icon: (0, $200392fae49ddb7e$export$2e2bcd8739ae039),
        lead: 'Your exit money usually waits for a re-sale.',
        body: "That timing matters for your estate, and for funding aged care if it's ever needed."
    },
    {
        icon: (0, $6b98cc9f5dadc552$export$2e2bcd8739ae039),
        lead: 'A later move into aged care means moving twice.',
        body: 'Worth modelling both steps, which this tool can do.'
    },
    {
        icon: (0, $0811c1891b547863$export$2e2bcd8739ae039),
        lead: 'Compare contracts, not brochures.',
        body: "Look at two or three villages' contracts and get legal advice before signing. Your state's protections are summarised further down this page."
    }
];
const $7911ccd6eced4ff4$var$RetirementVillageExplained = ({ setActivePage: setActivePage, onContinue: onContinue, rvState: rvState, setRvState: setRvState, backLabel: backLabel })=>{
    const [openAccordion, setOpenAccordion] = (0, $acw62.useState)(null);
    const toggleAccordion = (id)=>setOpenAccordion(openAccordion === id ? null : id);
    const stateRules = (0, $cb0d223b5401e577$export$432ee5f70f8b1031)(rvState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-6xl mx-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                variant: "ghost",
                size: "sm",
                icon: (0, $c31db635520dc385$export$2e2bcd8739ae039),
                onClick: ()=>backLabel ? onContinue() : setActivePage('Dashboard'),
                className: "mb-4 -ml-2",
                "data-testid": "rv-guide-back",
                children: backLabel || 'Back to Dashboard'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-4 mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                icon: (0, $d5c3c2c5a9eb8655$export$388c0e4f7230aadf).retirement_village,
                                tone: "brand",
                                variant: "solid",
                                size: "lg",
                                className: "hidden sm:inline-flex"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-4xl md:text-5xl font-bold text-gray-900",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6288781efbc92679$export$2e2bcd8739ae039), {
                                    children: "Retirement Village (Independent Living)"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-lg text-slate-700 leading-relaxed mb-3",
                        children: "Plenty of Australians choose village living for the lifestyle: your own home without the maintenance, a ready-made community, and facilities \u2014 gardens, pools, social clubs \u2014 a short walk away. You live independently, add services like cleaning or meals only if and when you want them, and lock up and travel whenever you like. It's not aged care, and no government assessment is needed \u2014 it's a lifestyle choice with a financial contract attached, and this section helps you weigh both."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-sm text-slate-500",
                        children: [
                            "Many villages provide a ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "disclosure statement"
                            }),
                            " that sets out costs and contract terms. If you have or expect one, use it when modelling your options in the calculator."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                className: "mb-8 rounded-2xl border border-slate-200 bg-white shadow-card group overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("summary", {
                        className: "cursor-pointer list-none p-5 flex items-center gap-4 [&::-webkit-details-marker]:hidden",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                icon: (0, $0811c1891b547863$export$2e2bcd8739ae039),
                                tone: "brand",
                                variant: "soft",
                                size: "md",
                                className: "hidden sm:inline-flex"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex-1 min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "block text-lg font-bold text-gray-900",
                                        children: "Is a village right for you?"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "block text-sm text-slate-600",
                                        children: "The honest checklist \u2014 what residents love, and what to weigh up before you sign."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "shrink-0 inline-flex items-center gap-1 rounded-full border border-slate-200 px-3 py-1 text-sm font-semibold text-blue-700",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "group-open:hidden",
                                        children: "Show"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "hidden group-open:inline",
                                        children: "Hide"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                        size: 16,
                                        className: "transition-transform group-open:rotate-180",
                                        "aria-hidden": true
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-4 px-5 pb-5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                className: "rounded-xl border border-emerald-200 p-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                        className: "mb-3 flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-emerald-800",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90bba72fbdd9e9$export$2e2bcd8739ae039), {
                                                size: 16,
                                                "aria-hidden": true
                                            }),
                                            " What residents tend to love"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                        className: "space-y-3.5",
                                        children: $7911ccd6eced4ff4$var$RV_CHECKLIST_LOVES.map(({ icon: Icon, lead: lead, body: body })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                className: "flex gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-navy text-white",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                                            size: 16,
                                                            "aria-hidden": true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-sm leading-relaxed text-slate-700",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-semibold text-slate-900",
                                                                children: lead
                                                            }),
                                                            " ",
                                                            body
                                                        ]
                                                    })
                                                ]
                                            }, lead))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                className: "rounded-xl border border-amber-200 p-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                        className: "mb-3 flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-amber-800",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                                size: 16,
                                                "aria-hidden": true
                                            }),
                                            " What to weigh up before signing"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                        className: "space-y-3.5",
                                        children: $7911ccd6eced4ff4$var$RV_CHECKLIST_WEIGH_UP.map(({ icon: Icon, lead: lead, body: body })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                className: "flex gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-amber-500 text-white",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                                            size: 16,
                                                            "aria-hidden": true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-sm leading-relaxed text-slate-700",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-semibold text-slate-900",
                                                                children: lead
                                                            }),
                                                            " ",
                                                            body
                                                        ]
                                                    })
                                                ]
                                            }, lead))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "text-2xl font-bold text-gray-900 mb-2",
                children: "Your options and what they cost"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-base text-gray-600 mb-4",
                children: "Tap each one to see how it works \u2014 the upfront entry payment, the regular fees, what happens when you leave, who owns the unit, and how it affects your Age Pension and estate."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "space-y-4 mb-8",
                children: $7911ccd6eced4ff4$var$RV_EXPLAIN_SECTIONS.map((fee)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b5fe5727b69e005$export$2e2bcd8739ae039), {
                        ...fee,
                        isOpen: openAccordion === fee.id,
                        onToggle: ()=>toggleAccordion(fee.id),
                        factFind: {}
                    }, fee.id))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-8 rounded-2xl border border-slate-200 bg-white p-5 shadow-card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-start gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                        icon: (0, $e325251f2797f6cf$export$2e2bcd8739ae039),
                                        tone: "brand",
                                        variant: "soft",
                                        size: "sm",
                                        className: "hidden sm:inline-flex"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                className: "text-2xl font-bold text-gray-900",
                                                children: "The rules where you live"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-base text-slate-600 max-w-xl",
                                                children: "The money side (Age Pension, Rent Assistance) is the same Australia-wide. What changes by state is the consumer-protection law \u2014 most importantly, how long you (or your estate) might wait to be repaid after you leave, and how long you keep paying fees after moving out."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "shrink-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "rv-state",
                                        className: "block text-xs font-medium text-slate-600 mb-1",
                                        children: "Your state or territory"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        id: "rv-state",
                                        value: rvState || '',
                                        onChange: (e)=>setRvState && setRvState(e.target.value),
                                        className: "border border-slate-300 rounded-lg px-3 py-2 text-sm bg-white min-w-[14rem]",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Select\u2026"
                                            }),
                                            (0, $cb0d223b5401e577$export$5c9ab6f574716f4e).map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: s.code,
                                                    children: s.name
                                                }, s.code))
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-4 space-y-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "rounded-lg border border-slate-200 border-l-4 border-l-blue-500 bg-slate-50 p-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center justify-between gap-2 mb-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm font-semibold text-gray-900",
                                                children: "Getting your money back when you leave"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: `text-[11px] font-semibold px-2 py-0.5 rounded-full whitespace-nowrap ${stateRules.buyback.hasStatutoryTimeframe ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'}`,
                                                children: stateRules.buyback.hasStatutoryTimeframe ? 'Statutory timeframe' : 'Contract-based'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-slate-700 leading-relaxed",
                                        children: stateRules.buyback.summary
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "rounded-lg border border-slate-200 border-l-4 border-l-slate-400 bg-slate-50 p-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "block text-sm font-semibold text-gray-900 mb-1",
                                        children: "Ongoing fees after you move out"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-slate-700 leading-relaxed",
                                        children: stateRules.recurrentChargesAfterVacating
                                    })
                                ]
                            }),
                            stateRules.note && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-xs text-slate-500 leading-relaxed",
                                children: stateRules.note
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-xs text-slate-500 mt-3 leading-relaxed",
                        children: [
                            stateRules.code ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "Governed by the ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: stateRules.act
                                    }),
                                    ". "
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: "Select your state above for the rules that apply to you. "
                            }),
                            "See ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: stateRules.regulatorUrl,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "text-blue-600 hover:underline",
                                children: stateRules.regulator
                            }),
                            ". Your village's ",
                            (stateRules.disclosureDocument || 'disclosure statement').toLowerCase(),
                            " and contract always govern."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-xs text-slate-500 mb-6",
                children: 'This tool is for illustration only. Get the village\'s disclosure statement and independent legal and financial advice. Consumer-protection rules differ by state and territory\u2014see "Rules where you live" above for the law and regulator that apply to you.'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                    onClick: onContinue,
                    variant: "brand",
                    size: "lg",
                    iconRight: (0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039),
                    children: backLabel || 'Continue to calculator'
                })
            })
        ]
    });
};
/** An empty contract: what step 1 opens on for a new model (growth 3% and half the capital gain are the starting estimates). */ const $7911ccd6eced4ff4$var$RV_FRESH_VILLAGE_INPUTS = {
    entryFee: 0,
    ongoingWeeklyOrMonthly: 0,
    ongoingFrequency: 'monthly',
    dmfPctPerYear: 0,
    dmfCapYears: 0,
    yearsResidency: 0,
    growthRatePct: 3,
    capitalGainShareToResident: 0.5,
    reinstatementCap: 0
};
/** The village and the step 3 answers a new model takes off the file, so nothing carries over. */ const $7911ccd6eced4ff4$var$RV_FRESH_GOAL_KEYS = [
    'rvVillageName',
    'rvHomeRoute',
    'rvRentPerWeek',
    'rvRentCosts',
    'rvVacancyWeeks',
    'rvEmergencyReserve',
    'rvResidualUses',
    'rvEntryDate'
];
const $7911ccd6eced4ff4$var$RetirementVillageAnalyser = ({ setActivePage: setActivePage, factFind: factFind, onBack: onBack, savedStrategies: savedStrategies, setSavedStrategies: setSavedStrategies, rvState: rvState, setFactFind: setFactFind, onSoaGenerated: onSoaGenerated })=>{
    /*
   * HOW THE MODULE OPENS (rebuild M2, 21 Oct 2026). With a plan chosen, on the plan page (RvHub). From Home's
   * "Start a new model", on an empty step 1 with step 3's questions asked again. From "Model another village
   * or unit", on step 1 with everything carried over. The session flags are read here and cleared in an
   * effect below, so a second render (StrictMode) reads the same answer.
   */ const [openedFresh] = (0, $acw62.useState)(()=>{
        try {
            return !!sessionStorage.getItem((0, $accc76cd2fa8edd9$export$1b00af1e78405459));
        } catch  {
            return false;
        }
    });
    const [anotherUnit, setAnotherUnit] = (0, $acw62.useState)(()=>{
        try {
            return !!sessionStorage.getItem((0, $accc76cd2fa8edd9$export$9770b2ddd15762ac));
        } catch  {
            return false;
        }
    });
    const [rvView, setRvView] = (0, $acw62.useState)(()=>!openedFresh && !anotherUnit && (0, $accc76cd2fa8edd9$export$d11c0ebb38aa6e79)(savedStrategies) ? 'hub' : 'steps');
    /** What the plan page asked for, done once the tested plans are back. */ const [pendingHubAction, setPendingHubAction] = (0, $acw62.useState)(null);
    // Unit growth 3%/yr is a conservative starting estimate the adviser can overwrite. Years in
    // village deliberately stays 0 ("not modelling an exit"): the projection engine CLAMPS a stay
    // longer than the projection window to its final year (resolveExitYear in the village plugin,
    // "preserved rather than endorsed") — a defaulted 10-year stay in a 5-year projection modelled
    // every resident LEAVING in year 5, entitlement and all, inflating every mover's legacy by ~the
    // exit entitlement and poisoning the suggestion-engine rankings. Until the clamp's semantics are
    // fixed engine-side, an exit is modelled only when the adviser explicitly enters a residency.
    // Opens on the contract last worked on — the chosen village plan's, else the newest saved one's
    // (village review, 18 Oct 2026: returning to the module reset every contract figure to $0).
    const [villageInputs, setVillageInputs] = (0, $acw62.useState)(()=>{
        const defaults = {
            ...$7911ccd6eced4ff4$var$RV_FRESH_VILLAGE_INPUTS
        };
        // On the file first (village rebuild, 21 Oct 2026: step 1's answers are goals.rv*), then the chosen plan's.
        if (openedFresh) return defaults;
        const fromGoals = $7911ccd6eced4ff4$var$villageInputsFromGoals(factFind);
        if (fromGoals) return {
            ...defaults,
            ...fromGoals
        };
        const plans = (savedStrategies || []).filter((s)=>s.type === 'retirement_village' && s.inputs?.villageInputs);
        const from = plans.find((s)=>s.chosen === true) ?? plans[plans.length - 1];
        const saved = from?.inputs?.villageInputs;
        return saved ? {
            ...defaults,
            ...saved
        } : defaults;
    });
    // Every change to the contract is written to the file, so it is saved by the autosave.
    (0, $acw62.useEffect)(()=>{
        if (!setFactFind) return;
        setFactFind((prev)=>({
                ...prev,
                goals: {
                    ...prev?.goals || {},
                    ...$7911ccd6eced4ff4$var$villageInputsToGoals(villageInputs)
                }
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        villageInputs
    ]);
    const [strategyName, setStrategyName] = (0, $acw62.useState)('');
    // '' until the user chooses — the mode choice is the FIRST act, matching the aged care and SAH
    // modules (owner-caught here too, 2026-08-25: Manual Control defaulting to on skipped the choice).
    // Restoring a saved strategy still lands in manual (see the restore handler).
    const [strategyMode, setStrategyMode] = (0, $acw62.useState)('');
    /*
   * THE THREE STEPS (owner, 24 Sep 2026: "replicate the UI and functionality as much as possible
   * as to what you did with the aged care suggestion engine"). 1: the village contract and the
   * move-in date. 2: where the client stands STAYING PUT — the one baseline. 3: the two ways to fund
   * the move, with the plan summary beside them. The strip is a map, not a gate.
   */ const [step, setStep] = (0, $acw62.useState)(1);
    const rvVoice = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const goToStep = (next)=>{
        // Step 3 opens on the plans we tested; Manual Control is "Build a plan yourself" from there.
        if (next === 3) setStrategyMode((m)=>m === '' ? 'optimised' : m);
        setStep(next);
        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
    };
    const [activeSavedStrategyId, setActiveSavedStrategyId] = (0, $acw62.useState)(null);
    const [showCompareModal, setShowCompareModal] = (0, $acw62.useState)(false);
    /** "Understanding your plan" — the full recap, opened from the plan summary. */ const [showRvExplanation, setShowRvExplanation] = (0, $acw62.useState)(false);
    const [showStrategyOptions, setShowStrategyOptions] = (0, $acw62.useState)(true);
    const [showOtherStrategies, setShowOtherStrategies] = (0, $acw62.useState)(false);
    const [otherStrategies, setOtherStrategies] = (0, $acw62.useState)({
        gifting: false,
        giftingAmount: 0,
        giftingSource: 'bankAccounts',
        funeralBonds: false,
        funeralBondAmount: 0,
        funeralBondSource: 'bankAccounts',
        annuity: false
    });
    const [annuityRecord, setAnnuityRecord] = (0, $acw62.useState)(null);
    const [rvOverallStrategy, setRvOverallStrategy] = (0, $acw62.useState)({
        rentHome: false,
        downsizeHome: false,
        sellInvestmentProperty: false
    });
    const [rvInvestmentPropertyDetails, setRvInvestmentPropertyDetails] = (0, $acw62.useState)(()=>{
        const first = factFind?.assets?.investmentProperty?.[0];
        const val = first?.value || 0;
        return {
            selectedPropertyId: first?.id ?? null,
            salePrice: val,
            sellingCosts: val * 0.025,
            costBase: first?.costBase ?? 0,
            entryFeeAllocation: 0,
            downsizerContribution: 0,
            partnerDownsizerContribution: 0,
            commenceIncomeStream: false,
            giftingAmount: 0,
            funeralBondPurchase: 0
        };
    });
    const [sellHomeDetails, setSellHomeDetails] = (0, $acw62.useState)({
        salePrice: $7911ccd6eced4ff4$var$n(factFind?.home?.value),
        sellingCosts: $7911ccd6eced4ff4$var$n(factFind?.home?.value) * 0.025,
        downsizerContribution: 0,
        partnerDownsizerContribution: 0,
        commenceIncomeStream: false,
        giftingAmount: 0,
        funeralBondPurchase: 0,
        purchaseAnnuity: 0,
        purchaseInvestmentProperty: 0,
        investmentPropertyRent: 0,
        investmentPropertyExpenses: 0,
        investmentPropertyState: rvState || '',
        investmentPropertyStampDuty: 0,
        purchaseShares: 0
    });
    const [rentDetails, setRentDetails] = (0, $acw62.useState)(()=>({
            rentAmount: $7911ccd6eced4ff4$var$n(factFind?.home?.likelyRent),
            rentExpenses: $7911ccd6eced4ff4$var$n(factFind?.home?.likelyExpenses),
            partnerRent: 0
        }));
    // Keep rent assumptions in sync with Client Profile (fact find) when user hasn't entered values yet
    (0, $acw62.useEffect)(()=>{
        if (!factFind?.home) return;
        const lr = $7911ccd6eced4ff4$var$n(factFind.home.likelyRent);
        const le = $7911ccd6eced4ff4$var$n(factFind.home.likelyExpenses);
        if ((lr > 0 || le > 0) && rentDetails.rentAmount === 0 && rentDetails.rentExpenses === 0) setRentDetails((prev)=>({
                ...prev,
                rentAmount: lr || 0,
                rentExpenses: le || 0
            }));
    }, [
        factFind?.home?.likelyRent,
        factFind?.home?.likelyExpenses,
        rentDetails.rentAmount,
        rentDetails.rentExpenses
    ]);
    const [entryFeeFunding, setEntryFeeFunding] = (0, $acw62.useState)({});
    const [entryFeeCgtOverrides, setEntryFeeCgtOverrides] = (0, $acw62.useState)({});
    // 10 years, the same as every module but aged care (owner, 19 Oct 2026: "10 years makes sense").
    const [localLegacyYears, setLocalLegacyYears] = (0, $acw62.useState)(10);
    // Suggestion Engine state (Task #3): computed off-thread-of-render so the loader paints first.
    const [seLoading, setSeLoading] = (0, $acw62.useState)(false);
    const [rvSuggestions, setRvSuggestions] = (0, $acw62.useState)(null);
    const [seDeepDive, setSeDeepDive] = (0, $acw62.useState)(null);
    // "What could go wrong" for one engine card (StrategyRisksPanel).
    const [riskStrategy, setRiskStrategy] = (0, $acw62.useState)(null);
    /**
   * The Statement of Advice for the selected engine strategy (owner, 2 Oct 2026). Built from the
   * figures already on screen (rvSoa.ts), opened and downloaded like aged care's, and handed to App
   * so it lands on the advice register with its document snapshot.
   */ const generateRvSoa = (strategy)=>{
        const snapshot = (0, $98fc2fd674f4d688$export$61954784371996c2)({
            strategy: strategy,
            all: rvSuggestions?.strategies || [],
            leaders: visibleSeCards.map((c)=>({
                    strategy: c.strategy,
                    badges: c.badges
                })),
            baseline: rvSuggestions?.stayHome ?? null,
            factFind: factFind,
            summary: summary,
            villageInputs: villageInputs,
            legacyYears: Number(localLegacyYears) || 5
        });
        (0, $482dbb064a59e381$export$bedc55c6dae3ee6a)(snapshot);
        onSoaGenerated?.({
            id: strategy.id,
            name: strategy.name,
            type: 'retirement_village',
            source: 'suggestion_engine',
            strategy: strategy,
            soaSnapshot: snapshot
        });
    };
    const [selectedSeId, setSelectedSeId] = (0, $acw62.useState)(null);
    /** The card whose "Explain this" is open — explaining a plan never selects it (review, 18 Oct 2026). */ const [explainSeId, setExplainSeId] = (0, $acw62.useState)(null); // selected SE strategy → drives the narrative + Financial Impact panels
    /*
   * THE STRATEGY ANALYSIS SETUP (owner, 24 Sep 2026). Opens once per visit when the Suggestion
   * Engine is chosen, and again from "Adjust setup". Its answers are saved on the client record
   * (goals.rvPurchaseState / rvAnnuityShareCapPct / rvCashflowTarget), so a returning adviser sees
   * their own choices rather than the defaults. While it is open the engine waits: one run on the
   * answers, not a run on the defaults and then another.
   */ const [rvSetup, setRvSetup] = (0, $acw62.useState)(()=>(0, $6d7411748a56fc80$export$65f94a7151daf91a)(factFind, rvState));
    const [rvSetupOpen, setRvSetupOpen] = (0, $acw62.useState)(false);
    // Step 3 asks its questions before the first run, and again from "Things that change the answer" (village rebuild, 21 Oct 2026).
    const [rvAsking, setRvAsking] = (0, $acw62.useState)(()=>openedFresh || factFind?.goals?.rvHomeRoute == null);
    // A fresh model: the flags cleared, and the village and the answers taken off the file so nothing carries over.
    (0, $acw62.useEffect)(()=>{
        try {
            sessionStorage.removeItem((0, $accc76cd2fa8edd9$export$1b00af1e78405459));
            sessionStorage.removeItem((0, $accc76cd2fa8edd9$export$9770b2ddd15762ac));
        } catch  {}
        if (openedFresh && setFactFind) setFactFind((prev)=>{
            const g = {
                ...prev?.goals || {}
            };
            for (const k of $7911ccd6eced4ff4$var$RV_FRESH_GOAL_KEYS)delete g[k];
            return {
                ...prev,
                goals: g
            };
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Answered before, on this file: don't ask again on every visit (review, 18 Oct 2026). "Adjust setup" still opens it.
    const [rvSetupSeen, setRvSetupSeen] = (0, $acw62.useState)(()=>factFind?.goals?.rvAnnuityAppetite != null);
    const rvNetFreedAfterEntry = (0, $acw62.useMemo)(()=>{
        const homeValue = $7911ccd6eced4ff4$var$n(factFind?.home?.value);
        if (!(homeValue > 0)) return 0;
        return Math.max(0, homeValue - Math.round(homeValue * 0.025) - ($7911ccd6eced4ff4$var$n(villageInputs.entryFee) || 0));
    }, [
        factFind?.home?.value,
        villageInputs.entryFee
    ]);
    // Entry fee funding: only sell IP or sell/downsize home use property; otherwise liquid (including when renting the home for cashflow).
    const fundFrom = rvOverallStrategy.sellInvestmentProperty ? 'investment_property' : rvOverallStrategy.downsizeHome ? 'sell_home' : 'liquid';
    const EMERGENCY_RESERVE = (0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind); // 6 months of living expenses
    /** The money kept for emergencies: step 3's answer, else the suggestion (the greater of six months' costs and $50,000). */ const rvReserve = Number.isFinite(Number(factFind?.goals?.rvEmergencyReserve)) && factFind?.goals?.rvEmergencyReserve != null ? Number((factFind?.goals).rvEmergencyReserve) : EMERGENCY_RESERVE;
    /*
   * WHAT THE PROPERTY PAYS, AND WHAT SAVINGS MUST (owner-caught, 24 Sep 2026). On the sell-a-property
   * routes the shortfall was only ever computed for the savings route, so an $800,000 contribution
   * against $651,966 of net proceeds read "paid in full" and offered nowhere to allocate the other
   * $148,034. The property's share is what its sale nets, capped at the contribution; the rest is
   * the target the savings allocator below is asked for, and what the engine tops up in the same
   * order (shared topUpEntryFeeFromLiquid).
   */ const propertyTowardEntry = (0, $acw62.useMemo)(()=>{
        const entryFee = villageInputs.entryFee;
        if (!(entryFee > 0)) return 0;
        if (fundFrom === 'investment_property') {
            const list = factFind?.assets?.investmentProperty || [];
            const ip = list.find((p)=>String(p.id) === String(rvInvestmentPropertyDetails.selectedPropertyId)) || list[0];
            if (!ip) return 0;
            const { netProceeds: netProceeds } = (0, $d6349ba6b2bbee8e$export$8e7496bf07ef5a98)(factFind, ip, $7911ccd6eced4ff4$var$n(ip.value));
            return Math.min(entryFee, Math.max(0, $7911ccd6eced4ff4$var$n(rvInvestmentPropertyDetails.entryFeeAllocation)), netProceeds);
        }
        if (fundFrom === 'sell_home') return Math.min(entryFee, Math.max(0, $7911ccd6eced4ff4$var$n(sellHomeDetails.salePrice) - $7911ccd6eced4ff4$var$n(sellHomeDetails.sellingCosts)));
        return 0;
    }, [
        fundFrom,
        villageInputs.entryFee,
        factFind,
        rvInvestmentPropertyDetails.selectedPropertyId,
        rvInvestmentPropertyDetails.entryFeeAllocation,
        sellHomeDetails.salePrice,
        sellHomeDetails.sellingCosts
    ]);
    /** What the savings allocator is asked for: the whole contribution, or what the sale leaves. */ const liquidTargetForEntryFee = fundFrom === 'liquid' ? villageInputs.entryFee : Math.max(0, villageInputs.entryFee - propertyTowardEntry);
    const defaultEntryFeeAllocation = (0, $acw62.useMemo)(()=>{
        const entryFee = liquidTargetForEntryFee;
        if (entryFee <= 0 || !factFind?.assets) return {};
        const order = [
            'bankAccounts',
            'termDeposits',
            'accountBasedPensions',
            'shares'
        ];
        let remaining = entryFee;
        const out = {};
        order.forEach((type)=>{
            if (remaining <= 0 || !factFind.assets[type]) return;
            if (type === 'bankAccounts') {
                const bankAccounts = factFind.assets.bankAccounts || [];
                const totalBank = bankAccounts.reduce((s, a)=>s + $7911ccd6eced4ff4$var$n(a.value), 0);
                const availableFromBank = Math.max(0, totalBank - EMERGENCY_RESERVE);
                let takenFromBank = 0;
                bankAccounts.forEach((asset)=>{
                    if (remaining <= 0 || takenFromBank >= availableFromBank) return;
                    const assetId = `bankAccounts-${asset.id}`;
                    const val = $7911ccd6eced4ff4$var$n(asset.value);
                    const canTake = Math.min(val, remaining, availableFromBank - takenFromBank);
                    if (canTake > 0) {
                        out[assetId] = canTake;
                        remaining -= canTake;
                        takenFromBank += canTake;
                    }
                });
                return;
            }
            (factFind.assets[type] || []).forEach((asset)=>{
                if (remaining <= 0) return;
                const assetId = `${type}-${asset.id}`;
                const val = $7911ccd6eced4ff4$var$n(asset.value);
                const take = Math.min(val, remaining);
                if (take > 0) {
                    out[assetId] = take;
                    remaining -= take;
                }
            });
        });
        /*
     * NO PARTIAL PRE-FILL WHEN SAVINGS CANNOT COVER IT (owner, 2026-09-01).
     *
     * `remaining > 0` here means the draw order ran out of liquid assets before it reached the entry
     * contribution — the savings genuinely cannot fund this move. Handing back the partial
     * allocation anyway put every slider at maximum, drew down the account-based pension by default,
     * and then told the client on screen that none of it would work and the real decision was
     * elsewhere. They had to read a wall of reasoning about a plan the tool already knew was
     * impossible, and then undo it.
     *
     * A village contribution has to be paid in full, so a partial allocation is not a partial plan —
     * it is no plan. Returning nothing leaves the sliders at zero and lets the screen lead with the
     * routes that CAN fund it (selling or renting the home, selling an investment property), which
     * is where the decision actually is.
     */ if (remaining > 0) return {};
        /*
     * GROSS UP FOR THE TAX ON A SALE (village review, 18 Oct 2026: the default left $1,200 of the entry
     * payment unfunded, because shares sold at the entry amount raise that amount LESS the capital gains
     * tax on them). Sell a little more of the same holdings until what reaches the village covers it, or
     * the holdings run out — in which case the shortfall line says so, as before.
     */ for(let pass = 0; pass < 6; pass++){
            const net = (0, $d6349ba6b2bbee8e$export$d5119f51b5211c8b)(factFind, out, {}).netTotal;
            const gap = entryFee - net;
            if (gap < 1) break;
            let topUp = gap;
            for (const type of [
                'shares',
                'accountBasedPensions',
                'termDeposits'
            ])(factFind.assets[type] || []).forEach((asset)=>{
                if (topUp <= 0) return;
                const assetId = `${type}-${asset.id}`;
                const room = $7911ccd6eced4ff4$var$n(asset.value) - (out[assetId] || 0);
                const add = Math.min(room, topUp);
                if (add > 0) {
                    out[assetId] = (out[assetId] || 0) + add;
                    topUp -= add;
                }
            });
            if (topUp >= gap) break; // nothing left to sell
        }
        return out;
    }, [
        liquidTargetForEntryFee,
        factFind?.assets
    ]);
    // Resolved by the SAME function the allocator card renders from: the user's figure for any asset
    // they have touched, the default for every asset they have not. Previously this took the user's
    // map wholesale once it had any key at all, so dragging one slider dropped the other assets'
    // defaults from the map handed to the ENGINE while the card still showed them — the projections
    // modelled a fraction of the entry fee the client could see was fully funded.
    const effectiveEntryFeeFunding = (0, $acw62.useMemo)(()=>(0, $056bec631a0e8ebc$export$f609a2216aa879e7)(factFind, entryFeeFunding, defaultEntryFeeAllocation), [
        factFind,
        entryFeeFunding,
        defaultEntryFeeAllocation
    ]);
    const totalTowardEntryFee = (0, $acw62.useMemo)(()=>(0, $d6349ba6b2bbee8e$export$d5119f51b5211c8b)(factFind, effectiveEntryFeeFunding, entryFeeCgtOverrides).netTotal, [
        effectiveEntryFeeFunding,
        entryFeeCgtOverrides,
        factFind
    ]);
    const entryFeeAmount = villageInputs.entryFee;
    // On every route: what neither the sale nor the allocated savings cover.
    const entryFeeShortfall = liquidTargetForEntryFee > 0 ? Math.max(0, liquidTargetForEntryFee - totalTowardEntryFee) : 0;
    /*
   * KEEPING THE HOME, SAVINGS PUT TO WORK (rebuild, 21 Oct 2026): the ledger's guaranteed income, property and
   * investing, when the home is kept, are bought from savings — after the entry payment, in the usual order,
   * keeping the emergency money back. The engine draws exactly these accounts (applyRvSavingsDeployment).
   */ const savingsDeployment = (0, $acw62.useMemo)(()=>{
        if (fundFrom !== 'liquid') return null;
        const d = sellHomeDetails;
        const ip = $7911ccd6eced4ff4$var$n(d.purchaseInvestmentProperty);
        const dep = {
            shares: $7911ccd6eced4ff4$var$n(d.purchaseShares),
            investmentProperty: ip,
            ipStampDuty: ip > 0 ? $7911ccd6eced4ff4$var$n(d.investmentPropertyStampDuty) : 0,
            ipRent: ip > 0 ? $7911ccd6eced4ff4$var$n(d.investmentPropertyRent) : 0,
            ipExpenses: ip > 0 ? $7911ccd6eced4ff4$var$n(d.investmentPropertyExpenses) : 0,
            ...d.investmentPropertyOwner ? {
                ipOwnership: d.investmentPropertyOwner
            } : {},
            annuity: $7911ccd6eced4ff4$var$n(d.purchaseAnnuity),
            annuityType: d.rvAnnuityType === 'fixedTerm' ? 'fixedTerm' : d.rvAnnuityType === 'guaranteed' ? 'guaranteed' : 'lifetime',
            annuityResidualPercent: $7911ccd6eced4ff4$var$n(d.rvAnnuityResidualPercent),
            annuityIndexation: !!d.rvAnnuityIndexation,
            annuityReversionary: !!d.rvAnnuityReversionary,
            ...d.rvAnnuityOwner ? {
                annuityOwner: d.rvAnnuityOwner
            } : {},
            ...d.rvAnnuityIncomeOverride != null ? {
                annuityIncomeOverride: $7911ccd6eced4ff4$var$n(d.rvAnnuityIncomeOverride)
            } : {}
        };
        return dep.shares + dep.investmentProperty + dep.annuity > 0 ? dep : null;
    }, [
        fundFrom,
        sellHomeDetails
    ]);
    const savingsIpLoan = fundFrom === 'liquid' && $7911ccd6eced4ff4$var$n(sellHomeDetails.purchaseInvestmentProperty) > 0 && $7911ccd6eced4ff4$var$n(sellHomeDetails.ipLoanAmount) > 0 ? {
        amount: $7911ccd6eced4ff4$var$n(sellHomeDetails.ipLoanAmount),
        rate: $7911ccd6eced4ff4$var$n(sellHomeDetails.ipLoanRate),
        termYears: $7911ccd6eced4ff4$var$n(sellHomeDetails.ipLoanTermYears)
    } : null;
    /** Which accounts pay for it: after the entry payment's draw, bank above the emergency money, then term deposits, pensions, shares. */ const savingsDeploymentFunding = (0, $acw62.useMemo)(()=>{
        if (!savingsDeployment) return {};
        let left = savingsDeployment.shares + savingsDeployment.investmentProperty + savingsDeployment.ipStampDuty + savingsDeployment.annuity - (savingsIpLoan?.amount ?? 0);
        const out = {};
        const assets = factFind?.assets || {};
        const bankTotal = (assets.bankAccounts || []).reduce((t, a)=>t + $7911ccd6eced4ff4$var$n(a.value), 0);
        let bankRoom = Math.max(0, bankTotal - rvReserve - (assets.bankAccounts || []).reduce((t, a)=>t + $7911ccd6eced4ff4$var$n(effectiveEntryFeeFunding[`bankAccounts-${a.id}`]), 0));
        for (const kind of [
            'bankAccounts',
            'termDeposits',
            'accountBasedPensions',
            'shares'
        ])for (const a of assets[kind] || []){
            if (left <= 0) break;
            const key = `${kind}-${a.id}`;
            let room = Math.max(0, $7911ccd6eced4ff4$var$n(a.value) - $7911ccd6eced4ff4$var$n(effectiveEntryFeeFunding[key]));
            if (kind === 'bankAccounts') {
                room = Math.min(room, bankRoom);
                bankRoom -= room;
            }
            const take = Math.min(room, left);
            if (take > 0) {
                out[key] = take;
                left -= take;
            }
        }
        return out;
    }, [
        savingsDeployment,
        savingsIpLoan?.amount,
        factFind?.assets,
        rvReserve,
        effectiveEntryFeeFunding
    ]);
    const rvCoreStrategy = (0, $acw62.useMemo)(()=>({
            ...savingsDeployment ? {
                savingsDeployment: savingsDeployment,
                savingsDeploymentFunding: savingsDeploymentFunding,
                ...savingsIpLoan ? {
                    savingsIpLoan: savingsIpLoan
                } : {}
            } : {},
            fundFrom: fundFrom,
            rentHome: rvOverallStrategy.rentHome,
            sellHomeDetails: fundFrom === 'sell_home' ? sellHomeDetails : undefined,
            rentDetails: rvOverallStrategy.rentHome ? rentDetails : undefined,
            // On every route — on a property route this is the remainder the sale did not cover.
            entryFeeFunding: effectiveEntryFeeFunding,
            entryFeeCgtOverrides: entryFeeCgtOverrides,
            investmentPropertyDetails: fundFrom === 'investment_property' ? rvInvestmentPropertyDetails : undefined
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        fundFrom,
        rvOverallStrategy.rentHome,
        sellHomeDetails,
        rentDetails,
        effectiveEntryFeeFunding,
        entryFeeCgtOverrides,
        rvInvestmentPropertyDetails,
        savingsDeployment,
        savingsDeploymentFunding
    ]);
    const liquidFactFindAfterVillage = (0, $acw62.useMemo)(()=>(0, $d6349ba6b2bbee8e$export$51ca4b84e58af4b9)(factFind, rvCoreStrategy, villageInputs).factFind, [
        factFind,
        rvCoreStrategy,
        villageInputs
    ]);
    /**
   * The shared debt strategy — see the Aged Care module. Handed to the ENGINE via the strategy
   * options rather than applied here: the village projections' own year-1 financials are what feed
   * this page's after-position and impact panel, so the one wiring point keeps the projections, the
   * panel and the legacy estimate agreeing about whether the debt exists. The engine performs the
   * payoff at the projection's start — a lender takes the money any day.
   */ /**
   * When the client moves into the village, blank = model it from today. A case fact, asked with the
   * village costs and threaded to the manual projection AND every Suggestion Engine candidate — the
   * two modes must never model the same move on different timing.
   */ const [villageEntryDate, setVillageEntryDateState] = (0, $acw62.useState)(()=>String(factFind?.goals?.rvEntryDate || ''));
    const setVillageEntryDate = (value)=>{
        setVillageEntryDateState(value);
        setFactFind?.((prev)=>({
                ...prev,
                goals: {
                    ...prev?.goals || {},
                    rvEntryDate: value
                }
            }));
    };
    const villageEntryDateInPast = villageEntryDate !== '' && villageEntryDate < new Date().toISOString().slice(0, 10);
    const effectiveVillageEntryDate = villageEntryDateInPast ? '' : villageEntryDate;
    const [debtPayments, setDebtPayments] = (0, $acw62.useState)({});
    const [debtFunding, setDebtFunding] = (0, $acw62.useState)({});
    const [debtRepaymentBasis, setDebtRepaymentBasis] = (0, $acw62.useState)('keep_repayment');
    const debtPayoffPlan = (0, $acw62.useMemo)(()=>{
        const payments = Object.fromEntries(Object.entries(debtPayments).filter(([, amount])=>(Number(amount) || 0) > 0));
        if (Object.keys(payments).length === 0) return null;
        const funding = Object.fromEntries(Object.entries(debtFunding).filter(([, amount])=>(Number(amount) || 0) > 0));
        return {
            payments: payments,
            funding: funding,
            repaymentBasis: debtRepaymentBasis
        };
    }, [
        debtPayments,
        debtFunding,
        debtRepaymentBasis
    ]);
    const rvStrategyOptions = (0, $acw62.useMemo)(()=>{
        const hasOther = otherStrategies.gifting || otherStrategies.funeralBonds || otherStrategies.annuity;
        return {
            inflationAssumptionPct: (0, $1abe73eeef086faf$export$e51ae1118d375fce),
            otherStrategies: hasOther ? otherStrategies : undefined,
            retirementVillage: {
                ...rvCoreStrategy,
                otherStrategies: hasOther ? otherStrategies : undefined,
                annuityRecord: otherStrategies.annuity ? annuityRecord : null
            },
            ...debtPayoffPlan ? {
                debtPayoff: debtPayoffPlan
            } : {},
            ...effectiveVillageEntryDate ? {
                villageEntryDate: effectiveVillageEntryDate
            } : {}
        };
    }, [
        rvCoreStrategy,
        otherStrategies,
        annuityRecord,
        debtPayoffPlan,
        effectiveVillageEntryDate
    ]);
    const summary = (0, $acw62.useMemo)(()=>(0, $d6349ba6b2bbee8e$export$15cb494f5ce70974)(villageInputs), [
        villageInputs
    ]);
    /** The hand-built plan's figures are still being worked out (utils/calcTracker.ts, 25 Oct 2026). */ const { track: trackRv, working: rvCalcWorking } = (0, $a8ad6b8c257d1221$export$66e981b52ef0ad9f)();
    const [projections, setProjections] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        // The payout choice rides with the village inputs (the server builds the moved balance sheet from them).
        trackRv($55a1d8a64f1e5dfa$export$e5422a7f4e7fbdd0(factFind, rvStrategyOptions, {
            ...villageInputs,
            oldUnitPaysAtMove: rvSetup.oldUnitPaysAtMove !== false
        }, localLegacyYears)).then((proj)=>{
            if (!cancelled) setProjections(proj);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind,
        rvStrategyOptions,
        villageInputs,
        localLegacyYears,
        rvSetup.oldUnitPaysAtMove
    ]);
    const [legacyEstimate, setLegacyEstimate] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (async ()=>{
            if (projections.length === 0) {
                setLegacyEstimate(0);
                return;
            }
            const lastRow = projections[localLegacyYears - 1];
            if (lastRow?.netWorth != null) {
                setLegacyEstimate((0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(lastRow));
                return;
            }
            if (lastRow?.factFind) {
                const fin = await $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(lastRow.factFind);
                if (!cancelled) setLegacyEstimate(fin.netWorth);
                return;
            }
            setLegacyEstimate(0);
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        projections,
        localLegacyYears
    ]);
    const [initialFinancials, setInitialFinancials] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind).then((r)=>{
            if (!cancelled) setInitialFinancials(r);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind
    ]);
    const simulatedFinancialsRaw = projections.length > 0 ? projections[0].financials : null;
    /**
   * With a dated entry, year 1 of the projection is the PRE-entry year — the client still at home —
   * so the impact panel's "after" must come from the plan-in-place position instead (the moved
   * fact-find, assessed normally). Undated, this is exactly the year-1 financials it always was.
   */ const [villageAfterFinancials, setVillageAfterFinancials] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!effectiveVillageEntryDate) {
            setVillageAfterFinancials(null);
            return undefined;
        }
        let cancelled = false;
        // Assessed WITH the move's means-test options (rent-the-home income, kept-home assessability) —
        // the same shared mapping the server's projection run applies, so the plan-in-place position and
        // the projections can never disagree about what the move does to the tests.
        const meansOptions = (0, $d6349ba6b2bbee8e$export$be9042bee889487b)(rvCoreStrategy, villageInputs, liquidFactFindAfterVillage);
        trackRv($55a1d8a64f1e5dfa$export$463f0620dd36e1f8(liquidFactFindAfterVillage, meansOptions)).then((r)=>{
            if (!cancelled) setVillageAfterFinancials(r);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        effectiveVillageEntryDate,
        liquidFactFindAfterVillage,
        rvCoreStrategy,
        villageInputs
    ]);
    const simulatedFinancials = effectiveVillageEntryDate ? villageAfterFinancials ?? simulatedFinancialsRaw : simulatedFinancialsRaw;
    const [showProjectionsModal, setShowProjectionsModal] = (0, $acw62.useState)(false);
    /** What "See the projections" opens: the plan, or staying put (step 2 and the rail before a plan is named). */ const [projectionsSource, setProjectionsSource] = (0, $acw62.useState)('plan');
    /*
   * THE FINANCIAL-YEAR / CALENDAR-YEAR TOGGLE (owner, 23 Sep 2026: missing here, present in Aged
   * Care). It is not a display filter — the engine PROJECTS the year it REPORTS, so the rows have to
   * be cut again. That second run is what the shared modal gates the toggle on, which is why passing
   * `onPeriodModeChange` is the whole of the change. Fetched only while the modal is open, so a
   * remembered 'calendar_year' does not fire a second run on every page load, and the mode is the
   * modal's own sticky preference, shared with Aged Care.
   */ const [modalPeriodMode, setModalPeriodMode] = (0, $acw62.useState)((0, $4f50ab660c01dd64$export$1e222c2c280e2a28));
    const [calendarYearProjections, setCalendarYearProjections] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (modalPeriodMode !== 'calendar_year') {
            setCalendarYearProjections(null);
            return undefined;
        }
        if (!showProjectionsModal) return undefined;
        let cancelled = false;
        // Cleared first so a changed input re-shows the hourglass rather than leaving the previous run's
        // rows on screen as though they were current.
        setCalendarYearProjections(null);
        $55a1d8a64f1e5dfa$export$e5422a7f4e7fbdd0(factFind, {
            ...rvStrategyOptions,
            projectionPeriodMode: 'calendar_year'
        }, villageInputs, localLegacyYears).then((proj)=>{
            if (!cancelled) setCalendarYearProjections(proj);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        showProjectionsModal,
        modalPeriodMode,
        factFind,
        rvStrategyOptions,
        villageInputs,
        localLegacyYears
    ]);
    /** First row unchanged; adds fyFullYearView for dual-world FY blend (financial_year mode only). */ const [projectionsForModal, setProjectionsForModal] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        if (!projections?.length) {
            setProjectionsForModal(projections);
            return undefined;
        }
        const mode = rvStrategyOptions.projectionPeriodMode ?? 'financial_year';
        if (mode === 'strategy_year') {
            setProjectionsForModal(projections);
            return undefined;
        }
        let cancelled = false;
        $55a1d8a64f1e5dfa$export$7c78bf5386f0643f({
            baselineFactFind: factFind,
            strategyOptionsStrategy: rvStrategyOptions,
            villageInputsStrategy: villageInputs,
            strategyYearOneProjection: projections[0],
            initialFinancials: initialFinancials,
            currentFinancials: simulatedFinancials,
            options: {}
        }).then((fyView)=>{
            if (!cancelled) setProjectionsForModal(projections.map((row, i)=>i === 0 ? {
                    ...row,
                    fyFullYearView: fyView
                } : row));
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        projections,
        rvStrategyOptions,
        villageInputs,
        factFind,
        initialFinancials,
        simulatedFinancials
    ]);
    const noVillageScenario = summary.entryFee === 0 && summary.annualOngoing === 0;
    const investmentPropertySaleSummary = (0, $acw62.useMemo)(()=>{
        if (fundFrom !== 'investment_property' || !rvInvestmentPropertyDetails || !factFind?.assets?.investmentProperty?.length) return null;
        const ip = factFind.assets.investmentProperty.find((p)=>String(p.id) === String(rvInvestmentPropertyDetails.selectedPropertyId)) || factFind.assets.investmentProperty[0];
        if (!ip) return null;
        const fullValue = $7911ccd6eced4ff4$var$n(ip.value);
        const { netProceeds: netProceeds, cgt: cgt } = (0, $d6349ba6b2bbee8e$export$8e7496bf07ef5a98)(factFind, ip, fullValue);
        return {
            netProceeds: netProceeds,
            estimatedCGT: cgt
        };
    }, [
        fundFrom,
        rvInvestmentPropertyDetails,
        factFind
    ]);
    const totalEntryFeeCgtFromLiquidIp = (0, $acw62.useMemo)(()=>{
        if (fundFrom !== 'liquid' || !effectiveEntryFeeFunding || !factFind?.assets?.investmentProperty) return 0;
        let total = 0;
        Object.entries(effectiveEntryFeeFunding).forEach(([assetId, amount])=>{
            if (!assetId.startsWith('investmentProperty-') || !$7911ccd6eced4ff4$var$n(amount)) return;
            const idRaw = assetId.replace(/^investmentProperty-/, '');
            const asset = factFind.assets.investmentProperty.find((a)=>String(a.id) === idRaw);
            if (asset) total += (0, $d6349ba6b2bbee8e$export$8e7496bf07ef5a98)(factFind, asset, Math.min($7911ccd6eced4ff4$var$n(amount), $7911ccd6eced4ff4$var$n(asset.value))).cgt;
        });
        return total;
    }, [
        fundFrom,
        effectiveEntryFeeFunding,
        factFind
    ]);
    const entryFeeCgtForModal = (investmentPropertySaleSummary?.estimatedCGT ?? 0) + (totalEntryFeeCgtFromLiquidIp ?? 0);
    const [rvImpactBreakdowns, setRvImpactBreakdowns] = (0, $acw62.useState)({
        agePension: [],
        cashFlow: [],
        netWorth: [],
        legacy: []
    });
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (async ()=>{
            const fmt = (v)=>v == null || v === '' || isNaN(Number(v)) ? '$0' : '$' + Number(v).toLocaleString('en-AU', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                });
            const y0 = projections[0];
            const lastProj = projections[localLegacyYears - 1];
            const agePension = y0?.financials?.socialSecurityBreakdown && Array.isArray(y0.financials.socialSecurityBreakdown) && y0.financials.socialSecurityBreakdown.length > 0 ? y0.financials.socialSecurityBreakdown : initialFinancials?.socialSecurityBreakdown && Array.isArray(initialFinancials.socialSecurityBreakdown) ? initialFinancials.socialSecurityBreakdown : [
                {
                    label: 'Age Pension (p.a.)',
                    value: fmt(y0?.financials?.socialSecurity ?? initialFinancials?.socialSecurity)
                }
            ];
            const ipCgt = (investmentPropertySaleSummary?.estimatedCGT ?? 0) + (totalEntryFeeCgtFromLiquidIp ?? 0);
            // CGT is NOT a cashflow item. Under Option A (net proceeds pool) it is deducted from the sale
            // proceeds before they are allocated, so it reduces net worth at settlement and never reaches
            // `netCashflow`. It used to be emitted as a "Less:" row ABOVE the total, which made the rows
            // fail to reconcile against the stated net cashflow and read as though cashflow bore the tax.
            // It now sits below the total, as reference only.
            const cashFlow = y0?.financials?.cashFlowBreakdown && Array.isArray(y0.financials.cashFlowBreakdown) ? [
                ...y0.financials.cashFlowBreakdown,
                ...summary.annualOngoing > 0 ? [
                    {
                        label: '--- Village costs ---',
                        value: ''
                    },
                    {
                        label: 'Less: Village ongoing fees (p.a.)',
                        value: -summary.annualOngoing
                    }
                ] : [],
                {
                    label: '--- Net cashflow (Year 1) ---',
                    value: ''
                },
                {
                    label: 'Net cashflow',
                    value: y0?.netCashflow ?? 0
                },
                ...ipCgt > 0 ? [
                    {
                        label: '--- Not in cashflow ---',
                        value: ''
                    },
                    {
                        label: 'CGT on investment property sale (paid from sale proceeds)',
                        value: fmt(ipCgt)
                    }
                ] : []
            ] : [
                {
                    label: 'Net cashflow (Year 1)',
                    value: fmt(y0?.netCashflow)
                }
            ];
            const netWorthFromAssets = (formDataOrAssets)=>{
                const assets = formDataOrAssets?.assets || formDataOrAssets;
                if (!assets) return [];
                const types = [
                    'bankAccounts',
                    'termDeposits',
                    'shares',
                    'accountBasedPensions'
                ];
                const out = [];
                types.forEach((t)=>{
                    const arr = assets[t] || [];
                    if (t === 'bankAccounts' && arr.some((a)=>a.id === 'rv-sell-residual')) {
                        const residualEntry = arr.find((a)=>a.id === 'rv-sell-residual');
                        const residualVal = $7911ccd6eced4ff4$var$n(residualEntry?.value);
                        const otherBank = arr.filter((a)=>a.id !== 'rv-sell-residual').reduce((s, a)=>s + $7911ccd6eced4ff4$var$n(a.value), 0);
                        if (otherBank > 0) out.push({
                            label: 'Bank accounts',
                            value: fmt(otherBank)
                        });
                        if (residualVal > 0) out.push({
                            label: 'Residual from home sale (to bank)',
                            value: fmt(residualVal)
                        });
                    } else {
                        const sum = arr.reduce((s, a)=>s + $7911ccd6eced4ff4$var$n(a.value), 0);
                        if (sum > 0) out.push({
                            label: t === 'bankAccounts' ? 'Bank accounts' : t === 'termDeposits' ? 'Term deposits' : t === 'accountBasedPensions' ? 'Account-based pensions' : 'Shares',
                            value: fmt(sum)
                        });
                    }
                });
                const total = out.reduce((s, o)=>s + (typeof o.value === 'number' ? o.value : parseFloat(String(o.value).replace(/[$,]/g, '')) || 0), 0);
                if (out.length) out.push({
                    label: '--- Total (liquid) ---',
                    value: ''
                }, {
                    label: 'Total',
                    value: fmt(total)
                });
                return out;
            };
            const netWorth = y0?.factFind ? netWorthFromAssets(y0.factFind) : netWorthFromAssets(factFind);
            const legacyAssets = lastProj?.factFind?.assets;
            const legacyBreakdown = legacyAssets ? [
                ...netWorthFromAssets(lastProj.factFind),
                ...(lastProj?.exitProceeds ?? 0) > 0 ? [
                    {
                        label: '--- Village exit ---',
                        value: ''
                    },
                    {
                        label: 'Exit entitlement received',
                        value: fmt(lastProj.exitProceeds)
                    }
                ] : []
            ] : [
                {
                    label: 'Legacy estimate',
                    value: fmt(legacyEstimate)
                }
            ];
            let netWorthFinal = netWorth;
            if (!netWorth.length) {
                const fallbackNetWorth = y0?.factFind ? (await $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(y0.factFind)).netWorth : initialFinancials?.netWorth;
                netWorthFinal = [
                    {
                        label: 'Net Worth (Year 1)',
                        value: fmt(fallbackNetWorth)
                    }
                ];
            }
            if (!cancelled) setRvImpactBreakdowns({
                agePension: agePension,
                cashFlow: cashFlow,
                netWorth: netWorthFinal,
                legacy: legacyBreakdown
            });
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        projections,
        summary.entryFee,
        summary.annualOngoing,
        localLegacyYears,
        initialFinancials,
        factFind,
        legacyEstimate,
        investmentPropertySaleSummary,
        totalEntryFeeCgtFromLiquidIp
    ]);
    const legacyEstimateDisplay = legacyEstimate;
    const [netWorthAfterDisplay, setNetWorthAfterDisplay] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        // The engine's own rows now carry the accrued exit entitlement in net worth (the village plugin
        // values the contract each resident-year — the refundable-RAD principle), so this reads the
        // engine's figure directly. The old path recomputed net worth from the raw fact-find (which
        // cannot know about the contract) and added a capped entitlement back on — a UI-side patch that
        // would now double count.
        if (noVillageScenario) {
            setNetWorthAfterDisplay(initialFinancials?.netWorth);
            return;
        }
        /*
     * The tile says "TODAY", so it must show the position the day the plan is done — not year 1's
     * CLOSING figure, which is what it used to read (owner-caught, 2026-08-26: "I'm not clear how
     * the net worth has gone up from $2,365,000 to $2,369,997 given we started with the same money
     * and have incurred selling costs of $50k"). It had gone up because a full year of investment
     * growth was folded into a number labelled "today", masking the immediate cost of the move.
     *
     * `openingNetWorth` is that day-one position — the moved balance sheet including the refundable
     * entry contribution — so the tile now shows the real immediate effect. On the owner's scenario
     * that is $2,365,000 -> $2,315,000: down by the selling costs, and nothing else, because paying
     * an entry contribution is an asset swap rather than a loss.
     */ const dayOne = projections[0]?.openingNetWorth;
        setNetWorthAfterDisplay(typeof dayOne === 'number' ? dayOne : initialFinancials?.netWorth);
    }, [
        noVillageScenario,
        projections,
        initialFinancials
    ]);
    /**
   * The STAY-PUT estate — what this client would be worth at the horizon if they did nothing.
   *
   * Owner-caught (2026-08-26): the plan summary compared the projected estate against TODAY'S net
   * worth, while the Suggestion Engine compares it against the stay-put projection. Those are not
   * the same benchmark and they can disagree about the direction: a plan can leave more than the
   * client is worth today (five years of growth will do that on its own) while leaving materially
   * LESS than simply staying home would have. Measuring the move against today's wealth credits the
   * move with growth it did not cause, which is exactly the wrong way for a comparison to be wrong.
   *
   * One projection, the same call the engine's own baseline candidate makes: the village zeroed out.
   */ /*
   * Kept WHOLE, not just its last row (24 Sep 2026): the stay-put projection is now the position
   * step 2 shows, the runway the rail carries until a plan is chosen, and what "See the projections"
   * opens in that state — one run, read everywhere staying put is quoted. Independent of the village
   * inputs: the village is zeroed out of it by definition.
   */ const [stayPutProjections, setStayPutProjections] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        trackRv($55a1d8a64f1e5dfa$export$e5422a7f4e7fbdd0(factFind, {
            inflationAssumptionPct: (0, $1abe73eeef086faf$export$e51ae1118d375fce),
            retirementVillage: {}
        }, {
            entryFee: 0,
            ongoingWeeklyOrMonthly: 0,
            ongoingFrequency: 'monthly',
            dmfPctPerYear: 0,
            dmfCapYears: 0,
            yearsResidency: 0,
            growthRatePct: 0,
            capitalGainShareToResident: 0.5,
            reinstatementCap: 0
        }, localLegacyYears)).then((rows)=>{
            if (!cancelled) setStayPutProjections(rows || []);
        }).catch(()=>{
            if (!cancelled) setStayPutProjections([]);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind,
        localLegacyYears
    ]);
    const manualBaselineLegacy = (0, $acw62.useMemo)(()=>{
        const last = stayPutProjections[localLegacyYears - 1] ?? stayPutProjections[stayPutProjections.length - 1];
        return (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(last);
    }, [
        stayPutProjections,
        localLegacyYears
    ]);
    /*
   * An ENGINE plan's levers, in Manual Control's terms (village review, 18 Oct 2026: a sell-the-home
   * plan saved from the engine reopened as paid from savings, because the engine candidate carries
   * `fundFrom` / `sellHomeDetails` / `entryFeeFundingOverride` / `investmentPropertyDetails` and the
   * restore read only Manual Control's own keys). Also used when Manual Control is opened with an
   * engine plan selected, so "your selection carries over" is true.
   */ const seedManualFromEngineInputs = (inputs)=>{
        const fundFrom = inputs.fundFrom;
        if (!fundFrom) return false;
        setRvOverallStrategy({
            downsizeHome: fundFrom === 'sell_home',
            rentHome: !!inputs.rentHome,
            sellInvestmentProperty: fundFrom === 'investment_property'
        });
        if (inputs.sellHomeDetails) setSellHomeDetails((prev)=>({
                ...prev,
                ...inputs.sellHomeDetails
            }));
        if (inputs.rentDetails) setRentDetails((prev)=>({
                ...prev,
                ...inputs.rentDetails
            }));
        setEntryFeeFunding(inputs.entryFeeFundingOverride || {});
        if (inputs.investmentPropertyDetails) setRvInvestmentPropertyDetails((prev)=>({
                ...prev,
                ...inputs.investmentPropertyDetails
            }));
        // A plan that also clears the debts brings its payoff with it (25 Oct 2026), or the hand-built figures
        // open short of the card's by the repayments.
        const payoff = inputs.debtPayoff;
        setDebtPayments({
            ...payoff?.payments || {}
        });
        setDebtFunding({
            ...payoff?.funding || {}
        });
        setDebtRepaymentBasis(payoff?.repaymentBasis === 'lower_repayment' ? 'lower_repayment' : 'keep_repayment');
        return true;
    };
    const reopenStrategy = (strategy)=>{
        const inputs = strategy.inputs || {};
        if (inputs.villageInputs) setVillageInputs(inputs.villageInputs);
        if (!inputs.rvOverallStrategy && seedManualFromEngineInputs(inputs)) {
            setEntryFeeCgtOverrides({});
            setStrategyMode('manual');
            setShowStrategyOptions(true);
            setActiveSavedStrategyId(strategy.id);
            return;
        }
        setRvOverallStrategy(inputs.rvOverallStrategy || {
            rentHome: false,
            downsizeHome: false,
            sellInvestmentProperty: false
        });
        setSellHomeDetails(inputs.sellHomeDetails || sellHomeDetails);
        setRentDetails(inputs.rentDetails || rentDetails);
        setEntryFeeFunding(inputs.entryFeeFunding || {});
        setEntryFeeCgtOverrides(inputs.entryFeeCgtOverrides || {});
        setRvInvestmentPropertyDetails(inputs.rvInvestmentPropertyDetails || rvInvestmentPropertyDetails);
        const restoredOtherStrategies = inputs.otherStrategies;
        setOtherStrategies(restoredOtherStrategies || {
            gifting: false,
            giftingAmount: 0,
            giftingSource: 'bankAccounts',
            funeralBonds: false,
            funeralBondAmount: 0,
            funeralBondSource: 'bankAccounts',
            annuity: false
        });
        setAnnuityRecord(inputs.annuityRecord || null);
        if (restoredOtherStrategies?.annuity || inputs.annuityRecord) setShowOtherStrategies(true);
        setStrategyMode('manual');
        setShowStrategyOptions(true);
        setActiveSavedStrategyId(strategy.id);
    };
    const rvSavedStrategies = savedStrategies?.filter((s)=>s.type === 'retirement_village') || [];
    const hasHome = !!(factFind?.home && $7911ccd6eced4ff4$var$n(factFind.home.value) > 0);
    // Matches the suggestion engine's own test for generating a sell-IP candidate
    // (generateRetirementVillageCandidates), so the narrative and the strategies can never disagree
    // about whether this client has an investment property to sell.
    /**
   * One pool, two claimants. A dollar can pay the village entry fee or retire a debt, never both, so
   * each card's sliders are capped by what the OTHER has already claimed of that asset — the aged
   * care module's shared-pool rule (see DebtPayoffStrategy's header). Without this the debt card
   * offered an asset's FULL balance even after the entry fee had spent most of it.
   */ const reservedForEntryFee = (0, $acw62.useMemo)(()=>Object.fromEntries(Object.entries(effectiveEntryFeeFunding || {}).map(([key, amount])=>[
                key,
                $7911ccd6eced4ff4$var$n(amount)
            ])), [
        effectiveEntryFeeFunding
    ]);
    const reservedForDebt = (0, $acw62.useMemo)(()=>Object.fromEntries(Object.entries(debtFunding || {}).map(([key, amount])=>[
                key,
                $7911ccd6eced4ff4$var$n(amount)
            ])), [
        debtFunding
    ]);
    const entryFeeFundingFromIp = (0, $acw62.useMemo)(()=>{
        const funding = effectiveEntryFeeFunding || {};
        return Object.keys(funding).some((id)=>id.startsWith('investmentProperty-') && $7911ccd6eced4ff4$var$n(funding[id]) > 0);
    }, [
        effectiveEntryFeeFunding
    ]);
    const entryFeeAllocationBreakdown = (0, $acw62.useMemo)(()=>{
        if (fundFrom !== 'liquid' || summary.entryFee <= 0 || !factFind?.assets) return [];
        const order = [
            'bankAccounts',
            'termDeposits',
            'accountBasedPensions',
            'shares',
            'investmentProperty'
        ];
        const typeLabels = {
            bankAccounts: 'Bank accounts',
            termDeposits: 'Term deposits',
            accountBasedPensions: 'Account-based pensions',
            shares: 'Shares',
            investmentProperty: 'Investment property'
        };
        const out = [];
        order.forEach((type)=>{
            const arr = factFind.assets[type];
            if (!arr) return;
            (arr || []).forEach((asset)=>{
                const assetId = `${type}-${asset.id}`;
                const amount = $7911ccd6eced4ff4$var$n(effectiveEntryFeeFunding?.[assetId]);
                if (amount <= 0) return;
                const label = asset.description || typeLabels[type] || type;
                out.push({
                    label: label,
                    amount: amount
                });
            });
        });
        return out;
    }, [
        fundFrom,
        summary.entryFee,
        factFind?.assets,
        effectiveEntryFeeFunding
    ]);
    /*
   * GOAL LEADERS, with the aged care horizon rule (owner, 23 Sep 2026: "a flagged strategy should
   * not win a ranking"; 24 Sep: the nil-residual annuity led "best cashflow" here). A candidate
   * whose annuity needs more years than this client's age and health point to is set aside from
   * the leadership — never hidden: the disclosure below the cards names it and opens it.
   */ const rvRecommended = (0, $acw62.useMemo)(()=>{
        if (!rvSuggestions) return [];
        const movers = (rvSuggestions.strategies || []).filter((s)=>s.id !== 'rv-stay-home' && !s.inputs?.stayHome);
        const eligible = movers.filter((s)=>(0, $4852c06b0c4c15b4$export$ee2616655543b3d)(s, factFind) == null);
        /*
     * RANKED AMONG THE WAYS OF MOVING, not against staying put (village rebuild, owner 20–21 Oct 2026).
     * The shared ranking withholds a plan that does not beat doing nothing; for a village that is most
     * families, since a move usually costs the estate something. They are moving for other reasons, so
     * the screen shows the least costly ways to do it, with the price said in one line above the cards
     * and an "Important" line on each — never as if the move were free.
     */ return (0, $f8ee565b442c040e$export$3140a3b98e6384f2)(eligible, null, {
            cashflowTarget: Number(rvSetup.cashflowTarget) || 0,
            readings: (0, $5a094123650e8adb$export$448a1f2525c95b5b)
        });
    }, [
        rvSuggestions,
        factFind,
        rvSetup.cashflowTarget
    ]);
    const rvGoalLeaders = (0, $acw62.useMemo)(()=>(0, $f8ee565b442c040e$export$64e432c7e60d26e3)(rvRecommended), [
        rvRecommended
    ]);
    /** Whether the cashflow-covered leader is also the best estate outright — said, not shown twice. */ const coveredSameAsEstate = (0, $acw62.useMemo)(()=>(0, $400a08a42b233386$export$b8b8a2cedd92aa3a)(rvRecommended), [
        rvRecommended
    ]);
    /** The cashflow-covered leader's case, for the line on its card. */ const coveredNoteFor = (s)=>{
        const v = rvRecommended.find((r)=>r.label === (0, $400a08a42b233386$export$920ad41b346ae01a) && r.strategy?.name === s.name)?.cashflowCovered;
        return v ? (0, $400a08a42b233386$export$455fad9aa8ff9328)(v, Number(localLegacyYears) || 5, (0, $f94e45ac645ae232$export$3dc27271f5d5c629)) : null;
    };
    /** The leaders the horizon rule set aside, so the screen can say so and open them. */ const rvSetAside = (0, $acw62.useMemo)(()=>{
        if (!rvSuggestions) return [];
        return (0, $f8ee565b442c040e$export$64e432c7e60d26e3)(rvSuggestions.recommended).map((s)=>({
                strategy: s,
                labels: s.recommendationLabels || [],
                warning: (0, $4852c06b0c4c15b4$export$ee2616655543b3d)(s, factFind) || ''
            })).filter((x)=>x.warning);
    }, [
        rvSuggestions,
        factFind
    ]);
    /** Which goal's card is shown — aged care's chips (presentation only; the engine is not re-run). */ const [optimisationFocus, setOptimisationFocus] = (0, $acw62.useState)('legacy');
    /** How the full list is ordered — aged care's sort. */ const [allSortBy, setAllSortBy] = (0, $acw62.useState)('legacy');
    const selectedStrategy = (0, $acw62.useMemo)(// Search the FULL evaluated set, not just the goal leaders — "Compare all strategies" lets the
    // user select any evaluated strategy, not only the three leaders.
    ()=>strategyMode === 'optimised' ? (rvSuggestions?.strategies || []).find((s)=>s.id === (explainSeId ?? selectedSeId)) || rvGoalLeaders.find((s)=>s.id === (explainSeId ?? selectedSeId)) || null : null, [
        strategyMode,
        rvSuggestions,
        rvGoalLeaders,
        selectedSeId,
        explainSeId
    ]);
    /**
   * Which strategy CARDS appear, and what each is badged as.
   *
   * Owner-caught (2026-08-26), two faults with one cause — the screen only ever rendered the goal
   * leaders:
   *   1. A run where nothing beat staying put on estate or Age Pension showed a single card. The
   *      withholding is honest (recommending something worse than doing nothing would not be), but a
   *      client who has already decided to move still needs to know which option is LEAST damaging.
   *      So a goal with no improver now shows its best-of-field, badged as not beating the baseline
   *      rather than presented as a recommendation.
   *   2. Selecting a strategy from "All modelled strategies" set the selection correctly and drove
   *      the panels — but if it was not a goal leader it had no card, so the screen looked unchanged
   *      and read as though the click had been ignored.
   */ const seCards = (0, $acw62.useMemo)(()=>{
        if (!rvSuggestions) return [];
        const LABELS = {
            ...(0, $400a08a42b233386$export$900f9fe722d67fa2)
        };
        const movers = (rvSuggestions.strategies || []).filter((s)=>!s.inputs?.stayHome);
        const out = [];
        const byId = new Map();
        const second = (0, $37a1f55bdc037774$export$fd1fff32319e093c)(rvRecommended, (0, $f94e45ac645ae232$export$3dc27271f5d5c629));
        const leadWords = (0, $37a1f55bdc037774$export$7e1712c96a3999b4)(rvRecommended, (0, $f94e45ac645ae232$export$3dc27271f5d5c629));
        const push = (strategy, badges, belowBaseline)=>{
            const key = String(strategy.id ?? strategy.name ?? '');
            const existing = byId.get(key);
            if (existing) {
                badges.forEach((b)=>{
                    if (!existing.badges.includes(b)) existing.badges.push(b);
                });
                return;
            }
            const entry = {
                strategy: strategy,
                badges: [
                    ...badges
                ],
                belowBaseline: belowBaseline
            };
            byId.set(key, entry);
            out.push(entry);
        };
        // A leader of the MOVERS can still leave less than staying put: the card says so, neutrally
        // (owner, 19 Oct 2026 — awareness, not a mistake; see belowBaselineWords).
        rvGoalLeaders.forEach((leader)=>{
            const labels = leader.recommendationLabels || [];
            const short = labels.map((l)=>(0, $37a1f55bdc037774$export$36bb4723017cc200)(l, leader, rvSuggestions.stayHome, 'staying put', (0, $f94e45ac645ae232$export$3dc27271f5d5c629))).find(Boolean);
            push(leader, labels.map((l)=>LABELS[l] || l), short);
            // The chip says what the card is, and the line why (planChoiceRule.ts).
            const key = String(leader.id ?? leader.name ?? '');
            const e = byId.get(key);
            if (e) {
                (0, $37a1f55bdc037774$export$c33ffdd7e2f8a65a)(e, key, second, (0, $5a094123650e8adb$export$a1a7ae9e29edd48c));
                (0, $37a1f55bdc037774$export$c33ffdd7e2f8a65a)(e, key, leadWords, (0, $400a08a42b233386$export$8a102fa4742ce4ac));
            }
        });
        const base = rvSuggestions.stayHome?.snapshot;
        const GOALS = [
            {
                label: 'Optimal Legacy',
                friendly: 'estate',
                pick: (s)=>s.snapshot?.legacyValue ?? 0,
                baseValue: base?.legacyValue ?? 0
            },
            {
                label: 'Optimal Cashflow',
                friendly: 'cashflow',
                pick: (s)=>s.snapshot?.netCashflow ?? 0,
                baseValue: base?.netCashflow ?? 0
            },
            {
                label: 'Optimal Age Pension',
                friendly: 'Age Pension',
                pick: (s)=>s.snapshot?.pension ?? 0,
                baseValue: base?.pension ?? 0
            }
        ];
        GOALS.forEach(({ label: label, friendly: friendly, pick: pick, baseValue: baseValue })=>{
            if (movers.length === 0) return;
            if (rvGoalLeaders.some((l)=>(l.recommendationLabels || []).includes(label))) return;
            // Every option at nil pension is a finding, not a shortlist — the note below says so, and a
            // "best available $0" card would add nothing.
            if (label === 'Optimal Age Pension' && movers.every((s)=>(s.snapshot?.pension ?? 0) <= 0)) return;
            const best = movers.reduce((top, s)=>pick(s) > pick(top) ? s : top, movers[0]);
            push(best, [
                `Best available ${friendly}`
            ], (0, $37a1f55bdc037774$export$36bb4723017cc200)(label, best, rvSuggestions.stayHome, 'staying put', (0, $f94e45ac645ae232$export$3dc27271f5d5c629)) ?? `Does not beat staying put (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(baseValue)}); the closest of the options modelled on this goal.`);
        });
        if (selectedSeId && !byId.has(String(selectedSeId))) {
            const chosen = movers.find((s)=>s.id === selectedSeId);
            if (chosen) push(chosen, [
                'Your selection'
            ]);
        }
        return out;
    }, [
        rvSuggestions,
        rvGoalLeaders,
        selectedSeId,
        rvRecommended
    ]);
    /*
   * `usingSe`: a Suggestion Engine strategy is selected, which drives its EXPLANATION (the recap
   * behind "Explain this") and its deep dive. It never drives the rail: in engine mode the plan
   * summary holds STAYING PUT while every card carries its own figures — the aged care pattern,
   * adopted here on 24 Sep 2026 (owner: "replicate ... the interplay with the Your Plan Summary").
   */ const usingSe = strategyMode === 'optimised' && !!selectedStrategy;
    /*
   * BUILD A PLAN YOURSELF (rebuild M3, 21 Oct 2026): the ledger's own state — which plan it started from,
   * the last change and its effect, and whether this hand-built plan is the chosen one.
   */ const [manualStartedFrom, setManualStartedFrom] = (0, $acw62.useState)(null);
    const [manualLastChange, setManualLastChange] = (0, $acw62.useState)(null);
    const [manualChosen, setManualChosen] = (0, $acw62.useState)(false);
    const noteManualChange = (words)=>{
        setManualLastChange(words);
        setManualChosen(false);
    };
    const manualRent = (0, $acw62.useMemo)(()=>{
        const g = factFind?.goals || {};
        return {
            weekly: g.rvRentPerWeek != null ? $7911ccd6eced4ff4$var$n(g.rvRentPerWeek) : $7911ccd6eced4ff4$var$n(factFind?.home?.likelyRent),
            costs: g.rvRentCosts != null ? $7911ccd6eced4ff4$var$n(g.rvRentCosts) : $7911ccd6eced4ff4$var$n(factFind?.home?.likelyExpenses),
            vacancy: g.rvVacancyWeeks != null ? $7911ccd6eced4ff4$var$n(g.rvVacancyWeeks) : (0, $6d7411748a56fc80$export$cf7cc42462ce27c2)
        };
    }, [
        factFind?.goals,
        factFind?.home?.likelyRent,
        factFind?.home?.likelyExpenses
    ]);
    /** The rented home's figures from step 3's answers, less the weeks it sits empty. */ const syncRentFromAnswers = ()=>setRentDetails((prev)=>({
                ...prev,
                rentAmount: (0, $6d7411748a56fc80$export$f18276a1042657ae)(manualRent.weekly, manualRent.vacancy),
                rentExpenses: manualRent.costs
            }));
    /** "A blank plan": the home kept, nothing moved, every amount the client's to choose. */ const startBlankManualPlan = ()=>{
        setRvOverallStrategy({
            downsizeHome: false,
            rentHome: false,
            sellInvestmentProperty: false
        });
        const zeros = {};
        for (const kind of [
            'bankAccounts',
            'termDeposits',
            'accountBasedPensions',
            'shares'
        ])for (const a of factFind?.assets?.[kind] || [])zeros[`${kind}-${a.id}`] = 0;
        setEntryFeeFunding(zeros);
        setSellHomeDetails((prev)=>({
                ...prev,
                downsizerContribution: 0,
                partnerDownsizerContribution: 0,
                commenceIncomeStream: false,
                giftingAmount: 0,
                funeralBondPurchase: 0,
                purchaseAnnuity: 0,
                purchaseInvestmentProperty: 0,
                investmentPropertyStampDuty: 0,
                purchaseShares: 0
            }));
        setOtherStrategies((prev)=>({
                ...prev,
                gifting: false,
                giftingAmount: 0,
                funeralBonds: false,
                funeralBondAmount: 0,
                annuity: false
            }));
        setDebtPayments({});
        setDebtFunding({});
        setDebtRepaymentBasis('keep_repayment');
        setEntryFeeCgtOverrides({});
    };
    /**
   * TWO DOORS INTO THE LEDGER (owner, 25 Oct 2026). "Build a plan yourself" (no plan) opens a BLANK plan —
   * it used to open on whatever was last there. "Customise this plan" (a tested plan) clears first, then
   * copies that plan in, so nothing from an earlier hand-built plan lingers under it.
   */ const openRvBuild = (row)=>{
        startBlankManualPlan();
        if (row?.inputs && seedManualFromEngineInputs(row.inputs)) setManualStartedFrom((0, $7175ce4c598409db$export$6078d665f40b52df)(row, factFind, summary.entryFee).title);
        else setManualStartedFrom(null);
        setManualLastChange(null);
        setManualChosen(false);
        setRvAsking(false);
        setStrategyMode('manual');
        setShowStrategyOptions(true);
        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
    };
    /** The hand-built plan as a tested plan would be read: its words and its risks. */ const manualAsCandidate = ()=>({
            id: 'rv-manual',
            name: rvPlanSummaryName || 'A plan built by hand',
            inputs: {
                fundFrom: fundFrom,
                rentHome: rvOverallStrategy.rentHome,
                rentDetails: rvOverallStrategy.rentHome ? rentDetails : undefined,
                sellHomeDetails: fundFrom === 'sell_home' ? sellHomeDetails : undefined,
                entryFeeFundingOverride: effectiveEntryFeeFunding,
                investmentPropertyDetails: fundFrom === 'investment_property' ? rvInvestmentPropertyDetails : undefined
            }
        });
    const manualPlanWords = ()=>(0, $7175ce4c598409db$export$6078d665f40b52df)(manualAsCandidate(), factFind, summary.entryFee);
    const manualRiskKinds = ()=>{
        const k = [
            'villageEntry'
        ];
        const d = sellHomeDetails;
        if (fundFrom === 'sell_home') {
            k.push('sellHome');
            if ($7911ccd6eced4ff4$var$n(d.downsizerContribution) + $7911ccd6eced4ff4$var$n(d.partnerDownsizerContribution) > 0) k.push('superContribution');
            if (d.commenceIncomeStream) k.push('accountBasedPension');
            if ($7911ccd6eced4ff4$var$n(d.purchaseAnnuity) > 0) k.push(d.rvAnnuityType === 'guaranteed' ? 'annuityGuaranteed' : $7911ccd6eced4ff4$var$n(d.rvAnnuityResidualPercent) > 0 ? 'annuityReturned' : 'annuityNil');
            if ($7911ccd6eced4ff4$var$n(d.purchaseInvestmentProperty) > 0) k.push('investmentProperty');
            if ($7911ccd6eced4ff4$var$n(d.purchaseShares) > 0) k.push('shares');
            if ($7911ccd6eced4ff4$var$n(d.giftingAmount) > 0) k.push('gift');
            if ($7911ccd6eced4ff4$var$n(d.funeralBondPurchase) > 0) k.push('funeralBond');
        } else {
            k.push('fromSavings');
            if (rvOverallStrategy.rentHome) k.push('rentFormerHome');
            if (fundFrom === 'investment_property') k.push('sellInvestmentProperty');
            if (otherStrategies.gifting) k.push('gift');
            if (otherStrategies.funeralBonds) k.push('funeralBond');
        }
        if (debtPayoffPlan) k.push('clearDebt');
        return k;
    };
    /** Choosing the hand-built plan: the same card record a tested plan saves (Manual Control parity). */ const chooseManualPlan = ()=>{
        const words = manualPlanWords();
        const villageName = String(factFind?.goals?.rvVillageName || '').trim();
        const horizon = Number(localLegacyYears) || 10;
        const exitAtHorizon = (0, $a5e43ea76f631c99$export$92ec836666aacd49)(villageInputs, horizon);
        const card = {
            plan: {
                legacy: $7911ccd6eced4ff4$var$n(legacyEstimateDisplay),
                pension: $7911ccd6eced4ff4$var$n(simulatedFinancials?.socialSecurity),
                cashflow: $7911ccd6eced4ff4$var$n(projections[0]?.netCashflow)
            },
            baseline: initialFinancials ? {
                legacy: $7911ccd6eced4ff4$var$n(manualBaselineLegacy),
                pension: $7911ccd6eced4ff4$var$n(initialFinancials.socialSecurity),
                cashflow: $7911ccd6eced4ff4$var$n(initialFinancials.cashFlow)
            } : null,
            words: words,
            village: {
                name: villageName,
                entryFee: summary.entryFee,
                annualOngoing: summary.annualOngoing,
                fees: $7911ccd6eced4ff4$var$n(villageInputs.ongoingWeeklyOrMonthly),
                feesFrequency: villageInputs.ongoingFrequency,
                departureFee: exitAtHorizon.dmf,
                backAfter: exitAtHorizon.netToResident
            },
            horizonYears: horizon,
            riskKinds: manualRiskKinds(),
            rentNet: rvOverallStrategy.rentHome ? Math.max(0, $7911ccd6eced4ff4$var$n(rentDetails.rentAmount) * 52 - $7911ccd6eced4ff4$var$n(rentDetails.rentExpenses)) : 0,
            origin: 'manual',
            // A hand-built guaranteed income: the family table from this plan's own rows, no twin to compare (E4/M4).
            family: (0, $91a0ac81d8d23067$export$e9940ef619b461f8)((0, $91a0ac81d8d23067$export$32b560717abe61e8)({
                inputs: {
                    sellHomeDetails: sellHomeDetails
                }
            }, factFind), factFind, projections, null, horizon),
            // The card's runway sentence and the plan's own risks, frozen with it for the plan page (22 Oct 2026).
            runLine: projections.length ? (0, $2ddaae90639b5011$export$7526d1fcb4423629)({
                rows: projections,
                factFind: factFind,
                horizonYears: horizon,
                spentOn: 'the entry payment'
            }) : null,
            riskSpecifics: manualRiskSpecifics()
        };
        const id = `rv-manual-${Date.now()}`;
        setSavedStrategies((prev)=>(0, $accc76cd2fa8edd9$export$75afc4671887f877)(prev, {
                id: id,
                name: words.title,
                displayName: words.title,
                type: 'retirement_village',
                source: 'manual',
                inputsFingerprint: (0, $78a369bbf1e0d995$export$236630ee0fd3b65b)(factFind),
                // Built by the client from a tested plan ("Customise this plan", 25 Oct 2026).
                ...manualStartedFrom ? {
                    customisedFrom: manualStartedFrom
                } : {},
                inputs: {
                    card: card,
                    unitKey: (0, $accc76cd2fa8edd9$export$a3fbef763ac12540)(villageName, summary.entryFee),
                    legacyYears: horizon,
                    planContext: {
                        entryFee: summary.entryFee,
                        annualOngoing: summary.annualOngoing,
                        villageName: villageName
                    },
                    villageInputs: {
                        ...villageInputs
                    },
                    rvOverallStrategy: rvOverallStrategy,
                    sellHomeDetails: sellHomeDetails,
                    rentDetails: rentDetails,
                    entryFeeFunding: effectiveEntryFeeFunding,
                    entryFeeCgtOverrides: entryFeeCgtOverrides,
                    rvInvestmentPropertyDetails: rvInvestmentPropertyDetails,
                    otherStrategies: otherStrategies,
                    annuityRecord: annuityRecord,
                    // Who decided the draw: the client's typed amounts, or our starting point left standing.
                    entryFeeFundingProvenance: {
                        source: (0, $056bec631a0e8ebc$export$7ecf57148a92ad89)(entryFeeFunding) ? 'adviser_allocated' : 'tool_default_accepted',
                        recordedAt: new Date().toISOString(),
                        resolvedAllocation: {
                            ...effectiveEntryFeeFunding
                        }
                    }
                },
                outputs: {
                    summary: summary,
                    entryFee: summary.entryFee,
                    annualOngoing: summary.annualOngoing,
                    agePension: card.plan.pension,
                    cashFlow: card.plan.cashflow,
                    legacyEstimate: card.plan.legacy,
                    netWorthSchedule: (0, $a882fd27fa2c97d8$export$7386c6396507d94b)(projections || [])
                },
                createdAt: new Date().toISOString()
            }));
        setActiveSavedStrategyId(id);
        setManualChosen(true);
    };
    /** The plan chosen on an earlier visit, for its card (one plan per unit). */ // Read off THE chosen plan (the one the plan page shows), never off another record still flagged chosen —
    // see rvChosenEngineIdOf (25 Oct 2026). A hand-built chosen plan has no tested twin.
    const rvChosenEngineId = (0, $acw62.useMemo)(()=>(0, $accc76cd2fa8edd9$export$5a65a0ca975061d)((0, $accc76cd2fa8edd9$export$d11c0ebb38aa6e79)(savedStrategies)), [
        savedStrategies
    ]);
    const [showAllSeStrategies, setShowAllSeStrategies] = (0, $acw62.useState)(false);
    // Escape closes "Every way we tested" (review, 18 Oct 2026).
    (0, $acw62.useEffect)(()=>{
        if (!showAllSeStrategies) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') setShowAllSeStrategies(false);
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        showAllSeStrategies
    ]);
    /** The cards the chosen goal shows; a chosen card that leads nothing shows under every goal. */ const visibleSeCards = (0, $acw62.useMemo)(()=>{
        if (optimisationFocus === 'all') return seCards;
        // The same plan as Best estate is said in one line, not shown twice (owner, 24 Sep 2026).
        if (optimisationFocus === 'covered' && coveredSameAsEstate) return [];
        const badgesFor = {
            covered: [
                (0, $400a08a42b233386$export$8d25e363f6ae69ae)
            ],
            legacy: [
                (0, $400a08a42b233386$export$8a102fa4742ce4ac),
                'Best available estate',
                (0, $5a094123650e8adb$export$a1a7ae9e29edd48c)
            ],
            cashflow: [
                'Best cashflow',
                'Best available cashflow'
            ],
            pension: [
                'Best Age Pension',
                'Best available Age Pension'
            ]
        };
        return seCards.filter((c)=>c.badges.some((b)=>badgesFor[optimisationFocus].includes(b) || optimisationFocus === 'legacy' && (0, $37a1f55bdc037774$export$47bf00807fdc72f0)(b) || b === 'Your selection'));
    }, [
        seCards,
        optimisationFocus,
        coveredSameAsEstate
    ]);
    /**
   * A real annuity quote, replacing the tool's indicative rate across the whole Suggestion Engine
   * field (owner, 2026-08-26). Null until the adviser enters one, in which case every candidate that
   * buys an annuity is re-modelled and the goals re-ranked on the quoted income — a provider's
   * actual figure can easily change which strategy wins, so it must re-rank rather than just relabel.
   */ // A provider's quote belongs to one type and one amount (annuityQuote.ts, guaranteed income review M5).
    const [seAnnuityQuote, setSeAnnuityQuote] = (0, $acw62.useState)(null);
    const [seAnnuityQuoteDraft, setSeAnnuityQuoteDraft] = (0, $acw62.useState)('');
    const effProjections = usingSe ? selectedStrategy.projections || [] : projections;
    const effFundFrom = usingSe ? selectedStrategy.inputs?.fundFrom || fundFrom : fundFrom;
    /*
   * HOW LONG THE MONEY LASTS — the section every other module's rail carries, and the one this
   * module needed most (2026-08-27). A village move commonly turns a small surplus into a deficit
   * of tens of thousands a year: the entry contribution leaves savings, the ongoing fees start, and
   * the Age Pension often goes with the home exemption. Reporting all three without ever saying how
   * many years the savings then last leaves out the question the client is actually asking.
   */ /**
   * What the plan summary is describing, in the client's words — or null when it is describing
   * STAYING PUT. Manual Control only: the Suggestion Engine's cards each carry their own plan and
   * the rail holds the baseline beside them. Derived from the choices actually made, never a stored
   * label: a panel headed with a name that no longer matches the figures underneath is worse than
   * one with no name at all.
   *
   * PAYING FROM SAVINGS IS A CHOICE, AND IS NAMED (owner, 24 Sep 2026). The rail used to head "No
   * plan yet" over a plan the app had chosen — the entry contribution taken from savings in a
   * default order. In Manual Control that funding is the plan, so it is named as one.
   */ const rvPlanSummaryName = (0, $acw62.useMemo)(()=>{
        if (strategyMode !== 'manual') return null;
        const parts = [];
        if (rvOverallStrategy.downsizeHome) parts.push('Sell the family home');
        if (rvOverallStrategy.rentHome) parts.push('Rent the family home');
        if (rvOverallStrategy.sellInvestmentProperty) parts.push('Sell the investment property');
        if (!parts.length && summary.entryFee > 0) parts.push('Pay the entry contribution from savings');
        if (otherStrategies.annuity) parts.push('Commence an annuity');
        if (otherStrategies.gifting) parts.push('Gift to loved ones');
        if (otherStrategies.funeralBonds) parts.push('Buy a funeral bond');
        if (!parts.length) return null;
        const [lead, ...rest] = parts;
        return rest.length ? `${lead}, ${rest.map((p)=>p.charAt(0).toLowerCase() + p.slice(1)).join(', ')}` : lead;
    }, [
        strategyMode,
        rvOverallStrategy,
        otherStrategies,
        summary.entryFee
    ]);
    /** The lifetime annuity Manual Control buys, if any — said in the sentence and the recap when it returns nothing on death. */ const manualAnnuity = (0, $acw62.useMemo)(()=>{
        const ownerName = (o)=>(o === 'partner' ? factFind?.partner?.firstName : factFind?.client?.firstName) || 'you';
        if (fundFrom === 'sell_home' && $7911ccd6eced4ff4$var$n(sellHomeDetails.purchaseAnnuity) > 0) return {
            amount: $7911ccd6eced4ff4$var$n(sellHomeDetails.purchaseAnnuity),
            residualPercent: $7911ccd6eced4ff4$var$n(sellHomeDetails.rvAnnuityResidualPercent),
            ownerName: ownerName(sellHomeDetails.rvAnnuityOwner)
        };
        if (otherStrategies.annuity && annuityRecord && $7911ccd6eced4ff4$var$n(annuityRecord.purchaseAmount) > 0) return {
            amount: $7911ccd6eced4ff4$var$n(annuityRecord.purchaseAmount),
            residualPercent: Math.round((Number(annuityRecord.residualCapital) || 0) * 100),
            ownerName: ownerName(annuityRecord.owner)
        };
        return null;
    }, [
        fundFrom,
        sellHomeDetails,
        otherStrategies.annuity,
        annuityRecord,
        factFind
    ]);
    /** The nil-residual annuity the recap must name — the selected card's, or Manual Control's. */ const nilResidualAnnuityForRecap = (()=>{
        const a = usingSe && selectedStrategy ? (0, $4852c06b0c4c15b4$export$6d4129e74a169c1e)(selectedStrategy, factFind) : manualAnnuity;
        return a && a.amount > 0 && Math.round(a.residualPercent) === 0 ? a : null;
    })();
    /** "What could go wrong" about the hand-built plan in particular — its annuity's age-and-health warning and any stamp duty (22 Oct 2026). */ const manualRiskSpecifics = ()=>{
        const owner = fundFrom === 'sell_home' && $7911ccd6eced4ff4$var$n(sellHomeDetails.purchaseAnnuity) > 0 ? sellHomeDetails.rvAnnuityOwner : annuityRecord?.owner;
        const annuityTerms = manualAnnuity ? {
            purchaseAmount: manualAnnuity.amount,
            residualPercent: manualAnnuity.residualPercent,
            owner: owner
        } : null;
        return (0, $4852c06b0c4c15b4$export$7a83655e7acf7684)({
            ...manualAsCandidate(),
            annuityTerms: annuityTerms
        }, factFind);
    };
    /**
   * The rail holds STAYING PUT — the one baseline — until Manual Control names a plan. In engine
   * mode it always does: each card carries its own figures, measured against this rail.
   */ const railHoldsStayPut = !rvPlanSummaryName;
    const railProjections = railHoldsStayPut ? stayPutProjections : projections;
    const rvRunway = (0, $acw62.useMemo)(()=>railProjections.length ? (0, $0fe89e03b6df746e$export$464558962ff4a811)(railProjections, Number(localLegacyYears) || 5) : null, [
        railProjections,
        localLegacyYears
    ]);
    /**
   * The panel's "In brief": the SAME sentence template every engine card carries (rvInBrief.tsx),
   * fed here with Manual Control's own figures — the tiles beneath it — against staying put.
   */ const rvInBrief = (0, $acw62.useMemo)(()=>{
        if (!rvPlanSummaryName) return null;
        const cashBefore = initialFinancials?.cashFlow ?? 0;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed3a1547818f47b$export$baf7acd040ea3369), {
            entryFee: summary.entryFee,
            fundFrom: fundFrom,
            rentHome: rvOverallStrategy.rentHome,
            fromSaleAmount: fundFrom === 'liquid' ? null : propertyTowardEntry,
            fromSavingsAmount: fundFrom === 'liquid' ? null : liquidTargetForEntryFee,
            annuity: manualAnnuity,
            pensionBefore: initialFinancials?.socialSecurity ?? 0,
            pensionAfter: simulatedFinancials?.socialSecurity ?? 0,
            cashBefore: cashBefore,
            cashAfter: noVillageScenario ? cashBefore : projections[0]?.netCashflow ?? cashBefore,
            planLegacy: legacyEstimateDisplay,
            baseLegacy: manualBaselineLegacy,
            legacyYears: Number(localLegacyYears) || 0,
            shortfall: entryFeeShortfall
        });
    }, [
        rvPlanSummaryName,
        initialFinancials,
        simulatedFinancials,
        noVillageScenario,
        projections,
        legacyEstimateDisplay,
        manualBaselineLegacy,
        summary.entryFee,
        fundFrom,
        rvOverallStrategy.rentHome,
        localLegacyYears,
        entryFeeShortfall,
        propertyTowardEntry,
        liquidTargetForEntryFee,
        manualAnnuity
    ]);
    const effRentHome = usingSe ? effFundFrom === 'rent_home' || !!selectedStrategy.inputs?.rentHome : rvOverallStrategy.rentHome;
    const effDownsizeHome = usingSe ? effFundFrom === 'sell_home' : rvOverallStrategy.downsizeHome;
    const effSellInvestmentProperty = usingSe ? effFundFrom === 'investment_property' : rvOverallStrategy.sellInvestmentProperty;
    const effLegacyEstimate = usingSe ? effProjections.length ? (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(effProjections[localLegacyYears - 1] ?? effProjections[effProjections.length - 1]) ?? legacyEstimateDisplay : legacyEstimateDisplay : legacyEstimateDisplay;
    const rvInsightFinancials = (0, $acw62.useMemo)(()=>{
        const before = initialFinancials?.socialSecurity ?? 0;
        const after = noVillageScenario ? before : effProjections[0]?.financials?.socialSecurity ?? before;
        const cashflowAfter = noVillageScenario ? initialFinancials?.cashFlow ?? 0 : effProjections[0]?.netCashflow ?? 0;
        let agePensionWhy = '';
        if (summary.entryFee > 0 && hasHome && (effFundFrom === 'liquid' || effFundFrom === 'rent_home' || effRentHome)) // The entry contribution's treatment is decided by the Extra Allowable Amount test, and saying
        // it is "also assessed" unconditionally was wrong in the COMMON case: above the EAA the
        // resident is a homeowner and the contribution is exempt (verified against the engine — a
        // $500k entry on a kept $3.5m home assesses $3.5m, not $4.0m). Only at or below the EAA is the
        // contribution itself an assessable asset, and then the higher non-homeowner limits apply.
        agePensionWhy = summary.entryFee <= (0, $1abe73eeef086faf$export$e2cf792e99a08354) ? `Your former principal home is assessable under the assets test (no 2\u{2011}year exemption in retirement village). Your entry contribution is at or below the extra allowable amount of ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$e2cf792e99a08354))}, so it is also counted as an asset \u{2014} but the higher non-homeowner thresholds apply, and Rent Assistance may be payable on your regular fees. The change in Age Pension reflects your total assessable assets and the income test.` : `Your former principal home is assessable under the assets test (no 2\u{2011}year exemption in retirement village). Your entry contribution is above the extra allowable amount of ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$e2cf792e99a08354))}, so the contribution itself is not counted \u{2014} it is treated as your home \u{2014} but the lower homeowner thresholds then apply to everything else. The change in Age Pension reflects your total assessable assets and the income test.`;
        else if (summary.entryFee > 0 && (effFundFrom === 'sell_home' || effFundFrom === 'investment_property')) agePensionWhy = 'Your entry fee is funded from the sale of property. The change in Age Pension reflects your revised assessable assets and income (e.g. less home value, possible CGT, and how proceeds are invested).';
        else if (summary.entryFee > 0) agePensionWhy = 'The entry contribution is assessable under the assets test. Your Age Pension change reflects your total assessable assets and the income test.';
        let cashflowDeficitNarrative = null;
        if (cashflowAfter < 0 && effProjections?.length > 0) {
            const y1 = effProjections[0];
            const drawdown = y1?.drawdownBreakdown || [];
            const firstSource = drawdown.length > 0 ? drawdown[0] : null;
            const firstLabel = firstSource?.label || '';
            const isBankOrTerm = firstLabel && !/account-based pension|abp|pension|share/i.test(firstLabel);
            if (isBankOrTerm) {
                let yearBankDepletes = null;
                let nextLabel = null;
                for(let i = 0; i < effProjections.length; i++){
                    const proj = effProjections[i];
                    let totalBank = 0;
                    (proj?.assets?.bankAccounts || []).forEach((acc)=>{
                        totalBank += $7911ccd6eced4ff4$var$n(acc.value);
                    });
                    if (totalBank < 1000 && yearBankDepletes === null) {
                        yearBankDepletes = proj.year ?? i + 1;
                        const bd = proj.drawdownBreakdown || [];
                        for (const item of bd){
                            const norm = (item.label || '').toLowerCase();
                            const amt = $7911ccd6eced4ff4$var$n(item.value);
                            if (amt > 0 && (norm.includes('account-based pension') || norm.includes('abp') || norm.includes('pension'))) {
                                nextLabel = item.label;
                                break;
                            }
                            if (amt > 0 && norm.includes('share')) {
                                nextLabel = item.label;
                                break;
                            }
                            if (amt > 0 && (norm.includes('term') || norm.includes('deposit'))) {
                                nextLabel = item.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                const bankOrFirstLabel = /bank|acc/i.test(firstLabel) && !/term deposit/i.test(firstLabel) ? 'bank account' : firstLabel;
                if (yearBankDepletes != null && nextLabel) cashflowDeficitNarrative = `This deficit will be funded from your ${firstLabel}. Your ${bankOrFirstLabel} will be depleted by year ${yearBankDepletes}, at which stage the deficit will be funded from your ${nextLabel}.`;
                else if (yearBankDepletes != null) cashflowDeficitNarrative = `This deficit will be funded from your ${firstLabel}. Your ${bankOrFirstLabel} will be depleted by year ${yearBankDepletes}. After this point, the deficit will be funded from your remaining liquid assets (account-based pensions, then shares).`;
                else cashflowDeficitNarrative = `This deficit will be funded from your ${firstLabel} throughout the projection period.`;
            } else if (firstSource) cashflowDeficitNarrative = `This deficit will be funded from your ${firstLabel}.`;
            else {
                const orderLabels = [];
                const types = [
                    'bankAccounts',
                    'termDeposits',
                    'accountBasedPensions',
                    'shares'
                ];
                const typeNames = {
                    bankAccounts: 'bank accounts',
                    termDeposits: 'term deposits',
                    accountBasedPensions: 'account-based pensions',
                    shares: 'shares'
                };
                types.forEach((t)=>{
                    const arr = factFind?.assets?.[t];
                    if (arr?.some((a)=>$7911ccd6eced4ff4$var$n(a.value) > 0)) orderLabels.push(typeNames[t] || t);
                });
                cashflowDeficitNarrative = orderLabels.length > 0 ? `This deficit will be funded from your liquid assets in the following order: ${orderLabels.join(', then ')}.` : `This deficit will be funded from your liquid assets (bank accounts, then account-based pensions, then shares).`;
            }
        }
        const cashflowBefore = initialFinancials?.cashFlow ?? 0; // Dashboard cashflow, before any village move
        // State-aware estate-timing note: the exit entitlement is usually only paid when the unit re-sells, and
        // each state/territory sets a different statutory backstop for when the operator must pay regardless.
        const rvStateRules = (0, $cb0d223b5401e577$export$432ee5f70f8b1031)(rvState);
        const estateTimingNote = rvStateRules.code ? `${rvStateRules.name}: ${rvStateRules.buyback.summary}` : "Exit-entitlement timeframes differ by state and territory \u2014 select your state on the Retirement Village overview to see the rule that applies to you.";
        const rentAssistance = (()=>{
            const bd = effProjections[0]?.financials?.cashFlowBreakdown || [];
            const item = bd.find((r)=>/rent assistance/i.test(r.label || ''));
            return item ? $7911ccd6eced4ff4$var$n(item.value) : 0;
        })();
        return {
            agePensionBefore: before,
            agePensionAfter: after,
            agePensionWhy: agePensionWhy,
            cashflowBefore: cashflowBefore,
            cashflowAfter: cashflowAfter,
            villageOngoingAnnual: summary.annualOngoing ?? 0,
            legacyEstimate: effLegacyEstimate,
            noVillageScenario: noVillageScenario,
            cashflowDeficitNarrative: cashflowDeficitNarrative,
            estateTimingNote: estateTimingNote,
            rentAssistance: rentAssistance
        };
    }, [
        initialFinancials,
        effProjections,
        noVillageScenario,
        summary.entryFee,
        summary.annualOngoing,
        hasHome,
        effFundFrom,
        effRentHome,
        effLegacyEstimate,
        factFind?.assets,
        rvState
    ]);
    // Build suggestions when in Suggestion-Engine mode. We paint the loader first (60ms yield) THEN run the
    // (synchronous, multi-projection) evaluation, and hold the loader to a minimum so it reads as real work —
    // the same pattern that fixed the Aged Care engine flash.
    const entryFeeForSe = villageInputs.entryFee;
    /**
   * The just-in-time "how would new money be invested?" gate. The answer is an INPUT to the
   * modelling — invest strategies price at it — so it is asked BEFORE the engine runs, not
   * disclosed after a ranking that would reshuffle on the answer. Shown only when this run would
   * actually invest money, only until the client answers (answering saves to the profile, so it
   * is asked at most once, ever, across every module), and always skippable — a skip runs at
   * Conservative and leaves the question available next time, which is a different provenance
   * from choosing Conservative.
   */ const [newMoneySkipped, setNewMoneySkipped] = (0, $acw62.useState)(false);
    const seRunWouldInvest = (0, $acw62.useMemo)(()=>{
        if (!(entryFeeForSe > 0)) return false;
        try {
            return (0, $6d7411748a56fc80$export$a8c959bf5420987a)(factFind, villageInputs).some((c)=>{
                const d = c.sellHomeDetails;
                return !!d && ((Number(d.purchaseShares) || 0) > 0 || (Number(d.downsizerContribution) || 0) > 0 || (Number(d.partnerDownsizerContribution) || 0) > 0);
            });
        } catch  {
            return false;
        }
    }, [
        factFind,
        villageInputs,
        entryFeeForSe
    ]);
    // The module's own questions ask this; "Not sure" there is an answer that records nothing, so once they are answered the
    // old one-question gate never shows (owner, 22 Oct 2026: it stood alone in place of the questions on a return visit).
    const needsNewMoneyAnswer = strategyMode === 'optimised' && seRunWouldInvest && !(0, $0f2c0a6799fe36da$export$848647f164f42923)(factFind) && !newMoneySkipped && factFind?.goals?.rvHomeRoute == null;
    const answerNewMoneyProfile = (id)=>{
        if (setFactFind) setFactFind((prev)=>({
                ...prev,
                goals: {
                    ...prev.goals || {},
                    newMoneyInvestmentProfile: id
                }
            }));
        else // No persistence route (shouldn't happen from the app shell) — run rather than trap the user.
        setNewMoneySkipped(true);
    };
    // The Transfer Balance Cap question, chained after the new-money one: only when this run would
    // COMMENCE a pension and a person's balances trip the $1.6m screen (transferBalanceCap.ts).
    // Skipping estimates cap usage from current pension balances — stated in the SOA assumptions —
    // and the engine splits any commencement at the cap either way.
    const [tbcSkipped, setTbcSkipped] = (0, $acw62.useState)(false);
    const seRunCommencesPension = (0, $acw62.useMemo)(()=>{
        if (!(entryFeeForSe > 0)) return false;
        try {
            return (0, $6d7411748a56fc80$export$a8c959bf5420987a)(factFind, villageInputs).some((c)=>c.sellHomeDetails?.commenceIncomeStream === true);
        } catch  {
            return false;
        }
    }, [
        factFind,
        villageInputs,
        entryFeeForSe
    ]);
    const tbcPersonNeedingAnswer = !tbcSkipped && seRunCommencesPension ? (0, $4f5a997f1c0139af$export$7bf826dbcbb0ddc)(factFind, 'client') ? 'client' : factFind?.adviceFor === 'couple' && (0, $4f5a997f1c0139af$export$7bf826dbcbb0ddc)(factFind, 'partner') ? 'partner' : null : null;
    const needsTbcAnswer = strategyMode === 'optimised' && tbcPersonNeedingAnswer !== null;
    const answerTbc = (amount)=>{
        if (setFactFind && tbcPersonNeedingAnswer) {
            const key = tbcPersonNeedingAnswer;
            setFactFind((prev)=>({
                    ...prev,
                    [key]: {
                        ...prev[key] || {},
                        transferBalanceUsed: amount
                    }
                }));
        } else setTbcSkipped(true);
    };
    (0, $acw62.useEffect)(()=>{
        if (strategyMode !== 'optimised') return undefined;
        if (rvSetupOpen || rvAsking) {
            setSeLoading(false);
            return undefined;
        }
        if (needsNewMoneyAnswer || needsTbcAnswer) {
            setSeLoading(false);
            return undefined;
        }
        if (!(entryFeeForSe > 0)) {
            setRvSuggestions(null);
            setSeLoading(false);
            return undefined;
        }
        setSeLoading(true);
        const startedAt = Date.now();
        const t = setTimeout(async ()=>{
            let result = null;
            try {
                result = await (0, $6d7411748a56fc80$export$9e49656695b3019f)(factFind, villageInputs, {
                    legacyYears: localLegacyYears,
                    villageEntryDate: effectiveVillageEntryDate || undefined,
                    annuityQuote: seAnnuityQuote,
                    setup: rvSetup
                });
            } catch  {
                result = null;
            }
            setRvSuggestions(result);
            const elapsed = Date.now() - startedAt;
            setTimeout(()=>setSeLoading(false), Math.max(0, 2200 - elapsed));
        }, 60);
        return ()=>clearTimeout(t);
    }, [
        strategyMode,
        factFind,
        villageInputs,
        localLegacyYears,
        entryFeeForSe,
        needsNewMoneyAnswer,
        needsTbcAnswer,
        rvSetup,
        rvSetupOpen,
        rvAsking,
        seAnnuityQuote
    ]);
    /**
   * "How does my plan compare?" for MANUAL control.
   *
   * The strongest protection against a client accepting a default and regretting it later is not a
   * warning, it is the alternative's number. Run on demand rather than automatically: the engine is
   * a real multi-projection evaluation, and a manual user who never asks should not pay for it on
   * every keystroke.
   */ const [manualComparison, setManualComparison] = (0, $acw62.useState)(null);
    const runManualComparison = async ()=>{
        setManualComparison({
            loading: true,
            best: null,
            ranAt: Date.now()
        });
        try {
            const result = await (0, $6d7411748a56fc80$export$9e49656695b3019f)(factFind, villageInputs, {
                legacyYears: localLegacyYears,
                villageEntryDate: effectiveVillageEntryDate || undefined,
                setup: rvSetup
            });
            const movers = (result?.strategies || []).filter((s)=>s.id !== 'rv-stay-home');
            const best = movers.length ? movers.reduce((top, s)=>(s.snapshot?.legacyValue ?? 0) > (top.snapshot?.legacyValue ?? 0) ? s : top, movers[0]) : null;
            setManualComparison({
                loading: false,
                best: best,
                ranAt: Date.now()
            });
        } catch  {
            setManualComparison({
                loading: false,
                best: null,
                ranAt: Date.now()
            });
        }
    };
    // A changed plan invalidates a previous comparison — better to re-offer it than to show a stale one.
    (0, $acw62.useEffect)(()=>{
        setManualComparison(null);
    }, [
        villageInputs,
        entryFeeFunding,
        fundFrom,
        localLegacyYears
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!pendingHubAction || seLoading || !rvSuggestions) return;
        const id = selectedSeId ?? rvChosenEngineId;
        const row = (rvSuggestions.strategies || []).find((x)=>x.id === id);
        setPendingHubAction(null);
        if (!row) return;
        if (pendingHubAction === 'explain') {
            setExplainSeId(row.id ?? null);
            setShowRvExplanation(true);
        } else generateRvSoa(row);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pendingHubAction,
        seLoading,
        rvSuggestions
    ]);
    const rvChosen = (0, $acw62.useMemo)(()=>(0, $accc76cd2fa8edd9$export$d11c0ebb38aa6e79)(savedStrategies), [
        savedStrategies
    ]);
    /*
   * A PLAN CHOSEN BEFORE 22 OCT 2026 KEPT NO "WHEN THE MONEY RUNS OUT" LINE (owner, 23 Oct 2026: fix it). Once the
   * plans have been tested again and the chosen one is among them, its line is worked out from that plan's own rows
   * and saved with the card, so the plan page shows it from then on. Only where the card has no line yet (undefined);
   * a card that saved null (no rows when chosen) is left as it is.
   */ (0, $acw62.useEffect)(()=>{
        const card = rvChosen?.inputs?.card;
        // Only a tested plan's card, from its own row: a hand-built card's line comes from its own rows when chosen.
        if (!rvChosen || !card || card.runLine !== undefined || !rvChosenEngineId || (0, $accc76cd2fa8edd9$export$5a65a0ca975061d)(rvChosen) !== rvChosenEngineId) return;
        const row = (rvSuggestions?.strategies || []).find((x)=>x.id === rvChosenEngineId);
        if (!row?.projections?.length) return;
        const line = (0, $2ddaae90639b5011$export$7526d1fcb4423629)({
            rows: row.projections,
            factFind: factFind,
            horizonYears: Number(card.horizonYears) || Number(localLegacyYears) || 10,
            spentOn: 'the entry payment'
        });
        const chosenId = rvChosen.id;
        if (chosenId == null) return;
        setSavedStrategies((prev)=>prev.map((x)=>x.id === chosenId ? {
                    ...x,
                    inputs: {
                        ...x.inputs || {},
                        card: {
                            ...x.inputs?.card || {},
                            runLine: line
                        }
                    }
                } : x));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        rvChosen,
        rvChosenEngineId,
        rvSuggestions
    ]);
    /*
   * THE CHOSEN PLAN'S FIGURES FOLLOW ITS RE-TEST (owner, 25 Oct 2026: as aged care and Support at home). When the
   * plans are tested again for the chosen unit over the same years, the chosen tested plan's figures are brought up
   * to date on its record (Home and the plan page read it), or, where the run no longer has it, it is marked out
   * of date. A plan for another unit, or over other years, is left as it is.
   */ (0, $acw62.useEffect)(()=>{
        if (!rvChosen || rvChosen.source !== 'suggestion_engine' || !rvSuggestions || seLoading) return;
        const ins = rvChosen.inputs || {};
        const unitNow = (0, $accc76cd2fa8edd9$export$a3fbef763ac12540)(String(factFind?.goals?.rvVillageName || ''), summary.entryFee);
        if (ins.unitKey !== unitNow || Number(ins.card?.horizonYears) !== (Number(localLegacyYears) || 10)) return;
        const row = (rvSuggestions.strategies || []).find((x)=>x.id === ins.engineStrategyId);
        const base = rvSuggestions.stayHome?.snapshot;
        const chosenId = rvChosen.id;
        setSavedStrategies((prev)=>{
            const next = row ? (0, $78a369bbf1e0d995$export$d5989af62c88c0aa)(prev, chosenId, {
                legacy: Number(row.snapshot?.legacyValue) || 0,
                pension: Number(row.snapshot?.pension) || 0,
                cashflow: Number(row.snapshot?.netCashflow) || 0
            }, base ? {
                legacy: Number(base.legacyValue) || 0,
                pension: Number(base.pension) || 0,
                cashflow: Number(base.netCashflow) || 0
            } : null, (0, $78a369bbf1e0d995$export$236630ee0fd3b65b)(factFind)) : (0, $78a369bbf1e0d995$export$91485c71ed77db22)(prev, chosenId, (0, $78a369bbf1e0d995$export$a2028cac13d6740f));
            return next ?? prev;
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        rvSuggestions,
        seLoading
    ]);
    const rvUnitPlans = (0, $acw62.useMemo)(()=>(0, $accc76cd2fa8edd9$export$48ec0984e7b656be)(savedStrategies), [
        savedStrategies
    ]);
    /*
   * From the plan page, the steps open on the CHOSEN unit (21 Oct 2026, caught live: after "Start a new model"
   * the contract on the file is empty, and "Change the contract" opened on $0). The chosen record carries
   * its contract and the card its village's name.
   */ const restoreChosenUnit = ()=>{
        const ins = rvChosen?.inputs;
        if (ins?.villageInputs && Number(ins.villageInputs.entryFee) > 0) setVillageInputs((prev)=>({
                ...prev,
                ...ins.villageInputs
            }));
        const name = ins?.card?.village.name;
        if (name != null) setFactFind?.((prev)=>({
                ...prev,
                goals: {
                    ...prev?.goals || {},
                    rvVillageName: name
                }
            }));
    };
    const openSteps = (to)=>{
        restoreChosenUnit();
        setRvView('steps');
        if (to === 3) setStrategyMode('optimised');
        goToStep(to);
    };
    /*
   * A NEW MODEL FROM SCRATCH, from the plan page (owner, 22 Oct 2026: every plan page has aged care's "Model
   * something else"). What Home's "Start a new model" does on opening (RV_START_FRESH_KEY), done in place: an
   * empty contract, the village and the answers taken off the file, step 3's questions asked again, step 1.
   * The chosen plan stays saved and chosen until another is chosen.
   */ const startFresh = ()=>{
        setAnotherUnit(false);
        setVillageInputs({
            ...$7911ccd6eced4ff4$var$RV_FRESH_VILLAGE_INPUTS
        });
        setFactFind?.((prev)=>{
            const g = {
                ...prev?.goals || {}
            };
            for (const k of $7911ccd6eced4ff4$var$RV_FRESH_GOAL_KEYS)delete g[k];
            return {
                ...prev,
                goals: g
            };
        });
        setManualStartedFrom(null);
        setRvAsking(true);
        setRvView('steps');
        goToStep(1);
    };
    // Nothing is selected for the reader (aged care's rule): a card is selected by choosing it. Cleared outside engine mode.
    (0, $acw62.useEffect)(()=>{
        if (strategyMode !== 'optimised' && selectedSeId !== null) setSelectedSeId(null);
    }, [
        strategyMode,
        selectedSeId
    ]);
    /**
   * "Select Strategy" on an engine card SAVES it, exactly as it does in Aged Care — the saved list
   * is what the Dashboard and the advice document read, and a selection that lived only on this
   * screen was lost on the next click. Recorded with its source and what the engine recommended.
   */ const selectEngineStrategy = (strategy)=>{
        // Income only waits for the client's dated confirmation for this amount (guaranteed income review E5).
        if ((0, $91a0ac81d8d23067$export$b263a858888cc4a2)(strategy, factFind)) return;
        setSelectedSeId(strategy.id ?? null);
        // Already chosen: nothing to save again (it used to add a duplicate on every click).
        if (selectedSeId != null && strategy.id === selectedSeId) return;
        const id = `rv-se-${Date.now()}`;
        const recommended = rvGoalLeaders.map((l)=>({
                labels: l.recommendationLabels || [],
                name: l.name
            }));
        const villageName = String(factFind?.goals?.rvVillageName || '').trim();
        const horizon = Number(localLegacyYears) || 10;
        const exitAtHorizon = (0, $a5e43ea76f631c99$export$92ec836666aacd49)(villageInputs, horizon);
        const baseSnap = rvSuggestions?.stayHome?.snapshot;
        const sInputs = strategy.inputs || {};
        const card = {
            plan: {
                legacy: Number(strategy.snapshot?.legacyValue) || 0,
                pension: Number(strategy.snapshot?.pension) || 0,
                cashflow: Number(strategy.snapshot?.netCashflow) || 0
            },
            baseline: baseSnap ? {
                legacy: Number(baseSnap.legacyValue) || 0,
                pension: Number(baseSnap.pension) || 0,
                cashflow: Number(baseSnap.netCashflow) || 0
            } : null,
            words: (0, $7175ce4c598409db$export$6078d665f40b52df)(strategy, factFind, summary.entryFee),
            village: {
                name: villageName,
                entryFee: summary.entryFee,
                annualOngoing: summary.annualOngoing,
                fees: Number(villageInputs.ongoingWeeklyOrMonthly) || 0,
                feesFrequency: villageInputs.ongoingFrequency,
                departureFee: exitAtHorizon.dmf,
                backAfter: exitAtHorizon.netToResident
            },
            horizonYears: horizon,
            riskKinds: (0, $203e38d6e6c434f4$export$c301be208b2d16d)(String(strategy.id || '')),
            rentNet: sInputs.rentHome ? Math.max(0, (Number(sInputs.rentDetails?.rentAmount) || 0) * 52 - (Number(sInputs.rentDetails?.rentExpenses) || 0)) : 0,
            origin: 'engine',
            family: (()=>{
                const compare = (0, $91a0ac81d8d23067$export$c241e21d61e3872b)(strategy, rvSuggestions?.strategies || []);
                return (0, $91a0ac81d8d23067$export$e9940ef619b461f8)((0, $91a0ac81d8d23067$export$32b560717abe61e8)(strategy, factFind), factFind, strategy.projections, compare ? {
                    rows: compare.row.projections,
                    note: compare.note
                } : null, horizon);
            })(),
            // The card's runway sentence and the plan's own risks, frozen with it for the plan page (22 Oct 2026).
            runLine: strategy.projections?.length ? (0, $2ddaae90639b5011$export$7526d1fcb4423629)({
                rows: strategy.projections,
                factFind: factFind,
                horizonYears: horizon,
                spentOn: 'the entry payment'
            }) : null,
            riskSpecifics: (0, $4852c06b0c4c15b4$export$7a83655e7acf7684)(strategy, factFind)
        };
        setSavedStrategies((prev)=>(0, $accc76cd2fa8edd9$export$75afc4671887f877)(prev, {
                id: id,
                name: strategy.name || 'Suggested village strategy',
                type: 'retirement_village',
                source: 'suggestion_engine',
                displayName: card.words.title,
                // The client's figures it was priced on, so Home can tell when they change (chosenPlanRefresh.ts).
                inputsFingerprint: (0, $78a369bbf1e0d995$export$236630ee0fd3b65b)(factFind),
                inputs: {
                    engineStrategyId: strategy.id ?? null,
                    card: card,
                    unitKey: (0, $accc76cd2fa8edd9$export$a3fbef763ac12540)(villageName, summary.entryFee),
                    legacyYears: horizon,
                    planContext: {
                        entryFee: summary.entryFee,
                        annualOngoing: summary.annualOngoing,
                        villageName: villageName
                    },
                    villageInputs: {
                        ...villageInputs
                    },
                    ...strategy.inputs || {},
                    recommendedOptimalStrategies: recommended,
                    clientSelectedIsAlternative: recommended.length > 0 && !recommended.some((r)=>r.name === strategy.name)
                },
                outputs: {
                    summary: summary,
                    entryFee: summary.entryFee,
                    annualOngoing: summary.annualOngoing,
                    agePension: strategy.snapshot?.pension ?? 0,
                    cashFlow: strategy.snapshot?.netCashflow ?? 0,
                    legacyEstimate: strategy.snapshot?.legacyValue ?? 0,
                    netWorthSchedule: (0, $a882fd27fa2c97d8$export$7386c6396507d94b)(strategy.projections || [])
                },
                createdAt: new Date().toISOString()
            }));
        setActiveSavedStrategyId(id);
    };
    if (rvView === 'hub' && rvChosen) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-[1520px] mx-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f295042478994e3b$export$2e2bcd8739ae039), {
                factFind: factFind,
                plan: rvChosen,
                unitCount: rvUnitPlans.length,
                entryDate: villageEntryDate || undefined,
                onChangeContract: ()=>openSteps(1),
                onAnotherUnit: ()=>{
                    setAnotherUnit(true);
                    openSteps(1);
                },
                onStartFresh: startFresh,
                onAllPlans: ()=>openSteps(3),
                onExplain: ()=>{
                    setPendingHubAction('explain');
                    openSteps(3);
                },
                onRisks: ()=>setRiskStrategy({
                        id: String(rvChosen.inputs?.engineStrategyId || ''),
                        name: rvChosen.inputs?.card?.words.title
                    }),
                onAdvice: ()=>{
                    setPendingHubAction('advice');
                    openSteps(3);
                },
                onBuild: ()=>{
                    restoreChosenUnit();
                    // A hand-built plan reopens with every lever it was built with; a tested one seeds the ledger.
                    if (rvChosen.source === 'manual') {
                        reopenStrategy(rvChosen);
                        // Its own record says where it began, if it was customised from a tested plan.
                        setManualStartedFrom(rvChosen.customisedFrom ?? null);
                    } else {
                        startBlankManualPlan();
                        const ins = rvChosen.inputs;
                        if (ins) seedManualFromEngineInputs(ins);
                        setManualStartedFrom(rvChosen.inputs?.card?.words.title ?? null);
                    }
                    setRvView('steps');
                    setStrategyMode('manual');
                    setShowStrategyOptions(true);
                    goToStep(3);
                },
                onBuildNew: ()=>{
                    restoreChosenUnit();
                    openRvBuild(null);
                    setRvView('steps');
                    goToStep(3);
                },
                outOfDate: (0, $78a369bbf1e0d995$export$ceccff7104f70d1e)(rvChosen, factFind),
                onGuide: onBack,
                onAssumptions: ()=>setActivePage('AssumptionsPage'),
                onHome: ()=>setActivePage('Dashboard')
            }),
            riskStrategy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5757b380cc124794$export$2e2bcd8739ae039), {
                voice: rvVoice,
                strategyName: rvChosen.inputs?.card?.words.title || '',
                onClose: ()=>setRiskStrategy(null),
                /* The same specifics the tested plan's panel passes (22 Oct 2026): frozen on the card when chosen; a
               card saved before then carries none, so the saved inputs give what they can (the stamp duty). */ risks: (0, $203e38d6e6c434f4$export$124603ee0434ece5)(rvChosen.inputs?.card?.riskKinds || [], rvChosen.inputs?.card?.riskSpecifics ?? {
                    horizonWarning: null,
                    stampDuty: (0, $4852c06b0c4c15b4$export$7a83655e7acf7684)({
                        inputs: rvChosen.inputs || {}
                    }, factFind).stampDuty
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-[1520px] mx-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] text-slate-500",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setActivePage('Dashboard'),
                        className: "underline decoration-dotted underline-offset-2 hover:text-slate-800",
                        children: "Home"
                    }),
                    " \u203A Retirement village \u203A ",
                    step === 1 ? 'The village' : step === 2 ? 'What it means' : 'Ways to fund the move'
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "mt-2 text-[32px] font-bold leading-tight tracking-tight text-brand-navy",
                "data-testid": "rv-title",
                children: rvVoice.you ? 'Your retirement village' : `A retirement village for ${rvVoice.names}`
            }),
            step === 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-1 text-[15px] text-slate-600",
                children: [
                    "Three short steps: the village and its contract, what moving would mean for ",
                    rvVoice.them,
                    ", and the ways to fund the move."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $724b7566e2d97e1f$export$2e2bcd8739ae039), {
                step: step,
                onStep: goToStep,
                steps: [
                    {
                        title: 'The village and its contract',
                        sub: villageInputs.entryFee > 0 ? `${String(factFind?.goals?.rvVillageName || 'The village')} \xb7 ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(villageInputs.entryFee)}` : 'From the disclosure statement'
                    },
                    {
                        title: `What it means for ${rvVoice.them}`,
                        sub: $7911ccd6eced4ff4$var$n(factFind?.home?.value) > 0 ? 'Staying put, in four numbers' : 'Renting on, in four numbers'
                    },
                    {
                        title: 'Ways to fund the move',
                        sub: 'Plans we tested, or build your own'
                    }
                ]
            }),
            step === 1 && anotherUnit && rvChosen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-6 rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700",
                "data-testid": "rv-another-unit-note",
                children: [
                    "Everything is carried over from the ",
                    rvChosen.inputs?.card?.village.name || 'chosen',
                    " plan. Change the contract figures and give this option a name; the first plan stays saved and chosen."
                ]
            }),
            step === 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-8",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7c01c2620d70182$export$2e2bcd8739ae039), {
                    factFind: factFind,
                    setFactFind: setFactFind,
                    villageInputs: villageInputs,
                    setVillageInputs: setVillageInputs,
                    villageEntryDate: villageEntryDate,
                    setVillageEntryDate: setVillageEntryDate,
                    villageEntryDateInPast: villageEntryDateInPast,
                    onNext: ()=>goToStep(2),
                    onReadGuide: onBack
                })
            }),
            step === 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-8",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c787e0b77f2f1be$export$2e2bcd8739ae039), {
                    factFind: factFind,
                    reserve: rvReserve,
                    todayFinancials: initialFinancials,
                    stayPutLegacy: manualBaselineLegacy,
                    runway: stayPutProjections.length ? (0, $0fe89e03b6df746e$export$464558962ff4a811)(stayPutProjections, Number(localLegacyYears) || 5) : null,
                    legacyYears: localLegacyYears,
                    villageInputs: villageInputs,
                    annualOngoing: summary.annualOngoing,
                    onLegacyYearsChange: setLocalLegacyYears,
                    onBack: ()=>goToStep(1),
                    onNext: ()=>goToStep(3),
                    onAssumptions: ()=>setActivePage('AssumptionsPage'),
                    onShowProjections: ()=>{
                        setProjectionsSource('stayPut');
                        setShowProjectionsModal(true);
                    }
                })
            }),
            step === 3 && strategyMode !== 'manual' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-8",
                children: rvAsking ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6dbbd81bf88b5930$export$2e2bcd8739ae039), {
                    factFind: factFind,
                    entryFee: entryFeeForSe,
                    firstRun: factFind?.goals?.rvHomeRoute == null,
                    onRun: (answers)=>{
                        const add = (0, $6dbbd81bf88b5930$export$c3fcad8c1047c5ef)(answers);
                        const updated = {
                            ...factFind,
                            goals: {
                                ...factFind?.goals || {},
                                ...add
                            }
                        };
                        setFactFind?.((prev)=>({
                                ...prev,
                                goals: {
                                    ...prev?.goals || {},
                                    ...add
                                }
                            }));
                        setRvSetup((0, $6d7411748a56fc80$export$65f94a7151daf91a)(updated, rvState));
                        setLocalLegacyYears(answers.years);
                        setRvSetupSeen(true);
                        setNewMoneySkipped(true);
                        setRvAsking(false);
                        setStrategyMode('optimised');
                        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
                    },
                    onBuildYourOwn: ()=>openRvBuild(null),
                    onChangeUnit: ()=>goToStep(1),
                    onCancel: factFind?.goals?.rvHomeRoute == null ? undefined : ()=>setRvAsking(false)
                }) : entryFeeForSe <= 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] text-slate-700",
                    children: [
                        "Enter the ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "entry payment"
                        }),
                        " and the ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "village fees"
                        }),
                        " on step 1, and we'll compare the ways to fund the move."
                    ]
                }) : needsNewMoneyAnswer ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a08e2ea281a6041$export$2e2bcd8739ae039), {
                        onAnswer: answerNewMoneyProfile,
                        onSkip: ()=>setNewMoneySkipped(true)
                    })
                }) : needsTbcAnswer ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $216ea083fe16cb8b$export$2e2bcd8739ae039), {
                        name: (tbcPersonNeedingAnswer === 'partner' ? factFind?.partner?.firstName : factFind?.client?.firstName) || 'this person',
                        onAnswer: answerTbc,
                        onSkip: ()=>setTbcSkipped(true)
                    })
                }) : seLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $81c96376e6bb9658$export$2e2bcd8739ae039), {
                    title: "Testing the ways to fund the move",
                    subtitle: "We're modelling each way of paying for the unit, and staying put, over the same years."
                }) : !rvSuggestions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-[14px] text-slate-600",
                    children: [
                        "We couldn't test the plans for this unit. ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "font-semibold text-brand-navy underline",
                            onClick: ()=>openRvBuild(null),
                            children: "Build a plan yourself"
                        }),
                        " instead."
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fff5f5b4635cb028$export$2e2bcd8739ae039), {
                    notices: (()=>{
                        const unitNow = (0, $accc76cd2fa8edd9$export$a3fbef763ac12540)(String(factFind?.goals?.rvVillageName || ''), summary.entryFee);
                        const chosenHere = rvChosen && rvChosen.inputs?.unitKey === unitNow && (rvSuggestions.strategies || []).some((x)=>x.id === (selectedSeId ?? rvChosenEngineId));
                        if (chosenHere && rvChosen?.inputs?.card) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 border-l-4 border-l-emerald-500 bg-white px-5 py-4 shadow-card",
                            "data-testid": "rv-chosen-banner",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-[26px] leading-none text-emerald-500",
                                    "aria-hidden": true,
                                    children: "\u2713"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "min-w-0 flex-1 text-[14px] leading-relaxed text-slate-700",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                            className: "text-slate-900",
                                            children: [
                                                rvVoice.you ? "You've" : `${rvVoice.Names} have`,
                                                " chosen \u201C",
                                                rvChosen.inputs.card.words.title,
                                                "\u201D",
                                                rvChosen.inputs.card.village.name ? ` for ${rvChosen.inputs.card.village.name}` : '',
                                                "."
                                            ]
                                        }),
                                        ' ',
                                        "It's saved with ",
                                        rvVoice.possessive,
                                        " file, with the village's contract figures. The next step is the advice document \u2014 and, before signing anything, independent legal advice on the village contract."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setRvView('hub'),
                                    className: "text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                    "data-testid": "rv-go-to-plan-page",
                                    children: "Go to the village plan"
                                })
                            ]
                        });
                        if (rvChosen?.inputs?.card && rvChosen.inputs.unitKey !== unitNow) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700",
                            "data-testid": "rv-other-unit-note",
                            children: [
                                "Re-tested for the ",
                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(summary.entryFee),
                                " unit. ",
                                rvVoice.Possessive,
                                " chosen plan is for ",
                                rvChosen.inputs.card.village.name ? `${rvChosen.inputs.card.village.name}, ` : '',
                                "the ",
                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(rvChosen.inputs.card.village.entryFee),
                                " unit, and stays chosen until ",
                                rvVoice.they,
                                " choose here."
                            ]
                        });
                        return null;
                    })(),
                    factFind: factFind,
                    strategies: rvSuggestions.strategies || [],
                    stayHome: rvSuggestions.stayHome ?? null,
                    recommended: rvRecommended,
                    setAside: rvSetAside,
                    villageInputs: villageInputs,
                    annualOngoing: summary.annualOngoing,
                    horizonYears: Number(localLegacyYears) || 10,
                    ownToday: Number(initialFinancials?.netWorth) || 0,
                    focus: optimisationFocus === 'all' ? 'legacy' : optimisationFocus,
                    onFocus: (f)=>setOptimisationFocus(f),
                    chosenId: selectedSeId ?? rvChosenEngineId,
                    onChoose: (row)=>selectEngineStrategy(row),
                    onIncomeOnly: (0, $5eae79c7e46ed27e$export$415ddf94c95c9134)(setFactFind),
                    onExplain: (row)=>{
                        setExplainSeId(row.id ?? null);
                        setShowRvExplanation(true);
                    },
                    onRisks: (row)=>setRiskStrategy(row),
                    renderDetail: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4852c06b0c4c15b4$export$2e2bcd8739ae039), {
                            detailOnly: true,
                            strategy: row,
                            factFind: factFind,
                            badges: [],
                            baseline: rvSuggestions?.stayHome ?? null,
                            entryFee: summary.entryFee,
                            legacyYears: localLegacyYears,
                            clientName: factFind?.client?.firstName || 'you',
                            partnerName: factFind?.partner?.firstName || 'your partner',
                            isSelected: false,
                            goalNote: coveredNoteFor(row),
                            onSelect: ()=>selectEngineStrategy(row),
                            onExplain: ()=>{
                                setExplainSeId(row.id ?? null);
                                setShowRvExplanation(true);
                            },
                            onRisks: ()=>setRiskStrategy(row),
                            alternative: (0, $835055d548f621e0$export$8096a1e5a8250ea8)(row, rvSuggestions?.strategies || [], (s)=>s.snapshot?.legacyValue ?? null, Number(localLegacyYears) || 5),
                            annuityBlock: (row.annuityIncome ?? 0) > 0 ? (()=>{
                                const gi = (0, $91a0ac81d8d23067$export$32b560717abe61e8)(row, factFind);
                                const quotedHere = !!gi && (0, $da24031d156d6acb$export$2ee327201b9e82a1)(seAnnuityQuote, gi.annuityType, gi.residualPercent, gi.amount) != null;
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-3 rounded-lg border border-slate-200 border-l-4 border-l-blue-500 bg-white p-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-[13px] font-semibold text-slate-700",
                                            children: [
                                                "Guaranteed income for life ",
                                                quotedHere ? '(your quote)' : '(our estimate)',
                                                ": ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "text-brand-navy",
                                                    children: [
                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.annuityIncome),
                                                        " a year"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6421482343679f4$export$d05c00195a7db941), {
                                            className: "mt-2",
                                            terms: row.annuityTerms,
                                            factFind: factFind
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6421482343679f4$export$624bbc9c6c5928), {
                                            draft: seAnnuityQuoteDraft,
                                            onDraft: (next)=>setSeAnnuityQuoteDraft(next === '' ? '' : Number(next)),
                                            committed: seAnnuityQuote?.income ?? null,
                                            scope: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    "Have a quote from a provider for this guaranteed income? Enter the yearly income they offered for ",
                                                    gi ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(gi.amount) : 'this amount',
                                                    ". Plans with the same type are re-compared on it, scaled to their amount; other types keep our estimate."
                                                ]
                                            }),
                                            onCommit: (next)=>{
                                                // The quote is for THIS plan's type and amount; plans of the same type use it scaled to theirs.
                                                setSeAnnuityQuote(next != null && gi ? {
                                                    income: next,
                                                    amount: gi.amount,
                                                    shape: (0, $da24031d156d6acb$export$f7e5360546f2cc73)(gi.annuityType, gi.residualPercent)
                                                } : null);
                                                if (next == null) setSeAnnuityQuoteDraft('');
                                            }
                                        }),
                                        (0, $da24031d156d6acb$export$3c59a0c7e65b683b)(seAnnuityQuote, (0, $f94e45ac645ae232$export$3dc27271f5d5c629)) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "mt-2 text-[12px] text-slate-600",
                                            "data-testid": "rv-quote-note",
                                            children: (0, $da24031d156d6acb$export$3c59a0c7e65b683b)(seAnnuityQuote, (0, $f94e45ac645ae232$export$3dc27271f5d5c629))
                                        })
                                    ]
                                });
                            })() : undefined
                        }),
                    onAllWays: ()=>setShowAllSeStrategies(true),
                    onChanges: ()=>{
                        setRvAsking(true);
                        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
                    },
                    onBuildYourOwn: (row)=>openRvBuild(row ?? null),
                    onAdvice: ()=>{
                        const chosen = (rvSuggestions.strategies || []).find((x)=>x.id === (selectedSeId ?? rvChosenEngineId));
                        if (chosen) generateRvSoa(chosen);
                    },
                    onChangeDecided: ()=>goToStep(1)
                })
            }),
            step === 3 && strategyMode === 'manual' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-8 space-y-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c67b656ca11544c$export$2e2bcd8739ae039), {
                    factFind: factFind,
                    setFactFind: setFactFind,
                    debtCard: (0, $35f2741dc40fa45c$export$403bb596c20e48)(factFind).length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35f2741dc40fa45c$export$2e2bcd8739ae039), {
                        variant: "section",
                        heading: "3 \xb7 Debts",
                        factFind: factFind,
                        debtPayments: debtPayments,
                        setDebtPayments: setDebtPayments,
                        debtFunding: debtFunding,
                        setDebtFunding: setDebtFunding,
                        repaymentBasis: debtRepaymentBasis,
                        setRepaymentBasis: setDebtRepaymentBasis,
                        competingUseNote: "The money comes from the same assets that can fund the village entry payment, so what is spent here reduces what is left for it.",
                        reservedByAsset: reservedForEntryFee,
                        reservedFor: "the village entry payment"
                    }) : undefined,
                    villageName: String(factFind?.goals?.rvVillageName || ''),
                    entryFee: summary.entryFee,
                    reserve: rvReserve,
                    horizonYears: Number(localLegacyYears) || 10,
                    startedFrom: manualStartedFrom,
                    onClear: ()=>openRvBuild(null),
                    startOptions: [
                        ...rvGoalLeaders.slice(0, 3).map((l)=>({
                                id: String(l.id),
                                label: (0, $7175ce4c598409db$export$6078d665f40b52df)(l, factFind, summary.entryFee).title
                            })),
                        {
                            id: 'blank',
                            label: 'A blank plan'
                        }
                    ],
                    onStartFrom: (id)=>{
                        if (id === 'blank') openRvBuild(null);
                        else openRvBuild((rvSuggestions?.strategies || []).find((x)=>String(x.id) === id) ?? null);
                    },
                    route: rvOverallStrategy.downsizeHome ? 'sell' : rvOverallStrategy.rentHome ? 'rent' : 'keep',
                    onRoute: (r)=>{
                        setRvOverallStrategy((prev)=>({
                                ...prev,
                                downsizeHome: r === 'sell',
                                rentHome: r === 'rent',
                                sellInvestmentProperty: r === 'sell' ? false : prev.sellInvestmentProperty
                            }));
                        // A new route starts from our draw for it: selling, the sale pays and savings stay put. And what was
                        // placed starts again, so a sale's amounts are never quietly drawn from savings.
                        setEntryFeeFunding({});
                        setSellHomeDetails((prev)=>({
                                ...prev,
                                downsizerContribution: 0,
                                partnerDownsizerContribution: 0,
                                commenceIncomeStream: false,
                                giftingAmount: 0,
                                funeralBondPurchase: 0,
                                purchaseAnnuity: 0,
                                purchaseInvestmentProperty: 0,
                                investmentPropertyStampDuty: 0,
                                purchaseShares: 0
                            }));
                        if (r === 'rent') syncRentFromAnswers();
                        noteManualChange(r === 'sell' ? 'The home is sold' : r === 'rent' ? 'The home is kept and rented out' : 'The home is kept, not rented');
                    },
                    rent: manualRent,
                    onRent: (patch)=>{
                        const next = {
                            ...manualRent,
                            ...patch
                        };
                        setFactFind?.((prev)=>({
                                ...prev,
                                goals: {
                                    ...prev?.goals || {},
                                    rvRentPerWeek: next.weekly,
                                    rvRentCosts: next.costs,
                                    rvVacancyWeeks: next.vacancy
                                }
                            }));
                        setRentDetails((prev)=>({
                                ...prev,
                                rentAmount: (0, $6d7411748a56fc80$export$f18276a1042657ae)(next.weekly, next.vacancy),
                                rentExpenses: next.costs
                            }));
                        noteManualChange(`The rent ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(next.weekly)} a week, ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(next.costs)} a year of costs, ${next.vacancy} weeks empty`);
                    },
                    funding: effectiveEntryFeeFunding,
                    onFunding: (key, amount)=>{
                        setEntryFeeFunding((prev)=>({
                                ...prev,
                                [key]: amount
                            }));
                        noteManualChange(`${key.replace(/^[a-zA-Z]+-/, 'An account ')} \u{2192} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(amount)} towards the entry payment`);
                    },
                    ipSoldId: rvOverallStrategy.sellInvestmentProperty ? String(rvInvestmentPropertyDetails.selectedPropertyId ?? '') : null,
                    ipNetFromSale: fundFrom === 'investment_property' ? propertyTowardEntry : 0,
                    onIpSell: (id)=>{
                        setRvOverallStrategy((prev)=>({
                                ...prev,
                                sellInvestmentProperty: !!id,
                                downsizeHome: id ? false : prev.downsizeHome
                            }));
                        if (id) setRvInvestmentPropertyDetails((prev)=>({
                                ...prev,
                                selectedPropertyId: id,
                                entryFeeAllocation: villageInputs.entryFee
                            }));
                        noteManualChange(id ? 'An investment property is sold for the entry payment' : 'The investment property is kept');
                    },
                    details: sellHomeDetails,
                    onDetails: (patch, words)=>{
                        setSellHomeDetails((prev)=>({
                                ...prev,
                                ...patch
                            }));
                        if (words) noteManualChange(words);
                    },
                    other: {
                        giftingAmount: $7911ccd6eced4ff4$var$n(otherStrategies.giftingAmount),
                        funeralBondAmount: $7911ccd6eced4ff4$var$n(otherStrategies.funeralBondAmount)
                    },
                    onOther: (patch, words)=>{
                        setOtherStrategies((prev)=>{
                            const next = {
                                ...prev,
                                ...patch
                            };
                            return {
                                ...next,
                                gifting: $7911ccd6eced4ff4$var$n(next.giftingAmount) > 0,
                                funeralBonds: $7911ccd6eced4ff4$var$n(next.funeralBondAmount) > 0
                            };
                        });
                        if (words) noteManualChange(words);
                    },
                    working: rvCalcWorking,
                    effect: {
                        cashflow: projections.length ? $7911ccd6eced4ff4$var$n(projections[0]?.netCashflow) : null,
                        baseCashflow: initialFinancials ? $7911ccd6eced4ff4$var$n(initialFinancials.cashFlow) : null,
                        pension: simulatedFinancials ? $7911ccd6eced4ff4$var$n(simulatedFinancials.socialSecurity) : null,
                        basePension: initialFinancials ? $7911ccd6eced4ff4$var$n(initialFinancials.socialSecurity) : null,
                        legacy: projections.length ? legacyEstimateDisplay : null,
                        baseLegacy: manualBaselineLegacy ?? null
                    },
                    lastChange: manualLastChange,
                    onExplain: ()=>{
                        setExplainSeId(null);
                        setShowRvExplanation(true);
                    },
                    onRisks: ()=>setRiskStrategy({
                            ...manualAsCandidate(),
                            __kinds: manualRiskKinds()
                        }),
                    onChoose: chooseManualPlan,
                    chosen: manualChosen,
                    onBackToPlans: ()=>{
                        setStrategyMode('optimised');
                        setShowStrategyOptions(false);
                        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
                    },
                    reservedByAsset: reservedForDebt,
                    rawFunding: entryFeeFunding,
                    onYearByYear: ()=>{
                        setProjectionsSource('plan');
                        setShowProjectionsModal(true);
                    },
                    planRows: projections,
                    comparison: strategyMode === 'manual' && summary.entryFee > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-3 border-t border-slate-200 pt-2 text-[13px] text-slate-700",
                        "data-testid": "rv-build-compare",
                        children: !manualComparison ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: runManualComparison,
                            className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                            children: "Compare with the strongest option"
                        }) : manualComparison.loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-slate-500",
                            children: "Testing the ways to fund it\u2026"
                        }) : manualComparison.best ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "The way of moving that leaves the most, ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: (0, $7175ce4c598409db$export$6078d665f40b52df)(manualComparison.best, factFind, summary.entryFee).title.replace(/^./, (c)=>c.toLowerCase())
                                }),
                                ", leaves ",
                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round($7911ccd6eced4ff4$var$n(manualComparison.best.snapshot?.legacyValue))),
                                " after about ",
                                Number(localLegacyYears) || 10,
                                " years",
                                projections.length ? `, against ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round($7911ccd6eced4ff4$var$n(legacyEstimateDisplay)))} for this plan` : '',
                                ". That doesn't make it right for you \u2014 it's a comparison, not a switch."
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-slate-500",
                            children: "No other way of funding this unit could be tested."
                        })
                    })
                })
            }),
            showAllSeStrategies && rvSuggestions && (()=>{
                const rows = rvSuggestions.strategies || [];
                const stay = rows.find((s)=>s.id === 'rv-stay-home') || null;
                const pick = (s)=>allSortBy === 'cashflow' ? s.snapshot?.netCashflow ?? 0 : allSortBy === 'pension' ? s.snapshot?.pension ?? 0 : s.snapshot?.legacyValue ?? 0;
                const sorted = rows.filter((s)=>s.id !== 'rv-stay-home').sort((a, b)=>pick(b) - pick(a));
                const diff = (n, base)=>base == null ? null : n - base;
                const signed = (d)=>d == null || Math.round(d) === 0 ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: `block text-[12px] ${d < 0 ? 'text-rose-700' : 'text-emerald-700'}`,
                        children: [
                            d < 0 ? "\u2212" : '+',
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(d)))
                        ]
                    });
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                    titleId: "rv-all-ways-title",
                    title: `Every way we tested, ${sorted.length}`,
                    eyebrow: `Against staying put, over about ${localLegacyYears} years`,
                    onClose: ()=>setShowAllSeStrategies(false),
                    size: "xl",
                    testId: "rv-all-ways-dialog",
                    flush: true,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap items-center justify-between gap-3 border-b border-slate-100 px-5 py-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-[14px] text-slate-700",
                                    children: [
                                        "These are all the ways of paying for the unit we worked through for ",
                                        rvVoice.them,
                                        ". The plans ",
                                        rvVoice.you ? 'you were shown' : `${rvVoice.names} ${rvVoice.are === 'is' ? 'was' : 'were'} shown`,
                                        " are the ones that do best on ",
                                        rvVoice.their,
                                        " goals."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "flex items-center gap-2 text-[13px] text-slate-600",
                                    children: [
                                        "Order by",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: allSortBy,
                                            onChange: (e)=>setAllSortBy(e.target.value),
                                            className: "rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-[13px]",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "legacy",
                                                    children: "Left to the family"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "cashflow",
                                                    children: "Left over each year"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "pension",
                                                    children: "Age Pension"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "overflow-x-auto",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                className: "min-w-full text-[14px]",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "border-b border-slate-200 text-left text-[12px] font-semibold text-slate-500",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3",
                                                    children: "The plan"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3 text-right",
                                                    children: "Left to the family"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3 text-right",
                                                    children: "Age Pension, a year"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3 text-right",
                                                    children: "Left over, first year"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        className: "tabular-nums",
                                        children: [
                                            stay && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100 bg-slate-50",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "px-5 py-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-semibold text-slate-900",
                                                                children: "Staying put"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "mt-0.5 text-[12.5px] text-slate-500",
                                                                children: "What every plan is measured against."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(stay.snapshot?.legacyValue)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(stay.snapshot?.pension)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: (stay.snapshot?.netCashflow ?? 0) < 0 ? `short ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(-(stay.snapshot?.netCashflow ?? 0))}` : (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(stay.snapshot?.netCashflow)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3"
                                                    })
                                                ]
                                            }),
                                            sorted.map((s)=>{
                                                const isSelected = s.id === selectedSeId;
                                                const w = (0, $7175ce4c598409db$export$6078d665f40b52df)(s, factFind, summary.entryFee);
                                                const cash = s.snapshot?.netCashflow ?? 0;
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    className: `border-b border-slate-100 ${isSelected ? 'bg-blue-50/60' : ''}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "px-5 py-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "font-semibold text-slate-900",
                                                                    children: w.title
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "mt-0.5 max-w-xl text-[12.5px] text-slate-500",
                                                                    children: w.sub
                                                                }),
                                                                (()=>{
                                                                    // Income only: the confirmation before it can be chosen, here as on the card (E5).
                                                                    const gi = (0, $91a0ac81d8d23067$export$32b560717abe61e8)(s, factFind);
                                                                    const setter = (0, $5eae79c7e46ed27e$export$415ddf94c95c9134)(setFactFind);
                                                                    return gi && gi.kind === 'incomeOnly' && setter && !isSelected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "mt-2 max-w-xl",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$4538b371a206da0c), {
                                                                            factFind: factFind,
                                                                            amount: gi.amount,
                                                                            onChange: setter
                                                                        })
                                                                    }) : null;
                                                                })()
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "px-5 py-3 text-right font-semibold",
                                                            children: [
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(s.snapshot?.legacyValue),
                                                                signed(diff(s.snapshot?.legacyValue ?? 0, stay?.snapshot?.legacyValue))
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "px-5 py-3 text-right",
                                                            children: [
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(s.snapshot?.pension),
                                                                signed(diff(s.snapshot?.pension ?? 0, stay?.snapshot?.pension))
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: `px-5 py-3 text-right ${cash < 0 ? 'text-rose-700' : ''}`,
                                                            children: cash < 0 ? `short ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(-cash)}` : (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(cash)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "whitespace-nowrap px-5 py-3 text-right",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "inline-flex gap-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                                                        variant: isSelected ? 'secondary' : 'brand',
                                                                        size: "sm",
                                                                        disabled: !isSelected && (0, $91a0ac81d8d23067$export$b263a858888cc4a2)(s, factFind),
                                                                        onClick: ()=>{
                                                                            selectEngineStrategy(s);
                                                                            setShowAllSeStrategies(false);
                                                                        },
                                                                        children: isSelected ? 'Chosen' : 'Choose this plan'
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                                                        variant: "secondary",
                                                                        size: "sm",
                                                                        onClick: ()=>{
                                                                            setSeDeepDive({
                                                                                projections: s.projections || [],
                                                                                name: w.title
                                                                            });
                                                                            setShowAllSeStrategies(false);
                                                                        },
                                                                        children: "Year by year"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }, s.id || s.name);
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                });
            })(),
            showRvExplanation && (()=>{
                const tested = usingSe && !!selectedStrategy;
                const row = tested ? selectedStrategy : manualAsCandidate();
                const words = tested ? (0, $7175ce4c598409db$export$6078d665f40b52df)(row, factFind, summary.entryFee) : manualPlanWords();
                const rows = (tested ? selectedStrategy?.projections : projections) || [];
                const horizon = Number(localLegacyYears) || 5;
                const stayRow = rvSuggestions?.stayHome ?? null;
                const decided = factFind?.goals?.rvDecided === 'decided';
                const movers = (rvSuggestions?.strategies || []).filter((s)=>s.id !== 'rv-stay-home' && !s.inputs?.stayHome);
                const bestMover = movers.length ? movers.reduce((top, s)=>$7911ccd6eced4ff4$var$n(s.snapshot?.legacyValue) > $7911ccd6eced4ff4$var$n(top.snapshot?.legacyValue) ? s : top, movers[0]) : null;
                const stayPut = tested ? stayRow?.snapshot ? {
                    legacy: $7911ccd6eced4ff4$var$n(stayRow.snapshot.legacyValue),
                    pension: $7911ccd6eced4ff4$var$n(stayRow.snapshot.pension),
                    cashflow: $7911ccd6eced4ff4$var$n(stayRow.snapshot.netCashflow),
                    investmentIncome: (0, $12ed609b340a4036$export$279780a48d38fdab)(stayRow.projections, false)
                } : null : initialFinancials ? {
                    legacy: $7911ccd6eced4ff4$var$n(manualBaselineLegacy),
                    pension: $7911ccd6eced4ff4$var$n(initialFinancials.socialSecurity),
                    cashflow: $7911ccd6eced4ff4$var$n(initialFinancials.cashFlow),
                    investmentIncome: (0, $12ed609b340a4036$export$279780a48d38fdab)(stayPutProjections, false)
                } : null;
                const plan = tested ? {
                    legacy: $7911ccd6eced4ff4$var$n(row.snapshot?.legacyValue),
                    pension: $7911ccd6eced4ff4$var$n(row.snapshot?.pension),
                    cashflow: $7911ccd6eced4ff4$var$n(row.snapshot?.netCashflow),
                    investmentIncome: (0, $12ed609b340a4036$export$279780a48d38fdab)(rows)
                } : {
                    legacy: $7911ccd6eced4ff4$var$n(legacyEstimateDisplay),
                    pension: $7911ccd6eced4ff4$var$n(simulatedFinancials?.socialSecurity),
                    cashflow: $7911ccd6eced4ff4$var$n(projections[0]?.netCashflow),
                    investmentIncome: (0, $12ed609b340a4036$export$279780a48d38fdab)(rows)
                };
                const benchmark = decided && bestMover ? {
                    legacy: $7911ccd6eced4ff4$var$n(bestMover.snapshot?.legacyValue),
                    word: 'the best way to move'
                } : stayPut ? {
                    legacy: stayPut.legacy,
                    word: 'staying put'
                } : null;
                const inputs = row.inputs || {};
                const rent = tested ? inputs.rentDetails : effRentHome ? rentDetails : null;
                const sale = (tested ? inputs.sellHomeDetails : effDownsizeHome ? sellHomeDetails : null) ?? null;
                const exitAtHorizon = (0, $a5e43ea76f631c99$export$92ec836666aacd49)(villageInputs, horizon);
                const story = (0, $0fe89e03b6df746e$export$693cc3146baa3244)(rows).hasDeficit ? (0, $2ddaae90639b5011$export$bdea18f456fd84b)({
                    rows: rows,
                    factFind: factFind,
                    runway: (0, $0fe89e03b6df746e$export$464558962ff4a811)(rows, rows.length),
                    deposit: {
                        paid: 0,
                        refundTo: ''
                    },
                    horizonYears: horizon,
                    enteringName: factFind?.client?.firstName || 'The household',
                    spentOn: 'the entry payment'
                }) : null;
                // A guaranteed income: what the family receives if death comes early, against the same sale invested (E4).
                const gi = (0, $91a0ac81d8d23067$export$32b560717abe61e8)(tested ? row : {
                    inputs: {
                        sellHomeDetails: sale
                    }
                }, factFind);
                const compare = gi && tested ? (0, $91a0ac81d8d23067$export$c241e21d61e3872b)(row, rvSuggestions?.strategies || []) : null;
                const close = ()=>{
                    setShowRvExplanation(false);
                    setExplainSeId(null);
                };
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $12084f898a868747$export$2e2bcd8739ae039), {
                    eyebrow: "Explain this",
                    title: words.title,
                    intro: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "Each line says what ",
                            rvVoice.you ? 'you do' : `${rvVoice.names} do${rvVoice.s ? 'es' : ''}`,
                            ', and what that does to the numbers. "Staying put" means keeping the home and not moving.',
                            decided && bestMover ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    " As ",
                                    rvVoice.you ? 'you have' : `${rvVoice.names} ${rvVoice.have}`,
                                    " decided to move, what the family is left is set against the best way to move."
                                ]
                            }) : null
                        ]
                    }),
                    onClose: close,
                    footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        size: "sm",
                        onClick: ()=>{
                            close();
                            if (tested) setSeDeepDive({
                                projections: rows,
                                name: words.title
                            });
                            else {
                                setProjectionsSource('plan');
                                setShowProjectionsModal(true);
                            }
                        },
                        children: "See the year-by-year figures"
                    }),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $12ed609b340a4036$export$2e2bcd8739ae039), {
                        voice: rvVoice,
                        sub: words.sub,
                        fundFrom: String(tested ? inputs.fundFrom || 'liquid' : effFundFrom),
                        rentHome: effRentHome,
                        hasHome: hasHome,
                        homeValue: $7911ccd6eced4ff4$var$n(factFind?.home?.value),
                        entryFee: summary.entryFee,
                        salePrice: $7911ccd6eced4ff4$var$n(sale?.salePrice),
                        rentWeekly: $7911ccd6eced4ff4$var$n(rent?.rentAmount),
                        rentCosts: $7911ccd6eced4ff4$var$n(rent?.rentExpenses),
                        shortfall: tested ? 0 : entryFeeShortfall,
                        nilAnnuity: nilResidualAnnuityForRecap,
                        villageFeesAYear: summary.annualOngoing,
                        departureFee: exitAtHorizon.dmf,
                        backAfter: exitAtHorizon.netToResident,
                        rentAssistance: rvInsightFinancials.rentAssistance,
                        plan: plan,
                        stayPut: stayPut,
                        benchmark: benchmark,
                        horizonYears: horizon,
                        moneyStory: story ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ddaae90639b5011$export$1a915263dc5391f1), {
                            story: story,
                            testId: "rv-money-story"
                        }) : null,
                        leverKinds: tested ? (0, $203e38d6e6c434f4$export$c301be208b2d16d)(String(row.id || '')) : manualRiskKinds(),
                        children: [
                            gi && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-5",
                                "data-testid": "rv-recap-family-panel",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
                                    factFind: factFind,
                                    personName: gi.personName,
                                    amount: gi.amount,
                                    kind: gi.kind,
                                    incomeAYear: gi.incomeAYear,
                                    rows: rows,
                                    compareRows: compare?.row.projections ?? null,
                                    compareNote: compare?.note ?? null,
                                    horizonYears: horizon,
                                    testId: "rv-recap-annuity-family-panel"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1f2b2692daf0da1$export$d520641036c1ebe9), {
                                className: "mt-5",
                                pieces: (0, $b09eddbdc2b9438e$export$23826e09bab3c866)({
                                    fundFrom: effFundFrom,
                                    rentHome: effRentHome,
                                    entryFee: summary.entryFee,
                                    allocations: sale,
                                    clientName: factFind?.client?.firstName || 'you',
                                    partnerName: factFind?.partner?.firstName || 'your partner',
                                    nilResidualAnnuity: !!nilResidualAnnuityForRecap
                                })
                            }),
                            (()=>{
                                // The debts this plan keeps, and what the same plan with them paid off did ("<id>-clear-debt").
                                const fig = (p)=>({
                                        estate: Number(p?.snapshot?.legacyValue) || 0,
                                        pension: Number(p?.snapshot?.pension) || 0,
                                        cashflow: Number(p?.snapshot?.netCashflow) || 0
                                    });
                                const twin = tested ? (rvSuggestions?.strategies || []).find((s)=>s.id === `${row.id}-clear-debt`) ?? null : null;
                                const cleared = tested ? /-clear-debt$/.test(String(row.id)) ? (0, $fe4e1ee5e30419ba$export$abbf1dec1caebd5a)(factFind) : 0 : Object.values(debtPayoffPlan?.payments || {}).reduce((t, x)=>t + (Number(x) || 0), 0);
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe4e1ee5e30419ba$export$2e2bcd8739ae039), {
                                    factFind: factFind,
                                    clearedAmount: cleared,
                                    plan: tested ? fig(row) : null,
                                    twin: twin ? fig(twin) : null,
                                    years: horizon,
                                    context: tested ? 'tested' : 'manual'
                                });
                            })(),
                            effRentHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a8295193c5be8a0$export$2e2bcd8739ae039), {
                                horizonYears: Number(localLegacyYears) || 5,
                                they: (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind).they
                            }),
                            (0, $5fe2dfde2f334213$export$4abd1e21404204e)(words.sub) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd95277538ec3233$export$2e2bcd8739ae039), {
                                factFind: factFind
                            })
                        ]
                    })
                });
            })(),
            showProjectionsModal && projectionsSource === 'stayPut' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9847d752f8df838f$export$2e2bcd8739ae039), {
                onClose: ()=>{
                    setShowProjectionsModal(false);
                    setProjectionsSource('plan');
                },
                title: factFind?.home?.value ? "Staying put \u2014 nothing changed" : "Keep renting \u2014 nothing changed",
                comparedOverYears: Number(localLegacyYears) || undefined,
                projections: stayPutProjections,
                factFind: factFind,
                initialFinancials: initialFinancials,
                costLabel: "Village Fees",
                costSource: "village"
            }),
            showProjectionsModal && projectionsSource === 'plan' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9847d752f8df838f$export$2e2bcd8739ae039), {
                onClose: ()=>setShowProjectionsModal(false),
                title: strategyMode === 'manual' ? manualPlanWords().title : undefined,
                comparedOverYears: Number(localLegacyYears) || undefined,
                projections: modalPeriodMode === 'calendar_year' && calendarYearProjections ? calendarYearProjections : projectionsForModal,
                onPeriodModeChange: setModalPeriodMode,
                isReloading: modalPeriodMode === 'calendar_year' && !calendarYearProjections,
                factFind: factFind,
                initialFinancials: initialFinancials,
                costLabel: "Village Fees",
                costSource: "village"
            }),
            riskStrategy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5757b380cc124794$export$2e2bcd8739ae039), {
                voice: rvVoice,
                strategyName: (0, $7175ce4c598409db$export$6078d665f40b52df)(riskStrategy, factFind, summary.entryFee).title,
                onClose: ()=>setRiskStrategy(null),
                risks: (0, $203e38d6e6c434f4$export$124603ee0434ece5)(riskStrategy.__kinds ?? (0, $203e38d6e6c434f4$export$c301be208b2d16d)(String(riskStrategy.id || '')), // The hand-built plan's own annuity and duty; a tested plan's from its row (rvRiskSpecificsOf).
                riskStrategy.id === 'rv-manual' ? manualRiskSpecifics() : (0, $4852c06b0c4c15b4$export$7a83655e7acf7684)(riskStrategy, factFind))
            }),
            seDeepDive && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9847d752f8df838f$export$2e2bcd8739ae039), {
                onClose: ()=>setSeDeepDive(null),
                title: seDeepDive.name,
                comparedOverYears: Number(localLegacyYears) || undefined,
                projections: seDeepDive.projections,
                factFind: factFind,
                initialFinancials: initialFinancials,
                costLabel: "Village Fees",
                costSource: "village"
            }),
            showCompareModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "bg-white rounded-2xl shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-hidden flex flex-col border border-slate-200/80",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "px-6 pt-6 pb-4 border-b border-slate-100 bg-slate-50",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-start justify-between gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                className: "text-2xl md:text-3xl font-bold tracking-tight",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6288781efbc92679$export$2e2bcd8739ae039), {
                                                    children: "Strategy Comparison"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-slate-600 mt-1.5",
                                                children: "Side-by-side view of saved retirement village strategies."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setShowCompareModal(false),
                                        className: "shrink-0 rounded-lg p-2 text-slate-500 hover:text-slate-800 hover:bg-slate-100 transition-colors text-2xl leading-none",
                                        "aria-label": "Close",
                                        children: "\xd7"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "overflow-auto flex-1 px-6 py-5",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "rounded-xl border border-slate-200 overflow-hidden shadow-sm",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    className: "w-full text-sm border-collapse",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "bg-slate-100 text-slate-800",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-4 py-3 text-left font-semibold border-b border-slate-200/90",
                                                        children: "Strategy name"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-4 py-3 text-right font-semibold border-b border-slate-200/90 whitespace-nowrap",
                                                        children: "Entry fee"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-4 py-3 text-right font-semibold border-b border-slate-200/90 whitespace-nowrap",
                                                        children: "Annual ongoing"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-4 py-3 text-right font-semibold border-b border-slate-200/90 whitespace-nowrap",
                                                        children: "Age pension (Yr1)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-4 py-3 text-right font-semibold border-b border-slate-200/90 whitespace-nowrap",
                                                        children: "Cash flow (Yr1)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-4 py-3 text-right font-semibold border-b border-slate-200/90 whitespace-nowrap",
                                                        children: "Legacy estimate"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        className: "px-4 py-3 text-center font-semibold border-b border-slate-200/90 whitespace-nowrap",
                                                        children: "Created"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: rvSavedStrategies.map((strategy, index)=>{
                                                const outputs = strategy.outputs;
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    className: `border-b border-slate-100 last:border-b-0 transition-colors hover:bg-sky-50/50 ${index % 2 === 0 ? 'bg-white' : 'bg-slate-50/60'}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3 font-medium text-slate-900 align-top",
                                                            children: strategy.name
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3 text-right tabular-nums",
                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(outputs?.entryFee ?? outputs?.summary?.entryFee)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3 text-right tabular-nums",
                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(outputs?.annualOngoing ?? outputs?.summary?.annualOngoing)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3 text-right tabular-nums",
                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(outputs?.agePension)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: `px-4 py-3 text-right tabular-nums font-medium ${(outputs?.cashFlow ?? 0) < 0 ? 'text-rose-700' : 'text-emerald-700'}`,
                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(outputs?.cashFlow)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3 text-right tabular-nums",
                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(outputs?.legacyEstimate ?? outputs?.legacyAtYear15)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-4 py-3 text-center text-slate-600 align-top",
                                                            children: new Date(strategy.createdAt || strategy.savedAt || Date.now()).toLocaleDateString()
                                                        })
                                                    ]
                                                }, strategy.id);
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "px-6 py-4 border-t border-slate-100 bg-slate-50/50 flex justify-end",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setShowCompareModal(false),
                                className: "px-5 py-2.5 rounded-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 shadow-sm transition-all",
                                children: "Close"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $7911ccd6eced4ff4$var$RetirementVillagePage = ({ setActivePage: setActivePage, factFind: factFind, savedStrategies: savedStrategies, setSavedStrategies: setSavedStrategies, setFactFind: setFactFind, onSoaGenerated: onSoaGenerated })=>{
    // The steps first; the guide is a link from step 1 (village review decision 2, agreed 21 Oct 2026).
    const [view, setView] = (0, $acw62.useState)('calculator');
    /** Where the reader was when the guide opened, to put them back there. */ const scrollWas = (0, $acw62.useRef)(0);
    const appScroller = ()=>document.querySelector('[data-app-scroll-container]');
    const openGuide = ()=>{
        scrollWas.current = appScroller()?.scrollTop ?? window.scrollY;
        setView('explanation');
        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
    };
    const closeGuide = ()=>{
        setView('calculator');
        const y = scrollWas.current;
        requestAnimationFrame(()=>{
            const el = appScroller();
            if (el) el.scrollTop = y;
            else window.scrollTo(0, y);
        });
    };
    // The village's state is asked on step 1 and kept on the file (goals.rvState).
    const rvState = String(factFind?.goals?.rvState || '');
    const setRvState = (value)=>setFactFind?.((prev)=>({
                ...prev,
                goals: {
                    ...prev?.goals || {},
                    rvState: value
                }
            }));
    // The calculator stays mounted (hidden) under the guide, so the step, the answers and the plans are kept, as in
    // aged care; closing the guide puts the reader back where they were.
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            view === 'explanation' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7911ccd6eced4ff4$var$RetirementVillageExplained, {
                setActivePage: setActivePage,
                onContinue: closeGuide,
                rvState: rvState,
                setRvState: setRvState,
                backLabel: "Back to where you were"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: view === 'explanation' ? 'hidden' : undefined,
                "aria-hidden": view === 'explanation' || undefined,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7911ccd6eced4ff4$var$RetirementVillageAnalyser, {
                    setActivePage: setActivePage,
                    factFind: factFind,
                    onBack: openGuide,
                    savedStrategies: savedStrategies,
                    setSavedStrategies: setSavedStrategies,
                    rvState: rvState,
                    setFactFind: setFactFind,
                    onSoaGenerated: onSoaGenerated
                })
            })
        ]
    });
};
var $7911ccd6eced4ff4$export$2e2bcd8739ae039 = $7911ccd6eced4ff4$var$RetirementVillagePage;






var $acw62 = parcelRequire("acw62");







/**
 * The granny flat Statement of Advice, in the shared document's shape (features/advice/moduleSoa.ts).
 * Quotes the strategy's own snapshot, projections and funding rows, and the stay-put candidate's.
 */ 










/**
 * THE GRANNY FLAT'S GUARANTEED INCOME, PLAN BY PLAN (owner, 21 Oct 2026 — the guaranteed income review and the
 * agreed mock-up, docs/ux-review/annuities/, screen 6: granny flat works "as the village").
 *
 * One reading of a plan's guaranteed income, used by the engine cards, the hand-built plan, "Explain this" and
 * the advice document, so they cannot disagree:
 *   - who it is for (the owner's first name; a joint one names both), how much, and which type it is
 *     (familyPanelKindOf: full amount back, money back, income only);
 *   - about how much it pays a year (the projection's own first-year figure);
 *   - the plan to compare it with: the same sale, with the money invested instead (`gf-sell-invest`);
 *   - for the document, the best plan tested with no guaranteed income at all.
 *
 * Only structural types here, so the page and gfSoa.ts can both import it without a cycle.
 */ 


var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c42d182890f3ecf5$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11 17h3v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a3.16 3.16 0 0 0 2-2h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-1a5 5 0 0 0-2-4V3a4 4 0 0 0-3.2 1.6l-.3.4H11a6 6 0 0 0-6 6v1a5 5 0 0 0 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1z",
            key: "1piglc"
        }
    ],
    [
        "path",
        {
            d: "M16 10h.01",
            key: "1m94wz"
        }
    ],
    [
        "path",
        {
            d: "M2 8v1a2 2 0 0 0 2 2h1",
            key: "1env43"
        }
    ]
];
const $c42d182890f3ecf5$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("piggy-bank", $c42d182890f3ecf5$export$3efd853dbb351e94);












const $80740ae64106afa1$var$formatCurrency = (value)=>{
    if (value == null || value === '' || isNaN(Number(value))) return '$0';
    const n = Math.round(Number(value));
    return `${n < 0 ? '-' : ''}$${Math.abs(n).toLocaleString('en-AU')}`;
};
const $80740ae64106afa1$var$num = (v)=>Math.max(0, parseFloat(String(v)) || 0);
function $80740ae64106afa1$export$d5bc675b676c44ae(value, isCouple) {
    return value.annuityOwner || (isCouple ? 'joint' : 'client');
}
function $80740ae64106afa1$export$14a5903af8acddef(value, isCouple) {
    const purchaseAmount = Math.max(0, parseFloat(String(value?.annuity ?? 0)) || 0);
    if (!(purchaseAmount > 0)) return null;
    const owner = $80740ae64106afa1$export$d5bc675b676c44ae(value || {}, isCouple);
    return {
        purchaseAmount: purchaseAmount,
        residualPercent: Math.min(100, Math.max(0, parseFloat(String(value?.annuityResidualPercent ?? 0)) || 0)),
        owner: owner,
        /*
         * A JOINT annuity continues to the survivor by its ownership — there is no separate
         * reversionary nomination to make, and reporting "not reversionary" for one would be true
         * to the field and false to the client. What they want to know is whether the income
         * survives them, and for a joint annuity it does.
         */ reversionary: owner === 'joint' || !!value?.annuityReversionary,
        indexed: !!value?.annuityIndexation,
        annuityType: value?.annuityType === 'fixedTerm' ? 'fixedTerm' : value?.annuityType === 'guaranteed' ? 'guaranteed' : 'lifetime',
        termYears: value?.annuityType === 'fixedTerm' ? Math.max(0, parseFloat(String(value?.annuityTermYears ?? 0)) || 0) || null : null,
        deferralYears: value?.annuityType === 'fixedTerm' ? 0 : Math.max(0, Math.round(parseFloat(String(value?.annuityDeferralYears ?? 0)) || 0))
    };
}
function $80740ae64106afa1$export$bba70ab5d49cb5db(value) {
    if (!value) return false;
    return (0, $5eae79c7e46ed27e$export$3c8a471078a7436)({
        purchaseAmount: value.annuity,
        annuityType: value.annuityType,
        residualCapital: (parseFloat(String(value.annuityResidualPercent ?? 0)) || 0) / 100
    });
}
function $80740ae64106afa1$export$24ea1903eb6c4b62(value, field, next) {
    const had = parseFloat(String(value?.annuity ?? 0)) || 0;
    return field === 'annuity' && !(had > 0) && (Number(next) || 0) > 0 ? {
        annuityType: 'lifetime',
        annuityResidualPercent: 100
    } : {};
}
/**
 * Shared "put the freed-up money to work" allocator.
 *
 * Lets a client deploy a residual lump sum (downsizing proceeds, or the residual after selling a home to
 * fund a granny-flat payment) across shares / managed funds, an investment property, and an annuity — with
 * anything left over staying in the bank. Mirrors the calculation done by
 * {@link applyResidualDeployment} so manual control and the suggestion engine agree.
 *
 * Cleaner, card-based version of the RV sell-home allocator's inline block — built here first for the new
 * modules; a candidate to back-port to RV / Aged Care / Support at Home.
 *
 * @param {Object}   props
 * @param {Object}   props.factFind
 * @param {number}   props.available  - residual available to deploy (the rest goes to the bank)
 * @param {Object}   props.value      - the deployment config (see residualDeployment.js ResidualDeployment)
 * @param {Function} props.onChange   - (nextDeployment) => void
 * @param {string}   [props.idPrefix='deploy'] - DOM id/name prefix to keep radios unique on a page
 */ const $80740ae64106afa1$var$ProceedsDeploymentFields = ({ factFind: factFind, setFactFind: setFactFind, available: available = 0, value: value = {}, onChange: onChange, idPrefix: idPrefix = 'deploy' })=>{
    const isCouple = factFind?.adviceFor === 'couple';
    const clientAge = factFind?.client?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client.dob) : null;
    const partnerAge = isCouple && factFind?.partner?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner.dob) : null;
    const shares = $80740ae64106afa1$var$num(value.shares);
    const ip = $80740ae64106afa1$var$num(value.investmentProperty);
    const annuity = $80740ae64106afa1$var$num(value.annuity);
    const superClient = $80740ae64106afa1$var$num(value.superContribution);
    const superPartner = isCouple ? $80740ae64106afa1$var$num(value.partnerSuperContribution) : 0;
    const bond = $80740ae64106afa1$var$num(value.investmentBond);
    const totalAllocated = shares + ip + annuity + superClient + superPartner + bond;
    const remaining = available - totalAllocated;
    /*
     * AFTER-TAX SUPER (F.6) AND INVESTMENT BONDS (F.5) — 17 Sep 2026.
     *
     * The super card exists only for a person who may contribute (under 75, with room under the
     * total super balance bands): the same all-or-nothing rule the Suggestion Engine applies, so a
     * client is never offered a move the rules refuse. Each field is capped at that person's room,
     * and the engine caps it again when the deployment is applied.
     */ const superRoom = (0, $acw62.useMemo)(()=>(0, $996111778bb35e70$export$3156faa588d94c0c)(factFind), [
        factFind
    ]);
    const clientName = factFind?.client?.firstName || 'you';
    const partnerName = factFind?.partner?.firstName || 'your partner';
    const canCommenceClient = (0, $f1228be62b68f76b$export$d1b692f4d3924fcd)(factFind, 'client');
    const canCommencePartner = isCouple && (0, $f1228be62b68f76b$export$d1b692f4d3924fcd)(factFind, 'partner');
    const bondRatePct = (0, $0f2c0a6799fe36da$export$d4067a97c0e75560)((0, $0f2c0a6799fe36da$export$580cfd0c6323bf7e)(factFind));
    const set = (patch)=>onChange({
            ...value,
            ...patch
        });
    // AllocationInput calls onChange(name, val); map name → field.
    const setAmount = (field, v)=>set({
            [field]: v ?? 0,
            ...$80740ae64106afa1$export$24ea1903eb6c4b62(value, field, v)
        });
    const annuityType = value.annuityType === 'fixedTerm' ? 'fixedTerm' : 'lifetime';
    const annuityOwner = $80740ae64106afa1$export$d5bc675b676c44ae(value, isCouple);
    // The freed-up proceeds are the single funding source (the annuity is funded from the residual).
    const deploymentSource = {
        id: 'freed-up-proceeds',
        type: 'proceeds',
        label: `Your freed-up proceeds \u{2014} ${$80740ae64106afa1$var$formatCurrency(available)} available`,
        ownership: annuityOwner,
        available: available
    };
    const fundingSources = [
        deploymentSource
    ];
    // Adapter: present the deployment's flat annuity fields to the shared configurator as an annuityDetails object,
    // and map its updates back into the deployment config — so residualDeployment.js still drives the real result.
    const annuityDetails = {
        purchaseAmount: annuity,
        annuityType: annuityType,
        residualCapital: Math.min(1, Math.max(0, $80740ae64106afa1$var$num(value.annuityResidualPercent) / 100)),
        termYears: annuityType === 'fixedTerm' ? $80740ae64106afa1$var$num(value.annuityTermYears) || null : null,
        deferralYears: annuityType === 'lifetime' ? Math.round($80740ae64106afa1$var$num(value.annuityDeferralYears)) : 0,
        indexation: !!value.annuityIndexation,
        reversionary: !!value.annuityReversionary,
        owner: annuityOwner,
        incomeOverride: value.annuityIncomeOverride != null && value.annuityIncomeOverride !== '' ? parseFloat(String(value.annuityIncomeOverride)) : null,
        fundingSource: deploymentSource
    };
    const setAnnuityDetails = (updater)=>{
        const next = typeof updater === 'function' ? updater(annuityDetails) : updater;
        set({
            annuity: next.purchaseAmount || 0,
            annuityType: next.annuityType === 'fixedTerm' ? 'fixedTerm' : next.annuityType === 'guaranteed' ? 'guaranteed' : 'lifetime',
            annuityResidualPercent: Math.round((Number(next.residualCapital) || 0) * 100),
            annuityTermYears: Number(next.termYears) || 0,
            annuityDeferralYears: Math.max(0, Math.round(Number(next.deferralYears) || 0)),
            annuityIndexation: !!next.indexation,
            annuityReversionary: !!next.reversionary,
            annuityOwner: next.owner || annuityOwner,
            annuityIncomeOverride: next.incomeOverride ?? undefined
        });
    };
    // Live annuity outcome — built the SAME way residualDeployment.js builds it, so the preview matches the projection.
    const annuitySummary = (0, $acw62.useMemo)(()=>{
        if (!(annuity > 0)) return null;
        try {
            const wantsContinuation = !!value.annuityReversionary || annuityOwner === 'joint';
            const effPartnerAge = isCouple && wantsContinuation && partnerAge != null ? partnerAge : null;
            const rec = (0, $f7f7b62814c3b615$export$fb67395f10ad20c9)(factFind, {
                annuityType: annuityType,
                purchaseAmount: annuity,
                age: clientAge ?? 65,
                partnerAge: effPartnerAge,
                owner: annuityOwner,
                residualCapital: Math.min(1, Math.max(0, $80740ae64106afa1$var$num(value.annuityResidualPercent) / 100)),
                termYears: annuityType === 'fixedTerm' ? $80740ae64106afa1$var$num(value.annuityTermYears) || null : null,
                deferralYears: annuityType === 'lifetime' ? Math.round($80740ae64106afa1$var$num(value.annuityDeferralYears)) : 0,
                indexation: !!value.annuityIndexation,
                reversionary: !!value.annuityReversionary && !!effPartnerAge,
                incomeOverride: value.annuityIncomeOverride != null && value.annuityIncomeOverride !== '' ? parseFloat(String(value.annuityIncomeOverride)) : null
            });
            return rec && !rec.warnings ? (0, $f7f7b62814c3b615$export$fc6c67b5fdf45998)(rec) : null;
        } catch  {
            return null;
        }
    }, [
        factFind,
        annuity,
        annuityType,
        annuityOwner,
        value.annuityReversionary,
        value.annuityResidualPercent,
        value.annuityTermYears,
        value.annuityDeferralYears,
        value.annuityIndexation,
        value.annuityIncomeOverride,
        clientAge,
        partnerAge,
        isCouple
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-xl border border-slate-200 bg-white p-4 space-y-4 shadow-sm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                className: "text-sm font-semibold text-gray-900",
                                children: "Put the freed-up money to work"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-xs text-gray-600",
                                children: [
                                    "Allocate up to ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: $80740ae64106afa1$var$formatCurrency(available)
                                    }),
                                    ". Anything you don't allocate stays in the bank."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-right shrink-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[11px] font-semibold text-slate-500 uppercase tracking-wide",
                                children: "Stays in bank"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: `text-lg font-bold ${remaining < 0 ? 'text-red-600' : 'text-green-700'}`,
                                children: $80740ae64106afa1$var$formatCurrency(remaining)
                            })
                        ]
                    })
                ]
            }),
            remaining < 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-xs text-red-700 bg-white border border-slate-200 border-l-4 border-l-red-500 rounded-r-lg px-3 py-2",
                children: "You've allocated more than the freed-up money available. Reduce an amount above."
            }),
            remaining >= 25000 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-lg bg-white border border-slate-200/70 border-l-4 border-l-amber-500 px-3 py-2.5 shadow-sm flex items-center justify-between gap-3 flex-wrap",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-xs text-slate-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: $80740ae64106afa1$var$formatCurrency(remaining)
                            }),
                            " will sit in the bank earning 2% interest with no growth. That's a decision too \u2014 leave it there, or invest it."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>set({
                                shares: shares + remaining
                            }),
                        className: "shrink-0 px-3 py-1.5 rounded-lg bg-blue-600 text-white text-xs font-semibold hover:bg-blue-700 transition-colors",
                        children: [
                            "Invest the remainder \u2014 ",
                            (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[(0, $0f2c0a6799fe36da$export$580cfd0c6323bf7e)(factFind)].label
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-lg border border-slate-200 bg-slate-50 p-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                        icon: (0, $c9921f4f81a419f0$export$2e2bcd8739ae039),
                        name: "shares",
                        label: "Shares / managed funds",
                        value: shares,
                        onChange: setAmount,
                        max: Math.max(available, shares),
                        tooltip: "Invest in a diversified share or managed-fund portfolio. Counted for the pension (deemed income); aims for higher long-term growth than cash, but returns aren't guaranteed."
                    }),
                    shares > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25ac2ec5abfb5852$export$23e482971454dc30), {
                        factFind: factFind,
                        setFactFind: setFactFind,
                        idPrefix: idPrefix,
                        what: "this money"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-lg border border-slate-200 bg-slate-50 p-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                        icon: (0, $8474226e5f2f9b18$export$2e2bcd8739ae039),
                        name: "investmentProperty",
                        label: "Investment property",
                        value: ip,
                        onChange: setAmount,
                        max: Math.max(available, ip),
                        tooltip: "Buy an investment property with the proceeds. The property value is an assessable asset; net rent (after expenses) is counted in the income test."
                    }),
                    ip > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3 pl-6 border-l-2 border-slate-200 grid grid-cols-1 sm:grid-cols-2 gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                label: "Assumed annual rent ($)",
                                value: value.ipRent ?? '',
                                onChange: (v)=>set({
                                        ipRent: v ?? 0
                                    }),
                                className: ""
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                label: "Assumed annual expenses ($)",
                                value: value.ipExpenses ?? '',
                                onChange: (v)=>set({
                                        ipExpenses: v ?? 0
                                    }),
                                className: ""
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[11px] text-gray-500 sm:col-span-2",
                                children: "Expenses (rates, insurance, maintenance, management) are generally tax-deductible and reduce the assessable rental income."
                            })
                        ]
                    })
                ]
            }),
            superRoom.total > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-lg border border-slate-200 bg-slate-50 p-3 space-y-3",
                children: [
                    superRoom.client.cap > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                        icon: (0, $c42d182890f3ecf5$export$2e2bcd8739ae039),
                        name: "superContribution",
                        label: isCouple ? `Super \u{2014} ${clientName} (after-tax contribution)` : 'Super (after-tax contribution)',
                        value: superClient,
                        onChange: (_n, v)=>set({
                                superContribution: Math.min(superRoom.client.cap, v ?? 0)
                            }),
                        max: Math.min(Math.max(available, superClient), superRoom.client.cap),
                        tooltip: `A non-concessional contribution: money that has already been taxed goes into super, where earnings are taxed at 15% (nil once it is paying a pension) instead of at your own rate. ${clientName === 'you' ? 'You' : clientName} may contribute up to ${$80740ae64106afa1$var$formatCurrency(superRoom.client.cap)} now${superRoom.client.years > 1 ? ` (${superRoom.client.years} years of the cap brought forward)` : ''}.${superRoom.client.exemptFromMeansTests ? ' Being under Age Pension age, super kept in accumulation is not counted by Centrelink until pension age.' : ''}`
                    }),
                    isCouple && superRoom.partner.cap > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                        icon: (0, $c42d182890f3ecf5$export$2e2bcd8739ae039),
                        name: "partnerSuperContribution",
                        label: `Super \u{2014} ${partnerName} (after-tax contribution)`,
                        value: superPartner,
                        onChange: (_n, v)=>set({
                                partnerSuperContribution: Math.min(superRoom.partner.cap, v ?? 0)
                            }),
                        max: Math.min(Math.max(available, superPartner), superRoom.partner.cap),
                        tooltip: `${partnerName} may contribute up to ${$80740ae64106afa1$var$formatCurrency(superRoom.partner.cap)} now${superRoom.partner.years > 1 ? ` (${superRoom.partner.years} years of the cap brought forward)` : ''}.${superRoom.partner.exemptFromMeansTests ? ' Being under Age Pension age, super kept in accumulation is not counted by Centrelink until pension age.' : ''}`
                    }),
                    isCouple && superRoom.client.cap <= 0 && superRoom.client.blocker && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-slate-600",
                        children: (0, $996111778bb35e70$export$773ed733b3205cdb)(clientName, superRoom.client.blocker)
                    }),
                    isCouple && superRoom.partner.cap <= 0 && superRoom.partner.blocker && superRoom.partner.blocker !== 'no_person' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-slate-600",
                        children: (0, $996111778bb35e70$export$773ed733b3205cdb)(partnerName, superRoom.partner.blocker)
                    }),
                    (superClient > 0 || superPartner > 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "pl-6 border-l-2 border-slate-200 space-y-1.5",
                        children: [
                            (canCommenceClient || canCommencePartner) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "flex items-start gap-2 text-xs text-slate-700",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "checkbox",
                                        className: "mt-0.5",
                                        checked: !!value.superCommenceIncomeStream,
                                        onChange: (e)=>set({
                                                superCommenceIncomeStream: e.target.checked
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "Start an account-based pension with it (earnings tax-free; the minimum pension is drawn each year)",
                                            superRoom.preferred ? ` \u{2014} leaves ${superRoom.preferred === 'client' ? clientName : partnerName}'s money counted by Centrelink, where accumulation super is not while they are under Age Pension age` : '',
                                            "."
                                        ]
                                    })
                                ]
                            }),
                            (superRoom.client.balanceEstimated || superRoom.partner.balanceEstimated) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[11px] text-slate-500",
                                children: "The cap is worked out from the super balances recorded here. The real figure is the total super balance at the last 30 June on the ATO record; check it before relying on a contribution near the limit."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "rounded-lg border border-slate-200 bg-slate-50 p-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                    icon: (0, $5f6f007318f39d57$export$2e2bcd8739ae039),
                    name: "investmentBond",
                    label: "Investment bond",
                    value: bond,
                    onChange: setAmount,
                    max: Math.max(available, bond),
                    tooltip: `An investment (insurance) bond pays its own tax inside at 30% and pays nothing out to you; after ${(0, $0f2c0a6799fe36da$export$4dc921a4380ac181)} years withdrawals are tax-free. Priced at your ${(0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[(0, $0f2c0a6799fe36da$export$580cfd0c6323bf7e)(factFind)].label} approach, that is about ${bondRatePct}% a year net. Centrelink counts it in full and deems it, like cash or shares. The projection leaves it untouched for ${(0, $0f2c0a6799fe36da$export$4dc921a4380ac181)} years, so it suits money you will not need before then${superRoom.total > 0 ? " \u2014 super is usually the better home first, while the rules still let you contribute" : " \u2014 the usual home for money super can no longer take"}.`
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-lg border border-slate-200 bg-slate-50 p-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce351ee2283539a$export$2e2bcd8739ae039), {
                        icon: (0, $e325251f2797f6cf$export$2e2bcd8739ae039),
                        name: "annuity",
                        label: "Annuity (guaranteed income)",
                        value: annuity,
                        onChange: setAmount,
                        max: Math.max(available, annuity),
                        tooltip: "Convert a lump sum into guaranteed income. For a lifetime annuity only 60% of the purchase price is counted for the assets test (for the first five years, or until age 85 if that is later, and 30% after that), which can lift the Age Pension."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $307ed5693fe6d99c$export$c57570017839ab6d), {
                        factFind: factFind,
                        amount: annuity,
                        investable: available,
                        testId: `${idPrefix}-annuity-ceiling-caution`
                    }),
                    annuity > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a72ca5744dce23c$export$2e2bcd8739ae039), {
                            factFind: factFind,
                            annuityDetails: annuityDetails,
                            setAnnuityDetails: setAnnuityDetails,
                            annuitySummary: annuitySummary,
                            annuityWarnings: [],
                            fundingSources: fundingSources,
                            formatCurrency: $80740ae64106afa1$var$formatCurrency,
                            clientAge: clientAge,
                            partnerAge: partnerAge,
                            hideAmount: true,
                            onIncomeOnlyUnderstoodChange: (0, $5eae79c7e46ed27e$export$415ddf94c95c9134)(setFactFind)
                        })
                    })
                ]
            })
        ]
    });
};
var $80740ae64106afa1$export$2e2bcd8739ae039 = $80740ae64106afa1$var$ProceedsDeploymentFields;


const $75f9bc5abce573de$export$a5d7138b0effd291 = 'the same sale, with the money invested instead';
const $75f9bc5abce573de$export$a55ca25c79a63520 = 'gf-sell-invest';
const $75f9bc5abce573de$var$num = (v)=>{
    const x = typeof v === 'number' ? v : parseFloat(String(v ?? ''));
    return Number.isFinite(x) ? x : 0;
};
const $75f9bc5abce573de$var$deploymentOf = (plan)=>plan?.inputs?.deployment || undefined;
function $75f9bc5abce573de$export$15bbfa7f38b82881(factFind, owner) {
    const client = factFind?.client?.firstName?.trim() || '';
    const partner = factFind?.partner?.firstName?.trim() || '';
    if (owner === 'joint' && client && partner) return `${client} and ${partner}`;
    if (owner === 'partner') return partner || 'the partner';
    return client || 'the client';
}
function $75f9bc5abce573de$export$17e8fd6418cf40dc(rows, factFind) {
    const first = (rows || [])[0];
    const list = first?.assets?.annuities || [];
    const onFile = new Set((factFind?.assets?.annuities || []).map((a)=>String(a?.id)));
    const total = list.filter((a)=>!onFile.has(String(a?.id))).reduce((t, a)=>t + $75f9bc5abce573de$var$num(a.annualPayment ?? a.income), 0);
    return total > 0 ? Math.round(total) : null;
}
function $75f9bc5abce573de$export$816a4f32463eb868(plan, factFind) {
    const deployment = $75f9bc5abce573de$var$deploymentOf(plan);
    const terms = (0, $80740ae64106afa1$export$14a5903af8acddef)(deployment, factFind?.adviceFor === 'couple');
    if (!terms) return null;
    const amount = $75f9bc5abce573de$var$num(terms.purchaseAmount);
    if (!(amount > 0)) return null;
    const owner = terms.owner || 'client';
    const annuityType = terms.annuityType || 'lifetime';
    const residualPercent = $75f9bc5abce573de$var$num(terms.residualPercent);
    const override = $75f9bc5abce573de$var$num(deployment?.annuityIncomeOverride);
    return {
        amount: amount,
        kind: (0, $8665f80549f60a1b$export$3ab75b1250c8af22)({
            annuityType: annuityType,
            annuityResidualPercent: residualPercent
        }),
        annuityType: annuityType,
        residualPercent: residualPercent,
        owner: owner,
        personName: $75f9bc5abce573de$export$15bbfa7f38b82881(factFind, owner),
        incomeOnly: (0, $80740ae64106afa1$export$bba70ab5d49cb5db)(deployment),
        incomeAYear: $75f9bc5abce573de$export$17e8fd6418cf40dc(plan?.projections, factFind) ?? (override > 0 ? Math.round(override) : null),
        quoted: override > 0
    };
}
function $75f9bc5abce573de$export$31540525a196c11f(plan, all) {
    const id = String(plan?.id || '');
    if (!id || id === $75f9bc5abce573de$export$a55ca25c79a63520) return null;
    const list = all || [];
    const debt = /-clear-debt$/.test(id) ? '-clear-debt' : '';
    return list.find((s)=>String(s.id) === `${$75f9bc5abce573de$export$a55ca25c79a63520}${debt}`) || list.find((s)=>String(s.id) === $75f9bc5abce573de$export$a55ca25c79a63520) || null;
}
function $75f9bc5abce573de$export$a097dc7cfe73cdc2(all, excludeId) {
    let best = null;
    for (const s of all || []){
        const id = String(s.id || '');
        if (!id || id === 'gf-stay-put' || id === excludeId) continue;
        if ($75f9bc5abce573de$var$num($75f9bc5abce573de$var$deploymentOf(s)?.annuity) > 0) continue;
        const estate = s.snapshot?.legacyValue;
        if (estate == null || !Number.isFinite(Number(estate))) continue;
        if (!best || Number(estate) > Number(best.snapshot?.legacyValue)) best = s;
    }
    return best;
}


/**
 * A tested granny flat plan in everyday words — the card's title and the line under it (granny flat rebuild,
 * 21 Oct 2026; the agreed mock-up's plans screen, as the village's rvPlanWords).
 *
 * The engine's names ("Pay the assessed value and rent out your home") were written for an adviser's list.
 * The card says who is paid and how much, where the money comes from, and what happens to the home:
 * "Pay your child $398,316 from savings; keep the home and rent it out", "$150,000 from the bank and
 * $248,316 from the account-based pension. None of it is a gift. The home is let for about $78,000 a year."
 *
 * The words are read from the plan's own inputs (what is paid, signed over or built, the funding rows, the
 * home, what a sale's money goes into), so a plan built by hand reads the same way as a tested one. Nothing
 * here is computed beyond sums; every figure is the engine row's own.
 */ 



/**
 * How the granny flat module talks about the estate, the person the client lives with, and the
 * pension leader — the words, kept in one place so the cards, the rail, the recap and the advice
 * document cannot drift (review of the two-children file, 18 Oct 2026; owner, 19 Oct 2026).
 *
 * WHAT GOES TO THE HOST IS NOT LOST (owner, 19 Oct 2026). The home signed over, the cash paid or the
 * build paid for goes to the person the client lives with. It leaves the client's estate, but it is
 * not gone: so the estate figure is "what is left in their estate", and beside it, what is already
 * with that person. Who that person is comes from nowhere on the file, so the words stay neutral —
 * never "your child" or "the family" (it may be a friend). The fairness point for the other
 * children belongs to What could go wrong (strategyRisks' familyToKeepWhole), only where the file
 * records two or more children.
 *
 * Presentation only: no engine figure is changed here.
 */ 
function $32bd8c8afa665e9e$export$2b2184b5390b1cd2(factFind) {
    const h = factFind?.goals?.gfHost;
    return h === 'child' || h === 'family' || h === 'friend' ? h : null;
}
function $32bd8c8afa665e9e$export$4411cd57c45e8c9e(factFind) {
    return parseInt(String(factFind?.family?.childrenCount ?? ''), 10) || 0;
}
function $32bd8c8afa665e9e$export$d71f476d519c5ae3(factFind) {
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const kind = $32bd8c8afa665e9e$export$2b2184b5390b1cd2(factFind);
    if (kind === 'child') return `${v.their} child`;
    if (kind === 'family') return `${v.their} family member`;
    if (kind === 'friend') return `${v.their} friend`;
    // Unanswered: "their host" — short, takes a possessive ("the home becomes their host’s"), and fits a child,
    // another relative or a friend alike (live review, 22 Oct 2026: "the person John and Kerry live with’s").
    return `${v.their} host`;
}
function $32bd8c8afa665e9e$export$f61aefdb7cc5750d(factFind) {
    if (!$32bd8c8afa665e9e$export$2b2184b5390b1cd2(factFind)) return `the home ${(0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind).they} would live in`;
    return `${$32bd8c8afa665e9e$export$d71f476d519c5ae3(factFind)}\u{2019}s home`;
}
function $32bd8c8afa665e9e$export$8363795918a7ca5e(factFind) {
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const kids = $32bd8c8afa665e9e$export$4411cd57c45e8c9e(factFind);
    const childLabel = kids >= 2 ? `One of ${v.their} ${kids === 2 ? 'two' : kids} children` : kids === 1 ? `${v.Their} child` : `One of ${v.their} children`;
    return [
        {
            id: 'child',
            label: childLabel
        },
        {
            id: 'family',
            label: 'Another family member'
        },
        {
            id: 'friend',
            label: 'A friend'
        }
    ];
}
function $32bd8c8afa665e9e$export$2f8f6124885fff97(factFind) {
    return `${(0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind).possessive} estate`;
}
function $32bd8c8afa665e9e$export$b725c0eaf4710e08(move) {
    return Math.max(0, (Number(move.amountPaid) || 0) + (Number(move.propertyTransferred) || 0) + (Number(move.construction) || 0));
}
function $32bd8c8afa665e9e$export$3223208257ce2d02(amount, factFind, money) {
    if (!(amount > 0)) return null;
    return `Plus ${money(Math.round(amount))} already with ${$32bd8c8afa665e9e$export$d71f476d519c5ae3(factFind)}, given when the arrangement starts.`;
}
function $32bd8c8afa665e9e$export$f4087385558a2ae(leader, movers, baseline, opts) {
    if (!(leader.recommendationLabels || []).includes('Optimal Age Pension')) return null;
    const own = Number(leader.snapshot?.pension) || 0;
    if (!(own > 0)) return null;
    const others = movers.filter((s)=>s !== leader && (s.id == null || s.id !== leader.id));
    if (others.length === 0 || others.some((s)=>(Number(s.snapshot?.pension) || 0) > 0)) return null;
    const basePension = Number(baseline?.snapshot?.pension) || 0;
    let line = `It leads on the Age Pension only because every other way of setting it up modelled here stops the pension${basePension > 0 ? '' : ', and not entering pays none either'}.`;
    const est = Number(leader.snapshot?.legacyValue);
    const baseEst = Number(baseline?.snapshot?.legacyValue);
    if (Number.isFinite(est) && Number.isFinite(baseEst) && baseEst - est >= 1) {
        const gap = baseEst - est;
        const toHost = Math.min(gap, Math.max(0, opts.hostReceived));
        line += ` It leaves ${opts.money(Math.round(gap))} less in ${$32bd8c8afa665e9e$export$2f8f6124885fff97(opts.factFind)} than not entering after ${opts.legacyYears} ${opts.legacyYears === 1 ? 'year' : 'years'}${toHost > 0 ? `, though ${opts.money(Math.round(opts.hostReceived))} of what was given is with ${$32bd8c8afa665e9e$export$d71f476d519c5ae3(opts.factFind)} rather than lost` : ''}.`;
    }
    return line;
}
const $32bd8c8afa665e9e$export$b0bc22f097476301 = 'careCompanionGrannyFlatOpenSection';
function $32bd8c8afa665e9e$export$e1d1ed890ff44b99(setActivePage, section) {
    try {
        sessionStorage.setItem($32bd8c8afa665e9e$export$b0bc22f097476301, section);
    } catch  {}
    setActivePage('GrannyFlatPage');
}
function $32bd8c8afa665e9e$export$8e5959f9bd823cc2() {
    try {
        const v = sessionStorage.getItem($32bd8c8afa665e9e$export$b0bc22f097476301);
        if (v) sessionStorage.removeItem($32bd8c8afa665e9e$export$b0bc22f097476301);
        return v === 'guide' || v === 'calculator' || v === 'overview' ? v : null;
    } catch  {
        return null;
    }
}
const $32bd8c8afa665e9e$export$f629769d5dbca664 = 'acw:page-reselected';



/** "the $X home" — and, with a loan on it, that the family member takes the loan over (24 Oct 2026). */ function $263fcb126ae0e669$var$homeSignedOverWords(given, factFind) {
    const loans = (0, $a528307a9ba99a26$export$6bae1904888d8a72)(factFind);
    return loans >= 1 ? `home, ${$263fcb126ae0e669$var$money(given)} after the ${$263fcb126ae0e669$var$money(loans)} loan the family member takes over with it,` : `${$263fcb126ae0e669$var$money(given)} home`;
}
const $263fcb126ae0e669$var$num = (v)=>parseFloat(String(v ?? '')) || 0;
const $263fcb126ae0e669$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
const $263fcb126ae0e669$var$joinAnd = (xs)=>xs.length <= 1 ? xs[0] || '' : `${xs.slice(0, -1).join(', ')} and ${xs[xs.length - 1]}`;
const $263fcb126ae0e669$var$cap = (s)=>s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
function $263fcb126ae0e669$export$ca60ec58f5352c3a(plan, factFind) {
    const cfg = plan?.inputs || {};
    const homeValue = $263fcb126ae0e669$var$num(factFind?.home?.value);
    const hasHome = homeValue > 0;
    const amountPaid = $263fcb126ae0e669$var$num(cfg.amountPaid);
    const propertyTransferred = $263fcb126ae0e669$var$num(cfg.propertyTransferredValue);
    const construction = $263fcb126ae0e669$var$num(cfg.constructionCost);
    const entryContribution = amountPaid + propertyTransferred + construction;
    const selling = cfg.fundFrom === 'sell_home' && homeValue > 0;
    const keeping = hasHome && propertyTransferred === 0 && !selling;
    const rented = keeping && cfg.keptHomeUse === 'rented';
    const sellingCosts = $263fcb126ae0e669$var$num(cfg.sellingCosts) || Math.round(homeValue * 0.025);
    const saleResidual = selling ? Math.max(0, homeValue - sellingCosts - amountPaid - construction) : 0;
    const justMovingIn = /^gf-move-in-only/.test(String(plan?.id || '')) || entryContribution === 0 && cfg.fundFrom !== 'sell_home';
    const home = !hasHome ? null : selling ? 'sold' : propertyTransferred > 0 ? 'transferred' : rented ? 'rented' : 'kept';
    return {
        amountPaid: amountPaid,
        propertyTransferred: propertyTransferred,
        construction: construction,
        entryContribution: entryContribution,
        isHomeowner: entryContribution > (0, $1abe73eeef086faf$export$e2cf792e99a08354),
        selling: selling,
        keeping: keeping,
        rented: rented,
        keptHomeRent: $263fcb126ae0e669$var$num(cfg.keptHomeRent),
        sellingCosts: sellingCosts,
        saleResidual: saleResidual,
        justMovingIn: justMovingIn,
        home: home,
        deprivation: $263fcb126ae0e669$var$num(plan?.deprivation)
    };
}
function $263fcb126ae0e669$export$172c8762bdedaa06(m) {
    return m.justMovingIn ? 0 : m.entryContribution;
}
/** "the bank", "the account-based pension" — the evaluator's funding rows in plain words. */ const $263fcb126ae0e669$var$SOURCE_WORDS = [
    [
        /bank/i,
        'the bank'
    ],
    [
        /term deposit/i,
        'term deposits'
    ],
    [
        /account-based pension|pension/i,
        'the account-based pension'
    ],
    [
        /shares|managed funds/i,
        'selling shares'
    ],
    [
        /cash from your savings/i,
        'savings'
    ]
];
function $263fcb126ae0e669$export$ab3387a69352496(rows) {
    const parts = [];
    for (const r of rows || []){
        if (!($263fcb126ae0e669$var$num(r.amount) > 0)) continue;
        if (/home transferred|selling your home/i.test(r.label)) continue;
        const words = $263fcb126ae0e669$var$SOURCE_WORDS.find(([re])=>re.test(r.label))?.[1] ?? r.label.toLowerCase();
        parts.push(`${$263fcb126ae0e669$var$money($263fcb126ae0e669$var$num(r.amount))} from ${words}`);
    }
    return $263fcb126ae0e669$var$joinAnd(parts);
}
/** What a sale's money is put into, short (for the title) and long (for the line). */ function $263fcb126ae0e669$var$saleUsesOf(d, factFind) {
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const short = [];
    const long = [];
    const sup = $263fcb126ae0e669$var$num(d.superContribution) + $263fcb126ae0e669$var$num(d.partnerSuperContribution);
    if (sup > 0) {
        short.push(`top up super by ${$263fcb126ae0e669$var$money(sup)}`);
        long.push(`${$263fcb126ae0e669$var$money(sup)} into super as an after-tax contribution${d.superCommenceIncomeStream === true ? ', drawn as a pension' : ''}`);
    }
    const annuity = $263fcb126ae0e669$var$num(d.annuity);
    if (annuity > 0) {
        const back = String(d.annuityType) === 'guaranteed' ? 'that pays the full amount back to the family at any time' : $263fcb126ae0e669$var$num(d.annuityResidualPercent) > 0 ? 'that pays the money back to the family in the early years' : 'that pays the most income, with nothing back to the family';
        // The kind in the title too: two plans differing only in it read alike (24 Oct 2026).
        const kind = String(d.annuityType) === 'guaranteed' ? ', full amount back' : $263fcb126ae0e669$var$num(d.annuityResidualPercent) > 0 ? ', money back early on' : ', income only';
        short.push(`put ${$263fcb126ae0e669$var$money(annuity)} into a guaranteed income${kind}`);
        long.push(`${$263fcb126ae0e669$var$money(annuity)} into a guaranteed income for life ${back}`);
    }
    const ip = $263fcb126ae0e669$var$num(d.investmentProperty);
    if (ip > 0) {
        short.push('buy an investment property');
        const duty = $263fcb126ae0e669$var$num(d.ipStampDuty);
        long.push(`${$263fcb126ae0e669$var$money(ip)} on an investment property${duty > 0 ? ` plus ${$263fcb126ae0e669$var$money(duty)} stamp duty` : ''}${$263fcb126ae0e669$var$num(d.ipRent) > 0 ? `, let for about ${$263fcb126ae0e669$var$money($263fcb126ae0e669$var$num(d.ipRent))} a year` : ''}`);
    }
    const bond = $263fcb126ae0e669$var$num(d.investmentBond);
    if (bond > 0) {
        short.push(short.length ? 'put the rest in an investment bond' : 'put it in an investment bond');
        long.push(`${$263fcb126ae0e669$var$money(bond)} into an investment bond`);
    }
    const shares = $263fcb126ae0e669$var$num(d.shares);
    if (shares > 0) {
        short.push(short.length ? 'invest the rest' : 'invest what is left');
        long.push(`${short.length > 1 ? 'the other ' : ''}${$263fcb126ae0e669$var$money(shares)} invested ${(0, $5fe2dfde2f334213$export$445db77df4ca8114)(factFind)}${v.couple ? `, in ${v.their} joint names` : ''}`);
    }
    return {
        short: short,
        long: long
    };
}
function $263fcb126ae0e669$export$bf2295610779f6b(plan, factFind) {
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const m = $263fcb126ae0e669$export$ca60ec58f5352c3a(plan, factFind);
    const host = (0, $32bd8c8afa665e9e$export$d71f476d519c5ae3)(factFind);
    const id = String(plan?.id || '');
    const debts = /-clear-debt$/.test(id) || plan?.inputs?.debtPayoff ? true : false;
    const debtsTitle = debts ? ', and clear the debts' : '';
    const debtsSub = debts ? ` ${v.Possessive} debts are cleared at the same time.` : '';
    const hasHome = $263fcb126ae0e669$var$num(factFind?.home?.value) > 0;
    const homeValue = $263fcb126ae0e669$var$num(factFind?.home?.value);
    const cfg = plan?.inputs || {};
    // The gift as Centrelink counts it: above what the right is worth, less the $10,000 a year that can be given
    // freely (24 Oct 2026: the cards showed the gross figure, the calc counts the net one).
    const giftWords = m.deprivation > 0 ? $263fcb126ae0e669$export$15946ade44cdb983(m.deprivation) > 0 ? `${$263fcb126ae0e669$var$money(m.deprivation)} is above what the right is worth; ${$263fcb126ae0e669$var$money($263fcb126ae0e669$export$15946ade44cdb983(m.deprivation))} of it counts as a gift for five years, after the ${$263fcb126ae0e669$var$money((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))} that can be given freely.` : `${$263fcb126ae0e669$var$money(m.deprivation)} is above what the right is worth, but within the ${$263fcb126ae0e669$var$money((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))} a year that can be given freely, so nothing is counted.` : m.amountPaid === 0 && (m.propertyTransferred > 0 || m.construction > 0) ? `Centrelink takes it at face value, so none of it is a gift${m.isHomeowner ? `, and ${v.they} stay homeowners` : `, but at ${$263fcb126ae0e669$var$money(m.entryContribution)} it is not more than ${$263fcb126ae0e669$var$money((0, $1abe73eeef086faf$export$e2cf792e99a08354))}, so ${v.they} are not homeowners and the right counts as an asset`}.` : 'None of it is a gift.';
    const homeWords = m.home === 'rented' ? ` The home is let for about ${$263fcb126ae0e669$var$money(m.keptHomeRent * 52)} a year, after the weeks it sits empty.` : m.home === 'kept' ? ` The home is kept empty, and counted by Centrelink from the day ${v.they} move.` : '';
    if (m.justMovingIn) return {
        title: `Move in with ${host} and pay nothing for the right${debtsTitle}`,
        sub: `No right is paid for, so nothing is a gift.${hasHome ? ` The home stops being exempt the day ${v.they} move, and is counted from then.` : ''}${debtsSub}`.trim()
    };
    if (m.propertyTransferred > 0) {
        const top = m.amountPaid + m.construction;
        return {
            title: `Sign the home over to ${host} for the right to live with them${top > 0 ? `, with ${$263fcb126ae0e669$var$money(top)} on top` : ''}${debtsTitle}`,
            sub: `The ${$263fcb126ae0e669$var$homeSignedOverWords(m.propertyTransferred, factFind)} pays for the right. ${giftWords}${debtsSub}`.trim()
        };
    }
    if (m.selling) {
        const d = cfg.deployment || {};
        const { short: short, long: long } = $263fcb126ae0e669$var$saleUsesOf(d, factFind);
        const pays = m.construction > 0 ? `pay ${$263fcb126ae0e669$var$money(m.construction)} for a build at ${(0, $32bd8c8afa665e9e$export$f61aefdb7cc5750d)(factFind)}${m.amountPaid > 0 ? ` and ${$263fcb126ae0e669$var$money(m.amountPaid)} in cash` : ''}` : `pay ${host} ${$263fcb126ae0e669$var$money(m.amountPaid)}`;
        const title = `Sell the home, ${pays}${short.length ? `, and ${$263fcb126ae0e669$var$joinAnd(short)}` : ', and keep the rest in the bank'}${debtsTitle}`;
        const left = Math.max(0, homeValue - m.sellingCosts - m.amountPaid - m.construction);
        const sub = `The sale pays for the right, after selling costs. ${giftWords} ${long.length ? `Of the ${$263fcb126ae0e669$var$money(left)} left: ${long.join('; ')}.` : `The ${$263fcb126ae0e669$var$money(left)} left stays in the bank.`}${debtsSub}`;
        return {
            title: title,
            sub: sub.trim()
        };
    }
    // Paid from savings, the home kept (or no home).
    const homeTitle = m.home === 'rented' ? '; keep the home and rent it out' : m.home === 'kept' ? '; keep the home as it is' : '';
    const pays = m.construction > 0 ? `Pay ${$263fcb126ae0e669$var$money(m.construction)} for a build at ${(0, $32bd8c8afa665e9e$export$f61aefdb7cc5750d)(factFind)}${m.amountPaid > 0 ? `, plus ${$263fcb126ae0e669$var$money(m.amountPaid)} in cash` : ''}` : `Pay ${host} ${$263fcb126ae0e669$var$money(m.amountPaid)}`;
    const drawn = $263fcb126ae0e669$export$ab3387a69352496(plan?.fundingBreakdown);
    // Two plans that differ only in the order the savings are drawn say which (owner's review, 24 Oct 2026: four
    // rows read "Pay their host $654,966 from savings; keep the home as it is"). The engine names the order.
    const order = String(plan?.name || '').split(" \u2014 from ")[1]?.replace(/, and clear your debts$/, '').trim();
    const title = `${pays} ${order ? `from ${order}` : 'from savings'}${homeTitle}${debtsTitle}`;
    const sub = `${drawn ? `${$263fcb126ae0e669$var$cap(drawn)}. ` : ''}${giftWords}${homeWords}${debtsSub}`;
    return {
        title: title,
        sub: sub.trim()
    };
}
function $263fcb126ae0e669$export$cd6e127b50c27e2a(plan, factFind) {
    const m = $263fcb126ae0e669$export$ca60ec58f5352c3a(plan, factFind);
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    if (m.home === 'rented') return 'the rented home is counted';
    if (m.home === 'kept') return 'the empty home is counted';
    if (m.home === 'sold') return 'the sale money is counted';
    if (m.home === 'transferred') return null;
    if (m.entryContribution > 0 && !m.isHomeowner) return `${v.they} are no longer homeowners`;
    return null;
}
function $263fcb126ae0e669$export$15946ade44cdb983(gross) {
    return Math.max(0, (gross || 0) - (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0));
}
function $263fcb126ae0e669$export$a92053e247f31e57(plan, base, factFind, horizonYears) {
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const m = $263fcb126ae0e669$export$ca60ec58f5352c3a(plan, factFind);
    const host = (0, $32bd8c8afa665e9e$export$d71f476d519c5ae3)(factFind);
    const snap = plan.snapshot || {};
    const b = base?.snapshot || null;
    const steps = [];
    if (m.justMovingIn) steps.push(`${v.Names} move${v.s} in with ${host} and pay nothing for the right, so nothing is a gift and no right is created.`);
    else if (m.propertyTransferred > 0) steps.push(`${v.Names} sign${v.s} the ${$263fcb126ae0e669$var$homeSignedOverWords(m.propertyTransferred, factFind)} over to ${host} for the right to live with them${m.amountPaid > 0 ? `, with ${$263fcb126ae0e669$var$money(m.amountPaid)} on top` : ''}. Centrelink takes the home at face value, so ${m.deprivation > 0 ? `${$263fcb126ae0e669$var$money($263fcb126ae0e669$export$15946ade44cdb983(m.deprivation))} of what is on top counts as a gift, after the ${$263fcb126ae0e669$var$money((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))} that can be given freely` : 'none of it is a gift'}${m.isHomeowner ? `, and ${v.they} stay homeowners` : `; at ${$263fcb126ae0e669$var$money(m.entryContribution)} it is not more than ${$263fcb126ae0e669$var$money((0, $1abe73eeef086faf$export$e2cf792e99a08354))}, so ${v.they} are not homeowners and the right counts as an asset`}.`);
    else {
        const what = m.construction > 0 ? `${$263fcb126ae0e669$var$money(m.construction)} for a build at ${(0, $32bd8c8afa665e9e$export$f61aefdb7cc5750d)(factFind)}${m.amountPaid > 0 ? ` and ${$263fcb126ae0e669$var$money(m.amountPaid)} in cash` : ''}` : `${host} ${$263fcb126ae0e669$var$money(m.amountPaid)}`;
        const from = m.selling ? 'from the sale of the home' : $263fcb126ae0e669$export$ab3387a69352496(plan.fundingBreakdown);
        const gift = m.deprivation > 0 ? `${$263fcb126ae0e669$var$money(m.deprivation)} of it is above what the right is worth, so ${$263fcb126ae0e669$var$money($263fcb126ae0e669$export$15946ade44cdb983(m.deprivation))} counts as a gift for five years, after the ${$263fcb126ae0e669$var$money((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))} that can be given freely` : m.amountPaid === 0 ? 'the build is taken at face value, so none of it is a gift' : "it is within Centrelink\u2019s limit for the right, so none of it is a gift";
        const owner = m.isHomeowner ? `, and it is more than ${$263fcb126ae0e669$var$money((0, $1abe73eeef086faf$export$e2cf792e99a08354))}, so ${v.they} stay homeowners and the right is not counted` : `; it is not more than ${$263fcb126ae0e669$var$money((0, $1abe73eeef086faf$export$e2cf792e99a08354))}, so ${v.they} are not homeowners for the Age Pension, and the right counts as an asset`;
        steps.push(`${v.Names} give${v.s} ${what} for the right to live with them${from ? ` \u{2014} ${from}` : ''}. ${$263fcb126ae0e669$var$cap(gift)}${owner}.`);
    }
    if (m.home === 'rented') steps.push(`${v.They} keep ${v.their} home and rent it out for about ${$263fcb126ae0e669$var$money(m.keptHomeRent * 52)} a year, after the weeks it sits empty.`);
    else if (m.home === 'kept') steps.push(`${v.They} keep ${v.their} home, empty.`);
    else if (m.home === 'sold') {
        const d = (plan.inputs || {}).deployment || {};
        const { long: long } = $263fcb126ae0e669$var$saleUsesOf(d, factFind);
        steps.push(`The home is sold; of the ${$263fcb126ae0e669$var$money(m.saleResidual)} left after the right is paid for, ${long.length ? long.join('; ') : 'all of it stays in the bank'}.`);
    }
    const pAfter = $263fcb126ae0e669$var$num(snap.pension);
    const pBefore = $263fcb126ae0e669$var$num(b?.pension);
    // The pension step's figure as data, for Explain this's colour (the steps keep their words for the document).
    const stepChanges = steps.map(()=>null);
    if (b) {
        if (Math.abs(pAfter - pBefore) < 1) steps.push(`${v.Possessive} Age Pension is unchanged, ${$263fcb126ae0e669$var$money(pAfter)} a year.`);
        else if (m.home === 'rented' || m.home === 'kept') {
            steps.push(`The home is counted from the day ${v.they} move, so ${v.their} Age Pension ${pAfter < 1 ? 'stops' : 'falls'}: ${$263fcb126ae0e669$var$money(pBefore)} to ${$263fcb126ae0e669$var$money(pAfter)}.`);
            if (pAfter >= 1) stepChanges[steps.length - 1] = {
                before: `The home is counted from the day ${v.they} move, so ${v.their} Age Pension falls`,
                change: {
                    from: pBefore,
                    to: pAfter,
                    unit: ' a year',
                    better: 'up',
                    after: '.'
                }
            };
        } else {
            steps.push(`${v.Possessive} Age Pension goes from ${$263fcb126ae0e669$var$money(pBefore)} to ${$263fcb126ae0e669$var$money(pAfter)} a year.`);
            stepChanges[steps.length - 1] = {
                before: `${v.Possessive} Age Pension goes`,
                change: {
                    from: pBefore,
                    to: pAfter,
                    unit: ' a year',
                    better: 'up',
                    after: '.'
                }
            };
        }
    }
    while(stepChanges.length < steps.length)stepChanges.push(null);
    /*
     * THE "PUT TOGETHER" LINE AND THE "=" LINE ARE THE SHARED LEDGER'S (owner, 22 Oct 2026: "Explain this" as aged care
     * tells it, in every module). The steps above are the causes only; the figures for putTogetherLine and
     * CauseEffectLedger are returned beside them, against staying put — the plan's OWN staying-put run.
     */ const cAfter = $263fcb126ae0e669$var$num(snap.netCashflow);
    const est = $263fcb126ae0e669$var$num(snap.legacyValue);
    const delta = b ? est - $263fcb126ae0e669$var$num(b.legacyValue) : null;
    const given = $263fcb126ae0e669$export$172c8762bdedaa06(m);
    const givenNote = given > 0 ? `The ${$263fcb126ae0e669$var$money(given)} ${host} received is not in that figure.` : null;
    const putTogether = `Put together, ${v.they} have ${cAfter < 0 ? `${$263fcb126ae0e669$var$money(-cAfter)} a year short` : `${$263fcb126ae0e669$var$money(cAfter)} a year to spare`} in the first year${b ? ` (staying put, ${$263fcb126ae0e669$var$num(b.netCashflow) < 0 ? `${$263fcb126ae0e669$var$money(-$263fcb126ae0e669$var$num(b.netCashflow))} short` : `${$263fcb126ae0e669$var$money($263fcb126ae0e669$var$num(b.netCashflow))} to spare`})` : ''}.`;
    const total = `After about ${horizonYears} ${horizonYears === 1 ? 'year' : 'years'} ${v.their} estate is ${$263fcb126ae0e669$var$money(est)}${delta != null ? ` \u{2014} ${$263fcb126ae0e669$var$money(Math.abs(delta))} ${delta < 0 ? 'less' : 'more'} than staying put` : ''}.${givenNote ? ` ${givenNote}` : ''}`;
    return {
        steps: steps,
        stepChanges: stepChanges,
        putTogether: putTogether,
        total: total,
        givenNote: givenNote,
        cashflow: cAfter,
        baseCashflow: b ? $263fcb126ae0e669$var$num(b.netCashflow) : null,
        estate: est,
        baseEstate: b ? $263fcb126ae0e669$var$num(b.legacyValue) : null
    };
}
function $263fcb126ae0e669$export$45a1f9979a03ca0d(plan, factFind) {
    const m = $263fcb126ae0e669$export$ca60ec58f5352c3a(plan, factFind);
    if (m.justMovingIn) return 'moving in without paying';
    if (m.propertyTransferred > 0) return 'signing the home over';
    if (m.selling) return 'selling the home';
    if (m.construction > 0) return 'paying for a build';
    if (m.home === 'rented') return 'paying from savings and renting the home out';
    if (m.home === 'kept') return 'paying from savings and keeping the home empty';
    return 'paying from savings';
}



const $262da6d05a14a944$var$n = (v)=>{
    const x = typeof v === 'number' ? v : parseFloat(String(v ?? ''));
    return Number.isFinite(x) ? x : 0;
};
const $262da6d05a14a944$var$money = (v)=>`$${Math.round(v).toLocaleString('en-AU')}`;
function $262da6d05a14a944$export$59e09e610bb3ddfb(factFind) {
    const host = (0, $32bd8c8afa665e9e$export$2b2184b5390b1cd2)(factFind);
    return host === 'child' ? 'your child' : host === 'family' ? 'your family member' : host === 'friend' ? 'your friend' : 'your host';
}
function $262da6d05a14a944$export$59bda1c999165b0(factFind, move) {
    const childrenCount = parseInt(String(factFind?.family?.childrenCount ?? ''), 10) || 0;
    if (childrenCount < 2 || !(move.entryContribution > 0)) return null;
    // "One of your children receives…" is said only where it is one of the children (granny flat rebuild,
    // 21 Oct 2026: step 1 asks who; another family member or a friend is not one child of several).
    const host = (0, $32bd8c8afa665e9e$export$2b2184b5390b1cd2)(factFind);
    if (host === 'family' || host === 'friend') return null;
    return move.propertyTransferred > 0 ? {
        childrenCount: childrenCount,
        amount: move.propertyTransferred,
        what: 'home'
    } : {
        childrenCount: childrenCount,
        amount: move.entryContribution,
        what: 'payment'
    };
}
function $262da6d05a14a944$export$5c6074aa828c431c(p) {
    const { strategy: strategy, factFind: factFind } = p;
    const id = String(strategy.id || '');
    const kinds = (0, $203e38d6e6c434f4$export$c301be208b2d16d)(id);
    const cfg = strategy.inputs || {};
    const amountPaid = $262da6d05a14a944$var$n(cfg.amountPaid);
    const transferred = $262da6d05a14a944$var$n(cfg.propertyTransferredValue);
    // A loan on the home goes with it to the family member (24 Oct 2026); what is given is after it.
    const homeLoans = transferred > 0 ? (0, $a528307a9ba99a26$export$6bae1904888d8a72)(factFind) : 0;
    const loanNote = homeLoans >= 1 ? `, after the ${$262da6d05a14a944$var$money(homeLoans)} loan the family member takes over with it` : '';
    const build = $262da6d05a14a944$var$n(cfg.constructionCost);
    const entry = amountPaid + transferred + build;
    // The forms Centrelink takes at face value (Social Security Guide 4.6.4.50): the home's title
    // or the cost of the build, on its own, is the price of the right — no gift.
    const faceValueOnly = amountPaid === 0 && (transferred > 0 || build > 0);
    const deprivation = $262da6d05a14a944$var$n(strategy.deprivation);
    const years = Number(p.legacyYears) || 5;
    const stayPut = p.all.find((s)=>String(s.id) === 'gf-stay-put') || null;
    const snap = strategy.snapshot || {};
    const base = stayPut?.snapshot || {};
    const rows = strategy.projections || [];
    const headline = {
        pension: $262da6d05a14a944$var$n(snap.pension),
        cashflow: $262da6d05a14a944$var$n(snap.netCashflow),
        estate: $262da6d05a14a944$var$n(snap.legacyValue ?? (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(rows[Math.min(rows.length, years) - 1]))
    };
    const baseline = {
        name: 'Not entering the arrangement',
        pension: $262da6d05a14a944$var$n(base.pension),
        cashflow: $262da6d05a14a944$var$n(base.netCashflow),
        estate: $262da6d05a14a944$var$n(base.legacyValue)
    };
    // The plan in the words the screens use (granny flat rebuild, 21 Oct 2026): the card's title and line.
    const words = (0, $263fcb126ae0e669$export$bf2295610779f6b)(strategy, factFind);
    const host = $262da6d05a14a944$export$59e09e610bb3ddfb(factFind);
    const willLiveWith = host === 'your host' ? 'the person you will live with' : host;
    const funding = strategy.fundingBreakdown || [];
    const common = (0, $482dbb064a59e381$export$df893918412205e2)(factFind, {
        kind: 'granny_flat',
        strategySource: p.manual ? 'manual_control' : 'suggestion_engine',
        customisedFrom: p.customisedFrom ?? null,
        riskKinds: kinds,
        riskSpecifics: {
            familyToKeepWhole: $262da6d05a14a944$export$59bda1c999165b0(factFind, {
                propertyTransferred: transferred,
                entryContribution: entry
            })
        }
    });
    const moneyFlow = [
        ...amountPaid > 0 ? [
            {
                label: 'Paid for the granny flat right',
                amount: amountPaid
            }
        ] : [],
        ...build > 0 ? [
            {
                label: 'Paid to build or extend the accommodation',
                amount: build,
                note: 'taken at face value as the price of the right'
            }
        ] : [],
        ...transferred > 0 ? [
            {
                label: `Home signed over to ${host}`,
                amount: transferred,
                note: `its value counts as the payment${loanNote}`
            }
        ] : [],
        ...funding.map((f)=>({
                label: f.label,
                amount: $262da6d05a14a944$var$n(f.amount)
            })),
        ...$262da6d05a14a944$var$n(strategy.fundingCgt) > 0 ? [
            {
                label: 'Capital gains tax on investments sold',
                amount: $262da6d05a14a944$var$n(strategy.fundingCgt)
            }
        ] : []
    ].filter((r)=>r.amount > 0);
    const amounts = {
        grannyFlat: entry,
        transferHome: transferred
    };
    for (const f of funding){
        if (/annuity/i.test(f.label)) {
            amounts.annuityNil = $262da6d05a14a944$var$n(f.amount);
            amounts.annuityReturned = $262da6d05a14a944$var$n(f.amount);
            amounts.annuityGuaranteed = $262da6d05a14a944$var$n(f.amount);
        }
        if (/super/i.test(f.label)) amounts.superContribution = $262da6d05a14a944$var$n(f.amount);
        if (/property/i.test(f.label)) amounts.investmentProperty = $262da6d05a14a944$var$n(f.amount);
        if (/shares|managed/i.test(f.label)) amounts.shares = $262da6d05a14a944$var$n(f.amount);
        if (/bond/i.test(f.label)) amounts.investmentBond = $262da6d05a14a944$var$n(f.amount);
    }
    // The plan's guaranteed income, read once (gfGuaranteedIncome.ts): its amount for the plan's pieces too.
    const guaranteed = (0, $75f9bc5abce573de$export$816a4f32463eb868)(strategy, factFind);
    if (guaranteed) {
        amounts.annuityNil = guaranteed.amount;
        amounts.annuityReturned = guaranteed.amount;
        amounts.annuityGuaranteed = guaranteed.amount;
    }
    const pieces = (0, $482dbb064a59e381$export$11e6b3c860abae6f)(kinds, amounts);
    const giftLine = deprivation > 0 ? `The most Centrelink can value the right at is ${$262da6d05a14a944$var$money(Math.max(p.reasonableValue, transferred, build))}, so ${$262da6d05a14a944$var$money(deprivation)} of what you give is a gift; less the ${$262da6d05a14a944$var$money((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))} that can be given freely, ${$262da6d05a14a944$var$money(Math.max(0, deprivation - (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0)))} is counted for five years.` : faceValueOnly ? `Centrelink takes ${transferred > 0 ? 'the home\'s value' : 'the cost of the build'} as the price of the right, so none of it counts as a gift.` : p.reasonableValue > 0 ? `What you pay is within Centrelink's limit for the right, ${$262da6d05a14a944$var$money(p.reasonableValue)}, so none of it counts as a gift.` : '';
    const givesWhat = transferred > 0 ? `Transfer the home, worth ${$262da6d05a14a944$var$money(transferred)}${loanNote}, to ${willLiveWith}${amountPaid > 0 ? ` and pay ${$262da6d05a14a944$var$money(amountPaid)} on top` : ''}` : build > 0 ? `Pay ${$262da6d05a14a944$var$money(build)} to build or extend the home of ${willLiveWith}${amountPaid > 0 ? `, and ${$262da6d05a14a944$var$money(amountPaid)} in cash on top,` : ''}` : `Pay ${willLiveWith} ${$262da6d05a14a944$var$money(amountPaid)}`;
    const fromVillage = (0, $4633117ee929ec27$export$cb26bf32ff9b2b4d)(factFind) ? (()=>{
        const e = (0, $4633117ee929ec27$export$3da79be84c8bf9e7)(factFind, (0, $4633117ee929ec27$export$6005e8b092eea057)(new Date()));
        return e ? {
            ...e,
            feesAfterLeaving: (0, $4633117ee929ec27$export$de22c25de5484f31)(factFind.retirementVillage, (0, $4633117ee929ec27$export$6005e8b092eea057)(new Date()), e.refundDate)
        } : null;
    })() : null;
    // What is already with the person they live with, beside the estate figures (owner, 19 Oct 2026).
    const hostLine = entry > 0 ? `Plus ${$262da6d05a14a944$var$money(entry)} already with ${host}, given when the arrangement starts \u{2014} not lost, but not in your estate.` : '';
    const inBrief = [
        entry > 0 ? `${givesWhat} in return for the right to live in the granny flat for life.` : strategy.description || '',
        giftLine,
        ...(0, $482dbb064a59e381$export$64ada78711707257)(headline, baseline, years),
        hostLine
    ].filter(Boolean);
    const alternatives = p.all.filter((s)=>(s.recommendationLabels || []).length > 0 || s.id === strategy.id).map((s)=>{
        const ss = s.snapshot || {};
        const w = (0, $263fcb126ae0e669$export$bf2295610779f6b)(s, factFind);
        return {
            name: w.title,
            description: w.sub,
            pension: $262da6d05a14a944$var$n(ss.pension),
            cashflow: $262da6d05a14a944$var$n(ss.netCashflow),
            estate: $262da6d05a14a944$var$n(ss.legacyValue),
            selected: s.id === strategy.id,
            badges: (s.recommendationLabels || []).map((0, $400a08a42b233386$export$da83f84a5a007a8a))
        };
    });
    const allEvaluated = p.all.filter((s)=>String(s.id) !== 'gf-stay-put').map((s)=>{
        const ss = s.snapshot || {};
        const w = (0, $263fcb126ae0e669$export$bf2295610779f6b)(s, factFind);
        return {
            name: w.title,
            description: w.sub,
            pension: $262da6d05a14a944$var$n(ss.pension),
            cashflow: $262da6d05a14a944$var$n(ss.netCashflow),
            estate: $262da6d05a14a944$var$n(ss.legacyValue),
            selected: s.id === strategy.id,
            badges: (s.recommendationLabels || []).map((0, $400a08a42b233386$export$da83f84a5a007a8a))
        };
    });
    const projRows = (list)=>(0, $482dbb064a59e381$export$998b1d0a26b4d727)(list, years);
    /*
     * THE GUARANTEED INCOME PAGE (guaranteed income review, 21 Oct 2026; soaGuaranteedIncome.ts): what the family
     * receives if the person passes away, year by year, against the same sale with the money invested instead
     * (a tested plan only: a hand-built plan has no sibling); the best plan tested with no guaranteed income as
     * the alternative; the client's answers; and, for income only, the confirmation word for word.
     */ const comparePlan = guaranteed ? (0, $75f9bc5abce573de$export$31540525a196c11f)(strategy, p.all) : null;
    const bestWithout = guaranteed ? (0, $75f9bc5abce573de$export$a097dc7cfe73cdc2)(p.all, id) : null;
    const guaranteedIncome = guaranteed ? (0, $66827b1304244a1d$export$11aaa304d9182b)({
        factFind: factFind,
        personName: guaranteed.personName,
        amount: guaranteed.amount,
        kind: guaranteed.kind,
        incomeAYear: guaranteed.incomeAYear,
        quoted: guaranteed.quoted,
        rows: rows,
        compareRows: comparePlan?.projections ?? null,
        compareNote: comparePlan ? (0, $75f9bc5abce573de$export$a5d7138b0effd291) : null,
        horizonYears: years,
        plan: {
            estate: headline.estate,
            pension: headline.pension,
            cashflow: headline.cashflow
        },
        alternative: bestWithout ? {
            name: (0, $263fcb126ae0e669$export$bf2295610779f6b)(bestWithout, factFind).title,
            estate: $262da6d05a14a944$var$n(bestWithout.snapshot?.legacyValue),
            pension: $262da6d05a14a944$var$n(bestWithout.snapshot?.pension),
            cashflow: $262da6d05a14a944$var$n(bestWithout.snapshot?.netCashflow)
        } : null
    }) : null;
    const pensionDelta = Math.round(headline.pension - baseline.pension);
    const sold = kinds.includes('sellHome');
    // What the sale leaves once the right is paid for — the cash AND any build (24 Oct 2026: the build was left out,
    // so a build paid from the sale showed that much more "left over" than the plan holds).
    const paidFromSale = amountPaid + build;
    const saleResidual = sold ? Math.max(0, $262da6d05a14a944$var$n(cfg.sellingCosts) > 0 ? $262da6d05a14a944$var$n(factFind?.home?.value) - $262da6d05a14a944$var$n(cfg.sellingCosts) - paidFromSale : $262da6d05a14a944$var$n(factFind?.home?.value) * 0.975 - paidFromSale) : 0;
    const estateDrivers = [
        // Not lost (owner, 19 Oct 2026): with the person they live with, and no longer in the estate.
        ...entry > 0 ? [
            {
                text: `Given to ${host}: theirs now, not lost, but no longer in your estate and not something that can be called back`,
                amount: entry,
                sign: 'minus'
            }
        ] : [],
        // The gift is part of what was given, already counted above: said, not subtracted a second time (24 Oct 2026).
        ...deprivation > 0 ? [
            {
                text: `Of what was given, ${$262da6d05a14a944$var$money(deprivation)} is above what the right can be valued at, so Centrelink counts it as a gift for five years; it is in the line above, not a second loss`,
                amount: null,
                sign: 'neutral'
            }
        ] : [],
        ...pensionDelta !== 0 ? [
            {
                text: `${pensionDelta > 0 ? 'More' : 'Less'} Age Pension, compounding over the ${years} years`,
                amount: Math.abs(pensionDelta),
                perYear: true,
                sign: pensionDelta > 0 ? 'plus' : 'minus'
            }
        ] : [],
        ...sold ? [
            {
                text: `The home is sold to fund it, so it is no longer growing in the background${saleResidual > 0 ? ` \u{2014} what is left over stays invested instead, where its growth is counted and taxed` : ''}`,
                amount: saleResidual > 0 ? saleResidual : null,
                sign: 'neutral'
            }
        ] : [],
        ...guaranteed?.kind === 'incomeOnly' ? [
            {
                text: 'The guaranteed income is the income-only type: nothing of what was paid for it goes to the family; its value is the income for life',
                amount: guaranteed.amount,
                sign: 'minus'
            }
        ] : []
    ];
    const motiveNote = headline.estate < baseline.estate - 1 ? `An estate that ends behind ${baseline.name.toLowerCase()} is the usual shape of a granny flat arrangement: money or the home goes to the person you live with now, rather than staying in your estate to be left later. Living with them, and the care that often comes with it, has a value the projection cannot count. The figures show what the arrangement costs, so it is entered with eyes open.` : null;
    return {
        ...common,
        decisionIntro: `You are weighing a granny flat arrangement: paying, or giving, something to ${willLiveWith} in return for the right to live in their home for life. This advice is about how much to pay, how to fund it, and what it does to your Age Pension, your yearly cashflow and what is left in your estate, beside what is already with ${host}.`,
        selectedStrategyName: words.title || strategy.name || 'Selected strategy',
        selectedStrategyDescription: words.sub || strategy.description || '',
        inOneLine: inBrief[0] || `${strategy.name}.`,
        inBrief: fromVillage ? [
            ...inBrief,
            (0, $511dfa7ed5ad5c31$export$2bd5a1cd4f86f5f0)({
                name: factFind?.client?.firstName || 'The client',
                ...fromVillage
            }, 'granny_flat')
        ] : inBrief,
        pieces: pieces,
        moneyFlow: moneyFlow,
        legacyYears: years,
        headline: headline,
        baseline: baseline,
        whyItFits: (0, $482dbb064a59e381$export$64ada78711707257)(headline, baseline, years),
        estateDrivers: estateDrivers,
        motiveNote: motiveNote,
        modulePage: entry > 0 ? {
            title: 'The granny flat arrangement',
            intro: 'Centrelink values a right paid for in cash with a formula: pay up to that value and nothing is treated as a gift; pay more and the excess counts against you for five years. Signing over your home or paying for the build is taken at face value as the price of the right, so on its own none of it is a gift; only what is given on top is tested.',
            rows: [
                ...amountPaid > 0 ? [
                    {
                        label: 'Cash paid',
                        amount: amountPaid
                    }
                ] : [],
                ...build > 0 ? [
                    {
                        label: 'Paid for the build',
                        amount: build,
                        note: 'taken at face value'
                    }
                ] : [],
                ...transferred > 0 ? [
                    {
                        label: 'Home transferred',
                        amount: transferred,
                        note: `taken at face value${loanNote}`
                    }
                ] : [],
                // The limit, said for what it is; with a home or build given, the right can be valued up to that instead (24 Oct 2026).
                {
                    label: "Centrelink's limit for the right",
                    amount: p.reasonableValue,
                    note: build > 0 || transferred > 0 ? 'the right can be valued up to this, or the home or build given if that is more; cash above the greater is a gift' : 'the most you can pay in cash without any of it being a gift'
                },
                {
                    label: 'Value of the right',
                    amount: Math.max(0, entry - deprivation),
                    note: 'what is given, less any gift'
                },
                {
                    label: 'Treated as a gift',
                    amount: Math.max(0, deprivation - (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0)),
                    note: deprivation > 0 ? `${$262da6d05a14a944$var$money(deprivation)} above the right\u{2019}s value, less the ${$262da6d05a14a944$var$money((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))} that can be given freely in a year; counted as an asset, and deemed, for five years` : 'none'
                },
                {
                    label: "Total given \u2014 homeowners for the Age Pension?",
                    amount: entry,
                    note: entry > (0, $1abe73eeef086faf$export$e2cf792e99a08354) ? `yes: more than ${$262da6d05a14a944$var$money((0, $1abe73eeef086faf$export$e2cf792e99a08354))} given, so the right is not counted` : `no: not more than ${$262da6d05a14a944$var$money((0, $1abe73eeef086faf$export$e2cf792e99a08354))} given, so the right counts as an asset and the higher non-homeowner limits apply`
                },
                ...$262da6d05a14a944$var$n(strategy.fundingShortfall) > 0 ? [
                    {
                        label: 'Not able to be funded from your assets',
                        amount: $262da6d05a14a944$var$n(strategy.fundingShortfall),
                        note: 'the plan is short by this much'
                    }
                ] : []
            ],
            footnote: 'Put the arrangement in writing with a solicitor before any money changes hands. Without a written agreement you have little protection if the family\'s circumstances change.'
        } : null,
        moduleCostLabel: '',
        projectionConvention: 'Year 1 is the first full year after the arrangement starts; each later year follows it.',
        alternatives: alternatives,
        allEvaluated: allEvaluated,
        totalEvaluated: p.all.filter((s)=>String(s.id) !== 'gf-stay-put').length,
        ...guaranteedIncome ? {
            guaranteedIncome: guaranteedIncome
        } : {},
        projections: projRows(rows),
        baselineProjections: projRows(stayPut?.projections),
        ...p.periodMode ? {
            periodMode: p.periodMode
        } : {},
        replacements: (0, $482dbb064a59e381$export$caf941bdb2b0342e)(kinds, moneyFlow),
        implications: [
            {
                title: 'Get it in writing',
                lead: 'A granny flat right is only as strong as the agreement behind it.',
                body: 'A solicitor should draw up the agreement: what you paid, your right to live there, what happens if you need care or the family sells, and how any money comes back.'
            },
            {
                title: 'Tell Services Australia',
                lead: 'The arrangement must be reported.',
                body: 'Centrelink will assess the reasonable value and decide whether any of the payment is a gift. Keep the agreement and evidence of what was paid.'
            },
            ...kinds.includes('sellHome') ? [
                {
                    title: 'Selling the home first',
                    lead: 'The sale funds the payment; what is left is counted.',
                    body: 'Tell Services Australia when the home is sold, and plan where the rest of the money goes before it lands in the bank.'
                }
            ] : [],
            ...kinds.includes('rentHome') || kinds.includes('rentFormerHome') ? [
                {
                    title: 'The former home, kept and let',
                    lead: 'The rent is counted as income and is taxable; the home is counted as an asset from the day you move. The rent modelled allows for weeks without a tenant (two a year unless you said otherwise) and the costs you entered.',
                    body: 'The main-residence exemption from capital gains tax runs for up to six years after you move out where the home is let; after that a sale can be taxed. Confirm with a tax agent before selling.'
                }
            ] : [],
            ...kinds.includes('investmentProperty') ? [
                {
                    title: 'The investment property rests on assumptions',
                    lead: `A standard ${(0, $0f2c0a6799fe36da$export$b037eefb915b86ec).propertyYieldPct.toFixed(1)}% gross rent less ${(0, $6ee1c1106c00a64d$export$ccb8ef6339a33b59)}, ${(0, $0f2c0a6799fe36da$export$b037eefb915b86ec).propertyGrowthPct.toFixed(1)}% growth a year, and stamp duty where a state was chosen.`,
                    body: "These are the tool's figures for a property that does not exist yet. In Manual Control you can enter a property you are looking at and the projections re-run on your figures. A gain on an investment property is taxed when it is sold. The figure left to the family is after the capital gains tax that would be paid on selling it, estimated at the household\u2019s own tax rates; the property itself is carried at its value."
                }
            ] : [],
            ...guaranteed ? [
                {
                    title: 'The guaranteed income needs a written quote',
                    lead: guaranteed.quoted ? "The income shown is the provider\u2019s quote, scaled to this amount." : 'The income shown is our estimate from published rates, not a quote.',
                    body: 'Get a written quote from the insurer before buying; if it differs, re-run the analysis on the real figure.'
                }
            ] : [],
            {
                title: 'The right ends with you',
                lead: 'A granny flat right is personal: it cannot be sold or left to anyone.',
                body: "If you later move into residential care, the right has no value to count \u2014 but the money paid for it is not refunded either. The agreement should say what happens then."
            }
        ],
        scope: {
            inScope: [
                'How much to pay for a granny flat right, how to fund it, and what it does to your position.',
                ...(0, $482dbb064a59e381$export$472dfc9f05c9ea81)
            ],
            outOfScope: [
                "Whether the family arrangement itself is sound, and the terms of the agreement \u2014 those are for you and a solicitor.",
                'Building approvals, construction contracts and the value of the family home.',
                ...(0, $482dbb064a59e381$export$b73d600a5ab2902f)(factFind)
            ]
        },
        nextSteps: [
            'Work through the family discussion guide in the granny flat module together, so everyone understands what is being given, what it buys, and what happens if circumstances change.',
            'See a solicitor and have the granny flat agreement put in writing before any money or property changes hands.',
            'Ask Services Australia to confirm the reasonable value of the right, and report the arrangement once made.',
            ...kinds.includes('sellHome') ? [
                'Get appraisals on the home and line up settlement with the family\'s building or purchase timing.'
            ] : [],
            'Where you sell assets or trigger capital gains tax, confirm the tax with a registered tax agent before you act.'
        ]
    };
}










/**
 * Granny Flat suggestion engine — generate & rank a curated set of ways to STRUCTURE a granny-flat
 * arrangement, optimising the real levers: avoiding unnecessary deprivation (don't pay above the assessed
 * value of the right) and how to handle the home (pay cash from savings vs transfer the home vs sell it).
 * Each candidate is evaluated with the same validated engine the manual path uses and ranked into
 * Best legacy / Best cashflow / Best Age Pension via the shared buildRecommendedOptimalStrategies.
 */ 
















const $576b15178c677e44$var$formatAud = (n)=>Math.round(n || 0).toLocaleString('en-AU', {
        style: 'currency',
        currency: 'AUD',
        maximumFractionDigits: 0
    });
const $576b15178c677e44$export$e6e1168cddfa88fc = 25;
const $576b15178c677e44$export$c33aaf6975fc9af0 = 50000;
const $576b15178c677e44$var$GF_ANNUITY_MIN = 25000;
function $576b15178c677e44$export$c296c00256bcac50(setup) {
    const raw = Number(setup?.annuityShareCapPct);
    if (!Number.isFinite(raw) || setup?.annuityShareCapPct == null) return $576b15178c677e44$export$e6e1168cddfa88fc;
    return Math.min(100, Math.max(0, raw));
}
function $576b15178c677e44$export$acf534e7eb17fe32(factFind) {
    const goals = factFind?.goals || {};
    const village = factFind?.retirementVillage;
    for (const v of [
        goals.gfPurchaseState,
        goals.dzNewHomeState,
        goals.rvPurchaseState,
        village?.state
    ]){
        const code = typeof v === 'string' ? v.trim().toUpperCase() : '';
        if (code && (0, $30ff538d4b47bf21$export$96fdbeb3c760993a)(code)) return code;
    }
    return '';
}
const $576b15178c677e44$export$4a9fb6bdf3fe5eb2 = 2;
function $576b15178c677e44$export$76881bf9211d0f88(weeklyRent, vacancyWeeks) {
    const empty = Math.min(52, Math.max(0, vacancyWeeks != null && Number.isFinite(Number(vacancyWeeks)) ? Number(vacancyWeeks) : $576b15178c677e44$export$4a9fb6bdf3fe5eb2));
    return Math.round((Number(weeklyRent) || 0) * (52 - empty) / 52 * 100) / 100;
}
function $576b15178c677e44$export$db301251dc134f1c(factFind) {
    const goals = factFind?.goals || {};
    const give = goals.gfGive;
    // Giving the home (step 1) is the transfer route on its own; otherwise the home's answer, with the transfer
    // tested beside it only while they are not sure what they would give.
    const savedRoute = goals.gfHomeRoute === 'keep' || goals.gfHomeRoute === 'sell' || goals.gfHomeRoute === 'transfer' || goals.gfHomeRoute === 'all' ? goals.gfHomeRoute : 'all';
    const homeRoute = give === 'home' ? 'transfer' : give && savedRoute === 'transfer' ? 'all' : savedRoute;
    const withTransfer = give === 'cash' || give === 'build' ? false : give === 'unsure' ? true : null;
    const preference = (0, $ff5de4128b46b139$export$636a9065c3f862c1)(factFind);
    // The client's ceiling first; this module's older share answer only where the client has none.
    const ceiling = (0, $ff5de4128b46b139$export$e46e91ebc7373b0a)(factFind, goals.gfAnnuityShareCapPct);
    const knownAmount = (give === 'cash' || give === 'build') && Number(goals.gfKnownAmount) > 0 ? Number(goals.gfKnownAmount) : 0;
    const rent = goals.gfRentPerWeek != null && Number(goals.gfRentPerWeek) > 0 ? Number(goals.gfRentPerWeek) : Number(factFind?.home?.likelyRent) > 0 ? Number(factFind?.home?.likelyRent) : 0;
    return {
        homeRoute: homeRoute,
        give: give === 'cash' || give === 'build' || give === 'home' || give === 'unsure' ? give : null,
        withTransfer: withTransfer,
        keptHomeRent: rent,
        keptHomeExpenses: goals.gfRentCosts != null && Number.isFinite(Number(goals.gfRentCosts)) ? Math.max(0, Number(goals.gfRentCosts)) : null,
        vacancyWeeks: goals.gfVacancyWeeks != null && Number.isFinite(Number(goals.gfVacancyWeeks)) ? Number(goals.gfVacancyWeeks) : $576b15178c677e44$export$4a9fb6bdf3fe5eb2,
        purchaseState: $576b15178c677e44$export$acf534e7eb17fe32(factFind),
        annuityShareCapPct: ceiling.pct ?? $576b15178c677e44$export$e6e1168cddfa88fc,
        annuityShareCapAmount: ceiling.amount,
        annuityAppetite: preference.appetite,
        annuityResidual: preference.residual,
        emergencyReserve: Number(goals.gfEmergencyReserve) > 0 ? Number(goals.gfEmergencyReserve) : (0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind ?? undefined),
        knownAmount: knownAmount,
        knownAmountKind: give === 'build' ? 'build' : 'cash',
        // Cash on top of a build, or of the home signed over (24 Oct 2026: both are face-value forms with cash tested on top).
        knownExtraCash: (give === 'build' || give === 'home') && Number(goals.gfKnownExtraCash) > 0 ? Number(goals.gfKnownExtraCash) : 0,
        oldUnitPaysAtMove: typeof goals.gfOldUnitPaysAtMove === 'boolean' ? goals.gfOldUnitPaysAtMove : true
    };
}
function $576b15178c677e44$export$bd66aaa55eff01b1(factFind) {
    const goals = factFind?.goals || {};
    return goals.gfGive === 'build' && !(Number(goals.gfKnownAmount) > 0);
}
function $576b15178c677e44$export$dc63b614bb30b736(factFind, startDate) {
    if (!((factFind?.home?.value || 0) > 0)) return null;
    const g = (0, $a528307a9ba99a26$export$828d07fe6ecf7e29)(factFind, $576b15178c677e44$export$37d7ba658a355219(startDate ?? undefined) || null);
    if (g.given > 0) return null;
    return `The loans on the home (${$576b15178c677e44$var$formatAud(g.loans)}) are as much as it is worth (${$576b15178c677e44$var$formatAud(g.homeValue)}), so signing it over would give nothing for the right. It is not tested; paying the loan off first, or another way of paying, is.`;
}
function $576b15178c677e44$export$fb07bda88c1da18b(factFind) {
    if (!factFind?.client?.dob) return true;
    return factFind?.adviceFor === 'couple' && !factFind?.partner?.dob;
}
function $576b15178c677e44$export$37d7ba658a355219(date) {
    const today = new Date().toISOString().slice(0, 10);
    const d = typeof date === 'string' ? date.slice(0, 10) : '';
    return d && d > today ? d : today;
}
async function $576b15178c677e44$export$cdb9477b6f7db8e1(factFind, dateEntered) {
    const date = dateEntered || new Date().toISOString().slice(0, 10);
    const probe = await $55a1d8a64f1e5dfa$export$a4daa50757e2f837(factFind, {
        amountPaid: 1,
        dateEntered: date
    });
    const dep = await $55a1d8a64f1e5dfa$export$eb48a6112ea73d5a(probe, (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).couple);
    return dep?.reasonableValue || 0;
}
async function $576b15178c677e44$export$d30b8a6e4bd366e3(factFind, options = {}) {
    const dateEntered = $576b15178c677e44$export$37d7ba658a355219(options.dateEntered);
    const hasHome = (factFind?.home?.value || 0) > 0;
    const homeValue = factFind?.home?.value || 0;
    const reasonableValueRaw = await $576b15178c677e44$export$cdb9477b6f7db8e1(factFind, dateEntered);
    // Pay the FLOORED reasonable value so we never tip a dollar over it (which would create a tiny gift).
    const fairAmount = Math.floor(reasonableValueRaw);
    const reasonableValueDisplay = Math.round(reasonableValueRaw);
    const setup = options.setup ?? {};
    // Emergency funds to keep in the bank rather than spend on the granny-flat payment (from the setup).
    const reserve = Math.max(0, Number(setup.emergencyReserve ?? options.emergencyReserve) || 0);
    /*
     * WHAT HAPPENS TO THE HOME — the client's choice, from the setup. 'all' (the default) models
     * every route; a chosen route narrows the field to it. The do-not-proceed benchmark, the
     * move-in-only candidate and the client's own plan are route-independent.
     */ const homeRoute = setup.homeRoute === 'keep' || setup.homeRoute === 'sell' || setup.homeRoute === 'transfer' ? setup.homeRoute : 'all';
    const routeKeep = homeRoute === 'all' || homeRoute === 'keep' || !hasHome;
    const routeSell = hasHome && (homeRoute === 'all' || homeRoute === 'sell');
    // Signing the home over: its own route, or beside the others while the client is not sure what they would give.
    // What signing the home over gives: its value on the start date, less the loans on it, which the family
    // member takes over (24 Oct 2026). Nothing left once the loans are paid → nothing to sign over.
    const homeGiven = (0, $a528307a9ba99a26$export$828d07fe6ecf7e29)(factFind, dateEntered || null);
    const transferValue = Math.round(homeGiven.given);
    const loanWords = homeGiven.loans >= 1 ? ` (the ${$576b15178c677e44$var$formatAud(homeGiven.homeValue)} home${homeGiven.grown ? ' at the start date' : ''}, less the ${$576b15178c677e44$var$formatAud(homeGiven.loans)} loan the family takes over with it)` : homeGiven.grown ? ' (its value at the start date)' : '';
    const routeTransfer = hasHome && transferValue > 0 && (homeRoute === 'transfer' || (setup.withTransfer != null ? setup.withTransfer === true : homeRoute === 'all'));
    /*
     * THE CLIENT'S ANSWER (guaranteed income review, 21 Oct 2026; annuityPreference.ts). "No" builds no
     * guaranteed income at all; "Yes, if the money goes back" ('back', and the unanswered default) tests
     * money back, and the full amount back where the person may buy it; "Yes, and the most income"
     * ('all') adds income only. The setup's answer wins where it carries one (it is seeded from the
     * client record and written back to it); every value, the older 'returned' / 'nil' / 'guaranteed' /
     * 'both' included, is read the way annuityPreferenceOf reads it, so nothing here narrows it again.
     */ const goalsNow = factFind?.goals || {};
    const gfAnnuityPreference = (0, $ff5de4128b46b139$export$636a9065c3f862c1)({
        ...factFind,
        goals: {
            ...goalsNow,
            ...setup.annuityAppetite ? {
                annuityAppetite: setup.annuityAppetite
            } : {},
            ...setup.annuityResidual ? {
                annuityResidual: setup.annuityResidual
            } : {}
        }
    });
    const annuityCapPct = (0, $ff5de4128b46b139$export$dfe7011c177934aa)(gfAnnuityPreference) ? $576b15178c677e44$export$c296c00256bcac50(setup) : 0;
    // The client's ceiling in dollars, where the setup carries it and the file does not hold an answer yet.
    const sizesFactFind = Number(setup.annuityShareCapAmount) > 0 && !(Number(goalsNow.annuityShareCapAmount) > 0) && !(Number(goalsNow.annuityShareCapPct) > 0) ? {
        ...factFind,
        goals: {
            ...goalsNow,
            annuityShareCapAmount: Number(setup.annuityShareCapAmount)
        }
    } : factFind;
    const quote = (0, $da24031d156d6acb$export$792bf827cea0133b)(options.annuityQuote);
    /** The provider's quote for this plan's type and amount, scaled; undefined keeps our estimate. */ const quotedFor = (annuityType, residualPercent, amount)=>(0, $da24031d156d6acb$export$2ee327201b9e82a1)(quote, annuityType, residualPercent, amount);
    /** The property a budget buys once its stamp duty is paid, with the rent struck on the PRICE (the village's rule). */ const purchaseState = (0, $30ff538d4b47bf21$export$96fdbeb3c760993a)(setup.purchaseState) ? setup.purchaseState : undefined;
    const propertyFor = (budget)=>{
        // Investor rates; the firm's yield, two weeks empty, 8% agent and 1% upkeep (investmentPropertyDefaults.ts, 21 Oct 2026).
        const bought = (0, $30ff538d4b47bf21$export$be7ef09ba9b335a2)(purchaseState, budget, 'investment');
        const f = (0, $6ee1c1106c00a64d$export$ad80a9624457bb5e)(bought.price);
        return {
            investmentProperty: bought.price,
            ipStampDuty: bought.duty,
            ipRent: f.rent,
            ipExpenses: f.expenses
        };
    };
    const dutyWords = (duty)=>purchaseState ? ` Stamp duty of ${$576b15178c677e44$var$formatAud(duty)} (${purchaseState}) comes out of the proceeds, so the property is sized to what is left.` : " Stamp duty on the property is not modelled \u2014 no state was chosen.";
    const candidates = [];
    /*
     * 0. DO NOT PROCEED — the benchmark, and the floor every arrangement must beat. Excluded from the
     *    ranked universe and passed as the benchmark instead (see buildGrannyFlatSuggestions).
     */ candidates.push({
        id: 'gf-stay-put',
        name: 'Do not enter the arrangement',
        description: "No granny flat arrangement \u2014 life as it is today. This is the baseline every option below is measured against.",
        gf: {
            oldUnitPaysAtMove: setup.oldUnitPaysAtMove !== false,
            amountPaid: 0,
            propertyTransferredValue: 0,
            constructionCost: 0,
            dateEntered: '',
            fundFrom: 'liquid'
        },
        stayPut: true
    });
    // 1. Pay the assessed (reasonable) value from savings — no gift. The default "clean" structure (home kept,
    //    vacant). The SE COMPARES funding mechanisms: when the payment needs more than cash and the client holds
    //    both shares and an account-based pension, we generate BOTH (draw the ABP — no CGT — vs sell shares — CGT),
    //    and the projection's after-CGT / after-return outcome decides which wins.
    /*
     * THE FORM THE FAMILY CHOSE, IN EVERY HOME ROUTE (owner's granny flat review, 24 Oct 2026: a build was chosen
     * with the home kept and rented, and no build-and-rent plan was ever tested - every rented and sold plan paid
     * cash at the formula value). A build (with its cost) or a known cash amount is tested with the home kept
     * empty, kept and let, and sold — and, since 25 Oct 2026, ONLY that form (see "A DECIDED FORM IS THE PLAN").
     */ const knownAmount = Math.round(Number(setup.knownAmount) > 0 ? Number(setup.knownAmount) : options.knownAmount || 0);
    const knownIsBuild = setup.knownAmountKind === 'build';
    const knownExtraCashAll = Math.max(0, Math.round(Number(setup.knownExtraCash) || 0));
    /** What the chosen form gives: the build (face value) with any cash on top, or the cash amount. */ const knownGf = knownIsBuild ? {
        amountPaid: knownExtraCashAll,
        propertyTransferredValue: 0,
        constructionCost: knownAmount
    } : {
        amountPaid: knownAmount,
        propertyTransferredValue: 0,
        constructionCost: 0
    };
    const knownTotal = knownAmount + (knownIsBuild ? knownExtraCashAll : 0);
    const knownWords = knownIsBuild ? `Pay ${$576b15178c677e44$var$formatAud(knownAmount)} for the build${knownExtraCashAll > 0 ? ` plus ${$576b15178c677e44$var$formatAud(knownExtraCashAll)} cash` : ''}` : `Pay the ${$576b15178c677e44$var$formatAud(knownAmount)} planned, in cash`;
    const knownLower = knownWords.charAt(0).toLowerCase() + knownWords.slice(1);
    const knownGiftWords = (()=>{
        const interest = knownIsBuild ? Math.max(fairAmount, knownAmount) : fairAmount;
        const gift = Math.max(0, knownTotal - interest);
        if (knownIsBuild && knownExtraCashAll <= 0) return ' Centrelink takes the cost of the build as the price of the right, so none of it is a gift.';
        return gift > 0 ? ` About ${$576b15178c677e44$var$formatAud(gift)} of it is above what the right is worth, so it is treated as a gift and counted for five years.` : ' None of it is a gift.';
    })();
    /*
     * A DECIDED FORM IS THE PLAN (owner, 25 Oct 2026: "if they've told us the arrangement is going to cost $600K the
     * engine is supposed to work out the best way of achieving this … you can't just say to the builder I'm going to
     * pay you a portion of the build"). With a build and its cost, cash and its amount, or the home signed over, every
     * plan pays exactly that; what the engine varies is where the money comes from, what happens to the home, and
     * what is done with anything left from a sale. Only "not sure yet" compares the forms themselves: cash at
     * Centrelink's limit, the home signed over, and moving in with nothing paid. (Until now the plans that paid cash
     * at the limit, or nothing, stood beside a decided build, marked "not what was described".)
     */ const give = setup.give ?? (knownAmount > 0 ? knownIsBuild ? 'build' : 'cash' : null);
    const decidedKnown = (give === 'build' || give === 'cash') && knownAmount > 0;
    const decidedHome = give === 'home';
    const buildNoCost = give === 'build' && !(knownAmount > 0);
    // Cash chosen with no amount: Centrelink's limit is the cash plan, so the limit plans ARE the chosen form.
    const decidedCashAtLimit = give === 'cash' && !(knownAmount > 0);
    const comparingForms = !decidedKnown && !decidedHome && !buildNoCost && !decidedCashAtLimit;
    // A build without its cost cannot be priced: no plan, and the screens say so (gfBuildNeedsCost).
    if (buildNoCost) return candidates;
    // 1. The home kept, empty: the payment from savings, one plan per way of funding it.
    if (routeKeep && !decidedKnown && !decidedHome) (0, $70f4a8eac5c2154b$export$78a43ea1192852fa)(factFind, fairAmount, reserve).forEach((v)=>{
        candidates.push({
            id: `gf-fair-cash${v.key}`,
            name: `${hasHome ? 'Pay the assessed value, keep your home vacant' : 'Pay the assessed value (no gift)'}${v.nameSuffix}`,
            description: `Pay about ${$576b15178c677e44$var$formatAud(reasonableValueDisplay)} \u{2014} the value Centrelink puts on your lifetime right at your age \u{2014} from your savings. Nothing counts as a gift.${v.note ? ' ' + v.note : ''}${hasHome ? " Your former home is kept but left vacant \u2014 it becomes an assessable asset." : ''}`,
            gf: {
                oldUnitPaysAtMove: setup.oldUnitPaysAtMove !== false,
                amountPaid: fairAmount,
                propertyTransferredValue: 0,
                constructionCost: 0,
                dateEntered: dateEntered,
                fundFrom: 'savings',
                keptHomeUse: 'vacant',
                funding: Object.keys(v.funding).length ? v.funding : undefined,
                emergencyReserve: reserve
            }
        });
    });
    if (routeKeep && decidedKnown && knownIsBuild) {
        /*
         * PAYING FOR THE BUILD (2 Oct 2026). The cost of constructing the accommodation is one of the
         * three forms Centrelink accepts at face value (home title, construction, a property bought in
         * the family's name): no reasonableness test, no gift, however much it costs. Cash on top is
         * "additional assets" — then the whole amount is tested against the greater of the build cost
         * and the formula (shared/src/calculation/grannyFlatArrangement.ts). Both money out is funded
         * from the client's assets, so the funding variants target the total.
         */ const extraCash = knownExtraCashAll;
        const total = knownAmount + extraCash;
        const interest = Math.max(fairAmount, knownAmount);
        const gift = Math.max(0, total - interest);
        (0, $70f4a8eac5c2154b$export$78a43ea1192852fa)(factFind, total, reserve).forEach((v)=>{
            candidates.push({
                id: `gf-known${v.key}`,
                name: `Pay for the build (${$576b15178c677e44$var$formatAud(knownAmount)})${extraCash > 0 ? ` plus ${$576b15178c677e44$var$formatAud(extraCash)} cash` : ''}${v.nameSuffix}`,
                description: `Pay ${$576b15178c677e44$var$formatAud(knownAmount)} to build or extend the family's home for your accommodation, from your savings. Centrelink takes the cost of the build as the price of the right, so on its own none of it is a gift${knownAmount > fairAmount ? ` \u{2014} even though it is above the formula value of ${$576b15178c677e44$var$formatAud(reasonableValueDisplay)}` : ''}.${extraCash > 0 ? ` The ${$576b15178c677e44$var$formatAud(extraCash)} given on top is tested: the right is valued at ${$576b15178c677e44$var$formatAud(interest)}, so ${gift > 0 ? `about ${$576b15178c677e44$var$formatAud(gift)} is treated as a gift and counted for 5 years` : 'nothing counts as a gift'}.` : ''}${v.note ? ' ' + v.note : ''}`,
                gf: {
                    oldUnitPaysAtMove: setup.oldUnitPaysAtMove !== false,
                    amountPaid: extraCash,
                    propertyTransferredValue: 0,
                    constructionCost: knownAmount,
                    dateEntered: dateEntered,
                    fundFrom: 'savings',
                    keptHomeUse: 'vacant',
                    funding: Object.keys(v.funding).length ? v.funding : undefined,
                    emergencyReserve: reserve
                }
            });
        });
    } else if (routeKeep && decidedKnown) {
        const overAssessed = knownAmount > fairAmount;
        (0, $70f4a8eac5c2154b$export$78a43ea1192852fa)(factFind, knownAmount, reserve).forEach((v)=>{
            candidates.push({
                id: `gf-known${v.key}`,
                name: `Pay your planned amount (${$576b15178c677e44$var$formatAud(knownAmount)})${v.nameSuffix}`,
                description: `Pay the ${$576b15178c677e44$var$formatAud(knownAmount)} you plan to give in cash, from your savings.${overAssessed ? ` This is above Centrelink's reasonable value (${$576b15178c677e44$var$formatAud(reasonableValueDisplay)}), so about ${$576b15178c677e44$var$formatAud(knownAmount - fairAmount)} is treated as a gift and counted for 5 years.` : ` This is at or below the reasonable value (${$576b15178c677e44$var$formatAud(reasonableValueDisplay)}), so nothing counts as a gift.`}${v.note ? ' ' + v.note : ''}`,
                gf: {
                    oldUnitPaysAtMove: setup.oldUnitPaysAtMove !== false,
                    amountPaid: knownAmount,
                    propertyTransferredValue: 0,
                    constructionCost: 0,
                    dateEntered: dateEntered,
                    fundFrom: 'savings',
                    keptHomeUse: 'vacant',
                    funding: Object.keys(v.funding).length ? v.funding : undefined,
                    emergencyReserve: reserve
                }
            });
        });
    }
    if (hasHome && routeKeep && !decidedHome) {
        // 1b. Same, but RENT OUT the kept former home. Once you move into the granny flat the former home is an
        // assessable asset whether or not it's rented — so renting it is usually pure extra cashflow/estate (the
        // pension is already affected by the asset). Uses the setup's rent, else the client's likely rent (or ~3.5% gross yield).
        const grossWeeklyRent = Math.round(Number(setup.keptHomeRent) > 0 ? Number(setup.keptHomeRent) : factFind?.home?.likelyRent || homeValue * 0.035 / 52);
        /*
         * THE WEEKS IT SITS EMPTY (granny flat rebuild, 21 Oct 2026 — the village's ruling): between tenants
         * the rent stops and the costs go on, so the rent modelled is the gross rent over the weeks it is let
         * (two empty weeks a year, suggested). The costs are the client's, itemised on the questions screen
         * (rates, insurance, repairs, the agent, land tax); absent, the profile's, else a quarter of the rent.
         */ const weeklyRent = $576b15178c677e44$export$76881bf9211d0f88(grossWeeklyRent, setup.vacancyWeeks);
        const annualExpenses = Math.round(setup.keptHomeExpenses != null && Number.isFinite(Number(setup.keptHomeExpenses)) ? Number(setup.keptHomeExpenses) : factFind?.home?.likelyExpenses || grossWeeklyRent * 13);
        if (!decidedKnown) candidates.push({
            id: 'gf-keep-rent',
            name: 'Pay the assessed value and rent out your home',
            description: `Pay the assessed value from savings (no gift), keep your former home and rent it out for about ${$576b15178c677e44$var$formatAud(weeklyRent * 52)}/yr after the weeks it sits empty. The home is assessable either way, so the rent is extra income. Heads-up: the main-residence CGT exemption lasts up to 6 years after you move out \u{2014} after that, capital gains tax can apply when you sell (you can only have one main residence at a time).`,
            gf: {
                oldUnitPaysAtMove: setup.oldUnitPaysAtMove !== false,
                amountPaid: fairAmount,
                propertyTransferredValue: 0,
                constructionCost: 0,
                dateEntered: dateEntered,
                fundFrom: 'savings',
                keptHomeUse: 'rented',
                keptHomeRent: weeklyRent,
                keptHomeExpenses: annualExpenses,
                emergencyReserve: reserve
            }
        });
        else // The decided form with the home let, one plan per way of funding it.
        (0, $70f4a8eac5c2154b$export$78a43ea1192852fa)(factFind, knownTotal, reserve).forEach((v)=>{
            candidates.push({
                id: `gf-known-keep-rent${v.key}`,
                name: `${knownWords}, and rent out your home${v.nameSuffix}`,
                description: `${knownWords} from your savings, and keep your former home and rent it out for about ${$576b15178c677e44$var$formatAud(weeklyRent * 52)}/yr after the weeks it sits empty.${knownGiftWords} The home is counted either way, so the rent is extra income.${v.note ? ' ' + v.note : ''}`,
                gf: {
                    oldUnitPaysAtMove: setup.oldUnitPaysAtMove !== false,
                    ...knownGf,
                    dateEntered: dateEntered,
                    fundFrom: 'savings',
                    keptHomeUse: 'rented',
                    keptHomeRent: weeklyRent,
                    keptHomeExpenses: annualExpenses,
                    funding: Object.keys(v.funding).length ? v.funding : undefined,
                    emergencyReserve: reserve
                }
            });
        });
    }
    // 2. The home signed over: decided, or one of the forms compared while they are not sure.
    if (routeTransfer && (decidedHome || comparingForms)) {
        if (knownExtraCashAll > 0 && !knownIsBuild) {
            // The home signed over WITH cash on top (24 Oct 2026): the cash is tested - the right is valued at the
            // greater of the home and the formula, and anything given above that is a gift. One plan per way of
            // funding the cash.
            const interest = Math.max(fairAmount, transferValue);
            const gift = Math.max(0, transferValue + knownExtraCashAll - interest);
            (0, $70f4a8eac5c2154b$export$78a43ea1192852fa)(factFind, knownExtraCashAll, reserve).forEach((v)=>{
                candidates.push({
                    id: `gf-transfer-home-cash${v.key}`,
                    name: `Transfer your home for the right, plus ${$576b15178c677e44$var$formatAud(knownExtraCashAll)} cash${v.nameSuffix}`,
                    description: `Sign your home over to the family${loanWords} and add ${$576b15178c677e44$var$formatAud(knownExtraCashAll)} in cash. The home on its own is taken at face value; the cash on top is tested - ${gift > 0 ? `about ${$576b15178c677e44$var$formatAud(gift)} is above what the right is worth, so it is treated as a gift and counted for five years` : 'none of it is a gift'}.${v.note ? ' ' + v.note : ''}`,
                    gf: {
                        oldUnitPaysAtMove: setup.oldUnitPaysAtMove !== false,
                        amountPaid: knownExtraCashAll,
                        propertyTransferredValue: transferValue,
                        constructionCost: 0,
                        dateEntered: dateEntered,
                        fundFrom: 'savings',
                        funding: Object.keys(v.funding).length ? v.funding : undefined,
                        emergencyReserve: reserve
                    }
                });
            });
        }
        // The title on its own: taken at face value as the price of the right (Social Security Guide 4.6.4.50),
        // whatever the home is worth. Not a plan when the decided form is the home WITH cash on top.
        if (!(decidedHome && knownExtraCashAll > 0)) candidates.push({
            id: 'gf-transfer-home',
            name: 'Transfer your home for the right',
            description: `Sign your home over to the family in return for the lifetime right to live there${loanWords}. Centrelink takes what is given as the price of the right, so none of it is a gift \u{2014} however much the home is worth${transferValue > (0, $1abe73eeef086faf$export$e2cf792e99a08354) ? " \u2014 and you stay a homeowner for the pension" : `. At ${$576b15178c677e44$var$formatAud(transferValue)} it is not more than ${$576b15178c677e44$var$formatAud((0, $1abe73eeef086faf$export$e2cf792e99a08354))}, so you are not a homeowner for the pension and the right is counted as an asset`}.`,
            gf: {
                oldUnitPaysAtMove: setup.oldUnitPaysAtMove !== false,
                amountPaid: 0,
                propertyTransferredValue: transferValue,
                constructionCost: 0,
                dateEntered: dateEntered,
                fundFrom: 'savings'
            }
        });
    }
    // 3. Sell the home: the payment from the proceeds, and the rest kept, invested, or put to work.
    if (routeSell && !decidedHome) {
        const sellCosts = Math.round(homeValue * 0.025);
        // Loans on the home are repaid from the sale (24 Oct 2026), so they are not there to invest.
        const homeLoansRepaid = (0, $a528307a9ba99a26$export$6bae1904888d8a72)(factFind);
        /*
         * THE EMERGENCY RESERVE applies to the sale route too (owner, 2 Oct 2026): what the bank
         * already holds counts towards it, and only the shortfall is held back from the proceeds.
         */ const bankToday = (factFind.assets?.bankAccounts || []).reduce((sum, a)=>sum + (Number(a?.value) || 0), 0);
        const reserveTopUp = Math.max(0, reserve - bankToday);
        const reserveWords = reserveTopUp > 0 ? ` ${$576b15178c677e44$var$formatAud(reserveTopUp)} of the proceeds stays in the bank as the emergency reserve.` : '';
        /*
         * WHAT IS PAID FROM THE SALE: the decided form exactly (a build, a cash amount), else cash at Centrelink's
         * limit. The same family of plans either way — the rest in the bank, invested, in property, in a guaranteed
         * income, in super or a bond — so the decided form is tested as thoroughly as the limit ever was.
         */ const payTotal = decidedKnown ? knownTotal : fairAmount;
        const pay = decidedKnown ? `${knownLower} from the proceeds` : 'pay the assessed value for your right (no gift)';
        const payGift = decidedKnown ? knownGiftWords : '';
        const idOf = (fairId, knownId)=>decidedKnown ? knownId : fairId;
        const nameOf = (fairName, knownTail)=>decidedKnown ? `Sell your home; ${knownLower}${knownTail}` : fairName;
        const residualAfterPay = Math.max(0, homeValue - sellCosts - homeLoansRepaid - payTotal - reserveTopUp);
        // Pin sellingCosts so the deployed amount equals the scenario's residual exactly (no rounding over-deploy).
        const baseSell = decidedKnown ? {
            oldUnitPaysAtMove: setup.oldUnitPaysAtMove !== false,
            ...knownGf,
            dateEntered: dateEntered,
            fundFrom: 'sell_home',
            sellingCosts: sellCosts
        } : {
            amountPaid: fairAmount,
            propertyTransferredValue: 0,
            constructionCost: 0,
            dateEntered: dateEntered,
            fundFrom: 'sell_home',
            sellingCosts: sellCosts
        };
        candidates.push(decidedKnown ? {
            id: 'gf-known-sell',
            name: `Sell your home; ${knownLower} from the sale`,
            description: `Sell the home and ${knownLower} from the proceeds; keep the rest in the bank.${knownGiftWords}`,
            gf: {
                ...baseSell
            }
        } : {
            id: 'gf-sell-pay-fair',
            name: 'Sell your home and pay the assessed value',
            description: "Sell the home, pay the assessed value for your right (no gift), and keep the rest in the bank \u2014 more cash on hand, but more is counted for the pension.",
            gf: {
                oldUnitPaysAtMove: setup.oldUnitPaysAtMove !== false,
                amountPaid: fairAmount,
                propertyTransferredValue: 0,
                constructionCost: 0,
                dateEntered: dateEntered,
                fundFrom: 'sell_home'
            }
        });
        if (residualAfterPay >= $576b15178c677e44$export$c33aaf6975fc9af0) {
            candidates.push({
                id: idOf('gf-sell-invest', 'gf-known-sell-invest'),
                name: nameOf('Sell your home and invest the rest', ' and invest the rest'),
                description: `Sell the home, ${pay}, and put the freed-up money into a diversified share / managed-fund portfolio instead of the bank \u{2014} aiming for higher long-term growth and income (still counted for the pension; returns aren't guaranteed).${payGift}${reserveWords}`,
                gf: {
                    ...baseSell,
                    deployment: {
                        shares: residualAfterPay
                    }
                }
            });
            const ip = propertyFor(residualAfterPay);
            if (ip.investmentProperty > 0) candidates.push({
                id: idOf('gf-sell-property', 'gf-known-sell-property'),
                name: nameOf('Sell your home and buy an investment property', ' and buy an investment property'),
                description: `Sell the home, ${pay}, and use the freed-up money to buy an investment property for rental income and potential growth. The property is an assessable asset and the net rent counts for the pension.${dutyWords(ip.ipStampDuty)}${payGift}${reserveWords}`,
                gf: {
                    ...baseSell,
                    deployment: ip
                }
            });
            /*
             * BOTH ENDS OF THE RESIDUAL-CAPITAL TRADE-OFF, or the strategy is disqualified rather
             * than weighed.
             *
             * Centrelink assesses a lifetime annuity at 60% of its purchase price WHATEVER its
             * residual capital value — RCV changes the payment rate, not the assets-test treatment.
             * But net worth values an annuity at its RESIDUAL (assessment/netWorth.ts, deliberately:
             * a nil-RCV lifetime annuity really does leave nothing behind), so a nil-RCV candidate
             * loses the legacy ranking by its full purchase price on day one. It was never being
             * compared against the alternatives; it was being ruled out before the comparison began.
             *
             * The Downsizer, Retirement Village, Support at Home and Aged Care engines were all fixed
             * for this. This module and Cashflow & Age Pension were built afterwards and inherited
             * the original single-variant shape — which is exactly why the guard now covers every
             * module in annuityResidualCapitalVariants.test.ts rather than the four it started with.
             */ const annuityMeansTest = 'only 60% of the purchase price counted for the assets test (for the first five years, or until age 85 if that is later, and 30% after that), which often lifts the Age Pension';
            // NEVER all of it: the setup's share goes into the annuity, the rest into shares — and, where it
            // lifts the Age Pension, the amount that lifts it most as a plan of its own (annuitySizes.ts,
            // 21 Oct 2026). A granny flat right counts as a home when more than the extra allowable amount was paid for it.
            (0, $cb76d0656284f28b$export$4dc6c2d1b2b95e25)(sizesFactFind, {
                investable: residualAfterPay,
                capPct: annuityCapPct,
                homeowner: payTotal > (0, $1abe73eeef086faf$export$e2cf792e99a08354)
            }).forEach((size)=>{
                const annuityShare = size.amount;
                const tail = size.pensionMax ? '-max' : '';
                const sizeName = size.pensionMax ? ', the amount that lifts the Age Pension most' : '';
                const annuityRest = Math.max(0, residualAfterPay - annuityShare);
                const restWords = annuityRest > 0 ? ` The remaining ${$576b15178c677e44$var$formatAud(annuityRest)} goes into shares.` : '';
                const annuityId = (kind)=>idOf(`gf-sell-annuity${tail}${kind}`, `gf-known-sell-annuity${tail}${kind}`);
                const annuityName = (shape)=>nameOf(`Sell your home and buy a guaranteed income for life (${shape}${sizeName})`, ` and buy a guaranteed income for life (${shape}${sizeName})`);
                if (annuityShare >= $576b15178c677e44$var$GF_ANNUITY_MIN && (0, $ff5de4128b46b139$export$b8876d0a37b8526a)(gfAnnuityPreference, 0)) candidates.push({
                    id: annuityId(''),
                    name: annuityName('income only'),
                    description: `Sell the home, ${pay}, and put ${$576b15178c677e44$var$formatAud(annuityShare)} of the freed-up money into a guaranteed income for life, with ${annuityMeansTest}. This type pays the most income, and nothing comes back to the family, even after an early death. Tested because it was asked for.${restWords}${payGift}${reserveWords}`,
                    gf: {
                        ...baseSell,
                        deployment: {
                            annuity: annuityShare,
                            annuityType: 'lifetime',
                            annuityResidualPercent: 0,
                            annuityIncomeOverride: quotedFor('lifetime', 0, annuityShare),
                            ...annuityRest > 0 ? {
                                shares: annuityRest
                            } : {}
                        }
                    }
                });
                if (annuityShare >= $576b15178c677e44$var$GF_ANNUITY_MIN && (0, $ff5de4128b46b139$export$b8876d0a37b8526a)(gfAnnuityPreference, 1)) candidates.push({
                    id: annuityId('-rcv'),
                    name: annuityName('money back'),
                    description: `Sell the home, ${pay}, and put ${$576b15178c677e44$var$formatAud(annuityShare)} of the freed-up money into a guaranteed income for life, with ${annuityMeansTest}. The money goes back to the family on an early death: the whole amount in about the first half of life expectancy, then a smaller amount, falling to nothing.${restWords}${payGift}${reserveWords}`,
                    gf: {
                        ...baseSell,
                        deployment: {
                            annuity: annuityShare,
                            annuityType: 'lifetime',
                            annuityResidualPercent: 100,
                            annuityIncomeOverride: quotedFor('lifetime', 100, annuityShare),
                            ...annuityRest > 0 ? {
                                shares: annuityRest
                            } : {}
                        }
                    }
                });
                if (annuityShare >= $576b15178c677e44$var$GF_ANNUITY_MIN && (0, $ff5de4128b46b139$export$623904c9366cf5a0)(gfAnnuityPreference, factFind)) candidates.push({
                    id: annuityId('-guaranteed'),
                    name: annuityName('full amount back'),
                    description: `Sell the home, ${pay}, and put ${$576b15178c677e44$var$formatAud(annuityShare)} of the freed-up money into a guaranteed income for life combined with life cover, so the full amount goes back to the family whenever death comes. It pays the least income of the types, and only the income part earns the 60% assets-test treatment; the life cover is counted at what it cost.${restWords}${payGift}${reserveWords}`,
                    gf: {
                        ...baseSell,
                        deployment: {
                            annuity: annuityShare,
                            annuityType: 'guaranteed',
                            annuityResidualPercent: 100,
                            annuityIncomeOverride: quotedFor('guaranteed', 100, annuityShare),
                            ...annuityRest > 0 ? {
                                shares: annuityRest
                            } : {}
                        }
                    }
                });
            });
            /*
             * 7-8. AFTER-TAX SUPER (F.6) AND AN INVESTMENT BOND (F.5) for the residual — 17 Sep 2026.
             * Owner-directed: a granny flat funded by selling the home leaves residual money too, and
             * it deserves the same homes the Downsizer offers. Logic-based: super only where the
             * person may still contribute (under 75, room under the balance bands), the bond as the
             * tax-paid alternative where they may not, or for what the caps cannot take.
             */ const ff = factFind;
            const superRoom = (0, $996111778bb35e70$export$3156faa588d94c0c)(ff);
            const bondBlurb = 'An investment bond pays its own tax inside (30%) and nothing on your tax return; after ten years withdrawals are tax-free. Centrelink counts it in full and deems it, like shares, so this is about tax, not the pension.';
            if (superRoom.total > 0) {
                const ncc = (0, $996111778bb35e70$export$38069100974264d)(ff, residualAfterPay);
                const nccTotal = ncc.client + ncc.partner;
                if (nccTotal >= 25000) candidates.push({
                    id: idOf('gf-sell-super', 'gf-known-sell-super'),
                    name: nameOf('Sell your home, pay the assessed value, and top up super after tax', ', and top up super after tax'),
                    description: `Sell the home, ${pay}, and put ${$576b15178c677e44$var$formatAud(nccTotal)} of the rest into super as an after-tax contribution${ncc.preferred ? ` \u{2014} ${ncc.preferred === 'client' ? factFind?.client?.firstName || 'the client' : factFind?.partner?.firstName || 'the partner'} first, whose accumulation super is not counted by Centrelink until Age Pension age` : ''}. Capped at what each of you may contribute now; anything above the cap goes into shares.${payGift}`,
                    gf: {
                        ...baseSell,
                        deployment: {
                            superContribution: ncc.client,
                            partnerSuperContribution: ncc.partner,
                            superCommenceIncomeStream: ncc.preferred == null,
                            shares: Math.max(0, residualAfterPay - nccTotal)
                        }
                    }
                });
                if (residualAfterPay - superRoom.total >= $576b15178c677e44$export$c33aaf6975fc9af0) candidates.push({
                    id: idOf('gf-sell-super-and-bond', 'gf-known-sell-super-and-bond'),
                    name: nameOf('Sell your home, fill super after tax, and bond the rest', ', fill super after tax, and bond the rest'),
                    description: `${decidedKnown ? `Sell the home, ${pay}. ` : ''}Put ${$576b15178c677e44$var$formatAud(nccTotal)} into super as an after-tax contribution \u{2014} the most the caps allow \u{2014} and the remaining ${$576b15178c677e44$var$formatAud(residualAfterPay - nccTotal)} into an investment bond. ${bondBlurb}${payGift}`,
                    gf: {
                        ...baseSell,
                        deployment: {
                            superContribution: ncc.client,
                            partnerSuperContribution: ncc.partner,
                            superCommenceIncomeStream: ncc.preferred == null,
                            investmentBond: Math.max(0, residualAfterPay - nccTotal)
                        }
                    }
                });
            } else candidates.push({
                id: idOf('gf-sell-bond', 'gf-known-sell-bond'),
                name: nameOf('Sell your home, pay the assessed value, and bond the rest', ', and bond the rest'),
                description: `Sell the home, ${pay}, and put the remaining ${$576b15178c677e44$var$formatAud(residualAfterPay)} into an investment bond \u{2014} the tax-paid home for money super can no longer take. ${bondBlurb}${payGift}`,
                gf: {
                    ...baseSell,
                    deployment: {
                        investmentBond: residualAfterPay
                    }
                }
            });
        }
    }
    /*
     * "YOUR CURRENT PLAN" (gf-your-plan) WAS REMOVED 24 Oct 2026: no screen ever passed the hand-built plan in, so it
     * was never generated; the plans built from step 1's own amount (gf-known*) are that comparison now.
     */ /*
     * MOVE IN AND PAY NOTHING — the option every family raises first, and the engine never modelled.
     *
     * This is NOT the same thing as the do-nothing benchmark, which is not moving at all. Here the
     * client moves in with family without paying for the right to live there: no granny-flat
     * interest is created, so nothing counts as a gift and there is no reasonableness test to
     * satisfy. It looks like the cheapest option on the page, and it usually is in cash terms.
     *
     * What it does NOT avoid is the consequence families are most surprised by. Centrelink exempts
     * ONE home, and only while you live in it. Move out and the house you still own becomes an
     * ordinary counted asset — on the case this was written against, that alone takes a $29,824
     * pension to nil and turns a $9,176 cashflow gap into $39,000. Paying nothing does not protect
     * the pension; living somewhere else is what costs it.
     *
     * So this is offered as a candidate precisely so the ranking can show that. An engine that only
     * ever priced arrangements with a payment left the family to discover the free option's cost on
     * their own. One of the forms compared while they are not sure; not a plan once a form is decided.
     */ if (comparingForms) candidates.push({
        id: 'gf-move-in-only',
        name: 'Move in without paying for the right',
        description: "Move in with family and pay nothing for the right to live there. No granny-flat interest is created, so nothing counts as a gift and there is no assessed value to meet \u2014 but the home you leave stops being exempt the moment you stop living in it, and is counted like any other asset from then on. Rent Assistance generally does not apply when living with family.",
        gf: {
            amountPaid: 0,
            propertyTransferredValue: 0,
            constructionCost: 0,
            dateEntered: dateEntered,
            fundFrom: 'liquid'
        }
    });
    /*
     * DEBT CLEARANCE — paired against every arrangement above, the same pattern the aged care and
     * village engines use. The interest stops and the repayments leave the cashflow, but the money
     * spent is money that cannot also pay the family for the right to live there — which for a
     * household doing both at once is exactly the competition worth ranking.
     *
     * The do-nothing benchmark is left pure: it has to stay indistinguishable from the client's life
     * as it is, or nothing else has anything to be measured against.
     *
     * Which debts: strategy/debtsToTest.ts (never a card paid off monthly; any interest-bearing debt;
     * interest-free debts from $5,000), the same rule every module uses.
     */ const debts = (0, $485d903040fc3504$export$718566aeb53e1efe)((0, $35f2741dc40fa45c$export$403bb596c20e48)(factFind));
    const totalDebt = debts.reduce((sum, d)=>sum + d.balance, 0);
    if (debts.length > 0) {
        const payments = Object.fromEntries(debts.map((d)=>[
                d.key,
                d.balance
            ]));
        const twins = candidates.filter((c)=>c.stayPut !== true).map((c)=>({
                ...c,
                id: `${c.id}-clear-debt`,
                name: `${c.name}, and clear your debts`,
                description: `${c.description} This version also clears your outstanding debts of ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(totalDebt)} at the same time \u{2014} the interest stops and the repayments leave your cashflow, but that money is no longer available for anything else in the plan.`,
                debtPayoff: {
                    payments: payments,
                    repaymentBasis: 'keep_repayment'
                }
            }));
        candidates.push(...twins);
    }
    return candidates;
}
async function $576b15178c677e44$export$8ef4aa8bb38d60e4(factFind, options = {}) {
    const legacyYears = options.legacyYears || 10;
    const dateEntered = $576b15178c677e44$export$37d7ba658a355219(options.dateEntered);
    const reasonableValue = Math.round(await $576b15178c677e44$export$cdb9477b6f7db8e1(factFind, dateEntered));
    const candidates = await $576b15178c677e44$export$d30b8a6e4bd366e3(factFind, {
        ...options,
        dateEntered: dateEntered
    });
    // One request evaluates every candidate against the engine server-side (see
    // server/src/rest/calculation/suggestionEngine/grannyFlat.ts) instead of 3 calls x N candidates.
    // A FUTURE entry date defers every candidate to the same day as the manual run — timing belongs
    // to the case. Today or the past means the arrangement starts now, the long-standing behaviour.
    const today = new Date().toISOString().slice(0, 10);
    const futureEntryDate = options.dateEntered && options.dateEntered > today ? options.dateEntered : undefined;
    const strategies = await $55a1d8a64f1e5dfa$export$e0ff603d890d58d6(factFind, candidates, legacyYears, futureEntryDate);
    // Ranked among the real arrangements, each measured against not proceeding — so nothing is
    // recommended that leaves the client worse off than doing nothing.
    const stayPut = strategies.find((s)=>s.id === 'gf-stay-put') || null;
    const arrangements = strategies.filter((s)=>s.id !== 'gf-stay-put');
    const recommended = (0, $f8ee565b442c040e$export$3140a3b98e6384f2)(arrangements, stayPut, {
        readings: (0, $5a094123650e8adb$export$448a1f2525c95b5b)
    });
    return {
        strategies: strategies,
        recommended: recommended,
        reasonableValue: reasonableValue,
        stayPut: stayPut,
        rerun: {
            candidates: candidates,
            legacyYears: legacyYears,
            date: futureEntryDate
        }
    };
}












/**
 * "Your plan, in plain words" — the Granny Flat module's interpretation layer, the same guided-UX
 * pattern as the Aged Care and Downsizer modules (owner direction, 2026-08-25). Sentences that
 * interpret the arrangement — the reasonableness test, homeowner status, the kept former home —
 * then the pension and cashflow movements as ShiftRows with driver-named whys. Content transposed
 * from GrannyFlatInsightPanel's narratives so the closable panel and this always-visible card tell
 * one story.
 *
 * CALCULATION DISCIPLINE — every figure is quoted from `panelModel`, the SAME object that feeds
 * the Financial Impact panel and the insight panel, for whichever view is live (manual settings or
 * the selected Suggestion Engine strategy). Nothing is re-derived here.
 */ 
parcelRequire("acw62");







/** The pieces of the plan, one line each with "what's this?" where the glossary explains it. */ function $2384f8e2c7bd0a38$var$gfPlanPiecesOf(model, factFind) {
    const hostPhrase = (0, $32bd8c8afa665e9e$export$d71f476d519c5ae3)(factFind);
    const estateWords = (0, $32bd8c8afa665e9e$export$2f8f6124885fff97)(factFind);
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const planPieces = [];
    const build = model.constructionCost || 0;
    if (build > 0) planPieces.push({
        key: 'build',
        name: 'A build paid for at their home',
        amount: build,
        what: `${v.Names} pay${v.s} for a build or extension at ${hostPhrase}\u{2019}s home, for a lifetime right to live there. It has left ${estateWords} (the building is ${hostPhrase}\u{2019}s, not lost). Centrelink takes the cost at face value: it is the price of the right, never a gift on its own.`
    });
    if (model.amountPaid > 0) planPieces.push({
        key: 'payment',
        name: build > 0 || model.propertyTransferred > 0 ? 'Cash on top, for the right to live there' : 'Payment for the right to live there',
        amount: model.amountPaid,
        what: `Money paid to ${hostPhrase} in exchange for a lifetime right to live in their home. It has left ${estateWords} (it is with them, not lost). Cash is tested: the right can be valued up to Centrelink\u{2019}s limit for ${v.their} age${build > 0 || model.propertyTransferred > 0 ? ', or the home or build it comes with if that is more' : ''}, and anything above that is a gift.`,
        glossaryTerm: 'reasonableness test'
    });
    if (model.propertyTransferred > 0) planPieces.push({
        key: 'transfer',
        name: 'Home signed over for the right to live there',
        amount: model.propertyTransferred,
        what: `The home itself is given to ${hostPhrase} in exchange for the right to live there. It is theirs now and no longer in ${estateWords}. Centrelink takes it at face value: it is the price of the right, never a gift on its own, whatever it is worth.`
    });
    if (model.saleFlow) planPieces.push({
        key: 'sell-home',
        name: 'Sell the family home',
        amount: model.saleFlow.homeValue,
        what: `The home is sold; after ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.saleFlow.sellingCosts)} of selling costs the money funds the arrangement, and what is left over is money Centrelink counts.`
    });
    if (model.keptHomeRented) planPieces.push({
        key: 'rent-home',
        name: 'Keep the former home and rent it out',
        what: 'The former home is let. The rent counts as income, and the home is counted as an asset once the granny flat is the main home.'
    });
    const counted = Math.max(0, model.deprivation - (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0));
    if (counted > 0) planPieces.push({
        key: 'gift',
        name: 'Counted as a gift by Centrelink',
        amount: counted,
        what: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.deprivation)} was given above what the right can be valued at (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.interestValue)}). Less the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))} a year that can be given freely, it is treated as a gift and still counted for five years.`,
        glossaryTerm: 'gifting'
    });
    return planPieces;
}
const $2384f8e2c7bd0a38$var$GrannyFlatPlanRecap = ({ model: model, baselineLegacy: baselineLegacy = null, legacyYears: legacyYears = 5, factFind: factFind = null, piecesOnly: piecesOnly = false })=>{
    /*
     * INSIDE "EXPLAIN THIS", ONLY THE PIECES (owner, 22 Oct 2026: "Explain this" as aged care tells it). The numbered
     * cause→effect lines already say the gift, homeowner status, the home, the pension, the year's money and the estate,
     * so the summary card would say them twice; what the ledger lacks is one line per piece of the plan with its
     * glossary "what's this?", which aged care shows under its ledger the same way (PlanPiecesCard plain, no heading).
     */ if (piecesOnly) {
        if (!model.hasArrangement && !model.justMovingIn) return null;
        const pieces = $2384f8e2c7bd0a38$var$gfPlanPiecesOf(model, factFind);
        return pieces.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1f2b2692daf0da1$export$d520641036c1ebe9), {
            plain: true,
            className: "mt-5",
            pieces: pieces
        }) : null;
    }
    const fin = model.insightFinancials;
    if (!model.hasArrangement && !model.justMovingIn || !fin) return null;
    const hostPhrase = (0, $32bd8c8afa665e9e$export$d71f476d519c5ae3)(factFind);
    const estateWords = (0, $32bd8c8afa665e9e$export$2f8f6124885fff97)(factFind);
    const hostLine = (0, $32bd8c8afa665e9e$export$3223208257ce2d02)(model.entryContribution, factFind, (0, $f94e45ac645ae232$export$3dc27271f5d5c629));
    // "you" to the client, the household's names to an adviser (owner, 21 Oct 2026) — the same voice
    // as hostPhrase and estateWords above.
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const pensionBefore = fin.agePensionBefore ?? 0;
    const pensionAfter = fin.agePensionAfter ?? 0;
    const cashflowBefore = model.before?.cashFlow ?? 0;
    const cashflowAfter = fin.cashflowAfter ?? 0;
    const pensionDelta = Math.round(pensionAfter) - Math.round(pensionBefore);
    /*
     * Driver-named whys. The insight panel's own finding applies here with force: when the former
     * home is KEPT, that — not the gift result — is usually the main event for the pension, so the
     * kept home leads the explanation whenever it is in play.
     */ const pensionDrivers = [];
    if (model.keepingHome) pensionDrivers.push(`the former home (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.formerHomeValue)}) is no longer lived in, so Centrelink now counts it in the assets test${model.keptHomeRented ? ', and the rent it earns is counted as income' : ''}`);
    if (model.deprivation > 0) pensionDrivers.push(`${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.deprivation)} given above the assessed value of the right counts as a gift for five years`);
    if (model.hasArrangement && !model.isHomeowner) pensionDrivers.push(`the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.entryContribution)} paid is counted as an asset (though non-homeowner thresholds are higher, and Rent Assistance may apply)`);
    if (model.saleFlow && (model.saleFlow.residual || 0) > 0) pensionDrivers.push(`${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.saleFlow.residual)} of home-sale money not used for the arrangement stays countable`);
    const pensionWhy = pensionDrivers.length > 0 ? `What moves the pension here: ${pensionDrivers.join('; ')}.` : model.justMovingIn ? `Nothing is being paid for the right to live there, so there is no gift to count \u{2014} ${v.names} ${v.are} simply assessed as a non-homeowner, with the higher asset limits.` : `The amount given sits within the assessed value of the right, and as a homeowner that value is exempt \u{2014} so what Centrelink counts barely changes.`;
    const cashflowDrivers = [];
    if (model.keptHomeRented) cashflowDrivers.push('rent from the former home comes in');
    if (model.hasArrangement) cashflowDrivers.push(`the money paid across stops earning where it was`);
    if (pensionDelta !== 0) cashflowDrivers.push(`the Age Pension is ${pensionDelta > 0 ? 'higher' : 'lower'} (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pensionBefore)} \u{2192} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pensionAfter)} a year)`);
    const cashflowWhy = `A full year of money in, less money out.` + (cashflowDrivers.length > 0 ? ` What changes it: ${cashflowDrivers.join('; ')}.` : '');
    /*
     * THE ESTATE, AND WHAT DECIDES IT. Both sides are projected over the same years by the same
     * engine — the arrangement against not entering it — so the comparison is like for like. The
     * money handed over has genuinely left the estate; the reason says so rather than letting the
     * reader work it out from a smaller number.
     */ const legacyAfter = model.legacyEstimate ?? null;
    const legacyDelta = baselineLegacy != null && legacyAfter != null ? Math.round(legacyAfter - baselineLegacy) : null;
    const legacyDrivers = [];
    // Not lost (owner, 19 Oct 2026): it is with the person they live with, and no longer in the estate.
    if (model.entryContribution > 0) legacyDrivers.push({
        text: `Given to ${hostPhrase} \u{2014} theirs now, not lost, but no longer in ${estateWords} and not something that can be called back`,
        amount: model.entryContribution,
        sign: 'minus'
    });
    if (pensionDelta !== 0) legacyDrivers.push({
        text: `${pensionDelta > 0 ? 'More' : 'Less'} Age Pension, compounding over the ${legacyYears} ${legacyYears === 1 ? 'year' : 'years'}`,
        amount: Math.abs(pensionDelta),
        suffix: 'a year',
        sign: pensionDelta > 0 ? 'plus' : 'minus'
    });
    /*
     * ONLY WHAT ACTUALLY DIFFERS. A kept former home grows in BOTH projections, so listing it as a
     * driver of the difference was wrong — it explained the level, not the gap (caught on screen,
     * 2026-08-27). A home that is SOLD to fund the arrangement genuinely differs: the do-nothing
     * projection still holds it.
     */ if (model.saleFlow) legacyDrivers.push({
        text: `The ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.saleFlow.homeValue)} home is sold to fund it, so it is no longer growing in the background${(model.saleFlow.residual || 0) > 0 ? ` \u{2014} the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.saleFlow.residual)} left over stays invested instead` : ''}`,
        sign: 'minus'
    });
    const legacyWhy = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$721778c36dbce7e7), {
        lead: `Both figures are projected over the same ${legacyYears} ${legacyYears === 1 ? 'year' : 'years'} \u{2014} the arrangement against not entering it \u{2014} so they can be compared directly.`,
        drivers: legacyDrivers
    });
    const planPieces = $2384f8e2c7bd0a38$var$gfPlanPiecesOf(model, factFind);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$28c8139bd562d0e), {
                eyebrow: "Your plan summary",
                className: "mt-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "space-y-1.5 text-sm leading-relaxed text-slate-700",
                        children: model.justMovingIn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                "Moving in with family ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "font-semibold text-slate-900",
                                    children: "without paying"
                                }),
                                " for the right to live there: no granny-flat interest, nothing counts as a gift \u2014 ",
                                v.names,
                                " ",
                                v.are,
                                ' ',
                                "assessed as a non-homeowner (higher asset limits), though ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                    term: "Rent Assistance"
                                }),
                                ' ',
                                "generally doesn't apply when living with family."
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        "Giving ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold text-slate-900",
                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.entryContribution)
                                        }),
                                        model.propertyTransferred > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                " (",
                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.amountPaid),
                                                " cash + ",
                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.propertyTransferred),
                                                " in property)"
                                            ]
                                        }),
                                        ' ',
                                        "to ",
                                        hostPhrase,
                                        " for a lifetime right to live there. The most Centrelink can value that right at is",
                                        ' ',
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold text-slate-900",
                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.interestValue)
                                        }),
                                        model.interestValue > model.reasonableValue ? " \u2014 the home or build provided, taken at face value" : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                " \u2014 its limit under the ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                                    term: "reasonableness test"
                                                })
                                            ]
                                        }),
                                        model.deprivation > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                ' ',
                                                "\u2014 and the ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "font-semibold text-slate-900",
                                                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.deprivation)
                                                }),
                                                ' ',
                                                "given above it is a gift under the ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                                    term: "deprivation"
                                                }),
                                                " rules: less the",
                                                ' ',
                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0)),
                                                " a year that can be given freely, it is counted for five years."
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: " \u2014 and everything given sits within it, so none of it counts as a gift."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        "Because the total given is ",
                                        model.isHomeowner ? 'above' : 'at or below',
                                        " the",
                                        ' ',
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                            term: "Extra Allowable Amount"
                                        }),
                                        " (",
                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$e2cf792e99a08354)),
                                        "), Centrelink treats ",
                                        v.names,
                                        " as a",
                                        ' ',
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold text-slate-900",
                                            children: model.isHomeowner ? 'homeowner' : 'non-homeowner'
                                        }),
                                        model.isHomeowner ? " \u2014 the right is exempt from the assets test." : " \u2014 the amount paid is counted as an asset, but the higher asset limits apply and Rent Assistance may too."
                                    ]
                                }),
                                model.keepingHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        "The former home is ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold text-slate-900",
                                            children: "kept"
                                        }),
                                        model.keptHomeRented ? ' and rented out' : '',
                                        " \u2014 no one in the household lives in it any more, so Centrelink ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold text-slate-900",
                                            children: "counts it"
                                        }),
                                        " in the assets test",
                                        model.keptHomeRented ? ', with the rent counted as income' : '',
                                        ". This is usually the biggest driver of the pension change below."
                                    ]
                                }),
                                model.saleFlow && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        "Selling the ",
                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.saleFlow.homeValue),
                                        " home funds the arrangement",
                                        (model.saleFlow.residual || 0) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                "; the ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "font-semibold text-slate-900",
                                                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.saleFlow.residual)
                                                }),
                                                ' ',
                                                "left over stays countable"
                                            ]
                                        }),
                                        "."
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3 border-t border-slate-100 pt-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$e95813558e26ce51), {
                                variant: "expanded",
                                label: "Age Pension",
                                before: pensionBefore,
                                after: pensionAfter,
                                why: pensionWhy
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$e95813558e26ce51), {
                                variant: "expanded",
                                label: "Yearly cashflow",
                                before: cashflowBefore,
                                after: cashflowAfter,
                                why: cashflowWhy
                            }),
                            legacyDelta != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$e95813558e26ce51), {
                                variant: "expanded",
                                label: `Estate after ${legacyYears} ${legacyYears === 1 ? 'year' : 'years'} (what is left in ${estateWords}, vs staying put)`,
                                before: baselineLegacy,
                                after: legacyAfter,
                                suffix: "",
                                why: legacyWhy
                            }),
                            legacyDelta != null && hostLine && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1 text-[13px] text-slate-600",
                                "data-testid": "gf-host-line",
                                children: hostLine
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-1 text-[11px] text-slate-400",
                        children: 'For the Age Pension and cashflow, "before" is today and "after" is a full year with the plan. The estate compares two projections over the same years, not today\'s figure.'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1f2b2692daf0da1$export$d520641036c1ebe9), {
                className: "mt-4",
                pieces: planPieces
            })
        ]
    });
};
var $2384f8e2c7bd0a38$export$2e2bcd8739ae039 = $2384f8e2c7bd0a38$var$GrannyFlatPlanRecap;




















/**
 * Step 1 — the arrangement (granny flat rebuild, 21 Oct 2026; the agreed mock-up's j1 step 1).
 *
 * Top to bottom: the primer, shown once and folded after (what a granny flat right is, Centrelink's value of
 * it, the three forms taken at face value, get it in writing); then who they would live with (from the
 * profile: one of their children, another family member, a friend — never a name), what they would give
 * (not sure yet, cash, a build, the home signed over), what happens to the home, and when it would start;
 * then Centrelink's value of the right and the homeowner line, with what each means.
 *
 * Every answer is kept on the file (goals.gf*), so a return never resets it. The rules said here are the
 * verified ones (granny-flat rules, 2 Oct 2026): the home's title, the cost of a build, or a property bought
 * in the family's name, on its own, is taken at face value as the price of the right — no gift; cash, or
 * anything on top, is tested against Centrelink's value.
 */ 

var $acw62 = parcelRequire("acw62");







/**
 * WHAT CENTRELINK WOULD MAKE OF THE ARRANGEMENT, as step 1 is filled in (owner, 24 Oct 2026: with a build of
 * $600,000 entered, step 1 still said "Centrelink's value of the right $398,316 … pay more than that in cash and
 * the excess is a gift" — true only of cash).
 *
 * The same arithmetic as the shared formula (shared/src/calculation/grannyFlatArrangement.ts,
 * getGrannyFlatDeprivation — pinned equal by tests/gfCentrelinkView.test.ts), taking Centrelink's formula
 * value as given, so step 1 can redraw as they type without a calculation call:
 *
 *  - the home signed over, or the cost of a build, ON ITS OWN is taken at face value: that is the value of the
 *    right, and none of it is a gift, whatever it is worth;
 *  - cash, or cash on top of the home or a build, is tested: the right can be valued up to the greater of the
 *    formula value ("the limit") and the home or build; whatever is given above that is a gift;
 *  - a gift counts for five years, less what can be given freely ($10,000 a year);
 *  - homeowner status turns on the total given (cash + home + build), as the calc reads it
 *    (shared householdPosition: above the extra allowable amount, homeowners and the right is not counted; at
 *    or below it, non-homeowners, and the right counts as an asset).
 */ 
function $c6e404ce7f537892$export$9bf7cdb74b205947(args) {
    const form = args.form;
    const cash = form === 'unsure' ? 0 : Math.max(0, args.cash || 0);
    const build = form === 'build' ? Math.max(0, args.build || 0) : 0;
    const home = form === 'home' ? Math.max(0, args.home || 0) : 0;
    const limit = Math.max(0, args.limit || 0);
    const totalGiven = cash + build + home;
    const valueCeiling = Math.max(limit, home, build);
    const giftGross = Math.max(0, totalGiven - valueCeiling);
    return {
        form: form,
        cash: cash,
        build: build,
        home: home,
        totalGiven: totalGiven,
        limit: limit,
        valueCeiling: valueCeiling,
        valueOfRight: totalGiven - giftGross,
        giftGross: giftGross,
        giftCounted: Math.max(0, giftGross - (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0)),
        homeowner: totalGiven > (0, $1abe73eeef086faf$export$e2cf792e99a08354),
        homeownerLine: (0, $1abe73eeef086faf$export$e2cf792e99a08354)
    };
}




/**
 * The home signed over, in words (24 Oct 2026): its value on the start date when that is ahead, less any loan
 * the family member takes over with it, and what that leaves given for the right.
 */ function $3c33fc2d17e5ab0e$var$homeGivenWords(g) {
    const m = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
    const home = `${m(g.homeValue)} home${g.grown ? ' (its value at the start date)' : ''}`;
    return g.loans >= 1 ? `${home}, less the ${m(g.loans)} loan the family member takes over with it \u{2014} ${m(g.given)} given \u{2014}` : home;
}
const $3c33fc2d17e5ab0e$var$card = 'rounded-2xl border border-slate-200 bg-white p-6 shadow-card';
const $3c33fc2d17e5ab0e$var$input = 'rounded-lg border border-slate-300 bg-white px-3 py-2 text-[15px] font-semibold text-slate-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-500';
const $3c33fc2d17e5ab0e$var$link = 'font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy';
/** One question: the rule-lined heading of the mock-up. */ const $3c33fc2d17e5ab0e$var$Q = ({ title: title, children: children, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "shrink-0 text-[14px] font-semibold text-slate-900",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "h-px flex-1 bg-slate-200",
                        "aria-hidden": true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-2.5",
                children: children
            })
        ]
    });
const $3c33fc2d17e5ab0e$var$Radio = ({ name: name, checked: checked, onChange: onChange, children: children, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
        className: "flex cursor-pointer items-start gap-2.5 py-1 text-[14.5px] text-slate-700",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "radio",
                name: name,
                checked: checked,
                onChange: onChange,
                className: "mt-1 h-4 w-4 accent-blue-600",
                "data-testid": testId
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: children
            })
        ]
    });
/*
 * WHAT CENTRELINK WOULD MAKE OF THIS (owner, 24 Oct 2026: a $600,000 build still showed "Centrelink's value of
 * the right $398,316 … pay more than that in cash and the excess is a gift"). Redrawn from what is entered, form
 * by form (gfCentrelinkView.ts): the value of the right, any gift and the part of it counted, and which side of
 * the homeowner line the total falls — both sides said in plain words.
 */ function $3c33fc2d17e5ab0e$var$CentrelinkPanel({ f: f, give: give, v: v, homeGiven: homeGiven }) {
    const homeValue = homeGiven.given;
    const money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
    if (!f) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "text-[13px] text-slate-500",
        children: "Working out Centrelink's value of the right\u2026"
    });
    const valueSub = give === 'build' && f.cash === 0 ? 'the cost of the build, taken at face value' : give === 'home' && f.cash === 0 ? "the home\u2019s value, taken at face value" : give === 'build' ? 'the build, and the cash on top up to the limit' : give === 'home' ? 'the home, and the cash on top up to the limit' : 'the cash, up to the limit';
    const tile = (label, value, sub, testId)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "px-4 py-3.5",
            "data-testid": testId,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-[12.5px] text-slate-500",
                    children: label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "mt-0.5 text-[22px] font-bold tabular-nums text-brand-navy",
                    children: value
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "mt-0.5 text-[12.5px] leading-snug text-slate-500",
                    children: sub
                })
            ]
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "gf-value-box",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "shrink-0 text-[14px] font-semibold text-slate-900",
                        children: "What Centrelink would make of this"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "h-px flex-1 bg-slate-200",
                        "aria-hidden": true
                    })
                ]
            }),
            give === 'unsure' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-2.5 grid grid-cols-1 overflow-hidden rounded-xl border border-slate-200 sm:grid-cols-3 sm:divide-x sm:divide-slate-200",
                        "data-testid": "gf-unsure-guide",
                        children: [
                            tile('Cash', money(f.limit), 'the most without any of it being a gift; above it, the excess is a gift for five years', 'gf-unsure-cash'),
                            tile('A build they pay for', 'Its cost', 'taken at face value: no gift, whatever it costs', 'gf-unsure-build'),
                            tile('Their home, signed over', homeValue > 0 ? money(homeValue) : 'Its value', 'taken at face value: no gift, whatever it is worth', 'gf-unsure-home')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-3 text-[13.5px] leading-relaxed text-slate-600",
                        "data-testid": "gf-homeowner-line",
                        children: [
                            "Give more than ",
                            money(f.homeownerLine),
                            " and ",
                            v.they,
                            " stay ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-slate-900",
                                children: "homeowners"
                            }),
                            " for the Age Pension, and the right is not counted. Give that or less and ",
                            v.they,
                            " are ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-slate-900",
                                children: "not homeowners"
                            }),
                            ": the right counts as an asset and the higher non-homeowner limits apply. Choose a way above to see the figures for it."
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-2.5 grid grid-cols-1 overflow-hidden rounded-xl border border-slate-200 sm:grid-cols-3 sm:divide-x sm:divide-slate-200",
                        children: [
                            tile('Value of the right', /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                "data-testid": "gf-value-of-right",
                                children: money(f.valueOfRight)
                            }), valueSub),
                            tile('Counted as a gift', f.giftCounted >= 1 ? money(f.giftCounted) : '$0', f.giftGross >= 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    money(f.giftGross),
                                    " above what the right is worth, less the ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0)),
                                    " that can be given freely in a year; counted for five years"
                                ]
                            }) : 'nothing is given above what the right is worth', 'gf-gift-tile'),
                            tile('Homeowners for the Age Pension', f.homeowner ? 'Yes' : 'No', /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "given ",
                                    money(f.totalGiven),
                                    "; the line is ",
                                    money(f.homeownerLine)
                                ]
                            }), 'gf-homeowner-tile')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3 space-y-2 text-[13.5px] leading-relaxed text-slate-600",
                        children: [
                            give === 'build' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "The cost of a build ",
                                    v.they,
                                    " pay for is taken at face value: it is the price of the right, and none of it is a gift, whatever it costs. Cash on top is tested: the right can be valued up to the greater of the build and Centrelink's limit (",
                                    money(f.limit),
                                    "), and anything given above that is a gift."
                                ]
                            }),
                            give === 'home' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "The ",
                                    $3c33fc2d17e5ab0e$var$homeGivenWords(homeGiven),
                                    " signed over is taken at face value: it is the price of the right, and none of it is a gift, whatever it is worth. Cash on top is tested: the right can be valued up to the greater of the home and Centrelink's limit (",
                                    money(f.limit),
                                    "), and anything given above that is a gift."
                                ]
                            }),
                            give === 'cash' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                "data-testid": "gf-limit-line",
                                children: [
                                    "The most ",
                                    v.they,
                                    " can pay in cash without any of it being a gift is ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "tabular-nums text-slate-900",
                                        children: money(f.limit)
                                    }),
                                    " \u2014 Centrelink's limit for a lifetime right at ",
                                    v.their,
                                    " age. Pay more and the excess is a gift, counted for five years."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                "data-testid": "gf-homeowner-line",
                                children: f.homeowner ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        v.They,
                                        " would give ",
                                        money(f.totalGiven),
                                        ", more than ",
                                        money(f.homeownerLine),
                                        ", so ",
                                        v.they,
                                        " stay ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            className: "text-slate-900",
                                            children: "homeowners"
                                        }),
                                        " for the Age Pension: the right is not counted as an asset, and the homeowner limits apply."
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        v.They,
                                        " would give ",
                                        money(f.totalGiven),
                                        ", not more than ",
                                        money(f.homeownerLine),
                                        ", so ",
                                        v.they,
                                        " are ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            className: "text-slate-900",
                                            children: "not homeowners"
                                        }),
                                        " for the Age Pension: the right counts as an asset, and the higher non-homeowner limits apply."
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $3c33fc2d17e5ab0e$export$be6ce8332e69af13(factFind) {
    const goals = factFind?.goals;
    const g = goals?.gfGive;
    if (g === 'cash' || g === 'build' || g === 'home' || g === 'unsure') return g;
    // A file set up before the rebuild with "sign it over" chosen gave the home.
    return goals?.gfHomeRoute === 'transfer' ? 'home' : 'unsure';
}
const $3c33fc2d17e5ab0e$var$GfStep1 = ({ factFind: factFind, setFactFind: setFactFind, reasonableValue: reasonableValue, onNext: onNext, onReadGuide: onReadGuide, onFamilyGuide: onFamilyGuide })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const goals = factFind?.goals || {};
    const setGoal = (patch)=>setFactFind?.((prev)=>({
                ...prev,
                goals: {
                    ...prev?.goals || {},
                    ...patch
                }
            }));
    const homeValue = parseFloat(String(factFind?.home?.value ?? '')) || 0;
    const hasHome = homeValue > 0;
    const hasInvestmentProperty = (factFind?.assets?.investmentProperty || []).some((p)=>(parseFloat(String(p?.value ?? '')) || 0) > 0);
    const host = (0, $32bd8c8afa665e9e$export$2b2184b5390b1cd2)(factFind);
    const hostHome = (0, $32bd8c8afa665e9e$export$f61aefdb7cc5750d)(factFind);
    const give = $3c33fc2d17e5ab0e$export$be6ce8332e69af13(factFind);
    const route = goals.gfHomeRoute === 'keep' || goals.gfHomeRoute === 'sell' ? goals.gfHomeRoute : 'all';
    const startDate = String(goals.gfStartDate || '');
    const todayIso = new Date().toISOString().slice(0, 10);
    const rv = reasonableValue != null ? Math.round(reasonableValue) : null;
    const knownAmount = Number(goals.gfKnownAmount) > 0 ? Number(goals.gfKnownAmount) : 0;
    const extraCash = Number(goals.gfKnownExtraCash) > 0 ? Number(goals.gfKnownExtraCash) : 0;
    /*
     * EACH WAY OF PAYING KEEPS ITS OWN AMOUNT (owner, 24 Oct 2026: switching from a $600,000 build to cash carried
     * the $600,000 across as cash). The file holds one amount and one "cash on top" (goals.gfKnownAmount /
     * gfKnownExtraCash, what the plans read); a switch puts away what was entered for the way being left and
     * brings back what was entered for the way chosen, or nothing.
     */ const stash = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({});
    const chooseGive = (next)=>{
        if (next === give) return;
        stash.current[give] = {
            amount: knownAmount,
            extra: extraCash
        };
        const back = stash.current[next] || {
            amount: 0,
            extra: 0
        };
        setGoal({
            gfGive: next,
            gfKnownAmount: next === 'cash' || next === 'build' ? back.amount : 0,
            gfKnownExtraCash: next === 'build' || next === 'home' ? back.extra : 0
        });
    };
    // What signing the home over gives: on the start date, less the loans on it (24 Oct 2026).
    const homeGiven = (0, $a528307a9ba99a26$export$828d07fe6ecf7e29)(factFind, (0, $576b15178c677e44$export$37d7ba658a355219)(startDate) || null);
    const transferUnavailable = (0, $576b15178c677e44$export$dc63b614bb30b736)(factFind, startDate || null);
    const figures = rv == null ? null : (0, $c6e404ce7f537892$export$9bf7cdb74b205947)({
        form: give,
        // Cash left blank is tested at the limit, so none of it is a gift.
        cash: give === 'cash' ? knownAmount || rv : extraCash,
        build: knownAmount,
        home: homeGiven.given,
        limit: rv
    });
    // Without a date of birth the right cannot be valued: Centrelink's factor depends on age (24 Oct 2026).
    const noDob = (0, $576b15178c677e44$export$fb07bda88c1da18b)(factFind);
    // The primer is shown once, then folds to one line that opens it again.
    const primerSeen = goals.gfPrimerSeen === true;
    const [primerOpen, setPrimerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(!primerSeen);
    (0, $acw62.useEffect)(()=>{
        if (!primerSeen) setGoal({
            gfPrimerSeen: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // The guide links: under the open primer, beside "Show" when it is folded (23 Oct 2026).
    const primerLinks = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onReadGuide,
                className: $3c33fc2d17e5ab0e$var$link,
                "data-testid": "gf-read-guide",
                children: "Read the full guide"
            }),
            " \xb7 ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onFamilyGuide,
                className: $3c33fc2d17e5ab0e$var$link,
                "data-testid": "gf-step1-family-guide",
                children: "The family discussion guide"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        "data-testid": "gf-step1",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: `${$3c33fc2d17e5ab0e$var$card} ${(0, $e1e942361049df06$export$10832a06bd6966f8)}`,
                "data-testid": "gf-primer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1e942361049df06$export$eb5dff254945ec0e), {
                        title: "Granny flat arrangements, in a minute",
                        open: primerOpen,
                        onToggle: ()=>setPrimerOpen((o)=>!o),
                        aside: primerLinks,
                        testId: "gf-primer-toggle"
                    }),
                    primerOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3 grid grid-cols-1 gap-x-8 gap-y-2.5 text-[14px] leading-relaxed text-slate-700 md:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: (0, $e1e942361049df06$export$60f4f4563d451e62),
                                        children: [
                                            v.you ? 'You give' : `${v.Names} give${v.s}`,
                                            " money or ",
                                            v.their,
                                            " home in return for a right to live with family for life."
                                        ]
                                    }),
                                    " It is a family agreement, not a property purchase, and it can be with a friend too."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: (0, $e1e942361049df06$export$60f4f4563d451e62),
                                        children: [
                                            "Centrelink puts a value on that right",
                                            rv != null ? `: ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(rv)} for ${v.names} today` : '',
                                            "."
                                        ]
                                    }),
                                    " Pay cash up to that and none of it is a gift."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                "data-testid": "gf-primer-gift",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: (0, $e1e942361049df06$export$60f4f4563d451e62),
                                        children: "Why a gift matters."
                                    }),
                                    " Centrelink lets ",
                                    v.names,
                                    " give away up to ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0)),
                                    " a year, and ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9cd36ea38af5a5f3)),
                                    " over five years",
                                    v.couple ? ' between them' : '',
                                    ". Anything given above that still counts as ",
                                    v.you ? 'yours' : v.couple ? 'theirs' : v.possessive,
                                    " for five years, as an asset and as deemed income, even though it has gone, so it can lower the Age Pension."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: (0, $e1e942361049df06$export$60f4f4563d451e62),
                                        children: [
                                            "Signing ",
                                            v.their,
                                            " home over, or paying for a build, is taken at face value"
                                        ]
                                    }),
                                    " \u2014 never a gift on its own, whatever it is worth.",
                                    hasInvestmentProperty ? ' An investment property is different: it is not the home, so signed over it is tested like cash.' : ''
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "md:col-span-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: (0, $e1e942361049df06$export$60f4f4563d451e62),
                                        children: "Get it in writing."
                                    }),
                                    " The right depends on the relationship; a solicitor's agreement protects everyone."
                                ]
                            })
                        ]
                    }),
                    primerOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-3 text-[13px] text-slate-500",
                        children: primerLinks
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: `${$3c33fc2d17e5ab0e$var$card} space-y-6`,
                "data-testid": "gf-arrangement",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3c33fc2d17e5ab0e$var$Q, {
                        title: `Who would ${v.names} live with?`,
                        testId: "gf-q-host",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex flex-wrap items-center gap-2",
                                role: "radiogroup",
                                "aria-label": "Who they would live with",
                                children: (0, $32bd8c8afa665e9e$export$8363795918a7ca5e)(factFind).map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        role: "radio",
                                        "aria-checked": host === o.id,
                                        onClick: ()=>setGoal({
                                                gfHost: o.id
                                            }),
                                        "data-testid": `gf-host-${o.id}`,
                                        className: `rounded-lg border px-3.5 py-2 text-[14px] ${host === o.id ? 'border-blue-600 bg-blue-50 font-semibold text-brand-navy' : 'border-slate-300 text-slate-700 hover:border-blue-300'}`,
                                        children: [
                                            host === o.id ? "\u2713 " : '',
                                            o.label
                                        ]
                                    }, o.id))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-2 text-[13px] text-slate-500",
                                children: "So the plan can say who it is with. No names are needed."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3c33fc2d17e5ab0e$var$Q, {
                        title: `What would ${v.names} give for the right?`,
                        testId: "gf-q-give",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3c33fc2d17e5ab0e$var$Radio, {
                                name: "gf-give",
                                checked: give === 'unsure',
                                onChange: ()=>chooseGive('unsure'),
                                testId: "gf-give-unsure",
                                children: [
                                    "Not sure yet \u2014 show ",
                                    v.them,
                                    " the options"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3c33fc2d17e5ab0e$var$Radio, {
                                name: "gf-give",
                                checked: give === 'cash',
                                onChange: ()=>chooseGive('cash'),
                                testId: "gf-give-cash",
                                children: "Cash"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3c33fc2d17e5ab0e$var$Radio, {
                                name: "gf-give",
                                checked: give === 'build',
                                onChange: ()=>chooseGive('build'),
                                testId: "gf-give-build",
                                children: [
                                    "Paying for a build or extension at ",
                                    hostHome
                                ]
                            }),
                            hasHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3c33fc2d17e5ab0e$var$Radio, {
                                name: "gf-give",
                                checked: give === 'home',
                                onChange: ()=>chooseGive('home'),
                                testId: "gf-give-home",
                                children: [
                                    v.Their,
                                    " home, signed over"
                                ]
                            }),
                            give === 'cash' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "ml-6 mt-2 flex flex-wrap items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                        value: knownAmount > 0 ? knownAmount : '',
                                        onChange: (x)=>setGoal({
                                                gfKnownAmount: Math.max(0, x ?? 0)
                                            }),
                                        className: "w-40",
                                        ariaLabel: "How much cash",
                                        placeholder: "Not sure"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-[13px] text-slate-500",
                                        children: [
                                            "If ",
                                            v.they,
                                            " know the amount. Blank, and we test Centrelink's limit",
                                            rv != null ? `, ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(rv)}` : '',
                                            ", so none of it is a gift."
                                        ]
                                    })
                                ]
                            }),
                            give === 'build' && knownAmount <= 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "ml-6 mt-2 text-[13px] font-semibold text-rose-700",
                                "data-testid": "gf-build-needs-cost",
                                children: "No build plan is tested until the cost is entered."
                            }),
                            give === 'build' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "ml-6 mt-2 space-y-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-wrap items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                value: knownAmount > 0 ? knownAmount : '',
                                                onChange: (x)=>setGoal({
                                                        gfKnownAmount: Math.max(0, x ?? 0)
                                                    }),
                                                className: "w-40",
                                                ariaLabel: "Cost of the build",
                                                placeholder: "The quote"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-[13px] text-slate-500",
                                                children: "The builder's quote. The cost of the build is the price of the right \u2014 no gift, whatever it costs. Keep the contract and invoices."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-wrap items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                value: extraCash > 0 ? extraCash : '',
                                                onChange: (x)=>setGoal({
                                                        gfKnownExtraCash: Math.max(0, x ?? 0)
                                                    }),
                                                className: "w-40",
                                                ariaLabel: "Cash on top of the build",
                                                placeholder: "None"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-[13px] text-slate-500",
                                                children: "Cash on top of the build, if any. Anything on top is tested: above the greater of the build's cost and Centrelink's limit, it is a gift."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            give === 'home' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "ml-6 mt-2 space-y-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-[13.5px] text-slate-700",
                                        "data-testid": "gf-give-home-line",
                                        children: [
                                            "The ",
                                            $3c33fc2d17e5ab0e$var$homeGivenWords(homeGiven),
                                            " pays for the right. Centrelink takes it at face value, so none of it is a gift, whatever it is worth."
                                        ]
                                    }),
                                    transferUnavailable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-[13.5px] font-semibold text-rose-700",
                                        "data-testid": "gf-transfer-unavailable",
                                        children: transferUnavailable
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-wrap items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                value: extraCash > 0 ? extraCash : '',
                                                onChange: (x)=>setGoal({
                                                        gfKnownExtraCash: Math.max(0, x ?? 0)
                                                    }),
                                                className: "w-40",
                                                ariaLabel: "Cash on top of the home",
                                                placeholder: "None"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-[13px] text-slate-500",
                                                children: "Cash on top of the home, if any. It is tested: above the greater of the home's value and Centrelink's limit, it is a gift."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            give === 'unsure' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "ml-6 mt-2 space-y-1.5 text-[13.5px] leading-relaxed text-slate-600",
                                "data-testid": "gf-give-unsure-line",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "The ways to pay, and what Centrelink makes of each:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                        className: "list-disc space-y-1 pl-5",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        className: "text-slate-800",
                                                        children: "Cash"
                                                    }),
                                                    " \u2014 tested: up to Centrelink's limit",
                                                    rv != null ? ` (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(rv)})` : '',
                                                    " is not a gift; above it, the excess is."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        className: "text-slate-800",
                                                        children: "Paying for a build"
                                                    }),
                                                    " \u2014 taken at face value: the cost is the price of the right, never a gift on its own."
                                                ]
                                            }),
                                            hasHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                        className: "text-slate-800",
                                                        children: [
                                                            v.Their,
                                                            " home, signed over"
                                                        ]
                                                    }),
                                                    " \u2014 taken at face value too, whatever it is worth."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        className: "text-slate-800",
                                                        children: "Moving in, paying nothing"
                                                    }),
                                                    " \u2014 no right is bought, so no gift",
                                                    hasHome ? `; ${v.their} home is counted from the day ${v.they} move` : '',
                                                    "."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            "The plans test cash at the limit",
                                            hasHome ? `, ${v.their} home signed over` : '',
                                            " and moving in with nothing paid. A build needs its cost: choose \u201CPaying for a build\u201D and enter the quote to see build plans."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    hasHome && give !== 'home' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3c33fc2d17e5ab0e$var$Q, {
                        title: `What would happen to ${v.their} home?`,
                        testId: "gf-q-home",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3c33fc2d17e5ab0e$var$Radio, {
                                name: "gf-home",
                                checked: route === 'keep',
                                onChange: ()=>setGoal({
                                        gfHomeRoute: 'keep'
                                    }),
                                testId: "gf-home-keep",
                                children: [
                                    "Keep it, and rent it out ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-[13px] text-slate-500",
                                        children: "(keeping it empty is tested too)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3c33fc2d17e5ab0e$var$Radio, {
                                name: "gf-home",
                                checked: route === 'sell',
                                onChange: ()=>setGoal({
                                        gfHomeRoute: 'sell'
                                    }),
                                testId: "gf-home-sell",
                                children: "Sell it"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3c33fc2d17e5ab0e$var$Radio, {
                                name: "gf-home",
                                checked: route === 'all',
                                onChange: ()=>setGoal({
                                        gfHomeRoute: 'all'
                                    }),
                                testId: "gf-home-compare",
                                children: "Compare these"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-1 text-[13px] text-slate-500",
                                children: [
                                    "Either way it stops being exempt the day ",
                                    v.they,
                                    " move.",
                                    give === 'unsure' ? ' Signing it over is tested too, while the payment is undecided.' : ''
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3c33fc2d17e5ab0e$var$Q, {
                        title: "When would it start?",
                        testId: "gf-q-start",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        id: "gf-event-date",
                                        type: "date",
                                        value: startDate,
                                        onChange: (e)=>setGoal({
                                                gfStartDate: e.target.value
                                            }),
                                        className: `${$3c33fc2d17e5ab0e$var$input} font-normal`,
                                        "aria-label": "When the arrangement would start"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-[13px] text-slate-500",
                                        children: startDate === '' ? 'Leave this blank to model it from today, the usual case.' : startDate < todayIso ? "A past date models as \u201Cstarting now\u201D. An arrangement that already exists belongs in the profile instead." : 'Life as it is until then, then the arrangement.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1.5 text-[12.5px] text-slate-500",
                                children: "The date sets the age the right is valued at and starts the five-year gift clock."
                            })
                        ]
                    }),
                    noDob && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "rounded-xl border border-slate-200 border-l-4 border-l-rose-500 bg-white px-4 py-3 text-[13.5px] text-slate-700",
                        "data-testid": "gf-no-dob",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-slate-900",
                                children: "A date of birth is missing from the profile."
                            }),
                            " Centrelink values the right by age, so the figures below cannot be relied on until it is entered."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3c33fc2d17e5ab0e$var$CentrelinkPanel, {
                        f: figures,
                        give: give,
                        v: v,
                        homeGiven: homeGiven
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-wrap items-center justify-end gap-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    type: "button",
                    onClick: onNext,
                    "data-testid": "gf-step1-next",
                    className: "inline-flex h-11 items-center gap-2 rounded-lg bg-blue-600 hover:bg-blue-700 px-5 text-[14px] font-semibold text-white shadow-sm ",
                    children: [
                        "See what this means for ",
                        v.them,
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                            size: 16
                        })
                    ]
                })
            })
        ]
    });
};
var $3c33fc2d17e5ab0e$export$2e2bcd8739ae039 = $3c33fc2d17e5ab0e$var$GfStep1;


/**
 * Step 2 — what it means for them (granny flat rebuild, 21 Oct 2026; the agreed mock-up's j1 step 2).
 *
 * Not entering the arrangement in four numbers, with "See the year-by-year figures" beneath: the baseline
 * every plan on step 3 is measured against. Then the two sentences that matter for a granny flat (review):
 * the home stops being exempt the day they move, and what they give leaves their estate though it stays
 * with the person they live with. Then what the right is worth, and how long the money lasts.
 *
 * ONE SOURCE, as the village: the pension and cashflow are today's assessment (`todayFinancials`), the
 * estate and the runway the not-entering projection — the same run the engine's own baseline makes.
 */ 

var $acw62 = parcelRequire("acw62");










const $5237a01799695368$var$card = 'rounded-2xl border border-slate-200 bg-white p-6 shadow-card';
const $5237a01799695368$var$Tile = ({ label: label, value: value, unit: unit, caption: caption, tone: tone })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-xl border border-slate-200 bg-white px-4 py-4 shadow-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[12.5px] font-semibold text-slate-500",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: `mt-1 text-[26px] font-bold leading-none tabular-nums tracking-tight ${tone === 'good' ? 'text-emerald-700' : tone === 'bad' ? 'text-rose-700' : 'text-slate-900'}`,
                children: [
                    value,
                    unit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ml-1 text-[13px] font-semibold text-slate-500",
                        children: unit
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-[12.5px] leading-snug text-slate-500",
                children: caption
            })
        ]
    });
const $5237a01799695368$var$GfStep2 = ({ factFind: factFind, todayFinancials: todayFinancials, stayPutLegacy: stayPutLegacy, runway: runway, legacyYears: legacyYears, reasonableValue: reasonableValue, onLegacyYearsChange: onLegacyYearsChange, onBack: onBack, onNext: onNext, onReadGuide: onReadGuide, onAssumptions: onAssumptions, onShowProjections: onShowProjections })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const ready = !!todayFinancials;
    const pension = todayFinancials?.socialSecurity ?? 0;
    const cashFlow = todayFinancials?.cashFlow ?? 0;
    const netWorth = todayFinancials?.netWorth ?? 0;
    const years = Number(legacyYears) || 0;
    const homeValue = parseFloat(String(factFind?.home?.value ?? '')) || 0;
    const host = (0, $32bd8c8afa665e9e$export$d71f476d519c5ae3)(factFind);
    const hostKind = (0, $32bd8c8afa665e9e$export$2b2184b5390b1cd2)(factFind);
    const [showWhy, setShowWhy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const rv = reasonableValue != null ? Math.round(reasonableValue) : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        "data-testid": "gf-step2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: "text-[24px] font-bold tracking-tight text-brand-navy",
                        children: [
                            "If ",
                            v.names,
                            " stay",
                            v.s,
                            " where ",
                            v.they,
                            " are"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1 text-[15px] text-slate-600",
                        children: [
                            "Staying put \u2014 not entering the arrangement \u2014 in four numbers. Every way of setting it up on the next step is measured against these, which the cards call \u201C",
                            (0, $1a5a24a0286ded56$export$b3949d624101f360)('grannyFlat').word,
                            "\u201D."
                        ]
                    })
                ]
            }),
            !ready ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "rounded-xl border border-dashed border-slate-300 bg-white px-4 py-6 text-center text-[14px] text-slate-600",
                children: "Working out today's position\u2026"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4",
                        "data-testid": "gf-four-numbers",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5237a01799695368$var$Tile, {
                                label: "Age Pension",
                                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(pension)),
                                unit: "a year",
                                caption: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        v.couple ? 'the two of them' : 'a year',
                                        " \xb7 ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setShowWhy((o)=>!o),
                                            className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2",
                                            children: "why?"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5237a01799695368$var$Tile, {
                                label: cashFlow < 0 ? 'Short each year' : 'Left over each year',
                                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(cashFlow))),
                                tone: cashFlow < 0 ? 'bad' : 'good',
                                caption: cashFlow < 0 ? 'money in, less money out; met from savings' : 'money in, less money out'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5237a01799695368$var$Tile, {
                                label: `What ${v.they} own`,
                                value: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(netWorth)),
                                caption: homeValue > 0 ? 'the home included, less what is owed' : 'less what is owed'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5237a01799695368$var$Tile, {
                                label: "Left to the family",
                                value: stayPutLegacy != null ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(stayPutLegacy)) : "\u2014",
                                caption: stayPutLegacy != null ? onLegacyYearsChange ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9873a6fbc9fd360$export$68741d4d7bc37a6d), {
                                    years: years,
                                    onChange: onLegacyYearsChange,
                                    after: " not entering the arrangement."
                                }) : `after about ${years} years` : 'not available: the projection could not be run'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[14px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onShowProjections,
                                className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                "data-testid": "gf-step2-year-by-year",
                                children: "See the year-by-year figures, not entering"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-slate-500",
                                children: [
                                    " \u2014 Age Pension, money in and out, and what ",
                                    v.they,
                                    " own, each year for about ",
                                    years,
                                    " years."
                                ]
                            })
                        ]
                    }),
                    showWhy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $5237a01799695368$var$card,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$28c8139bd562d0e), {
                            eyebrow: `Why ${v.possessive} Age Pension is ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(pension))}`,
                            className: "-m-5 border-0 bg-transparent shadow-none",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eec331ce661055d2$export$836922263996c16c), {
                                careDepositRelevant: false,
                                financials: todayFinancials,
                                isCouple: factFind?.adviceFor === 'couple',
                                name: v.names,
                                alsoMoves: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        "changes how Centrelink treats what ",
                                        v.they,
                                        " give for the granny flat"
                                    ]
                                }),
                                whereNext: "The ways to set it up on the next step"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $5237a01799695368$var$card,
                "data-testid": "gf-what-changes",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[12px] font-semibold text-brand-navy",
                        children: [
                            "What moving in with ",
                            host,
                            " changes"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                        className: "mt-2 list-disc space-y-2 pl-5 text-[15px] leading-relaxed text-slate-700",
                        children: [
                            homeValue > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: "text-slate-900",
                                        children: [
                                            v.Their,
                                            " ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(homeValue),
                                            " home stops being exempt the day ",
                                            v.they,
                                            " move."
                                        ]
                                    }),
                                    " Kept or sold, it is counted for the Age Pension from then: there is no grace period for this kind of move. The next step shows what each way does to the pension."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: "text-slate-900",
                                        children: [
                                            "What ",
                                            v.they,
                                            " give ",
                                            host,
                                            " leaves ",
                                            v.their,
                                            " estate."
                                        ]
                                    }),
                                    " It is ",
                                    hostKind ? `${host}\u{2019}s` : 'theirs',
                                    " from that day, so the next step shows it beside the estate figure rather than in it \u2014 it is not lost",
                                    hostKind === 'child' || hostKind === 'family' ? ', and it stays in the family' : '',
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: "text-slate-900",
                                        children: [
                                            "The most ",
                                            v.names,
                                            " can pay in cash for a lifetime right without any of it counting as a gift is ",
                                            rv != null ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(rv) : "\u2026"
                                        ]
                                    }),
                                    " \u2014 Centrelink's limit for a lifetime right at ",
                                    v.their,
                                    " age. Signing over the home or paying for a build is taken at face value instead, never a gift on its own. Give more than ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$e2cf792e99a08354)),
                                    " in all and ",
                                    v.they,
                                    " stay homeowners for the Age Pension, with the right not counted; give that or less and ",
                                    v.they,
                                    " are not homeowners, and the right counts as an asset."
                                ]
                            })
                        ]
                    }),
                    runway && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-5 text-[12px] font-semibold text-brand-navy",
                                children: "How long the money lasts, staying put"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c05f3bca3803eec$export$7fbbcd423808f3d5), {
                                    headline: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-[15px] text-slate-700",
                                        children: runway.headline
                                    }),
                                    coveredPct: runway.coveredPct,
                                    leftLabel: runway.leftLabel,
                                    rightLabel: runway.rightLabel,
                                    depleted: runway.depleted,
                                    flag: runway.flag
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] text-slate-500",
                children: [
                    "Figures use the rates in force from ",
                    (0, $1abe73eeef086faf$export$946308c675ba021d).agePension,
                    ". ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onAssumptions,
                        className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2",
                        children: "What the figures assume"
                    }),
                    " \xb7 ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onReadGuide,
                        className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2",
                        children: "Read the overview of granny flat arrangements"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onBack,
                        className: "inline-flex items-center gap-1 text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                size: 15
                            }),
                            " Change the arrangement"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onNext,
                        disabled: !ready,
                        "data-testid": "gf-step2-next",
                        className: "inline-flex h-11 items-center gap-2 rounded-lg bg-blue-600 hover:bg-blue-700 px-5 text-[14px] font-semibold text-white shadow-sm disabled:cursor-not-allowed disabled:opacity-50",
                        children: [
                            "See ways to set it up ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                size: 16
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $5237a01799695368$export$2e2bcd8739ae039 = $5237a01799695368$var$GfStep2;


/**
 * Step 3's questions — before the plans run, and again under "Things that change the answer" (granny flat
 * rebuild, 21 Oct 2026; the agreed mock-up's j1 questions screen, with the village's rulings carried over).
 *
 * Only the levers the client actually has, each asked only where a plan turns on it:
 *   1. has the family talked it through — the family discussion guide, linked (its answers go into a brief
 *      for the solicitor);
 *   2. if they keep the home and rent it out: the rent, its yearly costs and the weeks it sits empty (two,
 *      suggested), with the check on land tax — asked only where keeping the home is tested;
 *   3. the money kept for emergencies (kept back when money moves, drawn on only if a year runs short);
 *   4. whether they would consider a guaranteed income for life — the shared question every module uses,
 *      the client's own answer, "we work out how much" — asked only where a sale frees money to put in one;
 *   5. moving out of a village: when the current unit is paid out;
 *   6. where a sale frees money: the state a bought property's stamp duty is struck in (said, not asked
 *      again, when the file has one) and how money that is invested is assumed to be invested;
 * and the years, as a default on one line. "Build a plan yourself instead" sits beside the run button.
 */ 

var $acw62 = parcelRequire("acw62");















const $fdeb548393f050ad$var$num = (x, d = 0)=>x != null && x !== '' && Number.isFinite(Number(x)) ? Number(x) : d;
function $fdeb548393f050ad$export$ffdbe83affa25ff4(homeValue, fair, reserve, bankToday) {
    const sellCosts = Math.round(homeValue * 0.025);
    const reserveTopUp = Math.max(0, reserve - bankToday);
    return Math.max(0, homeValue - sellCosts - fair - reserveTopUp);
}
function $fdeb548393f050ad$export$42f411d400ba8538(factFind) {
    const g = factFind?.goals || {};
    const appetite = (0, $ff5de4128b46b139$export$636a9065c3f862c1)(factFind).appetite;
    const likelyRent = $fdeb548393f050ad$var$num(factFind?.home?.likelyRent);
    const rentPerWeek = $fdeb548393f050ad$var$num(g.gfRentPerWeek, likelyRent > 0 ? likelyRent : Math.round($fdeb548393f050ad$var$num(factFind?.home?.value) * 0.035 / 52));
    // A year of costs: the client's, else the profile's, else a quarter of the rent (owner's granny flat review,
    // 24 Oct 2026). It defaulted to $0 when the profile had none, and that $0 was then saved as an answer, so
    // every let home was modelled with no rates, insurance or repairs at all.
    const profileCosts = $fdeb548393f050ad$var$num(factFind?.home?.likelyExpenses);
    return {
        rentPerWeek: rentPerWeek,
        rentCosts: $fdeb548393f050ad$var$num(g.gfRentCosts, profileCosts > 0 ? profileCosts : Math.round(rentPerWeek * 13)),
        vacancyWeeks: $fdeb548393f050ad$var$num(g.gfVacancyWeeks, (0, $576b15178c677e44$export$4a9fb6bdf3fe5eb2)),
        emergencyReserve: $fdeb548393f050ad$var$num(g.gfEmergencyReserve, (0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind)),
        annuity: appetite === 'none' ? 'none' : 'yes',
        guaranteedIncome: null,
        purchaseState: (0, $576b15178c677e44$export$acf534e7eb17fe32)(factFind),
        oldUnitPaysAtMove: g.gfOldUnitPaysAtMove !== false,
        investProfile: String(g.newMoneyInvestmentProfile || ''),
        years: $fdeb548393f050ad$var$num(g.gfLegacyYears, 10)
    };
}
function $fdeb548393f050ad$export$cdf6ac86b6cfac7f(a) {
    return {
        gfRentPerWeek: a.rentPerWeek,
        gfRentCosts: a.rentCosts,
        gfVacancyWeeks: a.vacancyWeeks,
        gfEmergencyReserve: a.emergencyReserve,
        ...a.guaranteedIncome || {},
        gfPurchaseState: a.purchaseState,
        gfOldUnitPaysAtMove: a.oldUnitPaysAtMove,
        ...a.investProfile ? {
            newMoneyInvestmentProfile: a.investProfile
        } : {},
        gfLegacyYears: a.years
    };
}
const $fdeb548393f050ad$var$link = 'font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy';
const $fdeb548393f050ad$var$Why = ({ open: open, onToggle: onToggle, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            ' ',
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onToggle,
                "aria-expanded": open,
                className: "text-[12px] font-semibold text-blue-700 underline decoration-dotted underline-offset-2",
                children: "what's this?"
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "mt-1.5 block rounded-lg border border-slate-200 border-l-4 border-l-blue-500 bg-white px-3 py-2 text-[13px] font-normal leading-relaxed text-slate-700",
                children: children
            })
        ]
    });
const $fdeb548393f050ad$var$Radio = ({ name: name, checked: checked, onChange: onChange, children: children, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
        className: "flex cursor-pointer items-start gap-2 py-1 text-[14px] text-slate-700",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "radio",
                name: name,
                checked: checked,
                onChange: onChange,
                className: "mt-1 accent-blue-600",
                "data-testid": testId
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: children
            })
        ]
    });
/** One question; defined outside the screen so its inputs keep focus. */ /** Numbered as every module's questions are (owner, 23 Oct 2026: the granny flat's were the only ones without). */ const $fdeb548393f050ad$var$Q = ({ n: n, title: title, why: why, whyOpen: whyOpen = false, onWhy: onWhy, children: children, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-t border-slate-200 pt-4",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d7fa4e176455787d$export$d5095ecb707035a), {
                n: n,
                children: [
                    title,
                    why && onWhy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fdeb548393f050ad$var$Why, {
                        open: whyOpen,
                        onToggle: onWhy,
                        children: why
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-2",
                children: children
            })
        ]
    });
const $fdeb548393f050ad$var$GfQuestions = ({ factFind: factFind, reasonableValue: reasonableValue, firstRun: firstRun, onRun: onRun, onBuildYourOwn: onBuildYourOwn, onFamilyGuide: onFamilyGuide, onCancel: onCancel })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const [a, setA] = (0, $acw62.useState)(()=>$fdeb548393f050ad$export$42f411d400ba8538(factFind));
    const set = (patch)=>setA((prev)=>({
                ...prev,
                ...patch
            }));
    const [openWhy, setOpenWhy] = (0, $acw62.useState)(null);
    const whyProps = (id)=>({
            whyOpen: openWhy === id,
            onWhy: ()=>setOpenWhy((o)=>o === id ? null : id)
        });
    const [editState, setEditState] = (0, $acw62.useState)(false);
    const goals = factFind?.goals || {};
    const homeValue = $fdeb548393f050ad$var$num(factFind?.home?.value);
    const hasHome = homeValue > 0;
    const give = (0, $3c33fc2d17e5ab0e$export$be6ce8332e69af13)(factFind);
    const route = give === 'home' ? 'transfer' : goals.gfHomeRoute === 'keep' || goals.gfHomeRoute === 'sell' ? String(goals.gfHomeRoute) : 'all';
    const keeps = hasHome && (route === 'keep' || route === 'all');
    const sells = hasHome && (route === 'sell' || route === 'all');
    const suggestedReserve = (0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind);
    const bankToday = (factFind?.assets?.bankAccounts || []).reduce((t, x)=>t + $fdeb548393f050ad$var$num(x?.value), 0);
    const fair = Math.round(reasonableValue ?? 0);
    // What a sale pays for the right: the formula value, or the build / cash step 1 described where that is
    // smaller (24 Oct 2026: the engine now tests that form with a sale too, so either can leave money to invest).
    const goalsNow = factFind?.goals || {};
    const known = (goalsNow.gfGive === 'build' || goalsNow.gfGive === 'cash') && $fdeb548393f050ad$var$num(goalsNow.gfKnownAmount) > 0 ? $fdeb548393f050ad$var$num(goalsNow.gfKnownAmount) + (goalsNow.gfGive === 'build' ? $fdeb548393f050ad$var$num(goalsNow.gfKnownExtraCash) : 0) : 0;
    const investable = $fdeb548393f050ad$export$ffdbe83affa25ff4(homeValue, known > 0 ? Math.min(fair, known) : fair, a.emergencyReserve, bankToday);
    const spends = sells && investable >= (0, $576b15178c677e44$export$c33aaf6975fc9af0);
    const stateOnFile = (0, $30ff538d4b47bf21$export$96fdbeb3c760993a)((0, $576b15178c677e44$export$acf534e7eb17fe32)(factFind)) ? (0, $669f0c9987a611db$export$2f609b1773ce8fef).find((s)=>s.code === (0, $576b15178c677e44$export$acf534e7eb17fe32)(factFind)) : undefined;
    const chosenState = (0, $30ff538d4b47bf21$export$96fdbeb3c760993a)(a.purchaseState) ? (0, $669f0c9987a611db$export$2f609b1773ce8fef).find((s)=>s.code === a.purchaseState) : undefined;
    const currentVillage = (0, $acw62.useMemo)(()=>{
        const ff = factFind;
        if (!(0, $4633117ee929ec27$export$cb26bf32ff9b2b4d)(ff)) return null;
        const today = (0, $4633117ee929ec27$export$6005e8b092eea057)(new Date());
        const e = (0, $4633117ee929ec27$export$3da79be84c8bf9e7)(ff, today);
        return e ? {
            name: ff.client?.firstName || 'The client',
            ...e,
            feesAfterLeaving: (0, $4633117ee929ec27$export$de22c25de5484f31)(ff.retirementVillage, today, e.refundDate)
        } : null;
    }, [
        factFind
    ]);
    // The client's guaranteed-income answers as this screen shows them: the file's, with any change made here.
    const giView = (0, $acw62.useMemo)(()=>a.guaranteedIncome ? {
            ...factFind,
            goals: {
                ...factFind?.goals || {},
                ...a.guaranteedIncome
            }
        } : factFind, [
        factFind,
        a.guaranteedIncome
    ]);
    // A sale that leaves money to put to work asks two questions: the guaranteed income and how the rest is invested.
    const count = 2 + (keeps ? 1 : 0) + (spends ? 2 : 0) + (currentVillage ? 1 : 0);
    let asked = 0;
    const next = ()=>{
        asked += 1;
        return asked;
    };
    const countWord = [
        '',
        'One',
        'Two',
        'Three',
        'Four',
        'Five',
        'Six'
    ][count] || String(count);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
        "data-testid": "gf-questions",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                className: "text-[22px] font-bold text-brand-navy",
                children: [
                    countWord,
                    " questions before we test the ways to set it up"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-1 text-[15px] text-slate-600",
                children: [
                    "Everything else comes from ",
                    v.possessive,
                    " file and step 1. Our suggestions are filled in, and each can be changed later."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d7fa4e176455787d$export$b506d3545e935872), {
                onClick: onBuildYourOwn,
                testId: "gf-build-own-top"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-4 space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fdeb548393f050ad$var$Q, {
                        n: next(),
                        title: "Has the family talked it through?",
                        testId: "gf-q-talked",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-[14px] leading-relaxed text-slate-700",
                            children: [
                                "The arrangement only works if everyone understands it. ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: onFamilyGuide,
                                    className: $fdeb548393f050ad$var$link,
                                    "data-testid": "gf-questions-guide",
                                    children: "Open the family discussion guide"
                                }),
                                " \u2014 the answers go into a brief for the solicitor."
                            ]
                        })
                    }),
                    currentVillage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($fdeb548393f050ad$var$Q, {
                        n: next(),
                        title: "When will the current village unit be paid out?",
                        testId: "gf-from-village-q",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fdeb548393f050ad$var$Radio, {
                                name: "gf-payout",
                                checked: a.oldUnitPaysAtMove,
                                onChange: ()=>set({
                                        oldUnitPaysAtMove: true
                                    }),
                                children: "At the move"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($fdeb548393f050ad$var$Radio, {
                                name: "gf-payout",
                                checked: !a.oldUnitPaysAtMove,
                                onChange: ()=>set({
                                        oldUnitPaysAtMove: false
                                    }),
                                children: [
                                    "Later \u2014 up to ",
                                    currentVillage.refundMonths,
                                    " months after leaving"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1 text-[13px] text-slate-600",
                                "data-testid": "gf-from-village",
                                children: (0, $511dfa7ed5ad5c31$export$2bd5a1cd4f86f5f0)(currentVillage, 'granny_flat', {
                                    atMove: a.oldUnitPaysAtMove
                                })
                            })
                        ]
                    }),
                    keeps && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($fdeb548393f050ad$var$Q, {
                        n: next(),
                        title: `If ${v.they} keep the home and rent it out, what rent?`,
                        testId: "gf-q-rent",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-x-3 gap-y-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                        value: a.rentPerWeek,
                                        onChange: (x)=>set({
                                                rentPerWeek: Math.max(0, x ?? 0)
                                            }),
                                        className: "w-36",
                                        ariaLabel: "Rent a week"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-[13px] text-slate-600",
                                        children: "a week, less"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                        value: a.rentCosts,
                                        onChange: (x)=>set({
                                                rentCosts: Math.max(0, x ?? 0)
                                            }),
                                        className: "w-36",
                                        ariaLabel: "Yearly costs of the rented home"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-[13px] text-slate-600",
                                        children: "a year of costs, empty for"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "number",
                                        min: 0,
                                        max: 52,
                                        value: a.vacancyWeeks,
                                        onChange: (e)=>set({
                                                vacancyWeeks: Math.min(52, Math.max(0, parseFloat(e.target.value) || 0))
                                            }),
                                        className: "w-20 rounded-lg border border-gray-300 bg-white/80 px-3 py-2 transition focus:border-blue-500 focus:ring-blue-500",
                                        "aria-label": "Weeks a year without a tenant",
                                        "data-testid": "gf-vacancy-weeks"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-[13px] text-slate-600",
                                        children: [
                                            "weeks a year",
                                            a.vacancyWeeks === (0, $576b15178c677e44$export$4a9fb6bdf3fe5eb2) ? ', suggested' : ''
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-2 text-[13.5px] leading-relaxed text-slate-700",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: "Check the costs."
                                    }),
                                    " Include council rates, insurance, repairs, the agent's fee and ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: "land tax"
                                    }),
                                    ", which can apply once the home is no longer where ",
                                    v.they,
                                    " live and is often the largest. And ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: "allow for empty weeks"
                                    }),
                                    " between tenants: each one is ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(a.rentPerWeek)),
                                    " of rent lost while the costs go on."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fdeb548393f050ad$var$Q, {
                        n: next(),
                        title: "How much should stay in the bank for emergencies?",
                        ...whyProps('reserve'),
                        why: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "Money kept in the bank for the unexpected. We keep it back when we move ",
                                v.their,
                                " money, and draw on it only if a year runs short. Centrelink still counts it."
                            ]
                        }),
                        testId: "gf-q-reserve",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                    value: a.emergencyReserve,
                                    onChange: (x)=>set({
                                            emergencyReserve: Math.max(0, x ?? 0)
                                        }),
                                    className: "w-36",
                                    ariaLabel: "Money kept for emergencies"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "text-[13px] text-slate-500",
                                    children: [
                                        "We suggest ",
                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(suggestedReserve),
                                        ": the greater of six months' living costs and $50,000.",
                                        Math.round(a.emergencyReserve) !== Math.round(suggestedReserve) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    onClick: ()=>set({
                                                            emergencyReserve: suggestedReserve
                                                        }),
                                                    className: $fdeb548393f050ad$var$link,
                                                    children: [
                                                        "Use ",
                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(suggestedReserve)
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    spends && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($fdeb548393f050ad$var$Q, {
                        n: next(),
                        title: "A guaranteed income for life",
                        testId: "gf-q-annuity",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f92088f7258458cc$export$b30880333d8bfec9), {
                                fromHomeSale: true,
                                factFind: giView,
                                onGoals: (patch)=>set({
                                        guaranteedIncome: {
                                            ...a.guaranteedIncome || {},
                                            ...patch
                                        },
                                        ...patch.annuityAppetite ? {
                                            annuity: patch.annuityAppetite === 'none' ? 'none' : 'yes'
                                        } : {}
                                    }),
                                investable: investable,
                                investableLead: `If the home is sold, the right is paid for and ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(a.emergencyReserve))} is kept for emergencies`,
                                investableMadeOf: "money left from the sale, after the selling costs and the money kept for emergencies",
                                inCare: (0, $d08210caeacdc75a$export$7095ab72ebd46272)(factFind),
                                idPrefix: "gf"
                            }),
                            a.annuity === 'yes' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-2 text-[13.5px] leading-relaxed text-slate-700",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: "We work out how much."
                                    }),
                                    " We test amounts up to that share, so most of ",
                                    v.their,
                                    " money stays within reach. Where it would lift the Age Pension, we also test the amount that lifts it most, held to the same share."
                                ]
                            })
                        ]
                    }),
                    spends && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($fdeb548393f050ad$var$Q, {
                        n: next(),
                        title: "If the home is sold, how is the money left invested?",
                        testId: "gf-q-invest",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[13.5px] text-slate-600",
                                children: "The plans test investing it, an investment property, super, an investment bond and the bank, and say what each adds."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-2 flex flex-wrap items-center gap-2 text-[13px] text-slate-600",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Money that is invested is assumed to go into"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: a.investProfile,
                                        onChange: (e)=>set({
                                                investProfile: e.target.value
                                            }),
                                        className: "rounded border border-slate-300 px-2 py-1 text-[13px]",
                                        "aria-label": "How money that is freed up is invested",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Not sure \u2014 assume the most cautious"
                                            }),
                                            (0, $0f2c0a6799fe36da$export$56315028e4277c0c).map((id)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: id,
                                                    children: (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[id].label
                                                }, id))
                                        ]
                                    })
                                ]
                            }),
                            stateOnFile && !editState ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-2 text-[13px] text-slate-600",
                                "data-testid": "gf-state-on-file",
                                children: [
                                    "The state for stamp duty on a bought property is already on the file: ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: stateOnFile.name
                                    }),
                                    ". ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setEditState(true),
                                        className: $fdeb548393f050ad$var$link,
                                        children: "Change"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-2 flex flex-wrap items-center gap-2 text-[13px] text-slate-600",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "A bought property would be in"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: chosenState ? chosenState.code : '',
                                        onChange: (e)=>set({
                                                purchaseState: e.target.value
                                            }),
                                        className: "rounded border border-slate-300 px-2 py-1 text-[13px]",
                                        "aria-label": "The state a bought property would be in",
                                        "data-testid": "gf-purchase-state",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "choose the state"
                                            }),
                                            (0, $669f0c9987a611db$export$2f609b1773ce8fef).map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: s.code,
                                                    children: s.name
                                                }, s.code))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: chosenState ? 'investor stamp duty is struck on its scale, and the property is sized to what is left.' : "with no state, no duty is charged, and the property\u2019s card says so."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-5 text-[13px] text-slate-600",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9873a6fbc9fd360$export$68741d4d7bc37a6d), {
                    years: a.years,
                    onChange: (y)=>set({
                            years: Math.min(30, Math.max(1, y))
                        }),
                    before: "We plan for",
                    after: " \u2014 the same span for every way tested.",
                    ariaLabel: "Years to plan for"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-[14px] text-slate-700",
                        children: [
                            "Prefer to set the numbers yourself? ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onBuildYourOwn,
                                className: $fdeb548393f050ad$var$link,
                                "data-testid": "gf-build-own",
                                children: "Build a plan yourself instead"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex items-center gap-3",
                        children: [
                            !firstRun && onCancel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onCancel,
                                className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>onRun(a),
                                className: "rounded-lg bg-blue-600 hover:bg-blue-700 px-5 py-2.5 text-[15px] font-semibold text-white ",
                                "data-testid": "gf-run",
                                children: firstRun ? 'Test the ways to set it up' : 'Test the ways again'
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $fdeb548393f050ad$export$2e2bcd8739ae039 = $fdeb548393f050ad$var$GfQuestions;


/**
 * Step 3's plans — the granny flat on the aged care spine (rebuild, 21 Oct 2026; the agreed mock-up's
 * j1 plans screen, as the village's RvPlansView).
 *
 *  - Not entering the arrangement as a strip of the four numbers from step 2; every card is read against it.
 *  - One verdict line, computed: whether any way of setting it up leaves more in their estate; that part of
 *    the gap is what they give the person they live with (still theirs to that person, not lost); and what
 *    leaves the household altogether — the lost Age Pension, naming the plans that keep it.
 *  - "What matters most to you?" — the four goals; choosing one never re-runs the engine.
 *  - The cards side by side, aligned row by row: the plan in words, what is left IN THEIR ESTATE (owner,
 *    19 Oct 2026: what goes to the person they live with is not counted as lost), two bars — less in the
 *    estate, and given to that person — then Age Pension / Left over each year / Counted as a gift (review
 *    decision 4: the gift is the rule a granny flat turns on), an Important or Worth knowing line, and the
 *    three buttons.
 *  - The ways on: compare, every way tested, the family discussion guide, things that change the answer,
 *    build a plan yourself.
 *
 * Presentation only. Every figure is the engine row's own.
 */ 

var $acw62 = parcelRequire("acw62");
























const $124fc1b7c2dbb105$var$isMover = (s)=>s.id !== 'gf-stay-put';
const $124fc1b7c2dbb105$var$legacyOf = (s)=>Number(s?.snapshot?.legacyValue) || 0;
const $124fc1b7c2dbb105$var$pensionOf = (s)=>Number(s?.snapshot?.pension) || 0;
const $124fc1b7c2dbb105$var$cashOf = (s)=>Number(s?.snapshot?.netCashflow) || 0;
const $124fc1b7c2dbb105$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
const $124fc1b7c2dbb105$var$signed = (n)=>`${n >= 0 ? '+' : "\u2212"}${$124fc1b7c2dbb105$var$money(Math.abs(n))}`;
const $124fc1b7c2dbb105$var$lower = (s)=>s.charAt(0).toLowerCase() + s.slice(1);
const $124fc1b7c2dbb105$var$joinAnd = (xs)=>xs.length <= 1 ? xs[0] || '' : `${xs.slice(0, -1).join(', ')} and ${xs[xs.length - 1]}`;
function $124fc1b7c2dbb105$export$e71f9e3250a35b7e(p) {
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(p.factFind);
    const movers = p.strategies.filter($124fc1b7c2dbb105$var$isMover);
    const base = p.stayPut;
    if (!base || movers.length === 0) return null;
    const best = movers.reduce((top, s)=>$124fc1b7c2dbb105$var$legacyOf(s) > $124fc1b7c2dbb105$var$legacyOf(top) ? s : top, movers[0]);
    const estate = (0, $32bd8c8afa665e9e$export$2f8f6124885fff97)(p.factFind);
    const host = (0, $32bd8c8afa665e9e$export$d71f476d519c5ae3)(p.factFind);
    const hostKind = (0, $32bd8c8afa665e9e$export$2b2184b5390b1cd2)(p.factFind);
    const yrs = `${p.horizonYears} ${p.horizonYears === 1 ? 'year' : 'years'}`;
    const basePension = $124fc1b7c2dbb105$var$pensionOf(base);
    const keepers = movers.filter((s)=>$124fc1b7c2dbb105$var$pensionOf(s) >= 1);
    const keeperWords = keepers.length > 0 && keepers.length <= 3 ? $124fc1b7c2dbb105$var$joinAnd([
        ...new Set(keepers.map((s)=>(0, $263fcb126ae0e669$export$45a1f9979a03ca0d)(s, p.factFind)))
    ]) : '';
    const pensionWords = basePension >= 1 ? keepers.length === 0 ? ` The cost that leaves ${v.them} altogether is the lost Age Pension, ${$124fc1b7c2dbb105$var$money(basePension)} a year in every plan.` : keepers.length < movers.length ? ` The cost that leaves ${v.them} altogether is the lost Age Pension, ${$124fc1b7c2dbb105$var$money(basePension)} a year in every plan${keeperWords ? ` except ${keeperWords}` : ' but the few that keep it'}.` : '' : '';
    if ($124fc1b7c2dbb105$var$legacyOf(best) < $124fc1b7c2dbb105$var$legacyOf(base) - 1) {
        const within = hostKind === 'child' || hostKind === 'family' ? `it is still in the family, but it is ${host}\u{2019}s, not the estate\u{2019}s` : `it is not lost, but it is ${hostKind ? `${host}\u{2019}s` : 'theirs'}, not the estate\u{2019}s`;
        return {
            cost: true,
            text: `Every way of setting this up leaves less in ${estate} than staying where ${v.they} are. We tested ${movers.length}. Part of that is what ${v.they} give ${host} \u{2014} ${within}.${pensionWords}`
        };
    }
    return {
        cost: false,
        text: `The best way of setting this up leaves ${$124fc1b7c2dbb105$var$money($124fc1b7c2dbb105$var$legacyOf(best) - $124fc1b7c2dbb105$var$legacyOf(base))} more in ${estate} than staying where ${v.they} are, after about ${yrs}. We tested ${movers.length}.${pensionWords}`
    };
}
function $124fc1b7c2dbb105$export$6d57bd98289a5dd9(give, m) {
    if (give === 'unsure' || !(m.entryContribution || m.justMovingIn)) return null;
    const form = m.justMovingIn ? 'nothing' : (m.propertyTransferred || 0) > 0 ? 'home' : (m.construction || 0) > 0 ? 'build' : 'cash';
    if (form === give) return null;
    const said = give === 'build' ? 'the build you described' : give === 'home' ? 'signing the home over, as you described' : 'the cash you described';
    const does = form === 'nothing' ? 'Pays nothing for the right' : form === 'home' ? 'Signs the home over' : form === 'build' ? 'Pays for a build' : 'Pays cash';
    return `${does}, not ${said}, for comparison.`;
}
const $124fc1b7c2dbb105$var$GfPlansView = ({ factFind: factFind, strategies: strategies, stayPut: stayPut, recommended: recommended, setAside: setAside, horizonYears: horizonYears, ownToday: ownToday, focus: focus, onFocus: onFocus, chosenId: chosenId, onChoose: onChoose, onExplain: onExplain, onRisks: onRisks, renderDetail: renderDetail, onAllWays: onAllWays, onChanges: onChanges, onBuildYourOwn: onBuildYourOwn, onAdvice: onAdvice, onFamilyGuide: onFamilyGuide, notices: notices, onIncomeOnly: onIncomeOnly })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const [openDetail, setOpenDetail] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [why, setWhy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [comparing, setComparing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const yrs = `${horizonYears} ${horizonYears === 1 ? 'year' : 'years'}`;
    const host = (0, $32bd8c8afa665e9e$export$d71f476d519c5ae3)(factFind);
    const hostKind = (0, $32bd8c8afa665e9e$export$2b2184b5390b1cd2)(factFind);
    const estate = (0, $32bd8c8afa665e9e$export$2f8f6124885fff97)(factFind);
    const movers = strategies.filter($124fc1b7c2dbb105$var$isMover);
    const byName = (name)=>strategies.find((s)=>s.name === name) ?? null;
    const fullRow = (r)=>r?.strategy?.name ? byName(r.strategy.name) || r.strategy : null;
    const coveredSame = (0, $400a08a42b233386$export$b8b8a2cedd92aa3a)(recommended);
    const effective = focus === 'covered' && coveredSame ? 'legacy' : focus;
    const base = stayPut?.snapshot ? stayPut : null;
    const noPensionAnyWay = movers.length > 0 && movers.every((s)=>$124fc1b7c2dbb105$var$pensionOf(s) < 1);
    const keepers = movers.filter((s)=>$124fc1b7c2dbb105$var$pensionOf(s) >= 1);
    const leader = fullRow((0, $f8ee565b442c040e$export$cf9821b188ee27f0)(recommended, effective));
    const secondEntry = effective === 'legacy' ? recommended.find((r)=>r.label === (0, $f8ee565b442c040e$export$40de0448f2611c56) && r.second) ?? null : null;
    const secondRow = secondEntry ? fullRow(secondEntry) : null;
    const estateEntry = recommended.find((r)=>r.label === 'Optimal Legacy') ?? null;
    const pensionLeader = fullRow((0, $f8ee565b442c040e$export$cf9821b188ee27f0)(recommended, 'pension'));
    /*
     * ONE CARD PER GOAL, A SECOND ONLY WITH A PURPOSE (owner, 22 Oct 2026: "each section has a specific purpose … only
     * show the second card when there is a purpose to it"). The second card is the plan choice rule's near-tie beside
     * the estate leader (nearly the same estate, less locked away or a better cashflow — planChoiceRule.ts), as aged
     * care and support at home do. Another goal's leader is pointed to in one line under the cards (OtherGoalLeaders).
     */ const showPensionNote = effective === 'pension' && noPensionAnyWay;
    const shown = showPensionNote || !leader ? [] : [
        leader,
        ...secondRow && secondRow.name !== leader.name ? [
            secondRow
        ] : []
    ];
    const others = [
        'legacy',
        'cashflow',
        'pension'
    ].filter((g)=>g !== effective).map((g)=>({
            g: g,
            row: g === 'pension' ? pensionLeader : fullRow((0, $f8ee565b442c040e$export$cf9821b188ee27f0)(recommended, g))
        })).filter((x)=>!!x.row && !shown.some((s)=>s.name === x.row.name)).map((x)=>({
            goal: x.g,
            title: (0, $263fcb126ae0e669$export$bf2295610779f6b)(x.row, factFind).title,
            legacy: $124fc1b7c2dbb105$var$legacyOf(x.row),
            cashflow: $124fc1b7c2dbb105$var$cashOf(x.row),
            pension: $124fc1b7c2dbb105$var$pensionOf(x.row)
        }));
    // “Income covers the costs” only on a plan that does: when none does, that goal falls back to the estate leader,
    // and the label on a plan that is short each year would contradict its own figures (review, 22 Oct 2026).
    const labelsFor = (row)=>recommended.filter((r)=>r.strategy?.name === row.name).map((r)=>String(r.label)).filter((l)=>l !== (0, $400a08a42b233386$export$920ad41b346ae01a) || (Number(row.snapshot?.netCashflow) || 0) >= 0);
    const chipFor = (l)=>{
        if (l === 'Optimal Legacy') return (0, $5a094123650e8adb$export$a035dca5f387c63d)(estateEntry?.lead).replace(/^Leaves the most$/, 'Leaves the most in the estate');
        if (l === (0, $f8ee565b442c040e$export$40de0448f2611c56) && secondEntry?.second) return (0, $5a094123650e8adb$export$8d9f0aa086032e89)(secondEntry.second);
        if (l === 'Optimal Age Pension') return keepers.length > 0 && keepers.length < movers.length ? 'Keeps the Age Pension' : 'Highest Age Pension';
        if (l === (0, $400a08a42b233386$export$920ad41b346ae01a)) return 'Income covers the costs';
        if (l === 'Optimal Cashflow') return 'Most left over each year';
        return undefined;
    };
    const verdict = $124fc1b7c2dbb105$export$e71f9e3250a35b7e({
        factFind: factFind,
        strategies: strategies,
        stayPut: stayPut,
        horizonYears: horizonYears
    });
    const maxGain = Math.max(1, ...shown.map((s)=>Math.abs($124fc1b7c2dbb105$var$legacyOf(s) - $124fc1b7c2dbb105$var$legacyOf(base))));
    const maxGiven = Math.max(1, ...shown.map((s)=>(0, $263fcb126ae0e669$export$172c8762bdedaa06)((0, $263fcb126ae0e669$export$ca60ec58f5352c3a)(s, factFind))));
    const twoOrMoreChildren = (0, $32bd8c8afa665e9e$export$4411cd57c45e8c9e)(factFind) >= 2 && (hostKind === 'child' || hostKind == null);
    const giftCaption = (row)=>{
        const m = (0, $263fcb126ae0e669$export$ca60ec58f5352c3a)(row, factFind);
        if (m.justMovingIn || m.entryContribution === 0) return 'nothing paid for the right';
        if ((0, $263fcb126ae0e669$export$15946ade44cdb983)(m.deprivation) > 0) return 'counted for five years';
        if (m.deprivation > 0) return 'within what can be given freely';
        if (m.amountPaid === 0 && (m.propertyTransferred > 0 || m.construction > 0)) return 'taken at face value';
        return "within Centrelink\u2019s limit";
    };
    const card = (row)=>{
        const key = String(row.id ?? row.name);
        const words = (0, $263fcb126ae0e669$export$bf2295610779f6b)(row, factFind);
        const m = (0, $263fcb126ae0e669$export$ca60ec58f5352c3a)(row, factFind);
        const given = (0, $263fcb126ae0e669$export$172c8762bdedaa06)(m);
        const chip = labelsFor(row).map(chipFor).filter(Boolean).map((c, i)=>i === 0 ? c : $124fc1b7c2dbb105$var$lower(c)).join(" \xb7 ") || null;
        const delta = base ? $124fc1b7c2dbb105$var$legacyOf(row) - $124fc1b7c2dbb105$var$legacyOf(base) : null;
        const pDelta = base ? $124fc1b7c2dbb105$var$pensionOf(row) - $124fc1b7c2dbb105$var$pensionOf(base) : 0;
        const cDelta = base ? $124fc1b7c2dbb105$var$cashOf(row) - $124fc1b7c2dbb105$var$cashOf(base) : 0;
        const reason = (0, $263fcb126ae0e669$export$cd6e127b50c27e2a)(row, factFind);
        const numbers = [
            {
                label: 'Age Pension',
                value: $124fc1b7c2dbb105$var$pensionOf(row),
                unit: 'a year',
                vs: base && Math.abs(pDelta) >= 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: `font-bold ${pDelta > 0 ? 'text-emerald-700' : 'text-rose-700'}`,
                            children: [
                                $124fc1b7c2dbb105$var$signed(pDelta),
                                " a year"
                            ]
                        }),
                        reason && pDelta < 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                " \u2014 ",
                                reason
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: " vs staying put"
                        })
                    ]
                }) : 'unchanged',
                tone: pDelta > 0 ? 'good' : 'neutral',
                onWhy: ()=>setWhy({
                        row: row,
                        page: 'pension'
                    })
            },
            {
                label: $124fc1b7c2dbb105$var$cashOf(row) < 0 ? 'Each year, short by' : 'Left over each year',
                value: Math.abs($124fc1b7c2dbb105$var$cashOf(row)),
                vs: base ? Math.abs(cDelta) < 1 ? 'unchanged' : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "in the first year; was ",
                        $124fc1b7c2dbb105$var$cashOf(base) < 0 ? `short ${$124fc1b7c2dbb105$var$money(-$124fc1b7c2dbb105$var$cashOf(base))}` : $124fc1b7c2dbb105$var$money($124fc1b7c2dbb105$var$cashOf(base))
                    ]
                }) : '',
                tone: $124fc1b7c2dbb105$var$cashOf(row) >= 0 ? 'good' : 'neutral',
                onWhy: ()=>setWhy({
                        row: row,
                        page: 'cashflow'
                    })
            },
            {
                // Counted after the $10,000 a year that can be given freely, as the calc counts it (24 Oct 2026).
                label: 'Counted as a gift',
                value: (0, $263fcb126ae0e669$export$15946ade44cdb983)(m.deprivation),
                vs: giftCaption(row),
                tone: (0, $263fcb126ae0e669$export$15946ade44cdb983)(m.deprivation) > 0 ? 'bad' : 'neutral',
                onWhy: given > 0 ? ()=>setWhy({
                        row: row,
                        page: 'gift'
                    }) : undefined
            }
        ];
        /*
         * "When the money runs out" ON EVERY CARD, every account in the order it is drawn (owner, 22 Oct 2026: as every
         * module's card now says it — runwayCardLine). The older headline stays only as the fallback when the accounts
         * cannot be read.
         */ const runway = row.projections && row.projections.length ? (0, $0fe89e03b6df746e$export$464558962ff4a811)(row.projections, horizonYears) : null;
        const runText = row.projections && row.projections.length ? (0, $2ddaae90639b5011$export$7526d1fcb4423629)({
            rows: row.projections,
            factFind: factFind,
            horizonYears: horizonYears,
            spentOn: 'the granny flat'
        }) : null;
        const runline = runText ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
            "data-testid": `gf-card-runway-${row.id}`,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "When the money runs out:"
                }),
                " ",
                runText
            ]
        }) : runway && runway.depleted ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "When the money runs out:"
                }),
                " ",
                $124fc1b7c2dbb105$var$lower(runway.headline),
                ".",
                runway.flag ? ` ${runway.flag}` : ''
            ]
        }) : null;
        const lines = [];
        const baseDelta = base ? $124fc1b7c2dbb105$var$legacyOf(row) - $124fc1b7c2dbb105$var$legacyOf(base) : 0;
        if (m.home === 'transferred') lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-rose-700",
                    children: "Important:"
                }),
                " the home becomes ",
                host,
                "\u2019s.",
                baseDelta < -1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        " ",
                        v.Possessive,
                        " estate falls by ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: $124fc1b7c2dbb105$var$money(-baseDelta)
                        })
                    ]
                }) : null,
                twoOrMoreChildren ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        baseDelta < -1 ? " \u2014 and the" : ' The',
                        " ",
                        (0, $32bd8c8afa665e9e$export$4411cd57c45e8c9e)(factFind) === 2 ? "other child\u2019s" : "other children\u2019s",
                        " share of the family's wealth falls with it unless the Will evens it out"
                    ]
                }) : null,
                baseDelta < -1 || twoOrMoreChildren ? '.' : ''
            ]
        }));
        const pensionOnly = (0, $32bd8c8afa665e9e$export$f4087385558a2ae)({
            ...row,
            recommendationLabels: labelsFor(row)
        }, movers, base, {
            hostReceived: given,
            legacyYears: horizonYears,
            factFind: factFind,
            money: $124fc1b7c2dbb105$var$money
        });
        // Beside the figures with every "why it is shown" (EnginePlanCard whyShown; 23 Oct 2026).
        const pensionOnlyWhy = pensionOnly && m.home !== 'transferred' ? pensionOnly : null;
        // "Worth knowing:" with a colon on every line, as aged care's card lines (owner, 22 Oct 2026: one voice across modules).
        // A decided form is the only form the plans use (25 Oct 2026); this line now speaks only for plans tested
        // before step 1 changed (an earlier run on screen), so they are never read as what was described.
        const otherForm = $124fc1b7c2dbb105$export$6d57bd98289a5dd9((0, $3c33fc2d17e5ab0e$export$be6ce8332e69af13)(factFind), m);
        if (otherForm) lines.unshift(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
            "data-testid": "gf-other-form",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "Not what was described:"
                }),
                " ",
                otherForm
            ]
        }));
        if (m.home === 'rented') lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "Worth knowing:"
                }),
                " ",
                (0, $203e38d6e6c434f4$export$b96695c1a4aaa70d)
            ]
        }));
        if (m.home === 'kept') lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "Worth knowing:"
                }),
                " the empty home earns nothing, but Centrelink counts it from the day ",
                v.they,
                " move."
            ]
        }));
        if (m.home === 'sold') lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "Worth knowing:"
                }),
                " the money from the sale is counted for the Age Pension wherever it is put."
            ]
        }));
        if (m.justMovingIn && m.home) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "Worth knowing:"
                }),
                " paying nothing does not protect the Age Pension. The home ",
                v.they,
                " leave is counted from the day ",
                v.they,
                " move."
            ]
        }));
        if ((0, $263fcb126ae0e669$export$15946ade44cdb983)(m.deprivation) > 0) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "Worth knowing:"
                }),
                " ",
                $124fc1b7c2dbb105$var$money(m.deprivation),
                " is paid above what the right can be valued at; less the ",
                $124fc1b7c2dbb105$var$money((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0)),
                " that can be given freely, ",
                $124fc1b7c2dbb105$var$money((0, $263fcb126ae0e669$export$15946ade44cdb983)(m.deprivation)),
                " counts as a gift. It is still counted as ",
                v.you ? 'yours' : 'theirs',
                " for five years though it has gone."
            ]
        }));
        if ((row.fundingShortfall ?? 0) > 0) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-rose-700",
                    children: "Important:"
                }),
                " ",
                $124fc1b7c2dbb105$var$money(row.fundingShortfall ?? 0),
                " of the payment cannot be found from ",
                v.their,
                " savings, so this is not yet a plan that can go ahead."
            ]
        }));
        const gi = (0, $75f9bc5abce573de$export$816a4f32463eb868)(row, factFind);
        if (gi?.incomeOnly) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "Worth knowing:"
                }),
                " the guaranteed income is income only. It pays the most for life, and nothing from it goes back to the family, even after an early death."
            ]
        }));
        const isChosen = chosenId != null && row.id === chosenId;
        const compare = gi ? (0, $75f9bc5abce573de$export$31540525a196c11f)(row, strategies) : null;
        const familyPanel = gi ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
            factFind: factFind,
            personName: gi.personName,
            amount: gi.amount,
            kind: gi.kind,
            incomeAYear: gi.incomeAYear,
            rows: row.projections,
            compareRows: compare?.projections ?? null,
            compareNote: compare ? (0, $75f9bc5abce573de$export$a5d7138b0effd291) : null,
            horizonYears: horizonYears,
            testId: `gf-family-panel-${row.id}`
        }) : null;
        const tradeOff = secondEntry?.second && row === secondRow ? (0, $5a094123650e8adb$export$a104569a4d958475)(secondEntry.second, (0, $f94e45ac645ae232$export$3dc27271f5d5c629)) : estateEntry?.lead && row.name === estateEntry.strategy?.name ? (0, $5a094123650e8adb$export$27f705a6fa40271e)(estateEntry.lead, (0, $f94e45ac645ae232$export$3dc27271f5d5c629)) : null;
        const held = !!gi && gi.incomeOnly && (0, $5eae79c7e46ed27e$export$655f124668ce439a)(factFind, true, gi.amount);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b383720e6b5df564$export$2e2bcd8739ae039), {
            aligned: true,
            testId: "gf-plan-card",
            whyShown: tradeOff || pensionOnlyWhy || null,
            chip: chip,
            chipTone: "blue",
            title: words.title,
            sub: words.sub,
            legacy: $124fc1b7c2dbb105$var$legacyOf(row),
            legacyDelta: delta,
            legacyCaption: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "in ",
                    estate,
                    " after about ",
                    yrs
                ]
            }),
            lessLabel: "Less in the estate",
            horizonYears: horizonYears,
            baselineWord: (0, $1a5a24a0286ded56$export$b3949d624101f360)('grannyFlat', {
                rents: (0, $1a5a24a0286ded56$export$71623450cbaee3cf)(factFind)
            }).word,
            bars: delta != null ? {
                gainPct: Math.abs(delta) / maxGain * 100,
                tiedUp: given,
                tiedUpPct: given / maxGiven * 100
            } : null,
            tiedUpLabel: `Given to ${host}`,
            hideEmptyTiedUp: true,
            numbers: numbers,
            runline: runline,
            familyPanel: familyPanel,
            worthKnowing: lines.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: lines.map((l, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: l
                    }, i))
            }) : null,
            lines: [],
            chosen: isChosen,
            beforeChoose: gi?.incomeOnly && onIncomeOnly ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": `gf-choose-held-${row.id}`,
                "data-held": held ? 'true' : 'false',
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$4538b371a206da0c), {
                    factFind: factFind,
                    amount: gi.amount,
                    onChange: onIncomeOnly
                })
            }) : undefined,
            chooseHeld: held,
            onExplain: ()=>onExplain(row),
            onRisks: ()=>onRisks(row),
            onChoose: ()=>onChoose(row),
            chooseLabel: chosenId != null && !isChosen ? 'Choose this instead' : 'Choose this plan',
            chosenStrip: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2194d8b5de21e3ff$export$4df4eb62309771d0), {
                possessiveFile: v.possessive,
                onAdvice: onAdvice,
                onCustomise: ()=>onBuildYourOwn(row),
                extra: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: onFamilyGuide,
                    className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                    children: "The family guide"
                })
            }),
            detail: renderDetail(row),
            detailOpen: openDetail === key,
            onToggleDetail: ()=>setOpenDetail((d)=>d === key ? null : key),
            detailHint: "where the money comes from and every calculation"
        }, key);
    };
    const Strip = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            "data-testid": "gf-stay-put-strip",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-[13px] font-semibold text-slate-500",
                    children: "Compared with staying put, not entering the arrangement \u2014 the four numbers from step 2"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mt-2 grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-slate-200 bg-slate-200 shadow-card lg:grid-cols-4",
                    children: [
                        {
                            label: 'Age Pension',
                            value: $124fc1b7c2dbb105$var$money($124fc1b7c2dbb105$var$pensionOf(base)),
                            note: 'a year'
                        },
                        {
                            label: $124fc1b7c2dbb105$var$cashOf(base) < 0 ? 'Short each year' : 'Left over each year',
                            value: $124fc1b7c2dbb105$var$money(Math.abs($124fc1b7c2dbb105$var$cashOf(base))),
                            note: 'money in, less money out',
                            tone: $124fc1b7c2dbb105$var$cashOf(base) >= 0 ? 'text-emerald-700' : 'text-rose-700'
                        },
                        {
                            label: `What ${v.they} own`,
                            value: $124fc1b7c2dbb105$var$money(ownToday),
                            note: 'today'
                        },
                        {
                            label: 'Left to the family',
                            value: $124fc1b7c2dbb105$var$money($124fc1b7c2dbb105$var$legacyOf(base)),
                            note: `after about ${yrs}`
                        }
                    ].map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white px-4 py-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-[12px] font-semibold text-slate-500",
                                    children: c.label
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: `mt-0.5 text-[22px] font-bold tabular-nums leading-tight ${c.tone || 'text-slate-900'}`,
                                    children: c.value
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-[12px] text-slate-500",
                                    children: c.note
                                })
                            ]
                        }, c.label))
                })
            ]
        });
    const goalSubs = {
        legacy: verdict?.cost ? 'Smallest cost to the estate' : `Biggest estate after about ${yrs}`,
        covered: coveredSame ? 'Same plan as "leave the most"' : 'Pays its way without savings',
        cashflow: 'Easiest cashflow',
        pension: noPensionAnyWay ? 'No way of setting it up keeps any' : keepers.length < movers.length ? 'Keeps it, where others lose it' : 'Most government support'
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-6",
        "data-testid": "gf-plans",
        children: [
            (0, $576b15178c677e44$export$bd66aaa55eff01b1)(factFind) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "rounded-xl border border-slate-200 border-l-4 border-l-rose-500 bg-white px-4 py-3 text-[14px] text-slate-700",
                "data-testid": "gf-plans-build-needs-cost",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "text-slate-900",
                        children: "No build plan is tested until the cost is entered."
                    }),
                    " Enter the builder's quote on step 1 to see plans that pay for the build."
                ]
            }),
            notices,
            base && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Strip, {}),
            verdict && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `rounded-xl border border-slate-200 border-l-4 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700 shadow-card ${verdict.cost ? 'border-l-rose-500' : 'border-l-emerald-500'}`,
                "data-testid": "gf-verdict",
                children: (()=>{
                    const first = verdict.text.indexOf('. ');
                    return first > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-slate-900",
                                children: verdict.text.slice(0, first + 1)
                            }),
                            verdict.text.slice(first + 1)
                        ]
                    }) : verdict.text;
                })()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54f65c4595e0c798$export$2e2bcd8739ae039), {
                value: focus,
                onChange: onFocus,
                household: v.names,
                enteringName: v.names,
                horizonYears: horizonYears,
                coveredSameAsBest: coveredSame,
                bestCovers: coveredSame && $124fc1b7c2dbb105$var$cashOf(fullRow((0, $f8ee565b442c040e$export$cf9821b188ee27f0)(recommended, 'legacy'))) >= 0,
                waysTested: movers.length,
                shown: shown.length,
                testedFor: "to set it up",
                closingNote: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Each card says what ",
                        v.they,
                        " give ",
                        host,
                        ", what counts as a gift, and what is left in ",
                        estate,
                        "."
                    ]
                }),
                subs: goalSubs,
                countLine: showPensionNote ? 'No way of setting it up keeps any Age Pension.' : shown.length === 0 ? 'None leads on this goal.' : undefined
            }),
            showPensionNote ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-2xl border border-slate-200 border-l-4 border-l-brand-navy bg-white p-6 shadow-card",
                "data-testid": "gf-no-pension",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                        className: "text-[19px] font-bold text-slate-900",
                        children: [
                            "No way of setting it up keeps ",
                            v.possessive,
                            " Age Pension"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-2 text-[15px] leading-relaxed text-slate-700",
                        children: $124fc1b7c2dbb105$var$pensionOf(base) >= 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "Staying put, ",
                                v.they,
                                " get ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                    children: [
                                        $124fc1b7c2dbb105$var$money($124fc1b7c2dbb105$var$pensionOf(base)),
                                        " a year"
                                    ]
                                }),
                                ". Once ",
                                v.they,
                                " move, the home stops being exempt: kept, it counts in full; sold, the money counts wherever it is put. Either way Centrelink counts more than ",
                                v.couple ? 'a couple is' : 'one person is',
                                " allowed."
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "Staying put, Centrelink already counts more than ",
                                v.couple ? 'a couple is' : 'one person is',
                                " allowed, and moving in doesn't change that."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-3 text-[15px] leading-relaxed text-slate-700",
                        children: "So this goal can't tell the plans apart. Choose one of the other three goals to compare them."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-4 flex flex-wrap gap-3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>onFocus('legacy'),
                            className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                            children: "Compare the plans on another goal"
                        })
                    })
                ]
            }) : shown.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
                "data-testid": "gf-no-leader",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-[19px] font-bold text-slate-900",
                        children: "No plan leads on this goal"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 text-[14px] leading-relaxed text-slate-700",
                        children: [
                            "Choose another goal above, or see all ",
                            movers.length,
                            " ways tested."
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `grid grid-cols-1 gap-5 ${shown.length > 1 ? 'lg:grid-cols-2' : ''}`,
                "data-testid": "gf-plan-cards",
                children: [
                    chosenId != null && !shown.some((s)=>s.id === chosenId) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: shown.length > 1 ? 'lg:col-span-2' : '',
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2194d8b5de21e3ff$export$4df4eb62309771d0), {
                            possessiveFile: v.possessive,
                            onAdvice: onAdvice,
                            offCard: true,
                            testId: "chosen-plan-off-card"
                        })
                    }),
                    shown.map(card)
                ]
            }),
            shown.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c41b14da14ed8be$export$2e2bcd8739ae039), {
                others: others,
                here: {
                    legacy: $124fc1b7c2dbb105$var$legacyOf(shown[0]),
                    cashflow: $124fc1b7c2dbb105$var$cashOf(shown[0]),
                    pension: $124fc1b7c2dbb105$var$pensionOf(shown[0])
                },
                baseLegacy: base ? $124fc1b7c2dbb105$var$legacyOf(base) : null,
                baseWord: "staying put",
                onFocus: onFocus,
                testId: "gf-other-leaders"
            }),
            setAside.map((sa)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8dcabb024256f5a9$export$2e2bcd8739ae039), {
                    testId: "gf-set-aside",
                    className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700",
                    note: (link)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                setAside.length === 1 ? 'One plan was set aside: ' : '',
                                $124fc1b7c2dbb105$var$lower((0, $263fcb126ae0e669$export$bf2295610779f6b)(sa.strategy, factFind).title),
                                " would lead on ",
                                sa.labels.map((l)=>({
                                        'Optimal Legacy': 'the estate',
                                        'Optimal Cashflow': 'cashflow',
                                        'Optimal Age Pension': 'the Age Pension'
                                    })[l] || 'one goal').join(' and '),
                                ", but ",
                                $124fc1b7c2dbb105$var$lower(sa.warning),
                                ' ',
                                link
                            ]
                        }),
                    renderCard: ()=>card(sa.strategy)
                }, String(sa.strategy.id ?? sa.strategy.name))),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-3",
                "data-testid": "gf-ways-on",
                children: [
                    shown.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setComparing(true),
                        className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                        "data-testid": "gf-compare",
                        children: "Compare the plans side by side"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onAllWays,
                        className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                        "data-testid": "gf-all-ways",
                        children: [
                            "All ",
                            movers.length,
                            " ways tested"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onFamilyGuide,
                        className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                        "data-testid": "gf-plans-guide",
                        children: "The family discussion guide"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onChanges,
                        className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                        "data-testid": "gf-changes",
                        children: "Things that change the answer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>onBuildYourOwn(null),
                        className: "text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy",
                        "data-testid": "gf-build-your-own",
                        children: "Build a plan yourself \u2192"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[13px] text-slate-500",
                "data-testid": "all-plans-open-line",
                children: (0, $5a094123650e8adb$export$af182f21f972ef03)(movers.length)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] text-slate-500",
                children: [
                    "Figures use the rates in force today and are projections over ",
                    yrs,
                    ", not guarantees. Always get legal and financial advice before committing."
                ]
            }),
            comparing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                titleId: "gf-compare-title",
                title: "The plans side by side",
                eyebrow: `Over about ${yrs}`,
                onClose: ()=>setComparing(false),
                size: "xl",
                testId: "gf-compare-dialog",
                flush: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "min-w-full text-[14px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    className: "border-b border-slate-200 text-left text-[12px] font-semibold text-slate-500",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-5 py-3",
                                            children: " "
                                        }),
                                        base && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-5 py-3",
                                            children: "Staying put"
                                        }),
                                        shown.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3",
                                                children: (0, $263fcb126ae0e669$export$bf2295610779f6b)(s, factFind).title
                                            }, String(s.id)))
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                className: "tabular-nums",
                                children: [
                                    {
                                        label: `In ${estate}`,
                                        pick: $124fc1b7c2dbb105$var$legacyOf,
                                        baseCell: (b)=>$124fc1b7c2dbb105$var$money($124fc1b7c2dbb105$var$legacyOf(b))
                                    },
                                    {
                                        label: `Given to ${host}`,
                                        pick: (s)=>(0, $263fcb126ae0e669$export$172c8762bdedaa06)((0, $263fcb126ae0e669$export$ca60ec58f5352c3a)(s, factFind)),
                                        baseCell: ()=>"\u2014"
                                    },
                                    {
                                        label: 'Age Pension, a year',
                                        pick: $124fc1b7c2dbb105$var$pensionOf,
                                        baseCell: (b)=>$124fc1b7c2dbb105$var$money($124fc1b7c2dbb105$var$pensionOf(b))
                                    },
                                    {
                                        label: 'Left over each year',
                                        pick: $124fc1b7c2dbb105$var$cashOf,
                                        baseCell: (b)=>$124fc1b7c2dbb105$var$money($124fc1b7c2dbb105$var$cashOf(b))
                                    },
                                    {
                                        label: 'Counted as a gift',
                                        pick: (s)=>(0, $263fcb126ae0e669$export$15946ade44cdb983)((0, $263fcb126ae0e669$export$ca60ec58f5352c3a)(s, factFind).deprivation),
                                        baseCell: ()=>"\u2014"
                                    }
                                ].map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "border-b border-slate-100",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3 text-left font-semibold text-slate-700",
                                                children: r.label
                                            }),
                                            base && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-5 py-3",
                                                children: r.baseCell(base)
                                            }),
                                            shown.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-5 py-3 font-semibold text-slate-900",
                                                    children: $124fc1b7c2dbb105$var$money(r.pick(s))
                                                }, String(s.id)))
                                        ]
                                    }, r.label))
                            })
                        ]
                    })
                })
            }),
            why && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                titleId: "gf-why-title",
                eyebrow: (0, $263fcb126ae0e669$export$bf2295610779f6b)(why.row, factFind).title,
                title: why.page === 'pension' ? 'Why the Age Pension is what it is' : why.page === 'cashflow' ? 'Left over each year' : 'Counted as a gift',
                onClose: ()=>setWhy(null),
                testId: "gf-why-dialog",
                children: [
                    why.page === 'pension' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-3 text-[14px] leading-relaxed text-slate-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "Staying put: ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            $124fc1b7c2dbb105$var$money($124fc1b7c2dbb105$var$pensionOf(base)),
                                            " a year"
                                        ]
                                    }),
                                    ". With this plan: ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            $124fc1b7c2dbb105$var$money($124fc1b7c2dbb105$var$pensionOf(why.row)),
                                            " a year"
                                        ]
                                    }),
                                    " in the first year.",
                                    (0, $263fcb126ae0e669$export$cd6e127b50c27e2a)(why.row, factFind) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            " The difference is mostly because ",
                                            (0, $263fcb126ae0e669$export$cd6e127b50c27e2a)(why.row, factFind),
                                            "."
                                        ]
                                    }) : null
                                ]
                            }),
                            (0, $263fcb126ae0e669$export$ca60ec58f5352c3a)(why.row, factFind).entryContribution > 0 && ((0, $263fcb126ae0e669$export$ca60ec58f5352c3a)(why.row, factFind).entryContribution > (0, $1abe73eeef086faf$export$e2cf792e99a08354) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    v.They,
                                    " give more than ",
                                    $124fc1b7c2dbb105$var$money((0, $1abe73eeef086faf$export$e2cf792e99a08354)),
                                    " for the right, so ",
                                    v.they,
                                    " stay homeowners and the right itself is not counted."
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    v.They,
                                    " give ",
                                    $124fc1b7c2dbb105$var$money((0, $263fcb126ae0e669$export$ca60ec58f5352c3a)(why.row, factFind).entryContribution),
                                    ", not more than ",
                                    $124fc1b7c2dbb105$var$money((0, $1abe73eeef086faf$export$e2cf792e99a08354)),
                                    ", so ",
                                    v.they,
                                    " are not homeowners for the Age Pension: the right counts as an asset, and the higher non-homeowner limits apply."
                                ]
                            })),
                            (()=>{
                                const f = why.row.projections?.[0]?.financials;
                                const pos = (0, $eec331ce661055d2$export$d318875bf548d09)(f?.socialSecurityBreakdown, f?.socialSecurity, factFind?.adviceFor === 'couple');
                                if (!pos) return null;
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    "data-testid": "gf-why-pension-count",
                                    children: [
                                        "With this plan Centrelink counts ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: $124fc1b7c2dbb105$var$money(pos.assessableAssets)
                                        }),
                                        " of assets and ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                            children: [
                                                $124fc1b7c2dbb105$var$money(pos.assessableIncome),
                                                " a year"
                                            ]
                                        }),
                                        " of income.",
                                        ' ',
                                        "The ",
                                        pos.determinedBy === 'income' ? 'income' : 'assets',
                                        " test sets the pension: it gives ",
                                        $124fc1b7c2dbb105$var$money(pos.determinedBy === 'income' ? pos.incomeTestPension : pos.assetTestPension),
                                        " a year, against ",
                                        $124fc1b7c2dbb105$var$money(pos.determinedBy === 'income' ? pos.assetTestPension : pos.incomeTestPension),
                                        " on the other test, and the lower of the two is paid."
                                    ]
                                });
                            })()
                        ]
                    }),
                    why.page === 'cashflow' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-3 text-[14px] leading-relaxed text-slate-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "Money in, less money out, in the first year: ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: $124fc1b7c2dbb105$var$cashOf(why.row) < 0 ? `short ${$124fc1b7c2dbb105$var$money(-$124fc1b7c2dbb105$var$cashOf(why.row))}` : `${$124fc1b7c2dbb105$var$money($124fc1b7c2dbb105$var$cashOf(why.row))} to spare`
                                    }),
                                    ". Not entering: ",
                                    $124fc1b7c2dbb105$var$cashOf(base) < 0 ? `short ${$124fc1b7c2dbb105$var$money(-$124fc1b7c2dbb105$var$cashOf(base))}` : `${$124fc1b7c2dbb105$var$money($124fc1b7c2dbb105$var$cashOf(base))} to spare`,
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: (()=>{
                                    const m = (0, $263fcb126ae0e669$export$ca60ec58f5352c3a)(why.row, factFind);
                                    if (m.home === 'rented') return 'The rent from the home, after its costs and the weeks it sits empty, is part of the money in; the lost Age Pension is part of the difference.';
                                    if (m.home === 'sold') return 'What the sale money earns, wherever it is put, is part of the money in.';
                                    return 'What is paid for the right no longer earns anything, and any change in the Age Pension is part of the difference.';
                                })()
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Explain this sets out every line of it, year by year."
                            })
                        ]
                    }),
                    why.page === 'gift' && (()=>{
                        const m = (0, $263fcb126ae0e669$export$ca60ec58f5352c3a)(why.row, factFind);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-3 text-[14px] leading-relaxed text-slate-700",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        v.They,
                                        " give ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: $124fc1b7c2dbb105$var$money(m.entryContribution)
                                        }),
                                        " for the right to live with ",
                                        host,
                                        "."
                                    ]
                                }),
                                m.amountPaid === 0 && (m.propertyTransferred > 0 || m.construction > 0) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        m.propertyTransferred > 0 ? "The home\u2019s title" : 'The cost of the build',
                                        ", on its own, is taken at face value as the price of the right, so none of it is a gift, whatever it is worth."
                                    ]
                                }) : m.deprivation > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        "Cash is tested: the right can be valued up to Centrelink's limit, or the home or build it comes with if that is more. ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: $124fc1b7c2dbb105$var$money(m.deprivation)
                                        }),
                                        " is above that. Less the ",
                                        $124fc1b7c2dbb105$var$money((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0)),
                                        " a year that can be given freely, ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: $124fc1b7c2dbb105$var$money((0, $263fcb126ae0e669$export$15946ade44cdb983)(m.deprivation))
                                        }),
                                        " counts as a gift: Centrelink keeps counting it as ",
                                        v.you ? 'yours' : 'theirs',
                                        ", and deems it to earn income, for five years, then it drops off."
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "Cash is tested against Centrelink's value of the right. This plan pays no more than that value, so none of it is a gift."
                                })
                            ]
                        });
                    })()
                ]
            })
        ]
    });
};
var $124fc1b7c2dbb105$export$2e2bcd8739ae039 = $124fc1b7c2dbb105$var$GfPlansView;


/**
 * The granny flat plan page (rebuild, 21 Oct 2026; the agreed mock-up's j1 plan page and j2 "back on the
 * plan page").
 *
 * AGED CARE'S SHAPE, FROM THE SHARED PIECES (owner, 22 Oct 2026: "Yes i want this all consistent"). The chosen
 * plan on ChosenPlanCard — what is left against staying put, the Age Pension, the year's money and what is given
 * for the right; the arrangement and, with a guaranteed income, what the family receives; then the advice document
 * and the next step (the family guide, then a solicitor, or the questions left once the brief is printed); then
 * "Model something else" and the ways on as links. Every figure is the chosen card's own, as it was chosen.
 */ 
parcelRequire("acw62");








/**
 * The solicitor brief — what the family discussion guide produces (owner, 2 Oct 2026).
 *
 * The guide used to be a page to read. It is now a set of questions the family answers together,
 * and this file turns those answers into a document they can hand to a solicitor: who is
 * instructing, the arrangement proposed, what the right should cover, what happens if things
 * change, how fairness to the other family is handled, and — honestly — what is still undecided,
 * listed as questions for the solicitor rather than hidden.
 *
 * It is a brief, not an agreement, and says so. Nothing here is advice: the figures are the
 * modelling tool's estimate and Services Australia decides; the agreement is the solicitor's work.
 * No provider or firm names in client-facing text.
 */ const $82f6c9c0d5566ac3$export$808b1469e403446d = {
    cash: 'A cash payment to the family',
    build: 'Paying to build or extend accommodation on the family\'s property',
    transfer_home: 'Transferring the title of the current home to the family',
    buy_in_their_name: 'Buying a home in the family member\'s name',
    mixed: 'A mix: one of the above plus cash or other assets on top',
    undecided: 'Still to decide'
};
const $82f6c9c0d5566ac3$export$186c9d965b8fe09 = {
    me: 'The person moving in pays an agreed share of household bills',
    family: 'The family covers household bills',
    shared: 'Bills are shared on a basis still to be written down',
    undecided: 'Still to decide'
};
const $82f6c9c0d5566ac3$export$9dfc2fad813fc18 = {
    yes: "Yes \u2014 a family member will provide substantial daily care",
    no: "No \u2014 company and support, not daily care",
    unsure: 'Not sure yet'
};
const $82f6c9c0d5566ac3$export$aa60e76ea289eada = {
    will: 'Adjust the Will so the other family members are balanced up',
    advance: 'Record what is given as an advance on that family member\'s inheritance',
    insurance: 'Use life insurance to top up the other family members',
    care_exchange: "It is a fair exchange for the care being provided \u2014 write that understanding down",
    not_needed: "Not needed \u2014 the family has agreed it is fair as it stands",
    undecided: 'Still to decide'
};
const $82f6c9c0d5566ac3$export$43bfd2f329881f11 = {
    ifHostSells: {
        question: 'If the family sells or moves',
        money_back: 'An agreed amount comes back, or the right moves to the new home',
        new_right: 'The right continues in whatever home the family moves to',
        undecided: 'Still to decide'
    },
    ifNeedCare: {
        question: 'If residential aged care is needed',
        money_back: 'An agreed amount is repaid to help meet care costs',
        nothing_back: "Nothing is repaid \u2014 the money stays with the family",
        undecided: 'Still to decide'
    },
    ifRelationshipEnds: {
        question: 'If the relationship breaks down',
        money_back: 'An agreed amount is repaid and the arrangement ends',
        new_right: 'The right stays in place regardless',
        undecided: 'Still to decide'
    },
    ifHostDies: {
        question: 'If the family member dies, divorces or goes bankrupt',
        money_back: 'An agreed amount is repaid from the estate or the property',
        right_continues: 'The right binds whoever then owns the home',
        undecided: 'Still to decide'
    }
};
const $82f6c9c0d5566ac3$var$money = (v)=>`$${Math.round(v).toLocaleString('en-AU')}`;
const $82f6c9c0d5566ac3$var$esc = (s)=>String(s ?? '').replace(/[&<>"']/g, (c)=>({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        })[c]);
const $82f6c9c0d5566ac3$var$paragraphs = (s)=>(s || '').trim() ? s.trim().split(/\n{2,}|\n/).map((l)=>`<p>${$82f6c9c0d5566ac3$var$esc(l)}</p>`).join('') : '';
function $82f6c9c0d5566ac3$var$longDate(iso) {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });
}
const $82f6c9c0d5566ac3$export$834b773472e58cde = [
    {
        id: 'arrangement',
        title: 'The arrangement',
        keys: [
            'hostNames',
            'arrangementForm',
            'includes',
            'billsPaidBy',
            'careProvided'
        ]
    },
    {
        id: 'fairness',
        title: 'Fairness to the rest of the family',
        keys: [
            'fairness'
        ]
    },
    {
        id: 'whatIfs',
        title: 'The "what-ifs" to settle up front',
        keys: [
            'ifHostSells',
            'ifNeedCare',
            'ifRelationshipEnds',
            'ifHostDies'
        ]
    }
];
function $82f6c9c0d5566ac3$export$bb1680e8e7820e8a(a, key) {
    const v = a?.[key];
    if (typeof v !== 'string') return false;
    const t = v.trim();
    return t !== '' && t !== 'undecided' && t !== 'unsure';
}
function $82f6c9c0d5566ac3$export$db547e884904c14a(a) {
    const answers = a || {};
    const sections = {};
    let answered = 0;
    let total = 0;
    for (const s of $82f6c9c0d5566ac3$export$834b773472e58cde){
        const done = s.keys.filter((k)=>$82f6c9c0d5566ac3$export$bb1680e8e7820e8a(answers, k)).length;
        sections[s.id] = {
            answered: done,
            total: s.keys.length
        };
        answered += done;
        total += s.keys.length;
    }
    return {
        answered: answered,
        total: total,
        sections: sections
    };
}
function $82f6c9c0d5566ac3$export$b3e7fddc7911492a(a) {
    const q = [];
    if (!a.arrangementForm || a.arrangementForm === 'undecided') q.push('What form the payment for the right should take, and how it is best recorded.');
    if (!(a.includes || '').trim()) q.push("Exactly what the right to live there covers \u2014 rooms, shared areas, parking, garden, visitors.");
    if (!a.billsPaidBy || a.billsPaidBy === 'undecided') q.push('Who pays which household bills, and how that is written into the agreement.');
    if (!a.ifHostSells || a.ifHostSells === 'undecided') q.push(`${$82f6c9c0d5566ac3$export$43bfd2f329881f11.ifHostSells.question}: what happens to the right and to the money.`);
    if (!a.ifNeedCare || a.ifNeedCare === 'undecided') q.push(`${$82f6c9c0d5566ac3$export$43bfd2f329881f11.ifNeedCare.question}: whether any amount is repaid, and how it is calculated.`);
    if (!a.ifRelationshipEnds || a.ifRelationshipEnds === 'undecided') q.push(`${$82f6c9c0d5566ac3$export$43bfd2f329881f11.ifRelationshipEnds.question}: how the person moving in is protected.`);
    if (!a.ifHostDies || a.ifHostDies === 'undecided') q.push(`${$82f6c9c0d5566ac3$export$43bfd2f329881f11.ifHostDies.question}: whether the right binds the next owner, and what the estate owes.`);
    if (!a.fairness || a.fairness === 'undecided') q.push("How to keep things fair for other family members \u2014 the Will, an advance on inheritance, or otherwise.");
    return q;
}
function $82f6c9c0d5566ac3$export$13f025c8274eff6b(input) {
    const a = input.answers || {};
    const who = input.partnerName ? `${input.clientName} and ${input.partnerName}` : input.clientName;
    const f = input.figures;
    const open = $82f6c9c0d5566ac3$export$b3e7fddc7911492a(a);
    const whatIf = (key)=>{
        const def = $82f6c9c0d5566ac3$export$43bfd2f329881f11[key];
        const v = a[key] || 'undecided';
        const text = def[v] || def.undecided;
        const pending = !a[key] || a[key] === 'undecided';
        return `<tr><th scope="row">${$82f6c9c0d5566ac3$var$esc(def.question)}</th><td${pending ? ' class="pending"' : ''}>${$82f6c9c0d5566ac3$var$esc(text)}</td></tr>`;
    };
    return `<!DOCTYPE html>
<html lang="en-AU"><head><meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<title>Granny flat agreement \u{2014} instructions for our solicitor</title>
<style>
  :root{color-scheme:light}
  *{box-sizing:border-box}
  body{margin:0;background:#f8fafc;color:#0f172a;font:15px/1.55 -apple-system,"Segoe UI",Roboto,Helvetica,Arial,sans-serif}
  .page{max-width:820px;margin:0 auto;padding:40px 24px 64px}
  .doc{background:#fff;border:1px solid #e2e8f0;border-radius:16px;box-shadow:0 10px 30px rgba(15,23,42,.06);overflow:hidden}
  .doc::before{content:'';display:block;height:4px;background:linear-gradient(90deg,#2563eb,#14b8a6)}
  .inner{padding:36px 40px 40px}
  h1{margin:0 0 6px;font-size:26px;letter-spacing:-.02em;line-height:1.2}
  .lede{color:#334155;margin:0 0 24px;font-size:15px}
  h2{font-size:12px;font-weight:800;text-transform:uppercase;letter-spacing:.08em;color:#64748b;margin:28px 0 10px}
  p{margin:0 0 8px}
  table{width:100%;border-collapse:collapse;margin:4px 0 8px}
  th,td{text-align:left;vertical-align:top;padding:9px 10px;border-bottom:1px solid #e2e8f0;font-size:14px}
  th[scope=row]{width:42%;font-weight:600;color:#334155}
  td.pending{color:#b45309;font-weight:600}
  td.num{text-align:right;font-variant-numeric:tabular-nums;font-weight:700}
  .note{border:1px solid #e2e8f0;border-left:4px solid #2563eb;border-radius:12px;padding:12px 14px;margin:12px 0;font-size:14px;color:#334155}
  .note--amber{border-left-color:#f59e0b}
  ol{padding-left:20px;margin:0}
  ol li{margin:0 0 6px}
  .foot{margin-top:28px;padding-top:14px;border-top:1px solid #e2e8f0;font-size:12.5px;color:#64748b}
  .actions{display:flex;gap:10px;justify-content:flex-end;margin:0 0 14px}
  .btn{border:1px solid #cbd5e1;background:#fff;border-radius:10px;padding:8px 14px;font-weight:600;font-size:14px;cursor:pointer}
  @media print{body{background:#fff}.page{padding:0}.doc{border:0;box-shadow:none;border-radius:0}.actions{display:none}}
</style></head>
<body><div class="page">
<div class="actions"><button class="btn" type="button" onclick="window.print()">Print or save as PDF</button></div>
<div class="doc"><div class="inner">
<h1>Granny flat agreement \u{2014} instructions for our solicitor</h1>
<p class="lede">Prepared by ${$82f6c9c0d5566ac3$var$esc(who)} on ${$82f6c9c0d5566ac3$var$esc($82f6c9c0d5566ac3$var$longDate(input.generatedAt))}, from the family's own answers. This is a brief to start the conversation, not a draft agreement, and it is not legal advice. Please prepare the agreement and tell us what we have missed.</p>

<h2>Who is instructing</h2>
<table>
  <tr><th scope="row">The person${input.partnerName ? 's' : ''} moving in</th><td>${$82f6c9c0d5566ac3$var$esc(who)}</td></tr>
  <tr><th scope="row">The family member${/,| and |&/.test(a.hostNames || '') ? 's' : ''} they would live with</th><td${(a.hostNames || '').trim() ? '' : ' class="pending"'}>${$82f6c9c0d5566ac3$var$esc((a.hostNames || '').trim() || 'Still to confirm')}</td></tr>
</table>

<h2>The arrangement proposed</h2>
<table>
  <tr><th scope="row">What is given for the right to live there for life</th><td${!a.arrangementForm || a.arrangementForm === 'undecided' ? ' class="pending"' : ''}>${$82f6c9c0d5566ac3$var$esc($82f6c9c0d5566ac3$export$808b1469e403446d[a.arrangementForm || 'undecided'])}</td></tr>
  ${f ? `${f.planTitle ? `
  <tr><th scope="row">The plan chosen</th><td>${$82f6c9c0d5566ac3$var$esc(f.planTitle)}</td></tr>` : ''}
  <tr><th scope="row">Intended start</th><td>${$82f6c9c0d5566ac3$var$esc(f.dateEntered ? $82f6c9c0d5566ac3$var$longDate(f.dateEntered) : 'As soon as the agreement is in place')}</td></tr>
  <tr><th scope="row">Amount being given (cash, home or build)</th><td class="num">${$82f6c9c0d5566ac3$var$money(f.entryContribution)}</td></tr>
  <tr><th scope="row">Centrelink's value of the right (the tool's estimate)</th><td class="num">${$82f6c9c0d5566ac3$var$money(f.interestValue)}</td></tr>
  <tr><th scope="row">Amount expected to be treated as a gift</th><td class="num">${f.deprivation > 0 ? $82f6c9c0d5566ac3$var$money(f.deprivation) : 'None'}</td></tr>
  <tr><th scope="row">Expected Age Pension homeowner status</th><td>${f.isHomeowner ? "Homeowner \u2014 the right is an exempt asset" : "Non-homeowner \u2014 the amount paid is an assessable asset"}</td></tr>` : `
  <tr><th scope="row">Figures</th><td class="pending">Not yet modelled \u{2014} the amount, Centrelink's value of the right and any gift will follow once the family has settled on a figure.</td></tr>`}
</table>
<div class="note">The pension figures are the modelling tool's estimate under the social security rules. Services Australia makes the assessment once the arrangement is reported to it; the agreement and evidence of what was paid (including any building contract and invoices) are what it will ask for.</div>

<h2>What the right should cover</h2>
<table>
  <tr><th scope="row">Rooms, shared areas and the rest</th><td${(a.includes || '').trim() ? '' : ' class="pending"'}>${(a.includes || '').trim() ? $82f6c9c0d5566ac3$var$paragraphs(a.includes) : 'Still to decide'}</td></tr>
  <tr><th scope="row">Household bills and upkeep</th><td${!a.billsPaidBy || a.billsPaidBy === 'undecided' ? ' class="pending"' : ''}>${$82f6c9c0d5566ac3$var$esc($82f6c9c0d5566ac3$export$186c9d965b8fe09[a.billsPaidBy || 'undecided'])}</td></tr>
  <tr><th scope="row">Daily care from the family</th><td>${$82f6c9c0d5566ac3$var$esc($82f6c9c0d5566ac3$export$9dfc2fad813fc18[a.careProvided || 'unsure'])}</td></tr>
</table>

<h2>What happens if things change</h2>
<table>
  ${whatIf('ifHostSells')}
  ${whatIf('ifNeedCare')}
  ${whatIf('ifRelationshipEnds')}
  ${whatIf('ifHostDies')}
</table>
<div class="note note--amber">Where an amount is to come back, please advise how it should be set and recorded (for example as a loan repayable only in these events) so that it does not count as a financial asset for the pension in the meantime, and whether leaving within five years of starting could affect the pension assessment.</div>

<h2>Fairness to the rest of the family</h2>
<table>
  <tr><th scope="row">The family's approach</th><td${!a.fairness || a.fairness === 'undecided' ? ' class="pending"' : ''}>${$82f6c9c0d5566ac3$var$esc($82f6c9c0d5566ac3$export$aa60e76ea289eada[a.fairness || 'undecided'])}</td></tr>
</table>
<p>Please also advise whether the Will${input.partnerName ? 's' : ''} and any enduring power of attorney need updating alongside the agreement.</p>

${(a.notes || '').trim() ? `<h2>Notes from the family</h2>${$82f6c9c0d5566ac3$var$paragraphs(a.notes)}` : ''}

<h2>Questions we would like you to answer</h2>
${open.length ? `<ol>${open.map((q)=>`<li>${$82f6c9c0d5566ac3$var$esc(q)}</li>`).join('')}</ol>` : '<p>The family has settled each of the points above; please tell us what we have missed.</p>'}
<ol start="${open.length + 1}">
  <li>How the right to live there for life is best protected \u{2014} a registered interest on the title, a caveat, or otherwise.</li>
  <li>What the agreement should say about who may live there, visitors, and changes to the home.</li>
  <li>Any stamp duty, land tax or capital gains tax consequences of the chosen form, and who bears them.</li>
</ol>

<div class="foot">Produced from the granny flat family discussion guide. General information to help a family instruct a solicitor; it is not legal advice and does not replace the agreement the solicitor prepares.</div>
</div></div>
</div></body></html>`;
}
function $82f6c9c0d5566ac3$export$92b81748c7df1848(input) {
    const html = $82f6c9c0d5566ac3$export$13f025c8274eff6b(input);
    const blob = new Blob([
        html
    ], {
        type: 'text/html;charset=utf-8'
    });
    const url = URL.createObjectURL(blob);
    const safeName = input.clientName.replace(/[^a-zA-Z0-9]/g, '_') || 'Client';
    const tab = window.open('', '_blank');
    if (tab) {
        tab.document.open();
        tab.document.write(html);
        tab.document.close();
    } else {
        const openLink = document.createElement('a');
        openLink.href = url;
        openLink.target = '_blank';
        openLink.rel = 'noopener noreferrer';
        document.body.appendChild(openLink);
        openLink.click();
        document.body.removeChild(openLink);
    }
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = `GrannyFlat_SolicitorBrief_${safeName}_${input.generatedAt.slice(0, 10)}.html`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    setTimeout(()=>URL.revokeObjectURL(url), 30000);
}


const $549d68d9d6e3a57c$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
const $549d68d9d6e3a57c$var$signed = (n)=>`${n >= 0 ? '+' : "\u2212"}${$549d68d9d6e3a57c$var$money(Math.abs(n))}`;
const $549d68d9d6e3a57c$var$dateWords = (iso)=>iso ? new Date(iso).toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }) : null;
const $549d68d9d6e3a57c$var$link = 'font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900';
const $549d68d9d6e3a57c$var$GfHub = ({ factFind: factFind, plan: plan, onChangeArrangement: onChangeArrangement, onModelAnother: onModelAnother, onStartFresh: onStartFresh, onAllPlans: onAllPlans, onExplain: onExplain, onRisks: onRisks, onAdvice: onAdvice, onBuild: onBuild, onBuildNew: onBuildNew, outOfDate: outOfDate = null, onFamilyGuide: onFamilyGuide, onPrintBrief: onPrintBrief, onReadGuide: onReadGuide, onAssumptions: onAssumptions, onHome: onHome })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const card = plan.inputs.card;
    const host = (0, $32bd8c8afa665e9e$export$d71f476d519c5ae3)(factFind);
    const estate = (0, $32bd8c8afa665e9e$export$2f8f6124885fff97)(factFind);
    const base = card.baseline;
    const delta = base ? card.plan.legacy - base.legacy : null;
    const yrs = `${card.horizonYears} ${card.horizonYears === 1 ? 'year' : 'years'}`;
    const cash = (n)=>n < 0 ? `short ${$549d68d9d6e3a57c$var$money(-n)}` : `${$549d68d9d6e3a57c$var$money(n)} left over`;
    const a = card.arrangement;
    const guide = factFind?.grannyFlat?.familyGuide || {};
    const progress = (0, $82f6c9c0d5566ac3$export$db547e884904c14a)(guide);
    const brief = guide.brief?.generatedAt ? guide.brief : null;
    const openLeft = (0, $82f6c9c0d5566ac3$export$b3e7fddc7911492a)(guide).length;
    const builtByYou = card.origin === 'manual';
    const homeWords = a.home === 'rented' ? `kept, rented at about ${$549d68d9d6e3a57c$var$money(a.rentAYear)} a year` : a.home === 'kept' ? 'kept, empty' : a.home === 'sold' ? 'sold' : a.home === 'transferred' ? `signed over to ${host}` : null;
    const pensionChange = base ? card.plan.pension - base.pension : null;
    const figures = [
        {
            label: 'Age Pension',
            value: $549d68d9d6e3a57c$var$money(card.plan.pension),
            unit: 'a year',
            note: pensionChange == null ? undefined : Math.abs(pensionChange) >= 1 ? `${$549d68d9d6e3a57c$var$signed(pensionChange)} a year vs staying put` : 'the same as staying put'
        },
        {
            /* "Each year, short by" when the plan falls short, as aged care's plan page says it (owner, 22 Oct 2026). */ label: card.plan.cashflow < 0 ? 'Each year, short by' : 'Left over each year',
            value: $549d68d9d6e3a57c$var$money(Math.abs(card.plan.cashflow)),
            tone: card.plan.cashflow < 0 ? 'plain' : 'good',
            note: base ? `staying put: ${cash(base.cashflow)}` : undefined,
            testId: 'gf-hub-cashflow'
        },
        {
            label: a.given > 0 ? `Given to ${host}` : 'Paid for the right to live there',
            value: $549d68d9d6e3a57c$var$money(a.given),
            note: a.given > 0 ? a.gift > 0 ? `${$549d68d9d6e3a57c$var$money(a.gift)} of it counts as a gift` : 'none of it counts as a gift' : "nothing is given \u2014 just moving in",
            testId: 'gf-hub-given'
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-4",
        "data-testid": "gf-hub",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[13px] text-slate-500",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onHome,
                                className: "underline decoration-dotted underline-offset-2 hover:text-slate-800",
                                children: "Home"
                            }),
                            " \u203A Granny flat"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                        className: "mt-2 text-[32px] font-bold leading-tight tracking-tight text-brand-navy",
                        "data-testid": "gf-hub-title",
                        children: [
                            v.you ? 'Your granny flat plan' : `${v.Possessive} granny flat plan`,
                            " \u2014 with ",
                            host
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1 text-[15px] leading-relaxed text-slate-600",
                        children: [
                            delta != null && (delta < 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    v.Possessive,
                                    " estate is ",
                                    $549d68d9d6e3a57c$var$money(-delta),
                                    " less than staying put after about ",
                                    yrs,
                                    a.given > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            "; ",
                                            $549d68d9d6e3a57c$var$money(a.given),
                                            " of what was given is with ",
                                            host,
                                            ", not lost"
                                        ]
                                    }) : null,
                                    ".",
                                    ' '
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    v.Possessive,
                                    " estate is ",
                                    $549d68d9d6e3a57c$var$money(delta),
                                    " more than staying put after about ",
                                    yrs,
                                    ".",
                                    ' '
                                ]
                            })),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onChangeArrangement,
                                className: $549d68d9d6e3a57c$var$link,
                                children: "Change the arrangement"
                            }),
                            onStartFresh && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    " \xb7 ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: onStartFresh,
                                        className: $549d68d9d6e3a57c$var$link,
                                        "data-testid": "gf-hub-start-fresh-header",
                                        children: "Start a new model from scratch"
                                    })
                                ]
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e32778aa0d8016bc$export$582b8e8b67199c5d), {
                reason: outOfDate,
                onChooseAgain: onAllPlans,
                testId: "gf-hub-out-of-date"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b200f9f0b001184e$export$14ec62d97a734af3), {
                testIdPrefix: "gf-hub",
                chosenOn: $549d68d9d6e3a57c$var$dateWords(plan.createdAt),
                builtByYou: builtByYou,
                title: card.words.title,
                sub: card.words.sub || undefined,
                estate: card.plan.legacy,
                years: card.horizonYears,
                estateDelta: delta,
                baseWord: "staying put",
                figures: figures,
                onExplain: onExplain,
                onRisks: onRisks,
                onAllPlans: onAllPlans,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        "data-testid": "gf-hub-arrangement",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[14px] font-semibold text-slate-900",
                                children: "The arrangement"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                className: "mt-1 space-y-0.5 text-[14px] leading-relaxed text-slate-700",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        "data-testid": "gf-hub-estate",
                                        children: [
                                            "In ",
                                            estate,
                                            " after about ",
                                            yrs,
                                            ": ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                className: "tabular-nums text-slate-900",
                                                children: $549d68d9d6e3a57c$var$money(card.plan.legacy)
                                            }),
                                            a.given > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    ", plus ",
                                                    $549d68d9d6e3a57c$var$money(a.given),
                                                    " with ",
                                                    host
                                                ]
                                            }) : null,
                                            "."
                                        ]
                                    }),
                                    a.given > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        children: [
                                            "Centrelink's value of the right to live there: ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "tabular-nums",
                                                children: $549d68d9d6e3a57c$var$money(a.interestValue)
                                            }),
                                            "."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        children: [
                                            "Homeowner for the Age Pension: ",
                                            a.isHomeowner ? `yes \u{2014} more than ${$549d68d9d6e3a57c$var$money((0, $1abe73eeef086faf$export$e2cf792e99a08354))} given, so the right is not counted` : a.given > 0 ? `no \u{2014} ${$549d68d9d6e3a57c$var$money(a.given)} given, not more than ${$549d68d9d6e3a57c$var$money((0, $1abe73eeef086faf$export$e2cf792e99a08354))}, so the right counts as an asset` : 'no',
                                            "."
                                        ]
                                    }),
                                    homeWords && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        children: [
                                            "The home: ",
                                            homeWords,
                                            "."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        children: [
                                            "Starting: ",
                                            a.dateEntered ? $549d68d9d6e3a57c$var$dateWords(a.dateEntered) : 'now',
                                            "."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    card.family && card.family.rows.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
                            factFind: factFind,
                            personName: card.family.personName,
                            amount: card.family.amount,
                            kind: card.family.kind,
                            incomeAYear: card.family.incomeAYear,
                            rows: null,
                            frozen: card.family.rows,
                            compareNote: card.family.compareNote,
                            horizonYears: card.horizonYears,
                            testId: "gf-hub-family-panel"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "gf-hub-next",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b200f9f0b001184e$export$402ee133f3748280), {
                    documentState: plan.soaSnapshot ? 'prepared' : 'not prepared yet',
                    documentLine: "The written record of this plan: what it assumes, what it costs, what could go wrong.",
                    documentAction: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onAdvice,
                        className: $549d68d9d6e3a57c$var$link,
                        "data-testid": "gf-hub-advice",
                        children: plan.soaSnapshot ? 'Open the advice document' : 'Get the advice document'
                    }),
                    nextTitle: brief ? 'see a solicitor' : 'the family guide, then a solicitor',
                    nextLine: brief ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        "data-testid": "gf-hub-brief",
                        children: [
                            "Solicitor brief printed ",
                            $549d68d9d6e3a57c$var$dateWords(brief.generatedAt),
                            ". ",
                            openLeft === 0 ? 'Every question has an answer.' : `${openLeft} ${openLeft === 1 ? 'question' : 'questions'} left for the solicitor.`,
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onPrintBrief,
                                className: $549d68d9d6e3a57c$var$link,
                                "data-testid": "gf-hub-print-again",
                                children: "Print it again"
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onFamilyGuide,
                                className: $549d68d9d6e3a57c$var$link,
                                "data-testid": "gf-hub-guide",
                                children: "Continue the guide"
                            }),
                            "."
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        "data-testid": "gf-hub-guide-progress",
                        children: [
                            progress.answered,
                            " of ",
                            progress.total,
                            " questions answered.",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onFamilyGuide,
                                className: $549d68d9d6e3a57c$var$link,
                                "data-testid": "gf-hub-guide",
                                children: progress.answered > 0 ? 'Continue the guide' : 'Open the guide'
                            }),
                            " \u2014 it prints a brief with this plan's figures for the solicitor."
                        ]
                    }),
                    nextAction: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onHome,
                        className: $549d68d9d6e3a57c$var$link,
                        children: "Full action plan on Home"
                    })
                })
            }),
            (onModelAnother || onStartFresh) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b200f9f0b001184e$export$9e6485da48da532f), {
                testId: "gf-hub-model-something-else",
                options: [
                    ...onModelAnother ? [
                        {
                            title: 'Another arrangement, same answers',
                            body: `Keeps who ${v.they} would live with and the answers to the questions. Change what is given, the home or the start.`,
                            action: 'Model another arrangement',
                            onClick: onModelAnother,
                            testId: 'gf-hub-model-another'
                        }
                    ] : [],
                    ...onStartFresh ? [
                        {
                            title: 'A new model from scratch',
                            body: 'Starts again at step 1 with nothing carried over, and asks the questions again so you can change any of them.',
                            action: 'Start a new model from scratch',
                            onClick: onStartFresh,
                            testId: 'gf-hub-start-fresh'
                        }
                    ] : []
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b200f9f0b001184e$export$29d0c084f57dd4ac), {
                links: [
                    {
                        label: 'Change the arrangement',
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        onClick: onChangeArrangement,
                        testId: 'gf-hub-change'
                    },
                    {
                        label: 'All the plans we tested',
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e583651be68dae50$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        onClick: onAllPlans
                    },
                    // Two doors (owner, 25 Oct 2026): change this plan, or start a blank one.
                    {
                        label: builtByYou ? 'Change the plan you built' : 'Customise this plan',
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $712d717556ef1508$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        onClick: onBuild,
                        testId: 'gf-hub-build'
                    },
                    ...onBuildNew ? [
                        {
                            label: 'Build a plan yourself',
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $712d717556ef1508$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            onClick: onBuildNew,
                            testId: 'gf-hub-build-new'
                        }
                    ] : [],
                    {
                        label: 'The family discussion guide',
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        onClick: onFamilyGuide
                    },
                    {
                        label: "How granny flat arrangements work \u2014 the guide",
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        onClick: onReadGuide
                    },
                    {
                        label: 'Rates and assumptions',
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        onClick: onAssumptions
                    }
                ]
            })
        ]
    });
};
var $549d68d9d6e3a57c$export$2e2bcd8739ae039 = $549d68d9d6e3a57c$var$GfHub;


/**
 * "Build a plan yourself" — the granny flat's ledger (rebuild, 21 Oct 2026; the village's RvBuildPlan, with
 * Manual Control's parity: the same card on record, Explain this, What could go wrong and the same words).
 *
 * One picture of the arrangement, in the order a family decides it:
 *   1. what they give for the right — cash, a build, the home signed over, or nothing — with the gift test
 *      said where the amount is entered (GrannyFlatArrangementNote);
 *   2. what happens to the home — kept empty, kept and let (the rent, its costs and the weeks it sits empty,
 *      with the six-year capital gains tax clock), or sold, with where the money left after the right goes;
 *   3. where a payment from savings comes from, account by account;
 * and, for every piece in use, How it works / Good for / Watch out for, in this client's figures. Beside it,
 * what the plan does, updating as it changes, the buttons, and "before you choose" for an income-only
 * guaranteed income.
 *
 * Presentation over the page's Manual Control state: every input writes the same fields the projection
 * already reads (amountPaid, transferHome, constructionCost, fundFrom, funding, deployment, keptHomeUse and
 * the rent), so the figures are the engine's own.
 */ 
parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");






/**
 * Shared "choose which assets to sell to fund $X" allocator.
 *
 * Lists the client's personal/joint liquid assets (bank, term deposits, shares, account-based pensions,
 * super) and lets them allocate an amount from each toward a target — instead of an opaque automatic
 * draw-down order. Share sales show estimated CGT (net credited toward the target). This is the same
 * mechanism the Aged Care RAD and RV entry-fee pickers use, so the granny-flat and downsizer modules stay
 * consistent. De-pastelled per the design system (white/slate surfaces, semantic accents only).
 *
 * @param {Object}   props
 * @param {Object}   props.factFind
 * @param {number}   props.target        - net amount the client needs to fund
 * @param {Object}   props.funding       - allocation map (assetId → gross amount)
 * @param {Function} props.onChange      - (nextMap) => void
 * @param {Object}   [props.cgtOverrides]
 * @param {Function} [props.onCgtOverridesChange]
 * @param {string}   [props.targetLabel='Amount to fund']
 * @param {string}   [props.help]
 */ const $dc43d1ee81f3ee79$var$AssetFundingAllocator = ({ factFind: factFind, target: target = 0, funding: funding = {}, onChange: onChange, cgtOverrides: cgtOverrides = {}, onCgtOverridesChange: onCgtOverridesChange, targetLabel: targetLabel = 'Amount to fund', help: help })=>{
    const assets = (0, $acw62.useMemo)(()=>(0, $bd80071df75c742b$export$a6f66b42cac1f673)(factFind), [
        factFind
    ]);
    const totals = (0, $acw62.useMemo)(()=>(0, $bd80071df75c742b$export$e98193fa2b9f521b)(factFind, funding, cgtOverrides), [
        factFind,
        funding,
        cgtOverrides
    ]);
    const netAllocated = totals.netTotal;
    const remaining = target - netAllocated;
    const setAmount = (assetId, value)=>{
        const numeric = parseFloat(String(value)) || 0;
        const next = {
            ...funding
        };
        if (numeric <= 0) delete next[assetId];
        else next[assetId] = numeric;
        onChange(next);
        if (numeric <= 0 && onCgtOverridesChange && cgtOverrides?.[assetId] != null) {
            const nextO = {
                ...cgtOverrides
            };
            delete nextO[assetId];
            onCgtOverridesChange(nextO);
        }
    };
    const handleCgtOverride = (assetId, value)=>{
        if (!onCgtOverridesChange) return;
        const next = {
            ...cgtOverrides
        };
        if (value == null) delete next[assetId];
        else next[assetId] = value;
        onCgtOverridesChange(next);
    };
    if (assets.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "text-sm text-slate-500 italic",
        children: "No liquid assets are recorded in your profile to fund this from."
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-xl border border-slate-200 bg-white p-4 space-y-4 shadow-sm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                className: "text-sm font-semibold text-gray-900",
                                children: "Which assets will you use?"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-xs text-gray-600",
                                children: help || 'Choose how much to draw from each asset. Share sales show estimated capital gains tax; the net amount counts toward what you need.'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-right shrink-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[11px] font-semibold text-slate-500 uppercase tracking-wide",
                                children: remaining > 0 ? 'Still to fund' : 'Fully funded'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: `text-lg font-bold ${remaining > 0.5 ? 'text-amber-700' : 'text-green-700'}`,
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.max(0, remaining))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "space-y-3",
                children: assets.map((asset)=>{
                    const amount = funding[asset.assetId] || 0;
                    const available = parseFloat(String(asset.value)) || 0;
                    const isShares = asset.typeId === 'shares';
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "rounded-lg border border-slate-200 bg-slate-50 p-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "block text-sm font-medium text-gray-700",
                                children: [
                                    (0, $e850825c00b15be4$export$87285386e0429fb5)(asset, factFind, asset.typeName),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "block text-xs font-normal text-slate-500",
                                        children: [
                                            "Available ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(available),
                                            isShares && asset.costBase ? " \xb7 CGT deducted from proceeds" : ''
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-2 mt-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "range",
                                        min: "0",
                                        max: available,
                                        value: amount,
                                        onChange: (e)=>setAmount(asset.assetId, e.target.value),
                                        className: "w-full h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-blue-600"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "w-32",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                            value: amount || '',
                                            onChange: (v)=>setAmount(asset.assetId, v),
                                            placeholder: "0",
                                            className: "",
                                            ariaLabel: `Amount from ${(0, $e850825c00b15be4$export$87285386e0429fb5)(asset, factFind, asset.typeName)}`
                                        })
                                    })
                                ]
                            }),
                            isShares && amount > 0 && asset.costBase && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e778a6a28982486d$export$45781c28beddd168), {
                                    factFind: factFind,
                                    taxSummary: (0, $a764bc0f6f904854$export$bb01b201c6492ed7)(factFind, asset, amount, {
                                        trustDisposal: 'distribute'
                                    }),
                                    overrideValue: cgtOverrides?.[asset.assetId],
                                    onOverrideChange: (value)=>handleCgtOverride(asset.assetId, value),
                                    asset: asset,
                                    showNetProceedsLine: true,
                                    saleAmount: amount,
                                    netProceedsLabel: "Net toward what you need (after estimated CGT)"
                                })
                            })
                        ]
                    }, asset.assetId);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pt-3 border-t border-slate-200 flex justify-between text-sm font-bold",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            targetLabel,
                            ": ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(target)
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: netAllocated > target + 0.5 ? 'text-red-600' : 'text-gray-800',
                        children: [
                            "Allocated (net): ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(netAllocated)
                        ]
                    })
                ]
            })
        ]
    });
};
var $dc43d1ee81f3ee79$export$2e2bcd8739ae039 = $dc43d1ee81f3ee79$var$AssetFundingAllocator;



/**
 * The reasonableness test, said where the amount is entered.
 *
 * WHY IT MOVED HERE. This is the single question that decides whether a granny flat arrangement is a
 * clean transfer or a five-year penalty, and it was explained only inside the floating
 * "What's happening" panel. A family could type $600,000 into the box above and see nothing at all
 * about the assessed value it is being measured against — until they opened a panel elsewhere on the
 * screen and found the right card.
 *
 * WHAT THE TEST IS. Centrelink puts a value on the lifetime right you receive: the combined
 * partnered pension rate times an age factor, or the value of the property or dwelling you provide,
 * whichever applies. Give up to that and none of it is a gift — granny flat interests are a
 * deliberate exception to the ordinary gifting limits. Give more and the excess is deprivation:
 * counted as your asset, and deemed to earn income, for five years from the start date.
 *
 * AND THE THING FAMILIES GET WRONG. When the former home is KEPT, the gift result is usually not
 * the main event. A house nobody lives in stops being exempt the moment you move out, and on most
 * cases that costs more pension than any deprivation does. The note says so where it applies,
 * because a family reading "none of this counts as a gift" would otherwise reasonably conclude the
 * arrangement is means-test neutral.
 *
 * Every figure is passed in from the page's own state — the same values the plan summary and the
 * projections use. Nothing is re-derived here.
 */ 
parcelRequire("acw62");



function $dcb65f51c88a7220$export$2e2bcd8739ae039({ entryContribution: entryContribution, interestValue: interestValue, reasonableValue: reasonableValue, deprivation: deprivation, keepingHome: keepingHome, formerHomeValue: formerHomeValue }) {
    if (!(entryContribution > 0)) return null;
    /*
     * ONE MEANING FOR "THE VALUE OF THE RIGHT" (24 Oct 2026: this note called the larger-of figure the value, the
     * plan page and the brief called given − gift the value). The right is valued at what is given less any
     * gift; `interestValue` is the most it can be valued at — the limit, or the home or build taken at face value.
     */ const gifted = Math.round(deprivation) > 0;
    const counted = Math.max(0, deprivation - (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0));
    const providesProperty = interestValue > reasonableValue;
    const valued = Math.max(0, entryContribution - deprivation);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$36b8132fbfd1058f), {
                tone: counted >= 1 ? 'warn' : 'good',
                heading: counted >= 1 ? `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(counted)} of this counts as a gift` : gifted ? 'Within what can be given freely, so nothing is counted' : 'None of this counts as a gift',
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            "You are giving ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(entryContribution)
                            }),
                            ", and Centrelink values the lifetime right at ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(valued)
                            }),
                            ". The most it can be valued at is",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(interestValue)
                            }),
                            providesProperty ? " \u2014 the home or build you are providing, taken at face value." : " \u2014 Centrelink\u2019s limit for a lifetime right at your age."
                        ]
                    }),
                    gifted ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1.5",
                        children: [
                            "The ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(deprivation)
                            }),
                            " above that is a ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "gift"
                            }),
                            ". Less the",
                            ' ',
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0)),
                            " a year that can be given freely, Centrelink counts",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(counted)
                            }),
                            " as your asset, and deems it to earn income, for",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "five years"
                            }),
                            " \u2014 even though the money has gone. Keeping what you give within the most the right can be valued at avoids it."
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-1.5",
                        children: "What you give is within what the right can be valued at, so none of it is a gift. Granny flat rights are a deliberate exception to the ordinary gifting limits when the amount is within that."
                    })
                ]
            }),
            keepingHome && formerHomeValue > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$36b8132fbfd1058f), {
                tone: "warn",
                heading: "The gift question is usually not the main event",
                children: [
                    "Whatever the gift result, the",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(formerHomeValue)
                    }),
                    " home you are keeping stops being exempt the moment nobody in the household lives in it. From then it is counted like any other asset \u2014 and on most cases that moves the Age Pension further than any deprivation does. Selling it, or moving in without keeping it, is the bigger lever."
                ]
            })
        ]
    });
}




const $76543b97b38c81f2$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
const $76543b97b38c81f2$var$signed = (n)=>`${n >= 0 ? '+' : "\u2212"}${$76543b97b38c81f2$var$money(Math.abs(n))}`;
const $76543b97b38c81f2$var$cashWords = (n)=>n < 0 ? `short ${$76543b97b38c81f2$var$money(-n)}` : $76543b97b38c81f2$var$money(n);
const $76543b97b38c81f2$var$link = 'font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy';
const $76543b97b38c81f2$var$card = 'rounded-2xl border border-slate-200 bg-white p-5 shadow-card';
const $76543b97b38c81f2$var$num = (v)=>Number(v) || 0;
const $76543b97b38c81f2$var$Choice = ({ value: value, options: options, onChange: onChange, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-wrap gap-2",
        role: "radiogroup",
        "data-testid": testId,
        children: options.map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                role: "radio",
                "aria-checked": value === o.id,
                disabled: o.disabled,
                onClick: ()=>onChange(o.id),
                className: `rounded-lg border px-3 py-1.5 text-[13px] font-semibold disabled:cursor-not-allowed disabled:opacity-40 ${value === o.id ? 'border-blue-600 bg-blue-50 text-brand-navy' : 'border-slate-300 bg-white text-slate-700 hover:border-blue-300'}`,
                children: [
                    value === o.id ? "\u2713 " : '',
                    o.label
                ]
            }, o.id))
    });
function $76543b97b38c81f2$export$5c6d57f11da7e68b(p) {
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(p.factFind);
    const host = (0, $32bd8c8afa665e9e$export$d71f476d519c5ae3)(p.factFind);
    const out = [];
    if (p.form === 'cash') out.push({
        id: 'cash',
        title: `Paying ${host} ${$76543b97b38c81f2$var$money(p.cash)} for the right`,
        how: `${v.Names} pay${v.s} ${host} for a right to live in ${(0, $32bd8c8afa665e9e$export$f61aefdb7cc5750d)(p.factFind)} for life. Centrelink\u{2019}s limit for that right at ${v.their} age is ${$76543b97b38c81f2$var$money(p.reasonableValue)}; cash up to that is the price of the right, and none of it is a gift.${p.deprivation > 0 ? ` This plan pays ${$76543b97b38c81f2$var$money(p.deprivation)} more, which counts as a gift for five years (less the ${$76543b97b38c81f2$var$money((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))} that can be given freely).` : ''}`,
        good: [
            "Keeping the Age Pension\u2019s homeowner rules where more than the homeowner line is paid",
            "Avoiding a gift, when the payment stays within Centrelink\u2019s limit"
        ],
        watch: [
            `It becomes ${host}\u{2019}s money: exposed to their divorce, debts or death`,
            "Cash above Centrelink\u2019s limit is counted for five years though it has gone",
            'Without a written agreement, little protection if things change'
        ]
    });
    if (p.form === 'build') out.push({
        id: 'build',
        title: `Paying ${$76543b97b38c81f2$var$money(p.build)} for a build`,
        how: `${v.Names} pay${v.s} to build or extend ${(0, $32bd8c8afa665e9e$export$f61aefdb7cc5750d)(p.factFind)} for ${v.their} own accommodation. Centrelink takes the cost of the build as the price of the right \u{2014} no gift, whatever it costs.${p.cash > 0 ? ` The ${$76543b97b38c81f2$var$money(p.cash)} given on top is tested against the greater of the build\u{2019}s cost and ${$76543b97b38c81f2$var$money(p.reasonableValue)}.` : ''}`,
        good: [
            'A home designed around what is needed',
            'No gift on the build itself, however large'
        ],
        watch: [
            "Keep the building contract and invoices: anything paid beyond the build\u2019s cost is tested",
            'Building approvals, delays and over-runs',
            `The building belongs to ${host}`
        ]
    });
    if (p.form === 'home') out.push({
        id: 'home',
        title: `Signing the ${$76543b97b38c81f2$var$money(p.homeValue)} home over`,
        how: `The home\u{2019}s title passes to ${host} in return for the right to live with them. Centrelink takes the home at face value as the price of the right, so none of it is a gift${p.homeValue > (0, $1abe73eeef086faf$export$e2cf792e99a08354) ? `, and ${v.they} stay homeowners for the Age Pension` : `; but as it is not more than ${$76543b97b38c81f2$var$money((0, $1abe73eeef086faf$export$e2cf792e99a08354))}, ${v.they} are not homeowners and the right counts as an asset`}.${p.cash > 0 ? ` The ${$76543b97b38c81f2$var$money(p.cash)} given on top is tested against the greater of the home and ${$76543b97b38c81f2$var$money(p.reasonableValue)}.` : ''}`,
        good: [
            'Keeping the Age Pension, where every other way stops it',
            'No cash leaves savings'
        ],
        watch: [
            `The home is ${host}\u{2019}s from then \u{2014} exposed to their divorce, debts or death`,
            "The estate falls by the home\u2019s value; other family can be left behind unless the Will evens it out",
            `Stamp duty may be payable on the transfer, usually by ${host}; it is not in these figures \u{2014} ask the solicitor`,
            'Leaving within five years can lead Centrelink to look at the transfer again as a gift'
        ]
    });
    if (p.homeUse === 'rented') out.push({
        id: 'rent',
        title: 'Keeping the home and renting it out',
        how: `The home is let for about ${$76543b97b38c81f2$var$money(p.rentWeekly)} a week, less ${p.vacancy} ${p.vacancy === 1 ? 'week' : 'weeks'} a year without a tenant. It is counted for the Age Pension from the day ${v.they} move, and the rent after costs counts as income.`,
        good: [
            'Rent while the home stays in the family',
            'Keeping the option to sell later'
        ],
        watch: [
            'Land tax can apply once it is no longer where they live',
            "Weeks without a tenant, repairs and the agent\u2019s fee",
            'Capital gains tax on a sale more than six years after moving out'
        ]
    });
    if (p.homeUse === 'vacant') out.push({
        id: 'vacant',
        title: 'Keeping the home, empty',
        how: `The home stays as it is. It earns nothing, but Centrelink counts it in full from the day ${v.they} move.`,
        good: [
            'Somewhere to go back to if the arrangement ends'
        ],
        watch: [
            'Rates, insurance and upkeep go on with no rent to pay them (not added as a cost in these figures)',
            'It usually costs the Age Pension'
        ]
    });
    if (p.homeUse === 'sold') out.push({
        id: 'sold',
        title: 'Selling the home',
        how: `The home is sold for about ${$76543b97b38c81f2$var$money(p.homeValue)}, less selling costs. The sale pays for the right; what is left is ${v.their} to put to work, and Centrelink counts it wherever it goes.`,
        good: [
            'Money freed for income and the costs ahead',
            'No property to look after'
        ],
        watch: [
            'No home to go back to if the arrangement ends',
            'Selling costs, and the time a sale takes'
        ]
    });
    const d = p.deployment || {};
    if ($76543b97b38c81f2$var$num(d.annuity) > 0) out.push({
        id: 'annuity',
        title: 'A guaranteed income for life',
        how: `${$76543b97b38c81f2$var$money($76543b97b38c81f2$var$num(d.annuity))} is handed to an insurer, who pays a set income for as long as ${v.they} live. What comes back if the money is needed, or on death, depends on the type chosen.`,
        good: [
            'An income that does not depend on markets, for life'
        ],
        watch: [
            'Prices rising faster than the payments',
            'Money that is hard to get back if plans change',
            "A provider\u2019s quote can differ from our estimate"
        ]
    });
    if ($76543b97b38c81f2$var$num(d.investmentProperty) > 0) out.push({
        id: 'property',
        title: 'An investment property',
        how: `A ${$76543b97b38c81f2$var$money($76543b97b38c81f2$var$num(d.investmentProperty))} property is bought and let. Rent is suggested at 3.5% of the price, the agent at 8% of the rent, upkeep at 1% of the value and two weeks a year empty; investor stamp duty is paid, and capital gains tax when it is sold, by ${v.them} or the estate.`,
        good: [
            'Rental income and possible growth'
        ],
        watch: [
            'Weeks without a tenant, while the costs go on',
            'Rates, insurance and land tax',
            'Money that takes months to get out'
        ]
    });
    if ($76543b97b38c81f2$var$num(d.superContribution) + $76543b97b38c81f2$var$num(d.partnerSuperContribution) > 0) out.push({
        id: 'super',
        title: 'Super, after tax',
        how: `${$76543b97b38c81f2$var$money($76543b97b38c81f2$var$num(d.superContribution) + $76543b97b38c81f2$var$num(d.partnerSuperContribution))} goes into super as an after-tax contribution, within each person\u{2019}s cap. Inside super the earnings are taxed at no more than 15%, or not at all once drawn as a pension.`,
        good: [
            'Lower tax on what the money earns'
        ],
        watch: [
            'Caps on how much can go in',
            'Centrelink counts it once a person reaches Age Pension age'
        ]
    });
    if ($76543b97b38c81f2$var$num(d.investmentBond) > 0) out.push({
        id: 'bond',
        title: 'An investment bond',
        how: `${$76543b97b38c81f2$var$money($76543b97b38c81f2$var$num(d.investmentBond))} goes into an investment bond, which pays its own tax inside (30%) and nothing on ${v.their} tax return; after ten years, withdrawals are tax-free.`,
        good: [
            'Money super can no longer take'
        ],
        watch: [
            'Centrelink counts it in full and deems it, like shares'
        ]
    });
    if ($76543b97b38c81f2$var$num(d.shares) > 0) out.push({
        id: 'shares',
        title: 'Investing it',
        how: `${$76543b97b38c81f2$var$money($76543b97b38c81f2$var$num(d.shares))} is invested in ${v.their} own names, in the mix chosen for new money.`,
        good: [
            'Growth and income over time'
        ],
        watch: [
            'The value rises and falls with markets',
            'Centrelink counts it in full and deems it'
        ]
    });
    if (out.length === 0) out.push({
        id: 'nothing',
        title: 'Moving in without paying',
        how: `${v.Names} move${v.s} in with ${host} and pay nothing for the right, so nothing is a gift. The home ${v.they} leave stops being exempt the day ${v.they} move.`,
        good: [
            'No money leaves savings'
        ],
        watch: [
            'No right is created, so there is less protection if things change',
            `Gifts to family above ${$76543b97b38c81f2$var$money((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))} a year (${$76543b97b38c81f2$var$money((0, $1abe73eeef086faf$export$9cd36ea38af5a5f3))} over five) are counted for five years`
        ]
    });
    return out;
}
const $76543b97b38c81f2$var$HowItWorks = ({ e: e })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $76543b97b38c81f2$var$card,
        "data-testid": `gf-how-${e.id}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[14px] font-bold text-slate-900",
                children: e.title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-[13px] font-bold text-brand-navy",
                children: "How it works"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-1 text-[14px] leading-relaxed text-slate-700",
                children: e.how
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-3 text-[13px] font-semibold text-slate-900",
                children: "Good for"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "mt-1 list-disc space-y-0.5 pl-5 text-[14px] text-slate-700",
                children: e.good.map((g)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: g
                    }, g))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-3 text-[13px] font-semibold text-slate-900",
                children: "Watch out for"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "mt-1 list-disc space-y-0.5 pl-5 text-[14px] text-slate-700",
                children: e.watch.map((g)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: g
                    }, g))
            })
        ]
    });
const $76543b97b38c81f2$var$GfBuildPlan = (p)=>{
    const { factFind: factFind } = p;
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const host = (0, $32bd8c8afa665e9e$export$d71f476d519c5ae3)(factFind);
    const homeValue = parseFloat(String(factFind?.home?.value ?? '')) || 0;
    const hasHome = homeValue > 0;
    const selling = p.homeUse === 'sold' && p.form !== 'home';
    const canSell = hasHome && (p.form === 'cash' || p.form === 'build') && p.cash + p.build > 0;
    const given = p.form === 'nothing' ? 0 : p.entryContribution;
    const explainers = $76543b97b38c81f2$export$5c6d57f11da7e68b({
        factFind: factFind,
        form: p.form,
        homeUse: hasHome && p.form !== 'home' ? p.homeUse : null,
        cash: p.cash,
        build: p.build,
        homeValue: homeValue,
        reasonableValue: p.reasonableValue,
        deprivation: p.deprivation,
        rentWeekly: p.rent.weekly,
        vacancy: p.rent.vacancy,
        deployment: p.deployment
    });
    const shortfall = p.fundingShortfall >= 1;
    const canChoose = !shortfall && !p.chooseHeld && !p.working;
    // While working, every figure reads "…" (never a mix of new and old) — the same as cashflow's panel.
    const eff = p.working ? {
        ...p.effect,
        cashflow: null,
        baseCashflow: null,
        pension: null,
        basePension: null,
        legacy: null,
        baseLegacy: null
    } : p.effect;
    const effectPanel = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `${$76543b97b38c81f2$var$card} xl:sticky xl:top-8`,
        "data-testid": "gf-build-effect",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] font-bold text-brand-navy",
                children: [
                    "Effect on the plan ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-normal text-slate-500",
                        children: "\u2014 updates as you go"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                className: "mt-2 w-full text-[14px] tabular-nums",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "border-b border-slate-100",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "py-2 text-slate-600",
                                    children: "Left over each year"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-right",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            className: $76543b97b38c81f2$var$num(eff.cashflow) >= 0 ? 'text-emerald-700' : 'text-rose-700',
                                            children: eff.cashflow == null ? "\u2026" : $76543b97b38c81f2$var$cashWords(eff.cashflow)
                                        }),
                                        eff.cashflow != null && eff.baseCashflow != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: `text-[12.5px] ${eff.cashflow - eff.baseCashflow >= 0 ? 'text-emerald-700' : 'text-rose-700'}`,
                                                    children: [
                                                        $76543b97b38c81f2$var$signed(eff.cashflow - eff.baseCashflow),
                                                        " vs staying put \xb7 first year"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "border-b border-slate-100",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "py-2 text-slate-600",
                                    children: "Age Pension"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-right",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: eff.pension == null ? "\u2026" : $76543b97b38c81f2$var$money(eff.pension)
                                        }),
                                        eff.pension != null && eff.basePension != null && Math.abs(eff.pension - eff.basePension) >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: `text-[12.5px] ${eff.pension > eff.basePension ? 'text-emerald-700' : 'text-rose-700'}`,
                                                    children: [
                                                        $76543b97b38c81f2$var$signed(eff.pension - eff.basePension),
                                                        " vs staying put"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "border-b border-slate-100",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-slate-600",
                                    children: [
                                        "In ",
                                        v.possessive,
                                        " estate, about ",
                                        p.horizonYears,
                                        " years"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-right",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: eff.legacy == null ? "\u2026" : $76543b97b38c81f2$var$money(eff.legacy)
                                        }),
                                        eff.legacy != null && eff.baseLegacy != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: `text-[12.5px] ${eff.legacy >= eff.baseLegacy ? 'text-emerald-700' : 'text-rose-700'}`,
                                                    children: [
                                                        $76543b97b38c81f2$var$signed(eff.legacy - eff.baseLegacy),
                                                        " vs staying put"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "border-b border-slate-100",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-slate-600",
                                    children: [
                                        "Given to ",
                                        host
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "py-2 text-right",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: $76543b97b38c81f2$var$money(given)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "py-2 text-slate-600",
                                    children: "Counted as a gift"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "py-2 text-right",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: p.deprivation > 0 ? 'text-rose-700' : '',
                                        children: $76543b97b38c81f2$var$money(p.deprivation)
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            p.lastChange && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 border-t border-slate-200 pt-2 text-[13px] text-slate-700",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-slate-500",
                        children: "Last change"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: p.lastChange
                    })
                ]
            }),
            p.onYearByYear && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: p.onYearByYear,
                className: `mt-3 block text-[13px] ${$76543b97b38c81f2$var$link}`,
                "data-testid": "gf-build-year-by-year",
                children: "See the year-by-year figures for this plan"
            }),
            p.comparison,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 grid grid-cols-2 gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: p.onExplain,
                        className: "inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-[13px] font-semibold text-slate-800 hover:border-blue-300",
                        "data-testid": "gf-build-explain",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                size: 15
                            }),
                            " Explain this"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: p.onRisks,
                        className: "inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-[13px] font-semibold text-slate-800 hover:border-blue-300",
                        "data-testid": "gf-build-risks",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4666dd9ae485baaf$export$2e2bcd8739ae039), {
                                size: 15
                            }),
                            " What could go wrong"
                        ]
                    })
                ]
            }),
            p.beforeChoose && !p.chosen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-3",
                "data-testid": "gf-build-before-choose",
                children: p.beforeChoose
            }),
            p.familyPanel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-3",
                children: p.familyPanel
            }),
            shortfall && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-3 text-[13px] text-rose-700",
                "data-testid": "gf-build-short",
                children: [
                    $76543b97b38c81f2$var$money(p.fundingShortfall),
                    " of it still has nowhere to come from: take more from the accounts on the left, or give less."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: canChoose ? p.onChoose : undefined,
                disabled: !canChoose,
                "aria-pressed": p.chosen,
                className: `mt-3 w-full rounded-lg px-4 py-2.5 text-[14px] font-semibold ${p.chosen ? 'border border-emerald-500 bg-white text-emerald-800' : canChoose ? 'bg-blue-600 text-white hover:bg-blue-700' : 'cursor-not-allowed bg-slate-200 text-slate-500'}`,
                "data-testid": "gf-build-choose",
                children: p.chosen ? "Chosen \u2713" : 'Choose this plan'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        "data-testid": "gf-build",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-x-6 gap-y-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: p.onBackToPlans,
                        className: "inline-flex items-center gap-1.5 text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                        "data-testid": "gf-back-to-plans",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                size: 16
                            }),
                            " Back to the plans we tested"
                        ]
                    }),
                    p.onClear && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: p.onClear,
                        className: "text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                        "data-testid": "gf-clear-start-again",
                        children: "Clear and start again"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[13px] text-slate-500",
                        children: [
                            "Granny flat \u203A ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: p.onBackToPlans,
                                className: "underline decoration-dotted underline-offset-2",
                                children: "Ways to set it up"
                            }),
                            " \u203A ",
                            p.customising ? 'Customise this plan' : 'Build a plan yourself'
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "mt-2 text-[28px] font-bold leading-tight tracking-tight text-brand-navy",
                        "data-testid": "gf-build-title",
                        children: p.customising ? 'Customise this plan' : 'Build a plan yourself'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1 text-[15px] leading-relaxed text-slate-600",
                        children: [
                            "What ",
                            v.they,
                            " give ",
                            host,
                            ", what happens to the home, and where the money comes from.",
                            p.startedFrom ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    " ",
                                    p.customising ? 'Customising' : 'Started from',
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            "\u201C",
                                            p.startedFrom,
                                            "\u201D"
                                        ]
                                    }),
                                    "; change anything and the figures follow."
                                ]
                            }) : null
                        ]
                    })
                ]
            }),
            p.startOptions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-2 text-[13px]",
                "data-testid": "gf-start-from",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-slate-500",
                        children: "Start from:"
                    }),
                    p.startOptions.map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            onClick: ()=>p.onStartFrom(o.id),
                            className: `rounded-lg border px-3 py-1.5 font-semibold ${p.startedFrom === o.label ? 'border-blue-600 bg-blue-50 text-brand-navy' : 'border-slate-300 bg-white text-slate-700 hover:border-blue-300'}`,
                            children: [
                                p.startedFrom === o.label ? "\u2713 " : '',
                                o.label
                            ]
                        }, o.id))
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 items-start gap-5 xl:grid-cols-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-5 xl:col-span-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: $76543b97b38c81f2$var$card,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-[13px] font-bold text-brand-navy",
                                        children: [
                                            "1 \xb7 What ",
                                            v.they,
                                            " give for the right"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-2",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($76543b97b38c81f2$var$Choice, {
                                            value: p.form,
                                            onChange: (id)=>p.onForm(id),
                                            testId: "gf-build-form",
                                            options: [
                                                {
                                                    id: 'cash',
                                                    label: 'Cash'
                                                },
                                                {
                                                    id: 'build',
                                                    label: 'Pay for a build'
                                                },
                                                ...hasHome ? [
                                                    {
                                                        id: 'home',
                                                        label: 'Sign the home over'
                                                    }
                                                ] : [],
                                                {
                                                    id: 'nothing',
                                                    label: 'Move in, pay nothing'
                                                }
                                            ]
                                        })
                                    }),
                                    p.form === 'cash' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-3 flex flex-wrap items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                value: p.cash,
                                                onChange: (x)=>p.onCash(Math.max(0, x ?? 0)),
                                                className: "w-40",
                                                ariaLabel: "Cash paid for the right",
                                                testId: "gf-build-cash"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "text-[13px] text-slate-500",
                                                children: [
                                                    "paid to ",
                                                    host,
                                                    ".",
                                                    Math.round(p.cash) !== Math.floor(p.reasonableValue) && p.reasonableValue > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                type: "button",
                                                                onClick: ()=>p.onCash(Math.floor(p.reasonableValue)),
                                                                className: $76543b97b38c81f2$var$link,
                                                                children: [
                                                                    "Use Centrelink's value, ",
                                                                    $76543b97b38c81f2$var$money(p.reasonableValue)
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    p.form === 'build' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-3 space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex flex-wrap items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                        value: p.build,
                                                        onChange: (x)=>p.onBuild(Math.max(0, x ?? 0)),
                                                        className: "w-40",
                                                        ariaLabel: "Cost of the build",
                                                        testId: "gf-build-cost"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-[13px] text-slate-500",
                                                        children: "the cost of the build \u2014 taken at face value"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex flex-wrap items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                        value: p.cash,
                                                        onChange: (x)=>p.onCash(Math.max(0, x ?? 0)),
                                                        className: "w-40",
                                                        ariaLabel: "Cash on top of the build"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-[13px] text-slate-500",
                                                        children: "cash on top, if any \u2014 tested"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    p.form === 'home' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-3 space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-[14px] text-slate-700",
                                                children: [
                                                    "The ",
                                                    $76543b97b38c81f2$var$money(homeValue),
                                                    " home is signed over to ",
                                                    host,
                                                    ". Taken at face value: no gift on the home, whatever it is worth."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex flex-wrap items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                        value: p.cash,
                                                        onChange: (x)=>p.onCash(Math.max(0, x ?? 0)),
                                                        className: "w-40",
                                                        ariaLabel: "Cash on top of the home"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-[13px] text-slate-500",
                                                        children: "cash on top, if any \u2014 tested"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    p.form === 'nothing' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-3 text-[14px] text-slate-700",
                                        children: [
                                            "No right is paid for, so nothing is a gift",
                                            hasHome ? `; the home ${v.they} leave is counted from the day ${v.they} move` : '',
                                            "."
                                        ]
                                    }),
                                    p.form !== 'nothing' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-3",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dcb65f51c88a7220$export$2e2bcd8739ae039), {
                                            entryContribution: p.entryContribution,
                                            interestValue: p.interestValue,
                                            reasonableValue: p.reasonableValue,
                                            deprivation: p.deprivation,
                                            keepingHome: hasHome && p.form !== 'home' && p.homeUse !== 'sold',
                                            formerHomeValue: homeValue
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-2 text-[12.5px] text-slate-500",
                                        "data-testid": "gf-build-homeowner-line",
                                        children: [
                                            "Give more than ",
                                            $76543b97b38c81f2$var$money((0, $1abe73eeef086faf$export$e2cf792e99a08354)),
                                            " in all and ",
                                            v.they,
                                            " stay homeowners for the Age Pension, with the right not counted; give that or less and ",
                                            v.they,
                                            " are not homeowners, and the right counts as an asset."
                                        ]
                                    }),
                                    hasHome && p.form !== 'home' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-6 text-[13px] font-bold text-brand-navy",
                                                children: "2 \xb7 The home"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "mt-2",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($76543b97b38c81f2$var$Choice, {
                                                    value: p.homeUse,
                                                    onChange: (id)=>p.onHomeUse(id),
                                                    testId: "gf-build-home",
                                                    options: [
                                                        {
                                                            id: 'vacant',
                                                            label: 'Kept, empty'
                                                        },
                                                        {
                                                            id: 'rented',
                                                            label: 'Kept and rented out'
                                                        },
                                                        {
                                                            id: 'sold',
                                                            label: 'Sold',
                                                            disabled: !canSell
                                                        }
                                                    ]
                                                })
                                            }),
                                            !canSell && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-1 text-[12.5px] text-slate-500",
                                                children: "Selling pays for the right, so it is offered once something is paid."
                                            }),
                                            p.homeUse === 'rented' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mt-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex flex-wrap items-center gap-2 text-[13px] text-slate-600",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                                value: p.rent.weekly,
                                                                onChange: (x)=>p.onRent({
                                                                        weekly: Math.max(0, x ?? 0)
                                                                    }),
                                                                className: "w-28",
                                                                ariaLabel: "Rent a week"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "a week, less"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                                value: p.rent.costs,
                                                                onChange: (x)=>p.onRent({
                                                                        costs: Math.max(0, x ?? 0)
                                                                    }),
                                                                className: "w-28",
                                                                ariaLabel: "Yearly costs of the rented home"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "a year of costs, empty"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "number",
                                                                min: 0,
                                                                max: 52,
                                                                value: p.rent.vacancy,
                                                                onChange: (e)=>p.onRent({
                                                                        vacancy: Math.max(0, Math.min(52, parseFloat(e.target.value) || 0))
                                                                    }),
                                                                className: "w-16 rounded-lg border border-slate-300 px-2 py-1",
                                                                "aria-label": "Weeks a year empty",
                                                                "data-testid": "gf-build-vacancy"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                children: [
                                                                    "weeks a year",
                                                                    p.rent.vacancy === (0, $576b15178c677e44$export$4a9fb6bdf3fe5eb2) ? ', suggested' : ''
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "mt-2 text-[13px] text-slate-700",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "Check the costs:"
                                                            }),
                                                            " rates, insurance, repairs, the agent's fee and ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "land tax"
                                                            }),
                                                            ", which can apply once it is no longer where ",
                                                            v.they,
                                                            " live."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "mt-2",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f5ab3af26c11dd09$export$5d3c9135c9ed8866), {
                                                            homeValue: homeValue
                                                        })
                                                    })
                                                ]
                                            }),
                                            p.homeUse === 'vacant' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-2 text-[13px] text-slate-700",
                                                children: [
                                                    "Kept as it is: it earns nothing, and counts for the Age Pension from the day ",
                                                    v.they,
                                                    " move."
                                                ]
                                            }),
                                            selling && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mt-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-[14px] text-slate-700",
                                                        children: [
                                                            "The sale pays the ",
                                                            $76543b97b38c81f2$var$money(p.cash + p.build),
                                                            ", after selling costs. Where the ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: $76543b97b38c81f2$var$money(p.saleResidual)
                                                            }),
                                                            " left goes \u2014 anything not placed stays in the bank:"
                                                        ]
                                                    }),
                                                    p.saleResidual > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "mt-2",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80740ae64106afa1$export$2e2bcd8739ae039), {
                                                            factFind: factFind,
                                                            setFactFind: p.setFactFind,
                                                            available: p.saleResidual,
                                                            value: p.deployment,
                                                            onChange: (d)=>p.onDeployment(d),
                                                            idPrefix: "gf"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    p.cashFromSavings > 0 && !selling && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-6 text-[13px] font-bold text-brand-navy",
                                                children: [
                                                    hasHome && p.form !== 'home' ? '3' : '2',
                                                    " \xb7 Where the ",
                                                    $76543b97b38c81f2$var$money(p.cashFromSavings),
                                                    " comes from"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "mt-2",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc43d1ee81f3ee79$export$2e2bcd8739ae039), {
                                                    factFind: factFind,
                                                    target: p.cashFromSavings,
                                                    funding: p.funding,
                                                    onChange: p.onFunding,
                                                    cgtOverrides: p.cgtOverrides,
                                                    onCgtOverridesChange: p.onCgtOverrides,
                                                    targetLabel: p.build > 0 ? 'Cash and the build to fund' : `Cash to pay ${host}`,
                                                    help: "How much to take from each account. The account-based pension is suggested before shares: drawing it costs no tax, where selling shares can mean capital gains tax. Change any of them."
                                                })
                                            }),
                                            p.fundingSuggested && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-2 text-[12.5px] text-slate-500",
                                                "data-testid": "gf-build-suggested-draw",
                                                children: [
                                                    "Until ",
                                                    v.you ? 'you choose' : `${v.they} choose`,
                                                    ", the figures use our suggested order: the bank first",
                                                    $76543b97b38c81f2$var$num(p.reserve) > 0 ? `, keeping the ${$76543b97b38c81f2$var$money($76543b97b38c81f2$var$num(p.reserve))} for emergencies` : '',
                                                    ", then term deposits, the account-based pension and shares. This is a starting point, not a recommendation."
                                                ]
                                            })
                                        ]
                                    }),
                                    p.debtCard
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-[13px] font-bold text-brand-navy",
                                        children: "How each piece works"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-2 grid grid-cols-1 gap-4 md:grid-cols-2",
                                        "data-testid": "gf-build-explainers",
                                        children: explainers.map((e)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($76543b97b38c81f2$var$HowItWorks, {
                                                e: e
                                            }, e.id))
                                    })
                                ]
                            })
                        ]
                    }),
                    effectPanel
                ]
            })
        ]
    });
};
var $76543b97b38c81f2$export$2e2bcd8739ae039 = $76543b97b38c81f2$var$GfBuildPlan;


/**
 * The family discussion guide — "Talking it through as a family" (reworked 2 Oct 2026; rebuilt to the agreed
 * mock-up's j2 guide, 21 Oct 2026).
 *
 * A set of questions the family answers together — the arrangement, fairness to the rest of the family, the
 * "what-ifs" — with progress by section, and a brief at the end they can print and hand to a solicitor
 * (gfSolicitorBrief.ts). "Still to decide" is a real answer everywhere: the brief lists those as questions for
 * the solicitor instead of pretending they are settled.
 *
 * THE PLAN THIS BRIEF IS ABOUT (review, 18 Oct 2026: "the family guide has no figures after an engine
 * choice"). The chosen plan's own figures — its title, Centrelink's value of the right, the gift, homeowner
 * status, the start — from the plan on record, so the guide and the brief agree with the plan page.
 *
 * WHERE THE ANSWERS LIVE. On the client file (`grannyFlat.familyGuide`, strong-typed in factFindSchema.ts),
 * so the family can come back to it and the brief can be printed again. Text is committed on blur.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1cbb901abf788f33$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
            key: "143wyd"
        }
    ],
    [
        "path",
        {
            d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6",
            key: "1itne7"
        }
    ],
    [
        "rect",
        {
            x: "6",
            y: "14",
            width: "12",
            height: "8",
            rx: "1",
            key: "1ue0tg"
        }
    ]
];
const $1cbb901abf788f33$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("printer", $1cbb901abf788f33$export$3efd853dbb351e94);







function $ec71447dcc27993d$export$be92f20da694dad2(arrangement) {
    if (!arrangement) return null;
    const cash = Number(arrangement.cash) > 0;
    const build = Number(arrangement.build) > 0;
    const home = Number(arrangement.homeSignedOver) > 0;
    if (cash && (build || home)) return 'mixed';
    if (cash) return 'cash';
    if (home) return 'transfer_home';
    if (build) return 'build';
    return null;
}
/** One question's answers as radio rows — the mock-up's quieter voice. */ function $ec71447dcc27993d$var$GuidePick({ options: options, value: value, onChange: onChange, name: name }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "space-y-0.5",
        role: "radiogroup",
        "aria-label": name,
        children: options.map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: "flex cursor-pointer items-start gap-2.5 py-1 text-[14.5px] text-slate-700",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "radio",
                        name: name,
                        checked: value === o.id,
                        onChange: ()=>onChange(o.id),
                        className: "mt-1 h-4 w-4 accent-blue-600"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: o.label
                    })
                ]
            }, o.id))
    });
}
const $ec71447dcc27993d$var$asOptions = (labels, short)=>Object.keys(labels).map((id)=>({
            id: id,
            label: short?.[id] ?? labels[id]
        }));
const $ec71447dcc27993d$var$Section = ({ title: title, progress: progress, children: children, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "shrink-0 text-[13px] font-semibold text-brand-navy",
                        children: [
                            title,
                            progress ? ` \xb7 ${progress.answered} of ${progress.total} answered` : ''
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "h-px flex-1 bg-slate-200",
                        "aria-hidden": true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-3 space-y-5",
                children: children
            })
        ]
    });
const $ec71447dcc27993d$var$Q = ({ title: title, hint: hint, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-b border-slate-100 pb-4 last:border-b-0",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[15px] font-semibold text-slate-900",
                children: title
            }),
            hint && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-0.5 text-[13px] text-slate-500",
                children: hint
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-2",
                children: children
            })
        ]
    });
const $ec71447dcc27993d$var$GfFamilyGuide = ({ factFind: factFind, setFactFind: setFactFind, figures: figures = null, onBack: onBack, backLabel: backLabel = 'Back', onToPlans: onToPlans, onHome: onHome, planForm: planForm = null })=>{
    const saved = factFind?.grannyFlat?.familyGuide || {};
    // The chosen plan's answer to "what is given", where the family has not given one.
    const [formFromPlan] = (0, $acw62.useState)(()=>!saved.arrangementForm && planForm ? planForm : null);
    const [answers, setAnswers] = (0, $acw62.useState)(()=>formFromPlan ? {
            ...saved,
            arrangementForm: formFromPlan
        } : saved);
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const clientName = factFind?.client?.firstName || 'you';
    const partnerName = factFind?.adviceFor === 'couple' ? factFind?.partner?.firstName || null : null;
    const kids = (0, $32bd8c8afa665e9e$export$4411cd57c45e8c9e)(factFind);
    const hostKind = (0, $32bd8c8afa665e9e$export$2b2184b5390b1cd2)(factFind);
    const host = (0, $32bd8c8afa665e9e$export$d71f476d519c5ae3)(factFind);
    const progress = (0, $82f6c9c0d5566ac3$export$db547e884904c14a)(answers);
    const input = 'w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-[14px] focus:border-blue-500 focus:ring-blue-500';
    /** Saves one answer locally and to the file; text fields call this on blur. */ const commit = (key, value)=>{
        const next = {
            ...answers,
            [key]: value
        };
        setAnswers(next);
        if (setFactFind) setFactFind((prev)=>({
                ...prev,
                grannyFlat: {
                    ...prev.grannyFlat || {},
                    familyGuide: next
                }
            }));
    };
    // Kept on the file, so the brief and the count read it too.
    (0, $acw62.useEffect)(()=>{
        if (formFromPlan && setFactFind) setFactFind((prev)=>({
                ...prev,
                grannyFlat: {
                    ...prev.grannyFlat || {},
                    familyGuide: {
                        ...prev.grannyFlat?.familyGuide || {},
                        arrangementForm: prev.grannyFlat?.familyGuide?.arrangementForm || formFromPlan
                    }
                }
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const open = (0, $82f6c9c0d5566ac3$export$b3e7fddc7911492a)(answers);
    /** Opens and downloads the brief, and keeps a copy with the file: the answers plus the figures it quoted (owner, 3 Oct 2026). */ const printBrief = ()=>{
        const generatedAt = new Date().toISOString();
        (0, $82f6c9c0d5566ac3$export$92b81748c7df1848)({
            clientName: clientName,
            partnerName: partnerName,
            answers: answers,
            figures: figures,
            generatedAt: generatedAt
        });
        const brief = figures ? {
            generatedAt: generatedAt,
            entryContribution: figures.entryContribution,
            interestValue: figures.interestValue,
            deprivation: figures.deprivation,
            isHomeowner: figures.isHomeowner,
            dateEntered: figures.dateEntered,
            ...figures.planTitle ? {
                planTitle: figures.planTitle
            } : {}
        } : {
            generatedAt: generatedAt
        };
        const next = {
            ...answers,
            brief: brief
        };
        setAnswers(next);
        if (setFactFind) setFactFind((prev)=>({
                ...prev,
                grannyFlat: {
                    ...prev.grannyFlat || {},
                    familyGuide: next
                }
            }));
    };
    const whatIfOptions = (key)=>{
        const def = (0, $82f6c9c0d5566ac3$export$43bfd2f329881f11)[key];
        return Object.keys(def).filter((k)=>k !== 'question').map((id)=>({
                id: id,
                label: def[id]
            }));
    };
    const fairnessTitle = hostKind === 'child' && kids >= 2 ? `How will ${v.their} other ${kids === 2 ? 'child' : 'children'} be treated?` : 'How will the rest of the family be kept whole?';
    const hostHint = hostKind === 'child' ? `Step 1 says ${kids >= 2 ? `one of ${v.their} ${kids} children` : `${v.their} child`}. The brief can name them, and say where \u{2014} a studio at the back, the downstairs rooms.` : hostKind ? `Step 1 says ${host}. The brief can name them.` : 'First names and relationship, as the family says them.';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mx-auto max-w-[1100px] space-y-6",
        "data-testid": "gf-family-guide",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[13px] text-slate-500",
                        children: [
                            onHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: onHome,
                                        className: "underline decoration-dotted underline-offset-2 hover:text-slate-800",
                                        children: "Home"
                                    }),
                                    " \u203A "
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onBack,
                                className: "underline decoration-dotted underline-offset-2 hover:text-slate-800",
                                children: "Granny flat"
                            }),
                            " \u203A Family discussion guide"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "mt-2 text-[32px] font-bold leading-tight tracking-tight text-brand-navy",
                        children: "Talking it through as a family"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-1 text-[15px] leading-relaxed text-slate-600",
                        children: "Each answer goes into a brief for the solicitor; anything undecided is listed as a question for them. This is general information to help the conversation, not legal advice."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-7 rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec71447dcc27993d$var$Section, {
                        title: "The plan this brief is about",
                        testId: "gf-guide-plan",
                        children: figures == null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-[14px] text-slate-600",
                            children: [
                                "No plan is chosen yet. Once one is, its figures appear here and in the brief: what is being given, Centrelink's value of the right, anything counted as a gift, and homeowner status.",
                                onToPlans && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: onToPlans,
                                            className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                            children: "See the ways to set it up"
                                        }),
                                        "."
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                            className: "w-full text-[14.5px] tabular-nums",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                children: [
                                    figures.planTitle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "border-b border-slate-100",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-2 text-slate-700",
                                                children: "Chosen plan"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-2 text-right font-semibold text-slate-900",
                                                children: figures.planTitle
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "border-b border-slate-100",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-2 text-slate-700",
                                                children: "Given for the right"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-2 text-right",
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(figures.entryContribution))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "border-b border-slate-100",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-2 text-slate-700",
                                                children: "Centrelink's value of the right"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-2 text-right",
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(figures.interestValue))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "border-b border-slate-100",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                className: "py-2 text-slate-700",
                                                children: [
                                                    "Counted as a gift ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-[12px] text-slate-500",
                                                        children: [
                                                            "(after the ",
                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0)),
                                                            " that can be given freely)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-2 text-right",
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(Math.max(0, figures.deprivation - (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "border-b border-slate-100",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-2 text-slate-700",
                                                children: "Homeowner for the Age Pension"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-2 text-right",
                                                children: figures.isHomeowner ? `Yes \u{2014} more than ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$e2cf792e99a08354))} given; the right is not counted` : `No \u{2014} the right counts as an asset`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-2 text-slate-700",
                                                children: "Start"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-2 text-right",
                                                children: figures.dateEntered || 'As soon as it is in place'
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ec71447dcc27993d$var$Section, {
                        title: "The arrangement",
                        progress: progress.sections.arrangement,
                        testId: "gf-guide-arrangement",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec71447dcc27993d$var$Q, {
                                title: `Who would ${v.names} live with?`,
                                hint: hostHint,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "gf-guide-host",
                                    type: "text",
                                    className: input,
                                    defaultValue: answers.hostNames || '',
                                    placeholder: "e.g. Sam and Priya, our daughter and son-in-law, in the studio at the back",
                                    onBlur: (e)=>commit('hostNames', e.target.value.trim()),
                                    "aria-label": "Who they would live with"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec71447dcc27993d$var$Q, {
                                title: "What would be given for the right to live there?",
                                hint: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        "The home, a build or a bought property, on its own, is taken at face value \u2014 no gift. Cash, or anything on top, is tested against Centrelink\u2019s value.",
                                        formFromPlan ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            "data-testid": "gf-guide-form-from-plan",
                                            children: " Filled in from the chosen plan; change it if the family has something else in mind."
                                        }) : null
                                    ]
                                }),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec71447dcc27993d$var$GuidePick, {
                                    name: "What would be given",
                                    value: answers.arrangementForm,
                                    onChange: (x)=>commit('arrangementForm', x),
                                    options: $ec71447dcc27993d$var$asOptions((0, $82f6c9c0d5566ac3$export$808b1469e403446d), {
                                        cash: 'Cash',
                                        build: 'Paying for a build or extension',
                                        transfer_home: 'The home, signed over',
                                        buy_in_their_name: 'A home bought in their name',
                                        mixed: 'A mix, with cash on top',
                                        undecided: 'Still to decide'
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec71447dcc27993d$var$Q, {
                                title: "What does the right cover?",
                                hint: "Rooms, shared areas, parking, garden, visitors.",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                    id: "gf-guide-includes",
                                    rows: 3,
                                    className: input,
                                    defaultValue: answers.includes || '',
                                    placeholder: "e.g. The downstairs bedroom and bathroom, the kitchen and living room shared, one car space",
                                    onBlur: (e)=>commit('includes', e.target.value.trim()),
                                    "aria-label": "What the right covers"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec71447dcc27993d$var$Q, {
                                title: "Who pays the household bills and upkeep?",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec71447dcc27993d$var$GuidePick, {
                                    name: "Who pays the bills",
                                    value: answers.billsPaidBy,
                                    onChange: (x)=>commit('billsPaidBy', x),
                                    options: $ec71447dcc27993d$var$asOptions((0, $82f6c9c0d5566ac3$export$186c9d965b8fe09), {
                                        me: `${v.Names} pay${v.s} an agreed share`,
                                        family: 'The family covers them',
                                        shared: "Shared \u2014 still to write down",
                                        undecided: 'Still to decide'
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec71447dcc27993d$var$Q, {
                                title: "Will someone be providing daily care?",
                                hint: "Carer Payment or Carer Allowance are separate from the granny flat rules \u2014 worth checking with Services Australia, and worth writing into the agreement.",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec71447dcc27993d$var$GuidePick, {
                                    name: "Care from the family",
                                    value: answers.careProvided,
                                    onChange: (x)=>commit('careProvided', x),
                                    options: $ec71447dcc27993d$var$asOptions((0, $82f6c9c0d5566ac3$export$9dfc2fad813fc18), {
                                        yes: "Yes \u2014 daily care",
                                        no: "No \u2014 company and support",
                                        unsure: 'Not sure yet'
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec71447dcc27993d$var$Section, {
                        title: "Fairness to the rest of the family",
                        progress: progress.sections.fairness,
                        testId: "gf-guide-fairness",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec71447dcc27993d$var$Q, {
                            title: fairnessTitle,
                            hint: "One person receives a large amount now. If the rest of the estate is then split equally, the others can be left behind \u2014 a common cause of Will disputes.",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec71447dcc27993d$var$GuidePick, {
                                name: "Fairness to the rest of the family",
                                value: answers.fairness,
                                onChange: (x)=>commit('fairness', x),
                                options: $ec71447dcc27993d$var$asOptions((0, $82f6c9c0d5566ac3$export$aa60e76ea289eada), {
                                    will: 'An equal amount in the Will',
                                    advance: "An advance on that person\u2019s inheritance",
                                    insurance: 'Life insurance tops up the others',
                                    care_exchange: 'A fair exchange for the care provided',
                                    not_needed: "Not needed \u2014 agreed as fair",
                                    undecided: 'Still to decide'
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ec71447dcc27993d$var$Section, {
                        title: "What happens if things change",
                        progress: progress.sections.whatIfs,
                        testId: "gf-guide-what-ifs",
                        children: [
                            [
                                'ifHostSells',
                                'ifNeedCare',
                                'ifRelationshipEnds',
                                'ifHostDies'
                            ].map((key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec71447dcc27993d$var$Q, {
                                    title: (0, $82f6c9c0d5566ac3$export$43bfd2f329881f11)[key].question,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec71447dcc27993d$var$GuidePick, {
                                        name: (0, $82f6c9c0d5566ac3$export$43bfd2f329881f11)[key].question,
                                        value: answers[key],
                                        onChange: (x)=>commit(key, x),
                                        options: whatIfOptions(key)
                                    })
                                }, key)),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[13px] text-slate-500",
                                children: "Leaving within five years can also mean Centrelink looks at the payment again."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec71447dcc27993d$var$Section, {
                        title: "Anything else the solicitor should know",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                            id: "gf-guide-notes",
                            rows: 3,
                            className: input,
                            defaultValue: answers.notes || '',
                            placeholder: "Anything agreed between you that is not covered above",
                            onBlur: (e)=>commit('notes', e.target.value.trim()),
                            "aria-label": "Anything else the solicitor should know"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[14px] text-slate-700",
                        "data-testid": "gf-guide-open",
                        children: open.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    className: "text-slate-900",
                                    children: "Every question has an answer."
                                }),
                                " The brief sets them out for the solicitor to turn into the agreement."
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                    className: "text-slate-900",
                                    children: [
                                        open.length,
                                        " ",
                                        open.length === 1 ? 'question is' : 'questions are',
                                        " still to decide."
                                    ]
                                }),
                                " That's fine \u2014 the brief lists ",
                                open.length === 1 ? 'it' : 'them',
                                " as ",
                                open.length === 1 ? 'a question' : 'questions',
                                " for the solicitor."
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] text-slate-500",
                children: [
                    "Take the brief to a ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "solicitor"
                    }),
                    " to prepare the granny flat agreement and update the Will, and to ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "Services Australia's Financial Information Service"
                    }),
                    " for the pension side."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onBack,
                        className: "inline-flex items-center gap-1 text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                        "data-testid": "gf-guide-back",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                size: 15
                            }),
                            " ",
                            backLabel
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: printBrief,
                        className: "inline-flex h-11 items-center gap-2 rounded-lg bg-blue-600 hover:bg-blue-700 px-5 text-[14px] font-semibold text-white shadow-sm ",
                        "data-testid": "gf-print-brief",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cbb901abf788f33$export$2e2bcd8739ae039), {
                                size: 16
                            }),
                            " Print the solicitor brief"
                        ]
                    })
                ]
            })
        ]
    });
};
var $ec71447dcc27993d$export$2e2bcd8739ae039 = $ec71447dcc27993d$var$GfFamilyGuide;



/**
 * The chosen granny flat plan, as the plan page, the family guide and Home read it (granny flat rebuild,
 * 21 Oct 2026 — the village's rvChosenPlan.ts, the Support at home sahChosenPlan.ts).
 *
 * ONE GRANNY FLAT PLAN ON RECORD. Choosing another plan replaces the earlier one that carries a card; older
 * records saved before the rebuild (no card) are left as they are.
 *
 * The card the family chose is stored on the record — its figures, not entering's at the time, the plan in
 * words, the arrangement (what was given, to whom, what counts as a gift, homeowner status, the home) — so
 * the plan page, the family guide's brief and Home show exactly what was chosen, with no re-run between.
 */ 

function $fa9cadf0a1243d03$export$4c657fe15c8489ed(prev, record) {
    const others = (prev || []).filter((p)=>!(p.type === 'granny_flat' && p.inputs?.card));
    return (0, $7445cb9532643693$export$bda89f6290a6f044)(others, record);
}
function $fa9cadf0a1243d03$export$2eb90fb4fe01ab98(list) {
    const hit = (list || []).find((s)=>s?.type === 'granny_flat' && s.chosen === true && s.inputs?.card);
    return hit ?? null;
}
function $fa9cadf0a1243d03$export$87a1da0d4877e2d0(plan) {
    const card = plan?.inputs?.card;
    if (!card || !(card.arrangement.given > 0)) return null;
    return {
        entryContribution: card.arrangement.given,
        interestValue: card.arrangement.interestValue,
        deprivation: card.arrangement.gift,
        isHomeowner: card.arrangement.isHomeowner,
        dateEntered: card.arrangement.dateEntered,
        planTitle: card.words.title
    };
}
function $fa9cadf0a1243d03$export$299c54074564e6d3(gi, factFind, rows, compare, horizonYears) {
    if (!gi) return null;
    const built = (0, $66827b1304244a1d$export$11aaa304d9182b)({
        factFind: factFind,
        personName: gi.personName,
        amount: gi.amount,
        kind: gi.kind,
        incomeAYear: gi.incomeAYear,
        rows: rows,
        compareRows: compare?.rows ?? null,
        compareNote: compare?.note ?? null,
        horizonYears: horizonYears,
        plan: {
            estate: 0,
            pension: 0,
            cashflow: 0
        }
    });
    return built ? {
        personName: gi.personName,
        amount: gi.amount,
        kind: gi.kind,
        incomeAYear: gi.incomeAYear,
        compareNote: built.compareNote,
        rows: built.rows
    } : null;
}
const $fa9cadf0a1243d03$export$edd6500f2ae69e6b = 'careCompanionGfStartFresh';







/**
 * The investment property line is shown only to a client who has one on file (owner, 2 Oct 2026:
 * no need to confuse the others). The face-value forms name the title of the HOME; an investment
 * property signed over is assets given, and tested.
 */ const $f34df9d62ff01218$var$gfExplainSections = (hasInvestmentProperty)=>[
        {
            id: 'what',
            icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
            title: 'What a granny flat arrangement is',
            summary: "You give money or assets to family in exchange for a lifetime right to live in their home. It is a Centrelink concept \u2014 not necessarily a separate flat.",
            details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-gray-700 leading-relaxed",
                children: 'A "granny flat interest" (or right) is a formal arrangement where you transfer money and/or assets \u2014 sometimes your own home \u2014 to a family member, in return for the right to live in their home for life. You don\'t have to build an actual granny flat. It can be very tax- and pension-effective, but it needs to be set up carefully.'
            }),
            applies: null
        },
        {
            id: 'homeowner',
            icon: (0, $33b542e8915cec79$export$2e2bcd8739ae039),
            title: "Test 1 \u2014 Will Centrelink treat you as a homeowner?",
            summary: `Two separate tests apply, and this is the first. It asks one thing: how much you give in total. Above the extra allowable amount ($${(0, $1abe73eeef086faf$export$e2cf792e99a08354).toLocaleString()}), you're a homeowner and the right to live there is exempt from the assets test, like a home. At or below it, you're a non-homeowner.`,
            details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-gray-700 leading-relaxed space-y-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            "This test only decides ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "which Age Pension limits apply to you"
                            }),
                            ". Add up everything you give \u2014 cash, the cost of any build you pay for, and any home you transfer. If the total is ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "above"
                            }),
                            " the extra allowable amount (currently $",
                            (0, $1abe73eeef086faf$export$e2cf792e99a08354).toLocaleString(),
                            "), Centrelink treats you as a ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "homeowner"
                            }),
                            ": your right to live there is exempt from the assets test, just as a home would be, and the lower homeowner asset limits apply. If the total is ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "at or below"
                            }),
                            " it, you're a ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "non-homeowner"
                            }),
                            ": the right counts as an asset, the higher non-homeowner limits apply, and you may qualify for Rent Assistance."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            "Because you're turning counted savings into an exempt right, your Age Pension often ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "goes up"
                            }),
                            '. But "exempt" is about the right you receive. It says nothing about whether you paid too much for it \u2014 that\'s the second test, below.'
                        ]
                    })
                ]
            }),
            applies: null
        },
        {
            id: 'reasonable',
            icon: (0, $0811c1891b547863$export$2e2bcd8739ae039),
            title: "Test 2 \u2014 Did you pay more than the right is worth? (the gift test)",
            summary: "The second test asks a different question: did you give more than Centrelink says the right is worth? It depends on what you give. Sign over your home, or pay to build the accommodation, and Centrelink takes that at face value \u2014 no gift, whatever it costs. Pay cash and there is a limit: up to Centrelink's reasonable value nothing is a gift; above it, the excess is counted against you for five years.",
            details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-gray-700 leading-relaxed space-y-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Three ways of paying are taken at face value."
                            }),
                            " If all you do is sign over the title of your home, pay for the building or extension of your accommodation, or buy a home in the family member's name, Centrelink accepts what that is worth as the price of the right. There is no gift, however large the amount \u2014 a $600,000 build is a $600,000 right. Keep the building contract and invoices: anything paid beyond the actual cost of the build counts as extra."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Cash is tested."
                            }),
                            " Pay cash, or add cash or other assets on top of one of the three above, and Centrelink works out a ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "reasonable value"
                            }),
                            " for your lifetime right: the combined partnered pension rate multiplied by a factor for your age. The right is valued at the greater of that formula and what you provided (the home, the build). Whatever you give ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "up to that value"
                            }),
                            " is the price of the right \u2014 no gift. The excess is treated as a gift: after the usual free area ($10,000 a year, $30,000 over five years) it is counted in your assets and deemed in your income for ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "five years"
                            }),
                            ", then drops off."
                        ]
                    }),
                    hasInvestmentProperty && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Your investment property is not your home."
                            }),
                            " The face-value rule is for the title of the home you live in. Sign an investment property over to family for the right and Centrelink treats it as assets given, like cash: the right is valued at the formula, and the property's value above that is a gift. Confirm this with Services Australia's Financial Information Service before relying on it."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "How the two tests fit together."
                            }),
                            " Test 1 makes the right itself exempt. Test 2 catches any overpayment and counts it anyway. So you can be a homeowner with an exempt right ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                children: "and"
                            }),
                            " still have a gift counted against you, if you paid too much in cash. The plans that pay Centrelink's value sit exactly at its figure, so nothing is a gift."
                        ]
                    })
                ]
            }),
            applies: null
        },
        {
            id: 'documentation',
            icon: (0, $e325251f2797f6cf$export$2e2bcd8739ae039),
            title: "Protect yourself \u2014 get it in writing",
            summary: 'An undocumented arrangement is risky: if things go wrong with the family member, you can lose both the money and the home.',
            details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-gray-700 leading-relaxed",
                children: [
                    "Always use a ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "written agreement"
                    }),
                    ". If the family member divorces, dies, goes bankrupt, sells, or you fall out, an undocumented arrangement can leave you with no home and no money back. A written agreement makes your right enforceable and is what Centrelink expects. Get independent legal advice before transferring anything."
                ]
            }),
            applies: null
        },
        {
            id: 'estate',
            icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
            title: 'Fairness to other family',
            summary: "Giving a large amount to one family member can leave others with much less \u2014 a common cause of will disputes. Plan for fairness.",
            details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-gray-700 leading-relaxed",
                children: [
                    "A granny-flat arrangement gives one family member a large slice of your wealth. If the rest of your estate is then split equally, the others can be left behind \u2014 a classic trigger for ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "will disputes"
                    }),
                    ". Consider how to keep things fair (for example, adjusting your will) and talk to an estate-planning solicitor."
                ]
            }),
            applies: null
        }
    ];
/** How granny flat arrangements work — the full guide, a link from step 1 (the village's ruling: the steps first). */ const $f34df9d62ff01218$var$GrannyFlatExplained = ({ onBack: onBack, onFamilyGuide: onFamilyGuide, factFind: factFind })=>{
    const [openAccordion, setOpenAccordion] = (0, $acw62.useState)(null);
    const toggle = (id)=>setOpenAccordion(openAccordion === id ? null : id);
    const hasInvestmentProperty = (factFind?.assets?.investmentProperty || []).some((p)=>(parseFloat(String(p?.value ?? '')) || 0) > 0);
    const sections = $f34df9d62ff01218$var$gfExplainSections(hasInvestmentProperty);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-6xl mx-auto",
        "data-testid": "gf-overview",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                variant: "ghost",
                size: "sm",
                icon: (0, $c31db635520dc385$export$2e2bcd8739ae039),
                onClick: onBack,
                className: "mb-4 -ml-2",
                children: "Back to the granny flat"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-4 mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                icon: (0, $d5c3c2c5a9eb8655$export$388c0e4f7230aadf).granny_flat,
                                tone: "brand",
                                variant: "solid",
                                size: "lg",
                                className: "hidden sm:inline-flex"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-4xl md:text-5xl font-bold text-gray-900",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6288781efbc92679$export$2e2bcd8739ae039), {
                                    children: "Granny flat arrangements"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-lg text-slate-700 leading-relaxed mb-3",
                        children: "Moving in with family and giving them money or your home for the right to live there? A granny flat arrangement can be very pension- and tax-effective, but it must be set up carefully. This is how it works."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-slate-500",
                        children: "This is general information. A granny flat arrangement is a significant legal and family decision \u2014 get independent legal, financial and estate-planning advice before you commit."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "space-y-4 mb-8",
                children: sections.map((fee)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b5fe5727b69e005$export$2e2bcd8739ae039), {
                        ...fee,
                        isOpen: openAccordion === fee.id,
                        onToggle: ()=>toggle(fee.id),
                        factFind: {}
                    }, fee.id))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                className: "mb-8",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col sm:flex-row sm:items-center gap-3 sm:justify-between",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-start gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                    icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
                                    tone: "brand",
                                    variant: "soft",
                                    size: "sm",
                                    className: "hidden sm:inline-flex"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: "text-xl font-bold text-gray-800",
                                            children: "Talk it through as a family first"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-600",
                                            children: 'Questions to settle together before any money changes hands \u2014 what the right covers, who pays what, fairness to other family, and the "what-ifs" \u2014 with a brief you can print and hand to a solicitor.'
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                            variant: "secondary",
                            size: "sm",
                            iconRight: (0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039),
                            className: "shrink-0",
                            onClick: onFamilyGuide,
                            children: "Open the guide"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                    onClick: onBack,
                    variant: "brand",
                    size: "lg",
                    iconRight: (0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039),
                    children: "Back to the granny flat"
                })
            })
        ]
    });
};
/** The age-and-health warning for a candidate's annuity — the aged care rule, applied here. */ function $f34df9d62ff01218$var$gfAnnuityHorizonWarningOf(strategy, factFind) {
    const terms = (0, $80740ae64106afa1$export$14a5903af8acddef)(strategy.inputs?.deployment, factFind?.adviceFor === 'couple');
    if (!terms) return null;
    const flag = (0, $3d096644ffaac9d7$export$2a10947020c112ea)({
        factFind: factFind,
        residualCapital: (Number(terms.residualPercent) || 0) / 100,
        owner: terms.owner
    });
    return flag?.warning ?? null;
}
const $f34df9d62ff01218$var$num = (v)=>parseFloat(String(v ?? '')) || 0;
/** Step 1's and step 3's answers: what a new model from scratch takes off the file so nothing carries over. */ const $f34df9d62ff01218$var$GF_FRESH_GOAL_KEYS = [
    'gfHost',
    'gfGive',
    'gfKnownAmount',
    'gfKnownExtraCash',
    'gfHomeRoute',
    'gfStartDate',
    'gfRentPerWeek',
    'gfRentCosts',
    'gfVacancyWeeks',
    'gfLegacyYears',
    'gfEmergencyReserve'
];
const $f34df9d62ff01218$var$GrannyFlatAnalyser = ({ setActivePage: setActivePage, factFind: factFind, savedStrategies: savedStrategies, setSavedStrategies: setSavedStrategies, setFactFind: setFactFind, onSoaGenerated: onSoaGenerated, opening: opening = null })=>{
    const hasHome = $f34df9d62ff01218$var$num(factFind?.home?.value) > 0;
    const homeValue = $f34df9d62ff01218$var$num(factFind?.home?.value);
    const todayIso = new Date().toISOString().slice(0, 10);
    const isCouple = factFind?.adviceFor === 'couple';
    /** "you" to the client, the household's names to an adviser (owner, 21 Oct 2026). */ const voice = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const goals = factFind?.goals || {};
    /*
   * HOW THE MODULE OPENS (granny flat rebuild, 21 Oct 2026 — the village's rule). With a plan chosen, on the
   * plan page. From Home's "Start a new model", on an empty step 1 with step 3's questions asked again. Home's
   * "Open the guide" and the action plan's links open the family guide; "overview" the full guide.
   */ const [openedFresh] = (0, $acw62.useState)(()=>{
        try {
            return !!sessionStorage.getItem((0, $fa9cadf0a1243d03$export$edd6500f2ae69e6b));
        } catch  {
            return false;
        }
    });
    const gfChosen = (0, $acw62.useMemo)(()=>(0, $fa9cadf0a1243d03$export$2eb90fb4fe01ab98)(savedStrategies), [
        savedStrategies
    ]);
    const [gfView, setGfView] = (0, $acw62.useState)(()=>opening === 'guide' ? 'guide' : opening === 'overview' ? 'overview' : !openedFresh && opening !== 'calculator' && (0, $fa9cadf0a1243d03$export$2eb90fb4fe01ab98)(savedStrategies) ? 'hub' : 'steps');
    /** Where the guides go back to. */ const [guideFrom, setGuideFrom] = (0, $acw62.useState)(()=>(0, $fa9cadf0a1243d03$export$2eb90fb4fe01ab98)(savedStrategies) ? 'hub' : 'steps');
    const openGuide = (view)=>{
        setGuideFrom(gfView === 'hub' ? 'hub' : 'steps');
        setGfView(view);
        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
    };
    const closeGuide = ()=>{
        setGfView(guideFrom === 'hub' && gfChosen ? 'hub' : 'steps');
        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
    };
    /** What the plan page asked for, done once the tested plans are back (or the hand-built plan is restored). */ const [pendingHubAction, setPendingHubAction] = (0, $acw62.useState)(null);
    // A fresh model: the flag cleared, and step 1's and step 3's answers taken off the file so nothing carries over.
    (0, $acw62.useEffect)(()=>{
        try {
            sessionStorage.removeItem((0, $fa9cadf0a1243d03$export$edd6500f2ae69e6b));
        } catch  {}
        if (openedFresh && setFactFind) setFactFind((prev)=>{
            const g = {
                ...prev?.goals || {}
            };
            for (const k of $f34df9d62ff01218$var$GF_FRESH_GOAL_KEYS)delete g[k];
            return {
                ...prev,
                goals: g
            };
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /*
   * THREE STEPS (the village's spine). 1: the arrangement — who, what is given, the home, the start. 2: what it
   * means — not entering it, in four numbers. 3: the ways to set it up — the questions before the first run,
   * then the plans, or the plan built by hand.
   */ const [step, setStep] = (0, $acw62.useState)(1);
    const [strategyMode, setStrategyMode] = (0, $acw62.useState)('');
    const goToStep = (next)=>{
        if (next === 3) setStrategyMode((m)=>m === '' ? 'optimised' : m);
        setStep(next);
        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
    };
    // Step 3 asks its questions before the first run, and again from "Things that change the answer".
    const [gfAsking, setGfAsking] = (0, $acw62.useState)(()=>openedFresh || goals.gfLegacyYears == null);
    const startDate = String(goals.gfStartDate || '');
    // A past start date models as starting now (24 Oct 2026): the right valued at today's age and rates, the gift dated today.
    const effectiveStart = (0, $576b15178c677e44$export$37d7ba658a355219)(startDate);
    const [localLegacyYears, setLocalLegacyYears] = (0, $acw62.useState)(()=>Number(goals.gfLegacyYears) > 0 ? Number(goals.gfLegacyYears) : 10);
    const setLegacyYears = (y)=>{
        setLocalLegacyYears(y);
        setFactFind?.((prev)=>({
                ...prev,
                goals: {
                    ...prev?.goals || {},
                    gfLegacyYears: y
                }
            }));
    };
    /* ── MANUAL CONTROL'S MODEL ("Build a plan yourself") ─────────────────────────────────────── */ const rentAnswers = (0, $acw62.useMemo)(()=>({
            weekly: goals.gfRentPerWeek != null ? $f34df9d62ff01218$var$num(goals.gfRentPerWeek) : $f34df9d62ff01218$var$num(factFind?.home?.likelyRent),
            costs: goals.gfRentCosts != null ? $f34df9d62ff01218$var$num(goals.gfRentCosts) : $f34df9d62ff01218$var$num(factFind?.home?.likelyExpenses),
            vacancy: goals.gfVacancyWeeks != null ? $f34df9d62ff01218$var$num(goals.gfVacancyWeeks) : (0, $576b15178c677e44$export$4a9fb6bdf3fe5eb2)
        }), [
        goals.gfRentPerWeek,
        goals.gfRentCosts,
        goals.gfVacancyWeeks,
        factFind?.home?.likelyRent,
        factFind?.home?.likelyExpenses
    ]);
    const [gfInputs, setGfInputs] = (0, $acw62.useState)(()=>({
            amountPaid: 0,
            transferHome: false,
            constructionCost: 0,
            fundFrom: 'savings',
            funding: {},
            fundingCgtOverrides: {},
            deployment: {},
            justMovingIn: false,
            keptHomeUse: 'vacant',
            keptHomeRent: rentAnswers.weekly,
            keptHomeExpenses: rentAnswers.costs,
            keptHomeVacancy: rentAnswers.vacancy
        }));
    /** What is given in the hand-built plan, as the ledger shows it (kept apart from the amounts, which may be 0). */ const [manualForm, setManualForm] = (0, $acw62.useState)('cash');
    const [manualStartedFrom, setManualStartedFrom] = (0, $acw62.useState)(null);
    /** The TESTED plan the hand-built one was customised from ("Customise this plan", 25 Oct 2026), for its record and document; null for a blank start or step 1's. */ const [manualCustomisedFrom, setManualCustomisedFrom] = (0, $acw62.useState)(null);
    const [manualLastChange, setManualLastChange] = (0, $acw62.useState)(null);
    const [manualChosen, setManualChosen] = (0, $acw62.useState)(false);
    const noteManualChange = (words)=>{
        setManualLastChange(words);
        setManualChosen(false);
    };
    const setField = (field, value)=>setGfInputs((prev)=>({
                ...prev,
                [field]: value
            }));
    // "Just moving in" = no payment / transfer at all → no granny-flat interest, no gift, non-homeowner.
    const justMovingIn = !!gfInputs.justMovingIn;
    // The home signed over gives its value on the start date, less the loans the family member takes over (24 Oct 2026).
    const propertyTransferred = justMovingIn ? 0 : gfInputs.transferHome ? Math.round((0, $a528307a9ba99a26$export$828d07fe6ecf7e29)(factFind, effectiveStart || null).given) : 0;
    const amountPaid = justMovingIn ? 0 : $f34df9d62ff01218$var$num(gfInputs.amountPaid);
    const constructionCost = justMovingIn ? 0 : $f34df9d62ff01218$var$num(gfInputs.constructionCost);
    // Construction is money paid to build the accommodation: consideration given, in the homeowner test, funded from assets.
    const entryContribution = amountPaid + propertyTransferred + constructionCost;
    const cashOutlay = amountPaid + constructionCost;
    const hasArrangement = entryContribution > 0;
    const isHomeowner = entryContribution > (0, $1abe73eeef086faf$export$e2cf792e99a08354);
    const sellingHomeToFund = !justMovingIn && !gfInputs.transferHome && gfInputs.fundFrom === 'sell_home' && homeValue > 0 && cashOutlay > 0;
    // The home's loans are repaid from the sale (24 Oct 2026), as the engine and the server do.
    const saleResidual = sellingHomeToFund ? Math.max(0, homeValue - Math.round(homeValue * 0.025) - (0, $a528307a9ba99a26$export$6bae1904888d8a72)(factFind) - cashOutlay) : 0;
    const keepingHome = hasHome && propertyTransferred === 0 && !sellingHomeToFund;
    const shouldSimulate = hasArrangement || justMovingIn;
    const deployment = gfInputs.deployment;
    const manualIncomeOnly = sellingHomeToFund && saleResidual > 0 && (0, $80740ae64106afa1$export$bba70ab5d49cb5db)(deployment);
    const setIncomeOnlyUnderstood = (0, $5eae79c7e46ed27e$export$415ddf94c95c9134)(setFactFind);
    const manualIncomeOnlyHeld = !!setIncomeOnlyUnderstood && (0, $5eae79c7e46ed27e$export$655f124668ce439a)(factFind, manualIncomeOnly, Number(deployment?.annuity) || 0);
    const cashFromSavings = gfInputs.transferHome || gfInputs.fundFrom === 'savings' || !sellingHomeToFund ? cashOutlay : 0;
    /*
   * Until the client chooses the accounts, the payment is drawn in our suggested order — the bank (keeping the
   * emergency money), then term deposits, the account-based pension and shares — the engine's own draw for the
   * tested plans (grannyFlatFactFind.buildAutoFundingMap). So the ledger's figures are live from the first change.
   */ const fundingSuggested = cashFromSavings > 0 && Object.keys(gfInputs.funding || {}).length === 0;
    const manualReserve = $f34df9d62ff01218$var$num(goals.gfEmergencyReserve) > 0 ? $f34df9d62ff01218$var$num(goals.gfEmergencyReserve) : (0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind);
    const funding = gfInputs.funding;
    const fundingCgtOverrides = gfInputs.fundingCgtOverrides;
    const gf = (0, $acw62.useMemo)(()=>({
            amountPaid: amountPaid,
            propertyTransferredValue: propertyTransferred,
            constructionCost: constructionCost,
            dateEntered: effectiveStart,
            fundFrom: justMovingIn || gfInputs.transferHome || !sellingHomeToFund ? 'savings' : 'sell_home',
            deployment: sellingHomeToFund ? deployment : undefined,
            funding: cashFromSavings > 0 ? funding : undefined,
            fundingCgtOverrides: fundingCgtOverrides,
            emergencyReserve: manualReserve,
            sellingCosts: undefined,
            // When the home is kept, how it's used drives whether the (now-assessable) former home also earns rent —
            // the rent over the weeks it is let (two empty weeks a year, suggested: the village's ruling).
            keptHomeUse: keepingHome ? gfInputs.keptHomeUse : 'vacant',
            keptHomeRent: (0, $576b15178c677e44$export$76881bf9211d0f88)($f34df9d62ff01218$var$num(gfInputs.keptHomeRent), gfInputs.keptHomeVacancy),
            keptHomeExpenses: $f34df9d62ff01218$var$num(gfInputs.keptHomeExpenses)
        }), [
        amountPaid,
        propertyTransferred,
        constructionCost,
        startDate,
        todayIso,
        justMovingIn,
        gfInputs.transferHome,
        sellingHomeToFund,
        deployment,
        cashFromSavings,
        funding,
        fundingCgtOverrides,
        manualReserve,
        keepingHome,
        gfInputs.keptHomeUse,
        gfInputs.keptHomeRent,
        gfInputs.keptHomeVacancy,
        gfInputs.keptHomeExpenses
    ]);
    /* TODAY'S POSITION — step 2's four numbers and the plans' "not entering" strip. */ const [todayFinancials, setTodayFinancials] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind).then((r)=>{
            if (!cancelled) setTodayFinancials(r);
        }).catch(()=>{
            if (!cancelled) setTodayFinancials(null);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind
    ]);
    const manualOn = strategyMode === 'manual' && step === 3;
    /** The hand-built plan's figures are still being worked out (utils/calcTracker.ts, 25 Oct 2026). */ const { track: trackGf, working: gfCalcWorking } = (0, $a8ad6b8c257d1221$export$66e981b52ef0ad9f)();
    const [{ before: before, after: afterRaw, simulated: simulated }, setBeforeAfter] = (0, $acw62.useState)({
        before: {},
        after: {},
        simulated: factFind
    });
    (0, $acw62.useEffect)(()=>{
        if (!manualOn) return undefined;
        let cancelled = false;
        trackGf((async ()=>{
            let resolved;
            if (shouldSimulate) resolved = await $55a1d8a64f1e5dfa$export$b426c10567c13d23(factFind, gf);
            else {
                const b = await $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind);
                resolved = {
                    before: b,
                    after: b,
                    simulated: factFind
                };
            }
            if (!cancelled) setBeforeAfter(resolved);
        })());
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind,
        gf,
        shouldSimulate,
        manualOn
    ]);
    /** The debt strategy, shared with aged care: applied at the origin so every figure agrees. */ const [debtPayments, setDebtPayments] = (0, $acw62.useState)({});
    const [debtFunding, setDebtFunding] = (0, $acw62.useState)({});
    const [debtRepaymentBasis, setDebtRepaymentBasis] = (0, $acw62.useState)('keep_repayment');
    const debtPayoffPlan = (0, $acw62.useMemo)(()=>{
        const payments = Object.fromEntries(Object.entries(debtPayments).filter(([, amount])=>(Number(amount) || 0) > 0));
        if (Object.keys(payments).length === 0) return null;
        const fundingMap = Object.fromEntries(Object.entries(debtFunding).filter(([, amount])=>(Number(amount) || 0) > 0));
        return {
            payments: payments,
            funding: fundingMap,
            repaymentBasis: debtRepaymentBasis
        };
    }, [
        debtPayments,
        debtFunding,
        debtRepaymentBasis
    ]);
    /** A future start date is a REAL deferral: the engine establishes the arrangement on the day. */ const futureGfDate = gf.dateEntered && gf.dateEntered > todayIso ? gf.dateEntered : '';
    const simulatedForModelling = (0, $acw62.useMemo)(()=>debtPayoffPlan ? (0, $5a6326d9013f181c$export$525e306199c9748e)(simulated, debtPayoffPlan).factFind : simulated, [
        simulated,
        debtPayoffPlan
    ]);
    const [afterWithDebt, setAfterWithDebt] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!debtPayoffPlan || !shouldSimulate || !manualOn) {
            setAfterWithDebt(null);
            return undefined;
        }
        let cancelled = false;
        trackGf($55a1d8a64f1e5dfa$export$463f0620dd36e1f8(simulatedForModelling)).then((r)=>{
            if (!cancelled) setAfterWithDebt(r);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        simulatedForModelling,
        debtPayoffPlan,
        shouldSimulate,
        manualOn
    ]);
    const after = afterWithDebt ?? afterRaw;
    const depResult = (0, $acw62.useMemo)(()=>hasArrangement ? (0, $a528307a9ba99a26$export$eb48a6112ea73d5a)(simulated, (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).couple) : null, [
        simulated,
        hasArrangement
    ]);
    const [projections, setProjections] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        if (!shouldSimulate || !manualOn) {
            setProjections([]);
            return undefined;
        }
        let cancelled = false;
        const projectionsPromise = futureGfDate ? $55a1d8a64f1e5dfa$export$bb4a59e402c33896(factFind, {
            legacyYears: localLegacyYears,
            grannyFlatEvent: {
                date: futureGfDate,
                gf: gf
            },
            ...debtPayoffPlan ? {
                debtPayoff: debtPayoffPlan
            } : {}
        }) : $55a1d8a64f1e5dfa$export$bb4a59e402c33896(simulatedForModelling, {
            legacyYears: localLegacyYears
        });
        trackGf(projectionsPromise).then((proj)=>{
            if (!cancelled) setProjections(proj);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        simulatedForModelling,
        shouldSimulate,
        localLegacyYears,
        futureGfDate,
        factFind,
        gf,
        debtPayoffPlan,
        manualOn
    ]);
    const legacyEstimate = projections.length > 0 ? (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(projections[localLegacyYears - 1] ?? projections[projections.length - 1]) ?? after.netWorth : after.netWorth;
    const manualDeploymentRows = (0, $86923a7f40531161$export$56004bc8d68e8454)(gfInputs.deployment);
    const reasonableValue = depResult?.reasonableValue ?? 0;
    const interestValue = depResult?.interestValue ?? 0;
    const deprivation = depResult?.deprivation ?? 0;
    /* CENTRELINK'S VALUE OF THE RIGHT AT THE START DATE, whether or not anything has been entered. */ const [reasonableValueToday, setReasonableValueToday] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (0, $576b15178c677e44$export$cdb9477b6f7db8e1)(factFind, effectiveStart).then((v)=>{
            if (!cancelled) setReasonableValueToday(v);
        }).catch(()=>{
            if (!cancelled) setReasonableValueToday(null);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind,
        startDate,
        todayIso
    ]);
    const insightFinancials = (0, $acw62.useMemo)(()=>({
            agePensionBefore: before?.socialSecurity ?? 0,
            agePensionAfter: after?.socialSecurity ?? 0,
            cashflowAfter: projections[0]?.netCashflow ?? after?.cashFlow ?? 0,
            legacyEstimate: legacyEstimate
        }), [
        before,
        after,
        projections,
        legacyEstimate
    ]);
    /*
   * THE BENCHMARK: this client's position over the horizon if they do not enter the arrangement — step 2's
   * estate and runway, and what "See the year-by-year figures, not entering" opens. The same run the
   * engine's own baseline makes.
   */ const [stayPutProjections, setStayPutProjections] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        trackGf($55a1d8a64f1e5dfa$export$bb4a59e402c33896(factFind, {
            legacyYears: localLegacyYears
        })).then((rows)=>{
            if (!cancelled) setStayPutProjections(rows || []);
        }).catch(()=>{
            if (!cancelled) setStayPutProjections([]);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind,
        localLegacyYears
    ]);
    const manualBaselineLegacy = (0, $acw62.useMemo)(()=>{
        const last = stayPutProjections[localLegacyYears - 1] ?? stayPutProjections[stayPutProjections.length - 1];
        return (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(last);
    }, [
        stayPutProjections,
        localLegacyYears
    ]);
    const stayPutRunway = (0, $acw62.useMemo)(()=>stayPutProjections.length ? (0, $0fe89e03b6df746e$export$464558962ff4a811)(stayPutProjections, Number(localLegacyYears) || 10) : null, [
        stayPutProjections,
        localLegacyYears
    ]);
    /* ── THE TESTED PLANS ─────────────────────────────────────────────────────────────────────── */ /** The setup the engine runs on: step 1's and step 3's answers, as kept on the file (gfEngineSetupFromGoals). */ const gfSetup = (0, $acw62.useMemo)(()=>(0, $576b15178c677e44$export$db301251dc134f1c)(factFind), [
        factFind
    ]);
    // True until the first run is back, so step 3 never flashes "couldn't test" before the loader.
    const [seLoading, setSeLoading] = (0, $acw62.useState)(true);
    const [gfSuggestions, setGfSuggestions] = (0, $acw62.useState)(null);
    const [seDeepDive, setSeDeepDive] = (0, $acw62.useState)(null);
    const [riskStrategy, setRiskStrategy] = (0, $acw62.useState)(null);
    const [explainSeId, setExplainSeId] = (0, $acw62.useState)(null);
    const [showGfExplanation, setShowGfExplanation] = (0, $acw62.useState)(false);
    const [showStayPutProjections, setShowStayPutProjections] = (0, $acw62.useState)(false);
    const [showAllSeStrategies, setShowAllSeStrategies] = (0, $acw62.useState)(false);
    const [allSortBy, setAllSortBy] = (0, $acw62.useState)('legacy');
    const [optimisationFocus, setOptimisationFocus] = (0, $acw62.useState)('legacy');
    const [selectedSeId, setSelectedSeId] = (0, $acw62.useState)(null);
    /*
   * A real provider quote. Only the committed value re-runs the field. A quote belongs to ONE type and ONE
   * amount (annuityQuote.ts): plans of the same type use it scaled to their amount, others keep our estimate.
   */ const [gfAnnuityQuote, setGfAnnuityQuote] = (0, $acw62.useState)(null);
    const [gfAnnuityQuoteDraft, setGfAnnuityQuoteDraft] = (0, $acw62.useState)('');
    // The just-in-time "how would new money be invested?" gate — asked on the questions screen first.
    const [newMoneySkipped, setNewMoneySkipped] = (0, $acw62.useState)(false);
    // The module's own questions ask this; "Not sure" there is an answer that records nothing, so once they are answered the
    // old one-question gate never shows (owner, 22 Oct 2026: it stood alone in place of the questions on a return visit).
    const needsNewMoneyAnswer = strategyMode === 'optimised' && hasHome && !(0, $0f2c0a6799fe36da$export$848647f164f42923)(factFind) && !newMoneySkipped && !gfAsking && goals.gfLegacyYears == null;
    const answerNewMoneyProfile = (id)=>{
        if (setFactFind) setFactFind((prev)=>({
                ...prev,
                goals: {
                    ...prev.goals || {},
                    newMoneyInvestmentProfile: id
                }
            }));
        else setNewMoneySkipped(true);
    };
    // The Transfer Balance Cap question: only when a sale route would COMMENCE a pension and a person's balances trip the screen.
    const [tbcSkipped, setTbcSkipped] = (0, $acw62.useState)(false);
    const seRunCommencesPension = (0, $acw62.useMemo)(()=>{
        if (!hasHome) return false;
        const room = (0, $996111778bb35e70$export$3156faa588d94c0c)(factFind);
        return room.total > 0 && room.preferred == null && (gfSetup.homeRoute === 'sell' || gfSetup.homeRoute === 'all' || gfSetup.homeRoute == null);
    }, [
        factFind,
        hasHome,
        gfSetup.homeRoute
    ]);
    const tbcPersonNeedingAnswer = !tbcSkipped && seRunCommencesPension ? (0, $4f5a997f1c0139af$export$7bf826dbcbb0ddc)(factFind, 'client') ? 'client' : isCouple && (0, $4f5a997f1c0139af$export$7bf826dbcbb0ddc)(factFind, 'partner') ? 'partner' : null : null;
    const needsTbcAnswer = strategyMode === 'optimised' && tbcPersonNeedingAnswer !== null && !gfAsking;
    const answerTbc = (amount)=>{
        if (setFactFind && tbcPersonNeedingAnswer) {
            const key = tbcPersonNeedingAnswer;
            setFactFind((prev)=>({
                    ...prev,
                    [key]: {
                        ...prev[key] || {},
                        transferBalanceUsed: amount
                    }
                }));
        } else setTbcSkipped(true);
    };
    // The engine runs on step 3 once the questions are answered (and never while they are open).
    (0, $acw62.useEffect)(()=>{
        if (strategyMode !== 'optimised' || step !== 3 || gfView !== 'steps') return undefined;
        if (gfAsking || needsNewMoneyAnswer || needsTbcAnswer) {
            setSeLoading(false);
            return undefined;
        }
        setSeLoading(true);
        const startedAt = Date.now();
        const t = setTimeout(async ()=>{
            let result = null;
            try {
                result = await (0, $576b15178c677e44$export$8ef4aa8bb38d60e4)(factFind, {
                    legacyYears: localLegacyYears,
                    dateEntered: effectiveStart,
                    setup: gfSetup,
                    annuityQuote: gfAnnuityQuote
                });
            } catch  {
                result = null;
            }
            setGfSuggestions(result);
            setTimeout(()=>setSeLoading(false), Math.max(0, 1600 - (Date.now() - startedAt)));
        }, 60);
        return ()=>clearTimeout(t);
    // gfAnnuityQuote: a committed provider quote re-ranks the whole field (for the plans of its type).
    }, [
        strategyMode,
        step,
        gfView,
        factFind,
        localLegacyYears,
        startDate,
        todayIso,
        gfAsking,
        needsNewMoneyAnswer,
        needsTbcAnswer,
        gfSetup,
        gfAnnuityQuote
    ]);
    /**
   * The Statement of Advice for an engine plan (gfSoa.ts). On the calendar-year setting the plan and the
   * benchmark are re-cut on calendar years first, so the document's rows match what the client reads.
   */ const gfStrategies = (0, $acw62.useMemo)(()=>gfSuggestions ? (0, $f8ee565b442c040e$export$ca5137fb416189aa)(gfSuggestions.strategies, gfSuggestions.recommended) : [], [
        gfSuggestions
    ]);
    const gfStayPut = (0, $acw62.useMemo)(()=>gfSuggestions?.stayPut ?? null, [
        gfSuggestions
    ]);
    const isGfBaseline = (s)=>s.id === 'gf-stay-put';
    const markSoaPrepared = (planId)=>{
        if (!setSavedStrategies) return;
        setSavedStrategies((prev)=>prev.map((s)=>s.type === 'granny_flat' && s.chosen === true && (planId == null || s.inputs?.engineStrategyId === planId || s.source === 'manual') ? {
                    ...s,
                    soaPreparedAt: new Date().toISOString()
                } : s));
    };
    const generateGfSoa = async (strategy)=>{
        const periodMode = (0, $4f50ab660c01dd64$export$1e222c2c280e2a28)();
        let picked = strategy;
        let all = gfStrategies;
        const rerun = gfSuggestions?.rerun;
        if (periodMode === 'calendar_year' && rerun) {
            const wanted = rerun.candidates.filter((c)=>c?.id === strategy.id || c?.id === 'gf-stay-put');
            if (wanted.length) try {
                const rows = await $55a1d8a64f1e5dfa$export$e0ff603d890d58d6(factFind, wanted, rerun.legacyYears, rerun.date, 'calendar_year');
                const byId = new Map(rows.map((r)=>[
                        String(r.id),
                        r.projections || []
                    ]));
                picked = {
                    ...strategy,
                    projections: byId.get(String(strategy.id)) ?? strategy.projections
                };
                all = gfStrategies.map((s)=>byId.has(String(s.id)) ? {
                        ...s,
                        projections: byId.get(String(s.id))
                    } : s);
            } catch  {}
        }
        const snapshot = (0, $262da6d05a14a944$export$5c6074aa828c431c)({
            strategy: picked,
            all: all,
            factFind: factFind,
            legacyYears: Number(localLegacyYears) || 10,
            reasonableValue: Number(gfSuggestions?.reasonableValue) || 0,
            periodMode: periodMode
        });
        (0, $482dbb064a59e381$export$bedc55c6dae3ee6a)(snapshot);
        markSoaPrepared(strategy.id);
        onSoaGenerated?.({
            id: strategy.id,
            name: strategy.name,
            type: 'granny_flat',
            source: 'suggestion_engine',
            strategy: strategy,
            soaSnapshot: snapshot
        });
    };
    /* THE DEEP DIVE'S YEAR TOGGLE: re-cutting a candidate on the calendar year means running it again. */ const [modalPeriodMode, setModalPeriodMode] = (0, $acw62.useState)((0, $4f50ab660c01dd64$export$1e222c2c280e2a28));
    const [calendarYearProjections, setCalendarYearProjections] = (0, $acw62.useState)(null);
    const deepDiveCandidate = (0, $acw62.useMemo)(()=>{
        const rerun = gfSuggestions?.rerun;
        if (!rerun || !seDeepDive?.id) return null;
        const candidate = rerun.candidates.find((c)=>c?.id === seDeepDive.id);
        return candidate ? {
            candidate: candidate,
            legacyYears: rerun.legacyYears,
            date: rerun.date
        } : null;
    }, [
        gfSuggestions,
        seDeepDive
    ]);
    (0, $acw62.useEffect)(()=>{
        if (modalPeriodMode !== 'calendar_year' || !seDeepDive || !deepDiveCandidate) {
            setCalendarYearProjections(null);
            return undefined;
        }
        let cancelled = false;
        setCalendarYearProjections(null);
        $55a1d8a64f1e5dfa$export$e0ff603d890d58d6(factFind, [
            deepDiveCandidate.candidate
        ], deepDiveCandidate.legacyYears, deepDiveCandidate.date, 'calendar_year').then((rows)=>{
            if (cancelled) return;
            const first = Array.isArray(rows) ? rows[0] : undefined;
            setCalendarYearProjections(first?.projections ?? []);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        modalPeriodMode,
        seDeepDive,
        deepDiveCandidate,
        factFind
    ]);
    /* GOAL LEADERS, with the aged care horizon rule: a plan whose annuity needs more years is set aside, never hidden. */ const gfRecommended = (0, $acw62.useMemo)(()=>{
        if (!gfSuggestions) return [];
        const movers = gfStrategies.filter((s)=>!isGfBaseline(s));
        const eligible = movers.filter((s)=>$f34df9d62ff01218$var$gfAnnuityHorizonWarningOf(s, factFind) == null);
        /*
     * RANKED AMONG THE WAYS OF SETTING IT UP, not against not entering the arrangement (the village's rule, owner 20–21 Oct 2026; found in the
     * live review 22 Oct 2026: when every way left less than not entering the arrangement, the shared ranking withheld them all and
     * the plans screen showed no cards). The price is said in one line above the cards and an "Important"
     * line on each, against not entering the arrangement.
     */ return (0, $f8ee565b442c040e$export$3140a3b98e6384f2)(eligible, null, {
            readings: (0, $5a094123650e8adb$export$448a1f2525c95b5b)
        });
    }, [
        gfSuggestions,
        gfStrategies,
        gfStayPut,
        factFind
    ]);
    const gfGoalLeaders = (0, $acw62.useMemo)(()=>(0, $f8ee565b442c040e$export$64e432c7e60d26e3)(gfRecommended), [
        gfRecommended
    ]);
    const gfSetAside = (0, $acw62.useMemo)(()=>{
        if (!gfSuggestions) return [];
        return (0, $f8ee565b442c040e$export$64e432c7e60d26e3)(gfSuggestions.recommended).map((s)=>({
                strategy: s,
                labels: s.recommendationLabels || [],
                warning: $f34df9d62ff01218$var$gfAnnuityHorizonWarningOf(s, factFind) || ''
            })).filter((x)=>x.warning);
    }, [
        gfSuggestions,
        factFind
    ]);
    const explainStrategy = (0, $acw62.useMemo)(()=>explainSeId ? gfStrategies.find((s)=>s.id === explainSeId) || null : null, [
        gfStrategies,
        explainSeId
    ]);
    /** The plan chosen on an earlier visit, for its card. */ const gfChosenEngineId = (0, $acw62.useMemo)(()=>{
        const id = gfChosen && gfChosen.source === 'suggestion_engine' ? gfChosen.inputs?.engineStrategyId : null;
        return typeof id === 'string' ? id : null;
    }, [
        gfChosen
    ]);
    const chosenIdNow = selectedSeId ?? gfChosenEngineId;
    /*
   * INCOME ONLY NEEDS THE CLIENT'S CONFIRMATION BEFORE A TESTED PLAN IS CHOSEN (guaranteed income review E5,
   * 21 Oct 2026; IncomeOnlyTick.tsx). The full-amount-back type and a set term are never income only.
   */ const engineIncomeOnlyHeld = (strategy)=>{
        const g = (0, $75f9bc5abce573de$export$816a4f32463eb868)(strategy, factFind);
        return !!g && !!setIncomeOnlyUnderstood && (0, $5eae79c7e46ed27e$export$655f124668ce439a)(factFind, g.incomeOnly, g.amount);
    };
    /** The arrangement on the record, read off a plan the way the cards read it. */ const arrangementOf = (plan, rv)=>{
        const m = (0, $263fcb126ae0e669$export$ca60ec58f5352c3a)(plan, factFind);
        const given = (0, $263fcb126ae0e669$export$172c8762bdedaa06)(m);
        return {
            given: given,
            cash: m.amountPaid,
            homeSignedOver: m.propertyTransferred,
            build: m.construction,
            gift: m.deprivation,
            interestValue: Math.max(0, given - m.deprivation),
            reasonableValue: rv,
            isHomeowner: m.isHomeowner,
            home: m.home,
            rentAYear: m.rented ? Math.round(m.keptHomeRent * 52) : 0,
            dateEntered: startDate,
            hostKind: (0, $32bd8c8afa665e9e$export$2b2184b5390b1cd2)(factFind)
        };
    };
    /**
   * Choosing a tested plan SAVES it, as aged care and the village do: the card is stored on the record, one
   * granny flat plan on record (withChosenGfPlan), and the plan page, the guide and Home read it.
   */ const [heldSelectId, setHeldSelectId] = (0, $acw62.useState)(null);
    /*
   * THE CHOSEN PLAN'S FIGURES FOLLOW ITS RE-TEST (owner, 25 Oct 2026: as aged care and Support at home). Tested again
   * over the same years, the chosen tested plan is brought up to date on its record (Home and the plan page read it)
   * when the run has the same plan for the same arrangement (what is given); otherwise it is marked out of date.
   */ (0, $acw62.useEffect)(()=>{
        if (!gfChosen || gfChosen.source !== 'suggestion_engine' || !gfSuggestions || seLoading || !setSavedStrategies) return;
        const ins = gfChosen.inputs || {};
        if (Number(ins.card?.horizonYears) !== (Number(localLegacyYears) || 10)) return;
        const row = gfStrategies.find((x)=>x.id === ins.engineStrategyId);
        const sameArrangement = !!row && Math.round(arrangementOf(row, Number(gfSuggestions.reasonableValue) || 0).given) === Math.round(Number(ins.card?.arrangement?.given) || 0);
        const base = gfStrategies.find((x)=>x.id === 'gf-stay-put')?.snapshot;
        const chosenId = gfChosen.id;
        setSavedStrategies((prev)=>{
            const next = row && sameArrangement ? (0, $78a369bbf1e0d995$export$d5989af62c88c0aa)(prev, chosenId, {
                legacy: Number(row.snapshot?.legacyValue) || 0,
                pension: Number(row.snapshot?.pension) || 0,
                cashflow: Number(row.snapshot?.netCashflow) || 0
            }, base ? {
                legacy: Number(base.legacyValue) || 0,
                pension: Number(base.pension) || 0,
                cashflow: Number(base.netCashflow) || 0
            } : null, (0, $78a369bbf1e0d995$export$236630ee0fd3b65b)(factFind)) : (0, $78a369bbf1e0d995$export$91485c71ed77db22)(prev, chosenId, (0, $78a369bbf1e0d995$export$a2028cac13d6740f));
            return next ?? prev;
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        gfSuggestions,
        seLoading
    ]);
    const selectEngineStrategy = (strategy)=>{
        if (chosenIdNow != null && strategy.id === chosenIdNow) {
            setSelectedSeId(strategy.id);
            return;
        } // already chosen — no second save
        if (engineIncomeOnlyHeld(strategy)) {
            setHeldSelectId(strategy.id ?? null);
            setShowAllSeStrategies(false);
            return;
        }
        setHeldSelectId(null);
        setSelectedSeId(strategy.id ?? null);
        if (!setSavedStrategies) return;
        const recommended = gfGoalLeaders.map((l)=>({
                labels: l.recommendationLabels || [],
                name: l.name
            }));
        const horizon = Number(localLegacyYears) || 10;
        const baseSnap = gfStayPut?.snapshot;
        const compare = (0, $75f9bc5abce573de$export$31540525a196c11f)(strategy, gfStrategies);
        const card = {
            plan: {
                legacy: Number(strategy.snapshot?.legacyValue) || 0,
                pension: Number(strategy.snapshot?.pension) || 0,
                cashflow: Number(strategy.snapshot?.netCashflow) || 0
            },
            baseline: baseSnap ? {
                legacy: Number(baseSnap.legacyValue) || 0,
                pension: Number(baseSnap.pension) || 0,
                cashflow: Number(baseSnap.netCashflow) || 0
            } : null,
            words: (0, $263fcb126ae0e669$export$bf2295610779f6b)(strategy, factFind),
            arrangement: arrangementOf(strategy, Number(gfSuggestions?.reasonableValue) || 0),
            horizonYears: horizon,
            riskKinds: (()=>{
                const mv = (0, $263fcb126ae0e669$export$ca60ec58f5352c3a)(strategy, factFind);
                return (0, $203e38d6e6c434f4$export$bac9d5a868c209ac)(String(strategy.id || ''), {
                    construction: mv.construction,
                    amountPaid: mv.amountPaid,
                    home: mv.home
                });
            })(),
            origin: 'engine',
            family: (0, $fa9cadf0a1243d03$export$299c54074564e6d3)((0, $75f9bc5abce573de$export$816a4f32463eb868)(strategy, factFind), factFind, strategy.projections, compare ? {
                rows: compare.projections,
                note: (0, $75f9bc5abce573de$export$a5d7138b0effd291)
            } : null, horizon)
        };
        setSavedStrategies((prev)=>(0, $fa9cadf0a1243d03$export$4c657fe15c8489ed)(prev, {
                id: `gf-se-${Date.now()}`,
                name: strategy.name || 'Suggested granny flat arrangement',
                displayName: card.words.title,
                type: 'granny_flat',
                source: 'suggestion_engine',
                // The client's figures it was priced on, so Home can tell when they change (chosenPlanRefresh.ts).
                inputsFingerprint: (0, $78a369bbf1e0d995$export$236630ee0fd3b65b)(factFind),
                inputs: {
                    engineStrategyId: strategy.id ?? null,
                    card: card,
                    planContext: {
                        setup: {
                            ...gfSetup
                        }
                    },
                    gf: {
                        ...strategy.inputs || {}
                    },
                    setup: {
                        ...gfSetup
                    },
                    reasonableValue: Number(gfSuggestions?.reasonableValue) || 0,
                    legacyYears: horizon,
                    source: 'suggestion_engine',
                    seStrategyName: strategy.name ?? null,
                    recommendedOptimalStrategies: recommended,
                    clientSelectedIsAlternative: recommended.length > 0 && !recommended.some((r)=>r.name === strategy.name)
                },
                outputs: {
                    agePension: strategy.snapshot?.pension ?? 0,
                    cashFlow: strategy.snapshot?.netCashflow ?? 0,
                    legacyEstimate: strategy.snapshot?.legacyValue ?? 0,
                    deprivation: Number(strategy.deprivation) || 0,
                    netWorthSchedule: (0, $a882fd27fa2c97d8$export$7386c6396507d94b)(strategy.projections || [])
                },
                createdAt: new Date().toISOString()
            }));
    };
    // The explanation of an engine card is built from ITS before/after — never from the hand-built plan.
    const [explainView, setExplainView] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!explainStrategy) {
            setExplainView(null);
            return undefined;
        }
        let cancelled = false;
        const cfg = explainStrategy.inputs || {};
        $55a1d8a64f1e5dfa$export$b426c10567c13d23(factFind, cfg).then(({ before: sBefore, after: sAfter, simulated: sSim })=>{
            if (cancelled) return;
            const dep = (0, $a528307a9ba99a26$export$eb48a6112ea73d5a)(sSim, (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).couple);
            const sDeploymentRows = (0, $86923a7f40531161$export$56004bc8d68e8454)(cfg.deployment);
            const proj = explainStrategy.projections || [];
            const m = (0, $263fcb126ae0e669$export$ca60ec58f5352c3a)(explainStrategy, factFind);
            const sLegacy = proj.length ? (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(proj[localLegacyYears - 1] ?? proj[proj.length - 1]) ?? sAfter?.netWorth ?? 0 : sAfter?.netWorth ?? 0;
            setExplainView({
                name: explainStrategy.name,
                before: sBefore,
                after: sAfter,
                projections: proj,
                depResult: dep,
                hasArrangement: m.entryContribution > 0,
                justMovingIn: m.justMovingIn,
                amountPaid: m.amountPaid,
                propertyTransferred: m.propertyTransferred,
                constructionCost: m.construction,
                entryContribution: m.entryContribution,
                isHomeowner: m.isHomeowner,
                keepingHome: m.keeping,
                keptHomeRented: m.rented,
                formerHomeValue: m.keeping ? homeValue : 0,
                reasonableValue: dep?.reasonableValue ?? 0,
                interestValue: dep?.interestValue ?? 0,
                deprivation: dep?.deprivation ?? 0,
                legacyEstimate: sLegacy,
                fundingRows: explainStrategy.fundingBreakdown || [],
                fundingCgt: explainStrategy.fundingCgt || 0,
                fundingShortfall: explainStrategy.fundingShortfall || 0,
                deploymentRows: sDeploymentRows,
                saleFlow: m.selling ? {
                    homeValue: homeValue,
                    sellingCosts: m.sellingCosts,
                    amountPaid: m.amountPaid,
                    residual: m.saleResidual
                } : null,
                insightFinancials: {
                    agePensionBefore: sBefore?.socialSecurity ?? 0,
                    agePensionAfter: sAfter?.socialSecurity ?? 0,
                    cashflowAfter: proj[0]?.netCashflow ?? proj[0]?.cashFlow ?? sAfter?.cashFlow ?? 0,
                    legacyEstimate: sLegacy
                }
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        explainStrategy,
        factFind,
        homeValue,
        localLegacyYears
    ]);
    /* Manual Control's model: the recap, the ledger's effect and the hand-built plan read one object. */ const manualImpactReady = shouldSimulate;
    const fundingMeta = simulated?.__grannyFlatFundingMeta;
    const panelModel = (0, $acw62.useMemo)(()=>({
            name: null,
            before: before,
            after: manualImpactReady ? after : before,
            simulated: simulated,
            depResult: depResult,
            hasArrangement: hasArrangement,
            justMovingIn: justMovingIn,
            amountPaid: amountPaid,
            propertyTransferred: propertyTransferred,
            constructionCost: $f34df9d62ff01218$var$num(constructionCost),
            entryContribution: entryContribution,
            isHomeowner: isHomeowner,
            keepingHome: keepingHome && shouldSimulate,
            keptHomeRented: keepingHome && gfInputs.keptHomeUse === 'rented',
            formerHomeValue: keepingHome ? homeValue : 0,
            reasonableValue: reasonableValue,
            interestValue: interestValue,
            deprivation: deprivation,
            legacyEstimate: manualImpactReady ? legacyEstimate : before?.netWorth ?? 0,
            projections: manualImpactReady ? projections : [],
            fundingRows: manualImpactReady ? fundingMeta?.breakdown || [] : [],
            fundingCgt: manualImpactReady ? fundingMeta?.cgt || 0 : 0,
            fundingShortfall: manualImpactReady ? fundingMeta?.shortfall || 0 : 0,
            deploymentRows: manualImpactReady ? manualDeploymentRows : [],
            saleFlow: manualImpactReady && sellingHomeToFund ? {
                homeValue: homeValue,
                sellingCosts: Math.round(homeValue * 0.025),
                amountPaid: cashOutlay,
                residual: saleResidual
            } : null,
            insightFinancials: manualImpactReady ? insightFinancials : null
        }), [
        before,
        after,
        manualImpactReady,
        simulated,
        depResult,
        hasArrangement,
        justMovingIn,
        amountPaid,
        propertyTransferred,
        entryContribution,
        isHomeowner,
        keepingHome,
        shouldSimulate,
        gfInputs.keptHomeUse,
        homeValue,
        reasonableValue,
        interestValue,
        deprivation,
        legacyEstimate,
        projections,
        fundingMeta,
        manualDeploymentRows,
        sellingHomeToFund,
        cashOutlay,
        saleResidual,
        insightFinancials
    ]);
    /*
   * ── MANUAL CONTROL'S PLAN, AS A PLAN. The hand-built arrangement in the engine card's shape, so the choice
   * goes through the same record and the document is written by the same buildGrannyFlatSoaSnapshot. Its id
   * is composed from what the plan does so the risks and the document's parts are read the engine's way.
   */ const manualPlanId = (0, $acw62.useMemo)(()=>{
        let id = justMovingIn ? 'gf-move-in-only' : propertyTransferred > 0 ? 'gf-transfer-home' : sellingHomeToFund ? 'gf-sell' : 'gf-known';
        if (!justMovingIn && keepingHome && gfInputs.keptHomeUse === 'rented') id += '-keep-rent';
        if (sellingHomeToFund) {
            const d = deployment;
            const terms = (0, $80740ae64106afa1$export$14a5903af8acddef)(d, isCouple);
            const amt = (v)=>parseFloat(String(v ?? '')) || 0;
            if (terms && amt(terms.purchaseAmount) > 0) id += d.annuityType === 'guaranteed' ? '-annuity-guaranteed' : amt(terms.residualPercent) > 0 ? '-annuity-rcv' : '-annuity';
            else if (amt(d.investmentProperty) > 0) id += '-property';
            else if (amt(d.superContribution) + amt(d.partnerSuperContribution) > 0) id += '-super';
            else if (amt(d.investmentBond) > 0) id += '-bond';
            else if (amt(d.shares) > 0) id += '-shares';
        }
        if (debtPayoffPlan) id += '-clear-debt';
        return `${id}`;
    }, [
        justMovingIn,
        propertyTransferred,
        sellingHomeToFund,
        keepingHome,
        gfInputs.keptHomeUse,
        deployment,
        isCouple,
        debtPayoffPlan
    ]);
    const manualPlanView = (0, $acw62.useMemo)(()=>{
        if (!(strategyMode === 'manual' && manualImpactReady)) return null;
        return {
            id: manualPlanId,
            name: 'Your granny flat arrangement',
            description: 'The arrangement as built by hand.',
            inputs: {
                ...gf
            },
            snapshot: {
                pension: Number(panelModel.after?.socialSecurity) || 0,
                netCashflow: Number(panelModel.projections[0]?.netCashflow ?? panelModel.after?.cashFlow) || 0,
                legacyValue: Number(panelModel.legacyEstimate) || 0
            },
            projections: panelModel.projections,
            fundingBreakdown: panelModel.fundingRows,
            fundingCgt: panelModel.fundingCgt,
            fundingShortfall: panelModel.fundingShortfall,
            deprivation: panelModel.deprivation
        };
    }, [
        strategyMode,
        manualImpactReady,
        manualPlanId,
        gf,
        panelModel
    ]);
    /** Not entering, in the engine's shape — the benchmark the manual plan and its document are measured against. */ const manualStayPutView = (0, $acw62.useMemo)(()=>({
            id: 'gf-stay-put',
            name: 'Do not enter the arrangement',
            snapshot: {
                pension: Number(todayFinancials?.socialSecurity ?? before?.socialSecurity) || 0,
                netCashflow: Number(stayPutProjections[0]?.netCashflow ?? todayFinancials?.cashFlow ?? before?.cashFlow) || 0,
                legacyValue: Number(manualBaselineLegacy) || 0
            },
            projections: stayPutProjections
        }), [
        todayFinancials,
        before,
        stayPutProjections,
        manualBaselineLegacy
    ]);
    /** The hand-built plan's guaranteed income (only when the home is sold and part of it funds one). */ const manualGuaranteed = (0, $acw62.useMemo)(()=>manualPlanView ? (0, $75f9bc5abce573de$export$816a4f32463eb868)(manualPlanView, factFind) : null, [
        manualPlanView,
        factFind
    ]);
    /** Choosing the hand-built plan: the same card record a tested plan saves (Manual Control parity). */ const chooseManualPlan = ()=>{
        if (!manualPlanView || manualIncomeOnlyHeld || panelModel.fundingShortfall >= 1) return;
        const horizon = Number(localLegacyYears) || 10;
        const words = (0, $263fcb126ae0e669$export$bf2295610779f6b)(manualPlanView, factFind);
        const card = {
            plan: {
                legacy: Number(manualPlanView.snapshot?.legacyValue) || 0,
                pension: Number(manualPlanView.snapshot?.pension) || 0,
                cashflow: Number(manualPlanView.snapshot?.netCashflow) || 0
            },
            baseline: {
                legacy: Number(manualStayPutView.snapshot?.legacyValue) || 0,
                pension: Number(manualStayPutView.snapshot?.pension) || 0,
                cashflow: Number(manualStayPutView.snapshot?.netCashflow) || 0
            },
            words: words,
            arrangement: arrangementOf(manualPlanView, Number(reasonableValue || reasonableValueToday) || 0),
            horizonYears: horizon,
            riskKinds: (()=>{
                const mv = (0, $263fcb126ae0e669$export$ca60ec58f5352c3a)(manualPlanView, factFind);
                return (0, $203e38d6e6c434f4$export$bac9d5a868c209ac)(manualPlanId, {
                    construction: mv.construction,
                    amountPaid: mv.amountPaid,
                    home: mv.home
                });
            })(),
            origin: 'manual',
            family: (0, $fa9cadf0a1243d03$export$299c54074564e6d3)(manualGuaranteed, factFind, panelModel.projections, null, horizon)
        };
        const id = `gf-manual-${Date.now()}`;
        setManualChosen(true);
        if (!setSavedStrategies) return;
        setSavedStrategies((prev)=>(0, $fa9cadf0a1243d03$export$4c657fe15c8489ed)(prev, {
                id: id,
                name: words.title,
                displayName: words.title,
                type: 'granny_flat',
                source: 'manual',
                inputsFingerprint: (0, $78a369bbf1e0d995$export$236630ee0fd3b65b)(factFind),
                // Built by the client from a tested plan ("Customise this plan", 25 Oct 2026).
                ...manualCustomisedFrom ? {
                    customisedFrom: manualCustomisedFrom
                } : {},
                inputs: {
                    card: card,
                    planContext: {},
                    gf: {
                        ...manualPlanView.inputs || {}
                    },
                    manualInputs: {
                        ...gfInputs
                    },
                    manualForm: manualForm,
                    ...debtPayoffPlan ? {
                        debtPayoff: debtPayoffPlan
                    } : {},
                    reasonableValue: Number(reasonableValue || reasonableValueToday) || 0,
                    legacyYears: horizon,
                    source: 'manual'
                },
                outputs: {
                    agePension: card.plan.pension,
                    cashFlow: card.plan.cashflow,
                    legacyEstimate: card.plan.legacy,
                    deprivation: panelModel.deprivation,
                    netWorthSchedule: (0, $a882fd27fa2c97d8$export$7386c6396507d94b)(manualPlanView.projections || [])
                },
                createdAt: new Date().toISOString()
            }));
    };
    /** The advice document for the hand-built plan — the engine path's builder, the same register. */ const generateManualSoa = ()=>{
        if (!manualPlanView) return;
        const snapshot = (0, $262da6d05a14a944$export$5c6074aa828c431c)({
            strategy: manualPlanView,
            all: [
                manualPlanView,
                manualStayPutView
            ],
            factFind: factFind,
            legacyYears: Number(localLegacyYears) || 10,
            reasonableValue: Number(reasonableValue || reasonableValueToday) || 0,
            // The rows on screen are the financial-year run, so no calendar-year label is put on them.
            // A hand-built plan's document says so (25 Oct 2026: it was labelled as a tested plan), and where it began.
            manual: true,
            customisedFrom: manualCustomisedFrom
        });
        (0, $482dbb064a59e381$export$bedc55c6dae3ee6a)(snapshot);
        markSoaPrepared(null);
        onSoaGenerated?.({
            id: manualPlanView.id,
            name: manualPlanView.name,
            type: 'granny_flat',
            source: 'manual',
            strategy: manualPlanView,
            soaSnapshot: snapshot
        });
    };
    /** Seed the ledger from a tested plan's inputs ("Customise this plan", "Start from"). */ const seedManualFrom = (row)=>{
        const cfg = row.inputs || {};
        const move = (0, $263fcb126ae0e669$export$ca60ec58f5352c3a)(row, factFind);
        const form = move.justMovingIn ? 'nothing' : move.propertyTransferred > 0 ? 'home' : move.construction > 0 ? 'build' : 'cash';
        setManualForm(form);
        setGfInputs((prev)=>({
                ...prev,
                justMovingIn: form === 'nothing',
                transferHome: form === 'home',
                amountPaid: $f34df9d62ff01218$var$num(cfg.amountPaid),
                constructionCost: $f34df9d62ff01218$var$num(cfg.constructionCost),
                fundFrom: cfg.fundFrom === 'sell_home' ? 'sell_home' : 'savings',
                funding: cfg.funding || {},
                fundingCgtOverrides: {},
                deployment: cfg.deployment || {},
                keptHomeUse: cfg.keptHomeUse === 'rented' ? 'rented' : 'vacant',
                keptHomeRent: rentAnswers.weekly,
                keptHomeExpenses: cfg.keptHomeUse === 'rented' && cfg.keptHomeExpenses != null ? $f34df9d62ff01218$var$num(cfg.keptHomeExpenses) : rentAnswers.costs,
                keptHomeVacancy: rentAnswers.vacancy
            }));
        // A plan that also clears the debts brings its payoff with it.
        const cand = gfSuggestions?.rerun.candidates?.find((c)=>c?.id === row.id);
        setDebtPayments(cand?.debtPayoff?.payments ? {
            ...cand.debtPayoff.payments
        } : {});
        setDebtFunding({
            ...cand?.debtPayoff?.funding || {}
        });
        setDebtRepaymentBasis(cand?.debtPayoff?.repaymentBasis === 'lower_repayment' ? 'lower_repayment' : 'keep_repayment');
        setManualStartedFrom((0, $263fcb126ae0e669$export$bf2295610779f6b)(row, factFind).title);
        setManualCustomisedFrom((0, $263fcb126ae0e669$export$bf2295610779f6b)(row, factFind).title);
        setManualLastChange(null);
        setManualChosen(false);
    };
    /** Restore a hand-built plan from its record (the plan page's "Build a plan yourself"). */ const restoreManualFrom = (rec)=>{
        const ins = rec.inputs;
        if (ins?.manualInputs) setGfInputs((prev)=>({
                ...prev,
                ...ins.manualInputs
            }));
        if (ins?.manualForm) setManualForm(ins.manualForm);
        setDebtPayments(ins?.debtPayoff?.payments ? {
            ...ins.debtPayoff.payments
        } : {});
        setDebtFunding({
            ...ins?.debtPayoff?.funding || {}
        });
        setDebtRepaymentBasis(ins?.debtPayoff?.repaymentBasis === 'lower_repayment' ? 'lower_repayment' : 'keep_repayment');
        // Its own record says where it began, if it was customised from a tested plan.
        const from = rec.customisedFrom ?? null;
        setManualStartedFrom(from ?? rec.inputs?.card?.words.title ?? null);
        setManualCustomisedFrom(from);
        setManualChosen(true);
    };
    /*
   * BUILD A PLAN YOURSELF STARTS FROM STEP 1 (owner, 24 Oct 2026: a $600,000 build chosen on step 1 opened here as
   * "pay nothing" with a $0 build). What they said they would give, its amounts, and what happens to the home.
   * Returns false when step 1 is still "not sure", so the caller keeps its own starting point.
   */ const seedManualFromStep1 = ()=>{
        const give = (0, $3c33fc2d17e5ab0e$export$be6ce8332e69af13)(factFind);
        if (give === 'unsure') return false;
        const known = $f34df9d62ff01218$var$num(goals.gfKnownAmount);
        const extra = $f34df9d62ff01218$var$num(goals.gfKnownExtraCash);
        const route = goals.gfHomeRoute;
        const form = give === 'home' ? 'home' : give === 'build' ? 'build' : 'cash';
        setManualForm(form);
        setGfInputs((prev)=>({
                ...prev,
                justMovingIn: false,
                transferHome: form === 'home',
                amountPaid: form === 'cash' ? known > 0 ? known : Math.floor(Number(reasonableValueToday) || 0) : extra,
                constructionCost: form === 'build' ? known : 0,
                fundFrom: form !== 'home' && route === 'sell' ? 'sell_home' : 'savings',
                funding: {},
                fundingCgtOverrides: {},
                deployment: {},
                keptHomeUse: route === 'keep' ? 'rented' : 'vacant',
                keptHomeRent: rentAnswers.weekly,
                keptHomeExpenses: rentAnswers.costs,
                keptHomeVacancy: rentAnswers.vacancy
            }));
        setDebtPayments({});
        setDebtFunding({});
        setDebtRepaymentBasis('keep_repayment');
        setManualStartedFrom('What you described on step 1');
        setManualCustomisedFrom(null);
        setManualLastChange(null);
        setManualChosen(false);
        return true;
    };
    /*
   * EACH WAY OF PAYING KEEPS ITS OWN AMOUNTS here too (24 Oct 2026: switching from cash to "sign the home over" kept
   * $398,316 as cash on top of the home, a $398,316 gift). Switching puts away what was entered for the way left.
   */ const manualStash = (0, $acw62.useRef)({});
    const startBlankManualPlan = ()=>{
        setManualForm('cash');
        setGfInputs((prev)=>({
                ...prev,
                justMovingIn: false,
                transferHome: false,
                amountPaid: 0,
                constructionCost: 0,
                fundFrom: 'savings',
                funding: {},
                fundingCgtOverrides: {},
                deployment: {},
                keptHomeUse: 'vacant'
            }));
        setDebtPayments({});
        setDebtFunding({});
        setDebtRepaymentBasis('keep_repayment');
        setManualStartedFrom('A blank plan');
        setManualCustomisedFrom(null);
        setManualLastChange(null);
        setManualChosen(false);
    };
    /**
   * "Build a plan yourself" (owner, 25 Oct 2026): a blank hand-built plan, which for the granny flat is what step 1
   * decided (24 Oct 2026: a $600,000 build opened as "pay nothing") and nothing else; where step 1 is "not sure",
   * a blank cash plan. It used to keep whatever the ledger last held.
   */ const openGfBlank = ()=>{
        if (!seedManualFromStep1()) startBlankManualPlan();
    };
    /* "Compare with the strongest option" — on demand, information, never a switch. */ const [manualComparison, setManualComparison] = (0, $acw62.useState)(null);
    const runManualComparison = async ()=>{
        const fromField = gfStrategies.filter((s)=>!isGfBaseline(s));
        if (fromField.length) {
            setManualComparison({
                loading: false,
                best: fromField.reduce((top, s)=>$f34df9d62ff01218$var$num(s.snapshot?.legacyValue) > $f34df9d62ff01218$var$num(top.snapshot?.legacyValue) ? s : top, fromField[0])
            });
            return;
        }
        setManualComparison({
            loading: true,
            best: null
        });
        try {
            const result = await (0, $576b15178c677e44$export$8ef4aa8bb38d60e4)(factFind, {
                legacyYears: localLegacyYears,
                dateEntered: effectiveStart,
                setup: gfSetup
            });
            const movers = (result?.strategies || []).filter((s)=>s.id !== 'gf-stay-put');
            setManualComparison({
                loading: false,
                best: movers.length ? movers.reduce((top, s)=>$f34df9d62ff01218$var$num(s.snapshot?.legacyValue) > $f34df9d62ff01218$var$num(top.snapshot?.legacyValue) ? s : top, movers[0]) : null
            });
        } catch  {
            setManualComparison({
                loading: false,
                best: null
            });
        }
    };
    (0, $acw62.useEffect)(()=>{
        setManualComparison(null);
    }, [
        gfInputs,
        localLegacyYears
    ]);
    /* The plan page's Explain this / the advice document, done once the plans (or the hand-built plan) are back. */ (0, $acw62.useEffect)(()=>{
        if (!pendingHubAction) return;
        if (gfChosen?.source === 'manual') {
            if (!manualPlanView || !panelModel.projections.length) return;
            setPendingHubAction(null);
            if (pendingHubAction === 'explain') {
                setExplainSeId(null);
                setShowGfExplanation(true);
            } else generateManualSoa();
            return;
        }
        if (seLoading || !gfSuggestions) return;
        const row = gfStrategies.find((x)=>x.id === chosenIdNow);
        setPendingHubAction(null);
        if (!row) return;
        if (pendingHubAction === 'explain') {
            setExplainSeId(row.id ?? null);
            setShowGfExplanation(true);
        } else generateGfSoa(row);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pendingHubAction,
        seLoading,
        gfSuggestions,
        manualPlanView,
        panelModel.projections.length
    ]);
    const openSteps = (to, mode = 'optimised')=>{
        setGfView('steps');
        setStrategyMode(mode);
        goToStep(to);
    };
    /*
   * A NEW MODEL FROM SCRATCH, FROM THE PLAN PAGE (owner, 22 Oct 2026: every plan page has aged care's "Model
   * something else"). Home's "Start a new model" does this on opening; here it is done in place: step 1's and
   * step 3's answers come off the file, step 3 asks its questions again, and the module opens on an empty step 1.
   * The chosen plan stays chosen until another is chosen.
   */ const startFresh = ()=>{
        setFactFind?.((prev)=>{
            const g = {
                ...prev?.goals || {}
            };
            for (const k of $f34df9d62ff01218$var$GF_FRESH_GOAL_KEYS)delete g[k];
            return {
                ...prev,
                goals: g
            };
        });
        setLocalLegacyYears(10);
        setGfAsking(true);
        setManualStartedFrom(null);
        setManualChosen(false);
        setGfView('steps');
        setStrategyMode('');
        setStep(1);
        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
    };
    const openChosenForAction = (action)=>{
        setPendingHubAction(action);
        if (gfChosen?.source === 'manual') {
            restoreManualFrom(gfChosen);
            openSteps(3, 'manual');
        } else openSteps(3, 'optimised');
    };
    // Escape closes "every way tested".
    (0, $acw62.useEffect)(()=>{
        if (!showAllSeStrategies) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') setShowAllSeStrategies(false);
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        showAllSeStrategies
    ]);
    /** The risks of a plan: its parts, and the fairness point where the file records two or more children (and the host is a child). */ const risksFor = (kinds, move, horizonWarning, stampDuty)=>(0, $203e38d6e6c434f4$export$124603ee0434ece5)(kinds, {
            familyToKeepWhole: (0, $262da6d05a14a944$export$59bda1c999165b0)(factFind, move),
            horizonWarning: horizonWarning,
            stampDuty: stampDuty
        });
    /** The family guide's figures: the chosen plan's, from its record. */ const guideFigures = (0, $acw62.useMemo)(()=>(0, $fa9cadf0a1243d03$export$87a1da0d4877e2d0)(gfChosen), [
        gfChosen
    ]);
    const printBriefFromHub = ()=>{
        const answers = factFind?.grannyFlat?.familyGuide || {};
        const generatedAt = new Date().toISOString();
        (0, $82f6c9c0d5566ac3$export$92b81748c7df1848)({
            clientName: factFind?.client?.firstName || 'you',
            partnerName: isCouple ? factFind?.partner?.firstName || null : null,
            answers: answers,
            figures: guideFigures,
            generatedAt: generatedAt
        });
        const brief = guideFigures ? {
            generatedAt: generatedAt,
            entryContribution: guideFigures.entryContribution,
            interestValue: guideFigures.interestValue,
            deprivation: guideFigures.deprivation,
            isHomeowner: guideFigures.isHomeowner,
            dateEntered: guideFigures.dateEntered,
            ...guideFigures.planTitle ? {
                planTitle: guideFigures.planTitle
            } : {}
        } : {
            generatedAt: generatedAt
        };
        setFactFind?.((prev)=>({
                ...prev,
                grannyFlat: {
                    ...prev.grannyFlat || {},
                    familyGuide: {
                        ...prev.grannyFlat?.familyGuide || {},
                        brief: brief
                    }
                }
            }));
    };
    /* ── THE VIEWS ─────────────────────────────────────────────────────────────────────────────── */ if (gfView === 'guide') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec71447dcc27993d$export$2e2bcd8739ae039), {
        factFind: factFind,
        setFactFind: setFactFind,
        figures: guideFigures,
        planForm: (0, $ec71447dcc27993d$export$be92f20da694dad2)(gfChosen?.inputs?.card?.arrangement),
        onBack: closeGuide,
        backLabel: guideFrom === 'hub' && gfChosen ? 'Back to the plan' : 'Back to the granny flat',
        onToPlans: ()=>openSteps(3),
        onHome: ()=>setActivePage('Dashboard')
    });
    if (gfView === 'overview') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f34df9d62ff01218$var$GrannyFlatExplained, {
        onBack: closeGuide,
        onFamilyGuide: ()=>setGfView('guide'),
        factFind: factFind
    });
    if (gfView === 'hub' && gfChosen) {
        const card = gfChosen.inputs.card;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "max-w-[1240px] mx-auto",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $549d68d9d6e3a57c$export$2e2bcd8739ae039), {
                    factFind: factFind,
                    outOfDate: (0, $78a369bbf1e0d995$export$ceccff7104f70d1e)(gfChosen, factFind),
                    plan: {
                        ...gfChosen,
                        soaSnapshot: gfChosen.soaSnapshot ?? gfChosen.soaPreparedAt
                    },
                    onChangeArrangement: ()=>openSteps(1),
                    onModelAnother: ()=>openSteps(1),
                    onStartFresh: startFresh,
                    onAllPlans: ()=>openSteps(3),
                    onExplain: ()=>openChosenForAction('explain'),
                    onRisks: ()=>setRiskStrategy({
                            id: String(gfChosen.inputs?.engineStrategyId || ''),
                            name: card.words.title,
                            __kinds: card.riskKinds,
                            __move: {
                                propertyTransferred: card.arrangement.homeSignedOver,
                                entryContribution: card.arrangement.given
                            }
                        }),
                    onAdvice: ()=>openChosenForAction('advice'),
                    onBuild: ()=>{
                        if (gfChosen.source === 'manual') restoreManualFrom(gfChosen);
                        else {
                            const ins = gfChosen.inputs;
                            seedManualFrom({
                                id: String(ins?.engineStrategyId || ''),
                                inputs: ins?.gf || {},
                                fundingBreakdown: [],
                                deprivation: card.arrangement.gift
                            });
                            setManualStartedFrom(card.words.title);
                            setManualCustomisedFrom(card.words.title);
                        }
                        openSteps(3, 'manual');
                    },
                    onBuildNew: ()=>{
                        openGfBlank();
                        openSteps(3, 'manual');
                    },
                    onFamilyGuide: ()=>openGuide('guide'),
                    onPrintBrief: printBriefFromHub,
                    onReadGuide: ()=>openGuide('overview'),
                    onAssumptions: ()=>setActivePage('AssumptionsPage'),
                    onHome: ()=>setActivePage('Dashboard')
                }),
                riskStrategy && (()=>{
                    /*
           * THE SAME SPECIFICS AS THE TESTED PLAN'S LIST (owner, 22 Oct 2026: one "What could go wrong" per plan, wherever
           * it is opened). The saved record keeps the plan's own settings (inputs.gf, engine or hand-built), so the
           * guaranteed income's horizon warning and the stamp duty on a bought property are read from those, not dropped.
           */ const savedGf = gfChosen.inputs?.gf || {};
                    const savedAsPlan = {
                        id: String(gfChosen.inputs?.engineStrategyId || ''),
                        inputs: savedGf
                    };
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5757b380cc124794$export$2e2bcd8739ae039), {
                        voice: voice,
                        strategyName: card.words.title,
                        onClose: ()=>setRiskStrategy(null),
                        risks: risksFor(card.riskKinds || [], {
                            propertyTransferred: card.arrangement.homeSignedOver,
                            entryContribution: card.arrangement.given
                        }, $f34df9d62ff01218$var$gfAnnuityHorizonWarningOf(savedAsPlan, factFind), Number(savedGf.deployment?.ipStampDuty) || null)
                    });
                })()
            ]
        });
    }
    const stepDefs = [
        {
            title: 'The arrangement',
            sub: 'Who, what is given, the home'
        },
        {
            title: `What it means for ${voice.them}`,
            sub: 'Staying put, in four numbers'
        },
        {
            title: 'Ways to set it up',
            sub: 'Plans we tested, or build your own'
        }
    ];
    const crumb = step === 1 ? 'The arrangement' : step === 2 ? 'What it means' : strategyMode === 'manual' ? 'Build a plan yourself' : 'Ways to set it up';
    const host = (0, $32bd8c8afa665e9e$export$d71f476d519c5ae3)(factFind);
    /** The plans' detail layer: where the money comes from, the alternative, a quote for a guaranteed income. */ const renderDetail = (row)=>{
        const terms = (0, $80740ae64106afa1$export$14a5903af8acddef)(row.inputs?.deployment, isCouple);
        const guaranteed = (0, $75f9bc5abce573de$export$816a4f32463eb868)(row, factFind);
        const moneyRows = [
            ...row.fundingBreakdown || [],
            ...(0, $86923a7f40531161$export$56004bc8d68e8454)(row.inputs?.deployment),
            ...(row.fundingCgt ?? 0) > 0 ? [
                {
                    label: 'Capital gains tax on the shares sold',
                    amount: row.fundingCgt ?? 0
                }
            ] : []
        ];
        const alt = (0, $835055d548f621e0$export$8096a1e5a8250ea8)(row, gfStrategies, (s)=>s.snapshot?.legacyValue ?? null, Number(localLegacyYears) || 10);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-3 text-[13.5px] text-slate-700",
            "data-testid": "gf-card-detail",
            children: [
                moneyRows.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "font-semibold text-slate-900",
                            children: "How it is paid for"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                            className: "mt-1 w-full tabular-nums",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: moneyRows.map((r, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "border-b border-slate-100",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-1",
                                                children: r.label
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-1 text-right",
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(Number(r.amount) || 0))
                                            })
                                        ]
                                    }, i))
                            })
                        })
                    ]
                }),
                row.description && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-slate-600",
                    children: row.description
                }),
                alt && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    "data-testid": "gf-alternative",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "text-slate-900",
                            children: alt.question
                        }),
                        " ",
                        alt.answer
                    ]
                }),
                terms && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6421482343679f4$export$d05c00195a7db941), {
                    terms: terms,
                    factFind: factFind,
                    quote: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6421482343679f4$export$624bbc9c6c5928), {
                                draft: gfAnnuityQuoteDraft,
                                onDraft: setGfAnnuityQuoteDraft,
                                committed: guaranteed ? (0, $da24031d156d6acb$export$2ee327201b9e82a1)(gfAnnuityQuote, guaranteed.annuityType, guaranteed.residualPercent, guaranteed.amount) ?? null : null,
                                onCommit: (v)=>setGfAnnuityQuote(v != null && v > 0 && guaranteed ? {
                                        income: v,
                                        amount: guaranteed.amount,
                                        shape: (0, $da24031d156d6acb$export$f7e5360546f2cc73)(guaranteed.annuityType, guaranteed.residualPercent)
                                    } : null)
                            }),
                            gfAnnuityQuote && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-2 text-[12.5px] text-slate-600",
                                "data-testid": "gf-annuity-quote-note",
                                children: (0, $da24031d156d6acb$export$3c59a0c7e65b683b)(gfAnnuityQuote, (0, $f94e45ac645ae232$export$3dc27271f5d5c629))
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: ()=>setSeDeepDive({
                            projections: row.projections || [],
                            name: (0, $263fcb126ae0e669$export$bf2295610779f6b)(row, factFind).title,
                            id: row.id
                        }),
                    className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                    children: "See the year-by-year figures"
                })
            ]
        });
    };
    const homeUse = sellingHomeToFund ? 'sold' : gfInputs.keptHomeUse;
    const ownToday = Number(todayFinancials?.netWorth) || 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-[1320px] mx-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] text-slate-500",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setActivePage('Dashboard'),
                        className: "underline decoration-dotted underline-offset-2 hover:text-slate-800",
                        children: "Home"
                    }),
                    " \u203A Granny flat \u203A ",
                    crumb
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                className: "mt-2 text-[32px] font-bold leading-tight tracking-tight text-brand-navy",
                "data-testid": "gf-title",
                children: [
                    "Living with family: a granny flat for ",
                    voice.names
                ]
            }),
            step === 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-1 text-[15px] text-slate-600",
                children: [
                    "Three short steps: the arrangement, what it would mean for ",
                    voice.them,
                    ", and the ways to set it up."
                ]
            }),
            gfChosen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-2 text-[14px] text-slate-600",
                "data-testid": "gf-chosen-note",
                children: [
                    voice.Possessive,
                    " chosen plan: ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "text-slate-900",
                        children: gfChosen.inputs?.card?.words.title
                    }),
                    ".",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>{
                            setGfView('hub');
                            (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
                        },
                        className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                        "data-testid": "gf-go-to-plan-page",
                        children: [
                            "Go to ",
                            voice.possessive,
                            " granny flat plan"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $724b7566e2d97e1f$export$2e2bcd8739ae039), {
                step: step,
                onStep: goToStep,
                steps: stepDefs,
                ariaLabel: "Granny flat steps"
            }),
            step === 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-8",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c33fc2d17e5ab0e$export$2e2bcd8739ae039), {
                    factFind: factFind,
                    setFactFind: setFactFind,
                    reasonableValue: reasonableValueToday,
                    onNext: ()=>goToStep(2),
                    onReadGuide: ()=>openGuide('overview'),
                    onFamilyGuide: ()=>openGuide('guide')
                })
            }),
            step === 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-8",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5237a01799695368$export$2e2bcd8739ae039), {
                    factFind: factFind,
                    todayFinancials: todayFinancials,
                    stayPutLegacy: manualBaselineLegacy,
                    runway: stayPutRunway,
                    legacyYears: localLegacyYears,
                    reasonableValue: reasonableValueToday,
                    onLegacyYearsChange: setLegacyYears,
                    onBack: ()=>goToStep(1),
                    onNext: ()=>goToStep(3),
                    onReadGuide: ()=>openGuide('overview'),
                    onAssumptions: ()=>setActivePage('AssumptionsPage'),
                    onShowProjections: ()=>setShowStayPutProjections(true)
                })
            }),
            step === 3 && strategyMode !== 'manual' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-8",
                children: gfAsking ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdeb548393f050ad$export$2e2bcd8739ae039), {
                    factFind: factFind,
                    reasonableValue: reasonableValueToday,
                    firstRun: goals.gfLegacyYears == null || openedFresh,
                    onRun: (answers)=>{
                        const add = (0, $fdeb548393f050ad$export$cdf6ac86b6cfac7f)(answers);
                        setFactFind?.((prev)=>({
                                ...prev,
                                goals: {
                                    ...prev?.goals || {},
                                    ...add
                                }
                            }));
                        setLocalLegacyYears(answers.years);
                        setGfInputs((prev)=>({
                                ...prev,
                                keptHomeRent: answers.rentPerWeek,
                                keptHomeExpenses: answers.rentCosts,
                                keptHomeVacancy: answers.vacancyWeeks
                            }));
                        setNewMoneySkipped(true);
                        setGfAsking(false);
                        setStrategyMode('optimised');
                        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
                    },
                    onBuildYourOwn: ()=>{
                        openGfBlank();
                        setGfAsking(false);
                        setStrategyMode('manual');
                        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
                    },
                    onFamilyGuide: ()=>openGuide('guide'),
                    onCancel: goals.gfLegacyYears == null ? undefined : ()=>setGfAsking(false)
                }) : needsNewMoneyAnswer ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a08e2ea281a6041$export$2e2bcd8739ae039), {
                        onAnswer: answerNewMoneyProfile,
                        onSkip: ()=>setNewMoneySkipped(true),
                        contextLine: "Some of the plans invest the money a sale of the home frees."
                    })
                }) : needsTbcAnswer ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $216ea083fe16cb8b$export$2e2bcd8739ae039), {
                        name: (tbcPersonNeedingAnswer === 'partner' ? factFind?.partner?.firstName : factFind?.client?.firstName) || 'this person',
                        onAnswer: answerTbc,
                        onSkip: ()=>setTbcSkipped(true)
                    })
                }) : seLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $81c96376e6bb9658$export$2e2bcd8739ae039), {
                    title: "Testing the ways to set it up",
                    subtitle: "We're modelling each way of paying for the right and handling the home, and staying put, over the same years."
                }) : !gfSuggestions || gfStrategies.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-[14px] text-slate-600",
                    children: [
                        "We couldn't test the ways to set it up for this arrangement. ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "font-semibold text-brand-navy underline",
                            onClick: ()=>setStrategyMode('manual'),
                            children: "Build a plan yourself"
                        }),
                        " instead."
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $124fc1b7c2dbb105$export$2e2bcd8739ae039), {
                    notices: (()=>{
                        const chosenHere = gfChosen?.inputs?.card && gfStrategies.some((x)=>x.id === chosenIdNow);
                        if (chosenHere && gfChosen?.inputs?.card) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 border-l-4 border-l-emerald-500 bg-white px-5 py-4 shadow-card",
                            "data-testid": "gf-chosen-banner",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-[26px] leading-none text-emerald-500",
                                    "aria-hidden": true,
                                    children: "\u2713"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "min-w-0 flex-1 text-[14px] leading-relaxed text-slate-700",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                            className: "text-slate-900",
                                            children: [
                                                voice.you ? "You've" : `${voice.Names} have`,
                                                " chosen \u201C",
                                                gfChosen.inputs.card.words.title,
                                                "\u201D."
                                            ]
                                        }),
                                        ' ',
                                        "It's saved with ",
                                        voice.possessive,
                                        " file. Next, the family discussion guide, then a solicitor to put the agreement in writing."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>{
                                        setGfView('hub');
                                        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
                                    },
                                    className: "text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                    "data-testid": "gf-banner-plan-page",
                                    children: "Go to the granny flat plan"
                                })
                            ]
                        });
                        // A plan chosen from "every way tested" that needs the income-only confirmation first.
                        const held = heldSelectId ? gfStrategies.find((s)=>s.id === heldSelectId) : null;
                        const g = held ? (0, $75f9bc5abce573de$export$816a4f32463eb868)(held, factFind) : null;
                        if (held && g && setIncomeOnlyUnderstood) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-2 rounded-2xl border border-slate-200 bg-white p-5 shadow-card",
                            "data-testid": "gf-held-select",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-[14px] text-slate-700",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            className: "text-slate-900",
                                            children: (0, $263fcb126ae0e669$export$bf2295610779f6b)(held, factFind).title
                                        }),
                                        " has a guaranteed income where nothing comes back."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$4538b371a206da0c), {
                                    factFind: factFind,
                                    amount: g.amount,
                                    onChange: setIncomeOnlyUnderstood
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    size: "sm",
                                    onClick: ()=>selectEngineStrategy(held),
                                    disabled: engineIncomeOnlyHeld(held),
                                    "data-testid": "gf-held-select-button",
                                    children: "Choose this plan"
                                })
                            ]
                        });
                        return null;
                    })(),
                    factFind: factFind,
                    strategies: gfStrategies,
                    stayPut: gfStayPut,
                    recommended: gfRecommended,
                    setAside: gfSetAside,
                    horizonYears: Number(localLegacyYears) || 10,
                    ownToday: ownToday,
                    focus: optimisationFocus,
                    onFocus: setOptimisationFocus,
                    chosenId: chosenIdNow,
                    onChoose: selectEngineStrategy,
                    onExplain: (row)=>{
                        setExplainSeId(row.id ?? null);
                        setShowGfExplanation(true);
                    },
                    onRisks: (row)=>setRiskStrategy(row),
                    renderDetail: renderDetail,
                    onAllWays: ()=>setShowAllSeStrategies(true),
                    onChanges: ()=>{
                        setGfAsking(true);
                        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
                    },
                    onBuildYourOwn: (row)=>{
                        if (row) seedManualFrom(row);
                        else openGfBlank();
                        setStrategyMode('manual');
                        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
                    },
                    onAdvice: ()=>{
                        const row = gfStrategies.find((x)=>x.id === chosenIdNow);
                        if (row) generateGfSoa(row);
                    },
                    onFamilyGuide: ()=>openGuide('guide'),
                    onIncomeOnly: setIncomeOnlyUnderstood ?? undefined
                })
            }),
            step === 3 && strategyMode === 'manual' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $76543b97b38c81f2$export$2e2bcd8739ae039), {
                        factFind: factFind,
                        setFactFind: setFactFind,
                        horizonYears: Number(localLegacyYears) || 10,
                        startedFrom: manualStartedFrom,
                        customising: !!manualCustomisedFrom,
                        onClear: openGfBlank,
                        startOptions: [
                            ...gfGoalLeaders.slice(0, 3).map((l)=>({
                                    id: String(l.id),
                                    label: (0, $263fcb126ae0e669$export$bf2295610779f6b)(l, factFind).title
                                })),
                            {
                                id: 'blank',
                                label: 'A blank plan'
                            }
                        ],
                        onStartFrom: (id)=>{
                            if (id === 'blank') startBlankManualPlan();
                            else {
                                const row = gfStrategies.find((x)=>String(x.id) === id);
                                if (row) seedManualFrom(row);
                            }
                        },
                        form: manualForm,
                        onForm: (f)=>{
                            manualStash.current[manualForm] = {
                                amountPaid: $f34df9d62ff01218$var$num(gfInputs.amountPaid),
                                constructionCost: $f34df9d62ff01218$var$num(gfInputs.constructionCost)
                            };
                            const back = manualStash.current[f];
                            setManualForm(f);
                            setGfInputs((prev)=>({
                                    ...prev,
                                    justMovingIn: f === 'nothing',
                                    transferHome: f === 'home',
                                    // Cash comes back as it was, or starts at the limit; cash on top of a build or the home starts at nothing.
                                    amountPaid: f === 'nothing' ? 0 : back ? back.amountPaid : f === 'cash' ? Math.floor(Number(reasonableValueToday) || 0) : 0,
                                    constructionCost: f === 'build' ? back ? back.constructionCost : (0, $3c33fc2d17e5ab0e$export$be6ce8332e69af13)(factFind) === 'build' ? $f34df9d62ff01218$var$num(goals.gfKnownAmount) : 0 : 0,
                                    fundFrom: f === 'home' || f === 'nothing' ? 'savings' : prev.fundFrom,
                                    funding: {}
                                }));
                            noteManualChange(f === 'cash' ? 'Cash for the right' : f === 'build' ? 'A build paid for' : f === 'home' ? 'The home signed over' : 'Moving in, paying nothing');
                        },
                        cash: $f34df9d62ff01218$var$num(gfInputs.amountPaid),
                        onCash: (n)=>{
                            setField('amountPaid', n);
                            noteManualChange(`Cash \u{2192} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(n)}`);
                        },
                        build: $f34df9d62ff01218$var$num(gfInputs.constructionCost),
                        onBuild: (n)=>{
                            setField('constructionCost', n);
                            noteManualChange(`The build \u{2192} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(n)}`);
                        },
                        reasonableValue: Number(reasonableValueToday) || reasonableValue,
                        entryContribution: entryContribution,
                        interestValue: interestValue,
                        deprivation: deprivation,
                        homeUse: homeUse,
                        onHomeUse: (u)=>{
                            setGfInputs((prev)=>({
                                    ...prev,
                                    fundFrom: u === 'sold' ? 'sell_home' : 'savings',
                                    keptHomeUse: u === 'rented' ? 'rented' : 'vacant',
                                    funding: {},
                                    deployment: u === 'sold' ? prev.deployment : {}
                                }));
                            noteManualChange(u === 'sold' ? 'The home is sold' : u === 'rented' ? 'The home is kept and rented out' : 'The home is kept, empty');
                        },
                        rent: {
                            weekly: $f34df9d62ff01218$var$num(gfInputs.keptHomeRent),
                            costs: $f34df9d62ff01218$var$num(gfInputs.keptHomeExpenses),
                            vacancy: gfInputs.keptHomeVacancy
                        },
                        onRent: (patch)=>{
                            setGfInputs((prev)=>({
                                    ...prev,
                                    ...patch.weekly != null ? {
                                        keptHomeRent: patch.weekly
                                    } : {},
                                    ...patch.costs != null ? {
                                        keptHomeExpenses: patch.costs
                                    } : {},
                                    ...patch.vacancy != null ? {
                                        keptHomeVacancy: patch.vacancy
                                    } : {}
                                }));
                            noteManualChange('The rent, its costs and the weeks empty');
                        },
                        saleResidual: saleResidual,
                        deployment: deployment,
                        onDeployment: (d)=>{
                            setField('deployment', d);
                            noteManualChange('Where the money from the sale goes');
                        },
                        cashFromSavings: cashFromSavings,
                        fundingSuggested: fundingSuggested,
                        reserve: manualReserve,
                        funding: funding,
                        onFunding: (m)=>{
                            setField('funding', m);
                            noteManualChange('Where the money comes from');
                        },
                        cgtOverrides: fundingCgtOverrides,
                        onCgtOverrides: (o)=>setField('fundingCgtOverrides', o),
                        fundingShortfall: panelModel.fundingShortfall,
                        working: gfCalcWorking,
                        effect: {
                            cashflow: manualImpactReady && projections.length ? $f34df9d62ff01218$var$num(projections[0]?.netCashflow ?? projections[0]?.cashFlow) : null,
                            baseCashflow: todayFinancials ? $f34df9d62ff01218$var$num(stayPutProjections[0]?.netCashflow ?? todayFinancials.cashFlow) : null,
                            pension: manualImpactReady && after?.socialSecurity != null ? $f34df9d62ff01218$var$num(after.socialSecurity) : null,
                            basePension: todayFinancials ? $f34df9d62ff01218$var$num(todayFinancials.socialSecurity) : null,
                            legacy: manualImpactReady && projections.length ? $f34df9d62ff01218$var$num(legacyEstimate) : null,
                            baseLegacy: manualBaselineLegacy
                        },
                        lastChange: manualLastChange,
                        onExplain: ()=>{
                            setExplainSeId(null);
                            setShowGfExplanation(true);
                        },
                        onRisks: ()=>setRiskStrategy({
                                ...manualPlanView || {
                                    id: manualPlanId,
                                    name: 'Your granny flat arrangement'
                                },
                                __move: {
                                    propertyTransferred: propertyTransferred,
                                    entryContribution: entryContribution
                                }
                            }),
                        onChoose: chooseManualPlan,
                        chosen: manualChosen,
                        chooseHeld: manualIncomeOnlyHeld || !manualPlanView,
                        beforeChoose: manualIncomeOnly && setIncomeOnlyUnderstood ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$4538b371a206da0c), {
                            factFind: factFind,
                            amount: Number(deployment?.annuity) || 0,
                            onChange: setIncomeOnlyUnderstood,
                            action: "saving"
                        }) : undefined,
                        familyPanel: manualGuaranteed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
                            factFind: factFind,
                            personName: manualGuaranteed.personName,
                            amount: manualGuaranteed.amount,
                            kind: manualGuaranteed.kind,
                            incomeAYear: manualGuaranteed.incomeAYear,
                            rows: panelModel.projections,
                            horizonYears: Number(localLegacyYears) || 10,
                            testId: "gf-manual-family-panel"
                        }) : undefined,
                        onBackToPlans: ()=>{
                            setStrategyMode('optimised');
                            (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
                        },
                        onYearByYear: ()=>setSeDeepDive({
                                projections: panelModel.projections,
                                name: manualPlanView ? (0, $263fcb126ae0e669$export$bf2295610779f6b)(manualPlanView, factFind).title : 'Your granny flat arrangement'
                            }),
                        comparison: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "mt-3 border-t border-slate-200 pt-2 text-[13px] text-slate-700",
                            "data-testid": "gf-build-compare",
                            children: !manualComparison ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: runManualComparison,
                                className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                children: "Compare with the plan that leaves the most"
                            }) : manualComparison.loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-slate-500",
                                children: "Testing the ways to set it up\u2026"
                            }) : manualComparison.best ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    "The tested plan that leaves the most in ",
                                    voice.possessive,
                                    " estate, ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: (0, $263fcb126ae0e669$export$bf2295610779f6b)(manualComparison.best, factFind).title.replace(/^./, (c)=>c.toLowerCase())
                                    }),
                                    ", leaves ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round($f34df9d62ff01218$var$num(manualComparison.best.snapshot?.legacyValue))),
                                    " after about ",
                                    Number(localLegacyYears) || 10,
                                    " years",
                                    manualImpactReady && projections.length ? `, against ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round($f34df9d62ff01218$var$num(legacyEstimate)))} for this plan` : '',
                                    ". That doesn't make it right for ",
                                    voice.them,
                                    " \u2014 it's a comparison, not a switch."
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-slate-500",
                                children: "No other way of setting it up could be tested."
                            })
                        }),
                        debtCard: (0, $35f2741dc40fa45c$export$403bb596c20e48)(factFind).length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35f2741dc40fa45c$export$2e2bcd8739ae039), {
                            variant: "section",
                            factFind: factFind,
                            debtPayments: debtPayments,
                            setDebtPayments: (v)=>{
                                setDebtPayments(v);
                                noteManualChange('Debts cleared');
                            },
                            debtFunding: debtFunding,
                            setDebtFunding: setDebtFunding,
                            repaymentBasis: debtRepaymentBasis,
                            setRepaymentBasis: setDebtRepaymentBasis,
                            competingUseNote: "The money comes from the same assets that can pay for the right, so what is spent here reduces what is left to pay or build with."
                        }) : undefined
                    }),
                    manualChosen && manualPlanView && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-5 flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 border-l-4 border-l-emerald-500 bg-white px-5 py-4 shadow-card",
                        "data-testid": "gf-manual-chosen",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "min-w-0 flex-1 text-[14px] text-slate-700",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: "text-slate-900",
                                        children: [
                                            "This plan is saved with ",
                                            voice.possessive,
                                            " file as the chosen plan."
                                        ]
                                    }),
                                    " The advice document is written from it."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>{
                                    setGfView('hub');
                                    (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
                                },
                                className: "text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                children: "Go to the granny flat plan"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: generateManualSoa,
                                className: "rounded-lg bg-blue-600 px-4 py-2.5 text-[14px] font-semibold text-white hover:bg-blue-700",
                                "data-testid": "gf-manual-advice",
                                children: "Get the advice document \u2192"
                            })
                        ]
                    })
                ]
            }),
            showAllSeStrategies && gfSuggestions && (()=>{
                const stay = gfStayPut;
                const pick = (s)=>allSortBy === 'cashflow' ? $f34df9d62ff01218$var$num(s.snapshot?.netCashflow) : allSortBy === 'pension' ? $f34df9d62ff01218$var$num(s.snapshot?.pension) : $f34df9d62ff01218$var$num(s.snapshot?.legacyValue);
                const sorted = gfStrategies.filter((s)=>!isGfBaseline(s)).sort((a, b)=>pick(b) - pick(a));
                const signedCell = (d)=>d == null || Math.round(d) === 0 ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: `block text-[12px] ${d < 0 ? 'text-rose-700' : 'text-emerald-700'}`,
                        children: [
                            d < 0 ? "\u2212" : '+',
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(d)))
                        ]
                    });
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                    titleId: "gf-all-ways-title",
                    title: `Every way we tested, ${sorted.length}`,
                    eyebrow: `Against staying put, over about ${localLegacyYears} years`,
                    onClose: ()=>setShowAllSeStrategies(false),
                    size: "xl",
                    testId: "gf-all-ways-dialog",
                    flush: true,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap items-center justify-between gap-3 border-b border-slate-100 px-5 py-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-[14px] text-slate-700",
                                    children: [
                                        "Every way of setting up the arrangement we worked through for ",
                                        voice.them,
                                        ". The estate figure is what is left in ",
                                        voice.possessive,
                                        " estate; what is given to ",
                                        host,
                                        " is beside it, not lost."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "flex items-center gap-2 text-[13px] text-slate-600",
                                    children: [
                                        "Order by",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: allSortBy,
                                            onChange: (e)=>setAllSortBy(e.target.value),
                                            className: "rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-[13px]",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "legacy",
                                                    children: "In the estate"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "cashflow",
                                                    children: "Left over each year"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "pension",
                                                    children: "Age Pension"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "overflow-x-auto",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                className: "min-w-full text-[14px]",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "border-b border-slate-200 text-left text-[12px] font-semibold text-slate-500",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3",
                                                    children: "The plan"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3 text-right",
                                                    children: "In the estate"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                    className: "px-5 py-3 text-right",
                                                    children: [
                                                        "Given to ",
                                                        host
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3 text-right",
                                                    children: "Age Pension, a year"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3 text-right",
                                                    children: "Left over, first year"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        className: "tabular-nums",
                                        children: [
                                            stay && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100 bg-slate-50",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "px-5 py-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-semibold text-slate-900",
                                                                children: "Staying put \u2014 not entering the arrangement"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "mt-0.5 text-[12.5px] text-slate-500",
                                                                children: "What every plan is measured against."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(stay.snapshot?.legacyValue)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(stay.snapshot?.pension)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: $f34df9d62ff01218$var$num(stay.snapshot?.netCashflow) < 0 ? `short ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(-$f34df9d62ff01218$var$num(stay.snapshot?.netCashflow))}` : (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(stay.snapshot?.netCashflow)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3"
                                                    })
                                                ]
                                            }),
                                            sorted.map((s)=>{
                                                const isSel = s.id === chosenIdNow;
                                                const w = (0, $263fcb126ae0e669$export$bf2295610779f6b)(s, factFind);
                                                const cashNow = $f34df9d62ff01218$var$num(s.snapshot?.netCashflow);
                                                const gi = (0, $75f9bc5abce573de$export$816a4f32463eb868)(s, factFind);
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    className: `border-b border-slate-100 ${isSel ? 'bg-blue-50/60' : ''}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "px-5 py-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "font-semibold text-slate-900",
                                                                    children: w.title
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "mt-0.5 max-w-xl text-[12.5px] text-slate-500",
                                                                    children: w.sub
                                                                }),
                                                                gi?.incomeOnly && setIncomeOnlyUnderstood && !isSel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "mt-2 max-w-xl",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$4538b371a206da0c), {
                                                                        factFind: factFind,
                                                                        amount: gi.amount,
                                                                        onChange: setIncomeOnlyUnderstood
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "px-5 py-3 text-right font-semibold",
                                                            children: [
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(s.snapshot?.legacyValue),
                                                                signedCell(stay ? $f34df9d62ff01218$var$num(s.snapshot?.legacyValue) - $f34df9d62ff01218$var$num(stay.snapshot?.legacyValue) : null)
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "px-5 py-3 text-right",
                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $263fcb126ae0e669$export$172c8762bdedaa06)((0, $263fcb126ae0e669$export$ca60ec58f5352c3a)(s, factFind)))
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "px-5 py-3 text-right",
                                                            children: [
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(s.snapshot?.pension),
                                                                signedCell(stay ? $f34df9d62ff01218$var$num(s.snapshot?.pension) - $f34df9d62ff01218$var$num(stay.snapshot?.pension) : null)
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: `px-5 py-3 text-right ${cashNow < 0 ? 'text-rose-700' : ''}`,
                                                            children: cashNow < 0 ? `short ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(-cashNow)}` : (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(cashNow)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "whitespace-nowrap px-5 py-3 text-right",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "inline-flex gap-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                                                        variant: isSel ? 'secondary' : 'brand',
                                                                        size: "sm",
                                                                        disabled: !isSel && engineIncomeOnlyHeld(s),
                                                                        onClick: ()=>{
                                                                            selectEngineStrategy(s);
                                                                            setShowAllSeStrategies(false);
                                                                        },
                                                                        children: isSel ? 'Chosen' : 'Choose this plan'
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                                                        variant: "secondary",
                                                                        size: "sm",
                                                                        onClick: ()=>{
                                                                            setSeDeepDive({
                                                                                projections: s.projections || [],
                                                                                name: w.title,
                                                                                id: s.id
                                                                            });
                                                                            setShowAllSeStrategies(false);
                                                                        },
                                                                        children: "Year by year"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }, s.id || s.name);
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                });
            })(),
            showGfExplanation && (()=>{
                const plan = explainStrategy ?? manualPlanView;
                const recapModel = explainView ?? panelModel;
                const basePlan = explainStrategy ? gfStayPut : manualStayPutView;
                const horizon = Number(localLegacyYears) || 10;
                const story = plan ? (0, $263fcb126ae0e669$export$a92053e247f31e57)(plan, basePlan, factFind, horizon) : null;
                const g = (0, $75f9bc5abce573de$export$816a4f32463eb868)(plan, factFind);
                const compare = explainStrategy && g ? (0, $75f9bc5abce573de$export$31540525a196c11f)(explainStrategy, gfStrategies) : null;
                const rows = plan?.projections || [];
                const moneyStory = (0, $0fe89e03b6df746e$export$693cc3146baa3244)(rows).hasDeficit ? (0, $2ddaae90639b5011$export$bdea18f456fd84b)({
                    rows: rows,
                    factFind: factFind,
                    runway: (0, $0fe89e03b6df746e$export$464558962ff4a811)(rows, rows.length),
                    deposit: {
                        paid: 0,
                        refundTo: ''
                    },
                    horizonYears: horizon,
                    enteringName: factFind?.client?.firstName || 'The household',
                    spentOn: 'the granny flat'
                }) : null;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $12084f898a868747$export$2e2bcd8739ae039), {
                    eyebrow: "Explain this",
                    title: plan ? (0, $263fcb126ae0e669$export$bf2295610779f6b)(plan, factFind).title : 'Your granny flat arrangement',
                    intro: `Each line says what ${voice.they} do, and what that does to the numbers. "Staying put" means not entering the arrangement and changing nothing else.`,
                    onClose: ()=>{
                        setShowGfExplanation(false);
                        setExplainSeId(null);
                    },
                    footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        size: "sm",
                        onClick: ()=>{
                            setShowGfExplanation(false);
                            if (explainStrategy) setSeDeepDive({
                                projections: explainStrategy.projections || [],
                                name: (0, $263fcb126ae0e669$export$bf2295610779f6b)(explainStrategy, factFind).title,
                                id: explainStrategy.id
                            });
                            else setSeDeepDive({
                                projections: panelModel.projections,
                                name: 'Your granny flat arrangement'
                            });
                            setExplainSeId(null);
                        },
                        children: "See the year-by-year figures"
                    }),
                    children: story && plan && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4800816561106c2d$export$d053159fb36403b3), {
                        testId: "gf-explain-steps",
                        // What each piece IS, above what it does (owner, 24 Oct 2026).
                        leverKinds: (()=>{
                            const row = explainStrategy ?? manualPlanView;
                            const mv = row ? (0, $263fcb126ae0e669$export$ca60ec58f5352c3a)(row, factFind) : null;
                            return (0, $203e38d6e6c434f4$export$bac9d5a868c209ac)(explainStrategy ? String(explainStrategy.id || '') : manualPlanId, {
                                construction: mv?.construction,
                                amountPaid: mv?.amountPaid,
                                home: mv?.home
                            });
                        })(),
                        lines: [
                            ...story.steps.map((t, i)=>{
                                const sc = story.stepChanges[i];
                                return sc ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        sc.before,
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$8dd54625d22f0463), {
                                            change: sc.change,
                                            text: null
                                        })
                                    ]
                                }) : t;
                            }),
                            (0, $4800816561106c2d$export$4be361d56ef6ce0f)({
                                cashflow: story.cashflow,
                                baseCashflow: story.baseCashflow,
                                they: voice.they,
                                baseWord: 'staying put',
                                // Where a short year is drawn from, account by account, inside "Put together" (owner, 21–22 Oct 2026).
                                moneyStory: moneyStory ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    "data-testid": "gf-money-story-section",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ddaae90639b5011$export$1a915263dc5391f1), {
                                        story: moneyStory,
                                        testId: "gf-money-story"
                                    })
                                }) : null
                            })
                        ],
                        estate: story.estate,
                        baseEstate: story.baseEstate,
                        horizonYears: horizon,
                        baseWord: "staying put",
                        children: [
                            story.givenNote && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-1 text-[14px] leading-relaxed text-slate-600",
                                "data-testid": "gf-explain-given-note",
                                children: [
                                    story.givenNote,
                                    " It is with ",
                                    (0, $32bd8c8afa665e9e$export$d71f476d519c5ae3)(factFind),
                                    " \u2014 not lost, but no longer in ",
                                    voice.their,
                                    " estate."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2384f8e2c7bd0a38$export$2e2bcd8739ae039), {
                                model: recapModel,
                                firstName: factFind?.client?.firstName,
                                baselineLegacy: story.baseEstate,
                                legacyYears: localLegacyYears,
                                factFind: factFind,
                                piecesOnly: true
                            }),
                            g && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-5",
                                "data-testid": "gf-explain-family-section",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1c6c21ec44833357$export$cb63b5f03a3ae2c6), {
                                        children: [
                                            "If ",
                                            g.personName,
                                            " passes away"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-2",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
                                            factFind: factFind,
                                            personName: g.personName,
                                            amount: g.amount,
                                            kind: g.kind,
                                            incomeAYear: g.incomeAYear,
                                            rows: plan.projections || [],
                                            compareRows: compare?.projections || null,
                                            compareNote: compare ? (0, $75f9bc5abce573de$export$a5d7138b0effd291) : null,
                                            horizonYears: horizon,
                                            testId: "gf-explain-family-panel"
                                        })
                                    })
                                ]
                            }),
                            (()=>{
                                // The debts this plan keeps, and what the same plan with them paid off did ("<id>-clear-debt").
                                const isManual = !explainStrategy;
                                const fig = (p)=>({
                                        estate: Number(p?.snapshot?.legacyValue) || 0,
                                        pension: Number(p?.snapshot?.pension) || 0,
                                        cashflow: Number(p?.snapshot?.netCashflow) || 0
                                    });
                                const twin = isManual ? null : (gfStrategies || []).find((s)=>s.id === `${explainStrategy.id}-clear-debt`) ?? null;
                                const cleared = isManual ? Object.values(debtPayoffPlan?.payments || {}).reduce((t, x)=>t + (Number(x) || 0), 0) : /-clear-debt$/.test(String(explainStrategy.id)) ? (0, $fe4e1ee5e30419ba$export$abbf1dec1caebd5a)(factFind) : 0;
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe4e1ee5e30419ba$export$2e2bcd8739ae039), {
                                    factFind: factFind,
                                    clearedAmount: cleared,
                                    plan: fig(plan),
                                    twin: twin ? fig(twin) : null,
                                    years: horizon,
                                    context: isManual ? 'manual' : 'tested'
                                });
                            })(),
                            plan && (0, $263fcb126ae0e669$export$ca60ec58f5352c3a)(plan, factFind).home === 'rented' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a8295193c5be8a0$export$2e2bcd8739ae039), {
                                horizonYears: Number(localLegacyYears) || 10,
                                they: voice.they
                            }),
                            plan && (0, $5fe2dfde2f334213$export$4abd1e21404204e)((0, $263fcb126ae0e669$export$bf2295610779f6b)(plan, factFind).sub) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd95277538ec3233$export$2e2bcd8739ae039), {
                                factFind: factFind
                            })
                        ]
                    })
                });
            })(),
            riskStrategy && (()=>{
                const m = (0, $263fcb126ae0e669$export$ca60ec58f5352c3a)(riskStrategy, factFind);
                const kinds = riskStrategy.__kinds ?? (0, $203e38d6e6c434f4$export$bac9d5a868c209ac)(String(riskStrategy.id || ''), {
                    construction: m.construction,
                    amountPaid: m.amountPaid,
                    home: m.home
                });
                const move = riskStrategy.__move ?? {
                    propertyTransferred: m.propertyTransferred,
                    entryContribution: m.entryContribution
                };
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5757b380cc124794$export$2e2bcd8739ae039), {
                    voice: voice,
                    strategyName: riskStrategy.inputs ? (0, $263fcb126ae0e669$export$bf2295610779f6b)(riskStrategy, factFind).title : riskStrategy.name || '',
                    onClose: ()=>setRiskStrategy(null),
                    risks: risksFor(kinds, move, $f34df9d62ff01218$var$gfAnnuityHorizonWarningOf(riskStrategy, factFind), Number(riskStrategy.inputs?.deployment?.ipStampDuty) || null)
                });
            })(),
            showStayPutProjections && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9847d752f8df838f$export$2e2bcd8739ae039), {
                onClose: ()=>setShowStayPutProjections(false),
                title: "Staying put \u2014 not entering the arrangement",
                comparedOverYears: Number(localLegacyYears) || undefined,
                projections: stayPutProjections,
                factFind: factFind,
                initialFinancials: todayFinancials ?? before,
                costLabel: null
            }),
            seDeepDive && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9847d752f8df838f$export$2e2bcd8739ae039), {
                onClose: ()=>setSeDeepDive(null),
                title: seDeepDive.name,
                comparedOverYears: Number(localLegacyYears) || undefined,
                projections: modalPeriodMode === 'calendar_year' && calendarYearProjections ? calendarYearProjections : seDeepDive.projections,
                ...deepDiveCandidate ? {
                    onPeriodModeChange: setModalPeriodMode,
                    isReloading: modalPeriodMode === 'calendar_year' && !calendarYearProjections
                } : {},
                factFind: factFind,
                initialFinancials: todayFinancials ?? before,
                costLabel: null
            })
        ]
    });
};
const $f34df9d62ff01218$var$GrannyFlatPage = ({ setActivePage: setActivePage, factFind: factFind, savedStrategies: savedStrategies, setSavedStrategies: setSavedStrategies, setFactFind: setFactFind, onSoaGenerated: onSoaGenerated })=>{
    /*
   * WHERE THE PAGE OPENS (review, 18 Oct 2026). Home's "Open the guide" and the action plan's "Solicitor
   * brief" / "Family discussion guide" hand a section over in sessionStorage (openGrannyFlatSection); read
   * once, on mount, then cleared. Otherwise the plan page, once a plan is chosen, else step 1.
   */ const [opening, setOpening] = (0, $acw62.useState)(()=>(0, $32bd8c8afa665e9e$export$8e5959f9bd823cc2)());
    /** Bumped to start the module over: remounts the analyser, so nothing half-entered survives. */ const [startKey, setStartKey] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
    }, []);
    /*
   * CHOOSING "Granny flat" IN THE MENU FROM INSIDE THE MODULE RETURNS TO THE START (review, 18 Oct 2026): the
   * layout fires PAGE_RESELECTED_EVENT (see gfPresentation.ts). A section handed over at the same moment wins.
   */ (0, $acw62.useEffect)(()=>{
        const onReselect = (e)=>{
            const page = e.detail?.page;
            if (page && page !== 'GrannyFlatPage') return;
            setOpening((0, $32bd8c8afa665e9e$export$8e5959f9bd823cc2)());
            setStartKey((k)=>k + 1);
            (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
        };
        window.addEventListener((0, $32bd8c8afa665e9e$export$f629769d5dbca664), onReselect);
        return ()=>window.removeEventListener((0, $32bd8c8afa665e9e$export$f629769d5dbca664), onReselect);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f34df9d62ff01218$var$GrannyFlatAnalyser, {
        setActivePage: setActivePage,
        factFind: factFind,
        savedStrategies: savedStrategies,
        setSavedStrategies: setSavedStrategies,
        setFactFind: setFactFind,
        onSoaGenerated: onSoaGenerated,
        opening: opening
    }, `analyser-${startKey}`);
};
var $f34df9d62ff01218$export$2e2bcd8739ae039 = $f34df9d62ff01218$var$GrannyFlatPage;


/**
 * The downsizing module (rebuild, 21 Oct 2026; docs/ux-review/modules/dz/mockup, the village as template).
 *
 * Three steps and a plan page, as the village: (1) the sale and the new home — buy or rent, the price or "test
 * a range", the state and its stamp duty; (2) what it means for them — staying put in four numbers, and the
 * trap in their figures; (3) the ways to use the money — five questions before the first run, then the tested
 * plans on the three levers against staying put, with "Build a plan yourself" (the ledger) one link away.
 * Choosing a plan puts it on record (dzChosenPlan.ts) and the module then opens on its plan page (DzHub), with
 * "Model another home" carrying everything over. The engine and its candidates are unchanged
 * (downsizerScenario.tsx); the advice document (dzSoa.ts) reads the same words and figures.
 */ 



var $acw62 = parcelRequire("acw62");





/**
 * The downsizer Statement of Advice, in the shared document's shape (features/advice/moduleSoa.ts).
 * Quotes the strategy's own snapshot, projections and proceeds breakdown, and the stay-put
 * candidate's, as the card shows them.
 */ 



/**
 * "What could go wrong" for a downsizing plan (downsizing rebuild, 21 Oct 2026; the agreed mock-up's d-risks).
 *
 * The shared list (strategyRisks.ts) with the points that are about THIS plan put right:
 *   - the stamp duty on the new home is said as the new home's ("recovered only if the new home grows by at
 *     least that much"), not a property bought with the proceeds;
 *   - "the money is no longer exempt … so the pension can fall" is said only where the plan frees money that
 *     is counted. A plan that puts the whole sale into the new home frees nothing (review defect: it was said
 *     on a plan whose pension rises by $10,252);
 *   - buying and selling rarely line up: the 24-month exemption, and that a gap means bridging or renting.
 */ 
const $29500f2a86f5f83f$var$money = (n)=>`$${Math.round(n).toLocaleString('en-AU')}`;
function $29500f2a86f5f83f$export$60e4d14b8d823b60({ kinds: kinds, move: move, ipStampDuty: ipStampDuty, horizonWarning: horizonWarning }) {
    const base = (0, $203e38d6e6c434f4$export$124603ee0434ece5)(kinds, {
        horizonWarning: horizonWarning ?? null
    });
    const forYou = [
        ...base.forYou
    ];
    if (move && !move.sellAndRent && move.stampDuty > 0) forYou.push({
        icon: 'receipt',
        lead: `${$29500f2a86f5f83f$var$money(move.stampDuty)} of stamp duty is paid on day one.`,
        body: 'It is recovered only if the new home grows by at least that much.'
    });
    // A dearer home is paid partly from savings: that money becomes part of the home, hard to reach if costs rise
    // (live review, 22 Oct 2026 — the plan moved $476,847 into the house and nothing said so).
    if (move && !move.sellAndRent && (move.buyUpShortfall ?? 0) >= 1) forYou.push({
        icon: 'lock',
        lead: `${$29500f2a86f5f83f$var$money(move.buyUpShortfall ?? 0)} of savings goes into the home.`,
        body: 'It is no longer money to draw on: if costs rise or care is needed, it comes back only by selling or borrowing against the home.'
    });
    if (ipStampDuty != null && ipStampDuty > 0) forYou.push({
        icon: 'receipt',
        lead: `${$29500f2a86f5f83f$var$money(ipStampDuty)} of stamp duty on the investment property.`,
        body: 'It comes out of the money the sale frees, and is only recovered if the property grows by at least that much.'
    });
    const freesNothing = !!move && !move.sellAndRent && move.freedCapital < 1;
    const sections = base.sections.map((s)=>{
        if (s.kind !== 'sellHome' || !move) return s;
        const points = s.points.filter((p)=>!(freesNothing && p.icon === 'landmark'));
        if (!move.sellAndRent && move.newHomePrice > 0) points.push({
            icon: 'clock',
            lead: "Buying and selling don't line up.",
            body: 'Money set aside for the new home is exempt for up to 24 months, but a gap means bridging or renting.'
        });
        return {
            ...s,
            points: points
        };
    });
    return {
        forYou: forYou,
        sections: sections
    };
}
function $29500f2a86f5f83f$export$ff22458321af692(id, inputs) {
    const kinds = [
        ...(0, $203e38d6e6c434f4$export$c301be208b2d16d)(id)
    ];
    const add = (k)=>{
        if (!kinds.includes(k)) kinds.push(k);
    };
    const d = inputs || {};
    const dep = d.deployment || {};
    const n = (v)=>Number(v) || 0;
    if (n(d.salePrice) > 0) add('sellHome');
    if (d.rentInstead === true) add('sellAndRent');
    if (n(d.downsizerContribution) + n(d.partnerDownsizerContribution) + n(dep.superContribution) + n(dep.partnerSuperContribution) > 0) add('superContribution');
    if (d.commenceIncomeStream === true || dep.superCommenceIncomeStream === true) add('accountBasedPension');
    if (n(dep.annuity) > 0 && !kinds.some((k)=>k.startsWith('annuity'))) add(dep.annuityType === 'guaranteed' ? 'annuityGuaranteed' : n(dep.annuityResidualPercent) > 0 ? 'annuityReturned' : 'annuityNil');
    if (n(dep.investmentProperty) > 0) add('investmentProperty');
    if (n(dep.shares) > 0) add('shares');
    if (n(dep.investmentBond) > 0) add('investmentBond');
    if (n(d.funeralBondPurchase) > 0) add('funeralBond');
    if (n(d.giftingAmount) > 0) add('gift');
    return kinds.filter((k)=>k !== 'stayPut');
}




/**
 * Downsizer / Downsizing MODULE scenario + suggestion logic.
 *
 * Reuses the validated downsize mutator (applyDownsizeToFactFind: new home purchase, downsizer-to-super,
 * gifting, debt repayment, residual to bank) and the shared projection engine, so the module's numbers
 * match the sell-home paths already used across Aged Care / Support at Home / Retirement Village.
 *
 * Domain notes (current law, verified Jun 2026; surfaced as advice in the UI):
 *  - Downsizer super contribution: 55+, up to $300k per person ($600k couple) from a main residence owned
 *    10+ years, within 90 days of settlement; doesn't count to contribution caps. (DOWNSIZER_CONTRIBUTION_CAP)
 *  - Selling an exempt home converts equity into assessable assets — the Age-Pension "downsizing trap".
 *  - Home-sale proceeds you intend to use for a new home are EXEMPT from the assets test for up to 24 months
 *    (extendable to 36), and deemed at the LOWER rate during that period. This is a TRANSITIONAL rule between
 *    selling and buying; the module models the post-downsize STEADY STATE (new home exempt, freed capital
 *    deployed) and explains the transitional exemption in the insight panel.
 */ 
















/**
 * The sale arithmetic and the stamp duty state, in one place for the whole downsizing module
 * (review of John and Kerry's file, 18 Oct 2026).
 *
 * ONE HELPER FOR THE MONEY FREED UP. Manual Control took the duty off its "net proceeds" and the
 * Strategy Analysis Setup did not, so the same home showed two different amounts freed up. Every
 * screen now reads these figures: the sale nets the price less the selling costs; the new home and
 * its duty come out of that; what is left is freed up, and what is short has to come from savings.
 *
 * THE STATE THE NEW HOME IS IN. With no state the duty was nil, which made a $3.2m purchase look
 * $273,000 better than it is in New South Wales. The setup's own answer wins; where it has none,
 * the state already recorded for this household is used, so the duty is charged from the start.
 */ 
const $6b146b31ad2b1e77$var$num = (v)=>{
    const n = typeof v === 'number' ? v : parseFloat(String(v ?? ''));
    return Number.isFinite(n) ? n : 0;
};
function $6b146b31ad2b1e77$export$855cd09595261b3b(input) {
    const salePrice = Math.max(0, $6b146b31ad2b1e77$var$num(input.salePrice));
    const sellingCosts = Math.max(0, $6b146b31ad2b1e77$var$num(input.sellingCosts));
    const newHomePrice = input.sellAndRent ? 0 : Math.max(0, $6b146b31ad2b1e77$var$num(input.newHomePrice));
    const stampDuty = !input.sellAndRent && newHomePrice > 0 ? Math.max(0, $6b146b31ad2b1e77$var$num(input.stampDuty)) : 0;
    const netProceeds = Math.max(0, salePrice - sellingCosts);
    return {
        netProceeds: netProceeds,
        stampDuty: stampDuty,
        freedCapital: Math.max(0, netProceeds - newHomePrice - stampDuty),
        buyUpShortfall: input.sellAndRent ? 0 : Math.max(0, newHomePrice + stampDuty - netProceeds)
    };
}
function $6b146b31ad2b1e77$export$a8a5bac4bde49384(state, price, use = 'home') {
    return (0, $30ff538d4b47bf21$export$765ba460decf7858)(state ?? '', price, use) ?? 0;
}
const $6b146b31ad2b1e77$var$stateOrNull = (v)=>{
    const s = typeof v === 'string' ? v.trim().toUpperCase() : '';
    return s && (0, $30ff538d4b47bf21$export$96fdbeb3c760993a)(s) ? s : null;
};
function $6b146b31ad2b1e77$export$c4b416b99a9a4a71(factFind) {
    const ff = factFind || {};
    const goals = ff.goals || {};
    const client = ff.client || {};
    const village = ff.retirementVillage || {};
    const appData = ff.__appData || {};
    const couple = appData.coupleValidation || {};
    return $6b146b31ad2b1e77$var$stateOrNull(goals.dzNewHomeState) ?? $6b146b31ad2b1e77$var$stateOrNull(client.state) ?? $6b146b31ad2b1e77$var$stateOrNull(client.addressState) ?? $6b146b31ad2b1e77$var$stateOrNull(village.state) ?? $6b146b31ad2b1e77$var$stateOrNull(goals.rvPurchaseState) ?? $6b146b31ad2b1e77$var$stateOrNull(goals.gfPurchaseState) ?? $6b146b31ad2b1e77$var$stateOrNull(couple.newHomeState) ?? '';
}


function $d50f5b54e8b24258$var$zeroCareCosts(scenarioLivingExpenses) {
    return {
        totalDailyCost: 0,
        dailyAccommodationPayment: 0,
        basicDailyFee: 0,
        dailyNCCC: 0,
        dailyHSC: 0,
        dailyExtraServiceFee: 0,
        scenarioLivingExpenses: scenarioLivingExpenses
    };
}
async function $d50f5b54e8b24258$export$2a669b0fe6cbdea6(factFind, details) {
    const before = await $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind);
    const simulated = (0, $41978d8498e37f65$export$e9de74ff7fc60a05)(factFind, details);
    const after = await $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(simulated);
    return {
        before: before,
        after: after,
        simulated: simulated
    };
}
async function $d50f5b54e8b24258$export$98e4e1c36d3d9b78(simulatedFactFind, options = {}) {
    const legacyYears = options.legacyYears || 10;
    const scenarioLivingExpenses = parseFloat(String(simulatedFactFind?.expenses?.livingExpenses ?? '')) || 0;
    const result = await $55a1d8a64f1e5dfa$export$75699a59a86ef1ab(simulatedFactFind, {
        scenarioLivingExpenses: scenarioLivingExpenses,
        ...options.inflationAssumptionPct != null ? {
            inflationAssumptionPct: options.inflationAssumptionPct
        } : {},
        // Dated: the engine sells, buys and allocates ON the day — see RunProjectionsOptions.
        ...options.downsizeDate && options.downsizeDetails ? {
            downsizeEvent: {
                date: options.downsizeDate,
                details: options.downsizeDetails
            }
        } : {},
        ...options.debtPayoff ? {
            debtPayoff: options.debtPayoff
        } : {}
    }, $d50f5b54e8b24258$var$zeroCareCosts(scenarioLivingExpenses), legacyYears);
    return result;
}
function $d50f5b54e8b24258$export$f6a66feacdeaef0e(factFind, setup) {
    const raw = Number(setup?.emergencyReserve);
    return setup?.emergencyReserve != null && Number.isFinite(raw) && raw >= 0 ? raw : (0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind);
}
const $d50f5b54e8b24258$export$b8aa11d632815bd4 = 25;
const $d50f5b54e8b24258$export$6820740a12e5e2b9 = 50000;
/** The minimum credible lifetime annuity purchase. */ const $d50f5b54e8b24258$var$DZ_ANNUITY_MIN = 25000;
function $d50f5b54e8b24258$export$5c3c91479c40bfc2(setup) {
    const raw = Number(setup?.annuityShareCapPct);
    if (!Number.isFinite(raw) || setup?.annuityShareCapPct == null) return $d50f5b54e8b24258$export$b8aa11d632815bd4;
    return Math.min(100, Math.max(0, raw));
}
function $d50f5b54e8b24258$export$9fe8a2b95ef5f52(factFind, fallback = {}) {
    // dzCashflowTarget is read ahead of its schema key (server/src/shared/factFindSchema.ts goals):
    // until the key exists it is never written, so this reads 0 — the bills paid — as before.
    const goals = factFind?.goals || {};
    const savedReserve = goals.dzEmergencyReserve != null && Number.isFinite(Number(goals.dzEmergencyReserve)) && Number(goals.dzEmergencyReserve) >= 0 ? Number(goals.dzEmergencyReserve) : null;
    const housing = goals.dzHousing === 'buy' || goals.dzHousing === 'rent' || goals.dzHousing === 'both' ? goals.dzHousing : fallback.housing ?? 'buy';
    const motive = goals.dzMotive === 'money' || goals.dzMotive === 'home' || goals.dzMotive === 'both' ? goals.dzMotive : 'both';
    // The guaranteed income answers are the CLIENT's (annuityPreferenceOf / annuityCeilingOf), read by the
    // generator from the file itself, so they are not copied into the setup (guaranteed income review, 21 Oct 2026).
    return {
        motive: motive,
        housing: housing,
        newHomePrice: Number(goals.dzNewHomePrice) > 0 ? Number(goals.dzNewHomePrice) : fallback.newHomePrice ?? 0,
        // The setup's own answer, else Manual Control's, else the state the file already records
        // for this household (review, 18 Oct 2026: no state meant no duty, and a misleading leader).
        newHomeState: typeof goals.dzNewHomeState === 'string' && goals.dzNewHomeState.trim() !== '' ? goals.dzNewHomeState : fallback.newHomeState || (0, $6b146b31ad2b1e77$export$c4b416b99a9a4a71)(factFind),
        rentPerWeek: Number(goals.dzRentPerWeek) > 0 ? Number(goals.dzRentPerWeek) : fallback.rentPerWeek ?? 0,
        // The module's older share answer, kept only as the fallback annuityCeilingOf reads.
        annuityShareCapPct: goals.dzAnnuityShareCapPct != null && Number.isFinite(Number(goals.dzAnnuityShareCapPct)) && Number(goals.dzAnnuityShareCapPct) > 0 ? Number(goals.dzAnnuityShareCapPct) : null,
        // ONE RULE FOR "COVERS THE COSTS" (owner, 23 Oct 2026): money in at least matches money out, as aged care has always used; no module asks for a margin.
        cashflowTarget: 0,
        emergencyReserve: savedReserve
    };
}
const $d50f5b54e8b24258$export$2cbcd11218125c86 = (s)=>!!s && s.sensitivity === true;
function $d50f5b54e8b24258$export$395a7db7b95be5d3(id) {
    const raw = String(id ?? '');
    const debt = /-clear-debt$/.test(raw) ? '-clear-debt' : '';
    const bare = raw.replace(/-clear-debt$/, '');
    const m = /^(dz(?:-rent)?(?:-super)?)-annuity(?:-max)?(?:-rcv|-guaranteed)?$/.exec(bare);
    return m ? `${m[1]}-invest${debt}` : null;
}
/** Short money for a candidate name — "$1.2m", "$840k" — so a card title stays scannable. */ function $d50f5b54e8b24258$var$formatRough(amount) {
    const n = Math.max(0, Math.round(amount));
    if (n >= 1000000) return `$${(n / 1000000).toFixed(n % 1000000 === 0 ? 0 : 1)}m`;
    if (n >= 1000) return `$${Math.round(n / 1000)}k`;
    return `$${n.toLocaleString('en-AU')}`;
}
/**
 * What could actually be drawn on to top up a dearer purchase.
 *
 * A "buy up" candidate the client cannot fund is not a strategy, so the dearer option is only
 * offered where the money exists. Deliberately excludes the home itself, which is being sold.
 */ function $d50f5b54e8b24258$var$accessibleLiquidFor(factFind) {
    const assets = factFind.assets || {};
    const sum = (list)=>(list || []).reduce((total, item)=>total + (parseFloat(String(item?.value)) || 0), 0);
    return sum(assets.bankAccounts) + sum(assets.termDeposits) + sum(assets.shares) + sum(assets.accountBasedPensions);
}
const $d50f5b54e8b24258$var$money = (n)=>n.toLocaleString('en-AU', {
        style: 'currency',
        currency: 'AUD',
        maximumFractionDigits: 0
    });
function $d50f5b54e8b24258$export$a230187ca30d6754(factFind, options = {}) {
    const carriedHomeValue = parseFloat(String(factFind?.home?.value ?? '')) || 0;
    // The adviser's OWN sale figures, where entered. The candidates must play with the same numbers
    // the manual inputs use, or the two modes model different sales of the same home.
    const ciSalePrice = parseFloat(String(options.currentInputs?.salePrice ?? '')) || 0;
    const homeValue = ciSalePrice > 0 ? ciSalePrice : carriedHomeValue;
    if (!(homeValue > 0)) return [];
    const ff = factFind;
    const isCouple = factFind?.adviceFor === 'couple';
    const clientAge = factFind?.client?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.client.dob) : null;
    const partnerAge = isCouple && factFind?.partner?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind.partner.dob) : null;
    // A downsizer contribution needs a qualifying SALE (55+, ten years' ownership, within 90 days
    // of settlement) — never a purchase, so the rent route offers it too.
    const downsizerEligible = clientAge != null && clientAge >= 55 || partnerAge != null && partnerAge >= 55;
    const ciSellingCosts = parseFloat(String(options.currentInputs?.sellingCosts ?? ''));
    const sellingCosts = Number.isFinite(ciSellingCosts) && ciSellingCosts >= 0 ? Math.round(ciSellingCosts) : Math.round(homeValue * 0.025);
    const ci = options.currentInputs;
    const ciNewHomePrice = parseFloat(String(ci?.newHomePurchasePrice ?? '')) || 0;
    const ciRents = ci?.rentInstead === true;
    const setup = options.setup ?? {};
    const intended = Math.round(Number(setup.newHomePrice) > 0 ? Number(setup.newHomePrice) : Number(options.intendedNewHomePrice) || 0);
    /*
     * The price everything else is built around: what they told us they intend to buy, else what is
     * already entered in Manual Control, else the old 70% assumption.
     */ const newHomeDefault = intended > 0 ? intended : ci && ciNewHomePrice > 0 && !ciRents ? Math.round(ciNewHomePrice) : Math.round(homeValue * 0.7);
    /*
     * THE DUTY ON THE NEW HOME (owner, 23 Sep 2026). A cost of the changeover the candidates never
     * charged. For the price the client named, the figure on their screen — estimated from the state
     * or overwritten from a quote; for the price ladder's other prices, struck from the same state's
     * scale, since a quote for one price says nothing about another. No state, no duty.
     */ const newHomeState = String(typeof setup.newHomeState === 'string' && setup.newHomeState || ci?.newHomeState || '');
    const ciStampDuty = parseFloat(String(ci?.stampDuty ?? '')) || 0;
    const dutyFor = (newHome)=>(0, $30ff538d4b47bf21$export$765ba460decf7858)(newHomeState, newHome) ?? 0;
    const dutyAt = (newHome)=>newHome === newHomeDefault && ciStampDuty > 0 && !ciRents ? ciStampDuty : dutyFor(newHome);
    const netProceeds = Math.max(0, homeValue - sellingCosts);
    const freedBuying = (newHome)=>Math.max(0, homeValue - sellingCosts - dutyAt(newHome) - newHome);
    /** What has to come from savings when the new home and its duty cost more than the sale nets. */ const topUpNeeded = (newHome)=>Math.max(0, newHome + dutyAt(newHome) - netProceeds);
    /*
     * THE EMERGENCY RESERVE (owner, 2 Oct 2026). The village and aged care engines keep
     * max(6 months' expenses, $50,000) in the bank before deploying anything; the downsizer
     * deployed every dollar. The reserve is a HOUSEHOLD floor: what the bank already holds counts
     * towards it, and only the shortfall is held back from the proceeds (it lands in the bank with
     * the rest of the residue — the event banks whatever is not deployed).
     */ const bankToday = (factFind.assets?.bankAccounts || []).reduce((s, a)=>s + (parseFloat(String(a?.value)) || 0), 0);
    // The client's own answer where given (step 3), else our suggestion — the same figure as before.
    const reserve = $d50f5b54e8b24258$export$f6a66feacdeaef0e(factFind, setup);
    const reserveTopUp = Math.max(0, reserve - bankToday);
    const housing = setup.housing === 'rent' || setup.housing === 'both' || setup.housing === 'buy' ? setup.housing : ciRents ? 'rent' : 'buy';
    const motive = setup.motive === 'money' || setup.motive === 'home' ? setup.motive : 'both';
    /** A buy-up's top-up, drawn from savings in the usual order with the reserve kept in the bank. */ const buyUpFundingFor = (topUp)=>(0, $70f4a8eac5c2154b$export$c0f19f0b2aa7e069)(factFind, topUp, [
            'bankAccounts',
            'termDeposits',
            'shares',
            'accountBasedPensions'
        ], reserve);
    const fundedOf = (map)=>Object.values(map).reduce((sum, v)=>sum + (Number(v) || 0), 0);
    const rentPerWeek = Math.max(0, Number(setup.rentPerWeek) > 0 ? Number(setup.rentPerWeek) : Number(ci?.rentPerWeek) || 0);
    const routes = housing === 'both' ? [
        'buy',
        'rent'
    ] : [
        housing
    ];
    /*
     * THE CLIENT'S GUARANTEED INCOME ANSWER (guaranteed income review, 21 Oct 2026): "no" builds no
     * annuity candidate at all; "yes, if the money goes back" (and an unanswered profile) builds the
     * types that return the money — money back in the early years, and the full amount back at any time
     * where the client may buy it; "yes, and the most income" adds income only. Read from the CLIENT
     * RECORD, the same answer every other module reads (annuityPreference.ts). A setup override is read
     * through the same normaliser, so an older value ('both', 'returned', 'nil', 'guaranteed') keeps the
     * meaning annuityPreferenceOf gives it.
     */ const preference = (0, $ff5de4128b46b139$export$636a9065c3f862c1)({
        ...ff,
        goals: {
            ...ff?.goals || {},
            ...setup.annuityAppetite ? {
                annuityAppetite: setup.annuityAppetite
            } : {},
            ...setup.annuityResidual ? {
                annuityResidual: setup.annuityResidual
            } : {}
        }
    });
    const appetite = preference.appetite;
    // The ceiling: the client's own "at most" answer wins inside annuitySizesFor (annuityCeilingOf); this
    // module's older share answer, else a quarter, is the fallback.
    const annuityCapPct = appetite === 'none' ? 0 : $d50f5b54e8b24258$export$5c3c91479c40bfc2(setup);
    const annuityShapes = [
        // Income only: built only when the client asked for the most income, even if nothing goes back.
        ...(0, $ff5de4128b46b139$export$b8876d0a37b8526a)(preference, 0) ? [
            {
                suffix: '',
                name: 'nil residual',
                type: 'lifetime',
                residual: 0,
                words: 'This type is income only: it pays the most income, and nothing of the purchase price goes back to the family, even after an early death.'
            }
        ] : [],
        ...(0, $ff5de4128b46b139$export$b8876d0a37b8526a)(preference, 1) ? [
            {
                suffix: '-rcv',
                name: 'capital returned',
                type: 'lifetime',
                residual: 100,
                words: 'This type pays the money back in the early years: the whole purchase price goes to the family on a death in about the first half of life expectancy, then a smaller amount, falling to nothing. It pays less income, and Centrelink still counts only 60% either way.'
            }
        ] : [],
        // Only where the client is in, or entering, government-subsidised care: the product is not sold to anyone else.
        ...(0, $ff5de4128b46b139$export$623904c9366cf5a0)(preference, ff) ? [
            {
                suffix: '-guaranteed',
                name: 'full amount guaranteed',
                type: 'guaranteed',
                residual: 100,
                words: 'This type pays the full amount back at any time: a guaranteed income combined with life cover, so the whole purchase price goes to the family whenever death comes. It pays the least income, and only the income part earns the 60% assets-test treatment.'
            }
        ] : []
    ];
    const annuityDeployment = (amount, shape, rest)=>({
            annuity: amount,
            // The guaranteed shape (annuity + life policy) is its own product; the two plain shapes differ only in residual.
            ...shape.type === 'guaranteed' ? {
                annuityType: 'guaranteed'
            } : {
                annuityType: 'lifetime'
            },
            annuityResidualPercent: shape.residual,
            // A quote belongs to one type and amount: the same type uses it scaled to this amount, another keeps our estimate.
            annuityIncomeOverride: (0, $da24031d156d6acb$export$2ee327201b9e82a1)(options.annuityQuote, shape.type, shape.residual, amount),
            ...rest > 0 ? {
                shares: rest
            } : {}
        });
    /** The property a budget buys once its stamp duty is paid, with the rent struck on the PRICE (the village's rule). */ const purchaseState = (0, $30ff538d4b47bf21$export$96fdbeb3c760993a)(newHomeState) ? newHomeState : undefined;
    const propertyFor = (budget)=>{
        // Investor rates; the firm's yield, two weeks empty, 8% agent and 1% upkeep (investmentPropertyDefaults.ts, 21 Oct 2026).
        const bought = (0, $30ff538d4b47bf21$export$be7ef09ba9b335a2)(purchaseState, budget, 'investment');
        const f = (0, $6ee1c1106c00a64d$export$ad80a9624457bb5e)(bought.price);
        return {
            investmentProperty: bought.price,
            ipStampDuty: bought.duty,
            ipRent: f.rent,
            ipExpenses: f.expenses
        };
    };
    const dutyWords = (duty)=>purchaseState ? ` Stamp duty of ${$d50f5b54e8b24258$var$money(duty)} (${purchaseState}) comes out of the proceeds, so the property is sized to what is left.` : " Stamp duty on the property is not modelled \u2014 no state was chosen.";
    const superRoom = (0, $996111778bb35e70$export$3156faa588d94c0c)(ff);
    const whoFirst = (preferred)=>preferred ? ` \u{2014} ${preferred === 'client' ? factFind?.client?.firstName || 'the client' : factFind?.partner?.firstName || 'the partner'} first, whose accumulation super is not counted by Centrelink until Age Pension age` : '';
    const bondBlurb = "An investment bond pays its own tax inside (30%) and nothing on your tax return; after ten years withdrawals are tax-free. Centrelink counts it in full and deems it, like shares, so this is about tax, not the pension \u2014 and the money is best left alone for ten years.";
    const candidates = [];
    /*
     * 0. STAY PUT — the do-nothing benchmark, and the floor every strategy must beat.
     *
     * Without it the engine ranked actions only against each other: whichever downsize was least bad
     * won "best estate", even when not downsizing beat all of them (owner-caught, 2026-08-26). It is
     * excluded from the ranked universe and passed as the benchmark instead — the same discipline
     * the Retirement Village engine uses with its stay-home candidate.
     */ candidates.push({
        id: 'dz-stay-put',
        name: 'Stay in your current home',
        description: "No downsize \u2014 life as it is today. This is the baseline every strategy below is measured against.",
        details: {},
        stayPut: true
    });
    routes.forEach((route)=>{
        const rents = route === 'rent';
        const p = rents ? 'dz-rent' : 'dz';
        const base = rents ? {
            salePrice: homeValue,
            sellingCosts: sellingCosts,
            newHomePurchasePrice: 0,
            rentInstead: true,
            rentPerWeek: rentPerWeek
        } : {
            salePrice: homeValue,
            sellingCosts: sellingCosts,
            newHomePurchasePrice: newHomeDefault,
            stampDuty: dutyAt(newHomeDefault),
            newHomeState: newHomeState
        };
        const f = rents ? netProceeds : freedBuying(newHomeDefault);
        /** What may be deployed once the reserve is in the bank. */ const D = Math.max(0, f - reserveTopUp);
        const lead = rents ? 'Sell and rent' : 'Downsize';
        const housingWords = rents ? `Sell, and rent instead of buying${rentPerWeek > 0 ? ` (about ${$d50f5b54e8b24258$var$money(rentPerWeek)} a week)` : " (no rent entered \u2014 none is charged)"}. With no home, every dollar is counted and deemed, the higher non-homeowner limit applies, and Rent Assistance may be paid on the rent.` : `Buy a home around ${$d50f5b54e8b24258$var$money(newHomeDefault)}.`;
        const reserveWords = reserveTopUp > 0 ? ` ${$d50f5b54e8b24258$var$money(reserveTopUp)} stays in the bank as the emergency reserve.` : '';
        const push = (c)=>candidates.push({
                ...c,
                housing: route
            });
        // 1. Freed cash to the bank (no super top-up). The simple version every leg is measured against.
        push({
            id: `${p}-simple`,
            name: `${lead} and keep the cash accessible`,
            description: `${housingWords} Keep the freed-up money in the bank. Simple and flexible \u{2014} but more is counted for the Age Pension.`,
            details: {
                ...base
            }
        });
        // 2. SUPER — the downsizer contribution first (a sale is the condition, so renters too).
        let dzUsed = {
            client: 0,
            partner: 0,
            preferred: null
        };
        if (downsizerEligible && D > 0) {
            // Age-aware: the member under Age Pension age is filled first, because only their
            // accumulation super escapes the means tests. See allocateDownsizerContribution.
            dzUsed = (0, $f1228be62b68f76b$export$6373eb0865b1a234)(ff, D);
            const dzTotal = dzUsed.client + dzUsed.partner;
            if (dzTotal > 0) {
                const dzDetails = {
                    ...base,
                    downsizerContribution: dzUsed.client,
                    partnerDownsizerContribution: dzUsed.partner
                };
                push({
                    id: `${p}-super`,
                    name: `${lead} and top up super (downsizer)`,
                    description: `${housingWords} Move ${$d50f5b54e8b24258$var$money(dzTotal)} of the freed-up money into super using the downsizer contribution (up to $300,000 each)${whoFirst(dzUsed.preferred)}. Often more tax-effective; the pension effect depends on your age and balances. The rest stays in the bank.${reserveWords}`,
                    details: dzDetails
                });
                // The same contribution commenced as an account-based pension (earnings tax-free; the
                // minimum pension drawn each year) — where the person is old enough to start one.
                const canCommence = dzUsed.client > 0 && (0, $f1228be62b68f76b$export$d1b692f4d3924fcd)(ff, 'client') || dzUsed.partner > 0 && (0, $f1228be62b68f76b$export$d1b692f4d3924fcd)(ff, 'partner');
                if (canCommence) push({
                    id: `${p}-super-abp`,
                    name: `${lead}, top up super (downsizer), and start a pension from it`,
                    description: `${housingWords} The same ${$d50f5b54e8b24258$var$money(dzTotal)} downsizer contribution, commenced as an account-based pension: earnings are tax-free and a minimum is drawn each year, but the money is counted by Centrelink from day one${dzUsed.preferred ? " \u2014 including the member whose accumulation super would not have been" : ''}.${reserveWords}`,
                    details: {
                        ...dzDetails,
                        commenceIncomeStream: true
                    }
                });
                const remainder = Math.max(0, D - dzTotal);
                if (remainder >= $d50f5b54e8b24258$export$6820740a12e5e2b9) {
                    push({
                        id: `${p}-super-invest`,
                        name: `${lead}, top up super (downsizer), and invest the rest`,
                        description: `${housingWords} The ${$d50f5b54e8b24258$var$money(dzTotal)} downsizer contribution first, then the remaining ${$d50f5b54e8b24258$var$money(remainder)} into a diversified share / managed-fund portfolio rather than the bank.${reserveWords}`,
                        details: {
                            ...dzDetails,
                            deployment: {
                                shares: remainder
                            }
                        }
                    });
                    // Downsizer to the cap + a lifetime annuity with part of the remainder, capped at the
                    // setup's share of the whole deployable amount, the rest into shares. And, where it
                    // lifts the Age Pension, the amount that lifts it most (annuitySizes.ts, 21 Oct 2026).
                    // Super counts once someone is of Age Pension age, so the contribution stays counted.
                    (0, $cb76d0656284f28b$export$4dc6c2d1b2b95e25)(factFind, {
                        investable: D,
                        capPct: annuityCapPct,
                        homeowner: !rents
                    }).forEach((size)=>{
                        const share = Math.min(remainder, size.amount);
                        if (share < $d50f5b54e8b24258$var$DZ_ANNUITY_MIN) return;
                        annuityShapes.forEach((shape)=>push({
                                id: `${p}-super-annuity${size.pensionMax ? '-max' : ''}${shape.suffix}`,
                                name: `${lead}, top up super (downsizer), and buy a lifetime annuity (${shape.name}${size.pensionMax ? ', the amount that lifts the Age Pension most' : ''})`,
                                description: `${housingWords} The ${$d50f5b54e8b24258$var$money(dzTotal)} downsizer contribution first; then ${$d50f5b54e8b24258$var$money(share)} into a lifetime annuity for a guaranteed income for life, with only 60% of its price counted for the assets test; the remaining ${$d50f5b54e8b24258$var$money(remainder - share)} into shares. ${shape.words}${reserveWords}`,
                                details: {
                                    ...dzDetails,
                                    deployment: annuityDeployment(share, shape, remainder - share)
                                }
                            }));
                    });
                }
            }
        }
        // 3–7. Deploy the freed-up money: shares, an investment property, a lifetime annuity, the
        //      means-test fixes, after-tax super, an investment bond.
        if (D >= $d50f5b54e8b24258$export$6820740a12e5e2b9) {
            push({
                id: `${p}-invest`,
                name: `${lead} and invest the proceeds`,
                description: `${housingWords} Put the freed-up ${$d50f5b54e8b24258$var$money(D)} into a diversified share / managed-fund portfolio instead of leaving it in the bank. Aims for higher long-term growth and income; it's still counted for the pension (deemed), and returns aren't guaranteed.${reserveWords}`,
                details: {
                    ...base,
                    deployment: {
                        shares: D
                    }
                }
            });
            const ip = propertyFor(D);
            if (ip.investmentProperty > 0) push({
                id: `${p}-invest-property`,
                name: `${lead} and buy an investment property`,
                description: `${housingWords} Use the freed-up money to buy an investment property for rental income and potential growth. The property is an assessable asset and the net rent counts for the pension; it's less flexible than shares and has buying/selling costs.${dutyWords(ip.ipStampDuty)}${reserveWords}`,
                details: {
                    ...base,
                    deployment: ip
                }
            });
            /*
             * RESIDUAL CAPITAL IS A CHOICE, AND OFFERING ONLY NIL DISQUALIFIES THE STRATEGY.
             *
             * Centrelink assesses a lifetime annuity at 60% of its purchase price WHATEVER its
             * residual capital value — RCV changes the payment rate, not the assets-test treatment.
             * But net worth values an annuity at its RESIDUAL (assessment/netWorth.ts, deliberately:
             * a nil-RCV annuity really does leave nothing behind), so a nil-RCV candidate loses the
             * legacy ranking by its full purchase price on day one. Both ends are offered so the
             * ranking decides. And NEVER all of it: the setup's share, the rest into shares — and, where it
             * lifts the Age Pension, the amount that lifts it most as a plan of its own (annuitySizes.ts).
             */ (0, $cb76d0656284f28b$export$4dc6c2d1b2b95e25)(factFind, {
                investable: D,
                capPct: annuityCapPct,
                homeowner: !rents
            }).forEach((size)=>{
                const share = size.amount;
                if (share < $d50f5b54e8b24258$var$DZ_ANNUITY_MIN) return;
                annuityShapes.forEach((shape)=>push({
                        id: `${p}-annuity${size.pensionMax ? '-max' : ''}${shape.suffix}`,
                        name: `${lead} and buy a lifetime annuity (${shape.name}${size.pensionMax ? ', the amount that lifts the Age Pension most' : ''})`,
                        description: `${housingWords} Convert ${$d50f5b54e8b24258$var$money(share)} of the freed-up money into a lifetime annuity \u{2014} guaranteed income for life, with only 60% of the purchase price counted for the assets test (for the first five years, or until age 85 if that is later, and 30% after that), which often lifts the Age Pension; the remaining ${$d50f5b54e8b24258$var$money(D - share)} into shares. ${shape.words}${reserveWords}`,
                        details: {
                            ...base,
                            deployment: annuityDeployment(share, shape, D - share)
                        }
                    }));
            });
            /*
             * THE TWO LEVERS THAT ACT DIRECTLY ON THE DOWNSIZING TRAP. The home is exempt, the money it
             * turns into is not; a funeral bond and a gift are the two cheapest ways to put part of that
             * money back outside the assessment. Both stay within their limits: the published funeral
             * bond cap per person, and the yearly gifting free area — above it the excess is still
             * counted, and still deemed, for five years, a cost the engine cannot weigh.
             */ const bondAmount = Math.min(D, (0, $1abe73eeef086faf$export$aca3edb7cd7a3f17) * (isCouple ? 2 : 1));
            if (bondAmount > 0) push({
                id: `${p}-funeral-bond`,
                name: `${lead} and shelter part of it in a funeral bond`,
                description: `${housingWords} Put ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(bondAmount)} of the freed-up money into a funeral bond${isCouple ? 's (one each)' : ''}. A funeral bond is exempt from the assets test up to ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$aca3edb7cd7a3f17))} per person, so that part stops being counted \u{2014} the simplest way to soften the downsizing trap, on money most families set aside anyway. The rest goes into shares.${reserveWords}`,
                details: {
                    ...base,
                    funeralBondPurchase: bondAmount,
                    deployment: {
                        shares: Math.max(0, D - bondAmount)
                    }
                }
            });
            const giftAmount = Math.min(D, (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0));
            if (giftAmount > 0) push({
                id: `${p}-gift`,
                name: `${lead} and gift within the free area`,
                description: `${housingWords} Gift ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(giftAmount)} of the freed-up money to family. Gifts up to ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))} a year leave the means test straight away; anything above that is still counted, and still deemed to earn income, for five years \u{2014} so this stays inside the free area. The rest goes into shares.${reserveWords}`,
                details: {
                    ...base,
                    giftingAmount: giftAmount,
                    deployment: {
                        shares: Math.max(0, D - giftAmount)
                    }
                }
            });
            /*
             * AFTER-TAX SUPER (F.6) AND INVESTMENT BONDS (F.5) — 17 Sep 2026. A person under 75 with
             * room under the total super balance bands may contribute after tax — up to $390,000 each
             * with the bring-forward. Where the super door is shut (75+, or the bands full) the
             * tax-paid alternative is an investment bond. Logic-based: each candidate exists only
             * where the rules would let the person make the move, capped at what they may contribute.
             */ const afterDownsizer = Math.max(0, D - dzUsed.client - dzUsed.partner);
            if (superRoom.total > 0) {
                const ncc = (0, $996111778bb35e70$export$38069100974264d)(ff, D);
                const nccTotal = ncc.client + ncc.partner;
                if (nccTotal >= 25000) push({
                    id: `${p}-super-after-tax`,
                    name: `${lead} and contribute to super after tax`,
                    description: `${housingWords} Put ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(nccTotal)} of the freed-up money into super as an after-tax (non-concessional) contribution${whoFirst(ncc.preferred)}. Earnings are taxed at super rates rather than your own. Capped at what each of you may contribute now${superRoom.client.balanceEstimated || superRoom.partner.balanceEstimated ? ' (worked out from the super balances recorded)' : ''}; anything above the cap goes into shares.${reserveWords}`,
                    details: {
                        ...base,
                        deployment: {
                            superContribution: ncc.client,
                            partnerSuperContribution: ncc.partner,
                            superCommenceIncomeStream: ncc.preferred == null,
                            shares: Math.max(0, D - nccTotal)
                        }
                    }
                });
                if (downsizerEligible && afterDownsizer >= 25000 && dzUsed.client + dzUsed.partner > 0) {
                    const more = (0, $996111778bb35e70$export$38069100974264d)(ff, afterDownsizer);
                    const moreTotal = more.client + more.partner;
                    if (moreTotal >= 25000) push({
                        id: `${p}-super-max`,
                        name: `${lead} and put the most you can into super`,
                        description: `${housingWords} The downsizer contribution first (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dzUsed.client + dzUsed.partner)}), then ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(moreTotal)} more as an after-tax contribution${whoFirst(more.preferred)} \u{2014} the most the rules let you move into super from this sale. Anything left goes into shares.${reserveWords}`,
                        details: {
                            ...base,
                            downsizerContribution: dzUsed.client,
                            partnerDownsizerContribution: dzUsed.partner,
                            deployment: {
                                superContribution: more.client,
                                partnerSuperContribution: more.partner,
                                superCommenceIncomeStream: more.preferred == null,
                                shares: Math.max(0, afterDownsizer - moreTotal)
                            }
                        }
                    });
                }
            }
            if (superRoom.total === 0) push({
                id: `${p}-invest-bond`,
                name: `${lead} and put the proceeds into an investment bond`,
                description: `${housingWords} Put the freed-up ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(D)} into an investment bond \u{2014} the tax-paid home for money super can no longer take. ${bondBlurb}${reserveWords}`,
                details: {
                    ...base,
                    deployment: {
                        investmentBond: D
                    }
                }
            });
            else if (D - superRoom.total >= $d50f5b54e8b24258$export$6820740a12e5e2b9) {
                const ncc = (0, $996111778bb35e70$export$38069100974264d)(ff, D);
                const toBond = Math.max(0, D - ncc.client - ncc.partner);
                push({
                    id: `${p}-super-and-bond`,
                    name: `${lead}, fill super after tax, and bond the rest`,
                    description: `${housingWords} Put ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(ncc.client + ncc.partner)} into super as an after-tax contribution${whoFirst(ncc.preferred)} \u{2014} the most the caps allow \u{2014} and the remaining ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(toBond)} into an investment bond. ${bondBlurb}${reserveWords}`,
                    details: {
                        ...base,
                        deployment: {
                            superContribution: ncc.client,
                            partnerSuperContribution: ncc.partner,
                            superCommenceIncomeStream: ncc.preferred == null,
                            investmentBond: toBond
                        }
                    }
                });
            }
        }
    });
    /*
     * THE PRICE LADDER — a sensitivity or a strategy, by the client's REASON for moving (owner,
     * 3 Oct 2026). Same sale, same deployment (cash), only the price differs, so the reader sees
     * what the PRICE decision does: cheaper frees capital that is then counted (the trap); similar
     * frees almost nothing; dearer moves counted savings INTO the exempt home and can LIFT the
     * pension — the opposite of the trap.
     *
     *   'money'  the client wants the money out: every price is a what-if, listed and explained,
     *            never crowned — a dearer home would win "Best Age Pension" by hiding more, which
     *            is true and is not what they asked for (owner, 2 Oct 2026).
     *   'home'   the client wants a home that suits them better: the similar and dearer homes —
     *            and the most home the savings allow — are real candidates that compete for the
     *            goals; the cashflow-covered rule says whether the bills are still paid. The
     *            cheaper move stays a what-if.
     *   'both'   compare everything.
     *
     * A buy-up's top-up is drawn from savings in the usual order with the reserve kept, and
     * carried as `buyUpFunding` so the event sells the right assets rather than overdrawing the
     * bank; a buy-up the savings cannot fund is not generated.
     */ if (routes.includes('buy')) {
        /*
         * A PRICE THEY STATED IS THE PRICE (owner, 25 Oct 2026: "if they've told us … the suggestion engine is
         * supposed to work out the best way of achieving this"). With a price named on step 1, every plan that
         * competes buys at it; the other prices are what-ifs, shown under "What if the new home cost more, or
         * less?", never crowned. With no price ("Not sure — test a range"), the ladder competes as before.
         */ const priceStated = intended > 0;
        const ladder = [];
        const cheaper = Math.round(homeValue * 0.6);
        if (cheaper > 0 && Math.abs(cheaper - newHomeDefault) > homeValue * 0.05) ladder.push({
            id: 'dz-price-cheaper',
            price: cheaper,
            label: `Buy a cheaper home (${$d50f5b54e8b24258$var$formatRough(cheaper)})`,
            note: `Frees up the most \u{2014} ${$d50f5b54e8b24258$var$formatRough(freedBuying(cheaper))} after costs. It is also the version that counts the most against the Age Pension, because the home was not counted and the cash is.`,
            sensitivity: priceStated || motive !== 'both'
        });
        const similar = Math.round(netProceeds);
        if (similar > 0 && Math.abs(similar - newHomeDefault) > homeValue * 0.05) ladder.push({
            id: 'dz-price-similar',
            price: similar,
            label: `Buy a home at a similar price (${$d50f5b54e8b24258$var$formatRough(similar)})`,
            note: "Spends the whole sale on the new home. Nothing is freed up and nothing new is counted \u2014 the move is about the house, not the money, and the selling costs are what it costs you.",
            sensitivity: priceStated || motive === 'money'
        });
        const dearer = Math.round(homeValue * 1.15);
        const topUp = topUpNeeded(dearer);
        if (topUp > 0 && Math.abs(dearer - newHomeDefault) > homeValue * 0.05) {
            const funding = buyUpFundingFor(topUp);
            if (fundedOf(funding) >= topUp - 1) ladder.push({
                id: 'dz-price-dearer',
                price: dearer,
                label: `Buy a somewhat dearer home (${$d50f5b54e8b24258$var$formatRough(dearer)})`,
                note: `Costs ${$d50f5b54e8b24258$var$formatRough(topUp)} more than the sale nets, topped up from savings. A home is not counted by Centrelink, so that money stops being counted and the Age Pension can rise rather than fall \u{2014} the opposite of the usual downsizing trap. The trade-off: that money is in the house now, not available to spend.`,
                sensitivity: priceStated || motive === 'money',
                buyUpFunding: funding
            });
        }
        /*
         * THE MOST HOME THE SAVINGS ALLOW — only where the reason is the home. Every spare dollar
         * above the reserve goes into the exempt home: the largest lift the assets test can give,
         * and nothing left invested, so the cashflow rests on the pension and any other income.
         * Offered only where it is materially above the dearer rung.
         */ if (motive !== 'money') {
            const spare = Math.max(0, $d50f5b54e8b24258$var$accessibleLiquidFor(factFind) - reserve);
            const most = (0, $30ff538d4b47bf21$export$be7ef09ba9b335a2)(purchaseState, netProceeds + spare).price;
            const mostTopUp = topUpNeeded(most);
            // Materially above the anchor and above the dearer rung WHERE THAT RUNG EXISTS — a
            // client who cannot fund +15% (owner-caught 3 Oct 2026: $780k liquid against an $800k
            // top-up) still has a buy-up the savings DO allow, and it is the one that lifts the pension.
            const floor = Math.max(newHomeDefault, ladder.some((r)=>r.id === 'dz-price-dearer') ? dearer : 0);
            if (spare > 0 && most > floor * 1.05 && mostTopUp > 0) {
                const funding = buyUpFundingFor(mostTopUp);
                if (fundedOf(funding) >= mostTopUp - 1) ladder.push({
                    id: 'dz-price-max',
                    price: most,
                    label: `Buy a dearer home, using the savings (${$d50f5b54e8b24258$var$formatRough(most)})`,
                    note: `Puts ${$d50f5b54e8b24258$var$formatRough(mostTopUp)} of savings \u{2014} everything above the ${$d50f5b54e8b24258$var$formatRough(reserve)} kept in reserve \u{2014} towards a dearer home. A home is not counted by Centrelink, so less is counted and the Age Pension can rise. The trade-off: almost nothing is left invested, so the bills rest on the pension and any other income.`,
                    sensitivity: priceStated,
                    buyUpFunding: funding
                });
            }
        }
        ladder.forEach(({ id: id, price: price, label: label, note: note, sensitivity: sensitivity, buyUpFunding: buyUpFunding })=>{
            candidates.push({
                id: id,
                name: label,
                description: `${note} Everything else is held the same, so this shows what the price alone does.`,
                details: {
                    salePrice: homeValue,
                    sellingCosts: sellingCosts,
                    newHomePurchasePrice: price,
                    stampDuty: dutyAt(price),
                    newHomeState: newHomeState,
                    ...buyUpFunding ? {
                        buyUpFunding: buyUpFunding
                    } : {}
                },
                housing: 'buy',
                sensitivity: sensitivity
            });
        });
    }
    // The client's current plan (if they've entered a downsize in Manual Control) — for comparison.
    if (ci && options.manualPlanEntered === true && ciNewHomePrice >= 0 && ((parseFloat(String(ci.salePrice ?? '')) || 0) > 0 || homeValue > 0)) candidates.push({
        id: 'dz-your-plan',
        name: 'Your current plan',
        description: 'The downsize you entered in Manual Control, for comparison.',
        housing: ciRents ? 'rent' : 'buy',
        details: {
            salePrice: parseFloat(String(ci.salePrice ?? '')) || homeValue,
            sellingCosts: parseFloat(String(ci.sellingCosts ?? '')) || sellingCosts,
            newHomePurchasePrice: ciRents ? 0 : ciNewHomePrice,
            // The client's own plan carries the figure on their screen, whatever it was.
            stampDuty: ciRents ? 0 : ciStampDuty,
            newHomeState: newHomeState,
            rentInstead: ciRents,
            rentPerWeek: ciRents ? Number(ci.rentPerWeek) || 0 : 0,
            downsizerContribution: parseFloat(String(ci.downsizerContribution ?? '')) || 0,
            partnerDownsizerContribution: parseFloat(String(ci.partnerDownsizerContribution ?? '')) || 0,
            commenceIncomeStream: !!ci.commenceIncomeStream,
            giftingAmount: parseFloat(String(ci.giftingAmount ?? '')) || 0,
            funeralBondPurchase: parseFloat(String(ci.funeralBondPurchase ?? '')) || 0,
            deployment: ci.deployment || {}
        }
    });
    /*
     * DEBT CLEARANCE — paired against every downsizing candidate above (never the benchmark, never
     * a sensitivity). The interest stops and the repayments leave the cashflow, but the money spent
     * is money no other part of the plan can use — the competition worth ranking. Which debts:
     * strategy/debtsToTest.ts (never a card paid off monthly; any interest-bearing debt; interest-free
     * debts from $5,000), the same rule every module uses.
     */ const debts = (0, $485d903040fc3504$export$718566aeb53e1efe)((0, $35f2741dc40fa45c$export$403bb596c20e48)(factFind));
    const totalDebt = debts.reduce((sum, d)=>sum + d.balance, 0);
    if (debts.length > 0) {
        const payments = Object.fromEntries(debts.map((d)=>[
                d.key,
                d.balance
            ]));
        const twins = candidates.filter((c)=>!c.stayPut && !c.sensitivity).map((c)=>({
                ...c,
                id: `${c.id}-clear-debt`,
                name: `${c.name}, and clear your debts`,
                description: `${c.description} This version also clears your outstanding debts of ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(totalDebt)} at the same time \u{2014} the interest stops and the repayments leave your cashflow, but that money is no longer available for anything else in the plan.`,
                debtPayoff: {
                    payments: payments,
                    repaymentBasis: 'keep_repayment'
                }
            }));
        candidates.push(...twins);
    }
    return candidates;
}
async function $d50f5b54e8b24258$export$517e4e1adb5fb749(factFind, options = {}) {
    const legacyYears = options.legacyYears || 10;
    const candidates = $d50f5b54e8b24258$export$a230187ca30d6754(factFind, options);
    // One request evaluates every candidate against the engine server-side (see
    // server/src/rest/calculation/suggestionEngine/downsizer.ts) instead of one request per candidate.
    // The case's downsize date rides along so every candidate is projected on the same timing as the
    // manual run — timing belongs to the case, never to a strategy.
    const strategies = await $55a1d8a64f1e5dfa$export$3c56e8c3a3f7ace8(factFind, candidates, legacyYears, options.downsizeDate);
    // Ranked among the MOVE strategies, each measured against staying put — so nothing is ever
    // recommended that leaves the client worse off than doing nothing. The price ladder is a
    // sensitivity: evaluated and listed, never ranked.
    const stayPut = strategies.find((s)=>s.id === 'dz-stay-put') || null;
    const moveStrategies = strategies.filter((s)=>s.id !== 'dz-stay-put' && !$d50f5b54e8b24258$export$2cbcd11218125c86(s));
    const recommended = (0, $f8ee565b442c040e$export$3140a3b98e6384f2)(moveStrategies, stayPut, {
        cashflowTarget: Number(options.setup?.cashflowTarget) || 0,
        readings: (0, $5a094123650e8adb$export$448a1f2525c95b5b)
    });
    return {
        strategies: strategies,
        recommended: recommended,
        stayPut: stayPut,
        rerun: {
            candidates: candidates,
            legacyYears: legacyYears,
            date: options.downsizeDate
        }
    };
}





/**
 * THE GUARANTEED INCOME ON A DOWNSIZING PLAN, read once for the card, the hand-built plan and the advice
 * document (owner, 21 Oct 2026 — the guaranteed income review and the agreed mock-up, docs/ux-review/annuities/,
 * screen 6: downsizing works as the village).
 *
 * From a plan's deployment and its own projection rows: who the guaranteed income is for (named as the
 * screens name them), how much goes in, its type in the family panel's terms (full amount back, money back,
 * income only), about what it pays a year, and — for a tested plan — the sibling plan with the same sale and
 * the money invested instead (`dzInvestSiblingIdOf`), which is what the family panel and the document set it
 * against. A hand-built plan has no sibling, so no comparison.
 */ 



const $ed6c3bc1777d5c34$export$2d8e7d1fb8934a4c = 'the same sale, with the money invested instead';
function $ed6c3bc1777d5c34$export$493617eb0743bbd3(factFind, owner) {
    const client = (factFind?.client?.firstName || '').trim() || 'the client';
    const partner = (factFind?.partner?.firstName || '').trim() || 'the partner';
    if (owner === 'partner') return partner;
    if (owner === 'joint' && factFind?.adviceFor === 'couple') return `${client} and ${partner}`;
    return client;
}
function $ed6c3bc1777d5c34$export$b5fbc3d3651c5a13(rows, factFind) {
    const first = (rows || [])[0];
    const list = first?.assets?.annuities || [];
    const onFile = new Set((factFind?.assets?.annuities || []).map((a)=>String(a?.id)));
    const total = list.filter((a)=>!onFile.has(String(a?.id))).reduce((t, a)=>t + (Number(a?.annualPayment) || 0), 0);
    return total > 0 ? Math.round(total) : null;
}
function $ed6c3bc1777d5c34$export$432c3d850768ad70(deployment, factFind, rows) {
    const terms = (0, $80740ae64106afa1$export$14a5903af8acddef)(deployment, factFind?.adviceFor === 'couple');
    if (!terms) return null;
    const amount = Number(terms.purchaseAmount) || 0;
    const annuityType = terms.annuityType === 'guaranteed' || terms.annuityType === 'fixedTerm' ? terms.annuityType : 'lifetime';
    const residualPercent = Number(terms.residualPercent) || 0;
    return {
        personName: $ed6c3bc1777d5c34$export$493617eb0743bbd3(factFind, terms.owner),
        amount: amount,
        kind: (0, $8665f80549f60a1b$export$3ab75b1250c8af22)({
            annuityType: annuityType,
            annuityResidualPercent: residualPercent
        }),
        incomeAYear: $ed6c3bc1777d5c34$export$b5fbc3d3651c5a13(rows, factFind),
        incomeOnly: (0, $5eae79c7e46ed27e$export$3c8a471078a7436)({
            purchaseAmount: amount,
            annuityType: annuityType,
            residualCapital: residualPercent / 100
        }),
        annuityType: annuityType,
        residualPercent: residualPercent
    };
}
function $ed6c3bc1777d5c34$export$7e3067ac8807505a(id, all) {
    const sibling = (0, $d50f5b54e8b24258$export$395a7db7b95be5d3)(id);
    if (!sibling) return null;
    return (all || []).find((s)=>String(s.id) === sibling) || null;
}


/**
 * A downsizing plan in everyday words — the card's title and the line under it, the money each plan frees
 * and where it goes (downsizing rebuild, 21 Oct 2026; the agreed mock-up's plans screen).
 *
 * The engine's names ("Downsize, top up super (downsizer), and start a pension from it") were written for an
 * adviser's list. The card says what is bought (or that they rent), at what price, and where the money the
 * sale frees goes — "Buy a $1.96 million home, put $600,000 into super and draw it as a pension". Read from
 * the candidate's own inputs with the module's one sale arithmetic (dzSaleFigures.ts), so the words, the
 * plan page and the advice document quote the same figures. Presentation only: nothing here is computed
 * beyond sums.
 */ 


/**
 * The chosen downsizing plan, as the plan page and Home read it (downsizing rebuild, 21 Oct 2026 — the
 * village pattern, rvChosenPlan.ts).
 *
 * ONE PLAN PER HOME. A family may model more than one home ("Model another home", the mock-up's journey 2):
 * each keeps one saved plan, keyed by the home's name, its price and whether it is bought or rented, and one
 * of them is the chosen plan. Choosing another plan for the same home replaces that home's plan; choosing for
 * another home keeps the first one saved and marks the new one chosen.
 *
 * The card the family chose is stored on the record — its figures, staying put's at the time, the plan in
 * words, the sale and the new home — so the plan page shows exactly what was chosen, with no re-run between.
 */ 
function $4e46e0dde908c630$export$1cd766d21ccc216e(name, namedPrice, housing) {
    const h = housing === 'rent' || housing === 'both' ? housing : 'buy';
    return `${String(name || '').trim().toLowerCase()}|${h === 'rent' ? 0 : Math.round(Number(namedPrice) || 0)}|${h}`;
}
function $4e46e0dde908c630$export$ca3f5e02abff08b8(prev, record) {
    const key = record.inputs?.homeKey;
    const others = (prev || []).filter((p)=>!(p.type === 'downsizer' && key != null && p.inputs?.homeKey === key));
    return (0, $7445cb9532643693$export$bda89f6290a6f044)(others, record);
}
function $4e46e0dde908c630$export$599ead36dcfb6049(list) {
    const hit = (list || []).find((s)=>s?.type === 'downsizer' && s.chosen === true && s.inputs?.card);
    return hit ?? null;
}
function $4e46e0dde908c630$export$f54a1f0bc6e6915a(list) {
    const withCard = (list || []).filter((s)=>s?.type === 'downsizer' && s.inputs?.card);
    return [
        ...withCard
    ].sort((a, b)=>Number(b.chosen === true) - Number(a.chosen === true));
}
const $4e46e0dde908c630$export$5d7344b7ed506119 = 'careCompanionDzStartFresh';
const $4e46e0dde908c630$export$d35c47ced6d86226 = 'careCompanionDzAnotherHome';
function $4e46e0dde908c630$export$b48e0c6120d679a4(price) {
    const p = Math.max(0, Math.round(Number(price) || 0));
    if (p >= 1000000) {
        const m = Math.round(p / 10000) / 100;
        return `$${String(m.toFixed(2)).replace(/\.?0+$/, '')} million`;
    }
    return `$${p.toLocaleString('en-AU')}`;
}



const $6cafaaa2bceecd94$var$num = (v)=>{
    const n = typeof v === 'number' ? v : parseFloat(String(v ?? ''));
    return Number.isFinite(n) ? n : 0;
};
const $6cafaaa2bceecd94$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
const $6cafaaa2bceecd94$var$joinAnd = (xs)=>xs.length <= 1 ? xs[0] || '' : `${xs.slice(0, -1).join(', ')} and ${xs[xs.length - 1]}`;
function $6cafaaa2bceecd94$export$4c99534ae83f65d1(inputs, extra = {}) {
    const d = inputs || {};
    const salePrice = $6cafaaa2bceecd94$var$num(d.salePrice);
    const sellingCosts = $6cafaaa2bceecd94$var$num(d.sellingCosts);
    const newHomePrice = $6cafaaa2bceecd94$var$num(d.newHomePurchasePrice);
    const sellAndRent = d.rentInstead === true || newHomePrice === 0 && salePrice > 0;
    const { stampDuty: stampDuty, freedCapital: freedCapital, buyUpShortfall: buyUpShortfall } = (0, $6b146b31ad2b1e77$export$855cd09595261b3b)({
        salePrice: salePrice,
        sellingCosts: sellingCosts,
        newHomePrice: newHomePrice,
        stampDuty: $6cafaaa2bceecd94$var$num(d.stampDuty),
        sellAndRent: sellAndRent
    });
    return {
        salePrice: salePrice,
        sellingCosts: sellingCosts,
        newHomePrice: sellAndRent ? 0 : newHomePrice,
        stampDuty: stampDuty,
        state: String(d.newHomeState || ''),
        sellAndRent: sellAndRent,
        rentPerWeek: sellAndRent ? $6cafaaa2bceecd94$var$num(extra.rentPerWeek ?? d.rentPerWeek) : 0,
        freedCapital: freedCapital,
        buyUpShortfall: buyUpShortfall,
        homeName: String(extra.homeName || ''),
        date: String(extra.date || '')
    };
}
function $6cafaaa2bceecd94$export$ba4ded872bfc6459(inputs) {
    const d = inputs || {};
    const dep = d.deployment || {};
    const move = $6cafaaa2bceecd94$export$4c99534ae83f65d1(d);
    const u = {
        downsizerClient: $6cafaaa2bceecd94$var$num(d.downsizerContribution),
        downsizerPartner: $6cafaaa2bceecd94$var$num(d.partnerDownsizerContribution),
        pensionFromDownsizer: d.commenceIncomeStream === true,
        afterTaxSuper: $6cafaaa2bceecd94$var$num(dep.superContribution) + $6cafaaa2bceecd94$var$num(dep.partnerSuperContribution),
        pensionFromAfterTax: dep.superCommenceIncomeStream === true,
        annuity: $6cafaaa2bceecd94$var$num(dep.annuity),
        annuityType: String(dep.annuityType || 'lifetime'),
        annuityResidualPercent: $6cafaaa2bceecd94$var$num(dep.annuityResidualPercent),
        investmentProperty: $6cafaaa2bceecd94$var$num(dep.investmentProperty),
        ipStampDuty: $6cafaaa2bceecd94$var$num(dep.ipStampDuty),
        investmentBond: $6cafaaa2bceecd94$var$num(dep.investmentBond),
        funeralBond: $6cafaaa2bceecd94$var$num(d.funeralBondPurchase),
        gift: $6cafaaa2bceecd94$var$num(d.giftingAmount),
        shares: $6cafaaa2bceecd94$var$num(dep.shares)
    };
    const placed = u.downsizerClient + u.downsizerPartner + u.afterTaxSuper + u.annuity + u.investmentProperty + u.ipStampDuty + u.investmentBond + u.funeralBond + u.gift + u.shares;
    return {
        ...u,
        placed: placed,
        bank: Math.max(0, move.freedCapital - placed)
    };
}
function $6cafaaa2bceecd94$export$a730dc99fb22310a(price) {
    const p = Math.max(0, Math.round(price));
    return p >= 1000000 ? `$${String((Math.round(p / 100000) / 10).toFixed(1)).replace(/\.0$/, '')}m` : `$${Math.round(p / 1000)}k`;
}
function $6cafaaa2bceecd94$export$ad52b9cc096416fa(m) {
    if (m.sellAndRent) return 'Selling and renting';
    const net = m.salePrice - m.sellingCosts;
    if (Math.abs(m.newHomePrice - net) <= m.salePrice * 0.05) return `A home at a similar price, ${$6cafaaa2bceecd94$export$a730dc99fb22310a(m.newHomePrice)}`;
    if (m.newHomePrice > net) return `A dearer home, ${$6cafaaa2bceecd94$export$a730dc99fb22310a(m.newHomePrice)}`;
    return `A ${$6cafaaa2bceecd94$export$a730dc99fb22310a(m.newHomePrice)} home`;
}
/** "the money back in the early years" — a guaranteed income said by what the family receives. */ function $6cafaaa2bceecd94$var$annuityBack(u) {
    if (u.annuityType === 'guaranteed') return 'that pays the full amount back to the family at any time';
    if (u.annuityType === 'fixedTerm') return 'for a set term';
    return u.annuityResidualPercent > 0 ? 'that pays the money back to the family in the early years' : 'that pays the most income, with nothing back to the family';
}
function $6cafaaa2bceecd94$export$c0e0825daa2dbb24(row, factFind) {
    const inputs = row.inputs || {};
    const id = String(row.id || '');
    const m = $6cafaaa2bceecd94$export$4c99534ae83f65d1(inputs, {
        rentPerWeek: row.rentPerWeek
    });
    const u = $6cafaaa2bceecd94$export$ba4ded872bfc6459(inputs);
    const clientName = factFind?.client?.firstName || 'you';
    const partnerName = factFind?.partner?.firstName || 'your partner';
    const debts = /-clear-debt$/.test(id);
    // The home.
    const similar = !m.sellAndRent && m.newHomePrice > 0 && Math.abs(m.newHomePrice - (m.salePrice - m.sellingCosts)) <= m.salePrice * 0.05;
    const dearer = !m.sellAndRent && !similar && m.newHomePrice > m.salePrice - m.sellingCosts;
    const home = m.sellAndRent ? `Sell and rent${m.rentPerWeek > 0 ? ` at ${$6cafaaa2bceecd94$var$money(m.rentPerWeek)} a week` : ''}` : similar ? `Buy a home at a similar price, about ${(0, $4e46e0dde908c630$export$b48e0c6120d679a4)(m.newHomePrice)}` : dearer ? `Buy a dearer home, about ${(0, $4e46e0dde908c630$export$b48e0c6120d679a4)(m.newHomePrice)}` : `Buy a ${(0, $4e46e0dde908c630$export$b48e0c6120d679a4)(m.newHomePrice)} home`;
    // Where the money goes, short for the title and long for the sub-line.
    const short = [];
    const long = [];
    const ds = u.downsizerClient + u.downsizerPartner;
    if (ds > 0) {
        short.push(`put ${$6cafaaa2bceecd94$var$money(ds)} into super${u.pensionFromDownsizer ? ' and draw it as a pension' : ''}`);
        const into = u.downsizerClient > 0 && u.downsizerPartner > 0 ? Math.round(u.downsizerClient) === Math.round(u.downsizerPartner) ? `${$6cafaaa2bceecd94$var$money(u.downsizerClient)} each goes into super as a downsizer contribution` : `${$6cafaaa2bceecd94$var$money(u.downsizerClient)} goes into ${clientName}'s super and ${$6cafaaa2bceecd94$var$money(u.downsizerPartner)} into ${partnerName}'s, each as a downsizer contribution` : `${$6cafaaa2bceecd94$var$money(ds)} goes into ${u.downsizerClient > 0 ? clientName : partnerName}'s super as a downsizer contribution`;
        long.push(`${into}${u.pensionFromDownsizer ? ', drawn as a pension' : ''}`);
    }
    if (u.afterTaxSuper > 0) {
        short.push(`put ${$6cafaaa2bceecd94$var$money(u.afterTaxSuper)}${ds > 0 ? ' more' : ''} into super after tax`);
        long.push(`${$6cafaaa2bceecd94$var$money(u.afterTaxSuper)} into super as an after-tax contribution${u.pensionFromAfterTax ? ', drawn as a pension' : ''}`);
    }
    if (u.annuity > 0) {
        short.push(`put ${$6cafaaa2bceecd94$var$money(u.annuity)} into a guaranteed income`);
        long.push(`${$6cafaaa2bceecd94$var$money(u.annuity)} into a guaranteed income for life ${$6cafaaa2bceecd94$var$annuityBack(u)}`);
    }
    if (u.investmentProperty > 0) {
        short.push('buy an investment property');
        long.push(`${$6cafaaa2bceecd94$var$money(u.investmentProperty)} on an investment property${u.ipStampDuty > 0 ? `, plus ${$6cafaaa2bceecd94$var$money(u.ipStampDuty)} of stamp duty` : ''}`);
    }
    if (u.investmentBond > 0) {
        short.push(`put ${$6cafaaa2bceecd94$var$money(u.investmentBond)} into an investment bond`);
        long.push(`${$6cafaaa2bceecd94$var$money(u.investmentBond)} into an investment bond`);
    }
    if (u.funeralBond > 0) {
        short.push(`put ${$6cafaaa2bceecd94$var$money(u.funeralBond)} into funeral bonds`);
        long.push(`${$6cafaaa2bceecd94$var$money(u.funeralBond)} into funeral bonds, outside the assets test`);
    }
    if (u.gift > 0) {
        short.push(`give ${$6cafaaa2bceecd94$var$money(u.gift)} to family`);
        long.push(`${$6cafaaa2bceecd94$var$money(u.gift)} given to family`);
    }
    if (u.shares > 0) {
        short.push(short.length ? 'invest the rest' : `invest the ${$6cafaaa2bceecd94$var$money(u.shares)}`);
        long.push(`${short.length > 1 ? 'the other ' : ''}${$6cafaaa2bceecd94$var$money(u.shares)} invested ${(0, $5fe2dfde2f334213$export$445db77df4ca8114)(factFind)}`);
    }
    if (!short.length && m.freedCapital >= 1) short.push('keep the rest in the bank');
    const title = `${home}${short.length ? `, ${$6cafaaa2bceecd94$var$joinAnd(short)}` : ''}${debts ? ', and clear the debts' : ''}`;
    // The sub-line: what the sale leaves, then where it goes.
    const parts = [];
    if (m.sellAndRent) parts.push(`The sale nets ${$6cafaaa2bceecd94$var$money(m.salePrice - m.sellingCosts)} and nothing is bought; the rent${m.rentPerWeek > 0 ? ` of ${$6cafaaa2bceecd94$var$money(m.rentPerWeek)} a week` : ''} is paid from the money, with Rent Assistance where it applies.`);
    else if (m.buyUpShortfall >= 1) {
        const draw = (0, $7175ce4c598409db$export$260d1042b8a534f2)(inputs.buyUpFunding || null, factFind, 'the top-up');
        parts.push(similar ? `The whole sale goes into the new home; the ${$6cafaaa2bceecd94$var$money(m.stampDuty)} of stamp duty comes from savings. Nothing is freed up.` : `The whole sale and ${$6cafaaa2bceecd94$var$money(m.buyUpShortfall)} of savings go into the new home${m.stampDuty > 0 ? ` and its ${$6cafaaa2bceecd94$var$money(m.stampDuty)} of stamp duty` : ''}. Nothing is freed up.${draw ? ` ${draw.replace(/^./, (c)=>c.toUpperCase())}.` : ''}`);
    } else if (m.freedCapital >= 1) parts.push(`The sale frees ${$6cafaaa2bceecd94$var$money(m.freedCapital)}${m.stampDuty > 0 ? ` after ${$6cafaaa2bceecd94$var$money(m.stampDuty)} of stamp duty` : ''}.`);
    else parts.push('The whole sale goes into the new home. Nothing is freed up.');
    if (!m.sellAndRent && m.newHomePrice > 0 && m.stampDuty <= 0) parts.push('No stamp duty is in the figures: no state was chosen.');
    if (long.length) parts.push(`${long.join('; ').replace(/^./, (c)=>c.toUpperCase())}${u.bank >= 1 ? `; ${$6cafaaa2bceecd94$var$money(u.bank)} stays in the bank` : ''}.`);
    else if (m.freedCapital >= 1) parts.push(`The ${$6cafaaa2bceecd94$var$money(m.freedCapital)} stays in the bank.`);
    if (debts) parts.push('The debts are cleared at the same time.');
    return {
        title: title,
        sub: parts.join(' ')
    };
}
function $6cafaaa2bceecd94$export$4e25df6b98b4ff33(inputs, breakdown) {
    const rows = (breakdown || []).filter((r)=>!/^kept in bank$/i.test(r.label) && !/^rent \(/i.test(r.label) && $6cafaaa2bceecd94$var$num(r.amount) > 0);
    const u = $6cafaaa2bceecd94$export$ba4ded872bfc6459(inputs);
    const m = $6cafaaa2bceecd94$export$4c99534ae83f65d1(inputs);
    if (m.stampDuty > 0 && !m.sellAndRent) rows.splice(rows.findIndex((r)=>/^new home$/i.test(r.label)) + 1, 0, {
        label: 'Stamp duty on the new home',
        amount: m.stampDuty
    });
    if (u.funeralBond > 0 && !rows.some((r)=>/funeral/i.test(r.label))) rows.push({
        label: 'Funeral bonds',
        amount: u.funeralBond
    });
    if (u.bank >= 1) rows.push({
        label: 'Kept in the bank',
        amount: u.bank
    });
    return rows;
}


/** A projection row in the document's shape — the engine's label, figures and working (moduleSoa.ts). */ const $a8ea1c05c1194ef5$var$projRows = (rows, years)=>(0, $482dbb064a59e381$export$998b1d0a26b4d727)(rows, years);
const $a8ea1c05c1194ef5$var$n = (v)=>{
    const x = typeof v === 'number' ? v : parseFloat(String(v ?? ''));
    return Number.isFinite(x) ? x : 0;
};
const $a8ea1c05c1194ef5$var$money = (v)=>`$${Math.round(v).toLocaleString('en-AU')}`;
function $a8ea1c05c1194ef5$export$8cf32ecded529ff3(p) {
    const { strategy: strategy, factFind: factFind } = p;
    const id = String(strategy.id || '');
    const kindsFromId = (0, $203e38d6e6c434f4$export$c301be208b2d16d)(id);
    const details = strategy.inputs || {};
    const salePrice = $a8ea1c05c1194ef5$var$n(details.salePrice);
    const sellingCosts = $a8ea1c05c1194ef5$var$n(details.sellingCosts);
    const newHome = $a8ea1c05c1194ef5$var$n(details.newHomePurchasePrice);
    const sellAndRent = details.rentInstead === true || newHome === 0 && salePrice > 0;
    const rentPerWeek = sellAndRent ? $a8ea1c05c1194ef5$var$n(strategy.rentPerWeek ?? details.rentPerWeek) : 0;
    // The one sale arithmetic the screens use (dzSaleFigures.ts), so the document quotes the same freed-up figure.
    const { netProceeds: netProceeds, stampDuty: stampDuty, buyUpShortfall: buyUp, freedCapital: freed } = (0, $6b146b31ad2b1e77$export$855cd09595261b3b)({
        salePrice: salePrice,
        sellingCosts: sellingCosts,
        newHomePrice: newHome,
        stampDuty: $a8ea1c05c1194ef5$var$n(details.stampDuty),
        sellAndRent: sellAndRent
    });
    const deploy = details.deployment || {};
    // The plan's guaranteed income, and whether its income is a provider's quote rather than our estimate.
    const gi = (0, $ed6c3bc1777d5c34$export$432c3d850768ad70)(deploy, factFind, strategy.projections);
    const quoted = !!gi && ($a8ea1c05c1194ef5$var$n(deploy.annuityIncomeOverride) > 0 || (0, $da24031d156d6acb$export$2ee327201b9e82a1)(p.annuityQuote, gi.annuityType, gi.residualPercent, gi.amount) != null);
    const ipDuty = $a8ea1c05c1194ef5$var$n(deploy.ipStampDuty);
    const ipPrice = $a8ea1c05c1194ef5$var$n(deploy.investmentProperty);
    const dzContribution = $a8ea1c05c1194ef5$var$n(details.downsizerContribution) + $a8ea1c05c1194ef5$var$n(details.partnerDownsizerContribution);
    // The plan's parts come from what it actually does, not only from its id (a custom id still reads right).
    const kinds = [
        ...kindsFromId
    ];
    const addKind = (k)=>{
        if (!kinds.includes(k)) kinds.push(k);
    };
    if (salePrice > 0) addKind('sellHome');
    if (sellAndRent) addKind('sellAndRent');
    if (ipPrice > 0) addKind('investmentProperty');
    if ($a8ea1c05c1194ef5$var$n(deploy.shares) > 0) addKind('shares');
    if ($a8ea1c05c1194ef5$var$n(deploy.investmentBond) > 0) addKind('investmentBond');
    if (dzContribution + $a8ea1c05c1194ef5$var$n(deploy.superContribution) + $a8ea1c05c1194ef5$var$n(deploy.partnerSuperContribution) > 0) addKind('superContribution');
    if (deploy.superCommenceIncomeStream) addKind('accountBasedPension');
    if ($a8ea1c05c1194ef5$var$n(deploy.annuity) > 0 && !kinds.some((k)=>k.startsWith('annuity'))) addKind(deploy.annuityType === 'guaranteed' ? 'annuityGuaranteed' : $a8ea1c05c1194ef5$var$n(deploy.annuityResidualPercent) > 0 ? 'annuityReturned' : 'annuityNil');
    if ($a8ea1c05c1194ef5$var$n(details.funeralBondPurchase) > 0) addKind('funeralBond');
    if ($a8ea1c05c1194ef5$var$n(details.giftingAmount) > 0) addKind('gift');
    const years = Number(p.legacyYears) || 5;
    const stayPut = p.all.find((s)=>String(s.id) === 'dz-stay-put') || null;
    const snap = strategy.snapshot || {};
    const base = stayPut?.snapshot || {};
    const rows = strategy.projections || [];
    const headline = {
        pension: $a8ea1c05c1194ef5$var$n(snap.pension),
        cashflow: $a8ea1c05c1194ef5$var$n(snap.netCashflow),
        estate: $a8ea1c05c1194ef5$var$n(snap.legacyValue ?? (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(rows[Math.min(rows.length, years) - 1]))
    };
    const baseline = {
        name: 'Staying in your current home',
        pension: $a8ea1c05c1194ef5$var$n(base.pension),
        cashflow: $a8ea1c05c1194ef5$var$n(base.netCashflow),
        estate: $a8ea1c05c1194ef5$var$n(base.legacyValue)
    };
    const deployment = strategy.deploymentBreakdown || [];
    const common = (0, $482dbb064a59e381$export$df893918412205e2)(factFind, {
        kind: 'downsizer',
        strategySource: id === 'dz-manual' ? 'manual_control' : 'suggestion_engine',
        customisedFrom: p.customisedFrom ?? null,
        riskKinds: kinds,
        riskSpecifics: {
            stampDuty: stampDuty || null
        }
    });
    // The same "What could go wrong" as the screen (dzPlanRisks): the duty said as the new home's, the savings that
    // go into the home, the 24-month gap — never the generic list beside a different one on screen.
    common.strategyRisks = (0, $29500f2a86f5f83f$export$60e4d14b8d823b60)({
        kinds: kinds,
        move: {
            stampDuty: stampDuty,
            freedCapital: freed,
            sellAndRent: sellAndRent,
            newHomePrice: newHome,
            buyUpShortfall: buyUp
        },
        ipStampDuty: ipDuty || null
    });
    // The same rows the plan card's detail shows (dzWhereTheMoneyGoes): what stays in the bank is after the
    // stamp duty and any funeral bond, so the document and the screen quote one figure.
    const moneyFlow = [
        ...salePrice > 0 ? [
            {
                label: 'Home sold',
                amount: salePrice
            },
            {
                label: 'Selling costs',
                amount: sellingCosts,
                note: 'agent, legal and moving costs'
            }
        ] : [],
        ...(0, $6cafaaa2bceecd94$export$4e25df6b98b4ff33)(details, deployment).map((d)=>/^new home$/i.test(d.label) ? {
                label: 'New home bought',
                amount: $a8ea1c05c1194ef5$var$n(d.amount)
            } : {
                label: d.label,
                amount: $a8ea1c05c1194ef5$var$n(d.amount)
            })
    ].filter((r)=>r.amount > 0);
    const amounts = {};
    for (const d of deployment){
        if (/^stamp duty/i.test(d.label)) continue;
        if (/super/i.test(d.label)) amounts.superContribution = (amounts.superContribution ?? 0) + $a8ea1c05c1194ef5$var$n(d.amount);
        if (/pension/i.test(d.label)) amounts.accountBasedPension = (amounts.accountBasedPension ?? 0) + $a8ea1c05c1194ef5$var$n(d.amount);
        if (/annuity/i.test(d.label)) {
            amounts.annuityNil = $a8ea1c05c1194ef5$var$n(d.amount);
            amounts.annuityReturned = $a8ea1c05c1194ef5$var$n(d.amount);
            amounts.annuityGuaranteed = $a8ea1c05c1194ef5$var$n(d.amount);
        }
        if (/property/i.test(d.label)) amounts.investmentProperty = $a8ea1c05c1194ef5$var$n(d.amount);
        if (/shares|managed/i.test(d.label)) amounts.shares = $a8ea1c05c1194ef5$var$n(d.amount);
        if (/funeral/i.test(d.label)) amounts.funeralBond = $a8ea1c05c1194ef5$var$n(d.amount);
        if (/gift/i.test(d.label)) amounts.gift = $a8ea1c05c1194ef5$var$n(d.amount);
        if (/bond/i.test(d.label) && !/funeral/i.test(d.label)) amounts.investmentBond = $a8ea1c05c1194ef5$var$n(d.amount);
    }
    const pieces = [
        ...newHome > 0 ? [
            {
                name: 'Buying a smaller home',
                what: 'The new home is exempt from the Age Pension test, like the old one. Stamp duty is paid on the way in.',
                amount: newHome
            }
        ] : [],
        ...sellAndRent ? [
            {
                name: 'Renting instead of buying',
                what: 'With no home, you are assessed as a non-homeowner: a higher assets-test limit, and Rent Assistance may be payable.',
                amount: null
            }
        ] : [],
        ...(0, $482dbb064a59e381$export$11e6b3c860abae6f)(kinds.filter((k)=>k !== 'sellHome' || salePrice > 0), amounts)
    ];
    /*
     * THE ONE LINE NAMES THE WHOLE PLAN (owner, 3 Oct 2026: the executive summary was "completely
     * silent on the investment property"). The sale and the home first, then every place the money
     * goes, from the evaluator's own breakdown — the same rows the card showed.
     */ const housing = sellAndRent ? `rent instead of buying${rentPerWeek > 0 ? ` (about ${$a8ea1c05c1194ef5$var$money(rentPerWeek)} a week)` : ''}` : newHome > 0 ? `buy a new home for ${$a8ea1c05c1194ef5$var$money(newHome)}${stampDuty > 0 ? ` plus ${$a8ea1c05c1194ef5$var$money(stampDuty)} stamp duty` : ''}` : '';
    /*
     * THE GUARANTEED INCOME IN THE WORDS FOR ITS TYPE (guaranteed income review, 21 Oct 2026): what the family
     * receives, never "nil residual", and never the money-back sentence for every type.
     */ const deferral = $a8ea1c05c1194ef5$var$n(deploy.annuityDeferralYears) > 0 ? `, starting in ${Math.round($a8ea1c05c1194ef5$var$n(deploy.annuityDeferralYears))} years` : '';
    const annuityWord = deploy.annuityType === 'fixedTerm' ? 'a guaranteed income for a set term' : deploy.annuityType === 'guaranteed' ? 'a guaranteed income for life that pays the full amount back to the family at any time' : $a8ea1c05c1194ef5$var$n(deploy.annuityResidualPercent) > 0 ? `a guaranteed income for life${deferral} that pays the money back to the family in the early years` : `a guaranteed income for life${deferral}, income only (nothing goes back to the family)`;
    const goesWords = [
        ...dzContribution > 0 ? [
            `put ${$a8ea1c05c1194ef5$var$money(dzContribution)} into super as a downsizer contribution`
        ] : [],
        ...$a8ea1c05c1194ef5$var$n(deploy.superContribution) + $a8ea1c05c1194ef5$var$n(deploy.partnerSuperContribution) > 0 ? [
            `put ${$a8ea1c05c1194ef5$var$money($a8ea1c05c1194ef5$var$n(deploy.superContribution) + $a8ea1c05c1194ef5$var$n(deploy.partnerSuperContribution))} into super as an after-tax contribution${deploy.superCommenceIncomeStream ? ' and start a pension from it' : ''}`
        ] : [],
        ...ipPrice > 0 ? [
            `buy an investment property for ${$a8ea1c05c1194ef5$var$money(ipPrice)}${ipDuty > 0 ? ` (plus ${$a8ea1c05c1194ef5$var$money(ipDuty)} stamp duty)` : ''}`
        ] : [],
        ...$a8ea1c05c1194ef5$var$n(deploy.shares) > 0 ? [
            `invest ${$a8ea1c05c1194ef5$var$money($a8ea1c05c1194ef5$var$n(deploy.shares))} in shares or managed funds`
        ] : [],
        ...$a8ea1c05c1194ef5$var$n(deploy.investmentBond) > 0 ? [
            `put ${$a8ea1c05c1194ef5$var$money($a8ea1c05c1194ef5$var$n(deploy.investmentBond))} into an investment bond`
        ] : [],
        ...$a8ea1c05c1194ef5$var$n(deploy.annuity) > 0 ? [
            `put ${$a8ea1c05c1194ef5$var$money($a8ea1c05c1194ef5$var$n(deploy.annuity))} into ${annuityWord}`
        ] : [],
        ...$a8ea1c05c1194ef5$var$n(details.funeralBondPurchase) > 0 ? [
            `put ${$a8ea1c05c1194ef5$var$money($a8ea1c05c1194ef5$var$n(details.funeralBondPurchase))} into a funeral bond`
        ] : [],
        ...$a8ea1c05c1194ef5$var$n(details.giftingAmount) > 0 ? [
            `gift ${$a8ea1c05c1194ef5$var$money($a8ea1c05c1194ef5$var$n(details.giftingAmount))} to family`
        ] : []
    ];
    const kept = {
        amount: (0, $6cafaaa2bceecd94$export$ba4ded872bfc6459)(details).bank
    };
    const oneLine = salePrice > 0 ? `Sell the home for about ${$a8ea1c05c1194ef5$var$money(salePrice)} (less ${$a8ea1c05c1194ef5$var$money(sellingCosts)} in selling costs)${housing ? `, ${housing}` : ''}${buyUp > 0 ? `, with ${$a8ea1c05c1194ef5$var$money(buyUp)} of the price topped up from savings` : ''}${goesWords.length ? `, and ${goesWords.join(', ')}` : ''}${kept && $a8ea1c05c1194ef5$var$n(kept.amount) > 0 ? `${goesWords.length ? ',' : ', and'} keep ${$a8ea1c05c1194ef5$var$money($a8ea1c05c1194ef5$var$n(kept.amount))} in the bank` : ''}.` : strategy.description || '';
    const reserve = (0, $d50f5b54e8b24258$export$f6a66feacdeaef0e)(factFind, p.setup ?? null);
    const inBrief = [
        oneLine,
        freed > 0 ? `That frees up about ${$a8ea1c05c1194ef5$var$money(freed)}, which the plan puts to work as the pieces above describe.` : buyUp > 0 ? `The new home costs ${$a8ea1c05c1194ef5$var$money(buyUp)} more than the sale leaves, so money moves from being counted by Centrelink into an exempt home.` : '',
        ...(0, $482dbb064a59e381$export$64ada78711707257)(headline, baseline, years),
        `${$a8ea1c05c1194ef5$var$money(reserve)} is kept in the bank for emergencies: it is held back when the money moves, and drawn on only if a year runs short.`
    ].filter(Boolean);
    /*
     * WHY THE ESTATE MOVES (owner, 3 Oct 2026): the reasons, one per line with its amount — the
     * recap's list, not a bare "worse by $163,072" — and, where the setup asked, the reason for
     * the move beside it, so a lifestyle decision is read as one.
     */ const pensionDelta = Math.round(headline.pension - baseline.pension);
    const estateDrivers = [
        ...sellingCosts > 0 ? [
            {
                text: 'Selling costs leave the estate on the day and never come back',
                amount: sellingCosts,
                sign: 'minus'
            }
        ] : [],
        ...stampDuty > 0 ? [
            {
                text: 'Stamp duty on the new home is a cost of the changeover, gone for good',
                amount: stampDuty,
                sign: 'minus'
            }
        ] : [],
        ...ipDuty > 0 ? [
            {
                text: 'Stamp duty on the investment property leaves the proceeds (it sits in its cost base for tax)',
                amount: ipDuty,
                sign: 'minus'
            }
        ] : [],
        ...pensionDelta !== 0 ? [
            {
                text: `${pensionDelta > 0 ? 'More' : 'Less'} Age Pension, compounding over the ${years} years`,
                amount: Math.abs(pensionDelta),
                perYear: true,
                sign: pensionDelta > 0 ? 'plus' : 'minus'
            }
        ] : [],
        ...sellAndRent ? [
            {
                text: `Rent is paid from the savings every year${rentPerWeek > 0 ? ` (about ${$a8ea1c05c1194ef5$var$money(Math.round(rentPerWeek * 52))} a year, rising with inflation)` : ''}, and there is no longer a home growing in the background`,
                amount: rentPerWeek > 0 ? Math.round(rentPerWeek * 52) : null,
                perYear: rentPerWeek > 0,
                sign: 'minus'
            }
        ] : [],
        ...!sellAndRent && newHome > 0 ? [
            {
                text: `A ${$a8ea1c05c1194ef5$var$money(newHome)} home grows instead of the ${$a8ea1c05c1194ef5$var$money(salePrice)} one \u{2014} ${newHome < salePrice ? 'less' : 'more'} growing where it is not counted`,
                sign: 'neutral'
            }
        ] : [],
        ...freed > 0 ? [
            {
                text: "The money freed up grows where it is put to work \u2014 and the growth is counted and taxed there",
                amount: freed,
                sign: 'neutral'
            }
        ] : [],
        ...kinds.includes('annuityNil') ? [
            {
                text: 'The guaranteed income is income only: nothing of its price goes back to the family; its value is the income for life',
                sign: 'minus'
            }
        ] : []
    ];
    const motive = p.setup?.motive;
    const estateBehind = headline.estate < baseline.estate - 1;
    const motiveNote = estateBehind ? motive === 'home' ? `You told us you are moving for a home that suits you better, and that the money is secondary. The estate ends behind ${baseline.name.toLowerCase()} mainly because the costs of selling and buying are gone for good; the move buys a home that fits your life, which is the point of it. The figures show what that costs, so the decision is made with eyes open.` : motive === 'money' ? `You told us you are moving to free up money. The estate ends behind ${baseline.name.toLowerCase()} because the costs of selling and buying are gone for good and the money freed up is counted where the home was not \u{2014} the "downsizing trap" this advice weighs for you. The trade is money you can use now against money left later.` : `An estate that ends behind ${baseline.name.toLowerCase()} is not, on its own, a reason not to move: the costs of selling and buying are gone for good, but a home that suits your life has a value the projection cannot count. The figures show what the move costs, so the decision is made with eyes open.` : null;
    const stayPutStrategy = p.all.find((s)=>String(s.id) === 'dz-stay-put') || null;
    const allEvaluated = p.all.filter((s)=>String(s.id) !== 'dz-stay-put').map((s)=>{
        const ss = s.snapshot || {};
        return {
            name: (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(s, factFind).title,
            description: (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(s, factFind).sub,
            pension: $a8ea1c05c1194ef5$var$n(ss.pension),
            cashflow: $a8ea1c05c1194ef5$var$n(ss.netCashflow),
            estate: $a8ea1c05c1194ef5$var$n(ss.legacyValue),
            selected: s.id === strategy.id,
            badges: (s.recommendationLabels || []).map((0, $400a08a42b233386$export$da83f84a5a007a8a)),
            sensitivity: (0, $d50f5b54e8b24258$export$2cbcd11218125c86)(s)
        };
    });
    /*
     * THE GUARANTEED INCOME PAGE (guaranteed income review, 21 Oct 2026; soaGuaranteedIncome.ts): for a plan
     * with a guaranteed income for life, what the family receives if the person passes away, set against the
     * same sale with the money invested instead (the tested twin, when it was evaluated), and the best plan
     * tested without a guaranteed income as the alternative. Not for a set term.
     */ const sibling = gi ? (0, $ed6c3bc1777d5c34$export$7e3067ac8807505a)(strategy.id, p.all) : null;
    const best = gi ? p.all.filter((s)=>String(s.id) !== 'dz-stay-put' && s.id !== strategy.id && !(0, $d50f5b54e8b24258$export$2cbcd11218125c86)(s)).filter((s)=>!($a8ea1c05c1194ef5$var$n((s.inputs || {}).deployment?.annuity) > 0)).reduce((top, s)=>top == null || $a8ea1c05c1194ef5$var$n(s.snapshot?.legacyValue) > $a8ea1c05c1194ef5$var$n(top.snapshot?.legacyValue) ? s : top, null) : null;
    const guaranteedIncome = gi && gi.annuityType !== 'fixedTerm' ? (0, $66827b1304244a1d$export$11aaa304d9182b)({
        factFind: factFind,
        personName: gi.personName,
        amount: gi.amount,
        kind: gi.kind,
        incomeAYear: gi.incomeAYear ?? ($a8ea1c05c1194ef5$var$n(deploy.annuityIncomeOverride) > 0 ? $a8ea1c05c1194ef5$var$n(deploy.annuityIncomeOverride) : null),
        quoted: quoted,
        rows: rows,
        compareRows: sibling?.projections ?? null,
        compareNote: sibling ? (0, $ed6c3bc1777d5c34$export$2d8e7d1fb8934a4c) : null,
        horizonYears: years,
        plan: {
            estate: headline.estate,
            pension: headline.pension,
            cashflow: headline.cashflow
        },
        alternative: best ? {
            name: (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(best, factFind).title,
            estate: $a8ea1c05c1194ef5$var$n(best.snapshot?.legacyValue),
            pension: $a8ea1c05c1194ef5$var$n(best.snapshot?.pension),
            cashflow: $a8ea1c05c1194ef5$var$n(best.snapshot?.netCashflow)
        } : null
    }) : null;
    const alternatives = p.all.filter((s)=>(s.recommendationLabels || []).length > 0 || s.id === strategy.id).map((s)=>{
        const ss = s.snapshot || {};
        return {
            name: (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(s, factFind).title,
            description: (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(s, factFind).sub,
            pension: $a8ea1c05c1194ef5$var$n(ss.pension),
            cashflow: $a8ea1c05c1194ef5$var$n(ss.netCashflow),
            estate: $a8ea1c05c1194ef5$var$n(ss.legacyValue),
            selected: s.id === strategy.id,
            badges: (s.recommendationLabels || []).map((0, $400a08a42b233386$export$da83f84a5a007a8a))
        };
    });
    return {
        ...common,
        decisionIntro: `You are weighing selling the family home${newHome > 0 ? ' and buying a smaller one' : ''}. This advice is about what to do with the money that frees up, and what each choice does to your Age Pension, your yearly cashflow and what is left to the family.`,
        // The plan in the words its card used (dzPlanWords.ts), so the document names what the client chose.
        selectedStrategyName: (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(strategy, factFind).title,
        selectedStrategyDescription: (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(strategy, factFind).sub,
        inOneLine: oneLine || `${strategy.name}.`,
        inBrief: inBrief,
        pieces: pieces,
        moneyFlow: moneyFlow,
        legacyYears: years,
        headline: headline,
        baseline: baseline,
        whyItFits: (0, $482dbb064a59e381$export$64ada78711707257)(headline, baseline, years),
        estateDrivers: estateDrivers,
        motiveNote: motiveNote,
        modulePage: salePrice > 0 ? {
            title: 'The sale and the new home',
            intro: 'Downsizing has two money moments: what the sale brings in after costs, and what the new home takes out. What is left is the money this advice is about.',
            rows: [
                {
                    label: 'Sale price of the home',
                    amount: salePrice
                },
                {
                    label: 'Selling costs',
                    amount: sellingCosts,
                    note: 'agent, legal and moving'
                },
                ...newHome > 0 ? [
                    {
                        label: p.homeName ? `New home, ${p.homeName}` : 'New home',
                        amount: newHome
                    },
                    {
                        label: 'Stamp duty',
                        amount: stampDuty,
                        note: stampDuty > 0 ? 'estimated from the state scale, no concessions' : "not modelled \u2014 no state chosen"
                    }
                ] : [],
                {
                    label: 'Freed up',
                    amount: freed,
                    note: 'what the plan puts to work'
                }
            ],
            // Said only where the plan makes one — a rule the plan does not use is noise (owner, 3 Oct 2026).
            footnote: dzContribution > 0 ? 'A downsizer contribution to super must be made within 90 days of settlement, from the proceeds of a home you have owned for at least ten years, and can only be made once.' : undefined
        } : null,
        moduleCostLabel: '',
        projectionConvention: 'Year 1 is the first full year after the sale settles; each later year follows it.',
        alternatives: alternatives,
        allEvaluated: allEvaluated,
        totalEvaluated: p.all.filter((s)=>String(s.id) !== 'dz-stay-put' && !(0, $d50f5b54e8b24258$export$2cbcd11218125c86)(s)).length,
        projections: $a8ea1c05c1194ef5$var$projRows(rows, years),
        baselineProjections: $a8ea1c05c1194ef5$var$projRows(stayPutStrategy?.projections, years),
        ...p.periodMode ? {
            periodMode: p.periodMode
        } : {},
        guaranteedIncome: guaranteedIncome,
        replacements: (0, $482dbb064a59e381$export$caf941bdb2b0342e)(kinds, moneyFlow),
        implications: [
            ...salePrice > 0 && !sellAndRent ? [
                {
                    title: 'The sale proceeds are exempt for a time',
                    lead: 'Money from selling a home is exempt from the assets test for up to 24 months while you intend to buy another.',
                    body: 'It is still deemed for the income test at the lower rate. Tell Services Australia when the home is sold and again when the new home settles.'
                }
            ] : [],
            ...sellAndRent ? [
                {
                    title: 'Renting changes how you are assessed',
                    lead: 'With no home, you are a non-homeowner: a higher assets-test limit, and Rent Assistance on the rent.',
                    body: `The rent${rentPerWeek > 0 ? ` of about ${$a8ea1c05c1194ef5$var$money(rentPerWeek)} a week` : ''} is charged every year and rises with inflation in the projection; Rent Assistance is assessed on it and paid with the pension. Tell Services Australia the rent you pay and keep the lease.`
                }
            ] : [],
            ...stampDuty > 0 || newHome > 0 ? [
                {
                    title: 'Stamp duty on the new home',
                    lead: stampDuty > 0 ? `About ${$a8ea1c05c1194ef5$var$money(stampDuty)}, on the state's standard scale with no concessions.` : 'No state was chosen, so no duty is in the figures.',
                    body: 'Pensioner, seniors or first-home concessions can reduce it. Confirm the duty with a conveyancer in the state you are buying in; where it differs, re-run the analysis on the real figure.'
                }
            ] : [],
            ...dzContribution > 0 ? [
                {
                    title: 'The downsizer contribution has a clock',
                    lead: 'It must be made within 90 days of settlement.',
                    body: "Check the eligibility rules with your super fund before settlement \u2014 55 or over, the home owned for ten years, once only \u2014 and keep the contract and settlement statement as evidence."
                }
            ] : [],
            ...ipPrice > 0 ? [
                {
                    title: 'The investment property rests on assumptions',
                    lead: `Bought for ${$a8ea1c05c1194ef5$var$money(ipPrice)}${ipDuty > 0 ? ` plus ${$a8ea1c05c1194ef5$var$money(ipDuty)} stamp duty` : ''}, earning ${(0, $0f2c0a6799fe36da$export$b037eefb915b86ec).propertyYieldPct.toFixed(1)}% gross rent less ${(0, $6ee1c1106c00a64d$export$ccb8ef6339a33b59)}, and growing ${(0, $0f2c0a6799fe36da$export$b037eefb915b86ec).propertyGrowthPct.toFixed(1)}% a year.`,
                    body: 'These are the tool\'s standard figures for a property that does not exist yet, not a forecast of one you have chosen. In Manual Control you can enter the price, rent, expenses and growth of a property you are looking at, and the projections re-run on your figures.'
                },
                {
                    title: 'Capital gains tax when the property is sold',
                    lead: 'An investment property is not your home, so a gain on it is taxed when it is sold.',
                    body: `The cost base includes the purchase price${ipDuty > 0 ? ', the stamp duty' : ''} and buying costs. The projection carries the property to the horizon at its value; the figure left to the family is after the capital gains tax that would be paid on selling it, estimated at the household\u{2019}s own tax rates. Confirm the tax with a registered tax agent before any sale.`
                },
                {
                    title: 'The rent is counted and taxed',
                    lead: 'Centrelink counts the net rent as income, and it is taxable.',
                    body: 'Rent can stop between tenants, and rates, insurance and maintenance continue whether or not it does. A property is slow and costly to sell if money is needed in a hurry.'
                }
            ] : [],
            ...$a8ea1c05c1194ef5$var$n(deploy.shares) > 0 ? [
                {
                    title: 'Shares and managed funds are priced on your investment approach',
                    lead: 'The return assumed is the one recorded in your profile (Conservative where none is).',
                    body: 'Returns are not guaranteed and values move; a different approach changes the figures. You can change it in the client profile and re-run.'
                }
            ] : [],
            ...kinds.includes('annuityNil') || kinds.includes('annuityReturned') || kinds.includes('annuityGuaranteed') ? [
                {
                    title: 'The guaranteed income needs a written quote',
                    lead: quoted ? "The income shown is the provider\u2019s quote, scaled to this amount." : 'The income shown is our estimate from published rates, not a quote.',
                    body: 'Get a written quote from the insurer before buying; if it differs, re-run the analysis on the real figure.'
                }
            ] : [],
            {
                title: 'Tell Services Australia',
                lead: 'Each of these moves changes what is counted.',
                body: 'Report the sale, the purchase and where the money went within 14 days, so the pension is reassessed on the new figures.'
            }
        ],
        scope: {
            inScope: [
                'What to do with the money freed up by selling the home, using the sale and purchase figures you entered.',
                ...(0, $482dbb064a59e381$export$472dfc9f05c9ea81)
            ],
            outOfScope: [
                "Whether to sell at all, and what the home or the new home is worth \u2014 those are your decisions and your valuers' figures.",
                ...(0, $482dbb064a59e381$export$b73d600a5ab2902f)(factFind)
            ]
        },
        nextSteps: [
            'Get two or three appraisals on the home, and a clear estimate of selling and moving costs.',
            ...newHome > 0 ? [
                'Confirm stamp duty and any concession you qualify for with a conveyancer in the state you are buying in.'
            ] : [],
            ...kinds.includes('superContribution') ? [
                'Confirm downsizer-contribution eligibility with your super fund before settlement.'
            ] : [],
            sellAndRent ? 'Tell Services Australia within 14 days of the sale, with the rent you will pay.' : 'Tell Services Australia within 14 days of the sale and again when the new home settles; money set aside for the new home is exempt for up to 24 months.',
            'Where you sell assets or trigger capital gains tax, confirm the tax with a registered tax agent before you act.'
        ]
    };
}
















/**
 * "Your plan, in plain words" — the Downsizer module's interpretation layer, the same guided-UX
 * pattern as the Aged Care module (owner direction, 2026-08-25: port the design principles across
 * every module). Sentences for people who don't read the input cards above, then the pension and
 * cashflow movements as ShiftRows with driver-named whys. Content transposed from
 * DownsizerInsightPanel's narratives (the downsizing trap, the buy-up story, the self-funded
 * case), so the closable panel and this always-visible card tell one story.
 *
 * CALCULATION DISCIPLINE — every figure is quoted from `panelModel`, the SAME object that feeds
 * the Financial Impact panel and the insight panel, for whichever view is live (manual settings or
 * the selected Suggestion Engine strategy). Nothing is re-derived, so this card cannot disagree
 * with the panels beside it.
 */ 
parcelRequire("acw62");






const $e49e8af2e37bf019$var$DownsizerPlanRecap = ({ model: model, giftingAmount: giftingAmount = 0, baselineLegacy: baselineLegacy = null, legacyYears: legacyYears = 5, factFind: factFind = null, hideSummary: hideSummary = false, eyebrow: eyebrow = 'Your plan summary' })=>{
    const fin = model.insightFinancials;
    if (!model.hasDownsize || !fin) return null;
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const pensionBefore = fin.agePensionBefore ?? 0;
    const pensionAfter = fin.agePensionAfter ?? 0;
    const cashflowBefore = model.before?.cashFlow ?? 0;
    const cashflowAfter = fin.cashflowAfter ?? 0;
    const pensionDelta = Math.round(pensionAfter) - Math.round(pensionBefore);
    const isBuyUp = model.buyUpShortfall > 0;
    /* A shortfall can come from the price OR from stamp duty on a home that is not dearer at all (a $2.73m
       home bought from a $2.8m sale): the words must follow which (review, 18 Oct 2026). */ const isDearer = model.newHomePrice > model.salePrice - model.sellingCosts;
    const selfFunded = pensionBefore <= 0;
    const isSeView = !!model.name;
    const gift = isSeView ? 0 : giftingAmount;
    const giftExcess = Math.max(0, gift - (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0));
    /*
     * Driver-named whys, never generic — the aged care module's rule. Each explanation quotes the
     * same figures as the sentences above it and names what actually moved this client's pension.
     */ const pensionWhy = isBuyUp ? pensionDelta > 0 ? isDearer ? `The new home and its costs come to more than the sale leaves, so ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.buyUpShortfall)} of savings and investments Centrelink was counting moved into an exempt home or was spent on it. Less counted, more pension. The trade-off: those assets were earning income, and the money is no longer easy to reach.` : `The whole sale goes into the new home, and ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.buyUpShortfall)} of savings Centrelink was counting pays the stamp duty and costs. That money is gone, so less is counted and the pension rises. The trade-off: it no longer earns income, and it does not come back.` : `Moving ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.buyUpShortfall)} into the exempt home takes it out of the assets test, but other effects (like the income those assets were earning) offset it here.` : model.sellAndRent ? `Renting makes ${v.names} ${v.couple ? 'non-homeowners' : 'a non-homeowner'}: the whole ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.salePrice)} of home equity becomes money Centrelink counts and deems, though non-homeowners get a higher assets-test threshold and possibly Rent Assistance. The net of those is what the figures show.` : selfFunded ? `No Age Pension is being received today, so the usual downsizing trap \u{2014} freed-up cash reducing the pension \u{2014} doesn't bite. The planning is in where the proceeds go (super, an income stream, the downsizer contribution).` : pensionDelta < 0 ? `The home didn't count for the pension; the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.freedCapital)} it freed up does \u{2014} Centrelink counts it in the assets test and deems income on it. If the move is really about a more suitable home, buying one of similar value keeps the pension unchanged.` : pensionDelta > 0 ? `Money moved from counted assets into exempt ones, so Centrelink counts less than before.` : `Where ${v.names} sit${v.s} on the means test, the freed money doesn't shift the pension. A similar-value home would leave it unchanged too.`;
    const cashflowDrivers = [];
    if (model.sellAndRent) cashflowDrivers.push('rent now has to be paid, with any Rent Assistance helping offset it');
    if (isBuyUp) cashflowDrivers.push(isDearer ? `the assets sold to fund the dearer home stop earning their income` : `the savings spent on stamp duty stop earning their income`);
    if (!model.sellAndRent && !isBuyUp && model.freedCapital > 0) cashflowDrivers.push(`the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.freedCapital)} freed up starts earning where it is deployed`);
    if (pensionDelta !== 0) cashflowDrivers.push(`the Age Pension is ${pensionDelta > 0 ? 'higher' : 'lower'} (${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pensionBefore)} \u{2192} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(pensionAfter)} a year)`);
    const cashflowWhy = `A full year of money in, less money out.` + (cashflowDrivers.length > 0 ? ` What changes it: ${cashflowDrivers.join('; ')}.` : '');
    /*
     * THE ESTATE, AND WHAT DECIDES IT. Both sides are projected over the same years from the same
     * engine — this move against simply not making it — so the comparison is like for like. The
     * reason names the three things that actually move it, and says plainly that the transaction
     * costs are gone for good, which is the part clients most often do not expect.
     */ const legacyAfter = fin.legacyEstimate ?? null;
    const legacyDelta = baselineLegacy != null && legacyAfter != null ? Math.round(legacyAfter - baselineLegacy) : null;
    const legacyDrivers = [];
    if (model.sellingCosts > 0) legacyDrivers.push({
        text: 'Selling costs leave the estate on the day and never come back',
        amount: model.sellingCosts,
        sign: 'minus'
    });
    if ((model.stampDuty ?? 0) > 0) legacyDrivers.push({
        text: 'Stamp duty on the new home is a cost of the changeover, gone for good',
        amount: model.stampDuty ?? 0,
        sign: 'minus'
    });
    if (pensionDelta !== 0) legacyDrivers.push({
        text: `${pensionDelta > 0 ? 'More' : 'Less'} Age Pension, compounding over the ${legacyYears} ${legacyYears === 1 ? 'year' : 'years'}`,
        amount: Math.abs(pensionDelta),
        suffix: 'a year',
        sign: pensionDelta > 0 ? 'plus' : 'minus'
    });
    if (!model.sellAndRent && model.newHomePrice > 0) legacyDrivers.push({
        text: `The ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.newHomePrice)} home grows instead of the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.salePrice)} one`,
        sign: 'neutral'
    });
    if (model.sellAndRent) legacyDrivers.push({
        text: 'There is no longer a home growing in the background, and rent is paid from the savings',
        sign: 'minus'
    });
    if (model.freedCapital > 0) legacyDrivers.push({
        text: 'The money freed up grows where it is deployed',
        amount: model.freedCapital,
        sign: 'plus'
    });
    const legacyWhy = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$721778c36dbce7e7), {
        lead: `Both figures are projected over the same ${legacyYears} ${legacyYears === 1 ? 'year' : 'years'} \u{2014} this move against not downsizing \u{2014} so they can be compared directly.`,
        drivers: legacyDrivers
    });
    const planPieces = [];
    if (model.salePrice > 0) planPieces.push({
        key: 'sell-home',
        name: 'Sell the family home',
        amount: model.salePrice,
        what: `The home is sold; after ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.sellingCosts)} of selling costs the money buys the next home and frees the rest. The home was exempt; whatever is not put into the next home becomes money Centrelink counts.`
    });
    if (!model.sellAndRent && model.newHomePrice > 0) planPieces.push({
        key: 'new-home',
        name: model.newHomePrice > model.salePrice ? 'Buy a dearer home' : model.newHomePrice < model.salePrice ? 'Buy a smaller home' : 'Buy the next home',
        amount: model.newHomePrice,
        what: 'The new home is the principal residence, so it is exempt from the assets test while it is lived in. Stamp duty on the purchase is charged where a state was chosen.',
        glossaryTerm: 'home exemption cap'
    });
    if (model.sellAndRent) planPieces.push({
        key: 'rent',
        name: 'Rent instead of buying',
        what: `No new home is bought; rent is paid from the freed-up money. Without a home of ${v.their} own, the whole amount is counted, and Rent Assistance may be payable.`,
        glossaryTerm: 'rent assistance'
    });
    if (model.downsizerContribution > 0) planPieces.push({
        key: 'downsizer',
        name: 'Downsizer contribution into super',
        amount: model.downsizerContribution,
        what: 'A special rule lets each person aged 55 or over put up to $300,000 from selling their home into super, on top of the usual limits. Inside super the earnings are taxed at no more than 15%.',
        glossaryTerm: 'downsizer contribution'
    });
    if (model.freedCapital > 0) planPieces.push({
        key: 'freed',
        name: 'Money freed up',
        amount: model.freedCapital,
        what: 'What the sale leaves after the next home and its costs. Wherever it is kept or invested, it is counted in full as an asset and deemed to earn income.',
        glossaryTerm: 'deeming'
    });
    if (giftingAmount > 0) planPieces.push({
        key: 'gift',
        name: 'Gift to family',
        amount: giftingAmount,
        what: 'Money given away. Up to $10,000 a year ($30,000 over five years) leaves the means tests straight away; anything above that is still counted for five years.',
        glossaryTerm: 'gifting'
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$28c8139bd562d0e), {
                eyebrow: eyebrow,
                className: "mt-6",
                children: [
                    !hideSummary && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-1.5 text-sm leading-relaxed text-slate-700",
                        children: [
                            model.sellAndRent ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "Selling the ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.salePrice),
                                    " home and renting frees up all of the equity \u2014 but as a non-homeowner, Centrelink counts that money and ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                        term: "deems",
                                        children: 'Centrelink assumes financial assets earn a set rate of income (deeming) and counts that income in the pension income test, whatever they actually earn.'
                                    }),
                                    " income on it. ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                        term: "Rent Assistance"
                                    }),
                                    " may help with the rent."
                                ]
                            }) : isBuyUp ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: isDearer ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        "Selling for ",
                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.salePrice),
                                        " and buying a dearer home for",
                                        ' ',
                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.newHomePrice),
                                        " moves",
                                        ' ',
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold text-slate-900",
                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.buyUpShortfall)
                                        }),
                                        " of countable savings into the new home and its costs \u2014 which Centrelink doesn't count at all."
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        "Selling for ",
                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.salePrice),
                                        " and buying for ",
                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.newHomePrice),
                                        " uses the whole sale, and ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold text-slate-900",
                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.buyUpShortfall)
                                        }),
                                        " of savings pays the stamp duty and costs. The new home isn't counted, and the money spent is gone."
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "Selling for ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.salePrice),
                                    " and buying for ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.newHomePrice),
                                    ' ',
                                    "frees up ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-semibold text-slate-900",
                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.freedCapital)
                                    }),
                                    ".",
                                    model.downsizerContribution > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            ' ',
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(model.downsizerContribution),
                                            " of it goes into super as a",
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                                term: "downsizer contribution"
                                            }),
                                            " \u2014 Centrelink counts that from pension age."
                                        ]
                                    }),
                                    gift > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            " ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(gift),
                                            " is gifted."
                                        ]
                                    })
                                ]
                            }),
                            !model.sellAndRent && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-xs text-slate-500",
                                children: [
                                    "If there's a gap between selling and buying, the money set aside for the new home stays exempt for up to 24 months \u2014 the ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                        term: "home sale proceeds exemption"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: hideSummary ? '' : 'mt-3 border-t border-slate-100 pt-3',
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$e95813558e26ce51), {
                                variant: "expanded",
                                label: "Age Pension",
                                before: pensionBefore,
                                after: pensionAfter,
                                why: pensionWhy
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$e95813558e26ce51), {
                                variant: "expanded",
                                label: "Yearly cashflow",
                                before: cashflowBefore,
                                after: cashflowAfter,
                                why: cashflowWhy
                            }),
                            legacyDelta != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$e95813558e26ce51), {
                                variant: "expanded",
                                label: `Estate after ${legacyYears} ${legacyYears === 1 ? 'year' : 'years'} (vs not downsizing)`,
                                before: baselineLegacy,
                                after: legacyAfter,
                                suffix: "",
                                why: legacyWhy
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-1 text-[11px] text-slate-400",
                        children: 'For the Age Pension and cashflow, "before" is today, keeping the home; "after" is the plan\'s first year. The estate compares two projections over the same years, not today\'s figure.'
                    }),
                    giftExcess > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 rounded-lg border border-slate-200/70 border-l-4 border-l-amber-500 bg-white px-3 py-2 text-sm leading-relaxed text-amber-900 shadow-sm",
                        children: [
                            "The ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(giftExcess),
                            " gifted above the yearly free area still counts for five years under the ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357e6188006bbf96$export$18c1070e2827c601), {
                                term: "deprivation"
                            }),
                            " rules."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1f2b2692daf0da1$export$d520641036c1ebe9), {
                className: "mt-4",
                pieces: planPieces
            })
        ]
    });
};
var $e49e8af2e37bf019$export$2e2bcd8739ae039 = $e49e8af2e37bf019$var$DownsizerPlanRecap;





















/**
 * Step 1 — the sale and the new home (downsizing rebuild, 21 Oct 2026; the agreed mock-up's j1-step1).
 *
 * Top to bottom: the primer, shown once (the downsizing trap, buying dearer, stamp duty, the downsizer
 * contribution); the sale, prefilled from the profile; buy another home, rent instead, or compare both — asked
 * here, not in a pop-over (review decision 2); the new home's price, or "test a range"; the weekly rent; the
 * state, from the file where it is recorded, with the stamp duty for every price tested shown on the step
 * (review decision 1: duty is never silently off). Every answer is kept on the file (goals.dz*), so a return
 * never resets it.
 */ 

var $acw62 = parcelRequire("acw62");









function $b0451585083b21c1$export$7706c53b2f791524(salePrice, sellingCosts, namedPrice) {
    if (namedPrice > 0) return [
        {
            label: 'the home',
            price: Math.round(namedPrice)
        }
    ];
    const net = Math.max(0, salePrice - sellingCosts);
    const out = [
        {
            label: 'a cheaper home',
            price: Math.round(salePrice * 0.6)
        },
        {
            label: 'a smaller home',
            price: Math.round(salePrice * 0.7)
        },
        {
            label: 'a home at a similar price',
            price: Math.round(net)
        },
        {
            label: 'a dearer home',
            price: Math.round(salePrice * 1.15)
        }
    ];
    return out.filter((p)=>p.price > 0);
}
function $b0451585083b21c1$export$a597c8d4cd87c330(factFind) {
    const g = factFind?.goals || {};
    if (typeof g.dzNewHomeState === 'string') return {
        code: (0, $30ff538d4b47bf21$export$96fdbeb3c760993a)(g.dzNewHomeState) ? g.dzNewHomeState : '',
        fromFile: false
    };
    const d = (0, $6b146b31ad2b1e77$export$c4b416b99a9a4a71)(factFind);
    return {
        code: d,
        fromFile: !!d
    };
}
const $b0451585083b21c1$var$card = 'rounded-2xl border border-slate-200 bg-white p-6 shadow-card';
const $b0451585083b21c1$var$label = 'text-[13px] font-semibold text-slate-600';
const $b0451585083b21c1$var$input = 'rounded-lg border border-slate-300 bg-white px-3 py-2 text-[15px] font-semibold text-slate-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-500';
const $b0451585083b21c1$var$link = 'font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy';
const $b0451585083b21c1$var$Choice = ({ value: value, options: options, onChange: onChange, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-wrap gap-2",
        role: "radiogroup",
        "data-testid": testId,
        children: options.map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                role: "radio",
                "aria-checked": value === o.id,
                onClick: ()=>onChange(o.id),
                "data-testid": testId ? `${testId}-${o.id}` : undefined,
                className: `rounded-lg border px-3.5 py-2 text-[14px] font-semibold ${value === o.id ? 'border-blue-600 bg-blue-50 text-brand-navy' : 'border-slate-300 bg-white text-slate-700 hover:border-blue-300'}`,
                children: [
                    value === o.id ? "\u2713 " : '',
                    o.label
                ]
            }, o.id))
    });
const $b0451585083b21c1$var$DzStep1 = ({ factFind: factFind, setFactFind: setFactFind, sale: sale, onSale: onSale, onNext: onNext, onReadGuide: onReadGuide })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const goals = factFind?.goals || {};
    const setGoal = (patch)=>setFactFind?.((prev)=>({
                ...prev,
                goals: {
                    ...prev?.goals || {},
                    ...patch
                }
            }));
    const homeValue = parseFloat(String(factFind?.home?.value ?? '')) || 0;
    const housing = goals.dzHousing === 'rent' || goals.dzHousing === 'both' ? goals.dzHousing : 'buy';
    const buys = housing !== 'rent';
    const rents = housing !== 'buy';
    const named = Number(goals.dzNewHomePrice) > 0 ? Number(goals.dzNewHomePrice) : 0;
    const [rangeMode, setRangeMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(!(named > 0));
    const rent = Number(goals.dzRentPerWeek) > 0 ? Number(goals.dzRentPerWeek) : 0;
    const st = $b0451585083b21c1$export$a597c8d4cd87c330(factFind);
    const stateName = (0, $669f0c9987a611db$export$2f609b1773ce8fef).find((s)=>s.code === st.code)?.name ?? '';
    const { netProceeds: netProceeds } = (0, $6b146b31ad2b1e77$export$855cd09595261b3b)({
        salePrice: sale.salePrice,
        sellingCosts: sale.sellingCosts,
        newHomePrice: 0,
        stampDuty: 0,
        sellAndRent: true
    });
    const prices = $b0451585083b21c1$export$7706c53b2f791524(sale.salePrice, sale.sellingCosts, rangeMode ? 0 : named);
    const similar = Math.round(netProceeds);
    const similarDuty = st.code ? (0, $6b146b31ad2b1e77$export$a8a5bac4bde49384)(st.code, similar) : 0;
    const rentMissing = rents && !(rent > 0);
    const [showExemption, setShowExemption] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // The primer is shown once, then folds to one line that opens it again.
    const primerSeen = goals.dzPrimerSeen === true;
    const [primerOpen, setPrimerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(!primerSeen);
    (0, $acw62.useEffect)(()=>{
        if (!primerSeen) setGoal({
            dzPrimerSeen: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // The guide links: under the open primer, beside "Show" when it is folded (23 Oct 2026).
    const primerLinks = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onReadGuide,
                className: $b0451585083b21c1$var$link,
                children: "Read the full guide"
            }),
            " \xb7 ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: ()=>setShowExemption((o)=>!o),
                "aria-expanded": showExemption,
                className: $b0451585083b21c1$var$link,
                "data-testid": "dz-exemption-link",
                children: [
                    "The 24-month exemption while ",
                    v.you ? 'you buy' : `${v.they} buy`
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        "data-testid": "dz-step1",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: `${$b0451585083b21c1$var$card} ${(0, $e1e942361049df06$export$10832a06bd6966f8)}`,
                "data-testid": "dz-primer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1e942361049df06$export$eb5dff254945ec0e), {
                        title: "Downsizing, in a minute",
                        open: primerOpen,
                        onToggle: ()=>setPrimerOpen((o)=>!o),
                        aside: primerLinks,
                        testId: "dz-primer-toggle"
                    }),
                    primerOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3 grid grid-cols-1 gap-x-7 gap-y-2 text-[14px] leading-relaxed text-slate-700 md:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: (0, $e1e942361049df06$export$60f4f4563d451e62),
                                        children: "The home isn't counted for the Age Pension; money is."
                                    }),
                                    " Buy cheaper and the money ",
                                    v.you ? 'you free' : 'the sale frees',
                                    " is counted. That is the downsizing trap."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: (0, $e1e942361049df06$export$60f4f4563d451e62),
                                        children: "Buy dearer, and the reverse happens:"
                                    }),
                                    " savings move into a home that isn't counted, and the pension can rise."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: (0, $e1e942361049df06$export$60f4f4563d451e62),
                                        children: "Stamp duty and selling costs are gone on the day."
                                    }),
                                    " ",
                                    stateName && similarDuty > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            "In ",
                                            stateName,
                                            " the duty on a ",
                                            (0, $4e46e0dde908c630$export$b48e0c6120d679a4)(similar),
                                            " home is about ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: (0, $e1e942361049df06$export$2231117efb2a2550),
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(similarDuty))
                                            }),
                                            "."
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: "Choose the state below and we work out the duty on every price."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: (0, $e1e942361049df06$export$60f4f4563d451e62),
                                        children: [
                                            "From 55, each of ",
                                            v.you ? 'you' : v.them,
                                            " can put up to ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$42edd27decf8c272)),
                                            " of the sale into super"
                                        ]
                                    }),
                                    " as a downsizer contribution, if the home was owned for 10 years or more."
                                ]
                            })
                        ]
                    }),
                    primerOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-3 text-[13px] text-slate-500",
                        children: primerLinks
                    }),
                    showExemption && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 rounded-lg border border-slate-200 border-l-4 border-l-blue-500 bg-white px-3 py-2 text-[13.5px] leading-relaxed text-slate-700",
                        "data-testid": "dz-exemption",
                        children: [
                            "If ",
                            v.they,
                            " sell before buying, the part of the sale ",
                            v.they,
                            " mean to spend on the new home is ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "not counted for the Age Pension for up to 24 months"
                            }),
                            " (36 if the delay is outside ",
                            v.their,
                            " control). It is still deemed to earn income, at the lower rate. Tell Services Australia within 14 days of the sale."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: $b0451585083b21c1$var$card,
                "data-testid": "dz-sale",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[12px] font-semibold text-brand-navy",
                        children: "The sale"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3 grid grid-cols-1 gap-x-7 gap-y-4 md:grid-cols-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: $b0451585083b21c1$var$label,
                                        children: "Sale price"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                        value: sale.salePrice || '',
                                        onChange: (x)=>onSale({
                                                salePrice: Math.max(0, x ?? 0)
                                            }),
                                        className: "mt-1 w-44",
                                        ariaLabel: "Sale price",
                                        testId: "dz-sale-price"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mt-1 text-[12.5px] text-slate-500",
                                        children: homeValue > 0 && Math.round(sale.salePrice) === Math.round(homeValue) ? 'From the profile' : homeValue > 0 ? `The profile says ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(homeValue)}` : 'No home value on the profile'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: $b0451585083b21c1$var$label,
                                        children: "Selling costs"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                        value: sale.sellingCosts ?? '',
                                        onChange: (x)=>onSale({
                                                sellingCosts: Math.max(0, x ?? 0)
                                            }),
                                        className: "mt-1 w-44",
                                        ariaLabel: "Selling costs",
                                        testId: "dz-selling-costs"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-1 text-[12.5px] text-slate-500",
                                        children: [
                                            sale.salePrice > 0 ? `${(Math.round(sale.sellingCosts / sale.salePrice * 1000) / 10).toLocaleString('en-AU')}%` : '2.5%',
                                            ": agent, legal and moving. Change it if ",
                                            v.you ? 'you have' : `${v.they} have`,
                                            " a quote."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "dz-event-date",
                                        className: $b0451585083b21c1$var$label,
                                        children: "When?"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        id: "dz-event-date",
                                        type: "date",
                                        value: sale.date,
                                        onChange: (e)=>onSale({
                                                date: e.target.value
                                            }),
                                        className: `${$b0451585083b21c1$var$input} mt-1 block font-normal`
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mt-1 text-[12.5px] text-slate-500",
                                        children: sale.date ? sale.date < new Date().toISOString().slice(0, 10) ? 'A past date models as "now".' : 'Life as it is until then, then the move.' : 'Now. Leave it blank while still deciding.'
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-6 text-[12px] font-semibold text-brand-navy",
                        children: "After the sale"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0451585083b21c1$var$Choice, {
                                value: housing,
                                onChange: (id)=>setGoal({
                                        dzHousing: id
                                    }),
                                testId: "dz-housing",
                                options: [
                                    {
                                        id: 'buy',
                                        label: 'Buy another home'
                                    },
                                    {
                                        id: 'rent',
                                        label: 'Rent instead'
                                    },
                                    {
                                        id: 'both',
                                        label: 'Compare both'
                                    }
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-2 text-[13px] text-slate-600",
                                children: "Buying keeps a home out of the Age Pension test. Renting frees the most money, but every dollar is then counted, and the rent is a cost for life."
                            })
                        ]
                    }),
                    buys && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-6 text-[12px] font-semibold text-brand-navy",
                                children: "The new home"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-2 flex flex-wrap items-start gap-x-6 gap-y-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: $b0451585083b21c1$var$label,
                                                children: [
                                                    "Price, if ",
                                                    v.you ? 'you have' : `${v.they} have`,
                                                    " one in mind"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                value: rangeMode ? '' : named || '',
                                                onChange: (x)=>{
                                                    const p = Math.max(0, x ?? 0);
                                                    setRangeMode(!(p > 0));
                                                    setGoal({
                                                        dzNewHomePrice: p
                                                    });
                                                },
                                                placeholder: "e.g. 1,950,000",
                                                className: "mt-1 w-48",
                                                ariaLabel: "The new home's price",
                                                testId: "dz-new-home-price"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "mt-6 flex cursor-pointer items-start gap-2 text-[14px] text-slate-700",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: rangeMode,
                                                onChange: (e)=>{
                                                    setRangeMode(e.target.checked);
                                                    if (e.target.checked) setGoal({
                                                        dzNewHomePrice: 0
                                                    });
                                                },
                                                className: "mt-1 h-4 w-4 accent-blue-600",
                                                "data-testid": "dz-test-range"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        className: "text-slate-900",
                                                        children: "Not sure \u2014 test a range."
                                                    }),
                                                    " We test a cheaper, a similar and a dearer home",
                                                    prices.length > 1 ? `: ${prices.map((p)=>(0, $4e46e0dde908c630$export$b48e0c6120d679a4)(p.price).replace(' million', 'm')).join(', ')}` : '',
                                                    "."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    rents && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[12px] font-semibold text-brand-navy",
                                children: "The rent"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-2 flex flex-wrap items-center gap-2 text-[13px] text-slate-600",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                        value: rent || '',
                                        onChange: (x)=>setGoal({
                                                dzRentPerWeek: Math.max(0, x ?? 0)
                                            }),
                                        className: "w-36",
                                        ariaLabel: "Rent a week",
                                        testId: "dz-rent"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "a week",
                                            rent > 0 ? ` (about ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(rent * 52))} a year, rising with inflation; Rent Assistance is assessed on it)` : ''
                                        ]
                                    })
                                ]
                            }),
                            rentMissing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1 text-[13px] text-amber-800",
                                "data-testid": "dz-rent-missing",
                                children: "Enter the weekly rent: it is charged every year and rises with prices, so without it renting looks free."
                            })
                        ]
                    }),
                    buys && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-6",
                        "data-testid": "dz-state",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "dz-state-select",
                                        className: "text-[12px] font-semibold text-brand-navy",
                                        children: "State"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        id: "dz-state-select",
                                        value: st.code,
                                        onChange: (e)=>setGoal({
                                                dzNewHomeState: e.target.value
                                            }),
                                        className: $b0451585083b21c1$var$input,
                                        "data-testid": "dz-state-select",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Not sure \u2014 no stamp duty in the figures"
                                            }),
                                            (0, $669f0c9987a611db$export$2f609b1773ce8fef).map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: s.code,
                                                    children: s.name
                                                }, s.code))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-[13px] text-slate-500",
                                        children: [
                                            st.code ? st.fromFile ? 'From what the file already records. ' : '' : '',
                                            st.code ? 'Stamp duty is worked out for every price we test.' : ''
                                        ]
                                    })
                                ]
                            }),
                            st.code ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                className: "mt-3 w-full max-w-xl text-[14px]",
                                "data-testid": "dz-duty-table",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: prices.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "border-b border-slate-100",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "py-1.5 text-slate-700",
                                                    children: [
                                                        "Stamp duty on a ",
                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(p.price),
                                                        " home"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "py-1.5 text-right font-bold tabular-nums text-slate-900",
                                                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round((0, $6b146b31ad2b1e77$export$a8a5bac4bde49384)(st.code, p.price)))
                                                })
                                            ]
                                        }, p.label))
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-2 rounded-lg border border-slate-200 border-l-4 border-l-amber-400 bg-white px-3 py-2 text-[13.5px] text-slate-700",
                                "data-testid": "dz-no-state",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "No state, no stamp duty."
                                    }),
                                    " Without the state the figures leave the duty out, which makes buying \u2014 a dearer home most of all \u2014 look better than it is. Every plan will say so."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1 text-[12.5px] text-slate-500",
                                children: "The state's standard scale for a home to live in, with no concessions. A conveyancer confirms the real figure."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center justify-end gap-3",
                children: [
                    rentMissing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-[13px] text-slate-500",
                        children: "Enter the rent to go on."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onNext,
                        disabled: !(sale.salePrice > 0) || rentMissing,
                        "data-testid": "dz-step1-next",
                        className: "inline-flex h-11 items-center gap-2 rounded-lg bg-blue-600 hover:bg-blue-700 px-5 text-[14px] font-semibold text-white shadow-sm disabled:cursor-not-allowed disabled:opacity-50",
                        children: [
                            "See what this means for ",
                            v.them,
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                size: 16
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $b0451585083b21c1$export$2e2bcd8739ae039 = $b0451585083b21c1$var$DzStep1;


/**
 * Step 2 — what it means for them (downsizing rebuild, 21 Oct 2026; the agreed mock-up's j1-step2).
 *
 * Staying put in four numbers — every plan on step 3 is measured against them — with "why 10?" beside the
 * horizon (owner, 19 Oct 2026: 10 years in every module but aged care, said on the screen). Then what the
 * sale would bring in, and the trap in their own figures: what Centrelink counts today, which test sets the
 * pension, and how much freed money would stop it.
 *
 * ONE SOURCE: the pension and cashflow are today's assessment (`todayFinancials`), the estate and the runway
 * the stay-put projection — the same run the engine's own baseline makes.
 */ 

var $acw62 = parcelRequire("acw62");








const $6888989aaf3877cf$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
const $6888989aaf3877cf$export$d4d5926140d64983 = "Ten years is long enough for what a move costs on the day \u2014 selling costs and stamp duty \u2014 to be weighed against what it changes every year: the Age Pension, what is left over, and how the new home and the money grow. It is short enough to be a fair projection. The village and Support at home plan over the same 10 years; only aged care uses age and health instead.";
function $6888989aaf3877cf$export$dfe4ed16ea902817(todayFinancials, isCouple, they) {
    const pos = (0, $eec331ce661055d2$export$d318875bf548d09)(todayFinancials?.socialSecurityBreakdown, todayFinancials?.socialSecurity, isCouple);
    if (!pos) return null;
    const pension = Number(todayFinancials?.socialSecurity) || 0;
    const counted = `Today Centrelink counts ${$6888989aaf3877cf$var$money(pos.assessableAssets)} of ${they === 'you' ? 'your' : 'their'} assets`;
    if (!(pension >= 1)) return `${counted}, and no Age Pension is paid, so the money the sale frees cannot reduce it.`;
    if (pos.determinedBy === 'income') return `${counted}, and the pension is set by the income test: the money the sale frees is deemed to earn income, so it lowers the pension as that income rises.`;
    // Assets test: the pension falls by $78 a year for every $1,000 more counted ($3 a fortnight).
    const stops = Math.ceil(pos.assetTestPension / (0, $1abe73eeef086faf$export$6ca758cf677ce6c5) * 1000 / 10000) * 10000;
    return `${counted}, and the pension is set by the assets test, so any money the sale frees reduces the pension, and freeing about ${$6888989aaf3877cf$var$money(stops)} stops it.`;
}
const $6888989aaf3877cf$var$card = 'rounded-2xl border border-slate-200 bg-white p-6 shadow-card';
const $6888989aaf3877cf$var$Tile = ({ label: label, value: value, unit: unit, caption: caption, tone: tone })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-xl border border-slate-200 bg-white px-4 py-4 shadow-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[12.5px] font-semibold text-slate-500",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: `mt-1 text-[26px] font-bold leading-none tabular-nums tracking-tight ${tone === 'good' ? 'text-emerald-700' : tone === 'bad' ? 'text-rose-700' : 'text-slate-900'}`,
                children: [
                    value,
                    unit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ml-1 text-[13px] font-semibold text-slate-500",
                        children: unit
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-2 text-[12.5px] leading-snug text-slate-500",
                children: caption
            })
        ]
    });
const $6888989aaf3877cf$var$DzStep2 = ({ factFind: factFind, todayFinancials: todayFinancials, stayPutLegacy: stayPutLegacy, runway: runway, legacyYears: legacyYears, salePrice: salePrice, sellingCosts: sellingCosts, onLegacyYearsChange: onLegacyYearsChange, onBack: onBack, onNext: onNext, onAssumptions: onAssumptions, onShowProjections: onShowProjections })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const ready = !!todayFinancials;
    const pension = todayFinancials?.socialSecurity ?? 0;
    const cashFlow = todayFinancials?.cashFlow ?? 0;
    const netWorth = todayFinancials?.netWorth ?? 0;
    const years = Number(legacyYears) || 0;
    const [showWhy, setShowWhy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [showTen, setShowTen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const trap = $6888989aaf3877cf$export$dfe4ed16ea902817(todayFinancials, factFind?.adviceFor === 'couple', v.they);
    const net = Math.max(0, salePrice - sellingCosts);
    const whyTen = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: ()=>setShowTen((o)=>!o),
        "aria-expanded": showTen,
        className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2",
        "data-testid": "dz-why-ten",
        children: [
            "why ",
            years,
            "?"
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        "data-testid": "dz-step2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: "text-[24px] font-bold tracking-tight text-brand-navy",
                        children: [
                            "If ",
                            v.names,
                            " stay",
                            v.s,
                            " where ",
                            v.they,
                            " are"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-1 text-[15px] text-slate-600",
                        children: "Every way of downsizing on the next step is measured against these four numbers, which the cards call \u201Cstaying put\u201D."
                    })
                ]
            }),
            !ready ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "rounded-xl border border-dashed border-slate-300 bg-white px-4 py-6 text-center text-[14px] text-slate-600",
                children: "Working out today's position\u2026"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4",
                        "data-testid": "dz-four-numbers",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6888989aaf3877cf$var$Tile, {
                                label: "Age Pension",
                                value: $6888989aaf3877cf$var$money(pension),
                                unit: "a year",
                                caption: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        v.couple ? 'the two of them' : 'a year',
                                        " \xb7 ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setShowWhy((o)=>!o),
                                            className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2",
                                            children: "why?"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6888989aaf3877cf$var$Tile, {
                                label: cashFlow < 0 ? 'Short each year' : 'Left over each year',
                                value: $6888989aaf3877cf$var$money(Math.abs(cashFlow)),
                                tone: cashFlow < 0 ? 'bad' : 'good',
                                caption: cashFlow < 0 ? 'money in, less money out; met from savings' : 'money in, less money out'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6888989aaf3877cf$var$Tile, {
                                label: `What ${v.they} own`,
                                value: $6888989aaf3877cf$var$money(netWorth),
                                caption: `less what ${v.they} owe`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6888989aaf3877cf$var$Tile, {
                                label: "Left to the family",
                                value: stayPutLegacy != null ? $6888989aaf3877cf$var$money(stayPutLegacy) : "\u2014",
                                caption: stayPutLegacy != null ? onLegacyYearsChange ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "inline-flex flex-wrap items-center gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9873a6fbc9fd360$export$68741d4d7bc37a6d), {
                                            years: years,
                                            onChange: onLegacyYearsChange,
                                            before: "after about",
                                            after: " \xb7 "
                                        }),
                                        " ",
                                        whyTen
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        "after about ",
                                        years,
                                        " years \xb7 ",
                                        whyTen
                                    ]
                                }) : 'not available: the projection could not be run'
                            })
                        ]
                    }),
                    showTen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "rounded-lg border border-slate-200 border-l-4 border-l-blue-500 bg-white px-3 py-2 text-[13.5px] leading-relaxed text-slate-700",
                        "data-testid": "dz-why-ten-text",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    "Why ",
                                    years,
                                    " years?"
                                ]
                            }),
                            " ",
                            $6888989aaf3877cf$export$d4d5926140d64983
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[14px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onShowProjections,
                                className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                "data-testid": "dz-step2-year-by-year",
                                children: "See the year-by-year figures, staying put"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-slate-500",
                                children: [
                                    " \u2014 Age Pension, money in and out, and what ",
                                    v.they,
                                    " own, each year for about ",
                                    years,
                                    " years."
                                ]
                            })
                        ]
                    }),
                    showWhy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $6888989aaf3877cf$var$card,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$28c8139bd562d0e), {
                            eyebrow: `Why ${v.possessive} Age Pension is ${$6888989aaf3877cf$var$money(pension)}`,
                            className: "-m-5 border-0 bg-transparent shadow-none",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eec331ce661055d2$export$836922263996c16c), {
                                careDepositRelevant: false,
                                financials: todayFinancials,
                                isCouple: factFind?.adviceFor === 'couple',
                                name: v.names,
                                alsoMoves: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: "changes what downsizing does to the pension"
                                })
                            })
                        })
                    })
                ]
            }),
            salePrice > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $6888989aaf3877cf$var$card,
                "data-testid": "dz-sale-brings",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[12px] font-semibold text-brand-navy",
                        children: "What the sale would bring in"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                        className: "mt-1 w-full max-w-xl text-[14px] tabular-nums",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    className: "border-b border-slate-100",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-2 text-slate-700",
                                            children: "Sale price"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-2 text-right text-slate-900",
                                            children: $6888989aaf3877cf$var$money(salePrice)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    className: "border-b border-slate-100",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-2 text-slate-700",
                                            children: "Selling costs"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                            className: "py-2 text-right text-rose-700",
                                            children: [
                                                "\u2212",
                                                $6888989aaf3877cf$var$money(sellingCosts)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-2 font-semibold text-slate-900",
                                            children: "Net proceeds"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-2 text-right font-bold text-slate-900",
                                            "data-testid": "dz-net-proceeds",
                                            children: $6888989aaf3877cf$var$money(net)
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-3 text-[15px] leading-relaxed text-slate-700",
                        "data-testid": "dz-trap-line",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-slate-900",
                                children: "Every dollar of that which doesn't go into the new home is counted for the Age Pension."
                            }),
                            trap ? ` ${trap}` : ''
                        ]
                    }),
                    runway && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-5 text-[12px] font-semibold text-brand-navy",
                                children: "How long the money lasts, staying put"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c05f3bca3803eec$export$7fbbcd423808f3d5), {
                                    headline: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-[15px] text-slate-700",
                                        children: runway.headline
                                    }),
                                    coveredPct: runway.coveredPct,
                                    leftLabel: runway.leftLabel,
                                    rightLabel: runway.rightLabel,
                                    depleted: runway.depleted,
                                    flag: runway.flag
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] text-slate-500",
                children: [
                    "Figures use the rates in force from ",
                    (0, $1abe73eeef086faf$export$946308c675ba021d).agePension,
                    ". ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onAssumptions,
                        className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2",
                        children: "What the figures assume"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onBack,
                        className: "inline-flex items-center gap-1 text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                size: 15
                            }),
                            " Change the sale or the new home"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onNext,
                        disabled: !ready,
                        "data-testid": "dz-step2-next",
                        className: "inline-flex h-11 items-center gap-2 rounded-lg bg-blue-600 hover:bg-blue-700 px-5 text-[14px] font-semibold text-white shadow-sm disabled:cursor-not-allowed disabled:opacity-50",
                        children: [
                            "See ways to use the money ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                size: 16
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $6888989aaf3877cf$export$2e2bcd8739ae039 = $6888989aaf3877cf$var$DzStep2;


/**
 * Step 3's questions — before the plans run, and again under "Things that change the answer" (downsizing
 * rebuild, 21 Oct 2026; the agreed mock-up's j1-setup). The home, the price and the state are answered on
 * step 1, so five questions are left:
 *   1. why they are thinking of moving — it decides whether a dearer home is a plan or a what-if;
 *   2. the years to plan for — 10, suggested for a move, with "why 10?";
 *   3. the money kept for emergencies — kept back when money moves, drawn on only if a year runs short
 *      (owner, 20 Oct 2026; the review: "the plans assume a reserve the client never saw");
 *   4. whether they would consider a guaranteed income for life — the shared question (GuaranteedIncomeQuestions),
 *      the client's own answer; "we work out how much";
 *   5. how freed-up money would be invested.
 * The cashflow-covered goal's yearly target (review fix, 19 Oct 2026) stays, on one line under them.
 * "Build a plan yourself instead" sits beside the run button.
 */ 

var $acw62 = parcelRequire("acw62");










const $a028f10b8733b568$var$num = (x, d = 0)=>x != null && x !== '' && Number.isFinite(Number(x)) ? Number(x) : d;
function $a028f10b8733b568$export$b3ee973e866a2ac1(factFind) {
    const g = factFind?.goals || {};
    return {
        motive: g.dzMotive === 'money' || g.dzMotive === 'home' ? g.dzMotive : 'both',
        years: Math.min(30, Math.max(1, $a028f10b8733b568$var$num(g.dzLegacyYears, 10))),
        emergencyReserve: Math.max(0, $a028f10b8733b568$var$num(g.dzEmergencyReserve, (0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind))),
        guaranteedIncome: null,
        investProfile: String(g.newMoneyInvestmentProfile || ''),
        // ONE RULE FOR "COVERS THE COSTS" (owner, 23 Oct 2026): money in at least matches money out, as aged care has always used; no module asks for a margin.
        cashflowTarget: 0
    };
}
function $a028f10b8733b568$export$ab9e4b86119bb8dd(a) {
    return {
        dzMotive: a.motive,
        dzLegacyYears: a.years,
        dzEmergencyReserve: a.emergencyReserve,
        dzCashflowTarget: a.cashflowTarget,
        ...a.guaranteedIncome || {},
        ...a.investProfile ? {
            newMoneyInvestmentProfile: a.investProfile
        } : {}
    };
}
function $a028f10b8733b568$export$7dd769ec2673bd1b(factFind, sale, housing, newHomePrice, state, reserve) {
    const anchor = newHomePrice > 0 ? newHomePrice : Math.round(sale.salePrice * 0.7);
    const buying = (0, $6b146b31ad2b1e77$export$855cd09595261b3b)({
        salePrice: sale.salePrice,
        sellingCosts: sale.sellingCosts,
        newHomePrice: anchor,
        stampDuty: (0, $6b146b31ad2b1e77$export$a8a5bac4bde49384)(state, anchor),
        sellAndRent: false
    });
    const freed = housing === 'buy' ? buying.freedCapital : buying.netProceeds;
    const bank = (factFind?.assets?.bankAccounts || []).reduce((s, a)=>s + (parseFloat(String(a?.value)) || 0), 0);
    return Math.max(0, freed - Math.max(0, reserve - bank));
}
const $a028f10b8733b568$var$link = 'font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy';
const $a028f10b8733b568$var$Why = ({ open: open, onToggle: onToggle, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            ' ',
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onToggle,
                "aria-expanded": open,
                className: "text-[12px] font-semibold text-blue-700 underline decoration-dotted underline-offset-2",
                children: "what's this?"
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "mt-1.5 block rounded-lg border border-slate-200 border-l-4 border-l-blue-500 bg-white px-3 py-2 text-[13px] font-normal leading-relaxed text-slate-700",
                children: children
            })
        ]
    });
const $a028f10b8733b568$var$Q = ({ n: n, title: title, why: why, whyOpen: whyOpen = false, onWhy: onWhy, children: children, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-t border-slate-200 pt-4",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d7fa4e176455787d$export$d5095ecb707035a), {
                n: n,
                children: [
                    title,
                    why && onWhy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a028f10b8733b568$var$Why, {
                        open: whyOpen,
                        onToggle: onWhy,
                        children: why
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-2",
                children: children
            })
        ]
    });
const $a028f10b8733b568$var$Radio = ({ name: name, checked: checked, onChange: onChange, children: children, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
        className: "flex cursor-pointer items-start gap-2 py-1 text-[14px] text-slate-700",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "radio",
                name: name,
                checked: checked,
                onChange: onChange,
                className: "mt-1 accent-blue-600",
                "data-testid": testId
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: children
            })
        ]
    });
const $a028f10b8733b568$var$DzQuestions = ({ factFind: factFind, sale: sale, housing: housing, newHomePrice: newHomePrice, state: state, firstRun: firstRun, onRun: onRun, onBuildYourOwn: onBuildYourOwn, onCancel: onCancel })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const [a, setA] = (0, $acw62.useState)(()=>$a028f10b8733b568$export$b3ee973e866a2ac1(factFind));
    const set = (patch)=>setA((prev)=>({
                ...prev,
                ...patch
            }));
    const [openWhy, setOpenWhy] = (0, $acw62.useState)(null);
    const whyProps = (id)=>({
            whyOpen: openWhy === id,
            onWhy: ()=>setOpenWhy((o)=>o === id ? null : id)
        });
    const suggestedReserve = (0, $5941a0d5c38ddae8$export$bec244491e023b43)(factFind);
    const investable = $a028f10b8733b568$export$7dd769ec2673bd1b(factFind, sale, housing, newHomePrice, state, a.emergencyReserve);
    const giView = (0, $acw62.useMemo)(()=>a.guaranteedIncome ? {
            ...factFind,
            goals: {
                ...factFind?.goals || {},
                ...a.guaranteedIncome
            }
        } : factFind, [
        factFind,
        a.guaranteedIncome
    ]);
    const appetiteNone = String((giView?.goals || {}).annuityAppetite || '') === 'none';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
        "data-testid": "dz-questions",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "text-[22px] font-bold text-brand-navy",
                children: "Five questions before we test the ways to use the money"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-1 text-[15px] text-slate-600",
                children: [
                    "The sale, the new home and the state are on step 1; everything else comes from ",
                    v.possessive,
                    " file. Our suggestions are filled in, and each can be changed later."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d7fa4e176455787d$export$b506d3545e935872), {
                onClick: onBuildYourOwn,
                testId: "dz-build-own-top"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-4 space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a028f10b8733b568$var$Q, {
                        n: 1,
                        title: `Why ${v.are} ${v.names} thinking of moving?`,
                        testId: "dz-q-motive",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a028f10b8733b568$var$Radio, {
                                name: "dz-motive",
                                checked: a.motive === 'money',
                                onChange: ()=>set({
                                        motive: 'money'
                                    }),
                                testId: "dz-motive-money",
                                children: "To free up money"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a028f10b8733b568$var$Radio, {
                                name: "dz-motive",
                                checked: a.motive === 'home',
                                onChange: ()=>set({
                                        motive: 'home'
                                    }),
                                testId: "dz-motive-home",
                                children: [
                                    "For a home that suits ",
                                    v.them,
                                    " better"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a028f10b8733b568$var$Radio, {
                                name: "dz-motive",
                                checked: a.motive === 'both',
                                onChange: ()=>set({
                                        motive: 'both'
                                    }),
                                testId: "dz-motive-both",
                                children: "Both \u2014 compare everything"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1 text-[13px] text-slate-600",
                                children: newHomePrice > 0 && housing !== 'rent' ? `Every plan buys at the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(newHomePrice)} named on step 1. A cheaper, a similar or a dearer home is shown as a what-if, never recommended.` : a.motive === 'money' ? 'A dearer home is shown as a what-if, never recommended: it would only hide more money in the home.' : a.motive === 'home' ? 'A similar and a dearer home compete as plans of their own, with the bills checked; a cheaper one is shown as a what-if.' : 'Every price competes, from a cheaper home to a dearer one.'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a028f10b8733b568$var$Q, {
                        n: 2,
                        title: "How many years should we plan for?",
                        ...whyProps('years'),
                        why: (0, $6888989aaf3877cf$export$d4d5926140d64983),
                        testId: "dz-q-years",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-2 text-[14px] text-slate-700",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "number",
                                    min: 1,
                                    max: 30,
                                    value: a.years,
                                    onChange: (e)=>set({
                                            years: Math.min(30, Math.max(1, parseInt(e.target.value, 10) || 1))
                                        }),
                                    className: "w-16 rounded-lg border border-slate-300 px-2 py-1.5 text-center font-semibold text-slate-900",
                                    "aria-label": "Years to plan for",
                                    "data-testid": "dz-years"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        "years",
                                        a.years === 10 ? ', suggested for a move.' : '.'
                                    ]
                                }),
                                a.years !== 10 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>set({
                                            years: 10
                                        }),
                                    className: `text-[13px] ${$a028f10b8733b568$var$link}`,
                                    children: "Use 10"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a028f10b8733b568$var$Q, {
                        n: 3,
                        title: "How much should stay in the bank for emergencies?",
                        ...whyProps('reserve'),
                        why: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "Money kept in the bank for the unexpected. We keep it back when we move ",
                                v.their,
                                " money, and draw on it only if a year runs short. Centrelink still counts it."
                            ]
                        }),
                        testId: "dz-q-reserve",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                        value: a.emergencyReserve,
                                        onChange: (x)=>set({
                                                emergencyReserve: Math.max(0, x ?? 0)
                                            }),
                                        className: "w-36",
                                        ariaLabel: "Money kept for emergencies",
                                        testId: "dz-reserve"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-[13px] text-slate-500",
                                        children: [
                                            "We suggest ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(suggestedReserve),
                                            ": the greater of six months' living costs and $50,000.",
                                            Math.round(a.emergencyReserve) !== Math.round(suggestedReserve) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>set({
                                                                emergencyReserve: suggestedReserve
                                                            }),
                                                        className: $a028f10b8733b568$var$link,
                                                        children: [
                                                            "Use ",
                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(suggestedReserve)
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-1.5 text-[13.5px] text-slate-700",
                                children: [
                                    "We keep it back when we move ",
                                    v.their,
                                    " money, and draw on it only if a year runs short. ",
                                    v.Possessive,
                                    " yearly costs are already on ",
                                    v.their,
                                    " file."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a028f10b8733b568$var$Q, {
                        n: 4,
                        title: "A guaranteed income for life",
                        testId: "dz-q-annuity",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f92088f7258458cc$export$b30880333d8bfec9), {
                                fromHomeSale: true,
                                factFind: giView,
                                onGoals: (patch)=>set({
                                        guaranteedIncome: {
                                            ...a.guaranteedIncome || {},
                                            ...patch
                                        }
                                    }),
                                investable: investable,
                                investableLead: housing === 'rent' ? 'After the sale, renting instead of buying, and keeping the money for emergencies' : 'After the sale, the new home and its stamp duty, and keeping the money for emergencies',
                                investableMadeOf: "money freed by the sale, which the plans would invest",
                                inCare: (0, $d08210caeacdc75a$export$7095ab72ebd46272)(factFind),
                                idPrefix: "dz"
                            }),
                            !appetiteNone && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-2 text-[13.5px] leading-relaxed text-slate-700",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: "We work out how much."
                                    }),
                                    " We test amounts up to a quarter of what ",
                                    v.they,
                                    " would invest, so most of ",
                                    v.their,
                                    " money stays within reach, and where it would lift the Age Pension, the amount that lifts it most."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a028f10b8733b568$var$Q, {
                        n: 5,
                        title: "How would money that is freed up be invested?",
                        testId: "dz-q-invest",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: a.investProfile,
                                onChange: (e)=>set({
                                        investProfile: e.target.value
                                    }),
                                className: "w-full max-w-md rounded-lg border border-slate-300 bg-white px-3 py-2 text-[14px]",
                                "aria-label": "How money that is freed up is invested",
                                "data-testid": "dz-invest-profile",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "Not sure \u2014 assume the most cautious"
                                    }),
                                    (0, $0f2c0a6799fe36da$export$56315028e4277c0c).map((id)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: id,
                                            children: (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[id].label
                                        }, id))
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-1 text-[13px] text-slate-500",
                                children: [
                                    "Saved to ",
                                    v.possessive,
                                    " profile, so it is asked once."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-4 flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-[14px] text-slate-700",
                        children: [
                            "Prefer to set the numbers yourself? ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onBuildYourOwn,
                                className: $a028f10b8733b568$var$link,
                                "data-testid": "dz-build-own",
                                children: "Build a plan yourself instead"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex items-center gap-3",
                        children: [
                            !firstRun && onCancel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onCancel,
                                className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>onRun(a),
                                className: "rounded-lg bg-blue-600 px-5 py-2.5 text-[15px] font-semibold text-white hover:bg-blue-700",
                                "data-testid": "dz-run",
                                children: firstRun ? 'Test the ways to use the money' : 'Test the ways again'
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $a028f10b8733b568$export$2e2bcd8739ae039 = $a028f10b8733b568$var$DzQuestions;


/**
 * Step 3's plans — downsizing on the aged care spine (rebuild, 21 Oct 2026; the agreed mock-up's j1-plans and
 * j2-plans, with d-why, d-compare and d-compare2).
 *
 *  - Staying put as a strip of the four numbers from step 2 — every card is read against it.
 *  - One line saying what the move does to the estate, said as awareness, not alarm (owner, 19 Oct 2026):
 *    "No way of downsizing leaves the family more than staying put … If they move, it should be for the
 *    home." — and whether every plan that frees money stops the Age Pension.
 *  - "What matters most?" — the four goals; "Highest Age Pension" always shown (owner ruling), with the
 *    plain explanation in place of cards when no way of downsizing keeps any.
 *  - The cards side by side, aligned row by row: the plan in words, the estate against staying put, the
 *    bars (less than staying put; stamp duty and selling costs), Age Pension / Left over each year / Money
 *    freed up — the figure that drives the trap — each with "why?", when the money runs out, an
 *    "Important" line, and the three buttons.
 *  - The ways on: compare, every way tested, things that change the answer, build a plan yourself.
 *
 * Presentation only. Every figure is the engine row's own.
 */ 

var $acw62 = parcelRequire("acw62");



















const $c23f2635a2ea2069$var$GOAL_CHIP = {
    'Optimal Legacy': 'Leaves the most',
    [(0, $400a08a42b233386$export$920ad41b346ae01a)]: 'Income covers the costs',
    'Optimal Cashflow': 'Most left over each year',
    'Optimal Age Pension': 'Highest Age Pension',
    [(0, $f8ee565b442c040e$export$40de0448f2611c56)]: (0, $5a094123650e8adb$export$a1a7ae9e29edd48c)
};
const $c23f2635a2ea2069$var$legacyOf = (s)=>Number(s?.snapshot?.legacyValue) || 0;
const $c23f2635a2ea2069$var$pensionOf = (s)=>Number(s?.snapshot?.pension) || 0;
const $c23f2635a2ea2069$var$cashOf = (s)=>Number(s?.snapshot?.netCashflow) || 0;
const $c23f2635a2ea2069$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
const $c23f2635a2ea2069$var$signed = (n)=>`${n >= 0 ? '+' : "\u2212"}${$c23f2635a2ea2069$var$money(Math.abs(n))}`;
const $c23f2635a2ea2069$var$moveOf = (s)=>(0, $6cafaaa2bceecd94$export$4c99534ae83f65d1)(s.inputs, {
        rentPerWeek: s.rentPerWeek
    });
function $c23f2635a2ea2069$export$2ae4d3edf3ae676b(row, factFind) {
    const gi = row ? (0, $ed6c3bc1777d5c34$export$432c3d850768ad70)(row.inputs?.deployment, factFind) : null;
    return !!gi && gi.incomeOnly && (0, $5eae79c7e46ed27e$export$655f124668ce439a)(factFind, true, gi.amount);
}
function $c23f2635a2ea2069$export$715f1a62b1300ad4(row) {
    const m = $c23f2635a2ea2069$var$moveOf(row);
    if (m.sellAndRent) return 'With no home, the whole sale is counted, against the higher limit for people who don\'t own a home.';
    if (m.buyUpShortfall >= 1) {
        const net = m.salePrice - m.sellingCosts;
        return m.newHomePrice > net * 1.05 ? `The new home isn't counted. ${$c23f2635a2ea2069$var$money(m.buyUpShortfall)} of savings that were counted go into it and its stamp duty, so Centrelink counts that much less.` : `The new home isn't counted. The ${$c23f2635a2ea2069$var$money(m.stampDuty)} of stamp duty is paid from savings that were counted, and once it is paid it is gone, so Centrelink counts that much less.`;
    }
    if (m.freedCapital >= 1) return `The new home isn't counted, but the ${$c23f2635a2ea2069$var$money(m.freedCapital)} the sale frees is, wherever it is put (funeral bonds within their limit, and part of a guaranteed income, are the exceptions).`;
    return 'The new home isn\'t counted, and the sale frees nothing, so Centrelink counts about what it does today.';
}
const $c23f2635a2ea2069$var$DzPlansView = ({ factFind: factFind, strategies: strategies, stayPut: stayPut, recommended: recommended, setAside: setAside, horizonYears: horizonYears, ownToday: ownToday, focus: focus, onFocus: onFocus, chosenId: chosenId, onChoose: onChoose, onExplain: onExplain, onRisks: onRisks, onYearByYear: onYearByYear, renderDetail: renderDetail, onAllWays: onAllWays, onChanges: onChanges, onBuildYourOwn: onBuildYourOwn, onAdvice: onAdvice, notices: notices, onIncomeOnly: onIncomeOnly, forHome: forHome, whatIfCount: whatIfCount = 0 })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const [openDetail, setOpenDetail] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [why, setWhy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [comparing, setComparing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const yrs = `${horizonYears} ${horizonYears === 1 ? 'year' : 'years'}`;
    const movers = strategies.filter((s)=>s.id !== 'dz-stay-put' && s.sensitivity !== true);
    const byName = (name)=>strategies.find((s)=>s.name === name) ?? null;
    const fullRow = (r)=>r?.strategy?.name ? byName(r.strategy.name) || r.strategy : null;
    const coveredSame = (0, $400a08a42b233386$export$b8b8a2cedd92aa3a)(recommended);
    const effective = focus === 'covered' && coveredSame ? 'legacy' : focus;
    const base = stayPut?.snapshot ? stayPut : null;
    const bestMover = fullRow((0, $f8ee565b442c040e$export$cf9821b188ee27f0)(recommended, 'legacy')) ?? (movers.length ? movers.reduce((top, s)=>$c23f2635a2ea2069$var$legacyOf(s) > $c23f2635a2ea2069$var$legacyOf(top) ? s : top, movers[0]) : null);
    const noPensionAnyWay = movers.length > 0 && movers.every((s)=>$c23f2635a2ea2069$var$pensionOf(s) < 1);
    const freeingMovers = movers.filter((s)=>$c23f2635a2ea2069$var$moveOf(s).freedCapital >= 1);
    const freeingStopsPension = $c23f2635a2ea2069$var$pensionOf(base) >= 1 && freeingMovers.length > 0 && freeingMovers.every((s)=>$c23f2635a2ea2069$var$pensionOf(s) < 1);
    const leader = fullRow((0, $f8ee565b442c040e$export$cf9821b188ee27f0)(recommended, effective));
    const secondEntry = effective === 'legacy' ? recommended.find((r)=>r.label === (0, $f8ee565b442c040e$export$40de0448f2611c56) && r.second) ?? null : null;
    const secondRow = secondEntry ? fullRow(secondEntry) : null;
    const estateEntry = recommended.find((r)=>r.label === 'Optimal Legacy') ?? null;
    /*
     * ONE CARD PER GOAL, A SECOND ONLY WITH A PURPOSE (owner, 22 Oct 2026: "each section has a specific purpose … only
     * show the second card when there is a purpose to it"). The second card is the plan choice rule's near-tie beside
     * the estate leader (nearly the same estate, less locked away or a better cashflow — planChoiceRule.ts), as aged
     * care and support at home do. Another goal's leader is pointed to in one line under the cards (OtherGoalLeaders).
     */ const showPensionNote = effective === 'pension' && noPensionAnyWay;
    const shown = showPensionNote || !leader ? [] : [
        leader,
        ...secondRow && secondRow.name !== leader.name ? [
            secondRow
        ] : []
    ];
    const others = [
        'legacy',
        'cashflow',
        'pension'
    ].filter((g)=>g !== effective).map((g)=>({
            g: g,
            row: fullRow((0, $f8ee565b442c040e$export$cf9821b188ee27f0)(recommended, g))
        })).filter((x)=>!!x.row && !shown.some((s)=>s.name === x.row.name)).map((x)=>({
            goal: x.g,
            title: (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(x.row, factFind).title,
            legacy: $c23f2635a2ea2069$var$legacyOf(x.row),
            cashflow: $c23f2635a2ea2069$var$cashOf(x.row),
            pension: $c23f2635a2ea2069$var$pensionOf(x.row)
        }));
    // “Income covers the costs” only on a plan that does: when none does, that goal falls back to the estate leader,
    // and the label on a plan that is short each year would contradict its own figures (review, 22 Oct 2026).
    const labelsFor = (row)=>recommended.filter((r)=>r.strategy?.name === row.name).map((r)=>String(r.label)).filter((l)=>l !== (0, $400a08a42b233386$export$920ad41b346ae01a) || (Number(row.snapshot?.netCashflow) || 0) >= 0);
    const chipFor = (l)=>l === 'Optimal Legacy' ? (0, $5a094123650e8adb$export$a035dca5f387c63d)(estateEntry?.lead) : l === (0, $f8ee565b442c040e$export$40de0448f2611c56) && secondEntry?.second ? (0, $5a094123650e8adb$export$8d9f0aa086032e89)(secondEntry.second) : $c23f2635a2ea2069$var$GOAL_CHIP[l];
    const maxGain = Math.max(1, ...shown.map((s)=>Math.abs($c23f2635a2ea2069$var$legacyOf(s) - $c23f2635a2ea2069$var$legacyOf(base))));
    const maxCost = Math.max(1, ...shown.map((s)=>{
        const m = $c23f2635a2ea2069$var$moveOf(s);
        return m.sellingCosts + m.stampDuty;
    }));
    // The verdict, as awareness: what the move does to the estate, against staying put.
    const cost = base && bestMover ? $c23f2635a2ea2069$var$legacyOf(base) - $c23f2635a2ea2069$var$legacyOf(bestMover) : 0;
    const bestLifts = !!bestMover && !!base && $c23f2635a2ea2069$var$pensionOf(bestMover) > $c23f2635a2ea2069$var$pensionOf(base) + 1;
    const ways = movers.length + whatIfCount;
    const verdict = base && bestMover ? cost > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                children: [
                    "No way of downsizing",
                    forHome ? ` to ${forHome}` : '',
                    " leaves the family more than staying put."
                ]
            }),
            " We tested ",
            ways,
            ". Selling costs and stamp duty are gone on the day",
            freeingStopsPension ? ', and every plan that frees money stops the Age Pension' : '',
            ". If ",
            v.they,
            " move, it should be for the home.",
            ' ',
            (()=>{
                const lead = (0, $6cafaaa2bceecd94$export$ad52b9cc096416fa)($c23f2635a2ea2069$var$moveOf(bestMover));
                return `${lead}${lead.includes(',') ? ',' : ''}`;
            })(),
            " costs the family least",
            bestLifts ? ', and lifts the pension' : '',
            ": ",
            $c23f2635a2ea2069$var$money(cost),
            " less after about ",
            yrs,
            "."
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                children: [
                    "Downsizing",
                    forHome ? ` to ${forHome}` : '',
                    " can leave the family ",
                    $c23f2635a2ea2069$var$money(-cost),
                    " more than staying put"
                ]
            }),
            " over about ",
            yrs,
            ", on the best way of doing it.",
            freeingStopsPension ? ' Every plan that frees money stops the Age Pension.' : '',
            " We tested ",
            ways,
            "; below are the strongest."
        ]
    }) : null;
    const pensionLeader = fullRow((0, $f8ee565b442c040e$export$cf9821b188ee27f0)(recommended, 'pension'));
    const goalSubs = {
        legacy: cost > 0 ? 'Smallest cost against staying put' : `Biggest estate after about ${yrs}`,
        covered: coveredSame ? 'Same plan' : 'Pays its way without savings',
        cashflow: 'Easiest cashflow',
        pension: noPensionAnyWay ? effective === 'pension' ? 'No way of downsizing keeps any' : "No way keeps any \u2014 see why" : pensionLeader ? (0, $6cafaaa2bceecd94$export$ad52b9cc096416fa)($c23f2635a2ea2069$var$moveOf(pensionLeader)) : 'Most government support'
    };
    const card = (row)=>{
        const key = String(row.id ?? row.name);
        const words = (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(row, factFind);
        const m = $c23f2635a2ea2069$var$moveOf(row);
        const chip = labelsFor(row).map(chipFor).filter(Boolean).join(" \xb7 ") || null;
        const delta = base ? $c23f2635a2ea2069$var$legacyOf(row) - $c23f2635a2ea2069$var$legacyOf(base) : null;
        const pDelta = base ? $c23f2635a2ea2069$var$pensionOf(row) - $c23f2635a2ea2069$var$pensionOf(base) : 0;
        const cDelta = base ? $c23f2635a2ea2069$var$cashOf(row) - $c23f2635a2ea2069$var$cashOf(base) : 0;
        const numbers = [
            {
                label: 'Age Pension',
                value: $c23f2635a2ea2069$var$pensionOf(row),
                unit: 'a year',
                vs: base && Math.abs(pDelta) >= 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: `font-bold ${pDelta > 0 ? 'text-emerald-700' : 'text-rose-700'}`,
                            children: [
                                $c23f2635a2ea2069$var$signed(pDelta),
                                " a year"
                            ]
                        }),
                        " \u2014 ",
                        pDelta > 0 ? m.buyUpShortfall >= 1 ? 'the duty and top-up leave less to count' : 'less is counted' : m.freedCapital >= 1 || m.sellAndRent ? 'the freed money is counted' : 'more is counted'
                    ]
                }) : 'the same as staying put',
                tone: pDelta > 0 ? 'good' : 'neutral',
                onWhy: ()=>setWhy({
                        row: row,
                        page: 'pension'
                    })
            },
            {
                label: $c23f2635a2ea2069$var$cashOf(row) < 0 ? 'Each year, short by' : 'Left over each year',
                value: Math.abs($c23f2635a2ea2069$var$cashOf(row)),
                vs: base ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "in the first year; was ",
                        $c23f2635a2ea2069$var$cashOf(base) < 0 ? `short ${$c23f2635a2ea2069$var$money(-$c23f2635a2ea2069$var$cashOf(base))}` : $c23f2635a2ea2069$var$money($c23f2635a2ea2069$var$cashOf(base)),
                        " staying put ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: `font-bold ${cDelta >= 0 ? 'text-emerald-700' : 'text-rose-700'}`,
                            children: [
                                "(",
                                $c23f2635a2ea2069$var$signed(cDelta),
                                ")"
                            ]
                        })
                    ]
                }) : 'in the first year',
                tone: $c23f2635a2ea2069$var$cashOf(row) >= 0 ? cDelta > 0 ? 'good' : 'neutral' : 'neutral',
                onWhy: ()=>setWhy({
                        row: row,
                        page: 'cashflow'
                    })
            },
            {
                label: 'Money freed up',
                value: m.freedCapital,
                vs: m.sellAndRent ? 'renting: the whole sale, after costs' : m.freedCapital < 1 ? m.buyUpShortfall >= 1 ? `the sale buys the new home; ${$c23f2635a2ea2069$var$money(m.buyUpShortfall)} more from savings` : 'the sale buys the new home' : m.stampDuty > 0 ? 'after stamp duty' : 'no stamp duty in the figures',
                onWhy: ()=>setWhy({
                        row: row,
                        page: 'freed'
                    })
            }
        ];
        /*
         * "When the money runs out" as every module's card says it (owner, 22 Oct 2026): income covers it, or every
         * account in the order it is drawn and when each runs low (runwayCardLine). The older headline stays only as
         * the fallback when the accounts cannot be read.
         */ const runText = row.projections && row.projections.length ? (0, $2ddaae90639b5011$export$7526d1fcb4423629)({
            rows: row.projections,
            factFind: factFind,
            horizonYears: horizonYears,
            spentOn: 'the new home'
        }) : null;
        const runway = row.projections && row.projections.length ? (0, $0fe89e03b6df746e$export$464558962ff4a811)(row.projections, horizonYears) : null;
        const cashLeft = $c23f2635a2ea2069$var$cashOf(row);
        const runline = runText ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
            "data-testid": `dz-card-runway-${row.id}`,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "When the money runs out:"
                }),
                " ",
                runText
            ]
        }) : runway ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "When the money runs out:"
                }),
                " ",
                runway.depleted ? `${runway.headline.charAt(0).toLowerCase()}${runway.headline.slice(1)}.` : cashLeft >= 0 && cashLeft < 2000 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "it doesn't, within the ",
                        yrs,
                        " \u2014 but there is almost nothing to spare: ",
                        $c23f2635a2ea2069$var$money(cashLeft),
                        " a year."
                    ]
                }) : cashLeft >= 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: "it doesn't \u2014 income covers the costs every year."
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        runway.headline.charAt(0).toLowerCase(),
                        runway.headline.slice(1),
                        "."
                    ]
                }),
                runway.flag ? ` ${runway.flag}` : ''
            ]
        }) : null;
        const lines = [];
        if (delta != null && delta < -1) {
            const stops = $c23f2635a2ea2069$var$pensionOf(row) < 1 && $c23f2635a2ea2069$var$pensionOf(base) >= 1;
            const mostlyCosts = m.sellingCosts + m.stampDuty >= -delta * 0.5;
            // Rose, as aged care, the village, granny flat and cashflow say it (owner, 22 Oct 2026).
            lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "text-rose-700",
                        children: "Important:"
                    }),
                    " what ",
                    v.they,
                    " leave the family would be ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                        className: "text-rose-700",
                        children: [
                            $c23f2635a2ea2069$var$money(-delta),
                            " less"
                        ]
                    }),
                    " than staying put",
                    stops ? ', and the Age Pension stops' : mostlyCosts ? " \u2014 mostly the stamp duty and selling costs, gone on the day" : '',
                    ".",
                    stops && m.freedCapital >= 1 ? ' This is the downsizing trap.' : ''
                ]
            }));
        }
        const gi = (0, $ed6c3bc1777d5c34$export$432c3d850768ad70)(row.inputs?.deployment, factFind, row.projections);
        if (gi && gi.kind === 'incomeOnly') lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "Worth knowing:"
                }),
                " the guaranteed income is income only. It pays the most for life, and nothing from it goes back to the family, even after an early death."
            ]
        }));
        const sibling = gi ? (0, $ed6c3bc1777d5c34$export$7e3067ac8807505a)(row.id, strategies) : null;
        const familyPanel = gi ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: runline ? 'mt-3' : '',
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
                factFind: factFind,
                personName: gi.personName,
                amount: gi.amount,
                kind: gi.kind,
                incomeAYear: gi.incomeAYear,
                rows: row.projections,
                compareRows: sibling?.projections ?? null,
                compareNote: sibling ? (0, $ed6c3bc1777d5c34$export$2d8e7d1fb8934a4c) : null,
                horizonYears: horizonYears,
                testId: `dz-family-panel-${row.id}`
            })
        }) : null;
        const isChosen = chosenId != null && row.id === chosenId;
        const tradeOff = secondEntry?.second && row === secondRow ? (0, $5a094123650e8adb$export$a104569a4d958475)(secondEntry.second, (0, $f94e45ac645ae232$export$3dc27271f5d5c629)) : estateEntry?.lead && row.name === estateEntry.strategy?.name ? (0, $5a094123650e8adb$export$27f705a6fa40271e)(estateEntry.lead, (0, $f94e45ac645ae232$export$3dc27271f5d5c629)) : null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b383720e6b5df564$export$2e2bcd8739ae039), {
            aligned: true,
            testId: "dz-plan-card",
            whyShown: tradeOff || null,
            chip: chip ? `${chip}${forHome && chip.includes('Leaves the most') ? ', for this home' : ''}` : null,
            chipTone: "blue",
            title: words.title,
            sub: words.sub,
            legacy: $c23f2635a2ea2069$var$legacyOf(row),
            legacyDelta: delta,
            horizonYears: horizonYears,
            baselineWord: (0, $1a5a24a0286ded56$export$b3949d624101f360)('downsizer', {
                rents: (0, $1a5a24a0286ded56$export$71623450cbaee3cf)(factFind)
            }).word,
            bars: delta != null ? {
                gainPct: Math.abs(delta) / maxGain * 100,
                tiedUp: m.sellingCosts + m.stampDuty,
                tiedUpPct: (m.sellingCosts + m.stampDuty) / maxCost * 100
            } : null,
            tiedUpLabel: "Stamp duty and selling costs",
            numbers: numbers,
            runline: runline || familyPanel ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    runline,
                    familyPanel
                ]
            }) : null,
            worthKnowing: lines.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: lines.map((l, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: l
                    }, i))
            }) : null,
            lines: [],
            chosen: isChosen,
            beforeChoose: gi?.incomeOnly && onIncomeOnly ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$4538b371a206da0c), {
                factFind: factFind,
                amount: gi.amount,
                onChange: onIncomeOnly,
                testId: `dz-income-only-${row.id}`
            }) : undefined,
            chooseHeld: !!gi?.incomeOnly && $c23f2635a2ea2069$export$2ae4d3edf3ae676b(row, factFind),
            onExplain: ()=>onExplain(row),
            onRisks: ()=>onRisks(row),
            onChoose: ()=>onChoose(row),
            chooseLabel: chosenId != null && !isChosen ? 'Choose this instead' : 'Choose this plan',
            chosenStrip: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2194d8b5de21e3ff$export$4df4eb62309771d0), {
                possessiveFile: v.possessive,
                onAdvice: onAdvice,
                onCustomise: ()=>onBuildYourOwn(row)
            }),
            detail: renderDetail(row),
            detailOpen: openDetail === key,
            onToggleDetail: ()=>setOpenDetail((d)=>d === key ? null : key),
            detailHint: "where the money goes, the engine's own description and the annuity's terms"
        }, key);
    };
    const Strip = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            "data-testid": "dz-stay-put-strip",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-[13px] font-semibold text-slate-500",
                    children: "Compared with staying put \u2014 the four numbers from step 2"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mt-2 grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-slate-200 bg-slate-200 shadow-card lg:grid-cols-4",
                    children: [
                        {
                            label: 'Age Pension',
                            value: $c23f2635a2ea2069$var$money($c23f2635a2ea2069$var$pensionOf(base)),
                            note: 'a year'
                        },
                        {
                            label: $c23f2635a2ea2069$var$cashOf(base) < 0 ? 'Short each year' : 'Left over each year',
                            value: $c23f2635a2ea2069$var$money(Math.abs($c23f2635a2ea2069$var$cashOf(base))),
                            note: 'money in, less money out',
                            tone: $c23f2635a2ea2069$var$cashOf(base) >= 0 ? 'text-emerald-700' : 'text-rose-700'
                        },
                        {
                            label: `What ${v.they} own`,
                            value: $c23f2635a2ea2069$var$money(ownToday),
                            note: 'today'
                        },
                        {
                            label: 'Left to the family',
                            value: $c23f2635a2ea2069$var$money($c23f2635a2ea2069$var$legacyOf(base)),
                            note: `after about ${yrs}`
                        }
                    ].map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white px-4 py-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-[12px] font-semibold text-slate-500",
                                    children: c.label
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: `mt-0.5 text-[22px] font-bold tabular-nums leading-tight ${c.tone || 'text-slate-900'}`,
                                    children: c.value
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-[12px] text-slate-500",
                                    children: c.note
                                })
                            ]
                        }, c.label))
                })
            ]
        });
    const firstYearCount = (row)=>{
        const f = row?.projections?.[0];
        return (0, $eec331ce661055d2$export$d318875bf548d09)(f?.financials?.socialSecurityBreakdown, f?.financials?.socialSecurity, factFind?.adviceFor === 'couple');
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-6",
        "data-testid": "dz-plans",
        children: [
            notices,
            base && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Strip, {}),
            verdict && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `rounded-xl border border-slate-200 border-l-4 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700 shadow-card ${cost > 0 ? 'border-l-rose-500' : 'border-l-emerald-500'}`,
                "data-testid": "dz-verdict",
                children: verdict
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54f65c4595e0c798$export$2e2bcd8739ae039), {
                value: focus,
                onChange: onFocus,
                household: v.names,
                enteringName: v.names,
                horizonYears: horizonYears,
                coveredSameAsBest: coveredSame,
                bestCovers: coveredSame && $c23f2635a2ea2069$var$cashOf(fullRow((0, $f8ee565b442c040e$export$cf9821b188ee27f0)(recommended, 'legacy'))) >= 0,
                waysTested: ways,
                shown: shown.length,
                testedFor: forHome ? `to use the money, for ${forHome}` : 'to downsize and use the money',
                closingNote: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: "Each card says what the move costs on the day, what it frees, and when the money would run out."
                }),
                subs: goalSubs,
                countLine: showPensionNote ? 'No way of downsizing keeps any Age Pension.' : shown.length === 0 ? 'None leads on this goal.' : undefined
            }),
            showPensionNote ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-2xl border border-slate-200 border-l-4 border-l-brand-navy bg-white p-6 shadow-card",
                "data-testid": "dz-no-pension",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                        className: "text-[19px] font-bold text-slate-900",
                        children: [
                            "No way of downsizing keeps ",
                            v.possessive,
                            " Age Pension"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-2 text-[15px] leading-relaxed text-slate-700",
                        children: $c23f2635a2ea2069$var$pensionOf(base) >= 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "Staying put, ",
                                v.they,
                                " get",
                                v.s,
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                    children: [
                                        $c23f2635a2ea2069$var$money($c23f2635a2ea2069$var$pensionOf(base)),
                                        " a year"
                                    ]
                                }),
                                ". Once the home is sold, Centrelink counts more than ",
                                v.couple ? 'a couple is' : 'one person is',
                                " allowed in every way we tested: the money the sale frees is counted wherever it goes, and renting counts the whole sale."
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "Staying put, Centrelink already counts more than ",
                                v.couple ? 'a couple is' : 'one person is',
                                " allowed, and downsizing doesn't change that."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-3 text-[15px] leading-relaxed text-slate-700",
                        children: "So this goal can't tell the plans apart. Choose one of the other three goals to compare them."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-4 flex flex-wrap gap-3",
                        children: [
                            bestMover && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>setWhy({
                                        row: bestMover,
                                        page: 'pension'
                                    }),
                                className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                                children: [
                                    "Why ",
                                    v.possessive,
                                    " Age Pension is $0"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>onFocus('legacy'),
                                className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                                children: "Compare the plans on another goal"
                            })
                        ]
                    })
                ]
            }) : shown.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
                "data-testid": "dz-no-leader",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-[19px] font-bold text-slate-900",
                        children: "No plan leads on this goal"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 text-[14px] leading-relaxed text-slate-700",
                        children: [
                            "Choose another goal above, or see all ",
                            ways,
                            " ways tested."
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `grid grid-cols-1 gap-5 ${shown.length > 1 ? 'lg:grid-cols-2' : ''}`,
                "data-testid": "dz-plan-cards",
                children: [
                    chosenId != null && !shown.some((s)=>s.id === chosenId) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: shown.length > 1 ? 'lg:col-span-2' : '',
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2194d8b5de21e3ff$export$4df4eb62309771d0), {
                            possessiveFile: v.possessive,
                            onAdvice: onAdvice,
                            offCard: true,
                            testId: "chosen-plan-off-card"
                        })
                    }),
                    shown.map(card)
                ]
            }),
            shown.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c41b14da14ed8be$export$2e2bcd8739ae039), {
                others: others,
                here: {
                    legacy: $c23f2635a2ea2069$var$legacyOf(shown[0]),
                    cashflow: $c23f2635a2ea2069$var$cashOf(shown[0]),
                    pension: $c23f2635a2ea2069$var$pensionOf(shown[0])
                },
                baseLegacy: base ? $c23f2635a2ea2069$var$legacyOf(base) : null,
                baseWord: "staying put",
                onFocus: onFocus,
                testId: "dz-other-leaders"
            }),
            setAside.map((sa)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8dcabb024256f5a9$export$2e2bcd8739ae039), {
                    testId: "dz-set-aside",
                    className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700",
                    note: (link)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                setAside.length === 1 ? 'One plan was set aside: ' : '',
                                (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(sa.strategy, factFind).title.replace(/^./, (c)=>c.toLowerCase()),
                                " would lead on ",
                                sa.labels.map((l)=>({
                                        'Optimal Legacy': 'the estate',
                                        'Optimal Cashflow': 'cashflow',
                                        'Optimal Age Pension': 'the Age Pension'
                                    })[l] || 'one goal').join(' and '),
                                ", but ",
                                sa.warning.replace(/^./, (c)=>c.toLowerCase()),
                                ' ',
                                link
                            ]
                        }),
                    renderCard: ()=>card(sa.strategy)
                }, String(sa.strategy.id ?? sa.strategy.name))),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-3",
                "data-testid": "dz-ways-on",
                children: [
                    shown.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setComparing(true),
                        className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                        "data-testid": "dz-compare",
                        children: "Compare the plans side by side"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onAllWays,
                        className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                        "data-testid": "dz-all-ways",
                        children: [
                            "All ",
                            ways,
                            " ways tested"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onChanges,
                        className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                        "data-testid": "dz-changes",
                        children: "Things that change the answer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>onBuildYourOwn(null),
                        className: "text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy",
                        "data-testid": "dz-build-your-own",
                        children: "Prefer to set the numbers yourself? Build a plan \u2192"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[13px] text-slate-500",
                "data-testid": "all-plans-open-line",
                children: (0, $5a094123650e8adb$export$af182f21f972ef03)(ways)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] text-slate-500",
                children: [
                    "Figures use the rates in force today, with stamp duty on the state's standard scale, and are projections over about ",
                    yrs,
                    ", not guarantees."
                ]
            }),
            comparing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                titleId: "dz-compare-title",
                title: "All the plans, side by side",
                eyebrow: `Over about ${yrs}${base && bestMover && $c23f2635a2ea2069$var$moveOf(bestMover).stampDuty > 0 ? ', with stamp duty' : ''}`,
                onClose: ()=>setComparing(false),
                size: "xl",
                testId: "dz-compare-dialog",
                flush: true,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "px-5 pt-4 text-[14px] text-slate-600",
                        children: "The best plan for each goal, and staying put."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "overflow-x-auto",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "phone-stack min-w-full text-[14px]",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "border-b border-slate-200 text-left text-[12px] font-semibold text-slate-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3",
                                                children: "Plan"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3",
                                                children: "Best for"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3 text-right",
                                                children: "Left to the family"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3 text-right",
                                                children: "Each year"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3 text-right",
                                                children: "Age Pension"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3 text-right",
                                                children: "Freed up"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                    className: "tabular-nums",
                                    children: [
                                        base && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "border-b border-slate-100 bg-slate-50",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-5 py-3 font-semibold text-slate-900",
                                                    children: "Staying put"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    "data-label": "Best for",
                                                    className: "px-5 py-3 text-slate-500",
                                                    children: "the comparison"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    "data-label": "Left to the family",
                                                    className: "px-5 py-3 text-right",
                                                    children: $c23f2635a2ea2069$var$money($c23f2635a2ea2069$var$legacyOf(base))
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    "data-label": "Each year",
                                                    className: "px-5 py-3 text-right",
                                                    children: $c23f2635a2ea2069$var$signed($c23f2635a2ea2069$var$cashOf(base))
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    "data-label": "Age Pension",
                                                    className: "px-5 py-3 text-right",
                                                    children: $c23f2635a2ea2069$var$money($c23f2635a2ea2069$var$pensionOf(base))
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    "data-label": "Freed up",
                                                    className: "px-5 py-3 text-right",
                                                    children: "\u2014"
                                                })
                                            ]
                                        }),
                                        [
                                            ...new Map([
                                                ...shown,
                                                ...[
                                                    'legacy',
                                                    'cashflow',
                                                    'pension'
                                                ].map((g)=>fullRow((0, $f8ee565b442c040e$export$cf9821b188ee27f0)(recommended, g))).filter(Boolean)
                                            ].map((s)=>[
                                                    String(s.id),
                                                    s
                                                ])).values()
                                        ].map((s)=>{
                                            const d = $c23f2635a2ea2069$var$legacyOf(s) - $c23f2635a2ea2069$var$legacyOf(base);
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "px-5 py-3 font-semibold text-slate-900",
                                                        children: [
                                                            (0, $6cafaaa2bceecd94$export$ad52b9cc096416fa)($c23f2635a2ea2069$var$moveOf(s)),
                                                            (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(s, factFind).title.includes(', ') ? `, ${(0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(s, factFind).title.split(', ').slice(1).join(', ')}` : ''
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        "data-label": "Best for",
                                                        className: "px-5 py-3 text-slate-600",
                                                        children: labelsFor(s).map(chipFor).filter(Boolean).join(" \xb7 ") || "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        "data-label": "Left to the family",
                                                        className: "px-5 py-3 text-right font-semibold",
                                                        children: [
                                                            $c23f2635a2ea2069$var$money($c23f2635a2ea2069$var$legacyOf(s)),
                                                            base && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: `block text-[12px] ${d < 0 ? 'text-rose-700' : 'text-emerald-700'}`,
                                                                children: $c23f2635a2ea2069$var$signed(d)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        "data-label": "Each year",
                                                        className: `px-5 py-3 text-right ${$c23f2635a2ea2069$var$cashOf(s) < 0 ? 'text-rose-700' : ''}`,
                                                        children: $c23f2635a2ea2069$var$cashOf(s) < 0 ? `short ${$c23f2635a2ea2069$var$money(-$c23f2635a2ea2069$var$cashOf(s))}` : $c23f2635a2ea2069$var$signed($c23f2635a2ea2069$var$cashOf(s))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        "data-label": "Age Pension",
                                                        className: "px-5 py-3 text-right",
                                                        children: $c23f2635a2ea2069$var$money($c23f2635a2ea2069$var$pensionOf(s))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        "data-label": "Freed up",
                                                        className: "px-5 py-3 text-right",
                                                        children: $c23f2635a2ea2069$var$money($c23f2635a2ea2069$var$moveOf(s).freedCapital)
                                                    })
                                                ]
                                            }, String(s.id));
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            why && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                titleId: "dz-why-title",
                eyebrow: (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(why.row, factFind).title,
                title: why.page === 'pension' ? `Why ${v.possessive} Age Pension ${$c23f2635a2ea2069$var$pensionOf(why.row) > $c23f2635a2ea2069$var$pensionOf(base) + 1 ? 'rises' : $c23f2635a2ea2069$var$pensionOf(why.row) < $c23f2635a2ea2069$var$pensionOf(base) - 1 ? 'falls' : 'is'} ${$c23f2635a2ea2069$var$pensionOf(why.row) > $c23f2635a2ea2069$var$pensionOf(base) + 1 || $c23f2635a2ea2069$var$pensionOf(why.row) < $c23f2635a2ea2069$var$pensionOf(base) - 1 ? 'to ' : ''}${$c23f2635a2ea2069$var$money($c23f2635a2ea2069$var$pensionOf(why.row))}` : why.page === 'cashflow' ? 'Left over each year' : 'The money freed up',
                onClose: ()=>setWhy(null),
                testId: "dz-why-dialog",
                children: [
                    why.page === 'pension' && (()=>{
                        const before = firstYearCount(base);
                        const after = firstYearCount(why.row);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-3 text-[14px] leading-relaxed text-slate-700",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: $c23f2635a2ea2069$export$715f1a62b1300ad4(why.row)
                                }),
                                before && after && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                    className: "w-full tabular-nums",
                                    "data-testid": "dz-why-pension-count",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-1.5",
                                                        children: "Counted staying put"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-1.5 text-right font-semibold",
                                                        children: $c23f2635a2ea2069$var$money(before.assessableAssets)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-1.5",
                                                        children: "Counted after the move"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-1.5 text-right font-semibold",
                                                        children: $c23f2635a2ea2069$var$money(after.assessableAssets)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-1.5",
                                                        children: "Income counted after the move"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "py-1.5 text-right",
                                                        children: [
                                                            $c23f2635a2ea2069$var$money(after.assessableIncome),
                                                            " a year"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-1.5 font-semibold text-slate-900",
                                                        children: "Age Pension"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-1.5 text-right font-bold text-slate-900",
                                                        children: $c23f2635a2ea2069$var$money($c23f2635a2ea2069$var$pensionOf(why.row))
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                after && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        "The ",
                                        after.determinedBy === 'income' ? 'income' : 'assets',
                                        " test sets the pension: it gives ",
                                        $c23f2635a2ea2069$var$money(after.determinedBy === 'income' ? after.incomeTestPension : after.assetTestPension),
                                        " a year, against ",
                                        $c23f2635a2ea2069$var$money(after.determinedBy === 'income' ? after.assetTestPension : after.incomeTestPension),
                                        " on the other test, and the lower of the two is paid. Staying put, the pension is ",
                                        $c23f2635a2ea2069$var$money($c23f2635a2ea2069$var$pensionOf(base)),
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>{
                                        setWhy(null);
                                        onYearByYear(why.row);
                                    },
                                    className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                    children: "See the year-by-year figures"
                                })
                            ]
                        });
                    })(),
                    why.page === 'cashflow' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-3 text-[14px] leading-relaxed text-slate-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "Money in, less money out, in the first year: ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: $c23f2635a2ea2069$var$cashOf(why.row) < 0 ? `short ${$c23f2635a2ea2069$var$money(-$c23f2635a2ea2069$var$cashOf(why.row))}` : `${$c23f2635a2ea2069$var$money($c23f2635a2ea2069$var$cashOf(why.row))} to spare`
                                    }),
                                    ". Staying put: ",
                                    $c23f2635a2ea2069$var$cashOf(base) < 0 ? `short ${$c23f2635a2ea2069$var$money(-$c23f2635a2ea2069$var$cashOf(base))}` : `${$c23f2635a2ea2069$var$money($c23f2635a2ea2069$var$cashOf(base))} to spare`,
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: $c23f2635a2ea2069$var$moveOf(why.row).sellAndRent ? 'The rent is part of the money out; Rent Assistance and what the sale money earns are part of the money in.' : $c23f2635a2ea2069$var$moveOf(why.row).freedCapital >= 1 ? 'What the money the sale frees earns, wherever it is put, is part of the money in, and so is the Age Pension.' : $c23f2635a2ea2069$var$moveOf(why.row).buyUpShortfall >= 1 ? 'Savings spent on the new home and its duty stop earning, so the money in changes with the Age Pension and what is left invested.' : 'The new home changes little of the money in or out; the Age Pension is the main difference.'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Explain this sets out every line of it, year by year."
                            })
                        ]
                    }),
                    why.page === 'freed' && (()=>{
                        const m = $c23f2635a2ea2069$var$moveOf(why.row);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-3 text-[14px] leading-relaxed text-slate-700",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                    className: "w-full tabular-nums",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-1.5",
                                                        children: "Sale, less costs"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-1.5 text-right",
                                                        children: $c23f2635a2ea2069$var$money(m.salePrice - m.sellingCosts)
                                                    })
                                                ]
                                            }),
                                            !m.sellAndRent && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-1.5",
                                                        children: "New home"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "py-1.5 text-right",
                                                        children: [
                                                            "\u2212",
                                                            $c23f2635a2ea2069$var$money(m.newHomePrice)
                                                        ]
                                                    })
                                                ]
                                            }),
                                            !m.sellAndRent && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "py-1.5",
                                                        children: [
                                                            "Stamp duty",
                                                            m.state ? `, ${m.state}` : ''
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-1.5 text-right",
                                                        children: m.stampDuty > 0 ? `\u{2212}${$c23f2635a2ea2069$var$money(m.stampDuty)}` : 'none charged'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-1.5 font-semibold text-slate-900",
                                                        children: "Money freed up"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-1.5 text-right font-bold text-slate-900",
                                                        children: $c23f2635a2ea2069$var$money(m.freedCapital)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: m.buyUpShortfall >= 1 ? `Nothing is freed: the new home and its duty cost ${$c23f2635a2ea2069$var$money(m.buyUpShortfall)} more than the sale, which comes from savings.` : m.freedCapital >= 1 ? 'Money freed is counted for the Age Pension wherever it goes; that is the downsizing trap. The plan says where it goes.' : 'The sale buys the new home and nothing is left over.'
                                })
                            ]
                        });
                    })()
                ]
            })
        ]
    });
};
var $c23f2635a2ea2069$export$2e2bcd8739ae039 = $c23f2635a2ea2069$var$DzPlansView;


/**
 * The downsizing plan page (rebuild, 21 Oct 2026; the agreed mock-up's j1-hub).
 *
 * Where the module opens once a plan is chosen: the sale and the state, the chosen plan against staying put,
 * the advice document, and the next step — telling Services Australia about the sale, with the 24-month
 * exemption explained. Every figure is the chosen card's own, as chosen.
 *
 * Aged care's page, in the shared pieces (owner, 22 Oct 2026: "Yes i want this all consistent"): the chosen-plan
 * card (ChosenPlanCard), the document and the next step in one card (DocumentAndNextStep), "Model something
 * else" — another home with the same answers, or a new model from scratch (ModelSomethingElse) — and the ways
 * on as links with icons (PlanPageLinks).
 */ 
parcelRequire("acw62");








const $c4a5c3133e48e027$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
const $c4a5c3133e48e027$var$signed = (n)=>`${n >= 0 ? '+' : "\u2212"}${$c4a5c3133e48e027$var$money(Math.abs(n))}`;
const $c4a5c3133e48e027$var$dateWords = (iso)=>iso ? new Date(iso).toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }) : null;
const $c4a5c3133e48e027$var$MOTIVE_WORDS = {
    money: 'to free up money',
    home: 'for a home that suits them better',
    both: 'for a better home and to free up money'
};
const $c4a5c3133e48e027$var$DzHub = ({ factFind: factFind, plan: plan, homeCount: homeCount, onChangeSale: onChangeSale, onAnotherHome: onAnotherHome, onStartFresh: onStartFresh, onAllPlans: onAllPlans, onExplain: onExplain, onRisks: onRisks, onAdvice: onAdvice, onBuild: onBuild, onBuildNew: onBuildNew, outOfDate: outOfDate = null, onGuide: onGuide, onAssumptions: onAssumptions, onHome: onHome })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const card = plan.inputs.card;
    const m = card.move;
    const base = card.baseline;
    const delta = base ? card.plan.legacy - base.legacy : null;
    const yrs = `${card.horizonYears} ${card.horizonYears === 1 ? 'year' : 'years'}`;
    const chosenOn = $c4a5c3133e48e027$var$dateWords(plan.createdAt);
    const cash = (n)=>n < 0 ? `short ${$c4a5c3133e48e027$var$money(-n)}` : $c4a5c3133e48e027$var$money(n);
    const stateName = (0, $669f0c9987a611db$export$2f609b1773ce8fef).find((s)=>s.code === m.state)?.name;
    const when = m.date ? `Selling on ${$c4a5c3133e48e027$var$dateWords(m.date)}` : 'Selling now';
    const motive = String((factFind?.goals || {}).dzMotive || '');
    const link = 'font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900';
    const cf = card.plan.cashflow;
    const pensionChange = base ? card.plan.pension - base.pension : null;
    // The strip, as the tested plans' card says it (DzPlansView): the Age Pension, the year's cash, the money freed.
    const figures = [
        {
            label: 'Age Pension',
            value: $c4a5c3133e48e027$var$money(card.plan.pension),
            unit: 'a year',
            testId: 'dz-hub-pension',
            note: pensionChange != null && Math.abs(pensionChange) >= 1 ? `${$c4a5c3133e48e027$var$signed(pensionChange)} a year vs staying put` : base ? 'the same as staying put' : undefined
        },
        {
            // A shortfall is named as one, as aged care and support at home do (22 Oct 2026).
            label: cf < 0 ? 'Each year, short by' : 'Left over each year',
            value: $c4a5c3133e48e027$var$money(Math.abs(cf)),
            tone: cf < 0 ? 'plain' : 'good',
            testId: 'dz-hub-cashflow',
            note: base ? `staying put: ${cash(base.cashflow)}` : cf < 0 ? 'covered by savings' : 'stays in the bank'
        },
        {
            label: 'Money freed up',
            value: $c4a5c3133e48e027$var$money(m.freedCapital),
            testId: 'dz-hub-freed',
            note: m.sellAndRent ? 'renting: the whole sale, after costs' : m.freedCapital < 1 ? m.buyUpShortfall >= 1 ? `the sale buys the new home; ${$c4a5c3133e48e027$var$money(m.buyUpShortfall)} more from savings` : 'the sale buys the new home' : m.stampDuty > 0 ? 'after stamp duty' : 'no stamp duty in the figures'
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        "data-testid": "dz-hub",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[13px] text-slate-500",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onHome,
                                className: "underline decoration-dotted underline-offset-2 hover:text-slate-800",
                                children: "Home"
                            }),
                            " \u203A Downsizing"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "mt-2 text-[32px] font-bold leading-tight tracking-tight text-brand-navy",
                        "data-testid": "dz-hub-title",
                        children: v.you ? 'Your downsizing plan' : `${v.Possessive} downsizing plan`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1 text-[15px] text-slate-600",
                        children: [
                            when,
                            " for ",
                            $c4a5c3133e48e027$var$money(m.salePrice),
                            stateName ? `, in ${stateName}` : '',
                            m.homeName ? ` \u{2014} ${m.homeName}` : '',
                            ".",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onChangeSale,
                                className: link,
                                "data-testid": "dz-hub-change-sale",
                                children: "Change the sale"
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onAnotherHome,
                                className: link,
                                "data-testid": "dz-hub-another-home",
                                children: "Model another home"
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onStartFresh,
                                className: link,
                                "data-testid": "dz-hub-start-fresh-header",
                                children: "Start a new model from scratch"
                            }),
                            "."
                        ]
                    }),
                    ($c4a5c3133e48e027$var$MOTIVE_WORDS[motive] || delta != null) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 text-[15px] leading-relaxed text-slate-900",
                        children: [
                            $c4a5c3133e48e027$var$MOTIVE_WORDS[motive] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            "Why ",
                                            v.you ? "you're" : `${v.they} ${v.are}`,
                                            " moving:"
                                        ]
                                    }),
                                    " ",
                                    v.you ? $c4a5c3133e48e027$var$MOTIVE_WORDS[motive].replace('them', 'you') : $c4a5c3133e48e027$var$MOTIVE_WORDS[motive],
                                    ". "
                                ]
                            }),
                            delta != null && (delta < 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "The move leaves the family ",
                                    $c4a5c3133e48e027$var$money(-delta),
                                    " less than staying put over about ",
                                    yrs,
                                    m.sellingCosts + m.stampDuty > 0 ? `, mostly the ${$c4a5c3133e48e027$var$money(m.sellingCosts + m.stampDuty)} of selling costs and stamp duty` : '',
                                    "."
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "The move leaves the family ",
                                    $c4a5c3133e48e027$var$money(delta),
                                    " more than staying put over about ",
                                    yrs,
                                    "."
                                ]
                            }))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e32778aa0d8016bc$export$582b8e8b67199c5d), {
                reason: outOfDate,
                onChooseAgain: onAllPlans,
                testId: "dz-hub-out-of-date"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b200f9f0b001184e$export$14ec62d97a734af3), {
                testIdPrefix: "dz-hub",
                chosenOn: chosenOn,
                builtByYou: card.origin === 'manual',
                title: card.words.title,
                sub: card.words.sub,
                estate: card.plan.legacy,
                years: card.horizonYears,
                estateDelta: delta,
                baseWord: "staying put",
                figures: figures,
                onExplain: onExplain,
                onRisks: onRisks,
                onAllPlans: onAllPlans,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[14px] leading-relaxed text-slate-800",
                        "data-testid": "dz-hub-move",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "The move:"
                            }),
                            " the sale leaves ",
                            $c4a5c3133e48e027$var$money(m.salePrice - m.sellingCosts),
                            " after ",
                            $c4a5c3133e48e027$var$money(m.sellingCosts),
                            " of selling costs",
                            m.sellAndRent ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "; ",
                                    v.they,
                                    " rent instead",
                                    m.rentPerWeek > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            ", at ",
                                            $c4a5c3133e48e027$var$money(m.rentPerWeek),
                                            " a week"
                                        ]
                                    }) : ', the rent not entered yet',
                                    "."
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "; the new home",
                                    m.homeName ? `, ${m.homeName},` : '',
                                    " costs about ",
                                    (0, $4e46e0dde908c630$export$b48e0c6120d679a4)(m.newHomePrice),
                                    m.stampDuty > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            ", with ",
                                            $c4a5c3133e48e027$var$money(m.stampDuty),
                                            " of stamp duty"
                                        ]
                                    }) : ", with no stamp duty in the figures \u2014 no state chosen",
                                    m.buyUpShortfall >= 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            ", and ",
                                            $c4a5c3133e48e027$var$money(m.buyUpShortfall),
                                            " of it comes from savings"
                                        ]
                                    }) : null,
                                    "."
                                ]
                            }),
                            m.sellingCosts + m.stampDuty > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    " Stamp duty and selling costs: ",
                                    $c4a5c3133e48e027$var$money(m.sellingCosts + m.stampDuty),
                                    ", gone on the day."
                                ]
                            }),
                            base && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    " Staying put leaves the family ",
                                    $c4a5c3133e48e027$var$money(base.legacy),
                                    "."
                                ]
                            })
                        ]
                    }),
                    card.family && card.family.rows.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
                            factFind: factFind,
                            personName: card.family.personName,
                            amount: card.family.amount,
                            kind: card.family.kind,
                            incomeAYear: card.family.incomeAYear,
                            rows: null,
                            frozen: card.family.rows,
                            compareNote: card.family.compareNote,
                            horizonYears: card.horizonYears,
                            testId: "dz-hub-family-panel"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "dz-hub-next",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b200f9f0b001184e$export$402ee133f3748280), {
                    documentState: plan.soaSnapshot ? 'prepared' : 'not prepared yet',
                    documentLine: "The written record of this plan, the sale and the new home.",
                    documentAction: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onAdvice,
                        className: link,
                        "data-testid": "dz-hub-advice",
                        children: plan.soaSnapshot ? 'Open the advice document' : 'Get the advice document'
                    }),
                    nextTitle: "tell Services Australia about the sale",
                    nextLine: m.sellAndRent ? `Within 14 days of settlement, with the rent ${v.they} will pay, so Rent Assistance is worked out.` : `Within 14 days of settlement. Money set aside for the new home is exempt for up to 24 months while ${v.they} buy.`,
                    nextAction: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onHome,
                        className: link,
                        "data-testid": "dz-hub-action-plan",
                        children: "Full action plan on Home"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b200f9f0b001184e$export$9e6485da48da532f), {
                testId: "dz-hub-model-something-else",
                options: [
                    {
                        title: 'Another home, same answers',
                        body: `Keeps the sale, the state and ${v.their} answers to the questions. Only the new home is new${homeCount > 1 ? ` (${homeCount} homes modelled so far)` : ''}.`,
                        action: 'Model another home',
                        onClick: onAnotherHome,
                        testId: 'dz-hub-another-home-model'
                    },
                    {
                        title: 'A new model from scratch',
                        body: 'Starts again at step 1 with nothing carried over, and asks the questions again so any of them can change.',
                        action: 'Start a new model from scratch',
                        onClick: onStartFresh,
                        testId: 'dz-hub-start-fresh'
                    }
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b200f9f0b001184e$export$29d0c084f57dd4ac), {
                links: [
                    {
                        label: 'Change the sale or new home',
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        onClick: onChangeSale
                    },
                    {
                        label: 'All the plans we tested',
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e583651be68dae50$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        onClick: onAllPlans
                    },
                    // Two doors (owner, 25 Oct 2026): change this plan, or start a blank one.
                    {
                        label: card.origin === 'manual' ? 'Change the plan you built' : 'Customise this plan',
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $712d717556ef1508$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        onClick: onBuild,
                        testId: 'dz-hub-build'
                    },
                    ...onBuildNew ? [
                        {
                            label: 'Build a plan yourself',
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $712d717556ef1508$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            onClick: onBuildNew,
                            testId: 'dz-hub-build-new'
                        }
                    ] : [],
                    {
                        label: "How downsizing works \u2014 the guide",
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        onClick: onGuide
                    },
                    {
                        label: 'Rates and assumptions',
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        onClick: onAssumptions
                    }
                ]
            })
        ]
    });
};
var $c4a5c3133e48e027$export$2e2bcd8739ae039 = $c4a5c3133e48e027$var$DzHub;


/**
 * "Model another home" (downsizing rebuild, 21 Oct 2026; the agreed mock-up's j2-step1).
 *
 * Opened from the plan page or Home. Everything is carried over from the chosen plan — the sale, the state,
 * the years and the answers — and only the home changes: its name, so the plans can be told apart, and its
 * price. The duty and the money freed up update as the price is typed. The plans are then re-tested for
 * this home, saved as its own plan; the chosen plan stays chosen until the client chooses again.
 */ 
parcelRequire("acw62");






const $24f508e167d5afdc$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
const $24f508e167d5afdc$var$DzAnotherHome = ({ factFind: factFind, setFactFind: setFactFind, salePrice: salePrice, sellingCosts: sellingCosts, state: state, chosenTitle: chosenTitle, onRun: onRun, onCancel: onCancel })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const goals = factFind?.goals || {};
    const setGoal = (patch)=>setFactFind?.((prev)=>({
                ...prev,
                goals: {
                    ...prev?.goals || {},
                    ...patch
                }
            }));
    const price = Number(goals.dzNewHomePrice) > 0 ? Number(goals.dzNewHomePrice) : 0;
    const duty = (0, $6b146b31ad2b1e77$export$a8a5bac4bde49384)(state, price);
    const f = (0, $6b146b31ad2b1e77$export$855cd09595261b3b)({
        salePrice: salePrice,
        sellingCosts: sellingCosts,
        newHomePrice: price,
        stampDuty: duty,
        sellAndRent: false
    });
    const stateName = (0, $669f0c9987a611db$export$2f609b1773ce8fef).find((s)=>s.code === state)?.name;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        "data-testid": "dz-another-home",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[15px] leading-relaxed text-slate-700",
                children: [
                    price > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            v.you ? "You've" : `${v.Names} ${v.have}`,
                            " found a home for ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: $24f508e167d5afdc$var$money(price)
                            }),
                            ". "
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "Enter the home ",
                            v.you ? "you've" : `${v.they}'ve`,
                            " found. "
                        ]
                    }),
                    "Everything else is carried over",
                    chosenTitle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " from the chosen plan, \u201C",
                            chosenTitle,
                            "\u201D"
                        ]
                    }) : '',
                    "; this saves as its own plan, and the chosen one stays chosen."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[12px] font-semibold text-brand-navy",
                        children: "The new home"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3 grid grid-cols-1 gap-x-7 gap-y-4 md:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "dz-home-name",
                                        className: "text-[13px] font-semibold text-slate-600",
                                        children: "Name, so the plans can be told apart"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        id: "dz-home-name",
                                        type: "text",
                                        value: String(goals.dzHomeName || ''),
                                        onChange: (e)=>setGoal({
                                                dzHomeName: e.target.value.slice(0, 80)
                                            }),
                                        placeholder: "e.g. Elm Street townhouse",
                                        className: "mt-1 block w-full max-w-sm rounded-lg border border-slate-300 px-3 py-2 text-[15px]",
                                        "data-testid": "dz-home-name"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-[13px] font-semibold text-slate-600",
                                        children: "Price"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                        value: price || '',
                                        onChange: (x)=>setGoal({
                                                dzNewHomePrice: Math.max(0, x ?? 0),
                                                dzHousing: 'buy'
                                            }),
                                        className: "mt-1 w-48",
                                        ariaLabel: "The home's price",
                                        testId: "dz-another-price"
                                    })
                                ]
                            })
                        ]
                    }),
                    price > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                        className: "mt-4 w-full max-w-xl text-[14px] tabular-nums",
                        "data-testid": "dz-another-sums",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    className: "border-b border-slate-100",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-1.5 text-slate-700",
                                            children: "Sale, less costs"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-1.5 text-right",
                                            children: $24f508e167d5afdc$var$money(f.netProceeds)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    className: "border-b border-slate-100",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-1.5 text-slate-700",
                                            children: "New home"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                            className: "py-1.5 text-right",
                                            children: [
                                                "\u2212",
                                                $24f508e167d5afdc$var$money(price)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    className: "border-b border-slate-100",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                            className: "py-1.5 text-slate-700",
                                            children: [
                                                "Stamp duty",
                                                stateName ? `, ${stateName}` : ''
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-1.5 text-right",
                                            children: stateName ? `\u{2212}${$24f508e167d5afdc$var$money(f.stampDuty)}` : "none \u2014 no state chosen on step 1"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-1.5 font-semibold text-slate-900",
                                            children: f.buyUpShortfall >= 1 ? 'From savings' : 'Money freed up'
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-1.5 text-right font-bold text-slate-900",
                                            "data-testid": "dz-another-freed",
                                            children: $24f508e167d5afdc$var$money(f.buyUpShortfall >= 1 ? f.buyUpShortfall : f.freedCapital)
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onCancel,
                        className: "text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                        children: "Back to the plan"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onRun,
                        disabled: !(price > 0),
                        "data-testid": "dz-another-run",
                        className: "inline-flex h-11 items-center gap-2 rounded-lg bg-blue-600 hover:bg-blue-700 px-5 text-[14px] font-semibold text-white shadow-sm disabled:cursor-not-allowed disabled:opacity-50",
                        children: [
                            "Test the ways to use the money ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                size: 16
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $24f508e167d5afdc$export$2e2bcd8739ae039 = $24f508e167d5afdc$var$DzAnotherHome;


/**
 * "Build a plan yourself" — downsizing's ledger (rebuild, 21 Oct 2026; the village's j1-build, carried over
 * by the owner's rule: Manual Control gets the engine's card, Explain this, risks, buttons and words in the
 * same build, every module).
 *
 * One picture of the money: where it comes from (the sale, after its costs; savings, only where the new home
 * costs more than the sale leaves), where it goes in order (the new home and its stamp duty, or the rent; the
 * emergency money; each person's downsizer contribution; a guaranteed income; an investment property; an
 * investment bond; funeral bonds; a gift; investing), and "still to place" joining the two — anything not
 * placed stays in the bank. Beside it, what the plan does, updating as it changes, and "Before you choose":
 * owning the home 10 years (a downsizer contribution) and that nothing comes back from an income-only annuity.
 *
 * Presentation over the page's Manual Control state: every input writes the same `details` the projection
 * already reads (applyDownsizeToFactFind), so the figures are the engine's own.
 */ 

var $acw62 = parcelRequire("acw62");
























/**
 * The hand-built plan ("Build a plan yourself") and the `details` the projection reads (downsizing rebuild,
 * 21 Oct 2026). One mapping each way, so the ledger, a tested plan seeding it, a saved plan reopening it and
 * the projection all read the same fields.
 */ 
const $3ffb5e286ef10c73$var$num = (v)=>Number(v) || 0;
function $3ffb5e286ef10c73$export$16b92ab69d0ca0d9(L) {
    const d = L.deployment || {};
    const placed = $3ffb5e286ef10c73$var$num(L.downsizerContribution) + $3ffb5e286ef10c73$var$num(L.partnerDownsizerContribution) + $3ffb5e286ef10c73$var$num(L.giftingAmount) + $3ffb5e286ef10c73$var$num(L.funeralBondPurchase) + $3ffb5e286ef10c73$var$num(d.shares) + $3ffb5e286ef10c73$var$num(d.investmentProperty) + $3ffb5e286ef10c73$var$num(d.ipStampDuty) + $3ffb5e286ef10c73$var$num(d.annuity) + $3ffb5e286ef10c73$var$num(d.superContribution) + $3ffb5e286ef10c73$var$num(d.partnerSuperContribution) + $3ffb5e286ef10c73$var$num(d.investmentBond);
    return {
        placed: placed
    };
}
function $3ffb5e286ef10c73$export$b283f320d1480737(L) {
    const { stampDuty: stampDuty, buyUpShortfall: buyUpShortfall } = (0, $6b146b31ad2b1e77$export$855cd09595261b3b)({
        salePrice: L.salePrice,
        sellingCosts: L.sellingCosts,
        newHomePrice: L.newHomePurchasePrice,
        stampDuty: L.stampDuty,
        sellAndRent: L.sellAndRent
    });
    return {
        salePrice: $3ffb5e286ef10c73$var$num(L.salePrice),
        sellingCosts: $3ffb5e286ef10c73$var$num(L.sellingCosts),
        stampDuty: stampDuty,
        newHomeState: L.newHomeState,
        newHomePurchasePrice: L.sellAndRent ? 0 : $3ffb5e286ef10c73$var$num(L.newHomePurchasePrice),
        rentInstead: L.sellAndRent,
        rentPerWeek: L.sellAndRent ? $3ffb5e286ef10c73$var$num(L.rentPerWeek) : 0,
        downsizerContribution: $3ffb5e286ef10c73$var$num(L.downsizerContribution),
        partnerDownsizerContribution: $3ffb5e286ef10c73$var$num(L.partnerDownsizerContribution),
        commenceIncomeStream: !!L.commenceIncomeStream,
        giftingAmount: $3ffb5e286ef10c73$var$num(L.giftingAmount),
        funeralBondPurchase: $3ffb5e286ef10c73$var$num(L.funeralBondPurchase),
        deployment: L.deployment || {},
        buyUpFunding: buyUpShortfall > 0 ? L.buyUpFunding : undefined,
        buyUpCgtOverrides: L.buyUpCgtOverrides
    };
}
function $3ffb5e286ef10c73$export$2d47a140007a8f61(details, fallback) {
    const d = details || {};
    const has = (k)=>d[k] != null && d[k] !== '';
    const rents = d.rentInstead === true;
    return {
        salePrice: has('salePrice') ? $3ffb5e286ef10c73$var$num(d.salePrice) : fallback.salePrice,
        sellingCosts: has('sellingCosts') ? $3ffb5e286ef10c73$var$num(d.sellingCosts) : fallback.sellingCosts,
        sellAndRent: rents,
        rentPerWeek: rents ? $3ffb5e286ef10c73$var$num(d.rentPerWeek) || fallback.rentPerWeek : fallback.rentPerWeek,
        newHomePurchasePrice: rents ? fallback.newHomePurchasePrice : has('newHomePurchasePrice') ? $3ffb5e286ef10c73$var$num(d.newHomePurchasePrice) : fallback.newHomePurchasePrice,
        stampDuty: has('stampDuty') ? $3ffb5e286ef10c73$var$num(d.stampDuty) : fallback.stampDuty,
        newHomeState: typeof d.newHomeState === 'string' ? d.newHomeState : fallback.newHomeState,
        downsizerContribution: $3ffb5e286ef10c73$var$num(d.downsizerContribution),
        partnerDownsizerContribution: $3ffb5e286ef10c73$var$num(d.partnerDownsizerContribution),
        commenceIncomeStream: d.commenceIncomeStream === true,
        giftingAmount: $3ffb5e286ef10c73$var$num(d.giftingAmount),
        funeralBondPurchase: $3ffb5e286ef10c73$var$num(d.funeralBondPurchase),
        deployment: {
            ...d.deployment || {}
        },
        buyUpFunding: {
            ...d.buyUpFunding || {}
        },
        buyUpCgtOverrides: {
            ...d.buyUpCgtOverrides || {}
        }
    };
}
function $3ffb5e286ef10c73$export$4c069de515dd3018(L) {
    return {
        ...L,
        downsizerContribution: 0,
        partnerDownsizerContribution: 0,
        commenceIncomeStream: false,
        giftingAmount: 0,
        funeralBondPurchase: 0,
        deployment: {}
    };
}


/**
 * What each downsizing choice does, said where the choice is made.
 *
 * WHY THESE ARE HERE AND NOT ONLY ON THE INTRO PAGE. The module's opening explainer already covers
 * the 24-month exemption and the downsizer contribution in general terms — but that is read once,
 * before any numbers exist, and it cannot say what THIS client's choice does. These say it at the
 * point of decision, with the client's own figures, which is the whole difference between a rule and
 * a consequence.
 *
 * They replace the same content from the floating "What's happening" panel, which a client had to
 * know to open.
 */ 
parcelRequire("acw62");


function $ca8c3002399ce80c$export$f6ec7687502bb548({ pensionBefore: pensionBefore, pensionAfter: pensionAfter, freedCapital: freedCapital, alreadySoftened: alreadySoftened = false }) {
    const lost = Math.round(pensionBefore) - Math.round(pensionAfter);
    // Below a token amount there is nothing worth acting on, and a warning would be noise.
    if (lost < 500 || !(freedCapital > 0)) return null;
    const gone = Math.round(pensionAfter) <= 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$36b8132fbfd1058f), {
        tone: "warn",
        heading: gone ? `This is the downsizing trap \u{2014} the Age Pension stops` : `This is the downsizing trap \u{2014} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(lost)} a year of Age Pension`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "The home was exempt. The ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(freedCapital)
                    }),
                    " it turns into is counted, and deemed to earn income \u2014 which is what moves the pension",
                    gone ? ' all the way to nil' : '',
                    "."
                ]
            }),
            !alreadySoftened && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-1.5",
                children: [
                    "Two of the boxes below put part of that money back outside the assets test: a",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "funeral bond"
                    }),
                    " is exempt up to the published limit per person, and a",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "gift"
                    }),
                    " within the yearly free area leaves the test straight away. Neither undoes the trap, but both reduce what is counted \u2014 and the Suggestion Engine ranks them against the alternatives."
                ]
            })
        ]
    });
}
function $ca8c3002399ce80c$export$c2e5ea36163c0651({ downsizeDate: downsizeDate, freedCapital: freedCapital }) {
    if (!downsizeDate) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$36b8132fbfd1058f), {
        tone: "info",
        heading: "If there is a gap before you buy, the money stays exempt for a while",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "The part of the proceeds you ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "intend to use for the new home"
                    }),
                    " is exempt from the assets test for up to ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "24 months"
                    }),
                    " \u2014 up to 36 if you are delayed for reasons outside your control. During that time it is counted under the income test only, and at the",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "lower deeming rate"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-1.5",
                children: [
                    "Once you have bought, the new home is exempt and this stops applying. Anything left over \u2014",
                    freedCapital > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " here about ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(freedCapital)
                            }),
                            " \u2014"
                        ]
                    }) : null,
                    " is counted from the day of sale. Tell Services Australia within ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "14 days"
                    }),
                    " of selling."
                ]
            })
        ]
    });
}
function $ca8c3002399ce80c$export$826fdd034b051d4({ clientAmount: clientAmount, partnerAmount: partnerAmount = 0, isPensionAge: isPensionAge = true }) {
    const total = (Number(clientAmount) || 0) + (Number(partnerAmount) || 0);
    if (!(total > 0)) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$36b8132fbfd1058f), {
        tone: "info",
        heading: `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(total)} moves from the sale into super`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "A downsizer contribution does not count towards your normal contribution caps, and you can make it whatever your super balance. Inside super, earnings are taxed at 15% at most, and nothing in a retirement pension \u2014 usually far less than in your own name."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-1.5",
                children: isPensionAge ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "The trade-off:"
                        }),
                        " the home was exempt from the Age Pension assets test and super is not, once you are pension age. So this can lower the pension even while it lowers the tax. Whether that is worth it is what the Suggestion Engine ranks."
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "Worth knowing:"
                        }),
                        " super in accumulation is not counted for the Age Pension until you reach pension age. After that it is, so the pension effect arrives later."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-1.5 text-slate-500",
                children: [
                    "You can use it ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "once, ever"
                    }),
                    ", from a single home sale, and it must be made within 90 days of settlement."
                ]
            })
        ]
    });
}
function $ca8c3002399ce80c$export$7d6b9ea02ec846aa({ salePrice: salePrice, isCouple: isCouple = false }) {
    if (!(salePrice > 0)) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63f0f38d9f9fe7ac$export$36b8132fbfd1058f), {
        tone: "warn",
        heading: "Renting makes you a non-homeowner \u2014 all of the equity becomes assessable",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "Selling without buying turns the whole ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(salePrice)
                    }),
                    " into money Centrelink counts and deems to earn income. Non-homeowners do get a higher assets-test threshold \u2014 and Rent Assistance may be payable \u2014 but the two rarely make up for counting the lot."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-1.5",
                children: [
                    "Rent also becomes a lifelong cost, and there is no longer a home growing in the background for the estate. It suits people who want the flexibility and no maintenance; it usually reduces the pension more than buying somewhere cheaper does.",
                    isCouple ? ' Both of you are assessed as non-homeowners.' : ''
                ]
            })
        ]
    });
}


const $8c2d8ecb78ee1c16$var$num = (v)=>Number(v) || 0;
const $8c2d8ecb78ee1c16$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
const $8c2d8ecb78ee1c16$var$signed = (n)=>`${n >= 0 ? '+' : "\u2212"}${$8c2d8ecb78ee1c16$var$money(Math.abs(n))}`;
const $8c2d8ecb78ee1c16$var$cash = (n)=>n < 0 ? `short ${$8c2d8ecb78ee1c16$var$money(-n)}` : $8c2d8ecb78ee1c16$var$money(n);
const $8c2d8ecb78ee1c16$var$link = 'font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy';
const $8c2d8ecb78ee1c16$var$sec = 'mt-6 border-b border-slate-200 pb-1 text-[13px] font-bold text-brand-navy';
const $8c2d8ecb78ee1c16$var$card = 'rounded-2xl border border-slate-200 bg-white p-5 shadow-card';
const $8c2d8ecb78ee1c16$var$Choice = ({ value: value, options: options, onChange: onChange, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-wrap gap-2",
        role: "radiogroup",
        "data-testid": testId,
        children: options.map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                role: "radio",
                "aria-checked": value === o.id,
                onClick: ()=>onChange(o.id),
                "data-testid": testId ? `${testId}-${o.id}` : undefined,
                className: `rounded-lg border px-3 py-1.5 text-[13px] font-semibold ${value === o.id ? 'border-blue-600 bg-blue-50 text-brand-navy' : 'border-slate-300 bg-white text-slate-700 hover:border-blue-300'}`,
                children: [
                    value === o.id ? "\u2713 " : '',
                    o.label
                ]
            }, o.id))
    });
const $8c2d8ecb78ee1c16$export$409faa00494a55a = ({ how: how, good: good, watch: watch })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $8c2d8ecb78ee1c16$var$card,
        "data-testid": "dz-how-it-works",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[13px] font-bold text-brand-navy",
                children: "How it works"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-[14px] leading-relaxed text-slate-700",
                children: how
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-3 text-[14px] font-semibold text-slate-900",
                children: "Good for"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "mt-1 list-disc space-y-0.5 pl-5 text-[14px] text-slate-700",
                children: good.map((g)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: g
                    }, g))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-3 text-[14px] font-semibold text-slate-900",
                children: "Watch out for"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "mt-1 list-disc space-y-0.5 pl-5 text-[14px] text-slate-700",
                children: watch.map((g)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: g
                    }, g))
            })
        ]
    });
const $8c2d8ecb78ee1c16$var$DzBuildPlan = (p)=>{
    const { factFind: factFind, ledger: L } = p;
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const [dive, setDive] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const goals = factFind?.goals || {};
    const setGoal = (k, val)=>p.setFactFind?.((prev)=>({
                ...prev,
                goals: {
                    ...prev?.goals || {},
                    [k]: val
                }
            }));
    const isCouple = factFind?.adviceFor === 'couple';
    const clientName = factFind?.client?.firstName || (v.you ? 'You' : 'The client');
    const partnerName = factFind?.partner?.firstName || 'your partner';
    const clientAge = factFind?.client?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(String(factFind.client.dob)) : null;
    const partnerAge = isCouple && factFind?.partner?.dob ? (0, $5589d9476399db47$export$8ada184d5eef4694)(String(factFind.partner.dob)) : null;
    const ff = factFind;
    const dep = L.deployment || {};
    const setDep = (patch, words)=>p.onLedger({
            deployment: {
                ...dep,
                ...patch
            }
        }, words);
    // The sale and what it leaves — the module's one arithmetic.
    const { netProceeds: netProceeds, stampDuty: stampDuty, freedCapital: freedCapital, buyUpShortfall: buyUpShortfall } = (0, $6b146b31ad2b1e77$export$855cd09595261b3b)({
        salePrice: L.salePrice,
        sellingCosts: L.sellingCosts,
        newHomePrice: L.newHomePurchasePrice,
        stampDuty: L.stampDuty,
        sellAndRent: L.sellAndRent
    });
    const topUpFunded = Object.values(L.buyUpFunding || {}).reduce((t, x)=>t + $8c2d8ecb78ee1c16$var$num(x), 0);
    const sale = (0, $3ffb5e286ef10c73$export$16b92ab69d0ca0d9)(L);
    const placed = sale.placed;
    const stillToPlace = freedCapital - placed;
    const bankToday = (factFind?.assets?.bankAccounts || []).reduce((s, a)=>s + $8c2d8ecb78ee1c16$var$num(a.value), 0);
    const reserveFromSale = Math.max(0, p.reserve - bankToday);
    // What must be confirmed before choosing.
    const usesDownsizer = $8c2d8ecb78ee1c16$var$num(L.downsizerContribution) + $8c2d8ecb78ee1c16$var$num(L.partnerDownsizerContribution) > 0;
    const incomeOnly = (0, $80740ae64106afa1$export$bba70ab5d49cb5db)(dep);
    const tenYearsOk = !usesDownsizer || goals.dzOwned10Years === 'yes';
    const incomeOnlyOk = !incomeOnly || (0, $5eae79c7e46ed27e$export$9ad5f972205b4f88)(factFind, $8c2d8ecb78ee1c16$var$num(dep.annuity));
    const setIncomeOnly = (0, $5eae79c7e46ed27e$export$415ddf94c95c9134)(p.setFactFind);
    const rentMissing = L.sellAndRent && !($8c2d8ecb78ee1c16$var$num(L.rentPerWeek) > 0);
    const topUpShort = buyUpShortfall >= 1 && topUpFunded < buyUpShortfall - 1;
    const canChoose = L.salePrice > 0 && tenYearsOk && incomeOnlyOk && stillToPlace > -1 && !topUpShort && !rentMissing && !p.working;
    // While working, every figure reads "…" (never a mix of new and old) — the same as cashflow's panel.
    const eff = p.working ? {
        ...p.effect,
        cashflow: null,
        baseCashflow: null,
        pension: null,
        basePension: null,
        legacy: null,
        baseLegacy: null
    } : p.effect;
    // A guaranteed income: what the family receives if death comes early (the plan's own rows; no twin to compare).
    const giAmount = $8c2d8ecb78ee1c16$var$num(dep.annuity);
    const giOwner = (0, $80740ae64106afa1$export$d5bc675b676c44ae)(dep, isCouple);
    const giPerson = giOwner === 'partner' && isCouple ? partnerName : giOwner === 'joint' && isCouple ? `${clientName} and ${partnerName}` : clientName;
    const familyPanel = giAmount > 0 && dep.annuityType !== 'fixedTerm' && p.planRows && p.planRows.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
        factFind: factFind,
        personName: giPerson,
        amount: giAmount,
        kind: (0, $8665f80549f60a1b$export$3ab75b1250c8af22)({
            annuityType: dep.annuityType,
            annuityResidualPercent: dep.annuityResidualPercent
        }),
        rows: p.planRows,
        horizonYears: p.horizonYears,
        testId: "dz-build-family-panel"
    }) : null;
    const destRow = (label, value, onSet, words, opts = {})=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
            className: "border-b border-slate-100",
            "data-testid": opts.testId,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                    className: "py-2 pr-3 text-[14px] text-slate-700",
                    children: [
                        label,
                        opts.dive && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                " \xb7 ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setDive(opts.dive),
                                    className: `${$8c2d8ecb78ee1c16$var$link} text-[13px]`,
                                    children: "set it up \u203A"
                                })
                            ]
                        }),
                        opts.note
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                    className: "py-2 text-right",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        value: value,
                        onChange: (x)=>onSet(Math.max(0, Math.min(opts.max ?? Infinity, x ?? 0))),
                        className: "ml-auto w-36",
                        ariaLabel: words
                    })
                })
            ]
        });
    const effectPanel = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `${$8c2d8ecb78ee1c16$var$card} xl:sticky xl:top-8`,
        "data-testid": "dz-build-effect",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] font-bold text-brand-navy",
                children: [
                    "Effect on the plan ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-normal text-slate-500",
                        children: "\u2014 updates as you go"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                className: "mt-2 w-full text-[14px] tabular-nums",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "border-b border-slate-100",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "py-2 text-slate-600",
                                    children: "Left over each year"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-right",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            className: $8c2d8ecb78ee1c16$var$num(eff.cashflow) >= 0 ? 'text-emerald-700' : 'text-rose-700',
                                            children: eff.cashflow == null ? "\u2026" : $8c2d8ecb78ee1c16$var$cash(eff.cashflow)
                                        }),
                                        eff.cashflow != null && eff.baseCashflow != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: `text-[12.5px] ${eff.cashflow - eff.baseCashflow >= 0 ? 'text-emerald-700' : 'text-rose-700'}`,
                                                    children: [
                                                        $8c2d8ecb78ee1c16$var$signed(eff.cashflow - eff.baseCashflow),
                                                        " vs staying put \xb7 first year"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "border-b border-slate-100",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "py-2 text-slate-600",
                                    children: "Age Pension"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-right",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: eff.pension == null ? "\u2026" : $8c2d8ecb78ee1c16$var$money(eff.pension)
                                        }),
                                        eff.pension != null && eff.basePension != null && Math.abs(eff.pension - eff.basePension) >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: `text-[12.5px] ${eff.pension > eff.basePension ? 'text-emerald-700' : 'text-rose-700'}`,
                                                    children: [
                                                        $8c2d8ecb78ee1c16$var$signed(eff.pension - eff.basePension),
                                                        " vs staying put"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "border-b border-slate-100",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-slate-600",
                                    children: [
                                        "Left to the family, about ",
                                        p.horizonYears,
                                        " years"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-right",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            "data-testid": "dz-build-legacy",
                                            children: eff.legacy == null ? "\u2026" : $8c2d8ecb78ee1c16$var$money(eff.legacy)
                                        }),
                                        eff.legacy != null && eff.baseLegacy != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: `text-[12.5px] ${eff.legacy >= eff.baseLegacy ? 'text-emerald-700' : 'text-rose-700'}`,
                                                    children: [
                                                        $8c2d8ecb78ee1c16$var$signed(eff.legacy - eff.baseLegacy),
                                                        " vs staying put"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "border-b border-slate-100",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "py-2 text-slate-600",
                                    children: "Money freed up"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-right",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: $8c2d8ecb78ee1c16$var$money(freedCapital)
                                        }),
                                        buyUpShortfall >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "text-[12.5px] text-slate-500",
                                                    children: [
                                                        $8c2d8ecb78ee1c16$var$money(buyUpShortfall),
                                                        " more from savings"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "py-2 text-slate-600",
                                    children: "Stamp duty and selling costs"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-right",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: $8c2d8ecb78ee1c16$var$money(stampDuty + $8c2d8ecb78ee1c16$var$num(L.sellingCosts))
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-[12.5px] text-slate-500",
                                            children: "gone on the day; the home itself is free of capital gains tax"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            p.lastChange && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 border-t border-slate-200 pt-2 text-[13px] text-slate-700",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-slate-500",
                        children: "Last change"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: p.lastChange
                    })
                ]
            }),
            p.onYearByYear && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: p.onYearByYear,
                className: `mt-3 block text-[13px] ${$8c2d8ecb78ee1c16$var$link}`,
                "data-testid": "dz-build-year-by-year",
                children: "See the year-by-year figures for this plan"
            }),
            p.comparison,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 grid grid-cols-2 gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: p.onExplain,
                        className: "inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-[13px] font-semibold text-slate-800 hover:border-blue-300",
                        "data-testid": "dz-build-explain",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                size: 15
                            }),
                            " Explain this"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: p.onRisks,
                        className: "inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-[13px] font-semibold text-slate-800 hover:border-blue-300",
                        "data-testid": "dz-build-risks",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4666dd9ae485baaf$export$2e2bcd8739ae039), {
                                size: 15
                            }),
                            " What could go wrong"
                        ]
                    })
                ]
            }),
            usesDownsizer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 space-y-2 rounded-lg border border-slate-200 border-l-4 border-l-amber-400 bg-white px-3 py-2 text-[13px] text-slate-700",
                "data-testid": "dz-before-you-choose",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "text-slate-900",
                            children: "Before you choose:"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        className: "flex items-start gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "checkbox",
                                checked: goals.dzOwned10Years === 'yes',
                                onChange: (e)=>setGoal('dzOwned10Years', e.target.checked ? 'yes' : ''),
                                className: "mt-0.5",
                                "data-testid": "dz-tick-ten-years"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    "The downsizer contributions need ",
                                    v.them,
                                    " to have owned the home for 10 years or more. ",
                                    v.you ? 'We did.' : `${v.Names} did.`
                                ]
                            })
                        ]
                    })
                ]
            }),
            incomeOnly && setIncomeOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-3",
                "data-testid": "dz-before-you-choose-income-only",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$4538b371a206da0c), {
                    factFind: factFind,
                    amount: giAmount,
                    onChange: setIncomeOnly
                })
            }),
            familyPanel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-3",
                children: familyPanel
            }),
            stillToPlace < -1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-3 text-[13px] text-rose-700",
                "data-testid": "dz-build-over",
                children: [
                    $8c2d8ecb78ee1c16$var$money(-stillToPlace),
                    " more is placed than the sale frees: take some off one of the uses."
                ]
            }),
            topUpShort && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-3 text-[13px] text-rose-700",
                "data-testid": "dz-build-top-up-short",
                children: [
                    "The new home needs ",
                    $8c2d8ecb78ee1c16$var$money(buyUpShortfall - topUpFunded),
                    " more from savings: choose where it comes from."
                ]
            }),
            rentMissing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-3 text-[13px] text-rose-700",
                children: "Enter the weekly rent: without it renting looks free."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: canChoose ? p.onChoose : undefined,
                disabled: !canChoose,
                "aria-pressed": p.chosen,
                className: `mt-3 w-full rounded-lg px-4 py-2.5 text-[14px] font-semibold ${p.chosen ? 'border border-emerald-500 bg-white text-emerald-800' : canChoose ? 'bg-blue-600 text-white hover:bg-blue-700' : 'cursor-not-allowed bg-slate-200 text-slate-500'}`,
                "data-testid": "dz-build-choose",
                children: p.chosen ? "Chosen \u2713" : 'Choose this plan'
            })
        ]
    });
    const nav = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-wrap gap-2 text-[13px]",
        "data-testid": "dz-dive-nav",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: ()=>setDive(null),
                className: "rounded-lg border border-slate-300 bg-white px-3 py-1.5 font-semibold text-slate-700 hover:border-blue-300",
                children: "\u2039 The whole plan"
            }),
            [
                [
                    'super',
                    'Super'
                ],
                [
                    'annuity',
                    'Guaranteed income'
                ],
                [
                    'property',
                    'Investment property'
                ],
                [
                    'gift',
                    'Gift to family'
                ]
            ].map(([id, label])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: ()=>setDive(id),
                    className: `rounded-lg border px-3 py-1.5 font-semibold ${dive === id ? 'border-blue-600 bg-blue-50 text-brand-navy' : 'border-slate-300 bg-white text-slate-700 hover:border-blue-300'}`,
                    children: label
                }, id))
        ]
    });
    const header = (title, lead)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-[13px] text-slate-500",
                    children: [
                        "Downsizing \u203A ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: p.onBackToPlans,
                            className: "underline decoration-dotted underline-offset-2",
                            children: "Ways to use the money"
                        }),
                        " \u203A ",
                        dive ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>setDive(null),
                            className: "underline decoration-dotted underline-offset-2",
                            children: "Build a plan yourself"
                        }) : 'Build a plan yourself'
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    className: "mt-2 text-[28px] font-bold leading-tight tracking-tight text-brand-navy",
                    "data-testid": dive ? `dz-dive-${dive}` : 'dz-build-title',
                    children: title
                }),
                lead && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "mt-1 text-[15px] leading-relaxed text-slate-600",
                    children: lead
                })
            ]
        });
    const sidePanel = (what, how)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: $8c2d8ecb78ee1c16$var$card,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-[13px] font-bold text-brand-navy",
                            children: "What it does to the plan"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                            className: "mt-2 w-full text-[14px]",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                children: [
                                    what,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "py-2 text-slate-600",
                                                children: "Age Pension"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                className: "py-2 text-right",
                                                children: [
                                                    eff.pension == null ? "\u2026" : $8c2d8ecb78ee1c16$var$money(eff.pension),
                                                    " a year"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                how
            ]
        });
    // ---------- the set-ups ----------
    if (dive === 'super') {
        const people = [
            {
                who: 'client',
                name: clientName,
                age: clientAge,
                field: 'downsizerContribution',
                ncc: 'superContribution'
            },
            ...isCouple ? [
                {
                    who: 'partner',
                    name: partnerName,
                    age: partnerAge,
                    field: 'partnerDownsizerContribution',
                    ncc: 'partnerSuperContribution'
                }
            ] : []
        ];
        const room = (0, $996111778bb35e70$export$3156faa588d94c0c)(ff);
        const canPension = people.some((x)=>$8c2d8ecb78ee1c16$var$num(L[x.field]) > 0 && (0, $f1228be62b68f76b$export$d1b692f4d3924fcd)(ff, x.who));
        const minOf = (x)=>Math.round($8c2d8ecb78ee1c16$var$num(L[x.field]) * (0, $e0f54937e270d5ff$export$a7b4a1ff258d7449)(x.age));
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-5",
            children: [
                header('Super: the downsizer contribution'),
                nav,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid grid-cols-1 gap-5 xl:grid-cols-[1.35fr_1fr]",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: $8c2d8ecb78ee1c16$var$card,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                    className: "w-full text-[14px]",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                        children: people.map((x)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "py-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                children: [
                                                                    x.name,
                                                                    "'s super"
                                                                ]
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "text-slate-500",
                                                                children: [
                                                                    "downsizer contribution, up to ",
                                                                    $8c2d8ecb78ee1c16$var$money((0, $1abe73eeef086faf$export$42edd27decf8c272))
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2 text-right",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                            value: $8c2d8ecb78ee1c16$var$num(L[x.field]),
                                                            onChange: (n)=>p.onLedger({
                                                                    [x.field]: Math.max(0, Math.min((0, $1abe73eeef086faf$export$42edd27decf8c272), n ?? 0))
                                                                }, `${x.name}'s super ${$8c2d8ecb78ee1c16$var$money($8c2d8ecb78ee1c16$var$num(L[x.field]))} \u{2192} ${$8c2d8ecb78ee1c16$var$money(Math.min((0, $1abe73eeef086faf$export$42edd27decf8c272), n ?? 0))}`),
                                                            className: "ml-auto w-36",
                                                            ariaLabel: `${x.name}'s downsizer contribution`,
                                                            testId: `dz-downsizer-${x.who}`
                                                        })
                                                    })
                                                ]
                                            }, x.who))
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: $8c2d8ecb78ee1c16$var$sec,
                                    children: [
                                        "Can ",
                                        v.they,
                                        " use this strategy?"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mt-2 text-[14px] text-slate-700",
                                    children: [
                                        "To put money from selling ",
                                        v.their,
                                        " home into super this way, each person has to meet the rules. We check what we can from the file; please confirm the rest."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                    className: "mt-2 w-full text-[14px]",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2",
                                                        children: "55 or over"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2 text-right",
                                                        children: people.map((x)=>`${(x.age ?? 0) >= 55 ? "\u2713" : "\u2717"} ${x.name} ${x.age ?? '?'}`).join(" \xb7 ")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "py-2",
                                                        children: [
                                                            v.you ? 'You' : v.Names,
                                                            " owned the home for 10 years or more ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-slate-500",
                                                                children: "\xb7 please confirm"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2 text-right",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                            value: goals.dzOwned10Years || '',
                                                            onChange: (e)=>setGoal('dzOwned10Years', e.target.value),
                                                            className: "rounded-lg border border-amber-400 px-2 py-1",
                                                            "aria-label": "Owned the home for 10 years or more",
                                                            "data-testid": "dz-owned-ten-years",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "",
                                                                    children: "Not confirmed"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "yes",
                                                                    children: "Yes"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "no",
                                                                    children: "No"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2",
                                                        children: "Paid in within 90 days of the sale settling"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2 text-right text-slate-600",
                                                        children: "a step in the action plan"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2",
                                                        children: "Room under the transfer balance cap, to draw it as a pension"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2 text-right",
                                                        children: people.map((x)=>`${(0, $4f5a997f1c0139af$export$f55aec102ef92752)(ff, x.who) >= $8c2d8ecb78ee1c16$var$num(L[x.field]) ? "\u2713" : "\u2717"} ${x.name}`).join(" \xb7 ")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mt-3",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca8c3002399ce80c$export$826fdd034b051d4), {
                                        clientAmount: $8c2d8ecb78ee1c16$var$num(L.downsizerContribution),
                                        partnerAmount: $8c2d8ecb78ee1c16$var$num(L.partnerDownsizerContribution)
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mt-3",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b75d5c6eae88a43d$export$2e2bcd8739ae039), {
                                        factFind: factFind
                                    })
                                }),
                                goals.dzOwned10Years === 'no' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-2 text-[13px] text-rose-700",
                                    children: "Without 10 years of ownership a downsizer contribution isn't allowed; set these to $0."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mt-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-[13px] text-slate-700",
                                    "data-testid": "dz-tbc-explained",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "The transfer balance cap"
                                        }),
                                        " is the most anyone can move into a retirement pension over their lifetime: ",
                                        $8c2d8ecb78ee1c16$var$money((0, $1abe73eeef086faf$export$807e93be6ec93c1b)),
                                        " each. A downsizer contribution doesn't count towards the yearly contribution limits, but any amount drawn as a pension does count towards this cap; above what is left of it, the money stays in ordinary super."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: $8c2d8ecb78ee1c16$var$sec,
                                    children: "Turn it into a pension"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mt-2 text-[14px] text-slate-700",
                                    children: [
                                        "An ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "account-based pension"
                                        }),
                                        " turns super into an income. It pays at least a set share of the balance each year, its earnings are tax-free, and whatever is left on death goes to the estate or the person nominated. Left in ordinary super, the earnings are taxed at up to 15%."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "mt-2 flex items-start gap-2 text-[14px]",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            checked: !!L.commenceIncomeStream,
                                            disabled: !canPension && !L.commenceIncomeStream,
                                            onChange: (e)=>p.onLedger({
                                                    commenceIncomeStream: e.target.checked
                                                }, e.target.checked ? 'Started a pension from the downsizer money' : 'Left the downsizer money in super'),
                                            className: "mt-1",
                                            "data-testid": "dz-start-pension"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Start an account-based pension with it"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-slate-500",
                                                    children: "\u2014 the person must be old enough to start one"
                                                }),
                                                L.commenceIncomeStream && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "block text-[12.5px] text-slate-500",
                                                    children: [
                                                        "At least ",
                                                        people.filter((x)=>$8c2d8ecb78ee1c16$var$num(L[x.field]) > 0).map((x)=>`${$8c2d8ecb78ee1c16$var$money(minOf(x))} a year for ${x.name} (${Math.round((0, $e0f54937e270d5ff$export$a7b4a1ff258d7449)(x.age) * 100)}% at ${x.age})`).join(' and '),
                                                        "."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                room.total > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: $8c2d8ecb78ee1c16$var$sec,
                                            children: "More into super, after tax"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "mt-2 text-[14px] text-slate-700",
                                            children: [
                                                "Under 75 and with room under the limits, each person can also put money in as an ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "after-tax contribution"
                                                }),
                                                "."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                            className: "mt-2 w-full text-[14px]",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                children: people.filter((x)=>(x.who === 'client' ? room.client.cap : room.partner.cap) > 0).map((x)=>{
                                                    const cap = x.who === 'client' ? room.client.cap : room.partner.cap;
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "border-b border-slate-100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "py-2",
                                                                children: [
                                                                    x.name,
                                                                    ", up to ",
                                                                    $8c2d8ecb78ee1c16$var$money(cap)
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-2 text-right",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                                    value: $8c2d8ecb78ee1c16$var$num(dep[x.ncc]),
                                                                    onChange: (n)=>setDep({
                                                                            [x.ncc]: Math.max(0, Math.min(cap, n ?? 0))
                                                                        }, `${x.name}'s after-tax super \u{2192} ${$8c2d8ecb78ee1c16$var$money(Math.min(cap, n ?? 0))}`),
                                                                    className: "ml-auto w-36",
                                                                    ariaLabel: `${x.name}'s after-tax contribution`
                                                                })
                                                            })
                                                        ]
                                                    }, x.who);
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        sidePanel(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "border-b border-slate-100",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "py-2 text-slate-600",
                                    children: "Counted by Centrelink"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-right",
                                    children: [
                                        "in full once ",
                                        v.they,
                                        " reach Age Pension age, and deemed"
                                    ]
                                })
                            ]
                        }), /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c2d8ecb78ee1c16$export$409faa00494a55a, {
                            how: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "When a home owned for at least 10 years is sold, each person aged 55 or over can put up to ",
                                    $8c2d8ecb78ee1c16$var$money((0, $1abe73eeef086faf$export$42edd27decf8c272)),
                                    " of the sale into super, whatever their work or balance. That is a ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "downsizer contribution"
                                    }),
                                    ". It can be made once, within 90 days of settlement. Inside super the earnings are taxed at no more than 15%; drawn as a pension, nothing."
                                ]
                            }),
                            good: [
                                'Moving sale money somewhere its earnings are taxed less, or not at all',
                                'A steady income from the pension',
                                `${isCouple ? `${clientName} and ${partnerName} each` : clientName} up to ${$8c2d8ecb78ee1c16$var$money((0, $1abe73eeef086faf$export$42edd27decf8c272))}`
                            ],
                            watch: [
                                'It must be paid in within 90 days of settlement, once only',
                                'Centrelink counts it from Age Pension age, so it does not soften the downsizing trap',
                                'A pension must pay at least a minimum each year',
                                'The value rises and falls with markets'
                            ]
                        }))
                    ]
                })
            ]
        });
    }
    if (dive === 'annuity') {
        const amount = $8c2d8ecb78ee1c16$var$num(dep.annuity);
        const annuityType = dep.annuityType === 'fixedTerm' ? 'fixedTerm' : dep.annuityType === 'guaranteed' ? 'guaranteed' : 'lifetime';
        const investable = Math.max(0, freedCapital - reserveFromSale);
        const source = {
            id: 'freed-up-proceeds',
            type: 'proceeds',
            label: `Money the sale frees \u{2014} ${$8c2d8ecb78ee1c16$var$money(freedCapital)}`,
            ownership: giOwner,
            available: freedCapital
        };
        const details = {
            purchaseAmount: amount,
            annuityType: annuityType === 'guaranteed' ? 'lifetime' : annuityType,
            residualCapital: Math.min(1, Math.max(0, $8c2d8ecb78ee1c16$var$num(dep.annuityResidualPercent) / 100)),
            termYears: annuityType === 'fixedTerm' ? $8c2d8ecb78ee1c16$var$num(dep.annuityTermYears) || null : null,
            deferralYears: annuityType === 'lifetime' ? Math.round($8c2d8ecb78ee1c16$var$num(dep.annuityDeferralYears)) : 0,
            indexation: !!dep.annuityIndexation,
            reversionary: !!dep.annuityReversionary,
            owner: giOwner,
            incomeOverride: dep.annuityIncomeOverride != null && dep.annuityIncomeOverride !== '' ? $8c2d8ecb78ee1c16$var$num(dep.annuityIncomeOverride) : null,
            fundingSource: source
        };
        const setDetails = (updater)=>{
            const next = typeof updater === 'function' ? updater(details) : updater;
            setDep({
                annuity: next.purchaseAmount || 0,
                annuityType: next.annuityType === 'fixedTerm' ? 'fixedTerm' : annuityType === 'guaranteed' ? 'guaranteed' : 'lifetime',
                annuityResidualPercent: Math.round((Number(next.residualCapital) || 0) * 100),
                annuityTermYears: Number(next.termYears) || 0,
                annuityDeferralYears: Math.max(0, Math.round(Number(next.deferralYears) || 0)),
                annuityIndexation: !!next.indexation,
                annuityReversionary: !!next.reversionary,
                annuityOwner: next.owner || giOwner,
                annuityIncomeOverride: next.incomeOverride ?? undefined
            }, 'Changed the guaranteed income');
        };
        let summary = null;
        try {
            const cont = !!dep.annuityReversionary || giOwner === 'joint';
            const effPartnerAge = isCouple && cont && partnerAge != null ? partnerAge : null;
            const rec = amount > 0 ? (0, $f7f7b62814c3b615$export$fb67395f10ad20c9)(ff, {
                annuityType: details.annuityType,
                purchaseAmount: amount,
                age: clientAge ?? 65,
                partnerAge: effPartnerAge,
                owner: giOwner,
                residualCapital: details.residualCapital,
                termYears: details.termYears,
                deferralYears: details.deferralYears,
                indexation: details.indexation,
                reversionary: !!dep.annuityReversionary && !!effPartnerAge,
                incomeOverride: details.incomeOverride
            }) : null;
            summary = rec && !rec.warnings ? (0, $f7f7b62814c3b615$export$fc6c67b5fdf45998)(rec) : null;
        } catch  {
            summary = null;
        }
        const income = $8c2d8ecb78ee1c16$var$num(summary?.annualPayment);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-5",
            children: [
                header('Guaranteed income for life'),
                nav,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid grid-cols-1 gap-5 xl:grid-cols-[1.35fr_1fr]",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: $8c2d8ecb78ee1c16$var$card,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-[13px] font-semibold text-slate-600",
                                    children: "How much goes in"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                    value: amount,
                                    onChange: (n)=>setDep({
                                            annuity: Math.max(0, n ?? 0),
                                            ...(0, $80740ae64106afa1$export$24ea1903eb6c4b62)(dep, 'annuity', n)
                                        }, `Guaranteed income ${$8c2d8ecb78ee1c16$var$money(amount)} \u{2192} ${$8c2d8ecb78ee1c16$var$money(Math.max(0, n ?? 0))}`),
                                    className: "mt-1 w-44",
                                    ariaLabel: "How much goes into the guaranteed income",
                                    testId: "dz-annuity-amount"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mt-1 text-[12.5px] text-slate-500",
                                    children: [
                                        "From the money the sale frees. We suggest no more than ",
                                        $8c2d8ecb78ee1c16$var$money((0, $ff5de4128b46b139$export$19a5715b59108050)((0, $ff5de4128b46b139$export$e46e91ebc7373b0a)(factFind, null), investable)),
                                        " of the ",
                                        $8c2d8ecb78ee1c16$var$money(investable),
                                        " that could be invested, so most of ",
                                        v.their,
                                        " money stays within reach."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $307ed5693fe6d99c$export$c57570017839ab6d), {
                                    factFind: factFind,
                                    amount: amount,
                                    investable: investable,
                                    testId: "dz-annuity-ceiling-caution"
                                }),
                                amount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mt-4",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a72ca5744dce23c$export$2e2bcd8739ae039), {
                                        factFind: factFind,
                                        annuityDetails: details,
                                        setAnnuityDetails: setDetails,
                                        annuitySummary: summary,
                                        annuityWarnings: [],
                                        fundingSources: [
                                            source
                                        ],
                                        formatCurrency: (x)=>$8c2d8ecb78ee1c16$var$money($8c2d8ecb78ee1c16$var$num(x)),
                                        clientAge: clientAge,
                                        partnerAge: partnerAge,
                                        hideAmount: true,
                                        onIncomeOnlyUnderstoodChange: setIncomeOnly
                                    })
                                }),
                                incomeOnly && setIncomeOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mt-3",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$61c5566b790f51c4), {
                                        factFind: factFind,
                                        amount: amount,
                                        onChange: setIncomeOnly,
                                        testId: "dz-annuity-income-only-tick"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mt-3 text-[12.5px] text-slate-500",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "These incomes are estimates"
                                        }),
                                        " from published rates. For exact figures, ask an annuity provider for a quote and enter it above."
                                    ]
                                })
                            ]
                        }),
                        sidePanel(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    className: "border-b border-slate-100",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-2 text-slate-600",
                                            children: "Guaranteed income"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                            className: "py-2 text-right",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: $8c2d8ecb78ee1c16$var$money(income)
                                                }),
                                                " a year"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    className: "border-b border-slate-100",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-2 text-slate-600",
                                            children: "Counted as an asset"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                            className: "py-2 text-right",
                                            children: [
                                                $8c2d8ecb78ee1c16$var$money(amount * 0.6),
                                                " ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-slate-500",
                                                    children: "60% for the first five years, or until 85 if later; 30% after"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }), /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c2d8ecb78ee1c16$export$409faa00494a55a, {
                            how: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "A lump sum is handed to an insurer, who pays a set income for as long as ",
                                    v.they,
                                    " live. This is called an ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "annuity"
                                    }),
                                    ". Centrelink counts only part of it, which can lift the Age Pension. What comes back if the money is needed, or on death, depends on the type chosen: a new one starts as \u201Cmoney back\u201D."
                                ]
                            }),
                            good: [
                                'An income that doesn\'t depend on markets, for life',
                                'Softening the downsizing trap: only part of it is counted'
                            ],
                            watch: [
                                'Prices rising faster than the payments, unless they rise with prices',
                                'Money that is hard to get back if plans change',
                                'A provider\'s quote can differ from our estimate'
                            ]
                        }))
                    ]
                })
            ]
        });
    }
    if (dive === 'property') {
        const price = $8c2d8ecb78ee1c16$var$num(dep.investmentProperty);
        const sugg = (0, $6ee1c1106c00a64d$export$ad80a9624457bb5e)(price);
        const weekly = dep.ipWeeklyRent != null ? $8c2d8ecb78ee1c16$var$num(dep.ipWeeklyRent) : Math.round(sugg.grossRent / 52);
        const vacancy = dep.ipVacancyWeeks != null ? $8c2d8ecb78ee1c16$var$num(dep.ipVacancyWeeks) : (0, $6ee1c1106c00a64d$export$faaf7ad57b31d035);
        const other = $8c2d8ecb78ee1c16$var$num(dep.ipRates) + $8c2d8ecb78ee1c16$var$num(dep.ipInsurance) + $8c2d8ecb78ee1c16$var$num(dep.ipLandTax) + $8c2d8ecb78ee1c16$var$num(dep.ipStrata);
        const f = (0, $6ee1c1106c00a64d$export$ad80a9624457bb5e)(price, {
            weeklyRent: weekly,
            vacancyWeeks: vacancy,
            upkeep: dep.ipUpkeep != null ? $8c2d8ecb78ee1c16$var$num(dep.ipUpkeep) : null,
            otherCosts: other
        });
        const agent = dep.ipAgentFee != null ? $8c2d8ecb78ee1c16$var$num(dep.ipAgentFee) : f.agentFee;
        const ipState = String(dep.ipState ?? L.newHomeState ?? '');
        // Every change writes the rent and costs the projection reads.
        const write = (patch, words)=>{
            const next = {
                ...dep,
                ...patch
            };
            const pr = $8c2d8ecb78ee1c16$var$num(next.investmentProperty);
            const s2 = (0, $6ee1c1106c00a64d$export$ad80a9624457bb5e)(pr);
            const wk = next.ipWeeklyRent != null ? $8c2d8ecb78ee1c16$var$num(next.ipWeeklyRent) : Math.round(s2.grossRent / 52);
            const fig = (0, $6ee1c1106c00a64d$export$ad80a9624457bb5e)(pr, {
                weeklyRent: wk,
                vacancyWeeks: next.ipVacancyWeeks != null ? $8c2d8ecb78ee1c16$var$num(next.ipVacancyWeeks) : (0, $6ee1c1106c00a64d$export$faaf7ad57b31d035),
                upkeep: next.ipUpkeep != null ? $8c2d8ecb78ee1c16$var$num(next.ipUpkeep) : null,
                otherCosts: $8c2d8ecb78ee1c16$var$num(next.ipRates) + $8c2d8ecb78ee1c16$var$num(next.ipInsurance) + $8c2d8ecb78ee1c16$var$num(next.ipLandTax) + $8c2d8ecb78ee1c16$var$num(next.ipStrata)
            });
            const ag = next.ipAgentFee != null ? $8c2d8ecb78ee1c16$var$num(next.ipAgentFee) : fig.agentFee;
            p.onLedger({
                deployment: {
                    ...next,
                    ipRent: fig.rent,
                    ipExpenses: ag + fig.upkeep + fig.otherCosts
                }
            }, words);
        };
        const cost = (label, field, value, suggested, enter = false)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                className: "border-b border-slate-100",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                        className: "py-2 text-[14px] text-slate-700",
                        children: label
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                        className: "py-2 text-right",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                value: dep[field] != null ? $8c2d8ecb78ee1c16$var$num(dep[field]) : enter ? '' : value,
                                onChange: (n)=>write({
                                        [field]: n == null ? undefined : Math.max(0, n)
                                    }, `${typeof label === 'string' ? label : 'A cost'} \u{2192} ${$8c2d8ecb78ee1c16$var$money(n ?? 0)}`),
                                placeholder: enter ? 'enter' : undefined,
                                className: `ml-auto w-32 ${enter && dep[field] == null ? 'rounded-lg ring-1 ring-amber-400' : ''}`,
                                ariaLabel: field
                            }),
                            suggested && dep[field] == null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ml-1 text-[11px] text-slate-500",
                                children: "suggested"
                            })
                        ]
                    })
                ]
            });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-5",
            children: [
                header('An investment property, bought outright', 'Every figure can be changed. Ours are suggestions until you do.'),
                nav,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid grid-cols-1 gap-5 xl:grid-cols-[1.35fr_1fr]",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: $8c2d8ecb78ee1c16$var$card,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-[13px] font-semibold text-slate-600",
                                    children: "Price"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                    value: price,
                                    onChange: (n)=>write({
                                            investmentProperty: Math.max(0, n ?? 0),
                                            ipStampDuty: $8c2d8ecb78ee1c16$export$815c71fe24b27d23(ipState, Math.max(0, n ?? 0))
                                        }, `Investment property ${$8c2d8ecb78ee1c16$var$money(price)} \u{2192} ${$8c2d8ecb78ee1c16$var$money(Math.max(0, n ?? 0))}`),
                                    className: "mt-1 w-44",
                                    ariaLabel: "Price of the investment property",
                                    testId: "dz-ip-price"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-1 text-[12.5px] text-slate-500",
                                    children: "Paid from the money the sale frees, with its stamp duty."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mt-3",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $89d49377c5c902f9$export$2e2bcd8739ae039), {
                                        subject: "the investment property",
                                        use: "investment",
                                        state: ipState,
                                        onStateChange: (st)=>write({
                                                ipState: st,
                                                ...st ? {} : {
                                                    ipStampDuty: 0
                                                }
                                            }, `Stamp duty state \u{2192} ${st || 'none'}`),
                                        newHomePrice: price,
                                        duty: $8c2d8ecb78ee1c16$var$num(dep.ipStampDuty),
                                        onDutyChange: (d)=>write({
                                                ipStampDuty: d
                                            }, `Investment property duty \u{2192} ${$8c2d8ecb78ee1c16$var$money(d)}`),
                                        fieldClassName: "max-w-xs"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: $8c2d8ecb78ee1c16$var$sec,
                                    children: "The rent"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-2 flex flex-wrap items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                            value: weekly,
                                            onChange: (n)=>write({
                                                    ipWeeklyRent: n == null ? undefined : Math.max(0, n)
                                                }, `Rent \u{2192} ${$8c2d8ecb78ee1c16$var$money(n ?? 0)} a week`),
                                            className: "w-32",
                                            ariaLabel: "Rent a week",
                                            testId: "dz-ip-rent"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "text-[13px] text-slate-500",
                                            children: [
                                                "a week (",
                                                $8c2d8ecb78ee1c16$var$money(weekly * 52),
                                                " a year)",
                                                dep.ipWeeklyRent == null ? " \xb7 suggested at 3.5% of the price; replace it with an agent's appraisal" : ''
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-2 flex flex-wrap items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "number",
                                            min: 0,
                                            max: 52,
                                            value: vacancy,
                                            onChange: (e)=>write({
                                                    ipVacancyWeeks: Math.max(0, Math.min(52, parseFloat(e.target.value) || 0))
                                                }, `Weeks empty \u{2192} ${e.target.value}`),
                                            className: "w-20 rounded-lg border border-slate-300 px-2 py-1.5",
                                            "aria-label": "Weeks a year empty",
                                            "data-testid": "dz-ip-vacancy"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "text-[13px] text-slate-500",
                                            children: [
                                                "weeks a year empty",
                                                dep.ipVacancyWeeks == null ? ', suggested' : '',
                                                " \u2014 ",
                                                $8c2d8ecb78ee1c16$var$money(weekly * vacancy),
                                                " of rent lost. Between tenants the rent stops; the costs don't."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: $8c2d8ecb78ee1c16$var$sec,
                                    children: "The costs, each year"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                    className: "mt-2 w-full",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        children: [
                                            cost(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    "Agent's management fee ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-slate-500",
                                                        children: [
                                                            "\xb7 ",
                                                            (0, $6ee1c1106c00a64d$export$a7e68df0b44e69a1),
                                                            "% of the rent"
                                                        ]
                                                    })
                                                ]
                                            }), 'ipAgentFee', agent, true),
                                            cost(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    "Repairs and upkeep ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-slate-500",
                                                        children: [
                                                            "\xb7 ",
                                                            (0, $6ee1c1106c00a64d$export$aa7b942bbfbd31d3),
                                                            "% of the value"
                                                        ]
                                                    })
                                                ]
                                            }), 'ipUpkeep', sugg.upkeep, true),
                                            cost(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    "Council and water rates ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-slate-500",
                                                        children: "\xb7 from the council notice"
                                                    })
                                                ]
                                            }), 'ipRates', 0, false, true),
                                            cost('Landlord insurance', 'ipInsurance', 0, false, true),
                                            cost(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Land tax"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-slate-500",
                                                        children: "\xb7 from the state revenue office"
                                                    })
                                                ]
                                            }), 'ipLandTax', 0, false, true),
                                            cost(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    "Strata levies ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-slate-500",
                                                        children: "\xb7 if it is a unit"
                                                    })
                                                ]
                                            }), 'ipStrata', 0, false)
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: $8c2d8ecb78ee1c16$var$sec,
                                    children: "Growth"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mt-2 text-[14px] text-slate-700",
                                    children: [
                                        "Value growth ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                            children: [
                                                (0, $0f2c0a6799fe36da$export$b037eefb915b86ec).propertyGrowthPct,
                                                "% a year"
                                            ]
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-slate-500",
                                            children: "\u2014 our assumption. Capital gains tax on the rise is taken off what is left to the family, as if it were sold."
                                        })
                                    ]
                                })
                            ]
                        }),
                        sidePanel(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    className: "border-b border-slate-100",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-2 text-slate-600",
                                            children: "Takes from the money freed"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                            className: "py-2 text-right",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: $8c2d8ecb78ee1c16$var$money(price + $8c2d8ecb78ee1c16$var$num(dep.ipStampDuty))
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-slate-500",
                                                    children: "price and duty"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    className: "border-b border-slate-100",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-2 text-slate-600",
                                            children: "Rent after costs and empty weeks"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                            className: "py-2 text-right",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    "data-testid": "dz-ip-net-rent",
                                                    children: $8c2d8ecb78ee1c16$var$money(f.rent - (agent + f.upkeep + f.otherCosts))
                                                }),
                                                " a year"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }), /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c2d8ecb78ee1c16$export$409faa00494a55a, {
                            how: "A property is bought and rented out. The rent, less the costs, is income, and the property's value can grow. Centrelink counts the property in full as an asset and the rent after costs as income. Stamp duty is paid to buy it, at the rate for an investment, and capital gains tax on any rise in value when it is sold.",
                            good: [
                                'Rental income and possible growth in value',
                                'Spreading money across more than shares and cash'
                            ],
                            watch: [
                                'Weeks without a tenant, while the costs go on',
                                'Repairs, rates, insurance and land tax',
                                'A fall in value',
                                'Money that takes months to get out, and costs to sell'
                            ]
                        }))
                    ]
                })
            ]
        });
    }
    if (dive === 'gift') {
        const amount = $8c2d8ecb78ee1c16$var$num(L.giftingAmount);
        const free = Math.min(amount, (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0));
        const history = factFind.giftsHistory;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-5",
            children: [
                header('A gift to family'),
                nav,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid grid-cols-1 gap-5 xl:grid-cols-[1.35fr_1fr]",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: $8c2d8ecb78ee1c16$var$card,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-[13px] font-semibold text-slate-600",
                                    children: "How much"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                    value: amount,
                                    onChange: (n)=>p.onLedger({
                                            giftingAmount: Math.max(0, n ?? 0)
                                        }, `Gift ${$8c2d8ecb78ee1c16$var$money(amount)} \u{2192} ${$8c2d8ecb78ee1c16$var$money(Math.max(0, n ?? 0))}`),
                                    className: "mt-1 w-44",
                                    ariaLabel: "How much to give",
                                    testId: "dz-gift-amount"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-1 text-[12.5px] text-slate-500",
                                    children: "From the money the sale frees."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-3 text-[13px] font-semibold text-slate-600",
                                    children: "Gifts already made"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-[14px] text-slate-700",
                                    children: history?.hasGifted ? 'Recorded on the profile; they count towards the same limits.' : history?.confirmedNone ? 'From the profile: none in the last five years.' : 'Not answered on the profile yet.'
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: $8c2d8ecb78ee1c16$var$sec,
                                    children: "How Centrelink counts it"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                    className: "mt-2 w-full text-[14px]",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2 text-slate-600",
                                                        children: "Leaves the means tests straight away"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "py-2 text-right",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: $8c2d8ecb78ee1c16$var$money(free)
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-slate-500",
                                                                children: "this year's free amount"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "py-2 text-slate-600",
                                                        children: [
                                                            "Still counted as ",
                                                            v.you ? 'yours' : 'theirs',
                                                            ", for five years"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-2 text-right",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: $8c2d8ecb78ee1c16$var$money(amount - free)
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mt-2 text-[12.5px] text-slate-500",
                                    children: [
                                        "Free amounts: ",
                                        $8c2d8ecb78ee1c16$var$money((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0)),
                                        " a financial year, and no more than ",
                                        $8c2d8ecb78ee1c16$var$money((0, $1abe73eeef086faf$export$9cd36ea38af5a5f3)),
                                        " over any five."
                                    ]
                                })
                            ]
                        }),
                        sidePanel(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "border-b border-slate-100",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "py-2 text-slate-600",
                                    children: "Left to the family"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-right",
                                    children: [
                                        "falls by about ",
                                        $8c2d8ecb78ee1c16$var$money(amount),
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-slate-500",
                                            children: "\u2014 given now instead"
                                        })
                                    ]
                                })
                            ]
                        }), /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c2d8ecb78ee1c16$export$409faa00494a55a, {
                            how: `Money is given to family now, rather than left in the estate. Centrelink stops counting up to ${$8c2d8ecb78ee1c16$var$money((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))} given away in a financial year, and no more than ${$8c2d8ecb78ee1c16$var$money((0, $1abe73eeef086faf$export$9cd36ea38af5a5f3))} over five years. Anything above that is still counted as the giver's for five years.`,
                            good: [
                                'Helping family now, when it matters to them',
                                'Within the limits, lowering what Centrelink counts'
                            ],
                            watch: [
                                'A gift cannot be taken back',
                                'Above the limits it is still counted for five years',
                                'Less left for their own costs later'
                            ]
                        }))
                    ]
                })
            ]
        });
    }
    // ---------- the whole plan ----------
    const profile = (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[(0, $0f2c0a6799fe36da$export$580cfd0c6323bf7e)(factFind)]?.label || 'Conservative';
    const room = (0, $996111778bb35e70$export$3156faa588d94c0c)(ff);
    const bondMax = (0, $1abe73eeef086faf$export$aca3edb7cd7a3f17) * (isCouple ? 2 : 1);
    const ipDuty = $8c2d8ecb78ee1c16$var$num(dep.ipStampDuty);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        "data-testid": "dz-build",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-x-6 gap-y-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: p.onBackToPlans,
                        className: "inline-flex items-center gap-1.5 text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                        "data-testid": "dz-back-to-plans",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                size: 16
                            }),
                            " Back to the plans we tested"
                        ]
                    }),
                    p.onClear && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: p.onClear,
                        className: "text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                        "data-testid": "dz-clear-start-again",
                        children: "Clear and start again"
                    })
                ]
            }),
            header(p.startedFrom ? 'Customise this plan' : 'Build a plan yourself', /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "One picture of ",
                    v.their,
                    " money: where it comes from, and where every dollar goes \u2014 the new home first, then the emergency money, then what's left put to work.",
                    p.startedFrom ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " Customising ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    "\u201C",
                                    p.startedFrom,
                                    "\u201D"
                                ]
                            }),
                            "; change anything and the figures follow."
                        ]
                    }) : null
                ]
            })),
            p.startOptions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-2 text-[13px]",
                "data-testid": "dz-start-from",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-slate-500",
                        children: "Start from:"
                    }),
                    p.startOptions.map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            onClick: ()=>p.onStartFrom(o.id),
                            className: `rounded-lg border px-3 py-1.5 font-semibold ${p.startedFrom === o.label ? 'border-blue-600 bg-blue-50 text-brand-navy' : 'border-slate-300 bg-white text-slate-700 hover:border-blue-300'}`,
                            children: [
                                p.startedFrom === o.label ? "\u2713 " : '',
                                o.label
                            ]
                        }, o.id))
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 items-start gap-5 xl:grid-cols-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `${$8c2d8ecb78ee1c16$var$card} xl:col-span-2`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[13px] font-bold text-brand-navy",
                                children: "1 \xb7 Where the money comes from"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                className: "mt-2 w-full text-[14px] tabular-nums",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "border-b border-slate-100",
                                            "data-testid": "dz-source-sale",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "py-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "The family home, sold"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-[12.5px] text-slate-500",
                                                            children: [
                                                                "No tax: it is ",
                                                                v.their,
                                                                " home. Once sold, money that doesn't go into a home is counted for the Age Pension."
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "py-2 text-right",
                                                    children: [
                                                        $8c2d8ecb78ee1c16$var$money(L.salePrice),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-[12.5px] text-rose-700",
                                                            children: [
                                                                "\u2212",
                                                                $8c2d8ecb78ee1c16$var$money(L.sellingCosts),
                                                                " selling costs"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "py-2 text-right font-bold",
                                                    children: $8c2d8ecb78ee1c16$var$money(netProceeds)
                                                })
                                            ]
                                        }),
                                        buyUpShortfall >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                className: "py-2",
                                                colSpan: 3,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Savings, to top up the new home"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-slate-500",
                                                        children: [
                                                            "\u2014 ",
                                                            $8c2d8ecb78ee1c16$var$money(buyUpShortfall),
                                                            " needed; choose where it comes from"
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            buyUpShortfall >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc43d1ee81f3ee79$export$2e2bcd8739ae039), {
                                        factFind: factFind,
                                        target: buyUpShortfall,
                                        funding: L.buyUpFunding,
                                        onChange: (m)=>p.onLedger({
                                                buyUpFunding: m
                                            }, 'Changed where the top-up comes from'),
                                        cgtOverrides: L.buyUpCgtOverrides,
                                        onCgtOverridesChange: (o)=>p.onLedger({
                                                buyUpCgtOverrides: o
                                            }),
                                        targetLabel: "From savings",
                                        help: "The new home and its stamp duty cost more than the sale leaves. A home isn't counted, so moving counted savings into it can lift the Age Pension; the trade-off is the income those savings were earning."
                                    }),
                                    !topUpShort && Object.keys(L.buyUpFunding || {}).some((k)=>k.startsWith('shares-')) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mt-2 text-[12.5px] text-slate-600",
                                        "data-testid": "dz-build-cgt-note",
                                        children: "Selling shares can mean capital gains tax. Any tax is paid from the bank account, and the figures on the right already include it."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-3 text-[14px] text-slate-700",
                                "data-testid": "dz-freed-line",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: "text-slate-900",
                                        children: [
                                            "Money freed up: ",
                                            $8c2d8ecb78ee1c16$var$money(freedCapital)
                                        ]
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-slate-500",
                                        children: L.sellAndRent ? "\u2014 renting: the whole sale, after costs" : `\u{2014} after the new home${stampDuty > 0 ? ` and ${$8c2d8ecb78ee1c16$var$money(stampDuty)} of stamp duty` : ''}`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca8c3002399ce80c$export$f6ec7687502bb548), {
                                pensionBefore: $8c2d8ecb78ee1c16$var$num(eff.basePension),
                                pensionAfter: $8c2d8ecb78ee1c16$var$num(eff.pension ?? eff.basePension),
                                freedCapital: freedCapital,
                                alreadySoftened: $8c2d8ecb78ee1c16$var$num(L.giftingAmount) > 0 || $8c2d8ecb78ee1c16$var$num(L.funeralBondPurchase) > 0
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca8c3002399ce80c$export$c2e5ea36163c0651), {
                                downsizeDate: p.downsizeDate || '',
                                freedCapital: freedCapital
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-5 text-[13px] font-bold text-brand-navy",
                                children: "2 \xb7 Where it goes, in this order"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                className: "mt-2 w-full",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                            className: "border-b border-slate-100",
                                            "data-testid": "dz-dest-home",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                className: "py-2 pr-3 text-[14px] text-slate-700",
                                                colSpan: 2,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex flex-wrap items-center gap-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "The new home"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c2d8ecb78ee1c16$var$Choice, {
                                                                value: L.sellAndRent ? 'rent' : 'buy',
                                                                onChange: (id)=>p.onLedger(id === 'rent' ? {
                                                                        sellAndRent: true
                                                                    } : {
                                                                        sellAndRent: false,
                                                                        stampDuty: (0, $6b146b31ad2b1e77$export$a8a5bac4bde49384)(L.newHomeState, L.newHomePurchasePrice)
                                                                    }, id === 'rent' ? 'Rent instead of buying' : 'Buy another home'),
                                                                testId: "dz-build-housing",
                                                                options: [
                                                                    {
                                                                        id: 'buy',
                                                                        label: 'Buy'
                                                                    },
                                                                    {
                                                                        id: 'rent',
                                                                        label: 'Rent instead'
                                                                    }
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    L.sellAndRent ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "mt-2 flex flex-wrap items-center gap-2 text-[13px] text-slate-600",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                                        value: L.rentPerWeek || '',
                                                                        onChange: (n)=>p.onLedger({
                                                                                rentPerWeek: Math.max(0, n ?? 0)
                                                                            }, `Rent \u{2192} ${$8c2d8ecb78ee1c16$var$money(n ?? 0)} a week`),
                                                                        className: "w-32",
                                                                        ariaLabel: "Rent a week",
                                                                        testId: "dz-build-rent"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        children: "a week \u2014 a cost for life, rising with prices; Rent Assistance is assessed on it. With no home, the whole sale is counted."
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "mt-2",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca8c3002399ce80c$export$7d6b9ea02ec846aa), {
                                                                    salePrice: L.salePrice,
                                                                    isCouple: isCouple
                                                                })
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mt-2 grid grid-cols-1 gap-3 sm:grid-cols-[auto_1fr] sm:items-end",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        className: "text-[12.5px] font-semibold text-slate-600",
                                                                        children: "Price"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                                        value: L.newHomePurchasePrice || '',
                                                                        onChange: (n)=>p.onLedger({
                                                                                newHomePurchasePrice: Math.max(0, n ?? 0)
                                                                            }, `New home ${$8c2d8ecb78ee1c16$var$money(L.newHomePurchasePrice)} \u{2192} ${$8c2d8ecb78ee1c16$var$money(Math.max(0, n ?? 0))}`),
                                                                        className: "mt-1 w-40",
                                                                        ariaLabel: "Price of the new home",
                                                                        testId: "dz-build-price"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $89d49377c5c902f9$export$2e2bcd8739ae039), {
                                                                state: L.newHomeState,
                                                                onStateChange: (st)=>p.onLedger({
                                                                        newHomeState: st
                                                                    }, `Stamp duty state \u{2192} ${st || 'none'}`),
                                                                newHomePrice: L.newHomePurchasePrice,
                                                                duty: L.stampDuty,
                                                                onDutyChange: (d)=>p.onLedger({
                                                                        stampDuty: d
                                                                    }),
                                                                fieldClassName: "max-w-xs"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "border-b border-slate-100",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "py-2 text-[14px]",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Emergency money"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-slate-500",
                                                            children: [
                                                                "\u2014 kept in the bank",
                                                                reserveFromSale > 0 ? `, ${$8c2d8ecb78ee1c16$var$money(reserveFromSale)} of it from the sale` : ', from what is already there'
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "py-2 text-right text-slate-500 tabular-nums",
                                                    children: [
                                                        $8c2d8ecb78ee1c16$var$money(p.reserve),
                                                        " held"
                                                    ]
                                                })
                                            ]
                                        }),
                                        destRow(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                clientName,
                                                "'s super, downsizer contribution ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "text-slate-500",
                                                    children: [
                                                        "up to ",
                                                        $8c2d8ecb78ee1c16$var$money((0, $1abe73eeef086faf$export$42edd27decf8c272))
                                                    ]
                                                })
                                            ]
                                        }), $8c2d8ecb78ee1c16$var$num(L.downsizerContribution), (n)=>p.onLedger({
                                                downsizerContribution: n
                                            }, `${clientName}'s super \u{2192} ${$8c2d8ecb78ee1c16$var$money(n)}`), `${clientName}'s super`, {
                                            max: (0, $1abe73eeef086faf$export$42edd27decf8c272),
                                            dive: 'super',
                                            testId: 'dz-dest-super-client',
                                            note: $8c2d8ecb78ee1c16$var$num(L.downsizerContribution) > 0 && goals.dzOwned10Years !== 'yes' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "text-[12.5px] font-semibold text-amber-700",
                                                children: [
                                                    " \xb7 confirm ",
                                                    v.they,
                                                    " owned the home 10 years"
                                                ]
                                            }) : null
                                        }),
                                        isCouple && destRow(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                partnerName,
                                                "'s super, downsizer contribution ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "text-slate-500",
                                                    children: [
                                                        "up to ",
                                                        $8c2d8ecb78ee1c16$var$money((0, $1abe73eeef086faf$export$42edd27decf8c272))
                                                    ]
                                                })
                                            ]
                                        }), $8c2d8ecb78ee1c16$var$num(L.partnerDownsizerContribution), (n)=>p.onLedger({
                                                partnerDownsizerContribution: n
                                            }, `${partnerName}'s super \u{2192} ${$8c2d8ecb78ee1c16$var$money(n)}`), `${partnerName}'s super`, {
                                            max: (0, $1abe73eeef086faf$export$42edd27decf8c272),
                                            dive: 'super',
                                            testId: 'dz-dest-super-partner'
                                        }),
                                        room.total > 0 && $8c2d8ecb78ee1c16$var$num(dep.superContribution) + $8c2d8ecb78ee1c16$var$num(dep.partnerSuperContribution) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "border-b border-slate-100",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "py-2 text-[14px] text-slate-700",
                                                    children: [
                                                        "More into super, after tax \xb7 ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>setDive('super'),
                                                            className: `${$8c2d8ecb78ee1c16$var$link} text-[13px]`,
                                                            children: "change it \u203A"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "py-2 text-right tabular-nums",
                                                    children: $8c2d8ecb78ee1c16$var$money($8c2d8ecb78ee1c16$var$num(dep.superContribution) + $8c2d8ecb78ee1c16$var$num(dep.partnerSuperContribution))
                                                })
                                            ]
                                        }),
                                        destRow('Guaranteed income for life', $8c2d8ecb78ee1c16$var$num(dep.annuity), (n)=>setDep({
                                                annuity: n,
                                                ...(0, $80740ae64106afa1$export$24ea1903eb6c4b62)(dep, 'annuity', n)
                                            }, `Guaranteed income \u{2192} ${$8c2d8ecb78ee1c16$var$money(n)}`), 'Guaranteed income', {
                                            dive: 'annuity',
                                            testId: 'dz-dest-annuity'
                                        }),
                                        destRow(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                "Investment property, bought outright",
                                                ipDuty > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "text-slate-500",
                                                    children: [
                                                        " \xb7 plus ",
                                                        $8c2d8ecb78ee1c16$var$money(ipDuty),
                                                        " stamp duty"
                                                    ]
                                                }) : null
                                            ]
                                        }), $8c2d8ecb78ee1c16$var$num(dep.investmentProperty), (n)=>{
                                            const st = String(dep.ipState ?? L.newHomeState ?? '');
                                            const f = (0, $6ee1c1106c00a64d$export$ad80a9624457bb5e)(n);
                                            setDep({
                                                investmentProperty: n,
                                                ipStampDuty: $8c2d8ecb78ee1c16$export$815c71fe24b27d23(st, n),
                                                ipRent: f.rent,
                                                ipExpenses: f.expenses
                                            }, `Investment property \u{2192} ${$8c2d8ecb78ee1c16$var$money(n)}`);
                                        }, 'Investment property', {
                                            dive: 'property',
                                            testId: 'dz-dest-property'
                                        }),
                                        destRow(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                "Investment bond ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-slate-500",
                                                    children: "pays its own tax; tax-free after ten years"
                                                })
                                            ]
                                        }), $8c2d8ecb78ee1c16$var$num(dep.investmentBond), (n)=>setDep({
                                                investmentBond: n
                                            }, `Investment bond \u{2192} ${$8c2d8ecb78ee1c16$var$money(n)}`), 'Investment bond', {
                                            testId: 'dz-dest-bond'
                                        }),
                                        destRow(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                "Funeral bonds ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "text-slate-500",
                                                    children: [
                                                        "up to ",
                                                        $8c2d8ecb78ee1c16$var$money((0, $1abe73eeef086faf$export$aca3edb7cd7a3f17)),
                                                        " each, left out of the assets test"
                                                    ]
                                                })
                                            ]
                                        }), $8c2d8ecb78ee1c16$var$num(L.funeralBondPurchase), (n)=>p.onLedger({
                                                funeralBondPurchase: n
                                            }, `Funeral bonds \u{2192} ${$8c2d8ecb78ee1c16$var$money(n)}`), 'Funeral bonds', {
                                            max: bondMax,
                                            testId: 'dz-dest-funeral'
                                        }),
                                        destRow('Gift to family', $8c2d8ecb78ee1c16$var$num(L.giftingAmount), (n)=>p.onLedger({
                                                giftingAmount: n
                                            }, `Gift \u{2192} ${$8c2d8ecb78ee1c16$var$money(n)}`), 'Gift', {
                                            dive: 'gift',
                                            testId: 'dz-dest-gift'
                                        }),
                                        destRow(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                "Invested",
                                                isCouple ? ', joint names' : '',
                                                " ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "text-slate-500",
                                                    children: [
                                                        "\xb7 ",
                                                        profile,
                                                        " mix"
                                                    ]
                                                })
                                            ]
                                        }), $8c2d8ecb78ee1c16$var$num(dep.shares), (n)=>setDep({
                                                shares: n
                                            }, `Invested \u{2192} ${$8c2d8ecb78ee1c16$var$money(n)}`), 'Invested', {
                                            testId: 'dz-dest-invested'
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "py-2 text-[14px]",
                                                    children: [
                                                        "Kept in the bank ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-slate-500",
                                                            children: "earns 2%, no growth"
                                                        }),
                                                        stillToPlace >= 25000 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                            children: [
                                                                " \xb7 ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                    type: "button",
                                                                    onClick: ()=>setDep({
                                                                            shares: $8c2d8ecb78ee1c16$var$num(dep.shares) + stillToPlace
                                                                        }, `Invested the ${$8c2d8ecb78ee1c16$var$money(stillToPlace)} left in the bank`),
                                                                    className: `${$8c2d8ecb78ee1c16$var$link} text-[13px]`,
                                                                    "data-testid": "dz-invest-remainder",
                                                                    children: [
                                                                        "invest it \u2014 ",
                                                                        profile
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "py-2 text-right tabular-nums text-slate-700",
                                                    "data-testid": "dz-dest-bank",
                                                    children: $8c2d8ecb78ee1c16$var$money(Math.max(0, stillToPlace))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-3 flex flex-wrap items-baseline justify-between gap-2 rounded-xl border border-slate-200 px-4 py-2.5 text-[14px]",
                                "data-testid": "dz-still-to-place",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                className: "text-brand-navy",
                                                children: [
                                                    "Freed by the sale: ",
                                                    $8c2d8ecb78ee1c16$var$money(freedCapital)
                                                ]
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-slate-500",
                                                children: L.sellAndRent ? 'renting: the whole sale, after costs' : `after the new home${stampDuty > 0 ? ` and ${$8c2d8ecb78ee1c16$var$money(stampDuty)} of stamp duty` : ''}`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: stillToPlace < -1 ? 'text-rose-700' : 'text-emerald-700',
                                        children: [
                                            "Still to place: ",
                                            $8c2d8ecb78ee1c16$var$money(Math.max(0, stillToPlace)),
                                            stillToPlace >= -1 && stillToPlace < 1 ? " \u2713" : '',
                                            stillToPlace < -1 ? ` (over by ${$8c2d8ecb78ee1c16$var$money(-stillToPlace)})` : ''
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-1 text-[13.5px] text-slate-700",
                                children: [
                                    "Any money ",
                                    v.you ? 'you don\'t' : `${v.they} don't`,
                                    " place stays in ",
                                    v.their,
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "bank account"
                                    }),
                                    "."
                                ]
                            }),
                            $8c2d8ecb78ee1c16$var$num(dep.shares) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-3",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25ac2ec5abfb5852$export$23e482971454dc30), {
                                    factFind: factFind,
                                    setFactFind: p.setFactFind,
                                    idPrefix: "dz-build",
                                    what: "this money"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-3 text-[13px] text-slate-500",
                                children: [
                                    "Every dollar the sale frees goes somewhere above. ",
                                    p.children ? 'Clearing a debt, below, comes from the same money.' : ''
                                ]
                            }),
                            p.children
                        ]
                    }),
                    effectPanel
                ]
            })
        ]
    });
};
function $8c2d8ecb78ee1c16$export$815c71fe24b27d23(state, price) {
    return (0, $6b146b31ad2b1e77$export$a8a5bac4bde49384)(state, price, 'investment');
}
var $8c2d8ecb78ee1c16$export$2e2bcd8739ae039 = $8c2d8ecb78ee1c16$var$DzBuildPlan;


/**
 * "Explain this" for a downsizing plan, as numbered lines (downsizing rebuild, 21 Oct 2026; the agreed
 * mock-up's d-explain): each line says what they do, and what that does to the numbers, ending in what is
 * left to the family against staying put. The same reading for a tested plan and one built by hand (the
 * owner's Manual Control parity rule), from the plan's own inputs and figures. Presentation only.
 *
 * Told on aged care's ledger (owner, 22 Oct 2026: "all modules use consistent UI"): CauseEffectLedger's navy
 * numerals and hairlines, each line's lead in bold, the money story inside the "Put together" line, then the
 * "=" line against staying put. Its own small blue circles are gone.
 */ 
parcelRequire("acw62");




const $ca6ec27e57b2f02a$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
const $ca6ec27e57b2f02a$var$joined = (l)=>l.body ? `${l.lead} ${l.body}` : l.lead;
function $ca6ec27e57b2f02a$export$b0ebe329d8eb73ec(p) {
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(p.factFind);
    const m = (0, $6cafaaa2bceecd94$export$4c99534ae83f65d1)(p.inputs, {
        rentPerWeek: p.rentPerWeek
    });
    const u = (0, $6cafaaa2bceecd94$export$ba4ded872bfc6459)(p.inputs);
    // The household named once, at the start; after that, "they" and "their" (or "you" and "your").
    const They = v.They;
    const Names = v.you ? 'You' : v.Names;
    const sell = `${Names} sell${v.s}`;
    const lines = [];
    const push = (lead, body = '', change)=>lines.push({
            lead: lead,
            body: body,
            ...change ? {
                change: change
            } : {}
        });
    const net = m.salePrice - m.sellingCosts;
    if (m.sellAndRent) push(`${sell} for ${$ca6ec27e57b2f02a$var$money(m.salePrice)} and pay ${$ca6ec27e57b2f02a$var$money(m.sellingCosts)} in selling costs, leaving ${$ca6ec27e57b2f02a$var$money(net)}.`, `Nothing is bought: ${v.they} rent${m.rentPerWeek > 0 ? ` at ${$ca6ec27e57b2f02a$var$money(m.rentPerWeek)} a week, a cost that rises each year` : ', and no rent was entered, so none is charged'}.`);
    else if (m.buyUpShortfall >= 1) {
        push(`${sell} for ${$ca6ec27e57b2f02a$var$money(m.salePrice)} and pay ${$ca6ec27e57b2f02a$var$money(m.sellingCosts)} in selling costs, leaving ${$ca6ec27e57b2f02a$var$money(net)}`, "\u2014 all of it goes into the new home.");
        if (m.newHomePrice > net * 1.05) push(`The ${$ca6ec27e57b2f02a$var$money(m.newHomePrice)} home costs more than that:`, `${$ca6ec27e57b2f02a$var$money(m.buyUpShortfall)} of savings pay the rest${m.stampDuty > 0 ? `, with the ${$ca6ec27e57b2f02a$var$money(m.stampDuty)} of stamp duty` : ''}. The duty is gone on the day; the rest is now in a home that isn't counted.`);
        else push(`${They} pay ${$ca6ec27e57b2f02a$var$money(m.stampDuty)} of stamp duty from savings.`, 'It is gone on the day; it does not add to the home\'s value.');
    } else {
        push(`${sell} for ${$ca6ec27e57b2f02a$var$money(m.salePrice)} and pay ${$ca6ec27e57b2f02a$var$money(m.sellingCosts)} in selling costs, leaving ${$ca6ec27e57b2f02a$var$money(net)};`, `${$ca6ec27e57b2f02a$var$money(m.newHomePrice)} goes into the new home.`);
        if (m.stampDuty > 0) push(`${They} pay ${$ca6ec27e57b2f02a$var$money(m.stampDuty)} of stamp duty from the sale.`, 'It is gone on the day.');
        else push('No stamp duty is in the figures:', 'no state was chosen.');
    }
    if (m.freedCapital >= 1) {
        const where = (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)({
            inputs: p.inputs,
            rentPerWeek: p.rentPerWeek
        }, p.factFind).sub.replace(/^The sale (frees|nets)[^.]*\.\s*/, '').replace(/^No stamp duty[^.]*\.\s*/, '');
        push(`That frees ${$ca6ec27e57b2f02a$var$money(m.freedCapital)},`, `which is counted for the Age Pension wherever it goes.${where ? ` ${where}` : ''}${u.bank >= 1 && !/stays in the bank/.test(where) ? ` ${$ca6ec27e57b2f02a$var$money(u.bank)} stays in the bank.` : ''}`);
    }
    const b = p.baseline;
    if (b) {
        const d = p.plan.pension - b.pension;
        if (Math.abs(d) < 1) push(`${v.Their} Age Pension stays at ${$ca6ec27e57b2f02a$var$money(p.plan.pension)} a year.`);
        else if (d > 0) push(`Less is counted, so ${v.their} Age Pension rises`, `from ${$ca6ec27e57b2f02a$var$money(b.pension)} to ${$ca6ec27e57b2f02a$var$money(p.plan.pension)} a year.`, {
            from: b.pension,
            to: p.plan.pension,
            unit: ' a year',
            better: 'up',
            after: '.'
        });
        else if (p.plan.pension < 1) push(`More is counted, so ${v.their} Age Pension of ${$ca6ec27e57b2f02a$var$money(b.pension)} a year stops.`);
        else push(`More is counted, so ${v.their} Age Pension falls`, `from ${$ca6ec27e57b2f02a$var$money(b.pension)} to ${$ca6ec27e57b2f02a$var$money(p.plan.pension)} a year.`, {
            from: b.pension,
            to: p.plan.pension,
            unit: ' a year',
            better: 'up',
            after: '.'
        });
    }
    const steps = lines.map($ca6ec27e57b2f02a$var$joined);
    if (b) steps.push(p.plan.cashflow >= 0 ? `Put together, ${v.they} have ${$ca6ec27e57b2f02a$var$money(p.plan.cashflow)} a year to spare in the first year (staying put, ${b.cashflow < 0 ? `short ${$ca6ec27e57b2f02a$var$money(-b.cashflow)}` : $ca6ec27e57b2f02a$var$money(b.cashflow)}).` : `Put together, ${v.they} are ${$ca6ec27e57b2f02a$var$money(-p.plan.cashflow)} short in the first year, met from savings (staying put, ${b.cashflow < 0 ? `short ${$ca6ec27e57b2f02a$var$money(-b.cashflow)}` : `${$ca6ec27e57b2f02a$var$money(b.cashflow)} to spare`}).`);
    let result = null;
    let resultWhy = null;
    if (p.plan.legacy != null) {
        const yrs = `${p.horizonYears} ${p.horizonYears === 1 ? 'year' : 'years'}`;
        const costs = m.sellingCosts + m.stampDuty;
        if (b?.legacy != null) {
            const delta = p.plan.legacy - b.legacy;
            const higher = p.plan.pension > b.pension + 1;
            if (delta < -1) {
                resultWhy = higher && costs > 0 ? `The higher pension doesn't make up for ${$ca6ec27e57b2f02a$var$money(costs)} of duty and selling costs.` : costs > 0 ? `The ${$ca6ec27e57b2f02a$var$money(costs)} of duty and selling costs ${p.plan.pension < b.pension - 1 ? 'and the lower pension both come' : 'comes'} out of it.` : null;
                result = `After about ${yrs} the family is left ${$ca6ec27e57b2f02a$var$money(p.plan.legacy)} \u{2014} ${$ca6ec27e57b2f02a$var$money(-delta)} less than staying put.${resultWhy ? ` ${resultWhy}` : ''}`;
            } else result = `After about ${yrs} the family is left ${$ca6ec27e57b2f02a$var$money(p.plan.legacy)} \u{2014} ${$ca6ec27e57b2f02a$var$money(delta)} more than staying put.`;
        } else result = `After about ${yrs} the family is left ${$ca6ec27e57b2f02a$var$money(p.plan.legacy)}.`;
    }
    return {
        steps: steps,
        lines: lines,
        result: result,
        resultWhy: resultWhy
    };
}
function $ca6ec27e57b2f02a$export$e6ea202b0ce035ff(factFind) {
    return `Each line says what ${(0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind).they} do, and what that does to the numbers. "Staying put" means keeping the home and changing nothing else.`;
}
const $ca6ec27e57b2f02a$var$DzExplainSteps = ({ moneyStory: moneyStory = null, children: children, leverKinds: leverKinds = [], ...p })=>{
    const { lines: lines, resultWhy: resultWhy } = $ca6ec27e57b2f02a$export$b0ebe329d8eb73ec(p);
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(p.factFind);
    const nodes = lines.map((l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: l.lead
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$8dd54625d22f0463), {
                    change: l.change,
                    text: l.body ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " ",
                            l.body
                        ]
                    }) : null
                })
            ]
        }));
    nodes.push((0, $4800816561106c2d$export$4be361d56ef6ce0f)({
        cashflow: p.plan.cashflow,
        baseCashflow: p.baseline ? p.baseline.cashflow : null,
        they: v.they,
        baseWord: 'staying put',
        moneyStory: moneyStory
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4800816561106c2d$export$d053159fb36403b3), {
        testId: "dz-explain-steps",
        lines: nodes,
        estate: p.plan.legacy ?? 0,
        baseEstate: p.baseline?.legacy ?? null,
        horizonYears: p.horizonYears,
        baseWord: "staying put",
        leverKinds: leverKinds,
        children: [
            resultWhy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-3 text-[14px] leading-relaxed text-slate-600",
                "data-testid": "dz-explain-result-why",
                children: resultWhy
            }),
            children
        ]
    });
};
var $ca6ec27e57b2f02a$export$2e2bcd8739ae039 = $ca6ec27e57b2f02a$var$DzExplainSteps;









const $3d2901929448dacd$var$DZ_EXPLAIN_SECTIONS = [
    {
        id: 'what',
        icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
        title: 'What downsizing is',
        summary: "Selling your home and moving somewhere that suits you better \u2014 smaller or easier to run. It does not have to be cheaper.",
        details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-gray-700 leading-relaxed space-y-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        "Downsizing means selling your current home and moving somewhere that suits you better: smaller, easier to look after, closer to family or services. ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "It does not have to be cheaper"
                        }),
                        ", and often is not \u2014 a low-maintenance apartment in the same suburb can cost as much as the house you are leaving, or more."
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "Why people actually move"
                        }),
                        " matters here, because it changes which answer is right:"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                    className: "list-disc pl-5 space-y-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "To free up money"
                                }),
                                " for retirement \u2014 buy cheaper, and the difference becomes cash you can use."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "To reduce the upkeep"
                                }),
                                " \u2014 the garden, the stairs, the maintenance. The money may not change at all."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "To move somewhere better"
                                }),
                                " \u2014 closer to family, services or care. That can cost more than the home you sell."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "All three are legitimate, and they lead to different financial outcomes. The next two sections are the two directions this can go \u2014 and they are opposites."
                })
            ]
        }),
        applies: null
    },
    {
        id: 'trap',
        icon: (0, $00824d397ec63c04$export$2e2bcd8739ae039),
        title: 'Buying CHEAPER: the Age Pension "downsizing trap"',
        summary: "Your home is exempt from the assets test whatever it is worth, but the cash you free up is counted \u2014 so buying cheaper can reduce your pension.",
        details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-gray-700 leading-relaxed space-y-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        "Your home doesn't count towards the Age Pension assets test, ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "no matter its value"
                        }),
                        ". When you sell and buy something cheaper, the money you free up ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "becomes an assessable asset"
                        }),
                        " \u2014 and is deemed to earn income on top. That can reduce your Age Pension, sometimes to nil."
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "It can still be the right move: freed-up cash is money you can actually use, and a pension you lose is not the only thing that matters. But you should see the size of the effect before deciding, which is what the calculator is for."
                })
            ]
        }),
        applies: null
    },
    /*
   * THE OPPOSITE OF THE TRAP, and the module never said it (owner, 2026-08-28).
   *
   * Every word of this explainer assumed downsizing means buying cheaper, so the only pension story
   * it could tell was the trap. But the exemption that CAUSES the trap runs both ways: the home is
   * exempt at any value, so moving counted money INTO a dearer home lifts the pension by the same
   * mechanism that buying cheaper lowers it.
   *
   * Measured against the engine on a $1m homeowner with $500k in savings, a $1.15m purchase took the
   * pension from $17,300 to $29,418 — see server/.../downsizerNewHomePrice.test.ts. That is a real
   * strategy an adviser would consider, and it is exactly the person who moves for MAINTENANCE
   * rather than money who is most likely to be buying at or above what they sell for.
   *
   * It is stated with its costs, not as a trick. The money is in the house, it is not deprivation,
   * and it only helps someone the assets test is actually biting.
   */ {
        id: 'buyup',
        icon: (0, $c9921f4f81a419f0$export$2e2bcd8739ae039),
        title: 'Buying SMALLER BUT DEARER: the opposite of the trap',
        summary: "The home is exempt at any value \u2014 so moving money into a more expensive home can INCREASE your Age Pension.",
        details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-gray-700 leading-relaxed space-y-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        "The rule that causes the trap works both ways. If the home is exempt ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "whatever it is worth"
                        }),
                        ", then money moved out of your savings and into a dearer home ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "stops being counted"
                        }),
                        " \u2014 and the Age Pension can go ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "up"
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        "That is not a loophole, and it is worth being clear about why. If you ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "give money away"
                        }),
                        ", Centrelink does not simply stop counting it \u2014 anything above $10,000 in a year (or $30,000 over five years) is treated as though you still own it ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "for the next five years"
                        }),
                        ". That rule is called ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                            children: "deprivation"
                        }),
                        ", and it exists to stop people giving assets away to qualify for a pension."
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "Buying a home is not giving money away."
                        }),
                        " You still own every dollar \u2014 it is simply held in a house instead of a bank account. So nothing is treated as deprived, and that five-year rule does not apply here at all. It is a recognised strategy, and it suits the person who is moving for the upkeep rather than the money: a smaller, newer, easier place that happens to cost more than the house they are leaving."
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "What it costs you, and this is the real trade-off:"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                    className: "list-disc pl-5 space-y-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "The money is in the house."
                                }),
                                " You cannot spend it, and getting it back means selling again or borrowing against it."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "It only helps if the assets test is what is limiting your pension."
                                }),
                                " On a full pension already, or limited by the income test, there may be nothing to gain."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Aged care assesses the home differently."
                                }),
                                " If residential care is on the horizon, a larger home is counted there up to a cap \u2014 so this can help the pension and cost you later."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Buying and selling costs are real"
                                }),
                                " and are paid whichever direction you move."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "The Suggestion Engine models a cheaper, a similar-priced and a dearer move side by side, so you can see which way your own numbers fall rather than assuming."
                })
            ]
        }),
        applies: null
    },
    {
        id: 'exemption',
        icon: (0, $0811c1891b547863$export$2e2bcd8739ae039),
        title: 'The 24-month proceeds exemption',
        summary: 'Proceeds you intend to use for a new home are exempt from the assets test for up to 24 months (longer if delayed), and deemed at the lower rate.',
        details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            className: "text-gray-700 leading-relaxed",
            children: [
                "If you sell before you've bought or built your new home, the portion of the proceeds you ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    children: "intend to use for the new home"
                }),
                " is exempt from the assets test for up to ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    children: "24 months"
                }),
                " (and up to 36 months if you're delayed for reasons outside your control). During that time it's counted under the income test at the ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    children: "lower deeming rate"
                }),
                " only. Once you buy, the new home is exempt. Tell Services Australia within 14 days of selling."
            ]
        }),
        applies: null
    },
    {
        id: 'super',
        icon: (0, $c42d182890f3ecf5$export$2e2bcd8739ae039),
        title: 'Topping up super (downsizer contribution)',
        summary: "If you are 55+, you can put up to $300,000 each from the sale into super \u2014 outside the normal caps, but with some important rules.",
        details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-gray-700 leading-relaxed space-y-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        "If you're ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "55 or older"
                        }),
                        " and you (or your spouse) owned the home for ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "10+ years"
                        }),
                        ", you can contribute up to ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "$300,000 each"
                        }),
                        " ($600,000 for a couple) from the sale into super as a ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "downsizer contribution"
                        }),
                        ", within ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "90 days"
                        }),
                        " of settlement. No work test, no upper age limit, and you don't have to actually buy a new (or cheaper) home."
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "The rules worth knowing:"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                    className: "list-disc pl-5 space-y-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Once only."
                                }),
                                " You can use the downsizer contribution just once, ever, from a single home sale."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Doesn't use your contribution caps."
                                }),
                                " It's on top of your normal concessional/non-concessional caps, and you can make it even if your total super balance is already large."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "But the transfer balance cap still applies."
                                }),
                                " Money held in a ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                    children: "retirement pension"
                                }),
                                " account inside super pays ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "no tax at all"
                                }),
                                " on its earnings \u2014 so there is a lifetime limit on how much you are allowed to move into one. That limit is the ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "transfer balance cap"
                                }),
                                ", currently ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$807e93be6ec93c1b))
                                }),
                                ", and a downsizer contribution counts towards it like any other money. Anything above the cap has to stay in an ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                    children: "accumulation"
                                }),
                                " account instead, where earnings are taxed at 15% \u2014 still low, just not free."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Very large balances:"
                                }),
                                " from 1 July 2026 an extra 15% tax applies to earnings on the part of any super balance over $3 million (Division 296)."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "Why bother?"
                        }),
                        " Inside super, investment earnings are taxed at most 15% (and 0% in pension phase) \u2014 usually far less than in your own name. The trade-off: once you're Age-Pension age, super counts in the means test, so moving home equity (exempt) into super (assessable) can reduce your pension. The Suggestion Engine weighs that tax saving against the pension cost on your own figures, so you can see which way it lands rather than guessing."
                    ]
                })
            ]
        }),
        applies: null
    },
    {
        id: 'cgt',
        icon: (0, $33b542e8915cec79$export$2e2bcd8739ae039),
        title: 'Capital Gains Tax',
        summary: 'Selling your main residence is usually CGT-free.',
        details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            className: "text-gray-700 leading-relaxed",
            children: [
                "Your main residence is generally ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    children: "exempt from Capital Gains Tax"
                }),
                ". If part of the home was used to produce income (e.g. rented out or a home business), a partial CGT liability can apply. Confirm with your accountant."
            ]
        }),
        applies: null
    }
];
const $3d2901929448dacd$var$DownsizerExplained = ({ setActivePage: setActivePage, onContinue: onContinue, backLabel: backLabel })=>{
    const [openAccordion, setOpenAccordion] = (0, $acw62.useState)(null);
    const toggle = (id)=>setOpenAccordion(openAccordion === id ? null : id);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-6xl mx-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                variant: "ghost",
                size: "sm",
                icon: (0, $c31db635520dc385$export$2e2bcd8739ae039),
                onClick: ()=>backLabel ? onContinue() : setActivePage('Dashboard'),
                className: "mb-4 -ml-2",
                "data-testid": "dz-guide-back",
                children: backLabel || 'Back to Dashboard'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-4 mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                icon: (0, $d5c3c2c5a9eb8655$export$388c0e4f7230aadf).downsizer,
                                tone: "brand",
                                variant: "solid",
                                size: "lg",
                                className: "hidden sm:inline-flex"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-4xl md:text-5xl font-bold text-gray-900",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6288781efbc92679$export$2e2bcd8739ae039), {
                                    children: "Downsizing Your Home"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-lg text-slate-700 leading-relaxed mb-3",
                        children: "Selling the family home and moving somewhere that suits you better \u2014 smaller, easier to run, closer to family. It might free up money, or it might not; either way it changes your Age Pension and where your wealth sits. Let's model it so there are no surprises."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-slate-500",
                        children: "General information and modelling only. You can confirm pension impacts free with Services Australia's Financial Information Service, and your accountant should look at any capital gains tax before you sell."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "space-y-4 mb-8",
                children: $3d2901929448dacd$var$DZ_EXPLAIN_SECTIONS.map((fee)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b5fe5727b69e005$export$2e2bcd8739ae039), {
                        ...fee,
                        isOpen: openAccordion === fee.id,
                        onToggle: ()=>toggle(fee.id),
                        factFind: {}
                    }, fee.id))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                    onClick: onContinue,
                    variant: "brand",
                    size: "lg",
                    iconRight: (0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039),
                    children: backLabel || 'Continue to calculator'
                })
            })
        ]
    });
};
const $3d2901929448dacd$var$n = (v)=>Number(v) || 0;
/** The age-and-health warning for a candidate's annuity — the aged care rule, applied here. */ function $3d2901929448dacd$var$dzAnnuityHorizonWarningOf(strategy, factFind) {
    const terms = (0, $80740ae64106afa1$export$14a5903af8acddef)(strategy.inputs?.deployment, factFind?.adviceFor === 'couple');
    if (!terms) return null;
    const flag = (0, $3d096644ffaac9d7$export$2a10947020c112ea)({
        factFind: factFind,
        residualCapital: (Number(terms.residualPercent) || 0) / 100,
        owner: terms.owner
    });
    return flag?.warning ?? null;
}
const $3d2901929448dacd$var$DownsizerAnalyser = ({ setActivePage: setActivePage, factFind: factFind, onBack: onBack, savedStrategies: savedStrategies = [], setSavedStrategies: setSavedStrategies, setFactFind: setFactFind, onSoaGenerated: onSoaGenerated })=>{
    const isCouple = factFind?.adviceFor === 'couple';
    const homeValue = parseFloat(String(factFind?.home?.value ?? '')) || 0;
    const hasHome = homeValue > 0;
    /** "you" to the client, the household's names to an adviser (owner, 21 Oct 2026). */ const voice = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const goals = factFind?.goals || {};
    const setGoal = (patch)=>setFactFind?.((prev)=>({
                ...prev,
                goals: {
                    ...prev?.goals || {},
                    ...patch
                }
            }));
    /*
   * HOW THE MODULE OPENS (as the village, 21 Oct 2026). With a plan chosen, on the plan page (DzHub). From
   * Home's "Start a new model", on step 1 with step 3's questions asked again. From "Model another home", on
   * the another-home step with everything carried over. The session flags are read here and cleared below.
   */ const [openedFresh] = (0, $acw62.useState)(()=>{
        try {
            return !!sessionStorage.getItem((0, $4e46e0dde908c630$export$5d7344b7ed506119));
        } catch  {
            return false;
        }
    });
    const [anotherHome, setAnotherHome] = (0, $acw62.useState)(()=>{
        try {
            return !!sessionStorage.getItem((0, $4e46e0dde908c630$export$d35c47ced6d86226));
        } catch  {
            return false;
        }
    });
    const dzChosen = (0, $acw62.useMemo)(()=>(0, $4e46e0dde908c630$export$599ead36dcfb6049)(savedStrategies), [
        savedStrategies
    ]);
    const dzHomePlans = (0, $acw62.useMemo)(()=>(0, $4e46e0dde908c630$export$f54a1f0bc6e6915a)(savedStrategies), [
        savedStrategies
    ]);
    const [dzView, setDzView] = (0, $acw62.useState)(()=>!openedFresh && !anotherHome && (0, $4e46e0dde908c630$export$599ead36dcfb6049)(savedStrategies) ? 'hub' : 'steps');
    const [pendingHubAction, setPendingHubAction] = (0, $acw62.useState)(null);
    // Step 3 asks its questions before the first run, and again from "Things that change the answer". The
    // emergency money is the rebuild's own question, so a file that has it has answered them.
    const [dzAsking, setDzAsking] = (0, $acw62.useState)(()=>openedFresh || factFind?.goals?.dzEmergencyReserve == null);
    (0, $acw62.useEffect)(()=>{
        try {
            sessionStorage.removeItem((0, $4e46e0dde908c630$export$5d7344b7ed506119));
            sessionStorage.removeItem((0, $4e46e0dde908c630$export$d35c47ced6d86226));
        } catch  {}
        if (openedFresh && setFactFind) // A fresh model: the home, the price and the answers taken off the file so nothing carries over.
        setFactFind((prev)=>{
            const g = {
                ...prev?.goals || {}
            };
            for (const k of [
                'dzNewHomePrice',
                'dzHomeName',
                'dzRentPerWeek',
                'dzEmergencyReserve',
                'dzDownsizeDate',
                'dzSalePrice',
                'dzSellingCosts'
            ])delete g[k];
            return {
                ...prev,
                goals: g
            };
        });
        // From Home's "Model another home": the chosen plan's sale carried over, the home itself left to name and price.
        if (anotherHome && !openedFresh && setFactFind) {
            const m = (0, $4e46e0dde908c630$export$599ead36dcfb6049)(savedStrategies)?.inputs?.card?.move;
            setFactFind((prev)=>({
                    ...prev,
                    goals: {
                        ...prev?.goals || {},
                        ...m ? {
                            dzSalePrice: m.salePrice,
                            dzSellingCosts: m.sellingCosts,
                            dzDownsizeDate: m.date || '',
                            dzNewHomeState: m.state
                        } : {},
                        dzHomeName: '',
                        dzHousing: 'buy'
                    }
                }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /*
   * THE THREE STEPS. 1: the sale and the new home. 2: staying put, the one baseline. 3: the ways to use the
   * money — the tested plans, or "Build a plan yourself". The strip is a map, not a gate.
   */ const [step, setStep] = (0, $acw62.useState)(1);
    const [strategyMode, setStrategyMode] = (0, $acw62.useState)('optimised');
    const goToStep = (next)=>{
        setStep(next);
        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
    };
    // ── Step 1's answers, kept on the file (goals.dz*) ──
    const sale = (0, $acw62.useMemo)(()=>{
        const salePrice = goals.dzSalePrice != null && $3d2901929448dacd$var$n(goals.dzSalePrice) > 0 ? $3d2901929448dacd$var$n(goals.dzSalePrice) : homeValue;
        return {
            salePrice: salePrice,
            sellingCosts: goals.dzSellingCosts != null ? $3d2901929448dacd$var$n(goals.dzSellingCosts) : Math.round(salePrice * 0.025),
            date: typeof goals.dzDownsizeDate === 'string' ? goals.dzDownsizeDate : ''
        };
    }, [
        goals.dzSalePrice,
        goals.dzSellingCosts,
        goals.dzDownsizeDate,
        homeValue
    ]);
    const onSale = (patch)=>setGoal({
            // Until the selling costs are typed they follow the price at 2.5% (the `sale` reading above).
            ...patch.salePrice != null ? {
                dzSalePrice: patch.salePrice
            } : {},
            ...patch.sellingCosts != null ? {
                dzSellingCosts: patch.sellingCosts
            } : {},
            ...patch.date != null ? {
                dzDownsizeDate: patch.date
            } : {}
        });
    const housing = goals.dzHousing === 'rent' || goals.dzHousing === 'both' ? goals.dzHousing : 'buy';
    const namedPrice = $3d2901929448dacd$var$n(goals.dzNewHomePrice);
    const homeName = String(goals.dzHomeName || '').trim();
    const dutyState = (0, $b0451585083b21c1$export$a597c8d4cd87c330)(factFind).code;
    const rentAWeek = $3d2901929448dacd$var$n(goals.dzRentPerWeek);
    const downsizeDate = sale.date;
    const downsizeDateInPast = downsizeDate !== '' && downsizeDate < new Date().toISOString().slice(0, 10);
    const effectiveDownsizeDate = downsizeDateInPast ? '' : downsizeDate;
    // 10 years, the same as every module but aged care (owner, 19 Oct 2026); the client's answer where given.
    const localLegacyYears = Math.min(30, Math.max(1, $3d2901929448dacd$var$n(goals.dzLegacyYears) || 10));
    const setLocalLegacyYears = (y)=>setGoal({
            dzLegacyYears: Math.min(30, Math.max(1, Math.round(y) || 10))
        });
    /*
   * THE ENGINE'S SETUP, from the file: step 1's home, price, rent and state (the state the client chose, even
   * "not sure"), and step 3's answers. One run on the answers, never on defaults first.
   */ const dzSetup = (0, $acw62.useMemo)(()=>({
            ...(0, $d50f5b54e8b24258$export$9fe8a2b95ef5f52)(factFind),
            newHomeState: dutyState
        }), [
        factFind,
        dutyState
    ]);
    const reserve = (0, $d50f5b54e8b24258$export$f6a66feacdeaef0e)(factFind, dzSetup);
    // ── Build a plan yourself: the ledger (Manual Control's state), seeded from step 1 ──
    const ledgerFromStep1 = ()=>{
        const price = namedPrice > 0 ? namedPrice : Math.round(sale.salePrice * 0.7);
        return {
            salePrice: sale.salePrice,
            sellingCosts: sale.sellingCosts,
            sellAndRent: housing === 'rent',
            rentPerWeek: rentAWeek,
            newHomePurchasePrice: price,
            stampDuty: (0, $6b146b31ad2b1e77$export$a8a5bac4bde49384)(dutyState, price),
            newHomeState: dutyState,
            downsizerContribution: 0,
            partnerDownsizerContribution: 0,
            commenceIncomeStream: false,
            giftingAmount: 0,
            funeralBondPurchase: 0,
            deployment: {},
            buyUpFunding: {},
            buyUpCgtOverrides: {}
        };
    };
    const [ledger, setLedger] = (0, $acw62.useState)(ledgerFromStep1);
    /*
   * Whether a plan was actually built by hand. Until then the ledger is nobody's plan, so the engine does not
   * list it as "Your current plan" (review, 18 Oct 2026), and it follows step 1.
   */ const [manualPlanEntered, setManualPlanEntered] = (0, $acw62.useState)(false);
    const [manualStartedFrom, setManualStartedFrom] = (0, $acw62.useState)(null);
    const [manualLastChange, setManualLastChange] = (0, $acw62.useState)(null);
    const [manualChosen, setManualChosen] = (0, $acw62.useState)(false);
    const onLedger = (patch, words)=>{
        setLedger((prev)=>{
            const next = {
                ...prev,
                ...patch
            };
            // A new price or state strikes the duty again (StampDutyFields does the same on screen).
            if (('newHomePurchasePrice' in patch || 'newHomeState' in patch) && !('stampDuty' in patch)) next.stampDuty = (0, $6b146b31ad2b1e77$export$a8a5bac4bde49384)(next.newHomeState, next.newHomePurchasePrice);
            return next;
        });
        if (words) {
            setManualLastChange(words);
            setManualPlanEntered(true);
        }
        setManualChosen(false);
    };
    // Step 1 is the sale for both ways in; the home, price and state follow it until a plan is built by hand.
    (0, $acw62.useEffect)(()=>{
        setLedger((prev)=>({
                ...prev,
                salePrice: sale.salePrice,
                sellingCosts: sale.sellingCosts,
                ...manualPlanEntered ? {} : (()=>{
                    const s = ledgerFromStep1();
                    return {
                        sellAndRent: s.sellAndRent,
                        rentPerWeek: s.rentPerWeek,
                        newHomePurchasePrice: s.newHomePurchasePrice,
                        stampDuty: s.stampDuty,
                        newHomeState: s.newHomeState
                    };
                })()
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sale.salePrice,
        sale.sellingCosts,
        housing,
        namedPrice,
        dutyState,
        rentAWeek
    ]);
    const details = (0, $acw62.useMemo)(()=>(0, $3ffb5e286ef10c73$export$b283f320d1480737)(ledger), [
        ledger
    ]);
    const hasDownsize = hasHome && sale.salePrice > 0;
    /** The shared debt strategy — the hand-built plan's; the engine pairs a debt twin with every plan. */ const [debtPayments, setDebtPayments] = (0, $acw62.useState)({});
    const [debtFunding, setDebtFunding] = (0, $acw62.useState)({});
    const [debtRepaymentBasis, setDebtRepaymentBasis] = (0, $acw62.useState)('keep_repayment');
    const debtPayoffPlan = (0, $acw62.useMemo)(()=>{
        const payments = Object.fromEntries(Object.entries(debtPayments).filter(([, amount])=>(Number(amount) || 0) > 0));
        if (Object.keys(payments).length === 0) return null;
        const funding = Object.fromEntries(Object.entries(debtFunding).filter(([, amount])=>(Number(amount) || 0) > 0));
        return {
            payments: payments,
            funding: funding,
            repaymentBasis: debtRepaymentBasis
        };
    }, [
        debtPayments,
        debtFunding,
        debtRepaymentBasis
    ]);
    /* TODAY'S POSITION — step 2's four numbers and the baseline of every "why?". */ const [todayFinancials, setTodayFinancials] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind).then((r)=>{
            if (!cancelled) setTodayFinancials(r);
        }).catch(()=>{
            if (!cancelled) setTodayFinancials(null);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind
    ]);
    /* THE BENCHMARK: the client's position over the horizon if they simply do not downsize — the same run the engine's stay-put candidate makes. */ /** The hand-built plan's figures are still being worked out (utils/calcTracker.ts, 25 Oct 2026). */ const { track: trackDz, working: dzCalcWorking } = (0, $a8ad6b8c257d1221$export$66e981b52ef0ad9f)();
    const [stayPutProjections, setStayPutProjections] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        trackDz((0, $d50f5b54e8b24258$export$98e4e1c36d3d9b78)(factFind, {
            legacyYears: localLegacyYears
        })).then((rows)=>{
            if (!cancelled) setStayPutProjections(rows || []);
        }).catch(()=>{
            if (!cancelled) setStayPutProjections([]);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind,
        localLegacyYears
    ]);
    const manualBaselineLegacy = (0, $acw62.useMemo)(()=>(0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(stayPutProjections[localLegacyYears - 1] ?? stayPutProjections[stayPutProjections.length - 1]), [
        stayPutProjections,
        localLegacyYears
    ]);
    const stayPutRunway = (0, $acw62.useMemo)(()=>stayPutProjections.length ? (0, $0fe89e03b6df746e$export$464558962ff4a811)(stayPutProjections, localLegacyYears) : null, [
        stayPutProjections,
        localLegacyYears
    ]);
    /* THE HAND-BUILT PLAN'S FIGURES — only while it is being built (the engine's rows carry every tested plan's). */ const building = strategyMode === 'manual' && step === 3 && dzView === 'steps';
    const [{ before: before, after: afterRaw }, setBeforeAfter] = (0, $acw62.useState)({
        before: {},
        after: {}
    });
    const [afterWithDebt, setAfterWithDebt] = (0, $acw62.useState)(null);
    const [projections, setProjections] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        if (!building || !hasDownsize) return undefined;
        let cancelled = false;
        trackDz((async ()=>{
            try {
                const r = await (0, $d50f5b54e8b24258$export$2a669b0fe6cbdea6)(factFind, details);
                const { simulated: simulated } = r;
                if (cancelled) return;
                setBeforeAfter({
                    before: r.before,
                    after: r.after
                });
                if (debtPayoffPlan) {
                    const withDebt = (0, $5a6326d9013f181c$export$525e306199c9748e)(simulated, debtPayoffPlan).factFind;
                    const fin = await $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(withDebt);
                    if (!cancelled) setAfterWithDebt(fin);
                } else setAfterWithDebt(null);
                const proj = effectiveDownsizeDate ? await (0, $d50f5b54e8b24258$export$98e4e1c36d3d9b78)(factFind, {
                    legacyYears: localLegacyYears,
                    downsizeDate: effectiveDownsizeDate,
                    downsizeDetails: details,
                    debtPayoff: debtPayoffPlan
                }) : await (0, $d50f5b54e8b24258$export$98e4e1c36d3d9b78)(debtPayoffPlan ? (0, $5a6326d9013f181c$export$525e306199c9748e)(simulated, debtPayoffPlan).factFind : simulated, {
                    legacyYears: localLegacyYears
                });
                if (!cancelled) setProjections(proj);
            } catch  {
                if (!cancelled) setProjections([]);
            }
        })());
        return ()=>{
            cancelled = true;
        };
    }, [
        building,
        factFind,
        details,
        hasDownsize,
        localLegacyYears,
        debtPayoffPlan,
        effectiveDownsizeDate
    ]);
    const after = afterWithDebt ?? afterRaw;
    const manualLegacy = projections.length > 0 ? (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(projections[localLegacyYears - 1] ?? projections[projections.length - 1]) ?? $3d2901929448dacd$var$n(after?.netWorth) : null;
    // The just-in-time gates the questions do not cover: how new money is invested (when the questions were
    // skipped), and the transfer balance cap when a run would start a pension and a balance trips the screen.
    const [newMoneySkipped, setNewMoneySkipped] = (0, $acw62.useState)(false);
    // The module's own questions ask this; "Not sure" there is an answer that records nothing, so once they are answered the
    // old one-question gate never shows (owner, 22 Oct 2026: it stood alone in place of the questions on a return visit).
    const needsNewMoneyAnswer = strategyMode === 'optimised' && hasDownsize && !(0, $0f2c0a6799fe36da$export$848647f164f42923)(factFind) && !newMoneySkipped && factFind?.goals?.dzEmergencyReserve == null;
    const answerNewMoneyProfile = (id)=>{
        if (setFactFind) setFactFind((prev)=>({
                ...prev,
                goals: {
                    ...prev.goals || {},
                    newMoneyInvestmentProfile: id
                }
            }));
        else setNewMoneySkipped(true);
    };
    const [tbcSkipped, setTbcSkipped] = (0, $acw62.useState)(false);
    const seRunCommencesPension = (0, $acw62.useMemo)(()=>{
        if (!hasDownsize) return false;
        try {
            return (0, $d50f5b54e8b24258$export$a230187ca30d6754)(factFind, {
                currentInputs: details,
                manualPlanEntered: manualPlanEntered,
                setup: dzSetup
            }).some((c)=>{
                const d = c.details;
                return d.commenceIncomeStream === true || d.deployment?.superCommenceIncomeStream === true;
            });
        } catch  {
            return false;
        }
    }, [
        factFind,
        details,
        manualPlanEntered,
        dzSetup,
        hasDownsize
    ]);
    const tbcPersonNeedingAnswer = !tbcSkipped && seRunCommencesPension ? (0, $4f5a997f1c0139af$export$7bf826dbcbb0ddc)(factFind, 'client') ? 'client' : isCouple && (0, $4f5a997f1c0139af$export$7bf826dbcbb0ddc)(factFind, 'partner') ? 'partner' : null : null;
    const needsTbcAnswer = strategyMode === 'optimised' && tbcPersonNeedingAnswer !== null;
    const answerTbc = (amount)=>{
        if (setFactFind && tbcPersonNeedingAnswer) {
            const key = tbcPersonNeedingAnswer;
            setFactFind((prev)=>({
                    ...prev,
                    [key]: {
                        ...prev[key] || {},
                        transferBalanceUsed: amount
                    }
                }));
        } else setTbcSkipped(true);
    };
    /*
   * A real provider quote for the annuity plans (annuityQuote.ts): it belongs to one type and amount; plans of
   * the same type use it scaled to theirs. Only the committed value re-runs the field.
   */ const [dzAnnuityQuote, setDzAnnuityQuote] = (0, $acw62.useState)(null);
    const [dzAnnuityQuoteDraft, setDzAnnuityQuoteDraft] = (0, $acw62.useState)('');
    // The engine: paint the loader, then compute, then hold to a minimum (the shared pattern).
    const [seLoading, setSeLoading] = (0, $acw62.useState)(false);
    const [dzSuggestions, setDzSuggestions] = (0, $acw62.useState)(null);
    const engineWanted = strategyMode === 'optimised' && (dzView === 'steps' && step === 3 || pendingHubAction != null);
    (0, $acw62.useEffect)(()=>{
        if (!engineWanted) return undefined;
        if (dzAsking || anotherHome) {
            setSeLoading(false);
            return undefined;
        }
        if (needsNewMoneyAnswer || needsTbcAnswer) {
            setSeLoading(false);
            return undefined;
        }
        if (!hasDownsize) {
            setDzSuggestions(null);
            setSeLoading(false);
            return undefined;
        }
        setSeLoading(true);
        const startedAt = Date.now();
        const t = setTimeout(async ()=>{
            let result = null;
            try {
                result = await (0, $d50f5b54e8b24258$export$517e4e1adb5fb749)(factFind, {
                    legacyYears: localLegacyYears,
                    currentInputs: details,
                    manualPlanEntered: manualPlanEntered,
                    downsizeDate: effectiveDownsizeDate || undefined,
                    setup: dzSetup,
                    annuityQuote: dzAnnuityQuote
                });
            } catch  {
                result = null;
            }
            // A failed run is said, not left spinning: an empty field shows "we couldn't test the plans".
            setDzSuggestions(result ?? {
                strategies: [],
                recommended: [],
                stayPut: null,
                rerun: {
                    candidates: [],
                    legacyYears: localLegacyYears
                }
            });
            setTimeout(()=>setSeLoading(false), Math.max(0, 1500 - (Date.now() - startedAt)));
        }, 60);
        return ()=>clearTimeout(t);
    }, [
        engineWanted,
        factFind,
        localLegacyYears,
        details,
        manualPlanEntered,
        hasDownsize,
        needsNewMoneyAnswer,
        needsTbcAnswer,
        dzSetup,
        dzAsking,
        anotherHome,
        effectiveDownsizeDate,
        dzAnnuityQuote
    ]);
    const dzStrategies = (0, $acw62.useMemo)(()=>dzSuggestions ? (0, $f8ee565b442c040e$export$ca5137fb416189aa)(dzSuggestions.strategies, dzSuggestions.recommended) : [], [
        dzSuggestions
    ]);
    const dzStayPut = (0, $acw62.useMemo)(()=>dzSuggestions?.stayPut ?? null, [
        dzSuggestions
    ]);
    const isDzBaseline = (s)=>s.id === 'dz-stay-put';
    /*
   * A NAMED HOME (journey 2): the cards are the ways to use the money for THAT home — "Leaves the most, for
   * this home" — and the other prices stay in "every way tested" as what-ifs. Otherwise the client's reason
   * for moving decides which prices compete, as before.
   */ const forHome = homeName && namedPrice > 0 && housing === 'buy' ? homeName : null;
    // A price stated on step 1 — named home or not — makes the other prices what-ifs (25 Oct 2026; the generator
    // flags them too, this also covers a run made before that).
    const isWhatIf = (s)=>(0, $d50f5b54e8b24258$export$2cbcd11218125c86)(s) || namedPrice > 0 && housing !== 'rent' && /^dz-price-/.test(String(s.id));
    /*
   * GOAL LEADERS, with the aged care horizon rule (a flagged strategy does not win a ranking; it is said and
   * can be opened) and the named-home rule above. Ranked among the ways of downsizing, against staying put.
   */ const dzRecommended = (0, $acw62.useMemo)(()=>{
        if (!dzSuggestions) return [];
        const movers = dzStrategies.filter((s)=>!isDzBaseline(s) && !isWhatIf(s));
        const eligible = movers.filter((s)=>$3d2901929448dacd$var$dzAnnuityHorizonWarningOf(s, factFind) == null);
        /*
     * RANKED AMONG THE WAYS OF DOWNSIZING, not against staying put (the village's rule, owner 20–21 Oct 2026; found in the
     * live review 22 Oct 2026: when every way left less than staying put, the shared ranking withheld them all and
     * the plans screen showed no cards). The price is said in one line above the cards and an "Important"
     * line on each, against staying put.
     */ return (0, $f8ee565b442c040e$export$3140a3b98e6384f2)(eligible, null, {
            cashflowTarget: Number(dzSetup.cashflowTarget) || 0,
            readings: (0, $5a094123650e8adb$export$448a1f2525c95b5b)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dzSuggestions,
        dzStrategies,
        dzStayPut,
        factFind,
        dzSetup.cashflowTarget,
        forHome
    ]);
    const dzGoalLeaders = (0, $acw62.useMemo)(()=>(0, $f8ee565b442c040e$export$64e432c7e60d26e3)(dzRecommended), [
        dzRecommended
    ]);
    const dzSetAside = (0, $acw62.useMemo)(()=>{
        if (!dzSuggestions) return [];
        return (0, $f8ee565b442c040e$export$64e432c7e60d26e3)(dzSuggestions.recommended).map((s)=>({
                strategy: s,
                labels: s.recommendationLabels || [],
                warning: $3d2901929448dacd$var$dzAnnuityHorizonWarningOf(s, factFind) || ''
            })).filter((x)=>x.warning);
    }, [
        dzSuggestions,
        factFind
    ]);
    const [optimisationFocus, setOptimisationFocus] = (0, $acw62.useState)('legacy');
    /** The tested plan chosen on an earlier visit, for its card. */ const dzChosenEngineId = (0, $acw62.useMemo)(()=>{
        const id = dzChosen?.source === 'suggestion_engine' ? dzChosen.inputs?.engineStrategyId : null;
        return typeof id === 'string' ? id : null;
    }, [
        dzChosen
    ]);
    const [selectedSeId, setSelectedSeId] = (0, $acw62.useState)(null);
    const currentHomeKey = (0, $4e46e0dde908c630$export$1cd766d21ccc216e)(homeName, namedPrice, housing);
    /*
   * THE CHOSEN PLAN'S FIGURES FOLLOW ITS RE-TEST (owner, 25 Oct 2026: as aged care and Support at home). Tested
   * again for the chosen home over the same years, the chosen tested plan is brought up to date on its record (Home
   * and the plan page read it), or marked out of date where the run no longer has it.
   */ (0, $acw62.useEffect)(()=>{
        if (!dzChosen || dzChosen.source !== 'suggestion_engine' || !dzSuggestions || seLoading || !setSavedStrategies) return;
        const ins = dzChosen.inputs || {};
        if (ins.homeKey !== currentHomeKey || Number(ins.card?.horizonYears) !== Number(localLegacyYears)) return;
        const row = dzStrategies.find((x)=>x.id === ins.engineStrategyId);
        const base = dzStrategies.find((x)=>x.id === 'dz-stay-put')?.snapshot;
        const chosenId = dzChosen.id;
        setSavedStrategies((prev)=>{
            const next = row ? (0, $78a369bbf1e0d995$export$d5989af62c88c0aa)(prev, chosenId, {
                legacy: $3d2901929448dacd$var$n(row.snapshot?.legacyValue),
                pension: $3d2901929448dacd$var$n(row.snapshot?.pension),
                cashflow: $3d2901929448dacd$var$n(row.snapshot?.netCashflow)
            }, base ? {
                legacy: $3d2901929448dacd$var$n(base.legacyValue),
                pension: $3d2901929448dacd$var$n(base.pension),
                cashflow: $3d2901929448dacd$var$n(base.netCashflow)
            } : null, (0, $78a369bbf1e0d995$export$236630ee0fd3b65b)(factFind)) : (0, $78a369bbf1e0d995$export$91485c71ed77db22)(prev, chosenId, (0, $78a369bbf1e0d995$export$a2028cac13d6740f));
            return next ?? prev;
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dzSuggestions,
        seLoading
    ]);
    /** Whether the chosen plan is for the home on screen (set below, read when choosing). */ const chosenHereRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    /** What the family receives from a plan's guaranteed income, frozen for the plan page (as the village). */ const familyRecordOf = (inputs, rows, sibling)=>{
        const gi = (0, $ed6c3bc1777d5c34$export$432c3d850768ad70)(inputs?.deployment, factFind, rows);
        if (!gi || gi.annuityType === 'fixedTerm') return null;
        const built = (0, $66827b1304244a1d$export$11aaa304d9182b)({
            factFind: factFind,
            personName: gi.personName,
            amount: gi.amount,
            kind: gi.kind,
            incomeAYear: gi.incomeAYear,
            rows: rows,
            compareRows: sibling?.projections ?? null,
            compareNote: sibling ? (0, $ed6c3bc1777d5c34$export$2d8e7d1fb8934a4c) : null,
            horizonYears: localLegacyYears,
            plan: {
                estate: 0,
                pension: 0,
                cashflow: 0
            }
        });
        return built ? {
            personName: gi.personName,
            amount: gi.amount,
            kind: gi.kind,
            incomeAYear: gi.incomeAYear,
            compareNote: built.compareNote,
            rows: built.rows
        } : null;
    };
    /*
   * CHOOSING A TESTED PLAN puts it on record with its card (dzChosenPlan.ts): one plan per home; another home's
   * plan stays saved. Income only waits for the client's dated confirmation for this amount.
   */ const selectEngineStrategy = (strategy)=>{
        if ((0, $c23f2635a2ea2069$export$2ae4d3edf3ae676b)(strategy, factFind)) return;
        // Already chosen (here, or on an earlier visit for this home): nothing to save again.
        if (strategy.id != null && strategy.id === (selectedSeId ?? (chosenHereRef.current ? dzChosenEngineId : null))) return;
        setSelectedSeId(strategy.id ?? null);
        if (!setSavedStrategies) return;
        const recommended = dzGoalLeaders.map((l)=>({
                labels: l.recommendationLabels || [],
                name: l.name
            }));
        const baseSnap = dzStayPut?.snapshot;
        const move = {
            ...(0, $6cafaaa2bceecd94$export$4c99534ae83f65d1)(strategy.inputs, {
                rentPerWeek: strategy.rentPerWeek,
                homeName: homeName,
                date: effectiveDownsizeDate
            })
        };
        const card = {
            plan: {
                legacy: $3d2901929448dacd$var$n(strategy.snapshot?.legacyValue),
                pension: $3d2901929448dacd$var$n(strategy.snapshot?.pension),
                cashflow: $3d2901929448dacd$var$n(strategy.snapshot?.netCashflow)
            },
            baseline: baseSnap ? {
                legacy: $3d2901929448dacd$var$n(baseSnap.legacyValue),
                pension: $3d2901929448dacd$var$n(baseSnap.pension),
                cashflow: $3d2901929448dacd$var$n(baseSnap.netCashflow)
            } : null,
            words: (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(strategy, factFind),
            move: move,
            horizonYears: localLegacyYears,
            riskKinds: (0, $29500f2a86f5f83f$export$ff22458321af692)(String(strategy.id || ''), strategy.inputs),
            origin: 'engine',
            family: familyRecordOf(strategy.inputs, strategy.projections, (0, $ed6c3bc1777d5c34$export$7e3067ac8807505a)(strategy.id, dzStrategies))
        };
        setSavedStrategies((prev)=>(0, $4e46e0dde908c630$export$ca3f5e02abff08b8)(prev, {
                id: `dz-se-${Date.now()}`,
                name: strategy.name || 'Suggested downsizing strategy',
                displayName: card.words.title,
                type: 'downsizer',
                source: 'suggestion_engine',
                // The client's figures it was priced on, so Home can tell when they change (chosenPlanRefresh.ts).
                inputsFingerprint: (0, $78a369bbf1e0d995$export$236630ee0fd3b65b)(factFind),
                inputs: {
                    engineStrategyId: strategy.id ?? null,
                    card: card,
                    homeKey: currentHomeKey,
                    legacyYears: localLegacyYears,
                    planContext: {
                        setup: {
                            ...dzSetup
                        },
                        downsizeDate: effectiveDownsizeDate || null
                    },
                    details: {
                        ...strategy.inputs || {}
                    },
                    downsizeDate: effectiveDownsizeDate || null,
                    setup: {
                        ...dzSetup
                    },
                    source: 'suggestion_engine',
                    seStrategyName: strategy.name ?? null,
                    recommendedOptimalStrategies: recommended,
                    clientSelectedIsAlternative: recommended.length > 0 && !recommended.some((r)=>r.name === strategy.name)
                },
                outputs: {
                    agePension: card.plan.pension,
                    cashFlow: card.plan.cashflow,
                    legacyEstimate: card.plan.legacy,
                    netWorthSchedule: (0, $a882fd27fa2c97d8$export$7386c6396507d94b)(strategy.projections || [])
                },
                createdAt: new Date().toISOString()
            }));
    };
    /** The hand-built plan as a tested plan would be read — its words, its risks, its document. */ const manualAsStrategy = ()=>({
            id: 'dz-manual',
            name: (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)({
                id: 'dz-manual',
                inputs: details
            }, factFind).title,
            inputs: details,
            projections: projections,
            snapshot: {
                legacyValue: manualLegacy ?? 0,
                pension: $3d2901929448dacd$var$n(after?.socialSecurity),
                netCashflow: $3d2901929448dacd$var$n(projections[0]?.netCashflow ?? after?.cashFlow)
            },
            deploymentBreakdown: []
        });
    /** Staying put, as the engine's benchmark row reads, from the screen's own run (no engine needed). */ const stayPutAsStrategy = ()=>({
            id: 'dz-stay-put',
            name: 'Stay in your current home',
            inputs: {},
            projections: stayPutProjections,
            snapshot: {
                legacyValue: manualBaselineLegacy ?? 0,
                pension: $3d2901929448dacd$var$n(todayFinancials?.socialSecurity),
                netCashflow: $3d2901929448dacd$var$n(todayFinancials?.cashFlow)
            }
        });
    const chooseManualPlan = ()=>{
        if (!setSavedStrategies) return;
        const s = manualAsStrategy();
        const move = (0, $6cafaaa2bceecd94$export$4c99534ae83f65d1)(details, {
            homeName: homeName,
            date: effectiveDownsizeDate
        });
        const card = {
            plan: {
                legacy: $3d2901929448dacd$var$n(manualLegacy),
                pension: $3d2901929448dacd$var$n(after?.socialSecurity),
                cashflow: $3d2901929448dacd$var$n(projections[0]?.netCashflow ?? after?.cashFlow)
            },
            baseline: todayFinancials ? {
                legacy: $3d2901929448dacd$var$n(manualBaselineLegacy),
                pension: $3d2901929448dacd$var$n(todayFinancials.socialSecurity),
                cashflow: $3d2901929448dacd$var$n(todayFinancials.cashFlow)
            } : null,
            words: (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(s, factFind),
            move: move,
            horizonYears: localLegacyYears,
            riskKinds: [
                ...(0, $29500f2a86f5f83f$export$ff22458321af692)('dz-manual', details),
                ...debtPayoffPlan ? [
                    'clearDebt'
                ] : []
            ],
            origin: 'manual',
            family: familyRecordOf(details, projections, null)
        };
        setSavedStrategies((prev)=>(0, $4e46e0dde908c630$export$ca3f5e02abff08b8)(prev, {
                id: `dz-manual-${Date.now()}`,
                name: card.words.title,
                displayName: card.words.title,
                type: 'downsizer',
                source: 'manual',
                inputsFingerprint: (0, $78a369bbf1e0d995$export$236630ee0fd3b65b)(factFind),
                // Built by the client from a tested plan ("Customise this plan", 25 Oct 2026).
                ...manualStartedFrom ? {
                    customisedFrom: manualStartedFrom
                } : {},
                inputs: {
                    card: card,
                    homeKey: currentHomeKey,
                    legacyYears: localLegacyYears,
                    details: {
                        ...details
                    },
                    downsizeDate: effectiveDownsizeDate || null,
                    debtPayoff: debtPayoffPlan || null,
                    source: 'manual',
                    seStrategyName: null
                },
                outputs: {
                    agePension: card.plan.pension,
                    cashFlow: card.plan.cashflow,
                    legacyEstimate: card.plan.legacy,
                    netWorthSchedule: (0, $a882fd27fa2c97d8$export$7386c6396507d94b)(projections || [])
                },
                createdAt: new Date().toISOString()
            }));
        setManualChosen(true);
    };
    /**
   * The Statement of Advice for a plan (dzSoa.ts) — opened, downloaded, registered. On the app's calendar-year
   * setting the plan and the benchmark are re-cut on calendar years first, so the document's rows match.
   */ const generateDzSoa = async (strategy, field = dzStrategies)=>{
        const periodMode = (0, $4f50ab660c01dd64$export$1e222c2c280e2a28)();
        let picked = strategy;
        let all = field;
        const rerun = dzSuggestions?.rerun;
        if (periodMode === 'calendar_year' && rerun && strategy.id !== 'dz-manual') {
            const siblingId = (0, $ed6c3bc1777d5c34$export$7e3067ac8807505a)(strategy.id, field)?.id ?? null;
            const wanted = rerun.candidates.filter((c)=>c?.id === strategy.id || c?.id === 'dz-stay-put' || siblingId != null && c?.id === siblingId);
            if (wanted.length) try {
                const rows = await $55a1d8a64f1e5dfa$export$3c56e8c3a3f7ace8(factFind, wanted, rerun.legacyYears, rerun.date, 'calendar_year');
                const byId = new Map(rows.map((r)=>[
                        String(r.id),
                        r.projections || []
                    ]));
                picked = {
                    ...strategy,
                    projections: byId.get(String(strategy.id)) ?? strategy.projections
                };
                all = field.map((s)=>byId.has(String(s.id)) ? {
                        ...s,
                        projections: byId.get(String(s.id))
                    } : s);
            } catch  {}
        }
        const snapshot = (0, $a8ea1c05c1194ef5$export$8cf32ecded529ff3)({
            strategy: picked,
            all: all,
            factFind: factFind,
            legacyYears: localLegacyYears,
            setup: dzSetup,
            periodMode: periodMode,
            annuityQuote: dzAnnuityQuote,
            homeName: homeName,
            customisedFrom: strategy.id === 'dz-manual' ? manualStartedFrom : null
        });
        (0, $482dbb064a59e381$export$bedc55c6dae3ee6a)(snapshot);
        onSoaGenerated?.({
            id: strategy.id,
            name: strategy.name,
            type: 'downsizer',
            source: strategy.id === 'dz-manual' ? 'manual' : 'suggestion_engine',
            strategy: strategy,
            soaSnapshot: snapshot
        });
    };
    const generateManualSoa = ()=>generateDzSoa(manualAsStrategy(), [
            stayPutAsStrategy(),
            manualAsStrategy()
        ]);
    // Explain this / What could go wrong — for a tested plan, the hand-built plan, or the chosen plan.
    const [explainSeId, setExplainSeId] = (0, $acw62.useState)(null);
    const [explainManual, setExplainManual] = (0, $acw62.useState)(false);
    const [riskTarget, setRiskTarget] = (0, $acw62.useState)(null);
    const explainStrategy = (0, $acw62.useMemo)(()=>explainSeId ? dzStrategies.find((s)=>s.id === explainSeId) || null : null, [
        dzStrategies,
        explainSeId
    ]);
    const [explainView, setExplainView] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!explainStrategy) {
            setExplainView(null);
            return undefined;
        }
        let cancelled = false;
        const cfg = explainStrategy.inputs || {};
        (0, $d50f5b54e8b24258$export$2a669b0fe6cbdea6)(factFind, cfg).catch(()=>({
                before: {},
                after: {}
            })).then(({ before: sBefore, after: sAfter })=>{
            if (cancelled) return;
            const proj = explainStrategy.projections || [];
            const m = (0, $6cafaaa2bceecd94$export$4c99534ae83f65d1)(cfg, {
                rentPerWeek: explainStrategy.rentPerWeek
            });
            const sLegacy = proj.length ? (0, $7ca740f4c8b36af2$export$8bec68a96a4d6d98)(proj[localLegacyYears - 1] ?? proj[proj.length - 1]) ?? sAfter?.netWorth ?? 0 : sAfter?.netWorth ?? 0;
            setExplainView({
                id: explainStrategy.id,
                name: explainStrategy.name,
                before: sBefore,
                after: sAfter,
                projections: proj,
                hasDownsize: m.salePrice > 0,
                salePrice: m.salePrice,
                sellingCosts: m.sellingCosts,
                newHomePrice: m.newHomePrice,
                stampDuty: m.stampDuty,
                freedCapital: m.freedCapital,
                buyUpShortfall: m.buyUpShortfall,
                sellAndRent: m.sellAndRent,
                rentPerWeek: m.rentPerWeek,
                downsizerContribution: $3d2901929448dacd$var$n(cfg.downsizerContribution) + $3d2901929448dacd$var$n(cfg.partnerDownsizerContribution),
                legacyEstimate: sLegacy,
                insightFinancials: {
                    agePensionBefore: sBefore?.socialSecurity ?? 0,
                    agePensionAfter: sAfter?.socialSecurity ?? 0,
                    cashflowAfter: proj[0]?.netCashflow ?? proj[0]?.cashFlow ?? sAfter?.cashFlow ?? 0,
                    legacyEstimate: sLegacy
                }
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        explainStrategy,
        factFind,
        localLegacyYears
    ]);
    const explainViewReady = !!explainStrategy && !!explainView && explainView.id === explainStrategy.id;
    const manualModel = (0, $acw62.useMemo)(()=>{
        const m = (0, $6cafaaa2bceecd94$export$4c99534ae83f65d1)(details);
        return {
            before: before,
            after: after,
            projections: projections,
            hasDownsize: hasDownsize,
            salePrice: m.salePrice,
            sellingCosts: m.sellingCosts,
            newHomePrice: m.newHomePrice,
            stampDuty: m.stampDuty,
            freedCapital: m.freedCapital,
            buyUpShortfall: m.buyUpShortfall,
            sellAndRent: m.sellAndRent,
            rentPerWeek: m.rentPerWeek,
            downsizerContribution: $3d2901929448dacd$var$n(details.downsizerContribution) + $3d2901929448dacd$var$n(details.partnerDownsizerContribution),
            legacyEstimate: $3d2901929448dacd$var$n(manualLegacy),
            insightFinancials: {
                agePensionBefore: $3d2901929448dacd$var$n(before?.socialSecurity),
                agePensionAfter: $3d2901929448dacd$var$n(after?.socialSecurity),
                cashflowAfter: $3d2901929448dacd$var$n(projections[0]?.netCashflow ?? after?.cashFlow),
                legacyEstimate: $3d2901929448dacd$var$n(manualLegacy)
            }
        };
    }, [
        before,
        after,
        projections,
        hasDownsize,
        details,
        manualLegacy
    ]);
    const openRisksFor = (row)=>setRiskTarget({
            title: (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(row, factFind).title,
            kinds: (0, $29500f2a86f5f83f$export$ff22458321af692)(String(row.id || ''), row.inputs),
            inputs: row.inputs,
            horizonWarning: $3d2901929448dacd$var$dzAnnuityHorizonWarningOf(row, factFind)
        });
    /*
   * THE DEEP DIVE'S YEAR TOGGLE: re-cutting a tested plan on the calendar year runs it again through the engine,
   * with the candidate, horizon and date from the same builder that ranked it.
   */ const [seDeepDive, setSeDeepDive] = (0, $acw62.useState)(null);
    const [showStayPutProjections, setShowStayPutProjections] = (0, $acw62.useState)(false);
    const [modalPeriodMode, setModalPeriodMode] = (0, $acw62.useState)((0, $4f50ab660c01dd64$export$1e222c2c280e2a28));
    const [calendarYearProjections, setCalendarYearProjections] = (0, $acw62.useState)(null);
    const deepDiveCandidate = (0, $acw62.useMemo)(()=>{
        const rerun = dzSuggestions?.rerun;
        if (!rerun || !seDeepDive?.id) return null;
        const candidate = rerun.candidates.find((c)=>c?.id === seDeepDive.id);
        return candidate ? {
            candidate: candidate,
            legacyYears: rerun.legacyYears,
            date: rerun.date
        } : null;
    }, [
        dzSuggestions,
        seDeepDive
    ]);
    (0, $acw62.useEffect)(()=>{
        if (modalPeriodMode !== 'calendar_year' || !seDeepDive || !deepDiveCandidate) {
            setCalendarYearProjections(null);
            return undefined;
        }
        let cancelled = false;
        setCalendarYearProjections(null);
        $55a1d8a64f1e5dfa$export$3c56e8c3a3f7ace8(factFind, [
            deepDiveCandidate.candidate
        ], deepDiveCandidate.legacyYears, deepDiveCandidate.date, 'calendar_year').then((rows)=>{
            if (cancelled) return;
            const first = Array.isArray(rows) ? rows[0] : undefined;
            setCalendarYearProjections(first?.projections ?? []);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        modalPeriodMode,
        seDeepDive,
        deepDiveCandidate,
        factFind
    ]);
    // "Every way we tested", worded for the reader; Escape closes it.
    const [showAllSeStrategies, setShowAllSeStrategies] = (0, $acw62.useState)(false);
    /** "Compare the two homes side by side" (journey 2). */ const [comparingHomes, setComparingHomes] = (0, $acw62.useState)(false);
    const [allSortBy, setAllSortBy] = (0, $acw62.useState)('legacy');
    (0, $acw62.useEffect)(()=>{
        if (!showAllSeStrategies) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') setShowAllSeStrategies(false);
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        showAllSeStrategies
    ]);
    // What the plan page asked for, done once the tested plans are back.
    (0, $acw62.useEffect)(()=>{
        if (!pendingHubAction || seLoading || !dzSuggestions) return;
        const row = dzStrategies.find((x)=>x.id === (selectedSeId ?? dzChosenEngineId));
        setPendingHubAction(null);
        if (!row) return;
        if (pendingHubAction === 'explain') setExplainSeId(row.id ?? null);
        else generateDzSoa(row);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pendingHubAction,
        seLoading,
        dzSuggestions
    ]);
    /** The chosen plan's sale and home, back on the steps (the plan page's "Change the sale" and a reopen). */ const restoreChosenHome = ()=>{
        const card = dzChosen?.inputs?.card;
        if (!card) return;
        const m = card.move;
        setGoal({
            dzSalePrice: m.salePrice,
            dzSellingCosts: m.sellingCosts,
            dzDownsizeDate: m.date || '',
            dzHousing: m.sellAndRent ? 'rent' : 'buy',
            ...m.sellAndRent ? {
                dzRentPerWeek: m.rentPerWeek
            } : {
                dzNewHomePrice: m.newHomePrice
            },
            dzNewHomeState: m.state,
            dzHomeName: m.homeName || ''
        });
    };
    const openSteps = (to)=>{
        setDzView('steps');
        setAnotherHome(false);
        if (to === 3) setStrategyMode('optimised');
        goToStep(to);
    };
    const seedManualFrom = (inputs, label)=>{
        setLedger((prev)=>(0, $3ffb5e286ef10c73$export$2d47a140007a8f61)(inputs, prev));
        setManualPlanEntered(true);
        setManualStartedFrom(label);
        setManualLastChange(null);
        setManualChosen(false);
    };
    /** The chosen hand-built plan, reopened in the ledger as it was chosen (its levers, its debt plan), still chosen. */ const reopenManual = ()=>{
        const ins = dzChosen?.inputs;
        restoreChosenHome();
        // Its own record says where it began, if it was customised from a tested plan (25 Oct 2026).
        seedManualFrom(ins?.details ?? null, dzChosen?.customisedFrom ?? null);
        if (ins?.debtPayoff) {
            setDebtPayments(ins.debtPayoff.payments || {});
            setDebtFunding(ins.debtPayoff.funding || {});
            setDebtRepaymentBasis(ins.debtPayoff.repaymentBasis || 'keep_repayment');
        }
        setManualChosen(true);
        setDzView('steps');
        setStrategyMode('manual');
        setStep(3);
        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
    };
    /** The plan page asked for the hand-built plan's document: made once its figures are back. */ const [pendingManualAdvice, setPendingManualAdvice] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!pendingManualAdvice || !projections.length || !todayFinancials || !stayPutProjections.length) return;
        setPendingManualAdvice(false);
        generateManualSoa();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pendingManualAdvice,
        projections,
        todayFinancials,
        stayPutProjections
    ]);
    /** The "…and clear your debts" twin carries its payoff on the candidate, not on the row (25 Oct 2026). */ const seedDebtFrom = (id)=>{
        const cand = dzSuggestions?.rerun.candidates?.find((c)=>c?.id === id);
        setDebtPayments({
            ...cand?.debtPayoff?.payments || {}
        });
        setDebtFunding({
            ...cand?.debtPayoff?.funding || {}
        });
        setDebtRepaymentBasis(cand?.debtPayoff?.repaymentBasis === 'lower_repayment' ? 'lower_repayment' : 'keep_repayment');
    };
    /**
   * A BLANK hand-built plan (owner, 25 Oct 2026): the sale and the new home as step 1 decided them, nothing put
   * to work, no debts cleared — what "Build a plan yourself" and "Clear and start again" open. It used to open on
   * whatever the ledger last held, so a plan customised earlier reappeared under the blank door.
   */ const clearManual = ()=>{
        setLedger(ledgerFromStep1());
        setManualPlanEntered(false);
        setManualStartedFrom(null);
        setManualLastChange(null);
        setManualChosen(false);
        setDebtPayments({});
        setDebtFunding({});
        setDebtRepaymentBasis('keep_repayment');
    };
    /** "Customise this plan" (a tested plan) or "Build a plan yourself" (none): the two doors into the ledger. */ const openBuild = (from)=>{
        clearManual();
        if (from) {
            seedManualFrom(from.inputs, (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(from, factFind).title);
            seedDebtFrom(from.id);
        }
        setStrategyMode('manual');
        setStep(3);
        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
    };
    // ───────────────────────────── the plan page ─────────────────────────────
    const riskPanel = riskTarget && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5757b380cc124794$export$2e2bcd8739ae039), {
        voice: voice,
        strategyName: riskTarget.title,
        onClose: ()=>setRiskTarget(null),
        risks: (0, $29500f2a86f5f83f$export$60e4d14b8d823b60)({
            kinds: riskTarget.kinds,
            move: riskTarget.inputs ? (0, $6cafaaa2bceecd94$export$4c99534ae83f65d1)(riskTarget.inputs) : null,
            ipStampDuty: $3d2901929448dacd$var$n(riskTarget.inputs?.deployment?.ipStampDuty) || null,
            horizonWarning: riskTarget.horizonWarning
        })
    });
    if (dzView === 'hub' && dzChosen?.inputs?.card) {
        const card = dzChosen.inputs.card;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "max-w-[1520px] mx-auto",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4a5c3133e48e027$export$2e2bcd8739ae039), {
                    factFind: factFind,
                    plan: dzChosen,
                    outOfDate: (0, $78a369bbf1e0d995$export$ceccff7104f70d1e)(dzChosen, factFind),
                    homeCount: dzHomePlans.length,
                    onChangeSale: ()=>{
                        restoreChosenHome();
                        openSteps(1);
                    },
                    onAnotherHome: ()=>{
                        restoreChosenHome();
                        setGoal({
                            dzHomeName: '',
                            dzHousing: 'buy'
                        });
                        setDzView('steps');
                        setAnotherHome(true);
                        setStep(1);
                        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
                    },
                    // "A new model from scratch" (owner, 22 Oct 2026): what Home's "Start a new model" does, from here — the home,
                    // the price and the answers taken off the file, step 1 again, and step 3's questions asked afresh.
                    onStartFresh: ()=>{
                        setFactFind?.((prev)=>{
                            const g = {
                                ...prev?.goals || {}
                            };
                            for (const k of [
                                'dzNewHomePrice',
                                'dzHomeName',
                                'dzRentPerWeek',
                                'dzEmergencyReserve',
                                'dzDownsizeDate',
                                'dzSalePrice',
                                'dzSellingCosts'
                            ])delete g[k];
                            return {
                                ...prev,
                                goals: g
                            };
                        });
                        // Nothing hand-built carries over either: the ledger follows step 1 again until a plan is built.
                        setManualPlanEntered(false);
                        setManualStartedFrom(null);
                        setManualLastChange(null);
                        setManualChosen(false);
                        setDzAsking(true);
                        openSteps(1);
                    },
                    onAllPlans: ()=>{
                        restoreChosenHome();
                        openSteps(3);
                    },
                    onExplain: ()=>{
                        if (dzChosen.source === 'manual') {
                            reopenManual();
                            setExplainManual(true);
                            return;
                        }
                        restoreChosenHome();
                        setPendingHubAction('explain');
                        openSteps(3);
                    },
                    // The same specifics the tested plan's panel says (22 Oct 2026): the saved plan carries its details, so the
                    // guaranteed income's horizon warning is read from them and the client file, as on the plans screen.
                    onRisks: ()=>{
                        const details = dzChosen.inputs?.details || null;
                        setRiskTarget({
                            title: card.words.title,
                            kinds: card.riskKinds,
                            inputs: details,
                            horizonWarning: details ? $3d2901929448dacd$var$dzAnnuityHorizonWarningOf({
                                inputs: details
                            }, factFind) : null
                        });
                    },
                    onAdvice: ()=>{
                        if (dzChosen.source === 'manual') {
                            reopenManual();
                            setPendingManualAdvice(true);
                            return;
                        }
                        restoreChosenHome();
                        setPendingHubAction('advice');
                        openSteps(3);
                    },
                    onBuild: ()=>{
                        // A hand-built plan reopens with every lever it was built with, still chosen; a tested one seeds the ledger.
                        if (dzChosen.source === 'manual') {
                            reopenManual();
                            return;
                        }
                        restoreChosenHome();
                        clearManual();
                        seedManualFrom(dzChosen.inputs?.details || null, card.words.title);
                        seedDebtFrom(dzChosenEngineId);
                        setDzView('steps');
                        setStrategyMode('manual');
                        setStep(3);
                        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
                    },
                    onBuildNew: ()=>{
                        restoreChosenHome();
                        clearManual();
                        setDzView('steps');
                        setStrategyMode('manual');
                        setStep(3);
                        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
                    },
                    onGuide: onBack,
                    onAssumptions: ()=>setActivePage('AssumptionsPage'),
                    onHome: ()=>setActivePage('Dashboard')
                }),
                riskPanel
            ]
        });
    }
    // ───────────────────────────── the steps ─────────────────────────────
    const stepTitle = step === 1 ? anotherHome ? 'Another home' : 'The sale and the new home' : step === 2 ? 'What it means' : strategyMode === 'manual' ? 'Build a plan yourself' : 'Ways to use the money';
    const stayPutCash = $3d2901929448dacd$var$n(todayFinancials?.cashFlow);
    const ways = dzStrategies.filter((s)=>!isDzBaseline(s));
    const chosenHere = !!dzChosen?.inputs?.card && dzChosen.inputs.homeKey === currentHomeKey && dzStrategies.some((x)=>x.id === (selectedSeId ?? dzChosenEngineId));
    chosenHereRef.current = chosenHere;
    const notices = (()=>{
        if (!dzSuggestions) return null;
        if (chosenHere && dzChosen?.inputs?.card) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 border-l-4 border-l-emerald-500 bg-white px-5 py-4 shadow-card",
            "data-testid": "dz-chosen-banner",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-[26px] leading-none text-emerald-500",
                    "aria-hidden": true,
                    children: "\u2713"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "min-w-0 flex-1 text-[14px] leading-relaxed text-slate-700",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                            className: "text-slate-900",
                            children: [
                                voice.you ? "You've" : `${voice.Names} ${voice.have}`,
                                " chosen \u201C",
                                dzChosen.inputs.card.words.title,
                                "\u201D."
                            ]
                        }),
                        ' ',
                        "It's saved with ",
                        voice.possessive,
                        " file. The next step is the advice document, then telling Services Australia when the home is sold."
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: ()=>setDzView('hub'),
                    className: "text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                    "data-testid": "dz-go-to-plan-page",
                    children: "Go to the downsizing plan"
                })
            ]
        });
        const chosenCard = dzChosen?.inputs?.card;
        if (chosenCard && dzChosen?.inputs?.homeKey !== currentHomeKey) {
            const best = ways.filter((s)=>!isWhatIf(s)).reduce((top, s)=>top == null || $3d2901929448dacd$var$n(s.snapshot?.legacyValue) > $3d2901929448dacd$var$n(top.snapshot?.legacyValue) ? s : top, null);
            const chosenLeaves = chosenCard.plan.legacy;
            const thisLeaves = $3d2901929448dacd$var$n(best?.snapshot?.legacyValue);
            const homeWords = forHome ? `the ${(0, $4e46e0dde908c630$export$b48e0c6120d679a4)(namedPrice)} home` : housing === 'rent' ? 'renting' : namedPrice > 0 ? `a ${(0, $4e46e0dde908c630$export$b48e0c6120d679a4)(namedPrice)} home` : 'this home';
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700",
                "data-testid": "dz-other-home-note",
                children: [
                    "Re-tested for ",
                    homeWords,
                    ". ",
                    voice.Possessive,
                    " chosen plan, ",
                    chosenCard.words.title.charAt(0).toLowerCase(),
                    chosenCard.words.title.slice(1),
                    ",",
                    ' ',
                    best ? chosenLeaves >= thisLeaves ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "still leaves the family more: ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(chosenLeaves)),
                            " against ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(thisLeaves)),
                            ". "
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "leaves the family ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(chosenLeaves)),
                            ", against ",
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(thisLeaves)),
                            " here. "
                        ]
                    }) : null,
                    "It stays chosen until ",
                    voice.they,
                    " choose here.",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setComparingHomes(true),
                        className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                        "data-testid": "dz-compare-homes",
                        children: "Compare the two homes side by side"
                    })
                ]
            });
        }
        return null;
    })();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-[1520px] mx-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] text-slate-500",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setActivePage('Dashboard'),
                        className: "underline decoration-dotted underline-offset-2 hover:text-slate-800",
                        children: "Home"
                    }),
                    " \u203A Downsizing \u203A ",
                    forHome && step === 3 ? `${forHome} \u{203A} ` : '',
                    stepTitle
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "mt-2 text-[32px] font-bold leading-tight tracking-tight text-brand-navy",
                "data-testid": "dz-title",
                children: voice.you ? 'Your downsizing' : `Downsizing for ${voice.names}`
            }),
            step === 1 && !anotherHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-1 text-[15px] text-slate-600",
                children: [
                    "Three short steps: the sale and the new home, what it would mean for ",
                    voice.them,
                    ", and the ways to use any money it frees."
                ]
            }),
            !hasHome ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-6 rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] text-slate-700",
                children: [
                    "Downsizing applies when ",
                    voice.you ? 'you own' : `${voice.names} own${voice.s}`,
                    " a home. There's no home recorded in ",
                    voice.possessive,
                    " profile, so there's nothing to downsize here."
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $724b7566e2d97e1f$export$2e2bcd8739ae039), {
                        step: step,
                        onStep: (s)=>{
                            if (s !== 1) setAnotherHome(false);
                            goToStep(s);
                        },
                        ariaLabel: "Downsizing steps",
                        steps: [
                            {
                                title: 'The sale and the new home',
                                sub: sale.salePrice > 0 ? `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(sale.salePrice)}${dutyState ? ` \xb7 ${dutyState}` : ''}` : 'Prices, costs, stamp duty'
                            },
                            {
                                title: `What it means for ${voice.them}`,
                                sub: todayFinancials ? `${stayPutCash < 0 ? `short ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(-stayPutCash))}` : `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(stayPutCash))} a year spare`}` : 'Staying put, in four numbers'
                            },
                            {
                                title: 'Ways to use the money',
                                sub: 'Plans we tested, or build your own'
                            }
                        ]
                    }),
                    step === 1 && anotherHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-8",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24f508e167d5afdc$export$2e2bcd8739ae039), {
                            factFind: factFind,
                            setFactFind: setFactFind,
                            salePrice: sale.salePrice,
                            sellingCosts: sale.sellingCosts,
                            state: dutyState,
                            chosenTitle: dzChosen?.inputs?.card?.words.title ?? null,
                            onRun: ()=>{
                                setAnotherHome(false);
                                setStrategyMode('optimised');
                                setDzAsking(false);
                                goToStep(3);
                            },
                            onCancel: ()=>{
                                setAnotherHome(false);
                                if (dzChosen) {
                                    restoreChosenHome();
                                    setDzView('hub');
                                }
                            }
                        })
                    }),
                    step === 1 && !anotherHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-8",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0451585083b21c1$export$2e2bcd8739ae039), {
                            factFind: factFind,
                            setFactFind: setFactFind,
                            sale: sale,
                            onSale: onSale,
                            onNext: ()=>goToStep(2),
                            onReadGuide: onBack
                        })
                    }),
                    step === 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-8",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6888989aaf3877cf$export$2e2bcd8739ae039), {
                            factFind: factFind,
                            todayFinancials: todayFinancials,
                            stayPutLegacy: manualBaselineLegacy,
                            runway: stayPutRunway,
                            legacyYears: localLegacyYears,
                            salePrice: sale.salePrice,
                            sellingCosts: sale.sellingCosts,
                            onLegacyYearsChange: setLocalLegacyYears,
                            onBack: ()=>goToStep(1),
                            onNext: ()=>{
                                setStrategyMode('optimised');
                                goToStep(3);
                            },
                            onAssumptions: ()=>setActivePage('AssumptionsPage'),
                            onShowProjections: ()=>setShowStayPutProjections(true)
                        })
                    }),
                    step === 3 && strategyMode === 'optimised' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-8",
                        children: dzAsking ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a028f10b8733b568$export$2e2bcd8739ae039), {
                            factFind: factFind,
                            sale: sale,
                            housing: housing,
                            newHomePrice: namedPrice,
                            state: dutyState,
                            firstRun: factFind?.goals?.dzEmergencyReserve == null,
                            onRun: (answers)=>{
                                setGoal((0, $a028f10b8733b568$export$ab9e4b86119bb8dd)(answers));
                                setNewMoneySkipped(true);
                                setDzAsking(false);
                                (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
                            },
                            onBuildYourOwn: ()=>{
                                setDzAsking(false);
                                openBuild(null);
                            },
                            onCancel: factFind?.goals?.dzEmergencyReserve == null ? undefined : ()=>setDzAsking(false)
                        }) : !hasDownsize ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] text-slate-700",
                            children: [
                                "Enter the ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "sale price"
                                }),
                                " on step 1, and we'll compare the ways to use the money."
                            ]
                        }) : needsNewMoneyAnswer ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a08e2ea281a6041$export$2e2bcd8739ae039), {
                                onAnswer: answerNewMoneyProfile,
                                onSkip: ()=>setNewMoneySkipped(true),
                                contextLine: "The plans we'll compare put the money the sale frees to work."
                            })
                        }) : needsTbcAnswer ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $216ea083fe16cb8b$export$2e2bcd8739ae039), {
                                name: (tbcPersonNeedingAnswer === 'partner' ? factFind?.partner?.firstName : factFind?.client?.firstName) || 'this person',
                                onAnswer: answerTbc,
                                onSkip: ()=>setTbcSkipped(true)
                            })
                        }) : seLoading || !dzSuggestions && engineWanted ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $81c96376e6bb9658$export$2e2bcd8739ae039), {
                            title: "Testing the ways to use the money",
                            subtitle: "We're modelling each way of downsizing, and staying put, over the same years."
                        }) : !dzSuggestions || dzStrategies.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-[14px] text-slate-600",
                            children: [
                                "We couldn't test the plans for this sale. ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "font-semibold text-brand-navy underline",
                                    onClick: ()=>openBuild(null),
                                    children: "Build a plan yourself"
                                }),
                                " instead."
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c23f2635a2ea2069$export$2e2bcd8739ae039), {
                            notices: notices,
                            factFind: factFind,
                            strategies: dzStrategies.map((s)=>isWhatIf(s) ? {
                                    ...s,
                                    sensitivity: true
                                } : s),
                            stayPut: dzStayPut,
                            recommended: dzRecommended,
                            setAside: dzSetAside,
                            horizonYears: localLegacyYears,
                            ownToday: $3d2901929448dacd$var$n(todayFinancials?.netWorth),
                            focus: optimisationFocus,
                            onFocus: setOptimisationFocus,
                            chosenId: selectedSeId ?? (chosenHere ? dzChosenEngineId : null),
                            onChoose: selectEngineStrategy,
                            onIncomeOnly: (0, $5eae79c7e46ed27e$export$415ddf94c95c9134)(setFactFind),
                            onExplain: (row)=>setExplainSeId(row.id ?? null),
                            onRisks: openRisksFor,
                            onYearByYear: (row)=>setSeDeepDive({
                                    projections: row.projections || [],
                                    name: (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(row, factFind).title,
                                    id: row.id
                                }),
                            renderDetail: (row)=>{
                                const terms = (0, $80740ae64106afa1$export$14a5903af8acddef)(row.inputs?.deployment, isCouple);
                                const rows = (0, $6cafaaa2bceecd94$export$4e25df6b98b4ff33)(row.inputs, row.deploymentBreakdown);
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-3 text-[13px] text-slate-700",
                                    "data-testid": "dz-card-detail",
                                    children: [
                                        rows.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                            className: "w-full tabular-nums",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                children: rows.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "border-b border-slate-100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-1",
                                                                children: r.label
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-1 text-right",
                                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(r.amount))
                                                            })
                                                        ]
                                                    }, r.label))
                                            })
                                        }),
                                        row.description && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-slate-600",
                                            children: row.description
                                        }),
                                        terms && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6421482343679f4$export$d05c00195a7db941), {
                                            terms: terms,
                                            factFind: factFind,
                                            quote: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6421482343679f4$export$624bbc9c6c5928), {
                                                        draft: dzAnnuityQuoteDraft,
                                                        onDraft: setDzAnnuityQuoteDraft,
                                                        committed: dzAnnuityQuote?.income ?? null,
                                                        scope: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                            children: [
                                                                "Have a quote from a provider for this guaranteed income? Enter the yearly income they offered for ",
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(terms.purchaseAmount) || 0),
                                                                ". Plans with the same type are re-compared on it, scaled to their amount; other types keep our estimate."
                                                            ]
                                                        }),
                                                        onCommit: (income)=>setDzAnnuityQuote(income != null && income > 0 ? {
                                                                income: income,
                                                                amount: Number(terms.purchaseAmount) || 0,
                                                                shape: (0, $da24031d156d6acb$export$f7e5360546f2cc73)(terms.annuityType, terms.residualPercent)
                                                            } : null)
                                                    }),
                                                    dzAnnuityQuote && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "mt-2 text-[12px] text-slate-600",
                                                        "data-testid": "dz-annuity-quote-note",
                                                        children: (0, $da24031d156d6acb$export$3c59a0c7e65b683b)(dzAnnuityQuote, (0, $f94e45ac645ae232$export$3dc27271f5d5c629))
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setSeDeepDive({
                                                    projections: row.projections || [],
                                                    name: (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(row, factFind).title,
                                                    id: row.id
                                                }),
                                            className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                            children: "See the year-by-year figures"
                                        })
                                    ]
                                });
                            },
                            onAllWays: ()=>setShowAllSeStrategies(true),
                            onChanges: ()=>{
                                setDzAsking(true);
                                (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
                            },
                            onBuildYourOwn: openBuild,
                            onAdvice: ()=>{
                                const row = dzStrategies.find((x)=>x.id === (selectedSeId ?? dzChosenEngineId));
                                if (row) generateDzSoa(row);
                            },
                            forHome: forHome,
                            whatIfCount: dzStrategies.filter((s)=>!isDzBaseline(s) && isWhatIf(s)).length
                        })
                    }),
                    step === 3 && strategyMode === 'manual' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-8",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c2d8ecb78ee1c16$export$2e2bcd8739ae039), {
                            factFind: factFind,
                            setFactFind: setFactFind,
                            ledger: ledger,
                            onLedger: onLedger,
                            reserve: reserve,
                            horizonYears: localLegacyYears,
                            startedFrom: manualStartedFrom,
                            onClear: clearManual,
                            startOptions: [
                                ...dzGoalLeaders.slice(0, 3).map((l)=>({
                                        id: String(l.id),
                                        label: (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(l, factFind).title
                                    })),
                                {
                                    id: 'blank',
                                    label: 'A blank plan'
                                }
                            ],
                            onStartFrom: (id)=>{
                                if (id === 'blank') {
                                    clearManual();
                                    return;
                                }
                                const row = dzStrategies.find((x)=>String(x.id) === id);
                                if (row) {
                                    clearManual();
                                    seedManualFrom(row.inputs, (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(row, factFind).title);
                                    seedDebtFrom(row.id);
                                }
                            },
                            working: dzCalcWorking,
                            effect: {
                                cashflow: projections.length ? $3d2901929448dacd$var$n(projections[0]?.netCashflow ?? after?.cashFlow) : null,
                                baseCashflow: todayFinancials ? $3d2901929448dacd$var$n(todayFinancials.cashFlow) : null,
                                pension: projections.length ? $3d2901929448dacd$var$n(after?.socialSecurity) : null,
                                basePension: todayFinancials ? $3d2901929448dacd$var$n(todayFinancials.socialSecurity) : null,
                                legacy: projections.length ? $3d2901929448dacd$var$n(manualLegacy) : null,
                                baseLegacy: manualBaselineLegacy
                            },
                            lastChange: manualLastChange,
                            onExplain: ()=>setExplainManual(true),
                            onRisks: ()=>setRiskTarget({
                                    title: (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)({
                                        id: 'dz-manual',
                                        inputs: details
                                    }, factFind).title,
                                    kinds: [
                                        ...(0, $29500f2a86f5f83f$export$ff22458321af692)('dz-manual', details),
                                        ...debtPayoffPlan ? [
                                            'clearDebt'
                                        ] : []
                                    ],
                                    inputs: details,
                                    horizonWarning: $3d2901929448dacd$var$dzAnnuityHorizonWarningOf({
                                        inputs: details
                                    }, factFind)
                                }),
                            onChoose: chooseManualPlan,
                            chosen: manualChosen,
                            onBackToPlans: ()=>{
                                setStrategyMode('optimised');
                                (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
                            },
                            onYearByYear: ()=>setSeDeepDive({
                                    projections: projections,
                                    name: 'The plan you built'
                                }),
                            planRows: projections,
                            downsizeDate: effectiveDownsizeDate,
                            comparison: manualChosen && setSavedStrategies ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-3 flex flex-wrap gap-x-4 gap-y-1 border-t border-slate-200 pt-2 text-[13px]",
                                "data-testid": "dz-build-chosen-strip",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-slate-600",
                                        children: [
                                            "Saved with ",
                                            voice.possessive,
                                            " file."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>void generateManualSoa(),
                                        className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                        "data-testid": "dz-build-advice",
                                        children: "Get the advice document"
                                    }),
                                    dzChosen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setDzView('hub'),
                                        className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                        children: "Go to the downsizing plan"
                                    })
                                ]
                            }) : null,
                            children: (0, $35f2741dc40fa45c$export$403bb596c20e48)(factFind).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35f2741dc40fa45c$export$2e2bcd8739ae039), {
                                variant: "section",
                                heading: "3 \xb7 Debts",
                                factFind: factFind,
                                debtPayments: debtPayments,
                                setDebtPayments: (v)=>{
                                    setDebtPayments(v);
                                    setManualChosen(false);
                                },
                                debtFunding: debtFunding,
                                setDebtFunding: setDebtFunding,
                                repaymentBasis: debtRepaymentBasis,
                                setRepaymentBasis: setDebtRepaymentBasis,
                                competingUseNote: "The money comes from the same sale proceeds and savings the plan puts to work, so what is spent here reduces what is left to place."
                            })
                        })
                    })
                ]
            }),
            showAllSeStrategies && dzSuggestions && (()=>{
                const stay = dzStayPut;
                const pick = (s)=>allSortBy === 'cashflow' ? $3d2901929448dacd$var$n(s.snapshot?.netCashflow) : allSortBy === 'pension' ? $3d2901929448dacd$var$n(s.snapshot?.pension) : $3d2901929448dacd$var$n(s.snapshot?.legacyValue);
                const plans = ways.filter((s)=>!isWhatIf(s)).sort((a, b)=>pick(b) - pick(a));
                const whatIfs = ways.filter((s)=>isWhatIf(s)).sort((a, b)=>pick(b) - pick(a));
                const signed = (d)=>Math.round(d) === 0 ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: `block text-[12px] ${d < 0 ? 'text-rose-700' : 'text-emerald-700'}`,
                        children: [
                            d < 0 ? "\u2212" : '+',
                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(d)))
                        ]
                    });
                const row = (s)=>{
                    const isSelected = s.id === (selectedSeId ?? (chosenHere ? dzChosenEngineId : null));
                    const w = (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(s, factFind);
                    const cashLeft = $3d2901929448dacd$var$n(s.snapshot?.netCashflow);
                    const gi = (0, $ed6c3bc1777d5c34$export$432c3d850768ad70)(s.inputs?.deployment, factFind);
                    const setter = (0, $5eae79c7e46ed27e$export$415ddf94c95c9134)(setFactFind);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                        className: `border-b border-slate-100 ${isSelected ? 'bg-blue-50/60' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                className: "px-5 py-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "font-semibold text-slate-900",
                                        children: w.title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mt-0.5 max-w-xl text-[12.5px] text-slate-500",
                                        children: w.sub
                                    }),
                                    gi?.incomeOnly && setter && !isSelected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-2 max-w-xl",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$4538b371a206da0c), {
                                            factFind: factFind,
                                            amount: gi.amount,
                                            onChange: setter
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                className: "px-5 py-3 text-right font-semibold",
                                children: [
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($3d2901929448dacd$var$n(s.snapshot?.legacyValue)),
                                    stay && signed($3d2901929448dacd$var$n(s.snapshot?.legacyValue) - $3d2901929448dacd$var$n(stay.snapshot?.legacyValue))
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                className: "px-5 py-3 text-right",
                                children: [
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($3d2901929448dacd$var$n(s.snapshot?.pension)),
                                    stay && signed($3d2901929448dacd$var$n(s.snapshot?.pension) - $3d2901929448dacd$var$n(stay.snapshot?.pension))
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                className: `px-5 py-3 text-right ${cashLeft < 0 ? 'text-rose-700' : ''}`,
                                children: cashLeft < 0 ? `short ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(-cashLeft)}` : (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(cashLeft)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                className: "px-5 py-3 text-right",
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $6cafaaa2bceecd94$export$4c99534ae83f65d1)(s.inputs).freedCapital)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                className: "whitespace-nowrap px-5 py-3 text-right",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "inline-flex gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                            variant: isSelected ? 'secondary' : 'brand',
                                            size: "sm",
                                            disabled: !isSelected && ((0, $c23f2635a2ea2069$export$2ae4d3edf3ae676b)(s, factFind) || !!gi?.incomeOnly && !!setter && (0, $5eae79c7e46ed27e$export$655f124668ce439a)(factFind, true, gi.amount)),
                                            onClick: ()=>{
                                                selectEngineStrategy(s);
                                                setShowAllSeStrategies(false);
                                            },
                                            children: isSelected ? 'Chosen' : 'Choose this plan'
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                            variant: "secondary",
                                            size: "sm",
                                            onClick: ()=>{
                                                setSeDeepDive({
                                                    projections: s.projections || [],
                                                    name: w.title,
                                                    id: s.id
                                                });
                                                setShowAllSeStrategies(false);
                                            },
                                            children: "Year by year"
                                        })
                                    ]
                                })
                            })
                        ]
                    }, s.id || s.name);
                };
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                    titleId: "dz-all-ways-title",
                    title: `Every way we tested, ${ways.length}`,
                    eyebrow: `Against staying put, over about ${localLegacyYears} years`,
                    onClose: ()=>setShowAllSeStrategies(false),
                    size: "xl",
                    testId: "dz-all-ways-dialog",
                    flush: true,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap items-center justify-between gap-3 border-b border-slate-100 px-5 py-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-[14px] text-slate-700",
                                    children: [
                                        "These are all the ways of downsizing and using the money we worked through for ",
                                        voice.them,
                                        ". The plans ",
                                        voice.you ? 'you were shown' : `${voice.names} ${voice.are === 'is' ? 'was' : 'were'} shown`,
                                        " are the ones that do best on ",
                                        voice.their,
                                        " goals."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "flex items-center gap-2 text-[13px] text-slate-600",
                                    children: [
                                        "Order by",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: allSortBy,
                                            onChange: (e)=>setAllSortBy(e.target.value),
                                            className: "rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-[13px]",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "legacy",
                                                    children: "Left to the family"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "cashflow",
                                                    children: "Left over each year"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "pension",
                                                    children: "Age Pension"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "overflow-x-auto",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                className: "min-w-full text-[14px]",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "border-b border-slate-200 text-left text-[12px] font-semibold text-slate-500",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3",
                                                    children: "The plan"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3 text-right",
                                                    children: "Left to the family"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3 text-right",
                                                    children: "Age Pension, a year"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3 text-right",
                                                    children: "Left over, first year"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3 text-right",
                                                    children: "Freed up"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        className: "tabular-nums",
                                        children: [
                                            stay && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100 bg-slate-50",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "px-5 py-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-semibold text-slate-900",
                                                                children: "Staying put"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "mt-0.5 text-[12.5px] text-slate-500",
                                                                children: "What every plan is measured against."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($3d2901929448dacd$var$n(stay.snapshot?.legacyValue))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($3d2901929448dacd$var$n(stay.snapshot?.pension))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: $3d2901929448dacd$var$n(stay.snapshot?.netCashflow) < 0 ? `short ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(-$3d2901929448dacd$var$n(stay.snapshot?.netCashflow))}` : (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($3d2901929448dacd$var$n(stay.snapshot?.netCashflow))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3"
                                                    })
                                                ]
                                            }),
                                            plans.map(row),
                                            whatIfs.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    colSpan: 6,
                                                    className: "bg-white px-5 pb-1 pt-5",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-[13px] font-bold text-brand-navy",
                                                            "data-testid": "dz-what-ifs",
                                                            children: "What if the new home cost more, or less?"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-[12.5px] text-slate-500",
                                                            children: [
                                                                "The same sale with only the price changed",
                                                                forHome ? `, beside ${forHome}` : '',
                                                                ". Shown so the price decision can be seen on its own; ",
                                                                forHome ? 'they are for other homes' : namedPrice > 0 ? `the plans above all buy at the ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(namedPrice)} named` : 'never recommended for the reason given for moving',
                                                                "."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            whatIfs.map(row)
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                });
            })(),
            comparingHomes && dzChosen?.inputs?.card && (()=>{
                const c = dzChosen.inputs.card;
                const best = ways.filter((s)=>!isWhatIf(s)).reduce((top, s)=>top == null || $3d2901929448dacd$var$n(s.snapshot?.legacyValue) > $3d2901929448dacd$var$n(top.snapshot?.legacyValue) ? s : top, null);
                const bm = best ? (0, $6cafaaa2bceecd94$export$4c99534ae83f65d1)(best.inputs) : null;
                const stay = dzStayPut;
                const money = (x)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(x));
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                    titleId: "dz-homes-title",
                    title: "Two homes, side by side",
                    eyebrow: "Same sale, same years, same state",
                    onClose: ()=>setComparingHomes(false),
                    size: "xl",
                    testId: "dz-compare-homes-dialog",
                    flush: true,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "overflow-x-auto",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                className: "min-w-full text-[14px] tabular-nums",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "border-b border-slate-200 text-left text-[12px] font-semibold text-slate-500",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3",
                                                    children: "Plan \xb7 home"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3 text-right",
                                                    children: "Left to the family"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3 text-right",
                                                    children: "Each year"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3 text-right",
                                                    children: "Age Pension"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3 text-right",
                                                    children: "Stamp duty"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-5 py-3 text-right",
                                                    children: "Freed up"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        children: [
                                            stay && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100 bg-slate-50",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "px-5 py-3 font-semibold",
                                                        children: [
                                                            "Staying put",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-[12.5px] font-normal text-slate-500",
                                                                children: "the comparison"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: money($3d2901929448dacd$var$n(stay.snapshot?.legacyValue))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: money($3d2901929448dacd$var$n(stay.snapshot?.netCashflow))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: money($3d2901929448dacd$var$n(stay.snapshot?.pension))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: "\u2014"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-b border-slate-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "px-5 py-3 font-semibold",
                                                        children: [
                                                            c.words.title,
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "text-[12.5px] font-normal text-slate-500",
                                                                children: [
                                                                    c.move.sellAndRent ? 'renting' : `about ${(0, $4e46e0dde908c630$export$b48e0c6120d679a4)(c.move.newHomePrice)}`,
                                                                    c.move.homeName ? `, ${c.move.homeName}` : '',
                                                                    " \xb7 Chosen"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: money(c.plan.legacy)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: money(c.plan.cashflow)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: money(c.plan.pension)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: money(c.move.stampDuty)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: money(c.move.freedCapital)
                                                    })
                                                ]
                                            }),
                                            best && bm && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "px-5 py-3 font-semibold",
                                                        children: [
                                                            (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(best, factFind).title,
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "text-[12.5px] font-normal text-slate-500",
                                                                children: [
                                                                    bm.sellAndRent ? 'renting' : (0, $4e46e0dde908c630$export$b48e0c6120d679a4)(bm.newHomePrice),
                                                                    forHome ? `, ${forHome}` : ''
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: money($3d2901929448dacd$var$n(best.snapshot?.legacyValue))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: money($3d2901929448dacd$var$n(best.snapshot?.netCashflow))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: money($3d2901929448dacd$var$n(best.snapshot?.pension))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: money(bm.stampDuty)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-right",
                                                        children: money(bm.freedCapital)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap justify-end gap-2 px-5 py-3",
                            children: [
                                best && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                    variant: "brand",
                                    size: "sm",
                                    disabled: (0, $c23f2635a2ea2069$export$2ae4d3edf3ae676b)(best, factFind),
                                    onClick: ()=>{
                                        selectEngineStrategy(best);
                                        setComparingHomes(false);
                                    },
                                    children: "Choose the other plan instead"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    size: "sm",
                                    onClick: ()=>setComparingHomes(false),
                                    children: "Back"
                                })
                            ]
                        })
                    ]
                });
            })(),
            (explainStrategy || explainManual) && (()=>{
                const isManual = !explainStrategy;
                const row = explainStrategy ?? manualAsStrategy();
                const rows = row.projections || [];
                const base = explainStrategy ? dzStayPut?.snapshot : null;
                const baseline = isManual ? todayFinancials ? {
                    legacy: manualBaselineLegacy,
                    pension: $3d2901929448dacd$var$n(todayFinancials.socialSecurity),
                    cashflow: $3d2901929448dacd$var$n(todayFinancials.cashFlow)
                } : null : base ? {
                    legacy: $3d2901929448dacd$var$n(base.legacyValue),
                    pension: $3d2901929448dacd$var$n(base.pension),
                    cashflow: $3d2901929448dacd$var$n(base.netCashflow)
                } : null;
                const gi = (0, $ed6c3bc1777d5c34$export$432c3d850768ad70)(row.inputs?.deployment, factFind, rows);
                const sibling = gi && !isManual ? (0, $ed6c3bc1777d5c34$export$7e3067ac8807505a)(row.id, dzStrategies) : null;
                const story = (0, $0fe89e03b6df746e$export$693cc3146baa3244)(rows).hasDeficit ? (0, $2ddaae90639b5011$export$bdea18f456fd84b)({
                    rows: rows,
                    factFind: factFind,
                    runway: (0, $0fe89e03b6df746e$export$464558962ff4a811)(rows, rows.length),
                    deposit: {
                        paid: 0,
                        refundTo: ''
                    },
                    horizonYears: localLegacyYears,
                    enteringName: factFind?.client?.firstName || 'The household',
                    spentOn: 'the new home'
                }) : null;
                const close = ()=>{
                    setExplainSeId(null);
                    setExplainManual(false);
                };
                return(// Aged care's Explain this (owner, 22 Oct 2026: "all modules use consistent UI"): the "Explain this" chip,
                // the plan's own words as the title, one line saying how to read it, and the ledger below.
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $12084f898a868747$export$2e2bcd8739ae039), {
                    eyebrow: "Explain this",
                    title: (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(row, factFind).title,
                    intro: (0, $ca6ec27e57b2f02a$export$e6ea202b0ce035ff)(factFind),
                    onClose: close,
                    footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        size: "sm",
                        onClick: ()=>{
                            close();
                            setSeDeepDive({
                                projections: rows,
                                name: (0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(row, factFind).title,
                                id: isManual ? undefined : row.id
                            });
                        },
                        children: "See the year-by-year figures"
                    }),
                    children: !isManual && !explainViewReady || isManual && !projections.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "rounded-xl border border-dashed border-slate-300 bg-white px-4 py-6 text-center text-[14px] text-slate-600",
                        role: "status",
                        "aria-live": "polite",
                        children: "Working out this plan's figures\u2026"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ca6ec27e57b2f02a$export$2e2bcd8739ae039), {
                        factFind: factFind,
                        inputs: row.inputs || {},
                        rentPerWeek: row.rentPerWeek,
                        plan: {
                            legacy: isManual ? manualLegacy : $3d2901929448dacd$var$n(row.snapshot?.legacyValue),
                            pension: $3d2901929448dacd$var$n(row.snapshot?.pension),
                            cashflow: $3d2901929448dacd$var$n(row.snapshot?.netCashflow)
                        },
                        baseline: baseline,
                        horizonYears: localLegacyYears,
                        // The money story is told inside the "Put together" line, as aged care tells it (22 Oct 2026).
                        moneyStory: story ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ddaae90639b5011$export$1a915263dc5391f1), {
                            story: story,
                            testId: "dz-money-story"
                        }) : null,
                        leverKinds: isManual ? [
                            ...(0, $29500f2a86f5f83f$export$ff22458321af692)('dz-manual', row.inputs || {}),
                            ...debtPayoffPlan ? [
                                'clearDebt'
                            ] : []
                        ] : (0, $29500f2a86f5f83f$export$ff22458321af692)(String(row.id || ''), row.inputs || {}),
                        children: [
                            gi && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-5",
                                "data-testid": "dz-recap-family-panel",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
                                    factFind: factFind,
                                    personName: gi.personName,
                                    amount: gi.amount,
                                    kind: gi.kind,
                                    incomeAYear: gi.incomeAYear,
                                    rows: rows,
                                    compareRows: sibling?.projections ?? null,
                                    compareNote: sibling ? (0, $ed6c3bc1777d5c34$export$2d8e7d1fb8934a4c) : null,
                                    horizonYears: localLegacyYears,
                                    testId: "dz-recap-annuity-family-panel"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e49e8af2e37bf019$export$2e2bcd8739ae039), {
                                hideSummary: true,
                                eyebrow: "Why each number moves",
                                model: isManual ? manualModel : explainView,
                                giftingAmount: $3d2901929448dacd$var$n(row.inputs?.giftingAmount),
                                baselineLegacy: isManual ? manualBaselineLegacy : base ? $3d2901929448dacd$var$n(base.legacyValue) : manualBaselineLegacy,
                                legacyYears: localLegacyYears,
                                factFind: factFind
                            }),
                            (()=>{
                                // The debts this plan keeps, and what the same plan with them paid off did ("<id>-clear-debt").
                                const twin = isManual ? null : (dzStrategies || []).find((s)=>s.id === `${row.id}-clear-debt`) ?? null;
                                const cleared = isManual ? Object.values(debtPayoffPlan?.payments || {}).reduce((t, x)=>t + (Number(x) || 0), 0) : /-clear-debt$/.test(String(row.id)) ? (0, $fe4e1ee5e30419ba$export$abbf1dec1caebd5a)(factFind) : 0;
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe4e1ee5e30419ba$export$2e2bcd8739ae039), {
                                    factFind: factFind,
                                    clearedAmount: cleared,
                                    plan: {
                                        estate: isManual ? $3d2901929448dacd$var$n(manualLegacy) : $3d2901929448dacd$var$n(row.snapshot?.legacyValue),
                                        pension: $3d2901929448dacd$var$n(row.snapshot?.pension),
                                        cashflow: $3d2901929448dacd$var$n(row.snapshot?.netCashflow)
                                    },
                                    twin: twin ? {
                                        estate: $3d2901929448dacd$var$n(twin.snapshot?.legacyValue),
                                        pension: $3d2901929448dacd$var$n(twin.snapshot?.pension),
                                        cashflow: $3d2901929448dacd$var$n(twin.snapshot?.netCashflow)
                                    } : null,
                                    years: localLegacyYears,
                                    context: isManual ? 'manual' : 'tested'
                                });
                            })(),
                            (0, $5fe2dfde2f334213$export$4abd1e21404204e)((0, $6cafaaa2bceecd94$export$c0e0825daa2dbb24)(row, factFind).sub) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd95277538ec3233$export$2e2bcd8739ae039), {
                                factFind: factFind
                            })
                        ]
                    })
                }));
            })(),
            riskPanel,
            showStayPutProjections && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9847d752f8df838f$export$2e2bcd8739ae039), {
                onClose: ()=>setShowStayPutProjections(false),
                title: "Staying put \u2014 nothing changed",
                comparedOverYears: Number(localLegacyYears) || undefined,
                projections: stayPutProjections,
                factFind: factFind,
                initialFinancials: todayFinancials,
                costLabel: null
            }),
            seDeepDive && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9847d752f8df838f$export$2e2bcd8739ae039), {
                onClose: ()=>setSeDeepDive(null),
                title: seDeepDive.name,
                comparedOverYears: Number(localLegacyYears) || undefined,
                projections: modalPeriodMode === 'calendar_year' && calendarYearProjections ? calendarYearProjections : seDeepDive.projections,
                ...deepDiveCandidate ? {
                    onPeriodModeChange: setModalPeriodMode,
                    isReloading: modalPeriodMode === 'calendar_year' && !calendarYearProjections
                } : {},
                factFind: factFind,
                initialFinancials: todayFinancials,
                costLabel: null
            })
        ]
    });
};
const $3d2901929448dacd$var$DownsizerPage = ({ setActivePage: setActivePage, factFind: factFind, savedStrategies: savedStrategies, setSavedStrategies: setSavedStrategies, setFactFind: setFactFind, onSoaGenerated: onSoaGenerated })=>{
    // The steps first; the guide is a link from step 1's primer and the plan page (as the village, 21 Oct 2026).
    const [view, setView] = (0, $acw62.useState)('calculator');
    // The calculator stays mounted (hidden) under the guide, and closing it puts the reader back where they were.
    const scrollWas = (0, $acw62.useRef)(0);
    const scroller = ()=>document.querySelector('[data-app-scroll-container]');
    const openGuide = ()=>{
        scrollWas.current = scroller()?.scrollTop ?? window.scrollY;
        setView('explanation');
        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
    };
    const closeGuide = ()=>{
        setView('calculator');
        const y = scrollWas.current;
        requestAnimationFrame(()=>{
            const el = scroller();
            if (el) el.scrollTop = y;
            else window.scrollTo(0, y);
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            view === 'explanation' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3d2901929448dacd$var$DownsizerExplained, {
                setActivePage: setActivePage,
                onContinue: closeGuide,
                backLabel: "Back to where you were"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: view === 'explanation' ? 'hidden' : undefined,
                "aria-hidden": view === 'explanation' || undefined,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3d2901929448dacd$var$DownsizerAnalyser, {
                    setActivePage: setActivePage,
                    factFind: factFind,
                    onBack: openGuide,
                    savedStrategies: savedStrategies,
                    setSavedStrategies: setSavedStrategies,
                    setFactFind: setFactFind,
                    onSoaGenerated: onSoaGenerated
                })
            })
        ]
    });
};
var $3d2901929448dacd$export$2e2bcd8739ae039 = $3d2901929448dacd$var$DownsizerPage;


/**
 * Cashflow & Age Pension — the module for a client with no care event, on the shared spine (cashflow
 * rebuild, 21 Oct 2026; the agreed mock-up docs/ux-review/modules/cp/mockup, the village as built).
 *
 * See cashflowPensionScenario.ts for why this exists and why it is deliberately general. In short: CHSP has no
 * means test, so the care cost is an INPUT the client gives us rather than an OUTPUT we calculate, and the
 * question worth answering becomes "can we afford this, and can we do better with what we have?"
 *
 * THE SPINE, as aged care, Support at home and the village:
 *   1. Your money today — the support cost first (it changes the numbers), then the four numbers.
 *   2. What it means — why the Age Pension is what it is, the money each year, what is left to the family.
 *   3. Ways to improve it — three plain questions, then the plans that lead each goal against changing nothing,
 *      with Explain this, What could go wrong and Choose; every way side by side; "Build a plan yourself" as a
 *      link to the ledger (no mode chooser: owner, 20 Oct 2026).
 *   Then the plan page, where the module opens once a plan is chosen, and the advice document.
 *
 * THE DOOR (owner, 19 Oct 2026): Support at home's step 1 while nobody being priced is assessed; Home and the
 * menu list it only once a plan is saved, with "Start a new model" on its Home tile. `cameFrom` says which
 * door was used, so Back returns through it.
 *
 * THE PAGE NEVER HOLDS THE FILE'S OWN WRITER (a test enforces it): the support cost is the client's own figure and is
 * never written to the file. It writes through three narrow writers App gives it — the income-only tick, the
 * guaranteed-income answers, and step 3's own answers (cashflowGoalsSetter) — each for its keys alone.
 */ 


var $acw62 = parcelRequire("acw62");














/**
 * The cashflow & pension Statement of Advice, in the shared document's shape
 * (features/advice/moduleSoa.ts). Quotes the option's own snapshot and projections and the
 * change-nothing option's.
 */ 



/**
 * A cashflow & Age Pension plan in everyday words (cashflow rebuild, 21 Oct 2026; the agreed mock-up's plans
 * screen, and the village's rvPlanWords.ts).
 *
 * The engine's names ("Lifetime annuity (nil residual)", "Funeral bonds — one each") were written for an
 * adviser's list, and the review found them on the client's screen. The card says what the plan does with the
 * money, how much, and from which accounts — read from the candidate AS RUN, never from its wording. The same
 * reading gives the plan's parts (for the risks and the advice document), the money it puts out of reach (for
 * the plan choice rule), and each part's plain explanation.
 *
 * Presentation only: nothing here is computed beyond sums of the candidate's own fields.
 */ 







const $4876815f03a5e1e6$var$num = (v)=>Math.max(0, Number(v) || 0);
const $4876815f03a5e1e6$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
const $4876815f03a5e1e6$var$joinAnd = (xs)=>xs.length <= 1 ? xs[0] || '' : `${xs.slice(0, -1).join(', ')} and ${xs[xs.length - 1]}`;
const $4876815f03a5e1e6$var$cap = (s)=>s.charAt(0).toUpperCase() + s.slice(1);
function $4876815f03a5e1e6$export$7b3fc74da8f66f1(c) {
    const a = c?.annuity || {};
    const payments = c?.debtPayoff?.payments || {};
    const superClient = $4876815f03a5e1e6$var$num(c?.superContribution?.client);
    const superPartner = $4876815f03a5e1e6$var$num(c?.superContribution?.partner);
    return {
        funeralBond: $4876815f03a5e1e6$var$num(c?.funeralBondPurchase),
        gift: $4876815f03a5e1e6$var$num(c?.giftingAmount),
        annuity: $4876815f03a5e1e6$var$num(a.purchaseAmount),
        annuityType: a.annuityType === 'guaranteed' ? 'guaranteed' : 'lifetime',
        residual: Math.max(0, Math.min(1, Number(a.residualCapital) || 0)),
        superClient: superClient,
        superPartner: superPartner,
        superTotal: superClient + superPartner,
        investmentBond: $4876815f03a5e1e6$var$num(c?.investmentBond),
        debt: Object.values(payments).reduce((t, v)=>t + $4876815f03a5e1e6$var$num(v), 0)
    };
}
function $4876815f03a5e1e6$export$1555bdcd9f522821(c) {
    if (!c || c.changeNothing) return [
        'stayPut'
    ];
    const m = $4876815f03a5e1e6$export$7b3fc74da8f66f1(c);
    const kinds = [];
    if (m.superTotal > 0) kinds.push('superContribution');
    if (m.investmentBond > 0) kinds.push('investmentBond');
    if (m.annuity > 0) kinds.push(m.annuityType === 'guaranteed' ? 'annuityGuaranteed' : m.residual > 0 ? 'annuityReturned' : 'annuityNil');
    if (m.funeralBond > 0) kinds.push('funeralBond');
    if (m.gift > 0) kinds.push('gift');
    if (m.debt > 0) kinds.push('clearDebt');
    return kinds;
}
function $4876815f03a5e1e6$export$2188ff7ffabde39e(c) {
    const m = $4876815f03a5e1e6$export$7b3fc74da8f66f1(c);
    return m.funeralBond + m.gift + m.annuity;
}
function $4876815f03a5e1e6$export$ec4b9fd87c177556(c) {
    const m = $4876815f03a5e1e6$export$7b3fc74da8f66f1(c);
    const parts = [
        m.annuity > 0 ? 'the guaranteed income' : null,
        m.funeralBond > 0 ? 'the funeral bond' : null,
        m.gift > 0 ? 'the gift' : null,
        m.superTotal > 0 ? 'super' : null,
        m.investmentBond > 0 ? 'the investment bond' : null,
        m.debt > 0 ? 'repaying the debt' : null
    ].filter(Boolean);
    return parts.length ? $4876815f03a5e1e6$var$joinAnd(parts) : 'the plan';
}
function $4876815f03a5e1e6$export$4e85d1c490f63764(m) {
    if (m.annuityType === 'guaranteed') return {
        short: 'with the full amount back to the family',
        long: 'bought with life cover, so the full amount goes to the family whenever death comes'
    };
    if (m.residual > 0) return {
        short: 'with money back in the early years',
        long: 'that pays the money back to the family if death comes in the early years, falling to nothing later'
    };
    return {
        short: 'that stops at death',
        long: 'that pays the most income for life, with nothing back to the family'
    };
}
function $4876815f03a5e1e6$export$f32c8e12406086f7(c, factFind) {
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const m = $4876815f03a5e1e6$export$7b3fc74da8f66f1(c);
    const id = String(c.id || '');
    const couple = factFind?.adviceFor === 'couple';
    const clientName = factFind?.client?.firstName || (v.you ? 'you' : 'the client');
    const partnerName = factFind?.partner?.firstName || (v.you ? 'your partner' : 'the partner');
    if (c.changeNothing) return {
        title: 'Change nothing',
        sub: `Everything stays as it is today, projected over the same years. Every plan is measured against this.`
    };
    const funding = {};
    for (const s of c.fundingSources || [])funding[`${s.type}-${s.id}`] = (funding[`${s.type}-${s.id}`] || 0) + $4876815f03a5e1e6$var$num(s.amountToTake);
    const drawn = (0, $7175ce4c598409db$export$260d1042b8a534f2)(funding, factFind, 'the money');
    const from = drawn ? ` ${$4876815f03a5e1e6$var$cap(drawn)}.` : '';
    const pensionMax = /-max(-|$)/.test(id);
    // One lever, said as the card's whole title.
    const parts = [];
    if (m.annuity > 0) {
        const w = $4876815f03a5e1e6$export$4e85d1c490f63764(m);
        parts.push({
            title: `A guaranteed income for life ${w.short}`,
            sub: `Put ${$4876815f03a5e1e6$var$money(m.annuity)} into a guaranteed income for life (a lifetime annuity) ${w.long}.${pensionMax ? ' This is the amount that lifts the Age Pension most.' : ''}`
        });
    }
    if (m.funeralBond > 0) {
        const each = couple && m.funeralBond >= (0, $1abe73eeef086faf$export$aca3edb7cd7a3f17) * 2 - 1;
        parts.push({
            title: each ? 'Funeral bonds, one each' : 'A funeral bond',
            sub: `Put ${$4876815f03a5e1e6$var$money(m.funeralBond)} into ${each ? `funeral bonds, ${$4876815f03a5e1e6$var$money(m.funeralBond / 2)} each` : 'a funeral bond'}, set aside for the funeral. Centrelink stops counting it.`
        });
    }
    if (m.gift > 0) parts.push({
        title: `Give ${$4876815f03a5e1e6$var$money(m.gift)} to family`,
        sub: m.gift <= (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0) ? `Give ${$4876815f03a5e1e6$var$money(m.gift)} to family now, within the yearly free area, so Centrelink stops counting it straight away.` : `Give ${$4876815f03a5e1e6$var$money(m.gift)} to family now. Only ${$4876815f03a5e1e6$var$money((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))} a year is free; the rest still counts for five years.`
    });
    if (m.superTotal > 0) {
        const split = couple && m.superClient > 0 && m.superPartner > 0 ? `${$4876815f03a5e1e6$var$money(m.superClient)} for ${clientName} and ${$4876815f03a5e1e6$var$money(m.superPartner)} for ${partnerName}` : m.superPartner > 0 ? `for ${partnerName}` : couple ? `for ${clientName}` : '';
        parts.push({
            title: `Move ${$4876815f03a5e1e6$var$money(m.superTotal)} of savings into super`,
            sub: `Contribute ${$4876815f03a5e1e6$var$money(m.superTotal)} to super after tax${split ? `, ${split}` : ''}, where its earnings are taxed at 15% or nothing once it pays a pension, instead of at ${v.their} own rate. It stays ${v.you ? 'yours' : 'theirs'} to draw on.`
        });
    }
    if (m.investmentBond > 0) parts.push({
        title: `Move ${$4876815f03a5e1e6$var$money(m.investmentBond)} of savings into an investment bond`,
        sub: `An investment bond pays its own tax inside (30%) and nothing on ${v.their} tax return; after ten years what comes out is tax-free. Centrelink counts it like the cash it replaces.`
    });
    if (m.debt > 0) parts.push({
        title: `Pay ${$4876815f03a5e1e6$var$money(m.debt)} off ${v.their} debts`,
        sub: `Repay ${$4876815f03a5e1e6$var$money(m.debt)} of what ${v.they} owe, dearest first, so the repayments stop.`
    });
    if (parts.length === 0) return {
        title: 'Change nothing',
        sub: 'Nothing is moved.'
    };
    if (parts.length === 1) return {
        title: parts[0].title,
        sub: `${parts[0].sub}${from}`.trim()
    };
    // Two or more: the short names joined; the sub lists each one.
    const shortNames = parts.map((p, i)=>i === 0 ? p.title : p.title.charAt(0).toLowerCase() + p.title.slice(1));
    return {
        title: $4876815f03a5e1e6$var$joinAnd(shortNames),
        sub: `${parts.map((p)=>p.sub).join(' ')}${from}`.trim()
    };
}
function $4876815f03a5e1e6$export$48b7937c00a51078(c) {
    const m = $4876815f03a5e1e6$export$7b3fc74da8f66f1(c);
    const kinds = $4876815f03a5e1e6$export$1555bdcd9f522821(c);
    const amounts = {
        annuityNil: m.annuity,
        annuityReturned: m.annuity,
        annuityGuaranteed: m.annuity,
        funeralBond: m.funeralBond,
        gift: m.gift,
        superContribution: m.superTotal,
        investmentBond: m.investmentBond,
        clearDebt: m.debt
    };
    return (0, $482dbb064a59e381$export$11e6b3c860abae6f)(kinds, amounts).map((p, i)=>({
            key: `${kinds[i] ?? i}`,
            name: p.name,
            what: p.what,
            amount: p.amount ?? null
        }));
}
const $4876815f03a5e1e6$export$1dd9e721f9a6fc9c = {
    bond: {
        name: 'A funeral bond',
        what: 'Money set aside now to pay for the funeral, held by a funeral fund or insurer until it is needed.',
        centrelink: `Up to ${$4876815f03a5e1e6$var$money((0, $1abe73eeef086faf$export$aca3edb7cd7a3f17))} each is not counted at all, so it can lift the Age Pension.`,
        watch: "The money can\u2019t be taken back for anything else; above the limit it is counted like savings."
    },
    gift: {
        name: 'A gift to family, within the free area',
        what: 'Giving money to children or grandchildren now, rather than leaving it in the estate.',
        centrelink: `Up to ${$4876815f03a5e1e6$var$money((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))} a year (and ${$4876815f03a5e1e6$var$money((0, $1abe73eeef086faf$export$9cd36ea38af5a5f3))} over five years) stops counting straight away.`,
        watch: 'Anything above that still counts as yours, and is deemed to earn income, for five years, even though it has gone.'
    },
    annuity: {
        name: 'A guaranteed income for life',
        what: 'A lump sum handed to an insurer in return for a fixed income for as long as you live (a lifetime annuity).',
        centrelink: 'Only 60% of what goes in is counted at first (30% later), so it lowers what Centrelink counts more than anything else.',
        watch: 'The money is committed for life. Each type gives back a different amount to the family if death comes early; income only gives back nothing.'
    },
    super: {
        name: 'After-tax super',
        what: 'Savings put into super as an after-tax contribution, where the earnings are taxed at 15%, or not at all once it pays a pension.',
        centrelink: 'Counted and deemed like the cash it replaces, once you are of Age Pension age; so this is about tax, not the pension.',
        watch: 'Only allowed under 75, and within yearly limits set by your super balance.'
    },
    investmentBond: {
        name: 'An investment bond',
        what: 'An investment that pays its own tax inside (30%), with nothing on your tax return; after ten years what comes out is tax-free.',
        centrelink: 'Counted and deemed like the cash it replaces, so this is about tax, not the pension.',
        watch: 'Best left alone for ten years; taking money out sooner brings tax back.'
    },
    debt: {
        name: 'Paying off a debt',
        what: 'Using savings to repay what you owe, dearest first.',
        centrelink: 'Money owed against savings is already netted off, so repaying it rarely changes the pension.',
        watch: 'The repayments stop, which is money kept every year; the savings used are gone from the bank.'
    }
};
function $4876815f03a5e1e6$export$fa520b49d4c209b6(row, isCouple) {
    const pos = (0, $eec331ce661055d2$export$d318875bf548d09)(row?.socialSecurityBreakdown, Number(row?.socialSecurity) || 0, isCouple);
    if (!pos) return null;
    return {
        pension: pos.pension,
        assets: pos.assessableAssets,
        income: pos.assessableIncome,
        test: pos.determinedBy === 'income' ? 'income' : 'assets',
        perThousand: (0, $1abe73eeef086faf$export$6ca758cf677ce6c5),
        toFull: pos.shiftForFullPension,
        atFull: pos.atFullPension,
        fullOutOfReach: pos.fullOutOfReach,
        maxRate: pos.maxRate
    };
}
function $4876815f03a5e1e6$export$47e779574a8223ac(w, theirWord) {
    if (w.atFull) return `Centrelink counts ${$4876815f03a5e1e6$var$money(w.assets)} of ${theirWord} assets and ${$4876815f03a5e1e6$var$money(w.income)} a year of income, and that is within the limits for the full pension, so there is nothing more to gain on the Age Pension.`;
    if (w.test === 'income') return `Centrelink counts ${$4876815f03a5e1e6$var$money(w.assets)} of ${theirWord} assets and ${$4876815f03a5e1e6$var$money(w.income)} a year of income, and at that level the income test sets the pension. Lowering what Centrelink counts lifts it only where it also lowers the income Centrelink counts (the income it assumes savings earn).`;
    if (w.pension < 1) return `Centrelink counts ${$4876815f03a5e1e6$var$money(w.assets)} of ${theirWord} assets, more than the limit for any Age Pension, so the assets test sets it at nothing. Every $1,000 less that Centrelink counts, below that limit, would be worth about ${$4876815f03a5e1e6$var$money(w.perThousand)} a year.`;
    const full = w.toFull != null && w.toFull > 0 && !w.fullOutOfReach ? `; about ${$4876815f03a5e1e6$var$money(w.toFull)} less counted would bring the full pension` : '';
    return `Centrelink counts ${$4876815f03a5e1e6$var$money(w.assets)} of ${theirWord} assets, and at that level the assets test sets the pension. Every $1,000 less that Centrelink counts adds about ${$4876815f03a5e1e6$var$money(w.perThousand)} a year${full}.`;
}
function $4876815f03a5e1e6$export$d9301325205437f6(plan, base, c, years, v, annuityIncome = null) {
    if (!base) return [];
    const m = $4876815f03a5e1e6$export$7b3fc74da8f66f1(c);
    const out = [];
    const dE = plan.estate - base.estate;
    const dP = plan.pension - base.pension;
    const dC = plan.cashflow - base.cashflow;
    const outOfCount = [
        m.funeralBond > 0 ? `the ${$4876815f03a5e1e6$var$money(m.funeralBond)} funeral bond is not counted` : null,
        m.gift > 0 ? `the ${$4876815f03a5e1e6$var$money(m.gift)} gift ${m.gift <= (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0) ? 'stops being counted straight away' : 'stops being counted only up to the yearly limit'}` : null,
        m.annuity > 0 ? `only part of the ${$4876815f03a5e1e6$var$money(m.annuity)} guaranteed income is counted (60% at first${m.annuityType === 'guaranteed' ? ', and the life cover in full' : ''})` : null
    ].filter(Boolean);
    // The estate.
    const estateWhy = [
        m.gift > 0 ? 'the gift has already gone to the family' : null,
        m.annuity > 0 && m.annuityType !== 'guaranteed' && m.residual <= 0 ? 'nothing of the guaranteed income comes back' : null,
        m.annuity > 0 && m.annuityType !== 'guaranteed' && m.residual > 0 ? 'what comes back from the guaranteed income falls each year' : null,
        m.annuity > 0 && m.annuityType === 'guaranteed' ? 'the full amount of the guaranteed income comes back' : null,
        m.funeralBond > 0 ? 'the funeral bond pays for the funeral rather than being left to spend' : null,
        Math.abs(dP) >= 1 ? `${dP > 0 ? 'more' : 'less'} Age Pension adds up over the years` : null,
        Math.abs(dC) >= 1 ? `${dC > 0 ? 'less' : 'more'} is drawn from savings each year` : null,
        m.superTotal > 0 || m.investmentBond > 0 ? 'less tax is paid on what the money earns' : null
    ].filter(Boolean);
    out.push(Math.abs(dE) < 1 ? `What is left to the family after about ${years} years is the same as changing nothing.` : `It leaves the family ${$4876815f03a5e1e6$var$money(Math.abs(dE))} ${dE > 0 ? 'more' : 'less'} than changing nothing after about ${years} years${estateWhy.length ? `, because ${$4876815f03a5e1e6$var$joinAnd(estateWhy)}` : ''}.`);
    // The money each year.
    const cashWhy = [
        m.annuity > 0 ? `the guaranteed income pays ${annuityIncome && annuityIncome > 0 ? `about ${$4876815f03a5e1e6$var$money(annuityIncome)} a year` : 'an income every year'}` : null,
        dP >= 1 ? 'the Age Pension is higher' : dP <= -1 ? 'the Age Pension is lower' : null,
        m.debt > 0 ? 'the debt repayments stop' : null,
        m.annuity + m.funeralBond + m.gift + m.superTotal + m.investmentBond > 0 ? 'the money moved no longer earns interest in the bank' : null
    ].filter(Boolean);
    out.push(Math.abs(dC) < 1 ? 'The money each year is the same as changing nothing.' : `Each year ${v.they} ${dC > 0 ? 'have' : 'are'} ${$4876815f03a5e1e6$var$money(Math.abs(dC))} ${dC > 0 ? 'more to spend' : 'further short'} than changing nothing${cashWhy.length ? `: ${$4876815f03a5e1e6$var$joinAnd(cashWhy)}` : ''}.`);
    // The Age Pension.
    out.push(Math.abs(dP) < 1 ? `The Age Pension is the same as changing nothing${m.superTotal > 0 || m.investmentBond > 0 ? ': super and an investment bond are counted like the savings they replace, so this plan is about tax' : ''}.` : `The Age Pension is ${$4876815f03a5e1e6$var$money(Math.abs(dP))} a year ${dP > 0 ? 'higher' : 'lower'}${outOfCount.length && dP > 0 ? `, because ${$4876815f03a5e1e6$var$joinAnd(outOfCount)}, so Centrelink counts less of what ${v.they} own` : ''}.`);
    return out;
}
function $4876815f03a5e1e6$export$1e981f6e28bf53cb(c, factFind, cardAnnuity = null) {
    const a = c?.annuity || null;
    if (a && Number(a.purchaseAmount) > 0) return (0, $3d096644ffaac9d7$export$2a10947020c112ea)({
        factFind: factFind,
        residualCapital: Number(a.residualCapital) || 0,
        owner: a.ownership,
        annuityType: a.annuityType,
        indexation: a.indexation
    })?.warning ?? null;
    if (cardAnnuity && cardAnnuity.amount > 0) return (0, $3d096644ffaac9d7$export$2a10947020c112ea)({
        factFind: factFind,
        residualCapital: (Number(cardAnnuity.residualPercent) || 0) / 100,
        owner: 'client',
        annuityType: cardAnnuity.type
    })?.warning ?? null;
    return null;
}
const $4876815f03a5e1e6$export$3733ad232ff5ea09 = (rows)=>{
    const r = rows?.[0];
    return r ? {
        investmentIncome: Number(r.investmentIncome) || 0,
        tax: Number(r.tax) || 0
    } : null;
};
/**
 * EXPLAIN THIS AS AGED CARE TELLS IT (owner, 22 Oct 2026: "all modules use consistent UI"). The reasons the old
 * "Why, against changing nothing" bullets gave, said as cause → effect lines for the numbered ledger
 * (CauseEffectLedger): the Age Pension before → after and why, the guaranteed income's own payments, the
 * investment income and the tax the money moved changes (only from the plan's own projection rows — a saved card
 * keeps none, so those two lines are left out rather than guessed), and what the plan does to the family's share.
 * "Put together" (the money each year) and the "=" line (what is left) follow in the ledger itself.
 * Presentation only: every figure is the engine's own.
 */ /** Tax for the year in words: a negative figure is a refund. */ const $4876815f03a5e1e6$var$taxWords = (n)=>n < 0 ? `a refund of ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(-n))}` : (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
function $4876815f03a5e1e6$export$4e5476165fd09dec(i) {
    const { plan: plan, base: base, v: v } = i;
    const m = $4876815f03a5e1e6$export$7b3fc74da8f66f1(i.c);
    const out = [];
    const their = $4876815f03a5e1e6$var$cap(v.their);
    // The Age Pension, before → after, and what Centrelink stops counting.
    const outOfCount = [
        m.funeralBond > 0 ? `the ${$4876815f03a5e1e6$var$money(m.funeralBond)} funeral bond is not counted` : null,
        m.gift > 0 ? `the ${$4876815f03a5e1e6$var$money(m.gift)} gift ${m.gift <= (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0) ? 'stops being counted straight away' : 'stops being counted only up to the yearly limit'}` : null,
        m.annuity > 0 ? `only part of the ${$4876815f03a5e1e6$var$money(m.annuity)} guaranteed income is counted (60% at first${m.annuityType === 'guaranteed' ? ', and the life cover in full' : ''})` : null
    ].filter(Boolean);
    const taxOnly = m.superTotal > 0 || m.investmentBond > 0;
    if (!base) out.push({
        key: 'pension',
        lead: `${their} Age Pension is ${$4876815f03a5e1e6$var$money(plan.pension)} a year`,
        body: outOfCount.length ? `: ${$4876815f03a5e1e6$var$joinAnd(outOfCount)}.` : '.'
    });
    else {
        const dP = plan.pension - base.pension;
        if (Math.abs(dP) < 1) out.push({
            key: 'pension',
            lead: `${their} Age Pension stays at ${$4876815f03a5e1e6$var$money(plan.pension)} a year`,
            body: taxOnly ? ': super and an investment bond are counted like the savings they replace, so this plan is about tax.' : '.'
        });
        else if (dP > 0) {
            const after = `${outOfCount.length ? `: ${$4876815f03a5e1e6$var$joinAnd(outOfCount)}` : ''}.`;
            out.push({
                key: 'pension',
                lead: `Centrelink counts less, so ${v.their} Age Pension rises`,
                body: ` from ${$4876815f03a5e1e6$var$money(base.pension)} to ${$4876815f03a5e1e6$var$money(plan.pension)} a year${after}`,
                change: {
                    from: base.pension,
                    to: plan.pension,
                    unit: ' a year',
                    better: 'up',
                    after: after
                }
            });
        } else out.push({
            key: 'pension',
            lead: `Centrelink counts more, so ${v.their} Age Pension falls`,
            body: ` from ${$4876815f03a5e1e6$var$money(base.pension)} to ${$4876815f03a5e1e6$var$money(plan.pension)} a year.`,
            change: {
                from: base.pension,
                to: plan.pension,
                unit: ' a year',
                better: 'up',
                after: '.'
            }
        });
    }
    // The guaranteed income's own payments.
    if (m.annuity > 0) {
        const inc = Number(i.annuityIncome) || 0;
        out.push({
            key: 'annuity',
            lead: inc > 0 ? `The guaranteed income pays about ${$4876815f03a5e1e6$var$money(inc)} a year` : 'The guaranteed income pays an income every year',
            body: `, for life, on top of the Age Pension \u{2014} ${m.annuityType === 'guaranteed' ? 'and the full amount goes back to the family at death' : m.residual > 0 ? 'with money back to the family if death comes in the early years' : 'with nothing back to the family at death'}.`
        });
    }
    // Investment income and tax: only from the plan's own rows.
    if (i.first && i.baseFirst) {
        const di = i.first.investmentIncome - i.baseFirst.investmentIncome;
        if (Math.abs(di) >= 100) out.push({
            key: 'income',
            lead: di < 0 ? 'Less money stays in the bank, so investment income falls' : 'More money is invested, so investment income rises',
            body: ` from ${$4876815f03a5e1e6$var$money(i.baseFirst.investmentIncome)} to ${$4876815f03a5e1e6$var$money(i.first.investmentIncome)} in the first year.${di < 0 ? ' That is part of the cost of the plan.' : ''}`,
            change: {
                from: i.baseFirst.investmentIncome,
                to: i.first.investmentIncome,
                unit: ' in the first year',
                better: 'up',
                after: `.${di < 0 ? ' That is part of the cost of the plan.' : ''}`
            }
        });
        const dt = i.first.tax - i.baseFirst.tax;
        if (Math.abs(dt) >= 100) out.push({
            key: 'tax',
            lead: dt < 0 ? 'Less tax is paid' : 'More tax is paid',
            // A negative figure is a refund, said as one (live check, 22 Oct 2026: "-$600 … against -$2,400").
            body: ` \u{2014} ${$4876815f03a5e1e6$var$taxWords(i.first.tax)} in the first year, against ${$4876815f03a5e1e6$var$taxWords(i.baseFirst.tax)} changing nothing${dt < 0 && taxOnly ? `, because ${m.superTotal > 0 && m.investmentBond > 0 ? 'super and the investment bond pay' : m.superTotal > 0 ? 'super pays' : 'the investment bond pays'} lower tax on what the money earns than ${v.their} own rate` : ''}.`
        });
    }
    // What the plan itself does to the family's share (the "=" line gives the figure).
    const estateWhy = [
        m.gift > 0 ? 'the gift has already gone to the family' : null,
        m.annuity > 0 && m.annuityType !== 'guaranteed' && m.residual <= 0 ? 'nothing of the guaranteed income comes back' : null,
        m.annuity > 0 && m.annuityType !== 'guaranteed' && m.residual > 0 ? 'what comes back from the guaranteed income falls each year' : null,
        m.annuity > 0 && m.annuityType === 'guaranteed' ? 'the full amount of the guaranteed income comes back' : null,
        m.funeralBond > 0 ? 'the funeral bond pays for the funeral rather than being left to spend' : null
    ].filter(Boolean);
    if (estateWhy.length) out.push({
        key: 'estate',
        lead: 'For what is left to the family',
        body: `, ${$4876815f03a5e1e6$var$joinAnd(estateWhy)}.`
    });
    return out;
}



/*
 * THE GUARANTEED INCOME SECTION (owner, 21 Oct 2026 — the guaranteed income review R1–R4, mock-up screen 5): for
 * an option with a guaranteed income, the words for its type, the income and where it came from, the family
 * table year by year against changing nothing (every such option here buys it and does nothing else), the best
 * option tested without one, the assumptions, the client's dated answers and, for income only, the
 * confirmation word for word. The shared section (features/advice/soaGuaranteedIncome.ts).
 */ function $e53542c7d33c24ce$var$cpGuaranteedIncome(p, nothing, years) {
    const a = p.candidate?.annuity;
    const amount = $e53542c7d33c24ce$var$n(a?.purchaseAmount);
    if (!a || !(amount > 0)) return null;
    const owner = a.ownership === 'partner' ? 'partner' : 'client';
    const personName = (owner === 'partner' ? p.factFind?.partner?.firstName : p.factFind?.client?.firstName) || (owner === 'partner' ? 'the partner' : 'the client');
    const withAnnuity = new Set((p.candidates || []).filter((c)=>c.annuity).map((c)=>c.id));
    const without = p.all.filter((s)=>!s.error && !withAnnuity.has(s.id) && !(p.candidates == null && /annuity/i.test(String(s.id))));
    const best = without.reduce((b, s)=>!b || $e53542c7d33c24ce$var$n(s.snapshot?.estate) > $e53542c7d33c24ce$var$n(b.snapshot?.estate) ? s : b, null);
    // The best plan without one, in the screen's words (cpPlanWords); changing nothing keeps its own name.
    const altName = (s)=>{
        const c = (p.candidates || []).find((x)=>x.id === s.id);
        return s.changeNothing || !c ? s.name : (0, $4876815f03a5e1e6$export$f32c8e12406086f7)(c, p.factFind).title;
    };
    return (0, $66827b1304244a1d$export$11aaa304d9182b)({
        factFind: p.factFind,
        personName: personName,
        amount: amount,
        kind: (0, $8665f80549f60a1b$export$3ab75b1250c8af22)({
            annuityType: a.annuityType,
            residualCapital: a.residualCapital
        }),
        incomeAYear: $e53542c7d33c24ce$var$n(p.option.annuityTerms?.annualPayment) || null,
        quoted: $e53542c7d33c24ce$var$n(a.incomeOverride) > 0,
        rows: p.option.projections,
        compareRows: nothing?.projections ?? null,
        compareNote: nothing ? 'the same plan without it, the money left in savings' : null,
        horizonYears: years,
        plan: {
            estate: $e53542c7d33c24ce$var$n(p.option.snapshot?.estate),
            pension: $e53542c7d33c24ce$var$n(p.option.snapshot?.pension),
            cashflow: $e53542c7d33c24ce$var$n(p.option.snapshot?.cashflow)
        },
        alternative: best ? {
            name: altName(best),
            estate: $e53542c7d33c24ce$var$n(best.snapshot?.estate),
            pension: $e53542c7d33c24ce$var$n(best.snapshot?.pension),
            cashflow: $e53542c7d33c24ce$var$n(best.snapshot?.cashflow)
        } : null
    });
}
const $e53542c7d33c24ce$var$n = (v)=>{
    const x = typeof v === 'number' ? v : parseFloat(String(v ?? ''));
    return Number.isFinite(x) ? x : 0;
};
const $e53542c7d33c24ce$var$money = (v)=>`$${Math.round(v).toLocaleString('en-AU')}`;
function $e53542c7d33c24ce$export$3c5720c15451e6ca(p) {
    const { option: option, factFind: factFind } = p;
    const id = String(option.id || '');
    /*
     * The plan's parts from what it does when the candidate is known (a hand-built plan's id names none), else
     * from its id as before. And its words are the screen's own (cpPlanWords): the card, the plan page and the
     * document say the same thing (cashflow rebuild, 21 Oct 2026).
     */ const kinds = p.candidate ? (0, $4876815f03a5e1e6$export$1555bdcd9f522821)({
        id: id,
        ...p.candidate
    }) : (0, $203e38d6e6c434f4$export$c301be208b2d16d)(id);
    const candidateOf = (s)=>s.id === option.id && p.candidate ? {
            id: id,
            ...p.candidate
        } : (p.candidates || []).find((c)=>c.id === s.id) ?? null;
    const wordsOf = (s)=>{
        const c = candidateOf(s);
        return s.changeNothing ? {
            title: 'Changing nothing',
            sub: s.description
        } : c ? (0, $4876815f03a5e1e6$export$f32c8e12406086f7)(c, factFind) : {
            title: s.name,
            sub: s.description
        };
    };
    const words = wordsOf(option);
    const years = Number(p.legacyYears) || 10;
    const nothing = p.all.find((s)=>s.changeNothing) || null;
    const headline = {
        pension: $e53542c7d33c24ce$var$n(option.snapshot?.pension),
        cashflow: $e53542c7d33c24ce$var$n(option.snapshot?.cashflow),
        estate: $e53542c7d33c24ce$var$n(option.snapshot?.estate)
    };
    const baseline = {
        name: 'Changing nothing',
        pension: $e53542c7d33c24ce$var$n(nothing?.snapshot?.pension),
        cashflow: $e53542c7d33c24ce$var$n(nothing?.snapshot?.cashflow),
        estate: $e53542c7d33c24ce$var$n(nothing?.snapshot?.estate)
    };
    const terms = option.annuityTerms || {};
    const annuityAmount = $e53542c7d33c24ce$var$n(terms.purchaseAmount);
    const common = (0, $482dbb064a59e381$export$df893918412205e2)(factFind, {
        kind: 'cashflow_pension',
        strategySource: p.manual ? 'manual_control' : 'suggestion_engine',
        customisedFrom: p.customisedFrom ?? null,
        riskKinds: kinds
    });
    /*
     * The amounts come from the plan AS RUN — the candidate's own fields — never from its wording.
     * The first cut read them out of the description with patterns, and the descriptions carry no
     * figures for the funeral bond or the gift ("up to the exempt limit", "the yearly free area"), so
     * both were silently left out of the document; and the investment bond's description mentions
     * super ("the tax-paid home for money super can no longer take"), so the bond was listed twice,
     * once as a super contribution (review of Joe and Kim Smith's file, 18 Oct 2026).
     *
     * Each lever is read from its one field, and only where the option's kinds include it, so an
     * investment bond is classified once, as a bond.
     */ const lever = p.candidate || {};
    const has = (kind)=>kinds.includes(kind);
    const superTotal = $e53542c7d33c24ce$var$n(lever.superContribution?.client) + $e53542c7d33c24ce$var$n(lever.superContribution?.partner);
    const amounts = {
        annuityNil: annuityAmount,
        annuityReturned: annuityAmount,
        annuityGuaranteed: annuityAmount,
        funeralBond: $e53542c7d33c24ce$var$n(lever.funeralBondPurchase),
        gift: $e53542c7d33c24ce$var$n(lever.giftingAmount),
        superContribution: has('investmentBond') ? 0 : superTotal,
        investmentBond: $e53542c7d33c24ce$var$n(lever.investmentBond)
    };
    const moneyFlow = [
        ...annuityAmount > 0 ? [
            {
                label: 'Guaranteed income for life (a lifetime annuity)',
                amount: annuityAmount
            }
        ] : [],
        ...amounts.funeralBond ? [
            {
                label: 'Funeral bond',
                amount: amounts.funeralBond
            }
        ] : [],
        ...amounts.gift ? [
            {
                label: 'Gift to family',
                amount: amounts.gift
            }
        ] : [],
        ...amounts.superContribution ? [
            {
                label: 'Into super',
                amount: amounts.superContribution
            }
        ] : [],
        ...amounts.investmentBond ? [
            {
                label: 'Investment bond',
                amount: amounts.investmentBond
            }
        ] : []
    ];
    const pieces = (0, $482dbb064a59e381$export$11e6b3c860abae6f)(kinds, amounts);
    // The why on the three levers, in the screen's words (cpWhyLines), then the plain comparison.
    const why = nothing ? (0, $4876815f03a5e1e6$export$d9301325205437f6)(headline, baseline, candidateOf(option), years, (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind), $e53542c7d33c24ce$var$n(option.annuityTerms?.annualPayment) || null) : [];
    const inBrief = [
        words.sub || words.title,
        ...why.length ? why : (0, $482dbb064a59e381$export$64ada78711707257)(headline, baseline, years)
    ].filter(Boolean);
    const alternatives = p.all.filter((s)=>!s.error && (p.leaders.some((l)=>l.id === s.id) || s.id === option.id)).map((s)=>({
            name: wordsOf(s).title,
            description: wordsOf(s).sub,
            pension: $e53542c7d33c24ce$var$n(s.snapshot?.pension),
            cashflow: $e53542c7d33c24ce$var$n(s.snapshot?.cashflow),
            estate: $e53542c7d33c24ce$var$n(s.snapshot?.estate),
            selected: s.id === option.id,
            badges: p.leaders.filter((l)=>l.id === s.id).map((l)=>l.label)
        }));
    const support = p.supportCost;
    const allEvaluated = p.all.filter((s)=>!s.error && !s.changeNothing).map((s)=>({
            name: wordsOf(s).title,
            description: wordsOf(s).sub,
            pension: $e53542c7d33c24ce$var$n(s.snapshot?.pension),
            cashflow: $e53542c7d33c24ce$var$n(s.snapshot?.cashflow),
            estate: $e53542c7d33c24ce$var$n(s.snapshot?.estate),
            selected: s.id === option.id,
            badges: p.leaders.filter((l)=>l.id === s.id).map((l)=>l.label)
        }));
    const projRows = (list)=>(0, $482dbb064a59e381$export$998b1d0a26b4d727)(list, years, support ? {
            moduleCostLabel: support.label,
            moduleCost: ()=>support.annual
        } : {});
    const pensionDelta = Math.round(headline.pension - baseline.pension);
    const estateDrivers = [
        ...amounts.gift ? [
            {
                text: 'The gift leaves the estate on the day; it is in the family\'s hands now rather than later',
                amount: amounts.gift,
                sign: 'minus'
            }
        ] : [],
        ...kinds.includes('annuityNil') && annuityAmount > 0 ? [
            {
                text: 'A nil-residual annuity leaves nothing of its price to the estate; its value is the income for life',
                amount: annuityAmount,
                sign: 'minus'
            }
        ] : [],
        ...kinds.includes('annuityReturned') && annuityAmount > 0 ? [
            {
                text: 'The annuity\'s withdrawal value winds down on a set schedule; what is left at the horizon stays in the estate',
                amount: annuityAmount,
                sign: 'neutral'
            }
        ] : [],
        ...amounts.funeralBond ? [
            {
                text: 'The funeral bond is set aside for the funeral, so it is not counted and not part of what is left to spend',
                amount: amounts.funeralBond,
                sign: 'neutral'
            }
        ] : [],
        ...pensionDelta !== 0 ? [
            {
                text: `${pensionDelta > 0 ? 'More' : 'Less'} Age Pension, compounding over the ${years} years`,
                amount: Math.abs(pensionDelta),
                perYear: true,
                sign: pensionDelta > 0 ? 'plus' : 'minus'
            }
        ] : [],
        ...headline.cashflow !== baseline.cashflow ? [
            {
                text: `${headline.cashflow > baseline.cashflow ? 'Less' : 'More'} drawn from savings each year to cover the bills`,
                amount: Math.abs(Math.round(headline.cashflow - baseline.cashflow)),
                perYear: true,
                sign: headline.cashflow > baseline.cashflow ? 'plus' : 'minus'
            }
        ] : []
    ];
    const motiveNote = headline.estate < baseline.estate - 1 ? `An estate that ends behind ${baseline.name.toLowerCase()} is the price of the income and the pension this plan buys${support ? `, with ${$e53542c7d33c24ce$var$money(support.annual)} a year of ${support.label.toLowerCase()} to pay for` : ''}. The trade is money you can rely on now against money left later; the figures show the size of it, so the decision is made with eyes open.` : null;
    return {
        ...common,
        decisionIntro: `You asked how to make your money go further at home${support ? `, with ${$e53542c7d33c24ce$var$money(support.annual)} a year of ${support.label.toLowerCase()} to pay for` : ''}: lifting the Age Pension, covering the bills each year, and keeping as much as possible for the family. This advice is about the levers that do that, and what each one costs.`,
        selectedStrategyName: words.title,
        selectedStrategyDescription: words.sub,
        inOneLine: words.sub || words.title,
        inBrief: inBrief,
        pieces: pieces,
        moneyFlow: moneyFlow,
        legacyYears: years,
        headline: headline,
        baseline: baseline,
        whyItFits: (0, $482dbb064a59e381$export$64ada78711707257)(headline, baseline, years),
        estateDrivers: estateDrivers,
        motiveNote: motiveNote,
        modulePage: support ? {
            title: 'Your spending',
            intro: 'The plan has to cover these each year. Where it does not, the projections draw the shortfall from savings.',
            rows: [
                {
                    label: 'Living expenses',
                    amount: common.annualLivingExpenses,
                    note: 'a year, as you entered them'
                },
                {
                    label: support.label,
                    amount: support.annual,
                    note: 'a year'
                }
            ]
        } : null,
        moduleCostLabel: support ? support.label : '',
        projectionConvention: 'Year 1 is the first full year after the change; each later year follows it.',
        alternatives: alternatives,
        allEvaluated: allEvaluated,
        totalEvaluated: allEvaluated.length,
        projections: projRows(option.projections),
        baselineProjections: projRows(nothing?.projections),
        replacements: (0, $482dbb064a59e381$export$caf941bdb2b0342e)(kinds, moneyFlow),
        implications: [
            ...annuityAmount > 0 ? [
                {
                    title: 'The annuity needs a provider quote',
                    lead: `The ${$e53542c7d33c24ce$var$money(annuityAmount)} annuity is priced on a published rate sheet.`,
                    body: 'The income shown is an estimate. Get a quote from the insurer before buying; if it differs, re-run the analysis on the real figure.'
                }
            ] : [],
            ...amounts.gift ? [
                {
                    title: 'Gifts have a limit',
                    lead: 'Up to $10,000 a year and $30,000 over five years stops being counted.',
                    body: 'Tell Services Australia about the gift. Anything above the limit still counts as your asset, and is deemed, for five years.'
                }
            ] : [],
            {
                title: 'Tell Services Australia',
                lead: 'Each of these moves changes what is counted.',
                body: 'Report the change within 14 days so the pension is reassessed on the new figures.'
            }
        ],
        scope: {
            inScope: [
                'The levers that lift the Age Pension or free up cashflow while you stay at home, using the figures you entered.',
                ...(0, $482dbb064a59e381$export$472dfc9f05c9ea81)
            ],
            outOfScope: [
                "Moving house, a village, aged care or a granny flat \u2014 each has its own module and its own advice.",
                ...(0, $482dbb064a59e381$export$b73d600a5ab2902f)(factFind)
            ]
        },
        nextSteps: [
            ...annuityAmount > 0 ? [
                'Get a quote from an annuity provider and re-run the analysis on it.'
            ] : [],
            ...amounts.funeralBond ? [
                'Compare funeral bond providers on fees; the exemption limit is the same whichever you choose.'
            ] : [],
            ...amounts.superContribution ? [
                'Check with your super fund that the contribution can be accepted at your age and balance.'
            ] : [],
            'Tell Services Australia about each change within 14 days.',
            'Where you sell assets or trigger capital gains tax, confirm the tax with a registered tax agent before you act.'
        ],
        guaranteedIncome: $e53542c7d33c24ce$var$cpGuaranteedIncome(p, nothing, years)
    };
}






/**
 * Manual Control for Cashflow & Age Pension — move your own money, and watch the three figures.
 *
 * WHY IT IS ITS OWN ALLOCATOR rather than the shared ProceedsDeploymentFields. Every other module's
 * Manual Control deploys PROCEEDS: a lump sum a sale has just created, sitting outside the balance
 * sheet waiting to be placed. There is no sale here. The client is REARRANGING what they already
 * own, so the pool is their existing liquid assets and every dollar allocated has to leave something
 * they currently hold. Reusing an allocator built around "here is $400,000, where does it go?" would
 * have modelled money appearing from nowhere.
 *
 * IT SHARES THE ENGINE WITH THE SUGGESTION ENGINE, deliberately. A manual allocation is turned into
 * exactly the same candidate shape the engine ranks, and evaluated by the same call. Two paths to
 * one answer is how a module comes to show a client two different numbers for the same plan.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $34c3e517ec92034a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16",
            key: "jecpp"
        }
    ],
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "6",
            rx: "2",
            key: "i6l2r4"
        }
    ]
];
const $34c3e517ec92034a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("briefcase", $34c3e517ec92034a$export$3efd853dbb351e94);














function $f1faa9f80daa40f2$export$7fa517cadf59987c(factFind, owner) {
    return (0, $d08210caeacdc75a$export$7095ab72ebd46272)(factFind, owner) ? 'guaranteed' : 'lifetime';
}
const $f1faa9f80daa40f2$export$61deebe6e8d12f2f = 50000;
const $f1faa9f80daa40f2$export$e63473be6d7e0dc0 = 50000;
const $f1faa9f80daa40f2$var$LEVERS = [
    {
        key: 'funeralBond',
        icon: (0, $e325251f2797f6cf$export$2e2bcd8739ae039),
        label: 'Into a funeral bond',
        help: 'Exempt from the assets test up to the published limit per person, and it pays for something the family would fund anyway. Above the limit it is counted like any other asset.'
    },
    {
        key: 'gift',
        icon: (0, $6315759428919b56$export$2e2bcd8739ae039),
        label: 'Given away',
        help: "Inside the yearly free area it leaves the assets test straight away. Above it, the excess is still counted \u2014 and still deemed to earn income \u2014 for five years, even though the money has gone."
    },
    {
        key: 'annuity',
        icon: (0, $c42d182890f3ecf5$export$2e2bcd8739ae039),
        label: 'Into a lifetime annuity',
        help: 'Only 60% of the purchase price is assessed as an asset, so it moves more than anything else here. How much of the capital stays available depends on the shape you pick below.'
    },
    {
        key: 'superContribution',
        icon: (0, $05565f19ab398c04$export$2e2bcd8739ae039),
        label: 'Into super, after tax',
        help: `${(0, $4876815f03a5e1e6$export$1dd9e721f9a6fc9c).super.what} ${(0, $4876815f03a5e1e6$export$1dd9e721f9a6fc9c).super.centrelink} ${(0, $4876815f03a5e1e6$export$1dd9e721f9a6fc9c).super.watch}`
    },
    {
        key: 'investmentBond',
        icon: (0, $34c3e517ec92034a$export$2e2bcd8739ae039),
        label: 'Into an investment bond',
        help: `${(0, $4876815f03a5e1e6$export$1dd9e721f9a6fc9c).investmentBond.what} ${(0, $4876815f03a5e1e6$export$1dd9e721f9a6fc9c).investmentBond.centrelink} ${(0, $4876815f03a5e1e6$export$1dd9e721f9a6fc9c).investmentBond.watch}`
    },
    {
        key: 'debtRepayment',
        icon: (0, $1299b0a605d22052$export$2e2bcd8739ae039),
        label: 'Off your debt',
        help: "Repaying debt does not change your net worth on its own, but it frees the repayments \u2014 which is cashflow you keep every year."
    }
];
function $f1faa9f80daa40f2$export$d0d5cbe98357a270({ factFind: factFind, sources: sources, allocation: allocation, onChange: onChange, totalDebt: totalDebt, annuityTerms: annuityTerms, onAnnuityTermsChange: onAnnuityTermsChange, onIncomeOnlyUnderstoodChange: onIncomeOnlyUnderstoodChange, incomeOnlyUnderstood: incomeOnlyUnderstood, reserve: reserve = $f1faa9f80daa40f2$export$61deebe6e8d12f2f }) {
    /** The most each person may put into super after tax now, between them (the engine caps it the same way). */ const superRoom = (0, $acw62.useMemo)(()=>{
        try {
            return (0, $996111778bb35e70$export$3156faa588d94c0c)(factFind).total;
        } catch  {
            return 0;
        }
    }, [
        factFind
    ]);
    /*
     * What can be moved is what the accounts hold LESS the emergency money kept back (live review, 22 Oct 2026:
     * "Still unallocated $50,000" sat under the ledger's "Still free to place $0" — the reserve, counted twice).
     */ const available = Math.max(0, sources.reduce((sum, s)=>sum + s.value, 0) - Math.max(0, reserve));
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    /** The money the options size a guaranteed income against (above the emergency money), for the ceiling caution. */ const annuityInvestable = (0, $acw62.useMemo)(()=>(0, $cc855f77b4e7e2d7$export$54e72ca193834515)(factFind).amount, [
        factFind
    ]);
    const clientAge = (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind?.client?.dob);
    const partnerAge = factFind?.adviceFor === 'couple' ? (0, $5589d9476399db47$export$8ada184d5eef4694)(factFind?.partner?.dob) : null;
    /*
     * The configurator speaks `AnnuityDetails`; this module stores the four terms plus the quote.
     * Adapted in both directions here rather than widening the module's own state to the
     * configurator's shape — the amount belongs to the slider, and only these five fields are the
     * client's to set.
     */ const annuityFundingSources = (0, $acw62.useMemo)(()=>sources.map((source)=>({
                id: `${source.type}-${source.id}`,
                type: source.type,
                assetId: source.id,
                label: `${source.description} \u{2014} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(source.value)} available`,
                available: source.value
            })), [
        sources
    ]);
    const annuityDetails = (0, $acw62.useMemo)(()=>({
            annuityType: annuityTerms.annuityType === 'guaranteed' ? 'guaranteed' : 'lifetime',
            purchaseAmount: allocation.annuity,
            residualCapital: annuityTerms.residualCapital,
            termYears: null,
            indexation: annuityTerms.indexation,
            reversionary: annuityTerms.reversionary,
            owner: annuityTerms.owner,
            incomeOverride: annuityTerms.incomeOverride,
            fundingSource: annuityFundingSources[0] || null
        }), [
        allocation.annuity,
        annuityTerms,
        annuityFundingSources
    ]);
    const applyAnnuityDetails = (updater)=>{
        const next = typeof updater === 'function' ? updater(annuityDetails) : updater;
        onAnnuityTermsChange({
            residualCapital: Math.max(0, Math.min(1, Number(next.residualCapital) || 0)),
            owner: next.owner || 'client',
            reversionary: !!next.reversionary,
            indexation: !!next.indexation,
            incomeOverride: next.incomeOverride != null && Number.isFinite(Number(next.incomeOverride)) ? Number(next.incomeOverride) : null,
            // The full-amount-back card sets the type; the plain cards set it back to a lifetime annuity.
            annuityType: next.annuityType === 'guaranteed' ? 'guaranteed' : 'lifetime'
        });
    };
    /*
     * The live outcome, built the SAME way the engine builds it, so the income shown beside the
     * controls is the income the projection runs on.
     */ const annuitySummary = (0, $acw62.useMemo)(()=>{
        if (!(allocation.annuity >= $f1faa9f80daa40f2$export$e63473be6d7e0dc0)) return null;
        try {
            const record = (0, $f7f7b62814c3b615$export$fb67395f10ad20c9)(factFind, {
                annuityType: annuityTerms.annuityType === 'guaranteed' ? 'guaranteed' : 'lifetime',
                purchaseAmount: allocation.annuity,
                age: clientAge ?? 70,
                partnerAge: annuityTerms.owner === 'joint' || annuityTerms.reversionary ? partnerAge : null,
                indexation: annuityTerms.indexation,
                residualCapital: annuityTerms.residualCapital,
                owner: annuityTerms.owner,
                reversionary: annuityTerms.reversionary,
                incomeOverride: annuityTerms.incomeOverride
            });
            return (0, $f7f7b62814c3b615$export$fc6c67b5fdf45998)(record);
        } catch  {
            return null;
        }
    }, [
        factFind,
        allocation.annuity,
        annuityTerms,
        clientAge,
        partnerAge
    ]);
    const allocated = (0, $2663acaa6cb9dd5e$export$cdf8b234292e0c72)(allocation);
    const remaining = available - allocated;
    const people = factFind?.adviceFor === 'couple' ? 2 : 1;
    const bondLimit = (0, $1abe73eeef086faf$export$aca3edb7cd7a3f17) * people;
    const set = (key, value)=>{
        /*
         * A NEW GUARANTEED INCOME STARTS AS "MONEY BACK" (owner, 21 Oct 2026), as the village's does — or as the
         * full amount back at any time where the person may buy it (in or entering care, or receiving support
         * at home: the guaranteed income review M1, mock-up screen 6). Only when money first goes into it: an
         * annuity already holding money keeps the shape chosen or saved. Never income only.
         */ if (key === 'annuity' && !(allocation.annuity > 0) && (value ?? 0) > 0) {
            const startType = $f1faa9f80daa40f2$export$7fa517cadf59987c(factFind, annuityTerms.owner);
            if (annuityTerms.residualCapital !== (0, $2663acaa6cb9dd5e$export$8a567aa13eab014b).residualCapital || (annuityTerms.annuityType ?? 'lifetime') !== startType) onAnnuityTermsChange({
                ...annuityTerms,
                residualCapital: (0, $2663acaa6cb9dd5e$export$8a567aa13eab014b).residualCapital,
                annuityType: startType
            });
        }
        onChange({
            ...allocation,
            [key]: Math.max(0, value ?? 0)
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-2xl border border-slate-200/70 bg-white p-5 shadow-card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-4 flex flex-wrap items-baseline justify-between gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-base font-bold text-gray-800",
                                        children: "Move your money"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-0.5 text-sm text-slate-600",
                                        children: [
                                            v.Names,
                                            " ",
                                            v.have,
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(available)
                                            }),
                                            " to move after the ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(reserve),
                                            " kept for emergencies \u2014 cash, term deposits and shares. ",
                                            v.Possessive,
                                            " home and super pension aren't included."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-right",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-[11px] font-semibold uppercase tracking-wide text-slate-500",
                                        children: "Still unallocated"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: `text-xl font-bold tabular-nums ${remaining < 0 ? 'text-red-600' : 'text-gray-900'}`,
                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(remaining)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "space-y-3",
                        children: $f1faa9f80daa40f2$var$LEVERS.filter((lever)=>(lever.key !== 'debtRepayment' || totalDebt > 0) && (lever.key !== 'superContribution' || superRoom > 0 || Number(allocation.superContribution) > 0)).map((lever)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "rounded-xl border border-slate-200 bg-slate-50/60 p-3.5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-wrap items-start gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                                icon: lever.icon,
                                                tone: "brand",
                                                variant: "soft",
                                                size: "sm"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "min-w-0 flex-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-sm font-bold text-gray-800",
                                                        children: lever.label
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "mt-0.5 text-xs leading-relaxed text-slate-500",
                                                        children: lever.help
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-44 shrink-0",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                    label: "",
                                                    value: allocation[lever.key] || '',
                                                    onChange: (v)=>set(lever.key, v),
                                                    className: ""
                                                })
                                            })
                                        ]
                                    }),
                                    lever.key === 'funeralBond' && allocation.funeralBond > bondLimit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-2 rounded-lg bg-white border border-slate-200 border-l-4 border-l-amber-400 px-3 py-2 text-xs text-slate-700",
                                        children: [
                                            "Only ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(bondLimit)
                                            }),
                                            " is exempt",
                                            people > 1 ? ' between you' : '',
                                            ". The",
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(allocation.funeralBond - bondLimit)
                                            }),
                                            " above that is counted like any other asset \u2014 you would be locking money away for no means-test gain."
                                        ]
                                    }),
                                    lever.key === 'gift' && allocation.gift > (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-2 rounded-lg bg-white border border-slate-200 border-l-4 border-l-amber-400 px-3 py-2 text-xs text-slate-700",
                                        children: [
                                            "Above the ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))
                                            }),
                                            " yearly free area, the extra ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(allocation.gift - (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0))
                                            }),
                                            " is still counted as yours \u2014 and still deemed to earn income \u2014 for ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "five years"
                                            }),
                                            ". The money is gone; the means test has not noticed."
                                        ]
                                    }),
                                    lever.key === 'annuity' && allocation.annuity > 0 && allocation.annuity < $f1faa9f80daa40f2$export$e63473be6d7e0dc0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-2 rounded-lg bg-white border border-slate-200 border-l-4 border-l-amber-400 px-3 py-2 text-xs text-slate-700",
                                        children: [
                                            "Providers don't generally write lifetime annuities below",
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)($f1faa9f80daa40f2$export$e63473be6d7e0dc0)
                                            }),
                                            ", so we haven't modelled this one. Raise it, or put the money somewhere else on this page."
                                        ]
                                    }),
                                    lever.key === 'annuity' && allocation.annuity >= $f1faa9f80daa40f2$export$e63473be6d7e0dc0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-2 space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a72ca5744dce23c$export$2e2bcd8739ae039), {
                                                factFind: factFind,
                                                annuityDetails: annuityDetails,
                                                setAnnuityDetails: applyAnnuityDetails,
                                                annuitySummary: annuitySummary,
                                                annuityWarnings: [],
                                                fundingSources: annuityFundingSources,
                                                formatCurrency: (0, $f94e45ac645ae232$export$3dc27271f5d5c629),
                                                clientAge: clientAge,
                                                partnerAge: partnerAge,
                                                onIncomeOnlyUnderstoodChange: onIncomeOnlyUnderstoodChange,
                                                incomeOnlyUnderstood: incomeOnlyUnderstood,
                                                // Above the client's ceiling, a caution (not a block): a share of the money the options size against.
                                                ceilingInvestable: annuityInvestable
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6421482343679f4$export$9f9fb1aea9338121), {
                                                purchaseAmount: allocation.annuity,
                                                residualPercent: Math.round(Math.max(0, Math.min(1, annuityTerms.residualCapital)) * 100),
                                                ownerName: annuityTerms.owner === 'partner' ? factFind?.partner?.firstName || 'your partner' : factFind?.client?.firstName || 'you',
                                                partnerName: factFind?.adviceFor === 'couple' ? annuityTerms.owner === 'partner' ? factFind?.client?.firstName || 'you' : factFind?.partner?.firstName || 'your partner' : null,
                                                /* A jointly owned annuity keeps paying the survivor by its ownership. */ reversionary: annuityTerms.owner === 'joint' || annuityTerms.reversionary,
                                                indexed: annuityTerms.indexation,
                                                annuityType: annuityTerms.annuityType === 'guaranteed' ? 'guaranteed' : 'lifetime',
                                                annualPayment: Number(annuitySummary?.annualPayment) || null
                                            })
                                        ]
                                    }),
                                    lever.key === 'superContribution' && (Number(allocation.superContribution) || 0) > superRoom && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-2 rounded-lg bg-white border border-slate-200 border-l-4 border-l-amber-400 px-3 py-2 text-xs text-slate-700",
                                        "data-testid": "cp-super-over-cap",
                                        children: [
                                            "Only ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(superRoom)
                                            }),
                                            " can go into super after tax now. The rest stays in the bank."
                                        ]
                                    }),
                                    lever.key === 'debtRepayment' && allocation.debtRepayment > totalDebt && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-2 rounded-lg bg-white border border-slate-200 border-l-4 border-l-amber-400 px-3 py-2 text-xs text-slate-700",
                                        children: [
                                            "You only owe ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(totalDebt)
                                            }),
                                            "."
                                        ]
                                    })
                                ]
                            }, lever.key))
                    })
                ]
            }),
            remaining < 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bc32c6ef2e03125$export$2e2bcd8739ae039), {
                tone: "caution",
                heading: "That is more than you have",
                icon: (0, $00824d397ec63c04$export$2e2bcd8739ae039),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        "You have allocated ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(allocated)
                        }),
                        " from",
                        ' ',
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(available)
                        }),
                        ". Reduce something before the figures below mean anything."
                    ]
                })
            }),
            remaining >= 0 && remaining < reserve && allocated > 0 && /*
                 * Not a block — an adviser may have good reason. But someone paying for help at home
                 * needs money they can reach this month, and every lever here locks capital away to
                 * some degree: a gift is gone, a bond is untouchable until death, an annuity is
                 * committed for life. Improving a means test while leaving nothing accessible is a
                 * bad outcome the numbers alone would report as a win.
                 */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bc32c6ef2e03125$export$2e2bcd8739ae039), {
                tone: "caution",
                heading: "Very little left to hand",
                icon: (0, $00824d397ec63c04$export$2e2bcd8739ae039),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        "This leaves ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(remaining)
                        }),
                        " you can actually reach. A gift is gone, a funeral bond can't be touched, and an annuity is committed for life \u2014 so keeping something accessible matters more than the last bit of pension."
                    ]
                })
            })
        ]
    });
}
var $f1faa9f80daa40f2$export$2e2bcd8739ae039 = $f1faa9f80daa40f2$export$d0d5cbe98357a270;







/**
 * The chosen cashflow & Age Pension plan, as the plan page and Home read it (cashflow rebuild, 21 Oct 2026 —
 * the village's rvChosenPlan.ts and Support at home's sahChosenPlan.ts).
 *
 * The card the client chose is stored on the record: its three figures, changing nothing's at the time, the
 * plan in words, its parts and pieces, the support cost and the years it was priced on. So the plan page shows
 * exactly what was chosen, with no re-run in between, and a later change of support cost can be said against
 * it ("priced on $12,000").
 */ const $94964a4bbfeb638b$export$ee6e400ca50ecedf = 'careCompanionCpStartFresh';
function $94964a4bbfeb638b$export$ce1dae2ac0d07e63(list) {
    return (list || []).find((s)=>s?.type === 'cashflow_pension' && s.chosen === true) ?? null;
}
function $94964a4bbfeb638b$export$d0bed6e7d13194fc(record) {
    const card = record?.inputs?.card;
    return card && typeof card === 'object' && card.plan ? card : null;
}
function $94964a4bbfeb638b$export$b352889aabc51046(key) {
    try {
        const v = window.sessionStorage.getItem(key);
        if (v) window.sessionStorage.removeItem(key);
        return !!v;
    } catch  {
        return false;
    }
}
function $94964a4bbfeb638b$export$5cbbd0676ba1975c(card, currentAnnual) {
    if (!card) return false;
    return Math.round(Number(card.support?.annual) || 0) !== Math.round(Number(currentAnnual) || 0);
}


/**
 * Step 1 — your money today (cashflow rebuild, 21 Oct 2026; the agreed mock-up's j1-step1 and j2-step1).
 *
 * THE SUPPORT COST FIRST, because it changes the numbers (review, 18 Oct 2026: it was asked after the four
 * cards, which then changed under the reader). It is the client's own figure from the provider's invoices: we
 * can't work it out, and it is never written to the file. Then the four numbers, each with its "why?": the Age
 * Pension, what is left over (or short) each year, what they own, and what is left to the family after about
 * ten years — with "why 10?" and the one control for the years (the review: "Estate in [N] years" and "Project
 * over" were two controls for one setting).
 *
 * A returning client who changes the support cost is told the plans are re-tested, and that the chosen plan
 * was priced on the old figure and stays chosen until they choose again (j2-step1).
 */ 

var $acw62 = parcelRequire("acw62");





/**
 * Small pieces the cashflow & Age Pension screens share (cashflow rebuild, 21 Oct 2026): the engine's own
 * working rendered as it comes, a number tile, the link and card classes.
 */ 
parcelRequire("acw62");

const $db27db5ed814451d$export$9c30223ca0a664fb = 'font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy';
const $db27db5ed814451d$export$f038740a94d131a9 = 'font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900';
const $db27db5ed814451d$export$aa3e815946b80764 = 'rounded-2xl border border-slate-200 bg-white p-6 shadow-card';
const $db27db5ed814451d$export$e17a63917e2ebf0f = 'text-[13px] font-semibold text-brand-navy';
const $db27db5ed814451d$export$5517df3497010beb = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
const $db27db5ed814451d$export$a785de3a2a8dd1aa = (n)=>`${n >= 0 ? '+' : "\u2212"}${$db27db5ed814451d$export$5517df3497010beb(Math.abs(n))}`;
const $db27db5ed814451d$export$202882938379ba30 = (n)=>n < 0 ? `short ${$db27db5ed814451d$export$5517df3497010beb(-n)}` : `${$db27db5ed814451d$export$5517df3497010beb(n)} to spare`;
const $db27db5ed814451d$export$c8225646f50a07d8 = ({ rows: rows })=>{
    if (!rows?.length) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "text-slate-500",
        children: "No working available for this figure."
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "space-y-0.5",
        children: rows.map((row, i)=>{
            const heading = /^-{2,}\s*(.+?)\s*-{2,}$/.exec(String(row.label));
            if (heading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 border-t border-slate-200 pt-2 text-[12px] font-semibold text-slate-600 first:mt-0 first:border-0 first:pt-0",
                children: heading[1]
            }, i);
            if (row.value === '' || row.value == null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-slate-500",
                children: row.label
            }, i);
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `flex items-baseline justify-between gap-4 ${row.emphasis ? 'font-semibold text-slate-800' : ''}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: row.label
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "shrink-0 tabular-nums",
                        children: typeof row.value === 'number' ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(row.value) : row.value
                    })
                ]
            }, i);
        })
    });
};
const $db27db5ed814451d$export$235cb65c20ad2b7 = ({ label: label, value: value, unit: unit, caption: caption, tone: tone, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-card",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[13px] font-semibold text-slate-500",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: `mt-1 text-[28px] font-bold leading-none tabular-nums tracking-tight ${tone === 'good' ? 'text-emerald-700' : tone === 'bad' ? 'text-rose-700' : 'text-slate-900'}`,
                children: [
                    value,
                    unit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ml-1 text-[13px] font-semibold text-slate-500",
                        children: unit
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-[12.5px] leading-snug text-slate-500",
                children: caption
            })
        ]
    });
const $db27db5ed814451d$export$ecef4fbbe3ba5fa1 = 'Ten years is long enough to see what a choice does to what is left to the family and to the money each year, and short enough for the figures to still mean something. Every plan is tested over the same years, so they compare fairly. You can change it.';


const $6cbd45224d06260b$var$CpStep1 = ({ factFind: factFind, supportAnnual: supportAnnual, onSupportAnnual: onSupportAnnual, supportLabel: supportLabel, onSupportLabel: onSupportLabel, supportCost: supportCost, position: position, loading: loading, error: error, legacyYears: legacyYears, onLegacyYears: onLegacyYears, chosenCard: chosenCard, onWhy: onWhy, onNext: onNext })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const [whyTen, setWhyTen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const current = supportCost?.annual ?? 0;
    const changed = (0, $94964a4bbfeb638b$export$5cbbd0676ba1975c)(chosenCard, current);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        "data-testid": "cp-step1",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $db27db5ed814451d$export$aa3e815946b80764),
                "data-testid": "cp-support-cost",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: (0, $db27db5ed814451d$export$e17a63917e2ebf0f),
                        children: v.you ? 'Do you already pay for help at home?' : `${v.couple ? 'Do' : 'Does'} ${v.names} already pay for help at home?`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1 text-[15px] leading-relaxed text-slate-700",
                        children: [
                            "Cleaning, meals, transport, personal care: if ",
                            v.names,
                            " pay",
                            v.s,
                            " for any of it, put the yearly cost here. ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    "We can't work this out for ",
                                    v.them
                                ]
                            }),
                            ": these fees are set by each provider, so the figure comes from ",
                            v.their,
                            " provider or ",
                            v.their,
                            " invoices. Leave it empty if there is none."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3 flex flex-wrap items-end gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "w-48",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                    label: "Yearly cost",
                                    value: supportAnnual,
                                    onChange: (x)=>onSupportAnnual(x ?? ''),
                                    className: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "pb-2.5 text-[14px] text-slate-500",
                                children: "a year, for"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "min-w-[14rem] flex-1 sm:max-w-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "mb-1 block text-sm font-medium text-gray-700",
                                        htmlFor: "cp-support-label",
                                        children: "What it is for"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        id: "cp-support-label",
                                        type: "text",
                                        value: supportLabel,
                                        onChange: (e)=>onSupportLabel(e.target.value),
                                        className: "w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-brand-blue focus:ring-2 focus:ring-brand-blue"
                                    })
                                ]
                            })
                        ]
                    }),
                    supportCost && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-3 text-[14px] leading-relaxed text-slate-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: v.you ? 'You told us' : 'We were told'
                            }),
                            " ",
                            supportLabel.toLowerCase(),
                            " costs ",
                            (0, $db27db5ed814451d$export$5517df3497010beb)(supportCost.annual),
                            " a year. The numbers below include it.",
                            ' ',
                            "Paying for support does ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "not"
                            }),
                            " change ",
                            v.possessive,
                            " Age Pension \u2014 that is assessed on what ",
                            v.they,
                            " own and earn, not on what ",
                            v.they,
                            " spend. It changes only what is left over each year."
                        ]
                    })
                ]
            }),
            changed && chosenCard && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700",
                "data-testid": "cp-support-changed",
                children: [
                    "The four numbers and the plans are re-tested with ",
                    (0, $db27db5ed814451d$export$5517df3497010beb)(current),
                    " a year of support. ",
                    v.Possessive,
                    " chosen plan was priced on ",
                    (0, $db27db5ed814451d$export$5517df3497010beb)(chosenCard.support.annual),
                    ", and stays chosen until ",
                    v.they,
                    " choose again on step 3; the advice document will use the new cost once ",
                    v.they,
                    " do."
                ]
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] text-slate-700",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                        className: "text-slate-900",
                        children: [
                            "We couldn't work out ",
                            v.possessive,
                            " position."
                        ]
                    }),
                    " ",
                    error,
                    " This usually means something in ",
                    v.possessive,
                    " profile is incomplete: check ",
                    v.their,
                    " assets and income, then come back."
                ]
            }),
            loading && !position && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-xl border border-dashed border-slate-300 bg-white px-4 py-6 text-center text-[14px] text-slate-600",
                children: [
                    "Working out ",
                    v.possessive,
                    " position\u2026"
                ]
            }),
            position && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4",
                        "data-testid": "cp-four-numbers",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db27db5ed814451d$export$235cb65c20ad2b7), {
                                label: "Age Pension",
                                value: (0, $db27db5ed814451d$export$5517df3497010beb)(position.agePension),
                                unit: "a year",
                                caption: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        v.couple ? v.you ? 'for the two of you' : 'for the two of them' : 'a year',
                                        " \xb7 ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: onWhy,
                                            className: (0, $db27db5ed814451d$export$f038740a94d131a9),
                                            children: "why?"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db27db5ed814451d$export$235cb65c20ad2b7), {
                                label: position.cashFlow < 0 ? 'Each year, short by' : 'Left over each year',
                                value: (0, $db27db5ed814451d$export$5517df3497010beb)(Math.abs(position.cashFlow)),
                                tone: position.cashFlow < 0 ? 'bad' : 'good',
                                caption: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        supportCost ? `after the ${(0, $db27db5ed814451d$export$5517df3497010beb)(supportCost.annual)} of support` : 'money in, less money out',
                                        " \xb7 ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: onWhy,
                                            className: (0, $db27db5ed814451d$export$f038740a94d131a9),
                                            children: "why?"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db27db5ed814451d$export$235cb65c20ad2b7), {
                                label: `What ${v.they} own`,
                                value: (0, $db27db5ed814451d$export$5517df3497010beb)(position.netWorth),
                                caption: `less what ${v.they} owe, today`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db27db5ed814451d$export$235cb65c20ad2b7), {
                                label: "Left to the family",
                                value: (0, $db27db5ed814451d$export$5517df3497010beb)(position.estate),
                                testId: "cp-estate-tile",
                                caption: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9873a6fbc9fd360$export$68741d4d7bc37a6d), {
                                            years: legacyYears,
                                            onChange: onLegacyYears,
                                            before: "after about"
                                        }),
                                        " \xb7 ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>setWhyTen((o)=>!o),
                                            "aria-expanded": whyTen,
                                            className: (0, $db27db5ed814451d$export$f038740a94d131a9),
                                            "data-testid": "cp-why-ten",
                                            children: [
                                                "why ",
                                                legacyYears,
                                                "?"
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    whyTen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "rounded-xl border border-slate-200 border-l-4 border-l-blue-500 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700",
                        "data-testid": "cp-why-ten-words",
                        children: (0, $db27db5ed814451d$export$ecef4fbbe3ba5fa1)
                    }),
                    position.shortfallYear != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700",
                        "data-testid": "cp-runs-short",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                className: "text-slate-900",
                                children: [
                                    "On these figures the savings can no longer cover the gap from about year ",
                                    position.shortfallYear,
                                    "."
                                ]
                            }),
                            " Not a prediction, but the point worth planning around. The next step shows where the money comes from until then."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-wrap items-center justify-end gap-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    type: "button",
                    onClick: onNext,
                    disabled: !position,
                    "data-testid": "cp-step1-next",
                    className: "inline-flex h-11 items-center gap-2 rounded-lg bg-blue-600 hover:bg-blue-700 px-5 text-[14px] font-semibold text-white shadow-sm disabled:cursor-not-allowed disabled:opacity-50",
                    children: [
                        "Why the numbers are what they are ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                            size: 16
                        })
                    ]
                })
            })
        ]
    });
};
var $6cbd45224d06260b$export$2e2bcd8739ae039 = $6cbd45224d06260b$var$CpStep1;


/**
 * Step 2 — what the numbers mean (cashflow rebuild, 21 Oct 2026; the agreed mock-up's "Why the Age Pension is
 * what it is", with the cashflow and the estate beside it).
 *
 *  - WHY THE AGE PENSION IS WHAT IT IS (owner ruling, every module): which test sets it, what Centrelink
 *    counts, what every $1,000 moved out of the count is worth, and how much would bring the full pension.
 *    Read from the engine's own breakdown; Centrelink's working is one fold away.
 *  - THE MONEY EACH YEAR: money in, money out, line by line; and where a shortfall is met from, account by
 *    account and in the engine's order (the money story every module's Explain this tells).
 *  - WHAT THEY OWN AND LEAVE: today's net worth, line by line, and how the estate figure is reached.
 *
 * One source, as before: the pension and cashflow are the first projected year WITH the support cost; what
 * they own today is the run WITHOUT it (paying for support next year cannot change what they own now).
 */ 

var $acw62 = parcelRequire("acw62");









const $7ace27ec3f1c2144$var$Fold = ({ label: label, children: children, testId: testId })=>{
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-4 border-t border-slate-200 pt-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: ()=>setOpen((o)=>!o),
                "aria-expanded": open,
                className: "inline-flex items-center gap-1.5 text-[13px] font-semibold text-blue-700 hover:text-blue-900",
                "data-testid": testId,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                        size: 15,
                        className: `transition-transform ${open ? 'rotate-180' : ''}`
                    }),
                    " ",
                    open ? 'Hide' : label
                ]
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-3 text-[13px] leading-relaxed text-slate-600 md:columns-2 md:gap-8",
                children: children
            })
        ]
    });
};
const $7ace27ec3f1c2144$var$CpStep2 = ({ factFind: factFind, first: first, todayFirst: todayFirst, years: years, position: position, supportCost: supportCost, legacyYears: legacyYears, onBack: onBack, onNext: onNext, onAssumptions: onAssumptions })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const isCouple = factFind?.adviceFor === 'couple';
    const why = (0, $4876815f03a5e1e6$export$fa520b49d4c209b6)(first, isCouple);
    const rows = years || [];
    const story = rows.length && (0, $0fe89e03b6df746e$export$693cc3146baa3244)(rows).hasDeficit ? (0, $2ddaae90639b5011$export$bdea18f456fd84b)({
        rows: rows,
        factFind: factFind,
        runway: (0, $0fe89e03b6df746e$export$464558962ff4a811)(rows, rows.length),
        deposit: {
            paid: 0,
            refundTo: ''
        },
        horizonYears: legacyYears,
        enteringName: factFind?.client?.firstName || 'The household',
        spentOn: 'the plan'
    }) : null;
    if (!position) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-xl border border-dashed border-slate-300 bg-white px-4 py-6 text-center text-[14px] text-slate-600",
        children: [
            "Working out ",
            v.possessive,
            " position\u2026"
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        "data-testid": "cp-step2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $db27db5ed814451d$export$aa3e815946b80764),
                "data-testid": "cp-why-pension",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: (0, $db27db5ed814451d$export$e17a63917e2ebf0f),
                        children: [
                            "Why ",
                            v.possessive,
                            " Age Pension is ",
                            (0, $db27db5ed814451d$export$5517df3497010beb)(position.agePension),
                            " a year"
                        ]
                    }),
                    why ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-2 text-[16px] leading-relaxed text-slate-800",
                        "data-testid": "cp-why-pension-words",
                        children: (0, $4876815f03a5e1e6$export$47e779574a8223ac)(why, v.their)
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 text-[15px] leading-relaxed text-slate-700",
                        children: [
                            "Centrelink's working isn't available on ",
                            v.possessive,
                            " figures \u2014 usually because no one on the file is of Age Pension age yet."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63f0f38d9f9fe7ac$export$28c8139bd562d0e), {
                        eyebrow: `Where ${v.names} stand${v.s} today`,
                        className: "mt-4 border-0 bg-transparent p-0 shadow-none",
                        collapsible: true,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eec331ce661055d2$export$836922263996c16c), {
                            careDepositRelevant: Boolean(factFind?.goals?.aged_care),
                            financials: first,
                            isCouple: isCouple,
                            name: v.names,
                            whereNext: "The plans on the next step"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($7ace27ec3f1c2144$var$Fold, {
                        label: "See Centrelink's working",
                        testId: "cp-pension-working",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db27db5ed814451d$export$c8225646f50a07d8), {
                                rows: first?.socialSecurityBreakdown
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-3 border-t border-slate-200 pt-3 text-slate-500",
                                children: [
                                    "Centrelink works out both tests and pays whichever gives the ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "lower"
                                    }),
                                    " amount."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $db27db5ed814451d$export$aa3e815946b80764),
                "data-testid": "cp-money-each-year",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: (0, $db27db5ed814451d$export$e17a63917e2ebf0f),
                        children: [
                            v.Possessive,
                            " money each year"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 text-[16px] leading-relaxed text-slate-800",
                        children: [
                            "Money in, less money out, over the next twelve months: ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: position.cashFlow < 0 ? 'text-rose-700' : 'text-emerald-700',
                                children: (0, $db27db5ed814451d$export$202882938379ba30)(position.cashFlow)
                            }),
                            supportCost ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    ", after ",
                                    (0, $db27db5ed814451d$export$5517df3497010beb)(supportCost.annual),
                                    " a year of ",
                                    supportCost.label.toLowerCase()
                                ]
                            }) : null,
                            ".",
                            position.cashFlow < 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: " The gap is met from savings. That is not automatically wrong \u2014 it is what savings are for \u2014 but it is worth seeing where it comes from."
                            })
                        ]
                    }),
                    story && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3 text-[15px] leading-relaxed text-slate-700",
                        "data-testid": "cp-step2-money-story",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[13px] font-semibold text-slate-600",
                                children: "Where the gap comes from"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ddaae90639b5011$export$1a915263dc5391f1), {
                                    story: story,
                                    testId: "cp-money-story"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7ace27ec3f1c2144$var$Fold, {
                        label: "See every line, money in and money out",
                        testId: "cp-cashflow-working",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db27db5ed814451d$export$c8225646f50a07d8), {
                            rows: first?.cashFlowBreakdown
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $db27db5ed814451d$export$aa3e815946b80764),
                "data-testid": "cp-own-and-leave",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: (0, $db27db5ed814451d$export$e17a63917e2ebf0f),
                        children: [
                            "What ",
                            v.they,
                            " own, and what is left to the family"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 text-[16px] leading-relaxed text-slate-800",
                        children: [
                            v.Names,
                            " own",
                            v.s,
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: (0, $db27db5ed814451d$export$5517df3497010beb)(position.netWorth)
                            }),
                            " today, less what ",
                            v.they,
                            " owe. Changing nothing, about ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: (0, $db27db5ed814451d$export$5517df3497010beb)(position.estate)
                            }),
                            " is left to the family after about ",
                            legacyYears,
                            " years, after living costs, investment returns",
                            supportCost ? ' and the support paid for' : '',
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7ace27ec3f1c2144$var$Fold, {
                        label: `See what makes up what ${v.they} own`,
                        testId: "cp-networth-working",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db27db5ed814451d$export$c8225646f50a07d8), {
                            rows: todayFirst?.netWorthBreakdown
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7ace27ec3f1c2144$var$Fold, {
                        label: "See how the estate figure is reached",
                        testId: "cp-estate-working",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db27db5ed814451d$export$c8225646f50a07d8), {
                            rows: [
                                {
                                    label: 'Net worth today',
                                    value: position.netWorth
                                },
                                {
                                    label: 'Change over the period',
                                    value: position.estate - position.netWorth
                                },
                                {
                                    label: `Left to the family after ${legacyYears} years`,
                                    value: position.estate,
                                    emphasis: true
                                }
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] text-slate-500",
                children: [
                    "Figures use the rates in force from ",
                    (0, $1abe73eeef086faf$export$946308c675ba021d).agePension,
                    ". ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onAssumptions,
                        className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2",
                        children: "What the figures assume"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onBack,
                        className: `inline-flex items-center gap-1 text-[14px] ${(0, $db27db5ed814451d$export$9c30223ca0a664fb)}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                size: 15
                            }),
                            " Change the support cost"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onNext,
                        "data-testid": "cp-step2-next",
                        className: "inline-flex h-11 items-center gap-2 rounded-lg bg-blue-600 hover:bg-blue-700 px-5 text-[14px] font-semibold text-white shadow-sm ",
                        children: [
                            "See ways to improve it ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                size: 16
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $7ace27ec3f1c2144$export$2e2bcd8739ae039 = $7ace27ec3f1c2144$var$CpStep2;


/**
 * Step 3's questions — before the plans run, and again under "Things that change the answer" (cashflow
 * rebuild, 21 Oct 2026; the village's RvQuestions, owner rulings 20–21 Oct 2026).
 *
 * WHAT WE ALREADY KNOW first, from the file, in plain words: what could be moved (cash, term deposits and
 * shares; never the home or a super pension), that nothing here moves house, and that the emergency money is
 * kept back. Then only three questions, each with its "what's this?":
 *   1. how much stays in the bank for emergencies — kept back when money moves, drawn on only if a year runs
 *      short (owner, 21 Oct 2026: never "no plan will touch it");
 *   2. a guaranteed income for life — the shared question (GuaranteedIncomeQuestions), the client's own answer,
 *      "we work out how much";
 *   3. which of the other levers they would consider — funeral bonds, a gift within the free area, moving
 *      savings where the tax is lower — each explained in one line.
 * The years are one line with "why 10?". "Build a plan yourself instead" sits beside the run button.
 */ 

var $acw62 = parcelRequire("acw62");









const $9d5328aeeb077969$var$Why = ({ open: open, onToggle: onToggle, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            ' ',
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onToggle,
                "aria-expanded": open,
                className: `text-[12px] ${(0, $db27db5ed814451d$export$f038740a94d131a9)}`,
                children: "what's this?"
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "mt-1.5 block rounded-lg border border-slate-200 border-l-4 border-l-blue-500 bg-white px-3 py-2 text-[13px] font-normal leading-relaxed text-slate-700",
                children: children
            })
        ]
    });
const $9d5328aeeb077969$var$Q = ({ n: n, title: title, why: why, whyOpen: whyOpen, onWhy: onWhy, children: children, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-t border-slate-200 pt-4",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d7fa4e176455787d$export$d5095ecb707035a), {
                n: n,
                children: [
                    title,
                    why && onWhy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9d5328aeeb077969$var$Why, {
                        open: !!whyOpen,
                        onToggle: onWhy,
                        children: why
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-2",
                children: children
            })
        ]
    });
const $9d5328aeeb077969$var$LEVER_OPTIONS = [
    {
        id: 'bond',
        key: 'bond'
    },
    {
        id: 'gift',
        key: 'gift'
    },
    {
        id: 'tax',
        key: 'super'
    }
];
const $9d5328aeeb077969$var$CpQuestions = ({ factFind: factFind, onGuaranteedIncomeGoals: onGuaranteedIncomeGoals, legacyYears: legacyYears, firstRun: firstRun, onRun: onRun, onBuildYourOwn: onBuildYourOwn, onCancel: onCancel })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const [reserve, setReserve] = (0, $acw62.useState)(()=>(0, $cc855f77b4e7e2d7$export$c44200ae02a0feac)(factFind));
    const [levers, setLevers] = (0, $acw62.useState)(()=>(0, $cc855f77b4e7e2d7$export$fa523d4ac46927e8)(factFind));
    const [years, setYears] = (0, $acw62.useState)(legacyYears);
    const [openWhy, setOpenWhy] = (0, $acw62.useState)(null);
    const whyProps = (id)=>({
            whyOpen: openWhy === id,
            onWhy: ()=>setOpenWhy((o)=>o === id ? null : id)
        });
    const liquid = (0, $2663acaa6cb9dd5e$export$c81b76ce53c83adf)(factFind);
    const movable = Math.max(0, liquid - reserve);
    const debts = (0, $2663acaa6cb9dd5e$export$d9e7ffb0b289bb15)(factFind).reduce((t, d)=>t + d.balance, 0);
    const toggle = (id)=>setLevers((l)=>l.includes(id) ? l.filter((x)=>x !== id) : [
                ...l,
                id
            ]);
    let qn = 0;
    const next = ()=>{
        qn += 1;
        return qn;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
        "data-testid": "cp-questions",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                className: "text-[22px] font-bold text-brand-navy",
                children: [
                    onGuaranteedIncomeGoals ? 'Three' : 'Two',
                    " choices that shape the plans"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-1 text-[15px] text-slate-600",
                children: [
                    "Everything else comes from ",
                    v.possessive,
                    " file. Our suggestions are filled in, and each can be changed later."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d7fa4e176455787d$export$b506d3545e935872), {
                onClick: onBuildYourOwn,
                testId: "cp-build-own-top"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-4 rounded-xl border border-slate-200 border-l-4 border-l-brand-navy bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700",
                "data-testid": "cp-what-we-know",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "text-slate-900",
                        children: "What we already know"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                        className: "mt-1.5 list-disc space-y-1 pl-5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: "text-slate-900",
                                        children: [
                                            v.Names,
                                            " ",
                                            v.have,
                                            " ",
                                            (0, $db27db5ed814451d$export$5517df3497010beb)(liquid),
                                            " that could be moved"
                                        ]
                                    }),
                                    " \u2014 cash, term deposits and shares. The home and any super pension stay as they are."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        className: "text-slate-900",
                                        children: [
                                            "After the ",
                                            (0, $db27db5ed814451d$export$5517df3497010beb)(reserve),
                                            " kept for emergencies, ",
                                            (0, $db27db5ed814451d$export$5517df3497010beb)(movable),
                                            " is free to rearrange."
                                        ]
                                    }),
                                    " Every plan is sized from that, never from more."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: "Nobody moves house."
                                    }),
                                    " Downsizing, a retirement village or a granny flat each has its own section, because the trade-offs are different."
                                ]
                            }),
                            debts > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    v.Names,
                                    " owe",
                                    v.s,
                                    " ",
                                    (0, $db27db5ed814451d$export$5517df3497010beb)(debts),
                                    ". Paying it off is a choice ",
                                    v.they,
                                    " can make when building a plan ",
                                    v.you ? 'yourself' : 'by hand',
                                    "."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-4 space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($9d5328aeeb077969$var$Q, {
                        n: next(),
                        title: "How much should stay in the bank for emergencies?",
                        ...whyProps('reserve'),
                        why: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "Money kept in the bank for the unexpected. We keep it back when we move ",
                                v.their,
                                " money, and draw on it only if a year runs short. Centrelink still counts it."
                            ]
                        }),
                        testId: "cp-q-reserve",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                        value: reserve,
                                        onChange: (x)=>setReserve(Math.max(0, x ?? 0)),
                                        className: "w-36",
                                        ariaLabel: "Money kept for emergencies",
                                        testId: "cp-reserve"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-[13px] text-slate-500",
                                        children: [
                                            "We suggest ",
                                            (0, $db27db5ed814451d$export$5517df3497010beb)((0, $cc855f77b4e7e2d7$export$bd01c53d266fa90)),
                                            ".",
                                            Math.round(reserve) !== (0, $cc855f77b4e7e2d7$export$bd01c53d266fa90) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>setReserve((0, $cc855f77b4e7e2d7$export$bd01c53d266fa90)),
                                                        className: (0, $db27db5ed814451d$export$9c30223ca0a664fb),
                                                        children: [
                                                            "Use ",
                                                            (0, $db27db5ed814451d$export$5517df3497010beb)((0, $cc855f77b4e7e2d7$export$bd01c53d266fa90))
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-1.5 text-[13.5px] text-slate-700",
                                children: [
                                    "We keep it back when we move ",
                                    v.their,
                                    " money, and draw on it only if a year runs short."
                                ]
                            })
                        ]
                    }),
                    onGuaranteedIncomeGoals && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($9d5328aeeb077969$var$Q, {
                        n: next(),
                        title: "A guaranteed income for life",
                        testId: "cp-guaranteed-income",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f92088f7258458cc$export$2e2bcd8739ae039), {
                                factFind: factFind,
                                onGoals: onGuaranteedIncomeGoals,
                                investable: movable,
                                investableLead: `After the ${(0, $db27db5ed814451d$export$5517df3497010beb)(reserve)} kept for emergencies`,
                                investableMadeOf: "cash, term deposits and shares",
                                inCare: (0, $d08210caeacdc75a$export$7095ab72ebd46272)(factFind, 'client'),
                                idPrefix: "cp"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-2 text-[13.5px] leading-relaxed text-slate-700",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: "We work out how much."
                                    }),
                                    " We test amounts up to that share. Where it would lift the Age Pension, we also test the amount that lifts it most, held to the same share."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($9d5328aeeb077969$var$Q, {
                        n: next(),
                        title: `Which of these would ${v.names} consider?`,
                        testId: "cp-q-levers",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mb-1 text-[13.5px] text-slate-600",
                                children: [
                                    "Tick what ",
                                    v.they,
                                    "'d consider; the plans try each one, and the two together."
                                ]
                            }),
                            $9d5328aeeb077969$var$LEVER_OPTIONS.map((o)=>{
                                const w = (0, $4876815f03a5e1e6$export$1dd9e721f9a6fc9c)[o.key];
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "flex cursor-pointer items-start gap-2 py-1.5 text-[14px] text-slate-700",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            checked: levers.includes(o.id),
                                            onChange: ()=>toggle(o.id),
                                            className: "mt-1 h-4 w-4 accent-blue-600",
                                            "data-testid": `cp-lever-${o.id}`
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    className: "text-slate-900",
                                                    children: o.id === 'tax' ? 'Moving savings where the tax is lower' : w.name
                                                }),
                                                " \u2014 ",
                                                o.id === 'tax' ? `${(0, $4876815f03a5e1e6$export$1dd9e721f9a6fc9c).super.what} Where super can\u{2019}t take it, ${(0, $4876815f03a5e1e6$export$1dd9e721f9a6fc9c).investmentBond.name.toLowerCase()} instead.` : w.what,
                                                " ",
                                                w.centrelink
                                            ]
                                        })
                                    ]
                                }, o.id);
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-1.5 text-[13.5px] text-slate-700",
                                children: [
                                    "Anything ",
                                    v.they,
                                    " don't move stays in ",
                                    v.their,
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-900",
                                        children: "bank account"
                                    }),
                                    ", and changing nothing is always tested too, so ",
                                    v.they,
                                    " can see what each choice adds."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-5 text-[13px] text-slate-500",
                children: [
                    "We plan for",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "number",
                        min: 1,
                        max: 30,
                        value: years,
                        onChange: (e)=>setYears(Math.min(30, Math.max(1, parseInt(e.target.value, 10) || 1))),
                        className: "w-14 rounded border border-slate-300 px-1.5 py-0.5 text-center text-[13px] font-semibold text-slate-900",
                        "aria-label": "Years to plan for"
                    }),
                    " years.",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9d5328aeeb077969$var$Why, {
                        open: openWhy === 'years',
                        onToggle: ()=>setOpenWhy((o)=>o === 'years' ? null : 'years'),
                        children: (0, $db27db5ed814451d$export$ecef4fbbe3ba5fa1)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-[14px] text-slate-700",
                        children: [
                            "Prefer to set the numbers yourself? ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onBuildYourOwn,
                                className: (0, $db27db5ed814451d$export$9c30223ca0a664fb),
                                "data-testid": "cp-build-own",
                                children: "Build a plan yourself instead"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex items-center gap-3",
                        children: [
                            !firstRun && onCancel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onCancel,
                                className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>onRun({
                                        reserve: reserve,
                                        levers: levers,
                                        years: years
                                    }),
                                className: "rounded-lg bg-blue-600 px-5 py-2.5 text-[15px] font-semibold text-white hover:bg-blue-700",
                                "data-testid": "cp-run",
                                children: firstRun ? 'Test the ways to improve it' : 'Test them again'
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $9d5328aeeb077969$export$2e2bcd8739ae039 = $9d5328aeeb077969$var$CpQuestions;


/**
 * Step 3's plans — cashflow & Age Pension on the shared spine (cashflow rebuild, 21 Oct 2026; the agreed
 * mock-up's j1-plans, and the village's RvPlansView).
 *
 *  - Changing nothing as a strip of the four numbers from step 1: every card is read against it.
 *  - One line saying what the best plan does against changing nothing — or, plainly, that none leaves the
 *    family more (cross-module change 5: a verdict line when no plan beats doing nothing).
 *  - "What matters most to you?" — the four goals; choosing one never re-runs the engine. "Highest Age
 *    Pension" is always shown, and opens to the reason when no plan lifts it.
 *  - The cards side by side, aligned row by row: the plan in words, what is left to the family against
 *    changing nothing, the Age Pension and each year's money (each with "why?"), when the money runs out, an
 *    "Important" or "Worth knowing" line, and Explain this / What could go wrong / Choose this plan.
 *  - The ways on: compare every way side by side, things that change the answer, build a plan yourself.
 *
 * Presentation only. Every figure is the engine row's own; the ranking is the shared rule
 * (cashflowPensionRanking.bestForEachGoal) with the plan choice rule on top (planChoiceRule.ts).
 */ 

var $acw62 = parcelRequire("acw62");





/**
 * Which Cashflow & Age Pension option wins, for each of the three things a client might want.
 *
 * SHARED, not duplicated. The server evaluates the candidates and the frontend renders them, and
 * both need to agree on which one is "best cashflow". Two copies of this rule would be two answers
 * to one question, free to drift — the defect shape this codebase keeps meeting. It lives here so
 * there is one.
 *
 * Pure arithmetic over results that have already been projected; no engine dependencies, which is
 * why it can sit in the shared slice at all.
 */ /** The three things a client might be optimising for. */ function $cfe51a4282da6cb0$export$e58a9b153ebee0d0(results, minimumWorthDoing = 100) {
    const baseline = results.find((r)=>r.changeNothing && !r.error);
    const usable = results.filter((r)=>!r.changeNothing && !r.error);
    const pick = (goal)=>{
        // A tie (within a dollar) goes to the plan that does better on the other goals, the estate first: two plans
        // with the same Age Pension, one also paying off the credit card and leaving more, led by list order
        // (owner's file, 22 Oct 2026).
        const others = [
            'estate',
            'cashflow',
            'pension'
        ].filter((g)=>g !== goal);
        const ranked = [
            ...usable
        ].sort((a, b)=>{
            const d = b.snapshot[goal] - a.snapshot[goal];
            if (Math.abs(d) >= 1) return d;
            for (const g of others){
                const e = b.snapshot[g] - a.snapshot[g];
                if (Math.abs(e) >= 1) return e;
            }
            return 0;
        });
        const top = ranked[0];
        if (!top) return null;
        if (!baseline) return top;
        return top.snapshot[goal] - baseline.snapshot[goal] > minimumWorthDoing ? top : null;
    };
    return {
        cashflow: pick('cashflow'),
        pension: pick('pension'),
        estate: pick('estate')
    };
}










const $3c19f7e7397007b7$export$d7ad7a8376e374d5 = "We couldn\u2019t work this one out on your figures, so it can\u2019t be chosen, saved or used for advice. The other options are not affected.";
function $3c19f7e7397007b7$export$78d6356b3b8e19a2(results, candidates) {
    const list = results || [];
    const base = list.find((r)=>r.changeNothing && !r.error) ?? null;
    const usable = list.filter((r)=>!r.changeNothing && !r.error);
    const cand = (r)=>candidates.find((c)=>c.id === r.id) ?? null;
    const readings = {
        estate: (r)=>r.snapshot.estate,
        moved: (r)=>(0, $4876815f03a5e1e6$export$2188ff7ffabde39e)(cand(r)),
        cashflow: (r)=>r.snapshot.cashflow,
        kinds: (r)=>(0, $4876815f03a5e1e6$export$1555bdcd9f522821)(cand(r) ?? {
                id: r.id
            })
    };
    const winners = (0, $cfe51a4282da6cb0$export$e58a9b153ebee0d0)(list);
    const gated = usable.filter((r)=>!base || r.snapshot.estate - base.snapshot.estate > 100);
    let estate = null;
    let exception = null;
    let estateBeats = false;
    if (winners.estate && gated.length) {
        estate = (0, $5a094123650e8adb$export$3ef36734776b870)(gated, readings) ?? winners.estate;
        exception = (0, $5a094123650e8adb$export$db12984b57d6f833)(gated, estate, readings);
        estateBeats = true;
    } else if (usable.length) estate = usable.reduce((t, r)=>r.snapshot.estate > t.snapshot.estate ? r : t, usable[0]);
    const second = estate ? (0, $5a094123650e8adb$export$ab51b61210e311f4)(usable, estate, readings, (a, b)=>a.id === b.id) : null;
    const coveredPick = (0, $400a08a42b233386$export$db04dcb0634643af)(usable.map((r)=>({
            name: r.id,
            row: r,
            snapshot: {
                netCashflow: r.snapshot.cashflow,
                legacyValue: r.snapshot.estate
            },
            projections: r.projections
        })));
    return {
        base: base,
        usable: usable,
        estate: estate,
        estateBeats: estateBeats,
        exception: exception,
        second: second,
        covered: coveredPick?.strategy.row ?? null,
        cashflow: winners.cashflow,
        pension: winners.pension
    };
}
const $3c19f7e7397007b7$var$CpPlansView = ({ factFind: factFind, results: results, candidates: candidates, horizonYears: horizonYears, ownToday: ownToday, supportCost: supportCost, focus: focus, onFocus: onFocus, chosenId: chosenId, onChoose: onChoose, onExplain: onExplain, onRisks: onRisks, onAdvice: onAdvice, onBuildYourOwn: onBuildYourOwn, onChanges: onChanges, renderDetail: renderDetail, renderFamily: renderFamily, beforeChoose: beforeChoose, chooseHeld: chooseHeld, notices: notices, initialOpenDetail: initialOpenDetail = null })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const yrs = `${horizonYears} ${horizonYears === 1 ? 'year' : 'years'}`;
    const [openDetail, setOpenDetail] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(initialOpenDetail);
    const [why, setWhy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [comparing, setComparing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const L = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$3c19f7e7397007b7$export$78d6356b3b8e19a2(results, candidates), [
        results,
        candidates
    ]);
    const base = L.base;
    const cand = (r)=>candidates.find((c)=>c.id === r.id) ?? {
            id: r.id
        };
    const words = (r)=>(0, $4876815f03a5e1e6$export$f32c8e12406086f7)(cand(r), factFind);
    const estateOf = (r)=>Number(r?.snapshot.estate) || 0;
    const pensionOf = (r)=>Number(r?.snapshot.pension) || 0;
    const cashOf = (r)=>Number(r?.snapshot.cashflow) || 0;
    const tested = results.filter((r)=>!r.changeNothing).length;
    const coveredSame = !!L.covered && !!L.estate && L.covered.id === L.estate.id;
    const effective = focus === 'covered' && coveredSame ? 'legacy' : focus;
    const isCouple = factFind?.adviceFor === 'couple';
    const leaderFor = (f)=>f === 'legacy' ? L.estate : f === 'covered' ? L.covered : f === 'cashflow' ? L.cashflow : L.pension;
    const leader = leaderFor(effective);
    /*
     * ONE CARD PER GOAL, A SECOND ONLY WITH A PURPOSE (owner, 22 Oct 2026: "each section has a specific purpose … only
     * show the second card when there is a purpose to it"). The second card is the plan choice rule's near-tie beside
     * the estate leader (nearly the same estate, less locked away or a better cashflow — planChoiceRule.ts), as aged
     * care and support at home do. Another goal's leader is pointed to in one line under the cards (OtherGoalLeaders).
     */ const partner = leader && effective === 'legacy' && L.second && L.second.strategy.id !== leader.id ? L.second.strategy : null;
    const noPensionLift = effective === 'pension' && !L.pension;
    const shown = noPensionLift || !leader ? [] : [
        leader,
        ...partner ? [
            partner
        ] : []
    ];
    const others = [
        'legacy',
        'cashflow',
        'pension'
    ].filter((g)=>g !== effective).map((g)=>({
            g: g,
            row: leaderFor(g)
        })).filter((x)=>!!x.row && !shown.some((s)=>s.id === x.row.id)).map((x)=>({
            goal: x.g,
            title: words(x.row).title,
            legacy: estateOf(x.row),
            cashflow: cashOf(x.row),
            pension: pensionOf(x.row)
        }));
    const chipsFor = (r)=>{
        const chips = [];
        if (L.estate?.id === r.id) chips.push(L.estateBeats ? (0, $5a094123650e8adb$export$a035dca5f387c63d)(L.exception) : 'The closest to changing nothing');
        if (L.second?.strategy.id === r.id && effective === 'legacy') chips.push((0, $5a094123650e8adb$export$8d9f0aa086032e89)(L.second));
        if (L.covered?.id === r.id && !coveredSame) chips.push('Income covers the costs');
        if (L.cashflow?.id === r.id) chips.push('Most left over each year');
        if (L.pension?.id === r.id) chips.push('Highest Age Pension');
        return chips.length ? chips.join(" \xb7 ") : null;
    };
    const maxGain = Math.max(1, ...shown.map((s)=>Math.abs(estateOf(s) - estateOf(base))));
    const maxTied = Math.max(1, ...shown.map((s)=>(0, $4876815f03a5e1e6$export$2188ff7ffabde39e)(cand(s))));
    const card = (row)=>{
        const w = words(row);
        const m = (0, $4876815f03a5e1e6$export$7b3fc74da8f66f1)(cand(row));
        const delta = base ? estateOf(row) - estateOf(base) : null;
        const pDelta = base ? pensionOf(row) - pensionOf(base) : 0;
        const cDelta = base ? cashOf(row) - cashOf(base) : 0;
        const tied = (0, $4876815f03a5e1e6$export$2188ff7ffabde39e)(cand(row));
        const numbers = [
            {
                label: 'Age Pension',
                value: pensionOf(row),
                unit: 'a year',
                vs: base && Math.abs(pDelta) >= 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: `font-bold ${pDelta > 0 ? 'text-emerald-700' : 'text-rose-700'}`,
                            children: [
                                (0, $db27db5ed814451d$export$a785de3a2a8dd1aa)(pDelta),
                                " a year"
                            ]
                        }),
                        " vs changing nothing"
                    ]
                }) : 'the same as changing nothing',
                tone: pDelta >= 1 ? 'good' : 'neutral',
                onWhy: ()=>setWhy({
                        row: row,
                        page: 'pension'
                    })
            },
            {
                label: cashOf(row) < 0 ? 'Each year, short by' : 'Left over each year',
                value: Math.abs(cashOf(row)),
                vs: base ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: `font-bold ${cDelta >= 0 ? 'text-emerald-700' : 'text-rose-700'}`,
                            children: [
                                (0, $db27db5ed814451d$export$a785de3a2a8dd1aa)(cDelta),
                                " a year"
                            ]
                        }),
                        " \xb7 changing nothing: ",
                        (0, $db27db5ed814451d$export$202882938379ba30)(cashOf(base))
                    ]
                }) : '',
                tone: cashOf(row) >= 0 ? cDelta > 0 ? 'good' : 'neutral' : 'neutral',
                onWhy: ()=>setWhy({
                        row: row,
                        page: 'cashflow'
                    })
            }
        ];
        const runway = row.projections?.length ? (0, $0fe89e03b6df746e$export$464558962ff4a811)(row.projections, horizonYears) : null;
        // Every account in the order it is drawn, as every module's card says it (owner, 22 Oct 2026); the old line where that cannot be read.
        const cardLine = row.projections?.length ? (0, $2ddaae90639b5011$export$7526d1fcb4423629)({
            rows: row.projections,
            factFind: factFind,
            horizonYears: horizonYears,
            spentOn: (0, $4876815f03a5e1e6$export$ec4b9fd87c177556)(cand(row))
        }) : null;
        const runline = cardLine ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "When the money runs out:"
                }),
                " ",
                cardLine
            ]
        }) : runway ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "When the money runs out:"
                }),
                " ",
                runway.depleted ? `${runway.headline.charAt(0).toLowerCase()}${runway.headline.slice(1)}.` : cashOf(row) >= 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "it doesn't \u2014 income covers the costs",
                        cashOf(row) < 2000 ? `, with only ${(0, $db27db5ed814451d$export$5517df3497010beb)(cashOf(row))} a year to spare` : ' with room to spare',
                        "."
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        runway.headline.charAt(0).toLowerCase(),
                        runway.headline.slice(1),
                        "."
                    ]
                }),
                runway.flag ? ` ${runway.flag}` : ''
            ]
        }) : null;
        const lines = [];
        if (delta != null && delta < -1) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-rose-700",
                    children: "Important:"
                }),
                " it leaves the family ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-rose-700",
                    children: (0, $db27db5ed814451d$export$5517df3497010beb)(-delta)
                }),
                " less than changing nothing after about ",
                yrs,
                ". That is the price of the ",
                pDelta >= 1 && cDelta >= 1 ? 'higher Age Pension and the extra each year' : cDelta >= 1 ? 'extra each year' : pDelta >= 1 ? 'higher Age Pension' : 'change',
                " it buys."
            ]
        }));
        if (m.annuity > 0 && m.annuityType !== 'guaranteed' && m.residual <= 0) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "Worth knowing:"
                }),
                " the guaranteed income is income only. It pays the most for life, and nothing from it goes back to the family, even after an early death."
            ]
        }));
        else if (m.annuity > 0) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "Worth knowing:"
                }),
                " the ",
                (0, $db27db5ed814451d$export$5517df3497010beb)(m.annuity),
                " is committed for life.",
                m.annuityType === 'guaranteed' ? ' It pays the least income of the three types, in return for the full amount back to the family.' : ' The money back to the family falls over time, to nothing later in life.'
            ]
        }));
        if ((m.superTotal > 0 || m.investmentBond > 0) && Math.abs(pDelta) < 1) lines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    className: "text-slate-900",
                    children: "Worth knowing:"
                }),
                " this is about tax, not the Age Pension: Centrelink counts the money the same way it counts the savings it replaces."
            ]
        }));
        const tradeOff = L.second && row.id === L.second.strategy.id && effective === 'legacy' ? (0, $5a094123650e8adb$export$a104569a4d958475)(L.second, (n)=>(0, $db27db5ed814451d$export$5517df3497010beb)(n)) : L.exception && row.id === L.estate?.id ? (0, $5a094123650e8adb$export$27f705a6fa40271e)(L.exception, (n)=>(0, $db27db5ed814451d$export$5517df3497010beb)(n)) : null;
        const key = String(row.id);
        const isChosen = chosenId != null && row.id === chosenId;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b383720e6b5df564$export$2e2bcd8739ae039), {
            aligned: true,
            testId: "cp-plan-card",
            whyShown: tradeOff || null,
            chip: chipsFor(row),
            chipTone: "blue",
            title: w.title,
            sub: w.sub,
            legacy: estateOf(row),
            legacyDelta: delta,
            horizonYears: horizonYears,
            baselineWord: (0, $1a5a24a0286ded56$export$b3949d624101f360)('cashflow').word,
            bars: delta != null ? {
                gainPct: Math.abs(delta) / maxGain * 100,
                tiedUp: tied,
                tiedUpPct: tied / maxTied * 100
            } : null,
            tiedUpLabel: "Put out of reach",
            hideEmptyTiedUp: true,
            numbers: numbers,
            runline: runline,
            worthKnowing: lines.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: lines.map((l, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: l
                    }, i))
            }) : null,
            lines: [],
            familyPanel: renderFamily(row),
            chosen: isChosen,
            beforeChoose: beforeChoose(row),
            chooseHeld: chooseHeld(row),
            onExplain: ()=>onExplain(row),
            onRisks: ()=>onRisks(row),
            onChoose: ()=>onChoose(row),
            chooseLabel: chosenId != null && !isChosen ? 'Choose this instead' : 'Choose this plan',
            chosenStrip: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2194d8b5de21e3ff$export$4df4eb62309771d0), {
                possessiveFile: v.possessive,
                onAdvice: ()=>onAdvice(row),
                onCustomise: ()=>onBuildYourOwn(row)
            }),
            detail: renderDetail(row),
            detailOpen: openDetail === key,
            onToggleDetail: ()=>setOpenDetail((d)=>d === key ? null : key),
            detailHint: "where the money comes from and the terms"
        }, key);
    };
    const Strip = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            "data-testid": "cp-nothing-strip",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-[13px] font-semibold text-slate-500",
                    children: "Compared with changing nothing \u2014 the four numbers from step 1"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mt-2 grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-slate-200 bg-slate-200 shadow-card lg:grid-cols-4",
                    children: [
                        {
                            label: 'Age Pension',
                            value: (0, $db27db5ed814451d$export$5517df3497010beb)(pensionOf(base)),
                            note: 'a year'
                        },
                        {
                            label: cashOf(base) < 0 ? 'Each year, short by' : 'Left over each year',
                            value: (0, $db27db5ed814451d$export$5517df3497010beb)(Math.abs(cashOf(base))),
                            note: supportCost ? `with ${(0, $db27db5ed814451d$export$5517df3497010beb)(supportCost.annual)} of support` : 'money in, less money out',
                            tone: cashOf(base) >= 0 ? 'text-emerald-700' : 'text-rose-700'
                        },
                        {
                            label: `What ${v.they} own`,
                            value: (0, $db27db5ed814451d$export$5517df3497010beb)(ownToday),
                            note: 'today'
                        },
                        {
                            label: 'Left to the family',
                            value: (0, $db27db5ed814451d$export$5517df3497010beb)(estateOf(base)),
                            note: `after about ${yrs}`
                        }
                    ].map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white px-4 py-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-[12px] font-semibold text-slate-500",
                                    children: c.label
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: `mt-0.5 text-[22px] font-bold leading-tight tabular-nums ${c.tone || 'text-slate-900'}`,
                                    children: c.value
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-[12px] text-slate-500",
                                    children: c.note
                                })
                            ]
                        }, c.label))
                })
            ]
        });
    const top = L.estate;
    const topDelta = top && base ? estateOf(top) - estateOf(base) : 0;
    const verdict = base && top ? L.estateBeats ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                className: "text-slate-900",
                children: [
                    "The best way leaves the family ",
                    (0, $db27db5ed814451d$export$5517df3497010beb)(topDelta),
                    " more than changing nothing after about ",
                    yrs
                ]
            }),
            L.pension ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    ", and the most it can lift ",
                    v.possessive,
                    " Age Pension is ",
                    (0, $db27db5ed814451d$export$5517df3497010beb)(pensionOf(L.pension) - pensionOf(base)),
                    " a year"
                ]
            }) : null,
            ". We tested ",
            tested,
            " ways; below are the strongest."
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                className: "text-slate-900",
                children: "No way we tested leaves the family more than changing nothing."
            }),
            ' ',
            "The closest leaves ",
            (0, $db27db5ed814451d$export$5517df3497010beb)(-topDelta),
            " less after about ",
            yrs,
            L.pension ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "; ",
                    v.they,
                    " can still lift the Age Pension by up to ",
                    (0, $db27db5ed814451d$export$5517df3497010beb)(pensionOf(L.pension) - pensionOf(base)),
                    " a year, at a cost to the estate"
                ]
            }) : null,
            ". Changing nothing is a real answer; the cards show what each change would buy."
        ]
    }) : null;
    const pensionWhyBase = (0, $4876815f03a5e1e6$export$fa520b49d4c209b6)(base?.projections?.[0], isCouple);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-6",
        "data-testid": "cp-plans",
        children: [
            notices,
            base && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Strip, {}),
            verdict && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `rounded-xl border border-slate-200 border-l-4 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700 shadow-card ${L.estateBeats ? 'border-l-emerald-500' : 'border-l-brand-navy'}`,
                "data-testid": "cp-verdict",
                children: verdict
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54f65c4595e0c798$export$2e2bcd8739ae039), {
                value: focus,
                onChange: onFocus,
                household: v.names,
                enteringName: v.names,
                horizonYears: horizonYears,
                coveredSameAsBest: coveredSame,
                bestCovers: coveredSame && cashOf(L.estate) >= 0,
                waysTested: tested,
                shown: shown.length,
                testedFor: "without moving house",
                closingNote: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: "Each card says when the savings would run out, and how much money it puts out of reach."
                }),
                subs: {
                    legacy: L.estateBeats ? `Biggest estate after about ${yrs}` : 'Nothing beats changing nothing',
                    covered: coveredSame ? 'Same plan as "leave the most"' : 'Pays its way without savings',
                    pension: L.pension ? 'Most government support' : "No plan lifts it \u2014 see why"
                },
                countLine: noPensionLift ? 'No plan lifts the Age Pension.' : shown.length === 0 ? 'None leads on this goal.' : undefined
            }),
            noPensionLift ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-2xl border border-slate-200 border-l-4 border-l-brand-navy bg-white p-6 shadow-card",
                "data-testid": "cp-no-pension",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                        className: "text-[19px] font-bold text-slate-900",
                        children: [
                            "No plan lifts ",
                            v.possessive,
                            " Age Pension"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-2 text-[15px] leading-relaxed text-slate-700",
                        children: [
                            "Changing nothing, ",
                            v.they,
                            " get",
                            v.s,
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    (0, $db27db5ed814451d$export$5517df3497010beb)(pensionOf(base)),
                                    " a year"
                                ]
                            }),
                            ". ",
                            pensionWhyBase ? (0, $4876815f03a5e1e6$export$47e779574a8223ac)(pensionWhyBase, v.their) : ''
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-2 text-[15px] leading-relaxed text-slate-700",
                        children: "None of the ways we tested moves enough out of Centrelink's count to change that by more than $100 a year, so this goal can't tell the plans apart. Choose another goal to compare them."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>onFocus('legacy'),
                            className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                            children: "Compare the plans on another goal"
                        })
                    })
                ]
            }) : shown.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-2xl border border-slate-200 bg-white p-6 shadow-card",
                "data-testid": "cp-no-leader",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-[19px] font-bold text-slate-900",
                        children: L.usable.length ? 'No plan leads on this goal' : 'On these figures there is nothing we would change'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-2 text-[14px] leading-relaxed text-slate-700",
                        children: L.usable.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "None of the ways we tested beats changing nothing on this goal. Choose another goal above, or compare all ",
                                tested,
                                " ways."
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: "That is a real answer, not a gap: these ways need savings beyond the money kept for emergencies to be worth doing."
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `grid grid-cols-1 gap-5 ${shown.length > 1 ? 'lg:grid-cols-2' : ''}`,
                "data-testid": "cp-plan-cards",
                children: [
                    chosenId != null && !shown.some((s)=>s.id === chosenId) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: shown.length > 1 ? 'lg:col-span-2' : '',
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2194d8b5de21e3ff$export$4df4eb62309771d0), {
                            possessiveFile: v.possessive,
                            onAdvice: ()=>{
                                const row = results.find((r)=>r.id === chosenId);
                                if (row) onAdvice(row);
                            },
                            offCard: true,
                            testId: "chosen-plan-off-card"
                        })
                    }),
                    shown.map(card)
                ]
            }),
            shown.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c41b14da14ed8be$export$2e2bcd8739ae039), {
                others: others,
                here: {
                    legacy: estateOf(shown[0]),
                    cashflow: cashOf(shown[0]),
                    pension: pensionOf(shown[0])
                },
                baseLegacy: base ? estateOf(base) : null,
                baseWord: "changing nothing",
                onFocus: onFocus,
                testId: "cp-other-leaders"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-3",
                "data-testid": "cp-ways-on",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>setComparing(true),
                        className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                        "data-testid": "cp-compare-all",
                        children: [
                            "Compare all ",
                            tested,
                            " side by side"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onChanges,
                        className: "rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-[14px] font-semibold text-slate-800 hover:border-blue-300",
                        "data-testid": "cp-changes",
                        children: "Things that change the answer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>onBuildYourOwn(null),
                        className: "text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy",
                        "data-testid": "cp-build-your-own",
                        children: "Prefer to set the numbers yourself? Build a plan \u2192"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[13px] text-slate-500",
                "data-testid": "all-plans-open-line",
                children: (0, $5a094123650e8adb$export$af182f21f972ef03)(tested)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] text-slate-500",
                children: [
                    "Each figure is the total that plan gives, with the change against changing nothing beneath it. Figures use the rates in force today and are projections over ",
                    yrs,
                    ", not guarantees. Moving house \u2014 downsizing, a retirement village or a granny flat \u2014 is modelled in its own section."
                ]
            }),
            comparing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                titleId: "cp-compare-title",
                title: `All ${tested} ways side by side, and changing nothing`,
                eyebrow: `Over about ${yrs}, each against changing nothing`,
                onClose: ()=>setComparing(false),
                size: "xl",
                testId: "cp-compare-dialog",
                flush: true,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "overflow-x-auto",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "phone-stack min-w-full text-[14px]",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "border-b border-slate-200 text-left text-[12px] font-semibold text-slate-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3",
                                                children: "Plan"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3 text-right",
                                                children: "Left to the family"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3 text-right",
                                                children: "Age Pension"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3 text-right",
                                                children: "Each year"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3 text-right",
                                                children: "Put out of reach"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3",
                                                children: " "
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    className: "tabular-nums",
                                    children: results.map((r)=>{
                                        const errored = !!r.error;
                                        const isChosen = chosenId != null && r.id === chosenId;
                                        const held = !errored && chooseHeld(r);
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: `border-b border-slate-100 align-top ${r.changeNothing ? 'text-slate-500' : ''}`,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "px-5 py-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            className: r.changeNothing ? 'text-slate-600' : 'text-slate-900',
                                                            children: r.changeNothing ? 'Change nothing' : words(r).title
                                                        }),
                                                        !r.changeNothing && chipsFor(r) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "block text-[12px] font-semibold text-brand-navy",
                                                            children: chipsFor(r)
                                                        }),
                                                        errored && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "mt-1 block text-[12.5px] text-slate-600",
                                                            "data-testid": "cp-errored-row",
                                                            children: $3c19f7e7397007b7$export$d7ad7a8376e374d5
                                                        })
                                                    ]
                                                }),
                                                errored ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "px-5 py-3 text-right",
                                                    colSpan: 4,
                                                    children: "\u2014"
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            "data-label": "Left to the family",
                                                            className: "px-5 py-3 text-right font-semibold",
                                                            children: [
                                                                (0, $db27db5ed814451d$export$5517df3497010beb)(estateOf(r)),
                                                                !r.changeNothing && base && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: `block text-[12px] ${estateOf(r) >= estateOf(base) ? 'text-emerald-700' : 'text-rose-700'}`,
                                                                    children: (0, $db27db5ed814451d$export$a785de3a2a8dd1aa)(estateOf(r) - estateOf(base))
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            "data-label": "Age Pension",
                                                            className: "px-5 py-3 text-right",
                                                            children: [
                                                                (0, $db27db5ed814451d$export$5517df3497010beb)(pensionOf(r)),
                                                                !r.changeNothing && base && Math.abs(pensionOf(r) - pensionOf(base)) >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: `block text-[12px] ${pensionOf(r) > pensionOf(base) ? 'text-emerald-700' : 'text-rose-700'}`,
                                                                    children: (0, $db27db5ed814451d$export$a785de3a2a8dd1aa)(pensionOf(r) - pensionOf(base))
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            "data-label": "Each year",
                                                            className: `px-5 py-3 text-right ${cashOf(r) < 0 ? 'text-rose-700' : ''}`,
                                                            children: (0, $db27db5ed814451d$export$202882938379ba30)(cashOf(r))
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            "data-label": "Put out of reach",
                                                            className: "px-5 py-3 text-right",
                                                            children: r.changeNothing ? "\u2014" : (0, $db27db5ed814451d$export$5517df3497010beb)((0, $4876815f03a5e1e6$export$2188ff7ffabde39e)(cand(r)))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "whitespace-nowrap px-5 py-3 text-right",
                                                    children: !r.changeNothing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        disabled: errored || held,
                                                        "aria-disabled": errored || held,
                                                        onClick: ()=>{
                                                            if (!errored && !held) {
                                                                onChoose(r);
                                                                setComparing(false);
                                                            }
                                                        },
                                                        className: `rounded-lg px-3 py-1.5 text-[13px] font-semibold ${isChosen ? 'border border-emerald-500 bg-white text-emerald-800' : errored || held ? 'cursor-not-allowed bg-slate-200 text-slate-500' : 'bg-blue-600 text-white hover:bg-blue-700'}`,
                                                        children: isChosen ? "Chosen \u2713" : 'Choose this plan'
                                                    })
                                                })
                                            ]
                                        }, String(r.id));
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "px-5 py-3 text-[13px] text-slate-500",
                        children: [
                            "A plan with a guaranteed income that pays nothing back can be chosen once ",
                            v.you ? 'you have' : `${v.names} ${v.have}`,
                            " confirmed it on its card."
                        ]
                    })
                ]
            }),
            why && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
                titleId: "cp-why-title",
                eyebrow: words(why.row).title,
                title: why.page === 'pension' ? 'Why the Age Pension is what it is' : 'Left over each year',
                onClose: ()=>setWhy(null),
                testId: "cp-why-dialog",
                children: why.page === 'pension' ? (()=>{
                    const w = (0, $4876815f03a5e1e6$export$fa520b49d4c209b6)(why.row.projections?.[0], isCouple);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-3 text-[14px] leading-relaxed text-slate-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "Changing nothing: ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            (0, $db27db5ed814451d$export$5517df3497010beb)(pensionOf(base)),
                                            " a year"
                                        ]
                                    }),
                                    ". With this plan: ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            (0, $db27db5ed814451d$export$5517df3497010beb)(pensionOf(why.row)),
                                            " a year"
                                        ]
                                    }),
                                    " in the first year."
                                ]
                            }),
                            w && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                "data-testid": "cp-why-pension-count",
                                children: [
                                    "With this plan, ",
                                    (0, $4876815f03a5e1e6$export$47e779574a8223ac)(w, v.their)
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-slate-600",
                                children: "A funeral bond within the limit and a gift within the free area are not counted at all; a guaranteed income is counted at 60% of what went in (30% later); super and an investment bond are counted like the savings they replace."
                            })
                        ]
                    });
                })() : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "space-y-3 text-[14px] leading-relaxed text-slate-700",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                "Money in, less money out, in the first year: ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: (0, $db27db5ed814451d$export$202882938379ba30)(cashOf(why.row))
                                }),
                                ". Changing nothing: ",
                                (0, $db27db5ed814451d$export$202882938379ba30)(cashOf(base)),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-[13px] text-slate-600",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db27db5ed814451d$export$c8225646f50a07d8), {
                                rows: why.row.projections?.[0]?.cashFlowBreakdown
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $3c19f7e7397007b7$export$2e2bcd8739ae039 = $3c19f7e7397007b7$var$CpPlansView;


/**
 * The cashflow & Age Pension plan page (cashflow rebuild, 21 Oct 2026; the agreed mock-up's j1-hub and
 * j2-hub, the village's RvHub).
 *
 * Where the module opens once a plan is chosen — from Home, the client menu or Support at home's door —
 * with everything as it was left (review, 18 Oct 2026: "a saved plan opens a blank page; the support cost,
 * the option and the years are all lost"). Every figure is the chosen card's own, as it was chosen.
 *
 * BUILT FROM THE SHARED CHOSEN-PLAN PIECES (owner, 22 Oct 2026: "Yes i want this all consistent"): the card,
 * the document and next step, "Model something else" and the ways on are aged care's (ChosenPlanPage.tsx),
 * not this page's own. The support cost it was priced on stays above the card, with "Change it".
 */ 
parcelRequire("acw62");








const $d068eb2c3c41b4f7$var$dateWords = (iso)=>iso ? new Date(iso).toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }) : null;
/** The plan's key fact, as its card said it when chosen ("Worth knowing"). */ function $d068eb2c3c41b4f7$var$keyFactOf(card, candidate) {
    const m = candidate ? (0, $4876815f03a5e1e6$export$7b3fc74da8f66f1)(candidate) : null;
    const annuity = m?.annuity || card.annuity?.amount || 0;
    const guaranteed = m ? m.annuityType === 'guaranteed' : card.annuity?.type === 'guaranteed';
    const residual = m ? m.residual : (card.annuity?.residualPercent || 0) / 100;
    if (annuity > 0 && !guaranteed && residual <= 0) return 'The guaranteed income is income only. It pays the most for life, and nothing from it goes back to the family, even after an early death.';
    if (annuity > 0) return `The ${(0, $db27db5ed814451d$export$5517df3497010beb)(annuity)} is committed for life.${guaranteed ? ' It pays the least income of the three types, in return for the full amount back to the family.' : ' The money back to the family falls over time, to nothing later in life.'}`;
    const pensionSame = !card.baseline || Math.abs(card.plan.pension - card.baseline.pension) < 1;
    if (m && (m.superTotal > 0 || m.investmentBond > 0) && pensionSame) return 'This is about tax, not the Age Pension: Centrelink counts the money the same way it counts the savings it replaces.';
    return null;
}
const $d068eb2c3c41b4f7$var$CpHub = ({ factFind: factFind, card: card, candidate: candidate = null, chosenOn: chosenOn, soaPreparedAt: soaPreparedAt, onChangeSupport: onChangeSupport, onExplain: onExplain, onRisks: onRisks, onAdvice: onAdvice, onAllPlans: onAllPlans, onBuild: onBuild, onBuildNew: onBuildNew, outOfDate: outOfDate = null, onQuote: onQuote, onAssumptions: onAssumptions, onHome: onHome, onStartFresh: onStartFresh, onChangeSupportFirst: onChangeSupportFirst, back: back })=>{
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const base = card.baseline;
    const delta = base ? card.plan.legacy - base.legacy : null;
    const prepared = $d068eb2c3c41b4f7$var$dateWords(soaPreparedAt);
    const pDelta = base ? card.plan.pension - base.pension : 0;
    const tied = candidate ? (0, $4876815f03a5e1e6$export$2188ff7ffabde39e)(candidate) : 0;
    const keyFact = $d068eb2c3c41b4f7$var$keyFactOf(card, candidate);
    /* The strip of figures (owner, 22 Oct 2026): the Age Pension, each year's money, and what it puts out of reach. */ const figures = [
        {
            label: 'Age Pension',
            value: (0, $db27db5ed814451d$export$5517df3497010beb)(card.plan.pension),
            unit: 'a year',
            note: base ? Math.abs(pDelta) >= 1 ? `${(0, $db27db5ed814451d$export$a785de3a2a8dd1aa)(pDelta)} a year vs changing nothing` : 'the same as changing nothing' : undefined,
            testId: 'cp-hub-pension'
        },
        {
            // "Each year, short by" when a year runs short, as aged care and support at home say it (22 Oct 2026).
            label: card.plan.cashflow < 0 ? 'Each year, short by' : 'Left over each year',
            value: (0, $db27db5ed814451d$export$5517df3497010beb)(Math.abs(card.plan.cashflow)),
            note: base ? `changing nothing: ${(0, $db27db5ed814451d$export$202882938379ba30)(base.cashflow)}` : undefined,
            tone: card.plan.cashflow > 0 ? 'good' : 'plain',
            testId: 'cp-hub-each-year'
        }
    ];
    if (tied > 0) figures.push({
        label: 'Put out of reach',
        value: (0, $db27db5ed814451d$export$5517df3497010beb)(tied),
        note: 'gifted, kept for the funeral or committed for life',
        testId: 'cp-hub-tied-up'
    });
    const options = [];
    if (onStartFresh) options.push({
        title: 'A new model from scratch',
        body: 'Starts again at step 1 with nothing carried over, and asks the three questions again so you can change any of them.',
        action: 'Start a new model from scratch',
        onClick: onStartFresh,
        testId: 'cp-hub-start-fresh'
    });
    if (onChangeSupportFirst) options.push({
        title: 'Change the support first',
        body: 'Keeps the answers to the three questions. Starts at step 1 so you can change the support paid for, then tests the plans again.',
        action: 'Change the support',
        onClick: onChangeSupportFirst,
        testId: 'cp-hub-change-support-first'
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        "data-testid": "cp-hub",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[13px] text-slate-500",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onHome,
                                className: "underline decoration-dotted underline-offset-2 hover:text-slate-800",
                                children: "Home"
                            }),
                            " \u203A Cashflow & Age Pension",
                            back && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    " \xb7 ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: back.onClick,
                                        className: "underline decoration-dotted underline-offset-2 hover:text-slate-800",
                                        "data-testid": "cp-hub-back",
                                        children: back.label
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "mt-2 text-[32px] font-bold leading-tight tracking-tight text-brand-navy",
                        "data-testid": "cp-hub-title",
                        children: v.you ? 'Your money plan' : `${v.Possessive} money plan`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1 text-[15px] text-slate-600",
                        children: [
                            card.support.annual > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "With ",
                                    (0, $db27db5ed814451d$export$5517df3497010beb)(card.support.annual),
                                    " a year of ",
                                    card.support.label.toLowerCase(),
                                    "."
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: "With no support paid for."
                            }),
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onChangeSupport,
                                className: (0, $db27db5ed814451d$export$9c30223ca0a664fb),
                                "data-testid": "cp-hub-change-support",
                                children: "Change it"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e32778aa0d8016bc$export$582b8e8b67199c5d), {
                reason: outOfDate,
                onChooseAgain: onAllPlans,
                testId: "cp-hub-out-of-date"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b200f9f0b001184e$export$14ec62d97a734af3), {
                testIdPrefix: "cp-hub",
                chosenOn: $d068eb2c3c41b4f7$var$dateWords(chosenOn),
                builtByYou: card.origin === 'manual',
                title: card.words.title,
                sub: card.words.sub,
                estate: card.plan.legacy,
                years: card.horizonYears,
                estateDelta: delta,
                baseWord: "changing nothing",
                figures: figures,
                onExplain: onExplain,
                onRisks: onRisks,
                onAllPlans: onAllPlans,
                children: [
                    (()=>{
                        const line = card.rows && card.rows.length ? (0, $2ddaae90639b5011$export$7526d1fcb4423629)({
                            rows: card.rows,
                            factFind: factFind,
                            horizonYears: card.horizonYears
                        }) : null;
                        return line ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "mb-4 text-[14px] leading-relaxed text-slate-700",
                            "data-testid": "cp-hub-runline",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    className: "text-slate-900",
                                    children: "When the money runs out:"
                                }),
                                " ",
                                line
                            ]
                        }) : null;
                    })(),
                    card.family && card.family.rows.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
                        factFind: factFind,
                        personName: card.family.personName,
                        amount: card.family.amount,
                        kind: card.family.kind,
                        incomeAYear: card.family.incomeAYear,
                        rows: null,
                        frozen: card.family.rows,
                        compareNote: card.family.compareNote,
                        horizonYears: card.horizonYears,
                        testId: "cp-hub-family-panel"
                    }),
                    keyFact && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: `${card.family && card.family.rows.length > 0 ? 'mt-4 ' : ''}text-[13px] leading-relaxed text-slate-700`,
                        "data-testid": "cp-hub-key-fact",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "text-slate-900",
                                children: "Worth knowing:"
                            }),
                            " ",
                            keyFact
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "cp-hub-next",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b200f9f0b001184e$export$402ee133f3748280), {
                    documentState: prepared ? `prepared ${prepared}` : 'not prepared yet',
                    documentLine: "The written record of this plan, what it changes and why.",
                    documentAction: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onAdvice,
                        className: (0, $db27db5ed814451d$export$9c30223ca0a664fb),
                        "data-testid": "cp-hub-advice",
                        children: "Get the advice document"
                    }),
                    nextTitle: card.annuity ? 'get a quote from the provider' : 'tell Services Australia',
                    nextLine: card.annuity ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "The income shown for the ",
                            (0, $db27db5ed814451d$export$5517df3497010beb)(card.annuity.amount),
                            " guaranteed income is an estimate from the published rate; a quote may differ. ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onQuote,
                                className: (0, $db27db5ed814451d$export$9c30223ca0a664fb),
                                "data-testid": "cp-hub-quote",
                                children: "Enter the quote"
                            }),
                            ", or see the"
                        ]
                    }) : 'Each change moves what Centrelink counts. Report it within 14 days so the Age Pension is worked out on the new figures. See the',
                    nextAction: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onHome,
                        className: (0, $db27db5ed814451d$export$9c30223ca0a664fb),
                        "data-testid": "cp-hub-home-plan",
                        children: "Full action plan on Home"
                    })
                })
            }),
            options.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b200f9f0b001184e$export$9e6485da48da532f), {
                options: options,
                testId: "cp-hub-model-something-else"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b200f9f0b001184e$export$29d0c084f57dd4ac), {
                links: [
                    {
                        label: 'All the plans we tested',
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e583651be68dae50$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        onClick: onAllPlans,
                        testId: 'cp-hub-link-all-plans'
                    },
                    // Two doors (owner, 25 Oct 2026): change this plan, or start a blank one.
                    {
                        label: card.origin === 'manual' ? 'Change the plan you built' : 'Customise this plan',
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $712d717556ef1508$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        onClick: onBuild,
                        testId: 'cp-hub-build'
                    },
                    ...onBuildNew ? [
                        {
                            label: 'Build a plan yourself',
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $712d717556ef1508$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            onClick: onBuildNew,
                            testId: 'cp-hub-build-new'
                        }
                    ] : [],
                    {
                        label: `${v.Possessive} money today`,
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33b542e8915cec79$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        onClick: onChangeSupport,
                        testId: 'cp-hub-money-today'
                    },
                    {
                        label: 'Rates and assumptions',
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        onClick: onAssumptions,
                        testId: 'cp-hub-assumptions'
                    }
                ]
            })
        ]
    });
};
var $d068eb2c3c41b4f7$export$2e2bcd8739ae039 = $d068eb2c3c41b4f7$var$CpHub;


/**
 * "Build a plan yourself" — cashflow & Age Pension's ledger (cashflow rebuild, 21 Oct 2026; the village's
 * RvBuildPlan, owner rulings 20 Oct 2026: ONE ledger reached by a link, not a mode chooser, with the live
 * effect beside it and the same Explain this / What could go wrong / Choose as the tested plans).
 *
 * One picture of the money: where it comes from (each account the client could move, in the order it is
 * drawn — cash first, shares last — with the money kept for emergencies), where it goes (a funeral bond, a
 * gift, a guaranteed income, after-tax super, an investment bond, off the debts), and what is still free to
 * place. Beside it, what the plan does against changing nothing, updating as it changes.
 *
 * Presentation over the page's Manual Control state: every input writes the allocation the page turns into
 * the SAME candidate the engine ranks (manualCandidateFrom), evaluated by the same call.
 */ 
parcelRequire("acw62");





const $ea387582edc92e02$var$KIND_WORDS = {
    bankAccounts: 'Cash goes first: nothing to sell, and no tax on taking it out.',
    termDeposits: 'No tax on taking it out; a break fee before the term ends is not modelled.',
    shares: 'Shares come last: selling them can realise capital gains tax, which is not modelled here, so check it with a tax agent.'
};
const $ea387582edc92e02$var$CpBuildPlan = (p)=>{
    const { factFind: factFind, sources: sources, reserve: reserve, allocation: allocation, effect: effect } = p;
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const available = sources.reduce((t, s)=>t + s.value, 0);
    const allocated = (0, $2663acaa6cb9dd5e$export$cdf8b234292e0c72)(allocation);
    const draw = (0, $2663acaa6cb9dd5e$export$bc295484d84d1d5d)(sources, Math.min(allocated, available));
    const takenFrom = (s)=>draw.filter((d)=>d.type === s.type && d.id === s.id).reduce((t, d)=>t + d.amountToTake, 0);
    const free = available - reserve - allocated;
    const canChoose = allocated > 0 && !p.erroredWords && !p.chooseHeld && free + reserve >= 0 && effect.legacy != null && !p.working;
    const effectPanel = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `${(0, $db27db5ed814451d$export$aa3e815946b80764)} xl:sticky xl:top-8`,
        "data-testid": "cp-build-effect",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] font-bold text-brand-navy",
                children: [
                    "Effect on the plan ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-normal text-slate-500",
                        children: "\u2014 updates as you go"
                    })
                ]
            }),
            allocated <= 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-[14px] text-slate-600",
                children: "Put an amount somewhere on the left and the figures appear here, against changing nothing."
            }) : p.erroredWords ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-[14px] text-slate-700",
                "data-testid": "cp-build-errored",
                children: p.erroredWords
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                className: "mt-2 w-full text-[14px] tabular-nums",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "border-b border-slate-100",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-slate-600",
                                    children: [
                                        "Left to the family, about ",
                                        p.horizonYears,
                                        " years"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-right",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: effect.legacy == null || p.working ? "\u2026" : (0, $db27db5ed814451d$export$5517df3497010beb)(effect.legacy)
                                        }),
                                        effect.legacy != null && effect.baseLegacy != null && !p.working && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: `text-[12.5px] ${effect.legacy >= effect.baseLegacy ? 'text-emerald-700' : 'text-rose-700'}`,
                                                    children: [
                                                        (0, $db27db5ed814451d$export$a785de3a2a8dd1aa)(effect.legacy - effect.baseLegacy),
                                                        " vs changing nothing"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "border-b border-slate-100",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "py-2 text-slate-600",
                                    children: "Each year"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-right",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            className: (effect.cashflow ?? 0) >= 0 ? 'text-emerald-700' : 'text-rose-700',
                                            children: effect.cashflow == null || p.working ? "\u2026" : (0, $db27db5ed814451d$export$202882938379ba30)(effect.cashflow)
                                        }),
                                        effect.cashflow != null && effect.baseCashflow != null && !p.working && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: `text-[12.5px] ${effect.cashflow - effect.baseCashflow >= 0 ? 'text-emerald-700' : 'text-rose-700'}`,
                                                    children: [
                                                        (0, $db27db5ed814451d$export$a785de3a2a8dd1aa)(effect.cashflow - effect.baseCashflow),
                                                        " a year vs changing nothing"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "py-2 text-slate-600",
                                    children: "Age Pension"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    className: "py-2 text-right",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: effect.pension == null || p.working ? "\u2026" : (0, $db27db5ed814451d$export$5517df3497010beb)(effect.pension)
                                        }),
                                        " a year",
                                        effect.pension != null && effect.basePension != null && !p.working && Math.abs(effect.pension - effect.basePension) >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: `text-[12.5px] ${effect.pension > effect.basePension ? 'text-emerald-700' : 'text-rose-700'}`,
                                                    children: [
                                                        (0, $db27db5ed814451d$export$a785de3a2a8dd1aa)(effect.pension - effect.basePension),
                                                        " vs changing nothing"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-[12.5px] text-slate-500",
                children: "Measured against changing nothing, on the same projection the tested plans use."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 grid grid-cols-2 gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: p.onExplain,
                        disabled: allocated <= 0,
                        className: "inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-[13px] font-semibold text-slate-800 hover:border-blue-300 disabled:opacity-50",
                        "data-testid": "cp-build-explain",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                size: 15
                            }),
                            " Explain this"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: p.onRisks,
                        disabled: allocated <= 0,
                        className: "inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-[13px] font-semibold text-slate-800 hover:border-blue-300 disabled:opacity-50",
                        "data-testid": "cp-build-risks",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4666dd9ae485baaf$export$2e2bcd8739ae039), {
                                size: 15
                            }),
                            " What could go wrong"
                        ]
                    })
                ]
            }),
            p.beforeChoose && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-3",
                "data-testid": "cp-build-before-choose",
                children: p.beforeChoose
            }),
            p.familyPanel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-3",
                children: p.familyPanel
            }),
            free + reserve < 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-3 text-[13px] text-rose-700",
                "data-testid": "cp-build-over",
                children: [
                    "That is ",
                    (0, $db27db5ed814451d$export$5517df3497010beb)(-(free + reserve)),
                    " more than ",
                    v.they,
                    " have to move: take some off."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: canChoose || p.chosen ? p.onChoose : undefined,
                disabled: !canChoose && !p.chosen,
                "aria-pressed": p.chosen,
                className: `mt-3 w-full rounded-lg px-4 py-2.5 text-[14px] font-semibold ${p.chosen ? 'border border-emerald-500 bg-white text-emerald-800' : canChoose ? 'bg-blue-600 text-white hover:bg-blue-700' : 'cursor-not-allowed bg-slate-200 text-slate-500'}`,
                "data-testid": "cp-build-choose",
                children: p.chosen ? "Chosen \u2713" : 'Choose this plan'
            }),
            p.chosen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-2 text-[13px] text-slate-600",
                children: [
                    "Saved with ",
                    v.possessive,
                    " file. ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: p.onAdvice,
                        className: (0, $db27db5ed814451d$export$9c30223ca0a664fb),
                        "data-testid": "cp-build-advice",
                        children: "Get the advice document"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        "data-testid": "cp-build",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "mt-2 text-[28px] font-bold leading-tight tracking-tight text-brand-navy",
                        "data-testid": "cp-build-title",
                        children: p.customising ? 'Customise this plan' : 'Build a plan yourself'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1 text-[15px] leading-relaxed text-slate-600",
                        children: [
                            "Move ",
                            v.possessive,
                            " own money and watch the three figures change. It is tested on the same projection as the plans we tested, against changing nothing."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3 flex flex-wrap items-center gap-2 text-[13px]",
                        "data-testid": "cp-build-start",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-slate-600",
                                children: p.startedFrom ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        p.customising ? 'Customising' : 'Started from',
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            className: "text-slate-900",
                                            children: p.startedFrom
                                        }),
                                        ". Start again from"
                                    ]
                                }) : 'Start from'
                            }),
                            p.startOptions.map((o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>p.onStartFrom(o.id),
                                    className: "rounded-lg border border-slate-300 bg-white px-3 py-1.5 font-semibold text-slate-700 hover:border-blue-300",
                                    children: o.label
                                }, o.id)),
                            p.onClear && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: p.onClear,
                                className: "ml-2 font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                "data-testid": "cp-clear-start-again",
                                children: "Clear and start again"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 gap-5 xl:grid-cols-[1.6fr_1fr]",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $db27db5ed814451d$export$aa3e815946b80764),
                                "data-testid": "cp-build-sources",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-[13px] font-bold text-brand-navy",
                                        children: "Where the money comes from"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                        className: "mt-2 w-full text-[14px]",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                            children: [
                                                sources.map((s)=>{
                                                    const taken = takenFrom(s);
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "border-b border-slate-100 align-top",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "py-2 pr-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        className: "text-slate-900",
                                                                        children: s.description
                                                                    }),
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                        className: "text-slate-500",
                                                                        children: [
                                                                            "\xb7 ",
                                                                            (0, $db27db5ed814451d$export$5517df3497010beb)(s.value)
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                        className: "text-[12.5px] text-slate-500",
                                                                        children: [
                                                                            taken > 0 ? 'Used. ' : 'Kept. ',
                                                                            $ea387582edc92e02$var$KIND_WORDS[s.type] || ''
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "py-2 text-right tabular-nums",
                                                                children: taken > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: (0, $db27db5ed814451d$export$5517df3497010beb)(taken)
                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-slate-400",
                                                                    children: "\u2014"
                                                                })
                                                            })
                                                        ]
                                                    }, `${s.type}-${s.id}`);
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    className: "border-b border-slate-100",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "py-2 text-slate-700",
                                                            children: [
                                                                "Kept in the bank for emergencies ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-[12.5px] text-slate-500",
                                                                    children: "\u2014 drawn on only if a year runs short"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "py-2 text-right tabular-nums",
                                                            children: (0, $db27db5ed814451d$export$5517df3497010beb)(reserve)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "py-2 font-semibold text-slate-900",
                                                            children: "Still free to place"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: `py-2 text-right font-bold tabular-nums ${free < 0 ? 'text-rose-700' : 'text-slate-900'}`,
                                                            "data-testid": "cp-build-free",
                                                            children: (0, $db27db5ed814451d$export$5517df3497010beb)(free)
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mt-2 text-[12.5px] text-slate-500",
                                        children: "The home and any super pension stay as they are. Anything not placed stays in the bank account, as in changing nothing."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1faa9f80daa40f2$export$2e2bcd8739ae039), {
                                factFind: factFind,
                                sources: sources,
                                allocation: allocation,
                                annuityTerms: p.annuityTerms,
                                onAnnuityTermsChange: p.onAnnuityTerms,
                                onChange: p.onAllocation,
                                totalDebt: p.totalDebt,
                                reserve: reserve,
                                onIncomeOnlyUnderstoodChange: p.onIncomeOnlyUnderstoodChange
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: effectPanel
                    })
                ]
            })
        ]
    });
};
var $ea387582edc92e02$export$2e2bcd8739ae039 = $ea387582edc92e02$var$CpBuildPlan;




/** What a cashflow plan pays off (its shared `debtPayoff`). */ const $61e08b09c5525908$var$cpDebtClearedBy = (c)=>Object.values(c?.debtPayoff?.payments || {}).reduce((t, n)=>t + (Number(n) || 0), 0);
const $61e08b09c5525908$var$MANUAL_PLAN_ERRORED = "We couldn\u2019t work your plan out on your figures, so it can\u2019t be saved. Try different amounts.";
const $61e08b09c5525908$var$chosenStateOf = (record)=>{
    const card = (0, $94964a4bbfeb638b$export$d0bed6e7d13194fc)(record);
    if (!record || !card) return null;
    const inputs = record.inputs || {};
    return {
        card: card,
        createdAt: record.createdAt ? String(record.createdAt) : null,
        id: record.id != null ? String(record.id) : null,
        soaPreparedAt: record.soaPreparedAt ? String(record.soaPreparedAt) : null,
        engineId: inputs.engineOptionId != null ? String(inputs.engineOptionId) : null,
        manual: (inputs.source || record.source) === 'manual',
        candidate: inputs.candidate ?? null,
        allocation: inputs.allocation ?? null,
        annuityTerms: inputs.annuityTerms ?? null,
        customisedFrom: typeof record.customisedFrom === 'string' ? record.customisedFrom : null,
        years: Number(inputs.legacyYears) || card.horizonYears
    };
};
/** A tested plan as the hand-built ledger holds it (Customise this plan). */ function $61e08b09c5525908$var$allocationFromCandidate(c) {
    const m = (0, $4876815f03a5e1e6$export$7b3fc74da8f66f1)(c);
    const a = c?.annuity || {};
    return {
        allocation: {
            ...(0, $2663acaa6cb9dd5e$export$8471fcc462280406),
            funeralBond: m.funeralBond,
            gift: m.gift,
            annuity: m.annuity,
            debtRepayment: m.debt,
            superContribution: m.superTotal,
            investmentBond: m.investmentBond
        },
        terms: {
            ...(0, $2663acaa6cb9dd5e$export$8a567aa13eab014b),
            residualCapital: m.annuity > 0 ? m.residual : (0, $2663acaa6cb9dd5e$export$8a567aa13eab014b).residualCapital,
            annuityType: m.annuityType,
            owner: a.ownership === 'partner' ? 'partner' : a.ownership === 'joint' ? 'joint' : 'client',
            reversionary: !!a.reversionary,
            indexation: !!a.indexation,
            incomeOverride: Number(a.incomeOverride) > 0 ? Number(a.incomeOverride) : null
        }
    };
}
const $61e08b09c5525908$var$CashflowPensionPage = ({ setActivePage: setActivePage, factFind: factFind, onIncomeOnlyUnderstoodChange: onIncomeOnlyUnderstoodChange, onGuaranteedIncomeGoals: onGuaranteedIncomeGoals, onCashflowGoals: onCashflowGoals, setSavedStrategies: setSavedStrategies, savedStrategies: savedStrategies, cameFrom: cameFrom, onSoaGenerated: onSoaGenerated })=>{
    /*
     * "Start a new model" from Home (one-shot): an empty step 1 and the questions asked again; the chosen plan
     * stays chosen until a new one is chosen.
     */ const [startFresh] = (0, $acw62.useState)(()=>(0, $94964a4bbfeb638b$export$b352889aabc51046)((0, $94964a4bbfeb638b$export$ee6e400ca50ecedf)));
    /*
     * A saved plan being reopened: Home's hand-off (CASHFLOW_REOPEN_KEY), or the file's chosen plan when the
     * page is opened from another door. Read once, before any other state, so every input starts where the
     * plan was saved; the hand-off is cleared in an effect, so a second render cannot lose it.
     */ const [reopened] = (0, $acw62.useState)(()=>startFresh ? null : (0, $2663acaa6cb9dd5e$export$9ca6d4362a508002)() ?? (0, $2663acaa6cb9dd5e$export$65cd5313ae403f79)((0, $94964a4bbfeb638b$export$ce1dae2ac0d07e63)(savedStrategies)));
    (0, $acw62.useEffect)(()=>{
        try {
            sessionStorage.removeItem((0, $2663acaa6cb9dd5e$export$bcc8e45d2598fb47));
        } catch  {}
    }, []);
    const [chosen, setChosen] = (0, $acw62.useState)(()=>$61e08b09c5525908$var$chosenStateOf((0, $94964a4bbfeb638b$export$ce1dae2ac0d07e63)(savedStrategies)) ?? (reopened?.card && reopened.chosen ? $61e08b09c5525908$var$chosenStateOf({
            inputs: {
                card: reopened.card,
                engineOptionId: reopened.engineOptionId,
                legacyYears: reopened.legacyYears,
                source: reopened.mode === 'manual' ? 'manual' : 'suggestion_engine'
            },
            createdAt: reopened.createdAt,
            id: reopened.id,
            soaPreparedAt: reopened.soaPreparedAt
        }) : null));
    const v = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const [view, setView] = (0, $acw62.useState)(()=>reopened?.card && chosen ? 'hub' : 'steps');
    const [step, setStep] = (0, $acw62.useState)(()=>reopened && !reopened.card ? 3 : 1);
    const [asking, setAsking] = (0, $acw62.useState)(()=>startFresh || !reopened && factFind?.goals?.cpLevers == null);
    const [focus, setFocus] = (0, $acw62.useState)('legacy');
    const goToStep = (s)=>{
        setView('steps');
        setStep(s);
        try {
            window.scrollTo?.(0, 0);
        } catch  {}
    };
    const [years, setYears] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [legacyYears, setLegacyYears] = (0, $acw62.useState)(()=>reopened?.legacyYears || 10);
    /*
     * The support cost is held HERE, not on the fact-find (owner direction). It is the client's figure, taken
     * from their provider's bill; it is only kept if they choose a plan.
     */ const [supportAnnual, setSupportAnnual] = (0, $acw62.useState)(()=>reopened && reopened.supportCostAnnual > 0 ? reopened.supportCostAnnual : '');
    const [supportLabel, setSupportLabel] = (0, $acw62.useState)(()=>reopened?.supportCostLabel || 'Support at home services');
    const supportCost = (0, $acw62.useMemo)(()=>typeof supportAnnual === 'number' && supportAnnual > 0 ? {
            annual: supportAnnual,
            label: supportLabel
        } : null, [
        supportAnnual,
        supportLabel
    ]);
    /*
     * NET WORTH TODAY CANNOT DEPEND ON THE SUPPORT COST (review of Joe and Kim Smith's file, 18 Oct 2026:
     * entering a support cost moved "Net worth today" from $3,823,397 to $3,815,398). "Today" is read from the
     * run WITHOUT the support cost; the figures about the year ahead come from the run with it.
     */ const [todayYears, setTodayYears] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        setLoading(true);
        setError(null);
        Promise.all([
            (0, $2663acaa6cb9dd5e$export$78ad5907e1d0a084)(factFind, {
                legacyYears: legacyYears,
                supportCost: supportCost
            }),
            supportCost ? (0, $2663acaa6cb9dd5e$export$78ad5907e1d0a084)(factFind, {
                legacyYears: legacyYears,
                supportCost: null
            }) : Promise.resolve(null)
        ]).then(([result, withoutSupport])=>{
            if (cancelled) return;
            setYears(result);
            setTodayYears(withoutSupport ?? result);
            setLoading(false);
        }).catch((e)=>{
            if (cancelled) return;
            setError(e instanceof Error ? e.message : 'Could not work out your position.');
            setLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind,
        legacyYears,
        supportCost
    ]);
    /*
     * WHAT THEY OWN TODAY IS TODAY'S POSITION (live review, 22 Oct 2026): the first projection row closes a year
     * on, with a year's growth in it — $3,089,217 where every other module showed $3,020,000 for the same
     * file. It is read from today's financials, as downsizing and granny flat read it, falling back to the run.
     */ const [todayNetWorth, setTodayNetWorth] = (0, $acw62.useState)(null);
    /* Today's financials whole, too: the year-by-year figures open from them, as downsizing's do (22 Oct 2026). */ const [todayFinancials, setTodayFinancials] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (0, $55a1d8a64f1e5dfa$export$463f0620dd36e1f8)(factFind).then((r)=>{
            if (!cancelled) {
                setTodayNetWorth(Number.isFinite(Number(r?.netWorth)) ? Number(r?.netWorth) : null);
                setTodayFinancials(r || null);
            }
        }).catch(()=>{
            if (!cancelled) {
                setTodayNetWorth(null);
                setTodayFinancials(null);
            }
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind
    ]);
    const position = (0, $acw62.useMemo)(()=>{
        const summary = years ? (0, $2663acaa6cb9dd5e$export$bb519fac30b1105e)(years) : null;
        const today = todayYears?.[0];
        // Today's net worth: today's financials, else the run without the support cost (see above).
        if (!summary) return summary;
        if (todayNetWorth != null) return {
            ...summary,
            netWorth: todayNetWorth
        };
        return today ? {
            ...summary,
            netWorth: Number(today.netWorth) || 0
        } : summary;
    }, [
        years,
        todayYears,
        todayNetWorth
    ]);
    const first = years?.[0];
    /** The year the "today" figures are read from: the first year WITHOUT the support cost. */ const todayFirst = todayYears?.[0] ?? first;
    /* ─── The tested plans ─── */ const [strategies, setStrategies] = (0, $acw62.useState)(null);
    const [strategiesLoading, setStrategiesLoading] = (0, $acw62.useState)(false);
    const [strategiesError, setStrategiesError] = (0, $acw62.useState)(null);
    /* 'manual' is the "Build a plan yourself" ledger, reached by a link (no mode chooser). */ const [strategyMode, setStrategyMode] = (0, $acw62.useState)(()=>reopened?.mode === 'manual' ? 'manual' : 'optimised');
    const [allocation, setAllocation] = (0, $acw62.useState)(()=>reopened?.allocation ?? (0, $2663acaa6cb9dd5e$export$8471fcc462280406));
    /* The annuity's TERMS, held beside the amount (allocationTotal sums the allocation map). */ const [annuityTerms, setAnnuityTerms] = (0, $acw62.useState)(()=>reopened?.annuityTerms ?? (0, $2663acaa6cb9dd5e$export$8a567aa13eab014b));
    /*
     * A QUOTE BELONGS TO ONE TYPE AND ONE AMOUNT (owner, 21 Oct 2026; annuityQuote.ts): the type and amount of
     * the plan it was entered on. Plans of the same type use it scaled to their own amount; the others keep our
     * estimate. The draft being typed is kept apart, so a digit does not fire a run.
     */ const [seAnnuityQuote, setSeAnnuityQuote] = (0, $acw62.useState)(()=>reopened?.annuityQuote && reopened.annuityQuoteFor ? {
            income: reopened.annuityQuote,
            amount: reopened.annuityQuoteFor.amount,
            shape: reopened.annuityQuoteFor.shape
        } : null);
    const [seAnnuityQuoteDraft, setSeAnnuityQuoteDraft] = (0, $acw62.useState)(()=>reopened?.annuityQuote ?? '');
    const [manualResult, setManualResult] = (0, $acw62.useState)(null);
    const [manualLoading, setManualLoading] = (0, $acw62.useState)(false);
    /* The plans themselves, kept so a choice records exactly what was run (the Action Plan rebuilds from them). */ const [manualCandidate, setManualCandidate] = (0, $acw62.useState)(null);
    const [engineCandidates, setEngineCandidates] = (0, $acw62.useState)([]);
    const [manualStartedFrom, setManualStartedFrom] = (0, $acw62.useState)(null);
    /** The TESTED plan the hand-built one was copied from ("Customise this plan", 25 Oct 2026); null for a blank start. */ const [manualCustomisedFrom, setManualCustomisedFrom] = (0, $acw62.useState)(null);
    const [saveNote, setSaveNote] = (0, $acw62.useState)('');
    /** The tested plan chosen ON THESE INPUTS — it lights its card; a change of inputs lets it go. */ const [selectedEngineId, setSelectedEngineId] = (0, $acw62.useState)(()=>reopened?.mode === 'manual' ? null : reopened?.engineOptionId ?? null);
    /** A line saying the chosen plan is no longer offered, or could not be worked out. */ const [reopenNote, setReopenNote] = (0, $acw62.useState)(null);
    const [explain, setExplain] = (0, $acw62.useState)(null);
    const [risk, setRisk] = (0, $acw62.useState)(null);
    /** An action asked for on the plan page that needs the plans re-run first. */ const [pending, setPending] = (0, $acw62.useState)(null);
    /** A plan's year-by-year figures, opened from its Explain this. */ const [yearByYear, setYearByYear] = (0, $acw62.useState)(null);
    const sources = (0, $acw62.useMemo)(()=>(0, $2663acaa6cb9dd5e$export$a6b5e1b0a97dc6ff)(factFind), [
        factFind
    ]);
    // The debts Manual Control can actually repay — the same list the payoff is built from.
    const totalDebt = (0, $acw62.useMemo)(()=>(0, $2663acaa6cb9dd5e$export$d9e7ffb0b289bb15)(factFind).reduce((sum, d)=>sum + d.balance, 0), [
        factFind
    ]);
    const reserve = (0, $cc855f77b4e7e2d7$export$c44200ae02a0feac)(factFind);
    /*
     * Re-rank when the quote is committed. Only when plans are already showing: before the client has asked
     * for them there is nothing to re-rank.
     */ (0, $acw62.useEffect)(()=>{
        if (strategyMode !== 'optimised') return;
        if (!strategies && !strategiesLoading) return;
        loadStrategies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        seAnnuityQuote
    ]);
    /*
     * Each run is numbered, and only the latest may land. Without this a run started before the support cost
     * changed could finish after the change and put the old plans back on screen.
     */ const runSeq = (0, $acw62.useRef)(0);
    const loadStrategies = async ()=>{
        const seq = ++runSeq.current;
        setStrategiesLoading(true);
        setStrategiesError(null);
        try {
            const candidates = (0, $cc855f77b4e7e2d7$export$1ae058badd5eea31)(factFind, seAnnuityQuote);
            const results = await (0, $55a1d8a64f1e5dfa$export$e95a0c7472081943)(factFind, candidates, legacyYears, supportCost?.annual || 0);
            if (seq !== runSeq.current) return;
            setEngineCandidates(candidates);
            setStrategies(results || []);
        } catch (e) {
            if (seq !== runSeq.current) return;
            setStrategiesError(e instanceof Error ? e.message : "We couldn\u2019t model the plans just now.");
        } finally{
            if (seq === runSeq.current) setStrategiesLoading(false);
        }
    };
    /*
     * A manual allocation is turned into the SAME candidate shape the engine ranks, and evaluated by the same
     * call. Two code paths to one answer is how a module comes to show a client two numbers for one plan.
     */ (0, $acw62.useEffect)(()=>{
        if (strategyMode !== 'manual') return undefined;
        const allocated = (0, $2663acaa6cb9dd5e$export$cdf8b234292e0c72)(allocation);
        // Nothing to run: not working either (a run cancelled mid-flight must not leave the panel on "…").
        if (allocated <= 0) {
            setManualResult(null);
            setManualLoading(false);
            return undefined;
        }
        let cancelled = false;
        setManualLoading(true);
        const timer = setTimeout(()=>{
            // The file too, so "Off your debt" becomes a real payoff against its liabilities.
            const candidate = (0, $2663acaa6cb9dd5e$export$f9c2275cb7305f03)(allocation, annuityTerms, sources, factFind);
            setManualCandidate(candidate);
            (0, $55a1d8a64f1e5dfa$export$e95a0c7472081943)(factFind, [
                {
                    id: 'cp-nothing',
                    name: 'Change nothing',
                    description: '',
                    changeNothing: true
                },
                candidate
            ], legacyYears, supportCost?.annual || 0).then((r)=>{
                if (!cancelled) setManualResult(r || []);
            }).catch(()=>{
                if (!cancelled) setManualResult(null);
            }).finally(()=>{
                if (!cancelled) setManualLoading(false);
            });
        }, 500); // typing settles before a full projection is run
        return ()=>{
            cancelled = true;
            clearTimeout(timer);
        };
    }, [
        strategyMode,
        allocation,
        annuityTerms,
        sources,
        factFind,
        legacyYears,
        supportCost
    ]);
    /*
     * Any change to the inputs invalidates a ranking built on the old ones — AND THE CHOICE MADE ON IT (review,
     * 18 Oct 2026: changing the support cost cleared the options but kept the selection). Compared against the
     * last inputs, so opening the page does not count as a change. The client's income-only confirmation is
     * not an input to any figure, so ticking it does not re-test the plans under the reader.
     */ const calcKey = (0, $acw62.useMemo)(()=>{
        const goals = {
            ...factFind?.goals || {}
        };
        delete goals.incomeOnlyConfirmation;
        delete goals.incomeOnlyUnderstood;
        return JSON.stringify({
            ...factFind,
            goals: goals
        });
    }, [
        factFind
    ]);
    const lastInputs = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const now = {
            calcKey: calcKey,
            legacyYears: legacyYears,
            supportAnnual: supportCost?.annual ?? 0
        };
        const before = lastInputs.current;
        lastInputs.current = now;
        if (!before) return;
        if (before.calcKey === now.calcKey && before.legacyYears === now.legacyYears && before.supportAnnual === now.supportAnnual) return;
        runSeq.current += 1; // a run in flight was started on the old inputs
        setStrategiesLoading(false);
        setStrategiesError(null);
        setStrategies(null);
        setSelectedEngineId(null);
        setReopenNote(null);
        setSaveNote('');
    }, [
        calcKey,
        legacyYears,
        supportCost
    ]);
    /* Step 3 runs the plans on its own once the questions are answered, and again after any change of input. */ (0, $acw62.useEffect)(()=>{
        if (view !== 'steps' || step !== 3 || strategyMode !== 'optimised' || asking) return;
        if (strategies || strategiesLoading || strategiesError) return;
        loadStrategies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        view,
        step,
        strategyMode,
        asking,
        strategies,
        strategiesLoading,
        strategiesError
    ]);
    /*
     * The chosen plan is checked against every new run: one no longer offered, or that the engine could not
     * work out this time, is let go with a plain line saying why. A chosen plan priced on the same inputs
     * lights its card again.
     */ (0, $acw62.useEffect)(()=>{
        if (!strategies) return;
        if (!selectedEngineId && chosen && !chosen.manual && chosen.engineId && !(0, $94964a4bbfeb638b$export$5cbbd0676ba1975c)(chosen.card, supportCost?.annual ?? 0) && chosen.years === legacyYears) {
            const again = strategies.find((s)=>s.id === chosen.engineId && !s.error);
            if (again) {
                setSelectedEngineId(again.id);
                return;
            }
        }
        if (!selectedEngineId) return;
        const match = strategies.find((s)=>s.id === selectedEngineId);
        if (match && !match.error) return;
        setSelectedEngineId(null);
        setReopenNote(match?.error ? "The plan you had chosen couldn\u2019t be worked out on your current figures. It stays chosen until you choose again." : 'The plan you had chosen is no longer among those tested on your current figures. It stays chosen until you choose again.');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        strategies,
        selectedEngineId
    ]);
    /* ─── Reading a plan ─── */ const candidateOf = (row)=>engineCandidates.find((c)=>c.id === row?.id) ?? null;
    /*
     * THE GUARANTEED INCOME IN A TESTED PLAN (owner, 21 Oct 2026). Read from the candidate as run, so the panel,
     * the confirmation, the quote and the document describe the same product. Every such plan buys it in the
     * client's name and does nothing else, so changing nothing IS the same plan without it.
     */ const optionAnnuityOf = (option)=>{
        const a = candidateOf(option)?.annuity;
        const amount = Number(a?.purchaseAmount) || 0;
        if (!a || !(amount > 0)) return null;
        const residualCapital = Number(a.residualCapital) || 0;
        return {
            amount: amount,
            annuityType: String(a.annuityType || 'lifetime'),
            residualCapital: residualCapital,
            kind: (0, $8665f80549f60a1b$export$3ab75b1250c8af22)({
                annuityType: a.annuityType,
                residualCapital: residualCapital
            }),
            incomeOnly: (0, $5eae79c7e46ed27e$export$3c8a471078a7436)({
                purchaseAmount: amount,
                annuityType: a.annuityType,
                residualCapital: residualCapital
            })
        };
    };
    /*
     * INCOME ONLY NEEDS THE CLIENT'S TICK (owner, 21 Oct 2026): a plan whose guaranteed income returns nothing
     * cannot be chosen (and so saved, or advised on) until the client has confirmed it for that amount. Held only
     * where the tick can be given (App passes the writer).
     */ const setIncomeOnlyUnderstood = onIncomeOnlyUnderstoodChange;
    const engineIncomeOnlyHeld = (option)=>{
        const optionAnnuity = optionAnnuityOf(option);
        return !!setIncomeOnlyUnderstood && (0, $5eae79c7e46ed27e$export$655f124668ce439a)(factFind, !!optionAnnuity?.incomeOnly, optionAnnuity?.amount ?? 0);
    };
    const manualIncomeOnly = strategyMode === 'manual' && allocation.annuity >= (0, $f1faa9f80daa40f2$export$e63473be6d7e0dc0) && Math.round(annuityTerms.residualCapital * 100) <= 0 && annuityTerms.annuityType !== 'guaranteed';
    const manualIncomeOnlyHeld = !!setIncomeOnlyUnderstood && (0, $5eae79c7e46ed27e$export$655f124668ce439a)(factFind, manualIncomeOnly, Number(allocation?.annuity) || 0);
    const clientName = factFind?.client?.firstName || (v.you ? 'you' : 'the client');
    const nothingOf = (list)=>list?.find((s)=>s.changeNothing && !s.error) ?? null;
    const changeNothingRun = nothingOf(strategies);
    /*
     * THE CHOSEN PLAN'S FIGURES FOLLOW ITS RE-TEST (owner, 25 Oct 2026: as aged care and Support at home). Tested
     * again over the same years and the same support cost, the chosen tested plan is brought up to date on its record
     * and on the plan page, or marked out of date where the run no longer has it.
     */ (0, $acw62.useEffect)(()=>{
        if (!chosen || chosen.manual || !chosen.engineId || !strategies || strategiesLoading || !setSavedStrategies) return;
        if (Number(chosen.years) !== Number(legacyYears) || Math.round(Number(chosen.card.support?.annual) || 0) !== Math.round(Number(supportCost?.annual) || 0)) return;
        const row = strategies.find((s)=>s.id === chosen.engineId && !s.error) ?? null;
        const base = changeNothingRun;
        const plan = row ? {
            legacy: Number(row.snapshot.estate) || 0,
            pension: Number(row.snapshot.pension) || 0,
            cashflow: Number(row.snapshot.cashflow) || 0
        } : null;
        const baseline = base ? {
            legacy: Number(base.snapshot.estate) || 0,
            pension: Number(base.snapshot.pension) || 0,
            cashflow: Number(base.snapshot.cashflow) || 0
        } : null;
        setSavedStrategies((prev)=>{
            const next = plan ? (0, $78a369bbf1e0d995$export$d5989af62c88c0aa)(prev || [], chosen.id, plan, baseline, (0, $78a369bbf1e0d995$export$236630ee0fd3b65b)(factFind)) : (0, $78a369bbf1e0d995$export$91485c71ed77db22)(prev || [], chosen.id, (0, $78a369bbf1e0d995$export$a2028cac13d6740f));
            return next ?? prev;
        });
        if (plan && (Math.round(chosen.card.plan.legacy) !== Math.round(plan.legacy) || Math.round(chosen.card.plan.pension) !== Math.round(plan.pension) || Math.round(chosen.card.plan.cashflow) !== Math.round(plan.cashflow))) setChosen((c)=>c ? {
                ...c,
                card: {
                    ...c.card,
                    plan: plan,
                    ...baseline ? {
                        baseline: baseline
                    } : {}
                }
            } : c);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        strategies,
        strategiesLoading
    ]);
    const manualRow = manualResult?.find((r)=>r.id === 'cp-manual') ?? null;
    const manualNothing = nothingOf(manualResult);
    /** What the family receives from a guaranteed income, against changing nothing (the same plan without it). */ const familyFor = (option, compareRows, testId, personName = clientName)=>{
        const optionAnnuity = optionAnnuityOf(option);
        if (option.error || !optionAnnuity) return null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
            factFind: factFind,
            personName: personName,
            amount: optionAnnuity.amount,
            kind: optionAnnuity.kind,
            incomeAYear: Number(option.annuityTerms?.annualPayment) || null,
            rows: option.projections,
            compareRows: compareRows || null,
            compareNote: compareRows ? 'the same plan without it, the money left in savings' : null,
            horizonYears: legacyYears,
            testId: testId
        });
    };
    /* ─── Choosing ─── */ const leaders = (0, $acw62.useMemo)(()=>(0, $3c19f7e7397007b7$export$78d6356b3b8e19a2)(strategies, engineCandidates), [
        strategies,
        engineCandidates
    ]);
    const soaLeaders = ()=>[
            ...leaders.estate && leaders.estateBeats ? [
                {
                    label: 'Leaves the most',
                    id: leaders.estate.id
                }
            ] : [],
            ...leaders.cashflow ? [
                {
                    label: 'Most left over each year',
                    id: leaders.cashflow.id
                }
            ] : [],
            ...leaders.pension ? [
                {
                    label: 'Highest Age Pension',
                    id: leaders.pension.id
                }
            ] : []
        ];
    /**
     * CHOOSING SAVES THE PLAN, like every module (strategy/chosenPlan.ts): one chosen cashflow plan per file,
     * its card on the record so the plan page shows exactly what was chosen. `type: 'cashflow_pension'` is its
     * OWN type, filed by what it is, not by the door the client came through.
     */ const savePlan = (row, mode)=>{
        const chosen = mode === 'manual' ? manualResult?.find((r)=>r.id === 'cp-manual') : row;
        if (!chosen) {
            setSaveNote(mode === 'manual' ? 'Allocate something above before saving.' : 'Choose one of the options above before saving.');
            return;
        }
        // Nothing the engine could not work out is saved (review, 18 Oct 2026).
        if (chosen.error) {
            setSaveNote(mode === 'manual' ? $61e08b09c5525908$var$MANUAL_PLAN_ERRORED : (0, $3c19f7e7397007b7$export$d7ad7a8376e374d5));
            return;
        }
        const held = mode === 'manual' ? manualIncomeOnlyHeld : engineIncomeOnlyHeld(chosen);
        if (held) return;
        const candidate = mode === 'manual' ? manualCandidate : candidateOf(chosen);
        const base = mode === 'manual' ? manualNothing : changeNothingRun;
        const words = (0, $4876815f03a5e1e6$export$f32c8e12406086f7)(candidate ?? {
            id: chosen.id
        }, factFind);
        const annuityIncome = Number(chosen.annuityTerms?.annualPayment) || null;
        const m = (0, $4876815f03a5e1e6$export$7b3fc74da8f66f1)(candidate);
        const famAnnuity = mode === 'manual' ? m.annuity > 0 ? {
            amount: m.annuity,
            kind: (0, $8665f80549f60a1b$export$3ab75b1250c8af22)({
                annuityType: m.annuityType,
                residualCapital: m.residual
            })
        } : null : optionAnnuityOf(chosen);
        const family = famAnnuity ? (()=>{
            const only = mode !== 'manual' || m.funeralBond + m.gift + m.debt + m.superTotal + m.investmentBond <= 0;
            const built = (0, $66827b1304244a1d$export$11aaa304d9182b)({
                factFind: factFind,
                personName: clientName,
                amount: famAnnuity.amount,
                kind: famAnnuity.kind,
                incomeAYear: annuityIncome,
                rows: chosen.projections,
                compareRows: only ? base?.projections ?? null : null,
                compareNote: only && base ? 'the same plan without it, the money left in savings' : null,
                horizonYears: legacyYears,
                plan: {
                    estate: 0,
                    pension: 0,
                    cashflow: 0
                }
            });
            return built ? {
                personName: clientName,
                amount: famAnnuity.amount,
                kind: famAnnuity.kind,
                incomeAYear: annuityIncome,
                compareNote: built.compareNote,
                rows: built.rows
            } : null;
        })() : null;
        const plan = {
            legacy: chosen.snapshot.estate,
            pension: chosen.snapshot.pension,
            cashflow: chosen.snapshot.cashflow
        };
        const baseline = base ? {
            legacy: base.snapshot.estate,
            pension: base.snapshot.pension,
            cashflow: base.snapshot.cashflow
        } : null;
        const card = {
            plan: plan,
            baseline: baseline,
            words: words,
            horizonYears: legacyYears,
            riskKinds: (0, $4876815f03a5e1e6$export$1555bdcd9f522821)(candidate ?? {
                id: chosen.id
            }),
            pieces: (0, $4876815f03a5e1e6$export$48b7937c00a51078)(candidate),
            why: (0, $4876815f03a5e1e6$export$d9301325205437f6)({
                estate: plan.legacy,
                pension: plan.pension,
                cashflow: plan.cashflow
            }, baseline ? {
                estate: baseline.legacy,
                pension: baseline.pension,
                cashflow: baseline.cashflow
            } : null, candidate, legacyYears, v, annuityIncome),
            support: {
                annual: supportCost?.annual ?? 0,
                label: supportCost?.label ?? supportLabel
            },
            annuity: m.annuity > 0 ? {
                amount: m.annuity,
                type: m.annuityType,
                residualPercent: Math.round(m.residual * 100)
            } : null,
            origin: mode === 'manual' ? 'manual' : 'engine',
            family: family,
            rows: (0, $2ddaae90639b5011$export$30c8cd38763344a6)(chosen.projections),
            baseRows: base ? (0, $2ddaae90639b5011$export$30c8cd38763344a6)(base.projections) : null
        };
        const id = `cp-${Date.now()}`;
        const createdAt = new Date().toISOString();
        setSavedStrategies?.((prev)=>(0, $7445cb9532643693$export$bda89f6290a6f044)(prev, {
                id: id,
                name: words.title,
                displayName: words.title,
                type: 'cashflow_pension',
                // At the top level too: the Dashboard's source badge reads strategy.source.
                source: mode === 'manual' ? 'manual' : 'suggestion_engine',
                // The client's figures it was priced on, so Home can tell when they change (chosenPlanRefresh.ts).
                inputsFingerprint: (0, $78a369bbf1e0d995$export$236630ee0fd3b65b)(factFind),
                // Built by the client from a tested plan ("Customise this plan", 25 Oct 2026).
                ...mode === 'manual' && manualCustomisedFrom ? {
                    customisedFrom: manualCustomisedFrom
                } : {},
                inputs: {
                    engineStrategyId: mode === 'manual' ? null : chosen.id,
                    planContext: {
                        supportCostAnnual: supportCost?.annual ?? 0,
                        legacyYears: legacyYears
                    },
                    source: mode === 'manual' ? 'manual' : 'suggestion_engine',
                    allocation: mode === 'manual' ? {
                        ...allocation
                    } : null,
                    // The annuity's terms too, so a reopened hand-built plan is the same plan.
                    annuityTerms: mode === 'manual' ? {
                        ...annuityTerms
                    } : null,
                    engineOptionId: mode === 'manual' ? null : chosen.id,
                    engineOptionName: mode === 'manual' ? null : chosen.name,
                    candidate: // The plan as run, so its position can be rebuilt for the forms.
                    candidate,
                    supportCostAnnual: supportCost?.annual ?? 0,
                    supportCostLabel: supportCost?.label ?? null,
                    legacyYears: legacyYears,
                    card: card
                },
                outputs: {
                    agePension: chosen.snapshot.pension,
                    cashFlow: chosen.snapshot.cashflow,
                    legacyEstimate: chosen.snapshot.estate
                },
                createdAt: createdAt
            }));
        setChosen({
            card: card,
            createdAt: createdAt,
            id: id,
            soaPreparedAt: null,
            engineId: mode === 'manual' ? null : chosen.id,
            manual: mode === 'manual',
            candidate: candidate,
            years: legacyYears,
            allocation: mode === 'manual' ? {
                ...allocation
            } : null,
            annuityTerms: mode === 'manual' ? {
                ...annuityTerms
            } : null,
            customisedFrom: mode === 'manual' ? manualCustomisedFrom : null
        });
        setSelectedEngineId(mode === 'manual' ? null : chosen.id);
        setReopenNote(null);
        setSaveNote('');
    };
    /** The Statement of Advice for a plan (cpSoa.ts) — opened, downloaded, registered, and marked on the plan. */ const generateCpSoa = (option)=>{
        // A plan the engine could not work out has no figures to advise on (review, 18 Oct 2026).
        if (option.error) return;
        if (engineIncomeOnlyHeld(option)) return;
        const leaders = soaLeaders();
        // The plan as run, so the document reads each lever's amount from its own field (cpSoa.ts).
        const candidate = engineCandidates.find((c)=>c.id === option.id) ?? null;
        const snapshot = (0, $e53542c7d33c24ce$export$3c5720c15451e6ca)({
            option: option,
            all: strategies || [],
            leaders: leaders,
            factFind: factFind,
            legacyYears: legacyYears,
            supportCost: supportCost,
            candidate: candidate,
            candidates: engineCandidates
        });
        (0, $482dbb064a59e381$export$bedc55c6dae3ee6a)(snapshot);
        onSoaGenerated?.({
            id: option.id,
            name: option.name,
            type: 'cashflow_pension',
            source: 'suggestion_engine',
            strategy: option,
            soaSnapshot: snapshot
        });
        markPrepared(option.id === chosen?.engineId && !chosen?.manual);
    };
    const generateManualSoa = ()=>{
        if (!manualRow || manualRow.error || manualIncomeOnlyHeld) return;
        const snapshot = (0, $e53542c7d33c24ce$export$3c5720c15451e6ca)({
            option: manualRow,
            all: manualResult || [],
            leaders: [],
            factFind: factFind,
            legacyYears: legacyYears,
            supportCost: supportCost,
            candidate: manualCandidate,
            candidates: [
                manualCandidate
            ],
            manual: true,
            customisedFrom: manualCustomisedFrom
        });
        (0, $482dbb064a59e381$export$bedc55c6dae3ee6a)(snapshot);
        onSoaGenerated?.({
            id: 'cp-manual',
            name: 'Your plan',
            type: 'cashflow_pension',
            source: 'manual',
            strategy: manualRow,
            soaSnapshot: snapshot
        });
        markPrepared(!!chosen?.manual);
    };
    const markPrepared = (isChosen)=>{
        if (!isChosen || !chosen?.id) return;
        const at = new Date().toISOString();
        setChosen((c)=>c ? {
                ...c,
                soaPreparedAt: at
            } : c);
        setSavedStrategies?.((prev)=>(prev || []).map((p)=>p?.id === chosen.id ? {
                    ...p,
                    soaPreparedAt: at
                } : p));
    };
    /* An action asked for on the plan page, once the plans it needs have run. */ (0, $acw62.useEffect)(()=>{
        if (!pending || !chosen) return;
        if ((0, $94964a4bbfeb638b$export$5cbbd0676ba1975c)(chosen.card, supportCost?.annual ?? 0)) {
            setPending(null);
            return;
        }
        if (chosen.manual) {
            if (pending === 'advice' && manualRow && !manualLoading && !manualRow.error) {
                generateManualSoa();
                setPending(null);
            }
            // The plan page's "See the year-by-year figures": the saved card keeps no rows, so they open once re-priced (22 Oct 2026).
            if (pending === 'yearByYear' && manualRow && !manualLoading && !manualRow.error) {
                setYearByYear({
                    title: chosen.card.words.title,
                    projections: manualRow.projections
                });
                setPending(null);
            }
            return;
        }
        if (!strategies) return;
        const row = strategies.find((s)=>s.id === chosen.engineId);
        if (pending === 'advice' && row) generateCpSoa(row);
        if (pending === 'yearByYear' && row && !row.error) setYearByYear({
            title: chosen.card.words.title,
            projections: row.projections
        });
        setPending(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pending,
        strategies,
        manualRow,
        manualLoading
    ]);
    /* ─── Build a plan yourself ─── */ /*
     * TWO DOORS (owner, 25 Oct 2026): "Customise this plan" (a tested plan) copies it in; "Build a plan yourself"
     * (none) opens a BLANK plan. It used to keep whatever amounts were last on screen.
     */ const openBuild = (from, label)=>{
        if (from) {
            const seeded = $61e08b09c5525908$var$allocationFromCandidate(from);
            setAllocation(seeded.allocation);
            setAnnuityTerms(seeded.terms);
        } else {
            setAllocation((0, $2663acaa6cb9dd5e$export$8471fcc462280406));
            setAnnuityTerms((0, $2663acaa6cb9dd5e$export$8a567aa13eab014b));
        }
        setManualStartedFrom(label);
        setManualCustomisedFrom(from ? label : null);
        setStrategyMode('manual');
        setView('steps');
        setStep(3);
        try {
            window.scrollTo?.(0, 0);
        } catch  {}
    };
    /*
     * REOPENING A CHOSEN HAND-BUILT PLAN RESTORES ITS AMOUNTS (23 Oct 2026). "See the year-by-year figures" and "Get
     * the advice document" on the plan page re-price the plan; they opened the build page with whatever amounts were
     * on screen, which after a reload is nothing, so the plan was never priced and the request waited for good.
     */ const openChosenBuild = (label)=>{
        if (!chosen) return;
        if (chosen.allocation && Object.keys(chosen.allocation).length) {
            setAllocation({
                ...(0, $2663acaa6cb9dd5e$export$8471fcc462280406),
                ...chosen.allocation
            });
            if (chosen.annuityTerms) setAnnuityTerms({
                ...(0, $2663acaa6cb9dd5e$export$8a567aa13eab014b),
                ...chosen.annuityTerms
            });
            // Its own record says where it began, if it was customised from a tested plan.
            setManualStartedFrom(chosen.customisedFrom ?? label);
            setManualCustomisedFrom(chosen.customisedFrom ?? null);
            setStrategyMode('manual');
            setView('steps');
            setStep(3);
            return;
        }
        openBuild(chosen.candidate, label);
    };
    const startOptions = [
        ...[
            leaders.estate,
            leaders.cashflow,
            leaders.pension
        ].filter((r, i, all)=>!!r && all.findIndex((x)=>x?.id === r.id) === i).map((r)=>({
                id: String(r.id),
                label: (0, $4876815f03a5e1e6$export$f32c8e12406086f7)(candidateOf(r) ?? {
                    id: r.id
                }, factFind).title
            })),
        {
            id: 'blank',
            label: 'A blank plan'
        }
    ];
    /* ─── Explain this ─── */ /*
     * EXPLAIN THIS AS AGED CARE TELLS IT (owner, 22 Oct 2026: "all modules use consistent UI"). Numbered lines —
     * what is done and paid from where, then each cause and what it does to the numbers (cpLedgerLines) — then
     * "Put together" with the money story inside it (only when a year runs short), then the "=" line against
     * changing nothing (CauseEffectLedger). The old three-figure grid is gone: the ledger states the same figures.
     * The guaranteed income's family panel, the plan's pieces and the debts follow, in that order.
     */ const explainBody = (i)=>{
        const rows = i.rows;
        const story = rows && rows.length && (0, $0fe89e03b6df746e$export$693cc3146baa3244)(rows).hasDeficit ? (0, $2ddaae90639b5011$export$bdea18f456fd84b)({
            rows: rows,
            factFind: factFind,
            runway: (0, $0fe89e03b6df746e$export$464558962ff4a811)(rows, rows.length),
            deposit: {
                paid: 0,
                refundTo: ''
            },
            horizonYears: i.years,
            enteringName: factFind?.client?.firstName || 'The household',
            spentOn: (0, $4876815f03a5e1e6$export$ec4b9fd87c177556)(i.candidate)
        }) : null;
        const causes = (0, $4876815f03a5e1e6$export$4e5476165fd09dec)({
            plan: i.plan,
            base: i.base,
            c: i.candidate,
            v: v,
            annuityIncome: i.annuityIncome,
            first: (0, $4876815f03a5e1e6$export$3733ad232ff5ea09)(rows),
            baseFirst: (0, $4876815f03a5e1e6$export$3733ad232ff5ea09)(i.baseRows)
        });
        const lines = [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                "data-testid": "cp-explain-do",
                children: i.words.sub
            }, "do"),
            ...causes.map((l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    "data-testid": `cp-explain-${l.key}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "text-slate-900",
                            children: l.lead
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4800816561106c2d$export$8dd54625d22f0463), {
                            change: l.change,
                            text: l.body
                        })
                    ]
                }, l.key)),
            (0, $4800816561106c2d$export$4be361d56ef6ce0f)({
                cashflow: i.plan.cashflow,
                baseCashflow: i.base?.cashflow ?? null,
                they: v.they,
                baseWord: 'changing nothing',
                moneyStory: story ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ddaae90639b5011$export$1a915263dc5391f1), {
                    story: story,
                    testId: "cp-explain-money-story"
                }) : null
            })
        ];
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            "data-testid": "cp-explain",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4800816561106c2d$export$d053159fb36403b3), {
                lines: lines,
                estate: i.plan.estate,
                baseEstate: i.base?.estate ?? null,
                horizonYears: i.years,
                baseWord: "changing nothing",
                testId: "cp-cause-effect",
                leverKinds: (0, $4876815f03a5e1e6$export$1555bdcd9f522821)(i.candidate),
                children: [
                    i.family && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-5",
                        children: i.family
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1f2b2692daf0da1$export$d520641036c1ebe9), {
                        className: "mt-5",
                        pieces: i.pieces
                    }),
                    i.debts
                ]
            })
        });
    };
    /* ─── Rendering ─── */ const backButton = /* Back returns through the door used (review, 18 Oct 2026: it always went to Support at home). */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: ()=>setActivePage(cameFrom === 'support_at_home' ? 'HomeCarePage' : 'Dashboard'),
        className: "mb-3 -ml-1 inline-flex items-center gap-1 text-[14px] font-semibold text-slate-600 hover:text-slate-900",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                size: 16
            }),
            " ",
            cameFrom === 'support_at_home' ? 'Back to Support at home' : 'Back to Home'
        ]
    });
    /*
     * Every "What could go wrong" carries the age-and-health warning when the plan buys a guaranteed income
     * (owner, 22 Oct 2026: the chosen plan's never did) — read from the plan as run (cpHorizonWarningOf).
     */ const riskPanel = risk && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5757b380cc124794$export$2e2bcd8739ae039), {
        voice: v,
        strategyName: risk.name,
        onClose: ()=>setRisk(null),
        risks: (0, $203e38d6e6c434f4$export$124603ee0434ece5)(risk.kinds, {
            horizonWarning: risk.horizonWarning ?? null
        })
    });
    /* Explain this, as aged care says it (owner, 22 Oct 2026): an intro saying how to read it and what the benchmark is. */ const explainIntro = `Each line says what ${v.they} do, and what that does to the numbers. "Changing nothing" means keeping everything as it is today${supportCost ? ', with the same support paid for' : ''}, over the same years.`;
    const yearByYearButton = (onClick)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            type: "button",
            onClick: onClick,
            className: "rounded-lg border border-slate-300 bg-white px-4 py-2 text-[14px] font-semibold text-slate-800 hover:border-blue-300 hover:bg-blue-50",
            "data-testid": "cp-explain-year-by-year",
            children: "See the year-by-year figures"
        });
    const explainModal = (()=>{
        if (!explain) return null;
        if (explain.kind === 'card' && chosen) {
            const c = chosen.card;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $12084f898a868747$export$2e2bcd8739ae039), {
                eyebrow: "Explain this",
                title: c.words.title,
                intro: explainIntro,
                onClose: ()=>setExplain(null),
                // The saved card keeps no projection rows, so the plans are re-priced and the figures open for this plan (as SahHub).
                footer: yearByYearButton(()=>{
                    setExplain(null);
                    setPending('yearByYear');
                    if (chosen.manual) openChosenBuild(c.words.title);
                    else {
                        setStrategyMode('optimised');
                        setAsking(false);
                        goToStep(3);
                    }
                }),
                children: explainBody({
                    words: c.words,
                    plan: {
                        estate: c.plan.legacy,
                        pension: c.plan.pension,
                        cashflow: c.plan.cashflow
                    },
                    base: c.baseline ? {
                        estate: c.baseline.legacy,
                        pension: c.baseline.pension,
                        cashflow: c.baseline.cashflow
                    } : null,
                    candidate: chosen.candidate,
                    annuityIncome: c.family?.incomeAYear ?? null,
                    // The rows saved with the card (older cards have none, so the shorter ledger shows).
                    rows: c.rows ?? null,
                    baseRows: c.baseRows ?? null,
                    pieces: c.pieces,
                    family: c.family && c.family.rows.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
                        factFind: factFind,
                        personName: c.family.personName,
                        amount: c.family.amount,
                        kind: c.family.kind,
                        incomeAYear: c.family.incomeAYear,
                        rows: null,
                        frozen: c.family.rows,
                        compareNote: c.family.compareNote,
                        horizonYears: c.horizonYears,
                        testId: "cp-explain-family-panel"
                    }) : null,
                    debts: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe4e1ee5e30419ba$export$2e2bcd8739ae039), {
                        factFind: factFind,
                        clearedAmount: $61e08b09c5525908$var$cpDebtClearedBy(chosen.candidate),
                        years: c.horizonYears,
                        context: String(chosen.candidate?.id || '').startsWith('cp-your-plan') || c.origin === 'manual' ? 'manual' : 'chosen'
                    }),
                    years: c.horizonYears
                })
            });
        }
        const isManual = explain.kind === 'manual';
        const row = isManual ? manualRow : explain.kind === 'row' ? explain.row : null;
        if (!row) return null;
        const candidate = isManual ? manualCandidate : candidateOf(row);
        const base = isManual ? manualNothing : changeNothingRun;
        const words = (0, $4876815f03a5e1e6$export$f32c8e12406086f7)(candidate ?? {
            id: row.id
        }, factFind);
        const plan = {
            estate: row.snapshot.estate,
            pension: row.snapshot.pension,
            cashflow: row.snapshot.cashflow
        };
        const baseFig = base ? {
            estate: base.snapshot.estate,
            pension: base.snapshot.pension,
            cashflow: base.snapshot.cashflow
        } : null;
        const income = Number(row.annuityTerms?.annualPayment) || null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $12084f898a868747$export$2e2bcd8739ae039), {
            eyebrow: "Explain this",
            title: words.title,
            intro: explainIntro,
            onClose: ()=>setExplain(null),
            footer: row.projections?.length ? yearByYearButton(()=>{
                setExplain(null);
                setYearByYear({
                    title: words.title,
                    projections: row.projections
                });
            }) : undefined,
            children: explainBody({
                words: words,
                plan: plan,
                base: baseFig,
                candidate: candidate,
                annuityIncome: income,
                rows: row.projections,
                baseRows: base?.projections ?? null,
                pieces: (0, $4876815f03a5e1e6$export$48b7937c00a51078)(candidate),
                // What the family receives from a guaranteed income, against the same plan without it (a tested plan's).
                family: isManual ? null : familyFor(row, changeNothingRun?.projections, 'cp-explain-family-panel'),
                debts: (()=>{
                    // The same plan with the debts paid off ("<id>-clear-debt", cashflowPensionCandidates.clearDebtTwins).
                    const twin = isManual ? null : (strategies || []).find((s)=>s.id === `${row.id}-clear-debt`) ?? (candidate?.changeNothing ? (strategies || []).find((s)=>s.id === 'cp-clear-debt') : null) ?? null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe4e1ee5e30419ba$export$2e2bcd8739ae039), {
                        factFind: factFind,
                        clearedAmount: $61e08b09c5525908$var$cpDebtClearedBy(candidate),
                        plan: plan,
                        twin: twin ? {
                            estate: twin.snapshot.estate,
                            pension: twin.snapshot.pension,
                            cashflow: twin.snapshot.cashflow
                        } : null,
                        years: legacyYears,
                        context: isManual ? 'manual' : 'tested'
                    });
                })(),
                years: legacyYears
            })
        });
    })();
    /* The year-by-year figures, opened from Explain this — the one projections view every module shares. */ const yearByYearModal = yearByYear && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9847d752f8df838f$export$2e2bcd8739ae039), {
        onClose: ()=>setYearByYear(null),
        title: yearByYear.title,
        comparedOverYears: Number(legacyYears) || undefined,
        projections: yearByYear.projections,
        factFind: factFind,
        initialFinancials: todayFinancials,
        costLabel: null
    });
    if (view === 'hub' && chosen) {
        const card = chosen.card;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "mx-auto max-w-6xl",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d068eb2c3c41b4f7$export$2e2bcd8739ae039), {
                    factFind: factFind,
                    card: card,
                    outOfDate: (0, $78a369bbf1e0d995$export$ceccff7104f70d1e)((0, $94964a4bbfeb638b$export$ce1dae2ac0d07e63)(savedStrategies) ?? (chosen.id ? (savedStrategies || []).find((p)=>p.id === chosen.id) : null), factFind),
                    candidate: chosen.candidate,
                    chosenOn: chosen.createdAt,
                    soaPreparedAt: chosen.soaPreparedAt,
                    back: cameFrom === 'support_at_home' ? {
                        label: 'Back to Support at home',
                        onClick: ()=>setActivePage('HomeCarePage')
                    } : null,
                    onChangeSupport: ()=>goToStep(1),
                    onExplain: ()=>setExplain({
                            kind: 'card'
                        }),
                    onRisks: ()=>setRisk({
                            name: card.words.title,
                            kinds: card.riskKinds,
                            horizonWarning: (0, $4876815f03a5e1e6$export$1e981f6e28bf53cb)(chosen.candidate, factFind, card.annuity)
                        }),
                    onAdvice: ()=>{
                        setPending('advice');
                        if (chosen.manual) openChosenBuild(card.words.title);
                        else {
                            setStrategyMode('optimised');
                            setAsking(false);
                            goToStep(3);
                        }
                    },
                    onAllPlans: ()=>{
                        setStrategyMode('optimised');
                        setAsking(false);
                        goToStep(3);
                    },
                    onBuild: ()=>chosen.manual ? openChosenBuild(card.words.title) : openBuild(chosen.candidate, card.words.title),
                    onBuildNew: ()=>openBuild(null, null),
                    onQuote: ()=>{
                        setPending('quote');
                        setStrategyMode('optimised');
                        setAsking(false);
                        goToStep(3);
                    },
                    onAssumptions: ()=>setActivePage('AssumptionsPage'),
                    onHome: ()=>setActivePage('Dashboard'),
                    /*
                     * Model something else (owner, 22 Oct 2026): cashflow keeps one plan per file, so a new model
                     * starts at step 1 with nothing carried over and the questions asked again, as Home's "Start a
                     * new model" does; the chosen plan stays chosen until another is chosen.
                     */ onStartFresh: ()=>{
                        setSupportAnnual('');
                        setSupportLabel('Support at home services');
                        setLegacyYears(10);
                        setSelectedEngineId(null);
                        setManualStartedFrom(null);
                        setStrategyMode('optimised');
                        setAsking(true);
                        goToStep(1);
                    },
                    /* From Support at home: change the support paid for first, keeping the answers to the questions. */ onChangeSupportFirst: cameFrom === 'support_at_home' ? ()=>{
                        setStrategyMode('optimised');
                        setAsking(false);
                        goToStep(1);
                    } : null
                }),
                riskPanel,
                explainModal,
                yearByYearModal
            ]
        });
    }
    const supportChanged = !!chosen && (0, $94964a4bbfeb638b$export$5cbbd0676ba1975c)(chosen.card, supportCost?.annual ?? 0);
    const chosenHere = !!chosen && !chosen.manual && selectedEngineId != null && selectedEngineId === chosen.engineId;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mx-auto max-w-6xl",
        children: [
            backButton,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-[13px] text-slate-500",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setActivePage('Dashboard'),
                        className: "underline decoration-dotted underline-offset-2 hover:text-slate-800",
                        children: "Home"
                    }),
                    " \u203A Cashflow & Age Pension \u203A ",
                    step === 1 ? 'Your money today' : step === 2 ? 'What it means' : strategyMode === 'manual' ? 'Build a plan yourself' : 'Ways to improve it',
                    chosen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " \xb7 ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>setView('hub'),
                                className: "font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                "data-testid": "cp-go-to-plan",
                                children: [
                                    v.you ? 'Your' : v.Possessive,
                                    " money plan"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "mt-2 text-[32px] font-bold leading-tight tracking-tight text-brand-navy",
                "data-testid": "cp-title",
                children: v.you ? 'Your money, as it stands' : `${v.Possessive} money, as it stands`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-1 text-[15px] text-slate-600",
                "data-testid": "cashflow-intro",
                children: cameFrom === 'support_at_home' ? `None of this needs a care assessment. Three short steps: where ${v.names} stand${v.s} today, why the numbers are what they are, and ways to improve them without moving house.` : `Three short steps: where ${v.names} stand${v.s} today, why the numbers are what they are, and ways to improve them without moving house.`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $724b7566e2d97e1f$export$2e2bcd8739ae039), {
                step: step,
                onStep: goToStep,
                ariaLabel: "Cashflow and Age Pension steps",
                steps: [
                    {
                        title: `${v.you ? 'Your' : v.Possessive} money today`,
                        sub: supportCost ? `With ${(0, $db27db5ed814451d$export$5517df3497010beb)(supportCost.annual)} a year of support` : 'Four numbers, with any support paid for'
                    },
                    {
                        title: 'What it means',
                        sub: 'Why the Age Pension is what it is'
                    },
                    {
                        title: 'Ways to improve it',
                        sub: 'Plans we tested, or build your own'
                    }
                ]
            }),
            step === 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-8",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6cbd45224d06260b$export$2e2bcd8739ae039), {
                    factFind: factFind,
                    supportAnnual: supportAnnual,
                    onSupportAnnual: setSupportAnnual,
                    supportLabel: supportLabel,
                    onSupportLabel: setSupportLabel,
                    supportCost: supportCost,
                    position: position,
                    loading: loading,
                    error: error,
                    legacyYears: legacyYears,
                    onLegacyYears: setLegacyYears,
                    chosenCard: chosen?.card ?? null,
                    onWhy: ()=>goToStep(2),
                    onNext: ()=>goToStep(2)
                })
            }),
            step === 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-8",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ace27ec3f1c2144$export$2e2bcd8739ae039), {
                    factFind: factFind,
                    first: first,
                    todayFirst: todayFirst,
                    years: years,
                    position: position,
                    supportCost: supportCost,
                    legacyYears: legacyYears,
                    onBack: ()=>goToStep(1),
                    onNext: ()=>{
                        setStrategyMode('optimised');
                        goToStep(3);
                    },
                    onAssumptions: ()=>setActivePage('AssumptionsPage')
                })
            }),
            step === 3 && strategyMode === 'optimised' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-8",
                children: asking ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d5328aeeb077969$export$2e2bcd8739ae039), {
                    factFind: factFind,
                    onGuaranteedIncomeGoals: onGuaranteedIncomeGoals,
                    legacyYears: legacyYears,
                    firstRun: !strategies,
                    onRun: (a)=>{
                        const goals = factFind?.goals || {};
                        const levers = (0, $cc855f77b4e7e2d7$export$da06e6e0ac437362).filter((l)=>a.levers.includes(l)).join(',');
                        if (onCashflowGoals && (Number(goals.cpEmergencyReserve) !== a.reserve || goals.cpEmergencyReserve == null || goals.cpLevers !== levers)) onCashflowGoals({
                            cpEmergencyReserve: a.reserve,
                            cpLevers: levers
                        });
                        setLegacyYears(a.years);
                        setAsking(false);
                    },
                    onBuildYourOwn: ()=>{
                        setAsking(false);
                        openBuild(null, null);
                    },
                    onCancel: ()=>setAsking(false)
                }) : strategiesLoading || !strategies && !strategiesError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "rounded-2xl border border-slate-200 bg-white p-10 text-center shadow-card",
                    "data-testid": "cp-testing",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-[16px] font-semibold text-slate-900",
                            children: "Testing the ways to improve it"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "mt-1 text-[14px] text-slate-600",
                            children: [
                                "Each way, and changing nothing, over the same ",
                                legacyYears,
                                " years."
                            ]
                        })
                    ]
                }) : strategiesError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] text-slate-700",
                    children: [
                        strategiesError,
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>void loadStrategies(),
                            className: "font-semibold text-brand-navy underline",
                            children: "Try again"
                        }),
                        " or ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>openBuild(null, null),
                            className: "font-semibold text-brand-navy underline",
                            children: "build a plan yourself"
                        }),
                        "."
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c19f7e7397007b7$export$2e2bcd8739ae039), {
                    notices: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            chosenHere && chosen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 border-l-4 border-l-emerald-500 bg-white px-5 py-4 shadow-card",
                                "data-testid": "cp-chosen-banner",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-[26px] leading-none text-emerald-500",
                                        "aria-hidden": true,
                                        children: "\u2713"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "min-w-0 flex-1 text-[14px] leading-relaxed text-slate-700",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                className: "text-slate-900",
                                                children: [
                                                    v.you ? "You've" : `${v.Names} ${v.have}`,
                                                    " chosen \u201C",
                                                    chosen.card.words.title,
                                                    "\u201D."
                                                ]
                                            }),
                                            ' ',
                                            "It's saved with ",
                                            v.possessive,
                                            " file. The next step is the advice document",
                                            chosen.card.annuity ? ', and a quote from the provider' : '',
                                            "."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>setView('hub'),
                                        className: "text-[14px] font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4",
                                        "data-testid": "cp-banner-plan-page",
                                        children: [
                                            "Go to ",
                                            v.possessive,
                                            " money plan"
                                        ]
                                    })
                                ]
                            }),
                            chosen && !chosenHere && (supportChanged || chosen.manual || reopenNote) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700",
                                "data-testid": "cp-retested-note",
                                children: supportChanged ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        "Re-tested with ",
                                        (0, $db27db5ed814451d$export$5517df3497010beb)(supportCost?.annual ?? 0),
                                        " a year of support. ",
                                        v.Possessive,
                                        " chosen plan, \u201C",
                                        chosen.card.words.title,
                                        "\u201D, was priced on ",
                                        (0, $db27db5ed814451d$export$5517df3497010beb)(chosen.card.support.annual),
                                        " and stays chosen until ",
                                        v.they,
                                        " choose again."
                                    ]
                                }) : chosen.manual ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        v.Possessive,
                                        " chosen plan is one ",
                                        v.you ? 'you' : v.they,
                                        " built: \u201C",
                                        chosen.card.words.title,
                                        "\u201D. It stays chosen until ",
                                        v.they,
                                        " choose another."
                                    ]
                                }) : reopenNote
                            }),
                            saveNote && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[14px] text-slate-700",
                                role: "status",
                                children: saveNote
                            })
                        ]
                    }),
                    factFind: factFind,
                    results: strategies || [],
                    candidates: engineCandidates,
                    horizonYears: legacyYears,
                    ownToday: position?.netWorth ?? 0,
                    supportCost: supportCost,
                    focus: focus,
                    onFocus: setFocus,
                    chosenId: selectedEngineId,
                    initialOpenDetail: pending === 'quote' ? chosen?.engineId ?? null : null,
                    onChoose: (row)=>savePlan(row, 'optimised'),
                    onExplain: (row)=>setExplain({
                            kind: 'row',
                            row: row
                        }),
                    onRisks: (row)=>setRisk({
                            name: (0, $4876815f03a5e1e6$export$f32c8e12406086f7)(candidateOf(row) ?? {
                                id: row.id
                            }, factFind).title,
                            kinds: (0, $4876815f03a5e1e6$export$1555bdcd9f522821)(candidateOf(row) ?? {
                                id: row.id
                            }),
                            horizonWarning: (0, $4876815f03a5e1e6$export$1e981f6e28bf53cb)(candidateOf(row), factFind)
                        }),
                    onAdvice: (row)=>generateCpSoa(row),
                    onBuildYourOwn: (row)=>openBuild(row ? candidateOf(row) : null, row ? (0, $4876815f03a5e1e6$export$f32c8e12406086f7)(candidateOf(row) ?? {
                            id: row.id
                        }, factFind).title : null),
                    onChanges: ()=>setAsking(true),
                    renderFamily: (option)=>familyFor(option, changeNothingRun?.projections, `cp-annuity-family-panel-${option.id}`),
                    beforeChoose: (option)=>{
                        const optionAnnuity = optionAnnuityOf(option);
                        return optionAnnuity?.incomeOnly && setIncomeOnlyUnderstood ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$4538b371a206da0c), {
                            factFind: factFind,
                            amount: optionAnnuity.amount,
                            onChange: setIncomeOnlyUnderstood
                        }) : undefined;
                    },
                    chooseHeld: engineIncomeOnlyHeld,
                    renderDetail: (option)=>{
                        const optionAnnuity = optionAnnuityOf(option);
                        const c = candidateOf(option);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-3 text-[13px] leading-relaxed text-slate-700",
                            children: [
                                c?.fundingSources?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            className: "text-slate-900",
                                            children: "Where the money comes from:"
                                        }),
                                        " ",
                                        (0, $4876815f03a5e1e6$export$f32c8e12406086f7)(c, factFind).sub
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-slate-500",
                                    children: [
                                        "Kept back for emergencies: ",
                                        (0, $db27db5ed814451d$export$5517df3497010beb)(reserve),
                                        ", drawn on only if a year runs short."
                                    ]
                                }),
                                optionAnnuity && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6421482343679f4$export$d05c00195a7db941), {
                                    terms: option.annuityTerms,
                                    factFind: factFind,
                                    /*
                                                 * A REAL QUOTE, and the whole field re-ranked on it: a different rate can change
                                                 * which plan wins (owner, 2026-09-01). The quote is for THIS plan's type and
                                                 * amount (annuityQuote.ts).
                                                 */ quote: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6421482343679f4$export$624bbc9c6c5928), {
                                                draft: seAnnuityQuoteDraft,
                                                onDraft: setSeAnnuityQuoteDraft,
                                                committed: seAnnuityQuote?.income ?? null,
                                                onCommit: (next)=>setSeAnnuityQuote(next != null && next > 0 ? {
                                                        income: next,
                                                        amount: optionAnnuity.amount,
                                                        shape: (0, $da24031d156d6acb$export$f7e5360546f2cc73)(optionAnnuity.annuityType, Math.round(optionAnnuity.residualCapital * 100))
                                                    } : null)
                                            }),
                                            (0, $da24031d156d6acb$export$3c59a0c7e65b683b)(seAnnuityQuote, (0, $f94e45ac645ae232$export$3dc27271f5d5c629)) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-1.5 text-[12px] text-slate-500",
                                                "data-testid": "cp-annuity-quote-note",
                                                children: (0, $da24031d156d6acb$export$3c59a0c7e65b683b)(seAnnuityQuote, (0, $f94e45ac645ae232$export$3dc27271f5d5c629))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-1.5 text-[12px] text-slate-500",
                                                children: "These incomes are estimates from published rates \u2014 get a quote from the provider."
                                            })
                                        ]
                                    })
                                })
                            ]
                        });
                    }
                })
            }),
            step === 3 && strategyMode === 'manual' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ea387582edc92e02$export$2e2bcd8739ae039), {
                        factFind: factFind,
                        sources: sources,
                        reserve: reserve,
                        allocation: allocation,
                        onAllocation: setAllocation,
                        annuityTerms: annuityTerms,
                        onAnnuityTerms: setAnnuityTerms,
                        totalDebt: totalDebt,
                        onIncomeOnlyUnderstoodChange: setIncomeOnlyUnderstood,
                        horizonYears: legacyYears,
                        working: manualLoading,
                        erroredWords: manualRow?.error ? $61e08b09c5525908$var$MANUAL_PLAN_ERRORED : null,
                        effect: {
                            cashflow: manualRow && !manualRow.error ? manualRow.snapshot.cashflow : null,
                            baseCashflow: manualNothing ? manualNothing.snapshot.cashflow : null,
                            pension: manualRow && !manualRow.error ? manualRow.snapshot.pension : null,
                            basePension: manualNothing ? manualNothing.snapshot.pension : null,
                            legacy: manualRow && !manualRow.error ? manualRow.snapshot.estate : null,
                            baseLegacy: manualNothing ? manualNothing.snapshot.estate : null
                        },
                        startedFrom: manualStartedFrom,
                        customising: !!manualCustomisedFrom,
                        onClear: ()=>{
                            setAllocation((0, $2663acaa6cb9dd5e$export$8471fcc462280406));
                            setAnnuityTerms((0, $2663acaa6cb9dd5e$export$8a567aa13eab014b));
                            setManualStartedFrom(null);
                            setManualCustomisedFrom(null);
                        },
                        startOptions: startOptions,
                        onStartFrom: (id)=>{
                            if (id === 'blank') {
                                setAllocation((0, $2663acaa6cb9dd5e$export$8471fcc462280406));
                                setAnnuityTerms((0, $2663acaa6cb9dd5e$export$8a567aa13eab014b));
                                setManualStartedFrom('A blank plan');
                                setManualCustomisedFrom(null);
                                return;
                            }
                            const row = strategies?.find((s)=>String(s.id) === id);
                            if (row) openBuild(candidateOf(row), (0, $4876815f03a5e1e6$export$f32c8e12406086f7)(candidateOf(row) ?? {
                                id: row.id
                            }, factFind).title);
                        },
                        onExplain: ()=>setExplain({
                                kind: 'manual'
                            }),
                        /* The plan's own title, as its Explain this says it (owner, 22 Oct 2026: it said "Your own plan" here). */ onRisks: ()=>setRisk({
                                name: (0, $4876815f03a5e1e6$export$f32c8e12406086f7)(manualCandidate ?? {
                                    id: 'cp-manual'
                                }, factFind).title,
                                kinds: (0, $4876815f03a5e1e6$export$1555bdcd9f522821)(manualCandidate),
                                horizonWarning: (0, $4876815f03a5e1e6$export$1e981f6e28bf53cb)(manualCandidate, factFind)
                            }),
                        onChoose: ()=>savePlan(null, 'manual'),
                        chosen: !!chosen?.manual && !!manualRow && !manualLoading && chosen.card.plan.legacy === manualRow.snapshot.estate && chosen.card.plan.cashflow === manualRow.snapshot.cashflow,
                        beforeChoose: manualIncomeOnly && setIncomeOnlyUnderstood ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae79c7e46ed27e$export$4538b371a206da0c), {
                            factFind: factFind,
                            amount: allocation.annuity,
                            onChange: setIncomeOnlyUnderstood,
                            action: "saving"
                        }) : undefined,
                        chooseHeld: manualIncomeOnlyHeld,
                        onBackToPlans: ()=>{
                            setStrategyMode('optimised');
                            goToStep(3);
                        },
                        onHome: ()=>setActivePage('Dashboard'),
                        onAdvice: generateManualSoa,
                        familyPanel: manualRow && !manualRow.error && allocation.annuity >= (0, $f1faa9f80daa40f2$export$e63473be6d7e0dc0) ? (()=>{
                            // Changing nothing is the same plan without it only when the guaranteed income is the one thing moved.
                            const only = !(allocation.funeralBond > 0) && !(allocation.gift > 0) && !(allocation.debtRepayment > 0) && !(Number(allocation.superContribution) > 0) && !(Number(allocation.investmentBond) > 0);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8665f80549f60a1b$export$2e2bcd8739ae039), {
                                factFind: factFind,
                                personName: annuityTerms.owner === 'partner' ? factFind?.partner?.firstName || 'the partner' : clientName,
                                amount: allocation.annuity,
                                kind: (0, $8665f80549f60a1b$export$3ab75b1250c8af22)({
                                    annuityType: annuityTerms.annuityType ?? 'lifetime',
                                    residualCapital: annuityTerms.residualCapital
                                }),
                                rows: manualRow.projections,
                                compareRows: only ? manualNothing?.projections ?? null : null,
                                compareNote: only ? 'the same plan without it, the money left in savings' : null,
                                horizonYears: legacyYears,
                                testId: "cp-manual-annuity-family-panel"
                            });
                        })() : null
                    }),
                    saveNote && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-3 text-[14px] text-slate-700",
                        role: "status",
                        children: saveNote
                    })
                ]
            }),
            riskPanel,
            explainModal,
            yearByYearModal
        ]
    });
};
var $61e08b09c5525908$export$2e2bcd8739ae039 = $61e08b09c5525908$var$CashflowPensionPage;






/**
 * Dashboard page: welcome, client overview, financial overview, goals, saved strategies & case studies, next steps, workflow card.
 */ 
/**
 * Bringing the browser-session copy of the saved plans into the app's own list (3 Oct 2026).
 *
 * Aged care and Support at Home also write their plans to sessionStorage, and Support at Home writes
 * ONLY there, so the Dashboard reads that copy in. It used to REPLACE the app's list with it. But the
 * village, downsizer, granny flat and cashflow modules save to the app's list alone, and the session
 * copy is whatever aged care last wrote (or what was mirrored when the file was last saved). So
 * opening the Dashboard dropped every plan those four modules had saved since, and the next autosave
 * made the loss permanent.
 *
 * Now the session copy only ADDS plans the app does not already hold. Nothing in the app deletes a
 * plan from its list, so adding is all that was ever needed.
 */ /*
 * ONLY THE MODULES THAT WRITE THE SESSION COPY (21 Oct 2026). Choosing a plan now REPLACES an earlier one
 * (strategy/chosenPlan.ts; one plan per village unit, rvChosenPlan.ts), so "nothing deletes a plan" stopped
 * being true. A stale session copy then brought a replaced village plan back, still marked chosen, beside
 * the new one (caught live). The village, downsizer, granny flat and cashflow modules never write the
 * session copy, so their plans are never taken from it.
 */ const $85cb556e7e19db04$var$SESSION_PLAN_TYPES = new Set([
    'aged_care',
    'home_care'
]);
function $85cb556e7e19db04$export$a51febbf9f38f8c5(current, fromSession) {
    if (!Array.isArray(fromSession)) return current;
    const have = new Set(current.map((p)=>String(p?.id)));
    const extra = fromSession.filter((p)=>p && p.id != null && !have.has(String(p.id)) && $85cb556e7e19db04$var$SESSION_PLAN_TYPES.has(String(p.type ?? 'aged_care')));
    return extra.length ? [
        ...current,
        ...extra
    ] : current;
}




var $acw62 = parcelRequire("acw62");









/**
 * Dashboard helper components: section headers, profile cards, stats, goals, next steps.
 * Used only by the Dashboard page.
 */ 
parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $fa7706f9ee0421dc$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "6",
            key: "1vlfrh"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "2",
            key: "1c9p78"
        }
    ]
];
const $fa7706f9ee0421dc$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("target", $fa7706f9ee0421dc$export$3efd853dbb351e94);






const $91cd8ed21bb5644f$export$8adb256d999cd5a0 = ({ title: title, showArrow: showArrow = true })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex justify-between items-center pb-2 border-b border-gray-100",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "text-xl font-bold text-brand-navy ",
                children: title
            }),
            showArrow && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "text-blue-600 hover:text-blue-800 transition-all hover:translate-x-1",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                    size: 22
                })
            })
        ]
    });
const $91cd8ed21bb5644f$export$bed540ccfa8743c4 = ({ user: user })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-4 p-4 rounded-xl bg-white border border-blue-100/50 hover:shadow-md transition-all duration-300",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3504415ad7167981$export$2e2bcd8739ae039), {
                        initials: user.initials,
                        color1: user.color1,
                        color2: user.color2
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "font-bold text-lg text-gray-800",
                        children: user.name || 'N/A'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-sm text-gray-500 flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "w-2 h-2 bg-green-500 rounded-full"
                            }),
                            user.health
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-right ml-auto pl-4 border-l border-slate-100",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-[10px] font-semibold uppercase tracking-wider text-slate-400",
                        children: "Age"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-2xl font-bold text-slate-800 leading-tight",
                        children: user.age || '?'
                    })
                ]
            })
        ]
    });
const $91cd8ed21bb5644f$export$b9109ed793f09d29 = ({ icon: Icon, text: text })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-2 bg-blue-500/10 text-blue-700 font-semibold px-4 py-2 rounded-full w-max border border-blue-200/50",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                size: 18
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: text
            })
        ]
    });
const $91cd8ed21bb5644f$export$5d33149bed29a0ae = ({ title: title, value: value, gradient: gradient = "bg-brand-navy" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "group relative p-4 rounded-xl bg-white border border-gray-100 hover:border-gray-200 transition-all duration-300 hover:shadow-md",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-xs font-medium text-gray-600 uppercase tracking-wide flex items-center gap-2 mb-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `w-2 h-2 ${gradient} rounded-full shadow-sm`
                    }),
                    title
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-3xl font-extrabold text-brand-navy ",
                children: value === null || value === undefined ? '$Nil' : (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(value)
            })
        ]
    });
const $91cd8ed21bb5644f$export$995c77c012c8eb7f = ({ label: label, value: value, icon: Icon, signed: signed = false })=>{
    const isNeg = signed && (value || 0) < 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-2xl bg-white/10 hover:bg-white/[0.16] backdrop-blur-sm border border-white/15 p-5 transition-colors duration-300",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-2 mb-2 text-blue-100/80",
                children: [
                    Icon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                        size: 16,
                        strokeWidth: 2.2
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-[13px] font-semibold",
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: `text-3xl font-extrabold tracking-tight ${isNeg ? 'text-rose-200' : 'text-white'}`,
                children: value === null || value === undefined ? '$Nil' : (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(value)
            })
        ]
    });
};
const $91cd8ed21bb5644f$export$9d1db7317d6f21a0 = ({ text: text })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-3 mb-3 p-2 rounded-lg hover:bg-blue-50/50 transition-colors group",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex-shrink-0 w-6 h-6 rounded-full bg-brand-navy flex items-center justify-center shadow-sm group-hover:scale-110 transition-transform",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                    size: 16,
                    className: "text-white",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "font-medium text-gray-700 group-hover:text-gray-900",
                children: text
            })
        ]
    });
const $91cd8ed21bb5644f$export$9d0feb8d41aa92e0 = ({ setActivePage: setActivePage, goals: goals })=>{
    const filteredSteps = (0, $85ae9bb7b6ee4811$export$d0620fcb9828c0c).filter((step)=>goals?.[step.goal]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
        className: "bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 text-white p-6 relative overflow-hidden border-white/10 shadow-cardlg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute inset-0 z-0"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative z-10",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-2 mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "w-8 h-8 rounded-lg bg-brand-navy flex items-center justify-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa7706f9ee0421dc$export$2e2bcd8739ae039), {
                                    size: 18,
                                    className: "text-white"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "font-bold text-xl",
                                children: "Next Steps"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        className: "space-y-3",
                        children: filteredSteps.map((step, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                onClick: ()=>setActivePage(step.page),
                                className: "flex items-center justify-between p-4 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20 hover:bg-white/20 hover:border-white/30 transition-all duration-300 cursor-pointer group hover:shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-300 group-hover:text-white transition-colors",
                                                children: step.text
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6288781efbc92679$export$2e2bcd8739ae039), {
                                                className: "font-bold text-lg group-hover:scale-105 transition-transform inline-block",
                                                children: step.link
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                        size: 20,
                                        className: "text-gray-400 group-hover:text-white group-hover:translate-x-1 transition-all"
                                    })
                                ]
                            }, i))
                    })
                ]
            })
        ]
    });
};


/**
 * The dashboard's first-visit state.
 *
 * WHY THIS EXISTS. A client meeting on 2026-08-20 put a non-financial reader through the whole
 * product. He handled the fact-find; the dashboard stopped him dead — "he felt completely lost...
 * he eventually clicked on Next Steps". Reading the page as he saw it explains why: on a first
 * visit EIGHT of its eleven blocks are empty, five of them "No <module> strategies saved yet" in
 * the widest column, so the eye is pulled to the emptiest part of the screen — while the one thing
 * he should do sits in a narrow card on the right, below the fold on a laptop.
 *
 * So on a first visit the dashboard leads with what to do, and stops showing shelves that hold
 * nothing. Nothing is deleted: the folded sections are one click away, and the moment anything is
 * saved this state is gone and the full dashboard returns unchanged.
 *
 * WHAT COUNTS AS A FIRST VISIT is "nothing saved yet", not "has logged in before" — owner's call,
 * 2026-08-22. Someone who arrives, feels lost and leaves without modelling anything is exactly the
 * person who needs this on their next visit, and a once-only flag would have taken it away from
 * them.
 *
 * The voice is NAME-LED, matching the fact-find: the reader is often a son or daughter, so this
 * says "George's profile" rather than "your profile" unless they are the applicant themselves.
 */ 
parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $420bac4ddd218a80$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 20h9",
            key: "t2du7b"
        }
    ],
    [
        "path",
        {
            d: "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z",
            key: "1ykcvy"
        }
    ],
    [
        "path",
        {
            d: "m15 5 3 3",
            key: "1w25hb"
        }
    ]
];
const $420bac4ddd218a80$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("pencil-line", $420bac4ddd218a80$export$3efd853dbb351e94);




const $ac9fcf827b574382$export$73e034489d98be69 = [
    {
        goal: 'aged_care',
        page: 'AgedCarePage',
        icon: (0, $d5c3c2c5a9eb8655$export$c5ec57f918f403fe).aged_care,
        title: (p)=>`Model ${p} aged care costs`,
        blurb: 'What a room costs, what would be paid each year, and how long the savings last.',
        forField: 'aged_care_for'
    },
    {
        goal: 'home_care',
        page: 'HomeCarePage',
        icon: (0, $d5c3c2c5a9eb8655$export$c5ec57f918f403fe).home_care,
        title: (p)=>`Model ${p} home care support`,
        blurb: 'What Support at Home would contribute, and what would be paid towards it.',
        forField: 'home_care_for'
    },
    {
        goal: 'retirement_village',
        page: 'RetirementVillagePage',
        icon: (0, $d5c3c2c5a9eb8655$export$c5ec57f918f403fe).retirement_village,
        title: (p)=>`Compare retirement village options`,
        blurb: 'Entry contribution, ongoing fees, and what comes back on leaving.'
    },
    {
        goal: 'downsize_home',
        page: 'DownsizingPage',
        icon: (0, $d5c3c2c5a9eb8655$export$c5ec57f918f403fe).downsize_home,
        title: (p)=>`Model downsizing ${p} home`,
        blurb: 'What selling frees up, and what it does to the Age Pension.'
    },
    {
        goal: 'granny_flat',
        page: 'GrannyFlatPage',
        icon: (0, $d5c3c2c5a9eb8655$export$c5ec57f918f403fe).granny_flat,
        title: (p)=>`Explore a granny flat arrangement`,
        blurb: 'What can be paid for the right to live there, and how Centrelink treats it.'
    }
];
const $ac9fcf827b574382$export$da1451e131353a6a = {
    goal: 'cashflow',
    page: 'CashflowPensionPage',
    icon: (0, $d5c3c2c5a9eb8655$export$c5ec57f918f403fe).cashflow,
    title: (p)=>`Model ${p} cashflow and Age Pension`,
    blurb: 'Where the money stands today, how far it goes, and what could improve the Age Pension.'
};
function $ac9fcf827b574382$export$b99630ccf9c9a1b7(forWhom, names, isCouple, readerIsApplicant) {
    const clientPossessive = readerIsApplicant ? 'your' : names.client ? `${names.client}'s` : 'their';
    const partnerPossessive = names.partner ? `${names.partner}'s` : 'their';
    if (!isCouple) return clientPossessive;
    if (forWhom === 'client') return clientPossessive;
    if (forWhom === 'partner') return partnerPossessive;
    // 'both', or a household goal with no answer recorded. ONE possessive at the end — "Michael and
    // Tara's home care", not "Michael's and Tara's home care", which is the owner's own phrasing and
    // the way people actually say it. The reader's own half is "you", since nobody refers to
    // themselves by name.
    const first = readerIsApplicant ? 'you' : names.client;
    if (!first && !names.partner) return 'their';
    if (!names.partner) return clientPossessive;
    if (!first) return partnerPossessive;
    return `${first} and ${names.partner}'s`;
}
function $ac9fcf827b574382$export$db92024a69a3ce1b(Possessive, completeness) {
    if (!completeness || completeness.isComplete) return `${Possessive} profile is complete.`;
    // "Your" drops its capital mid-sentence; a name keeps it.
    if (completeness.isEmpty) return `Let's start with ${Possessive === 'Your' ? 'your' : Possessive} profile.`;
    return `${Possessive} profile is ${completeness.percent}% complete.`;
}
function $ac9fcf827b574382$export$77c6d1ff598f455f(completeness) {
    // Nothing entered yet: from the beginning, "who is completing", not the first assessed step.
    if (completeness?.isEmpty) return 1;
    const i = (completeness?.steps ?? []).findIndex((st)=>!st.complete);
    return i < 0 ? 1 : i + 2;
}
const $ac9fcf827b574382$export$ef5c5eb8eeb80017 = ({ goals: goals, completeness: completeness = null, setClientProfileStep: setClientProfileStep, Possessive: Possessive, possessiveFor: possessiveFor, setActivePage: setActivePage, rows: rows = {}, alternatives: alternatives = null })=>{
    const actions = [
        ...$ac9fcf827b574382$export$73e034489d98be69.filter((a)=>goals?.[a.goal]),
        ...(rows.cashflow?.savedCount ?? 0) > 0 ? [
            $ac9fcf827b574382$export$da1451e131353a6a
        ] : []
    ];
    const incomplete = !!completeness && !completeness.isComplete;
    const nextLabel = incomplete ? completeness.steps.find((st)=>!st.complete)?.label ?? null : null;
    // The card that asks for the profile first: nothing entered yet, or no goal to act on. With a goal
    // set the actions show even when later steps are unfinished — a client may model from the goals
    // step (the browser flows do) — and the unfinished profile is a line beneath them, not a wall.
    const unfinished = incomplete && (completeness.isEmpty || actions.length === 0);
    if (unfinished) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-white rounded-2xl border border-slate-200/70 border-l-4 border-l-blue-600 shadow-card p-6",
        "data-testid": "start-here-unfinished",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-xs font-semibold uppercase tracking-wider text-blue-700 mb-1.5",
                children: "Start here"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "text-xl font-bold text-slate-900 tracking-tight",
                children: $ac9fcf827b574382$export$db92024a69a3ce1b(Possessive, completeness)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-sm text-slate-600 mt-1",
                children: completeness.isEmpty ? "It takes about ten minutes, and everything after it \u2014 the options, the figures, the plan \u2014 is built from it." : `Pick up where you left off${nextLabel ? ` \u{2014} ${nextLabel}` : ''}. The options and figures appear once the profile is done.`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    type: "button",
                    onClick: ()=>{
                        setClientProfileStep?.($ac9fcf827b574382$export$77c6d1ff598f455f(completeness));
                        setActivePage('Client Profile');
                    },
                    className: "inline-flex items-center gap-1.5 rounded-lg bg-blue-600 text-white text-sm font-semibold px-4 py-2.5 hover:bg-blue-700",
                    children: [
                        completeness.isEmpty ? 'Start the profile' : 'Continue the profile',
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                            size: 16
                        })
                    ]
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-white rounded-2xl border border-slate-200/70 border-l-4 border-l-blue-600 shadow-card p-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-xs font-semibold uppercase tracking-wider text-blue-700 mb-1.5",
                children: "Start here"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "text-xl font-bold text-slate-900 tracking-tight",
                children: incomplete ? `${Possessive} profile is nearly done.` : $ac9fcf827b574382$export$db92024a69a3ce1b(Possessive, completeness)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-sm text-slate-600 mt-1",
                children: actions.length > 0 ? 'Based on the goals you set, here is what to do next.' : 'No goals were set, so there is nothing to model yet. Add a goal in the profile and it will appear here.'
            }),
            alternatives && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-sm text-slate-600 mt-1",
                "data-testid": "start-here-alternatives",
                children: alternatives
            }),
            incomplete && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-sm text-slate-600 mt-1",
                "data-testid": "start-here-incomplete-line",
                children: [
                    "The profile is ",
                    completeness.percent,
                    "% complete",
                    nextLabel ? ` \u{2014} ${nextLabel} is next` : '',
                    ".",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "font-semibold text-blue-700 underline decoration-blue-300 underline-offset-2 hover:text-blue-800",
                        onClick: ()=>{
                            setClientProfileStep?.($ac9fcf827b574382$export$77c6d1ff598f455f(completeness));
                            setActivePage('Client Profile');
                        },
                        children: "Continue the profile"
                    })
                ]
            }),
            actions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-4 flex flex-col gap-3",
                children: actions.map((action)=>{
                    const { goal: goal, page: page, icon: Icon, title: title, blurb: blurb } = action;
                    const row = rows[goal];
                    if (row && row.savedCount > 0) {
                        const chosen = !!row.chosenTitle;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "w-full flex flex-wrap items-center gap-4 rounded-xl border border-slate-200 bg-white px-4 py-3.5",
                            "data-testid": `start-here-row-${goal}`,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                    icon: Icon,
                                    tone: "brand",
                                    variant: "solid",
                                    size: "md"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "flex-1 min-w-[220px]",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "flex flex-wrap items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "font-semibold text-slate-900",
                                                    children: title(possessiveFor(action))
                                                }),
                                                chosen && !row.outOfDate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "rounded-full border border-emerald-500 bg-white px-2 py-0.5 text-[12px] font-semibold text-emerald-800",
                                                    children: "Plan chosen"
                                                }),
                                                chosen && row.outOfDate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "rounded-full border border-slate-300 bg-white px-2 py-0.5 text-[12px] font-semibold text-slate-700",
                                                    "data-testid": `start-here-out-of-date-${goal}`,
                                                    children: "Plan out of date"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "block text-sm text-slate-600",
                                            "data-testid": `start-here-state-${goal}`,
                                            children: [
                                                chosen ? row.chosenTitle : `${row.savedCount} ${row.savedCount === 1 ? 'plan' : 'plans'} saved, none chosen yet`,
                                                chosen && row.outOfDate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        " \xb7 ",
                                                        row.outOfDate
                                                    ]
                                                }) : null,
                                                row.compare && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        " \xb7 ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: row.compare.onClick,
                                                            className: "font-semibold text-blue-700 underline decoration-dotted underline-offset-2 hover:text-blue-900",
                                                            children: row.compare.label
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "shrink-0 flex flex-wrap items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            onClick: row.onOpen,
                                            "data-testid": `start-here-open-${goal}`,
                                            className: "inline-flex items-center gap-1.5 rounded-lg bg-blue-600 text-white text-sm font-semibold px-3.5 py-2 hover:bg-blue-700 transition-colors",
                                            children: [
                                                chosen ? `Open ${/^you( |$)/.test(possessiveFor(action)) ? 'your' : possessiveFor(action)} plan` : 'Open last saved',
                                                " ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                    size: 15
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: row.onStartFresh,
                                            "data-testid": `start-here-start-${goal}`,
                                            title: "A new model from scratch: nothing carried over, and the questions asked again",
                                            className: "inline-flex items-center gap-1.5 rounded-lg border border-slate-300 bg-white text-slate-800 text-sm font-semibold px-3.5 py-2 hover:border-blue-300 hover:bg-blue-50 transition-colors",
                                            children: "Start new"
                                        })
                                    ]
                                })
                            ]
                        }, goal);
                    }
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>setActivePage(page),
                        className: "group w-full text-left flex items-center gap-4 rounded-xl border border-slate-200 bg-white hover:border-blue-300 px-4 py-3.5 transition-colors",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                icon: Icon,
                                tone: "brand",
                                variant: "solid",
                                size: "md"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "flex-1 min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "block font-semibold text-slate-900",
                                        children: title(possessiveFor(action))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "block text-sm text-slate-600",
                                        children: blurb
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "shrink-0 inline-flex items-center gap-1.5 rounded-lg bg-blue-600 text-white text-sm font-semibold px-3.5 py-2 group-hover:bg-blue-700 transition-colors",
                                children: [
                                    "Start ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                        size: 15
                                    })
                                ]
                            })
                        ]
                    }, goal);
                })
            })
        ]
    });
};
const $ac9fcf827b574382$export$8654c5f14998d604 = ({ facts: facts, onEdit: onEdit })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-white rounded-2xl border border-slate-200/70 shadow-card px-5 py-4 flex items-start justify-between gap-4 flex-wrap",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid gap-x-8 gap-y-3 sm:grid-cols-2 min-w-0 flex-1",
                children: facts.map(({ label: label, value: value })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-xs text-slate-500",
                                children: label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm font-semibold text-slate-900",
                                children: value
                            })
                        ]
                    }, label))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: onEdit,
                className: "shrink-0 inline-flex items-center gap-1.5 text-sm font-semibold text-blue-600 hover:text-blue-800 hover:underline",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $420bac4ddd218a80$export$2e2bcd8739ae039), {
                        size: 15
                    }),
                    " Edit details"
                ]
            })
        ]
    });
const $ac9fcf827b574382$export$32ae7e77b43ca9a4 = ({ onShowAll: onShowAll })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-2xl border border-dashed border-slate-300 bg-slate-50/70 px-5 py-4 flex items-center justify-between gap-4 flex-wrap",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-sm text-slate-600",
                children: "Your saved plans will appear here once you have modelled something."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: onShowAll,
                className: "shrink-0 inline-flex items-center gap-1.5 text-sm font-semibold text-slate-600 hover:text-slate-900 hover:underline",
                children: [
                    "Show all sections ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                        size: 15
                    })
                ]
            })
        ]
    });


/**
 * The village units side by side: one plan per unit, as chosen or saved. Opened from the village row's
 * "Compare the units" on Home when more than one unit is modelled (moved here from Home's former tiles,
 * 23 Oct 2026). Nothing here is computed: the figures are the saved plans' own.
 */ 
parcelRequire("acw62");


const $5eb5ca8e9ee335a7$var$RvUnitsDialog = ({ units: units, onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
        titleId: "rv-units-title",
        title: "The village units side by side",
        eyebrow: "One plan per unit, as chosen or saved",
        onClose: onClose,
        size: "xl",
        testId: "rv-units-dialog",
        flush: true,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "overflow-x-auto",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    className: "min-w-full text-[14px] tabular-nums",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                className: "border-b border-slate-200 text-left text-[12px] font-semibold text-slate-500",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "px-5 py-3",
                                        children: "Unit"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "px-5 py-3",
                                        children: "Plan"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "px-5 py-3 text-right",
                                        children: "Left to the family"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "px-5 py-3 text-right",
                                        children: "Age Pension"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "px-5 py-3 text-right",
                                        children: "Left over each year"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "px-5 py-3 text-right",
                                        children: "Fees a year"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                            children: units.map((u)=>{
                                const c = u.inputs?.card;
                                if (!c) return null;
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    className: "border-b border-slate-100",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                            className: "px-5 py-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    className: "text-slate-900",
                                                    children: c.village.name || 'The village'
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "text-slate-500",
                                                    children: [
                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(c.village.entryFee),
                                                        " entry payment"
                                                    ]
                                                }),
                                                u.chosen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "ml-2 rounded-full bg-emerald-50 px-2 py-0.5 text-[12px] font-semibold text-emerald-800",
                                                    children: "Chosen"
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "px-5 py-3 text-slate-700",
                                            children: c.words.title
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "px-5 py-3 text-right font-semibold",
                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(c.plan.legacy))
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "px-5 py-3 text-right",
                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(c.plan.pension))
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "px-5 py-3 text-right",
                                            children: c.plan.cashflow < 0 ? `short ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(-c.plan.cashflow))}` : (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(c.plan.cashflow))
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "px-5 py-3 text-right",
                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(c.village.annualOngoing))
                                        })
                                    ]
                                }, String(u.id));
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "px-5 py-3 text-[13px] text-slate-500",
                children: "Each unit was tested over its own years; figures are as they were when the plan was chosen or saved."
            })
        ]
    });
var $5eb5ca8e9ee335a7$export$2e2bcd8739ae039 = $5eb5ca8e9ee335a7$var$RvUnitsDialog;


/**
 * WHAT TELLS ONE SAVED PLAN FROM ANOTHER, at a glance on Home (owner, 23 Oct 2026: "I could create multiple saved
 * scenarios at different room costs … what's the lever that differentiates the saved models", without filling
 * the cards). One short fact per plan, from what the plan saved:
 *   aged care            the room: "Lakeside Gardens, $700,000 room"
 *   retirement village   the unit: "Banksia Grove, $600,000 entry"
 *   downsizing           the next home: "Elm Street, $850,000 home" / "renting at $650 a week"
 *   granny flat          what was given for the right: "$300,000 given for the right"
 * Null where the plan saved nothing to tell it by (an older record), so the line simply shows the date.
 */ 
const $8a1c93567d70a6d1$var$obj = (v)=>v && typeof v === 'object' ? v : {};
const $8a1c93567d70a6d1$var$num = (v)=>Number(v) || 0;
const $8a1c93567d70a6d1$var$named = (name, rest)=>String(name || '').trim() ? `${String(name).trim()}, ${rest}` : rest;
function $8a1c93567d70a6d1$export$8fe97d85839733d(record, typeHint) {
    const r = $8a1c93567d70a6d1$var$obj(record);
    // An advice document carries its plan's figures itself, or the plan under `strategy`.
    const inner = $8a1c93567d70a6d1$var$obj(r.strategy);
    const type = String(typeHint || r.type || inner.type || '');
    const inputs = {
        ...$8a1c93567d70a6d1$var$obj(inner.inputs),
        ...$8a1c93567d70a6d1$var$obj(r.inputs)
    };
    const outputs = {
        ...$8a1c93567d70a6d1$var$obj(inner.outputs),
        ...$8a1c93567d70a6d1$var$obj(r.outputs)
    };
    const card = $8a1c93567d70a6d1$var$obj(inputs.card);
    // An aged care advice document keeps the room on its snapshot (buildAgedCareDigitalSOASnapshot's roomCost).
    const snapshotRoom = $8a1c93567d70a6d1$var$num($8a1c93567d70a6d1$var$obj(r.soaSnapshot).roomCost);
    if (type === 'aged_care' || $8a1c93567d70a6d1$var$num(outputs.roomCost) > 0 || snapshotRoom > 0) {
        const room = $8a1c93567d70a6d1$var$num(outputs.roomCost) || $8a1c93567d70a6d1$var$num(inputs.radInput) || snapshotRoom;
        if (room <= 0) return null;
        return $8a1c93567d70a6d1$var$named(r.homeName ?? inner.homeName, `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(room)} room`);
    }
    if (type === 'retirement_village') {
        const ctx = $8a1c93567d70a6d1$var$obj(inputs.planContext);
        const village = $8a1c93567d70a6d1$var$obj(card.village);
        const fee = $8a1c93567d70a6d1$var$num(ctx.entryFee) || $8a1c93567d70a6d1$var$num(village.entryFee) || $8a1c93567d70a6d1$var$num($8a1c93567d70a6d1$var$obj(inputs.villageInputs).entryFee);
        if (fee <= 0) return null;
        return $8a1c93567d70a6d1$var$named(ctx.villageName ?? village.name, `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(fee)} entry`);
    }
    if (type === 'downsizer') {
        const move = $8a1c93567d70a6d1$var$obj(card.move);
        if (move.sellAndRent && $8a1c93567d70a6d1$var$num(move.rentPerWeek) > 0) return $8a1c93567d70a6d1$var$named(move.homeName, `renting at ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)($8a1c93567d70a6d1$var$num(move.rentPerWeek))} a week`);
        if ($8a1c93567d70a6d1$var$num(move.newHomePrice) > 0) return $8a1c93567d70a6d1$var$named(move.homeName, `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)($8a1c93567d70a6d1$var$num(move.newHomePrice))} home`);
        return null;
    }
    if (type === 'granny_flat') {
        const given = $8a1c93567d70a6d1$var$num($8a1c93567d70a6d1$var$obj(card.arrangement).given);
        return given > 0 ? `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(given)} given for the right` : null;
    }
    return null;
}







/**
 * Saved plans side by side — the comparison across homes, from Home (owner's design, 17 Oct 2026).
 *
 * Modelling another home is the same three steps again; the comparison happens afterwards, here, on
 * whichever saved plans the reader ticked. One row per plan, columns in the words the plans use, the
 * chosen row marked, and — because a pick-list cannot promise "same John, same money" — a line that
 * says what every plan shares and flags, in amber, anything that differs (living costs, horizon,
 * care start), so "left to the family" is never misread as a room comparison when it is not one.
 *
 * Every figure is the saved plan's own, quoted; nothing is re-run.
 */ 
parcelRequire("acw62");





const $913a5d4dfade16ea$var$homeWords = (plan)=>{
    const room = Number(plan.outputs?.roomCost) || 0;
    const name = String(plan.homeName || '').trim();
    const roomWords = room > 0 ? `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(room)} room` : 'room';
    return name ? `${name} \xb7 ${roomWords}` : roomWords;
};
const $913a5d4dfade16ea$var$basisOf = (plan)=>{
    const inputs = plan.inputs || {};
    const living = inputs.scenarioLivingExpenses != null ? Number(inputs.scenarioLivingExpenses) : plan.outputs?.livingExpenses != null ? Number(plan.outputs.livingExpenses) : null;
    const years = inputs.legacyYears != null ? Number(inputs.legacyYears) : null;
    const start = inputs.careStartDate ? String(inputs.careStartDate) : null;
    return {
        living: Number.isFinite(living) ? living : null,
        years: Number.isFinite(years) ? years : null,
        start: start
    };
};
const $913a5d4dfade16ea$var$ComparePlansModal = ({ plans: plans, factFind: factFind, chosenId: chosenId, onOpenPlan: onOpenPlan, onChoose: onChoose, onClose: onClose })=>{
    const titleOf = (plan)=>(0, $95e43332fd84eec4$export$6cc0d9545ae1511e)(plan, factFind);
    const bases = plans.map($913a5d4dfade16ea$var$basisOf);
    // A difference is two RECORDED values that disagree; a plan saved before a value was recorded
    // (null) is said to be unrecorded, never counted as different.
    const recorded = (pick)=>bases.map(pick).filter((v)=>v != null);
    const same = (pick)=>new Set(recorded(pick).map((v)=>JSON.stringify(v))).size <= 1;
    const livingSame = same((b)=>b.living);
    const yearsSame = same((b)=>b.years);
    const startSame = same((b)=>b.start ?? 'now');
    const first = bases[0];
    const firstLiving = recorded((b)=>b.living)[0];
    const firstYears = recorded((b)=>b.years)[0];
    const unrecorded = bases.some((b)=>b.years == null);
    const shared = [];
    if (livingSame && firstLiving != null) shared.push(`living costs ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(firstLiving))} a year once in care`);
    if (yearsSame && firstYears != null && !unrecorded) shared.push(`about ${firstYears} ${firstYears === 1 ? 'year' : 'years'} of care`);
    if (startSame) shared.push(first?.start ? `care starting ${new Date(first.start).toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    })}` : 'care starting now');
    const differ = [];
    if (!livingSame) differ.push('living costs');
    if (!yearsSame) differ.push('planning horizons');
    if (!startSame) differ.push('care start dates');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6c21ec44833357$export$2e2bcd8739ae039), {
        titleId: "compare-saved-plans-heading",
        testId: "compare-saved-plans-dialog",
        size: "xl",
        eyebrow: "The plans you ticked on Home",
        title: plans.length === 2 ? 'Two homes, side by side' : `${plans.length} plans, side by side`,
        intro: "The line under the table says which assumptions they share and flags any that differ.",
        onClose: onClose,
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                onChoose && plans.filter((p)=>chosenId == null || String(p.id) !== String(chosenId)).length === 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                    type: "button",
                    variant: "primary",
                    onClick: ()=>onChoose(plans.find((p)=>chosenId == null || String(p.id) !== String(chosenId))),
                    children: "Choose the other plan instead"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                    type: "button",
                    variant: "secondary",
                    onClick: onClose,
                    children: "Back to Home"
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d8e44526b4d2fe9$export$2e2bcd8739ae039), {
                    testId: "compare-saved-plans-table",
                    firstHeading: "Plan \xb7 home",
                    columns: [
                        {
                            key: 'legacy',
                            label: 'Left to the family',
                            best: 'max',
                            headline: true
                        },
                        {
                            key: 'cf',
                            label: 'Each year, short by',
                            best: 'max'
                        },
                        {
                            key: 'pension',
                            label: 'Age Pension a year',
                            best: 'max'
                        },
                        {
                            key: 'care',
                            label: 'Care costs a year',
                            best: 'min'
                        },
                        {
                            key: 'deposit',
                            label: 'Tied up in the deposit',
                            bar: 'amber'
                        }
                    ],
                    rows: plans.map((p)=>{
                        const isChosen = chosenId != null && String(p.id) === String(chosenId);
                        const legacy = Number(p.outputs?.legacyEstimate) || 0;
                        const base = p.baseline;
                        const delta = base?.legacyValue != null ? legacy - Number(base.legacyValue) : null;
                        const cf = Number(p.outputs?.cashFlow) || 0;
                        const row = p.strategy;
                        const deposit = Math.max(0, Number(row?.radPaidNet) || 0);
                        return {
                            key: String(p.id),
                            chosen: isChosen,
                            title: titleOf(p),
                            subtitle: $913a5d4dfade16ea$var$homeWords(p),
                            onOpen: ()=>onOpenPlan(p),
                            cells: {
                                legacy: {
                                    value: legacy,
                                    sub: delta != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: delta >= 0 ? 'text-emerald-700' : 'text-rose-700',
                                        children: [
                                            delta >= 0 ? '+' : "\u2212",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(delta))),
                                            " vs the comparison"
                                        ]
                                    }) : undefined
                                },
                                cf: {
                                    value: cf,
                                    display: cf < 0 ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Math.round(cf))) : `+${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(cf))}`,
                                    tone: cf < 0 ? 'neutral' : 'good'
                                },
                                pension: {
                                    value: Math.round(Number(p.outputs?.agePension) || 0)
                                },
                                care: {
                                    value: Math.round(Number(p.outputs?.agedCareCost) || 0)
                                },
                                deposit: {
                                    value: Math.round(deposit)
                                }
                            }
                        };
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mt-3 rounded-xl border border-slate-200 px-4 py-3 text-[13px] text-slate-700",
                    "data-testid": "compare-saved-plans-basis",
                    children: [
                        shared.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Same for every plan here:"
                                }),
                                " ",
                                shared.join(" \xb7 "),
                                "."
                            ]
                        }),
                        unrecorded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mt-1 text-slate-500",
                            children: "One of these plans was saved before its planning horizon was recorded, so the horizon is not compared."
                        }),
                        differ.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "mt-1 rounded-lg border border-slate-200 border-l-4 border-l-amber-400 bg-white px-3 py-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "Not a like-for-like comparison:"
                                }),
                                " these plans were modelled with different ",
                                differ.join(' and '),
                                ', so "left to the family" is not only a room comparison. Open a plan to change its assumptions and model it again.'
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $913a5d4dfade16ea$export$2e2bcd8739ae039 = $913a5d4dfade16ea$var$ComparePlansModal;



/**
 * The client menu, as one rule: what is on it, in what state, and why.
 *
 * Owner, 22–24 Sep 2026, from two mock-ups ("The client menu, today and proposed" and "The same
 * menu, at four points in a client's life"). The menu shows what is known and nothing more, and
 * grows as the file does — the same stages the Partner Portal's pipeline already uses:
 *
 *   1. Invite sent      — no name yet ("Not yet named"), the profile steps, and a hint saying the
 *                         living options appear once the goals in step 3 are set.
 *   2. Filling in       — step 2 has given the file a name; the goals ticked in step 3 appear as
 *                         living options, each a single click from anywhere.
 *   3. Ready to model   — the profile is complete, so its steps fold away behind a "Complete" tag.
 *   4. Advice           — plans exist, so their count sits on the option they belong to, and
 *                         Reports appears for the first time because there is now something to open.
 *
 * Decisions the owner made that this file exists to keep:
 *   - The client-file block carries the NAME and nothing else (23 Sep: "Just keep it simple with
 *     the client file name").
 *   - Only the goals ticked are listed. The other options are one line away under Goals, and the
 *     hint says so, rather than clutter for a client who never asked about them.
 *   - NO LOCK (24 Sep). A first design held each option back until Assets and Income/Expenses were
 *     done; the Dashboard has no such gate, and the owner did not want one while testing ("I don't
 *     want to be in a scenario where I need to enter every single bit of data before it unlocks").
 *     The menu and the Dashboard are two doors to the same rooms, reading the same facts, and they
 *     must never disagree about which doors are open.
 *   - Nothing on the menu leads to "coming soon". Partners is gone until there is something behind
 *     it; Reports opens the advice documents on the Dashboard, and only once one exists.
 *
 * "Complete" is profileCompleteness.ts's word — the same seven steps the Partner Portal measures —
 * so the menu and the portal never disagree about whether a file is ready.
 */ /**
 * How complete a client's fact-find actually is.
 *
 * ONE definition, shared by the server (which stamps it onto client_profiles at save time so the
 * Partner Portal's client list can show it without decrypting anything) and the frontend. Before
 * this existed the portal simply showed every real client as "50%" — a hardcoded placeholder, not a
 * measurement — so a finished file and an empty one looked identical in the pipeline.
 *
 * Measured against the SEVEN DATA-GATHERING STEPS of the fact-find UI (ClientProfileSteps.tsx),
 * because that is what the adviser and the client both see: "5 of 7 done" is answerable by looking
 * at the form, whereas a field-count percentage is not. A step counts as done when it holds the
 * data the advice engine actually needs from it — not merely when it has been visited, which is
 * what the old `clientProfileStep / 7` progress measured and why simply opening the last step read
 * as 95%.
 *
 * The UI's Step 1 ("who is completing this form?") is deliberately NOT one of them: it always
 * holds an answer, defaulting to the applicant themselves, so it can neither be incomplete nor
 * distinguish a finished file from an empty one. That is why the UI has eight steps and this has
 * seven, and why the labels below start at the UI's Step 2.
 *
 * Deliberately tolerant: this reads files written by every past version of the app, so a missing
 * section is "not done", never an error. It never throws.
 */ const $88b3ba5d01a1bc33$var$nonEmpty = (v)=>typeof v === 'string' && v.trim() !== '';
const $88b3ba5d01a1bc33$var$positive = (v)=>typeof v === 'number' && Number.isFinite(v) && v > 0;
/** A count that has been given, INCLUDING zero — "none" is an answer, not a blank. */ const $88b3ba5d01a1bc33$var$numberAnswered = (v)=>{
    if (typeof v === 'number') return Number.isFinite(v) && v >= 0;
    // Older files stored form values as the strings the DOM produced (see repairStoredFactFind);
    // reads here still have to cope with one that hasn't been through a save since.
    if (typeof v === 'string' && v.trim() !== '') return Number.isFinite(Number(v)) && Number(v) >= 0;
    return false;
};
/** Any row in any category of an assets/liabilities category map. */ function $88b3ba5d01a1bc33$var$hasAnyRow(map) {
    if (!map || typeof map !== 'object') return false;
    return Object.values(map).some((list)=>Array.isArray(list) && list.length > 0);
}
/** Any goal ticked, across the goals bag (values are booleans, plus a couple of string settings). */ function $88b3ba5d01a1bc33$var$hasAnyGoal(goals) {
    if (!goals || typeof goals !== 'object') return false;
    return Object.values(goals).some((v)=>v === true);
}
/**
 * The living-arrangements step is whichever sub-form the client's residency selects, so it is
 * complete when THAT form has its headline figure — not when the family-home form does.
 */ function $88b3ba5d01a1bc33$var$livingArrangementsComplete(fd) {
    const residency = fd.client?.currentResidency || 'own_home';
    switch(residency){
        // Read straight off the typed fact-find, no local casts: the rent figure is `rentAmount`
        // (factFindSchema.ts's `rentSchema`, which is `additionalProperties: false` and so would
        // strip anything else). A cast here spelt it `weeklyRent`, a field nothing ever writes, so
        // every renting client scored this step incomplete no matter what they entered.
        case 'renting':
            return $88b3ba5d01a1bc33$var$positive(fd.rent?.rentAmount);
        case 'granny_flat':
            return $88b3ba5d01a1bc33$var$positive(fd.grannyFlat?.amountPaid);
        case 'retirement_village':
            return $88b3ba5d01a1bc33$var$positive(fd.retirementVillage?.entryContribution);
        case 'with_family':
            // No figure of its own — answering the residency question IS the substance of this step.
            return true;
        case 'aged_care':
            return true;
        default:
            return $88b3ba5d01a1bc33$var$positive(fd.home?.value);
    }
}
/**
 * Gifting has been ANSWERED — a gift recorded, or "nothing gifted" explicitly confirmed.
 *
 * OWNER-CAUGHT, 23 Sep 2026. This step counted only living expenses, so skipping the gifting
 * question left the file "complete" with the question never asked. Gifts inside five years are
 * assessed by Centrelink, so "no gifts" and "never asked" produce different advice while looking
 * identical in the data — the same trap `liabilitiesConfirmedNone` exists to close on the step
 * above. The UI already writes `confirmedNone` when the client answers "No — nothing gifted";
 * this simply reads it.
 *
 * Capital expenses are deliberately NOT tested: they are genuinely optional, and requiring them
 * would leave most files permanently incomplete for a section most households never use.
 */ function $88b3ba5d01a1bc33$var$giftingAnswered(fd) {
    const gifts = fd.giftsHistory;
    return gifts?.hasGifted === true || gifts?.confirmedNone === true;
}
/**
 * The estate questions have been ANSWERED for a person — "Will in place?" is yes, no or unsure.
 *
 * OWNER-CAUGHT, 24 Sep 2026. The Family/Estate step counted only the children count, and a blank
 * profile seeds that as 0 — a legitimate answer for a childless household, but also what every
 * untouched file carries — so the step read as done, and the whole profile as "Complete", before
 * anyone had opened it. The estate radios have no seed and are only ever set by a person answering,
 * so they are the evidence the children count cannot be. "Unsure" counts: it is an answer.
 */ function $88b3ba5d01a1bc33$var$estateAnswered(family, who) {
    const answer = family?.[`${who}Will`];
    return answer === 'yes' || answer === 'no' || answer === 'unsure';
}
/** A person's details are enough to advise on: who they are and how old they are. */ function $88b3ba5d01a1bc33$var$personComplete(person) {
    return $88b3ba5d01a1bc33$var$nonEmpty(person?.firstName) && $88b3ba5d01a1bc33$var$nonEmpty(person?.dob);
}
function $88b3ba5d01a1bc33$export$e88a800cc66f6f24(factFind) {
    const fd = factFind || {};
    const isCouple = fd.adviceFor === 'couple';
    const steps = [
        {
            id: 'your_details',
            label: 'Your Details',
            // For a couple, BOTH applicants' details drive the modelling (ages set drawdowns, means
            // testing and SAPTO), so a half-filled couple is not a finished step.
            complete: $88b3ba5d01a1bc33$var$personComplete(fd.client) && (!isCouple || $88b3ba5d01a1bc33$var$personComplete(fd.partner))
        },
        {
            id: 'goals',
            label: 'Goals',
            complete: $88b3ba5d01a1bc33$var$hasAnyGoal(fd.goals)
        },
        {
            id: 'living_arrangements',
            label: 'Living Arrangements',
            complete: $88b3ba5d01a1bc33$var$livingArrangementsComplete(fd)
        },
        {
            id: 'assets',
            label: 'Assets',
            complete: $88b3ba5d01a1bc33$var$hasAnyRow(fd.assets)
        },
        {
            id: 'liabilities',
            label: 'Liabilities',
            // "No debts" is a legitimate, complete answer — but an untouched step is not, and the two
            // look identical in the data. `liabilitiesConfirmedNone` is what the UI sets when the
            // client explicitly confirms it; without it, rows are the only positive evidence.
            complete: $88b3ba5d01a1bc33$var$hasAnyRow(fd.liabilities) || fd.liabilitiesConfirmedNone === true
        },
        {
            id: 'income_expenses',
            label: 'Income/Expenses',
            complete: $88b3ba5d01a1bc33$var$positive(fd.expenses?.livingExpenses) && $88b3ba5d01a1bc33$var$giftingAnswered(fd)
        },
        {
            id: 'family_estate',
            // A childless household answers 0, which is every bit as complete as answering 3 — so
            // this tests for "a number is present", not "a number greater than zero". But 0 is also
            // the seed, so the step needs the estate question answered too (estateAnswered), for
            // both of a couple as Your Details requires both.
            label: 'Family/Estate',
            complete: $88b3ba5d01a1bc33$var$numberAnswered(fd.family?.childrenCount) && $88b3ba5d01a1bc33$var$estateAnswered(fd.family, 'client') && (!isCouple || $88b3ba5d01a1bc33$var$estateAnswered(fd.family, 'partner'))
        }
    ];
    const completedSteps = steps.filter((s)=>s.complete).length;
    const totalSteps = steps.length;
    return {
        percent: Math.round(completedSteps / totalSteps * 100),
        completedSteps: completedSteps,
        totalSteps: totalSteps,
        steps: steps,
        isEmpty: completedSteps === 0,
        isComplete: completedSteps === totalSteps
    };
}


const $e990f63b36c4bd03$export$a0cc69c164393dad = [
    {
        step: 1,
        name: "Who's Completing",
        id: null
    },
    {
        step: 2,
        name: 'Your Details',
        id: 'your_details'
    },
    {
        step: 3,
        name: 'Goals',
        id: 'goals'
    },
    {
        step: 4,
        name: 'Living Arrangements',
        id: 'living_arrangements'
    },
    {
        step: 5,
        name: 'Assets',
        id: 'assets'
    },
    {
        step: 6,
        name: 'Liabilities',
        id: 'liabilities'
    },
    {
        step: 7,
        name: 'Income/Expenses',
        id: 'income_expenses'
    },
    {
        step: 8,
        name: 'Family/Estate',
        id: 'family_estate'
    }
];
const $e990f63b36c4bd03$export$44b67b06507366d = 3;
const $e990f63b36c4bd03$export$af6a642f26fbf6dd = [
    {
        goal: 'aged_care',
        page: 'AgedCarePage',
        label: 'Aged care',
        planType: 'aged_care'
    },
    {
        goal: 'home_care',
        page: 'HomeCarePage',
        label: 'Support at home',
        planType: 'home_care'
    },
    {
        goal: 'retirement_village',
        page: 'RetirementVillagePage',
        label: 'Retirement village',
        planType: 'retirement_village'
    },
    {
        goal: 'downsize_home',
        page: 'DownsizingPage',
        label: 'Downsizing',
        planType: 'downsizer'
    },
    {
        goal: 'granny_flat',
        page: 'GrannyFlatPage',
        label: 'Granny flat',
        planType: 'granny_flat'
    }
];
const $e990f63b36c4bd03$export$83d175d808ef6f68 = {
    goal: null,
    page: 'CashflowPensionPage',
    label: 'Cashflow & Age Pension',
    planType: 'cashflow_pension'
};
const $e990f63b36c4bd03$export$b2f3bf9c7e33d4ec = 'advice-documents';
const $e990f63b36c4bd03$var$clean = (v)=>String(v ?? '').trim();
function $e990f63b36c4bd03$export$784a6ad9c3f17bc8(fd, fallbackName) {
    const cf = $e990f63b36c4bd03$var$clean(fd?.client?.firstName);
    const cl = $e990f63b36c4bd03$var$clean(fd?.client?.lastName);
    if (!cf) return $e990f63b36c4bd03$var$clean(fallbackName) || null;
    const pf = $e990f63b36c4bd03$var$clean(fd?.partner?.firstName);
    const pl = $e990f63b36c4bd03$var$clean(fd?.partner?.lastName);
    const clientName = [
        cf,
        cl
    ].filter(Boolean).join(' ');
    if (fd?.adviceFor !== 'couple' || !pf) return clientName;
    if (cl && pl && cl.toLowerCase() === pl.toLowerCase()) return `${cf} & ${pf} ${cl}`;
    if (!cl && !pl) return `${cf} & ${pf}`;
    return `${clientName} & ${[
        pf,
        pl
    ].filter(Boolean).join(' ')}`;
}
const $e990f63b36c4bd03$var$plural = (n, one, many)=>`${n} ${n === 1 ? one : many}`;
function $e990f63b36c4bd03$export$3410c5544a8327c2(input) {
    const fd = input.factFind ?? null;
    const completeness = (0, $88b3ba5d01a1bc33$export$e88a800cc66f6f24)(fd);
    const doneById = new Map(completeness.steps.map((s)=>[
            s.id,
            s.complete
        ]));
    const steps = $e990f63b36c4bd03$export$a0cc69c164393dad.map((s)=>({
            step: s.step,
            name: s.name,
            // Step 1 always holds an answer, so it reads as done once anything at all has been entered.
            done: s.id ? Boolean(doneById.get(s.id)) : !completeness.isEmpty
        }));
    const goals = fd?.goals ?? {};
    const plans = input.savedStrategies ?? [];
    const countPlans = (planType)=>plans.filter((p)=>p?.type === planType).length;
    const withCount = (def)=>{
        const planCount = countPlans(def.planType);
        // Once a plan is chosen the tag says so (UX review, 17 Oct 2026): "Plan chosen" is the state
        // that matters on the menu, not how many were saved along the way.
        const chosen = plans.some((p)=>p?.type === def.planType && p?.chosen === true);
        return {
            ...def,
            planCount: planCount,
            planTag: chosen ? 'Plan chosen' : planCount > 0 ? $e990f63b36c4bd03$var$plural(planCount, 'plan', 'plans') : null
        };
    };
    const ticked = $e990f63b36c4bd03$export$af6a642f26fbf6dd.filter((o)=>o.goal && goals[o.goal] === true).map(withCount);
    // Listed only once a plan of it is saved, so saved work keeps a door (owner, 19 Oct 2026: a permanent
    // entry "just creates noise"; the way in is Support at home's, for someone awaiting an assessment).
    const livingOptions = countPlans($e990f63b36c4bd03$export$83d175d808ef6f68.planType) > 0 ? [
        ...ticked,
        withCount($e990f63b36c4bd03$export$83d175d808ef6f68)
    ] : ticked;
    let livingHint = null;
    if (ticked.length === 0) livingHint = livingOptions.length ? `More options appear once the goals in step ${$e990f63b36c4bd03$export$44b67b06507366d} are set.` : `Living options appear once the goals in step ${$e990f63b36c4bd03$export$44b67b06507366d} are set.`;
    else {
        const others = $e990f63b36c4bd03$export$af6a642f26fbf6dd.filter((o)=>o.goal && goals[o.goal] !== true).map((o)=>o.label.toLowerCase());
        if (others.length) livingHint = `Other options \u{2014} ${others.join(', ')} \u{2014} are added under Goals.`;
    }
    const visibleDocs = (input.savedCaseStudies ?? []).filter((s)=>!input.professionalCaseId || !s.caseId || s.caseId === input.professionalCaseId);
    const drafts = visibleDocs.filter((s)=>(s.soaDeliveryStatus || 'draft') === 'draft').length;
    const reports = visibleDocs.length ? {
        total: visibleDocs.length,
        drafts: drafts,
        tag: drafts === 1 ? 'Draft' : drafts > 1 ? $e990f63b36c4bd03$var$plural(drafts, 'draft', 'drafts') : $e990f63b36c4bd03$var$plural(visibleDocs.length, 'saved', 'saved')
    } : null;
    return {
        fileName: $e990f63b36c4bd03$export$784a6ad9c3f17bc8(fd, input.fallbackName),
        profileComplete: completeness.isComplete,
        steps: steps,
        livingOptions: livingOptions,
        livingHint: livingHint,
        reports: reports
    };
}




/**
 * "Your Action Plan" on the Dashboard: one journey per goal, its steps, and the documents each step
 * opens (owner, 3 Oct 2026 rework).
 *
 * Every chip now opens something real — a pre-filled answer sheet for an official form, a checklist,
 * or the page in the app where the work is done (features/forms/actionPlanDocuments.ts). A step that
 * needs something we cannot provide yet shows it greyed as "coming soon" rather than promising it.
 *
 * The means assessment opens a chooser rather than a form, because which form is right turns on a
 * fact the tool can only estimate — whether the client actually receives the Age Pension today — and,
 * for a couple, on who is going into care. It replaces the old position pop-up, whose Continue button
 * closed it and produced nothing.
 */ 

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");





/**
 * Every document the Action Plan can open, by id, and which form a client needs (owner, 3 Oct 2026).
 *
 * A journey step names document ids; this file says what each one is called on the chip, whether it
 * applies to this client, and builds it. One place, so the step chips, the Quick Actions and the tests
 * agree — and so a chip is never a label with nothing behind it again.
 */ /**
 * The pre-filled "answer sheet" — how the Action Plan fills in government forms (owner, 3 Oct 2026).
 *
 * WHY NOT THE OFFICIAL PDF. Services Australia's SA485, SA457 and SA456 are print-and-fill PDFs with
 * no fillable fields, and they are locked against modification, so answers cannot be stamped into
 * the official document. They are also revised several times a year (SA485.2511 → .2607), so a
 * copy kept here would go stale. What the client gets instead is the official form's own questions,
 * by number, with the answer from their profile beside each one — to copy onto the paper form, or
 * to have open while they complete the same claim online through myGov, which Services Australia
 * says is faster. Every sheet links to the form's landing page, never to a PDF address (those
 * change with each edition).
 *
 * WHAT EACH ROW SAYS. `filled` — taken from the profile. `check` — from the profile but an
 * estimate the form wants exact (a balance on a statement, a market value). `you` — the form asks
 * for something the profile does not hold (a reference number, an address, a legal description).
 * `skip` — the form's own "go to" logic means the question does not apply. Nothing is invented: a
 * figure the profile does not have is a `you`, never a guess.
 *
 * No provider names in client-facing text; the documents are the client's, not ours.
 */ 
const $6e8c599c5d82cc63$export$5517df3497010beb = (v)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(v));
function $6e8c599c5d82cc63$export$4cf11838cdc2a8a8(s) {
    return String(s ?? '').replace(/[&<>"']/g, (c)=>({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        })[c]);
}
function $6e8c599c5d82cc63$export$36b357fd0e6c9d2f(iso) {
    if (!iso) return '';
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso));
    if (m) return `${m[3]}/${m[2]}/${m[1]}`;
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-AU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
}
const $6e8c599c5d82cc63$var$STATUS_LABEL = {
    filled: 'From your profile',
    check: 'Check this',
    you: 'You fill this in',
    skip: 'Does not apply'
};
function $6e8c599c5d82cc63$export$635e8b66b7517c56(sheet) {
    const counts = {
        filled: 0,
        check: 0,
        you: 0,
        skip: 0
    };
    for (const s of sheet.sections)for (const r of s.rows)counts[r.status] += 1;
    return counts;
}
function $6e8c599c5d82cc63$export$4d4a859ac38bf121(sheet) {
    const counts = $6e8c599c5d82cc63$export$635e8b66b7517c56(sheet);
    const isChecklist = sheet.kind === 'checklist';
    const generated = new Date(sheet.generatedAt);
    const when = Number.isNaN(generated.getTime()) ? '' : generated.toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });
    const section = (s)=>isChecklist ? `<h2>${$6e8c599c5d82cc63$export$4cf11838cdc2a8a8(s.title)}</h2><ul class="check">${s.rows.map((r)=>`<li><span class="box" aria-hidden="true"></span><div><strong>${$6e8c599c5d82cc63$export$4cf11838cdc2a8a8(r.question)}</strong>${r.answer ? `<div class="sub">${$6e8c599c5d82cc63$export$4cf11838cdc2a8a8(r.answer)}</div>` : ''}${r.note ? `<div class="note-inline">${$6e8c599c5d82cc63$export$4cf11838cdc2a8a8(r.note)}</div>` : ''}</div></li>`).join('')}</ul>` : `<h2>${$6e8c599c5d82cc63$export$4cf11838cdc2a8a8(s.title)}</h2><table><colgroup><col class="c-q"><col class="c-ask"><col></colgroup><thead><tr><th class="qn">Q</th><th>The form asks</th><th>Your answer</th></tr></thead><tbody>${s.rows.map((r)=>`<tr class="st-${r.status}"><td class="qn">${$6e8c599c5d82cc63$export$4cf11838cdc2a8a8(r.q ?? '')}</td><td>${$6e8c599c5d82cc63$export$4cf11838cdc2a8a8(r.question)}</td><td><div class="ans">${$6e8c599c5d82cc63$export$4cf11838cdc2a8a8(r.answer)}</div><div class="tag tag-${r.status}">${$6e8c599c5d82cc63$var$STATUS_LABEL[r.status]}</div>${r.note ? `<div class="note-inline">${$6e8c599c5d82cc63$export$4cf11838cdc2a8a8(r.note)}</div>` : ''}</td></tr>`).join('')}</tbody></table>`;
    return `<!DOCTYPE html>
<html lang="en-AU"><head><meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<title>${$6e8c599c5d82cc63$export$4cf11838cdc2a8a8(sheet.code ? `${sheet.code} \u{2014} ${sheet.title}` : sheet.title)}</title>
<style>
  :root{color-scheme:light}
  *{box-sizing:border-box}
  body{margin:0;background:#f8fafc;color:#0f172a;font:15px/1.5 -apple-system,"Segoe UI",Roboto,Helvetica,Arial,sans-serif}
  .page{max-width:900px;margin:0 auto;padding:36px 20px 64px}
  .doc{background:#fff;border:1px solid #e2e8f0;border-radius:16px;box-shadow:0 10px 30px rgba(15,23,42,.06);overflow:hidden}
  .doc::before{content:'';display:block;height:4px;background:linear-gradient(90deg,#2563eb,#14b8a6)}
  .inner{padding:32px 36px 36px}
  .badge{display:inline-block;font-size:12px;font-weight:800;letter-spacing:.06em;color:#1d4ed8;border:1px solid #bfdbfe;border-radius:999px;padding:3px 10px;margin-bottom:10px}
  h1{margin:0 0 4px;font-size:25px;letter-spacing:-.02em;line-height:1.2}
  .for{color:#475569;margin:0 0 16px}
  .lede{color:#334155;margin:0 0 14px}
  .note{border:1px solid #e2e8f0;border-left:4px solid #2563eb;border-radius:12px;padding:12px 14px;margin:14px 0;font-size:14px;color:#334155}
  .note--amber{border-left-color:#f59e0b}
  .note ul{margin:6px 0 0;padding-left:18px}
  .summary{display:flex;flex-wrap:wrap;gap:8px;margin:6px 0 4px}
  .summary span{font-size:12.5px;font-weight:600;border:1px solid #e2e8f0;border-radius:999px;padding:3px 10px;color:#334155;background:#fff}
  h2{font-size:12px;font-weight:800;text-transform:uppercase;letter-spacing:.08em;color:#64748b;margin:26px 0 8px}
  table{width:100%;border-collapse:collapse;table-layout:fixed}
  col.c-q{width:48px}col.c-ask{width:46%}
  th,td{text-align:left;vertical-align:top;padding:9px 10px;border-bottom:1px solid #e2e8f0;font-size:14px}
  th{font-size:11.5px;text-transform:uppercase;letter-spacing:.05em;color:#64748b;font-weight:700}
  td.qn,th.qn{color:#1d4ed8;font-weight:800;font-variant-numeric:tabular-nums}
  .ans{font-weight:600;color:#0f172a;white-space:pre-line}
  tr.st-you .ans{color:#92400e}
  tr.st-skip td{color:#94a3b8}
  tr.st-skip .ans{color:#94a3b8;font-weight:500}
  .tag{display:inline-block;margin-top:4px;font-size:11px;font-weight:700;border-radius:999px;padding:1px 8px;border:1px solid #e2e8f0;color:#475569}
  .tag-filled{border-color:#a7f3d0;color:#047857}
  .tag-check{border-color:#bfdbfe;color:#1d4ed8}
  .tag-you{border-color:#fcd34d;color:#92400e}
  .tag-skip{color:#94a3b8}
  .note-inline{margin-top:4px;font-size:12.5px;color:#64748b}
  ul.check{list-style:none;margin:0;padding:0}
  ul.check li{display:flex;gap:12px;align-items:flex-start;padding:9px 0;border-bottom:1px solid #f1f5f9}
  .box{flex:0 0 18px;height:18px;border:2px solid #94a3b8;border-radius:4px;margin-top:2px}
  .sub{font-size:13.5px;color:#475569}
  ol.docs{margin:0;padding-left:20px}
  ol.docs li{margin:0 0 5px}
  .foot{margin-top:26px;padding-top:12px;border-top:1px solid #e2e8f0;font-size:12.5px;color:#64748b}
  .actions{display:flex;gap:10px;justify-content:flex-end;margin:0 0 12px}
  .btn{border:1px solid #cbd5e1;background:#fff;border-radius:10px;padding:8px 14px;font-weight:600;font-size:14px;cursor:pointer;color:#0f172a;text-decoration:none}
  @media print{body{background:#fff}.page{padding:0}.doc{border:0;box-shadow:none;border-radius:0}.actions{display:none}tr{break-inside:avoid}}
</style></head>
<body><div class="page">
<div class="actions">${sheet.officialUrl ? `<a class="btn" href="${$6e8c599c5d82cc63$export$4cf11838cdc2a8a8(sheet.officialUrl)}" target="_blank" rel="noopener noreferrer">Open the official ${isChecklist ? 'page' : 'form'}</a>` : ''}<button class="btn" type="button" onclick="window.print()">Print or save as PDF</button></div>
<div class="doc"><div class="inner">
${sheet.code ? `<div class="badge">${$6e8c599c5d82cc63$export$4cf11838cdc2a8a8(sheet.code)}</div>` : ''}
<h1>${$6e8c599c5d82cc63$export$4cf11838cdc2a8a8(sheet.title)}</h1>
<p class="for">Prepared for ${$6e8c599c5d82cc63$export$4cf11838cdc2a8a8(sheet.personName)}${when ? ` on ${$6e8c599c5d82cc63$export$4cf11838cdc2a8a8(when)}` : ''}</p>
<p class="lede">${$6e8c599c5d82cc63$export$4cf11838cdc2a8a8(sheet.intro)}</p>
${isChecklist ? '' : `<div class="summary"><span>${counts.filled + counts.check} answered from your profile</span><span>${counts.you} for you to fill in</span>${counts.skip ? `<span>${counts.skip} that do not apply</span>` : ''}</div>
<div class="note">This is not the form itself. ${sheet.code ? `It follows the official ${$6e8c599c5d82cc63$export$4cf11838cdc2a8a8(sheet.code)} question by question` : 'It follows the official form'}, with the answer from your profile beside each one. Copy the answers onto the form, or keep this open while you complete it online. Answer as at the date you lodge: if anything has changed since you last updated your profile, use today's figure.</div>`}
${sheet.howToLodge.length ? `<div class="note note--amber"><strong>${isChecklist ? 'Before you start' : 'How to lodge'}</strong><ul>${sheet.howToLodge.map((l)=>`<li>${$6e8c599c5d82cc63$export$4cf11838cdc2a8a8(l)}</li>`).join('')}</ul></div>` : ''}
${sheet.sections.map(section).join('')}
${sheet.documents.length ? `<h2>Documents to include</h2><ol class="docs">${sheet.documents.map((d)=>`<li>${$6e8c599c5d82cc63$export$4cf11838cdc2a8a8(d)}</li>`).join('')}</ol>` : ''}
<div class="foot">Prepared from the details in your profile${sheet.code ? `. The official form may have changed since: if a question number does not match, go by the wording` : ''}. This is general information to help you complete it, not advice; Services Australia makes the assessment.</div>
</div></div>
</div></body></html>`;
}
function $6e8c599c5d82cc63$export$69a28af8f8bbe07c(sheet, fileStem) {
    const html = $6e8c599c5d82cc63$export$4d4a859ac38bf121(sheet);
    const blob = new Blob([
        html
    ], {
        type: 'text/html;charset=utf-8'
    });
    const url = URL.createObjectURL(blob);
    const tab = window.open('', '_blank');
    if (tab) {
        tab.document.open();
        tab.document.write(html);
        tab.document.close();
    } else {
        const openLink = document.createElement('a');
        openLink.href = url;
        openLink.target = '_blank';
        openLink.rel = 'noopener noreferrer';
        document.body.appendChild(openLink);
        openLink.click();
        document.body.removeChild(openLink);
    }
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = `${fileStem.replace(/[^a-zA-Z0-9_-]/g, '_')}_${sheet.generatedAt.slice(0, 10)}.html`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    setTimeout(()=>URL.revokeObjectURL(url), 30000);
}


/**
 * The Action Plan's other documents (owner, 3 Oct 2026) — the ones that are not a Services Australia
 * means-assessment form but are still a step the client has to take:
 *
 *   - the aged care needs assessment application (My Aged Care) — there is no paper form; the details
 *     it asks for, ready to hand;
 *   - the ATO's Downsizer contribution into super form (NAT 75073) — one per person;
 *   - telling Services Australia about a granny flat interest, or a move into a retirement village —
 *     there is no form for either, so the sheet is what to say and what to have in front of you;
 *   - the move-in checklist for residential care, the village contract checklist and the moving
 *     checklist — practical lists with nothing to pre-fill but everything to tick.
 */ 
/**
 * The profile, read from the point of view of the person a form is for.
 *
 * The means-assessment forms are completed for ONE person ("the person the assessment is for"),
 * with their partner's details alongside. So "your share" and "your partner's share" depend on who
 * that is: a joint account is 50/50 either way, an account in the partner's name is 0/100 on the
 * client's form and 100/0 on the partner's. Everything here takes `who` and answers accordingly.
 */ const $4156d91797dcfac7$export$61cc6a0be4938a2a = (v)=>{
    const x = typeof v === 'number' ? v : parseFloat(String(v ?? '').replace(/[$,\s]/g, ''));
    return Number.isFinite(x) ? x : 0;
};
const $4156d91797dcfac7$export$411666eeb8222a3e = (ff)=>ff?.adviceFor === 'couple';
function $4156d91797dcfac7$export$6a69dcfdc0a4cbf4(ff, who) {
    const p = (who === 'partner' ? ff?.partner : ff?.client) || {};
    const first = String(p.firstName || '').trim();
    const last = String(p.lastName || '').trim();
    return {
        first: first,
        last: last,
        full: [
            first,
            last
        ].filter(Boolean).join(' ') || (who === 'partner' ? 'Your partner' : 'You'),
        dob: String(p.dob || ''),
        sex: String(p.sex || ''),
        email: String(p.email || ''),
        phone: String(p.preferredPhone || ''),
        residency: String(p.currentResidency || '')
    };
}
const $4156d91797dcfac7$export$dcc5ce7991925d32 = (who)=>who === 'client' ? 'partner' : 'client';
function $4156d91797dcfac7$export$cecba97898c85a14(ownership, who, couple) {
    const o = String(ownership ?? '');
    if (o.startsWith('entity:')) return {
        you: 0,
        partner: 0,
        other: 100,
        entity: o.slice(7)
    };
    if (o === 'joint') return couple ? {
        you: 50,
        partner: 50,
        other: 0,
        entity: null
    } : {
        you: 100,
        partner: 0,
        other: 0,
        entity: null
    };
    if (o === 'other_entity') return {
        you: 0,
        partner: 0,
        other: 100,
        entity: null
    };
    if (o === 'partner') return who === 'partner' ? {
        you: 100,
        partner: 0,
        other: 0,
        entity: null
    } : {
        you: 0,
        partner: 100,
        other: 0,
        entity: null
    };
    // 'client', blank or unsure: the client's.
    return who === 'client' ? {
        you: 100,
        partner: 0,
        other: 0,
        entity: null
    } : {
        you: 0,
        partner: 100,
        other: 0,
        entity: null
    };
}
function $4156d91797dcfac7$export$544e28ed14862ad(s, couple, structureName) {
    if (s.entity) return `Owned by ${structureName || 'a trust or company'} (an entity), not personally`;
    const parts = [
        `your share ${s.you}%`
    ];
    if (couple) parts.push(`partner's share ${s.partner}%`);
    if (s.other) parts.push(`other's share ${s.other}%`);
    return parts.join(', ');
}
function $4156d91797dcfac7$export$f15d9fecc8ba66e9(ff, ...types) {
    const map = ff?.assets || {};
    return types.flatMap((t)=>(map[t] || []).map((a)=>({
                ...a,
                type: a.type || t
            })));
}
function $4156d91797dcfac7$export$7d9d14c3abaeac86(ff) {
    const map = ff?.liabilities || {};
    return Object.entries(map).flatMap(([t, rows])=>(rows || []).map((l)=>({
                ...l,
                type: l.type || t
            })));
}
function $4156d91797dcfac7$export$7bda649cebedb52f(ff) {
    return $4156d91797dcfac7$export$7d9d14c3abaeac86(ff).filter((l)=>l.type === 'mortgages' && (!l.assetLink || l.assetLink === 'home')).reduce((t, l)=>t + $4156d91797dcfac7$export$61cc6a0be4938a2a(l.balance ?? l.value), 0);
}
function $4156d91797dcfac7$export$5d71e490b6ce5ee1(ff, assetId) {
    if (!assetId) return 0;
    return $4156d91797dcfac7$export$7d9d14c3abaeac86(ff).filter((l)=>String(l.assetLink) === String(assetId)).reduce((t, l)=>t + $4156d91797dcfac7$export$61cc6a0be4938a2a(l.balance ?? l.value), 0);
}
function $4156d91797dcfac7$export$b3032da444501e98(ff, id) {
    if (!id) return undefined;
    return (ff?.structures || []).find((s)=>String(s.id) === id)?.name || undefined;
}
function $4156d91797dcfac7$export$e0ae14a586691b5(ff, asAt) {
    const g = ff?.giftsHistory || {};
    const fyEnd = asAt.getMonth() >= 6 ? asAt.getFullYear() + 1 : asAt.getFullYear();
    return Object.entries(g).map(([k, v])=>({
            m: /^year(\d{4})$/.exec(k),
            v: v
        })).filter((x)=>x.m && $4156d91797dcfac7$export$61cc6a0be4938a2a(x.v) > 0).map((x)=>({
            year: Number(x.m[1]),
            amount: $4156d91797dcfac7$export$61cc6a0be4938a2a(x.v)
        })).filter((x)=>x.year > fyEnd - 5 && x.year <= fyEnd).sort((a, b)=>a.year - b.year);
}
function $4156d91797dcfac7$export$8f1258fd713609e3(ff) {
    const res = ff?.client?.currentResidency;
    return $4156d91797dcfac7$export$61cc6a0be4938a2a(ff?.home?.value) > 0 && (res === 'own_home' || res === 'retirement_village' || res === 'aged_care' || !res);
}
function $4156d91797dcfac7$export$90b433c608c179c0(ff) {
    if (!$4156d91797dcfac7$export$411666eeb8222a3e(ff)) return 'client';
    const c = ff?.careNeeds?.clientAcat?.recommendation?.residential;
    const p = ff?.careNeeds?.partnerAcat?.recommendation?.residential;
    return !c && p ? 'partner' : 'client';
}
function $4156d91797dcfac7$export$6c7d5c44eeff8f8a(ff) {
    const onBehalf = !!ff?.completer && ff.completer !== 'client';
    return {
        onBehalf: onBehalf,
        name: [
            ff?.completerFirstName,
            ff?.completerLastName
        ].filter(Boolean).join(' '),
        relationship: String(ff?.completerRelationship || '')
    };
}


const $5c498757507ee8ef$var$yes = (question, answer = '', note)=>({
        question: question,
        answer: answer,
        status: 'filled',
        note: note
    });
const $5c498757507ee8ef$var$tick = (question, answer = '', note)=>({
        question: question,
        answer: answer,
        status: 'you',
        note: note
    });
function $5c498757507ee8ef$export$6a38bc9ff3623d28(ff, opts) {
    const p = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, opts.who);
    const couple = (0, $4156d91797dcfac7$export$411666eeb8222a3e)(ff);
    const partner = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, (0, $4156d91797dcfac7$export$dcc5ce7991925d32)(opts.who));
    const c = (0, $4156d91797dcfac7$export$6c7d5c44eeff8f8a)(ff);
    const health = String((opts.who === 'partner' ? ff?.partner : ff?.client)?.healthStatus || '');
    const rows = [
        c.onBehalf ? $5c498757507ee8ef$var$yes('Who is applying', `${c.name || 'You'}${c.relationship ? ` (${c.relationship})` : ''}, on behalf of ${p.full}`, 'You will be asked to confirm they agree to the assessment.') : $5c498757507ee8ef$var$yes('Who is applying', `${p.full}, for yourself`),
        p.first ? $5c498757507ee8ef$var$yes('Name', p.full) : $5c498757507ee8ef$var$tick('Name'),
        p.dob ? $5c498757507ee8ef$var$yes('Date of birth', (0, $6e8c599c5d82cc63$export$36b357fd0e6c9d2f)(p.dob)) : $5c498757507ee8ef$var$tick('Date of birth'),
        p.sex ? $5c498757507ee8ef$var$yes('Sex', p.sex === 'male' ? 'Male' : 'Female') : $5c498757507ee8ef$var$tick('Sex'),
        p.phone || p.email ? $5c498757507ee8ef$var$yes('Contact details', [
            p.phone,
            p.email
        ].filter(Boolean).join('\n')) : $5c498757507ee8ef$var$tick('Contact details'),
        $5c498757507ee8ef$var$tick('Address', '', 'Where you live now.'),
        $5c498757507ee8ef$var$tick('Medicare card number', '', 'Have the card in front of you.'),
        couple ? $5c498757507ee8ef$var$yes('Who you live with', `With your partner, ${partner.full}`) : $5c498757507ee8ef$var$tick('Who you live with'),
        $5c498757507ee8ef$var$yes('What you are applying for', opts.forHomeCare ? 'Help to keep living at home (Support at Home services)' : 'Residential aged care (and help at home in the meantime, if needed)'),
        health ? $5c498757507ee8ef$var$yes('Your general health', {
            good: 'Good',
            fair: 'Fair',
            poor: 'Poor'
        }[health] || health, "You will be asked about the everyday things you need help with \u2014 keep a short list.") : $5c498757507ee8ef$var$tick('Your general health and what you need help with'),
        $5c498757507ee8ef$var$tick("Your doctor\u2019s name and practice", '', 'The assessor may ask to speak with them.'),
        $5c498757507ee8ef$var$tick('Anyone who helps you now (a carer, family, services)')
    ];
    return {
        code: '',
        title: 'Applying for an aged care needs assessment',
        officialUrl: 'https://www.myagedcare.gov.au/apply-online',
        personName: p.full,
        intro: "Government-funded aged care starts with a free needs assessment through My Aged Care. There is no paper form to fill in \u2014 you apply online or by phone, and an assessor then visits. These are the details you will be asked for, filled in from your profile where we have them.",
        howToLodge: [
            "Online: myagedcare.gov.au/apply-online \u2014 about 15 to 20 minutes.",
            'By phone: My Aged Care on 1800 200 422.',
            "In person: an Aged Care Specialist Officer at some Services Australia centres \u2014 book on 1800 227 475."
        ],
        sections: [
            {
                title: 'The details you will be asked for',
                rows: rows
            }
        ],
        documents: [
            'Your Medicare card',
            'A list of your medicines and health conditions',
            ...c.onBehalf ? [
                "The person\u2019s consent to apply on their behalf (or a power of attorney)"
            ] : []
        ],
        kind: 'checklist',
        generatedAt: opts.generatedAt
    };
}
function $5c498757507ee8ef$export$925a0e97eaddead(ff, opts) {
    const p = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, opts.who);
    const supers = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'superannuation', 'accountBasedPensions').filter((a)=>!a.ownership || a.ownership === opts.who);
    const amount = (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(opts.amount);
    return {
        code: 'NAT 75073',
        title: 'Downsizer contribution into superannuation',
        officialUrl: 'https://www.ato.gov.au/forms-and-instructions/superannuation-downsizer-contribution-form',
        personName: p.full,
        intro: "If your plan puts part of the home sale into super as a downsizer contribution, this ATO form goes to your super fund \u2014 signed \u2014 before or at the same time as the money. Without it the fund treats the money as an ordinary personal contribution, which counts towards your caps. Each person completes their own form, and a separate one for each payment.",
        howToLodge: [
            "Give the signed form to your super fund, not the ATO \u2014 before or with the contribution.",
            'The contribution must be made within 90 days of settlement (the date you received the sale proceeds).',
            'Up to $300,000 each, and no more than the sale proceeds. You can only ever do this once.'
        ],
        sections: [
            {
                title: "Section A \u2014 Your super fund",
                rows: [
                    supers.length ? {
                        question: 'Your superannuation fund name',
                        answer: supers.map((s)=>s.description || 'Super').join(' or '),
                        status: 'check',
                        note: 'The fund the contribution is going into.'
                    } : {
                        question: 'Your superannuation fund name',
                        answer: 'Fill in yourself',
                        status: 'you'
                    },
                    {
                        question: 'Your member number',
                        answer: 'Fill in yourself',
                        status: 'you',
                        note: 'On your super statement.'
                    }
                ]
            },
            {
                title: "Section B \u2014 Your details",
                rows: [
                    {
                        question: 'Tax file number (TFN)',
                        answer: 'Fill in yourself',
                        status: 'you',
                        note: 'The fund cannot accept the contribution without your TFN unless it already holds it.'
                    },
                    {
                        question: 'Full name',
                        answer: p.full,
                        status: p.first ? 'filled' : 'you'
                    },
                    {
                        question: 'Date of birth',
                        answer: (0, $6e8c599c5d82cc63$export$36b357fd0e6c9d2f)(p.dob) || 'Fill in yourself',
                        status: p.dob ? 'filled' : 'you'
                    },
                    {
                        question: 'Postal and street address',
                        answer: 'Fill in yourself',
                        status: 'you',
                        note: 'Make sure the ATO has your current address.'
                    },
                    p.phone || p.email ? {
                        question: 'Contact details',
                        answer: [
                            p.phone,
                            p.email
                        ].filter(Boolean).join('\n'),
                        status: 'filled'
                    } : {
                        question: 'Contact details',
                        answer: 'Fill in yourself',
                        status: 'you'
                    }
                ]
            },
            {
                title: "Section C \u2014 Your downsizer contribution",
                rows: [
                    amount > 0 ? {
                        question: 'Amount of your contribution',
                        answer: (0, $6e8c599c5d82cc63$export$5517df3497010beb)(amount),
                        status: 'check',
                        note: 'From your saved plan. Any amount over $300,000 is not accepted as a downsizer contribution.'
                    } : {
                        question: 'Amount of your contribution',
                        answer: "Up to $300,000 \u2014 fill in the amount your plan uses",
                        status: 'you'
                    }
                ]
            },
            {
                title: "Section D \u2014 Your declaration",
                rows: [
                    {
                        question: 'Sign and date, confirming you meet every eligibility requirement',
                        answer: 'Sign and date',
                        status: 'you',
                        note: 'A downsizer contribution counts as super for the Age Pension assets test, and you cannot claim a tax deduction for it.'
                    }
                ]
            }
        ],
        documents: [
            'The settlement statement for the home sale (the fund may ask for it)'
        ],
        generatedAt: opts.generatedAt
    };
}
function $5c498757507ee8ef$export$6a62f3ce9569e7a5(ff, opts) {
    const p = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, 'client');
    const gf = ff?.grannyFlat || {};
    const brief = gf.familyGuide?.brief || {};
    const cash = (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(gf.amountPaid);
    const property = (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(gf.propertyTransferredValue);
    const build = (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(gf.constructionCost);
    const given = cash + property + build || (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(brief.entryContribution);
    const rows = [
        given > 0 ? {
            question: 'What you are giving for the right to live there for life',
            answer: [
                cash > 0 ? `Cash: ${(0, $6e8c599c5d82cc63$export$5517df3497010beb)(cash)}` : '',
                property > 0 ? `Home or property transferred: ${(0, $6e8c599c5d82cc63$export$5517df3497010beb)(property)}` : '',
                build > 0 ? `Paying for the build: ${(0, $6e8c599c5d82cc63$export$5517df3497010beb)(build)}` : '',
                !cash && !property && !build ? `In total: ${(0, $6e8c599c5d82cc63$export$5517df3497010beb)(given)}` : ''
            ].filter(Boolean).join('\n'),
            status: 'check'
        } : {
            question: 'What you are giving for the right to live there for life',
            answer: 'Fill in once the amount is settled',
            status: 'you'
        },
        gf.dateEntered || brief.dateEntered ? {
            question: 'The date the arrangement starts',
            answer: (0, $6e8c599c5d82cc63$export$36b357fd0e6c9d2f)(gf.dateEntered || brief.dateEntered),
            status: 'check'
        } : {
            question: 'The date the arrangement starts',
            answer: 'Fill in yourself',
            status: 'you'
        },
        gf.familyGuide?.hostNames ? {
            question: 'Who you will live with',
            answer: gf.familyGuide.hostNames,
            status: 'filled'
        } : {
            question: 'Who you will live with',
            answer: 'Fill in yourself',
            status: 'you'
        },
        (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(brief.deprivation) > 0 ? {
            question: 'Amount the tool expects to be treated as a gift',
            answer: (0, $6e8c599c5d82cc63$export$5517df3497010beb)((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(brief.deprivation)),
            status: 'check',
            note: "Services Australia decides; this is the tool\u2019s estimate from your guide."
        } : {
            question: 'Whether any of it is a gift',
            answer: "Services Australia decides \u2014 tell them every amount",
            status: 'you'
        },
        {
            question: 'Whether it is in writing',
            answer: gf.familyGuide?.brief?.generatedAt ? 'A solicitor brief was produced on ' + (0, $6e8c599c5d82cc63$export$36b357fd0e6c9d2f)(gf.familyGuide.brief.generatedAt) : 'Not yet',
            status: 'check',
            note: 'Services Australia may accept an arrangement that is not in writing, but recommends a legal agreement.'
        },
        {
            question: 'What happens to your current home',
            answer: (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(ff?.home?.value) > 0 ? "Say whether you will keep it, sell it or transfer it \u2014 it stops being exempt when you move out" : 'Not applicable',
            status: (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(ff?.home?.value) > 0 ? 'you' : 'filled'
        }
    ];
    return {
        code: '',
        title: 'Telling Services Australia about your granny flat arrangement',
        officialUrl: 'https://www.servicesaustralia.gov.au/granny-flat-interest',
        personName: p.full,
        intro: 'There is no form for a granny flat interest. Services Australia asks you to call before you set one up, so they can explain how it will affect your payment, and then to tell them its value. These are the details to have in front of you, from your profile and the family discussion guide.',
        howToLodge: [
            "Call your regular payment line before you set it up \u2014 for the Age Pension, 132 300.",
            'Then report it within 14 days of it starting, by phone or through your Centrelink online account in myGov.'
        ],
        sections: [
            {
                title: 'What they will ask',
                rows: rows
            }
        ],
        documents: [
            'The written agreement',
            'Evidence of what was paid or transferred (bank statements, the transfer of title, or the building contract and invoices)'
        ],
        kind: 'checklist',
        generatedAt: opts.generatedAt
    };
}
function $5c498757507ee8ef$export$e293fe3471f8411e(ff, opts) {
    const p = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, 'client');
    const entry = (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(opts.entryContribution) || (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(ff?.retirementVillage?.entryContribution);
    return {
        code: '',
        title: 'Telling Services Australia about your move into a retirement village',
        officialUrl: 'https://www.servicesaustralia.gov.au/real-estate-assets?context=22526',
        personName: p.full,
        intro: 'There is no special form: you report the change of address and assets within 14 days, online or by phone. The entry contribution decides whether you are treated as a homeowner for the pension, so have the contract figures ready.',
        howToLodge: [
            "Report through your Centrelink online account in myGov, or call 132 300 \u2014 within 14 days of the move."
        ],
        sections: [
            {
                title: 'What they will ask',
                rows: [
                    entry > 0 ? $5c498757507ee8ef$var$yes('Your entry contribution', (0, $6e8c599c5d82cc63$export$5517df3497010beb)(entry), 'Above the extra allowable amount you are a homeowner and it is exempt; at or below it, it counts as an asset and you may get Rent Assistance.') : $5c498757507ee8ef$var$tick('Your entry contribution', '', 'From the village contract.'),
                    $5c498757507ee8ef$var$tick('Your new address and the date you moved'),
                    $5c498757507ee8ef$var$tick('Your ongoing village fees'),
                    (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(ff?.home?.value) > 0 ? $5c498757507ee8ef$var$tick('What happened to your former home', 'Sold (sale price and settlement date), or kept (and whether it is let)') : $5c498757507ee8ef$var$yes('Your former home', 'Not applicable'),
                    $5c498757507ee8ef$var$tick('What you did with any money left over from the sale', 'Bank balances, investments, super')
                ]
            }
        ],
        documents: [
            'The village contract or disclosure statement showing the entry contribution',
            'The settlement statement if you sold your home'
        ],
        kind: 'checklist',
        generatedAt: opts.generatedAt
    };
}
function $5c498757507ee8ef$export$e6b062ec77e80f40(ff, opts) {
    const p = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, 'client');
    const c = (q, a = '')=>$5c498757507ee8ef$var$tick(q, a);
    return {
        code: '',
        title: "Moving into an aged care home \u2014 checklist",
        officialUrl: 'https://www.myagedcare.gov.au/aged-care-homes',
        personName: p.full,
        intro: "A practical list for the weeks before moving in. Ask the home what they supply and how much room there is before packing \u2014 every room is different.",
        howToLodge: [
            'Ask the home for their own list too, and what they label or supply.'
        ],
        sections: [
            {
                title: 'Papers to bring',
                rows: [
                    c('Medicare card, pension or concession card, DVA card'),
                    c('Private health insurance card', 'If you keep your cover'),
                    c('The signed agreement with the home, and your fee advice letter from Services Australia'),
                    c('A copy of your power of attorney and advance care directive', 'Leave the original Will with your solicitor'),
                    c('Names and numbers of your GP, specialists, pharmacy and next of kin')
                ]
            },
            {
                title: 'Health',
                rows: [
                    c("A current list of medicines, and a few days\u2019 supply", 'The home will usually arrange packing with a pharmacy'),
                    c('Allergies and recent letters from specialists'),
                    c("Glasses, hearing aids (and batteries), dentures \u2014 labelled"),
                    c("Walking frame, wheelchair or other aids \u2014 labelled")
                ]
            },
            {
                title: 'Clothes and personal things',
                rows: [
                    c('About a week to ten days of comfortable clothes, labelled', 'Ask the home how they label laundry'),
                    c('Non-slip shoes and slippers'),
                    c('Toiletries'),
                    c('Photos, a favourite chair or quilt, small keepsakes', 'Check sizes and electrical safety rules first'),
                    c('A small amount of money', 'Leave valuables and jewellery with family')
                ]
            },
            {
                title: 'Paperwork after the move',
                rows: [
                    c('Redirect your mail'),
                    c('Tell your bank, insurers and utilities about the move'),
                    c('Decide what happens to your home', "For the pension it is usually exempt for two years after you move \u2014 or longer while a partner lives there"),
                    c('Check that your means assessment has been lodged', 'Without it the home can charge the maximum fees')
                ]
            }
        ],
        documents: [],
        kind: 'checklist',
        generatedAt: opts.generatedAt
    };
}
function $5c498757507ee8ef$export$f202907573a49b9b(ff, opts) {
    const p = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, 'client');
    const c = (q, a = '')=>$5c498757507ee8ef$var$tick(q, a);
    return {
        code: '',
        title: "Retirement village contract \u2014 questions to have answered",
        officialUrl: '',
        personName: p.full,
        intro: "Every village contract is different, and the differences decide what you pay and what comes back. Get these answered in writing from the village\u2019s disclosure documents, and take the contract to a solicitor before you sign.",
        howToLodge: [
            "Ask each village for its disclosure statement and the full contract \u2014 compare contracts, not brochures."
        ],
        sections: [
            {
                title: 'Going in',
                rows: [
                    c('The entry contribution (ingoing)', 'What you pay to move in'),
                    c('Any other upfront costs', 'Legal fees, stamp duty, refurbishment')
                ]
            },
            {
                title: 'While you live there',
                rows: [
                    c('The ongoing (recurrent) fees', 'How much, what they cover, and how they are increased'),
                    c('Who pays for maintenance and replacing fixtures'),
                    c('What care or support services are available, and their cost')
                ]
            },
            {
                title: 'When you leave',
                rows: [
                    c('The departure fee (deferred management fee)', 'The percentage per year and the maximum'),
                    c('Your share of any capital gain, or of any loss'),
                    c('Refurbishment or reinstatement costs charged on exit'),
                    c('How long until your exit entitlement is paid', 'And whether fees stop when you leave'),
                    c('What happens if you need to move into residential care')
                ]
            },
            {
                title: 'Before you sign',
                rows: [
                    c('The cooling-off period'),
                    c('Independent legal advice on the contract'),
                    c("Re-run the village module on the contract\u2019s real figures")
                ]
            }
        ],
        documents: [],
        kind: 'checklist',
        generatedAt: opts.generatedAt
    };
}
function $5c498757507ee8ef$export$6723dea4880a8d68(ff, opts) {
    const p = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, 'client');
    const c = (q, a = '')=>$5c498757507ee8ef$var$tick(q, a);
    return {
        code: '',
        title: "Selling and moving \u2014 checklist",
        officialUrl: '',
        personName: p.full,
        intro: 'The practical steps between deciding and settling in, so nothing that affects your money is missed.',
        howToLodge: [],
        sections: [
            ...opts.selling ? [
                {
                    title: 'The sale',
                    rows: [
                        c('Two or three agent appraisals', 'Then re-run the model on the real figure'),
                        c('A conveyancer or solicitor for the sale contract'),
                        c('Plan where the proceeds go before settlement', 'Money left in the bank is counted for the pension')
                    ]
                }
            ] : [],
            {
                title: 'Telling people',
                rows: [
                    c("Services Australia \u2014 within 14 days of the move and of settlement", 'Your Centrelink online account in myGov, or 132 300'),
                    c('Your bank, super fund, insurers and the ATO'),
                    c('Redirect your mail, and update your electoral enrolment'),
                    c("Utilities, internet and phone \u2014 disconnect and connect")
                ]
            },
            {
                title: 'The move',
                rows: [
                    c('Removalist quotes'),
                    c('Decide what comes, what goes to family, and what is sold or donated'),
                    c('Update your Will and powers of attorney if your circumstances have changed')
                ]
            }
        ],
        documents: [],
        kind: 'checklist',
        generatedAt: opts.generatedAt
    };
}



/**
 * The official forms the Action Plan fills in — SA485, SA457, SA456 and the ATO's NAT 75073 — and the
 * answers it writes on each (owner, 3 Oct 2026: "all the official forms").
 *
 * Each form is the government's own PDF (src/assets/forms, mapped by tools/forms/map_official_form.py)
 * plus a function that turns the profile into values for its mapped boxes. Only what the profile
 * knows is written — names, dates of birth, the home and its loan, who owns it, who lives there —
 * and nothing is guessed: no reference numbers, addresses, legal descriptions or signatures.
 */ /**
 * Writing the client's answers onto the OFFICIAL form (owner, 3 Oct 2026: "I want the official form
 * to be pre-populated", not a sheet to copy from).
 *
 * The government forms are print-and-fill PDFs: no fields, only drawn boxes. tools/forms/
 * map_official_form.py finds every box from its question number and label and saves the form, plus
 * a JSON map of its boxes, under src/assets/forms. Here the answers are written into those boxes —
 * a cross in a tick box, text in a field, DD / MM / YYYY in a date — and the client gets the real
 * form back, ready to check, complete and sign.
 *
 * What is written is only what the profile knows. Anything it does not (a reference number, an
 * address, a legal description) is left for the client, and the form's own declaration is never
 * touched. Services Australia publishes the forms under Creative Commons Attribution 4.0.
 */ var $00483d97acd1a213$exports = {};
$parcel$export($00483d97acd1a213$exports, "PDFButton", () => $b3771f5aa96680ee$export$2e2bcd8739ae039);
$parcel$export($00483d97acd1a213$exports, "PDFDocument", () => $93b2571d4e1dfe94$export$2e2bcd8739ae039);
$parcel$export($00483d97acd1a213$exports, "PDFTextField", () => $f989cc5b81a68a40$export$2e2bcd8739ae039);
$parcel$export($00483d97acd1a213$exports, "rgb", () => $030fa0a2c4d1456e$export$8972dc0e6ad9238f);
$parcel$export($00483d97acd1a213$exports, "StandardFonts", () => $d275b823cf3c6e5b$export$7dcb046109e65a3d);
$parcel$export($00483d97acd1a213$exports, "PDFName", () => (parcelRequire("dPHSK")).default);
$parcel$export($00483d97acd1a213$exports, "PDFNumber", () => (parcelRequire("j04jt")).default);

var $cOQTW = parcelRequire("cOQTW");

var $cOQTW = parcelRequire("cOQTW");
parcelRequire("nAWRe");

var $8zvel = parcelRequire("8zvel");

var $cOQTW = parcelRequire("cOQTW");

var $ckCqy = parcelRequire("ckCqy");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ab35d5c6c69177c9$var$PDFHeader = /** @class */ function() {
    function PDFHeader(major, minor) {
        this.major = String(major);
        this.minor = String(minor);
    }
    PDFHeader.prototype.toString = function() {
        var bc = (0, $7Kmy8.charFromCode)(129);
        return "%PDF-" + this.major + "." + this.minor + "\n%" + bc + bc + bc + bc;
    };
    PDFHeader.prototype.sizeInBytes = function() {
        return 12 + this.major.length + this.minor.length;
    };
    PDFHeader.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).Percent;
        buffer[offset++] = (0, $8zvel.default).P;
        buffer[offset++] = (0, $8zvel.default).D;
        buffer[offset++] = (0, $8zvel.default).F;
        buffer[offset++] = (0, $8zvel.default).Dash;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.major, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).Period;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.minor, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).Newline;
        buffer[offset++] = (0, $8zvel.default).Percent;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        return offset - initialOffset;
    };
    PDFHeader.forVersion = function(major, minor) {
        return new PDFHeader(major, minor);
    };
    return PDFHeader;
}();
var $ab35d5c6c69177c9$export$2e2bcd8739ae039 = $ab35d5c6c69177c9$var$PDFHeader;



var $nAWRe = parcelRequire("nAWRe");

var $8auL6 = parcelRequire("8auL6");

var $8gQNC = parcelRequire("8gQNC");

var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");

var $cOQTW = parcelRequire("cOQTW");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
var $ad8a981877dc5d20$var$PDFNull = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFNull, _super);
    function PDFNull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFNull.prototype.asNull = function() {
        return null;
    };
    PDFNull.prototype.clone = function() {
        return this;
    };
    PDFNull.prototype.toString = function() {
        return 'null';
    };
    PDFNull.prototype.sizeInBytes = function() {
        return 4;
    };
    PDFNull.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $8zvel.default).n;
        buffer[offset++] = (0, $8zvel.default).u;
        buffer[offset++] = (0, $8zvel.default).l;
        buffer[offset++] = (0, $8zvel.default).l;
        return 4;
    };
    return PDFNull;
}((0, $11c5J.default));
var $ad8a981877dc5d20$export$2e2bcd8739ae039 = new $ad8a981877dc5d20$var$PDFNull();



var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
var $85408478fbb7cbde$var$PDFDict = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFDict, _super);
    function PDFDict(map, context) {
        var _this = _super.call(this) || this;
        _this.dict = map;
        _this.context = context;
        return _this;
    }
    PDFDict.prototype.keys = function() {
        return Array.from(this.dict.keys());
    };
    PDFDict.prototype.values = function() {
        return Array.from(this.dict.values());
    };
    PDFDict.prototype.entries = function() {
        return Array.from(this.dict.entries());
    };
    PDFDict.prototype.set = function(key, value) {
        this.dict.set(key, value);
    };
    PDFDict.prototype.get = function(key, // TODO: `preservePDFNull` is for backwards compatibility. Should be
    // removed in next breaking API change.
    preservePDFNull) {
        if (preservePDFNull === void 0) preservePDFNull = false;
        var value = this.dict.get(key);
        if (value === (0, $ad8a981877dc5d20$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.has = function(key) {
        var value = this.dict.get(key);
        return value !== undefined && value !== (0, $ad8a981877dc5d20$export$2e2bcd8739ae039);
    };
    PDFDict.prototype.lookupMaybe = function(key) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $ad8a981877dc5d20$export$2e2bcd8739ae039));
        var value = (_a = this.context).lookupMaybe.apply(_a, (0, $cOQTW.__spreadArrays)([
            this.get(key, preservePDFNull)
        ], types));
        if (value === (0, $ad8a981877dc5d20$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.lookup = function(key) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $ad8a981877dc5d20$export$2e2bcd8739ae039));
        var value = (_a = this.context).lookup.apply(_a, (0, $cOQTW.__spreadArrays)([
            this.get(key, preservePDFNull)
        ], types));
        if (value === (0, $ad8a981877dc5d20$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.delete = function(key) {
        return this.dict.delete(key);
    };
    PDFDict.prototype.asMap = function() {
        return new Map(this.dict);
    };
    /** Generate a random key that doesn't exist in current key set */ PDFDict.prototype.uniqueKey = function(tag) {
        if (tag === void 0) tag = '';
        var existingKeys = this.keys();
        var key = (0, $dPHSK.default).of(this.context.addRandomSuffix(tag, 10));
        while(existingKeys.includes(key))key = (0, $dPHSK.default).of(this.context.addRandomSuffix(tag, 10));
        return key;
    };
    PDFDict.prototype.clone = function(context) {
        var clone = PDFDict.withContext(context || this.context);
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            clone.set(key, value);
        }
        return clone;
    };
    PDFDict.prototype.toString = function() {
        var dictString = '<<\n';
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            dictString += key.toString() + ' ' + value.toString() + '\n';
        }
        dictString += '>>';
        return dictString;
    };
    PDFDict.prototype.sizeInBytes = function() {
        var size = 5;
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            size += key.sizeInBytes() + value.sizeInBytes() + 2;
        }
        return size;
    };
    PDFDict.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).LessThan;
        buffer[offset++] = (0, $8zvel.default).LessThan;
        buffer[offset++] = (0, $8zvel.default).Newline;
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            offset += key.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
            offset += value.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Newline;
        }
        buffer[offset++] = (0, $8zvel.default).GreaterThan;
        buffer[offset++] = (0, $8zvel.default).GreaterThan;
        return offset - initialOffset;
    };
    PDFDict.withContext = function(context) {
        return new PDFDict(new Map(), context);
    };
    PDFDict.fromMapWithContext = function(map, context) {
        return new PDFDict(map, context);
    };
    return PDFDict;
}((0, $11c5J.default));
var $85408478fbb7cbde$export$2e2bcd8739ae039 = $85408478fbb7cbde$var$PDFDict;



var $dPHSK = parcelRequire("dPHSK");


var $j04jt = parcelRequire("j04jt");

var $11c5J = parcelRequire("11c5J");

var $cOQTW = parcelRequire("cOQTW");

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
var $35c7d4c8e4f2bcc7$var$PDFStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFStream, _super);
    function PDFStream(dict) {
        var _this = _super.call(this) || this;
        _this.dict = dict;
        return _this;
    }
    PDFStream.prototype.clone = function(_context) {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'clone');
    };
    PDFStream.prototype.getContentsString = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'getContentsString');
    };
    PDFStream.prototype.getContents = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'getContents');
    };
    PDFStream.prototype.getContentsSize = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'getContentsSize');
    };
    PDFStream.prototype.updateDict = function() {
        var contentsSize = this.getContentsSize();
        this.dict.set((0, $dPHSK.default).Length, (0, $j04jt.default).of(contentsSize));
    };
    PDFStream.prototype.sizeInBytes = function() {
        this.updateDict();
        return this.dict.sizeInBytes() + this.getContentsSize() + 18;
    };
    PDFStream.prototype.toString = function() {
        this.updateDict();
        var streamString = this.dict.toString();
        streamString += '\nstream\n';
        streamString += this.getContentsString();
        streamString += '\nendstream';
        return streamString;
    };
    PDFStream.prototype.copyBytesInto = function(buffer, offset) {
        this.updateDict();
        var initialOffset = offset;
        offset += this.dict.copyBytesInto(buffer, offset);
        buffer[offset++] = (0, $8zvel.default).Newline;
        buffer[offset++] = (0, $8zvel.default).s;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).a;
        buffer[offset++] = (0, $8zvel.default).m;
        buffer[offset++] = (0, $8zvel.default).Newline;
        var contents = this.getContents();
        for(var idx = 0, len = contents.length; idx < len; idx++)buffer[offset++] = contents[idx];
        buffer[offset++] = (0, $8zvel.default).Newline;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).n;
        buffer[offset++] = (0, $8zvel.default).d;
        buffer[offset++] = (0, $8zvel.default).s;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).a;
        buffer[offset++] = (0, $8zvel.default).m;
        return offset - initialOffset;
    };
    return PDFStream;
}((0, $11c5J.default));
var $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039 = $35c7d4c8e4f2bcc7$var$PDFStream;


parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $ef28c75b0f11042e$var$PDFRawStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFRawStream, _super);
    function PDFRawStream(dict, contents) {
        var _this = _super.call(this, dict) || this;
        _this.contents = contents;
        return _this;
    }
    PDFRawStream.prototype.asUint8Array = function() {
        return this.contents.slice();
    };
    PDFRawStream.prototype.clone = function(context) {
        return PDFRawStream.of(this.dict.clone(context), this.contents.slice());
    };
    PDFRawStream.prototype.getContentsString = function() {
        return (0, $4ISq8.arrayAsString)(this.contents);
    };
    PDFRawStream.prototype.getContents = function() {
        return this.contents;
    };
    PDFRawStream.prototype.getContentsSize = function() {
        return this.contents.length;
    };
    PDFRawStream.of = function(dict, contents) {
        return new PDFRawStream(dict, contents);
    };
    return PDFRawStream;
}((0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039));
var $ef28c75b0f11042e$export$2e2bcd8739ae039 = $ef28c75b0f11042e$var$PDFRawStream;



var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $11c5J = parcelRequire("11c5J");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $f1233b848bc26abe$var$ENFORCER = {};
var $f1233b848bc26abe$var$pool = new Map();
var $f1233b848bc26abe$var$PDFRef = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFRef, _super);
    function PDFRef(enforcer, objectNumber, generationNumber) {
        var _this = this;
        if (enforcer !== $f1233b848bc26abe$var$ENFORCER) throw new (0, $nAWRe.PrivateConstructorError)('PDFRef');
        _this = _super.call(this) || this;
        _this.objectNumber = objectNumber;
        _this.generationNumber = generationNumber;
        _this.tag = objectNumber + " " + generationNumber + " R";
        return _this;
    }
    PDFRef.prototype.clone = function() {
        return this;
    };
    PDFRef.prototype.toString = function() {
        return this.tag;
    };
    PDFRef.prototype.sizeInBytes = function() {
        return this.tag.length;
    };
    PDFRef.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.tag, buffer, offset);
        return this.tag.length;
    };
    PDFRef.of = function(objectNumber, generationNumber) {
        if (generationNumber === void 0) generationNumber = 0;
        var tag = objectNumber + " " + generationNumber + " R";
        var instance = $f1233b848bc26abe$var$pool.get(tag);
        if (!instance) {
            instance = new PDFRef($f1233b848bc26abe$var$ENFORCER, objectNumber, generationNumber);
            $f1233b848bc26abe$var$pool.set(tag, instance);
        }
        return instance;
    };
    return PDFRef;
}((0, $11c5J.default));
var $f1233b848bc26abe$export$2e2bcd8739ae039 = $f1233b848bc26abe$var$PDFRef;



var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $400c0bd11400a1c4$var$PDFOperator = /** @class */ function() {
    function PDFOperator(name, args) {
        this.name = name;
        this.args = args || [];
    }
    PDFOperator.prototype.clone = function(context) {
        var args = new Array(this.args.length);
        for(var idx = 0, len = args.length; idx < len; idx++){
            var arg = this.args[idx];
            args[idx] = arg instanceof (0, $11c5J.default) ? arg.clone(context) : arg;
        }
        return PDFOperator.of(this.name, args);
    };
    PDFOperator.prototype.toString = function() {
        var value = '';
        for(var idx = 0, len = this.args.length; idx < len; idx++)value += String(this.args[idx]) + ' ';
        value += this.name;
        return value;
    };
    PDFOperator.prototype.sizeInBytes = function() {
        var size = 0;
        for(var idx = 0, len = this.args.length; idx < len; idx++){
            var arg = this.args[idx];
            size += (arg instanceof (0, $11c5J.default) ? arg.sizeInBytes() : arg.length) + 1;
        }
        size += this.name.length;
        return size;
    };
    PDFOperator.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        for(var idx = 0, len = this.args.length; idx < len; idx++){
            var arg = this.args[idx];
            if (arg instanceof (0, $11c5J.default)) offset += arg.copyBytesInto(buffer, offset);
            else offset += (0, $7Kmy8.copyStringIntoBuffer)(arg, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
        }
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.name, buffer, offset);
        return offset - initialOffset;
    };
    PDFOperator.of = function(name, args) {
        return new PDFOperator(name, args);
    };
    return PDFOperator;
}();
var $400c0bd11400a1c4$export$2e2bcd8739ae039 = $400c0bd11400a1c4$var$PDFOperator;


var $27958cc2c5d88a31$var$PDFOperatorNames;
(function(PDFOperatorNames) {
    // Non Stroking Color Operators
    PDFOperatorNames["NonStrokingColor"] = "sc";
    PDFOperatorNames["NonStrokingColorN"] = "scn";
    PDFOperatorNames["NonStrokingColorRgb"] = "rg";
    PDFOperatorNames["NonStrokingColorGray"] = "g";
    PDFOperatorNames["NonStrokingColorCmyk"] = "k";
    PDFOperatorNames["NonStrokingColorspace"] = "cs";
    // Stroking Color Operators
    PDFOperatorNames["StrokingColor"] = "SC";
    PDFOperatorNames["StrokingColorN"] = "SCN";
    PDFOperatorNames["StrokingColorRgb"] = "RG";
    PDFOperatorNames["StrokingColorGray"] = "G";
    PDFOperatorNames["StrokingColorCmyk"] = "K";
    PDFOperatorNames["StrokingColorspace"] = "CS";
    // Marked Content Operators
    PDFOperatorNames["BeginMarkedContentSequence"] = "BDC";
    PDFOperatorNames["BeginMarkedContent"] = "BMC";
    PDFOperatorNames["EndMarkedContent"] = "EMC";
    PDFOperatorNames["MarkedContentPointWithProps"] = "DP";
    PDFOperatorNames["MarkedContentPoint"] = "MP";
    PDFOperatorNames["DrawObject"] = "Do";
    // Graphics State Operators
    PDFOperatorNames["ConcatTransformationMatrix"] = "cm";
    PDFOperatorNames["PopGraphicsState"] = "Q";
    PDFOperatorNames["PushGraphicsState"] = "q";
    PDFOperatorNames["SetFlatness"] = "i";
    PDFOperatorNames["SetGraphicsStateParams"] = "gs";
    PDFOperatorNames["SetLineCapStyle"] = "J";
    PDFOperatorNames["SetLineDashPattern"] = "d";
    PDFOperatorNames["SetLineJoinStyle"] = "j";
    PDFOperatorNames["SetLineMiterLimit"] = "M";
    PDFOperatorNames["SetLineWidth"] = "w";
    PDFOperatorNames["SetTextMatrix"] = "Tm";
    PDFOperatorNames["SetRenderingIntent"] = "ri";
    // Graphics Operators
    PDFOperatorNames["AppendRectangle"] = "re";
    PDFOperatorNames["BeginInlineImage"] = "BI";
    PDFOperatorNames["BeginInlineImageData"] = "ID";
    PDFOperatorNames["EndInlineImage"] = "EI";
    PDFOperatorNames["ClipEvenOdd"] = "W*";
    PDFOperatorNames["ClipNonZero"] = "W";
    PDFOperatorNames["CloseAndStroke"] = "s";
    PDFOperatorNames["CloseFillEvenOddAndStroke"] = "b*";
    PDFOperatorNames["CloseFillNonZeroAndStroke"] = "b";
    PDFOperatorNames["ClosePath"] = "h";
    PDFOperatorNames["AppendBezierCurve"] = "c";
    PDFOperatorNames["CurveToReplicateFinalPoint"] = "y";
    PDFOperatorNames["CurveToReplicateInitialPoint"] = "v";
    PDFOperatorNames["EndPath"] = "n";
    PDFOperatorNames["FillEvenOddAndStroke"] = "B*";
    PDFOperatorNames["FillEvenOdd"] = "f*";
    PDFOperatorNames["FillNonZeroAndStroke"] = "B";
    PDFOperatorNames["FillNonZero"] = "f";
    PDFOperatorNames["LegacyFillNonZero"] = "F";
    PDFOperatorNames["LineTo"] = "l";
    PDFOperatorNames["MoveTo"] = "m";
    PDFOperatorNames["ShadingFill"] = "sh";
    PDFOperatorNames["StrokePath"] = "S";
    // Text Operators
    PDFOperatorNames["BeginText"] = "BT";
    PDFOperatorNames["EndText"] = "ET";
    PDFOperatorNames["MoveText"] = "Td";
    PDFOperatorNames["MoveTextSetLeading"] = "TD";
    PDFOperatorNames["NextLine"] = "T*";
    PDFOperatorNames["SetCharacterSpacing"] = "Tc";
    PDFOperatorNames["SetFontAndSize"] = "Tf";
    PDFOperatorNames["SetTextHorizontalScaling"] = "Tz";
    PDFOperatorNames["SetTextLineHeight"] = "TL";
    PDFOperatorNames["SetTextRenderingMode"] = "Tr";
    PDFOperatorNames["SetTextRise"] = "Ts";
    PDFOperatorNames["SetWordSpacing"] = "Tw";
    PDFOperatorNames["ShowText"] = "Tj";
    PDFOperatorNames["ShowTextAdjusted"] = "TJ";
    PDFOperatorNames["ShowTextLine"] = "'";
    PDFOperatorNames["ShowTextLineAndSpace"] = "\"";
    // Type3 Font Operators
    PDFOperatorNames["Type3D0"] = "d0";
    PDFOperatorNames["Type3D1"] = "d1";
    // Compatibility Section Operators
    PDFOperatorNames["BeginCompatibilitySection"] = "BX";
    PDFOperatorNames["EndCompatibilitySection"] = "EX";
})($27958cc2c5d88a31$var$PDFOperatorNames || ($27958cc2c5d88a31$var$PDFOperatorNames = {}));
var $27958cc2c5d88a31$export$2e2bcd8739ae039 = $27958cc2c5d88a31$var$PDFOperatorNames;



var $cOQTW = parcelRequire("cOQTW");

var $cOQTW = parcelRequire("cOQTW");

var $ckCqy = parcelRequire("ckCqy");

var $nAWRe = parcelRequire("nAWRe");

var $dPHSK = parcelRequire("dPHSK");

parcelRequire("fvYKZ");
var $clYSv = parcelRequire("clYSv");
var $2d4cf9103ab67d11$var$PDFFlateStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFFlateStream, _super);
    function PDFFlateStream(dict, encode) {
        var _this = _super.call(this, dict) || this;
        _this.computeContents = function() {
            var unencodedContents = _this.getUnencodedContents();
            return _this.encode ? (0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).deflate(unencodedContents) : unencodedContents;
        };
        _this.encode = encode;
        if (encode) dict.set((0, $dPHSK.default).of('Filter'), (0, $dPHSK.default).of('FlateDecode'));
        _this.contentsCache = (0, $clYSv.default).populatedBy(_this.computeContents);
        return _this;
    }
    PDFFlateStream.prototype.getContents = function() {
        return this.contentsCache.access();
    };
    PDFFlateStream.prototype.getContentsSize = function() {
        return this.contentsCache.access().length;
    };
    PDFFlateStream.prototype.getUnencodedContents = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'getUnencodedContents');
    };
    return PDFFlateStream;
}((0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039));
var $2d4cf9103ab67d11$export$2e2bcd8739ae039 = $2d4cf9103ab67d11$var$PDFFlateStream;



var $8zvel = parcelRequire("8zvel");
var $707f21d02e4e1bf4$var$PDFContentStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFContentStream, _super);
    function PDFContentStream(dict, operators, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, dict, encode) || this;
        _this.operators = operators;
        return _this;
    }
    PDFContentStream.prototype.push = function() {
        var _a;
        var operators = [];
        for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
        (_a = this.operators).push.apply(_a, operators);
    };
    PDFContentStream.prototype.clone = function(context) {
        var operators = new Array(this.operators.length);
        for(var idx = 0, len = this.operators.length; idx < len; idx++)operators[idx] = this.operators[idx].clone(context);
        var _a = this, dict = _a.dict, encode = _a.encode;
        return PDFContentStream.of(dict.clone(context), operators, encode);
    };
    PDFContentStream.prototype.getContentsString = function() {
        var value = '';
        for(var idx = 0, len = this.operators.length; idx < len; idx++)value += this.operators[idx] + "\n";
        return value;
    };
    PDFContentStream.prototype.getUnencodedContents = function() {
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = 0;
        for(var idx = 0, len = this.operators.length; idx < len; idx++){
            offset += this.operators[idx].copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Newline;
        }
        return buffer;
    };
    PDFContentStream.prototype.getUnencodedContentsSize = function() {
        var size = 0;
        for(var idx = 0, len = this.operators.length; idx < len; idx++)size += this.operators[idx].sizeInBytes() + 1;
        return size;
    };
    PDFContentStream.of = function(dict, operators, encode) {
        if (encode === void 0) encode = true;
        return new PDFContentStream(dict, operators, encode);
    };
    return PDFContentStream;
}((0, $2d4cf9103ab67d11$export$2e2bcd8739ae039));
var $707f21d02e4e1bf4$export$2e2bcd8739ae039 = $707f21d02e4e1bf4$var$PDFContentStream;


parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
/**
 * Generates a pseudo random number. Although it is not cryptographically secure
 * and uniformly distributed, it is not a concern for the intended use-case,
 * which is to generate distinct numbers.
 *
 * Credit: https://stackoverflow.com/a/19303725/10254049
 */ var $440fb620dea1b860$export$205b650d120b95b5 = /** @class */ function() {
    function SimpleRNG(seed) {
        this.seed = seed;
    }
    SimpleRNG.prototype.nextInt = function() {
        var x = Math.sin(this.seed++) * 10000;
        return x - Math.floor(x);
    };
    SimpleRNG.withSeed = function(seed) {
        return new SimpleRNG(seed);
    };
    return SimpleRNG;
}();


var $ece91e5f61c516eb$var$byAscendingObjectNumber = function(_a, _b) {
    var a = _a[0];
    var b = _b[0];
    return a.objectNumber - b.objectNumber;
};
var $ece91e5f61c516eb$var$PDFContext = /** @class */ function() {
    function PDFContext() {
        this.largestObjectNumber = 0;
        this.header = (0, $ab35d5c6c69177c9$export$2e2bcd8739ae039).forVersion(1, 7);
        this.trailerInfo = {};
        this.indirectObjects = new Map();
        this.rng = (0, $440fb620dea1b860$export$205b650d120b95b5).withSeed(1);
    }
    PDFContext.prototype.assign = function(ref, object) {
        this.indirectObjects.set(ref, object);
        if (ref.objectNumber > this.largestObjectNumber) this.largestObjectNumber = ref.objectNumber;
    };
    PDFContext.prototype.nextRef = function() {
        this.largestObjectNumber += 1;
        return (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(this.largestObjectNumber);
    };
    PDFContext.prototype.register = function(object) {
        var ref = this.nextRef();
        this.assign(ref, object);
        return ref;
    };
    PDFContext.prototype.delete = function(ref) {
        return this.indirectObjects.delete(ref);
    };
    PDFContext.prototype.lookupMaybe = function(ref) {
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $ad8a981877dc5d20$export$2e2bcd8739ae039));
        var result = ref instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039) ? this.indirectObjects.get(ref) : ref;
        if (!result || result === (0, $ad8a981877dc5d20$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        for(var idx = 0, len = types.length; idx < len; idx++){
            var type = types[idx];
            if (type === (0, $ad8a981877dc5d20$export$2e2bcd8739ae039)) {
                if (result === (0, $ad8a981877dc5d20$export$2e2bcd8739ae039)) return result;
            } else {
                if (result instanceof type) return result;
            }
        }
        throw new (0, $nAWRe.UnexpectedObjectTypeError)(types, result);
    };
    PDFContext.prototype.lookup = function(ref) {
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        var result = ref instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039) ? this.indirectObjects.get(ref) : ref;
        if (types.length === 0) return result;
        for(var idx = 0, len = types.length; idx < len; idx++){
            var type = types[idx];
            if (type === (0, $ad8a981877dc5d20$export$2e2bcd8739ae039)) {
                if (result === (0, $ad8a981877dc5d20$export$2e2bcd8739ae039)) return result;
            } else {
                if (result instanceof type) return result;
            }
        }
        throw new (0, $nAWRe.UnexpectedObjectTypeError)(types, result);
    };
    PDFContext.prototype.getObjectRef = function(pdfObject) {
        var entries = Array.from(this.indirectObjects.entries());
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], ref = _a[0], object = _a[1];
            if (object === pdfObject) return ref;
        }
        return undefined;
    };
    PDFContext.prototype.enumerateIndirectObjects = function() {
        return Array.from(this.indirectObjects.entries()).sort($ece91e5f61c516eb$var$byAscendingObjectNumber);
    };
    PDFContext.prototype.obj = function(literal) {
        if (literal instanceof (0, $11c5J.default)) return literal;
        else if (literal === null || literal === undefined) return 0, $ad8a981877dc5d20$export$2e2bcd8739ae039;
        else if (typeof literal === 'string') return (0, $dPHSK.default).of(literal);
        else if (typeof literal === 'number') return (0, $j04jt.default).of(literal);
        else if (typeof literal === 'boolean') return literal ? (0, $8gQNC.default).True : (0, $8gQNC.default).False;
        else if (Array.isArray(literal)) {
            var array = (0, $8auL6.default).withContext(this);
            for(var idx = 0, len = literal.length; idx < len; idx++)array.push(this.obj(literal[idx]));
            return array;
        } else {
            var dict = (0, $85408478fbb7cbde$export$2e2bcd8739ae039).withContext(this);
            var keys = Object.keys(literal);
            for(var idx = 0, len = keys.length; idx < len; idx++){
                var key = keys[idx];
                var value = literal[key];
                if (value !== undefined) dict.set((0, $dPHSK.default).of(key), this.obj(value));
            }
            return dict;
        }
    };
    PDFContext.prototype.stream = function(contents, dict) {
        if (dict === void 0) dict = {};
        return (0, $ef28c75b0f11042e$export$2e2bcd8739ae039).of(this.obj(dict), (0, $4ISq8.typedArrayFor)(contents));
    };
    PDFContext.prototype.flateStream = function(contents, dict) {
        if (dict === void 0) dict = {};
        return this.stream((0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).deflate((0, $4ISq8.typedArrayFor)(contents)), (0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, dict), {
            Filter: 'FlateDecode'
        }));
    };
    PDFContext.prototype.contentStream = function(operators, dict) {
        if (dict === void 0) dict = {};
        return (0, $707f21d02e4e1bf4$export$2e2bcd8739ae039).of(this.obj(dict), operators);
    };
    PDFContext.prototype.formXObject = function(operators, dict) {
        if (dict === void 0) dict = {};
        return this.contentStream(operators, (0, $cOQTW.__assign)((0, $cOQTW.__assign)({
            BBox: this.obj([
                0,
                0,
                0,
                0
            ]),
            Matrix: this.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        }, dict), {
            Type: 'XObject',
            Subtype: 'Form'
        }));
    };
    /*
     * Reference to PDFContentStream that contains a single PDFOperator: `q`.
     * Used by [[PDFPageLeaf]] instances to ensure that when content streams are
     * added to a modified PDF, they start in the default, unchanged graphics
     * state.
     */ PDFContext.prototype.getPushGraphicsStateContentStream = function() {
        if (this.pushGraphicsStateContentStreamRef) return this.pushGraphicsStateContentStreamRef;
        var dict = this.obj({});
        var op = (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).PushGraphicsState);
        var stream = (0, $707f21d02e4e1bf4$export$2e2bcd8739ae039).of(dict, [
            op
        ]);
        this.pushGraphicsStateContentStreamRef = this.register(stream);
        return this.pushGraphicsStateContentStreamRef;
    };
    /*
     * Reference to PDFContentStream that contains a single PDFOperator: `Q`.
     * Used by [[PDFPageLeaf]] instances to ensure that when content streams are
     * added to a modified PDF, they start in the default, unchanged graphics
     * state.
     */ PDFContext.prototype.getPopGraphicsStateContentStream = function() {
        if (this.popGraphicsStateContentStreamRef) return this.popGraphicsStateContentStreamRef;
        var dict = this.obj({});
        var op = (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).PopGraphicsState);
        var stream = (0, $707f21d02e4e1bf4$export$2e2bcd8739ae039).of(dict, [
            op
        ]);
        this.popGraphicsStateContentStreamRef = this.register(stream);
        return this.popGraphicsStateContentStreamRef;
    };
    PDFContext.prototype.addRandomSuffix = function(prefix, suffixLength) {
        if (suffixLength === void 0) suffixLength = 4;
        return prefix + "-" + Math.floor(this.rng.nextInt() * Math.pow(10, suffixLength));
    };
    PDFContext.create = function() {
        return new PDFContext();
    };
    return PDFContext;
}();
var $ece91e5f61c516eb$export$2e2bcd8739ae039 = $ece91e5f61c516eb$var$PDFContext;



var $8auL6 = parcelRequire("8auL6");


var $dPHSK = parcelRequire("dPHSK");



var $cOQTW = parcelRequire("cOQTW");

var $8auL6 = parcelRequire("8auL6");


var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $a9e73b7ced5abfa4$var$PDFPageLeaf = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFPageLeaf, _super);
    function PDFPageLeaf(map, context, autoNormalizeCTM) {
        if (autoNormalizeCTM === void 0) autoNormalizeCTM = true;
        var _this = _super.call(this, map, context) || this;
        _this.normalized = false;
        _this.autoNormalizeCTM = autoNormalizeCTM;
        return _this;
    }
    PDFPageLeaf.prototype.clone = function(context) {
        var clone = PDFPageLeaf.fromMapWithContext(new Map(), context || this.context, this.autoNormalizeCTM);
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            clone.set(key, value);
        }
        return clone;
    };
    PDFPageLeaf.prototype.Parent = function() {
        return this.lookupMaybe((0, $dPHSK.default).Parent, (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
    };
    PDFPageLeaf.prototype.Contents = function() {
        return this.lookup((0, $dPHSK.default).of('Contents'));
    };
    PDFPageLeaf.prototype.Annots = function() {
        return this.lookupMaybe((0, $dPHSK.default).Annots, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.BleedBox = function() {
        return this.lookupMaybe((0, $dPHSK.default).BleedBox, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.TrimBox = function() {
        return this.lookupMaybe((0, $dPHSK.default).TrimBox, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.ArtBox = function() {
        return this.lookupMaybe((0, $dPHSK.default).ArtBox, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.Resources = function() {
        var dictOrRef = this.getInheritableAttribute((0, $dPHSK.default).Resources);
        return this.context.lookupMaybe(dictOrRef, (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
    };
    PDFPageLeaf.prototype.MediaBox = function() {
        var arrayOrRef = this.getInheritableAttribute((0, $dPHSK.default).MediaBox);
        return this.context.lookup(arrayOrRef, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.CropBox = function() {
        var arrayOrRef = this.getInheritableAttribute((0, $dPHSK.default).CropBox);
        return this.context.lookupMaybe(arrayOrRef, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.Rotate = function() {
        var numberOrRef = this.getInheritableAttribute((0, $dPHSK.default).Rotate);
        return this.context.lookupMaybe(numberOrRef, (0, $j04jt.default));
    };
    PDFPageLeaf.prototype.getInheritableAttribute = function(name) {
        var attribute;
        this.ascend(function(node) {
            if (!attribute) attribute = node.get(name);
        });
        return attribute;
    };
    PDFPageLeaf.prototype.setParent = function(parentRef) {
        this.set((0, $dPHSK.default).Parent, parentRef);
    };
    PDFPageLeaf.prototype.addContentStream = function(contentStreamRef) {
        var Contents = this.normalizedEntries().Contents || this.context.obj([]);
        this.set((0, $dPHSK.default).Contents, Contents);
        Contents.push(contentStreamRef);
    };
    PDFPageLeaf.prototype.wrapContentStreams = function(startStream, endStream) {
        var Contents = this.Contents();
        if (Contents instanceof (0, $8auL6.default)) {
            Contents.insert(0, startStream);
            Contents.push(endStream);
            return true;
        }
        return false;
    };
    PDFPageLeaf.prototype.addAnnot = function(annotRef) {
        var Annots = this.normalizedEntries().Annots;
        Annots.push(annotRef);
    };
    PDFPageLeaf.prototype.removeAnnot = function(annotRef) {
        var Annots = this.normalizedEntries().Annots;
        var index = Annots.indexOf(annotRef);
        if (index !== undefined) Annots.remove(index);
    };
    PDFPageLeaf.prototype.setFontDictionary = function(name, fontDictRef) {
        var Font = this.normalizedEntries().Font;
        Font.set(name, fontDictRef);
    };
    PDFPageLeaf.prototype.newFontDictionaryKey = function(tag) {
        var Font = this.normalizedEntries().Font;
        return Font.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newFontDictionary = function(tag, fontDictRef) {
        var key = this.newFontDictionaryKey(tag);
        this.setFontDictionary(key, fontDictRef);
        return key;
    };
    PDFPageLeaf.prototype.setXObject = function(name, xObjectRef) {
        var XObject = this.normalizedEntries().XObject;
        XObject.set(name, xObjectRef);
    };
    PDFPageLeaf.prototype.newXObjectKey = function(tag) {
        var XObject = this.normalizedEntries().XObject;
        return XObject.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newXObject = function(tag, xObjectRef) {
        var key = this.newXObjectKey(tag);
        this.setXObject(key, xObjectRef);
        return key;
    };
    PDFPageLeaf.prototype.setExtGState = function(name, extGStateRef) {
        var ExtGState = this.normalizedEntries().ExtGState;
        ExtGState.set(name, extGStateRef);
    };
    PDFPageLeaf.prototype.newExtGStateKey = function(tag) {
        var ExtGState = this.normalizedEntries().ExtGState;
        return ExtGState.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newExtGState = function(tag, extGStateRef) {
        var key = this.newExtGStateKey(tag);
        this.setExtGState(key, extGStateRef);
        return key;
    };
    PDFPageLeaf.prototype.ascend = function(visitor) {
        visitor(this);
        var Parent = this.Parent();
        if (Parent) Parent.ascend(visitor);
    };
    PDFPageLeaf.prototype.normalize = function() {
        if (this.normalized) return;
        var context = this.context;
        var contentsRef = this.get((0, $dPHSK.default).Contents);
        var contents = this.context.lookup(contentsRef);
        if (contents instanceof (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039)) this.set((0, $dPHSK.default).Contents, context.obj([
            contentsRef
        ]));
        if (this.autoNormalizeCTM) this.wrapContentStreams(this.context.getPushGraphicsStateContentStream(), this.context.getPopGraphicsStateContentStream());
        // TODO: Clone `Resources` if it is inherited
        var dictOrRef = this.getInheritableAttribute((0, $dPHSK.default).Resources);
        var Resources = context.lookupMaybe(dictOrRef, (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) || context.obj({});
        this.set((0, $dPHSK.default).Resources, Resources);
        // TODO: Clone `Font` if it is inherited
        var Font = Resources.lookupMaybe((0, $dPHSK.default).Font, (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $dPHSK.default).Font, Font);
        // TODO: Clone `XObject` if it is inherited
        var XObject = Resources.lookupMaybe((0, $dPHSK.default).XObject, (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $dPHSK.default).XObject, XObject);
        // TODO: Clone `ExtGState` if it is inherited
        var ExtGState = Resources.lookupMaybe((0, $dPHSK.default).ExtGState, (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $dPHSK.default).ExtGState, ExtGState);
        var Annots = this.Annots() || context.obj([]);
        this.set((0, $dPHSK.default).Annots, Annots);
        this.normalized = true;
    };
    PDFPageLeaf.prototype.normalizedEntries = function() {
        this.normalize();
        var Annots = this.Annots();
        var Resources = this.Resources();
        var Contents = this.Contents();
        return {
            Annots: Annots,
            Resources: Resources,
            Contents: Contents,
            Font: Resources.lookup((0, $dPHSK.default).Font, (0, $85408478fbb7cbde$export$2e2bcd8739ae039)),
            XObject: Resources.lookup((0, $dPHSK.default).XObject, (0, $85408478fbb7cbde$export$2e2bcd8739ae039)),
            ExtGState: Resources.lookup((0, $dPHSK.default).ExtGState, (0, $85408478fbb7cbde$export$2e2bcd8739ae039))
        };
    };
    PDFPageLeaf.InheritableEntries = [
        'Resources',
        'MediaBox',
        'CropBox',
        'Rotate'
    ];
    PDFPageLeaf.withContextAndParent = function(context, parent) {
        var dict = new Map();
        dict.set((0, $dPHSK.default).Type, (0, $dPHSK.default).Page);
        dict.set((0, $dPHSK.default).Parent, parent);
        dict.set((0, $dPHSK.default).Resources, context.obj({}));
        dict.set((0, $dPHSK.default).MediaBox, context.obj([
            0,
            0,
            612,
            792
        ]));
        return new PDFPageLeaf(dict, context, false);
    };
    PDFPageLeaf.fromMapWithContext = function(map, context, autoNormalizeCTM) {
        if (autoNormalizeCTM === void 0) autoNormalizeCTM = true;
        return new PDFPageLeaf(map, context, autoNormalizeCTM);
    };
    return PDFPageLeaf;
}((0, $85408478fbb7cbde$export$2e2bcd8739ae039));
var $a9e73b7ced5abfa4$export$2e2bcd8739ae039 = $a9e73b7ced5abfa4$var$PDFPageLeaf;


/**
 * PDFObjectCopier copies PDFObjects from a src context to a dest context.
 * The primary use case for this is to copy pages between PDFs.
 *
 * _Copying_ an object with a PDFObjectCopier is different from _cloning_ an
 * object with its [[PDFObject.clone]] method:
 *
 * ```
 *   const src: PDFContext = ...
 *   const dest: PDFContext = ...
 *   const originalObject: PDFObject = ...
 *   const copiedObject = PDFObjectCopier.for(src, dest).copy(originalObject);
 *   const clonedObject = originalObject.clone();
 * ```
 *
 * Copying an object is equivalent to cloning it and then copying over any other
 * objects that it references. Note that only dictionaries, arrays, and streams
 * (or structures build from them) can contain indirect references to other
 * objects. Copying a PDFObject that is not a dictionary, array, or stream is
 * supported, but is equivalent to cloning it.
 */ var $ea102798c96bfd06$var$PDFObjectCopier = /** @class */ function() {
    function PDFObjectCopier(src, dest) {
        var _this = this;
        this.traversedObjects = new Map();
        // prettier-ignore
        this.copy = function(object) {
            return object instanceof (0, $a9e73b7ced5abfa4$export$2e2bcd8739ae039) ? _this.copyPDFPage(object) : object instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039) ? _this.copyPDFDict(object) : object instanceof (0, $8auL6.default) ? _this.copyPDFArray(object) : object instanceof (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039) ? _this.copyPDFStream(object) : object instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039) ? _this.copyPDFIndirectObject(object) : object.clone();
        };
        this.copyPDFPage = function(originalPage) {
            var clonedPage = originalPage.clone();
            // Move any entries that the originalPage is inheriting from its parent
            // tree nodes directly into originalPage so they are preserved during
            // the copy.
            var InheritableEntries = (0, $a9e73b7ced5abfa4$export$2e2bcd8739ae039).InheritableEntries;
            for(var idx = 0, len = InheritableEntries.length; idx < len; idx++){
                var key = (0, $dPHSK.default).of(InheritableEntries[idx]);
                var value = clonedPage.getInheritableAttribute(key);
                if (!clonedPage.get(key) && value) clonedPage.set(key, value);
            }
            // Remove the parent reference to prevent the whole donor document's page
            // tree from being copied when we only need a single page.
            clonedPage.delete((0, $dPHSK.default).of('Parent'));
            return _this.copyPDFDict(clonedPage);
        };
        this.copyPDFDict = function(originalDict) {
            if (_this.traversedObjects.has(originalDict)) return _this.traversedObjects.get(originalDict);
            var clonedDict = originalDict.clone(_this.dest);
            _this.traversedObjects.set(originalDict, clonedDict);
            var entries = originalDict.entries();
            for(var idx = 0, len = entries.length; idx < len; idx++){
                var _a = entries[idx], key = _a[0], value = _a[1];
                clonedDict.set(key, _this.copy(value));
            }
            return clonedDict;
        };
        this.copyPDFArray = function(originalArray) {
            if (_this.traversedObjects.has(originalArray)) return _this.traversedObjects.get(originalArray);
            var clonedArray = originalArray.clone(_this.dest);
            _this.traversedObjects.set(originalArray, clonedArray);
            for(var idx = 0, len = originalArray.size(); idx < len; idx++){
                var value = originalArray.get(idx);
                clonedArray.set(idx, _this.copy(value));
            }
            return clonedArray;
        };
        this.copyPDFStream = function(originalStream) {
            if (_this.traversedObjects.has(originalStream)) return _this.traversedObjects.get(originalStream);
            var clonedStream = originalStream.clone(_this.dest);
            _this.traversedObjects.set(originalStream, clonedStream);
            var entries = originalStream.dict.entries();
            for(var idx = 0, len = entries.length; idx < len; idx++){
                var _a = entries[idx], key = _a[0], value = _a[1];
                clonedStream.dict.set(key, _this.copy(value));
            }
            return clonedStream;
        };
        this.copyPDFIndirectObject = function(ref) {
            var alreadyMapped = _this.traversedObjects.has(ref);
            if (!alreadyMapped) {
                var newRef = _this.dest.nextRef();
                _this.traversedObjects.set(ref, newRef);
                var dereferencedValue = _this.src.lookup(ref);
                if (dereferencedValue) {
                    var cloned = _this.copy(dereferencedValue);
                    _this.dest.assign(newRef, cloned);
                }
            }
            return _this.traversedObjects.get(ref);
        };
        this.src = src;
        this.dest = dest;
    }
    PDFObjectCopier.for = function(src, dest) {
        return new PDFObjectCopier(src, dest);
    };
    return PDFObjectCopier;
}();
var $ea102798c96bfd06$export$2e2bcd8739ae039 = $ea102798c96bfd06$var$PDFObjectCopier;



var $cOQTW = parcelRequire("cOQTW");


var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
/**
 * Entries should be added using the [[addEntry]] and [[addDeletedEntry]]
 * methods **in order of ascending object number**.
 */ var $0acfb4f0f4898246$var$PDFCrossRefSection = /** @class */ function() {
    function PDFCrossRefSection(firstEntry) {
        this.subsections = firstEntry ? [
            [
                firstEntry
            ]
        ] : [];
        this.chunkIdx = 0;
        this.chunkLength = firstEntry ? 1 : 0;
    }
    PDFCrossRefSection.prototype.addEntry = function(ref, offset) {
        this.append({
            ref: ref,
            offset: offset,
            deleted: false
        });
    };
    PDFCrossRefSection.prototype.addDeletedEntry = function(ref, nextFreeObjectNumber) {
        this.append({
            ref: ref,
            offset: nextFreeObjectNumber,
            deleted: true
        });
    };
    PDFCrossRefSection.prototype.toString = function() {
        var section = "xref\n";
        for(var rangeIdx = 0, rangeLen = this.subsections.length; rangeIdx < rangeLen; rangeIdx++){
            var range = this.subsections[rangeIdx];
            section += range[0].ref.objectNumber + " " + range.length + "\n";
            for(var entryIdx = 0, entryLen = range.length; entryIdx < entryLen; entryIdx++){
                var entry = range[entryIdx];
                section += (0, $7Kmy8.padStart)(String(entry.offset), 10, '0');
                section += ' ';
                section += (0, $7Kmy8.padStart)(String(entry.ref.generationNumber), 5, '0');
                section += ' ';
                section += entry.deleted ? 'f' : 'n';
                section += ' \n';
            }
        }
        return section;
    };
    PDFCrossRefSection.prototype.sizeInBytes = function() {
        var size = 5;
        for(var idx = 0, len = this.subsections.length; idx < len; idx++){
            var subsection = this.subsections[idx];
            var subsectionLength = subsection.length;
            var firstEntry = subsection[0];
            size += 2;
            size += String(firstEntry.ref.objectNumber).length;
            size += String(subsectionLength).length;
            size += 20 * subsectionLength;
        }
        return size;
    };
    PDFCrossRefSection.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).x;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).f;
        buffer[offset++] = (0, $8zvel.default).Newline;
        offset += this.copySubsectionsIntoBuffer(this.subsections, buffer, offset);
        return offset - initialOffset;
    };
    PDFCrossRefSection.prototype.copySubsectionsIntoBuffer = function(subsections, buffer, offset) {
        var initialOffset = offset;
        var length = subsections.length;
        for(var idx = 0; idx < length; idx++){
            var subsection = this.subsections[idx];
            var firstObjectNumber = String(subsection[0].ref.objectNumber);
            offset += (0, $7Kmy8.copyStringIntoBuffer)(firstObjectNumber, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
            var rangeLength = String(subsection.length);
            offset += (0, $7Kmy8.copyStringIntoBuffer)(rangeLength, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Newline;
            offset += this.copyEntriesIntoBuffer(subsection, buffer, offset);
        }
        return offset - initialOffset;
    };
    PDFCrossRefSection.prototype.copyEntriesIntoBuffer = function(entries, buffer, offset) {
        var length = entries.length;
        for(var idx = 0; idx < length; idx++){
            var entry = entries[idx];
            var entryOffset = (0, $7Kmy8.padStart)(String(entry.offset), 10, '0');
            offset += (0, $7Kmy8.copyStringIntoBuffer)(entryOffset, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
            var entryGen = (0, $7Kmy8.padStart)(String(entry.ref.generationNumber), 5, '0');
            offset += (0, $7Kmy8.copyStringIntoBuffer)(entryGen, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
            buffer[offset++] = entry.deleted ? (0, $8zvel.default).f : (0, $8zvel.default).n;
            buffer[offset++] = (0, $8zvel.default).Space;
            buffer[offset++] = (0, $8zvel.default).Newline;
        }
        return 20 * length;
    };
    PDFCrossRefSection.prototype.append = function(currEntry) {
        if (this.chunkLength === 0) {
            this.subsections.push([
                currEntry
            ]);
            this.chunkIdx = 0;
            this.chunkLength = 1;
            return;
        }
        var chunk = this.subsections[this.chunkIdx];
        var prevEntry = chunk[this.chunkLength - 1];
        if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
            this.subsections.push([
                currEntry
            ]);
            this.chunkIdx += 1;
            this.chunkLength = 1;
        } else {
            chunk.push(currEntry);
            this.chunkLength += 1;
        }
    };
    PDFCrossRefSection.create = function() {
        return new PDFCrossRefSection({
            ref: (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(0, 65535),
            offset: 0,
            deleted: true
        });
    };
    PDFCrossRefSection.createEmpty = function() {
        return new PDFCrossRefSection();
    };
    return PDFCrossRefSection;
}();
var $0acfb4f0f4898246$export$2e2bcd8739ae039 = $0acfb4f0f4898246$var$PDFCrossRefSection;




var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $38bebcf76e0d2d54$var$PDFTrailer = /** @class */ function() {
    function PDFTrailer(lastXRefOffset) {
        this.lastXRefOffset = String(lastXRefOffset);
    }
    PDFTrailer.prototype.toString = function() {
        return "startxref\n" + this.lastXRefOffset + "\n%%EOF";
    };
    PDFTrailer.prototype.sizeInBytes = function() {
        return 16 + this.lastXRefOffset.length;
    };
    PDFTrailer.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).s;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).a;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).x;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).f;
        buffer[offset++] = (0, $8zvel.default).Newline;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.lastXRefOffset, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).Newline;
        buffer[offset++] = (0, $8zvel.default).Percent;
        buffer[offset++] = (0, $8zvel.default).Percent;
        buffer[offset++] = (0, $8zvel.default).E;
        buffer[offset++] = (0, $8zvel.default).O;
        buffer[offset++] = (0, $8zvel.default).F;
        return offset - initialOffset;
    };
    PDFTrailer.forLastCrossRefSectionOffset = function(offset) {
        return new PDFTrailer(offset);
    };
    return PDFTrailer;
}();
var $38bebcf76e0d2d54$export$2e2bcd8739ae039 = $38bebcf76e0d2d54$var$PDFTrailer;



var $8zvel = parcelRequire("8zvel");
var $b9d4f51bf55d54ab$var$PDFTrailerDict = /** @class */ function() {
    function PDFTrailerDict(dict) {
        this.dict = dict;
    }
    PDFTrailerDict.prototype.toString = function() {
        return "trailer\n" + this.dict.toString();
    };
    PDFTrailerDict.prototype.sizeInBytes = function() {
        return 8 + this.dict.sizeInBytes();
    };
    PDFTrailerDict.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).a;
        buffer[offset++] = (0, $8zvel.default).i;
        buffer[offset++] = (0, $8zvel.default).l;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).Newline;
        offset += this.dict.copyBytesInto(buffer, offset);
        return offset - initialOffset;
    };
    PDFTrailerDict.of = function(dict) {
        return new PDFTrailerDict(dict);
    };
    return PDFTrailerDict;
}();
var $b9d4f51bf55d54ab$export$2e2bcd8739ae039 = $b9d4f51bf55d54ab$var$PDFTrailerDict;



var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");


var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $4ISq8 = parcelRequire("4ISq8");
var $61a4452f4878bba9$var$PDFObjectStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFObjectStream, _super);
    function PDFObjectStream(context, objects, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, context.obj({}), encode) || this;
        _this.objects = objects;
        _this.offsets = _this.computeObjectOffsets();
        _this.offsetsString = _this.computeOffsetsString();
        _this.dict.set((0, $dPHSK.default).of('Type'), (0, $dPHSK.default).of('ObjStm'));
        _this.dict.set((0, $dPHSK.default).of('N'), (0, $j04jt.default).of(_this.objects.length));
        _this.dict.set((0, $dPHSK.default).of('First'), (0, $j04jt.default).of(_this.offsetsString.length));
        return _this;
    }
    PDFObjectStream.prototype.getObjectsCount = function() {
        return this.objects.length;
    };
    PDFObjectStream.prototype.clone = function(context) {
        return PDFObjectStream.withContextAndObjects(context || this.dict.context, this.objects.slice(), this.encode);
    };
    PDFObjectStream.prototype.getContentsString = function() {
        var value = this.offsetsString;
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], object = _a[1];
            value += object + "\n";
        }
        return value;
    };
    PDFObjectStream.prototype.getUnencodedContents = function() {
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = (0, $7Kmy8.copyStringIntoBuffer)(this.offsetsString, buffer, 0);
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], object = _a[1];
            offset += object.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Newline;
        }
        return buffer;
    };
    PDFObjectStream.prototype.getUnencodedContentsSize = function() {
        return this.offsetsString.length + (0, $4ISq8.last)(this.offsets)[1] + (0, $4ISq8.last)(this.objects)[1].sizeInBytes() + 1;
    };
    PDFObjectStream.prototype.computeOffsetsString = function() {
        var offsetsString = '';
        for(var idx = 0, len = this.offsets.length; idx < len; idx++){
            var _a = this.offsets[idx], objectNumber = _a[0], offset = _a[1];
            offsetsString += objectNumber + " " + offset + " ";
        }
        return offsetsString;
    };
    PDFObjectStream.prototype.computeObjectOffsets = function() {
        var offset = 0;
        var offsets = new Array(this.objects.length);
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], ref = _a[0], object = _a[1];
            offsets[idx] = [
                ref.objectNumber,
                offset
            ];
            offset += object.sizeInBytes() + 1; // '\n'
        }
        return offsets;
    };
    PDFObjectStream.withContextAndObjects = function(context, objects, encode) {
        if (encode === void 0) encode = true;
        return new PDFObjectStream(context, objects, encode);
    };
    return PDFObjectStream;
}((0, $2d4cf9103ab67d11$export$2e2bcd8739ae039));
var $61a4452f4878bba9$export$2e2bcd8739ae039 = $61a4452f4878bba9$var$PDFObjectStream;



var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ggjMi = parcelRequire("ggjMi");
var $4261dca68d44d2dc$var$PDFWriter = /** @class */ function() {
    function PDFWriter(context, objectsPerTick) {
        var _this = this;
        this.parsedObjects = 0;
        this.shouldWaitForTick = function(n) {
            _this.parsedObjects += n;
            return _this.parsedObjects % _this.objectsPerTick === 0;
        };
        this.context = context;
        this.objectsPerTick = objectsPerTick;
    }
    PDFWriter.prototype.serializeToBuffer = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, size, header, indirectObjects, xref, trailerDict, trailer, offset, buffer, idx, len, _b, ref, object, objectNumber, generationNumber, n;
            return (0, $cOQTW.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.computeBufferSize()
                        ];
                    case 1:
                        _a = _c.sent(), size = _a.size, header = _a.header, indirectObjects = _a.indirectObjects, xref = _a.xref, trailerDict = _a.trailerDict, trailer = _a.trailer;
                        offset = 0;
                        buffer = new Uint8Array(size);
                        offset += header.copyBytesInto(buffer, offset);
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        idx = 0, len = indirectObjects.length;
                        _c.label = 2;
                    case 2:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            5
                        ];
                        _b = indirectObjects[idx], ref = _b[0], object = _b[1];
                        objectNumber = String(ref.objectNumber);
                        offset += (0, $7Kmy8.copyStringIntoBuffer)(objectNumber, buffer, offset);
                        buffer[offset++] = (0, $8zvel.default).Space;
                        generationNumber = String(ref.generationNumber);
                        offset += (0, $7Kmy8.copyStringIntoBuffer)(generationNumber, buffer, offset);
                        buffer[offset++] = (0, $8zvel.default).Space;
                        buffer[offset++] = (0, $8zvel.default).o;
                        buffer[offset++] = (0, $8zvel.default).b;
                        buffer[offset++] = (0, $8zvel.default).j;
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        offset += object.copyBytesInto(buffer, offset);
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        buffer[offset++] = (0, $8zvel.default).e;
                        buffer[offset++] = (0, $8zvel.default).n;
                        buffer[offset++] = (0, $8zvel.default).d;
                        buffer[offset++] = (0, $8zvel.default).o;
                        buffer[offset++] = (0, $8zvel.default).b;
                        buffer[offset++] = (0, $8zvel.default).j;
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        n = object instanceof (0, $61a4452f4878bba9$export$2e2bcd8739ae039) ? object.getObjectsCount() : 1;
                        if (!this.shouldWaitForTick(n)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4:
                        idx++;
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        if (xref) {
                            offset += xref.copyBytesInto(buffer, offset);
                            buffer[offset++] = (0, $8zvel.default).Newline;
                        }
                        if (trailerDict) {
                            offset += trailerDict.copyBytesInto(buffer, offset);
                            buffer[offset++] = (0, $8zvel.default).Newline;
                            buffer[offset++] = (0, $8zvel.default).Newline;
                        }
                        offset += trailer.copyBytesInto(buffer, offset);
                        return [
                            2 /*return*/ ,
                            buffer
                        ];
                }
            });
        });
    };
    PDFWriter.prototype.computeIndirectObjectSize = function(_a) {
        var ref = _a[0], object = _a[1];
        var refSize = ref.sizeInBytes() + 3; // 'R' -> 'obj\n'
        var objectSize = object.sizeInBytes() + 9; // '\nendobj\n\n'
        return refSize + objectSize;
    };
    PDFWriter.prototype.createTrailerDict = function() {
        return this.context.obj({
            Size: this.context.largestObjectNumber + 1,
            Root: this.context.trailerInfo.Root,
            Encrypt: this.context.trailerInfo.Encrypt,
            Info: this.context.trailerInfo.Info,
            ID: this.context.trailerInfo.ID
        });
    };
    PDFWriter.prototype.computeBufferSize = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var header, size, xref, indirectObjects, idx, len, indirectObject, ref, xrefOffset, trailerDict, trailer;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        header = (0, $ab35d5c6c69177c9$export$2e2bcd8739ae039).forVersion(1, 7);
                        size = header.sizeInBytes() + 2;
                        xref = (0, $0acfb4f0f4898246$export$2e2bcd8739ae039).create();
                        indirectObjects = this.context.enumerateIndirectObjects();
                        idx = 0, len = indirectObjects.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        indirectObject = indirectObjects[idx];
                        ref = indirectObject[0];
                        xref.addEntry(ref, size);
                        size += this.computeIndirectObjectSize(indirectObject);
                        if (!this.shouldWaitForTick(1)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        xrefOffset = size;
                        size += xref.sizeInBytes() + 1; // '\n'
                        trailerDict = (0, $b9d4f51bf55d54ab$export$2e2bcd8739ae039).of(this.createTrailerDict());
                        size += trailerDict.sizeInBytes() + 2; // '\n\n'
                        trailer = (0, $38bebcf76e0d2d54$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(xrefOffset);
                        size += trailer.sizeInBytes();
                        return [
                            2 /*return*/ ,
                            {
                                size: size,
                                header: header,
                                indirectObjects: indirectObjects,
                                xref: xref,
                                trailerDict: trailerDict,
                                trailer: trailer
                            }
                        ];
                }
            });
        });
    };
    PDFWriter.forContext = function(context, objectsPerTick) {
        return new PDFWriter(context, objectsPerTick);
    };
    return PDFWriter;
}();
var $4261dca68d44d2dc$export$2e2bcd8739ae039 = $4261dca68d44d2dc$var$PDFWriter;



var $cOQTW = parcelRequire("cOQTW");



var $cOQTW = parcelRequire("cOQTW");

var $11c5J = parcelRequire("11c5J");
var $ad9390730b9495a5$var$PDFInvalidObject = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFInvalidObject, _super);
    function PDFInvalidObject(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    PDFInvalidObject.prototype.clone = function() {
        return PDFInvalidObject.of(this.data.slice());
    };
    PDFInvalidObject.prototype.toString = function() {
        return "PDFInvalidObject(" + this.data.length + " bytes)";
    };
    PDFInvalidObject.prototype.sizeInBytes = function() {
        return this.data.length;
    };
    PDFInvalidObject.prototype.copyBytesInto = function(buffer, offset) {
        var length = this.data.length;
        for(var idx = 0; idx < length; idx++)buffer[offset++] = this.data[idx];
        return length;
    };
    PDFInvalidObject.of = function(data) {
        return new PDFInvalidObject(data);
    };
    return PDFInvalidObject;
}((0, $11c5J.default));
var $ad9390730b9495a5$export$2e2bcd8739ae039 = $ad9390730b9495a5$var$PDFInvalidObject;



var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");



var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");


parcelRequire("fvYKZ");
var $hiEdU = parcelRequire("hiEdU");
var $clYSv = parcelRequire("clYSv");
var $4ISq8 = parcelRequire("4ISq8");
var $ac24be9f2612b58f$export$e41c32906b33062a;
(function(EntryType) {
    EntryType[EntryType["Deleted"] = 0] = "Deleted";
    EntryType[EntryType["Uncompressed"] = 1] = "Uncompressed";
    EntryType[EntryType["Compressed"] = 2] = "Compressed";
})($ac24be9f2612b58f$export$e41c32906b33062a || ($ac24be9f2612b58f$export$e41c32906b33062a = {}));
/**
 * Entries should be added using the [[addDeletedEntry]],
 * [[addUncompressedEntry]], and [[addCompressedEntry]] methods
 * **in order of ascending object number**.
 */ var $ac24be9f2612b58f$var$PDFCrossRefStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFCrossRefStream, _super);
    function PDFCrossRefStream(dict, entries, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, dict, encode) || this;
        // Returns an array of integer pairs for each subsection of the cross ref
        // section, where each integer pair represents:
        //   firstObjectNumber(OfSection), length(OfSection)
        _this.computeIndex = function() {
            var subsections = [];
            var subsectionLength = 0;
            for(var idx = 0, len = _this.entries.length; idx < len; idx++){
                var currEntry = _this.entries[idx];
                var prevEntry = _this.entries[idx - 1];
                if (idx === 0) subsections.push(currEntry.ref.objectNumber);
                else if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
                    subsections.push(subsectionLength);
                    subsections.push(currEntry.ref.objectNumber);
                    subsectionLength = 0;
                }
                subsectionLength += 1;
            }
            subsections.push(subsectionLength);
            return subsections;
        };
        _this.computeEntryTuples = function() {
            var entryTuples = new Array(_this.entries.length);
            for(var idx = 0, len = _this.entries.length; idx < len; idx++){
                var entry = _this.entries[idx];
                if (entry.type === $ac24be9f2612b58f$export$e41c32906b33062a.Deleted) {
                    var type = entry.type, nextFreeObjectNumber = entry.nextFreeObjectNumber, ref = entry.ref;
                    entryTuples[idx] = [
                        type,
                        nextFreeObjectNumber,
                        ref.generationNumber
                    ];
                }
                if (entry.type === $ac24be9f2612b58f$export$e41c32906b33062a.Uncompressed) {
                    var type = entry.type, offset = entry.offset, ref = entry.ref;
                    entryTuples[idx] = [
                        type,
                        offset,
                        ref.generationNumber
                    ];
                }
                if (entry.type === $ac24be9f2612b58f$export$e41c32906b33062a.Compressed) {
                    var type = entry.type, objectStreamRef = entry.objectStreamRef, index = entry.index;
                    entryTuples[idx] = [
                        type,
                        objectStreamRef.objectNumber,
                        index
                    ];
                }
            }
            return entryTuples;
        };
        _this.computeMaxEntryByteWidths = function() {
            var entryTuples = _this.entryTuplesCache.access();
            var widths = [
                0,
                0,
                0
            ];
            for(var idx = 0, len = entryTuples.length; idx < len; idx++){
                var _a = entryTuples[idx], first = _a[0], second = _a[1], third = _a[2];
                var firstSize = (0, $hiEdU.sizeInBytes)(first);
                var secondSize = (0, $hiEdU.sizeInBytes)(second);
                var thirdSize = (0, $hiEdU.sizeInBytes)(third);
                if (firstSize > widths[0]) widths[0] = firstSize;
                if (secondSize > widths[1]) widths[1] = secondSize;
                if (thirdSize > widths[2]) widths[2] = thirdSize;
            }
            return widths;
        };
        _this.entries = entries || [];
        _this.entryTuplesCache = (0, $clYSv.default).populatedBy(_this.computeEntryTuples);
        _this.maxByteWidthsCache = (0, $clYSv.default).populatedBy(_this.computeMaxEntryByteWidths);
        _this.indexCache = (0, $clYSv.default).populatedBy(_this.computeIndex);
        dict.set((0, $dPHSK.default).of('Type'), (0, $dPHSK.default).of('XRef'));
        return _this;
    }
    PDFCrossRefStream.prototype.addDeletedEntry = function(ref, nextFreeObjectNumber) {
        var type = $ac24be9f2612b58f$export$e41c32906b33062a.Deleted;
        this.entries.push({
            type: type,
            ref: ref,
            nextFreeObjectNumber: nextFreeObjectNumber
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.addUncompressedEntry = function(ref, offset) {
        var type = $ac24be9f2612b58f$export$e41c32906b33062a.Uncompressed;
        this.entries.push({
            type: type,
            ref: ref,
            offset: offset
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.addCompressedEntry = function(ref, objectStreamRef, index) {
        var type = $ac24be9f2612b58f$export$e41c32906b33062a.Compressed;
        this.entries.push({
            type: type,
            ref: ref,
            objectStreamRef: objectStreamRef,
            index: index
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.clone = function(context) {
        var _a = this, dict = _a.dict, entries = _a.entries, encode = _a.encode;
        return PDFCrossRefStream.of(dict.clone(context), entries.slice(), encode);
    };
    PDFCrossRefStream.prototype.getContentsString = function() {
        var entryTuples = this.entryTuplesCache.access();
        var byteWidths = this.maxByteWidthsCache.access();
        var value = '';
        for(var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++){
            var _a = entryTuples[entryIdx], first = _a[0], second = _a[1], third = _a[2];
            var firstBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(first));
            var secondBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(second));
            var thirdBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(third));
            for(var idx = byteWidths[0] - 1; idx >= 0; idx--)value += (firstBytes[idx] || 0).toString(2);
            for(var idx = byteWidths[1] - 1; idx >= 0; idx--)value += (secondBytes[idx] || 0).toString(2);
            for(var idx = byteWidths[2] - 1; idx >= 0; idx--)value += (thirdBytes[idx] || 0).toString(2);
        }
        return value;
    };
    PDFCrossRefStream.prototype.getUnencodedContents = function() {
        var entryTuples = this.entryTuplesCache.access();
        var byteWidths = this.maxByteWidthsCache.access();
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = 0;
        for(var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++){
            var _a = entryTuples[entryIdx], first = _a[0], second = _a[1], third = _a[2];
            var firstBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(first));
            var secondBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(second));
            var thirdBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(third));
            for(var idx = byteWidths[0] - 1; idx >= 0; idx--)buffer[offset++] = firstBytes[idx] || 0;
            for(var idx = byteWidths[1] - 1; idx >= 0; idx--)buffer[offset++] = secondBytes[idx] || 0;
            for(var idx = byteWidths[2] - 1; idx >= 0; idx--)buffer[offset++] = thirdBytes[idx] || 0;
        }
        return buffer;
    };
    PDFCrossRefStream.prototype.getUnencodedContentsSize = function() {
        var byteWidths = this.maxByteWidthsCache.access();
        var entryWidth = (0, $4ISq8.sum)(byteWidths);
        return entryWidth * this.entries.length;
    };
    PDFCrossRefStream.prototype.updateDict = function() {
        _super.prototype.updateDict.call(this);
        var byteWidths = this.maxByteWidthsCache.access();
        var index = this.indexCache.access();
        var context = this.dict.context;
        this.dict.set((0, $dPHSK.default).of('W'), context.obj(byteWidths));
        this.dict.set((0, $dPHSK.default).of('Index'), context.obj(index));
    };
    PDFCrossRefStream.create = function(dict, encode) {
        if (encode === void 0) encode = true;
        var stream = new PDFCrossRefStream(dict, [], encode);
        stream.addDeletedEntry((0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(0, 65535), 0);
        return stream;
    };
    PDFCrossRefStream.of = function(dict, entries, encode) {
        if (encode === void 0) encode = true;
        return new PDFCrossRefStream(dict, entries, encode);
    };
    return PDFCrossRefStream;
}((0, $2d4cf9103ab67d11$export$2e2bcd8739ae039));
var $ac24be9f2612b58f$export$2e2bcd8739ae039 = $ac24be9f2612b58f$var$PDFCrossRefStream;




parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $ggjMi = parcelRequire("ggjMi");
var $5cd89dbe12e59987$var$PDFStreamWriter = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFStreamWriter, _super);
    function PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream) {
        var _this = _super.call(this, context, objectsPerTick) || this;
        _this.encodeStreams = encodeStreams;
        _this.objectsPerStream = objectsPerStream;
        return _this;
    }
    PDFStreamWriter.prototype.computeBufferSize = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var objectNumber, header, size, xrefStream, uncompressedObjects, compressedObjects, objectStreamRefs, indirectObjects, idx, len, indirectObject, ref, object, shouldNotCompress, chunk, objectStreamRef, idx, len, chunk, ref, objectStream, xrefStreamRef, xrefOffset, trailer;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        objectNumber = this.context.largestObjectNumber + 1;
                        header = (0, $ab35d5c6c69177c9$export$2e2bcd8739ae039).forVersion(1, 7);
                        size = header.sizeInBytes() + 2;
                        xrefStream = (0, $ac24be9f2612b58f$export$2e2bcd8739ae039).create(this.createTrailerDict(), this.encodeStreams);
                        uncompressedObjects = [];
                        compressedObjects = [];
                        objectStreamRefs = [];
                        indirectObjects = this.context.enumerateIndirectObjects();
                        idx = 0, len = indirectObjects.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            6
                        ];
                        indirectObject = indirectObjects[idx];
                        ref = indirectObject[0], object = indirectObject[1];
                        shouldNotCompress = ref === this.context.trailerInfo.Encrypt || object instanceof (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039) || object instanceof (0, $ad9390730b9495a5$export$2e2bcd8739ae039) || ref.generationNumber !== 0;
                        if (!shouldNotCompress) return [
                            3 /*break*/ ,
                            4
                        ];
                        uncompressedObjects.push(indirectObject);
                        xrefStream.addUncompressedEntry(ref, size);
                        size += this.computeIndirectObjectSize(indirectObject);
                        if (!this.shouldWaitForTick(1)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        chunk = (0, $4ISq8.last)(compressedObjects);
                        objectStreamRef = (0, $4ISq8.last)(objectStreamRefs);
                        if (!chunk || chunk.length % this.objectsPerStream === 0) {
                            chunk = [];
                            compressedObjects.push(chunk);
                            objectStreamRef = (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(objectNumber++);
                            objectStreamRefs.push(objectStreamRef);
                        }
                        xrefStream.addCompressedEntry(ref, objectStreamRef, chunk.length);
                        chunk.push(indirectObject);
                        _a.label = 5;
                    case 5:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 6:
                        idx = 0, len = compressedObjects.length;
                        _a.label = 7;
                    case 7:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            10
                        ];
                        chunk = compressedObjects[idx];
                        ref = objectStreamRefs[idx];
                        objectStream = (0, $61a4452f4878bba9$export$2e2bcd8739ae039).withContextAndObjects(this.context, chunk, this.encodeStreams);
                        xrefStream.addUncompressedEntry(ref, size);
                        size += this.computeIndirectObjectSize([
                            ref,
                            objectStream
                        ]);
                        uncompressedObjects.push([
                            ref,
                            objectStream
                        ]);
                        if (!this.shouldWaitForTick(chunk.length)) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9:
                        idx++;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 10:
                        xrefStreamRef = (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(objectNumber++);
                        xrefStream.dict.set((0, $dPHSK.default).of('Size'), (0, $j04jt.default).of(objectNumber));
                        xrefStream.addUncompressedEntry(xrefStreamRef, size);
                        xrefOffset = size;
                        size += this.computeIndirectObjectSize([
                            xrefStreamRef,
                            xrefStream
                        ]);
                        uncompressedObjects.push([
                            xrefStreamRef,
                            xrefStream
                        ]);
                        trailer = (0, $38bebcf76e0d2d54$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(xrefOffset);
                        size += trailer.sizeInBytes();
                        return [
                            2 /*return*/ ,
                            {
                                size: size,
                                header: header,
                                indirectObjects: uncompressedObjects,
                                trailer: trailer
                            }
                        ];
                }
            });
        });
    };
    PDFStreamWriter.forContext = function(context, objectsPerTick, encodeStreams, objectsPerStream) {
        if (encodeStreams === void 0) encodeStreams = true;
        if (objectsPerStream === void 0) objectsPerStream = 50;
        return new PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream);
    };
    return PDFStreamWriter;
}((0, $4261dca68d44d2dc$export$2e2bcd8739ae039));
var $5cd89dbe12e59987$export$2e2bcd8739ae039 = $5cd89dbe12e59987$var$PDFStreamWriter;






parcelRequire("eNCdi");
var $90iSP = parcelRequire("90iSP");
var $kkdJe = parcelRequire("kkdJe");

var $cOQTW = parcelRequire("cOQTW");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ejAvl = parcelRequire("ejAvl");
var $iSBb0 = parcelRequire("iSBb0");

var $nAWRe = parcelRequire("nAWRe");
var $e8537943f4279a06$var$PDFHexString = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFHexString, _super);
    function PDFHexString(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFHexString.prototype.asBytes = function() {
        // Append a zero if the number of digits is odd. See PDF spec 7.3.4.3
        var hex = this.value + (this.value.length % 2 === 1 ? '0' : '');
        var hexLength = hex.length;
        var bytes = new Uint8Array(hex.length / 2);
        var hexOffset = 0;
        var bytesOffset = 0;
        // Interpret each pair of hex digits as a single byte
        while(hexOffset < hexLength){
            var byte = parseInt(hex.substring(hexOffset, hexOffset + 2), 16);
            bytes[bytesOffset] = byte;
            hexOffset += 2;
            bytesOffset += 1;
        }
        return bytes;
    };
    PDFHexString.prototype.decodeText = function() {
        var bytes = this.asBytes();
        if ((0, $ejAvl.hasUtf16BOM)(bytes)) return (0, $ejAvl.utf16Decode)(bytes);
        return (0, $iSBb0.pdfDocEncodingDecode)(bytes);
    };
    PDFHexString.prototype.decodeDate = function() {
        var text = this.decodeText();
        var date = (0, $7Kmy8.parseDate)(text);
        if (!date) throw new (0, $nAWRe.InvalidPDFDateStringError)(text);
        return date;
    };
    PDFHexString.prototype.asString = function() {
        return this.value;
    };
    PDFHexString.prototype.clone = function() {
        return PDFHexString.of(this.value);
    };
    PDFHexString.prototype.toString = function() {
        return "<" + this.value + ">";
    };
    PDFHexString.prototype.sizeInBytes = function() {
        return this.value.length + 2;
    };
    PDFHexString.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $8zvel.default).LessThan;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.value, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).GreaterThan;
        return this.value.length + 2;
    };
    PDFHexString.of = function(value) {
        return new PDFHexString(value);
    };
    PDFHexString.fromText = function(value) {
        var encoded = (0, $ejAvl.utf16Encode)(value);
        var hex = '';
        for(var idx = 0, len = encoded.length; idx < len; idx++)hex += (0, $7Kmy8.toHexStringOfMinLength)(encoded[idx], 4);
        return new PDFHexString(hex);
    };
    return PDFHexString;
}((0, $11c5J.default));
var $e8537943f4279a06$export$2e2bcd8739ae039 = $e8537943f4279a06$var$PDFHexString;


parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/foliojs/pdfkit/blob/f91bdd61c164a72ea06be1a43dc0a412afc3925f/lib/font/afm.coffee
 */ var $e3698d9fec5e57b0$var$StandardFontEmbedder = /** @class */ function() {
    function StandardFontEmbedder(fontName, customName) {
        // prettier-ignore
        this.encoding = fontName === (0, $kkdJe.FontNames).ZapfDingbats ? (0, $90iSP.Encodings).ZapfDingbats : fontName === (0, $kkdJe.FontNames).Symbol ? (0, $90iSP.Encodings).Symbol : (0, $90iSP.Encodings).WinAnsi;
        this.font = (0, $kkdJe.Font).load(fontName);
        this.fontName = this.font.FontName;
        this.customName = customName;
    }
    /**
     * Encode the JavaScript string into this font. (JavaScript encodes strings in
     * Unicode, but standard fonts use either WinAnsi, ZapfDingbats, or Symbol
     * encodings)
     */ StandardFontEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.encodeTextAsGlyphs(text);
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++)hexCodes[idx] = (0, $7Kmy8.toHexString)(glyphs[idx].code);
        return (0, $e8537943f4279a06$export$2e2bcd8739ae039).of(hexCodes.join(''));
    };
    StandardFontEmbedder.prototype.widthOfTextAtSize = function(text, size) {
        var glyphs = this.encodeTextAsGlyphs(text);
        var totalWidth = 0;
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var left = glyphs[idx].name;
            var right = (glyphs[idx + 1] || {}).name;
            var kernAmount = this.font.getXAxisKerningForPair(left, right) || 0;
            totalWidth += this.widthOfGlyph(left) + kernAmount;
        }
        var scale = size / 1000;
        return totalWidth * scale;
    };
    StandardFontEmbedder.prototype.heightOfFontAtSize = function(size, options) {
        if (options === void 0) options = {};
        var _a = options.descender, descender = _a === void 0 ? true : _a;
        var _b = this.font, Ascender = _b.Ascender, Descender = _b.Descender, FontBBox = _b.FontBBox;
        var yTop = Ascender || FontBBox[3];
        var yBottom = Descender || FontBBox[1];
        var height = yTop - yBottom;
        if (!descender) height += Descender || 0;
        return height / 1000 * size;
    };
    StandardFontEmbedder.prototype.sizeOfFontAtHeight = function(height) {
        var _a = this.font, Ascender = _a.Ascender, Descender = _a.Descender, FontBBox = _a.FontBBox;
        var yTop = Ascender || FontBBox[3];
        var yBottom = Descender || FontBBox[1];
        return 1000 * height / (yTop - yBottom);
    };
    StandardFontEmbedder.prototype.embedIntoContext = function(context, ref) {
        var fontDict = context.obj({
            Type: 'Font',
            Subtype: 'Type1',
            BaseFont: this.customName || this.fontName,
            Encoding: this.encoding === (0, $90iSP.Encodings).WinAnsi ? 'WinAnsiEncoding' : undefined
        });
        if (ref) {
            context.assign(ref, fontDict);
            return ref;
        } else return context.register(fontDict);
    };
    StandardFontEmbedder.prototype.widthOfGlyph = function(glyphName) {
        // Default to 250 if font doesn't specify a width
        return this.font.getWidthOfGlyph(glyphName) || 250;
    };
    StandardFontEmbedder.prototype.encodeTextAsGlyphs = function(text) {
        var codePoints = Array.from(text);
        var glyphs = new Array(codePoints.length);
        for(var idx = 0, len = codePoints.length; idx < len; idx++){
            var codePoint = (0, $7Kmy8.toCodePoint)(codePoints[idx]);
            glyphs[idx] = this.encoding.encodeUnicodeCodePoint(codePoint);
        }
        return glyphs;
    };
    StandardFontEmbedder.for = function(fontName, customName) {
        return new StandardFontEmbedder(fontName, customName);
    };
    return StandardFontEmbedder;
}();
var $e3698d9fec5e57b0$export$2e2bcd8739ae039 = $e3698d9fec5e57b0$var$StandardFontEmbedder;



var $cOQTW = parcelRequire("cOQTW");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");

var $ejAvl = parcelRequire("ejAvl");
var $8fa4fd029ce650b8$export$ecb273704ecc155f = function(glyphs, glyphId) {
    var bfChars = new Array(glyphs.length);
    for(var idx = 0, len = glyphs.length; idx < len; idx++){
        var glyph = glyphs[idx];
        var id = $8fa4fd029ce650b8$var$cmapHexFormat($8fa4fd029ce650b8$var$cmapHexString(glyphId(glyph)));
        var unicode = $8fa4fd029ce650b8$var$cmapHexFormat.apply(void 0, glyph.codePoints.map($8fa4fd029ce650b8$var$cmapCodePointFormat));
        bfChars[idx] = [
            id,
            unicode
        ];
    }
    return $8fa4fd029ce650b8$var$fillCmapTemplate(bfChars);
};
/* =============================== Templates ================================ */ var $8fa4fd029ce650b8$var$fillCmapTemplate = function(bfChars) {
    return "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange\n" + bfChars.length + " beginbfchar\n" + bfChars.map(function(_a) {
        var glyphId = _a[0], codePoint = _a[1];
        return glyphId + " " + codePoint;
    }).join('\n') + "\nendbfchar\nendcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
};
/* =============================== Utilities ================================ */ var $8fa4fd029ce650b8$var$cmapHexFormat = function() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    return "<" + values.join('') + ">";
};
var $8fa4fd029ce650b8$var$cmapHexString = function(value) {
    return (0, $7Kmy8.toHexStringOfMinLength)(value, 4);
};
var $8fa4fd029ce650b8$var$cmapCodePointFormat = function(codePoint) {
    if ((0, $ejAvl.isWithinBMP)(codePoint)) return $8fa4fd029ce650b8$var$cmapHexString(codePoint);
    if ((0, $ejAvl.hasSurrogates)(codePoint)) {
        var hs = (0, $ejAvl.highSurrogate)(codePoint);
        var ls = (0, $ejAvl.lowSurrogate)(codePoint);
        return "" + $8fa4fd029ce650b8$var$cmapHexString(hs) + $8fa4fd029ce650b8$var$cmapHexString(ls);
    }
    var hex = (0, $7Kmy8.toHexString)(codePoint);
    var msg = "0x" + hex + " is not a valid UTF-8 or UTF-16 codepoint.";
    throw new Error(msg);
};


// prettier-ignore
var $740505aae0fb9700$var$makeFontFlags = function(options) {
    var flags = 0;
    var flipBit = function(bit) {
        flags |= 1 << bit - 1;
    };
    if (options.fixedPitch) flipBit(1);
    if (options.serif) flipBit(2);
    if (options.symbolic) flipBit(3);
    if (options.script) flipBit(4);
    if (options.nonsymbolic) flipBit(6);
    if (options.italic) flipBit(7);
    if (options.allCap) flipBit(17);
    if (options.smallCap) flipBit(18);
    if (options.forceBold) flipBit(19);
    return flags;
};
var $740505aae0fb9700$export$aa92af1a056b24e8 = function(font) {
    var familyClass = font['OS/2'] ? font['OS/2'].sFamilyClass : 0;
    var flags = $740505aae0fb9700$var$makeFontFlags({
        fixedPitch: font.post.isFixedPitch,
        serif: 1 <= familyClass && familyClass <= 7,
        symbolic: true,
        script: familyClass === 10,
        italic: font.head.macStyle.italic
    });
    return flags;
};




var $cOQTW = parcelRequire("cOQTW");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ejAvl = parcelRequire("ejAvl");
var $iSBb0 = parcelRequire("iSBb0");

var $nAWRe = parcelRequire("nAWRe");
var $5fbdc5307b6362f1$var$PDFString = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFString, _super);
    function PDFString(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFString.prototype.asBytes = function() {
        var bytes = [];
        var octal = '';
        var escaped = false;
        var pushByte = function(byte) {
            if (byte !== undefined) bytes.push(byte);
            escaped = false;
        };
        for(var idx = 0, len = this.value.length; idx < len; idx++){
            var char = this.value[idx];
            var byte = (0, $7Kmy8.toCharCode)(char);
            var nextChar = this.value[idx + 1];
            if (!escaped) {
                if (byte === (0, $8zvel.default).BackSlash) escaped = true;
                else pushByte(byte);
            } else {
                if (byte === (0, $8zvel.default).Newline) pushByte();
                else if (byte === (0, $8zvel.default).CarriageReturn) pushByte();
                else if (byte === (0, $8zvel.default).n) pushByte((0, $8zvel.default).Newline);
                else if (byte === (0, $8zvel.default).r) pushByte((0, $8zvel.default).CarriageReturn);
                else if (byte === (0, $8zvel.default).t) pushByte((0, $8zvel.default).Tab);
                else if (byte === (0, $8zvel.default).b) pushByte((0, $8zvel.default).Backspace);
                else if (byte === (0, $8zvel.default).f) pushByte((0, $8zvel.default).FormFeed);
                else if (byte === (0, $8zvel.default).LeftParen) pushByte((0, $8zvel.default).LeftParen);
                else if (byte === (0, $8zvel.default).RightParen) pushByte((0, $8zvel.default).RightParen);
                else if (byte === (0, $8zvel.default).Backspace) pushByte((0, $8zvel.default).BackSlash);
                else if (byte >= (0, $8zvel.default).Zero && byte <= (0, $8zvel.default).Seven) {
                    octal += char;
                    if (octal.length === 3 || !(nextChar >= '0' && nextChar <= '7')) {
                        pushByte(parseInt(octal, 8));
                        octal = '';
                    }
                } else pushByte(byte);
            }
        }
        return new Uint8Array(bytes);
    };
    PDFString.prototype.decodeText = function() {
        var bytes = this.asBytes();
        if ((0, $ejAvl.hasUtf16BOM)(bytes)) return (0, $ejAvl.utf16Decode)(bytes);
        return (0, $iSBb0.pdfDocEncodingDecode)(bytes);
    };
    PDFString.prototype.decodeDate = function() {
        var text = this.decodeText();
        var date = (0, $7Kmy8.parseDate)(text);
        if (!date) throw new (0, $nAWRe.InvalidPDFDateStringError)(text);
        return date;
    };
    PDFString.prototype.asString = function() {
        return this.value;
    };
    PDFString.prototype.clone = function() {
        return PDFString.of(this.value);
    };
    PDFString.prototype.toString = function() {
        return "(" + this.value + ")";
    };
    PDFString.prototype.sizeInBytes = function() {
        return this.value.length + 2;
    };
    PDFString.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $8zvel.default).LeftParen;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.value, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).RightParen;
        return this.value.length + 2;
    };
    // The PDF spec allows newlines and parens to appear directly within a literal
    // string. These character _may_ be escaped. But they do not _have_ to be. So
    // for simplicity, we will not bother escaping them.
    PDFString.of = function(value) {
        return new PDFString(value);
    };
    PDFString.fromDate = function(date) {
        var year = (0, $7Kmy8.padStart)(String(date.getUTCFullYear()), 4, '0');
        var month = (0, $7Kmy8.padStart)(String(date.getUTCMonth() + 1), 2, '0');
        var day = (0, $7Kmy8.padStart)(String(date.getUTCDate()), 2, '0');
        var hours = (0, $7Kmy8.padStart)(String(date.getUTCHours()), 2, '0');
        var mins = (0, $7Kmy8.padStart)(String(date.getUTCMinutes()), 2, '0');
        var secs = (0, $7Kmy8.padStart)(String(date.getUTCSeconds()), 2, '0');
        return new PDFString("D:" + year + month + day + hours + mins + secs + "Z");
    };
    return PDFString;
}((0, $11c5J.default));
var $5fbdc5307b6362f1$export$2e2bcd8739ae039 = $5fbdc5307b6362f1$var$PDFString;


parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $clYSv = parcelRequire("clYSv");
var $7Kmy8 = parcelRequire("7Kmy8");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/jpeg.coffee
 */ var $c1a3ddaa0f08fc18$var$CustomFontEmbedder = /** @class */ function() {
    function CustomFontEmbedder(font, fontData, customName, fontFeatures) {
        var _this = this;
        this.allGlyphsInFontSortedById = function() {
            var glyphs = new Array(_this.font.characterSet.length);
            for(var idx = 0, len = glyphs.length; idx < len; idx++){
                var codePoint = _this.font.characterSet[idx];
                glyphs[idx] = _this.font.glyphForCodePoint(codePoint);
            }
            return (0, $4ISq8.sortedUniq)(glyphs.sort((0, $4ISq8.byAscendingId)), function(g) {
                return g.id;
            });
        };
        this.font = font;
        this.scale = 1000 / this.font.unitsPerEm;
        this.fontData = fontData;
        this.fontName = this.font.postscriptName || 'Font';
        this.customName = customName;
        this.fontFeatures = fontFeatures;
        this.baseFontName = '';
        this.glyphCache = (0, $clYSv.default).populatedBy(this.allGlyphsInFontSortedById);
    }
    CustomFontEmbedder.for = function(fontkit, fontData, customName, fontFeatures) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var font;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fontkit.create(fontData)
                        ];
                    case 1:
                        font = _a.sent();
                        return [
                            2 /*return*/ ,
                            new CustomFontEmbedder(font, fontData, customName, fontFeatures)
                        ];
                }
            });
        });
    };
    /**
     * Encode the JavaScript string into this font. (JavaScript encodes strings in
     * Unicode, but embedded fonts use their own custom encodings)
     */ CustomFontEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++)hexCodes[idx] = (0, $7Kmy8.toHexStringOfMinLength)(glyphs[idx].id, 4);
        return (0, $e8537943f4279a06$export$2e2bcd8739ae039).of(hexCodes.join(''));
    };
    // The advanceWidth takes into account kerning automatically, so we don't
    // have to do that manually like we do for the standard fonts.
    CustomFontEmbedder.prototype.widthOfTextAtSize = function(text, size) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var totalWidth = 0;
        for(var idx = 0, len = glyphs.length; idx < len; idx++)totalWidth += glyphs[idx].advanceWidth * this.scale;
        var scale = size / 1000;
        return totalWidth * scale;
    };
    CustomFontEmbedder.prototype.heightOfFontAtSize = function(size, options) {
        if (options === void 0) options = {};
        var _a = options.descender, descender = _a === void 0 ? true : _a;
        var _b = this.font, ascent = _b.ascent, descent = _b.descent, bbox = _b.bbox;
        var yTop = (ascent || bbox.maxY) * this.scale;
        var yBottom = (descent || bbox.minY) * this.scale;
        var height = yTop - yBottom;
        if (!descender) height -= Math.abs(descent) || 0;
        return height / 1000 * size;
    };
    CustomFontEmbedder.prototype.sizeOfFontAtHeight = function(height) {
        var _a = this.font, ascent = _a.ascent, descent = _a.descent, bbox = _a.bbox;
        var yTop = (ascent || bbox.maxY) * this.scale;
        var yBottom = (descent || bbox.minY) * this.scale;
        return 1000 * height / (yTop - yBottom);
    };
    CustomFontEmbedder.prototype.embedIntoContext = function(context, ref) {
        this.baseFontName = this.customName || context.addRandomSuffix(this.fontName);
        return this.embedFontDict(context, ref);
    };
    CustomFontEmbedder.prototype.embedFontDict = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var cidFontDictRef, unicodeCMapRef, fontDict;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedCIDFontDict(context)
                        ];
                    case 1:
                        cidFontDictRef = _a.sent();
                        unicodeCMapRef = this.embedUnicodeCmap(context);
                        fontDict = context.obj({
                            Type: 'Font',
                            Subtype: 'Type0',
                            BaseFont: this.baseFontName,
                            Encoding: 'Identity-H',
                            DescendantFonts: [
                                cidFontDictRef
                            ],
                            ToUnicode: unicodeCMapRef
                        });
                        if (ref) {
                            context.assign(ref, fontDict);
                            return [
                                2 /*return*/ ,
                                ref
                            ];
                        } else return [
                            2 /*return*/ ,
                            context.register(fontDict)
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.isCFF = function() {
        return this.font.cff;
    };
    CustomFontEmbedder.prototype.embedCIDFontDict = function(context) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var fontDescriptorRef, cidFontDict;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedFontDescriptor(context)
                        ];
                    case 1:
                        fontDescriptorRef = _a.sent();
                        cidFontDict = context.obj({
                            Type: 'Font',
                            Subtype: this.isCFF() ? 'CIDFontType0' : 'CIDFontType2',
                            CIDToGIDMap: 'Identity',
                            BaseFont: this.baseFontName,
                            CIDSystemInfo: {
                                Registry: (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).of('Adobe'),
                                Ordering: (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).of('Identity'),
                                Supplement: 0
                            },
                            FontDescriptor: fontDescriptorRef,
                            W: this.computeWidths()
                        });
                        return [
                            2 /*return*/ ,
                            context.register(cidFontDict)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.embedFontDescriptor = function(context) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var fontStreamRef, scale, _a, italicAngle, ascent, descent, capHeight, xHeight, _b, minX, minY, maxX, maxY, fontDescriptor;
            var _c;
            return (0, $cOQTW.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedFontStream(context)
                        ];
                    case 1:
                        fontStreamRef = _d.sent();
                        scale = this.scale;
                        _a = this.font, italicAngle = _a.italicAngle, ascent = _a.ascent, descent = _a.descent, capHeight = _a.capHeight, xHeight = _a.xHeight;
                        _b = this.font.bbox, minX = _b.minX, minY = _b.minY, maxX = _b.maxX, maxY = _b.maxY;
                        fontDescriptor = context.obj((_c = {
                            Type: 'FontDescriptor',
                            FontName: this.baseFontName,
                            Flags: (0, $740505aae0fb9700$export$aa92af1a056b24e8)(this.font),
                            FontBBox: [
                                minX * scale,
                                minY * scale,
                                maxX * scale,
                                maxY * scale
                            ],
                            ItalicAngle: italicAngle,
                            Ascent: ascent * scale,
                            Descent: descent * scale,
                            CapHeight: (capHeight || ascent) * scale,
                            XHeight: (xHeight || 0) * scale,
                            // Not sure how to compute/find this, nor is anybody else really:
                            // https://stackoverflow.com/questions/35485179/stemv-value-of-the-truetype-font
                            StemV: 0
                        }, _c[this.isCFF() ? 'FontFile3' : 'FontFile2'] = fontStreamRef, _c));
                        return [
                            2 /*return*/ ,
                            context.register(fontDescriptor)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.serializeFont = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.fontData
                ];
            });
        });
    };
    CustomFontEmbedder.prototype.embedFontStream = function(context) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var fontStream, _a, _b;
            return (0, $cOQTW.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _b = (_a = context).flateStream;
                        return [
                            4 /*yield*/ ,
                            this.serializeFont()
                        ];
                    case 1:
                        fontStream = _b.apply(_a, [
                            _c.sent(),
                            {
                                Subtype: this.isCFF() ? 'CIDFontType0C' : undefined
                            }
                        ]);
                        return [
                            2 /*return*/ ,
                            context.register(fontStream)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.embedUnicodeCmap = function(context) {
        var cmap = (0, $8fa4fd029ce650b8$export$ecb273704ecc155f)(this.glyphCache.access(), this.glyphId.bind(this));
        var cmapStream = context.flateStream(cmap);
        return context.register(cmapStream);
    };
    CustomFontEmbedder.prototype.glyphId = function(glyph) {
        return glyph ? glyph.id : -1;
    };
    CustomFontEmbedder.prototype.computeWidths = function() {
        var glyphs = this.glyphCache.access();
        var widths = [];
        var currSection = [];
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var currGlyph = glyphs[idx];
            var prevGlyph = glyphs[idx - 1];
            var currGlyphId = this.glyphId(currGlyph);
            var prevGlyphId = this.glyphId(prevGlyph);
            if (idx === 0) widths.push(currGlyphId);
            else if (currGlyphId - prevGlyphId !== 1) {
                widths.push(currSection);
                widths.push(currGlyphId);
                currSection = [];
            }
            currSection.push(currGlyph.advanceWidth * this.scale);
        }
        widths.push(currSection);
        return widths;
    };
    return CustomFontEmbedder;
}();
var $c1a3ddaa0f08fc18$export$2e2bcd8739ae039 = $c1a3ddaa0f08fc18$var$CustomFontEmbedder;



var $cOQTW = parcelRequire("cOQTW");


parcelRequire("fvYKZ");
var $clYSv = parcelRequire("clYSv");
var $4ISq8 = parcelRequire("4ISq8");
var $7Kmy8 = parcelRequire("7Kmy8");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/jpeg.coffee
 */ var $4bb3e5ce3694dd68$var$CustomFontSubsetEmbedder = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(CustomFontSubsetEmbedder, _super);
    function CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures) {
        var _this = _super.call(this, font, fontData, customFontName, fontFeatures) || this;
        _this.subset = _this.font.createSubset();
        _this.glyphs = [];
        _this.glyphCache = (0, $clYSv.default).populatedBy(function() {
            return _this.glyphs;
        });
        _this.glyphIdMap = new Map();
        return _this;
    }
    CustomFontSubsetEmbedder.for = function(fontkit, fontData, customFontName, fontFeatures) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var font;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fontkit.create(fontData)
                        ];
                    case 1:
                        font = _a.sent();
                        return [
                            2 /*return*/ ,
                            new CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures)
                        ];
                }
            });
        });
    };
    CustomFontSubsetEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var glyph = glyphs[idx];
            var subsetGlyphId = this.subset.includeGlyph(glyph);
            this.glyphs[subsetGlyphId - 1] = glyph;
            this.glyphIdMap.set(glyph.id, subsetGlyphId);
            hexCodes[idx] = (0, $7Kmy8.toHexStringOfMinLength)(subsetGlyphId, 4);
        }
        this.glyphCache.invalidate();
        return (0, $e8537943f4279a06$export$2e2bcd8739ae039).of(hexCodes.join(''));
    };
    CustomFontSubsetEmbedder.prototype.isCFF = function() {
        return this.subset.cff;
    };
    CustomFontSubsetEmbedder.prototype.glyphId = function(glyph) {
        return glyph ? this.glyphIdMap.get(glyph.id) : -1;
    };
    CustomFontSubsetEmbedder.prototype.serializeFont = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var parts = [];
            _this.subset.encodeStream().on('data', function(bytes) {
                return parts.push(bytes);
            }).on('end', function() {
                return resolve((0, $4ISq8.mergeUint8Arrays)(parts));
            }).on('error', function(err) {
                return reject(err);
            });
        });
    };
    return CustomFontSubsetEmbedder;
}((0, $c1a3ddaa0f08fc18$export$2e2bcd8739ae039));
var $4bb3e5ce3694dd68$export$2e2bcd8739ae039 = $4bb3e5ce3694dd68$var$CustomFontSubsetEmbedder;



var $cOQTW = parcelRequire("cOQTW");


var $03c8546b8537a071$export$c12eac46fbec1b74;
(function(AFRelationship) {
    AFRelationship["Source"] = "Source";
    AFRelationship["Data"] = "Data";
    AFRelationship["Alternative"] = "Alternative";
    AFRelationship["Supplement"] = "Supplement";
    AFRelationship["EncryptedPayload"] = "EncryptedPayload";
    AFRelationship["FormData"] = "EncryptedPayload";
    AFRelationship["Schema"] = "Schema";
    AFRelationship["Unspecified"] = "Unspecified";
})($03c8546b8537a071$export$c12eac46fbec1b74 || ($03c8546b8537a071$export$c12eac46fbec1b74 = {}));
var $03c8546b8537a071$var$FileEmbedder = /** @class */ function() {
    function FileEmbedder(fileData, fileName, options) {
        if (options === void 0) options = {};
        this.fileData = fileData;
        this.fileName = fileName;
        this.options = options;
    }
    FileEmbedder.for = function(bytes, fileName, options) {
        if (options === void 0) options = {};
        return new FileEmbedder(bytes, fileName, options);
    };
    FileEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, mimeType, description, creationDate, modificationDate, afRelationship, embeddedFileStream, embeddedFileStreamRef, fileSpecDict;
            return (0, $cOQTW.__generator)(this, function(_b) {
                _a = this.options, mimeType = _a.mimeType, description = _a.description, creationDate = _a.creationDate, modificationDate = _a.modificationDate, afRelationship = _a.afRelationship;
                embeddedFileStream = context.flateStream(this.fileData, {
                    Type: 'EmbeddedFile',
                    Subtype: mimeType !== null && mimeType !== void 0 ? mimeType : undefined,
                    Params: {
                        Size: this.fileData.length,
                        CreationDate: creationDate ? (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).fromDate(creationDate) : undefined,
                        ModDate: modificationDate ? (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).fromDate(modificationDate) : undefined
                    }
                });
                embeddedFileStreamRef = context.register(embeddedFileStream);
                fileSpecDict = context.obj({
                    Type: 'Filespec',
                    F: (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).of(this.fileName),
                    UF: (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(this.fileName),
                    EF: {
                        F: embeddedFileStreamRef
                    },
                    Desc: description ? (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(description) : undefined,
                    AFRelationship: afRelationship !== null && afRelationship !== void 0 ? afRelationship : undefined
                });
                if (ref) {
                    context.assign(ref, fileSpecDict);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(fileSpecDict)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return FileEmbedder;
}();
var $03c8546b8537a071$export$2e2bcd8739ae039 = $03c8546b8537a071$var$FileEmbedder;



var $cOQTW = parcelRequire("cOQTW");
// prettier-ignore
var $b2f30d23c2f107ea$var$MARKERS = [
    0xffc0,
    0xffc1,
    0xffc2,
    0xffc3,
    0xffc5,
    0xffc6,
    0xffc7,
    0xffc8,
    0xffc9,
    0xffca,
    0xffcb,
    0xffcc,
    0xffcd,
    0xffce,
    0xffcf
];
var $b2f30d23c2f107ea$var$ColorSpace;
(function(ColorSpace) {
    ColorSpace["DeviceGray"] = "DeviceGray";
    ColorSpace["DeviceRGB"] = "DeviceRGB";
    ColorSpace["DeviceCMYK"] = "DeviceCMYK";
})($b2f30d23c2f107ea$var$ColorSpace || ($b2f30d23c2f107ea$var$ColorSpace = {}));
var $b2f30d23c2f107ea$var$ChannelToColorSpace = {
    1: $b2f30d23c2f107ea$var$ColorSpace.DeviceGray,
    3: $b2f30d23c2f107ea$var$ColorSpace.DeviceRGB,
    4: $b2f30d23c2f107ea$var$ColorSpace.DeviceCMYK
};
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/foliojs/pdfkit/blob/a6af76467ce06bd6a2af4aa7271ccac9ff152a7d/lib/image/jpeg.js
 */ var $b2f30d23c2f107ea$var$JpegEmbedder = /** @class */ function() {
    function JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace) {
        this.imageData = imageData;
        this.bitsPerComponent = bitsPerComponent;
        this.width = width;
        this.height = height;
        this.colorSpace = colorSpace;
    }
    JpegEmbedder.for = function(imageData) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var dataView, soi, pos, marker, bitsPerComponent, height, width, channelByte, channelName, colorSpace;
            return (0, $cOQTW.__generator)(this, function(_a) {
                dataView = new DataView(imageData.buffer);
                soi = dataView.getUint16(0);
                if (soi !== 0xffd8) throw new Error('SOI not found in JPEG');
                pos = 2;
                while(pos < dataView.byteLength){
                    marker = dataView.getUint16(pos);
                    pos += 2;
                    if ($b2f30d23c2f107ea$var$MARKERS.includes(marker)) break;
                    pos += dataView.getUint16(pos);
                }
                if (!$b2f30d23c2f107ea$var$MARKERS.includes(marker)) throw new Error('Invalid JPEG');
                pos += 2;
                bitsPerComponent = dataView.getUint8(pos++);
                height = dataView.getUint16(pos);
                pos += 2;
                width = dataView.getUint16(pos);
                pos += 2;
                channelByte = dataView.getUint8(pos++);
                channelName = $b2f30d23c2f107ea$var$ChannelToColorSpace[channelByte];
                if (!channelName) throw new Error('Unknown JPEG channel.');
                colorSpace = channelName;
                return [
                    2 /*return*/ ,
                    new JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace)
                ];
            });
        });
    };
    JpegEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var xObject;
            return (0, $cOQTW.__generator)(this, function(_a) {
                xObject = context.stream(this.imageData, {
                    Type: 'XObject',
                    Subtype: 'Image',
                    BitsPerComponent: this.bitsPerComponent,
                    Width: this.width,
                    Height: this.height,
                    ColorSpace: this.colorSpace,
                    Filter: 'DCTDecode',
                    // CMYK JPEG streams in PDF are typically stored complemented,
                    // with 1 as 'off' and 0 as 'on' (PDF 32000-1:2008, 8.6.4.4).
                    //
                    // Standalone CMYK JPEG (usually exported by Photoshop) are
                    // stored inverse, with 0 as 'off' and 1 as 'on', like RGB.
                    //
                    // Applying a swap here as a hedge that most bytes passing
                    // through this method will benefit from it.
                    Decode: this.colorSpace === $b2f30d23c2f107ea$var$ColorSpace.DeviceCMYK ? [
                        1,
                        0,
                        1,
                        0,
                        1,
                        0,
                        1,
                        0
                    ] : undefined
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return JpegEmbedder;
}();
var $b2f30d23c2f107ea$export$2e2bcd8739ae039 = $b2f30d23c2f107ea$var$JpegEmbedder;



var $cOQTW = parcelRequire("cOQTW");

var $ckCqy = parcelRequire("ckCqy");
var $6ee893d66c44e557$var$UPNG = {};
$6ee893d66c44e557$var$UPNG.toRGBA8 = function(out) {
    var w = out.width, h = out.height;
    if (out.tabs.acTL == null) return [
        $6ee893d66c44e557$var$UPNG.toRGBA8.decodeImage(out.data, w, h, out).buffer
    ];
    var frms = [];
    if (out.frames[0].data == null) out.frames[0].data = out.data;
    var len = w * h * 4, img = new Uint8Array(len), empty = new Uint8Array(len), prev = new Uint8Array(len);
    for(var i = 0; i < out.frames.length; i++){
        var frm = out.frames[i];
        var fx = frm.rect.x, fy = frm.rect.y, fw = frm.rect.width, fh = frm.rect.height;
        var fdata = $6ee893d66c44e557$var$UPNG.toRGBA8.decodeImage(frm.data, fw, fh, out);
        if (i != 0) for(var j = 0; j < len; j++)prev[j] = img[j];
        if (frm.blend == 0) $6ee893d66c44e557$var$UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 0);
        else if (frm.blend == 1) $6ee893d66c44e557$var$UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 1);
        frms.push(img.buffer.slice(0));
        if (frm.dispose == 0) ;
        else if (frm.dispose == 1) $6ee893d66c44e557$var$UPNG._copyTile(empty, fw, fh, img, w, h, fx, fy, 0);
        else if (frm.dispose == 2) for(var j = 0; j < len; j++)img[j] = prev[j];
    }
    return frms;
};
$6ee893d66c44e557$var$UPNG.toRGBA8.decodeImage = function(data, w, h, out) {
    var area = w * h, bpp = $6ee893d66c44e557$var$UPNG.decode._getBPP(out);
    var bpl = Math.ceil(w * bpp / 8); // bytes per line
    var bf = new Uint8Array(area * 4), bf32 = new Uint32Array(bf.buffer);
    var ctype = out.ctype, depth = out.depth;
    var rs = $6ee893d66c44e557$var$UPNG._bin.readUshort;
    //console.log(ctype, depth);
    var time = Date.now();
    if (ctype == 6) {
        var qarea = area << 2;
        if (depth == 8) for(var i = 0; i < qarea; i += 4){
            bf[i] = data[i];
            bf[i + 1] = data[i + 1];
            bf[i + 2] = data[i + 2];
            bf[i + 3] = data[i + 3];
        }
        if (depth == 16) for(var i = 0; i < qarea; i++)bf[i] = data[i << 1];
    } else if (ctype == 2) {
        var ts = out.tabs["tRNS"];
        if (ts == null) {
            if (depth == 8) for(var i = 0; i < area; i++){
                var ti = i * 3;
                bf32[i] = -16777216 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
            }
            if (depth == 16) for(var i = 0; i < area; i++){
                var ti = i * 6;
                bf32[i] = -16777216 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
            }
        } else {
            var tr = ts[0], tg = ts[1], tb = ts[2];
            if (depth == 8) for(var i = 0; i < area; i++){
                var qi = i << 2, ti = i * 3;
                bf32[i] = -16777216 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
                if (data[ti] == tr && data[ti + 1] == tg && data[ti + 2] == tb) bf[qi + 3] = 0;
            }
            if (depth == 16) for(var i = 0; i < area; i++){
                var qi = i << 2, ti = i * 6;
                bf32[i] = -16777216 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
                if (rs(data, ti) == tr && rs(data, ti + 2) == tg && rs(data, ti + 4) == tb) bf[qi + 3] = 0;
            }
        }
    } else if (ctype == 3) {
        var p = out.tabs["PLTE"], ap = out.tabs["tRNS"], tl = ap ? ap.length : 0;
        //console.log(p, ap);
        if (depth == 1) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 3)] >> 7 - ((i & 7) << 0) & 1, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 2) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 2)] >> 6 - ((i & 3) << 1) & 3, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 4) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 1)] >> 4 - ((i & 1) << 2) & 15, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 8) for(var i = 0; i < area; i++){
            var qi = i << 2, j = data[i], cj = 3 * j;
            bf[qi] = p[cj];
            bf[qi + 1] = p[cj + 1];
            bf[qi + 2] = p[cj + 2];
            bf[qi + 3] = j < tl ? ap[j] : 255;
        }
    } else if (ctype == 4) {
        if (depth == 8) for(var i = 0; i < area; i++){
            var qi = i << 2, di = i << 1, gr = data[di];
            bf[qi] = gr;
            bf[qi + 1] = gr;
            bf[qi + 2] = gr;
            bf[qi + 3] = data[di + 1];
        }
        if (depth == 16) for(var i = 0; i < area; i++){
            var qi = i << 2, di = i << 2, gr = data[di];
            bf[qi] = gr;
            bf[qi + 1] = gr;
            bf[qi + 2] = gr;
            bf[qi + 3] = data[di + 2];
        }
    } else if (ctype == 0) {
        var tr = out.tabs["tRNS"] ? out.tabs["tRNS"] : -1;
        for(var y = 0; y < h; y++){
            var off = y * bpl, to = y * w;
            if (depth == 1) for(var x = 0; x < w; x++){
                var gr = 255 * (data[off + (x >>> 3)] >>> 7 - (x & 7) & 1), al = gr == tr * 255 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 2) for(var x = 0; x < w; x++){
                var gr = 85 * (data[off + (x >>> 2)] >>> 6 - ((x & 3) << 1) & 3), al = gr == tr * 85 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 4) for(var x = 0; x < w; x++){
                var gr = 17 * (data[off + (x >>> 1)] >>> 4 - ((x & 1) << 2) & 15), al = gr == tr * 17 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 8) for(var x = 0; x < w; x++){
                var gr = data[off + x], al = gr == tr ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 16) for(var x = 0; x < w; x++){
                var gr = data[off + (x << 1)], al = rs(data, off + (x << i)) == tr ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
        }
    }
    //console.log(Date.now()-time);
    return bf;
};
$6ee893d66c44e557$var$UPNG.decode = function(buff) {
    var data = new Uint8Array(buff), offset = 8, bin = $6ee893d66c44e557$var$UPNG._bin, rUs = bin.readUshort, rUi = bin.readUint;
    var out = {
        tabs: {},
        frames: []
    };
    var dd = new Uint8Array(data.length), doff = 0; // put all IDAT data into it
    var fd, foff = 0; // frames
    var mgck = [
        0x89,
        0x50,
        0x4e,
        0x47,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ];
    for(var i = 0; i < 8; i++)if (data[i] != mgck[i]) throw "The input is not a PNG file!";
    while(offset < data.length){
        var len = bin.readUint(data, offset);
        offset += 4;
        var type = bin.readASCII(data, offset, 4);
        offset += 4;
        //console.log(type,len);
        if (type == "IHDR") $6ee893d66c44e557$var$UPNG.decode._IHDR(data, offset, out);
        else if (type == "IDAT") {
            for(var i = 0; i < len; i++)dd[doff + i] = data[offset + i];
            doff += len;
        } else if (type == "acTL") {
            out.tabs[type] = {
                num_frames: rUi(data, offset),
                num_plays: rUi(data, offset + 4)
            };
            fd = new Uint8Array(data.length);
        } else if (type == "fcTL") {
            if (foff != 0) {
                var fr = out.frames[out.frames.length - 1];
                fr.data = $6ee893d66c44e557$var$UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
                foff = 0;
            }
            var rct = {
                x: rUi(data, offset + 12),
                y: rUi(data, offset + 16),
                width: rUi(data, offset + 4),
                height: rUi(data, offset + 8)
            };
            var del = rUs(data, offset + 22);
            del = rUs(data, offset + 20) / (del == 0 ? 100 : del);
            var frm = {
                rect: rct,
                delay: Math.round(del * 1000),
                dispose: data[offset + 24],
                blend: data[offset + 25]
            };
            //console.log(frm);
            out.frames.push(frm);
        } else if (type == "fdAT") {
            for(var i = 0; i < len - 4; i++)fd[foff + i] = data[offset + i + 4];
            foff += len - 4;
        } else if (type == "pHYs") out.tabs[type] = [
            bin.readUint(data, offset),
            bin.readUint(data, offset + 4),
            data[offset + 8]
        ];
        else if (type == "cHRM") {
            out.tabs[type] = [];
            for(var i = 0; i < 8; i++)out.tabs[type].push(bin.readUint(data, offset + i * 4));
        } else if (type == "tEXt") {
            if (out.tabs[type] == null) out.tabs[type] = {};
            var nz = bin.nextZero(data, offset);
            var keyw = bin.readASCII(data, offset, nz - offset);
            var text = bin.readASCII(data, nz + 1, offset + len - nz - 1);
            out.tabs[type][keyw] = text;
        } else if (type == "iTXt") {
            if (out.tabs[type] == null) out.tabs[type] = {};
            var nz = 0, off = offset;
            nz = bin.nextZero(data, off);
            var keyw = bin.readASCII(data, off, nz - off);
            off = nz + 1;
            var cflag = data[off], cmeth = data[off + 1];
            off += 2;
            nz = bin.nextZero(data, off);
            var ltag = bin.readASCII(data, off, nz - off);
            off = nz + 1;
            nz = bin.nextZero(data, off);
            var tkeyw = bin.readUTF8(data, off, nz - off);
            off = nz + 1;
            var text = bin.readUTF8(data, off, len - (off - offset));
            out.tabs[type][keyw] = text;
        } else if (type == "PLTE") out.tabs[type] = bin.readBytes(data, offset, len);
        else if (type == "hIST") {
            var pl = out.tabs["PLTE"].length / 3;
            out.tabs[type] = [];
            for(var i = 0; i < pl; i++)out.tabs[type].push(rUs(data, offset + i * 2));
        } else if (type == "tRNS") {
            if (out.ctype == 3) out.tabs[type] = bin.readBytes(data, offset, len);
            else if (out.ctype == 0) out.tabs[type] = rUs(data, offset);
            else if (out.ctype == 2) out.tabs[type] = [
                rUs(data, offset),
                rUs(data, offset + 2),
                rUs(data, offset + 4)
            ];
        //else console.log("tRNS for unsupported color type",out.ctype, len);
        } else if (type == "gAMA") out.tabs[type] = bin.readUint(data, offset) / 100000;
        else if (type == "sRGB") out.tabs[type] = data[offset];
        else if (type == "bKGD") {
            if (out.ctype == 0 || out.ctype == 4) out.tabs[type] = [
                rUs(data, offset)
            ];
            else if (out.ctype == 2 || out.ctype == 6) out.tabs[type] = [
                rUs(data, offset),
                rUs(data, offset + 2),
                rUs(data, offset + 4)
            ];
            else if (out.ctype == 3) out.tabs[type] = data[offset];
        } else if (type == "IEND") break;
        //else {  log("unknown chunk type", type, len);  }
        offset += len;
        var crc = bin.readUint(data, offset);
        offset += 4;
    }
    if (foff != 0) {
        var fr = out.frames[out.frames.length - 1];
        fr.data = $6ee893d66c44e557$var$UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
        foff = 0;
    }
    out.data = $6ee893d66c44e557$var$UPNG.decode._decompress(out, dd, out.width, out.height);
    delete out.compress;
    delete out.interlace;
    delete out.filter;
    return out;
};
$6ee893d66c44e557$var$UPNG.decode._decompress = function(out, dd, w, h) {
    var time = Date.now();
    var bpp = $6ee893d66c44e557$var$UPNG.decode._getBPP(out), bpl = Math.ceil(w * bpp / 8), buff = new Uint8Array((bpl + 1 + out.interlace) * h);
    dd = $6ee893d66c44e557$var$UPNG.decode._inflate(dd, buff);
    //console.log(dd.length, buff.length);
    //console.log(Date.now()-time);
    var time = Date.now();
    if (out.interlace == 0) dd = $6ee893d66c44e557$var$UPNG.decode._filterZero(dd, out, 0, w, h);
    else if (out.interlace == 1) dd = $6ee893d66c44e557$var$UPNG.decode._readInterlace(dd, out);
    //console.log(Date.now()-time);
    return dd;
};
$6ee893d66c44e557$var$UPNG.decode._inflate = function(data, buff) {
    var out = $6ee893d66c44e557$var$UPNG["inflateRaw"](new Uint8Array(data.buffer, 2, data.length - 6), buff);
    return out;
};
$6ee893d66c44e557$var$UPNG.inflateRaw = function() {
    var H = {};
    H.H = {};
    H.H.N = function(N, W) {
        var R = Uint8Array, i = 0, m = 0, J = 0, h = 0, Q = 0, X = 0, u = 0, w = 0, d = 0, v, C;
        if (N[0] == 3 && N[1] == 0) return W ? W : new R(0);
        var V = H.H, n = V.b, A = V.e, l = V.R, M = V.n, I = V.A, e = V.Z, b = V.m, Z = W == null;
        if (Z) W = new R(N.length >>> 2 << 3);
        while(i == 0){
            i = n(N, d, 1);
            m = n(N, d + 1, 2);
            d += 3;
            if (m == 0) {
                if ((d & 7) != 0) d += 8 - (d & 7);
                var D = (d >>> 3) + 4, q = N[D - 4] | N[D - 3] << 8;
                if (Z) W = H.H.W(W, w + q);
                W.set(new R(N.buffer, N.byteOffset + D, q), w);
                d = D + q << 3;
                w += q;
                continue;
            }
            if (Z) W = H.H.W(W, w + 131072);
            if (m == 1) {
                v = b.J;
                C = b.h;
                X = 511;
                u = 31;
            }
            if (m == 2) {
                J = A(N, d, 5) + 257;
                h = A(N, d + 5, 5) + 1;
                Q = A(N, d + 10, 4) + 4;
                d += 14;
                var E = d, j = 1;
                for(var c = 0; c < 38; c += 2){
                    b.Q[c] = 0;
                    b.Q[c + 1] = 0;
                }
                for(var c = 0; c < Q; c++){
                    var K = A(N, d + c * 3, 3);
                    b.Q[(b.X[c] << 1) + 1] = K;
                    if (K > j) j = K;
                }
                d += 3 * Q;
                M(b.Q, j);
                I(b.Q, j, b.u);
                v = b.w;
                C = b.d;
                d = l(b.u, (1 << j) - 1, J + h, N, d, b.v);
                var r = V.V(b.v, 0, J, b.C);
                X = (1 << r) - 1;
                var S = V.V(b.v, J, h, b.D);
                u = (1 << S) - 1;
                M(b.C, r);
                I(b.C, r, v);
                M(b.D, S);
                I(b.D, S, C);
            }
            while(true){
                var T = v[e(N, d) & X];
                d += T & 15;
                var p = T >>> 4;
                if (p >>> 8 == 0) W[w++] = p;
                else if (p == 256) break;
                else {
                    var z = w + p - 254;
                    if (p > 264) {
                        var _ = b.q[p - 257];
                        z = w + (_ >>> 3) + A(N, d, _ & 7);
                        d += _ & 7;
                    }
                    var $ = C[e(N, d) & u];
                    d += $ & 15;
                    var s = $ >>> 4, Y = b.c[s], a = (Y >>> 4) + n(N, d, Y & 15);
                    d += Y & 15;
                    while(w < z){
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                    }
                    w = z;
                }
            }
        }
        return W.length == w ? W : W.slice(0, w);
    };
    H.H.W = function(N, W) {
        var R = N.length;
        if (W <= R) return N;
        var V = new Uint8Array(R << 1);
        V.set(N, 0);
        return V;
    };
    H.H.R = function(N, W, R, V, n, A) {
        var l = H.H.e, M = H.H.Z, I = 0;
        while(I < R){
            var e = N[M(V, n) & W];
            n += e & 15;
            var b = e >>> 4;
            if (b <= 15) {
                A[I] = b;
                I++;
            } else {
                var Z = 0, m = 0;
                if (b == 16) {
                    m = 3 + l(V, n, 2);
                    n += 2;
                    Z = A[I - 1];
                } else if (b == 17) {
                    m = 3 + l(V, n, 3);
                    n += 3;
                } else if (b == 18) {
                    m = 11 + l(V, n, 7);
                    n += 7;
                }
                var J = I + m;
                while(I < J){
                    A[I] = Z;
                    I++;
                }
            }
        }
        return n;
    };
    H.H.V = function(N, W, R, V) {
        var n = 0, A = 0, l = V.length >>> 1;
        while(A < R){
            var M = N[A + W];
            V[A << 1] = 0;
            V[(A << 1) + 1] = M;
            if (M > n) n = M;
            A++;
        }
        while(A < l){
            V[A << 1] = 0;
            V[(A << 1) + 1] = 0;
            A++;
        }
        return n;
    };
    H.H.n = function(N, W) {
        var R = H.H.m, V = N.length, n, A, l, M, I, e = R.j;
        for(var M = 0; M <= W; M++)e[M] = 0;
        for(M = 1; M < V; M += 2)e[N[M]]++;
        var b = R.K;
        n = 0;
        e[0] = 0;
        for(A = 1; A <= W; A++){
            n = n + e[A - 1] << 1;
            b[A] = n;
        }
        for(l = 0; l < V; l += 2){
            I = N[l + 1];
            if (I != 0) {
                N[l] = b[I];
                b[I]++;
            }
        }
    };
    H.H.A = function(N, W, R) {
        var V = N.length, n = H.H.m, A = n.r;
        for(var l = 0; l < V; l += 2)if (N[l + 1] != 0) {
            var M = l >> 1, I = N[l + 1], e = M << 4 | I, b = W - I, Z = N[l] << b, m = Z + (1 << b);
            while(Z != m){
                var J = A[Z] >>> 15 - W;
                R[J] = e;
                Z++;
            }
        }
    };
    H.H.l = function(N, W) {
        var R = H.H.m.r, V = 15 - W;
        for(var n = 0; n < N.length; n += 2){
            var A = N[n] << W - N[n + 1];
            N[n] = R[A] >>> V;
        }
    };
    H.H.M = function(N, W, R) {
        R = R << (W & 7);
        var V = W >>> 3;
        N[V] |= R;
        N[V + 1] |= R >>> 8;
    };
    H.H.I = function(N, W, R) {
        R = R << (W & 7);
        var V = W >>> 3;
        N[V] |= R;
        N[V + 1] |= R >>> 8;
        N[V + 2] |= R >>> 16;
    };
    H.H.e = function(N, W, R) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8) >>> (W & 7) & (1 << R) - 1;
    };
    H.H.b = function(N, W, R) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7) & (1 << R) - 1;
    };
    H.H.Z = function(N, W) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7);
    };
    H.H.i = function(N, W) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16 | N[(W >>> 3) + 3] << 24) >>> (W & 7);
    };
    H.H.m = function() {
        var N = Uint16Array, W = Uint32Array;
        return {
            K: new N(16),
            j: new N(16),
            X: [
                16,
                17,
                18,
                0,
                8,
                7,
                9,
                6,
                10,
                5,
                11,
                4,
                12,
                3,
                13,
                2,
                14,
                1,
                15
            ],
            S: [
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                13,
                15,
                17,
                19,
                23,
                27,
                31,
                35,
                43,
                51,
                59,
                67,
                83,
                99,
                115,
                131,
                163,
                195,
                227,
                258,
                999,
                999,
                999
            ],
            T: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                1,
                1,
                1,
                2,
                2,
                2,
                2,
                3,
                3,
                3,
                3,
                4,
                4,
                4,
                4,
                5,
                5,
                5,
                5,
                0,
                0,
                0,
                0
            ],
            q: new N(32),
            p: [
                1,
                2,
                3,
                4,
                5,
                7,
                9,
                13,
                17,
                25,
                33,
                49,
                65,
                97,
                129,
                193,
                257,
                385,
                513,
                769,
                1025,
                1537,
                2049,
                3073,
                4097,
                6145,
                8193,
                12289,
                16385,
                24577,
                65535,
                65535
            ],
            z: [
                0,
                0,
                0,
                0,
                1,
                1,
                2,
                2,
                3,
                3,
                4,
                4,
                5,
                5,
                6,
                6,
                7,
                7,
                8,
                8,
                9,
                9,
                10,
                10,
                11,
                11,
                12,
                12,
                13,
                13,
                0,
                0
            ],
            c: new W(32),
            J: new N(512),
            _: [],
            h: new N(32),
            $: [],
            w: new N(32768),
            C: [],
            v: [],
            d: new N(32768),
            D: [],
            u: new N(512),
            Q: [],
            r: new N(32768),
            s: new W(286),
            Y: new W(30),
            a: new W(19),
            t: new W(15e3),
            k: new N(65536),
            g: new N(32768)
        };
    }();
    (function() {
        var N = H.H.m, W = 32768;
        for(var R = 0; R < W; R++){
            var V = R;
            V = (V & 2863311530) >>> 1 | (V & 1431655765) << 1;
            V = (V & 3435973836) >>> 2 | (V & 858993459) << 2;
            V = (V & 4042322160) >>> 4 | (V & 252645135) << 4;
            V = (V & 4278255360) >>> 8 | (V & 16711935) << 8;
            N.r[R] = (V >>> 16 | V << 16) >>> 17;
        }
        function n(A, l, M) {
            while(l-- != 0)A.push(0, M);
        }
        for(var R = 0; R < 32; R++){
            N.q[R] = N.S[R] << 3 | N.T[R];
            N.c[R] = N.p[R] << 4 | N.z[R];
        }
        n(N._, 144, 8);
        n(N._, 112, 9);
        n(N._, 24, 7);
        n(N._, 8, 8);
        H.H.n(N._, 9);
        H.H.A(N._, 9, N.J);
        H.H.l(N._, 9);
        n(N.$, 32, 5);
        H.H.n(N.$, 5);
        H.H.A(N.$, 5, N.h);
        H.H.l(N.$, 5);
        n(N.Q, 19, 0);
        n(N.C, 286, 0);
        n(N.D, 30, 0);
        n(N.v, 320, 0);
    })();
    return H.H.N;
}();
$6ee893d66c44e557$var$UPNG.decode._readInterlace = function(data, out) {
    var w = out.width, h = out.height;
    var bpp = $6ee893d66c44e557$var$UPNG.decode._getBPP(out), cbpp = bpp >> 3, bpl = Math.ceil(w * bpp / 8);
    var img = new Uint8Array(h * bpl);
    var di = 0;
    var starting_row = [
        0,
        0,
        4,
        0,
        2,
        0,
        1
    ];
    var starting_col = [
        0,
        4,
        0,
        2,
        0,
        1,
        0
    ];
    var row_increment = [
        8,
        8,
        8,
        4,
        4,
        2,
        2
    ];
    var col_increment = [
        8,
        8,
        4,
        4,
        2,
        2,
        1
    ];
    var pass = 0;
    while(pass < 7){
        var ri = row_increment[pass], ci = col_increment[pass];
        var sw = 0, sh = 0;
        var cr = starting_row[pass];
        while(cr < h){
            cr += ri;
            sh++;
        }
        var cc = starting_col[pass];
        while(cc < w){
            cc += ci;
            sw++;
        }
        var bpll = Math.ceil(sw * bpp / 8);
        $6ee893d66c44e557$var$UPNG.decode._filterZero(data, out, di, sw, sh);
        var y = 0, row = starting_row[pass];
        while(row < h){
            var col = starting_col[pass];
            var cdi = di + y * bpll << 3;
            while(col < w){
                if (bpp == 1) {
                    var val = data[cdi >> 3];
                    val = val >> 7 - (cdi & 7) & 1;
                    img[row * bpl + (col >> 3)] |= val << 7 - ((col & 7) << 0);
                }
                if (bpp == 2) {
                    var val = data[cdi >> 3];
                    val = val >> 6 - (cdi & 7) & 3;
                    img[row * bpl + (col >> 2)] |= val << 6 - ((col & 3) << 1);
                }
                if (bpp == 4) {
                    var val = data[cdi >> 3];
                    val = val >> 4 - (cdi & 7) & 15;
                    img[row * bpl + (col >> 1)] |= val << 4 - ((col & 1) << 2);
                }
                if (bpp >= 8) {
                    var ii = row * bpl + col * cbpp;
                    for(var j = 0; j < cbpp; j++)img[ii + j] = data[(cdi >> 3) + j];
                }
                cdi += bpp;
                col += ci;
            }
            y++;
            row += ri;
        }
        if (sw * sh != 0) di += sh * (1 + bpll);
        pass = pass + 1;
    }
    return img;
};
$6ee893d66c44e557$var$UPNG.decode._getBPP = function(out) {
    var noc = [
        1,
        null,
        3,
        1,
        2,
        null,
        4
    ][out.ctype];
    return noc * out.depth;
};
$6ee893d66c44e557$var$UPNG.decode._filterZero = function(data, out, off, w, h) {
    var bpp = $6ee893d66c44e557$var$UPNG.decode._getBPP(out), bpl = Math.ceil(w * bpp / 8), paeth = $6ee893d66c44e557$var$UPNG.decode._paeth;
    bpp = Math.ceil(bpp / 8);
    var i = 0, di = 1, type = data[off], x = 0;
    if (type > 1) data[off] = [
        0,
        0,
        1
    ][type - 2];
    if (type == 3) for(x = bpp; x < bpl; x++)data[x + 1] = data[x + 1] + (data[x + 1 - bpp] >>> 1) & 255;
    for(var y = 0; y < h; y++){
        i = off + y * bpl;
        di = i + y + 1;
        type = data[di - 1];
        x = 0;
        if (type == 0) for(; x < bpl; x++)data[i + x] = data[di + x];
        else if (type == 1) {
            for(; x < bpp; x++)data[i + x] = data[di + x];
            for(; x < bpl; x++)data[i + x] = data[di + x] + data[i + x - bpp];
        } else if (type == 2) for(; x < bpl; x++)data[i + x] = data[di + x] + data[i + x - bpl];
        else if (type == 3) {
            for(; x < bpp; x++)data[i + x] = data[di + x] + (data[i + x - bpl] >>> 1);
            for(; x < bpl; x++)data[i + x] = data[di + x] + (data[i + x - bpl] + data[i + x - bpp] >>> 1);
        } else {
            for(; x < bpp; x++)data[i + x] = data[di + x] + paeth(0, data[i + x - bpl], 0);
            for(; x < bpl; x++)data[i + x] = data[di + x] + paeth(data[i + x - bpp], data[i + x - bpl], data[i + x - bpp - bpl]);
        }
    }
    return data;
};
$6ee893d66c44e557$var$UPNG.decode._paeth = function(a, b, c) {
    var p = a + b - c, pa = p - a, pb = p - b, pc = p - c;
    if (pa * pa <= pb * pb && pa * pa <= pc * pc) return a;
    else if (pb * pb <= pc * pc) return b;
    return c;
};
$6ee893d66c44e557$var$UPNG.decode._IHDR = function(data, offset, out) {
    var bin = $6ee893d66c44e557$var$UPNG._bin;
    out.width = bin.readUint(data, offset);
    offset += 4;
    out.height = bin.readUint(data, offset);
    offset += 4;
    out.depth = data[offset];
    offset++;
    out.ctype = data[offset];
    offset++;
    out.compress = data[offset];
    offset++;
    out.filter = data[offset];
    offset++;
    out.interlace = data[offset];
    offset++;
};
$6ee893d66c44e557$var$UPNG._bin = {
    nextZero: function(data, p) {
        while(data[p] != 0)p++;
        return p;
    },
    readUshort: function(buff, p) {
        return buff[p] << 8 | buff[p + 1];
    },
    writeUshort: function(buff, p, n) {
        buff[p] = n >> 8 & 255;
        buff[p + 1] = n & 255;
    },
    readUint: function(buff, p) {
        return buff[p] * 16777216 + (buff[p + 1] << 16 | buff[p + 2] << 8 | buff[p + 3]);
    },
    writeUint: function(buff, p, n) {
        buff[p] = n >> 24 & 255;
        buff[p + 1] = n >> 16 & 255;
        buff[p + 2] = n >> 8 & 255;
        buff[p + 3] = n & 255;
    },
    readASCII: function(buff, p, l) {
        var s = "";
        for(var i = 0; i < l; i++)s += String.fromCharCode(buff[p + i]);
        return s;
    },
    writeASCII: function(data, p, s) {
        for(var i = 0; i < s.length; i++)data[p + i] = s.charCodeAt(i);
    },
    readBytes: function(buff, p, l) {
        var arr = [];
        for(var i = 0; i < l; i++)arr.push(buff[p + i]);
        return arr;
    },
    pad: function(n) {
        return n.length < 2 ? "0" + n : n;
    },
    readUTF8: function(buff, p, l) {
        var s = "", ns;
        for(var i = 0; i < l; i++)s += "%" + $6ee893d66c44e557$var$UPNG._bin.pad(buff[p + i].toString(16));
        try {
            ns = decodeURIComponent(s);
        } catch (e) {
            return $6ee893d66c44e557$var$UPNG._bin.readASCII(buff, p, l);
        }
        return ns;
    }
};
$6ee893d66c44e557$var$UPNG._copyTile = function(sb, sw, sh, tb, tw, th, xoff, yoff, mode) {
    var w = Math.min(sw, tw), h = Math.min(sh, th);
    var si = 0, ti = 0;
    for(var y = 0; y < h; y++)for(var x = 0; x < w; x++){
        if (xoff >= 0 && yoff >= 0) {
            si = y * sw + x << 2;
            ti = (yoff + y) * tw + xoff + x << 2;
        } else {
            si = (-yoff + y) * sw - xoff + x << 2;
            ti = y * tw + x << 2;
        }
        if (mode == 0) {
            tb[ti] = sb[si];
            tb[ti + 1] = sb[si + 1];
            tb[ti + 2] = sb[si + 2];
            tb[ti + 3] = sb[si + 3];
        } else if (mode == 1) {
            var fa = sb[si + 3] * (1 / 255), fr = sb[si] * fa, fg = sb[si + 1] * fa, fb = sb[si + 2] * fa;
            var ba = tb[ti + 3] * (1 / 255), br = tb[ti] * ba, bg = tb[ti + 1] * ba, bb = tb[ti + 2] * ba;
            var ifa = 1 - fa, oa = fa + ba * ifa, ioa = oa == 0 ? 0 : 1 / oa;
            tb[ti + 3] = 255 * oa;
            tb[ti + 0] = (fr + br * ifa) * ioa;
            tb[ti + 1] = (fg + bg * ifa) * ioa;
            tb[ti + 2] = (fb + bb * ifa) * ioa;
        } else if (mode == 2) {
            var fa = sb[si + 3], fr = sb[si], fg = sb[si + 1], fb = sb[si + 2];
            var ba = tb[ti + 3], br = tb[ti], bg = tb[ti + 1], bb = tb[ti + 2];
            if (fa == ba && fr == br && fg == bg && fb == bb) {
                tb[ti] = 0;
                tb[ti + 1] = 0;
                tb[ti + 2] = 0;
                tb[ti + 3] = 0;
            } else {
                tb[ti] = fr;
                tb[ti + 1] = fg;
                tb[ti + 2] = fb;
                tb[ti + 3] = fa;
            }
        } else if (mode == 3) {
            var fa = sb[si + 3], fr = sb[si], fg = sb[si + 1], fb = sb[si + 2];
            var ba = tb[ti + 3], br = tb[ti], bg = tb[ti + 1], bb = tb[ti + 2];
            if (fa == ba && fr == br && fg == bg && fb == bb) continue;
            //if(fa!=255 && ba!=0) return false;
            if (fa < 220 && ba > 20) return false;
        }
    }
    return true;
};
$6ee893d66c44e557$var$UPNG.encode = function(bufs, w, h, ps, dels, tabs, forbidPlte) {
    if (ps == null) ps = 0;
    if (forbidPlte == null) forbidPlte = false;
    var nimg = $6ee893d66c44e557$var$UPNG.encode.compress(bufs, w, h, ps, [
        false,
        false,
        false,
        0,
        forbidPlte
    ]);
    $6ee893d66c44e557$var$UPNG.encode.compressPNG(nimg, -1);
    return $6ee893d66c44e557$var$UPNG.encode._main(nimg, w, h, dels, tabs);
};
$6ee893d66c44e557$var$UPNG.encodeLL = function(bufs, w, h, cc, ac, depth, dels, tabs) {
    var nimg = {
        ctype: 0 + (cc == 1 ? 0 : 2) + (ac == 0 ? 0 : 4),
        depth: depth,
        frames: []
    };
    var time = Date.now();
    var bipp = (cc + ac) * depth, bipl = bipp * w;
    for(var i = 0; i < bufs.length; i++)nimg.frames.push({
        rect: {
            x: 0,
            y: 0,
            width: w,
            height: h
        },
        img: new Uint8Array(bufs[i]),
        blend: 0,
        dispose: 1,
        bpp: Math.ceil(bipp / 8),
        bpl: Math.ceil(bipl / 8)
    });
    $6ee893d66c44e557$var$UPNG.encode.compressPNG(nimg, 0, true);
    var out = $6ee893d66c44e557$var$UPNG.encode._main(nimg, w, h, dels, tabs);
    return out;
};
$6ee893d66c44e557$var$UPNG.encode._main = function(nimg, w, h, dels, tabs) {
    if (tabs == null) tabs = {};
    var crc = $6ee893d66c44e557$var$UPNG.crc.crc, wUi = $6ee893d66c44e557$var$UPNG._bin.writeUint, wUs = $6ee893d66c44e557$var$UPNG._bin.writeUshort, wAs = $6ee893d66c44e557$var$UPNG._bin.writeASCII;
    var offset = 8, anim = nimg.frames.length > 1, pltAlpha = false;
    var leng = 33 + (anim ? 20 : 0);
    if (tabs["sRGB"] != null) leng += 13;
    if (tabs["pHYs"] != null) leng += 21;
    if (nimg.ctype == 3) {
        var dl = nimg.plte.length;
        for(var i = 0; i < dl; i++)if (nimg.plte[i] >>> 24 != 255) pltAlpha = true;
        leng += 8 + dl * 3 + 4 + (pltAlpha ? 8 + dl * 1 + 4 : 0);
    }
    for(var j = 0; j < nimg.frames.length; j++){
        var fr = nimg.frames[j];
        if (anim) leng += 38;
        leng += fr.cimg.length + 12;
        if (j != 0) leng += 4;
    }
    leng += 12;
    var data = new Uint8Array(leng);
    var wr = [
        0x89,
        0x50,
        0x4e,
        0x47,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ];
    for(var i = 0; i < 8; i++)data[i] = wr[i];
    wUi(data, offset, 13);
    offset += 4;
    wAs(data, offset, "IHDR");
    offset += 4;
    wUi(data, offset, w);
    offset += 4;
    wUi(data, offset, h);
    offset += 4;
    data[offset] = nimg.depth;
    offset++; // depth
    data[offset] = nimg.ctype;
    offset++; // ctype
    data[offset] = 0;
    offset++; // compress
    data[offset] = 0;
    offset++; // filter
    data[offset] = 0;
    offset++; // interlace
    wUi(data, offset, crc(data, offset - 17, 17));
    offset += 4; // crc
    // 13 bytes to say, that it is sRGB
    if (tabs["sRGB"] != null) {
        wUi(data, offset, 1);
        offset += 4;
        wAs(data, offset, "sRGB");
        offset += 4;
        data[offset] = tabs["sRGB"];
        offset++;
        wUi(data, offset, crc(data, offset - 5, 5));
        offset += 4; // crc
    }
    if (tabs["pHYs"] != null) {
        wUi(data, offset, 9);
        offset += 4;
        wAs(data, offset, "pHYs");
        offset += 4;
        wUi(data, offset, tabs["pHYs"][0]);
        offset += 4;
        wUi(data, offset, tabs["pHYs"][1]);
        offset += 4;
        data[offset] = tabs["pHYs"][2];
        offset++;
        wUi(data, offset, crc(data, offset - 13, 13));
        offset += 4; // crc
    }
    if (anim) {
        wUi(data, offset, 8);
        offset += 4;
        wAs(data, offset, "acTL");
        offset += 4;
        wUi(data, offset, nimg.frames.length);
        offset += 4;
        wUi(data, offset, tabs["loop"] != null ? tabs["loop"] : 0);
        offset += 4;
        wUi(data, offset, crc(data, offset - 12, 12));
        offset += 4; // crc
    }
    if (nimg.ctype == 3) {
        var dl = nimg.plte.length;
        wUi(data, offset, dl * 3);
        offset += 4;
        wAs(data, offset, "PLTE");
        offset += 4;
        for(var i = 0; i < dl; i++){
            var ti = i * 3, c = nimg.plte[i], r = c & 255, g = c >>> 8 & 255, b = c >>> 16 & 255;
            data[offset + ti + 0] = r;
            data[offset + ti + 1] = g;
            data[offset + ti + 2] = b;
        }
        offset += dl * 3;
        wUi(data, offset, crc(data, offset - dl * 3 - 4, dl * 3 + 4));
        offset += 4; // crc
        if (pltAlpha) {
            wUi(data, offset, dl);
            offset += 4;
            wAs(data, offset, "tRNS");
            offset += 4;
            for(var i = 0; i < dl; i++)data[offset + i] = nimg.plte[i] >>> 24 & 255;
            offset += dl;
            wUi(data, offset, crc(data, offset - dl - 4, dl + 4));
            offset += 4; // crc
        }
    }
    var fi = 0;
    for(var j = 0; j < nimg.frames.length; j++){
        var fr = nimg.frames[j];
        if (anim) {
            wUi(data, offset, 26);
            offset += 4;
            wAs(data, offset, "fcTL");
            offset += 4;
            wUi(data, offset, fi++);
            offset += 4;
            wUi(data, offset, fr.rect.width);
            offset += 4;
            wUi(data, offset, fr.rect.height);
            offset += 4;
            wUi(data, offset, fr.rect.x);
            offset += 4;
            wUi(data, offset, fr.rect.y);
            offset += 4;
            wUs(data, offset, dels[j]);
            offset += 2;
            wUs(data, offset, 1000);
            offset += 2;
            data[offset] = fr.dispose;
            offset++; // dispose
            data[offset] = fr.blend;
            offset++; // blend
            wUi(data, offset, crc(data, offset - 30, 30));
            offset += 4; // crc
        }
        var imgd = fr.cimg, dl = imgd.length;
        wUi(data, offset, dl + (j == 0 ? 0 : 4));
        offset += 4;
        var ioff = offset;
        wAs(data, offset, j == 0 ? "IDAT" : "fdAT");
        offset += 4;
        if (j != 0) {
            wUi(data, offset, fi++);
            offset += 4;
        }
        data.set(imgd, offset);
        offset += dl;
        wUi(data, offset, crc(data, ioff, offset - ioff));
        offset += 4; // crc
    }
    wUi(data, offset, 0);
    offset += 4;
    wAs(data, offset, "IEND");
    offset += 4;
    wUi(data, offset, crc(data, offset - 4, 4));
    offset += 4; // crc
    return data.buffer;
};
$6ee893d66c44e557$var$UPNG.encode.compressPNG = function(out, filter, levelZero) {
    for(var i = 0; i < out.frames.length; i++){
        var frm = out.frames[i], nw = frm.rect.width, nh = frm.rect.height;
        var fdata = new Uint8Array(nh * frm.bpl + nh);
        frm.cimg = $6ee893d66c44e557$var$UPNG.encode._filterZero(frm.img, nh, frm.bpp, frm.bpl, fdata, filter, levelZero);
    }
};
$6ee893d66c44e557$var$UPNG.encode.compress = function(bufs, w, h, ps, prms) {
    //var time = Date.now();
    var onlyBlend = prms[0], evenCrd = prms[1], forbidPrev = prms[2], minBits = prms[3], forbidPlte = prms[4];
    var ctype = 6, depth = 8, alphaAnd = 255;
    for(var j = 0; j < bufs.length; j++){
        var img = new Uint8Array(bufs[j]), ilen = img.length;
        for(var i = 0; i < ilen; i += 4)alphaAnd &= img[i + 3];
    }
    var gotAlpha = alphaAnd != 255;
    //console.log("alpha check", Date.now()-time);  time = Date.now();
    //var brute = gotAlpha && forGIF;		// brute : frames can only be copied, not "blended"
    var frms = $6ee893d66c44e557$var$UPNG.encode.framize(bufs, w, h, onlyBlend, evenCrd, forbidPrev);
    //console.log("framize", Date.now()-time);  time = Date.now();
    var cmap = {}, plte = [], inds = [];
    if (ps != 0) {
        var nbufs = [];
        for(var i = 0; i < frms.length; i++)nbufs.push(frms[i].img.buffer);
        var abuf = $6ee893d66c44e557$var$UPNG.encode.concatRGBA(nbufs), qres = $6ee893d66c44e557$var$UPNG.quantize(abuf, ps);
        var cof = 0, bb = new Uint8Array(qres.abuf);
        for(var i = 0; i < frms.length; i++){
            var ti = frms[i].img, bln = ti.length;
            inds.push(new Uint8Array(qres.inds.buffer, cof >> 2, bln >> 2));
            for(var j = 0; j < bln; j += 4){
                ti[j] = bb[cof + j];
                ti[j + 1] = bb[cof + j + 1];
                ti[j + 2] = bb[cof + j + 2];
                ti[j + 3] = bb[cof + j + 3];
            }
            cof += bln;
        }
        for(var i = 0; i < qres.plte.length; i++)plte.push(qres.plte[i].est.rgba);
    //console.log("quantize", Date.now()-time);  time = Date.now();
    } else // what if ps==0, but there are <=256 colors?  we still need to detect, if the palette could be used
    for(var j = 0; j < frms.length; j++){
        var frm = frms[j], img32 = new Uint32Array(frm.img.buffer), nw = frm.rect.width, ilen = img32.length;
        var ind = new Uint8Array(ilen);
        inds.push(ind);
        for(var i = 0; i < ilen; i++){
            var c = img32[i];
            if (i != 0 && c == img32[i - 1]) ind[i] = ind[i - 1];
            else if (i > nw && c == img32[i - nw]) ind[i] = ind[i - nw];
            else {
                var cmc = cmap[c];
                if (cmc == null) {
                    cmap[c] = cmc = plte.length;
                    plte.push(c);
                    if (plte.length >= 300) break;
                }
                ind[i] = cmc;
            }
        }
    }
    var cc = plte.length; //console.log("colors:",cc);
    if (cc <= 256 && forbidPlte == false) {
        if (cc <= 2) depth = 1;
        else if (cc <= 4) depth = 2;
        else if (cc <= 16) depth = 4;
        else depth = 8;
        depth = Math.max(depth, minBits);
    }
    for(var j = 0; j < frms.length; j++){
        var frm = frms[j], nx = frm.rect.x, ny = frm.rect.y, nw = frm.rect.width, nh = frm.rect.height;
        var cimg = frm.img, cimg32 = new Uint32Array(cimg.buffer);
        var bpl = 4 * nw, bpp = 4;
        if (cc <= 256 && forbidPlte == false) {
            bpl = Math.ceil(depth * nw / 8);
            var nimg = new Uint8Array(bpl * nh);
            var inj = inds[j];
            for(var y = 0; y < nh; y++){
                var i = y * bpl, ii = y * nw;
                if (depth == 8) for(var x = 0; x < nw; x++)nimg[i + x] = inj[ii + x];
                else if (depth == 4) for(var x = 0; x < nw; x++)nimg[i + (x >> 1)] |= inj[ii + x] << 4 - (x & 1) * 4;
                else if (depth == 2) for(var x = 0; x < nw; x++)nimg[i + (x >> 2)] |= inj[ii + x] << 6 - (x & 3) * 2;
                else if (depth == 1) for(var x = 0; x < nw; x++)nimg[i + (x >> 3)] |= inj[ii + x] << 7 - (x & 7) * 1;
            }
            cimg = nimg;
            ctype = 3;
            bpp = 1;
        } else if (gotAlpha == false && frms.length == 1) {
            var nimg = new Uint8Array(nw * nh * 3), area = nw * nh;
            for(var i = 0; i < area; i++){
                var ti = i * 3, qi = i * 4;
                nimg[ti] = cimg[qi];
                nimg[ti + 1] = cimg[qi + 1];
                nimg[ti + 2] = cimg[qi + 2];
            }
            cimg = nimg;
            ctype = 2;
            bpp = 3;
            bpl = 3 * nw;
        }
        frm.img = cimg;
        frm.bpl = bpl;
        frm.bpp = bpp;
    }
    //console.log("colors => palette indices", Date.now()-time);  time = Date.now();
    return {
        ctype: ctype,
        depth: depth,
        plte: plte,
        frames: frms
    };
};
$6ee893d66c44e557$var$UPNG.encode.framize = function(bufs, w, h, alwaysBlend, evenCrd, forbidPrev) {
    /*  DISPOSE
	    - 0 : no change
		- 1 : clear to transparent
		- 2 : retstore to content before rendering (previous frame disposed)
		BLEND
		- 0 : replace
		- 1 : blend
	*/ var frms = [];
    for(var j = 0; j < bufs.length; j++){
        var cimg = new Uint8Array(bufs[j]), cimg32 = new Uint32Array(cimg.buffer);
        var nimg;
        var nx = 0, ny = 0, nw = w, nh = h, blend = alwaysBlend ? 1 : 0;
        if (j != 0) {
            var tlim = forbidPrev || alwaysBlend || j == 1 || frms[j - 2].dispose != 0 ? 1 : 2, tstp = 0, tarea = 1e9;
            for(var it = 0; it < tlim; it++){
                var pimg = new Uint8Array(bufs[j - 1 - it]), p32 = new Uint32Array(bufs[j - 1 - it]);
                var mix = w, miy = h, max = -1, may = -1;
                for(var y = 0; y < h; y++)for(var x = 0; x < w; x++){
                    var i = y * w + x;
                    if (cimg32[i] != p32[i]) {
                        if (x < mix) mix = x;
                        if (x > max) max = x;
                        if (y < miy) miy = y;
                        if (y > may) may = y;
                    }
                }
                if (max == -1) mix = miy = max = may = 0;
                if (evenCrd) {
                    if ((mix & 1) == 1) mix--;
                    if ((miy & 1) == 1) miy--;
                }
                var sarea = (max - mix + 1) * (may - miy + 1);
                if (sarea < tarea) {
                    tarea = sarea;
                    tstp = it;
                    nx = mix;
                    ny = miy;
                    nw = max - mix + 1;
                    nh = may - miy + 1;
                }
            }
            // alwaysBlend: pokud zjistím, že blendit nelze, nastavím předchozímu snímku dispose=1. Zajistím, aby obsahoval můj obdélník.
            var pimg = new Uint8Array(bufs[j - 1 - tstp]);
            if (tstp == 1) frms[j - 1].dispose = 2;
            nimg = new Uint8Array(nw * nh * 4);
            $6ee893d66c44e557$var$UPNG._copyTile(pimg, w, h, nimg, nw, nh, -nx, -ny, 0);
            blend = $6ee893d66c44e557$var$UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 3) ? 1 : 0;
            if (blend == 1) $6ee893d66c44e557$var$UPNG.encode._prepareDiff(cimg, w, h, nimg, {
                x: nx,
                y: ny,
                width: nw,
                height: nh
            });
            else $6ee893d66c44e557$var$UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 0);
        //UPNG._copyTile(cimg,w,h, nimg,nw,nh, -nx,-ny, blend==1?2:0);
        } else nimg = cimg.slice(0); // img may be rewritten further ... don't rewrite input
        frms.push({
            rect: {
                x: nx,
                y: ny,
                width: nw,
                height: nh
            },
            img: nimg,
            blend: blend,
            dispose: 0
        });
    }
    if (alwaysBlend) for(var j = 0; j < frms.length; j++){
        var frm = frms[j];
        if (frm.blend == 1) continue;
        var r0 = frm.rect, r1 = frms[j - 1].rect;
        var miX = Math.min(r0.x, r1.x), miY = Math.min(r0.y, r1.y);
        var maX = Math.max(r0.x + r0.width, r1.x + r1.width), maY = Math.max(r0.y + r0.height, r1.y + r1.height);
        var r = {
            x: miX,
            y: miY,
            width: maX - miX,
            height: maY - miY
        };
        frms[j - 1].dispose = 1;
        if (j - 1 != 0) $6ee893d66c44e557$var$UPNG.encode._updateFrame(bufs, w, h, frms, j - 1, r, evenCrd);
        $6ee893d66c44e557$var$UPNG.encode._updateFrame(bufs, w, h, frms, j, r, evenCrd);
    }
    var area = 0;
    if (bufs.length != 1) for(var i = 0; i < frms.length; i++){
        var frm = frms[i];
        area += frm.rect.width * frm.rect.height;
    //if(i==0 || frm.blend!=1) continue;
    //var ob = new Uint8Array(
    //console.log(frm.blend, frm.dispose, frm.rect);
    }
    //if(area!=0) console.log(area);
    return frms;
};
$6ee893d66c44e557$var$UPNG.encode._updateFrame = function(bufs, w, h, frms, i, r, evenCrd) {
    var U8 = Uint8Array, U32 = Uint32Array;
    var pimg = new U8(bufs[i - 1]), pimg32 = new U32(bufs[i - 1]), nimg = i + 1 < bufs.length ? new U8(bufs[i + 1]) : null;
    var cimg = new U8(bufs[i]), cimg32 = new U32(cimg.buffer);
    var mix = w, miy = h, max = -1, may = -1;
    for(var y = 0; y < r.height; y++)for(var x = 0; x < r.width; x++){
        var cx = r.x + x, cy = r.y + y;
        var j = cy * w + cx, cc = cimg32[j];
        // no need to draw transparency, or to dispose it. Or, if writing the same color and the next one does not need transparency.
        if (cc == 0 || frms[i - 1].dispose == 0 && pimg32[j] == cc && (nimg == null || nimg[j * 4 + 3] != 0)) ;
        else {
            if (cx < mix) mix = cx;
            if (cx > max) max = cx;
            if (cy < miy) miy = cy;
            if (cy > may) may = cy;
        }
    }
    if (max == -1) mix = miy = max = may = 0;
    if (evenCrd) {
        if ((mix & 1) == 1) mix--;
        if ((miy & 1) == 1) miy--;
    }
    r = {
        x: mix,
        y: miy,
        width: max - mix + 1,
        height: may - miy + 1
    };
    var fr = frms[i];
    fr.rect = r;
    fr.blend = 1;
    fr.img = new Uint8Array(r.width * r.height * 4);
    if (frms[i - 1].dispose == 0) {
        $6ee893d66c44e557$var$UPNG._copyTile(pimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
        $6ee893d66c44e557$var$UPNG.encode._prepareDiff(cimg, w, h, fr.img, r);
    //UPNG._copyTile(cimg,w,h, fr.img,r.width,r.height, -r.x,-r.y, 2);
    } else $6ee893d66c44e557$var$UPNG._copyTile(cimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
};
$6ee893d66c44e557$var$UPNG.encode._prepareDiff = function(cimg, w, h, nimg, rec) {
    $6ee893d66c44e557$var$UPNG._copyTile(cimg, w, h, nimg, rec.width, rec.height, -rec.x, -rec.y, 2);
/*
	var n32 = new Uint32Array(nimg.buffer);
	var og = new Uint8Array(rec.width*rec.height*4), o32 = new Uint32Array(og.buffer);
	UPNG._copyTile(cimg,w,h, og,rec.width,rec.height, -rec.x,-rec.y, 0);
	for(var i=4; i<nimg.length; i+=4) {
		if(nimg[i-1]!=0 && nimg[i+3]==0 && o32[i>>>2]==o32[(i>>>2)-1]) {
			n32[i>>>2]=o32[i>>>2];
			//var j = i, c=p32[(i>>>2)-1];
			//while(p32[j>>>2]==c) {  n32[j>>>2]=c;  j+=4;  }
		}
	}
	for(var i=nimg.length-8; i>0; i-=4) {
		if(nimg[i+7]!=0 && nimg[i+3]==0 && o32[i>>>2]==o32[(i>>>2)+1]) {
			n32[i>>>2]=o32[i>>>2];
			//var j = i, c=p32[(i>>>2)-1];
			//while(p32[j>>>2]==c) {  n32[j>>>2]=c;  j+=4;  }
		}
	}*/ };
$6ee893d66c44e557$var$UPNG.encode._filterZero = function(img, h, bpp, bpl, data, filter, levelZero) {
    var fls = [], ftry = [
        0,
        1,
        2,
        3,
        4
    ];
    if (filter != -1) ftry = [
        filter
    ];
    else if (h * bpl > 500000 || bpp == 1) ftry = [
        0
    ];
    var opts;
    if (levelZero) opts = {
        level: 0
    };
    var CMPR = levelZero && UZIP != null ? UZIP : (0, (/*@__PURE__*/$parcel$interopDefault($ckCqy)));
    for(var i = 0; i < ftry.length; i++){
        for(var y = 0; y < h; y++)$6ee893d66c44e557$var$UPNG.encode._filterLine(data, img, y, bpl, bpp, ftry[i]);
        //var nimg = new Uint8Array(data.length);
        //var sz = UZIP.F.deflate(data, nimg);  fls.push(nimg.slice(0,sz));
        //var dfl = pako["deflate"](data), dl=dfl.length-4;
        //var crc = (dfl[dl+3]<<24)|(dfl[dl+2]<<16)|(dfl[dl+1]<<8)|(dfl[dl+0]<<0);
        //console.log(crc, UZIP.adler(data,2,data.length-6));
        fls.push(CMPR["deflate"](data, opts));
    }
    var ti, tsize = 1e9;
    for(var i = 0; i < fls.length; i++)if (fls[i].length < tsize) {
        ti = i;
        tsize = fls[i].length;
    }
    return fls[ti];
};
$6ee893d66c44e557$var$UPNG.encode._filterLine = function(data, img, y, bpl, bpp, type) {
    var i = y * bpl, di = i + y, paeth = $6ee893d66c44e557$var$UPNG.decode._paeth;
    data[di] = type;
    di++;
    if (type == 0) {
        if (bpl < 500) for(var x = 0; x < bpl; x++)data[di + x] = img[i + x];
        else data.set(new Uint8Array(img.buffer, i, bpl), di);
    } else if (type == 1) {
        for(var x = 0; x < bpp; x++)data[di + x] = img[i + x];
        for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - img[i + x - bpp] + 256 & 255;
    } else if (y == 0) {
        for(var x = 0; x < bpp; x++)data[di + x] = img[i + x];
        if (type == 2) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x];
        if (type == 3) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - (img[i + x - bpp] >> 1) + 256 & 255;
        if (type == 4) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - paeth(img[i + x - bpp], 0, 0) + 256 & 255;
    } else {
        if (type == 2) for(var x = 0; x < bpl; x++)data[di + x] = img[i + x] + 256 - img[i + x - bpl] & 255;
        if (type == 3) {
            for(var x = 0; x < bpp; x++)data[di + x] = img[i + x] + 256 - (img[i + x - bpl] >> 1) & 255;
            for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] + 256 - (img[i + x - bpl] + img[i + x - bpp] >> 1) & 255;
        }
        if (type == 4) {
            for(var x = 0; x < bpp; x++)data[di + x] = img[i + x] + 256 - paeth(0, img[i + x - bpl], 0) & 255;
            for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] + 256 - paeth(img[i + x - bpp], img[i + x - bpl], img[i + x - bpp - bpl]) & 255;
        }
    }
};
$6ee893d66c44e557$var$UPNG.crc = {
    table: function() {
        var tab = new Uint32Array(256);
        for(var n = 0; n < 256; n++){
            var c = n;
            for(var k = 0; k < 8; k++)if (c & 1) c = 0xedb88320 ^ c >>> 1;
            else c = c >>> 1;
            tab[n] = c;
        }
        return tab;
    }(),
    update: function(c, buf, off, len) {
        for(var i = 0; i < len; i++)c = $6ee893d66c44e557$var$UPNG.crc.table[(c ^ buf[off + i]) & 0xff] ^ c >>> 8;
        return c;
    },
    crc: function(b, o, l) {
        return $6ee893d66c44e557$var$UPNG.crc.update(0xffffffff, b, o, l) ^ 0xffffffff;
    }
};
$6ee893d66c44e557$var$UPNG.quantize = function(abuf, ps) {
    var oimg = new Uint8Array(abuf), nimg = oimg.slice(0), nimg32 = new Uint32Array(nimg.buffer);
    var KD = $6ee893d66c44e557$var$UPNG.quantize.getKDtree(nimg, ps);
    var root = KD[0], leafs = KD[1];
    var planeDst = $6ee893d66c44e557$var$UPNG.quantize.planeDst;
    var sb = oimg, tb = nimg32, len = sb.length;
    var inds = new Uint8Array(oimg.length >> 2);
    for(var i = 0; i < len; i += 4){
        var r = sb[i] * (1 / 255), g = sb[i + 1] * (1 / 255), b = sb[i + 2] * (1 / 255), a = sb[i + 3] * (1 / 255);
        //  exact, but too slow :(
        var nd = $6ee893d66c44e557$var$UPNG.quantize.getNearest(root, r, g, b, a);
        //var nd = root;
        //while(nd.left) nd = (planeDst(nd.est,r,g,b,a)<=0) ? nd.left : nd.right;
        inds[i >> 2] = nd.ind;
        tb[i >> 2] = nd.est.rgba;
    }
    return {
        abuf: nimg.buffer,
        inds: inds,
        plte: leafs
    };
};
$6ee893d66c44e557$var$UPNG.quantize.getKDtree = function(nimg, ps, err) {
    if (err == null) err = 0.0001;
    var nimg32 = new Uint32Array(nimg.buffer);
    var root = {
        i0: 0,
        i1: nimg.length,
        bst: null,
        est: null,
        tdst: 0,
        left: null,
        right: null
    }; // basic statistic, extra statistic
    root.bst = $6ee893d66c44e557$var$UPNG.quantize.stats(nimg, root.i0, root.i1);
    root.est = $6ee893d66c44e557$var$UPNG.quantize.estats(root.bst);
    var leafs = [
        root
    ];
    while(leafs.length < ps){
        var maxL = 0, mi = 0;
        for(var i = 0; i < leafs.length; i++)if (leafs[i].est.L > maxL) {
            maxL = leafs[i].est.L;
            mi = i;
        }
        if (maxL < err) break;
        var node = leafs[mi];
        var s0 = $6ee893d66c44e557$var$UPNG.quantize.splitPixels(nimg, nimg32, node.i0, node.i1, node.est.e, node.est.eMq255);
        var s0wrong = node.i0 >= s0 || node.i1 <= s0;
        //console.log(maxL, leafs.length, mi);
        if (s0wrong) {
            node.est.L = 0;
            continue;
        }
        var ln = {
            i0: node.i0,
            i1: s0,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        ln.bst = $6ee893d66c44e557$var$UPNG.quantize.stats(nimg, ln.i0, ln.i1);
        ln.est = $6ee893d66c44e557$var$UPNG.quantize.estats(ln.bst);
        var rn = {
            i0: s0,
            i1: node.i1,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        rn.bst = {
            R: [],
            m: [],
            N: node.bst.N - ln.bst.N
        };
        for(var i = 0; i < 16; i++)rn.bst.R[i] = node.bst.R[i] - ln.bst.R[i];
        for(var i = 0; i < 4; i++)rn.bst.m[i] = node.bst.m[i] - ln.bst.m[i];
        rn.est = $6ee893d66c44e557$var$UPNG.quantize.estats(rn.bst);
        node.left = ln;
        node.right = rn;
        leafs[mi] = ln;
        leafs.push(rn);
    }
    leafs.sort(function(a, b) {
        return b.bst.N - a.bst.N;
    });
    for(var i = 0; i < leafs.length; i++)leafs[i].ind = i;
    return [
        root,
        leafs
    ];
};
$6ee893d66c44e557$var$UPNG.quantize.getNearest = function(nd, r, g, b, a) {
    if (nd.left == null) {
        nd.tdst = $6ee893d66c44e557$var$UPNG.quantize.dist(nd.est.q, r, g, b, a);
        return nd;
    }
    var planeDst = $6ee893d66c44e557$var$UPNG.quantize.planeDst(nd.est, r, g, b, a);
    var node0 = nd.left, node1 = nd.right;
    if (planeDst > 0) {
        node0 = nd.right;
        node1 = nd.left;
    }
    var ln = $6ee893d66c44e557$var$UPNG.quantize.getNearest(node0, r, g, b, a);
    if (ln.tdst <= planeDst * planeDst) return ln;
    var rn = $6ee893d66c44e557$var$UPNG.quantize.getNearest(node1, r, g, b, a);
    return rn.tdst < ln.tdst ? rn : ln;
};
$6ee893d66c44e557$var$UPNG.quantize.planeDst = function(est, r, g, b, a) {
    var e = est.e;
    return e[0] * r + e[1] * g + e[2] * b + e[3] * a - est.eMq;
};
$6ee893d66c44e557$var$UPNG.quantize.dist = function(q, r, g, b, a) {
    var d0 = r - q[0], d1 = g - q[1], d2 = b - q[2], d3 = a - q[3];
    return d0 * d0 + d1 * d1 + d2 * d2 + d3 * d3;
};
$6ee893d66c44e557$var$UPNG.quantize.splitPixels = function(nimg, nimg32, i0, i1, e, eMq) {
    var vecDot = $6ee893d66c44e557$var$UPNG.quantize.vecDot;
    i1 -= 4;
    var shfs = 0;
    while(i0 < i1){
        while(vecDot(nimg, i0, e) <= eMq)i0 += 4;
        while(vecDot(nimg, i1, e) > eMq)i1 -= 4;
        if (i0 >= i1) break;
        var t = nimg32[i0 >> 2];
        nimg32[i0 >> 2] = nimg32[i1 >> 2];
        nimg32[i1 >> 2] = t;
        i0 += 4;
        i1 -= 4;
    }
    while(vecDot(nimg, i0, e) > eMq)i0 -= 4;
    return i0 + 4;
};
$6ee893d66c44e557$var$UPNG.quantize.vecDot = function(nimg, i, e) {
    return nimg[i] * e[0] + nimg[i + 1] * e[1] + nimg[i + 2] * e[2] + nimg[i + 3] * e[3];
};
$6ee893d66c44e557$var$UPNG.quantize.stats = function(nimg, i0, i1) {
    var R = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var m = [
        0,
        0,
        0,
        0
    ];
    var N = i1 - i0 >> 2;
    for(var i = i0; i < i1; i += 4){
        var r = nimg[i] * (1 / 255), g = nimg[i + 1] * (1 / 255), b = nimg[i + 2] * (1 / 255), a = nimg[i + 3] * (1 / 255);
        //var r = nimg[i], g = nimg[i+1], b = nimg[i+2], a = nimg[i+3];
        m[0] += r;
        m[1] += g;
        m[2] += b;
        m[3] += a;
        R[0] += r * r;
        R[1] += r * g;
        R[2] += r * b;
        R[3] += r * a;
        R[5] += g * g;
        R[6] += g * b;
        R[7] += g * a;
        R[10] += b * b;
        R[11] += b * a;
        R[15] += a * a;
    }
    R[4] = R[1];
    R[8] = R[2];
    R[9] = R[6];
    R[12] = R[3];
    R[13] = R[7];
    R[14] = R[11];
    return {
        R: R,
        m: m,
        N: N
    };
};
$6ee893d66c44e557$var$UPNG.quantize.estats = function(stats) {
    var R = stats.R, m = stats.m, N = stats.N;
    // when all samples are equal, but N is large (millions), the Rj can be non-zero ( 0.0003.... - precission error)
    var m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3], iN = N == 0 ? 0 : 1 / N;
    var Rj = [
        R[0] - m0 * m0 * iN,
        R[1] - m0 * m1 * iN,
        R[2] - m0 * m2 * iN,
        R[3] - m0 * m3 * iN,
        R[4] - m1 * m0 * iN,
        R[5] - m1 * m1 * iN,
        R[6] - m1 * m2 * iN,
        R[7] - m1 * m3 * iN,
        R[8] - m2 * m0 * iN,
        R[9] - m2 * m1 * iN,
        R[10] - m2 * m2 * iN,
        R[11] - m2 * m3 * iN,
        R[12] - m3 * m0 * iN,
        R[13] - m3 * m1 * iN,
        R[14] - m3 * m2 * iN,
        R[15] - m3 * m3 * iN
    ];
    var A = Rj, M = $6ee893d66c44e557$var$UPNG.M4;
    var b = [
        0.5,
        0.5,
        0.5,
        0.5
    ], mi = 0, tmi = 0;
    if (N != 0) for(var i = 0; i < 10; i++){
        b = M.multVec(A, b);
        tmi = Math.sqrt(M.dot(b, b));
        b = M.sml(1 / tmi, b);
        if (Math.abs(tmi - mi) < 1e-9) break;
        mi = tmi;
    }
    //b = [0,0,1,0];  mi=N;
    var q = [
        m0 * iN,
        m1 * iN,
        m2 * iN,
        m3 * iN
    ];
    var eMq255 = M.dot(M.sml(255, q), b);
    return {
        Cov: Rj,
        q: q,
        e: b,
        L: mi,
        eMq255: eMq255,
        eMq: M.dot(b, q),
        rgba: (Math.round(255 * q[3]) << 24 | Math.round(255 * q[2]) << 16 | Math.round(255 * q[1]) << 8 | Math.round(255 * q[0]) << 0) >>> 0
    };
};
$6ee893d66c44e557$var$UPNG.M4 = {
    multVec: function(m, v) {
        return [
            m[0] * v[0] + m[1] * v[1] + m[2] * v[2] + m[3] * v[3],
            m[4] * v[0] + m[5] * v[1] + m[6] * v[2] + m[7] * v[3],
            m[8] * v[0] + m[9] * v[1] + m[10] * v[2] + m[11] * v[3],
            m[12] * v[0] + m[13] * v[1] + m[14] * v[2] + m[15] * v[3]
        ];
    },
    dot: function(x, y) {
        return x[0] * y[0] + x[1] * y[1] + x[2] * y[2] + x[3] * y[3];
    },
    sml: function(a, y) {
        return [
            a * y[0],
            a * y[1],
            a * y[2],
            a * y[3]
        ];
    }
};
$6ee893d66c44e557$var$UPNG.encode.concatRGBA = function(bufs) {
    var tlen = 0;
    for(var i = 0; i < bufs.length; i++)tlen += bufs[i].byteLength;
    var nimg = new Uint8Array(tlen), noff = 0;
    for(var i = 0; i < bufs.length; i++){
        var img = new Uint8Array(bufs[i]), il = img.length;
        for(var j = 0; j < il; j += 4){
            var r = img[j], g = img[j + 1], b = img[j + 2], a = img[j + 3];
            if (a == 0) r = g = b = 0;
            nimg[noff + j] = r;
            nimg[noff + j + 1] = g;
            nimg[noff + j + 2] = b;
            nimg[noff + j + 3] = a;
        }
        noff += il;
    }
    return nimg.buffer;
};
var $6ee893d66c44e557$export$2e2bcd8739ae039 = $6ee893d66c44e557$var$UPNG;


var $eb710dec6a4e1482$var$getImageType = function(ctype) {
    if (ctype === 0) return $eb710dec6a4e1482$export$3ff975e8f63e458c.Greyscale;
    if (ctype === 2) return $eb710dec6a4e1482$export$3ff975e8f63e458c.Truecolour;
    if (ctype === 3) return $eb710dec6a4e1482$export$3ff975e8f63e458c.IndexedColour;
    if (ctype === 4) return $eb710dec6a4e1482$export$3ff975e8f63e458c.GreyscaleWithAlpha;
    if (ctype === 6) return $eb710dec6a4e1482$export$3ff975e8f63e458c.TruecolourWithAlpha;
    throw new Error("Unknown color type: " + ctype);
};
var $eb710dec6a4e1482$var$splitAlphaChannel = function(rgbaChannel) {
    var pixelCount = Math.floor(rgbaChannel.length / 4);
    var rgbChannel = new Uint8Array(pixelCount * 3);
    var alphaChannel = new Uint8Array(pixelCount * 1);
    var rgbaOffset = 0;
    var rgbOffset = 0;
    var alphaOffset = 0;
    while(rgbaOffset < rgbaChannel.length){
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        alphaChannel[alphaOffset++] = rgbaChannel[rgbaOffset++];
    }
    return {
        rgbChannel: rgbChannel,
        alphaChannel: alphaChannel
    };
};
var $eb710dec6a4e1482$export$3ff975e8f63e458c;
(function(PngType) {
    PngType["Greyscale"] = "Greyscale";
    PngType["Truecolour"] = "Truecolour";
    PngType["IndexedColour"] = "IndexedColour";
    PngType["GreyscaleWithAlpha"] = "GreyscaleWithAlpha";
    PngType["TruecolourWithAlpha"] = "TruecolourWithAlpha";
})($eb710dec6a4e1482$export$3ff975e8f63e458c || ($eb710dec6a4e1482$export$3ff975e8f63e458c = {}));
var $eb710dec6a4e1482$export$1f536085c24cc947 = /** @class */ function() {
    function PNG(pngData) {
        var upng = (0, $6ee893d66c44e557$export$2e2bcd8739ae039).decode(pngData);
        var frames = (0, $6ee893d66c44e557$export$2e2bcd8739ae039).toRGBA8(upng);
        if (frames.length > 1) throw new Error("Animated PNGs are not supported");
        var frame = new Uint8Array(frames[0]);
        var _a = $eb710dec6a4e1482$var$splitAlphaChannel(frame), rgbChannel = _a.rgbChannel, alphaChannel = _a.alphaChannel;
        this.rgbChannel = rgbChannel;
        var hasAlphaValues = alphaChannel.some(function(a) {
            return a < 255;
        });
        if (hasAlphaValues) this.alphaChannel = alphaChannel;
        this.type = $eb710dec6a4e1482$var$getImageType(upng.ctype);
        this.width = upng.width;
        this.height = upng.height;
        this.bitsPerComponent = 8;
    }
    PNG.load = function(pngData) {
        return new PNG(pngData);
    };
    return PNG;
}();


/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/png.coffee
 */ var $79f8a6e417146498$var$PngEmbedder = /** @class */ function() {
    function PngEmbedder(png) {
        this.image = png;
        this.bitsPerComponent = png.bitsPerComponent;
        this.width = png.width;
        this.height = png.height;
        this.colorSpace = 'DeviceRGB';
    }
    PngEmbedder.for = function(imageData) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var png;
            return (0, $cOQTW.__generator)(this, function(_a) {
                png = (0, $eb710dec6a4e1482$export$1f536085c24cc947).load(imageData);
                return [
                    2 /*return*/ ,
                    new PngEmbedder(png)
                ];
            });
        });
    };
    PngEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var SMask, xObject;
            return (0, $cOQTW.__generator)(this, function(_a) {
                SMask = this.embedAlphaChannel(context);
                xObject = context.flateStream(this.image.rgbChannel, {
                    Type: 'XObject',
                    Subtype: 'Image',
                    BitsPerComponent: this.image.bitsPerComponent,
                    Width: this.image.width,
                    Height: this.image.height,
                    ColorSpace: this.colorSpace,
                    SMask: SMask
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    PngEmbedder.prototype.embedAlphaChannel = function(context) {
        if (!this.image.alphaChannel) return undefined;
        var xObject = context.flateStream(this.image.alphaChannel, {
            Type: 'XObject',
            Subtype: 'Image',
            Height: this.image.height,
            Width: this.image.width,
            BitsPerComponent: this.image.bitsPerComponent,
            ColorSpace: 'DeviceGray',
            Decode: [
                0,
                1
            ]
        });
        return context.register(xObject);
    };
    return PngEmbedder;
}();
var $79f8a6e417146498$export$2e2bcd8739ae039 = $79f8a6e417146498$var$PngEmbedder;



var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $j04jt = parcelRequire("j04jt");



var $nAWRe = parcelRequire("nAWRe");

var $8auL6 = parcelRequire("8auL6");


var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The Ascii85Stream class contained in this file is a TypeScript port of the
 * JavaScript Ascii85Stream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The Stream class contained in this file is a TypeScript port of the
 * JavaScript Stream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ var $6994bc106090076a$var$Stream = /** @class */ function() {
    function Stream(buffer, start, length) {
        this.bytes = buffer;
        this.start = start || 0;
        this.pos = this.start;
        this.end = !!start && !!length ? start + length : this.bytes.length;
    }
    Object.defineProperty(Stream.prototype, "length", {
        get: function() {
            return this.end - this.start;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Stream.prototype, "isEmpty", {
        get: function() {
            return this.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Stream.prototype.getByte = function() {
        if (this.pos >= this.end) return -1;
        return this.bytes[this.pos++];
    };
    Stream.prototype.getUint16 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        if (b0 === -1 || b1 === -1) return -1;
        return (b0 << 8) + b1;
    };
    Stream.prototype.getInt32 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        var b2 = this.getByte();
        var b3 = this.getByte();
        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    };
    // Returns subarray of original buffer, should only be read.
    Stream.prototype.getBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.bytes;
        var pos = this.pos;
        var strEnd = this.end;
        if (!length) {
            var subarray = bytes.subarray(pos, strEnd);
            // `this.bytes` is always a `Uint8Array` here.
            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
        } else {
            var end = pos + length;
            if (end > strEnd) end = strEnd;
            this.pos = end;
            var subarray = bytes.subarray(pos, end);
            // `this.bytes` is always a `Uint8Array` here.
            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
        }
    };
    Stream.prototype.peekByte = function() {
        var peekedByte = this.getByte();
        this.pos--;
        return peekedByte;
    };
    Stream.prototype.peekBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.getBytes(length, forceClamped);
        this.pos -= bytes.length;
        return bytes;
    };
    Stream.prototype.skip = function(n) {
        if (!n) n = 1;
        this.pos += n;
    };
    Stream.prototype.reset = function() {
        this.pos = this.start;
    };
    Stream.prototype.moveStart = function() {
        this.start = this.pos;
    };
    Stream.prototype.makeSubStream = function(start, length) {
        return new Stream(this.bytes, start, length);
    };
    Stream.prototype.decode = function() {
        return this.bytes;
    };
    return Stream;
}();
var $6994bc106090076a$export$2e2bcd8739ae039 = $6994bc106090076a$var$Stream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The DecodeStream class contained in this file is a TypeScript port of the
 * JavaScript DecodeStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ // Lots of DecodeStreams are created whose buffers are never used.  For these
// we share a single empty buffer. This is (a) space-efficient and (b) avoids
// having special cases that would be required if we used |null| for an empty
// buffer.
var $6ff39b2bedd52666$var$emptyBuffer = new Uint8Array(0);
/**
 * Super class for the decoding streams
 */ var $6ff39b2bedd52666$var$DecodeStream = /** @class */ function() {
    function DecodeStream(maybeMinBufferLength) {
        this.pos = 0;
        this.bufferLength = 0;
        this.eof = false;
        this.buffer = $6ff39b2bedd52666$var$emptyBuffer;
        this.minBufferLength = 512;
        if (maybeMinBufferLength) // Compute the first power of two that is as big as maybeMinBufferLength.
        while(this.minBufferLength < maybeMinBufferLength)this.minBufferLength *= 2;
    }
    Object.defineProperty(DecodeStream.prototype, "isEmpty", {
        get: function() {
            while(!this.eof && this.bufferLength === 0)this.readBlock();
            return this.bufferLength === 0;
        },
        enumerable: false,
        configurable: true
    });
    DecodeStream.prototype.getByte = function() {
        var pos = this.pos;
        while(this.bufferLength <= pos){
            if (this.eof) return -1;
            this.readBlock();
        }
        return this.buffer[this.pos++];
    };
    DecodeStream.prototype.getUint16 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        if (b0 === -1 || b1 === -1) return -1;
        return (b0 << 8) + b1;
    };
    DecodeStream.prototype.getInt32 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        var b2 = this.getByte();
        var b3 = this.getByte();
        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    };
    DecodeStream.prototype.getBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var end;
        var pos = this.pos;
        if (length) {
            this.ensureBuffer(pos + length);
            end = pos + length;
            while(!this.eof && this.bufferLength < end)this.readBlock();
            var bufEnd = this.bufferLength;
            if (end > bufEnd) end = bufEnd;
        } else {
            while(!this.eof)this.readBlock();
            end = this.bufferLength;
        }
        this.pos = end;
        var subarray = this.buffer.subarray(pos, end);
        // `this.buffer` is either a `Uint8Array` or `Uint8ClampedArray` here.
        return forceClamped && !(subarray instanceof Uint8ClampedArray) ? new Uint8ClampedArray(subarray) : subarray;
    };
    DecodeStream.prototype.peekByte = function() {
        var peekedByte = this.getByte();
        this.pos--;
        return peekedByte;
    };
    DecodeStream.prototype.peekBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.getBytes(length, forceClamped);
        this.pos -= bytes.length;
        return bytes;
    };
    DecodeStream.prototype.skip = function(n) {
        if (!n) n = 1;
        this.pos += n;
    };
    DecodeStream.prototype.reset = function() {
        this.pos = 0;
    };
    DecodeStream.prototype.makeSubStream = function(start, length /* dict */ ) {
        var end = start + length;
        while(this.bufferLength <= end && !this.eof)this.readBlock();
        return new (0, $6994bc106090076a$export$2e2bcd8739ae039)(this.buffer, start, length /* dict */ );
    };
    DecodeStream.prototype.decode = function() {
        while(!this.eof)this.readBlock();
        return this.buffer.subarray(0, this.bufferLength);
    };
    DecodeStream.prototype.readBlock = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'readBlock');
    };
    DecodeStream.prototype.ensureBuffer = function(requested) {
        var buffer = this.buffer;
        if (requested <= buffer.byteLength) return buffer;
        var size = this.minBufferLength;
        while(size < requested)size *= 2;
        var buffer2 = new Uint8Array(size);
        buffer2.set(buffer);
        return this.buffer = buffer2;
    };
    return DecodeStream;
}();
var $6ff39b2bedd52666$export$2e2bcd8739ae039 = $6ff39b2bedd52666$var$DecodeStream;


var $1d792bffef4b9a0f$var$isSpace = function(ch) {
    return ch === 0x20 || ch === 0x09 || ch === 0x0d || ch === 0x0a;
};
var $1d792bffef4b9a0f$var$Ascii85Stream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(Ascii85Stream, _super);
    function Ascii85Stream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.input = new Uint8Array(5);
        // Most streams increase in size when decoded, but Ascii85 streams
        // typically shrink by ~20%.
        if (maybeLength) maybeLength = 0.8 * maybeLength;
        return _this;
    }
    Ascii85Stream.prototype.readBlock = function() {
        var TILDA_CHAR = 0x7e; // '~'
        var Z_LOWER_CHAR = 0x7a; // 'z'
        var EOF = -1;
        var stream = this.stream;
        var c = stream.getByte();
        while($1d792bffef4b9a0f$var$isSpace(c))c = stream.getByte();
        if (c === EOF || c === TILDA_CHAR) {
            this.eof = true;
            return;
        }
        var bufferLength = this.bufferLength;
        var buffer;
        var i;
        // special code for z
        if (c === Z_LOWER_CHAR) {
            buffer = this.ensureBuffer(bufferLength + 4);
            for(i = 0; i < 4; ++i)buffer[bufferLength + i] = 0;
            this.bufferLength += 4;
        } else {
            var input = this.input;
            input[0] = c;
            for(i = 1; i < 5; ++i){
                c = stream.getByte();
                while($1d792bffef4b9a0f$var$isSpace(c))c = stream.getByte();
                input[i] = c;
                if (c === EOF || c === TILDA_CHAR) break;
            }
            buffer = this.ensureBuffer(bufferLength + i - 1);
            this.bufferLength += i - 1;
            // partial ending;
            if (i < 5) {
                for(; i < 5; ++i)input[i] = 117;
                this.eof = true;
            }
            var t = 0;
            for(i = 0; i < 5; ++i)t = t * 85 + (input[i] - 0x21);
            for(i = 3; i >= 0; --i){
                buffer[bufferLength + i] = t & 0xff;
                t >>= 8;
            }
        }
    };
    return Ascii85Stream;
}((0, $6ff39b2bedd52666$export$2e2bcd8739ae039));
var $1d792bffef4b9a0f$export$2e2bcd8739ae039 = $1d792bffef4b9a0f$var$Ascii85Stream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The AsciiHexStream class contained in this file is a TypeScript port of the
 * JavaScript AsciiHexStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

var $e8d1eed445279b14$var$AsciiHexStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(AsciiHexStream, _super);
    function AsciiHexStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.firstDigit = -1;
        // Most streams increase in size when decoded, but AsciiHex streams shrink
        // by 50%.
        if (maybeLength) maybeLength = 0.5 * maybeLength;
        return _this;
    }
    AsciiHexStream.prototype.readBlock = function() {
        var UPSTREAM_BLOCK_SIZE = 8000;
        var bytes = this.stream.getBytes(UPSTREAM_BLOCK_SIZE);
        if (!bytes.length) {
            this.eof = true;
            return;
        }
        var maxDecodeLength = bytes.length + 1 >> 1;
        var buffer = this.ensureBuffer(this.bufferLength + maxDecodeLength);
        var bufferLength = this.bufferLength;
        var firstDigit = this.firstDigit;
        for(var i = 0, ii = bytes.length; i < ii; i++){
            var ch = bytes[i];
            var digit = void 0;
            if (ch >= 0x30 && ch <= 0x39) // '0'-'9'
            digit = ch & 0x0f;
            else if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) // 'A'-'Z', 'a'-'z'
            digit = (ch & 0x0f) + 9;
            else if (ch === 0x3e) {
                // '>'
                this.eof = true;
                break;
            } else continue; // ignoring
            if (firstDigit < 0) firstDigit = digit;
            else {
                buffer[bufferLength++] = firstDigit << 4 | digit;
                firstDigit = -1;
            }
        }
        if (firstDigit >= 0 && this.eof) {
            // incomplete byte
            buffer[bufferLength++] = firstDigit << 4;
            firstDigit = -1;
        }
        this.firstDigit = firstDigit;
        this.bufferLength = bufferLength;
    };
    return AsciiHexStream;
}((0, $6ff39b2bedd52666$export$2e2bcd8739ae039));
var $e8d1eed445279b14$export$2e2bcd8739ae039 = $e8d1eed445279b14$var$AsciiHexStream;


/*
 * Copyright 1996-2003 Glyph & Cog, LLC
 *
 * The flate stream implementation contained in this file is a JavaScript port
 * of XPDF's implementation, made available under the Apache 2.0 open source
 * license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

// prettier-ignore
var $106ef4d7516ef3d6$var$codeLenCodeMap = new Int32Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// prettier-ignore
var $106ef4d7516ef3d6$var$lengthDecode = new Int32Array([
    0x00003,
    0x00004,
    0x00005,
    0x00006,
    0x00007,
    0x00008,
    0x00009,
    0x0000a,
    0x1000b,
    0x1000d,
    0x1000f,
    0x10011,
    0x20013,
    0x20017,
    0x2001b,
    0x2001f,
    0x30023,
    0x3002b,
    0x30033,
    0x3003b,
    0x40043,
    0x40053,
    0x40063,
    0x40073,
    0x50083,
    0x500a3,
    0x500c3,
    0x500e3,
    0x00102,
    0x00102,
    0x00102
]);
// prettier-ignore
var $106ef4d7516ef3d6$var$distDecode = new Int32Array([
    0x00001,
    0x00002,
    0x00003,
    0x00004,
    0x10005,
    0x10007,
    0x20009,
    0x2000d,
    0x30011,
    0x30019,
    0x40021,
    0x40031,
    0x50041,
    0x50061,
    0x60081,
    0x600c1,
    0x70101,
    0x70181,
    0x80201,
    0x80301,
    0x90401,
    0x90601,
    0xa0801,
    0xa0c01,
    0xb1001,
    0xb1801,
    0xc2001,
    0xc3001,
    0xd4001,
    0xd6001
]);
// prettier-ignore
var $106ef4d7516ef3d6$var$fixedLitCodeTab = [
    new Int32Array([
        0x70100,
        0x80050,
        0x80010,
        0x80118,
        0x70110,
        0x80070,
        0x80030,
        0x900c0,
        0x70108,
        0x80060,
        0x80020,
        0x900a0,
        0x80000,
        0x80080,
        0x80040,
        0x900e0,
        0x70104,
        0x80058,
        0x80018,
        0x90090,
        0x70114,
        0x80078,
        0x80038,
        0x900d0,
        0x7010c,
        0x80068,
        0x80028,
        0x900b0,
        0x80008,
        0x80088,
        0x80048,
        0x900f0,
        0x70102,
        0x80054,
        0x80014,
        0x8011c,
        0x70112,
        0x80074,
        0x80034,
        0x900c8,
        0x7010a,
        0x80064,
        0x80024,
        0x900a8,
        0x80004,
        0x80084,
        0x80044,
        0x900e8,
        0x70106,
        0x8005c,
        0x8001c,
        0x90098,
        0x70116,
        0x8007c,
        0x8003c,
        0x900d8,
        0x7010e,
        0x8006c,
        0x8002c,
        0x900b8,
        0x8000c,
        0x8008c,
        0x8004c,
        0x900f8,
        0x70101,
        0x80052,
        0x80012,
        0x8011a,
        0x70111,
        0x80072,
        0x80032,
        0x900c4,
        0x70109,
        0x80062,
        0x80022,
        0x900a4,
        0x80002,
        0x80082,
        0x80042,
        0x900e4,
        0x70105,
        0x8005a,
        0x8001a,
        0x90094,
        0x70115,
        0x8007a,
        0x8003a,
        0x900d4,
        0x7010d,
        0x8006a,
        0x8002a,
        0x900b4,
        0x8000a,
        0x8008a,
        0x8004a,
        0x900f4,
        0x70103,
        0x80056,
        0x80016,
        0x8011e,
        0x70113,
        0x80076,
        0x80036,
        0x900cc,
        0x7010b,
        0x80066,
        0x80026,
        0x900ac,
        0x80006,
        0x80086,
        0x80046,
        0x900ec,
        0x70107,
        0x8005e,
        0x8001e,
        0x9009c,
        0x70117,
        0x8007e,
        0x8003e,
        0x900dc,
        0x7010f,
        0x8006e,
        0x8002e,
        0x900bc,
        0x8000e,
        0x8008e,
        0x8004e,
        0x900fc,
        0x70100,
        0x80051,
        0x80011,
        0x80119,
        0x70110,
        0x80071,
        0x80031,
        0x900c2,
        0x70108,
        0x80061,
        0x80021,
        0x900a2,
        0x80001,
        0x80081,
        0x80041,
        0x900e2,
        0x70104,
        0x80059,
        0x80019,
        0x90092,
        0x70114,
        0x80079,
        0x80039,
        0x900d2,
        0x7010c,
        0x80069,
        0x80029,
        0x900b2,
        0x80009,
        0x80089,
        0x80049,
        0x900f2,
        0x70102,
        0x80055,
        0x80015,
        0x8011d,
        0x70112,
        0x80075,
        0x80035,
        0x900ca,
        0x7010a,
        0x80065,
        0x80025,
        0x900aa,
        0x80005,
        0x80085,
        0x80045,
        0x900ea,
        0x70106,
        0x8005d,
        0x8001d,
        0x9009a,
        0x70116,
        0x8007d,
        0x8003d,
        0x900da,
        0x7010e,
        0x8006d,
        0x8002d,
        0x900ba,
        0x8000d,
        0x8008d,
        0x8004d,
        0x900fa,
        0x70101,
        0x80053,
        0x80013,
        0x8011b,
        0x70111,
        0x80073,
        0x80033,
        0x900c6,
        0x70109,
        0x80063,
        0x80023,
        0x900a6,
        0x80003,
        0x80083,
        0x80043,
        0x900e6,
        0x70105,
        0x8005b,
        0x8001b,
        0x90096,
        0x70115,
        0x8007b,
        0x8003b,
        0x900d6,
        0x7010d,
        0x8006b,
        0x8002b,
        0x900b6,
        0x8000b,
        0x8008b,
        0x8004b,
        0x900f6,
        0x70103,
        0x80057,
        0x80017,
        0x8011f,
        0x70113,
        0x80077,
        0x80037,
        0x900ce,
        0x7010b,
        0x80067,
        0x80027,
        0x900ae,
        0x80007,
        0x80087,
        0x80047,
        0x900ee,
        0x70107,
        0x8005f,
        0x8001f,
        0x9009e,
        0x70117,
        0x8007f,
        0x8003f,
        0x900de,
        0x7010f,
        0x8006f,
        0x8002f,
        0x900be,
        0x8000f,
        0x8008f,
        0x8004f,
        0x900fe,
        0x70100,
        0x80050,
        0x80010,
        0x80118,
        0x70110,
        0x80070,
        0x80030,
        0x900c1,
        0x70108,
        0x80060,
        0x80020,
        0x900a1,
        0x80000,
        0x80080,
        0x80040,
        0x900e1,
        0x70104,
        0x80058,
        0x80018,
        0x90091,
        0x70114,
        0x80078,
        0x80038,
        0x900d1,
        0x7010c,
        0x80068,
        0x80028,
        0x900b1,
        0x80008,
        0x80088,
        0x80048,
        0x900f1,
        0x70102,
        0x80054,
        0x80014,
        0x8011c,
        0x70112,
        0x80074,
        0x80034,
        0x900c9,
        0x7010a,
        0x80064,
        0x80024,
        0x900a9,
        0x80004,
        0x80084,
        0x80044,
        0x900e9,
        0x70106,
        0x8005c,
        0x8001c,
        0x90099,
        0x70116,
        0x8007c,
        0x8003c,
        0x900d9,
        0x7010e,
        0x8006c,
        0x8002c,
        0x900b9,
        0x8000c,
        0x8008c,
        0x8004c,
        0x900f9,
        0x70101,
        0x80052,
        0x80012,
        0x8011a,
        0x70111,
        0x80072,
        0x80032,
        0x900c5,
        0x70109,
        0x80062,
        0x80022,
        0x900a5,
        0x80002,
        0x80082,
        0x80042,
        0x900e5,
        0x70105,
        0x8005a,
        0x8001a,
        0x90095,
        0x70115,
        0x8007a,
        0x8003a,
        0x900d5,
        0x7010d,
        0x8006a,
        0x8002a,
        0x900b5,
        0x8000a,
        0x8008a,
        0x8004a,
        0x900f5,
        0x70103,
        0x80056,
        0x80016,
        0x8011e,
        0x70113,
        0x80076,
        0x80036,
        0x900cd,
        0x7010b,
        0x80066,
        0x80026,
        0x900ad,
        0x80006,
        0x80086,
        0x80046,
        0x900ed,
        0x70107,
        0x8005e,
        0x8001e,
        0x9009d,
        0x70117,
        0x8007e,
        0x8003e,
        0x900dd,
        0x7010f,
        0x8006e,
        0x8002e,
        0x900bd,
        0x8000e,
        0x8008e,
        0x8004e,
        0x900fd,
        0x70100,
        0x80051,
        0x80011,
        0x80119,
        0x70110,
        0x80071,
        0x80031,
        0x900c3,
        0x70108,
        0x80061,
        0x80021,
        0x900a3,
        0x80001,
        0x80081,
        0x80041,
        0x900e3,
        0x70104,
        0x80059,
        0x80019,
        0x90093,
        0x70114,
        0x80079,
        0x80039,
        0x900d3,
        0x7010c,
        0x80069,
        0x80029,
        0x900b3,
        0x80009,
        0x80089,
        0x80049,
        0x900f3,
        0x70102,
        0x80055,
        0x80015,
        0x8011d,
        0x70112,
        0x80075,
        0x80035,
        0x900cb,
        0x7010a,
        0x80065,
        0x80025,
        0x900ab,
        0x80005,
        0x80085,
        0x80045,
        0x900eb,
        0x70106,
        0x8005d,
        0x8001d,
        0x9009b,
        0x70116,
        0x8007d,
        0x8003d,
        0x900db,
        0x7010e,
        0x8006d,
        0x8002d,
        0x900bb,
        0x8000d,
        0x8008d,
        0x8004d,
        0x900fb,
        0x70101,
        0x80053,
        0x80013,
        0x8011b,
        0x70111,
        0x80073,
        0x80033,
        0x900c7,
        0x70109,
        0x80063,
        0x80023,
        0x900a7,
        0x80003,
        0x80083,
        0x80043,
        0x900e7,
        0x70105,
        0x8005b,
        0x8001b,
        0x90097,
        0x70115,
        0x8007b,
        0x8003b,
        0x900d7,
        0x7010d,
        0x8006b,
        0x8002b,
        0x900b7,
        0x8000b,
        0x8008b,
        0x8004b,
        0x900f7,
        0x70103,
        0x80057,
        0x80017,
        0x8011f,
        0x70113,
        0x80077,
        0x80037,
        0x900cf,
        0x7010b,
        0x80067,
        0x80027,
        0x900af,
        0x80007,
        0x80087,
        0x80047,
        0x900ef,
        0x70107,
        0x8005f,
        0x8001f,
        0x9009f,
        0x70117,
        0x8007f,
        0x8003f,
        0x900df,
        0x7010f,
        0x8006f,
        0x8002f,
        0x900bf,
        0x8000f,
        0x8008f,
        0x8004f,
        0x900ff
    ]),
    9
];
// prettier-ignore
var $106ef4d7516ef3d6$var$fixedDistCodeTab = [
    new Int32Array([
        0x50000,
        0x50010,
        0x50008,
        0x50018,
        0x50004,
        0x50014,
        0x5000c,
        0x5001c,
        0x50002,
        0x50012,
        0x5000a,
        0x5001a,
        0x50006,
        0x50016,
        0x5000e,
        0x00000,
        0x50001,
        0x50011,
        0x50009,
        0x50019,
        0x50005,
        0x50015,
        0x5000d,
        0x5001d,
        0x50003,
        0x50013,
        0x5000b,
        0x5001b,
        0x50007,
        0x50017,
        0x5000f,
        0x00000
    ]),
    5
];
var $106ef4d7516ef3d6$var$FlateStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(FlateStream, _super);
    function FlateStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        var cmf = stream.getByte();
        var flg = stream.getByte();
        if (cmf === -1 || flg === -1) throw new Error("Invalid header in flate stream: " + cmf + ", " + flg);
        if ((cmf & 0x0f) !== 0x08) throw new Error("Unknown compression method in flate stream: " + cmf + ", " + flg);
        if (((cmf << 8) + flg) % 31 !== 0) throw new Error("Bad FCHECK in flate stream: " + cmf + ", " + flg);
        if (flg & 0x20) throw new Error("FDICT bit set in flate stream: " + cmf + ", " + flg);
        _this.codeSize = 0;
        _this.codeBuf = 0;
        return _this;
    }
    FlateStream.prototype.readBlock = function() {
        var buffer;
        var len;
        var str = this.stream;
        // read block header
        var hdr = this.getBits(3);
        if (hdr & 1) this.eof = true;
        hdr >>= 1;
        if (hdr === 0) {
            // uncompressed block
            var b = void 0;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            var blockLen = b;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            blockLen |= b << 8;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            var check = b;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            check |= b << 8;
            if (check !== (~blockLen & 0xffff) && (blockLen !== 0 || check !== 0)) // Ignoring error for bad "empty" block (see issue 1277)
            throw new Error('Bad uncompressed block length in flate stream');
            this.codeBuf = 0;
            this.codeSize = 0;
            var bufferLength = this.bufferLength;
            buffer = this.ensureBuffer(bufferLength + blockLen);
            var end = bufferLength + blockLen;
            this.bufferLength = end;
            if (blockLen === 0) {
                if (str.peekByte() === -1) this.eof = true;
            } else for(var n = bufferLength; n < end; ++n){
                if ((b = str.getByte()) === -1) {
                    this.eof = true;
                    break;
                }
                buffer[n] = b;
            }
            return;
        }
        var litCodeTable;
        var distCodeTable;
        if (hdr === 1) {
            // compressed block, fixed codes
            litCodeTable = $106ef4d7516ef3d6$var$fixedLitCodeTab;
            distCodeTable = $106ef4d7516ef3d6$var$fixedDistCodeTab;
        } else if (hdr === 2) {
            // compressed block, dynamic codes
            var numLitCodes = this.getBits(5) + 257;
            var numDistCodes = this.getBits(5) + 1;
            var numCodeLenCodes = this.getBits(4) + 4;
            // build the code lengths code table
            var codeLenCodeLengths = new Uint8Array($106ef4d7516ef3d6$var$codeLenCodeMap.length);
            var i = void 0;
            for(i = 0; i < numCodeLenCodes; ++i)codeLenCodeLengths[$106ef4d7516ef3d6$var$codeLenCodeMap[i]] = this.getBits(3);
            var codeLenCodeTab = this.generateHuffmanTable(codeLenCodeLengths);
            // build the literal and distance code tables
            len = 0;
            i = 0;
            var codes = numLitCodes + numDistCodes;
            var codeLengths = new Uint8Array(codes);
            var bitsLength = void 0;
            var bitsOffset = void 0;
            var what = void 0;
            while(i < codes){
                var code = this.getCode(codeLenCodeTab);
                if (code === 16) {
                    bitsLength = 2;
                    bitsOffset = 3;
                    what = len;
                } else if (code === 17) {
                    bitsLength = 3;
                    bitsOffset = 3;
                    what = len = 0;
                } else if (code === 18) {
                    bitsLength = 7;
                    bitsOffset = 11;
                    what = len = 0;
                } else {
                    codeLengths[i++] = len = code;
                    continue;
                }
                var repeatLength = this.getBits(bitsLength) + bitsOffset;
                while(repeatLength-- > 0)codeLengths[i++] = what;
            }
            litCodeTable = this.generateHuffmanTable(codeLengths.subarray(0, numLitCodes));
            distCodeTable = this.generateHuffmanTable(codeLengths.subarray(numLitCodes, codes));
        } else throw new Error('Unknown block type in flate stream');
        buffer = this.buffer;
        var limit = buffer ? buffer.length : 0;
        var pos = this.bufferLength;
        while(true){
            var code1 = this.getCode(litCodeTable);
            if (code1 < 256) {
                if (pos + 1 >= limit) {
                    buffer = this.ensureBuffer(pos + 1);
                    limit = buffer.length;
                }
                buffer[pos++] = code1;
                continue;
            }
            if (code1 === 256) {
                this.bufferLength = pos;
                return;
            }
            code1 -= 257;
            code1 = $106ef4d7516ef3d6$var$lengthDecode[code1];
            var code2 = code1 >> 16;
            if (code2 > 0) code2 = this.getBits(code2);
            len = (code1 & 0xffff) + code2;
            code1 = this.getCode(distCodeTable);
            code1 = $106ef4d7516ef3d6$var$distDecode[code1];
            code2 = code1 >> 16;
            if (code2 > 0) code2 = this.getBits(code2);
            var dist = (code1 & 0xffff) + code2;
            if (pos + len >= limit) {
                buffer = this.ensureBuffer(pos + len);
                limit = buffer.length;
            }
            for(var k = 0; k < len; ++k, ++pos)buffer[pos] = buffer[pos - dist];
        }
    };
    FlateStream.prototype.getBits = function(bits) {
        var str = this.stream;
        var codeSize = this.codeSize;
        var codeBuf = this.codeBuf;
        var b;
        while(codeSize < bits){
            if ((b = str.getByte()) === -1) throw new Error('Bad encoding in flate stream');
            codeBuf |= b << codeSize;
            codeSize += 8;
        }
        b = codeBuf & (1 << bits) - 1;
        this.codeBuf = codeBuf >> bits;
        this.codeSize = codeSize -= bits;
        return b;
    };
    FlateStream.prototype.getCode = function(table) {
        var str = this.stream;
        var codes = table[0];
        var maxLen = table[1];
        var codeSize = this.codeSize;
        var codeBuf = this.codeBuf;
        var b;
        while(codeSize < maxLen){
            if ((b = str.getByte()) === -1) break;
            codeBuf |= b << codeSize;
            codeSize += 8;
        }
        var code = codes[codeBuf & (1 << maxLen) - 1];
        if (typeof codes === 'number') console.log('FLATE:', code);
        var codeLen = code >> 16;
        var codeVal = code & 0xffff;
        if (codeLen < 1 || codeSize < codeLen) throw new Error('Bad encoding in flate stream');
        this.codeBuf = codeBuf >> codeLen;
        this.codeSize = codeSize - codeLen;
        return codeVal;
    };
    FlateStream.prototype.generateHuffmanTable = function(lengths) {
        var n = lengths.length;
        // find max code length
        var maxLen = 0;
        var i;
        for(i = 0; i < n; ++i)if (lengths[i] > maxLen) maxLen = lengths[i];
        // build the table
        var size = 1 << maxLen;
        var codes = new Int32Array(size);
        for(var len = 1, code = 0, skip = 2; len <= maxLen; ++len, code <<= 1, skip <<= 1){
            for(var val = 0; val < n; ++val)if (lengths[val] === len) {
                // bit-reverse the code
                var code2 = 0;
                var t = code;
                for(i = 0; i < len; ++i){
                    code2 = code2 << 1 | t & 1;
                    t >>= 1;
                }
                // fill the table entries
                for(i = code2; i < size; i += skip)codes[i] = len << 16 | val;
                ++code;
            }
        }
        return [
            codes,
            maxLen
        ];
    };
    return FlateStream;
}((0, $6ff39b2bedd52666$export$2e2bcd8739ae039));
var $106ef4d7516ef3d6$export$2e2bcd8739ae039 = $106ef4d7516ef3d6$var$FlateStream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The LZWStream class contained in this file is a TypeScript port of the
 * JavaScript LZWStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

var $caad20b69225c7a9$var$LZWStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(LZWStream, _super);
    function LZWStream(stream, maybeLength, earlyChange) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.cachedData = 0;
        _this.bitsCached = 0;
        var maxLzwDictionarySize = 4096;
        var lzwState = {
            earlyChange: earlyChange,
            codeLength: 9,
            nextCode: 258,
            dictionaryValues: new Uint8Array(maxLzwDictionarySize),
            dictionaryLengths: new Uint16Array(maxLzwDictionarySize),
            dictionaryPrevCodes: new Uint16Array(maxLzwDictionarySize),
            currentSequence: new Uint8Array(maxLzwDictionarySize),
            currentSequenceLength: 0
        };
        for(var i = 0; i < 256; ++i){
            lzwState.dictionaryValues[i] = i;
            lzwState.dictionaryLengths[i] = 1;
        }
        _this.lzwState = lzwState;
        return _this;
    }
    LZWStream.prototype.readBlock = function() {
        var blockSize = 512;
        var estimatedDecodedSize = blockSize * 2;
        var decodedSizeDelta = blockSize;
        var i;
        var j;
        var q;
        var lzwState = this.lzwState;
        if (!lzwState) return; // eof was found
        var earlyChange = lzwState.earlyChange;
        var nextCode = lzwState.nextCode;
        var dictionaryValues = lzwState.dictionaryValues;
        var dictionaryLengths = lzwState.dictionaryLengths;
        var dictionaryPrevCodes = lzwState.dictionaryPrevCodes;
        var codeLength = lzwState.codeLength;
        var prevCode = lzwState.prevCode;
        var currentSequence = lzwState.currentSequence;
        var currentSequenceLength = lzwState.currentSequenceLength;
        var decodedLength = 0;
        var currentBufferLength = this.bufferLength;
        var buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
        for(i = 0; i < blockSize; i++){
            var code = this.readBits(codeLength);
            var hasPrev = currentSequenceLength > 0;
            if (!code || code < 256) {
                currentSequence[0] = code;
                currentSequenceLength = 1;
            } else if (code >= 258) {
                if (code < nextCode) {
                    currentSequenceLength = dictionaryLengths[code];
                    for(j = currentSequenceLength - 1, q = code; j >= 0; j--){
                        currentSequence[j] = dictionaryValues[q];
                        q = dictionaryPrevCodes[q];
                    }
                } else currentSequence[currentSequenceLength++] = currentSequence[0];
            } else if (code === 256) {
                codeLength = 9;
                nextCode = 258;
                currentSequenceLength = 0;
                continue;
            } else {
                this.eof = true;
                delete this.lzwState;
                break;
            }
            if (hasPrev) {
                dictionaryPrevCodes[nextCode] = prevCode;
                dictionaryLengths[nextCode] = dictionaryLengths[prevCode] + 1;
                dictionaryValues[nextCode] = currentSequence[0];
                nextCode++;
                codeLength = nextCode + earlyChange & nextCode + earlyChange - 1 ? codeLength : Math.min(Math.log(nextCode + earlyChange) / 0.6931471805599453 + 1, 12) | 0;
            }
            prevCode = code;
            decodedLength += currentSequenceLength;
            if (estimatedDecodedSize < decodedLength) {
                do estimatedDecodedSize += decodedSizeDelta;
                while (estimatedDecodedSize < decodedLength);
                buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
            }
            for(j = 0; j < currentSequenceLength; j++)buffer[currentBufferLength++] = currentSequence[j];
        }
        lzwState.nextCode = nextCode;
        lzwState.codeLength = codeLength;
        lzwState.prevCode = prevCode;
        lzwState.currentSequenceLength = currentSequenceLength;
        this.bufferLength = currentBufferLength;
    };
    LZWStream.prototype.readBits = function(n) {
        var bitsCached = this.bitsCached;
        var cachedData = this.cachedData;
        while(bitsCached < n){
            var c = this.stream.getByte();
            if (c === -1) {
                this.eof = true;
                return null;
            }
            cachedData = cachedData << 8 | c;
            bitsCached += 8;
        }
        this.bitsCached = bitsCached -= n;
        this.cachedData = cachedData;
        return cachedData >>> bitsCached & (1 << n) - 1;
    };
    return LZWStream;
}((0, $6ff39b2bedd52666$export$2e2bcd8739ae039));
var $caad20b69225c7a9$export$2e2bcd8739ae039 = $caad20b69225c7a9$var$LZWStream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The RunLengthStream class contained in this file is a TypeScript port of the
 * JavaScript RunLengthStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

var $04ab37ade25dd344$var$RunLengthStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(RunLengthStream, _super);
    function RunLengthStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        return _this;
    }
    RunLengthStream.prototype.readBlock = function() {
        // The repeatHeader has following format. The first byte defines type of run
        // and amount of bytes to repeat/copy: n = 0 through 127 - copy next n bytes
        // (in addition to the second byte from the header), n = 129 through 255 -
        // duplicate the second byte from the header (257 - n) times, n = 128 - end.
        var repeatHeader = this.stream.getBytes(2);
        if (!repeatHeader || repeatHeader.length < 2 || repeatHeader[0] === 128) {
            this.eof = true;
            return;
        }
        var buffer;
        var bufferLength = this.bufferLength;
        var n = repeatHeader[0];
        if (n < 128) {
            // copy n bytes
            buffer = this.ensureBuffer(bufferLength + n + 1);
            buffer[bufferLength++] = repeatHeader[1];
            if (n > 0) {
                var source = this.stream.getBytes(n);
                buffer.set(source, bufferLength);
                bufferLength += n;
            }
        } else {
            n = 257 - n;
            var b = repeatHeader[1];
            buffer = this.ensureBuffer(bufferLength + n + 1);
            for(var i = 0; i < n; i++)buffer[bufferLength++] = b;
        }
        this.bufferLength = bufferLength;
    };
    return RunLengthStream;
}((0, $6ff39b2bedd52666$export$2e2bcd8739ae039));
var $04ab37ade25dd344$export$2e2bcd8739ae039 = $04ab37ade25dd344$var$RunLengthStream;



var $a0659294f562ac04$var$decodeStream = function(stream, encoding, params) {
    if (encoding === (0, $dPHSK.default).of('FlateDecode')) return new (0, $106ef4d7516ef3d6$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $dPHSK.default).of('LZWDecode')) {
        var earlyChange = 1;
        if (params instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) {
            var EarlyChange = params.lookup((0, $dPHSK.default).of('EarlyChange'));
            if (EarlyChange instanceof (0, $j04jt.default)) earlyChange = EarlyChange.asNumber();
        }
        return new (0, $caad20b69225c7a9$export$2e2bcd8739ae039)(stream, undefined, earlyChange);
    }
    if (encoding === (0, $dPHSK.default).of('ASCII85Decode')) return new (0, $1d792bffef4b9a0f$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $dPHSK.default).of('ASCIIHexDecode')) return new (0, $e8d1eed445279b14$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $dPHSK.default).of('RunLengthDecode')) return new (0, $04ab37ade25dd344$export$2e2bcd8739ae039)(stream);
    throw new (0, $nAWRe.UnsupportedEncodingError)(encoding.asString());
};
var $a0659294f562ac04$export$b8317e68ca978594 = function(_a) {
    var dict = _a.dict, contents = _a.contents;
    var stream = new (0, $6994bc106090076a$export$2e2bcd8739ae039)(contents);
    var Filter = dict.lookup((0, $dPHSK.default).of('Filter'));
    var DecodeParms = dict.lookup((0, $dPHSK.default).of('DecodeParms'));
    if (Filter instanceof (0, $dPHSK.default)) stream = $a0659294f562ac04$var$decodeStream(stream, Filter, DecodeParms);
    else if (Filter instanceof (0, $8auL6.default)) for(var idx = 0, len = Filter.size(); idx < len; idx++)stream = $a0659294f562ac04$var$decodeStream(stream, Filter.lookup(idx, (0, $dPHSK.default)), DecodeParms && DecodeParms.lookupMaybe(idx, (0, $85408478fbb7cbde$export$2e2bcd8739ae039)));
    else if (!!Filter) throw new (0, $nAWRe.UnexpectedObjectTypeError)([
        (0, $dPHSK.default),
        (0, $8auL6.default)
    ], Filter);
    return stream;
};




var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $c7d58da35b52112a$var$fullPageBoundingBox = function(page) {
    var mediaBox = page.MediaBox();
    var width = mediaBox.lookup(2, (0, $j04jt.default)).asNumber() - mediaBox.lookup(0, (0, $j04jt.default)).asNumber();
    var height = mediaBox.lookup(3, (0, $j04jt.default)).asNumber() - mediaBox.lookup(1, (0, $j04jt.default)).asNumber();
    return {
        left: 0,
        bottom: 0,
        right: width,
        top: height
    };
};
// Returns the identity matrix, modified to position the content of the given
// bounding box at (0, 0).
var $c7d58da35b52112a$var$boundingBoxAdjustedMatrix = function(bb) {
    return [
        1,
        0,
        0,
        1,
        -bb.left,
        -bb.bottom
    ];
};
var $c7d58da35b52112a$var$PDFPageEmbedder = /** @class */ function() {
    function PDFPageEmbedder(page, boundingBox, transformationMatrix) {
        this.page = page;
        var bb = boundingBox !== null && boundingBox !== void 0 ? boundingBox : $c7d58da35b52112a$var$fullPageBoundingBox(page);
        this.width = bb.right - bb.left;
        this.height = bb.top - bb.bottom;
        this.boundingBox = bb;
        this.transformationMatrix = transformationMatrix !== null && transformationMatrix !== void 0 ? transformationMatrix : $c7d58da35b52112a$var$boundingBoxAdjustedMatrix(bb);
    }
    PDFPageEmbedder.for = function(page, boundingBox, transformationMatrix) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new PDFPageEmbedder(page, boundingBox, transformationMatrix)
                ];
            });
        });
    };
    PDFPageEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, Contents, Resources, decodedContents, _b, left, bottom, right, top, xObject;
            return (0, $cOQTW.__generator)(this, function(_c) {
                _a = this.page.normalizedEntries(), Contents = _a.Contents, Resources = _a.Resources;
                if (!Contents) throw new (0, $nAWRe.MissingPageContentsEmbeddingError)();
                decodedContents = this.decodeContents(Contents);
                _b = this.boundingBox, left = _b.left, bottom = _b.bottom, right = _b.right, top = _b.top;
                xObject = context.flateStream(decodedContents, {
                    Type: 'XObject',
                    Subtype: 'Form',
                    FormType: 1,
                    BBox: [
                        left,
                        bottom,
                        right,
                        top
                    ],
                    Matrix: this.transformationMatrix,
                    Resources: Resources
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    // `contents` is an array of streams which are merged to include them in the XObject.
    // This methods extracts each stream and joins them with a newline character.
    PDFPageEmbedder.prototype.decodeContents = function(contents) {
        var newline = Uint8Array.of((0, $8zvel.default).Newline);
        var decodedContents = [];
        for(var idx = 0, len = contents.size(); idx < len; idx++){
            var stream = contents.lookup(idx, (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039));
            var content = void 0;
            if (stream instanceof (0, $ef28c75b0f11042e$export$2e2bcd8739ae039)) content = (0, $a0659294f562ac04$export$b8317e68ca978594)(stream).decode();
            else if (stream instanceof (0, $707f21d02e4e1bf4$export$2e2bcd8739ae039)) content = stream.getUnencodedContents();
            else throw new (0, $nAWRe.UnrecognizedStreamTypeError)(stream);
            decodedContents.push(content, newline);
        }
        return (0, $4ISq8.mergeIntoTypedArray).apply(void 0, decodedContents);
    };
    return PDFPageEmbedder;
}();
var $c7d58da35b52112a$export$2e2bcd8739ae039 = $c7d58da35b52112a$var$PDFPageEmbedder;



var $cpTWE = parcelRequire("cpTWE");

var $11c5J = parcelRequire("11c5J");

var $8gQNC = parcelRequire("8gQNC");

var $j04jt = parcelRequire("j04jt");



var $dPHSK = parcelRequire("dPHSK");


var $8auL6 = parcelRequire("8auL6");






var $cOQTW = parcelRequire("cOQTW");


var $dPHSK = parcelRequire("dPHSK");

var $cOQTW = parcelRequire("cOQTW");



var $8auL6 = parcelRequire("8auL6");

var $dPHSK = parcelRequire("dPHSK");

var $cOQTW = parcelRequire("cOQTW");


var $dPHSK = parcelRequire("dPHSK");




var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $8auL6 = parcelRequire("8auL6");

parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");

var $nAWRe = parcelRequire("nAWRe");
// Examples:
//   `/Helv 12 Tf` -> ['Helv', '12']
//   `/HeBo 8.00 Tf` -> ['HeBo', '8.00']
//   `/HeBo Tf` -> ['HeBo', undefined]
var $3a62e0bdc23bf2e5$var$tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+Tf/;
var $3a62e0bdc23bf2e5$var$PDFAcroField = /** @class */ function() {
    function PDFAcroField(dict, ref) {
        this.dict = dict;
        this.ref = ref;
    }
    PDFAcroField.prototype.T = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('T'), (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039), (0, $e8537943f4279a06$export$2e2bcd8739ae039));
    };
    PDFAcroField.prototype.Ff = function() {
        var numberOrRef = this.getInheritableAttribute((0, $dPHSK.default).of('Ff'));
        return this.dict.context.lookupMaybe(numberOrRef, (0, $j04jt.default));
    };
    PDFAcroField.prototype.V = function() {
        var valueOrRef = this.getInheritableAttribute((0, $dPHSK.default).of('V'));
        return this.dict.context.lookup(valueOrRef);
    };
    PDFAcroField.prototype.Kids = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('Kids'), (0, $8auL6.default));
    };
    // Parent(): PDFDict | undefined {
    //   return this.dict.lookupMaybe(PDFName.of('Parent'), PDFDict);
    // }
    PDFAcroField.prototype.DA = function() {
        var da = this.dict.lookup((0, $dPHSK.default).of('DA'));
        if (da instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || da instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) return da;
        return undefined;
    };
    PDFAcroField.prototype.setKids = function(kids) {
        this.dict.set((0, $dPHSK.default).of('Kids'), this.dict.context.obj(kids));
    };
    PDFAcroField.prototype.getParent = function() {
        // const parent = this.Parent();
        // if (!parent) return undefined;
        // return new PDFAcroField(parent);
        var parentRef = this.dict.get((0, $dPHSK.default).of('Parent'));
        if (parentRef instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039)) {
            var parent_1 = this.dict.lookup((0, $dPHSK.default).of('Parent'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
            return new PDFAcroField(parent_1, parentRef);
        }
        return undefined;
    };
    PDFAcroField.prototype.setParent = function(parent) {
        if (!parent) this.dict.delete((0, $dPHSK.default).of('Parent'));
        else this.dict.set((0, $dPHSK.default).of('Parent'), parent);
    };
    PDFAcroField.prototype.getFullyQualifiedName = function() {
        var parent = this.getParent();
        if (!parent) return this.getPartialName();
        return parent.getFullyQualifiedName() + "." + this.getPartialName();
    };
    PDFAcroField.prototype.getPartialName = function() {
        var _a;
        return (_a = this.T()) === null || _a === void 0 ? void 0 : _a.decodeText();
    };
    PDFAcroField.prototype.setPartialName = function(partialName) {
        if (!partialName) this.dict.delete((0, $dPHSK.default).of('T'));
        else this.dict.set((0, $dPHSK.default).of('T'), (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(partialName));
    };
    PDFAcroField.prototype.setDefaultAppearance = function(appearance) {
        this.dict.set((0, $dPHSK.default).of('DA'), (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).of(appearance));
    };
    PDFAcroField.prototype.getDefaultAppearance = function() {
        var DA = this.DA();
        if (DA instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) return DA.decodeText();
        return DA === null || DA === void 0 ? void 0 : DA.asString();
    };
    PDFAcroField.prototype.setFontSize = function(fontSize) {
        var _a;
        var name = (_a = this.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : '';
        var da = this.getDefaultAppearance();
        if (!da) throw new (0, $nAWRe.MissingDAEntryError)(name);
        var daMatch = (0, $7Kmy8.findLastMatch)(da, $3a62e0bdc23bf2e5$var$tfRegex);
        if (!daMatch.match) throw new (0, $nAWRe.MissingTfOperatorError)(name);
        var daStart = da.slice(0, daMatch.pos - daMatch.match[0].length);
        var daEnd = daMatch.pos <= da.length ? da.slice(daMatch.pos) : '';
        var fontName = daMatch.match[1];
        var modifiedDa = daStart + " /" + fontName + " " + fontSize + " Tf " + daEnd;
        this.setDefaultAppearance(modifiedDa);
    };
    PDFAcroField.prototype.getFlags = function() {
        var _a, _b;
        return (_b = (_a = this.Ff()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
    };
    PDFAcroField.prototype.setFlags = function(flags) {
        this.dict.set((0, $dPHSK.default).of('Ff'), (0, $j04jt.default).of(flags));
    };
    PDFAcroField.prototype.hasFlag = function(flag) {
        var flags = this.getFlags();
        return (flags & flag) !== 0;
    };
    PDFAcroField.prototype.setFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags | flag);
    };
    PDFAcroField.prototype.clearFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags & ~flag);
    };
    PDFAcroField.prototype.setFlagTo = function(flag, enable) {
        if (enable) this.setFlag(flag);
        else this.clearFlag(flag);
    };
    PDFAcroField.prototype.getInheritableAttribute = function(name) {
        var attribute;
        this.ascend(function(node) {
            if (!attribute) attribute = node.dict.get(name);
        });
        return attribute;
    };
    PDFAcroField.prototype.ascend = function(visitor) {
        visitor(this);
        var parent = this.getParent();
        if (parent) parent.ascend(visitor);
    };
    return PDFAcroField;
}();
var $3a62e0bdc23bf2e5$export$2e2bcd8739ae039 = $3a62e0bdc23bf2e5$var$PDFAcroField;



var $cOQTW = parcelRequire("cOQTW");


var $dPHSK = parcelRequire("dPHSK");




var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");
// TODO: Also handle the `/S` and `/D` entries
var $1cccd5df89c90385$var$BorderStyle = /** @class */ function() {
    function BorderStyle(dict) {
        this.dict = dict;
    }
    BorderStyle.prototype.W = function() {
        var W = this.dict.lookup((0, $dPHSK.default).of('W'));
        if (W instanceof (0, $j04jt.default)) return W;
        return undefined;
    };
    BorderStyle.prototype.getWidth = function() {
        var _a, _b;
        return (_b = (_a = this.W()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
    };
    BorderStyle.prototype.setWidth = function(width) {
        var W = this.dict.context.obj(width);
        this.dict.set((0, $dPHSK.default).of('W'), W);
    };
    BorderStyle.fromDict = function(dict) {
        return new BorderStyle(dict);
    };
    return BorderStyle;
}();
var $1cccd5df89c90385$export$2e2bcd8739ae039 = $1cccd5df89c90385$var$BorderStyle;




var $dPHSK = parcelRequire("dPHSK");


var $8auL6 = parcelRequire("8auL6");


var $j04jt = parcelRequire("j04jt");
var $b3d65ce7bc0fb74b$var$PDFAnnotation = /** @class */ function() {
    function PDFAnnotation(dict) {
        this.dict = dict;
    }
    // This is technically required by the PDF spec
    PDFAnnotation.prototype.Rect = function() {
        return this.dict.lookup((0, $dPHSK.default).of('Rect'), (0, $8auL6.default));
    };
    PDFAnnotation.prototype.AP = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('AP'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
    };
    PDFAnnotation.prototype.F = function() {
        var numberOrRef = this.dict.lookup((0, $dPHSK.default).of('F'));
        return this.dict.context.lookupMaybe(numberOrRef, (0, $j04jt.default));
    };
    PDFAnnotation.prototype.getRectangle = function() {
        var _a;
        var Rect = this.Rect();
        return (_a = Rect === null || Rect === void 0 ? void 0 : Rect.asRectangle()) !== null && _a !== void 0 ? _a : {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    };
    PDFAnnotation.prototype.setRectangle = function(rect) {
        var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
        var Rect = this.dict.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.dict.set((0, $dPHSK.default).of('Rect'), Rect);
    };
    PDFAnnotation.prototype.getAppearanceState = function() {
        var AS = this.dict.lookup((0, $dPHSK.default).of('AS'));
        if (AS instanceof (0, $dPHSK.default)) return AS;
        return undefined;
    };
    PDFAnnotation.prototype.setAppearanceState = function(state) {
        this.dict.set((0, $dPHSK.default).of('AS'), state);
    };
    PDFAnnotation.prototype.setAppearances = function(appearances) {
        this.dict.set((0, $dPHSK.default).of('AP'), appearances);
    };
    PDFAnnotation.prototype.ensureAP = function() {
        var AP = this.AP();
        if (!AP) {
            AP = this.dict.context.obj({});
            this.dict.set((0, $dPHSK.default).of('AP'), AP);
        }
        return AP;
    };
    PDFAnnotation.prototype.getNormalAppearance = function() {
        var AP = this.ensureAP();
        var N = AP.get((0, $dPHSK.default).of('N'));
        if (N instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039) || N instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) return N;
        throw new Error("Unexpected N type: " + (N === null || N === void 0 ? void 0 : N.constructor.name));
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setNormalAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $dPHSK.default).of('N'), appearance);
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setRolloverAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $dPHSK.default).of('R'), appearance);
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setDownAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $dPHSK.default).of('D'), appearance);
    };
    PDFAnnotation.prototype.removeRolloverAppearance = function() {
        var AP = this.AP();
        AP === null || AP === void 0 || AP.delete((0, $dPHSK.default).of('R'));
    };
    PDFAnnotation.prototype.removeDownAppearance = function() {
        var AP = this.AP();
        AP === null || AP === void 0 || AP.delete((0, $dPHSK.default).of('D'));
    };
    PDFAnnotation.prototype.getAppearances = function() {
        var AP = this.AP();
        if (!AP) return undefined;
        var N = AP.lookup((0, $dPHSK.default).of('N'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039), (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039));
        var R = AP.lookupMaybe((0, $dPHSK.default).of('R'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039), (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039));
        var D = AP.lookupMaybe((0, $dPHSK.default).of('D'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039), (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039));
        return {
            normal: N,
            rollover: R,
            down: D
        };
    };
    PDFAnnotation.prototype.getFlags = function() {
        var _a, _b;
        return (_b = (_a = this.F()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
    };
    PDFAnnotation.prototype.setFlags = function(flags) {
        this.dict.set((0, $dPHSK.default).of('F'), (0, $j04jt.default).of(flags));
    };
    PDFAnnotation.prototype.hasFlag = function(flag) {
        var flags = this.getFlags();
        return (flags & flag) !== 0;
    };
    PDFAnnotation.prototype.setFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags | flag);
    };
    PDFAnnotation.prototype.clearFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags & ~flag);
    };
    PDFAnnotation.prototype.setFlagTo = function(flag, enable) {
        if (enable) this.setFlag(flag);
        else this.clearFlag(flag);
    };
    PDFAnnotation.fromDict = function(dict) {
        return new PDFAnnotation(dict);
    };
    return PDFAnnotation;
}();
var $b3d65ce7bc0fb74b$export$2e2bcd8739ae039 = $b3d65ce7bc0fb74b$var$PDFAnnotation;



var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $8auL6 = parcelRequire("8auL6");


var $4649f56151c7fd29$var$AppearanceCharacteristics = /** @class */ function() {
    function AppearanceCharacteristics(dict) {
        this.dict = dict;
    }
    AppearanceCharacteristics.prototype.R = function() {
        var R = this.dict.lookup((0, $dPHSK.default).of('R'));
        if (R instanceof (0, $j04jt.default)) return R;
        return undefined;
    };
    AppearanceCharacteristics.prototype.BC = function() {
        var BC = this.dict.lookup((0, $dPHSK.default).of('BC'));
        if (BC instanceof (0, $8auL6.default)) return BC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.BG = function() {
        var BG = this.dict.lookup((0, $dPHSK.default).of('BG'));
        if (BG instanceof (0, $8auL6.default)) return BG;
        return undefined;
    };
    AppearanceCharacteristics.prototype.CA = function() {
        var CA = this.dict.lookup((0, $dPHSK.default).of('CA'));
        if (CA instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039) || CA instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039)) return CA;
        return undefined;
    };
    AppearanceCharacteristics.prototype.RC = function() {
        var RC = this.dict.lookup((0, $dPHSK.default).of('RC'));
        if (RC instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039) || RC instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039)) return RC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.AC = function() {
        var AC = this.dict.lookup((0, $dPHSK.default).of('AC'));
        if (AC instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039) || AC instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039)) return AC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.getRotation = function() {
        var _a;
        return (_a = this.R()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    AppearanceCharacteristics.prototype.getBorderColor = function() {
        var BC = this.BC();
        if (!BC) return undefined;
        var components = [];
        for(var idx = 0, len = BC === null || BC === void 0 ? void 0 : BC.size(); idx < len; idx++){
            var component = BC.get(idx);
            if (component instanceof (0, $j04jt.default)) components.push(component.asNumber());
        }
        return components;
    };
    AppearanceCharacteristics.prototype.getBackgroundColor = function() {
        var BG = this.BG();
        if (!BG) return undefined;
        var components = [];
        for(var idx = 0, len = BG === null || BG === void 0 ? void 0 : BG.size(); idx < len; idx++){
            var component = BG.get(idx);
            if (component instanceof (0, $j04jt.default)) components.push(component.asNumber());
        }
        return components;
    };
    AppearanceCharacteristics.prototype.getCaptions = function() {
        var CA = this.CA();
        var RC = this.RC();
        var AC = this.AC();
        return {
            normal: CA === null || CA === void 0 ? void 0 : CA.decodeText(),
            rollover: RC === null || RC === void 0 ? void 0 : RC.decodeText(),
            down: AC === null || AC === void 0 ? void 0 : AC.decodeText()
        };
    };
    AppearanceCharacteristics.prototype.setRotation = function(rotation) {
        var R = this.dict.context.obj(rotation);
        this.dict.set((0, $dPHSK.default).of('R'), R);
    };
    AppearanceCharacteristics.prototype.setBorderColor = function(color) {
        var BC = this.dict.context.obj(color);
        this.dict.set((0, $dPHSK.default).of('BC'), BC);
    };
    AppearanceCharacteristics.prototype.setBackgroundColor = function(color) {
        var BG = this.dict.context.obj(color);
        this.dict.set((0, $dPHSK.default).of('BG'), BG);
    };
    AppearanceCharacteristics.prototype.setCaptions = function(captions) {
        var CA = (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(captions.normal);
        this.dict.set((0, $dPHSK.default).of('CA'), CA);
        if (captions.rollover) {
            var RC = (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(captions.rollover);
            this.dict.set((0, $dPHSK.default).of('RC'), RC);
        } else this.dict.delete((0, $dPHSK.default).of('RC'));
        if (captions.down) {
            var AC = (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(captions.down);
            this.dict.set((0, $dPHSK.default).of('AC'), AC);
        } else this.dict.delete((0, $dPHSK.default).of('AC'));
    };
    AppearanceCharacteristics.fromDict = function(dict) {
        return new AppearanceCharacteristics(dict);
    };
    return AppearanceCharacteristics;
}();
var $4649f56151c7fd29$export$2e2bcd8739ae039 = $4649f56151c7fd29$var$AppearanceCharacteristics;


var $540f7922618e60a2$var$PDFWidgetAnnotation = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFWidgetAnnotation, _super);
    function PDFWidgetAnnotation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFWidgetAnnotation.prototype.MK = function() {
        var MK = this.dict.lookup((0, $dPHSK.default).of('MK'));
        if (MK instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) return MK;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.BS = function() {
        var BS = this.dict.lookup((0, $dPHSK.default).of('BS'));
        if (BS instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) return BS;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.DA = function() {
        var da = this.dict.lookup((0, $dPHSK.default).of('DA'));
        if (da instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || da instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) return da;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.P = function() {
        var P = this.dict.get((0, $dPHSK.default).of('P'));
        if (P instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039)) return P;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.setP = function(page) {
        this.dict.set((0, $dPHSK.default).of('P'), page);
    };
    PDFWidgetAnnotation.prototype.setDefaultAppearance = function(appearance) {
        this.dict.set((0, $dPHSK.default).of('DA'), (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).of(appearance));
    };
    PDFWidgetAnnotation.prototype.getDefaultAppearance = function() {
        var DA = this.DA();
        if (DA instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) return DA.decodeText();
        return DA === null || DA === void 0 ? void 0 : DA.asString();
    };
    PDFWidgetAnnotation.prototype.getAppearanceCharacteristics = function() {
        var MK = this.MK();
        if (MK) return (0, $4649f56151c7fd29$export$2e2bcd8739ae039).fromDict(MK);
        return undefined;
    };
    PDFWidgetAnnotation.prototype.getOrCreateAppearanceCharacteristics = function() {
        var MK = this.MK();
        if (MK) return (0, $4649f56151c7fd29$export$2e2bcd8739ae039).fromDict(MK);
        var ac = (0, $4649f56151c7fd29$export$2e2bcd8739ae039).fromDict(this.dict.context.obj({}));
        this.dict.set((0, $dPHSK.default).of('MK'), ac.dict);
        return ac;
    };
    PDFWidgetAnnotation.prototype.getBorderStyle = function() {
        var BS = this.BS();
        if (BS) return (0, $1cccd5df89c90385$export$2e2bcd8739ae039).fromDict(BS);
        return undefined;
    };
    PDFWidgetAnnotation.prototype.getOrCreateBorderStyle = function() {
        var BS = this.BS();
        if (BS) return (0, $1cccd5df89c90385$export$2e2bcd8739ae039).fromDict(BS);
        var bs = (0, $1cccd5df89c90385$export$2e2bcd8739ae039).fromDict(this.dict.context.obj({}));
        this.dict.set((0, $dPHSK.default).of('BS'), bs.dict);
        return bs;
    };
    PDFWidgetAnnotation.prototype.getOnValue = function() {
        var _a;
        var normal = (_a = this.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
        if (normal instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) {
            var keys = normal.keys();
            for(var idx = 0, len = keys.length; idx < len; idx++){
                var key = keys[idx];
                if (key !== (0, $dPHSK.default).of('Off')) return key;
            }
        }
        return undefined;
    };
    PDFWidgetAnnotation.fromDict = function(dict) {
        return new PDFWidgetAnnotation(dict);
    };
    PDFWidgetAnnotation.create = function(context, parent) {
        var dict = context.obj({
            Type: 'Annot',
            Subtype: 'Widget',
            Rect: [
                0,
                0,
                0,
                0
            ],
            Parent: parent
        });
        return new PDFWidgetAnnotation(dict);
    };
    return PDFWidgetAnnotation;
}((0, $b3d65ce7bc0fb74b$export$2e2bcd8739ae039));
var $540f7922618e60a2$export$2e2bcd8739ae039 = $540f7922618e60a2$var$PDFWidgetAnnotation;



var $nAWRe = parcelRequire("nAWRe");
var $46d285649821c095$var$PDFAcroTerminal = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroTerminal, _super);
    function PDFAcroTerminal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroTerminal.prototype.FT = function() {
        var nameOrRef = this.getInheritableAttribute((0, $dPHSK.default).of('FT'));
        return this.dict.context.lookup(nameOrRef, (0, $dPHSK.default));
    };
    PDFAcroTerminal.prototype.getWidgets = function() {
        var kidDicts = this.Kids();
        // This field is itself a widget
        if (!kidDicts) return [
            (0, $540f7922618e60a2$export$2e2bcd8739ae039).fromDict(this.dict)
        ];
        // This field's kids are its widgets
        var widgets = new Array(kidDicts.size());
        for(var idx = 0, len = kidDicts.size(); idx < len; idx++){
            var dict = kidDicts.lookup(idx, (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
            widgets[idx] = (0, $540f7922618e60a2$export$2e2bcd8739ae039).fromDict(dict);
        }
        return widgets;
    };
    PDFAcroTerminal.prototype.addWidget = function(ref) {
        var Kids = this.normalizedEntries().Kids;
        Kids.push(ref);
    };
    PDFAcroTerminal.prototype.removeWidget = function(idx) {
        var kidDicts = this.Kids();
        if (!kidDicts) {
            // This field is itself a widget
            if (idx !== 0) throw new (0, $nAWRe.IndexOutOfBoundsError)(idx, 0, 0);
            this.setKids([]);
        } else {
            // This field's kids are its widgets
            if (idx < 0 || idx > kidDicts.size()) throw new (0, $nAWRe.IndexOutOfBoundsError)(idx, 0, kidDicts.size());
            kidDicts.remove(idx);
        }
    };
    PDFAcroTerminal.prototype.normalizedEntries = function() {
        var Kids = this.Kids();
        // If this field is itself a widget (because it was only rendered once in
        // the document, so the field and widget properties were merged) then we
        // add itself to the `Kids` array. The alternative would be to try
        // splitting apart the widget properties and creating a separate object
        // for them.
        if (!Kids) {
            Kids = this.dict.context.obj([
                this.ref
            ]);
            this.dict.set((0, $dPHSK.default).of('Kids'), Kids);
        }
        return {
            Kids: Kids
        };
    };
    PDFAcroTerminal.fromDict = function(dict, ref) {
        return new PDFAcroTerminal(dict, ref);
    };
    return PDFAcroTerminal;
}((0, $3a62e0bdc23bf2e5$export$2e2bcd8739ae039));
var $46d285649821c095$export$2e2bcd8739ae039 = $46d285649821c095$var$PDFAcroTerminal;



var $nAWRe = parcelRequire("nAWRe");
var $8b75e0d2aabd8761$var$PDFAcroButton = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroButton, _super);
    function PDFAcroButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroButton.prototype.Opt = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('Opt'), (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039), (0, $e8537943f4279a06$export$2e2bcd8739ae039), (0, $8auL6.default));
    };
    PDFAcroButton.prototype.setOpt = function(opt) {
        this.dict.set((0, $dPHSK.default).of('Opt'), this.dict.context.obj(opt));
    };
    PDFAcroButton.prototype.getExportValues = function() {
        var opt = this.Opt();
        if (!opt) return undefined;
        if (opt instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || opt instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) return [
            opt
        ];
        var values = [];
        for(var idx = 0, len = opt.size(); idx < len; idx++){
            var value = opt.lookup(idx);
            if (value instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || value instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) values.push(value);
        }
        return values;
    };
    PDFAcroButton.prototype.removeExportValue = function(idx) {
        var opt = this.Opt();
        if (!opt) return;
        if (opt instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || opt instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) {
            if (idx !== 0) throw new (0, $nAWRe.IndexOutOfBoundsError)(idx, 0, 0);
            this.setOpt([]);
        } else {
            if (idx < 0 || idx > opt.size()) throw new (0, $nAWRe.IndexOutOfBoundsError)(idx, 0, opt.size());
            opt.remove(idx);
        }
    };
    // Enforce use use of /Opt even if it isn't strictly necessary
    PDFAcroButton.prototype.normalizeExportValues = function() {
        var _a, _b, _c, _d;
        var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
        var Opt = [];
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var exportVal = (_b = exportValues[idx]) !== null && _b !== void 0 ? _b : (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText((_d = (_c = widget.getOnValue()) === null || _c === void 0 ? void 0 : _c.decodeText()) !== null && _d !== void 0 ? _d : '');
            Opt.push(exportVal);
        }
        this.setOpt(Opt);
    };
    /**
     * Reuses existing opt if one exists with the same value (assuming
     * `useExistingIdx` is `true`). Returns index of existing (or new) opt.
     */ PDFAcroButton.prototype.addOpt = function(opt, useExistingOptIdx) {
        var _a;
        this.normalizeExportValues();
        var optText = opt.decodeText();
        var existingIdx;
        if (useExistingOptIdx) {
            var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
            for(var idx = 0, len = exportValues.length; idx < len; idx++){
                var exportVal = exportValues[idx];
                if (exportVal.decodeText() === optText) existingIdx = idx;
            }
        }
        var Opt = this.Opt();
        Opt.push(opt);
        return existingIdx !== null && existingIdx !== void 0 ? existingIdx : Opt.size() - 1;
    };
    PDFAcroButton.prototype.addWidgetWithOpt = function(widget, opt, useExistingOptIdx) {
        var optIdx = this.addOpt(opt, useExistingOptIdx);
        var apStateValue = (0, $dPHSK.default).of(String(optIdx));
        this.addWidget(widget);
        return apStateValue;
    };
    return PDFAcroButton;
}((0, $46d285649821c095$export$2e2bcd8739ae039));
var $8b75e0d2aabd8761$export$2e2bcd8739ae039 = $8b75e0d2aabd8761$var$PDFAcroButton;



var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");


var $nAWRe = parcelRequire("nAWRe");
var $f8e31b0e21e15332$var$PDFAcroCheckBox = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroCheckBox, _super);
    function PDFAcroCheckBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroCheckBox.prototype.setValue = function(value) {
        var _a;
        var onValue = (_a = this.getOnValue()) !== null && _a !== void 0 ? _a : (0, $dPHSK.default).of('Yes');
        if (value !== onValue && value !== (0, $dPHSK.default).of('Off')) throw new (0, $nAWRe.InvalidAcroFieldValueError)();
        this.dict.set((0, $dPHSK.default).of('V'), value);
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getOnValue() === value ? value : (0, $dPHSK.default).of('Off');
            widget.setAppearanceState(state);
        }
    };
    PDFAcroCheckBox.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $dPHSK.default)) return v;
        return (0, $dPHSK.default).of('Off');
    };
    PDFAcroCheckBox.prototype.getOnValue = function() {
        var widget = this.getWidgets()[0];
        return widget === null || widget === void 0 ? void 0 : widget.getOnValue();
    };
    PDFAcroCheckBox.fromDict = function(dict, ref) {
        return new PDFAcroCheckBox(dict, ref);
    };
    PDFAcroCheckBox.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroCheckBox(dict, ref);
    };
    return PDFAcroCheckBox;
}((0, $8b75e0d2aabd8761$export$2e2bcd8739ae039));
var $f8e31b0e21e15332$export$2e2bcd8739ae039 = $f8e31b0e21e15332$var$PDFAcroCheckBox;



var $cOQTW = parcelRequire("cOQTW");




var $8auL6 = parcelRequire("8auL6");

var $dPHSK = parcelRequire("dPHSK");
var $987e37c460e8464e$var$flag = function(bitIndex) {
    return 1 << bitIndex;
};
var $987e37c460e8464e$export$3600c95532547643;
(function(AcroFieldFlags) {
    /**
     * If set, the user may not change the value of the field. Any associated
     * widget annotations will not interact with the user; that is, they will not
     * respond to mouse clicks or change their appearance in response to mouse
     * motions. This flag is useful for fields whose values are computed or
     * imported from a database.
     */ AcroFieldFlags[AcroFieldFlags["ReadOnly"] = $987e37c460e8464e$var$flag(0)] = "ReadOnly";
    /**
     * If set, the field shall have a value at the time it is exported by a
     * submit-form action (see 12.7.5.2, "Submit-Form Action").
     */ AcroFieldFlags[AcroFieldFlags["Required"] = $987e37c460e8464e$var$flag(1)] = "Required";
    /**
     * If set, the field shall not be exported by a submit-form action
     * (see 12.7.5.2, "Submit-Form Action").
     */ AcroFieldFlags[AcroFieldFlags["NoExport"] = $987e37c460e8464e$var$flag(2)] = "NoExport";
})($987e37c460e8464e$export$3600c95532547643 || ($987e37c460e8464e$export$3600c95532547643 = {}));
var $987e37c460e8464e$export$59f660e89ffb4f8a;
(function(AcroButtonFlags) {
    /**
     * (Radio buttons only) If set, exactly one radio button shall be selected at
     * all times; selecting the currently selected button has no effect. If clear,
     * clicking the selected button deselects it, leaving no button selected.
     */ AcroButtonFlags[AcroButtonFlags["NoToggleToOff"] = $987e37c460e8464e$var$flag(14)] = "NoToggleToOff";
    /**
     * If set, the field is a set of radio buttons; if clear, the field is a check
     * box. This flag may be set only if the Pushbutton flag is clear.
     */ AcroButtonFlags[AcroButtonFlags["Radio"] = $987e37c460e8464e$var$flag(15)] = "Radio";
    /**
     * If set, the field is a pushbutton that does not retain a permanent value.
     */ AcroButtonFlags[AcroButtonFlags["PushButton"] = $987e37c460e8464e$var$flag(16)] = "PushButton";
    /**
     * If set, a group of radio buttons within a radio button field that use the
     * same value for the on state will turn on and off in unison; that is if one
     * is checked, they are all checked. If clear, the buttons are mutually
     * exclusive (the same behavior as HTML radio buttons).
     */ AcroButtonFlags[AcroButtonFlags["RadiosInUnison"] = $987e37c460e8464e$var$flag(25)] = "RadiosInUnison";
})($987e37c460e8464e$export$59f660e89ffb4f8a || ($987e37c460e8464e$export$59f660e89ffb4f8a = {}));
var $987e37c460e8464e$export$389fc7b97397dc8b;
(function(AcroTextFlags) {
    /**
     * If set, the field may contain multiple lines of text; if clear, the field's
     * text shall be restricted to a single line.
     */ AcroTextFlags[AcroTextFlags["Multiline"] = $987e37c460e8464e$var$flag(12)] = "Multiline";
    /**
     * If set, the field is intended for entering a secure password that should
     * not be echoed visibly to the screen. Characters typed from the keyboard
     * shall instead be echoed in some unreadable form, such as asterisks or
     * bullet characters.
     * > NOTE   To protect password confidentiality, readers should never store
     * >        the value of the text field in the PDF file if this flag is set.
     */ AcroTextFlags[AcroTextFlags["Password"] = $987e37c460e8464e$var$flag(13)] = "Password";
    /**
     * If set, the text entered in the field represents the pathname of a file
     * whose contents shall be submitted as the value of the field.
     */ AcroTextFlags[AcroTextFlags["FileSelect"] = $987e37c460e8464e$var$flag(20)] = "FileSelect";
    /**
     * If set, text entered in the field shall not be spell-checked.
     */ AcroTextFlags[AcroTextFlags["DoNotSpellCheck"] = $987e37c460e8464e$var$flag(22)] = "DoNotSpellCheck";
    /**
     * If set, the field shall not scroll (horizontally for single-line fields,
     * vertically for multiple-line fields) to accommodate more text than fits
     * within its annotation rectangle. Once the field is full, no further text
     * shall be accepted for interactive form filling; for non-interactive form
     * filling, the filler should take care not to add more character than will
     * visibly fit in the defined area.
     */ AcroTextFlags[AcroTextFlags["DoNotScroll"] = $987e37c460e8464e$var$flag(23)] = "DoNotScroll";
    /**
     * May be set only if the MaxLen entry is present in the text field dictionary
     * (see Table 229) and if the Multiline, Password, and FileSelect flags are
     * clear. If set, the field shall be automatically divided into as many
     * equally spaced positions, or combs, as the value of MaxLen, and the text
     * is laid out into those combs.
     */ AcroTextFlags[AcroTextFlags["Comb"] = $987e37c460e8464e$var$flag(24)] = "Comb";
    /**
     * If set, the value of this field shall be a rich text string
     * (see 12.7.3.4, "Rich Text Strings"). If the field has a value, the RV
     * entry of the field dictionary (Table 222) shall specify the rich text
     * string.
     */ AcroTextFlags[AcroTextFlags["RichText"] = $987e37c460e8464e$var$flag(25)] = "RichText";
})($987e37c460e8464e$export$389fc7b97397dc8b || ($987e37c460e8464e$export$389fc7b97397dc8b = {}));
var $987e37c460e8464e$export$eb88827058402599;
(function(AcroChoiceFlags) {
    /**
     * If set, the field is a combo box; if clear, the field is a list box.
     */ AcroChoiceFlags[AcroChoiceFlags["Combo"] = $987e37c460e8464e$var$flag(17)] = "Combo";
    /**
     * If set, the combo box shall include an editable text box as well as a
     * drop-down list; if clear, it shall include only a drop-down list. This
     * flag shall be used only if the Combo flag is set.
     */ AcroChoiceFlags[AcroChoiceFlags["Edit"] = $987e37c460e8464e$var$flag(18)] = "Edit";
    /**
     * If set, the field's option items shall be sorted alphabetically. This flag
     * is intended for use by writers, not by readers. Conforming readers shall
     * display the options in the order in which they occur in the Opt array
     * (see Table 231).
     */ AcroChoiceFlags[AcroChoiceFlags["Sort"] = $987e37c460e8464e$var$flag(19)] = "Sort";
    /**
     * If set, more than one of the field's option items may be selected
     * simultaneously; if clear, at most one item shall be selected.
     */ AcroChoiceFlags[AcroChoiceFlags["MultiSelect"] = $987e37c460e8464e$var$flag(21)] = "MultiSelect";
    /**
     * If set, text entered in the field shall not be spell-checked. This flag
     * shall not be used unless the Combo and Edit flags are both set.
     */ AcroChoiceFlags[AcroChoiceFlags["DoNotSpellCheck"] = $987e37c460e8464e$var$flag(22)] = "DoNotSpellCheck";
    /**
     * If set, the new value shall be committed as soon as a selection is made
     * (commonly with the pointing device). In this case, supplying a value for
     * a field involves three actions: selecting the field for fill-in,
     * selecting a choice for the fill-in value, and leaving that field, which
     * finalizes or "commits" the data choice and triggers any actions associated
     * with the entry or changing of this data. If this flag is on, then
     * processing does not wait for leaving the field action to occur, but
     * immediately proceeds to the third step.
     *
     * This option enables applications to perform an action once a selection is
     * made, without requiring the user to exit the field. If clear, the new
     * value is not committed until the user exits the field.
     */ AcroChoiceFlags[AcroChoiceFlags["CommitOnSelChange"] = $987e37c460e8464e$var$flag(26)] = "CommitOnSelChange";
})($987e37c460e8464e$export$eb88827058402599 || ($987e37c460e8464e$export$eb88827058402599 = {}));



var $nAWRe = parcelRequire("nAWRe");
var $10788dcfb83fdb6c$var$PDFAcroChoice = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroChoice, _super);
    function PDFAcroChoice() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroChoice.prototype.setValues = function(values) {
        if (this.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).Combo) && !this.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).Edit) && !this.valuesAreValid(values)) throw new (0, $nAWRe.InvalidAcroFieldValueError)();
        if (values.length === 0) this.dict.delete((0, $dPHSK.default).of('V'));
        if (values.length === 1) this.dict.set((0, $dPHSK.default).of('V'), values[0]);
        if (values.length > 1) {
            if (!this.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).MultiSelect)) throw new (0, $nAWRe.MultiSelectValueError)();
            this.dict.set((0, $dPHSK.default).of('V'), this.dict.context.obj(values));
        }
        this.updateSelectedIndices(values);
    };
    PDFAcroChoice.prototype.valuesAreValid = function(values) {
        var options = this.getOptions();
        var _loop_1 = function(idx, len) {
            var val = values[idx].decodeText();
            if (!options.find(function(o) {
                return val === (o.display || o.value).decodeText();
            })) return {
                value: false
            };
        };
        for(var idx = 0, len = values.length; idx < len; idx++){
            var state_1 = _loop_1(idx, len);
            if (typeof state_1 === "object") return state_1.value;
        }
        return true;
    };
    PDFAcroChoice.prototype.updateSelectedIndices = function(values) {
        if (values.length > 1) {
            var indices = new Array(values.length);
            var options = this.getOptions();
            var _loop_2 = function(idx, len) {
                var val = values[idx].decodeText();
                indices[idx] = options.findIndex(function(o) {
                    return val === (o.display || o.value).decodeText();
                });
            };
            for(var idx = 0, len = values.length; idx < len; idx++)_loop_2(idx, len);
            this.dict.set((0, $dPHSK.default).of('I'), this.dict.context.obj(indices.sort()));
        } else this.dict.delete((0, $dPHSK.default).of('I'));
    };
    PDFAcroChoice.prototype.getValues = function() {
        var v = this.V();
        if (v instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || v instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) return [
            v
        ];
        if (v instanceof (0, $8auL6.default)) {
            var values = [];
            for(var idx = 0, len = v.size(); idx < len; idx++){
                var value = v.lookup(idx);
                if (value instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || value instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) values.push(value);
            }
            return values;
        }
        return [];
    };
    PDFAcroChoice.prototype.Opt = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('Opt'), (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039), (0, $e8537943f4279a06$export$2e2bcd8739ae039), (0, $8auL6.default));
    };
    PDFAcroChoice.prototype.setOptions = function(options) {
        var newOpt = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = options[idx], value = _a.value, display = _a.display;
            newOpt[idx] = this.dict.context.obj([
                value,
                display || value
            ]);
        }
        this.dict.set((0, $dPHSK.default).of('Opt'), this.dict.context.obj(newOpt));
    };
    PDFAcroChoice.prototype.getOptions = function() {
        var Opt = this.Opt();
        // Not supposed to happen - Opt _should_ always be `PDFArray | undefined`
        if (Opt instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || Opt instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) return [
            {
                value: Opt,
                display: Opt
            }
        ];
        if (Opt instanceof (0, $8auL6.default)) {
            var res = [];
            for(var idx = 0, len = Opt.size(); idx < len; idx++){
                var item = Opt.lookup(idx);
                // If `item` is a string, use that as both the export and text value
                if (item instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || item instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) res.push({
                    value: item,
                    display: item
                });
                // If `item` is an array of one, treat it the same as just a string,
                // if it's an array of two then `item[0]` is the export value and
                // `item[1]` is the text value
                if (item instanceof (0, $8auL6.default)) {
                    if (item.size() > 0) {
                        var first = item.lookup(0, (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039), (0, $e8537943f4279a06$export$2e2bcd8739ae039));
                        var second = item.lookupMaybe(1, (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039), (0, $e8537943f4279a06$export$2e2bcd8739ae039));
                        res.push({
                            value: first,
                            display: second || first
                        });
                    }
                }
            }
            return res;
        }
        return [];
    };
    return PDFAcroChoice;
}((0, $46d285649821c095$export$2e2bcd8739ae039));
var $10788dcfb83fdb6c$export$2e2bcd8739ae039 = $10788dcfb83fdb6c$var$PDFAcroChoice;



var $cOQTW = parcelRequire("cOQTW");


var $3488827c1474fcce$var$PDFAcroComboBox = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroComboBox, _super);
    function PDFAcroComboBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroComboBox.fromDict = function(dict, ref) {
        return new PDFAcroComboBox(dict, ref);
    };
    PDFAcroComboBox.create = function(context) {
        var dict = context.obj({
            FT: 'Ch',
            Ff: (0, $987e37c460e8464e$export$eb88827058402599).Combo,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroComboBox(dict, ref);
    };
    return PDFAcroComboBox;
}((0, $10788dcfb83fdb6c$export$2e2bcd8739ae039));
var $3488827c1474fcce$export$2e2bcd8739ae039 = $3488827c1474fcce$var$PDFAcroComboBox;





var $8auL6 = parcelRequire("8auL6");

var $dPHSK = parcelRequire("dPHSK");

var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");

var $a105ec5aeb848914$var$PDFAcroNonTerminal = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroNonTerminal, _super);
    function PDFAcroNonTerminal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroNonTerminal.prototype.addField = function(field) {
        var Kids = this.normalizedEntries().Kids;
        Kids === null || Kids === void 0 || Kids.push(field);
    };
    PDFAcroNonTerminal.prototype.normalizedEntries = function() {
        var Kids = this.Kids();
        if (!Kids) {
            Kids = this.dict.context.obj([]);
            this.dict.set((0, $dPHSK.default).of('Kids'), Kids);
        }
        return {
            Kids: Kids
        };
    };
    PDFAcroNonTerminal.fromDict = function(dict, ref) {
        return new PDFAcroNonTerminal(dict, ref);
    };
    PDFAcroNonTerminal.create = function(context) {
        var dict = context.obj({});
        var ref = context.register(dict);
        return new PDFAcroNonTerminal(dict, ref);
    };
    return PDFAcroNonTerminal;
}((0, $3a62e0bdc23bf2e5$export$2e2bcd8739ae039));
var $a105ec5aeb848914$export$2e2bcd8739ae039 = $a105ec5aeb848914$var$PDFAcroNonTerminal;



var $j04jt = parcelRequire("j04jt");


var $dPHSK = parcelRequire("dPHSK");

var $8auL6 = parcelRequire("8auL6");




var $cOQTW = parcelRequire("cOQTW");

var $54d8c5346cdc5323$var$PDFAcroSignature = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroSignature, _super);
    function PDFAcroSignature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroSignature.fromDict = function(dict, ref) {
        return new PDFAcroSignature(dict, ref);
    };
    return PDFAcroSignature;
}((0, $46d285649821c095$export$2e2bcd8739ae039));
var $54d8c5346cdc5323$export$2e2bcd8739ae039 = $54d8c5346cdc5323$var$PDFAcroSignature;



var $cOQTW = parcelRequire("cOQTW");

var $j04jt = parcelRequire("j04jt");



var $dPHSK = parcelRequire("dPHSK");

var $8fd9de5d2343325e$var$PDFAcroText = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroText, _super);
    function PDFAcroText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroText.prototype.MaxLen = function() {
        var maxLen = this.dict.lookup((0, $dPHSK.default).of('MaxLen'));
        if (maxLen instanceof (0, $j04jt.default)) return maxLen;
        return undefined;
    };
    PDFAcroText.prototype.Q = function() {
        var q = this.dict.lookup((0, $dPHSK.default).of('Q'));
        if (q instanceof (0, $j04jt.default)) return q;
        return undefined;
    };
    PDFAcroText.prototype.setMaxLength = function(maxLength) {
        this.dict.set((0, $dPHSK.default).of('MaxLen'), (0, $j04jt.default).of(maxLength));
    };
    PDFAcroText.prototype.removeMaxLength = function() {
        this.dict.delete((0, $dPHSK.default).of('MaxLen'));
    };
    PDFAcroText.prototype.getMaxLength = function() {
        var _a;
        return (_a = this.MaxLen()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFAcroText.prototype.setQuadding = function(quadding) {
        this.dict.set((0, $dPHSK.default).of('Q'), (0, $j04jt.default).of(quadding));
    };
    PDFAcroText.prototype.getQuadding = function() {
        var _a;
        return (_a = this.Q()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFAcroText.prototype.setValue = function(value) {
        this.dict.set((0, $dPHSK.default).of('V'), value);
    // const widgets = this.getWidgets();
    // for (let idx = 0, len = widgets.length; idx < len; idx++) {
    //   const widget = widgets[idx];
    //   const state = widget.getOnValue() === value ? value : PDFName.of('Off');
    //   widget.setAppearanceState(state);
    // }
    };
    PDFAcroText.prototype.removeValue = function() {
        this.dict.delete((0, $dPHSK.default).of('V'));
    };
    PDFAcroText.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039) || v instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) return v;
        return undefined;
    };
    PDFAcroText.fromDict = function(dict, ref) {
        return new PDFAcroText(dict, ref);
    };
    PDFAcroText.create = function(context) {
        var dict = context.obj({
            FT: 'Tx',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroText(dict, ref);
    };
    return PDFAcroText;
}((0, $46d285649821c095$export$2e2bcd8739ae039));
var $8fd9de5d2343325e$export$2e2bcd8739ae039 = $8fd9de5d2343325e$var$PDFAcroText;



var $cOQTW = parcelRequire("cOQTW");


var $0cfa6a9523f95402$var$PDFAcroPushButton = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroPushButton, _super);
    function PDFAcroPushButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroPushButton.fromDict = function(dict, ref) {
        return new PDFAcroPushButton(dict, ref);
    };
    PDFAcroPushButton.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Ff: (0, $987e37c460e8464e$export$59f660e89ffb4f8a).PushButton,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroPushButton(dict, ref);
    };
    return PDFAcroPushButton;
}((0, $8b75e0d2aabd8761$export$2e2bcd8739ae039));
var $0cfa6a9523f95402$export$2e2bcd8739ae039 = $0cfa6a9523f95402$var$PDFAcroPushButton;



var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");



var $nAWRe = parcelRequire("nAWRe");
var $cad74455a26124b0$var$PDFAcroRadioButton = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroRadioButton, _super);
    function PDFAcroRadioButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroRadioButton.prototype.setValue = function(value) {
        var onValues = this.getOnValues();
        if (!onValues.includes(value) && value !== (0, $dPHSK.default).of('Off')) throw new (0, $nAWRe.InvalidAcroFieldValueError)();
        this.dict.set((0, $dPHSK.default).of('V'), value);
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getOnValue() === value ? value : (0, $dPHSK.default).of('Off');
            widget.setAppearanceState(state);
        }
    };
    PDFAcroRadioButton.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $dPHSK.default)) return v;
        return (0, $dPHSK.default).of('Off');
    };
    PDFAcroRadioButton.prototype.getOnValues = function() {
        var widgets = this.getWidgets();
        var onValues = [];
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var onValue = widgets[idx].getOnValue();
            if (onValue) onValues.push(onValue);
        }
        return onValues;
    };
    PDFAcroRadioButton.fromDict = function(dict, ref) {
        return new PDFAcroRadioButton(dict, ref);
    };
    PDFAcroRadioButton.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Ff: (0, $987e37c460e8464e$export$59f660e89ffb4f8a).Radio,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroRadioButton(dict, ref);
    };
    return PDFAcroRadioButton;
}((0, $8b75e0d2aabd8761$export$2e2bcd8739ae039));
var $cad74455a26124b0$export$2e2bcd8739ae039 = $cad74455a26124b0$var$PDFAcroRadioButton;





var $cOQTW = parcelRequire("cOQTW");

var $c1f53a89685317ba$var$PDFAcroListBox = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroListBox, _super);
    function PDFAcroListBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroListBox.fromDict = function(dict, ref) {
        return new PDFAcroListBox(dict, ref);
    };
    PDFAcroListBox.create = function(context) {
        var dict = context.obj({
            FT: 'Ch',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroListBox(dict, ref);
    };
    return PDFAcroListBox;
}((0, $10788dcfb83fdb6c$export$2e2bcd8739ae039));
var $c1f53a89685317ba$export$2e2bcd8739ae039 = $c1f53a89685317ba$var$PDFAcroListBox;



var $be3fb214968b38d5$export$34b4fb8893136c4c = function(kidDicts) {
    if (!kidDicts) return [];
    var kids = [];
    for(var idx = 0, len = kidDicts.size(); idx < len; idx++){
        var ref = kidDicts.get(idx);
        var dict = kidDicts.lookup(idx);
        // if (dict instanceof PDFDict) kids.push(PDFAcroField.fromDict(dict));
        if (ref instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039) && dict instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) kids.push([
            $be3fb214968b38d5$export$fe770f59a8fbe6d(dict, ref),
            ref
        ]);
    }
    return kids;
};
var $be3fb214968b38d5$export$fe770f59a8fbe6d = function(dict, ref) {
    var isNonTerminal = $be3fb214968b38d5$var$isNonTerminalAcroField(dict);
    if (isNonTerminal) return (0, $a105ec5aeb848914$export$2e2bcd8739ae039).fromDict(dict, ref);
    return $be3fb214968b38d5$var$createPDFAcroTerminal(dict, ref);
};
// TODO: Maybe just check if the dict is *not* a widget? That might be better.
// According to the PDF spec:
//
//   > A field's children in the hierarchy may also include widget annotations
//   > that define its appearance on the page. A field that has children that
//   > are fields is called a non-terminal field. A field that does not have
//   > children that are fields is called a terminal field.
//
// The spec is not entirely clear about how to determine whether a given
// dictionary represents an acrofield or a widget annotation. So we will assume
// that a dictionary is an acrofield if it is a member of the `/Kids` array
// and it contains a `/T` entry (widgets do not have `/T` entries). This isn't
// a bullet proof solution, because the `/T` entry is technically defined as
// optional for acrofields by the PDF spec. But in practice all acrofields seem
// to have a `/T` entry defined.
var $be3fb214968b38d5$var$isNonTerminalAcroField = function(dict) {
    var kids = dict.lookup((0, $dPHSK.default).of('Kids'));
    if (kids instanceof (0, $8auL6.default)) for(var idx = 0, len = kids.size(); idx < len; idx++){
        var kid = kids.lookup(idx);
        var kidIsField = kid instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039) && kid.has((0, $dPHSK.default).of('T'));
        if (kidIsField) return true;
    }
    return false;
};
var $be3fb214968b38d5$var$createPDFAcroTerminal = function(dict, ref) {
    var ftNameOrRef = $be3fb214968b38d5$var$getInheritableAttribute(dict, (0, $dPHSK.default).of('FT'));
    var type = dict.context.lookup(ftNameOrRef, (0, $dPHSK.default));
    if (type === (0, $dPHSK.default).of('Btn')) return $be3fb214968b38d5$var$createPDFAcroButton(dict, ref);
    if (type === (0, $dPHSK.default).of('Ch')) return $be3fb214968b38d5$var$createPDFAcroChoice(dict, ref);
    if (type === (0, $dPHSK.default).of('Tx')) return (0, $8fd9de5d2343325e$export$2e2bcd8739ae039).fromDict(dict, ref);
    if (type === (0, $dPHSK.default).of('Sig')) return (0, $54d8c5346cdc5323$export$2e2bcd8739ae039).fromDict(dict, ref);
    // We should never reach this line. But there are a lot of weird PDFs out
    // there. So, just to be safe, we'll try to handle things gracefully instead
    // of throwing an error.
    return (0, $46d285649821c095$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $be3fb214968b38d5$var$createPDFAcroButton = function(dict, ref) {
    var _a;
    var ffNumberOrRef = $be3fb214968b38d5$var$getInheritableAttribute(dict, (0, $dPHSK.default).of('Ff'));
    var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, (0, $j04jt.default));
    var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
    if ($be3fb214968b38d5$var$flagIsSet(flags, (0, $987e37c460e8464e$export$59f660e89ffb4f8a).PushButton)) return (0, $0cfa6a9523f95402$export$2e2bcd8739ae039).fromDict(dict, ref);
    else if ($be3fb214968b38d5$var$flagIsSet(flags, (0, $987e37c460e8464e$export$59f660e89ffb4f8a).Radio)) return (0, $cad74455a26124b0$export$2e2bcd8739ae039).fromDict(dict, ref);
    else return (0, $f8e31b0e21e15332$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $be3fb214968b38d5$var$createPDFAcroChoice = function(dict, ref) {
    var _a;
    var ffNumberOrRef = $be3fb214968b38d5$var$getInheritableAttribute(dict, (0, $dPHSK.default).of('Ff'));
    var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, (0, $j04jt.default));
    var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
    if ($be3fb214968b38d5$var$flagIsSet(flags, (0, $987e37c460e8464e$export$eb88827058402599).Combo)) return (0, $3488827c1474fcce$export$2e2bcd8739ae039).fromDict(dict, ref);
    else return (0, $c1f53a89685317ba$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $be3fb214968b38d5$var$flagIsSet = function(flags, flag) {
    return (flags & flag) !== 0;
};
var $be3fb214968b38d5$var$getInheritableAttribute = function(startNode, name) {
    var attribute;
    $be3fb214968b38d5$var$ascend(startNode, function(node) {
        if (!attribute) attribute = node.get(name);
    });
    return attribute;
};
var $be3fb214968b38d5$var$ascend = function(startNode, visitor) {
    visitor(startNode);
    var Parent = startNode.lookupMaybe((0, $dPHSK.default).of('Parent'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
    if (Parent) $be3fb214968b38d5$var$ascend(Parent, visitor);
};


var $b2be38e1e2597241$var$PDFAcroForm = /** @class */ function() {
    function PDFAcroForm(dict) {
        this.dict = dict;
    }
    PDFAcroForm.prototype.Fields = function() {
        var fields = this.dict.lookup((0, $dPHSK.default).of('Fields'));
        if (fields instanceof (0, $8auL6.default)) return fields;
        return undefined;
    };
    PDFAcroForm.prototype.getFields = function() {
        var Fields = this.normalizedEntries().Fields;
        var fields = new Array(Fields.size());
        for(var idx = 0, len = Fields.size(); idx < len; idx++){
            var ref = Fields.get(idx);
            var dict = Fields.lookup(idx, (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
            fields[idx] = [
                (0, $be3fb214968b38d5$export$fe770f59a8fbe6d)(dict, ref),
                ref
            ];
        }
        return fields;
    };
    PDFAcroForm.prototype.getAllFields = function() {
        var allFields = [];
        var pushFields = function(fields) {
            if (!fields) return;
            for(var idx = 0, len = fields.length; idx < len; idx++){
                var field = fields[idx];
                allFields.push(field);
                var fieldModel = field[0];
                if (fieldModel instanceof (0, $a105ec5aeb848914$export$2e2bcd8739ae039)) pushFields((0, $be3fb214968b38d5$export$34b4fb8893136c4c)(fieldModel.Kids()));
            }
        };
        pushFields(this.getFields());
        return allFields;
    };
    PDFAcroForm.prototype.addField = function(field) {
        var Fields = this.normalizedEntries().Fields;
        Fields === null || Fields === void 0 || Fields.push(field);
    };
    PDFAcroForm.prototype.removeField = function(field) {
        var parent = field.getParent();
        var fields = parent === undefined ? this.normalizedEntries().Fields : parent.Kids();
        var index = fields === null || fields === void 0 ? void 0 : fields.indexOf(field.ref);
        if (fields === undefined || index === undefined) throw new Error("Tried to remove inexistent field " + field.getFullyQualifiedName());
        fields.remove(index);
        if (parent !== undefined && fields.size() === 0) this.removeField(parent);
    };
    PDFAcroForm.prototype.normalizedEntries = function() {
        var Fields = this.Fields();
        if (!Fields) {
            Fields = this.dict.context.obj([]);
            this.dict.set((0, $dPHSK.default).of('Fields'), Fields);
        }
        return {
            Fields: Fields
        };
    };
    PDFAcroForm.fromDict = function(dict) {
        return new PDFAcroForm(dict);
    };
    PDFAcroForm.create = function(context) {
        var dict = context.obj({
            Fields: []
        });
        return new PDFAcroForm(dict);
    };
    return PDFAcroForm;
}();
var $b2be38e1e2597241$export$2e2bcd8739ae039 = $b2be38e1e2597241$var$PDFAcroForm;














var $cpTWE = parcelRequire("cpTWE");
var $80c05707f2c8c1f7$var$PDFCatalog = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFCatalog, _super);
    function PDFCatalog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFCatalog.prototype.Pages = function() {
        return this.lookup((0, $dPHSK.default).of('Pages'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.AcroForm = function() {
        return this.lookupMaybe((0, $dPHSK.default).of('AcroForm'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.getAcroForm = function() {
        var dict = this.AcroForm();
        if (!dict) return undefined;
        return (0, $b2be38e1e2597241$export$2e2bcd8739ae039).fromDict(dict);
    };
    PDFCatalog.prototype.getOrCreateAcroForm = function() {
        var acroForm = this.getAcroForm();
        if (!acroForm) {
            acroForm = (0, $b2be38e1e2597241$export$2e2bcd8739ae039).create(this.context);
            var acroFormRef = this.context.register(acroForm.dict);
            this.set((0, $dPHSK.default).of('AcroForm'), acroFormRef);
        }
        return acroForm;
    };
    PDFCatalog.prototype.ViewerPreferences = function() {
        return this.lookupMaybe((0, $dPHSK.default).of('ViewerPreferences'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.getViewerPreferences = function() {
        var dict = this.ViewerPreferences();
        if (!dict) return undefined;
        return (0, $cpTWE.default).fromDict(dict);
    };
    PDFCatalog.prototype.getOrCreateViewerPreferences = function() {
        var viewerPrefs = this.getViewerPreferences();
        if (!viewerPrefs) {
            viewerPrefs = (0, $cpTWE.default).create(this.context);
            var viewerPrefsRef = this.context.register(viewerPrefs.dict);
            this.set((0, $dPHSK.default).of('ViewerPreferences'), viewerPrefsRef);
        }
        return viewerPrefs;
    };
    /**
     * Inserts the given ref as a leaf node of this catalog's page tree at the
     * specified index (zero-based). Also increments the `Count` of each node in
     * the page tree hierarchy to accomodate the new page.
     *
     * Returns the ref of the PDFPageTree node into which `leafRef` was inserted.
     */ PDFCatalog.prototype.insertLeafNode = function(leafRef, index) {
        var pagesRef = this.get((0, $dPHSK.default).of('Pages'));
        var maybeParentRef = this.Pages().insertLeafNode(leafRef, index);
        return maybeParentRef || pagesRef;
    };
    PDFCatalog.prototype.removeLeafNode = function(index) {
        this.Pages().removeLeafNode(index);
    };
    PDFCatalog.withContextAndPages = function(context, pages) {
        var dict = new Map();
        dict.set((0, $dPHSK.default).of('Type'), (0, $dPHSK.default).of('Catalog'));
        dict.set((0, $dPHSK.default).of('Pages'), pages);
        return new PDFCatalog(dict, context);
    };
    PDFCatalog.fromMapWithContext = function(map, context) {
        return new PDFCatalog(map, context);
    };
    return PDFCatalog;
}((0, $85408478fbb7cbde$export$2e2bcd8739ae039));
var $80c05707f2c8c1f7$export$2e2bcd8739ae039 = $80c05707f2c8c1f7$var$PDFCatalog;






var $cOQTW = parcelRequire("cOQTW");

var $8auL6 = parcelRequire("8auL6");


var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");


var $nAWRe = parcelRequire("nAWRe");
var $333acd2e5fba0d32$var$PDFPageTree = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFPageTree, _super);
    function PDFPageTree() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFPageTree.prototype.Parent = function() {
        return this.lookup((0, $dPHSK.default).of('Parent'));
    };
    PDFPageTree.prototype.Kids = function() {
        return this.lookup((0, $dPHSK.default).of('Kids'), (0, $8auL6.default));
    };
    PDFPageTree.prototype.Count = function() {
        return this.lookup((0, $dPHSK.default).of('Count'), (0, $j04jt.default));
    };
    PDFPageTree.prototype.pushTreeNode = function(treeRef) {
        var Kids = this.Kids();
        Kids.push(treeRef);
    };
    PDFPageTree.prototype.pushLeafNode = function(leafRef) {
        var Kids = this.Kids();
        this.insertLeafKid(Kids.size(), leafRef);
    };
    /**
     * Inserts the given ref as a leaf node of this page tree at the specified
     * index (zero-based). Also increments the `Count` of each page tree in the
     * hierarchy to accomodate the new page.
     *
     * Returns the ref of the PDFPageTree node into which `leafRef` was inserted,
     * or `undefined` if it was inserted into the root node (the PDFPageTree upon
     * which the method was first called).
     */ PDFPageTree.prototype.insertLeafNode = function(leafRef, targetIndex) {
        var Kids = this.Kids();
        var Count = this.Count().asNumber();
        if (targetIndex > Count) throw new (0, $nAWRe.InvalidTargetIndexError)(targetIndex, Count);
        var leafsRemainingUntilTarget = targetIndex;
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            if (leafsRemainingUntilTarget === 0) {
                // Insert page and return
                this.insertLeafKid(idx, leafRef);
                return undefined;
            }
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) {
                if (kid.Count().asNumber() > leafsRemainingUntilTarget) // Dig in
                return kid.insertLeafNode(leafRef, leafsRemainingUntilTarget) || kidRef;
                else // Move on
                leafsRemainingUntilTarget -= kid.Count().asNumber();
            }
            if (kid instanceof (0, $a9e73b7ced5abfa4$export$2e2bcd8739ae039)) // Move on
            leafsRemainingUntilTarget -= 1;
        }
        if (leafsRemainingUntilTarget === 0) {
            // Insert page at the end and return
            this.insertLeafKid(Kids.size(), leafRef);
            return undefined;
        }
        // Should never get here if `targetIndex` is valid
        throw new (0, $nAWRe.CorruptPageTreeError)(targetIndex, 'insertLeafNode');
    };
    /**
     * Removes the leaf node at the specified index (zero-based) from this page
     * tree. Also decrements the `Count` of each page tree in the hierarchy to
     * account for the removed page.
     *
     * If `prune` is true, then intermediate tree nodes will be removed from the
     * tree if they contain 0 children after the leaf node is removed.
     */ PDFPageTree.prototype.removeLeafNode = function(targetIndex, prune) {
        if (prune === void 0) prune = true;
        var Kids = this.Kids();
        var Count = this.Count().asNumber();
        if (targetIndex >= Count) throw new (0, $nAWRe.InvalidTargetIndexError)(targetIndex, Count);
        var leafsRemainingUntilTarget = targetIndex;
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) {
                if (kid.Count().asNumber() > leafsRemainingUntilTarget) {
                    // Dig in
                    kid.removeLeafNode(leafsRemainingUntilTarget, prune);
                    if (prune && kid.Kids().size() === 0) Kids.remove(idx);
                    return;
                } else // Move on
                leafsRemainingUntilTarget -= kid.Count().asNumber();
            }
            if (kid instanceof (0, $a9e73b7ced5abfa4$export$2e2bcd8739ae039)) {
                if (leafsRemainingUntilTarget === 0) {
                    // Remove page and return
                    this.removeKid(idx);
                    return;
                } else // Move on
                leafsRemainingUntilTarget -= 1;
            }
        }
        // Should never get here if `targetIndex` is valid
        throw new (0, $nAWRe.CorruptPageTreeError)(targetIndex, 'removeLeafNode');
    };
    PDFPageTree.prototype.ascend = function(visitor) {
        visitor(this);
        var Parent = this.Parent();
        if (Parent) Parent.ascend(visitor);
    };
    /** Performs a Post-Order traversal of this page tree */ PDFPageTree.prototype.traverse = function(visitor) {
        var Kids = this.Kids();
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) kid.traverse(visitor);
            visitor(kid, kidRef);
        }
    };
    PDFPageTree.prototype.insertLeafKid = function(kidIdx, leafRef) {
        var Kids = this.Kids();
        this.ascend(function(node) {
            var newCount = node.Count().asNumber() + 1;
            node.set((0, $dPHSK.default).of('Count'), (0, $j04jt.default).of(newCount));
        });
        Kids.insert(kidIdx, leafRef);
    };
    PDFPageTree.prototype.removeKid = function(kidIdx) {
        var Kids = this.Kids();
        var kid = Kids.lookup(kidIdx);
        if (kid instanceof (0, $a9e73b7ced5abfa4$export$2e2bcd8739ae039)) this.ascend(function(node) {
            var newCount = node.Count().asNumber() - 1;
            node.set((0, $dPHSK.default).of('Count'), (0, $j04jt.default).of(newCount));
        });
        Kids.remove(kidIdx);
    };
    PDFPageTree.withContext = function(context, parent) {
        var dict = new Map();
        dict.set((0, $dPHSK.default).of('Type'), (0, $dPHSK.default).of('Pages'));
        dict.set((0, $dPHSK.default).of('Kids'), context.obj([]));
        dict.set((0, $dPHSK.default).of('Count'), context.obj(0));
        if (parent) dict.set((0, $dPHSK.default).of('Parent'), parent);
        return new PDFPageTree(dict, context);
    };
    PDFPageTree.fromMapWithContext = function(map, context) {
        return new PDFPageTree(map, context);
    };
    return PDFPageTree;
}((0, $85408478fbb7cbde$export$2e2bcd8739ae039));
var $333acd2e5fba0d32$export$2e2bcd8739ae039 = $333acd2e5fba0d32$var$PDFPageTree;







var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $8auL6 = parcelRequire("8auL6");

var $8gQNC = parcelRequire("8gQNC");



var $dPHSK = parcelRequire("dPHSK");


var $j04jt = parcelRequire("j04jt");




var $nAWRe = parcelRequire("nAWRe");

var $8zvel = parcelRequire("8zvel");

var $8zvel = parcelRequire("8zvel");
var $5679a387c9e20301$export$9492c31549e88980 = new Uint8Array(256);
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Zero] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).One] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Two] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Three] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Four] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Five] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Six] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Seven] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Eight] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Nine] = 1;
var $5679a387c9e20301$export$d438b84505bee68c = new Uint8Array(256);
$5679a387c9e20301$export$d438b84505bee68c[(0, $8zvel.default).Period] = 1;
$5679a387c9e20301$export$d438b84505bee68c[(0, $8zvel.default).Plus] = 1;
$5679a387c9e20301$export$d438b84505bee68c[(0, $8zvel.default).Minus] = 1;
var $5679a387c9e20301$export$4d926b029fa61cfe = new Uint8Array(256);
for(var $5679a387c9e20301$var$idx = 0, $5679a387c9e20301$var$len = 256; $5679a387c9e20301$var$idx < $5679a387c9e20301$var$len; $5679a387c9e20301$var$idx++)$5679a387c9e20301$export$4d926b029fa61cfe[$5679a387c9e20301$var$idx] = $5679a387c9e20301$export$9492c31549e88980[$5679a387c9e20301$var$idx] || $5679a387c9e20301$export$d438b84505bee68c[$5679a387c9e20301$var$idx] ? 1 : 0;



var $14u6w = parcelRequire("14u6w");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ccc28a798e23d674$var$Newline = (0, $8zvel.default).Newline, $ccc28a798e23d674$var$CarriageReturn = (0, $8zvel.default).CarriageReturn;
// TODO: Throw error if eof is reached before finishing object parse...
var $ccc28a798e23d674$var$BaseParser = /** @class */ function() {
    function BaseParser(bytes, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        this.bytes = bytes;
        this.capNumbers = capNumbers;
    }
    BaseParser.prototype.parseRawInt = function() {
        var value = '';
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $5679a387c9e20301$export$9492c31549e88980)[byte]) break;
            value += (0, $7Kmy8.charFromCode)(this.bytes.next());
        }
        var numberValue = Number(value);
        if (!value || !isFinite(numberValue)) throw new (0, $nAWRe.NumberParsingError)(this.bytes.position(), value);
        return numberValue;
    };
    // TODO: Maybe handle exponential format?
    // TODO: Compare performance of string concatenation to charFromCode(...bytes)
    BaseParser.prototype.parseRawNumber = function() {
        var value = '';
        // Parse integer-part, the leading (+ | - | . | 0-9)
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $5679a387c9e20301$export$4d926b029fa61cfe)[byte]) break;
            value += (0, $7Kmy8.charFromCode)(this.bytes.next());
            if (byte === (0, $8zvel.default).Period) break;
        }
        // Parse decimal-part, the trailing (0-9)
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $5679a387c9e20301$export$9492c31549e88980)[byte]) break;
            value += (0, $7Kmy8.charFromCode)(this.bytes.next());
        }
        var numberValue = Number(value);
        if (!value || !isFinite(numberValue)) throw new (0, $nAWRe.NumberParsingError)(this.bytes.position(), value);
        if (numberValue > Number.MAX_SAFE_INTEGER) {
            if (this.capNumbers) {
                var msg = "Parsed number that is too large for some PDF readers: " + value + ", using Number.MAX_SAFE_INTEGER instead.";
                console.warn(msg);
                return Number.MAX_SAFE_INTEGER;
            } else {
                var msg = "Parsed number that is too large for some PDF readers: " + value + ", not capping.";
                console.warn(msg);
            }
        }
        return numberValue;
    };
    BaseParser.prototype.skipWhitespace = function() {
        while(!this.bytes.done() && (0, $14u6w.IsWhitespace)[this.bytes.peek()])this.bytes.next();
    };
    BaseParser.prototype.skipLine = function() {
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (byte === $ccc28a798e23d674$var$Newline || byte === $ccc28a798e23d674$var$CarriageReturn) return;
            this.bytes.next();
        }
    };
    BaseParser.prototype.skipComment = function() {
        if (this.bytes.peek() !== (0, $8zvel.default).Percent) return false;
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (byte === $ccc28a798e23d674$var$Newline || byte === $ccc28a798e23d674$var$CarriageReturn) return true;
            this.bytes.next();
        }
        return true;
    };
    BaseParser.prototype.skipWhitespaceAndComments = function() {
        this.skipWhitespace();
        while(this.skipComment())this.skipWhitespace();
    };
    BaseParser.prototype.matchKeyword = function(keyword) {
        var initialOffset = this.bytes.offset();
        for(var idx = 0, len = keyword.length; idx < len; idx++)if (this.bytes.done() || this.bytes.next() !== keyword[idx]) {
            this.bytes.moveTo(initialOffset);
            return false;
        }
        return true;
    };
    return BaseParser;
}();
var $ccc28a798e23d674$export$2e2bcd8739ae039 = $ccc28a798e23d674$var$BaseParser;



var $nAWRe = parcelRequire("nAWRe");


var $8zvel = parcelRequire("8zvel");
// TODO: See how line/col tracking affects performance
var $93214384d2c510d6$var$ByteStream = /** @class */ function() {
    function ByteStream(bytes) {
        this.idx = 0;
        this.line = 0;
        this.column = 0;
        this.bytes = bytes;
        this.length = this.bytes.length;
    }
    ByteStream.prototype.moveTo = function(offset) {
        this.idx = offset;
    };
    ByteStream.prototype.next = function() {
        var byte = this.bytes[this.idx++];
        if (byte === (0, $8zvel.default).Newline) {
            this.line += 1;
            this.column = 0;
        } else this.column += 1;
        return byte;
    };
    ByteStream.prototype.assertNext = function(expected) {
        if (this.peek() !== expected) throw new (0, $nAWRe.NextByteAssertionError)(this.position(), expected, this.peek());
        return this.next();
    };
    ByteStream.prototype.peek = function() {
        return this.bytes[this.idx];
    };
    ByteStream.prototype.peekAhead = function(steps) {
        return this.bytes[this.idx + steps];
    };
    ByteStream.prototype.peekAt = function(offset) {
        return this.bytes[offset];
    };
    ByteStream.prototype.done = function() {
        return this.idx >= this.length;
    };
    ByteStream.prototype.offset = function() {
        return this.idx;
    };
    ByteStream.prototype.slice = function(start, end) {
        return this.bytes.slice(start, end);
    };
    ByteStream.prototype.position = function() {
        return {
            line: this.line,
            column: this.column,
            offset: this.idx
        };
    };
    ByteStream.of = function(bytes) {
        return new ByteStream(bytes);
    };
    ByteStream.fromPDFRawStream = function(rawStream) {
        return ByteStream.of((0, $a0659294f562ac04$export$b8317e68ca978594)(rawStream).decode());
    };
    return ByteStream;
}();
var $93214384d2c510d6$export$2e2bcd8739ae039 = $93214384d2c510d6$var$ByteStream;






var $8zvel = parcelRequire("8zvel");

var $eOx0D = parcelRequire("eOx0D");

var $cOQTW = parcelRequire("cOQTW");

var $8zvel = parcelRequire("8zvel");
var $f3568ef95260ec55$var$Space = (0, $8zvel.default).Space, $f3568ef95260ec55$var$CarriageReturn = (0, $8zvel.default).CarriageReturn, $f3568ef95260ec55$var$Newline = (0, $8zvel.default).Newline;
var $f3568ef95260ec55$var$stream = [
    (0, $8zvel.default).s,
    (0, $8zvel.default).t,
    (0, $8zvel.default).r,
    (0, $8zvel.default).e,
    (0, $8zvel.default).a,
    (0, $8zvel.default).m
];
var $f3568ef95260ec55$var$endstream = [
    (0, $8zvel.default).e,
    (0, $8zvel.default).n,
    (0, $8zvel.default).d,
    (0, $8zvel.default).s,
    (0, $8zvel.default).t,
    (0, $8zvel.default).r,
    (0, $8zvel.default).e,
    (0, $8zvel.default).a,
    (0, $8zvel.default).m
];
var $f3568ef95260ec55$export$93ad50ccfacdd77 = {
    header: [
        (0, $8zvel.default).Percent,
        (0, $8zvel.default).P,
        (0, $8zvel.default).D,
        (0, $8zvel.default).F,
        (0, $8zvel.default).Dash
    ],
    eof: [
        (0, $8zvel.default).Percent,
        (0, $8zvel.default).Percent,
        (0, $8zvel.default).E,
        (0, $8zvel.default).O,
        (0, $8zvel.default).F
    ],
    obj: [
        (0, $8zvel.default).o,
        (0, $8zvel.default).b,
        (0, $8zvel.default).j
    ],
    endobj: [
        (0, $8zvel.default).e,
        (0, $8zvel.default).n,
        (0, $8zvel.default).d,
        (0, $8zvel.default).o,
        (0, $8zvel.default).b,
        (0, $8zvel.default).j
    ],
    xref: [
        (0, $8zvel.default).x,
        (0, $8zvel.default).r,
        (0, $8zvel.default).e,
        (0, $8zvel.default).f
    ],
    trailer: [
        (0, $8zvel.default).t,
        (0, $8zvel.default).r,
        (0, $8zvel.default).a,
        (0, $8zvel.default).i,
        (0, $8zvel.default).l,
        (0, $8zvel.default).e,
        (0, $8zvel.default).r
    ],
    startxref: [
        (0, $8zvel.default).s,
        (0, $8zvel.default).t,
        (0, $8zvel.default).a,
        (0, $8zvel.default).r,
        (0, $8zvel.default).t,
        (0, $8zvel.default).x,
        (0, $8zvel.default).r,
        (0, $8zvel.default).e,
        (0, $8zvel.default).f
    ],
    true: [
        (0, $8zvel.default).t,
        (0, $8zvel.default).r,
        (0, $8zvel.default).u,
        (0, $8zvel.default).e
    ],
    false: [
        (0, $8zvel.default).f,
        (0, $8zvel.default).a,
        (0, $8zvel.default).l,
        (0, $8zvel.default).s,
        (0, $8zvel.default).e
    ],
    null: [
        (0, $8zvel.default).n,
        (0, $8zvel.default).u,
        (0, $8zvel.default).l,
        (0, $8zvel.default).l
    ],
    stream: $f3568ef95260ec55$var$stream,
    streamEOF1: (0, $cOQTW.__spreadArrays)($f3568ef95260ec55$var$stream, [
        $f3568ef95260ec55$var$Space,
        $f3568ef95260ec55$var$CarriageReturn,
        $f3568ef95260ec55$var$Newline
    ]),
    streamEOF2: (0, $cOQTW.__spreadArrays)($f3568ef95260ec55$var$stream, [
        $f3568ef95260ec55$var$CarriageReturn,
        $f3568ef95260ec55$var$Newline
    ]),
    streamEOF3: (0, $cOQTW.__spreadArrays)($f3568ef95260ec55$var$stream, [
        $f3568ef95260ec55$var$CarriageReturn
    ]),
    streamEOF4: (0, $cOQTW.__spreadArrays)($f3568ef95260ec55$var$stream, [
        $f3568ef95260ec55$var$Newline
    ]),
    endstream: $f3568ef95260ec55$var$endstream,
    EOF1endstream: (0, $cOQTW.__spreadArrays)([
        $f3568ef95260ec55$var$CarriageReturn,
        $f3568ef95260ec55$var$Newline
    ], $f3568ef95260ec55$var$endstream),
    EOF2endstream: (0, $cOQTW.__spreadArrays)([
        $f3568ef95260ec55$var$CarriageReturn
    ], $f3568ef95260ec55$var$endstream),
    EOF3endstream: (0, $cOQTW.__spreadArrays)([
        $f3568ef95260ec55$var$Newline
    ], $f3568ef95260ec55$var$endstream)
};




var $14u6w = parcelRequire("14u6w");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
// TODO: Throw error if eof is reached before finishing object parse...
var $2ce01d1490df00cf$var$PDFObjectParser = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFObjectParser, _super);
    function PDFObjectParser(byteStream, context, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        var _this = _super.call(this, byteStream, capNumbers) || this;
        _this.context = context;
        return _this;
    }
    // TODO: Is it possible to reduce duplicate parsing for ref lookaheads?
    PDFObjectParser.prototype.parseObject = function() {
        this.skipWhitespaceAndComments();
        if (this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).true)) return (0, $8gQNC.default).True;
        if (this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).false)) return (0, $8gQNC.default).False;
        if (this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).null)) return 0, $ad8a981877dc5d20$export$2e2bcd8739ae039;
        var byte = this.bytes.peek();
        if (byte === (0, $8zvel.default).LessThan && this.bytes.peekAhead(1) === (0, $8zvel.default).LessThan) return this.parseDictOrStream();
        if (byte === (0, $8zvel.default).LessThan) return this.parseHexString();
        if (byte === (0, $8zvel.default).LeftParen) return this.parseString();
        if (byte === (0, $8zvel.default).ForwardSlash) return this.parseName();
        if (byte === (0, $8zvel.default).LeftSquareBracket) return this.parseArray();
        if ((0, $5679a387c9e20301$export$4d926b029fa61cfe)[byte]) return this.parseNumberOrRef();
        throw new (0, $nAWRe.PDFObjectParsingError)(this.bytes.position(), byte);
    };
    PDFObjectParser.prototype.parseNumberOrRef = function() {
        var firstNum = this.parseRawNumber();
        this.skipWhitespaceAndComments();
        var lookaheadStart = this.bytes.offset();
        if ((0, $5679a387c9e20301$export$9492c31549e88980)[this.bytes.peek()]) {
            var secondNum = this.parseRawNumber();
            this.skipWhitespaceAndComments();
            if (this.bytes.peek() === (0, $8zvel.default).R) {
                this.bytes.assertNext((0, $8zvel.default).R);
                return (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(firstNum, secondNum);
            }
        }
        this.bytes.moveTo(lookaheadStart);
        return (0, $j04jt.default).of(firstNum);
    };
    // TODO: Maybe update PDFHexString.of() logic to remove whitespace and validate input?
    PDFObjectParser.prototype.parseHexString = function() {
        var value = '';
        this.bytes.assertNext((0, $8zvel.default).LessThan);
        while(!this.bytes.done() && this.bytes.peek() !== (0, $8zvel.default).GreaterThan)value += (0, $7Kmy8.charFromCode)(this.bytes.next());
        this.bytes.assertNext((0, $8zvel.default).GreaterThan);
        return (0, $e8537943f4279a06$export$2e2bcd8739ae039).of(value);
    };
    PDFObjectParser.prototype.parseString = function() {
        var nestingLvl = 0;
        var isEscaped = false;
        var value = '';
        while(!this.bytes.done()){
            var byte = this.bytes.next();
            value += (0, $7Kmy8.charFromCode)(byte);
            // Check for unescaped parenthesis
            if (!isEscaped) {
                if (byte === (0, $8zvel.default).LeftParen) nestingLvl += 1;
                if (byte === (0, $8zvel.default).RightParen) nestingLvl -= 1;
            }
            // Track whether current character is being escaped or not
            if (byte === (0, $8zvel.default).BackSlash) isEscaped = !isEscaped;
            else if (isEscaped) isEscaped = false;
            // Once (if) the unescaped parenthesis balance out, return their contents
            if (nestingLvl === 0) // Remove the outer parens so they aren't part of the contents
            return (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).of(value.substring(1, value.length - 1));
        }
        throw new (0, $nAWRe.UnbalancedParenthesisError)(this.bytes.position());
    };
    // TODO: Compare performance of string concatenation to charFromCode(...bytes)
    // TODO: Maybe preallocate small Uint8Array if can use charFromCode?
    PDFObjectParser.prototype.parseName = function() {
        this.bytes.assertNext((0, $8zvel.default).ForwardSlash);
        var name = '';
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if ((0, $14u6w.IsWhitespace)[byte] || (0, $eOx0D.IsDelimiter)[byte]) break;
            name += (0, $7Kmy8.charFromCode)(byte);
            this.bytes.next();
        }
        return (0, $dPHSK.default).of(name);
    };
    PDFObjectParser.prototype.parseArray = function() {
        this.bytes.assertNext((0, $8zvel.default).LeftSquareBracket);
        this.skipWhitespaceAndComments();
        var pdfArray = (0, $8auL6.default).withContext(this.context);
        while(this.bytes.peek() !== (0, $8zvel.default).RightSquareBracket){
            var element = this.parseObject();
            pdfArray.push(element);
            this.skipWhitespaceAndComments();
        }
        this.bytes.assertNext((0, $8zvel.default).RightSquareBracket);
        return pdfArray;
    };
    PDFObjectParser.prototype.parseDict = function() {
        this.bytes.assertNext((0, $8zvel.default).LessThan);
        this.bytes.assertNext((0, $8zvel.default).LessThan);
        this.skipWhitespaceAndComments();
        var dict = new Map();
        while(!this.bytes.done() && this.bytes.peek() !== (0, $8zvel.default).GreaterThan && this.bytes.peekAhead(1) !== (0, $8zvel.default).GreaterThan){
            var key = this.parseName();
            var value = this.parseObject();
            dict.set(key, value);
            this.skipWhitespaceAndComments();
        }
        this.skipWhitespaceAndComments();
        this.bytes.assertNext((0, $8zvel.default).GreaterThan);
        this.bytes.assertNext((0, $8zvel.default).GreaterThan);
        var Type = dict.get((0, $dPHSK.default).of('Type'));
        if (Type === (0, $dPHSK.default).of('Catalog')) return (0, $80c05707f2c8c1f7$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else if (Type === (0, $dPHSK.default).of('Pages')) return (0, $333acd2e5fba0d32$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else if (Type === (0, $dPHSK.default).of('Page')) return (0, $a9e73b7ced5abfa4$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else return (0, $85408478fbb7cbde$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
    };
    PDFObjectParser.prototype.parseDictOrStream = function() {
        var startPos = this.bytes.position();
        var dict = this.parseDict();
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).streamEOF1) && !this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).streamEOF2) && !this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).streamEOF3) && !this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).streamEOF4) && !this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).stream)) return dict;
        var start = this.bytes.offset();
        var end;
        var Length = dict.get((0, $dPHSK.default).of('Length'));
        if (Length instanceof (0, $j04jt.default)) {
            end = start + Length.asNumber();
            this.bytes.moveTo(end);
            this.skipWhitespaceAndComments();
            if (!this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).endstream)) {
                this.bytes.moveTo(start);
                end = this.findEndOfStreamFallback(startPos);
            }
        } else end = this.findEndOfStreamFallback(startPos);
        var contents = this.bytes.slice(start, end);
        return (0, $ef28c75b0f11042e$export$2e2bcd8739ae039).of(dict, contents);
    };
    PDFObjectParser.prototype.findEndOfStreamFallback = function(startPos) {
        // Move to end of stream, while handling nested streams
        var nestingLvl = 1;
        var end = this.bytes.offset();
        while(!this.bytes.done()){
            end = this.bytes.offset();
            if (this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).stream)) nestingLvl += 1;
            else if (this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).EOF1endstream) || this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).EOF2endstream) || this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).EOF3endstream) || this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).endstream)) nestingLvl -= 1;
            else this.bytes.next();
            if (nestingLvl === 0) break;
        }
        if (nestingLvl !== 0) throw new (0, $nAWRe.PDFStreamParsingError)(startPos);
        return end;
    };
    PDFObjectParser.forBytes = function(bytes, context, capNumbers) {
        return new PDFObjectParser((0, $93214384d2c510d6$export$2e2bcd8739ae039).of(bytes), context, capNumbers);
    };
    PDFObjectParser.forByteStream = function(byteStream, context, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        return new PDFObjectParser(byteStream, context, capNumbers);
    };
    return PDFObjectParser;
}((0, $ccc28a798e23d674$export$2e2bcd8739ae039));
var $2ce01d1490df00cf$export$2e2bcd8739ae039 = $2ce01d1490df00cf$var$PDFObjectParser;



var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");



parcelRequire("fvYKZ");
var $ggjMi = parcelRequire("ggjMi");
var $016bbd830ce30da5$var$PDFObjectStreamParser = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFObjectStreamParser, _super);
    function PDFObjectStreamParser(rawStream, shouldWaitForTick) {
        var _this = _super.call(this, (0, $93214384d2c510d6$export$2e2bcd8739ae039).fromPDFRawStream(rawStream), rawStream.dict.context) || this;
        var dict = rawStream.dict;
        _this.alreadyParsed = false;
        _this.shouldWaitForTick = shouldWaitForTick || function() {
            return false;
        };
        _this.firstOffset = dict.lookup((0, $dPHSK.default).of('First'), (0, $j04jt.default)).asNumber();
        _this.objectCount = dict.lookup((0, $dPHSK.default).of('N'), (0, $j04jt.default)).asNumber();
        return _this;
    }
    PDFObjectStreamParser.prototype.parseIntoContext = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var offsetsAndObjectNumbers, idx, len, _a, objectNumber, offset, object, ref;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.alreadyParsed) throw new (0, $nAWRe.ReparseError)('PDFObjectStreamParser', 'parseIntoContext');
                        this.alreadyParsed = true;
                        offsetsAndObjectNumbers = this.parseOffsetsAndObjectNumbers();
                        idx = 0, len = offsetsAndObjectNumbers.length;
                        _b.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a = offsetsAndObjectNumbers[idx], objectNumber = _a.objectNumber, offset = _a.offset;
                        this.bytes.moveTo(this.firstOffset + offset);
                        object = this.parseObject();
                        ref = (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(objectNumber, 0);
                        this.context.assign(ref, object);
                        if (!this.shouldWaitForTick()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFObjectStreamParser.prototype.parseOffsetsAndObjectNumbers = function() {
        var offsetsAndObjectNumbers = [];
        for(var idx = 0, len = this.objectCount; idx < len; idx++){
            this.skipWhitespaceAndComments();
            var objectNumber = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var offset = this.parseRawInt();
            offsetsAndObjectNumbers.push({
                objectNumber: objectNumber,
                offset: offset
            });
        }
        return offsetsAndObjectNumbers;
    };
    PDFObjectStreamParser.forStream = function(rawStream, shouldWaitForTick) {
        return new PDFObjectStreamParser(rawStream, shouldWaitForTick);
    };
    return PDFObjectStreamParser;
}((0, $2ce01d1490df00cf$export$2e2bcd8739ae039));
var $016bbd830ce30da5$export$2e2bcd8739ae039 = $016bbd830ce30da5$var$PDFObjectStreamParser;



var $cOQTW = parcelRequire("cOQTW");




var $nAWRe = parcelRequire("nAWRe");



var $dPHSK = parcelRequire("dPHSK");






var $nAWRe = parcelRequire("nAWRe");

var $8auL6 = parcelRequire("8auL6");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");


var $805c54c8bff8c138$var$PDFXRefStreamParser = /** @class */ function() {
    function PDFXRefStreamParser(rawStream) {
        this.alreadyParsed = false;
        this.dict = rawStream.dict;
        this.bytes = (0, $93214384d2c510d6$export$2e2bcd8739ae039).fromPDFRawStream(rawStream);
        this.context = this.dict.context;
        var Size = this.dict.lookup((0, $dPHSK.default).of('Size'), (0, $j04jt.default));
        var Index = this.dict.lookup((0, $dPHSK.default).of('Index'));
        if (Index instanceof (0, $8auL6.default)) {
            this.subsections = [];
            for(var idx = 0, len = Index.size(); idx < len; idx += 2){
                var firstObjectNumber = Index.lookup(idx + 0, (0, $j04jt.default)).asNumber();
                var length_1 = Index.lookup(idx + 1, (0, $j04jt.default)).asNumber();
                this.subsections.push({
                    firstObjectNumber: firstObjectNumber,
                    length: length_1
                });
            }
        } else this.subsections = [
            {
                firstObjectNumber: 0,
                length: Size.asNumber()
            }
        ];
        var W = this.dict.lookup((0, $dPHSK.default).of('W'), (0, $8auL6.default));
        this.byteWidths = [
            -1,
            -1,
            -1
        ];
        for(var idx = 0, len = W.size(); idx < len; idx++)this.byteWidths[idx] = W.lookup(idx, (0, $j04jt.default)).asNumber();
    }
    PDFXRefStreamParser.prototype.parseIntoContext = function() {
        if (this.alreadyParsed) throw new (0, $nAWRe.ReparseError)('PDFXRefStreamParser', 'parseIntoContext');
        this.alreadyParsed = true;
        this.context.trailerInfo = {
            Root: this.dict.get((0, $dPHSK.default).of('Root')),
            Encrypt: this.dict.get((0, $dPHSK.default).of('Encrypt')),
            Info: this.dict.get((0, $dPHSK.default).of('Info')),
            ID: this.dict.get((0, $dPHSK.default).of('ID'))
        };
        var entries = this.parseEntries();
        // for (let idx = 0, len = entries.length; idx < len; idx++) {
        // const entry = entries[idx];
        // if (entry.deleted) this.context.delete(entry.ref);
        // }
        return entries;
    };
    PDFXRefStreamParser.prototype.parseEntries = function() {
        var entries = [];
        var _a = this.byteWidths, typeFieldWidth = _a[0], offsetFieldWidth = _a[1], genFieldWidth = _a[2];
        for(var subsectionIdx = 0, subsectionLen = this.subsections.length; subsectionIdx < subsectionLen; subsectionIdx++){
            var _b = this.subsections[subsectionIdx], firstObjectNumber = _b.firstObjectNumber, length_2 = _b.length;
            for(var objIdx = 0; objIdx < length_2; objIdx++){
                var type = 0;
                for(var idx = 0, len = typeFieldWidth; idx < len; idx++)type = type << 8 | this.bytes.next();
                var offset = 0;
                for(var idx = 0, len = offsetFieldWidth; idx < len; idx++)offset = offset << 8 | this.bytes.next();
                var generationNumber = 0;
                for(var idx = 0, len = genFieldWidth; idx < len; idx++)generationNumber = generationNumber << 8 | this.bytes.next();
                // When the `type` field is absent, it defaults to 1
                if (typeFieldWidth === 0) type = 1;
                var objectNumber = firstObjectNumber + objIdx;
                var entry = {
                    ref: (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(objectNumber, generationNumber),
                    offset: offset,
                    deleted: type === 0,
                    inObjectStream: type === 2
                };
                entries.push(entry);
            }
        }
        return entries;
    };
    PDFXRefStreamParser.forStream = function(rawStream) {
        return new PDFXRefStreamParser(rawStream);
    };
    return PDFXRefStreamParser;
}();
var $805c54c8bff8c138$export$2e2bcd8739ae039 = $805c54c8bff8c138$var$PDFXRefStreamParser;




var $8zvel = parcelRequire("8zvel");


parcelRequire("fvYKZ");
var $ggjMi = parcelRequire("ggjMi");
var $0c78b71d995ee90b$var$PDFParser = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFParser, _super);
    function PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
        if (objectsPerTick === void 0) objectsPerTick = Infinity;
        if (throwOnInvalidObject === void 0) throwOnInvalidObject = false;
        if (capNumbers === void 0) capNumbers = false;
        var _this = _super.call(this, (0, $93214384d2c510d6$export$2e2bcd8739ae039).of(pdfBytes), (0, $ece91e5f61c516eb$export$2e2bcd8739ae039).create(), capNumbers) || this;
        _this.alreadyParsed = false;
        _this.parsedObjects = 0;
        _this.shouldWaitForTick = function() {
            _this.parsedObjects += 1;
            return _this.parsedObjects % _this.objectsPerTick === 0;
        };
        _this.objectsPerTick = objectsPerTick;
        _this.throwOnInvalidObject = throwOnInvalidObject;
        return _this;
    }
    PDFParser.prototype.parseDocument = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var prevOffset, offset;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.alreadyParsed) throw new (0, $nAWRe.ReparseError)('PDFParser', 'parseDocument');
                        this.alreadyParsed = true;
                        this.context.header = this.parseHeader();
                        _a.label = 1;
                    case 1:
                        if (!!this.bytes.done()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.parseDocumentSection()
                        ];
                    case 2:
                        _a.sent();
                        offset = this.bytes.offset();
                        if (offset === prevOffset) throw new (0, $nAWRe.StalledParserError)(this.bytes.position());
                        prevOffset = offset;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 3:
                        this.maybeRecoverRoot();
                        if (this.context.lookup((0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(0))) {
                            console.warn('Removing parsed object: 0 0 R');
                            this.context.delete((0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(0));
                        }
                        return [
                            2 /*return*/ ,
                            this.context
                        ];
                }
            });
        });
    };
    PDFParser.prototype.maybeRecoverRoot = function() {
        var isValidCatalog = function(obj) {
            return obj instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039) && obj.lookup((0, $dPHSK.default).of('Type')) === (0, $dPHSK.default).of('Catalog');
        };
        var catalog = this.context.lookup(this.context.trailerInfo.Root);
        if (!isValidCatalog(catalog)) {
            var indirectObjects = this.context.enumerateIndirectObjects();
            for(var idx = 0, len = indirectObjects.length; idx < len; idx++){
                var _a = indirectObjects[idx], ref = _a[0], object = _a[1];
                if (isValidCatalog(object)) this.context.trailerInfo.Root = ref;
            }
        }
    };
    PDFParser.prototype.parseHeader = function() {
        while(!this.bytes.done()){
            if (this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).header)) {
                var major = this.parseRawInt();
                this.bytes.assertNext((0, $8zvel.default).Period);
                var minor = this.parseRawInt();
                var header = (0, $ab35d5c6c69177c9$export$2e2bcd8739ae039).forVersion(major, minor);
                this.skipBinaryHeaderComment();
                return header;
            }
            this.bytes.next();
        }
        throw new (0, $nAWRe.MissingPDFHeaderError)(this.bytes.position());
    };
    PDFParser.prototype.parseIndirectObjectHeader = function() {
        this.skipWhitespaceAndComments();
        var objectNumber = this.parseRawInt();
        this.skipWhitespaceAndComments();
        var generationNumber = this.parseRawInt();
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).obj)) throw new (0, $nAWRe.MissingKeywordError)(this.bytes.position(), (0, $f3568ef95260ec55$export$93ad50ccfacdd77).obj);
        return (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(objectNumber, generationNumber);
    };
    PDFParser.prototype.matchIndirectObjectHeader = function() {
        var initialOffset = this.bytes.offset();
        try {
            this.parseIndirectObjectHeader();
            return true;
        } catch (e) {
            this.bytes.moveTo(initialOffset);
            return false;
        }
    };
    PDFParser.prototype.parseIndirectObject = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var ref, object;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ref = this.parseIndirectObjectHeader();
                        this.skipWhitespaceAndComments();
                        object = this.parseObject();
                        this.skipWhitespaceAndComments();
                        // if (!this.matchKeyword(Keywords.endobj)) {
                        // throw new MissingKeywordError(this.bytes.position(), Keywords.endobj);
                        // }
                        // TODO: Log a warning if this fails...
                        this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).endobj);
                        if (!(object instanceof (0, $ef28c75b0f11042e$export$2e2bcd8739ae039) && object.dict.lookup((0, $dPHSK.default).of('Type')) === (0, $dPHSK.default).of('ObjStm'))) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $016bbd830ce30da5$export$2e2bcd8739ae039).forStream(object, this.shouldWaitForTick).parseIntoContext()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        if (object instanceof (0, $ef28c75b0f11042e$export$2e2bcd8739ae039) && object.dict.lookup((0, $dPHSK.default).of('Type')) === (0, $dPHSK.default).of('XRef')) (0, $805c54c8bff8c138$export$2e2bcd8739ae039).forStream(object).parseIntoContext();
                        else this.context.assign(ref, object);
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ ,
                            ref
                        ];
                }
            });
        });
    };
    // TODO: Improve and clean this up
    PDFParser.prototype.tryToParseInvalidIndirectObject = function() {
        var startPos = this.bytes.position();
        var msg = "Trying to parse invalid object: " + JSON.stringify(startPos) + ")";
        if (this.throwOnInvalidObject) throw new Error(msg);
        console.warn(msg);
        var ref = this.parseIndirectObjectHeader();
        console.warn("Invalid object ref: " + ref);
        this.skipWhitespaceAndComments();
        var start = this.bytes.offset();
        var failed = true;
        while(!this.bytes.done()){
            if (this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).endobj)) failed = false;
            if (!failed) break;
            this.bytes.next();
        }
        if (failed) throw new (0, $nAWRe.PDFInvalidObjectParsingError)(startPos);
        var end = this.bytes.offset() - (0, $f3568ef95260ec55$export$93ad50ccfacdd77).endobj.length;
        var object = (0, $ad9390730b9495a5$export$2e2bcd8739ae039).of(this.bytes.slice(start, end));
        this.context.assign(ref, object);
        return ref;
    };
    PDFParser.prototype.parseIndirectObjects = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var initialOffset, e_1;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.skipWhitespaceAndComments();
                        _a.label = 1;
                    case 1:
                        if (!(!this.bytes.done() && (0, $5679a387c9e20301$export$9492c31549e88980)[this.bytes.peek()])) return [
                            3 /*break*/ ,
                            8
                        ];
                        initialOffset = this.bytes.offset();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.parseIndirectObject()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        e_1 = _a.sent();
                        // TODO: Add tracing/logging mechanism to track when this happens!
                        this.bytes.moveTo(initialOffset);
                        this.tryToParseInvalidIndirectObject();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        this.skipWhitespaceAndComments();
                        // TODO: Can this be done only when needed, to avoid harming performance?
                        this.skipJibberish();
                        if (!this.shouldWaitForTick()) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFParser.prototype.maybeParseCrossRefSection = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).xref)) return;
        this.skipWhitespaceAndComments();
        var objectNumber = -1;
        var xref = (0, $0acfb4f0f4898246$export$2e2bcd8739ae039).createEmpty();
        while(!this.bytes.done() && (0, $5679a387c9e20301$export$9492c31549e88980)[this.bytes.peek()]){
            var firstInt = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var secondInt = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var byte = this.bytes.peek();
            if (byte === (0, $8zvel.default).n || byte === (0, $8zvel.default).f) {
                var ref = (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(objectNumber, secondInt);
                if (this.bytes.next() === (0, $8zvel.default).n) xref.addEntry(ref, firstInt);
                else // this.context.delete(ref);
                xref.addDeletedEntry(ref, firstInt);
                objectNumber += 1;
            } else objectNumber = firstInt;
            this.skipWhitespaceAndComments();
        }
        return xref;
    };
    PDFParser.prototype.maybeParseTrailerDict = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).trailer)) return;
        this.skipWhitespaceAndComments();
        var dict = this.parseDict();
        var context = this.context;
        context.trailerInfo = {
            Root: dict.get((0, $dPHSK.default).of('Root')) || context.trailerInfo.Root,
            Encrypt: dict.get((0, $dPHSK.default).of('Encrypt')) || context.trailerInfo.Encrypt,
            Info: dict.get((0, $dPHSK.default).of('Info')) || context.trailerInfo.Info,
            ID: dict.get((0, $dPHSK.default).of('ID')) || context.trailerInfo.ID
        };
    };
    PDFParser.prototype.maybeParseTrailer = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).startxref)) return;
        this.skipWhitespaceAndComments();
        var offset = this.parseRawInt();
        this.skipWhitespace();
        this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).eof);
        this.skipWhitespaceAndComments();
        this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).eof);
        this.skipWhitespaceAndComments();
        return (0, $38bebcf76e0d2d54$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(offset);
    };
    PDFParser.prototype.parseDocumentSection = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.parseIndirectObjects()
                        ];
                    case 1:
                        _a.sent();
                        this.maybeParseCrossRefSection();
                        this.maybeParseTrailerDict();
                        this.maybeParseTrailer();
                        // TODO: Can this be done only when needed, to avoid harming performance?
                        this.skipJibberish();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * This operation is not necessary for valid PDF files. But some invalid PDFs
     * contain jibberish in between indirect objects. This method is designed to
     * skip past that jibberish, should it exist, until it reaches the next
     * indirect object header, an xref table section, or the file trailer.
     */ PDFParser.prototype.skipJibberish = function() {
        this.skipWhitespaceAndComments();
        while(!this.bytes.done()){
            var initialOffset = this.bytes.offset();
            var byte = this.bytes.peek();
            var isAlphaNumeric = byte >= (0, $8zvel.default).Space && byte <= (0, $8zvel.default).Tilde;
            if (isAlphaNumeric) {
                if (this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).xref) || this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).trailer) || this.matchKeyword((0, $f3568ef95260ec55$export$93ad50ccfacdd77).startxref) || this.matchIndirectObjectHeader()) {
                    this.bytes.moveTo(initialOffset);
                    break;
                }
            }
            this.bytes.next();
        }
    };
    /**
     * Skips the binary comment following a PDF header. The specification
     * defines this binary comment (section 7.5.2 File Header) as a sequence of 4
     * or more bytes that are 128 or greater, and which are preceded by a "%".
     *
     * This would imply that to strip out this binary comment, we could check for
     * a sequence of bytes starting with "%", and remove all subsequent bytes that
     * are 128 or greater. This works for many documents that properly comply with
     * the spec. But in the wild, there are PDFs that omit the leading "%", and
     * include bytes that are less than 128 (e.g. 0 or 1). So in order to parse
     * these headers correctly, we just throw out all bytes leading up to the
     * first indirect object header.
     */ PDFParser.prototype.skipBinaryHeaderComment = function() {
        this.skipWhitespaceAndComments();
        try {
            var initialOffset = this.bytes.offset();
            this.parseIndirectObjectHeader();
            this.bytes.moveTo(initialOffset);
        } catch (e) {
            this.bytes.next();
            this.skipWhitespaceAndComments();
        }
    };
    PDFParser.forBytesWithOptions = function(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
        return new PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers);
    };
    return PDFParser;
}((0, $2ce01d1490df00cf$export$2e2bcd8739ae039));
var $0c78b71d995ee90b$export$2e2bcd8739ae039 = $0c78b71d995ee90b$var$PDFParser;







var $8f93b7bf8ef0f00e$var$flag = function(bitIndex) {
    return 1 << bitIndex;
};
var $8f93b7bf8ef0f00e$export$1fa7b68b35026177;
(function(AnnotationFlags) {
    /**
     * If set, do not display the annotation if it does not belong to one of the
     * standard annotation types and no annotation handler is available. If clear,
     * display such an unknown annotation using an appearance stream specified by
     * its appearance dictionary, if any.
     */ AnnotationFlags[AnnotationFlags["Invisible"] = $8f93b7bf8ef0f00e$var$flag(0)] = "Invisible";
    /**
     * If set, do not display or print the annotation or allow it to interact with
     * the user, regardless of its annotation type or whether an annotation
     * handler is available.
     *
     * In cases where screen space is limited, the ability to hide and show
     * annotations selectively can be used in combination with appearance streams
     * to display auxiliary pop-up information similar in function to online help
     * systems.
     */ AnnotationFlags[AnnotationFlags["Hidden"] = $8f93b7bf8ef0f00e$var$flag(1)] = "Hidden";
    /**
     * If set, print the annotation when the page is printed. If clear, never
     * print the annotation, regardless of whether it is displayed on the screen.
     *
     * This can be useful for annotations representing interactive pushbuttons,
     * which would serve no meaningful purpose on the printed page.
     */ AnnotationFlags[AnnotationFlags["Print"] = $8f93b7bf8ef0f00e$var$flag(2)] = "Print";
    /**
     * If set, do not scale the annotation’s appearance to match the magnification
     * of the page. The location of the annotation on the page (defined by the
     * upper-left corner of its annotation rectangle) shall remain fixed,
     * regardless of the page magnification.
     */ AnnotationFlags[AnnotationFlags["NoZoom"] = $8f93b7bf8ef0f00e$var$flag(3)] = "NoZoom";
    /**
     * If set, do not rotate the annotation’s appearance to match the rotation of
     * the page. The upper-left corner of the annotation rectangle shall remain in
     * a fixed location on the page, regardless of the page rotation.
     */ AnnotationFlags[AnnotationFlags["NoRotate"] = $8f93b7bf8ef0f00e$var$flag(4)] = "NoRotate";
    /**
     * If set, do not display the annotation on the screen or allow it to interact
     * with the user. The annotation may be printed (depending on the setting of
     * the Print flag) but should be considered hidden for purposes of on-screen
     * display and user interaction.
     */ AnnotationFlags[AnnotationFlags["NoView"] = $8f93b7bf8ef0f00e$var$flag(5)] = "NoView";
    /**
     * If set, do not allow the annotation to interact with the user. The
     * annotation may be displayed or printed (depending on the settings of the
     * NoView and Print flags) but should not respond to mouse clicks or change
     * its appearance in response to mouse motions.
     *
     * This flag shall be ignored for widget annotations; its function is
     * subsumed by the ReadOnly flag of the associated form field.
     */ AnnotationFlags[AnnotationFlags["ReadOnly"] = $8f93b7bf8ef0f00e$var$flag(6)] = "ReadOnly";
    /**
     * If set, do not allow the annotation to be deleted or its properties
     * (including position and size) to be modified by the user. However, this
     * flag does not restrict changes to the annotation’s contents, such as the
     * value of a form field.
     */ AnnotationFlags[AnnotationFlags["Locked"] = $8f93b7bf8ef0f00e$var$flag(7)] = "Locked";
    /**
     * If set, invert the interpretation of the NoView flag for certain events.
     *
     * A typical use is to have an annotation that appears only when a mouse
     * cursor is held over it.
     */ AnnotationFlags[AnnotationFlags["ToggleNoView"] = $8f93b7bf8ef0f00e$var$flag(8)] = "ToggleNoView";
    /**
     * If set, do not allow the contents of the annotation to be modified by the
     * user. This flag does not restrict deletion of the annotation or changes to
     * other annotation properties, such as position and size.
     */ AnnotationFlags[AnnotationFlags["LockedContents"] = $8f93b7bf8ef0f00e$var$flag(9)] = "LockedContents";
})($8f93b7bf8ef0f00e$export$1fa7b68b35026177 || ($8f93b7bf8ef0f00e$export$1fa7b68b35026177 = {}));







var $dPHSK = parcelRequire("dPHSK");
var $j04jt = parcelRequire("j04jt");
var $a25479a44f824b27$export$69d5e1b305482e08 = function(name) {
    return name instanceof (0, $dPHSK.default) ? name : (0, $dPHSK.default).of(name);
};
var $a25479a44f824b27$export$fb5b5e76a3a5c568 = function(num) {
    return num instanceof (0, $j04jt.default) ? num : (0, $j04jt.default).of(num);
};
var $a25479a44f824b27$export$37576b9ba69b50db = function(num) {
    return num instanceof (0, $j04jt.default) ? num.asNumber() : num;
};


parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $hP0hy = parcelRequire("hP0hy");
var $3b4f8728c2695c8d$export$c3cc0f63dbb3500f;
(function(RotationTypes) {
    RotationTypes["Degrees"] = "degrees";
    RotationTypes["Radians"] = "radians";
})($3b4f8728c2695c8d$export$c3cc0f63dbb3500f || ($3b4f8728c2695c8d$export$c3cc0f63dbb3500f = {}));
var $3b4f8728c2695c8d$export$8449e153fbd325fc = function(radianAngle) {
    (0, $j0tvB.assertIs)(radianAngle, 'radianAngle', [
        'number'
    ]);
    return {
        type: $3b4f8728c2695c8d$export$c3cc0f63dbb3500f.Radians,
        angle: radianAngle
    };
};
var $3b4f8728c2695c8d$export$41fc368e1a942b97 = function(degreeAngle) {
    (0, $j0tvB.assertIs)(degreeAngle, 'degreeAngle', [
        'number'
    ]);
    return {
        type: $3b4f8728c2695c8d$export$c3cc0f63dbb3500f.Degrees,
        angle: degreeAngle
    };
};
var $3b4f8728c2695c8d$var$Radians = $3b4f8728c2695c8d$export$c3cc0f63dbb3500f.Radians, $3b4f8728c2695c8d$var$Degrees = $3b4f8728c2695c8d$export$c3cc0f63dbb3500f.Degrees;
var $3b4f8728c2695c8d$export$c9fcf1a7df975d78 = function(degree) {
    return degree * Math.PI / 180;
};
var $3b4f8728c2695c8d$export$c41dd2a8460d3196 = function(radian) {
    return radian * 180 / Math.PI;
};
var $3b4f8728c2695c8d$export$cba01ba138429a1d = function(rotation) {
    return rotation.type === $3b4f8728c2695c8d$var$Radians ? rotation.angle : rotation.type === $3b4f8728c2695c8d$var$Degrees ? $3b4f8728c2695c8d$export$c9fcf1a7df975d78(rotation.angle) : (0, $hP0hy.error)("Invalid rotation: " + JSON.stringify(rotation));
};
var $3b4f8728c2695c8d$export$56cb859c01fa134d = function(rotation) {
    return rotation.type === $3b4f8728c2695c8d$var$Radians ? $3b4f8728c2695c8d$export$c41dd2a8460d3196(rotation.angle) : rotation.type === $3b4f8728c2695c8d$var$Degrees ? rotation.angle : (0, $hP0hy.error)("Invalid rotation: " + JSON.stringify(rotation));
};
var $3b4f8728c2695c8d$export$ee0ed07fe78ec05 = function(degreeAngle) {
    if (degreeAngle === void 0) degreeAngle = 0;
    var quadrants = degreeAngle / 90 % 4;
    if (quadrants === 0) return 0;
    if (quadrants === 1) return 90;
    if (quadrants === 2) return 180;
    if (quadrants === 3) return 270;
    return 0; // `degreeAngle` is not a multiple of 90
};
var $3b4f8728c2695c8d$export$312e44550db33c6a = function(dims, degreeAngle) {
    if (degreeAngle === void 0) degreeAngle = 0;
    var rotation = $3b4f8728c2695c8d$export$ee0ed07fe78ec05(degreeAngle);
    return rotation === 90 || rotation === 270 ? {
        width: dims.height,
        height: dims.width
    } : {
        width: dims.width,
        height: dims.height
    };
};
var $3b4f8728c2695c8d$export$afddc3b8600307a4 = function(rectangle, borderWidth, degreeAngle) {
    if (borderWidth === void 0) borderWidth = 0;
    if (degreeAngle === void 0) degreeAngle = 0;
    var x = rectangle.x, y = rectangle.y, w = rectangle.width, h = rectangle.height;
    var r = $3b4f8728c2695c8d$export$ee0ed07fe78ec05(degreeAngle);
    var b = borderWidth / 2;
    // prettier-ignore
    if (r === 0) return {
        x: x - b,
        y: y - b,
        width: w,
        height: h
    };
    else if (r === 90) return {
        x: x - h + b,
        y: y - b,
        width: h,
        height: w
    };
    else if (r === 180) return {
        x: x - w + b,
        y: y - h + b,
        width: w,
        height: h
    };
    else if (r === 270) return {
        x: x - b,
        y: y - w + b,
        width: h,
        height: w
    };
    else return {
        x: x - b,
        y: y - b,
        width: w,
        height: h
    };
};



var $cfb765e9daff3c3a$export$e0b576e7a74416cd = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).ClipNonZero);
};
var $cfb765e9daff3c3a$export$dd6fb25f201b5a7a = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).ClipEvenOdd);
};
/* ==================== Graphics State Operators ==================== */ var $cfb765e9daff3c3a$var$cos = Math.cos, $cfb765e9daff3c3a$var$sin = Math.sin, $cfb765e9daff3c3a$var$tan = Math.tan;
var $cfb765e9daff3c3a$export$ed5b99ee38154497 = function(a, b, c, d, e, f) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).ConcatTransformationMatrix, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(a),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(b),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(c),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(d),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(e),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(f)
    ]);
};
var $cfb765e9daff3c3a$export$d73ee8ef04f5226a = function(xPos, yPos) {
    return $cfb765e9daff3c3a$export$ed5b99ee38154497(1, 0, 0, 1, xPos, yPos);
};
var $cfb765e9daff3c3a$export$dcdf75081b88279d = function(xPos, yPos) {
    return $cfb765e9daff3c3a$export$ed5b99ee38154497(xPos, 0, 0, yPos, 0, 0);
};
var $cfb765e9daff3c3a$export$a2ba89726971a90f = function(angle) {
    return $cfb765e9daff3c3a$export$ed5b99ee38154497($cfb765e9daff3c3a$var$cos((0, $a25479a44f824b27$export$37576b9ba69b50db)(angle)), $cfb765e9daff3c3a$var$sin((0, $a25479a44f824b27$export$37576b9ba69b50db)(angle)), -$cfb765e9daff3c3a$var$sin((0, $a25479a44f824b27$export$37576b9ba69b50db)(angle)), $cfb765e9daff3c3a$var$cos((0, $a25479a44f824b27$export$37576b9ba69b50db)(angle)), 0, 0);
};
var $cfb765e9daff3c3a$export$91df22fbff99d059 = function(angle) {
    return $cfb765e9daff3c3a$export$a2ba89726971a90f((0, $3b4f8728c2695c8d$export$c9fcf1a7df975d78)((0, $a25479a44f824b27$export$37576b9ba69b50db)(angle)));
};
var $cfb765e9daff3c3a$export$985cb1d69d6a3add = function(xSkewAngle, ySkewAngle) {
    return $cfb765e9daff3c3a$export$ed5b99ee38154497(1, $cfb765e9daff3c3a$var$tan((0, $a25479a44f824b27$export$37576b9ba69b50db)(xSkewAngle)), $cfb765e9daff3c3a$var$tan((0, $a25479a44f824b27$export$37576b9ba69b50db)(ySkewAngle)), 1, 0, 0);
};
var $cfb765e9daff3c3a$export$8ecb831b3efbb169 = function(xSkewAngle, ySkewAngle) {
    return $cfb765e9daff3c3a$export$985cb1d69d6a3add((0, $3b4f8728c2695c8d$export$c9fcf1a7df975d78)((0, $a25479a44f824b27$export$37576b9ba69b50db)(xSkewAngle)), (0, $3b4f8728c2695c8d$export$c9fcf1a7df975d78)((0, $a25479a44f824b27$export$37576b9ba69b50db)(ySkewAngle)));
};
var $cfb765e9daff3c3a$export$e0e900d241274e06 = function(dashArray, dashPhase) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetLineDashPattern, [
        "[" + dashArray.map((0, $a25479a44f824b27$export$fb5b5e76a3a5c568)).join(' ') + "]",
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(dashPhase)
    ]);
};
var $cfb765e9daff3c3a$export$d10d019aadfd45c7 = function() {
    return $cfb765e9daff3c3a$export$e0e900d241274e06([], 0);
};
var $cfb765e9daff3c3a$export$7a77bc708e50709e;
(function(LineCapStyle) {
    LineCapStyle[LineCapStyle["Butt"] = 0] = "Butt";
    LineCapStyle[LineCapStyle["Round"] = 1] = "Round";
    LineCapStyle[LineCapStyle["Projecting"] = 2] = "Projecting";
})($cfb765e9daff3c3a$export$7a77bc708e50709e || ($cfb765e9daff3c3a$export$7a77bc708e50709e = {}));
var $cfb765e9daff3c3a$export$6c65ed24e870eec = function(style) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetLineCapStyle, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(style)
    ]);
};
var $cfb765e9daff3c3a$export$cba5d0f1cde60b86;
(function(LineJoinStyle) {
    LineJoinStyle[LineJoinStyle["Miter"] = 0] = "Miter";
    LineJoinStyle[LineJoinStyle["Round"] = 1] = "Round";
    LineJoinStyle[LineJoinStyle["Bevel"] = 2] = "Bevel";
})($cfb765e9daff3c3a$export$cba5d0f1cde60b86 || ($cfb765e9daff3c3a$export$cba5d0f1cde60b86 = {}));
var $cfb765e9daff3c3a$export$97dfb3b4509cd5bc = function(style) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetLineJoinStyle, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(style)
    ]);
};
var $cfb765e9daff3c3a$export$568567f665d3f3bb = function(state) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetGraphicsStateParams, [
        (0, $a25479a44f824b27$export$69d5e1b305482e08)(state)
    ]);
};
var $cfb765e9daff3c3a$export$cb182c48e35739ac = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).PushGraphicsState);
};
var $cfb765e9daff3c3a$export$10581a6f45bf75eb = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).PopGraphicsState);
};
var $cfb765e9daff3c3a$export$558e0f90d8262345 = function(width) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetLineWidth, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(width)
    ]);
};
var $cfb765e9daff3c3a$export$45bd49bb15a3c5cb = function(x1, y1, x2, y2, x3, y3) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).AppendBezierCurve, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(x1),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(y1),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(x2),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(y2),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(x3),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(y3)
    ]);
};
var $cfb765e9daff3c3a$export$6f4913b22432f892 = function(x1, y1, x2, y2) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).CurveToReplicateInitialPoint, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(x1),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(y1),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(x2),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(y2)
    ]);
};
var $cfb765e9daff3c3a$export$21f87e210c424cd0 = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).ClosePath);
};
var $cfb765e9daff3c3a$export$75f1ccd6dc32e80a = function(xPos, yPos) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).MoveTo, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(xPos),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(yPos)
    ]);
};
var $cfb765e9daff3c3a$export$73abee0cf983cb99 = function(xPos, yPos) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).LineTo, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(xPos),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(yPos)
    ]);
};
var $cfb765e9daff3c3a$export$405b065079b7caf2 = function(xPos, yPos, width, height) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).AppendRectangle, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(xPos),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(yPos),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(width),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(height)
    ]);
};
var $cfb765e9daff3c3a$export$dd4f28cef696bc7d = function(xPos, yPos, size) {
    return $cfb765e9daff3c3a$export$405b065079b7caf2(xPos, yPos, size, size);
};
var $cfb765e9daff3c3a$export$d9b706f8d0a70aef = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).StrokePath);
};
var $cfb765e9daff3c3a$export$9563e054e6f787fb = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).FillNonZero);
};
var $cfb765e9daff3c3a$export$76d37801baac10fb = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).FillNonZeroAndStroke);
};
var $cfb765e9daff3c3a$export$d366e9c0a9bd860f = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).EndPath);
};
var $cfb765e9daff3c3a$export$829ffc2dbe358942 = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).NextLine);
};
var $cfb765e9daff3c3a$export$b84c1833e225e397 = function(x, y) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).MoveText, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(x),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(y)
    ]);
};
var $cfb765e9daff3c3a$export$778bfc3c1a2b7ba4 = function(text) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).ShowText, [
        text
    ]);
};
var $cfb765e9daff3c3a$export$337b8dbf65fbb95e = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).BeginText);
};
var $cfb765e9daff3c3a$export$e3caa83a99d72806 = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).EndText);
};
var $cfb765e9daff3c3a$export$df01d619ff6ce7f7 = function(name, size) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetFontAndSize, [
        (0, $a25479a44f824b27$export$69d5e1b305482e08)(name),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(size)
    ]);
};
var $cfb765e9daff3c3a$export$710392ce2617f080 = function(spacing) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetCharacterSpacing, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(spacing)
    ]);
};
var $cfb765e9daff3c3a$export$a2801242b2f8967d = function(spacing) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetWordSpacing, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(spacing)
    ]);
};
var $cfb765e9daff3c3a$export$20dbb065c447b4da = function(squeeze) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetTextHorizontalScaling, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(squeeze)
    ]);
};
var $cfb765e9daff3c3a$export$79399e66b6bb212c = function(lineHeight) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetTextLineHeight, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(lineHeight)
    ]);
};
var $cfb765e9daff3c3a$export$ad1653459b07f70c = function(rise) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetTextRise, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(rise)
    ]);
};
var $cfb765e9daff3c3a$export$ca45e4ab114d4814;
(function(TextRenderingMode) {
    TextRenderingMode[TextRenderingMode["Fill"] = 0] = "Fill";
    TextRenderingMode[TextRenderingMode["Outline"] = 1] = "Outline";
    TextRenderingMode[TextRenderingMode["FillAndOutline"] = 2] = "FillAndOutline";
    TextRenderingMode[TextRenderingMode["Invisible"] = 3] = "Invisible";
    TextRenderingMode[TextRenderingMode["FillAndClip"] = 4] = "FillAndClip";
    TextRenderingMode[TextRenderingMode["OutlineAndClip"] = 5] = "OutlineAndClip";
    TextRenderingMode[TextRenderingMode["FillAndOutlineAndClip"] = 6] = "FillAndOutlineAndClip";
    TextRenderingMode[TextRenderingMode["Clip"] = 7] = "Clip";
})($cfb765e9daff3c3a$export$ca45e4ab114d4814 || ($cfb765e9daff3c3a$export$ca45e4ab114d4814 = {}));
var $cfb765e9daff3c3a$export$99f0dc2c4cb099ab = function(mode) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetTextRenderingMode, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(mode)
    ]);
};
var $cfb765e9daff3c3a$export$d3656d656af31043 = function(a, b, c, d, e, f) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).SetTextMatrix, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(a),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(b),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(c),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(d),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(e),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(f)
    ]);
};
var $cfb765e9daff3c3a$export$f567083ac6aa5aa3 = function(rotationAngle, xSkewAngle, ySkewAngle, x, y) {
    return $cfb765e9daff3c3a$export$d3656d656af31043($cfb765e9daff3c3a$var$cos((0, $a25479a44f824b27$export$37576b9ba69b50db)(rotationAngle)), $cfb765e9daff3c3a$var$sin((0, $a25479a44f824b27$export$37576b9ba69b50db)(rotationAngle)) + $cfb765e9daff3c3a$var$tan((0, $a25479a44f824b27$export$37576b9ba69b50db)(xSkewAngle)), -$cfb765e9daff3c3a$var$sin((0, $a25479a44f824b27$export$37576b9ba69b50db)(rotationAngle)) + $cfb765e9daff3c3a$var$tan((0, $a25479a44f824b27$export$37576b9ba69b50db)(ySkewAngle)), $cfb765e9daff3c3a$var$cos((0, $a25479a44f824b27$export$37576b9ba69b50db)(rotationAngle)), x, y);
};
var $cfb765e9daff3c3a$export$909384d9b9d39aff = function(rotationAngle, xSkewAngle, ySkewAngle, x, y) {
    return $cfb765e9daff3c3a$export$f567083ac6aa5aa3((0, $3b4f8728c2695c8d$export$c9fcf1a7df975d78)((0, $a25479a44f824b27$export$37576b9ba69b50db)(rotationAngle)), (0, $3b4f8728c2695c8d$export$c9fcf1a7df975d78)((0, $a25479a44f824b27$export$37576b9ba69b50db)(xSkewAngle)), (0, $3b4f8728c2695c8d$export$c9fcf1a7df975d78)((0, $a25479a44f824b27$export$37576b9ba69b50db)(ySkewAngle)), x, y);
};
var $cfb765e9daff3c3a$export$382c18f8bccd9e2b = function(name) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).DrawObject, [
        (0, $a25479a44f824b27$export$69d5e1b305482e08)(name)
    ]);
};
var $cfb765e9daff3c3a$export$f30201749d00f572 = function(gray) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).NonStrokingColorGray, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(gray)
    ]);
};
var $cfb765e9daff3c3a$export$6502921112196b8f = function(gray) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).StrokingColorGray, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(gray)
    ]);
};
var $cfb765e9daff3c3a$export$f59cae633978eea7 = function(red, green, blue) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).NonStrokingColorRgb, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(red),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(green),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(blue)
    ]);
};
var $cfb765e9daff3c3a$export$e743468c48a4fd5a = function(red, green, blue) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).StrokingColorRgb, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(red),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(green),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(blue)
    ]);
};
var $cfb765e9daff3c3a$export$e836aceb3db98cc0 = function(cyan, magenta, yellow, key) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).NonStrokingColorCmyk, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(cyan),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(magenta),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(yellow),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(key)
    ]);
};
var $cfb765e9daff3c3a$export$4004b818fda831c1 = function(cyan, magenta, yellow, key) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).StrokingColorCmyk, [
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(cyan),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(magenta),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(yellow),
        (0, $a25479a44f824b27$export$fb5b5e76a3a5c568)(key)
    ]);
};
var $cfb765e9daff3c3a$export$a028b403e40f1ab2 = function(tag) {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).BeginMarkedContent, [
        (0, $a25479a44f824b27$export$69d5e1b305482e08)(tag)
    ]);
};
var $cfb765e9daff3c3a$export$935e2334f5a50589 = function() {
    return (0, $400c0bd11400a1c4$export$2e2bcd8739ae039).of((0, $27958cc2c5d88a31$export$2e2bcd8739ae039).EndMarkedContent);
};


parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $hP0hy = parcelRequire("hP0hy");
var $030fa0a2c4d1456e$export$4eb09b1c0a6dec24;
(function(ColorTypes) {
    ColorTypes["Grayscale"] = "Grayscale";
    ColorTypes["RGB"] = "RGB";
    ColorTypes["CMYK"] = "CMYK";
})($030fa0a2c4d1456e$export$4eb09b1c0a6dec24 || ($030fa0a2c4d1456e$export$4eb09b1c0a6dec24 = {}));
var $030fa0a2c4d1456e$export$6f416a6db2dfcd5c = function(gray) {
    (0, $j0tvB.assertRange)(gray, 'gray', 0.0, 1.0);
    return {
        type: $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.Grayscale,
        gray: gray
    };
};
var $030fa0a2c4d1456e$export$8972dc0e6ad9238f = function(red, green, blue) {
    (0, $j0tvB.assertRange)(red, 'red', 0, 1);
    (0, $j0tvB.assertRange)(green, 'green', 0, 1);
    (0, $j0tvB.assertRange)(blue, 'blue', 0, 1);
    return {
        type: $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.RGB,
        red: red,
        green: green,
        blue: blue
    };
};
var $030fa0a2c4d1456e$export$358b1a66a3c77756 = function(cyan, magenta, yellow, key) {
    (0, $j0tvB.assertRange)(cyan, 'cyan', 0, 1);
    (0, $j0tvB.assertRange)(magenta, 'magenta', 0, 1);
    (0, $j0tvB.assertRange)(yellow, 'yellow', 0, 1);
    (0, $j0tvB.assertRange)(key, 'key', 0, 1);
    return {
        type: $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.CMYK,
        cyan: cyan,
        magenta: magenta,
        yellow: yellow,
        key: key
    };
};
var $030fa0a2c4d1456e$var$Grayscale = $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.Grayscale, $030fa0a2c4d1456e$var$RGB = $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.RGB, $030fa0a2c4d1456e$var$CMYK = $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.CMYK;
var $030fa0a2c4d1456e$export$6126e5d7ba707741 = function(color) {
    return color.type === $030fa0a2c4d1456e$var$Grayscale ? (0, $cfb765e9daff3c3a$export$f30201749d00f572)(color.gray) : color.type === $030fa0a2c4d1456e$var$RGB ? (0, $cfb765e9daff3c3a$export$f59cae633978eea7)(color.red, color.green, color.blue) : color.type === $030fa0a2c4d1456e$var$CMYK ? (0, $cfb765e9daff3c3a$export$e836aceb3db98cc0)(color.cyan, color.magenta, color.yellow, color.key) : (0, $hP0hy.error)("Invalid color: " + JSON.stringify(color));
};
var $030fa0a2c4d1456e$export$ae31e5cacc8bb23d = function(color) {
    return color.type === $030fa0a2c4d1456e$var$Grayscale ? (0, $cfb765e9daff3c3a$export$6502921112196b8f)(color.gray) : color.type === $030fa0a2c4d1456e$var$RGB ? (0, $cfb765e9daff3c3a$export$e743468c48a4fd5a)(color.red, color.green, color.blue) : color.type === $030fa0a2c4d1456e$var$CMYK ? (0, $cfb765e9daff3c3a$export$4004b818fda831c1)(color.cyan, color.magenta, color.yellow, color.key) : (0, $hP0hy.error)("Invalid color: " + JSON.stringify(color));
};
var $030fa0a2c4d1456e$export$8750a268217b0987 = function(comps, scale) {
    if (scale === void 0) scale = 1;
    return (comps === null || comps === void 0 ? void 0 : comps.length) === 1 ? $030fa0a2c4d1456e$export$6f416a6db2dfcd5c(comps[0] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 3 ? $030fa0a2c4d1456e$export$8972dc0e6ad9238f(comps[0] * scale, comps[1] * scale, comps[2] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 4 ? $030fa0a2c4d1456e$export$358b1a66a3c77756(comps[0] * scale, comps[1] * scale, comps[2] * scale, comps[3] * scale) : undefined;
};
var $030fa0a2c4d1456e$export$ffee2793812e3e56 = function(color) {
    return color.type === $030fa0a2c4d1456e$var$Grayscale ? [
        color.gray
    ] : color.type === $030fa0a2c4d1456e$var$RGB ? [
        color.red,
        color.green,
        color.blue
    ] : color.type === $030fa0a2c4d1456e$var$CMYK ? [
        color.cyan,
        color.magenta,
        color.yellow,
        color.key
    ] : (0, $hP0hy.error)("Invalid color: " + JSON.stringify(color));
};




// Originated from pdfkit Copyright (c) 2014 Devon Govett
// https://github.com/foliojs/pdfkit/blob/1e62e6ffe24b378eb890df507a47610f4c4a7b24/lib/path.js
// MIT LICENSE
// Updated for pdf-lib & TypeScript by Jeremy Messenger

var $d3cf96a299d38647$var$cx = 0;
var $d3cf96a299d38647$var$cy = 0;
var $d3cf96a299d38647$var$px = 0;
var $d3cf96a299d38647$var$py = 0;
var $d3cf96a299d38647$var$sx = 0;
var $d3cf96a299d38647$var$sy = 0;
var $d3cf96a299d38647$var$parameters = new Map([
    [
        'A',
        7
    ],
    [
        'a',
        7
    ],
    [
        'C',
        6
    ],
    [
        'c',
        6
    ],
    [
        'H',
        1
    ],
    [
        'h',
        1
    ],
    [
        'L',
        2
    ],
    [
        'l',
        2
    ],
    [
        'M',
        2
    ],
    [
        'm',
        2
    ],
    [
        'Q',
        4
    ],
    [
        'q',
        4
    ],
    [
        'S',
        4
    ],
    [
        's',
        4
    ],
    [
        'T',
        2
    ],
    [
        't',
        2
    ],
    [
        'V',
        1
    ],
    [
        'v',
        1
    ],
    [
        'Z',
        0
    ],
    [
        'z',
        0
    ]
]);
var $d3cf96a299d38647$var$parse = function(path) {
    var cmd;
    var ret = [];
    var args = [];
    var curArg = '';
    var foundDecimal = false;
    var params = 0;
    for(var _i = 0, path_1 = path; _i < path_1.length; _i++){
        var c = path_1[_i];
        if ($d3cf96a299d38647$var$parameters.has(c)) {
            params = $d3cf96a299d38647$var$parameters.get(c);
            if (cmd) {
                // save existing command
                if (curArg.length > 0) args[args.length] = +curArg;
                ret[ret.length] = {
                    cmd: cmd,
                    args: args
                };
                args = [];
                curArg = '';
                foundDecimal = false;
            }
            cmd = c;
        } else if ([
            ' ',
            ','
        ].includes(c) || c === '-' && curArg.length > 0 && curArg[curArg.length - 1] !== 'e' || c === '.' && foundDecimal) {
            if (curArg.length === 0) continue;
            if (args.length === params) {
                // handle reused commands
                ret[ret.length] = {
                    cmd: cmd,
                    args: args
                };
                args = [
                    +curArg
                ];
                // handle assumed commands
                if (cmd === 'M') cmd = 'L';
                if (cmd === 'm') cmd = 'l';
            } else args[args.length] = +curArg;
            foundDecimal = c === '.';
            // fix for negative numbers or repeated decimals with no delimeter between commands
            curArg = [
                '-',
                '.'
            ].includes(c) ? c : '';
        } else {
            curArg += c;
            if (c === '.') foundDecimal = true;
        }
    }
    // add the last command
    if (curArg.length > 0) {
        if (args.length === params) {
            // handle reused commands
            ret[ret.length] = {
                cmd: cmd,
                args: args
            };
            args = [
                +curArg
            ];
            // handle assumed commands
            if (cmd === 'M') cmd = 'L';
            if (cmd === 'm') cmd = 'l';
        } else args[args.length] = +curArg;
    }
    ret[ret.length] = {
        cmd: cmd,
        args: args
    };
    return ret;
};
var $d3cf96a299d38647$var$apply = function(commands) {
    // current point, control point, and subpath starting point
    $d3cf96a299d38647$var$cx = $d3cf96a299d38647$var$cy = $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$sx = $d3cf96a299d38647$var$sy = 0;
    // run the commands
    var cmds = [];
    for(var i = 0; i < commands.length; i++){
        var c = commands[i];
        if (c.cmd && typeof $d3cf96a299d38647$var$runners[c.cmd] === 'function') {
            var cmd = $d3cf96a299d38647$var$runners[c.cmd](c.args);
            if (Array.isArray(cmd)) cmds = cmds.concat(cmd);
            else cmds.push(cmd);
        }
    }
    return cmds;
};
var $d3cf96a299d38647$var$runners = {
    M: function(a) {
        $d3cf96a299d38647$var$cx = a[0];
        $d3cf96a299d38647$var$cy = a[1];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        $d3cf96a299d38647$var$sx = $d3cf96a299d38647$var$cx;
        $d3cf96a299d38647$var$sy = $d3cf96a299d38647$var$cy;
        return (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    m: function(a) {
        $d3cf96a299d38647$var$cx += a[0];
        $d3cf96a299d38647$var$cy += a[1];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        $d3cf96a299d38647$var$sx = $d3cf96a299d38647$var$cx;
        $d3cf96a299d38647$var$sy = $d3cf96a299d38647$var$cy;
        return (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    C: function(a) {
        $d3cf96a299d38647$var$cx = a[4];
        $d3cf96a299d38647$var$cy = a[5];
        $d3cf96a299d38647$var$px = a[2];
        $d3cf96a299d38647$var$py = a[3];
        return (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(a[0], a[1], a[2], a[3], a[4], a[5]);
    },
    c: function(a) {
        var cmd = (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(a[0] + $d3cf96a299d38647$var$cx, a[1] + $d3cf96a299d38647$var$cy, a[2] + $d3cf96a299d38647$var$cx, a[3] + $d3cf96a299d38647$var$cy, a[4] + $d3cf96a299d38647$var$cx, a[5] + $d3cf96a299d38647$var$cy);
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx + a[2];
        $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy + a[3];
        $d3cf96a299d38647$var$cx += a[4];
        $d3cf96a299d38647$var$cy += a[5];
        return cmd;
    },
    S: function(a) {
        if ($d3cf96a299d38647$var$px === null || $d3cf96a299d38647$var$py === null) {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx;
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy;
        }
        var cmd = (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)($d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx), $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy), a[0], a[1], a[2], a[3]);
        $d3cf96a299d38647$var$px = a[0];
        $d3cf96a299d38647$var$py = a[1];
        $d3cf96a299d38647$var$cx = a[2];
        $d3cf96a299d38647$var$cy = a[3];
        return cmd;
    },
    s: function(a) {
        if ($d3cf96a299d38647$var$px === null || $d3cf96a299d38647$var$py === null) {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx;
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy;
        }
        var cmd = (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)($d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx), $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy), $d3cf96a299d38647$var$cx + a[0], $d3cf96a299d38647$var$cy + a[1], $d3cf96a299d38647$var$cx + a[2], $d3cf96a299d38647$var$cy + a[3]);
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx + a[0];
        $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy + a[1];
        $d3cf96a299d38647$var$cx += a[2];
        $d3cf96a299d38647$var$cy += a[3];
        return cmd;
    },
    Q: function(a) {
        $d3cf96a299d38647$var$px = a[0];
        $d3cf96a299d38647$var$py = a[1];
        $d3cf96a299d38647$var$cx = a[2];
        $d3cf96a299d38647$var$cy = a[3];
        return (0, $cfb765e9daff3c3a$export$6f4913b22432f892)(a[0], a[1], $d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    q: function(a) {
        var cmd = (0, $cfb765e9daff3c3a$export$6f4913b22432f892)(a[0] + $d3cf96a299d38647$var$cx, a[1] + $d3cf96a299d38647$var$cy, a[2] + $d3cf96a299d38647$var$cx, a[3] + $d3cf96a299d38647$var$cy);
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx + a[0];
        $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy + a[1];
        $d3cf96a299d38647$var$cx += a[2];
        $d3cf96a299d38647$var$cy += a[3];
        return cmd;
    },
    T: function(a) {
        if ($d3cf96a299d38647$var$px === null || $d3cf96a299d38647$var$py === null) {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx;
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy;
        } else {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx);
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy);
        }
        var cmd = (0, $cfb765e9daff3c3a$export$6f4913b22432f892)($d3cf96a299d38647$var$px, $d3cf96a299d38647$var$py, a[0], a[1]);
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx);
        $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy);
        $d3cf96a299d38647$var$cx = a[0];
        $d3cf96a299d38647$var$cy = a[1];
        return cmd;
    },
    t: function(a) {
        if ($d3cf96a299d38647$var$px === null || $d3cf96a299d38647$var$py === null) {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx;
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy;
        } else {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx);
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy);
        }
        var cmd = (0, $cfb765e9daff3c3a$export$6f4913b22432f892)($d3cf96a299d38647$var$px, $d3cf96a299d38647$var$py, $d3cf96a299d38647$var$cx + a[0], $d3cf96a299d38647$var$cy + a[1]);
        $d3cf96a299d38647$var$cx += a[0];
        $d3cf96a299d38647$var$cy += a[1];
        return cmd;
    },
    A: function(a) {
        var cmds = $d3cf96a299d38647$var$solveArc($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy, a);
        $d3cf96a299d38647$var$cx = a[5];
        $d3cf96a299d38647$var$cy = a[6];
        return cmds;
    },
    a: function(a) {
        a[5] += $d3cf96a299d38647$var$cx;
        a[6] += $d3cf96a299d38647$var$cy;
        var cmds = $d3cf96a299d38647$var$solveArc($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy, a);
        $d3cf96a299d38647$var$cx = a[5];
        $d3cf96a299d38647$var$cy = a[6];
        return cmds;
    },
    L: function(a) {
        $d3cf96a299d38647$var$cx = a[0];
        $d3cf96a299d38647$var$cy = a[1];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    l: function(a) {
        $d3cf96a299d38647$var$cx += a[0];
        $d3cf96a299d38647$var$cy += a[1];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    H: function(a) {
        $d3cf96a299d38647$var$cx = a[0];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    h: function(a) {
        $d3cf96a299d38647$var$cx += a[0];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    V: function(a) {
        $d3cf96a299d38647$var$cy = a[0];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    v: function(a) {
        $d3cf96a299d38647$var$cy += a[0];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    Z: function() {
        var cmd = (0, $cfb765e9daff3c3a$export$21f87e210c424cd0)();
        $d3cf96a299d38647$var$cx = $d3cf96a299d38647$var$sx;
        $d3cf96a299d38647$var$cy = $d3cf96a299d38647$var$sy;
        return cmd;
    },
    z: function() {
        var cmd = (0, $cfb765e9daff3c3a$export$21f87e210c424cd0)();
        $d3cf96a299d38647$var$cx = $d3cf96a299d38647$var$sx;
        $d3cf96a299d38647$var$cy = $d3cf96a299d38647$var$sy;
        return cmd;
    }
};
var $d3cf96a299d38647$var$solveArc = function(x, y, coords) {
    var rx = coords[0], ry = coords[1], rot = coords[2], large = coords[3], sweep = coords[4], ex = coords[5], ey = coords[6];
    var segs = $d3cf96a299d38647$var$arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
    var cmds = [];
    for(var _i = 0, segs_1 = segs; _i < segs_1.length; _i++){
        var seg = segs_1[_i];
        var bez = $d3cf96a299d38647$var$segmentToBezier.apply(void 0, seg);
        cmds.push((0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb).apply(void 0, bez));
    }
    return cmds;
};
// from Inkscape svgtopdf, thanks!
var $d3cf96a299d38647$var$arcToSegments = function(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
    var th = rotateX * (Math.PI / 180);
    var sinTh = Math.sin(th);
    var cosTh = Math.cos(th);
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    $d3cf96a299d38647$var$px = cosTh * (ox - x) * 0.5 + sinTh * (oy - y) * 0.5;
    $d3cf96a299d38647$var$py = cosTh * (oy - y) * 0.5 - sinTh * (ox - x) * 0.5;
    var pl = $d3cf96a299d38647$var$px * $d3cf96a299d38647$var$px / (rx * rx) + $d3cf96a299d38647$var$py * $d3cf96a299d38647$var$py / (ry * ry);
    if (pl > 1) {
        pl = Math.sqrt(pl);
        rx *= pl;
        ry *= pl;
    }
    var a00 = cosTh / rx;
    var a01 = sinTh / rx;
    var a10 = -sinTh / ry;
    var a11 = cosTh / ry;
    var x0 = a00 * ox + a01 * oy;
    var y0 = a10 * ox + a11 * oy;
    var x1 = a00 * x + a01 * y;
    var y1 = a10 * x + a11 * y;
    var d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
    var sfactorSq = 1 / d - 0.25;
    if (sfactorSq < 0) sfactorSq = 0;
    var sfactor = Math.sqrt(sfactorSq);
    if (sweep === large) sfactor = -sfactor;
    var xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
    var yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
    var th0 = Math.atan2(y0 - yc, x0 - xc);
    var th1 = Math.atan2(y1 - yc, x1 - xc);
    var thArc = th1 - th0;
    if (thArc < 0 && sweep === 1) thArc += 2 * Math.PI;
    else if (thArc > 0 && sweep === 0) thArc -= 2 * Math.PI;
    var segments = Math.ceil(Math.abs(thArc / (Math.PI * 0.5 + 0.001)));
    var result = [];
    for(var i = 0; i < segments; i++){
        var th2 = th0 + i * thArc / segments;
        var th3 = th0 + (i + 1) * thArc / segments;
        result[i] = [
            xc,
            yc,
            th2,
            th3,
            rx,
            ry,
            sinTh,
            cosTh
        ];
    }
    return result;
};
var $d3cf96a299d38647$var$segmentToBezier = function(cx1, cy1, th0, th1, rx, ry, sinTh, cosTh) {
    var a00 = cosTh * rx;
    var a01 = -sinTh * ry;
    var a10 = sinTh * rx;
    var a11 = cosTh * ry;
    var thHalf = 0.5 * (th1 - th0);
    var t = 8 / 3 * Math.sin(thHalf * 0.5) * Math.sin(thHalf * 0.5) / Math.sin(thHalf);
    var x1 = cx1 + Math.cos(th0) - t * Math.sin(th0);
    var y1 = cy1 + Math.sin(th0) + t * Math.cos(th0);
    var x3 = cx1 + Math.cos(th1);
    var y3 = cy1 + Math.sin(th1);
    var x2 = x3 + t * Math.sin(th1);
    var y2 = y3 - t * Math.cos(th1);
    var result = [
        a00 * x1 + a01 * y1,
        a10 * x1 + a11 * y1,
        a00 * x2 + a01 * y2,
        a10 * x2 + a11 * y2,
        a00 * x3 + a01 * y3,
        a10 * x3 + a11 * y3
    ];
    return result;
};
var $d3cf96a299d38647$export$8de5166f0a5bde2a = function(path) {
    return $d3cf96a299d38647$var$apply($d3cf96a299d38647$var$parse(path));
};



var $55cf96b3448598de$export$b11bd9a0808bdc9 = function(line, options) {
    return [
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $cfb765e9daff3c3a$export$568567f665d3f3bb)(options.graphicsState),
        (0, $cfb765e9daff3c3a$export$337b8dbf65fbb95e)(),
        (0, $030fa0a2c4d1456e$export$6126e5d7ba707741)(options.color),
        (0, $cfb765e9daff3c3a$export$df01d619ff6ce7f7)(options.font, options.size),
        (0, $cfb765e9daff3c3a$export$f567083ac6aa5aa3)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.rotate), (0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.xSkew), (0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.ySkew), options.x, options.y),
        (0, $cfb765e9daff3c3a$export$778bfc3c1a2b7ba4)(line),
        (0, $cfb765e9daff3c3a$export$e3caa83a99d72806)(),
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$f7b8b44d3d84bc26 = function(lines, options) {
    var operators = [
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $cfb765e9daff3c3a$export$568567f665d3f3bb)(options.graphicsState),
        (0, $cfb765e9daff3c3a$export$337b8dbf65fbb95e)(),
        (0, $030fa0a2c4d1456e$export$6126e5d7ba707741)(options.color),
        (0, $cfb765e9daff3c3a$export$df01d619ff6ce7f7)(options.font, options.size),
        (0, $cfb765e9daff3c3a$export$79399e66b6bb212c)(options.lineHeight),
        (0, $cfb765e9daff3c3a$export$f567083ac6aa5aa3)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.rotate), (0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.xSkew), (0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.ySkew), options.x, options.y)
    ].filter(Boolean);
    for(var idx = 0, len = lines.length; idx < len; idx++)operators.push((0, $cfb765e9daff3c3a$export$778bfc3c1a2b7ba4)(lines[idx]), (0, $cfb765e9daff3c3a$export$829ffc2dbe358942)());
    operators.push((0, $cfb765e9daff3c3a$export$e3caa83a99d72806)(), (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)());
    return operators;
};
var $55cf96b3448598de$export$21a059be5bfd5fb = function(name, options) {
    return [
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $cfb765e9daff3c3a$export$568567f665d3f3bb)(options.graphicsState),
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $cfb765e9daff3c3a$export$a2ba89726971a90f)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.rotate)),
        (0, $cfb765e9daff3c3a$export$dcdf75081b88279d)(options.width, options.height),
        (0, $cfb765e9daff3c3a$export$985cb1d69d6a3add)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.xSkew), (0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.ySkew)),
        (0, $cfb765e9daff3c3a$export$382c18f8bccd9e2b)(name),
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$f8ea28c31069cbc9 = function(name, options) {
    return [
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $cfb765e9daff3c3a$export$568567f665d3f3bb)(options.graphicsState),
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $cfb765e9daff3c3a$export$a2ba89726971a90f)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.rotate)),
        (0, $cfb765e9daff3c3a$export$dcdf75081b88279d)(options.xScale, options.yScale),
        (0, $cfb765e9daff3c3a$export$985cb1d69d6a3add)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.xSkew), (0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.ySkew)),
        (0, $cfb765e9daff3c3a$export$382c18f8bccd9e2b)(name),
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$819db45aec5fcbe5 = function(options) {
    var _a, _b;
    return [
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $cfb765e9daff3c3a$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $030fa0a2c4d1456e$export$ae31e5cacc8bb23d)(options.color),
        (0, $cfb765e9daff3c3a$export$558e0f90d8262345)(options.thickness),
        (0, $cfb765e9daff3c3a$export$e0e900d241274e06)((_a = options.dashArray) !== null && _a !== void 0 ? _a : [], (_b = options.dashPhase) !== null && _b !== void 0 ? _b : 0),
        (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)(options.start.x, options.start.y),
        options.lineCap && (0, $cfb765e9daff3c3a$export$6c65ed24e870eec)(options.lineCap),
        (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)(options.start.x, options.start.y),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(options.end.x, options.end.y),
        (0, $cfb765e9daff3c3a$export$d9b706f8d0a70aef)(),
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$cac848e0621718d8 = function(options) {
    var _a, _b;
    return [
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $cfb765e9daff3c3a$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $030fa0a2c4d1456e$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $030fa0a2c4d1456e$export$ae31e5cacc8bb23d)(options.borderColor),
        (0, $cfb765e9daff3c3a$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $cfb765e9daff3c3a$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $cfb765e9daff3c3a$export$e0e900d241274e06)((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0),
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $cfb765e9daff3c3a$export$a2ba89726971a90f)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.rotate)),
        (0, $cfb765e9daff3c3a$export$985cb1d69d6a3add)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.xSkew), (0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.ySkew)),
        (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)(0, 0),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(0, options.height),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(options.width, options.height),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(options.width, 0),
        (0, $cfb765e9daff3c3a$export$21f87e210c424cd0)(),
        // prettier-ignore
        options.color && options.borderWidth ? (0, $cfb765e9daff3c3a$export$76d37801baac10fb)() : options.color ? (0, $cfb765e9daff3c3a$export$9563e054e6f787fb)() : options.borderColor ? (0, $cfb765e9daff3c3a$export$d9b706f8d0a70aef)() : (0, $cfb765e9daff3c3a$export$21f87e210c424cd0)(),
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $55cf96b3448598de$var$KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var $55cf96b3448598de$export$f219d5f4b18063ad = function(config) {
    var x = (0, $a25479a44f824b27$export$37576b9ba69b50db)(config.x);
    var y = (0, $a25479a44f824b27$export$37576b9ba69b50db)(config.y);
    var xScale = (0, $a25479a44f824b27$export$37576b9ba69b50db)(config.xScale);
    var yScale = (0, $a25479a44f824b27$export$37576b9ba69b50db)(config.yScale);
    x -= xScale;
    y -= yScale;
    var ox = xScale * $55cf96b3448598de$var$KAPPA;
    var oy = yScale * $55cf96b3448598de$var$KAPPA;
    var xe = x + xScale * 2;
    var ye = y + yScale * 2;
    var xm = x + xScale;
    var ym = y + yScale;
    return [
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)(x, ym),
        (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(x, ym - oy, xm - ox, y, xm, y),
        (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(xm + ox, y, xe, ym - oy, xe, ym),
        (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(xe, ym + oy, xm + ox, ye, xm, ye),
        (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(xm - ox, ye, x, ym + oy, x, ym),
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ];
};
var $55cf96b3448598de$var$drawEllipseCurves = function(config) {
    var centerX = (0, $a25479a44f824b27$export$37576b9ba69b50db)(config.x);
    var centerY = (0, $a25479a44f824b27$export$37576b9ba69b50db)(config.y);
    var xScale = (0, $a25479a44f824b27$export$37576b9ba69b50db)(config.xScale);
    var yScale = (0, $a25479a44f824b27$export$37576b9ba69b50db)(config.yScale);
    var x = -xScale;
    var y = -yScale;
    var ox = xScale * $55cf96b3448598de$var$KAPPA;
    var oy = yScale * $55cf96b3448598de$var$KAPPA;
    var xe = x + xScale * 2;
    var ye = y + yScale * 2;
    var xm = x + xScale;
    var ym = y + yScale;
    return [
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(centerX, centerY),
        (0, $cfb765e9daff3c3a$export$a2ba89726971a90f)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(config.rotate)),
        (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)(x, ym),
        (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(x, ym - oy, xm - ox, y, xm, y),
        (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(xm + ox, y, xe, ym - oy, xe, ym),
        (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(xe, ym + oy, xm + ox, ye, xm, ye),
        (0, $cfb765e9daff3c3a$export$45bd49bb15a3c5cb)(xm - ox, ye, x, ym + oy, x, ym)
    ];
};
var $55cf96b3448598de$export$43c9e2bb0dc74582 = function(options) {
    var _a, _b, _c;
    return (0, $cOQTW.__spreadArrays)([
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $cfb765e9daff3c3a$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $030fa0a2c4d1456e$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $030fa0a2c4d1456e$export$ae31e5cacc8bb23d)(options.borderColor),
        (0, $cfb765e9daff3c3a$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $cfb765e9daff3c3a$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $cfb765e9daff3c3a$export$e0e900d241274e06)((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0)
    ], options.rotate === undefined ? $55cf96b3448598de$export$f219d5f4b18063ad({
        x: options.x,
        y: options.y,
        xScale: options.xScale,
        yScale: options.yScale
    }) : $55cf96b3448598de$var$drawEllipseCurves({
        x: options.x,
        y: options.y,
        xScale: options.xScale,
        yScale: options.yScale,
        rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
    }), [
        // prettier-ignore
        options.color && options.borderWidth ? (0, $cfb765e9daff3c3a$export$76d37801baac10fb)() : options.color ? (0, $cfb765e9daff3c3a$export$9563e054e6f787fb)() : options.borderColor ? (0, $cfb765e9daff3c3a$export$d9b706f8d0a70aef)() : (0, $cfb765e9daff3c3a$export$21f87e210c424cd0)(),
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ]).filter(Boolean);
};
var $55cf96b3448598de$export$47c8a640c39d0756 = function(path, options) {
    var _a, _b, _c;
    return (0, $cOQTW.__spreadArrays)([
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $cfb765e9daff3c3a$export$568567f665d3f3bb)(options.graphicsState),
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $cfb765e9daff3c3a$export$a2ba89726971a90f)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)((_a = options.rotate) !== null && _a !== void 0 ? _a : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0))),
        // SVG path Y axis is opposite pdf-lib's
        options.scale ? (0, $cfb765e9daff3c3a$export$dcdf75081b88279d)(options.scale, -options.scale) : (0, $cfb765e9daff3c3a$export$dcdf75081b88279d)(1, -1),
        options.color && (0, $030fa0a2c4d1456e$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $030fa0a2c4d1456e$export$ae31e5cacc8bb23d)(options.borderColor),
        options.borderWidth && (0, $cfb765e9daff3c3a$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $cfb765e9daff3c3a$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $cfb765e9daff3c3a$export$e0e900d241274e06)((_b = options.borderDashArray) !== null && _b !== void 0 ? _b : [], (_c = options.borderDashPhase) !== null && _c !== void 0 ? _c : 0)
    ], (0, $d3cf96a299d38647$export$8de5166f0a5bde2a)(path), [
        // prettier-ignore
        options.color && options.borderWidth ? (0, $cfb765e9daff3c3a$export$76d37801baac10fb)() : options.color ? (0, $cfb765e9daff3c3a$export$9563e054e6f787fb)() : options.borderColor ? (0, $cfb765e9daff3c3a$export$d9b706f8d0a70aef)() : (0, $cfb765e9daff3c3a$export$21f87e210c424cd0)(),
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ]).filter(Boolean);
};
var $55cf96b3448598de$export$695703ffa02b3ffb = function(options) {
    var size = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.size);
    /*********************** Define Check Mark Points ***************************/ // A check mark is defined by three points in some coordinate space. Here, we
    // define these points in a unit coordinate system, where the range of the x
    // and y axis are both [-1, 1].
    //
    // Note that we do not hard code `p1y` in case we wish to change the
    // size/shape of the check mark in the future. We want the check mark to
    // always form a right angle. This means that the dot product between (p1-p2)
    // and (p3-p2) should be zero:
    //
    //   (p1x-p2x) * (p3x-p2x) + (p1y-p2y) * (p3y-p2y) = 0
    //
    // We can now rejigger this equation to solve for `p1y`:
    //
    //   (p1y-p2y) * (p3y-p2y) = -((p1x-p2x) * (p3x-p2x))
    //   (p1y-p2y) = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y)
    //   p1y = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y) + p2y
    //
    // Thanks to my friend Joel Walker (https://github.com/JWalker1995) for
    // devising the above equation and unit coordinate system approach!
    // (x, y) coords of the check mark's bottommost point
    var p2x = -0.25;
    var p2y = -0.49;
    // (x, y) coords of the check mark's topmost point
    var p3y = 0.475;
    var p3x = 0.69;
    // (x, y) coords of the check mark's center (vertically) point
    var p1x = -0.675;
    var p1y = -((p1x - p2x) * (p3x - p2x)) / (p3y - p2y) + p2y;
    /****************************************************************************/ return [
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
        options.color && (0, $030fa0a2c4d1456e$export$ae31e5cacc8bb23d)(options.color),
        (0, $cfb765e9daff3c3a$export$558e0f90d8262345)(options.thickness),
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)(p1x * size, p1y * size),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(p2x * size, p2y * size),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(p3x * size, p3y * size),
        (0, $cfb765e9daff3c3a$export$d9b706f8d0a70aef)(),
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$5dd9a0a87f38a2a6 = function(options) {
    return options.rotation === 0 ? [
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(0, 0),
        (0, $cfb765e9daff3c3a$export$91df22fbff99d059)(0)
    ] : options.rotation === 90 ? [
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(options.width, 0),
        (0, $cfb765e9daff3c3a$export$91df22fbff99d059)(90)
    ] : options.rotation === 180 ? [
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(options.width, options.height),
        (0, $cfb765e9daff3c3a$export$91df22fbff99d059)(180)
    ] : options.rotation === 270 ? [
        (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(0, options.height),
        (0, $cfb765e9daff3c3a$export$91df22fbff99d059)(270)
    ] : [];
}; // Invalid rotation - noop
var $55cf96b3448598de$export$1c2f7a8d0ec539ab = function(options) {
    var outline = $55cf96b3448598de$export$cac848e0621718d8({
        x: options.x,
        y: options.y,
        width: options.width,
        height: options.height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        xSkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        ySkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
    });
    if (!options.filled) return outline;
    var width = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.width);
    var height = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.height);
    var checkMarkSize = Math.min(width, height) / 2;
    var checkMark = $55cf96b3448598de$export$695703ffa02b3ffb({
        x: width / 2,
        y: height / 2,
        size: checkMarkSize,
        thickness: options.thickness,
        color: options.markColor
    });
    return (0, $cOQTW.__spreadArrays)([
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)()
    ], outline, checkMark, [
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ]);
};
var $55cf96b3448598de$export$d01bb537f184a293 = function(options) {
    var width = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.width);
    var height = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.height);
    var outlineScale = Math.min(width, height) / 2;
    var outline = $55cf96b3448598de$export$43c9e2bb0dc74582({
        x: options.x,
        y: options.y,
        xScale: outlineScale,
        yScale: outlineScale,
        color: options.color,
        borderColor: options.borderColor,
        borderWidth: options.borderWidth
    });
    if (!options.filled) return outline;
    var dot = $55cf96b3448598de$export$43c9e2bb0dc74582({
        x: options.x,
        y: options.y,
        xScale: outlineScale * 0.45,
        yScale: outlineScale * 0.45,
        color: options.dotColor,
        borderColor: undefined,
        borderWidth: 0
    });
    return (0, $cOQTW.__spreadArrays)([
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)()
    ], outline, dot, [
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ]);
};
var $55cf96b3448598de$export$31046eb8c5070d92 = function(options) {
    var x = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.x);
    var y = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.y);
    var width = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.width);
    var height = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.height);
    var background = $55cf96b3448598de$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        xSkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        ySkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
    });
    var lines = $55cf96b3448598de$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        xSkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        ySkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
    });
    return (0, $cOQTW.__spreadArrays)([
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)()
    ], background, lines, [
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ]);
};
var $55cf96b3448598de$export$8a28629e0fa0aec4 = function(lines, options) {
    var operators = [
        (0, $cfb765e9daff3c3a$export$337b8dbf65fbb95e)(),
        (0, $030fa0a2c4d1456e$export$6126e5d7ba707741)(options.color),
        (0, $cfb765e9daff3c3a$export$df01d619ff6ce7f7)(options.font, options.size)
    ];
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var _a = lines[idx], encoded = _a.encoded, x = _a.x, y = _a.y;
        operators.push((0, $cfb765e9daff3c3a$export$f567083ac6aa5aa3)((0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.rotate), (0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.xSkew), (0, $3b4f8728c2695c8d$export$cba01ba138429a1d)(options.ySkew), x, y), (0, $cfb765e9daff3c3a$export$778bfc3c1a2b7ba4)(encoded));
    }
    operators.push((0, $cfb765e9daff3c3a$export$e3caa83a99d72806)());
    return operators;
};
var $55cf96b3448598de$export$7d8517ad99905084 = function(options) {
    var x = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.x);
    var y = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.y);
    var width = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.width);
    var height = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.height);
    var borderWidth = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.borderWidth);
    var padding = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.padding);
    var clipX = x + borderWidth / 2 + padding;
    var clipY = y + borderWidth / 2 + padding;
    var clipWidth = width - (borderWidth / 2 + padding) * 2;
    var clipHeight = height - (borderWidth / 2 + padding) * 2;
    var clippingArea = [
        (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)(clipX, clipY),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(clipX, clipY + clipHeight),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(clipX + clipWidth, clipY + clipHeight),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(clipX + clipWidth, clipY),
        (0, $cfb765e9daff3c3a$export$21f87e210c424cd0)(),
        (0, $cfb765e9daff3c3a$export$e0b576e7a74416cd)(),
        (0, $cfb765e9daff3c3a$export$d366e9c0a9bd860f)()
    ];
    var background = $55cf96b3448598de$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        xSkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        ySkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
    });
    var lines = $55cf96b3448598de$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        xSkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        ySkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
    });
    var markedContent = (0, $cOQTW.__spreadArrays)([
        (0, $cfb765e9daff3c3a$export$a028b403e40f1ab2)('Tx'),
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)()
    ], lines, [
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)(),
        (0, $cfb765e9daff3c3a$export$935e2334f5a50589)()
    ]);
    return (0, $cOQTW.__spreadArrays)([
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)()
    ], background, clippingArea, markedContent, [
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ]);
};
var $55cf96b3448598de$export$5a3093287b85b7c0 = function(options) {
    var x = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.x);
    var y = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.y);
    var width = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.width);
    var height = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.height);
    var lineHeight = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.lineHeight);
    var borderWidth = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.borderWidth);
    var padding = (0, $a25479a44f824b27$export$37576b9ba69b50db)(options.padding);
    var clipX = x + borderWidth / 2 + padding;
    var clipY = y + borderWidth / 2 + padding;
    var clipWidth = width - (borderWidth / 2 + padding) * 2;
    var clipHeight = height - (borderWidth / 2 + padding) * 2;
    var clippingArea = [
        (0, $cfb765e9daff3c3a$export$75f1ccd6dc32e80a)(clipX, clipY),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(clipX, clipY + clipHeight),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(clipX + clipWidth, clipY + clipHeight),
        (0, $cfb765e9daff3c3a$export$73abee0cf983cb99)(clipX + clipWidth, clipY),
        (0, $cfb765e9daff3c3a$export$21f87e210c424cd0)(),
        (0, $cfb765e9daff3c3a$export$e0b576e7a74416cd)(),
        (0, $cfb765e9daff3c3a$export$d366e9c0a9bd860f)()
    ];
    var background = $55cf96b3448598de$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        xSkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        ySkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
    });
    var highlights = [];
    for(var idx = 0, len = options.selectedLines.length; idx < len; idx++){
        var line = options.textLines[options.selectedLines[idx]];
        highlights.push.apply(highlights, $55cf96b3448598de$export$cac848e0621718d8({
            x: line.x - padding,
            y: line.y - (lineHeight - line.height) / 2,
            width: width - borderWidth,
            height: line.height + (lineHeight - line.height) / 2,
            borderWidth: 0,
            color: options.selectedColor,
            borderColor: undefined,
            rotate: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            xSkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            ySkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
        }));
    }
    var lines = $55cf96b3448598de$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        xSkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
        ySkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
    });
    var markedContent = (0, $cOQTW.__spreadArrays)([
        (0, $cfb765e9daff3c3a$export$a028b403e40f1ab2)('Tx'),
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)()
    ], lines, [
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)(),
        (0, $cfb765e9daff3c3a$export$935e2334f5a50589)()
    ]);
    return (0, $cOQTW.__spreadArrays)([
        (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)()
    ], background, highlights, clippingArea, markedContent, [
        (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
    ]);
};




// tslint:disable: max-classes-per-file

var $cOQTW = parcelRequire("cOQTW");
// TODO: Include link to documentation with example
var $7fe2d034822cb526$export$20fcceeca2b098d2 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(EncryptedPDFError, _super);
    function EncryptedPDFError() {
        var _this = this;
        var msg = 'Input document to `PDFDocument.load` is encrypted. You can use `PDFDocument.load(..., { ignoreEncryption: true })` if you wish to load the document anyways.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return EncryptedPDFError;
}(Error);
// TODO: Include link to documentation with example
var $7fe2d034822cb526$export$529a7c74d0636a48 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(FontkitNotRegisteredError, _super);
    function FontkitNotRegisteredError() {
        var _this = this;
        var msg = 'Input to `PDFDocument.embedFont` was a custom font, but no `fontkit` instance was found. You must register a `fontkit` instance with `PDFDocument.registerFontkit(...)` before embedding custom fonts.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FontkitNotRegisteredError;
}(Error);
// TODO: Include link to documentation with example
var $7fe2d034822cb526$export$9564a4d28d94eae2 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(ForeignPageError, _super);
    function ForeignPageError() {
        var _this = this;
        var msg = 'A `page` passed to `PDFDocument.addPage` or `PDFDocument.insertPage` was from a different (foreign) PDF document. If you want to copy pages from one PDFDocument to another, you must use `PDFDocument.copyPages(...)` to copy the pages before adding or inserting them.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ForeignPageError;
}(Error);
// TODO: Include link to documentation with example
var $7fe2d034822cb526$export$cdca06c5927ddc2d = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(RemovePageFromEmptyDocumentError, _super);
    function RemovePageFromEmptyDocumentError() {
        var _this = this;
        var msg = 'PDFDocument has no pages so `PDFDocument.removePage` cannot be called';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return RemovePageFromEmptyDocumentError;
}(Error);
var $7fe2d034822cb526$export$5bc08baa4a027cbd = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(NoSuchFieldError, _super);
    function NoSuchFieldError(name) {
        var _this = this;
        var msg = "PDFDocument has no form field with the name \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return NoSuchFieldError;
}(Error);
var $7fe2d034822cb526$export$8909da6c566ff652 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnexpectedFieldTypeError, _super);
    function UnexpectedFieldTypeError(name, expected, actual) {
        var _a, _b;
        var _this = this;
        var expectedType = expected === null || expected === void 0 ? void 0 : expected.name;
        var actualType = (_b = (_a = actual === null || actual === void 0 ? void 0 : actual.constructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : actual;
        var msg = "Expected field \"" + name + "\" to be of type " + expectedType + ", " + ("but it is actually of type " + actualType);
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnexpectedFieldTypeError;
}(Error);
var $7fe2d034822cb526$export$3437b42908c7d7a3 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingOnValueCheckError, _super);
    function MissingOnValueCheckError(onValue) {
        var _this = this;
        var msg = "Failed to select check box due to missing onValue: \"" + onValue + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingOnValueCheckError;
}(Error);
var $7fe2d034822cb526$export$c428cfe4dc6c68df = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(FieldAlreadyExistsError, _super);
    function FieldAlreadyExistsError(name) {
        var _this = this;
        var msg = "A field already exists with the specified name: \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FieldAlreadyExistsError;
}(Error);
var $7fe2d034822cb526$export$83c39fdacfe38500 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidFieldNamePartError, _super);
    function InvalidFieldNamePartError(namePart) {
        var _this = this;
        var msg = "Field name contains invalid component: \"" + namePart + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidFieldNamePartError;
}(Error);
var $7fe2d034822cb526$export$6353a2ffd9106bd2 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(FieldExistsAsNonTerminalError, _super);
    function FieldExistsAsNonTerminalError(name) {
        var _this = this;
        var msg = "A non-terminal field already exists with the specified name: \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FieldExistsAsNonTerminalError;
}(Error);
var $7fe2d034822cb526$export$f2fed572e1ed57ab = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(RichTextFieldReadError, _super);
    function RichTextFieldReadError(fieldName) {
        var _this = this;
        var msg = "Reading rich text fields is not supported: Attempted to read rich text field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return RichTextFieldReadError;
}(Error);
var $7fe2d034822cb526$export$5283dffc620a5c9f = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(CombedTextLayoutError, _super);
    function CombedTextLayoutError(lineLength, cellCount) {
        var _this = this;
        var msg = "Failed to layout combed text as lineLength=" + lineLength + " is greater than cellCount=" + cellCount;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return CombedTextLayoutError;
}(Error);
var $7fe2d034822cb526$export$1577e99040d42609 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(ExceededMaxLengthError, _super);
    function ExceededMaxLengthError(textLength, maxLength, name) {
        var _this = this;
        var msg = "Attempted to set text with length=" + textLength + " for TextField with maxLength=" + maxLength + " and name=" + name;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ExceededMaxLengthError;
}(Error);
var $7fe2d034822cb526$export$6da6c372180e79b0 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidMaxLengthError, _super);
    function InvalidMaxLengthError(textLength, maxLength, name) {
        var _this = this;
        var msg = "Attempted to set maxLength=" + maxLength + ", which is less than " + textLength + ", the length of this field's current value (name=" + name + ")";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidMaxLengthError;
}(Error);


var $010595e4078a43c6$export$84b2d1b68830363f;
(function(TextAlignment) {
    TextAlignment[TextAlignment["Left"] = 0] = "Left";
    TextAlignment[TextAlignment["Center"] = 1] = "Center";
    TextAlignment[TextAlignment["Right"] = 2] = "Right";
})($010595e4078a43c6$export$84b2d1b68830363f || ($010595e4078a43c6$export$84b2d1b68830363f = {}));


parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $97c78c294af7eaa8$var$MIN_FONT_SIZE = 4;
var $97c78c294af7eaa8$var$MAX_FONT_SIZE = 500;
var $97c78c294af7eaa8$var$computeFontSize = function(lines, font, bounds, multiline) {
    if (multiline === void 0) multiline = false;
    var fontSize = $97c78c294af7eaa8$var$MIN_FONT_SIZE;
    while(fontSize < $97c78c294af7eaa8$var$MAX_FONT_SIZE){
        var linesUsed = 0;
        for(var lineIdx = 0, lineLen = lines.length; lineIdx < lineLen; lineIdx++){
            linesUsed += 1;
            var line = lines[lineIdx];
            var words = line.split(' ');
            // Layout the words using the current `fontSize`, line wrapping
            // whenever we reach the end of the current line.
            var spaceInLineRemaining = bounds.width;
            for(var idx = 0, len = words.length; idx < len; idx++){
                var isLastWord = idx === len - 1;
                var word = isLastWord ? words[idx] : words[idx] + ' ';
                var widthOfWord = font.widthOfTextAtSize(word, fontSize);
                spaceInLineRemaining -= widthOfWord;
                if (spaceInLineRemaining <= 0) {
                    linesUsed += 1;
                    spaceInLineRemaining = bounds.width - widthOfWord;
                }
            }
        }
        // Return if we exceeded the allowed width
        if (!multiline && linesUsed > lines.length) return fontSize - 1;
        var height = font.heightAtSize(fontSize);
        var lineHeight = height + height * 0.2;
        var totalHeight = lineHeight * linesUsed;
        // Return if we exceeded the allowed height
        if (totalHeight > Math.abs(bounds.height)) return fontSize - 1;
        fontSize += 1;
    }
    return fontSize;
};
var $97c78c294af7eaa8$var$computeCombedFontSize = function(line, font, bounds, cellCount) {
    var cellWidth = bounds.width / cellCount;
    var cellHeight = bounds.height;
    var fontSize = $97c78c294af7eaa8$var$MIN_FONT_SIZE;
    var chars = (0, $7Kmy8.charSplit)(line);
    while(fontSize < $97c78c294af7eaa8$var$MAX_FONT_SIZE){
        for(var idx = 0, len = chars.length; idx < len; idx++){
            var c = chars[idx];
            var tooLong = font.widthOfTextAtSize(c, fontSize) > cellWidth * 0.75;
            if (tooLong) return fontSize - 1;
        }
        var height = font.heightAtSize(fontSize, {
            descender: false
        });
        if (height > cellHeight) return fontSize - 1;
        fontSize += 1;
    }
    return fontSize;
};
var $97c78c294af7eaa8$var$lastIndexOfWhitespace = function(line) {
    for(var idx = line.length; idx > 0; idx--){
        if (/\s/.test(line[idx])) return idx;
    }
    return undefined;
};
var $97c78c294af7eaa8$var$splitOutLines = function(input, maxWidth, font, fontSize) {
    var _a;
    var lastWhitespaceIdx = input.length;
    while(lastWhitespaceIdx > 0){
        var line = input.substring(0, lastWhitespaceIdx);
        var encoded = font.encodeText(line);
        var width = font.widthOfTextAtSize(line, fontSize);
        if (width < maxWidth) {
            var remainder = input.substring(lastWhitespaceIdx) || undefined;
            return {
                line: line,
                encoded: encoded,
                width: width,
                remainder: remainder
            };
        }
        lastWhitespaceIdx = (_a = $97c78c294af7eaa8$var$lastIndexOfWhitespace(line)) !== null && _a !== void 0 ? _a : 0;
    }
    // We were unable to split the input enough to get a chunk that would fit
    // within the specified `maxWidth` so we'll just return everything
    return {
        line: input,
        encoded: font.encodeText(input),
        width: font.widthOfTextAtSize(input, fontSize),
        remainder: undefined
    };
};
var $97c78c294af7eaa8$export$f6ba9f13f815cc95 = function(text, _a) {
    var alignment = _a.alignment, fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds;
    var lines = (0, $7Kmy8.lineSplit)((0, $7Kmy8.cleanText)(text));
    if (fontSize === undefined || fontSize === 0) fontSize = $97c78c294af7eaa8$var$computeFontSize(lines, font, bounds, true);
    var height = font.heightAtSize(fontSize);
    var lineHeight = height + height * 0.2;
    var textLines = [];
    var minX = bounds.x;
    var minY = bounds.y;
    var maxX = bounds.x + bounds.width;
    var maxY = bounds.y + bounds.height;
    var y = bounds.y + bounds.height;
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var prevRemainder = lines[idx];
        while(prevRemainder !== undefined){
            var _b = $97c78c294af7eaa8$var$splitOutLines(prevRemainder, bounds.width, font, fontSize), line = _b.line, encoded = _b.encoded, width = _b.width, remainder = _b.remainder;
            // prettier-ignore
            var x = alignment === (0, $010595e4078a43c6$export$84b2d1b68830363f).Left ? bounds.x : alignment === (0, $010595e4078a43c6$export$84b2d1b68830363f).Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === (0, $010595e4078a43c6$export$84b2d1b68830363f).Right ? bounds.x + bounds.width - width : bounds.x;
            y -= lineHeight;
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x + width > maxX) maxX = x + width;
            if (y + height > maxY) maxY = y + height;
            textLines.push({
                text: line,
                encoded: encoded,
                width: width,
                height: height,
                x: x,
                y: y
            });
            // Only trim lines that we had to split ourselves. So we won't trim lines
            // that the user provided themselves with whitespace.
            prevRemainder = remainder === null || remainder === void 0 ? void 0 : remainder.trim();
        }
    }
    return {
        fontSize: fontSize,
        lineHeight: lineHeight,
        lines: textLines,
        bounds: {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        }
    };
};
var $97c78c294af7eaa8$export$deba41d88dd75dfc = function(text, _a) {
    var fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds, cellCount = _a.cellCount;
    var line = (0, $7Kmy8.mergeLines)((0, $7Kmy8.cleanText)(text));
    if (line.length > cellCount) throw new (0, $7fe2d034822cb526$export$5283dffc620a5c9f)(line.length, cellCount);
    if (fontSize === undefined || fontSize === 0) fontSize = $97c78c294af7eaa8$var$computeCombedFontSize(line, font, bounds, cellCount);
    var cellWidth = bounds.width / cellCount;
    var height = font.heightAtSize(fontSize, {
        descender: false
    });
    var y = bounds.y + (bounds.height / 2 - height / 2);
    var cells = [];
    var minX = bounds.x;
    var minY = bounds.y;
    var maxX = bounds.x + bounds.width;
    var maxY = bounds.y + bounds.height;
    var cellOffset = 0;
    var charOffset = 0;
    while(cellOffset < cellCount){
        var _b = (0, $7Kmy8.charAtIndex)(line, charOffset), char = _b[0], charLength = _b[1];
        var encoded = font.encodeText(char);
        var width = font.widthOfTextAtSize(char, fontSize);
        var cellCenter = bounds.x + (cellWidth * cellOffset + cellWidth / 2);
        var x = cellCenter - width / 2;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x + width > maxX) maxX = x + width;
        if (y + height > maxY) maxY = y + height;
        cells.push({
            text: line,
            encoded: encoded,
            width: width,
            height: height,
            x: x,
            y: y
        });
        cellOffset += 1;
        charOffset += charLength;
    }
    return {
        fontSize: fontSize,
        cells: cells,
        bounds: {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        }
    };
};
var $97c78c294af7eaa8$export$c0030606588cf6f2 = function(text, _a) {
    var alignment = _a.alignment, fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds;
    var line = (0, $7Kmy8.mergeLines)((0, $7Kmy8.cleanText)(text));
    if (fontSize === undefined || fontSize === 0) fontSize = $97c78c294af7eaa8$var$computeFontSize([
        line
    ], font, bounds);
    var encoded = font.encodeText(line);
    var width = font.widthOfTextAtSize(line, fontSize);
    var height = font.heightAtSize(fontSize, {
        descender: false
    });
    // prettier-ignore
    var x = alignment === (0, $010595e4078a43c6$export$84b2d1b68830363f).Left ? bounds.x : alignment === (0, $010595e4078a43c6$export$84b2d1b68830363f).Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === (0, $010595e4078a43c6$export$84b2d1b68830363f).Right ? bounds.x + bounds.width - width : bounds.x;
    var y = bounds.y + (bounds.height / 2 - height / 2);
    return {
        fontSize: fontSize,
        line: {
            text: line,
            encoded: encoded,
            width: width,
            height: height,
            x: x,
            y: y
        },
        bounds: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    };
};




parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $d5944ab433082972$export$8a3aea031520d39b = function(appearance) {
    if ('normal' in appearance) return appearance;
    return {
        normal: appearance
    };
};
// Examples:
//   `/Helv 12 Tf` -> ['/Helv 12 Tf', 'Helv', '12']
//   `/HeBo 8.00 Tf` -> ['/HeBo 8 Tf', 'HeBo', '8.00']
var $d5944ab433082972$var$tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]+(\d*\.\d+|\d+)[\0\t\n\f\r\ ]+Tf/;
var $d5944ab433082972$var$getDefaultFontSize = function(field) {
    var _a, _b;
    var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
    var daMatch = (_b = (0, $7Kmy8.findLastMatch)(da, $d5944ab433082972$var$tfRegex).match) !== null && _b !== void 0 ? _b : [];
    var defaultFontSize = Number(daMatch[2]);
    return isFinite(defaultFontSize) ? defaultFontSize : undefined;
};
// Examples:
//   `0.3 g` -> ['0.3', 'g']
//   `0.3 1 .3 rg` -> ['0.3', '1', '.3', 'rg']
//   `0.3 1 .3 0 k` -> ['0.3', '1', '.3', '0', 'k']
var $d5944ab433082972$var$colorRegex = /(\d*\.\d+|\d+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+(g|rg|k)/;
var $d5944ab433082972$var$getDefaultColor = function(field) {
    var _a;
    var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
    var daMatch = (0, $7Kmy8.findLastMatch)(da, $d5944ab433082972$var$colorRegex).match;
    var _b = daMatch !== null && daMatch !== void 0 ? daMatch : [], c1 = _b[1], c2 = _b[2], c3 = _b[3], c4 = _b[4], colorSpace = _b[5];
    if (colorSpace === 'g' && c1) return (0, $030fa0a2c4d1456e$export$6f416a6db2dfcd5c)(Number(c1));
    if (colorSpace === 'rg' && c1 && c2 && c3) return (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(Number(c1), Number(c2), Number(c3));
    if (colorSpace === 'k' && c1 && c2 && c3 && c4) return (0, $030fa0a2c4d1456e$export$358b1a66a3c77756)(Number(c1), Number(c2), Number(c3), Number(c4));
    return undefined;
};
var $d5944ab433082972$var$updateDefaultAppearance = function(field, color, font, fontSize) {
    var _a;
    if (fontSize === void 0) fontSize = 0;
    var da = [
        (0, $030fa0a2c4d1456e$export$6126e5d7ba707741)(color).toString(),
        (0, $cfb765e9daff3c3a$export$df01d619ff6ce7f7)((_a = font === null || font === void 0 ? void 0 : font.name) !== null && _a !== void 0 ? _a : 'dummy__noop', fontSize).toString()
    ].join('\n');
    field.setDefaultAppearance(da);
};
var $d5944ab433082972$export$e11eab3ac6c06eb0 = function(checkBox, widget) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(checkBox.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $3b4f8728c2695c8d$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $3b4f8728c2695c8d$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $55cf96b3448598de$export$5dd9a0a87f38a2a6)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (_b = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
    var normalBackgroundColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    // Update color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor);
    else $d5944ab433082972$var$updateDefaultAppearance(checkBox.acroField, textColor);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        thickness: 1.5,
        borderWidth: borderWidth,
        borderColor: borderColor,
        markColor: textColor
    };
    return {
        normal: {
            on: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$1c2f7a8d0ec539ab)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: true
            }))),
            off: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$1c2f7a8d0ec539ab)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: false
            })))
        },
        down: {
            on: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$1c2f7a8d0ec539ab)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: downBackgroundColor,
                filled: true
            }))),
            off: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$1c2f7a8d0ec539ab)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: downBackgroundColor,
                filled: false
            })))
        }
    };
};
var $d5944ab433082972$export$6440094330a99ef8 = function(radioGroup, widget) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(radioGroup.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $3b4f8728c2695c8d$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $3b4f8728c2695c8d$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $55cf96b3448598de$export$5dd9a0a87f38a2a6)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (_b = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
    var normalBackgroundColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    // Update color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor);
    else $d5944ab433082972$var$updateDefaultAppearance(radioGroup.acroField, textColor);
    var options = {
        x: width / 2,
        y: height / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth,
        borderColor: borderColor,
        dotColor: textColor
    };
    return {
        normal: {
            on: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$d01bb537f184a293)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: true
            }))),
            off: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$d01bb537f184a293)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: false
            })))
        },
        down: {
            on: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$d01bb537f184a293)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: downBackgroundColor,
                filled: true
            }))),
            off: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$d01bb537f184a293)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: downBackgroundColor,
                filled: false
            })))
        }
    };
};
var $d5944ab433082972$export$68f9b19f48ffeeec = function(button, widget, font) {
    var _a, _b, _c, _d, _e;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(button.acroField);
    var widgetFontSize = $d5944ab433082972$var$getDefaultFontSize(widget);
    var fieldFontSize = $d5944ab433082972$var$getDefaultFontSize(button.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var captions = ap === null || ap === void 0 ? void 0 : ap.getCaptions();
    var normalText = (_a = captions === null || captions === void 0 ? void 0 : captions.normal) !== null && _a !== void 0 ? _a : '';
    var downText = (_c = (_b = captions === null || captions === void 0 ? void 0 : captions.down) !== null && _b !== void 0 ? _b : normalText) !== null && _c !== void 0 ? _c : '';
    var borderWidth = (_d = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _d !== void 0 ? _d : 0;
    var rotation = (0, $3b4f8728c2695c8d$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _f = (0, $3b4f8728c2695c8d$export$312e44550db33c6a)(rectangle, rotation), width = _f.width, height = _f.height;
    var rotate = (0, $55cf96b3448598de$export$5dd9a0a87f38a2a6)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    var bounds = {
        x: borderWidth,
        y: borderWidth,
        width: width - borderWidth * 2,
        height: height - borderWidth * 2
    };
    var normalLayout = (0, $97c78c294af7eaa8$export$c0030606588cf6f2)(normalText, {
        alignment: (0, $010595e4078a43c6$export$84b2d1b68830363f).Center,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    });
    var downLayout = (0, $97c78c294af7eaa8$export$c0030606588cf6f2)(downText, {
        alignment: (0, $010595e4078a43c6$export$84b2d1b68830363f).Center,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    });
    // Update font size and color
    var fontSize = Math.min(normalLayout.fontSize, downLayout.fontSize);
    var textColor = (_e = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _e !== void 0 ? _e : black;
    if (widgetColor || widgetFontSize !== undefined) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $d5944ab433082972$var$updateDefaultAppearance(button.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize
    };
    return {
        normal: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$31046eb8c5070d92)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
            color: normalBackgroundColor,
            textLines: [
                normalLayout.line
            ]
        }))),
        down: (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$31046eb8c5070d92)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
            color: downBackgroundColor,
            textLines: [
                downLayout.line
            ]
        })))
    };
};
var $d5944ab433082972$export$42ba95e6b8df3d7 = function(textField, widget, font) {
    var _a, _b, _c, _d;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(textField.acroField);
    var widgetFontSize = $d5944ab433082972$var$getDefaultFontSize(widget);
    var fieldFontSize = $d5944ab433082972$var$getDefaultFontSize(textField.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var text = (_a = textField.getText()) !== null && _a !== void 0 ? _a : '';
    var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
    var rotation = (0, $3b4f8728c2695c8d$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _e = (0, $3b4f8728c2695c8d$export$312e44550db33c6a)(rectangle, rotation), width = _e.width, height = _e.height;
    var rotate = (0, $55cf96b3448598de$export$5dd9a0a87f38a2a6)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var textLines;
    var fontSize;
    var padding = textField.isCombed() ? 0 : 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    if (textField.isMultiline()) {
        var layout = (0, $97c78c294af7eaa8$export$f6ba9f13f815cc95)(text, {
            alignment: textField.getAlignment(),
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds
        });
        textLines = layout.lines;
        fontSize = layout.fontSize;
    } else if (textField.isCombed()) {
        var layout = (0, $97c78c294af7eaa8$export$deba41d88dd75dfc)(text, {
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds,
            cellCount: (_c = textField.getMaxLength()) !== null && _c !== void 0 ? _c : 0
        });
        textLines = layout.cells;
        fontSize = layout.fontSize;
    } else {
        var layout = (0, $97c78c294af7eaa8$export$c0030606588cf6f2)(text, {
            alignment: textField.getAlignment(),
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds
        });
        textLines = [
            layout.line
        ];
        fontSize = layout.fontSize;
    }
    // Update font size and color
    var textColor = (_d = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _d !== void 0 ? _d : black;
    if (widgetColor || widgetFontSize !== undefined) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $d5944ab433082972$var$updateDefaultAppearance(textField.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: textLines,
        padding: padding
    };
    return (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$7d8517ad99905084)(options));
};
var $d5944ab433082972$export$90f1ca03d512ec5 = function(dropdown, widget, font) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(dropdown.acroField);
    var widgetFontSize = $d5944ab433082972$var$getDefaultFontSize(widget);
    var fieldFontSize = $d5944ab433082972$var$getDefaultFontSize(dropdown.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var text = (_a = dropdown.getSelected()[0]) !== null && _a !== void 0 ? _a : '';
    var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
    var rotation = (0, $3b4f8728c2695c8d$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $3b4f8728c2695c8d$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $55cf96b3448598de$export$5dd9a0a87f38a2a6)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var padding = 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    var _e = (0, $97c78c294af7eaa8$export$c0030606588cf6f2)(text, {
        alignment: (0, $010595e4078a43c6$export$84b2d1b68830363f).Left,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    }), line = _e.line, fontSize = _e.fontSize;
    // Update font size and color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor || widgetFontSize !== undefined) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $d5944ab433082972$var$updateDefaultAppearance(dropdown.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: [
            line
        ],
        padding: padding
    };
    return (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$7d8517ad99905084)(options));
};
var $d5944ab433082972$export$f9fab495286778d2 = function(optionList, widget, font) {
    var _a, _b;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(optionList.acroField);
    var widgetFontSize = $d5944ab433082972$var$getDefaultFontSize(widget);
    var fieldFontSize = $d5944ab433082972$var$getDefaultFontSize(optionList.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $3b4f8728c2695c8d$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _c = (0, $3b4f8728c2695c8d$export$312e44550db33c6a)(rectangle, rotation), width = _c.width, height = _c.height;
    var rotate = (0, $55cf96b3448598de$export$5dd9a0a87f38a2a6)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $030fa0a2c4d1456e$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var options = optionList.getOptions();
    var selected = optionList.getSelected();
    if (optionList.isSorted()) options.sort();
    var text = '';
    for(var idx = 0, len = options.length; idx < len; idx++){
        text += options[idx];
        if (idx < len - 1) text += '\n';
    }
    var padding = 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    var _d = (0, $97c78c294af7eaa8$export$f6ba9f13f815cc95)(text, {
        alignment: (0, $010595e4078a43c6$export$84b2d1b68830363f).Left,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    }), lines = _d.lines, fontSize = _d.fontSize, lineHeight = _d.lineHeight;
    var selectedLines = [];
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var line = lines[idx];
        if (selected.includes(line.text)) selectedLines.push(idx);
    }
    var blue = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0.6, 193 / 255, 218 / 255);
    // Update font size and color
    var textColor = (_b = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _b !== void 0 ? _b : black;
    if (widgetColor || widgetFontSize !== undefined) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $d5944ab433082972$var$updateDefaultAppearance(optionList.acroField, textColor, font, fontSize);
    return (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$5a3093287b85b7c0)({
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: lines,
        lineHeight: lineHeight,
        selectedColor: blue,
        selectedLines: selectedLines,
        padding: padding
    }));
};



var $cOQTW = parcelRequire("cOQTW");

var $cOQTW = parcelRequire("cOQTW");




var $cOQTW = parcelRequire("cOQTW");


var $cOQTW = parcelRequire("cOQTW");


parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a PDF page that has been embedded in a [[PDFDocument]].
 */ var $f38ed62eeee08801$var$PDFEmbeddedPage = /** @class */ function() {
    function PDFEmbeddedPage(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $f1233b848bc26abe$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $93b2571d4e1dfe94$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        (0, $j0tvB.assertIs)(embedder, 'embedder', [
            [
                (0, $c7d58da35b52112a$export$2e2bcd8739ae039),
                'PDFPageEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.width = embedder.width;
        this.height = embedder.height;
        this.embedder = embedder;
    }
    /**
     * Compute the width and height of this page after being scaled by the
     * given `factor`. For example:
     * ```js
     * embeddedPage.width  // => 500
     * embeddedPage.height // => 250
     *
     * const scaled = embeddedPage.scale(0.5)
     * scaled.width  // => 250
     * scaled.height // => 125
     * ```
     * This operation is often useful before drawing a page with
     * [[PDFPage.drawPage]] to compute the `width` and `height` options.
     * @param factor The factor by which this page should be scaled.
     * @returns The width and height of the page after being scaled.
     */ PDFEmbeddedPage.prototype.scale = function(factor) {
        (0, $j0tvB.assertIs)(factor, 'factor', [
            'number'
        ]);
        return {
            width: this.width * factor,
            height: this.height * factor
        };
    };
    /**
     * Get the width and height of this page. For example:
     * ```js
     * const { width, height } = embeddedPage.size()
     * ```
     * @returns The width and height of the page.
     */ PDFEmbeddedPage.prototype.size = function() {
        return this.scale(1);
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all embeddable pages get embedded.
     *
     * Embed this embeddable page in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFEmbeddedPage.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        _a.sent();
                        this.alreadyEmbedded = true;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedPdf]] and
     * > [[PDFDocument.embedPage]] methods, which will create instances of
     * > [[PDFEmbeddedPage]] for you.
     *
     * Create an instance of [[PDFEmbeddedPage]] from an existing ref and embedder
     *
     * @param ref The unique reference for this embedded page.
     * @param doc The document to which the embedded page will belong.
     * @param embedder The embedder that will be used to embed the page.
     */ PDFEmbeddedPage.of = function(ref, doc, embedder) {
        return new PDFEmbeddedPage(ref, doc, embedder);
    };
    return PDFEmbeddedPage;
}();
var $f38ed62eeee08801$export$2e2bcd8739ae039 = $f38ed62eeee08801$var$PDFEmbeddedPage;



var $cOQTW = parcelRequire("cOQTW");


parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a font that has been embedded in a [[PDFDocument]].
 */ var $fb353673e42bee9b$var$PDFFont = /** @class */ function() {
    function PDFFont(ref, doc, embedder) {
        this.modified = true;
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $f1233b848bc26abe$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $93b2571d4e1dfe94$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        (0, $j0tvB.assertIs)(embedder, 'embedder', [
            [
                (0, $c1a3ddaa0f08fc18$export$2e2bcd8739ae039),
                'CustomFontEmbedder'
            ],
            [
                (0, $e3698d9fec5e57b0$export$2e2bcd8739ae039),
                'StandardFontEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.name = embedder.fontName;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFPage.drawText]] method will automatically encode the text it is
     * > given.
     *
     * Encodes a string of text in this font.
     *
     * @param text The text to be encoded.
     * @returns The encoded text as a hex string.
     */ PDFFont.prototype.encodeText = function(text) {
        (0, $j0tvB.assertIs)(text, 'text', [
            'string'
        ]);
        this.modified = true;
        return this.embedder.encodeText(text);
    };
    /**
     * Measure the width of a string of text drawn in this font at a given size.
     * For example:
     * ```js
     * const width = font.widthOfTextAtSize('Foo Bar Qux Baz', 36)
     * ```
     * @param text The string of text to be measured.
     * @param size The font size to be used for this measurement.
     * @returns The width of the string of text when drawn in this font at the
     *          given size.
     */ PDFFont.prototype.widthOfTextAtSize = function(text, size) {
        (0, $j0tvB.assertIs)(text, 'text', [
            'string'
        ]);
        (0, $j0tvB.assertIs)(size, 'size', [
            'number'
        ]);
        return this.embedder.widthOfTextAtSize(text, size);
    };
    /**
     * Measure the height of this font at a given size. For example:
     * ```js
     * const height = font.heightAtSize(24)
     * ```
     *
     * The `options.descender` value controls whether or not the font's
     * descender is included in the height calculation.
     *
     * @param size The font size to be used for this measurement.
     * @param options The options to be used when computing this measurement.
     * @returns The height of this font at the given size.
     */ PDFFont.prototype.heightAtSize = function(size, options) {
        var _a;
        (0, $j0tvB.assertIs)(size, 'size', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.descender, 'options.descender', [
            'boolean'
        ]);
        return this.embedder.heightOfFontAtSize(size, {
            descender: (_a = options === null || options === void 0 ? void 0 : options.descender) !== null && _a !== void 0 ? _a : true
        });
    };
    /**
     * Compute the font size at which this font is a given height. For example:
     * ```js
     * const fontSize = font.sizeAtHeight(12)
     * ```
     * @param height The height to be used for this calculation.
     * @returns The font size at which this font is the given height.
     */ PDFFont.prototype.sizeAtHeight = function(height) {
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        return this.embedder.sizeOfFontAtHeight(height);
    };
    /**
     * Get the set of unicode code points that can be represented by this font.
     * @returns The set of unicode code points supported by this font.
     */ PDFFont.prototype.getCharacterSet = function() {
        if (this.embedder instanceof (0, $e3698d9fec5e57b0$export$2e2bcd8739ae039)) return this.embedder.encoding.supportedCodePoints;
        else return this.embedder.font.characterSet;
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all fonts get embedded.
     *
     * Embed this font in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFFont.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.modified) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        _a.sent();
                        this.modified = false;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedFont]] and
     * > [[PDFDocument.embedStandardFont]] methods, which will create instances
     * > of [[PDFFont]] for you.
     *
     * Create an instance of [[PDFFont]] from an existing ref and embedder
     *
     * @param ref The unique reference for this font.
     * @param doc The document to which the font will belong.
     * @param embedder The embedder that will be used to embed the font.
     */ PDFFont.of = function(ref, doc, embedder) {
        return new PDFFont(ref, doc, embedder);
    };
    return PDFFont;
}();
var $fb353673e42bee9b$export$2e2bcd8739ae039 = $fb353673e42bee9b$var$PDFFont;



var $cOQTW = parcelRequire("cOQTW");


parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents an image that has been embedded in a [[PDFDocument]].
 */ var $593e57425d0dad5a$var$PDFImage = /** @class */ function() {
    function PDFImage(ref, doc, embedder) {
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $f1233b848bc26abe$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $93b2571d4e1dfe94$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        (0, $j0tvB.assertIs)(embedder, 'embedder', [
            [
                (0, $b2f30d23c2f107ea$export$2e2bcd8739ae039),
                'JpegEmbedder'
            ],
            [
                (0, $79f8a6e417146498$export$2e2bcd8739ae039),
                'PngEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.width = embedder.width;
        this.height = embedder.height;
        this.embedder = embedder;
    }
    /**
     * Compute the width and height of this image after being scaled by the
     * given `factor`. For example:
     * ```js
     * image.width  // => 500
     * image.height // => 250
     *
     * const scaled = image.scale(0.5)
     * scaled.width  // => 250
     * scaled.height // => 125
     * ```
     * This operation is often useful before drawing an image with
     * [[PDFPage.drawImage]] to compute the `width` and `height` options.
     * @param factor The factor by which this image should be scaled.
     * @returns The width and height of the image after being scaled.
     */ PDFImage.prototype.scale = function(factor) {
        (0, $j0tvB.assertIs)(factor, 'factor', [
            'number'
        ]);
        return {
            width: this.width * factor,
            height: this.height * factor
        };
    };
    /**
     * Get the width and height of this image after scaling it as large as
     * possible while maintaining its aspect ratio and not exceeding the
     * specified `width` and `height`. For example:
     * ```
     * image.width  // => 500
     * image.height // => 250
     *
     * const scaled = image.scaleToFit(750, 1000)
     * scaled.width  // => 750
     * scaled.height // => 375
     * ```
     * The `width` and `height` parameters can also be thought of as the width
     * and height of a box that the scaled image must fit within.
     * @param width The bounding box's width.
     * @param height The bounding box's height.
     * @returns The width and height of the image after being scaled.
     */ PDFImage.prototype.scaleToFit = function(width, height) {
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var imgWidthScale = width / this.width;
        var imgHeightScale = height / this.height;
        var scale = Math.min(imgWidthScale, imgHeightScale);
        return this.scale(scale);
    };
    /**
     * Get the width and height of this image. For example:
     * ```js
     * const { width, height } = image.size()
     * ```
     * @returns The width and height of the image.
     */ PDFImage.prototype.size = function() {
        return this.scale(1);
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all images get embedded.
     *
     * Embed this image in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFImage.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, doc, ref;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.embedder) return [
                            2 /*return*/ 
                        ];
                        // The image should only be embedded once. If there's a pending embed
                        // operation then wait on it. Otherwise we need to start the embed.
                        if (!this.embedTask) {
                            _a = this, doc = _a.doc, ref = _a.ref;
                            this.embedTask = this.embedder.embedIntoContext(doc.context, ref);
                        }
                        return [
                            4 /*yield*/ ,
                            this.embedTask
                        ];
                    case 1:
                        _b.sent();
                        // We clear `this.embedder` so that the indirectly referenced image data
                        // can be garbage collected, thus avoiding a memory leak.
                        // See https://github.com/Hopding/pdf-lib/pull/1032/files.
                        this.embedder = undefined;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedPng]] and [[PDFDocument.embedJpg]]
     * > methods, which will create instances of [[PDFImage]] for you.
     *
     * Create an instance of [[PDFImage]] from an existing ref and embedder
     *
     * @param ref The unique reference for this image.
     * @param doc The document to which the image will belong.
     * @param embedder The embedder that will be used to embed the image.
     */ PDFImage.of = function(ref, doc, embedder) {
        return new PDFImage(ref, doc, embedder);
    };
    return PDFImage;
}();
var $593e57425d0dad5a$export$2e2bcd8739ae039 = $593e57425d0dad5a$var$PDFImage;




var $cOQTW = parcelRequire("cOQTW");



var $cOQTW = parcelRequire("cOQTW");





var $cOQTW = parcelRequire("cOQTW");




var $nAWRe = parcelRequire("nAWRe");
var $dPHSK = parcelRequire("dPHSK");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $c5ccd91931a24d5b$export$8efa99ca8f041e7e;
(function(ImageAlignment) {
    ImageAlignment[ImageAlignment["Left"] = 0] = "Left";
    ImageAlignment[ImageAlignment["Center"] = 1] = "Center";
    ImageAlignment[ImageAlignment["Right"] = 2] = "Right";
})($c5ccd91931a24d5b$export$8efa99ca8f041e7e || ($c5ccd91931a24d5b$export$8efa99ca8f041e7e = {}));





var $9a88d5b8c9019f73$export$55643210f1835a35 = function(options) {
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.x, 'options.x', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.y, 'options.y', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.width, 'options.width', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.height, 'options.height', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.textColor, 'options.textColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.backgroundColor, 'options.backgroundColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.borderColor, 'options.borderColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.borderWidth, 'options.borderWidth', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.rotate, 'options.rotate', [
        [
            Object,
            'Rotation'
        ]
    ]);
};
/**
 * Represents a field of a [[PDFForm]].
 *
 * This class is effectively abstract. All fields in a [[PDFForm]] will
 * actually be an instance of a subclass of this class.
 *
 * Note that each field in a PDF is represented by a single field object.
 * However, a given field object may be rendered at multiple locations within
 * the document (across one or more pages). The rendering of a field is
 * controlled by its widgets. Each widget causes its field to be displayed at a
 * particular location in the document.
 *
 * Most of the time each field in a PDF has only a single widget, and thus is
 * only rendered once. However, if a field is rendered multiple times, it will
 * have multiple widgets - one for each location it is rendered.
 *
 * This abstraction of field objects and widgets is defined in the PDF
 * specification and dictates how PDF files store fields and where they are
 * to be rendered.
 */ var $9a88d5b8c9019f73$var$PDFField = /** @class */ function() {
    function PDFField(acroField, ref, doc) {
        (0, $j0tvB.assertIs)(acroField, 'acroField', [
            [
                (0, $46d285649821c095$export$2e2bcd8739ae039),
                'PDFAcroTerminal'
            ]
        ]);
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $f1233b848bc26abe$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $93b2571d4e1dfe94$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        this.acroField = acroField;
        this.ref = ref;
        this.doc = doc;
    }
    /**
     * Get the fully qualified name of this field. For example:
     * ```js
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const name = field.getName()
     *   console.log('Field name:', name)
     * })
     * ```
     * Note that PDF fields are structured as a tree. Each field is the
     * descendent of a series of ancestor nodes all the way up to the form node,
     * which is always the root of the tree. Each node in the tree (except for
     * the form node) has a partial name. Partial names can be composed of any
     * unicode characters except a period (`.`). The fully qualified name of a
     * field is composed of the partial names of all its ancestors joined
     * with periods. This means that splitting the fully qualified name on
     * periods and taking the last element of the resulting array will give you
     * the partial name of a specific field.
     * @returns The fully qualified name of this field.
     */ PDFField.prototype.getName = function() {
        var _a;
        return (_a = this.acroField.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : '';
    };
    /**
     * Returns `true` if this field is read only. This means that PDF readers
     * will not allow users to interact with the field or change its value. See
     * [[PDFField.enableReadOnly]] and [[PDFField.disableReadOnly]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isReadOnly()) console.log('Read only is enabled')
     * ```
     * @returns Whether or not this is a read only field.
     */ PDFField.prototype.isReadOnly = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$3600c95532547643).ReadOnly);
    };
    /**
     * Prevent PDF readers from allowing users to interact with this field or
     * change its value. The field will not respond to mouse or keyboard input.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableReadOnly()
     * ```
     * Useful for fields whose values are computed, imported from a database, or
     * prefilled by software before being displayed to the user.
     */ PDFField.prototype.enableReadOnly = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$3600c95532547643).ReadOnly, true);
    };
    /**
     * Allow users to interact with this field and change its value in PDF
     * readers via mouse and keyboard input. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableReadOnly()
     * ```
     */ PDFField.prototype.disableReadOnly = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$3600c95532547643).ReadOnly, false);
    };
    /**
     * Returns `true` if this field must have a value when the form is submitted.
     * See [[PDFField.enableRequired]] and [[PDFField.disableRequired]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isRequired()) console.log('Field is required')
     * ```
     * @returns Whether or not this field is required.
     */ PDFField.prototype.isRequired = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$3600c95532547643).Required);
    };
    /**
     * Require this field to have a value when the form is submitted.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableRequired()
     * ```
     */ PDFField.prototype.enableRequired = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$3600c95532547643).Required, true);
    };
    /**
     * Do not require this field to have a value when the form is submitted.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableRequired()
     * ```
     */ PDFField.prototype.disableRequired = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$3600c95532547643).Required, false);
    };
    /**
     * Returns `true` if this field's value should be exported when the form is
     * submitted. See [[PDFField.enableExporting]] and
     * [[PDFField.disableExporting]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isExported()) console.log('Exporting is enabled')
     * ```
     * @returns Whether or not this field's value should be exported.
     */ PDFField.prototype.isExported = function() {
        return !this.acroField.hasFlag((0, $987e37c460e8464e$export$3600c95532547643).NoExport);
    };
    /**
     * Indicate that this field's value should be exported when the form is
     * submitted in a PDF reader. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableExporting()
     * ```
     */ PDFField.prototype.enableExporting = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$3600c95532547643).NoExport, false);
    };
    /**
     * Indicate that this field's value should **not** be exported when the form
     * is submitted in a PDF reader. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableExporting()
     * ```
     */ PDFField.prototype.disableExporting = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$3600c95532547643).NoExport, true);
    };
    /** @ignore */ PDFField.prototype.needsAppearancesUpdate = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'needsAppearancesUpdate');
    };
    /** @ignore */ PDFField.prototype.defaultUpdateAppearances = function(_font) {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'defaultUpdateAppearances');
    };
    PDFField.prototype.markAsDirty = function() {
        this.doc.getForm().markFieldAsDirty(this.ref);
    };
    PDFField.prototype.markAsClean = function() {
        this.doc.getForm().markFieldAsClean(this.ref);
    };
    PDFField.prototype.isDirty = function() {
        return this.doc.getForm().fieldIsDirty(this.ref);
    };
    PDFField.prototype.createWidget = function(options) {
        var _a;
        var textColor = options.textColor;
        var backgroundColor = options.backgroundColor;
        var borderColor = options.borderColor;
        var borderWidth = options.borderWidth;
        var degreesAngle = (0, $3b4f8728c2695c8d$export$56cb859c01fa134d)(options.rotate);
        var caption = options.caption;
        var x = options.x;
        var y = options.y;
        var width = options.width + borderWidth;
        var height = options.height + borderWidth;
        var hidden = Boolean(options.hidden);
        var pageRef = options.page;
        (0, $j0tvB.assertMultiple)(degreesAngle, 'degreesAngle', 90);
        // Create a widget for this field
        var widget = (0, $540f7922618e60a2$export$2e2bcd8739ae039).create(this.doc.context, this.ref);
        // Set widget properties
        var rect = (0, $3b4f8728c2695c8d$export$afddc3b8600307a4)({
            x: x,
            y: y,
            width: width,
            height: height
        }, borderWidth, degreesAngle);
        widget.setRectangle(rect);
        if (pageRef) widget.setP(pageRef);
        var ac = widget.getOrCreateAppearanceCharacteristics();
        if (backgroundColor) ac.setBackgroundColor((0, $030fa0a2c4d1456e$export$ffee2793812e3e56)(backgroundColor));
        ac.setRotation(degreesAngle);
        if (caption) ac.setCaptions({
            normal: caption
        });
        if (borderColor) ac.setBorderColor((0, $030fa0a2c4d1456e$export$ffee2793812e3e56)(borderColor));
        var bs = widget.getOrCreateBorderStyle();
        if (borderWidth !== undefined) bs.setWidth(borderWidth);
        widget.setFlagTo((0, $8f93b7bf8ef0f00e$export$1fa7b68b35026177).Print, true);
        widget.setFlagTo((0, $8f93b7bf8ef0f00e$export$1fa7b68b35026177).Hidden, hidden);
        widget.setFlagTo((0, $8f93b7bf8ef0f00e$export$1fa7b68b35026177).Invisible, false);
        // Set acrofield properties
        if (textColor) {
            var da = (_a = this.acroField.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
            var newDa = da + '\n' + (0, $030fa0a2c4d1456e$export$6126e5d7ba707741)(textColor).toString();
            this.acroField.setDefaultAppearance(newDa);
        }
        return widget;
    };
    PDFField.prototype.updateWidgetAppearanceWithFont = function(widget, font, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        this.updateWidgetAppearances(widget, {
            normal: this.createAppearanceStream(widget, normal, font),
            rollover: rollover && this.createAppearanceStream(widget, rollover, font),
            down: down && this.createAppearanceStream(widget, down, font)
        });
    };
    PDFField.prototype.updateOnOffWidgetAppearance = function(widget, onValue, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        this.updateWidgetAppearances(widget, {
            normal: this.createAppearanceDict(widget, normal, onValue),
            rollover: rollover && this.createAppearanceDict(widget, rollover, onValue),
            down: down && this.createAppearanceDict(widget, down, onValue)
        });
    };
    PDFField.prototype.updateWidgetAppearances = function(widget, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        widget.setNormalAppearance(normal);
        if (rollover) widget.setRolloverAppearance(rollover);
        else widget.removeRolloverAppearance();
        if (down) widget.setDownAppearance(down);
        else widget.removeDownAppearance();
    };
    // // TODO: Do we need to do this...?
    // private foo(font: PDFFont, dict: PDFDict) {
    //   if (!dict.lookup(PDFName.of('DR'))) {
    //     dict.set(PDFName.of('DR'), dict.context.obj({}));
    //   }
    //   const DR = dict.lookup(PDFName.of('DR'), PDFDict);
    //   if (!DR.lookup(PDFName.of('Font'))) {
    //     DR.set(PDFName.of('Font'), dict.context.obj({}));
    //   }
    //   const Font = DR.lookup(PDFName.of('Font'), PDFDict);
    //   Font.set(PDFName.of(font.name), font.ref);
    // }
    PDFField.prototype.createAppearanceStream = function(widget, appearance, font) {
        var _a;
        var context = this.acroField.dict.context;
        var _b = widget.getRectangle(), width = _b.width, height = _b.height;
        // TODO: Do we need to do this...?
        // if (font) {
        //   this.foo(font, widget.dict);
        //   this.foo(font, this.doc.getForm().acroForm.dict);
        // }
        // END TODO
        var Resources = font && {
            Font: (_a = {}, _a[font.name] = font.ref, _a)
        };
        var stream = context.formXObject(appearance, {
            Resources: Resources,
            BBox: context.obj([
                0,
                0,
                width,
                height
            ]),
            Matrix: context.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        });
        var streamRef = context.register(stream);
        return streamRef;
    };
    /**
     * Create a FormXObject of the supplied image and add it to context.
     * The FormXObject size is calculated based on the widget (including
     * the alignment).
     * @param widget The widget that should display the image.
     * @param alignment The alignment of the image.
     * @param image The image that should be displayed.
     * @returns The ref for the FormXObject that was added to the context.
     */ PDFField.prototype.createImageAppearanceStream = function(widget, image, alignment) {
        // NOTE: This implementation doesn't handle image borders.
        // NOTE: Acrobat seems to resize the image (maybe even skewing its aspect
        //       ratio) to fit perfectly within the widget's rectangle. This method
        //       does not currently do that. Should there be an option for that?
        var _a;
        var _b;
        var context = this.acroField.dict.context;
        var rectangle = widget.getRectangle();
        var ap = widget.getAppearanceCharacteristics();
        var bs = widget.getBorderStyle();
        var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
        var rotation = (0, $3b4f8728c2695c8d$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
        var rotate = (0, $55cf96b3448598de$export$5dd9a0a87f38a2a6)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
            rotation: rotation
        }));
        var adj = (0, $3b4f8728c2695c8d$export$312e44550db33c6a)(rectangle, rotation);
        var imageDims = image.scaleToFit(adj.width - borderWidth * 2, adj.height - borderWidth * 2);
        // Support borders on images and maybe other properties
        var options = {
            x: borderWidth,
            y: borderWidth,
            width: imageDims.width,
            height: imageDims.height,
            //
            rotate: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            xSkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            ySkew: (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0)
        };
        if (alignment === (0, $c5ccd91931a24d5b$export$8efa99ca8f041e7e).Center) {
            options.x += (adj.width - borderWidth * 2) / 2 - imageDims.width / 2;
            options.y += (adj.height - borderWidth * 2) / 2 - imageDims.height / 2;
        } else if (alignment === (0, $c5ccd91931a24d5b$export$8efa99ca8f041e7e).Right) {
            options.x = adj.width - borderWidth - imageDims.width;
            options.y = adj.height - borderWidth - imageDims.height;
        }
        var imageName = this.doc.context.addRandomSuffix('Image', 10);
        var appearance = (0, $cOQTW.__spreadArrays)(rotate, (0, $55cf96b3448598de$export$21a059be5bfd5fb)(imageName, options));
        ////////////
        var Resources = {
            XObject: (_a = {}, _a[imageName] = image.ref, _a)
        };
        var stream = context.formXObject(appearance, {
            Resources: Resources,
            BBox: context.obj([
                0,
                0,
                rectangle.width,
                rectangle.height
            ]),
            Matrix: context.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        });
        return context.register(stream);
    };
    PDFField.prototype.createAppearanceDict = function(widget, appearance, onValue) {
        var context = this.acroField.dict.context;
        var onStreamRef = this.createAppearanceStream(widget, appearance.on);
        var offStreamRef = this.createAppearanceStream(widget, appearance.off);
        var appearanceDict = context.obj({});
        appearanceDict.set(onValue, onStreamRef);
        appearanceDict.set((0, $dPHSK.default).of('Off'), offStreamRef);
        return appearanceDict;
    };
    return PDFField;
}();
var $9a88d5b8c9019f73$export$2e2bcd8739ae039 = $9a88d5b8c9019f73$var$PDFField;



var $dPHSK = parcelRequire("dPHSK");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a check box field of a [[PDFForm]].
 *
 * [[PDFCheckBox]] fields are interactive boxes that users can click with their
 * mouse. This type of [[PDFField]] has two states: `on` and `off`. The purpose
 * of a check box is to enable users to select from one or more options, where
 * each option is represented by a single check box. Check boxes are typically
 * square in shape and display a check mark when they are in the `on` state.
 */ var $4740dcccc2940521$var$PDFCheckBox = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFCheckBox, _super);
    function PDFCheckBox(acroCheckBox, ref, doc) {
        var _this = _super.call(this, acroCheckBox, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroCheckBox, 'acroCheckBox', [
            [
                (0, $f8e31b0e21e15332$export$2e2bcd8739ae039),
                'PDFAcroCheckBox'
            ]
        ]);
        _this.acroField = acroCheckBox;
        return _this;
    }
    /**
     * Mark this check box. This operation is analogous to a human user clicking
     * a check box to fill it in a PDF reader. This method will update the
     * underlying state of the check box field to indicate it has been selected.
     * PDF libraries and readers will be able to extract this value from the
     * saved document and determine that it was selected.
     *
     * For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.check()
     * ```
     *
     * This method will mark this check box as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated appearance
     * streams will display a check mark inside the widgets of this check box
     * field.
     */ PDFCheckBox.prototype.check = function() {
        var _a;
        var onValue = (_a = this.acroField.getOnValue()) !== null && _a !== void 0 ? _a : (0, $dPHSK.default).of('Yes');
        this.markAsDirty();
        this.acroField.setValue(onValue);
    };
    /**
     * Clears this check box. This operation is analogous to a human user clicking
     * a check box to unmark it in a PDF reader. This method will update the
     * underlying state of the check box field to indicate it has been deselected.
     * PDF libraries and readers will be able to extract this value from the
     * saved document and determine that it was not selected.
     *
     * For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.uncheck()
     * ```
     *
     * This method will mark this check box as dirty. See [[PDFCheckBox.check]]
     * for more details about what this means.
     */ PDFCheckBox.prototype.uncheck = function() {
        this.markAsDirty();
        this.acroField.setValue((0, $dPHSK.default).of('Off'));
    };
    /**
     * Returns `true` if this check box is selected (either by a human user via
     * a PDF reader, or else programmatically via software). For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * if (checkBox.isChecked()) console.log('check box is selected')
     * ```
     * @returns Whether or not this check box is selected.
     */ PDFCheckBox.prototype.isChecked = function() {
        var onValue = this.acroField.getOnValue();
        return !!onValue && onValue === this.acroField.getValue();
    };
    /**
     * Show this check box on the specified page. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const checkBox = form.createCheckBox('some.checkBox.field')
     *
     * checkBox.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 25,
     *   height: 25,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     * })
     * ```
     * This will create a new widget for this check box field.
     * @param page The page to which this check box widget should be added.
     * @param options The options to be used when adding this check box widget.
     */ PDFCheckBox.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f;
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $9a88d5b8c9019f73$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this check box
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 50,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        widget.setAppearanceState((0, $dPHSK.default).of('Off'));
        this.updateWidgetAppearance(widget, (0, $dPHSK.default).of('Yes'));
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if any of this check box's widgets do not have an
     * appearance stream for its current state. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * if (checkBox.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this check box needs an appearance update.
     */ PDFCheckBox.prototype.needsAppearancesUpdate = function() {
        var _a;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getAppearanceState();
            var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
            if (!(normal instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039))) return true;
            if (state && !normal.has(state)) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this check box's widgets using
     * the default appearance provider for check boxes. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.defaultUpdateAppearances()
     * ```
     */ PDFCheckBox.prototype.defaultUpdateAppearances = function() {
        this.updateAppearances();
    };
    /**
     * Update the appearance streams for each of this check box's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for check boxs will be used. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.updateAppearances((field, widget) => {
     *   ...
     *   return {
     *     normal: { on: drawCheckBox(...), off: drawCheckBox(...) },
     *     down: { on: drawCheckBox(...), off: drawCheckBox(...) },
     *   }
     * })
     * ```
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFCheckBox.prototype.updateAppearances = function(provider) {
        var _a;
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var onValue = (_a = widget.getOnValue()) !== null && _a !== void 0 ? _a : (0, $dPHSK.default).of('Yes');
            if (!onValue) continue;
            this.updateWidgetAppearance(widget, onValue, provider);
        }
        this.markAsClean();
    };
    PDFCheckBox.prototype.updateWidgetAppearance = function(widget, onValue, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $d5944ab433082972$export$e11eab3ac6c06eb0);
        var appearances = (0, $d5944ab433082972$export$8a3aea031520d39b)(apProvider(this, widget));
        this.updateOnOffWidgetAppearance(widget, onValue, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getCheckBox]] method, which will create an
     * > instance of [[PDFCheckBox]] for you.
     *
     * Create an instance of [[PDFCheckBox]] from an existing acroCheckBox and ref
     *
     * @param acroCheckBox The underlying `PDFAcroCheckBox` for this check box.
     * @param ref The unique reference for this check box.
     * @param doc The document to which this check box will belong.
     */ PDFCheckBox.of = function(acroCheckBox, ref, doc) {
        return new PDFCheckBox(acroCheckBox, ref, doc);
    };
    return PDFCheckBox;
}((0, $9a88d5b8c9019f73$export$2e2bcd8739ae039));
var $4740dcccc2940521$export$2e2bcd8739ae039 = $4740dcccc2940521$var$PDFCheckBox;



var $cOQTW = parcelRequire("cOQTW");







parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a dropdown field of a [[PDFForm]].
 *
 * [[PDFDropdown]] fields are interactive text boxes that display a single
 * element (the currently selected value). The purpose of a dropdown is to
 * enable users to select a single option from a set of possible options. Users
 * can click on a dropdown to view the full list of options it provides.
 * Clicking on an option in the list will cause it to be selected and displayed
 * in the dropdown's text box. Some dropdowns allow users to enter text
 * directly into the box from their keyboard, rather than only being allowed to
 * choose an option from the list (see [[PDFDropdown.isEditable]]).
 */ var $8c3a0a776d3c65cf$var$PDFDropdown = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFDropdown, _super);
    function PDFDropdown(acroComboBox, ref, doc) {
        var _this = _super.call(this, acroComboBox, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroComboBox, 'acroComboBox', [
            [
                (0, $3488827c1474fcce$export$2e2bcd8739ae039),
                'PDFAcroComboBox'
            ]
        ]);
        _this.acroField = acroComboBox;
        return _this;
    }
    /**
     * Get the list of available options for this dropdown. These options will be
     * displayed to users who click on this dropdown in a PDF reader.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * const options = dropdown.getOptions()
     * console.log('Dropdown options:', options)
     * ```
     * @returns The options for this dropdown.
     */ PDFDropdown.prototype.getOptions = function() {
        var rawOptions = this.acroField.getOptions();
        var options = new Array(rawOptions.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = rawOptions[idx], display = _a.display, value = _a.value;
            options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
        }
        return options;
    };
    /**
     * Get the selected options for this dropdown. These are the values that were
     * selected by a human user via a PDF reader, or programatically via
     * software.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * const selections = dropdown.getSelected()
     * console.log('Dropdown selections:', selections)
     * ```
     * > **NOTE:** Note that PDF readers only display one selected option when
     * > rendering dropdowns. However, the PDF specification does allow for
     * > multiple values to be selected in a dropdown. As such, the `pdf-lib`
     * > API supports this. However, in most cases the array returned by this
     * > method will contain only a single element (or no elements).
     * @returns The selected options in this dropdown.
     */ PDFDropdown.prototype.getSelected = function() {
        var values = this.acroField.getValues();
        var selected = new Array(values.length);
        for(var idx = 0, len = values.length; idx < len; idx++)selected[idx] = values[idx].decodeText();
        return selected;
    };
    /**
     * Set the list of options that are available for this dropdown. These are
     * the values that will be available for users to select when they view this
     * dropdown in a PDF reader. Note that preexisting options for this dropdown
     * will be removed. Only the values passed as `options` will be available to
     * select.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('planets.dropdown')
     * dropdown.setOptions(['Earth', 'Mars', 'Pluto', 'Venus'])
     * ```
     * @param options The options that should be available in this dropdown.
     */ PDFDropdown.prototype.setOptions = function(options) {
        (0, $j0tvB.assertIs)(options, 'options', [
            Array
        ]);
        var optionObjects = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++)optionObjects[idx] = {
            value: (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(options[idx])
        };
        this.acroField.setOptions(optionObjects);
    };
    /**
     * Add to the list of options that are available for this dropdown. Users
     * will be able to select these values in a PDF reader. In addition to the
     * values passed as `options`, any preexisting options for this dropdown will
     * still be available for users to select.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('rockets.dropdown')
     * dropdown.addOptions(['Saturn IV', 'Falcon Heavy'])
     * ```
     * @param options New options that should be available in this dropdown.
     */ PDFDropdown.prototype.addOptions = function(options) {
        (0, $j0tvB.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var existingOptions = this.acroField.getOptions();
        var newOptions = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)newOptions[idx] = {
            value: (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(optionsArr[idx])
        };
        this.acroField.setOptions(existingOptions.concat(newOptions));
    };
    /**
     * Select one or more values for this dropdown. This operation is analogous
     * to a human user opening the dropdown in a PDF reader and clicking on a
     * value to select it. This method will update the underlying state of the
     * dropdown to indicate which values have been selected. PDF libraries and
     * readers will be able to extract these values from the saved document and
     * determine which values were selected.
     *
     * For example:
     * ```js
     * const dropdown = form.getDropdown('best.superhero.dropdown')
     * dropdown.select('One Punch Man')
     * ```
     *
     * This method will mark this dropdown as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the selected option inside the widgets of this dropdown.
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if the selected option for this field
     * contains characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFDropdown.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * Selecting an option that does not exist in this dropdown's option list
     * (see [[PDFDropdown.getOptions]]) will enable editing on this dropdown
     * (see [[PDFDropdown.enableEditing]]).
     *
     * > **NOTE:** PDF readers only display one selected option when rendering
     * > dropdowns. However, the PDF specification does allow for multiple values
     * > to be selected in a dropdown. As such, the `pdf-lib` API supports this.
     * > However, it is not recommended to select more than one value with this
     * > method, as only one will be visible. [[PDFOptionList]] fields are better
     * > suited for displaying multiple selected values.
     *
     * @param options The options to be selected.
     * @param merge Whether or not existing selections should be preserved.
     */ PDFDropdown.prototype.select = function(options, merge) {
        if (merge === void 0) merge = false;
        (0, $j0tvB.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        (0, $j0tvB.assertIs)(merge, 'merge', [
            'boolean'
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var validOptions = this.getOptions();
        var hasCustomOption = optionsArr.find(function(option) {
            return !validOptions.includes(option);
        });
        if (hasCustomOption) this.enableEditing();
        this.markAsDirty();
        if (optionsArr.length > 1 || optionsArr.length === 1 && merge) this.enableMultiselect();
        var values = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)values[idx] = (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(optionsArr[idx]);
        if (merge) {
            var existingValues = this.acroField.getValues();
            this.acroField.setValues(existingValues.concat(values));
        } else this.acroField.setValues(values);
    };
    /**
     * Clear all selected values for this dropdown. This operation is equivalent
     * to selecting an empty list. This method will update the underlying state
     * of the dropdown to indicate that no values have been selected.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.clear()
     * ```
     * This method will mark this text field as dirty. See [[PDFDropdown.select]]
     * for more details about what this means.
     */ PDFDropdown.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValues([]);
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this dropdown. Font sizes may
     * be integer or floating point numbers. Supplying a negative font size will
     * cause this method to throw an error.
     *
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.setFontSize(4)
     * dropdown.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFDropdown.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if users are allowed to edit the selected value of this
     * dropdown directly and are not constrained by the list of available
     * options. See [[PDFDropdown.enableEditing]] and
     * [[PDFDropdown.disableEditing]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isEditable()) console.log('Editing is enabled')
     * ```
     * @returns Whether or not this dropdown is editable.
     */ PDFDropdown.prototype.isEditable = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).Edit);
    };
    /**
     * Allow users to edit the selected value of this dropdown in PDF readers
     * with their keyboard. This means that the selected value of this dropdown
     * will not be constrained by the list of available options. However, if this
     * dropdown has any available options, users will still be allowed to select
     * from that list.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableEditing()
     * ```
     */ PDFDropdown.prototype.enableEditing = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).Edit, true);
    };
    /**
     * Do not allow users to edit the selected value of this dropdown in PDF
     * readers with their keyboard. This will constrain the selected value of
     * this dropdown to the list of available options. Users will only be able
     * to select an option from that list.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableEditing()
     * ```
     */ PDFDropdown.prototype.disableEditing = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).Edit, false);
    };
    /**
     * Returns `true` if the option list of this dropdown is always displayed
     * in alphabetical order, irrespective of the order in which the options
     * were added to the dropdown. See [[PDFDropdown.enableSorting]] and
     * [[PDFDropdown.disableSorting]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSorted()) console.log('Sorting is enabled')
     * ```
     * @returns Whether or not this dropdown's options are sorted.
     */ PDFDropdown.prototype.isSorted = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).Sort);
    };
    /**
     * Always display the option list of this dropdown in alphabetical order,
     * irrespective of the order in which the options were added to this dropdown.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSorting()
     * ```
     */ PDFDropdown.prototype.enableSorting = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).Sort, true);
    };
    /**
     * Do not always display the option list of this dropdown in alphabetical
     * order. Instead, display the options in whichever order they were added
     * to the list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSorting()
     * ```
     */ PDFDropdown.prototype.disableSorting = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).Sort, false);
    };
    /**
     * Returns `true` if multiple options can be selected from this dropdown's
     * option list. See [[PDFDropdown.enableMultiselect]] and
     * [[PDFDropdown.disableMultiselect]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isMultiselect()) console.log('Multiselect is enabled')
     * ```
     * @returns Whether or not multiple options can be selected.
     */ PDFDropdown.prototype.isMultiselect = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).MultiSelect);
    };
    /**
     * Allow users to select more than one option from this dropdown's option
     * list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableMultiselect()
     * ```
     */ PDFDropdown.prototype.enableMultiselect = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).MultiSelect, true);
    };
    /**
     * Do not allow users to select more than one option from this dropdown's
     * option list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableMultiselect()
     * ```
     */ PDFDropdown.prototype.disableMultiselect = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).MultiSelect, false);
    };
    /**
     * Returns `true` if the selected option should be spell checked by PDF
     * readers. Spell checking will only be performed if this dropdown allows
     * editing (see [[PDFDropdown.isEditable]]). See
     * [[PDFDropdown.enableSpellChecking]] and
     * [[PDFDropdown.disableSpellChecking]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSpellChecked()) console.log('Spell checking is enabled')
     * ```
     * @returns Whether or not this dropdown can be spell checked.
     */ PDFDropdown.prototype.isSpellChecked = function() {
        return !this.acroField.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).DoNotSpellCheck);
    };
    /**
     * Allow PDF readers to spell check the selected option of this dropdown.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSpellChecking()
     * ```
     */ PDFDropdown.prototype.enableSpellChecking = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).DoNotSpellCheck, false);
    };
    /**
     * Do not allow PDF readers to spell check the selected option of this
     * dropdown. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSpellChecking()
     * ```
     */ PDFDropdown.prototype.disableSpellChecking = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).DoNotSpellCheck, true);
    };
    /**
     * Returns `true` if the option selected by a user is stored, or "committed",
     * when the user clicks the option. The alternative is that the user's
     * selection is stored when the user leaves this dropdown field (by clicking
     * outside of it - on another field, for example). See
     * [[PDFDropdown.enableSelectOnClick]] and
     * [[PDFDropdown.disableSelectOnClick]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSelectOnClick()) console.log('Select on click is enabled')
     * ```
     * @returns Whether or not options are selected immediately after they are
     *          clicked.
     */ PDFDropdown.prototype.isSelectOnClick = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).CommitOnSelChange);
    };
    /**
     * Store the option selected by a user immediately after the user clicks the
     * option. Do not wait for the user to leave this dropdown field (by clicking
     * outside of it - on another field, for example). For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSelectOnClick()
     * ```
     */ PDFDropdown.prototype.enableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).CommitOnSelChange, true);
    };
    /**
     * Wait to store the option selected by a user until they leave this dropdown
     * field (by clicking outside of it - on another field, for example).
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSelectOnClick()
     * ```
     */ PDFDropdown.prototype.disableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).CommitOnSelChange, false);
    };
    /**
     * Show this dropdown on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const dropdown = form.createDropdown('best.gundam')
     * dropdown.setOptions(['Exia', 'Dynames'])
     * dropdown.select('Exia')
     *
     * dropdown.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this dropdown field.
     * @param page The page to which this dropdown widget should be added.
     * @param options The options to be used when adding this dropdown widget.
     */ PDFDropdown.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $9a88d5b8c9019f73$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this dropdown
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this dropdown has been marked as dirty, or if any of
     * this dropdown's widgets do not have an appearance stream. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this dropdown needs an appearance update.
     */ PDFDropdown.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this dropdown's widgets using
     * the default appearance provider for dropdowns. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFDropdown.prototype.defaultUpdateAppearances = function(font) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this dropdown's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for dropdowns will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawTextField(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFDropdown.prototype.updateAppearances = function(font, provider) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    // getOption(index: number): string {}
    // getSelectedIndices(): number[] {}
    // removeOptions(option: string | string[]) {}
    // removeIndices(option: number[]) {}
    // deselect(options: string | string[]) {}
    // deselectIndices(optionIndices: number[]) {}
    PDFDropdown.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $d5944ab433082972$export$90f1ca03d512ec5);
        var appearances = (0, $d5944ab433082972$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getDropdown]] method, which will create an
     * > instance of [[PDFDropdown]] for you.
     *
     * Create an instance of [[PDFDropdown]] from an existing acroComboBox and ref
     *
     * @param acroComboBox The underlying `PDFAcroComboBox` for this dropdown.
     * @param ref The unique reference for this dropdown.
     * @param doc The document to which this dropdown will belong.
     */ PDFDropdown.of = function(acroComboBox, ref, doc) {
        return new PDFDropdown(acroComboBox, ref, doc);
    };
    return PDFDropdown;
}((0, $9a88d5b8c9019f73$export$2e2bcd8739ae039));
var $8c3a0a776d3c65cf$export$2e2bcd8739ae039 = $8c3a0a776d3c65cf$var$PDFDropdown;



var $cOQTW = parcelRequire("cOQTW");







parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents an option list field of a [[PDFForm]].
 *
 * [[PDFOptionList]] fields are interactive lists of options. The purpose of an
 * option list is to enable users to select one or more options from a set of
 * possible options. Users are able to see the full set of options without
 * first having to click on the field (though scrolling may be necessary).
 * Clicking an option in the list will cause it to be selected and displayed
 * with a highlighted background. Some option lists allow users to select
 * more than one option (see [[PDFOptionList.isMultiselect]]).
 */ var $41141972e5bafa05$var$PDFOptionList = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFOptionList, _super);
    function PDFOptionList(acroListBox, ref, doc) {
        var _this = _super.call(this, acroListBox, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroListBox, 'acroListBox', [
            [
                (0, $c1f53a89685317ba$export$2e2bcd8739ae039),
                'PDFAcroListBox'
            ]
        ]);
        _this.acroField = acroListBox;
        return _this;
    }
    /**
     * Get the list of available options for this option list. These options will
     * be displayed to users who view this option list in a PDF reader.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * const options = optionList.getOptions()
     * console.log('Option List options:', options)
     * ```
     * @returns The options for this option list.
     */ PDFOptionList.prototype.getOptions = function() {
        var rawOptions = this.acroField.getOptions();
        var options = new Array(rawOptions.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = rawOptions[idx], display = _a.display, value = _a.value;
            options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
        }
        return options;
    };
    /**
     * Get the selected options for this option list. These are the values that
     * were selected by a human user via a PDF reader, or programatically via
     * software.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * const selections = optionList.getSelected()
     * console.log('Option List selections:', selections)
     * ```
     * @returns The selected options for this option list.
     */ PDFOptionList.prototype.getSelected = function() {
        var values = this.acroField.getValues();
        var selected = new Array(values.length);
        for(var idx = 0, len = values.length; idx < len; idx++)selected[idx] = values[idx].decodeText();
        return selected;
    };
    /**
     * Set the list of options that are available for this option list. These are
     * the values that will be available for users to select when they view this
     * option list in a PDF reader. Note that preexisting options for this
     * option list will be removed. Only the values passed as `options` will be
     * available to select.
     *
     * For example:
     * ```js
     * const optionList = form.getOptionList('planets.optionList')
     * optionList.setOptions(['Earth', 'Mars', 'Pluto', 'Venus'])
     * ```
     *
     * This method will mark this option list as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the options this field contains inside the widgets of this text
     * field (with selected options highlighted).
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if this field contains any options
     * with characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFOptionList.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * @param options The options that should be available in this option list.
     */ PDFOptionList.prototype.setOptions = function(options) {
        (0, $j0tvB.assertIs)(options, 'options', [
            Array
        ]);
        this.markAsDirty();
        var optionObjects = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++)optionObjects[idx] = {
            value: (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(options[idx])
        };
        this.acroField.setOptions(optionObjects);
    };
    /**
     * Add to the list of options that are available for this option list. Users
     * will be able to select these values in a PDF reader. In addition to the
     * values passed as `options`, any preexisting options for this option list
     * will still be available for users to select.
     * For example:
     * ```js
     * const optionList = form.getOptionList('rockets.optionList')
     * optionList.addOptions(['Saturn IV', 'Falcon Heavy'])
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     * @param options New options that should be available in this option list.
     */ PDFOptionList.prototype.addOptions = function(options) {
        (0, $j0tvB.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        this.markAsDirty();
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var existingOptions = this.acroField.getOptions();
        var newOptions = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)newOptions[idx] = {
            value: (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(optionsArr[idx])
        };
        this.acroField.setOptions(existingOptions.concat(newOptions));
    };
    /**
     * Select one or more values for this option list. This operation is analogous
     * to a human user opening the option list in a PDF reader and clicking on one
     * or more values to select them. This method will update the underlying state
     * of the option list to indicate which values have been selected. PDF
     * libraries and readers will be able to extract these values from the saved
     * document and determine which values were selected.
     * For example:
     * ```js
     * const optionList = form.getOptionList('best.superheroes.optionList')
     * optionList.select(['One Punch Man', 'Iron Man'])
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     * @param options The options to be selected.
     * @param merge Whether or not existing selections should be preserved.
     */ PDFOptionList.prototype.select = function(options, merge) {
        if (merge === void 0) merge = false;
        (0, $j0tvB.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        (0, $j0tvB.assertIs)(merge, 'merge', [
            'boolean'
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var validOptions = this.getOptions();
        (0, $j0tvB.assertIsSubset)(optionsArr, 'option', validOptions);
        this.markAsDirty();
        if (optionsArr.length > 1 || optionsArr.length === 1 && merge) this.enableMultiselect();
        var values = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)values[idx] = (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(optionsArr[idx]);
        if (merge) {
            var existingValues = this.acroField.getValues();
            this.acroField.setValues(existingValues.concat(values));
        } else this.acroField.setValues(values);
    };
    /**
     * Clear all selected values for this option list. This operation is
     * equivalent to selecting an empty list. This method will update the
     * underlying state of the option list to indicate that no values have been
     * selected.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.clear()
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     */ PDFOptionList.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValues([]);
    };
    /**
     * Set the font size for the text in this field. There needs to be a
     * default appearance string (DA) set with a font value specified
     * for this to work. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.setFontSize(4);
     * ```
     * @param fontSize The font size to set the font to.
     */ /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this option list. Font sizes
     * may be integer or floating point numbers. Supplying a negative font size
     * will cause this method to throw an error.
     *
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.setFontSize(4)
     * optionList.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFOptionList.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if the options of this option list are always displayed
     * in alphabetical order, irrespective of the order in which the options
     * were added to the option list. See [[PDFOptionList.enableSorting]] and
     * [[PDFOptionList.disableSorting]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isSorted()) console.log('Sorting is enabled')
     * ```
     * @returns Whether or not this option list is sorted.
     */ PDFOptionList.prototype.isSorted = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).Sort);
    };
    /**
     * Always display the options of this option list in alphabetical order,
     * irrespective of the order in which the options were added to this option
     * list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableSorting()
     * ```
     */ PDFOptionList.prototype.enableSorting = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).Sort, true);
    };
    /**
     * Do not always display the options of this option list in alphabetical
     * order. Instead, display the options in whichever order they were added
     * to this option list. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableSorting()
     * ```
     */ PDFOptionList.prototype.disableSorting = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).Sort, false);
    };
    /**
     * Returns `true` if multiple options can be selected from this option list.
     * See [[PDFOptionList.enableMultiselect]] and
     * [[PDFOptionList.disableMultiselect]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isMultiselect()) console.log('Multiselect is enabled')
     * ```
     * @returns Whether or not multiple options can be selected.
     */ PDFOptionList.prototype.isMultiselect = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).MultiSelect);
    };
    /**
     * Allow users to select more than one option from this option list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableMultiselect()
     * ```
     */ PDFOptionList.prototype.enableMultiselect = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).MultiSelect, true);
    };
    /**
     * Do not allow users to select more than one option from this option list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableMultiselect()
     * ```
     */ PDFOptionList.prototype.disableMultiselect = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).MultiSelect, false);
    };
    /**
     * Returns `true` if the option selected by a user is stored, or "committed",
     * when the user clicks the option. The alternative is that the user's
     * selection is stored when the user leaves this option list field (by
     * clicking outside of it - on another field, for example). See
     * [[PDFOptionList.enableSelectOnClick]] and
     * [[PDFOptionList.disableSelectOnClick]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isSelectOnClick()) console.log('Select on click is enabled')
     * ```
     * @returns Whether or not options are selected immediately after they are
     *          clicked.
     */ PDFOptionList.prototype.isSelectOnClick = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$eb88827058402599).CommitOnSelChange);
    };
    /**
     * Store the option selected by a user immediately after the user clicks the
     * option. Do not wait for the user to leave this option list field (by
     * clicking outside of it - on another field, for example). For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableSelectOnClick()
     * ```
     */ PDFOptionList.prototype.enableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).CommitOnSelChange, true);
    };
    /**
     * Wait to store the option selected by a user until they leave this option
     * list field (by clicking outside of it - on another field, for example).
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableSelectOnClick()
     * ```
     */ PDFOptionList.prototype.disableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$eb88827058402599).CommitOnSelChange, false);
    };
    /**
     * Show this option list on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const optionList = form.createOptionList('best.gundams')
     * optionList.setOptions(['Exia', 'Dynames', 'Kyrios', 'Virtue'])
     * optionList.select(['Exia', 'Virtue'])
     *
     * optionList.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this option list field.
     * @param page The page to which this option list widget should be added.
     * @param options The options to be used when adding this option list widget.
     */ PDFOptionList.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $9a88d5b8c9019f73$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this option list
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this option list has been marked as dirty, or if any of
     * this option list's widgets do not have an appearance stream. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this option list needs an appearance update.
     */ PDFOptionList.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this option list's widgets using
     * the default appearance provider for option lists. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFOptionList.prototype.defaultUpdateAppearances = function(font) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this option list's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for option lists will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawOptionList(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFOptionList.prototype.updateAppearances = function(font, provider) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    // getOption(index: number): string {}
    // getSelectedIndices(): number[] {}
    // removeOptions(option: string | string[]) {}
    // removeIndices(option: number[]) {}
    // deselect(options: string | string[]) {}
    // deselectIndices(optionIndices: number[]) {}
    PDFOptionList.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $d5944ab433082972$export$f9fab495286778d2);
        var appearances = (0, $d5944ab433082972$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getOptionList]] method, which will create
     * > an instance of [[PDFOptionList]] for you.
     *
     * Create an instance of [[PDFOptionList]] from an existing acroListBox and
     * ref
     *
     * @param acroComboBox The underlying `PDFAcroListBox` for this option list.
     * @param ref The unique reference for this option list.
     * @param doc The document to which this option list will belong.
     */ PDFOptionList.of = function(acroListBox, ref, doc) {
        return new PDFOptionList(acroListBox, ref, doc);
    };
    return PDFOptionList;
}((0, $9a88d5b8c9019f73$export$2e2bcd8739ae039));
var $41141972e5bafa05$export$2e2bcd8739ae039 = $41141972e5bafa05$var$PDFOptionList;



var $cOQTW = parcelRequire("cOQTW");






var $dPHSK = parcelRequire("dPHSK");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a radio group field of a [[PDFForm]].
 *
 * [[PDFRadioGroup]] fields are collections of radio buttons. The purpose of a
 * radio group is to enable users to select one option from a set of mutually
 * exclusive choices. Each choice in a radio group is represented by a radio
 * button. Radio buttons each have two states: `on` and `off`. At most one
 * radio button in a group may be in the `on` state at any time. Users can
 * click on a radio button to select it (and thereby automatically deselect any
 * other radio button that might have already been selected). Some radio
 * groups allow users to toggle a selected radio button `off` by clicking on
 * it (see [[PDFRadioGroup.isOffToggleable]]).
 *
 * Note that some radio groups allow multiple radio buttons to be in the `on`
 * state at the same type **if** they represent the same underlying value (see
 * [[PDFRadioGroup.isMutuallyExclusive]]).
 */ var $131d580cd94f5347$var$PDFRadioGroup = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFRadioGroup, _super);
    function PDFRadioGroup(acroRadioButton, ref, doc) {
        var _this = _super.call(this, acroRadioButton, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroRadioButton, 'acroRadioButton', [
            [
                (0, $cad74455a26124b0$export$2e2bcd8739ae039),
                'PDFAcroRadioButton'
            ]
        ]);
        _this.acroField = acroRadioButton;
        return _this;
    }
    /**
     * Get the list of available options for this radio group. Each option is
     * represented by a radio button. These radio buttons are displayed at
     * various locations in the document, potentially on different pages (though
     * typically they are stacked horizontally or vertically on the same page).
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * const options = radioGroup.getOptions()
     * console.log('Radio Group options:', options)
     * ```
     * @returns The options for this radio group.
     */ PDFRadioGroup.prototype.getOptions = function() {
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            var exportOptions = new Array(exportValues.length);
            for(var idx = 0, len = exportValues.length; idx < len; idx++)exportOptions[idx] = exportValues[idx].decodeText();
            return exportOptions;
        }
        var onValues = this.acroField.getOnValues();
        var onOptions = new Array(onValues.length);
        for(var idx = 0, len = onOptions.length; idx < len; idx++)onOptions[idx] = onValues[idx].decodeText();
        return onOptions;
    };
    /**
     * Get the selected option for this radio group. The selected option is
     * represented by the radio button in this group that is turned on. At most
     * one radio button in a group can be selected. If no buttons in this group
     * are selected, `undefined` is returned.
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * const selected = radioGroup.getSelected()
     * console.log('Selected radio button:', selected)
     * ```
     * @returns The selected option for this radio group.
     */ PDFRadioGroup.prototype.getSelected = function() {
        var value = this.acroField.getValue();
        if (value === (0, $dPHSK.default).of('Off')) return undefined;
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            var onValues = this.acroField.getOnValues();
            for(var idx = 0, len = onValues.length; idx < len; idx++){
                if (onValues[idx] === value) return exportValues[idx].decodeText();
            }
        }
        return value.decodeText();
    };
    // // TODO: Figure out why this seems to crash Acrobat. Maybe it's because we
    // //       aren't removing the widget reference from the page's Annots?
    // removeOption(option: string) {
    //   assertIs(option, 'option', ['string']);
    //   // TODO: Assert is valid `option`!
    //   const onValues = this.acroField.getOnValues();
    //   const exportValues = this.acroField.getExportValues();
    //   if (exportValues) {
    //     for (let idx = 0, len = exportValues.length; idx < len; idx++) {
    //       if (exportValues[idx].decodeText() === option) {
    //         this.acroField.removeWidget(idx);
    //         this.acroField.removeExportValue(idx);
    //       }
    //     }
    //   } else {
    //     for (let idx = 0, len = onValues.length; idx < len; idx++) {
    //       const value = onValues[idx];
    //       if (value.decodeText() === option) {
    //         this.acroField.removeWidget(idx);
    //         this.acroField.removeExportValue(idx);
    //       }
    //     }
    //   }
    // }
    /**
     * Select an option for this radio group. This operation is analogous to a
     * human user clicking one of the radio buttons in this group via a PDF
     * reader to toggle it on. This method will update the underlying state of
     * the radio group to indicate which option has been selected. PDF libraries
     * and readers will be able to extract this value from the saved document and
     * determine which option was selected.
     *
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('best.superhero.radioGroup')
     * radioGroup.select('One Punch Man')
     * ```
     *
     * This method will mark this radio group as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated appearance
     * streams will display a dot inside the widget of this check box field
     * that represents the selected option.
     *
     * @param option The option to be selected.
     */ PDFRadioGroup.prototype.select = function(option) {
        (0, $j0tvB.assertIs)(option, 'option', [
            'string'
        ]);
        var validOptions = this.getOptions();
        (0, $j0tvB.assertIsOneOf)(option, 'option', validOptions);
        this.markAsDirty();
        var onValues = this.acroField.getOnValues();
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            for(var idx = 0, len = exportValues.length; idx < len; idx++)if (exportValues[idx].decodeText() === option) this.acroField.setValue(onValues[idx]);
        } else for(var idx = 0, len = onValues.length; idx < len; idx++){
            var value = onValues[idx];
            if (value.decodeText() === option) this.acroField.setValue(value);
        }
    };
    /**
     * Clear any selected option for this dropdown. This will result in all
     * radio buttons in this group being toggled off. This method will update
     * the underlying state of the dropdown to indicate that no radio buttons
     * have been selected.
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.clear()
     * ```
     * This method will mark this radio group as dirty. See
     * [[PDFRadioGroup.select]] for more details about what this means.
     */ PDFRadioGroup.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValue((0, $dPHSK.default).of('Off'));
    };
    /**
     * Returns `true` if users can click on radio buttons in this group to toggle
     * them off. The alternative is that once a user clicks on a radio button
     * to select it, the only way to deselect it is by selecting on another radio
     * button in the group. See [[PDFRadioGroup.enableOffToggling]] and
     * [[PDFRadioGroup.disableOffToggling]]. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.isOffToggleable()) console.log('Off toggling is enabled')
     * ```
     */ PDFRadioGroup.prototype.isOffToggleable = function() {
        return !this.acroField.hasFlag((0, $987e37c460e8464e$export$59f660e89ffb4f8a).NoToggleToOff);
    };
    /**
     * Allow users to click on selected radio buttons in this group to toggle
     * them off. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.enableOffToggling()
     * ```
     * > **NOTE:** This feature is documented in the PDF specification
     * > (Table 226). However, most PDF readers do not respect this option and
     * > prevent users from toggling radio buttons off even when it is enabled.
     * > At the time of this writing (9/6/2020) Mac's Preview software did
     * > respect the option. Adobe Acrobat, Foxit Reader, and Google Chrome did
     * > not.
     */ PDFRadioGroup.prototype.enableOffToggling = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$59f660e89ffb4f8a).NoToggleToOff, false);
    };
    /**
     * Prevent users from clicking on selected radio buttons in this group to
     * toggle them off. Clicking on a selected radio button will have no effect.
     * The only way to deselect a selected radio button is to click on a
     * different radio button in the group. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.disableOffToggling()
     * ```
     */ PDFRadioGroup.prototype.disableOffToggling = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$59f660e89ffb4f8a).NoToggleToOff, true);
    };
    /**
     * Returns `true` if the radio buttons in this group are mutually exclusive.
     * This means that when the user selects a radio button, only that specific
     * button will be turned on. Even if other radio buttons in the group
     * represent the same value, they will not be enabled. The alternative to
     * this is that clicking a radio button will select that button along with
     * any other radio buttons in the group that share the same value. See
     * [[PDFRadioGroup.enableMutualExclusion]] and
     * [[PDFRadioGroup.disableMutualExclusion]].
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.isMutuallyExclusive()) console.log('Mutual exclusion is enabled')
     * ```
     */ PDFRadioGroup.prototype.isMutuallyExclusive = function() {
        return !this.acroField.hasFlag((0, $987e37c460e8464e$export$59f660e89ffb4f8a).RadiosInUnison);
    };
    /**
     * When the user clicks a radio button in this group it will be selected. In
     * addition, any other radio buttons in this group that share the same
     * underlying value will also be selected. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.enableMutualExclusion()
     * ```
     * Note that this option must be enabled prior to adding options to the
     * radio group. It does not currently apply retroactively to existing
     * radio buttons in the group.
     */ PDFRadioGroup.prototype.enableMutualExclusion = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$59f660e89ffb4f8a).RadiosInUnison, false);
    };
    /**
     * When the user clicks a radio button in this group only it will be selected.
     * No other radio buttons in the group will be selected, even if they share
     * the same underlying value. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.disableMutualExclusion()
     * ```
     * Note that this option must be disabled prior to adding options to the
     * radio group. It does not currently apply retroactively to existing
     * radio buttons in the group.
     */ PDFRadioGroup.prototype.disableMutualExclusion = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$59f660e89ffb4f8a).RadiosInUnison, true);
    };
    /**
     * Add a new radio button to this group on the specified page. For example:
     * ```js
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const radioGroup = form.createRadioGroup('best.gundam')
     *
     * const options = {
     *   x: 50,
     *   width: 25,
     *   height: 25,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     * }
     *
     * radioGroup.addOptionToPage('Exia', page, { ...options, y: 50 })
     * radioGroup.addOptionToPage('Dynames', page, { ...options, y: 110 })
     * ```
     * This will create a new radio button widget for this radio group field.
     * @param option The option that the radio button widget represents.
     * @param page The page to which the radio button widget should be added.
     * @param options The options to be used when adding the radio button widget.
     */ PDFRadioGroup.prototype.addOptionToPage = function(option, page, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        (0, $j0tvB.assertIs)(option, 'option', [
            'string'
        ]);
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $9a88d5b8c9019f73$export$55643210f1835a35)(options);
        // Create a widget for this radio button
        var widget = this.createWidget({
            x: (_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options === null || options === void 0 ? void 0 : options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options === null || options === void 0 ? void 0 : options.width) !== null && _c !== void 0 ? _c : 50,
            height: (_d = options === null || options === void 0 ? void 0 : options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: (_e = options === null || options === void 0 ? void 0 : options.textColor) !== null && _e !== void 0 ? _e : (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0),
            backgroundColor: (_f = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _f !== void 0 ? _f : (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(1, 1, 1),
            borderColor: (_g = options === null || options === void 0 ? void 0 : options.borderColor) !== null && _g !== void 0 ? _g : (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0),
            borderWidth: (_h = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _h !== void 0 ? _h : 1,
            rotate: (_j = options === null || options === void 0 ? void 0 : options.rotate) !== null && _j !== void 0 ? _j : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            hidden: options === null || options === void 0 ? void 0 : options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        var apStateValue = this.acroField.addWidgetWithOpt(widgetRef, (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(option), !this.isMutuallyExclusive());
        // Set appearance streams for widget
        widget.setAppearanceState((0, $dPHSK.default).of('Off'));
        this.updateWidgetAppearance(widget, apStateValue);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if any of this group's radio button widgets do not have an
     * appearance stream for their current state. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this radio group needs an appearance update.
     */ PDFRadioGroup.prototype.needsAppearancesUpdate = function() {
        var _a;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getAppearanceState();
            var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
            if (!(normal instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039))) return true;
            if (state && !normal.has(state)) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this group's radio button widgets
     * using the default appearance provider for radio groups. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.defaultUpdateAppearances()
     * ```
     */ PDFRadioGroup.prototype.defaultUpdateAppearances = function() {
        this.updateAppearances();
    };
    // rg.updateAppearances((field: any, widget: any) => {
    //   assert(field === rg);
    //   assert(widget instanceof PDFWidgetAnnotation);
    //   return { on: [...rectangle, ...circle], off: [...rectangle, ...circle] };
    // });
    /**
     * Update the appearance streams for each of this group's radio button widgets
     * using the given appearance provider. If no `provider` is passed, the
     * default appearance provider for radio groups will be used. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.updateAppearances((field, widget) => {
     *   ...
     *   return {
     *     normal: { on: drawRadioButton(...), off: drawRadioButton(...) },
     *     down: { on: drawRadioButton(...), off: drawRadioButton(...) },
     *   }
     * })
     * ```
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFRadioGroup.prototype.updateAppearances = function(provider) {
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var onValue = widget.getOnValue();
            if (!onValue) continue;
            this.updateWidgetAppearance(widget, onValue, provider);
        }
    };
    PDFRadioGroup.prototype.updateWidgetAppearance = function(widget, onValue, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $d5944ab433082972$export$6440094330a99ef8);
        var appearances = (0, $d5944ab433082972$export$8a3aea031520d39b)(apProvider(this, widget));
        this.updateOnOffWidgetAppearance(widget, onValue, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getOptionList]] method, which will create an
     * > instance of [[PDFOptionList]] for you.
     *
     * Create an instance of [[PDFOptionList]] from an existing acroRadioButton
     * and ref
     *
     * @param acroRadioButton The underlying `PDFAcroRadioButton` for this
     *                        radio group.
     * @param ref The unique reference for this radio group.
     * @param doc The document to which this radio group will belong.
     */ PDFRadioGroup.of = function(acroRadioButton, ref, doc) {
        return new PDFRadioGroup(acroRadioButton, ref, doc);
    };
    return PDFRadioGroup;
}((0, $9a88d5b8c9019f73$export$2e2bcd8739ae039));
var $131d580cd94f5347$export$2e2bcd8739ae039 = $131d580cd94f5347$var$PDFRadioGroup;



var $cOQTW = parcelRequire("cOQTW");


parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a signature field of a [[PDFForm]].
 *
 * [[PDFSignature]] fields are digital signatures. `pdf-lib` does not
 * currently provide any specialized APIs for creating digital signatures or
 * reading the contents of existing digital signatures.
 */ var $cca3a084a6440272$var$PDFSignature = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFSignature, _super);
    function PDFSignature(acroSignature, ref, doc) {
        var _this = _super.call(this, acroSignature, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroSignature, 'acroSignature', [
            [
                (0, $54d8c5346cdc5323$export$2e2bcd8739ae039),
                'PDFAcroSignature'
            ]
        ]);
        _this.acroField = acroSignature;
        return _this;
    }
    PDFSignature.prototype.needsAppearancesUpdate = function() {
        return false;
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getSignature]] method, which will create an
     * > instance of [[PDFSignature]] for you.
     *
     * Create an instance of [[PDFSignature]] from an existing acroSignature and
     * ref
     *
     * @param acroSignature The underlying `PDFAcroSignature` for this signature.
     * @param ref The unique reference for this signature.
     * @param doc The document to which this signature will belong.
     */ PDFSignature.of = function(acroSignature, ref, doc) {
        return new PDFSignature(acroSignature, ref, doc);
    };
    return PDFSignature;
}((0, $9a88d5b8c9019f73$export$2e2bcd8739ae039));
var $cca3a084a6440272$export$2e2bcd8739ae039 = $cca3a084a6440272$var$PDFSignature;



var $cOQTW = parcelRequire("cOQTW");










parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a text field of a [[PDFForm]].
 *
 * [[PDFTextField]] fields are boxes that display text entered by the user. The
 * purpose of a text field is to enable users to enter text or view text values
 * in the document prefilled by software. Users can click on a text field and
 * input text via their keyboard. Some text fields allow multiple lines of text
 * to be entered (see [[PDFTextField.isMultiline]]).
 */ var $f989cc5b81a68a40$var$PDFTextField = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFTextField, _super);
    function PDFTextField(acroText, ref, doc) {
        var _this = _super.call(this, acroText, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroText, 'acroText', [
            [
                (0, $8fd9de5d2343325e$export$2e2bcd8739ae039),
                'PDFAcroText'
            ]
        ]);
        _this.acroField = acroText;
        return _this;
    }
    /**
     * Get the text that this field contains. This text is visible to users who
     * view this field in a PDF reader.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const text = textField.getText()
     * console.log('Text field contents:', text)
     * ```
     *
     * Note that if this text field contains no underlying value, `undefined`
     * will be returned. Text fields may also contain an underlying value that
     * is simply an empty string (`''`). This detail is largely irrelevant for
     * most applications. In general, you'll want to treat both cases the same
     * way and simply consider the text field to be empty. In either case, the
     * text field will appear empty to users when viewed in a PDF reader.
     *
     * An error will be thrown if this is a rich text field. `pdf-lib` does not
     * support reading rich text fields. Nor do most PDF readers and writers.
     * Rich text fields are based on XFA (XML Forms Architecture). Relatively few
     * PDFs use rich text fields or XFA. Unlike PDF itself, XFA is not an ISO
     * standard. XFA has been deprecated in PDF 2.0:
     * * https://en.wikipedia.org/wiki/XFA
     * * http://blog.pdfshareforms.com/pdf-2-0-release-bid-farewell-xfa-forms/
     *
     * @returns The text contained in this text field.
     */ PDFTextField.prototype.getText = function() {
        var value = this.acroField.getValue();
        if (!value && this.isRichFormatted()) throw new (0, $7fe2d034822cb526$export$f2fed572e1ed57ab)(this.getName());
        return value === null || value === void 0 ? void 0 : value.decodeText();
    };
    /**
     * Set the text for this field. This operation is analogous to a human user
     * clicking on the text field in a PDF reader and typing in text via their
     * keyboard. This method will update the underlying state of the text field
     * to indicate what text has been set. PDF libraries and readers will be able
     * to extract these values from the saved document and determine what text
     * was set.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('best.superhero.text.field')
     * textField.setText('One Punch Man')
     * ```
     *
     * This method will mark this text field as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the text this field contains inside the widgets of this text
     * field.
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if this field contains text outside
     * the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFTextField.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * If this is a rich text field, it will be converted to a standard text
     * field in order to set the text. `pdf-lib` does not support writing rich
     * text strings. Nor do most PDF readers and writers. See
     * [[PDFTextField.getText]] for more information about rich text fields and
     * their deprecation in PDF 2.0.
     *
     * @param text The text this field should contain.
     */ PDFTextField.prototype.setText = function(text) {
        (0, $j0tvB.assertOrUndefined)(text, 'text', [
            'string'
        ]);
        var maxLength = this.getMaxLength();
        if (maxLength !== undefined && text && text.length > maxLength) throw new (0, $7fe2d034822cb526$export$1577e99040d42609)(text.length, maxLength, this.getName());
        this.markAsDirty();
        this.disableRichFormatting();
        if (text) this.acroField.setValue((0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(text));
        else this.acroField.removeValue();
    };
    /**
     * Get the alignment for this text field. This value represents the
     * justification of the text when it is displayed to the user in PDF readers.
     * There are three possible alignments: left, center, and right. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const alignment = textField.getAlignment()
     * if (alignment === TextAlignment.Left) console.log('Text is left justified')
     * if (alignment === TextAlignment.Center) console.log('Text is centered')
     * if (alignment === TextAlignment.Right) console.log('Text is right justified')
     * ```
     * @returns The alignment of this text field.
     */ PDFTextField.prototype.getAlignment = function() {
        var quadding = this.acroField.getQuadding();
        // prettier-ignore
        return quadding === 0 ? (0, $010595e4078a43c6$export$84b2d1b68830363f).Left : quadding === 1 ? (0, $010595e4078a43c6$export$84b2d1b68830363f).Center : quadding === 2 ? (0, $010595e4078a43c6$export$84b2d1b68830363f).Right : (0, $010595e4078a43c6$export$84b2d1b68830363f).Left;
    };
    /**
     * Set the alignment for this text field. This will determine the
     * justification of the text when it is displayed to the user in PDF readers.
     * There are three possible alignments: left, center, and right. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     *
     * // Text will be left justified when displayed
     * textField.setAlignment(TextAlignment.Left)
     *
     * // Text will be centered when displayed
     * textField.setAlignment(TextAlignment.Center)
     *
     * // Text will be right justified when displayed
     * textField.setAlignment(TextAlignment.Right)
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     * @param alignment The alignment for this text field.
     */ PDFTextField.prototype.setAlignment = function(alignment) {
        (0, $j0tvB.assertIsOneOf)(alignment, 'alignment', (0, $010595e4078a43c6$export$84b2d1b68830363f));
        this.markAsDirty();
        this.acroField.setQuadding(alignment);
    };
    /**
     * Get the maximum length of this field. This value represents the maximum
     * number of characters that can be typed into this field by the user. If
     * this field does not have a maximum length, `undefined` is returned.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const maxLength = textField.getMaxLength()
     * if (maxLength === undefined) console.log('No max length')
     * else console.log(`Max length is ${maxLength}`)
     * ```
     * @returns The maximum number of characters allowed in this field, or
     *          `undefined` if no limit exists.
     */ PDFTextField.prototype.getMaxLength = function() {
        return this.acroField.getMaxLength();
    };
    /**
     * Set the maximum length of this field. This limits the number of characters
     * that can be typed into this field by the user. This also limits the length
     * of the string that can be passed to [[PDFTextField.setText]]. This limit
     * can be removed by passing `undefined` as `maxLength`. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     *
     * // Allow between 0 and 5 characters to be entered
     * textField.setMaxLength(5)
     *
     * // Allow any number of characters to be entered
     * textField.setMaxLength(undefined)
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     * @param maxLength The maximum number of characters allowed in this field, or
     *                  `undefined` to remove the limit.
     */ PDFTextField.prototype.setMaxLength = function(maxLength) {
        (0, $j0tvB.assertRangeOrUndefined)(maxLength, 'maxLength', 0, Number.MAX_SAFE_INTEGER);
        this.markAsDirty();
        if (maxLength === undefined) this.acroField.removeMaxLength();
        else {
            var text = this.getText();
            if (text && text.length > maxLength) throw new (0, $7fe2d034822cb526$export$6da6c372180e79b0)(text.length, maxLength, this.getName());
            this.acroField.setMaxLength(maxLength);
        }
    };
    /**
     * Remove the maximum length for this text field. This allows any number of
     * characters to be typed into this field by the user. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.removeMaxLength()
     * ```
     * Calling this method is equivalent to passing `undefined` to
     * [[PDFTextField.setMaxLength]].
     */ PDFTextField.prototype.removeMaxLength = function() {
        this.markAsDirty();
        this.acroField.removeMaxLength();
    };
    /**
     * Display an image inside the bounds of this text field's widgets. For example:
     * ```js
     * const pngImage = await pdfDoc.embedPng(...)
     * const textField = form.getTextField('some.text.field')
     * textField.setImage(pngImage)
     * ```
     * This will update the appearances streams for each of this text field's widgets.
     * @param image The image that should be displayed.
     */ PDFTextField.prototype.setImage = function(image) {
        var fieldAlignment = this.getAlignment();
        // prettier-ignore
        var alignment = fieldAlignment === (0, $010595e4078a43c6$export$84b2d1b68830363f).Center ? (0, $c5ccd91931a24d5b$export$8efa99ca8f041e7e).Center : fieldAlignment === (0, $010595e4078a43c6$export$84b2d1b68830363f).Right ? (0, $c5ccd91931a24d5b$export$8efa99ca8f041e7e).Right : (0, $c5ccd91931a24d5b$export$8efa99ca8f041e7e).Left;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var streamRef = this.createImageAppearanceStream(widget, image, alignment);
            this.updateWidgetAppearances(widget, {
                normal: streamRef
            });
        }
        this.markAsClean();
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this text field. Font sizes
     * may be integer or floating point numbers. Supplying a negative font size
     * will cause this method to throw an error.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.setFontSize(4)
     * textField.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFTextField.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if each line of text is shown on a new line when this
     * field is displayed in a PDF reader. The alternative is that all lines of
     * text are merged onto a single line when displayed. See
     * [[PDFTextField.enableMultiline]] and [[PDFTextField.disableMultiline]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isMultiline()) console.log('Multiline is enabled')
     * ```
     * @returns Whether or not this is a multiline text field.
     */ PDFTextField.prototype.isMultiline = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$389fc7b97397dc8b).Multiline);
    };
    /**
     * Display each line of text on a new line when this field is displayed in a
     * PDF reader. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableMultiline()
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.enableMultiline = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).Multiline, true);
    };
    /**
     * Display each line of text on the same line when this field is displayed
     * in a PDF reader. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableMultiline()
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.disableMultiline = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).Multiline, false);
    };
    /**
     * Returns `true` if this is a password text field. This means that the field
     * is intended for storing a secure password. See
     * [[PDFTextField.enablePassword]] and [[PDFTextField.disablePassword]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isPassword()) console.log('Password is enabled')
     * ```
     * @returns Whether or not this is a password text field.
     */ PDFTextField.prototype.isPassword = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$389fc7b97397dc8b).Password);
    };
    /**
     * Indicate that this text field is intended for storing a secure password.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enablePassword()
     * ```
     * Values entered into password text fields should not be displayed on the
     * screen by PDF readers. Most PDF readers will display the value as
     * asterisks or bullets. PDF readers should never store values entered by the
     * user into password text fields. Similarly, applications should not
     * write data to a password text field.
     *
     * **Please note that this method does not cause entered values to be
     * encrypted or secured in any way! It simply sets a flag that PDF software
     * and readers can access to determine the _purpose_ of this field.**
     */ PDFTextField.prototype.enablePassword = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).Password, true);
    };
    /**
     * Indicate that this text field is **not** intended for storing a secure
     * password. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disablePassword()
     * ```
     */ PDFTextField.prototype.disablePassword = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).Password, false);
    };
    /**
     * Returns `true` if the contents of this text field represent a file path.
     * See [[PDFTextField.enableFileSelection]] and
     * [[PDFTextField.disableFileSelection]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isFileSelector()) console.log('Is a file selector')
     * ```
     * @returns Whether or not this field should contain file paths.
     */ PDFTextField.prototype.isFileSelector = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$389fc7b97397dc8b).FileSelect);
    };
    /**
     * Indicate that this text field is intended to store a file path. The
     * contents of the file stored at that path should be submitted as the value
     * of the field. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableFileSelection()
     * ```
     */ PDFTextField.prototype.enableFileSelection = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).FileSelect, true);
    };
    /**
     * Indicate that this text field is **not** intended to store a file path.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableFileSelection()
     * ```
     */ PDFTextField.prototype.disableFileSelection = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).FileSelect, false);
    };
    /**
     * Returns `true` if the text entered in this field should be spell checked
     * by PDF readers. See [[PDFTextField.enableSpellChecking]] and
     * [[PDFTextField.disableSpellChecking]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isSpellChecked()) console.log('Spell checking is enabled')
     * ```
     * @returns Whether or not this field should be spell checked.
     */ PDFTextField.prototype.isSpellChecked = function() {
        return !this.acroField.hasFlag((0, $987e37c460e8464e$export$389fc7b97397dc8b).DoNotSpellCheck);
    };
    /**
     * Allow PDF readers to spell check the text entered in this field.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableSpellChecking()
     * ```
     */ PDFTextField.prototype.enableSpellChecking = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).DoNotSpellCheck, false);
    };
    /**
     * Do not allow PDF readers to spell check the text entered in this field.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableSpellChecking()
     * ```
     */ PDFTextField.prototype.disableSpellChecking = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).DoNotSpellCheck, true);
    };
    /**
     * Returns `true` if PDF readers should allow the user to scroll the text
     * field when its contents do not fit within the field's view bounds. See
     * [[PDFTextField.enableScrolling]] and [[PDFTextField.disableScrolling]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isScrollable()) console.log('Scrolling is enabled')
     * ```
     * @returns Whether or not the field is scrollable in PDF readers.
     */ PDFTextField.prototype.isScrollable = function() {
        return !this.acroField.hasFlag((0, $987e37c460e8464e$export$389fc7b97397dc8b).DoNotScroll);
    };
    /**
     * Allow PDF readers to present a scroll bar to the user when the contents
     * of this text field do not fit within its view bounds. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableScrolling()
     * ```
     * A horizontal scroll bar should be shown for singleline fields. A vertical
     * scroll bar should be shown for multiline fields.
     */ PDFTextField.prototype.enableScrolling = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).DoNotScroll, false);
    };
    /**
     * Do not allow PDF readers to present a scroll bar to the user when the
     * contents of this text field do not fit within its view bounds. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableScrolling()
     * ```
     */ PDFTextField.prototype.disableScrolling = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).DoNotScroll, true);
    };
    /**
     * Returns `true` if this is a combed text field. This means that the field
     * is split into `n` equal size cells with one character in each (where `n`
     * is equal to the max length of the text field). The result is that all
     * characters in this field are displayed an equal distance apart from one
     * another. See [[PDFTextField.enableCombing]] and
     * [[PDFTextField.disableCombing]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isCombed()) console.log('Combing is enabled')
     * ```
     * Note that in order for a text field to be combed, the following must be
     * true (in addition to enabling combing):
     * * It must not be a multiline field (see [[PDFTextField.isMultiline]])
     * * It must not be a password field (see [[PDFTextField.isPassword]])
     * * It must not be a file selector field (see [[PDFTextField.isFileSelector]])
     * * It must have a max length defined (see [[PDFTextField.setMaxLength]])
     * @returns Whether or not this field is combed.
     */ PDFTextField.prototype.isCombed = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$389fc7b97397dc8b).Comb) && !this.isMultiline() && !this.isPassword() && !this.isFileSelector() && this.getMaxLength() !== undefined;
    };
    /**
     * Split this field into `n` equal size cells with one character in each
     * (where `n` is equal to the max length of the text field). This will cause
     * all characters in the field to be displayed an equal distance apart from
     * one another. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableCombing()
     * ```
     *
     * In addition to calling this method, text fields must have a max length
     * defined in order to be combed (see [[PDFTextField.setMaxLength]]).
     *
     * This method will also call the following three methods internally:
     * * [[PDFTextField.disableMultiline]]
     * * [[PDFTextField.disablePassword]]
     * * [[PDFTextField.disableFileSelection]]
     *
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.enableCombing = function() {
        if (this.getMaxLength() === undefined) {
            var msg = "PDFTextFields must have a max length in order to be combed";
            console.warn(msg);
        }
        this.markAsDirty();
        this.disableMultiline();
        this.disablePassword();
        this.disableFileSelection();
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).Comb, true);
    };
    /**
     * Turn off combing for this text field. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableCombing()
     * ```
     * See [[PDFTextField.isCombed]] and [[PDFTextField.enableCombing]] for more
     * information about what combing is.
     *
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.disableCombing = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).Comb, false);
    };
    /**
     * Returns `true` if this text field contains rich text. See
     * [[PDFTextField.enableRichFormatting]] and
     * [[PDFTextField.disableRichFormatting]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isRichFormatted()) console.log('Rich formatting enabled')
     * ```
     * @returns Whether or not this field contains rich text.
     */ PDFTextField.prototype.isRichFormatted = function() {
        return this.acroField.hasFlag((0, $987e37c460e8464e$export$389fc7b97397dc8b).RichText);
    };
    /**
     * Indicate that this field contains XFA data - or rich text. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableRichFormatting()
     * ```
     * Note that `pdf-lib` does not support reading or writing rich text fields.
     * Nor do most PDF readers and writers. Rich text fields are based on XFA
     * (XML Forms Architecture). Relatively few PDFs use rich text fields or XFA.
     * Unlike PDF itself, XFA is not an ISO standard. XFA has been deprecated in
     * PDF 2.0:
     * * https://en.wikipedia.org/wiki/XFA
     * * http://blog.pdfshareforms.com/pdf-2-0-release-bid-farewell-xfa-forms/
     */ PDFTextField.prototype.enableRichFormatting = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).RichText, true);
    };
    /**
     * Indicate that this is a standard text field that does not XFA data (rich
     * text). For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableRichFormatting()
     * ```
     */ PDFTextField.prototype.disableRichFormatting = function() {
        this.acroField.setFlagTo((0, $987e37c460e8464e$export$389fc7b97397dc8b).RichText, false);
    };
    /**
     * Show this text field on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const textField = form.createTextField('best.gundam')
     * textField.setText('Exia')
     *
     * textField.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this text field.
     * @param page The page to which this text field widget should be added.
     * @param options The options to be used when adding this text field widget.
     */ PDFTextField.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $9a88d5b8c9019f73$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this text field
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this text field has been marked as dirty, or if any of
     * this text field's widgets do not have an appearance stream. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this text field needs an appearance update.
     */ PDFTextField.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this text field's widgets using
     * the default appearance provider for text fields. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const textField = form.getTextField('some.text.field')
     * textField.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFTextField.prototype.defaultUpdateAppearances = function(font) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this text field's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for text fields will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const textField = form.getTextField('some.text.field')
     * textField.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawTextField(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFTextField.prototype.updateAppearances = function(font, provider) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    PDFTextField.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $d5944ab433082972$export$42ba95e6b8df3d7);
        var appearances = (0, $d5944ab433082972$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getTextField]] method, which will create an
     * > instance of [[PDFTextField]] for you.
     *
     * Create an instance of [[PDFTextField]] from an existing acroText and ref
     *
     * @param acroText The underlying `PDFAcroText` for this text field.
     * @param ref The unique reference for this text field.
     * @param doc The document to which this text field will belong.
     */ PDFTextField.of = function(acroText, ref, doc) {
        return new PDFTextField(acroText, ref, doc);
    };
    return PDFTextField;
}((0, $9a88d5b8c9019f73$export$2e2bcd8739ae039));
var $f989cc5b81a68a40$export$2e2bcd8739ae039 = $f989cc5b81a68a40$var$PDFTextField;




var $d275b823cf3c6e5b$export$7dcb046109e65a3d;
(function(StandardFonts) {
    StandardFonts["Courier"] = "Courier";
    StandardFonts["CourierBold"] = "Courier-Bold";
    StandardFonts["CourierOblique"] = "Courier-Oblique";
    StandardFonts["CourierBoldOblique"] = "Courier-BoldOblique";
    StandardFonts["Helvetica"] = "Helvetica";
    StandardFonts["HelveticaBold"] = "Helvetica-Bold";
    StandardFonts["HelveticaOblique"] = "Helvetica-Oblique";
    StandardFonts["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
    StandardFonts["TimesRoman"] = "Times-Roman";
    StandardFonts["TimesRomanBold"] = "Times-Bold";
    StandardFonts["TimesRomanItalic"] = "Times-Italic";
    StandardFonts["TimesRomanBoldItalic"] = "Times-BoldItalic";
    StandardFonts["Symbol"] = "Symbol";
    StandardFonts["ZapfDingbats"] = "ZapfDingbats";
})($d275b823cf3c6e5b$export$7dcb046109e65a3d || ($d275b823cf3c6e5b$export$7dcb046109e65a3d = {}));





var $dPHSK = parcelRequire("dPHSK");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $clYSv = parcelRequire("clYSv");
/**
 * Represents the interactive form of a [[PDFDocument]].
 *
 * Interactive forms (sometimes called _AcroForms_) are collections of fields
 * designed to gather information from a user. A PDF document may contains any
 * number of fields that appear on various pages, all of which make up a single,
 * global interactive form spanning the entire document. This means that
 * instances of [[PDFDocument]] shall contain at most one [[PDFForm]].
 *
 * The fields of an interactive form are represented by [[PDFField]] instances.
 */ var $1ca8b80442f19ab5$var$PDFForm = /** @class */ function() {
    function PDFForm(acroForm, doc) {
        var _this = this;
        this.embedDefaultFont = function() {
            return _this.doc.embedStandardFont((0, $d275b823cf3c6e5b$export$7dcb046109e65a3d).Helvetica);
        };
        (0, $j0tvB.assertIs)(acroForm, 'acroForm', [
            [
                (0, $b2be38e1e2597241$export$2e2bcd8739ae039),
                'PDFAcroForm'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $93b2571d4e1dfe94$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        this.acroForm = acroForm;
        this.doc = doc;
        this.dirtyFields = new Set();
        this.defaultFontCache = (0, $clYSv.default).populatedBy(this.embedDefaultFont);
    }
    /**
     * Returns `true` if this [[PDFForm]] has XFA data. Most PDFs with form
     * fields do not use XFA as it is not widely supported by PDF readers.
     *
     * > `pdf-lib` does not support creation, modification, or reading of XFA
     * > fields.
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * if (form.hasXFA()) console.log('PDF has XFA data')
     * ```
     * @returns Whether or not this form has XFA data.
     */ PDFForm.prototype.hasXFA = function() {
        return this.acroForm.dict.has((0, $dPHSK.default).of('XFA'));
    };
    /**
     * Disconnect the XFA data from this [[PDFForm]] (if any exists). This will
     * force readers to fallback to standard fields if the [[PDFDocument]]
     * contains any. For example:
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * form.deleteXFA()
     * ```
     */ PDFForm.prototype.deleteXFA = function() {
        this.acroForm.dict.delete((0, $dPHSK.default).of('XFA'));
    };
    /**
     * Get all fields contained in this [[PDFForm]]. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const type = field.constructor.name
     *   const name = field.getName()
     *   console.log(`${type}: ${name}`)
     * })
     * ```
     * @returns An array of all fields in this form.
     */ PDFForm.prototype.getFields = function() {
        var allFields = this.acroForm.getAllFields();
        var fields = [];
        for(var idx = 0, len = allFields.length; idx < len; idx++){
            var _a = allFields[idx], acroField = _a[0], ref = _a[1];
            var field = $1ca8b80442f19ab5$var$convertToPDFField(acroField, ref, this.doc);
            if (field) fields.push(field);
        }
        return fields;
    };
    /**
     * Get the field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getFieldMaybe('Page1.Foo.Bar[0]')
     * if (field) console.log('Field exists!')
     * ```
     * @param name A fully qualified field name.
     * @returns The field with the specified name, if one exists.
     */ PDFForm.prototype.getFieldMaybe = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var fields = this.getFields();
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var field = fields[idx];
            if (field.getName() === name) return field;
        }
        return undefined;
    };
    /**
     * Get the field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('Page1.Foo.Bar[0]')
     * ```
     * If no field exists with the provided name, an error will be thrown.
     * @param name A fully qualified field name.
     * @returns The field with the specified name.
     */ PDFForm.prototype.getField = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getFieldMaybe(name);
        if (field) return field;
        throw new (0, $7fe2d034822cb526$export$5bc08baa4a027cbd)(name);
    };
    /**
     * Get the button field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const button = form.getButton('Page1.Foo.Button[0]')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a button.
     * @param name A fully qualified button name.
     * @returns The button with the specified name.
     */ PDFForm.prototype.getButton = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $b3771f5aa96680ee$export$2e2bcd8739ae039)) return field;
        throw new (0, $7fe2d034822cb526$export$8909da6c566ff652)(name, (0, $b3771f5aa96680ee$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the check box field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const checkBox = form.getCheckBox('Page1.Foo.CheckBox[0]')
     * checkBox.check()
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a check box.
     * @param name A fully qualified check box name.
     * @returns The check box with the specified name.
     */ PDFForm.prototype.getCheckBox = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $4740dcccc2940521$export$2e2bcd8739ae039)) return field;
        throw new (0, $7fe2d034822cb526$export$8909da6c566ff652)(name, (0, $4740dcccc2940521$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the dropdown field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const dropdown = form.getDropdown('Page1.Foo.Dropdown[0]')
     * const options = dropdown.getOptions()
     * dropdown.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a dropdown.
     * @param name A fully qualified dropdown name.
     * @returns The dropdown with the specified name.
     */ PDFForm.prototype.getDropdown = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $8c3a0a776d3c65cf$export$2e2bcd8739ae039)) return field;
        throw new (0, $7fe2d034822cb526$export$8909da6c566ff652)(name, (0, $8c3a0a776d3c65cf$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the option list field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const optionList = form.getOptionList('Page1.Foo.OptionList[0]')
     * const options = optionList.getOptions()
     * optionList.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not an option list.
     * @param name A fully qualified option list name.
     * @returns The option list with the specified name.
     */ PDFForm.prototype.getOptionList = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $41141972e5bafa05$export$2e2bcd8739ae039)) return field;
        throw new (0, $7fe2d034822cb526$export$8909da6c566ff652)(name, (0, $41141972e5bafa05$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the radio group field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const radioGroup = form.getRadioGroup('Page1.Foo.RadioGroup[0]')
     * const options = radioGroup.getOptions()
     * radioGroup.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a radio group.
     * @param name A fully qualified radio group name.
     * @returns The radio group with the specified name.
     */ PDFForm.prototype.getRadioGroup = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $131d580cd94f5347$export$2e2bcd8739ae039)) return field;
        throw new (0, $7fe2d034822cb526$export$8909da6c566ff652)(name, (0, $131d580cd94f5347$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the signature field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const signature = form.getSignature('Page1.Foo.Signature[0]')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a signature.
     * @param name A fully qualified signature name.
     * @returns The signature with the specified name.
     */ PDFForm.prototype.getSignature = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $cca3a084a6440272$export$2e2bcd8739ae039)) return field;
        throw new (0, $7fe2d034822cb526$export$8909da6c566ff652)(name, (0, $cca3a084a6440272$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the text field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const textField = form.getTextField('Page1.Foo.TextField[0]')
     * textField.setText('Are you designed to act or to be acted upon?')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a text field.
     * @param name A fully qualified text field name.
     * @returns The text field with the specified name.
     */ PDFForm.prototype.getTextField = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $f989cc5b81a68a40$export$2e2bcd8739ae039)) return field;
        throw new (0, $7fe2d034822cb526$export$8909da6c566ff652)(name, (0, $f989cc5b81a68a40$export$2e2bcd8739ae039), field);
    };
    /**
     * Create a new button field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const button = form.createButton('cool.new.button')
     *
     * button.addToPage('Do Stuff', font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new button.
     * @returns The new button field.
     */ PDFForm.prototype.createButton = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var button = (0, $0cfa6a9523f95402$export$2e2bcd8739ae039).create(this.doc.context);
        button.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            button,
            button.ref
        ], nameParts.terminal);
        return (0, $b3771f5aa96680ee$export$2e2bcd8739ae039).of(button, button.ref, this.doc);
    };
    /**
     * Create a new check box field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const checkBox = form.createCheckBox('cool.new.checkBox')
     *
     * checkBox.addToPage(page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new check box.
     * @returns The new check box field.
     */ PDFForm.prototype.createCheckBox = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var checkBox = (0, $f8e31b0e21e15332$export$2e2bcd8739ae039).create(this.doc.context);
        checkBox.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            checkBox,
            checkBox.ref
        ], nameParts.terminal);
        return (0, $4740dcccc2940521$export$2e2bcd8739ae039).of(checkBox, checkBox.ref, this.doc);
    };
    /**
     * Create a new dropdown field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const dropdown = form.createDropdown('cool.new.dropdown')
     *
     * dropdown.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new dropdown.
     * @returns The new dropdown field.
     */ PDFForm.prototype.createDropdown = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var comboBox = (0, $3488827c1474fcce$export$2e2bcd8739ae039).create(this.doc.context);
        comboBox.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            comboBox,
            comboBox.ref
        ], nameParts.terminal);
        return (0, $8c3a0a776d3c65cf$export$2e2bcd8739ae039).of(comboBox, comboBox.ref, this.doc);
    };
    /**
     * Create a new option list field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const optionList = form.createOptionList('cool.new.optionList')
     *
     * optionList.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new option list.
     * @returns The new option list field.
     */ PDFForm.prototype.createOptionList = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var listBox = (0, $c1f53a89685317ba$export$2e2bcd8739ae039).create(this.doc.context);
        listBox.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            listBox,
            listBox.ref
        ], nameParts.terminal);
        return (0, $41141972e5bafa05$export$2e2bcd8739ae039).of(listBox, listBox.ref, this.doc);
    };
    /**
     * Create a new radio group field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const radioGroup = form.createRadioGroup('cool.new.radioGroup')
     *
     * radioGroup.addOptionToPage('is-dog', page, { y: 0 })
     * radioGroup.addOptionToPage('is-cat', page, { y: 75 })
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new radio group.
     * @returns The new radio group field.
     */ PDFForm.prototype.createRadioGroup = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var radioButton = (0, $cad74455a26124b0$export$2e2bcd8739ae039).create(this.doc.context);
        radioButton.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            radioButton,
            radioButton.ref
        ], nameParts.terminal);
        return (0, $131d580cd94f5347$export$2e2bcd8739ae039).of(radioButton, radioButton.ref, this.doc);
    };
    /**
     * Create a new text field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const textField = form.createTextField('cool.new.textField')
     *
     * textField.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new radio group.
     * @returns The new radio group field.
     */ PDFForm.prototype.createTextField = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var text = (0, $8fd9de5d2343325e$export$2e2bcd8739ae039).create(this.doc.context);
        text.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            text,
            text.ref
        ], nameParts.terminal);
        return (0, $f989cc5b81a68a40$export$2e2bcd8739ae039).of(text, text.ref, this.doc);
    };
    /**
     * Flatten all fields in this [[PDFForm]].
     *
     * Flattening a form field will take the current appearance for each of that
     * field's widgets and make them part of their page's content stream. All form
     * fields and annotations associated are then removed. Note that once a form
     * has been flattened its fields can no longer be accessed or edited.
     *
     * This operation is often used after filling form fields to ensure a
     * consistent appearance across different PDF readers and/or printers.
     * Another common use case is to copy a template document with form fields
     * into another document. In this scenario you would load the template
     * document, fill its fields, flatten it, and then copy its pages into the
     * recipient document - the filled fields will be copied over.
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm();
     * form.flatten();
     * ```
     */ PDFForm.prototype.flatten = function(options) {
        if (options === void 0) options = {
            updateFieldAppearances: true
        };
        if (options.updateFieldAppearances) this.updateFieldAppearances();
        var fields = this.getFields();
        for(var i = 0, lenFields = fields.length; i < lenFields; i++){
            var field = fields[i];
            var widgets = field.acroField.getWidgets();
            for(var j = 0, lenWidgets = widgets.length; j < lenWidgets; j++){
                var widget = widgets[j];
                var page = this.findWidgetPage(widget);
                var widgetRef = this.findWidgetAppearanceRef(field, widget);
                var xObjectKey = page.node.newXObject('FlatWidget', widgetRef);
                var rectangle = widget.getRectangle();
                var operators = (0, $cOQTW.__spreadArrays)([
                    (0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(),
                    (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(rectangle.x, rectangle.y)
                ], (0, $55cf96b3448598de$export$5dd9a0a87f38a2a6)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
                    rotation: 0
                })), [
                    (0, $cfb765e9daff3c3a$export$382c18f8bccd9e2b)(xObjectKey),
                    (0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)()
                ]).filter(Boolean);
                page.pushOperators.apply(page, operators);
            }
            this.removeField(field);
        }
    };
    /**
     * Remove a field from this [[PDFForm]].
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm();
     * const ageField = form.getFields().find(x => x.getName() === 'Age');
     * form.removeField(ageField);
     * ```
     */ PDFForm.prototype.removeField = function(field) {
        var widgets = field.acroField.getWidgets();
        var pages = new Set();
        for(var i = 0, len = widgets.length; i < len; i++){
            var widget = widgets[i];
            var widgetRef = this.findWidgetAppearanceRef(field, widget);
            var page = this.findWidgetPage(widget);
            pages.add(page);
            page.node.removeAnnot(widgetRef);
        }
        pages.forEach(function(page) {
            return page.node.removeAnnot(field.ref);
        });
        this.acroForm.removeField(field.acroField);
        var fieldKids = field.acroField.normalizedEntries().Kids;
        var kidsCount = fieldKids.size();
        for(var childIndex = 0; childIndex < kidsCount; childIndex++){
            var child = fieldKids.get(childIndex);
            if (child instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039)) this.doc.context.delete(child);
        }
        this.doc.context.delete(field.ref);
    };
    /**
     * Update the appearance streams for all widgets of all fields in this
     * [[PDFForm]]. Appearance streams will only be created for a widget if it
     * does not have any existing appearance streams, or the field's value has
     * changed (e.g. by calling [[PDFTextField.setText]] or
     * [[PDFDropdown.select]]).
     *
     * For example:
     * ```js
     * const courier = await pdfDoc.embedFont(StandardFonts.Courier)
     * const form = pdfDoc.getForm()
     * form.updateFieldAppearances(courier)
     * ```
     *
     * **IMPORTANT:** The default value for the `font` parameter is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if any fields contain text with
     * characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing that as the `font`
     * parameter allows you to generate appearance streams with non WinAnsi
     * characters (assuming your custom font supports them).
     *
     * > **NOTE:** The [[PDFDocument.save]] method will call this method to
     * > update appearances automatically if a form was accessed via the
     * > [[PDFDocument.getForm]] method prior to saving.
     *
     * @param font Optionally, the font to use when creating new appearances.
     */ PDFForm.prototype.updateFieldAppearances = function(font) {
        (0, $j0tvB.assertOrUndefined)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        font = font !== null && font !== void 0 ? font : this.getDefaultFont();
        var fields = this.getFields();
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var field = fields[idx];
            if (field.needsAppearancesUpdate()) field.defaultUpdateAppearances(font);
        }
    };
    /**
     * Mark a field as dirty. This will cause its appearance streams to be
     * updated by [[PDFForm.updateFieldAppearances]].
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * form.markFieldAsDirty(field.ref)
     * ```
     * @param fieldRef The reference to the field that should be marked.
     */ PDFForm.prototype.markFieldAsDirty = function(fieldRef) {
        (0, $j0tvB.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $f1233b848bc26abe$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        this.dirtyFields.add(fieldRef);
    };
    /**
     * Mark a field as dirty. This will cause its appearance streams to not be
     * updated by [[PDFForm.updateFieldAppearances]].
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * form.markFieldAsClean(field.ref)
     * ```
     * @param fieldRef The reference to the field that should be marked.
     */ PDFForm.prototype.markFieldAsClean = function(fieldRef) {
        (0, $j0tvB.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $f1233b848bc26abe$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        this.dirtyFields.delete(fieldRef);
    };
    /**
     * Returns `true` is the specified field has been marked as dirty.
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * if (form.fieldIsDirty(field.ref)) console.log('Field is dirty')
     * ```
     * @param fieldRef The reference to the field that should be checked.
     * @returns Whether or not the specified field is dirty.
     */ PDFForm.prototype.fieldIsDirty = function(fieldRef) {
        (0, $j0tvB.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $f1233b848bc26abe$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        return this.dirtyFields.has(fieldRef);
    };
    PDFForm.prototype.getDefaultFont = function() {
        return this.defaultFontCache.access();
    };
    PDFForm.prototype.findWidgetPage = function(widget) {
        var pageRef = widget.P();
        var page = this.doc.getPages().find(function(x) {
            return x.ref === pageRef;
        });
        if (page === undefined) {
            var widgetRef = this.doc.context.getObjectRef(widget.dict);
            if (widgetRef === undefined) throw new Error('Could not find PDFRef for PDFObject');
            page = this.doc.findPageForAnnotationRef(widgetRef);
            if (page === undefined) throw new Error("Could not find page for PDFRef " + widgetRef);
        }
        return page;
    };
    PDFForm.prototype.findWidgetAppearanceRef = function(field, widget) {
        var _a;
        var refOrDict = widget.getNormalAppearance();
        if (refOrDict instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039) && (field instanceof (0, $4740dcccc2940521$export$2e2bcd8739ae039) || field instanceof (0, $131d580cd94f5347$export$2e2bcd8739ae039))) {
            var value = field.acroField.getValue();
            var ref = (_a = refOrDict.get(value)) !== null && _a !== void 0 ? _a : refOrDict.get((0, $dPHSK.default).of('Off'));
            if (ref instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039)) refOrDict = ref;
        }
        if (!(refOrDict instanceof (0, $f1233b848bc26abe$export$2e2bcd8739ae039))) {
            var name_1 = field.getName();
            throw new Error("Failed to extract appearance ref for: " + name_1);
        }
        return refOrDict;
    };
    PDFForm.prototype.findOrCreateNonTerminals = function(partialNames) {
        var nonTerminal = [
            this.acroForm
        ];
        for(var idx = 0, len = partialNames.length; idx < len; idx++){
            var namePart = partialNames[idx];
            if (!namePart) throw new (0, $7fe2d034822cb526$export$83c39fdacfe38500)(namePart);
            var parent_1 = nonTerminal[0], parentRef = nonTerminal[1];
            var res = this.findNonTerminal(namePart, parent_1);
            if (res) nonTerminal = res;
            else {
                var node = (0, $a105ec5aeb848914$export$2e2bcd8739ae039).create(this.doc.context);
                node.setPartialName(namePart);
                node.setParent(parentRef);
                var nodeRef = this.doc.context.register(node.dict);
                parent_1.addField(nodeRef);
                nonTerminal = [
                    node,
                    nodeRef
                ];
            }
        }
        return nonTerminal;
    };
    PDFForm.prototype.findNonTerminal = function(partialName, parent) {
        var fields = parent instanceof (0, $b2be38e1e2597241$export$2e2bcd8739ae039) ? this.acroForm.getFields() : (0, $be3fb214968b38d5$export$34b4fb8893136c4c)(parent.Kids());
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var _a = fields[idx], field = _a[0], ref = _a[1];
            if (field.getPartialName() === partialName) {
                if (field instanceof (0, $a105ec5aeb848914$export$2e2bcd8739ae039)) return [
                    field,
                    ref
                ];
                throw new (0, $7fe2d034822cb526$export$c428cfe4dc6c68df)(partialName);
            }
        }
        return undefined;
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.getForm]] method, which will create an
     * > instance of [[PDFForm]] for you.
     *
     * Create an instance of [[PDFForm]] from an existing acroForm and embedder
     *
     * @param acroForm The underlying `PDFAcroForm` for this form.
     * @param doc The document to which the form will belong.
     */ PDFForm.of = function(acroForm, doc) {
        return new PDFForm(acroForm, doc);
    };
    return PDFForm;
}();
var $1ca8b80442f19ab5$export$2e2bcd8739ae039 = $1ca8b80442f19ab5$var$PDFForm;
var $1ca8b80442f19ab5$var$convertToPDFField = function(field, ref, doc) {
    if (field instanceof (0, $0cfa6a9523f95402$export$2e2bcd8739ae039)) return (0, $b3771f5aa96680ee$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $f8e31b0e21e15332$export$2e2bcd8739ae039)) return (0, $4740dcccc2940521$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $3488827c1474fcce$export$2e2bcd8739ae039)) return (0, $8c3a0a776d3c65cf$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $c1f53a89685317ba$export$2e2bcd8739ae039)) return (0, $41141972e5bafa05$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $8fd9de5d2343325e$export$2e2bcd8739ae039)) return (0, $f989cc5b81a68a40$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $cad74455a26124b0$export$2e2bcd8739ae039)) return (0, $131d580cd94f5347$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $54d8c5346cdc5323$export$2e2bcd8739ae039)) return (0, $cca3a084a6440272$export$2e2bcd8739ae039).of(field, ref, doc);
    return undefined;
};
var $1ca8b80442f19ab5$var$splitFieldName = function(fullyQualifiedName) {
    if (fullyQualifiedName.length === 0) throw new Error('PDF field names must not be empty strings');
    var parts = fullyQualifiedName.split('.');
    for(var idx = 0, len = parts.length; idx < len; idx++){
        if (parts[idx] === '') throw new Error("Periods in PDF field names must be separated by at least one character: \"" + fullyQualifiedName + "\"");
    }
    if (parts.length === 1) return {
        nonTerminal: [],
        terminal: parts[0]
    };
    return {
        nonTerminal: parts.slice(0, parts.length - 1),
        terminal: parts[parts.length - 1]
    };
};
var $1ca8b80442f19ab5$var$addFieldToParent = function(_a, _b, partialName) {
    var parent = _a[0], parentRef = _a[1];
    var field = _b[0], fieldRef = _b[1];
    var entries = parent.normalizedEntries();
    var fields = (0, $be3fb214968b38d5$export$34b4fb8893136c4c)('Kids' in entries ? entries.Kids : entries.Fields);
    for(var idx = 0, len = fields.length; idx < len; idx++){
        if (fields[idx][0].getPartialName() === partialName) throw new (0, $7fe2d034822cb526$export$c428cfe4dc6c68df)(partialName);
    }
    parent.addField(fieldRef);
    field.setParent(parentRef);
};


var $bdf8b405f72f9bf0$export$b4a05ae367f5515c = {
    '4A0': [
        4767.87,
        6740.79
    ],
    '2A0': [
        3370.39,
        4767.87
    ],
    A0: [
        2383.94,
        3370.39
    ],
    A1: [
        1683.78,
        2383.94
    ],
    A2: [
        1190.55,
        1683.78
    ],
    A3: [
        841.89,
        1190.55
    ],
    A4: [
        595.28,
        841.89
    ],
    A5: [
        419.53,
        595.28
    ],
    A6: [
        297.64,
        419.53
    ],
    A7: [
        209.76,
        297.64
    ],
    A8: [
        147.4,
        209.76
    ],
    A9: [
        104.88,
        147.4
    ],
    A10: [
        73.7,
        104.88
    ],
    B0: [
        2834.65,
        4008.19
    ],
    B1: [
        2004.09,
        2834.65
    ],
    B2: [
        1417.32,
        2004.09
    ],
    B3: [
        1000.63,
        1417.32
    ],
    B4: [
        708.66,
        1000.63
    ],
    B5: [
        498.9,
        708.66
    ],
    B6: [
        354.33,
        498.9
    ],
    B7: [
        249.45,
        354.33
    ],
    B8: [
        175.75,
        249.45
    ],
    B9: [
        124.72,
        175.75
    ],
    B10: [
        87.87,
        124.72
    ],
    C0: [
        2599.37,
        3676.54
    ],
    C1: [
        1836.85,
        2599.37
    ],
    C2: [
        1298.27,
        1836.85
    ],
    C3: [
        918.43,
        1298.27
    ],
    C4: [
        649.13,
        918.43
    ],
    C5: [
        459.21,
        649.13
    ],
    C6: [
        323.15,
        459.21
    ],
    C7: [
        229.61,
        323.15
    ],
    C8: [
        161.57,
        229.61
    ],
    C9: [
        113.39,
        161.57
    ],
    C10: [
        79.37,
        113.39
    ],
    RA0: [
        2437.8,
        3458.27
    ],
    RA1: [
        1729.13,
        2437.8
    ],
    RA2: [
        1218.9,
        1729.13
    ],
    RA3: [
        864.57,
        1218.9
    ],
    RA4: [
        609.45,
        864.57
    ],
    SRA0: [
        2551.18,
        3628.35
    ],
    SRA1: [
        1814.17,
        2551.18
    ],
    SRA2: [
        1275.59,
        1814.17
    ],
    SRA3: [
        907.09,
        1275.59
    ],
    SRA4: [
        637.8,
        907.09
    ],
    Executive: [
        521.86,
        756.0
    ],
    Folio: [
        612.0,
        936.0
    ],
    Legal: [
        612.0,
        1008.0
    ],
    Letter: [
        612.0,
        792.0
    ],
    Tabloid: [
        792.0,
        1224.0
    ]
};



var $nAWRe = parcelRequire("nAWRe");
var $dPHSK = parcelRequire("dPHSK");
var $9fe7d517881d9f8b$export$ba19d141a3749548;
(function(ParseSpeeds) {
    ParseSpeeds[ParseSpeeds["Fastest"] = Infinity] = "Fastest";
    ParseSpeeds[ParseSpeeds["Fast"] = 1500] = "Fast";
    ParseSpeeds[ParseSpeeds["Medium"] = 500] = "Medium";
    ParseSpeeds[ParseSpeeds["Slow"] = 100] = "Slow";
})($9fe7d517881d9f8b$export$ba19d141a3749548 || ($9fe7d517881d9f8b$export$ba19d141a3749548 = {}));


parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $clYSv = parcelRequire("clYSv");
var $4ISq8 = parcelRequire("4ISq8");
var $fZ8o5 = parcelRequire("fZ8o5");
var $cbIAG = parcelRequire("cbIAG");


var $cOQTW = parcelRequire("cOQTW");

var $8auL6 = parcelRequire("8auL6");
var $dPHSK = parcelRequire("dPHSK");
/**
 * Represents a file that has been embedded in a [[PDFDocument]].
 */ var $072855dc9321c2b4$var$PDFEmbeddedFile = /** @class */ function() {
    function PDFEmbeddedFile(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        this.ref = ref;
        this.doc = doc;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all embeddable files get embedded.
     *
     * Embed this embeddable file in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFEmbeddedFile.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var ref, Names, EmbeddedFiles, EFNames, AF;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        ref = _a.sent();
                        if (!this.doc.catalog.has((0, $dPHSK.default).of('Names'))) this.doc.catalog.set((0, $dPHSK.default).of('Names'), this.doc.context.obj({}));
                        Names = this.doc.catalog.lookup((0, $dPHSK.default).of('Names'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
                        if (!Names.has((0, $dPHSK.default).of('EmbeddedFiles'))) Names.set((0, $dPHSK.default).of('EmbeddedFiles'), this.doc.context.obj({}));
                        EmbeddedFiles = Names.lookup((0, $dPHSK.default).of('EmbeddedFiles'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
                        if (!EmbeddedFiles.has((0, $dPHSK.default).of('Names'))) EmbeddedFiles.set((0, $dPHSK.default).of('Names'), this.doc.context.obj([]));
                        EFNames = EmbeddedFiles.lookup((0, $dPHSK.default).of('Names'), (0, $8auL6.default));
                        EFNames.push((0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(this.embedder.fileName));
                        EFNames.push(ref);
                        /**
                         * The AF-Tag is needed to achieve PDF-A3 compliance for embedded files
                         *
                         * The following document outlines the uses cases of the associated files (AF) tag.
                         * See:
                         * https://www.pdfa.org/wp-content/uploads/2018/10/PDF20_AN002-AF.pdf
                         */ if (!this.doc.catalog.has((0, $dPHSK.default).of('AF'))) this.doc.catalog.set((0, $dPHSK.default).of('AF'), this.doc.context.obj([]));
                        AF = this.doc.catalog.lookup((0, $dPHSK.default).of('AF'), (0, $8auL6.default));
                        AF.push(ref);
                        this.alreadyEmbedded = true;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.attach]] method, which will create
     * instances of [[PDFEmbeddedFile]] for you.
     *
     * Create an instance of [[PDFEmbeddedFile]] from an existing ref and embedder
     *
     * @param ref The unique reference for this file.
     * @param doc The document to which the file will belong.
     * @param embedder The embedder that will be used to embed the file.
     */ PDFEmbeddedFile.of = function(ref, doc, embedder) {
        return new PDFEmbeddedFile(ref, doc, embedder);
    };
    return PDFEmbeddedFile;
}();
var $072855dc9321c2b4$export$2e2bcd8739ae039 = $072855dc9321c2b4$var$PDFEmbeddedFile;



var $cOQTW = parcelRequire("cOQTW");

var $8auL6 = parcelRequire("8auL6");
var $dPHSK = parcelRequire("dPHSK");
/**
 * Represents JavaScript that has been embedded in a [[PDFDocument]].
 */ var $8e93f6bd1fec6f6e$var$PDFJavaScript = /** @class */ function() {
    function PDFJavaScript(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        this.ref = ref;
        this.doc = doc;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all JavaScripts get embedded.
     *
     * Embed this JavaScript in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFJavaScript.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, catalog, context, ref, Names, Javascript, JSNames;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = this.doc, catalog = _a.catalog, context = _a.context;
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        ref = _b.sent();
                        if (!catalog.has((0, $dPHSK.default).of('Names'))) catalog.set((0, $dPHSK.default).of('Names'), context.obj({}));
                        Names = catalog.lookup((0, $dPHSK.default).of('Names'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
                        if (!Names.has((0, $dPHSK.default).of('JavaScript'))) Names.set((0, $dPHSK.default).of('JavaScript'), context.obj({}));
                        Javascript = Names.lookup((0, $dPHSK.default).of('JavaScript'), (0, $85408478fbb7cbde$export$2e2bcd8739ae039));
                        if (!Javascript.has((0, $dPHSK.default).of('Names'))) Javascript.set((0, $dPHSK.default).of('Names'), context.obj([]));
                        JSNames = Javascript.lookup((0, $dPHSK.default).of('Names'), (0, $8auL6.default));
                        JSNames.push((0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(this.embedder.scriptName));
                        JSNames.push(ref);
                        this.alreadyEmbedded = true;
                        _b.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addJavaScript]] method, which will
     * create instances of [[PDFJavaScript]] for you.
     *
     * Create an instance of [[PDFJavaScript]] from an existing ref and script
     *
     * @param ref The unique reference for this script.
     * @param doc The document to which the script will belong.
     * @param embedder The embedder that will be used to embed the script.
     */ PDFJavaScript.of = function(ref, doc, embedder) {
        return new PDFJavaScript(ref, doc, embedder);
    };
    return PDFJavaScript;
}();
var $8e93f6bd1fec6f6e$export$2e2bcd8739ae039 = $8e93f6bd1fec6f6e$var$PDFJavaScript;



var $cOQTW = parcelRequire("cOQTW");

var $60420ad6933b406d$var$JavaScriptEmbedder = /** @class */ function() {
    function JavaScriptEmbedder(script, scriptName) {
        this.script = script;
        this.scriptName = scriptName;
    }
    JavaScriptEmbedder.for = function(script, scriptName) {
        return new JavaScriptEmbedder(script, scriptName);
    };
    JavaScriptEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var jsActionDict;
            return (0, $cOQTW.__generator)(this, function(_a) {
                jsActionDict = context.obj({
                    Type: 'Action',
                    S: 'JavaScript',
                    JS: (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(this.script)
                });
                if (ref) {
                    context.assign(ref, jsActionDict);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(jsActionDict)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return JavaScriptEmbedder;
}();
var $60420ad6933b406d$export$2e2bcd8739ae039 = $60420ad6933b406d$var$JavaScriptEmbedder;


/**
 * Represents a PDF document.
 */ var $93b2571d4e1dfe94$var$PDFDocument = /** @class */ function() {
    function PDFDocument(context, ignoreEncryption, updateMetadata) {
        var _this = this;
        /** The default word breaks used in PDFPage.drawText */ this.defaultWordBreaks = [
            ' '
        ];
        this.computePages = function() {
            var pages = [];
            _this.catalog.Pages().traverse(function(node, ref) {
                if (node instanceof (0, $a9e73b7ced5abfa4$export$2e2bcd8739ae039)) {
                    var page = _this.pageMap.get(node);
                    if (!page) {
                        page = (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039).of(node, ref, _this);
                        _this.pageMap.set(node, page);
                    }
                    pages.push(page);
                }
            });
            return pages;
        };
        this.getOrCreateForm = function() {
            var acroForm = _this.catalog.getOrCreateAcroForm();
            return (0, $1ca8b80442f19ab5$export$2e2bcd8739ae039).of(acroForm, _this);
        };
        (0, $j0tvB.assertIs)(context, 'context', [
            [
                (0, $ece91e5f61c516eb$export$2e2bcd8739ae039),
                'PDFContext'
            ]
        ]);
        (0, $j0tvB.assertIs)(ignoreEncryption, 'ignoreEncryption', [
            'boolean'
        ]);
        this.context = context;
        this.catalog = context.lookup(context.trailerInfo.Root);
        this.isEncrypted = !!context.lookup(context.trailerInfo.Encrypt);
        this.pageCache = (0, $clYSv.default).populatedBy(this.computePages);
        this.pageMap = new Map();
        this.formCache = (0, $clYSv.default).populatedBy(this.getOrCreateForm);
        this.fonts = [];
        this.images = [];
        this.embeddedPages = [];
        this.embeddedFiles = [];
        this.javaScripts = [];
        if (!ignoreEncryption && this.isEncrypted) throw new (0, $7fe2d034822cb526$export$20fcceeca2b098d2)();
        if (updateMetadata) this.updateInfoDict();
    }
    /**
     * Load an existing [[PDFDocument]]. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                               |
     * | ------------- | ------------------------------------------------------ |
     * | `string`      | A base64 encoded string (or data URI) containing a PDF |
     * | `Uint8Array`  | The raw bytes of a PDF                                 |
     * | `ArrayBuffer` | The raw bytes of a PDF                                 |
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     *
     * // pdf=string
     * const base64 =
     *  'JVBERi0xLjcKJYGBgYEKCjUgMCBvYmoKPDwKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbm' +
     *  'd0aCAxMDQKPj4Kc3RyZWFtCniccwrhMlAAwaJ0Ln2P1Jyy1JLM5ERdc0MjCwUjE4WQNC4Q' +
     *  '6cNlCFZkqGCqYGSqEJLLZWNuYGZiZmbkYuZsZmlmZGRgZmluDCQNzc3NTM2NzdzMXMxMjQ' +
     *  'ztFEKyuEK0uFxDuAAOERdVCmVuZHN0cmVhbQplbmRvYmoKCjYgMCBvYmoKPDwKL0ZpbHRl' +
     *  'ciAvRmxhdGVEZWNvZGUKL1R5cGUgL09ialN0bQovTiA0Ci9GaXJzdCAyMAovTGVuZ3RoID' +
     *  'IxNQo+PgpzdHJlYW0KeJxVj9GqwjAMhu/zFHkBzTo3nCCCiiKIHPEICuJF3cKoSCu2E8/b' +
     *  '20wPIr1p8v9/8kVhgilmGfawX2CGaVrgcAi0/bsy0lrX7IGWpvJ4iJYEN3gEmrrGBlQwGs' +
     *  'HHO9VBX1wNrxAqMX87RBD5xpJuddqwd82tjAHxzV1U5LPgy52DKXWnr1Lheg+j/c/pzGVr' +
     *  'iqV0VlwZPXGPCJjElw/ybkwUmeoWgxesDXGhHJC/D/iikp1Av80ptKU0FdBEe25pPihAM1' +
     *  'u6ytgaaWfs2Hrz35CJT1+EWmAKZW5kc3RyZWFtCmVuZG9iagoKNyAwIG9iago8PAovU2l6' +
     *  'ZSA4Ci9Sb290IDIgMCBSCi9GaWx0ZXIgL0ZsYXRlRGVjb2RlCi9UeXBlIC9YUmVmCi9MZW' +
     *  '5ndGggMzgKL1cgWyAxIDIgMiBdCi9JbmRleCBbIDAgOCBdCj4+CnN0cmVhbQp4nBXEwREA' +
     *  'EBAEsCwz3vrvRmOOyyOoGhZdutHN2MT55fIAVocD+AplbmRzdHJlYW0KZW5kb2JqCgpzdG' +
     *  'FydHhyZWYKNTEwCiUlRU9G'
     *
     * const dataUri = 'data:application/pdf;base64,' + base64
     *
     * const pdfDoc1 = await PDFDocument.load(base64)
     * const pdfDoc2 = await PDFDocument.load(dataUri)
     *
     * // pdf=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('with_update_sections.pdf')
     * const pdfDoc3 = await PDFDocument.load(uint8Array)
     *
     * // pdf=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/with_update_sections.pdf'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const pdfDoc4 = await PDFDocument.load(arrayBuffer)
     *
     * ```
     *
     * @param pdf The input data containing a PDF document.
     * @param options The options to be used when loading the document.
     * @returns Resolves with a document loaded from the input.
     */ PDFDocument.load = function(pdf, options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, ignoreEncryption, _b, parseSpeed, _c, throwOnInvalidObject, _d, updateMetadata, _e, capNumbers, bytes, context;
            return (0, $cOQTW.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        _a = options.ignoreEncryption, ignoreEncryption = _a === void 0 ? false : _a, _b = options.parseSpeed, parseSpeed = _b === void 0 ? (0, $9fe7d517881d9f8b$export$ba19d141a3749548).Slow : _b, _c = options.throwOnInvalidObject, throwOnInvalidObject = _c === void 0 ? false : _c, _d = options.updateMetadata, updateMetadata = _d === void 0 ? true : _d, _e = options.capNumbers, capNumbers = _e === void 0 ? false : _e;
                        (0, $j0tvB.assertIs)(pdf, 'pdf', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        (0, $j0tvB.assertIs)(ignoreEncryption, 'ignoreEncryption', [
                            'boolean'
                        ]);
                        (0, $j0tvB.assertIs)(parseSpeed, 'parseSpeed', [
                            'number'
                        ]);
                        (0, $j0tvB.assertIs)(throwOnInvalidObject, 'throwOnInvalidObject', [
                            'boolean'
                        ]);
                        bytes = (0, $4ISq8.toUint8Array)(pdf);
                        return [
                            4 /*yield*/ ,
                            (0, $0c78b71d995ee90b$export$2e2bcd8739ae039).forBytesWithOptions(bytes, parseSpeed, throwOnInvalidObject, capNumbers).parseDocument()
                        ];
                    case 1:
                        context = _f.sent();
                        return [
                            2 /*return*/ ,
                            new PDFDocument(context, ignoreEncryption, updateMetadata)
                        ];
                }
            });
        });
    };
    /**
     * Create a new [[PDFDocument]].
     * @returns Resolves with the newly created document.
     */ PDFDocument.create = function(options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, updateMetadata, context, pageTree, pageTreeRef, catalog;
            return (0, $cOQTW.__generator)(this, function(_b) {
                _a = options.updateMetadata, updateMetadata = _a === void 0 ? true : _a;
                context = (0, $ece91e5f61c516eb$export$2e2bcd8739ae039).create();
                pageTree = (0, $333acd2e5fba0d32$export$2e2bcd8739ae039).withContext(context);
                pageTreeRef = context.register(pageTree);
                catalog = (0, $80c05707f2c8c1f7$export$2e2bcd8739ae039).withContextAndPages(context, pageTreeRef);
                context.trailerInfo.Root = context.register(catalog);
                return [
                    2 /*return*/ ,
                    new PDFDocument(context, false, updateMetadata)
                ];
            });
        });
    };
    /**
     * Register a fontkit instance. This must be done before custom fonts can
     * be embedded. See [here](https://github.com/Hopding/pdf-lib/tree/master#fontkit-installation)
     * for instructions on how to install and register a fontkit instance.
     *
     * > You do **not** need to call this method to embed standard fonts.
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     * import fontkit from '@pdf-lib/fontkit'
     *
     * const pdfDoc = await PDFDocument.create()
     * pdfDoc.registerFontkit(fontkit)
     * ```
     *
     * @param fontkit The fontkit instance to be registered.
     */ PDFDocument.prototype.registerFontkit = function(fontkit) {
        this.fontkit = fontkit;
    };
    /**
     * Get the [[PDFForm]] containing all interactive fields for this document.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const type = field.constructor.name
     *   const name = field.getName()
     *   console.log(`${type}: ${name}`)
     * })
     * ```
     * @returns The form for this document.
     */ PDFDocument.prototype.getForm = function() {
        var form = this.formCache.access();
        if (form.hasXFA()) {
            console.warn('Removing XFA form data as pdf-lib does not support reading or writing XFA');
            form.deleteXFA();
        }
        return form;
    };
    /**
     * Get this document's title metadata. The title appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const title = pdfDoc.getTitle()
     * ```
     * @returns A string containing the title of this document, if it has one.
     */ PDFDocument.prototype.getTitle = function() {
        var title = this.getInfoDict().lookup((0, $dPHSK.default).Title);
        if (!title) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(title);
        return title.decodeText();
    };
    /**
     * Get this document's author metadata. The author appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const author = pdfDoc.getAuthor()
     * ```
     * @returns A string containing the author of this document, if it has one.
     */ PDFDocument.prototype.getAuthor = function() {
        var author = this.getInfoDict().lookup((0, $dPHSK.default).Author);
        if (!author) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(author);
        return author.decodeText();
    };
    /**
     * Get this document's subject metadata. The subject appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const subject = pdfDoc.getSubject()
     * ```
     * @returns A string containing the subject of this document, if it has one.
     */ PDFDocument.prototype.getSubject = function() {
        var subject = this.getInfoDict().lookup((0, $dPHSK.default).Subject);
        if (!subject) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(subject);
        return subject.decodeText();
    };
    /**
     * Get this document's keywords metadata. The keywords appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const keywords = pdfDoc.getKeywords()
     * ```
     * @returns A string containing the keywords of this document, if it has any.
     */ PDFDocument.prototype.getKeywords = function() {
        var keywords = this.getInfoDict().lookup((0, $dPHSK.default).Keywords);
        if (!keywords) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(keywords);
        return keywords.decodeText();
    };
    /**
     * Get this document's creator metadata. The creator appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const creator = pdfDoc.getCreator()
     * ```
     * @returns A string containing the creator of this document, if it has one.
     */ PDFDocument.prototype.getCreator = function() {
        var creator = this.getInfoDict().lookup((0, $dPHSK.default).Creator);
        if (!creator) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(creator);
        return creator.decodeText();
    };
    /**
     * Get this document's producer metadata. The producer appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const producer = pdfDoc.getProducer()
     * ```
     * @returns A string containing the producer of this document, if it has one.
     */ PDFDocument.prototype.getProducer = function() {
        var producer = this.getInfoDict().lookup((0, $dPHSK.default).Producer);
        if (!producer) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(producer);
        return producer.decodeText();
    };
    /**
     * Get this document's creation date metadata. The creation date appears in
     * the "Document Properties" section of most PDF readers. For example:
     * ```js
     * const creationDate = pdfDoc.getCreationDate()
     * ```
     * @returns A Date containing the creation date of this document,
     *          if it has one.
     */ PDFDocument.prototype.getCreationDate = function() {
        var creationDate = this.getInfoDict().lookup((0, $dPHSK.default).CreationDate);
        if (!creationDate) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(creationDate);
        return creationDate.decodeDate();
    };
    /**
     * Get this document's modification date metadata. The modification date
     * appears in the "Document Properties" section of most PDF readers.
     * For example:
     * ```js
     * const modification = pdfDoc.getModificationDate()
     * ```
     * @returns A Date containing the modification date of this document,
     *          if it has one.
     */ PDFDocument.prototype.getModificationDate = function() {
        var modificationDate = this.getInfoDict().lookup((0, $dPHSK.default).ModDate);
        if (!modificationDate) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(modificationDate);
        return modificationDate.decodeDate();
    };
    /**
     * Set this document's title metadata. The title will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setTitle('🥚 The Life of an Egg 🍳')
     * ```
     *
     * To display the title in the window's title bar, set the
     * `showInWindowTitleBar` option to `true` (works for _most_ PDF readers).
     * For example:
     * ```js
     * pdfDoc.setTitle('🥚 The Life of an Egg 🍳', { showInWindowTitleBar: true })
     * ```
     *
     * @param title The title of this document.
     * @param options The options to be used when setting the title.
     */ PDFDocument.prototype.setTitle = function(title, options) {
        (0, $j0tvB.assertIs)(title, 'title', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Title');
        this.getInfoDict().set(key, (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(title));
        // Indicate that readers should display the title rather than the filename
        if (options === null || options === void 0 ? void 0 : options.showInWindowTitleBar) {
            var prefs = this.catalog.getOrCreateViewerPreferences();
            prefs.setDisplayDocTitle(true);
        }
    };
    /**
     * Set this document's author metadata. The author will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setAuthor('Humpty Dumpty')
     * ```
     * @param author The author of this document.
     */ PDFDocument.prototype.setAuthor = function(author) {
        (0, $j0tvB.assertIs)(author, 'author', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Author');
        this.getInfoDict().set(key, (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(author));
    };
    /**
     * Set this document's subject metadata. The subject will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setSubject('📘 An Epic Tale of Woe 📖')
     * ```
     * @param subject The subject of this document.
     */ PDFDocument.prototype.setSubject = function(subject) {
        (0, $j0tvB.assertIs)(subject, 'author', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Subject');
        this.getInfoDict().set(key, (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(subject));
    };
    /**
     * Set this document's keyword metadata. These keywords will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setKeywords(['eggs', 'wall', 'fall', 'king', 'horses', 'men'])
     * ```
     * @param keywords An array of keywords associated with this document.
     */ PDFDocument.prototype.setKeywords = function(keywords) {
        (0, $j0tvB.assertIs)(keywords, 'keywords', [
            Array
        ]);
        var key = (0, $dPHSK.default).of('Keywords');
        this.getInfoDict().set(key, (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(keywords.join(' ')));
    };
    /**
     * Set this document's creator metadata. The creator will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setCreator('PDF App 9000 🤖')
     * ```
     * @param creator The creator of this document.
     */ PDFDocument.prototype.setCreator = function(creator) {
        (0, $j0tvB.assertIs)(creator, 'creator', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Creator');
        this.getInfoDict().set(key, (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(creator));
    };
    /**
     * Set this document's producer metadata. The producer will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setProducer('PDF App 9000 🤖')
     * ```
     * @param producer The producer of this document.
     */ PDFDocument.prototype.setProducer = function(producer) {
        (0, $j0tvB.assertIs)(producer, 'creator', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Producer');
        this.getInfoDict().set(key, (0, $e8537943f4279a06$export$2e2bcd8739ae039).fromText(producer));
    };
    /**
     * Set this document's language metadata. The language will appear in the
     * "Document Properties" section of some PDF readers. For example:
     * ```js
     * pdfDoc.setLanguage('en-us')
     * ```
     *
     * @param language An RFC 3066 _Language-Tag_ denoting the language of this
     *                 document, or an empty string if the language is unknown.
     */ PDFDocument.prototype.setLanguage = function(language) {
        (0, $j0tvB.assertIs)(language, 'language', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Lang');
        this.catalog.set(key, (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).of(language));
    };
    /**
     * Set this document's creation date metadata. The creation date will appear
     * in the "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setCreationDate(new Date())
     * ```
     * @param creationDate The date this document was created.
     */ PDFDocument.prototype.setCreationDate = function(creationDate) {
        (0, $j0tvB.assertIs)(creationDate, 'creationDate', [
            [
                Date,
                'Date'
            ]
        ]);
        var key = (0, $dPHSK.default).of('CreationDate');
        this.getInfoDict().set(key, (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).fromDate(creationDate));
    };
    /**
     * Set this document's modification date metadata. The modification date will
     * appear in the "Document Properties" section of most PDF readers. For
     * example:
     * ```js
     * pdfDoc.setModificationDate(new Date())
     * ```
     * @param modificationDate The date this document was last modified.
     */ PDFDocument.prototype.setModificationDate = function(modificationDate) {
        (0, $j0tvB.assertIs)(modificationDate, 'modificationDate', [
            [
                Date,
                'Date'
            ]
        ]);
        var key = (0, $dPHSK.default).of('ModDate');
        this.getInfoDict().set(key, (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039).fromDate(modificationDate));
    };
    /**
     * Get the number of pages contained in this document. For example:
     * ```js
     * const totalPages = pdfDoc.getPageCount()
     * ```
     * @returns The number of pages in this document.
     */ PDFDocument.prototype.getPageCount = function() {
        if (this.pageCount === undefined) this.pageCount = this.getPages().length;
        return this.pageCount;
    };
    /**
     * Get an array of all the pages contained in this document. The pages are
     * stored in the array in the same order that they are rendered in the
     * document. For example:
     * ```js
     * const pages = pdfDoc.getPages()
     * pages[0]   // The first page of the document
     * pages[2]   // The third page of the document
     * pages[197] // The 198th page of the document
     * ```
     * @returns An array of all the pages contained in this document.
     */ PDFDocument.prototype.getPages = function() {
        return this.pageCache.access();
    };
    /**
     * Get the page rendered at a particular `index` of the document. For example:
     * ```js
     * pdfDoc.getPage(0)   // The first page of the document
     * pdfDoc.getPage(2)   // The third page of the document
     * pdfDoc.getPage(197) // The 198th page of the document
     * ```
     * @returns The [[PDFPage]] rendered at the given `index` of the document.
     */ PDFDocument.prototype.getPage = function(index) {
        var pages = this.getPages();
        (0, $j0tvB.assertRange)(index, 'index', 0, pages.length - 1);
        return pages[index];
    };
    /**
     * Get an array of indices for all the pages contained in this document. The
     * array will contain a range of integers from
     * `0..pdfDoc.getPageCount() - 1`. For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     * pdfDoc.addPage()
     * pdfDoc.addPage()
     * pdfDoc.addPage()
     *
     * const indices = pdfDoc.getPageIndices()
     * indices // => [0, 1, 2]
     * ```
     * @returns An array of indices for all pages contained in this document.
     */ PDFDocument.prototype.getPageIndices = function() {
        return (0, $4ISq8.range)(0, this.getPageCount());
    };
    /**
     * Remove the page at a given index from this document. For example:
     * ```js
     * pdfDoc.removePage(0)   // Remove the first page of the document
     * pdfDoc.removePage(2)   // Remove the third page of the document
     * pdfDoc.removePage(197) // Remove the 198th page of the document
     * ```
     * Once a page has been removed, it will no longer be rendered at that index
     * in the document.
     * @param index The index of the page to be removed.
     */ PDFDocument.prototype.removePage = function(index) {
        var pageCount = this.getPageCount();
        if (this.pageCount === 0) throw new (0, $7fe2d034822cb526$export$cdca06c5927ddc2d)();
        (0, $j0tvB.assertRange)(index, 'index', 0, pageCount - 1);
        this.catalog.removeLeafNode(index);
        this.pageCount = pageCount - 1;
    };
    /**
     * Add a page to the end of this document. This method accepts three
     * different value types for the `page` parameter:
     *
     * | Type               | Behavior                                                                            |
     * | ------------------ | ----------------------------------------------------------------------------------- |
     * | `undefined`        | Create a new page and add it to the end of this document                            |
     * | `[number, number]` | Create a new page with the given dimensions and add it to the end of this document  |
     * | `PDFPage`          | Add the existing page to the end of this document                                   |
     *
     * For example:
     * ```js
     * // page=undefined
     * const newPage = pdfDoc.addPage()
     *
     * // page=[number, number]
     * import { PageSizes } from 'pdf-lib'
     * const newPage1 = pdfDoc.addPage(PageSizes.A7)
     * const newPage2 = pdfDoc.addPage(PageSizes.Letter)
     * const newPage3 = pdfDoc.addPage([500, 750])
     *
     * // page=PDFPage
     * const pdfDoc1 = await PDFDocument.create()
     * const pdfDoc2 = await PDFDocument.load(...)
     * const [existingPage] = await pdfDoc1.copyPages(pdfDoc2, [0])
     * pdfDoc1.addPage(existingPage)
     * ```
     *
     * @param page Optionally, the desired dimensions or existing page.
     * @returns The newly created (or existing) page.
     */ PDFDocument.prototype.addPage = function(page) {
        (0, $j0tvB.assertIs)(page, 'page', [
            'undefined',
            [
                (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039),
                'PDFPage'
            ],
            Array
        ]);
        return this.insertPage(this.getPageCount(), page);
    };
    /**
     * Insert a page at a given index within this document. This method accepts
     * three different value types for the `page` parameter:
     *
     * | Type               | Behavior                                                                       |
     * | ------------------ | ------------------------------------------------------------------------------ |
     * | `undefined`        | Create a new page and insert it into this document                             |
     * | `[number, number]` | Create a new page with the given dimensions and insert it into this document   |
     * | `PDFPage`          | Insert the existing page into this document                                    |
     *
     * For example:
     * ```js
     * // page=undefined
     * const newPage = pdfDoc.insertPage(2)
     *
     * // page=[number, number]
     * import { PageSizes } from 'pdf-lib'
     * const newPage1 = pdfDoc.insertPage(2, PageSizes.A7)
     * const newPage2 = pdfDoc.insertPage(0, PageSizes.Letter)
     * const newPage3 = pdfDoc.insertPage(198, [500, 750])
     *
     * // page=PDFPage
     * const pdfDoc1 = await PDFDocument.create()
     * const pdfDoc2 = await PDFDocument.load(...)
     * const [existingPage] = await pdfDoc1.copyPages(pdfDoc2, [0])
     * pdfDoc1.insertPage(0, existingPage)
     * ```
     *
     * @param index The index at which the page should be inserted (zero-based).
     * @param page Optionally, the desired dimensions or existing page.
     * @returns The newly created (or existing) page.
     */ PDFDocument.prototype.insertPage = function(index, page) {
        var pageCount = this.getPageCount();
        (0, $j0tvB.assertRange)(index, 'index', 0, pageCount);
        (0, $j0tvB.assertIs)(page, 'page', [
            'undefined',
            [
                (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039),
                'PDFPage'
            ],
            Array
        ]);
        if (!page || Array.isArray(page)) {
            var dims = Array.isArray(page) ? page : (0, $bdf8b405f72f9bf0$export$b4a05ae367f5515c).A4;
            page = (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039).create(this);
            page.setSize.apply(page, dims);
        } else if (page.doc !== this) throw new (0, $7fe2d034822cb526$export$9564a4d28d94eae2)();
        var parentRef = this.catalog.insertLeafNode(page.ref, index);
        page.node.setParent(parentRef);
        this.pageMap.set(page.node, page);
        this.pageCache.invalidate();
        this.pageCount = pageCount + 1;
        return page;
    };
    /**
     * Copy pages from a source document into this document. Allows pages to be
     * copied between different [[PDFDocument]] instances. For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     * const srcDoc = await PDFDocument.load(...)
     *
     * const copiedPages = await pdfDoc.copyPages(srcDoc, [0, 3, 89])
     * const [firstPage, fourthPage, ninetiethPage] = copiedPages;
     *
     * pdfDoc.addPage(fourthPage)
     * pdfDoc.insertPage(0, ninetiethPage)
     * pdfDoc.addPage(firstPage)
     * ```
     * @param srcDoc The document from which pages should be copied.
     * @param indices The indices of the pages that should be copied.
     * @returns Resolves with an array of pages copied into this document.
     */ PDFDocument.prototype.copyPages = function(srcDoc, indices) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var copier, srcPages, copiedPages, idx, len, srcPage, copiedPage, ref;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $j0tvB.assertIs)(srcDoc, 'srcDoc', [
                            [
                                PDFDocument,
                                'PDFDocument'
                            ]
                        ]);
                        (0, $j0tvB.assertIs)(indices, 'indices', [
                            Array
                        ]);
                        return [
                            4 /*yield*/ ,
                            srcDoc.flush()
                        ];
                    case 1:
                        _a.sent();
                        copier = (0, $ea102798c96bfd06$export$2e2bcd8739ae039).for(srcDoc.context, this.context);
                        srcPages = srcDoc.getPages();
                        copiedPages = new Array(indices.length);
                        for(idx = 0, len = indices.length; idx < len; idx++){
                            srcPage = srcPages[indices[idx]];
                            copiedPage = copier.copy(srcPage.node);
                            ref = this.context.register(copiedPage);
                            copiedPages[idx] = (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039).of(copiedPage, ref, this);
                        }
                        return [
                            2 /*return*/ ,
                            copiedPages
                        ];
                }
            });
        });
    };
    /**
     * Get a copy of this document.
     *
     * For example:
     * ```js
     * const srcDoc = await PDFDocument.load(...)
     * const pdfDoc = await srcDoc.copy()
     * ```
     *
     * > **NOTE:**  This method won't copy all information over to the new
     * > document (acroforms, outlines, etc...).
     *
     * @returns Resolves with a copy this document.
     */ PDFDocument.prototype.copy = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var pdfCopy, contentPages, idx, len;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            PDFDocument.create()
                        ];
                    case 1:
                        pdfCopy = _a.sent();
                        return [
                            4 /*yield*/ ,
                            pdfCopy.copyPages(this, this.getPageIndices())
                        ];
                    case 2:
                        contentPages = _a.sent();
                        for(idx = 0, len = contentPages.length; idx < len; idx++)pdfCopy.addPage(contentPages[idx]);
                        if (this.getAuthor() !== undefined) pdfCopy.setAuthor(this.getAuthor());
                        if (this.getCreationDate() !== undefined) pdfCopy.setCreationDate(this.getCreationDate());
                        if (this.getCreator() !== undefined) pdfCopy.setCreator(this.getCreator());
                        if (this.getModificationDate() !== undefined) pdfCopy.setModificationDate(this.getModificationDate());
                        if (this.getProducer() !== undefined) pdfCopy.setProducer(this.getProducer());
                        if (this.getSubject() !== undefined) pdfCopy.setSubject(this.getSubject());
                        if (this.getTitle() !== undefined) pdfCopy.setTitle(this.getTitle());
                        pdfCopy.defaultWordBreaks = this.defaultWordBreaks;
                        return [
                            2 /*return*/ ,
                            pdfCopy
                        ];
                }
            });
        });
    };
    /**
     * Add JavaScript to this document. The supplied `script` is executed when the
     * document is opened. The `script` can be used to perform some operation
     * when the document is opened (e.g. logging to the console), or it can be
     * used to define a function that can be referenced later in a JavaScript
     * action. For example:
     * ```js
     * // Show "Hello World!" in the console when the PDF is opened
     * pdfDoc.addJavaScript(
     *   'main',
     *   'console.show(); console.println("Hello World!");'
     * );
     *
     * // Define a function named "foo" that can be called in JavaScript Actions
     * pdfDoc.addJavaScript(
     *   'foo',
     *   'function foo() { return "foo"; }'
     * );
     * ```
     * See the [JavaScript for Acrobat API Reference](https://www.adobe.com/content/dam/acom/en/devnet/acrobat/pdfs/js_api_reference.pdf)
     * for details.
     * @param name The name of the script. Must be unique per document.
     * @param script The JavaScript to execute.
     */ PDFDocument.prototype.addJavaScript = function(name, script) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        (0, $j0tvB.assertIs)(script, 'script', [
            'string'
        ]);
        var embedder = (0, $60420ad6933b406d$export$2e2bcd8739ae039).for(script, name);
        var ref = this.context.nextRef();
        var javaScript = (0, $8e93f6bd1fec6f6e$export$2e2bcd8739ae039).of(ref, this, embedder);
        this.javaScripts.push(javaScript);
    };
    /**
     * Add an attachment to this document. Attachments are visible in the
     * "Attachments" panel of Adobe Acrobat and some other PDF readers. Any
     * type of file can be added as an attachment. This includes, but is not
     * limited to, `.png`, `.jpg`, `.pdf`, `.csv`, `.docx`, and `.xlsx` files.
     *
     * The input data can be provided in multiple formats:
     *
     * | Type          | Contents                                                       |
     * | ------------- | -------------------------------------------------------------- |
     * | `string`      | A base64 encoded string (or data URI) containing an attachment |
     * | `Uint8Array`  | The raw bytes of an attachment                                 |
     * | `ArrayBuffer` | The raw bytes of an attachment                                 |
     *
     * For example:
     * ```js
     * // attachment=string
     * await pdfDoc.attach('/9j/4AAQSkZJRgABAQAAAQABAAD/2wBD...', 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     * await pdfDoc.attach('data:image/jpeg;base64,/9j/4AAQ...', 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     *
     * // attachment=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('cat_riding_unicorn.jpg')
     * await pdfDoc.attach(uint8Array, 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     *
     * // attachment=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * await pdfDoc.attach(arrayBuffer, 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     * ```
     *
     * @param attachment The input data containing the file to be attached.
     * @param name The name of the file to be attached.
     * @returns Resolves when the attachment is complete.
     */ PDFDocument.prototype.attach = function(attachment, name, options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, embeddedFile;
            return (0, $cOQTW.__generator)(this, function(_a) {
                (0, $j0tvB.assertIs)(attachment, 'attachment', [
                    'string',
                    Uint8Array,
                    ArrayBuffer
                ]);
                (0, $j0tvB.assertIs)(name, 'name', [
                    'string'
                ]);
                (0, $j0tvB.assertOrUndefined)(options.mimeType, 'mimeType', [
                    'string'
                ]);
                (0, $j0tvB.assertOrUndefined)(options.description, 'description', [
                    'string'
                ]);
                (0, $j0tvB.assertOrUndefined)(options.creationDate, 'options.creationDate', [
                    Date
                ]);
                (0, $j0tvB.assertOrUndefined)(options.modificationDate, 'options.modificationDate', [
                    Date
                ]);
                (0, $j0tvB.assertIsOneOfOrUndefined)(options.afRelationship, 'options.afRelationship', (0, $03c8546b8537a071$export$c12eac46fbec1b74));
                bytes = (0, $4ISq8.toUint8Array)(attachment);
                embedder = (0, $03c8546b8537a071$export$2e2bcd8739ae039).for(bytes, name, options);
                ref = this.context.nextRef();
                embeddedFile = (0, $072855dc9321c2b4$export$2e2bcd8739ae039).of(ref, this, embedder);
                this.embeddedFiles.push(embeddedFile);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Embed a font into this document. The input data can be provided in multiple
     * formats:
     *
     * | Type            | Contents                                                |
     * | --------------- | ------------------------------------------------------- |
     * | `StandardFonts` | One of the standard 14 fonts                            |
     * | `string`        | A base64 encoded string (or data URI) containing a font |
     * | `Uint8Array`    | The raw bytes of a font                                 |
     * | `ArrayBuffer`   | The raw bytes of a font                                 |
     *
     * For example:
     * ```js
     * // font=StandardFonts
     * import { StandardFonts } from 'pdf-lib'
     * const font1 = await pdfDoc.embedFont(StandardFonts.Helvetica)
     *
     * // font=string
     * const font2 = await pdfDoc.embedFont('AAEAAAAVAQAABABQRFNJRx/upe...')
     * const font3 = await pdfDoc.embedFont('data:font/opentype;base64,AAEAAA...')
     *
     * // font=Uint8Array
     * import fs from 'fs'
     * const font4 = await pdfDoc.embedFont(fs.readFileSync('Ubuntu-R.ttf'))
     *
     * // font=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/ubuntu/Ubuntu-R.ttf'
     * const ubuntuBytes = await fetch(url).then(res => res.arrayBuffer())
     * const font5 = await pdfDoc.embedFont(ubuntuBytes)
     * ```
     * See also: [[registerFontkit]]
     * @param font The input data for a font.
     * @param options The options to be used when embedding the font.
     * @returns Resolves with the embedded font.
     */ PDFDocument.prototype.embedFont = function(font, options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, subset, customName, features, embedder, bytes, fontkit, _b, ref, pdfFont;
            return (0, $cOQTW.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = options.subset, subset = _a === void 0 ? false : _a, customName = options.customName, features = options.features;
                        (0, $j0tvB.assertIs)(font, 'font', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        (0, $j0tvB.assertIs)(subset, 'subset', [
                            'boolean'
                        ]);
                        if (!(0, $cbIAG.isStandardFont)(font)) return [
                            3 /*break*/ ,
                            1
                        ];
                        embedder = (0, $e3698d9fec5e57b0$export$2e2bcd8739ae039).for(font, customName);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 1:
                        if (!(0, $4ISq8.canBeConvertedToUint8Array)(font)) return [
                            3 /*break*/ ,
                            6
                        ];
                        bytes = (0, $4ISq8.toUint8Array)(font);
                        fontkit = this.assertFontkit();
                        if (!subset) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $4bb3e5ce3694dd68$export$2e2bcd8739ae039).for(fontkit, bytes, customName, features)
                        ];
                    case 2:
                        _b = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            (0, $c1a3ddaa0f08fc18$export$2e2bcd8739ae039).for(fontkit, bytes, customName, features)
                        ];
                    case 4:
                        _b = _c.sent();
                        _c.label = 5;
                    case 5:
                        embedder = _b;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        throw new TypeError('`font` must be one of `StandardFonts | string | Uint8Array | ArrayBuffer`');
                    case 7:
                        ref = this.context.nextRef();
                        pdfFont = (0, $fb353673e42bee9b$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.fonts.push(pdfFont);
                        return [
                            2 /*return*/ ,
                            pdfFont
                        ];
                }
            });
        });
    };
    /**
     * Embed a standard font into this document.
     * For example:
     * ```js
     * import { StandardFonts } from 'pdf-lib'
     * const helveticaFont = pdfDoc.embedFont(StandardFonts.Helvetica)
     * ```
     * @param font The standard font to be embedded.
     * @param customName The name to be used when embedding the font.
     * @returns The embedded font.
     */ PDFDocument.prototype.embedStandardFont = function(font, customName) {
        (0, $j0tvB.assertIs)(font, 'font', [
            'string'
        ]);
        if (!(0, $cbIAG.isStandardFont)(font)) throw new TypeError('`font` must be one of type `StandardFonts`');
        var embedder = (0, $e3698d9fec5e57b0$export$2e2bcd8739ae039).for(font, customName);
        var ref = this.context.nextRef();
        var pdfFont = (0, $fb353673e42bee9b$export$2e2bcd8739ae039).of(ref, this, embedder);
        this.fonts.push(pdfFont);
        return pdfFont;
    };
    /**
     * Embed a JPEG image into this document. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                                      |
     * | ------------- | ------------------------------------------------------------- |
     * | `string`      | A base64 encoded string (or data URI) containing a JPEG image |
     * | `Uint8Array`  | The raw bytes of a JPEG image                                 |
     * | `ArrayBuffer` | The raw bytes of a JPEG image                                 |
     *
     * For example:
     * ```js
     * // jpg=string
     * const image1 = await pdfDoc.embedJpg('/9j/4AAQSkZJRgABAQAAAQABAAD/2wBD...')
     * const image2 = await pdfDoc.embedJpg('data:image/jpeg;base64,/9j/4AAQ...')
     *
     * // jpg=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('cat_riding_unicorn.jpg')
     * const image3 = await pdfDoc.embedJpg(uint8Array)
     *
     * // jpg=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const image4 = await pdfDoc.embedJpg(arrayBuffer)
     * ```
     *
     * @param jpg The input data for a JPEG image.
     * @returns Resolves with the embedded image.
     */ PDFDocument.prototype.embedJpg = function(jpg) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, pdfImage;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $j0tvB.assertIs)(jpg, 'jpg', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        bytes = (0, $4ISq8.toUint8Array)(jpg);
                        return [
                            4 /*yield*/ ,
                            (0, $b2f30d23c2f107ea$export$2e2bcd8739ae039).for(bytes)
                        ];
                    case 1:
                        embedder = _a.sent();
                        ref = this.context.nextRef();
                        pdfImage = (0, $593e57425d0dad5a$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.images.push(pdfImage);
                        return [
                            2 /*return*/ ,
                            pdfImage
                        ];
                }
            });
        });
    };
    /**
     * Embed a PNG image into this document. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                                     |
     * | ------------- | ------------------------------------------------------------ |
     * | `string`      | A base64 encoded string (or data URI) containing a PNG image |
     * | `Uint8Array`  | The raw bytes of a PNG image                                 |
     * | `ArrayBuffer` | The raw bytes of a PNG image                                 |
     *
     * For example:
     * ```js
     * // png=string
     * const image1 = await pdfDoc.embedPng('iVBORw0KGgoAAAANSUhEUgAAAlgAAAF3...')
     * const image2 = await pdfDoc.embedPng('data:image/png;base64,iVBORw0KGg...')
     *
     * // png=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('small_mario.png')
     * const image3 = await pdfDoc.embedPng(uint8Array)
     *
     * // png=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/small_mario.png'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const image4 = await pdfDoc.embedPng(arrayBuffer)
     * ```
     *
     * @param png The input data for a PNG image.
     * @returns Resolves with the embedded image.
     */ PDFDocument.prototype.embedPng = function(png) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, pdfImage;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $j0tvB.assertIs)(png, 'png', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        bytes = (0, $4ISq8.toUint8Array)(png);
                        return [
                            4 /*yield*/ ,
                            (0, $79f8a6e417146498$export$2e2bcd8739ae039).for(bytes)
                        ];
                    case 1:
                        embedder = _a.sent();
                        ref = this.context.nextRef();
                        pdfImage = (0, $593e57425d0dad5a$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.images.push(pdfImage);
                        return [
                            2 /*return*/ ,
                            pdfImage
                        ];
                }
            });
        });
    };
    /**
     * Embed one or more PDF pages into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourcePdf = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     *
     * // Embed page 74 of `sourcePdf` into `pdfDoc`
     * const [embeddedPage] = await pdfDoc.embedPdf(sourcePdf, [73])
     * ```
     *
     * See [[PDFDocument.load]] for examples of the allowed input data formats.
     *
     * @param pdf The input data containing a PDF document.
     * @param indices The indices of the pages that should be embedded.
     * @returns Resolves with an array of the embedded pages.
     */ PDFDocument.prototype.embedPdf = function(pdf, indices) {
        if (indices === void 0) indices = [
            0
        ];
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var srcDoc, _a, srcPages;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (0, $j0tvB.assertIs)(pdf, 'pdf', [
                            'string',
                            Uint8Array,
                            ArrayBuffer,
                            [
                                PDFDocument,
                                'PDFDocument'
                            ]
                        ]);
                        (0, $j0tvB.assertIs)(indices, 'indices', [
                            Array
                        ]);
                        if (!(pdf instanceof PDFDocument)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = pdf;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            PDFDocument.load(pdf)
                        ];
                    case 2:
                        _a = _b.sent();
                        _b.label = 3;
                    case 3:
                        srcDoc = _a;
                        srcPages = (0, $4ISq8.pluckIndices)(srcDoc.getPages(), indices);
                        return [
                            2 /*return*/ ,
                            this.embedPages(srcPages)
                        ];
                }
            });
        });
    };
    /**
     * Embed a single PDF page into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourceBuffer = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     * const sourcePdfDoc = await PDFDocument.load(sourceBuffer)
     * const sourcePdfPage = sourcePdfDoc.getPages()[73]
     *
     * const embeddedPage = await pdfDoc.embedPage(
     *   sourcePdfPage,
     *
     *   // Clip a section of the source page so that we only embed part of it
     *   { left: 100, right: 450, bottom: 330, top: 570 },
     *
     *   // Translate all drawings of the embedded page by (10, 200) units
     *   [1, 0, 0, 1, 10, 200],
     * )
     * ```
     *
     * @param page The page to be embedded.
     * @param boundingBox
     * Optionally, an area of the source page that should be embedded
     * (defaults to entire page).
     * @param transformationMatrix
     * Optionally, a transformation matrix that is always applied to the embedded
     * page anywhere it is drawn.
     * @returns Resolves with the embedded pdf page.
     */ PDFDocument.prototype.embedPage = function(page, boundingBox, transformationMatrix) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var embeddedPage;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $j0tvB.assertIs)(page, 'page', [
                            [
                                (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039),
                                'PDFPage'
                            ]
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.embedPages([
                                page
                            ], [
                                boundingBox
                            ], [
                                transformationMatrix
                            ])
                        ];
                    case 1:
                        embeddedPage = _a.sent()[0];
                        return [
                            2 /*return*/ ,
                            embeddedPage
                        ];
                }
            });
        });
    };
    /**
     * Embed one or more PDF pages into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourceBuffer = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     * const sourcePdfDoc = await PDFDocument.load(sourceBuffer)
     *
     * const page1 = sourcePdfDoc.getPages()[0]
     * const page2 = sourcePdfDoc.getPages()[52]
     * const page3 = sourcePdfDoc.getPages()[73]
     *
     * const embeddedPages = await pdfDoc.embedPages([page1, page2, page3])
     * ```
     *
     * @param page
     * The pages to be embedded (they must all share the same context).
     * @param boundingBoxes
     * Optionally, an array of clipping boundaries - one for each page
     * (defaults to entirety of each page).
     * @param transformationMatrices
     * Optionally, an array of transformation matrices - one for each page
     * (each page's transformation will apply anywhere it is drawn).
     * @returns Resolves with an array of the embedded pdf pages.
     */ PDFDocument.prototype.embedPages = function(pages, boundingBoxes, transformationMatrices) {
        if (boundingBoxes === void 0) boundingBoxes = [];
        if (transformationMatrices === void 0) transformationMatrices = [];
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var idx, len, currPage, nextPage, context, maybeCopyPage, embeddedPages, idx, len, page, box, matrix, embedder, ref;
            var _a;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (pages.length === 0) return [
                            2 /*return*/ ,
                            []
                        ];
                        // Assert all pages have the same context
                        for(idx = 0, len = pages.length - 1; idx < len; idx++){
                            currPage = pages[idx];
                            nextPage = pages[idx + 1];
                            if (currPage.node.context !== nextPage.node.context) throw new (0, $nAWRe.PageEmbeddingMismatchedContextError)();
                        }
                        context = pages[0].node.context;
                        maybeCopyPage = context === this.context ? function(p) {
                            return p;
                        } : (0, $ea102798c96bfd06$export$2e2bcd8739ae039).for(context, this.context).copy;
                        embeddedPages = new Array(pages.length);
                        idx = 0, len = pages.length;
                        _b.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        page = maybeCopyPage(pages[idx].node);
                        box = boundingBoxes[idx];
                        matrix = transformationMatrices[idx];
                        return [
                            4 /*yield*/ ,
                            (0, $c7d58da35b52112a$export$2e2bcd8739ae039).for(page, box, matrix)
                        ];
                    case 2:
                        embedder = _b.sent();
                        ref = this.context.nextRef();
                        embeddedPages[idx] = (0, $f38ed62eeee08801$export$2e2bcd8739ae039).of(ref, this, embedder);
                        _b.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        (_a = this.embeddedPages).push.apply(_a, embeddedPages);
                        return [
                            2 /*return*/ ,
                            embeddedPages
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You shouldn't need to call this method directly. The [[save]]
     * > and [[saveAsBase64]] methods will automatically ensure that all embedded
     * > assets are flushed before serializing the document.
     *
     * Flush all embedded fonts, PDF pages, and images to this document's
     * [[context]].
     *
     * @returns Resolves when the flush is complete.
     */ PDFDocument.prototype.flush = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.fonts)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.images)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.embeddedPages)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.embeddedFiles)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.javaScripts)
                        ];
                    case 5:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Serialize this document to an array of bytes making up a PDF file.
     * For example:
     * ```js
     * const pdfBytes = await pdfDoc.save()
     * ```
     *
     * There are a number of things you can do with the serialized document,
     * depending on the JavaScript environment you're running in:
     * * Write it to a file in Node or React Native
     * * Download it as a Blob in the browser
     * * Render it in an `iframe`
     *
     * @param options The options to be used when saving the document.
     * @returns Resolves with the bytes of the serialized document.
     */ PDFDocument.prototype.save = function(options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, useObjectStreams, _b, addDefaultPage, _c, objectsPerTick, _d, updateFieldAppearances, form, Writer;
            return (0, $cOQTW.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.useObjectStreams, useObjectStreams = _a === void 0 ? true : _a, _b = options.addDefaultPage, addDefaultPage = _b === void 0 ? true : _b, _c = options.objectsPerTick, objectsPerTick = _c === void 0 ? 50 : _c, _d = options.updateFieldAppearances, updateFieldAppearances = _d === void 0 ? true : _d;
                        (0, $j0tvB.assertIs)(useObjectStreams, 'useObjectStreams', [
                            'boolean'
                        ]);
                        (0, $j0tvB.assertIs)(addDefaultPage, 'addDefaultPage', [
                            'boolean'
                        ]);
                        (0, $j0tvB.assertIs)(objectsPerTick, 'objectsPerTick', [
                            'number'
                        ]);
                        (0, $j0tvB.assertIs)(updateFieldAppearances, 'updateFieldAppearances', [
                            'boolean'
                        ]);
                        if (addDefaultPage && this.getPageCount() === 0) this.addPage();
                        if (updateFieldAppearances) {
                            form = this.formCache.getValue();
                            if (form) form.updateFieldAppearances();
                        }
                        return [
                            4 /*yield*/ ,
                            this.flush()
                        ];
                    case 1:
                        _e.sent();
                        Writer = useObjectStreams ? (0, $5cd89dbe12e59987$export$2e2bcd8739ae039) : (0, $4261dca68d44d2dc$export$2e2bcd8739ae039);
                        return [
                            2 /*return*/ ,
                            Writer.forContext(this.context, objectsPerTick).serializeToBuffer()
                        ];
                }
            });
        });
    };
    /**
     * Serialize this document to a base64 encoded string or data URI making up a
     * PDF file. For example:
     * ```js
     * const base64String = await pdfDoc.saveAsBase64()
     * base64String // => 'JVBERi0xLjcKJYGBgYEKC...'
     *
     * const base64DataUri = await pdfDoc.saveAsBase64({ dataUri: true })
     * base64DataUri // => 'data:application/pdf;base64,JVBERi0xLjcKJYGBgYEKC...'
     * ```
     *
     * @param options The options to be used when saving the document.
     * @returns Resolves with a base64 encoded string or data URI of the
     *          serialized document.
     */ PDFDocument.prototype.saveAsBase64 = function(options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, dataUri, otherOptions, bytes, base64;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = options.dataUri, dataUri = _a === void 0 ? false : _a, otherOptions = (0, $cOQTW.__rest)(options, [
                            "dataUri"
                        ]);
                        (0, $j0tvB.assertIs)(dataUri, 'dataUri', [
                            'boolean'
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.save(otherOptions)
                        ];
                    case 1:
                        bytes = _b.sent();
                        base64 = (0, $fZ8o5.encodeToBase64)(bytes);
                        return [
                            2 /*return*/ ,
                            dataUri ? "data:application/pdf;base64," + base64 : base64
                        ];
                }
            });
        });
    };
    PDFDocument.prototype.findPageForAnnotationRef = function(ref) {
        var pages = this.getPages();
        for(var idx = 0, len = pages.length; idx < len; idx++){
            var page = pages[idx];
            var annotations = page.node.Annots();
            if ((annotations === null || annotations === void 0 ? void 0 : annotations.indexOf(ref)) !== undefined) return page;
        }
        return undefined;
    };
    PDFDocument.prototype.embedAll = function(embeddables) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var idx, len;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        idx = 0, len = embeddables.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            embeddables[idx].embed()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFDocument.prototype.updateInfoDict = function() {
        var pdfLib = "pdf-lib (https://github.com/Hopding/pdf-lib)";
        var now = new Date();
        var info = this.getInfoDict();
        this.setProducer(pdfLib);
        this.setModificationDate(now);
        if (!info.get((0, $dPHSK.default).of('Creator'))) this.setCreator(pdfLib);
        if (!info.get((0, $dPHSK.default).of('CreationDate'))) this.setCreationDate(now);
    };
    PDFDocument.prototype.getInfoDict = function() {
        var existingInfo = this.context.lookup(this.context.trailerInfo.Info);
        if (existingInfo instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) return existingInfo;
        var newInfo = this.context.obj({});
        this.context.trailerInfo.Info = this.context.register(newInfo);
        return newInfo;
    };
    PDFDocument.prototype.assertFontkit = function() {
        if (!this.fontkit) throw new (0, $7fe2d034822cb526$export$529a7c74d0636a48)();
        return this.fontkit;
    };
    return PDFDocument;
}();
var $93b2571d4e1dfe94$export$2e2bcd8739ae039 = $93b2571d4e1dfe94$var$PDFDocument;
/* tslint:disable-next-line only-arrow-functions */ function $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(pdfObject) {
    if (!(pdfObject instanceof (0, $e8537943f4279a06$export$2e2bcd8739ae039)) && !(pdfObject instanceof (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039))) throw new (0, $nAWRe.UnexpectedObjectTypeError)([
        (0, $e8537943f4279a06$export$2e2bcd8739ae039),
        (0, $5fbdc5307b6362f1$export$2e2bcd8739ae039)
    ], pdfObject);
}





var $dd8872426cc55b05$export$c9b8fe72ac71821;
(function(BlendMode) {
    BlendMode["Normal"] = "Normal";
    BlendMode["Multiply"] = "Multiply";
    BlendMode["Screen"] = "Screen";
    BlendMode["Overlay"] = "Overlay";
    BlendMode["Darken"] = "Darken";
    BlendMode["Lighten"] = "Lighten";
    BlendMode["ColorDodge"] = "ColorDodge";
    BlendMode["ColorBurn"] = "ColorBurn";
    BlendMode["HardLight"] = "HardLight";
    BlendMode["SoftLight"] = "SoftLight";
    BlendMode["Difference"] = "Difference";
    BlendMode["Exclusion"] = "Exclusion";
})($dd8872426cc55b05$export$c9b8fe72ac71821 || ($dd8872426cc55b05$export$c9b8fe72ac71821 = {}));





var $8auL6 = parcelRequire("8auL6");
var $dPHSK = parcelRequire("dPHSK");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $7Kmy8 = parcelRequire("7Kmy8");
var $cbIAG = parcelRequire("cbIAG");
/**
 * Represents a single page of a [[PDFDocument]].
 */ var $a7f75cccfbb7eb6c$var$PDFPage = /** @class */ function() {
    function PDFPage(leafNode, ref, doc) {
        this.fontSize = 24;
        this.fontColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        this.lineHeight = 24;
        this.x = 0;
        this.y = 0;
        (0, $j0tvB.assertIs)(leafNode, 'leafNode', [
            [
                (0, $a9e73b7ced5abfa4$export$2e2bcd8739ae039),
                'PDFPageLeaf'
            ]
        ]);
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $f1233b848bc26abe$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $93b2571d4e1dfe94$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        this.node = leafNode;
        this.ref = ref;
        this.doc = doc;
    }
    /**
     * Rotate this page by a multiple of 90 degrees. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * page.setRotation(degrees(-90))
     * page.setRotation(degrees(0))
     * page.setRotation(degrees(90))
     * page.setRotation(degrees(180))
     * page.setRotation(degrees(270))
     * ```
     * @param angle The angle to rotate this page.
     */ PDFPage.prototype.setRotation = function(angle) {
        var degreesAngle = (0, $3b4f8728c2695c8d$export$56cb859c01fa134d)(angle);
        (0, $j0tvB.assertMultiple)(degreesAngle, 'degreesAngle', 90);
        this.node.set((0, $dPHSK.default).of('Rotate'), this.doc.context.obj(degreesAngle));
    };
    /**
     * Get this page's rotation angle in degrees. For example:
     * ```js
     * const rotationAngle = page.getRotation().angle;
     * ```
     * @returns The rotation angle of the page in degrees (always a multiple of
     *          90 degrees).
     */ PDFPage.prototype.getRotation = function() {
        var Rotate = this.node.Rotate();
        return (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(Rotate ? Rotate.asNumber() : 0);
    };
    /**
     * Resize this page by increasing or decreasing its width and height. For
     * example:
     * ```js
     * page.setSize(250, 500)
     * page.setSize(page.getWidth() + 50, page.getHeight() + 100)
     * page.setSize(page.getWidth() - 50, page.getHeight() - 100)
     * ```
     *
     * Note that the PDF specification does not allow for pages to have explicit
     * widths and heights. Instead it defines the "size" of a page in terms of
     * five rectangles: the MediaBox, CropBox, BleedBox, TrimBox, and ArtBox. As a
     * result, this method cannot directly change the width and height of a page.
     * Instead, it works by adjusting these five boxes.
     *
     * This method performs the following steps:
     *   1. Set width & height of MediaBox.
     *   2. Set width & height of CropBox, if it has same dimensions as MediaBox.
     *   3. Set width & height of BleedBox, if it has same dimensions as MediaBox.
     *   4. Set width & height of TrimBox, if it has same dimensions as MediaBox.
     *   5. Set width & height of ArtBox, if it has same dimensions as MediaBox.
     *
     * This approach works well for most PDF documents as all PDF pages must
     * have a MediaBox, but relatively few have a CropBox, BleedBox, TrimBox, or
     * ArtBox. And when they do have these additional boxes, they often have the
     * same dimensions as the MediaBox. However, if you find this method does not
     * work for your document, consider setting the boxes directly:
     *   * [[PDFPage.setMediaBox]]
     *   * [[PDFPage.setCropBox]]
     *   * [[PDFPage.setBleedBox]]
     *   * [[PDFPage.setTrimBox]]
     *   * [[PDFPage.setArtBox]]
     *
     * @param width The new width of the page.
     * @param height The new height of the page.
     */ PDFPage.prototype.setSize = function(width, height) {
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var mediaBox = this.getMediaBox();
        this.setMediaBox(mediaBox.x, mediaBox.y, width, height);
        var cropBox = this.getCropBox();
        var bleedBox = this.getBleedBox();
        var trimBox = this.getTrimBox();
        var artBox = this.getArtBox();
        var hasCropBox = this.node.CropBox();
        var hasBleedBox = this.node.BleedBox();
        var hasTrimBox = this.node.TrimBox();
        var hasArtBox = this.node.ArtBox();
        if (hasCropBox && (0, $cbIAG.rectanglesAreEqual)(cropBox, mediaBox)) this.setCropBox(mediaBox.x, mediaBox.y, width, height);
        if (hasBleedBox && (0, $cbIAG.rectanglesAreEqual)(bleedBox, mediaBox)) this.setBleedBox(mediaBox.x, mediaBox.y, width, height);
        if (hasTrimBox && (0, $cbIAG.rectanglesAreEqual)(trimBox, mediaBox)) this.setTrimBox(mediaBox.x, mediaBox.y, width, height);
        if (hasArtBox && (0, $cbIAG.rectanglesAreEqual)(artBox, mediaBox)) this.setArtBox(mediaBox.x, mediaBox.y, width, height);
    };
    /**
     * Resize this page by increasing or decreasing its width. For example:
     * ```js
     * page.setWidth(250)
     * page.setWidth(page.getWidth() + 50)
     * page.setWidth(page.getWidth() - 50)
     * ```
     *
     * This method uses [[PDFPage.setSize]] to set the page's width.
     *
     * @param width The new width of the page.
     */ PDFPage.prototype.setWidth = function(width) {
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        this.setSize(width, this.getSize().height);
    };
    /**
     * Resize this page by increasing or decreasing its height. For example:
     * ```js
     * page.setHeight(500)
     * page.setHeight(page.getWidth() + 100)
     * page.setHeight(page.getWidth() - 100)
     * ```
     *
     * This method uses [[PDFPage.setSize]] to set the page's height.
     *
     * @param height The new height of the page.
     */ PDFPage.prototype.setHeight = function(height) {
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        this.setSize(this.getSize().width, height);
    };
    /**
     * Set the MediaBox of this page. For example:
     * ```js
     * const mediaBox = page.getMediaBox()
     *
     * page.setMediaBox(0, 0, 250, 500)
     * page.setMediaBox(mediaBox.x, mediaBox.y, 50, 100)
     * page.setMediaBox(15, 5, mediaBox.width - 50, mediaBox.height - 100)
     * ```
     *
     * See [[PDFPage.getMediaBox]] for details about what the MediaBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new MediaBox.
     * @param y The y coordinate of the lower left corner of the new MediaBox.
     * @param width The width of the new MediaBox.
     * @param height The height of the new MediaBox.
     */ PDFPage.prototype.setMediaBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var mediaBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).MediaBox, mediaBox);
    };
    /**
     * Set the CropBox of this page. For example:
     * ```js
     * const cropBox = page.getCropBox()
     *
     * page.setCropBox(0, 0, 250, 500)
     * page.setCropBox(cropBox.x, cropBox.y, 50, 100)
     * page.setCropBox(15, 5, cropBox.width - 50, cropBox.height - 100)
     * ```
     *
     * See [[PDFPage.getCropBox]] for details about what the CropBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new CropBox.
     * @param y The y coordinate of the lower left corner of the new CropBox.
     * @param width The width of the new CropBox.
     * @param height The height of the new CropBox.
     */ PDFPage.prototype.setCropBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var cropBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).CropBox, cropBox);
    };
    /**
     * Set the BleedBox of this page. For example:
     * ```js
     * const bleedBox = page.getBleedBox()
     *
     * page.setBleedBox(0, 0, 250, 500)
     * page.setBleedBox(bleedBox.x, bleedBox.y, 50, 100)
     * page.setBleedBox(15, 5, bleedBox.width - 50, bleedBox.height - 100)
     * ```
     *
     * See [[PDFPage.getBleedBox]] for details about what the BleedBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new BleedBox.
     * @param y The y coordinate of the lower left corner of the new BleedBox.
     * @param width The width of the new BleedBox.
     * @param height The height of the new BleedBox.
     */ PDFPage.prototype.setBleedBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var bleedBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).BleedBox, bleedBox);
    };
    /**
     * Set the TrimBox of this page. For example:
     * ```js
     * const trimBox = page.getTrimBox()
     *
     * page.setTrimBox(0, 0, 250, 500)
     * page.setTrimBox(trimBox.x, trimBox.y, 50, 100)
     * page.setTrimBox(15, 5, trimBox.width - 50, trimBox.height - 100)
     * ```
     *
     * See [[PDFPage.getTrimBox]] for details about what the TrimBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new TrimBox.
     * @param y The y coordinate of the lower left corner of the new TrimBox.
     * @param width The width of the new TrimBox.
     * @param height The height of the new TrimBox.
     */ PDFPage.prototype.setTrimBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var trimBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).TrimBox, trimBox);
    };
    /**
     * Set the ArtBox of this page. For example:
     * ```js
     * const artBox = page.getArtBox()
     *
     * page.setArtBox(0, 0, 250, 500)
     * page.setArtBox(artBox.x, artBox.y, 50, 100)
     * page.setArtBox(15, 5, artBox.width - 50, artBox.height - 100)
     * ```
     *
     * See [[PDFPage.getArtBox]] for details about what the ArtBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new ArtBox.
     * @param y The y coordinate of the lower left corner of the new ArtBox.
     * @param width The width of the new ArtBox.
     * @param height The height of the new ArtBox.
     */ PDFPage.prototype.setArtBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var artBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).ArtBox, artBox);
    };
    /**
     * Get this page's width and height. For example:
     * ```js
     * const { width, height } = page.getSize()
     * ```
     *
     * This method uses [[PDFPage.getMediaBox]] to obtain the page's
     * width and height.
     *
     * @returns The width and height of the page.
     */ PDFPage.prototype.getSize = function() {
        var _a = this.getMediaBox(), width = _a.width, height = _a.height;
        return {
            width: width,
            height: height
        };
    };
    /**
     * Get this page's width. For example:
     * ```js
     * const width = page.getWidth()
     * ```
     *
     * This method uses [[PDFPage.getSize]] to obtain the page's size.
     *
     * @returns The width of the page.
     */ PDFPage.prototype.getWidth = function() {
        return this.getSize().width;
    };
    /**
     * Get this page's height. For example:
     * ```js
     * const height = page.getHeight()
     * ```
     *
     * This method uses [[PDFPage.getSize]] to obtain the page's size.
     *
     * @returns The height of the page.
     */ PDFPage.prototype.getHeight = function() {
        return this.getSize().height;
    };
    /**
     * Get the rectangle defining this page's MediaBox. For example:
     * ```js
     * const { x, y, width, height } = page.getMediaBox()
     * ```
     *
     * The MediaBox of a page defines the boundaries of the physical medium on
     * which the page is to be displayed/printed. It may include extended area
     * surrounding the page content for bleed marks, printing marks, etc...
     * It may also include areas close to the edges of the medium that cannot be
     * marked because of physical limitations of the output device. Content
     * falling outside this boundary may safely be discarded without affecting
     * the meaning of the PDF file.
     *
     * @returns An object defining the lower left corner of the MediaBox and its
     *          width & height.
     */ PDFPage.prototype.getMediaBox = function() {
        var mediaBox = this.node.MediaBox();
        return mediaBox.asRectangle();
    };
    /**
     * Get the rectangle defining this page's CropBox. For example:
     * ```js
     * const { x, y, width, height } = page.getCropBox()
     * ```
     *
     * The CropBox of a page defines the region to which the contents of the page
     * shall be clipped when displayed or printed. Unlike the other boxes, the
     * CropBox does not necessarily represent the physical page geometry. It
     * merely imposes clipping on the page contents.
     *
     * The CropBox's default value is the page's MediaBox.
     *
     * @returns An object defining the lower left corner of the CropBox and its
     *          width & height.
     */ PDFPage.prototype.getCropBox = function() {
        var _a;
        var cropBox = this.node.CropBox();
        return (_a = cropBox === null || cropBox === void 0 ? void 0 : cropBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getMediaBox();
    };
    /**
     * Get the rectangle defining this page's BleedBox. For example:
     * ```js
     * const { x, y, width, height } = page.getBleedBox()
     * ```
     *
     * The BleedBox of a page defines the region to which the contents of the
     * page shall be clipped when output in a production environment. This may
     * include any extra bleed area needed to accommodate the physical
     * limitations of cutting, folding, and trimming equipment. The actual
     * printed page may include printing marks that fall outside the BleedBox.
     *
     * The BleedBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the BleedBox and its
     *          width & height.
     */ PDFPage.prototype.getBleedBox = function() {
        var _a;
        var bleedBox = this.node.BleedBox();
        return (_a = bleedBox === null || bleedBox === void 0 ? void 0 : bleedBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Get the rectangle defining this page's TrimBox. For example:
     * ```js
     * const { x, y, width, height } = page.getTrimBox()
     * ```
     *
     * The TrimBox of a page defines the intended dimensions of the finished
     * page after trimming. It may be smaller than the MediaBox to allow for
     * production-related content, such as printing instructions, cut marks, or
     * color bars.
     *
     * The TrimBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the TrimBox and its
     *          width & height.
     */ PDFPage.prototype.getTrimBox = function() {
        var _a;
        var trimBox = this.node.TrimBox();
        return (_a = trimBox === null || trimBox === void 0 ? void 0 : trimBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Get the rectangle defining this page's ArtBox. For example:
     * ```js
     * const { x, y, width, height } = page.getArtBox()
     * ```
     *
     * The ArtBox of a page defines the extent of the page's meaningful content
     * (including potential white space).
     *
     * The ArtBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the ArtBox and its
     *          width & height.
     */ PDFPage.prototype.getArtBox = function() {
        var _a;
        var artBox = this.node.ArtBox();
        return (_a = artBox === null || artBox === void 0 ? void 0 : artBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Translate this page's content to a new location on the page. This operation
     * is often useful after resizing the page with [[setSize]]. For example:
     * ```js
     * // Add 50 units of whitespace to the top and right of the page
     * page.setSize(page.getWidth() + 50, page.getHeight() + 50)
     *
     * // Move the page's content from the lower-left corner of the page
     * // to the top-right corner.
     * page.translateContent(50, 50)
     *
     * // Now there are 50 units of whitespace to the left and bottom of the page
     * ```
     * See also: [[resetPosition]]
     * @param x The new position on the x-axis for this page's content.
     * @param y The new position on the y-axis for this page's content.
     */ PDFPage.prototype.translateContent = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        this.node.normalize();
        this.getContentStream();
        var start = this.createContentStream((0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(), (0, $cfb765e9daff3c3a$export$d73ee8ef04f5226a)(x, y));
        var startRef = this.doc.context.register(start);
        var end = this.createContentStream((0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)());
        var endRef = this.doc.context.register(end);
        this.node.wrapContentStreams(startRef, endRef);
    };
    /**
     * Scale the size, content, and annotations of a page.
     *
     * For example:
     * ```js
     * page.scale(0.5, 0.5);
     * ```
     *
     * @param x The factor by which the width for the page should be scaled
     *          (e.g. `0.5` is 50%).
     * @param y The factor by which the height for the page should be scaled
     *          (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scale = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        this.setSize(this.getWidth() * x, this.getHeight() * y);
        this.scaleContent(x, y);
        this.scaleAnnotations(x, y);
    };
    /**
     * Scale the content of a page. This is useful after resizing an existing
     * page. This scales only the content, not the annotations.
     *
     * For example:
     * ```js
     * // Bisect the size of the page
     * page.setSize(page.getWidth() / 2, page.getHeight() / 2);
     *
     * // Scale the content of the page down by 50% in x and y
     * page.scaleContent(0.5, 0.5);
     * ```
     * See also: [[scaleAnnotations]]
     * @param x The factor by which the x-axis for the content should be scaled
     *          (e.g. `0.5` is 50%).
     * @param y The factor by which the y-axis for the content should be scaled
     *          (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scaleContent = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        this.node.normalize();
        this.getContentStream();
        var start = this.createContentStream((0, $cfb765e9daff3c3a$export$cb182c48e35739ac)(), (0, $cfb765e9daff3c3a$export$dcdf75081b88279d)(x, y));
        var startRef = this.doc.context.register(start);
        var end = this.createContentStream((0, $cfb765e9daff3c3a$export$10581a6f45bf75eb)());
        var endRef = this.doc.context.register(end);
        this.node.wrapContentStreams(startRef, endRef);
    };
    /**
     * Scale the annotations of a page. This is useful if you want to scale a
     * page with comments or other annotations.
     * ```js
     * // Scale the content of the page down by 50% in x and y
     * page.scaleContent(0.5, 0.5);
     *
     * // Scale the content of the page down by 50% in x and y
     * page.scaleAnnotations(0.5, 0.5);
     * ```
     * See also: [[scaleContent]]
     * @param x The factor by which the x-axis for the annotations should be
     *          scaled (e.g. `0.5` is 50%).
     * @param y The factor by which the y-axis for the annotations should be
     *          scaled (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scaleAnnotations = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        var annots = this.node.Annots();
        if (!annots) return;
        for(var idx = 0; idx < annots.size(); idx++){
            var annot = annots.lookup(idx);
            if (annot instanceof (0, $85408478fbb7cbde$export$2e2bcd8739ae039)) this.scaleAnnot(annot, x, y);
        }
    };
    /**
     * Reset the x and y coordinates of this page to `(0, 0)`. This operation is
     * often useful after calling [[translateContent]]. For example:
     * ```js
     * // Shift the page's contents up and to the right by 50 units
     * page.translateContent(50, 50)
     *
     * // This text will shifted - it will be drawn at (50, 50)
     * page.drawText('I am shifted')
     *
     * // Move back to (0, 0)
     * page.resetPosition()
     *
     * // This text will not be shifted - it will be drawn at (0, 0)
     * page.drawText('I am not shifted')
     * ```
     */ PDFPage.prototype.resetPosition = function() {
        this.getContentStream(false);
        this.x = 0;
        this.y = 0;
    };
    /**
     * Choose a default font for this page. The default font will be used whenever
     * text is drawn on this page and no font is specified. For example:
     * ```js
     * import { StandardFonts } from 'pdf-lib'
     *
     * const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)
     * const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const courierFont = await pdfDoc.embedFont(StandardFonts.Courier)
     *
     * const page = pdfDoc.addPage()
     *
     * page.setFont(helveticaFont)
     * page.drawText('I will be drawn in Helvetica')
     *
     * page.setFont(timesRomanFont)
     * page.drawText('I will be drawn in Courier', { font: courierFont })
     * ```
     * @param font The default font to be used when drawing text on this page.
     */ PDFPage.prototype.setFont = function(font) {
        // TODO: Reuse image Font name if we've already added this image to Resources.Fonts
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.font = font;
        this.fontKey = this.node.newFontDictionary(this.font.name, this.font.ref);
    };
    /**
     * Choose a default font size for this page. The default font size will be
     * used whenever text is drawn on this page and no font size is specified.
     * For example:
     * ```js
     * page.setFontSize(12)
     * page.drawText('I will be drawn in size 12')
     *
     * page.setFontSize(36)
     * page.drawText('I will be drawn in size 24', { fontSize: 24 })
     * ```
     * @param fontSize The default font size to be used when drawing text on this
     *                 page.
     */ PDFPage.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertIs)(fontSize, 'fontSize', [
            'number'
        ]);
        this.fontSize = fontSize;
    };
    /**
     * Choose a default font color for this page. The default font color will be
     * used whenever text is drawn on this page and no font color is specified.
     * For example:
     * ```js
     * import { rgb, cmyk, grayscale } from 'pdf-lib'
     *
     * page.setFontColor(rgb(0.97, 0.02, 0.97))
     * page.drawText('I will be drawn in pink')
     *
     * page.setFontColor(cmyk(0.4, 0.7, 0.39, 0.15))
     * page.drawText('I will be drawn in gray', { color: grayscale(0.5) })
     * ```
     * @param fontColor The default font color to be used when drawing text on
     *                  this page.
     */ PDFPage.prototype.setFontColor = function(fontColor) {
        (0, $j0tvB.assertIs)(fontColor, 'fontColor', [
            [
                Object,
                'Color'
            ]
        ]);
        this.fontColor = fontColor;
    };
    /**
     * Choose a default line height for this page. The default line height will be
     * used whenever text is drawn on this page and no line height is specified.
     * For example:
     * ```js
     * page.setLineHeight(12);
     * page.drawText('These lines will be vertically \n separated by 12 units')
     *
     * page.setLineHeight(36);
     * page.drawText('These lines will be vertically \n separated by 24 units', {
     *   lineHeight: 24
     * })
     * ```
     * @param lineHeight The default line height to be used when drawing text on
     *                   this page.
     */ PDFPage.prototype.setLineHeight = function(lineHeight) {
        (0, $j0tvB.assertIs)(lineHeight, 'lineHeight', [
            'number'
        ]);
        this.lineHeight = lineHeight;
    };
    /**
     * Get the default position of this page. For example:
     * ```js
     * const { x, y } = page.getPosition()
     * ```
     * @returns The default position of the page.
     */ PDFPage.prototype.getPosition = function() {
        return {
            x: this.x,
            y: this.y
        };
    };
    /**
     * Get the default x coordinate of this page. For example:
     * ```js
     * const x = page.getX()
     * ```
     * @returns The default x coordinate of the page.
     */ PDFPage.prototype.getX = function() {
        return this.x;
    };
    /**
     * Get the default y coordinate of this page. For example:
     * ```js
     * const y = page.getY()
     * ```
     * @returns The default y coordinate of the page.
     */ PDFPage.prototype.getY = function() {
        return this.y;
    };
    /**
     * Change the default position of this page. For example:
     * ```js
     * page.moveTo(0, 0)
     * page.drawText('I will be drawn at the origin')
     *
     * page.moveTo(0, 25)
     * page.drawText('I will be drawn 25 units up')
     *
     * page.moveTo(25, 25)
     * page.drawText('I will be drawn 25 units up and 25 units to the right')
     * ```
     * @param x The new default position on the x-axis for this page.
     * @param y The new default position on the y-axis for this page.
     */ PDFPage.prototype.moveTo = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        this.x = x;
        this.y = y;
    };
    /**
     * Change the default position of this page to be further down the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveDown(10)
     * page.drawText('I will be drawn at (50, 40)')
     * ```
     * @param yDecrease The amount by which the page's default position along the
     *                  y-axis should be decreased.
     */ PDFPage.prototype.moveDown = function(yDecrease) {
        (0, $j0tvB.assertIs)(yDecrease, 'yDecrease', [
            'number'
        ]);
        this.y -= yDecrease;
    };
    /**
     * Change the default position of this page to be further up the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveUp(10)
     * page.drawText('I will be drawn at (50, 60)')
     * ```
     * @param yIncrease The amount by which the page's default position along the
     *                  y-axis should be increased.
     */ PDFPage.prototype.moveUp = function(yIncrease) {
        (0, $j0tvB.assertIs)(yIncrease, 'yIncrease', [
            'number'
        ]);
        this.y += yIncrease;
    };
    /**
     * Change the default position of this page to be further left on the x-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveLeft(10)
     * page.drawText('I will be drawn at (40, 50)')
     * ```
     * @param xDecrease The amount by which the page's default position along the
     *                  x-axis should be decreased.
     */ PDFPage.prototype.moveLeft = function(xDecrease) {
        (0, $j0tvB.assertIs)(xDecrease, 'xDecrease', [
            'number'
        ]);
        this.x -= xDecrease;
    };
    /**
     * Change the default position of this page to be further right on the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveRight(10)
     * page.drawText('I will be drawn at (60, 50)')
     * ```
     * @param xIncrease The amount by which the page's default position along the
     *                  x-axis should be increased.
     */ PDFPage.prototype.moveRight = function(xIncrease) {
        (0, $j0tvB.assertIs)(xIncrease, 'xIncrease', [
            'number'
        ]);
        this.x += xIncrease;
    };
    /**
     * Push one or more operators to the end of this page's current content
     * stream. For example:
     * ```js
     * import {
     *   pushGraphicsState,
     *   moveTo,
     *   lineTo,
     *   closePath,
     *   setFillingColor,
     *   rgb,
     *   fill,
     *   popGraphicsState,
     * } from 'pdf-lib'
     *
     * // Draw a green triangle in the lower-left corner of the page
     * page.pushOperators(
     *   pushGraphicsState(),
     *   moveTo(0, 0),
     *   lineTo(100, 0),
     *   lineTo(50, 100),
     *   closePath(),
     *   setFillingColor(rgb(0.0, 1.0, 0.0)),
     *   fill(),
     *   popGraphicsState(),
     * )
     * ```
     * @param operator The operators to be pushed.
     */ PDFPage.prototype.pushOperators = function() {
        var operator = [];
        for(var _i = 0; _i < arguments.length; _i++)operator[_i] = arguments[_i];
        (0, $j0tvB.assertEachIs)(operator, 'operator', [
            [
                (0, $400c0bd11400a1c4$export$2e2bcd8739ae039),
                'PDFOperator'
            ]
        ]);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, operator);
    };
    /**
     * Draw one or more lines of text on this page. For example:
     * ```js
     * import { StandardFonts, rgb } from 'pdf-lib'
     *
     * const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)
     *
     * const page = pdfDoc.addPage()
     *
     * page.setFont(helveticaFont)
     *
     * page.moveTo(5, 200)
     * page.drawText('The Life of an Egg', { size: 36 })
     *
     * page.moveDown(36)
     * page.drawText('An Epic Tale of Woe', { size: 30 })
     *
     * page.drawText(
     *   `Humpty Dumpty sat on a wall \n` +
     *   `Humpty Dumpty had a great fall; \n` +
     *   `All the king's horses and all the king's men \n` +
     *   `Couldn't put Humpty together again. \n`,
     *   {
     *     x: 25,
     *     y: 100,
     *     font: timesRomanFont,
     *     size: 24,
     *     color: rgb(1, 0, 0),
     *     lineHeight: 24,
     *     opacity: 0.75,
     *   },
     * )
     * ```
     * @param text The text to be drawn.
     * @param options The options to be used when drawing the text.
     */ PDFPage.prototype.drawText = function(text, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (options === void 0) options = {};
        (0, $j0tvB.assertIs)(text, 'text', [
            'string'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.font, 'options.font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.size, 'options.size', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.lineHeight, 'options.lineHeight', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.maxWidth, 'options.maxWidth', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.wordBreaks, 'options.wordBreaks', [
            Array
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $dd8872426cc55b05$export$c9b8fe72ac71821));
        var _h = this.setOrEmbedFont(options.font), oldFont = _h.oldFont, newFont = _h.newFont, newFontKey = _h.newFontKey;
        var fontSize = options.size || this.fontSize;
        var wordBreaks = options.wordBreaks || this.doc.defaultWordBreaks;
        var textWidth = function(t) {
            return newFont.widthOfTextAtSize(t, fontSize);
        };
        var lines = options.maxWidth === undefined ? (0, $7Kmy8.lineSplit)((0, $7Kmy8.cleanText)(text)) : (0, $7Kmy8.breakTextIntoLines)(text, wordBreaks, options.maxWidth, textWidth);
        var encodedLines = new Array(lines.length);
        for(var idx = 0, len = lines.length; idx < len; idx++)encodedLines[idx] = newFont.encodeText(lines[idx]);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $55cf96b3448598de$export$f7b8b44d3d84bc26)(encodedLines, {
            color: (_a = options.color) !== null && _a !== void 0 ? _a : this.fontColor,
            font: newFontKey,
            size: fontSize,
            rotate: (_b = options.rotate) !== null && _b !== void 0 ? _b : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            xSkew: (_c = options.xSkew) !== null && _c !== void 0 ? _c : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            ySkew: (_d = options.ySkew) !== null && _d !== void 0 ? _d : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            x: (_e = options.x) !== null && _e !== void 0 ? _e : this.x,
            y: (_f = options.y) !== null && _f !== void 0 ? _f : this.y,
            lineHeight: (_g = options.lineHeight) !== null && _g !== void 0 ? _g : this.lineHeight,
            graphicsState: graphicsStateKey
        }));
        if (options.font) {
            if (oldFont) this.setFont(oldFont);
            else this.resetFont();
        }
    };
    /**
     * Draw an image on this page. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * const jpgUrl = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const jpgImageBytes = await fetch(jpgUrl).then((res) => res.arrayBuffer())
     *
     * const jpgImage = await pdfDoc.embedJpg(jpgImageBytes)
     * const jpgDims = jpgImage.scale(0.5)
     *
     * const page = pdfDoc.addPage()
     *
     * page.drawImage(jpgImage, {
     *   x: 25,
     *   y: 25,
     *   width: jpgDims.width,
     *   height: jpgDims.height,
     *   rotate: degrees(30),
     *   opacity: 0.75,
     * })
     * ```
     * @param image The image to be drawn.
     * @param options The options to be used when drawing the image.
     */ PDFPage.prototype.drawImage = function(image, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (options === void 0) options = {};
        // TODO: Reuse image XObject name if we've already added this image to Resources.XObjects
        (0, $j0tvB.assertIs)(image, 'image', [
            [
                (0, $593e57425d0dad5a$export$2e2bcd8739ae039),
                'PDFImage'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $dd8872426cc55b05$export$c9b8fe72ac71821));
        var xObjectKey = this.node.newXObject('Image', image.ref);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $55cf96b3448598de$export$21a059be5bfd5fb)(xObjectKey, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : image.size().width,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : image.size().height,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw an embedded PDF page on this page. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const page = pdfDoc.addPage()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourcePdf = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     *
     * // Embed page 74 from the PDF
     * const [embeddedPage] = await pdfDoc.embedPdf(sourcePdf, 73)
     *
     * page.drawPage(embeddedPage, {
     *   x: 250,
     *   y: 200,
     *   xScale: 0.5,
     *   yScale: 0.5,
     *   rotate: degrees(30),
     *   opacity: 0.75,
     * })
     * ```
     *
     * The `options` argument accepts both `width`/`height` and `xScale`/`yScale`
     * as options. Since each of these options defines the size of the drawn page,
     * if both options are given, `width` and `height` take precedence and the
     * corresponding scale variants are ignored.
     *
     * @param embeddedPage The embedded page to be drawn.
     * @param options The options to be used when drawing the embedded page.
     */ PDFPage.prototype.drawPage = function(embeddedPage, options) {
        var _a, _b, _c, _d, _e;
        if (options === void 0) options = {};
        // TODO: Reuse embeddedPage XObject name if we've already added this embeddedPage to Resources.XObjects
        (0, $j0tvB.assertIs)(embeddedPage, 'embeddedPage', [
            [
                (0, $f38ed62eeee08801$export$2e2bcd8739ae039),
                'PDFEmbeddedPage'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xScale, 'options.xScale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.yScale, 'options.yScale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $dd8872426cc55b05$export$c9b8fe72ac71821));
        var xObjectKey = this.node.newXObject('EmbeddedPdfPage', embeddedPage.ref);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        // prettier-ignore
        var xScale = options.width !== undefined ? options.width / embeddedPage.width : options.xScale !== undefined ? options.xScale : 1;
        // prettier-ignore
        var yScale = options.height !== undefined ? options.height / embeddedPage.height : options.yScale !== undefined ? options.yScale : 1;
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $55cf96b3448598de$export$f8ea28c31069cbc9)(xObjectKey, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            xScale: xScale,
            yScale: yScale,
            rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            xSkew: (_d = options.xSkew) !== null && _d !== void 0 ? _d : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            ySkew: (_e = options.ySkew) !== null && _e !== void 0 ? _e : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw an SVG path on this page. For example:
     * ```js
     * import { rgb } from 'pdf-lib'
     *
     * const svgPath = 'M 0,20 L 100,160 Q 130,200 150,120 C 190,-40 200,200 300,150 L 400,90'
     *
     * // Draw path as black line
     * page.drawSvgPath(svgPath, { x: 25, y: 75 })
     *
     * // Change border style and opacity
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 275,
     *   borderColor: rgb(0.5, 0.5, 0.5),
     *   borderWidth: 2,
     *   borderOpacity: 0.75,
     * })
     *
     * // Set fill color and opacity
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 475,
     *   color: rgb(1.0, 0, 0),
     *   opacity: 0.75,
     * })
     *
     * // Draw 50% of original size
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 675,
     *   scale: 0.5,
     * })
     * ```
     * @param path The SVG path to be drawn.
     * @param options The options to be used when drawing the SVG path.
     */ PDFPage.prototype.drawSvgPath = function(path, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (options === void 0) options = {};
        (0, $j0tvB.assertIs)(path, 'path', [
            'string'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.scale, 'options.scale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $cfb765e9daff3c3a$export$7a77bc708e50709e));
        (0, $j0tvB.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $dd8872426cc55b05$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.borderColor = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $55cf96b3448598de$export$47c8a640c39d0756)(path, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            scale: options.scale,
            rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            color: (_d = options.color) !== null && _d !== void 0 ? _d : undefined,
            borderColor: (_e = options.borderColor) !== null && _e !== void 0 ? _e : undefined,
            borderWidth: (_f = options.borderWidth) !== null && _f !== void 0 ? _f : 0,
            borderDashArray: (_g = options.borderDashArray) !== null && _g !== void 0 ? _g : undefined,
            borderDashPhase: (_h = options.borderDashPhase) !== null && _h !== void 0 ? _h : undefined,
            borderLineCap: (_j = options.borderLineCap) !== null && _j !== void 0 ? _j : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a line on this page. For example:
     * ```js
     * import { rgb } from 'pdf-lib'
     *
     * page.drawLine({
     *   start: { x: 25, y: 75 },
     *   end: { x: 125, y: 175 },
     *   thickness: 2,
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the line.
     */ PDFPage.prototype.drawLine = function(options) {
        var _a, _b, _c, _d, _e;
        (0, $j0tvB.assertIs)(options.start, 'options.start', [
            [
                Object,
                '{ x: number, y: number }'
            ]
        ]);
        (0, $j0tvB.assertIs)(options.end, 'options.end', [
            [
                Object,
                '{ x: number, y: number }'
            ]
        ]);
        (0, $j0tvB.assertIs)(options.start.x, 'options.start.x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(options.start.y, 'options.start.y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(options.end.x, 'options.end.x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(options.end.y, 'options.end.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.thickness, 'options.thickness', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.dashArray, 'options.dashArray', [
            Array
        ]);
        (0, $j0tvB.assertOrUndefined)(options.dashPhase, 'options.dashPhase', [
            'number'
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.lineCap, 'options.lineCap', (0, $cfb765e9daff3c3a$export$7a77bc708e50709e));
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $dd8872426cc55b05$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            borderOpacity: options.opacity,
            blendMode: options.blendMode
        });
        if (!('color' in options)) options.color = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $55cf96b3448598de$export$819db45aec5fcbe5)({
            start: options.start,
            end: options.end,
            thickness: (_a = options.thickness) !== null && _a !== void 0 ? _a : 1,
            color: (_b = options.color) !== null && _b !== void 0 ? _b : undefined,
            dashArray: (_c = options.dashArray) !== null && _c !== void 0 ? _c : undefined,
            dashPhase: (_d = options.dashPhase) !== null && _d !== void 0 ? _d : undefined,
            lineCap: (_e = options.lineCap) !== null && _e !== void 0 ? _e : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a rectangle on this page. For example:
     * ```js
     * import { degrees, grayscale, rgb } from 'pdf-lib'
     *
     * page.drawRectangle({
     *   x: 25,
     *   y: 75,
     *   width: 250,
     *   height: 75,
     *   rotate: degrees(-15),
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the rectangle.
     */ PDFPage.prototype.drawRectangle = function(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (options === void 0) options = {};
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $cfb765e9daff3c3a$export$7a77bc708e50709e));
        (0, $j0tvB.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $dd8872426cc55b05$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.color = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $55cf96b3448598de$export$cac848e0621718d8)({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 150,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
            color: (_j = options.color) !== null && _j !== void 0 ? _j : undefined,
            borderColor: (_k = options.borderColor) !== null && _k !== void 0 ? _k : undefined,
            borderDashArray: (_l = options.borderDashArray) !== null && _l !== void 0 ? _l : undefined,
            borderDashPhase: (_m = options.borderDashPhase) !== null && _m !== void 0 ? _m : undefined,
            graphicsState: graphicsStateKey,
            borderLineCap: (_o = options.borderLineCap) !== null && _o !== void 0 ? _o : undefined
        }));
    };
    /**
     * Draw a square on this page. For example:
     * ```js
     * import { degrees, grayscale, rgb } from 'pdf-lib'
     *
     * page.drawSquare({
     *   x: 25,
     *   y: 75,
     *   size: 100,
     *   rotate: degrees(-15),
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the square.
     */ PDFPage.prototype.drawSquare = function(options) {
        if (options === void 0) options = {};
        var size = options.size;
        (0, $j0tvB.assertOrUndefined)(size, 'size', [
            'number'
        ]);
        this.drawRectangle((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
            width: size,
            height: size
        }));
    };
    /**
     * Draw an ellipse on this page. For example:
     * ```js
     * import { grayscale, rgb } from 'pdf-lib'
     *
     * page.drawEllipse({
     *   x: 200,
     *   y: 75,
     *   xScale: 100,
     *   yScale: 50,
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the ellipse.
     */ PDFPage.prototype.drawEllipse = function(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (options === void 0) options = {};
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xScale, 'options.xScale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.yScale, 'options.yScale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $cfb765e9daff3c3a$export$7a77bc708e50709e));
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $dd8872426cc55b05$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.color = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $55cf96b3448598de$export$43c9e2bb0dc74582)({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            xScale: (_c = options.xScale) !== null && _c !== void 0 ? _c : 100,
            yScale: (_d = options.yScale) !== null && _d !== void 0 ? _d : 100,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : undefined,
            color: (_f = options.color) !== null && _f !== void 0 ? _f : undefined,
            borderColor: (_g = options.borderColor) !== null && _g !== void 0 ? _g : undefined,
            borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
            borderDashArray: (_j = options.borderDashArray) !== null && _j !== void 0 ? _j : undefined,
            borderDashPhase: (_k = options.borderDashPhase) !== null && _k !== void 0 ? _k : undefined,
            borderLineCap: (_l = options.borderLineCap) !== null && _l !== void 0 ? _l : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a circle on this page. For example:
     * ```js
     * import { grayscale, rgb } from 'pdf-lib'
     *
     * page.drawCircle({
     *   x: 200,
     *   y: 150,
     *   size: 100,
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the ellipse.
     */ PDFPage.prototype.drawCircle = function(options) {
        if (options === void 0) options = {};
        var _a = options.size, size = _a === void 0 ? 100 : _a;
        (0, $j0tvB.assertOrUndefined)(size, 'size', [
            'number'
        ]);
        this.drawEllipse((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
            xScale: size,
            yScale: size
        }));
    };
    PDFPage.prototype.setOrEmbedFont = function(font) {
        var oldFont = this.font;
        var oldFontKey = this.fontKey;
        if (font) this.setFont(font);
        else this.getFont();
        var newFont = this.font;
        var newFontKey = this.fontKey;
        return {
            oldFont: oldFont,
            oldFontKey: oldFontKey,
            newFont: newFont,
            newFontKey: newFontKey
        };
    };
    PDFPage.prototype.getFont = function() {
        if (!this.font || !this.fontKey) {
            var font = this.doc.embedStandardFont((0, $d275b823cf3c6e5b$export$7dcb046109e65a3d).Helvetica);
            this.setFont(font);
        }
        return [
            this.font,
            this.fontKey
        ];
    };
    PDFPage.prototype.resetFont = function() {
        this.font = undefined;
        this.fontKey = undefined;
    };
    PDFPage.prototype.getContentStream = function(useExisting) {
        if (useExisting === void 0) useExisting = true;
        if (useExisting && this.contentStream) return this.contentStream;
        this.contentStream = this.createContentStream();
        this.contentStreamRef = this.doc.context.register(this.contentStream);
        this.node.addContentStream(this.contentStreamRef);
        return this.contentStream;
    };
    PDFPage.prototype.createContentStream = function() {
        var operators = [];
        for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
        var dict = this.doc.context.obj({});
        var contentStream = (0, $707f21d02e4e1bf4$export$2e2bcd8739ae039).of(dict, operators);
        return contentStream;
    };
    PDFPage.prototype.maybeEmbedGraphicsState = function(options) {
        var opacity = options.opacity, borderOpacity = options.borderOpacity, blendMode = options.blendMode;
        if (opacity === undefined && borderOpacity === undefined && blendMode === undefined) return undefined;
        var graphicsState = this.doc.context.obj({
            Type: 'ExtGState',
            ca: opacity,
            CA: borderOpacity,
            BM: blendMode
        });
        var key = this.node.newExtGState('GS', graphicsState);
        return key;
    };
    PDFPage.prototype.scaleAnnot = function(annot, x, y) {
        var selectors = [
            'RD',
            'CL',
            'Vertices',
            'QuadPoints',
            'L',
            'Rect'
        ];
        for(var idx = 0, len = selectors.length; idx < len; idx++){
            var list = annot.lookup((0, $dPHSK.default).of(selectors[idx]));
            if (list instanceof (0, $8auL6.default)) list.scalePDFNumbers(x, y);
        }
        var inkLists = annot.lookup((0, $dPHSK.default).of('InkList'));
        if (inkLists instanceof (0, $8auL6.default)) for(var idx = 0, len = inkLists.size(); idx < len; idx++){
            var arr = inkLists.lookup(idx);
            if (arr instanceof (0, $8auL6.default)) arr.scalePDFNumbers(x, y);
        }
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addPage]] and [[PDFDocument.insertPage]]
     * > methods, which can create instances of [[PDFPage]] for you.
     *
     * Create an instance of [[PDFPage]] from an existing leaf node.
     *
     * @param leafNode The leaf node to be wrapped.
     * @param ref The unique reference for the page.
     * @param doc The document to which the page will belong.
     */ PDFPage.of = function(leafNode, ref, doc) {
        return new PDFPage(leafNode, ref, doc);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addPage]] and [[PDFDocument.insertPage]]
     * > methods, which can create instances of [[PDFPage]] for you.
     *
     * Create an instance of [[PDFPage]].
     *
     * @param doc The document to which the page will belong.
     */ PDFPage.create = function(doc) {
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $93b2571d4e1dfe94$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        var dummyRef = (0, $f1233b848bc26abe$export$2e2bcd8739ae039).of(-1);
        var pageLeaf = (0, $a9e73b7ced5abfa4$export$2e2bcd8739ae039).withContextAndParent(doc.context, dummyRef);
        var pageRef = doc.context.register(pageLeaf);
        return new PDFPage(pageLeaf, pageRef, doc);
    };
    return PDFPage;
}();
var $a7f75cccfbb7eb6c$export$2e2bcd8739ae039 = $a7f75cccfbb7eb6c$var$PDFPage;









parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a button field of a [[PDFForm]].
 *
 * [[PDFButton]] fields are interactive controls that users can click with their
 * mouse. This type of [[PDFField]] is not stateful. The purpose of a button
 * is to perform an action when the user clicks on it, such as opening a print
 * modal or resetting the form. Buttons are typically rectangular in shape and
 * have a text label describing the action that they perform when clicked.
 */ var $b3771f5aa96680ee$var$PDFButton = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFButton, _super);
    function PDFButton(acroPushButton, ref, doc) {
        var _this = _super.call(this, acroPushButton, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroPushButton, 'acroButton', [
            [
                (0, $0cfa6a9523f95402$export$2e2bcd8739ae039),
                'PDFAcroPushButton'
            ]
        ]);
        _this.acroField = acroPushButton;
        return _this;
    }
    /**
     * Display an image inside the bounds of this button's widgets. For example:
     * ```js
     * const pngImage = await pdfDoc.embedPng(...)
     * const button = form.getButton('some.button.field')
     * button.setImage(pngImage, ImageAlignment.Center)
     * ```
     * This will update the appearances streams for each of this button's widgets.
     * @param image The image that should be displayed.
     * @param alignment The alignment of the image.
     */ PDFButton.prototype.setImage = function(image, alignment) {
        if (alignment === void 0) alignment = (0, $c5ccd91931a24d5b$export$8efa99ca8f041e7e).Center;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var streamRef = this.createImageAppearanceStream(widget, image, alignment);
            this.updateWidgetAppearances(widget, {
                normal: streamRef
            });
        }
        this.markAsClean();
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this button. Font sizes may
     * be integer or floating point numbers. Supplying a negative font size will
     * cause this method to throw an error.
     *
     * For example:
     * ```js
     * const button = form.getButton('some.button.field')
     * button.setFontSize(4)
     * button.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFButton.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Show this button on the specified page with the given text. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const button = form.createButton('some.button.field')
     *
     * button.addToPage('Do Stuff', page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this button field.
     * @param text The text to be displayed for this button widget.
     * @param page The page to which this button widget should be added.
     * @param options The options to be used when adding this button widget.
     */ PDFButton.prototype.addToPage = function(// TODO: This needs to be optional, e.g. for image buttons
    text, page, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        (0, $j0tvB.assertOrUndefined)(text, 'text', [
            'string'
        ]);
        (0, $j0tvB.assertOrUndefined)(page, 'page', [
            [
                (0, $a7f75cccfbb7eb6c$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $9a88d5b8c9019f73$export$55643210f1835a35)(options);
        // Create a widget for this button
        var widget = this.createWidget({
            x: ((_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0) - ((_b = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _b !== void 0 ? _b : 0) / 2,
            y: ((_c = options === null || options === void 0 ? void 0 : options.y) !== null && _c !== void 0 ? _c : 0) - ((_d = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _d !== void 0 ? _d : 0) / 2,
            width: (_e = options === null || options === void 0 ? void 0 : options.width) !== null && _e !== void 0 ? _e : 100,
            height: (_f = options === null || options === void 0 ? void 0 : options.height) !== null && _f !== void 0 ? _f : 50,
            textColor: (_g = options === null || options === void 0 ? void 0 : options.textColor) !== null && _g !== void 0 ? _g : (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0, 0, 0),
            backgroundColor: (_h = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _h !== void 0 ? _h : (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0.75, 0.75, 0.75),
            borderColor: options === null || options === void 0 ? void 0 : options.borderColor,
            borderWidth: (_j = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _j !== void 0 ? _j : 0,
            rotate: (_k = options === null || options === void 0 ? void 0 : options.rotate) !== null && _k !== void 0 ? _k : (0, $3b4f8728c2695c8d$export$41fc368e1a942b97)(0),
            caption: text,
            hidden: options === null || options === void 0 ? void 0 : options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_l = options === null || options === void 0 ? void 0 : options.font) !== null && _l !== void 0 ? _l : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this button has been marked as dirty, or if any of this
     * button's widgets do not have an appearance stream. For example:
     * ```js
     * const button = form.getButton('some.button.field')
     * if (button.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this button needs an appearance update.
     */ PDFButton.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this button's widgets using
     * the default appearance provider for buttons. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const button = form.getButton('some.button.field')
     * button.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFButton.prototype.defaultUpdateAppearances = function(font) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this button's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for buttons will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const button = form.getButton('some.button.field')
     * button.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return {
     *     normal: drawButton(...),
     *     down: drawButton(...),
     *   }
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFButton.prototype.updateAppearances = function(font, provider) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $fb353673e42bee9b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
    };
    PDFButton.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $d5944ab433082972$export$68f9b19f48ffeeec);
        var appearances = (0, $d5944ab433082972$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getButton]] method, which will create an
     * > instance of [[PDFButton]] for you.
     *
     * Create an instance of [[PDFButton]] from an existing acroPushButton and ref
     *
     * @param acroPushButton The underlying `PDFAcroPushButton` for this button.
     * @param ref The unique reference for this button.
     * @param doc The document to which this button will belong.
     */ PDFButton.of = function(acroPushButton, ref, doc) {
        return new PDFButton(acroPushButton, ref, doc);
    };
    return PDFButton;
}((0, $9a88d5b8c9019f73$export$2e2bcd8739ae039));
var $b3771f5aa96680ee$export$2e2bcd8739ae039 = $b3771f5aa96680ee$var$PDFButton;




































var $37118a317aa117da$exports = {};


parcelRequire("fvYKZ");
$parcel$exportWildcard($00483d97acd1a213$exports, $37118a317aa117da$exports);


var $dPHSK = parcelRequire("dPHSK");
var $j04jt = parcelRequire("j04jt");
const $0faadd6209986a1b$var$INK = (0, $030fa0a2c4d1456e$export$8972dc0e6ad9238f)(0.05, 0.09, 0.32);
/** The standard PDF fonts only cover Latin-1: swap the characters that would otherwise throw. */ function $0faadd6209986a1b$var$safe(text) {
    return text.replace(/[‘’]/g, "'").replace(/[“”]/g, '"').replace(/[–—]/g, '-').replace(/…/g, '...').replace(/[^\x20-\x7E\xA0-\xFF]/g, '');
}
async function $0faadd6209986a1b$export$22e79b29233763fd(pdfBytes, template, values) {
    const pdf = await (0, $93b2571d4e1dfe94$export$2e2bcd8739ae039).load(pdfBytes);
    const font = await pdf.embedFont((0, $d275b823cf3c6e5b$export$7dcb046109e65a3d).Helvetica);
    const form = pdf.getForm();
    const pages = pdf.getPages();
    const plain = {
        borderWidth: 0,
        textColor: $0faadd6209986a1b$var$INK,
        font: font
    };
    /** A text field over [x0, y0, x1, y1] (top-left coordinates, as mapped), holding `text`. */ const textField = (name, page, box, text, opts = {})=>{
        const height = page.getHeight();
        const x0 = box[0] + (opts.padLeft ?? 0), y0 = box[1], x1 = box[2], y1 = box[3];
        const w = Math.max(4, x1 - x0), h = Math.max(4, y1 - y0);
        const f = form.createTextField(name);
        if (opts.comb) {
            f.setMaxLength(opts.comb);
            f.enableCombing();
        }
        const t = text ? $0faadd6209986a1b$var$safe(text) : '';
        if (t) f.setText(opts.comb ? t.slice(0, opts.comb) : t);
        f.addToPage(page, {
            ...plain,
            x: x0,
            y: height - y1,
            width: w,
            height: h
        });
        let size = Math.min(10, h * 0.62);
        if (!opts.comb) while(t && size > 5 && font.widthOfTextAtSize(t, size) > w - 4)size -= 0.5;
        f.setFontSize(size);
    };
    for (const [key, field] of Object.entries(template.fields)){
        const page = pages[field.page];
        if (!page || !field.boxes.length) continue;
        const raw = values[key];
        const value = raw === undefined || raw === null || raw === false || raw === '' ? undefined : raw;
        const height = page.getHeight();
        if (field.kind === 'tick') {
            const [x0, y0, x1, y1] = field.boxes[0];
            const cb = form.createCheckBox(key);
            cb.addToPage(page, {
                ...plain,
                x: x0,
                y: height - y1,
                width: x1 - x0,
                height: y1 - y0
            });
            if (value === true) cb.check();
        } else if (field.kind === 'date') {
            // DD, MM and YYYY each get their own box, as printed.
            const m = typeof value === 'string' ? /^(\d{4})-(\d{2})-(\d{2})/.exec(value) : null;
            const parts = m ? [
                m[3],
                m[2],
                m[1]
            ] : [];
            field.boxes.forEach((box, i)=>textField(`${key}_${[
                    'd',
                    'm',
                    'y'
                ][i] ?? i}`, page, box, parts[i], {
                    comb: i === 2 ? 4 : 2
                }));
        } else if (field.kind === 'comb') {
            const text = typeof value === 'string' ? value.replace(/\s+/g, '') : undefined;
            textField(key, page, field.boxes[0], text, {
                comb: Math.max(field.cells ?? 10, 1)
            });
        } else if (field.perAt) {
            // "$ amount per period": the amount and the period each get their own part of the box.
            const [amount, period] = typeof value === 'string' && / per /.test(value) ? value.split(' per ') : [
                typeof value === 'string' ? value : undefined,
                undefined
            ];
            const [x0, y0, x1, y1] = field.boxes[0];
            textField(key, page, [
                x0,
                y0,
                x0 + field.perAt - 14,
                y1
            ], amount, {
                padLeft: field.padLeft
            });
            textField(`${key}_per`, page, [
                x0 + field.perAt - 4,
                y0,
                x1,
                y1
            ], period);
        } else textField(key, page, field.boxes[0], typeof value === 'string' ? value : undefined, {
            padLeft: field.padLeft
        });
    }
    form.updateFieldAppearances(font);
    pdf.setTitle(`${template.code} \u{2014} pre-filled`);
    pdf.setSubject(`${template.edition}, pre-filled from the client profile. Source: ${template.source} (CC BY 4.0, Services Australia).`);
    return pdf.save();
}
function $0faadd6209986a1b$export$86f71714311cd923(bytes, fileName) {
    const blob = new Blob([
        bytes
    ], {
        type: 'application/pdf'
    });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank', 'noopener');
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(()=>URL.revokeObjectURL(url), 60000);
}
async function $0faadd6209986a1b$export$5e771c05ac100c56(pdfBytes, values, meta, opts = {}) {
    const pdf = await (0, $93b2571d4e1dfe94$export$2e2bcd8739ae039).load(pdfBytes);
    const form = pdf.getForm();
    const font = await pdf.embedFont((0, $d275b823cf3c6e5b$export$7dcb046109e65a3d).Helvetica);
    if (opts.revealHidden) $0faadd6209986a1b$var$revealAnswerFields(form);
    for (const [name, value] of Object.entries(values)){
        if (value === null || value === undefined || value === false || value === '') continue;
        let field;
        try {
            field = form.getField(name);
        } catch  {
            continue;
        }
        if (field instanceof (0, $f989cc5b81a68a40$export$2e2bcd8739ae039)) {
            if (typeof value !== 'string') continue;
            const max = field.getMaxLength();
            field.setText(max ? $0faadd6209986a1b$var$safe(value).slice(0, max) : $0faadd6209986a1b$var$safe(value));
            continue;
        }
        $0faadd6209986a1b$var$tickOption(field.acroField, value);
    }
    form.updateFieldAppearances(font);
    pdf.setTitle(meta.title);
    pdf.setSubject(meta.subject);
    return pdf.save();
}
/**
 * The Services Australia claim forms hide most of their fields until the form's own scripts reveal
 * them — the whole partner column waits for "Do you have a partner? Yes". A value written into a
 * hidden field is there but cannot be seen, printed or typed over, and not every reader runs the
 * scripts. So every answer field is shown, as the printed boxes beneath it already are. The form's
 * own helpers (its "DummyCalc" fields and "Go to" buttons) stay hidden.
 */ function $0faadd6209986a1b$var$revealAnswerFields(form) {
    const HIDDEN = 2;
    for (const field of form.getFields()){
        if (field instanceof (0, $b3771f5aa96680ee$export$2e2bcd8739ae039) || field.getName().startsWith('DummyCalc')) continue;
        for (const w of field.acroField.getWidgets()){
            const flags = w.dict.get((0, $dPHSK.default).of('F'));
            const n = flags instanceof (0, $j04jt.default) ? flags.asNumber() : 0;
            if (n & HIDDEN) w.dict.set((0, $dPHSK.default).of('F'), (0, $j04jt.default).of(n & ~HIDDEN));
        }
    }
}
/** Tick the box whose "on" name is `option` (or the only box, for `true`); every other box of the field is cleared. */ function $0faadd6209986a1b$var$tickOption(acroField, option) {
    const widgets = acroField.getWidgets();
    const target = widgets.find((w)=>{
        const on = w.getOnValue();
        return !!on && (option === true || on.decodeText() === option);
    });
    if (!target) return false;
    const on = target.getOnValue();
    for (const w of widgets)w.setAppearanceState(w === target ? on : (0, $dPHSK.default).of('Off'));
    acroField.dict.set((0, $dPHSK.default).of('V'), on);
    return true;
}
async function $0faadd6209986a1b$export$61b09c1a7c6c2ee0(pdfBytes) {
    const pdf = await (0, $93b2571d4e1dfe94$export$2e2bcd8739ae039).load(pdfBytes);
    const out = new Map();
    for (const f of pdf.getForm().getFields()){
        if (f instanceof (0, $f989cc5b81a68a40$export$2e2bcd8739ae039)) {
            out.set(f.getName(), 'text');
            continue;
        }
        const opts = new Set();
        for (const w of f.acroField.getWidgets()){
            const on = w.getOnValue();
            if (on) opts.add(on.decodeText());
        }
        out.set(f.getName(), opts);
    }
    return out;
}



var $1b1703fbcffc6055$exports = {};
$1b1703fbcffc6055$exports = JSON.parse("{\"code\":\"SA485\",\"edition\":\"SA485.2607\",\"pageSize\":[595.28,841.89],\"source\":\"https://www.servicesaustralia.gov.au/sa485\",\"fields\":{\"q1_residential\":{\"kind\":\"tick\",\"page\":4,\"boxes\":[[110.7,442.3,121.8,453.4]]},\"q2_yes\":{\"kind\":\"tick\",\"page\":4,\"boxes\":[[65.3,642.2,76.4,653.3]]},\"q3_yes\":{\"kind\":\"tick\",\"page\":4,\"boxes\":[[65.3,725.8,76.4,736.9]]},\"q4_no\":{\"kind\":\"tick\",\"page\":4,\"boxes\":[[348.8,154.6,359.9,165.7]]},\"q4_yes\":{\"kind\":\"tick\",\"page\":4,\"boxes\":[[348.8,170.2,359.9,181.3]]},\"q4_name\":{\"kind\":\"text\",\"page\":4,\"boxes\":[[331.8,200,566.8,239.4]]},\"q4_relationship\":{\"kind\":\"text\",\"page\":4,\"boxes\":[[331.8,256.7,566.8,276.3]]},\"q5_no\":{\"kind\":\"tick\",\"page\":4,\"boxes\":[[348.8,595.4,359.9,606.5]]},\"q5_yes\":{\"kind\":\"tick\",\"page\":4,\"boxes\":[[348.8,613.8,359.9,624.9]]},\"q6_na\":{\"kind\":\"tick\",\"page\":5,\"boxes\":[[110.7,141.9,121.8,152.9]]},\"q6_yes\":{\"kind\":\"tick\",\"page\":5,\"boxes\":[[110.7,207.1,121.8,218.1]]},\"q8_you_family\":{\"kind\":\"text\",\"page\":5,\"boxes\":[[48.3,449.4,283.3,469]]},\"q8_you_first\":{\"kind\":\"text\",\"page\":5,\"boxes\":[[48.3,484.8,283.3,504.4]]},\"q9_you_dob\":{\"kind\":\"date\",\"page\":5,\"boxes\":[[48.4,570,76.5,589.6],[82.5,570,110.6,589.6],[116.5,570,172.9,589.6]]},\"q8_partner_family\":{\"kind\":\"text\",\"page\":5,\"boxes\":[[331.8,449.4,566.8,469]]},\"q8_partner_first\":{\"kind\":\"text\",\"page\":5,\"boxes\":[[331.8,484.8,566.8,504.4]]},\"q9_partner_dob\":{\"kind\":\"date\",\"page\":5,\"boxes\":[[331.9,570,360,589.6],[365.9,570,394,589.6],[399.9,570,456.4,589.6]]},\"q12_option1\":{\"kind\":\"tick\",\"page\":6,\"boxes\":[[221.2,367.6,232.3,378.6]]},\"q13_no\":{\"kind\":\"tick\",\"page\":6,\"boxes\":[[348.8,181.5,359.9,192.6]]},\"q13_yes\":{\"kind\":\"tick\",\"page\":6,\"boxes\":[[348.8,200,359.9,211.1]]},\"q16_yes\":{\"kind\":\"tick\",\"page\":7,\"boxes\":[[65.3,245.3,76.4,256.4]]},\"q17_yes\":{\"kind\":\"tick\",\"page\":7,\"boxes\":[[65.3,397,76.4,408.1]]},\"q19_no\":{\"kind\":\"tick\",\"page\":8,\"boxes\":[[65.3,69.6,76.4,80.7]]},\"q20_no\":{\"kind\":\"tick\",\"page\":8,\"boxes\":[[348.8,106.4,359.9,117.5]]},\"q20_yes\":{\"kind\":\"tick\",\"page\":8,\"boxes\":[[348.8,126.3,359.9,137.4]]},\"q20_type\":{\"kind\":\"text\",\"page\":8,\"boxes\":[[336,160.3,562.6,179.9]]},\"q20_value\":{\"kind\":\"text\",\"page\":8,\"boxes\":[[336,197.1,446.3,216.7]],\"padLeft\":12.2},\"q20_share_you\":{\"kind\":\"text\",\"page\":8,\"boxes\":[[395.6,238.2,446.3,257.8]]},\"q20_share_partner\":{\"kind\":\"text\",\"page\":8,\"boxes\":[[511.8,238.2,562.6,257.8]]},\"q20_partner_no\":{\"kind\":\"tick\",\"page\":8,\"boxes\":[[353,319,364.1,330.1]]},\"q20_partner_yes\":{\"kind\":\"tick\",\"page\":8,\"boxes\":[[353,337.4,364.1,348.5]]},\"q22_o1_select\":{\"kind\":\"tick\",\"page\":9,\"boxes\":[[181.5,95.1,192.6,106.2]]},\"q22_o2_select\":{\"kind\":\"tick\",\"page\":9,\"boxes\":[[181.5,399.8,192.6,410.9]]},\"q22_o1_value\":{\"kind\":\"text\",\"page\":9,\"boxes\":[[52.6,153.2,162.9,172.8]],\"padLeft\":12.2},\"q22_o1_loan\":{\"kind\":\"text\",\"page\":9,\"boxes\":[[168.8,153.2,279.1,172.8]],\"padLeft\":12.2},\"q22_o1_share_you\":{\"kind\":\"text\",\"page\":9,\"boxes\":[[112.1,192.9,162.9,212.5]]},\"q22_o1_share_partner\":{\"kind\":\"text\",\"page\":9,\"boxes\":[[228.3,192.9,279.1,212.5]]},\"q22_o1_share_other\":{\"kind\":\"text\",\"page\":9,\"boxes\":[[112.1,218.4,162.9,238]]},\"q22_o1_partner_no\":{\"kind\":\"tick\",\"page\":9,\"boxes\":[[69.6,272.3,80.7,283.3]]},\"q22_o1_partner_yes\":{\"kind\":\"tick\",\"page\":9,\"boxes\":[[69.6,290.7,80.7,301.8]]},\"q22_o2_value\":{\"kind\":\"text\",\"page\":9,\"boxes\":[[52.6,533.7,162.9,553.3]],\"padLeft\":12.2},\"q22_o2_remaining\":{\"kind\":\"text\",\"page\":9,\"boxes\":[[168.8,533.7,279.1,553.3]],\"padLeft\":12.2},\"q22_o2_loan\":{\"kind\":\"text\",\"page\":9,\"boxes\":[[52.6,583.4,162.9,602.9]],\"padLeft\":12.2},\"q22_o2_share_you\":{\"kind\":\"text\",\"page\":9,\"boxes\":[[112.1,623,162.9,642.6]]},\"q22_o2_share_partner\":{\"kind\":\"text\",\"page\":9,\"boxes\":[[228.3,623,279.1,642.6]]},\"q22_o2_share_other\":{\"kind\":\"text\",\"page\":9,\"boxes\":[[112.1,648.6,162.9,668.1]]},\"q22_o2_partner_no\":{\"kind\":\"tick\",\"page\":9,\"boxes\":[[69.6,705.2,80.7,716.3]]},\"q22_o2_partner_yes\":{\"kind\":\"tick\",\"page\":9,\"boxes\":[[69.6,723.7,80.7,734.8]]},\"q26_no\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[65.3,93.7,76.4,104.8]]},\"q26_yes\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[65.3,112.1,76.4,123.2]]},\"q26_value\":{\"kind\":\"text\",\"page\":10,\"boxes\":[[85.2,139,195.5,158.6]],\"padLeft\":12.2},\"q27_no\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[65.3,256.7,76.4,267.7]]},\"q28_no\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[65.5,381.4,76.6,392.5]]},\"q28_yes\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[65.5,399.8,76.6,410.9]]},\"q30_no\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[348.8,58.2,359.9,69.3]]},\"q30_yes\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[348.8,76.7,359.9,87.7]]},\"q31_carer\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[501.9,238.4,512.9,249.5]]},\"q31_relative\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[501.9,281.6,512.9,292.7]]},\"q31_none\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[501.9,304.2,512.9,315.3]]}}}");


var $c48405acf7ab0f22$exports = {};
$c48405acf7ab0f22$exports = JSON.parse("{\"code\":\"SA457\",\"edition\":\"SA457.2604\",\"pageSize\":[595.28,841.89],\"source\":\"https://www.servicesaustralia.gov.au/sa457\",\"fields\":{\"q1_residential\":{\"kind\":\"tick\",\"page\":6,\"boxes\":[[110.7,442.3,121.8,453.4]]},\"q2_no\":{\"kind\":\"tick\",\"page\":6,\"boxes\":[[65.3,623.7,76.4,634.8]]},\"q3_no\":{\"kind\":\"tick\",\"page\":6,\"boxes\":[[348.8,156,359.9,167.1]]},\"q3_yes\":{\"kind\":\"tick\",\"page\":6,\"boxes\":[[348.8,174.5,359.9,185.5]]},\"q3_name\":{\"kind\":\"text\",\"page\":6,\"boxes\":[[331.8,205.6,566.8,245.1]]},\"q3_relationship\":{\"kind\":\"text\",\"page\":6,\"boxes\":[[331.8,263.7,566.8,283.3]]},\"q4_no\":{\"kind\":\"tick\",\"page\":6,\"boxes\":[[348.8,598.2,359.9,609.3]]},\"q4_yes\":{\"kind\":\"tick\",\"page\":6,\"boxes\":[[348.8,616.7,359.9,627.7]]},\"q5_na\":{\"kind\":\"tick\",\"page\":7,\"boxes\":[[110.7,139,121.8,150.1]]},\"q7_you_family\":{\"kind\":\"text\",\"page\":7,\"boxes\":[[48.3,483.4,283.3,503]]},\"q7_you_first\":{\"kind\":\"text\",\"page\":7,\"boxes\":[[48.3,518.9,283.3,538.5]]},\"q8_you_dob\":{\"kind\":\"date\",\"page\":7,\"boxes\":[[48.3,606.7,76.7,626.6],[82.3,606.7,110.7,626.6],[116.3,606.7,173,626.6]]},\"q9_you_male\":{\"kind\":\"tick\",\"page\":7,\"boxes\":[[96.5,662,107.6,673.1]]},\"q9_you_female\":{\"kind\":\"tick\",\"page\":7,\"boxes\":[[96.5,679,107.6,690.1]]},\"q11_you_phone\":{\"kind\":\"comb\",\"page\":8,\"boxes\":[[48.3,540.1,190,560]],\"cells\":10},\"q11_you_email\":{\"kind\":\"text\",\"page\":8,\"boxes\":[[48.3,575.6,283.3,595.2]]},\"q7_partner_family\":{\"kind\":\"text\",\"page\":7,\"boxes\":[[331.8,483.4,566.8,503]]},\"q7_partner_first\":{\"kind\":\"text\",\"page\":7,\"boxes\":[[331.8,518.9,566.8,538.5]]},\"q8_partner_dob\":{\"kind\":\"date\",\"page\":7,\"boxes\":[[331.8,606.7,360.1,626.6],[365.8,606.7,394.1,626.6],[399.8,606.7,456.5,626.6]]},\"q9_partner_male\":{\"kind\":\"tick\",\"page\":7,\"boxes\":[[380,662,391.1,673.1]]},\"q9_partner_female\":{\"kind\":\"tick\",\"page\":7,\"boxes\":[[380,679,391.1,690.1]]},\"q11_partner_phone\":{\"kind\":\"comb\",\"page\":8,\"boxes\":[[331.8,540.1,473.5,560]],\"cells\":10},\"q11_partner_email\":{\"kind\":\"text\",\"page\":8,\"boxes\":[[331.8,575.6,566.8,595.2]]},\"q14_yes\":{\"kind\":\"tick\",\"page\":9,\"boxes\":[[65.3,192.9,76.4,204]]},\"q15_option1\":{\"kind\":\"tick\",\"page\":9,\"boxes\":[[504.7,182.6,515.8,193.6]]},\"q16_no\":{\"kind\":\"tick\",\"page\":9,\"boxes\":[[348.8,633.7,359.9,644.8]]},\"q16_yes\":{\"kind\":\"tick\",\"page\":9,\"boxes\":[[348.8,652.1,359.9,663.2]]},\"q19_no\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[65.3,612.4,76.4,623.5]]},\"q19_yes\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[65.3,630.8,76.4,641.9]]},\"q20_yes\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[65.3,783.9,76.4,795]]},\"q22_no\":{\"kind\":\"tick\",\"page\":11,\"boxes\":[[65.5,69.6,76.6,80.7]]},\"q23_no\":{\"kind\":\"tick\",\"page\":11,\"boxes\":[[348.8,106.4,359.9,117.5]]},\"q23_yes\":{\"kind\":\"tick\",\"page\":11,\"boxes\":[[348.8,126.3,359.9,137.4]]},\"q23_type\":{\"kind\":\"text\",\"page\":11,\"boxes\":[[336,160.3,562.6,179.9]]},\"q23_value\":{\"kind\":\"text\",\"page\":11,\"boxes\":[[336,197.1,446.3,216.7]],\"padLeft\":12.2},\"q23_share_you\":{\"kind\":\"text\",\"page\":11,\"boxes\":[[395.6,238.2,446.3,257.8]]},\"q23_share_partner\":{\"kind\":\"text\",\"page\":11,\"boxes\":[[511.8,238.2,562.6,257.8]]},\"q23_partner_no\":{\"kind\":\"tick\",\"page\":11,\"boxes\":[[353,319,364.1,330.1]]},\"q23_partner_yes\":{\"kind\":\"tick\",\"page\":11,\"boxes\":[[353,337.4,364.1,348.5]]},\"q25_o1_select\":{\"kind\":\"tick\",\"page\":12,\"boxes\":[[181.5,95.1,192.6,106.2]]},\"q25_o2_select\":{\"kind\":\"tick\",\"page\":12,\"boxes\":[[181.5,399.8,192.6,410.9]]},\"q25_o1_value\":{\"kind\":\"text\",\"page\":12,\"boxes\":[[52.6,153.2,162.9,172.8]],\"padLeft\":12.2},\"q25_o1_loan\":{\"kind\":\"text\",\"page\":12,\"boxes\":[[168.8,153.2,279.1,172.8]],\"padLeft\":12.2},\"q25_o1_share_you\":{\"kind\":\"text\",\"page\":12,\"boxes\":[[112.1,192.9,162.9,212.5]]},\"q25_o1_share_partner\":{\"kind\":\"text\",\"page\":12,\"boxes\":[[228.3,192.9,279.1,212.5]]},\"q25_o1_share_other\":{\"kind\":\"text\",\"page\":12,\"boxes\":[[112.1,218.4,162.9,238]]},\"q25_o1_partner_no\":{\"kind\":\"tick\",\"page\":12,\"boxes\":[[69.6,272.3,80.7,283.3]]},\"q25_o1_partner_yes\":{\"kind\":\"tick\",\"page\":12,\"boxes\":[[69.6,290.7,80.7,301.8]]},\"q25_o2_value\":{\"kind\":\"text\",\"page\":12,\"boxes\":[[52.6,533,162.9,552.6]],\"padLeft\":12.2},\"q25_o2_remaining\":{\"kind\":\"text\",\"page\":12,\"boxes\":[[168.8,533,279.1,552.6]],\"padLeft\":12.2},\"q25_o2_loan\":{\"kind\":\"text\",\"page\":12,\"boxes\":[[52.6,582.6,162.9,602.2]],\"padLeft\":12.2},\"q25_o2_share_you\":{\"kind\":\"text\",\"page\":12,\"boxes\":[[112.1,622.3,162.9,641.9]]},\"q25_o2_share_partner\":{\"kind\":\"text\",\"page\":12,\"boxes\":[[228.3,622.3,279.1,641.9]]},\"q25_o2_share_other\":{\"kind\":\"text\",\"page\":12,\"boxes\":[[112.1,647.8,162.9,667.4]]},\"q25_o2_partner_no\":{\"kind\":\"tick\",\"page\":12,\"boxes\":[[69.6,704.5,80.7,715.6]]},\"q25_o2_partner_yes\":{\"kind\":\"tick\",\"page\":12,\"boxes\":[[69.6,723,80.7,734]]},\"q29_no\":{\"kind\":\"tick\",\"page\":13,\"boxes\":[[65.3,93.7,76.4,104.8]]},\"q29_yes\":{\"kind\":\"tick\",\"page\":13,\"boxes\":[[65.3,112.1,76.4,123.2]]},\"q29_value\":{\"kind\":\"text\",\"page\":13,\"boxes\":[[85.2,139,195.5,158.6]],\"padLeft\":12.2},\"q30_no\":{\"kind\":\"tick\",\"page\":13,\"boxes\":[[65.3,256.7,76.4,267.7]]},\"q31_no\":{\"kind\":\"tick\",\"page\":13,\"boxes\":[[65.5,381.4,76.6,392.5]]},\"q31_yes\":{\"kind\":\"tick\",\"page\":13,\"boxes\":[[65.5,399.8,76.6,410.9]]},\"q33_no\":{\"kind\":\"tick\",\"page\":13,\"boxes\":[[348.8,58.2,359.9,69.3]]},\"q33_yes\":{\"kind\":\"tick\",\"page\":13,\"boxes\":[[348.8,76.7,359.9,87.7]]},\"q34_carer\":{\"kind\":\"tick\",\"page\":13,\"boxes\":[[501.9,247.5,512.9,258.6]]},\"q34_relative\":{\"kind\":\"tick\",\"page\":13,\"boxes\":[[501.9,290.7,512.9,301.8]]},\"q34_none\":{\"kind\":\"tick\",\"page\":13,\"boxes\":[[501.9,313.4,512.9,324.5]]},\"q38_no\":{\"kind\":\"tick\",\"page\":15,\"boxes\":[[65.3,97.9,76.4,109]]},\"q38_yes\":{\"kind\":\"tick\",\"page\":15,\"boxes\":[[65.3,116.3,76.4,127.4]]},\"q40_you\":{\"kind\":\"tick\",\"page\":15,\"boxes\":[[102.2,567.1,113.3,578.1]]},\"q40_partner\":{\"kind\":\"tick\",\"page\":15,\"boxes\":[[102.2,591.1,113.3,602.2]]},\"q40_share_you\":{\"kind\":\"text\",\"page\":15,\"boxes\":[[204.2,562.8,283.3,582.4]]},\"q40_share_partner\":{\"kind\":\"text\",\"page\":15,\"boxes\":[[204.2,586.9,283.3,606.5]]},\"q42_value\":{\"kind\":\"text\",\"page\":15,\"boxes\":[[336,462.2,449.2,481.8]],\"padLeft\":12.2},\"q45_no\":{\"kind\":\"tick\",\"page\":16,\"boxes\":[[65.5,646.4,76.6,657.5]]},\"q45_yes\":{\"kind\":\"tick\",\"page\":16,\"boxes\":[[65.5,666.3,76.6,677.4]]},\"q46_no\":{\"kind\":\"tick\",\"page\":16,\"boxes\":[[348.8,90.8,359.9,101.9]]},\"q46_yes\":{\"kind\":\"tick\",\"page\":16,\"boxes\":[[348.8,109.3,359.9,120.3]]},\"q50_1_name\":{\"kind\":\"text\",\"page\":17,\"boxes\":[[336,422.5,562.6,442.1]]},\"q50_1_type\":{\"kind\":\"text\",\"page\":17,\"boxes\":[[336,494.8,562.6,514.4]]},\"q50_1_balance\":{\"kind\":\"text\",\"page\":17,\"boxes\":[[336,531.6,449.2,551.2]]},\"q50_1_share_you\":{\"kind\":\"text\",\"page\":17,\"boxes\":[[406.9,557.1,449.2,576.7]]},\"q50_1_share_partner\":{\"kind\":\"text\",\"page\":17,\"boxes\":[[520.3,557.1,562.6,576.7]]},\"q50_2_name\":{\"kind\":\"text\",\"page\":17,\"boxes\":[[336,603.9,562.6,623.5]]},\"q50_2_type\":{\"kind\":\"text\",\"page\":17,\"boxes\":[[336,676.2,562.6,695.8]]},\"q50_2_balance\":{\"kind\":\"text\",\"page\":17,\"boxes\":[[336,713,449.2,732.6]]},\"q50_2_share_you\":{\"kind\":\"text\",\"page\":17,\"boxes\":[[406.9,738.5,449.2,758.1]]},\"q50_2_share_partner\":{\"kind\":\"text\",\"page\":17,\"boxes\":[[520.3,738.5,562.6,758.1]]},\"q51_no\":{\"kind\":\"tick\",\"page\":18,\"boxes\":[[65.3,431,76.4,442.1]]},\"q51_yes\":{\"kind\":\"tick\",\"page\":18,\"boxes\":[[65.3,449.4,76.4,460.5]]},\"q51_1_institution\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[336,58.1,562.6,77.7]]},\"q51_1_fund\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[336,95.1,562.6,114.7]]},\"q51_1_balance\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[336,156,440.7,175.6]],\"padLeft\":11.5},\"q51_1_income\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[336,205.6,446.3,225.2]],\"padLeft\":11.5},\"q51_1_often\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[452.3,205.6,562.6,225.2]],\"padLeft\":18.7},\"q51_1_share_you\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[473.5,251,515.8,270.6]]},\"q51_1_share_partner\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[520.3,251,562.6,270.6]]},\"q51_2_institution\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[336,296.2,562.6,315.8]]},\"q51_2_fund\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[336,333.2,562.6,352.8]]},\"q51_2_balance\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[336,394.1,440.7,413.7]],\"padLeft\":11.5},\"q51_2_income\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[336,443.7,446.3,463.3]],\"padLeft\":11.5},\"q51_2_often\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[452.3,443.7,562.6,463.3]],\"padLeft\":18.7},\"q51_2_share_you\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[473.5,489.1,515.8,508.7]]},\"q51_2_share_partner\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[520.3,489.1,562.6,508.7]]},\"q52_no\":{\"kind\":\"tick\",\"page\":19,\"boxes\":[[65.3,280.8,76.4,291.8]]},\"q53_no\":{\"kind\":\"tick\",\"page\":19,\"boxes\":[[348.8,246.7,359.9,257.8]]},\"q53_yes\":{\"kind\":\"tick\",\"page\":19,\"boxes\":[[348.8,265.2,359.9,276.3]]},\"q53_1_company\":{\"kind\":\"text\",\"page\":19,\"boxes\":[[336,333.2,562.6,352.8]]},\"q53_1_share_you\":{\"kind\":\"text\",\"page\":19,\"boxes\":[[452.3,438.1,503,457.7]]},\"q53_1_share_partner\":{\"kind\":\"text\",\"page\":19,\"boxes\":[[510.4,438.1,561.1,457.7]]},\"q53_2_company\":{\"kind\":\"text\",\"page\":19,\"boxes\":[[336,486.3,562.6,505.9]]},\"q53_2_share_you\":{\"kind\":\"text\",\"page\":19,\"boxes\":[[452.3,567.1,503,586.6]]},\"q53_2_share_partner\":{\"kind\":\"text\",\"page\":19,\"boxes\":[[510.4,567.1,561.1,586.6]]},\"q54_no\":{\"kind\":\"tick\",\"page\":20,\"boxes\":[[65.3,238.7,76.4,249.8]]},\"q55_no\":{\"kind\":\"tick\",\"page\":20,\"boxes\":[[348.8,82.3,359.9,93.4]]},\"q55_yes\":{\"kind\":\"tick\",\"page\":20,\"boxes\":[[348.8,100.8,359.9,111.8]]},\"q55_1_company\":{\"kind\":\"text\",\"page\":20,\"boxes\":[[335.9,181.4,562.1,201]]},\"q55_1_value\":{\"kind\":\"text\",\"page\":20,\"boxes\":[[335.5,318.4,447.7,338]],\"padLeft\":11.5},\"q55_1_share_you\":{\"kind\":\"text\",\"page\":20,\"boxes\":[[452.2,318.4,503,338]]},\"q55_1_share_partner\":{\"kind\":\"text\",\"page\":20,\"boxes\":[[510.1,318.4,560.9,338]]},\"q55_2_company\":{\"kind\":\"text\",\"page\":20,\"boxes\":[[335.9,362.8,562.1,382.4]]},\"q55_2_value\":{\"kind\":\"text\",\"page\":20,\"boxes\":[[335.5,499.8,447.7,519.4]],\"padLeft\":11.5},\"q55_2_share_you\":{\"kind\":\"text\",\"page\":20,\"boxes\":[[452.2,499.8,503,519.4]]},\"q55_2_share_partner\":{\"kind\":\"text\",\"page\":20,\"boxes\":[[510.1,499.8,560.9,519.4]]},\"q56_no\":{\"kind\":\"tick\",\"page\":21,\"boxes\":[[65.3,69.6,76.4,80.7]]},\"q56_yes\":{\"kind\":\"tick\",\"page\":21,\"boxes\":[[65.3,88,76.4,99.1]]},\"q56_1_product\":{\"kind\":\"text\",\"page\":21,\"boxes\":[[52.6,154.6,279.1,174.2]]},\"q56_1_share_you\":{\"kind\":\"text\",\"page\":21,\"boxes\":[[170.2,238.2,221,257.8]]},\"q56_1_share_partner\":{\"kind\":\"text\",\"page\":21,\"boxes\":[[228.3,238.5,279.1,258.1]]},\"q56_2_product\":{\"kind\":\"text\",\"page\":21,\"boxes\":[[52.6,283.6,279.1,303.2]]},\"q56_2_share_you\":{\"kind\":\"text\",\"page\":21,\"boxes\":[[170.2,367.2,221,386.8]]},\"q56_2_share_partner\":{\"kind\":\"text\",\"page\":21,\"boxes\":[[228.3,367.5,279.1,387.1]]},\"q57_no\":{\"kind\":\"tick\",\"page\":21,\"boxes\":[[65.3,486.3,76.4,497.4]]},\"q57_yes\":{\"kind\":\"tick\",\"page\":21,\"boxes\":[[65.3,504.7,76.4,515.8]]},\"q57_amount\":{\"kind\":\"text\",\"page\":21,\"boxes\":[[52.6,541.5,162.9,561.1]],\"padLeft\":12.2},\"q58_no\":{\"kind\":\"tick\",\"page\":21,\"boxes\":[[348.8,119.2,359.9,130.3]]},\"q58_yes\":{\"kind\":\"tick\",\"page\":21,\"boxes\":[[348.8,137.6,359.9,148.7]]},\"q58_1_who\":{\"kind\":\"text\",\"page\":21,\"boxes\":[[335.8,276.5,562.3,296.1]]},\"q58_1_date\":{\"kind\":\"date\",\"page\":21,\"boxes\":[[336,313.4,364.4,333.2],[370,313.4,398.4,333.2],[404.1,313.4,460.8,333.2]]},\"q58_1_amount\":{\"kind\":\"text\",\"page\":21,\"boxes\":[[336,351.6,446.3,371.2]],\"padLeft\":11.5},\"q58_1_balance\":{\"kind\":\"text\",\"page\":21,\"boxes\":[[452.2,351.5,562.6,371.1]],\"padLeft\":11.5},\"q58_1_share_you\":{\"kind\":\"text\",\"page\":21,\"boxes\":[[395.6,378.6,446.3,398.1]]},\"q58_1_share_partner\":{\"kind\":\"text\",\"page\":21,\"boxes\":[[511.8,378.6,562.6,398.1]]},\"q58_2_who\":{\"kind\":\"text\",\"page\":21,\"boxes\":[[335.8,423.9,562.3,443.5]]},\"q58_2_date\":{\"kind\":\"date\",\"page\":21,\"boxes\":[[336,460.8,364.4,480.6],[370,460.8,398.4,480.6],[404.1,460.8,460.8,480.6]]},\"q58_2_amount\":{\"kind\":\"text\",\"page\":21,\"boxes\":[[336,499,446.3,518.6]],\"padLeft\":11.5},\"q58_2_balance\":{\"kind\":\"text\",\"page\":21,\"boxes\":[[452.2,498.9,562.6,518.5]],\"padLeft\":11.5},\"q58_2_share_you\":{\"kind\":\"text\",\"page\":21,\"boxes\":[[395.6,526,446.3,545.5]]},\"q58_2_share_partner\":{\"kind\":\"text\",\"page\":21,\"boxes\":[[511.8,526,562.6,545.5]]},\"q59_no\":{\"kind\":\"tick\",\"page\":22,\"boxes\":[[65.3,440.9,76.4,452]]},\"q59_yes\":{\"kind\":\"tick\",\"page\":22,\"boxes\":[[65.3,459.3,76.4,470.4]]},\"q60_no\":{\"kind\":\"tick\",\"page\":22,\"boxes\":[[348.8,399.8,359.9,410.9]]},\"q60_yes\":{\"kind\":\"tick\",\"page\":22,\"boxes\":[[348.8,418.2,359.9,429.3]]},\"q60_1_type\":{\"kind\":\"text\",\"page\":22,\"boxes\":[[336,526,562.6,545.5]]},\"q60_1_country\":{\"kind\":\"text\",\"page\":22,\"boxes\":[[336,562.8,562.6,582.4]]},\"q60_1_amount\":{\"kind\":\"text\",\"page\":22,\"boxes\":[[336,611.3,446.3,630.9]]},\"q61_no\":{\"kind\":\"tick\",\"page\":23,\"boxes\":[[65.3,348.8,76.4,359.9]]},\"q61_yes\":{\"kind\":\"tick\",\"page\":23,\"boxes\":[[65.3,368.6,76.4,379.7]]},\"q62_no\":{\"kind\":\"tick\",\"page\":23,\"boxes\":[[348.8,275.1,359.9,286.2]]},\"q62_yes\":{\"kind\":\"tick\",\"page\":23,\"boxes\":[[348.8,293.5,359.9,304.6]]},\"q64_no\":{\"kind\":\"tick\",\"page\":23,\"boxes\":[[348.8,633.7,359.9,644.8]]},\"q64_yes\":{\"kind\":\"tick\",\"page\":23,\"boxes\":[[348.8,652.1,359.9,663.2]]},\"q65_no\":{\"kind\":\"tick\",\"page\":24,\"boxes\":[[65.3,266.6,76.4,277.7]]},\"q65_yes\":{\"kind\":\"tick\",\"page\":24,\"boxes\":[[65.3,286.4,76.4,297.5]]},\"q65_1_description\":{\"kind\":\"text\",\"page\":24,\"boxes\":[[52.4,353,278.9,372.6]]},\"q65_1_value\":{\"kind\":\"text\",\"page\":24,\"boxes\":[[52.5,389.9,162.8,409.5]]},\"q65_1_share_you\":{\"kind\":\"text\",\"page\":24,\"boxes\":[[166,438,218.1,457.5]]},\"q65_1_share_partner\":{\"kind\":\"text\",\"page\":24,\"boxes\":[[221.9,438,278.2,457.5]]},\"q65_2_description\":{\"kind\":\"text\",\"page\":24,\"boxes\":[[52.4,484.8,278.9,504.4]]},\"q65_2_value\":{\"kind\":\"text\",\"page\":24,\"boxes\":[[52.5,521.7,162.8,541.3]]},\"q65_2_share_you\":{\"kind\":\"text\",\"page\":24,\"boxes\":[[166,569.8,218.1,589.4]]},\"q65_2_share_partner\":{\"kind\":\"text\",\"page\":24,\"boxes\":[[221.9,569.8,278.2,589.4]]},\"q66_no\":{\"kind\":\"tick\",\"page\":24,\"boxes\":[[348.8,266.6,359.9,277.7]]},\"q66_yes\":{\"kind\":\"tick\",\"page\":24,\"boxes\":[[348.8,286.4,359.9,297.5]]},\"q66_1_type\":{\"kind\":\"text\",\"page\":24,\"boxes\":[[336,365.8,562.6,385.4]]},\"q66_1_gross\":{\"kind\":\"text\",\"page\":24,\"boxes\":[[336,402.6,562.6,422.2]],\"padLeft\":12.2,\"perAt\":127.4},\"q66_2_type\":{\"kind\":\"text\",\"page\":24,\"boxes\":[[336,497.6,562.6,517.2]]},\"q66_2_gross\":{\"kind\":\"text\",\"page\":24,\"boxes\":[[336,534.5,562.6,554]],\"padLeft\":12.2,\"perAt\":127.4}}}");


var $8b528239ab8610e5$exports = {};
$8b528239ab8610e5$exports = JSON.parse("{\"code\":\"SA456\",\"edition\":\"SA456.2511\",\"pageSize\":[595.28,841.89],\"source\":\"https://www.servicesaustralia.gov.au/sa456\",\"fields\":{\"q1_option1\":{\"kind\":\"tick\",\"page\":6,\"boxes\":[[128.3,255.1,139.3,266.2]]},\"q2_no\":{\"kind\":\"tick\",\"page\":6,\"boxes\":[[65.3,635.1,76.4,646.2]]},\"q3_no\":{\"kind\":\"tick\",\"page\":6,\"boxes\":[[348.8,154.6,359.9,165.7]]},\"q3_yes\":{\"kind\":\"tick\",\"page\":6,\"boxes\":[[348.8,173,359.9,184.1]]},\"q3_name\":{\"kind\":\"text\",\"page\":6,\"boxes\":[[331.8,202.8,566.8,242.2]]},\"q3_relationship\":{\"kind\":\"text\",\"page\":6,\"boxes\":[[331.8,259.5,566.8,279.1]]},\"q4_no\":{\"kind\":\"tick\",\"page\":6,\"boxes\":[[348.8,555.7,359.9,566.8]]},\"q4_yes\":{\"kind\":\"tick\",\"page\":6,\"boxes\":[[348.8,574.1,359.9,585.2]]},\"q5_na\":{\"kind\":\"tick\",\"page\":7,\"boxes\":[[110.7,156,121.8,167.1]]},\"q7_you_family\":{\"kind\":\"text\",\"page\":7,\"boxes\":[[48.3,508.9,283.3,528.5]]},\"q7_you_first\":{\"kind\":\"text\",\"page\":7,\"boxes\":[[48.3,544.4,283.3,564]]},\"q8_you_dob\":{\"kind\":\"date\",\"page\":7,\"boxes\":[[48.3,632.3,76.7,652.1],[82.3,632.3,110.7,652.1],[116.3,632.3,173,652.1]]},\"q9_you_male\":{\"kind\":\"tick\",\"page\":7,\"boxes\":[[96.5,687.5,107.6,698.6]]},\"q9_you_female\":{\"kind\":\"tick\",\"page\":7,\"boxes\":[[96.5,703.1,107.6,714.2]]},\"q11_you_phone\":{\"kind\":\"comb\",\"page\":8,\"boxes\":[[48.3,545.8,190,565.6]],\"cells\":10},\"q11_you_email\":{\"kind\":\"text\",\"page\":8,\"boxes\":[[48.3,582.6,283.3,602.2]]},\"q7_partner_family\":{\"kind\":\"text\",\"page\":7,\"boxes\":[[331.8,508.9,566.8,528.5]]},\"q7_partner_first\":{\"kind\":\"text\",\"page\":7,\"boxes\":[[331.8,544.4,566.8,564]]},\"q8_partner_dob\":{\"kind\":\"date\",\"page\":7,\"boxes\":[[331.8,632.3,360.1,652.1],[365.8,632.3,394.1,652.1],[399.8,632.3,456.5,652.1]]},\"q9_partner_male\":{\"kind\":\"tick\",\"page\":7,\"boxes\":[[380,687.5,391.1,698.6]]},\"q9_partner_female\":{\"kind\":\"tick\",\"page\":7,\"boxes\":[[380,703.1,391.1,714.2]]},\"q11_partner_phone\":{\"kind\":\"comb\",\"page\":8,\"boxes\":[[331.8,545.8,473.5,565.6]],\"cells\":10},\"q11_partner_email\":{\"kind\":\"text\",\"page\":8,\"boxes\":[[331.8,582.6,566.8,602.2]]},\"q15_yes\":{\"kind\":\"tick\",\"page\":9,\"boxes\":[[65.3,499,76.4,510.1]]},\"q17_no\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[65.3,88,76.4,99.1]]},\"q17_yes\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[65.3,106.4,76.4,117.5]]},\"q18_no\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[65.3,354.5,76.4,365.5]]},\"q18_yes\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[65.3,372.9,76.4,384]]},\"q19_no\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[65.5,445.2,76.6,456.3]]},\"q20_no\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[348.9,59.7,360,70.7]]},\"q20_yes\":{\"kind\":\"tick\",\"page\":10,\"boxes\":[[348.9,75.2,360,86.3]]},\"q27_no\":{\"kind\":\"tick\",\"page\":12,\"boxes\":[[65.3,100.8,76.4,111.8]]},\"q27_yes\":{\"kind\":\"tick\",\"page\":12,\"boxes\":[[65.3,119.2,76.4,130.3]]},\"q28_count\":{\"kind\":\"text\",\"page\":12,\"boxes\":[[48.5,191.5,172.9,211.1]]},\"q31_you\":{\"kind\":\"tick\",\"page\":12,\"boxes\":[[385.6,61.1,396.7,72.2]]},\"q31_partner\":{\"kind\":\"tick\",\"page\":12,\"boxes\":[[385.6,85.2,396.7,96.3]]},\"q31_share_you\":{\"kind\":\"text\",\"page\":12,\"boxes\":[[487.7,56.8,566.8,76.4]]},\"q31_share_partner\":{\"kind\":\"text\",\"page\":12,\"boxes\":[[487.7,80.9,566.8,100.5]]},\"q32_no\":{\"kind\":\"tick\",\"page\":12,\"boxes\":[[348.8,326.1,359.9,337.2]]},\"q32_yes\":{\"kind\":\"tick\",\"page\":12,\"boxes\":[[348.8,344.5,359.9,355.6]]},\"q34_value\":{\"kind\":\"text\",\"page\":13,\"boxes\":[[52.6,133.4,165.7,152.9]],\"padLeft\":12.2},\"q37_no\":{\"kind\":\"tick\",\"page\":13,\"boxes\":[[348.9,646.4,360,657.5]]},\"q37_yes\":{\"kind\":\"tick\",\"page\":13,\"boxes\":[[348.9,666.3,360,677.4]]},\"q39_1_name\":{\"kind\":\"text\",\"page\":14,\"boxes\":[[336,477.8,562.6,497.4]]},\"q39_1_type\":{\"kind\":\"text\",\"page\":14,\"boxes\":[[336,550,562.6,569.6]]},\"q39_1_balance\":{\"kind\":\"text\",\"page\":14,\"boxes\":[[336,586.9,449.2,606.5]]},\"q39_1_share_you\":{\"kind\":\"text\",\"page\":14,\"boxes\":[[406.9,612.4,449.2,632]]},\"q39_1_share_partner\":{\"kind\":\"text\",\"page\":14,\"boxes\":[[520.3,612.4,562.6,632]]},\"q39_2_name\":{\"kind\":\"text\",\"page\":15,\"boxes\":[[52.6,62.5,279.1,82.1]]},\"q39_2_type\":{\"kind\":\"text\",\"page\":15,\"boxes\":[[52.6,134.8,279.1,154.4]]},\"q39_2_balance\":{\"kind\":\"text\",\"page\":15,\"boxes\":[[52.6,171.6,165.7,191.2]]},\"q39_2_share_you\":{\"kind\":\"text\",\"page\":15,\"boxes\":[[123.4,197.1,165.7,216.7]]},\"q39_2_share_partner\":{\"kind\":\"text\",\"page\":15,\"boxes\":[[236.8,197.1,279.1,216.7]]},\"q39_3_name\":{\"kind\":\"text\",\"page\":15,\"boxes\":[[52.6,246.7,279.1,266.3]]},\"q39_3_type\":{\"kind\":\"text\",\"page\":15,\"boxes\":[[52.6,319,279.1,338.6]]},\"q39_3_balance\":{\"kind\":\"text\",\"page\":15,\"boxes\":[[52.6,355.9,165.7,375.5]]},\"q39_3_share_you\":{\"kind\":\"text\",\"page\":15,\"boxes\":[[123.4,381.4,165.7,401]]},\"q39_3_share_partner\":{\"kind\":\"text\",\"page\":15,\"boxes\":[[236.8,381.4,279.1,401]]},\"q39_4_name\":{\"kind\":\"text\",\"page\":15,\"boxes\":[[52.6,429.6,279.1,449.2]]},\"q39_4_type\":{\"kind\":\"text\",\"page\":15,\"boxes\":[[52.6,501.9,279.1,521.5]]},\"q39_4_balance\":{\"kind\":\"text\",\"page\":15,\"boxes\":[[52.6,538.7,165.7,558.3]]},\"q39_4_share_you\":{\"kind\":\"text\",\"page\":15,\"boxes\":[[123.4,564.2,165.7,583.8]]},\"q39_4_share_partner\":{\"kind\":\"text\",\"page\":15,\"boxes\":[[236.8,564.2,279.1,583.8]]},\"q40_no\":{\"kind\":\"tick\",\"page\":15,\"boxes\":[[348.8,416.8,359.9,427.9]]},\"q40_yes\":{\"kind\":\"tick\",\"page\":15,\"boxes\":[[348.8,435.2,359.9,446.3]]},\"q40_1_institution\":{\"kind\":\"text\",\"page\":16,\"boxes\":[[52.6,58.1,279.1,77.7]]},\"q40_1_fund\":{\"kind\":\"text\",\"page\":16,\"boxes\":[[52.6,95.1,279.1,114.7]]},\"q40_1_balance\":{\"kind\":\"text\",\"page\":16,\"boxes\":[[52.6,156,157.2,175.6]],\"padLeft\":11.9},\"q40_1_income\":{\"kind\":\"text\",\"page\":16,\"boxes\":[[52.6,205.6,162.9,225.2]],\"padLeft\":11.9},\"q40_1_often\":{\"kind\":\"text\",\"page\":16,\"boxes\":[[168.8,205.6,279.1,225.2]],\"padLeft\":19.9},\"q40_1_share_you\":{\"kind\":\"text\",\"page\":16,\"boxes\":[[190,251,232.3,270.6]]},\"q40_1_share_partner\":{\"kind\":\"text\",\"page\":16,\"boxes\":[[236.8,251,279.1,270.6]]},\"q40_2_institution\":{\"kind\":\"text\",\"page\":16,\"boxes\":[[52.6,296.2,279.1,315.8]]},\"q40_2_fund\":{\"kind\":\"text\",\"page\":16,\"boxes\":[[52.6,333.2,279.1,352.8]]},\"q40_2_balance\":{\"kind\":\"text\",\"page\":16,\"boxes\":[[52.6,394.1,157.2,413.7]],\"padLeft\":11.9},\"q40_2_income\":{\"kind\":\"text\",\"page\":16,\"boxes\":[[52.6,443.7,162.9,463.3]],\"padLeft\":11.9},\"q40_2_often\":{\"kind\":\"text\",\"page\":16,\"boxes\":[[168.8,443.7,279.1,463.3]],\"padLeft\":19.9},\"q40_2_share_you\":{\"kind\":\"text\",\"page\":16,\"boxes\":[[190,489.1,232.3,508.7]]},\"q40_2_share_partner\":{\"kind\":\"text\",\"page\":16,\"boxes\":[[236.8,489.1,279.1,508.7]]},\"q41_no\":{\"kind\":\"tick\",\"page\":16,\"boxes\":[[348.8,283.6,359.9,294.7]]},\"q42_no\":{\"kind\":\"tick\",\"page\":17,\"boxes\":[[65.3,246.7,76.4,257.8]]},\"q42_yes\":{\"kind\":\"tick\",\"page\":17,\"boxes\":[[65.3,265.2,76.4,276.3]]},\"q42_1_company\":{\"kind\":\"text\",\"page\":17,\"boxes\":[[52.6,337.4,279.1,357]]},\"q42_1_share_you\":{\"kind\":\"text\",\"page\":17,\"boxes\":[[168.8,440.9,219.6,460.5]]},\"q42_1_share_partner\":{\"kind\":\"text\",\"page\":17,\"boxes\":[[226.9,440.9,277.7,460.5]]},\"q42_2_company\":{\"kind\":\"text\",\"page\":17,\"boxes\":[[52.6,487.7,279.1,507.3]]},\"q42_2_share_you\":{\"kind\":\"text\",\"page\":17,\"boxes\":[[168.8,568.5,219.6,588.1]]},\"q42_2_share_partner\":{\"kind\":\"text\",\"page\":17,\"boxes\":[[226.9,568.5,277.7,588.1]]},\"q43_no\":{\"kind\":\"tick\",\"page\":17,\"boxes\":[[348.8,244.4,359.9,255.5]]},\"q44_no\":{\"kind\":\"tick\",\"page\":18,\"boxes\":[[65.3,85.2,76.4,96.3]]},\"q44_yes\":{\"kind\":\"tick\",\"page\":18,\"boxes\":[[65.3,103.6,76.4,114.7]]},\"q44_1_company\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[52.4,187.1,278.7,206.7]]},\"q44_1_value\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[52,324,164.3,343.6]],\"padLeft\":12},\"q44_1_share_you\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[168.7,324,219.5,343.6]]},\"q44_1_share_partner\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[226.6,324,277.4,343.6]]},\"q44_2_company\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[52.4,368.5,278.7,388.1]]},\"q44_2_value\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[52,505.5,164.3,525.1]],\"padLeft\":12},\"q44_2_share_you\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[168.7,505.5,219.5,525.1]]},\"q44_2_share_partner\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[226.6,505.5,277.4,525.1]]},\"q45_no\":{\"kind\":\"tick\",\"page\":18,\"boxes\":[[348.8,71,359.9,82.1]]},\"q45_yes\":{\"kind\":\"tick\",\"page\":18,\"boxes\":[[348.8,89.4,359.9,100.5]]},\"q45_1_product\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[336,163.1,562.6,182.7]]},\"q45_1_share_you\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[453.7,246.7,504.4,266.3]]},\"q45_1_share_partner\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[511.8,247,562.6,266.6]]},\"q45_2_product\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[336,292.1,562.6,311.7]]},\"q45_2_share_you\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[453.7,375.7,504.4,395.3]]},\"q45_2_share_partner\":{\"kind\":\"text\",\"page\":18,\"boxes\":[[511.8,376,562.6,395.6]]},\"q47_no\":{\"kind\":\"tick\",\"page\":19,\"boxes\":[[348.8,448,359.9,459.1]]},\"q47_yes\":{\"kind\":\"tick\",\"page\":19,\"boxes\":[[348.8,466.4,359.9,477.5]]},\"q46_no\":{\"kind\":\"tick\",\"page\":19,\"boxes\":[[65.3,122,76.4,133.1]]},\"q46_yes\":{\"kind\":\"tick\",\"page\":19,\"boxes\":[[65.3,140.4,76.4,151.5]]},\"q46_1_who\":{\"kind\":\"text\",\"page\":19,\"boxes\":[[52.3,276.5,278.9,296.1]]},\"q46_1_date\":{\"kind\":\"date\",\"page\":19,\"boxes\":[[52.6,313.4,80.9,333.2],[86.6,313.4,114.9,333.2],[120.6,313.4,177.3,333.2]]},\"q46_1_amount\":{\"kind\":\"text\",\"page\":19,\"boxes\":[[52.6,351.6,162.9,371.2]],\"padLeft\":11.9},\"q46_1_balance\":{\"kind\":\"text\",\"page\":19,\"boxes\":[[168.8,351.5,279.1,371.1]],\"padLeft\":12},\"q46_1_share_you\":{\"kind\":\"text\",\"page\":19,\"boxes\":[[112.1,378.6,162.9,398.1]]},\"q46_1_share_partner\":{\"kind\":\"text\",\"page\":19,\"boxes\":[[228.3,378.6,279.1,398.1]]},\"q46_2_who\":{\"kind\":\"text\",\"page\":19,\"boxes\":[[52.3,423.9,278.9,443.5]]},\"q46_2_date\":{\"kind\":\"date\",\"page\":19,\"boxes\":[[52.6,460.8,80.9,480.6],[86.6,460.8,114.9,480.6],[120.6,460.8,177.3,480.6]]},\"q46_2_amount\":{\"kind\":\"text\",\"page\":19,\"boxes\":[[52.6,499,162.9,518.6]],\"padLeft\":11.9},\"q46_2_balance\":{\"kind\":\"text\",\"page\":19,\"boxes\":[[168.8,498.9,279.1,518.5]],\"padLeft\":11.9},\"q46_2_share_you\":{\"kind\":\"text\",\"page\":19,\"boxes\":[[112.1,526,162.9,545.5]]},\"q46_2_share_partner\":{\"kind\":\"text\",\"page\":19,\"boxes\":[[228.3,526,279.1,545.5]]},\"q48_no\":{\"kind\":\"tick\",\"page\":20,\"boxes\":[[65.3,408.3,76.4,419.4]]},\"q48_yes\":{\"kind\":\"tick\",\"page\":20,\"boxes\":[[65.3,426.7,76.4,437.8]]},\"q48_1_type\":{\"kind\":\"text\",\"page\":20,\"boxes\":[[52.6,537.3,279.1,556.9]]},\"q48_1_country\":{\"kind\":\"text\",\"page\":20,\"boxes\":[[52.6,574.1,279.1,593.7]]},\"q48_1_amount\":{\"kind\":\"text\",\"page\":20,\"boxes\":[[52.6,622.6,162.9,642.2]]},\"q49_no\":{\"kind\":\"tick\",\"page\":20,\"boxes\":[[348.8,354.5,359.9,365.5]]},\"q49_yes\":{\"kind\":\"tick\",\"page\":20,\"boxes\":[[348.8,374.3,359.9,385.4]]},\"q50_no\":{\"kind\":\"tick\",\"page\":21,\"boxes\":[[65.3,285,76.4,296.1]]},\"q50_yes\":{\"kind\":\"tick\",\"page\":21,\"boxes\":[[65.3,303.4,76.4,314.5]]},\"q52_no\":{\"kind\":\"tick\",\"page\":21,\"boxes\":[[348.8,234,359.9,245.1]]},\"q52_yes\":{\"kind\":\"tick\",\"page\":21,\"boxes\":[[348.8,252.4,359.9,263.5]]},\"q53_no\":{\"kind\":\"tick\",\"page\":22,\"boxes\":[[65.3,275.1,76.4,286.2]]},\"q53_yes\":{\"kind\":\"tick\",\"page\":22,\"boxes\":[[65.3,293.5,76.4,304.6]]},\"q53_1_type\":{\"kind\":\"text\",\"page\":22,\"boxes\":[[52.6,378.6,279.1,398.1]]},\"q53_1_gross\":{\"kind\":\"text\",\"page\":22,\"boxes\":[[52.6,415.4,279.1,435]],\"padLeft\":12.7,\"perAt\":128.6},\"q53_2_type\":{\"kind\":\"text\",\"page\":22,\"boxes\":[[52.6,513.2,279.1,532.8]]},\"q53_2_gross\":{\"kind\":\"text\",\"page\":22,\"boxes\":[[52.6,550,279.1,569.6]],\"padLeft\":12.7,\"perAt\":128.6},\"q56_no\":{\"kind\":\"tick\",\"page\":23,\"boxes\":[[65.3,266.6,76.4,277.7]]},\"q56_yes\":{\"kind\":\"tick\",\"page\":23,\"boxes\":[[65.3,286.4,76.4,297.5]]},\"q56_1_description\":{\"kind\":\"text\",\"page\":23,\"boxes\":[[52.4,353,278.9,372.6]]},\"q56_1_value\":{\"kind\":\"text\",\"page\":23,\"boxes\":[[52.5,389.9,162.8,409.5]]},\"q56_1_share_you\":{\"kind\":\"text\",\"page\":23,\"boxes\":[[166,438,218.1,457.5]]},\"q56_1_share_partner\":{\"kind\":\"text\",\"page\":23,\"boxes\":[[221.9,438,278.2,457.5]]},\"q56_2_description\":{\"kind\":\"text\",\"page\":23,\"boxes\":[[52.4,484.8,278.9,504.4]]},\"q56_2_value\":{\"kind\":\"text\",\"page\":23,\"boxes\":[[52.5,521.7,162.8,541.3]]},\"q56_2_share_you\":{\"kind\":\"text\",\"page\":23,\"boxes\":[[166,569.8,218.1,589.4]]},\"q56_2_share_partner\":{\"kind\":\"text\",\"page\":23,\"boxes\":[[221.9,569.8,278.2,589.4]]}}}");


var $94e04a64a9ad4ad0$exports = {};
$94e04a64a9ad4ad0$exports = import.meta.resolve("fZHmE");


const $8cf62c73564be5c1$var$SA485_PDF = new URL($94e04a64a9ad4ad0$exports).href;
var $9e92457fe1b59512$exports = {};
$9e92457fe1b59512$exports = import.meta.resolve("5V5z3");


const $8cf62c73564be5c1$var$SA457_PDF = new URL($9e92457fe1b59512$exports).href;
var $19757efff0c50878$exports = {};
$19757efff0c50878$exports = import.meta.resolve("0WStg");


const $8cf62c73564be5c1$var$SA456_PDF = new URL($19757efff0c50878$exports).href;
var $cf187c4cee7af47d$exports = {};
$cf187c4cee7af47d$exports = import.meta.resolve("jNfFP");


const $8cf62c73564be5c1$var$NAT75073_PDF = new URL($cf187c4cee7af47d$exports).href;
const $8cf62c73564be5c1$export$a845b5e7bd57675d = {
    SA485: {
        template: (0, (/*@__PURE__*/$parcel$interopDefault($1b1703fbcffc6055$exports))),
        pdfUrl: $8cf62c73564be5c1$var$SA485_PDF
    },
    SA457: {
        template: (0, (/*@__PURE__*/$parcel$interopDefault($c48405acf7ab0f22$exports))),
        pdfUrl: $8cf62c73564be5c1$var$SA457_PDF
    },
    SA456: {
        template: (0, (/*@__PURE__*/$parcel$interopDefault($8b528239ab8610e5$exports))),
        pdfUrl: $8cf62c73564be5c1$var$SA456_PDF
    }
};
const $8cf62c73564be5c1$var$dollars = (v)=>Math.round(v).toLocaleString('en-AU');
const $8cf62c73564be5c1$var$upper = (s)=>s.toUpperCase();
function $8cf62c73564be5c1$export$7523d08fc4a2877(ff, who, facts = {}) {
    const v = {};
    const p = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, who);
    const couple = (0, $4156d91797dcfac7$export$411666eeb8222a3e)(ff);
    const partner = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, (0, $4156d91797dcfac7$export$dcc5ce7991925d32)(who));
    const c = (0, $4156d91797dcfac7$export$6c7d5c44eeff8f8a)(ff);
    const home = ff?.home || {};
    const protectedPerson = String(home.protectedPerson || 'no');
    const partnerStays = couple && protectedPerson === 'partner';
    v.q1_residential = true;
    v.q2_yes = true; // the form's whole premise; the chooser offers the SA457 otherwise
    if ((0, $4156d91797dcfac7$export$8f1258fd713609e3)(ff)) v.q3_yes = true;
    if (c.onBehalf) {
        v.q4_yes = true;
        v.q4_name = $8cf62c73564be5c1$var$upper(c.name);
        v.q4_relationship = $8cf62c73564be5c1$var$upper(c.relationship);
    } else v.q4_no = true;
    if (couple) v.q5_yes = true;
    else v.q5_no = true;
    if (!couple) v.q6_na = true; // a couple ticks "Yes" themselves, once the partner has been told
    v.q8_you_family = $8cf62c73564be5c1$var$upper(p.last);
    v.q8_you_first = $8cf62c73564be5c1$var$upper(p.first);
    v.q9_you_dob = p.dob;
    if (couple) {
        v.q8_partner_family = $8cf62c73564be5c1$var$upper(partner.last);
        v.q8_partner_first = $8cf62c73564be5c1$var$upper(partner.first);
        v.q9_partner_dob = partner.dob;
    }
    if (p.residency !== 'aged_care') v.q12_option1 = true; // already in care: option 2 needs the entry date
    if (couple) {
        if (partnerStays) v.q13_yes = true;
        else v.q13_no = true;
    }
    if (!(0, $4156d91797dcfac7$export$8f1258fd713609e3)(ff)) return v;
    v.q16_yes = true;
    v.q17_yes = true;
    v.q19_no = true;
    const s = (0, $4156d91797dcfac7$export$cecba97898c85a14)(home.ownership, who, couple);
    const inVillage = ff?.client?.currentResidency === 'retirement_village';
    if (inVillage) {
        v.q20_yes = true;
        v.q20_type = 'RETIREMENT VILLAGE UNIT';
        const entry = (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(ff?.retirementVillage?.entryContribution) || (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.value);
        if (entry > 0) v.q20_value = $8cf62c73564be5c1$var$dollars(entry);
        v.q20_share_you = String(s.you);
        if (couple) v.q20_share_partner = String(s.partner);
        if (couple && partnerStays) v.q20_partner_yes = true;
        else v.q20_partner_no = true;
    } else {
        v.q20_no = true;
        const loan = (0, $4156d91797dcfac7$export$7bda649cebedb52f)(ff);
        const large = !!home.landSize && (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.landSizeValue) > 0;
        const o = large ? 'q22_o2' : 'q22_o1';
        v[`${o}_select`] = true;
        v[`${o}_value`] = $8cf62c73564be5c1$var$dollars(large ? Math.max(0, (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.value) - (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.landSizeValue)) : (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.value));
        if (large) v.q22_o2_remaining = $8cf62c73564be5c1$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.landSizeValue));
        v[`${o}_loan`] = $8cf62c73564be5c1$var$dollars(loan);
        if (!s.entity) {
            v[`${o}_share_you`] = String(s.you);
            if (couple) v[`${o}_share_partner`] = String(s.partner);
            if (s.other) v[`${o}_share_other`] = String(s.other);
        }
        if (partnerStays) v[`${o}_partner_yes`] = true;
        else v[`${o}_partner_no`] = true;
    }
    if (home.businessUse) {
        v.q26_yes = true;
        if ((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.businessUseValue) > 0) v.q26_value = $8cf62c73564be5c1$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.businessUseValue));
    } else {
        v.q26_no = true;
        v.q27_no = true;
    }
    if (home.primaryProductionUse) v.q28_yes = true;
    else v.q28_no = true;
    // Let at the application date: only under a plan that rents the home out (planPosition.ts).
    if (facts.homeRented) v.q30_yes = true;
    else v.q30_no = true;
    if (protectedPerson === 'carer') v.q31_carer = true;
    else if (protectedPerson === 'close_relative') v.q31_relative = true;
    else v.q31_none = true;
    return v;
}
/* ─── SA457 and SA456: every income and asset ──────────────────────────────────────────────────── */ /** The opening questions the SA457 and SA456 share (same numbers on both): on behalf, partner, names, dates of birth, gender, contact. */ function $8cf62c73564be5c1$var$aboutYouValues(v, ff, who) {
    const p = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, who);
    const couple = (0, $4156d91797dcfac7$export$411666eeb8222a3e)(ff);
    const partner = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, (0, $4156d91797dcfac7$export$dcc5ce7991925d32)(who));
    const c = (0, $4156d91797dcfac7$export$6c7d5c44eeff8f8a)(ff);
    if (c.onBehalf) {
        v.q3_yes = true;
        v.q3_name = $8cf62c73564be5c1$var$upper(c.name);
        v.q3_relationship = $8cf62c73564be5c1$var$upper(c.relationship);
    } else v.q3_no = true;
    if (couple) v.q4_yes = true;
    else v.q4_no = true;
    if (!couple) v.q5_na = true;
    const person = (side, x)=>{
        v[`q7_${side}_family`] = $8cf62c73564be5c1$var$upper(x.last);
        v[`q7_${side}_first`] = $8cf62c73564be5c1$var$upper(x.first);
        v[`q8_${side}_dob`] = x.dob;
        if (x.sex === 'male') v[`q9_${side}_male`] = true;
        if (x.sex === 'female') v[`q9_${side}_female`] = true;
        if (x.phone) v[`q11_${side}_phone`] = x.phone.replace(/\s+/g, '');
        if (x.email) v[`q11_${side}_email`] = x.email;
    };
    person('you', p);
    if (couple) person('partner', partner);
}
/** Ownership shares, said from the form-holder's side, into a "you" / "partner" pair of % boxes. */ function $8cf62c73564be5c1$var$shareValues(v, key, ownership, who, couple) {
    const s = (0, $4156d91797dcfac7$export$cecba97898c85a14)(ownership, who, couple);
    if (s.entity) return;
    v[`${key}_share_you`] = String(s.you);
    if (couple) v[`${key}_share_partner`] = String(s.partner);
}
/** Bank accounts to other income, the same profile facts on both forms; entries beyond the form's slots go on a separate sheet. */ function $8cf62c73564be5c1$var$incomeAssetValues(v, ff, who, n, asAt) {
    const couple = (0, $4156d91797dcfac7$export$411666eeb8222a3e)(ff);
    const yesNo = (q, yes)=>{
        if (yes) v[`${q}_yes`] = true;
        else v[`${q}_no`] = true;
    };
    (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'bankAccounts', 'termDeposits').slice(0, n.bank.slots).forEach((a, i)=>{
        const k = `${n.bank.q}_${i + 1}`;
        v[`${k}_name`] = $8cf62c73564be5c1$var$upper(a.description || (a.type === 'termDeposits' ? 'Term deposit' : 'Bank account'));
        v[`${k}_type`] = a.type === 'termDeposits' ? 'TERM DEPOSIT' : 'SAVINGS';
        v[`${k}_balance`] = $8cf62c73564be5c1$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.value ?? a.balance));
        $8cf62c73564be5c1$var$shareValues(v, k, a.ownership, who, couple);
    });
    const supers = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'superannuation', 'accountBasedPensions', 'annuities');
    yesNo(n.super.q, supers.length > 0);
    supers.slice(0, n.super.slots).forEach((a, i)=>{
        const k = `${n.super.q}_${i + 1}`;
        v[`${k}_institution`] = $8cf62c73564be5c1$var$upper(a.description || ({
            superannuation: 'Superannuation',
            accountBasedPensions: 'Account-based pension',
            annuities: 'Annuity'
        })[String(a.type)] || 'Super');
        v[`${k}_balance`] = $8cf62c73564be5c1$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.value));
        if ((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.income) > 0) {
            v[`${k}_income`] = $8cf62c73564be5c1$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.income));
            v[`${k}_often`] = 'YEAR';
        }
        $8cf62c73564be5c1$var$shareValues(v, k, a.ownership ?? who, who, couple);
    });
    const shares = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'shares');
    if (!shares.length) v[`${n.managedNo}_no`] = true; // the profile records shares and managed funds together
    yesNo(n.shares.q, shares.length > 0);
    shares.slice(0, n.shares.slots).forEach((a, i)=>{
        const k = `${n.shares.q}_${i + 1}`;
        v[`${k}_company`] = $8cf62c73564be5c1$var$upper(a.description || 'Share portfolio');
        $8cf62c73564be5c1$var$shareValues(v, k, a.ownership, who, couple);
    });
    v[`${n.bondsNo}_no`] = true;
    // The question covers funeral bonds and funeral contracts already paid for alike.
    const funeral = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'funeralBonds', 'prepaidFuneral');
    yesNo(n.funeral.q, funeral.length > 0);
    funeral.slice(0, n.funeral.slots).forEach((a, i)=>{
        const k = `${n.funeral.q}_${i + 1}`;
        v[`${k}_company`] = $8cf62c73564be5c1$var$upper(a.description || (a.type === 'prepaidFuneral' ? 'Prepaid funeral' : 'Funeral bond'));
        v[`${k}_value`] = $8cf62c73564be5c1$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.value));
        $8cf62c73564be5c1$var$shareValues(v, k, a.ownership ?? who, who, couple);
    });
    const bonds = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'investmentBonds');
    yesNo(n.lifeIns.q, bonds.length > 0);
    bonds.slice(0, n.lifeIns.slots).forEach((a, i)=>{
        const k = `${n.lifeIns.q}_${i + 1}`;
        v[`${k}_product`] = $8cf62c73564be5c1$var$upper(a.description || 'Investment bond');
        $8cf62c73564be5c1$var$shareValues(v, k, a.ownership, who, couple);
    });
    const gifts = (0, $4156d91797dcfac7$export$e0ae14a586691b5)(ff, asAt);
    if (gifts.length) v[`${n.gifts}_yes`] = true;
    else if (ff?.giftsHistory?.confirmedNone) v[`${n.gifts}_no`] = true;
    const overseas = (ff?.income?.otherIncomes || []).filter((i)=>i.type === 'overseasPension');
    yesNo(n.overseas, overseas.length > 0);
    if (overseas[0]) {
        v[`${n.overseas}_1_type`] = $8cf62c73564be5c1$var$upper(overseas[0].description || 'Overseas pension');
        v[`${n.overseas}_1_amount`] = `${$8cf62c73564be5c1$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(overseas[0].amount))} A YEAR`;
    }
    const structures = ff?.structures || [];
    yesNo(n.business, structures.some((s)=>s.type === 'partnership'));
    yesNo(n.trust, structures.some((s)=>s.type === 'family_trust' || s.type === 'unit_trust'));
    yesNo(n.company, structures.some((s)=>s.type === 'private_company'));
    const other = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'other');
    yesNo(n.otherAssets.q, other.length > 0);
    other.slice(0, n.otherAssets.slots).forEach((a, i)=>{
        const k = `${n.otherAssets.q}_${i + 1}`;
        v[`${k}_description`] = $8cf62c73564be5c1$var$upper(a.description || 'Other asset');
        v[`${k}_value`] = $8cf62c73564be5c1$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.value));
        $8cf62c73564be5c1$var$shareValues(v, k, a.ownership, who, couple);
    });
    const loans = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'loansToOthers');
    yesNo(n.loans.q, loans.length > 0);
    loans.slice(0, n.loans.slots).forEach((a, i)=>{
        const k = `${n.loans.q}_${i + 1}`;
        v[`${k}_who`] = $8cf62c73564be5c1$var$upper(a.description || 'Loan');
        if (a.commencementDate) v[`${k}_date`] = String(a.commencementDate);
        if ((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.purchasePrice) > 0) v[`${k}_amount`] = $8cf62c73564be5c1$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.purchasePrice));
        v[`${k}_balance`] = $8cf62c73564be5c1$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.value));
        $8cf62c73564be5c1$var$shareValues(v, k, a.ownership, who, couple);
    });
    const incomes = (ff?.income?.otherIncomes || []).filter((i)=>i.type === 'salary' || i.type === 'other' || i.type === 'boarders' || i.type === 'dvaWarWidow' || i.type === 'dvaDisability');
    yesNo(n.otherIncome.q, incomes.length > 0);
    incomes.slice(0, n.otherIncome.slots).forEach((inc, i)=>{
        const k = `${n.otherIncome.q}_${i + 1}`;
        v[`${k}_type`] = $8cf62c73564be5c1$var$upper(inc.description || ({
            salary: 'Salary or wages',
            other: 'Other income',
            boarders: 'Board and lodging',
            dvaWarWidow: "DVA war widow(er)'s pension",
            dvaDisability: 'DVA disability pension'
        })[String(inc.type)] || 'Income');
        v[`${k}_gross`] = `${$8cf62c73564be5c1$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(inc.amount))} per YEAR`;
    });
}
function $8cf62c73564be5c1$export$ee5fe45f48db377b(ff, who, asAt = new Date(), facts = {}) {
    const v = {};
    const p = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, who);
    const couple = (0, $4156d91797dcfac7$export$411666eeb8222a3e)(ff);
    const home = ff?.home || {};
    const protectedPerson = String(home.protectedPerson || 'no');
    const partnerStays = couple && protectedPerson === 'partner';
    v.q1_residential = true;
    v.q2_no = true; // the SA457 is for someone NOT on a means-tested payment
    $8cf62c73564be5c1$var$aboutYouValues(v, ff, who);
    v.q14_yes = true;
    if (p.residency !== 'aged_care') v.q15_option1 = true;
    if (couple) {
        if (partnerStays) v.q16_yes = true;
        else v.q16_no = true;
    }
    if ((0, $4156d91797dcfac7$export$8f1258fd713609e3)(ff)) {
        v.q19_yes = true;
        v.q20_yes = true;
        v.q22_no = true;
        const s = (0, $4156d91797dcfac7$export$cecba97898c85a14)(home.ownership, who, couple);
        if (ff?.client?.currentResidency === 'retirement_village') {
            v.q23_yes = true;
            v.q23_type = 'RETIREMENT VILLAGE UNIT';
            const entry = (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(ff?.retirementVillage?.entryContribution) || (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.value);
            if (entry > 0) v.q23_value = $8cf62c73564be5c1$var$dollars(entry);
            v.q23_share_you = String(s.you);
            if (couple) v.q23_share_partner = String(s.partner);
            if (partnerStays) v.q23_partner_yes = true;
            else v.q23_partner_no = true;
        } else {
            v.q23_no = true;
            const large = !!home.landSize && (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.landSizeValue) > 0;
            const o = large ? 'q25_o2' : 'q25_o1';
            v[`${o}_select`] = true;
            v[`${o}_value`] = $8cf62c73564be5c1$var$dollars(large ? Math.max(0, (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.value) - (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.landSizeValue)) : (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.value));
            if (large) v.q25_o2_remaining = $8cf62c73564be5c1$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.landSizeValue));
            v[`${o}_loan`] = $8cf62c73564be5c1$var$dollars((0, $4156d91797dcfac7$export$7bda649cebedb52f)(ff));
            if (!s.entity) {
                v[`${o}_share_you`] = String(s.you);
                if (couple) v[`${o}_share_partner`] = String(s.partner);
                if (s.other) v[`${o}_share_other`] = String(s.other);
            }
            if (partnerStays) v[`${o}_partner_yes`] = true;
            else v[`${o}_partner_no`] = true;
        }
        if (home.businessUse) {
            v.q29_yes = true;
            if ((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.businessUseValue) > 0) v.q29_value = $8cf62c73564be5c1$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.businessUseValue));
        } else {
            v.q29_no = true;
            v.q30_no = true;
        }
        if (home.primaryProductionUse) v.q31_yes = true;
        else v.q31_no = true;
        // Rental income from the home at the entry date: under a plan that lets it (planPosition.ts).
        if (facts.homeRented) v.q33_yes = true;
        else v.q33_no = true;
        if (protectedPerson === 'carer') v.q34_carer = true;
        else if (protectedPerson === 'close_relative') v.q34_relative = true;
        else v.q34_none = true;
    } else v.q19_no = true;
    const ip = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'investmentProperty')[0];
    if (ip) {
        v.q38_yes = true;
        const s = (0, $4156d91797dcfac7$export$cecba97898c85a14)(ip.ownership, who, couple);
        if (!s.entity) {
            if (s.you > 0) {
                v.q40_you = true;
                v.q40_share_you = String(s.you);
            }
            if (couple && s.partner > 0) {
                v.q40_partner = true;
                v.q40_share_partner = String(s.partner);
            }
        }
        v.q42_value = $8cf62c73564be5c1$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(ip.value));
        if ((0, $4156d91797dcfac7$export$5d71e490b6ce5ee1)(ff, ip.id) > 0) v.q45_yes = true;
        else v.q45_no = true;
        if ((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(ip.rent) > 0) v.q46_yes = true;
        else v.q46_no = true;
    } else v.q38_no = true;
    $8cf62c73564be5c1$var$incomeAssetValues(v, ff, who, {
        bank: {
            q: 'q50',
            slots: 2
        },
        super: {
            q: 'q51',
            slots: 2
        },
        managedNo: 'q52',
        shares: {
            q: 'q53',
            slots: 2
        },
        bondsNo: 'q54',
        funeral: {
            q: 'q55',
            slots: 2
        },
        lifeIns: {
            q: 'q56',
            slots: 2
        },
        gifts: 'q59',
        overseas: 'q60',
        business: 'q61',
        trust: 'q62',
        company: 'q64',
        otherAssets: {
            q: 'q65',
            slots: 2
        },
        otherIncome: {
            q: 'q66',
            slots: 2
        },
        loans: {
            q: 'q58',
            slots: 2
        }
    }, asAt);
    const rad = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'radPaid');
    if (rad.length) {
        v.q57_yes = true;
        v.q57_amount = $8cf62c73564be5c1$var$dollars(rad.reduce((t, a)=>t + (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.value), 0));
    } else v.q57_no = true;
    return v;
}
function $8cf62c73564be5c1$export$1e2af3bd183e7b5c(ff, who, asAt = new Date()) {
    const v = {};
    const couple = (0, $4156d91797dcfac7$export$411666eeb8222a3e)(ff);
    const home = ff?.home || {};
    v.q1_option1 = true;
    v.q2_no = true;
    $8cf62c73564be5c1$var$aboutYouValues(v, ff, who);
    v.q15_yes = true;
    v.q17_no = true; // no part of the home let at the start date
    if ((0, $4156d91797dcfac7$export$8f1258fd713609e3)(ff)) {
        v.q18_yes = true;
        if (home.businessUse || home.landSize || home.separateTitles) v.q20_yes = true;
        else v.q20_no = true;
    } else {
        v.q18_no = true;
        v.q19_no = true;
    }
    const ips = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'investmentProperty');
    const ip = ips[0];
    if (ip) {
        v.q27_yes = true;
        v.q28_count = String(ips.length);
        const s = (0, $4156d91797dcfac7$export$cecba97898c85a14)(ip.ownership, who, couple);
        if (!s.entity) {
            if (s.you > 0) {
                v.q31_you = true;
                v.q31_share_you = String(s.you);
            }
            if (couple && s.partner > 0) {
                v.q31_partner = true;
                v.q31_share_partner = String(s.partner);
            }
        }
        if ((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(ip.rent) > 0) v.q32_yes = true;
        else v.q32_no = true;
        v.q34_value = $8cf62c73564be5c1$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(ip.value));
        if ((0, $4156d91797dcfac7$export$5d71e490b6ce5ee1)(ff, ip.id) > 0) v.q37_yes = true;
        else v.q37_no = true;
    } else v.q27_no = true;
    $8cf62c73564be5c1$var$incomeAssetValues(v, ff, who, {
        bank: {
            q: 'q39',
            slots: 4
        },
        super: {
            q: 'q40',
            slots: 2
        },
        managedNo: 'q41',
        shares: {
            q: 'q42',
            slots: 2
        },
        bondsNo: 'q43',
        funeral: {
            q: 'q44',
            slots: 2
        },
        lifeIns: {
            q: 'q45',
            slots: 2
        },
        gifts: 'q47',
        overseas: 'q48',
        business: 'q49',
        trust: 'q50',
        company: 'q52',
        otherAssets: {
            q: 'q56',
            slots: 2
        },
        otherIncome: {
            q: 'q53',
            slots: 2
        },
        loans: {
            q: 'q46',
            slots: 2
        }
    }, asAt);
    return v;
}
function $8cf62c73564be5c1$export$7662070e9355b6(code, ff, who, facts = {}) {
    switch(code){
        case 'SA485':
            return $8cf62c73564be5c1$export$7523d08fc4a2877(ff, who, facts);
        case 'SA457':
            return $8cf62c73564be5c1$export$ee5fe45f48db377b(ff, who, new Date(), facts);
        case 'SA456':
            return $8cf62c73564be5c1$export$1e2af3bd183e7b5c(ff, who);
        default:
            return {};
    }
}
function $8cf62c73564be5c1$export$b07a2e8b04f87d32(ff, who, amount) {
    const p = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, who);
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(p.dob);
    const fund = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'superannuation', 'accountBasedPensions').filter((a)=>!a.ownership || a.ownership === who)[0];
    return {
        contactFamilyName: $8cf62c73564be5c1$var$upper(p.last),
        contactGivenName: $8cf62c73564be5c1$var$upper(p.first),
        ...m ? {
            dateDay: m[3],
            dateMonth: m[2],
            dateYear: m[1]
        } : {},
        ...fund?.description ? {
            'super-fund-name-line1': $8cf62c73564be5c1$var$upper(fund.description)
        } : {},
        ...p.phone ? {
            daytimePhone: p.phone.replace(/\s+/g, '')
        } : {},
        ...p.email ? {
            Email: p.email
        } : {},
        ...amount > 0 ? {
            contributionAmount: $8cf62c73564be5c1$var$dollars(Math.min(amount, 300000))
        } : {},
        'dec-1-name': $8cf62c73564be5c1$var$upper(p.full)
    };
}
async function $8cf62c73564be5c1$export$40137196adc0e44b(ff, who, amount) {
    const bytes = await (await fetch($8cf62c73564be5c1$var$NAT75073_PDF)).arrayBuffer();
    const filled = await (0, $0faadd6209986a1b$export$5e771c05ac100c56)(bytes, $8cf62c73564be5c1$export$b07a2e8b04f87d32(ff, who, amount), {
        title: "Downsizer contribution into superannuation \u2014 pre-filled",
        subject: 'NAT 75073-07.2022, pre-filled from the client profile. Source: ato.gov.au.'
    });
    (0, $0faadd6209986a1b$export$86f71714311cd923)(filled, `NAT75073_${(0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, who).first || 'Client'}_prefilled_${new Date().toISOString().slice(0, 10)}.pdf`);
}
async function $8cf62c73564be5c1$export$6ac59097a38cfe74(code, ff, who, opts = {}) {
    const { template: template, pdfUrl: pdfUrl } = $8cf62c73564be5c1$export$a845b5e7bd57675d[code];
    const bytes = await (await fetch(pdfUrl)).arrayBuffer();
    const filled = await (0, $0faadd6209986a1b$export$22e79b29233763fd)(bytes, template, $8cf62c73564be5c1$export$7662070e9355b6(code, ff, who, opts.facts));
    const name = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, who).first || 'Client';
    (0, $0faadd6209986a1b$export$86f71714311cd923)(filled, `${code}_${name}_${opts.afterPlan ? 'after-plan' : 'prefilled'}_${new Date().toISOString().slice(0, 10)}.pdf`);
}


const $f476351fdad6ba1d$export$90f485777e0c3396 = 'https://my.gov.au';
function $f476351fdad6ba1d$export$3a432508c5e373b2(ff, setting, receivesPension) {
    if (setting === 'home') return receivesPension ? 'none' : 'SA456';
    if (!receivesPension) return 'SA457';
    return (0, $4156d91797dcfac7$export$8f1258fd713609e3)(ff) ? 'SA485' : 'none';
}
/** The latest saved plan of a type — the documents quote the plan the client chose, not a default. */ function $f476351fdad6ba1d$var$latestPlan(saved, type) {
    const rows = (saved || []).filter((s)=>s?.type === type);
    if (!rows.length) return null;
    return rows.slice().sort((a, b)=>String(a.createdAt || '').localeCompare(String(b.createdAt || ''))).pop() || null;
}
function $f476351fdad6ba1d$export$215d3fa65273cf13(saved, who) {
    const details = $f476351fdad6ba1d$var$latestPlan(saved, 'downsizer')?.inputs?.details || {};
    return (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(who === 'partner' ? details.partnerDownsizerContribution : details.downsizerContribution);
}
function $f476351fdad6ba1d$export$cf084c1d08c32aad(saved) {
    const vi = $f476351fdad6ba1d$var$latestPlan(saved, 'retirement_village')?.inputs?.villageInputs || {};
    return (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(vi.entryFee);
}
function $f476351fdad6ba1d$export$3e9ad1b4f23356ec(id, ctx) {
    const ff = ctx.factFind;
    const now = ()=>new Date().toISOString();
    const first = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, 'client').first || 'Client';
    switch(id){
        case 'assessment_application':
        case 'assessment_application_home':
            return {
                id: id,
                label: 'Assessment application details',
                action: {
                    kind: 'sheet',
                    build: ()=>(0, $5c498757507ee8ef$export$6a38bc9ff3623d28)(ff, {
                            who: (0, $4156d91797dcfac7$export$90b433c608c179c0)(ff),
                            generatedAt: now(),
                            forHomeCare: id === 'assessment_application_home'
                        }),
                    fileStem: `AgedCareAssessment_${first}`
                }
            };
        case 'means_assessment':
            {
                const form = $f476351fdad6ba1d$export$3a432508c5e373b2(ff, 'residential', ctx.receivesPension);
                return {
                    id: id,
                    label: form === 'none' ? 'Which form do I need?' : `${form} pre-filled`,
                    action: {
                        kind: 'means',
                        setting: 'residential'
                    }
                };
            }
        case 'means_assessment_home':
            {
                const form = $f476351fdad6ba1d$export$3a432508c5e373b2(ff, 'home', ctx.receivesPension);
                return {
                    id: id,
                    label: form === 'none' ? 'Which form do I need?' : `${form} pre-filled`,
                    action: {
                        kind: 'means',
                        setting: 'home'
                    }
                };
            }
        case 'move_in_checklist':
            return {
                id: id,
                label: 'Move-in checklist',
                action: {
                    kind: 'sheet',
                    build: ()=>(0, $5c498757507ee8ef$export$e6b062ec77e80f40)(ff, {
                            generatedAt: now()
                        }),
                    fileStem: `MoveInChecklist_${first}`
                }
            };
        case 'village_contract_checklist':
            return {
                id: id,
                label: 'Contract questions',
                action: {
                    kind: 'sheet',
                    build: ()=>(0, $5c498757507ee8ef$export$f202907573a49b9b)(ff, {
                            generatedAt: now()
                        }),
                    fileStem: `VillageContractQuestions_${first}`
                }
            };
        case 'village_report':
            return {
                id: id,
                label: 'What to tell Services Australia',
                action: {
                    kind: 'sheet',
                    build: ()=>(0, $5c498757507ee8ef$export$e293fe3471f8411e)(ff, {
                            generatedAt: now(),
                            entryContribution: $f476351fdad6ba1d$export$cf084c1d08c32aad(ctx.savedStrategies)
                        }),
                    fileStem: `VillageMove_ServicesAustralia_${first}`
                }
            };
        case 'moving_checklist_village':
            return {
                id: id,
                label: 'Moving checklist',
                action: {
                    kind: 'sheet',
                    build: ()=>(0, $5c498757507ee8ef$export$6723dea4880a8d68)(ff, {
                            generatedAt: now(),
                            selling: (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(ff?.home?.value) > 0
                        }),
                    fileStem: `MovingChecklist_${first}`
                }
            };
        case 'moving_checklist_sale':
            return {
                id: id,
                label: 'Selling and moving checklist',
                action: {
                    kind: 'sheet',
                    build: ()=>(0, $5c498757507ee8ef$export$6723dea4880a8d68)(ff, {
                            generatedAt: now(),
                            selling: true
                        }),
                    fileStem: `MovingChecklist_${first}`
                }
            };
        case 'downsizer_contribution':
            // Only where the plan the client saved actually tops up super: the form is meaningless otherwise.
            if ($f476351fdad6ba1d$export$215d3fa65273cf13(ctx.savedStrategies, 'client') <= 0) return null;
            return {
                id: id,
                label: 'Downsizer contribution form (NAT 75073)',
                action: {
                    kind: 'official',
                    open: ()=>(0, $8cf62c73564be5c1$export$40137196adc0e44b)(ff, 'client', $f476351fdad6ba1d$export$215d3fa65273cf13(ctx.savedStrategies, 'client'))
                }
            };
        case 'family_guide':
            return {
                id: id,
                label: 'Family discussion guide',
                action: {
                    kind: 'page',
                    page: 'GrannyFlatPage',
                    section: 'guide'
                }
            };
        case 'solicitor_brief':
            return {
                id: id,
                label: 'Solicitor brief',
                action: {
                    kind: 'page',
                    page: 'GrannyFlatPage',
                    section: 'guide'
                }
            };
        case 'pension_claim':
            return {
                id: id,
                label: 'Claim the Age Pension (SA002 and SA369 pre-filled)',
                action: {
                    kind: 'pension_claim'
                }
            };
        case 'report_change':
            return {
                id: id,
                label: 'Report it in myGov',
                action: {
                    kind: 'link',
                    url: $f476351fdad6ba1d$export$90f485777e0c3396
                }
            };
        case 'granny_flat_report':
            return {
                id: id,
                label: 'What to tell Services Australia',
                action: {
                    kind: 'sheet',
                    build: ()=>(0, $5c498757507ee8ef$export$6a62f3ce9569e7a5)(ff, {
                            generatedAt: now()
                        }),
                    fileStem: `GrannyFlat_ServicesAustralia_${first}`
                }
            };
        default:
            return null;
    }
}
function $f476351fdad6ba1d$export$340875935d3c532d(chip) {
    if (chip.action.kind === 'sheet') (0, $6e8c599c5d82cc63$export$69a28af8f8bbe07c)(chip.action.build(), chip.action.fileStem);
}
function $f476351fdad6ba1d$export$8247bb8a998ec896(ctx) {
    if (!(0, $4156d91797dcfac7$export$411666eeb8222a3e)(ctx.factFind) || $f476351fdad6ba1d$export$215d3fa65273cf13(ctx.savedStrategies, 'partner') <= 0) return null;
    const name = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ctx.factFind, 'partner').first || 'Partner';
    return {
        id: 'downsizer_contribution',
        label: `NAT 75073 for ${name}`,
        action: {
            kind: 'official',
            open: ()=>(0, $8cf62c73564be5c1$export$40137196adc0e44b)(ctx.factFind, 'partner', $f476351fdad6ba1d$export$215d3fa65273cf13(ctx.savedStrategies, 'partner'))
        }
    };
}



/**
 * Claiming the Age Pension: Services Australia's SA002 (Claim for Age Pension) and the SA369
 * (Income and assets) that goes with it, pre-filled from the profile.
 *
 * Unlike the means-assessment forms these two are fillable PDFs, so the answers go into their own
 * named fields and the client can still type into everything else. The pension is not paid
 * automatically: someone who becomes eligible under a plan has to claim it — online through myGov,
 * or on these two forms. Once it is granted, the residential care means assessment needs only the
 * SA485 (or nothing, for someone without a home), not the SA457.
 *
 * As with every pre-filled form, only what the profile knows is written. Reference numbers,
 * addresses, the bank account for payments, the tax file number, relationship history, travel and
 * residence, and the declarations are the client's.
 */ 

var $6fa5ee5625aa6581$exports = {};
$6fa5ee5625aa6581$exports = import.meta.resolve("fXpAl");


const $74f3be2c35d1f42f$var$SA002_PDF = new URL($6fa5ee5625aa6581$exports).href;
var $bd98fbdb829b09a2$exports = {};
$bd98fbdb829b09a2$exports = import.meta.resolve("dU3dZ");


const $74f3be2c35d1f42f$var$SA369_PDF = new URL($bd98fbdb829b09a2$exports).href;
var $898bc0070953cde7$exports = {};
$898bc0070953cde7$exports = import.meta.resolve("eTsfL");


const $74f3be2c35d1f42f$var$MODR_PDF = new URL($898bc0070953cde7$exports).href;
const $74f3be2c35d1f42f$export$908ff717015478cd = {
    SA002: 'SA002.2608',
    SA369: 'SA369.2606'
};
const $74f3be2c35d1f42f$export$bcd5931613b5dd4a = {
    SA002: $74f3be2c35d1f42f$var$SA002_PDF,
    SA369: $74f3be2c35d1f42f$var$SA369_PDF
};
const $74f3be2c35d1f42f$var$dollars = (v)=>Math.round(v).toLocaleString('en-AU');
const $74f3be2c35d1f42f$var$upper = (s)=>s.toUpperCase();
const $74f3be2c35d1f42f$var$yn = (b)=>b ? 'Yes' : 'No';
function $74f3be2c35d1f42f$var$dmy(dob) {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(dob);
    return m ? {
        d: m[3],
        m: m[2],
        y: m[1]
    } : null;
}
/** A phone number goes in the mobile box when it looks like one, otherwise the home phone box. */ function $74f3be2c35d1f42f$var$phoneBox(phone) {
    return /^(\+?61|0)4/.test(phone.replace(/\s+/g, '')) ? 'Mobile' : 'HomePhone';
}
/** The SA002's "where do you live" options, from the profile's living arrangement. */ const $74f3be2c35d1f42f$var$ACCOMMODATION = {
    renting: '1',
    own_home: '2',
    aged_care: '7',
    retirement_village: '8',
    with_family: '10'
};
function $74f3be2c35d1f42f$export$d06da0cc31112c3e(ff, claimants) {
    const v = {};
    const couple = (0, $4156d91797dcfac7$export$411666eeb8222a3e)(ff);
    const you = claimants[0] ?? 'client';
    const bothClaim = couple && claimants.length > 1;
    v.Q1 = $74f3be2c35d1f42f$var$yn(couple);
    if (couple) {
        v.Q2 = $74f3be2c35d1f42f$var$yn(bothClaim);
        if (bothClaim) v.Q3 = 'This form';
    }
    const person = (who, prefix)=>{
        const p = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, who);
        if (p.last) v[`${prefix.name}.FamilyName`] = $74f3be2c35d1f42f$var$upper(p.last);
        if (p.first) v[`${prefix.name}.FirstGivenName`] = $74f3be2c35d1f42f$var$upper(p.first);
        const d = $74f3be2c35d1f42f$var$dmy(p.dob);
        if (d) {
            v[`${prefix.dob}.D`] = d.d;
            v[`${prefix.dob}.M`] = d.m;
            v[`${prefix.dob}.Y`] = d.y;
        }
        if (p.sex === 'male') v[prefix.gender] = 'Male';
        if (p.sex === 'female') v[prefix.gender] = 'Female';
        if (p.phone) v[`${prefix.contact}.${$74f3be2c35d1f42f$var$phoneBox(p.phone)}`] = p.phone.replace(/\s+/g, '');
        if (p.email) v[`${prefix.contact}.Email_Internet`] = p.email;
    };
    person(you, {
        name: 'Q5Y',
        dob: 'Q6Y',
        gender: 'Q11Y',
        contact: 'Q14Y'
    });
    if (bothClaim) person((0, $4156d91797dcfac7$export$dcc5ce7991925d32)(you), {
        name: 'P.Q5YP',
        dob: 'P.Q6YP',
        gender: 'P.Q11YP',
        contact: 'P.Q14YP'
    });
    // Living together, and the home they do not live in when one of them is in care.
    const residency = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, you).residency;
    if (couple) {
        const apart = residency !== (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, (0, $4156d91797dcfac7$export$dcc5ce7991925d32)(you)).residency && (residency === 'aged_care' || (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, (0, $4156d91797dcfac7$export$dcc5ce7991925d32)(you)).residency === 'aged_care');
        v.Q36 = $74f3be2c35d1f42f$var$yn(!apart);
    }
    const inCare = residency === 'aged_care';
    if ((0, $4156d91797dcfac7$export$8f1258fd713609e3)(ff)) {
        v.Q44 = $74f3be2c35d1f42f$var$yn(inCare && (!couple || (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, (0, $4156d91797dcfac7$export$dcc5ce7991925d32)(you)).residency === 'aged_care'));
        if (v.Q44 === 'Yes') v.Q45 = 'Receiving care in a nursing home';
    } else v.Q44 = 'No';
    const accommodation = $74f3be2c35d1f42f$var$ACCOMMODATION[residency || ((0, $4156d91797dcfac7$export$8f1258fd713609e3)(ff) ? 'own_home' : '')];
    if (accommodation) v.Q47 = accommodation;
    return v;
}
function $74f3be2c35d1f42f$export$9c36a0b15197649a(ff, claimants, asAt = new Date(), facts = {}) {
    const v = {};
    const couple = (0, $4156d91797dcfac7$export$411666eeb8222a3e)(ff);
    const who = claimants[0] ?? 'client';
    const share = (k, ownership)=>{
        const s = (0, $4156d91797dcfac7$export$cecba97898c85a14)(ownership, who, couple);
        if (s.entity) return;
        v[k.you] = String(s.you);
        if (couple) v[k.partner] = String(s.partner);
    };
    const owner = (key, ownership)=>{
        const s = (0, $4156d91797dcfac7$export$cecba97898c85a14)(ownership ?? who, who, couple);
        if (s.you >= s.partner && s.you > 0) v[key] = 'You';
        else if (s.partner > 0) v[key] = 'Partner';
    };
    const p = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, who);
    if (p.last) v['Q2.FamilyName'] = $74f3be2c35d1f42f$var$upper(p.last);
    if (p.first) v['Q2.FirstName'] = $74f3be2c35d1f42f$var$upper(p.first);
    const d = $74f3be2c35d1f42f$var$dmy(p.dob);
    if (d) {
        v['Q3.D'] = d.d;
        v['Q3.M'] = d.m;
        v['Q3.Y'] = d.y;
    }
    v.Q4 = $74f3be2c35d1f42f$var$yn(couple);
    if (couple) {
        const q = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, (0, $4156d91797dcfac7$export$dcc5ce7991925d32)(who));
        if (q.last) v['Q6.FamilyName'] = $74f3be2c35d1f42f$var$upper(q.last);
        if (q.first) v['Q6.FirstName'] = $74f3be2c35d1f42f$var$upper(q.first);
        const qd = $74f3be2c35d1f42f$var$dmy(q.dob);
        if (qd) {
            v['Q7.D'] = qd.d;
            v['Q7.M'] = qd.m;
            v['Q7.Y'] = qd.y;
        }
    }
    const incomes = ff?.income?.otherIncomes || [];
    const whoGets = (ownership)=>(0, $4156d91797dcfac7$export$cecba97898c85a14)(ownership ?? 'client', who, couple).you >= 50 ? 'You' : 'Partner';
    const salaries = incomes.filter((i)=>i.type === 'salary');
    v.Q8Q = $74f3be2c35d1f42f$var$yn(salaries.length > 0);
    salaries.slice(0, 2).forEach((inc, i)=>{
        v[`Q8.PersonWorking${i + 1}`] = whoGets(inc.ownership);
    });
    v.Q10 = 'No'; // claiming the Age Pension, not Carer Payment, DSP or Farm Household Allowance
    v.Q12 = 'No';
    // Business, private trusts and private companies: the profile's structures.
    const structures = ff?.structures || [];
    v.Q16 = $74f3be2c35d1f42f$var$yn(structures.some((x)=>x.type === 'partnership'));
    v.Q17 = $74f3be2c35d1f42f$var$yn(structures.some((x)=>x.type === 'family_trust' || x.type === 'unit_trust'));
    v.Q23 = $74f3be2c35d1f42f$var$yn(structures.some((x)=>x.type === 'private_company'));
    // Money from outside Australia: the overseas pensions in the profile.
    const overseas = incomes.filter((i)=>i.type === 'overseasPension');
    v.Q31Q = $74f3be2c35d1f42f$var$yn(overseas.length > 0);
    overseas.slice(0, 2).forEach((inc, i)=>{
        const n = i + 1;
        v[`Q31.PaymentType${n}`] = $74f3be2c35d1f42f$var$upper(inc.description || 'Overseas pension');
        v[`Q31.PaidTo${n}`] = whoGets(inc.ownership);
    });
    // Boarders and lodgers: the profile's board income, a fortnight, with the meals that come with it.
    const boarders = incomes.filter((i)=>i.type === 'boarders');
    v.Q32 = $74f3be2c35d1f42f$var$yn(boarders.length > 0);
    boarders.slice(0, 2).forEach((inc, i)=>{
        const n = i + 1;
        v[`Q32_Details.Name_${n}`] = $74f3be2c35d1f42f$var$upper(inc.description || 'Boarder');
        v[`Q32_Details.NoOfMeals_${n}`] = inc.boardType === 'board' ? '3' : inc.boardType === 'bedAndBreakfast' ? '1' : '0';
        v[`Q32_Details.Amount_${n}`] = $74f3be2c35d1f42f$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(inc.amount) / 26);
        share({
            you: `Q32_Details.YourShare_${n}`,
            partner: `Q32_Details.PartnerShare_${n}`
        }, inc.ownership ?? 'client');
    });
    (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'bankAccounts', 'termDeposits').slice(0, 6).forEach((a, i)=>{
        const n = i + 1;
        v[`Q35.BankName_${n}`] = $74f3be2c35d1f42f$var$upper(a.description || (a.type === 'termDeposits' ? 'Term deposit' : 'Bank account'));
        v[`Q35.Bal_${n}`] = $74f3be2c35d1f42f$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.value ?? a.balance));
        share({
            you: `Q35.YourShare_${n}`,
            partner: `Q35.PartnerShare_${n}`
        }, a.ownership);
    });
    // Personal assets: vehicles in their own question, contents and the rest as household contents.
    const personal = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'personalAssets');
    const isBoat = (s)=>/\b(boat|boats|caravan|caravans|motorhome|motor home|campervan|trailer sailer|yacht|jet ?ski)\b/i.test(s);
    const isVehicle = (s)=>!isBoat(s) && /\b(car|cars|vehicle|ute|van|truck|motorbike|motorcycle)\b/i.test(s);
    const vehicles = personal.filter((a)=>isVehicle(String(a.description || '')));
    const boats = personal.filter((a)=>isBoat(String(a.description || '')));
    const contents = personal.filter((a)=>!isVehicle(String(a.description || '')) && !isBoat(String(a.description || '')));
    const contentsTotal = contents.reduce((t, a)=>t + (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.value), 0);
    if (contentsTotal > 0) {
        v['Q36.Amount'] = $74f3be2c35d1f42f$var$dollars(contentsTotal);
        share({
            you: 'Q36.YourShare',
            partner: 'Q36PartnerShare'
        }, contents[0].ownership);
    }
    v.Q37Q = $74f3be2c35d1f42f$var$yn(vehicles.length > 0);
    vehicles.slice(0, 2).forEach((a, i)=>{
        const n = i + 1;
        v[`Q37.AssetType_${n}`] = $74f3be2c35d1f42f$var$upper(a.description || 'Car');
        v[`Q37.MValue_${n}`] = $74f3be2c35d1f42f$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.value));
        share({
            you: `Q37.YourShare_${n}`,
            partner: `Q37.PartnerShare_${n}`
        }, a.ownership);
    });
    v.Q38Q = $74f3be2c35d1f42f$var$yn(boats.length > 0);
    boats.slice(0, 2).forEach((a, i)=>{
        const n = i + 1;
        v[`Q38.AssetTYpe_${n}`] = $74f3be2c35d1f42f$var$upper(a.description || 'Boat or caravan');
        v[`Q38.MValue_${n}`] = $74f3be2c35d1f42f$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.value));
        share({
            you: `Q38.YourShare_${n}`,
            partner: `Q38.PartnerShare_${n}`
        }, a.ownership);
    });
    const home = ff?.home || {};
    v.Q39 = $74f3be2c35d1f42f$var$yn((0, $4156d91797dcfac7$export$8f1258fd713609e3)(ff));
    if ((0, $4156d91797dcfac7$export$8f1258fd713609e3)(ff)) {
        v.Q40 = $74f3be2c35d1f42f$var$yn(!!home.landSize);
        v.Q41 = $74f3be2c35d1f42f$var$yn(!!home.separateTitles);
        v.Q42 = $74f3be2c35d1f42f$var$yn(!!home.businessUse);
    }
    const ips = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'investmentProperty');
    // A former home let out while living in a village is other real estate too (planPosition.ts).
    const otherProperties = ips.length + (facts.homeRented && !facts.enteringCare ? 1 : 0);
    v.Q43 = $74f3be2c35d1f42f$var$yn(otherProperties > 0);
    if (otherProperties) v.Q44 = String(otherProperties);
    /*
     * Q33, a former home let out after entering care: answered under a plan that does it. Without
     * a plan it is "No" for someone not in care, and left for the client otherwise.
     */ if (facts.enteringCare) v.Q33 = $74f3be2c35d1f42f$var$yn(!!facts.homeRented);
    else if ((0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, who).residency !== 'aged_care') v.Q33 = 'No';
    const supers = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'superannuation');
    v.Q45Q = $74f3be2c35d1f42f$var$yn(supers.length > 0);
    supers.slice(0, 2).forEach((a, i)=>{
        const n = i + 1;
        v[`Q45.ManagerName_${n}`] = $74f3be2c35d1f42f$var$upper(a.description || 'Superannuation');
        v[`Q45.MValue_${n}`] = $74f3be2c35d1f42f$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.value));
        owner(`Q45.Ownedby_${n}`, a.ownership);
    });
    const streams = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'accountBasedPensions', 'annuities');
    v.Q46Q = $74f3be2c35d1f42f$var$yn(streams.length > 0);
    streams.slice(0, 2).forEach((a, i)=>{
        const n = i + 1;
        v[`Q46.ProductProvider_${n}`] = $74f3be2c35d1f42f$var$upper(a.description || (a.type === 'annuities' ? 'Annuity' : 'Account-based pension'));
        v[`Q46.Type_${n}`] = a.type === 'annuities' ? 'ANNUITY' : 'ACCOUNT-BASED PENSION';
        owner(`Q46.Ownedby_${n}`, a.ownership);
    });
    const shares = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'shares');
    v.Q47Q = $74f3be2c35d1f42f$var$yn(shares.length > 0);
    if (!shares.length) {
        v.Q48Q = 'No';
        v.Q49Q = 'No';
        v.Q50Q = 'No';
    }
    v.Q51Q = 'No'; // government bonds and debentures: not something the profile records
    shares.slice(0, 4).forEach((a, i)=>{
        const n = i + 1;
        v[`Q47.CompanyName_${n}`] = $74f3be2c35d1f42f$var$upper(a.description || 'Share portfolio');
        share({
            you: `Q47.YourShare_${n}`,
            partner: `Q47.PartnerShare_${n}`
        }, a.ownership);
    });
    // Money on loan: who, when, how much, what is still owed, and whose.
    const loans = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'loansToOthers');
    v.Q52Q = $74f3be2c35d1f42f$var$yn(loans.length > 0);
    loans.slice(0, 2).forEach((a, i)=>{
        const n = i + 1;
        v[`Q52.WhoTo_${n}`] = $74f3be2c35d1f42f$var$upper(a.description || 'Loan');
        const dd = $74f3be2c35d1f42f$var$dmy(String(a.commencementDate || ''));
        if (dd) {
            v[`Q52.DateLent.${n}.D`] = dd.d;
            v[`Q52.DateLent.${n}.M`] = dd.m;
            v[`Q52.DateLent.${n}.Y`] = dd.y;
        }
        if ((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.purchasePrice) > 0) v[`Q52.Amount_${n}`] = $74f3be2c35d1f42f$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.purchasePrice));
        v[`Q52.Balance_${n}`] = $74f3be2c35d1f42f$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.value));
        share({
            you: `Q52.You_${n}`,
            partner: `Q52.Partner_${n}`
        }, a.ownership);
    });
    const liabilities = Object.values(ff?.liabilities || {}).flat();
    const reverse = liabilities.filter((l)=>l && (l.type === 'reverse_mortgage' || l.id === 'reverse-mortgage'));
    v.Q53Q = $74f3be2c35d1f42f$var$yn(reverse.length > 0);
    const gifts = (0, $4156d91797dcfac7$export$e0ae14a586691b5)(ff, asAt);
    if (gifts.length) v.Q54Q = 'Yes';
    else if (ff?.giftsHistory?.confirmedNone) v.Q54Q = 'No';
    // The profile records gifts by financial year, so the year stands in for the date.
    gifts.slice(0, 3).forEach((g, i)=>{
        const n = i + 1;
        v[`Q54.Given_${n}`] = `MONEY (GIFTS IN ${g.year - 1}-${String(g.year).slice(2)})`;
        v[`Q54.Worth_${n}`] = $74f3be2c35d1f42f$var$dollars(g.amount);
        v[`Q54.AmountReceived_${n}`] = '0';
        v[`Q54.SDT_${n}`] = 'No';
    });
    // Q55 covers funeral bonds and pre-paid funerals; Q56 asks again about a contract already paid for.
    const funeral = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'funeralBonds', 'prepaidFuneral');
    v.Q55Q = $74f3be2c35d1f42f$var$yn(funeral.length > 0);
    v.Q56 = $74f3be2c35d1f42f$var$yn(funeral.some((a)=>a.type === 'prepaidFuneral'));
    funeral.slice(0, 2).forEach((a, i)=>{
        const n = i + 1;
        v[`Q55.CompanyName_${n}`] = $74f3be2c35d1f42f$var$upper(a.description || (a.type === 'prepaidFuneral' ? 'Prepaid funeral' : 'Funeral bond'));
        v[`Q55.Value_${n}`] = $74f3be2c35d1f42f$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.value));
        share({
            you: `Q55.YourShare_${n}`,
            partner: `Q55.PartnerShare_${n}`
        }, a.ownership ?? who);
    });
    const bonds = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'investmentBonds');
    v.Q57Q = $74f3be2c35d1f42f$var$yn(bonds.length > 0);
    bonds.slice(0, 2).forEach((a, i)=>{
        const n = i + 1;
        v[`Q57.InsuranceCoName_${n}`] = $74f3be2c35d1f42f$var$upper(a.description || 'Investment bond');
        v[`Q57.SurrenderValue_${n}`] = $74f3be2c35d1f42f$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.value));
        share({
            you: `Q57.YourShare_${n}`,
            partner: `Q57.PartnerShare_${n}`
        }, a.ownership);
    });
    const payments = incomes.filter((i)=>i.type === 'dvaWarWidow' || i.type === 'dvaDisability' || i.type === 'other');
    v.Q58Q = $74f3be2c35d1f42f$var$yn(payments.length > 0);
    payments.slice(0, 2).forEach((inc, i)=>{
        const n = i + 1;
        const dva = inc.type === 'dvaWarWidow' || inc.type === 'dvaDisability';
        v[`Q58.Type_${n}`] = $74f3be2c35d1f42f$var$upper(inc.description || ({
            dvaWarWidow: "DVA war widow(er)'s pension",
            dvaDisability: 'DVA disability pension',
            other: 'Other income'
        })[String(inc.type)] || 'Income');
        if (dva) v[`Q58.WhoPays_${n}`] = "DEPARTMENT OF VETERANS' AFFAIRS";
        v[`Q58.Amount_${n}`] = $74f3be2c35d1f42f$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(inc.amount) / 26);
        share({
            you: `Q58.YourShare_${n}`,
            partner: `Q58.PartnerShare_${n}`
        }, inc.ownership ?? 'client');
    });
    const other = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'other');
    v.Q59Q = $74f3be2c35d1f42f$var$yn(other.length > 0);
    other.slice(0, 2).forEach((a, i)=>{
        const n = i + 1;
        v[`Q59.Asset_${n}`] = $74f3be2c35d1f42f$var$upper(a.description || 'Other asset');
        v[`Q59.CurrentValue_${n}`] = $74f3be2c35d1f42f$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.value));
        share({
            you: `Q59.YourShare_${n}`,
            partner: `Q59.PartnerShare_${n}`
        }, a.ownership);
    });
    /*
     * Question 60, the checklist of what goes with the form: ticked for every "Yes" above that asks
     * for a document. The boxes run down the printed list in order (Q601 to Q6030).
     */ const docFor = [
        [
            1,
            v.Q8Q === 'Yes'
        ],
        [
            6,
            v.Q16 === 'Yes'
        ],
        [
            16,
            v.Q31Q === 'Yes'
        ],
        [
            17,
            v.Q33 === 'Yes' || v.Q40 === 'Yes' || v.Q41 === 'Yes' || v.Q42 === 'Yes' || v.Q43 === 'Yes'
        ],
        [
            18,
            v.Q45Q === 'Yes'
        ],
        [
            19,
            v.Q46Q === 'Yes'
        ],
        [
            20,
            v.Q47Q === 'Yes'
        ],
        [
            25,
            v.Q52Q === 'Yes'
        ],
        [
            26,
            v.Q53Q === 'Yes'
        ],
        [
            27,
            v.Q55Q === 'Yes'
        ],
        [
            28,
            v.Q56 === 'Yes'
        ],
        [
            29,
            v.Q57Q === 'Yes'
        ],
        [
            30,
            v.Q58Q === 'Yes'
        ]
    ];
    for (const [k, on] of docFor)if (on) v[`Q60${k}`] = 'Yes';
    return v;
}
async function $74f3be2c35d1f42f$export$66ca98268a6ed5db(code, ff, claimants, opts) {
    const bytes = await (await fetch($74f3be2c35d1f42f$export$bcd5931613b5dd4a[code])).arrayBuffer();
    const values = code === 'SA002' ? $74f3be2c35d1f42f$export$d06da0cc31112c3e(ff, claimants) : $74f3be2c35d1f42f$export$9c36a0b15197649a(ff, claimants, new Date(), opts.facts);
    const filled = await (0, $0faadd6209986a1b$export$5e771c05ac100c56)(bytes, values, {
        title: code === 'SA002' ? "Claim for Age Pension (SA002) \u2014 pre-filled" : "Income and assets (SA369) \u2014 pre-filled",
        subject: `${$74f3be2c35d1f42f$export$908ff717015478cd[code]}, pre-filled from the client profile (${opts.positionLabel}). Source: servicesaustralia.gov.au (CC BY 4.0).`
    }, {
        revealHidden: true
    });
    const name = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, claimants[0] ?? 'client').first || 'Client';
    (0, $0faadd6209986a1b$export$86f71714311cd923)(filled, `${code}_${name}_${opts.afterPlan ? 'after-plan' : 'prefilled'}_${new Date().toISOString().slice(0, 10)}.pdf`);
}
function $74f3be2c35d1f42f$export$36a096accbcad6ac(ff, facts = {}) {
    const out = [];
    const home = ff?.home || {};
    // A let former home needs one too (SA369 Q33, or Q43 from a village).
    if ((0, $4156d91797dcfac7$export$8f1258fd713609e3)(ff) && (home.landSize || home.separateTitles || home.businessUse || facts.homeRented) && !String(home.ownership || '').startsWith('entity')) out.push({
        kind: 'home'
    });
    (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'investmentProperty').forEach((a, index)=>{
        if (String(a.ownership || '').startsWith('entity:') || a.ownership === 'other_entity') return;
        out.push({
            kind: 'investment',
            index: index,
            description: String(a.description || `Property ${index + 1}`)
        });
    });
    return out;
}
const $74f3be2c35d1f42f$var$slashDate = (iso)=>{
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
    return m ? `${m[3]}/${m[2]}/${m[1]}` : undefined;
};
function $74f3be2c35d1f42f$export$3539b4a04e76dd47(ff, property, claimants, facts = {}) {
    const v = {};
    const couple = (0, $4156d91797dcfac7$export$411666eeb8222a3e)(ff);
    const who = claimants[0] ?? 'client';
    const p = (0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(ff, who);
    v.Q1 = 'No';
    if (p.last) v.Q3FamilyName = $74f3be2c35d1f42f$var$upper(p.last);
    if (p.first) v.Q3FirstName = $74f3be2c35d1f42f$var$upper(p.first);
    v.Q4DateOfBirth = $74f3be2c35d1f42f$var$slashDate(p.dob);
    const ips = (0, $4156d91797dcfac7$export$f15d9fecc8ba66e9)(ff, 'investmentProperty');
    v.Q5 = String(ips.length + ((0, $4156d91797dcfac7$export$8f1258fd713609e3)(ff) ? 1 : 0));
    let ownership;
    let loan = 0;
    let loanRate;
    if (property.kind === 'home') {
        const home = ff?.home || {};
        ownership = home.ownership;
        if (home.landSize) v.Q7 = '2ha';
        else if (facts.homeRented) v.Q7 = 'House';
        v['Q9.CurValue'] = $74f3be2c35d1f42f$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.value));
        // Let out under the plan: nobody in the household lives there any more.
        v.Q11 = facts.homeRented ? 'No' : 'Yes';
        if (facts.homeRented) {
            v.Q36 = facts.homeRented.perWeek > 0 ? 'Yes' : 'No';
            if (facts.homeRented.perWeek > 0) v['Q36Details.GrossRent'] = $74f3be2c35d1f42f$var$dollars(facts.homeRented.perWeek);
        }
        v.Q12 = $74f3be2c35d1f42f$var$yn(!!home.landSize);
        if (home.landSize && (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.landSizeValue) > 0) v.Q13 = $74f3be2c35d1f42f$var$dollars(Math.max(0, (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.value) - (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.landSizeValue)));
        v.Q14 = $74f3be2c35d1f42f$var$yn(!!home.businessUse);
        if (home.businessUse && (0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.businessUseValue) > 0) v.Q15 = $74f3be2c35d1f42f$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(home.businessUseValue));
        v.Q16 = $74f3be2c35d1f42f$var$yn(!!home.primaryProductionUse);
        v.Q18 = $74f3be2c35d1f42f$var$yn(!!home.separateTitles);
        if (home.landSize) {
            v.Q20 = 'Yes'; // completed with an Age Pension claim
            if (home.longTermLandAttachment !== undefined) v.Q21 = $74f3be2c35d1f42f$var$yn(!!home.longTermLandAttachment);
        }
        loan = (0, $4156d91797dcfac7$export$7bda649cebedb52f)(ff);
        loanRate = (0, $4156d91797dcfac7$export$7d9d14c3abaeac86)(ff).find((l)=>l.type === 'mortgages' && (!l.assetLink || l.assetLink === 'home'))?.interestRate;
    } else {
        const a = ips[property.index];
        ownership = a.ownership;
        v['Q9.CurValue'] = $74f3be2c35d1f42f$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.value));
        v.Q11 = 'No';
        if ((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.purchasePrice) > 0) {
            v.Q29 = 'Purchased';
            v['Q29Details.Price'] = $74f3be2c35d1f42f$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.purchasePrice));
        }
        v['Q30.OwnershipDate'] = $74f3be2c35d1f42f$var$slashDate(a.acquiredOn);
        loan = (0, $4156d91797dcfac7$export$5d71e490b6ce5ee1)(ff, a.id);
        loanRate = (0, $4156d91797dcfac7$export$7d9d14c3abaeac86)(ff).find((l)=>String(l.assetLink) === String(a.id))?.interestRate;
        v.Q36 = $74f3be2c35d1f42f$var$yn((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.rent) > 0);
        if ((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.rent) > 0) v['Q36Details.GrossRent'] = $74f3be2c35d1f42f$var$dollars((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(a.rent) / 52);
    }
    const s = (0, $4156d91797dcfac7$export$cecba97898c85a14)(ownership, who, couple);
    if (s.you > 0) {
        v['Q28.0'] = 'Yes';
        v.Q28Percent1 = String(s.you);
    }
    if (couple && s.partner > 0) {
        v['Q28.1'] = 'Yes';
        v.Q28Percent2 = String(s.partner);
    }
    if (s.other > 0) {
        v['Q28.2'] = 'Yes';
        v.Q28Percent3 = String(s.other);
    }
    v.Q33 = $74f3be2c35d1f42f$var$yn(loan > 0);
    if (loan > 0) {
        v['Q35.Owe'] = $74f3be2c35d1f42f$var$dollars(loan);
        if ((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(loanRate) > 0) v['Q35.Interest'] = String((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(loanRate));
    }
    // The checklist: a Mod R for each property, the rates notice it always asks for, and the loan and rental papers.
    if ((0, $4156d91797dcfac7$export$61cc6a0be4938a2a)(v.Q5) > 1) v['Q43.0'] = 'Yes';
    v['Q43.1'] = 'Yes';
    if (v.Q18 === 'Yes') v['Q43.3'] = 'Yes';
    if (v.Q33 === 'Yes') v['Q43.5'] = 'Yes';
    if (v.Q36 === 'Yes') v['Q43.6'] = 'Yes';
    return v;
}
function $74f3be2c35d1f42f$export$ce6edc01aa63956(property) {
    return property.kind === 'home' ? 'your home' : property.description;
}
async function $74f3be2c35d1f42f$export$bb05f2634531fd(ff, property, claimants, opts) {
    const bytes = await (await fetch($74f3be2c35d1f42f$var$MODR_PDF)).arrayBuffer();
    const filled = await (0, $0faadd6209986a1b$export$5e771c05ac100c56)(bytes, $74f3be2c35d1f42f$export$3539b4a04e76dd47(ff, property, claimants, opts.facts), {
        title: `Real estate details (Mod R) \u{2014} ${$74f3be2c35d1f42f$export$ce6edc01aa63956(property)} \u{2014} pre-filled`,
        subject: `Mod(R).2007, pre-filled from the client profile (${opts.positionLabel}). Source: servicesaustralia.gov.au (CC BY 4.0).`
    }, {
        revealHidden: true
    });
    const stem = $74f3be2c35d1f42f$export$ce6edc01aa63956(property).replace(/[^A-Za-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 30) || 'property';
    (0, $0faadd6209986a1b$export$86f71714311cd923)(filled, `ModR_${stem}_${opts.afterPlan ? 'after-plan' : 'prefilled'}_${new Date().toISOString().slice(0, 10)}.pdf`);
}




/**
 * "Fill it from today's position, or from after the plan?" — asked on every pre-filled Services
 * Australia form (owner, 3 Oct 2026).
 *
 * Both are right at different times. Today's position is what to lodge now, including the
 * time-critical case of moving into care straight away and restructuring afterwards. The position
 * after a plan is what to lodge once the changes are made, and never before: the reminder says so
 * beside the choice and the file is named "after-plan".
 */ 

var $acw62 = parcelRequire("acw62");


function $a02e12a1f659227c$export$d21b493f766381e8(factFind, plans, choice) {
    const plan = choice.mode === 'plan' ? plans.find((p)=>p.id === choice.planId) || null : null;
    const [state, setState] = (0, $acw62.useState)({
        status: 'ready',
        factFind: factFind,
        afterPlan: false,
        plan: null,
        caveats: [],
        facts: {}
    });
    (0, $acw62.useEffect)(()=>{
        if (!plan) {
            setState({
                status: 'ready',
                factFind: factFind,
                afterPlan: false,
                plan: null,
                caveats: [],
                facts: {}
            });
            return undefined;
        }
        let cancelled = false;
        setState({
            status: 'loading',
            factFind: factFind,
            afterPlan: true,
            plan: plan,
            caveats: [],
            facts: {}
        });
        (0, $13d137e110a3aed6$export$81e3be860652ae70)(factFind, plan).then((r)=>{
            if (cancelled) return;
            setState(r.ok ? {
                status: 'ready',
                factFind: r.factFind,
                afterPlan: true,
                plan: plan,
                caveats: r.caveats,
                facts: r.facts
            } : {
                status: 'failed',
                factFind: factFind,
                afterPlan: true,
                plan: plan,
                caveats: [],
                facts: {},
                reason: r.reason
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind,
        plan
    ]);
    return state;
}
function $a02e12a1f659227c$export$fce66e846a25fab1({ plans: plans, choice: choice, onChange: onChange, resolved: resolved }) {
    const selectedPlan = choice.mode === 'plan' ? plans.find((p)=>p.id === choice.planId) : null;
    const tab = (on)=>`rounded-lg border-2 px-3 py-2 text-left text-sm font-semibold ${on ? 'border-blue-600 bg-blue-50 text-blue-900' : 'border-slate-200 bg-slate-50 text-slate-700 hover:border-slate-300'}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-sm font-semibold text-gray-800 mb-2",
                children: "Fill it in from"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-2 gap-2",
                role: "radiogroup",
                "aria-label": "Fill the form in from",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        role: "radio",
                        "aria-checked": choice.mode === 'today',
                        onClick: ()=>onChange({
                                mode: 'today'
                            }),
                        className: tab(choice.mode === 'today'),
                        children: "Your position today"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        role: "radio",
                        "aria-checked": choice.mode === 'plan',
                        disabled: plans.length === 0,
                        onClick: ()=>plans[0]?.id && onChange({
                                mode: 'plan',
                                planId: String(plans[0].id)
                            }),
                        className: `${tab(choice.mode === 'plan')} disabled:cursor-not-allowed disabled:opacity-50`,
                        children: "After your plan"
                    })
                ]
            }),
            plans.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-xs text-slate-500 mt-1",
                children: "Save a plan in the module first to fill the form from the position after it."
            }),
            choice.mode === 'plan' && plans.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: "mt-2 block text-xs text-slate-600",
                children: [
                    "Which plan",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                        value: choice.planId,
                        onChange: (e)=>onChange({
                                mode: 'plan',
                                planId: e.target.value
                            }),
                        className: "mt-1 block w-full rounded-lg border border-slate-300 px-2 py-1.5 text-sm",
                        children: plans.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: String(p.id),
                                children: (0, $13d137e110a3aed6$export$c6aafd8353c81df)(p)
                            }, String(p.id)))
                    })
                ]
            }),
            choice.mode === 'plan' && selectedPlan ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-2 flex gap-2 rounded-lg border border-slate-200 border-l-4 border-l-amber-500 bg-white p-3 text-sm text-slate-800",
                role: "note",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                        size: 16,
                        className: "mt-0.5 shrink-0 text-amber-600"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Do not lodge this form until the changes in your plan have been made."
                                    }),
                                    " It is filled in as things will stand after ",
                                    plans.length > 1 ? 'the plan above' : `\u{201C}${selectedPlan.name || 'your plan'}\u{201D}`,
                                    ", and Services Australia assesses what you own and earn on the day it decides."
                                ]
                            }),
                            resolved.status === 'loading' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1 text-xs",
                                children: "Working out your position after the plan\u2026"
                            }),
                            resolved.status === 'failed' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1 text-xs font-semibold",
                                children: resolved.reason
                            }),
                            resolved.caveats.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-1 text-xs",
                                    children: c
                                }, c))
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-2 flex gap-2 rounded-lg border border-slate-200 bg-white p-3 text-xs text-slate-600",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                        size: 14,
                        className: "mt-0.5 shrink-0 text-blue-600"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "Filled in from what you own and earn today, to lodge now. If you lodge now and carry out your plan afterwards \u2014 for example, moving into care straight away and restructuring later \u2014 tell Services Australia about each change within 14 days."
                    })
                ]
            })
        ]
    });
}
function $a02e12a1f659227c$export$7cdb14bc2d7f4b11({ blanks: blanks }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex gap-2 rounded-lg border border-slate-200 border-l-4 border-l-blue-600 bg-white p-3 text-sm text-slate-800",
        role: "note",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                size: 16,
                className: "mt-0.5 shrink-0 text-blue-600"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "font-semibold text-slate-900",
                        children: "Please review every question before you sign."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-1",
                        children: [
                            "We fill in the answers your profile holds, but we can\u2019t complete every question for you. Check each answer we\u2019ve written in, and answer the ones left blank \u2014 for example ",
                            blanks,
                            "."
                        ]
                    })
                ]
            })
        ]
    });
}


/**
 * The Age Pension steps a plan adds to its journey (owner, 3 Oct 2026).
 *
 * A plan that makes someone eligible needs a claim: the pension is not paid automatically. A plan
 * that moves an existing pension needs the changes reported. And the order matters for aged care:
 * restructure, then claim, then the means assessment, which is then the SA485 (or no form at all)
 * rather than the SA457.
 *
 * Judged on the journey's latest saved plan against today's pension, the same comparison the
 * Statements of Advice make (features/advice/agePensionClaim.ts).
 */ 

const $3274a673609cf813$var$money = (v)=>`$${Math.round(v).toLocaleString('en-AU')}`;
function $3274a673609cf813$export$ec6059e380d9928a(workflowKey, ctx) {
    const type = (0, $13d137e110a3aed6$export$a35afb9ef2d5331d)[workflowKey];
    const plan = type ? (0, $13d137e110a3aed6$export$4917af9b05941375)(ctx.savedStrategies, [
        type
    ])[0] ?? null : null;
    const current = Number(ctx.currentPension) || 0;
    const planned = (0, $13d137e110a3aed6$export$4215b55f44adb313)(plan);
    return {
        kind: plan ? (0, $b82b108d4741f18d$export$143d894e260814c1)(planned, current) : 'none',
        plan: plan,
        planPension: planned,
        currentPension: current
    };
}
function $3274a673609cf813$export$7c4b82243c88c1fa(steps, workflowKey, ctx) {
    const jp = $3274a673609cf813$export$ec6059e380d9928a(workflowKey, ctx);
    if (jp.kind === 'none') return steps;
    if (jp.kind === 'newly_eligible') {
        const before = workflowKey === 'aged_care' ? 'sa457_form' : workflowKey === 'home_care' ? 'sah_means_form' : null;
        const order = before === 'sa457_form' ? ' Do this before the means assessment: once you are paid the pension, that needs only the SA485 (or no form if there is no home), not the SA457.' : before === 'sah_means_form' ? ' Do this before the contribution assessment: once you are paid the pension, no SA456 is needed.' : '';
        const claim = {
            id: 'claim_age_pension',
            name: 'Claim the Age Pension',
            description: `Your plan qualifies you for about ${$3274a673609cf813$var$money(jp.planPension)} a year of Age Pension, but it is not paid automatically. Claim once the changes in the plan are made, online through myGov or on the SA002 and SA369, which are pre-filled for you.${order}`,
            forms: [
                'pension_claim'
            ],
            estimatedTime: '~30 min online',
            status: 'pending'
        };
        const i = before ? steps.findIndex((s)=>s.id === before) : -1;
        return i >= 0 ? [
            ...steps.slice(0, i),
            claim,
            ...steps.slice(i)
        ] : [
            ...steps,
            claim
        ];
    }
    const text = jp.kind === 'increase' ? `Your pension is expected to rise from about ${$3274a673609cf813$var$money(jp.currentPension)} to ${$3274a673609cf813$var$money(jp.planPension)} a year, but only once Services Australia knows. Report each change, such as a sale, a purchase or money moved, within 14 days.` : `Your pension is expected to fall from about ${$3274a673609cf813$var$money(jp.currentPension)} to ${$3274a673609cf813$var$money(jp.planPension)} a year. Report each change, such as a sale, a purchase or money moved, within 14 days: anything paid at the old rate after a change has to be repaid.`;
    // A journey that already has a reporting step says it there, rather than twice.
    const existing = steps.findIndex((s)=>s.id === 'notify_services_australia' || s.id === 'notify_centrelink');
    if (existing >= 0) {
        const s = steps[existing];
        return steps.map((x, k)=>k === existing ? {
                ...s,
                description: `${s.description} ${text}`,
                forms: [
                    ...s.forms,
                    'report_change'
                ]
            } : x);
    }
    return [
        ...steps,
        {
            id: 'report_pension_change',
            name: 'Tell Services Australia',
            description: text,
            forms: [
                'report_change'
            ],
            estimatedTime: 'Within 14 days',
            status: 'pending'
        }
    ];
}


function $669dd463c00729a7$var$MeansChooser({ factFind: factFind, setting: setting, receivesPension: receivesPension, plans: plans, onClose: onClose }) {
    const couple = (0, $4156d91797dcfac7$export$411666eeb8222a3e)(factFind);
    const [who, setWho] = (0, $acw62.useState)((0, $4156d91797dcfac7$export$90b433c608c179c0)(factFind));
    const recommended = (0, $f476351fdad6ba1d$export$3a432508c5e373b2)(factFind, setting, receivesPension);
    const owns = (0, $4156d91797dcfac7$export$8f1258fd713609e3)(factFind);
    const name = (w)=>(0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(factFind, w).first || (w === 'client' ? 'Client' : 'Partner');
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [failed, setFailed] = (0, $acw62.useState)(null);
    // Today's position by default: the form most people lodge now (owner, 3 Oct 2026).
    const [choice, setChoice] = (0, $acw62.useState)({
        mode: 'today'
    });
    const position = (0, $a02e12a1f659227c$export$d21b493f766381e8)(factFind, plans, choice);
    /*
     * Every form comes back as the OFFICIAL Services Australia PDF, filled in from the profile
     * (owner, 3 Oct 2026: "all the official forms"), today's or as it will stand after the plan.
     */ const open = (form)=>{
        setBusy(true);
        setFailed(null);
        (0, $8cf62c73564be5c1$export$6ac59097a38cfe74)(form, position.factFind, who, {
            afterPlan: position.afterPlan,
            facts: position.facts
        }).catch(()=>setFailed('The form could not be prepared. Check your connection and try again.')).finally(()=>setBusy(false));
    };
    const why = setting === 'home' ? recommended === 'none' ? "Because you receive the Age Pension, Services Australia already holds what it needs to work out your Support at Home contribution. There is no form \u2014 just keep your income and assets up to date in myGov." : 'Because you do not receive the Age Pension, Services Australia needs your income and assets to work out your Support at Home contribution. That is the SA456.' : recommended === 'SA485' ? 'Because you receive the Age Pension, Services Australia already holds your income and assets. You only need to tell them about your home, on the shorter SA485.' : recommended === 'SA457' ? 'Because you do not receive the Age Pension, Services Australia needs your income and assets to work out your aged care fees. That is the SA457.' : `Because you receive the Age Pension${owns ? '' : ' and do not own a home'}, Services Australia can assess you automatically when you enter care \u{2014} generally no form is needed. Keep your details up to date in myGov.`;
    const formButton = (form, primary, label)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            type: "button",
            onClick: ()=>open(form),
            disabled: busy || position.status !== 'ready',
            className: `flex w-full disabled:opacity-60 items-center justify-between rounded-lg border px-4 py-3 text-left text-sm font-semibold transition-colors ${primary ? 'border-blue-600 bg-blue-600 text-white hover:bg-blue-700' : 'border-slate-200 bg-white text-slate-700 hover:border-blue-300 hover:text-blue-800'}`,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                    size: 16
                })
            ]
        });
    // Opened over the whole page: inside the card it was clipped and covered by the next tile.
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "means-chooser-title",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white rounded-xl max-w-lg w-full shadow-xl max-h-[90vh] overflow-y-auto",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-start justify-between gap-3 border-b border-slate-200 p-5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    id: "means-chooser-title",
                                    className: "text-lg font-bold text-gray-900",
                                    children: setting === 'home' ? 'Your Support at Home contribution assessment' : 'Your aged care means assessment'
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-slate-500 mt-0.5",
                                    children: "Pre-filled from your profile, question by question."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: onClose,
                            "aria-label": "Close",
                            className: "rounded p-1 text-gray-400 hover:text-gray-600",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 20
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "space-y-4 p-5",
                    children: [
                        couple && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm font-semibold text-gray-800 mb-2",
                                    children: "Who is the assessment for?"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "grid grid-cols-2 gap-2",
                                    role: "radiogroup",
                                    "aria-label": "Who is the assessment for",
                                    children: [
                                        'client',
                                        'partner'
                                    ].map((w)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            role: "radio",
                                            "aria-checked": who === w,
                                            onClick: ()=>setWho(w),
                                            className: `rounded-lg border-2 px-3 py-2 text-sm font-semibold ${who === w ? 'border-blue-600 bg-blue-50 text-blue-900' : 'border-slate-200 bg-slate-50 text-slate-700 hover:border-slate-300'}`,
                                            children: name(w)
                                        }, w))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-xs text-slate-500 mt-1",
                                    children: "If you both need an assessment, each completes their own form."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex gap-2 rounded-lg border border-slate-200 border-l-4 border-l-blue-500 bg-white p-3 text-sm text-slate-700",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                    size: 16,
                                    className: "mt-0.5 shrink-0 text-blue-600"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: why
                                })
                            ]
                        }),
                        !receivesPension && plans.some((p)=>(Number(p.outputs?.agePension) || 0) > 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "rounded-lg border border-slate-200 bg-slate-50 p-3 text-xs text-slate-600",
                            children: [
                                "Your plan makes you eligible for the Age Pension. Claim it first, once the changes are made: when you are paid it, ",
                                setting === 'home' ? 'no SA456 is needed' : 'you need only the SA485 (or no form if there is no home)',
                                ", not the ",
                                setting === 'home' ? 'SA456' : 'SA457',
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a02e12a1f659227c$export$fce66e846a25fab1), {
                            plans: plans,
                            choice: choice,
                            onChange: setChoice,
                            resolved: position
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a02e12a1f659227c$export$7cdb14bc2d7f4b11), {
                            blanks: "reference numbers, addresses and anything your profile doesn\u2019t ask about"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "space-y-2",
                            children: setting === 'home' ? recommended === 'SA456' ? formButton('SA456', true, 'Open the SA456, pre-filled') : formButton('SA456', false, 'Not receiving the Age Pension? Open the SA456') : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    recommended === 'SA485' && formButton('SA485', true, 'Open the SA485, pre-filled'),
                                    recommended === 'SA457' && formButton('SA457', true, 'Open the SA457, pre-filled'),
                                    recommended !== 'SA457' && formButton('SA457', false, 'Not receiving the Age Pension? Open the SA457'),
                                    recommended !== 'SA485' && owns && formButton('SA485', false, 'Receiving the Age Pension and own a home? Open the SA485')
                                ]
                            })
                        }),
                        failed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-red-700",
                            children: failed
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-xs text-slate-500",
                            children: "Each form opens as the official Services Australia form. Where you have more accounts or investments than the form has room for, list the rest on a separate sheet, as the form asks."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-xs text-slate-500",
                            children: "Whether you receive the Age Pension is about your Centrelink account today, not the estimate in this tool \u2014 pick the form that matches your situation."
                        })
                    ]
                })
            ]
        })
    }), document.body);
}
/* ─── Claiming the Age Pension ───────────────────────────────────────────────────────────────── */ /** The day someone can first lodge a claim: 13 weeks before Age Pension age (67). */ function $669dd463c00729a7$var$claimOpensOn(dob) {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(dob);
    if (!m) return null;
    const pensionAge = new Date(Number(m[1]) + 67, Number(m[2]) - 1, Number(m[3]));
    return new Date(pensionAge.getTime() - 7862400000);
}
/**
 * The claim itself: online through myGov, or on paper as the SA002 and SA369 together, pre-filled.
 * Filled from the position after the plan by default, because the plan is what makes the claim worth
 * making; the reminder beside it says not to lodge until the changes are made.
 */ function $669dd463c00729a7$var$PensionClaimChooser({ factFind: factFind, plans: plans, onClose: onClose }) {
    const couple = (0, $4156d91797dcfac7$export$411666eeb8222a3e)(factFind);
    const name = (w)=>(0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(factFind, w).first || (w === 'client' ? 'Client' : 'Partner');
    const [claimants, setClaimants] = (0, $acw62.useState)(couple ? [
        'client',
        'partner'
    ] : [
        'client'
    ]);
    const [choice, setChoice] = (0, $acw62.useState)(plans[0]?.id ? {
        mode: 'plan',
        planId: String(plans[0].id)
    } : {
        mode: 'today'
    });
    const position = (0, $a02e12a1f659227c$export$d21b493f766381e8)(factFind, plans, choice);
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [failed, setFailed] = (0, $acw62.useState)(null);
    const open = (code)=>{
        setBusy(true);
        setFailed(null);
        (0, $74f3be2c35d1f42f$export$66ca98268a6ed5db)(code, position.factFind, claimants, {
            positionLabel: position.afterPlan ? 'after the plan' : 'today',
            afterPlan: position.afterPlan,
            facts: position.facts
        }).catch(()=>setFailed('The form could not be prepared. Check your connection and try again.')).finally(()=>setBusy(false));
    };
    /* A Mod R for each property the SA369 asks about, from the same position. */ const properties = (0, $acw62.useMemo)(()=>(0, $74f3be2c35d1f42f$export$36a096accbcad6ac)(position.factFind, position.facts), [
        position.factFind,
        position.facts
    ]);
    const openModR = (property)=>{
        setBusy(true);
        setFailed(null);
        (0, $74f3be2c35d1f42f$export$bb05f2634531fd)(position.factFind, property, claimants, {
            positionLabel: position.afterPlan ? 'after the plan' : 'today',
            afterPlan: position.afterPlan,
            facts: position.facts
        }).catch(()=>setFailed('The form could not be prepared. Check your connection and try again.')).finally(()=>setBusy(false));
    };
    const today = new Date();
    const notYet = claimants.map((w)=>({
            w: w,
            opens: $669dd463c00729a7$var$claimOpensOn((0, $4156d91797dcfac7$export$6a69dcfdc0a4cbf4)(factFind, w).dob)
        })).filter((x)=>x.opens && x.opens > today);
    const options = couple ? [
        {
            key: 'both',
            label: 'Both of us',
            who: [
                'client',
                'partner'
            ]
        },
        {
            key: 'client',
            label: name('client'),
            who: [
                'client'
            ]
        },
        {
            key: 'partner',
            label: name('partner'),
            who: [
                'partner'
            ]
        }
    ] : [];
    const btn = (code, label)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            type: "button",
            onClick: ()=>open(code),
            disabled: busy || position.status !== 'ready',
            className: "flex w-full items-center justify-between rounded-lg border border-slate-200 bg-white px-4 py-3 text-left text-sm font-semibold text-slate-700 transition-colors hover:border-blue-300 hover:text-blue-800 disabled:opacity-60",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                    size: 16
                })
            ]
        });
    // Opened over the whole page: inside the card it was clipped and covered by the next tile.
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "pension-claim-title",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white rounded-xl max-w-lg w-full shadow-xl max-h-[90vh] overflow-y-auto",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-start justify-between gap-3 border-b border-slate-200 p-5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    id: "pension-claim-title",
                                    className: "text-lg font-bold text-gray-900",
                                    children: "Claim the Age Pension"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-slate-500 mt-0.5",
                                    children: "It is not paid automatically. You have to claim it."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: onClose,
                            "aria-label": "Close",
                            className: "rounded p-1 text-gray-400 hover:text-gray-600",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 20
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "space-y-4 p-5",
                    children: [
                        couple && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm font-semibold text-gray-800 mb-2",
                                    children: "Who is claiming?"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "grid grid-cols-3 gap-2",
                                    role: "radiogroup",
                                    "aria-label": "Who is claiming",
                                    children: options.map((o)=>{
                                        const on = o.who.join() === claimants.join();
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            role: "radio",
                                            "aria-checked": on,
                                            onClick: ()=>setClaimants(o.who),
                                            className: `rounded-lg border-2 px-3 py-2 text-sm font-semibold ${on ? 'border-blue-600 bg-blue-50 text-blue-900' : 'border-slate-200 bg-slate-50 text-slate-700 hover:border-slate-300'}`,
                                            children: o.label
                                        }, o.key);
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-xs text-slate-500 mt-1",
                                    children: "A couple both claiming can use the one SA002."
                                })
                            ]
                        }),
                        notYet.map((x)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-xs text-amber-800",
                                children: [
                                    name(x.w),
                                    " can lodge a claim from ",
                                    x.opens.toLocaleDateString('en-AU', {
                                        day: 'numeric',
                                        month: 'long',
                                        year: 'numeric'
                                    }),
                                    ", 13 weeks before Age Pension age."
                                ]
                            }, x.w)),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a02e12a1f659227c$export$fce66e846a25fab1), {
                            plans: plans,
                            choice: choice,
                            onChange: setChoice,
                            resolved: position
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a02e12a1f659227c$export$7cdb14bc2d7f4b11), {
                            blanks: "reference numbers, your address, the bank account for payments, your tax file number and your residence history"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                    href: (0, $f476351fdad6ba1d$export$90f485777e0c3396),
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "flex w-full items-center justify-between rounded-lg border border-blue-600 bg-blue-600 px-4 py-3 text-left text-sm font-semibold text-white transition-colors hover:bg-blue-700",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Claim online through myGov (quickest)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                            size: 16
                                        })
                                    ]
                                }),
                                btn('SA002', 'Or on paper: the SA002 claim, pre-filled'),
                                btn('SA369', 'With it: the SA369 income and assets, pre-filled'),
                                properties.map((pr)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>openModR(pr),
                                        disabled: busy || position.status !== 'ready',
                                        className: "flex w-full items-center justify-between rounded-lg border border-slate-200 bg-white px-4 py-3 text-left text-sm font-semibold text-slate-700 transition-colors hover:border-blue-300 hover:text-blue-800 disabled:opacity-60",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "With it: real estate details (Mod R) for ",
                                                    (0, $74f3be2c35d1f42f$export$ce6edc01aa63956)(pr),
                                                    ", pre-filled"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                size: 16
                                            })
                                        ]
                                    }, pr.kind === 'home' ? 'home' : `ip-${pr.index}`))
                            ]
                        }),
                        failed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-red-700",
                            children: failed
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-xs text-slate-500",
                            children: [
                                "On paper, lodge the SA002 and the SA369 together",
                                properties.length ? ', with a Mod R for each property listed' : '',
                                ". Each opens as the official Services Australia form."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-xs text-slate-500",
                            children: "The pension is generally paid from the day you claim, not before, so claim promptly once the changes are made."
                        })
                    ]
                })
            ]
        })
    }), document.body);
}
/* ─── The journey and its steps ──────────────────────────────────────────────────────────────── */ /**
 * The means assessment step, said for this client. Residential: SA485 (pension + home), SA457 (no
 * pension), or usually nothing (pension, no home). Support at Home: SA456 (no pension) or nothing.
 */ function $669dd463c00729a7$var$adaptFinancialAssessmentStep(step, workflowKey, receivesPension, factFind) {
    if (workflowKey === 'aged_care' && step.id === 'sa457_form') {
        const form = (0, $f476351fdad6ba1d$export$3a432508c5e373b2)(factFind, 'residential', receivesPension);
        if (form === 'SA485') return {
            ...step,
            name: 'Confirm your home details (SA485)',
            description: "You receive the Age Pension, so Services Australia already holds your income and assets. You only confirm your home on the shorter SA485 \u2014 pre-filled from your profile. Homes ask for the letter it produces, so do it before applying.",
            estimatedTime: '~5 min (pre-filled)'
        };
        if (form === 'SA457') return {
            ...step,
            name: 'Means assessment (SA457)',
            description: "As you do not receive the Age Pension, the SA457 tells Services Australia your income and assets so it can work out your fees \u2014 pre-filled from your profile. Homes ask for the letter it produces, so do it before applying.",
            estimatedTime: '~15 min (pre-filled)'
        };
        return {
            ...step,
            name: 'Means assessment (usually automatic)',
            description: 'You receive the Age Pension and do not own a home, so Services Australia can assess your fees automatically when you enter care. Keep your details in myGov up to date.',
            estimatedTime: 'Usually none'
        };
    }
    if (workflowKey === 'home_care' && step.id === 'sah_means_form') {
        const form = (0, $f476351fdad6ba1d$export$3a432508c5e373b2)(factFind, 'home', receivesPension);
        if (form === 'SA456') return {
            ...step,
            name: 'Contribution assessment (SA456)',
            description: "As you do not receive the Age Pension, the SA456 tells Services Australia your income and assets so it can work out your contribution \u2014 pre-filled from your profile. Without it your provider can charge the maximum.",
            estimatedTime: '~15 min (pre-filled)'
        };
        return {
            ...step,
            name: 'Contribution assessment (already on file)',
            description: "You receive the Age Pension, so Services Australia already has what it needs \u2014 no form. Keep your income and assets up to date in myGov.",
            estimatedTime: 'Usually none'
        };
    }
    return step;
}
/** The chips a step shows for this client — the downsizer form only where the plan makes a contribution, and the partner's own. */ function $669dd463c00729a7$var$chipsForStep(step, ctx) {
    const chips = step.forms.map((f)=>(0, $f476351fdad6ba1d$export$3e9ad1b4f23356ec)(f, ctx)).filter((c)=>!!c);
    if (step.forms.includes('downsizer_contribution')) {
        const partner = (0, $f476351fdad6ba1d$export$8247bb8a998ec896)(ctx);
        if (partner) chips.push(partner);
    }
    return chips;
}
function $669dd463c00729a7$var$WorkflowStep({ step: step, index: index, isCompleted: isCompleted, isNext: isNext, chips: chips, onChip: onChip }) {
    const statusIcon = isCompleted ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
        size: 20,
        className: "text-green-500"
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `w-5 h-5 ${isNext ? 'bg-blue-500 text-white' : 'bg-gray-300 text-gray-600'} rounded-full flex items-center justify-center text-xs font-bold`,
        children: index
    });
    const edge = isCompleted ? 'border-l-green-500' : isNext ? 'border-l-blue-500' : 'border-l-slate-300';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `p-4 rounded-lg bg-slate-50 border border-slate-200 border-l-4 ${edge} transition-colors`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex items-start gap-3",
            children: [
                statusIcon,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex-1 min-w-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center justify-between gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                    className: `font-semibold ${isCompleted ? 'text-green-700' : isNext ? 'text-blue-700' : 'text-gray-700'}`,
                                    children: step.name
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-xs text-gray-500 shrink-0",
                                    children: step.estimatedTime
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-gray-600 mt-1",
                            children: step.description
                        }),
                        (chips.length > 0 || (step.comingSoon?.length ?? 0) > 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mt-2 flex flex-wrap gap-1.5",
                            children: [
                                chips.map((chip)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>onChip(chip),
                                        className: "inline-flex items-center gap-1 px-2.5 py-1 bg-white rounded text-xs font-medium text-blue-700 border border-blue-200 hover:border-blue-400 hover:text-blue-900 transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                                size: 12
                                            }),
                                            " ",
                                            chip.label
                                        ]
                                    }, `${chip.id}-${chip.label}`)),
                                (step.comingSoon || []).map((label)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "inline-flex items-center gap-1 px-2.5 py-1 bg-white rounded text-xs text-slate-400 border border-slate-200 cursor-not-allowed",
                                        title: "Not available yet",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                                                size: 12
                                            }),
                                            " ",
                                            label,
                                            " \u2014 coming soon"
                                        ]
                                    }, label))
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $669dd463c00729a7$var$CollapsibleWorkflow({ workflow: workflow, workflowKey: workflowKey, completedIds: completedIds, isExpanded: isExpanded, onToggle: onToggle, ctx: ctx, onChip: onChip }) {
    const steps = (0, $3274a673609cf813$export$7c4b82243c88c1fa)(workflow.steps.map((s)=>$669dd463c00729a7$var$adaptFinancialAssessmentStep(s, workflowKey, ctx.receivesPension, ctx.factFind)), workflowKey, ctx);
    const total = steps.length;
    const done = completedIds.length;
    const nextStep = steps.find((s)=>!completedIds.includes(s.id));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border border-gray-200 rounded-lg overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: "w-full text-left bg-slate-50 p-4 hover:bg-slate-100 transition-colors",
                onClick: onToggle,
                "aria-expanded": isExpanded,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center justify-between gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                    icon: workflow.icon,
                                    tone: "brand",
                                    variant: "solid",
                                    size: "md"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: "text-lg font-semibold text-gray-800",
                                            children: workflow.title
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex items-center gap-2 mt-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "w-24 bg-gray-200 rounded-full h-1.5",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "bg-blue-600 h-1.5 rounded-full transition-all duration-500",
                                                        style: {
                                                            width: `${done / total * 100}%`
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "text-xs text-gray-600",
                                                    children: [
                                                        done,
                                                        "/",
                                                        total
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                nextStep && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "text-sm text-gray-600",
                                    children: [
                                        "Next: ",
                                        nextStep.name
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                    size: 20,
                                    className: `text-gray-500 transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`
                                })
                            ]
                        })
                    ]
                })
            }),
            isExpanded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "p-4 space-y-3 bg-white",
                children: steps.map((step, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($669dd463c00729a7$var$WorkflowStep, {
                        step: step,
                        index: index + 1,
                        isCompleted: completedIds.includes(step.id),
                        isNext: nextStep?.id === step.id,
                        chips: $669dd463c00729a7$var$chipsForStep(step, ctx),
                        onChip: onChip
                    }, step.id))
            })
        ]
    });
}
/** Which arrangement a form is for, where two forms share a name. */ const $669dd463c00729a7$var$WORKFLOW_SHORT_NAMES = {
    aged_care: 'residential care',
    home_care: 'Support at Home',
    retirement_village: 'the village',
    downsize_home: 'downsizing',
    granny_flat: 'the granny flat'
};
function $669dd463c00729a7$export$2e2bcd8739ae039({ factFind: factFind, setActivePage: setActivePage, savedStrategies: savedStrategies, receivesPension: receivesPension = false, currentPension: currentPension = 0 }) {
    const { goals: goals, careNeeds: careNeeds } = factFind;
    const couple = (0, $4156d91797dcfac7$export$411666eeb8222a3e)(factFind);
    const [expandedWorkflows, setExpandedWorkflows] = (0, $acw62.useState)({});
    const [meansSetting, setMeansSetting] = (0, $acw62.useState)(null);
    const [claimOpen, setClaimOpen] = (0, $acw62.useState)(false);
    const ctx = (0, $acw62.useMemo)(()=>({
            factFind: factFind,
            savedStrategies: savedStrategies,
            receivesPension: receivesPension,
            currentPension: currentPension
        }), [
        factFind,
        savedStrategies,
        receivesPension,
        currentPension
    ]);
    /* The plans each chooser can fill a form from "after", newest first. */ const residentialPlans = (0, $acw62.useMemo)(()=>(0, $13d137e110a3aed6$export$4917af9b05941375)(savedStrategies, [
            'aged_care'
        ]), [
        savedStrategies
    ]);
    const homePlans = (0, $acw62.useMemo)(()=>(0, $13d137e110a3aed6$export$4917af9b05941375)(savedStrategies, [
            'home_care'
        ]), [
        savedStrategies
    ]);
    /* For the claim: the plans that make someone eligible first, then every other plan. */ const claimPlans = (0, $acw62.useMemo)(()=>{
        const all = (0, $13d137e110a3aed6$export$4917af9b05941375)(savedStrategies, [
            'aged_care',
            'home_care',
            'retirement_village',
            'downsizer',
            'granny_flat',
            'cashflow_pension'
        ]);
        const qualifies = (p)=>(Number(p.outputs?.agePension) || 0) > 0 && currentPension < 1;
        return [
            ...all.filter(qualifies),
            ...all.filter((p)=>!qualifies(p))
        ];
    }, [
        savedStrategies,
        currentPension
    ]);
    const activeWorkflows = Object.keys((0, $85ae9bb7b6ee4811$export$baed740720ec0ee1)).filter((k)=>goals?.[k]);
    /** Steps the profile already shows as done: the needs assessment, once the outcome is recorded. */ const completedFor = (key)=>{
        if (key !== 'aged_care' && key !== 'home_care') return [];
        const assessed = careNeeds?.clientAcat?.status === 'yes' || couple && careNeeds?.partnerAcat?.status === 'yes';
        return assessed ? [
            'acat_assessment'
        ] : [];
    };
    const onChip = (chip)=>{
        if (chip.action.kind === 'official') chip.action.open().catch(()=>undefined);
        else if (chip.action.kind === 'sheet') (0, $f476351fdad6ba1d$export$340875935d3c532d)(chip);
        else if (chip.action.kind === 'means') setMeansSetting(chip.action.setting);
        else if (chip.action.kind === 'pension_claim') setClaimOpen(true);
        else if (chip.action.kind === 'link') window.open(chip.action.url, '_blank', 'noopener');
        else {
            // Land on the named section, not the module's overview (granny flat review, 18 Oct 2026).
            if (chip.action.section && chip.action.page === 'GrannyFlatPage') try {
                sessionStorage.setItem((0, $32bd8c8afa665e9e$export$b0bc22f097476301), chip.action.section);
            } catch  {}
            setActivePage(chip.action.page);
        }
    };
    /** Quick Actions: every document that applies across the active journeys, once each. */ const quickActions = (0, $acw62.useMemo)(()=>{
        const seen = new Set();
        const out = [];
        for (const key of activeWorkflows){
            for (const step of (0, $3274a673609cf813$export$7c4b82243c88c1fa)((0, $85ae9bb7b6ee4811$export$baed740720ec0ee1)[key].steps, key, ctx))for (const chip of $669dd463c00729a7$var$chipsForStep(step, ctx)){
                if (chip.action.kind === 'page' || chip.action.kind === 'link') continue;
                const k = `${chip.action.kind === 'means' ? `means-${chip.action.setting}` : chip.id}-${chip.label}`;
                if (seen.has(k)) continue;
                seen.add(k);
                const title = chip.action.kind === 'means' ? chip.action.setting === 'home' ? `Support at Home contribution assessment \u{2014} ${chip.label}` : `Aged care means assessment \u{2014} ${chip.label}` : chip.label;
                out.push({
                    chip: chip,
                    title: title,
                    key: key
                });
            }
        }
        /*
         * TWO FORMS, ONE NAME (owner, 23 Oct 2026): residential care and Support at Home each have their own
         * "Assessment application details", the village and the granny flat their own "What to tell Services
         * Australia". Where a name is shared, each says which arrangement it is for.
         */ const counts = out.reduce((m, o)=>({
                ...m,
                [o.title]: (m[o.title] || 0) + 1
            }), {});
        return out.map((o)=>({
                chip: o.chip,
                title: counts[o.title] > 1 ? `${o.title}: ${$669dd463c00729a7$var$WORKFLOW_SHORT_NAMES[o.key] ?? o.key}` : o.title
            }));
    }, [
        activeWorkflows,
        ctx
    ]);
    if (activeWorkflows.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91cd8ed21bb5644f$export$8adb256d999cd5a0), {
                title: "Your Action Plan"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-4 p-6 text-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                            size: 32,
                            className: "text-gray-400"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-lg font-semibold text-gray-700 mb-2",
                        children: "No Active Workflows"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-gray-500 text-sm mb-4",
                        children: "Complete your goals setup to see relevant applications and forms."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>setActivePage('Client Profile'),
                        className: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm",
                        children: "Set Up Goals"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91cd8ed21bb5644f$export$8adb256d999cd5a0), {
                title: "Your Action Plan"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-4 space-y-4",
                children: [
                    activeWorkflows.map((key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($669dd463c00729a7$var$CollapsibleWorkflow, {
                            workflow: (0, $85ae9bb7b6ee4811$export$baed740720ec0ee1)[key],
                            workflowKey: key,
                            completedIds: completedFor(key),
                            isExpanded: !!expandedWorkflows[key],
                            onToggle: ()=>setExpandedWorkflows((prev)=>({
                                        ...prev,
                                        [key]: !prev[key]
                                    })),
                            ctx: ctx,
                            onChip: onChip
                        }, key)),
                    quickActions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "border-t pt-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                className: "font-semibold text-gray-700 mb-1",
                                children: "Forms and checklists"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-xs text-slate-500 mb-3",
                                children: "Pre-filled from your profile where it can be. Each opens in a new tab to print or keep beside you."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "grid grid-cols-1 gap-2",
                                children: quickActions.map(({ chip: chip, title: title })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>onChip(chip),
                                        className: "flex w-full items-center justify-between gap-3 p-3 bg-slate-50 border border-slate-200 rounded-lg text-left hover:bg-slate-100 transition-colors",
                                        "data-testid": "forms-checklist-item",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex min-w-0 items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                                        size: 20,
                                                        className: "shrink-0 text-blue-600"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-sm font-medium text-gray-700",
                                                        children: title
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                size: 16,
                                                className: "shrink-0 text-gray-400"
                                            })
                                        ]
                                    }, `${chip.id}-${title}`))
                            })
                        ]
                    })
                ]
            }),
            meansSetting && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($669dd463c00729a7$var$MeansChooser, {
                factFind: factFind,
                setting: meansSetting,
                receivesPension: receivesPension,
                plans: meansSetting === 'home' ? homePlans : residentialPlans,
                onClose: ()=>setMeansSetting(null)
            }),
            claimOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($669dd463c00729a7$var$PensionClaimChooser, {
                factFind: factFind,
                plans: claimPlans,
                onClose: ()=>setClaimOpen(false)
            })
        ]
    });
}





/** "michael's" -> "Michael's", "your and Tara's" -> "Your and Tara's". */ const $91e8bd92d2abf1ed$var$capitaliseFirst = (text)=>text ? text.charAt(0).toUpperCase() + text.slice(1) : text;
/** Plain words for the residency codes, for the first-visit summary strip. */ const $91e8bd92d2abf1ed$var$RESIDENCY_LABELS = {
    own_home: 'Own home',
    renting: 'Renting',
    retirement_village: 'Retirement village',
    granny_flat: 'Granny flat',
    with_family: 'With family',
    aged_care: 'Residential aged care'
};
/**
 * Who produced a saved plan — the engine's proposal, or an adviser working the levers themselves.
 *
 * Asked for by the owner (11 Sep 2026): coming back to a list of plans weeks later, it matters which
 * ones you reasoned your way to and which were suggested to you.
 *
 * Words rather than the "SE"/"MC" initials used on SOA cards, because CLIENTS read this dashboard and
 * a two-letter code means nothing to them. Plans saved before the source was recorded carry none, and
 * get no badge — an unlabelled plan is honest, a wrongly-labelled one is not. Aged care stamps a hand-built
 * plan 'manual_control'; every other module stamps it 'manual', which went untagged until 25 Oct 2026.
 */ function $91e8bd92d2abf1ed$var$PlanSourceBadge({ source: source }) {
    const label = source === 'suggestion_engine' || source === 'SE' ? 'Suggested' : source === 'manual_control' || source === 'manual' || source === 'MC' ? 'Built by you' : null;
    if (!label) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "ml-2 inline-block align-middle rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-medium text-slate-600",
        title: label === 'Suggested' ? 'Found by AgedCareWise from the plans it tested' : 'Built by hand in "Build a plan yourself"',
        children: label
    });
}
/**
 * A saved plan's one line on Home, in the plan cards' words (owner, 25 Oct 2026): "leaves $X to the family after
 * about N years", then the module's own cost in plain words. No "Legacy:" / "Cost:" labels.
 */ function $91e8bd92d2abf1ed$var$savedPlanFiguresLine(strategy, extra = []) {
    const legacy = Number(strategy.outputs?.legacyEstimate) || 0;
    const years = Number(strategy.inputs?.legacyYears ?? strategy.legacyYears) || 0;
    const parts = [];
    if (legacy) parts.push(`leaves ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(legacy)} to the family${years ? ` after about ${years} ${years === 1 ? 'year' : 'years'}` : ''}`);
    for (const e of extra)if (e) parts.push(e);
    return parts.join(" \xb7 ");
}
/** A saved plan's name as it is shown: its plain title, never the engine's code ("SE | …", "MC | …"). */ const $91e8bd92d2abf1ed$var$shownPlanName = (s)=>String(s.displayName || s.name || 'Plan').replace(/^(SE|MC)\s*\|\s*/, '');
const $91e8bd92d2abf1ed$var$dateWords = (iso)=>new Date(String(iso)).toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    });
function $91e8bd92d2abf1ed$export$2e2bcd8739ae039({ setActivePage: setActivePage, setClientProfileStep: setClientProfileStep, factFind: factFind, setFactFind: setFactFind, savedStrategies: savedStrategies, setSavedStrategies: setSavedStrategies, savedCaseStudies: savedCaseStudies, setSavedCaseStudies: setSavedCaseStudies, onDeleteDraftSoa: onDeleteDraftSoa = null, selectedStrategy: selectedStrategy = null, setSelectedStrategy: setSelectedStrategy, professionalContext: professionalContext = null, onSubmitToAdviser: onSubmitToAdviser = null }) {
    const { client: client, partner: partner, adviceFor: adviceFor, family: family, goals: goals } = factFind;
    // The same rule the sidebar's "Complete" tag uses, so the two never disagree about the profile.
    const profileCompleteness = (0, $acw62.useMemo)(()=>(0, $88b3ba5d01a1bc33$export$e88a800cc66f6f24)(factFind), [
        factFind
    ]);
    const isPartnered = adviceFor === 'couple';
    const [showCoupleMeansTestPanel, setShowCoupleMeansTestPanel] = (0, $acw62.useState)(false);
    const [{ netWorth: netWorth, cashFlow: cashFlow, socialSecurity: socialSecurity }, setFinancials] = (0, $acw62.useState)({
        netWorth: 0,
        cashFlow: 0,
        socialSecurity: 0
    });
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind).then((result)=>{
            if (!cancelled) setFinancials(result);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind
    ]);
    const dashboardCouplePensionLabel = (0, $acw62.useMemo)(()=>{
        if (factFind?.adviceFor !== 'couple') return '';
        return (0, $8eecd0af141b9afb$export$9b95c99516118f10)(factFind, {}) ? 'illness-separated couple' : 'standard couple';
    }, [
        factFind
    ]);
    // Adds the session copy's plans; never replaces the list (sessionPlans.ts says why).
    (0, $acw62.useEffect)(()=>{
        const stored = sessionStorage.getItem('careCompanionStrategies');
        if (stored) try {
            const fromSession = JSON.parse(stored);
            setSavedStrategies((prev)=>(0, $85cb556e7e19db04$export$a51febbf9f38f8c5)(prev || [], fromSession));
        } catch (e) {
            console.error('Error parsing saved strategies:', e);
        }
    }, [
        factFind,
        setSavedStrategies
    ]);
    (0, $acw62.useEffect)(()=>{
        const stored = sessionStorage.getItem('careCompanionScenarios');
        if (stored) try {
            const parsed = JSON.parse(stored);
            setSavedCaseStudies(Array.isArray(parsed) ? parsed : []);
        } catch (e) {
            console.error('Error parsing saved case studies:', e);
        }
    }, [
        factFind,
        setSavedCaseStudies
    ]);
    const reopenStrategy = (strategy)=>{
        sessionStorage.setItem('careCompanionReopenStrategy', JSON.stringify(strategy));
        sessionStorage.removeItem('careCompanionModelAnotherHome');
        setActivePage('AgedCarePage');
    };
    /** "Model another home": the client's details and setup carried over from a saved plan, only the room to enter. */ const modelAnotherHome = (from)=>{
        sessionStorage.removeItem('careCompanionReopenStrategy');
        sessionStorage.setItem('careCompanionModelAnotherHome', JSON.stringify(from ?? {}));
        setActivePage('AgedCarePage');
    };
    /** "Start a new model": nothing carried over, the setup questions asked again (AgedCareAnalyser). */ const startNewAgedCareModel = ()=>{
        sessionStorage.removeItem('careCompanionReopenStrategy');
        sessionStorage.removeItem('careCompanionModelAnotherHome');
        sessionStorage.setItem('careCompanionStartFresh', '1');
        setActivePage('AgedCarePage');
    };
    /*
     * ONE SAVED PLAN PER HOME, THE CHOSEN ONE MARKED (owner, 17 Oct 2026: clients model several homes).
     * Ticking plans compares them side by side from here — the comparison across homes happens on Home,
     * after each home has been through the same three steps.
     */ const agedCarePlans = (0, $acw62.useMemo)(()=>savedStrategies.filter((s)=>s.type === 'aged_care'), [
        savedStrategies
    ]);
    const chosenAgedCarePlan = (0, $acw62.useMemo)(()=>{
        const bySelection = selectedStrategy ? agedCarePlans.find((p)=>selectedStrategy.id != null && String(p.id) === String(selectedStrategy.id) || !selectedStrategy.id && selectedStrategy.name && p.strategy?.name === selectedStrategy.name) ?? null : null;
        // The selection does not survive a reload; the saved plan's own mark does.
        return bySelection ?? agedCarePlans.find((p)=>p.chosen) ?? null;
    }, [
        agedCarePlans,
        selectedStrategy
    ]);
    const [tickedPlanIds, setTickedPlanIds] = (0, $acw62.useState)(()=>new Set());
    const [showComparePlans, setShowComparePlans] = (0, $acw62.useState)(false);
    const tickedPlans = agedCarePlans.filter((p)=>tickedPlanIds.has(String(p.id)));
    const togglePlanTick = (id)=>setTickedPlanIds((prev)=>{
            const next = new Set(prev);
            const k = String(id);
            if (next.has(k)) next.delete(k);
            else next.add(k);
            return next;
        });
    const compareHomes = ()=>{
        // Nothing ticked yet: compare everything, which is what "compare the homes" means with two.
        if (tickedPlans.length < 2) setTickedPlanIds(new Set(agedCarePlans.map((p)=>String(p.id))));
        setShowComparePlans(true);
    };
    /** The chosen Support at home plan, with its card (sahChosenPlan.ts). */ const chosenHomeCarePlan = (0, $acw62.useMemo)(()=>(0, $b2a376f07fa94da4$export$7502afc44cd7bedc)(savedStrategies), [
        savedStrategies
    ]);
    /** The chosen village plan with its card, and every unit's saved plan (rvChosenPlan.ts). */ const chosenVillagePlan = (0, $acw62.useMemo)(()=>(0, $accc76cd2fa8edd9$export$d11c0ebb38aa6e79)(savedStrategies), [
        savedStrategies
    ]);
    const villageUnitPlans = (0, $acw62.useMemo)(()=>(0, $accc76cd2fa8edd9$export$48ec0984e7b656be)(savedStrategies), [
        savedStrategies
    ]);
    /** The chosen downsizing plan with its card (dzChosenPlan.ts). */ const chosenDownsizingPlan = (0, $acw62.useMemo)(()=>(0, $4e46e0dde908c630$export$599ead36dcfb6049)(savedStrategies), [
        savedStrategies
    ]);
    /** The chosen granny flat plan with its card (gfChosenPlan.ts; granny flat rebuild, 21 Oct 2026). */ const chosenGrannyFlatPlan = (0, $acw62.useMemo)(()=>(0, $fa9cadf0a1243d03$export$2eb90fb4fe01ab98)(savedStrategies), [
        savedStrategies
    ]);
    const enteringFirstName = (goals?.aged_care_for === 'partner' ? partner?.firstName : client?.firstName) || 'the client';
    const reopenHomeCareStrategy = (strategy)=>{
        sessionStorage.setItem('careCompanionReopenHomeCareStrategy', JSON.stringify(strategy));
        setActivePage('HomeCarePage');
    };
    /*
     * CASHFLOW & AGE PENSION — saved plans reopen from Home; the way in is Support at home's (19 Oct 2026). The
     * plan is handed over the same way Support at home's is; the page reads it once and clears it.
     */ const reopenCashflowStrategy = (strategy)=>{
        if (strategy) sessionStorage.setItem((0, $2663acaa6cb9dd5e$export$bcc8e45d2598fb47), JSON.stringify(strategy));
        else sessionStorage.removeItem((0, $2663acaa6cb9dd5e$export$bcc8e45d2598fb47));
        setActivePage('CashflowPensionPage');
    };
    const cashflowPlans = savedStrategies.filter((s)=>s.type === 'cashflow_pension');
    const chosenCashflowPlan = cashflowPlans.find((s)=>s.chosen === true) ?? null;
    /*
     * WHERE EACH ARRANGEMENT STANDS, for Home's rows (owner, 23 Oct 2026). "Open" goes to the chosen plan's page,
     * or with none chosen to the latest save; "Start" is a fresh start in every module (its START_FRESH key:
     * nothing carried over, the questions asked again). Aged care, Support at home and cashflow reopen a given
     * save; the village, downsizing and the granny flat open where they were left, which is the last save.
     */ const [comparingUnits, setComparingUnits] = (0, $acw62.useState)(false);
    const plansOfType = (type)=>savedStrategies.filter((s)=>s.type === type);
    const latestOfType = (type)=>plansOfType(type).reduce((a, s)=>!a || new Date(String(s.createdAt)).getTime() >= new Date(String(a.createdAt)).getTime() ? s : a, null);
    const flaggedChosenOf = (type)=>plansOfType(type).find((s)=>s.chosen === true) ?? null;
    const cardTitle = (plan)=>{
        const t = plan?.inputs?.card?.words?.title;
        return t ? String(t) : null;
    };
    const chosenTitleOf = (type, withCard)=>{
        if (withCard) return cardTitle(withCard) ?? String(withCard.name || 'Saved plan');
        const flagged = flaggedChosenOf(type);
        return flagged ? cardTitle(flagged) ?? String(flagged.name || 'Saved plan') : null;
    };
    /*
     * The chosen village, downsizing, granny flat or cashflow plan, when the client's figures it was priced on have
     * changed or a re-test lost it (25 Oct 2026, chosenPlanRefresh.ts): Home says so instead of its old figures.
     */ const moduleOutOfDate = (type)=>(0, $78a369bbf1e0d995$export$ceccff7104f70d1e)(flaggedChosenOf(type), factFind);
    // The chosen Support at home plan, when the household it was priced on has changed or a re-test lost it (25 Oct 2026).
    const homeCareOutOfDate = (0, $2eb5e3232a8b6136$export$bc9892722f29f4ff)(chosenHomeCarePlan ?? flaggedChosenOf('home_care'), factFind, savedStrategies);
    const startFresh = (key, page)=>()=>{
            sessionStorage.setItem(key, '1');
            setActivePage(page);
        };
    const startHereRows = {
        aged_care: {
            savedCount: agedCarePlans.length,
            chosenTitle: chosenAgedCarePlan ? (0, $95e43332fd84eec4$export$6cc0d9545ae1511e)(chosenAgedCarePlan, factFind) : null,
            outOfDate: (0, $78a369bbf1e0d995$export$f4ec6e978b61cc57)(chosenAgedCarePlan)?.reason ?? null,
            onOpen: ()=>{
                const latest = latestOfType('aged_care');
                if (!chosenAgedCarePlan && latest) reopenStrategy(latest);
                else setActivePage('AgedCarePage');
            },
            onStartFresh: startNewAgedCareModel,
            compare: agedCarePlans.length > 1 ? {
                label: 'Compare the homes',
                onClick: compareHomes
            } : null
        },
        home_care: {
            savedCount: plansOfType('home_care').length,
            chosenTitle: chosenTitleOf('home_care', chosenHomeCarePlan),
            outOfDate: homeCareOutOfDate,
            onOpen: ()=>{
                // A plan with its card lands on the plan page (SahHub); otherwise the flagged or latest save reopens.
                const plan = chosenHomeCarePlan ? null : flaggedChosenOf('home_care') ?? latestOfType('home_care');
                if (plan) reopenHomeCareStrategy(plan);
                else setActivePage('HomeCarePage');
            },
            onStartFresh: startFresh((0, $b2a376f07fa94da4$export$23aa2da4fbf35540), 'HomeCarePage')
        },
        retirement_village: {
            savedCount: plansOfType('retirement_village').length,
            outOfDate: moduleOutOfDate('retirement_village'),
            chosenTitle: chosenTitleOf('retirement_village', chosenVillagePlan),
            onOpen: ()=>setActivePage('RetirementVillagePage'),
            onStartFresh: startFresh((0, $accc76cd2fa8edd9$export$1b00af1e78405459), 'RetirementVillagePage'),
            compare: villageUnitPlans.length > 1 ? {
                label: 'Compare the units',
                onClick: ()=>setComparingUnits(true)
            } : null
        },
        downsize_home: {
            savedCount: plansOfType('downsizer').length,
            outOfDate: moduleOutOfDate('downsizer'),
            chosenTitle: chosenTitleOf('downsizer', chosenDownsizingPlan),
            onOpen: ()=>setActivePage('DownsizingPage'),
            onStartFresh: startFresh((0, $4e46e0dde908c630$export$5d7344b7ed506119), 'DownsizingPage')
        },
        granny_flat: {
            savedCount: plansOfType('granny_flat').length,
            outOfDate: moduleOutOfDate('granny_flat'),
            chosenTitle: chosenTitleOf('granny_flat', chosenGrannyFlatPlan),
            onOpen: ()=>setActivePage('GrannyFlatPage'),
            onStartFresh: startFresh((0, $fa9cadf0a1243d03$export$edd6500f2ae69e6b), 'GrannyFlatPage')
        },
        cashflow: {
            savedCount: cashflowPlans.length,
            outOfDate: moduleOutOfDate('cashflow_pension'),
            chosenTitle: chosenCashflowPlan ? (0, $94964a4bbfeb638b$export$d0bed6e7d13194fc)(chosenCashflowPlan)?.words.title ?? String(chosenCashflowPlan.name || 'Saved plan') : null,
            onOpen: ()=>reopenCashflowStrategy(chosenCashflowPlan ?? latestOfType('cashflow_pension')),
            onStartFresh: ()=>{
                sessionStorage.removeItem((0, $2663acaa6cb9dd5e$export$bcc8e45d2598fb47));
                startFresh((0, $94964a4bbfeb638b$export$ee6e400ca50ecedf), 'CashflowPensionPage')();
            }
        }
    };
    const reopenSoaScenario = (scenario)=>{
        if (scenario?.soaSnapshot) {
            // SavedCaseStudy.soaSnapshot (dashboardConfig.tsx) is deliberately loose — it's whatever was
            // persisted to storage; openAgedCareDigitalSOAAttachment's SoaSnapshot (agedCare, out of
            // scope here) is the strict in-memory shape produced right before persisting the same data.
            (0, $02a659cad5e2280d$export$eed5e3bcf209d966)(scenario.soaSnapshot);
            return;
        }
        setActivePage('AgedCarePage');
    };
    const visibleCaseStudies = (0, $acw62.useMemo)(()=>{
        if (!professionalContext?.enabled || !professionalContext?.caseId) return savedCaseStudies;
        return savedCaseStudies.filter((scenario)=>!scenario.caseId || scenario.caseId === professionalContext.caseId);
    }, [
        savedCaseStudies,
        professionalContext
    ]);
    const clientData = {
        name: [
            client?.firstName || 'Applicant',
            client?.lastName
        ].filter(Boolean).join(' '),
        health: client?.healthStatus ? client.healthStatus.charAt(0).toUpperCase() + client.healthStatus.slice(1) : 'N/A',
        age: (0, $5589d9476399db47$export$8ada184d5eef4694)(client?.dob),
        initials: (0, $bebf3453094bd1f6$export$de9bdbce6502b027)(client?.firstName, client?.lastName),
        color1: '#89CFF0',
        color2: '#4682B4'
    };
    const partnerData = {
        name: `${partner?.firstName || 'Partner'} ${partner?.lastName || ''}`,
        health: partner?.healthStatus ? partner.healthStatus.charAt(0).toUpperCase() + partner.healthStatus.slice(1) : 'N/A',
        age: (0, $5589d9476399db47$export$8ada184d5eef4694)(partner?.dob),
        initials: (0, $bebf3453094bd1f6$export$de9bdbce6502b027)(partner?.firstName, partner?.lastName),
        color1: '#F4C2C2',
        color2: '#E08D8D'
    };
    const livingArrangementGoals = [
        goals?.home_care && "Access Home Care Support",
        goals?.downsize_home && "Downsize the family home",
        goals?.retirement_village && "Move to a retirement village",
        goals?.granny_flat && "Explore granny flat options",
        goals?.aged_care && "Move into residential aged care"
    ].filter(Boolean);
    const financialGoals = [
        goals?.meet_costs && "Meet Care Costs",
        goals?.maximise_support && "Maximise Government Support",
        goals?.preserve_assets && "Preserve Assets For Inheritance",
        goals?.funding_guidance && "Guidance On Funding Options"
    ].filter(Boolean);
    /*
     * THE HEADLINE IS THE FILE, THE GREETING IS THE READER (defect 11, 17 Oct 2026). "Welcome back
     * Ben" put the son's name where the client's belongs, and an adviser opening the file read the
     * completer's name as a headline. Now: "John & Kerry's file", and beneath it who is reading and
     * in what role — the completer when a family member filled it in, otherwise the client.
     */ const fileName = (0, $e990f63b36c4bd03$export$784a6ad9c3f17bc8)(factFind) ?? 'Your file';
    const fileHeadline = /s$/i.test(fileName) ? `${fileName}' file` : `${fileName}'s file`;
    const completerName = factFind.completer !== 'client' ? String(factFind.completerFirstName || '').trim() : '';
    const completerRelationship = String(factFind.completerRelationship || '').trim().toLowerCase();
    const householdWords = isPartnered && partner?.firstName ? `${client?.firstName || 'the client'} and ${partner.firstName}` : client?.firstName || 'the client';
    /*
     * THE READER'S VOICE (owner, 21 Oct 2026): "you" when the client is signed in, the household's
     * names when an adviser opens the file from the partner portal — no "Hello John" to the adviser.
     */ const voice = (0, $5d864ab5b3ee155d$export$4efdf34f2488f14a)(factFind);
    const greeting = !voice.you ? `${voice.Possessive} figures, as of today.${completerName ? ` Filled in by ${completerName}${completerRelationship ? `, ${voice.couple ? 'their' : voice.possessive} ${completerRelationship}` : ''}.` : ''}` : completerName ? `Hello ${completerName} \u{2014} you're helping ${householdWords}${completerRelationship ? ` as their ${completerRelationship}` : ''}. These figures are theirs, as of today.` : `Hello ${client?.firstName || 'there'} \u{2014} these are your figures, as of today.`;
    /*
     * FIRST VISIT: nothing modelled yet. See StartHere.tsx for why this state exists and why the
     * test is "nothing saved" rather than "has been here before".
     *
     * `showAllSections` lets the reader open the full dashboard anyway — nothing is hidden from
     * anyone who goes looking, and the moment a plan is saved this whole branch stops applying.
     */ /*
     * Your Details and Goals Summary are permanently superseded by the ProfileSummaryStrip above:
     * they say the same things in a longer form, and meeting the same facts twice in two different
     * layouts reads as a fault rather than as a summary (reported 2026-08-22). Kept behind a named
     * flag rather than deleted, because the per-person cards carry health status and the children
     * pill, and if the strip ever proves too terse this is where the richer version lives.
     */ const showLegacyProfileSections = false;
    const [showAllSections, setShowAllSections] = (0, $acw62.useState)(false);
    const hasNothingSaved = savedStrategies.length === 0 && visibleCaseStudies.length === 0;
    const isFirstVisit = hasNothingSaved && !showAllSections;
    /**
     * Name-led, matching the fact-find: a son filling this in for his father reads "George's".
     *
     * The HEADING names the whole household, because the profile covers the whole household. Each
     * ACTION names whoever that goal is for, which the profile records separately for residential
     * care and home care — one of a couple can be entering care while both are on home care.
     */ // An adviser opening the file reads the household's names, never "you and Kerry's" (25 Oct 2026).
    const readerIsApplicant = !(0, $5d864ab5b3ee155d$export$879d88d360a0f068)() && (factFind.completer === 'client' || !client?.firstName);
    const householdNames = {
        client: client?.firstName,
        partner: partner?.firstName
    };
    const ApplicantPossessive = $91e8bd92d2abf1ed$var$capitaliseFirst((0, $ac9fcf827b574382$export$b99630ccf9c9a1b7)(undefined, householdNames, isPartnered, readerIsApplicant));
    /** Two chosen plans that cannot both go ahead, said once on Home (kept from the former tiles, 23 Oct 2026). */ const startHereAlternatives = chosenAgedCarePlan && chosenHomeCarePlan ? `They are alternatives: ${voice.you && !voice.couple ? 'you' : enteringFirstName} in residential care, or ${voice.you && voice.couple ? 'both of you' : voice.names} at home with support. Both draw on the same savings, so only one can go ahead as modelled.` : null;
    const possessiveForAction = (action)=>(0, $ac9fcf827b574382$export$b99630ccf9c9a1b7)(action.forField ? goals?.[action.forField] : undefined, householdNames, isPartnered, readerIsApplicant);
    const openProfile = ()=>{
        // Step 2 is Your Details — the step someone means by "edit details". Without the setter we
        // still open the profile, just wherever it was left.
        setClientProfileStep?.(2);
        setActivePage('Client Profile');
    };
    /**
     * The first-visit summary. Each person carries their OWN age — the first cut appended one age to
     * a list of two names, so a couple read as "Michael Sooky, 83, and Tara Sooky" and Tara's age
     * silently belonged to Michael (reported 2026-08-22).
     */ const describePerson = (person)=>person.age ? `${person.name} (${person.age})` : person.name;
    const summaryFacts = [
        {
            label: isPartnered ? 'Who' : 'Who',
            value: isPartnered ? `${describePerson(clientData)} and ${describePerson(partnerData)}` : `${describePerson(clientData)}, single`
        },
        {
            label: 'Lives',
            value: $91e8bd92d2abf1ed$var$RESIDENCY_LABELS[String(client?.currentResidency || '')] || 'Not recorded'
        },
        // Living and financial goals are listed apart, as they are everywhere else in the tool: one
        // run-on line of six goals is a wall of text (reported 2026-08-22).
        ...livingArrangementGoals.length ? [
            {
                label: livingArrangementGoals.length === 1 ? 'Living goal' : 'Living goals',
                value: livingArrangementGoals.join(" \xb7 ")
            }
        ] : [],
        ...financialGoals.length ? [
            {
                label: financialGoals.length === 1 ? 'Financial goal' : 'Financial goals',
                value: financialGoals.join(" \xb7 ")
            }
        ] : [],
        ...livingArrangementGoals.length + financialGoals.length === 0 ? [
            {
                label: 'Goals',
                value: 'None set'
            }
        ] : []
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-8 relative min-h-screen",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative overflow-hidden rounded-3xl shadow-cardlg bg-brand-navy ",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute -top-20 -right-10 w-72 h-72 rounded-full bg-white/10 blur-3xl",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute -bottom-24 -left-12 w-80 h-80 rounded-full bg-teal-300/10 blur-3xl",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative p-7 md:p-9",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5 mb-7",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-14 h-14 rounded-2xl bg-white/15 ring-1 ring-white/25 backdrop-blur flex items-center justify-center text-white text-xl font-bold",
                                                children: (0, $bebf3453094bd1f6$export$de9bdbce6502b027)(client?.firstName, client?.lastName) || 'U'
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                                        className: "text-3xl md:text-4xl font-extrabold text-white tracking-tight leading-tight",
                                                        children: fileHeadline
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "mt-1 text-blue-100/90 text-sm font-medium",
                                                        "data-testid": "dashboard-greeting",
                                                        children: greeting
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    false
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-3 gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91cd8ed21bb5644f$export$995c77c012c8eb7f), {
                                        label: `What ${voice.they} own, less what ${voice.they} owe`,
                                        value: netWorth,
                                        icon: (0, $33b542e8915cec79$export$2e2bcd8739ae039)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91cd8ed21bb5644f$export$995c77c012c8eb7f), {
                                        label: (Number(cashFlow) || 0) < 0 ? 'Each year, short by' : 'Left over each year',
                                        value: cashFlow == null ? cashFlow : Math.abs(Number(cashFlow) || 0),
                                        icon: (0, $c9921f4f81a419f0$export$2e2bcd8739ae039)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91cd8ed21bb5644f$export$995c77c012c8eb7f), {
                                        label: "Age Pension today",
                                        value: socialSecurity,
                                        icon: (0, $05565f19ab398c04$export$2e2bcd8739ae039)
                                    })
                                ]
                            }),
                            !isPartnered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-4 text-xs text-blue-100/80 leading-relaxed max-w-2xl",
                                children: socialSecurity > 0 ? `${voice.Possessive} Age Pension figure is an estimate under Centrelink's single-person income and assets tests.` : `Based on ${voice.possessive} savings and assets, ${voice.you ? "you're" : `${voice.names} ${voice.are}`} currently above the Age Pension limit for a single person \u{2014} so no pension is payable right now. This can change if ${voice.their} assessable assets reduce (for example, after paying for care).`
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac9fcf827b574382$export$ef5c5eb8eeb80017), {
                        goals: goals,
                        completeness: profileCompleteness,
                        setClientProfileStep: setClientProfileStep,
                        Possessive: ApplicantPossessive,
                        possessiveFor: possessiveForAction,
                        setActivePage: setActivePage,
                        rows: startHereRows,
                        alternatives: startHereAlternatives
                    }),
                    comparingUnits && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eb5ca8e9ee335a7$export$2e2bcd8739ae039), {
                        units: villageUnitPlans,
                        onClose: ()=>setComparingUnits(false)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac9fcf827b574382$export$8654c5f14998d604), {
                        facts: summaryFacts,
                        onEdit: openProfile
                    })
                ]
            }),
            isFirstVisit ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac9fcf827b574382$export$32ae7e77b43ca9a4), {
                        onShowAll: ()=>setShowAllSections(true)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                        className: "bg-white/70",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91cd8ed21bb5644f$export$8adb256d999cd5a0), {
                                title: "Helpful Services",
                                showArrow: false
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-6 p-4 bg-white rounded-xl border border-gray-100 hover:shadow-md transition-shadow",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d735a46f6c8532a3$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 xl:grid-cols-3 gap-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "xl:col-span-2 space-y-8",
                        children: [
                            showLegacyProfileSections && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                                className: "bg-white/70",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91cd8ed21bb5644f$export$8adb256d999cd5a0), {
                                        title: "Your Details"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-6",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex flex-col sm:flex-row gap-4 mb-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91cd8ed21bb5644f$export$bed540ccfa8743c4), {
                                                        user: clientData
                                                    }),
                                                    isPartnered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91cd8ed21bb5644f$export$bed540ccfa8743c4), {
                                                        user: partnerData
                                                    })
                                                ]
                                            }),
                                            ((parseFloat(String(family?.childrenCount)) || 0) > 0 || client?.currentResidency === 'own_home') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex flex-wrap gap-3 pt-4 border-t border-gray-200",
                                                children: [
                                                    (parseFloat(String(family?.childrenCount)) || 0) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91cd8ed21bb5644f$export$b9109ed793f09d29), {
                                                        icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
                                                        text: `${family?.childrenCount} Children`
                                                    }),
                                                    client?.currentResidency === 'own_home' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91cd8ed21bb5644f$export$b9109ed793f09d29), {
                                                        icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
                                                        text: "Home Owner"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            showLegacyProfileSections && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                                className: "bg-white/70",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91cd8ed21bb5644f$export$8adb256d999cd5a0), {
                                        title: "Goals Summary"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "p-4 rounded-xl bg-slate-50 border border-slate-200/70",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex items-center gap-3 mb-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                                                icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
                                                                tone: "brand",
                                                                variant: "solid",
                                                                size: "sm"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-bold text-gray-800",
                                                                children: "Living Arrangement Goals"
                                                            })
                                                        ]
                                                    }),
                                                    livingArrangementGoals.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        children: livingArrangementGoals.map((g)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91cd8ed21bb5644f$export$9d1db7317d6f21a0), {
                                                                text: g
                                                            }, g))
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-gray-500 text-sm italic",
                                                        children: "No goals set."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "p-4 rounded-xl bg-slate-50 border border-slate-200/70",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex items-center gap-3 mb-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                                                icon: (0, $52885985d1db6c06$export$2e2bcd8739ae039),
                                                                tone: "brand",
                                                                variant: "solid",
                                                                size: "sm"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-bold text-gray-800",
                                                                children: "Financial Goals"
                                                            })
                                                        ]
                                                    }),
                                                    financialGoals.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        children: financialGoals.map((g)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91cd8ed21bb5644f$export$9d1db7317d6f21a0), {
                                                                text: g
                                                            }, g))
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-gray-500 text-sm italic",
                                                        children: "No goals set."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isPartnered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                                className: "bg-white border border-slate-200/70 border-l-4 border-blue-500",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>setShowCoupleMeansTestPanel(!showCoupleMeansTestPanel),
                                        className: "w-full p-4 text-left flex items-center justify-between hover:bg-slate-50 transition-colors duration-200 rounded-lg",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                                        className: "text-blue-600 flex-shrink-0",
                                                        size: 20
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                className: "text-blue-900 font-semibold text-sm",
                                                                children: "Couple means test (Age Pension snapshot)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-xs text-blue-700/90 mt-0.5",
                                                                children: "How your Age Pension figure above is assessed"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                className: `text-blue-600 transition-transform duration-200 flex-shrink-0 ${showCoupleMeansTestPanel ? 'rotate-180' : ''}`,
                                                size: 18
                                            })
                                        ]
                                    }),
                                    showCoupleMeansTestPanel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "px-4 pb-4 pt-0 space-y-4 text-sm text-blue-900 border-t border-blue-100/80",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "leading-relaxed",
                                                children: [
                                                    "The ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Age Pension"
                                                    }),
                                                    " amount above uses Centrelink's",
                                                    ' ',
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: dashboardCouplePensionLabel
                                                    }),
                                                    " income and assets test thresholds."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "leading-relaxed",
                                                children: [
                                                    "In the ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Aged Care"
                                                    }),
                                                    " module we apply Centrelink-style rules whereby, when one person moves into aged care, a different ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "\u201Cillness-separated\u201D"
                                                    }),
                                                    " assessment threshold is used. This provides higher thresholds to reflect the higher costs associated with care. The drop-down below lets you override this back to the normal (more conservative) standard-couple threshold."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                label: "Illness-separated couple treatment",
                                                name: "illnessSeparatedMode",
                                                value: factFind.relationship?.illnessSeparatedMode || 'auto',
                                                onChange: (name, value)=>setFactFind((prev)=>({
                                                            ...prev,
                                                            relationship: {
                                                                ...prev.relationship,
                                                                [name]: value
                                                            }
                                                        })),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "auto",
                                                        children: "Auto (recommended)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "yes",
                                                        children: "Yes \u2014 apply illness-separated rules"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "no",
                                                        children: "No \u2014 standard couple (not illness-separated)"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            professionalContext?.enabled && professionalContext.accessMode === 'client_stop_dashboard' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                                className: "bg-white border border-slate-200/70 border-l-4 border-blue-500",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center justify-between gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    className: "text-lg font-bold text-gray-900",
                                                    children: "Professional Handover"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-sm text-gray-700 mt-1",
                                                    children: "This case is configured to stop at Dashboard. Submit profile data to your adviser for modelling and strategy review."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-xs text-gray-600 mt-2",
                                                    children: [
                                                        "Submission date: ",
                                                        professionalContext.submissionDate ? new Date(professionalContext.submissionDate).toLocaleString('en-AU') : 'Not submitted yet'
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            onClick: ()=>onSubmitToAdviser && onSubmitToAdviser(),
                                            className: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-semibold",
                                            children: "Submit to Adviser"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                                className: "bg-white/70",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91cd8ed21bb5644f$export$8adb256d999cd5a0), {
                                        title: "Saved plans"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-6 space-y-5",
                                        children: [
                                            goals?.aged_care && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "border-l-4 border-blue-500 rounded-lg bg-white border border-slate-200/70 p-5 shadow-sm hover:shadow-md transition-shadow",
                                                "data-testid": "saved-plans-aged-care",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex flex-wrap items-center justify-between gap-3 mb-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex items-center gap-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                                                        icon: (0, $d5c3c2c5a9eb8655$export$388c0e4f7230aadf).aged_care,
                                                                        tone: "brand",
                                                                        variant: "solid",
                                                                        size: "md"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                                className: "font-bold text-gray-800",
                                                                                children: "Aged care \u2014 one plan per home"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                className: "bg-blue-100 text-blue-800 text-xs px-2.5 py-0.5 rounded-full font-semibold",
                                                                                children: [
                                                                                    agedCarePlans.length,
                                                                                    " saved"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex flex-wrap items-center gap-2",
                                                                children: [
                                                                    agedCarePlans.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                        type: "button",
                                                                        onClick: compareHomes,
                                                                        disabled: tickedPlans.length === 1,
                                                                        className: "rounded-lg bg-blue-600 px-3.5 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:opacity-50",
                                                                        children: [
                                                                            "Compare ticked plans",
                                                                            tickedPlans.length > 0 ? ` (${tickedPlans.length})` : ''
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        onClick: ()=>setActivePage('AgedCarePage'),
                                                                        className: "text-blue-600 hover:text-blue-800 text-sm font-semibold hover:underline transition-all",
                                                                        children: "Open Aged care \u2192"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    agedCarePlans.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "space-y-3",
                                                        children: [
                                                            agedCarePlans.map((strategy)=>{
                                                                const isChosen = chosenAgedCarePlan != null && String(chosenAgedCarePlan.id) === String(strategy.id);
                                                                const room = Number(strategy.outputs?.roomCost) || 0;
                                                                const home = String(strategy.homeName || '').trim();
                                                                const title = (0, $95e43332fd84eec4$export$6cc0d9545ae1511e)(strategy, factFind);
                                                                const years = Number(strategy.inputs?.legacyYears) || 0;
                                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: `flex items-center gap-3 rounded-xl border bg-white p-4 transition-all ${isChosen ? 'border-emerald-300' : 'border-slate-200'}`,
                                                                    "data-testid": "saved-plan-row",
                                                                    children: [
                                                                        agedCarePlans.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                            type: "checkbox",
                                                                            checked: tickedPlanIds.has(String(strategy.id)),
                                                                            onChange: ()=>togglePlanTick(strategy.id),
                                                                            "aria-label": `Compare ${title}`,
                                                                            className: "h-4 w-4 shrink-0 rounded border-slate-300"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "min-w-0 flex-1",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                    className: "font-semibold text-gray-900",
                                                                                    children: [
                                                                                        home ? `${home}, ` : '',
                                                                                        room > 0 ? `${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(room)} room` : 'room',
                                                                                        " \u2014 ",
                                                                                        title,
                                                                                        isChosen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: "ml-2 inline-flex items-center rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-semibold text-emerald-800 align-middle",
                                                                                            children: "Chosen"
                                                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: "ml-2 inline-flex items-center rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-semibold text-slate-600 align-middle",
                                                                                            children: "Saved, not chosen"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($91e8bd92d2abf1ed$var$PlanSourceBadge, {
                                                                                            source: strategy.source
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                isChosen && (0, $78a369bbf1e0d995$export$f4ec6e978b61cc57)(strategy) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                    className: "mt-1 text-xs text-slate-700",
                                                                                    "data-testid": "aged-care-card-out-of-date",
                                                                                    children: [
                                                                                        (0, $78a369bbf1e0d995$export$f4ec6e978b61cc57)(strategy).reason,
                                                                                        " \xb7 chosen ",
                                                                                        new Date(strategy.createdAt).toLocaleDateString('en-AU', {
                                                                                            day: 'numeric',
                                                                                            month: 'short',
                                                                                            year: 'numeric'
                                                                                        })
                                                                                    ]
                                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                    className: "mt-1 text-xs text-gray-500",
                                                                                    children: [
                                                                                        "Left to the family",
                                                                                        years ? ` after about ${years} ${years === 1 ? 'year' : 'years'}` : '',
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: "font-semibold text-slate-800 tabular-nums",
                                                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(strategy.outputs?.legacyEstimate)
                                                                                        }),
                                                                                        " \xb7 ",
                                                                                        "care ",
                                                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(strategy.outputs?.agedCareCost),
                                                                                        " a year",
                                                                                        " \xb7 ",
                                                                                        new Date(strategy.createdAt).toLocaleDateString('en-AU', {
                                                                                            day: 'numeric',
                                                                                            month: 'short',
                                                                                            year: 'numeric'
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            onClick: ()=>reopenStrategy(strategy),
                                                                            className: "shrink-0 rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-sm font-semibold text-slate-800 hover:border-blue-300 hover:bg-blue-50",
                                                                            children: "Open"
                                                                        })
                                                                    ]
                                                                }, strategy.id);
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                className: "text-sm text-slate-600",
                                                                children: [
                                                                    "Each home is kept as its own plan, so nothing is overwritten.",
                                                                    agedCarePlans.length > 1 ? ' Tick the ones you want to see side by side.' : '',
                                                                    ' ',
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        onClick: ()=>modelAnotherHome(chosenAgedCarePlan ?? agedCarePlans[0] ?? null),
                                                                        className: "font-semibold text-blue-700 hover:underline",
                                                                        children: "Model another home"
                                                                    }),
                                                                    " keeps ",
                                                                    enteringFirstName,
                                                                    "'s details and asks only for the room."
                                                                ]
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "space-y-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "p-6 text-center bg-slate-50 rounded-xl border-2 border-dashed border-gray-300",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8474226e5f2f9b18$export$2e2bcd8739ae039), {
                                                                        className: "mx-auto text-gray-300 mb-3",
                                                                        size: 32
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        className: "text-gray-500 text-sm font-medium mb-2",
                                                                        children: "No aged care plan saved yet."
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "p-4 bg-white border border-slate-200 border-l-4 border-blue-500 rounded-r-lg flex items-start gap-2.5",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e57d6b071418ede9$export$2e2bcd8739ae039), {
                                                                        size: 18,
                                                                        className: "text-blue-500 flex-shrink-0 mt-0.5"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                        className: "text-sm text-slate-800",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                                children: "Ready to start?"
                                                                            }),
                                                                            " Open Aged care: three short steps \u2014 what the room costs, what it means for ",
                                                                            enteringFirstName,
                                                                            ", and the ways to pay for it."
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            showComparePlans && tickedPlans.length >= 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $913a5d4dfade16ea$export$2e2bcd8739ae039), {
                                                plans: tickedPlans,
                                                factFind: factFind,
                                                chosenId: chosenAgedCarePlan?.id ?? null,
                                                onOpenPlan: (p)=>{
                                                    setShowComparePlans(false);
                                                    reopenStrategy(p);
                                                },
                                                onChoose: setSelectedStrategy ? (p)=>{
                                                    setSelectedStrategy(p);
                                                    setShowComparePlans(false);
                                                } : undefined,
                                                onClose: ()=>setShowComparePlans(false)
                                            }),
                                            visibleCaseStudies.length > 0 && /* The menu's Reports line lands here (components/layout/clientMenu.ts). */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                id: (0, $e990f63b36c4bd03$export$b2f3bf9c7e33d4ec),
                                                className: "scroll-mt-4 border-l-4 border-blue-500 rounded-lg bg-white border border-slate-200/70 p-5 shadow-sm hover:shadow-md transition-shadow",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "flex items-center justify-between mb-4",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex items-center gap-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                                                    icon: (0, $adb270212de20834$export$2e2bcd8739ae039),
                                                                    tone: "brand",
                                                                    variant: "solid",
                                                                    size: "md"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                            className: "font-bold text-gray-800",
                                                                            children: "Advice documents"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "bg-blue-100 text-blue-800 text-xs px-2.5 py-0.5 rounded-full font-semibold",
                                                                            children: [
                                                                                visibleCaseStudies.length,
                                                                                " saved"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "space-y-3",
                                                        children: visibleCaseStudies.map((scenario)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                onClick: ()=>reopenSoaScenario(scenario),
                                                                className: "flex items-center justify-between p-4 bg-slate-50 rounded-xl border border-slate-200 hover:border-blue-300 hover:shadow-lg cursor-pointer transition-all duration-300 group",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "flex-1",
                                                                        children: [
                                                                            (()=>{
                                                                                const source = scenario.soaSource || scenario.soaSnapshot?.strategySource || null;
                                                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                    className: "font-semibold text-gray-900 group-hover:text-blue-600 transition-colors",
                                                                                    children: [
                                                                                        $91e8bd92d2abf1ed$var$shownPlanName(scenario),
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($91e8bd92d2abf1ed$var$PlanSourceBadge, {
                                                                                            source: source
                                                                                        })
                                                                                    ]
                                                                                });
                                                                            })(),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "text-xs text-gray-500 mt-1",
                                                                                children: [
                                                                                    (()=>{
                                                                                        const lever = (0, $8a1c93567d70a6d1$export$8fe97d85839733d)(scenario);
                                                                                        return lever ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                                    className: "font-semibold text-slate-700",
                                                                                                    children: lever
                                                                                                }),
                                                                                                " \xb7 "
                                                                                            ]
                                                                                        }) : null;
                                                                                    })(),
                                                                                    (()=>{
                                                                                        const line = $91e8bd92d2abf1ed$var$savedPlanFiguresLine(scenario, [
                                                                                            Number(scenario.outputs?.agedCareCost) ? `care ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(scenario.outputs?.agedCareCost)} a year` : null
                                                                                        ]);
                                                                                        return line ? `${line} \xb7 ` : '';
                                                                                    })(),
                                                                                    $91e8bd92d2abf1ed$var$dateWords(scenario.createdAt)
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "text-right text-xs space-y-1 ml-4",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                className: "text-blue-600 font-semibold mt-2 group-hover:underline",
                                                                                children: "Open the advice document \u2192"
                                                                            }),
                                                                            (scenario.soaDeliveryStatus || 'draft') === 'draft' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                type: "button",
                                                                                className: "mt-2 text-red-600 hover:text-red-700 font-semibold",
                                                                                onClick: (e)=>{
                                                                                    e.stopPropagation();
                                                                                    onDeleteDraftSoa?.(scenario.id);
                                                                                },
                                                                                children: "Delete Draft"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }, scenario.id))
                                                    })
                                                ]
                                            }),
                                            goals?.home_care && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "border-l-4 border-blue-500 rounded-lg bg-white border border-slate-200/70 p-5 shadow-sm hover:shadow-md transition-shadow",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex items-center justify-between mb-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex items-center gap-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                                                        icon: (0, $d5c3c2c5a9eb8655$export$388c0e4f7230aadf).home_care,
                                                                        tone: "brand",
                                                                        variant: "solid",
                                                                        size: "md"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                                className: "font-bold text-gray-800",
                                                                                children: "Home Care"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                className: "bg-blue-100 text-blue-800 text-xs px-2.5 py-0.5 rounded-full font-semibold",
                                                                                children: [
                                                                                    savedStrategies.filter((s)=>s.type === 'home_care').length,
                                                                                    " saved"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                onClick: ()=>setActivePage('HomeCarePage'),
                                                                className: "text-blue-600 hover:text-blue-800 text-sm font-semibold hover:underline transition-all",
                                                                children: "View All \u2192"
                                                            })
                                                        ]
                                                    }),
                                                    savedStrategies.filter((s)=>s.type === 'home_care').length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "space-y-3",
                                                        children: savedStrategies.filter((s)=>s.type === 'home_care').map((strategy)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex items-center justify-between p-4 bg-slate-50 rounded-xl border border-slate-200 hover:border-blue-300 hover:shadow-lg cursor-pointer transition-all duration-300 group",
                                                                onClick: ()=>reopenHomeCareStrategy(strategy),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "flex-1",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "font-semibold text-gray-900 group-hover:text-blue-600 transition-colors",
                                                                                children: [
                                                                                    $91e8bd92d2abf1ed$var$shownPlanName(strategy),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($91e8bd92d2abf1ed$var$PlanSourceBadge, {
                                                                                        source: strategy.source
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            strategy.chosen && homeCareOutOfDate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "mt-1 text-xs text-slate-700",
                                                                                "data-testid": "home-care-card-out-of-date",
                                                                                children: [
                                                                                    homeCareOutOfDate,
                                                                                    " \xb7 chosen ",
                                                                                    $91e8bd92d2abf1ed$var$dateWords(strategy.createdAt)
                                                                                ]
                                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "text-xs text-gray-500 mt-1",
                                                                                children: [
                                                                                    $91e8bd92d2abf1ed$var$savedPlanFiguresLine(strategy, [
                                                                                        `support ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(strategy.outputs?.annualContribution || strategy.outputs?.totalCost || 0)} a year`
                                                                                    ]),
                                                                                    " \xb7 ",
                                                                                    $91e8bd92d2abf1ed$var$dateWords(strategy.createdAt)
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "text-right text-xs space-y-1 ml-4",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "text-blue-600 font-semibold mt-2 group-hover:underline",
                                                                            children: "Click to reopen \u2192"
                                                                        })
                                                                    })
                                                                ]
                                                            }, strategy.id))
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "p-6 text-center bg-slate-50 rounded-xl border-2 border-dashed border-gray-300",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bee7e1f6335e67ab$export$2e2bcd8739ae039), {
                                                                className: "mx-auto text-gray-300 mb-3",
                                                                size: 32
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-gray-500 text-sm font-medium",
                                                                children: "No home care strategies saved yet."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            goals?.retirement_village && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "border-l-4 border-blue-500 rounded-lg bg-white border border-slate-200/70 p-5 shadow-sm hover:shadow-md transition-shadow",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex items-center justify-between mb-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex items-center gap-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                                                        icon: (0, $d5c3c2c5a9eb8655$export$388c0e4f7230aadf).retirement_village,
                                                                        tone: "brand",
                                                                        variant: "solid",
                                                                        size: "md"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                                className: "font-bold text-gray-800",
                                                                                children: "Retirement Village"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                className: "bg-blue-100 text-blue-800 text-xs px-2.5 py-0.5 rounded-full font-semibold",
                                                                                children: [
                                                                                    savedStrategies.filter((s)=>s.type === 'retirement_village').length,
                                                                                    " saved"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                onClick: ()=>setActivePage('RetirementVillagePage'),
                                                                className: "text-blue-600 hover:text-blue-800 text-sm font-semibold hover:underline transition-all",
                                                                children: "View All \u2192"
                                                            })
                                                        ]
                                                    }),
                                                    savedStrategies.filter((s)=>s.type === 'retirement_village').length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "space-y-3",
                                                        children: savedStrategies.filter((s)=>s.type === 'retirement_village').map((strategy)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex items-center justify-between p-4 bg-slate-50 rounded-xl border border-slate-200 hover:border-blue-300 hover:shadow-lg cursor-pointer transition-all duration-300 group",
                                                                onClick: ()=>setActivePage('RetirementVillagePage'),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "flex-1",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "font-semibold text-gray-900 group-hover:text-blue-600 transition-colors",
                                                                                children: [
                                                                                    $91e8bd92d2abf1ed$var$shownPlanName(strategy),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($91e8bd92d2abf1ed$var$PlanSourceBadge, {
                                                                                        source: strategy.source
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            strategy.chosen && moduleOutOfDate('retirement_village') ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "mt-1 text-xs text-slate-700",
                                                                                "data-testid": "retirement_village-card-out-of-date",
                                                                                children: [
                                                                                    moduleOutOfDate('retirement_village'),
                                                                                    " \xb7 chosen ",
                                                                                    $91e8bd92d2abf1ed$var$dateWords(strategy.createdAt)
                                                                                ]
                                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "text-xs text-gray-500 mt-1",
                                                                                children: [
                                                                                    (()=>{
                                                                                        const lever = (0, $8a1c93567d70a6d1$export$8fe97d85839733d)(strategy, 'retirement_village');
                                                                                        return lever ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                                    className: "font-semibold text-slate-700",
                                                                                                    children: lever
                                                                                                }),
                                                                                                " \xb7 "
                                                                                            ]
                                                                                        }) : null;
                                                                                    })(),
                                                                                    (()=>{
                                                                                        const line = $91e8bd92d2abf1ed$var$savedPlanFiguresLine(strategy);
                                                                                        return line ? `${line} \xb7 ` : '';
                                                                                    })(),
                                                                                    $91e8bd92d2abf1ed$var$dateWords(strategy.createdAt)
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "text-right text-xs space-y-1 ml-4",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "text-blue-600 font-semibold mt-2 group-hover:underline",
                                                                            children: "Open Retirement Village \u2192"
                                                                        })
                                                                    })
                                                                ]
                                                            }, strategy.id))
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "p-6 text-center bg-slate-50 rounded-xl border-2 border-dashed border-gray-300",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                                                className: "mx-auto text-gray-300 mb-3",
                                                                size: 32
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-gray-500 text-sm font-medium",
                                                                children: "No retirement village strategies saved yet."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            goals?.downsize_home && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "border-l-4 border-blue-500 rounded-lg bg-white border border-slate-200/70 p-5 shadow-sm hover:shadow-md transition-shadow",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex items-center justify-between mb-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex items-center gap-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                                                        icon: (0, $d5c3c2c5a9eb8655$export$388c0e4f7230aadf).downsizer,
                                                                        tone: "brand",
                                                                        variant: "solid",
                                                                        size: "md"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                                className: "font-bold text-gray-800",
                                                                                children: "Downsizing"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                className: "bg-blue-100 text-blue-800 text-xs px-2.5 py-0.5 rounded-full font-semibold",
                                                                                children: [
                                                                                    savedStrategies.filter((s)=>s.type === 'downsizer').length,
                                                                                    " saved"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                onClick: ()=>setActivePage('DownsizingPage'),
                                                                className: "text-blue-600 hover:text-blue-800 text-sm font-semibold hover:underline transition-all",
                                                                children: "View All \u2192"
                                                            })
                                                        ]
                                                    }),
                                                    savedStrategies.filter((s)=>s.type === 'downsizer').length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "space-y-3",
                                                        children: savedStrategies.filter((s)=>s.type === 'downsizer').map((strategy)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex items-center justify-between p-4 bg-slate-50 rounded-xl border border-slate-200 hover:border-blue-300 hover:shadow-lg cursor-pointer transition-all duration-300 group",
                                                                onClick: ()=>setActivePage('DownsizingPage'),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "flex-1",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "font-semibold text-gray-900 group-hover:text-blue-600 transition-colors",
                                                                                children: [
                                                                                    $91e8bd92d2abf1ed$var$shownPlanName(strategy),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($91e8bd92d2abf1ed$var$PlanSourceBadge, {
                                                                                        source: strategy.source
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            strategy.chosen && moduleOutOfDate('downsizer') ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "mt-1 text-xs text-slate-700",
                                                                                "data-testid": "downsizer-card-out-of-date",
                                                                                children: [
                                                                                    moduleOutOfDate('downsizer'),
                                                                                    " \xb7 chosen ",
                                                                                    $91e8bd92d2abf1ed$var$dateWords(strategy.createdAt)
                                                                                ]
                                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "text-xs text-gray-500 mt-1",
                                                                                children: [
                                                                                    (()=>{
                                                                                        const lever = (0, $8a1c93567d70a6d1$export$8fe97d85839733d)(strategy, 'downsizer');
                                                                                        return lever ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                                    className: "font-semibold text-slate-700",
                                                                                                    children: lever
                                                                                                }),
                                                                                                " \xb7 "
                                                                                            ]
                                                                                        }) : null;
                                                                                    })(),
                                                                                    (()=>{
                                                                                        const line = $91e8bd92d2abf1ed$var$savedPlanFiguresLine(strategy);
                                                                                        return line ? `${line} \xb7 ` : '';
                                                                                    })(),
                                                                                    $91e8bd92d2abf1ed$var$dateWords(strategy.createdAt)
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "text-right text-xs space-y-1 ml-4",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "text-blue-600 font-semibold mt-2 group-hover:underline",
                                                                            children: "Open Downsizing \u2192"
                                                                        })
                                                                    })
                                                                ]
                                                            }, strategy.id))
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "p-6 text-center bg-slate-50 rounded-xl border-2 border-dashed border-gray-300",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bee7e1f6335e67ab$export$2e2bcd8739ae039), {
                                                                className: "mx-auto text-gray-300 mb-3",
                                                                size: 32
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-gray-500 text-sm font-medium",
                                                                children: "No downsizing strategies saved yet."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            savedStrategies.filter((s)=>s.type === 'cashflow_pension').length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "border-l-4 border-blue-500 rounded-lg bg-white border border-slate-200/70 p-5 shadow-sm hover:shadow-md transition-shadow",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex items-center justify-between mb-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex items-center gap-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                                                        icon: (0, $d5c3c2c5a9eb8655$export$388c0e4f7230aadf).cashflow_pension,
                                                                        tone: "brand",
                                                                        variant: "solid",
                                                                        size: "md"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                                className: "font-bold text-gray-800",
                                                                                children: "Cashflow & Age Pension"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                className: "bg-blue-100 text-blue-800 text-xs px-2.5 py-0.5 rounded-full font-semibold",
                                                                                children: [
                                                                                    savedStrategies.filter((s)=>s.type === 'cashflow_pension').length,
                                                                                    " saved"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                onClick: ()=>reopenCashflowStrategy(null),
                                                                className: "text-blue-600 hover:text-blue-800 text-sm font-semibold hover:underline transition-all",
                                                                children: "View All \u2192"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "space-y-3",
                                                        children: savedStrategies.filter((s)=>s.type === 'cashflow_pension').map((strategy)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex items-center justify-between p-4 bg-slate-50 rounded-xl border border-slate-200 hover:border-blue-300 hover:shadow-lg cursor-pointer transition-all duration-300 group",
                                                                onClick: ()=>reopenCashflowStrategy(strategy),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "flex-1",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "font-semibold text-gray-900 group-hover:text-blue-600 transition-colors",
                                                                                children: [
                                                                                    $91e8bd92d2abf1ed$var$shownPlanName(strategy),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($91e8bd92d2abf1ed$var$PlanSourceBadge, {
                                                                                        source: strategy.source
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            strategy.chosen && moduleOutOfDate('cashflow_pension') ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "mt-1 text-xs text-slate-700",
                                                                                "data-testid": "cashflow_pension-card-out-of-date",
                                                                                children: [
                                                                                    moduleOutOfDate('cashflow_pension'),
                                                                                    " \xb7 chosen ",
                                                                                    $91e8bd92d2abf1ed$var$dateWords(strategy.createdAt)
                                                                                ]
                                                                            }) : /* All three, never just the flattering one: most of these levers buy a bigger pension by
                                                           spending capital, so a line showing the pension alone would be selling rather than advising. */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "text-xs text-gray-500 mt-1",
                                                                                children: [
                                                                                    $91e8bd92d2abf1ed$var$savedPlanFiguresLine(strategy, [
                                                                                        `Age Pension ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(strategy.outputs?.agePension || 0)} a year`,
                                                                                        `${Number(strategy.outputs?.cashFlow) < 0 ? 'short' : 'to spare'} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.abs(Number(strategy.outputs?.cashFlow) || 0))} a year`
                                                                                    ]),
                                                                                    " \xb7 ",
                                                                                    $91e8bd92d2abf1ed$var$dateWords(strategy.createdAt)
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "text-right text-xs space-y-1 ml-4",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "text-blue-600 font-semibold mt-2 group-hover:underline",
                                                                            children: "Open Cashflow & Age Pension \u2192"
                                                                        })
                                                                    })
                                                                ]
                                                            }, strategy.id))
                                                    })
                                                ]
                                            }),
                                            goals?.granny_flat && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "border-l-4 border-blue-500 rounded-lg bg-white border border-slate-200/70 p-5 shadow-sm hover:shadow-md transition-shadow",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex items-center justify-between mb-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex items-center gap-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                                                        icon: (0, $d5c3c2c5a9eb8655$export$388c0e4f7230aadf).granny_flat,
                                                                        tone: "brand",
                                                                        variant: "solid",
                                                                        size: "md"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                                className: "font-bold text-gray-800",
                                                                                children: "Granny Flat"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                className: "bg-blue-100 text-blue-800 text-xs px-2.5 py-0.5 rounded-full font-semibold",
                                                                                children: [
                                                                                    savedStrategies.filter((s)=>s.type === 'granny_flat').length,
                                                                                    " saved"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                onClick: ()=>setActivePage('GrannyFlatPage'),
                                                                className: "text-blue-600 hover:text-blue-800 text-sm font-semibold hover:underline transition-all",
                                                                children: "View All \u2192"
                                                            })
                                                        ]
                                                    }),
                                                    savedStrategies.filter((s)=>s.type === 'granny_flat').length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "space-y-3",
                                                        children: savedStrategies.filter((s)=>s.type === 'granny_flat').map((strategy)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex items-center justify-between p-4 bg-slate-50 rounded-xl border border-slate-200 hover:border-blue-300 hover:shadow-lg cursor-pointer transition-all duration-300 group",
                                                                onClick: ()=>setActivePage('GrannyFlatPage'),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "flex-1",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "font-semibold text-gray-900 group-hover:text-blue-600 transition-colors",
                                                                                children: [
                                                                                    $91e8bd92d2abf1ed$var$shownPlanName(strategy),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($91e8bd92d2abf1ed$var$PlanSourceBadge, {
                                                                                        source: strategy.source
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            strategy.chosen && moduleOutOfDate('granny_flat') ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "mt-1 text-xs text-slate-700",
                                                                                "data-testid": "granny_flat-card-out-of-date",
                                                                                children: [
                                                                                    moduleOutOfDate('granny_flat'),
                                                                                    " \xb7 chosen ",
                                                                                    $91e8bd92d2abf1ed$var$dateWords(strategy.createdAt)
                                                                                ]
                                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "text-xs text-gray-500 mt-1",
                                                                                children: [
                                                                                    (()=>{
                                                                                        const lever = (0, $8a1c93567d70a6d1$export$8fe97d85839733d)(strategy, 'granny_flat');
                                                                                        return lever ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                                    className: "font-semibold text-slate-700",
                                                                                                    children: lever
                                                                                                }),
                                                                                                " \xb7 "
                                                                                            ]
                                                                                        }) : null;
                                                                                    })(),
                                                                                    (()=>{
                                                                                        const line = $91e8bd92d2abf1ed$var$savedPlanFiguresLine(strategy);
                                                                                        return line ? `${line} \xb7 ` : '';
                                                                                    })(),
                                                                                    $91e8bd92d2abf1ed$var$dateWords(strategy.createdAt)
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "text-right text-xs space-y-1 ml-4",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "text-blue-600 font-semibold mt-2 group-hover:underline",
                                                                            children: "Open Granny Flat \u2192"
                                                                        })
                                                                    })
                                                                ]
                                                            }, strategy.id))
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "p-6 text-center bg-slate-50 rounded-xl border-2 border-dashed border-gray-300",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bee7e1f6335e67ab$export$2e2bcd8739ae039), {
                                                                className: "mx-auto text-gray-300 mb-3",
                                                                size: 32
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-gray-500 text-sm font-medium",
                                                                children: "No granny flat strategies saved yet."
                                                            })
                                                        ]
                                                    }),
                                                    factFind?.grannyFlat?.familyGuide?.brief?.generatedAt && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mt-3 flex items-center justify-between gap-3 p-4 bg-slate-50 rounded-xl border border-slate-200",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex items-start gap-3 min-w-0",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                                                        size: 18,
                                                                        className: "mt-0.5 shrink-0 text-blue-600"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "min-w-0",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                className: "font-semibold text-gray-900",
                                                                                children: "Family discussion guide \u2014 solicitor brief"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "text-xs text-gray-500 mt-1",
                                                                                children: [
                                                                                    "Produced ",
                                                                                    new Date(factFind.grannyFlat.familyGuide.brief.generatedAt).toLocaleDateString('en-AU', {
                                                                                        day: 'numeric',
                                                                                        month: 'short',
                                                                                        year: 'numeric'
                                                                                    }),
                                                                                    " from the family's answers, which are kept with this file."
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex shrink-0 items-center gap-3 text-xs font-semibold",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        onClick: ()=>(0, $32bd8c8afa665e9e$export$e1d1ed890ff44b99)(setActivePage, 'guide'),
                                                                        className: "text-slate-600 hover:text-blue-700 hover:underline",
                                                                        children: "Open the guide"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        type: "button",
                                                                        onClick: ()=>{
                                                                            const guide = factFind.grannyFlat?.familyGuide || {};
                                                                            const b = guide.brief || {};
                                                                            (0, $82f6c9c0d5566ac3$export$92b81748c7df1848)({
                                                                                clientName: factFind.client?.firstName || 'you',
                                                                                partnerName: factFind.adviceFor === 'couple' ? factFind.partner?.firstName || null : null,
                                                                                answers: guide,
                                                                                figures: b.entryContribution != null ? {
                                                                                    entryContribution: Number(b.entryContribution) || 0,
                                                                                    interestValue: Number(b.interestValue) || 0,
                                                                                    deprivation: Number(b.deprivation) || 0,
                                                                                    isHomeowner: !!b.isHomeowner,
                                                                                    dateEntered: b.dateEntered || ''
                                                                                } : null,
                                                                                generatedAt: b.generatedAt || new Date().toISOString()
                                                                            });
                                                                        },
                                                                        className: "rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-slate-700 hover:border-blue-300 hover:text-blue-800",
                                                                        children: "Print it again"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-8",
                        children: [
                            !chosenAgedCarePlan && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91cd8ed21bb5644f$export$9d0feb8d41aa92e0), {
                                setActivePage: setActivePage,
                                goals: goals
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $669dd463c00729a7$export$2e2bcd8739ae039), {
                                factFind: factFind,
                                setActivePage: setActivePage,
                                savedStrategies: savedStrategies,
                                receivesPension: socialSecurity > 0,
                                currentPension: socialSecurity
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                                className: "bg-white/70",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91cd8ed21bb5644f$export$8adb256d999cd5a0), {
                                        title: "Helpful Services",
                                        showArrow: false
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-6 p-4 bg-white rounded-xl border border-gray-100 hover:shadow-md transition-shadow",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d735a46f6c8532a3$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            hasNothingSaved && showAllSections && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    type: "button",
                    onClick: ()=>setShowAllSections(false),
                    className: "inline-flex items-center gap-1.5 text-sm font-semibold text-slate-600 hover:text-slate-900 hover:underline",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                            size: 15
                        }),
                        " Show less"
                    ]
                })
            })
        ]
    });
}


/**
 * AssumptionsPage – displays system rates, thresholds, and assumptions used in projections.
 * Single source for aged care, social security, tax, and asset/market assumptions.
 */ 

var $acw62 = parcelRequire("acw62");




const $1ff70e3ad4640938$var$AssumptionsPage = ({ setActivePage: setActivePage })=>{
    const [modellingSectionOpen, setModellingSectionOpen] = (0, $acw62.useState)(false);
    // Read once per render off the wall clock — the question is whether the figures are current NOW,
    // at the moment advice is being given, not on any date inside the projection.
    const ratesReview = (0, $d92bca4a6da5b591$export$83e0daeeac89884f)();
    const assumptionSections = (0, $13910bc1e93fb74e$export$8d1b1c5d08b3c488)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-4xl mx-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                onClick: ()=>setActivePage('Dashboard'),
                className: "flex items-center gap-2 text-gray-600 hover:text-gray-900 font-medium mb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                        size: 20
                    }),
                    " Back to Dashboard"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "text-4xl font-bold text-gray-900 mb-2",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6288781efbc92679$export$2e2bcd8739ae039), {
                    children: "System Assumptions"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-lg text-gray-600 mb-8",
                children: "This page outlines the key financial rates, thresholds, and assumptions used in the calculator's projections. Year 1 uses today's legislated rates and thresholds. Future years are projections and rely on assumptions about inflation and indexation. Actual government indexation and policy changes (and market returns) may be different, which can change your results."
            }),
            ratesReview.overdue && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                role: "status",
                className: "mb-8 rounded-lg border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm font-semibold text-slate-900",
                        children: "Rates may be out of date"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-1 text-sm text-slate-600",
                        children: ratesReview.notice
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>setModellingSectionOpen((o)=>!o),
                                className: "flex w-full items-center justify-between gap-3 text-left rounded-lg -mx-1 px-1 py-0.5 hover:bg-slate-50/90 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2",
                                "aria-expanded": modellingSectionOpen,
                                "aria-controls": "assumptions-modelling-section",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        id: "assumptions-modelling-heading",
                                        className: "text-xl font-bold text-gray-800",
                                        children: "How financial modelling works in this tool"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                        className: `shrink-0 text-gray-500 transition-transform duration-200 ${modellingSectionOpen ? 'rotate-180' : ''}`,
                                        size: 22,
                                        "aria-hidden": true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                id: "assumptions-modelling-section",
                                role: "region",
                                "aria-labelledby": "assumptions-modelling-heading",
                                "aria-hidden": !modellingSectionOpen,
                                className: modellingSectionOpen ? 'mt-4' : 'hidden',
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-sm text-gray-700 leading-relaxed space-y-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            children: [
                                                "Multi-year projections use ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Australian financial year"
                                                }),
                                                " periods from a ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "projection start"
                                                }),
                                                ". That start is the ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "first day of the current calendar month"
                                                }),
                                                " (local time). Table rows follow ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "financial years"
                                                }),
                                                ' ',
                                                "(the first row may run from that start through ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "30 June"
                                                }),
                                                "; later rows are ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "full"
                                                }),
                                                " financial years)."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Comparison Yr1"
                                                }),
                                                " is the label we use for the ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "primary strategy comparison year"
                                                }),
                                                ". For that comparison, the tool shows figures ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "as they would look over a full financial year"
                                                }),
                                                "\u2014",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "as if"
                                                }),
                                                " your chosen",
                                                ' ',
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "living arrangement"
                                                }),
                                                " and ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "funding approach"
                                                }),
                                                " were already in place from ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "1 July"
                                                }),
                                                " through ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "30 June"
                                                }),
                                                ". That gives a ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "clearer, like-for-like"
                                                }),
                                                " view of what a normal year could look like ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "after"
                                                }),
                                                " those decisions and the funding model are applied, even when you model a change part-way through the year."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            children: [
                                                "Where the app offers it, an ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "optional full financial year"
                                                }),
                                                " row gives a ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "separate estimate"
                                                }),
                                                " that ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "weights together pre-strategy and post-strategy assumptions"
                                                }),
                                                " across the ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "same"
                                                }),
                                                " financial year (for example when strategy costs or pension treatment change mid-year). Use it to understand ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "timing"
                                                }),
                                                ' between "before" and "after"; it is still an ',
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "estimate"
                                                }),
                                                ", not a statutory financial-year total."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            children: [
                                                "Unless noted elsewhere, the ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "first projection period"
                                                }),
                                                " for rates on this page uses ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "current"
                                                }),
                                                " pension settings, thresholds, and tax settings.",
                                                ' ',
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Later years"
                                                }),
                                                " assume ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "indexation"
                                                }),
                                                " (for example pension and tax thresholds rising at the projection inflation rate below). ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Tax rates"
                                                }),
                                                " are generally held at today's legislative settings unless modelled otherwise."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-gray-800 font-medium",
                                            children: [
                                                "All results are ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "illustrative"
                                                }),
                                                " for strategic discussion."
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    assumptionSections.map((section)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "text-xl font-bold text-gray-800 mb-4",
                                    children: section.title
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3",
                                    children: section.items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex justify-between text-sm py-2 border-b border-slate-200",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "text-gray-600 flex items-center",
                                                    children: [
                                                        item.label,
                                                        " ",
                                                        item.details && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                            text: item.details
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "text-right",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "font-semibold text-gray-800",
                                                            children: item.value
                                                        }),
                                                        item.note && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-xs text-gray-500",
                                                            children: item.note
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, item.label))
                                })
                            ]
                        }, section.title))
                ]
            })
        ]
    });
};
var $1ff70e3ad4640938$export$2e2bcd8739ae039 = $1ff70e3ad4640938$var$AssumptionsPage;


/**
 * PlaceholderPage – on-brand "coming soon" for sections not yet implemented.
 * Used by renderPageContent in App.js for unknown activePage values (e.g. Reports, Partners).
 */ 
parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7b20c5205e441d74$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m12 19-7-7 7-7",
            key: "1l729n"
        }
    ],
    [
        "path",
        {
            d: "M19 12H5",
            key: "x3x0zl"
        }
    ]
];
const $7b20c5205e441d74$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("arrow-left", $7b20c5205e441d74$export$3efd853dbb351e94);



const $2e228dc2671f7e61$var$PlaceholderPage = ({ title: title, setActivePage: setActivePage })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-col items-center justify-center min-h-[60vh]",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-center max-w-md p-10 bg-white/80 backdrop-blur-xl rounded-2xl shadow-lg shadow-slate-200/60 border border-slate-200/70",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex justify-center mb-5",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                        icon: (0, $200392fae49ddb7e$export$2e2bcd8739ae039),
                        tone: "brand",
                        variant: "solid",
                        size: "lg"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "text-3xl font-bold text-gray-900 mb-2",
                    children: title
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-slate-500 mb-8",
                    children: "This area is coming soon \u2014 we're building it now."
                }),
                setActivePage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                    variant: "secondary",
                    icon: (0, $7b20c5205e441d74$export$2e2bcd8739ae039),
                    onClick: ()=>setActivePage('Dashboard'),
                    children: "Back to Dashboard"
                })
            ]
        })
    });
var $2e228dc2671f7e61$export$2e2bcd8739ae039 = $2e228dc2671f7e61$var$PlaceholderPage;


/**
 * Platform owner/super-admin console calls (Task #25). Every request carries the signed-in
 * platform admin's token; the server re-checks platform-admin + aal2 on each one (in the shared
 * requireAdmin gate — see server/src/rest/tenants/admin.ts), and the database enforces suspension.
 * The browser is never trusted to decide admin rights.
 */ 


function $0aae0b39fc034917$export$4d28219d42798a75() {
    // One source for this — see services/apiBase.ts for why eight copies was a problem.
    return (0, $4e54353814e6aea9$export$8ebae31efd30e025)();
}
async function $0aae0b39fc034917$var$authHeaders() {
    const token = await (0, $cc9e8a24185b91b0$export$84773cc9bf7dbe87)();
    if (!token) throw new Error('Not signed in');
    return {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
}
function $0aae0b39fc034917$export$bab87a1130a0d7b8(err, fallback) {
    const axiosErr = err;
    const code = axiosErr?.response?.data?.error?.code;
    if (code === 'MFA_REQUIRED') /*
     * Two different situations, one message, because the browser cannot tell them apart from a 403:
     * they have no authenticator yet, or they have one and this session was only ever a password (a
     * password reset ends up here, deliberately). Both are fixed from the same two places, and there
     * is no mid-session step-up screen yet — so the honest instruction is to sign in again.
     */ return "The admin console needs a code from your authenticator. If you haven't set one up yet, do that under Account; otherwise sign out and back in, and enter a code.";
    const serverMsg = axiosErr?.response?.data?.error?.message;
    if (serverMsg) return serverMsg;
    if (err?.message === 'Not signed in') return "Your session has expired \u2014 please sign in again.";
    if (!axiosErr?.response) return "We couldn't reach the server. Check your connection and try again.";
    return fallback;
}
async function $0aae0b39fc034917$export$de308d3ddda5dcbc() {
    return (await $0aae0b39fc034917$export$50b438d8bcaa9dbd()).isAdmin;
}
async function $0aae0b39fc034917$export$50b438d8bcaa9dbd() {
    for(let attempt = 0; attempt < 2; attempt += 1)try {
        const headers = await $0aae0b39fc034917$var$authHeaders();
        const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${$0aae0b39fc034917$export$4d28219d42798a75()}/rest/admin/whoami`, {
            headers: headers,
            timeout: 30000
        });
        return {
            isAdmin: Boolean(res.data?.isAdmin),
            canReviewAdvice: Boolean(res.data?.canReviewAdvice)
        };
    } catch  {
        // Only the first failure is worth waiting on; the second is an answer.
        if (attempt === 0) await new Promise((resolve)=>setTimeout(resolve, 1500));
    }
    return {
        isAdmin: false,
        canReviewAdvice: false
    };
}
async function $0aae0b39fc034917$export$75494d979f4a3d6c() {
    const headers = await $0aae0b39fc034917$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${$0aae0b39fc034917$export$4d28219d42798a75()}/rest/admin/usage`, {
        headers: headers,
        timeout: 30000
    });
    return res.data.usage;
}
async function $0aae0b39fc034917$export$beb13e603a77f43b() {
    const headers = await $0aae0b39fc034917$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${$0aae0b39fc034917$export$4d28219d42798a75()}/rest/admin/insights`, {
        headers: headers,
        timeout: 30000
    });
    return res.data.insights;
}
async function $0aae0b39fc034917$export$e66931258b72f27a() {
    const headers = await $0aae0b39fc034917$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${$0aae0b39fc034917$export$4d28219d42798a75()}/rest/compliance/advice`, {
        headers: headers,
        timeout: 30000
    });
    return res.data?.records ?? [];
}
async function $0aae0b39fc034917$export$b0af5bc150562a8c(soaId, reason) {
    const headers = await $0aae0b39fc034917$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$0aae0b39fc034917$export$4d28219d42798a75()}/rest/compliance/advice/${soaId}/open`, {
        reason: reason
    }, {
        headers: headers,
        timeout: 30000
    });
    return res.data.record;
}
async function $0aae0b39fc034917$export$841aa9cdb59544d0() {
    const headers = await $0aae0b39fc034917$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${$0aae0b39fc034917$export$4d28219d42798a75()}/rest/admin/tenants`, {
        headers: headers,
        timeout: 30000
    });
    return res.data?.tenants || [];
}
async function $0aae0b39fc034917$export$a5c81fd34ec479(tenantId, status) {
    const headers = await $0aae0b39fc034917$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$0aae0b39fc034917$export$4d28219d42798a75()}/rest/admin/tenants/${tenantId}/status`, {
        status: status
    }, {
        headers: headers,
        timeout: 30000
    });
    return res.data;
}
async function $0aae0b39fc034917$export$46623589dd9298dc(tenantId) {
    const headers = await $0aae0b39fc034917$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$0aae0b39fc034917$export$4d28219d42798a75()}/rest/admin/tenants/${tenantId}/free-access`, {}, {
        headers: headers,
        timeout: 30000
    });
    return res.data;
}
async function $0aae0b39fc034917$export$bc0bf79c02123600(tenantId) {
    const headers = await $0aae0b39fc034917$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).delete(`${$0aae0b39fc034917$export$4d28219d42798a75()}/rest/admin/tenants/${tenantId}/free-access`, {
        headers: headers,
        timeout: 30000
    });
    return res.data;
}
async function $0aae0b39fc034917$export$1dcb38cea112e29a(email) {
    const headers = await $0aae0b39fc034917$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$0aae0b39fc034917$export$4d28219d42798a75()}/rest/admin/free-access/by-email`, {
        email: email
    }, {
        headers: headers,
        timeout: 30000
    });
    return res.data;
}
async function $0aae0b39fc034917$export$d9829425852634cb() {
    const headers = await $0aae0b39fc034917$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${$0aae0b39fc034917$export$4d28219d42798a75()}/rest/admin/free-access/emails`, {
        headers: headers,
        timeout: 30000
    });
    return res.data?.emails || [];
}
async function $0aae0b39fc034917$export$11e63ebb02ab53d9(email) {
    const headers = await $0aae0b39fc034917$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).delete(`${$0aae0b39fc034917$export$4d28219d42798a75()}/rest/admin/free-access/by-email`, {
        headers: headers,
        data: {
            email: email
        },
        timeout: 30000
    });
    return res.data;
}
async function $0aae0b39fc034917$export$3577149374211382(includeDismissed = false) {
    const headers = await $0aae0b39fc034917$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${$0aae0b39fc034917$export$4d28219d42798a75()}/rest/admin/regulatory-prompts`, {
        headers: headers,
        params: {
            includeDismissed: includeDismissed
        },
        timeout: 30000
    });
    return {
        prompts: res.data?.prompts ?? [],
        lastRun: res.data?.lastRun ?? null
    };
}
async function $0aae0b39fc034917$export$d39fbc51d3c94dc2(id, status) {
    const headers = await $0aae0b39fc034917$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$0aae0b39fc034917$export$4d28219d42798a75()}/rest/admin/regulatory-prompts/${id}/status`, {
        status: status
    }, {
        headers: headers,
        timeout: 30000
    });
    return res.data;
}
async function $0aae0b39fc034917$export$3d161c819b962710() {
    const headers = await $0aae0b39fc034917$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$0aae0b39fc034917$export$4d28219d42798a75()}/rest/admin/regulatory-prompts/run`, {}, {
        headers: headers,
        timeout: 120000
    });
    return res.data;
}
async function $0aae0b39fc034917$export$2f21c3786b41ab81() {
    const headers = await $0aae0b39fc034917$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${$0aae0b39fc034917$export$4d28219d42798a75()}/rest/admin/openapi.json`, {
        headers: headers,
        timeout: 30000
    });
    return res.data;
}


/**
 * "Become a partner" — the Xero-style guided onboarding (owner spec, 3 Jul 2026).
 * Steps: about you → licensing (adviser = own AFSL; accountant = operates under AgedCareWise's
 * arrangements) → create login (+ email-confirm resume via a localStorage draft) → trial/payment
 * note → create firm (pending Jon's approval) → portal.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $09365e579c2377bf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ],
    [
        "line",
        {
            x1: "19",
            x2: "19",
            y1: "8",
            y2: "14",
            key: "1bvyxn"
        }
    ],
    [
        "line",
        {
            x1: "22",
            x2: "16",
            y1: "11",
            y2: "11",
            key: "1shjgl"
        }
    ]
];
const $09365e579c2377bf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("user-plus", $09365e579c2377bf$export$3efd853dbb351e94);





var $acw62 = parcelRequire("acw62");
//---------------------------------------------------------------------
//
// QR Code Generator for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//  http://www.opensource.org/licenses/mit-license.php
//
// The word 'QR Code' is registered trademark of
// DENSO WAVE INCORPORATED
//  http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
//---------------------------------------------------------------------
// qrcode
//---------------------------------------------------------------------
/**
 * qrcode
 * @param typeNumber 1 to 40
 * @param errorCorrectionLevel 'L','M','Q','H'
 */ const $4904b51f6c00d59a$export$5f3279733515fed0 = function(typeNumber, errorCorrectionLevel) {
    const PAD0 = 0xEC;
    const PAD1 = 0x11;
    let _typeNumber = typeNumber;
    const _errorCorrectionLevel = $4904b51f6c00d59a$var$QRErrorCorrectionLevel[errorCorrectionLevel];
    let _modules = null;
    let _moduleCount = 0;
    let _dataCache = null;
    const _dataList = [];
    const _this = {};
    const makeImpl = function(test, maskPattern) {
        _moduleCount = _typeNumber * 4 + 17;
        _modules = function(moduleCount) {
            const modules = new Array(moduleCount);
            for(let row = 0; row < moduleCount; row += 1){
                modules[row] = new Array(moduleCount);
                for(let col = 0; col < moduleCount; col += 1)modules[row][col] = null;
            }
            return modules;
        }(_moduleCount);
        setupPositionProbePattern(0, 0);
        setupPositionProbePattern(_moduleCount - 7, 0);
        setupPositionProbePattern(0, _moduleCount - 7);
        setupPositionAdjustPattern();
        setupTimingPattern();
        setupTypeInfo(test, maskPattern);
        if (_typeNumber >= 7) setupTypeNumber(test);
        if (_dataCache == null) _dataCache = createData(_typeNumber, _errorCorrectionLevel, _dataList);
        mapData(_dataCache, maskPattern);
    };
    const setupPositionProbePattern = function(row, col) {
        for(let r = -1; r <= 7; r += 1){
            if (row + r <= -1 || _moduleCount <= row + r) continue;
            for(let c = -1; c <= 7; c += 1){
                if (col + c <= -1 || _moduleCount <= col + c) continue;
                if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) _modules[row + r][col + c] = true;
                else _modules[row + r][col + c] = false;
            }
        }
    };
    const getBestMaskPattern = function() {
        let minLostPoint = 0;
        let pattern = 0;
        for(let i = 0; i < 8; i += 1){
            makeImpl(true, i);
            const lostPoint = $4904b51f6c00d59a$var$QRUtil.getLostPoint(_this);
            if (i == 0 || minLostPoint > lostPoint) {
                minLostPoint = lostPoint;
                pattern = i;
            }
        }
        return pattern;
    };
    const setupTimingPattern = function() {
        for(let r = 8; r < _moduleCount - 8; r += 1){
            if (_modules[r][6] != null) continue;
            _modules[r][6] = r % 2 == 0;
        }
        for(let c = 8; c < _moduleCount - 8; c += 1){
            if (_modules[6][c] != null) continue;
            _modules[6][c] = c % 2 == 0;
        }
    };
    const setupPositionAdjustPattern = function() {
        const pos = $4904b51f6c00d59a$var$QRUtil.getPatternPosition(_typeNumber);
        for(let i = 0; i < pos.length; i += 1)for(let j = 0; j < pos.length; j += 1){
            const row = pos[i];
            const col = pos[j];
            if (_modules[row][col] != null) continue;
            for(let r = -2; r <= 2; r += 1){
                for(let c = -2; c <= 2; c += 1)if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) _modules[row + r][col + c] = true;
                else _modules[row + r][col + c] = false;
            }
        }
    };
    const setupTypeNumber = function(test) {
        const bits = $4904b51f6c00d59a$var$QRUtil.getBCHTypeNumber(_typeNumber);
        for(let i = 0; i < 18; i += 1){
            const mod = !test && (bits >> i & 1) == 1;
            _modules[Math.floor(i / 3)][i % 3 + _moduleCount - 8 - 3] = mod;
        }
        for(let i = 0; i < 18; i += 1){
            const mod = !test && (bits >> i & 1) == 1;
            _modules[i % 3 + _moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
        }
    };
    const setupTypeInfo = function(test, maskPattern) {
        const data = _errorCorrectionLevel << 3 | maskPattern;
        const bits = $4904b51f6c00d59a$var$QRUtil.getBCHTypeInfo(data);
        // vertical
        for(let i = 0; i < 15; i += 1){
            const mod = !test && (bits >> i & 1) == 1;
            if (i < 6) _modules[i][8] = mod;
            else if (i < 8) _modules[i + 1][8] = mod;
            else _modules[_moduleCount - 15 + i][8] = mod;
        }
        // horizontal
        for(let i = 0; i < 15; i += 1){
            const mod = !test && (bits >> i & 1) == 1;
            if (i < 8) _modules[8][_moduleCount - i - 1] = mod;
            else if (i < 9) _modules[8][15 - i - 1 + 1] = mod;
            else _modules[8][15 - i - 1] = mod;
        }
        // fixed module
        _modules[_moduleCount - 8][8] = !test;
    };
    const mapData = function(data, maskPattern) {
        let inc = -1;
        let row = _moduleCount - 1;
        let bitIndex = 7;
        let byteIndex = 0;
        const maskFunc = $4904b51f6c00d59a$var$QRUtil.getMaskFunction(maskPattern);
        for(let col = _moduleCount - 1; col > 0; col -= 2){
            if (col == 6) col -= 1;
            while(true){
                for(let c = 0; c < 2; c += 1)if (_modules[row][col - c] == null) {
                    let dark = false;
                    if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) == 1;
                    const mask = maskFunc(row, col - c);
                    if (mask) dark = !dark;
                    _modules[row][col - c] = dark;
                    bitIndex -= 1;
                    if (bitIndex == -1) {
                        byteIndex += 1;
                        bitIndex = 7;
                    }
                }
                row += inc;
                if (row < 0 || _moduleCount <= row) {
                    row -= inc;
                    inc = -inc;
                    break;
                }
            }
        }
    };
    const createBytes = function(buffer, rsBlocks) {
        let offset = 0;
        let maxDcCount = 0;
        let maxEcCount = 0;
        const dcdata = new Array(rsBlocks.length);
        const ecdata = new Array(rsBlocks.length);
        for(let r = 0; r < rsBlocks.length; r += 1){
            const dcCount = rsBlocks[r].dataCount;
            const ecCount = rsBlocks[r].totalCount - dcCount;
            maxDcCount = Math.max(maxDcCount, dcCount);
            maxEcCount = Math.max(maxEcCount, ecCount);
            dcdata[r] = new Array(dcCount);
            for(let i = 0; i < dcdata[r].length; i += 1)dcdata[r][i] = 0xff & buffer.getBuffer()[i + offset];
            offset += dcCount;
            const rsPoly = $4904b51f6c00d59a$var$QRUtil.getErrorCorrectPolynomial(ecCount);
            const rawPoly = $4904b51f6c00d59a$var$qrPolynomial(dcdata[r], rsPoly.getLength() - 1);
            const modPoly = rawPoly.mod(rsPoly);
            ecdata[r] = new Array(rsPoly.getLength() - 1);
            for(let i = 0; i < ecdata[r].length; i += 1){
                const modIndex = i + modPoly.getLength() - ecdata[r].length;
                ecdata[r][i] = modIndex >= 0 ? modPoly.getAt(modIndex) : 0;
            }
        }
        let totalCodeCount = 0;
        for(let i = 0; i < rsBlocks.length; i += 1)totalCodeCount += rsBlocks[i].totalCount;
        const data = new Array(totalCodeCount);
        let index = 0;
        for(let i = 0; i < maxDcCount; i += 1){
            for(let r = 0; r < rsBlocks.length; r += 1)if (i < dcdata[r].length) {
                data[index] = dcdata[r][i];
                index += 1;
            }
        }
        for(let i = 0; i < maxEcCount; i += 1){
            for(let r = 0; r < rsBlocks.length; r += 1)if (i < ecdata[r].length) {
                data[index] = ecdata[r][i];
                index += 1;
            }
        }
        return data;
    };
    const createData = function(typeNumber, errorCorrectionLevel, dataList) {
        const rsBlocks = $4904b51f6c00d59a$var$QRRSBlock.getRSBlocks(typeNumber, errorCorrectionLevel);
        const buffer = $4904b51f6c00d59a$var$qrBitBuffer();
        for(let i = 0; i < dataList.length; i += 1){
            const data = dataList[i];
            buffer.put(data.getMode(), 4);
            buffer.put(data.getLength(), $4904b51f6c00d59a$var$QRUtil.getLengthInBits(data.getMode(), typeNumber));
            data.write(buffer);
        }
        // calc num max data.
        let totalDataCount = 0;
        for(let i = 0; i < rsBlocks.length; i += 1)totalDataCount += rsBlocks[i].dataCount;
        if (buffer.getLengthInBits() > totalDataCount * 8) throw 'code length overflow. (' + buffer.getLengthInBits() + '>' + totalDataCount * 8 + ')';
        // end code
        if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) buffer.put(0, 4);
        // padding
        while(buffer.getLengthInBits() % 8 != 0)buffer.putBit(false);
        // padding
        while(true){
            if (buffer.getLengthInBits() >= totalDataCount * 8) break;
            buffer.put(PAD0, 8);
            if (buffer.getLengthInBits() >= totalDataCount * 8) break;
            buffer.put(PAD1, 8);
        }
        return createBytes(buffer, rsBlocks);
    };
    _this.addData = function(data, mode) {
        mode = mode || 'Byte';
        let newData = null;
        switch(mode){
            case 'Numeric':
                newData = $4904b51f6c00d59a$var$qrNumber(data);
                break;
            case 'Alphanumeric':
                newData = $4904b51f6c00d59a$var$qrAlphaNum(data);
                break;
            case 'Byte':
                newData = $4904b51f6c00d59a$var$qr8BitByte(data);
                break;
            case 'Kanji':
                newData = $4904b51f6c00d59a$var$qrKanji(data);
                break;
            default:
                throw 'mode:' + mode;
        }
        _dataList.push(newData);
        _dataCache = null;
    };
    _this.isDark = function(row, col) {
        if (row < 0 || _moduleCount <= row || col < 0 || _moduleCount <= col) throw row + ',' + col;
        return _modules[row][col];
    };
    _this.getModuleCount = function() {
        return _moduleCount;
    };
    _this.make = function() {
        if (_typeNumber < 1) {
            let typeNumber = 1;
            for(; typeNumber < 40; typeNumber++){
                const rsBlocks = $4904b51f6c00d59a$var$QRRSBlock.getRSBlocks(typeNumber, _errorCorrectionLevel);
                const buffer = $4904b51f6c00d59a$var$qrBitBuffer();
                for(let i = 0; i < _dataList.length; i++){
                    const data = _dataList[i];
                    buffer.put(data.getMode(), 4);
                    buffer.put(data.getLength(), $4904b51f6c00d59a$var$QRUtil.getLengthInBits(data.getMode(), typeNumber));
                    data.write(buffer);
                }
                let totalDataCount = 0;
                for(let i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
                if (buffer.getLengthInBits() <= totalDataCount * 8) break;
            }
            _typeNumber = typeNumber;
        }
        makeImpl(false, getBestMaskPattern());
    };
    _this.createTableTag = function(cellSize, margin) {
        cellSize = cellSize || 2;
        margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
        let qrHtml = '';
        qrHtml += '<table style="';
        qrHtml += ' border-width: 0px; border-style: none;';
        qrHtml += ' border-collapse: collapse;';
        qrHtml += ' padding: 0px; margin: ' + margin + 'px;';
        qrHtml += '">';
        qrHtml += '<tbody>';
        for(let r = 0; r < _this.getModuleCount(); r += 1){
            qrHtml += '<tr>';
            for(let c = 0; c < _this.getModuleCount(); c += 1){
                qrHtml += '<td style="';
                qrHtml += ' border-width: 0px; border-style: none;';
                qrHtml += ' border-collapse: collapse;';
                qrHtml += ' padding: 0px; margin: 0px;';
                qrHtml += ' width: ' + cellSize + 'px;';
                qrHtml += ' height: ' + cellSize + 'px;';
                qrHtml += ' background-color: ';
                qrHtml += _this.isDark(r, c) ? '#000000' : '#ffffff';
                qrHtml += ';';
                qrHtml += '"/>';
            }
            qrHtml += '</tr>';
        }
        qrHtml += '</tbody>';
        qrHtml += '</table>';
        return qrHtml;
    };
    _this.createSvgTag = function(cellSize, margin, alt, title) {
        let opts = {};
        if (typeof arguments[0] == 'object') {
            // Called by options.
            opts = arguments[0];
            // overwrite cellSize and margin.
            cellSize = opts.cellSize;
            margin = opts.margin;
            alt = opts.alt;
            title = opts.title;
        }
        cellSize = cellSize || 2;
        margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
        // Compose alt property surrogate
        alt = typeof alt === 'string' ? {
            text: alt
        } : alt || {};
        alt.text = alt.text || null;
        alt.id = alt.text ? alt.id || 'qrcode-description' : null;
        // Compose title property surrogate
        title = typeof title === 'string' ? {
            text: title
        } : title || {};
        title.text = title.text || null;
        title.id = title.text ? title.id || 'qrcode-title' : null;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        let c, mc, r, mr, qrSvg = '', rect;
        rect = 'l' + cellSize + ',0 0,' + cellSize + ' -' + cellSize + ',0 0,-' + cellSize + 'z ';
        qrSvg += '<svg version="1.1" xmlns="http://www.w3.org/2000/svg"';
        qrSvg += !opts.scalable ? ' width="' + size + 'px" height="' + size + 'px"' : '';
        qrSvg += ' viewBox="0 0 ' + size + ' ' + size + '" ';
        qrSvg += ' preserveAspectRatio="xMinYMin meet"';
        qrSvg += title.text || alt.text ? ' role="img" aria-labelledby="' + escapeXml([
            title.id,
            alt.id
        ].join(' ').trim()) + '"' : '';
        qrSvg += '>';
        qrSvg += title.text ? '<title id="' + escapeXml(title.id) + '">' + escapeXml(title.text) + '</title>' : '';
        qrSvg += alt.text ? '<description id="' + escapeXml(alt.id) + '">' + escapeXml(alt.text) + '</description>' : '';
        qrSvg += '<rect width="100%" height="100%" fill="white" cx="0" cy="0"/>';
        qrSvg += '<path d="';
        for(r = 0; r < _this.getModuleCount(); r += 1){
            mr = r * cellSize + margin;
            for(c = 0; c < _this.getModuleCount(); c += 1)if (_this.isDark(r, c)) {
                mc = c * cellSize + margin;
                qrSvg += 'M' + mc + ',' + mr + rect;
            }
        }
        qrSvg += '" stroke="transparent" fill="black"/>';
        qrSvg += '</svg>';
        return qrSvg;
    };
    _this.createDataURL = function(cellSize, margin) {
        cellSize = cellSize || 2;
        margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        const min = margin;
        const max = size - margin;
        return $4904b51f6c00d59a$var$createDataURL(size, size, function(x, y) {
            if (min <= x && x < max && min <= y && y < max) {
                const c = Math.floor((x - min) / cellSize);
                const r = Math.floor((y - min) / cellSize);
                return _this.isDark(r, c) ? 0 : 1;
            } else return 1;
        });
    };
    _this.createImgTag = function(cellSize, margin, alt) {
        cellSize = cellSize || 2;
        margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        let img = '';
        img += '<img';
        img += '\u0020src="';
        img += _this.createDataURL(cellSize, margin);
        img += '"';
        img += '\u0020width="';
        img += size;
        img += '"';
        img += '\u0020height="';
        img += size;
        img += '"';
        if (alt) {
            img += '\u0020alt="';
            img += escapeXml(alt);
            img += '"';
        }
        img += '/>';
        return img;
    };
    const escapeXml = function(s) {
        let escaped = '';
        for(let i = 0; i < s.length; i += 1){
            const c = s.charAt(i);
            switch(c){
                case '<':
                    escaped += '&lt;';
                    break;
                case '>':
                    escaped += '&gt;';
                    break;
                case '&':
                    escaped += '&amp;';
                    break;
                case '"':
                    escaped += '&quot;';
                    break;
                default:
                    escaped += c;
                    break;
            }
        }
        return escaped;
    };
    const _createHalfASCII = function(margin) {
        const cellSize = 1;
        margin = typeof margin == 'undefined' ? cellSize * 2 : margin;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        const min = margin;
        const max = size - margin;
        let y, x, r1, r2, p;
        const blocks = {
            "\u2588\u2588": "\u2588",
            "\u2588 ": "\u2580",
            " \u2588": "\u2584",
            '  ': ' '
        };
        const blocksLastLineNoMargin = {
            "\u2588\u2588": "\u2580",
            "\u2588 ": "\u2580",
            " \u2588": ' ',
            '  ': ' '
        };
        let ascii = '';
        for(y = 0; y < size; y += 2){
            r1 = Math.floor((y - min) / cellSize);
            r2 = Math.floor((y + 1 - min) / cellSize);
            for(x = 0; x < size; x += 1){
                p = "\u2588";
                if (min <= x && x < max && min <= y && y < max && _this.isDark(r1, Math.floor((x - min) / cellSize))) p = ' ';
                if (min <= x && x < max && min <= y + 1 && y + 1 < max && _this.isDark(r2, Math.floor((x - min) / cellSize))) p += ' ';
                else p += "\u2588";
                // Output 2 characters per pixel, to create full square. 1 character per pixels gives only half width of square.
                ascii += margin < 1 && y + 1 >= max ? blocksLastLineNoMargin[p] : blocks[p];
            }
            ascii += '\n';
        }
        if (size % 2 && margin > 0) return ascii.substring(0, ascii.length - size - 1) + Array(size + 1).join("\u2580");
        return ascii.substring(0, ascii.length - 1);
    };
    _this.createASCII = function(cellSize, margin) {
        cellSize = cellSize || 1;
        if (cellSize < 2) return _createHalfASCII(margin);
        cellSize -= 1;
        margin = typeof margin == 'undefined' ? cellSize * 2 : margin;
        const size = _this.getModuleCount() * cellSize + margin * 2;
        const min = margin;
        const max = size - margin;
        let y, x, r, p;
        const white = Array(cellSize + 1).join("\u2588\u2588");
        const black = Array(cellSize + 1).join('  ');
        let ascii = '';
        let line = '';
        for(y = 0; y < size; y += 1){
            r = Math.floor((y - min) / cellSize);
            line = '';
            for(x = 0; x < size; x += 1){
                p = 1;
                if (min <= x && x < max && min <= y && y < max && _this.isDark(r, Math.floor((x - min) / cellSize))) p = 0;
                // Output 2 characters per pixel, to create full square. 1 character per pixels gives only half width of square.
                line += p ? white : black;
            }
            for(r = 0; r < cellSize; r += 1)ascii += line + '\n';
        }
        return ascii.substring(0, ascii.length - 1);
    };
    _this.renderTo2dContext = function(context, cellSize) {
        cellSize = cellSize || 2;
        const length = _this.getModuleCount();
        for(let row = 0; row < length; row++)for(let col = 0; col < length; col++){
            context.fillStyle = _this.isDark(row, col) ? 'black' : 'white';
            context.fillRect(col * cellSize, row * cellSize, cellSize, cellSize);
        }
    };
    return _this;
};
//---------------------------------------------------------------------
// qrcode.stringToBytes
//---------------------------------------------------------------------
$4904b51f6c00d59a$export$5f3279733515fed0.stringToBytes = function(s) {
    const bytes = [];
    for(let i = 0; i < s.length; i += 1){
        const c = s.charCodeAt(i);
        bytes.push(c & 0xff);
    }
    return bytes;
};
//---------------------------------------------------------------------
// qrcode.createStringToBytes
//---------------------------------------------------------------------
/**
 * @param unicodeData base64 string of byte array.
 * [16bit Unicode],[16bit Bytes], ...
 * @param numChars
 */ $4904b51f6c00d59a$export$5f3279733515fed0.createStringToBytes = function(unicodeData, numChars) {
    // create conversion map.
    const unicodeMap = function() {
        const bin = $4904b51f6c00d59a$var$base64DecodeInputStream(unicodeData);
        const read = function() {
            const b = bin.read();
            if (b == -1) throw 'eof';
            return b;
        };
        let count = 0;
        const unicodeMap = {};
        while(true){
            const b0 = bin.read();
            if (b0 == -1) break;
            const b1 = read();
            const b2 = read();
            const b3 = read();
            const k = String.fromCharCode(b0 << 8 | b1);
            const v = b2 << 8 | b3;
            unicodeMap[k] = v;
            count += 1;
        }
        if (count != numChars) throw count + ' != ' + numChars;
        return unicodeMap;
    }();
    const unknownChar = '?'.charCodeAt(0);
    return function(s) {
        const bytes = [];
        for(let i = 0; i < s.length; i += 1){
            const c = s.charCodeAt(i);
            if (c < 128) bytes.push(c);
            else {
                const b = unicodeMap[s.charAt(i)];
                if (typeof b == 'number') {
                    if ((b & 0xff) == b) // 1byte
                    bytes.push(b);
                    else {
                        // 2bytes
                        bytes.push(b >>> 8);
                        bytes.push(b & 0xff);
                    }
                } else bytes.push(unknownChar);
            }
        }
        return bytes;
    };
};
//---------------------------------------------------------------------
// QRMode
//---------------------------------------------------------------------
const $4904b51f6c00d59a$var$QRMode = {
    MODE_NUMBER: 1,
    MODE_ALPHA_NUM: 2,
    MODE_8BIT_BYTE: 4,
    MODE_KANJI: 8
};
//---------------------------------------------------------------------
// QRErrorCorrectionLevel
//---------------------------------------------------------------------
const $4904b51f6c00d59a$var$QRErrorCorrectionLevel = {
    L: 1,
    M: 0,
    Q: 3,
    H: 2
};
//---------------------------------------------------------------------
// QRMaskPattern
//---------------------------------------------------------------------
const $4904b51f6c00d59a$var$QRMaskPattern = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
//---------------------------------------------------------------------
// QRUtil
//---------------------------------------------------------------------
const $4904b51f6c00d59a$var$QRUtil = function() {
    const PATTERN_POSITION_TABLE = [
        [],
        [
            6,
            18
        ],
        [
            6,
            22
        ],
        [
            6,
            26
        ],
        [
            6,
            30
        ],
        [
            6,
            34
        ],
        [
            6,
            22,
            38
        ],
        [
            6,
            24,
            42
        ],
        [
            6,
            26,
            46
        ],
        [
            6,
            28,
            50
        ],
        [
            6,
            30,
            54
        ],
        [
            6,
            32,
            58
        ],
        [
            6,
            34,
            62
        ],
        [
            6,
            26,
            46,
            66
        ],
        [
            6,
            26,
            48,
            70
        ],
        [
            6,
            26,
            50,
            74
        ],
        [
            6,
            30,
            54,
            78
        ],
        [
            6,
            30,
            56,
            82
        ],
        [
            6,
            30,
            58,
            86
        ],
        [
            6,
            34,
            62,
            90
        ],
        [
            6,
            28,
            50,
            72,
            94
        ],
        [
            6,
            26,
            50,
            74,
            98
        ],
        [
            6,
            30,
            54,
            78,
            102
        ],
        [
            6,
            28,
            54,
            80,
            106
        ],
        [
            6,
            32,
            58,
            84,
            110
        ],
        [
            6,
            30,
            58,
            86,
            114
        ],
        [
            6,
            34,
            62,
            90,
            118
        ],
        [
            6,
            26,
            50,
            74,
            98,
            122
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126
        ],
        [
            6,
            26,
            52,
            78,
            104,
            130
        ],
        [
            6,
            30,
            56,
            82,
            108,
            134
        ],
        [
            6,
            34,
            60,
            86,
            112,
            138
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142
        ],
        [
            6,
            34,
            62,
            90,
            118,
            146
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ],
        [
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ],
        [
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ],
        [
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ],
        [
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]
    ];
    const G15 = 1335;
    const G18 = 7973;
    const G15_MASK = 21522;
    const _this = {};
    const getBCHDigit = function(data) {
        let digit = 0;
        while(data != 0){
            digit += 1;
            data >>>= 1;
        }
        return digit;
    };
    _this.getBCHTypeInfo = function(data) {
        let d = data << 10;
        while(getBCHDigit(d) - getBCHDigit(G15) >= 0)d ^= G15 << getBCHDigit(d) - getBCHDigit(G15);
        return (data << 10 | d) ^ G15_MASK;
    };
    _this.getBCHTypeNumber = function(data) {
        let d = data << 12;
        while(getBCHDigit(d) - getBCHDigit(G18) >= 0)d ^= G18 << getBCHDigit(d) - getBCHDigit(G18);
        return data << 12 | d;
    };
    _this.getPatternPosition = function(typeNumber) {
        return PATTERN_POSITION_TABLE[typeNumber - 1];
    };
    _this.getMaskFunction = function(maskPattern) {
        switch(maskPattern){
            case $4904b51f6c00d59a$var$QRMaskPattern.PATTERN000:
                return function(i, j) {
                    return (i + j) % 2 == 0;
                };
            case $4904b51f6c00d59a$var$QRMaskPattern.PATTERN001:
                return function(i, j) {
                    return i % 2 == 0;
                };
            case $4904b51f6c00d59a$var$QRMaskPattern.PATTERN010:
                return function(i, j) {
                    return j % 3 == 0;
                };
            case $4904b51f6c00d59a$var$QRMaskPattern.PATTERN011:
                return function(i, j) {
                    return (i + j) % 3 == 0;
                };
            case $4904b51f6c00d59a$var$QRMaskPattern.PATTERN100:
                return function(i, j) {
                    return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
                };
            case $4904b51f6c00d59a$var$QRMaskPattern.PATTERN101:
                return function(i, j) {
                    return i * j % 2 + i * j % 3 == 0;
                };
            case $4904b51f6c00d59a$var$QRMaskPattern.PATTERN110:
                return function(i, j) {
                    return (i * j % 2 + i * j % 3) % 2 == 0;
                };
            case $4904b51f6c00d59a$var$QRMaskPattern.PATTERN111:
                return function(i, j) {
                    return (i * j % 3 + (i + j) % 2) % 2 == 0;
                };
            default:
                throw 'bad maskPattern:' + maskPattern;
        }
    };
    _this.getErrorCorrectPolynomial = function(errorCorrectLength) {
        let a = $4904b51f6c00d59a$var$qrPolynomial([
            1
        ], 0);
        for(let i = 0; i < errorCorrectLength; i += 1)a = a.multiply($4904b51f6c00d59a$var$qrPolynomial([
            1,
            $4904b51f6c00d59a$var$QRMath.gexp(i)
        ], 0));
        return a;
    };
    _this.getLengthInBits = function(mode, type) {
        if (1 <= type && type < 10) // 1 - 9
        switch(mode){
            case $4904b51f6c00d59a$var$QRMode.MODE_NUMBER:
                return 10;
            case $4904b51f6c00d59a$var$QRMode.MODE_ALPHA_NUM:
                return 9;
            case $4904b51f6c00d59a$var$QRMode.MODE_8BIT_BYTE:
                return 8;
            case $4904b51f6c00d59a$var$QRMode.MODE_KANJI:
                return 8;
            default:
                throw 'mode:' + mode;
        }
        else if (type < 27) // 10 - 26
        switch(mode){
            case $4904b51f6c00d59a$var$QRMode.MODE_NUMBER:
                return 12;
            case $4904b51f6c00d59a$var$QRMode.MODE_ALPHA_NUM:
                return 11;
            case $4904b51f6c00d59a$var$QRMode.MODE_8BIT_BYTE:
                return 16;
            case $4904b51f6c00d59a$var$QRMode.MODE_KANJI:
                return 10;
            default:
                throw 'mode:' + mode;
        }
        else if (type < 41) // 27 - 40
        switch(mode){
            case $4904b51f6c00d59a$var$QRMode.MODE_NUMBER:
                return 14;
            case $4904b51f6c00d59a$var$QRMode.MODE_ALPHA_NUM:
                return 13;
            case $4904b51f6c00d59a$var$QRMode.MODE_8BIT_BYTE:
                return 16;
            case $4904b51f6c00d59a$var$QRMode.MODE_KANJI:
                return 12;
            default:
                throw 'mode:' + mode;
        }
        else throw 'type:' + type;
    };
    _this.getLostPoint = function(qrcode) {
        const moduleCount = qrcode.getModuleCount();
        let lostPoint = 0;
        // LEVEL1
        for(let row = 0; row < moduleCount; row += 1)for(let col = 0; col < moduleCount; col += 1){
            let sameCount = 0;
            const dark = qrcode.isDark(row, col);
            for(let r = -1; r <= 1; r += 1){
                if (row + r < 0 || moduleCount <= row + r) continue;
                for(let c = -1; c <= 1; c += 1){
                    if (col + c < 0 || moduleCount <= col + c) continue;
                    if (r == 0 && c == 0) continue;
                    if (dark == qrcode.isDark(row + r, col + c)) sameCount += 1;
                }
            }
            if (sameCount > 5) lostPoint += 3 + sameCount - 5;
        }
        // LEVEL2
        for(let row = 0; row < moduleCount - 1; row += 1)for(let col = 0; col < moduleCount - 1; col += 1){
            let count = 0;
            if (qrcode.isDark(row, col)) count += 1;
            if (qrcode.isDark(row + 1, col)) count += 1;
            if (qrcode.isDark(row, col + 1)) count += 1;
            if (qrcode.isDark(row + 1, col + 1)) count += 1;
            if (count == 0 || count == 4) lostPoint += 3;
        }
        // LEVEL3
        for(let row = 0; row < moduleCount; row += 1){
            for(let col = 0; col < moduleCount - 6; col += 1)if (qrcode.isDark(row, col) && !qrcode.isDark(row, col + 1) && qrcode.isDark(row, col + 2) && qrcode.isDark(row, col + 3) && qrcode.isDark(row, col + 4) && !qrcode.isDark(row, col + 5) && qrcode.isDark(row, col + 6)) lostPoint += 40;
        }
        for(let col = 0; col < moduleCount; col += 1){
            for(let row = 0; row < moduleCount - 6; row += 1)if (qrcode.isDark(row, col) && !qrcode.isDark(row + 1, col) && qrcode.isDark(row + 2, col) && qrcode.isDark(row + 3, col) && qrcode.isDark(row + 4, col) && !qrcode.isDark(row + 5, col) && qrcode.isDark(row + 6, col)) lostPoint += 40;
        }
        // LEVEL4
        let darkCount = 0;
        for(let col = 0; col < moduleCount; col += 1){
            for(let row = 0; row < moduleCount; row += 1)if (qrcode.isDark(row, col)) darkCount += 1;
        }
        const ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
        lostPoint += ratio * 10;
        return lostPoint;
    };
    return _this;
}();
//---------------------------------------------------------------------
// QRMath
//---------------------------------------------------------------------
const $4904b51f6c00d59a$var$QRMath = function() {
    const EXP_TABLE = new Array(256);
    const LOG_TABLE = new Array(256);
    // initialize tables
    for(let i = 0; i < 8; i += 1)EXP_TABLE[i] = 1 << i;
    for(let i = 8; i < 256; i += 1)EXP_TABLE[i] = EXP_TABLE[i - 4] ^ EXP_TABLE[i - 5] ^ EXP_TABLE[i - 6] ^ EXP_TABLE[i - 8];
    for(let i = 0; i < 255; i += 1)LOG_TABLE[EXP_TABLE[i]] = i;
    const _this = {};
    _this.glog = function(n) {
        if (n < 1) throw 'glog(' + n + ')';
        return LOG_TABLE[n];
    };
    _this.gexp = function(n) {
        while(n < 0)n += 255;
        while(n >= 256)n -= 255;
        return EXP_TABLE[n];
    };
    return _this;
}();
//---------------------------------------------------------------------
// qrPolynomial
//---------------------------------------------------------------------
const $4904b51f6c00d59a$var$qrPolynomial = function(num, shift) {
    if (typeof num.length == 'undefined') throw num.length + '/' + shift;
    const _num = function() {
        let offset = 0;
        while(offset < num.length && num[offset] == 0)offset += 1;
        const _num = new Array(num.length - offset + shift);
        for(let i = 0; i < num.length - offset; i += 1)_num[i] = num[i + offset];
        return _num;
    }();
    const _this = {};
    _this.getAt = function(index) {
        return _num[index];
    };
    _this.getLength = function() {
        return _num.length;
    };
    _this.multiply = function(e) {
        const num = new Array(_this.getLength() + e.getLength() - 1);
        for(let i = 0; i < _this.getLength(); i += 1)for(let j = 0; j < e.getLength(); j += 1)num[i + j] ^= $4904b51f6c00d59a$var$QRMath.gexp($4904b51f6c00d59a$var$QRMath.glog(_this.getAt(i)) + $4904b51f6c00d59a$var$QRMath.glog(e.getAt(j)));
        return $4904b51f6c00d59a$var$qrPolynomial(num, 0);
    };
    _this.mod = function(e) {
        if (_this.getLength() - e.getLength() < 0) return _this;
        const ratio = $4904b51f6c00d59a$var$QRMath.glog(_this.getAt(0)) - $4904b51f6c00d59a$var$QRMath.glog(e.getAt(0));
        const num = new Array(_this.getLength());
        for(let i = 0; i < _this.getLength(); i += 1)num[i] = _this.getAt(i);
        for(let i = 0; i < e.getLength(); i += 1)num[i] ^= $4904b51f6c00d59a$var$QRMath.gexp($4904b51f6c00d59a$var$QRMath.glog(e.getAt(i)) + ratio);
        // recursive call
        return $4904b51f6c00d59a$var$qrPolynomial(num, 0).mod(e);
    };
    return _this;
};
//---------------------------------------------------------------------
// QRRSBlock
//---------------------------------------------------------------------
const $4904b51f6c00d59a$var$QRRSBlock = function() {
    const RS_BLOCK_TABLE = [
        // L
        // M
        // Q
        // H
        // 1
        [
            1,
            26,
            19
        ],
        [
            1,
            26,
            16
        ],
        [
            1,
            26,
            13
        ],
        [
            1,
            26,
            9
        ],
        // 2
        [
            1,
            44,
            34
        ],
        [
            1,
            44,
            28
        ],
        [
            1,
            44,
            22
        ],
        [
            1,
            44,
            16
        ],
        // 3
        [
            1,
            70,
            55
        ],
        [
            1,
            70,
            44
        ],
        [
            2,
            35,
            17
        ],
        [
            2,
            35,
            13
        ],
        // 4
        [
            1,
            100,
            80
        ],
        [
            2,
            50,
            32
        ],
        [
            2,
            50,
            24
        ],
        [
            4,
            25,
            9
        ],
        // 5
        [
            1,
            134,
            108
        ],
        [
            2,
            67,
            43
        ],
        [
            2,
            33,
            15,
            2,
            34,
            16
        ],
        [
            2,
            33,
            11,
            2,
            34,
            12
        ],
        // 6
        [
            2,
            86,
            68
        ],
        [
            4,
            43,
            27
        ],
        [
            4,
            43,
            19
        ],
        [
            4,
            43,
            15
        ],
        // 7
        [
            2,
            98,
            78
        ],
        [
            4,
            49,
            31
        ],
        [
            2,
            32,
            14,
            4,
            33,
            15
        ],
        [
            4,
            39,
            13,
            1,
            40,
            14
        ],
        // 8
        [
            2,
            121,
            97
        ],
        [
            2,
            60,
            38,
            2,
            61,
            39
        ],
        [
            4,
            40,
            18,
            2,
            41,
            19
        ],
        [
            4,
            40,
            14,
            2,
            41,
            15
        ],
        // 9
        [
            2,
            146,
            116
        ],
        [
            3,
            58,
            36,
            2,
            59,
            37
        ],
        [
            4,
            36,
            16,
            4,
            37,
            17
        ],
        [
            4,
            36,
            12,
            4,
            37,
            13
        ],
        // 10
        [
            2,
            86,
            68,
            2,
            87,
            69
        ],
        [
            4,
            69,
            43,
            1,
            70,
            44
        ],
        [
            6,
            43,
            19,
            2,
            44,
            20
        ],
        [
            6,
            43,
            15,
            2,
            44,
            16
        ],
        // 11
        [
            4,
            101,
            81
        ],
        [
            1,
            80,
            50,
            4,
            81,
            51
        ],
        [
            4,
            50,
            22,
            4,
            51,
            23
        ],
        [
            3,
            36,
            12,
            8,
            37,
            13
        ],
        // 12
        [
            2,
            116,
            92,
            2,
            117,
            93
        ],
        [
            6,
            58,
            36,
            2,
            59,
            37
        ],
        [
            4,
            46,
            20,
            6,
            47,
            21
        ],
        [
            7,
            42,
            14,
            4,
            43,
            15
        ],
        // 13
        [
            4,
            133,
            107
        ],
        [
            8,
            59,
            37,
            1,
            60,
            38
        ],
        [
            8,
            44,
            20,
            4,
            45,
            21
        ],
        [
            12,
            33,
            11,
            4,
            34,
            12
        ],
        // 14
        [
            3,
            145,
            115,
            1,
            146,
            116
        ],
        [
            4,
            64,
            40,
            5,
            65,
            41
        ],
        [
            11,
            36,
            16,
            5,
            37,
            17
        ],
        [
            11,
            36,
            12,
            5,
            37,
            13
        ],
        // 15
        [
            5,
            109,
            87,
            1,
            110,
            88
        ],
        [
            5,
            65,
            41,
            5,
            66,
            42
        ],
        [
            5,
            54,
            24,
            7,
            55,
            25
        ],
        [
            11,
            36,
            12,
            7,
            37,
            13
        ],
        // 16
        [
            5,
            122,
            98,
            1,
            123,
            99
        ],
        [
            7,
            73,
            45,
            3,
            74,
            46
        ],
        [
            15,
            43,
            19,
            2,
            44,
            20
        ],
        [
            3,
            45,
            15,
            13,
            46,
            16
        ],
        // 17
        [
            1,
            135,
            107,
            5,
            136,
            108
        ],
        [
            10,
            74,
            46,
            1,
            75,
            47
        ],
        [
            1,
            50,
            22,
            15,
            51,
            23
        ],
        [
            2,
            42,
            14,
            17,
            43,
            15
        ],
        // 18
        [
            5,
            150,
            120,
            1,
            151,
            121
        ],
        [
            9,
            69,
            43,
            4,
            70,
            44
        ],
        [
            17,
            50,
            22,
            1,
            51,
            23
        ],
        [
            2,
            42,
            14,
            19,
            43,
            15
        ],
        // 19
        [
            3,
            141,
            113,
            4,
            142,
            114
        ],
        [
            3,
            70,
            44,
            11,
            71,
            45
        ],
        [
            17,
            47,
            21,
            4,
            48,
            22
        ],
        [
            9,
            39,
            13,
            16,
            40,
            14
        ],
        // 20
        [
            3,
            135,
            107,
            5,
            136,
            108
        ],
        [
            3,
            67,
            41,
            13,
            68,
            42
        ],
        [
            15,
            54,
            24,
            5,
            55,
            25
        ],
        [
            15,
            43,
            15,
            10,
            44,
            16
        ],
        // 21
        [
            4,
            144,
            116,
            4,
            145,
            117
        ],
        [
            17,
            68,
            42
        ],
        [
            17,
            50,
            22,
            6,
            51,
            23
        ],
        [
            19,
            46,
            16,
            6,
            47,
            17
        ],
        // 22
        [
            2,
            139,
            111,
            7,
            140,
            112
        ],
        [
            17,
            74,
            46
        ],
        [
            7,
            54,
            24,
            16,
            55,
            25
        ],
        [
            34,
            37,
            13
        ],
        // 23
        [
            4,
            151,
            121,
            5,
            152,
            122
        ],
        [
            4,
            75,
            47,
            14,
            76,
            48
        ],
        [
            11,
            54,
            24,
            14,
            55,
            25
        ],
        [
            16,
            45,
            15,
            14,
            46,
            16
        ],
        // 24
        [
            6,
            147,
            117,
            4,
            148,
            118
        ],
        [
            6,
            73,
            45,
            14,
            74,
            46
        ],
        [
            11,
            54,
            24,
            16,
            55,
            25
        ],
        [
            30,
            46,
            16,
            2,
            47,
            17
        ],
        // 25
        [
            8,
            132,
            106,
            4,
            133,
            107
        ],
        [
            8,
            75,
            47,
            13,
            76,
            48
        ],
        [
            7,
            54,
            24,
            22,
            55,
            25
        ],
        [
            22,
            45,
            15,
            13,
            46,
            16
        ],
        // 26
        [
            10,
            142,
            114,
            2,
            143,
            115
        ],
        [
            19,
            74,
            46,
            4,
            75,
            47
        ],
        [
            28,
            50,
            22,
            6,
            51,
            23
        ],
        [
            33,
            46,
            16,
            4,
            47,
            17
        ],
        // 27
        [
            8,
            152,
            122,
            4,
            153,
            123
        ],
        [
            22,
            73,
            45,
            3,
            74,
            46
        ],
        [
            8,
            53,
            23,
            26,
            54,
            24
        ],
        [
            12,
            45,
            15,
            28,
            46,
            16
        ],
        // 28
        [
            3,
            147,
            117,
            10,
            148,
            118
        ],
        [
            3,
            73,
            45,
            23,
            74,
            46
        ],
        [
            4,
            54,
            24,
            31,
            55,
            25
        ],
        [
            11,
            45,
            15,
            31,
            46,
            16
        ],
        // 29
        [
            7,
            146,
            116,
            7,
            147,
            117
        ],
        [
            21,
            73,
            45,
            7,
            74,
            46
        ],
        [
            1,
            53,
            23,
            37,
            54,
            24
        ],
        [
            19,
            45,
            15,
            26,
            46,
            16
        ],
        // 30
        [
            5,
            145,
            115,
            10,
            146,
            116
        ],
        [
            19,
            75,
            47,
            10,
            76,
            48
        ],
        [
            15,
            54,
            24,
            25,
            55,
            25
        ],
        [
            23,
            45,
            15,
            25,
            46,
            16
        ],
        // 31
        [
            13,
            145,
            115,
            3,
            146,
            116
        ],
        [
            2,
            74,
            46,
            29,
            75,
            47
        ],
        [
            42,
            54,
            24,
            1,
            55,
            25
        ],
        [
            23,
            45,
            15,
            28,
            46,
            16
        ],
        // 32
        [
            17,
            145,
            115
        ],
        [
            10,
            74,
            46,
            23,
            75,
            47
        ],
        [
            10,
            54,
            24,
            35,
            55,
            25
        ],
        [
            19,
            45,
            15,
            35,
            46,
            16
        ],
        // 33
        [
            17,
            145,
            115,
            1,
            146,
            116
        ],
        [
            14,
            74,
            46,
            21,
            75,
            47
        ],
        [
            29,
            54,
            24,
            19,
            55,
            25
        ],
        [
            11,
            45,
            15,
            46,
            46,
            16
        ],
        // 34
        [
            13,
            145,
            115,
            6,
            146,
            116
        ],
        [
            14,
            74,
            46,
            23,
            75,
            47
        ],
        [
            44,
            54,
            24,
            7,
            55,
            25
        ],
        [
            59,
            46,
            16,
            1,
            47,
            17
        ],
        // 35
        [
            12,
            151,
            121,
            7,
            152,
            122
        ],
        [
            12,
            75,
            47,
            26,
            76,
            48
        ],
        [
            39,
            54,
            24,
            14,
            55,
            25
        ],
        [
            22,
            45,
            15,
            41,
            46,
            16
        ],
        // 36
        [
            6,
            151,
            121,
            14,
            152,
            122
        ],
        [
            6,
            75,
            47,
            34,
            76,
            48
        ],
        [
            46,
            54,
            24,
            10,
            55,
            25
        ],
        [
            2,
            45,
            15,
            64,
            46,
            16
        ],
        // 37
        [
            17,
            152,
            122,
            4,
            153,
            123
        ],
        [
            29,
            74,
            46,
            14,
            75,
            47
        ],
        [
            49,
            54,
            24,
            10,
            55,
            25
        ],
        [
            24,
            45,
            15,
            46,
            46,
            16
        ],
        // 38
        [
            4,
            152,
            122,
            18,
            153,
            123
        ],
        [
            13,
            74,
            46,
            32,
            75,
            47
        ],
        [
            48,
            54,
            24,
            14,
            55,
            25
        ],
        [
            42,
            45,
            15,
            32,
            46,
            16
        ],
        // 39
        [
            20,
            147,
            117,
            4,
            148,
            118
        ],
        [
            40,
            75,
            47,
            7,
            76,
            48
        ],
        [
            43,
            54,
            24,
            22,
            55,
            25
        ],
        [
            10,
            45,
            15,
            67,
            46,
            16
        ],
        // 40
        [
            19,
            148,
            118,
            6,
            149,
            119
        ],
        [
            18,
            75,
            47,
            31,
            76,
            48
        ],
        [
            34,
            54,
            24,
            34,
            55,
            25
        ],
        [
            20,
            45,
            15,
            61,
            46,
            16
        ]
    ];
    const qrRSBlock = function(totalCount, dataCount) {
        const _this = {};
        _this.totalCount = totalCount;
        _this.dataCount = dataCount;
        return _this;
    };
    const _this = {};
    const getRsBlockTable = function(typeNumber, errorCorrectionLevel) {
        switch(errorCorrectionLevel){
            case $4904b51f6c00d59a$var$QRErrorCorrectionLevel.L:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
            case $4904b51f6c00d59a$var$QRErrorCorrectionLevel.M:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
            case $4904b51f6c00d59a$var$QRErrorCorrectionLevel.Q:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
            case $4904b51f6c00d59a$var$QRErrorCorrectionLevel.H:
                return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
            default:
                return undefined;
        }
    };
    _this.getRSBlocks = function(typeNumber, errorCorrectionLevel) {
        const rsBlock = getRsBlockTable(typeNumber, errorCorrectionLevel);
        if (typeof rsBlock == 'undefined') throw 'bad rs block @ typeNumber:' + typeNumber + '/errorCorrectionLevel:' + errorCorrectionLevel;
        const length = rsBlock.length / 3;
        const list = [];
        for(let i = 0; i < length; i += 1){
            const count = rsBlock[i * 3 + 0];
            const totalCount = rsBlock[i * 3 + 1];
            const dataCount = rsBlock[i * 3 + 2];
            for(let j = 0; j < count; j += 1)list.push(qrRSBlock(totalCount, dataCount));
        }
        return list;
    };
    return _this;
}();
//---------------------------------------------------------------------
// qrBitBuffer
//---------------------------------------------------------------------
const $4904b51f6c00d59a$var$qrBitBuffer = function() {
    const _buffer = [];
    let _length = 0;
    const _this = {};
    _this.getBuffer = function() {
        return _buffer;
    };
    _this.getAt = function(index) {
        const bufIndex = Math.floor(index / 8);
        return (_buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
    };
    _this.put = function(num, length) {
        for(let i = 0; i < length; i += 1)_this.putBit((num >>> length - i - 1 & 1) == 1);
    };
    _this.getLengthInBits = function() {
        return _length;
    };
    _this.putBit = function(bit) {
        const bufIndex = Math.floor(_length / 8);
        if (_buffer.length <= bufIndex) _buffer.push(0);
        if (bit) _buffer[bufIndex] |= 0x80 >>> _length % 8;
        _length += 1;
    };
    return _this;
};
//---------------------------------------------------------------------
// qrNumber
//---------------------------------------------------------------------
const $4904b51f6c00d59a$var$qrNumber = function(data) {
    const _mode = $4904b51f6c00d59a$var$QRMode.MODE_NUMBER;
    const _data = data;
    const _this = {};
    _this.getMode = function() {
        return _mode;
    };
    _this.getLength = function(buffer) {
        return _data.length;
    };
    _this.write = function(buffer) {
        const data = _data;
        let i = 0;
        while(i + 2 < data.length){
            buffer.put(strToNum(data.substring(i, i + 3)), 10);
            i += 3;
        }
        if (i < data.length) {
            if (data.length - i == 1) buffer.put(strToNum(data.substring(i, i + 1)), 4);
            else if (data.length - i == 2) buffer.put(strToNum(data.substring(i, i + 2)), 7);
        }
    };
    const strToNum = function(s) {
        let num = 0;
        for(let i = 0; i < s.length; i += 1)num = num * 10 + chatToNum(s.charAt(i));
        return num;
    };
    const chatToNum = function(c) {
        if ('0' <= c && c <= '9') return c.charCodeAt(0) - '0'.charCodeAt(0);
        throw 'illegal char :' + c;
    };
    return _this;
};
//---------------------------------------------------------------------
// qrAlphaNum
//---------------------------------------------------------------------
const $4904b51f6c00d59a$var$qrAlphaNum = function(data) {
    const _mode = $4904b51f6c00d59a$var$QRMode.MODE_ALPHA_NUM;
    const _data = data;
    const _this = {};
    _this.getMode = function() {
        return _mode;
    };
    _this.getLength = function(buffer) {
        return _data.length;
    };
    _this.write = function(buffer) {
        const s = _data;
        let i = 0;
        while(i + 1 < s.length){
            buffer.put(getCode(s.charAt(i)) * 45 + getCode(s.charAt(i + 1)), 11);
            i += 2;
        }
        if (i < s.length) buffer.put(getCode(s.charAt(i)), 6);
    };
    const getCode = function(c) {
        if ('0' <= c && c <= '9') return c.charCodeAt(0) - '0'.charCodeAt(0);
        else if ('A' <= c && c <= 'Z') return c.charCodeAt(0) - 'A'.charCodeAt(0) + 10;
        else switch(c){
            case '\u0020':
                return 36;
            case '$':
                return 37;
            case '%':
                return 38;
            case '*':
                return 39;
            case '+':
                return 40;
            case '-':
                return 41;
            case '.':
                return 42;
            case '/':
                return 43;
            case ':':
                return 44;
            default:
                throw 'illegal char :' + c;
        }
    };
    return _this;
};
//---------------------------------------------------------------------
// qr8BitByte
//---------------------------------------------------------------------
const $4904b51f6c00d59a$var$qr8BitByte = function(data) {
    const _mode = $4904b51f6c00d59a$var$QRMode.MODE_8BIT_BYTE;
    const _data = data;
    const _bytes = $4904b51f6c00d59a$export$5f3279733515fed0.stringToBytes(data);
    const _this = {};
    _this.getMode = function() {
        return _mode;
    };
    _this.getLength = function(buffer) {
        return _bytes.length;
    };
    _this.write = function(buffer) {
        for(let i = 0; i < _bytes.length; i += 1)buffer.put(_bytes[i], 8);
    };
    return _this;
};
//---------------------------------------------------------------------
// qrKanji
//---------------------------------------------------------------------
const $4904b51f6c00d59a$var$qrKanji = function(data) {
    const _mode = $4904b51f6c00d59a$var$QRMode.MODE_KANJI;
    const _data = data;
    const stringToBytes = $4904b51f6c00d59a$export$5f3279733515fed0.stringToBytes;
    !function(c, code) {
        // self test for sjis support.
        const test = stringToBytes(c);
        if (test.length != 2 || (test[0] << 8 | test[1]) != code) throw 'sjis not supported.';
    }('\u53cb', 0x9746);
    const _bytes = stringToBytes(data);
    const _this = {};
    _this.getMode = function() {
        return _mode;
    };
    _this.getLength = function(buffer) {
        return ~~(_bytes.length / 2);
    };
    _this.write = function(buffer) {
        const data = _bytes;
        let i = 0;
        while(i + 1 < data.length){
            let c = (0xff & data[i]) << 8 | 0xff & data[i + 1];
            if (0x8140 <= c && c <= 0x9FFC) c -= 0x8140;
            else if (0xE040 <= c && c <= 0xEBBF) c -= 0xC140;
            else throw 'illegal char at ' + (i + 1) + '/' + c;
            c = (c >>> 8 & 0xff) * 0xC0 + (c & 0xff);
            buffer.put(c, 13);
            i += 2;
        }
        if (i < data.length) throw 'illegal char at ' + (i + 1);
    };
    return _this;
};
//=====================================================================
// GIF Support etc.
//
//---------------------------------------------------------------------
// byteArrayOutputStream
//---------------------------------------------------------------------
const $4904b51f6c00d59a$var$byteArrayOutputStream = function() {
    const _bytes = [];
    const _this = {};
    _this.writeByte = function(b) {
        _bytes.push(b & 0xff);
    };
    _this.writeShort = function(i) {
        _this.writeByte(i);
        _this.writeByte(i >>> 8);
    };
    _this.writeBytes = function(b, off, len) {
        off = off || 0;
        len = len || b.length;
        for(let i = 0; i < len; i += 1)_this.writeByte(b[i + off]);
    };
    _this.writeString = function(s) {
        for(let i = 0; i < s.length; i += 1)_this.writeByte(s.charCodeAt(i));
    };
    _this.toByteArray = function() {
        return _bytes;
    };
    _this.toString = function() {
        let s = '';
        s += '[';
        for(let i = 0; i < _bytes.length; i += 1){
            if (i > 0) s += ',';
            s += _bytes[i];
        }
        s += ']';
        return s;
    };
    return _this;
};
//---------------------------------------------------------------------
// base64EncodeOutputStream
//---------------------------------------------------------------------
const $4904b51f6c00d59a$var$base64EncodeOutputStream = function() {
    let _buffer = 0;
    let _buflen = 0;
    let _length = 0;
    let _base64 = '';
    const _this = {};
    const writeEncoded = function(b) {
        _base64 += String.fromCharCode(encode(b & 0x3f));
    };
    const encode = function(n) {
        if (n < 0) throw 'n:' + n;
        else if (n < 26) return 0x41 + n;
        else if (n < 52) return 0x61 + (n - 26);
        else if (n < 62) return 0x30 + (n - 52);
        else if (n == 62) return 0x2b;
        else if (n == 63) return 0x2f;
        else throw 'n:' + n;
    };
    _this.writeByte = function(n) {
        _buffer = _buffer << 8 | n & 0xff;
        _buflen += 8;
        _length += 1;
        while(_buflen >= 6){
            writeEncoded(_buffer >>> _buflen - 6);
            _buflen -= 6;
        }
    };
    _this.flush = function() {
        if (_buflen > 0) {
            writeEncoded(_buffer << 6 - _buflen);
            _buffer = 0;
            _buflen = 0;
        }
        if (_length % 3 != 0) {
            // padding
            const padlen = 3 - _length % 3;
            for(let i = 0; i < padlen; i += 1)_base64 += '=';
        }
    };
    _this.toString = function() {
        return _base64;
    };
    return _this;
};
//---------------------------------------------------------------------
// base64DecodeInputStream
//---------------------------------------------------------------------
const $4904b51f6c00d59a$var$base64DecodeInputStream = function(str) {
    const _str = str;
    let _pos = 0;
    let _buffer = 0;
    let _buflen = 0;
    const _this = {};
    _this.read = function() {
        while(_buflen < 8){
            if (_pos >= _str.length) {
                if (_buflen == 0) return -1;
                throw 'unexpected end of file./' + _buflen;
            }
            const c = _str.charAt(_pos);
            _pos += 1;
            if (c == '=') {
                _buflen = 0;
                return -1;
            } else if (c.match(/^\s$/)) continue;
            _buffer = _buffer << 6 | decode(c.charCodeAt(0));
            _buflen += 6;
        }
        const n = _buffer >>> _buflen - 8 & 0xff;
        _buflen -= 8;
        return n;
    };
    const decode = function(c) {
        if (0x41 <= c && c <= 0x5a) return c - 0x41;
        else if (0x61 <= c && c <= 0x7a) return c - 0x61 + 26;
        else if (0x30 <= c && c <= 0x39) return c - 0x30 + 52;
        else if (c == 0x2b) return 62;
        else if (c == 0x2f) return 63;
        else throw 'c:' + c;
    };
    return _this;
};
//---------------------------------------------------------------------
// gifImage (B/W)
//---------------------------------------------------------------------
const $4904b51f6c00d59a$var$gifImage = function(width, height) {
    const _width = width;
    const _height = height;
    const _data = new Array(width * height);
    const _this = {};
    _this.setPixel = function(x, y, pixel) {
        _data[y * _width + x] = pixel;
    };
    _this.write = function(out) {
        //---------------------------------
        // GIF Signature
        out.writeString('GIF87a');
        //---------------------------------
        // Screen Descriptor
        out.writeShort(_width);
        out.writeShort(_height);
        out.writeByte(0x80); // 2bit
        out.writeByte(0);
        out.writeByte(0);
        //---------------------------------
        // Global Color Map
        // black
        out.writeByte(0x00);
        out.writeByte(0x00);
        out.writeByte(0x00);
        // white
        out.writeByte(0xff);
        out.writeByte(0xff);
        out.writeByte(0xff);
        //---------------------------------
        // Image Descriptor
        out.writeString(',');
        out.writeShort(0);
        out.writeShort(0);
        out.writeShort(_width);
        out.writeShort(_height);
        out.writeByte(0);
        //---------------------------------
        // Local Color Map
        //---------------------------------
        // Raster Data
        const lzwMinCodeSize = 2;
        const raster = getLZWRaster(lzwMinCodeSize);
        out.writeByte(lzwMinCodeSize);
        let offset = 0;
        while(raster.length - offset > 255){
            out.writeByte(255);
            out.writeBytes(raster, offset, 255);
            offset += 255;
        }
        out.writeByte(raster.length - offset);
        out.writeBytes(raster, offset, raster.length - offset);
        out.writeByte(0x00);
        //---------------------------------
        // GIF Terminator
        out.writeString(';');
    };
    const bitOutputStream = function(out) {
        const _out = out;
        let _bitLength = 0;
        let _bitBuffer = 0;
        const _this = {};
        _this.write = function(data, length) {
            if (data >>> length != 0) throw 'length over';
            while(_bitLength + length >= 8){
                _out.writeByte(0xff & (data << _bitLength | _bitBuffer));
                length -= 8 - _bitLength;
                data >>>= 8 - _bitLength;
                _bitBuffer = 0;
                _bitLength = 0;
            }
            _bitBuffer = data << _bitLength | _bitBuffer;
            _bitLength = _bitLength + length;
        };
        _this.flush = function() {
            if (_bitLength > 0) _out.writeByte(_bitBuffer);
        };
        return _this;
    };
    const getLZWRaster = function(lzwMinCodeSize) {
        const clearCode = 1 << lzwMinCodeSize;
        const endCode = (1 << lzwMinCodeSize) + 1;
        let bitLength = lzwMinCodeSize + 1;
        // Setup LZWTable
        const table = lzwTable();
        for(let i = 0; i < clearCode; i += 1)table.add(String.fromCharCode(i));
        table.add(String.fromCharCode(clearCode));
        table.add(String.fromCharCode(endCode));
        const byteOut = $4904b51f6c00d59a$var$byteArrayOutputStream();
        const bitOut = bitOutputStream(byteOut);
        // clear code
        bitOut.write(clearCode, bitLength);
        let dataIndex = 0;
        let s = String.fromCharCode(_data[dataIndex]);
        dataIndex += 1;
        while(dataIndex < _data.length){
            const c = String.fromCharCode(_data[dataIndex]);
            dataIndex += 1;
            if (table.contains(s + c)) s = s + c;
            else {
                bitOut.write(table.indexOf(s), bitLength);
                if (table.size() < 0xfff) {
                    if (table.size() == 1 << bitLength) bitLength += 1;
                    table.add(s + c);
                }
                s = c;
            }
        }
        bitOut.write(table.indexOf(s), bitLength);
        // end code
        bitOut.write(endCode, bitLength);
        bitOut.flush();
        return byteOut.toByteArray();
    };
    const lzwTable = function() {
        const _map = {};
        let _size = 0;
        const _this = {};
        _this.add = function(key) {
            if (_this.contains(key)) throw 'dup key:' + key;
            _map[key] = _size;
            _size += 1;
        };
        _this.size = function() {
            return _size;
        };
        _this.indexOf = function(key) {
            return _map[key];
        };
        _this.contains = function(key) {
            return typeof _map[key] != 'undefined';
        };
        return _this;
    };
    return _this;
};
const $4904b51f6c00d59a$var$createDataURL = function(width, height, getPixel) {
    const gif = $4904b51f6c00d59a$var$gifImage(width, height);
    for(let y = 0; y < height; y += 1)for(let x = 0; x < width; x += 1)gif.setPixel(x, y, getPixel(x, y));
    const b = $4904b51f6c00d59a$var$byteArrayOutputStream();
    gif.write(b);
    const base64 = $4904b51f6c00d59a$var$base64EncodeOutputStream();
    const bytes = b.toByteArray();
    for(let i = 0; i < bytes.length; i += 1)base64.writeByte(bytes[i]);
    base64.flush();
    return 'data:image/gif;base64,' + base64;
};
var $4904b51f6c00d59a$export$2e2bcd8739ae039 = $4904b51f6c00d59a$export$5f3279733515fed0;
const $4904b51f6c00d59a$export$c8dd6bc66a63753c = $4904b51f6c00d59a$export$5f3279733515fed0.stringToBytes;


/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d252ca8c87a49232$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 15V3",
            key: "m9g1x1"
        }
    ],
    [
        "path",
        {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
            key: "ih7n3h"
        }
    ],
    [
        "path",
        {
            d: "m7 10 5 5 5-5",
            key: "brsn70"
        }
    ]
];
const $d252ca8c87a49232$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("download", $d252ca8c87a49232$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8695263a8c6cd2c2$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "14",
            height: "20",
            x: "5",
            y: "2",
            rx: "2",
            ry: "2",
            key: "1yt0o3"
        }
    ],
    [
        "path",
        {
            d: "M12 18h.01",
            key: "mhygvu"
        }
    ]
];
const $8695263a8c6cd2c2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("smartphone", $8695263a8c6cd2c2$export$3efd853dbb351e94);



/**
 * What we CALL two-factor authentication on screen — decided in one place, because the right name
 * depends on who is reading.
 *
 * ADVISERS AND FIRM STAFF get "multi-factor authentication". It is the term on cyber-insurance
 * proposals, licensee audits and due-diligence questionnaires, so to a professional it reads as the
 * control they are already required to have, named properly. "Two-step sign in" would read as
 * something lesser, and would not obviously be the box they need to tick on a compliance form.
 *
 * CONSUMERS get "two-step sign in". Someone planning their mother's aged care has never met the
 * phrase "multi-factor authentication" and should not have to: the words have to do the explaining,
 * because there is nobody beside them to do it. This is the same reason the setup screen says "scan
 * this square" rather than "scan the QR code to provision your TOTP authenticator".
 *
 * Same feature, same screens, same security. Only the label changes, and it changes because the
 * audience does.
 */ const $19ccc74b4bce727a$var$PROFESSIONAL = {
    title: 'Multi-factor authentication',
    inline: 'multi-factor authentication',
    setUp: 'Set up multi-factor authentication',
    turnOn: 'Turn on multi-factor authentication',
    turnOff: 'Turn off multi-factor authentication',
    isOn: 'Multi-factor authentication is on',
    isOff: 'Multi-factor authentication is off'
};
const $19ccc74b4bce727a$var$CONSUMER = {
    title: 'Two-step sign in',
    inline: 'two-step sign in',
    setUp: 'Set up two-step sign in',
    turnOn: 'Turn on two-step sign in',
    turnOff: 'Turn off two-step sign in',
    isOn: 'Two-step sign in is on',
    isOff: 'Two-step sign in is off'
};
function $19ccc74b4bce727a$export$6f8ad042a19877fc(professional) {
    return professional ? $19ccc74b4bce727a$var$PROFESSIONAL : $19ccc74b4bce727a$var$CONSUMER;
}


/** The QR code as an inline SVG string. No network request, no image host, nothing to block. */ function $810a19cb10a15a4b$var$qrSvg(text) {
    // Type 0 = pick the smallest size that fits. 'M' correction is what every authenticator expects.
    const qr = (0, $4904b51f6c00d59a$export$2e2bcd8739ae039)(0, 'M');
    qr.addData(text);
    qr.make();
    return qr.createSvgTag({
        cellSize: 5,
        margin: 2,
        scalable: true
    });
}
/** Group the secret into fours — nobody can read 32 unbroken characters off a screen. */ function $810a19cb10a15a4b$var$readableSecret(secret) {
    return (secret.match(/.{1,4}/g) ?? [
        secret
    ]).join(' ');
}
const $810a19cb10a15a4b$var$TwoFactorSetup = ({ mandatory: mandatory = false, onDone: onDone, onCancel: onCancel })=>{
    // `mandatory` is only ever true for advisers, firm staff and platform admins — the people who
    // know the term. See twoFactorWording.ts for why the name differs by reader.
    const words = (0, $19ccc74b4bce727a$export$6f8ad042a19877fc)(mandatory);
    const [step, setStep] = (0, $acw62.useState)('scan');
    const [secret, setSecret] = (0, $acw62.useState)('');
    const [uri, setUri] = (0, $acw62.useState)('');
    const [code, setCode] = (0, $acw62.useState)('');
    const [recoveryCodes, setRecoveryCodes] = (0, $acw62.useState)([]);
    const [savedThem, setSavedThem] = (0, $acw62.useState)(false);
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [copied, setCopied] = (0, $acw62.useState)(null);
    const [showSecret, setShowSecret] = (0, $acw62.useState)(false);
    const [trustThisDevice, setTrustThisDevice] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (async ()=>{
            const res = await (0, $cc9e8a24185b91b0$export$ed9663ad0ae94f4d)();
            if (cancelled) return;
            if (!res.ok) return setError(res.message);
            setSecret(res.secret);
            setUri(res.uri);
        })();
        return ()=>{
            cancelled = true;
        };
    }, []);
    const svg = (0, $acw62.useMemo)(()=>uri ? $810a19cb10a15a4b$var$qrSvg(uri) : '', [
        uri
    ]);
    const copy = async (text, which)=>{
        try {
            await navigator.clipboard.writeText(text);
            setCopied(which);
            setTimeout(()=>setCopied(null), 2000);
        } catch  {
        /* Clipboard blocked — the text is on screen to be typed or selected by hand. */ }
    };
    const downloadCodes = ()=>{
        const body = [
            'AgedCareWise recovery codes',
            '',
            "Each code works once. Keep them somewhere safe and away from your phone \u2014",
            'they are what gets you back in if you lose it.',
            '',
            ...recoveryCodes
        ].join('\n');
        const url = URL.createObjectURL(new Blob([
            body
        ], {
            type: 'text/plain'
        }));
        const a = document.createElement('a');
        a.href = url;
        a.download = 'agedcarewise-recovery-codes.txt';
        a.click();
        URL.revokeObjectURL(url);
    };
    const handleConfirm = async ()=>{
        setBusy(true);
        setError(null);
        try {
            const res = await (0, $cc9e8a24185b91b0$export$86f29dce9d2b89d0)(code.trim(), trustThisDevice);
            if (!res.ok) {
                setCode('');
                return setError(res.message);
            }
            setRecoveryCodes(res.recoveryCodes);
            setStep('codes');
        } finally{
            setBusy(false);
        }
    };
    const primaryBtn = 'inline-flex w-full items-center justify-center gap-2 rounded-xl bg-blue-600 px-4 py-3 text-sm font-semibold text-white transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-gray-300';
    const quietBtn = 'w-full text-sm text-gray-500 transition hover:text-gray-700';
    if (error && !secret) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-4 text-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-sm text-red-600",
                children: error
            }),
            onCancel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onCancel,
                className: quietBtn,
                children: "Close"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex items-center justify-center gap-1.5",
                "aria-hidden": "true",
                children: [
                    'scan',
                    'confirm',
                    'codes'
                ].map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `h-1.5 rounded-full transition-all ${s === step ? 'w-6 bg-blue-600' : 'w-1.5 bg-gray-300'}`
                    }, s))
            }),
            step === 'scan' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-start gap-3 rounded-xl bg-blue-50 p-3.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8695263a8c6cd2c2$export$2e2bcd8739ae039), {
                                size: 18,
                                className: "mt-0.5 shrink-0 text-blue-600"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-blue-900",
                                children: mandatory ? 'Adviser accounts are protected by a code from your phone as well as a password. This takes about a minute.' : 'Add a second step to your login, so a password alone is never enough to get in.'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm font-semibold text-gray-800",
                                children: "1. Get an authenticator app"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-1 text-sm text-gray-600",
                                children: [
                                    "If you don't already have one, install ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Google Authenticator"
                                    }),
                                    " or",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Microsoft Authenticator"
                                    }),
                                    " from your phone's app store. They're free."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm font-semibold text-gray-800",
                                children: "2. Scan this square"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-1 text-sm text-gray-600",
                                children: [
                                    "Open the app, choose ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                        children: "add account"
                                    }),
                                    ", and point your camera here."
                                ]
                            }),
                            svg ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mx-auto mt-3 w-44 rounded-xl border border-gray-200 bg-white p-3 [&>svg]:h-full [&>svg]:w-full",
                                /*
                                 * The SVG is built in this file from a string we generated ourselves — it is
                                 * never user input and never comes from the network.
                                 */ dangerouslySetInnerHTML: {
                                    __html: svg
                                }
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mx-auto mt-3 h-44 w-44 animate-pulse rounded-xl bg-gray-100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "rounded-xl border border-gray-200 p-3",
                        children: showSecret ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-xs text-gray-500",
                                    children: "Or choose \u201Center a setup key\u201D in the app and type this:"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-1.5 select-all break-all font-mono text-sm tracking-wide text-gray-800",
                                    children: $810a19cb10a15a4b$var$readableSecret(secret)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>copy(secret, 'secret'),
                                    className: "mt-2 inline-flex items-center gap-1.5 text-xs font-medium text-blue-600 hover:text-blue-700",
                                    children: [
                                        copied === 'secret' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                            size: 13
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
                                            size: 13
                                        }),
                                        copied === 'secret' ? 'Copied' : 'Copy the key'
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>setShowSecret(true),
                            className: "text-sm text-blue-600 hover:text-blue-700",
                            children: "Can't scan it? Type a key instead"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setStep('confirm'),
                        disabled: !secret,
                        className: primaryBtn,
                        children: "I've added it"
                    }),
                    onCancel && !mandatory && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onCancel,
                        className: quietBtn,
                        children: "Not now"
                    })
                ]
            }),
            step === 'confirm' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                className: "space-y-4",
                onSubmit: (e)=>{
                    e.preventDefault();
                    handleConfirm();
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm font-semibold text-gray-800",
                                children: "3. Enter the code it shows"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1 text-sm text-gray-600",
                                children: "Your app is now showing a 6-digit code for AgedCareWise. It changes every 30 seconds \u2014 type whichever one is showing now."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "text",
                        inputMode: "numeric",
                        autoComplete: "one-time-code",
                        maxLength: 6,
                        value: code,
                        autoFocus: true,
                        onChange: (e)=>setCode(e.target.value.replace(/\D/g, '')),
                        className: "w-full rounded-xl border border-gray-300 px-4 py-3 text-center font-mono text-2xl tracking-[0.35em] text-gray-900 focus:border-blue-500 focus:outline-none",
                        placeholder: "000000",
                        "aria-label": "6-digit code from your authenticator app"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        className: "flex items-start gap-2.5 text-sm text-gray-600",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "checkbox",
                                checked: trustThisDevice,
                                onChange: (e)=>setTrustThisDevice(e.target.checked),
                                className: "mt-0.5 h-4 w-4 rounded border-gray-300 text-blue-600"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    "Don't ask for a code on this device for 30 days",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "mt-0.5 block text-xs text-gray-400",
                                        children: "Only tick this on a computer that's yours."
                                    })
                                ]
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-red-600",
                        children: error
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "submit",
                        disabled: busy || code.length < 6,
                        className: primaryBtn,
                        children: busy ? "Checking\u2026" : words.turnOn
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            setError(null);
                            setStep('scan');
                        },
                        className: quietBtn,
                        children: "Back"
                    })
                ]
            }),
            step === 'codes' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-start gap-3 rounded-xl bg-green-50 p-3.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                size: 18,
                                className: "mt-0.5 shrink-0 text-green-600"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-green-900",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "That's on now."
                                    }),
                                    " From here on you'll enter a code when you sign in on a new device."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm font-semibold text-gray-800",
                                children: "Save these recovery codes"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-1 text-sm text-gray-600",
                                children: [
                                    "These get you in if you ever lose your phone. Each one works once.",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "We can't show them to you again"
                                    }),
                                    " \u2014 print them, or keep them somewhere safe that isn't your phone."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        className: "grid grid-cols-2 gap-x-4 gap-y-1.5 rounded-xl border border-gray-200 bg-gray-50 p-4 font-mono text-sm text-gray-800",
                        children: recoveryCodes.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                className: "select-all",
                                children: c
                            }, c))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>copy(recoveryCodes.join('\n'), 'codes'),
                                className: "inline-flex flex-1 items-center justify-center gap-1.5 rounded-xl border border-gray-300 px-3 py-2.5 text-sm font-medium text-gray-700 transition hover:bg-gray-50",
                                children: [
                                    copied === 'codes' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                        size: 15
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
                                        size: 15
                                    }),
                                    copied === 'codes' ? 'Copied' : 'Copy'
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: downloadCodes,
                                className: "inline-flex flex-1 items-center justify-center gap-1.5 rounded-xl border border-gray-300 px-3 py-2.5 text-sm font-medium text-gray-700 transition hover:bg-gray-50",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d252ca8c87a49232$export$2e2bcd8739ae039), {
                                        size: 15
                                    }),
                                    " Download"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        className: "flex items-start gap-2.5 text-sm text-gray-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "checkbox",
                                checked: savedThem,
                                onChange: (e)=>setSavedThem(e.target.checked),
                                className: "mt-0.5 h-4 w-4 rounded border-gray-300 text-blue-600"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "I've saved these somewhere safe"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onDone,
                        disabled: !savedThem,
                        className: primaryBtn,
                        children: "Done"
                    })
                ]
            })
        ]
    });
};
var $810a19cb10a15a4b$export$2e2bcd8739ae039 = $810a19cb10a15a4b$var$TwoFactorSetup;


/**
 * Tenancy calls (partner channel): who am I / which workspaces, invite acceptance.
 * All requests carry the signed-in user's token; the server + database enforce access.
 */ 


const $442533e192804693$export$b59df854b6295776 = {
    adviser: 'Financial adviser',
    accountant: 'Accountant',
    solicitor: 'Solicitor',
    aged_care_provider: 'Aged-care provider',
    support_at_home_provider: 'Support at Home provider',
    super_fund: 'Superannuation trustee',
    other: 'Other professional'
};
function $442533e192804693$export$67df0a24993f58cf(profession) {
    switch(profession){
        case 'adviser':
            return 'Adviser';
        case 'accountant':
            return 'Accountant';
        case 'solicitor':
            return 'Solicitor';
        default:
            return 'Client lead';
    }
}
async function $442533e192804693$export$297cdab4afe3ed04(tenantId, settings) {
    try {
        const headers = await $442533e192804693$var$authHeaders();
        await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).put(`${$442533e192804693$var$getApiBaseUrl()}/rest/tenants/${tenantId}/settings`, {
            settings: settings
        }, {
            headers: headers,
            timeout: 30000
        });
        return {
            ok: true
        };
    } catch (err) {
        return {
            ok: false,
            message: $442533e192804693$var$explainError(err, 'Could not save those settings.')
        };
    }
}
function $442533e192804693$var$getApiBaseUrl() {
    // One source for this — see services/apiBase.ts for why eight copies was a problem.
    return (0, $4e54353814e6aea9$export$8ebae31efd30e025)();
}
async function $442533e192804693$var$authHeaders() {
    const token = await (0, $cc9e8a24185b91b0$export$84773cc9bf7dbe87)();
    if (!token) throw new Error('Not signed in');
    return {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
}
/**
 * Turn an axios failure into a message that actually helps: distinguish "can't reach the server"
 * (no response — server down / offline) from a real server-side reason, and surface that reason.
 */ function $442533e192804693$var$explainError(err, fallback) {
    const axiosErr = err;
    const serverMsg = axiosErr?.response?.data?.error?.message;
    if (serverMsg) return serverMsg;
    if (err?.message === 'Not signed in') return "Your session has expired \u2014 please sign in again.";
    if (!axiosErr?.response) return "We couldn't reach AgedCareWise. Check your internet connection and try again in a moment.";
    return fallback;
}
async function $442533e192804693$export$f1d37579424c00c1(tenantId) {
    const headers = await $442533e192804693$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${$442533e192804693$var$getApiBaseUrl()}/rest/tenants/${tenantId}/members`, {
        headers: headers,
        timeout: 30000
    });
    return res.data.members || [];
}
async function $442533e192804693$export$20839648df6ac6fe(tenantId, email, role) {
    try {
        const headers = await $442533e192804693$var$authHeaders();
        const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$442533e192804693$var$getApiBaseUrl()}/rest/tenants/${tenantId}/invites`, {
            email: email,
            role: role
        }, {
            headers: headers,
            timeout: 30000
        });
        return {
            ok: true,
            ...res.data
        };
    } catch (err) {
        return {
            ok: false,
            message: $442533e192804693$var$explainError(err, 'Could not send that invite.')
        };
    }
}
async function $442533e192804693$export$5eb419ad44f728fd(tenantId, userId, patch) {
    try {
        const headers = await $442533e192804693$var$authHeaders();
        await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).patch(`${$442533e192804693$var$getApiBaseUrl()}/rest/tenants/${tenantId}/members/${userId}`, patch, {
            headers: headers,
            timeout: 30000
        });
        return {
            ok: true
        };
    } catch (err) {
        return {
            ok: false,
            message: $442533e192804693$var$explainError(err, 'Could not save that change.')
        };
    }
}
async function $442533e192804693$export$b292608e58e5c4ed(tenantId, userId) {
    try {
        const headers = await $442533e192804693$var$authHeaders();
        await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).delete(`${$442533e192804693$var$getApiBaseUrl()}/rest/tenants/${tenantId}/members/${userId}`, {
            headers: headers,
            timeout: 30000
        });
        return {
            ok: true
        };
    } catch (err) {
        return {
            ok: false,
            message: $442533e192804693$var$explainError(err, 'Could not remove that person.')
        };
    }
}
async function $442533e192804693$export$f295b832cc46f372(tenantId, toUserId, outgoing) {
    try {
        const headers = await $442533e192804693$var$authHeaders();
        await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$442533e192804693$var$getApiBaseUrl()}/rest/tenants/${tenantId}/transfer-ownership`, {
            toUserId: toUserId,
            outgoing: outgoing
        }, {
            headers: headers,
            timeout: 30000
        });
        return {
            ok: true
        };
    } catch (err) {
        return {
            ok: false,
            message: $442533e192804693$var$explainError(err, 'Could not hand the account over.')
        };
    }
}
async function $442533e192804693$export$285f02a91c28b3ab(profileId, adviserUserId) {
    try {
        const headers = await $442533e192804693$var$authHeaders();
        await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$442533e192804693$var$getApiBaseUrl()}/rest/profiles/${profileId}/reassign`, {
            adviserUserId: adviserUserId
        }, {
            headers: headers,
            timeout: 30000
        });
        return {
            ok: true
        };
    } catch (err) {
        return {
            ok: false,
            message: $442533e192804693$var$explainError(err, 'Could not reassign that client.')
        };
    }
}
async function $442533e192804693$export$868da79368f9e4d0(profileId, visibility, note) {
    try {
        const headers = await $442533e192804693$var$authHeaders();
        await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$442533e192804693$var$getApiBaseUrl()}/rest/profiles/${profileId}/visibility`, {
            visibility: visibility,
            note: note ?? null
        }, {
            headers: headers,
            timeout: 30000
        });
        return {
            ok: true
        };
    } catch (err) {
        return {
            ok: false,
            message: $442533e192804693$var$explainError(err, 'Could not change who can see this client.')
        };
    }
}
async function $442533e192804693$export$7986551de014fb3e(tenantId, patch) {
    try {
        const headers = await $442533e192804693$var$authHeaders();
        await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).put(`${$442533e192804693$var$getApiBaseUrl()}/rest/tenants/${tenantId}/settings`, patch, {
            headers: headers,
            timeout: 30000
        });
        return {
            ok: true
        };
    } catch (err) {
        return {
            ok: false,
            message: $442533e192804693$var$explainError(err, 'Could not save your licensing details.')
        };
    }
}
async function $442533e192804693$export$76738e97a4787aff() {
    const headers = await $442533e192804693$var$authHeaders();
    // 60s (not 30s): this call decides where a partner lands at sign-in, and the first request to a
    // sleeping free-tier server can take 30–50s to wake. A too-short timeout here misroutes partners.
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${$442533e192804693$var$getApiBaseUrl()}/rest/me`, {
        headers: headers,
        timeout: 60000
    });
    return res.data.memberships || [];
}
async function $442533e192804693$export$7417b9ab7638b3e6() {
    const memberships = await $442533e192804693$export$76738e97a4787aff();
    return memberships.find((m)=>m.tenantKind === 'partner' && [
            'owner',
            'adviser',
            'staff'
        ].includes(m.role)) || null;
}
async function $442533e192804693$export$89efd5e1ca1c0c1f({ name: name, profession: profession, afslLicenseeName: afslLicenseeName, afslNumber: afslNumber, adviceStructure: adviceStructure, carName: carName, carNumber: carNumber, adviserNumber: adviserNumber }) {
    try {
        const headers = await $442533e192804693$var$authHeaders();
        const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$442533e192804693$var$getApiBaseUrl()}/rest/partners/register`, {
            name: name,
            profession: profession,
            // Empty strings are omitted, not sent: the API rejects a blank where it expects a number or
            // nothing, and "" would also read as a recorded-but-empty value on the firm.
            ...profession === 'adviser' ? {
                afslLicenseeName: afslLicenseeName,
                afslNumber: afslNumber,
                ...adviceStructure ? {
                    adviceStructure: adviceStructure
                } : {},
                ...carName ? {
                    carName: carName
                } : {},
                ...carNumber ? {
                    carNumber: carNumber
                } : {},
                ...adviserNumber ? {
                    adviserNumber: adviserNumber
                } : {}
            } : {}
        }, {
            headers: headers,
            timeout: 30000
        });
        return {
            ok: true,
            ...res.data
        };
    } catch (err) {
        return {
            ok: false,
            message: $442533e192804693$var$explainError(err, "Registration failed \u2014 please try again.")
        };
    }
}
async function $442533e192804693$export$e24d85f794d5f8dd(tenantId) {
    try {
        const headers = await $442533e192804693$var$authHeaders();
        const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${$442533e192804693$var$getApiBaseUrl()}/rest/tenants/${tenantId}`, {
            headers: headers,
            timeout: 30000
        });
        // The standard message wording rides along on the tenant fetch the portal already makes, so the
        // Settings screen can SHOW an adviser what we send rather than describing it.
        return {
            ...res.data.tenant,
            messageDefaults: res.data.messageDefaults,
            autoReminders: res.data.autoReminders
        };
    } catch  {
        return null;
    }
}
async function $442533e192804693$export$f2385fb263a7b829(tenantId, inviteId) {
    try {
        const headers = await $442533e192804693$var$authHeaders();
        const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$442533e192804693$var$getApiBaseUrl()}/rest/tenants/${tenantId}/invites/${inviteId}/resend`, {}, {
            headers: headers,
            timeout: 30000
        });
        return {
            ok: true,
            ...res.data
        };
    } catch (err) {
        return {
            ok: false,
            message: $442533e192804693$var$explainError(err, 'Could not send the reminder.')
        };
    }
}
async function $442533e192804693$export$3400e2a39cde89c1(tenantId, email, profileId = null, followUpDays = null) {
    try {
        const headers = await $442533e192804693$var$authHeaders();
        const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$442533e192804693$var$getApiBaseUrl()}/rest/tenants/${tenantId}/invites`, {
            email: email,
            role: 'client',
            ...profileId ? {
                profileId: profileId
            } : {},
            ...followUpDays ? {
                followUpDays: followUpDays
            } : {}
        }, {
            headers: headers,
            timeout: 30000
        });
        return {
            ok: true,
            ...res.data
        };
    } catch (err) {
        return {
            ok: false,
            message: $442533e192804693$var$explainError(err, 'Could not create the invite.')
        };
    }
}
async function $442533e192804693$export$f17229473791149b(token) {
    try {
        const headers = await $442533e192804693$var$authHeaders();
        const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$442533e192804693$var$getApiBaseUrl()}/rest/invites/accept`, {
            token: token
        }, {
            headers: headers,
            timeout: 30000
        });
        return {
            ok: true,
            ...res.data
        };
    } catch (err) {
        return {
            ok: false,
            message: $442533e192804693$var$explainError(err, 'This invite link is not valid.')
        };
    }
}
const $442533e192804693$var$PENDING_INVITE_KEY = 'awisePendingInvite';
function $442533e192804693$export$691aaaf0deffae39() {
    try {
        const url = new URL(window.location.href);
        const token = url.searchParams.get('invite');
        if (token) {
            sessionStorage.setItem($442533e192804693$var$PENDING_INVITE_KEY, token);
            url.searchParams.delete('invite');
            window.history.replaceState({}, '', url.toString());
        }
    } catch  {
    /* no-op: URL handling must never break app start-up */ }
    return sessionStorage.getItem($442533e192804693$var$PENDING_INVITE_KEY);
}
function $442533e192804693$export$3b3ae80d6efd63b1() {
    return sessionStorage.getItem($442533e192804693$var$PENDING_INVITE_KEY);
}
function $442533e192804693$export$6a9967bee0a17e3b() {
    sessionStorage.removeItem($442533e192804693$var$PENDING_INVITE_KEY);
}
function $442533e192804693$export$ec6a2e3c3bb73e9c() {
    const token = sessionStorage.getItem($442533e192804693$var$PENDING_INVITE_KEY);
    if (token) {
        sessionStorage.removeItem($442533e192804693$var$PENDING_INVITE_KEY);
        sessionStorage.setItem($442533e192804693$var$REDEEMING_INVITE_KEY, '1');
    }
    return token;
}
const $442533e192804693$var$REDEEMING_INVITE_KEY = 'awiseInviteRedeeming';
function $442533e192804693$export$339c81b2cc180bb5() {
    return sessionStorage.getItem($442533e192804693$var$REDEEMING_INVITE_KEY) === '1';
}
function $442533e192804693$export$900988654c72c4e3() {
    sessionStorage.removeItem($442533e192804693$var$REDEEMING_INVITE_KEY);
}


/**
 * Terms-acceptance client — records clickwrap acceptance on the server ledger (/rest/terms).
 * The server stamps the document VERSION itself; we only say which documents were agreed to.
 */ 


function $1124d5012b356e89$var$getApiBaseUrl() {
    // One source for this — see services/apiBase.ts for why eight copies was a problem.
    return (0, $4e54353814e6aea9$export$8ebae31efd30e025)();
}
async function $1124d5012b356e89$var$authHeaders() {
    const token = await (0, $cc9e8a24185b91b0$export$84773cc9bf7dbe87)();
    if (!token) throw new Error('Not signed in');
    return {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
}
async function $1124d5012b356e89$export$2fe2928877a2a98(documents, context = 'signup') {
    const headers = await $1124d5012b356e89$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$1124d5012b356e89$var$getApiBaseUrl()}/rest/terms/accept`, {
        documents: documents,
        context: context
    }, {
        headers: headers,
        timeout: 20000
    });
    return res.data;
}
async function $1124d5012b356e89$export$1da9236be1858959() {
    const headers = await $1124d5012b356e89$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${$1124d5012b356e89$var$getApiBaseUrl()}/rest/terms/status`, {
        headers: headers,
        timeout: 20000
    });
    return res.data;
}


/**
 * Legal documents (single client-side source of truth for the rendered text).
 * Versions must match server/src/legal/legalVersions.ts — tests/legalDocuments.test.js pins the
 * structure; bump BOTH sides together on any material change.
 */ /**
 * Consumer Terms of Use — DRAFT prepared for lawyer review (see docs/legal/README.md for the
 * legal-requirements research these are built on, and the open placeholders the owner/lawyer
 * must complete). The `version` string must match server/src/legal/legalVersions.ts — bump BOTH
 * on any material change, and re-run the acceptance gate.
 */ const $53b9787b76ac25b0$export$4aeb9bf2c158bdb6 = {
    key: 'consumer_terms',
    version: '2026-07-09',
    title: "Terms of Use \u2014 Individuals & Families",
    effectiveDate: '9 July 2026',
    draft: true,
    body: `
## 1. Who we are

AgedCareWise is guided financial-modelling software for Australian aged-care and retirement living
decisions, operated by **[ENTITY NAME + ABN \u{2014} to be completed]** ("AgedCareWise", "we", "us").

**Licensing.** AgedCareWise provides personal financial advice tools under Australian financial
services licensing arrangements. **[LICENSING STATEMENT \u{2014} to be completed on grant of the AFSL /
finalisation of licensing arrangements. The service must not be represented as licensed before
this is in place.]** Details of our advice service, including our Financial Services Guide, are
provided to you separately.

## 2. The service

- You enter information about your situation; AgedCareWise models Australian aged-care fees,
  Age Pension, cashflow and estate outcomes, compares strategies, and can produce a Statement of
  Advice.
- The modelling reflects the Australian rules current at the time you use it. Rules and rates
  change; results are projections based on stated assumptions, not guarantees of future outcomes.
- The quality of the output depends on the accuracy and completeness of what you enter. Please
  check your entries carefully.
- Some situations are too complex for guided modelling. We may tell you that part of your
  situation is outside what AgedCareWise can appropriately model and suggest you seek personal
  advice from a licensed adviser for that part.

## 3. Your account

- Keep your login details secure. You can add two-factor authentication in your account settings,
  and we recommend it.
- Your information saves automatically and is protected as described in our Privacy Policy.
- One account is for one person or couple's planning. Don't share your account.

## 4. Price and access

- The price is **$480 (including GST)**, paid once, for **4 months of full access** from the day
  you pay. There is no subscription and no automatic renewal; we do not keep your card on file.
- When your access period ends, your account locks but your information is **retained, not
  deleted** \u{2014} if you return and pay again, you continue exactly where you left off.
- Payments are processed by Stripe. Your card details never touch our servers.

## 5. Refunds

Australian Consumer Law consumer guarantees apply to our service and nothing in these terms
excludes, restricts or modifies them. If our service fails to meet a guarantee, you are entitled
to the remedies the law provides, which may include a refund.
**[CHANGE-OF-MIND REFUND POLICY \u{2014} owner decision required; recommend a short cooling-off window
given the upfront 4-month payment.]**

## 6. Fair use

You agree not to: use the service for anyone else's benefit on a commercial basis (professionals
have their own partner terms); attempt to access other people's information; probe, disrupt or
reverse-engineer the service; or use automated tools to bulk-extract content. The AWise assistant
has a fair-use daily allowance.

## 7. Intellectual property

The software, modelling engine, content and branding are ours (or our licensors'). Your
information is yours. The documents produced for you (including your Statement of Advice) are
yours to keep and share for your personal purposes.

## 8. Privacy

Our collection and handling of your personal information is described in the AgedCareWise
Privacy Policy, which forms part of these terms. Advice records are retained for at least
7 years as required by financial-services law, even if you close your account.

## 9. Our liability

Nothing in these terms excludes, restricts or modifies any consumer guarantee, right or remedy
under the Australian Consumer Law or the ASIC Act that cannot lawfully be excluded. Subject to
that, and to the extent permitted by law, we are not liable for loss arising from inaccurate
information you provide, from decisions you make against the guidance shown, or from events
outside our reasonable control. **[LIABILITY CLAUSE \u{2014} lawyer to settle; consumer-service caps
are tightly constrained by the consumer guarantees.]**

## 10. Changes to these terms

If we make a material change to these terms, we will give you at least **30 days' notice by
email** and ask you to accept the updated terms when you next sign in. If a change materially
disadvantages you during a period you have already paid for, you may end your access and we will
refund the unused portion on a pro-rata basis. Minor changes (clarifications, typo fixes) may be
made with notice on this page.

## 11. Suspension and termination

We may suspend or close accounts used in breach of these terms (with notice and a chance to
respond, except where the breach is severe). Your rights to your information \u{2014} export, deletion
subject to legal retention \u{2014} survive account closure.

## 12. Complaints and disputes

Contact us first at **[SUPPORT EMAIL \u{2014} to be completed]** and we will respond within a reasonable
time. **[AFCA MEMBERSHIP DETAILS \u{2014} required once the AFSL is in place.]** These terms are governed
by the laws of **[STATE \u{2014} to be completed]**, Australia.
`
};
var $53b9787b76ac25b0$export$2e2bcd8739ae039 = $53b9787b76ac25b0$export$4aeb9bf2c158bdb6;


/**
 * Partner Terms — DRAFT prepared for lawyer review (research + open items in docs/legal/README.md).
 * B2B, but the unfair-contract-terms regime still applies (small-business standard-form contracts),
 * so one-sided clauses are avoided by design. The adviser-vs-accountant licensing split is the
 * clause a lawyer MUST settle: Part B (accountants under the owner's licensing arrangements) needs
 * a proper authorised-representative agreement, not just these software terms.
 * `version` must match server/src/legal/legalVersions.ts — bump both on material change.
 */ const $c2b3fd776fdb0155$export$212a19a9508b2718 = {
    key: 'partner_terms',
    version: '2026-07-09',
    title: "Partner Terms \u2014 Professional Firms",
    effectiveDate: '9 July 2026',
    draft: true,
    body: `
## 1. What these terms cover

These terms are an agreement between **[ENTITY NAME + ABN \u{2014} to be completed]** ("AgedCareWise",
"we") and the professional firm named at sign-up ("the firm", "you"). They licence your firm to
use the AgedCareWise platform to model and prepare aged-care and retirement-living advice for
**your firm's own clients**. The person accepting these terms confirms they are authorised to
bind the firm.

## 2. Your plan and fees (all prices exclude GST)

- **Annual practice plan:** $800 per year, including up to 20 activated clients, then $70 per
  additional activated client, prompted at the time you add each one.
- **Pay per client:** $336 per activated client, charged when you take each client on. No annual
  commitment; you may switch to the annual plan at any time.
- An "activated client" is a client file created in your workspace (entered by you or invited by
  link). Deleting a file does not refund or free the slot \u{2014} pricing is per client taken on.
- Fees are payable by card via Stripe. **Your clients never pay AgedCareWise** \u{2014} how you charge
  your clients for your advice service is entirely your affair, outside the platform.

## 3. Who is responsible for the advice \u{2014} the critical clause

**Part A \u{2014} firms holding their own AFSL (financial advisers).**
The platform is a software tool. All personal advice produced with it for your clients is
provided by **your firm under your own AFSL**. You are responsible for: the best-interests duty
and appropriateness of the advice; reviewing every Statement of Advice before it is given; your
own FSG and disclosure documents; and your own record-keeping obligations (the platform's
export and retention features assist, but the obligation is yours).

**Part B \u{2014} professionals who are not licensed to give financial advice** (accountants, solicitors,
aged-care and Support at Home providers, superannuation trustees and others).

**All personal advice produced with the platform for your clients is provided by AgedCareWise under
our own AFSL. It is not your advice.** You are not our authorised representative, and nothing in
these terms appoints you as one.

You may: introduce clients to the platform; collect and enter their information; and help them
understand what the outputs mean, in the way you would explain any financial document to a client.

**You must not hold yourself out as the provider of the advice**, or as licensed to give it, or as
acting under our licence. You must not recommend a strategy to a client as your own advice. Where a
client asks which option they should take, that is a question for AgedCareWise as the advice
provider.

Your clients are told who provides the advice when they first enter the platform, and every
Statement of Advice names AgedCareWise and our AFSL.

**[WORDING TO BE SETTLED WITH LAWYER. The structure above is the owner's settled position and
replaces an earlier draft that described this as an authorised-representative relationship \u{2014} it is
not one, and never was. What still needs legal settlement is the drafting: the precise boundary
between explaining an output and providing advice, how that is expressed to the professional, and
what the platform should do where it is crossed.]**

## 4. Your clients' information

- Your workspace and your clients' files are yours to direct. We host and protect them (Privacy
  Policy applies; data stored in Australia, encrypted, strict tenant isolation \u{2014} your firm can
  only ever see its own clients, and other firms can never see yours).
- You warrant that you have the authority and consents needed to enter your clients' personal
  information into the platform, and that you will tell them how it is handled (our Collection
  Notice text is available for your engagement documents).
- You can export client files at any time. If your plan lapses, your workspace becomes read-only
  with export available for **90 days**, and records the law requires to be retained (Statements
  of Advice) are retained per the Privacy Policy. We will cooperate with your record-keeping
  obligations after exit.
- If either of us suffers an eligible data breach involving your clients' information, we will
  notify the other promptly and cooperate on Notifiable Data Breaches obligations.

## 5. Fair use and restrictions

Seats are per named login; invite colleagues rather than sharing credentials (multi-factor
authentication is mandatory for firm logins). You may not resell, white-label or provide platform
access to third parties, or represent the platform's output as your own software. The AWise
assistant has a fair-use daily allowance per user.

## 6. Service, support and availability

We provide the platform with due care and skill and keep the modelling aligned to current
Australian rules. We aim for high availability but do not promise uninterrupted service; planned
maintenance will be scheduled considerately. We will not make changes that materially degrade the
service you have paid for without the notice in clause 8.

## 7. Liability (business terms)

Nothing in these terms excludes rights that cannot lawfully be excluded. Subject to that: our
liability for a failure of the service is limited to resupplying the service or paying the cost
of resupply; neither of us is liable to the other for indirect or consequential loss; and your
liability for your clients' advice outcomes sits where clause 3 puts it. **[LAWYER TO SETTLE \u{2014}
including the cap's interaction with the ASIC Act implied warranties.]**

## 8. Changes

We may update these terms with at least **30 days' written notice** for material changes, taking
effect at your next renewal (annual plan) or 30 days after notice (pay-per-client). If a material
change disadvantages your firm, you may terminate before it takes effect and receive a pro-rata
refund of any unused annual fee. We will ask an authorised person to accept updated terms in the
portal.

## 9. Term and termination

Pay-per-client arrangements continue until you stop adding clients or either of us ends the
arrangement on notice. Annual plans run for 12 months and do not auto-renew without an authorised
person confirming renewal. Either party may terminate for material breach that is not remedied
within 14 days of notice. Clauses about client data, records, liability and disputes survive.

## 10. Complaints, disputes, law

Talk to us first at **[SUPPORT EMAIL \u{2014} to be completed]**. These terms are governed by the laws
of **[STATE \u{2014} to be completed]**, Australia.
`
};
var $c2b3fd776fdb0155$export$2e2bcd8739ae039 = $c2b3fd776fdb0155$export$212a19a9508b2718;


/**
 * Privacy Policy — DRAFT for lawyer review. Client-facing text only.
 *
 * REVISED 29 Sep 2026 (owner review). Three changes of principle:
 *
 *   1. NO INTERNAL NOTES IN THE CLIENT TEXT. The 16 Sep draft carried bracketed notes addressed to
 *      the lawyer, the owner and the engineer ("[LAWYER: confirm …]") inside the body, and the
 *      body is rendered verbatim, so every client who opened the policy read them. All of them now
 *      live in docs/legal/README.md ("Open items moved out of the client-facing text").
 *   2. PROVIDERS BY ROLE AND COUNTRY, NOT BY NAME. APP 1.4(f)–(g) requires us to say whether we are
 *      likely to disclose overseas and, if practicable, the countries — not to name vendors. Naming
 *      each supplier added nothing a client can act on, went stale whenever a supplier changed,
 *      and invited the reading that we endorse them. The internal register of named providers is
 *      in docs/legal/README.md.
 *   3. ONLY WHAT THE CODE DOES. A fact-check against the code on 29 Sep corrected: two-factor is
 *      required for firm staff and optional for individuals (not "all accounts"); firms are not
 *      asked for a phone number; sign-in throttling is per internet address; the data download
 *      covers account and planning information, not "everything"; the anonymous assistant counts
 *      by internet address; the storage city is not confirmed, so the policy says Australia; fonts
 *      and images loaded from third-party services were undisclosed; payments are not yet live.
 *
 * APP 1.4 structure: (a) kinds, (b) how collected and held, (c) purposes, (d) access and
 * correction, (e) complaints, (f)/(g) overseas disclosure and countries — plus sensitive
 * information (APP 3.3), collection from others (APP 5), direct marketing (APP 7), government
 * identifiers (APP 9), security and retention (APP 11), Notifiable Data Breaches, and the automated
 * decision-making statement (APP 1.7–1.9, from 10 December 2026).
 *
 * `version` must match server/src/shared/legal/legalVersions.ts.
 */ const $23065750a32ab3de$export$ecf6508459835aaf = {
    key: 'privacy_policy',
    version: '2026-10-15',
    title: 'Privacy Policy',
    effectiveDate: '15 October 2026',
    draft: true,
    body: `
## 1. About this policy

This policy explains how AgedCareWise ("we", "us") collects, holds, uses and discloses personal
information, and how you can access and correct it or make a complaint. We are bound by the
Privacy Act 1988 (Cth) and the Australian Privacy Principles.

It covers the AgedCareWise website and application, the AWise assistant, and our dealings with
the people who use them: individuals planning for themselves or a family member, the
professional firms that use AgedCareWise with their clients, and those firms' staff.

**Privacy contact:** privacy@agedcarewise.com.au. Write to us with any question, request or
complaint about privacy.

## 2. The kinds of personal information we collect and hold

**If you are planning for yourself or someone in your family:**

- **Identity and contact details:** name, email address, date of birth, sex (used only to apply
  the right life-expectancy tables) and, if you choose to give it, a preferred phone number. If
  someone is completing the profile on the person's behalf (for example under an enduring power
  of attorney), that person's name and relationship to them.
- **Household and living arrangements:** whether the plan is for one person or a couple, the
  partner's details, where each person lives now (own home, renting, with family, a retirement
  village, a granny-flat arrangement or residential care) and any related agreements.
- **Financial details:** the family home and other property, bank accounts, shares and
  investments, superannuation and pensions, annuities, trusts and companies, loans and other
  debts, income (including any government or veterans' payments), living expenses, gifts made,
  and insurance held.
- **Family and estate matters:** the number of children, family living arrangements and what the
  person would like to happen to their assets.
- **Care needs and health \u{2014} sensitive information:** a general rating of health (good, fair or
  poor), whether private health insurance is held, the outcome of an aged-care assessment and the
  level of care recommended, and the care and living goals being considered. We do not ask for
  medical conditions, diagnoses, medications or medical records. See section 4.
- **Plans and advice records:** the strategies modelled, the plans saved, and any Statement of
  Advice produced.

**If you work for a professional firm that uses AgedCareWise:** your name, work email address,
role, your firm's details (name, ABN and licence details where applicable) and your firm's
subscription records.

**Everyone with an account:** email address and password (stored only in a form that cannot be
reversed), two-factor authentication settings, sign-in and security events, the date, time,
internet (IP) address and browser type recorded when you accept our terms, a record of actions
taken in your account (an audit trail), payment records, your correspondence with us, and the
messages you send to the AWise assistant.

**We do not ask for government identifiers** such as a tax file number, Centrelink customer
reference number or Medicare number, and you should not enter them in free-text fields.

**Anonymous use.** You can try the AWise assistant on our website without an account. We do not
know who you are. To limit free use we keep a short-lived count of messages against your internet
address, and your message is sent to our AI service provider to produce the reply (section 6).

## 3. How we collect personal information

- **From you**, when you create an account, complete your profile, build plans, ask the AWise
  assistant a question, pay for the service or contact us \u{2014} including any financial document you
  choose to upload (such as a super, pension, bank or share statement) so that your profile can
  be drafted from it.
- **From someone else \u{2014} a professional firm that is helping you.** Where a firm has invited you, it may enter
  some or all of your details before you first sign in. When that happens we tell you the first
  time you open your planning link, and everything the firm entered is there for you to review
  and correct.
- **From a person acting for you**, such as an attorney or family member completing the profile
  on your behalf, who confirms they are authorised to do so.
- **Automatically**, as service data: sign-in events, security logs and the audit trail described
  in section 2. We do not use advertising or analytics trackers.
- **From our payment provider**, which tells us that a payment succeeded and gives us a reference.
  Card details go to the payment provider directly and never reach our systems.

If we receive personal information we did not ask for and could not lawfully have collected
ourselves, we destroy or de-identify it as soon as practicable.

## 4. Sensitive information (health)

Care-needs and health details are **sensitive information**. We ask only for a general picture:
how you would rate your health overall (good, fair or poor) and the outcome of any aged-care
assessment. We do not ask about specific medical conditions, diagnoses, medications or medical
records, and you do not need to give them to us.

We ask for these details for two reasons:

- **Your general health** helps us judge whether a strategy suits you. Some strategies tie money
  up or take many years to pay off, such as a lifetime annuity that returns little to your
  estate. When your general health suggests one of these may not suit you, we point that out, so
  you can weigh how much it matters to keep your money within easy reach. Your health rating does
  not change the figures in your plan.
- **Your aged-care assessment** sets the care you are approved for, which in turn sets the fees
  and government support that apply. We need it to model those costs.

We collect these details **only with your consent** and only for these purposes. You give that
consent by entering those details yourself, or by asking a firm or a person acting for you to
enter them. A firm that enters them tells us it has your consent to do so.

You may leave these fields blank. If you do, we make no assumption about your health, and the
modelling of care eligibility, care fees and related strategies will be limited or unavailable.
We do not use health information for any other purpose and do not disclose it except as set out
in section 6.

## 5. Why we collect, hold, use and disclose personal information

- **To provide the service you have asked for:** modelling your options, producing projections,
  strategy comparisons, plans and Statements of Advice, and answering your questions through the
  AWise assistant.
- **To run and secure your account:** signing you in, two-factor authentication, detecting and
  preventing unauthorised access, and keeping the audit trail.
- **To work with your professional firm**, where one has invited you, so that it can see and
  work on the file it is helping you with.
- **To take payment** and manage subscriptions.
- **To send service messages:** verification codes, password resets, invitations and \u{2014} where a
  firm has asked us to \u{2014} a reminder that a planning link is waiting. These are not marketing.
  We do not send text messages.
- **To meet our legal obligations**, including financial-services record-keeping and responding
  to lawful requests.
- **To supervise the advice we are responsible for.** Where AgedCareWise provides the advice, either
  directly or through a firm that is not itself licensed, people we authorise review advice records
  to check the quality of the advice and to handle complaints. Each review is recorded. We do not
  review the clients of firms that give advice under their own licence.
- **To improve the service**, using information in de-identified or aggregated form wherever
  possible, and to investigate and fix faults. To understand how the service is used, we count
  things such as the number of client files and Statements of Advice. For clients we advise under
  our own licence, we also keep a de-identified summary of each file: which goals were chosen,
  single or couple, an age band, and broad bands for home value, super, net wealth and living
  expenses. It holds no names, contact details, dates of birth or exact amounts, and we only ever
  look at groups of at least ten people.

**We do not sell personal information, use it for direct marketing, or share it with anyone for
advertising.** If we ever wish to send you marketing, we will ask first, and you will be able to
opt out at any time.

If you choose not to provide the information we ask for, we may be unable to create your
account, and any modelling will be incomplete or unavailable.

## 6. Who we disclose personal information to

- **Your professional firm.** If a firm invited you, its authorised staff see and work on your
  file. The firm is a separate organisation with its own obligations under the Privacy Act; its
  handling of your information is described in its own privacy policy.
- **A person acting for you**, where you or the law have authorised them.
- **Service providers who help us run AgedCareWise**, each of which receives only what it needs
  for its task and is bound to protect it:
  - **Email delivery** \u{2014} sends our service emails. It receives your email address and the
    message only.
  - **Payment processing** \u{2014} takes card payments when you pay for the service. Your card details
    go to it directly.
  - **AI service** \u{2014} generates the AWise assistant's replies. Your chat messages are sent to it
    for that purpose. If you ask the assistant about your own saved plan, we also send a short
    summary of that plan's figures \u{2014} such as the annual cost, Age Pension, cash flow and net worth
    by year \u{2014} but never your name, date of birth, contact details or the underlying profile.
    If you upload a financial document to pre-fill your profile, that document is sent to the AI
    service to draft the entries, which you then review before anything is saved. The AI service
    does not keep the document, and we do not store it either. Please cover or leave out any tax
    file number before uploading.
- **Regulators, courts and law-enforcement bodies** where the law requires or authorises it.
- **Our professional advisers** (lawyers, auditors) under a duty of confidentiality.
- **A purchaser of our business**, if the business or its assets are sold, with notice to you.

## 7. Overseas disclosure

Your profile, plans, advice records and account are held on servers in Australia. Some of the
service providers above are located, or process information, outside Australia: the AI service,
payment processing and email delivery. The countries where these
recipients are likely to be located are the **United States** and **Japan**. Before disclosing
personal information to an overseas recipient we take reasonable steps, including contractual
terms, to ensure it handles the information consistently with the Australian Privacy Principles.

## 8. How we hold and protect personal information

Your profile, plans and advice records are **stored in Australia**. Personal and financial
details are encrypted before they are stored, on top of encryption of the storage itself. Each
firm's workspace is kept separate, so no firm can see another's clients.

Two-factor authentication with an authenticator app is **required for professional firm staff**
and **available to everyone else** \u{2014} we recommend you turn it on. Repeated sign-in attempts are
slowed or blocked, every significant action is written to a tamper-evident audit trail, and only
staff who need access for a specific task are given it. The system is independently
security-tested before it is launched for public use.

## 9. How long we keep it

- **While your account exists.** If your access ends, your information is kept, locked, so that
  you can return to it.
- **Advice we give you is kept for at least 7 years** as financial-services law requires, even
  if you close your account or ask us to delete your information. The advice record is each
  Statement of Advice we gave you and the information about you that it was based on. It is
  locked, used only to meet our legal obligations, and deleted when the period ends.
- **Advice a professional firm gives you** is the firm's record. The firm decides how long it is
  kept, and we keep or delete it on the firm's instructions.
- **Records of your acceptance of our terms, and the audit trail,** are kept for as long as we may
  need to show what was agreed and what was done.
- When information is no longer needed for any purpose for which it may be used or disclosed, and
  we are not required to keep it, we delete or de-identify it.

## 10. Automated decision-making

The Privacy Act requires us to say how computer programs use personal information to make, or
help make, decisions that could reasonably be expected to significantly affect your rights or
interests.

- **The kinds of personal information used:** the planning information described in section 2 \u{2014}
  your household, financial, family and estate details, and (with your consent) your care-needs
  and health details \u{2014} and your account security data.
- **Decisions made solely by a computer program:** our systems automatically slow or temporarily
  block sign-in attempts and requests that look like an attack (for example, repeated failed
  passwords). No other decision about you is made solely by a program.
- **Programs that do things substantially and directly related to making a decision:** our
  modelling engine produces projections, ranks strategies and generates any Statement of Advice
  from the information you enter. These outputs are the substance of the service and can
  significantly influence the decisions you make. Where a professional firm advises you, its
  adviser reviews the outputs with you. The AWise assistant provides general and educational
  answers only and makes no decision about you.

You can ask us how any of these outputs was produced, and you can correct the information they
were produced from at any time.

## 11. Access and correction

- **Access:** download a copy of your account details and your planning information from your
  account settings at any time. For anything else we hold about you \u{2014} such as your terms
  acceptances, security records or assistant conversations \u{2014} ask us at
  privacy@agedcarewise.com.au. We may need to verify your identity first.
- **Correction:** most planning details you can correct yourself in the app. For anything else,
  ask us and we will correct it, or tell you in writing why we will not and how to complain.
- **Deletion:** request deletion from your account settings or by email, and we will action it
  within 30 days.
  - If we have never given you a Statement of Advice, we delete all of your information.
  - If we have, we keep the advice record described in section 9 and delete everything else:
    your sign-in and security details, your assistant conversations, plans and scenarios that
    did not form part of the advice, and contact details we no longer need. We will tell you
    what we have kept and when it will be deleted.
  - If a professional firm advises you, your file is part of the firm's records. Ask the firm
    first; if you ask us, we will pass your request to the firm. We delete a firm's client file
    when the firm instructs us to.

We respond to access and correction requests within 30 days and do not charge for them.

## 12. Complaints

Write to privacy@agedcarewise.com.au. We will acknowledge your complaint promptly, investigate,
and respond within 30 days. If you are not satisfied with our response you may complain to the
**Office of the Australian Information Commissioner** (oaic.gov.au, 1300 363 992).

## 13. Data breaches

If a data breach is likely to result in serious harm to you, we will notify you and the Office of
the Australian Information Commissioner promptly under the Notifiable Data Breaches scheme, tell
you what happened and what information was involved, and give you clear recommended steps.

## 14. Website, cookies and browser storage

We do not use advertising or analytics cookies. Your browser stores a sign-in token and a few
preferences (for example, a dismissed notice) so the application works; these are not shared
with anyone. Our servers keep standard technical logs, including internet addresses, for
security.

## 15. Changes to this policy

We will post updates here with a new version date. For material changes we will ask you to
acknowledge the updated policy when you next sign in.
`
};
var $23065750a32ab3de$export$2e2bcd8739ae039 = $23065750a32ab3de$export$ecf6508459835aaf;


/**
 * Privacy Collection Notice — DRAFT for lawyer review. Client-facing text only.
 *
 * APP 5 requires that, at or before the time we collect personal information (or as soon as
 * practicable after), we take reasonable steps to make the individual aware of the APP 5.2
 * matters. This is the short-form notice shown at the points of collection — account sign-up,
 * the first screen of the client profile (which is also the first thing a client invited by a
 * firm sees), and partner onboarding — with the full Privacy Policy one click away.
 *
 * REVISED 29 Sep 2026 alongside the Privacy Policy: no internal notes in the client text, service
 * providers described by role and country rather than by name, and the countries stated without
 * a bracketed condition. See the policy's header and docs/legal/README.md.
 *
 * It is a NOTICE, not an agreement: it is not part of the clickwrap acceptance ledger and has no
 * server-side version. It shares the LegalDoc shape so LegalDocModal can render it.
 *
 * APP 5.2 matters and where each is covered:
 *   (a) identity and contact details            — "Who is collecting it"
 *   (b) collection from someone else            — "If someone else entered your details"
 *   (c) collection required/authorised by law   — "What the law requires us to keep"
 *   (d) purposes                                — "Why we collect it"
 *   (e) consequences if not collected           — "If you leave things out"
 *   (f) who we usually disclose to              — "Who sees it"
 *   (g) the policy covers access/correction     — "Your rights"
 *   (h) the policy covers complaints            — "Your rights"
 *   (i)/(j) overseas disclosure and countries   — "Who sees it"
 */ const $296111d41e630adc$export$8f93e283f379672f = {
    key: 'collection_notice',
    version: '2026-10-15',
    title: 'How we handle your information',
    effectiveDate: '15 October 2026',
    draft: true,
    body: `
## Who is collecting it

AgedCareWise. Privacy contact: privacy@agedcarewise.com.au.

## Why we collect it

To model your options and produce your plans and any Statement of Advice; to run and secure
your account; to work with the professional firm helping you, if there is one; to take payment;
and to meet our legal obligations. We do not sell your information or use it for advertising.

## What we collect

Your contact details, your household and living arrangements, your finances, your family and
estate wishes, and \u{2014} only with your consent \u{2014} your care needs and health details. For health we
ask only for a general rating (good, fair or poor) and the outcome of any aged-care assessment,
never specific medical conditions or records. Health details are sensitive information. Your
general health helps us flag strategies that tie money up for many years, and your assessment
lets us model care costs and government support. You can leave them blank. A phone number is
optional. If you upload a financial statement to pre-fill your profile, it is read by the AWise
assistant's AI service to draft the entries for your review; neither we nor the AI service keeps
the document. Cover or leave out any tax file number before uploading.

## If someone else entered your details

A professional firm that invited you, or a person acting for you (such as an attorney or family
member), may have entered some of your details before you first signed in. Everything they
entered is here for you to review and correct.

## If you leave things out

We may not be able to create your account, and any modelling will be incomplete or unavailable.

## Who sees it

Your professional firm, if one invited you. The service providers who help us run AgedCareWise:
email delivery, payment processing and the AWise assistant's AI service. Regulators or courts
where the law requires. These providers are overseas, most likely in the United States and Japan.
Your profile, plans and advice records are stored in Australia.

## What the law requires us to keep

If we give you a Statement of Advice, it and the information it was based on are kept for at
least 7 years under financial-services law, even if you close your account or ask us to delete
your information. If a professional firm advises you, the firm decides how long its records are
kept.

## Your rights

Our Privacy Policy explains how to access and correct your information, request deletion, and
make a complaint to us or to the Office of the Australian Information Commissioner.
`
};
var $296111d41e630adc$export$2e2bcd8739ae039 = $296111d41e630adc$export$8f93e283f379672f;


const $ad6e10a1425a589d$export$6977204795a9b815 = {
    consumer_terms: (0, $53b9787b76ac25b0$export$4aeb9bf2c158bdb6),
    partner_terms: (0, $c2b3fd776fdb0155$export$212a19a9508b2718),
    privacy_policy: (0, $23065750a32ab3de$export$ecf6508459835aaf)
};


/**
 * CollectionNotice — the APP 5 short‑form privacy notice, shown at each point where personal
 * information is collected: account sign‑up, the first screen of the client profile (the first
 * thing a client invited by a firm sees) and partner onboarding.
 *
 * One line the reader cannot miss, and the full notice and the Privacy Policy each one click
 * away in the same reader the acceptance checkboxes use. Self‑contained so the three call sites
 * do not have to carry modal state of their own.
 */ 

var $acw62 = parcelRequire("acw62");

/**
 * LegalDocModal — full-screen reader for a legal document (terms / privacy policy), opened from
 * the acceptance checkboxes at signup and the partner wizard. Renders the markdown-lite body
 * from src/constants/legal/* (## headings, - bullets, **bold**, paragraphs). Read-only: the
 * accept action stays on the form underneath, per clickwrap best practice (terms readable
 * BEFORE the acceptance click).
 */ 
parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9a9bbf84fd0f8247$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 12h-5",
            key: "r7krc0"
        }
    ],
    [
        "path",
        {
            d: "M15 8h-5",
            key: "1khuty"
        }
    ],
    [
        "path",
        {
            d: "M19 17V5a2 2 0 0 0-2-2H4",
            key: "zz82l3"
        }
    ],
    [
        "path",
        {
            d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
            key: "1ph1d7"
        }
    ]
];
const $9a9bbf84fd0f8247$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("scroll-text", $9a9bbf84fd0f8247$export$3efd853dbb351e94);


/** Inline **bold** renderer. */ const $f1cc4e5852e6af25$var$Bold = ({ text: text })=>{
    const parts = String(text).split(/\*\*(.+?)\*\*/g);
    return parts.map((part, i)=>i % 2 === 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
            children: part
        }, i) : part);
};
function $f1cc4e5852e6af25$var$renderBody(body) {
    const blocks = [];
    let list = null;
    const flushList = ()=>{
        if (list) {
            blocks.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "my-3 ml-5 list-disc space-y-1.5",
                children: list.map((item, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        className: "text-sm leading-relaxed text-gray-700",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f1cc4e5852e6af25$var$Bold, {
                            text: item
                        })
                    }, i))
            }, `ul-${blocks.length}`));
            list = null;
        }
    };
    // Paragraphs are separated by blank lines; single newlines inside a block are soft wraps.
    for (const raw of String(body).split(/\n\s*\n/)){
        const block = raw.trim();
        if (!block) continue;
        if (block.startsWith('## ')) {
            flushList();
            blocks.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "mt-6 text-base font-bold text-slate-900",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f1cc4e5852e6af25$var$Bold, {
                    text: block.slice(3)
                })
            }, `h-${blocks.length}`));
            continue;
        }
        const lines = block.split('\n').map((l)=>l.trim());
        if (lines[0].startsWith('- ')) {
            // A bullet block: "- " starts an item; following lines without the marker are soft-wrapped
            // continuations of the current item.
            const items = [];
            for (const line of lines){
                if (line.startsWith('- ')) items.push(line.slice(2));
                else if (items.length) items[items.length - 1] += ` ${line}`;
            }
            list = (list || []).concat(items);
            flushList();
            continue;
        }
        flushList();
        blocks.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            className: "mt-3 text-sm leading-relaxed text-gray-700",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f1cc4e5852e6af25$var$Bold, {
                text: lines.join(' ')
            })
        }, `p-${blocks.length}`));
    }
    flushList();
    return blocks;
}
const $f1cc4e5852e6af25$var$LegalDocModal = ({ doc: doc, onClose: onClose })=>{
    if (!doc) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 z-[70] flex items-center justify-center bg-slate-900/60 p-4 backdrop-blur-sm",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex max-h-[85vh] w-full max-w-2xl flex-col overflow-hidden rounded-3xl bg-white shadow-2xl",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "relative shrink-0 overflow-hidden bg-gradient-to-br from-[#1a6fd4] to-[#17b8e0] px-6 py-5 text-white",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "pointer-events-none absolute -right-8 -top-10 h-32 w-32 rounded-full bg-white/10 blur-2xl"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "relative flex items-start justify-between gap-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex h-10 w-10 items-center justify-center rounded-xl bg-white/15 ring-1 ring-white/25",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a9bbf84fd0f8247$export$2e2bcd8739ae039), {
                                                size: 20
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                    className: "text-lg font-bold leading-tight",
                                                    children: doc.title
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-xs text-white/80",
                                                    children: [
                                                        "Version ",
                                                        doc.version,
                                                        " \xb7 Effective ",
                                                        doc.effectiveDate
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: onClose,
                                    "aria-label": "Close",
                                    className: "rounded-full p-1.5 text-white/80 transition hover:bg-white/15 hover:text-white",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                        size: 20
                                    })
                                })
                            ]
                        })
                    ]
                }),
                doc.draft && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "shrink-0 border-b border-slate-200 bg-white px-6 py-2 text-xs font-medium text-amber-700",
                    children: "Draft for review \u2014 this document is being finalised with our legal advisers."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-y-auto px-6 pb-8 pt-2",
                    children: $f1cc4e5852e6af25$var$renderBody(doc.body)
                })
            ]
        })
    });
};
var $f1cc4e5852e6af25$export$2e2bcd8739ae039 = $f1cc4e5852e6af25$var$LegalDocModal;




const $849c9b7caca39f06$var$LEAD = {
    signup: 'We collect the details you enter to run your account and build your plan. They are stored in Australia and never sold.',
    profile: "The details on the following screens are used only to model your options and produce your plan. Health details are optional and are used only with your consent. If a firm or family member invited you, they may have entered some details already \u2014 please check them.",
    partner: "We collect your name, work contact details and your firm\u2019s details to run your firm\u2019s workspace and billing."
};
const $849c9b7caca39f06$var$linkClass = 'font-semibold text-blue-600 underline decoration-blue-300 underline-offset-2 hover:text-blue-700';
const $849c9b7caca39f06$var$CollectionNotice = ({ variant: variant, className: className = '' })=>{
    const [viewDoc, setViewDoc] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                role: "note",
                "data-testid": `collection-notice-${variant}`,
                className: `flex items-start gap-2.5 rounded-xl border border-blue-100 bg-blue-50/60 px-3.5 py-3 text-xs leading-relaxed text-gray-700 ${className}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                        size: 15,
                        className: "mt-0.5 shrink-0 text-blue-500",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            $849c9b7caca39f06$var$LEAD[variant],
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setViewDoc((0, $296111d41e630adc$export$8f93e283f379672f)),
                                className: $849c9b7caca39f06$var$linkClass,
                                children: "How we handle your information"
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setViewDoc((0, $23065750a32ab3de$export$ecf6508459835aaf)),
                                className: $849c9b7caca39f06$var$linkClass,
                                children: "Privacy Policy"
                            })
                        ]
                    })
                ]
            }),
            viewDoc && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1cc4e5852e6af25$export$2e2bcd8739ae039), {
                doc: viewDoc,
                onClose: ()=>setViewDoc(null)
            })
        ]
    });
};
var $849c9b7caca39f06$export$2e2bcd8739ae039 = $849c9b7caca39f06$var$CollectionNotice;




const $32ebf447c4b68a2b$var$DRAFT_KEY = 'awisePartnerWizardDraft';
/** The "other" professions, in the order they are offered. 'adviser' has its own card. */ const $32ebf447c4b68a2b$var$OTHER_PROFESSIONS = [
    'accountant',
    'solicitor',
    'aged_care_provider',
    'support_at_home_provider',
    'super_fund',
    'other'
].map((key)=>({
        key: key,
        label: (0, $442533e192804693$export$b59df854b6295776)[key] === 'Other professional' ? 'Something else' : (0, $442533e192804693$export$b59df854b6295776)[key]
    }));
function $32ebf447c4b68a2b$export$9dd6f4410f0ac0c8() {
    try {
        const raw = localStorage.getItem($32ebf447c4b68a2b$var$DRAFT_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch  {
        return null;
    }
}
function $32ebf447c4b68a2b$export$93c6d857426f1fc7() {
    localStorage.removeItem($32ebf447c4b68a2b$var$DRAFT_KEY);
}
const $32ebf447c4b68a2b$var$inputClass = 'w-full rounded-xl border border-gray-200 bg-gray-50/70 px-3.5 py-2.5 text-gray-900 placeholder-gray-400 shadow-sm transition focus:bg-white focus:border-blue-400 focus:ring-2 focus:ring-blue-500/40 focus:outline-none';
const $32ebf447c4b68a2b$var$primaryBtn = 'inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-[#1a6fd4] to-[#17b8e0] px-6 py-2.5 font-semibold text-white shadow-lg shadow-blue-600/25 transition hover:shadow-xl hover:brightness-[1.04] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none';
const $32ebf447c4b68a2b$var$backBtn = 'text-sm text-gray-500 hover:text-gray-700 flex items-center gap-1';
const $32ebf447c4b68a2b$var$STEPS = [
    'About you',
    'Licensing',
    'Your login',
    'Finish'
];
/** The second step asks an adviser firm about its licence, and tells every other firm who gives the advice. */ const $32ebf447c4b68a2b$var$STEPS_NO_LICENCE = [
    'About you',
    'Who gives the advice',
    'Your login',
    'Finish'
];
/*
 * How the advice reaches the client, which is NOT the same question as "are you licensed?".
 *
 * For an advice firm the second question is always yes and tells you nothing. The three answers
 * below differ in which entities the advice document must name — one, two or three of them — and a
 * firm that has not answered cannot produce a compliant Statement of Advice.
 */ const $32ebf447c4b68a2b$var$ADVICE_STRUCTURES = [
    {
        value: 'own_afsl',
        title: 'Under our own AFSL',
        detail: 'The practice is the licensee.'
    },
    {
        value: 'corporate_ar',
        title: 'Through our practice, as a corporate authorised representative',
        detail: 'The practice is authorised by a licensee.'
    },
    {
        value: 'individual_ar',
        title: 'By me personally, as an authorised representative',
        detail: 'Authorised by a licensee, with no practice company.'
    }
];
const $32ebf447c4b68a2b$var$PartnerOnboardingWizard = ({ onClose: onClose, onComplete: onComplete })=>{
    const draft = $32ebf447c4b68a2b$export$9dd6f4410f0ac0c8() || {};
    const [step, setStep] = (0, $acw62.useState)(draft.step || 0);
    const [firmName, setFirmName] = (0, $acw62.useState)(draft.firmName || '');
    const [firstName, setFirstName] = (0, $acw62.useState)(draft.firstName || '');
    const [lastName, setLastName] = (0, $acw62.useState)(draft.lastName || '');
    const [profession, setProfession] = (0, $acw62.useState)(draft.profession || null);
    // Derived from a saved draft so a returning person sees the right card lit.
    const [firmKind, setFirmKind] = (0, $acw62.useState)(draft.profession ? draft.profession === 'adviser' ? 'adviser' : 'other' : null);
    const stepTitles = firmKind === 'other' ? $32ebf447c4b68a2b$var$STEPS_NO_LICENCE : $32ebf447c4b68a2b$var$STEPS;
    const [afslLicenseeName, setAfslLicenseeName] = (0, $acw62.useState)(draft.afslLicenseeName || '');
    const [afslNumber, setAfslNumber] = (0, $acw62.useState)(draft.afslNumber || '');
    const [adviceStructure, setAdviceStructure] = (0, $acw62.useState)(draft.adviceStructure || null);
    const [carName, setCarName] = (0, $acw62.useState)(draft.carName || '');
    const [carNumber, setCarNumber] = (0, $acw62.useState)(draft.carNumber || '');
    const [adviserNumber, setAdviserNumber] = (0, $acw62.useState)(draft.adviserNumber || '');
    const [acknowledged, setAcknowledged] = (0, $acw62.useState)(draft.acknowledged || false);
    const [agreedPartnerTerms, setAgreedPartnerTerms] = (0, $acw62.useState)(false); // firm-level clickwrap, ticked at the Finish step
    const [viewDoc, setViewDoc] = (0, $acw62.useState)(null); // legal document open in the reader
    const [email, setEmail] = (0, $acw62.useState)('');
    const [password, setPassword] = (0, $acw62.useState)('');
    const [haveAccount, setHaveAccount] = (0, $acw62.useState)(false);
    // Single-screen email confirmation: after sign-up we show a code box right here (no link, no
    // second tab), mirroring the client flow.
    const [awaitingCode, setAwaitingCode] = (0, $acw62.useState)(false);
    /** The second sign-in step: held only between the password and the code, and never a session. */ const [awaitingMfa, setAwaitingMfa] = (0, $acw62.useState)(false);
    /*
   * A brand-new firm owner has to set up multi-factor authentication before they reach the portal. Not a
   * nicety: the moment their firm exists they are an adviser, and the client files, firm routes and
   * SOAs all refuse a password-only session — so "Open your portal" would land them somewhere that
   * says no to everything, with nothing on screen explaining why.
   */ const [settingUpMfa, setSettingUpMfa] = (0, $acw62.useState)(false);
    const [mfaToken, setMfaToken] = (0, $acw62.useState)('');
    const [code, setCode] = (0, $acw62.useState)('');
    const [signedInAs, setSignedInAs] = (0, $acw62.useState)(null);
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [notice, setNotice] = (0, $acw62.useState)(null);
    const [result, setResult] = (0, $acw62.useState)(null);
    // Keep a draft so wizard progress survives a page reload. (Email confirmation is now a
    // single-screen code — no second tab — so the legacy awaitingAuth resume path is dormant.)
    (0, $acw62.useEffect)(()=>{
        // Preserve the awaitingAuth marker until sign-in completes — overwriting it made the
        // email-confirmation tab treat a new PARTNER as a plain client (owner-reported bug).
        const prior = $32ebf447c4b68a2b$export$9dd6f4410f0ac0c8() || {};
        localStorage.setItem($32ebf447c4b68a2b$var$DRAFT_KEY, JSON.stringify({
            step: step,
            firmName: firmName,
            firstName: firstName,
            lastName: lastName,
            profession: profession,
            afslLicenseeName: afslLicenseeName,
            afslNumber: afslNumber,
            acknowledged: acknowledged,
            adviceStructure: adviceStructure,
            carName: carName,
            carNumber: carNumber,
            adviserNumber: adviserNumber,
            ...prior.awaitingAuth && !signedInAs ? {
                awaitingAuth: true
            } : {}
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        step,
        firmName,
        firstName,
        lastName,
        profession,
        afslLicenseeName,
        afslNumber,
        acknowledged,
        signedInAs,
        adviceStructure,
        carName,
        carNumber,
        adviserNumber
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $cc9e8a24185b91b0$export$a79e7ef8c396bb0e)().then((user)=>{
            setSignedInAs(user);
            // Skip the login step ONLY when genuinely resuming the email-confirmation round trip
            // (awaitingAuth draft). A leftover session from a previous visit must NOT be silently
            // adopted as the firm owner — the login step stays visible with a 'use a different email'
            // escape hatch (owner-reported: it grabbed a stale email with no way to change it).
            if (user && step === 2 && $32ebf447c4b68a2b$export$9dd6f4410f0ac0c8()?.awaitingAuth) setStep(3);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /** Escape hatch: sign out of the leftover/wrong account and enter a different one. */ const useDifferentAccount = async ()=>{
        setBusy(true);
        setNotice(null);
        try {
            await (0, $cc9e8a24185b91b0$export$b0ac3a1c242cb1ea)().catch(()=>{});
            setSignedInAs(null);
            setEmail('');
            setPassword('');
            setHaveAccount(false);
        } finally{
            setBusy(false);
        }
    };
    const noticeCard = notice && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-start gap-3 rounded-xl border border-gray-200 bg-white shadow-sm px-4 py-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: `mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full ${notice.tone === 'error' ? 'bg-red-100 text-red-600' : 'bg-emerald-100 text-emerald-600'}`,
                children: notice.tone === 'error' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                    size: 16
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                    size: 16
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-sm text-gray-700 leading-relaxed",
                children: notice.text
            })
        ]
    });
    const next = ()=>{
        setNotice(null);
        setStep((s)=>Math.min(s + 1, $32ebf447c4b68a2b$var$STEPS.length - 1));
    };
    const back = ()=>{
        setNotice(null);
        setStep((s)=>Math.max(s - 1, 0));
    };
    /** The authenticator step. The same box takes a recovery code, for someone without their phone. */ const handleMfaStep = async (e)=>{
        e.preventDefault();
        setBusy(true);
        setNotice(null);
        try {
            const res = await (0, $cc9e8a24185b91b0$export$e58ad95e33a8ebbd)(mfaToken, code.trim(), true);
            if (!res.ok) {
                setCode('');
                return setNotice({
                    tone: 'error',
                    text: res.message
                });
            }
            setAwaitingMfa(false);
            setMfaToken('');
            setCode('');
            setSignedInAs(await (0, $cc9e8a24185b91b0$export$a79e7ef8c396bb0e)());
            next();
        } finally{
            setBusy(false);
        }
    };
    const handleLoginStep = async (e)=>{
        e.preventDefault();
        setBusy(true);
        setNotice(null);
        try {
            if (signedInAs) {
                next();
                return;
            }
            if (haveAccount) {
                const res = await (0, $cc9e8a24185b91b0$export$9670d83f11d4b64a)(email.trim(), password);
                if (!res.ok) {
                    /*
           * Their password was right and their account already has an authenticator on it. Advisers
           * are required to, so this is the ordinary case for anyone returning here — and without
           * this branch they would be told to confirm an email they confirmed long ago.
           */ if ('mfaRequired' in res && res.mfaRequired) {
                        setMfaToken(res.mfaToken);
                        setCode('');
                        setAwaitingMfa(true);
                        return setNotice({
                            tone: 'success',
                            text: 'Enter the 6-digit code from your authenticator app to finish signing in.'
                        });
                    }
                    return setNotice({
                        tone: 'error',
                        text: 'message' in res ? res.message : 'Please confirm your email before signing in.'
                    });
                }
            } else {
                if (password.length < 10) return setNotice({
                    tone: 'error',
                    text: 'Please use a password of at least 10 characters.'
                });
                const res = await (0, $cc9e8a24185b91b0$export$cf64224bcd829024)(email.trim(), password);
                if (!res.ok) return setNotice({
                    tone: 'error',
                    text: res.message
                });
                if (res.needsEmailConfirm) {
                    // Stay right here and ask for the emailed code — no confirmation link, no second tab.
                    setCode('');
                    setAwaitingCode(true);
                    return setNotice({
                        tone: 'success',
                        text: `We've emailed a code to ${email.trim()}. Enter it below to confirm your email and continue \u{2014} check your junk folder if it's not there within a minute.`
                    });
                }
            }
            setSignedInAs(await (0, $cc9e8a24185b91b0$export$a79e7ef8c396bb0e)());
            next();
        } catch (err) {
            /*
       * The API could not be reached at all.
       *
       * signUp/signIn use fetch, which THROWS on a refused or failed connection rather than
       * returning a result — so without this branch the whole handler unwound silently and the
       * button appeared to do nothing at all. A person then retypes their password, tries a
       * different email, and concludes the product is broken, which is very nearly the right
       * conclusion and tells them nothing useful. Every other failure here already explains itself;
       * this was the one that did not.
       */ setNotice({
                tone: 'error',
                text: "We couldn't reach AgedCareWise just now. Check your connection and try again \u2014 nothing you've typed has been lost."
            });
            // eslint-disable-next-line no-console
            console.error('partner sign-up: the API call failed', err);
        } finally{
            setBusy(false);
        }
    };
    /** Closing mid-wizard destroys the typed details — never do that silently. */ const requestClose = async ()=>{
        if (!result && (step > 0 || firmName.trim() || profession)) {
            const sure = await (0, $8e1e84c918e07c84$export$71edf76f07903b9c)("Leave partner setup? The details you\u2019ve entered here will be cleared.");
            if (!sure) return;
        }
        onClose();
    };
    /** Confirm the emailed code (single screen), then move on to the trial step. */ const handleVerifyCode = async ()=>{
        setBusy(true);
        setNotice(null);
        try {
            const res = await (0, $cc9e8a24185b91b0$export$feab9165e44c6d62)(email.trim(), code);
            if (!res.ok) return setNotice({
                tone: 'error',
                text: "That code wasn't accepted \u2014 check the digits in your email and try again."
            });
            setAwaitingCode(false);
            setCode('');
            setSignedInAs(await (0, $cc9e8a24185b91b0$export$a79e7ef8c396bb0e)());
            next();
        } finally{
            setBusy(false);
        }
    };
    const handleResendCode = async ()=>{
        setBusy(true);
        setNotice(null);
        try {
            const res = await (0, $cc9e8a24185b91b0$export$bb28b2d3718a590f)(email.trim());
            if (!res.ok) return setNotice({
                tone: 'error',
                text: res.message || "Could not resend the code \u2014 please try again."
            });
            setNotice({
                tone: 'success',
                text: `A fresh code is on its way to ${email.trim()}.`
            });
        } finally{
            setBusy(false);
        }
    };
    const handleCreateFirm = async ()=>{
        setBusy(true);
        setNotice(null);
        try {
            // Bind the owner's name to their LOGIN — advice attribution derives from the account.
            await (0, $cc9e8a24185b91b0$export$ee515d2564ec047b)(firstName, lastName).catch(()=>{});
            const res = await (0, $442533e192804693$export$89efd5e1ca1c0c1f)({
                name: firmName.trim(),
                // Guaranteed non-null here — the Continue button past step 0 is disabled (stepValid) until
                // profession is chosen.
                profession: profession,
                afslLicenseeName: afslLicenseeName.trim(),
                afslNumber: afslNumber.trim(),
                adviceStructure: adviceStructure,
                carName: carName.trim(),
                carNumber: carNumber.trim(),
                adviserNumber: adviserNumber.trim()
            });
            if (!res.ok) {
                // Each login can own only one firm — point the way out instead of a raw error.
                const friendly = /already own/i.test(res.message || '') ? `The account you're signed in as${signedInAs?.email ? ` (${signedInAs.email})` : ''} already runs a firm on AgedCareWise. Go Back to the login step and choose "Use a different email" to create another firm.` : res.message;
                return setNotice({
                    tone: 'error',
                    text: friendly
                });
            }
            $32ebf447c4b68a2b$export$93c6d857426f1fc7();
            // Record the firm's clickwrap acceptance on the server ledger (session is live here).
            // Fire-and-forget: a transient failure must not block onboarding.
            (0, $1124d5012b356e89$export$2fe2928877a2a98)([
                'partner_terms',
                'privacy_policy'
            ], 'partner_onboarding').catch(()=>{});
            setResult(res);
        } finally{
            setBusy(false);
        }
    };
    const stepValid = step === 0 && firmName.trim() && firstName.trim() && lastName.trim() && profession || // An adviser firm must say HOW its advice is provided, not merely that it is licensed: the
    // answer decides which entities an SOA names, and there is no safe default to guess.
    step === 1 && (profession === 'adviser' ? Boolean(adviceStructure) && Boolean(afslLicenseeName.trim()) : acknowledged) || step >= 2;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "fixed inset-0 z-[10000] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "w-full max-w-lg overflow-hidden rounded-3xl bg-white shadow-2xl ring-1 ring-black/5 max-h-[92vh] overflow-y-auto",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative overflow-hidden bg-gradient-to-br from-[#1a6fd4] to-[#17b8e0] px-6 pt-6 pb-6 text-white",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "pointer-events-none absolute -right-8 -top-10 h-32 w-32 rounded-full bg-white/10 blur-2xl"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: requestClose,
                                className: "absolute right-4 top-4 rounded-full p-1.5 text-white/80 transition hover:bg-white/15 hover:text-white",
                                "aria-label": "Close",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                    size: 18
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-3.5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/25 backdrop-blur",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $224502d93617e0e1$export$2e2bcd8739ae039), {
                                            className: "h-6 w-6"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                className: "text-xl font-bold leading-tight",
                                                children: "Become a partner"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-white/85",
                                                children: result ? 'All done' : `Step ${step + 1} of ${$32ebf447c4b68a2b$var$STEPS.length} \u{2014} ${stepTitles[step]}`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !result && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-4 flex gap-1.5",
                                children: stepTitles.map((s, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: `h-1.5 flex-1 rounded-full transition-colors ${i <= step ? 'bg-white' : 'bg-white/25'}`
                                    }, s))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-6 space-y-4",
                        children: [
                            noticeCard,
                            result && settingUpMfa ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $810a19cb10a15a4b$export$2e2bcd8739ae039), {
                                mandatory: true,
                                onDone: ()=>{
                                    setSettingUpMfa(false);
                                    onComplete(result);
                                }
                            }) : result ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-4 text-center py-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-emerald-100 text-emerald-600",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                            size: 30
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                        className: "text-lg font-bold text-gray-900",
                                        children: [
                                            firmName,
                                            " is live"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-600 leading-relaxed",
                                        children: "One last thing before you go in. Adviser accounts are protected by a code from your phone as well as a password \u2014 it takes about a minute, and you only do it once."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>setSettingUpMfa(true),
                                        className: `${$32ebf447c4b68a2b$var$primaryBtn} mx-auto`,
                                        children: [
                                            "Set up multi-factor authentication ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                size: 16
                                            })
                                        ]
                                    })
                                ]
                            }) : step === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "grid grid-cols-2 gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        htmlFor: "pw-first-name",
                                                        className: "block text-sm font-medium text-gray-700 mb-1",
                                                        children: "First name"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        id: "pw-first-name",
                                                        value: firstName,
                                                        onChange: (e)=>setFirstName(e.target.value),
                                                        className: $32ebf447c4b68a2b$var$inputClass,
                                                        placeholder: "e.g. Sam"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        htmlFor: "pw-last-name",
                                                        className: "block text-sm font-medium text-gray-700 mb-1",
                                                        children: "Surname"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        id: "pw-last-name",
                                                        value: lastName,
                                                        onChange: (e)=>setLastName(e.target.value),
                                                        className: $32ebf447c4b68a2b$var$inputClass,
                                                        placeholder: "e.g. Taylor"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: "pw-firm",
                                                className: "block text-sm font-medium text-gray-700 mb-1",
                                                children: "Firm name"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                id: "pw-firm",
                                                value: firmName,
                                                onChange: (e)=>setFirmName(e.target.value),
                                                className: $32ebf447c4b68a2b$var$inputClass,
                                                placeholder: "e.g. Taylor Advisory Pty Ltd"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "block text-sm font-medium text-gray-700 mb-2",
                                                children: "Which best describes your firm?"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "grid grid-cols-2 gap-3",
                                                children: [
                                                    {
                                                        key: 'adviser',
                                                        label: 'Licensed financial adviser',
                                                        hint: 'Your firm gives the advice under its own AFSL'
                                                    },
                                                    {
                                                        key: 'other',
                                                        label: 'Other professional',
                                                        hint: "AgedCareWise gives the advice \u2014 your firm refers clients"
                                                    }
                                                ].map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>{
                                                            // Picking "other" without saying which leaves the firm unnamed, and the step
                                                            // gate below holds until the dropdown is answered. Switching back to adviser
                                                            // drops whatever was chosen there — it would be a lie on an adviser's record.
                                                            setProfession(opt.key === 'adviser' ? 'adviser' : profession === 'adviser' || !profession ? null : profession);
                                                            setFirmKind(opt.key);
                                                        },
                                                        className: `text-left rounded-xl border-2 p-3 transition-colors ${firmKind === opt.key ? 'border-blue-600 bg-blue-50/60' : 'border-gray-200 hover:border-blue-300'}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-sm font-semibold text-gray-900",
                                                                children: opt.label
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-xs text-gray-500 mt-1 leading-snug",
                                                                children: opt.hint
                                                            })
                                                        ]
                                                    }, opt.key))
                                            }),
                                            firmKind === 'other' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mt-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        htmlFor: "wizard-profession",
                                                        className: "block text-sm font-medium text-gray-700 mb-1",
                                                        children: "Which profession?"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        id: "wizard-profession",
                                                        value: profession ?? '',
                                                        onChange: (e)=>setProfession(e.target.value || null),
                                                        className: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "",
                                                                children: "Choose one\u2026"
                                                            }),
                                                            $32ebf447c4b68a2b$var$OTHER_PROFESSIONS.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: opt.key,
                                                                    children: opt.label
                                                                }, opt.key))
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : step === 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "space-y-4",
                                children: profession === 'adviser' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-600 leading-relaxed",
                                            children: "Every Statement of Advice has to name the entities behind it. Which ones depends on how your advice reaches the client."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "space-y-2",
                                            children: $32ebf447c4b68a2b$var$ADVICE_STRUCTURES.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    onClick: ()=>setAdviceStructure(opt.value),
                                                    className: `w-full text-left rounded-xl border px-4 py-3 transition ${adviceStructure === opt.value ? 'border-[#1a6fd4] border-2 bg-blue-50/60' : 'border-gray-200 bg-white hover:border-gray-300'}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "block text-sm font-semibold text-gray-900",
                                                            children: opt.title
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "block text-xs text-gray-500 mt-0.5",
                                                            children: opt.detail
                                                        })
                                                    ]
                                                }, opt.value))
                                        }),
                                        adviceStructure && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "rounded-xl border-l-2 border-[#1a6fd4] bg-blue-50/40 px-4 py-3 space-y-4",
                                            children: [
                                                adviceStructure === 'corporate_ar' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "space-y-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-[10px] font-bold uppercase tracking-wider text-[#1a6fd4]",
                                                            children: "The practice"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    htmlFor: "pw-car-name",
                                                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                                                    children: "Practice (CAR) name"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    id: "pw-car-name",
                                                                    value: carName,
                                                                    onChange: (e)=>setCarName(e.target.value),
                                                                    className: $32ebf447c4b68a2b$var$inputClass,
                                                                    placeholder: "e.g. Taylor Advice Pty Ltd"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    htmlFor: "pw-car-number",
                                                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                                                    children: "CAR number"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    id: "pw-car-number",
                                                                    value: carNumber,
                                                                    onChange: (e)=>setCarNumber(e.target.value),
                                                                    className: $32ebf447c4b68a2b$var$inputClass,
                                                                    placeholder: "e.g. 234567"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "space-y-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-[10px] font-bold uppercase tracking-wider text-[#1a6fd4]",
                                                            children: adviceStructure === 'own_afsl' ? 'Your licence' : 'The licensee'
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    htmlFor: "pw-licensee",
                                                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                                                    children: adviceStructure === 'own_afsl' ? 'Licensee name' : 'Licensee'
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    id: "pw-licensee",
                                                                    value: afslLicenseeName,
                                                                    onChange: (e)=>setAfslLicenseeName(e.target.value),
                                                                    className: $32ebf447c4b68a2b$var$inputClass,
                                                                    placeholder: "e.g. Taylor Wealth Licensing Pty Ltd"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    htmlFor: "pw-afsl",
                                                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                                                    children: "AFSL number"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    id: "pw-afsl",
                                                                    value: afslNumber,
                                                                    onChange: (e)=>setAfslNumber(e.target.value),
                                                                    className: $32ebf447c4b68a2b$var$inputClass,
                                                                    placeholder: "e.g. 345678"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "space-y-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-[10px] font-bold uppercase tracking-wider text-[#1a6fd4]",
                                                            children: "You"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    htmlFor: "pw-adviser-no",
                                                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                                                    children: "Your ASIC adviser number"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    id: "pw-adviser-no",
                                                                    value: adviserNumber,
                                                                    onChange: (e)=>setAdviserNumber(e.target.value),
                                                                    className: $32ebf447c4b68a2b$var$inputClass,
                                                                    placeholder: "e.g. 123456"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "text-xs text-gray-500 mt-1 leading-relaxed",
                                                                    children: adviceStructure === 'own_afsl' ? 'Your number on the Financial Advisers Register. As an employee or director of your own licensee you are a representative of it, not an authorised representative, and your advice will not describe you as one.' : "Your number on the Financial Advisers Register \u2014 the same number as your authorised representative appointment."
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex items-start gap-3 rounded-xl border border-gray-200 bg-white shadow-sm px-4 py-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-blue-100 text-blue-600",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                                        size: 16
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "text-sm text-gray-700 leading-relaxed space-y-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            children: [
                                                                "Your firm doesn't need a financial-services licence to use AgedCareWise, because your firm isn't the one giving the advice. ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "AgedCareWise gives the advice, under its own AFSL"
                                                                }),
                                                                ", and every Statement of Advice says so."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: "Your firm's role is to refer clients and help them through the process. Your firm is not an authorised representative of AgedCareWise, and must not present itself to clients as the provider of the advice."
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            className: "flex items-start gap-3 text-sm text-gray-700 cursor-pointer",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: acknowledged,
                                                    onChange: (e)=>setAcknowledged(e.target.checked),
                                                    className: "mt-1 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                }),
                                                "I understand that AgedCareWise gives the advice under its own licence, and that my firm refers clients and does not give financial advice through AgedCareWise."
                                            ]
                                        })
                                    ]
                                })
                            }) : step === 2 ? signedInAs ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-start gap-3 rounded-xl border border-gray-200 bg-white shadow-sm px-4 py-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-600",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                                    size: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-sm text-gray-700",
                                                children: [
                                                    "You're signed in as ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: signedInAs.email
                                                    }),
                                                    " \u2014 this will be the firm owner's login."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: useDifferentAccount,
                                        disabled: busy,
                                        className: "text-sm text-blue-600 hover:underline",
                                        children: "Not you? Use a different email"
                                    })
                                ]
                            }) : awaitingMfa ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: handleMfaStep,
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-600",
                                        children: "Your password was right. Now enter the 6-digit code from your authenticator app."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        inputMode: "text",
                                        autoComplete: "one-time-code",
                                        maxLength: 20,
                                        value: code,
                                        autoFocus: true,
                                        onChange: (e)=>setCode(e.target.value),
                                        className: `${$32ebf447c4b68a2b$var$inputClass} text-center text-2xl font-mono tracking-[0.35em]`,
                                        placeholder: "000000",
                                        "aria-label": "Authentication code"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-xs text-gray-500",
                                        children: "Lost your phone? Enter one of your recovery codes here instead."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        disabled: busy,
                                        onClick: ()=>{
                                            setAwaitingMfa(false);
                                            setMfaToken('');
                                            setCode('');
                                            setNotice(null);
                                        },
                                        className: "text-sm text-blue-600 hover:underline",
                                        children: "Back"
                                    })
                                ]
                            }) : awaitingCode ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: (e)=>{
                                    e.preventDefault();
                                    handleVerifyCode();
                                },
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "Enter the code we emailed to ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: email
                                            }),
                                            ". It can take a minute to arrive \u2014 please check your junk or spam folder before asking for a new one."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        inputMode: "numeric",
                                        autoComplete: "one-time-code",
                                        maxLength: 10,
                                        value: code,
                                        autoFocus: true,
                                        onChange: (e)=>setCode(e.target.value.replace(/\D/g, '')),
                                        className: `${$32ebf447c4b68a2b$var$inputClass} text-center text-2xl font-mono tracking-[0.35em]`,
                                        placeholder: "Enter code"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: handleResendCode,
                                        disabled: busy,
                                        className: "text-sm text-gray-500 hover:text-gray-700",
                                        children: "Didn't get it? Resend the code"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: handleLoginStep,
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-600",
                                        children: "This login becomes the firm owner's account."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: "pw-email",
                                                className: "block text-sm font-medium text-gray-700 mb-1",
                                                children: "Work email"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                id: "pw-email",
                                                type: "email",
                                                required: true,
                                                autoComplete: "username",
                                                value: email,
                                                onChange: (e)=>setEmail(e.target.value),
                                                className: $32ebf447c4b68a2b$var$inputClass,
                                                placeholder: "you@yourfirm.com.au"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: "pw-password",
                                                className: "block text-sm font-medium text-gray-700 mb-1",
                                                children: "Password"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                id: "pw-password",
                                                type: "password",
                                                required: true,
                                                autoComplete: haveAccount ? 'current-password' : 'new-password',
                                                value: password,
                                                onChange: (e)=>setPassword(e.target.value),
                                                className: $32ebf447c4b68a2b$var$inputClass,
                                                placeholder: "At least 10 characters"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>setHaveAccount(!haveAccount),
                                        className: "text-sm text-blue-600 hover:underline flex items-center gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09365e579c2377bf$export$2e2bcd8739ae039), {
                                                size: 14
                                            }),
                                            " ",
                                            haveAccount ? 'New here? Create an account instead' : 'Already have an AgedCareWise login? Sign in instead'
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-600",
                                        children: "Quick check before we create your firm:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "rounded-xl border border-gray-200 divide-y divide-gray-100 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "px-4 py-2.5 flex justify-between gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-500",
                                                        children: "Firm"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-medium text-gray-900 text-right",
                                                        children: firmName
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "px-4 py-2.5 flex justify-between gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-500",
                                                        children: "Owner"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "font-medium text-gray-900 text-right",
                                                        children: [
                                                            `${firstName} ${lastName}`.trim(),
                                                            signedInAs ? ` (${signedInAs.email})` : ''
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "px-4 py-2.5 flex justify-between gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-500",
                                                        children: "Type"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-medium text-gray-900 text-right",
                                                        children: profession === 'adviser' ? 'Licensed financial adviser' : profession ? (0, $442533e192804693$export$b59df854b6295776)[profession] : "\u2014"
                                                    })
                                                ]
                                            }),
                                            profession === 'adviser' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "px-4 py-2.5 flex justify-between gap-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-gray-500",
                                                                children: "Licensee"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "font-medium text-gray-900 text-right",
                                                                children: [
                                                                    afslLicenseeName,
                                                                    afslNumber ? ` \xb7 AFSL ${afslNumber}` : ''
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    adviceStructure === 'corporate_ar' && (carName || carNumber) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "px-4 py-2.5 flex justify-between gap-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-gray-500",
                                                                children: "Practice (CAR)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "font-medium text-gray-900 text-right",
                                                                children: [
                                                                    carName,
                                                                    carNumber ? ` \xb7 CAR ${carNumber}` : ''
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    adviserNumber.trim() && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "px-4 py-2.5 flex justify-between gap-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-gray-500",
                                                                children: "Your adviser number"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-medium text-gray-900 text-right",
                                                                children: adviserNumber.trim()
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "px-4 py-2.5 flex justify-between gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-gray-500",
                                                        children: "Advice given by"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-medium text-gray-900 text-right",
                                                        children: "AgedCareWise, under its AFSL"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "flex cursor-pointer items-start gap-2.5 rounded-xl border border-gray-200 bg-gray-50/70 px-3.5 py-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: agreedPartnerTerms,
                                                onChange: (e)=>setAgreedPartnerTerms(e.target.checked),
                                                className: "mt-0.5 h-4 w-4 shrink-0 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "text-xs leading-relaxed text-gray-600",
                                                children: [
                                                    "I have authority to agree to these terms for ",
                                                    firmName.trim() || 'this firm',
                                                    ", and on its behalf I have read and agree to the",
                                                    ' ',
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>setViewDoc((0, $c2b3fd776fdb0155$export$212a19a9508b2718)),
                                                        className: "font-semibold text-blue-600 underline decoration-blue-300 underline-offset-2 hover:text-blue-700",
                                                        children: "Partner Terms"
                                                    }),
                                                    ' ',
                                                    "and the",
                                                    ' ',
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>setViewDoc((0, $23065750a32ab3de$export$ecf6508459835aaf)),
                                                        className: "font-semibold text-blue-600 underline decoration-blue-300 underline-offset-2 hover:text-blue-700",
                                                        children: "Privacy Policy"
                                                    }),
                                                    "."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $849c9b7caca39f06$export$2e2bcd8739ae039), {
                                        variant: "partner",
                                        className: "mt-3"
                                    })
                                ]
                            }),
                            !result && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center justify-between pt-2",
                                children: [
                                    step > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: awaitingCode ? ()=>{
                                            setAwaitingCode(false);
                                            setNotice(null);
                                        } : back,
                                        disabled: busy,
                                        className: $32ebf447c4b68a2b$var$backBtn,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                                size: 14
                                            }),
                                            " Back"
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                                    step === 2 ? awaitingCode ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: handleVerifyCode,
                                        disabled: busy || code.length < 6,
                                        className: $32ebf447c4b68a2b$var$primaryBtn,
                                        children: [
                                            busy ? "Checking\u2026" : 'Confirm & continue',
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                size: 16
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: handleLoginStep,
                                        disabled: busy || !signedInAs && (!email || !password),
                                        className: $32ebf447c4b68a2b$var$primaryBtn,
                                        children: [
                                            busy ? "Working\u2026" : 'Continue',
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                size: 16
                                            })
                                        ]
                                    }) : step === $32ebf447c4b68a2b$var$STEPS.length - 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: handleCreateFirm,
                                        disabled: busy || !agreedPartnerTerms,
                                        className: $32ebf447c4b68a2b$var$primaryBtn,
                                        children: [
                                            busy ? "Creating\u2026" : 'Create my firm',
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                size: 16
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: next,
                                        disabled: !stepValid || busy,
                                        className: $32ebf447c4b68a2b$var$primaryBtn,
                                        children: [
                                            "Continue ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                size: 16
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            viewDoc && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1cc4e5852e6af25$export$2e2bcd8739ae039), {
                doc: viewDoc,
                onClose: ()=>setViewDoc(null)
            })
        ]
    });
};
var $32ebf447c4b68a2b$export$2e2bcd8739ae039 = $32ebf447c4b68a2b$var$PartnerOnboardingWizard;


/**
 * Billing calls (Stripe). SAFE-BY-DEFAULT: the server reports `billingConfigured:false` and
 * `hasAccess:true` until Stripe keys are live, so the paywall never appears while billing is off.
 * All requests carry the signed-in user's token; the server + Stripe webhooks are the real enforcement.
 */ 


function $9969e0eb851fd9fb$var$getApiBaseUrl() {
    // One source for this — see services/apiBase.ts for why eight copies was a problem.
    return (0, $4e54353814e6aea9$export$8ebae31efd30e025)();
}
async function $9969e0eb851fd9fb$var$authHeaders() {
    const token = await (0, $cc9e8a24185b91b0$export$84773cc9bf7dbe87)();
    if (!token) throw new Error('Not signed in');
    return {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
}
async function $9969e0eb851fd9fb$export$4de14aec71635fd2(tenantId) {
    try {
        const headers = await $9969e0eb851fd9fb$var$authHeaders();
        const url = `${$9969e0eb851fd9fb$var$getApiBaseUrl()}/rest/billing/entitlement${tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : ''}`;
        const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(url, {
            headers: headers,
            timeout: 30000
        });
        return res.data || {
            billingConfigured: false,
            hasAccess: true,
            entitlement: null
        };
    } catch  {
        return {
            billingConfigured: false,
            hasAccess: true,
            entitlement: null
        };
    }
}
async function $9969e0eb851fd9fb$export$8a258e6ffbcb9c95(tenantId) {
    try {
        const headers = await $9969e0eb851fd9fb$var$authHeaders();
        const url = `${$9969e0eb851fd9fb$var$getApiBaseUrl()}/rest/billing/partner-summary${tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : ''}`;
        const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(url, {
            headers: headers,
            timeout: 30000
        });
        return res.data || {
            billingConfigured: false,
            summary: null
        };
    } catch  {
        return {
            billingConfigured: false,
            summary: null
        };
    }
}
async function $9969e0eb851fd9fb$export$b439f56cc3105c(plan, tenantId) {
    const headers = await $9969e0eb851fd9fb$var$authHeaders();
    const body = tenantId ? {
        plan: plan,
        tenantId: tenantId
    } : {
        plan: plan
    };
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$9969e0eb851fd9fb$var$getApiBaseUrl()}/rest/billing/checkout`, body, {
        headers: headers,
        timeout: 30000
    });
    if (res.data?.url) {
        window.location.assign(res.data.url);
        return {
            ok: true
        };
    }
    return {
        ok: false,
        message: 'Could not start the payment page. Please try again.'
    };
}
async function $9969e0eb851fd9fb$export$f4dd4b2c29960b0f() {
    const headers = await $9969e0eb851fd9fb$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$9969e0eb851fd9fb$var$getApiBaseUrl()}/rest/billing/portal`, {}, {
        headers: headers,
        timeout: 30000
    });
    if (res.data?.url) window.location.assign(res.data.url);
}
function $9969e0eb851fd9fb$export$2b77153545a8e902() {
    try {
        const params = new URLSearchParams(window.location.search);
        const outcome = params.get('billing');
        if (!outcome) return null;
        params.delete('billing');
        const qs = params.toString();
        window.history.replaceState({}, '', window.location.pathname + (qs ? `?${qs}` : ''));
        return outcome; // 'success' | 'cancelled'
    } catch  {
        return null;
    }
}




var $acw62 = parcelRequire("acw62");





/**
 * FinancialSnapshot.js – summary card showing total assets, liabilities, net worth and expandable annual cash flow.
 * Used in Client Profile (steps 4, 5, 6). Props: factFind.
 */ 

var $acw62 = parcelRequire("acw62");




/**
 * Financial Snapshot breakdown for trusts/companies (display).
 * Engine uses structureAttribution.js (same apportionment and net-asset rules).
 */ 


const $1fc6d30d717f2177$var$PERSONAL_OWNERSHIP = new Set([
    'client',
    'partner',
    'joint'
]);
function $1fc6d30d717f2177$var$sumAssetValues(factFind) {
    let individually = 0;
    let individualLiquid = 0;
    const byEntityId = {};
    (factFind.structures || []).forEach((s)=>{
        byEntityId[s.id ?? ''] = {
            gross: 0,
            liquid: 0,
            liabilities: 0
        };
    });
    Object.entries(factFind.assets || {}).forEach(([type, assetList])=>{
        (assetList || []).forEach((asset)=>{
            const value = asset.value || 0;
            if (!value) return;
            const { ownership: ownership } = asset;
            if ((0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(ownership)) {
                const entityId = (0, $1773fcf9595c5c0a$export$6a61da9f052ec919)(ownership);
                if (entityId && entityId !== '__unsure__' && byEntityId[entityId]) {
                    byEntityId[entityId].gross += value;
                    if ((0, $3bf9a60a18bad06d$export$513b229c1d6f572a)(type)) byEntityId[entityId].liquid += value;
                }
            } else if (typeof ownership === 'string' && $1fc6d30d717f2177$var$PERSONAL_OWNERSHIP.has(ownership)) {
                individually += value;
                if ((0, $3bf9a60a18bad06d$export$513b229c1d6f572a)(type)) individualLiquid += value;
            }
        });
    });
    const home = factFind.home || {};
    const homeValue = home.value || 0;
    if (homeValue > 0) {
        if (home.ownership === 'other_entity' && home.entityId && home.entityId !== '__unsure__' && byEntityId[home.entityId]) byEntityId[home.entityId].gross += homeValue;
        else if (home.ownership !== 'other_entity') individually += homeValue;
    }
    // A retirement village interest is wealth like the home (8 Oct 2026): what the village would pay
    // back today. The same figure the server puts in net worth, so the card's total adds up to it.
    individually += (0, $4633117ee929ec27$export$27943b3c73c6c12b)(factFind);
    Object.values(factFind.liabilities || {}).forEach((list)=>{
        (list || []).forEach((item)=>{
            const balance = item.balance || 0;
            if (!balance) return;
            const entityId = (0, $3bf9a60a18bad06d$export$cdbab4fc15bcd079)(item, factFind);
            if (entityId && byEntityId[entityId]) byEntityId[entityId].liabilities += balance;
        });
    });
    return {
        individually: individually,
        individualLiquid: individualLiquid,
        byEntityId: byEntityId
    };
}
function $1fc6d30d717f2177$var$sumPersonalLiabilities(factFind) {
    let total = 0;
    Object.values(factFind.liabilities || {}).forEach((list)=>{
        (list || []).forEach((item)=>{
            if ((0, $3bf9a60a18bad06d$export$ec9081b12e34149d)(item, factFind)) return;
            total += item.balance || 0;
        });
    });
    return total;
}
function $1fc6d30d717f2177$export$ead9d5eee1e838cb(factFind, isPartnered = factFind.adviceFor === 'couple') {
    const structures = factFind.structures || [];
    const hasStructures = structures.length > 0 || factFind.structuresGateAnswer === true;
    const { individually: individually, individualLiquid: individualLiquid, byEntityId: byEntityId } = $1fc6d30d717f2177$var$sumAssetValues(factFind);
    const personalLiabilities = $1fc6d30d717f2177$var$sumPersonalLiabilities(factFind);
    const entityLines = structures.map((s)=>{
        const bucket = byEntityId[s.id ?? ''] || {
            gross: 0,
            liquid: 0,
            liabilities: 0
        };
        const netGross = Math.max(0, bucket.gross - bucket.liabilities);
        // DraftFactFind's structure entries are structurally compatible with ClientStructure
        // (see types/formDraft.ts); the helper does `Math.min/Math.max` arithmetic that coerces via
        // `|| 0` regardless, so this cast is safe either way.
        const combinedPct = (0, $1773fcf9595c5c0a$export$b93377b4473f408b)(s, isPartnered);
        const applicantsShare = netGross * (combinedPct / 100);
        const netLiquid = Math.max(0, bucket.liquid - bucket.liabilities);
        const applicantsLiquidShare = netLiquid * (combinedPct / 100);
        return {
            id: s.id ?? '',
            name: s.name?.trim() || 'Unnamed arrangement',
            grossTotal: bucket.gross,
            liabilitiesTotal: bucket.liabilities,
            netGross: netGross,
            applicantsShare: applicantsShare,
            applicantsLiquidShare: applicantsLiquidShare,
            combinedApportionmentPct: combinedPct
        };
    });
    const entityApplicantsTotal = entityLines.reduce((sum, line)=>sum + line.applicantsShare, 0);
    const entityLiquidTotal = entityLines.reduce((sum, line)=>sum + line.applicantsLiquidShare, 0);
    const totalAssets = individually + entityLines.reduce((sum, line)=>sum + line.grossTotal, 0);
    const totalLiabilities = personalLiabilities + entityLines.reduce((sum, line)=>sum + line.liabilitiesTotal, 0);
    const combinedNetWorth = individually + entityApplicantsTotal - personalLiabilities;
    const applicantsLiquidNet = Math.max(0, individualLiquid - personalLiabilities) + entityLiquidTotal;
    return {
        hasStructures: hasStructures,
        individually: individually,
        individualLiquid: individualLiquid,
        entityLines: entityLines,
        totalAssets: totalAssets,
        totalLiabilities: totalLiabilities,
        personalLiabilities: personalLiabilities,
        combinedNetWorth: combinedNetWorth,
        applicantsLiquidNet: applicantsLiquidNet
    };
}


/**
 * How the client's assets are split by kind — the data behind the Financial Snapshot's
 * composition bar.
 *
 * WHY IT ONLY EVER COVERS PERSONALLY-OWNED ASSETS. The bar sits directly under the card's
 * "Total Assets" figure, so it has to decompose exactly that number or it is a lie told in
 * colour. That figure comes from `computeStructureSnapshotBreakdown`, which counts personally
 * owned assets plus the home in one pool and apportions each trust/company separately. Rather
 * than try to reconcile against those apportioned entity lines, the caller hides the bar
 * entirely for clients who have structures — that card already shows a per-entity breakdown,
 * which is its own composition view. See FinancialSnapshot's `showStructureSplit`.
 *
 * The family home is INCLUDED, and usually dominates. That is the point: for most clients
 * approaching aged care, "nearly everything is in the house" is the fact that shapes every
 * funding conversation, and a bar that hid it would flatter the liquid position.
 */ 
/** Ownership values that mean "the applicants hold this themselves", per structureSnapshotUtils. */ const $8ace70fbd3d0fef0$var$PERSONAL_OWNERSHIP = new Set([
    'client',
    'partner',
    'joint'
]);
/**
 * Asset types grouped into the handful of kinds worth telling apart at a glance. Ordered
 * darkest-first so the bar reads as a ramp rather than a scatter of colours.
 */ const $8ace70fbd3d0fef0$var$GROUPS = [
    {
        id: 'home',
        label: 'Family home',
        color: '#001E7A',
        types: []
    },
    {
        id: 'village',
        label: 'Village unit (what comes back)',
        color: '#1E3A8A',
        types: []
    },
    {
        id: 'super',
        label: 'Super & pension',
        color: '#0F52E0',
        types: [
            'superannuation',
            'accountBasedPensions'
        ]
    },
    {
        id: 'shares',
        label: 'Shares, funds & bonds',
        color: '#0290F5',
        types: [
            'shares',
            'investmentBonds'
        ]
    },
    {
        id: 'property',
        label: 'Investment property',
        color: '#38bdf8',
        types: [
            'investmentProperty'
        ]
    },
    {
        id: 'cash',
        label: 'Cash & deposits',
        color: '#60a5fa',
        types: [
            'bankAccounts',
            'termDeposits'
        ]
    },
    {
        id: 'other',
        label: 'Other assets',
        color: '#2dd4bf',
        types: [
            'annuities',
            'funeralBonds',
            'prepaidFuneral',
            'loansToOthers',
            'personalAssets',
            'other'
        ]
    }
];
function $8ace70fbd3d0fef0$export$30a4fc7927c933c6(factFind) {
    if (!factFind) return [];
    const totals = {};
    // The home, unless it is held through a structure — the same carve-out the snapshot's own
    // total makes, so the two agree.
    const home = factFind.home || {};
    const homeValue = Number(home.value) || 0;
    if (homeValue > 0 && home.ownership !== 'other_entity') totals.home = homeValue;
    // A village interest at what the village would pay back today (8 Oct 2026) — the snapshot's
    // total carries it, so the bar must too or the two stop adding up.
    const village = (0, $4633117ee929ec27$export$27943b3c73c6c12b)(factFind);
    if (village > 0) totals.village = village;
    const groupOfType = new Map();
    $8ace70fbd3d0fef0$var$GROUPS.forEach((g)=>g.types.forEach((t)=>groupOfType.set(t, g.id)));
    Object.entries(factFind.assets || {}).forEach(([type, assetList])=>{
        const groupId = groupOfType.get(type);
        if (!groupId) return;
        (assetList || []).forEach((asset)=>{
            const value = Number(asset?.value) || 0;
            if (!value) return;
            if (!$8ace70fbd3d0fef0$var$PERSONAL_OWNERSHIP.has(String(asset?.ownership))) return;
            totals[groupId] = (totals[groupId] || 0) + value;
        });
    });
    const total = Object.values(totals).reduce((sum, v)=>sum + v, 0);
    if (total <= 0) return [];
    return $8ace70fbd3d0fef0$var$GROUPS.filter((g)=>(totals[g.id] || 0) > 0).map((g)=>({
            id: g.id,
            label: g.label,
            amount: totals[g.id],
            pct: Math.round(totals[g.id] / total * 1000) / 10,
            color: g.color
        })).sort((a, b)=>b.amount - a.amount);
}
/** Colours for the slices an entity's share adds — a violet ramp so they read apart from the personal kinds. */ const $8ace70fbd3d0fef0$var$ENTITY_COLORS = [
    '#7c3aed',
    '#a78bfa',
    '#c4b5fd',
    '#8b5cf6'
];
function $8ace70fbd3d0fef0$export$75dab62b39043c71(slices, entityLines) {
    const extra = entityLines.filter((line)=>line.applicantsShare > 0).map((line, i)=>({
            id: `entity-${line.id}`,
            label: `Via ${line.name} (their share)`,
            amount: line.applicantsShare,
            pct: 0,
            color: $8ace70fbd3d0fef0$var$ENTITY_COLORS[i % $8ace70fbd3d0fef0$var$ENTITY_COLORS.length]
        }));
    const all = [
        ...slices,
        ...extra
    ];
    const total = all.reduce((sum, sl)=>sum + sl.amount, 0);
    if (total <= 0) return [];
    return all.map((sl)=>({
            ...sl,
            pct: Math.round(sl.amount / total * 1000) / 10
        })).sort((a, b)=>b.amount - a.amount);
}


const $82fb9e3eb31d73a3$var$buildStructuresFootnote = (possessive)=>`Trust and company lines show ${possessive} share of that arrangement (the percentages above), net of any debts recorded against it. Age Pension, tax, and care fee estimates use the same split.`;
const $82fb9e3eb31d73a3$var$EMPTY_FINANCIALS = {
    cashFlow: 0,
    cashFlowBreakdown: [],
    taxBreakdown: [],
    socialSecurityBreakdown: [],
    netWorth: 0
};
const $82fb9e3eb31d73a3$var$FinancialSnapshot = ({ factFind: factFind, onNetWorthChange: onNetWorthChange })=>{
    const [isExpanded, setIsExpanded] = (0, $acw62.useState)(false);
    // The composition legend opens by default, unlike the cash flow row below it. Collapsed, that
    // row still shows a meaningful number; a coloured bar with no labels shows nothing at all, so
    // it has to introduce itself once before it can be folded away.
    const [showComposition, setShowComposition] = (0, $acw62.useState)(true);
    const [financials, setFinancials] = (0, $acw62.useState)($82fb9e3eb31d73a3$var$EMPTY_FINANCIALS);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        $55a1d8a64f1e5dfa$export$463f0620dd36e1f8(factFind).then((result)=>{
            if (!cancelled) setFinancials(result);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        factFind
    ]);
    const { cashFlow: cashFlow, cashFlowBreakdown: cashFlowBreakdown, taxBreakdown: taxBreakdown, socialSecurityBreakdown: socialSecurityBreakdown, netWorth: netWorth } = financials;
    const isPartnered = factFind.adviceFor === 'couple';
    // "Your share" vs "Bob & Sally's share" — see utils/applicantVoice.ts.
    const voice = (0, $acw62.useMemo)(()=>(0, $7af19dec1ba96a5f$export$5d44334005555b21)(factFind), [
        factFind
    ]);
    const structuresFootnote = $82fb9e3eb31d73a3$var$buildStructuresFootnote(voice.possessive);
    const structureBreakdown = (0, $acw62.useMemo)(()=>(0, $1fc6d30d717f2177$export$ead9d5eee1e838cb)(factFind, isPartnered), [
        factFind,
        isPartnered
    ]);
    const showStructureSplit = (factFind.structures || []).length > 0 || factFind.structuresGateAnswer === true;
    const displayNetWorth = showStructureSplit ? structureBreakdown.combinedNetWorth : netWorth;
    // With a trust or company on the file, each entity's share (the figure printed above it) is a
    // slice of its own beside what is owned individually, so the bar still adds up to the card's
    // total (owner, 16 Oct 2026: the bar used to vanish the moment a file had a trust).
    const composition = (0, $acw62.useMemo)(()=>showStructureSplit ? (0, $8ace70fbd3d0fef0$export$75dab62b39043c71)((0, $8ace70fbd3d0fef0$export$30a4fc7927c933c6)(factFind), structureBreakdown.entityLines) : (0, $8ace70fbd3d0fef0$export$30a4fc7927c933c6)(factFind), [
        factFind,
        showStructureSplit,
        structureBreakdown
    ]);
    (0, $acw62.useEffect)(()=>{
        onNetWorthChange?.(displayNetWorth);
    }, [
        displayNetWorth,
        onNetWorthChange
    ]);
    const { totalAssets: totalAssets, totalLiabilities: totalLiabilities } = structureBreakdown;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
        className: "bg-white/80 sticky top-8",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                className: "text-xl font-bold mb-4 flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33b542e8915cec79$export$2e2bcd8739ae039), {
                        className: "text-blue-500"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6288781efbc92679$export$2e2bcd8739ae039), {
                        children: "Financial Snapshot"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-4 text-sm",
                children: [
                    showStructureSplit ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "font-medium text-gray-600",
                                        children: "Owned individually"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "font-semibold text-gray-800",
                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(structureBreakdown.individually)
                                    })
                                ]
                            }),
                            structureBreakdown.entityLines.map((line)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex justify-between items-start gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "font-medium text-gray-600 truncate pr-2",
                                            children: [
                                                line.name,
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "block text-xs font-normal text-gray-500",
                                                    children: [
                                                        voice.Possessive,
                                                        " share (",
                                                        line.combinedApportionmentPct,
                                                        "%",
                                                        line.liabilitiesTotal > 0 ? ', net of debt' : '',
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-semibold text-gray-800 shrink-0",
                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(line.applicantsShare)
                                        })
                                    ]
                                }, line.id)),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-between items-center border-t border-gray-200 pt-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "font-medium text-gray-600",
                                        children: "Total assets"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "font-semibold text-lg text-gray-800",
                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(totalAssets)
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "font-medium text-gray-600",
                                children: "Total Assets"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "font-semibold text-lg text-gray-800",
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(totalAssets)
                            })
                        ]
                    }),
                    composition.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "rounded-xl bg-slate-50/70 p-3.5 -mt-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>setShowComposition((v)=>!v),
                                className: "w-full flex items-center justify-between gap-2 text-left",
                                "aria-expanded": showComposition,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-[11px] font-semibold uppercase tracking-wider text-gray-500",
                                        children: "Where it sits"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                        size: 14,
                                        className: `text-gray-400 transition-transform ${showComposition ? 'rotate-180' : ''}`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-2 flex h-2.5 rounded-full overflow-hidden bg-gray-200",
                                children: composition.map((slice)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            width: `${slice.pct}%`,
                                            backgroundColor: slice.color
                                        },
                                        title: `${slice.label} ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(slice.amount)}`
                                    }, slice.id))
                            }),
                            showComposition && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-3 flex flex-col gap-2",
                                children: composition.map((slice)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-2 text-xs",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "w-2 h-2 rounded-full shrink-0",
                                                style: {
                                                    backgroundColor: slice.color
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-gray-600 flex-grow truncate",
                                                children: slice.label
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-gray-800 font-semibold shrink-0 tabular-nums",
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(slice.amount)
                                            })
                                        ]
                                    }, slice.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "font-medium text-gray-600",
                                children: "Total Liabilities"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "font-semibold text-lg text-rose-500",
                                children: [
                                    "(",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(totalLiabilities),
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-between items-start border-t-2 border-gray-800 pt-3 mt-3 gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "font-bold text-gray-800 flex items-center gap-1",
                                children: [
                                    "Estimated net worth",
                                    showStructureSplit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                        text: structuresFootnote
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6288781efbc92679$export$2e2bcd8739ae039), {
                                className: "font-extrabold text-2xl shrink-0",
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(displayNetWorth)
                            })
                        ]
                    }),
                    showStructureSplit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-gray-500 leading-snug",
                        children: structuresFootnote
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-6 pt-4 border-t border-dashed",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-between items-center cursor-pointer",
                                onClick: ()=>setIsExpanded(!isExpanded),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "font-medium text-gray-600 flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                                                size: 16
                                            }),
                                            " Est. Annual Cash Flow"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: `font-semibold text-lg ${cashFlow >= 0 ? 'text-green-600' : 'text-rose-600'}`,
                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(cashFlow)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                        size: 16,
                                        className: `transition-transform ${isExpanded ? 'rotate-180' : ''}`
                                    })
                                ]
                            }),
                            isExpanded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-2 pl-4 pr-2 py-2 bg-gray-50 rounded-lg",
                                children: cashFlowBreakdown.map((item, idx)=>{
                                    let tooltipTitle = null;
                                    let tooltipData = null;
                                    if (item.label && item.label.includes('Age Pension')) {
                                        tooltipTitle = 'Age Pension Breakdown (estimate)';
                                        tooltipData = socialSecurityBreakdown && socialSecurityBreakdown.length > 0 ? socialSecurityBreakdown : [
                                            {
                                                label: 'No Age Pension payable or not eligible.',
                                                value: ''
                                            }
                                        ];
                                    } else if (item.label && item.label.includes('Tax')) {
                                        tooltipTitle = 'Tax Breakdown (estimate)';
                                        tooltipData = taxBreakdown && taxBreakdown.length > 0 ? taxBreakdown : [
                                            {
                                                label: 'No tax payable.',
                                                value: ''
                                            }
                                        ];
                                    }
                                    // A `note` row explains the figures rather than being one of them, so
                                    // it is styled apart: no green/red, and set off by a rule above. Money
                                    // the client is taxed on but never receives must not read like income.
                                    const isNote = item.note === true;
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: `flex justify-between items-center text-xs py-1 rounded px-1 ${isNote ? 'mt-1 pt-2 border-t border-gray-200 italic' : 'hover:bg-gray-200/50'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center gap-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-gray-500",
                                                        children: item.label
                                                    }),
                                                    tooltipTitle && tooltipData && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c0ea688f7c20200$export$2e2bcd8739ae039), {
                                                        title: tooltipTitle,
                                                        data: tooltipData,
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                                            size: 14,
                                                            className: "text-blue-400 cursor-help"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: `font-medium ${isNote ? 'text-gray-400' : Number(item.value) >= 0 ? 'text-green-600' : 'text-rose-500'}`,
                                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(item.value)
                                            })
                                        ]
                                    }, item.label ? item.label + idx : idx);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $82fb9e3eb31d73a3$export$2e2bcd8739ae039 = $82fb9e3eb31d73a3$var$FinancialSnapshot;


/**
 * Brings the client profile's right-hand column to phones and tablets.
 *
 * That column is laid out beside the form only from `xl` (1280px) up, so below that — every phone, and an iPad in portrait —
 * the Financial Snapshot and every explanatory card simply did not exist: a client could enter
 * $3.8M of assets and never be shown a total, and ticking a goal produced nothing on screen.
 * This renders the SAME content (passed as children, never a second copy of it) as a bar
 * pinned to the bottom, which opens into a sheet.
 *
 * TWO DETAILS THAT MATTER.
 *
 * The children are mounted whether or not the sheet is open — hidden with CSS, never unmounted —
 * because the Financial Snapshot computes as it renders and reports its figure back up for the
 * collapsed bar to display. Unmounting it would leave the bar with nothing to show until the
 * first tap, and re-running the calculation on every open.
 *
 * The bar stops short of the right edge (`right-[88px]`) instead of spanning the full width,
 * leaving the floating AWise button its corner. The bottom of a phone screen is contested — the
 * chat button, the card's own Back/Next row and this bar all want it — and sitting BESIDE the
 * button keeps everything in one bottom row rather than stacking three things up the screen.
 * See MainAppLayout's `pb-28`, which reserves that row.
 */ 

var $acw62 = parcelRequire("acw62");

const $4dc00328f6988b10$var$MobileInsightSheet = ({ title: title, value: value, children: children })=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "xl:hidden",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed bottom-4 left-4 right-[88px] z-20",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    type: "button",
                    onClick: ()=>setOpen(true),
                    "aria-expanded": open,
                    className: "w-full min-h-[56px] flex items-center justify-between gap-3 rounded-2xl border border-slate-200 bg-white px-4 py-2.5 shadow-cardlg text-left",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "min-w-0 flex-grow",
                            children: value ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "block text-[11px] font-semibold uppercase tracking-wider text-gray-500 truncate",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "block text-xl font-extrabold text-brand-navy ",
                                        children: value
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "block text-[15px] font-semibold text-gray-900 truncate",
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center shrink-0",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                                size: 18,
                                className: "text-brand-navy",
                                "aria-hidden": "true"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `fixed inset-0 z-[60] flex items-end transition-opacity duration-200 ${open ? 'opacity-100' : 'opacity-0 invisible pointer-events-none'}`,
                role: "dialog",
                "aria-modal": "true",
                "aria-label": title,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "absolute inset-0 bg-slate-900/40",
                        "aria-label": `Close ${title}`,
                        onClick: ()=>setOpen(false)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative w-full max-h-[85vh] overflow-y-auto bg-white rounded-t-2xl shadow-2xl px-4 pt-2 pb-8",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex justify-center pb-1",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "w-10 h-1 rounded-full bg-gray-300",
                                    "aria-hidden": "true"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex justify-end",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setOpen(false),
                                    className: "w-11 h-11 -mr-1 flex items-center justify-center rounded-full text-brand-navy hover:bg-slate-100",
                                    "aria-label": `Close ${title}`,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                        size: 22,
                                        "aria-hidden": "true"
                                    })
                                })
                            }),
                            children
                        ]
                    })
                ]
            })
        ]
    });
};
var $4dc00328f6988b10$export$2e2bcd8739ae039 = $4dc00328f6988b10$var$MobileInsightSheet;




parcelRequire("acw62");



const $3e9caa5eea6f6034$export$75cd8fded50e1042 = ({ title: title, text: text, icon: Icon, onLearnMore: onLearnMore })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
        className: "bg-white/80 sticky top-8",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                className: "text-xl font-bold mb-4 flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                        className: "text-blue-500"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6288781efbc92679$export$2e2bcd8739ae039), {
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-gray-600",
                children: text
            }),
            onLearnMore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-4 flex justify-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    onClick: onLearnMore,
                    className: "px-4 py-2 bg-white text-blue-600 border-2 border-blue-600 rounded-lg hover:bg-blue-50 transition-colors text-sm font-medium flex items-center gap-2",
                    children: [
                        "Learn more about your state's process ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                            size: 16
                        })
                    ]
                })
            })
        ]
    });
const $3e9caa5eea6f6034$export$1e91935c527436d3 = ({ personName: personName, levelData: levelData })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
        className: "bg-white/80",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                className: "text-lg font-bold mb-2 flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b634449cc961be6$export$2e2bcd8739ae039), {
                        className: "text-blue-500"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6288781efbc92679$export$2e2bcd8739ae039), {
                        children: [
                            personName,
                            "'s Approval"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-gray-800",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "font-semibold",
                        children: levelData.label
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-sm text-gray-600 mt-1",
                        children: [
                            "This provides a total annual budget of approximately ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-bold text-gray-700",
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(levelData.budget)
                            }),
                            ". This is a combination of the government subsidy and any contributions you may be asked to make."
                        ]
                    })
                ]
            })
        ]
    });





var $acw62 = parcelRequire("acw62");



/**
 * "How is this card usually paid?" — the credit card's repayment question (owner, 26 Oct 2026).
 *
 * A card has no term, so its repayment cannot be worked out, and a family member filling in the
 * profile rarely knows the figure. They usually do know HOW the card is paid, so that is what is asked;
 * the payment and the interest follow from it (shared/src/calculation/support/creditCards.ts, the same
 * rules the projection uses). Every answer, including "Not sure", gives a sensible figure — an empty
 * repayment box used to be modelled as a card that cost nothing.
 */ 
parcelRequire("acw62");



const $80fca1c0ceeabc40$var$OPTIONS = [
    {
        value: 'full',
        label: 'Paid off in full every month'
    },
    {
        value: 'minimum',
        label: 'Pays the minimum each month'
    },
    {
        value: 'fixed',
        label: 'Pays a set amount each month'
    },
    {
        value: 'unsure',
        label: 'Not sure'
    }
];
const $80fca1c0ceeabc40$var$money = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Math.round(n));
function $80fca1c0ceeabc40$export$53f02a826abcbf37(card) {
    const summary = (0, $55a6490f14a54563$export$eb26b844a1947c6e)(card);
    if (summary.style === 'full') return 'No interest: it is cleared each month, and the spending is already in the living costs.';
    if (!(Number(card.balance) > 0)) return null;
    if (summary.style === 'fixed' && !(summary.monthlyPayment > 0)) return null;
    if (summary.grows) return `At ${$80fca1c0ceeabc40$var$money(summary.monthlyPayment)} a month the balance keeps growing. The interest alone is about ${$80fca1c0ceeabc40$var$money(summary.monthlyInterest)} a month.`;
    if (summary.months == null) return null;
    const years = summary.months / 12;
    const when = summary.months < 12 ? `about ${summary.months} ${summary.months === 1 ? 'month' : 'months'}` : `about ${Math.round(years)} ${Math.round(years) === 1 ? 'year' : 'years'}`;
    const start = summary.style === 'fixed' ? `At ${$80fca1c0ceeabc40$var$money(summary.monthlyPayment)} a month` : `Paying the minimum (${$80fca1c0ceeabc40$var$money(summary.monthlyPayment)} this month, falling as the balance falls)`;
    return `${start}, this card is paid off in ${when} and costs about ${$80fca1c0ceeabc40$var$money(summary.totalInterest)} in interest.`;
}
const $80fca1c0ceeabc40$var$CardPaymentQuestion = ({ card: card, onChange: onChange })=>{
    const style = (0, $55a6490f14a54563$export$ee09c2c29b17798e)(card);
    const consequence = $80fca1c0ceeabc40$export$53f02a826abcbf37(card);
    const groupName = `card-payment-${card.id ?? 'new'}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "md:col-span-2",
        "data-testid": "card-payment-question",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "block text-sm font-medium text-gray-700 mb-2",
                children: "How is this card usually paid?"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid grid-cols-1 gap-2 sm:grid-cols-2",
                role: "radiogroup",
                "aria-label": "How is this card usually paid?",
                children: $80fca1c0ceeabc40$var$OPTIONS.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        className: `flex cursor-pointer items-center gap-2 rounded-lg border bg-white px-3 py-2.5 text-sm ${style === opt.value ? 'border-blue-600 text-slate-900' : 'border-slate-300 text-slate-700 hover:border-blue-300'}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "radio",
                                name: groupName,
                                value: opt.value,
                                checked: style === opt.value,
                                onChange: ()=>onChange('cardPaymentStyle', opt.value),
                                className: "h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500",
                                "data-testid": `card-payment-${opt.value}`
                            }),
                            opt.label
                        ]
                    }, opt.value))
            }),
            style === 'fixed' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-3 max-w-xs",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                    label: "How much each month",
                    name: "repayments",
                    id: `liability-repayments-${card.id}`,
                    value: card.repayments || '',
                    onChange: (v)=>onChange('repayments', v)
                })
            }),
            style === 'unsure' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-[13px] text-slate-600",
                children: "We'll use the usual minimum. It's the \"minimum payment\" line on the statement."
            }),
            style !== 'full' && (0, $55a6490f14a54563$export$134b96fa640de378)(card) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-2 text-[13px] text-slate-600",
                "data-testid": "card-typical-rate",
                children: [
                    "No interest rate entered, so we use ",
                    (0, $55a6490f14a54563$export$4f8392bee1006cb3),
                    '%, a typical card rate. It\'s the "purchase rate" on the statement.'
                ]
            }),
            consequence && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-[13px] font-medium text-slate-800",
                "data-testid": "card-consequence",
                children: consequence
            })
        ]
    });
};
var $80fca1c0ceeabc40$export$2e2bcd8739ae039 = $80fca1c0ceeabc40$var$CardPaymentQuestion;


/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f0cdbf97a5c8afc2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z",
            key: "1s6t7t"
        }
    ],
    [
        "circle",
        {
            cx: "16.5",
            cy: "7.5",
            r: ".5",
            fill: "currentColor",
            key: "w0ekpg"
        }
    ]
];
const $f0cdbf97a5c8afc2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("key-round", $f0cdbf97a5c8afc2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1d55a58c47e43a5b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
            key: "4alrt4"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
            key: "v07s0e"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "10",
            y1: "11",
            y2: "17",
            key: "1uufr5"
        }
    ],
    [
        "line",
        {
            x1: "14",
            x2: "14",
            y1: "11",
            y2: "17",
            key: "xtxkd"
        }
    ]
];
const $1d55a58c47e43a5b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("trash-2", $1d55a58c47e43a5b$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0d957a6b316cfc10$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m16 11 2 2 4-4",
            key: "9rsbq5"
        }
    ],
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ]
];
const $0d957a6b316cfc10$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("user-check", $0d957a6b316cfc10$export$3efd853dbb351e94);




/**
 * Shared factory for fact-find asset rows (manual Add and statement import).
 */ 
/**
 * Statement import — the rows an AI reader returns from a client's documents, normalised into the
 * profile's own asset fields (owner, 15 Oct 2026).
 *
 * The reader (server/src/shared/statementExtraction.ts) is asked for a LIST per upload: a portfolio
 * report with fourteen holdings is fourteen rows; a bank statement with three accounts is three. The
 * rules it is given and that this module enforces again:
 *   - a PRODUCT (a super fund, an account-based pension, an annuity, an investment bond, a wrap or
 *     platform account) is ONE row at its account total with the product's own fields — the
 *     investment options inside it are never rows;
 *   - directly held investments (a CHESS/registry statement, a spreadsheet of shares in the client's
 *     own name) are one row per holding, with cost base and date acquired;
 *   - subtotal and total lines are never rows;
 *   - a field the document does not show is left blank, never guessed.
 *
 * Nothing here touches the profile: the adviser ticks what to add, and `appendImportedAssetDrafts`
 * (frontend) builds the asset cards from the drafts. Pure functions, so every rule is testable
 * without a document or a provider.
 */ const $f99f3d62d96a104c$export$3fc5c6097384c571 = [
    'bankAccounts',
    'termDeposits',
    'shares',
    'investmentProperty',
    'investmentBonds',
    'superannuation',
    'accountBasedPensions',
    'annuities',
    'funeralBonds',
    'personalAssets',
    'loansToOthers'
];
const $f99f3d62d96a104c$export$f03e7e034bb84b9a = {
    bankAccounts: [
        'incomeRate'
    ],
    termDeposits: [
        'incomeRate',
        'maturityDate'
    ],
    shares: [
        'costBase',
        'acquiredOn',
        'incomeRate',
        'frankingCredit',
        'reinvest'
    ],
    investmentProperty: [
        'rent',
        'expenses',
        'costBase',
        'acquiredOn'
    ],
    investmentBonds: [
        'purchasePrice',
        'commencementDate'
    ],
    superannuation: [],
    accountBasedPensions: [
        'income',
        'commencementDate',
        'purchasePrice',
        'taxFree'
    ],
    annuities: [
        'annuityType',
        'purchasePrice',
        'commencementDate',
        'term',
        'income',
        'rcv',
        'indexed',
        'guaranteePeriodYears',
        'reversionPct',
        'fundingSource'
    ],
    funeralBonds: [
        'purchasePrice',
        'commencementDate'
    ],
    prepaidFuneral: [],
    loansToOthers: [
        'purchasePrice',
        'commencementDate',
        'incomeRate'
    ],
    personalAssets: [],
    other: []
};
const $f99f3d62d96a104c$var$ENTITY_TYPES = [
    'family_trust',
    'unit_trust',
    'private_company',
    'partnership',
    'other'
];
function $f99f3d62d96a104c$export$a4fb609be60b1ad7(raw) {
    const e = raw || null;
    const name = e ? $f99f3d62d96a104c$var$str(e.name) : null;
    if (!name) return null;
    const t = String(e.type || '').toLowerCase();
    const type = $f99f3d62d96a104c$var$ENTITY_TYPES.includes(t) ? t : /unit/.test(t) ? 'unit_trust' : /trust/.test(t) ? 'family_trust' : /compan|pty/.test(t) ? 'private_company' : /partner/.test(t) ? 'partnership' : 'other';
    return {
        name: name,
        type: type
    };
}
const $f99f3d62d96a104c$export$ef91d6fba951e810 = [
    'mortgages',
    'personalLoans',
    'creditCards',
    'reverseMortgages'
];
const $f99f3d62d96a104c$var$num = (v)=>{
    if (v == null || v === '') return null;
    const n = typeof v === 'number' ? v : parseFloat(String(v).replace(/[$,\s]/g, ''));
    return Number.isFinite(n) ? n : null;
};
const $f99f3d62d96a104c$var$str = (v)=>{
    if (typeof v !== 'string') return null;
    const t = v.trim();
    // "N/A", a dash, "none": the document's way of saying nothing.
    return t && !/^(n\/?a|none|nil|-|—|–)$/i.test(t) ? t : null;
};
/** A document's title is not an asset's name (owner, 15 Oct 2026: "Annual Member Statement" landed as the description). */ const $f99f3d62d96a104c$var$DOCUMENT_TITLE = /\b(statement|summary|schedule|report|letter|notice|confirmation|certificate)\b/i;
function $f99f3d62d96a104c$export$603cf890e1133f6b(row) {
    const provider = $f99f3d62d96a104c$var$str(row.provider);
    const product = $f99f3d62d96a104c$var$str(row.productName);
    const described = $f99f3d62d96a104c$var$str(row.description);
    if (provider && product) return product.toLowerCase().startsWith(provider.toLowerCase()) ? product : `${provider} \u{2014} ${product}`;
    if (provider) return described && !$f99f3d62d96a104c$var$DOCUMENT_TITLE.test(described) && described.toLowerCase() !== provider.toLowerCase() ? `${provider} \u{2014} ${described}` : provider;
    if (described && !$f99f3d62d96a104c$var$DOCUMENT_TITLE.test(described)) return described;
    // Only a document title to go on: no name, and the normaliser falls back to the type and file.
    return product || '';
}
const $f99f3d62d96a104c$var$bool = (v)=>typeof v === 'boolean' ? v : v === 'true' ? true : v === 'false' ? false : null;
/** Whole-dollar payments per year for the frequencies a statement states. */ const $f99f3d62d96a104c$var$PER_YEAR = {
    weekly: 52,
    fortnightly: 26,
    monthly: 12,
    quarterly: 4,
    'half-yearly': 2,
    halfyearly: 2,
    annually: 1,
    yearly: 1,
    annual: 1
};
const $f99f3d62d96a104c$var$isoDate = (v)=>{
    const s = $f99f3d62d96a104c$var$str(v);
    if (!s) return null;
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) return s;
    const dmy = s.match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})$/);
    if (dmy) return `${dmy[3]}-${dmy[2].padStart(2, '0')}-${dmy[1].padStart(2, '0')}`;
    return null;
};
const $f99f3d62d96a104c$var$isoMonth = (v)=>{
    const s = $f99f3d62d96a104c$var$str(v);
    if (!s) return null;
    if (/^\d{4}-\d{2}$/.test(s)) return s;
    const d = $f99f3d62d96a104c$var$isoDate(s);
    if (d) return d.slice(0, 7);
    const my = s.match(/^(\d{1,2})[/-](\d{4})$/);
    return my ? `${my[2]}-${my[1].padStart(2, '0')}` : null;
};
/** Who a row belongs to, from the reader's answer and the household; 'client' with a flag where it did not say. */ function $f99f3d62d96a104c$var$ownershipOf(row, household, flags) {
    const o = (row.ownership || '').toLowerCase();
    if (o === 'joint') return household.isCouple ? 'joint' : 'client';
    if (o === 'partner') return household.isCouple ? 'partner' : 'client';
    if (o === 'client') return 'client';
    const name = (row.ownerName || '').toLowerCase();
    const first = (s)=>(s || '').toLowerCase().split(/\s+/)[0] || '';
    if (name && household.isCouple && first(household.partnerName) && name.includes(first(household.partnerName))) return 'partner';
    if (name && first(household.clientName) && name.includes(first(household.clientName))) return 'client';
    flags.push("owner not shown \u2014 set to the client");
    return 'client';
}
/** The type's fields the reader filled, in the profile's names and units. */ function $f99f3d62d96a104c$var$fieldsOf(type, row) {
    const f = row.fields || {};
    const out = {};
    const wanted = new Set($f99f3d62d96a104c$export$f03e7e034bb84b9a[type]);
    const put = (key, v)=>{
        if (wanted.has(key) && v != null) out[key] = v;
    };
    put('purchasePrice', $f99f3d62d96a104c$var$num(f.purchasePrice));
    put('costBase', $f99f3d62d96a104c$var$num(f.costBase));
    put('acquiredOn', $f99f3d62d96a104c$var$isoMonth(f.acquiredOn));
    put('rent', $f99f3d62d96a104c$var$num(f.rent));
    put('expenses', $f99f3d62d96a104c$var$num(f.expenses));
    put('incomeRate', $f99f3d62d96a104c$var$num(f.incomeRate));
    put('frankingCredit', $f99f3d62d96a104c$var$num(f.frankingCredit));
    put('reinvest', $f99f3d62d96a104c$var$bool(f.reinvest));
    put('maturityDate', $f99f3d62d96a104c$var$isoDate(f.maturityDate));
    put('taxFree', $f99f3d62d96a104c$var$num(f.taxFreePart ?? f.taxFree));
    put('rcv', $f99f3d62d96a104c$var$num(f.rcv ?? f.residualCapitalValue));
    put('indexed', $f99f3d62d96a104c$var$bool(f.indexed));
    put('guaranteePeriodYears', $f99f3d62d96a104c$var$num(f.guaranteePeriodYears));
    put('reversionPct', $f99f3d62d96a104c$var$num(f.reversionPct));
    put('term', $f99f3d62d96a104c$var$num(f.term));
    const commencement = $f99f3d62d96a104c$var$isoDate(f.commencementDate);
    if (commencement) {
        put('commencementDate', commencement);
        // The profile's own switch for the 1 January 2015 income-stream rule.
        if (type === 'accountBasedPensions') out.commencementDateOption = commencement >= '2015-01-01' ? 'post-2015' : 'pre-2015';
    }
    // A payment stated per period becomes the annual figure the profile holds. A schedule often prints
    // the ANNUAL income with the frequency it is paid beside it; multiplied up, $28,882 "fortnightly"
    // became $750,932 on a $412,600 pension (15 Oct 2026). A per-period amount that would exceed half
    // the balance (or purchase price) each year cannot be per period, so it is taken as annual.
    const annual = $f99f3d62d96a104c$var$num(f.annualIncome);
    const perPayment = $f99f3d62d96a104c$var$num(f.paymentAmount);
    const perYear = $f99f3d62d96a104c$var$PER_YEAR[String(f.paymentFrequency || '').toLowerCase()] ?? null;
    if (annual != null) put('income', annual);
    else if (perPayment != null && perYear != null) {
        const base = Math.max($f99f3d62d96a104c$var$num(row.value) ?? 0, $f99f3d62d96a104c$var$num(f.purchasePrice) ?? 0);
        const implausible = base > 0 && perPayment * perYear > base * 0.5;
        put('income', Math.round(implausible ? perPayment : perPayment * perYear));
    } else if (perPayment != null) put('income', Math.round(perPayment));
    const at = String(f.annuityType || '').toLowerCase();
    if (at === 'lifetime' || at === 'fixed_term') put('annuityType', at);
    else if (/fixed|term/.test(at)) put('annuityType', 'fixed_term');
    else if (/life/.test(at)) put('annuityType', 'lifetime');
    const fs = String(f.fundingSource || '').toLowerCase();
    if (fs === 'super' || fs === 'ordinary') put('fundingSource', fs);
    else if (/super/.test(fs)) put('fundingSource', 'super');
    else if (/ordinary|non-super|personal/.test(fs)) put('fundingSource', 'ordinary');
    return out;
}
let $f99f3d62d96a104c$var$seq = 0;
const $f99f3d62d96a104c$var$nextId = ()=>`import-${Date.now().toString(36)}-${$f99f3d62d96a104c$var$seq += 1}`;
function $f99f3d62d96a104c$export$18c835cc9577204e(rows, household, fallbackFile = 'statement') {
    const out = [];
    for (const row of rows || []){
        const description = $f99f3d62d96a104c$export$603cf890e1133f6b(row);
        const value = $f99f3d62d96a104c$var$num(row.value);
        if (!description && value == null) continue;
        if (/^(sub)?total\b|\btotal (portfolio|assets|balance|value)\b/i.test(description)) continue;
        // The family home is not an asset row: it fills the value on Living Arrangements, and only where
        // nothing is recorded there yet (owner, 16 Oct 2026 — never a duplicate, never an overwrite).
        if (String(row.assetType) === 'principalHome') {
            out.push({
                id: $f99f3d62d96a104c$var$nextId(),
                sourceFile: $f99f3d62d96a104c$var$str(row.sourceFile) || fallbackFile,
                kind: 'home',
                assetTypeId: null,
                description: `Family home${description ? ` \u{2014} ${description.replace(/^family home\s*[—-]?\s*/i, '')}` : ''}`,
                value: value == null ? '' : String(Math.round(value)),
                ownership: 'client',
                entity: null,
                confidence: row.confidence === 'high' || row.confidence === 'medium' || row.confidence === 'low' ? row.confidence : 'low',
                selected: value != null,
                fields: {},
                fieldsFound: 0,
                fieldsAsked: 0,
                flags: [],
                notes: $f99f3d62d96a104c$var$str(row.notes)
            });
            continue;
        }
        const flags = [];
        const type = $f99f3d62d96a104c$export$3fc5c6097384c571.includes(row.assetType) ? row.assetType : null;
        if (!type) flags.push("type unclear \u2014 add by hand if needed");
        const kindRaw = String(row.kind || '').toLowerCase();
        const kind = kindRaw === 'product' || kindRaw === 'direct_holding' ? kindRaw : 'unclear';
        const confidence = row.confidence === 'high' || row.confidence === 'medium' || row.confidence === 'low' ? row.confidence : 'low';
        // An entity's row is owned by the entity; otherwise an owner is only worth flagging on a row that can be added.
        // Money the person lent TO an entity is their own asset — the entity named on it is the borrower, not the holder.
        const entity = type === 'loansToOthers' ? null : $f99f3d62d96a104c$export$a4fb609be60b1ad7(row.entity);
        const ownerFlags = [];
        const ownership = entity ? 'client' : $f99f3d62d96a104c$var$ownershipOf(row, household, ownerFlags);
        if (type && !entity) flags.push(...ownerFlags);
        const fields = type ? $f99f3d62d96a104c$var$fieldsOf(type, row) : {};
        const asked = type ? $f99f3d62d96a104c$export$f03e7e034bb84b9a[type].length : 0;
        const found = Object.keys(fields).filter((k)=>k !== 'commencementDateOption').length;
        out.push({
            id: $f99f3d62d96a104c$var$nextId(),
            sourceFile: $f99f3d62d96a104c$var$str(row.sourceFile) || fallbackFile,
            kind: kind,
            assetTypeId: type,
            description: description || `${type ?? 'Asset'} from ${$f99f3d62d96a104c$var$str(row.sourceFile) || fallbackFile}`,
            value: value == null ? '' : String(Math.round(value)),
            ownership: ownership,
            entity: entity,
            confidence: confidence,
            selected: !!type && value != null,
            fields: fields,
            fieldsFound: found,
            fieldsAsked: asked,
            flags: flags,
            notes: $f99f3d62d96a104c$var$str(row.notes)
        });
    }
    return out;
}
function $f99f3d62d96a104c$export$e422eb33bf8eaa34(assets, home) {
    const out = {};
    // The home as recorded on Living Arrangements, so an imported home value is offered only where that is blank.
    const homeValue = $f99f3d62d96a104c$var$num(home?.value);
    if (homeValue != null && homeValue > 0) out.__home = [
        {
            description: 'home',
            value: homeValue
        }
    ];
    for (const [type, list] of Object.entries(assets || {})){
        if (!Array.isArray(list)) continue;
        out[type] = list.map((a)=>{
            const row = a || {};
            return {
                description: typeof row.description === 'string' ? row.description : '',
                value: $f99f3d62d96a104c$var$num(row.value)
            };
        });
    }
    return out;
}
function $f99f3d62d96a104c$export$872276b09c1e6972(drafts, assets) {
    const norm = (s)=>String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    return drafts.map((d)=>{
        if (d.kind === 'home') {
            const recorded = $f99f3d62d96a104c$var$num(assets?.__home?.[0]?.value);
            return recorded != null && recorded > 0 ? {
                ...d,
                selected: false,
                flags: [
                    ...d.flags,
                    `already recorded on Living Arrangements (${new Intl.NumberFormat('en-AU', {
                        style: 'currency',
                        currency: 'AUD',
                        maximumFractionDigits: 0
                    }).format(recorded)})`
                ]
            } : {
                ...d,
                flags: [
                    ...d.flags,
                    'fills the home value on Living Arrangements'
                ]
            };
        }
        if (!d.assetTypeId) return d;
        const existing = assets?.[d.assetTypeId] || [];
        const value = $f99f3d62d96a104c$var$num(d.value);
        const dup = existing.some((a)=>{
            const sameValue = value != null && $f99f3d62d96a104c$var$num(a.value) != null && Math.abs($f99f3d62d96a104c$var$num(a.value) - value) < 1;
            const sameName = norm(a.description) !== '' && norm(a.description) === norm(d.description);
            return sameName || sameValue && norm(a.description).includes(norm(d.description).slice(0, 6));
        });
        return dup ? {
            ...d,
            selected: false,
            flags: [
                ...d.flags,
                'looks like it is already on the profile'
            ]
        } : d;
    });
}
function $f99f3d62d96a104c$export$c62600a0332fc418(drafts) {
    const rows = drafts.filter((d)=>d.selected && d.assetTypeId);
    if (rows.length < 2) return null;
    const type = rows[0].assetTypeId;
    const owner = rows[0].ownership;
    if (rows.some((d)=>d.assetTypeId !== type || d.ownership !== owner || d.kind === 'product')) return null;
    const sum = (key)=>rows.reduce((t, d)=>t + ($f99f3d62d96a104c$var$num(d[key]) ?? 0), 0);
    const costBases = rows.map((d)=>$f99f3d62d96a104c$var$num(d.fields.costBase)).filter((v)=>v != null);
    const acquired = rows.map((d)=>d.fields.acquiredOn).filter((v)=>typeof v === 'string' && v !== '').sort();
    const fields = {};
    if (costBases.length === rows.length) fields.costBase = Math.round(costBases.reduce((a, b)=>a + b, 0));
    if (acquired.length) fields.acquiredOn = acquired[0];
    return {
        id: $f99f3d62d96a104c$var$nextId(),
        sourceFile: rows[0].sourceFile,
        kind: 'direct_holding',
        assetTypeId: type,
        description: rows.length <= 3 ? rows.map((d)=>d.description).join(', ') : `${rows[0].description} and ${rows.length - 1} other holdings`,
        value: String(Math.round(sum('value'))),
        ownership: owner,
        confidence: rows.every((d)=>d.confidence === 'high') ? 'high' : 'medium',
        selected: true,
        fields: fields,
        fieldsFound: Object.keys(fields).length,
        fieldsAsked: $f99f3d62d96a104c$export$f03e7e034bb84b9a[type].length,
        entity: rows[0].entity,
        flags: [],
        notes: `Combined from ${rows.length} holdings`
    };
}
const $f99f3d62d96a104c$var$LIABILITY_PER_YEAR = {
    weekly: 'weekly',
    fortnightly: 'fortnightly',
    monthly: 'monthly'
};
function $f99f3d62d96a104c$export$20d4588a7940f699(rows, household, fallbackFile = 'statement') {
    const out = [];
    for (const row of rows || []){
        const lender = $f99f3d62d96a104c$var$str(row.lender);
        const described = $f99f3d62d96a104c$var$str(row.description);
        const description = lender && described && !described.toLowerCase().startsWith(lender.toLowerCase()) ? `${lender} \u{2014} ${described}` : described || lender || '';
        const balance = $f99f3d62d96a104c$var$num(row.balance);
        if (!description && balance == null) continue;
        if (/^(sub)?total\b/i.test(description)) continue;
        const flags = [];
        const lt = String(row.liabilityType || '').toLowerCase();
        const liabilityTypeId = $f99f3d62d96a104c$export$ef91d6fba951e810.includes(lt) ? lt : /reverse/.test(lt) ? 'reverseMortgages' : /mortgage|home loan|investment loan|property/.test(lt) ? 'mortgages' : /card/.test(lt) ? 'creditCards' : /loan/.test(lt) ? 'personalLoans' : null;
        if (!liabilityTypeId) flags.push("type unclear \u2014 add by hand if needed");
        const entity = $f99f3d62d96a104c$export$a4fb609be60b1ad7(row.entity);
        const ownerFlags = [];
        const ownership = entity ? 'client' : $f99f3d62d96a104c$var$ownershipOf({
            ownerName: row.ownerName,
            ownership: row.ownership
        }, household, ownerFlags);
        if (liabilityTypeId && !entity) flags.push(...ownerFlags);
        const fields = {};
        const rate = $f99f3d62d96a104c$var$num(row.interestRate);
        if (rate != null) fields.interestRate = rate;
        const repayment = $f99f3d62d96a104c$var$num(row.repaymentAmount);
        const freq = $f99f3d62d96a104c$var$LIABILITY_PER_YEAR[String(row.repaymentFrequency || '').toLowerCase()];
        if (repayment != null) {
            fields.repayments = repayment;
            fields.repaymentCalculation = 'manual';
        }
        if (freq) fields.frequency = freq;
        const loanType = String(row.loanType || '').toLowerCase();
        if (loanType === 'io' || /interest only|interest-only/.test(loanType)) fields.loanType = 'io';
        else if (loanType === 'pi' || /principal/.test(loanType)) fields.loanType = 'pi';
        const term = $f99f3d62d96a104c$var$num(row.remainingTermYears);
        if (term != null) fields.loanTerm = term;
        const confidence = row.confidence === 'high' || row.confidence === 'medium' || row.confidence === 'low' ? row.confidence : 'low';
        out.push({
            id: $f99f3d62d96a104c$var$nextId(),
            sourceFile: $f99f3d62d96a104c$var$str(row.sourceFile) || fallbackFile,
            liabilityTypeId: liabilityTypeId,
            description: description || `${liabilityTypeId ?? 'Liability'} from ${$f99f3d62d96a104c$var$str(row.sourceFile) || fallbackFile}`,
            balance: balance == null ? '' : String(Math.round(balance)),
            ownership: ownership,
            entity: entity,
            confidence: confidence,
            selected: !!liabilityTypeId && balance != null,
            fields: fields,
            flags: flags,
            // "Secured against: Unsecured" is not a note.
            notes: [
                $f99f3d62d96a104c$var$str(row.securedAgainst) && !/^unsecured$/i.test($f99f3d62d96a104c$var$str(row.securedAgainst)) ? `Secured against ${$f99f3d62d96a104c$var$str(row.securedAgainst)}` : null,
                $f99f3d62d96a104c$var$str(row.notes)
            ].filter(Boolean).join('. ') || null
        });
    }
    return out;
}
function $f99f3d62d96a104c$export$a280f55013e4a912(name) {
    return String(name || '').toLowerCase().replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim().replace(/^the /, '');
}
function $f99f3d62d96a104c$export$d52fe623b94941f7(assets, liabilities) {
    const seen = new Map();
    [
        ...assets,
        ...liabilities
    ].forEach((d)=>{
        if (d.entity && d.selected) {
            const key = $f99f3d62d96a104c$export$a280f55013e4a912(d.entity.name);
            if (!seen.has(key)) seen.set(key, d.entity);
        }
    });
    return Array.from(seen.values());
}
function $f99f3d62d96a104c$export$fbfac0100852a861(id) {
    const labels = {
        mortgages: 'Mortgage / loan',
        personalLoans: 'Personal loan',
        creditCards: 'Credit card',
        reverseMortgages: 'Reverse mortgage'
    };
    return id ? labels[id] : "\u2014";
}
function $f99f3d62d96a104c$export$e31df1faac9ea30b(assetTypeId, kind) {
    if (kind === 'home') return "Family home \u2014 Living Arrangements";
    const labels = {
        bankAccounts: 'Bank account',
        termDeposits: 'Term deposit',
        shares: 'Shares / managed funds',
        investmentProperty: 'Investment property',
        investmentBonds: 'Investment bond',
        superannuation: 'Superannuation',
        accountBasedPensions: 'Account-based pension',
        annuities: 'Annuity',
        funeralBonds: 'Funeral bond',
        personalAssets: 'Personal asset',
        loansToOthers: 'Money lent to others'
    };
    return assetTypeId ? labels[assetTypeId] || assetTypeId : "\u2014";
}



/**
 * Client Profile — fact-find UI helpers for trust/company/partnership structures (form init +
 * validation). The calculation-relevant pieces (entity ownership encoding, apportionment math,
 * CLIENT_STRUCTURE_TYPES data) live server-side only now — see
 * shared/src/calculation/constants/clientStructureTypes.ts. These three stay here because
 * they're pure UI form concerns (new-structure defaults, live validation feedback) with no
 * calculation-engine equivalent.
 */ function $9a0fdbf41e16d1c8$export$df3bf4dd120d2017() {
    return crypto.randomUUID();
}
function $9a0fdbf41e16d1c8$export$6f799eb84f914055() {
    return {
        id: $9a0fdbf41e16d1c8$export$df3bf4dd120d2017(),
        name: '',
        type: 'family_trust',
        /** When annualDistributionPa set: true (default) = use for pension/care income test; false = cashflow only */ useDistributionForMeansTest: true,
        notes: ''
    };
}
function $9a0fdbf41e16d1c8$export$58e17024df23706b(structure, isPartnered) {
    const clientPct = structure.apportionmentClient || 0;
    const partnerPct = isPartnered ? structure.apportionmentPartner || 0 : 0;
    if (clientPct < 0 || clientPct > 100 || partnerPct < 0 || partnerPct > 100) return {
        valid: false,
        message: 'Each percentage must be between 0 and 100.'
    };
    if (isPartnered && clientPct + partnerPct > 100) return {
        valid: false,
        message: "These percentages can't add up to more than 100%. Check your Centrelink or accountant advice."
    };
    return {
        valid: true
    };
}


/**
 * Client-side identifier for a fact-find entity (an asset, liability, income item, capital expense,
 * or client structure). These ids exist only to tell one row from another within a profile's working
 * data — they are never database keys.
 *
 * A proper UUID, not a timestamp: the previous `Date.now()` scheme collided whenever two rows were
 * created in the same millisecond (e.g. importing several assets at once), which is why the import
 * path had to hand-roll an incrementing offset. `crypto.randomUUID()` removes the collision entirely.
 */ function $942f2f96766bf874$export$d3a77fab0baa99a2() {
    return crypto.randomUUID();
}



function $138d267475fbd696$export$5b0e102cd4dab698() {
    const ac = (0, $0f2c0a6799fe36da$export$b037eefb915b86ec);
    return {
        bankAccounts: {
            incomeRate: ac.bankIncomePct,
            growthRate: 0
        },
        termDeposits: {
            incomeRate: ac.termDepositIncomePct,
            growthRate: 0
        },
        shares: {
            incomeRate: ac.sharesIncomePct,
            growthRate: ac.sharesGrowthPct,
            frankingCredit: ac.sharesFrankingPct
        },
        // A bond's growth is the Balanced portfolio net of the life office's 30% tax; nothing is paid
        // out (its earnings stay inside), so incomeRate is 0 by design.
        investmentBonds: {
            incomeRate: 0,
            growthRate: (0, $0f2c0a6799fe36da$export$d4067a97c0e75560)('balanced')
        },
        investmentProperty: {
            incomeRate: ac.propertyYieldPct,
            growthRate: ac.propertyGrowthPct
        },
        // Super wrappers start on the published Balanced presets (investmentProfiles.ts) — the most
        // common fund default — visible and editable on the card, never a silent stamp. Their
        // incomeRate is 0 by design: nothing personal flows from inside the wrapper (an ABP's cash
        // is its pension payment, a separate field), and the old 4% here was dead weight.
        superannuation: {
            incomeRate: 0,
            growthRate: (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703).balanced.accumulationNetPct
        },
        accountBasedPensions: {
            incomeRate: 0,
            growthRate: (0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703).balanced.pensionNetPct
        },
        annuities: {
            incomeRate: 4,
            growthRate: 0
        },
        funeralBonds: {
            incomeRate: 0,
            growthRate: 0
        },
        // Neither grows: a prepaid funeral is a contract, and a loan is worth what is still owed.
        prepaidFuneral: {
            incomeRate: 0,
            growthRate: 0
        },
        loansToOthers: {
            incomeRate: 0,
            growthRate: 0
        },
        personalAssets: {
            incomeRate: 0,
            growthRate: 0
        },
        other: {
            incomeRate: 0,
            growthRate: 0
        }
    };
}
function $138d267475fbd696$export$7da607f9900cf706(type, isPartnered, overrides = {}) {
    const assetConfig = (0, $77d0522707ddb581$export$e18ad1b53d14ba76).find((t)=>t.id === type);
    if (!assetConfig) throw new Error(`Unknown asset type: ${type}`);
    const isIndividual = assetConfig.individualOnly;
    const defaultOwnership = isPartnered && !isIndividual ? 'joint' : 'client';
    const newAsset = {
        id: (0, $942f2f96766bf874$export$d3a77fab0baa99a2)(),
        description: '',
        ownership: defaultOwnership,
        hasCgt: assetConfig.hasCgt || false,
        ...$138d267475fbd696$export$5b0e102cd4dab698()[type],
        acquisitionDate: 'post',
        reinvest: true,
        frankingCredit: 70,
        commencementDateOption: 'post-2015',
        commencementDate: '',
        commencementDateUnsure: false,
        fundingSource: 'super',
        maturityDate: '',
        ...overrides,
        type: type
    };
    return newAsset;
}
function $138d267475fbd696$export$f959c68a0ca6048c(factFind, drafts, isPartnered) {
    const assets = {
        ...factFind.assets
    };
    drafts.forEach((draft)=>{
        if (!draft?.assetTypeId) return;
        const { assetTypeId: assetTypeId, description: description, value: value, ownership: ownership } = draft;
        const parsedValue = value != null && value !== '' ? parseFloat(value) : NaN;
        // buildNewAsset mints its own unique id; no need to offset a shared timestamp any more. The
        // document's fields (cost base, commencement date, payment…) land on the card as entered values,
        // over the type's defaults, so the adviser edits rather than re-keys.
        const newAsset = $138d267475fbd696$export$7da607f9900cf706(assetTypeId, isPartnered, {
            ...draft.fields || {},
            ...description != null ? {
                description: description
            } : {},
            ...!Number.isNaN(parsedValue) ? {
                value: parsedValue
            } : {},
            ...ownership ? {
                ownership: ownership
            } : {}
        });
        const list = assets[assetTypeId] || [];
        assets[assetTypeId] = [
            ...list,
            newAsset
        ];
    });
    return {
        ...factFind,
        assets: assets
    };
}
function $138d267475fbd696$export$66280580b9910f1d(factFind, picked, isPartnered) {
    let next = {
        ...factFind,
        structures: [
            ...factFind.structures || []
        ]
    };
    const idByEntity = new Map();
    for (const entity of (0, $f99f3d62d96a104c$export$d52fe623b94941f7)(picked.assets, picked.liabilities)){
        const key = (0, $f99f3d62d96a104c$export$a280f55013e4a912)(entity.name);
        const existing = (next.structures || []).find((s)=>(0, $f99f3d62d96a104c$export$a280f55013e4a912)(s.name) === key);
        if (existing?.id) {
            idByEntity.set(key, existing.id);
            continue;
        }
        // A new arrangement starts at the ordinary split — the whole of it counted toward the household,
        // half each for a couple — so its assets are not shown at nothing until the adviser visits it.
        const created = {
            ...(0, $9a0fdbf41e16d1c8$export$6f799eb84f914055)(),
            name: entity.name,
            type: entity.type,
            apportionmentClient: isPartnered ? 50 : 100,
            apportionmentPartner: isPartnered ? 50 : 0
        };
        next = {
            ...next,
            structuresGateAnswer: true,
            structures: [
                ...next.structures || [],
                created
            ]
        };
        idByEntity.set(key, created.id);
    }
    const owned = (d)=>d.entity ? {
            ...d,
            ownership: (0, $1773fcf9595c5c0a$export$66d936c41d42a933)(idByEntity.get((0, $f99f3d62d96a104c$export$a280f55013e4a912)(d.entity.name)) || '')
        } : d;
    next = $138d267475fbd696$export$f959c68a0ca6048c(next, picked.assets.filter((d)=>d.selected && d.assetTypeId).map(owned), isPartnered);
    // The family home's value fills Living Arrangements — only where nothing is recorded there yet.
    const homeRow = picked.assets.find((d)=>d.selected && d.kind === 'home' && Number(d.value) > 0);
    if (homeRow && !(Number(next.home?.value) > 0)) next = {
        ...next,
        home: {
            ...next.home || {},
            value: Number(homeRow.value)
        }
    };
    const liabilities = {
        ...next.liabilities || {}
    };
    picked.liabilities.filter((d)=>d.selected && d.liabilityTypeId).map(owned).forEach((d)=>{
        const type = d.liabilityTypeId;
        const balance = parseFloat(d.balance);
        const row = {
            id: (0, $942f2f96766bf874$export$d3a77fab0baa99a2)(),
            type: type,
            description: d.description,
            frequency: 'monthly',
            assetLink: 'none',
            ownership: d.ownership,
            loanType: 'pi',
            repaymentCalculation: type === 'mortgages' || type === 'personalLoans' ? 'auto' : 'manual',
            ...Number.isFinite(balance) ? {
                balance: balance
            } : {},
            ...d.fields
        };
        liabilities[type] = [
            ...liabilities[type] || [],
            row
        ];
    });
    return {
        ...next,
        liabilities: liabilities
    };
}


/**
 * Import from statement (owner, 15 Oct 2026): the adviser drops a client's documents — PDFs, photos,
 * spreadsheets — and gets draft rows back to tick, grouped by file: the person's assets, the assets
 * a trust or company holds (which land under that entity, created if the profile has none of that
 * name), and liabilities. Nothing lands on the profile until they confirm. Rendered through a portal
 * so it opens centred on the screen whatever the page's scroll (it used to land at the bottom).
 */ 

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $26cec67c26de53a9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
            key: "1rqfz7"
        }
    ],
    [
        "path",
        {
            d: "M14 2v4a2 2 0 0 0 2 2h4",
            key: "tnqrlb"
        }
    ],
    [
        "path",
        {
            d: "M8 13h2",
            key: "yr2amv"
        }
    ],
    [
        "path",
        {
            d: "M14 13h2",
            key: "un5t4a"
        }
    ],
    [
        "path",
        {
            d: "M8 17h2",
            key: "2yhykz"
        }
    ],
    [
        "path",
        {
            d: "M14 17h2",
            key: "10kma7"
        }
    ]
];
const $26cec67c26de53a9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("file-spreadsheet", $26cec67c26de53a9$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5f4bdaa89ec695b9$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            ry: "2",
            key: "1m3agn"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "9",
            r: "2",
            key: "af1f0g"
        }
    ],
    [
        "path",
        {
            d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
            key: "1xmnt7"
        }
    ]
];
const $5f4bdaa89ec695b9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("image", $5f4bdaa89ec695b9$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4f68e7f5ef2ab511$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 3v12",
            key: "1x0j5s"
        }
    ],
    [
        "path",
        {
            d: "m17 8-5-5-5 5",
            key: "7q97r8"
        }
    ],
    [
        "path",
        {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
            key: "ih7n3h"
        }
    ]
];
const $4f68e7f5ef2ab511$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("upload", $4f68e7f5ef2ab511$export$3efd853dbb351e94);



/**
 * Statement import — client side. The files go to OUR backend (/rest/ai/extract-assets), which holds
 * the AI key and does the reading; the browser never talks to a provider. Nothing is stored anywhere:
 * the drafts come back for the adviser to tick.
 */ 

/**
 * Client-profile persistence — talks to OUR backend (/rest/profiles) with the signed-in user's token.
 *
 * Privacy split (matches the server's assume-breach data model, D6):
 *   identity  — who the client is (names, DOB, contact) — stored encrypted in its own table
 *   factFind  — the financial situation the engine models — stored encrypted separately,
 *               with the identity fields BLANKED so the two segments are only joinable server-side.
 * `splitFactFind` / `mergeFactFind` are the single source of truth for that split.
 */ 



function $a0f9af581f384312$var$getApiBaseUrl() {
    // One source for this — see services/apiBase.ts for why eight copies was a problem.
    return (0, $4e54353814e6aea9$export$8ebae31efd30e025)();
}
async function $a0f9af581f384312$var$authHeaders() {
    const token = await (0, $cc9e8a24185b91b0$export$84773cc9bf7dbe87)();
    if (!token) throw new Error('Not signed in');
    return {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
}
function $a0f9af581f384312$export$321ff8dcbc3b0902(factFind) {
    const fd = structuredClone(factFind || {});
    const client = fd.client || {};
    const partner = fd.partner || {};
    const fullName = [
        client.firstName,
        client.lastName
    ].filter(Boolean).join(' ').trim();
    const identity = {
        fullName: fullName || 'Client',
        dateOfBirth: client.dob || undefined,
        email: client.email || undefined,
        phone: client.preferredPhone || undefined,
        partnerFullName: [
            partner.firstName,
            partner.lastName
        ].filter(Boolean).join(' ').trim() || undefined,
        partnerDateOfBirth: partner.dob || undefined,
        completerFirstName: fd.completerFirstName || undefined,
        completerLastName: fd.completerLastName || undefined
    };
    // Blank every identifying field in the stored fact-find (merged back on load).
    if (fd.client) fd.client = {
        ...fd.client,
        firstName: '',
        lastName: '',
        email: '',
        preferredPhone: '',
        dob: ''
    };
    if (fd.partner) fd.partner = {
        ...fd.partner,
        firstName: '',
        lastName: '',
        dob: ''
    };
    fd.completerFirstName = '';
    fd.completerLastName = '';
    (0, $3b66eba236b50ffc$export$a9c2d1d6ba0d8024)(fd);
    return {
        identity: identity,
        factFind: fd
    };
}
function $a0f9af581f384312$export$fc71f7546f8ae5f(factFind, identity) {
    const fd = structuredClone(factFind || {});
    const id = identity || {};
    const [firstName = '', ...rest] = String(id.fullName || '').split(' ');
    const [partnerFirst = '', ...partnerRest] = String(id.partnerFullName || '').split(' ');
    fd.client = {
        ...fd.client || {},
        firstName: firstName,
        lastName: rest.join(' '),
        email: id.email || '',
        preferredPhone: id.phone || '',
        dob: id.dateOfBirth || ''
    };
    if (id.partnerFullName || fd.partner) fd.partner = {
        ...fd.partner || {},
        firstName: partnerFirst,
        lastName: partnerRest.join(' '),
        dob: id.partnerDateOfBirth || ''
    };
    if (id.completerFirstName) fd.completerFirstName = id.completerFirstName;
    if (id.completerLastName) fd.completerLastName = id.completerLastName;
    return fd;
}
const $a0f9af581f384312$var$PROFILE_ID_KEY = 'awiseAccountProfileId';
/**
 * Session-storage keys that hold real client work (saved strategies, scenarios, SOA case
 * studies, service plans). They're captured into the encrypted account payload on save and
 * written back on resume, so nothing done in the app is lost when the browser closes.
 * (Transient navigation flags like the reopen/restore keys are deliberately excluded.)
 */ const $a0f9af581f384312$var$SESSION_MIRROR_KEYS = [
    'careCompanionStrategies',
    'careCompanionScenarios',
    'careCompanionCaseStudies',
    'careCompanionCurrentServicePlan',
    'careCompanionSelectedAgedCareStrategy',
    'careCompanionOptimizedFinancials'
];
/**
 * Session keys whose contents app data ALREADY carries (`savedStrategies`, `savedCaseStudies`). They
 * are not mirrored a second time: the mirror used to hold a full copy of every saved strategy and
 * every SOA draft beside the arrays themselves, so a file with a few strategies and drafts passed the
 * server's body limit and every save failed with 413 (owner-reported, 9 Oct 2026). On load they are
 * rebuilt from the arrays instead.
 */ const $a0f9af581f384312$var$MIRROR_KEYS_HELD_IN_APP_DATA = {
    careCompanionStrategies: 'savedStrategies',
    careCompanionCaseStudies: 'savedCaseStudies'
};
function $a0f9af581f384312$export$e77e0ac9cb053698() {
    const mirror = {};
    for (const key of $a0f9af581f384312$var$SESSION_MIRROR_KEYS){
        if (key in $a0f9af581f384312$var$MIRROR_KEYS_HELD_IN_APP_DATA) continue;
        const value = sessionStorage.getItem(key);
        if (value !== null) mirror[key] = value;
    }
    return mirror;
}
function $a0f9af581f384312$export$fe33d8b505081339(appData) {
    if (!appData) return;
    const mirror = appData.sessionMirror && typeof appData.sessionMirror === 'object' ? appData.sessionMirror : {};
    for (const key of $a0f9af581f384312$var$SESSION_MIRROR_KEYS){
        if (typeof mirror[key] === 'string') {
            sessionStorage.setItem(key, mirror[key]);
            continue;
        }
        const held = $a0f9af581f384312$var$MIRROR_KEYS_HELD_IN_APP_DATA[key];
        if (held && Array.isArray(appData[held])) sessionStorage.setItem(key, JSON.stringify(appData[held]));
    }
}
function $a0f9af581f384312$export$62a775eed95889de() {
    for (const key of $a0f9af581f384312$var$SESSION_MIRROR_KEYS)sessionStorage.removeItem(key);
}
function $a0f9af581f384312$export$25d8ec09bea77dfb() {
    return sessionStorage.getItem($a0f9af581f384312$var$PROFILE_ID_KEY) || null;
}
function $a0f9af581f384312$export$1db2a6d91babbd88(profileId) {
    if (profileId) sessionStorage.setItem($a0f9af581f384312$var$PROFILE_ID_KEY, profileId);
    else sessionStorage.removeItem($a0f9af581f384312$var$PROFILE_ID_KEY);
}
function $a0f9af581f384312$export$b9a006cb2241c14(appData) {
    const cloned = structuredClone(appData || {});
    (0, $3b66eba236b50ffc$export$e6ed5a41d50496b3)(cloned.coupleValidation, (0, $3b66eba236b50ffc$export$51d57466d53d81f).coupleValidationItem);
    return cloned;
}
/*
 * ONE WRITER AT A TIME (owner, 23 Oct 2026: a browser left open on a file kept saving its older copy over
 * newer work, and two village plans were lost). Each file's version — its `updatedAt` from the last load
 * or save — is remembered here and quoted with the next save; the server refuses a save whose file has
 * moved on since (409 PROFILE_CHANGED) instead of overwriting it. Keyed by profile id; "mine" for the
 * signed-in user's own file, which has no id on the wire.
 */ const $a0f9af581f384312$var$knownVersions = new Map();
const $a0f9af581f384312$var$versionKey = (profileId)=>profileId ?? 'mine';
function $a0f9af581f384312$var$rememberVersion(profileId, updatedAt) {
    if (typeof updatedAt === 'string' && updatedAt) $a0f9af581f384312$var$knownVersions.set($a0f9af581f384312$var$versionKey(profileId), updatedAt);
}
const $a0f9af581f384312$var$expectedVersion = (profileId)=>{
    const v = $a0f9af581f384312$var$knownVersions.get($a0f9af581f384312$var$versionKey(profileId));
    return v ? {
        expectedUpdatedAt: v
    } : {};
};
function $a0f9af581f384312$export$12328d6c67223805(err) {
    return (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).isAxiosError(err) && err.response?.status === 409 && err.response?.data?.error?.code === 'PROFILE_CHANGED';
}
async function $a0f9af581f384312$export$e38d9fa5fa0a9fe6({ factFind: wholeFactFind, profileId: profileId = null, appState: appState = null, appData: appData = null, tenantId: tenantId = null }) {
    const headers = await $a0f9af581f384312$var$authHeaders();
    const { identity: identity, factFind: factFind } = $a0f9af581f384312$export$321ff8dcbc3b0902(wholeFactFind);
    if (appState) factFind.__appState = appState;
    if (appData) factFind.__appData = $a0f9af581f384312$export$b9a006cb2241c14(appData);
    if (profileId) {
        const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).put(`${$a0f9af581f384312$var$getApiBaseUrl()}/rest/profiles/${profileId}`, {
            identity: identity,
            factFind: factFind,
            schemaVersion: 1,
            ...$a0f9af581f384312$var$expectedVersion(profileId)
        }, {
            headers: headers,
            timeout: 30000
        });
        $a0f9af581f384312$var$rememberVersion(profileId, res.data?.updatedAt);
        return {
            profileId: profileId
        };
    }
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$a0f9af581f384312$var$getApiBaseUrl()}/rest/profiles`, // tenantId says which workspace the file belongs to (an adviser belongs to their firm AND
    // may have a personal plan — new client files must land in the firm).
    {
        identity: identity,
        factFind: factFind,
        schemaVersion: 1,
        ...tenantId ? {
            tenantId: tenantId
        } : {}
    }, {
        headers: headers,
        timeout: 30000
    });
    // Withheld when the new file is the caller's only one — they reach it through /rest/profiles/mine.
    return {
        profileId: res.data.profileId ?? null
    };
}
async function $a0f9af581f384312$export$cb7149721c33bed5({ factFind: factFind, appState: appState, appData: appData }) {
    if ($a0f9af581f384312$var$soleProfileMode) {
        const headers = await $a0f9af581f384312$var$authHeaders();
        const { identity: identity, factFind: split } = $a0f9af581f384312$export$321ff8dcbc3b0902(factFind);
        if (appState) split.__appState = appState;
        if (appData) split.__appData = $a0f9af581f384312$export$b9a006cb2241c14(appData);
        const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).put(`${$a0f9af581f384312$var$getApiBaseUrl()}/rest/profiles/mine`, {
            identity: identity,
            factFind: split,
            schemaVersion: 1,
            ...$a0f9af581f384312$var$expectedVersion(null)
        }, {
            headers: headers,
            timeout: 30000
        });
        $a0f9af581f384312$var$rememberVersion(null, res.data?.updatedAt);
        return {
            profileId: null
        };
    }
    const saved = await $a0f9af581f384312$export$e38d9fa5fa0a9fe6({
        factFind: factFind,
        profileId: $a0f9af581f384312$export$25d8ec09bea77dfb(),
        appState: appState,
        appData: appData
    });
    // A withheld id means the file just created is the caller's only one: they are single-file from here,
    // and there is no id to remember.
    if (saved.profileId === null) $a0f9af581f384312$var$soleProfileMode = true;
    $a0f9af581f384312$export$1db2a6d91babbd88(saved.profileId);
    return saved;
}
/**
 * Whether the server last reported this caller as resolving to exactly ONE file.
 *
 * In that mode the server withholds profile ids entirely and serves the file through
 * /rest/profiles/mine, so there is no id for this module to hold, store or send. Refreshed by every
 * listClientProfiles() call — which every load path runs first — rather than assumed from the user's
 * role, because the server decides it from what the caller can actually see.
 */ let $a0f9af581f384312$var$soleProfileMode = false;
async function $a0f9af581f384312$export$13c7095e6fe0ed09() {
    const headers = await $a0f9af581f384312$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${$a0f9af581f384312$var$getApiBaseUrl()}/rest/profiles`, {
        headers: headers,
        timeout: 30000
    });
    $a0f9af581f384312$var$soleProfileMode = res.data.soleProfile === true;
    return res.data.profiles || [];
}
async function $a0f9af581f384312$export$ea46ab6498510ff6() {
    const headers = await $a0f9af581f384312$var$authHeaders();
    try {
        const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${$a0f9af581f384312$var$getApiBaseUrl()}/rest/profiles/mine`, {
            headers: headers,
            timeout: 30000
        });
        const { identity: identity, factFind: factFind } = res.data.profile;
        $a0f9af581f384312$var$rememberVersion(null, res.data.profile?.updatedAt);
        const { __appState: __appState = null, __appData: __appData = null, ...cleanFactFind } = factFind || {};
        // Nothing to remember: there is no id, which is the point.
        $a0f9af581f384312$export$1db2a6d91babbd88(null);
        return {
            profileId: null,
            factFind: $a0f9af581f384312$export$fc71f7546f8ae5f(cleanFactFind, identity),
            appState: __appState,
            appData: __appData
        };
    } catch (err) {
        if ((0, $57966c7e0affc4cb$export$2e2bcd8739ae039).isAxiosError(err) && err.response?.status === 409) return null;
        throw err;
    }
}
async function $a0f9af581f384312$export$49cf4955b0bc9ba8(profileId, { remember: remember = true } = {}) {
    const headers = await $a0f9af581f384312$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${$a0f9af581f384312$var$getApiBaseUrl()}/rest/profiles/${profileId}`, {
        headers: headers,
        timeout: 30000
    });
    const { identity: identity, factFind: factFind } = res.data.profile;
    $a0f9af581f384312$var$rememberVersion(profileId, res.data.profile?.updatedAt);
    const { __appState: __appState = null, __appData: __appData = null, ...cleanFactFind } = factFind || {};
    if (remember) $a0f9af581f384312$export$1db2a6d91babbd88(profileId);
    return {
        profileId: profileId,
        factFind: $a0f9af581f384312$export$fc71f7546f8ae5f(cleanFactFind, identity),
        appState: __appState,
        appData: __appData
    };
}
async function $a0f9af581f384312$export$25a6622c6a8b28cc() {
    const headers = await $a0f9af581f384312$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${$a0f9af581f384312$var$getApiBaseUrl()}/rest/privacy/export`, {
        headers: headers,
        timeout: 60000
    });
    return res.data;
}
async function $a0f9af581f384312$export$19641b75d6358d63() {
    const headers = await $a0f9af581f384312$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$a0f9af581f384312$var$getApiBaseUrl()}/rest/privacy/delete-request`, {}, {
        headers: headers,
        timeout: 30000
    });
    return res.data;
}
async function $a0f9af581f384312$export$4310a59bd5b0b729() {
    const profiles = await $a0f9af581f384312$export$13c7095e6fe0ed09();
    if (!profiles.length) return null;
    // One file: the server withheld its id and serves it through the id-free route.
    if ($a0f9af581f384312$var$soleProfileMode) return $a0f9af581f384312$export$ea46ab6498510ff6();
    return $a0f9af581f384312$export$49cf4955b0bc9ba8(profiles[0].id);
}




class $d11288115718fb45$export$d73927774eee66be extends Error {
    code;
    constructor(code, message){
        super(message);
        this.code = code;
    }
}
const $d11288115718fb45$var$readAsBase64 = (file)=>new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onerror = ()=>reject(new Error(`Could not read ${file.name}.`));
        reader.onload = ()=>{
            const result = String(reader.result || '');
            resolve(result.includes(',') ? result.slice(result.indexOf(',') + 1) : result);
        };
        reader.readAsDataURL(file);
    });
function $d11288115718fb45$export$d512738aa615cb55(err) {
    const axiosErr = err;
    const code = axiosErr.response?.data?.error?.code;
    const message = axiosErr.response?.data?.error?.message;
    if (code === 'AI_QUOTA_EXCEEDED') return "You've used today's statement-reading allowance. It resets tomorrow \u2014 you can still add assets by hand.";
    if (code === 'UNSUPPORTED_FILE' || code === 'FILE_TOO_LARGE' || code === 'FILES_TOO_LARGE') return message || 'That file could not be used.';
    if (code === 'NOT_CONFIGURED' || axiosErr.response?.status === 503) return 'Statement reading is not available right now. You can still add assets by hand.';
    if (axiosErr.response?.status === 401) return 'Please sign in to import a statement.';
    // No response at all: either the read outran the wait, or the connection dropped (a restarting
    // server mid-read looks like this too).
    if (!axiosErr.response) return axiosErr.code === 'ECONNABORTED' ? 'That took longer than four minutes to read. Try fewer pages or files at a time.' : "Couldn't reach the server \u2014 the connection dropped before the reply came back. Try again.";
    if (axiosErr.response.status === 429) return "Too many reads in a row \u2014 wait a minute and try again.";
    // A gateway giving up on a long request (the front door's own limit), not the reader.
    if ([
        502,
        504,
        524
    ].includes(axiosErr.response.status) || axiosErr.response.status === 503 && !code) return "That document took too long to read over this connection \u2014 try fewer pages or files at a time.";
    // Say what the server said, so a failure is never a mystery: Fastify's own validation errors carry
    // `message` at the top level, ours under `error`.
    const detail = message || axiosErr.response.data?.message;
    const codeNote = code ? ` (${code})` : '';
    return detail ? `Couldn't read that statement: ${detail}${codeNote}` : `Couldn't read that statement${codeNote}. Try a clearer copy, or add the assets by hand.`;
}
const $d11288115718fb45$export$57be4c05c66a7518 = 2500;
const $d11288115718fb45$export$ae3324e1b101225 = 300000;
const $d11288115718fb45$var$wait = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
/** A failed read, shaped like the request error the message writer already reads. */ const $d11288115718fb45$var$failedRead = (httpStatus, error)=>({
        response: {
            status: httpStatus,
            data: {
                error: error
            }
        }
    });
async function $d11288115718fb45$export$9ce255440e46c220(input) {
    const files = await Promise.all(input.files.map(async (file)=>({
            name: file.name,
            mimeType: file.type || 'application/octet-stream',
            dataBase64: await $d11288115718fb45$var$readAsBase64(file)
        })));
    const token = await (0, $cc9e8a24185b91b0$export$84773cc9bf7dbe87)().catch(()=>null);
    const headers = {
        'Content-Type': 'application/json'
    };
    if (token) headers.Authorization = `Bearer ${token}`;
    const profileId = (0, $a0f9af581f384312$export$25d8ec09bea77dfb)();
    const started = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${(0, $4e54353814e6aea9$export$8ebae31efd30e025)()}/rest/ai/extract-assets`, {
        files: files,
        household: {
            isCouple: input.household.isCouple,
            ...input.household.clientName ? {
                clientName: input.household.clientName
            } : {},
            ...input.household.partnerName ? {
                partnerName: input.household.partnerName
            } : {}
        },
        ...profileId ? {
            profileId: profileId
        } : {},
        // Names and values only: an asset's id is a raw UUID, which the server's id gate refuses.
        ...input.existingAssets || input.existingHome ? {
            existingAssets: (0, $f99f3d62d96a104c$export$e422eb33bf8eaa34)(input.existingAssets, input.existingHome)
        } : {}
    }, {
        headers: headers,
        timeout: 60000
    });
    const jobId = String(started.data?.jobId || '');
    if (!jobId) throw $d11288115718fb45$var$failedRead(502, {
        code: 'AI_ERROR',
        message: 'The read did not start.'
    });
    const deadline = Date.now() + $d11288115718fb45$export$ae3324e1b101225;
    while(Date.now() < deadline){
        await $d11288115718fb45$var$wait($d11288115718fb45$export$57be4c05c66a7518);
        const asked = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${(0, $4e54353814e6aea9$export$8ebae31efd30e025)()}/rest/ai/extract-assets/${encodeURIComponent(jobId)}`, {
            headers: headers,
            timeout: 30000
        });
        const data = asked.data;
        if (data.status === 'done') return {
            assets: Array.isArray(data.drafts) ? data.drafts : [],
            liabilities: Array.isArray(data.liabilities) ? data.liabilities : []
        };
        if (data.status === 'failed') throw $d11288115718fb45$var$failedRead(data.error?.httpStatus ?? 502, data.error ?? {});
    }
    throw {
        code: 'ECONNABORTED'
    };
}




const $3ab442452bedaadf$var$confidenceClass = {
    high: 'bg-emerald-50 text-emerald-800 ring-1 ring-emerald-100',
    medium: 'bg-blue-50 text-blue-800 ring-1 ring-blue-100',
    low: 'bg-slate-100 text-slate-700 ring-1 ring-slate-200'
};
const $3ab442452bedaadf$export$f414e14566fe75d7 = '.pdf,.xlsx,.xls,.csv,image/*';
const $3ab442452bedaadf$export$7f2bbe94a341c818 = 'Your file is read by an AI service to draft these entries and is not stored. Cover or leave out anything with a tax file number on it.';
const $3ab442452bedaadf$var$AssetStatementImportModal = ({ onClose: onClose, onConfirm: onConfirm, household: household, existingAssets: existingAssets, existingHome: existingHome = null, extract: extract = (0, $d11288115718fb45$export$9ce255440e46c220) })=>{
    const fileInputRef = (0, $acw62.useRef)(null);
    const [phase, setPhase] = (0, $acw62.useState)('upload');
    const [files, setFiles] = (0, $acw62.useState)([]);
    const [drafts, setDrafts] = (0, $acw62.useState)([]);
    const [liabilities, setLiabilities] = (0, $acw62.useState)([]);
    const [combine, setCombine] = (0, $acw62.useState)({});
    const [error, setError] = (0, $acw62.useState)('');
    const [dragOver, setDragOver] = (0, $acw62.useState)(false);
    // While the reader works, the words move so the wait reads as progress rather than a hang.
    const READING_STEPS = [
        "Opening the documents\u2026",
        "Reading each page\u2026",
        "Finding the assets and loans\u2026",
        "Matching the fields to your profile\u2026",
        "Nearly there\u2026"
    ];
    const [readingStep, setReadingStep] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        if (phase !== 'processing') {
            setReadingStep(0);
            return undefined;
        }
        const t = setInterval(()=>setReadingStep((i)=>Math.min(i + 1, READING_STEPS.length - 1)), 7000);
        return ()=>clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        phase
    ]);
    (0, $acw62.useEffect)(()=>{
        const onKey = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        onClose
    ]);
    const runExtraction = async (selectedFiles)=>{
        if (!selectedFiles.length) {
            setError('Choose at least one file.');
            return;
        }
        if (selectedFiles.length > 5) {
            setError('Up to 5 files at a time.');
            return;
        }
        setError('');
        setPhase('processing');
        try {
            const result = await extract({
                files: selectedFiles,
                household: household,
                existingAssets: existingAssets,
                existingHome: existingHome
            });
            setDrafts(result.assets);
            setLiabilities(result.liabilities);
            setCombine({});
            setPhase('review');
            if (!result.assets.length && !result.liabilities.length) setError('Nothing that looks like an asset or a loan was found in those files. Try a clearer copy, or add them by hand.');
        } catch (err) {
            setError((0, $d11288115718fb45$export$d512738aa615cb55)(err));
            setPhase('upload');
        }
    };
    const handleFiles = (fileList)=>{
        const next = Array.from(fileList || []);
        setFiles(next);
        if (next.length) runExtraction(next);
    };
    const addable = (row)=>!!row.assetTypeId || row.kind === 'home';
    const toggleRow = (id)=>setDrafts((prev)=>prev.map((row)=>row.id === id && addable(row) ? {
                    ...row,
                    selected: !row.selected
                } : row));
    const toggleLiability = (id)=>setLiabilities((prev)=>prev.map((row)=>row.id === id && row.liabilityTypeId ? {
                    ...row,
                    selected: !row.selected
                } : row));
    const setFileSelection = (file, selected)=>{
        setDrafts((prev)=>prev.map((row)=>row.sourceFile === file && addable(row) ? {
                    ...row,
                    selected: selected
                } : row));
        setLiabilities((prev)=>prev.map((row)=>row.sourceFile === file && row.liabilityTypeId ? {
                    ...row,
                    selected: selected
                } : row));
    };
    /** Rows by the file they came from, in upload order: the person's own, then each entity's, then the loans. */ const groups = (0, $acw62.useMemo)(()=>{
        const files = Array.from(new Set([
            ...drafts.map((d)=>d.sourceFile),
            ...liabilities.map((d)=>d.sourceFile)
        ]));
        return files.map((file)=>{
            const rows = drafts.filter((d)=>d.sourceFile === file);
            const own = rows.filter((d)=>!d.entity);
            const byEntity = new Map();
            rows.filter((d)=>d.entity).forEach((d)=>byEntity.set(d.entity.name, [
                    ...byEntity.get(d.entity.name) || [],
                    d
                ]));
            return {
                file: file,
                own: own,
                entities: Array.from(byEntity.entries()),
                loans: liabilities.filter((d)=>d.sourceFile === file),
                combined: (0, $f99f3d62d96a104c$export$c62600a0332fc418)(own)
            };
        });
    }, [
        drafts,
        liabilities
    ]);
    /** What confirm adds: each file's ticked rows, or its one combined line where the adviser chose that. */ const toAdd = (0, $acw62.useMemo)(()=>({
            assets: groups.flatMap((g)=>[
                    ...combine[g.file] && g.combined ? [
                        g.combined,
                        ...g.own.filter((d)=>d.selected && d.kind === 'home')
                    ] : g.own.filter((d)=>d.selected && addable(d)),
                    ...g.entities.flatMap(([, rows])=>rows.filter((d)=>d.selected && d.assetTypeId))
                ]),
            liabilities: liabilities.filter((d)=>d.selected && d.liabilityTypeId)
        }), [
        groups,
        combine,
        liabilities
    ]);
    const toAddCount = toAdd.assets.length + toAdd.liabilities.length;
    const handleConfirm = ()=>{
        if (!toAddCount) {
            setError('Select at least one item to add.');
            return;
        }
        onConfirm(toAdd);
    };
    const ownerLabel = (ownership)=>ownership === 'joint' ? 'joint' : ownership === 'partner' ? household.partnerName || 'partner' : household.clientName || 'client';
    const fieldsSummary = (row)=>{
        const bits = [];
        const f = row.fields;
        if (f.income != null) bits.push(`${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(f.income))} a year`);
        if (f.commencementDate) bits.push(`started ${String(f.commencementDate)}`);
        if (f.purchasePrice != null) bits.push(`bought for ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(f.purchasePrice))}`);
        if (f.costBase != null) bits.push(`cost base ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(f.costBase))}`);
        if (f.acquiredOn) bits.push(`acquired ${String(f.acquiredOn)}`);
        if (f.maturityDate) bits.push(`matures ${String(f.maturityDate)}`);
        if (f.incomeRate != null) bits.push(`${Number(f.incomeRate)}% p.a.`);
        if (f.taxFree != null) bits.push(`tax-free part ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(f.taxFree))}`);
        if (f.rcv != null) bits.push(`residual ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(f.rcv))}`);
        return bits.join(" \xb7 ");
    };
    const loanSummary = (row)=>{
        const bits = [];
        const f = row.fields;
        if (f.interestRate != null) bits.push(`${f.interestRate}% p.a.`);
        if (f.repayments != null) bits.push(`${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(f.repayments))} ${f.frequency || 'monthly'}`);
        if (f.loanType) bits.push(f.loanType === 'io' ? 'interest only' : 'principal and interest');
        if (f.loanTerm != null) bits.push(`${f.loanTerm} years left`);
        return bits.join(" \xb7 ");
    };
    const assetRow = (row, disabled)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
            className: `flex items-start gap-3 px-3 py-2.5 ${!addable(row) ? 'bg-slate-50/80' : ''}`,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "checkbox",
                    className: "mt-1",
                    checked: row.selected && !(disabled && row.kind !== 'home'),
                    disabled: !addable(row) || disabled && row.kind !== 'home',
                    onChange: ()=>toggleRow(row.id),
                    "aria-label": `Select ${row.description}`
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0 flex-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-baseline justify-between gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm font-semibold text-slate-900 truncate",
                                    children: row.description
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm font-semibold text-slate-900 tabular-nums whitespace-nowrap",
                                    children: row.value ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(row.value)) : "\u2014"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-xs text-slate-500",
                            children: [
                                (0, $f99f3d62d96a104c$export$e31df1faac9ea30b)(row.assetTypeId, row.kind),
                                row.assetTypeId && !row.entity && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        " \xb7 ",
                                        ownerLabel(row.ownership)
                                    ]
                                }),
                                row.fieldsAsked > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        " \xb7 ",
                                        row.fieldsFound,
                                        " of ",
                                        row.fieldsAsked,
                                        " fields found"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: `ml-2 inline-block px-1.5 py-0.5 rounded-full text-[10px] font-semibold ${$3ab442452bedaadf$var$confidenceClass[row.confidence]}`,
                                    children: row.confidence
                                })
                            ]
                        }),
                        fieldsSummary(row) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-xs text-slate-600 mt-0.5",
                            children: fieldsSummary(row)
                        }),
                        (row.flags.length > 0 || row.notes) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-xs text-slate-600 mt-0.5 flex items-start gap-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                    size: 12,
                                    className: "mt-0.5 shrink-0 text-amber-500",
                                    "aria-hidden": true
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: [
                                        ...row.flags,
                                        row.notes
                                    ].filter(Boolean).join(" \xb7 ")
                                })
                            ]
                        })
                    ]
                })
            ]
        }, row.id);
    const body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 bg-slate-900/40 backdrop-blur-sm flex items-center justify-center z-[10000] p-4",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "statement-import-title",
            onClick: (e)=>e.stopPropagation(),
            "data-testid": "statement-import-modal",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "px-6 pt-5 pb-4 flex items-start justify-between gap-4 shrink-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-3 min-w-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                                    icon: (0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039),
                                    tone: "brand",
                                    variant: "solid",
                                    size: "md"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "min-w-0",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            id: "statement-import-title",
                                            className: "text-lg font-bold text-slate-900 leading-tight",
                                            children: "Import from a statement"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-slate-500 mt-0.5",
                                            children: phase === 'review' ? "Tick what to add \u2014 each row lands as a card you can edit." : 'Drop the documents and we draft the entries for you to check.'
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: onClose,
                            className: "p-2 -mr-1 hover:bg-slate-100 rounded-full transition-colors",
                            "aria-label": "Close",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 20,
                                className: "text-slate-500"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "p-6 overflow-y-auto flex-1",
                    children: [
                        phase === 'upload' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: `relative overflow-hidden rounded-2xl border-2 border-dashed transition-all duration-200 ${dragOver ? 'border-blue-500 bg-blue-50/60 scale-[1.01]' : 'border-slate-200 bg-white hover:border-blue-300'}`,
                                    onDragOver: (e)=>{
                                        e.preventDefault();
                                        setDragOver(true);
                                    },
                                    onDragLeave: ()=>setDragOver(false),
                                    onDrop: (e)=>{
                                        e.preventDefault();
                                        setDragOver(false);
                                        handleFiles(e.dataTransfer.files);
                                    },
                                    "data-testid": "import-dropzone",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "px-6 py-10 text-center",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "mx-auto mb-4 w-16 h-16 rounded-2xl bg-brand-navy text-white shadow-lg shadow-blue-500/25 flex items-center justify-center",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f68e7f5ef2ab511$export$2e2bcd8739ae039), {
                                                    size: 28,
                                                    strokeWidth: 2.2,
                                                    "aria-hidden": true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-base font-bold text-slate-900",
                                                children: "Drop your statements here"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-1 text-sm text-slate-500",
                                                children: "Super, pension, bank, share and loan statements, a Centrelink schedule, a platform report, or a spreadsheet of holdings."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "mt-5",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                                    variant: "brand",
                                                    size: "md",
                                                    icon: (0, $adb270212de20834$export$2e2bcd8739ae039),
                                                    onClick: ()=>fileInputRef.current?.click(),
                                                    children: "Choose files"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                ref: fileInputRef,
                                                type: "file",
                                                accept: $3ab442452bedaadf$export$f414e14566fe75d7,
                                                multiple: true,
                                                className: "hidden",
                                                onChange: (e)=>{
                                                    handleFiles(e.target.files);
                                                    e.target.value = '';
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "mt-5 flex flex-wrap justify-center gap-2",
                                                children: [
                                                    {
                                                        Icon: (0, $adb270212de20834$export$2e2bcd8739ae039),
                                                        label: 'PDF'
                                                    },
                                                    {
                                                        Icon: (0, $5f4bdaa89ec695b9$export$2e2bcd8739ae039),
                                                        label: 'Photo'
                                                    },
                                                    {
                                                        Icon: (0, $26cec67c26de53a9$export$2e2bcd8739ae039),
                                                        label: 'Excel or CSV'
                                                    },
                                                    {
                                                        Icon: (0, $05565f19ab398c04$export$2e2bcd8739ae039),
                                                        label: "Up to 5 files \xb7 8 MB each"
                                                    }
                                                ].map(({ Icon: Icon, label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "inline-flex items-center gap-1.5 rounded-full bg-white border border-slate-200 px-2.5 py-1 text-[11px] font-semibold text-slate-600",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                                                size: 12,
                                                                className: "text-slate-400",
                                                                "aria-hidden": true
                                                            }),
                                                            label
                                                        ]
                                                    }, label))
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-4 rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 flex items-start gap-3",
                                    "data-testid": "import-disclaimer",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                            size: 18,
                                            className: "mt-0.5 shrink-0 text-amber-500",
                                            "aria-hidden": true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-sm text-slate-700 leading-relaxed",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    className: "font-semibold text-slate-900",
                                                    children: "AI can make mistakes."
                                                }),
                                                " Check every figure against the document before you rely on it \u2014 nothing is added to the profile until you tick it, and you can edit anything afterwards."
                                            ]
                                        })
                                    ]
                                }),
                                files.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-xs text-slate-500 mt-3",
                                    children: [
                                        "Selected: ",
                                        files.map((f)=>f.name).join(', ')
                                    ]
                                })
                            ]
                        }),
                        phase === 'processing' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "py-10 flex flex-col items-center text-center",
                            "data-testid": "import-reading",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "relative mb-5 w-16 h-16 rounded-2xl bg-brand-navy text-white shadow-lg shadow-blue-500/25 flex items-center justify-center",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                                        size: 28,
                                        strokeWidth: 2.2,
                                        "aria-hidden": true,
                                        className: "animate-pulse"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-base font-bold text-slate-900",
                                    children: [
                                        "Reading ",
                                        files.length === 1 ? 'your statement' : `${files.length} files`
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-1 text-sm text-slate-600",
                                    "aria-live": "polite",
                                    children: READING_STEPS[readingStep]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mt-5 w-full max-w-xs h-1.5 rounded-full bg-slate-100 overflow-hidden",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "h-full w-1/3 rounded-full bg-blue-600 animate-[importSweep_1.4s_ease-in-out_infinite]"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-3 text-xs text-slate-400",
                                    children: "A page or two takes about 10 seconds; a long schedule can take a minute."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("style", {
                                    children: `@keyframes importSweep { 0% { transform: translateX(-120%); } 100% { transform: translateX(320%); } }`
                                })
                            ]
                        }),
                        phase === 'review' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-slate-600 mb-3",
                                    children: "Anything a trust or company holds lands under that entity, created if it is not on the profile yet."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "space-y-4",
                                    children: groups.map((g)=>{
                                        const selectable = [
                                            ...g.own,
                                            ...g.entities.flatMap(([, r])=>r)
                                        ].filter(addable).length + g.loans.filter((d)=>d.liabilityTypeId).length;
                                        const allOn = selectable > 0 && [
                                            ...g.own,
                                            ...g.entities.flatMap(([, r])=>r)
                                        ].filter(addable).every((d)=>d.selected) && g.loans.filter((d)=>d.liabilityTypeId).every((d)=>d.selected);
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "rounded-xl border border-slate-200",
                                            "data-testid": "import-file-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-center justify-between gap-3 px-3 py-2 bg-slate-50 rounded-t-xl border-b border-slate-200",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-xs font-semibold text-slate-700 truncate",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                                                    size: 13,
                                                                    className: "inline -mt-0.5 mr-1 text-slate-400",
                                                                    "aria-hidden": true
                                                                }),
                                                                g.file
                                                            ]
                                                        }),
                                                        selectable > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                            className: "text-xs text-slate-600 flex items-center gap-1.5 whitespace-nowrap",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    type: "checkbox",
                                                                    checked: allOn,
                                                                    onChange: (e)=>setFileSelection(g.file, e.target.checked)
                                                                }),
                                                                "Select all (",
                                                                selectable,
                                                                ")"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                g.own.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                    className: "divide-y divide-slate-100",
                                                    children: g.own.map((row)=>assetRow(row, !!combine[g.file]))
                                                }),
                                                g.combined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                    className: "flex items-start gap-2 px-3 py-2.5 border-t border-slate-200 text-xs text-slate-700",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            type: "checkbox",
                                                            className: "mt-0.5",
                                                            checked: !!combine[g.file],
                                                            onChange: (e)=>setCombine((c)=>({
                                                                        ...c,
                                                                        [g.file]: e.target.checked
                                                                    }))
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            children: [
                                                                "Add the ticked holdings as ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "one combined line"
                                                                }),
                                                                " (",
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(g.combined.value)),
                                                                g.combined.fields.costBase != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                    children: [
                                                                        ", cost base ",
                                                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(g.combined.fields.costBase))
                                                                    ]
                                                                }) : null,
                                                                ") instead of ",
                                                                g.own.filter((d)=>d.selected && d.assetTypeId).length,
                                                                " separate ones."
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                g.entities.map(([name, rows])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        "data-testid": "import-entity-group",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                className: "flex items-center gap-1.5 px-3 py-1.5 bg-slate-50 border-y border-slate-200 text-[11px] font-semibold tracking-wide text-slate-600 uppercase",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $224502d93617e0e1$export$2e2bcd8739ae039), {
                                                                        size: 12,
                                                                        className: "text-slate-400",
                                                                        "aria-hidden": true
                                                                    }),
                                                                    " Held by ",
                                                                    name
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                                className: "divide-y divide-slate-100",
                                                                children: rows.map((row)=>assetRow(row, false))
                                                            })
                                                        ]
                                                    }, name)),
                                                g.loans.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    "data-testid": "import-liability-group",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "px-3 py-1.5 bg-slate-50 border-y border-slate-200 text-[11px] font-semibold tracking-wide text-slate-600 uppercase",
                                                            children: "Loans and debts"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                            className: "divide-y divide-slate-100",
                                                            children: g.loans.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                                    className: `flex items-start gap-3 px-3 py-2.5 ${!row.liabilityTypeId ? 'bg-slate-50/80' : ''}`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                            type: "checkbox",
                                                                            className: "mt-1",
                                                                            checked: row.selected,
                                                                            disabled: !row.liabilityTypeId,
                                                                            onChange: ()=>toggleLiability(row.id),
                                                                            "aria-label": `Select ${row.description}`
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "min-w-0 flex-1",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                    className: "flex items-baseline justify-between gap-3",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                            className: "text-sm font-semibold text-slate-900 truncate",
                                                                                            children: row.description
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                            className: "text-sm font-semibold text-rose-700 tabular-nums whitespace-nowrap",
                                                                                            children: row.balance ? `\u{2212}${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(row.balance))}` : "\u2014"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                    className: "text-xs text-slate-500",
                                                                                    children: [
                                                                                        (0, $f99f3d62d96a104c$export$fbfac0100852a861)(row.liabilityTypeId),
                                                                                        row.liabilityTypeId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                                            children: [
                                                                                                " \xb7 ",
                                                                                                row.entity ? `owed by ${row.entity.name}` : ownerLabel(row.ownership)
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: `ml-2 inline-block px-1.5 py-0.5 rounded-full text-[10px] font-semibold ${$3ab442452bedaadf$var$confidenceClass[row.confidence]}`,
                                                                                            children: row.confidence
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                loanSummary(row) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                    className: "text-xs text-slate-600 mt-0.5",
                                                                                    children: loanSummary(row)
                                                                                }),
                                                                                (row.flags.length > 0 || row.notes) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                    className: "text-xs text-slate-600 mt-0.5 flex items-start gap-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                                                                            size: 12,
                                                                                            className: "mt-0.5 shrink-0 text-amber-500",
                                                                                            "aria-hidden": true
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            children: [
                                                                                                ...row.flags,
                                                                                                row.notes
                                                                                            ].filter(Boolean).join(" \xb7 ")
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }, row.id))
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, g.file);
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-wrap gap-2 mt-5",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                            variant: "brand",
                                            size: "md",
                                            disabled: toAddCount === 0,
                                            onClick: handleConfirm,
                                            children: [
                                                "Add ",
                                                toAddCount,
                                                " to the profile"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                            variant: "secondary",
                                            size: "md",
                                            onClick: ()=>{
                                                setDrafts([]);
                                                setLiabilities([]);
                                                setFiles([]);
                                                setCombine({});
                                                setError('');
                                                setPhase('upload');
                                            },
                                            children: "Upload another"
                                        })
                                    ]
                                })
                            ]
                        }),
                        error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mt-3 text-sm text-red-600",
                            role: "alert",
                            children: error
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "shrink-0 px-6 py-3 border-t border-slate-100 bg-slate-50/70 rounded-b-2xl flex items-start gap-2 text-[11px] text-slate-500",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                            size: 14,
                            className: "mt-px shrink-0 text-emerald-600",
                            "aria-hidden": true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: $3ab442452bedaadf$export$7f2bbe94a341c818
                        })
                    ]
                })
            ]
        })
    });
    return typeof document !== 'undefined' ? /*#__PURE__*/ (0, $1u0KT.createPortal)(body, document.body) : body;
};
var $3ab442452bedaadf$export$2e2bcd8739ae039 = $3ab442452bedaadf$var$AssetStatementImportModal;









/**
 * The financial years a gift can still count in, worked out from today (owner, 24 Oct 2026: "the years
 * should update as the app gets older rather than hard coded"). A gift above the free area is counted for
 * five years from the day it was made (Services Australia), so the years that matter run from the one
 * holding the date five years ago up to this one, so far. The list moves on by itself each year.
 *
 * Until now the screen offered "FY ending June {this calendar year}" and the four before it: in
 * October 2026 that left out this financial year (July 2026 on) and the oldest year still counting
 * (from October 2021).
 */ const $6805f825f69416c6$var$MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
const $6805f825f69416c6$var$fyEndOf = (d)=>d.getMonth() >= 6 ? d.getFullYear() + 1 : d.getFullYear();
function $6805f825f69416c6$export$4807f5b7ac5d7c45(today = new Date()) {
    const fiveYearsAgo = new Date(today.getFullYear() - 5, today.getMonth(), 1);
    const newest = $6805f825f69416c6$var$fyEndOf(today);
    const oldest = $6805f825f69416c6$var$fyEndOf(fiveYearsAgo);
    const out = [];
    for(let fyEnd = newest; fyEnd >= oldest; fyEnd--){
        // July (fyEnd − 1) … June fyEnd, cut to the window.
        const months = [];
        for(let i = 0; i < 12; i++){
            const m = (6 + i) % 12; // 0-based: July first
            const y = m >= 6 ? fyEnd - 1 : fyEnd;
            const first = new Date(y, m, 1);
            if (first < fiveYearsAgo || first > today) continue;
            months.push({
                month: m + 1,
                label: `${$6805f825f69416c6$var$MONTHS[m]} ${y}`
            });
        }
        const short = `${fyEnd - 1}\u{2013}${String(fyEnd).slice(-2)}`;
        const label = fyEnd === newest ? `July ${fyEnd - 1} to now` : fyEnd === oldest && months.length < 12 ? `${short}, from ${months[0]?.label ?? ''}` : short;
        out.push({
            fyEnd: fyEnd,
            label: label,
            months: months
        });
    }
    return out;
}








/**
 * Shows a warning when an account-based pension's annual payment is below the legislated minimum
 * drawdown for the owner's age. Used in Client Profile (Assets step).
 *
 * IT NO LONGER FAILS SILENTLY (owner-reported, 2026-08-31). The check needs the owner's age; with no
 * date of birth on file there is no age, and this component simply rendered nothing — so a partner's
 * pension showed no warning while the client's did, with nothing on screen to say the check had not
 * been made. Silence is indistinguishable from a pass.
 *
 * The rule itself lives in pensionMinimum.ts, pure and tested. This renders its answer.
 */ 
parcelRequire("acw62");


/**
 * The minimum-drawdown check for an account-based pension, as pure logic.
 *
 * WHY IT IS EXTRACTED (owner-reported, 2026-08-31). The warning fired for the client's ABP and not
 * the partner's, and the reason was invisible: the check needs the OWNER'S AGE, that age comes from
 * the owner's date of birth, and when the date of birth is missing `calculateAge` returns null — at
 * which point the component returned null too. No warning, no explanation, nothing on screen to say
 * the check had not been made. The client sees a payment we never verified and assumes we did.
 *
 * So the check now has THREE outcomes rather than two, and "we could not tell" is one of them. A
 * check that cannot run must say so; silence is indistinguishable from a pass.
 *
 * Pure and exported so it can be tested without rendering — the frontend test environment is `node`,
 * with no DOM, and this rule is worth a test either way: the owner asked for one so it cannot break
 * again unnoticed.
 */ 

function $bf7afaad28ce9e40$export$b2b73b961da00a92(ownership, people) {
    if (ownership === 'client') return {
        age: (0, $5589d9476399db47$export$8ada184d5eef4694)(people.client?.dob),
        who: people.client?.firstName || 'the applicant'
    };
    if (ownership === 'partner') return {
        age: (0, $5589d9476399db47$export$8ada184d5eef4694)(people.partner?.dob),
        who: people.partner?.firstName || 'their partner'
    };
    return {
        age: null,
        who: 'the owner'
    };
}
function $bf7afaad28ce9e40$export$d02578fda83a9f8d(age) {
    if (!age || age <= 0) return 0;
    const bracket = (0, $1abe73eeef086faf$export$89d00d368c27d070).find((b)=>age <= b.age);
    return bracket ? bracket.rate : 0;
}
function $bf7afaad28ce9e40$export$171d235b443bf362(value, income, ownerAge, who = 'the owner') {
    const balance = parseFloat(String(value ?? '')) || 0;
    const payment = parseFloat(String(income ?? '')) || 0;
    if (balance <= 0 || payment <= 0) return {
        state: 'not-applicable'
    };
    /*
     * THE CASE THAT USED TO VANISH. A balance and a payment are present, so the client plainly
     * expects the check to run — but with no date of birth there is no age and no minimum. Saying so
     * is the only honest answer, and it points at the fix.
     */ if (!ownerAge || ownerAge <= 0) return {
        state: 'unknown-age',
        who: who
    };
    const rate = $bf7afaad28ce9e40$export$d02578fda83a9f8d(ownerAge);
    const minimumPayment = balance * rate;
    // A cent of tolerance: a payment set exactly at the minimum must not read as a breach.
    if (payment < minimumPayment - 0.01) return {
        state: 'below',
        minimumPayment: minimumPayment,
        rate: rate,
        age: ownerAge,
        shortfall: minimumPayment - payment
    };
    return {
        state: 'ok',
        minimumPayment: minimumPayment,
        rate: rate,
        age: ownerAge
    };
}


const $147efcf1cef318bc$var$PensionMinimumWarning = ({ asset: asset, ownerAge: ownerAge, ownerName: ownerName })=>{
    if (!asset) return null;
    const result = (0, $bf7afaad28ce9e40$export$171d235b443bf362)(asset.value, asset.income, ownerAge, ownerName || 'the owner');
    if (result.state === 'below') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-2 flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-100 p-2 text-xs text-amber-800",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                size: 18,
                className: "mt-0.5 flex-shrink-0 text-amber-600"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    "Warning: The annual payment is below the required minimum of",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(result.minimumPayment)
                    }),
                    " (which is",
                    ' ',
                    (result.rate * 100).toFixed(2),
                    "% for age ",
                    result.age,
                    ")."
                ]
            })
        ]
    });
    if (result.state === 'unknown-age') /*
         * The state that used to be invisible. A balance and a payment are entered, so the client
         * expects this checked — and the reason we cannot is something they can fix in one step.
         */ return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-2 flex items-start gap-2 rounded-lg border border-slate-200 bg-slate-50 p-2 text-xs text-slate-600",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c00fae44777e2393$export$2e2bcd8739ae039), {
                size: 18,
                className: "mt-0.5 flex-shrink-0 text-slate-400"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    "We can't check this against the minimum drawdown until we know ",
                    result.who,
                    "'s date of birth \u2014 the minimum depends on age. Add it in ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "Your Details"
                    }),
                    "."
                ]
            })
        ]
    });
    return null;
};
var $147efcf1cef318bc$export$2e2bcd8739ae039 = $147efcf1cef318bc$var$PensionMinimumWarning;


/**
 * RentalExpensesCalculator.js – modal to estimate annual rental expenses (management, maintenance, rates, insurance, etc.).
 * Used in Client Profile Step 4 (Family Home). Props: onClose, onSave, propertyValue, weeklyRent, currentExpenses.
 */ 

var $acw62 = parcelRequire("acw62");



const $2eb3027f7a6469b1$var$RentalExpensesCalculator = ({ onClose: onClose, onSave: onSave, propertyValue: propertyValue, weeklyRent: weeklyRent, currentExpenses: currentExpenses })=>{
    const [propertyType, setPropertyType] = (0, $acw62.useState)('house');
    const [expenses, setExpenses] = (0, $acw62.useState)({
        managementFees: 0,
        maintenance: 0,
        landTax: 0,
        councilRates: 0,
        insurance: 0,
        strata: 0,
        other: 0
    });
    (0, $acw62.useEffect)(()=>{
        const annualRent = weeklyRent * 52;
        const managementFees = annualRent * 0.08;
        let maintenanceRate;
        if (propertyValue <= 1000000) maintenanceRate = 0.015;
        else if (propertyValue <= 2000000) maintenanceRate = 0.01;
        else maintenanceRate = 0.0075;
        const maintenance = propertyValue * maintenanceRate;
        setExpenses((prev)=>({
                ...prev,
                managementFees: managementFees || 0,
                maintenance: maintenance || 0
            }));
    }, [
        weeklyRent,
        propertyValue
    ]);
    (0, $acw62.useEffect)(()=>{
        currentExpenses > 0 && expenses.managementFees === 0 && expenses.maintenance;
    }, [
        currentExpenses
    ]);
    const handleUpdate = (field, value)=>{
        setExpenses((prev)=>({
                ...prev,
                [field]: value ?? 0
            }));
    };
    const total = (0, $acw62.useMemo)(()=>Object.values(expenses).reduce((sum, val)=>sum + val, 0), [
        expenses
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white rounded-2xl shadow-2xl p-6 w-full max-w-2xl max-h-[90vh] flex flex-col",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex justify-between items-center mb-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                            className: "text-2xl font-bold text-gray-800 flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $27f56d6cfb7d79f8$export$2e2bcd8739ae039), {}),
                                " Rental Expenses Calculator"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: onClose,
                            className: "p-2 hover:bg-gray-200 rounded-full transition-all duration-300 hover:scale-110",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-sm text-gray-600 mb-4",
                    children: "Calculate your estimated annual expenses if you were to rent out your property. Some values are auto-calculated based on your property value and rent amount."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mb-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "block text-sm font-medium text-gray-700 mb-2",
                            children: "Property Type"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex gap-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setPropertyType('house'),
                                    className: `px-4 py-2 rounded-lg font-semibold transition-colors ${propertyType === 'house' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`,
                                    children: "House"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setPropertyType('apartment'),
                                    className: `px-4 py-2 rounded-lg font-semibold transition-colors ${propertyType === 'apartment' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`,
                                    children: "Apartment"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex-1 overflow-y-auto pr-2 space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-white p-4 rounded-lg border border-blue-200",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-xs font-semibold text-blue-900 mb-3",
                                    children: "Auto-Calculated (based on your inputs)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "grid grid-cols-2 items-center gap-4",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            className: "font-medium text-gray-700",
                                                            children: "Property Management Fees"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-xs text-gray-500",
                                                            children: "8% of annual rent"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                            name: "managementFees",
                                                            value: expenses.managementFees || '',
                                                            onChange: (v)=>handleUpdate('managementFees', v)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-xs text-gray-500 mt-1",
                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(expenses.managementFees)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "grid grid-cols-2 items-center gap-4",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            className: "font-medium text-gray-700",
                                                            children: "Repairs & Maintenance"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-xs text-gray-500",
                                                            children: [
                                                                propertyValue <= 1000000 ? '1.5%' : propertyValue <= 2000000 ? '1%' : '0.75%',
                                                                " of property value"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                            name: "maintenance",
                                                            value: expenses.maintenance || '',
                                                            onChange: (v)=>handleUpdate('maintenance', v)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-xs text-gray-500 mt-1",
                                                            children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(expenses.maintenance)
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                propertyType === 'house' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "grid grid-cols-2 items-center gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            className: "font-medium text-gray-700",
                                            children: "Land Tax ($)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                            name: "landTax",
                                            value: expenses.landTax || '',
                                            onChange: (v)=>handleUpdate('landTax', v)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "grid grid-cols-2 items-center gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            className: "font-medium text-gray-700",
                                            children: "Council Rates ($)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                            name: "councilRates",
                                            value: expenses.councilRates || '',
                                            onChange: (v)=>handleUpdate('councilRates', v)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "grid grid-cols-2 items-center gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            className: "font-medium text-gray-700",
                                            children: "Landlord's Insurance ($)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                            name: "insurance",
                                            value: expenses.insurance || '',
                                            onChange: (v)=>handleUpdate('insurance', v)
                                        })
                                    ]
                                }),
                                propertyType === 'apartment' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "grid grid-cols-2 items-center gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            className: "font-medium text-gray-700",
                                            children: "Strata / Body Corporate ($)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                            name: "strata",
                                            value: expenses.strata || '',
                                            onChange: (v)=>handleUpdate('strata', v)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "grid grid-cols-2 items-center gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            className: "font-medium text-gray-700",
                                            children: "Other Expenses ($)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                            name: "other",
                                            value: expenses.other || '',
                                            onChange: (v)=>handleUpdate('other', v)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mt-6 pt-4 border-t flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-xl font-bold",
                            children: [
                                "Total Annual Expenses: ",
                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(total)
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: ()=>onSave(total),
                            className: "px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-md hover:shadow-lg transition-all",
                            children: "Save Expenses"
                        })
                    ]
                })
            ]
        })
    });
};
var $2eb3027f7a6469b1$export$2e2bcd8739ae039 = $2eb3027f7a6469b1$var$RentalExpensesCalculator;


/**
 * BudgetCalculator.js – modal to set annual living expenses from ASFA Comfortable Standard categories.
 * Used in Client Profile Step 7 (Income/Expenses). Props: onClose, onSave, isPartnered.
 */ 

var $acw62 = parcelRequire("acw62");




const $0c33f1005a2d7660$var$BudgetCalculator = ({ onClose: onClose, onSave: onSave, isPartnered: isPartnered })=>{
    const budgetType = isPartnered ? 'couple' : 'single';
    const initialBudget = (0, $898ebfdbe190c9ba$export$8b6758150468ace7)[budgetType].categories;
    const [budget, setBudget] = (0, $acw62.useState)(initialBudget);
    const handleUpdate = (category, value)=>{
        setBudget((prev)=>({
                ...prev,
                [category]: value ?? 0
            }));
    };
    const total = (0, $acw62.useMemo)(()=>Object.values(budget).reduce((sum, val)=>sum + val, 0), [
        budget
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white rounded-2xl shadow-2xl p-6 w-full max-w-2xl max-h-[90vh] flex flex-col",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex justify-between items-center mb-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                            className: "text-2xl font-bold text-gray-800 flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $27f56d6cfb7d79f8$export$2e2bcd8739ae039), {}),
                                " Budget Calculator"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: onClose,
                            className: "p-2 hover:bg-gray-200 rounded-full transition-all duration-300 hover:scale-110",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-sm text-gray-600 mb-4",
                    children: "These figures are based on the ASFA Comfortable Standard for the March 2025 quarter. Adjust them to match your personal spending."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex-1 overflow-y-auto pr-2 space-y-4",
                    children: Object.entries(budget).map(([category, amount])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "grid grid-cols-2 items-center gap-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "font-medium text-gray-700",
                                    children: category
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                    name: category,
                                    value: amount,
                                    onChange: (v)=>handleUpdate(category, v)
                                })
                            ]
                        }, category))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mt-6 pt-4 border-t flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-xl font-bold",
                            children: [
                                "Total: ",
                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(total)
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: ()=>onSave(total),
                            className: "px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-md hover:shadow-lg",
                            children: "Save Budget"
                        })
                    ]
                })
            ]
        })
    });
};
var $0c33f1005a2d7660$export$2e2bcd8739ae039 = $0c33f1005a2d7660$var$BudgetCalculator;


/**
 * Client Profile Step 5 — trusts & companies fact-find (Phase 1a UI only).
 */ 

var $acw62 = parcelRequire("acw62");






/** Centrelink attribution help — plain language; not legal advice. */ const $00485cf07937db2b$var$buildApportionmentTooltip = (voice)=>`Centrelink often counts a family trust toward one person in full \u{2014} not automatically half each between a couple. Use ${voice.pronounPossessive} Centrelink letter or ${voice.pronounPossessive} accountant's advice. If you're not sure, leave 0% until you confirm.`;
const $00485cf07937db2b$var$ClientStructuresSection = ({ factFind: factFind, setFactFind: setFactFind, isPartnered: isPartnered, clientName: clientName, partnerName: partnerName, showAdviserFields: showAdviserFields = false, voice: voice })=>{
    const apportionmentTooltip = $00485cf07937db2b$var$buildApportionmentTooltip(voice);
    const [apportionmentErrors, setApportionmentErrors] = (0, $acw62.useState)({});
    const structures = factFind.structures || [];
    const gateAnswer = factFind.structuresGateAnswer ?? false;
    const homeIsEntity = factFind.home?.ownership === 'other_entity';
    const homePrefill = homeIsEntity && !gateAnswer;
    const setGateAnswer = async (value)=>{
        if (!value && homeIsEntity) {
            const proceed = await (0, $8e1e84c918e07c84$export$71edf76f07903b9c)(`On the previous step you said ${voice.possessive} home is owned by a trust or company. If you continue, we won't include that arrangement in the estimates until you update Step 4 or add the entity here.\n\nContinue without structures?`);
            if (!proceed) return;
        }
        setFactFind((prev)=>({
                ...prev,
                structuresGateAnswer: value,
                ...!value ? {
                    structures: [],
                    home: {
                        ...prev.home,
                        entityId: ''
                    }
                } : {}
            }));
        if (!value) setApportionmentErrors({});
    };
    const updateStructure = (id, field, value)=>{
        setFactFind((prev)=>({
                ...prev,
                structures: (prev.structures || []).map((s)=>s.id === id ? {
                        ...s,
                        [field]: value
                    } : s)
            }));
        if (field === 'apportionmentClient' || field === 'apportionmentPartner') setApportionmentErrors((prev)=>{
            const next = {
                ...prev
            };
            delete next[id || ''];
            return next;
        });
    };
    const addStructure = ()=>{
        setFactFind((prev)=>({
                ...prev,
                structuresGateAnswer: true,
                structures: [
                    ...prev.structures || [],
                    (0, $9a0fdbf41e16d1c8$export$6f799eb84f914055)()
                ]
            }));
    };
    const removeStructure = async (id)=>{
        const target = structures.find((s)=>s.id === id);
        const label = target?.name?.trim() || 'this arrangement';
        if (!await (0, $8e1e84c918e07c84$export$71edf76f07903b9c)(`Remove ${label}? Assets linked to it will need a new owner.`)) return;
        setFactFind((prev)=>{
            const nextStructures = (prev.structures || []).filter((s)=>s.id !== id);
            const nextAssets = {
                ...prev.assets
            };
            Object.keys(nextAssets).forEach((type)=>{
                nextAssets[type] = (nextAssets[type] || []).map((asset)=>asset.ownership === `entity:${id}` ? {
                        ...asset,
                        ownership: 'client'
                    } : asset);
            });
            const nextHome = prev.home?.entityId === id ? {
                ...prev.home,
                entityId: '',
                ownership: prev.home?.ownership === 'other_entity' ? 'client' : prev.home?.ownership
            } : prev.home;
            return {
                ...prev,
                structures: nextStructures,
                assets: nextAssets,
                home: nextHome,
                structuresGateAnswer: nextStructures.length > 0 ? true : prev.structuresGateAnswer
            };
        });
        setApportionmentErrors((prev)=>{
            const next = {
                ...prev
            };
            delete next[id || ''];
            return next;
        });
    };
    const blurApportionment = (structure)=>{
        const result = (0, $9a0fdbf41e16d1c8$export$58e17024df23706b)(structure, isPartnered);
        setApportionmentErrors((prev)=>({
                ...prev,
                [structure.id || '']: result.valid ? undefined : result.message
            }));
    };
    const linkHomeEntity = (entityId)=>{
        setFactFind((prev)=>({
                ...prev,
                home: {
                    ...prev.home,
                    entityId: entityId || ''
                }
            }));
    };
    const showStructuresBlock = gateAnswer === true;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                className: "text-lg font-semibold text-gray-700 mb-2",
                children: "Trusts & companies"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-sm text-gray-600 mb-4",
                children: "Some people hold investments or property through a family trust, company, or partnership \u2014 not in their own name."
            }),
            homePrefill && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex gap-2 p-3 rounded-lg bg-white border border-teal-200 text-sm text-teal-900",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                        className: "shrink-0 mt-0.5",
                        size: 18
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            "You told us ",
                            voice.possessive,
                            " home is owned by a trust or company. Please add that arrangement below."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                label: `Is any of ${voice.possessive} money or property held this way?`,
                name: "structuresGateAnswer",
                value: (0, $8ab044f9996773da$export$3b62265a75916bfa)(gateAnswer),
                onChange: (n, v)=>setGateAnswer((0, $8ab044f9996773da$export$1923fe087c479fde)(v)),
                options: [
                    {
                        label: voice.isThirdPerson ? `No \u{2014} everything is in ${voice.possessive} personal names` : "No \u2014 everything is in our personal names",
                        value: 'no'
                    },
                    {
                        label: voice.isThirdPerson ? `Yes \u{2014} ${voice.subject} ${voice.verb('have', 'has')} a trust, company, or similar` : "Yes \u2014 we have a trust, company, or similar",
                        value: 'yes'
                    }
                ]
            }),
            showStructuresBlock && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-6 pt-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                className: "text-md font-semibold text-gray-700 mb-2",
                                children: [
                                    voice.Possessive,
                                    " arrangements"
                                ]
                            }),
                            structures.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-gray-600 mb-3",
                                children: [
                                    "Add each trust, company, or partnership that holds assets for ",
                                    voice.pronounPossessive,
                                    " family."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "space-y-4",
                                children: structures.map((structure)=>{
                                    const apportionmentError = apportionmentErrors[structure.id || ''];
                                    const clientPct = parseFloat(String(structure.apportionmentClient)) || 0;
                                    const partnerPct = parseFloat(String(structure.apportionmentPartner)) || 0;
                                    const bothZero = clientPct === 0 && (!isPartnered || partnerPct === 0);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "p-4 bg-gray-50 rounded-lg border border-gray-200 space-y-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-between items-start gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-medium text-gray-800",
                                                        children: structure.name?.trim() || 'New arrangement'
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>removeStructure(structure.id),
                                                        className: "p-2 text-red-500 hover:text-red-700 hover:bg-red-100 rounded-full",
                                                        "aria-label": "Remove arrangement",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                            size: 18
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                                        label: `What ${voice.verb('do', 'does')} ${voice.subject} call this?`,
                                                        name: "name",
                                                        value: structure.name,
                                                        placeholder: "e.g. Smith Family Trust",
                                                        onChange: (n, v)=>updateStructure(structure.id, n, v)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            children: [
                                                                "What type is it?",
                                                                ' ',
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                                    text: `Choose the closest match. If you're unsure, pick Other and check with ${voice.pronounPossessive} accountant.`
                                                                })
                                                            ]
                                                        }),
                                                        name: "type",
                                                        value: structure.type || 'family_trust',
                                                        onChange: (n, v)=>updateStructure(structure.id, n, v),
                                                        children: (0, $1773fcf9595c5c0a$export$e2e42979292e1004).map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: t.id,
                                                                children: t.label
                                                            }, t.id))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "border-t border-gray-200 pt-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-sm font-semibold text-gray-700 mb-1",
                                                        children: "For Age Pension and care fee estimates"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-sm text-gray-600 mb-3",
                                                        children: "What percentage of this arrangement does Centrelink count toward each person?"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd6bad1410bfbf4$export$2e2bcd8739ae039), {
                                                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    children: [
                                                                        "Counted toward ",
                                                                        isPartnered || voice.isThirdPerson ? clientName : 'you',
                                                                        " (%)",
                                                                        ' ',
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                                            text: apportionmentTooltip
                                                                        })
                                                                    ]
                                                                }),
                                                                name: "apportionmentClient",
                                                                value: structure.apportionmentClient,
                                                                onChange: (v)=>{
                                                                    updateStructure(structure.id, 'apportionmentClient', v);
                                                                    blurApportionment({
                                                                        ...structure,
                                                                        apportionmentClient: v
                                                                    });
                                                                }
                                                            }),
                                                            isPartnered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd6bad1410bfbf4$export$2e2bcd8739ae039), {
                                                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    children: [
                                                                        "Counted toward ",
                                                                        partnerName,
                                                                        " (%)",
                                                                        ' ',
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                                            text: apportionmentTooltip
                                                                        })
                                                                    ]
                                                                }),
                                                                name: "apportionmentPartner",
                                                                value: structure.apportionmentPartner,
                                                                onChange: (v)=>{
                                                                    updateStructure(structure.id, 'apportionmentPartner', v);
                                                                    blurApportionment({
                                                                        ...structure,
                                                                        apportionmentPartner: v
                                                                    });
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    apportionmentError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-sm text-red-600 mt-2",
                                                        children: apportionmentError
                                                    }),
                                                    bothZero && !apportionmentError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex gap-2 p-2 mt-2 rounded bg-white border border-slate-200 border-l-4 border-l-amber-400 text-xs text-slate-700",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                                                className: "shrink-0",
                                                                size: 14
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "This arrangement won't affect pension or care fee estimates until you enter a percentage above 0%."
                                                            })
                                                        ]
                                                    }),
                                                    (()=>{
                                                        const remainder = (0, $1773fcf9595c5c0a$export$292b9fd0d68dfd69)(structure, isPartnered);
                                                        if (remainder <= 0 || apportionmentError) return null;
                                                        const remainderLabel = Number.isInteger(remainder) ? String(remainder) : remainder.toFixed(1).replace(/\.0$/, '');
                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-sm text-gray-600 mt-3 leading-relaxed",
                                                            children: [
                                                                "The remaining ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                                    children: [
                                                                        remainderLabel,
                                                                        "%"
                                                                    ]
                                                                }),
                                                                " is treated as belonging to other family members (for example children). When you add assets owned by this trust or company, enter the",
                                                                ' ',
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "full value"
                                                                }),
                                                                " of each asset \u2014 we apply the percentages above for",
                                                                ' ',
                                                                voice.possessive,
                                                                " net worth and estimates."
                                                            ]
                                                        });
                                                    })(),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-sm text-gray-600 mt-3 leading-relaxed",
                                                        children: "Where you link assets to this entity, we have assumed the income from the asset will be apportioned as above."
                                                    })
                                                ]
                                            }),
                                            showAdviserFields && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            children: [
                                                                "Override \u2014 actual distributions ($ p.a.)",
                                                                ' ',
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                                    text: `When set, can replace asset-based cashflow and (if selected below) pension and care fee income estimates. Tax still uses asset income unless ${voice.pronounPossessive} accountant advises otherwise.`
                                                                })
                                                            ]
                                                        }),
                                                        name: "annualDistributionPa",
                                                        value: structure.annualDistributionPa ?? '',
                                                        placeholder: "Blank = estimate from assets",
                                                        onChange: (v)=>updateStructure(structure.id, 'annualDistributionPa', v)
                                                    }),
                                                    parseFloat(String(structure.annualDistributionPa)) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                        label: "Use distribution for pension & care fee income test?",
                                                        name: "useDistributionForMeansTest",
                                                        value: (0, $8ab044f9996773da$export$3b62265a75916bfa)(structure.useDistributionForMeansTest ?? true),
                                                        onChange: (n, v)=>updateStructure(structure.id, n, (0, $8ab044f9996773da$export$1923fe087c479fde)(v)),
                                                        options: [
                                                            {
                                                                label: 'Yes (match Centrelink letter)',
                                                                value: 'yes'
                                                            },
                                                            {
                                                                label: "No \u2014 cashflow only",
                                                                value: 'no'
                                                            }
                                                        ]
                                                    })
                                                ]
                                            }),
                                            showAdviserFields && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                                label: "Notes (optional)",
                                                name: "notes",
                                                value: structure.notes,
                                                placeholder: "e.g. From accountant letter dated \u2026",
                                                onChange: (n, v)=>updateStructure(structure.id, n, v)
                                            })
                                        ]
                                    }, structure.id);
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: addStructure,
                                className: "mt-4 flex items-center gap-2 px-4 py-2 bg-blue-100 text-blue-700 font-semibold rounded-lg hover:bg-blue-200",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4da941c85c0c5fe$export$2e2bcd8739ae039), {
                                        size: 20
                                    }),
                                    " Add trust or company"
                                ]
                            })
                        ]
                    }),
                    homeIsEntity && structures.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-4 rounded-lg border-2 border-teal-200 bg-white space-y-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                className: "font-semibold text-gray-800",
                                children: voice.isThirdPerson ? `${voice.Possessive} home` : 'Your family home'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-gray-600",
                                children: "You told us the home is owned by a trust or company. Which one holds the title?"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                label: "Home owner on title",
                                name: "homeEntityId",
                                value: factFind.home?.entityId || '',
                                onChange: (n, v)=>linkHomeEntity(v),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "Select an arrangement\u2026"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "__unsure__",
                                        children: "I'm not sure yet"
                                    }),
                                    structures.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: s.id,
                                            children: s.name?.trim() || 'Unnamed arrangement'
                                        }, s.id))
                                ]
                            }),
                            factFind.home?.entityId && factFind.home.entityId !== '__unsure__' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-teal-800",
                                children: [
                                    "\u2713 ",
                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(parseFloat(String(factFind.home?.value)) || 0),
                                    " home included under",
                                    ' ',
                                    structures.find((s)=>s.id === factFind.home?.entityId)?.name?.trim() || 'selected arrangement'
                                ]
                            }),
                            factFind.home?.entityId === '__unsure__' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-amber-800",
                                children: [
                                    "We'll show ",
                                    voice.possessive,
                                    " home separately until you link it to an arrangement. Pension and care fee estimates may be incomplete."
                                ]
                            }),
                            homeIsEntity && !factFind.home?.entityId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex gap-2 text-sm text-slate-700",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                        className: "shrink-0",
                                        size: 16
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "Link ",
                                            voice.possessive,
                                            " home to a trust or company so we can include it correctly."
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $00485cf07937db2b$export$2e2bcd8739ae039 = $00485cf07937db2b$var$ClientStructuresSection;







/**
 * A living-arrangement goal's label, carrying the SAME icon as the insight card that appears
 * beside it once the box is ticked — both read `GOAL_INSIGHTS[key].icon`, so the row and its
 * explanation can never drift apart.
 *
 * Only the living-arrangement group gets these. They are concrete, depictable places; the
 * financial goals below them ("Preserve Assets For Inheritance") are abstract, and inventing
 * pictures for them is where an interface starts looking generic. Icons on one group and not the
 * other also does useful work: it separates places to live from priorities to weigh.
 */ const $9f897eee40813319$var$goalLabel = (goalKey, text)=>{
    const Icon = (0, $af797c9747431756$export$4c8d4692eb54c080)[goalKey]?.icon;
    if (!Icon) return text;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "flex items-center gap-2 min-w-0",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                size: 16,
                className: "text-blue-600 shrink-0",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "min-w-0",
                children: text
            })
        ]
    });
};
/**
 * The age a date of birth works out to, shown right under the field.
 *
 * Asked for by an adviser: a date of birth is what the form collects, but age is what the
 * conversation and the rules are actually about — pension age, the drawdown brackets, means-test
 * thresholds — and doing the arithmetic in your head for two people is friction the tool can
 * remove. Silent until the date is complete and sane, so it never flickers a stray number while a
 * year is being typed.
 */ const $9f897eee40813319$var$AgeHint = ({ dob: dob })=>{
    if (!dob) return null;
    const age = (0, $5589d9476399db47$export$8ada184d5eef4694)(dob);
    if (age === null || !Number.isFinite(age) || age < 0 || age > 120) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        className: "mt-1 text-sm text-gray-500",
        children: [
            "Age ",
            age
        ]
    });
};
const $9f897eee40813319$var$StepHeader = ({ icon: icon, step: step, title: title })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-4 mb-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f7020238dfb168a$export$2e2bcd8739ae039), {
                icon: icon,
                tone: "brand",
                variant: "solid",
                size: "lg"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-[11px] font-semibold uppercase tracking-wider text-blue-600/80",
                        children: [
                            "Step ",
                            step
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-2xl font-bold text-gray-900 leading-tight",
                        children: title
                    })
                ]
            })
        ]
    });
/**
 * Photographs for the "who is completing this form?" cards, hotlinked from Unsplash the same way
 * MainAppLayout sources its page backdrops. Each was chosen to be recognisable at a glance from
 * across the room — the whole point of this step is that the answer is picked deliberately rather
 * than left on the default of a dropdown nobody read.
 */ const $9f897eee40813319$var$completerPhoto = (id)=>(0, $5bb9a0b2f90fb898$export$260036ae09c24358)(id, 640, 420);
/* Photos are decorative (`alt=""`): the label and description already say what each card means, and
   describing the picture as well would read out ahead of the choice on every radio. */ const $9f897eee40813319$var$COMPLETER_OPTIONS = [
    {
        id: 'client',
        label: 'I am the person seeking advice',
        description: 'Planning for yourself, or for you and your partner together.',
        image: $9f897eee40813319$var$completerPhoto('1658632302217-984d432b4d38')
    },
    {
        id: 'family',
        label: 'I am a family member',
        description: 'A son, daughter or other relative helping someone you care about.',
        image: $9f897eee40813319$var$completerPhoto('1741651366517-cf81c7de3868')
    },
    {
        id: 'eop',
        // Reworded because a reader who was BOTH a son and his father's attorney could not tell
        // which card was his (client meeting, 2026-08-20). Naming the family case here, and the
        // tie-break line under the grid, settles it: the formal role wins.
        label: 'I hold Enduring Power of Attorney',
        description: 'A relative or other person formally authorised to make financial decisions.',
        image: $9f897eee40813319$var$completerPhoto('1664463760781-f159dfe3af30')
    },
    {
        id: 'professional',
        label: 'I am a professional',
        description: 'An adviser, accountant, lawyer or care manager acting for a client.',
        image: $9f897eee40813319$var$completerPhoto('1551836022-aadb801c60ae')
    }
];
/**
 * Step 1 — who is filling this in. Its own step because the answer changes every screen that
 * follows: it flips the whole fact-find between "your home" and "Bob & Sally's home" (see
 * utils/applicantVoice.ts), and drives the estate-planning and mental-capacity prompts on the last
 * step. As a dropdown among other Setup fields it was easy to miss and easy to leave on its
 * default, so the fact-find spoke to a daughter as though she were her mother.
 */ const $9f897eee40813319$export$f9f29a3c1409fd2d = ({ factFind: factFind, setMainData: setMainData })=>{
    const selected = factFind.completer || 'client';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$StepHeader, {
                icon: (0, $0d957a6b316cfc10$export$2e2bcd8739ae039),
                step: 1,
                title: "Who Is Completing This Form?"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                                className: "sr-only",
                                children: "Who is completing this form?"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-600 mb-3 max-w-2xl",
                                children: "Everything that follows is worded around this answer, so it's worth getting right. You can change it at any time by coming back to this step."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-gray-500 mb-6 max-w-2xl",
                                children: "More than one fits? Choose the one with the formal role \u2014 Enduring Power of Attorney if you hold it."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 gap-5",
                                children: $9f897eee40813319$var$COMPLETER_OPTIONS.map((option)=>{
                                    const isSelected = selected === option.id;
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "block cursor-pointer",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "radio",
                                                name: "completer",
                                                value: option.id,
                                                checked: isSelected,
                                                onChange: ()=>setMainData('completer', option.id),
                                                className: "peer sr-only"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: `h-full overflow-hidden rounded-2xl border-2 bg-white transition-all duration-200 peer-focus-visible:ring-2 peer-focus-visible:ring-[#0290F5] peer-focus-visible:ring-offset-2 ${isSelected ? 'border-[#0F52E0] shadow-cardlg' : 'border-slate-200 shadow-card hover:border-slate-300 hover:shadow-cardlg'}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "relative bg-slate-100 ",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                src: option.image,
                                                                alt: "",
                                                                loading: "lazy",
                                                                className: "h-40 w-full object-cover sm:h-44",
                                                                // A blocked or failed photo should leave the soft gradient behind it,
                                                                // not a broken-image glyph — the card still reads fine without it.
                                                                onError: (e)=>{
                                                                    e.currentTarget.style.display = 'none';
                                                                }
                                                            }),
                                                            isSelected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-[#0F52E0] text-white shadow-md",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                                                    size: 18,
                                                                    strokeWidth: 3
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "p-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: `text-base font-semibold leading-snug ${isSelected ? 'text-[#001E7A]' : 'text-gray-900'}`,
                                                                children: option.label
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "mt-1 text-sm text-gray-600",
                                                                children: option.description
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, option.id);
                                })
                            })
                        ]
                    }),
                    selected !== 'client' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                                className: "text-lg font-semibold text-gray-700 mb-4",
                                children: "Your Details (as the person completing this form)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                        label: "Your First Name",
                                        name: "completerFirstName",
                                        value: factFind.completerFirstName || '',
                                        onChange: (n, v)=>setMainData(n, v)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                        label: "Your Last Name",
                                        name: "completerLastName",
                                        value: factFind.completerLastName || '',
                                        onChange: (n, v)=>setMainData(n, v)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                        label: "Your Relationship to Applicant",
                                        name: "completerRelationship",
                                        value: factFind.completerRelationship || '',
                                        onChange: (n, v)=>setMainData(n, v)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $9f897eee40813319$export$9d5c5991cdca0dad = ({ factFind: factFind, updateFactFind: updateFactFind, setMainData: setMainData, isPartnered: isPartnered, hideApplicantContactFields: hideApplicantContactFields = true, voice: voice })=>{
    /*
     * TRI-STATE, not defaulted to No (owner, 23 Sep 2026). Private cover decides whether the Medicare
     * levy surcharge applies, so a seeded "No" answered a tax question on the client's behalf and put
     * a figure in their cashflow they never stated. Unanswered now shows as unanswered; the engine
     * still models no cover until told otherwise, which is the conservative direction, and the
     * Assumptions page discloses it.
     */ const handleCouplePhiChange = (name, value)=>{
        const phi = (0, $8ab044f9996773da$export$87f1f3a36f1f2332)(value);
        updateFactFind('client', 'phi', phi);
        if (isPartnered) updateFactFind('partner', 'phi', phi);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$StepHeader, {
                icon: (0, $0f45c1e8ae52ad76$export$2e2bcd8739ae039),
                step: 2,
                title: `${voice.Possessive} Details`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                                className: "text-lg font-semibold text-gray-700 mb-4",
                                children: "Setup"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                label: "Who are we providing advice for?",
                                name: "adviceFor",
                                value: factFind.adviceFor || 'single',
                                onChange: (n, val)=>setMainData(n, val),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "single",
                                        children: "A single person"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "couple",
                                        children: "A member of a couple"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("legend", {
                                className: "text-lg font-semibold text-gray-700 mb-4",
                                children: [
                                    voice.Possessive,
                                    " Details"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                        label: "First Name",
                                        name: "firstName",
                                        value: factFind.client?.firstName || '',
                                        onChange: (n, v)=>updateFactFind('client', n, v)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                        label: "Last Name",
                                        name: "lastName",
                                        value: factFind.client?.lastName || '',
                                        onChange: (n, v)=>updateFactFind('client', n, v)
                                    }),
                                    !hideApplicantContactFields && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                                label: "Email",
                                                name: "email",
                                                type: "email",
                                                value: factFind.client?.email || '',
                                                onChange: (n, v)=>updateFactFind('client', n, v),
                                                placeholder: "Optional"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                                label: "Preferred phone number",
                                                name: "preferredPhone",
                                                type: "tel",
                                                value: factFind.client?.preferredPhone || '',
                                                onChange: (n, v)=>updateFactFind('client', n, v)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                                label: "Date of Birth",
                                                name: "dob",
                                                type: "date",
                                                value: factFind.client?.dob || '',
                                                onChange: (n, v)=>updateFactFind('client', n, v)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$AgeHint, {
                                                dob: factFind.client?.dob
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                label: "Sex",
                                                name: "sex",
                                                value: factFind.client?.sex || '',
                                                onChange: (n, v)=>updateFactFind('client', n, v),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Prefer not to say"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "female",
                                                        children: "Female"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "male",
                                                        children: "Male"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-xs text-gray-500 mt-1",
                                                children: "Only used for the life-expectancy rules that apply to a lifetime annuity. Optional."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-xs text-gray-500 md:col-span-2 -mb-2",
                                        children: [
                                            "Health details are sensitive information and optional. ",
                                            voice.Possessive,
                                            " health helps us decide whether strategies that take years to pay off are worth considering. Leave it blank if ",
                                            voice.subject,
                                            " would rather not share it, and no judgement is made on it."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                        label: "Health Status",
                                        name: "healthStatus",
                                        value: factFind.client?.healthStatus || '',
                                        onChange: (n, v)=>updateFactFind('client', n, v),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Select..."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "good",
                                                children: "Good - Independent with no major health concerns."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "fair",
                                                children: "Fair - Some health issues, may need minor assistance."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "poor",
                                                children: "Poor - Significant health issues requiring regular assistance."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                        label: "Has Private Health Insurance?",
                                        name: "clientPhi",
                                        value: (0, $8ab044f9996773da$export$71dc53db491defdf)(factFind.client?.phi),
                                        onChange: handleCouplePhiChange,
                                        options: [
                                            {
                                                label: 'Yes',
                                                value: 'yes'
                                            },
                                            {
                                                label: 'No',
                                                value: 'no'
                                            }
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    isPartnered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                                className: "text-lg font-semibold text-gray-700 mb-4",
                                children: "Partner's Details"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                        label: "Partner's First Name",
                                        name: "firstName",
                                        value: factFind.partner?.firstName || '',
                                        onChange: (n, v)=>updateFactFind('partner', n, v)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                        label: "Partner's Last Name",
                                        name: "lastName",
                                        value: factFind.partner?.lastName || '',
                                        onChange: (n, v)=>updateFactFind('partner', n, v)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                                label: "Partner's Date of Birth",
                                                name: "dob",
                                                type: "date",
                                                value: factFind.partner?.dob || '',
                                                onChange: (n, v)=>updateFactFind('partner', n, v)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$AgeHint, {
                                                dob: factFind.partner?.dob
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                label: "Partner's Sex",
                                                name: "sex",
                                                value: factFind.partner?.sex || '',
                                                onChange: (n, v)=>updateFactFind('partner', n, v),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Prefer not to say"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "female",
                                                        children: "Female"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "male",
                                                        children: "Male"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-xs text-gray-500 mt-1",
                                                children: "Only used for the life-expectancy rules that apply to a lifetime annuity. Optional."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                        label: "Partner's Health Status",
                                        name: "healthStatus",
                                        value: factFind.partner?.healthStatus || '',
                                        onChange: (n, v)=>updateFactFind('partner', n, v),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Select..."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "good",
                                                children: "Good - Independent with no major health concerns."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "fair",
                                                children: "Fair - Some health issues, may need minor assistance."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "poor",
                                                children: "Poor - Significant health issues requiring regular assistance."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                        label: "Has Private Health Insurance?",
                                        name: "partnerPhi",
                                        value: (0, $8ab044f9996773da$export$71dc53db491defdf)(factFind.partner?.phi),
                                        onChange: handleCouplePhiChange,
                                        options: [
                                            {
                                                label: 'Yes',
                                                value: 'yes'
                                            },
                                            {
                                                label: 'No',
                                                value: 'no'
                                            }
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $9f897eee40813319$var$AcatAssessmentSection = ({ person: person, personData: personData, updatePersonAcat: updatePersonAcat, personName: personName, voice: voice })=>{
    /*
     * "No" is the most consequential answer on this step, and until 2026-08-28 it was also the
     * deadest: it recorded a fact and moved on. The client then met the Support at Home module with
     * no idea what was about to be asked of them, and no idea an entry-level program exists at all.
     *
     * The fork panel below is shown for BOTH 'no' and 'in_progress' — someone mid-assessment has
     * exactly the same question and exactly the same unknown answer.
     */ const [compareOpen, setCompareOpen] = (0, $acw62.useState)(false);
    const awaitingAssessment = personData?.status === 'no' || personData?.status === 'in_progress';
    // This section is already per-person, so third person names the individual rather than the
    // couple — "Was Sally in receipt of…", not "Were Bob & Sally in receipt of…".
    // Named whenever the person is not the one reading: the partner's section, a family member or adviser
    // completing, or an adviser viewing (25 Oct 2026: "does you have" read on Kerry's section).
    const named = voice.isThirdPerson || person === 'partnerAcat' || (0, $5d864ab5b3ee155d$export$879d88d360a0f068)();
    const who = named ? personName : 'you';
    const whose = named ? `${personName}'s` : 'your';
    const wasWere = named ? 'Was' : 'Were';
    const handleHomeCareChange = (level)=>{
        updatePersonAcat(person, 'homeCareLevel', level);
    };
    const handleOtherCareChange = (type, isChecked)=>{
        const currentRecommendation = personData?.recommendation || {};
        updatePersonAcat(person, 'recommendation', {
            ...currentRecommendation,
            [type]: isChecked
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-4 pt-4 border-t border-dashed",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "font-semibold text-gray-800 mb-2",
                children: [
                    personName,
                    "'s Assessment"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "block text-sm font-medium text-gray-700 mb-2",
                        children: "Has an assessment been completed?"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex flex-wrap items-center gap-4",
                                children: [
                                    {
                                        label: 'Yes',
                                        value: 'yes'
                                    },
                                    {
                                        label: 'No',
                                        value: 'no'
                                    },
                                    {
                                        label: 'In Progress',
                                        value: 'in_progress'
                                    }
                                ].map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "flex cursor-pointer items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "radio",
                                                name: `status_${person}`,
                                                value: opt.value,
                                                checked: personData?.status === opt.value,
                                                onChange: (e)=>updatePersonAcat(person, 'status', e.target.value),
                                                className: "h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm text-gray-700",
                                                children: opt.label
                                            })
                                        ]
                                    }, opt.value))
                            }),
                            awaitingAssessment && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $73bacbfa279634e3$export$2e2bcd8739ae039), {
                                status: personData.status,
                                className: "self-start sm:ml-auto"
                            })
                        ]
                    })
                ]
            }),
            awaitingAssessment && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02b552f3b0af8007$export$4dc872a89ff11540), {
                        who: named ? personName : undefined,
                        onCompare: ()=>setCompareOpen(true),
                        className: "mt-4"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02b552f3b0af8007$export$7753eabeacd6f0b2), {
                        open: compareOpen,
                        onClose: ()=>setCompareOpen(false)
                    })
                ]
            }),
            personData?.status === 'yes' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-4 space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white border border-blue-200 rounded-lg p-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        "Before 13 September 2024, ",
                                        wasWere,
                                        " ",
                                        who,
                                        " already getting government-funded care at home (a Home Care Package), or approved for one \u2014 including being on the waiting list?",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                            text: `Most people can answer No. Answer Yes only if ${who} had a Home Care Package, or had been approved for one at the aged care assessment, by 12 September 2024 \u{2014} even if the package never arrived because ${who} ${named ? 'was' : 'were'} still on the waiting list. The approval date is on the letter from My Aged Care after the assessment, or in the My Aged Care online account; My Aged Care (1800 200 422) can confirm it. Why we ask: under the Department's 'no worse off' principle it changes which fees apply \u{2014} in Support at Home and in an aged care home \u{2014} and usually lowers them. If you choose Unsure we use the standard rules, which are usually higher, and you can update this later.`
                                        })
                                    ]
                                }),
                                name: `hcpBeforeSep2024_${person}`,
                                value: personData.hcpBeforeSep2024 || '',
                                onChange: (n, v)=>updatePersonAcat(person, n.replace(`_${person}`, ''), v),
                                options: [
                                    {
                                        label: 'Yes',
                                        value: 'yes'
                                    },
                                    {
                                        label: 'No',
                                        value: 'no'
                                    },
                                    {
                                        label: 'Unsure',
                                        value: 'unsure'
                                    }
                                ]
                            }),
                            personData.hcpBeforeSep2024 === 'unsure' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-3 p-3 bg-blue-100 rounded border border-blue-300",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-xs text-blue-800",
                                    children: "No problem \u2014 we'll use the standard rules, which are usually the higher estimate, for Support at Home and for an aged care home. The approval date is on the letter from My Aged Care after the assessment, or you can call My Aged Care on 1800 200 422; update this any time."
                                })
                            }),
                            personData.hcpBeforeSep2024 === 'yes' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-3 p-3 bg-blue-100 rounded border border-blue-300",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-xs text-blue-900 mb-2 font-semibold",
                                        children: "What this means"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-xs text-blue-800 mb-3",
                                        children: [
                                            named ? personName : 'You',
                                            " ",
                                            named ? 'is' : 'are',
                                            " covered by the Department's \u2018no worse off\u2019 principle. In Support at Home that means reduced contribution rates (or none); in an aged care home it means the means-tested care fee instead of the hotelling and non-clinical care contributions. Two more details let the tool work out the exact figures \u2014 both are on the letters Services Australia sent about the package."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                        label: `Under the Home Care Package, ${named ? 'was' : 'were'} ${who} asked to pay an income-tested care fee? (It is named on Services Australia's fee letter for the package and on the provider's monthly statement.)`,
                                        name: `hcpCategory_${person}`,
                                        value: personData.hcpCategory || '',
                                        onChange: (n, v)=>updatePersonAcat(person, n.replace(`_${person}`, ''), v),
                                        options: [
                                            {
                                                label: "No \u2014 no income-tested care fee (nothing, or only the basic daily fee)",
                                                value: 'A'
                                            },
                                            {
                                                label: "Yes \u2014 an income-tested care fee of $1 a day or more",
                                                value: 'B'
                                            }
                                        ]
                                    }),
                                    personData.hcpCategory === 'B' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "block text-xs font-medium text-blue-900 mb-1",
                                                children: "The income-tested care fee under the package, per day (from the Services Australia fee letter or the provider's statement):"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                value: personData.previousITCF || '',
                                                onChange: (v)=>updatePersonAcat(person, 'previousITCF', v ?? 0),
                                                className: "text-sm",
                                                placeholder: "e.g., 37.70"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "block text-xs font-medium text-blue-900 mb-1",
                                                children: "Care contributions already paid, in total (income-tested care fees under the package and any Support at Home contributions) \u2014 optional:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                value: personData.priorCareContributionsPaid || '',
                                                onChange: (v)=>updatePersonAcat(person, 'priorCareContributionsPaid', v ?? 0),
                                                className: "text-sm",
                                                placeholder: "e.g., 4,200"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-1 text-xs text-blue-800",
                                                children: "Services Australia keeps this running total and states it in its letters. It counts towards the lifetime caps on care fees in Support at Home and in a home; leave it blank if you don't know it."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (()=>{
                        const levelBasis = personData.levelBasis ?? (personData.hcpBeforeSep2024 === 'yes' ? 'transitioned_hcp' : 'sah_classification');
                        const keys = levelBasis === 'transitioned_hcp' ? (0, $c220d08b55e5dd64$export$5e8d2d3fba9733e4) : (0, $c220d08b55e5dd64$export$712f07a1eb8135ac);
                        const current = personData.homeCareLevel || '';
                        const setBasis = (basis)=>{
                            updatePersonAcat(person, 'levelBasis', basis);
                            const allowed = basis === 'transitioned_hcp' ? (0, $c220d08b55e5dd64$export$5e8d2d3fba9733e4) : (0, $c220d08b55e5dd64$export$712f07a1eb8135ac);
                            if (current && !allowed.includes(current)) updatePersonAcat(person, 'homeCareLevel', '');
                        };
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-4",
                            "data-testid": `level-basis-${person}`,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "What kind of home care approval ",
                                            named ? `does ${who}` : 'do you',
                                            " have?",
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                text: `A Home Care Package approved before 1 November 2025 \u{2014} whether ${who} had started receiving it or ${named ? 'was' : 'were'} still on the waiting list \u{2014} became a 'transitioned' Support at Home level with the same funding as the package (levels 1 to 4). It stays that way until a new aged care assessment, which places ${who} in one of the eight Support at Home classifications. The level is on the My Aged Care approval letter; a classification is on the Notice of Decision from an assessment on or after 1 November 2025.`
                                            })
                                        ]
                                    }),
                                    name: `levelBasis_${person}`,
                                    value: levelBasis,
                                    onChange: (n, v)=>setBasis(String(v)),
                                    options: [
                                        {
                                            label: "A Home Care Package (level 1\u20134) approved before 1 November 2025, with no new assessment since",
                                            value: 'transitioned_hcp'
                                        },
                                        {
                                            label: "A Support at Home classification (1\u20138) from an assessment on or after 1 November 2025",
                                            value: 'sah_classification'
                                        }
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: levelBasis === 'transitioned_hcp' ? `Home Care Package level (the package ${who} had, or ${named ? 'was' : 'were'} approved for)` : 'Approved Support at Home classification (on the Notice of Decision)'
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                            name: "homeCareLevel",
                                            value: current,
                                            onChange: (n, v)=>handleHomeCareChange(v),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "",
                                                    children: "None"
                                                }),
                                                keys.map((key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                                        value: key,
                                                        children: [
                                                            (0, $c220d08b55e5dd64$export$bfae9591cc0d7897)[key].label,
                                                            " \u2014 ",
                                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $c220d08b55e5dd64$export$bfae9591cc0d7897)[key].budget),
                                                            " a year"
                                                        ]
                                                    }, key))
                                            ]
                                        }),
                                        levelBasis === 'transitioned_hcp' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "mt-1 text-xs text-gray-500",
                                            children: [
                                                "Carried into Support at Home with the package's own funding. If ",
                                                who,
                                                " ",
                                                named ? 'has' : 'have',
                                                " since been reassessed, choose the classification option above instead."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        });
                    })(),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                        label: "Approved for Residential Aged Care",
                        name: "residential",
                        checked: personData.recommendation?.residential,
                        onChange: (n, v)=>handleOtherCareChange(n, v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                        label: "Approved for Residential Respite Care",
                        name: "respite",
                        checked: personData.recommendation?.respite,
                        onChange: (n, v)=>handleOtherCareChange(n, v)
                    })
                ]
            })
        ]
    });
};
const $9f897eee40813319$export$ca063803b5049c23 = ({ factFind: factFind, updateFactFind: updateFactFind, isPartnered: isPartnered, voice: voice })=>{
    const { goals: goals, client: client, partner: partner } = factFind;
    const careGoals = [
        {
            id: 'home_care',
            label: 'Access Home Care Support'
        },
        {
            id: 'aged_care',
            label: 'Move into residential aged care'
        }
    ];
    const financialGoals = [
        {
            id: 'meet_costs',
            label: 'Meet Care Costs'
        },
        {
            id: 'maximise_support',
            label: 'Maximise Government Support'
        },
        {
            id: 'preserve_assets',
            label: 'Preserve Assets For Inheritance'
        },
        {
            id: 'funding_guidance',
            label: 'Guidance On Funding Options'
        }
    ];
    const selectedCareGoals = careGoals.filter((goal)=>goals?.[goal.id]);
    const updateCareNeeds = (person, field, value)=>{
        const currentPersonAcat = factFind.careNeeds?.[person] || {
            recommendation: {}
        };
        updateFactFind('careNeeds', person, {
            ...currentPersonAcat,
            [field]: value
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$StepHeader, {
                icon: (0, $fa7706f9ee0421dc$export$2e2bcd8739ae039),
                step: 3,
                title: "Goals"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                                className: "text-lg font-semibold text-gray-700 mb-4",
                                children: "Primary Living Arrangement Goals"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-gray-600 mb-4",
                                children: [
                                    "What would ",
                                    voice.subject,
                                    " like to explore? (Select all that apply)"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                        label: $9f897eee40813319$var$goalLabel('home_care', 'Access Home Care Support'),
                                        name: "home_care",
                                        checked: goals?.home_care || false,
                                        onChange: (n, v)=>updateFactFind('goals', n, v)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                        label: $9f897eee40813319$var$goalLabel('downsize_home', 'Downsize the family home'),
                                        name: "downsize_home",
                                        checked: goals?.downsize_home || false,
                                        onChange: (n, v)=>updateFactFind('goals', n, v)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                        label: $9f897eee40813319$var$goalLabel('retirement_village', 'Move to a retirement village'),
                                        name: "retirement_village",
                                        checked: goals?.retirement_village || false,
                                        onChange: (n, v)=>updateFactFind('goals', n, v)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                        label: $9f897eee40813319$var$goalLabel('granny_flat', 'Explore granny flat options'),
                                        name: "granny_flat",
                                        checked: goals?.granny_flat || false,
                                        onChange: (n, v)=>updateFactFind('goals', n, v)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                        label: $9f897eee40813319$var$goalLabel('aged_care', 'Move into residential aged care'),
                                        name: "aged_care",
                                        checked: goals?.aged_care || false,
                                        onChange: (n, v)=>updateFactFind('goals', n, v)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                                className: "text-lg font-semibold text-gray-700 mb-4",
                                children: "Financial Goals"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                                children: financialGoals.map((goal)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                        label: goal.label,
                                        name: goal.id,
                                        checked: goals?.[goal.id] || false,
                                        onChange: (n, v)=>updateFactFind('goals', n, v)
                                    }, goal.id))
                            })
                        ]
                    }),
                    isPartnered && selectedCareGoals.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                                className: "text-lg font-semibold text-gray-700 mb-4",
                                children: "Care Goal Details"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "space-y-4",
                                children: selectedCareGoals.map((goal)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                        label: `Who is the goal "${goal.label}" for?`,
                                        name: `${goal.id}_for`,
                                        value: goals?.[`${goal.id}_for`] || '',
                                        onChange: (n, v)=>updateFactFind('goals', n, v),
                                        options: [
                                            {
                                                label: client?.firstName || 'Applicant 1',
                                                value: 'client'
                                            },
                                            {
                                                label: partner?.firstName || 'Applicant 2',
                                                value: 'partner'
                                            },
                                            {
                                                label: 'Both',
                                                value: 'both'
                                            }
                                        ]
                                    }, goal.id))
                            })
                        ]
                    }),
                    selectedCareGoals.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                                className: "text-lg font-semibold text-gray-700 mb-4",
                                children: "Care assessment (aged care needs assessment)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$AcatAssessmentSection, {
                                person: "clientAcat",
                                personData: factFind.careNeeds?.clientAcat,
                                updatePersonAcat: updateCareNeeds,
                                personName: client?.firstName || 'the applicant',
                                voice: voice
                            }),
                            isPartnered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$AcatAssessmentSection, {
                                person: "partnerAcat",
                                personData: factFind.careNeeds?.partnerAcat,
                                updatePersonAcat: updateCareNeeds,
                                personName: partner?.firstName || 'Partner',
                                voice: voice
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $9f897eee40813319$export$db4a7af46992c46c = ({ home: home, updateFactFind: updateFactFind, client: client, partner: partner, isPartnered: isPartnered, factFind: factFind, onHomeTitleOwnershipChange: onHomeTitleOwnershipChange, voice: voice, showHeader: showHeader = true })=>{
    const [showRentalCalculator, setShowRentalCalculator] = (0, $acw62.useState)(false);
    /**
     * Whether to ASK who will stay in the home — and the answer is no whenever a partner is staying.
     *
     * Deliberately the same function the means test uses (`partnerRemainsInFamilyHome`), rather than
     * a second reading of the care goal here. If the form decided this on its own the two could drift,
     * and the failure would be silent: a question hidden on the belief the home is exempt, while the
     * engine assessed it anyway. Asking the same function both times makes that impossible.
     *
     * When a partner IS staying, the answer is already known — they are the protected person — so the
     * question has nothing to add and its natural-sounding "No" is simply wrong.
     */ const partnerStayingHome = (0, $8eecd0af141b9afb$export$6a0c2f6602682b05)(factFind);
    // Get client and partner names with fallbacks
    const clientName = client?.firstName || 'Client';
    const partnerName = partner?.firstName || 'Partner';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            showHeader ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$StepHeader, {
                icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
                step: 4,
                title: voice.isThirdPerson ? `${voice.Possessive} Home` : 'The Family Home'
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "text-xl font-bold text-gray-900 mb-6 mt-8 pt-8 border-t border-slate-200",
                children: voice.isThirdPerson ? `${voice.Possessive} Home` : 'The Family Home'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                                className: "text-lg font-semibold text-gray-700 mb-4",
                                children: "Home Value & Growth"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                        label: "Estimated Market Value ($)",
                                        name: "value",
                                        value: home.value || '',
                                        onChange: (v)=>updateFactFind('value', v)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd6bad1410bfbf4$export$2e2bcd8739ae039), {
                                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                "Assumed Annual Growth Rate (%) ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                    text: (0, $5d75c6e277be5884$export$5fcc0bb37cb5399b).homeGrowthRate
                                                })
                                            ]
                                        }),
                                        name: "homeGrowthRate",
                                        value: home.homeGrowthRate || '',
                                        onChange: (v)=>updateFactFind('homeGrowthRate', v)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                "Home owner on title records",
                                                ' ',
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                    text: `Who is named on the property title? This affects Age Pension and care fee estimates. If ${voice.possessive} home is in a family trust or company name, choose Other entity \u{2014} you'll add details on the next step.`
                                                })
                                            ]
                                        }),
                                        name: "ownership",
                                        value: home.ownership || (isPartnered ? 'joint' : 'client'),
                                        onChange: (n, v)=>{
                                            updateFactFind(n, v);
                                            onHomeTitleOwnershipChange?.(v);
                                        },
                                        children: [
                                            !isPartnered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                                value: "client",
                                                children: [
                                                    clientName,
                                                    " only"
                                                ]
                                            }),
                                            isPartnered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "joint",
                                                        children: "Jointly held (50/50)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                                        value: "client",
                                                        children: [
                                                            clientName,
                                                            " only"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                                        value: "partner",
                                                        children: [
                                                            partnerName,
                                                            " only"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "other_entity",
                                                children: "Other entity (trust, company, etc.)"
                                            })
                                        ]
                                    }),
                                    home.ownership === 'other_entity' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex gap-2 mt-3 p-3 rounded-lg bg-white border border-teal-200 text-sm text-teal-900",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                                        size: 18,
                                                        className: "shrink-0 mt-0.5"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "You'll add the trust or company name on the next step (Assets) and confirm which one owns this home."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "mt-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                    label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        children: [
                                                            voice.verb('Do', 'Does'),
                                                            " ",
                                                            voice.subject,
                                                            " have a secure right to keep living in this home?",
                                                            ' ',
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                                text: `Centrelink treats the home as ${voice.possessive} principal residence when a trust or company owns it only if ${voice.pronoun} have reasonable security of tenure (for example no real risk of being asked to leave).`
                                                            })
                                                        ]
                                                    }),
                                                    name: "securityOfTenure",
                                                    value: (0, $8ab044f9996773da$export$3b62265a75916bfa)(home.securityOfTenure ?? true),
                                                    onChange: (n, v)=>updateFactFind(n, (0, $8ab044f9996773da$export$1923fe087c479fde)(v)),
                                                    options: [
                                                        {
                                                            label: 'Yes',
                                                            value: 'yes'
                                                        },
                                                        {
                                                            label: 'No / not sure',
                                                            value: 'no'
                                                        }
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                                className: "text-lg font-semibold text-gray-700 mb-4",
                                children: "If the home were rented out"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-gray-600 mb-4",
                                children: [
                                    (()=>{
                                        const stepGoals = factFind?.goals || {};
                                        if (stepGoals.retirement_village) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                "Some people keep their home and rent it out to help fund village living \u2014 if you fill these in, we'll compare that path for you. Nothing here commits ",
                                                voice.subject,
                                                " to it."
                                            ]
                                        });
                                        if (stepGoals.aged_care) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                "Keeping the home and renting it out is one way to fund residential care \u2014 if you fill these in, we'll compare that path for you. Nothing here commits ",
                                                voice.subject,
                                                " to it."
                                            ]
                                        });
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                "Renting the home out isn't usually part of a downsizing plan (you're selling) \u2014 leave these blank unless it's a path you want modelled. Nothing here commits ",
                                                voice.subject,
                                                " to it."
                                            ]
                                        });
                                    })(),
                                    partnerStayingHome ? ` Renting it out would mean ${partnerName} living somewhere else, so we model that path separately from ${partnerName} staying put.` : ''
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                "Likely weekly rent if leased? ($) ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                    text: (0, $5d75c6e277be5884$export$5fcc0bb37cb5399b).likelyRent
                                                })
                                            ]
                                        }),
                                        name: "likelyRent",
                                        value: home.likelyRent || '',
                                        onChange: (v)=>updateFactFind('likelyRent', v)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: "likelyExpenses",
                                                className: "block text-sm font-medium text-gray-700 mb-1",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "inline-flex items-center flex-wrap gap-0",
                                                    children: [
                                                        "Estimated annual expenses if rented? ($)",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                            text: (0, $5d75c6e277be5884$export$5fcc0bb37cb5399b).likelyExpenses
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "flex-1",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                            label: "Expenses ($)",
                                                            name: "likelyExpenses",
                                                            value: home.likelyExpenses || '',
                                                            onChange: (v)=>updateFactFind('likelyExpenses', v),
                                                            className: "[&>label]:hidden"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>setShowRentalCalculator(true),
                                                        className: "flex items-center gap-2 px-4 py-2 bg-teal-100 text-teal-800 font-semibold rounded-lg hover:bg-teal-200 transition-colors whitespace-nowrap",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $27f56d6cfb7d79f8$export$2e2bcd8739ae039), {
                                                                size: 20
                                                            }),
                                                            " Calculate"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("legend", {
                                className: "text-lg font-semibold text-gray-700 mb-4 flex items-center gap-2",
                                children: [
                                    "About ",
                                    voice.possessive,
                                    " property",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                        text: `Understanding ${voice.possessive} property characteristics has implications to factors such as age pension eligibility as well as what's included to assess factors such as aged care costs.`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-6",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                label: "Is the home on land larger than 2 hectares (5 acres)?",
                                                name: "landSize",
                                                value: (0, $8ab044f9996773da$export$3b62265a75916bfa)(home.landSize),
                                                onChange: (n, v)=>updateFactFind(n, (0, $8ab044f9996773da$export$1923fe087c479fde)(v)),
                                                options: [
                                                    {
                                                        label: 'Yes',
                                                        value: 'yes'
                                                    },
                                                    {
                                                        label: 'No',
                                                        value: 'no'
                                                    }
                                                ]
                                            }),
                                            home.landSize && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "pl-6 mt-4 space-y-4 border-l-2 border-blue-200",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            children: [
                                                                "Roughly what is the land beyond 2 hectares worth? ($) ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                                    text: `Only the home and the first 2 hectares around it are exempt from the Age Pension assets test. Give the value of the land past that point \u{2014} a rough figure is fine. Include it in the home value above as well; we do not count it twice.`
                                                                })
                                                            ]
                                                        }),
                                                        name: "landSizeValue",
                                                        value: home.landSizeValue || '',
                                                        onChange: (v)=>updateFactFind('landSizeValue', v)
                                                    }),
                                                    !home.primaryProductionUse && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    children: [
                                                                        voice.verb('Have', 'Has'),
                                                                        " ",
                                                                        voice.subject,
                                                                        " lived on this property for 20 years or more? ",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                                            text: "Centrelink can exempt ALL the land around the home \u2014 however big \u2014 for someone with a long-term connection to the property. Twenty years of living there continuously is the test. Short absences, such as a stay in hospital or respite care, do not break it."
                                                                        })
                                                                    ]
                                                                }),
                                                                name: "longTermLandAttachment",
                                                                value: (0, $8ab044f9996773da$export$3b62265a75916bfa)(home.longTermLandAttachment),
                                                                onChange: (n, v)=>updateFactFind(n, (0, $8ab044f9996773da$export$1923fe087c479fde)(v)),
                                                                options: [
                                                                    {
                                                                        label: 'Yes',
                                                                        value: 'yes'
                                                                    },
                                                                    {
                                                                        label: 'No',
                                                                        value: 'no'
                                                                    }
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    children: [
                                                                        "Is that extra land being put to use? ",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                                            text: "The second half of the same Centrelink test. It is met if the land earns something \u2014 grazing, cropping, leased to a neighbour \u2014 or if it realistically cannot earn anything (too steep, bushland, no water). It is not met if the land could be earning and simply sits idle."
                                                                        })
                                                                    ]
                                                                }),
                                                                name: "effectiveLandUse",
                                                                value: (0, $8ab044f9996773da$export$3b62265a75916bfa)(home.effectiveLandUse),
                                                                onChange: (n, v)=>updateFactFind(n, (0, $8ab044f9996773da$export$1923fe087c479fde)(v)),
                                                                options: [
                                                                    {
                                                                        label: 'Yes',
                                                                        value: 'yes'
                                                                    },
                                                                    {
                                                                        label: 'No',
                                                                        value: 'no'
                                                                    }
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                label: "Is the home and land held on two separate titles?",
                                                name: "separateTitles",
                                                value: (0, $8ab044f9996773da$export$3b62265a75916bfa)(home.separateTitles),
                                                onChange: (n, v)=>updateFactFind(n, (0, $8ab044f9996773da$export$1923fe087c479fde)(v)),
                                                options: [
                                                    {
                                                        label: 'Yes',
                                                        value: 'yes'
                                                    },
                                                    {
                                                        label: 'No',
                                                        value: 'no'
                                                    }
                                                ]
                                            }),
                                            home.separateTitles && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                className: "mt-2",
                                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        "What is the land on the second title worth? ($) ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                            text: `A title without the house on it is not part of the home, so Centrelink counts it as an ordinary asset whatever its size \u{2014} there is no exemption for it. Include it in the home value above as well; we do not count it twice.`
                                                        })
                                                    ]
                                                }),
                                                name: "separateTitlesValue",
                                                value: home.separateTitlesValue || '',
                                                onChange: (v)=>updateFactFind('separateTitlesValue', v)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                label: "Is the property used for primary production (e.g., a farm)?",
                                                name: "primaryProductionUse",
                                                value: (0, $8ab044f9996773da$export$3b62265a75916bfa)(home.primaryProductionUse),
                                                onChange: (n, v)=>updateFactFind(n, (0, $8ab044f9996773da$export$1923fe087c479fde)(v)),
                                                options: [
                                                    {
                                                        label: 'Yes',
                                                        value: 'yes'
                                                    },
                                                    {
                                                        label: 'No',
                                                        value: 'no'
                                                    }
                                                ]
                                            }),
                                            home.primaryProductionUse && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "pl-6 mt-4 space-y-4 border-l-2 border-blue-200",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            children: [
                                                                voice.isThirdPerson ? `${voice.verb('Have', 'Has')} ${voice.subject} continuously worked the farm for the last 20 years?` : 'Have you or your partner continuously worked the farm for the last 20 years?',
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                                    text: "This helps establish a 'long-term continuous link' to the land, which is a key part of qualifying for the primary production concession."
                                                                })
                                                            ]
                                                        }),
                                                        name: "farmContinuouslyWorked",
                                                        value: (0, $8ab044f9996773da$export$3b62265a75916bfa)(home.farmContinuouslyWorked),
                                                        onChange: (n, v)=>updateFactFind(n, (0, $8ab044f9996773da$export$1923fe087c479fde)(v)),
                                                        options: [
                                                            {
                                                                label: 'Yes',
                                                                value: 'yes'
                                                            },
                                                            {
                                                                label: 'No',
                                                                value: 'no'
                                                            }
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            children: [
                                                                "Is the farm ",
                                                                voice.possessive,
                                                                " primary source of income? ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                                    text: "This helps determine if the farming activity is substantial, not just a hobby, which is another key part of the concession test."
                                                                })
                                                            ]
                                                        }),
                                                        name: "farmPrimaryIncome",
                                                        value: (0, $8ab044f9996773da$export$3b62265a75916bfa)(home.farmPrimaryIncome),
                                                        onChange: (n, v)=>updateFactFind(n, (0, $8ab044f9996773da$export$1923fe087c479fde)(v)),
                                                        options: [
                                                            {
                                                                label: 'Yes',
                                                                value: 'yes'
                                                            },
                                                            {
                                                                label: 'No',
                                                                value: 'no'
                                                            }
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !home.primaryProductionUse && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "Is a general business (non-farming) run from the property?"
                                                }),
                                                name: "businessUse",
                                                value: (0, $8ab044f9996773da$export$3b62265a75916bfa)(home.businessUse),
                                                onChange: (n, v)=>updateFactFind(n, (0, $8ab044f9996773da$export$1923fe087c479fde)(v)),
                                                options: [
                                                    {
                                                        label: 'Yes',
                                                        value: 'yes'
                                                    },
                                                    {
                                                        label: 'No',
                                                        value: 'no'
                                                    }
                                                ]
                                            }),
                                            home.businessUse && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "pl-6 mt-4 space-y-4 border-l-2 border-blue-200",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                        label: voice.isThirdPerson ? `Is the business expected to continue if ${voice.subject} ${voice.verb('move', 'moves')} into care?` : 'Is the business expected to continue if you (or your partner) move into care?',
                                                        name: "businessContinues",
                                                        value: (0, $8ab044f9996773da$export$3b62265a75916bfa)(home.businessContinues),
                                                        onChange: (n, v)=>updateFactFind(n, (0, $8ab044f9996773da$export$1923fe087c479fde)(v)),
                                                        options: [
                                                            {
                                                                label: 'Yes',
                                                                value: 'yes'
                                                            },
                                                            {
                                                                label: 'No',
                                                                value: 'no'
                                                            }
                                                        ]
                                                    }),
                                                    home.businessContinues && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Who is associated with (runs) the business?"
                                                                }),
                                                                name: "businessAssociation",
                                                                value: home.businessAssociation || 'self',
                                                                onChange: updateFactFind,
                                                                options: [
                                                                    {
                                                                        label: isPartnered ? `${client?.firstName || 'Applicant 1'} / ${partner?.firstName || 'Partner'}` : `${client?.firstName || 'Applicant 1'}`,
                                                                        value: 'self'
                                                                    },
                                                                    {
                                                                        label: 'Someone else (e.g., child)',
                                                                        value: 'other'
                                                                    }
                                                                ]
                                                            }),
                                                            home.businessAssociation === 'other' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    children: [
                                                                        voice.verb('Do', 'Does'),
                                                                        " ",
                                                                        voice.subject,
                                                                        " receive commercial rent or any income from this business? ",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                                            text: `If ${voice.pronoun} receive income, Centrelink may treat the business portion of the home as an asset. If it's an informal arrangement with no rent paid, it's generally not assessed.`
                                                                        })
                                                                    ]
                                                                }),
                                                                name: "businessReceivesRent",
                                                                value: (0, $8ab044f9996773da$export$3b62265a75916bfa)(home.businessReceivesRent),
                                                                onChange: (n, v)=>updateFactFind(n, (0, $8ab044f9996773da$export$1923fe087c479fde)(v)),
                                                                options: [
                                                                    {
                                                                        label: 'Yes',
                                                                        value: 'yes'
                                                                    },
                                                                    {
                                                                        label: 'No',
                                                                        value: 'no'
                                                                    }
                                                                ]
                                                            }),
                                                            (home.businessAssociation === 'self' || home.businessReceivesRent) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    children: [
                                                                        "What is the value of the business portion? ($) ",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                                            text: `Estimate the value of the part of ${voice.possessive} home used exclusively for the business. E.g., if 20% of the home is a dedicated office, the value would be 20% of the home's total value.`
                                                                        })
                                                                    ]
                                                                }),
                                                                name: "businessUseValue",
                                                                value: home.businessUseValue || '',
                                                                onChange: (v)=>updateFactFind('businessUseValue', v)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {})
                                ]
                            })
                        ]
                    }),
                    !partnerStayingHome && Boolean(factFind?.goals?.aged_care) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("legend", {
                                className: "text-lg font-semibold text-gray-700 mb-4 flex items-center",
                                children: [
                                    "Who will stay in ",
                                    voice.possessive,
                                    " home?",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                        text: `Certain people are treated as a 'protected person' by Centrelink \u{2014} typically a partner, a dependent child, or a long-term carer or close relative who meets certain criteria. If a protected person keeps living in ${voice.possessive} home after ${voice.subject} ${voice.verb('move', 'moves')} to aged care, the value of the home is exempt from the aged care means test.`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-gray-600 mb-4",
                                children: [
                                    isPartnered ? `Once ${clientName} and ${partnerName} have both moved into aged care, will anyone still be living in their home?` : `If ${voice.subject} ${voice.verb('move', 'moves')} into aged care, will anyone still be living in ${voice.possessive} home?`,
                                    ' ',
                                    "Only certain people make the home exempt from the aged care means test."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                label: "Will someone remain living there?",
                                name: "protectedPerson",
                                value: home.protectedPerson || 'no',
                                onChange: updateFactFind,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "no",
                                        children: "No, the home will be empty"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "dependent_child",
                                        children: "Yes, a dependent child"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "carer",
                                        children: "Yes, a carer (who has lived there 2+ years and gets income support)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "close_relative",
                                        children: "Yes, a close relative (who has lived there 5+ years and gets income support)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "occupied_not_protected",
                                        children: "Yes, but not one of the above (the home is still assessed)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "will_rent_out",
                                        children: "No \u2014 the home will be rented out (it is still assessed)"
                                    })
                                ]
                            })
                        ]
                    }),
                    showRentalCalculator && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2eb3027f7a6469b1$export$2e2bcd8739ae039), {
                        onClose: ()=>setShowRentalCalculator(false),
                        onSave: (total)=>{
                            updateFactFind('likelyExpenses', total);
                            setShowRentalCalculator(false);
                        },
                        propertyValue: Number(home.value) || 0,
                        weeklyRent: Number(home.likelyRent) || 0,
                        currentExpenses: Number(home.likelyExpenses) || 0
                    })
                ]
            })
        ]
    });
};
const $9f897eee40813319$var$STEP4_TONE_MAP = {
    blue: 'info',
    amber: 'caution',
    green: 'positive'
};
const $9f897eee40813319$var$Step4InsightCallout = ({ heading: heading, tone: tone = 'blue', children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bc32c6ef2e03125$export$2e2bcd8739ae039), {
        tone: $9f897eee40813319$var$STEP4_TONE_MAP[tone] || 'info',
        heading: heading,
        className: "mt-5",
        children: children
    });
// Granny-flat fact-find fields — shared by the legacy 'granny_flat' residency and the derived
// "living with family + paid for a right to live there" path.
const $9f897eee40813319$var$GrannyFlatFields = ({ factFind: factFind, updateFactFind: updateFactFind, voice: voice })=>{
    const gf = factFind.grannyFlat || {};
    const hasAmounts = (Number(gf.amountPaid) || 0) > 0 || (Number(gf.propertyTransferredValue) || 0) > 0 || (Number(gf.constructionCost) || 0) > 0;
    const dep = (0, $a528307a9ba99a26$export$eb48a6112ea73d5a)(factFind, (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).couple);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-sm text-gray-500 mb-4",
                children: [
                    "A granny flat arrangement gives ",
                    voice.subject,
                    " a lifetime right to live there. These details let us check ",
                    voice.possessive,
                    " homeowner status and whether any of what ",
                    voice.pronoun,
                    " paid is treated as a gift."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 items-start",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                        label: `Date ${voice.subject} entered the arrangement`,
                        name: "dateEntered",
                        type: "date",
                        value: factFind.grannyFlat?.dateEntered || '',
                        onChange: (n, v)=>updateFactFind('grannyFlat', n, v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        label: `Amount ${voice.subject} paid (cash)`,
                        value: factFind.grannyFlat?.amountPaid ?? '',
                        onChange: (v)=>updateFactFind('grannyFlat', 'amountPaid', v),
                        placeholder: "$0"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        label: `Value of property or assets ${voice.subject} signed over`,
                        value: factFind.grannyFlat?.propertyTransferredValue ?? '',
                        onChange: (v)=>updateFactFind('grannyFlat', 'propertyTransferredValue', v),
                        placeholder: "$0"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                        label: `What did ${voice.subject} sign over?`,
                        name: "transferredKind",
                        value: gf.transferredKind || 'home',
                        onChange: (_n, v)=>updateFactFind('grannyFlat', 'transferredKind', v),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                value: "home",
                                children: [
                                    "The home ",
                                    voice.pronoun,
                                    " lived in"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: "other_property",
                                children: "Another property (an investment property or holiday home)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: "other_assets",
                                children: "Other assets (shares, savings in kind, or similar)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        label: "Construction cost (if a flat was built)",
                        value: factFind.grannyFlat?.constructionCost ?? '',
                        onChange: (v)=>updateFactFind('grannyFlat', 'constructionCost', v),
                        placeholder: "$0"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mt-2 text-xs text-gray-500",
                children: [
                    "Cash ",
                    voice.pronoun,
                    " kept after selling a home is not paid for the right: record it under Assets as it stands today. Leave fields at $0 if they don't apply."
                ]
            }),
            hasAmounts && !gf.dateEntered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($9f897eee40813319$var$Step4InsightCallout, {
                children: [
                    "Add the ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                        children: [
                            "date ",
                            voice.subject,
                            " entered the arrangement"
                        ]
                    }),
                    " above and we'll show you whether any of this is treated as a gift."
                ]
            }),
            dep && dep.deprivation > 0 && dep.establishmentFyEnd < (new Date().getMonth() >= 6 ? new Date().getFullYear() + 1 : new Date().getFullYear()) - 4 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($9f897eee40813319$var$Step4InsightCallout, {
                heading: "A gift arose, but the five years have passed",
                children: [
                    "About ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dep.deprivation)
                    }),
                    " was treated as a ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "gift"
                    }),
                    " when the arrangement started (FY",
                    dep.establishmentFyEnd,
                    ") \u2014 the amount ",
                    voice.pronoun,
                    " paid ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                        children: "above"
                    }),
                    " the assessed value of the right. Gifts count for five years, and that time is up, so it no longer affects ",
                    voice.pronounPossessive,
                    " pension and nothing from it is carried into the calculations."
                ]
            }),
            dep && dep.deprivation > 0 && dep.establishmentFyEnd >= (new Date().getMonth() >= 6 ? new Date().getFullYear() + 1 : new Date().getFullYear()) - 4 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($9f897eee40813319$var$Step4InsightCallout, {
                heading: "Part of this is treated as a gift",
                tone: "amber",
                children: [
                    "Based on what you've entered, about ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(dep.deprivation)
                    }),
                    " is treated as a ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "gift"
                    }),
                    " (in FY",
                    dep.establishmentFyEnd,
                    ") \u2014 the amount ",
                    voice.pronoun,
                    " paid ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                        children: "above"
                    }),
                    " the assessed value of the right. It may reduce ",
                    voice.pronounPossessive,
                    " pension for five years, and we carry it into the Gifting section automatically (no need to re-enter it)."
                ]
            }),
            dep && dep.deprivation === 0 && hasAmounts && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($9f897eee40813319$var$Step4InsightCallout, {
                heading: "None of this is treated as a gift",
                tone: "green",
                children: [
                    "Signing ",
                    voice.possessive,
                    " home over, or paying for a build, in return for the right to live there is taken at ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "face value"
                    }),
                    " \u2014 never a gift on its own. Cash, or other property or assets, is tested against Centrelink's limit for the right; what is given here is within it, so none of it is a gift. A gift would only arise if ",
                    voice.pronoun,
                    " gave ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                        children: "more"
                    }),
                    " than the right can be valued at (for example, extra cash on top of the home)."
                ]
            })
        ]
    });
};
/**
 * Where each person lives now — the question the whole of step 4 hangs off.
 *
 * It used to be a dropdown among the name-and-date fields on step 2, which understated it badly.
 * This one answer decides whether the family home is treated as owned (the largest single lever in
 * the aged care means test), feeds household status and the illness-separated rules, is the way in
 * to granny-flat treatment, and swaps every question and insight on this step. The app's own
 * completeness model already counted it as part of Living Arrangements rather than Your Details
 * (profileCompleteness.ts), so the form was the odd one out.
 *
 * Cards rather than a dropdown so all five options are visible without opening anything, and
 * rather than photographs because this repeats per person — a couple would have faced ten images
 * for one factual question. It starts unanswered: nothing about a client's housing should be
 * assumed on their behalf, and everything below waits for the answer.
 */ const $9f897eee40813319$var$RESIDENCY_OPTIONS = [
    {
        id: 'own_home',
        label: 'Own home',
        description: 'Owned outright or with a mortgage.',
        icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039)
    },
    {
        id: 'renting',
        label: 'Renting',
        description: 'Renting privately or in public housing.',
        icon: (0, $f0cdbf97a5c8afc2$export$2e2bcd8739ae039)
    },
    {
        id: 'with_family',
        label: 'Living with family',
        description: "Living in a family member's home.",
        icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039)
    },
    {
        id: 'retirement_village',
        label: 'Retirement village',
        description: 'Already living in a village.',
        icon: (0, $224502d93617e0e1$export$2e2bcd8739ae039)
    },
    {
        id: 'aged_care',
        label: 'Residential aged care',
        description: 'Already living in residential care.',
        icon: (0, $95e9e50748ea8ef2$export$2e2bcd8739ae039)
    }
];
const $9f897eee40813319$var$ResidencyChoice = ({ who: who, legend: legend, value: value, onChange: onChange })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                className: "text-base font-semibold text-gray-800 mb-3",
                children: legend
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid grid-cols-1 sm:grid-cols-2 gap-3",
                children: $9f897eee40813319$var$RESIDENCY_OPTIONS.map((option)=>{
                    const isSelected = value === option.id;
                    const Icon = option.icon;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        className: "block cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "radio",
                                name: `${who}-residency`,
                                value: option.id,
                                checked: isSelected,
                                onChange: ()=>onChange(option.id),
                                className: "peer sr-only"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: `flex h-full items-start gap-3 rounded-xl border-2 bg-white p-4 transition-all peer-focus-visible:ring-2 peer-focus-visible:ring-[#0290F5] peer-focus-visible:ring-offset-2 ${isSelected ? 'border-[#0F52E0] shadow-cardlg' : 'border-slate-200 shadow-card hover:border-slate-300'}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                        size: 20,
                                        className: `shrink-0 mt-0.5 ${isSelected ? 'text-[#0F52E0]' : 'text-slate-400'}`,
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "min-w-0",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: `block text-sm font-semibold ${isSelected ? 'text-[#001E7A]' : 'text-gray-900'}`,
                                                children: option.label
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "mt-0.5 block text-xs text-gray-600",
                                                children: option.description
                                            })
                                        ]
                                    }),
                                    isSelected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                        size: 18,
                                        strokeWidth: 3,
                                        className: "ml-auto shrink-0 text-[#0F52E0]",
                                        "aria-hidden": "true"
                                    })
                                ]
                            })
                        ]
                    }, option.id);
                })
            })
        ]
    });
const $9f897eee40813319$export$2877414a5eaf8cb9 = ({ factFind: factFind, updateFactFind: updateFactFind, isPartnered: isPartnered, voice: voice })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$StepHeader, {
                icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
                step: 4,
                title: "Living Arrangements"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$ResidencyChoice, {
                        who: "client",
                        legend: voice.isThirdPerson ? `Where does ${factFind.client?.firstName || 'the applicant'} live now?` : 'Where do you live now?',
                        value: String(factFind.client?.currentResidency || ''),
                        onChange: (v)=>updateFactFind('client', 'currentResidency', v)
                    }),
                    isPartnered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$ResidencyChoice, {
                        who: "partner",
                        legend: `Where does ${factFind.partner?.firstName || 'their partner'} live now?`,
                        value: String(factFind.partner?.currentResidency || ''),
                        onChange: (v)=>updateFactFind('partner', 'currentResidency', v)
                    })
                ]
            })
        ]
    });
/**
 * Both of a couple in the same kind of arrangement, where the fact-find holds ONE record for it.
 *
 * Almost always right — a couple share the village unit or the rented flat, and one set of figures
 * describes it. It is wrong for the rare couple in SEPARATE villages, and the honest thing is to
 * say which one is being recorded rather than take the first and drop the other. Holding two is a
 * change to the stored shape and to everything downstream that reads it; backlogged in the
 * methodology register (2026-08-20).
 */ const $9f897eee40813319$var$SharedArrangementNote = ({ what: what })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        className: "mb-4 rounded-lg border border-slate-200 border-l-4 border-l-amber-400 bg-white px-3 py-2 text-sm text-slate-700",
        children: [
            "These figures cover the ",
            what,
            " you share. If you are in separate ones, enter the main arrangement here \u2014 only one can be recorded at present, so the plan will not reflect the cost of the second one."
        ]
    });
const $9f897eee40813319$export$a0d01cff79c3a599 = ({ factFind: factFind, updateFactFind: updateFactFind, voice: voice, showHeader: showHeader = true })=>{
    const isCouple = factFind.adviceFor === 'couple';
    const clientRes = factFind.client?.currentResidency;
    const partnerRes = isCouple ? factFind.partner?.currentResidency : undefined;
    /**
     * Whose arrangement this is — used to head each section by name when a couple live apart, and
     * null when there is nothing to disambiguate (a single client, or both of them in the same
     * arrangement). "Michael's retirement village details" beside "The Family Home" is the whole
     * point of showing the two together.
     */ const whoseArrangement = (residency)=>{
        if (!isCouple) return null;
        const clientHasIt = clientRes === residency;
        const partnerHasIt = partnerRes === residency;
        if (clientHasIt && partnerHasIt) return null; // shared — naming one of them would mislead
        if (clientHasIt) return factFind.client?.firstName || null;
        if (partnerHasIt) return factFind.partner?.firstName || null;
        return null;
    };
    /** Heads a section with a name when only one of a couple is in that arrangement. */ const sectionTitle = (residency, title)=>{
        const who = whoseArrangement(residency);
        return who ? `${who}'s ${title.charAt(0).toLowerCase()}${title.slice(1)}` : title;
    };
    /** True when BOTH are in this arrangement — the fact-find holds one record for it. */ const sharedArrangement = (residency)=>isCouple && clientRes === residency && partnerRes === residency;
    /**
     * The voice for ONE section, scoped to whoever is in that arrangement.
     *
     * The sections were headed by name but everything inside them still spoke about the couple:
     * "Tara's retirement village details" over a field labelled "Michael & Tara's entry
     * contribution", for a village only Tara lives in (adviser-reported, 2026-08-20). A section
     * about one person has to talk about that person throughout — the labels are what an adviser
     * reads while typing figures into them.
     *
     * Falls back to the page voice when there is nobody to single out (a single client, or both of
     * them in the same arrangement), and when the section belongs to the READER — someone filling
     * this in about their own rental should still see "you", not their own name.
     */ const sectionVoice = (residency)=>{
        const who = whoseArrangement(residency);
        if (!who) return voice;
        const belongsToReader = !voice.isThirdPerson && clientRes === residency;
        if (belongsToReader) return voice;
        return {
            ...voice,
            isThirdPerson: true,
            subject: who,
            Subject: who,
            possessive: `${who}'s`,
            Possessive: `${who}'s`,
            pronoun: 'they',
            pronounPossessive: 'their',
            verb: (_plural, singular)=>singular
        };
    };
    const vRent = sectionVoice('renting');
    const vVillage = sectionVoice('retirement_village');
    const vGranny = sectionVoice('granny_flat');
    const vFamily = sectionVoice('with_family');
    const isRenting = clientRes === 'renting' || partnerRes === 'renting';
    const inVillage = clientRes === 'retirement_village' || partnerRes === 'retirement_village';
    const inGrannyFlat = clientRes === 'granny_flat' || partnerRes === 'granny_flat';
    const withFamily = clientRes === 'with_family' || partnerRes === 'with_family';
    const alreadyInCare = clientRes === 'aged_care' || partnerRes === 'aged_care';
    const inCareNames = [
        clientRes === 'aged_care' ? factFind.client?.firstName : null,
        isCouple && partnerRes === 'aged_care' ? factFind.partner?.firstName : null
    ].filter(Boolean);
    const stayingHomeName = clientRes === 'own_home' ? factFind.client?.firstName : isCouple && partnerRes === 'own_home' ? factFind.partner?.firstName : null;
    const grannyFlatInterest = factFind.livingWithFamily?.grannyFlatInterest; // undefined | true | false
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            showHeader ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$StepHeader, {
                icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
                step: 4,
                title: `${voice.Possessive} Living Situation`
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "mt-8 mb-6 border-slate-200"
            }),
            (0, $d1b9bbc5238c0548$export$6d9ac5bb8b103361)(factFind) && /* A home value with nobody living in it: still owned (then it counts as an asset), or
               left behind when the arrangement changed. The profile asks rather than guessing
               (owner's living-arrangement review, 7 Oct 2026). */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-6 rounded-lg border border-slate-200 border-l-4 border-l-amber-500 bg-white px-4 py-3 text-sm text-slate-700",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            voice.Possessive,
                            " profile still holds a home worth ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(factFind.home?.value) || 0)
                            }),
                            ", but nobody is recorded as living in it. If ",
                            voice.subject,
                            " still ",
                            voice.verb('own', 'owns'),
                            " it, leave it: it counts as an asset for the Age Pension. If it has been sold, remove it so the figures are right."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>updateFactFind('home', 'value', 0),
                        className: "mt-2 text-sm font-semibold text-blue-700 hover:text-blue-900",
                        children: "The home has been sold \u2014 remove it"
                    })
                ]
            }),
            alreadyInCare && [
                'client',
                'partner'
            ].filter((who)=>(who === 'client' ? clientRes : partnerRes) === 'aged_care').map((who)=>{
                const p = who === 'client' ? factFind.client : factFind.partner;
                const stay = p?.careStay || {};
                const wantsResidentialCare = !!factFind.goals?.aged_care;
                const name = p?.firstName || (who === 'client' ? 'the applicant' : 'their partner');
                const own = !voice.isThirdPerson && who === 'client';
                const set = (field, value)=>updateFactFind(who, 'careStay', {
                        ...stay,
                        [field]: value
                    });
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                    className: "mb-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                            className: "text-lg font-semibold text-gray-700 mb-1",
                            children: own ? 'Your residential aged care' : `${name} \u{2014} already in residential aged care`
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-sm text-gray-500 mb-4",
                            children: [
                                "A few details about the home ",
                                own ? 'you are' : `${name} is`,
                                " in now. They let us price a move to another home properly, carry the deposit already paid into any plan, and apply the right fee rules.",
                                stayingHomeName ? ` Because ${stayingHomeName} still lives in the family home, it stays exempt from the aged care means test.` : ''
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                    label: "Name of the aged care home",
                                    name: "facilityName",
                                    value: stay.facilityName || '',
                                    onChange: (_n, v)=>set('facilityName', v)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "Date ",
                                            own ? 'you' : name,
                                            " moved in ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                text: "Moving in before 1 November 2025 keeps the earlier fee rules. The date also tells us how much of the deposit's retention has already been taken."
                                            })
                                        ]
                                    }),
                                    name: "entryDate",
                                    type: "date",
                                    value: stay.entryDate || '',
                                    onChange: (_n, v)=>set('entryDate', v)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "Agreed room price ($) ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                text: "The price of the room as agreed with the home, whether it is being paid as a deposit, a daily payment or both."
                                            })
                                        ]
                                    }),
                                    name: "roomPrice",
                                    value: stay.roomPrice ?? '',
                                    onChange: (v)=>set('roomPrice', v),
                                    placeholder: "$0"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "Refundable deposit paid ($) ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                text: "The lump sum paid for the room, if any. It comes back when care ends, less the home's retention, and does not count for the Age Pension."
                                            })
                                        ]
                                    }),
                                    name: "radPaid",
                                    value: stay.radPaid ?? '',
                                    onChange: (v)=>set('radPaid', v),
                                    placeholder: "$0"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "Daily payment for the room ($ a day) ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                text: "What is paid each day on the part of the room price not paid as a deposit, if any. Leave it blank if the whole room was paid as a deposit."
                                            })
                                        ]
                                    }),
                                    name: "dailyPayment",
                                    value: stay.dailyPayment ?? '',
                                    onChange: (v)=>set('dailyPayment', v),
                                    placeholder: "$0"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "Means-tested care fees paid so far this year ($) ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                text: "The means-tested care fee, or the non-clinical care and hotelling contributions, paid in the current home since the start of this year. These count towards the yearly cap, so the figures start from where they really are rather than from zero. Leave blank if none, or if the home does not charge them."
                                            })
                                        ]
                                    }),
                                    name: "contributionsPaidThisYear",
                                    value: stay.contributionsPaidThisYear ?? '',
                                    onChange: (v)=>set('contributionsPaidThisYear', v),
                                    placeholder: "$0"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "Means-tested care fees paid in all since entering care ($) ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                text: "The same fees, added up over every year in residential care. They count towards the lifetime cap, after which no more are charged."
                                            })
                                        ]
                                    }),
                                    name: "contributionsPaidToDate",
                                    value: stay.contributionsPaidToDate ?? '',
                                    onChange: (v)=>set('contributionsPaidToDate', v),
                                    placeholder: "$0"
                                }),
                                wantsResidentialCare && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            own ? 'Are you' : `Is ${name}`,
                                            " looking to move to a different aged care home? ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                text: "Moving between homes is common. On a move the deposit paid comes back within 14 days (less any retention taken so far) and can go towards the new home's room, which has its own price and its own fees. The Aged Care module compares staying put with the move."
                                            })
                                        ]
                                    }),
                                    name: "planningToMove",
                                    value: stay.planningToMove === true ? 'yes' : stay.planningToMove === false ? 'no' : '',
                                    onChange: (_n, v)=>set('planningToMove', v === 'yes' ? true : v === 'no' ? false : undefined),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "",
                                            children: "Not sure yet"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "yes",
                                            children: "Yes \u2014 looking to move"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                            value: "no",
                                            children: [
                                                "No \u2014 staying where ",
                                                own ? 'I am' : `${name} is`
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, who);
            }),
            isRenting && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                        className: "text-lg font-semibold text-gray-700 mb-1",
                        children: sectionTitle('renting', 'Renting details')
                    }),
                    sharedArrangement('renting') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$SharedArrangementNote, {
                        what: "rental"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-sm text-gray-500 mb-4",
                        children: [
                            "A few details about ",
                            vRent.possessive,
                            " rent let us check ",
                            vRent.pronounPossessive,
                            " Rent Assistance and asset limits."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                label: `How much rent ${vRent.verb('do', 'does')} ${vRent.subject} pay per week?`,
                                value: factFind.rent?.rentAmount ?? '',
                                onChange: (v)=>updateFactFind('rent', 'rentAmount', v),
                                placeholder: "$0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                label: `Who ${vRent.verb('do', 'does')} ${vRent.subject} rent from?`,
                                name: "landlordType",
                                value: factFind.rent?.landlordType || 'private',
                                onChange: (n, v)=>updateFactFind('rent', n, v),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "private",
                                        children: "A private landlord or real estate agent"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                        value: "family",
                                        children: [
                                            "A family member ",
                                            vRent.pronoun,
                                            " live with"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "public_housing",
                                        children: "Public or community housing"
                                    })
                                ]
                            }),
                            factFind.adviceFor !== 'couple' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                label: `${vRent.verb('Do', 'Does')} ${vRent.subject} share with others (not a partner)?`,
                                name: "sharedAccommodation",
                                value: (0, $8ab044f9996773da$export$3b62265a75916bfa)(factFind.rent?.sharedAccommodation),
                                onChange: (n, v)=>updateFactFind('rent', n, (0, $8ab044f9996773da$export$1923fe087c479fde)(v)),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "no",
                                        children: "No"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "yes",
                                        children: "Yes, shared private accommodation"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            inVillage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                        className: "text-lg font-semibold text-gray-700 mb-1",
                        children: sectionTitle('retirement_village', 'Retirement village details')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-sm text-gray-500 mb-4",
                        children: [
                            "How Centrelink assesses ",
                            vVillage.subject,
                            " depends on ",
                            vVillage.pronounPossessive,
                            " entry contribution."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                label: `${vVillage.Possessive} entry contribution (amount paid to move in)`,
                                value: factFind.retirementVillage?.entryContribution ?? '',
                                onChange: (v)=>updateFactFind('retirementVillage', 'entryContribution', v),
                                placeholder: "$0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                label: `Ongoing fees ${vVillage.subject} ${vVillage.verb('pay', 'pays')} per week`,
                                value: factFind.retirementVillage?.ongoingFees ?? '',
                                onChange: (v)=>updateFactFind('retirementVillage', 'ongoingFees', v),
                                placeholder: "$0"
                            })
                        ]
                    }),
                    (factFind.goals?.aged_care || factFind.goals?.retirement_village || factFind.goals?.granny_flat) && (()=>{
                        const careGoal = !!factFind.goals?.aged_care;
                        const movingTo = careGoal ? 'care' : factFind.goals?.retirement_village ? 'village' : 'granny_flat';
                        const v = factFind.retirementVillage || {};
                        const set = (field, value)=>updateFactFind('retirementVillage', field, value);
                        const stateMonths = (0, $4633117ee929ec27$export$50343794bd888a5f)[String(v.state || '').toUpperCase()];
                        // A couple where only one of them is entering care: the unit's fate is a question —
                        // and the exit terms matter only if it is given up. Both entering, or a single
                        // resident: the unit is given up, no question (owner, 8 Oct 2026).
                        const oneOfCoupleEntering = careGoal && isCouple && factFind.goals?.aged_care_for !== 'both';
                        // The exit terms are asked whichever way the unit goes (8 Oct 2026): a kept unit is in
                        // the family's estate at what the village would pay back, so the estate needs them too.
                        const enteringName = oneOfCoupleEntering ? (factFind.goals?.aged_care_for === 'partner' ? factFind.partner?.firstName : factFind.client?.firstName) || 'the person entering care' : vVillage.subject;
                        const stayingName = oneOfCoupleEntering ? (factFind.goals?.aged_care_for === 'partner' ? factFind.client?.firstName : factFind.partner?.firstName) || 'the other' : '';
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mt-6",
                            "data-testid": "village-exit-terms",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm font-semibold text-gray-700 mb-1",
                                    children: movingTo === 'care' ? 'Leaving the village for residential care' : movingTo === 'village' ? 'Leaving the village for another village' : 'Leaving the village for a granny flat'
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-gray-500 mb-4",
                                    children: movingTo !== 'care' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            "When ",
                                            vVillage.subject,
                                            " ",
                                            vVillage.verb('move', 'moves'),
                                            " on, the village pays back the entry contribution, less its departure fee and charges (there may be a waiting period to receive the funds). The ",
                                            movingTo === 'village' ? 'new village' : 'granny flat',
                                            " is paid for from savings at the move, and the payout goes back into savings when it arrives. The contract's terms tell us what comes back and when. Leave what you don't know blank: we then take the full entry contribution as coming back, with no departure fee."
                                        ]
                                    }) : oneOfCoupleEntering ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            "Only ",
                                            enteringName,
                                            " is moving into an aged care home, so the first question is what happens to the unit. If ",
                                            stayingName,
                                            " stays on, the unit is kept and stays in the family's estate at what the village would pay back for it. If the unit is given up, the village pays back the entry contribution, less its departure fee and charges (there may be a waiting period to receive the funds). Either way the contract's terms tell us what that is worth. Leave what you don't know blank: we then take the full entry contribution as coming back, with no departure fee."
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            "When ",
                                            vVillage.subject,
                                            " ",
                                            vVillage.verb('move', 'moves'),
                                            " into an aged care home the village pays back the entry contribution, less its departure fee and charges (there may be a waiting period to receive the funds). The contract's terms tell us what comes back and when. Leave what you don't know blank: we then take the full entry contribution as coming back, with no departure fee."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6",
                                    children: [
                                        oneOfCoupleEntering && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                            label: `When ${enteringName} moves into care, what happens to the unit?`,
                                            name: "onEnteringCare",
                                            value: v.onEnteringCare || '',
                                            onChange: (_n, val)=>set('onEnteringCare', val || undefined),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "",
                                                    children: "Select..."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                                    value: "keep_partner_stays",
                                                    children: [
                                                        stayingName,
                                                        " stays on in the unit"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "sell",
                                                    children: "The unit is given up and the village pays out"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                                    value: "sell_when_partner_leaves",
                                                    children: [
                                                        "Kept for now; given up when ",
                                                        stayingName,
                                                        " leaves too"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                            label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "Date ",
                                                    vVillage.subject,
                                                    " moved in ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                        text: "The departure fee builds up for each year in the village, usually up to a cap. The date sets how many years count."
                                                    })
                                                ]
                                            }),
                                            name: "dateEntered",
                                            type: "date",
                                            value: v.dateEntered || '',
                                            onChange: (_n, val)=>set('dateEntered', val)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $36fba7e03e1bb69f$export$2e2bcd8739ae039), {
                                            label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "Years in the village ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                        text: "Only if the date moved in is not known."
                                                    })
                                                ]
                                            }),
                                            name: "yearsResidency",
                                            value: v.yearsResidency ?? '',
                                            onChange: (val)=>set('yearsResidency', val)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                            label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "State or territory ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                        text: "Each state sets how long a village has to pay the exit entitlement where the unit has not resold sooner: about 6 months in Victoria, 12 in NSW and WA, 18 in Queensland and South Australia. Tasmania, the ACT and the NT set no limit, so 12 months is assumed unless the contract says otherwise."
                                                    })
                                                ]
                                            }),
                                            name: "state",
                                            value: v.state || '',
                                            onChange: (_n, val)=>set('state', val),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "",
                                                    children: "Select..."
                                                }),
                                                [
                                                    'NSW',
                                                    'VIC',
                                                    'QLD',
                                                    'SA',
                                                    'WA',
                                                    'TAS',
                                                    'ACT',
                                                    'NT'
                                                ].map((st)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: st,
                                                        children: st
                                                    }, st))
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $36fba7e03e1bb69f$export$2e2bcd8739ae039), {
                                            label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "Months the village has to pay ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                        text: `Only if the contract names a time limit. ${stateMonths ? `Leave blank to use the state's limit of ${stateMonths} months.` : "Leave blank to use the state's limit."}`
                                                    })
                                                ]
                                            }),
                                            name: "refundMonths",
                                            value: v.refundMonths ?? '',
                                            onChange: (val)=>set('refundMonths', val)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $36fba7e03e1bb69f$export$2e2bcd8739ae039), {
                                            label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "Months until the unit is likely to resell ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                        text: "Only if sooner than the limit: the village pays within days of a sale, so the money arrives earlier and its fees after leaving stop at the sale. Leave blank to assume the limit."
                                                    })
                                                ]
                                            }),
                                            name: "expectedResaleMonths",
                                            value: v.expectedResaleMonths ?? '',
                                            onChange: (val)=>set('expectedResaleMonths', val)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd6bad1410bfbf4$export$2e2bcd8739ae039), {
                                            label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "Departure fee (% a year) ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                        text: "Also called the deferred management fee or exit fee. Most contracts charge a percentage for each year of residency, up to a cap: for example 3% a year for up to 10 years."
                                                    })
                                                ]
                                            }),
                                            name: "dmfPctPerYear",
                                            value: v.dmfPctPerYear ?? '',
                                            onChange: (val)=>set('dmfPctPerYear', val)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $36fba7e03e1bb69f$export$2e2bcd8739ae039), {
                                            label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "Charged for up to (years) ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                        text: "The cap on the years the departure fee builds up over: 10 in the example above."
                                                    })
                                                ]
                                            }),
                                            name: "dmfCapYears",
                                            value: v.dmfCapYears ?? '',
                                            onChange: (val)=>set('dmfCapYears', val)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                            label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "Departure fee is a % of ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                        text: "Contracts charge the fee on the price paid to move in, or on the price the unit sells for. The contract says which."
                                                    })
                                                ]
                                            }),
                                            name: "dmfBasis",
                                            value: v.dmfBasis || 'entry',
                                            onChange: (_n, val)=>set('dmfBasis', val),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "entry",
                                                    children: "The entry contribution (price paid to move in)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "resale",
                                                    children: "The resale price"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd6bad1410bfbf4$export$2e2bcd8739ae039), {
                                            label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "Share of any resale gain kept (%) ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                        text: "Where the unit sells for more than was paid, the contract says how the gain is split with the village. Leave blank for an even split."
                                                    })
                                                ]
                                            }),
                                            name: "capitalGainSharePct",
                                            value: v.capitalGainSharePct ?? '',
                                            onChange: (val)=>set('capitalGainSharePct', val)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                            label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "Expected resale price ($) ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                        text: "Leave blank to assume it sells for the entry contribution. A lower figure reduces what comes back; a higher one adds the share of the gain."
                                                    })
                                                ]
                                            }),
                                            name: "expectedResaleValue",
                                            value: v.expectedResaleValue ?? '',
                                            onChange: (val)=>set('expectedResaleValue', val),
                                            placeholder: "$0"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                            label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "Reinstatement cost ($) ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                        text: "What the contract charges to bring the unit back to resale condition, if anything."
                                                    })
                                                ]
                                            }),
                                            name: "reinstatementCost",
                                            value: v.reinstatementCost ?? '',
                                            onChange: (val)=>set('reinstatementCost', val),
                                            placeholder: "$0"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$Step4InsightCallout, {
                                    heading: "What this means",
                                    children: movingTo !== 'care' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            "The ",
                                            movingTo === 'village' ? 'Retirement Village' : 'Granny Flat',
                                            " module pays the current unit out on these terms when the move happens: the money arrives within the state's time limit (or the contract's), goes back into savings, and the current unit's fees stop. Until it arrives, the unit sits in the family's estate at what the village would pay back for it."
                                        ]
                                    }) : oneOfCoupleEntering && !v.onEnteringCare ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            "Until this is answered we assume ",
                                            stayingName,
                                            " stays on: the village fees continue, nothing is paid out, ",
                                            enteringName,
                                            " is still treated as a homeowner through the unit, and the unit sits in the family's estate at what the village would pay back for it."
                                        ]
                                    }) : oneOfCoupleEntering && v.onEnteringCare === 'keep_partner_stays' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            stayingName,
                                            " stays on in the unit: the village fees continue, nothing is paid out, and ",
                                            enteringName,
                                            " is still treated as a homeowner through it. The Aged Care module prices care on that basis, and the unit sits in the family's estate at what the village would pay back for it."
                                        ]
                                    }) : oneOfCoupleEntering && v.onEnteringCare === 'sell_when_partner_leaves' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            "The unit is kept while ",
                                            stayingName,
                                            " is there, so for now nothing is paid out and ",
                                            enteringName,
                                            " is still a homeowner through it. The later sale is not dated, so the Aged Care module prices care on the unit being kept, with the unit in the family's estate at what the village would pay back for it."
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            "The Aged Care module works out the exit entitlement from these terms and models the wait for it: until the village pays, the entry contribution still counts as ",
                                            vVillage.pronounPossessive,
                                            " home, and any part of the aged care room it is to pay for is charged daily in the meantime. From the day it is paid ",
                                            vVillage.subject,
                                            " ",
                                            vVillage.verb('are', 'is'),
                                            " assessed as a non-homeowner, and the money can go to the room's deposit or stay in the bank."
                                        ]
                                    })
                                })
                            ]
                        });
                    })()
                ]
            }),
            inGrannyFlat && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                        className: "text-lg font-semibold text-gray-700 mb-1",
                        children: sectionTitle('granny_flat', 'Granny flat details')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$GrannyFlatFields, {
                        factFind: factFind,
                        updateFactFind: updateFactFind,
                        voice: voice
                    })
                ]
            }),
            withFamily && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                        className: "text-lg font-semibold text-gray-700 mb-1",
                        children: sectionTitle('with_family', 'Living with family')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-sm text-gray-500 mb-4",
                        children: [
                            "First, one question so we treat ",
                            vFamily.possessive,
                            " situation correctly."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                        label: `To live there, did ${vFamily.subject} pay money or transfer ${vFamily.pronounPossessive} home or other assets in return for the right to live there?`,
                        name: "grannyFlatInterest",
                        value: (0, $8ab044f9996773da$export$71dc53db491defdf)(grannyFlatInterest),
                        onChange: (n, v)=>updateFactFind('livingWithFamily', n, (0, $8ab044f9996773da$export$87f1f3a36f1f2332)(v)),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: "",
                                children: "Select..."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                value: "yes",
                                children: [
                                    "Yes \u2014 ",
                                    vFamily.isThirdPerson ? 'they' : 'I',
                                    " paid money or transferred assets for the right to live there"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                value: "no",
                                children: [
                                    "No \u2014 ",
                                    vFamily.isThirdPerson ? 'they' : 'I',
                                    " just live with family (and may pay board)"
                                ]
                            })
                        ]
                    }),
                    grannyFlatInterest === true && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$GrannyFlatFields, {
                            factFind: factFind,
                            updateFactFind: updateFactFind,
                            voice: voice
                        })
                    }),
                    grannyFlatInterest === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 items-start",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                    label: `Board / lodging ${vFamily.subject} ${vFamily.verb('pay', 'pays')} per week`,
                                    value: factFind.livingWithFamily?.boardPerWeek ?? '',
                                    onChange: (v)=>updateFactFind('livingWithFamily', 'boardPerWeek', v),
                                    placeholder: "$0"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-2 text-xs text-gray-500",
                                children: [
                                    "If ",
                                    vFamily.pronoun,
                                    " sold a home to move in, record what is left of the proceeds under Assets as it stands today. Anything given to family goes under Gifting with its date."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/**
 * ONE control for what a super or pension account is assumed to earn: a risk-profile dropdown whose
 * options carry the preset rates, with a numeric field appearing ONLY when "Custom" is chosen —
 * two always-visible fields describing the same number read as a question ("which one wins?").
 *
 * The dropdown writes ONLY `growthRate` (the field the projections read); the selection is DERIVED
 * by matching the saved rate back to the published table, so the two can never disagree, and a
 * hand-typed 6.6 on a pension honestly shows as Balanced because it IS the Balanced assumption.
 * `explicitCustom` is the one bit of local state: without it, choosing Custom while the rate still
 * equals a preset would immediately derive back to that preset and hide the field mid-edit.
 */ const $9f897eee40813319$var$SuperReturnControl = ({ asset: asset, wrapper: wrapper, updateAsset: updateAsset, voice: voice })=>{
    const [explicitCustom, setExplicitCustom] = (0, $acw62.useState)(false);
    const derived = (0, $0f2c0a6799fe36da$export$acc007763407ac2f)(wrapper, asset.growthRate);
    const profileId = explicitCustom ? 'custom' : derived;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Assumed Annual Return (risk profile) ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                            text: `The long-term yearly return assumed for this account \u{2014} income and growth combined, after fund fees and taxes, which is the figure ${voice.pronounPossessive} fund statement reports. Pick the investment option named on the statement (most funds call these Conservative, Balanced, Growth or similar); Balanced is the most common default. Choose Custom to enter the fund's actual published return instead. Left blank, we assume Balanced.`
                        })
                    ]
                }),
                name: "investmentProfile",
                value: profileId,
                onChange: (_n, v)=>{
                    if (v === 'custom') {
                        setExplicitCustom(true);
                        return;
                    }
                    setExplicitCustom(false);
                    updateAsset(asset.type, asset.id, 'growthRate', (0, $0f2c0a6799fe36da$export$d5067509ad465da9)(v, wrapper));
                },
                children: [
                    (0, $0f2c0a6799fe36da$export$56315028e4277c0c).map((id)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: id,
                            children: `${(0, $0f2c0a6799fe36da$export$c14c81fc2b7ae703)[id].label} \u{2014} ${(0, $0f2c0a6799fe36da$export$d5067509ad465da9)(id, wrapper).toFixed(2)}% p.a.${id === (0, $0f2c0a6799fe36da$export$f692c4a779b1d5f6) ? ' (most common default)' : ''}`
                        }, id)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: "custom",
                        children: "Custom \u2014 enter my own rate"
                    })
                ]
            }),
            profileId === 'custom' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd6bad1410bfbf4$export$2e2bcd8739ae039), {
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Custom annual return (%) ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                            text: "Income and growth combined, after fund fees and taxes \u2014 straight off the fund's statement. If it matches one of the standard options, we'll show it under that name."
                        })
                    ]
                }),
                name: "growthRate",
                value: asset.growthRate ?? '',
                onChange: (v)=>updateAsset(asset.type, asset.id, 'growthRate', v)
            })
        ]
    });
};
// --- AssetFormFields: A dedicated component to render asset-specific fields ---
const $9f897eee40813319$var$AssetFormFields = ({ asset: asset, updateAsset: updateAsset, isPartnered: isPartnered, factFind: factFind, voice: voice })=>{
    const assetConfig = (0, $77d0522707ddb581$export$e18ad1b53d14ba76).find((a)=>a.id === asset.type);
    const ownershipOptions = (individualOnly)=>{
        const options = [
            {
                value: 'client',
                label: factFind.client?.firstName || 'Applicant 1'
            }
        ];
        if (isPartnered) {
            options.push({
                value: 'partner',
                label: factFind.partner?.firstName || 'Applicant 2'
            });
            if (!individualOnly) options.push({
                value: 'joint',
                label: 'Joint'
            });
        }
        (factFind.structures || []).forEach((structure)=>{
            options.push({
                value: (0, $1773fcf9595c5c0a$export$66d936c41d42a933)(structure.id || ''),
                label: structure.name?.trim() || 'Unnamed arrangement'
            });
        });
        return options;
    };
    // Option C on the CGT data question: don't force the client to supply a cost base or purchase month
    // they may not have, but don't let the fallback assumptions pass unseen either (see cgtDataQuality.ts).
    //
    // Styled as quiet helper text, NOT as a warning: nothing is wrong — the client simply hasn't given us
    // an optional figure, and the estimate still works. A filled amber panel with a warning triangle read
    // as an error on a field the form itself labels "(if known)". Being unobtrusive is also what lets this
    // show on every asset with a gap rather than only large ones, so two assets missing the same field are
    // never treated differently for reasons invisible on screen.
    const renderCgtDataHint = (a)=>{
        const gap = (0, $2fa27b08acd205b2$export$71af6709f85e7408)(a, a.type || '');
        if (!gap) return null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            className: "md:col-span-2 -mt-1 text-xs text-slate-500 flex items-start gap-1.5",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                    size: 13,
                    className: "shrink-0 mt-0.5 text-slate-400"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: (0, $2fa27b08acd205b2$export$22708db49a7d569f)(gap)
                })
            ]
        });
    };
    const commonFields = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                label: "Description / Institution",
                name: "description",
                id: `description-${asset.id}`,
                value: asset.description,
                onChange: (n, v)=>updateAsset(asset.type, asset.id, n, v)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                label: asset.type === 'annuities' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Current Value ($) ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                            text: "The withdrawal value on the provider's statement \u2014 what would come back if the annuity were cancelled today (for a fixed term, the capital still to be returned). It is what the estate is worth. Centrelink does not use it for a lifetime annuity: it counts 60% of the purchase price for the first five years, or until age 85 if that is later, and 30% after that."
                        })
                    ]
                }) : 'Current Value ($)',
                name: "value",
                id: `value-${asset.id}`,
                value: asset.value,
                onChange: (v)=>updateAsset(asset.type, asset.id, 'value', v)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Ownership ",
                        (factFind.structures || []).length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                            text: `Personal name = in ${voice.pronounPossessive} own name. Choosing a trust or company means the asset is held inside that arrangement.`
                        }) : null
                    ]
                }),
                name: "ownership",
                id: `ownership-${asset.id}`,
                value: asset.ownership || 'client',
                onChange: (n, v)=>updateAsset(asset.type, asset.id, n, v),
                children: ownershipOptions(assetConfig?.individualOnly).map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: opt.value,
                        children: opt.label
                    }, opt.value))
            })
        ]
    });
    const superInvestmentFields = (wrapper)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$SuperReturnControl, {
            asset: asset,
            wrapper: wrapper,
            updateAsset: updateAsset,
            voice: voice
        });
    switch(asset.type){
        case 'investmentProperty':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-2",
                children: [
                    commonFields,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd6bad1410bfbf4$export$2e2bcd8739ae039), {
                        label: "Assumed Annual Growth Rate (%)",
                        name: "growthRate",
                        value: asset.growthRate || '5',
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'growthRate', v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Cost Base ($) ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                    text: `What ${voice.subject} originally paid, plus purchase costs such as stamp duty and legal fees. This is subtracted from the sale price to work out the capital gain. If you leave it blank we assume 25% of the current value, which usually overstates the tax.`
                                })
                            ]
                        }),
                        name: "costBase",
                        value: asset.costBase,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'costBase', v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Month/Year Acquired (if known) ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                    text: `Roughly when ${voice.subject} bought this \u{2014} the month is enough. It decides whether the 50% CGT discount applies (which needs more than 12 months of ownership), whether the property is exempt as a pre-20 September 1985 asset, and for sales from 1 July 2027 how the gain is split under the new CGT rules. Leave it blank if you're unsure and we'll assume it has been held more than 12 months; that assumption is disclosed in ${voice.possessive} Statement of Advice if the property is sold.`
                                })
                            ]
                        }),
                        name: "acquiredOn",
                        id: `acquiredOn-${asset.id}`,
                        type: "month",
                        value: asset.acquiredOn,
                        onChange: (n, v)=>updateAsset(asset.type, asset.id, n, v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        label: "Annual Rent ($)",
                        name: "rent",
                        value: asset.rent,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'rent', v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        label: "Annual Expenses ($)",
                        name: "expenses",
                        value: asset.expenses,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'expenses', v)
                    }),
                    !(0, $d1b9bbc5238c0548$export$2f999b99c41ee933)(factFind) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        "Was this the home ",
                                        voice.subject,
                                        " lived in before moving? ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                            text: `A home ${voice.subject} moved out of and rented since is sold under the main-residence rules: no CGT within six years of first renting it out, and after that tax only on the time beyond six years, from its value when first rented.`
                                        })
                                    ]
                                }),
                                name: "formerHome",
                                value: asset.formerHome === true ? 'yes' : asset.formerHome === false ? 'no' : '',
                                onChange: (_n, v)=>updateAsset(asset.type, asset.id, 'formerHome', v === 'yes' ? true : v === 'no' ? false : undefined),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "Select..."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                        value: "yes",
                                        children: [
                                            "Yes \u2014 ",
                                            voice.pronoun,
                                            " lived there and now rent it out"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "no",
                                        children: "No \u2014 always an investment"
                                    })
                                ]
                            }),
                            asset.formerHome === true && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        "Month/Year first rented out ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                            text: "The six years run from here, and the cost base for any later sale is the property's value at this date."
                                        })
                                    ]
                                }),
                                name: "firstRentedOn",
                                type: "month",
                                value: asset.firstRentedOn || '',
                                onChange: (_n, v)=>updateAsset(asset.type, asset.id, 'firstRentedOn', v)
                            })
                        ]
                    }),
                    renderCgtDataHint(asset)
                ]
            });
        case 'shares':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-2",
                children: [
                    commonFields,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd6bad1410bfbf4$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Income Rate (% p.a.) ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                    text: `This is the annual income yield (for example dividends/distributions) as a percentage of the current balance. You can usually find it on ${voice.pronounPossessive} annual tax statement, dividend/distribution statement, or ${voice.pronounPossessive} investment platform summary.`
                                })
                            ]
                        }),
                        name: "incomeRate",
                        value: asset.incomeRate,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'incomeRate', v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd6bad1410bfbf4$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Franking Credit (%) ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                    text: `Franking credits represent tax already paid by the company on ${voice.pronounPossessive} behalf. They can reduce the tax ${voice.pronoun} pay on dividends. You can find this rate on ${voice.pronounPossessive} dividend statements, annual tax statements, or ${voice.pronounPossessive} investment platform.`
                                })
                            ]
                        }),
                        name: "frankingCredit",
                        value: asset.frankingCredit || '70',
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'frankingCredit', v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd6bad1410bfbf4$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Assumed Annual Growth Rate (%) ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                    text: `This is ${voice.possessive} long-term capital growth assumption. If unsure, use the provider/app performance history as a guide and keep assumptions conservative for planning.`
                                })
                            ]
                        }),
                        name: "growthRate",
                        value: asset.growthRate || '5',
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'growthRate', v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Cost Base ($) ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                    text: `What ${voice.subject} originally paid, plus purchase costs such as brokerage. This is subtracted from the sale price to work out the capital gain. If you leave it blank we assume 25% of the current value, which usually overstates the tax.`
                                })
                            ]
                        }),
                        name: "costBase",
                        value: asset.costBase,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'costBase', v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Month/Year Acquired (if known) ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                    text: `Roughly when ${voice.subject} bought these \u{2014} the month is enough. It decides whether the 50% CGT discount applies (which needs more than 12 months of ownership) and, for sales from 1 July 2027, how the gain is split under the new CGT rules. For a holding built up over time, use when ${voice.pronoun} first started buying. Leave it blank if you're unsure and we'll assume they have been held more than 12 months; that assumption is disclosed in ${voice.possessive} Statement of Advice if the holding is sold.`
                                })
                            ]
                        }),
                        name: "acquiredOn",
                        id: `acquiredOn-${asset.id}`,
                        type: "month",
                        value: asset.acquiredOn,
                        onChange: (n, v)=>updateAsset(asset.type, asset.id, n, v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Reinvest Distributions? ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                    text: `If 'Yes', dividend and distribution payments are automatically used to buy more shares, increasing ${voice.possessive} investment over time. If 'No', payments are received as cash income.`
                                })
                            ]
                        }),
                        name: "reinvest",
                        value: (0, $8ab044f9996773da$export$3b62265a75916bfa)(asset.reinvest),
                        onChange: (n, v)=>updateAsset(asset.type, asset.id, n, (0, $8ab044f9996773da$export$1923fe087c479fde)(v)),
                        options: [
                            {
                                label: 'Yes',
                                value: 'yes'
                            },
                            {
                                label: 'No',
                                value: 'no'
                            }
                        ]
                    }),
                    renderCgtDataHint(asset)
                ]
            });
        case 'accountBasedPensions':
            {
                // Plain derivation (not useMemo) — this runs inside a switch branch, so a hook here
                // would violate the rules of hooks. calculateAge is cheap, so recomputing is fine.
                /*
             * Whose age governs this pension. Derived through the shared helper so the "we cannot
             * tell" case is a real answer rather than a null that silently removes the warning —
             * see components/pensionMinimum.ts.
             */ const { age: ownerAge, who: ownerName } = (0, $bf7afaad28ce9e40$export$b2b73b961da00a92)(asset.ownership, factFind);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-2",
                    children: [
                        commonFields,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "Annual Pension Payment ($) ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                text: `Usually shown on ${voice.pronounPossessive} account-based pension annual statement or portal. Note: this amount can differ from the legislated minimum for ${voice.pronounPossessive} age due to timing, pro-rata payments in the start year, payment frequency, and ad-hoc withdrawals.`
                                            })
                                        ]
                                    }),
                                    name: "income",
                                    value: asset.income,
                                    onChange: (v)=>updateAsset(asset.type, asset.id, 'income', v)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $147efcf1cef318bc$export$2e2bcd8739ae039), {
                                    asset: asset,
                                    ownerAge: ownerAge,
                                    ownerName: ownerName
                                })
                            ]
                        }),
                        superInvestmentFields('pension'),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-medium text-gray-700 mb-1",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "flex items-center",
                                        children: [
                                            "When was the pension commenced?",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "text-left",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "font-bold mb-1",
                                                            children: "This is crucial for the Centrelink income test:"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "mb-1",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    className: "text-blue-300",
                                                                    children: "Post 1 Jan 2015:"
                                                                }),
                                                                " The full account balance is 'deemed' to earn a set interest rate."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    className: "text-blue-300",
                                                                    children: "Pre 1 Jan 2015:"
                                                                }),
                                                                " A 'deductible amount' (based on life expectancy and original purchase price) is subtracted from ",
                                                                voice.pronounPossessive,
                                                                " annual payment. This is often more favourable. Providing the exact date allows for a more accurate calculation."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex items-center gap-4",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                        label: "",
                                        name: "commencementDateOption",
                                        value: asset.commencementDateOption || 'post-2015',
                                        onChange: (n, v)=>updateAsset(asset.type, asset.id, n, v),
                                        options: [
                                            {
                                                label: 'Pre 1 Jan 2015',
                                                value: 'pre-2015'
                                            },
                                            {
                                                label: 'Post 1 Jan 2015',
                                                value: 'post-2015'
                                            }
                                        ]
                                    })
                                }),
                                asset.commencementDateOption === 'pre-2015' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-2 space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                                    label: "Exact Commencement Date",
                                                    name: "commencementDate",
                                                    type: "date",
                                                    value: asset.commencementDate || '',
                                                    onChange: (n, v)=>updateAsset(asset.type, asset.id, n, v),
                                                    disabled: asset.commencementDateUnsure
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                    label: "Original Purchase Price ($)",
                                                    name: "purchasePrice",
                                                    value: asset.purchasePrice,
                                                    onChange: (v)=>updateAsset(asset.type, asset.id, 'purchasePrice', v)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                            label: "I'm not sure of the exact date",
                                            name: "commencementDateUnsure",
                                            checked: asset.commencementDateUnsure,
                                            onChange: (n, v)=>updateAsset(asset.type, asset.id, n, v)
                                        }),
                                        asset.commencementDateUnsure && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-xs text-amber-700 bg-amber-100 p-2 rounded-md flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                                    size: 14
                                                }),
                                                " We will use a worst-case scenario for calculations."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
        case 'annuities':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-2",
                children: [
                    commonFields,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        label: "Annual Payment ($)",
                        name: "income",
                        value: asset.income,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'income', v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                        label: "Annuity Type",
                        name: "annuityType",
                        value: asset.annuityType || '',
                        onChange: (n, v)=>updateAsset(asset.type, asset.id, n, v),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: "",
                                children: "Select..."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: "lifetime",
                                children: "Lifetime"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: "fixed_term",
                                children: "Fixed Term"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Date the annuity started (if known) ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                    text: "Decides how long it has been held. For a lifetime annuity that sets when Centrelink drops from counting 60% of the purchase price to 30%; for a fixed term it sets how much of the capital has already come back and when the term ends. Leave blank and we count from today."
                                })
                            ]
                        }),
                        name: "commencementDate",
                        type: "date",
                        value: asset.commencementDate,
                        onChange: (n, v)=>updateAsset(asset.type, asset.id, n, v)
                    }),
                    asset.annuityType === 'fixed_term' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $36fba7e03e1bb69f$export$2e2bcd8739ae039), {
                        label: "Term (years, if fixed)",
                        name: "term",
                        value: asset.term,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'term', v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        label: "Purchase Price ($)",
                        name: "purchasePrice",
                        value: asset.purchasePrice,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'purchasePrice', v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Residual Capital Value (RCV) ($) ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                    text: "The amount of capital left at the end of the annuity term. Enter 0 if none."
                                })
                            ]
                        }),
                        name: "rcv",
                        value: asset.rcv,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'rcv', v)
                    }),
                    asset.annuityType === 'lifetime' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                label: "Payments rise with inflation each year",
                                name: "indexed",
                                checked: !!asset.indexed,
                                onChange: (n, v)=>updateAsset(asset.type, asset.id, n, v)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $36fba7e03e1bb69f$export$2e2bcd8739ae039), {
                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        "Guarantee period (years, if any) ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                            text: "Some lifetime annuities promise a minimum number of years of payments: if death comes within that time, the rest of those payments go to the estate as a lump sum. UniSuper's Lifetime Income has one (the lesser of 10 years and life expectancy); Challenger's plain Liquid Lifetime does not. It is on the provider's statement. Leave blank if there is none."
                                        })
                                    ]
                                }),
                                name: "guaranteePeriodYears",
                                value: asset.guaranteePeriodYears,
                                onChange: (v)=>updateAsset(asset.type, asset.id, 'guaranteePeriodYears', v)
                            }),
                            isPartnered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd6bad1410bfbf4$export$2e2bcd8739ae039), {
                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        "Share that continues to a spouse on death (%) ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                            text: "The percentage of the payment the surviving spouse keeps for life, from the provider's statement \u2014 100% on a joint-life product, 0% where there is no reversion. Stated in the advice; the projection does not model a death."
                                        })
                                    ]
                                }),
                                name: "reversionPct",
                                value: asset.reversionPct,
                                onChange: (v)=>updateAsset(asset.type, asset.id, 'reversionPct', v)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Funding Source ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                    text: "Annuities bought with super money can have different social security outcomes compared to those bought with personal savings."
                                })
                            ]
                        }),
                        name: "fundingSource",
                        value: asset.fundingSource || 'super',
                        onChange: (n, v)=>updateAsset(asset.type, asset.id, n, v),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: "super",
                                children: "Superannuation Money"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: "non_super",
                                children: "Personal Savings"
                            })
                        ]
                    })
                ]
            });
        case 'termDeposits':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-2",
                children: [
                    commonFields,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd6bad1410bfbf4$export$2e2bcd8739ae039), {
                        label: "Interest Rate (% p.a.)",
                        name: "incomeRate",
                        value: asset.incomeRate,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'incomeRate', v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                        label: "Maturity Date",
                        name: "maturityDate",
                        type: "date",
                        value: asset.maturityDate,
                        onChange: (n, v)=>updateAsset(asset.type, asset.id, n, v)
                    })
                ]
            });
        case 'other':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-2",
                children: [
                    commonFields,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        label: "Annual Income ($)",
                        name: "income",
                        value: asset.income,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'income', v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        label: "Annual Expenses ($)",
                        name: "expenses",
                        value: asset.expenses,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'expenses', v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd6bad1410bfbf4$export$2e2bcd8739ae039), {
                        label: "Assumed Growth Rate (%)",
                        name: "growthRate",
                        value: asset.growthRate,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'growthRate', v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Cost Base ($) ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                    text: "The original purchase price for CGT calculations. If unknown, we'll assume 25% of current value."
                                })
                            ]
                        }),
                        name: "costBase",
                        value: asset.costBase,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'costBase', v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Month/Year Acquired (if known) ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                    text: `Roughly when ${voice.subject} bought this \u{2014} the month is enough. It decides whether the 50% CGT discount applies (which needs more than 12 months of ownership), whether it is exempt as a pre-20 September 1985 asset, and for sales from 1 July 2027 how the gain is split under the new CGT rules. Leave it blank if you're unsure and we'll assume it has been held more than 12 months; that assumption is disclosed in ${voice.possessive} Statement of Advice if the asset is sold.`
                                })
                            ]
                        }),
                        name: "acquiredOn",
                        id: `acquiredOn-${asset.id}`,
                        type: "month",
                        value: asset.acquiredOn,
                        onChange: (n, v)=>updateAsset(asset.type, asset.id, n, v)
                    }),
                    renderCgtDataHint(asset)
                ]
            });
        case 'bankAccounts':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-2",
                children: [
                    commonFields,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd6bad1410bfbf4$export$2e2bcd8739ae039), {
                        label: "Interest Rate (% p.a.)",
                        name: "incomeRate",
                        value: asset.incomeRate,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'incomeRate', v)
                    })
                ]
            });
        case 'investmentBonds':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-2",
                children: [
                    commonFields,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd6bad1410bfbf4$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Assumed Growth Rate (% p.a., after the bond's own tax) ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                    text: "An investment bond pays its own tax inside (30% on earnings) and pays nothing out, so this is the growth you would see on the statement. No tax is added on your side. After ten years withdrawals are tax-free; the projection leaves the bond untouched until then."
                                })
                            ]
                        }),
                        name: "growthRate",
                        value: asset.growthRate,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'growthRate', v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Date the bond started (if known) ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                    text: `When ${voice.subject} bought it. Withdrawals become tax-free ten years from this date \u{2014} the projection will not draw on the bond before then. Leave blank and we count from today.`
                                })
                            ]
                        }),
                        name: "commencementDate",
                        type: "date",
                        value: asset.commencementDate,
                        onChange: (n, v)=>updateAsset(asset.type, asset.id, n, v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "md:col-span-2 -mt-1 text-xs text-slate-500",
                        children: "Centrelink counts an investment bond in full and deems it, like cash or shares."
                    })
                ]
            });
        /* Owner, 5 Oct 2026: a funeral paid in advance is not a funeral bond, and is fully exempt. */ case 'prepaidFuneral':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-2",
                children: [
                    commonFields,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "md:col-span-2 -mt-1 text-xs text-slate-500",
                        children: "A funeral paid for in advance with a funeral director, under a contract that cannot be refunded. Centrelink does not count it at all, whatever it cost. If it can be refunded, or it is an investment set aside for a funeral, record it as a funeral bond instead."
                    })
                ]
            });
        /* Owner, 5 Oct 2026: money lent is still an asset — counted at what is owed, and deemed. */ case 'loansToOthers':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                        label: "Who the money was lent to",
                        name: "description",
                        id: `description-${asset.id}`,
                        value: asset.description,
                        onChange: (n, v)=>updateAsset(asset.type, asset.id, n, v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        label: "Still owed ($)",
                        name: "value",
                        id: `value-${asset.id}`,
                        value: asset.value,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'value', v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                        label: "Lent by",
                        name: "ownership",
                        id: `ownership-${asset.id}`,
                        value: asset.ownership || 'client',
                        onChange: (n, v)=>updateAsset(asset.type, asset.id, n, v),
                        children: ownershipOptions(assetConfig?.individualOnly).map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: opt.value,
                                children: opt.label
                            }, opt.value))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Amount first lent ($, optional) ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                    text: "Only used to fill in the Services Australia forms, which ask for it. It does not change any figures. Leave it blank and write it on the form yourself if you prefer."
                                })
                            ]
                        }),
                        name: "purchasePrice",
                        value: asset.purchasePrice,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'purchasePrice', v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Date lent (optional) ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                    text: "Only used to fill in the Services Australia forms, which ask for it. It does not change any figures. Leave it blank and write it on the form yourself if you prefer."
                                })
                            ]
                        }),
                        name: "commencementDate",
                        type: "date",
                        value: asset.commencementDate,
                        onChange: (n, v)=>updateAsset(asset.type, asset.id, n, v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd6bad1410bfbf4$export$2e2bcd8739ae039), {
                        label: "Interest charged (% p.a., if any)",
                        name: "incomeRate",
                        value: asset.incomeRate,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'incomeRate', v)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "md:col-span-2 -mt-1 text-xs text-slate-500",
                        children: "Centrelink counts what is still owed and deems it, like money in the bank, whether or not it is being paid back. A loan that has been forgiven is a gift instead."
                    })
                ]
            });
        case 'personalAssets':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-2",
                children: [
                    commonFields,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd6bad1410bfbf4$export$2e2bcd8739ae039), {
                        label: "Assumed Growth Rate (%)",
                        name: "growthRate",
                        value: asset.growthRate,
                        onChange: (v)=>updateAsset(asset.type, asset.id, 'growthRate', v)
                    })
                ]
            });
        // Accumulation super previously fell through to the bare default card: no return field at
        // all, while buildNewAsset silently stamped a growth rate the user never saw. The rate now
        // has a visible field and a named investment option, like every other earning asset.
        case 'superannuation':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-2",
                children: [
                    commonFields,
                    superInvestmentFields('accumulation')
                ]
            });
        default:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid grid-cols-1 md:grid-cols-3 gap-4 mt-2",
                children: commonFields
            });
    }
};
const $9f897eee40813319$export$e4d07404b15ce2bd = ({ factFind: factFind, setFactFind: setFactFind, isPartnered: isPartnered, showStructureAdviserFields: showStructureAdviserFields = false, voice: voice })=>{
    const [showImportModal, setShowImportModal] = (0, $acw62.useState)(false);
    const addAsset = (type)=>{
        const newAsset = (0, $138d267475fbd696$export$7da607f9900cf706)(type, isPartnered);
        const currentAssets = factFind.assets?.[type] || [];
        setFactFind((prev)=>({
                ...prev,
                assets: {
                    ...prev.assets,
                    [type]: [
                        ...currentAssets,
                        newAsset
                    ]
                }
            }));
        // Auto-scroll to the newly added asset after a brief delay
        setTimeout(()=>{
            const newAssetElement = document.querySelector(`[data-asset-id="${newAsset.id}"]`);
            if (newAssetElement) {
                newAssetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
                // Focus the first input field in the new asset
                const firstInput = newAssetElement.querySelector('input, select, textarea');
                if (firstInput && firstInput instanceof HTMLElement) firstInput.focus();
            }
        }, 200);
    };
    const updateAsset = (type, id, field, value)=>{
        if (!type) return;
        const updatedAssets = (factFind.assets?.[type] || []).map((asset)=>asset.id === id ? {
                ...asset,
                [field]: value
            } : asset);
        setFactFind((prev)=>({
                ...prev,
                assets: {
                    ...prev.assets,
                    [type]: updatedAssets
                }
            }));
    };
    const removeAsset = (type, id)=>{
        const filteredAssets = (factFind.assets?.[type] || []).filter((asset)=>asset.id !== id);
        setFactFind((prev)=>({
                ...prev,
                assets: {
                    ...prev.assets,
                    [type]: filteredAssets
                }
            }));
    };
    const handleImportConfirm = (picked)=>{
        setFactFind((prev)=>(0, $138d267475fbd696$export$66280580b9910f1d)(prev, picked, isPartnered));
        setShowImportModal(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            showImportModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ab442452bedaadf$export$2e2bcd8739ae039), {
                onClose: ()=>setShowImportModal(false),
                onConfirm: handleImportConfirm,
                household: {
                    isCouple: isPartnered,
                    clientName: factFind.client?.firstName || null,
                    partnerName: isPartnered ? factFind.partner?.firstName || null : null
                },
                existingAssets: factFind.assets || {},
                existingHome: factFind.home || null
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$StepHeader, {
                icon: (0, $33b542e8915cec79$export$2e2bcd8739ae039),
                step: 5,
                title: "Assets"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00485cf07937db2b$export$2e2bcd8739ae039), {
                        factFind: factFind,
                        setFactFind: setFactFind,
                        isPartnered: isPartnered,
                        clientName: factFind.client?.firstName || 'Applicant 1',
                        partnerName: factFind.partner?.firstName || 'Partner',
                        showAdviserFields: showStructureAdviserFields,
                        voice: voice
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                                className: "text-lg font-semibold text-gray-700 mb-4",
                                children: "Add Financial & Personal Assets"
                            }),
                            (factFind.structures || []).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-gray-600 mb-4",
                                children: [
                                    "For assets inside a trust or company, choose that arrangement under Ownership and enter the",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "full value"
                                    }),
                                    " of each asset. ",
                                    voice.Possessive,
                                    " net worth uses the apportionment percentages on each arrangement."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex gap-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                    name: "assetType",
                                    value: "",
                                    onChange: (name, value)=>{
                                        if (value) addAsset(value);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "",
                                            children: "Add an asset..."
                                        }),
                                        (0, $77d0522707ddb581$export$e18ad1b53d14ba76).map((type)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: type.id,
                                                children: type.name
                                            }, type.id))
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mt-3 text-sm text-gray-600",
                                children: [
                                    "Have a statement?",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "text-blue-600 font-semibold hover:underline focus:outline-none",
                                        onClick: ()=>setShowImportModal(true),
                                        children: "Import with AI"
                                    }),
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-gray-500",
                                        children: "(optional)"
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $77d0522707ddb581$export$e18ad1b53d14ba76).map((type)=>(factFind.assets?.[type.id]?.length ?? 0) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("legend", {
                                    className: "text-lg font-semibold text-gray-700 mb-4 flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(type.icon, {
                                            className: "text-blue-600"
                                        }),
                                        " ",
                                        type.name
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "space-y-4",
                                    children: (factFind.assets?.[type.id] || []).map((asset)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            "data-asset-id": asset.id,
                                            className: "p-4 bg-slate-50 rounded-lg border border-slate-200 hover:bg-slate-100 transition-all duration-300",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "flex justify-end",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>removeAsset(type.id, asset.id),
                                                        className: "p-2 text-red-500 hover:text-red-700 hover:bg-red-100 rounded-full transition-all duration-300 hover:scale-110",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                            size: 20
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$AssetFormFields, {
                                                    asset: asset,
                                                    updateAsset: updateAsset,
                                                    isPartnered: isPartnered,
                                                    factFind: factFind,
                                                    voice: voice
                                                })
                                            ]
                                        }, asset.id))
                                })
                            ]
                        }, type.id)),
                    (()=>{
                        const totalAssets = (0, $77d0522707ddb581$export$e18ad1b53d14ba76).reduce((total, type)=>total + (factFind.assets?.[type.id]?.length || 0), 0);
                        return totalAssets >= 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                            className: "mt-8 pt-6 border-t-2 border-gray-200",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                                    className: "text-lg font-semibold text-gray-700 mb-4",
                                    children: "Add More Assets"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex gap-4",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                        name: "assetType",
                                        value: "",
                                        onChange: (name, value)=>{
                                            if (value) addAsset(value);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: "Add another asset..."
                                            }),
                                            (0, $77d0522707ddb581$export$e18ad1b53d14ba76).map((type)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: type.id,
                                                    children: type.name
                                                }, type.id))
                                        ]
                                    })
                                })
                            ]
                        });
                    })()
                ]
            })
        ]
    });
};
const $9f897eee40813319$export$4df5c2c9b71b530b = ({ factFind: factFind, setFactFind: setFactFind, isPartnered: isPartnered, voice: voice })=>{
    const liabilityWarnings = (0, $acw62.useMemo)(()=>(0, $3bf9a60a18bad06d$export$78f08a6997809e06)(factFind), [
        factFind
    ]);
    const hasStructures = (factFind.structures || []).length > 0;
    const addLiability = (type)=>{
        const newLiability = {
            id: (0, $942f2f96766bf874$export$d3a77fab0baa99a2)(),
            type: type,
            description: '',
            frequency: 'monthly',
            assetLink: type === 'mortgages' ? 'home' : 'none',
            ownership: isPartnered ? 'joint' : 'client',
            loanType: 'pi',
            // Only a debt with a term has a repayment to derive. A credit card revolves, so it is
            // recorded as 'manual' from the outset rather than carrying an 'auto' the engine would
            // never act on and the form would never offer a way out of.
            repaymentCalculation: type === 'mortgages' || type === 'personalLoans' ? 'auto' : 'manual',
            // A capitalising loan always accrues, so it starts with a workable rate rather than a
            // blank the client may not know to fill. The HEAS rate is set by government; the reverse
            // mortgage figure is market-typical and meant to be edited. These match the defaults the
            // engine falls back to (loanPlugin), so the rate shown is the rate modelled.
            ...type === 'homeEquityAccessScheme' ? {
                interestRate: 3.95
            } : {},
            ...type === 'reverseMortgages' ? {
                interestRate: (0, $eb5ee2a9aeb43da8$export$143dcd48cd2c279)
            } : {}
        };
        const currentLiabilities = factFind.liabilities?.[type] || [];
        setFactFind((prev)=>({
                ...prev,
                liabilities: {
                    ...prev.liabilities,
                    [type]: [
                        ...currentLiabilities,
                        newLiability
                    ]
                }
            }));
    };
    const updateLiability = (type, id, field, value)=>{
        const updatedLiabilities = (factFind.liabilities?.[type] || []).map((item)=>item.id === id ? {
                ...item,
                [field]: value
            } : item);
        setFactFind((prev)=>({
                ...prev,
                liabilities: {
                    ...prev.liabilities,
                    [type]: updatedLiabilities
                }
            }));
    };
    const removeLiability = (type, id)=>{
        const filteredLiabilities = (factFind.liabilities?.[type] || []).filter((item)=>item.id !== id);
        setFactFind((prev)=>({
                ...prev,
                liabilities: {
                    ...prev.liabilities,
                    [type]: filteredLiabilities
                }
            }));
    };
    const investmentProperties = factFind.assets?.investmentProperty || [];
    const syncOwnershipFromAssetLink = (type, id, assetLink)=>{
        if (type !== 'mortgages' || !assetLink || assetLink === 'home') return;
        const prop = investmentProperties.find((p)=>String(p.id) === String(assetLink));
        if (prop?.ownership && (0, $1773fcf9595c5c0a$export$22ac2880024a2dd9)(prop.ownership)) updateLiability(type, id, 'ownership', prop.ownership);
    };
    /** Any debt row, in any category — what makes the "no debts" confirmation redundant. */ const hasAnyLiability = Object.values(factFind.liabilities || {}).some((list)=>Array.isArray(list) && list.length > 0);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$StepHeader, {
                icon: (0, $1299b0a605d22052$export$2e2bcd8739ae039),
                step: 6,
                title: "Liabilities"
            }),
            hasStructures && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-sm text-gray-600 mb-4",
                children: [
                    "If a loan secures property held in a trust or company, set ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "Ownership"
                    }),
                    " to that same arrangement so net worth and pension estimates reflect the debt correctly."
                ]
            }),
            liabilityWarnings.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mb-6 space-y-2",
                children: liabilityWarnings.map((msg)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex gap-2 p-3 rounded-lg bg-white border border-slate-200 border-l-4 border-l-amber-400 text-sm text-slate-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                className: "shrink-0",
                                size: 18
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: msg
                            })
                        ]
                    }, msg))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("legend", {
                                className: "text-lg font-semibold text-gray-700 mb-4",
                                children: [
                                    "Add ",
                                    voice.Possessive,
                                    " Debts"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex gap-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                    name: "liabilityType",
                                    value: "",
                                    onChange: (name, value)=>{
                                        if (value) addLiability(value);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: "",
                                            children: "Add a debt..."
                                        }),
                                        (0, $77d0522707ddb581$export$dfcae3bc547409fc).map((type)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: type.id,
                                                children: type.name
                                            }, type.id))
                                    ]
                                })
                            }),
                            !hasAnyLiability && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "mt-4 flex items-start gap-2 text-sm text-slate-600 cursor-pointer",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "checkbox",
                                        name: "liabilitiesConfirmedNone",
                                        className: "mt-0.5",
                                        checked: factFind.liabilitiesConfirmedNone === true,
                                        onChange: (e)=>setFactFind((prev)=>({
                                                    ...prev,
                                                    liabilitiesConfirmedNone: e.target.checked
                                                }))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: voice.isThirdPerson ? `${voice.Subject} ${voice.verb("don\u2019t", "doesn\u2019t")} have any debts \u{2014} nothing to add here.` : "I don\u2019t have any debts \u2014 nothing to add here."
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $77d0522707ddb581$export$dfcae3bc547409fc).map((type)=>(factFind.liabilities?.[type.id]?.length ?? 0) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("legend", {
                                    className: "text-lg font-semibold text-gray-700 mb-4 flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(type.icon, {
                                            className: "text-blue-600"
                                        }),
                                        " ",
                                        type.name
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "space-y-4",
                                    children: (factFind.liabilities?.[type.id] || []).map((item)=>{
                                        const calculatedRepayment = (0, $c9ee841cca8af175$export$1fcf7232357bf4d8)(Number(item.balance) || 0, Number(item.interestRate) || 0, Number(item.loanTerm) || 0, item.frequency || 'monthly', item.loanType || 'pi');
                                        const isMortgage = item.type === 'mortgages';
                                        // A term is what makes a repayment derivable, and a credit card has none —
                                        // it revolves. Mortgages and personal loans amortise, so they get the term,
                                        // the loan type and the auto/manual switch; a card gets a rate and whatever
                                        // the client actually pays each month.
                                        const isTermLoan = (0, $66c36853b590c88a$export$b5ec401fafcd623d)(type.id);
                                        // A reverse mortgage and a HEAS loan are repaid out of the property
                                        // when it is sold, not out of income. Asking for a repayment amount
                                        // invites a figure the client never actually pays, and the engine
                                        // deliberately ignores it (capitalisingLoans.ts) — so the box could
                                        // only ever mislead.
                                        const isCapitalising = (0, $eb5ee2a9aeb43da8$export$95d06fd31af89cb5)({
                                            type: type.id
                                        });
                                        // Asks the ENGINE whether it will derive this repayment, rather than
                                        // deciding separately and drifting from it — which is what produced the
                                        // read-only $0 that swallowed whatever was typed over it.
                                        const autoRepaymentApplies = (0, $66c36853b590c88a$export$8bcb8e3cf0ba65ef)(item);
                                        // A credit card is asked HOW it is paid, not how much (CardPaymentQuestion.tsx).
                                        const isCard = type.id === 'creditCards';
                                        const cardPaidInFull = isCard && (0, $55a6490f14a54563$export$ee09c2c29b17798e)(item) === 'full';
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "p-4 bg-slate-50 rounded-lg border border-slate-200 hover:bg-slate-100 transition-all duration-300",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "flex justify-end",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>removeLiability(type.id, item.id),
                                                        className: "p-2 text-red-500 hover:text-red-700 hover:bg-red-100 rounded-full transition-all duration-300 hover:scale-110",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                            size: 20
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                                            label: "Lender / Description",
                                                            name: "description",
                                                            id: `liability-description-${item.id}`,
                                                            value: item.description || '',
                                                            onChange: (n, v)=>updateLiability(type.id, item.id, n, v)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                            label: "Outstanding Balance ($)",
                                                            name: "balance",
                                                            id: `liability-balance-${item.id}`,
                                                            value: item.balance || '',
                                                            onChange: (v)=>updateLiability(type.id, item.id, 'balance', v)
                                                        }),
                                                        hasStructures && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                            label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                children: [
                                                                    "Ownership",
                                                                    ' ',
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                                        text: "Who is responsible for this debt? Match a trust or company if the loan secures property inside that arrangement."
                                                                    })
                                                                ]
                                                            }),
                                                            name: "ownership",
                                                            id: `liability-ownership-${item.id}`,
                                                            value: item.ownership || (isPartnered ? 'joint' : 'client'),
                                                            onChange: (n, v)=>updateLiability(type.id, item.id, n, v),
                                                            children: (0, $3bf9a60a18bad06d$export$b9bd8a3a3a6e780a)(factFind, {
                                                                isPartnered: isPartnered
                                                            }).map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: opt.value,
                                                                    children: opt.label
                                                                }, opt.value))
                                                        }),
                                                        isMortgage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                                label: "Loan secured against",
                                                                name: "assetLink",
                                                                id: `liability-assetLink-${item.id}`,
                                                                value: item.assetLink || 'home',
                                                                onChange: (n, v)=>{
                                                                    updateLiability(type.id, item.id, n, v);
                                                                    syncOwnershipFromAssetLink(type.id, item.id, v);
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "home",
                                                                        children: voice.isThirdPerson ? `${voice.Possessive} Home` : 'Family Home'
                                                                    }),
                                                                    investmentProperties.map((prop)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: prop.id,
                                                                            children: prop.description || 'Investment Property'
                                                                        }, prop.id))
                                                                ]
                                                            })
                                                        }),
                                                        !cardPaidInFull && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd6bad1410bfbf4$export$2e2bcd8739ae039), {
                                                            label: isCapitalising && type.id === 'homeEquityAccessScheme' ? "Interest Rate (%) \u2014 set by government" : 'Interest Rate (%)',
                                                            name: "interestRate",
                                                            id: `liability-interestRate-${item.id}`,
                                                            value: item.interestRate ?? (isCapitalising ? (0, $eb5ee2a9aeb43da8$export$1b1c345b360f098c)({
                                                                type: type.id
                                                            }) : ''),
                                                            onChange: (v)=>updateLiability(type.id, item.id, 'interestRate', v)
                                                        }),
                                                        isTermLoan && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $36fba7e03e1bb69f$export$2e2bcd8739ae039), {
                                                                    label: "Remaining Loan Term (Years)",
                                                                    name: "loanTerm",
                                                                    id: `liability-loanTerm-${item.id}`,
                                                                    value: item.loanTerm || '',
                                                                    onChange: (v)=>updateLiability(type.id, item.id, 'loanTerm', v)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                                    label: "Loan Type",
                                                                    name: "loanType",
                                                                    id: `liability-loanType-${item.id}`,
                                                                    value: item.loanType || 'pi',
                                                                    onChange: (n, v)=>updateLiability(type.id, item.id, n, v),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "pi",
                                                                            children: "Principal & Interest"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "io",
                                                                            children: "Interest Only"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        !isCapitalising && !isCard && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                            label: "Repayment Frequency",
                                                            name: "frequency",
                                                            id: `liability-frequency-${item.id}`,
                                                            value: item.frequency || 'monthly',
                                                            onChange: (n, v)=>updateLiability(type.id, item.id, n, v),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "weekly",
                                                                    children: "Weekly"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "fortnightly",
                                                                    children: "Fortnightly"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "monthly",
                                                                    children: "Monthly"
                                                                })
                                                            ]
                                                        }),
                                                        isTermLoan && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                            label: "Repayment Amount",
                                                            name: "repaymentCalculation",
                                                            value: item.repaymentCalculation || 'auto',
                                                            onChange: (n, v)=>updateLiability(type.id, item.id, n, v),
                                                            options: [
                                                                {
                                                                    label: 'Auto-Calculate',
                                                                    value: 'auto'
                                                                },
                                                                {
                                                                    label: 'Enter Manually',
                                                                    value: 'manual'
                                                                }
                                                            ]
                                                        }),
                                                        isCard && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80fca1c0ceeabc40$export$2e2bcd8739ae039), {
                                                            card: item,
                                                            onChange: (field, v)=>updateLiability(type.id, item.id, field, v)
                                                        }),
                                                        !isCapitalising && !isCard && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                            label: "Repayment Amount",
                                                            name: "repayments",
                                                            id: `liability-repayments-${item.id}`,
                                                            value: autoRepaymentApplies ? calculatedRepayment.toFixed(2) : item.repayments || '',
                                                            onChange: (v)=>updateLiability(type.id, item.id, 'repayments', v),
                                                            disabled: autoRepaymentApplies
                                                        }),
                                                        isCapitalising && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "md:col-span-2 rounded-lg border border-slate-200 bg-white px-3 py-2.5",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                className: "text-xs text-slate-600 leading-relaxed",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                        children: "No repayments."
                                                                    }),
                                                                    " The interest is added to the balance each year and the loan is repaid when the property is sold, so there is nothing to pay from ",
                                                                    voice.possessive,
                                                                    " income. We grow the balance using the rate above",
                                                                    type.id === 'homeEquityAccessScheme' ? " \u2014 the Home Equity Access Scheme rate is set by the government (currently 3.95%)" : '',
                                                                    "."
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, item.id);
                                    })
                                })
                            ]
                        }, type.id))
                ]
            })
        ]
    });
};
const $9f897eee40813319$export$aaa604a3749de934 = ({ factFind: factFind, updateFactFind: updateFactFind, isPartnered: isPartnered, voice: voice })=>{
    const [showBudgetCalculator, setShowBudgetCalculator] = (0, $acw62.useState)(false);
    const [showGiftingContext, setShowGiftingContext] = (0, $acw62.useState)(false);
    // When the client isn't sure, we drop in the ASFA "Comfortable" benchmark (overridable). Track it so we can show the
    // assumption note, and clear it the moment they edit the figure themselves.
    const [assumedFromAsfa, setAssumedFromAsfa] = (0, $acw62.useState)(false);
    const asfaEstimate = (isPartnered ? (0, $898ebfdbe190c9ba$export$8b6758150468ace7).couple : (0, $898ebfdbe190c9ba$export$8b6758150468ace7).single).total;
    const { income: income = {}, expenses: expenses = {} } = factFind;
    // Granny-flat deprivation (from Step 4) is auto-calculated and shown read-only here — one source of truth, no re-entry.
    const grannyFlatDep = (0, $a528307a9ba99a26$export$eb48a6112ea73d5a)(factFind, (0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).couple);
    const grannyFlatGift = grannyFlatDep && grannyFlatDep.deprivation > 0 ? grannyFlatDep : null;
    const addIncome = ()=>{
        const newIncomes = [
            ...income.otherIncomes || [],
            {
                id: (0, $942f2f96766bf874$export$d3a77fab0baa99a2)(),
                type: 'salary',
                description: '',
                amount: '',
                ownership: 'client',
                isTaxable: true,
                isAssessable: true
            }
        ];
        updateFactFind('income', 'otherIncomes', newIncomes);
    };
    /**
     * A defined benefit pension's fund preset: picking the fund settles every rule the engine turns on
     * (definedBenefitPension.ts, 15 Oct 2026), so the adviser enters a payment and a tax-free figure
     * and nothing else. A later explicit answer on the row overrides any of these.
     */ const withDefinedBenefitPreset = (inc, fundId)=>{
        const preset = (0, $f94c75e8792c4be0$export$9bb8c8dca6c61774)(fundId);
        return {
            ...inc,
            dbFund: preset.id,
            dbIndexed: preset.indexed,
            dbMilitary: preset.military,
            dbPreSept1998Product: preset.preSept1998Product,
            dbTaxedSource: preset.taxedSource,
            dbReversionPct: preset.reversionPct ?? undefined
        };
    };
    const updateIncome = (id, field, value)=>{
        const updatedIncomes = (income.otherIncomes || []).map((inc)=>{
            if (inc.id === id) {
                let newInc = {
                    ...inc,
                    [field]: value
                };
                // If type changes, update amount for auto-calculated types
                if (field === 'type') {
                    const incomeType = (0, $1abe73eeef086faf$export$3599b35124f1fb09).find((t)=>t.id === value);
                    if (incomeType && !incomeType.manualEntry) newInc.amount = incomeType.rate;
                    if (value === 'definedBenefitPension') {
                        // Nothing pre-filled (owner, 15 Oct 2026): the fund is chosen, then its preset applies.
                        newInc = {
                            ...newInc,
                            frequency: newInc.frequency || 'fortnightly',
                            amount: ''
                        };
                        if (newInc.dbFund) newInc = withDefinedBenefitPreset(newInc, newInc.dbFund);
                    }
                }
                if (field === 'dbFund') newInc = withDefinedBenefitPreset(newInc, value);
                // The annual figure the assessment reads, from the payment as it appears on the advice.
                if (newInc.type === 'definedBenefitPension' && (field === 'dbPaymentAmount' || field === 'frequency' || field === 'dbFund' || field === 'type')) newInc.amount = (0, $f94c75e8792c4be0$export$2ed8828a9a102eef)(newInc.dbPaymentAmount, newInc.frequency);
                return newInc;
            }
            return inc;
        });
        updateFactFind('income', 'otherIncomes', updatedIncomes);
    };
    const removeIncome = (id)=>{
        const filteredIncomes = (income.otherIncomes || []).filter((inc)=>inc.id !== id);
        updateFactFind('income', 'otherIncomes', filteredIncomes);
    };
    const addCapitalExpense = ()=>{
        const newExpenses = [
            ...expenses.capitalExpenses || [],
            {
                id: (0, $942f2f96766bf874$export$d3a77fab0baa99a2)(),
                description: '',
                amount: '',
                year: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`
            }
        ];
        updateFactFind('expenses', 'capitalExpenses', newExpenses);
    };
    const updateCapitalExpense = (id, field, value)=>{
        const updatedExpenses = (expenses.capitalExpenses || []).map((exp)=>exp.id === id ? {
                ...exp,
                [field]: value
            } : exp);
        updateFactFind('expenses', 'capitalExpenses', updatedExpenses);
    };
    const removeCapitalExpense = (id)=>{
        const filteredExpenses = (expenses.capitalExpenses || []).filter((exp)=>exp.id !== id);
        updateFactFind('expenses', 'capitalExpenses', filteredExpenses);
    };
    const handleBudgetSave = (total)=>{
        updateFactFind('expenses', 'livingExpenses', total);
        setShowBudgetCalculator(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$StepHeader, {
                icon: (0, $1571f1c57333e026$export$2e2bcd8739ae039),
                step: 7,
                title: "Other Income & Expenses"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                        className: "text-lg font-semibold text-gray-700 mb-4",
                        children: "Other Income"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-sm text-gray-600 mb-4",
                        children: [
                            "Add any other sources of income not already captured from ",
                            voice.possessive,
                            " assets (e.g., salaries, carer allowance, overseas pensions)."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "space-y-4",
                        children: (income.otherIncomes || []).map((inc)=>{
                            const incomeType = (0, $1abe73eeef086faf$export$3599b35124f1fb09).find((t)=>t.id === inc.type);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "p-4 bg-slate-50 rounded-lg border border-slate-200",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "grid grid-cols-1 md:grid-cols-3 gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                label: "Type",
                                                name: "type",
                                                value: inc.type || 'salary',
                                                onChange: (n, v)=>updateIncome(inc.id, n, v),
                                                children: (0, $1abe73eeef086faf$export$3599b35124f1fb09).map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: opt.id,
                                                        children: opt.name
                                                    }, opt.id))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                                label: "Description",
                                                name: "description",
                                                value: inc.description,
                                                onChange: (n, v)=>updateIncome(inc.id, n, v)
                                            }),
                                            inc.type === 'definedBenefitPension' ? isPartnered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                label: "Whose pension is it?",
                                                name: "ownership",
                                                value: inc.ownership || 'client',
                                                onChange: (n, v)=>updateIncome(inc.id, n, v),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "client",
                                                        children: factFind.client?.firstName || 'Client'
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "partner",
                                                        children: factFind.partner?.firstName || 'Partner'
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                label: "Annual Amount ($)",
                                                name: "amount",
                                                value: inc.amount,
                                                onChange: (v)=>updateIncome(inc.id, 'amount', v),
                                                disabled: !incomeType?.manualEntry
                                            })
                                        ]
                                    }),
                                    inc.type === 'definedBenefitPension' && (()=>{
                                        /*
                                     * A DEFINED BENEFIT PENSION (owner, 15 Oct 2026): at most five questions, every rule
                                     * applied behind them. The fund presets the rules; the tax-free part comes off the
                                     * fund's Centrelink schedule; the panel beside says what Centrelink and the ATO do
                                     * with it — the user never sees a rule they have to apply. Nothing is pre-filled
                                     * until the fund is chosen, and a bought annuity recorded under Assets is pointed
                                     * out so its payments are not entered twice.
                                     */ const fundChosen = !!inc.dbFund;
                                        const preset = (0, $f94c75e8792c4be0$export$9bb8c8dca6c61774)(inc.dbFund);
                                        const ownerIsPartner = inc.ownership === 'partner';
                                        const owner = ownerIsPartner ? factFind.partner : factFind.client;
                                        const other = ownerIsPartner ? factFind.client : factFind.partner;
                                        const ownerName = owner?.firstName || (ownerIsPartner ? 'your partner' : 'you');
                                        const partnerName = isPartnered ? other?.firstName || 'your partner' : null;
                                        const annual = Number(inc.amount) || 0;
                                        const annuities = (factFind.assets?.annuities || []).filter((a)=>!isPartnered || !a.ownership || a.ownership === (inc.ownership || 'client'));
                                        const sentences = fundChosen && annual > 0 ? (0, $f94c75e8792c4be0$export$6486cc97165e7a50)(inc, {
                                            ownerName: ownerName,
                                            ownerAge: (0, $5589d9476399db47$export$8ada184d5eef4694)(owner?.dob),
                                            partnerName: partnerName,
                                            cpiPct: (0, $f94c75e8792c4be0$export$3ab31fcc31991e8a),
                                            money: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)
                                        }) : [];
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mt-4 space-y-4",
                                            "data-testid": "defined-benefit-fields",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "grid grid-cols-1 md:grid-cols-3 gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                            label: "Which fund pays it?",
                                                            name: "dbFund",
                                                            value: inc.dbFund || '',
                                                            onChange: (n, v)=>updateIncome(inc.id, n, v),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "",
                                                                    children: "Choose the fund\u2026"
                                                                }),
                                                                (0, $f94c75e8792c4be0$export$3587e0218c6e04b3).map((f)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: f.id,
                                                                        children: f.name
                                                                    }, f.id))
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                            label: "Amount per payment ($)",
                                                            name: "dbPaymentAmount",
                                                            value: inc.dbPaymentAmount,
                                                            onChange: (v)=>updateIncome(inc.id, 'dbPaymentAmount', v)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                            label: "Paid",
                                                            name: "frequency",
                                                            value: inc.frequency || 'fortnightly',
                                                            onChange: (n, v)=>updateIncome(inc.id, n, v),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "weekly",
                                                                    children: "Weekly"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "fortnightly",
                                                                    children: "Fortnightly"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "monthly",
                                                                    children: "Monthly"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "annually",
                                                                    children: "Once a year"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-xs text-slate-500",
                                                    children: [
                                                        annual > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                            children: [
                                                                "That is ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(annual)
                                                                }),
                                                                " a year. "
                                                            ]
                                                        }) : null,
                                                        "Not for an annuity bought with a lump sum \u2014 that belongs under Assets, where its payments are already counted."
                                                    ]
                                                }),
                                                annuities.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "rounded-lg border border-slate-200 border-l-4 border-l-amber-400 bg-white px-3 py-2 text-xs text-slate-700",
                                                    "data-testid": "defined-benefit-annuity-warning",
                                                    children: [
                                                        ownerName,
                                                        " already has an annuity under Assets (",
                                                        annuities.map((a)=>`${a.description || 'Annuity'}${Number(a.income) > 0 ? `, ${(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(Number(a.income))} a year` : ''}`).join('; '),
                                                        "). Its payments are counted from there. Enter a pension here only if it is a different one."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "grid grid-cols-1 md:grid-cols-3 gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                            label: "Tax-free part (a year) ($)",
                                                            name: "dbDeductibleAmount",
                                                            value: inc.dbDeductibleAmount,
                                                            onChange: (v)=>updateIncome(inc.id, 'dbDeductibleAmount', v)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "md:col-span-2 self-end text-xs text-slate-500",
                                                            children: "Printed on the fund's Centrelink schedule and annual statement as the deductible amount or tax-free component. Leave it blank and the whole payment counts as income."
                                                        })
                                                    ]
                                                }),
                                                fundChosen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "grid grid-cols-1 md:grid-cols-3 gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                                            label: "Rises with inflation each year",
                                                            name: "dbIndexed",
                                                            checked: inc.dbIndexed ?? preset.indexed,
                                                            onChange: (n, v)=>updateIncome(inc.id, n, v)
                                                        }),
                                                        isPartnered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd6bad1410bfbf4$export$2e2bcd8739ae039), {
                                                            label: `${partnerName}'s share if ${ownerName} dies first (%)`,
                                                            name: "dbReversionPct",
                                                            value: inc.dbReversionPct ?? preset.reversionPct ?? '',
                                                            onChange: (v)=>updateIncome(inc.id, 'dbReversionPct', v)
                                                        }),
                                                        inc.dbFund === 'other' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                            label: "Offered before 20 September 1998?",
                                                            name: "dbPreSept1998Product",
                                                            value: inc.dbPreSept1998Product ? 'yes' : 'no',
                                                            onChange: (n, v)=>updateIncome(inc.id, n, v === 'yes'),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "no",
                                                                    children: "No, or not sure"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "yes",
                                                                    children: "Yes"
                                                                })
                                                            ]
                                                        }),
                                                        inc.dbFund === 'other' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                            label: "Paid from an untaxed source?",
                                                            name: "dbTaxedSource",
                                                            value: inc.dbTaxedSource === false ? 'untaxed' : 'taxed',
                                                            onChange: (n, v)=>updateIncome(inc.id, n, v !== 'untaxed'),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "taxed",
                                                                    children: "No \u2014 a taxed source (most funds)"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "untaxed",
                                                                    children: "Yes \u2014 a government scheme"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                inc.dbFund === 'other' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-xs text-slate-500",
                                                    children: 'The fund\'s payment summary says which: an untaxed source shows an "untaxed element" and is taxed after 60 with a 10% offset; a taxed source is tax-free from 60.'
                                                }),
                                                fundChosen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-xs text-slate-500",
                                                    children: preset.note
                                                }),
                                                sentences.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bc32c6ef2e03125$export$2e2bcd8739ae039), {
                                                    tone: "info",
                                                    heading: "How Centrelink and the ATO treat this pension",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                        className: "list-disc pl-5 space-y-1 text-sm text-slate-700",
                                                        "data-testid": "defined-benefit-treatment",
                                                        children: sentences.map((line, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: line
                                                            }, i))
                                                    })
                                                })
                                            ]
                                        });
                                    })(),
                                    inc.type === 'boarders' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "grid grid-cols-1 md:grid-cols-3 gap-4 mt-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                label: "What they get",
                                                name: "boardType",
                                                value: inc.boardType || 'lodging',
                                                onChange: (n, v)=>updateIncome(inc.id, n, v),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "lodging",
                                                        children: "A room only"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "bedAndBreakfast",
                                                        children: "A room and breakfast"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "board",
                                                        children: "A room and meals (full board)"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "md:col-span-2 self-end text-xs text-slate-500",
                                                children: [
                                                    "Centrelink counts only part of what a boarder pays: 70% for a room only, 50% with breakfast, 20% with full board. Leave out anything paid by ",
                                                    voice.possessive,
                                                    " parent, child or sibling \u2014 it is not counted."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "grid grid-cols-1 md:grid-cols-3 gap-4 mt-4 items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                children: isPartnered && inc.type !== 'definedBenefitPension' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                    label: "Owner",
                                                    name: "ownership",
                                                    value: inc.ownership || 'client',
                                                    onChange: (n, v)=>updateIncome(inc.id, n, v),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "client",
                                                            children: factFind.client?.firstName || 'Client'
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "partner",
                                                            children: factFind.partner?.firstName || 'Partner'
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: "joint",
                                                            children: "Joint"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex items-center space-x-4 pt-6",
                                                children: incomeType?.isCustom && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                                            label: "Taxable?",
                                                            name: "isTaxable",
                                                            checked: inc.isTaxable,
                                                            onChange: (n, v)=>updateIncome(inc.id, n, v)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1b91c2abdb2b42$export$2e2bcd8739ae039), {
                                                            label: "Assessable?",
                                                            name: "isAssessable",
                                                            checked: inc.isAssessable,
                                                            onChange: (n, v)=>updateIncome(inc.id, n, v)
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center justify-end gap-2 pt-6",
                                                children: [
                                                    incomeType?.tooltip && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                                        text: incomeType.tooltip
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>removeIncome(inc.id),
                                                        className: "p-2 text-red-500 hover:bg-red-100 rounded-full transition-all duration-300 hover:scale-110",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                            size: 18
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, inc.id);
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: addIncome,
                        className: "mt-4 flex items-center gap-2 px-4 py-2 bg-blue-100 text-blue-700 font-semibold rounded-lg hover:bg-blue-200",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4da941c85c0c5fe$export$2e2bcd8739ae039), {
                                size: 20
                            }),
                            " Add Income Source"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                        className: "text-lg font-semibold text-gray-700 mb-4",
                        children: "Living & Capital Expenses"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-4 bg-slate-50 rounded-lg border border-slate-200 mb-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "font-medium text-gray-800 mb-1",
                                children: "General Living Expenses (Annual)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-gray-500 mb-3",
                                children: [
                                    "Your best estimate of what ",
                                    voice.subject,
                                    " ",
                                    voice.verb('spend', 'spends'),
                                    " to live ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "now"
                                    }),
                                    " \u2014 ",
                                    voice.possessive,
                                    " current, day-to-day costs, before any move into aged care or other change in living arrangement. We'll factor that change in later."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                label: "",
                                name: "expenseMode",
                                value: expenses.expenseMode || 'total',
                                onChange: (n, v)=>updateFactFind('expenses', n, v),
                                options: [
                                    {
                                        label: 'Enter Total Amount',
                                        value: 'total'
                                    },
                                    {
                                        label: 'Use Budget Calculator',
                                        value: 'calculator'
                                    }
                                ]
                            }),
                            expenses.expenseMode === 'total' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                        className: "mt-4",
                                        label: "Total Annual Living Expenses ($)",
                                        name: "livingExpenses",
                                        value: expenses.livingExpenses || '',
                                        onChange: (v)=>{
                                            updateFactFind('expenses', 'livingExpenses', v);
                                            setAssumedFromAsfa(false);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>{
                                            updateFactFind('expenses', 'livingExpenses', asfaEstimate);
                                            setAssumedFromAsfa(true);
                                        },
                                        className: "mt-2 text-sm font-semibold text-blue-600 hover:text-blue-800",
                                        children: "Not sure? Use a typical estimate"
                                    }),
                                    assumedFromAsfa && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mt-2 text-sm text-gray-600 bg-white border border-blue-100 rounded-lg p-3",
                                        children: [
                                            "We've assumed an average for a ",
                                            isPartnered ? 'couple' : 'single retiree',
                                            " (",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(asfaEstimate),
                                            " a year, based on the ASFA 'Comfortable' retirement standard). You can change this at any time."
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        onClick: ()=>setShowBudgetCalculator(true),
                                        className: "flex items-center gap-2 px-4 py-2 bg-teal-100 text-teal-800 font-semibold rounded-lg hover:bg-teal-200",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $27f56d6cfb7d79f8$export$2e2bcd8739ae039), {
                                                size: 20
                                            }),
                                            " Open Budget Calculator"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-lg font-bold mt-2",
                                        children: [
                                            "Calculated Total: ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(expenses.livingExpenses)
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-4 bg-slate-50 rounded-lg border border-slate-200",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-2 mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-medium text-gray-800",
                                        children: "One-off Capital Expenses"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                        text: "Enter the amount in the dollars of the expected expense date (the cost you expect in that month/year). Projections use this nominal figure in the strategy year that contains that date\u2014they do not apply CPI or other indexation to this line for you."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-sm text-gray-600 mb-4",
                                children: [
                                    "Add any large, one-off expenses ",
                                    voice.subject,
                                    " ",
                                    voice.verb('expect', 'expects'),
                                    " (e.g., new car, major holiday).",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                        text: `Please do not include costs associated with ${voice.possessive} living arrangement choices (like aged care entry fees, retirement village costs, or home care package fees) as these will be modelled separately in other sections.`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "space-y-4",
                                children: (expenses.capitalExpenses || []).map((exp)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-wrap gap-4 items-end",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex-grow",
                                                style: {
                                                    minWidth: '200px'
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                                    label: "Description",
                                                    name: "description",
                                                    value: exp.description,
                                                    onChange: (n, v)=>updateCapitalExpense(exp.id, n, v)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex-grow",
                                                style: {
                                                    minWidth: '120px'
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                    label: "Amount ($)",
                                                    name: "amount",
                                                    value: exp.amount,
                                                    onChange: (v)=>updateCapitalExpense(exp.id, 'amount', v)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex-grow",
                                                style: {
                                                    minWidth: '150px'
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cba1229c5a28a3df$export$2e2bcd8739ae039), {
                                                    label: "Expected Date",
                                                    name: "year",
                                                    type: "month",
                                                    value: exp.year,
                                                    onChange: (n, v)=>updateCapitalExpense(exp.id, n, v)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    onClick: ()=>removeCapitalExpense(exp.id),
                                                    className: "p-2 text-red-500 hover:bg-red-100 rounded-full mb-1 transition-all duration-300 hover:scale-110",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                                        size: 18
                                                    })
                                                })
                                            })
                                        ]
                                    }, exp.id))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: addCapitalExpense,
                                className: "mt-4 flex items-center gap-2 px-4 py-2 bg-blue-100 text-blue-700 font-semibold rounded-lg hover:bg-blue-200 hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4da941c85c0c5fe$export$2e2bcd8739ae039), {
                                        size: 20
                                    }),
                                    " Add Capital Expense"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                className: "mt-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("legend", {
                        className: "text-lg font-semibold text-gray-700 mb-4 flex items-center gap-2",
                        children: [
                            "Asset Gifting History",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $746196baef5db40b$export$2e2bcd8739ae039), {
                                text: "Money or assets that have previously been gifted may impact age pension entitlements if they are over certain thresholds"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-4 bg-slate-50 rounded-lg border border-slate-200",
                        children: [
                            grannyFlatGift && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mb-4 bg-white border border-slate-200 border-l-4 border-l-amber-400 rounded-r-lg p-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-sm text-slate-700",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                            children: [
                                                "From ",
                                                voice.possessive,
                                                " granny flat arrangement (Step 4):"
                                            ]
                                        }),
                                        " ",
                                        (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(grannyFlatGift.deprivation),
                                        " is treated as a gift in FY",
                                        grannyFlatGift.establishmentFyEnd,
                                        ", calculated automatically from what ",
                                        voice.pronoun,
                                        " paid versus the assessed value of the arrangement. It's already counted in ",
                                        voice.pronounPossessive,
                                        " assessment for five years from then \u2014 just add any ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                            children: "other"
                                        }),
                                        " gifts below."
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("legend", {
                                        className: "text-gray-700 font-medium mb-3",
                                        children: [
                                            voice.verb('Have', 'Has'),
                                            " ",
                                            voice.subject,
                                            " given money or assets away in the last five years?"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "grid grid-cols-2 gap-3 max-w-md",
                                        children: [
                                            {
                                                id: 'yes',
                                                label: "Yes \u2014 there have been gifts",
                                                gifted: true
                                            },
                                            {
                                                id: 'no',
                                                label: "No \u2014 nothing gifted",
                                                gifted: false
                                            }
                                        ].map(({ id: id, label: label, gifted: gifted })=>{
                                            const chosen = gifted ? !!factFind.giftsHistory?.hasGifted : !factFind.giftsHistory?.hasGifted && !!factFind.giftsHistory?.confirmedNone;
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "block cursor-pointer",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "radio",
                                                        name: "hasGifted",
                                                        value: id,
                                                        checked: chosen,
                                                        onChange: ()=>{
                                                            updateFactFind('giftsHistory', 'hasGifted', gifted);
                                                            updateFactFind('giftsHistory', 'confirmedNone', !gifted);
                                                        },
                                                        className: "peer sr-only"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "flex h-full items-center justify-center rounded-xl border-2 border-slate-200 bg-white px-4 py-2.5 text-center text-sm font-medium text-gray-700 transition-all hover:border-slate-300 peer-checked:border-[#0F52E0] peer-checked:bg-blue-50 peer-checked:text-blue-900 peer-focus-visible:ring-2 peer-focus-visible:ring-[#0290F5] peer-focus-visible:ring-offset-2",
                                                        children: label
                                                    })
                                                ]
                                            }, id);
                                        })
                                    })
                                ]
                            }),
                            factFind.giftsHistory?.hasGifted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "ml-8 mt-4 space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-blue-50 border-l-4 border-blue-400 rounded-r-lg",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                onClick: ()=>setShowGiftingContext(!showGiftingContext),
                                                className: "w-full p-4 text-left flex items-center justify-between hover:bg-blue-100 transition-colors duration-200",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                                                className: "text-blue-600 mr-3 flex-shrink-0",
                                                                size: 18
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                                className: "text-blue-800 font-semibold text-sm",
                                                                children: "Gifting Calculation Context"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                        className: `text-blue-600 transition-transform duration-200 ${showGiftingContext ? 'rotate-180' : ''}`,
                                                        size: 16
                                                    })
                                                ]
                                            }),
                                            showGiftingContext && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "px-4 pb-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-blue-700 text-sm leading-relaxed",
                                                    children: [
                                                        "Combined limits (couple or single) are typically up to ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                            children: [
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0)),
                                                                " per financial year"
                                                            ]
                                                        }),
                                                        " (1 July-30 June) and up to ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                            children: [
                                                                (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$9cd36ea38af5a5f3)),
                                                                " over any rolling five financial years"
                                                            ]
                                                        }),
                                                        ", without deprivation. Amounts over those free areas are treated as ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "deprived assets"
                                                        }),
                                                        ": still counted in ",
                                                        voice.possessive,
                                                        " assets test for five years from the day of the gift."
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-600",
                                        children: "Gifts in these years can still count. Enter the total for each year; leave a year blank if nothing was given."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "space-y-3",
                                        "data-testid": "gift-years",
                                        children: (0, $6805f825f69416c6$export$4807f5b7ac5d7c45)().map(({ fyEnd: fyEnd, label: label, months: months })=>{
                                            const giftKey = `year${fyEnd}`;
                                            const monthKey = `month${fyEnd}`;
                                            const amount = Number(factFind.giftsHistory?.[giftKey]) || 0;
                                            const month = factFind.giftsHistory?.[monthKey];
                                            return(// Stacks below `sm` (a fixed-width row ran off a phone's edge, 2026-08-19).
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex flex-col gap-1 sm:flex-row sm:flex-wrap sm:items-center sm:gap-4",
                                                "data-testid": `gift-year-${fyEnd}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        className: "w-full text-sm font-medium text-gray-700 sm:w-56 sm:shrink-0",
                                                        children: label
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex min-w-0 items-center gap-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6be87416fe1722b6$export$2e2bcd8739ae039), {
                                                                label: "",
                                                                value: factFind.giftsHistory?.[giftKey] ?? '',
                                                                onChange: (v)=>updateFactFind('giftsHistory', giftKey, v ?? 0),
                                                                className: "w-32 shrink-0",
                                                                placeholder: "$0"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-sm text-gray-600",
                                                                children: "given in total"
                                                            })
                                                        ]
                                                    }),
                                                    amount > (0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                        className: "flex items-center gap-2 text-sm text-gray-600",
                                                        children: [
                                                            "Roughly when?",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                value: month ?? '',
                                                                onChange: (e)=>updateFactFind('giftsHistory', monthKey, e.target.value ? Number(e.target.value) : undefined),
                                                                className: "rounded-md border border-gray-300 bg-white px-2 py-1 text-sm",
                                                                "aria-label": `When the gifts in ${label} were made`,
                                                                "data-testid": `gift-month-${fyEnd}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: "",
                                                                        children: "Not sure"
                                                                    }),
                                                                    months.map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: m.month,
                                                                            children: m.label
                                                                        }, m.month))
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, fyEnd));
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-xs leading-relaxed text-gray-500",
                                        children: [
                                            "The month is asked only where a year's gifts are above ",
                                            (0, $f94e45ac645ae232$export$3dc27271f5d5c629)((0, $1abe73eeef086faf$export$c5a41c20c8e5e4e0)),
                                            ", because only then does it change anything. If ",
                                            voice.subject,
                                            " can't remember, leave it as \u201CNot sure\u201D: the gift is treated as made at the end of that year, which never shows more Age Pension than is due. If there was more than one gift, choose the latest."
                                        ]
                                    }),
                                    (()=>{
                                        const gh = factFind.giftsHistory || {};
                                        const totalGifts = Object.keys(gh).filter((key)=>key.startsWith('year')).reduce((sum, key)=>sum + (Number(gh[key]) || 0), 0);
                                        const modeledDeprived = (0, $171a6d8ba8937a5f$export$e13ba859aba62a6b)(gh, {
                                            asOfDate: new Date()
                                        });
                                        if (modeledDeprived > 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "mt-4 p-3 bg-white border border-slate-200 border-l-4 border-l-amber-400 rounded",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-sm text-slate-700",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Note:"
                                                    }),
                                                    " On the amounts entered (FY buckets), the tool includes about",
                                                    ' ',
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(modeledDeprived)
                                                    }),
                                                    " as deprived assets for Age Pension assessment (combined annual and five-year free areas). Gifts totaling ",
                                                    (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(totalGifts),
                                                    " were entered; Centrelink may still apply timing and other rules not modelled here."
                                                ]
                                            })
                                        });
                                        return null;
                                    })()
                                ]
                            })
                        ]
                    })
                ]
            }),
            showBudgetCalculator && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c33f1005a2d7660$export$2e2bcd8739ae039), {
                onClose: ()=>setShowBudgetCalculator(false),
                onSave: handleBudgetSave,
                isPartnered: isPartnered
            })
        ]
    });
};
/**
 * What a non-binding nomination actually means, shown only when someone selects one.
 *
 * Deliberately NOT a warning. A non-binding nomination usually results in the money going exactly
 * where it was nominated — the trustee normally follows it — so telling a family their wishes will
 * be ignored would be both alarmist and wrong (owner's direction, 2026-08-22). What is true is that
 * the trustee decides, which is worth knowing and worth a conversation, and that is all this says.
 */ const $9f897eee40813319$var$NonBindingNote = ({ nomination: nomination })=>{
    if (nomination !== 'non_binding') return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "mt-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            className: "text-xs text-slate-600 leading-relaxed",
            children: "With a non-binding nomination the super fund's trustee makes the final decision. In practice they usually follow the nomination, so this is not a problem to fix \u2014 it simply means the outcome is not guaranteed, and a binding nomination is the way to remove that discretion if certainty matters."
        })
    });
};
const $9f897eee40813319$export$ec7b4b8bc3293902 = ({ factFind: factFind, updateFactFind: updateFactFind, isPartnered: isPartnered, voice: voice })=>{
    const family = factFind.family || {};
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$StepHeader, {
                icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
                step: 8,
                title: "Family & Estate Planning"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                                className: "text-lg font-semibold text-gray-700 mb-4",
                                children: "Family Details"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $36fba7e03e1bb69f$export$2e2bcd8739ae039), {
                                label: voice.isThirdPerson ? `How many children ${voice.verb('do', 'does')} ${voice.subject} have?` : 'Number of Children',
                                name: "childrenCount",
                                value: family.childrenCount || 0,
                                onChange: (v)=>updateFactFind('family', 'childrenCount', v)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                                className: "text-lg font-semibold text-gray-700 mb-4",
                                children: "Legal & Health Directives"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "font-medium text-gray-800 mb-2",
                                                children: factFind.client?.firstName || 'the applicant'
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                label: "Will in place?",
                                                name: "clientWill",
                                                value: family.clientWill || '',
                                                onChange: (n, v)=>updateFactFind('family', n, v),
                                                options: [
                                                    {
                                                        label: 'Yes',
                                                        value: 'yes'
                                                    },
                                                    {
                                                        label: 'No',
                                                        value: 'no'
                                                    },
                                                    {
                                                        label: 'Unsure',
                                                        value: 'unsure'
                                                    }
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                label: "Enduring Power of Attorney?",
                                                name: "clientEpoa",
                                                value: family.clientEpoa || '',
                                                onChange: (n, v)=>updateFactFind('family', n, v),
                                                options: [
                                                    {
                                                        label: 'Yes',
                                                        value: 'yes'
                                                    },
                                                    {
                                                        label: 'No',
                                                        value: 'no'
                                                    },
                                                    {
                                                        label: 'Unsure',
                                                        value: 'unsure'
                                                    }
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                label: "Advanced Care Directive?",
                                                name: "clientAcd",
                                                value: family.clientAcd || '',
                                                onChange: (n, v)=>updateFactFind('family', n, v),
                                                options: [
                                                    {
                                                        label: 'Yes',
                                                        value: 'yes'
                                                    },
                                                    {
                                                        label: 'No',
                                                        value: 'no'
                                                    },
                                                    {
                                                        label: 'Unsure',
                                                        value: 'unsure'
                                                    }
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                label: "Super Death Benefit Nomination",
                                                name: "clientSuperNom",
                                                value: family.clientSuperNom || '',
                                                onChange: (n, v)=>updateFactFind('family', n, v),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Select..."
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "binding",
                                                        children: "Binding"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "non_binding",
                                                        children: "Non-Binding"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "none",
                                                        children: "None in place"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "unsure",
                                                        children: "Unsure"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$NonBindingNote, {
                                                nomination: family.clientSuperNom
                                            })
                                        ]
                                    }),
                                    isPartnered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "font-medium text-gray-800 mb-2",
                                                children: factFind.partner?.firstName || 'Partner'
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                label: "Will in place?",
                                                name: "partnerWill",
                                                value: family.partnerWill || '',
                                                onChange: (n, v)=>updateFactFind('family', n, v),
                                                options: [
                                                    {
                                                        label: 'Yes',
                                                        value: 'yes'
                                                    },
                                                    {
                                                        label: 'No',
                                                        value: 'no'
                                                    },
                                                    {
                                                        label: 'Unsure',
                                                        value: 'unsure'
                                                    }
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                label: "Enduring Power of Attorney?",
                                                name: "partnerEpoa",
                                                value: family.partnerEpoa || '',
                                                onChange: (n, v)=>updateFactFind('family', n, v),
                                                options: [
                                                    {
                                                        label: 'Yes',
                                                        value: 'yes'
                                                    },
                                                    {
                                                        label: 'No',
                                                        value: 'no'
                                                    },
                                                    {
                                                        label: 'Unsure',
                                                        value: 'unsure'
                                                    }
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                                label: "Advanced Care Directive?",
                                                name: "partnerAcd",
                                                value: family.partnerAcd || '',
                                                onChange: (n, v)=>updateFactFind('family', n, v),
                                                options: [
                                                    {
                                                        label: 'Yes',
                                                        value: 'yes'
                                                    },
                                                    {
                                                        label: 'No',
                                                        value: 'no'
                                                    },
                                                    {
                                                        label: 'Unsure',
                                                        value: 'unsure'
                                                    }
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebc7004069b89f4a$export$2e2bcd8739ae039), {
                                                label: "Super Death Benefit Nomination",
                                                name: "partnerSuperNom",
                                                value: family.partnerSuperNom || '',
                                                onChange: (n, v)=>updateFactFind('family', n, v),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Select..."
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "binding",
                                                        children: "Binding"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "non_binding",
                                                        children: "Non-Binding"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "none",
                                                        children: "None in place"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "unsure",
                                                        children: "Unsure"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f897eee40813319$var$NonBindingNote, {
                                                nomination: family.partnerSuperNom
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                                className: "text-lg font-semibold text-gray-700 mb-4",
                                children: "Family Dynamics"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                label: "Are there any complex family dynamics (e.g. blended families, estranged members)?",
                                name: "complexDynamics",
                                value: (0, $8ab044f9996773da$export$71dc53db491defdf)(family.complexDynamics),
                                onChange: (n, v)=>updateFactFind('family', n, (0, $8ab044f9996773da$export$87f1f3a36f1f2332)(v)),
                                options: [
                                    {
                                        label: 'Yes',
                                        value: 'yes'
                                    },
                                    {
                                        label: 'No',
                                        value: 'no'
                                    }
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ca312685d8e198$export$2e2bcd8739ae039), {
                                label: `${voice.verb('Have', 'Has')} ${voice.subject} provided significant financial assistance to one child over others that could cause issues?`,
                                name: "unevenAssistance",
                                value: (0, $8ab044f9996773da$export$71dc53db491defdf)(family.unevenAssistance),
                                onChange: (n, v)=>updateFactFind('family', n, (0, $8ab044f9996773da$export$87f1f3a36f1f2332)(v)),
                                options: [
                                    {
                                        label: 'Yes',
                                        value: 'yes'
                                    },
                                    {
                                        label: 'No',
                                        value: 'no'
                                    }
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");



const $2fdd0b8a01602d58$var$Step4LivingInsightPanel = ({ factFind: factFind })=>{
    const sections = (0, $5d75c6e277be5884$export$590d1311ebdc5150)({
        factFind: factFind
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "space-y-4",
        children: sections.map((section)=>{
            // The land card sits beside the living-arrangement one and is about a different
            // subject, so it does not wear the same house icon.
            const iconKind = section.icon;
            const Icon = iconKind === 'land' ? (0, $fab2f21898bf5b1d$export$2e2bcd8739ae039) : iconKind === 'village' ? (0, $224502d93617e0e1$export$2e2bcd8739ae039) : (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039);
            const lines = section.lines || [];
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                className: "bg-white/80",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                        className: "text-lg font-bold mb-1 flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                className: "text-blue-500 shrink-0",
                                size: 20,
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6288781efbc92679$export$2e2bcd8739ae039), {
                                children: section.title
                            })
                        ]
                    }),
                    section.subtitle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm font-medium text-[#001E7A] mb-3",
                        children: section.subtitle
                    }),
                    lines.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dl", {
                        className: "mb-3 divide-y divide-gray-100 rounded-lg border border-gray-100 bg-white/70",
                        "data-testid": "village-value-lines",
                        children: lines.map((line)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: `flex items-baseline justify-between gap-3 px-3 py-1.5 text-sm ${line.total ? 'font-semibold text-gray-900' : 'text-gray-600'}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                        className: "leading-snug",
                                        children: line.label
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                        className: "shrink-0 tabular-nums",
                                        children: line.value
                                    })
                                ]
                            }, line.label))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "space-y-3",
                        children: section.paragraphs.map((paragraph)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-600 text-sm leading-relaxed",
                                children: paragraph
                            }, paragraph))
                    }),
                    section.goalsIntro && (section.goalBlocks?.length ?? 0) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-600 text-sm leading-relaxed font-medium",
                                children: section.goalsIntro
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "mt-2 space-y-2",
                                children: (section.goalBlocks ?? []).map(({ label: label, summary: summary })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        className: "text-sm text-gray-600 leading-relaxed",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "font-semibold text-gray-800",
                                                children: [
                                                    label,
                                                    ":"
                                                ]
                                            }),
                                            ' ',
                                            summary
                                        ]
                                    }, label))
                            })
                        ]
                    })
                ]
            }, section.title);
        })
    });
};
var $2fdd0b8a01602d58$export$2e2bcd8739ae039 = $2fdd0b8a01602d58$var$Step4LivingInsightPanel;


/** What the mobile sheet's bar calls each step's supporting content (see MobileInsightSheet).
 *  Steps with no insight column — 1 and 2 — are absent, and no bar is shown for them. */ const $985134edd4f7191c$var$MOBILE_INSIGHT_TITLES = {
    3: 'About your goals',
    4: 'Your living arrangements',
    5: 'Financial Snapshot',
    6: 'Financial Snapshot',
    7: 'Financial Snapshot',
    8: 'Family & estate'
};
/** True while the viewport is at Tailwind's `xl` or wider — the width at which the insight
 *  column is laid out beside the form. Below it the same content goes in the bottom sheet.
 *
 *  `xl` (1280) rather than `lg` (1024): an iPad Pro in portrait is exactly 1024, so it tipped
 *  into the three-column layout with the persistent 256px nav also on screen, leaving the
 *  snapshot about 250px to render in — the composition legend truncated to "C.", "S.", "Ca."
 *  and the totals wrapped (seen 2026-08-19). A tablet in portrait is better served by the
 *  bottom sheet, which gets the full width; landscape (1366) still gets the column.
 *  Driven in JS rather than CSS so the content is mounted ONCE: rendering both and hiding one
 *  would run the Financial Snapshot's calculation twice on every edit. */ const $985134edd4f7191c$var$useIsDesktop = ()=>{
    const [isDesktop, setIsDesktop] = (0, $acw62.useState)(()=>typeof window !== 'undefined' && window.matchMedia('(min-width: 1280px)').matches);
    (0, $acw62.useEffect)(()=>{
        if (typeof window === 'undefined') return undefined;
        const mq = window.matchMedia('(min-width: 1280px)');
        const onChange = (e)=>setIsDesktop(e.matches);
        mq.addEventListener('change', onChange);
        setIsDesktop(mq.matches);
        return ()=>mq.removeEventListener('change', onChange);
    }, []);
    return isDesktop;
};
const $985134edd4f7191c$var$buildProfileStepLabels = (possessive)=>[
        "Who's Completing This Form",
        `${possessive} Details`,
        'Goals',
        'Living Arrangements',
        'Assets',
        'Liabilities',
        'Income/Expenses',
        'Family/Estate'
    ];
const $985134edd4f7191c$var$ClientProfile = ({ setActivePage: setActivePage, factFind: factFind, setFactFind: setFactFind, clientProfileStep: clientProfileStep, setClientProfileStep: setClientProfileStep, hideApplicantContactFields: hideApplicantContactFields = true, showStructureAdviserFields: showStructureAdviserFields = false })=>{
    const [step, setStep] = (0, $acw62.useState)(clientProfileStep);
    (0, $acw62.useEffect)(()=>{
        setStep(clientProfileStep);
    }, [
        clientProfileStep
    ]);
    // Back to the top of the form on every step change — see scrollAppToTop for why this cannot be
    // a querySelector on '.overflow-y-auto' (it matched the sidebar, so this never moved the page).
    (0, $acw62.useEffect)(()=>{
        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)();
    }, [
        step
    ]);
    const [showAgePensionContext, setShowAgePensionContext] = (0, $acw62.useState)(false);
    const totalSteps = 8;
    const nextStep = ()=>{
        const newStep = Math.min(step + 1, totalSteps);
        setStep(newStep);
        setClientProfileStep(newStep);
        // The effect on `step` above does the scrolling; this second pass catches the case where the
        // new step renders taller than the last and the container grows after the first attempt.
        setTimeout(()=>(0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)(), 100);
    };
    const prevStep = ()=>{
        const newStep = Math.max(step - 1, 1);
        setStep(newStep);
        setClientProfileStep(newStep);
        // The effect on `step` above does the scrolling; this second pass catches the case where the
        // new step renders taller than the last and the container grows after the first attempt.
        setTimeout(()=>(0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)(), 100);
    };
    const updateFactFind = (section, field, value)=>{
        setFactFind((prev)=>({
                ...prev,
                [section]: {
                    ...prev[section],
                    [field]: value
                }
            }));
    };
    const setMainData = (field, value)=>{
        setFactFind((prev)=>{
            if (field !== 'adviceFor') return {
                ...prev,
                [field]: value
            };
            const next = {
                ...prev,
                adviceFor: value
            };
            if (value === 'couple') {
                const ownership = prev.home?.ownership;
                if (!ownership || ownership === 'client') next.home = {
                    ...prev.home,
                    ownership: 'joint'
                };
            }
            return next;
        });
    };
    const isPartnered = factFind.adviceFor === 'couple';
    /**
     * Client OR partner, matching the engine's own `occupantHasOwnHomeResidency`
     * (shared/src/calculation/entityHomeRules.ts). It tested the client alone, so a couple where
     * the client had already moved into residential care and the spouse still lived in the family
     * home fell to the alternative-living branch — whose four cases all evaluated false, leaving
     * step 4 as a bare heading and the home value never asked for, while the engine went on
     * treating them as home-owning occupants.
     */ const ownsHome = factFind.client?.currentResidency === 'own_home' || isPartnered && factFind.partner?.currentResidency === 'own_home';
    /**
     * A couple can live apart — one already in residential care while the other is at home, one in
     * a village while the other rents. Step 4 used to pick ONE set of questions for the household:
     * if either of them owned the home, everybody got the family-home questions and nothing else,
     * so a village entry contribution was never asked for at all (adviser-reported, 2026-08-20).
     *
     * The home is shared, so it is asked once; every other arrangement belongs to a person, so the
     * two sections now appear together whenever both apply.
     *
     * `aged_care` is in the list even though it asks NOTHING. It was left out at first on the
     * reasoning that somebody already in residential care has no arrangement to describe — true of
     * the questions, but it meant the step named Living Arrangements said nothing whatsoever about
     * one of the two people living in it (adviser-reported, 2026-08-20: a couple with one already
     * in care showed only the family home). The section states what that answer already decides
     * instead.
     */ const ALTERNATIVE_RESIDENCIES = [
        'renting',
        'with_family',
        'retirement_village',
        'granny_flat',
        'aged_care'
    ];
    const hasAlternativeArrangement = [
        factFind.client?.currentResidency,
        isPartnered ? factFind.partner?.currentResidency : undefined
    ].some((residency)=>ALTERNATIVE_RESIDENCIES.includes(String(residency)));
    /**
     * Nothing below the chooser renders until the question is answered for everyone it applies to.
     * The default used to be 'own_home' for both people, so a profile modelled a home owner whether
     * or not anyone had said so; it is blank now, and this is what keeps a blank from simply
     * flowing through. It also has to gate the Next button: most of the engine reads a blank as
     * 'own_home', but entityHomeRules does not, so an unanswered profile would assess an
     * entity-held home differently depending on which rule looked at it.
     */ const residencyAnswered = !!factFind.client?.currentResidency && (!isPartnered || !!factFind.partner?.currentResidency);
    // Whether labels say "your home" or "Bob & Sally's home" — see utils/applicantVoice.ts. Built
    // once here and passed down, so every step (and the step list above the form) speaks the same way.
    const voice = (0, $acw62.useMemo)(()=>(0, $7af19dec1ba96a5f$export$5d44334005555b21)(factFind), [
        factFind
    ]);
    const [showMentalCapacityModal, setShowMentalCapacityModal] = (0, $acw62.useState)(false);
    const isDesktop = $985134edd4f7191c$var$useIsDesktop();
    // The net worth the Financial Snapshot is DISPLAYING, reported up by the card itself so the
    // collapsed mobile bar shows that same figure rather than a second, independently computed one.
    const [snapshotNetWorth, setSnapshotNetWorth] = (0, $acw62.useState)(null);
    const getContextualInsight = ()=>{
        switch(step){
            case 1:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e9caa5eea6f6034$export$75cd8fded50e1042), {
                    title: "Why We Ask This First",
                    text: "Your answer sets how the rest of the questions are worded \u2014 whether we ask about your own circumstances or about the person you're helping \u2014 so nothing later is ambiguous about whose home, income or care we mean.",
                    icon: (0, $e52b122f04c04d7d$export$2e2bcd8739ae039)
                });
            case 2:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e9caa5eea6f6034$export$75cd8fded50e1042), {
                    title: "Let's Get Started",
                    text: `The first step to clarity is understanding ${voice.possessive} current situation. Answer a few questions to begin building ${voice.pronounPossessive} personalised plan.`,
                    icon: (0, $e52b122f04c04d7d$export$2e2bcd8739ae039)
                });
            case 3:
                {
                    const { goals: goals, careNeeds: careNeeds } = factFind;
                    const isPartnered = factFind.adviceFor === 'couple';
                    const clientAcat = careNeeds?.clientAcat;
                    const partnerAcat = careNeeds?.partnerAcat;
                    const insightsToShow = [];
                    const goalKeys = [
                        'home_care',
                        'aged_care',
                        'retirement_village',
                        'granny_flat',
                        'downsize_home'
                    ];
                    goalKeys.forEach((key)=>{
                        if (goals?.[key]) insightsToShow.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e9caa5eea6f6034$export$75cd8fded50e1042), {
                            ...(0, $af797c9747431756$export$4c8d4692eb54c080)[key]
                        }, key));
                    });
                    const needsAcat = clientAcat?.status === 'no' || isPartnered && partnerAcat?.status === 'no';
                    if (goals?.home_care && needsAcat) insightsToShow.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e9caa5eea6f6034$export$75cd8fded50e1042), {
                        ...(0, $af797c9747431756$export$4c8d4692eb54c080).acat_assessment
                    }, "acat_assessment"));
                    const clientLevel = clientAcat?.status === 'yes' ? (0, $c220d08b55e5dd64$export$bfae9591cc0d7897)[clientAcat.homeCareLevel || ''] : null;
                    const partnerLevel = isPartnered && partnerAcat?.status === 'yes' ? (0, $c220d08b55e5dd64$export$bfae9591cc0d7897)[partnerAcat.homeCareLevel || ''] : null;
                    if (clientLevel) insightsToShow.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e9caa5eea6f6034$export$1e91935c527436d3), {
                        personName: factFind.client?.firstName || 'Applicant 1',
                        levelData: clientLevel
                    }, "client_acat_result"));
                    if (partnerLevel) insightsToShow.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e9caa5eea6f6034$export$1e91935c527436d3), {
                        personName: factFind.partner?.firstName || 'Partner',
                        levelData: partnerLevel
                    }, "partner_acat_result"));
                    if (insightsToShow.length === 0) insightsToShow.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e9caa5eea6f6034$export$75cd8fded50e1042), {
                        ...(0, $af797c9747431756$export$4c8d4692eb54c080).default
                    }, "default"));
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "space-y-4",
                        children: insightsToShow
                    });
                }
            case 4:
                // Nothing to explain until they have said where they live.
                return residencyAnswered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2fdd0b8a01602d58$export$2e2bcd8739ae039), {
                    factFind: factFind,
                    ownsHome: ownsHome
                }) : null;
            case 5:
            case 6:
            case 7:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82fb9e3eb31d73a3$export$2e2bcd8739ae039), {
                    factFind: factFind,
                    onNetWorthChange: setSnapshotNetWorth
                });
            case 8:
                {
                    const family = factFind.family || {};
                    const isPartnered = factFind.adviceFor === 'couple';
                    const defaultInsight = (0, $af797c9747431756$export$3f9d2c6e16b79b3f).find((i)=>i.key === 'default');
                    const additionalInsights = (0, $af797c9747431756$export$3f9d2c6e16b79b3f).filter((insight)=>insight.key !== 'default' && insight.trigger(family, factFind.completer, isPartnered));
                    if (!defaultInsight) return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e9caa5eea6f6034$export$75cd8fded50e1042), {
                                    title: defaultInsight.title,
                                    text: defaultInsight.text,
                                    icon: defaultInsight.icon
                                }),
                                additionalInsights.map((insight)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e9caa5eea6f6034$export$75cd8fded50e1042), {
                                        title: insight.title,
                                        text: insight.text,
                                        icon: insight.icon,
                                        onLearnMore: insight.hasModal ? ()=>setShowMentalCapacityModal(true) : undefined
                                    }, insight.key))
                            ]
                        })
                    });
                }
            default:
                return null;
        }
    };
    const contextualInsight = getContextualInsight();
    const mobileInsightTitle = $985134edd4f7191c$var$MOBILE_INSIGHT_TITLES[step];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: ()=>setActivePage('Dashboard'),
                        className: "flex items-center gap-2 text-gray-600 hover:text-gray-900 font-medium mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                size: 20
                            }),
                            " Back to Dashboard"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "text-4xl font-bold text-gray-900",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6288781efbc92679$export$2e2bcd8739ae039), {
                            children: "Client Profile"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-lg text-slate-600 mt-1",
                        children: [
                            "Let's gather some information to help us understand ",
                            voice.possessive,
                            " situation."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-3 text-sm font-semibold text-[#001E7A]",
                        children: [
                            "Step ",
                            step,
                            " of ",
                            totalSteps,
                            ": ",
                            $985134edd4f7191c$var$buildProfileStepLabels(voice.Possessive)[step - 1]
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "w-full bg-slate-200 rounded-full h-2.5 mb-8",
                role: "progressbar",
                "aria-valuenow": step,
                "aria-valuemin": 1,
                "aria-valuemax": totalSteps,
                "aria-label": `Profile progress: step ${step} of ${totalSteps}`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-blue-600 h-2.5 rounded-full transition-all duration-500",
                    style: {
                        width: `${step / totalSteps * 100}%`
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 xl:grid-cols-3 gap-8 items-start",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "xl:col-span-2",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f964382955d663ef$export$2e2bcd8739ae039), {
                            className: "bg-white/80",
                            children: [
                                step === 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f897eee40813319$export$f9f29a3c1409fd2d), {
                                    factFind: factFind,
                                    setMainData: setMainData
                                }),
                                step === 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f897eee40813319$export$9d5c5991cdca0dad), {
                                    factFind: factFind,
                                    updateFactFind: updateFactFind,
                                    setMainData: setMainData,
                                    isPartnered: isPartnered,
                                    hideApplicantContactFields: hideApplicantContactFields,
                                    voice: voice
                                }),
                                step === 3 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f897eee40813319$export$ca063803b5049c23), {
                                    factFind: factFind,
                                    updateFactFind: updateFactFind,
                                    isPartnered: isPartnered,
                                    voice: voice
                                }),
                                step === 4 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f897eee40813319$export$2877414a5eaf8cb9), {
                                    factFind: factFind,
                                    updateFactFind: updateFactFind,
                                    isPartnered: isPartnered,
                                    voice: voice
                                }),
                                step === 4 && residencyAnswered && ownsHome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f897eee40813319$export$db4a7af46992c46c), {
                                    home: factFind.home || {},
                                    updateFactFind: (f, v)=>updateFactFind('home', f, v),
                                    client: factFind.client,
                                    partner: factFind.partner,
                                    isPartnered: isPartnered,
                                    factFind: factFind,
                                    voice: voice,
                                    showHeader: false,
                                    onHomeTitleOwnershipChange: (v)=>{
                                        setFactFind((prev)=>({
                                                ...prev,
                                                structuresGateAnswer: v === 'other_entity' ? true : prev.structuresGateAnswer,
                                                home: {
                                                    ...prev.home,
                                                    ...v !== 'other_entity' ? {
                                                        entityId: ''
                                                    } : {}
                                                }
                                            }));
                                    }
                                }),
                                step === 4 && residencyAnswered && hasAlternativeArrangement && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f897eee40813319$export$a0d01cff79c3a599), {
                                    factFind: factFind,
                                    updateFactFind: updateFactFind,
                                    voice: voice,
                                    showHeader: false
                                }),
                                step === 5 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mb-6 bg-blue-50 border-l-4 border-blue-400 rounded-r-lg",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    onClick: ()=>setShowAgePensionContext(!showAgePensionContext),
                                                    className: "w-full p-4 text-left flex items-center justify-between hover:bg-blue-100 transition-colors duration-200",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                                                    className: "text-blue-600 mr-3 flex-shrink-0",
                                                                    size: 20
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                    className: "text-blue-800 font-semibold text-sm",
                                                                    children: "Calculation Context"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                            className: `text-blue-600 transition-transform duration-200 ${showAgePensionContext ? 'rotate-180' : ''}`,
                                                            size: 16
                                                        })
                                                    ]
                                                }),
                                                showAgePensionContext && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "px-4 pb-4",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-blue-700 text-sm leading-relaxed",
                                                        children: [
                                                            "Our calculations automatically determine ",
                                                            voice.possessive,
                                                            " Age Pension eligibility based on ",
                                                            voice.pronounPossessive,
                                                            " age & the Social Security Asset Test and Income Test. As you enter ",
                                                            voice.pronounPossessive,
                                                            " financial details, you may find that the Age Pension amount shown is reduced. We also provide tax estimates. Please note: these calculations are for planning purposes only and do not constitute tax advice. Actual tax obligations may vary based on ",
                                                            voice.pronounPossessive,
                                                            " accountant's analysis, specific circumstances and current tax legislation. Complete all steps to see the impact on the financial snapshot."
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f897eee40813319$export$e4d07404b15ce2bd), {
                                            factFind: factFind,
                                            setFactFind: setFactFind,
                                            isPartnered: isPartnered,
                                            showStructureAdviserFields: showStructureAdviserFields,
                                            voice: voice
                                        })
                                    ]
                                }),
                                step === 6 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f897eee40813319$export$4df5c2c9b71b530b), {
                                    factFind: factFind,
                                    setFactFind: setFactFind,
                                    isPartnered: isPartnered,
                                    voice: voice
                                }),
                                step === 7 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f897eee40813319$export$aaa604a3749de934), {
                                    factFind: factFind,
                                    updateFactFind: updateFactFind,
                                    isPartnered: isPartnered,
                                    voice: voice
                                }),
                                step === 8 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f897eee40813319$export$ec7b4b8bc3293902), {
                                    factFind: factFind,
                                    updateFactFind: updateFactFind,
                                    isPartnered: isPartnered,
                                    voice: voice
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-8 pt-6 border-t border-slate-200 flex justify-between items-center gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                            variant: "secondary",
                                            size: "md",
                                            icon: (0, $c31db635520dc385$export$2e2bcd8739ae039),
                                            onClick: prevStep,
                                            disabled: step === 1,
                                            children: "Back"
                                        }),
                                        step === 4 && !residencyAnswered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-sm text-gray-500 text-right",
                                            children: [
                                                "Choose where ",
                                                voice.subject,
                                                " ",
                                                voice.verb('live', 'lives'),
                                                " to continue."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                            variant: "brand",
                                            size: "md",
                                            iconRight: step === totalSteps ? undefined : (0, $7979593adeba180b$export$2e2bcd8739ae039),
                                            disabled: step === 4 && !residencyAnswered,
                                            onClick: step === totalSteps ? ()=>setActivePage('Dashboard') : nextStep,
                                            children: step === totalSteps ? 'Finish & View Dashboard' : 'Next'
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    isDesktop && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "sticky top-8",
                        children: contextualInsight
                    })
                ]
            }),
            !isDesktop && contextualInsight && mobileInsightTitle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4dc00328f6988b10$export$2e2bcd8739ae039), {
                title: mobileInsightTitle,
                value: snapshotNetWorth !== null && step >= 5 && step <= 7 ? (0, $f94e45ac645ae232$export$3dc27271f5d5c629)(snapshotNetWorth) : null,
                children: contextualInsight
            }),
            showMentalCapacityModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b22d82a0ef1a336$export$2e2bcd8739ae039), {
                onClose: ()=>setShowMentalCapacityModal(false)
            })
        ]
    });
};
var $985134edd4f7191c$export$2e2bcd8739ae039 = $985134edd4f7191c$var$ClientProfile;


/**
 * Partner Portal — wireframe shell (pipeline, tables, adviser/practice/licensee views).
 * Renamed from ProfessionalPortal.js for alignment with the Partner Portal product name.
 */ 

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
/**
 * The settings that change what the system DOES: how soon a client is chased, the wording they
 * receive, and the firm's documents.
 *
 * Its own component because the portal has TWO Settings screens — `realFirmSettings` for a signed-in
 * firm and `AdviserSettingsView` for the demo — and these belong in both. They were first written
 * into the demo one only, so a real firm could never reach them.
 *
 * Presentation follows the portal's existing template rows (coloured dot, name, "when this is sent")
 * rather than a stack of bare inputs: an adviser needs to know WHICH email they are editing and when
 * it goes out, and a wall of text boxes tells them neither.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * One collapsible row in a list of message templates: coloured dot, name, and a line saying when
 * that message goes out.
 *
 * Its own module because both the demo Settings view and the real firm's settings use it. It started
 * inside ProfessionalPortalFullWireframeViews, and importing it back out of there created a circular
 * import between the two files — the failure mode that shows up as a Parcel "does not export" error
 * at runtime rather than a type error at build time.
 */ 

var $acw62 = parcelRequire("acw62");
function $b3a124818f9cbd6d$export$6f8db72196b82f39({ id: id, dotColor: dotColor, name: name, meta: meta, defaultOpen: defaultOpen = false, last: last = false, children: children }) {
    const [open, setOpen] = (0, $acw62.useState)(defaultOpen);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tpl-row",
        style: last || id === 5 ? {
            borderBottom: 'none'
        } : undefined,
        "data-tpl-id": id,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                className: "tpl-hdr",
                onClick: ()=>setOpen(!open),
                "aria-expanded": open,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tpl-dot",
                                style: {
                                    background: dotColor
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tpl-name",
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tpl-meta",
                                        children: meta
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tag t-ok",
                                style: {
                                    fontSize: 10
                                },
                                children: "Active"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                viewBox: "0 0 24 24",
                                style: {
                                    width: 15,
                                    height: 15,
                                    stroke: 'var(--muted)',
                                    fill: 'none',
                                    strokeWidth: 2,
                                    transform: open ? 'rotate(180deg)' : 'none',
                                    transition: 'transform .2s'
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
                                    points: "6 9 12 15 18 9"
                                })
                            })
                        ]
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tpl-body",
                children: children
            })
        ]
    });
}


const $925452318330559f$var$FOLLOW_UP_CHOICES = [
    {
        value: '3',
        label: 'after 3 days'
    },
    {
        value: '5',
        label: 'after 5 days'
    },
    {
        value: '7',
        label: 'after 7 days'
    },
    {
        value: '14',
        label: 'after 14 days'
    },
    {
        value: 'manual',
        label: "never \u2014 I'll chase them myself"
    }
];
/** The placeholders a firm may use, shown as chips rather than buried in a sentence. */ const $925452318330559f$var$PLACEHOLDERS = [
    '{client_name}',
    '{adviser_name}',
    '{firm_name}',
    '{link}',
    '{expiry_date}'
];
const $925452318330559f$var$cardStyle = {
    background: '#fff',
    border: '1px solid #e2e8f0',
    borderRadius: 16,
    boxShadow: '0 1px 3px rgba(15,23,42,.06)',
    marginTop: 14,
    overflow: 'hidden'
};
const $925452318330559f$var$cardHeadStyle = {
    padding: '18px 20px 14px'
};
const $925452318330559f$var$titleStyle = {
    fontWeight: 700,
    fontSize: 15,
    color: '#0f172a',
    marginBottom: 4
};
const $925452318330559f$var$subtitleStyle = {
    fontSize: 13,
    color: '#64748b',
    lineHeight: 1.55
};
function $925452318330559f$var$PlaceholderChips() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 6,
            marginTop: 10,
            marginBottom: 4
        },
        children: $925452318330559f$var$PLACEHOLDERS.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                style: {
                    fontSize: 11,
                    background: '#f1f5f9',
                    color: '#334155',
                    border: '1px solid #e2e8f0',
                    borderRadius: 5,
                    padding: '2px 6px'
                },
                children: p
            }, p))
    });
}
function $925452318330559f$export$6874097f8226718e({ settings: settings, messageDefaults: messageDefaults, onSave: onSave }) {
    const [followUp, setFollowUp] = (0, $acw62.useState)(settings?.defaultFollowUpDays == null ? 'manual' : String(settings.defaultFollowUpDays));
    const [templates, setTemplates] = (0, $acw62.useState)({
        inviteSubject: settings?.templates?.invite?.subject ?? '',
        inviteBody: settings?.templates?.invite?.body ?? '',
        reminderSubject: settings?.templates?.reminder?.subject ?? '',
        reminderBody: settings?.templates?.reminder?.body ?? ''
    });
    const [documents, setDocuments] = (0, $acw62.useState)({
        fsgUrl: settings?.fsgUrl ?? '',
        companyProfileUrl: settings?.companyProfileUrl ?? ''
    });
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [saved, setSaved] = (0, $acw62.useState)(false);
    const touched = ()=>setSaved(false);
    const usingOwnWords = (subject, body)=>Boolean(subject.trim() || body.trim());
    const save = async ()=>{
        if (!onSave) return;
        setSaving(true);
        setSaved(false);
        // Blank means "use our wording", not "send an empty email" — so only filled fields are sent.
        const pick = (subject, body)=>{
            const t = {};
            if (subject.trim()) t.subject = subject.trim();
            if (body.trim()) t.body = body.trim();
            return Object.keys(t).length ? t : undefined;
        };
        const invite = pick(templates.inviteSubject, templates.inviteBody);
        const reminder = pick(templates.reminderSubject, templates.reminderBody);
        const ok = await onSave({
            defaultFollowUpDays: followUp === 'manual' ? null : Number(followUp),
            templates: {
                ...invite ? {
                    invite: invite
                } : {},
                ...reminder ? {
                    reminder: reminder
                } : {}
            },
            fsgUrl: documents.fsgUrl.trim(),
            companyProfileUrl: documents.companyProfileUrl.trim()
        });
        setSaving(false);
        setSaved(ok);
    };
    const emailFields = (kind, subjectKey, bodyKey)=>{
        const standard = messageDefaults?.[kind];
        const custom = usingOwnWords(templates[subjectKey], templates[bodyKey]);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                standard && !custom && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        marginTop: 14,
                        background: '#f8fafc',
                        border: '1px solid #e2e8f0',
                        borderRadius: 10,
                        padding: '12px 14px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: 10,
                                marginBottom: 8
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontSize: 12,
                                        fontWeight: 600,
                                        color: '#334155'
                                    },
                                    children: "What we send now"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "bsm bg",
                                    style: {
                                        fontSize: 11,
                                        padding: '4px 9px'
                                    },
                                    onClick: ()=>{
                                        // Copy it in, so they edit from our wording rather than a blank box.
                                        setTemplates((t)=>({
                                                ...t,
                                                [subjectKey]: standard.subject,
                                                [bodyKey]: standard.body
                                            }));
                                        touched();
                                    },
                                    children: "Edit this wording"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                fontSize: 12.5,
                                color: '#0f172a',
                                fontWeight: 600,
                                marginBottom: 6
                            },
                            children: standard.subject
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                fontSize: 12.5,
                                color: '#475569',
                                whiteSpace: 'pre-wrap',
                                lineHeight: 1.6
                            },
                            children: standard.body
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "fg",
                    style: {
                        marginTop: 14
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "fl",
                            children: "Subject"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            className: "fi",
                            placeholder: standard ? standard.subject : 'Leave blank to use our standard subject',
                            value: templates[subjectKey],
                            onChange: (e)=>{
                                setTemplates((t)=>({
                                        ...t,
                                        [subjectKey]: e.target.value
                                    }));
                                touched();
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "fg",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "fl",
                            children: "Message"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                            className: "fi",
                            rows: 7,
                            style: {
                                resize: 'vertical',
                                lineHeight: 1.6
                            },
                            placeholder: standard ? standard.body : 'Leave blank to use our standard message',
                            value: templates[bodyKey],
                            onChange: (e)=>{
                                setTemplates((t)=>({
                                        ...t,
                                        [bodyKey]: e.target.value
                                    }));
                                touched();
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($925452318330559f$var$PlaceholderChips, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                fontSize: 11,
                                color: 'var(--muted)',
                                lineHeight: 1.5
                            },
                            children: [
                                "Your message must include ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                    children: '{link}'
                                }),
                                ".",
                                ' ',
                                custom ? `Clear both fields to go back to our standard ${kind === 'invite' ? 'invitation' : 'reminder'}.` : "Leave both blank and we'll send the wording shown above."
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: $925452318330559f$var$cardStyle,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: $925452318330559f$var$cardHeadStyle,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: $925452318330559f$var$titleStyle,
                            children: "Chasing clients"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: $925452318330559f$var$subtitleStyle,
                            children: "When a client hasn\u2019t opened their invite, we can send them a reminder for you."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                                flexWrap: 'wrap',
                                marginTop: 14
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: 13.5,
                                        color: '#0f172a'
                                    },
                                    children: "Remind them"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                    className: "fi",
                                    style: {
                                        cursor: 'pointer',
                                        width: 'auto',
                                        minWidth: 220
                                    },
                                    value: followUp,
                                    onChange: (e)=>{
                                        setFollowUp(e.target.value);
                                        touched();
                                    },
                                    "aria-label": "How soon to chase a client who has not opened their invite",
                                    children: $925452318330559f$var$FOLLOW_UP_CHOICES.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: c.value,
                                            children: c.label
                                        }, c.value))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                fontSize: 12,
                                color: '#64748b',
                                marginTop: 8,
                                lineHeight: 1.5
                            },
                            children: "Applies to new invites; you can still change it for an individual client. We stop after three reminders and leave the rest to you."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: $925452318330559f$var$cardStyle,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: $925452318330559f$var$cardHeadStyle,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: $925452318330559f$var$titleStyle,
                                children: "Client emails"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: $925452318330559f$var$subtitleStyle,
                                children: "The two emails your clients receive. Leave them alone and we\u2019ll use our standard wording."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3a124818f9cbd6d$export$6f8db72196b82f39), {
                                id: 1,
                                dotColor: "#3b82f6",
                                name: `Invitation${usingOwnWords(templates.inviteSubject, templates.inviteBody) ? " \u2014 your wording" : ''}`,
                                meta: "Sent when you invite a client to fill in their profile",
                                children: emailFields('invite', 'inviteSubject', 'inviteBody')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3a124818f9cbd6d$export$6f8db72196b82f39), {
                                id: 2,
                                last: true,
                                dotColor: "#f59e0b",
                                name: `Reminder${usingOwnWords(templates.reminderSubject, templates.reminderBody) ? " \u2014 your wording" : ''}`,
                                meta: "Sent when you nudge a client, and by the automatic chase above",
                                children: emailFields('reminder', 'reminderSubject', 'reminderBody')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: $925452318330559f$var$cardStyle,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: $925452318330559f$var$cardHeadStyle,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: $925452318330559f$var$titleStyle,
                            children: "Your documents"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: $925452318330559f$var$subtitleStyle,
                            children: "Added to the bottom of every client email automatically, so changing the wording above can never drop them. Links rather than uploads, so your client always gets the current version."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "fg",
                            style: {
                                marginTop: 14
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "fl",
                                    children: "Financial Services Guide (FSG)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    className: "fi",
                                    placeholder: "https://yourfirm.com.au/fsg.pdf",
                                    value: documents.fsgUrl,
                                    onChange: (e)=>{
                                        setDocuments((d)=>({
                                                ...d,
                                                fsgUrl: e.target.value
                                            }));
                                        touched();
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "fg",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "fl",
                                    children: "Company / practice profile"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    className: "fi",
                                    placeholder: "https://yourfirm.com.au/about",
                                    value: documents.companyProfileUrl,
                                    onChange: (e)=>{
                                        setDocuments((d)=>({
                                                ...d,
                                                companyProfileUrl: e.target.value
                                            }));
                                        touched();
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 10,
                    alignItems: 'center',
                    marginTop: 14,
                    marginBottom: 4
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "bsm bp",
                        disabled: !onSave || saving,
                        onClick: save,
                        children: saving ? "Saving\u2026" : 'Save changes'
                    }),
                    saved && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 12.5,
                            color: '#059669',
                            fontWeight: 600
                        },
                        children: "Saved"
                    }),
                    !onSave && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 12.5,
                            color: '#64748b'
                        },
                        children: "Sign in to your firm to change these."
                    })
                ]
            })
        ]
    });
}



const $f84f127c8c7e0e3d$var$uploadDashStyle = {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '9px 13px',
    border: '1.5px dashed var(--bdr)',
    borderRadius: 'var(--r)',
    cursor: 'pointer',
    fontSize: 13,
    color: 'var(--muted)',
    transition: 'border-color .15s'
};
function $f84f127c8c7e0e3d$export$34925f746332c764({ identity: identity = null, firmSettings: firmSettings, messageDefaults: messageDefaults, onSaveFirmSettings: onSaveFirmSettings }) {
    const [reminderMode, setReminderMode] = (0, $acw62.useState)('auto');
    const [firstName = '', ...restOfName] = String(identity?.adviserName || '').trim().split(/\s+/);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                style: {
                    fontSize: 17,
                    fontWeight: 600,
                    marginBottom: 4
                },
                children: "Settings"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    fontSize: 14,
                    color: 'var(--muted)',
                    marginBottom: 14
                },
                children: "Your profile, follow-up rules, and client message templates."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ccm",
                style: {
                    marginBottom: 20,
                    padding: '10px 12px',
                    background: '#fffbeb',
                    border: '1px solid #fde68a',
                    borderRadius: 8,
                    color: '#854d0e',
                    maxWidth: 900
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "Your details are read-only."
                    }),
                    " They come from your sign-in and can\u2019t be edited here yet. Everything else on this page \u2014 the follow-up interval, the two client emails and your document links \u2014 saves and takes effect. The accordion at the bottom previews a longer reminder sequence that doesn\u2019t exist yet."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: 16,
                    marginBottom: 20,
                    maxWidth: 900
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1px solid var(--bdr)',
                            borderRadius: 'var(--rl)',
                            padding: 20
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 14,
                                    fontWeight: 600,
                                    marginBottom: 13
                                },
                                children: "Adviser Profile"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "fg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "fl",
                                        children: "First Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "fi",
                                        value: firstName,
                                        readOnly: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "fg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "fl",
                                        children: "Last Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "fi",
                                        value: restOfName.join(' '),
                                        readOnly: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "fg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "fl",
                                        children: "Email"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "fi",
                                        value: identity?.email || '',
                                        readOnly: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "fg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "fl",
                                        children: "Auth Rep / AFSL"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "fi",
                                        value: identity?.licenceLine || '',
                                        readOnly: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "fg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "fl",
                                        children: "Phone"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "fi",
                                        placeholder: "e.g. 02 9123 4567"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    borderTop: '1px solid var(--bdr)',
                                    margin: '14px 0'
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    fontWeight: 600,
                                    color: 'var(--dark)',
                                    marginBottom: 11
                                },
                                children: "FSG & Company Documents"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "fg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "fl",
                                        children: "Financial Services Guide (FSG)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            gap: 8,
                                            alignItems: 'center'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                style: $f84f127c8c7e0e3d$var$uploadDashStyle,
                                                onMouseEnter: (e)=>{
                                                    e.currentTarget.style.borderColor = 'var(--blue)';
                                                },
                                                onMouseLeave: (e)=>{
                                                    e.currentTarget.style.borderColor = 'var(--bdr)';
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                        width: "14",
                                                        height: "14",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        strokeWidth: "2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
                                                                points: "17 8 12 3 7 8"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                                                x1: "12",
                                                                y1: "3",
                                                                x2: "12",
                                                                y2: "15"
                                                            })
                                                        ]
                                                    }),
                                                    "Upload PDF",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "file",
                                                        accept: ".pdf",
                                                        style: {
                                                            display: 'none'
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    fontSize: 12,
                                                    color: 'var(--muted)'
                                                },
                                                children: "or"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                className: "fi",
                                                style: {
                                                    flex: 1
                                                },
                                                placeholder: "Paste a link to your FSG"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 11,
                                            color: 'var(--muted)',
                                            marginTop: 4
                                        },
                                        children: "Linked or embedded in the initial invite email sent to clients."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "fg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "fl",
                                        children: "Company / Practice Profile"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            gap: 8,
                                            alignItems: 'center'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                style: $f84f127c8c7e0e3d$var$uploadDashStyle,
                                                onMouseEnter: (e)=>{
                                                    e.currentTarget.style.borderColor = 'var(--blue)';
                                                },
                                                onMouseLeave: (e)=>{
                                                    e.currentTarget.style.borderColor = 'var(--bdr)';
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                        width: "14",
                                                        height: "14",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        strokeWidth: "2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
                                                                points: "17 8 12 3 7 8"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                                                x1: "12",
                                                                y1: "3",
                                                                x2: "12",
                                                                y2: "15"
                                                            })
                                                        ]
                                                    }),
                                                    "Upload PDF",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "file",
                                                        accept: ".pdf",
                                                        style: {
                                                            display: 'none'
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    fontSize: 12,
                                                    color: 'var(--muted)'
                                                },
                                                children: "or"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                className: "fi",
                                                style: {
                                                    flex: 1
                                                },
                                                placeholder: "Website / profile link"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 11,
                                            color: 'var(--muted)',
                                            marginTop: 4
                                        },
                                        children: "Displayed on the client's invitation and profile portal header."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                disabled: true,
                                title: "Saving settings isn't available yet",
                                className: "bsm bp",
                                children: "Save Profile"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            gridColumn: '1 / -1'
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $925452318330559f$export$6874097f8226718e), {
                            settings: firmSettings,
                            messageDefaults: messageDefaults,
                            onSave: onSaveFirmSettings
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1px solid var(--bdr)',
                            borderRadius: 'var(--rl)',
                            padding: 20
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 14,
                                    fontWeight: 600,
                                    marginBottom: 4
                                },
                                children: "Follow-up Rules"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    fontSize: 12,
                                    color: 'var(--muted)',
                                    marginBottom: 13
                                },
                                children: "Configure how the system handles inactive clients. You can disable auto-sends and manage reminders manually."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    marginBottom: 13
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "fl",
                                        children: "Reminder mode"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        className: "fi",
                                        style: {
                                            cursor: 'pointer'
                                        },
                                        value: reminderMode,
                                        onChange: (e)=>setReminderMode(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "auto",
                                                children: "Automatic \u2014 system sends emails on my behalf"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "manual",
                                                children: "Manual only \u2014 alert me in-app, I'll reach out myself"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "off",
                                                children: "Off \u2014 no reminders or alerts"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            reminderMode === 'auto' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                id: "auto-rules",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "fur",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "ful",
                                                children: "First reminder if invite not opened after"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                className: "fus",
                                                defaultValue: "5 days",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        children: "3 days"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        children: "5 days"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        children: "7 days"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "fur",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "ful",
                                                children: "Second reminder if still inactive after"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                className: "fus",
                                                defaultValue: "10 days",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        children: "7 days"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        children: "10 days"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        children: "14 days"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "fur",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "ful",
                                                children: "Stop auto-reminders after"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                className: "fus",
                                                defaultValue: "3 sends",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        children: "2 sends"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        children: "3 sends"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        children: "5 sends"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "fur",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "ful",
                                        children: "Alert me if client stalls mid-profile after"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        className: "fus",
                                        defaultValue: "2 days",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                children: "2 days"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                children: "3 days"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                children: "5 days"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                children: "Never"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                disabled: true,
                                title: "Saving settings isn't available yet",
                                className: "bsm bp",
                                style: {
                                    marginTop: 13
                                },
                                children: "Save Rules"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    background: '#fff',
                    border: '1px solid var(--bdr)',
                    borderRadius: 'var(--rl)',
                    overflow: 'hidden',
                    maxWidth: 900
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            padding: '16px 20px',
                            borderBottom: '1px solid var(--bdr)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 14,
                                            fontWeight: 600,
                                            color: 'var(--dark)'
                                        },
                                        children: "Communication Templates"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            fontSize: 12,
                                            color: 'var(--muted)',
                                            marginTop: 2
                                        },
                                        children: [
                                            "These are sent automatically or on-demand. Edit to match your tone. Use",
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                                style: {
                                                    fontSize: 11,
                                                    background: 'var(--bg2)',
                                                    padding: '1px 5px',
                                                    borderRadius: 4
                                                },
                                                children: '{client_name}'
                                            }),
                                            ",",
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                                style: {
                                                    fontSize: 11,
                                                    background: 'var(--bg2)',
                                                    padding: '1px 5px',
                                                    borderRadius: 4
                                                },
                                                children: '{adviser_name}'
                                            }),
                                            ",",
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                                style: {
                                                    fontSize: 11,
                                                    background: 'var(--bg2)',
                                                    padding: '1px 5px',
                                                    borderRadius: 4
                                                },
                                                children: '{link}'
                                            }),
                                            " as placeholders."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                disabled: true,
                                title: "This section is a design preview",
                                className: "bsm bg",
                                style: {
                                    fontSize: 12,
                                    flexShrink: 0
                                },
                                children: "Reset to Defaults"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        id: "tpl-list",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b3a124818f9cbd6d$export$6f8db72196b82f39), {
                                id: 1,
                                dotColor: "#3b82f6",
                                name: "Initial Invite",
                                meta: "Sent when you invite a new client  \xb7  Trigger: manual",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "fg",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "fl",
                                                children: "Subject line"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                className: "fi",
                                                defaultValue: "{adviser_name} has shared a planning tool with you"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "fg",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "fl",
                                                children: "Message body"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                className: "fi",
                                                rows: 6,
                                                style: {
                                                    resize: 'vertical',
                                                    lineHeight: 1.6
                                                },
                                                defaultValue: `Hi {client_name},

I've set up a personalised planning tool for you through AgedCareWise. It will help us explore your options, understand your situation, and make the most of our time together.

It should take around 15\u{2013}20 minutes to complete. Please click the link below to get started:

{link}

If you have any questions before you begin, please don't hesitate to reach out.

Kind regards,
{adviser_name}`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 11,
                                            color: 'var(--muted)',
                                            marginBottom: 10
                                        },
                                        children: "If you have an FSG, it will be automatically attached or linked in this email. You can upload your FSG in the Adviser Profile section above."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            gap: 8
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                disabled: true,
                                                title: "Saving settings isn't available yet",
                                                className: "bsm bp",
                                                children: "Save Template"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                disabled: true,
                                                title: "Saving settings isn't available yet",
                                                className: "bsm bg",
                                                children: "Preview Email"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b3a124818f9cbd6d$export$6f8db72196b82f39), {
                                id: 2,
                                dotColor: "#f59e0b",
                                name: "Follow-up Nudge (1st reminder)",
                                meta: "Auto-sent if invite not opened after your threshold  \xb7  Trigger: automatic",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "fg",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "fl",
                                                children: "Subject line"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                className: "fi",
                                                defaultValue: "Just a reminder \u2014 your planning link from {adviser_name} is still active"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "fg",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "fl",
                                                children: "Message body"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                className: "fi",
                                                rows: 5,
                                                style: {
                                                    resize: 'vertical',
                                                    lineHeight: 1.6
                                                },
                                                defaultValue: `Hi {client_name},

Just a quick follow-up \u{2014} your planning tool link is still active. It only takes around 15\u{2013}20 minutes to complete, and it will help us prepare for our conversation.

{link}

Kind regards,
{adviser_name}`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            gap: 8
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                disabled: true,
                                                title: "Saving settings isn't available yet",
                                                className: "bsm bp",
                                                children: "Save Template"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                disabled: true,
                                                title: "Saving settings isn't available yet",
                                                className: "bsm bg",
                                                children: "Preview Email"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b3a124818f9cbd6d$export$6f8db72196b82f39), {
                                id: 3,
                                dotColor: "#ef4444",
                                name: "Follow-up Nudge (2nd reminder)",
                                meta: "Auto-sent after second threshold  \xb7  Trigger: automatic",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "fg",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "fl",
                                                children: "Subject line"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                className: "fi",
                                                defaultValue: "One more reminder from {adviser_name} \u2014 your link is still waiting"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "fg",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "fl",
                                                children: "Message body"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                className: "fi",
                                                rows: 5,
                                                style: {
                                                    resize: 'vertical',
                                                    lineHeight: 1.6
                                                },
                                                defaultValue: `Hi {client_name},

I wanted to follow up one more time. I know life gets busy \u{2014} whenever you have a spare 15 minutes, the link below is still active.

{link}

Feel free to call me if you'd prefer to go through it together or have any questions.

Kind regards,
{adviser_name}`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            gap: 8
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                disabled: true,
                                                title: "Saving settings isn't available yet",
                                                className: "bsm bp",
                                                children: "Save Template"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                disabled: true,
                                                title: "Saving settings isn't available yet",
                                                className: "bsm bg",
                                                children: "Preview Email"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b3a124818f9cbd6d$export$6f8db72196b82f39), {
                                id: 4,
                                dotColor: "#10b981",
                                name: "Profile Submitted \u2014 Confirmation to Client",
                                meta: "Sent to client when they submit their profile  \xb7  Trigger: automatic on submission",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "fg",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "fl",
                                                children: "Subject line"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                className: "fi",
                                                defaultValue: "Thanks {client_name} \u2014 we've received your information"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "fg",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "fl",
                                                children: "Message body"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                className: "fi",
                                                rows: 6,
                                                style: {
                                                    resize: 'vertical',
                                                    lineHeight: 1.6
                                                },
                                                defaultValue: `Hi {client_name},

Thank you for completing your profile. I've received all your information and will now review it and prepare for our next conversation.

I'll be in touch shortly. In the meantime, if anything changes or you have questions, please don't hesitate to reach out.

Kind regards,
{adviser_name}`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            gap: 8
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                disabled: true,
                                                title: "Saving settings isn't available yet",
                                                className: "bsm bp",
                                                children: "Save Template"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                disabled: true,
                                                title: "Saving settings isn't available yet",
                                                className: "bsm bg",
                                                children: "Preview Email"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b3a124818f9cbd6d$export$6f8db72196b82f39), {
                                id: 5,
                                dotColor: "#6366f1",
                                name: "Report / Digital SOA Ready \u2014 Notification to Client",
                                meta: "Sent when you publish a report or Digital SOA for the client  \xb7  Trigger: manual (on publish)",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "fg",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "fl",
                                                children: "Subject line"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                className: "fi",
                                                defaultValue: "Your personalised report from {adviser_name} is ready to view"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "fg",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "fl",
                                                children: "Message body"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                className: "fi",
                                                rows: 6,
                                                style: {
                                                    resize: 'vertical',
                                                    lineHeight: 1.6
                                                },
                                                defaultValue: `Hi {client_name},

Your personalised report is now ready to view. It summarises the options we've explored and the recommendations I've prepared based on your situation.

You can access it securely here:

{link}

Please review it at your convenience, and feel free to call me if you have any questions or would like to discuss anything.

Kind regards,
{adviser_name}`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            gap: 8
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                disabled: true,
                                                title: "Saving settings isn't available yet",
                                                className: "bsm bp",
                                                children: "Save Template"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                disabled: true,
                                                title: "Saving settings isn't available yet",
                                                className: "bsm bg",
                                                children: "Preview Email"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $f84f127c8c7e0e3d$var$computeAgeFromDob(dobStr) {
    if (!dobStr) return null;
    const birth = new Date(dobStr);
    if (Number.isNaN(birth.getTime())) return null;
    const age = Math.floor((Date.now() - birth.getTime()) / 31557600000);
    return age >= 0 && age < 120 ? age : null;
}
function $f84f127c8c7e0e3d$var$pctFromTotal(n, total) {
    if (!total) return '0%';
    return `${Math.round(n / total * 100)}%`;
}
function $f84f127c8c7e0e3d$var$avg(values) {
    if (!values.length) return 0;
    return values.reduce((sum, value)=>sum + value, 0) / values.length;
}
function $f84f127c8c7e0e3d$export$125fcc61d7e7ba3({ cases: cases = [], dataState: dataState = 'idle' }) {
    const derived = (0, $acw62.useMemo)(()=>{
        const completedStatuses = [
            'submitted',
            'adviser_review',
            'soa_draft',
            'soa_published'
        ];
        const completed = cases.filter((c)=>completedStatuses.includes(c.status));
        const ages = completed.map((c)=>$f84f127c8c7e0e3d$var$computeAgeFromDob(c.factFind?.client?.dob)).filter((v)=>v != null);
        const avgAge = ages.length ? $f84f127c8c7e0e3d$var$avg(ages).toFixed(1) : "\u2014";
        const minA = ages.length ? Math.min(...ages) : null;
        const maxA = ages.length ? Math.max(...ages) : null;
        /*
         * Days from the invite going out to the profile coming back, averaged over the ones that
         * actually came back. Null — rendered as an em dash — when nothing has been submitted yet, or
         * when the dates needed are missing: an average of no observations is not zero, and it is not
         * 4.2 either.
         */ const completionSpans = completed.map((c)=>{
            /*
                 * Invite sent -> fact-find complete, which is what the label under this number claims
                 * it measures. A client the adviser set up in person has no invite (inviteSentAt is
                 * null) and is skipped rather than counted as zero days: they were never waited on.
                 */ const from = c.workflow?.inviteSentAt ? Date.parse(c.workflow.inviteSentAt) : NaN;
            const completedAt = c.workflow?.completedAt ?? c.submissionDate ?? null;
            const to = completedAt ? Date.parse(completedAt) : NaN;
            return Number.isFinite(from) && Number.isFinite(to) && to >= from ? (to - from) / 86400000 : null;
        }).filter((v)=>v != null);
        const avgCompletionDays = completionSpans.length ? $f84f127c8c7e0e3d$var$avg(completionSpans) : null;
        const soaSent = cases.filter((c)=>c.soaStatus === 'published').length;
        const invited = cases.filter((c)=>c.status === 'invited').length;
        const started = cases.filter((c)=>c.status === 'started').length;
        const total = cases.length;
        const completedN = completed.length;
        const ageBuckets = [
            {
                key: '60s',
                label: '60s',
                count: 0
            },
            {
                key: '70_74',
                label: "70\u201374",
                count: 0
            },
            {
                key: '75_79',
                label: "75\u201379",
                count: 0
            },
            {
                key: '80_84',
                label: "80\u201384",
                count: 0
            },
            {
                key: '85p',
                label: '85+',
                count: 0
            }
        ];
        ages.forEach((age)=>{
            if (age < 70) ageBuckets[0].count += 1;
            else if (age <= 74) ageBuckets[1].count += 1;
            else if (age <= 79) ageBuckets[2].count += 1;
            else if (age <= 84) ageBuckets[3].count += 1;
            else ageBuckets[4].count += 1;
        });
        const maxAgeBucket = Math.max(1, ...ageBuckets.map((b)=>b.count));
        const ageDistribution = ageBuckets.map((bucket)=>({
                ...bucket,
                height: Math.max(12, Math.round(bucket.count / maxAgeBucket * 95))
            }));
        const goalsByKey = {
            home_care: 'Stay at home with support (HCP)',
            aged_care: 'Residential aged care facility',
            retirement_village: 'Retirement village',
            granny_flat: 'Granny flat / with family',
            downsize_home: 'Downsize family home',
            undecided: 'Undecided'
        };
        const goalCounts = {};
        completed.forEach((c)=>{
            const goals = c.factFind?.goals || {};
            const keys = Object.keys(goals).filter((k)=>goals[k] === true && goalsByKey[k]);
            if (!keys.length) {
                goalCounts.undecided = (goalCounts.undecided || 0) + 1;
                return;
            }
            keys.forEach((k)=>{
                goalCounts[k] = (goalCounts[k] || 0) + 1;
            });
        });
        const totalGoalFlags = Object.values(goalCounts).reduce((sum, v)=>sum + v, 0) || 1;
        const livingArrangements = Object.entries(goalsByKey).map(([key, label])=>({
                label: label,
                count: goalCounts[key] || 0,
                pct: Math.round((goalCounts[key] || 0) / totalGoalFlags * 100)
            }));
        /*
         * The most common goal among completed profiles — or an em dash when none has been stated.
         * Sorting a list of zeros returns the first entry, so this used to name "Stay at home with
         * support (HCP)" as the most common goal of a firm with no clients, directly above the words
         * "0% of completed profiles". A ranking of nothing has no winner.
         */ /*
         * The most common goal — but only when one actually leads.
         *
         * Two problems, both found by the owner. Sorting a list of zeros returns the first entry, so an
         * empty book named a "most common goal" above the words "0% of completed profiles". And a
         * client who chose TWO goals produces a dead heat, where naming either one is an arbitrary
         * pick presented as a finding. Clients routinely want more than one thing — staying home and
         * residential care are both on the table while a family decides — so ties are normal here
         * rather than a curiosity.
         *
         * Where nothing leads, the tile says so, and the Preferred Living Arrangements chart directly
         * below already carries the full breakdown.
         */ const rankedGoals = [
            ...livingArrangements
        ].sort((a, b)=>b.count - a.count);
        const leader = rankedGoals[0];
        const tiedWithLeader = leader?.count ? rankedGoals.filter((g)=>g.count === leader.count).length : 0;
        const topGoal = !leader?.count ? {
            label: "\u2014",
            pct: 0
        } : tiedWithLeader > 1 ? {
            label: `${tiedWithLeader} goals tied`,
            pct: leader.pct
        } : leader;
        const careStageCounts = {
            no_assessment: 0,
            acat_pending: 0,
            hcp_1_2: 0,
            hcp_3_4: 0,
            residential: 0
        };
        completed.forEach((c)=>{
            const acat = c.factFind?.careNeeds?.clientAcat;
            const level = acat?.approvedLevel;
            if (!level) {
                careStageCounts.no_assessment += 1;
                return;
            }
            if (acat?.assessmentPending) careStageCounts.acat_pending += 1;
            if (String(level).toLowerCase().includes('residential')) careStageCounts.residential += 1;
            else if (String(level).includes('3') || String(level).includes('4')) careStageCounts.hcp_3_4 += 1;
            else careStageCounts.hcp_1_2 += 1;
        });
        const acatRows = [
            {
                label: "No assessment yet \u2014 planning ahead",
                count: careStageCounts.no_assessment,
                color: '#e2e8f0'
            },
            {
                label: 'Needs assessment pending',
                count: careStageCounts.acat_pending,
                color: '#fcd34d',
                amb: true
            },
            {
                label: "HCP Level 1\u20132 approved",
                count: careStageCounts.hcp_1_2,
                color: '#93c5fd'
            },
            {
                label: "HCP Level 3\u20134 approved",
                count: careStageCounts.hcp_3_4,
                color: 'var(--blue)'
            },
            {
                label: 'Residential care approved / active',
                count: careStageCounts.residential,
                color: '#a78bfa',
                pur: true
            }
        ].map((row)=>({
                ...row,
                pct: completedN ? Math.round(row.count / completedN * 100) : 0
            }));
        const strategyCases = completed.filter((c)=>c.strategySource || c.roomFunding || c.homeDecision || c.strategyUsageMode);
        const strategySourceCounts = strategyCases.reduce((acc, c)=>{
            if (c.strategySource === 'manual_control') acc.manual += 1;
            else acc.suggestion += 1;
            return acc;
        }, {
            manual: 0,
            suggestion: 0
        });
        const usageCounts = strategyCases.reduce((acc, c)=>{
            const mode = c.strategyUsageMode || (c.strategySource === 'manual_control' ? 'manual_only' : 'suggestion_only');
            if (mode === 'hybrid') acc.hybrid += 1;
            else if (mode === 'manual_only') acc.manualOnly += 1;
            else acc.suggestionOnly += 1;
            return acc;
        }, {
            manualOnly: 0,
            suggestionOnly: 0,
            hybrid: 0
        });
        const manualCases = strategyCases.filter((c)=>(c.strategyUsageMode || '') === 'manual_only' || (c.strategyUsageMode || '') === 'hybrid' || c.strategySource === 'manual_control');
        const manualAverageStrategies = manualCases.length ? $f84f127c8c7e0e3d$var$avg(manualCases.map((c)=>Number(c.manualStrategiesModelled) || Number(c.strategyGenerationCount) || 0)).toFixed(1) : '0.0';
        const manualAverageSavedStrategies = manualCases.length ? $f84f127c8c7e0e3d$var$avg(manualCases.map((c)=>Number(c.manualStrategiesSaved) || 0)).toFixed(1) : '0.0';
        const suggestionCases = strategyCases.filter((c)=>c.strategySource === 'suggestion_engine' || c.strategyUsageMode === 'hybrid' || c.strategyUsageMode === 'suggestion_only');
        const suggestionSelectionLabels = {
            optimal_estate: 'Optimal estate value',
            optimal_cashflow: 'Optimal cashflow',
            optimal_age_pension: 'Optimal age pension',
            other_from_full_list: 'Other (from full strategy list)'
        };
        const suggestionSelectionCounts = {};
        suggestionCases.forEach((c)=>{
            const key = c.suggestionSoaSelection || 'other_from_full_list';
            suggestionSelectionCounts[key] = (suggestionSelectionCounts[key] || 0) + 1;
        });
        const suggestionSelectionRows = Object.entries(suggestionSelectionLabels).map(([key, label])=>({
                key: key,
                label: label,
                count: suggestionSelectionCounts[key] || 0
            }));
        const homeDecisionLabels = {
            keep_home: 'Keep family home',
            sell_home: 'Sell family home',
            rent_home: 'Rent family home',
            downsize_home: 'Downsize family home'
        };
        const homeDecisionCounts = {};
        strategyCases.forEach((c)=>{
            const key = c.homeDecision || 'keep_home';
            homeDecisionCounts[key] = (homeDecisionCounts[key] || 0) + 1;
        });
        const commonStrategies = Object.entries(homeDecisionLabels).map(([key, label])=>({
                label: label,
                count: homeDecisionCounts[key] || 0
            })).sort((a, b)=>b.count - a.count);
        const assetSellCounts = {};
        strategyCases.forEach((c)=>{
            (c.assetSellMix || []).forEach((asset)=>{
                assetSellCounts[asset] = (assetSellCounts[asset] || 0) + 1;
            });
        });
        const assetSellRows = Object.entries(assetSellCounts).map(([key, count])=>({
                label: key.replace(/([A-Z])/g, ' $1').replace(/^./, (s)=>s.toUpperCase()),
                count: count
            })).sort((a, b)=>b.count - a.count).slice(0, 5);
        const fundingStats = strategyCases.reduce((acc, c)=>{
            const roomFunding = c.roomFunding || {};
            const room = Number(c.agedCareRoomCost) || 0;
            const radPct = Number(roomFunding.radPct) || 0;
            const dapPct = Number(roomFunding.dapPct) || 100 - radPct;
            acc.totalRoom += room;
            acc.totalRadPct += radPct;
            acc.totalDapPct += dapPct;
            if ((roomFunding.mode || '') === 'full_rad') acc.fullRad += 1;
            if ((roomFunding.mode || '') === 'dap_only') acc.dapOnly += 1;
            if ((roomFunding.mode || '') === 'partial_rad') acc.partial += 1;
            return acc;
        }, {
            totalRoom: 0,
            totalRadPct: 0,
            totalDapPct: 0,
            fullRad: 0,
            dapOnly: 0,
            partial: 0
        });
        return {
            completedN: completedN,
            avgAge: avgAge,
            ageRange: minA != null && maxA != null ? `${minA}\u{2013}${maxA}` : "\u2014",
            soaSent: soaSent,
            avgCompletionDays: avgCompletionDays,
            invited: invited,
            started: started,
            submittedN: completedN,
            total: Math.max(total, 1),
            ageDistribution: ageDistribution,
            livingArrangements: livingArrangements.filter((row)=>row.count > 0).sort((a, b)=>b.count - a.count).slice(0, 5),
            topGoal: topGoal,
            acatRows: acatRows,
            strategySourceCounts: strategySourceCounts,
            usageCounts: usageCounts,
            strategyCasesN: strategyCases.length,
            manualAverageStrategies: manualAverageStrategies,
            manualAverageSavedStrategies: manualAverageSavedStrategies,
            manualCasesN: manualCases.length,
            suggestionCasesN: suggestionCases.length,
            suggestionSelectionRows: suggestionSelectionRows,
            commonStrategies: commonStrategies,
            assetSellRows: assetSellRows,
            averageRoomCost: strategyCases.length ? Math.round(fundingStats.totalRoom / strategyCases.length) : 0,
            averageRadPct: strategyCases.length ? Math.round(fundingStats.totalRadPct / strategyCases.length) : 0,
            averageDapPct: strategyCases.length ? Math.round(fundingStats.totalDapPct / strategyCases.length) : 0,
            fundingMixCounts: {
                fullRad: fundingStats.fullRad,
                dapOnly: fundingStats.dapOnly,
                partial: fundingStats.partial
            }
        };
    }, [
        cases
    ]);
    /*
     * A bar's width, as a share of the whole book.
     *
     * Zero returns 0%, which sounds obvious and was not the case: the old version forced a minimum of
     * 8% so that a small-but-real number stayed visible, and applied it to genuine zeros as well — so
     * an empty funnel drew four bars of differing lengths. With no clients at all it was worse still,
     * dividing by a total of zero and handing CSS "NaN%", after which each bar fell back to the width
     * of its own label. That is how a firm with nothing in it got a funnel that looked like a book of
     * business.
     *
     * The floor still applies to anything above zero, because a single client should not be invisible.
     */ const pct = (n)=>{
        if (!derived.total || n <= 0) return '0%';
        return `${Math.max(8, Math.round(n / derived.total * 100))}%`;
    };
    /**
     * Every chart below reads each client's fact-find, which the client LIST doesn't carry — it is
     * encrypted per client and fetched only when needed (see loadFactFindsForAnalytics, triggered
     * when this tab opens). While that is in flight, or where a file couldn't be read, the charts
     * would otherwise render a confident wall of zeros an adviser could mistake for a finding about
     * their book — so the state is stated plainly instead.
     */ const realCasesMissingFactFind = cases.filter((c)=>c.isReal && !c.factFind?.client?.dob).length;
    const notice = dataState === 'loading' ? "Loading your clients&rsquo; details\u2026" : realCasesMissingFactFind > 0 ? `${realCasesMissingFactFind} of your ${cases.length} client files couldn't be read, so they're not counted below.` : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            notice && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ccm",
                style: {
                    marginBottom: 16,
                    padding: '10px 12px',
                    background: '#fffbeb',
                    border: '1px solid #fde68a',
                    borderRadius: 8,
                    color: '#854d0e'
                },
                children: dataState === 'loading' ? "Loading your clients\u2019 details\u2026" : notice
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                style: {
                    fontSize: 17,
                    fontWeight: 600,
                    marginBottom: 4
                },
                children: "Analytics"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    fontSize: 14,
                    color: 'var(--muted)',
                    marginBottom: 20
                },
                children: "Aggregate trends across your client base. Data updates as clients complete their profiles."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pp-analytics-kpi",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1px solid var(--bdr)',
                            borderRadius: 'var(--rl)',
                            padding: '16px 18px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 11,
                                    color: 'var(--muted)',
                                    marginBottom: 5
                                },
                                children: "Total Profiles Completed"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 26,
                                    fontWeight: 500
                                },
                                children: derived.completedN
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 11,
                                    color: 'var(--grn)',
                                    marginTop: 4
                                },
                                children: "In current scope"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1px solid var(--bdr)',
                            borderRadius: 'var(--rl)',
                            padding: '16px 18px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 11,
                                    color: 'var(--muted)',
                                    marginBottom: 5
                                },
                                children: "Average Client Age"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 26,
                                    fontWeight: 500
                                },
                                children: derived.avgAge
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    fontSize: 11,
                                    color: 'var(--muted)',
                                    marginTop: 4
                                },
                                children: [
                                    "Range: ",
                                    derived.ageRange
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1px solid var(--bdr)',
                            borderRadius: 'var(--rl)',
                            padding: '16px 18px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 11,
                                    color: 'var(--muted)',
                                    marginBottom: 5
                                },
                                children: "Most Common Goal"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 15,
                                    fontWeight: 500,
                                    lineHeight: 1.3,
                                    marginTop: 4
                                },
                                children: derived.topGoal.label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 11,
                                    color: 'var(--muted)',
                                    marginTop: 4
                                },
                                children: derived.topGoal.label === "\u2014" ? 'No goals recorded yet' : `${derived.topGoal.pct}% of completed profiles${derived.topGoal.label.includes('tied') ? ' each' : ''}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1px solid var(--bdr)',
                            borderRadius: 'var(--rl)',
                            padding: '16px 18px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 11,
                                    color: 'var(--muted)',
                                    marginBottom: 5
                                },
                                children: "Avg. Profile Completion"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    fontSize: 26,
                                    fontWeight: 500
                                },
                                children: [
                                    derived.avgCompletionDays == null ? "\u2014" : derived.avgCompletionDays.toFixed(1),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontSize: 14,
                                            fontWeight: 400,
                                            color: 'var(--muted)'
                                        },
                                        children: "\xa0days"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 11,
                                    color: 'var(--muted)',
                                    marginTop: 4
                                },
                                children: "From invite to submit"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pp-analytics-2col",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1px solid var(--bdr)',
                            borderRadius: 'var(--rl)',
                            padding: 20
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    fontWeight: 600,
                                    color: 'var(--dark)',
                                    marginBottom: 4
                                },
                                children: "Pipeline Funnel"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 12,
                                    color: 'var(--muted)',
                                    marginBottom: 16
                                },
                                children: "All-time across your client base (scoped)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 12,
                                                    color: 'var(--muted)',
                                                    width: 90,
                                                    flexShrink: 0
                                                },
                                                children: "Invited"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    flex: 1,
                                                    height: 28,
                                                    background: '#eff6ff',
                                                    borderRadius: 4,
                                                    overflow: 'hidden'
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        width: pct(derived.invited + derived.started + derived.submittedN),
                                                        height: '100%',
                                                        background: 'var(--blue)',
                                                        opacity: 0.85,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        padding: '0 10px',
                                                        fontSize: 12,
                                                        fontWeight: 600,
                                                        color: '#fff'
                                                    },
                                                    children: derived.invited + derived.started + derived.submittedN
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 12,
                                                    color: 'var(--muted)',
                                                    width: 90,
                                                    flexShrink: 0
                                                },
                                                children: "In progress"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    flex: 1,
                                                    height: 28,
                                                    background: '#eff6ff',
                                                    borderRadius: 4,
                                                    overflow: 'hidden'
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        width: pct(derived.started + derived.submittedN),
                                                        height: '100%',
                                                        background: 'var(--blue)',
                                                        opacity: 0.75,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        padding: '0 10px',
                                                        fontSize: 12,
                                                        fontWeight: 600,
                                                        color: '#fff'
                                                    },
                                                    children: derived.started
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 12,
                                                    color: 'var(--muted)',
                                                    width: 90,
                                                    flexShrink: 0
                                                },
                                                children: "Submitted"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    flex: 1,
                                                    height: 28,
                                                    background: '#eff6ff',
                                                    borderRadius: 4,
                                                    overflow: 'hidden'
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        width: pct(derived.submittedN),
                                                        height: '100%',
                                                        background: 'var(--blue)',
                                                        opacity: 0.9,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        padding: '0 10px',
                                                        fontSize: 12,
                                                        fontWeight: 600,
                                                        color: '#fff'
                                                    },
                                                    children: derived.submittedN
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 12,
                                                    color: 'var(--muted)',
                                                    width: 90,
                                                    flexShrink: 0
                                                },
                                                children: "SOA Sent"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    flex: 1,
                                                    height: 28,
                                                    background: '#f0fdf4',
                                                    borderRadius: 4,
                                                    overflow: 'hidden'
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        /* The fallback here was '40%' — a green bar reporting
                                           advice delivered by a firm that had delivered none. */ width: derived.submittedN && derived.soaSent ? `${Math.max(15, Math.round(derived.soaSent / derived.submittedN * 100))}%` : '0%',
                                                        height: '100%',
                                                        background: 'var(--grn)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        padding: '0 10px',
                                                        fontSize: 12,
                                                        fontWeight: 600,
                                                        color: '#fff'
                                                    },
                                                    children: derived.soaSent
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1px solid var(--bdr)',
                            borderRadius: 'var(--rl)',
                            padding: 20
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    fontWeight: 600,
                                    color: 'var(--dark)',
                                    marginBottom: 4
                                },
                                children: "Client Age Distribution"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 12,
                                    color: 'var(--muted)',
                                    marginBottom: 16
                                },
                                children: "Age at time of profile submission"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'flex-end',
                                    gap: 6,
                                    height: 120,
                                    paddingBottom: 24,
                                    position: 'relative'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            position: 'absolute',
                                            bottom: 24,
                                            left: 0,
                                            right: 0,
                                            borderTop: '1px dashed var(--bdr)'
                                        }
                                    }),
                                    derived.ageDistribution.map((b)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                flex: 1,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                gap: 4
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: 10,
                                                        color: 'var(--muted)'
                                                    },
                                                    children: b.count
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        width: '100%',
                                                        background: b.height > 50 ? 'var(--blue)' : '#93c5fd',
                                                        borderRadius: '3px 3px 0 0',
                                                        height: b.height
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: 10,
                                                        color: 'var(--lite)'
                                                    },
                                                    children: b.label
                                                })
                                            ]
                                        }, b.key))
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pp-analytics-2col",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1px solid var(--bdr)',
                            borderRadius: 'var(--rl)',
                            padding: 20
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    fontWeight: 600,
                                    color: 'var(--dark)',
                                    marginBottom: 4
                                },
                                children: "Preferred Living Arrangements"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 12,
                                    color: 'var(--muted)',
                                    marginBottom: 16
                                },
                                children: "Client-stated preference at time of profile"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 9
                                },
                                children: derived.livingArrangements.map((row, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    marginBottom: 4
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        style: {
                                                            fontSize: 12,
                                                            color: 'var(--dark)'
                                                        },
                                                        children: row.label
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        style: {
                                                            fontSize: 12,
                                                            fontWeight: 500,
                                                            color: idx === 0 ? 'var(--blue)' : 'var(--muted)'
                                                        },
                                                        children: [
                                                            row.pct,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    height: 7,
                                                    background: 'var(--bg2)',
                                                    borderRadius: 4
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        width: `${row.pct}%`,
                                                        height: '100%',
                                                        background: idx === 0 ? 'var(--blue)' : '#93c5fd',
                                                        borderRadius: 4
                                                    }
                                                })
                                            })
                                        ]
                                    }, row.label))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1px solid var(--bdr)',
                            borderRadius: 'var(--rl)',
                            padding: 20
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    fontWeight: 600,
                                    color: 'var(--dark)',
                                    marginBottom: 4
                                },
                                children: "Assessment / Support Stage"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 12,
                                    color: 'var(--muted)',
                                    marginBottom: 16
                                },
                                children: "Current stage reported in client profiles"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 9
                                },
                                children: derived.acatRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    marginBottom: 4
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        style: {
                                                            fontSize: 12,
                                                            color: 'var(--dark)'
                                                        },
                                                        children: row.label
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        style: {
                                                            fontSize: 12,
                                                            fontWeight: 500,
                                                            color: row.amb ? 'var(--amb)' : row.pur ? 'var(--pur)' : 'var(--muted)'
                                                        },
                                                        children: [
                                                            row.pct,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    height: 7,
                                                    background: 'var(--bg2)',
                                                    borderRadius: 4
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        width: `${row.pct}%`,
                                                        height: '100%',
                                                        background: row.color,
                                                        borderRadius: 4
                                                    }
                                                })
                                            })
                                        ]
                                    }, row.label))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    marginTop: 14,
                                    paddingTop: 12,
                                    borderTop: '1px solid var(--bdr)',
                                    fontSize: 11,
                                    color: 'var(--muted)'
                                },
                                children: [
                                    "Based on ",
                                    derived.completedN || "\u2014",
                                    " completed profiles in scope. Clients who skipped this question excluded."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pp-analytics-2col",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1px solid var(--bdr)',
                            borderRadius: 'var(--rl)',
                            padding: 20
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    fontWeight: 600,
                                    color: 'var(--dark)',
                                    marginBottom: 4
                                },
                                children: "Strategy Build Behaviour"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 12,
                                    color: 'var(--muted)',
                                    marginBottom: 14
                                },
                                children: "Manual Control versus Suggestion Engine activity"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr',
                                    gap: 12,
                                    marginBottom: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            background: '#eff6ff',
                                            borderRadius: 8,
                                            padding: 12
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 11,
                                                    color: 'var(--muted)'
                                                },
                                                children: "Suggestion Engine cases"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 22,
                                                    fontWeight: 600,
                                                    color: 'var(--blue)'
                                                },
                                                children: derived.strategySourceCounts.suggestion
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 11,
                                                    color: 'var(--muted)'
                                                },
                                                children: $f84f127c8c7e0e3d$var$pctFromTotal(derived.strategySourceCounts.suggestion, derived.strategyCasesN)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            background: '#fff7ed',
                                            borderRadius: 8,
                                            padding: 12
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 11,
                                                    color: 'var(--muted)'
                                                },
                                                children: "Manual Control cases"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 22,
                                                    fontWeight: 600,
                                                    color: '#b45309'
                                                },
                                                children: derived.strategySourceCounts.manual
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 11,
                                                    color: 'var(--muted)'
                                                },
                                                children: $f84f127c8c7e0e3d$var$pctFromTotal(derived.strategySourceCounts.manual, derived.strategyCasesN)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    gap: 8,
                                    flexWrap: 'wrap',
                                    marginBottom: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "tag t-ok",
                                        children: [
                                            "Suggestion-only: ",
                                            derived.usageCounts.suggestionOnly
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "tag t-pr",
                                        children: [
                                            "Manual-only: ",
                                            derived.usageCounts.manualOnly
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "tag t-st",
                                        children: [
                                            "Hybrid: ",
                                            derived.usageCounts.hybrid
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 12,
                                    color: 'var(--muted)',
                                    marginBottom: 6
                                },
                                children: "Average manual strategies modelled per client (manual + hybrid)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 26,
                                    fontWeight: 600,
                                    color: 'var(--dark)'
                                },
                                children: derived.manualAverageStrategies
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    fontSize: 12,
                                    color: 'var(--muted)',
                                    marginTop: 6
                                },
                                children: [
                                    "Average manual strategies saved: ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        style: {
                                            color: 'var(--dark)'
                                        },
                                        children: derived.manualAverageSavedStrategies
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1px solid var(--bdr)',
                            borderRadius: 'var(--rl)',
                            padding: 20
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    fontWeight: 600,
                                    color: 'var(--dark)',
                                    marginBottom: 4
                                },
                                children: "Room Funding Mix"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 12,
                                    color: 'var(--muted)',
                                    marginBottom: 14
                                },
                                children: "RAD/DAP patterns from strategy-ready cases"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr 1fr',
                                    gap: 10,
                                    marginBottom: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            background: '#f0fdf4',
                                            borderRadius: 8,
                                            padding: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 11,
                                                    color: 'var(--muted)'
                                                },
                                                children: "Full RAD"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 19,
                                                    fontWeight: 600
                                                },
                                                children: derived.fundingMixCounts.fullRad
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            background: '#eff6ff',
                                            borderRadius: 8,
                                            padding: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 11,
                                                    color: 'var(--muted)'
                                                },
                                                children: "Partial RAD"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 19,
                                                    fontWeight: 600
                                                },
                                                children: derived.fundingMixCounts.partial
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            background: '#f8fafc',
                                            borderRadius: 8,
                                            padding: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 11,
                                                    color: 'var(--muted)'
                                                },
                                                children: "DAP only"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 19,
                                                    fontWeight: 600
                                                },
                                                children: derived.fundingMixCounts.dapOnly
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    fontSize: 12,
                                    color: 'var(--muted)',
                                    marginTop: 8
                                },
                                children: [
                                    "Average room cost: ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        style: {
                                            color: 'var(--dark)'
                                        },
                                        children: [
                                            "$",
                                            derived.averageRoomCost.toLocaleString()
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    fontSize: 12,
                                    color: 'var(--muted)',
                                    marginTop: 4
                                },
                                children: [
                                    "Average RAD %: ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        style: {
                                            color: 'var(--dark)'
                                        },
                                        children: [
                                            derived.averageRadPct,
                                            "%"
                                        ]
                                    }),
                                    " \xb7 Average DAP %: ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        style: {
                                            color: 'var(--dark)'
                                        },
                                        children: [
                                            derived.averageDapPct,
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pp-analytics-2col",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1px solid var(--bdr)',
                            borderRadius: 'var(--rl)',
                            overflow: 'hidden'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    padding: '14px 18px',
                                    borderBottom: '1px solid var(--bdr)'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 13,
                                            fontWeight: 600,
                                            color: 'var(--dark)'
                                        },
                                        children: "Suggestion Engine SOA Selections"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 12,
                                            color: 'var(--muted)',
                                            marginTop: 2
                                        },
                                        children: "Which recommendation type is generally selected for the SOA"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Selected Suggestion Path"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Cases"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Share"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                        children: derived.suggestionSelectionRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "tn",
                                                        children: row.label
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "tm",
                                                        children: row.count
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "tm",
                                                        children: $f84f127c8c7e0e3d$var$pctFromTotal(row.count, derived.suggestionCasesN)
                                                    })
                                                ]
                                            }, row.key))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1px solid var(--bdr)',
                            borderRadius: 'var(--rl)',
                            overflow: 'hidden'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    padding: '14px 18px',
                                    borderBottom: '1px solid var(--bdr)'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 13,
                                            fontWeight: 600,
                                            color: 'var(--dark)'
                                        },
                                        children: "Most Common Home Strategies"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 12,
                                            color: 'var(--muted)',
                                            marginTop: 2
                                        },
                                        children: "Keep, sell, rent or downsize choices in generated strategies"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Strategy"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Cases"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Share"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                        children: derived.commonStrategies.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "tn",
                                                        children: row.label
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "tm",
                                                        children: row.count
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "tm",
                                                        children: $f84f127c8c7e0e3d$var$pctFromTotal(row.count, derived.strategyCasesN)
                                                    })
                                                ]
                                            }, row.label))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1px solid var(--bdr)',
                            borderRadius: 'var(--rl)',
                            overflow: 'hidden'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    padding: '14px 18px',
                                    borderBottom: '1px solid var(--bdr)'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 13,
                                            fontWeight: 600,
                                            color: 'var(--dark)'
                                        },
                                        children: "Most Common Assets Sold Down"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 12,
                                            color: 'var(--muted)',
                                            marginTop: 2
                                        },
                                        children: "Top liquidated assets used to fund RAD/DAP strategy paths"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Asset Type"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Mentions"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    children: "Share"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                        children: derived.assetSellRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "tn",
                                                        children: row.label
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "tm",
                                                        children: row.count
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "tm",
                                                        children: $f84f127c8c7e0e3d$var$pctFromTotal(row.count, derived.strategyCasesN)
                                                    })
                                                ]
                                            }, row.label))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $f84f127c8c7e0e3d$export$186b63797f9ccb51() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                style: {
                    fontSize: 17,
                    fontWeight: 600,
                    marginBottom: 18
                },
                children: "Practice Settings"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: 16,
                    maxWidth: 840
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1px solid var(--bdr)',
                            borderRadius: 'var(--rl)',
                            padding: 20
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 14,
                                    fontWeight: 600,
                                    marginBottom: 13
                                },
                                children: "Firm Details"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "fg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "fl",
                                        children: "Practice Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "fi",
                                        defaultValue: "La Rosa & Partners Pty Ltd"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "fg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "fl",
                                        children: "AFSL Number"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "fi",
                                        defaultValue: "482910"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "fg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "fl",
                                        children: "ABN"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "fi",
                                        defaultValue: "45 123 456 789"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "fg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "fl",
                                        children: "Licensee / Dealer Group"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "fi",
                                        defaultValue: "Independent \u2014 Self-licensed"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "bsm bp",
                                children: "Save"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1px solid var(--bdr)',
                            borderRadius: 'var(--rl)',
                            padding: 20
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 14,
                                    fontWeight: 600,
                                    marginBottom: 13
                                },
                                children: "Subscription"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    color: 'var(--muted)',
                                    marginBottom: 12
                                },
                                children: "Practice Annual Plan"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    fontSize: 24,
                                    fontWeight: 600,
                                    color: 'var(--dark)',
                                    marginBottom: 4
                                },
                                children: [
                                    "$2,450 ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontSize: 14,
                                            fontWeight: 400,
                                            color: 'var(--muted)'
                                        },
                                        children: "/year"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 12,
                                    color: 'var(--grn)',
                                    marginBottom: 14
                                },
                                children: "\u25CF Active \xb7 Renews 12 Mar 2026"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    color: 'var(--muted)'
                                },
                                children: "Unlimited clients \xb7 6 team members"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/**
 * Reconciling the two places a client's SOAs live.
 *
 * `savedCaseStudies` is the in-app WORKING COPY, held in sessionStorage: it carries the full snapshot
 * needed to reopen and re-render a document. The `soas` table is the ADVICE REGISTER — immutable,
 * versioned, licensee-attributed, the legal record.
 *
 * The Partner Portal's Reports & SOAs list was built from the working copy alone, so signing out
 * emptied it: a client's generated advice vanished from the portal even though every version was
 * safely stored server-side, and a draft sitting unsent could be neither seen nor published.
 *
 * Working copy wins where both exist (only it can reopen the document). Register-only versions are
 * appended and flagged, so nothing is invisible and the UI can offer only what actually works for
 * them — publishing, yes; reopening or deleting, no (the register has no DELETE grant at all).
 */ const $61c205d79dbc6f70$var$MODULE_LABELS = {
    aged_care: 'Aged Care',
    support_at_home: 'Support at Home',
    retirement_village: 'Retirement Village',
    downsizer: 'Downsizer',
    granny_flat: 'Granny Flat',
    cashflow_pension: 'Cashflow & Pension'
};
function $61c205d79dbc6f70$export$1053d17793faa19e(soa) {
    return `v${soa.version} \xb7 ${$61c205d79dbc6f70$var$MODULE_LABELS[soa.module] || soa.module}`;
}
function $61c205d79dbc6f70$export$dcb092af5d9a4069(savedCaseStudies, registeredSoasByProfileId) {
    const grouped = new Map();
    (savedCaseStudies || []).forEach((scenario)=>{
        if (!scenario?.caseId) return;
        if (!grouped.has(scenario.caseId)) grouped.set(scenario.caseId, []);
        grouped.get(scenario.caseId).push(scenario);
    });
    Object.entries(registeredSoasByProfileId || {}).forEach(([profileId, registered])=>{
        const existing = grouped.get(profileId) || [];
        // Match on the register id the working copy recorded when it was written there.
        const alreadyLocal = new Set(existing.map((sc)=>String(sc.serverSoaId || '')).filter(Boolean));
        const extras = (registered || []).filter((soa)=>!alreadyLocal.has(soa.id)).map((soa)=>({
                id: soa.id,
                caseId: profileId,
                name: $61c205d79dbc6f70$export$1053d17793faa19e(soa),
                createdAt: soa.createdAt,
                soaDeliveryStatus: soa.status,
                serverSoaId: soa.id,
                registerOnly: true
            }));
        if (extras.length) grouped.set(profileId, [
            ...existing,
            ...extras
        ]);
    });
    grouped.forEach((items)=>{
        items.sort((a, b)=>new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime());
    });
    return grouped;
}



/**
 * The firm's Capital Market Assumptions — the licensee-locked table every projection under this
 * firm runs on (client-profile presets, strategy pricing, Assumptions page, SOA appendices).
 *
 * Edited here by the firm admin, saved onto FirmSettings (merged server-side), applied to the
 * session immediately and re-applied at every sign-in (useProfessionalPortal). Advisers under the
 * firm receive the numbers read-only through the app — no per-client fiddling, no drift.
 *
 * A profile is entered as a PORTFOLIO ONLY — income, growth, franked share. The super and pension
 * columns are DERIVED and shown read-only (pension = income + growth, because pension earnings are
 * tax-free; super = that less the componentised fund tax), so a firm cannot state a super return
 * that contradicts the portfolio beside it. The remaining rule — options must rise Conservative →
 * High growth — is checked by the same shared validator the engine applies.
 */ 

var $acw62 = parcelRequire("acw62");

const $fadd4c9abe8ba3e8$var$toProfileDraft = (cma)=>{
    const out = {};
    for (const id of (0, $0f2c0a6799fe36da$export$56315028e4277c0c)){
        const personal = cma?.profiles?.[id]?.personal || (0, $0f2c0a6799fe36da$export$55c76d26484d72a8)[id].personal;
        out[id] = {
            incomeRatePct: String(personal.incomeRatePct),
            growthRatePct: String(personal.growthRatePct),
            frankingPct: String(personal.frankingPct)
        };
    }
    return out;
};
const $fadd4c9abe8ba3e8$var$toAssetDraft = (cma)=>{
    const out = {};
    for (const key of Object.keys((0, $0f2c0a6799fe36da$export$62973aa9238fb7ab))){
        const override = cma?.assetClasses?.[key];
        out[key] = String(typeof override === 'number' ? override : (0, $0f2c0a6799fe36da$export$62973aa9238fb7ab)[key]);
    }
    return out;
};
const $fadd4c9abe8ba3e8$var$num = (v)=>parseFloat(v) || 0;
/** The other asset classes, laid out as the rows the screen shows. */ const $fadd4c9abe8ba3e8$var$ASSET_ROWS = [
    {
        label: 'Cash / bank accounts',
        note: "Interest only \u2014 cash does not appreciate.",
        fields: [
            {
                key: 'bankIncomePct',
                head: 'Interest %'
            }
        ]
    },
    {
        label: 'Term deposits',
        note: 'Interest only.',
        fields: [
            {
                key: 'termDepositIncomePct',
                head: 'Interest %'
            }
        ]
    },
    {
        label: 'Shares / managed funds (personally held)',
        note: "Income is taxed each year at the client\u2019s own rates; growth is taxed as CGT on sale.",
        fields: [
            {
                key: 'sharesIncomePct',
                head: 'Income %'
            },
            {
                key: 'sharesGrowthPct',
                head: 'Growth %'
            },
            {
                key: 'sharesFrankingPct',
                head: 'Franked %'
            }
        ]
    },
    {
        label: 'Investment property',
        note: 'Gross rent as a % of value; expenses as a % of that rent.',
        fields: [
            {
                key: 'propertyYieldPct',
                head: 'Gross yield %'
            },
            {
                key: 'propertyExpenseRatioPct',
                head: 'Expenses % of rent'
            },
            {
                key: 'propertyGrowthPct',
                head: 'Growth %'
            }
        ]
    }
];
function $fadd4c9abe8ba3e8$export$16f4f806beb74376({ settings: settings, firmName: firmName, setBy: setBy, onSave: onSave }) {
    const saved = settings?.capitalMarketAssumptions ?? null;
    const [profileDraft, setProfileDraft] = (0, $acw62.useState)(()=>$fadd4c9abe8ba3e8$var$toProfileDraft(saved));
    const [assetDraft, setAssetDraft] = (0, $acw62.useState)(()=>$fadd4c9abe8ba3e8$var$toAssetDraft(saved));
    const [problems, setProblems] = (0, $acw62.useState)([]);
    const [state, setState] = (0, $acw62.useState)('idle');
    const buildCma = ()=>{
        const profiles = {};
        for (const id of (0, $0f2c0a6799fe36da$export$56315028e4277c0c)){
            const d = profileDraft[id];
            profiles[id] = {
                personal: {
                    incomeRatePct: $fadd4c9abe8ba3e8$var$num(d.incomeRatePct),
                    growthRatePct: $fadd4c9abe8ba3e8$var$num(d.growthRatePct),
                    frankingPct: $fadd4c9abe8ba3e8$var$num(d.frankingPct)
                }
            };
        }
        const assetClasses = {};
        for (const key of Object.keys((0, $0f2c0a6799fe36da$export$62973aa9238fb7ab)))assetClasses[key] = $fadd4c9abe8ba3e8$var$num(assetDraft[key]);
        return {
            profiles: profiles,
            assetClasses: assetClasses,
            effectiveDate: new Date().toISOString().slice(0, 10),
            setBy: setBy || undefined,
            firmName: firmName || undefined
        };
    };
    const save = async ()=>{
        const cma = buildCma();
        const found = (0, $0f2c0a6799fe36da$export$1789f7f4cdb387a)(cma);
        setProblems(found);
        if (found.length > 0 || !onSave) return;
        setState('saving');
        const ok = await onSave({
            capitalMarketAssumptions: cma
        });
        if (ok) (0, $0f2c0a6799fe36da$export$202e846e294fdcb3)(cma); // the session prices on the new table immediately
        setState(ok ? 'saved' : 'failed');
    };
    const resetToDefaults = async ()=>{
        setProfileDraft($fadd4c9abe8ba3e8$var$toProfileDraft(null));
        setAssetDraft($fadd4c9abe8ba3e8$var$toAssetDraft(null));
        setProblems([]);
        if (!onSave) return;
        setState('saving');
        const ok = await onSave({
            capitalMarketAssumptions: null
        });
        if (ok) (0, $0f2c0a6799fe36da$export$202e846e294fdcb3)(null);
        setState(ok ? 'saved' : 'failed');
    };
    const input = {
        width: '100%',
        maxWidth: 92,
        padding: '6px 8px',
        border: '1px solid #cbd5e1',
        borderRadius: 8,
        fontSize: 13,
        textAlign: 'right'
    };
    const th = {
        fontSize: 11,
        letterSpacing: '.02em',
        textTransform: 'uppercase',
        color: '#64748b',
        fontWeight: 600,
        textAlign: 'right',
        padding: '0 8px 8px',
        whiteSpace: 'nowrap'
    };
    const thLeft = {
        ...th,
        textAlign: 'left',
        paddingLeft: 0
    };
    const derived = {
        fontSize: 13.5,
        fontWeight: 700,
        color: '#0f172a',
        textAlign: 'right',
        padding: '0 8px',
        whiteSpace: 'nowrap'
    };
    const rowLabel = {
        fontSize: 13,
        fontWeight: 600,
        color: '#0f172a',
        paddingRight: 14,
        minWidth: 150
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            marginTop: 14,
            background: '#fff',
            border: '1px solid #e2e8f0',
            borderRadius: 16,
            padding: 24,
            boxShadow: '0 1px 3px rgba(15,23,42,.06)'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontWeight: 700,
                    fontSize: 15,
                    color: '#0f172a'
                },
                children: "Capital market assumptions"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    fontSize: 13,
                    color: '#64748b',
                    margin: '6px 0 4px',
                    lineHeight: 1.55,
                    maxWidth: 720
                },
                children: "Every projection your firm's advisers and clients see runs on these figures \u2014 client-profile presets, the returns strategies invest at, the Assumptions page and SOA appendices. Set once, applied firm-wide, disclosed on advice."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    fontSize: 12.5,
                    color: saved ? '#0f172a' : '#64748b',
                    margin: '0 0 16px'
                },
                children: saved?.effectiveDate ? `Your firm's assumptions are in force \u{2014} effective ${saved.effectiveDate}${saved.setBy ? `, set by ${saved.setBy}` : ''}.` : 'Currently using the AgedCareWise defaults.'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontWeight: 600,
                    fontSize: 13,
                    color: '#334155',
                    marginBottom: 2
                },
                children: "Superannuation & pension \u2014 by investment option"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    fontSize: 12.5,
                    color: '#64748b',
                    margin: '0 0 10px',
                    lineHeight: 1.5,
                    maxWidth: 720
                },
                children: "Enter the PORTFOLIO for each option. The super and pension columns are worked out from it: pension earnings are tax-free, so pension = income + growth; super is that less the fund's tax on income (15%, after franking credits) and growth (10%)."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    overflowX: 'auto',
                    paddingBottom: 4
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    style: {
                        borderCollapse: 'collapse',
                        width: '100%',
                        maxWidth: 720
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        style: thLeft,
                                        children: "Option"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        style: th,
                                        children: "Income %"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        style: th,
                                        children: "Growth %"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        style: th,
                                        children: "Franked %"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        style: {
                                            ...th,
                                            color: '#0f172a'
                                        },
                                        children: "Super %"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        style: {
                                            ...th,
                                            color: '#0f172a'
                                        },
                                        children: "Pension %"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                            children: (0, $0f2c0a6799fe36da$export$56315028e4277c0c).map((id)=>{
                                const d = profileDraft[id];
                                const row = (0, $0f2c0a6799fe36da$export$cd457b0896bf574b)((0, $0f2c0a6799fe36da$export$55c76d26484d72a8)[id].label, {
                                    incomeRatePct: $fadd4c9abe8ba3e8$var$num(d.incomeRatePct),
                                    growthRatePct: $fadd4c9abe8ba3e8$var$num(d.growthRatePct),
                                    frankingPct: $fadd4c9abe8ba3e8$var$num(d.frankingPct)
                                });
                                const set = (field)=>(e)=>setProfileDraft((prev)=>({
                                                ...prev,
                                                [id]: {
                                                    ...prev[id],
                                                    [field]: e.target.value
                                                }
                                            }));
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    style: {
                                        borderTop: '1px solid #f1f5f9'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            style: {
                                                ...rowLabel,
                                                padding: '8px 14px 8px 0'
                                            },
                                            children: (0, $0f2c0a6799fe36da$export$55c76d26484d72a8)[id].label
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            style: {
                                                padding: '6px 8px'
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                "aria-label": `${id} income`,
                                                style: input,
                                                value: d.incomeRatePct,
                                                onChange: set('incomeRatePct')
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            style: {
                                                padding: '6px 8px'
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                "aria-label": `${id} growth`,
                                                style: input,
                                                value: d.growthRatePct,
                                                onChange: set('growthRatePct')
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            style: {
                                                padding: '6px 8px'
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                "aria-label": `${id} franking`,
                                                style: input,
                                                value: d.frankingPct,
                                                onChange: set('frankingPct')
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            style: derived,
                                            children: row.accumulationNetPct.toFixed(2)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            style: derived,
                                            children: row.pensionNetPct.toFixed(2)
                                        })
                                    ]
                                }, id);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontWeight: 600,
                    fontSize: 13,
                    color: '#334155',
                    margin: '22px 0 10px'
                },
                children: "Other asset classes"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    overflowX: 'auto',
                    paddingBottom: 4
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                    style: {
                        borderCollapse: 'collapse',
                        width: '100%',
                        maxWidth: 720
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                        children: $fadd4c9abe8ba3e8$var$ASSET_ROWS.map((assetRow)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                style: {
                                    borderTop: '1px solid #f1f5f9'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        style: {
                                            ...rowLabel,
                                            padding: '10px 14px 10px 0',
                                            verticalAlign: 'top'
                                        },
                                        children: [
                                            assetRow.label,
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontWeight: 400,
                                                    fontSize: 11.5,
                                                    color: '#94a3b8',
                                                    marginTop: 3,
                                                    maxWidth: 240,
                                                    lineHeight: 1.45
                                                },
                                                children: assetRow.note
                                            })
                                        ]
                                    }),
                                    assetRow.fields.map((f)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                            style: {
                                                padding: '10px 8px',
                                                verticalAlign: 'top'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: 11,
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '.02em',
                                                        color: '#64748b',
                                                        fontWeight: 600,
                                                        marginBottom: 4
                                                    },
                                                    children: f.head
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    "aria-label": f.key,
                                                    style: input,
                                                    value: assetDraft[f.key],
                                                    onChange: (e)=>setAssetDraft((prev)=>({
                                                                ...prev,
                                                                [f.key]: e.target.value
                                                            }))
                                                })
                                            ]
                                        }, f.key))
                                ]
                            }, assetRow.label))
                    })
                })
            }),
            problems.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    marginTop: 14,
                    background: '#fff',
                    border: '1px solid #e2e8f0',
                    borderLeft: '4px solid #ef4444',
                    borderRadius: 8,
                    padding: '10px 14px'
                },
                children: problems.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            fontSize: 12.5,
                            color: '#b91c1c',
                            margin: '2px 0'
                        },
                        children: p
                    }, p))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 10,
                    alignItems: 'center',
                    marginTop: 18,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: save,
                        disabled: state === 'saving',
                        style: {
                            padding: '9px 18px',
                            borderRadius: 10,
                            border: 'none',
                            background: '#1a6fd4',
                            color: '#fff',
                            fontWeight: 600,
                            fontSize: 13.5,
                            cursor: 'pointer'
                        },
                        children: state === 'saving' ? "Saving\u2026" : 'Save firm assumptions'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: resetToDefaults,
                        disabled: state === 'saving',
                        style: {
                            padding: '9px 16px',
                            borderRadius: 10,
                            border: '1px solid #cbd5e1',
                            background: '#fff',
                            color: '#334155',
                            fontWeight: 600,
                            fontSize: 13,
                            cursor: 'pointer'
                        },
                        children: "Use AgedCareWise defaults"
                    }),
                    state === 'saved' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 12.5,
                            color: '#15803d',
                            fontWeight: 600
                        },
                        children: "Saved \u2014 applied to this session and every sign-in."
                    }),
                    state === 'failed' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 12.5,
                            color: '#b91c1c',
                            fontWeight: 600
                        },
                        children: "Couldn't save \u2014 try again."
                    })
                ]
            })
        ]
    });
}
var $fadd4c9abe8ba3e8$export$2e2bcd8739ae039 = $fadd4c9abe8ba3e8$export$16f4f806beb74376;


/**
 * Settings → Your team.
 *
 * The screen a firm with more than one person needs, and the reason the rest of the team work
 * exists. Deliberately ONE screen rather than a step in sign-up: this is the same page on day one
 * and in March when somebody joins, so a wizard version would only ever have covered the first day
 * and this one would still have had to be built.
 *
 * Most firms are one person and stay that way. A sole practitioner should be able to read this in a
 * glance, see that it does not apply to them, and never think about it again — which is why there is
 * no empty state urging them to build a team they do not have.
 */ 

var $acw62 = parcelRequire("acw62");


const $1633b2e963524d79$var$card = {
    background: '#fff',
    border: '1px solid #e2e8f0',
    borderRadius: 16,
    boxShadow: '0 1px 3px rgba(15,23,42,.06)',
    marginTop: 14,
    overflow: 'hidden'
};
const $1633b2e963524d79$var$label = {
    fontSize: 10.5,
    fontWeight: 700,
    letterSpacing: '.07em',
    textTransform: 'uppercase',
    color: '#64748b',
    display: 'block',
    marginBottom: 6
};
const $1633b2e963524d79$var$input = {
    width: '100%',
    border: '1px solid #cbd5e1',
    borderRadius: 8,
    padding: '9px 11px',
    fontSize: 14,
    color: '#0f172a',
    background: '#fff'
};
const $1633b2e963524d79$var$primaryBtn = {
    background: '#1a6fd4',
    color: '#fff',
    border: 0,
    borderRadius: 8,
    padding: '9px 16px',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer'
};
const $1633b2e963524d79$var$ghostBtn = {
    background: '#fff',
    color: '#475569',
    border: '1px solid #cbd5e1',
    borderRadius: 8,
    padding: '8px 13px',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer'
};
/** What this person's allowance means in a sentence, rather than four numbers to interpret. */ function $1633b2e963524d79$var$planLine(member) {
    if (!member.plan) return "Holds no clients \u2014 free";
    const { mode: mode, used: used, remaining: remaining } = member.plan;
    if (mode === 'comp') return "Complimentary access \u2014 unlimited clients";
    if (mode === 'none') // The moment that matters on this screen: an invited person who cannot start work yet.
    return "No plan yet \u2014 cannot take on a client until one is chosen";
    const plan = mode === 'annual' ? 'Annual plan' : 'Pay as you go';
    const left = remaining === null ? 'unlimited' : `${remaining} left`;
    return `${plan} \xb7 ${used} ${used === 1 ? 'client' : 'clients'} taken on \xb7 ${left}`;
}
function $1633b2e963524d79$var$roleLine(member, holderLabel) {
    if (member.role === 'owner') return `Principal \xb7 ${holderLabel.toLowerCase()} \xb7 sees every client`;
    if (member.role === 'adviser') return `${holderLabel} \xb7 sees their own clients`;
    return "Support \xb7 holds no clients \xb7 sees the practice";
}
function $1633b2e963524d79$export$de93620394a42578({ tenantId: tenantId, myUserId: myUserId, isPrincipal: isPrincipal, holderLabel: holderLabel = 'Adviser' }) {
    const [members, setMembers] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [inviteOpen, setInviteOpen] = (0, $acw62.useState)(false);
    const [inviteEmail, setInviteEmail] = (0, $acw62.useState)('');
    const [inviteRole, setInviteRole] = (0, $acw62.useState)('adviser');
    const [inviteLink, setInviteLink] = (0, $acw62.useState)(null);
    const [editingNumber, setEditingNumber] = (0, $acw62.useState)(null);
    const [numberDraft, setNumberDraft] = (0, $acw62.useState)('');
    const load = (0, $acw62.useCallback)(async ()=>{
        try {
            setMembers(await (0, $442533e192804693$export$f1d37579424c00c1)(tenantId));
        } catch  {
            setError('Could not load your team.');
        }
    }, [
        tenantId
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const holders = (0, $acw62.useMemo)(()=>(members ?? []).filter((m)=>m.role === 'owner' || m.role === 'adviser'), [
        members
    ]);
    /** Run an action, surface whatever the server said, and re-read the roster either way. */ const run = async (fn)=>{
        setBusy(true);
        setError(null);
        const res = await fn();
        if (!res.ok) setError(res.message ?? 'That did not work.');
        await load();
        setBusy(false);
        return res.ok;
    };
    const send = async ()=>{
        const email = inviteEmail.trim();
        if (!email) return;
        setBusy(true);
        setError(null);
        const res = await (0, $442533e192804693$export$20839648df6ac6fe)(tenantId, email, inviteRole);
        if (!res.ok) setError(res.message);
        else {
            // Colleague invites are not emailed by the server — only client invites are — so this
            // link is the only way in. Showing it beats an adviser waiting for a message that was
            // never going to arrive.
            setInviteLink(`${window.location.origin}/?invite=${res.token}`);
            setInviteEmail('');
        }
        await load();
        setBusy(false);
    };
    if (!members) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: $1633b2e963524d79$var$card,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                padding: 20,
                fontSize: 13,
                color: '#64748b'
            },
            children: "Loading your team\u2026"
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: $1633b2e963524d79$var$card,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    padding: '18px 20px 4px'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'baseline',
                            gap: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontWeight: 700,
                                    fontSize: 15,
                                    color: '#0f172a'
                                },
                                children: "Your team"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    fontSize: 12.5,
                                    color: '#64748b'
                                },
                                children: [
                                    holders.length,
                                    " ",
                                    holders.length === 1 ? holderLabel.toLowerCase() : `${holderLabel.toLowerCase()}s`,
                                    members.length - holders.length > 0 ? ` \xb7 ${members.length - holders.length} support` : ''
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        style: {
                            fontSize: 13,
                            color: '#64748b',
                            lineHeight: 1.55,
                            margin: '4px 0 0'
                        },
                        children: [
                            holderLabel,
                            "s hold their own clients and need their own plan. Support helps with anyone\u2019s clients, holds none, and is free."
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    margin: '12px 20px 0',
                    background: '#fef2f2',
                    border: '1px solid #fecaca',
                    color: '#b91c1c',
                    borderRadius: 10,
                    padding: '10px 13px',
                    fontSize: 13,
                    lineHeight: 1.5
                },
                children: error
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: '6px 20px 4px'
                },
                children: members.filter((m)=>m.role !== 'client').map((m)=>{
                    const isMe = m.userId === myUserId;
                    const holdsClients = m.role === 'owner' || m.role === 'adviser';
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: 12,
                            padding: '13px 0',
                            borderTop: '1px solid #f1f5f9'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    width: 34,
                                    height: 34,
                                    borderRadius: '50%',
                                    flexShrink: 0,
                                    background: holdsClients ? 'linear-gradient(135deg,#1a6fd4,#17b8e0)' : '#f1f5f9',
                                    color: holdsClients ? '#fff' : '#64748b',
                                    border: holdsClients ? 0 : '1px solid #e2e8f0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: 12,
                                    fontWeight: 700
                                },
                                children: (m.email ?? '?').slice(0, 2).toUpperCase()
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    flex: 1,
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            fontWeight: 600,
                                            fontSize: 14,
                                            color: '#0f172a'
                                        },
                                        children: [
                                            m.email ?? 'Unknown',
                                            isMe && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    marginLeft: 6,
                                                    fontSize: 10.5,
                                                    color: '#94a3b8',
                                                    border: '1px solid #e2e8f0',
                                                    borderRadius: 4,
                                                    padding: '1px 5px'
                                                },
                                                children: "you"
                                            }),
                                            m.status === 'invited' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    marginLeft: 6,
                                                    fontSize: 10.5,
                                                    color: '#d97706',
                                                    background: '#fdf3e5',
                                                    borderRadius: 4,
                                                    padding: '1px 5px'
                                                },
                                                children: "invited"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 12,
                                            color: '#64748b',
                                            marginTop: 2
                                        },
                                        children: $1633b2e963524d79$var$roleLine(m, holderLabel)
                                    }),
                                    holdsClients && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            fontSize: 12,
                                            color: m.plan?.mode === 'none' ? '#b45309' : '#64748b',
                                            marginTop: 2
                                        },
                                        children: [
                                            $1633b2e963524d79$var$planLine(m),
                                            m.clientCount > 0 && ` \xb7 ${m.clientCount} on their book`
                                        ]
                                    }),
                                    holdsClients && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 12,
                                            color: '#64748b',
                                            marginTop: 4
                                        },
                                        children: editingNumber === m.userId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            style: {
                                                display: 'inline-flex',
                                                gap: 6,
                                                alignItems: 'center'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    style: {
                                                        ...$1633b2e963524d79$var$input,
                                                        width: 150,
                                                        padding: '5px 8px',
                                                        fontSize: 13
                                                    },
                                                    value: numberDraft,
                                                    onChange: (e)=>setNumberDraft(e.target.value),
                                                    placeholder: "ASIC adviser number",
                                                    "aria-label": "ASIC adviser number"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    style: $1633b2e963524d79$var$ghostBtn,
                                                    disabled: busy,
                                                    onClick: async ()=>{
                                                        const ok = await run(()=>(0, $442533e192804693$export$5eb419ad44f728fd)(tenantId, m.userId, {
                                                                adviserNumber: numberDraft.trim() || null
                                                            }));
                                                        if (ok) setEditingNumber(null);
                                                    },
                                                    children: "Save"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    style: $1633b2e963524d79$var$ghostBtn,
                                                    onClick: ()=>setEditingNumber(null),
                                                    children: "Cancel"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                m.adviserNumber ? `Adviser No. ${m.adviserNumber}` : 'No adviser number recorded',
                                                (isMe || isPrincipal) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    style: {
                                                        background: 'none',
                                                        border: 0,
                                                        color: '#1a6fd4',
                                                        fontSize: 12,
                                                        fontWeight: 600,
                                                        cursor: 'pointer',
                                                        padding: '0 0 0 8px'
                                                    },
                                                    onClick: ()=>{
                                                        setEditingNumber(m.userId);
                                                        setNumberDraft(m.adviserNumber ?? '');
                                                    },
                                                    children: m.adviserNumber ? 'Change' : 'Add'
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            isPrincipal && !isMe && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 6,
                                    flexShrink: 0
                                },
                                children: [
                                    m.role === 'adviser' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        style: $1633b2e963524d79$var$ghostBtn,
                                        disabled: busy,
                                        onClick: async ()=>{
                                            if (!await (0, $8e1e84c918e07c84$export$71edf76f07903b9c)(`Hand the account to ${m.email}? They will see every client and manage the subscription. You cannot undo this yourself.`)) return;
                                            run(()=>(0, $442533e192804693$export$f295b832cc46f372)(tenantId, m.userId, 'adviser'));
                                        },
                                        children: "Make principal"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        style: $1633b2e963524d79$var$ghostBtn,
                                        disabled: busy,
                                        onClick: async ()=>{
                                            if (!await (0, $8e1e84c918e07c84$export$71edf76f07903b9c)(`Remove ${m.email} from the firm?`)) return;
                                            run(()=>(0, $442533e192804693$export$b292608e58e5c4ed)(tenantId, m.userId));
                                        },
                                        children: "Remove"
                                    })
                                ]
                            })
                        ]
                    }, m.userId);
                })
            }),
            isPrincipal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: '14px 20px 20px',
                    borderTop: '1px solid #f1f5f9'
                },
                children: !inviteOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    style: $1633b2e963524d79$var$primaryBtn,
                    onClick: ()=>setInviteOpen(true),
                    children: "Invite a colleague"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            style: $1633b2e963524d79$var$label,
                            htmlFor: "team-invite-email",
                            children: "Their work email"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            id: "team-invite-email",
                            style: $1633b2e963524d79$var$input,
                            type: "email",
                            value: inviteEmail,
                            onChange: (e)=>setInviteEmail(e.target.value),
                            placeholder: "name@firm.com.au"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                marginTop: 14
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: $1633b2e963524d79$var$label,
                                    children: "What will they do?"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                                        gap: 10
                                    },
                                    children: [
                                        {
                                            value: 'adviser',
                                            title: holderLabel,
                                            detail: 'Has their own clients. Needs their own plan before taking one on.'
                                        },
                                        {
                                            value: 'staff',
                                            title: 'Support',
                                            detail: "Helps with anyone's clients. Holds none of their own. Free."
                                        }
                                    ].map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>setInviteRole(opt.value),
                                            style: {
                                                textAlign: 'left',
                                                cursor: 'pointer',
                                                background: inviteRole === opt.value ? '#f0f7ff' : '#fff',
                                                border: inviteRole === opt.value ? '2px solid #1a6fd4' : '1px solid #e2e8f0',
                                                borderRadius: 12,
                                                padding: inviteRole === opt.value ? 12 : 13
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontWeight: 600,
                                                        fontSize: 14,
                                                        color: '#0f172a',
                                                        marginBottom: 3
                                                    },
                                                    children: opt.title
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: 12,
                                                        color: '#64748b',
                                                        lineHeight: 1.45
                                                    },
                                                    children: opt.detail
                                                })
                                            ]
                                        }, opt.value))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    style: {
                                        fontSize: 12,
                                        color: '#64748b',
                                        margin: '8px 0 0',
                                        lineHeight: 1.5
                                    },
                                    children: [
                                        "Every client file names the ",
                                        holderLabel.toLowerCase(),
                                        " responsible for it. Support can prepare a file, but it is always assigned to ",
                                        holderLabel === 'Adviser' ? 'an adviser' : `a ${holderLabel.toLowerCase()}`,
                                        "."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: 9,
                                marginTop: 16
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    style: $1633b2e963524d79$var$ghostBtn,
                                    onClick: ()=>{
                                        setInviteOpen(false);
                                        setInviteLink(null);
                                    },
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    style: $1633b2e963524d79$var$primaryBtn,
                                    disabled: busy || !inviteEmail.trim(),
                                    onClick: ()=>void send(),
                                    children: "Send invite"
                                })
                            ]
                        }),
                        inviteLink && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                marginTop: 14,
                                background: '#f0f7ff',
                                border: '1px solid #bfdbfe',
                                borderRadius: 10,
                                padding: '12px 14px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontSize: 13,
                                        fontWeight: 600,
                                        color: '#0f172a',
                                        marginBottom: 6
                                    },
                                    children: "Send them this link"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    style: {
                                        fontSize: 12,
                                        color: '#475569',
                                        margin: '0 0 8px',
                                        lineHeight: 1.5
                                    },
                                    children: "Colleague invites are not emailed automatically \u2014 pass this on yourself. It works once, and only for the address you entered."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                    style: {
                                        display: 'block',
                                        wordBreak: 'break-all',
                                        fontSize: 11.5,
                                        background: '#fff',
                                        border: '1px solid #e2e8f0',
                                        borderRadius: 8,
                                        padding: '8px 10px',
                                        color: '#334155'
                                    },
                                    children: inviteLink
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


/**
 * Settings → how this firm's advice is provided.
 *
 * The question is deliberately not "do you have an AFSL?". For an advice firm the answer is always
 * yes and it tells you nothing; what an advice document needs to know is the ROUTE the advice takes,
 * because that decides which entities it must name. Asking *how* separates the three structures in
 * one question, and each reveals only the fields that apply to it.
 *
 * Sign-up captures one of the three — the licensee and its AFSL — so a practice that is a corporate
 * authorised representative has had nowhere to record its own name and number, and an SOA from that
 * firm names one entity where a compliant attribution names three.
 */ 

var $acw62 = parcelRequire("acw62");

const $a7d9dfadc6ef7c34$var$OPTIONS = [
    {
        value: 'own_afsl',
        title: 'Under our own AFSL',
        detail: 'The practice is the licensee.'
    },
    {
        value: 'corporate_ar',
        title: 'Through our practice, as a corporate authorised representative',
        detail: 'The practice is authorised by a licensee.'
    },
    {
        value: 'individual_ar',
        title: 'By me personally, as an authorised representative',
        detail: 'Authorised by a licensee, with no practice company.'
    }
];
const $a7d9dfadc6ef7c34$var$card = {
    background: '#fff',
    border: '1px solid #e2e8f0',
    borderRadius: 16,
    boxShadow: '0 1px 3px rgba(15,23,42,.06)',
    marginTop: 14,
    overflow: 'hidden'
};
const $a7d9dfadc6ef7c34$var$label = {
    fontSize: 10.5,
    fontWeight: 700,
    letterSpacing: '.07em',
    textTransform: 'uppercase',
    color: '#64748b',
    display: 'block',
    marginBottom: 6
};
const $a7d9dfadc6ef7c34$var$input = {
    width: '100%',
    border: '1px solid #cbd5e1',
    borderRadius: 8,
    padding: '9px 11px',
    fontSize: 14,
    color: '#0f172a',
    background: '#fff'
};
const $a7d9dfadc6ef7c34$var$primaryBtn = {
    background: '#1a6fd4',
    color: '#fff',
    border: 0,
    borderRadius: 8,
    padding: '9px 16px',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer'
};
function $a7d9dfadc6ef7c34$export$5201925fd737e3ce({ tenantId: tenantId, isPrincipal: isPrincipal, myUserId: myUserId }) {
    const [tenant, setTenant] = (0, $acw62.useState)(null);
    const [structure, setStructure] = (0, $acw62.useState)(null);
    const [licensee, setLicensee] = (0, $acw62.useState)('');
    const [afsl, setAfsl] = (0, $acw62.useState)('');
    const [carName, setCarName] = (0, $acw62.useState)('');
    const [carNumber, setCarNumber] = (0, $acw62.useState)('');
    /**
     * The signer's OWN number. A different entity's from the CAR number above — that one belongs to
     * the practice company, this one to the person — and both are named on an advice document.
     * Stored against the membership, not the firm, because it follows someone between practices.
     */ const [adviserNumber, setAdviserNumber] = (0, $acw62.useState)('');
    const [state, setState] = (0, $acw62.useState)({
        busy: false,
        message: null,
        ok: false
    });
    // Read the firm here rather than threading it through the portal: this panel is the only screen
    // that wants these five fields, and the fields arrive asynchronously either way.
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (async ()=>{
            const t = await (0, $442533e192804693$export$e24d85f794d5f8dd)(tenantId);
            if (cancelled || !t) return;
            setTenant(t);
            setStructure(t.adviceStructure ?? null);
            setLicensee(t.afslLicenseeName ?? '');
            setAfsl(t.afslNumber ?? '');
            setCarName(t.carName ?? '');
            setCarNumber(t.carNumber ?? '');
            const me = (await (0, $442533e192804693$export$f1d37579424c00c1)(tenantId).catch(()=>[])).find((m)=>m.userId === myUserId);
            if (!cancelled) setAdviserNumber(me?.adviserNumber ?? '');
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        tenantId,
        myUserId
    ]);
    const save = async ()=>{
        setState({
            busy: true,
            message: null,
            ok: false
        });
        const res = await (0, $442533e192804693$export$7986551de014fb3e)(tenantId, {
            adviceStructure: structure,
            afslLicenseeName: licensee.trim(),
            afslNumber: afsl.trim(),
            // Cleared rather than left stale when the structure no longer has a practice company —
            // an out-of-date CAR number on an advice document is worse than none.
            carName: structure === 'corporate_ar' ? carName.trim() || null : null,
            carNumber: structure === 'corporate_ar' ? carNumber.trim() || null : null
        });
        // The person's number is a separate write because it lives on the membership, not the firm.
        // Attempted even when the firm save failed would be misleading, so it waits on that succeeding.
        const numberRes = res.ok ? await (0, $442533e192804693$export$5eb419ad44f728fd)(tenantId, myUserId, {
            adviserNumber: adviserNumber.trim() || null
        }) : res;
        const ok = res.ok && numberRes.ok;
        setState({
            busy: false,
            ok: ok,
            message: ok ? 'Saved.' : res.message ?? numberRes.message ?? 'Could not save.'
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: $a7d9dfadc6ef7c34$var$card,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    padding: '18px 20px 4px'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontWeight: 700,
                            fontSize: 15,
                            color: '#0f172a',
                            marginBottom: 4
                        },
                        children: "How your advice is provided"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            fontSize: 13,
                            color: '#64748b',
                            lineHeight: 1.55,
                            margin: 0
                        },
                        children: "This decides which entities a Statement of Advice has to name. Every SOA records what was true the day it was generated, so changing this does not rewrite advice already given."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    padding: '14px 20px 20px'
                },
                children: [
                    !tenant && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 13,
                            color: '#64748b'
                        },
                        children: "Loading your licensing\u2026"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            display: 'grid',
                            gap: 9
                        },
                        children: $a7d9dfadc6ef7c34$var$OPTIONS.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                disabled: !isPrincipal,
                                onClick: ()=>setStructure(opt.value),
                                style: {
                                    textAlign: 'left',
                                    cursor: isPrincipal ? 'pointer' : 'default',
                                    background: structure === opt.value ? '#f0f7ff' : '#fff',
                                    border: structure === opt.value ? '2px solid #1a6fd4' : '1px solid #e2e8f0',
                                    borderRadius: 12,
                                    padding: structure === opt.value ? 12 : 13
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontWeight: 600,
                                            fontSize: 14,
                                            color: '#0f172a',
                                            marginBottom: 3
                                        },
                                        children: opt.title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 12,
                                            color: '#64748b',
                                            lineHeight: 1.45
                                        },
                                        children: opt.detail
                                    })
                                ]
                            }, opt.value))
                    }),
                    structure && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            marginTop: 16,
                            paddingLeft: 14,
                            borderLeft: '2px solid #1a6fd4',
                            background: '#f8fbff',
                            borderRadius: '0 8px 8px 0',
                            padding: '13px 14px 14px'
                        },
                        children: [
                            structure === 'corporate_ar' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 10,
                                            letterSpacing: '.1em',
                                            textTransform: 'uppercase',
                                            color: '#1a6fd4',
                                            marginBottom: 8,
                                            fontWeight: 700
                                        },
                                        children: "The practice"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                                            gap: 11,
                                            marginBottom: 16
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        style: $a7d9dfadc6ef7c34$var$label,
                                                        htmlFor: "car-name",
                                                        children: "Practice (CAR) name"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        id: "car-name",
                                                        style: $a7d9dfadc6ef7c34$var$input,
                                                        value: carName,
                                                        disabled: !isPrincipal,
                                                        onChange: (e)=>setCarName(e.target.value)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        style: $a7d9dfadc6ef7c34$var$label,
                                                        htmlFor: "car-number",
                                                        children: "CAR number"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        id: "car-number",
                                                        style: $a7d9dfadc6ef7c34$var$input,
                                                        value: carNumber,
                                                        disabled: !isPrincipal,
                                                        onChange: (e)=>setCarNumber(e.target.value)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 10,
                                    letterSpacing: '.1em',
                                    textTransform: 'uppercase',
                                    color: '#1a6fd4',
                                    marginBottom: 8,
                                    fontWeight: 700
                                },
                                children: structure === 'own_afsl' ? 'Your licence' : 'The licensee'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                                    gap: 11
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                style: $a7d9dfadc6ef7c34$var$label,
                                                htmlFor: "licensee-name",
                                                children: structure === 'own_afsl' ? 'Licensee name' : 'Licensee'
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                id: "licensee-name",
                                                style: $a7d9dfadc6ef7c34$var$input,
                                                value: licensee,
                                                disabled: !isPrincipal,
                                                onChange: (e)=>setLicensee(e.target.value)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                style: $a7d9dfadc6ef7c34$var$label,
                                                htmlFor: "afsl-number",
                                                children: "AFSL number"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                id: "afsl-number",
                                                style: $a7d9dfadc6ef7c34$var$input,
                                                value: afsl,
                                                disabled: !isPrincipal,
                                                onChange: (e)=>setAfsl(e.target.value)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 10,
                                    letterSpacing: '.1em',
                                    textTransform: 'uppercase',
                                    color: '#1a6fd4',
                                    margin: '16px 0 8px',
                                    fontWeight: 700
                                },
                                children: "You"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    maxWidth: 240
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        style: $a7d9dfadc6ef7c34$var$label,
                                        htmlFor: "my-adviser-number",
                                        children: "Your ASIC adviser number"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        id: "my-adviser-number",
                                        style: $a7d9dfadc6ef7c34$var$input,
                                        value: adviserNumber,
                                        disabled: !isPrincipal,
                                        onChange: (e)=>setAdviserNumber(e.target.value),
                                        placeholder: "e.g. 123456"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    fontSize: 12,
                                    color: '#64748b',
                                    margin: '10px 0 0',
                                    lineHeight: 1.5
                                },
                                children: structure === 'own_afsl' ? "Your number on the Financial Advisers Register. As an employee or director of your own licensee you are a representative of it, not an authorised representative, and advice from this firm will not describe you as one. Colleagues\u2019 numbers are recorded against them in Your team, below." : "Your number on the Financial Advisers Register \u2014 the same number as your authorised representative appointment, and a different entity\u2019s from the CAR number above. Colleagues\u2019 numbers are recorded against them in Your team, below."
                            })
                        ]
                    }),
                    isPrincipal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12,
                            marginTop: 16
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                style: $a7d9dfadc6ef7c34$var$primaryBtn,
                                disabled: state.busy || !structure,
                                onClick: ()=>void save(),
                                children: state.busy ? "Saving\u2026" : 'Save licensing'
                            }),
                            state.message && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    fontSize: 13,
                                    color: state.ok ? '#059669' : '#b91c1c'
                                },
                                children: state.message
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/**
 * Settings → API access. Where a partner finds the REST API documentation, and mints the
 * client_secret their own systems sign in with.
 *
 * THE SCREEN IS SHAPED BY ONE FACT: a client_secret is shown exactly once. The server keeps only a
 * one-way hash of it (server/src/oauth/clientCredentials/), so there is no "show it again" and never
 * will be. Everything here follows from that:
 *
 *   • Generating is a TWO-STEP act. The first click only opens the warning, because the thing being
 *     warned about — every system still configured with the old secret stops being able to sign in —
 *     happens the instant the request lands, and cannot be undone by generating again.
 *   • The new secret appears in a panel that will not close on its own, with a Copy button, and says
 *     plainly that this is the only time anyone will see it. Nothing on the page re-fetches while it
 *     is open; the only way past it is to dismiss it deliberately.
 *   • Afterwards the card reports WHEN the live secret was set and when it was last used, and no part
 *     of the secret itself — not even a prefix. Those two dates are what an owner part-way through a
 *     rotation actually needs ("is the value in my config the current one?"), and they answer it
 *     without the server keeping any fragment of the credential to answer it with.
 *
 * The documentation button opens the API's own Swagger UI in a new tab rather than embedding it: the
 * page's Try-it-out makes real requests, which only work without CORS trouble from the API's own
 * origin, and a partner reading reference material wants it in a tab they can keep.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $39f04136db3724b2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-6.219-8.56",
            key: "13zald"
        }
    ]
];
const $39f04136db3724b2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("loader-circle", $39f04136db3724b2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8a800148d042d893$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
            key: "v9h5vc"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ],
    [
        "path",
        {
            d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
            key: "3uifl3"
        }
    ],
    [
        "path",
        {
            d: "M8 16H3v5",
            key: "1cv678"
        }
    ]
];
const $8a800148d042d893$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("refresh-cw", $8a800148d042d893$export$3efd853dbb351e94);


/**
 * The signed-in partner's own API credential — the client_id and client_secret their systems use to
 * call this API directly instead of going through the browser.
 *
 * ONE RULE GOVERNS THIS WHOLE FILE: the client_secret exists in this process for as long as the
 * person is looking at it, and nowhere else. It is never written to localStorage, never put in a
 * URL, never logged, and never re-fetched — because it cannot be. `generateClientSecret` is the only
 * call that returns one, the server keeps only a hash of it (see
 * server/src/oauth/clientCredentials/), and `getApiCredential` exists precisely so the screen can
 * describe the live secret without asking for it.
 *
 * AND NOT A FRAGMENT OF IT EITHER. An earlier cut of this screen showed the secret's first eight
 * characters so an owner could tell which one was installed. The rule is now absolute — no part of a
 * client_secret is readable after it is created — so the dates do that job instead. There is nothing
 * in `ApiCredential` that could sign in, or help anyone guess something that could.
 */ 

/**
 * The API paths that BOTH halves of the application have to agree on, in the one place they can
 * both import from.
 *
 * WHAT WENT WRONG, Oct 2026. The server published the Swagger UI at `/docs` and the frontend's
 * "Open API documentation" button opened `<api base>/docs`. Both were self-consistent, every test
 * passed, and no partner could open the page — because in deployment the app and the API answer on
 * ONE origin, behind a reverse proxy that forwards only `/rest`, `/oauth` and `/webhooks` to the
 * API and serves everything else from the frontend's static build, falling back to `index.html` so
 * the app's own screens survive a deep link.
 *
 * That fallback is what made the bug invisible. A browser-facing API path outside those prefixes
 * does not 404 — it returns the APP, with a 200 and an HTML body. The partner who clicked the
 * button got the portal dashboard they were already looking at, and nothing on screen, in a log, or
 * in any test suite said the documentation had been swallowed on the way.
 *
 * So the rule, and it is not negotiable: ANYTHING THE API SERVES TO A BROWSER LIVES UNDER ONE OF
 * {@link BROWSER_REACHABLE_API_PREFIXES}. The server asserts it at boot (see
 * `assertBrowserReachable` in server/src/app.ts) and the frontend builds its urls from the
 * constants below, so the two cannot drift apart again.
 */ /**
 * Every path prefix the deployment's reverse proxy forwards to the API. Everything else on the
 * origin belongs to the frontend.
 */ const $513a114750c50b5a$export$62e37eaf3e76b755 = [
    '/rest/',
    '/oauth/',
    '/webhooks/'
];
const $513a114750c50b5a$export$7e89924f90af2879 = '/rest/docs';
const $513a114750c50b5a$export$d53cd462a7c8d50d = '/rest/vendor';
function $513a114750c50b5a$export$9798a656e415da25(path) {
    return $513a114750c50b5a$export$62e37eaf3e76b755.some((prefix)=>path.startsWith(prefix));
}



async function $9497429010f3da08$var$authHeaders() {
    const token = await (0, $cc9e8a24185b91b0$export$84773cc9bf7dbe87)();
    if (!token) throw new Error('Not signed in');
    return {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
}
const $9497429010f3da08$var$endpoint = ()=>`${(0, $4e54353814e6aea9$export$8ebae31efd30e025)()}/rest/api-credentials`;
function $9497429010f3da08$export$99d105316f749f7c() {
    return `${(0, $4e54353814e6aea9$export$8ebae31efd30e025)()}${0, $513a114750c50b5a$export$7e89924f90af2879}`;
}
function $9497429010f3da08$export$88f4f8630c642ee3(err, fallback) {
    const axiosErr = err;
    const code = axiosErr?.response?.data?.error?.code;
    if (code === 'MFA_REQUIRED' || code === 'MFA_SETUP_REQUIRED') return 'API credentials need two-step sign in. Set up your authenticator under Account, then sign out and back in with a code.';
    const serverMsg = axiosErr?.response?.data?.error?.message;
    if (serverMsg) return serverMsg;
    if (err?.message === 'Not signed in') return "Your session has expired \u2014 please sign in again.";
    if (!axiosErr?.response) return "We couldn't reach the server. Check your connection and try again.";
    return fallback;
}
async function $9497429010f3da08$export$63a029a09fdf3cac() {
    const headers = await $9497429010f3da08$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get($9497429010f3da08$var$endpoint(), {
        headers: headers,
        timeout: 30000
    });
    return res.data?.credential ?? null;
}
async function $9497429010f3da08$export$23abccfd6e4855cb() {
    const headers = await $9497429010f3da08$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post($9497429010f3da08$var$endpoint(), {}, {
        headers: headers,
        timeout: 30000
    });
    return res.data;
}
async function $9497429010f3da08$export$b266c02c71dd0d6f() {
    const headers = await $9497429010f3da08$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).delete($9497429010f3da08$var$endpoint(), {
        headers: headers,
        timeout: 30000
    });
    return {
        revoked: Boolean(res.data?.revoked)
    };
}


// Matched to the other cards in this settings column (FirmLicensingSettings, FirmTeamSettings).
const $5d04974d4d9d65fa$var$card = {
    background: '#fff',
    border: '1px solid #e2e8f0',
    borderRadius: 16,
    boxShadow: '0 1px 3px rgba(15,23,42,.06)',
    marginTop: 14,
    overflow: 'hidden'
};
const $5d04974d4d9d65fa$var$btnBase = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 7,
    borderRadius: 8,
    padding: '9px 14px',
    fontSize: 13.5,
    fontWeight: 600,
    cursor: 'pointer'
};
const $5d04974d4d9d65fa$var$primaryBtn = {
    ...$5d04974d4d9d65fa$var$btnBase,
    background: '#1a6fd4',
    color: '#fff',
    border: 0
};
const $5d04974d4d9d65fa$var$outlineBtn = {
    ...$5d04974d4d9d65fa$var$btnBase,
    background: '#fff',
    color: '#1a6fd4',
    border: '1.5px solid #1a6fd4'
};
const $5d04974d4d9d65fa$var$ghostBtn = {
    ...$5d04974d4d9d65fa$var$btnBase,
    background: '#f1f5f9',
    color: '#475569',
    border: 0
};
const $5d04974d4d9d65fa$var$dangerBtn = {
    ...$5d04974d4d9d65fa$var$btnBase,
    background: '#fff',
    color: '#b91c1c',
    border: '1.5px solid #fca5a5'
};
const $5d04974d4d9d65fa$var$mono = {
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
    fontSize: 12.5,
    color: '#0f172a',
    wordBreak: 'break-all'
};
const $5d04974d4d9d65fa$var$fieldLabel = {
    fontSize: 10.5,
    fontWeight: 700,
    letterSpacing: '.07em',
    textTransform: 'uppercase',
    color: '#64748b'
};
/** "4 Oct 2026", or a dash when there is no date to show. */ function $5d04974d4d9d65fa$var$onDate(iso) {
    if (!iso) return "\u2014";
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? "\u2014" : d.toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    });
}
/** Copy, and say so for a moment. Silent when the browser blocks the clipboard — the value is on
 *  screen in full precisely so it can still be selected by hand. */ function $5d04974d4d9d65fa$var$CopyButton({ value: value, label: label, style: style }) {
    const [copied, setCopied] = (0, $acw62.useState)(false);
    const copy = async ()=>{
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);
            setTimeout(()=>setCopied(false), 2000);
        } catch  {
        /* Clipboard unavailable (permissions, insecure context) — nothing to recover from. */ }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: ()=>void copy(),
        style: {
            ...$5d04974d4d9d65fa$var$ghostBtn,
            ...style
        },
        "aria-label": label,
        children: [
            copied ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                size: 14
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
                size: 14
            }),
            copied ? 'Copied' : 'Copy'
        ]
    });
}
function $5d04974d4d9d65fa$export$da038b5fdece4075() {
    const [credential, setCredential] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [stage, setStage] = (0, $acw62.useState)('idle');
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [notice, setNotice] = (0, $acw62.useState)(null);
    /** The new secret, in this component's state and nowhere else, until the panel is dismissed. */ const [secret, setSecret] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (async ()=>{
            try {
                const current = await (0, $9497429010f3da08$export$63a029a09fdf3cac)();
                if (!cancelled) setCredential(current);
            } catch (err) {
                if (!cancelled) setError((0, $9497429010f3da08$export$88f4f8630c642ee3)(err, 'Could not read your API credential just now.'));
            } finally{
                if (!cancelled) setLoading(false);
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, []);
    const generate = async ()=>{
        setBusy(true);
        setError(null);
        setNotice(null);
        try {
            const minted = await (0, $9497429010f3da08$export$23abccfd6e4855cb)();
            setSecret(minted.clientSecret);
            setCredential(minted.credential);
            setStage('revealing');
        } catch (err) {
            setError((0, $9497429010f3da08$export$88f4f8630c642ee3)(err, 'Could not generate a client secret just now.'));
            setStage('idle');
        } finally{
            setBusy(false);
        }
    };
    const revoke = async ()=>{
        setBusy(true);
        setError(null);
        setNotice(null);
        try {
            const { revoked: revoked } = await (0, $9497429010f3da08$export$b266c02c71dd0d6f)();
            // Re-read rather than patch: the card's job is to report what the server holds, and a
            // locally-assumed state is how a screen starts disagreeing with the thing it describes.
            setCredential(await (0, $9497429010f3da08$export$63a029a09fdf3cac)());
            setNotice(revoked ? 'That client secret no longer works.' : 'There was no live client secret to revoke.');
        } catch (err) {
            setError((0, $9497429010f3da08$export$88f4f8630c642ee3)(err, 'Could not revoke your client secret just now.'));
        } finally{
            setBusy(false);
        }
    };
    /** Clear the secret from state the moment the panel closes. Nothing else holds a copy. */ const dismissSecret = ()=>{
        setSecret(null);
        setStage('idle');
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: $5d04974d4d9d65fa$var$card,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    padding: '18px 20px 4px'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            marginBottom: 4
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0cdbf97a5c8afc2$export$2e2bcd8739ae039), {
                                size: 16,
                                color: "#1a6fd4"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                style: {
                                    fontWeight: 700,
                                    fontSize: 15,
                                    color: '#0f172a',
                                    margin: 0
                                },
                                children: "API access"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            fontSize: 13,
                            color: '#64748b',
                            lineHeight: 1.55,
                            margin: 0
                        },
                        children: "Call AgedCareWise from your own systems \u2014 your CRM, a nightly job, anything that can make an HTTPS request. A client secret signs in as you and carries exactly the access you have, and everything done with it is recorded against you on the audit trail."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    padding: '14px 20px 20px'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        style: $5d04974d4d9d65fa$var$outlineBtn,
                        onClick: ()=>window.open((0, $9497429010f3da08$export$99d105316f749f7c)(), '_blank', 'noopener,noreferrer'),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            " Open API documentation"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        style: {
                            fontSize: 12.5,
                            color: '#64748b',
                            lineHeight: 1.5,
                            margin: '9px 0 0'
                        },
                        children: [
                            "Every endpoint, with a ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Try it out"
                            }),
                            " button on each one. Paste an access token into",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Authorize"
                            }),
                            " at the top and the page will use it for every call you make there."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            height: 1,
                            background: '#f1f5f9',
                            margin: '18px 0'
                        }
                    }),
                    loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            fontSize: 13,
                            color: '#64748b'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                size: 15,
                                className: "animate-spin"
                            }),
                            " Loading your credentials\u2026"
                        ]
                    }),
                    !loading && !credential && stage === 'idle' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            fontSize: 13,
                            color: '#475569',
                            lineHeight: 1.55,
                            margin: '0 0 14px'
                        },
                        children: "You haven't generated a client secret yet. Generating one gives you a client ID and a secret to put into whichever system needs to sign in."
                    }),
                    !loading && credential && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#f8fafc',
                            border: '1px solid #e2e8f0',
                            borderRadius: 12,
                            padding: '14px 16px',
                            marginBottom: 14
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: 12,
                                    flexWrap: 'wrap'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            minWidth: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: $5d04974d4d9d65fa$var$fieldLabel,
                                                children: "Client ID"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    ...$5d04974d4d9d65fa$var$mono,
                                                    marginTop: 3
                                                },
                                                children: credential.clientId
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5d04974d4d9d65fa$var$CopyButton, {
                                        value: credential.clientId,
                                        label: "Copy client ID"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    fontSize: 12,
                                    color: '#64748b',
                                    lineHeight: 1.5,
                                    margin: '7px 0 0'
                                },
                                children: "Not a secret, and it never changes \u2014 generating a new secret leaves it alone. Sending it when you sign in is optional, and worth doing: it ties your session to this one client, so a token that escapes your integration cannot be used anywhere else."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    height: 1,
                                    background: '#e2e8f0',
                                    margin: '13px 0'
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: $5d04974d4d9d65fa$var$fieldLabel,
                                children: "Client secret"
                            }),
                            credential.hasSecret ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            fontSize: 13.5,
                                            color: '#0f172a',
                                            marginTop: 3
                                        },
                                        children: [
                                            "Set ",
                                            $5d04974d4d9d65fa$var$onDate(credential.secretSetAt)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 12.5,
                                            color: '#64748b',
                                            marginTop: 4,
                                            lineHeight: 1.55
                                        },
                                        children: credential.lastUsedAt ? `Last used ${$5d04974d4d9d65fa$var$onDate(credential.lastUsedAt)}` : 'Never used yet'
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    color: '#b45309',
                                    marginTop: 4
                                },
                                children: "No live secret \u2014 nothing can sign in with this client ID until you generate one."
                            })
                        ]
                    }),
                    stage === 'revealing' && secret && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fffbeb',
                            border: '1.5px solid #fcd34d',
                            borderRadius: 12,
                            padding: '15px 16px',
                            marginBottom: 14
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    marginBottom: 7
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                        size: 16,
                                        color: "#b45309"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontWeight: 700,
                                            fontSize: 14,
                                            color: '#92400e'
                                        },
                                        children: "Copy this now \u2014 it will not be shown again"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    fontSize: 12.5,
                                    color: '#92400e',
                                    lineHeight: 1.55,
                                    margin: '0 0 11px'
                                },
                                children: "This is the only time anyone sees this secret. We store a one-way hash of it, so neither you nor we can read it back \u2014 if it is lost, the only way forward is to generate another one. Keep it somewhere a secret belongs: a password manager or your deployment's secret store, never in source control or an email."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    background: '#fff',
                                    border: '1px solid #fcd34d',
                                    borderRadius: 8,
                                    padding: '11px 12px'
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                    style: {
                                        ...$5d04974d4d9d65fa$var$mono,
                                        display: 'block'
                                    },
                                    children: secret
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    gap: 10,
                                    marginTop: 12,
                                    flexWrap: 'wrap'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5d04974d4d9d65fa$var$CopyButton, {
                                        value: secret,
                                        label: "Copy client secret",
                                        style: {
                                            background: '#b45309',
                                            color: '#fff'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        style: $5d04974d4d9d65fa$var$ghostBtn,
                                        onClick: dismissSecret,
                                        children: "I've saved it"
                                    })
                                ]
                            })
                        ]
                    }),
                    stage === 'confirming' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fef2f2',
                            border: '1.5px solid #fca5a5',
                            borderRadius: 12,
                            padding: '15px 16px',
                            marginBottom: 14
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    marginBottom: 7
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                        size: 16,
                                        color: "#b91c1c"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontWeight: 700,
                                            fontSize: 14,
                                            color: '#991b1b'
                                        },
                                        children: credential?.hasSecret ? 'This will break anything using your current secret' : 'Before you generate'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    fontSize: 12.5,
                                    color: '#991b1b',
                                    lineHeight: 1.6,
                                    margin: 0
                                },
                                children: credential?.hasSecret ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        "Generating a new client secret ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "invalidates the one you have now, immediately"
                                        }),
                                        ". Every system still configured with the old secret will be refused when it next tries to sign in \u2014 so be ready to put the new value into each of them. Access tokens already issued keep working until they expire, and your client ID does not change."
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: "You will be shown the new secret once, and once only. Have somewhere safe to put it before you continue."
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    gap: 10,
                                    marginTop: 13,
                                    flexWrap: 'wrap'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        style: {
                                            ...$5d04974d4d9d65fa$var$primaryBtn,
                                            background: '#b91c1c',
                                            opacity: busy ? 0.7 : 1
                                        },
                                        disabled: busy,
                                        onClick: ()=>void generate(),
                                        children: [
                                            busy ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                size: 14,
                                                className: "animate-spin"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0cdbf97a5c8afc2$export$2e2bcd8739ae039), {
                                                size: 14
                                            }),
                                            busy ? "Generating\u2026" : 'Generate the new secret'
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        style: $5d04974d4d9d65fa$var$ghostBtn,
                                        disabled: busy,
                                        onClick: ()=>setStage('idle'),
                                        children: "Cancel"
                                    })
                                ]
                            })
                        ]
                    }),
                    stage === 'idle' && !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 10,
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                style: $5d04974d4d9d65fa$var$primaryBtn,
                                disabled: busy,
                                onClick: ()=>setStage('confirming'),
                                children: [
                                    credential?.hasSecret ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                        size: 14
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0cdbf97a5c8afc2$export$2e2bcd8739ae039), {
                                        size: 14
                                    }),
                                    credential?.hasSecret ? 'Generate a new client secret' : 'Generate a client secret'
                                ]
                            }),
                            credential?.hasSecret && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                style: $5d04974d4d9d65fa$var$dangerBtn,
                                disabled: busy,
                                onClick: ()=>void revoke(),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                        size: 14
                                    }),
                                    " Revoke"
                                ]
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            marginTop: 12,
                            fontSize: 13,
                            color: '#b91c1c',
                            lineHeight: 1.5
                        },
                        children: error
                    }),
                    notice && !error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            marginTop: 12,
                            fontSize: 13,
                            color: '#047857',
                            lineHeight: 1.5
                        },
                        children: notice
                    })
                ]
            })
        ]
    });
}


/**
 * What a firm sees on the dashboard before they have a client.
 *
 * Sign-up ends at the payment and hands them straight to the portal, which on day one is four zeroes
 * and four empty columns — the product working exactly as designed and looking like nothing happened.
 * So the space the pipeline will occupy carries the three things left to do instead, and gives them
 * back once there is a client to put there.
 *
 * The first client comes FIRST, deliberately. It is what they signed up to do. The firm profile and
 * the team are real work but neither is urgent, and putting either above the client makes the tool
 * feel like admin on the day it should feel useful.
 *
 * The heading counts what is actually left rather than saying "three": an adviser who is not the
 * principal never sees the team step, and a heading that promises three items above a list of two
 * is the kind of small wrongness that makes a person distrust the rest of the screen.
 */ 
parcelRequire("acw62");
const $c317b0c1172678e2$var$wrap = {
    background: '#fff',
    // Written out rather than as the `border` shorthand: the compact panel below overrides only the
    // colour, and React warns (dev overlay) when a shorthand and one of its parts are mixed and the
    // part is later removed on re-render.
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#e2e8f0',
    borderRadius: 16,
    boxShadow: '0 1px 3px rgba(15,23,42,.06)',
    marginBottom: 18,
    overflow: 'hidden'
};
/** The portal's own gradient — the same one behind the avatars and the primary buttons. */ const $c317b0c1172678e2$var$GRADIENT = 'linear-gradient(135deg,#1a6fd4,#17b8e0)';
/*
 * One width for all three buttons.
 *
 * They sit in a column at the right-hand edge of three rows, so different widths read as a ragged
 * edge rather than as three equal choices — and the widest label ("Invite a client") is what the
 * column has to fit anyway. Fixed rather than min-width so the primary action cannot quietly grow
 * wider than the two beside it.
 */ /*
 * Each button names its DESTINATION, and no two of them share a name with anything else on the
 * screen. "Settings" was the obvious label for the firm-profile step and the wrong one: the sidebar
 * already has a Settings button, so the page carried two controls with the same accessible name —
 * ambiguous to a screen reader, and ambiguous to anything else reading the page by its labels.
 */ const $c317b0c1172678e2$var$actionBtn = {
    width: 132,
    textAlign: 'center',
    borderRadius: 8,
    padding: '8px 0',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    flexShrink: 0
};
const $c317b0c1172678e2$var$primaryBtn = {
    ...$c317b0c1172678e2$var$actionBtn,
    background: $c317b0c1172678e2$var$GRADIENT,
    color: '#fff',
    border: 0
};
const $c317b0c1172678e2$var$ghostBtn = {
    ...$c317b0c1172678e2$var$actionBtn,
    background: '#fff',
    color: '#475569',
    border: '1px solid #cbd5e1'
};
function $c317b0c1172678e2$var$Bullet({ done: done, n: n }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        "aria-hidden": "true",
        style: {
            width: 24,
            height: 24,
            borderRadius: '50%',
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 11,
            fontWeight: 700,
            border: done ? '1.5px solid #059669' : '1.5px solid #e2e8f0',
            background: done ? '#e7f6f0' : '#fff',
            color: done ? '#059669' : '#94a3b8'
        },
        children: done ? "\u2713" : n
    });
}
function $c317b0c1172678e2$export$778380418624aa22({ hasClient: hasClient, firmProfileDone: firmProfileDone, isAdviserFirm: isAdviserFirm, isPrincipal: isPrincipal, onInviteClient: onInviteClient, onNewInPerson: onNewInPerson, onOpenSettings: onOpenSettings, dismissed: dismissed, onDismiss: onDismiss }) {
    if (dismissed) return null;
    const steps = [
        {
            key: 'client',
            done: hasClient,
            // "Add", not "Invite": there are two ways to take a client on and the heading should not
            // name only one of them. A client sitting across the desk never gets an invite email.
            title: 'Add your first client',
            detail: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "Invite them to fill in their own details, or",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onNewInPerson,
                        style: {
                            background: 'none',
                            border: 0,
                            padding: 0,
                            font: 'inherit',
                            color: '#1a6fd4',
                            fontWeight: 600,
                            cursor: 'pointer'
                        },
                        children: "start one in person"
                    }),
                    ' ',
                    "and do it together."
                ]
            }),
            action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                style: $c317b0c1172678e2$var$primaryBtn,
                onClick: onInviteClient,
                children: "Invite a client"
            })
        },
        {
            key: 'firm',
            done: firmProfileDone,
            title: isAdviserFirm ? 'Finish your firm profile' : 'Set up your firm profile',
            detail: isAdviserFirm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: "How your advice is provided, and the details that appear on an SOA."
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: "Client reminders, the wording of your emails, and your firm\u2019s documents."
            }),
            action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                style: $c317b0c1172678e2$var$ghostBtn,
                onClick: onOpenSettings,
                children: "Firm profile \u2192"
            })
        },
        ...isPrincipal ? [
            {
                key: 'team',
                // Never "done": a firm of one has nothing to add, and ticking it would claim
                // something untrue. It simply stops being offered once the strip collapses.
                done: false,
                title: 'Add your team',
                detail: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: "Only if you have one. You can do this any time."
                }),
                action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    style: $c317b0c1172678e2$var$ghostBtn,
                    onClick: onOpenSettings,
                    children: "Your team \u2192"
                })
            }
        ] : []
    ];
    const doneCount = steps.filter((s)=>s.done).length;
    // Once there is a client, the job is done and the panel shrinks to a line they can dismiss.
    if (hasClient) {
        const left = steps.filter((s)=>!s.done);
        if (!left.length) return null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                ...$c317b0c1172678e2$var$wrap,
                padding: '10px 14px',
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                background: '#f0f7ff',
                borderColor: '#bfdbfe',
                overflow: 'visible'
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c317b0c1172678e2$var$Bullet, {
                    done: true,
                    n: 1
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    style: {
                        fontSize: 13,
                        color: '#334155'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                            children: [
                                doneCount,
                                " of ",
                                steps.length,
                                " done."
                            ]
                        }),
                        " ",
                        left.map((s)=>s.title).join(" \xb7 ")
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: onDismiss,
                    "aria-label": "Dismiss setup reminders",
                    style: {
                        marginLeft: 'auto',
                        background: 'none',
                        border: 0,
                        color: '#94a3b8',
                        fontSize: 18,
                        lineHeight: 1,
                        cursor: 'pointer',
                        padding: '0 4px'
                    },
                    children: "\xd7"
                })
            ]
        });
    }
    const remaining = steps.length - doneCount;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: $c317b0c1172678e2$var$wrap,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    background: $c317b0c1172678e2$var$GRADIENT,
                    color: '#fff',
                    padding: '16px 20px'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            fontWeight: 700,
                            fontSize: 16
                        },
                        children: [
                            "You\u2019re set up.",
                            ' ',
                            remaining === 1 ? 'One thing left.' : `${remaining} things left.`
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            fontSize: 12.5,
                            margin: '3px 0 0',
                            lineHeight: 1.5,
                            opacity: 0.92
                        },
                        children: "This disappears once you have your first client."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: '4px 20px 14px'
                },
                children: steps.map((s, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12,
                            padding: '13px 0',
                            borderTop: i === 0 ? 0 : '1px solid #f1f5f9'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c317b0c1172678e2$var$Bullet, {
                                done: s.done,
                                n: i + 1
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    flex: 1,
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontWeight: 600,
                                            fontSize: 14,
                                            color: '#0f172a'
                                        },
                                        children: s.title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 12.5,
                                            color: '#64748b',
                                            lineHeight: 1.45
                                        },
                                        children: s.detail
                                    })
                                ]
                            }),
                            s.action
                        ]
                    }, s.key))
            })
        ]
    });
}


/**
 * The two per-client actions a firm with a team needs: hand this client to another adviser, and
 * decide who can see them.
 *
 * They live behind a ⋯ on the client row because the Actions column already has two buttons and
 * neither of these is an everyday one. And the ⋯ appears only when there is something inside it —
 * each item has its own condition, not a shared "has a team" one:
 *
 *   Reassign      — only once somebody else can hold clients. With nobody to reassign TO it is a
 *                   dead menu item.
 *   Who can see   — only once the firm has support. Advisers already see just their own clients and
 *                   the principal always sees everything, so with no support there is nobody the
 *                   switch could exclude.
 *
 * So a sole practitioner gets the Actions column exactly as it is today, and two advisers with no
 * support get Reassign and nothing else.
 *
 * It is deliberately NOT called "access". The row already has an Access Mode column meaning
 * something completely different — how far the CLIENT gets on their own. Two "access" controls on
 * one row, meaning opposite things, is a support call waiting to happen.
 */ 

var $acw62 = parcelRequire("acw62");

const $f095723d2f4d5109$var$menuStyle = {
    position: 'absolute',
    right: 0,
    top: '100%',
    zIndex: 40,
    minWidth: 230,
    background: '#fff',
    border: '1px solid #e2e8f0',
    borderRadius: 10,
    boxShadow: '0 8px 28px -8px rgba(15,23,42,.28)',
    padding: 6,
    marginTop: 4
};
const $f095723d2f4d5109$var$itemStyle = {
    display: 'block',
    width: '100%',
    textAlign: 'left',
    background: 'none',
    border: 0,
    borderRadius: 6,
    padding: '9px 11px',
    fontSize: 13,
    color: '#334155',
    cursor: 'pointer'
};
const $f095723d2f4d5109$var$dialogWrap = {
    position: 'fixed',
    inset: 0,
    zIndex: 60,
    background: 'rgba(15,23,42,.45)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20
};
const $f095723d2f4d5109$var$dialog = {
    background: '#fff',
    borderRadius: 16,
    maxWidth: 440,
    width: '100%',
    padding: 22,
    maxHeight: 'calc(100vh - 48px)',
    overflowY: 'auto'
};
const $f095723d2f4d5109$var$primaryBtn = {
    background: '#1a6fd4',
    color: '#fff',
    border: 0,
    borderRadius: 8,
    padding: '9px 16px',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer'
};
const $f095723d2f4d5109$var$ghostBtn = {
    background: '#fff',
    color: '#475569',
    border: '1px solid #cbd5e1',
    borderRadius: 8,
    padding: '8px 14px',
    fontSize: 13.5,
    fontWeight: 600,
    cursor: 'pointer'
};
/** The rows' shared read of the firm's roster: one request per firm, reused for half a minute. */ const $f095723d2f4d5109$var$ROSTER_REUSE_MS = 30000;
const $f095723d2f4d5109$var$rosterReads = new Map();
function $f095723d2f4d5109$export$3dfa4f817a52f176(tenantId, now = Date.now()) {
    const hit = $f095723d2f4d5109$var$rosterReads.get(tenantId);
    if (hit && now - hit.at < $f095723d2f4d5109$var$ROSTER_REUSE_MS) return hit.members;
    const members = (0, $442533e192804693$export$f1d37579424c00c1)(tenantId);
    $f095723d2f4d5109$var$rosterReads.set(tenantId, {
        at: now,
        members: members
    });
    // A failed read is not reused.
    members.catch(()=>{
        if ($f095723d2f4d5109$var$rosterReads.get(tenantId)?.members === members) $f095723d2f4d5109$var$rosterReads.delete(tenantId);
    });
    return members;
}
function $f095723d2f4d5109$export$96a4931031b5caa0({ profileId: profileId, clientName: clientName, adviserUserId: adviserUserId, visibility: visibility, tenantId: tenantId, myUserId: myUserId, isPrincipal: isPrincipal, onChanged: onChanged }) {
    const [members, setMembers] = (0, $acw62.useState)(null);
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [dialogKind, setDialogKind] = (0, $acw62.useState)(null);
    const [choice, setChoice] = (0, $acw62.useState)('');
    const [note, setNote] = (0, $acw62.useState)('');
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    // One roster read shared by every row (26 Oct 2026: a dashboard of 24 clients sent 25 identical reads),
    // still self-contained rather than threaded through the whole portal for a menu most firms never open.
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (async ()=>{
            try {
                const list = await $f095723d2f4d5109$export$3dfa4f817a52f176(tenantId);
                if (!cancelled) setMembers(list);
            } catch  {
            // A roster we cannot read means no menu, which is the honest outcome — better than a
            // menu whose actions would fail.
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        tenantId
    ]);
    if (!members) return null;
    const holders = members.filter((m)=>(m.role === 'owner' || m.role === 'adviser') && m.status === 'active');
    const hasSupport = members.some((m)=>m.role === 'staff' && m.status === 'active');
    const mine = adviserUserId === myUserId;
    // Only the principal or the responsible adviser may do either of these — the server enforces it,
    // and offering a button that always fails is worse than not offering it.
    const mayAct = isPrincipal || mine;
    const canReassign = mayAct && holders.length > 1;
    const canSetVisibility = mayAct && hasSupport;
    if (!canReassign && !canSetVisibility) return null;
    const close = ()=>{
        setDialogKind(null);
        setError(null);
        setBusy(false);
    };
    const submit = async ()=>{
        setBusy(true);
        setError(null);
        const res = dialogKind === 'reassign' ? await (0, $442533e192804693$export$285f02a91c28b3ab)(profileId, choice) : await (0, $442533e192804693$export$868da79368f9e4d0)(profileId, choice === 'restricted' ? 'restricted' : 'firm', note.trim() || null);
        setBusy(false);
        if (!res.ok) {
            setError(res.message ?? 'That did not work.');
            return;
        }
        close();
        onChanged?.();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        style: {
            position: 'relative',
            display: 'inline-block'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: "ab",
                "aria-label": `More actions for ${clientName}`,
                "aria-expanded": open,
                onClick: ()=>setOpen((v)=>!v),
                children: "\u22EF"
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        role: "presentation",
                        onClick: ()=>setOpen(false),
                        style: {
                            position: 'fixed',
                            inset: 0,
                            zIndex: 30
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        style: $f095723d2f4d5109$var$menuStyle,
                        children: [
                            canReassign && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                style: $f095723d2f4d5109$var$itemStyle,
                                onClick: ()=>{
                                    setOpen(false);
                                    setChoice(adviserUserId ?? '');
                                    setDialogKind('reassign');
                                },
                                children: "Reassign to another adviser\u2026"
                            }),
                            canSetVisibility && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                style: $f095723d2f4d5109$var$itemStyle,
                                onClick: ()=>{
                                    setOpen(false);
                                    setChoice(visibility);
                                    setNote('');
                                    setDialogKind('visibility');
                                },
                                children: "Who can see this\u2026"
                            })
                        ]
                    })
                ]
            }),
            dialogKind && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: $f095723d2f4d5109$var$dialogWrap,
                role: "presentation",
                onClick: (e)=>e.target === e.currentTarget && close(),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    style: $f095723d2f4d5109$var$dialog,
                    role: "dialog",
                    "aria-modal": "true",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                fontWeight: 700,
                                fontSize: 16,
                                color: '#0f172a',
                                marginBottom: 3
                            },
                            children: dialogKind === 'reassign' ? 'Reassign this client' : 'Who can see this file?'
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            style: {
                                fontSize: 13,
                                color: '#64748b',
                                margin: '0 0 14px'
                            },
                            children: clientName
                        }),
                        dialogKind === 'reassign' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        display: 'grid',
                                        gap: 8
                                    },
                                    children: holders.map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>setChoice(m.userId),
                                            style: {
                                                textAlign: 'left',
                                                cursor: 'pointer',
                                                background: choice === m.userId ? '#f0f7ff' : '#fff',
                                                border: choice === m.userId ? '2px solid #1a6fd4' : '1px solid #e2e8f0',
                                                borderRadius: 10,
                                                padding: choice === m.userId ? 10 : 11
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    style: {
                                                        fontWeight: 600,
                                                        fontSize: 13.5,
                                                        color: '#0f172a'
                                                    },
                                                    children: [
                                                        m.email,
                                                        m.userId === adviserUserId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            style: {
                                                                marginLeft: 6,
                                                                fontSize: 11,
                                                                fontWeight: 500,
                                                                color: '#64748b'
                                                            },
                                                            children: "holds it now"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    style: {
                                                        fontSize: 12,
                                                        color: '#64748b'
                                                    },
                                                    children: [
                                                        m.role === 'owner' ? 'Principal' : 'Adviser',
                                                        " \xb7 ",
                                                        m.clientCount,
                                                        " on their book"
                                                    ]
                                                })
                                            ]
                                        }, m.userId))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    style: {
                                        fontSize: 12,
                                        color: '#64748b',
                                        margin: '10px 0 0',
                                        lineHeight: 1.5
                                    },
                                    children: "Nobody is charged again \u2014 this client was taken on once, and moving them between advisers in your firm is not a second client."
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        display: 'grid',
                                        gap: 8
                                    },
                                    children: [
                                        {
                                            value: 'firm',
                                            title: 'Everyone in the practice',
                                            detail: "The default \u2014 support can help with this client."
                                        },
                                        {
                                            value: 'restricted',
                                            title: 'The responsible adviser and the principal only',
                                            detail: 'Support will not see this client at all.'
                                        }
                                    ].map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>setChoice(opt.value),
                                            style: {
                                                textAlign: 'left',
                                                cursor: 'pointer',
                                                background: choice === opt.value ? '#f0f7ff' : '#fff',
                                                border: choice === opt.value ? '2px solid #1a6fd4' : '1px solid #e2e8f0',
                                                borderRadius: 10,
                                                padding: choice === opt.value ? 10 : 11
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontWeight: 600,
                                                        fontSize: 13.5,
                                                        color: '#0f172a'
                                                    },
                                                    children: opt.title
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: 12,
                                                        color: '#64748b'
                                                    },
                                                    children: opt.detail
                                                })
                                            ]
                                        }, opt.value))
                                }),
                                choice === 'restricted' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        marginTop: 12
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            htmlFor: "visibility-note",
                                            style: {
                                                fontSize: 10.5,
                                                fontWeight: 700,
                                                letterSpacing: '.07em',
                                                textTransform: 'uppercase',
                                                color: '#64748b',
                                                display: 'block',
                                                marginBottom: 6
                                            },
                                            children: "Why \u2014 optional, seen by the principal"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            id: "visibility-note",
                                            style: {
                                                width: '100%',
                                                border: '1px solid #cbd5e1',
                                                borderRadius: 8,
                                                padding: '9px 11px',
                                                fontSize: 14
                                            },
                                            value: note,
                                            onChange: (e)=>setNote(e.target.value),
                                            placeholder: "e.g. a colleague's family"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    style: {
                                        fontSize: 12,
                                        color: '#64748b',
                                        margin: '10px 0 0',
                                        lineHeight: 1.5
                                    },
                                    children: "This is forward-looking. Restricting a file somebody has already read does not unread it \u2014 for the cases you can see coming, set it when the file is created."
                                })
                            ]
                        }),
                        error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                marginTop: 12,
                                background: '#fef2f2',
                                border: '1px solid #fecaca',
                                color: '#b91c1c',
                                borderRadius: 8,
                                padding: '9px 12px',
                                fontSize: 13
                            },
                            children: error
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: 9,
                                marginTop: 18
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    style: $f095723d2f4d5109$var$ghostBtn,
                                    onClick: close,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    style: $f095723d2f4d5109$var$primaryBtn,
                                    disabled: busy || !choice,
                                    onClick: ()=>void submit(),
                                    children: busy ? "Saving\u2026" : 'Save'
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


/**
 * The client list as CSV — exactly the rows and columns on screen.
 *
 * The portal's "Export" button did nothing at all: it rendered, it looked live, and clicking it had
 * no effect. This builds the file in the browser from data already loaded, so nothing is sent
 * anywhere, and it honours the current search and filters — what you export is what you were
 * looking at.
 *
 * Workflow data only (who, what stage, how far through, when last active). A client's financial
 * position is deliberately not here: this is the list an adviser wants for chasing work, and the
 * fact-find is encrypted per client precisely so it doesn't leak into places like this.
 */ const $0313edef17a9cde3$export$71ad7a5d8098b55 = [
    'Client',
    'Type',
    'Profile status',
    'Profile %',
    'Steps done',
    'SOA status',
    'Last activity',
    'Access mode'
];
/** Quote every field and double any embedded quote — a client name containing a comma would
 *  otherwise split itself across two columns. */ function $0313edef17a9cde3$var$csvCell(value) {
    const text = value == null ? '' : String(value);
    return `"${text.replace(/"/g, '""')}"`;
}
function $0313edef17a9cde3$var$profilePercent(c) {
    if (c.profileProgressPct == null) return '';
    return `${c.profileProgressIsEstimated ? '~' : ''}${c.profileProgressPct}%`;
}
function $0313edef17a9cde3$var$stepsDone(c) {
    if (c.profileCompletedSteps == null || c.profileTotalSteps == null) return '';
    return `${c.profileCompletedSteps} of ${c.profileTotalSteps}`;
}
/** Same test the table's Type column uses: the fact-find where it's loaded, else the display name
 *  (a couple's file is titled "Tom & Robyn Smith"). */ function $0313edef17a9cde3$var$isCouple(c) {
    return c.factFind?.adviceFor === 'couple' || Boolean(c.clientName && c.clientName.includes('&'));
}
function $0313edef17a9cde3$var$soaStatusLabel(c) {
    if (c.soaStatus === 'published') return 'Published';
    if (c.soaStatus === 'draft') return 'Draft';
    return 'None';
}
function $0313edef17a9cde3$export$500b0d7e9d04562f(c, profileStatusLabel) {
    return [
        c.clientName,
        $0313edef17a9cde3$var$isCouple(c) ? 'Couple' : 'Single',
        profileStatusLabel,
        $0313edef17a9cde3$var$profilePercent(c),
        $0313edef17a9cde3$var$stepsDone(c),
        $0313edef17a9cde3$var$soaStatusLabel(c),
        c.lastActivityAt ? new Date(c.lastActivityAt).toLocaleDateString('en-AU') : '',
        c.accessMode === 'in_person' ? 'In-person' : 'Invited'
    ];
}
function $0313edef17a9cde3$export$4c0967f92bf03ce8(cases, profileStatusLabel) {
    const rows = cases.map((c)=>$0313edef17a9cde3$export$500b0d7e9d04562f(c, profileStatusLabel(c)));
    return [
        [
            ...$0313edef17a9cde3$export$71ad7a5d8098b55
        ],
        ...rows
    ].map((row)=>row.map($0313edef17a9cde3$var$csvCell).join(',')).join('\r\n');
}
function $0313edef17a9cde3$export$8ad5f403dfeb9e5b(csv, filename) {
    // A UTF-8 byte-order mark, so Excel opens the file as UTF-8 — without it, an accented name
    // comes out mangled.
    const blob = new Blob([
        "\uFEFF",
        csv
    ], {
        type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
}


/**
 * What has actually happened across an adviser's clients, newest first.
 *
 * The portal's sidebar had an "Activity Feed" item that opened the Dashboard — a link to a screen
 * that didn't exist. This builds the real thing out of data the client list already carries, so it
 * costs no extra requests: every event below is a timestamp the server derives from unencrypted
 * metadata (invites, saved models, SOAs, fact-find completion).
 *
 * KNOWN LIMITATION, deliberately visible rather than hidden: the client list carries only the LATEST
 * timestamp of each kind per client (`latestSoaAt`, `latestModelAt`, …), not a full history. So a
 * client who has had three SOAs generated contributes one "SOA generated" event, not three. That is
 * honest for "what needs my attention lately", which is what this screen is for; it is NOT an audit
 * trail. The real audit trail is the server's hash-chained audit_events table.
 */ const $397d0cafc1acbe4a$export$f88b35d024b1908 = {
    invite_sent: {
        label: 'Invite sent',
        actor: 'firm',
        colour: '#3b82f6'
    },
    client_started: {
        label: 'Client opened their invite',
        actor: 'client',
        colour: '#f59e0b'
    },
    profile_completed: {
        label: 'Profile completed',
        actor: 'client',
        colour: '#10b981'
    },
    modelling_saved: {
        label: 'Modelling saved',
        actor: 'firm',
        colour: '#8b5cf6'
    },
    soa_generated: {
        label: 'SOA generated',
        actor: 'firm',
        colour: '#6366f1'
    },
    soa_published: {
        label: 'SOA sent to client',
        actor: 'firm',
        colour: '#059669'
    }
};
/** The workflow timestamps a case can contribute, in the order they'd naturally occur. */ const $397d0cafc1acbe4a$var$SOURCES = [
    {
        kind: 'invite_sent',
        pick: (c)=>c.workflow?.inviteSentAt
    },
    {
        kind: 'client_started',
        pick: (c)=>c.workflow?.inviteAcceptedAt
    },
    {
        kind: 'profile_completed',
        pick: (c)=>c.workflow?.completedAt
    },
    {
        kind: 'modelling_saved',
        pick: (c)=>c.workflow?.latestModelAt
    },
    {
        kind: 'soa_generated',
        pick: (c)=>c.workflow?.latestSoaAt
    },
    {
        kind: 'soa_published',
        pick: (c)=>c.workflow?.latestPublishedAt
    }
];
function $397d0cafc1acbe4a$export$17ab98d78f084ac8(cases, limit = 50) {
    const events = [];
    for (const c of cases)for (const source of $397d0cafc1acbe4a$var$SOURCES){
        const at = source.pick(c);
        if (!at) continue;
        const presentation = $397d0cafc1acbe4a$export$f88b35d024b1908[source.kind];
        events.push({
            caseId: c.id,
            clientName: c.clientName,
            kind: source.kind,
            at: at,
            actor: presentation.actor,
            label: presentation.label
        });
    }
    return events.sort((a, b)=>new Date(b.at).getTime() - new Date(a.at).getTime()).slice(0, limit);
}



parcelRequire("acw62");

const $d5b7fd8298af6838$var$AnimatedBackground = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "absolute inset-0 overflow-hidden pointer-events-none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute inset-0 opacity-20",
                style: {
                    backgroundImage: `url(${(0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1559827260-dc66d52bef19', 1920, 1080)})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    animation: 'gentle-waves 20s ease-in-out infinite'
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute inset-0 opacity-15",
                style: {
                    backgroundImage: `url(${(0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1506905925346-21bda4d32df4', 1920, 1080)})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    animation: 'moving-clouds 25s ease-in-out infinite'
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute inset-0 bg-white opacity-5"
            })
        ]
    });
};
var $d5b7fd8298af6838$export$2e2bcd8739ae039 = $d5b7fd8298af6838$var$AnimatedBackground;


/** How each follow-up kind presents: what it is, its chip, and the action that clears it. */ const $3bd107510f74a4b4$var$FOLLOWUP_PRESENTATION = {
    invite_outstanding: {
        detail: 'Invite outstanding',
        chip: 'Not Started',
        chipCls: 'tag t-st',
        action: 'Send Reminder'
    },
    client_stalled: {
        detail: 'Part-way through their profile',
        chip: 'Stalled',
        chipCls: 'tag t-pr',
        action: 'Send Reminder'
    },
    awaiting_modelling: {
        detail: "Profile complete \u2014 nothing modelled yet",
        chip: 'Needs Modelling',
        chipCls: 'tag t-ok',
        action: "Open Model \u2192"
    },
    soa_unsent: {
        detail: 'SOA drafted but never sent',
        chip: 'SOA Unsent',
        chipCls: 'tag',
        action: "Review & Send \u2192"
    }
};
/**
 * Is this intake form complete enough to submit?
 *
 * Neither modal validated anything. On the invite path that mattered: with a blank email the case
 * creator substituted a placeholder address (`invite.<timestamp>@demo.local`), so the adviser got a
 * client file, a consumed billing seat, and an invite link bound to an address nobody owns — and
 * accepting an invite verifies the signed-in user against the invited address, so that link could
 * never be redeemed. A dead invite that costs a seat is worse than a refused one.
 *
 * The email test is deliberately loose: it rejects a blank or obviously-not-an-address entry and
 * leaves real deliverability to the mail server. Over-strict address validation rejects valid
 * addresses, which is a worse failure than accepting a typo.
 */ function $3bd107510f74a4b4$var$isIntakeReady(firstName, email, requireEmail) {
    if (!firstName.trim()) return false;
    if (!requireEmail) return true;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}
function $3bd107510f74a4b4$var$progressLabel(c) {
    const pct = c.profileProgressPct || 0;
    const steps = c.profileCompletedSteps;
    const total = c.profileTotalSteps;
    if (typeof steps === 'number' && typeof total === 'number' && total > 0) return `${steps} of ${total} steps \xb7 ${pct}%`;
    return c.profileProgressIsEstimated ? `~${pct}% complete (not yet measured)` : `${pct}% complete`;
}
const $3bd107510f74a4b4$var$V = {
    advDash: 'V-adv-dash',
    advFollow: 'V-adv-followups',
    advSoas: 'V-adv-soas',
    advSettings: 'V-adv-settings',
    advAnalytics: 'V-adv-analytics',
    advActivity: 'V-adv-activity',
    pracDash: 'V-prac-dash',
    pracClients: 'V-prac-clients',
    pracFollow: 'V-prac-followups',
    pracSettings: 'V-prac-settings',
    licDash: 'V-lic-dash',
    licAdvisers: 'V-lic-advisers',
    licBilling: 'V-lic-billing'
};
function $3bd107510f74a4b4$var$NavIcon({ name: name }) {
    const s = {
        width: 15,
        height: 15,
        stroke: 'currentColor',
        fill: 'none',
        strokeWidth: 2,
        flexShrink: 0
    };
    switch(name){
        case 'grid':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                style: s,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        x: "3",
                        y: "3",
                        width: "7",
                        height: "7",
                        rx: "1"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        x: "14",
                        y: "3",
                        width: "7",
                        height: "7",
                        rx: "1"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        x: "3",
                        y: "14",
                        width: "7",
                        height: "7",
                        rx: "1"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        x: "14",
                        y: "14",
                        width: "7",
                        height: "7",
                        rx: "1"
                    })
                ]
            });
        case 'users':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                style: s,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: "9",
                        cy: "7",
                        r: "4"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"
                    })
                ]
            });
        case 'file':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                style: s,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
                        points: "14 2 14 8 20 8"
                    })
                ]
            });
        case 'bell':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                style: s,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M13.73 21a2 2 0 01-3.46 0"
                    })
                ]
            });
        case 'activity':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                viewBox: "0 0 24 24",
                style: s,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
                    points: "22 12 18 12 15 21 9 3 6 12 2 12"
                })
            });
        case 'settings':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                style: s,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: "12",
                        cy: "12",
                        r: "3"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"
                    })
                ]
            });
        case 'card':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                style: s,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        x: "1",
                        y: "4",
                        width: "22",
                        height: "16",
                        rx: "2"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                        x1: "1",
                        y1: "10",
                        x2: "23",
                        y2: "10"
                    })
                ]
            });
        default:
            return null;
    }
}
function $3bd107510f74a4b4$var$daysSinceIso(iso) {
    if (!iso) return null;
    const t = new Date(iso).getTime();
    if (Number.isNaN(t)) return null;
    return Math.floor((Date.now() - t) / 86400000);
}
function $3bd107510f74a4b4$var$formatShortDate(value) {
    if (!value) return "\u2014";
    return new Date(value).toLocaleString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    });
}
/** Prefer submission date; fall back to last activity so pipeline never shows a bare "—" when activity exists. */ function $3bd107510f74a4b4$var$formatSubmittedLabel(c) {
    return $3bd107510f74a4b4$var$formatShortDate(c.submissionDate || c.lastActivityAt);
}
function $3bd107510f74a4b4$var$formatLastActivityDisplay(iso) {
    if (!iso) return "\u2014";
    const d = $3bd107510f74a4b4$var$daysSinceIso(iso);
    const dateStr = new Date(iso).toLocaleString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    });
    if (d === 0) return `${dateStr} \xb7 Today`;
    if (d === 1) return `${dateStr} \xb7 Yesterday`;
    return `${dateStr} \xb7 ${d} days ago`;
}
function $3bd107510f74a4b4$var$caseMatchesProfileFilter(c, f) {
    if (f === 'all') return true;
    // 'draft' folded in for the same reason the pipeline column went: no intake path produces it,
    // but demo cases still carry it, and a filter must not make a case disappear entirely.
    if (f === 'invited') return c.status === 'invited' || c.status === 'draft';
    if (f === 'started') return c.status === 'started';
    if (f === 'complete') return [
        'submitted',
        'adviser_review',
        'soa_draft',
        'soa_published'
    ].includes(c.status);
    return true;
}
function $3bd107510f74a4b4$var$caseMatchesActivityFilter(c, f) {
    if (f === 'all') return true;
    const d = $3bd107510f74a4b4$var$daysSinceIso(c.lastActivityAt);
    if (d == null) return false;
    if (f === 'today') return d === 0;
    if (f === 'week') return d <= 7;
    if (f === 'month') return d <= 30;
    if (f === 'older') return d > 30;
    return true;
}
function $3bd107510f74a4b4$var$accessModeLabel(mode) {
    if (mode === 'client_stop_dashboard') return 'Adviser-led';
    if (mode === 'client_end_to_end') return 'Self-serve';
    return 'In-person';
}
function $3bd107510f74a4b4$var$accessModeClass(mode) {
    if (mode === 'client_stop_dashboard' || mode === 'in_person') return 'mtag mt-adv';
    return 'mtag mt-self';
}
function $3bd107510f74a4b4$var$profileTag(caseRow) {
    const { status: status, profileProgressPct: profileProgressPct } = caseRow;
    if (status === 'draft') return {
        cls: 'tag t-dr',
        label: 'Not invited'
    };
    if (status === 'invited') return {
        cls: 'tag t-sn',
        label: 'Invite sent'
    };
    if (status === 'started') {
        const estimated = caseRow.profileProgressIsEstimated ? '~' : '';
        return {
            cls: 'tag t-pr',
            label: `\u{25CF} In Progress ${estimated}${profileProgressPct || 0}%`
        };
    }
    if ([
        'submitted',
        'adviser_review',
        'soa_draft',
        'soa_published'
    ].includes(status)) return {
        cls: 'tag t-ok',
        label: "\u25CF Complete"
    };
    return {
        cls: 'tag t-dr',
        label: status
    };
}
function $3bd107510f74a4b4$var$soaTag(caseRow) {
    if (caseRow.soaStatus === 'published') return {
        cls: 'tag t-ok',
        label: "\u25CF Published"
    };
    if (caseRow.soaStatus === 'draft') return {
        cls: 'tag',
        style: {
            background: '#fef9c3',
            color: '#854d0e'
        },
        label: "\u25CF Draft \u2014 unsent"
    };
    return {
        cls: 'tag',
        style: {
            background: '#f1f5f9',
            color: '#64748b'
        },
        label: "\u2014 No SOA yet"
    };
}
/** Review (adviser SOA workflow) only when there is something to review in the portal. */ function $3bd107510f74a4b4$var$hasReviewableSoa(caseRow) {
    return caseRow.soaStatus === 'draft' || caseRow.soaStatus === 'published';
}
const $3bd107510f74a4b4$var$PORTAL_CFG = {
    relationship_owner: {
        key: 'adv',
        lvlLabel: 'Adviser View',
        lvlCls: 'lv-adv',
        ctxName: 'Joncarl La Rosa',
        ctxSub: "CFP \xb7 La Rosa & Partners",
        avaInit: 'JL',
        avaColor: 'linear-gradient(135deg,#1a6fd4,#17b8e0)',
        uname: 'Joncarl La Rosa',
        urole: "Financial Adviser \xb7 CFP",
        tabs: [
            {
                id: $3bd107510f74a4b4$var$V.advDash,
                label: 'Dashboard'
            },
            {
                id: $3bd107510f74a4b4$var$V.advFollow,
                label: 'Follow-ups',
                badge: null
            },
            {
                id: $3bd107510f74a4b4$var$V.advSoas,
                label: 'Reports & SOAs'
            },
            {
                id: $3bd107510f74a4b4$var$V.advSettings,
                label: 'Settings'
            },
            {
                id: $3bd107510f74a4b4$var$V.advAnalytics,
                label: 'Analytics'
            }
        ],
        nav: [
            {
                sect: 'My Workspace'
            },
            {
                id: $3bd107510f74a4b4$var$V.advDash,
                icon: 'grid',
                label: 'Dashboard'
            },
            {
                id: $3bd107510f74a4b4$var$V.advDash,
                icon: 'users',
                label: 'My Clients',
                badgeKey: 'clients'
            },
            {
                id: $3bd107510f74a4b4$var$V.advSoas,
                icon: 'file',
                label: 'Reports & SOAs'
            },
            {
                sect: 'Actions'
            },
            {
                id: $3bd107510f74a4b4$var$V.advFollow,
                icon: 'bell',
                label: 'Follow-ups',
                badgeKey: 'followups',
                badgeCls: 'am'
            },
            {
                id: $3bd107510f74a4b4$var$V.advActivity,
                icon: 'activity',
                label: 'Activity Feed'
            },
            {
                sect: 'Profile'
            },
            {
                id: $3bd107510f74a4b4$var$V.advSettings,
                icon: 'settings',
                label: 'Settings'
            },
            {
                id: $3bd107510f74a4b4$var$V.advAnalytics,
                icon: 'activity',
                label: 'Analytics'
            }
        ],
        topInvite: true,
        topInPerson: true
    },
    practice_owner: {
        key: 'prac',
        lvlLabel: 'Practice View',
        lvlCls: 'lv-prac',
        ctxName: 'La Rosa & Partners',
        ctxSub: "AFSL 482910 \xb7 Sydney",
        avaInit: 'LR',
        avaColor: 'linear-gradient(135deg,#1a6fd4,#17b8e0)',
        uname: 'Practice Admin',
        urole: 'Firm Administrator',
        tabs: [
            {
                id: $3bd107510f74a4b4$var$V.pracDash,
                label: 'Dashboard'
            },
            {
                id: $3bd107510f74a4b4$var$V.pracClients,
                label: 'All Clients'
            },
            {
                id: $3bd107510f74a4b4$var$V.pracFollow,
                label: 'Follow-ups',
                badge: null
            },
            {
                id: $3bd107510f74a4b4$var$V.pracSettings,
                label: 'Settings'
            }
        ],
        nav: [
            {
                sect: 'Overview'
            },
            {
                id: $3bd107510f74a4b4$var$V.pracDash,
                icon: 'grid',
                label: 'Dashboard'
            },
            {
                id: $3bd107510f74a4b4$var$V.pracClients,
                icon: 'users',
                label: 'All Clients',
                badgeKey: 'clients'
            },
            {
                sect: 'Actions'
            },
            {
                id: $3bd107510f74a4b4$var$V.pracFollow,
                icon: 'bell',
                label: 'Follow-ups',
                badgeKey: 'followups',
                badgeCls: 'am'
            },
            {
                id: $3bd107510f74a4b4$var$V.pracDash,
                icon: 'activity',
                label: 'Activity Feed'
            },
            {
                sect: 'Practice'
            },
            {
                id: $3bd107510f74a4b4$var$V.pracSettings,
                icon: 'settings',
                label: 'Settings'
            },
            {
                id: $3bd107510f74a4b4$var$V.pracSettings,
                icon: 'card',
                label: 'Billing'
            }
        ],
        topInvite: true,
        topInPerson: true,
        topPracticeExtras: true
    },
    licensee: {
        key: 'lic',
        lvlLabel: 'Licensee View',
        lvlCls: 'lv-lic',
        ctxName: 'Demo Licensee Group',
        ctxSub: "AFSL Group \xb7 multiple practices",
        avaInit: 'LG',
        avaColor: 'linear-gradient(135deg,#7c3aed,#a78bfa)',
        uname: 'Licensee Admin',
        urole: 'AFSL Group Administrator',
        tabs: [
            {
                id: $3bd107510f74a4b4$var$V.licDash,
                label: 'All Practices'
            },
            {
                id: $3bd107510f74a4b4$var$V.licAdvisers,
                label: 'All Advisers'
            },
            {
                id: $3bd107510f74a4b4$var$V.licBilling,
                label: 'Billing'
            }
        ],
        nav: [
            {
                sect: 'Overview'
            },
            {
                id: $3bd107510f74a4b4$var$V.licDash,
                icon: 'grid',
                label: 'All Practices',
                badgeKey: 'practices',
                badgeCls: 'pu'
            },
            {
                id: $3bd107510f74a4b4$var$V.licAdvisers,
                icon: 'users',
                label: 'All Advisers',
                badgeKey: 'advisers'
            },
            {
                sect: 'Management'
            },
            {
                id: $3bd107510f74a4b4$var$V.licBilling,
                icon: 'card',
                label: 'Billing & Plans'
            },
            {
                id: $3bd107510f74a4b4$var$V.licDash,
                icon: 'activity',
                label: 'Platform Analytics'
            },
            {
                sect: 'Admin'
            },
            {
                id: $3bd107510f74a4b4$var$V.licDash,
                icon: 'settings',
                label: 'Licensee Settings'
            }
        ],
        topInvite: false,
        topInPerson: false,
        topLicensee: true
    }
};
const $3bd107510f74a4b4$var$VIEW_TITLES = {
    [$3bd107510f74a4b4$var$V.advDash]: 'My Dashboard',
    [$3bd107510f74a4b4$var$V.advFollow]: 'Follow-ups',
    [$3bd107510f74a4b4$var$V.advSoas]: 'Reports & SOAs',
    [$3bd107510f74a4b4$var$V.advSettings]: 'Settings',
    [$3bd107510f74a4b4$var$V.advAnalytics]: 'Analytics',
    [$3bd107510f74a4b4$var$V.pracDash]: 'Practice Dashboard',
    [$3bd107510f74a4b4$var$V.pracClients]: 'All Clients',
    [$3bd107510f74a4b4$var$V.pracFollow]: 'Follow-up Centre',
    [$3bd107510f74a4b4$var$V.pracSettings]: 'Practice Settings',
    [$3bd107510f74a4b4$var$V.licDash]: 'All Practices',
    [$3bd107510f74a4b4$var$V.licBilling]: 'Billing & Subscriptions',
    [$3bd107510f74a4b4$var$V.licAdvisers]: 'All Advisers'
};
function $3bd107510f74a4b4$var$PipelineCard({ title: title, subtitle: subtitle, children: children, highlight: highlight }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `cc${highlight ? ' hi' : ''}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ccn",
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ccm",
                children: subtitle
            }),
            children
        ]
    });
}
/** Real-mode Settings billing card: current plan, client usage, and the owner's billing actions. */ function $3bd107510f74a4b4$var$BillingCard({ summary: summary, onManage: onManage, onUpgrade: onUpgrade, onBuyClient: onBuyClient }) {
    const { mode: mode, used: used, remaining: remaining, includedBase: includedBase } = summary || {};
    const planLabel = mode === 'annual' ? 'Annual plan' : mode === 'payg' ? 'Pay per client' : mode === 'comp' ? 'Free access' : 'No plan';
    const planPrice = mode === 'annual' ? '$800 + GST / year' : mode === 'payg' ? '$336 + GST per client' : mode === 'comp' ? 'Complimentary' : '';
    const btn = {
        base: {
            border: 'none',
            borderRadius: 10,
            padding: '9px 14px',
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer'
        },
        primary: {
            background: 'linear-gradient(90deg,#1a6fd4,#17b8e0)',
            color: '#fff'
        },
        outline: {
            background: '#fff',
            color: '#1a6fd4',
            border: '2px solid #1a6fd4'
        },
        ghost: {
            background: '#f1f5f9',
            color: '#475569'
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            marginTop: 14,
            background: '#fff',
            border: '1px solid #e2e8f0',
            borderRadius: 16,
            padding: 24,
            boxShadow: '0 1px 3px rgba(15,23,42,.06)'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 12,
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    letterSpacing: '.04em',
                    color: '#94a3b8',
                    marginBottom: 12
                },
                children: "Billing"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'baseline',
                    gap: 16
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontWeight: 700,
                            fontSize: 16,
                            color: '#0f172a'
                        },
                        children: planLabel
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 13.5,
                            color: '#64748b',
                            fontWeight: 600
                        },
                        children: planPrice
                    })
                ]
            }),
            mode !== 'comp' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginTop: 6,
                    fontSize: 13.5,
                    color: '#475569'
                },
                children: [
                    used,
                    " client",
                    used === 1 ? '' : 's',
                    " taken on",
                    mode === 'annual' ? ` \xb7 ${includedBase} included${(remaining ?? 0) > 0 ? `, ${remaining} left before the $70 per-client fee` : " \u2014 extra clients are $70 + GST each"}` : remaining == null ? '' : ` \xb7 ${remaining} paid client${remaining === 1 ? '' : 's'} remaining`
                ]
            }),
            mode === 'comp' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    marginTop: 6,
                    fontSize: 13.5,
                    color: '#475569'
                },
                children: "Your firm has complimentary access \u2014 no charges apply."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 10,
                    marginTop: 16
                },
                children: [
                    mode === 'payg' && onBuyClient && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onBuyClient,
                        style: {
                            ...btn.base,
                            ...btn.primary
                        },
                        children: "Add a client \u2014 $336"
                    }),
                    mode === 'payg' && onUpgrade && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onUpgrade,
                        style: {
                            ...btn.base,
                            ...btn.outline
                        },
                        children: "Switch to annual \u2014 $800/yr"
                    }),
                    onManage && mode !== 'comp' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onManage,
                        style: {
                            ...btn.base,
                            ...btn.ghost
                        },
                        children: "Manage billing & invoices"
                    })
                ]
            })
        ]
    });
}
function $3bd107510f74a4b4$export$2e2bcd8739ae039({ role: role, cases: // `setRole` is still on the props (App passes it) but nothing here reads it: its only caller was
// the demo login's role picker, removed 29 Sep 2026. The real role comes from the firm membership.
cases, savedCaseStudies: savedCaseStudies = [], onCreateInPersonCase: onCreateInPersonCase, onCreateInviteCase: onCreateInviteCase, onOpenCaseJourney: onOpenCaseJourney, onOpenCaseFromModel: onOpenCaseFromModel, registeredSoasByProfileId: registeredSoasByProfileId, onRemindClient: onRemindClient, firmSettings: firmSettings, autoReminders: autoReminders, messageDefaults: messageDefaults, onSaveFirmSettings: onSaveFirmSettings, analyticsDataState: analyticsDataState = 'idle', onNeedAnalyticsData: onNeedAnalyticsData, onClientAssignmentChanged: onClientAssignmentChanged, onMarkSoaSent: onMarkSoaSent, onSetCurrentSoaForCase: onSetCurrentSoaForCase, onDeleteDraftSoa: onDeleteDraftSoa, onExitToConsumer: onExitToConsumer, onOpenAdmin: onOpenAdmin, reviewNavigationNonce: reviewNavigationNonce = 0, focusedCaseId: focusedCaseId = null, realIdentity: realIdentity = null, realModeLoading: realModeLoading = false, billingSummary: billingSummary = null, onManageBilling: onManageBilling, onUpgradeAnnual: onUpgradeAnnual, onBuyClient: onBuyClient }) {
    /*
     * THE DEMO LOGIN AND DEMO CODE SCREENS ARE GONE (29 Sep 2026, owner-reported).
     *
     * The portal used to carry its own wireframe sign-in and a fake "SMS code" screen, chosen by a
     * `stage` flag that started as 'login' and only switched to 'portal' in an effect once the real
     * workspace arrived. Effects run AFTER React paints, so on the render where the firm's identity
     * landed, the loading guard below stopped applying while `stage` still said 'login' — and the
     * demo sign-in was drawn for one frame before the effect flipped it. That was the split-second
     * "old demo authentication screen" the owner saw on some logins.
     *
     * Nothing reaches this component signed out any more: every route into the portal comes after a
     * real sign-in, and Sign out leaves the portal rather than returning to a portal login. So the
     * screens were only ever seen as that flash. Removing them removes the flash by construction;
     * real authentication, including the authenticator-app second factor, lives in AccountModal.
     */ const [search, setSearch] = (0, $acw62.useState)('');
    const [activeView, setActiveView] = (0, $acw62.useState)($3bd107510f74a4b4$var$V.advDash);
    // Analytics needs every client's fact-find, which the list deliberately omits. Fetch it the
    // moment the adviser actually opens the tab, not before — most sessions never go there.
    (0, $acw62.useEffect)(()=>{
        if (activeView === $3bd107510f74a4b4$var$V.advAnalytics) onNeedAnalyticsData?.();
    }, [
        activeView,
        onNeedAnalyticsData
    ]);
    const [navActiveId, setNavActiveId] = (0, $acw62.useState)($3bd107510f74a4b4$var$V.advDash);
    const [modal, setModal] = (0, $acw62.useState)(null);
    /*
     * Whether this firm has waved away the setup reminders.
     *
     * Per firm, per browser, and deliberately not on the server: it is a nudge, not a record, and a
     * preference this small does not justify a column or a round trip. Wrapped because storage throws
     * outright in a private window, and a dashboard must not fail to render over a dismissed hint.
     */ const setupDismissKey = realIdentity?.tenantId ? `acw.setupDismissed.${realIdentity.tenantId}` : null;
    const [setupDismissed, setSetupDismissed] = (0, $acw62.useState)(()=>{
        if (!setupDismissKey) return false;
        try {
            return window.localStorage.getItem(setupDismissKey) === '1';
        } catch  {
            return false;
        }
    });
    const dismissSetup = ()=>{
        setSetupDismissed(true);
        try {
            if (setupDismissKey) window.localStorage.setItem(setupDismissKey, '1');
        } catch  {
        // Dismissed for this visit; it returns next time. Better than a broken click.
        }
    };
    const [inviteCompletingAs, setInviteCompletingAs] = (0, $acw62.useState)('self');
    const [inviteFirstName, setInviteFirstName] = (0, $acw62.useState)('');
    const [inviteLastName, setInviteLastName] = (0, $acw62.useState)('');
    const [inviteEmail, setInviteEmail] = (0, $acw62.useState)('');
    // When someone else completes the form: their relationship to the client.
    const [inviteRelationship, setInviteRelationship] = (0, $acw62.useState)('');
    /** Why Send Invite did nothing, said under the button (owner, 16 Oct 2026: a disabled button looked live). */ const [inviteProblem, setInviteProblem] = (0, $acw62.useState)(null);
    const [inviteMobile, setInviteMobile] = (0, $acw62.useState)('');
    const [inviteAccessMode, setInviteAccessMode] = (0, $acw62.useState)('client_stop_dashboard');
    // Pre-set from the firm's own preference rather than a hardcoded 7 days, so an adviser who has
    // decided how their practice chases isn't re-answering it for every client. 'manual' when the
    // firm has chosen not to chase automatically.
    const firmDefaultFollowUp = firmSettings?.defaultFollowUpDays;
    const [inviteAutoFollowUp, setInviteAutoFollowUp] = (0, $acw62.useState)(firmDefaultFollowUp === null ? 'manual' : String(firmDefaultFollowUp ?? 7));
    const [inPersonFirstName, setInPersonFirstName] = (0, $acw62.useState)('');
    const [inPersonLastName, setInPersonLastName] = (0, $acw62.useState)('');
    const [inPersonEmail, setInPersonEmail] = (0, $acw62.useState)('');
    const [inPersonPhone, setInPersonPhone] = (0, $acw62.useState)('');
    const [inPersonCompletingAs, setInPersonCompletingAs] = (0, $acw62.useState)('self');
    const [filterProfile, setFilterProfile] = (0, $acw62.useState)('all');
    const [filterActivity, setFilterActivity] = (0, $acw62.useState)('all');
    const [pipelineFilter, setPipelineFilter] = (0, $acw62.useState)('all');
    const baseCfg = $3bd107510f74a4b4$var$PORTAL_CFG[role] || $3bd107510f74a4b4$var$PORTAL_CFG.relationship_owner;
    // Real mode: the signed-in adviser + their firm replace every piece of demo identity chrome.
    const cfg = realIdentity ? {
        ...baseCfg,
        ctxName: realIdentity.adviserName,
        ctxSub: realIdentity.firmName,
        avaInit: realIdentity.initials,
        uname: realIdentity.adviserName,
        urole: realIdentity.roleLine
    } : baseCfg;
    /** Real-mode Settings: the firm's actual profile (replaces the demo rosters entirely). */ const realFirmSettings = realIdentity && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                style: {
                    fontSize: 17,
                    fontWeight: 600,
                    marginBottom: 18
                },
                children: "Firm profile"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    maxWidth: 560
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1px solid #e2e8f0',
                            borderRadius: 16,
                            padding: 24,
                            boxShadow: '0 1px 3px rgba(15,23,42,.06)'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 14,
                                    marginBottom: 18
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            width: 46,
                                            height: 46,
                                            borderRadius: 12,
                                            background: 'linear-gradient(135deg,#1a6fd4,#17b8e0)',
                                            color: '#fff',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontWeight: 700,
                                            fontSize: 17
                                        },
                                        children: realIdentity.initials
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontWeight: 700,
                                                    fontSize: 16,
                                                    color: '#0f172a'
                                                },
                                                children: realIdentity.firmName
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 13,
                                                    color: '#64748b'
                                                },
                                                children: realIdentity.licenceLine
                                            })
                                        ]
                                    })
                                ]
                            }),
                            [
                                [
                                    'Owner',
                                    `${realIdentity.adviserName}${realIdentity.email ? ` \xb7 ${realIdentity.email}` : ''}`
                                ],
                                [
                                    'Role',
                                    realIdentity.roleLine
                                ],
                                [
                                    'Licensing',
                                    realIdentity.licenceLine
                                ]
                            ].map(([k, v])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        gap: 16,
                                        padding: '10px 0',
                                        borderTop: '1px solid #f1f5f9',
                                        fontSize: 13.5
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                color: '#64748b'
                                            },
                                            children: k
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                color: '#0f172a',
                                                fontWeight: 600,
                                                textAlign: 'right'
                                            },
                                            children: v
                                        })
                                    ]
                                }, k))
                        ]
                    }),
                    billingSummary && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3bd107510f74a4b4$var$BillingCard, {
                        summary: billingSummary,
                        onManage: onManageBilling,
                        onUpgrade: onUpgradeAnnual,
                        onBuyClient: onBuyClient
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $925452318330559f$export$6874097f8226718e), {
                        settings: firmSettings,
                        messageDefaults: messageDefaults,
                        onSave: onSaveFirmSettings
                    }),
                    realIdentity.tenantId && realIdentity.userId && realIdentity.profession === 'adviser' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7d9dfadc6ef7c34$export$5201925fd737e3ce), {
                        tenantId: realIdentity.tenantId,
                        myUserId: realIdentity.userId,
                        isPrincipal: realIdentity.role === 'owner'
                    }),
                    realIdentity.tenantId && realIdentity.userId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1633b2e963524d79$export$de93620394a42578), {
                        tenantId: realIdentity.tenantId,
                        myUserId: realIdentity.userId,
                        isPrincipal: realIdentity.role === 'owner',
                        holderLabel: realIdentity.holderLabel
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d04974d4d9d65fa$export$da038b5fdece4075), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            marginTop: 14,
                            background: '#f8fafc',
                            border: '1px solid #e2e8f0',
                            borderRadius: 12,
                            padding: '12px 16px',
                            fontSize: 13,
                            color: '#64748b',
                            lineHeight: 1.55
                        },
                        children: "Firm branding is on its way \u2014 it'll appear here as it goes live."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    maxWidth: 820,
                    marginTop: 18
                },
                children: realIdentity.profession === 'adviser' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fadd4c9abe8ba3e8$export$16f4f806beb74376), {
                    settings: firmSettings,
                    onSave: onSaveFirmSettings,
                    firmName: realIdentity.firmName,
                    setBy: realIdentity.adviserName
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        marginTop: 14,
                        background: '#fff',
                        border: '1px solid #e2e8f0',
                        borderRadius: 16,
                        padding: 24,
                        boxShadow: '0 1px 3px rgba(15,23,42,.06)'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                fontWeight: 700,
                                fontSize: 15,
                                color: '#0f172a'
                            },
                            children: "Capital market assumptions"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            style: {
                                fontSize: 13,
                                color: '#64748b',
                                margin: '6px 0 0',
                                lineHeight: 1.55,
                                maxWidth: 720
                            },
                            children: "AgedCareWise gives the advice for your firm's clients, so every projection runs on AgedCareWise's own assumptions \u2014 you can read them on the Assumptions page. A client can still set a rate on an individual asset in their profile; the advice document reports that as their decision and shows what the same plan looks like at AgedCareWise's rates."
                        })
                    ]
                })
            })
        ]
    });
    const metrics = (0, $acw62.useMemo)(()=>{
        const total = cases.length;
        const active = cases.filter((c)=>c.status !== 'draft').length;
        const invited = cases.filter((c)=>c.status === 'invited').length;
        const started = cases.filter((c)=>c.status === 'started').length;
        const awaiting = invited + started;
        const readyStatuses = [
            'submitted',
            'adviser_review'
        ];
        const ready = cases.filter((c)=>readyStatuses.includes(c.status)).length;
        // Split the "ready" queue: a submitted profile needs an adviser to PICK IT UP, whereas one
        // already in modelling is being worked. Lumping them together hid the queue that needs action.
        const awaitingModelling = cases.filter((c)=>c.status === 'submitted').length;
        const inModelling = cases.filter((c)=>c.status === 'adviser_review').length;
        const soaPub = cases.filter((c)=>c.soaStatus === 'published').length;
        // Drafted-but-unsent advice was invisible: the only SOA tile counted published, so an SOA
        // sitting in draft (the reported Tom Smith case) showed up nowhere on the dashboard.
        const soaDraft = cases.filter((c)=>c.soaStatus === 'draft').length;
        // Same definition as followupRows below, so the tab badge matches what the tab lists.
        const followups = cases.filter((c)=>c.soaStatus === 'draft' || c.status === 'submitted' || c.status === 'invited' || c.status === 'started').length;
        return {
            total: total,
            active: active,
            invited: invited,
            started: started,
            awaiting: awaiting,
            ready: ready,
            awaitingModelling: awaitingModelling,
            inModelling: inModelling,
            soaPub: soaPub,
            soaDraft: soaDraft,
            followups: followups
        };
    }, [
        cases
    ]);
    const filteredCases = (0, $acw62.useMemo)(()=>{
        const q = search.trim().toLowerCase();
        return cases.filter((c)=>!q || c.clientName.toLowerCase().includes(q) || (c.clientEmail || '').toLowerCase().includes(q));
    }, [
        cases,
        search
    ]);
    const clientTableFilteredCases = (0, $acw62.useMemo)(()=>{
        return filteredCases.filter((c)=>$3bd107510f74a4b4$var$caseMatchesProfileFilter(c, filterProfile) && $3bd107510f74a4b4$var$caseMatchesActivityFilter(c, filterActivity));
    }, [
        filteredCases,
        filterProfile,
        filterActivity
    ]);
    const pipelineScopedCases = (0, $acw62.useMemo)(()=>{
        if (pipelineFilter === 'ready') return filteredCases.filter((c)=>[
                'submitted',
                'adviser_review'
            ].includes(c.status));
        if (pipelineFilter === 'overdue') return filteredCases.filter((c)=>{
            const d = $3bd107510f74a4b4$var$daysSinceIso(c.lastActivityAt);
            if (d == null) return false;
            // Waiting on the client.
            if (c.status === 'invited' && d > 5) return true;
            if (c.status === 'started' && (c.profileProgressPct || 0) < 80 && d > 3) return true;
            // Waiting on US. A finished profile nobody has picked up, or an SOA drafted and never
            // sent, is a client waiting on the firm — previously never counted as overdue at all,
            // so the only work this filter could surface was somebody else's.
            if (c.status === 'submitted' && d > 3) return true;
            return c.soaStatus === 'draft' && d > 5;
        });
        return filteredCases;
    }, [
        filteredCases,
        pipelineFilter
    ]);
    // 'draft' is folded in: no real intake path produces it (see the pipeline markup), but demo
    // cases still carry it, and a case that exists in state must appear SOMEWHERE.
    const pipelineSentCases = (0, $acw62.useMemo)(()=>pipelineScopedCases.filter((c)=>c.status === 'invited' || c.status === 'draft'), [
        pipelineScopedCases
    ]);
    const pipelineProgressCases = (0, $acw62.useMemo)(()=>pipelineScopedCases.filter((c)=>c.status === 'started'), [
        pipelineScopedCases
    ]);
    const pipelineReadyCases = (0, $acw62.useMemo)(()=>pipelineScopedCases.filter((c)=>[
                'submitted',
                'adviser_review'
            ].includes(c.status)), [
        pipelineScopedCases
    ]);
    const pipelineSoaCases = (0, $acw62.useMemo)(()=>pipelineScopedCases.filter((c)=>c.soaStatus === 'draft' || c.soaStatus === 'published' || c.status === 'soa_draft' || c.status === 'soa_published'), [
        pipelineScopedCases
    ]);
    /**
     * What needs attention, on BOTH sides of the engagement.
     *
     * This used to list only clients — invited-but-not-started, or stalled part-way through the
     * fact-find — so work sitting with the FIRM was invisible: a finished profile nobody had picked
     * up, or an SOA drafted weeks ago and never sent. Those are the items a client is actually
     * waiting on, and they never appeared anywhere in the portal.
     */ const followupRows = (0, $acw62.useMemo)(()=>{
        const rows = filteredCases.map((c)=>{
            const days = $3bd107510f74a4b4$var$daysSinceIso(c.lastActivityAt);
            // Furthest-along first: an unsent SOA is a more pressing obligation than an unstarted invite.
            if (c.soaStatus === 'draft') return {
                c: c,
                kind: 'soa_unsent',
                waitingOn: 'firm',
                days: days
            };
            if (c.status === 'submitted') return {
                c: c,
                kind: 'awaiting_modelling',
                waitingOn: 'firm',
                days: days
            };
            if (c.status === 'invited') return {
                c: c,
                kind: 'invite_outstanding',
                waitingOn: 'client',
                days: days
            };
            if (c.status === 'started' && (c.profileProgressPct || 0) < 80) return {
                c: c,
                kind: 'client_stalled',
                waitingOn: 'client',
                days: days
            };
            return null;
        }).filter((r)=>r !== null);
        // Longest-waiting first — the whole point of the list is what has been ignored longest.
        return rows.sort((a, b)=>(b.days ?? -1) - (a.days ?? -1));
    }, [
        filteredCases
    ]);
    /** Working copies (sessionStorage) reconciled with the advice register — see soaSources.ts. */ const soaByCaseId = (0, $acw62.useMemo)(()=>(0, $61c205d79dbc6f70$export$dcb092af5d9a4069)(savedCaseStudies, registeredSoasByProfileId), [
        savedCaseStudies,
        registeredSoasByProfileId
    ]);
    /**
     * Download the client table as CSV — exactly the rows and columns on screen, honouring the
     * current search and filters, so what you export is what you were looking at.
     *
     * This button previously did nothing at all. No client FINANCIAL data is included: this is the
     * workflow view (who, what stage, how far through, when last active), which is what an adviser
     * wants a list of. Built in the browser from data already loaded — nothing is sent anywhere.
     */ /** Download the client table as CSV. This button previously did nothing. See clientsCsv.ts. */ const exportClientsCsv = (0, $acw62.useCallback)(()=>{
        const csv = (0, $0313edef17a9cde3$export$4c0967f92bf03ce8)(clientTableFilteredCases, (c)=>$3bd107510f74a4b4$var$profileTag(c).label.replace(/^[^A-Za-z]+/, ''));
        (0, $0313edef17a9cde3$export$8ad5f403dfeb9e5b)(csv, 'clients-' + new Date().toISOString().slice(0, 10) + '.csv');
    }, [
        clientTableFilteredCases
    ]);
    const clientTableFilterBar = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: 10,
            marginBottom: 12,
            padding: '10px 12px',
            background: 'linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)',
            border: '1px solid var(--bdr)',
            borderRadius: 'var(--rl)'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    fontSize: 12,
                    fontWeight: 600,
                    color: 'var(--muted)'
                },
                children: "Filters"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                className: "fus",
                value: filterProfile,
                onChange: (e)=>setFilterProfile(e.target.value),
                "aria-label": "Filter by profile stage",
                style: {
                    minWidth: 168
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: "all",
                        children: "All profile stages"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: "draft",
                        children: "Not invited yet"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: "invited",
                        children: "Sent (not started)"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: "started",
                        children: "In progress"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: "complete",
                        children: "Profile complete"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                className: "fus",
                value: filterActivity,
                onChange: (e)=>setFilterActivity(e.target.value),
                "aria-label": "Filter by last activity",
                style: {
                    minWidth: 176
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: "all",
                        children: "Any last activity"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: "today",
                        children: "Active today"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: "week",
                        children: "Last 7 days"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: "month",
                        children: "Last 30 days"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: "older",
                        children: "30+ days ago"
                    })
                ]
            }),
            (filterProfile !== 'all' || filterActivity !== 'all') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: "bsm bg",
                style: {
                    fontSize: 12,
                    padding: '5px 11px'
                },
                onClick: ()=>{
                    setFilterProfile('all');
                    setFilterActivity('all');
                },
                children: "Clear filters"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                style: {
                    fontSize: 12,
                    color: 'var(--muted)',
                    marginLeft: 'auto'
                },
                children: [
                    clientTableFilteredCases.length,
                    " shown"
                ]
            })
        ]
    });
    (0, $acw62.useEffect)(()=>{
        const first = $3bd107510f74a4b4$var$PORTAL_CFG[role]?.tabs[0]?.id || $3bd107510f74a4b4$var$V.advDash;
        setActiveView(first);
        setNavActiveId(first);
    }, [
        role
    ]);
    const setView = (0, $acw62.useCallback)((id)=>{
        setActiveView(id);
        setNavActiveId(id);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!reviewNavigationNonce) return;
        if (role === 'relationship_owner') {
            setView($3bd107510f74a4b4$var$V.advSoas);
            return;
        }
        if (role === 'practice_owner') {
            setView($3bd107510f74a4b4$var$V.pracClients);
            return;
        }
        setView($3bd107510f74a4b4$var$V.licDash);
    }, [
        reviewNavigationNonce,
        role,
        setView
    ]);
    const badgeCounts = (0, $acw62.useMemo)(()=>({
            clients: metrics.total,
            followups: metrics.followups,
            practices: 8,
            advisers: 34
        }), [
        metrics
    ]);
    const tabsWithBadges = (0, $acw62.useMemo)(()=>{
        return cfg.tabs.map((t)=>{
            if (t.id === $3bd107510f74a4b4$var$V.advFollow || t.id === $3bd107510f74a4b4$var$V.pracFollow) return {
                ...t,
                badge: metrics.followups > 0 ? String(metrics.followups) : null
            };
            return t;
        });
    }, [
        cfg.tabs,
        metrics.followups
    ]);
    const resetInviteForm = ()=>{
        setInviteProblem(null);
        setInviteCompletingAs('self');
        setInviteFirstName('');
        setInviteLastName('');
        setInviteRelationship('');
        setInviteEmail('');
        setInviteMobile('');
        setInviteAccessMode('client_stop_dashboard');
        setInviteAutoFollowUp('7');
    };
    const resetInPersonForm = ()=>{
        setInPersonFirstName('');
        setInPersonLastName('');
        setInPersonEmail('');
        setInPersonPhone('');
        setInPersonCompletingAs('self');
    };
    const renderInviteModal = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: `mdrop${modal === 'invite' ? ' on' : ''}`,
            role: "presentation",
            onClick: (e)=>e.target === e.currentTarget && setModal(null),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "modal",
                role: "dialog",
                "aria-modal": "true",
                onClick: (e)=>e.stopPropagation(),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "mclose",
                        onClick: ()=>setModal(null),
                        "aria-label": "Close",
                        children: "\xd7"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt",
                        children: "Invite a New Client"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "ms",
                        children: "A secure link is sent so the person can complete the profile remotely before your meeting."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mfg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "mfl",
                                htmlFor: "pp-invite-completer",
                                children: "Who will be completing this form?"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                id: "pp-invite-completer",
                                className: "fi",
                                value: inviteCompletingAs,
                                onChange: (e)=>setInviteCompletingAs(e.target.value),
                                style: {
                                    cursor: 'pointer'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "self",
                                        children: "The client (person seeking advice)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "family_member",
                                        children: "A family member"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "epoa",
                                        children: "An enduring power of attorney"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "professional",
                                        children: "A professional completing with the client"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 11,
                                    color: 'var(--muted)',
                                    marginTop: 5,
                                    lineHeight: 1.5
                                },
                                children: "Matches your existing client portal options. The client's link can pre-answer this question so they go straight to entering their details."
                            })
                        ]
                    }),
                    inviteCompletingAs !== 'self' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mfl",
                        style: {
                            marginTop: 4
                        },
                        children: "Who will complete it? The link goes to them."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "m2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mfg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "mfl",
                                        htmlFor: "pp-invite-fname",
                                        children: inviteCompletingAs === 'self' ? 'First Name' : 'Their First Name'
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        id: "pp-invite-fname",
                                        className: "fi",
                                        placeholder: "Helen",
                                        value: inviteFirstName,
                                        onChange: (e)=>{
                                            setInviteFirstName(e.target.value);
                                            setInviteProblem(null);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mfg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "mfl",
                                        htmlFor: "pp-invite-lname",
                                        children: inviteCompletingAs === 'self' ? 'Last Name' : 'Their Last Name'
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        id: "pp-invite-lname",
                                        className: "fi",
                                        placeholder: "Tan",
                                        value: inviteLastName,
                                        onChange: (e)=>setInviteLastName(e.target.value)
                                    })
                                ]
                            })
                        ]
                    }),
                    inviteCompletingAs !== 'self' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mfg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "mfl",
                                htmlFor: "pp-invite-relationship",
                                children: "Their relationship to the client"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                id: "pp-invite-relationship",
                                className: "fi",
                                placeholder: inviteCompletingAs === 'professional' ? 'Accountant' : 'Daughter',
                                value: inviteRelationship,
                                onChange: (e)=>setInviteRelationship(e.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mfg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "mfl",
                                htmlFor: "pp-invite-email",
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                id: "pp-invite-email",
                                className: "fi",
                                type: "email",
                                placeholder: "client@email.com",
                                value: inviteEmail,
                                onChange: (e)=>{
                                    setInviteEmail(e.target.value);
                                    setInviteProblem(null);
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "ms",
                                style: {
                                    marginTop: 6
                                },
                                children: [
                                    "Required \u2014 the secure link is sent here. If your client doesn't have an email address, close this and use ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "New Client (In-Person)"
                                    }),
                                    " instead: you fill the profile in together and no email is needed."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mfg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "mfl",
                                htmlFor: "pp-invite-mobile",
                                children: "Mobile number"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                id: "pp-invite-mobile",
                                className: "fi",
                                type: "tel",
                                placeholder: "04xx xxx xxx",
                                autoComplete: "tel",
                                value: inviteMobile,
                                onChange: (e)=>setInviteMobile(e.target.value)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 11,
                                    color: 'var(--muted)',
                                    marginTop: 5,
                                    lineHeight: 1.5
                                },
                                children: "Optional. Saved on the client\u2019s profile as their preferred phone number, so you can contact them. We do not send text messages."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "m2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mfg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "mfl",
                                        htmlFor: "pp-invite-access",
                                        children: "Access Mode"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        id: "pp-invite-access",
                                        className: "fi",
                                        value: inviteAccessMode,
                                        onChange: (e)=>setInviteAccessMode(e.target.value),
                                        style: {
                                            cursor: 'pointer'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "client_stop_dashboard",
                                                children: "Adviser-led \u2014 profile only"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "client_end_to_end",
                                                children: "Self-serve \u2014 full journey"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mfg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "mfl",
                                        htmlFor: "pp-invite-followup",
                                        children: "Follow-up after"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        id: "pp-invite-followup",
                                        className: "fi",
                                        value: inviteAutoFollowUp,
                                        onChange: (e)=>setInviteAutoFollowUp(e.target.value),
                                        style: {
                                            cursor: 'pointer'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "3",
                                                children: "3 days"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "5",
                                                children: "5 days"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "7",
                                                children: "7 days"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "manual",
                                                children: "Manual only \u2014 I'll reach out myself"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    inviteAutoFollowUp === 'manual' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ms",
                        style: {
                            marginTop: -4,
                            marginBottom: 14
                        },
                        children: [
                            "They'll appear in your ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Follow-ups"
                            }),
                            " list for you to chase."
                        ]
                    }) : autoReminders && !autoReminders.enabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ms",
                        style: {
                            marginTop: -4,
                            marginBottom: 14
                        },
                        children: [
                            "Automatic follow-ups are switched off on this server \u2014 they'll appear in your",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "Follow-ups"
                            }),
                            " list instead."
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mfoot",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "bsm bg",
                                onClick: ()=>setModal(null),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "bsm bp",
                                "aria-disabled": !$3bd107510f74a4b4$var$isIntakeReady(inviteFirstName, inviteEmail, true),
                                onClick: ()=>{
                                    // Never a silently dead button: say what is missing and put the cursor there.
                                    if (!inviteFirstName.trim()) {
                                        setInviteProblem("Enter the client's first name.");
                                        document.getElementById('pp-invite-fname')?.focus();
                                        return;
                                    }
                                    if (!$3bd107510f74a4b4$var$isIntakeReady(inviteFirstName, inviteEmail, true)) {
                                        setInviteProblem(inviteEmail.trim() ? "That email address does not look right \u2014 check it and try again." : "Enter the client's email address \u2014 the secure link is sent there.");
                                        document.getElementById('pp-invite-email')?.focus();
                                        return;
                                    }
                                    setInviteProblem(null);
                                    onCreateInviteCase?.({
                                        completingAs: inviteCompletingAs,
                                        firstName: inviteFirstName,
                                        lastName: inviteLastName,
                                        relationship: inviteRelationship,
                                        email: inviteEmail,
                                        mobile: inviteMobile,
                                        accessMode: inviteAccessMode,
                                        autoFollowUp: inviteAutoFollowUp
                                    });
                                    setModal(null);
                                    resetInviteForm();
                                },
                                children: "Send Invite \u2192"
                            })
                        ]
                    }),
                    inviteProblem && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "ms",
                        role: "alert",
                        style: {
                            color: 'var(--red)',
                            fontWeight: 600,
                            textAlign: 'right',
                            marginTop: 8
                        },
                        "data-testid": "invite-problem",
                        children: inviteProblem
                    })
                ]
            })
        });
    const renderInPersonModal = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: `mdrop${modal === 'inperson' ? ' on' : ''}`,
            role: "presentation",
            onClick: (e)=>e.target === e.currentTarget && setModal(null),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "modal",
                style: {
                    maxWidth: 460
                },
                role: "dialog",
                "aria-modal": "true",
                onClick: (e)=>e.stopPropagation(),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "mclose",
                        onClick: ()=>setModal(null),
                        "aria-label": "Close",
                        children: "\xd7"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12,
                            marginBottom: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    width: 40,
                                    height: 40,
                                    borderRadius: '50%',
                                    background: 'linear-gradient(135deg,var(--blue),var(--cyan))',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                    viewBox: "0 0 24 24",
                                    style: {
                                        width: 18,
                                        height: 18,
                                        stroke: '#fff',
                                        fill: 'none',
                                        strokeWidth: 2.5
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            cx: "9",
                                            cy: "7",
                                            r: "4"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                            x1: "19",
                                            y1: "8",
                                            x2: "19",
                                            y2: "14"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                            x1: "22",
                                            y1: "11",
                                            x2: "16",
                                            y2: "11"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt",
                                style: {
                                    margin: 0
                                },
                                children: "New Client \u2014 In-Person Session"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "ms",
                        children: "The client is with you now. Create their record and go straight into the profile fact-find together."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: '#eff6ff',
                            border: '1px solid #bfdbfe',
                            borderRadius: 'var(--r)',
                            padding: '10px 14px',
                            fontSize: 12,
                            color: '#1e40af',
                            marginBottom: 20,
                            lineHeight: 1.6
                        },
                        children: [
                            "This creates the engagement with status ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "In Progress"
                            }),
                            ". Details below pre-fill Step 2 of the client profile."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "m2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mfg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "mfl",
                                        htmlFor: "pp-ip-fname",
                                        children: "First Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        id: "pp-ip-fname",
                                        className: "fi",
                                        placeholder: "e.g. Margaret",
                                        value: inPersonFirstName,
                                        onChange: (e)=>setInPersonFirstName(e.target.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mfg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "mfl",
                                        htmlFor: "pp-ip-lname",
                                        children: "Last Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        id: "pp-ip-lname",
                                        className: "fi",
                                        placeholder: "e.g. Collins",
                                        value: inPersonLastName,
                                        onChange: (e)=>setInPersonLastName(e.target.value)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mfg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "mfl",
                                htmlFor: "pp-ip-email",
                                children: [
                                    "Email ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontWeight: 400,
                                            color: 'var(--muted)'
                                        },
                                        children: "(optional)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                id: "pp-ip-email",
                                className: "fi",
                                type: "email",
                                placeholder: "client@email.com",
                                value: inPersonEmail,
                                onChange: (e)=>setInPersonEmail(e.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mfg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "mfl",
                                htmlFor: "pp-ip-phone",
                                children: "Preferred phone number"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                id: "pp-ip-phone",
                                className: "fi",
                                type: "tel",
                                placeholder: "e.g. 04xx xxx xxx or 02 xxxx xxxx",
                                value: inPersonPhone,
                                onChange: (e)=>setInPersonPhone(e.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mfg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "mfl",
                                htmlFor: "pp-ip-completer",
                                children: "Who is providing the information?"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                id: "pp-ip-completer",
                                className: "fi",
                                value: inPersonCompletingAs,
                                onChange: (e)=>setInPersonCompletingAs(e.target.value),
                                style: {
                                    cursor: 'pointer'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "self",
                                        children: "The client (person seeking advice)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "family_member",
                                        children: "A family member"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "epoa",
                                        children: "An enduring power of attorney"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 11,
                                    color: 'var(--muted)',
                                    marginTop: 5,
                                    lineHeight: 1.4
                                },
                                children: "All other details are captured in the profile. Data should reflect the end client's situation regardless of who is filling it in."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mfoot",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "bsm bg",
                                onClick: ()=>setModal(null),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "bsm bp",
                                disabled: !$3bd107510f74a4b4$var$isIntakeReady(inPersonFirstName, inPersonEmail, false),
                                title: inPersonFirstName.trim() ? undefined : "Enter the client's first name.",
                                onClick: ()=>{
                                    onCreateInPersonCase?.({
                                        firstName: inPersonFirstName,
                                        lastName: inPersonLastName,
                                        email: inPersonEmail,
                                        preferredPhone: inPersonPhone,
                                        completingAs: inPersonCompletingAs
                                    });
                                    setModal(null);
                                    resetInPersonForm();
                                },
                                children: "Start Profile \u2192"
                            })
                        ]
                    })
                ]
            })
        });
    const renderAddUserModal = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: `mdrop${modal === 'adduser' ? ' on' : ''}`,
            role: "presentation",
            onClick: (e)=>e.target === e.currentTarget && setModal(null),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "modal",
                style: {
                    maxWidth: 440
                },
                role: "dialog",
                onClick: (e)=>e.stopPropagation(),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "mclose",
                        onClick: ()=>setModal(null),
                        children: "\xd7"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt",
                        children: "Add Team Member"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "ms",
                        children: "Invite an adviser or accountant to this practice (demo)."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mfoot",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "bsm bg",
                            onClick: ()=>setModal(null),
                            children: "Close"
                        })
                    })
                ]
            })
        });
    const renderAddPracticeModal = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: `mdrop${modal === 'addprac' ? ' on' : ''}`,
            role: "presentation",
            onClick: (e)=>e.target === e.currentTarget && setModal(null),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "modal",
                role: "dialog",
                onClick: (e)=>e.stopPropagation(),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "mclose",
                        onClick: ()=>setModal(null),
                        children: "\xd7"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt",
                        children: "Onboard New Practice"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "ms",
                        children: "Send a subscription invite to a new firm under your licence (demo)."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mfoot",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "bsm bg",
                            onClick: ()=>setModal(null),
                            children: "Close"
                        })
                    })
                ]
            })
        });
    const adviserDashboard = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            realIdentity?.tenantId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c317b0c1172678e2$export$778380418624aa22), {
                hasClient: cases.length > 0,
                firmProfileDone: Boolean(realIdentity.firmProfileComplete),
                isAdviserFirm: realIdentity.profession === 'adviser',
                isPrincipal: realIdentity.role === 'owner',
                onInviteClient: ()=>setModal('invite'),
                onNewInPerson: ()=>setModal('inperson'),
                onOpenSettings: ()=>setView($3bd107510f74a4b4$var$V.advSettings),
                dismissed: setupDismissed,
                onDismiss: dismissSetup
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "krow",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "kcard",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kl",
                                children: "My Active Clients"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kv",
                                children: metrics.active
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ks g",
                                children: "In scope"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "kcard",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kl",
                                children: "Awaiting Data"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kv",
                                children: metrics.awaiting
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ks a",
                                children: "Invited + in progress"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "kcard",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kl",
                                children: "Ready to Model"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kv",
                                children: metrics.ready
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ks g",
                                children: metrics.inModelling > 0 ? `${metrics.awaitingModelling} to pick up \xb7 ${metrics.inModelling} in modelling` : 'Profiles submitted'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "kcard",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kl",
                                children: "SOAs Delivered"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kv",
                                children: metrics.soaPub
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ks",
                                children: metrics.soaDraft > 0 ? `Published \xb7 ${metrics.soaDraft} in draft` : 'Published'
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "sh",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "sh-t",
                        children: "My Client Pipeline"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "fps",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: `fp${pipelineFilter === 'all' ? ' on' : ''}`,
                                onClick: ()=>setPipelineFilter('all'),
                                children: "All"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: `fp${pipelineFilter === 'overdue' ? ' on' : ''}`,
                                onClick: ()=>setPipelineFilter('overdue'),
                                children: "Overdue"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: `fp${pipelineFilter === 'ready' ? ' on' : ''}`,
                                onClick: ()=>setPipelineFilter('ready'),
                                children: "Ready"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pipe pp-pipe-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "pcol",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "pch",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "pcl",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "pd",
                                                style: {
                                                    background: '#3b82f6'
                                                }
                                            }),
                                            "Invite Sent"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "pcn",
                                        children: pipelineSentCases.length
                                    })
                                ]
                            }),
                            pipelineSentCases.slice(0, 5).map((c)=>{
                                const d = $3bd107510f74a4b4$var$daysSinceIso(c.lastActivityAt);
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3bd107510f74a4b4$var$PipelineCard, {
                                    title: c.clientName,
                                    subtitle: d != null ? `Invited ${d}d ago \u{2014} not started` : "Invited \u2014 not started",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "pbar",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "pfill",
                                                style: {
                                                    width: 0
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "ccf",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "tag t-st",
                                                    children: d != null && d > 7 ? `${d}d no activity` : 'Awaiting client'
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "ma",
                                                    disabled: !onRemindClient || !c.workflow?.inviteId,
                                                    title: c.workflow?.inviteId ? "Send this client a fresh link by email \u2014 the earlier one stops working" : 'No outstanding invite to resend',
                                                    onClick: ()=>onRemindClient?.(c.id),
                                                    children: "Nudge"
                                                })
                                            ]
                                        })
                                    ]
                                }, c.id);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "pcol",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "pch",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "pcl",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "pd",
                                                style: {
                                                    background: '#f59e0b'
                                                }
                                            }),
                                            "Filling In Profile"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "pcn",
                                        children: pipelineProgressCases.length
                                    })
                                ]
                            }),
                            pipelineProgressCases.slice(0, 8).map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3bd107510f74a4b4$var$PipelineCard, {
                                    title: c.clientName,
                                    subtitle: $3bd107510f74a4b4$var$progressLabel(c),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "pbar",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "pfill",
                                                style: {
                                                    width: `${c.profileProgressPct || 0}%`,
                                                    background: '#f59e0b'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "ccf",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "tag t-pr",
                                                    children: [
                                                        c.profileProgressIsEstimated ? '~' : '',
                                                        c.profileProgressPct || 0,
                                                        "%"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "ma go",
                                                    onClick: ()=>onOpenCaseJourney(c.id),
                                                    children: "Open \u2192"
                                                })
                                            ]
                                        })
                                    ]
                                }, c.id))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "pcol",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "pch",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "pcl",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "pd",
                                                style: {
                                                    background: '#10b981'
                                                }
                                            }),
                                            "Ready to Model"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "pcn",
                                        children: pipelineReadyCases.length
                                    })
                                ]
                            }),
                            pipelineReadyCases.slice(0, 5).map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3bd107510f74a4b4$var$PipelineCard, {
                                    title: c.clientName,
                                    subtitle: `Submitted ${$3bd107510f74a4b4$var$formatSubmittedLabel(c)}`,
                                    highlight: true,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "pbar",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "pfill g",
                                                style: {
                                                    width: '100%'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "ccf",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "tag t-ok",
                                                    children: (c.savedModelCount || 0) > 0 ? `${c.savedModelCount} modelled` : 'Profile done'
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "ma go",
                                                    onClick: ()=>onOpenCaseJourney(c.id),
                                                    children: "Open \u2192"
                                                })
                                            ]
                                        })
                                    ]
                                }, c.id))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "pcol soa-col",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "pch",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "pcl",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "pd",
                                                style: {
                                                    background: '#6366f1'
                                                }
                                            }),
                                            "Advice (SOA)"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "pcn",
                                        children: pipelineSoaCases.length
                                    })
                                ]
                            }),
                            pipelineSoaCases.slice(0, 5).map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3bd107510f74a4b4$var$PipelineCard, {
                                    title: c.clientName,
                                    subtitle: c.soaStatus === 'published' || c.status === 'soa_published' ? 'SOA sent to client' : 'SOA in draft',
                                    highlight: c.soaStatus === 'published' || c.status === 'soa_published',
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "ccf",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "ma go",
                                            onClick: ()=>onOpenCaseFromModel(c.id),
                                            children: c.soaStatus === 'published' || c.status === 'soa_published' ? 'View' : "Edit & Send \u2192"
                                        })
                                    })
                                }, c.id)),
                            pipelineSoaCases.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ccm",
                                style: {
                                    padding: '8px 0'
                                },
                                children: "No SOAs yet"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "thdr",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    fontWeight: 500,
                                    color: 'var(--dark)'
                                },
                                children: "All My Clients"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    gap: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "bsm bg",
                                        style: {
                                            fontSize: 12,
                                            padding: '5px 11px'
                                        },
                                        onClick: exportClientsCsv,
                                        disabled: clientTableFilteredCases.length === 0,
                                        children: "Export"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "si",
                                        placeholder: "Search\u2026",
                                        value: search,
                                        onChange: (e)=>setSearch(e.target.value)
                                    })
                                ]
                            })
                        ]
                    }),
                    clientTableFilterBar,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Client"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Type"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Profile Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "SOA Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Last Activity"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Access Mode"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: clientTableFilteredCases.map((c)=>{
                                    const pt = $3bd107510f74a4b4$var$profileTag(c);
                                    const st = $3bd107510f74a4b4$var$soaTag(c);
                                    const isCouple = c.factFind?.adviceFor === 'couple' || c.clientName && c.clientName.includes('&');
                                    const lastD = $3bd107510f74a4b4$var$daysSinceIso(c.lastActivityAt);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "tn",
                                                        children: [
                                                            c.clientName,
                                                            c.visibility === 'restricted' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                title: "Only you and the principal can see this client",
                                                                style: {
                                                                    marginLeft: 6,
                                                                    fontSize: 10,
                                                                    fontWeight: 600,
                                                                    color: '#64748b',
                                                                    border: '1px solid #e2e8f0',
                                                                    borderRadius: 4,
                                                                    padding: '1px 5px',
                                                                    verticalAlign: 1
                                                                },
                                                                children: "restricted"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "te",
                                                        children: c.clientEmail
                                                    }),
                                                    c.clientMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "te",
                                                        children: c.clientMobile
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "tm",
                                                children: isCouple ? 'Couple' : 'Single'
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: pt.cls,
                                                    children: pt.label
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: st.cls,
                                                    style: st.style,
                                                    children: st.label
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: lastD != null && lastD > 8 ? 'tov' : 'tm',
                                                children: $3bd107510f74a4b4$var$formatLastActivityDisplay(c.lastActivityAt)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: $3bd107510f74a4b4$var$accessModeClass(c.accessMode),
                                                    children: $3bd107510f74a4b4$var$accessModeLabel(c.accessMode)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "abtns",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "ab p",
                                                            onClick: ()=>onOpenCaseJourney(c.id),
                                                            children: "Open Model \u2192"
                                                        }),
                                                        $3bd107510f74a4b4$var$hasReviewableSoa(c) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "ab",
                                                            onClick: ()=>onOpenCaseFromModel(c.id),
                                                            children: "Review"
                                                        }),
                                                        realIdentity?.tenantId && c.isReal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f095723d2f4d5109$export$96a4931031b5caa0), {
                                                            profileId: c.id,
                                                            clientName: c.clientName,
                                                            adviserUserId: c.adviserUserId ?? null,
                                                            visibility: c.visibility ?? 'firm',
                                                            tenantId: realIdentity.tenantId,
                                                            myUserId: realIdentity.userId ?? '',
                                                            isPrincipal: realIdentity.role === 'owner',
                                                            onChanged: onClientAssignmentChanged
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, c.id);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
    const adviserFollowups = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                style: {
                    fontSize: 17,
                    fontWeight: 600,
                    marginBottom: 6
                },
                children: "My Follow-ups"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    fontSize: 14,
                    color: 'var(--muted)',
                    marginBottom: 18
                },
                children: "Everything waiting on someone \u2014 clients yet to start or stalled part-way, and work sitting with you: profiles ready to model, and SOAs drafted but never sent. Longest wait first."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Client"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Status"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Currently On"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Days Inactive"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Actions"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                            children: followupRows.map(({ c: c, kind: kind, waitingOn: waitingOn, days: d })=>{
                                const pres = $3bd107510f74a4b4$var$FOLLOWUP_PRESENTATION[kind];
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "tn",
                                                    children: c.clientName
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "te",
                                                    children: pres.detail
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: pres.chipCls,
                                                children: pres.chip
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "tm",
                                            children: c.status === 'started' ? $3bd107510f74a4b4$var$progressLabel(c) : waitingOn === 'firm' ? 'With you' : "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: d != null && d > 5 ? 'tov' : 'tm',
                                            children: d != null ? `${d} days` : "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "abtns",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "ab p",
                                                    disabled: waitingOn !== 'firm' && !c.workflow?.inviteId,
                                                    title: waitingOn === 'firm' || c.workflow?.inviteId ? undefined : 'This client was added in person, so there is no invite to resend.',
                                                    onClick: waitingOn === 'firm' ? ()=>onOpenCaseJourney(c.id) : ()=>onRemindClient?.(c.id),
                                                    children: pres.action
                                                })
                                            })
                                        })
                                    ]
                                }, c.id);
                            })
                        })
                    ]
                })
            })
        ]
    });
    const activityEvents = (0, $acw62.useMemo)(()=>(0, $397d0cafc1acbe4a$export$17ab98d78f084ac8)(filteredCases), [
        filteredCases
    ]);
    const focusCaseRow = focusedCaseId ? cases.find((x)=>x.id === focusedCaseId) : null;
    const adviserSoas = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                style: {
                    fontSize: 17,
                    fontWeight: 600,
                    marginBottom: 8
                },
                children: "Reports & Digital SOAs"
            }),
            role === 'relationship_owner' && focusCaseRow && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                style: {
                    fontSize: 13,
                    color: 'var(--muted)',
                    marginBottom: 16,
                    lineHeight: 1.5
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        style: {
                            color: 'var(--dark)'
                        },
                        children: "Review:"
                    }),
                    " ",
                    focusCaseRow.clientName,
                    " \u2014 draft / published SOA work happens here (demo). Use",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "Open Model \u2192"
                    }),
                    " from ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                        children: "All My Clients"
                    }),
                    " to open the full client journey."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Client"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "SOA Status"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Last activity"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Actions"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                            children: filteredCases.filter((c)=>c.soaStatus !== 'none' || [
                                    'submitted',
                                    'adviser_review',
                                    'soa_draft',
                                    'soa_published'
                                ].includes(c.status)).map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    style: focusedCaseId && c.id === focusedCaseId ? {
                                        background: 'rgba(59, 130, 246, 0.09)',
                                        boxShadow: 'inset 3px 0 0 0 #3b82f6'
                                    } : undefined,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "tn",
                                            children: c.clientName
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: c.soaStatus === 'published' || c.status === 'soa_published' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "tag t-ok",
                                                children: "Published"
                                            }) : c.soaStatus === 'draft' || c.status === 'soa_draft' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "tag t-pr",
                                                children: "Draft"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "tag t-sn",
                                                children: "Not started"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "tm",
                                            children: $3bd107510f74a4b4$var$formatLastActivityDisplay(c.lastActivityAt)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: (()=>{
                                                const caseSoas = soaByCaseId.get(c.id) || [];
                                                const selectedId = c.currentSoaId || caseSoas.find((s)=>s.isCurrentForCase)?.id || caseSoas[0]?.id || '';
                                                const selectedSoa = caseSoas.find((s)=>s.id === selectedId) || null;
                                                const selectedStatus = selectedSoa?.soaDeliveryStatus || (c.soaStatus === 'published' || c.status === 'soa_published' ? 'published' : 'draft');
                                                const isDraftSelected = selectedStatus === 'draft';
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "abtns",
                                                    style: {
                                                        gap: 6,
                                                        flexWrap: 'wrap'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "ab p",
                                                            onClick: ()=>onOpenCaseFromModel(c.id),
                                                            children: "Open \u2192"
                                                        }),
                                                        caseSoas.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                            value: selectedId,
                                                            onChange: (e)=>onSetCurrentSoaForCase?.(c.id, e.target.value),
                                                            className: "ab",
                                                            style: {
                                                                minWidth: 210
                                                            },
                                                            children: caseSoas.map((soa)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("option", {
                                                                    value: soa.id,
                                                                    children: [
                                                                        soa.name,
                                                                        " (",
                                                                        (soa.soaDeliveryStatus || 'draft') === 'published' ? 'Published' : 'Draft',
                                                                        ")",
                                                                        soa.registerOnly ? " \xb7 from register" : ''
                                                                    ]
                                                                }, soa.id))
                                                        }),
                                                        selectedSoa && isDraftSelected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "ab",
                                                            onClick: ()=>onMarkSoaSent?.(c.id, selectedSoa.id),
                                                            children: "Sent to Client"
                                                        }),
                                                        selectedSoa && isDraftSelected && !selectedSoa.registerOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "ab",
                                                            onClick: ()=>onDeleteDraftSoa?.(selectedSoa.id),
                                                            children: "Delete Draft"
                                                        })
                                                    ]
                                                });
                                            })()
                                        })
                                    ]
                                }, c.id))
                        })
                    ]
                })
            })
        ]
    });
    /**
     * Activity Feed — what has actually happened across this adviser's clients, newest first.
     *
     * The sidebar had this item pointing at the Dashboard: a link to a screen that did not exist.
     * Built from timestamps the client list already carries, so it costs no extra requests. See
     * activityFeed.ts for what it can and cannot show (latest-of-each-kind, not a full audit trail).
     */ const adviserActivity = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                style: {
                    fontSize: 17,
                    fontWeight: 600,
                    marginBottom: 6
                },
                children: "Activity Feed"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    fontSize: 14,
                    color: 'var(--muted)',
                    marginBottom: 18
                },
                children: "Recent milestones across your clients \u2014 what they have done, and what you have. Most recent first."
            }),
            activityEvents.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ccm",
                style: {
                    padding: '14px 0'
                },
                children: "Nothing yet. Milestones appear here as clients are invited, fill in their profile, and you model their options and issue advice."
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Client"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "What happened"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Who"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "When"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Actions"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                            children: activityEvents.map((ev)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "tn",
                                            children: ev.clientName
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                style: {
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: 8
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "pd",
                                                        style: {
                                                            background: (0, $397d0cafc1acbe4a$export$f88b35d024b1908)[ev.kind].colour,
                                                            flex: '0 0 auto'
                                                        }
                                                    }),
                                                    ev.label
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "tm",
                                            children: ev.actor === 'client' ? 'Client' : 'You'
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "tm",
                                            children: $3bd107510f74a4b4$var$formatLastActivityDisplay(ev.at)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "abtns",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "ab p",
                                                    onClick: ()=>onOpenCaseJourney(ev.caseId),
                                                    children: "Open \u2192"
                                                })
                                            })
                                        })
                                    ]
                                }, `${ev.caseId}-${ev.kind}`))
                        })
                    ]
                })
            })
        ]
    });
    const adviserAnalytics = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f84f127c8c7e0e3d$export$125fcc61d7e7ba3), {
        cases: cases,
        dataState: analyticsDataState
    });
    const adviserSettings = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f84f127c8c7e0e3d$export$34925f746332c764), {
        identity: realIdentity,
        firmSettings: firmSettings,
        messageDefaults: messageDefaults,
        onSaveFirmSettings: onSaveFirmSettings
    });
    const practiceDashboard = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bok",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                        viewBox: "0 0 24 24",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M22 11.08V12a10 10 0 11-5.93-9.14"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
                                points: "22 4 12 14.01 9 11.01"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                        style: {
                            marginRight: 4
                        },
                        children: [
                            metrics.ready,
                            " clients"
                        ]
                    }),
                    " ready for modelling across your practice.",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        style: {
                            marginLeft: 'auto',
                            fontSize: 12,
                            fontWeight: 600,
                            color: '#065f46',
                            textDecoration: 'underline',
                            background: 'none',
                            border: 'none'
                        },
                        onClick: ()=>setView($3bd107510f74a4b4$var$V.pracClients),
                        children: "View \u2192"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bwarn",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                        viewBox: "0 0 24 24",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                cx: "12",
                                cy: "12",
                                r: "10"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                x1: "12",
                                y1: "8",
                                x2: "12",
                                y2: "12"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                x1: "12",
                                y1: "16",
                                x2: "12.01",
                                y2: "16"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                        style: {
                            marginRight: 4
                        },
                        children: [
                            metrics.followups,
                            " clients"
                        ]
                    }),
                    " may need follow-up across the practice.",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        style: {
                            marginLeft: 'auto',
                            fontSize: 12,
                            fontWeight: 600,
                            color: '#92400e',
                            textDecoration: 'underline',
                            background: 'none',
                            border: 'none'
                        },
                        onClick: ()=>setView($3bd107510f74a4b4$var$V.pracFollow),
                        children: "Manage \u2192"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "krow",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "kcard",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kl",
                                children: "Advisers / CROs"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kv",
                                children: "6"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ks",
                                children: "Demo team"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "kcard",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kl",
                                children: "Active Client Cases"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kv",
                                children: metrics.total
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ks g",
                                children: "In this practice"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "kcard",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kl",
                                children: "Awaiting Data"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kv",
                                children: metrics.awaiting
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ks a",
                                children: "Invited + in progress"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "kcard",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kl",
                                children: "Completed This Month"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kv",
                                children: metrics.ready
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ks g",
                                children: "Submitted profiles"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "sh",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "sh-t",
                        children: "Advisers & Accountants"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "bsm bp",
                        style: {
                            fontSize: 12,
                            padding: '5px 11px'
                        },
                        onClick: ()=>setModal('adduser'),
                        children: "+ Add Team Member"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    background: '#fff',
                    border: '1px solid var(--bdr)',
                    borderRadius: 'var(--rl)',
                    padding: '4px 15px',
                    marginBottom: 22
                },
                children: [
                    'Joncarl La Rosa',
                    'Sarah Chen',
                    'Raj Patel'
                ].map((name, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ar",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ar-ava",
                                style: {
                                    background: [
                                        'linear-gradient(135deg,#1a6fd4,#17b8e0)',
                                        'linear-gradient(135deg,#7c3aed,#a78bfa)',
                                        'linear-gradient(135deg,#c2410c,#fb923c)'
                                    ][i]
                                },
                                children: name.split(' ').map((p)=>p[0]).join('')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "ar-info",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "ar-name",
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "ar-meta",
                                        children: i === 2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                "Accountant \xb7 ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "mtag mt-acc",
                                                    children: "Accountant"
                                                }),
                                                ' ',
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        fontSize: 10,
                                                        color: 'var(--amb)'
                                                    },
                                                    children: "\u26A0 Facilitator only"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                "Financial Adviser",
                                                i === 0 ? " \xb7 CFP" : '',
                                                " \xb7 ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "mtag mt-adv",
                                                    children: "Adviser"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "ar-stats",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "ast",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "astv",
                                                children: i === 0 ? 8 : i === 1 ? 6 : 5
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "astl",
                                                children: "Clients"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "ast",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "astv",
                                                style: {
                                                    color: 'var(--grn)'
                                                },
                                                children: i === 0 ? 3 : i === 1 ? 2 : 1
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "astl",
                                                children: "Done"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "ast",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "astv",
                                                style: {
                                                    color: i === 2 ? 'var(--dark)' : 'var(--amb)'
                                                },
                                                children: i === 0 ? 2 : i === 1 ? 1 : 0
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "astl",
                                                children: "Overdue"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginLeft: 12
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "ab",
                                    children: "View \u2192"
                                })
                            })
                        ]
                    }, name))
            })
        ]
    });
    const practiceClientsTable = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "sh",
                style: {
                    marginBottom: 14
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "sh-t",
                        children: "All Client Engagements"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "bsm bp",
                        style: {
                            fontSize: 12
                        },
                        onClick: ()=>setModal('invite'),
                        children: "+ New Engagement"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "thdr",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    fontSize: 13,
                                    fontWeight: 500,
                                    color: 'var(--dark)'
                                },
                                children: [
                                    filteredCases.length,
                                    " total"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                className: "si",
                                placeholder: "Search\u2026",
                                value: search,
                                onChange: (e)=>setSearch(e.target.value)
                            })
                        ]
                    }),
                    clientTableFilterBar,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Client"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Adviser"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Last Activity"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Access"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: clientTableFilteredCases.map((c)=>{
                                    const pt = $3bd107510f74a4b4$var$profileTag(c);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "tn",
                                                        children: c.clientName
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "te",
                                                        children: c.clientEmail
                                                    }),
                                                    c.clientMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "te",
                                                        children: c.clientMobile
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "tm",
                                                children: c.ownerName
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: pt.cls,
                                                    children: pt.label
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "tm",
                                                children: $3bd107510f74a4b4$var$formatLastActivityDisplay(c.lastActivityAt)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: $3bd107510f74a4b4$var$accessModeClass(c.accessMode),
                                                    children: $3bd107510f74a4b4$var$accessModeLabel(c.accessMode)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "abtns",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "ab p",
                                                        onClick: ()=>onOpenCaseJourney(c.id),
                                                        children: "Open \u2192"
                                                    })
                                                })
                                            })
                                        ]
                                    }, c.id);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
    const practiceFollow = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                style: {
                    fontSize: 17,
                    fontWeight: 600,
                    marginBottom: 6
                },
                children: "Follow-up Centre"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    fontSize: 14,
                    color: 'var(--muted)',
                    marginBottom: 18
                },
                children: "Practice-wide rules and overdue clients across all advisers."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    background: '#fff',
                    border: '1px solid var(--bdr)',
                    borderRadius: 'var(--rl)',
                    padding: 20,
                    marginBottom: 20
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 14,
                            fontWeight: 600,
                            marginBottom: 13
                        },
                        children: "Practice-wide Reminder Rules"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "fur",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ful",
                                children: "First reminder if not opened after"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                className: "fus",
                                defaultValue: "5 days",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        children: "3 days"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        children: "5 days"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        children: "7 days"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "fur",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ful",
                                children: "Second reminder if still inactive"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                className: "fus",
                                defaultValue: "10 days",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        children: "7 days"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        children: "10 days"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        children: "14 days"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "fur",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ful",
                                children: "Alert adviser if stalled after"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                className: "fus",
                                defaultValue: "2 days",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        children: "2 days"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        children: "3 days"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        children: "5 days"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "bsm bp",
                        style: {
                            marginTop: 13
                        },
                        children: "Save Rules"
                    })
                ]
            }),
            adviserFollowups
        ]
    });
    const practiceSettings = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f84f127c8c7e0e3d$export$186b63797f9ccb51), {});
    const licenseeDash = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "krow",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "kcard",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kl",
                                children: "Total Practices"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kv",
                                children: "8"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ks g",
                                children: "Demo"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "kcard",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kl",
                                children: "Total Advisers"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kv",
                                children: "34"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ks",
                                children: "Across all practices"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "kcard",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kl",
                                children: "Active Client Cases"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kv",
                                children: cases.length
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ks a",
                                children: "All demo cases"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "kcard",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kl",
                                children: "Subscriptions"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "kv",
                                style: {
                                    fontSize: 20
                                },
                                children: "8"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ks",
                                children: "Active plans"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "sh",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "sh-t",
                        children: "Practices Under Licence"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "fps",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "fp on",
                                children: "All"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "fp",
                                children: "Active"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "fp",
                                children: "Issues"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "sum-grid",
                children: [
                    [
                        'La Rosa & Partners',
                        'Chen & Associates',
                        'Rivers Wealth'
                    ].map((name, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "scard",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "sc-top",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "sc-name",
                                            children: name
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: idx === 2 ? 'tag t-st' : 'tag t-ok',
                                            children: idx === 2 ? 'Issue' : 'Active'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tm",
                                    style: {
                                        fontSize: 12
                                    },
                                    children: [
                                        [
                                            'Sydney',
                                            'Melbourne',
                                            'Brisbane'
                                        ][idx],
                                        " \xb7 Demo"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "sc-mini",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "sm",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "smv",
                                                    children: 4 + idx
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "sml",
                                                    children: "Advisers"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "sm",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "smv",
                                                    children: 12 + idx * 6
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "sml",
                                                    children: "Clients"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "sm",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "smv",
                                                    style: {
                                                        color: 'var(--amb)'
                                                    },
                                                    children: idx
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "sml",
                                                    children: "Overdue"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "sc-foot",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "sc-sub",
                                            children: "Renews demo"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "sc-btn",
                                            children: "View practice \u2192"
                                        })
                                    ]
                                })
                            ]
                        }, name)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "scard",
                        style: {
                            border: '1.5px dashed var(--bdr)',
                            boxShadow: 'none',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 7
                        },
                        onClick: ()=>setModal('addprac'),
                        role: "button",
                        tabIndex: 0,
                        onKeyDown: (e)=>e.key === 'Enter' && setModal('addprac'),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 26,
                                    color: 'var(--lite)'
                                },
                                children: "+"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    fontWeight: 500,
                                    color: 'var(--muted)'
                                },
                                children: "Onboard New Practice"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "sh",
                style: {
                    marginTop: 28
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "sh-t",
                        children: "All client engagements (demo)"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            fontSize: 13,
                            color: 'var(--muted)',
                            margin: '0 0 12px'
                        },
                        children: "Same case list as practice view \u2014 use Open \u2192 to return to the client journey (Dashboard resumes where you left off)."
                    })
                ]
            }),
            practiceClientsTable
        ]
    });
    const licenseeBilling = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                style: {
                    fontSize: 17,
                    fontWeight: 600,
                    marginBottom: 18
                },
                children: "Billing & Subscriptions"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Practice"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Advisers"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Annual Fee"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Status"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Renews"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Actions"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                            children: [
                                [
                                    'La Rosa & Partners',
                                    '6',
                                    'Active',
                                    '12 Mar 2026',
                                    false
                                ],
                                [
                                    'Chen & Associates',
                                    '4',
                                    'Active',
                                    '5 Jul 2025',
                                    false
                                ],
                                [
                                    'Rivers Wealth',
                                    '3',
                                    'Failed',
                                    "\u2014",
                                    true
                                ],
                                [
                                    'Northside Planning',
                                    '5',
                                    'Active',
                                    '22 Aug 2025',
                                    false
                                ]
                            ].map(([name, adv, _st, renew, failed])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "tn",
                                            children: name
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "tm",
                                            children: adv
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "tm",
                                            children: "$2,450"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: failed ? 'tag t-st' : 'tag t-ok',
                                                children: failed ? 'Failed' : 'Active'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "tm",
                                            children: renew
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "abtns",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: failed ? 'ab p' : 'ab',
                                                    children: failed ? 'Retry Payment' : 'Invoice'
                                                })
                                            })
                                        })
                                    ]
                                }, name))
                        })
                    ]
                })
            })
        ]
    });
    const licenseeAdvisers = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                style: {
                    fontSize: 17,
                    fontWeight: 600,
                    marginBottom: 18
                },
                children: "All Advisers Across Licence"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Adviser"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Practice"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Role"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Clients"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        children: "Actions"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "tn",
                                                children: "Joncarl La Rosa"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "te",
                                                children: "james@demo.local"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        className: "tm",
                                        children: "La Rosa & Partners"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "mtag mt-adv",
                                            children: "Adviser"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        className: "tm",
                                        children: "8"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "abtns",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: "ab",
                                                children: "View \u2192"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
    const renderMainViews = ()=>{
        if (role === 'relationship_owner') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    id: $3bd107510f74a4b4$var$V.advDash,
                    className: `pview${activeView === $3bd107510f74a4b4$var$V.advDash ? ' on' : ''}`,
                    children: adviserDashboard
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    id: $3bd107510f74a4b4$var$V.advFollow,
                    className: `pview${activeView === $3bd107510f74a4b4$var$V.advFollow ? ' on' : ''}`,
                    children: adviserFollowups
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    id: $3bd107510f74a4b4$var$V.advSoas,
                    className: `pview${activeView === $3bd107510f74a4b4$var$V.advSoas ? ' on' : ''}`,
                    children: adviserSoas
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    id: $3bd107510f74a4b4$var$V.advSettings,
                    className: `pview${activeView === $3bd107510f74a4b4$var$V.advSettings ? ' on' : ''}`,
                    children: realIdentity ? realFirmSettings : adviserSettings
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    id: $3bd107510f74a4b4$var$V.advActivity,
                    className: `pview${activeView === $3bd107510f74a4b4$var$V.advActivity ? ' on' : ''}`,
                    children: adviserActivity
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    id: $3bd107510f74a4b4$var$V.advAnalytics,
                    className: `pview${activeView === $3bd107510f74a4b4$var$V.advAnalytics ? ' on' : ''}`,
                    children: adviserAnalytics
                })
            ]
        });
        if (role === 'practice_owner') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    id: $3bd107510f74a4b4$var$V.pracDash,
                    className: `pview${activeView === $3bd107510f74a4b4$var$V.pracDash ? ' on' : ''}`,
                    children: practiceDashboard
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    id: $3bd107510f74a4b4$var$V.pracClients,
                    className: `pview${activeView === $3bd107510f74a4b4$var$V.pracClients ? ' on' : ''}`,
                    children: practiceClientsTable
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    id: $3bd107510f74a4b4$var$V.pracFollow,
                    className: `pview${activeView === $3bd107510f74a4b4$var$V.pracFollow ? ' on' : ''}`,
                    children: practiceFollow
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    id: $3bd107510f74a4b4$var$V.pracSettings,
                    className: `pview${activeView === $3bd107510f74a4b4$var$V.pracSettings ? ' on' : ''}`,
                    children: practiceSettings
                })
            ]
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    id: $3bd107510f74a4b4$var$V.licDash,
                    className: `pview${activeView === $3bd107510f74a4b4$var$V.licDash ? ' on' : ''}`,
                    children: licenseeDash
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    id: $3bd107510f74a4b4$var$V.licAdvisers,
                    className: `pview${activeView === $3bd107510f74a4b4$var$V.licAdvisers ? ' on' : ''}`,
                    children: licenseeAdvisers
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    id: $3bd107510f74a4b4$var$V.licBilling,
                    className: `pview${activeView === $3bd107510f74a4b4$var$V.licBilling ? ' on' : ''}`,
                    children: licenseeBilling
                })
            ]
        });
    };
    // A signed-in firm member is entering: show a branded loading state while their workspace
    // resolves — NEVER the demo login wireframe (owner-reported: real firms saw the demo screen).
    if (realModeLoading && !realIdentity) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "pp-wireframe",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "pp-auth-screen",
            style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d5b7fd8298af6838$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        position: 'relative',
                        zIndex: 1,
                        textAlign: 'center',
                        color: '#0f172a'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                width: 44,
                                height: 44,
                                margin: '0 auto 16px',
                                borderRadius: '50%',
                                border: '3px solid #dbeafe',
                                borderTopColor: '#2563eb',
                                animation: 'ppspin 0.8s linear infinite'
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            style: {
                                fontSize: 15,
                                fontWeight: 600
                            },
                            children: "Opening your workspace\u2026"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("style", {
                            children: '@keyframes ppspin{to{transform:rotate(360deg)}}'
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "pp-wireframe",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pp-portal-root",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("aside", {
                        className: "sb",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "sb-top",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "sb-logo",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "a",
                                                children: "AgedCare"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "b",
                                                children: "Wise"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "sb-badge",
                                        children: "Partner Portal"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "sb-ctx",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "sb-ctx-lbl",
                                        children: "Signed in as"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: `sb-lvl ${cfg.lvlCls}`,
                                        children: cfg.lvlLabel
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "sb-ctx-name",
                                        children: cfg.ctxName
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "sb-ctx-sub",
                                        children: cfg.ctxSub
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                                "aria-label": "Portal",
                                children: cfg.nav.map((item, idx)=>{
                                    if ('sect' in item) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "sb-sect",
                                        children: item.sect
                                    }, `s-${idx}`);
                                    const badge = item.badgeKey ? badgeCounts[item.badgeKey] : null;
                                    const isOn = navActiveId === item.id;
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        className: `nl${isOn ? ' on' : ''}`,
                                        onClick: ()=>setView(item.id),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3bd107510f74a4b4$var$NavIcon, {
                                                name: item.icon
                                            }),
                                            item.label,
                                            badge != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: `nbadge ${item.badgeCls || ''}`,
                                                children: badge
                                            }) : null
                                        ]
                                    }, `${item.id}-${item.label}-${idx}`);
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "sb-foot",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "urow",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "uava",
                                                style: {
                                                    background: cfg.avaColor
                                                },
                                                children: cfg.avaInit
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "un",
                                                        children: cfg.uname
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "ur",
                                                        children: cfg.urole
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    onOpenAdmin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        className: "sb-admin",
                                        onClick: onOpenAdmin,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                width: "14",
                                                height: "14",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                "aria-hidden": "true",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        d: "m9 12 2 2 4-4"
                                                    })
                                                ]
                                            }),
                                            "Platform Admin"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "sb-out",
                                        onClick: onExitToConsumer,
                                        children: "Sign out"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "pmain",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "topbar",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tb-title",
                                        children: $3bd107510f74a4b4$var$VIEW_TITLES[activeView] || 'Dashboard'
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "bc",
                                        "aria-hidden": "true",
                                        children: realIdentity ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    children: realIdentity.firmName
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "/"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    children: realIdentity.adviserName
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                role === 'relationship_owner' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            children: "La Rosa & Partners"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "/"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            children: "Joncarl La Rosa"
                                                        })
                                                    ]
                                                }),
                                                role === 'practice_owner' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            children: "Licensee"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "/"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            children: "La Rosa & Partners"
                                                        })
                                                    ]
                                                }),
                                                role === 'licensee' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    children: "Demo Licensee Group"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tb-r",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "notif",
                                                role: "button",
                                                tabIndex: 0,
                                                "aria-label": metrics.followups > 0 ? `Follow-ups: ${metrics.followups} waiting` : 'Follow-ups',
                                                title: metrics.followups > 0 ? `${metrics.followups} follow-up${metrics.followups === 1 ? '' : 's'} waiting` : 'Follow-ups',
                                                onClick: ()=>setView(role === 'practice_owner' ? $3bd107510f74a4b4$var$V.pracFollow : $3bd107510f74a4b4$var$V.advFollow),
                                                onKeyDown: (e)=>{
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                        e.preventDefault();
                                                        setView(role === 'practice_owner' ? $3bd107510f74a4b4$var$V.pracFollow : $3bd107510f74a4b4$var$V.advFollow);
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                        viewBox: "0 0 24 24",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M13.73 21a2 2 0 01-3.46 0"
                                                            })
                                                        ]
                                                    }),
                                                    metrics.followups > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "ndot"
                                                    })
                                                ]
                                            }),
                                            cfg.topInvite && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                className: "bsm bg",
                                                onClick: ()=>setModal('invite'),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                        viewBox: "0 0 24 24",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
                                                                points: "22,6 12,13 2,6"
                                                            })
                                                        ]
                                                    }),
                                                    "Invite Client"
                                                ]
                                            }),
                                            cfg.topInPerson && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                className: "bsm bp",
                                                onClick: ()=>setModal('inperson'),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                        viewBox: "0 0 24 24",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                                cx: "9",
                                                                cy: "7",
                                                                r: "4"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                                                x1: "19",
                                                                y1: "8",
                                                                x2: "19",
                                                                y2: "14"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                                                x1: "22",
                                                                y1: "11",
                                                                x2: "16",
                                                                y2: "11"
                                                            })
                                                        ]
                                                    }),
                                                    "New Client (In-Person)"
                                                ]
                                            }),
                                            cfg.topPracticeExtras && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: "bsm bp",
                                                onClick: ()=>setModal('adduser'),
                                                children: "Add Team"
                                            }),
                                            cfg.topLicensee && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                className: "bsm bp",
                                                onClick: ()=>setModal('addprac'),
                                                children: "Onboard Practice"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tabs",
                                role: "tablist",
                                children: tabsWithBadges.map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        role: "tab",
                                        className: `tab${activeView === t.id ? ' on' : ''}`,
                                        onClick: ()=>setView(t.id),
                                        children: [
                                            t.label,
                                            t.badge ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    fontSize: 10,
                                                    background: 'var(--amb)',
                                                    color: '#fff',
                                                    borderRadius: 9,
                                                    padding: '1px 6px',
                                                    marginLeft: 4
                                                },
                                                children: t.badge
                                            }) : null
                                        ]
                                    }, t.id))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "pscroll",
                                children: renderMainViews()
                            })
                        ]
                    })
                ]
            }),
            renderInviteModal(),
            renderInPersonModal(),
            renderAddUserModal(),
            renderAddPracticeModal()
        ]
    });
}


/**
 * Professional-portal domain: the signed-in firm member's workspace (real client list + firm
 * identity + billing gates) and the professional "case" lifecycle (in-person/invite intake,
 * opening a case's journey, SOA draft/publish/delete). Extracted out of App.tsx, which composes
 * this alongside the consumer-side session/auth and page-routing concerns.
 */ 
var $acw62 = parcelRequire("acw62");








/**
 * Advice register (compliance-grade SOA storage): every SOA generated for a REAL client file is
 * also written to the server's versioned register — immutable, numbered, attributed to the
 * licensee, and recorded on the tamper-evident audit trail. The in-app copy remains the working
 * view; the register is the legal record.
 */ 


function $3ca5b2fc75d0c72b$var$getApiBaseUrl() {
    // One source for this — see services/apiBase.ts for why eight copies was a problem.
    return (0, $4e54353814e6aea9$export$8ebae31efd30e025)();
}
async function $3ca5b2fc75d0c72b$var$authHeaders() {
    const token = await (0, $cc9e8a24185b91b0$export$84773cc9bf7dbe87)();
    if (!token) throw new Error('Not signed in');
    return {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
}
async function $3ca5b2fc75d0c72b$export$900fe88f3237d3b7(profileId, module, document) {
    const headers = await $3ca5b2fc75d0c72b$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$3ca5b2fc75d0c72b$var$getApiBaseUrl()}/rest/profiles/${profileId}/soas`, {
        module: module,
        document: document
    }, {
        headers: headers,
        timeout: 60000
    });
    return res.data;
}
async function $3ca5b2fc75d0c72b$export$1191fb166f7f7cba(module, document) {
    const headers = await $3ca5b2fc75d0c72b$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$3ca5b2fc75d0c72b$var$getApiBaseUrl()}/rest/profiles/mine/soas`, {
        module: module,
        document: document
    }, {
        headers: headers,
        timeout: 60000
    });
    return res.data;
}
async function $3ca5b2fc75d0c72b$export$35113fc8f9ba8931(soaId) {
    const headers = await $3ca5b2fc75d0c72b$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$3ca5b2fc75d0c72b$var$getApiBaseUrl()}/rest/soas/${soaId}/publish`, {}, {
        headers: headers,
        timeout: 30000
    });
    return res.data;
}
async function $3ca5b2fc75d0c72b$export$3d5e9e266a6dea6d(profileId, module) {
    const headers = await $3ca5b2fc75d0c72b$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${$3ca5b2fc75d0c72b$var$getApiBaseUrl()}/rest/profiles/${profileId}/soas`, {
        headers: headers,
        params: module ? {
            module: module
        } : undefined,
        timeout: 30000
    });
    return res.data?.soas ?? [];
}
async function $3ca5b2fc75d0c72b$export$524c7af693144442(profileId, module, label, payload, modelId) {
    const headers = await $3ca5b2fc75d0c72b$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${$3ca5b2fc75d0c72b$var$getApiBaseUrl()}/rest/profiles/${profileId}/models`, {
        module: module,
        label: label,
        payload: payload,
        ...modelId ? {
            modelId: modelId
        } : {}
    }, {
        headers: headers,
        timeout: 60000
    });
    return res.data;
}
async function $3ca5b2fc75d0c72b$export$8d63af86d795ece4(profileId, module) {
    const headers = await $3ca5b2fc75d0c72b$var$authHeaders();
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${$3ca5b2fc75d0c72b$var$getApiBaseUrl()}/rest/profiles/${profileId}/models`, {
        headers: headers,
        params: module ? {
            module: module
        } : undefined,
        timeout: 30000
    });
    return res.data?.models ?? [];
}



function $52bda4b4ecde5a3b$var$cloneInitialFactFind() {
    return structuredClone((0, $b116352393ba4abb$export$55f731ae3600e88a));
}
function $52bda4b4ecde5a3b$var$isoDateDaysAgo(daysAgo = 0) {
    const d = new Date();
    d.setDate(d.getDate() - daysAgo);
    return d.toISOString();
}
const $52bda4b4ecde5a3b$var$FIRST_NAMES = [
    'Irene',
    'John',
    'Thomas',
    'Gloria',
    'Frank',
    'Anne',
    'Kevin',
    'Mei',
    'Sarah',
    'Raj',
    'Helen',
    'Robert',
    'Nina',
    'Oscar',
    'Liam',
    'Sophia',
    'Grace',
    'Ethan',
    'Mia',
    'Lucas',
    'Ava',
    'Noah',
    'Ella',
    'James'
];
const $52bda4b4ecde5a3b$var$LAST_NAMES = [
    'Kowalski',
    'Blackwell',
    'Reid',
    'Morrison',
    'Okafor',
    'Tan',
    'Mitchell',
    'Patel',
    'Chen',
    'Sullivan',
    'Hart',
    'Wright',
    'Brooks',
    'Davies',
    'Clarke',
    'Nguyen'
];
const $52bda4b4ecde5a3b$var$GOAL_SETS = [
    {
        aged_care: true,
        meet_costs: true,
        preserve_assets: true
    },
    {
        home_care: true,
        maximise_support: true
    },
    {
        aged_care: true,
        home_care: true,
        meet_costs: true,
        funding_guidance: true
    },
    {
        downsize_home: true,
        preserve_assets: true
    },
    {
        retirement_village: true,
        funding_guidance: true
    }
];
const $52bda4b4ecde5a3b$var$HOME_DECISIONS = [
    'keep_home',
    'sell_home',
    'rent_home',
    'downsize_home'
];
const $52bda4b4ecde5a3b$var$FUNDING_MODES = [
    'full_rad',
    'partial_rad',
    'dap_only'
];
const $52bda4b4ecde5a3b$var$SUGGESTION_SOA_SELECTIONS = [
    'optimal_estate',
    'optimal_cashflow',
    'optimal_age_pension',
    'other_from_full_list'
];
const $52bda4b4ecde5a3b$var$ASSET_SELL_PATTERNS = [
    [
        'bankAccounts'
    ],
    [
        'bankAccounts',
        'shares'
    ],
    [
        'accountBasedPensions'
    ],
    [
        'shares',
        'superannuation'
    ],
    [
        'investmentProperty'
    ],
    [
        'bankAccounts',
        'termDeposits',
        'shares'
    ]
];
function $52bda4b4ecde5a3b$var$createDummyFactFind(index, isCouple = false) {
    const fd = $52bda4b4ecde5a3b$var$cloneInitialFactFind();
    // INITIAL_FACT_FIND always populates these sections, but the type keeps them optional (they're
    // lazily created on some paths) — assert non-null rather than widen every field to `| undefined`.
    const client = fd.client;
    const partner = fd.partner;
    const home = fd.home;
    const expenses = fd.expenses;
    const family = fd.family;
    const firstName = $52bda4b4ecde5a3b$var$FIRST_NAMES[index % $52bda4b4ecde5a3b$var$FIRST_NAMES.length];
    const lastName = $52bda4b4ecde5a3b$var$LAST_NAMES[index % $52bda4b4ecde5a3b$var$LAST_NAMES.length];
    const year = 1940 + index % 18;
    const month = String(index % 12 + 1).padStart(2, '0');
    const day = String(index % 27 + 1).padStart(2, '0');
    client.firstName = firstName;
    client.lastName = lastName;
    client.dob = `${year}-${month}-${day}`;
    client.currentResidency = index % 3 === 0 ? 'own_home' : 'renting';
    client.healthStatus = index % 4 === 0 ? 'fair' : 'good';
    fd.adviceFor = isCouple ? 'couple' : 'single';
    if (isCouple) {
        partner.firstName = $52bda4b4ecde5a3b$var$FIRST_NAMES[(index + 3) % $52bda4b4ecde5a3b$var$FIRST_NAMES.length];
        partner.lastName = lastName;
        partner.dob = `${year + 2}-${month}-${day}`;
        partner.currentResidency = client.currentResidency;
        partner.healthStatus = index % 5 === 0 ? 'fair' : 'good';
    }
    fd.goals = $52bda4b4ecde5a3b$var$GOAL_SETS[index % $52bda4b4ecde5a3b$var$GOAL_SETS.length];
    home.value = 700000 + index % 8 * 50000;
    home.likelyRent = 35000 + index % 5 * 2500;
    home.likelyExpenses = 9000 + index % 4 * 1200;
    expenses.livingExpenses = 42000 + index % 6 * 2800;
    family.childrenCount = index % 4;
    return fd;
}
function $52bda4b4ecde5a3b$export$bffe8049574b5b4a(role) {
    if (role === 'licensee') return {
        type: 'licensee'
    };
    if (role === 'practice_owner') return {
        type: 'practice',
        practiceId: 'prac-harbour'
    };
    return {
        type: 'owner',
        ownerId: 'adv-jm'
    };
}


/**
 * Which column of the Partner Portal pipeline a REAL client file belongs in.
 *
 * This is the piece that was missing. `mapProfileToCase` used to hardcode every real client to
 * `status: 'started', profileProgressPct: 50, soaStatus: 'none'`, so a client whose fact-find was
 * finished, whose strategies had been modelled and whose SOA had been generated sat in "In Progress
 * — 50% — No SOA yet", in the same column as a file nobody had touched. The pipeline was therefore
 * decorative: it never moved, whatever anyone did.
 *
 * The stage is DERIVED, not stored, and derived from evidence the server can see without decrypting
 * anything (see ClientProfileWorkflow): how much of the fact-find is filled in, whether any modelling
 * has been saved, and whether an SOA has been generated or published. Nothing here needs a workflow
 * status field that someone has to remember to update — the client's actual progress IS the status,
 * so it can't drift out of sync with reality the way a manually-advanced flag would.
 *
 * Order matters: the checks run from the FURTHEST stage backwards, because progress is cumulative
 * (an SOA implies the fact-find got finished) and the furthest evidence is what the adviser cares about.
 */ /**
 * Below this, a file is "not really started". An invite flow seeds the client's name from the invite
 * form, which alone can tick the first step — so requiring exactly 0% would move a client out of
 * "Invite Sent" before they had opened the link at all.
 */ const $2ec062e20945936a$var$INVITE_UNTOUCHED_MAX_PCT = 15;
/** What each stage implies about progress, for a file the server hasn't measured yet. */ const $2ec062e20945936a$var$STAGE_PROGRESS_FLOOR = {
    draft: 0,
    invited: 0,
    started: 50,
    submitted: 100,
    adviser_review: 100,
    soa_draft: 100,
    soa_published: 100
};
function $2ec062e20945936a$export$abc532b04182baa7(workflow, invitedOverride) {
    const measured = typeof workflow?.progressPct === 'number' ? workflow.progressPct : null;
    const soaCount = workflow?.soaCount ?? 0;
    const publishedCount = workflow?.soaPublishedCount ?? 0;
    const modelCount = workflow?.modelCount ?? 0;
    const completedAt = workflow?.completedAt ?? null;
    // An invite that was sent, never accepted, and hasn't been revoked or expired. This is the ONLY
    // thing that distinguishes a client who was sent a link and hasn't opened it from one the adviser
    // created in person — both otherwise look like an untouched file. Derived from the server rather
    // than held in memory, so it survives a page reload; before this, an invited client silently
    // reappeared as "in progress" the moment the portal reloaded.
    const inviteOutstanding = invitedOverride ?? Boolean(workflow?.inviteSentAt && !workflow?.inviteAcceptedAt && !workflow?.inviteClosed);
    const soaStatus = publishedCount > 0 ? 'published' : soaCount > 0 ? 'draft' : 'none';
    const status = (()=>{
        // An SOA is the furthest a file goes, and a published one outranks a draft.
        if (publishedCount > 0) return 'soa_published';
        if (soaCount > 0) return 'soa_draft';
        // Modelling saved against the file means an adviser has actively worked it.
        if (modelCount > 0) return 'adviser_review';
        // Fact-find finished, nothing modelled yet — this is the queue that needs an adviser.
        if (completedAt || measured === 100) return 'submitted';
        // An outstanding invite on a file with nothing meaningful in it yet: still waiting on the
        // client to open the link. A part-filled file means they HAVE started, invite or not.
        if (inviteOutstanding && (measured === null || measured <= $2ec062e20945936a$var$INVITE_UNTOUCHED_MAX_PCT)) return 'invited';
        return 'started';
    })();
    return {
        status: status,
        soaStatus: soaStatus,
        // A measured percentage always wins. Where the file predates measurement, the stage itself
        // implies a floor — an SOA can't exist against a half-finished fact-find — which is honest
        // about being an inference rather than quietly presenting a made-up number as measured.
        progressPct: measured ?? $2ec062e20945936a$var$STAGE_PROGRESS_FLOOR[status],
        progressIsEstimated: measured === null,
        submissionDate: completedAt
    };
}




/**
 * The invite form asks "Who will be completing this form?" and the client's profile asks the same
 * on its step 1. Until 16 Oct 2026 the adviser's answer went only to the demo case: a client invited
 * as "a family member" opened step 1 to find "I am the person seeking advice" selected.
 */ function $61be87c42767c473$export$d9ef07e10d41ffe6(answer) {
    switch(answer){
        case 'family_member':
            return 'family';
        case 'epoa':
            return 'eop';
        case 'professional':
            return 'professional';
        default:
            return 'client';
    }
}
function $61be87c42767c473$export$b141d1c0193c3d71(input) {
    const t = (v)=>(v || '').trim();
    const completer = $61be87c42767c473$export$d9ef07e10d41ffe6(input.completingAs);
    const invitee = {
        firstName: t(input.firstName),
        lastName: t(input.lastName)
    };
    const join = (p)=>[
            p.firstName,
            p.lastName
        ].filter(Boolean).join(' ').trim();
    if (completer === 'client') return {
        completer: completer,
        client: invitee,
        displayName: join(invitee)
    };
    // The file is called after the person invited until the profile names the client.
    return {
        completer: completer,
        client: {
            firstName: '',
            lastName: ''
        },
        completerFirstName: invitee.firstName || undefined,
        completerLastName: invitee.lastName || undefined,
        completerRelationship: t(input.relationship) || undefined,
        displayName: join(invitee)
    };
}


/**
 * Our own licence, for advice given under it rather than a firm's (an accountant's clients, say).
 *
 * The AFSL number is deliberately absent until it is real. adviceAttribution() reports the line as
 * incomplete without it rather than printing a placeholder, because a made-up licence number on a
 * client document looks finished and so nobody goes looking for it.
 */ const $4a3ab415a7732163$var$PLATFORM_LICENCE = {
    entityName: 'AgedCareWise Pty Ltd',
    afslNumber: null
};
const $4a3ab415a7732163$export$77b890292aeb9804 = [
    'Dashboard',
    'Client Profile',
    'AssumptionsPage',
    'AgedCarePage',
    'HomeCarePage',
    'RetirementVillagePage',
    'GrannyFlatPage',
    'DownsizingPage'
];
/** When primary applicant details exist in the fact-find, use them for Partner Portal list (overrides placeholders like "Applicant TBC (completer)"). */ function $4a3ab415a7732163$var$deriveEngagementLabelsFromFactFind(fd) {
    if (!fd) return {};
    const patch = {};
    const cf = (fd.client?.firstName || '').trim();
    const cl = (fd.client?.lastName || '').trim();
    const pf = (fd.partner?.firstName || '').trim();
    const pl = (fd.partner?.lastName || '').trim();
    const email = (fd.client?.email || '').trim();
    const adviceFor = fd.adviceFor || 'single';
    if (adviceFor === 'couple' && cf && pf) {
        const last = (cl || pl || '').trim();
        patch.clientName = last ? `${cf} & ${pf} ${last}` : `${cf} & ${pf}`;
    } else if (cf || cl) patch.clientName = [
        cf,
        cl
    ].filter(Boolean).join(' ').trim();
    if (email) patch.clientEmail = email;
    return patch;
}
async function $4a3ab415a7732163$export$2e7e98436b791c3c(attempts = 3) {
    for(let i = 0; i < attempts; i += 1)try {
        return {
            ok: true,
            membership: await (0, $442533e192804693$export$7417b9ab7638b3e6)()
        };
    } catch  {
        if (i < attempts - 1) await new Promise((r)=>setTimeout(r, 1200));
    }
    return {
        ok: false,
        membership: null
    };
}
function $4a3ab415a7732163$export$2aa10d7f02877481({ accountUser: accountUser, activePage: activePage, setActivePage: setActivePage, factFind: factFind, setFactFind: setFactFind, clientProfileStep: clientProfileStep, setClientProfileStep: setClientProfileStep, setSavedStrategies: setSavedStrategies, setCoupleValidation: setCoupleValidation, savedCaseStudies: savedCaseStudies, setSavedCaseStudies: setSavedCaseStudies, routePlatformAdminWithoutFirm: routePlatformAdminWithoutFirm }) {
    const [professionalRole, setProfessionalRole] = (0, $acw62.useState)('relationship_owner');
    /*
   * EMPTY, not a set of samples. This used to be seeded with twenty-four fabricated client files, so
   * the portal opened holding other people's names, ages and care situations until the real list
   * arrived — and if that fetch was slow or failed, an adviser sat looking at a book of business that
   * did not exist. Demo data has no business being the starting state of a screen that shows real
   * clients (owner's decision to remove the demo portal, 11 Sep 2026).
   */ const [professionalCases, setProfessionalCases] = (0, $acw62.useState)([]);
    const [activeProfessionalCaseId, setActiveProfessionalCaseId] = (0, $acw62.useState)(null);
    /** Increments when Partner Portal "Review" is clicked so the portal can switch to Reports & SOAs even if already on PartnerPortal. */ const [partnerPortalReviewNonce, setPartnerPortalReviewNonce] = (0, $acw62.useState)(0);
    // True while a sign-in was started from the partner door (routes to the portal, not resume).
    const [partnerIntent, setPartnerIntent] = (0, $acw62.useState)(false);
    // REAL portal mode: the signed-in user's firm membership, and (while an adviser has a real
    // client file open) that file's id — auto-save then targets the client's record.
    const [partnerFirm, setPartnerFirm] = (0, $acw62.useState)(null);
    const [activeRealProfileId, setActiveRealProfileId] = (0, $acw62.useState)(null);
    // True while the portal is resolving a signed-in firm member's workspace — the portal shows
    // a branded loading state instead of ever flashing the demo login (owner-reported race).
    const [partnerResolving, setPartnerResolving] = (0, $acw62.useState)(false);
    // Workspace resolution failed (server waking / network blip): show retry, never a dead screen.
    const [portalEntryError, setPortalEntryError] = (0, $acw62.useState)(false);
    const [portalRefreshNonce, setPortalRefreshNonce] = (0, $acw62.useState)(0);
    // Partner subscription gate — shown when a firm member enters the portal but the FIRM has no
    // active entitlement (and billing is live). Same safety: off while billing is off.
    const [partnerPaywall, setPartnerPaywall] = (0, $acw62.useState)(null);
    // Partner client-billing summary (plan/capacity/remaining) for the active firm, + the "add
    // another client" paywall when they run out of paid capacity mid-portal.
    const [partnerBilling, setPartnerBilling] = (0, $acw62.useState)(null);
    const [addClientPaywall, setAddClientPaywall] = (0, $acw62.useState)(null);
    const [showPartnerWizard, setShowPartnerWizard] = (0, $acw62.useState)(false);
    /** Advice-register versions per REAL profile id — the server-side truth behind Reports & SOAs. */ const [registeredSoasByProfileId, setRegisteredSoasByProfileId] = (0, $acw62.useState)({});
    /** The firm's working preferences (tenants.settings) — e.g. the default follow-up interval. */ const [firmSettings, setFirmSettings] = (0, $acw62.useState)({});
    /**
   * What this SERVER does about unresponsive clients, as opposed to what the firm has chosen. Kept
   * apart from firmSettings on purpose: one is the adviser's preference, the other is whether the
   * machinery honouring it is switched on, and conflating them is how a screen ends up describing a
   * setting nobody is acting on.
   */ const [autoReminders, setAutoReminders] = (0, $acw62.useState)(null);
    /** Our standard wording, from the server — shown so an adviser can read what we'd send. */ const [messageDefaults, setMessageDefaults] = (0, $acw62.useState)(null);
    /** Whether the Analytics tab's underlying fact-finds have been fetched yet (see loadFactFindsForAnalytics). */ const [analyticsDataState, setAnalyticsDataState] = (0, $acw62.useState)('idle');
    /** Real client files, dressed in the case shape the portal UI already renders. Strategy-engine
   *  fields (strategySource, homeDecision, roomFunding, etc.) don't exist yet for a freshly-listed
   *  real file — they're demo-only analytics dimensions — so sensible neutral defaults are used;
   *  factFind is a placeholder until loaded (encrypted server-side; fetched per file on open).
   *
   *  The STAGE, though, is real: derived from the server's workflow metadata (fact-find progress,
   *  saved models, SOAs) by derivePipelineStage. This used to be hardcoded to "started / 50% / no
   *  SOA", which is why a fully-modelled client with a generated SOA still sat in In Progress. */ /**
   * A firm's client file always arrives WITH its id: ids are withheld only from a caller whose one
   * visible file is their own, and a firm member is staff of the tenant these live in. See
   * resolveSoleProfileId — the id is required here rather than optional so that stops being a guess.
   */ const mapProfileToCase = (p)=>{
        const stage = (0, $2ec062e20945936a$export$abc532b04182baa7)(p.workflow);
        return {
            id: p.id,
            isReal: true,
            clientName: p.displayName || 'Client',
            clientEmail: '',
            // The adviser RESPONSIBLE for the file — which is not the same as who created it. Support can
            // prepare a file for an adviser, and it belongs on that adviser's book from the moment it exists.
            // Falls back to the creator for files that pre-date the column. scopedProfessionalCases matches
            // this against the signed-in user; the server enforces the same rule independently.
            ownerId: p.adviserUserId || p.createdBy || 'firm',
            adviserUserId: p.adviserUserId ?? null,
            visibility: p.visibility ?? 'firm',
            ownerName: '',
            ownerRole: 'adviser',
            practiceId: 'firm',
            accessMode: 'in_person',
            status: stage.status,
            profileProgressPct: stage.progressPct,
            profileProgressIsEstimated: stage.progressIsEstimated,
            profileCompletedSteps: p.workflow?.completedSteps ?? null,
            profileTotalSteps: p.workflow?.totalSteps ?? null,
            savedModelCount: p.workflow?.modelCount ?? 0,
            soaCount: p.workflow?.soaCount ?? 0,
            workflow: p.workflow,
            startedAt: p.createdAt,
            lastActivityAt: p.updatedAt,
            submissionDate: stage.submissionDate,
            soaStatus: stage.soaStatus,
            agedCareRoomCost: 0,
            sahBudget: 0,
            commonStrategy: 'Not set',
            estateStage: 'unknown',
            strategySource: 'manual_control',
            strategyGenerationCount: 0,
            strategyUsageMode: 'manual_only',
            manualStrategiesModelled: 0,
            manualStrategiesSaved: 0,
            suggestionSoaSelection: null,
            homeDecision: 'keep_home',
            assetSellMix: [],
            roomFunding: {
                mode: 'partial_rad',
                radPct: 0,
                dapPct: 0,
                radAmount: 0,
                dapAmount: 0
            },
            // Real modelling numbers land here once the file is opened and its saved models load; a list row
            // only ever carries the counts above.
            factFind: structuredClone((0, $b116352393ba4abb$export$55f731ae3600e88a))
        };
    };
    // Entering the portal signed-in as a firm member switches it to REAL mode: the firm's
    // actual client list replaces the demo cases. No membership → demo stays untouched.
    (0, $acw62.useEffect)(()=>{
        if (activePage !== 'PartnerPortal' || !accountUser) return;
        setPartnerResolving(true);
        setPortalEntryError(false);
        setPartnerPaywall(null);
        setProfessionalCases([]); // drop the demo samples immediately — real mode never shows them
        (async ()=>{
            // A transient failure (server waking from sleep, network blip) must NOT be read as
            // "you have no firm" — that showed real members the onboarding wizard and could strand
            // them on the loader. Retry; on continued failure show a retry screen; only a
            // POSITIVELY-confirmed "no membership" opens the wizard.
            const res = await $4a3ab415a7732163$export$2e7e98436b791c3c();
            if (!res.ok) {
                setPartnerResolving(false);
                setPortalEntryError(true);
                return;
            }
            const membership = res.membership;
            if (!membership) {
                // Confirmed: signed in but not a firm member. A platform admin goes to the admin console;
                // anyone else is offered onboarding.
                const routed = await routePlatformAdminWithoutFirm();
                setPartnerResolving(false);
                if (!routed) setShowPartnerWizard(true);
                return;
            }
            // Firm billing gate: if billing is live and the FIRM hasn't chosen a plan yet
            // (summary.mode === 'none'), show the setup chooser instead of the portal. A firm on the
            // annual plan, pay-as-you-go, or free access is "set up" and goes straight in. The summary
            // is kept so the portal can gate "add client" and show the billing panel. (Off while
            // billing is off — summary is null and nothing gates.)
            const billing = await (0, $9969e0eb851fd9fb$export$8a258e6ffbcb9c95)(membership.tenantId);
            if (billing.billingConfigured && billing.summary?.mode === 'none') {
                setPartnerResolving(false);
                setPartnerPaywall({
                    firmName: membership.tenantName,
                    tenantId: membership.tenantId
                });
                return;
            }
            setPartnerBilling(billing.summary);
            // Assemble the REAL identity the portal displays (adviser from the login, firm +
            // licensing from the tenant record) — no more demo stage names.
            const tenant = await (0, $442533e192804693$export$e24d85f794d5f8dd)(membership.tenantId).catch(()=>null);
            // The firm's own working preferences — currently just how soon to chase a client who hasn't
            // responded. Read once here so the invite form can pre-set it rather than asking every time.
            setFirmSettings(tenant?.settings ?? {});
            setAutoReminders(tenant?.autoReminders ?? null);
            // The firm's capital market assumptions become the session's table the moment the firm
            // resolves — every preset, strategy price, Assumptions row and SOA the adviser sees from
            // here runs on them (and rides to the server with each calculation request). Invalid or
            // absent sets leave the AgedCareWise defaults standing.
            (0, $0f2c0a6799fe36da$export$202e846e294fdcb3)(tenant?.settings?.capitalMarketAssumptions ?? null);
            setMessageDefaults(tenant?.messageDefaults ?? null);
            const user = await (0, $cc9e8a24185b91b0$export$a79e7ef8c396bb0e)().catch(()=>null);
            // Firms created by a platform admin before the profession was recorded carry null. Read the
            // one fact that decides everything — does it have a licence of its own? — rather than guess.
            const profession = tenant?.profession ?? (tenant?.afslLicenseeName || tenant?.afslNumber ? 'adviser' : 'other');
            // This person's own ASIC number, which an advice document names alongside the firm's entities.
            // A roster read that fails must not stop the workspace opening — the attribution then reports
            // itself incomplete, which is the truthful outcome.
            const myAdviserNumber = (await (0, $442533e192804693$export$f1d37579424c00c1)(membership.tenantId).catch(()=>[])).find((m)=>m.userId === user?.id)?.adviserNumber ?? null;
            const adviserName = [
                user?.firstName,
                user?.lastName
            ].filter(Boolean).join(' ') || (user?.email ? user.email.split('@')[0] : 'Adviser');
            const roleLabels = {
                owner: 'Firm Owner',
                adviser: 'Financial Adviser',
                staff: 'Staff'
            };
            const roleLabel = roleLabels[membership.role] || 'Member';
            // Load the firm's REAL client list BEFORE revealing the portal. Setting the identity is
            // what lifts the "Opening your workspace…" loader, so it must come LAST — otherwise the
            // portal appears with the demo samples still in state for the moment the client list is
            // still fetching (owner-reported flash of dummy clients). No real data crosses firms:
            // the demo cases are synthetic, and the real list is filtered to this tenant only.
            const profiles = await (0, $a0f9af581f384312$export$13c7095e6fe0ed09)().catch(()=>[]);
            // The id is optional on the wire — the server withholds it from a caller whose one visible file
            // is their OWN (see resolveSoleProfileId). A firm member is staff of the tenant these live in, so
            // it is always present here; narrowing once, at the point the firm's files are picked out, is what
            // lets every use below take it as given rather than each guessing.
            const firmProfiles = profiles.filter((p)=>p.tenantId === membership.tenantId && p.id !== undefined);
            setProfessionalCases(firmProfiles.map(mapProfileToCase));
            // Pull the ADVICE REGISTER for any file that has one. The portal's SOA list was built purely
            // from sessionStorage, so a client's generated advice disappeared from Reports & SOAs the
            // moment the adviser signed out — even though the register (the legal record) still held every
            // version. Only files the list says have SOAs are fetched, so this costs nothing for the rest.
            (async ()=>{
                const withSoas = firmProfiles.filter((p)=>(p.workflow?.soaCount ?? 0) > 0);
                const entries = await Promise.all(withSoas.map(async (p)=>{
                    try {
                        return [
                            p.id,
                            await (0, $3ca5b2fc75d0c72b$export$3d5e9e266a6dea6d)(p.id)
                        ];
                    } catch  {
                        // A register that can't be reached must not take the portal down with it; the row still
                        // shows its derived SOA status, just without the per-version list.
                        return [
                            p.id,
                            []
                        ];
                    }
                }));
                setRegisteredSoasByProfileId(Object.fromEntries(entries.filter(([, soas])=>soas.length > 0)));
            })();
            // Who advice from this firm comes from. Set here because this is the one place that holds the
            // firm record, the signed-in person and their role together; the document builders read it
            // rather than having it threaded down through every component between.
            (0, $92fb3c34dca71663$export$8dcd5d1de2b3df34)((0, $92fb3c34dca71663$export$236a6ecb53473bcf)({
                firmName: tenant?.name || membership.tenantName,
                adviserName: adviserName,
                adviserNumber: myAdviserNumber,
                licenseeName: tenant?.afslLicenseeName ?? null,
                afslNumber: tenant?.afslNumber ?? null,
                adviceStructure: tenant?.adviceStructure ?? null,
                carName: tenant?.carName ?? null,
                carNumber: tenant?.carNumber ?? null
            }, $4a3ab415a7732163$var$PLATFORM_LICENCE));
            setPartnerFirm({
                ...membership,
                identity: {
                    tenantId: membership.tenantId,
                    userId: user?.id || '',
                    role: membership.role,
                    profession: profession,
                    holderLabel: (0, $442533e192804693$export$67df0a24993f58cf)(profession),
                    // "Finished" means something different for the two kinds of firm. An adviser firm has
                    // finished when it has said how its advice is provided; a firm that gives no advice has no
                    // such question, and is finished once it has set up how it works — reminders, wording,
                    // documents — which is what its checklist step points at.
                    firmProfileComplete: profession === 'adviser' ? Boolean(tenant?.adviceStructure) : Boolean(tenant?.settings && (tenant.settings.defaultFollowUpDays !== undefined || tenant.settings.fsgUrl || tenant.settings.companyProfileUrl || tenant.settings.templates)),
                    adviserName: adviserName,
                    email: user?.email || '',
                    firmName: tenant?.name || membership.tenantName,
                    initials: adviserName.split(/\s+/).map((w)=>w[0]).join('').slice(0, 2).toUpperCase(),
                    roleLine: `${roleLabel} \xb7 ${tenant?.name || membership.tenantName}`,
                    // Not "operating under our arrangements": a firm that gives no advice is not our
                    // representative and must not be described as if it were. We give the advice; they refer.
                    licenceLine: tenant?.afslLicenseeName ? `${tenant.afslLicenseeName}${tenant.afslNumber ? ` \xb7 AFSL ${tenant.afslNumber}` : ''}` : "Advice provided by AgedCareWise under its AFSL \xb7 your firm refers clients"
                }
            });
            setPartnerResolving(false);
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        activePage,
        accountUser,
        portalRefreshNonce
    ]);
    const scopedProfessionalCases = (0, $acw62.useMemo)(()=>{
        // REAL firm mode is scoped by who actually created each client file. The role scopes below are
        // demo fixtures — their owner/practice ids ('adv-jm', 'prac-harbour') are invented sample
        // people, so applying them to real data matched nothing and hid every real client from the
        // portal. Firm owners see the whole firm's book; everyone else sees only their own clients.
        if (partnerFirm) {
            if (partnerFirm.role === 'owner') return professionalCases;
            return professionalCases.filter((c)=>c.ownerId === accountUser?.id);
        }
        const scope = (0, $52bda4b4ecde5a3b$export$bffe8049574b5b4a)(professionalRole);
        if (scope.type === 'licensee') return professionalCases;
        if (scope.type === 'practice') return professionalCases.filter((c)=>c.practiceId === scope.practiceId);
        return professionalCases.filter((c)=>c.ownerId === scope.ownerId);
    }, [
        professionalCases,
        professionalRole,
        partnerFirm,
        accountUser
    ]);
    const activeProfessionalCase = (0, $acw62.useMemo)(()=>professionalCases.find((c)=>c.id === activeProfessionalCaseId) || null, [
        professionalCases,
        activeProfessionalCaseId
    ]);
    const updateProfessionalCase = (caseId, patch)=>{
        setProfessionalCases((prev)=>prev.map((item)=>item.id === caseId ? {
                    ...item,
                    ...patch,
                    lastActivityAt: new Date().toISOString()
                } : item));
    };
    const markProfessionalCaseSoaStatus = (caseId, soaStatus)=>{
        if (!caseId) return;
        const statusPatch = soaStatus === 'published' ? {
            soaStatus: 'published',
            status: 'soa_published'
        } : {
            soaStatus: 'draft',
            status: 'soa_draft'
        };
        updateProfessionalCase(caseId, statusPatch);
    };
    const persistCaseStudies = (items)=>{
        setSavedCaseStudies(items);
        sessionStorage.setItem('careCompanionCaseStudies', JSON.stringify(items));
        sessionStorage.setItem('careCompanionScenarios', JSON.stringify(items));
    };
    const setCurrentSoaForCase = (caseId, soaId)=>{
        if (!caseId || !soaId) return;
        const next = savedCaseStudies.map((item)=>{
            if (item.caseId !== caseId) return item;
            return {
                ...item,
                isCurrentForCase: item.id === soaId
            };
        });
        persistCaseStudies(next);
        updateProfessionalCase(caseId, {
            currentSoaId: soaId
        });
    };
    /** Every id the advice register has told us about — lets publishSoaForCase recognise a version
   *  that exists only there, with no local working copy behind it. */ const registeredSoaIds = (0, $acw62.useMemo)(()=>new Set(Object.values(registeredSoasByProfileId).flat().map((soa)=>soa.id)), [
        registeredSoasByProfileId
    ]);
    const publishSoaForCase = (caseId, soaId)=>{
        if (!caseId || !soaId) return;
        const now = new Date().toISOString();
        const next = savedCaseStudies.map((item)=>{
            if (item.caseId !== caseId) return item;
            if (item.id === soaId) return {
                ...item,
                isCurrentForCase: true,
                soaDeliveryStatus: 'published',
                publishedAt: now
            };
            return {
                ...item,
                isCurrentForCase: false,
                soaDeliveryStatus: 'draft'
            };
        });
        persistCaseStudies(next);
        updateProfessionalCase(caseId, {
            currentSoaId: soaId
        });
        markProfessionalCaseSoaStatus(caseId, 'published');
        // Publication is a compliance event: mirror it to the versioned advice register.
        //
        // `soaId` is either a local working copy's id (which records the register id it was written to)
        // or — for a version that exists ONLY in the register, e.g. one generated before this session —
        // the register id itself. Falling back to it is what lets an adviser publish a draft they can
        // see but have no local snapshot of; before, that draft could be listed but never sent.
        const publishedItem = savedCaseStudies.find((item)=>item.id === soaId);
        const serverSoaId = publishedItem?.serverSoaId ? String(publishedItem.serverSoaId) : registeredSoaIds.has(soaId) ? soaId : null;
        if (serverSoaId) (0, $3ca5b2fc75d0c72b$export$35113fc8f9ba8931)(serverSoaId).then(()=>{
            // Reflect the new status in the register copy the portal holds, so the row stops offering
            // "Sent to Client" for something already sent.
            setRegisteredSoasByProfileId((prev)=>{
                const next = {};
                for (const [pid, list] of Object.entries(prev))next[pid] = list.map((soa)=>soa.id === serverSoaId ? {
                        ...soa,
                        status: 'published'
                    } : soa);
                return next;
            });
        }).catch((err)=>{});
    };
    const deleteDraftSoa = (soaId)=>{
        if (!soaId) return;
        const target = savedCaseStudies.find((item)=>item.id === soaId);
        if (!target) return;
        if ((target.soaDeliveryStatus || 'draft') === 'published') return;
        const caseId = target.caseId || null;
        const remaining = savedCaseStudies.filter((item)=>item.id !== soaId);
        const caseSoasAfter = caseId ? remaining.filter((item)=>item.caseId === caseId) : [];
        const hasCurrent = caseSoasAfter.some((item)=>item.isCurrentForCase);
        const normalizedRemaining = caseId && !hasCurrent && caseSoasAfter.length > 0 ? remaining.map((item)=>{
            if (item.caseId !== caseId) return item;
            const firstForCaseId = caseSoasAfter[0]?.id;
            if (!firstForCaseId) return item;
            return {
                ...item,
                isCurrentForCase: item.id === firstForCaseId
            };
        }) : remaining;
        persistCaseStudies(normalizedRemaining);
        if (caseId) {
            const caseSoas = normalizedRemaining.filter((item)=>item.caseId === caseId);
            const current = caseSoas.find((item)=>item.isCurrentForCase) || caseSoas[0] || null;
            if (!current) updateProfessionalCase(caseId, {
                currentSoaId: undefined,
                soaStatus: 'none',
                status: 'adviser_review'
            });
            else {
                const currentStatus = (current.soaDeliveryStatus || 'draft') === 'published' ? 'published' : 'draft';
                updateProfessionalCase(caseId, {
                    currentSoaId: String(current.id)
                });
                markProfessionalCaseSoaStatus(caseId, currentStatus);
            }
        }
    };
    const openProfessionalCaseJourney = (caseId)=>{
        const target = professionalCases.find((c)=>c.id === caseId);
        if (!target) return;
        // Re-arm the once-per-client AWise intro so it greets the user on this client's first
        // insight panel (it then stays dismissed across that client's modules for the session).
        (0, $357e6188006bbf96$export$2e58bf066eef6dcd)();
        // REAL client file: fetch + decrypt it from the firm's secure storage, restore the client's
        // strategies/SOAs, and point auto-save at THIS record for the whole working session.
        if (target.isReal) {
            (async ()=>{
                const loaded = await (0, $a0f9af581f384312$export$49cf4955b0bc9ba8)(caseId, {
                    remember: false
                }).catch(()=>null);
                if (!loaded) return;
                setActiveProfessionalCaseId(caseId);
                setActiveRealProfileId(caseId);
                setFactFind(loaded.factFind);
                const appData = loaded.appData || {};
                setSavedStrategies(Array.isArray(appData.savedStrategies) ? appData.savedStrategies : []);
                setSavedCaseStudies(Array.isArray(appData.savedCaseStudies) ? appData.savedCaseStudies : []);
                // This file's setup answers, or none — never the previous file's.
                setCoupleValidation(appData.coupleValidation ? {
                    ...(0, $87baeb3af1e4d5de$export$8c4af9c383a44b94)(),
                    ...appData.coupleValidation
                } : (0, $87baeb3af1e4d5de$export$8c4af9c383a44b94)());
                (0, $a0f9af581f384312$export$62a775eed95889de)();
                (0, $a0f9af581f384312$export$fe33d8b505081339)(appData);
                const appState = loaded.appState || {};
                setClientProfileStep(Number(appState.clientProfileStep) || 1);
                const lastPageRaw = appState.lastPage;
                const lastPage = typeof lastPageRaw === 'string' && $4a3ab415a7732163$export$77b890292aeb9804.includes(lastPageRaw) ? lastPageRaw : 'Dashboard';
                setActivePage(lastPage);
            })();
            return;
        }
        setActiveRealProfileId(null);
        setActiveProfessionalCaseId(caseId);
        setFactFind(structuredClone(target.factFind || (0, $b116352393ba4abb$export$55f731ae3600e88a)));
        setCoupleValidation((0, $87baeb3af1e4d5de$export$8c4af9c383a44b94)());
        setClientProfileStep(1);
        const statusPatch = target.status === 'draft' || target.status === 'invited' ? {
            status: 'started',
            profileProgressPct: Math.max(15, target.profileProgressPct || 0),
            startedAt: target.startedAt || new Date().toISOString()
        } : {};
        if (Object.keys(statusPatch).length) updateProfessionalCase(caseId, statusPatch);
        const resumablePages = [
            'Dashboard',
            'Client Profile',
            'AssumptionsPage',
            'AgedCarePage',
            'HomeCarePage',
            'RetirementVillagePage',
            'GrannyFlatPage',
            'DownsizingPage'
        ];
        const last = target.lastWorkedPage && resumablePages.includes(target.lastWorkedPage) ? target.lastWorkedPage : null;
        if (target.status === 'invited' || target.status === 'draft') setActivePage('Client Profile');
        else if (last) setActivePage(last);
        else setActivePage('Dashboard');
    };
    // Before opening a NEW client file in a real firm, confirm the firm has paid capacity for one more
    // client. If not, open the "add another client" paywall and return false. (Billing off → always
    // true; the server gate on POST /v1/profiles is the hard backstop.) Refreshes the stored summary.
    const partnerHasClientCapacity = async ()=>{
        if (!partnerFirm) return true;
        const res = await (0, $9969e0eb851fd9fb$export$8a258e6ffbcb9c95)(partnerFirm.tenantId);
        if (!res.billingConfigured || !res.summary) return true;
        setPartnerBilling(res.summary);
        if (res.summary.canAddClient) return true;
        setAddClientPaywall({
            summary: res.summary,
            tenantId: partnerFirm.tenantId
        });
        return false;
    };
    // Re-read the firm's client-billing summary after a client is created (a slot was consumed).
    const refreshPartnerBilling = ()=>{
        if (!partnerFirm) return;
        (0, $9969e0eb851fd9fb$export$8a258e6ffbcb9c95)(partnerFirm.tenantId).then((r)=>{
            if (r.summary) setPartnerBilling(r.summary);
        }).catch(()=>{});
    };
    const createInPersonProfessionalCase = (inPersonPayload = {})=>{
        const timestamp = Date.now();
        const first = (inPersonPayload.firstName || '').trim();
        const last = (inPersonPayload.lastName || '').trim();
        const email = (inPersonPayload.email || '').trim();
        const phone = (inPersonPayload.preferredPhone || '').trim();
        const completingAs = inPersonPayload.completingAs || 'self';
        const isClientCompleting = completingAs === 'self';
        const completerMap = {
            self: 'client',
            family_member: 'family',
            epoa: 'eop'
        };
        const completer = completerMap[completingAs] || 'client';
        const fd = structuredClone((0, $b116352393ba4abb$export$55f731ae3600e88a));
        fd.completer = completer;
        if (isClientCompleting) {
            if (first) fd.client.firstName = first;
            if (last) fd.client.lastName = last;
            if (email) fd.client.email = email;
            if (phone) fd.client.preferredPhone = phone;
        } else {
            if (first) fd.completerFirstName = first;
            if (last) fd.completerLastName = last;
        }
        const completerDisplay = [
            first,
            last
        ].filter(Boolean).join(' ').trim();
        const clientDisplay = [
            fd.client.firstName,
            fd.client.lastName
        ].filter(Boolean).join(' ').trim();
        const fullName = isClientCompleting ? clientDisplay || 'New In-Person Client' : clientDisplay || (completerDisplay ? `Applicant TBC (${completerDisplay})` : "In-person \u2014 applicant pending");
        // REAL portal mode: create the client file in the firm's secure storage and open it.
        if (partnerFirm && accountUser) {
            (async ()=>{
                // Per-client billing gate: only open a new client file if the firm has paid capacity.
                if (!await partnerHasClientCapacity()) return;
                const saved = await (0, $a0f9af581f384312$export$e38d9fa5fa0a9fe6)({
                    factFind: fd,
                    tenantId: partnerFirm.tenantId
                }).catch(()=>null);
                if (!saved) return;
                setProfessionalCases((prev)=>[
                        // createdBy mirrors what the server stamped (auth.uid() — this adviser). Without it the
                        // freshly created file would be scoped out of its own creator's list until a reload.
                        mapProfileToCase({
                            // Created in the firm's tenant by a staff member, so the id always comes back.
                            id: saved.profileId,
                            displayName: fullName,
                            createdAt: new Date().toISOString(),
                            updatedAt: new Date().toISOString(),
                            createdBy: accountUser.id
                        }),
                        ...prev
                    ]);
                setActiveProfessionalCaseId(saved.profileId);
                setActiveRealProfileId(saved.profileId);
                setFactFind(fd);
                setSavedStrategies([]);
                setSavedCaseStudies([]);
                setCoupleValidation((0, $87baeb3af1e4d5de$export$8c4af9c383a44b94)());
                (0, $a0f9af581f384312$export$62a775eed95889de)();
                setClientProfileStep(1);
                setActivePage('Client Profile');
                refreshPartnerBilling();
            })();
            return;
        }
        const newCase = {
            id: `case-new-${timestamp}`,
            clientName: fullName,
            clientEmail: email || `inperson.${timestamp}@demo.local`,
            ownerId: 'adv-jm',
            ownerName: 'Joncarl La Rosa',
            ownerRole: 'adviser',
            practiceId: 'prac-harbour',
            accessMode: 'in_person',
            inPersonCompletingAs: inPersonPayload.completingAs || 'self',
            status: 'started',
            profileProgressPct: 10,
            startedAt: new Date().toISOString(),
            lastActivityAt: new Date().toISOString(),
            submissionDate: null,
            soaStatus: 'none',
            agedCareRoomCost: 0,
            sahBudget: 0,
            commonStrategy: 'Not set',
            estateStage: 'unknown',
            strategySource: 'manual_control',
            strategyGenerationCount: 0,
            strategyUsageMode: 'manual_only',
            manualStrategiesModelled: 0,
            manualStrategiesSaved: 0,
            suggestionSoaSelection: null,
            homeDecision: 'keep_home',
            assetSellMix: [],
            roomFunding: {
                mode: 'partial_rad',
                radPct: 0,
                dapPct: 0,
                radAmount: 0,
                dapAmount: 0
            },
            factFind: fd,
            lastWorkedPage: 'Client Profile'
        };
        setProfessionalCases((prev)=>[
                newCase,
                ...prev
            ]);
        setActiveProfessionalCaseId(newCase.id);
        setFactFind(fd);
        setClientProfileStep(1);
        setActivePage('Client Profile');
    };
    const createInviteProfessionalCase = (invitePayload = {})=>{
        const timestamp = Date.now();
        const seed = (0, $61be87c42767c473$export$b141d1c0193c3d71)(invitePayload);
        const first = seed.client.firstName;
        const last = seed.client.lastName;
        const fullName = seed.displayName || 'Draft Invite Client';
        const email = (invitePayload.email || '').trim() || `invite.${timestamp}@demo.local`;
        const mobile = (invitePayload.mobile || '').trim();
        const accessMode = invitePayload.accessMode === 'client_end_to_end' ? 'client_end_to_end' : 'client_stop_dashboard';
        const autoFollowUp = invitePayload.autoFollowUp && [
            '3',
            '5',
            '7',
            'manual'
        ].includes(invitePayload.autoFollowUp) ? invitePayload.autoFollowUp : '7';
        const completingAs = invitePayload.completingAs || 'self';
        const fd = structuredClone((0, $b116352393ba4abb$export$55f731ae3600e88a));
        if (first) fd.client.firstName = first;
        if (last) fd.client.lastName = last;
        if (mobile) fd.client.preferredPhone = mobile;
        // The adviser's answer to "who will be completing this form?" is step 1's answer on the file,
        // and the names go where the profile keeps them (inviteFileSeed).
        fd.completer = seed.completer;
        if (seed.completerFirstName) fd.completerFirstName = seed.completerFirstName;
        if (seed.completerLastName) fd.completerLastName = seed.completerLastName;
        if (seed.completerRelationship) fd.completerRelationship = seed.completerRelationship;
        // REAL portal mode: create the client's file in the firm's storage AND a one-time invite
        // link (copied to the clipboard) the adviser sends to the client.
        if (partnerFirm && accountUser) {
            (async ()=>{
                // Per-client billing gate: inviting a client opens a new client file, so it needs capacity.
                if (!await partnerHasClientCapacity()) return;
                fd.client.email = email;
                const saved = await (0, $a0f9af581f384312$export$e38d9fa5fa0a9fe6)({
                    factFind: fd,
                    tenantId: partnerFirm.tenantId
                }).catch(()=>null);
                if (!saved) return;
                // 'manual' means the adviser will chase; anything else is a day count the scheduler acts on.
                // Until now this answer was collected by the form and thrown away.
                const followUpDays = autoFollowUp === 'manual' ? null : Number(autoFollowUp) || null;
                const invite = await (0, $442533e192804693$export$3400e2a39cde89c1)(partnerFirm.tenantId, email, saved.profileId, followUpDays);
                const link = invite.ok && invite.token ? `${window.location.origin}/?invite=${invite.token}` : null;
                setProfessionalCases((prev)=>[
                        {
                            ...mapProfileToCase({
                                // Created in the firm's tenant by a staff member, so the id always comes back.
                                id: saved.profileId,
                                displayName: fullName,
                                createdAt: new Date().toISOString(),
                                updatedAt: new Date().toISOString(),
                                createdBy: accountUser.id
                            }),
                            clientEmail: email,
                            status: 'invited',
                            inviteLink: link
                        },
                        ...prev
                    ]);
                refreshPartnerBilling();
                if (link) {
                    // Copied either way: even when the server emailed it, an adviser often wants to paste it
                    // into their own message, and it is the fallback if the email bounces.
                    try {
                        await navigator.clipboard.writeText(link);
                    } catch  {}
                    // `emailed` reports whether the server actually DELIVERED it. Claiming "we've sent it"
                    // when no email provider is configured would leave the adviser waiting on a client who was
                    // never contacted — the exact failure this change exists to remove.
                    const emailed = invite.ok && invite.emailed;
                    const expires = invite.ok && invite.expiresAt ? new Date(invite.expiresAt).toLocaleDateString('en-AU', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric'
                    }) : null;
                    (0, $8e1e84c918e07c84$export$5e14cdade93d6f7b)(emailed ? {
                        tone: 'success',
                        title: `Invite sent to ${email}`,
                        message: `${fullName || 'Your client'} will receive an email with a secure link to complete their profile.${expires ? ` It expires on ${expires}.` : ''}`,
                        link: {
                            url: link,
                            label: "Their secure link \u2014 already on your clipboard",
                            note: 'Send it yourself if you prefer; it works once.'
                        }
                    } : {
                        tone: 'warning',
                        title: `Invite created for ${fullName || email} \u{2014} not emailed`,
                        message: 'Email sending is not switched on for this server, so nothing has reached your client yet. Send them this one-time link yourself.',
                        link: {
                            url: link,
                            label: "Their secure link \u2014 already on your clipboard",
                            note: expires ? `It expires on ${expires}.` : undefined
                        }
                    });
                } else {
                    const failureMessage = !invite.ok && invite.message ? invite.message : undefined;
                    (0, $8e1e84c918e07c84$export$5e14cdade93d6f7b)({
                        tone: 'error',
                        title: 'The invite link could not be generated',
                        message: `${failureMessage ? `${failureMessage} ` : ''}The client file was created; you can send the invite again from their row.`
                    });
                }
            })();
            return;
        }
        const newCase = {
            id: `case-invite-${timestamp}`,
            clientName: fullName,
            clientEmail: email,
            clientMobile: mobile || undefined,
            ownerId: 'adv-jm',
            ownerName: 'Joncarl La Rosa',
            ownerRole: 'adviser',
            practiceId: 'prac-harbour',
            accessMode: accessMode,
            inviteCompletingAs: completingAs,
            inviteAutoFollowUp: autoFollowUp,
            status: 'invited',
            profileProgressPct: 0,
            startedAt: '',
            lastActivityAt: new Date().toISOString(),
            submissionDate: null,
            soaStatus: 'none',
            agedCareRoomCost: 0,
            sahBudget: 0,
            commonStrategy: 'Not set',
            estateStage: 'unknown',
            strategySource: 'manual_control',
            strategyGenerationCount: 0,
            strategyUsageMode: 'manual_only',
            manualStrategiesModelled: 0,
            manualStrategiesSaved: 0,
            suggestionSoaSelection: null,
            homeDecision: 'keep_home',
            assetSellMix: [],
            roomFunding: {
                mode: 'partial_rad',
                radPct: 0,
                dapPct: 0,
                radAmount: 0,
                dapAmount: 0
            },
            factFind: fd
        };
        setProfessionalCases((prev)=>[
                newCase,
                ...prev
            ]);
    };
    /**
   * Fetch the fact-finds the Analytics tab needs.
   *
   * The client LIST deliberately carries no fact-find — it is encrypted per client and only decrypted
   * when that client is opened, which is what keeps listing a whole firm's book cheap and private.
   * Analytics, though, is built entirely from fact-find content (ages, goals, assessment stage), so
   * on the client list alone every one of its charts rendered as zero: "0 clients in their 80s" for a
   * firm whose clients are all in their 80s.
   *
   * So it is loaded ON DEMAND, when the adviser actually opens Analytics, rather than up front for a
   * screen they may never visit. One request per client file; each failure is tolerated so a single
   * unreadable file can't blank the whole page. Loaded once per session — the results are patched
   * into the cases already in state.
   */ const loadFactFindsForAnalytics = async ()=>{
        if (analyticsDataState === 'loading' || analyticsDataState === 'loaded') return;
        const targets = professionalCases.filter((c)=>c.isReal && !c.factFind?.client?.dob);
        if (!targets.length) {
            setAnalyticsDataState('loaded');
            return;
        }
        setAnalyticsDataState('loading');
        let failed = 0;
        await Promise.all(targets.map(async (target)=>{
            try {
                // remember:false — reading a file for a chart must not change which client the app
                // considers "current", which is what would happen if this stored the profile id.
                const loaded = await (0, $a0f9af581f384312$export$49cf4955b0bc9ba8)(target.id, {
                    remember: false
                });
                // Patched directly rather than through updateProfessionalCase: that stamps lastActivityAt,
                // and merely drawing a chart is not activity on the client's file.
                setProfessionalCases((prev)=>prev.map((c)=>c.id === target.id ? {
                            ...c,
                            factFind: loaded.factFind
                        } : c));
            } catch  {
                failed += 1;
            }
        }));
        setAnalyticsDataState(failed ? 'partial' : 'loaded');
    };
    /**
   * Chase a client who hasn't opened their invite.
   *
   * Issues a fresh one-time link and emails it (the old one is retired server-side — see
   * resendInvite). Reports back plainly: if email delivery isn't configured the adviser is told the
   * client has NOT been contacted, rather than being left to assume a reminder went out.
   */ const remindClient = async (caseId)=>{
        const target = professionalCases.find((c)=>c.id === caseId);
        const inviteId = target?.workflow?.inviteId;
        if (!partnerFirm || !inviteId) {
            (0, $8e1e84c918e07c84$export$5e14cdade93d6f7b)({
                tone: 'info',
                title: 'Nothing to resend',
                message: 'There is no outstanding invite for this client.'
            });
            return;
        }
        const result = await (0, $442533e192804693$export$f2385fb263a7b829)(partnerFirm.tenantId, inviteId);
        if (!result.ok) {
            (0, $8e1e84c918e07c84$export$5e14cdade93d6f7b)({
                tone: 'error',
                title: 'The reminder could not be sent',
                message: result.message
            });
            return;
        }
        const freshLink = result.token ? `${window.location.origin}/?invite=${result.token}` : null;
        const freshExpiry = result.expiresAt ? new Date(result.expiresAt).toLocaleDateString('en-AU', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        }) : null;
        if (freshLink) try {
            await navigator.clipboard.writeText(freshLink);
        } catch  {}
        if (result.emailed) {
            // Reflect the new invite immediately: the reminder resets the clock the "days waiting" and
            // overdue checks read from, so the row shouldn't still look untouched.
            updateProfessionalCase(caseId, {});
            (0, $8e1e84c918e07c84$export$5e14cdade93d6f7b)({
                tone: 'success',
                title: `New link sent to ${target?.clientName || 'your client'}`,
                message: `A nudge creates a fresh secure link and emails it; the earlier link no longer works.${freshExpiry ? ` This one expires on ${freshExpiry}.` : ''}`,
                ...freshLink ? {
                    link: {
                        url: freshLink,
                        label: "The new link \u2014 already on your clipboard",
                        note: 'Send it yourself if you prefer; it works once.'
                    }
                } : {}
            });
        } else (0, $8e1e84c918e07c84$export$5e14cdade93d6f7b)({
            tone: 'warning',
            title: `New link created for ${target?.clientName || 'your client'} \u{2014} not emailed`,
            message: 'Email sending is not switched on for this server, so nothing has reached your client. The earlier link no longer works; send them this one yourself.',
            ...freshLink ? {
                link: {
                    url: freshLink,
                    label: "The new link \u2014 already on your clipboard",
                    note: freshExpiry ? `It expires on ${freshExpiry}.` : undefined
                }
            } : {}
        });
    };
    /** Save the firm's working preferences and keep the in-memory copy in step. */ const saveFirmSettings = async (patch)=>{
        if (!partnerFirm) return false;
        const result = await (0, $442533e192804693$export$297cdab4afe3ed04)(partnerFirm.tenantId, patch);
        if (!result.ok) {
            (0, $8e1e84c918e07c84$export$5e14cdade93d6f7b)({
                tone: 'error',
                title: 'Those settings could not be saved',
                message: result.message || undefined
            });
            return false;
        }
        setFirmSettings((prev)=>({
                ...prev,
                ...patch
            }));
        return true;
    };
    const submitProfessionalCaseToAdviser = ()=>{
        if (!activeProfessionalCaseId) return;
        updateProfessionalCase(activeProfessionalCaseId, {
            status: 'submitted',
            profileProgressPct: 100,
            submissionDate: new Date().toISOString(),
            factFind: structuredClone(factFind)
        });
        setActivePage('PartnerPortal');
    };
    (0, $acw62.useEffect)(()=>{
        if (!activeProfessionalCaseId) return;
        const labels = $4a3ab415a7732163$var$deriveEngagementLabelsFromFactFind(factFind);
        updateProfessionalCase(activeProfessionalCaseId, {
            factFind: structuredClone(factFind),
            ...labels
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        factFind,
        activeProfessionalCaseId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!activeProfessionalCaseId) return;
        if (activePage === 'Client Profile') updateProfessionalCase(activeProfessionalCaseId, {
            status: 'started',
            profileProgressPct: Math.max(15, Math.min(95, Math.round(clientProfileStep / 8 * 100)))
        });
        else if (activePage === 'Dashboard') {
            const curr = professionalCases.find((c)=>c.id === activeProfessionalCaseId);
            if (curr && curr.accessMode === 'client_stop_dashboard' && !curr.submissionDate) updateProfessionalCase(activeProfessionalCaseId, {
                status: 'submitted',
                profileProgressPct: 100,
                submissionDate: new Date().toISOString()
            });
        } else if ([
            'AgedCarePage',
            'HomeCarePage',
            'RetirementVillagePage'
        ].includes(activePage)) {
            const curr = professionalCases.find((c)=>c.id === activeProfessionalCaseId);
            updateProfessionalCase(activeProfessionalCaseId, {
                status: 'adviser_review',
                ...curr && !curr.submissionDate ? {
                    submissionDate: new Date().toISOString()
                } : {}
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        activePage,
        clientProfileStep,
        activeProfessionalCaseId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!activeProfessionalCaseId) return;
        if (activePage === 'LandingPage' || activePage === 'PartnerPortal') return;
        updateProfessionalCase(activeProfessionalCaseId, {
            lastWorkedPage: activePage
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        activePage,
        activeProfessionalCaseId
    ]);
    return {
        professionalRole: professionalRole,
        setProfessionalRole: setProfessionalRole,
        setProfessionalCases: setProfessionalCases,
        scopedProfessionalCases: scopedProfessionalCases,
        activeProfessionalCaseId: activeProfessionalCaseId,
        setActiveProfessionalCaseId: setActiveProfessionalCaseId,
        activeProfessionalCase: activeProfessionalCase,
        partnerPortalReviewNonce: partnerPortalReviewNonce,
        setPartnerPortalReviewNonce: setPartnerPortalReviewNonce,
        partnerIntent: partnerIntent,
        setPartnerIntent: setPartnerIntent,
        partnerFirm: partnerFirm,
        setPartnerFirm: setPartnerFirm,
        activeRealProfileId: activeRealProfileId,
        setActiveRealProfileId: setActiveRealProfileId,
        partnerResolving: partnerResolving,
        setPartnerResolving: setPartnerResolving,
        portalEntryError: portalEntryError,
        setPortalEntryError: setPortalEntryError,
        setPortalRefreshNonce: setPortalRefreshNonce,
        partnerPaywall: partnerPaywall,
        setPartnerPaywall: setPartnerPaywall,
        partnerBilling: partnerBilling,
        addClientPaywall: addClientPaywall,
        setAddClientPaywall: setAddClientPaywall,
        showPartnerWizard: showPartnerWizard,
        setShowPartnerWizard: setShowPartnerWizard,
        updateProfessionalCase: updateProfessionalCase,
        markProfessionalCaseSoaStatus: markProfessionalCaseSoaStatus,
        setCurrentSoaForCase: setCurrentSoaForCase,
        publishSoaForCase: publishSoaForCase,
        deleteDraftSoa: deleteDraftSoa,
        openProfessionalCaseJourney: openProfessionalCaseJourney,
        createInPersonProfessionalCase: createInPersonProfessionalCase,
        createInviteProfessionalCase: createInviteProfessionalCase,
        submitProfessionalCaseToAdviser: submitProfessionalCaseToAdviser,
        registeredSoasByProfileId: registeredSoasByProfileId,
        analyticsDataState: analyticsDataState,
        loadFactFindsForAnalytics: loadFactFindsForAnalytics,
        remindClient: remindClient,
        firmSettings: firmSettings,
        autoReminders: autoReminders,
        messageDefaults: messageDefaults,
        saveFirmSettings: saveFirmSettings
    };
}


/**
 * Session/auth domain: who is signed in, the AccountModal's open/mode state, the invite-link /
 * email-confirmation / password-reset / Stripe-return arrival flows, and resuming a signed-in
 * visitor back to exactly where they left off. Extracted out of App.tsx, which composes this
 * alongside the professional-portal and page-routing concerns.
 */ 
var $acw62 = parcelRequire("acw62");



/**
 * Which door someone signed in through — and therefore where they belong.
 *
 * The rule, in the owner's words: sign in through the Partner Portal and you land in your
 * workspace with your clients; sign in as a client and you land on the client dashboard, or
 * wherever you left off.
 *
 * WHY THIS IS PERSISTED RATHER THAN JUST HELD IN STATE. The partner flag used to live only in
 * React state, and two things knocked it over:
 *
 *   1. `closeAccountModal()` deliberately clears it, and the sign-in handler calls that BEFORE it
 *      reads it. The in-flight handler kept its own copy, so that was thought safe — but setting
 *      the session also triggers the auto-resume effect, which starts a SECOND handler with a
 *      fresh copy where the flag is already gone. That one takes the consumer path and overwrites
 *      the workspace the first was heading to.
 *   2. A page reload starts with no flag at all, so a partner who refreshed was posted back to the
 *      client fact-find.
 *
 * Session-scoped (not local) storage: it should last as long as the tab and no longer, so a shared
 * machine never inherits someone else's door.
 */ const $c68a4714eced6b3d$var$KEY = 'acw:signInDoor';
function $c68a4714eced6b3d$export$40966f30a56fb32(door) {
    try {
        globalThis.sessionStorage.setItem($c68a4714eced6b3d$var$KEY, door);
    } catch  {
    /* Private browsing or blocked storage — the in-memory flag still covers the common path. */ }
}
function $c68a4714eced6b3d$export$f8110d7fb5e549e5() {
    try {
        const stored = globalThis.sessionStorage.getItem($c68a4714eced6b3d$var$KEY);
        return stored === 'partner' || stored === 'client' ? stored : null;
    } catch  {
        return null;
    }
}
function $c68a4714eced6b3d$export$9e0389e1ecdd83c2() {
    try {
        globalThis.sessionStorage.removeItem($c68a4714eced6b3d$var$KEY);
    } catch  {
    /* ignore */ }
}









function $36466739b029c3d8$export$6af6f333c20ef9be({ accountUser: accountUser, setAccountUser: setAccountUser, activePage: activePage, setActivePage: setActivePage, setFactFind: setFactFind, setClientProfileStep: setClientProfileStep, setSavedStrategies: setSavedStrategies, setSavedCaseStudies: setSavedCaseStudies, setCoupleValidation: setCoupleValidation, setShowPaywall: setShowPaywall, partnerIntent: partnerIntent, setPartnerIntent: setPartnerIntent, setActiveProfessionalCaseId: setActiveProfessionalCaseId, setActiveRealProfileId: setActiveRealProfileId, setPartnerFirm: setPartnerFirm, setPartnerResolving: setPartnerResolving, setPortalRefreshNonce: setPortalRefreshNonce, showPartnerWizard: showPartnerWizard, setShowPartnerWizard: setShowPartnerWizard, setPartnerPaywall: setPartnerPaywall, setAddClientPaywall: setAddClientPaywall, flushPendingSave: flushPendingSave, routePlatformAdminWithoutFirm: routePlatformAdminWithoutFirm }) {
    // 'reset' when the user arrives from a password-reset email link; null otherwise.
    const [accountModalMode, setAccountModalMode] = (0, $acw62.useState)(null);
    // The token from a ?reset=<token> URL, threaded into AccountModal for the reset-confirm call.
    const [resetToken, setResetToken] = (0, $acw62.useState)(null);
    const [showAccountModal, setShowAccountModal] = (0, $acw62.useState)(false);
    // "Get Started" signup entry point (AccountModal in signup mode).
    const [showRegistration, setShowRegistration] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        (0, $cc9e8a24185b91b0$export$a79e7ef8c396bb0e)().then(setAccountUser);
    }, [
        setAccountUser
    ]);
    // A signed-in visitor who reloads the page (or returns via a bookmark) lands back on the
    // landing page with no URL routing to tell us otherwise. Rather than making them click
    // "Client Login" again to trigger the very same session check, do it once automatically —
    // mirrors exactly what AccountModal does on open: if a live session exists, resume straight
    // into the last page/step the server has saved. Skips when a more specific entry flow (invite
    // link, password reset, email-confirmation return, Stripe return) already owns this load, and
    // never fires more than once per app load. Declared BEFORE those flows' own accountUser-effects
    // so it reads their ref flags (below) before those effects clear them.
    const autoResumeAttemptedRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (!accountUser || autoResumeAttemptedRef.current) return;
        if (activePage !== 'LandingPage') return;
        if (resetToken || confirmReturnRef.current || billingReturnRef.current || (0, $442533e192804693$export$3b3ae80d6efd63b1)() || (0, $442533e192804693$export$339c81b2cc180bb5)()) return;
        autoResumeAttemptedRef.current = true;
        (async ()=>{
            const loaded = await (0, $a0f9af581f384312$export$4310a59bd5b0b729)().catch(()=>null);
            if (loaded) setFactFind(loaded.factFind);
            resumeFromSignIn(loaded);
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        accountUser
    ]);
    // LEGACY: this once auto-reopened the wizard for the old email-CONFIRMATION-LINK round trip.
    // Sign-up is now a single-screen code (no link/second tab), so `awaitingAuth` is never set by
    // current code — and a STALE draft left in localStorage from an earlier attempt must NOT pop
    // the "Become a partner" wizard over a normal sign-in. So we clear any such stale draft here
    // instead of acting on it.
    (0, $acw62.useEffect)(()=>{
        if ((0, $32ebf447c4b68a2b$export$9dd6f4410f0ac0c8)()?.awaitingAuth) (0, $32ebf447c4b68a2b$export$93c6d857426f1fc7)();
    }, []);
    // Arriving via an email-confirmation link: don't leave the new user stranded on the landing
    // page — continue their journey (partner wizard if that's what they were doing, otherwise
    // straight into the client flow).
    const confirmReturnRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (/type=signup/.test(window.location.hash)) confirmReturnRef.current = true;
    }, []);
    // Returning from Stripe hosted Checkout (?billing=success|cancelled). Capture + strip it on load.
    const billingReturnRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        billingReturnRef.current = (0, $9969e0eb851fd9fb$export$2b77153545a8e902)();
    }, []);
    // Once signed in, act on the Stripe return: success → re-check access and enter the app;
    // cancelled → keep them on the paywall (they're signed in but haven't paid).
    (0, $acw62.useEffect)(()=>{
        if (!accountUser || !billingReturnRef.current) return;
        const outcome = billingReturnRef.current;
        billingReturnRef.current = null;
        if (outcome === 'success') {
            // A partner may be returning from a plan/slot purchase — clear the setup chooser and the
            // "add another client" modal so the portal-entry gate re-reads their (now paid) summary.
            setPartnerPaywall(null);
            setAddClientPaywall(null);
            (async ()=>{
                const loaded = await (0, $a0f9af581f384312$export$4310a59bd5b0b729)().catch(()=>null);
                if (loaded) setFactFind(loaded.factFind);
                resumeFromSignIn(loaded);
            })();
        } else if (outcome === 'cancelled') setShowPaywall(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        accountUser
    ]);
    // A password-reset email link returns the user to the app (?reset=<token>) — open "choose a
    // new password" with the token threaded into AccountModal for the confirm call.
    (0, $acw62.useEffect)(()=>{
        const params = new URLSearchParams(window.location.search);
        const token = params.get('reset');
        if (!token) return;
        setResetToken(token);
        setAccountModalMode('reset');
        setShowAccountModal(true);
    }, []);
    // A person clicking an invite link deserves to KNOW what happened — never silence.
    const [inviteNotice, setInviteNotice] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!inviteNotice) return undefined;
        const t = setTimeout(()=>setInviteNotice(null), 12000);
        return ()=>clearTimeout(t);
    }, [
        inviteNotice
    ]);
    // Invite links (?invite=TOKEN): remember the token, and ask the visitor to sign in / create
    // an account — the invite is redeemed right after they're signed in.
    (0, $acw62.useEffect)(()=>{
        const token = (0, $442533e192804693$export$691aaaf0deffae39)();
        if (!token) return;
        (0, $cc9e8a24185b91b0$export$a79e7ef8c396bb0e)().then(async (user)=>{
            if (user) {
                // Taken, not read: whichever handler takes it redeems it, and only that one.
                const taken = (0, $442533e192804693$export$ec6a2e3c3bb73e9c)();
                if (!taken) return;
                const res = await (0, $442533e192804693$export$f17229473791149b)(taken).finally(()=>(0, $442533e192804693$export$900988654c72c4e3)());
                if (!res.ok) {
                    setInviteNotice({
                        tone: 'error',
                        text: /different email/i.test(res.message) ? "This invitation was sent to a different email address than the one you're signed in with. Sign out, then open the link again." : `That invitation link could not be used: ${res.message}. Please ask whoever sent it for a fresh one.`
                    });
                    return;
                }
                if ([
                    'owner',
                    'adviser',
                    'staff'
                ].includes(res.role)) {
                    setPartnerResolving(true);
                    setActivePage('PartnerPortal');
                    return;
                }
                // Client invite: open the file their adviser prepared and tell them it worked.
                const loaded = await (0, $a0f9af581f384312$export$4310a59bd5b0b729)().catch(()=>null);
                if (loaded) setFactFind(loaded.factFind);
                setInviteNotice({
                    tone: 'success',
                    text: "You're connected \u2014 this plan is linked with your adviser."
                });
                setClientProfileStep(1);
                setActivePage('Client Profile');
            } else {
                // Most invitees are brand new — greet them with CREATE ACCOUNT, not "Welcome back".
                setAccountModalMode('signup');
                setShowAccountModal(true);
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * Consumer app-entry gate (Option A paywall). If billing is LIVE and this consumer has no active
   * access, show the paywall; otherwise run `proceed` (into their plan / fact-find). Safe while
   * billing is off: the server reports hasAccess:true, so `proceed` always runs and nothing changes.
   */ const enterConsumerWithBilling = async (proceed)=>{
        const ent = await (0, $9969e0eb851fd9fb$export$4de14aec71635fd2)();
        if (ent.billingConfigured && !ent.hasAccess) {
            setShowPaywall(true);
            return;
        }
        setShowPaywall(false);
        proceed();
    };
    /** Signed in → put the client back exactly where they left off (or the fact-find if brand new). */ const resumeFromSignIn = async (loaded)=>{
        // Drives auto-save (see autosaveEnabled below) — without this, a session that just signed in
        // this page load (rather than resuming an existing one at mount) never enables auto-save, so
        // nothing about the plan the client is about to fill in ever gets persisted.
        setAccountUser(await (0, $cc9e8a24185b91b0$export$a79e7ef8c396bb0e)());
        closeAccountModal();
        setActiveProfessionalCaseId(null);
        setActiveRealProfileId(null);
        (0, $357e6188006bbf96$export$2e58bf066eef6dcd)();
        // An invite link brought them here: join the firm/file first; partner staff go to the portal.
        const inviteToken = (0, $442533e192804693$export$ec6a2e3c3bb73e9c)();
        if (inviteToken) {
            const res = await (0, $442533e192804693$export$f17229473791149b)(inviteToken).finally(()=>(0, $442533e192804693$export$900988654c72c4e3)());
            if (!res.ok) // Say so — a silently-failed invite reads as "the app is broken".
            setInviteNotice({
                tone: 'error',
                text: `That invitation link could not be used: ${res.message}. Please ask whoever sent it for a fresh one. (You are signed in; your own plan is still here.)`
            });
            if (res.ok && [
                'owner',
                'adviser',
                'staff'
            ].includes(res.role)) {
                setPartnerResolving(true); // show the branded loader, never the demo login, from frame 1
                setActivePage('PartnerPortal');
                return;
            }
            // A client invite just linked their prepared file — load it fresh (the earlier lookup
            // ran before the acceptance, so it saw nothing), and start them on step 1 of the profile:
            // the file is a shell their adviser named, not a plan to resume (owner, 16 Oct 2026 — an
            // invited client landed on a dashboard that called their empty profile complete).
            if (res.ok && res.role === 'client') {
                loaded = await (0, $a0f9af581f384312$export$4310a59bd5b0b729)().catch(()=>null);
                if (loaded) setFactFind(loaded.factFind);
                setInviteNotice({
                    tone: 'success',
                    text: "You're connected \u2014 this plan is linked with your adviser."
                });
                setClientProfileStep(1);
                setActivePage('Client Profile');
                return;
            }
        }
        // Signed in through the partner door: firm members go to the portal. Only offer the
        // onboarding wizard when we POSITIVELY confirm they have no firm — a transient failure must
        // never mean "become a partner" for a returning owner.
        // The recorded door counts as well as the in-memory flag. closeAccountModal() above clears
        // the flag, and setting the session starts a SECOND, racing copy of this handler via the
        // auto-resume effect — that copy saw no flag, took the consumer path and overwrote the
        // workspace. It also means a reload keeps a partner in their workspace. See signInDoor.ts.
        if (partnerIntent || (0, $c68a4714eced6b3d$export$f8110d7fb5e549e5)() === 'partner') {
            setPartnerIntent(false);
            const res = await (0, $4a3ab415a7732163$export$2e7e98436b791c3c)();
            if (res.membership) {
                (0, $32ebf447c4b68a2b$export$93c6d857426f1fc7)(); // never let a stale signup draft resurface for a real member
                setPartnerResolving(true); // show the branded loader, never the demo login, from frame 1
                setActivePage('PartnerPortal');
            } else if (res.ok) // Confirmed: this login has no firm. A platform admin goes to the admin console; anyone
            // else is offered onboarding.
            {
                if (!await routePlatformAdminWithoutFirm()) setShowPartnerWizard(true);
            } else {
                // Couldn't determine (network/timeout) → send them to the portal, whose own entry effect
                // retries and shows a retry screen on continued failure. NEVER the signup wizard.
                setPartnerResolving(true);
                setActivePage('PartnerPortal');
            }
            return;
        }
        // Not flagged as a partner sign-in, but this login may still belong to a firm — e.g. a partner
        // returning via a password-reset link (no partner-door flag). A firm member's home is their
        // portal (client list), never the consumer fact-find. (On a "couldn't determine" result we fall
        // through to the consumer resume — least surprising for a non-partner-door login.)
        const firm = await (0, $4a3ab415a7732163$export$2e7e98436b791c3c)();
        if (firm.membership) {
            (0, $32ebf447c4b68a2b$export$93c6d857426f1fc7)();
            setPartnerResolving(true); // branded loader, never the demo login, from frame 1
            setActivePage('PartnerPortal');
            return;
        }
        // A platform admin's home is the firms console, whichever door they used (owner, 1 Oct 2026):
        // signing in through the client door used to land the owner on Client Profile step 1.
        if (firm.ok && await routePlatformAdminWithoutFirm()) return;
        if (!loaded) {
            // No saved plan on this account yet — start the fact-find (behind the paywall if billing is live).
            await enterConsumerWithBilling(()=>{
                setClientProfileStep(1);
                setActivePage('Client Profile');
            });
            return;
        }
        // Put back everything the account holds: strategies, scenarios, SOA case studies,
        // service plans — then land the user on the screen they last worked on.
        const appData = loaded.appData || {};
        if (Array.isArray(appData.savedStrategies)) setSavedStrategies(appData.savedStrategies);
        if (Array.isArray(appData.savedCaseStudies)) setSavedCaseStudies(appData.savedCaseStudies);
        setCoupleValidation(appData.coupleValidation ? {
            ...(0, $87baeb3af1e4d5de$export$8c4af9c383a44b94)(),
            ...appData.coupleValidation
        } : (0, $87baeb3af1e4d5de$export$8c4af9c383a44b94)());
        (0, $a0f9af581f384312$export$fe33d8b505081339)(appData);
        const appState = loaded.appState || {};
        if (appState.clientProfileStep) setClientProfileStep(Number(appState.clientProfileStep) || 1);
        const lastPageRaw = appState.lastPage;
        const lastPage = typeof lastPageRaw === 'string' && (0, $4a3ab415a7732163$export$77b890292aeb9804).includes(lastPageRaw) ? lastPageRaw : 'Dashboard';
        await enterConsumerWithBilling(()=>setActivePage(lastPage));
    };
    // Completes the email-confirmation arrival once the session is ready (see confirmReturnRef).
    (0, $acw62.useEffect)(()=>{
        if (!confirmReturnRef.current || !accountUser) return;
        confirmReturnRef.current = false;
        // A partner mid-wizard owns this arrival — never hijack it into the client flow.
        if (showPartnerWizard || (0, $32ebf447c4b68a2b$export$9dd6f4410f0ac0c8)()?.awaitingAuth) return;
        (async ()=>{
            const loaded = await (0, $a0f9af581f384312$export$4310a59bd5b0b729)().catch(()=>null);
            if (loaded) setFactFind(loaded.factFind);
            resumeFromSignIn(loaded);
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        accountUser
    ]);
    /** Signed out → clear their data from the screen and this browser, back to the front door. */ const handleSignedOut = async ()=>{
        // Wait for any in-flight/queued autosave to actually land BEFORE invalidating the session —
        // authSignOut() below revokes the token, so a save still in flight (or one about to fire)
        // would fail auth and be silently dropped, losing the last few seconds of edits even though
        // an earlier, less complete autosave already succeeded. See useAutoSave.ts's doc comment.
        await flushPendingSave().catch(()=>{});
        // Always end the real session BEFORE navigating (awaited), so a subsequent login
        // can never see a stale session. The portal's Sign out calls this directly (bypassing the
        // account modal), so the sign-out must live here.
        await (0, $cc9e8a24185b91b0$export$b0ac3a1c242cb1ea)().catch(()=>{});
        // Forget whose licence advice is given under. Without this, a second firm signing in on the same
        // tab would generate documents carrying the FIRST firm's attribution until their workspace
        // finished resolving — the wrong licensee on a client document, for exactly as long as nobody
        // noticed.
        (0, $92fb3c34dca71663$export$8dcd5d1de2b3df34)(null);
        closeAccountModal();
        setFactFind(structuredClone((0, $b116352393ba4abb$export$55f731ae3600e88a)));
        setSavedStrategies([]);
        setSavedCaseStudies([]);
        setCoupleValidation((0, $87baeb3af1e4d5de$export$8c4af9c383a44b94)());
        (0, $a0f9af581f384312$export$62a775eed95889de)();
        (0, $a0f9af581f384312$export$1db2a6d91babbd88)(null); // forget which cloud file this browser was writing to
        setActiveProfessionalCaseId(null);
        setActiveRealProfileId(null);
        setPartnerFirm(null);
        setPartnerIntent(false); // a cancelled/finished partner journey must never haunt the next login
        (0, $c68a4714eced6b3d$export$9e0389e1ecdd83c2)(); // ...and neither must the door it came through
        setAccountUser(null);
        setClientProfileStep(1);
        setActivePage('LandingPage');
    };
    const closeAccountModal = ()=>{
        setShowAccountModal(false);
        setAccountModalMode(null);
        // A partner sign-in that didn't finish must not haunt the next journey: without this, a later
        // "Client Login" shows partner branding and shoves a plain consumer into the firm wizard.
        // (Safe on success too: the in-flight resume still sees its own copy of the flag.)
        setPartnerIntent(false);
        // Re-check the portal after the security panel closes (an MFA enrolment upgrades the
        // session, so the firm's client list can now load).
        if (activePage === 'PartnerPortal') setPortalRefreshNonce((n)=>n + 1);
    };
    return {
        resetToken: resetToken,
        accountModalMode: accountModalMode,
        showAccountModal: showAccountModal,
        setShowAccountModal: setShowAccountModal,
        showRegistration: showRegistration,
        setShowRegistration: setShowRegistration,
        inviteNotice: inviteNotice,
        setInviteNotice: setInviteNotice,
        enterConsumerWithBilling: enterConsumerWithBilling,
        resumeFromSignIn: resumeFromSignIn,
        handleSignedOut: handleSignedOut,
        closeAccountModal: closeAccountModal
    };
}


/**
 * Auto-save (signed-in consumers only): quietly persists EVERYTHING — the plan, where they're up
 * to, saved strategies/scenarios, SOA case studies and service plans — a few seconds after each
 * change, plus a 30-second sweep for work stored outside React state (e.g. SAH service plans).
 * Partner-portal demo journeys are excluded on purpose. Extracted out of App.tsx.
 */ 
var $acw62 = parcelRequire("acw62");

/** The one-line reason a save was refused, from whatever the request threw. */ function $b563189de2094b70$var$describeSaveFailure(err) {
    const e = err;
    const status = e?.response?.status;
    const code = e?.response?.data?.error?.code;
    if (status === 422 || code === 'INVALID_FACT_FIND') return 'The server did not accept the shape of the file (it may be running an older version). Nothing changed since your last successful save has been kept.';
    // A firm member's account must have two-step sign-in before it can save; told as what it is, not
    // as an expired session (owner, 16 Oct 2026, testing a client invite from an adviser's own login).
    // Only a genuine change to the name or contact details is refused now (the server ignores an
    // unchanged identity); say which half did not land rather than blaming the session.
    if (code === 'PROFILE_CHANGED') return 'This file was saved in another window or by someone else since you opened it. Reload to see the latest; nothing was overwritten.';
    if (code === 'IDENTITY_READ_ONLY') return 'Your changes were saved, except your name and contact details, which your adviser keeps. Ask them if those need updating.';
    if (code === 'MFA_SETUP_REQUIRED') return 'Saving needs two-step sign-in on this account. Set up your authenticator under Account, then try again.';
    if (status === 401 || status === 403) return 'Your sign-in has expired. Sign in again to keep saving.';
    if (status === 402) return 'Your plan does not allow saving at the moment.';
    if (!status) return 'The server could not be reached.';
    return e?.response?.data?.error?.message || e?.message || 'Something went wrong saving your work.';
}
function $b563189de2094b70$export$7bd7a03f2ad77f7a({ accountUser: accountUser, activeProfessionalCaseId: activeProfessionalCaseId, activeRealProfileId: activeRealProfileId, activePage: activePage, factFind: factFind, clientProfileStep: clientProfileStep, savedStrategies: savedStrategies, savedCaseStudies: savedCaseStudies, coupleValidation: coupleValidation }) {
    const autosaveEnabled = Boolean(accountUser) && (!activeProfessionalCaseId || Boolean(activeRealProfileId)) && activePage !== 'LandingPage' && activePage !== 'PartnerPortal';
    // Two overlapping saves race on the network: an earlier request (started first, e.g. while a
    // field was still mid-edit) can resolve AFTER a later, more complete one, silently overwriting
    // it with stale data — the PUT/POST here has no server-side ordering guard (no ETag/version
    // check), so the client must never have more than one save in flight. `savingRef` enforces that;
    // a save requested while one is already in flight just marks `pendingRef` and re-fires (with
    // whatever is CURRENT at that time, via `latestSaveRef`) once the in-flight one finishes — so the
    // most recent state always eventually lands, in the order it was produced. This also prevents a
    // second, duplicate profile being created: on a brand-new profile, autoSaveClientProfile POSTs
    // and only then learns the new profileId — a second save firing before that POST resolves would
    // otherwise see no stored id and POST its own separate profile record.
    const savingRef = (0, $acw62.useRef)(false);
    const pendingRef = (0, $acw62.useRef)(false);
    const latestSaveRef = (0, $acw62.useRef)(()=>{});
    const [saveFailure, setSaveFailure] = (0, $acw62.useState)(null);
    // Saved elsewhere since this copy was opened: stop saving until the page is reloaded (23 Oct 2026).
    const [savedElsewhere, setSavedElsewhere] = (0, $acw62.useState)(false);
    const savedElsewhereRef = (0, $acw62.useRef)(false);
    /*
   * WHAT WAS LAST SAVED, so an unchanged file is not sent again (owner, 23 Oct 2026). The 30-second sweep
   * re-sent the whole file every time whether or not anything had changed; a forgotten window doing that
   * is how older work overwrote newer. A save now goes only when the file differs from the last one that
   * landed; the version check (profileApi) refuses anything stale that still gets through.
   */ const lastSavedRef = (0, $acw62.useRef)(null);
    // Another file opened in this tab starts afresh: the refusal was about the file it came from.
    (0, $acw62.useEffect)(()=>{
        savedElsewhereRef.current = false;
        setSavedElsewhere(false);
        setSaveFailure(null);
    }, [
        activeRealProfileId
    ]);
    const performAutoSave = (0, $acw62.useCallback)(()=>{
        if (savedElsewhereRef.current) return;
        const payload = {
            factFind: factFind,
            appState: {
                lastPage: activePage,
                clientProfileStep: clientProfileStep
            },
            appData: {
                savedStrategies: savedStrategies,
                savedCaseStudies: savedCaseStudies,
                coupleValidation: coupleValidation,
                sessionMirror: (0, $a0f9af581f384312$export$e77e0ac9cb053698)()
            }
        };
        if (savingRef.current) {
            pendingRef.current = true;
            return;
        }
        let snapshot = null;
        try {
            snapshot = JSON.stringify([
                activeRealProfileId,
                payload
            ]);
        } catch  {
            snapshot = null;
        }
        if (snapshot !== null && snapshot === lastSavedRef.current) return;
        savingRef.current = true;
        // Adviser working on a REAL client file → save to that record; otherwise the user's own plan.
        const save = activeRealProfileId ? (0, $a0f9af581f384312$export$e38d9fa5fa0a9fe6)({
            ...payload,
            profileId: activeRealProfileId
        }) : (0, $a0f9af581f384312$export$cb7149721c33bed5)(payload);
        save.then(()=>{
            lastSavedRef.current = snapshot;
            setSaveFailure(null);
        }).catch((err)=>{
            if ((0, $a0f9af581f384312$export$12328d6c67223805)(err)) {
                savedElsewhereRef.current = true;
                setSavedElsewhere(true);
            }
            setSaveFailure($b563189de2094b70$var$describeSaveFailure(err));
        }).finally(()=>{
            savingRef.current = false;
            if (pendingRef.current) {
                pendingRef.current = false;
                latestSaveRef.current();
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        factFind,
        activePage,
        clientProfileStep,
        savedStrategies,
        savedCaseStudies,
        coupleValidation,
        activeRealProfileId
    ]);
    (0, $acw62.useEffect)(()=>{
        latestSaveRef.current = performAutoSave;
    }, [
        performAutoSave
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!autosaveEnabled) return undefined;
        const timer = setTimeout(performAutoSave, 4000);
        return ()=>clearTimeout(timer);
    }, [
        autosaveEnabled,
        performAutoSave
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!autosaveEnabled) return undefined;
        const interval = setInterval(performAutoSave, 30000);
        return ()=>clearInterval(interval);
    }, [
        autosaveEnabled,
        performAutoSave
    ]);
    /*
   * A SELECTED PLAN IS SAVED AT ONCE (owner, 3 Oct 2026). Selecting a strategy is the act the
   * dashboard and the advice document hang off; it used to wait out the four-second debounce like
   * a keystroke, and a reload inside that window (a Statement of Advice opening in a new tab, a
   * dev-server restart) lost it with nothing said. The count moving is the signal.
   */ const savedCountRef = (0, $acw62.useRef)(savedStrategies.length + savedCaseStudies.length);
    (0, $acw62.useEffect)(()=>{
        const count = savedStrategies.length + savedCaseStudies.length;
        if (count === savedCountRef.current) return;
        savedCountRef.current = count;
        if (autosaveEnabled) performAutoSave();
    }, [
        autosaveEnabled,
        performAutoSave,
        savedStrategies.length,
        savedCaseStudies.length
    ]);
    const retrySave = (0, $acw62.useCallback)(()=>{
        latestSaveRef.current();
    }, []);
    const flushPendingSave = (0, $acw62.useCallback)(()=>{
        if (!autosaveEnabled) return Promise.resolve();
        // Make sure a save reflecting the latest state is at least queued (if one's already in
        // flight, this just sets pendingRef, which is exactly what we want to wait out below).
        latestSaveRef.current();
        const deadline = Date.now() + 8000;
        return new Promise((resolve)=>{
            const poll = ()=>{
                if (!savingRef.current && !pendingRef.current || Date.now() > deadline) {
                    resolve();
                    return;
                }
                setTimeout(poll, 50);
            };
            poll();
        });
    }, [
        autosaveEnabled
    ]);
    return {
        flushPendingSave: flushPendingSave,
        saveFailure: saveFailure,
        retrySave: retrySave,
        savedElsewhere: savedElsewhere
    };
}


/**
 * Top-level screen selection: which full-screen mode the app is in (a standalone info/legal page,
 * the admin console, a paywall, the landing page, the partner portal, or the signed-in main app
 * shell) and the overlays (account modal, partner onboarding wizard) that can appear across them.
 * Extracted out of App.tsx, which owns all the state this reads and builds the pre-rendered
 * overlay nodes (registrationOverlay/inviteNoticeToast/chatWidget) it's handed.
 */ 
parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $960b709ecb4ade55$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ]
];
const $960b709ecb4ade55$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("shield", $960b709ecb4ade55$export$3efd853dbb351e94);




var $acw62 = parcelRequire("acw62");


const $b777d6e89b390316$var$HomeCareProviderSearch = ({ onClose: onClose })=>{
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)('');
    const [maxDistance, setMaxDistance] = (0, $acw62.useState)(10);
    const [packageLevel, setPackageLevel] = (0, $acw62.useState)('all');
    const [showResults, setShowResults] = (0, $acw62.useState)(false);
    // Mock home care provider data
    const mockProviders = [
        {
            id: 1,
            name: "Caring Hands Home Care",
            suburb: "Croydon",
            state: "NSW",
            distance: 1.2,
            rating: 4.3,
            packageLevels: [
                "Level 1 ($10,698)",
                "Level 2 ($15,982)",
                "Level 3 ($21,920)",
                "Level 4 ($29,545)",
                "Level 5 ($39,535)",
                "Level 6 ($47,957)",
                "Level 7 ($58,122)",
                "Level 8 ($77,709)"
            ],
            services: [
                "Personal Care",
                "Nursing",
                "Allied Health",
                "Social Support"
            ],
            coverage: "Inner West Sydney",
            websiteUrl: 'https://example.org/carecompanion-demo/providers/caring-hands-home-care',
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1559027615-cd4628902d4a', 600, 400),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1586023492125-27b2c045efd7', 600, 400),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1560448204-e02f11c3d0e2', 600, 400)
            ]
        },
        {
            id: 2,
            name: "Comfort Care Services",
            suburb: "Five Dock",
            state: "NSW",
            distance: 2.1,
            rating: 4.6,
            packageLevels: [
                "Level 2 ($15,982)",
                "Level 3 ($21,920)",
                "Level 4 ($29,545)",
                "Level 5 ($39,535)",
                "Level 6 ($47,957)"
            ],
            services: [
                "Personal Care",
                "Nursing",
                "Allied Health",
                "Social Support",
                "Respite Care"
            ],
            coverage: "Inner West Sydney",
            websiteUrl: 'https://example.org/carecompanion-demo/providers/comfort-care-services',
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1571896349842-33c89424de2d', 600, 400),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1564013799919-ab600027ffc6', 600, 400),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1512917774080-9991f1c4c750', 600, 400)
            ]
        },
        {
            id: 3,
            name: "Gentle Touch Home Care",
            suburb: "Campsie",
            state: "NSW",
            distance: 3.4,
            rating: 4.1,
            packageLevels: [
                "Level 1 ($10,698)",
                "Level 2 ($15,982)",
                "Level 3 ($21,920)",
                "Level 4 ($29,545)"
            ],
            services: [
                "Personal Care",
                "Nursing",
                "Social Support"
            ],
            coverage: "Canterbury-Bankstown",
            websiteUrl: 'https://example.org/carecompanion-demo/providers/gentle-touch-home-care',
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1560448204-603b3fc33ddc', 600, 400),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1582407947304-fd86f028f716', 600, 400),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1559027615-cd4628902d4a', 600, 400)
            ]
        },
        {
            id: 4,
            name: "Sunrise Home Care",
            suburb: "Burwood",
            state: "NSW",
            distance: 4.7,
            rating: 4.4,
            packageLevels: [
                "Level 3 ($21,920)",
                "Level 4 ($29,545)",
                "Level 5 ($39,535)",
                "Level 6 ($47,957)",
                "Level 7 ($58,122)"
            ],
            services: [
                "Personal Care",
                "Nursing",
                "Allied Health",
                "Social Support",
                "Respite Care"
            ],
            coverage: "Inner West Sydney",
            websiteUrl: 'https://example.org/carecompanion-demo/providers/sunrise-home-care',
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1586023492125-27b2c045efd7', 600, 400),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1571896349842-33c89424de2d', 600, 400),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1564013799919-ab600027ffc6', 600, 400)
            ]
        },
        {
            id: 5,
            name: "Family First Care",
            suburb: "Ashfield",
            state: "NSW",
            distance: 2.8,
            rating: 4.0,
            packageLevels: [
                "Level 1 ($10,698)",
                "Level 2 ($15,982)",
                "Level 3 ($21,920)",
                "Level 4 ($29,545)",
                "Level 5 ($39,535)",
                "Level 6 ($47,957)",
                "Level 7 ($58,122)",
                "Level 8 ($77,709)"
            ],
            services: [
                "Personal Care",
                "Nursing",
                "Allied Health",
                "Social Support",
                "Respite Care"
            ],
            coverage: "Inner West Sydney",
            websiteUrl: 'https://example.org/carecompanion-demo/providers/family-first-care',
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1512917774080-9991f1c4c750', 600, 400),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1560448204-e02f11c3d0e2', 600, 400),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1582407947304-fd86f028f716', 600, 400)
            ]
        }
    ];
    const filteredProviders = mockProviders.filter((provider)=>{
        const distanceMatch = provider.distance <= maxDistance;
        const packageMatch = packageLevel === 'all' || provider.packageLevels.includes(packageLevel);
        return distanceMatch && packageMatch;
    }).sort((a, b)=>a.distance - b.distance);
    const handleSearch = ()=>{
        if (searchTerm.trim()) setShowResults(true);
    };
    const handleBackToSearch = ()=>{
        setShowResults(false);
        setSearchTerm('');
    };
    const handleACATApplication = ()=>{
        window.open('https://www.myagedcare.gov.au/assessment/apply-online', '_blank');
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white rounded-xl shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-hidden",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center justify-between p-6 border-b border-gray-200",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            className: "text-2xl font-bold text-gray-900",
                            children: showResults ? `Home Care Providers near ${searchTerm}` : 'Find Home Care Providers'
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: onClose,
                            className: "text-gray-400 hover:text-gray-600 transition-colors",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 24
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "p-6",
                    children: !showResults ? // Search Interface
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-gray-600 mb-6",
                                    children: "Enter your suburb or area to find nearby home care service providers"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "max-w-md mx-auto space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "block text-sm font-medium text-gray-700 mb-2",
                                                children: "Suburb or Area"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "text",
                                                value: searchTerm,
                                                onChange: (e)=>setSearchTerm(e.target.value),
                                                onKeyPress: (e)=>e.key === 'Enter' && handleSearch(),
                                                placeholder: "e.g., Croydon, Five Dock, Campsie...",
                                                className: "w-full px-4 py-3 text-lg border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "block text-sm font-medium text-gray-700 mb-2",
                                                children: [
                                                    "Max Distance: ",
                                                    maxDistance,
                                                    "km"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "range",
                                                min: "1",
                                                max: "20",
                                                value: maxDistance,
                                                onChange: (e)=>setMaxDistance(parseInt(e.target.value)),
                                                className: "w-full"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "block text-sm font-medium text-gray-700 mb-2",
                                                children: "Package Level"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: packageLevel,
                                                onChange: (e)=>setPackageLevel(e.target.value),
                                                className: "w-full px-4 py-3 text-lg border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "all",
                                                        children: "All Package Levels"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "Level 1",
                                                        children: "Level 1 ($10,698)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "Level 2",
                                                        children: "Level 2 ($15,982)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "Level 3",
                                                        children: "Level 3 ($21,920)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "Level 4",
                                                        children: "Level 4 ($29,545)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "Level 5",
                                                        children: "Level 5 ($39,535)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "Level 6",
                                                        children: "Level 6 ($47,957)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "Level 7",
                                                        children: "Level 7 ($58,122)"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "Level 8",
                                                        children: "Level 8 ($77,709)"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: handleSearch,
                                        disabled: !searchTerm.trim(),
                                        className: "w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed text-lg font-semibold",
                                        children: "Search Providers"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-8 p-6 bg-white rounded-lg border border-blue-200",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-start gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex-shrink-0",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                    className: "w-6 h-6 text-white"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    className: "text-lg font-semibold text-blue-900 mb-2",
                                                    children: "Need an aged care needs assessment for Support at Home?"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-blue-800 mb-4",
                                                    children: "To access Support at Home, you need an aged care needs assessment. This determines your care needs and Support at Home classification."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    onClick: handleACATApplication,
                                                    className: "px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                            size: 16
                                                        }),
                                                        "Apply via My Aged Care"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : // Results Interface
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex items-center justify-between",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    onClick: handleBackToSearch,
                                    className: "flex items-center gap-2 text-blue-600 hover:text-blue-800 transition-colors",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                            size: 20
                                        }),
                                        "Back to Search"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "space-y-4 max-h-96 overflow-y-auto",
                                children: filteredProviders.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-center py-8 text-gray-500",
                                    children: "No providers found matching your criteria."
                                }) : filteredProviders.map((provider)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "border border-gray-200 rounded-xl p-4 md:p-5 hover:border-blue-300 hover:shadow-md transition-all",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-col md:flex-row gap-5",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "shrink-0 w-full md:w-[min(100%,280px)] md:max-w-[280px]",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "aspect-[4/3] rounded-xl overflow-hidden bg-slate-100 ring-1 ring-slate-200/80",
                                                            children: provider.images?.[0] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                src: provider.images[0],
                                                                alt: provider.name,
                                                                className: "w-full h-full object-cover"
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "w-full h-full flex items-center justify-center text-sm text-slate-400",
                                                                children: "No photo"
                                                            })
                                                        }),
                                                        provider.images && provider.images.length > 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "flex gap-1.5 mt-2",
                                                            children: provider.images.slice(1, 4).map((image, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                    src: image,
                                                                    alt: `${provider.name} view ${index + 2}`,
                                                                    className: "h-14 min-w-0 flex-1 object-cover rounded-lg border border-slate-200"
                                                                }, index))
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex-1 min-w-0 flex flex-col lg:flex-row gap-4 lg:gap-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex-1 min-w-0",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                    className: "text-xl font-bold text-gray-900 leading-tight",
                                                                    children: provider.name
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                    className: "text-gray-600 mt-0.5",
                                                                    children: [
                                                                        provider.suburb,
                                                                        ", ",
                                                                        provider.state
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "flex flex-wrap items-center gap-x-4 gap-y-1 mt-3 text-sm text-slate-600",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "inline-flex items-center gap-1.5",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c978075baab28645$export$2e2bcd8739ae039), {
                                                                                    size: 15,
                                                                                    className: "text-sky-600 shrink-0",
                                                                                    "aria-hidden": true
                                                                                }),
                                                                                provider.distance,
                                                                                "km away"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "inline-flex items-center gap-1.5",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04b006b04b8c21eb$export$2e2bcd8739ae039), {
                                                                                    size: 15,
                                                                                    className: "text-amber-500 shrink-0",
                                                                                    "aria-hidden": true
                                                                                }),
                                                                                provider.rating,
                                                                                "/5"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "inline-flex items-center gap-1.5",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                                                                    size: 15,
                                                                                    className: "text-violet-600 shrink-0",
                                                                                    "aria-hidden": true
                                                                                }),
                                                                                provider.coverage
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "mt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-xs font-semibold uppercase tracking-wide text-slate-500",
                                                                            children: "Package levels"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "text-sm text-gray-800 mt-0.5 leading-snug",
                                                                            children: provider.packageLevels.join(', ')
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "mt-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-xs font-semibold uppercase tracking-wide text-slate-500",
                                                                            children: "Services"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "text-sm text-gray-800 mt-0.5",
                                                                            children: provider.services.join(', ')
                                                                        })
                                                                    ]
                                                                }),
                                                                provider.websiteUrl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                    href: provider.websiteUrl,
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    className: "mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-blue-600 hover:text-blue-800",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                                            size: 14,
                                                                            "aria-hidden": true
                                                                        }),
                                                                        "Visit website",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-xs font-normal text-gray-500",
                                                                            children: "(demo URL)"
                                                                        })
                                                                    ]
                                                                }) : null
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "shrink-0 flex lg:flex-col justify-end lg:justify-center gap-2 lg:w-44",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                onClick: ()=>window.open('https://www.myagedcare.gov.au/find-a-provider', '_blank'),
                                                                className: "w-full lg:w-auto px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-all font-semibold shadow-sm",
                                                                children: "Contact Provider"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, provider.id))
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $b777d6e89b390316$export$2e2bcd8739ae039 = $b777d6e89b390316$var$HomeCareProviderSearch;




var $acw62 = parcelRequire("acw62");


const $11948ce62f179171$var$RetirementVillageSearch = ({ onClose: onClose })=>{
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)('');
    const [maxDistance, setMaxDistance] = (0, $acw62.useState)(10);
    const [priceRange, setPriceRange] = (0, $acw62.useState)('all');
    const [showResults, setShowResults] = (0, $acw62.useState)(false);
    // Mock retirement village data
    const mockVillages = [
        {
            id: 1,
            name: "Sunset Gardens Retirement Village",
            suburb: "Croydon",
            state: "NSW",
            distance: 1.2,
            rating: 4.4,
            entryCost: 450000,
            ongoingFees: 1200,
            amenities: [
                "Swimming Pool",
                "Gym",
                "Library",
                "Cafe",
                "Garden"
            ],
            unitTypes: [
                "1 Bedroom",
                "2 Bedroom",
                "3 Bedroom"
            ],
            websiteUrl: 'https://example.org/carecompanion-demo/villages/sunset-gardens',
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1564013799919-ab600027ffc6', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1571896349842-33c89424de2d', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1582407947304-fd86f028f716', 300, 200)
            ]
        },
        {
            id: 2,
            name: "Riverside Living Community",
            suburb: "Five Dock",
            state: "NSW",
            distance: 2.1,
            rating: 4.6,
            entryCost: 650000,
            ongoingFees: 1500,
            amenities: [
                "Water Views",
                "Swimming Pool",
                "Gym",
                "Library",
                "Caf\xe9",
                "Garden",
                "Bowling Green"
            ],
            unitTypes: [
                "2 Bedroom",
                "3 Bedroom"
            ],
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1564013799919-ab600027ffc6', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1571896349842-33c89424de2d', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1582407947304-fd86f028f716', 300, 200)
            ]
        },
        {
            id: 3,
            name: "Heritage Park Village",
            suburb: "Campsie",
            state: "NSW",
            distance: 3.4,
            rating: 4.1,
            entryCost: 380000,
            ongoingFees: 950,
            amenities: [
                "Garden",
                "Library",
                "Cafe",
                "Community Hall"
            ],
            unitTypes: [
                "1 Bedroom",
                "2 Bedroom"
            ],
            websiteUrl: 'https://example.org/carecompanion-demo/villages/heritage-park',
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1512917774080-9991f1c4c750', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1560448204-603b3fc33ddc', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1564013799919-ab600027ffc6', 300, 200)
            ]
        },
        {
            id: 4,
            name: "Mountain View Retirement",
            suburb: "Burwood",
            state: "NSW",
            distance: 4.7,
            rating: 4.3,
            entryCost: 520000,
            ongoingFees: 1300,
            amenities: [
                "Mountain Views",
                "Swimming Pool",
                "Gym",
                "Library",
                "Cafe",
                "Garden"
            ],
            unitTypes: [
                "2 Bedroom",
                "3 Bedroom"
            ],
            websiteUrl: 'https://example.org/carecompanion-demo/villages/mountain-view-retirement',
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1564013799919-ab600027ffc6', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1571896349842-33c89424de2d', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1582407947304-fd86f028f716', 300, 200)
            ]
        },
        {
            id: 5,
            name: "Garden Court Village",
            suburb: "Ashfield",
            state: "NSW",
            distance: 2.8,
            rating: 4.0,
            entryCost: 420000,
            ongoingFees: 1100,
            amenities: [
                "Garden",
                "Library",
                "Cafe",
                "Community Hall",
                "Chapel"
            ],
            unitTypes: [
                "1 Bedroom",
                "2 Bedroom",
                "3 Bedroom"
            ],
            websiteUrl: 'https://example.org/carecompanion-demo/villages/garden-court',
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1559027615-cd4628902d4a', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1586023492125-27b2c045efd7', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1560448204-e02f11c3d0e2', 300, 200)
            ]
        }
    ];
    const filteredVillages = mockVillages.filter((village)=>{
        const distanceMatch = village.distance <= maxDistance;
        let priceMatch = true;
        if (priceRange !== 'all') switch(priceRange){
            case 'under-400k':
                priceMatch = village.entryCost < 400000;
                break;
            case '400k-600k':
                priceMatch = village.entryCost >= 400000 && village.entryCost <= 600000;
                break;
            case 'over-600k':
                priceMatch = village.entryCost > 600000;
                break;
        }
        return distanceMatch && priceMatch;
    }).sort((a, b)=>a.distance - b.distance);
    const handleSearch = ()=>{
        if (searchTerm.trim()) setShowResults(true);
    };
    const handleBackToSearch = ()=>{
        setShowResults(false);
        setSearchTerm('');
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white rounded-xl shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-hidden",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center justify-between p-6 border-b border-gray-200",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            className: "text-2xl font-bold text-gray-900",
                            children: showResults ? `Retirement Villages near ${searchTerm}` : 'Find Retirement Villages'
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: onClose,
                            className: "text-gray-400 hover:text-gray-600 transition-colors",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 24
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "p-6",
                    children: !showResults ? // Search Interface
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-gray-600 mb-6",
                                    children: "Enter your suburb or area to find nearby retirement villages"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "max-w-md mx-auto space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "block text-sm font-medium text-gray-700 mb-2",
                                                children: "Suburb or Area"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "text",
                                                value: searchTerm,
                                                onChange: (e)=>setSearchTerm(e.target.value),
                                                onKeyPress: (e)=>e.key === 'Enter' && handleSearch(),
                                                placeholder: "e.g., Croydon, Five Dock, Campsie...",
                                                className: "w-full px-4 py-3 text-lg border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "block text-sm font-medium text-gray-700 mb-2",
                                                children: [
                                                    "Max Distance: ",
                                                    maxDistance,
                                                    "km"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "range",
                                                min: "1",
                                                max: "20",
                                                value: maxDistance,
                                                onChange: (e)=>setMaxDistance(parseInt(e.target.value)),
                                                className: "w-full"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "block text-sm font-medium text-gray-700 mb-2",
                                                children: "Entry Cost Range"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: priceRange,
                                                onChange: (e)=>setPriceRange(e.target.value),
                                                className: "w-full px-4 py-3 text-lg border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "all",
                                                        children: "All Price Ranges"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "under-400k",
                                                        children: "Under $400,000"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "400k-600k",
                                                        children: "$400,000 - $600,000"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "over-600k",
                                                        children: "Over $600,000"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: handleSearch,
                                        disabled: !searchTerm.trim(),
                                        className: "w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed text-lg font-semibold",
                                        children: "Search Villages"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-8 p-6 bg-white rounded-lg border border-green-200",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-start gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex-shrink-0",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-12 h-12 bg-green-600 rounded-full flex items-center justify-center",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bee7e1f6335e67ab$export$2e2bcd8739ae039), {
                                                    className: "w-6 h-6 text-white"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    className: "text-lg font-semibold text-green-900 mb-2",
                                                    children: "Independent Living"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-green-800 mb-4",
                                                    children: "Retirement villages offer independent living with optional care services. No aged care needs assessment required - you can move in directly and access care services as needed."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "text-sm text-green-700",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "Key Benefits:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                            className: "list-disc list-inside mt-2 space-y-1",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                    children: "Independent living with community support"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                    children: "Optional care services available"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                    children: "Social activities and amenities"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                    children: "Maintenance-free lifestyle"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : // Results Interface
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex items-center justify-between",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    onClick: handleBackToSearch,
                                    className: "flex items-center gap-2 text-blue-600 hover:text-blue-800 transition-colors",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                            size: 20
                                        }),
                                        "Back to Search"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "space-y-4 max-h-96 overflow-y-auto",
                                children: filteredVillages.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-center py-8 text-gray-500",
                                    children: "No villages found matching your criteria."
                                }) : filteredVillages.map((village)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "border border-gray-200 rounded-xl p-4 md:p-5 hover:border-blue-300 hover:shadow-md transition-all",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-col md:flex-row gap-5",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "shrink-0 w-full md:w-[min(100%,280px)] md:max-w-[280px]",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "aspect-[4/3] rounded-xl overflow-hidden bg-slate-100 ring-1 ring-slate-200/80",
                                                            children: village.images?.[0] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                src: village.images[0],
                                                                alt: village.name,
                                                                className: "w-full h-full object-cover"
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "w-full h-full flex items-center justify-center text-sm text-slate-400",
                                                                children: "No photo"
                                                            })
                                                        }),
                                                        village.images && village.images.length > 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "flex gap-1.5 mt-2",
                                                            children: village.images.slice(1, 4).map((image, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                    src: image,
                                                                    alt: `${village.name} view ${index + 2}`,
                                                                    className: "h-14 min-w-0 flex-1 object-cover rounded-lg border border-slate-200"
                                                                }, index))
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex-1 min-w-0 flex flex-col lg:flex-row gap-4 lg:gap-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex-1 min-w-0",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                    className: "text-xl font-bold text-gray-900 leading-tight",
                                                                    children: village.name
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                    className: "text-gray-600 mt-0.5",
                                                                    children: [
                                                                        village.suburb,
                                                                        ", ",
                                                                        village.state
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "flex flex-wrap items-center gap-x-4 gap-y-1 mt-3 text-sm text-slate-600",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "inline-flex items-center gap-1.5",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c978075baab28645$export$2e2bcd8739ae039), {
                                                                                    size: 15,
                                                                                    className: "text-sky-600 shrink-0",
                                                                                    "aria-hidden": true
                                                                                }),
                                                                                village.distance,
                                                                                "km away"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "inline-flex items-center gap-1.5",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04b006b04b8c21eb$export$2e2bcd8739ae039), {
                                                                                    size: 15,
                                                                                    className: "text-amber-500 shrink-0",
                                                                                    "aria-hidden": true
                                                                                }),
                                                                                village.rating,
                                                                                "/5"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "inline-flex items-center gap-1.5 font-medium text-slate-800",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                                                                                    size: 15,
                                                                                    className: "text-emerald-600 shrink-0",
                                                                                    "aria-hidden": true
                                                                                }),
                                                                                "$",
                                                                                village.entryCost.toLocaleString()
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "mt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-xs font-semibold uppercase tracking-wide text-slate-500",
                                                                            children: "Unit types"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "text-sm text-gray-800 mt-0.5",
                                                                            children: village.unitTypes.join(', ')
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "mt-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-xs font-semibold uppercase tracking-wide text-slate-500",
                                                                            children: "Amenities"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "text-sm text-gray-800 mt-0.5",
                                                                            children: village.amenities.join(', ')
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "mt-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-xs font-semibold uppercase tracking-wide text-slate-500",
                                                                            children: "Monthly fees"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                            className: "text-sm text-gray-800 mt-0.5",
                                                                            children: [
                                                                                "$",
                                                                                village.ongoingFees.toLocaleString()
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                village.websiteUrl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                    href: village.websiteUrl,
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    className: "mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-blue-600 hover:text-blue-800",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                                            size: 14,
                                                                            "aria-hidden": true
                                                                        }),
                                                                        "Visit website",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-xs font-normal text-gray-500",
                                                                            children: "(demo URL)"
                                                                        })
                                                                    ]
                                                                }) : null
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "shrink-0 flex lg:flex-col justify-end lg:justify-center gap-2 lg:w-44",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                onClick: ()=>window.open('https://www.retirementvillages.com.au', '_blank'),
                                                                className: "w-full lg:w-auto px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-all font-semibold shadow-sm",
                                                                children: "Contact Village"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, village.id))
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $11948ce62f179171$export$2e2bcd8739ae039 = $11948ce62f179171$var$RetirementVillageSearch;




var $acw62 = parcelRequire("acw62");


const $e87ab397afd99bf3$var$AgedCareFacilitySearch = ({ onClose: onClose })=>{
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)('');
    const [maxDistance, setMaxDistance] = (0, $acw62.useState)(10);
    const [sortBy, setSortBy] = (0, $acw62.useState)('distance');
    const [showResults, setShowResults] = (0, $acw62.useState)(false);
    // Mock aged care facility data (standalone version)
    const mockFacilities = [
        {
            id: 1,
            name: "Sunrise Aged Care",
            suburb: "Croydon",
            state: "NSW",
            radPrice: 500000,
            dailyFees: {
                basic: 70,
                dap: 68,
                nccc: 0,
                hsc: 13,
                extraServices: 0
            },
            distance: 1.2,
            rating: 4.2,
            careLevels: [
                "Low Care",
                "High Care"
            ],
            amenities: [
                "Garden",
                "Library",
                "Chapel"
            ],
            websiteUrl: 'https://example.org/carecompanion-demo/facilities/sunrise-aged-care',
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1559027615-cd4628902d4a', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1586023492125-27b2c045efd7', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1560448204-e02f11c3d0e2', 300, 200)
            ]
        },
        {
            id: 2,
            name: "Garden View Care Centre",
            suburb: "Five Dock",
            state: "NSW",
            radPrice: 850000,
            dailyFees: {
                basic: 70,
                dap: 116,
                nccc: 0,
                hsc: 13,
                extraServices: 15
            },
            distance: 2.1,
            rating: 4.5,
            careLevels: [
                "Low Care",
                "High Care",
                "Dementia Care"
            ],
            amenities: [
                "Swimming Pool",
                "Gym",
                "Caf\xe9"
            ],
            websiteUrl: 'https://example.org/carecompanion-demo/facilities/garden-view-care-centre',
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1571896349842-33c89424de2d', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1564013799919-ab600027ffc6', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1582407947304-fd86f028f716', 300, 200)
            ]
        },
        {
            id: 3,
            name: "Heritage Manor",
            suburb: "Campsie",
            state: "NSW",
            radPrice: 780000,
            dailyFees: {
                basic: 70,
                dap: 107,
                nccc: 0,
                hsc: 13,
                extraServices: 0
            },
            distance: 3.4,
            rating: 3.8,
            careLevels: [
                "Low Care",
                "High Care"
            ],
            amenities: [
                "Garden",
                "Library"
            ],
            websiteUrl: 'https://example.org/carecompanion-demo/facilities/heritage-manor',
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1512917774080-9991f1c4c750', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1560448204-603b3fc33ddc', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1564013799919-ab600027ffc6', 300, 200)
            ]
        },
        {
            id: 4,
            name: "Riverside Care Centre",
            suburb: "Burwood",
            state: "NSW",
            radPrice: 650000,
            dailyFees: {
                basic: 70,
                dap: 89,
                nccc: 0,
                hsc: 13,
                extraServices: 8
            },
            distance: 4.7,
            rating: 4.0,
            careLevels: [
                "Low Care",
                "High Care",
                "Palliative Care"
            ],
            amenities: [
                "Water Views",
                "Garden",
                "Chapel"
            ],
            websiteUrl: 'https://example.org/carecompanion-demo/facilities/riverside-care-centre',
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1564013799919-ab600027ffc6', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1582407947304-fd86f028f716', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1571896349842-33c89424de2d', 300, 200)
            ]
        },
        {
            id: 5,
            name: "Mountain View Aged Care",
            suburb: "Ashfield",
            state: "NSW",
            radPrice: 420000,
            dailyFees: {
                basic: 70,
                dap: 58,
                nccc: 0,
                hsc: 13,
                extraServices: 0
            },
            distance: 2.8,
            rating: 4.1,
            careLevels: [
                "Low Care",
                "High Care"
            ],
            amenities: [
                "Garden",
                "Library",
                "Chapel"
            ],
            websiteUrl: 'https://example.org/carecompanion-demo/facilities/mountain-view-aged-care',
            images: [
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1559027615-cd4628902d4a', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1586023492125-27b2c045efd7', 300, 200),
                (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1560448204-e02f11c3d0e2', 300, 200)
            ]
        }
    ];
    const filteredFacilities = mockFacilities.filter((facility)=>facility.distance <= maxDistance).sort((a, b)=>{
        switch(sortBy){
            case 'price':
                return a.radPrice - b.radPrice;
            case 'rating':
                return b.rating - a.rating;
            default:
                return a.distance - b.distance;
        }
    });
    const handleSearch = ()=>{
        if (searchTerm.trim()) setShowResults(true);
    };
    const handleBackToSearch = ()=>{
        setShowResults(false);
        setSearchTerm('');
    };
    const handleACATApplication = ()=>{
        window.open('https://www.myagedcare.gov.au/assessment/apply-online', '_blank');
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white rounded-xl shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-hidden",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center justify-between p-6 border-b border-gray-200",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            className: "text-2xl font-bold text-gray-900",
                            children: showResults ? `Aged Care Facilities near ${searchTerm}` : 'Find Aged Care Facilities'
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: onClose,
                            className: "text-gray-400 hover:text-gray-600 transition-colors",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 24
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "p-6",
                    children: !showResults ? // Search Interface
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-gray-600 mb-6",
                                    children: "Enter your suburb or area to find nearby aged care facilities"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "max-w-md mx-auto space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "block text-sm font-medium text-gray-700 mb-2",
                                                children: "Suburb or Area"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "text",
                                                value: searchTerm,
                                                onChange: (e)=>setSearchTerm(e.target.value),
                                                onKeyPress: (e)=>e.key === 'Enter' && handleSearch(),
                                                placeholder: "e.g., Croydon, Five Dock, Campsie...",
                                                className: "w-full px-4 py-3 text-lg border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "block text-sm font-medium text-gray-700 mb-2",
                                                children: [
                                                    "Max Distance: ",
                                                    maxDistance,
                                                    "km"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "range",
                                                min: "1",
                                                max: "20",
                                                value: maxDistance,
                                                onChange: (e)=>setMaxDistance(parseInt(e.target.value)),
                                                className: "w-full"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: handleSearch,
                                        disabled: !searchTerm.trim(),
                                        className: "w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed text-lg font-semibold",
                                        children: "Search Facilities"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-8 p-6 bg-white rounded-lg border border-blue-200",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-start gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex-shrink-0",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                    className: "w-6 h-6 text-white"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    className: "text-lg font-semibold text-blue-900 mb-2",
                                                    children: "Need an aged care needs assessment for residential care?"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-blue-800 mb-4",
                                                    children: "To access residential aged care, you need an aged care needs assessment. This determines your care needs and eligibility for government-subsidised care."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    onClick: handleACATApplication,
                                                    className: "px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                            size: 16
                                                        }),
                                                        "Apply via My Aged Care"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : // Results Interface
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        onClick: handleBackToSearch,
                                        className: "flex items-center gap-2 text-blue-600 hover:text-blue-800 transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                                size: 20
                                            }),
                                            "Back to Search"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "text-sm font-medium text-gray-700",
                                                children: "Sort By:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: sortBy,
                                                onChange: (e)=>setSortBy(e.target.value),
                                                className: "px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "distance",
                                                        children: "Distance"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "price",
                                                        children: "RAD Price"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "rating",
                                                        children: "Rating"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "space-y-4 max-h-96 overflow-y-auto",
                                children: filteredFacilities.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-center py-8 text-gray-500",
                                    children: "No facilities found matching your criteria."
                                }) : filteredFacilities.map((facility)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "border border-gray-200 rounded-xl p-4 md:p-5 hover:border-blue-300 hover:shadow-md transition-all",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-col md:flex-row gap-5",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "shrink-0 w-full md:w-[min(100%,280px)] md:max-w-[280px]",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "aspect-[4/3] rounded-xl overflow-hidden bg-slate-100 ring-1 ring-slate-200/80",
                                                            children: facility.images?.[0] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                src: facility.images[0],
                                                                alt: facility.name,
                                                                className: "w-full h-full object-cover"
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "w-full h-full flex items-center justify-center text-sm text-slate-400",
                                                                children: "No photo"
                                                            })
                                                        }),
                                                        facility.images && facility.images.length > 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "flex gap-1.5 mt-2",
                                                            children: facility.images.slice(1, 4).map((image, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                    src: image,
                                                                    alt: `${facility.name} view ${index + 2}`,
                                                                    className: "h-14 min-w-0 flex-1 object-cover rounded-lg border border-slate-200"
                                                                }, index))
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex-1 min-w-0 flex flex-col lg:flex-row gap-4 lg:gap-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex-1 min-w-0",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                    className: "text-xl font-bold text-gray-900 leading-tight",
                                                                    children: facility.name
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                    className: "text-gray-600 mt-0.5",
                                                                    children: [
                                                                        facility.suburb,
                                                                        ", ",
                                                                        facility.state
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "flex flex-wrap items-center gap-x-4 gap-y-1 mt-3 text-sm text-slate-600",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "inline-flex items-center gap-1.5",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c978075baab28645$export$2e2bcd8739ae039), {
                                                                                    size: 15,
                                                                                    className: "text-sky-600 shrink-0",
                                                                                    "aria-hidden": true
                                                                                }),
                                                                                facility.distance,
                                                                                "km away"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "inline-flex items-center gap-1.5",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04b006b04b8c21eb$export$2e2bcd8739ae039), {
                                                                                    size: 15,
                                                                                    className: "text-amber-500 shrink-0",
                                                                                    "aria-hidden": true
                                                                                }),
                                                                                facility.rating,
                                                                                "/5"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "inline-flex items-center gap-1.5 font-medium text-slate-800",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                                                                                    size: 15,
                                                                                    className: "text-emerald-600 shrink-0",
                                                                                    "aria-hidden": true
                                                                                }),
                                                                                "$",
                                                                                facility.radPrice.toLocaleString()
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "mt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-xs font-semibold uppercase tracking-wide text-slate-500",
                                                                            children: "Care levels"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "text-sm text-gray-800 mt-0.5",
                                                                            children: facility.careLevels.join(', ')
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "mt-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-xs font-semibold uppercase tracking-wide text-slate-500",
                                                                            children: "Amenities"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "text-sm text-gray-800 mt-0.5",
                                                                            children: facility.amenities.join(', ')
                                                                        })
                                                                    ]
                                                                }),
                                                                facility.websiteUrl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                    href: facility.websiteUrl,
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    className: "mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-blue-600 hover:text-blue-800",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                                            size: 14,
                                                                            "aria-hidden": true
                                                                        }),
                                                                        "Visit website",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-xs font-normal text-gray-500",
                                                                            children: "(demo URL)"
                                                                        })
                                                                    ]
                                                                }) : null
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "shrink-0 flex lg:flex-col justify-end lg:justify-center gap-2 lg:w-44",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                onClick: ()=>window.open('https://www.myagedcare.gov.au/find-a-provider', '_blank'),
                                                                className: "w-full lg:w-auto px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-all font-semibold shadow-sm",
                                                                children: "Contact Facility"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, facility.id))
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $e87ab397afd99bf3$export$2e2bcd8739ae039 = $e87ab397afd99bf3$var$AgedCareFacilitySearch;



parcelRequire("acw62");


const $d989e4f2a8ad0174$var$ACATApplicationButton = ({ context: context = "aged care" })=>{
    const handleACATApplication = ()=>{
        window.open((0, $73bacbfa279634e3$export$63641d97ed9ac2e9), '_blank', 'noopener,noreferrer');
    };
    const getContextText = ()=>{
        switch(context){
            case "home care":
                return {
                    title: "Need an aged care needs assessment for Support at Home?",
                    description: "To access Support at Home, you need an aged care needs assessment. This determines your care needs and Support at Home classification.",
                    benefits: [
                        "Determines your care needs and classification",
                        "Required for government-subsidised Support at Home",
                        "Free assessment service",
                        "Can be done in your own home"
                    ]
                };
            case "aged care":
            default:
                return {
                    title: "Need an aged care needs assessment for residential care?",
                    description: "To access residential aged care, you need an aged care needs assessment. This determines your care needs and eligibility for government-subsidised care.",
                    benefits: [
                        "Determines your care needs and care level",
                        "Required for government-subsidised care",
                        "Free assessment service",
                        "Can be done in your own home or hospital"
                    ]
                };
        }
    };
    const contextInfo = getContextText();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "p-6 bg-white rounded-lg border border-blue-200",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex items-start gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex-shrink-0",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                            className: "w-6 h-6 text-white"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "text-lg font-semibold text-blue-900 mb-2",
                            children: contextInfo.title
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-blue-800 mb-4",
                            children: contextInfo.description
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "mb-4",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "space-y-2",
                                children: contextInfo.benefits.map((benefit, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        className: "flex items-center gap-2 text-sm text-blue-700",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                size: 16,
                                                className: "text-blue-600 flex-shrink-0"
                                            }),
                                            benefit
                                        ]
                                    }, index))
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            onClick: handleACATApplication,
                            className: "px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                    size: 16
                                }),
                                "Apply via My Aged Care"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "mt-4 p-3 bg-blue-100 rounded-lg",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-2 text-sm text-blue-800",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                                        size: 16
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "Assessment Process:"
                                            }),
                                            " Usually takes 2-4 weeks from application to assessment completion"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $d989e4f2a8ad0174$export$2e2bcd8739ae039 = $d989e4f2a8ad0174$var$ACATApplicationButton;




var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");
/** Inline **markdown-style** bold segments for chat bubbles. */ function $b251b4a79d9a44dd$var$renderChatInlineFormatting(text) {
    if (!text) return null;
    const parts = text.split(/(\*\*[^*]+\*\*)/g);
    return parts.map((part, i)=>{
        if (part.length > 4 && part.startsWith('**') && part.endsWith('**')) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
            className: "font-semibold text-gray-900",
            children: part.slice(2, -2)
        }, i);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            children: part
        }, i);
    });
}
function $b251b4a79d9a44dd$export$2e2bcd8739ae039({ text: text }) {
    const blocks = text.split(/\n{2,}/).map((b)=>b.trim()).filter(Boolean);
    if (blocks.length === 0) return null;
    if (blocks.length === 1) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-sm leading-relaxed whitespace-pre-line",
        children: $b251b4a79d9a44dd$var$renderChatInlineFormatting(blocks[0])
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-sm leading-relaxed space-y-2",
        children: blocks.map((block, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "m-0 whitespace-pre-line",
                children: $b251b4a79d9a44dd$var$renderChatInlineFormatting(block)
            }, i))
    });
}


function $e31cd18cd0725a6f$export$2e2bcd8739ae039({ open: open, onClose: onClose, messages: messages, chatInput: chatInput, onChatInputChange: onChatInputChange, onSubmit: onSubmit, sending: sending, onSubscribe: onSubscribe, subscribeLabel: subscribeLabel = 'Get Started', signedIn: signedIn = false, className: className = '' }) {
    const scrollRef = (0, $acw62.useRef)(null);
    const inputRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        inputRef.current?.focus();
    }, [
        open
    ]);
    (0, $acw62.useEffect)(()=>{
        const el = scrollRef.current;
        if (el) el.scrollTop = el.scrollHeight;
    }, [
        messages,
        open,
        sending
    ]);
    if (!open) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `fixed inset-0 z-[100] flex items-end justify-center sm:justify-end p-4 pointer-events-none ${className}`,
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "awise-chat-title",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: "absolute inset-0 bg-black/30 pointer-events-auto",
                "aria-label": "Close chat",
                onClick: onClose
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative pointer-events-auto w-full max-w-md bg-white rounded-2xl shadow-2xl flex flex-col max-h-[min(32rem,85vh)] mb-2 sm:mb-10 sm:mr-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-between items-center gap-2 p-4 border-b border-gray-100 shrink-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-2 min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8afc40d49a7e79bf$export$2e2bcd8739ae039), {
                                        className: "text-blue-600 shrink-0",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2c4379c8d623235$export$2e2bcd8739ae039), {
                                        id: "awise-chat-title",
                                        size: "lg"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-1 shrink-0",
                                children: [
                                    onSubscribe && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: onSubscribe,
                                        className: "text-xs sm:text-sm font-semibold text-blue-600 hover:text-blue-800 px-2 py-1 rounded-lg hover:bg-blue-50",
                                        children: subscribeLabel
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: onClose,
                                        className: "p-2 hover:bg-gray-100 rounded-full transition-colors",
                                        "aria-label": "Close",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                            size: 20
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        ref: scrollRef,
                        className: "overflow-y-auto flex-1 p-4 space-y-3 min-h-[12rem]",
                        children: [
                            messages.map((msg, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: `flex ${msg.sender === 'user' ? 'justify-end' : 'justify-start'}`,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: `px-3 py-2 rounded-lg max-w-[92%] ${msg.sender === 'user' ? 'bg-blue-100 text-blue-900' : 'bg-gray-100 text-gray-700'}`,
                                        children: msg.sender === 'user' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-sm whitespace-pre-line",
                                            children: msg.text
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b251b4a79d9a44dd$export$2e2bcd8739ae039), {
                                            text: msg.text
                                        })
                                    })
                                }, i)),
                            sending && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex justify-start",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "px-3 py-2 rounded-lg bg-gray-100 text-gray-500 text-sm",
                                    children: "Thinking\u2026"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-4 border-t border-gray-100 shrink-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        ref: inputRef,
                                        type: "text",
                                        className: "flex-1 min-w-0 px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/40",
                                        placeholder: "What's on your mind?",
                                        value: chatInput,
                                        onChange: (e)=>onChatInputChange(e.target.value),
                                        onKeyDown: (e)=>{
                                            if (e.key !== 'Enter' || e.shiftKey) return;
                                            e.preventDefault();
                                            onSubmit();
                                        },
                                        disabled: sending,
                                        "aria-label": "Chat message"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "shrink-0 bg-blue-600 text-white px-4 py-2 rounded-lg font-semibold text-sm hover:bg-blue-700 disabled:opacity-60",
                                        onClick: onSubmit,
                                        disabled: sending || !chatInput.trim(),
                                        children: sending ? "\u2026" : 'Send'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-2 text-[11px] text-gray-500 leading-snug",
                                children: signedIn ? "General information only \u2014 not personal advice. The figures AWise quotes are the ones already in your plan; it explains them, it never recalculates them." : "General information only \u2014 not personal advice. Personalised modelling is available after you subscribe."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/**
 * AgedCareWise AI chat — client side. Talks to OUR backend (/rest/ai/chat), which holds the Gemini key
 * server-side and calls the provider. The API key is NEVER in the browser (see server/ + .env.example).
 */ 



/** API base URL: the backend origin. Configured via REACT_APP_API_BASE_URL; defaults to local dev. */ function $17f95ada13b08766$var$getApiBaseUrl() {
    // One source for this — see services/apiBase.ts for why eight copies was a problem.
    return (0, $4e54353814e6aea9$export$8ebae31efd30e025)();
}
function $17f95ada13b08766$export$e91c0eea0d8efe6a(err) {
    const status = err.response?.status;
    const apiMsg = String(err.response?.data?.error?.message || '').trim();
    const lower = apiMsg.toLowerCase();
    const code = err.response?.data?.error?.code;
    if (code === 'AI_ANON_QUOTA_EXCEEDED') return "You've used today's free questions \u2014 they reset tomorrow. Or create a free account (it takes a minute) and keep chatting with AWise.";
    if (code === 'AI_QUOTA_EXCEEDED') return "You've used today's AI assistant allowance \u2014 it resets tomorrow. Everything else in AgedCareWise keeps working as normal.";
    if (status === 429 || lower.includes('quota') || lower.includes('resource exhausted') || code === 'RESOURCE_EXHAUSTED') return "The AI service is busy or a short-term usage limit was hit. Wait a minute and try again \u2014 this often happens after several questions in a row.";
    if (!err.response) return "Couldn't reach the AI service (network). Check your connection, then try again.";
    if (status === 401) return "Please sign in to use the AI assistant \u2014 it\u2019s included with your account.";
    if (status === 503 || code === 'NOT_CONFIGURED') return 'AI chat is temporarily unavailable (the service is not configured). Please try again later.';
    if (status === 504) return 'The AI took too long to respond. Please try again in a moment.';
    if (status === 403) return "The AI service rejected the request. This is a server configuration issue, not something you did \u2014 please try again later.";
    if (status === 400 && apiMsg) {
        const short = apiMsg.length > 220 ? `${apiMsg.slice(0, 217)}\u{2026}` : apiMsg;
        return `The request wasn't accepted: ${short}`;
    }
    if (apiMsg && apiMsg.length < 300) return `Sorry \u{2014} ${apiMsg}`;
    return "Sorry, I couldn't get a response just then. Please try again in a moment.";
}
async function $17f95ada13b08766$export$58ecd998c8d4e9d3({ message: message, systemInstruction: systemInstruction, conversationHistory: conversationHistory = [] }) {
    const url = `${$17f95ada13b08766$var$getApiBaseUrl()}/rest/ai/chat`;
    try {
        // The server requires a signed-in caller (it spends real money per request). Attach the
        // session token when accounts are configured; demo/local builds have none and stay open.
        const token = await (0, $cc9e8a24185b91b0$export$84773cc9bf7dbe87)().catch(()=>null);
        const headers = {
            'Content-Type': 'application/json'
        };
        if (token) headers.Authorization = `Bearer ${token}`;
        // Which file is open, so AWise's affordability tool reports on the right one. Sent, not trusted:
        // the server serves it only if this user OWNS that file, and resolves it from ownership alone when
        // absent — which it is for a single-file caller, who is never given an id in the first place.
        const profileId = (0, $a0f9af581f384312$export$25d8ec09bea77dfb)();
        const response = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(url, {
            message: message,
            systemInstruction: systemInstruction,
            conversationHistory: conversationHistory,
            ...profileId ? {
                profileId: profileId
            } : {}
        }, {
            headers: headers,
            timeout: 95000
        });
        const text = response.data?.text;
        if (text) return text;
        // Server returns an empty text for a blocked/empty provider reply.
        return "I couldn't generate a reply for that message. Try rephrasing, or ask about aged care, retirement, super, or related topics.";
    } catch (err) {
        const axiosErr = err;
        return $17f95ada13b08766$export$e91c0eea0d8efe6a(axiosErr);
    }
}





/**
 * System instructions for AgedCareWise AI (Gemini).
 * Landing: general education + subscribe CTA; in-app: tool help without dollar calculations.
 */ 


const $076d4db919791ede$export$7771deecdec1975d = (0, $c79e495c2243b635$export$37a8fb3a3ffc9c34)();
const $076d4db919791ede$export$c25880153d3c2847 = `You are AWise, the AgedCareWise assistant on the public homepage, helping visitors in Australia understand retirement and aged care living choices.

${$076d4db919791ede$export$7771deecdec1975d}

ROLE
Provide general, educational information in plain language\u{2014}similar in spirit to My Aged Care and official government sources. You are not providing personal financial advice and you must not model outcomes for this visitor's situation.

ALLOWED TOPICS (only answer when the question relates to one or more of):
- Living arrangements: support at home (home care), downsizing, retirement villages / independent living, granny flat arrangements, residential aged care
- Aged care system and fees (RAD, DAP, means testing) explained conceptually
- Social security / Centrelink / Age Pension as concepts (not their entitlement)
- Superannuation, tax, and investments only as they relate to retirement living, aged care, or estate outcomes
- Estate / legacy concepts in general educational terms (not legal advice)

OUT OF SCOPE
If the question is unrelated (sports, recipes, coding, general chit-chat, etc.), briefly say it is outside AgedCareWise's scope and invite a question within the topics above.

NO MODELLING OR PERSONAL CALCULATIONS
Do not compute or estimate: pension amounts, means-test results, RAD/DAP payable, tax payable, cashflow projections, or "what you would get" from their numbers.
Do not ask them to provide assets, income, or dates so you can calculate outcomes.
Explain that personalised projections are inside AgedCareWise after they subscribe or use Get Started.

GENERAL IMPACTS ARE OK
You may describe typical considerations, e.g. downsizing and buying a more expensive home can increase assessable assets and may reduce Age Pension; granny flat arrangements have gifting and asset-test rules; selling the former home can change pension treatment depending on circumstances. Keep these conceptual\u{2014}no dollar figures for their case.

SUBSCRIBE / GET STARTED CTA
When you discuss financial impacts, comparing pathways, or "what if" questions, include a natural invitation once per reply when relevant, e.g. "Subscribe or Get Started with AgedCareWise to see how this could affect your cashflow, Age Pension, and what's left to your estate using your own figures."

DO NOT ROUTINE-REFER TO FINANCIAL ADVISERS
Do not tell the user to see a financial adviser, planner, or accountant as the default answer. AgedCareWise is their planning environment.

VS PERSONALISED FINANCIAL ADVICE
If asked how AgedCareWise differs from personalised financial advice, do not criticise personal advice. Explain that AgedCareWise uses technology to provide affordable, high-quality guidance, and that depending on the living arrangement chosen the solution can work through hundreds of strategy combinations\u{2014}with personalised modelling in the subscribed tool.

SOURCES
Prefer official Australian sources: My Aged Care, Services Australia, ATO, DSS. You may mention general educational material from reputable super funds where appropriate.

FORMATTING
Write for on-screen chat. Use blank lines between ideas. Use bullet or numbered lists for options. You may use **bold** for short labels. Stay concise and accurate. Australian spelling.`;
const $076d4db919791ede$export$80e8d3f847fbc35c = `You are AWise, the AgedCareWise assistant, helping people use the AgedCareWise app in Australia.

${$076d4db919791ede$export$7771deecdec1975d}

ALLOWED TOPICS \u{2014} Only answer when the question clearly relates to one or more of:
- Aged care (residential care, RAD/DAP, home care, My Aged Care, care fees in general terms)
- Tax, as it relates to retirement, superannuation, aged care, or personal finance in that context
- Social security / Centrelink / Age Pension and related benefits (conceptual and general)
- Retirement villages and independent living
- Superannuation
- Estate planning \u{2014} general, educational information only (not legal advice)
- Living arrangements, investments, and funding strategies in the context above

OUT OF SCOPE \u{2014} If the question is clearly unrelated (e.g. sports, recipes, homework, coding, general chit-chat, or topics with no link to the list above), do not answer that topic. Briefly say it is outside AgedCareWise's scope and invite them to ask something that fits the topics above.

DO NOT ROUTINE-REFER TO ADVISERS \u{2014} Do not default to telling the user to "see a financial adviser" or "consult a qualified financial adviser." This tool is their planning environment. If something is uncertain or highly individual, say that AgedCareWise's own modelling and their situation matter, suggest verifying against official sources (My Aged Care, Services Australia, ATO), and keep your reply general and educational\u{2014}not personal advice.

VS PERSONALISED FINANCIAL ADVICE \u{2014} If asked how AgedCareWise differs from personalised financial advice, do not criticise personal advice. Explain that AgedCareWise uses technology to deliver affordable, high-quality guidance and can explore many strategy combinations depending on living arrangement\u{2014}with personalised figures in the tool.

CALCULATIONS \u{2014} Do not perform or invent: aged care means-test outcomes, social security rate or eligibility dollar calculations, government fee calculations, or pension amounts from rules. For those, point users to the figures and projections shown in AgedCareWise when relevant, and to official government sources\u{2014}not your own calculated entitlement numbers.

AFFORDABILITY TOOL \u{2014} For any question about whether this user can afford care, how long their money lasts, what their own figures show, what they will be worth in a particular year, or what is left to their estate, call get_my_affordability_summary. It returns the projection AgedCareWise already calculated for their saved strategy. It takes no arguments and always returns this signed-in user's own file; never ask them for a client id or offer to look up anyone else.

Using the result:
- Quote its dollar figures EXACTLY as given, character for character. They are already rounded and formatted.
- Do no arithmetic on them. Do not add, subtract, scale, annualise, convert to fortnightly, or project them forward. If a question needs a figure the result does not contain, say the projection doesn't show that and point to the Aged Care section.
- State the affordability position using the result's "verdict" text. Explain and expand on it in your own words\u{2014}but do not reach a different conclusion from it.
- Use "drivers" to explain WHY the strategy produces those numbers. That is your main job here: the figures are settled, the reasoning is what the user needs.
- Say which plan it is ("planType"), which strategy the figures belong to ("strategyName") and when it was saved. Use "annualCostDescription" when you mention "annualCost"\u{2014}what the cost covers differs by plan and the label is part of the figure.
- If "otherSavedStrategies" is above zero, mention they have others saved and can compare them. If "otherPlanTypesSaved" is non-empty, say which other plans they have modelled\u{2014}do not imply this is their only one.
- If "horizonYears" is null, say the horizon wasn't recorded for that strategy rather than assuming one.
- For "what will I be worth in FY27/28" and any other net worth question about a particular year, use "netWorthByYear". Each entry is one balance-sheet date under two names: "atEndOf" is the period ending on it, "atStartOf" is the period beginning on it. Match the user's wording to whichever field names their period and quote that entry's "netWorth" verbatim. Never work a year out by counting entries, adding to a year number, or interpolating between two dates\u{2014}if no entry names the period they asked about, say so.
- Always read "netWorthByYearNote" before answering from "netWorthByYear", and follow it. It says what range the projection covers and what to do outside it. If "netWorthByYear" is empty, relay that note instead of falling back to "estateAtEndOfHorizon"\u{2014}the estate figure is the final year only and is not an answer about any other year.
- If it returns found: false, tell them what it says\u{2014}do not estimate anything from their fact-find to fill the gap.

NO ARITHMETIC \u{2014} Do not calculate. Not on tool figures, not on figures the user types in, not on the published rates above, not on anything. This includes adding, subtracting, multiplying, dividing, percentages, ratios, yields, totals, differences between two strategies, annual-to-fortnightly conversions, and "roughly" or "about" estimates. It applies even when the user sets the sum up for you, insists, says it is only an example, or says they will check it themselves.

Every number in your reply must be one you are repeating verbatim from the tool result, the published figures above, or the user's own message. If answering needs a number that does not already exist in one of those, say AgedCareWise calculates that and point them to the relevant section\u{2014}then explain the concept, which is what actually helps.

SOURCES \u{2014} Prefer official Australian government information (My Aged Care, Services Australia, ATO, DSS). You may reference educational technical material from Challenger, Colonial First State, and MLC where appropriate.

FORMATTING \u{2014} Write for on-screen reading in a chat panel. Separate ideas with blank lines (double line breaks). For multiple points, use numbered or bullet lists with each item on its own line. You may wrap short labels in **bold** (e.g. **Medicare Levy Surcharge:**) but keep answers concise.

Stay accurate, concise, and Australian-focused.`;
// --- GeneralAdvice (public education screens) — AWise trained on the on-screen content ---
const $076d4db919791ede$var$fmt0 = (n)=>'$' + Math.round(n).toLocaleString('en-AU');
const $076d4db919791ede$var$fmt2 = (n)=>'$' + Number(n).toLocaleString('en-AU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
const $076d4db919791ede$var$perFt = (annual)=>$076d4db919791ede$var$fmt2(annual / 26);
/** Published figures shown on the GeneralAdvice screens — keeps AWise consistent with the page. */ const $076d4db919791ede$var$AWISE_CURRENT_FIGURES = `CURRENT PUBLISHED FIGURES (general info, as at ${(0, $1abe73eeef086faf$export$946308c675ba021d).agePension} \u{2014} these are the figures shown on screen; quote these if asked, do not invent others; they are general rates, not this visitor's entitlement):
- Age Pension max rate: single ${$076d4db919791ede$var$perFt((0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single)}/fortnight (${$076d4db919791ede$var$fmt0((0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single)}/yr); couple combined ${$076d4db919791ede$var$perFt((0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).couple)}/fortnight (${$076d4db919791ede$var$fmt0((0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).couple)}/yr).
- Assets test (homeowner) \u{2014} full pension below: single ${$076d4db919791ede$var$fmt0((0, $1abe73eeef086faf$export$9a84fd450010fb2e).single.homeowner.full)}, couple ${$076d4db919791ede$var$fmt0((0, $1abe73eeef086faf$export$9a84fd450010fb2e).couple.homeowner.full)}. Pension cuts out above: single ${$076d4db919791ede$var$fmt0((0, $1abe73eeef086faf$export$9a84fd450010fb2e).single.homeowner.cutoff)}, couple ${$076d4db919791ede$var$fmt0((0, $1abe73eeef086faf$export$9a84fd450010fb2e).couple.homeowner.cutoff)}, couple illness-separated ${$076d4db919791ede$var$fmt0((0, $1abe73eeef086faf$export$9a84fd450010fb2e).coupleIllnessSeparated.homeowner.cutoff)}.
- Income test cut-off (annual): single ${$076d4db919791ede$var$fmt0((0, $1abe73eeef086faf$export$bad1f8cb9d172d1b).single)}, couple ${$076d4db919791ede$var$fmt0((0, $1abe73eeef086faf$export$bad1f8cb9d172d1b).couple)}, couple illness-separated ${$076d4db919791ede$var$fmt0((0, $1abe73eeef086faf$export$bad1f8cb9d172d1b).coupleIllnessSeparated)}.
- Residential care: Basic Daily Fee ${$076d4db919791ede$var$fmt2((0, $815d7df20c36742b$export$36c4ec5f3f340aef).basicDailyFeeDaily)}/day; NCCC cap ${$076d4db919791ede$var$fmt2((0, $815d7df20c36742b$export$36c4ec5f3f340aef).maxNCCCDaily)}/day (lifetime ${$076d4db919791ede$var$fmt0((0, $815d7df20c36742b$export$36c4ec5f3f340aef).ncccLifetimeCap)}); Hotelling cap ${$076d4db919791ede$var$fmt2((0, $815d7df20c36742b$export$36c4ec5f3f340aef).maxHotellingDaily)}/day; MPIR ${((0, $815d7df20c36742b$export$36c4ec5f3f340aef).MPIR * 100).toFixed(2)}%; maximum RAD without approval ${$076d4db919791ede$var$fmt0((0, $815d7df20c36742b$export$36c4ec5f3f340aef).maxRAD)}.

ILLNESS-SEPARATED (important): when one member of a couple moves into residential aged care, Centrelink treats them as "illness-separated" \u{2014} each is paid the higher single Age Pension rate and assessed against more generous (higher) asset and income cut-offs, even though their assets and income are still combined. This usually increases the couple's combined Age Pension and reduces means-tested care fees, and is a key reason aged care planning matters for couples.

TERMINOLOGY (1 Nov 2025 system): the two means-tested residential contributions are the Hotelling Supplement Contribution (HSC, everyday living) and the Non-Clinical Care Contribution (NCCC). Clinical care is fully government funded.`;
const $076d4db919791ede$export$7faa6f61d5963dc6 = {
    living: `The visitor is reading the "Living Arrangements" screen. It compares support at home, retirement villages, residential aged care and granny-flat arrangements \u{2014} what each is, who each suits, the key financial consideration of each (home value exempt from the assets test while lived in; village loan-licence / deferred management fee model; an aged care needs assessment/ACAT for residential care; formal granny-flat interest agreements and gifting/asset-test rules) and a quick cost-comparison table.`,
    funding: `The visitor is reading the "Funding Options" screen. It explains residential aged care costs (Basic Daily Fee; the means-tested Hotelling Supplement Contribution (HSC) and Non-Clinical Care Contribution (NCCC); accommodation as a RAD lump sum vs a DAP daily payment and the MPIR), the means-testing framework from 1 Nov 2025, the Age Pension, Support at Home funding levels, and home-funding strategies (sell, rent, use other assets, or a combination).`,
    impacts: `The visitor is reading the "Care & Financial Impacts" screen. It covers how choices affect the Age Pension (assets and income tests, key exemptions, and illness-separated couples), cash flow (cost drains vs income sources, RAD vs DAP) and estate/legacy (RAD refunds, estate erosion, protection strategies), plus key risks (longevity, care escalation, market and policy).`,
    nextSteps: `The visitor is reading the "Next Steps" screen. It lays out how to act: what AgedCareWise delivers (financial analysis, strategy recommendations, an action plan), a phased journey timeline, and official resources (My Aged Care, Services Australia, Aged Care Quality, MoneySmart).`
};
function $076d4db919791ede$export$f52fd7733cc15ff3(section) {
    const ctx = $076d4db919791ede$export$7faa6f61d5963dc6[section] || $076d4db919791ede$export$7faa6f61d5963dc6.living;
    return `${$076d4db919791ede$export$c25880153d3c2847}

CURRENT SCREEN
${ctx}

${$076d4db919791ede$var$AWISE_CURRENT_FIGURES}

Tailor your answers to what the visitor is currently reading on this screen, while still helping with related AgedCareWise topics.`;
}
const $076d4db919791ede$export$73e6cbd8e8065904 = {
    'factfind-1': `The user is on fact-find Step 1 "Who Is Completing This Form?" \u{2014} picking one of four cards: the person seeking advice themselves, a family member, the Enduring Power of Attorney, or a professional (adviser, accountant, lawyer, care manager). Anyone other than the applicant also gives their own name and relationship to the applicant. Why it matters: it decides whether the rest of the fact-find is worded in the second person ("your home") or names the applicant ("Bob & Sally's home"), and an attorney or professional completing it raises questions of authority and mental capacity that surface again on the Family & Estate Planning step.`,
    'factfind-2': `The user is on fact-find Step 2 "Your Details" \u{2014} names, dates of birth, relationship status and current residency for the applicant (and a partner if a couple). Why it matters: age drives pension age and life-expectancy projections; couple status drives combined means testing, and if one member enters residential care the couple is assessed as "illness-separated" (each paid the single rate with more generous cut-offs).`,
    'factfind-3': `The user is on fact-find Step 3 "Goals" \u{2014} choosing which living arrangements to explore: staying at home with support (home care), residential aged care, a retirement village, a granny flat arrangement, or downsizing. Multiple goals can be selected and compared.`,
    'factfind-4': `The user is on fact-find Step 4 "The Family Home / Your Living Situation" \u{2014} home ownership and what happens to the home. Key concepts on this screen: who is on the property title (including a family trust or company); whether anyone will keep living in the home if the user moves into care \u{2014} this is the PROTECTED PERSON question (a partner, dependent child, eligible carer of 2+ years, or close relative of 5+ years who is eligible for income support keeps the former home OUT of the aged care means test; otherwise the home counts only up to the home exemption cap); renting or selling the home; granny-flat arrangements (reasonableness test, Extra Allowable Amount); and retirement-village entry contributions vs the Extra Allowable Amount for homeowner status.`,
    'factfind-5': `The user is on fact-find Step 5 "Assets" \u{2014} bank accounts, shares, super, investment properties and other assets for each owner. Why it matters: financial assets are "deemed" to earn a set income for the pension income test; the assets test compares totals to homeowner/non-homeowner limits; super of a partner under pension age is exempt until they reach pension age.`,
    'factfind-6': `The user is on fact-find Step 6 "Liabilities" \u{2014} mortgages, loans and other debts. Why it matters: debts secured against an assessable asset generally reduce that asset's assessable value; debts secured against an exempt asset (like the home) generally do NOT reduce other assessable assets.`,
    'factfind-7': `The user is on fact-find Step 7 "Other Income & Expenses" \u{2014} employment or other income, regular expenses, and PAST GIFTS. Why it matters: gifts above the $10,000/year or $30,000/5-year free areas are "deprived assets" counted for five years; any granny-flat overpayment from Step 4 is automatically included as a gift; other income feeds the pension income test.`,
    'factfind-8': `The user is on fact-find Step 8 "Family & Estate Planning" \u{2014} family members, estate wishes and legacy considerations. Why it matters: the projections show what is left to the estate under each strategy (e.g. RAD refunds return to the estate; deferred management fees erode a village exit).`,
    dashboard: `The user is on Home \u{2014} the client file's first screen after the profile. It shows where things stand (the next action, the chosen plan if there is one), the household's three figures today (what they own less what they owe, money left over each year, the Age Pension today), the profile and goals, the action plan, the saved plans (one per home modelled, the chosen one marked, with "Compare ticked plans" for side by side) and the advice document. Help them understand what the figures and plans mean; the app itself does all calculations.`,
    // The Aged care module's screens (UX review, 17 Oct 2026). The module speaks in these words:
    // "paying daily" (the cards' comparison) is paying the whole room daily with nothing paid up front and nothing sold; "left to the family" is the
    // estate after the planning horizon; "the deposit" is the Refundable Accommodation Deposit (RAD);
    // "paid daily, like rent" is the Daily Accommodation Payment (DAP).
    'aged-care-hub': `The user is on the Aged care landing \u{2014} "<name>'s aged care plan", one column about the home's chosen plan: what is left to the family, care costs a year, each year's shortfall, how the deposit is paid (which accounts fund it; it is refunded when care ends less 2% a year for up to five years, never more than 10%), "Explain this", "What could go wrong", "All the plans we tested", what's next in the action plan, the advice document (Statement of Advice), and "Model another home" (each home is saved as its own plan). Help them read the plan; the figures are the app's.`,
    'aged-care-step-1': `The user is on Aged care step 1 "What the room costs" \u{2014} the home's name, the room price the home quoted (the app shows the same room "if the whole room were paid daily instead"), optional extra services, when care is expected to start, and living costs once the person is in care. A primer at the top explains the four fees: the room (paid up front as a refundable deposit \u{2014} RAD \u{2014} or daily like rent \u{2014} DAP \u{2014} or a mix), the basic daily fee (85% of the single Age Pension), the two means-tested contributions (an everyday living contribution and a care contribution, the HSC and NCCC on the fee schedule, both capped) and optional extras. The full guide is a link.`,
    'aged-care-step-2': `The user is on Aged care step 2 "What it means for <name>" \u{2014} four numbers if nothing were paid up front and nothing sold (the cards call this "paying daily"; for someone changing homes it is "staying put" in the current room): what care would cost a day and a year, the Age Pension once care starts (often higher: an illness-separated couple is each paid the single rate), what each year is short by (met from savings), and what is left to the family after the planning horizon; then the story behind each number and how long the money lasts (which account is drawn first and when it runs low). Every plan in step 3 is measured against these.`,
    'aged-care-step-3': `The user is on Aged care step 3 "Ways to pay for it" \u{2014} the plans the engine tested (a few hundred ways to pay: deposit sizes, which accounts fund the deposit, keep/rent/sell the home, with or without a lifetime income). They choose what matters most (leave the most to the family; \u{2026}and income covers the costs; most left over each year; highest Age Pension) and see the best one or two plans side by side: a name in words ("Pay $320,000 up front, keep the home"), what is left to the family and the gain against paying daily (the room paid daily, nothing up front, nothing sold \u{2014} the person still moves into care), how much is tied up in the deposit, care costs, the Age Pension, each year's shortfall, when the money runs out, and three buttons \u{2014} Explain this, What could go wrong, Choose this plan. "Things that change the answer" reopens the setup questions (planning horizon, emergency money, the family home, a partner entering care later, a lifetime income). "Build a plan yourself" is Manual Control for setting the numbers by hand. Explain the trade-offs; never recalculate the figures.`,
    'aged-care-manual': `The user is in Aged care Manual Control ("Build a plan yourself") \u{2014} setting what is sold and what is paid up front with sliders per account, property options (rent, downsize, reverse mortgage, Home Equity Access Scheme), debt payoff and other strategies (gifting, funeral bonds, a lifetime annuity), with the plan summary on the right updating as they do. Explain what each lever does in general terms; the figures are the app's.`,
    // The other modules (owner, 22 Oct 2026: AWise answered generically in Support at home).
    'support-at-home': `The user is in the Support at home module: step 1 sets up the services each person needs and their budgets; step 2 shows the position with those services and nothing else changed (the cards call this "the support alone" and measure every plan against it); step 3 "Ways to improve their position" shows the plans tested \u{2014} gifting, funeral bonds, a lifetime income, spending on or selling the home, the Home Equity Access Scheme, paying off debts, and combinations \u{2014} scored on what is left to the family, money left over each year and the Age Pension, with what they contribute to their services. Every plan is also tested with the household's debts (not a reverse mortgage) paid off from the savings it leaves, keeping the emergency money; where a plan keeps a debt and the facts below include it, they say what paying it off did to that plan's figures \u{2014} use them to explain why, and never say the app cannot or did not consider it. "Explain this" on each card has a Debts section saying the same. Explain the trade-offs; the figures are the app's.`,
    'retirement-village': `The user is in the Retirement village module: the village's entry payment and fees, how it is funded (selling the home, keeping and renting it, savings), and the plans tested, scored on what is left to the family, money left over each year and the Age Pension, each against "staying put" (staying in the home and changing nothing; "keep renting" for a household that rents). Every plan is also tested with the household's debts (not a reverse mortgage) paid off from the savings it leaves, keeping the emergency money; where a plan keeps a debt and the facts below include it, they say what paying it off did to that plan's figures \u{2014} use them to explain why, and never say the app cannot or did not consider it. "Explain this" on each card has a Debts section saying the same. The figures are the app's.`,
    downsizing: `The user is in the Downsizing module: selling the home and buying a cheaper one (or renting), what is done with the money freed (super, a lifetime income, investing, gifting), and the plans tested, scored on what is left to the family, money left over each year and the Age Pension, each against "staying put" (staying in the home and changing nothing; "keep renting" for a household that rents). Every plan is also tested with the household's debts (not a reverse mortgage) paid off from the savings it leaves, keeping the emergency money; where a plan keeps a debt and the facts below include it, they say what paying it off did to that plan's figures \u{2014} use them to explain why, and never say the app cannot or did not consider it. "Explain this" on each card has a Debts section saying the same. The figures are the app's.`,
    'granny-flat': `The user is in the Granny flat module: a right to live with family in exchange for the home, money or a build, the Centrelink granny flat rules (reasonableness test, no gift on their own), and the plans tested, scored on what is left to the family, money left over each year and the Age Pension, each against "staying put" (not entering the arrangement and changing nothing; "keep renting" for a household that rents). Every plan is also tested with the household's debts (not a reverse mortgage) paid off from the savings it leaves, keeping the emergency money; where a plan keeps a debt and the facts below include it, they say what paying it off did to that plan's figures \u{2014} use them to explain why, and never say the app cannot or did not consider it. "Explain this" on each card has a Debts section saying the same. The figures are the app's.`,
    'cashflow-pension': `The user is in the Cashflow & Age Pension module: ways to lift the Age Pension and the money left over each year without moving \u{2014} gifting, funeral bonds, a lifetime income, after-tax super or an investment bond, paying off debts \u{2014} and the plans tested, scored on what is left to the family, money left over each year and the Age Pension, each against "changing nothing". Every plan is also tested with the household's debts (not a reverse mortgage) paid off from the savings it leaves, keeping the emergency money; where a plan keeps a debt and the facts below include it, they say what paying it off did to that plan's figures \u{2014} use them to explain why, and never say the app cannot or did not consider it. "Explain this" on each card has a Debts section saying the same. The figures are the app's.`,
    'aged-care-guide': `The user is reading "Understanding Aged Care Costs", the full guide to residential aged care fees: the basic daily fee, accommodation (RAD lump sum vs DAP daily payment, MPIR), the Hotelling Supplement Contribution and Non-Clinical Care Contribution, extra services, the couples and illness-separated rules, and how funding choices affect the Age Pension and the estate.`
};
function $076d4db919791ede$export$7bd5b69b343d3c3a(screenKey, clientContext = null) {
    const ctx = $076d4db919791ede$export$73e6cbd8e8065904[screenKey];
    if (!ctx) return $076d4db919791ede$export$80e8d3f847fbc35c;
    const facts = clientContext && clientContext.trim() ? `

ON THIS SCREEN RIGHT NOW (this user's own figures, as the app shows them \u{2014} quote them exactly as written, explain what they mean, and do no arithmetic on them):
${clientContext.trim()}` : '';
    return `${$076d4db919791ede$export$80e8d3f847fbc35c}

CURRENT SCREEN
${ctx}${facts}

${$076d4db919791ede$var$AWISE_CURRENT_FIGURES}

Tailor your answers to what the user is currently doing on this screen, while still helping with any other AgedCareWise topic.`;
}
const $076d4db919791ede$export$b851e40c1bb58afb = {
    living: "Hi, I'm AWise. You're exploring living arrangements \u2014 ask me about support at home, retirement villages, granny flats or residential aged care, and how each affects your options.",
    funding: "Hi, I'm AWise. You're on funding options \u2014 ask about RAD vs DAP, the Basic Daily Fee, the means-tested care contributions, or strategies for funding care.",
    impacts: "Hi, I'm AWise. You're looking at care & financial impacts \u2014 ask how choices affect the Age Pension (including illness-separated couples), cash flow, or your estate.",
    nextSteps: "Hi, I'm AWise. You're on next steps \u2014 ask what to do first, what paperwork is involved, or how AgedCareWise builds your plan."
};
const $076d4db919791ede$export$c772c4977cceb0b8 = "Hi! I'm AWise, your guide from AgedCareWise. Ask about support at home, downsizing, villages, granny flats, or aged care \u2014 I'll explain general options and impacts. For personalised projections, use Get Started.";
const $076d4db919791ede$export$18735436527b64b6 = "Hi! I'm AWise, your guide from AgedCareWise. Ask about aged care, retirement living, pension rules, or how to use the tool.";




/** All Age Pension + aged-care figures on this page are driven from the app's maintained rate constants. */ // Read from the constants the calculator charges, so the label moves with each indexation.
const $cbea7fe05b0c10b5$var$RATES_AS_AT = `as at ${(0, $1abe73eeef086faf$export$946308c675ba021d).agePension}`;
/** The eight classifications' budgets come from the one table the engine reads (1 July 2026 edition). */ const $cbea7fe05b0c10b5$var$SAH_CLASSIFICATION_NOTES = [
    [
        'sah_level_1',
        'Basic support needs'
    ],
    [
        'sah_level_2',
        'Low-level care needs'
    ],
    [
        'sah_level_3',
        'Moderate care needs'
    ],
    [
        'sah_level_4',
        'Intermediate care needs'
    ],
    [
        'sah_level_5',
        'High-level care needs'
    ],
    [
        'sah_level_6',
        'Complex care needs'
    ],
    [
        'sah_level_7',
        'Very high care needs'
    ],
    [
        'sah_level_8',
        'Highest care needs'
    ]
];
/** Whole-dollar currency (e.g. thresholds, annual amounts). */ const $cbea7fe05b0c10b5$var$money0 = (n)=>(0, $f94e45ac645ae232$export$3dc27271f5d5c629)(n);
/** Currency with cents (e.g. daily fees, fortnightly pension). */ const $cbea7fe05b0c10b5$var$money2 = (n)=>'$' + Number(n).toLocaleString('en-AU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
/** Annualised pension rate → per-fortnight string. */ const $cbea7fe05b0c10b5$var$perFortnight = (annual)=>$cbea7fe05b0c10b5$var$money2(annual / 26);
const $cbea7fe05b0c10b5$var$GeneralAdvice = ({ section: section, onBack: onBack })=>{
    const [activeSection] = (0, $acw62.useState)(section);
    const [showHomeCareSearch, setShowHomeCareSearch] = (0, $acw62.useState)(false);
    const [showRetirementVillageSearch, setShowRetirementVillageSearch] = (0, $acw62.useState)(false);
    const [showAgedCareSearch, setShowAgedCareSearch] = (0, $acw62.useState)(false);
    // AWise assistant — trained on the content of the screen the visitor is reading.
    const [chatOpen, setChatOpen] = (0, $acw62.useState)(false);
    const [chatMessages, setChatMessages] = (0, $acw62.useState)(()=>[
            {
                sender: 'bot',
                text: (0, $076d4db919791ede$export$b851e40c1bb58afb)[section] || (0, $076d4db919791ede$export$b851e40c1bb58afb).living
            }
        ]);
    const [chatInput, setChatInput] = (0, $acw62.useState)('');
    const [chatSending, setChatSending] = (0, $acw62.useState)(false);
    // Reset the greeting to match the active screen (unless a conversation is already underway).
    (0, $acw62.useEffect)(()=>{
        setChatMessages((msgs)=>msgs.length > 1 ? msgs : [
                {
                    sender: 'bot',
                    text: (0, $076d4db919791ede$export$b851e40c1bb58afb)[activeSection] || (0, $076d4db919791ede$export$b851e40c1bb58afb).living
                }
            ]);
    }, [
        activeSection
    ]);
    const submitChatMessage = (0, $acw62.useCallback)(async ()=>{
        const trimmed = chatInput.trim();
        if (!trimmed || chatSending) return;
        setChatOpen(true);
        setChatSending(true);
        const history = chatMessages;
        setChatMessages((msgs)=>[
                ...msgs,
                {
                    sender: 'user',
                    text: trimmed
                }
            ]);
        setChatInput('');
        try {
            const aiReply = await (0, $17f95ada13b08766$export$58ecd998c8d4e9d3)({
                message: trimmed,
                systemInstruction: (0, $076d4db919791ede$export$f52fd7733cc15ff3)(activeSection),
                conversationHistory: history
            });
            setChatMessages((msgs)=>[
                    ...msgs,
                    {
                        sender: 'bot',
                        text: aiReply
                    }
                ]);
        } catch (e) {
            setChatMessages((msgs)=>[
                    ...msgs,
                    {
                        sender: 'bot',
                        text: 'Something went wrong sending your message. You can try again in a moment.'
                    }
                ]);
        } finally{
            setChatSending(false);
        }
    }, [
        chatInput,
        chatSending,
        chatMessages,
        activeSection
    ]);
    const sections = {
        living: {
            title: "Living Arrangements",
            subtitle: "Find the Right Home for Your Next Chapter",
            icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
            image: (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1758686253708-f0e21317d2aa', 1200, 600)
        },
        funding: {
            title: "Funding Options",
            subtitle: "Understanding Costs and Payment Strategies",
            icon: (0, $52885985d1db6c06$export$2e2bcd8739ae039),
            image: (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1554224155-6726b3ff858f', 1200, 600)
        },
        impacts: {
            title: "Care & Financial Impacts",
            subtitle: "How Your Choices Affect Your Future",
            icon: (0, $0c90bba72fbdd9e9$export$2e2bcd8739ae039),
            image: (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1579621970563-ebec7560ff3e', 1200, 600)
        },
        nextSteps: {
            title: "Next Steps",
            subtitle: "Get Your Personalized Plan",
            icon: (0, $adb270212de20834$export$2e2bcd8739ae039),
            image: (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1450101499163-c8848c66ca85', 1200, 600)
        }
    };
    const currentSection = sections[activeSection];
    const IconComponent = currentSection.icon;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen bg-white border border-slate-200 ",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white/80 backdrop-blur-lg border-b border-gray-200 sticky top-0 z-50",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "max-w-7xl mx-auto px-6 py-4 flex items-center justify-between",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: onBack,
                        className: "flex items-center gap-2 text-gray-600 hover:text-blue-600 font-medium transition-colors",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                size: 20
                            }),
                            "Back to Home"
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative h-96 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: currentSection.image,
                        alt: currentSection.title,
                        className: "w-full h-full object-cover",
                        onError: (e)=>{
                            e.target.style.visibility = 'hidden';
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute inset-0 bg-gradient-to-r from-brand-navy/90 via-brand-navy/70 to-brand-blue/40 flex items-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "max-w-7xl mx-auto px-6 text-white",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "inline-flex items-center gap-3 bg-white/15 ring-1 ring-white/25 backdrop-blur-sm rounded-full px-4 py-2 mb-5",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(IconComponent, {
                                            size: 22
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold tracking-wide",
                                            children: "General Advice"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "text-5xl md:text-6xl font-bold mb-4 tracking-tight",
                                    children: currentSection.title
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-xl md:text-2xl text-blue-100/90 max-w-2xl leading-relaxed",
                                    children: currentSection.subtitle
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "max-w-7xl mx-auto px-6 py-12",
                children: [
                    activeSection === 'living' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$LivingArrangementsContent, {
                        setShowHomeCareSearch: setShowHomeCareSearch,
                        setShowRetirementVillageSearch: setShowRetirementVillageSearch,
                        setShowAgedCareSearch: setShowAgedCareSearch
                    }),
                    activeSection === 'funding' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$FundingOptionsContent, {}),
                    activeSection === 'impacts' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$CareImpactsContent, {}),
                    activeSection === 'nextSteps' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$NextStepsContent, {})
                ]
            }),
            showHomeCareSearch && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b777d6e89b390316$export$2e2bcd8739ae039), {
                onClose: ()=>setShowHomeCareSearch(false)
            }),
            showRetirementVillageSearch && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11948ce62f179171$export$2e2bcd8739ae039), {
                onClose: ()=>setShowRetirementVillageSearch(false)
            }),
            showAgedCareSearch && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e87ab397afd99bf3$export$2e2bcd8739ae039), {
                onClose: ()=>setShowAgedCareSearch(false)
            }),
            !chatOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: ()=>setChatOpen(true),
                className: "fixed bottom-5 right-5 z-[90] flex items-center gap-2 rounded-full bg-blue-600 hover:bg-blue-700 text-white pl-4 pr-5 py-3 shadow-xl shadow-blue-600/30 hover:shadow-2xl hover:-translate-y-0.5 transition-all",
                "aria-label": "Ask AWise",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8afc40d49a7e79bf$export$2e2bcd8739ae039), {
                        size: 22
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold text-sm",
                        children: "Ask AWise"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e31cd18cd0725a6f$export$2e2bcd8739ae039), {
                open: chatOpen,
                onClose: ()=>setChatOpen(false),
                messages: chatMessages,
                chatInput: chatInput,
                onChatInputChange: setChatInput,
                onSubmit: submitChatMessage,
                sending: chatSending
            })
        ]
    });
};
// Living Arrangements Content Component
const $cbea7fe05b0c10b5$var$LivingArrangementsContent = ({ setShowHomeCareSearch: setShowHomeCareSearch, setShowRetirementVillageSearch: setShowRetirementVillageSearch, setShowAgedCareSearch: setShowAgedCareSearch })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-16",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "prose prose-lg max-w-none",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-xl text-gray-700 leading-relaxed",
                    children: "Choosing the right living arrangement is one of the most important decisions you'll make in retirement. Whether you want to stay at home with support, move to a vibrant retirement village, or transition to residential aged care, understanding your options helps you plan with confidence."
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-shadow duration-300 overflow-hidden border border-gray-100",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid md:grid-cols-2 gap-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1641232458416-feace752b346', 800, 600),
                            alt: "Home Care",
                            className: "w-full h-full object-cover min-h-[400px]",
                            onError: (e)=>{
                                e.target.style.visibility = 'hidden';
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "p-8 md:p-12",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full font-semibold mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bee7e1f6335e67ab$export$2e2bcd8739ae039), {
                                            size: 20
                                        }),
                                        "Support at Home"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    className: "text-3xl font-bold text-gray-900 mb-4",
                                    children: "Stay in Your Own Home"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-gray-600 mb-6",
                                    children: "Receive professional care and support services in the comfort of your own home. From personal care to domestic assistance, home care helps you maintain independence while getting the help you need."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-4 mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$DetailItem, {
                                            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
                                            text: "Personal care (showering, dressing, meals)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$DetailItem, {
                                            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
                                            text: "Domestic assistance (cleaning, shopping)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$DetailItem, {
                                            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
                                            text: "Clinical care (nursing, allied health)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$DetailItem, {
                                            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
                                            text: "Social support and companionship"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "relative bg-white border border-slate-200 border-l-4 border-blue-500 rounded-lg p-5 mb-6 shadow-sm hover:shadow-md transition-shadow",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-start gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex-shrink-0 w-8 h-8 rounded-lg bg-brand-navy flex items-center justify-center shadow-sm",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e57d6b071418ede9$export$2e2bcd8739ae039), {
                                                    size: 18,
                                                    className: "text-white"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        className: "font-bold text-blue-900 mb-2 text-base",
                                                        children: "Key Consideration"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-blue-800 text-sm leading-relaxed",
                                                        children: "The value of your home is exempt from the Age Pension assets test while you live there. This can significantly affect your pension entitlements compared to other living options."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-3 mb-6 p-4 bg-white rounded-lg border border-gray-100",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm font-bold text-gray-800 uppercase tracking-wide",
                                            children: "Ideal for:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                            className: "text-sm text-gray-700 space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "flex-shrink-0 w-5 h-5 rounded-full bg-brand-navy flex items-center justify-center",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                                size: 12,
                                                                className: "text-white",
                                                                fill: "currentColor"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Those who want to age in place"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "flex-shrink-0 w-5 h-5 rounded-full bg-brand-navy flex items-center justify-center",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                                size: 12,
                                                                className: "text-white",
                                                                fill: "currentColor"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "People with low to moderate care needs"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "flex-shrink-0 w-5 h-5 rounded-full bg-brand-navy flex items-center justify-center",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                                size: 12,
                                                                className: "text-white",
                                                                fill: "currentColor"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Individuals with strong community ties"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            onClick: ()=>setShowHomeCareSearch(true),
                                            className: "w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold flex items-center justify-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                                    size: 20
                                                }),
                                                "Find Support at Home providers"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d989e4f2a8ad0174$export$2e2bcd8739ae039), {
                                            context: "home care"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-shadow duration-300 overflow-hidden border border-gray-100",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid md:grid-cols-2 gap-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "p-8 md:p-12 order-2 md:order-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full font-semibold mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8474226e5f2f9b18$export$2e2bcd8739ae039), {
                                            size: 20
                                        }),
                                        "Retirement Village"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    className: "text-3xl font-bold text-gray-900 mb-4",
                                    children: "Independent Living Community"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-gray-600 mb-6",
                                    children: "Live independently in a purpose-built community with like-minded people. Enjoy a low-maintenance lifestyle with amenities, activities, and care services available as your needs change."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-4 mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$DetailItem, {
                                            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
                                            text: "Own or lease your unit"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$DetailItem, {
                                            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
                                            text: "Access to community facilities"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$DetailItem, {
                                            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
                                            text: "Social activities and events"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$DetailItem, {
                                            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
                                            text: "Optional care services available"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "relative bg-white border border-slate-200 border-l-4 border-amber-400 rounded-lg p-5 mb-6 shadow-sm hover:shadow-md transition-shadow",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-start gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex-shrink-0 w-8 h-8 rounded-lg bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center shadow-sm",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                                    size: 18,
                                                    className: "text-white"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        className: "font-bold text-amber-900 mb-2 text-base",
                                                        children: "Financial Structure"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-amber-800 text-sm leading-relaxed",
                                                        children: 'Most villages operate on a "loan-license" model where you pay an entry contribution (similar to buying property) and ongoing fees. When you leave, you typically receive 70-100% of the entry price back, minus a deferred management fee that increases over time.'
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-3 mb-6 p-4 bg-white rounded-lg border border-gray-100",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm font-bold text-gray-800 uppercase tracking-wide",
                                            children: "Ideal for:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                            className: "text-sm text-gray-700 space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "flex-shrink-0 w-5 h-5 rounded-full bg-brand-navy flex items-center justify-center",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                                size: 12,
                                                                className: "text-white",
                                                                fill: "currentColor"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Active seniors seeking social connections"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "flex-shrink-0 w-5 h-5 rounded-full bg-brand-navy flex items-center justify-center",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                                size: 12,
                                                                className: "text-white",
                                                                fill: "currentColor"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Those downsizing from family homes"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "flex-shrink-0 w-5 h-5 rounded-full bg-brand-navy flex items-center justify-center",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                                size: 12,
                                                                className: "text-white",
                                                                fill: "currentColor"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "People wanting maintenance-free living"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        onClick: ()=>setShowRetirementVillageSearch(true),
                                        className: "w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold flex items-center justify-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                                size: 20
                                            }),
                                            "Find Retirement Villages"
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1560184897-ae75f418493e', 800, 600),
                            alt: "Retirement Village",
                            className: "w-full h-full object-cover min-h-[400px] order-1 md:order-2",
                            onError: (e)=>{
                                e.target.style.visibility = 'hidden';
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-shadow duration-300 overflow-hidden border border-gray-100",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid md:grid-cols-2 gap-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1519494026892-80bbd2d6fd0d', 800, 600),
                            alt: "Residential Aged Care",
                            className: "w-full h-full object-cover min-h-[400px]",
                            onError: (e)=>{
                                e.target.style.visibility = 'hidden';
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "p-8 md:p-12",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full font-semibold mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $960b709ecb4ade55$export$2e2bcd8739ae039), {
                                            size: 20
                                        }),
                                        "Residential Aged Care"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    className: "text-3xl font-bold text-gray-900 mb-4",
                                    children: "24/7 Professional Care"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-gray-600 mb-6",
                                    children: "Live in a facility with round-the-clock nursing care and support. Residential aged care provides high-level personal and clinical care in a safe, comfortable environment."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-4 mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$DetailItem, {
                                            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
                                            text: "24/7 nursing and personal care"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$DetailItem, {
                                            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
                                            text: "All meals and accommodation"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$DetailItem, {
                                            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
                                            text: "Allied health services"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$DetailItem, {
                                            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
                                            text: "Social activities and support"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "relative bg-white border border-slate-200 border-l-4 border-blue-500 rounded-lg p-5 mb-6 shadow-sm hover:shadow-md transition-shadow",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-start gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex-shrink-0 w-8 h-8 rounded-lg bg-brand-navy flex items-center justify-center shadow-sm",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                                    size: 18,
                                                    className: "text-white"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        className: "font-bold text-slate-900 mb-2 text-base",
                                                        children: "Entry Requirements"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-slate-700 text-sm leading-relaxed",
                                                        children: "You'll need an aged care needs assessment to access government-subsidised aged care. This free assessment determines your eligibility and the care and services you may receive."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-3 mb-6 p-4 bg-white rounded-lg border border-gray-100",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm font-bold text-gray-800 uppercase tracking-wide",
                                            children: "Ideal for:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                            className: "text-sm text-gray-700 space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "flex-shrink-0 w-5 h-5 rounded-full bg-brand-navy flex items-center justify-center",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                                size: 12,
                                                                className: "text-white",
                                                                fill: "currentColor"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Those with high care needs"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "flex-shrink-0 w-5 h-5 rounded-full bg-brand-navy flex items-center justify-center",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                                size: 12,
                                                                className: "text-white",
                                                                fill: "currentColor"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "People requiring 24/7 supervision"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "flex-shrink-0 w-5 h-5 rounded-full bg-brand-navy flex items-center justify-center",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                                size: 12,
                                                                className: "text-white",
                                                                fill: "currentColor"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Individuals with complex health conditions"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            onClick: ()=>setShowAgedCareSearch(true),
                                            className: "w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold flex items-center justify-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                                    size: 20
                                                }),
                                                "Find Aged Care Facilities"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d989e4f2a8ad0174$export$2e2bcd8739ae039), {
                                            context: "aged care"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-shadow duration-300 overflow-hidden border border-gray-100",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid md:grid-cols-2 gap-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "p-8 md:p-12 order-2 md:order-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full font-semibold mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                            size: 20
                                        }),
                                        "Granny Flat"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    className: "text-3xl font-bold text-gray-900 mb-4",
                                    children: "Multi-Generational Living"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-gray-600 mb-6",
                                    children: "Live with family in a self-contained area or secondary dwelling. A granny flat arrangement provides independence while keeping loved ones close for support."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-4 mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$DetailItem, {
                                            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
                                            text: "Live near family support"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$DetailItem, {
                                            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
                                            text: "Maintain independence"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$DetailItem, {
                                            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
                                            text: "Potential cost savings"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$DetailItem, {
                                            icon: (0, $e3f86240925e7a9e$export$2e2bcd8739ae039),
                                            text: "Informal care arrangements"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "relative bg-white border border-slate-200 border-l-4 border-blue-500 rounded-lg p-5 mb-6 shadow-sm hover:shadow-md transition-shadow",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-start gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex-shrink-0 w-8 h-8 rounded-lg bg-brand-navy flex items-center justify-center shadow-sm",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $960b709ecb4ade55$export$2e2bcd8739ae039), {
                                                    size: 18,
                                                    className: "text-white"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        className: "font-bold text-slate-900 mb-3 text-base",
                                                        children: "Legal & Financial Protection"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-slate-700 text-sm mb-3 leading-relaxed",
                                                        children: 'It\'s crucial to have a formal "granny flat interest" agreement that:'
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                        className: "text-slate-700 text-sm space-y-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                                className: "flex items-start gap-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "flex-shrink-0 w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center mt-0.5",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-blue-700 text-xs font-bold",
                                                                            children: "\u2713"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        children: "Protects your right to occupy the property"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                                className: "flex items-start gap-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "flex-shrink-0 w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center mt-0.5",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-blue-700 text-xs font-bold",
                                                                            children: "\u2713"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        children: "May provide Age Pension asset test exemptions"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                                className: "flex items-start gap-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "flex-shrink-0 w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center mt-0.5",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-blue-700 text-xs font-bold",
                                                                            children: "\u2713"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        children: "Clarifies what happens if circumstances change"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                                className: "flex items-start gap-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "flex-shrink-0 w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center mt-0.5",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-blue-700 text-xs font-bold",
                                                                            children: "\u2713"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        children: "Defines financial contributions and obligations"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-3 p-4 bg-white rounded-lg border border-gray-100",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm font-bold text-gray-800 uppercase tracking-wide",
                                            children: "Ideal for:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                            className: "text-sm text-gray-700 space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "flex-shrink-0 w-5 h-5 rounded-full bg-brand-navy flex items-center justify-center",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                                size: 12,
                                                                className: "text-white",
                                                                fill: "currentColor"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Those wanting to be near family"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "flex-shrink-0 w-5 h-5 rounded-full bg-brand-navy flex items-center justify-center",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                                size: 12,
                                                                className: "text-white",
                                                                fill: "currentColor"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "People downsizing their assets"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "flex-shrink-0 w-5 h-5 rounded-full bg-brand-navy flex items-center justify-center",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                                size: 12,
                                                                className: "text-white",
                                                                fill: "currentColor"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Individuals seeking cost-effective living"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, $5bb9a0b2f90fb898$export$260036ae09c24358)('1600585154340-be6161a56a0c', 800, 600),
                            alt: "Granny Flat",
                            className: "w-full h-full object-cover min-h-[400px] order-1 md:order-2",
                            onError: (e)=>{
                                e.target.style.visibility = 'hidden';
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "bg-white rounded-2xl p-8 md:p-12 border border-slate-200/70",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-3xl font-bold text-slate-900 mb-8 text-center",
                        children: "Quick Comparison"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white rounded-xl p-5 shadow-lg hover:shadow-xl transition-shadow border-l-4 border-blue-500",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bee7e1f6335e67ab$export$2e2bcd8739ae039), {
                                                size: 20,
                                                className: "text-blue-600"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "font-bold text-gray-900",
                                                children: "Home Care"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-2 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-gray-500 font-medium",
                                                        children: "Entry Cost"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-gray-900 font-semibold",
                                                        children: "None"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-gray-500 font-medium",
                                                        children: "Ongoing Costs"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-gray-900 font-semibold",
                                                        children: "Service fees (partly subsidized)"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "pt-2 border-t border-gray-100",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-green-700 font-semibold flex items-center gap-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                            size: 16,
                                                            className: "text-green-600",
                                                            fill: "currentColor"
                                                        }),
                                                        "Home value exempt"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white rounded-xl p-5 shadow-lg hover:shadow-xl transition-shadow border-l-4 border-blue-500",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8474226e5f2f9b18$export$2e2bcd8739ae039), {
                                                size: 20,
                                                className: "text-blue-600"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "font-bold text-gray-900",
                                                children: "Retirement Village"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-2 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-gray-500 font-medium",
                                                        children: "Entry Cost"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-gray-900 font-semibold",
                                                        children: "$200k-$800k+"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-gray-500 font-medium",
                                                        children: "Ongoing Costs"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-gray-900 font-semibold",
                                                        children: "$200-$600/week"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "pt-2 border-t border-gray-100",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-amber-700 font-semibold flex items-center gap-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                                            size: 16,
                                                            className: "text-amber-600"
                                                        }),
                                                        "Entry amount assessed"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white rounded-xl p-5 shadow-lg hover:shadow-xl transition-shadow border-l-4 border-blue-500",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $960b709ecb4ade55$export$2e2bcd8739ae039), {
                                                size: 20,
                                                className: "text-blue-600"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "font-bold text-gray-900",
                                                children: "Aged Care"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-2 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-gray-500 font-medium",
                                                        children: "Entry Cost"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-gray-900 font-semibold",
                                                        children: [
                                                            "$0\u2013",
                                                            $cbea7fe05b0c10b5$var$money0(Math.round((0, $815d7df20c36742b$export$36c4ec5f3f340aef).maxRAD / 1000)),
                                                            "k (RAD)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-gray-500 font-medium",
                                                        children: "Ongoing Costs"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-gray-900 font-semibold",
                                                        children: "$500-$1,500/month"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "pt-2 border-t border-gray-100",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-amber-700 font-semibold flex items-center gap-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                                            size: 16,
                                                            className: "text-amber-600"
                                                        }),
                                                        "Assessed on means"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white rounded-xl p-5 shadow-lg hover:shadow-xl transition-shadow border-l-4 border-blue-500",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                                size: 20,
                                                className: "text-blue-600"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "font-bold text-gray-900",
                                                children: "Granny Flat"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-2 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-gray-500 font-medium",
                                                        children: "Entry Cost"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-gray-900 font-semibold",
                                                        children: "Variable"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-gray-500 font-medium",
                                                        children: "Ongoing Costs"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-gray-900 font-semibold",
                                                        children: "Share living costs"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "pt-2 border-t border-gray-100",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-green-700 font-semibold flex items-center gap-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                            size: 16,
                                                            className: "text-green-600",
                                                            fill: "currentColor"
                                                        }),
                                                        "Possible exemptions"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-sm text-gray-600 mt-4 text-center italic",
                        children: [
                            "* Costs are indicative and vary by location and provider. Figures ",
                            $cbea7fe05b0c10b5$var$RATES_AS_AT,
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-gradient-to-r from-brand-navy to-brand-blue rounded-2xl p-8 md:p-12 text-white text-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-3xl md:text-4xl font-bold mb-4",
                        children: "Which Option is Right for You?"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xl mb-8 text-blue-100",
                        children: "Get personalised recommendations based on your health, finances, and lifestyle preferences"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-lg text-blue-200",
                        children: "Return to the home screen to get started with your personalised assessment"
                    })
                ]
            })
        ]
    });
// Funding Options Content Component (continued in next part due to length)
const $cbea7fe05b0c10b5$var$FundingOptionsContent = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-16",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "prose prose-lg max-w-none",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-xl text-gray-700 leading-relaxed",
                    children: "Understanding how to fund your aged care or retirement living is essential for making informed decisions. The current aged care system features modern funding models, enhanced transparency, and strong consumer protections. Here's what you need to know about the current system."
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white border border-slate-200 rounded-2xl p-8 md:p-12",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-3xl font-bold text-gray-900 mb-8",
                        children: "Current Aged Care System Features"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid md:grid-cols-2 gap-8",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white rounded-xl p-6 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                        className: "text-xl font-bold text-gray-900 mb-4 flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                className: "w-6 h-6 text-green-600"
                                            }),
                                            "Consumer Protections"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                        className: "space-y-2 text-gray-700",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "\u2022 Full transparency in pricing and services"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "\u2022 Strong quality and safety standards"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "\u2022 Comprehensive complaint resolution processes"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "\u2022 Enhanced consumer choice and control"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white rounded-xl p-6 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                        className: "text-xl font-bold text-gray-900 mb-4 flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {
                                                className: "w-6 h-6 text-blue-600"
                                            }),
                                            "Modern Funding Models"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                        className: "space-y-2 text-gray-700",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "\u2022 Comprehensive means testing calculations"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "\u2022 Flexible accommodation payment options"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "\u2022 Enhanced home care package funding"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "\u2022 Robust financial hardship provisions"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-2xl shadow-xl p-8 md:p-12",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-3xl font-bold text-gray-900 mb-2",
                        children: "Current Aged Care Costs"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-sm text-gray-500 mb-8",
                        children: [
                            "Schedule of Fees and Charges, ",
                            $cbea7fe05b0c10b5$var$RATES_AS_AT
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid md:grid-cols-3 gap-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-slate-50 rounded-xl p-6 border-2 border-slate-200",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                                        className: "w-12 h-12 text-blue-600 mb-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-xl font-bold text-gray-900 mb-2",
                                        children: "Basic Daily Fee"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-3xl font-bold text-blue-600 mb-2",
                                        children: $cbea7fe05b0c10b5$var$money2((0, $815d7df20c36742b$export$36c4ec5f3f340aef).basicDailyFeeDaily)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "Per day \xb7 85% of the single Age Pension (",
                                            $cbea7fe05b0c10b5$var$RATES_AS_AT,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-700 mt-3",
                                        children: "Everyone pays this fee, which covers living costs like meals, utilities, and laundry."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-slate-50 rounded-xl p-6 border-2 border-slate-200",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {
                                        className: "w-12 h-12 text-blue-600 mb-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-xl font-bold text-gray-900 mb-2",
                                        children: "Means-Tested Care Fees"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-3xl font-bold text-blue-600 mb-2",
                                        children: [
                                            $cbea7fe05b0c10b5$var$money2(0),
                                            "\u2013",
                                            $cbea7fe05b0c10b5$var$money2((0, $815d7df20c36742b$export$36c4ec5f3f340aef).maxNCCCDaily)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "Per day \xb7 NCCC capped, plus hotelling up to ",
                                            $cbea7fe05b0c10b5$var$money2((0, $815d7df20c36742b$export$36c4ec5f3f340aef).maxHotellingDaily),
                                            "/day"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-700 mt-3",
                                        children: "Worked out from your means \u2014 higher means, higher contribution. Capped daily and over your lifetime."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-slate-50 rounded-xl p-6 border-2 border-slate-200",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bee7e1f6335e67ab$export$2e2bcd8739ae039), {
                                        className: "w-12 h-12 text-blue-600 mb-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-xl font-bold text-gray-900 mb-2",
                                        children: "Accommodation"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-3xl font-bold text-blue-600 mb-2",
                                        children: "Varies"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-600",
                                        children: "RAD, DAP, or combination"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-700 mt-3",
                                        children: "Pay as a lump sum (RAD), daily payment (DAP), or mix of both."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white border border-slate-200 rounded-2xl p-8 md:p-12",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-3xl font-bold text-gray-900 mb-8 text-center",
                        children: "RAD vs DAP: Which Should You Choose?"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid md:grid-cols-2 gap-8 mb-8",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white rounded-xl p-8 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-3 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "bg-blue-100 p-3 rounded-lg",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e57d6b071418ede9$export$2e2bcd8739ae039), {
                                                    className: "w-8 h-8 text-blue-600"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-2xl font-bold text-gray-900",
                                                children: "RAD (Lump Sum)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-600 mb-6",
                                        children: "Refundable Accommodation Deposit - pay upfront"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-4 mb-6",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-green-600 flex-shrink-0 mt-1"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-semibold text-gray-900",
                                                                children: "Refundable with retention"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-sm text-gray-600",
                                                                children: "2% retention per annum, up to 5 years (max 10%)"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-green-600 flex-shrink-0 mt-1"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-semibold text-gray-900",
                                                                children: "No interest charged"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-sm text-gray-600",
                                                                children: "Provider holds but doesn't earn interest"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-green-600 flex-shrink-0 mt-1"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-semibold text-gray-900",
                                                                children: "Lower ongoing costs"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-sm text-gray-600",
                                                                children: "No daily accommodation payments"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-blue-50 rounded-lg p-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm font-semibold text-blue-900 mb-2",
                                                children: "Best for:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                className: "text-sm text-blue-800 space-y-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                        children: "\u2022 Those with sufficient liquid assets"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                        children: "\u2022 People wanting cost certainty"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                        children: "\u2022 Families prioritizing estate protection"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white rounded-xl p-8 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-3 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "bg-green-100 p-3 rounded-lg",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                                                    className: "w-8 h-8 text-green-600"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-2xl font-bold text-gray-900",
                                                children: "DAP (Daily)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-600 mb-6",
                                        children: "Daily Accommodation Payment - pay as you go"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-4 mb-6",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-green-600 flex-shrink-0 mt-1"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-semibold text-gray-900",
                                                                children: "No upfront payment"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-sm text-gray-600",
                                                                children: "Preserve your capital and investments"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-green-600 flex-shrink-0 mt-1"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-semibold text-gray-900",
                                                                children: "Flexibility"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-sm text-gray-600",
                                                                children: "Switch to RAD later if you wish"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-green-600 flex-shrink-0 mt-1"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-semibold text-gray-900",
                                                                children: "Keep assets invested"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-sm text-gray-600",
                                                                children: "Potentially earn more than DAP cost"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-green-50 rounded-lg p-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm font-semibold text-green-900 mb-2",
                                                children: "Best for:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                className: "text-sm text-green-800 space-y-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                        children: "\u2022 Those with limited liquid assets"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                        children: "\u2022 People with high-return investments"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                        children: "\u2022 Individuals wanting flexibility"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white rounded-xl p-8 shadow-lg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-2xl font-bold text-gray-900 mb-4",
                                children: "Example: $400,000 Accommodation"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid md:grid-cols-2 gap-8",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "font-semibold text-gray-900 mb-2",
                                                children: "Option 1: RAD (Lump Sum)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-gray-700",
                                                children: "Pay $400,000 upfront"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-600 mt-2",
                                                children: "Daily cost: $0 (accommodation paid)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-green-700 font-semibold mt-2",
                                                children: "\u2713 Get $400,000 back (less retention fees)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-green-700 font-semibold mt-1",
                                                children: "\u2713 RAD is exempt from Age Pension assets test"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "font-semibold text-gray-900 mb-2",
                                                children: "Option 2: DAP (Daily)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-gray-700",
                                                children: "Pay $0 upfront"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-sm text-gray-600 mt-2",
                                                children: [
                                                    "Daily cost: ",
                                                    $cbea7fe05b0c10b5$var$money2(400000 * (0, $815d7df20c36742b$export$36c4ec5f3f340aef).MPIR / 365),
                                                    "/day (",
                                                    $cbea7fe05b0c10b5$var$money0(400000 * (0, $815d7df20c36742b$export$36c4ec5f3f340aef).MPIR),
                                                    "/year)"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-blue-700 font-semibold mt-2",
                                                children: "\u2713 Keep $400,000 invested"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-blue-700 font-semibold mt-1",
                                                children: "\u2713 Maintain liquidity for emergencies"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-gray-500 mt-4 italic",
                                children: [
                                    "* Based on Maximum Permissible Interest Rate (MPIR) of ",
                                    ((0, $815d7df20c36742b$export$36c4ec5f3f340aef).MPIR * 100).toFixed(2),
                                    "% p.a. (",
                                    (0, $815d7df20c36742b$export$36c4ec5f3f340aef).mpiQuarterLabel || "current quarter \u2014 see Department of Health",
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "relative bg-white border border-slate-200 border-l-4 border-amber-400 rounded-lg p-5 mt-4 shadow-sm",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-start gap-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex-shrink-0 w-8 h-8 rounded-lg bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center shadow-sm",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                                size: 18,
                                                className: "text-white"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex-1",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-sm text-amber-800 leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Current System:"
                                                    }),
                                                    " The MPIR is reviewed quarterly and published by the Department of Health, providing full transparency in accommodation payment calculations."
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-2xl shadow-xl p-8 md:p-12",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-3xl font-bold text-gray-900 mb-8",
                        children: "Understanding Means-Tested Care Fees"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "border-l-4 border-green-500 pl-6 py-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-xl font-bold text-gray-900 mb-2",
                                        children: "Non-Clinical Care Contribution (NCCC)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-700 mb-3",
                                        children: "The NCCC is worked out from your income and assets (your former home is excluded if a protected person lives there). It's designed so those with higher means contribute more toward their non-clinical care \u2014 clinical care is fully government-funded."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "bg-slate-50 rounded-lg p-4 border border-slate-200",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-sm text-slate-700",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Cap:"
                                                }),
                                                " up to ",
                                                $cbea7fe05b0c10b5$var$money2((0, $815d7df20c36742b$export$36c4ec5f3f340aef).maxNCCCDaily),
                                                "/day, with a lifetime cap of ",
                                                $cbea7fe05b0c10b5$var$money0((0, $815d7df20c36742b$export$36c4ec5f3f340aef).ncccLifetimeCap),
                                                " (a 4-year cap also applies). ",
                                                $cbea7fe05b0c10b5$var$RATES_AS_AT,
                                                "."
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "border-l-4 border-blue-500 pl-6 py-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-xl font-bold text-gray-900 mb-2",
                                        children: "Hotelling Supplement Contribution (HSC)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-700 mb-3",
                                        children: "A means-tested contribution toward everyday living costs \u2014 cleaning, laundry, catering and utilities \u2014 paid on top of the Basic Daily Fee by residents with the means to do so."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "bg-slate-50 rounded-lg p-4 border border-slate-200",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-sm text-slate-700",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Cap:"
                                                }),
                                                " up to ",
                                                $cbea7fe05b0c10b5$var$money2((0, $815d7df20c36742b$export$36c4ec5f3f340aef).maxHotellingDaily),
                                                "/day. ",
                                                $cbea7fe05b0c10b5$var$RATES_AS_AT,
                                                "."
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "border-l-4 border-blue-500 pl-6 py-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-xl font-bold text-gray-900 mb-2",
                                        children: "New Means-Tested Framework (From 1 November 2025)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-700 mb-3",
                                        children: "The new system uses a daily Means Tested Amount (MTA) to determine your contributions. It replaces the previous means-tested care fee with two separate contributions: the Hotelling Supplement Contribution (HSC) and the NCCC."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "bg-slate-50 rounded-lg p-4 border border-slate-200",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-sm text-slate-700",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "How it works:"
                                                }),
                                                " your daily MTA combines an income-tested and an asset-tested amount. From it you may pay a Hotelling Supplement Contribution (capped at ",
                                                $cbea7fe05b0c10b5$var$money2((0, $815d7df20c36742b$export$36c4ec5f3f340aef).maxHotellingDaily),
                                                "/day) and an NCCC (capped at ",
                                                $cbea7fe05b0c10b5$var$money2((0, $815d7df20c36742b$export$36c4ec5f3f340aef).maxNCCCDaily),
                                                "/day, lifetime cap ",
                                                $cbea7fe05b0c10b5$var$money0((0, $815d7df20c36742b$export$36c4ec5f3f340aef).ncccLifetimeCap),
                                                "). ",
                                                $cbea7fe05b0c10b5$var$RATES_AS_AT,
                                                "."
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-2xl shadow-xl p-8 md:p-12",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-3xl font-bold text-gray-900 mb-8",
                        children: "Government Support Available"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "border-l-4 border-blue-500 pl-6 py-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-xl font-bold text-gray-900 mb-2",
                                        children: "Age Pension"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-gray-700 mb-3",
                                        children: [
                                            "The Age Pension provides financial support in retirement. Maximum rates (",
                                            $cbea7fe05b0c10b5$var$RATES_AS_AT,
                                            "):"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "grid md:grid-cols-2 gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "bg-blue-50 rounded-lg p-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "font-semibold text-blue-900",
                                                        children: [
                                                            "Single: ",
                                                            $cbea7fe05b0c10b5$var$perFortnight((0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single),
                                                            "/fortnight"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-sm text-blue-700",
                                                        children: [
                                                            $cbea7fe05b0c10b5$var$money0((0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single),
                                                            "/year"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "bg-blue-50 rounded-lg p-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "font-semibold text-blue-900",
                                                        children: [
                                                            "Couple: ",
                                                            $cbea7fe05b0c10b5$var$perFortnight((0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).couple),
                                                            "/fortnight (combined)"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-sm text-blue-700",
                                                        children: [
                                                            $cbea7fe05b0c10b5$var$money0((0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).couple),
                                                            "/year"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "bg-white border border-slate-200 border-l-4 border-blue-500 rounded-lg p-4 mt-4",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-sm text-slate-700 leading-relaxed",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Illness-separated couples"
                                                }),
                                                " \u2014 where one partner moves into residential aged care \u2014 are each paid the higher ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "single"
                                                }),
                                                " rate (",
                                                $cbea7fe05b0c10b5$var$perFortnight((0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single),
                                                "/fortnight each), not the lower couple rate. This often ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "increases"
                                                }),
                                                " a couple's combined Age Pension at the point aged care begins."
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-600 mt-3",
                                        children: "Your actual pension depends on income and assets tests. Aged care accommodation can significantly impact your assessable assets."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "relative bg-white border border-slate-200 border-l-4 border-blue-500 rounded-lg p-4 mt-3 shadow-sm",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-sm text-blue-800 leading-relaxed",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Current System:"
                                                }),
                                                " Enhanced deeming rules and improved assessment processes provide accurate pension calculations for aged care residents."
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "border-l-4 border-green-500 pl-6 py-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-xl font-bold text-gray-900 mb-2",
                                        children: "Support at Home Packages (From 1 November 2025)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-700 mb-3",
                                        children: "The Support at Home program funds eight classifications of care based on your assessed needs (annual budgets from 1 July 2026):"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "grid md:grid-cols-2 lg:grid-cols-4 gap-3",
                                        children: $cbea7fe05b0c10b5$var$SAH_CLASSIFICATION_NOTES.map(([key, note], i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "bg-slate-50 rounded-lg p-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "font-semibold text-slate-900 text-sm",
                                                        children: [
                                                            "Classification ",
                                                            i + 1,
                                                            ": ",
                                                            $cbea7fe05b0c10b5$var$money0((0, $c220d08b55e5dd64$export$bfae9591cc0d7897)[key]?.budget ?? 0),
                                                            "/year"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs text-slate-600",
                                                        children: note
                                                    })
                                                ]
                                            }, key))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "relative bg-white border border-slate-200 border-l-4 border-green-500 rounded-lg p-4 mt-3 shadow-sm",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-sm text-green-800 leading-relaxed",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Support at Home:"
                                                }),
                                                " assessment into one of eight classifications, each with its own annual budget (indexed each 1 July), providing better tailored care packages and improved consumer choice."
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "border-l-4 border-blue-500 pl-6 py-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-xl font-bold text-gray-900 mb-2",
                                        children: "Residential Aged Care Subsidies"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-700 mb-3",
                                        children: "The government covers most of the cost of care in residential aged care facilities. You pay your accommodation and means-tested fees, while the government funds the actual care services."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "relative bg-white border border-slate-200 border-l-4 border-blue-500 rounded-lg p-4 mt-3 shadow-sm",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-sm text-slate-700 leading-relaxed",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "New System (From 1 November 2025):"
                                                }),
                                                " the government provides a means-tested supplement of ",
                                                $cbea7fe05b0c10b5$var$money2((0, $815d7df20c36742b$export$36c4ec5f3f340aef).MAS),
                                                "/day toward care costs. Residents contribute the Hotelling Supplement Contribution (HSC) and NCCC based on their means. ",
                                                $cbea7fe05b0c10b5$var$RATES_AS_AT,
                                                "."
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white border border-slate-200 rounded-2xl p-8 md:p-12",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-3xl font-bold text-gray-900 mb-8 text-center",
                        children: "Current Funding Strategies"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid md:grid-cols-2 gap-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white rounded-xl p-6 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-3 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-12 h-12 bg-brand-navy rounded-lg flex items-center justify-center text-white font-bold text-xl",
                                                children: "1"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-lg font-bold text-gray-900",
                                                children: "Sell the Family Home"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-700 text-sm mb-3",
                                        children: "Use proceeds to pay RAD and invest remainder for income. Lose home value asset test exemption, but gain liquidity and flexibility."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-xs text-gray-500 italic",
                                        children: "Best if: Home is underutilized, family agrees, market conditions favorable"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "relative bg-white border border-slate-200 border-l-4 border-blue-500 rounded-lg p-3 mt-3 shadow-sm",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-xs text-blue-800 leading-relaxed",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Current System:"
                                                }),
                                                " Enhanced capital gains tax considerations and improved estate planning options for home sales."
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white rounded-xl p-6 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-3 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-12 h-12 bg-brand-navy rounded-lg flex items-center justify-center text-white font-bold text-xl",
                                                children: "2"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-lg font-bold text-gray-900",
                                                children: "Rent Out the Home"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-700 text-sm mb-3",
                                        children: "Keep home ownership, receive rental income for fees, maintain 2-year asset test exemption. Property value protected, rental income supports DAP."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-xs text-gray-500 italic",
                                        children: "Best if: Property in good location, want to preserve asset, rental income covers costs"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "relative bg-white border border-slate-200 border-l-4 border-green-500 rounded-lg p-3 mt-3 shadow-sm",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-xs text-green-800 leading-relaxed",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Current System:"
                                                }),
                                                " Improved rental income assessment rules and enhanced property management support for aged care residents."
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white rounded-xl p-6 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-3 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-12 h-12 bg-brand-navy rounded-lg flex items-center justify-center text-white font-bold text-xl",
                                                children: "3"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-lg font-bold text-gray-900",
                                                children: "Use Existing Assets"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-700 text-sm mb-3",
                                        children: "Liquidate investments, superannuation, or other assets to fund RAD. Keep home, preserve Age Pension eligibility, maintain family home for partner/estate."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-xs text-gray-500 italic",
                                        children: "Best if: Sufficient non-home assets, want to preserve home, maintaining pension important"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "relative bg-white border border-slate-200 border-l-4 border-blue-500 rounded-lg p-3 mt-3 shadow-sm",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-xs text-slate-700 leading-relaxed",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Current System:"
                                                }),
                                                " Enhanced superannuation withdrawal rules and improved investment deeming arrangements for aged care funding."
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white rounded-xl p-6 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-3 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-12 h-12 bg-brand-navy rounded-lg flex items-center justify-center text-white font-bold text-xl",
                                                children: "4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-lg font-bold text-gray-900",
                                                children: "Combination Approach"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-700 text-sm mb-3",
                                        children: "Pay partial RAD and partial DAP to balance capital preservation with ongoing costs. Optimize Age Pension, manage cash flow, maintain flexibility."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-xs text-gray-500 italic",
                                        children: "Best if: Want to hedge your bets, uncertain about length of stay, balance cash flow"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "bg-white border border-slate-200 border-l-4 border-blue-500 rounded-lg p-3 mt-3",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-xs text-blue-800",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Current System:"
                                                }),
                                                " More flexible accommodation payment arrangements and improved financial hardship provisions for complex situations."
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-gradient-to-r from-brand-navy to-brand-blue rounded-2xl p-8 md:p-12 text-white text-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-3xl md:text-4xl font-bold mb-4",
                        children: "What's Your Best Funding Strategy?"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xl mb-8 text-blue-100",
                        children: "Get a personalised funding plan that optimises your Age Pension, cash flow, and estate goals"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-lg text-blue-200",
                        children: "Return to the home screen to get started with your personalised assessment"
                    })
                ]
            })
        ]
    });
// Care Impacts Content Component
const $cbea7fe05b0c10b5$var$CareImpactsContent = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-16",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "prose prose-lg max-w-none",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-xl text-gray-700 leading-relaxed",
                    children: "Your aged care and living choices have significant impacts on your Age Pension entitlements, cash flow, estate planning, and overall financial security. Understanding these impacts helps you make decisions that align with your priorities."
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-2xl shadow-xl overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-gradient-to-r from-brand-navy to-brand-blue p-8 text-white",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-3xl font-bold mb-2",
                                children: "Impact on Age Pension"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-blue-100",
                                children: "How your choices affect your government support"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-8 md:p-12",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid md:grid-cols-2 gap-8",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-xl font-bold text-gray-900 mb-4",
                                                children: "The Assets Test"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-gray-700 mb-4",
                                                children: "Your Age Pension is determined by both an income test and an assets test. The test that results in the lower payment applies."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "relative bg-white border border-slate-200 border-l-4 border-blue-500 rounded-lg p-5 mb-4 shadow-sm",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-bold text-blue-900 mb-1 text-base",
                                                        children: "Assets test \u2014 homeowners"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs text-gray-500 mb-3",
                                                        children: $cbea7fe05b0c10b5$var$RATES_AS_AT
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "space-y-3 text-sm",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "flex justify-between",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "text-gray-700",
                                                                                children: "Single \u2014 full pension below"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "font-bold text-blue-900",
                                                                                children: $cbea7fe05b0c10b5$var$money0((0, $1abe73eeef086faf$export$9a84fd450010fb2e).single.homeowner.full)
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "flex justify-between text-xs text-gray-500",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                children: "pension cuts out above"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                children: $cbea7fe05b0c10b5$var$money0((0, $1abe73eeef086faf$export$9a84fd450010fb2e).single.homeowner.cutoff)
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "flex justify-between",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "text-gray-700",
                                                                                children: "Couple (combined) \u2014 full below"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "font-bold text-blue-900",
                                                                                children: $cbea7fe05b0c10b5$var$money0((0, $1abe73eeef086faf$export$9a84fd450010fb2e).couple.homeowner.full)
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "flex justify-between text-xs text-gray-500",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                children: "pension cuts out above"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                children: $cbea7fe05b0c10b5$var$money0((0, $1abe73eeef086faf$export$9a84fd450010fb2e).couple.homeowner.cutoff)
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "rounded-lg bg-blue-50 -mx-2 px-2 py-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "flex justify-between",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "text-blue-900 font-medium",
                                                                                children: "Couple, illness-separated \u2014 full below"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "font-bold text-blue-900",
                                                                                children: $cbea7fe05b0c10b5$var$money0((0, $1abe73eeef086faf$export$9a84fd450010fb2e).coupleIllnessSeparated.homeowner.full)
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "flex justify-between text-xs text-blue-700",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                children: "pension cuts out above"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "font-semibold",
                                                                                children: $cbea7fe05b0c10b5$var$money0((0, $1abe73eeef086faf$export$9a84fd450010fb2e).coupleIllnessSeparated.homeowner.cutoff)
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-xs text-gray-500 mt-3",
                                                        children: [
                                                            "Non-homeowners can hold more \u2014 e.g. a single non-homeowner keeps the full pension below ",
                                                            $cbea7fe05b0c10b5$var$money0((0, $1abe73eeef086faf$export$9a84fd450010fb2e).single.nonHomeowner.full),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-gray-600",
                                                children: "For every $1,000 of assets over the lower threshold, your pension reduces by $3/fortnight. Centrelink applies whichever of the income and assets tests gives the lower payment."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-xl font-bold text-gray-900 mb-4",
                                                children: "Key Exemptions"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "space-y-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "border-l-4 border-green-500 pl-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-semibold text-gray-900",
                                                                children: "Principal Home (Living)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-sm text-gray-700",
                                                                children: "If you live in your home, it's fully exempt from the assets test"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "border-l-4 border-green-500 pl-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-semibold text-gray-900",
                                                                children: "Former Home \u2014 partner stays"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-sm text-gray-700",
                                                                children: "If your partner keeps living in the home, it stays exempt from the assets test for as long as they live there."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "border-l-4 border-yellow-500 pl-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-semibold text-gray-900",
                                                                children: "Former Home \u2014 2-year rule"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-sm text-gray-700",
                                                                children: "If no one stays (you rent it out or it's vacant), it's exempt for 2 years after you enter care, then becomes assessable. Any rent is counted as income."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "border-l-4 border-blue-500 pl-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-semibold text-gray-900",
                                                                children: "RAD Payment"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-sm text-gray-700",
                                                                children: "RAD is exempt from the assets test, but affects deemed income"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "border-l-4 border-blue-500 pl-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "font-semibold text-gray-900",
                                                                children: "Granny Flat Interest"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-sm text-gray-700",
                                                                children: "Formal agreements may provide partial or full exemptions"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-8 relative bg-white border border-slate-200 border-l-4 border-blue-500 rounded-lg p-6 shadow-sm",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex-shrink-0",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-10 h-10 rounded-lg bg-brand-navy flex items-center justify-center shadow-sm",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                                    className: "w-6 h-6 text-white"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                    className: "font-bold text-slate-900 mb-2 text-base",
                                                    children: "Illness-separated couples \u2014 where aged care usually begins"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-slate-700 text-sm leading-relaxed mb-2",
                                                    children: [
                                                        "When one partner moves into residential aged care, Centrelink treats the couple as ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "illness-separated"
                                                        }),
                                                        ". Each is then assessed at the more generous ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "single"
                                                        }),
                                                        " rates and thresholds, even though their assets and income are still combined:"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                    className: "text-slate-700 text-sm space-y-1 mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                            children: [
                                                                "\u2022 Each is paid the higher ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: "single"
                                                                }),
                                                                " Age Pension rate (",
                                                                $cbea7fe05b0c10b5$var$perFortnight((0, $1abe73eeef086faf$export$d3d0fa1dd4309cd0).single),
                                                                "/fortnight each)."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                            children: [
                                                                "\u2022 Assets cut-off rises to ",
                                                                $cbea7fe05b0c10b5$var$money0((0, $1abe73eeef086faf$export$9a84fd450010fb2e).coupleIllnessSeparated.homeowner.cutoff),
                                                                " (homeowners), vs ",
                                                                $cbea7fe05b0c10b5$var$money0((0, $1abe73eeef086faf$export$9a84fd450010fb2e).couple.homeowner.cutoff),
                                                                " for a standard couple."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                            children: [
                                                                "\u2022 Income cut-off rises to ",
                                                                $cbea7fe05b0c10b5$var$money0((0, $1abe73eeef086faf$export$bad1f8cb9d172d1b).coupleIllnessSeparated),
                                                                "/year, vs ",
                                                                $cbea7fe05b0c10b5$var$money0((0, $1abe73eeef086faf$export$bad1f8cb9d172d1b).couple),
                                                                " for a standard couple."
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-slate-700 text-sm leading-relaxed",
                                                    children: [
                                                        "The result is often a ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "higher combined Age Pension"
                                                        }),
                                                        " \u2014 and lower means-tested care fees \u2014 right when care costs arrive. AgedCareWise applies these rules automatically when you model an aged care scenario."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-8 relative bg-white border border-slate-200 border-l-4 border-amber-400 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex-shrink-0",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-10 h-10 rounded-lg bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center shadow-sm",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e57d6b071418ede9$export$2e2bcd8739ae039), {
                                                    className: "w-6 h-6 text-white"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                    className: "font-bold text-amber-900 mb-2 text-base",
                                                    children: "Strategic Insight"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-amber-800 text-sm leading-relaxed",
                                                    children: "Moving into aged care and selling your home can significantly reduce your Age Pension because you lose the home exemption and gain assessable assets. However, paying a RAD removes those funds from the assets test, potentially restoring your pension. This is why RAD vs DAP decisions are so important for Age Pension optimisation."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-2xl shadow-xl overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-gradient-to-r from-brand-navy to-brand-blue p-8 text-white",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-3xl font-bold mb-2",
                                children: "Impact on Cash Flow"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-blue-100",
                                children: "How your choices affect your day-to-day finances"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-8 md:p-12",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid md:grid-cols-2 gap-8 mb-8",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-white border border-slate-200 rounded-xl p-6",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                                className: "text-xl font-bold text-gray-900 mb-4 flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e71d8988c230db1b$export$2e2bcd8739ae039), {
                                                        className: "w-6 h-6 text-red-600"
                                                    }),
                                                    "Cash Flow Drains"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "space-y-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex justify-between items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-gray-700",
                                                                children: "Basic daily fee"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-bold text-red-700",
                                                                children: "$2,044/month"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex justify-between items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-gray-700",
                                                                children: "Means-tested fee"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-bold text-red-700",
                                                                children: "$0-$10,000+/month"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex justify-between items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-gray-700",
                                                                children: "DAP (if not paying RAD)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-bold text-red-700",
                                                                children: "$2,500+/month"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex justify-between items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-gray-700",
                                                                children: "Extra services"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-bold text-red-700",
                                                                children: "$500-$2,000/month"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "border-t-2 border-red-200 pt-3 flex justify-between items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-bold text-gray-900",
                                                                children: "Potential Monthly Cost"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-bold text-2xl text-red-700",
                                                                children: "$5,000-$15,000"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-white border border-slate-200 rounded-xl p-6",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                                className: "text-xl font-bold text-gray-900 mb-4 flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {
                                                        className: "w-6 h-6 text-green-600"
                                                    }),
                                                    "Income Sources"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "space-y-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex justify-between items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-gray-700",
                                                                children: "Age Pension"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-bold text-green-700",
                                                                children: "$1,300-$2,150/month"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex justify-between items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-gray-700",
                                                                children: "Super/investments"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-bold text-green-700",
                                                                children: "$1,000-$5,000/month"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex justify-between items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-gray-700",
                                                                children: "Rental income"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-bold text-green-700",
                                                                children: "$1,500-$3,000/month"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex justify-between items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-gray-700",
                                                                children: "Part pension top-ups"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-bold text-green-700",
                                                                children: "$500-$1,000/month"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "border-t-2 border-green-200 pt-3 flex justify-between items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-bold text-gray-900",
                                                                children: "Potential Monthly Income"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-bold text-2xl text-green-700",
                                                                children: "$4,300-$11,150"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative bg-white border border-slate-200 border-l-4 border-blue-500 rounded-lg p-6 shadow-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-3 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex-shrink-0 w-10 h-10 rounded-lg bg-brand-navy flex items-center justify-center shadow-sm",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $27f56d6cfb7d79f8$export$2e2bcd8739ae039), {
                                                    className: "w-6 h-6 text-white"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                className: "font-bold text-blue-900 text-base",
                                                children: "Cash Flow Optimization Strategies"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "grid md:grid-cols-2 gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "bg-white rounded-lg p-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-semibold text-gray-900 mb-2",
                                                        children: "1. Balance RAD vs DAP"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-sm text-gray-700",
                                                        children: "Pay enough RAD to manage DAP costs, but keep sufficient liquid assets for emergencies and lifestyle"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "bg-white rounded-lg p-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-semibold text-gray-900 mb-2",
                                                        children: "2. Optimise Age Pension"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-sm text-gray-700",
                                                        children: "Structure assets to maximise pension without compromising investment returns or estate goals"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "bg-white rounded-lg p-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-semibold text-gray-900 mb-2",
                                                        children: "3. Generate Income"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-sm text-gray-700",
                                                        children: "Consider rental income from former home, or maintain income-producing investments"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "bg-white rounded-lg p-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "font-semibold text-gray-900 mb-2",
                                                        children: "4. Plan for Inflation"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-sm text-gray-700",
                                                        children: "Fees increase annually; ensure your strategy remains sustainable over 10+ years"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-2xl shadow-xl overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-gradient-to-r from-brand-navy to-brand-blue p-8 text-white",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-3xl font-bold mb-2",
                                children: "Impact on Estate & Legacy"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-blue-100",
                                children: "How your choices affect what you leave behind"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "p-8 md:p-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-6",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "border-l-4 border-blue-500 pl-6",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: "text-xl font-bold text-gray-900 mb-3",
                                            children: "The Family Home Question"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-gray-700 mb-4",
                                            children: "For many Australians, the family home represents the largest component of their estate. Deciding whether to sell, rent, or keep the home affects both your current financial position and what you can pass on to your beneficiaries."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "grid md:grid-cols-3 gap-4",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "bg-slate-50 rounded-lg p-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "font-semibold text-slate-900 mb-2",
                                                            children: "Keep & Rent"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-sm text-slate-700",
                                                            children: "Preserve asset for estate, provide rental income, maintain family attachment"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "bg-slate-50 rounded-lg p-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "font-semibold text-slate-900 mb-2",
                                                            children: "Sell & Invest"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-sm text-slate-700",
                                                            children: "Maximize liquidity, simplify estate, fund aged care, diversify investments"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "bg-slate-50 rounded-lg p-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "font-semibold text-slate-900 mb-2",
                                                            children: "Transfer to Family"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-sm text-slate-700",
                                                            children: "Gift or granny flat arrangement, immediate transfer, careful planning needed"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "border-l-4 border-blue-500 pl-6",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: "text-xl font-bold text-gray-900 mb-3",
                                            children: "RAD Refunds"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-gray-700 mb-4",
                                            children: "A major advantage of paying a RAD is that it's largely refundable to your estate. However, providers can retain 2% per annum (up to a maximum of 10%) to cover accommodation costs. If you pay a $500,000 RAD, your estate receives most of this back when you pass away or leave the facility."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "relative bg-white border border-slate-200 border-l-4 border-green-500 rounded-lg p-5 shadow-sm",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-sm text-green-800 leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Example:"
                                                    }),
                                                    ' John pays a $400,000 RAD and lives in the facility for 5 years. When he passes away, his estate receives $360,000 back (after 10% retention), even though he effectively "used" accommodation worth approximately $150,000 over that time (at current DAP equivalent rates).'
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "border-l-4 border-blue-500 pl-6",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: "text-xl font-bold text-gray-900 mb-3",
                                            children: "Estate Erosion Risks"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-gray-700 mb-4",
                                            children: "Without proper planning, aged care and living costs can significantly erode your estate:"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "space-y-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex gap-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "flex-shrink-0 w-8 h-8 bg-red-100 rounded-full flex items-center justify-center",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-red-700 font-bold",
                                                                children: "!"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "font-semibold text-gray-900",
                                                                    children: "High ongoing fees"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "text-sm text-gray-700",
                                                                    children: "$60,000-$180,000/year in fees can quickly deplete savings"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex gap-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "flex-shrink-0 w-8 h-8 bg-red-100 rounded-full flex items-center justify-center",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-red-700 font-bold",
                                                                children: "!"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "font-semibold text-gray-900",
                                                                    children: "Forced asset sales"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "text-sm text-gray-700",
                                                                    children: "Selling at the wrong time or in the wrong market can reduce estate value"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex gap-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "flex-shrink-0 w-8 h-8 bg-red-100 rounded-full flex items-center justify-center",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-red-700 font-bold",
                                                                children: "!"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "font-semibold text-gray-900",
                                                                    children: "Longevity beyond expectations"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "text-sm text-gray-700",
                                                                    children: "Living longer than planned can exhaust funds meant for beneficiaries"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "bg-white border border-slate-200 rounded-xl p-6",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                            className: "font-bold text-gray-900 mb-4 flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $960b709ecb4ade55$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5 text-blue-600"
                                                }),
                                                "Estate Protection Strategies"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "grid md:grid-cols-2 gap-4",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "font-semibold text-gray-900 mb-2",
                                                            children: "Funeral bonds"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-sm text-gray-700",
                                                            children: "A funeral bond or prepaid funeral is exempt from the assets test up to a capped amount, while prepaying a known estate cost. (There is no private aged care insurance in Australia.)"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "font-semibold text-gray-900 mb-2",
                                                            children: "Testamentary trusts"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-sm text-gray-700",
                                                            children: "Set up in your will and effective on death, they protect a beneficiary's inheritance \u2014 from divorce, bankruptcy or spendthrift risk \u2014 and can be tax-effective. They don't reduce your own aged care fees while you're alive."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "font-semibold text-gray-900 mb-2",
                                                            children: "Strategic gifting"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-sm text-gray-700",
                                                            children: "Gifts within the limits ($10,000 a year, up to $30,000 over 5 years) aren't assessed. Amounts above are \u201Cdeprived assets\u201D \u2014 still counted for 5 years and deemed for income."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "font-semibold text-gray-900 mb-2",
                                                            children: "Will, POA & guardianship"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-sm text-gray-700",
                                                            children: "Keep your will current and appoint trusted attorneys for both financial and medical/guardianship decisions, so someone can act if you lose capacity."
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-2xl p-8 md:p-12 border border-amber-100",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: "text-3xl font-bold text-gray-900 mb-8 flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                className: "w-8 h-8 text-amber-600"
                            }),
                            "Key Risk Factors to Consider"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid md:grid-cols-2 gap-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white rounded-xl p-6 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-lg font-bold text-gray-900 mb-3",
                                        children: "Longevity Risk"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-700 text-sm mb-3",
                                        children: "Living longer than expected can exhaust your savings. Plan for potential 20+ year stays in aged care."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-xs text-orange-700 font-semibold",
                                        children: "Mitigation: Balance RAD/DAP, maintain buffer, consider annuities"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white rounded-xl p-6 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-lg font-bold text-gray-900 mb-3",
                                        children: "Care Needs Escalation"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-700 text-sm mb-3",
                                        children: "Your care needs may increase unexpectedly, leading to higher costs and fees."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-xs text-orange-700 font-semibold",
                                        children: "Mitigation: Build in cost escalation, maintain liquidity, review annually"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white rounded-xl p-6 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-lg font-bold text-gray-900 mb-3",
                                        children: "Market & Investment Risk"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-700 text-sm mb-3",
                                        children: "If paying DAP and relying on investment returns, market downturns can impact your ability to pay fees."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-xs text-orange-700 font-semibold",
                                        children: "Mitigation: Diversify investments, maintain cash reserves, consider partial RAD"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white rounded-xl p-6 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-lg font-bold text-gray-900 mb-3",
                                        children: "Policy & Rate Changes"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-700 text-sm mb-3",
                                        children: "Government policy changes, MPIR adjustments, or facility fee increases can affect your costs."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-xs text-orange-700 font-semibold",
                                        children: "Mitigation: Stay informed, review strategy regularly, maintain flexibility"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-gradient-to-r from-brand-navy to-brand-blue rounded-2xl p-8 md:p-12 text-white text-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-3xl md:text-4xl font-bold mb-4",
                        children: "Get a Comprehensive Impact Analysis"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xl mb-8 text-blue-100",
                        children: "See exactly how different choices affect your Age Pension, cash flow, and estate"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-lg text-blue-200",
                        children: "Return to the home screen to get started with your personalised assessment"
                    })
                ]
            })
        ]
    });
// Next Steps Content Component
const $cbea7fe05b0c10b5$var$NextStepsContent = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-16",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "text-center max-w-3xl mx-auto",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-2xl text-gray-700 leading-relaxed",
                    children: "Ready to turn information into action? Here's your roadmap to making confident, informed decisions about your aged care and retirement living."
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative overflow-hidden bg-brand-navy rounded-3xl p-12 text-white text-center shadow-2xl",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute -top-20 -right-10 w-72 h-72 rounded-full bg-white/10 blur-3xl",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute -bottom-24 -left-12 w-80 h-80 rounded-full bg-teal-300/10 blur-3xl",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative max-w-3xl mx-auto",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-full px-6 py-3 mb-6",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                                        className: "w-5 h-5"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-semibold",
                                        children: "Personalised Just For You"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-4xl md:text-5xl font-bold mb-6",
                                children: "Get Your Personalised Plan"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-xl text-blue-100 mb-8",
                                children: "Stop reading generic advice. Get specific recommendations based on YOUR unique situation, finances, health, and goals through our comprehensive suggestion engine."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-lg text-blue-200 mb-6",
                                children: "Return to the home screen to get started with your personalised assessment"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-blue-100",
                                children: "\u2713 Takes 10-15 minutes  \u2713 Personal advice  \u2713 $450 fee"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-2xl shadow-xl p-8 md:p-12",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-3xl font-bold text-gray-900 mb-8 text-center",
                        children: "What You'll Receive"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid md:grid-cols-3 gap-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "w-16 h-16 bg-brand-navy rounded-2xl flex items-center justify-center mx-auto mb-4",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $27f56d6cfb7d79f8$export$2e2bcd8739ae039), {
                                            className: "w-8 h-8 text-white"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-xl font-bold text-gray-900 mb-3",
                                        children: "Financial Analysis"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-600",
                                        children: "See exactly how different options affect your Age Pension, cash flow, and wealth over time"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "w-16 h-16 bg-brand-navy rounded-2xl flex items-center justify-center mx-auto mb-4",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e57d6b071418ede9$export$2e2bcd8739ae039), {
                                            className: "w-8 h-8 text-white"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-xl font-bold text-gray-900 mb-3",
                                        children: "Smart Recommendations"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-600",
                                        children: "Get recommendations from our suggestion engine that models thousands of strategy options, or create your own scenarios to compare different approaches"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "w-16 h-16 bg-brand-navy rounded-2xl flex items-center justify-center mx-auto mb-4",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                            className: "w-8 h-8 text-white"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-xl font-bold text-gray-900 mb-3",
                                        children: "Action Plan"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-600",
                                        children: "Receive a step-by-step roadmap with timelines, contacts, and required paperwork"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white border border-slate-200 rounded-2xl p-8 md:p-12",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-3xl font-bold text-gray-900 mb-8 text-center",
                        children: "Your Journey Timeline"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-6 max-w-4xl mx-auto",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$TimelineItem, {
                                phase: "Phase 1: Planning and Assessment",
                                items: [
                                    "Gather financial documents",
                                    "Consult with accountant regarding cost base of assets (if needed)",
                                    "Register on AgedCareWise",
                                    "Explore facilities and options"
                                ],
                                color: "blue"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$TimelineItem, {
                                phase: "Phase 2: Analyse and Discuss",
                                items: [
                                    "Review strategy options created by AgedCareWise",
                                    "Discuss with family",
                                    "Agree on pathway"
                                ],
                                color: "purple"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$TimelineItem, {
                                phase: "Phase 3: Action",
                                items: [
                                    "Finalise facility choice",
                                    "Arrange funding (sell/rent home, access super)",
                                    "Complete legal documents",
                                    "Submit applications"
                                ],
                                color: "pink"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$TimelineItem, {
                                phase: "Phase 4: Transition",
                                items: [
                                    "Move into new accommodation",
                                    "Settle payments and agreements",
                                    "Adjust to new lifestyle",
                                    "Review and optimise as needed"
                                ],
                                color: "orange"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white rounded-2xl shadow-xl p-8 md:p-12",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-3xl font-bold text-gray-900 mb-8",
                        children: "Helpful Resources"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid md:grid-cols-2 gap-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$ResourceCard, {
                                title: "My Aged Care",
                                description: "Official government portal for aged care services and assessments",
                                link: "myagedcare.gov.au",
                                icon: (0, $3c35b0991cad9668$export$2e2bcd8739ae039)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$ResourceCard, {
                                title: "Services Australia",
                                description: "Information about Age Pension and Centrelink support",
                                link: "servicesaustralia.gov.au",
                                icon: (0, $3c35b0991cad9668$export$2e2bcd8739ae039)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$ResourceCard, {
                                title: "Aged Care Quality Standards",
                                description: "Learn about care quality and your rights as a consumer",
                                link: "agedcarequality.gov.au",
                                icon: (0, $3c35b0991cad9668$export$2e2bcd8739ae039)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cbea7fe05b0c10b5$var$ResourceCard, {
                                title: "Financial Advice",
                                description: "Find a qualified financial adviser specialising in aged care",
                                link: "moneysmart.gov.au",
                                icon: (0, $3c35b0991cad9668$export$2e2bcd8739ae039)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-gradient-to-r from-brand-navy to-brand-blue rounded-2xl p-8 md:p-12 text-white text-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-3xl md:text-4xl font-bold mb-4",
                        children: "Don't Navigate This Alone"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xl mb-8 text-blue-100",
                        children: "Built by experienced advisers with comprehensive modelling capabilities"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-lg text-blue-200",
                        children: "Return to the home screen to get started with your personalised assessment"
                    })
                ]
            })
        ]
    });
const $cbea7fe05b0c10b5$var$DetailItem = ({ icon: Icon, text: text })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-start gap-3 p-3 rounded-lg bg-slate-50 border border-slate-200 hover:border-blue-200 hover:shadow-sm transition-all group",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex-shrink-0 w-6 h-6 rounded-full bg-brand-navy flex items-center justify-center shadow-sm group-hover:scale-110 transition-transform",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                    size: 14,
                    className: "text-white",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-gray-700 text-sm font-medium group-hover:text-gray-900 transition-colors flex-1",
                children: text
            })
        ]
    });
const $cbea7fe05b0c10b5$var$TimelineItem = ({ phase: phase, items: items, color: color })=>{
    const colorClasses = {
        blue: 'bg-brand-navy border-blue-200',
        purple: 'bg-brand-navy border-blue-200',
        pink: 'bg-brand-navy border-blue-200',
        orange: 'bg-brand-navy border-blue-200'
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex gap-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex-shrink-0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: `w-12 h-12 ${colorClasses[color]} rounded-full flex items-center justify-center`,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                        className: "w-6 h-6 text-white"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex-1 bg-white rounded-xl p-6 shadow-lg",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-xl font-bold text-gray-900 mb-3",
                        children: phase
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        className: "space-y-2",
                        children: items.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                className: "flex items-start gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                                        size: 18,
                                        className: "text-green-600 flex-shrink-0 mt-0.5"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-gray-700 text-sm",
                                        children: item
                                    })
                                ]
                            }, index))
                    })
                ]
            })
        ]
    });
};
const $cbea7fe05b0c10b5$var$ResourceCard = ({ title: title, description: description, link: link, icon: Icon })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
        href: `https://${link}`,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "flex gap-4 p-6 bg-white border border-slate-200 rounded-xl hover:shadow-lg transition-all group",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex-shrink-0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                        className: "w-6 h-6 text-white"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-lg font-bold text-gray-900 mb-1 group-hover:text-blue-600 transition-colors",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-gray-600 mb-2",
                        children: description
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-blue-600 font-medium",
                        children: link
                    })
                ]
            })
        ]
    });
var $cbea7fe05b0c10b5$export$2e2bcd8739ae039 = $cbea7fe05b0c10b5$var$GeneralAdvice;


/**
 * SecurityPage — a lay-person, confidence-building explanation of how AgedCareWise protects
 * people's information. Reachable from the landing-page "Security" nav link. Deliberately
 * plain-English (no IT jargon) and deliberately high-level: it reassures without handing an
 * attacker a map of the system. The deep technical evidence lives in docs/specs/*, not here.
 */ 
parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c884b30baaa9d8ee$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4",
            key: "1pf5j1"
        }
    ],
    [
        "path",
        {
            d: "M14 2v4a2 2 0 0 0 2 2h4",
            key: "tnqrlb"
        }
    ],
    [
        "path",
        {
            d: "m3 15 2 2 4-4",
            key: "1lhrkk"
        }
    ]
];
const $c884b30baaa9d8ee$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("file-check-2", $c884b30baaa9d8ee$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $bfcb8924c7a113d6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
            key: "c3ymky"
        }
    ],
    [
        "path",
        {
            d: "M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66",
            key: "4oyue0"
        }
    ],
    [
        "path",
        {
            d: "m18 15-2-2",
            key: "60u0ii"
        }
    ],
    [
        "path",
        {
            d: "m15 18-2-2",
            key: "6p76be"
        }
    ]
];
const $bfcb8924c7a113d6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("heart-handshake", $bfcb8924c7a113d6$export$3efd853dbb351e94);


const $704e9efeb37f3b49$var$PROMISES = [
    {
        icon: (0, $c978075baab28645$export$2e2bcd8739ae039),
        title: 'Your records are stored in Australia',
        body: 'Your profile, plans and advice records are stored securely in Australia, under Australian privacy law. The few service providers we use, and the countries they operate in, are described in our Privacy Policy.'
    },
    {
        icon: (0, $e20ffdae2aa9b33f$export$2e2bcd8739ae039),
        title: "Encrypted \u2014 even from us",
        body: 'Your personal and financial details are scrambled with bank-grade encryption before they are stored. Even if someone got hold of the raw data, it would be unreadable without keys we keep separately.'
    },
    {
        icon: (0, $8695263a8c6cd2c2$export$2e2bcd8739ae039),
        title: 'Two-factor protection',
        body: "You can link an authenticator app to your login, so a password alone is never enough to get in. For advisers handling clients\u2019 money, it\u2019s required."
    },
    {
        icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
        title: 'Only you can see your plan',
        body: "Strict walls keep every person\u2019s information private. One client can never see another\u2019s, and a professional firm only ever sees its own clients \u2014 enforced by the system, not just a promise."
    },
    {
        icon: (0, $c884b30baaa9d8ee$export$2e2bcd8739ae039),
        title: 'A tamper-proof record',
        body: "Every important action is written to a permanent, tamper-evident log. If anything were ever changed, it would show \u2014 which keeps your advice history trustworthy."
    },
    {
        icon: (0, $9ad14973a512851d$export$2e2bcd8739ae039),
        title: 'Independently tested',
        body: "Before we work with real clients, the system is put through a professional security review (a \u201Cpenetration test\u201D) by outside experts whose job is to try to break in."
    }
];
const $704e9efeb37f3b49$var$SecurityPage = ({ onBack: onBack })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen bg-slate-50",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "sticky top-0 z-10 border-b border-gray-200 bg-white/90 backdrop-blur",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mx-auto flex max-w-5xl items-center justify-between px-5 py-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            onClick: onBack,
                            className: "inline-flex items-center gap-1.5 rounded-lg px-2 py-1.5 text-sm font-medium text-gray-600 transition hover:bg-gray-100 hover:text-gray-900",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                    size: 16
                                }),
                                " Back"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-lg font-bold",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-slate-900",
                                    children: "AgedCare"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-[#17b8e0]",
                                    children: "Wise"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative overflow-hidden bg-gradient-to-br from-[#1a6fd4] to-[#17b8e0] text-white",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "pointer-events-none absolute -right-16 -top-20 h-64 w-64 rounded-full bg-white/10 blur-3xl"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "pointer-events-none absolute -left-10 bottom-0 h-48 w-48 rounded-full bg-white/5 blur-2xl"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative mx-auto max-w-5xl px-5 py-14 text-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/25 backdrop-blur",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                    className: "h-8 w-8"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-3xl font-bold sm:text-4xl",
                                children: "Your information is safe with us"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mx-auto mt-3 max-w-2xl text-base text-white/90 sm:text-lg",
                                children: "You\u2019re trusting AgedCareWise with sensitive details at an important time. Here\u2019s how we protect them."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mx-auto max-w-5xl px-5 py-12 space-y-12",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "grid gap-5 sm:grid-cols-2 lg:grid-cols-3",
                        children: $704e9efeb37f3b49$var$PROMISES.map(({ icon: Icon, title: title, body: body })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "rounded-2xl border border-gray-200 bg-white p-6 shadow-sm transition hover:shadow-md",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-blue-50 text-[#1a6fd4]",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                            size: 22
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-base font-bold text-slate-900",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mt-2 text-sm leading-relaxed text-gray-600",
                                        children: body
                                    })
                                ]
                            }, title))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "rounded-2xl border border-gray-200 bg-white p-7 shadow-sm sm:p-9",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-start gap-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-[#1a6fd4]",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bfcb8924c7a113d6$export$2e2bcd8739ae039), {
                                        size: 24
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            className: "text-xl font-bold text-slate-900",
                                            children: "Our approach: plan for the worst"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "mt-2 text-sm leading-relaxed text-gray-600 sm:text-base",
                                            children: [
                                                "Good security isn\u2019t one lock on the front door \u2014 it\u2019s many layers, designed on the assumption that someone ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                                    children: "will"
                                                }),
                                                " try to break in. So we make sure that even in a worst-case moment, the amount of information anyone could reach is as small as possible, and that the keys to unscramble it are kept well away from the data itself. It\u2019s the same \u201Cbelt-and-braces\u201D thinking a bank uses."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "rounded-2xl border border-gray-200 bg-white p-7 shadow-sm sm:p-9",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-start gap-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-[#1a6fd4]",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a9bbf84fd0f8247$export$2e2bcd8739ae039), {
                                        size: 24
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            className: "text-xl font-bold text-slate-900",
                                            children: "Your privacy, and your rights"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "mt-2 text-sm leading-relaxed text-gray-600 sm:text-base",
                                            children: [
                                                "We follow Australia\u2019s ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Privacy Act"
                                                }),
                                                ", and we only ever collect what we genuinely need. You stay in control of your information:"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                            className: "mt-4 space-y-2.5",
                                            children: [
                                                'You can download a copy of everything we hold about you, at any time.',
                                                'You can ask us to delete your information when you no longer need the service.',
                                                "Because we provide financial advice, we\u2019re legally required to keep advice records for a set period \u2014 we\u2019ll always be upfront about what\u2019s kept and why."
                                            ].map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    className: "flex items-start gap-2.5 text-sm text-gray-700",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                                            size: 17,
                                                            className: "mt-0.5 shrink-0 text-emerald-500"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: item
                                                        })
                                                    ]
                                                }, item))
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "rounded-2xl bg-gradient-to-br from-slate-900 to-slate-700 p-7 text-center text-white sm:p-9",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mx-auto mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-white/10 ring-1 ring-white/20",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0cdbf97a5c8afc2$export$2e2bcd8739ae039), {
                                    size: 20
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-lg font-bold sm:text-xl",
                                children: "Security you don\u2019t have to think about"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mx-auto mt-2 max-w-xl text-sm leading-relaxed text-white/80",
                                children: "You focus on the decision in front of you. We\u2019ll quietly do the work of keeping your details safe, private, and in your control \u2014 the way it should be."
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $704e9efeb37f3b49$export$2e2bcd8739ae039 = $704e9efeb37f3b49$var$SecurityPage;


/**
 * PrivacyPage — the plain-English privacy statement reachable from the landing-page "Privacy"
 * nav link. Mirrors SecurityPage's confidence-building pattern. It reflects what is actually
 * built (AU-only storage, field-level encryption, export/delete endpoints, advice-record
 * retention) — never promise here what the system doesn't do. The formal Privacy Policy and
 * the collection notice open from this page in the same reader the sign-up checkbox uses.
 */ 

var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $056e74b7b26d3329$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
            key: "ct8e1f"
        }
    ],
    [
        "path",
        {
            d: "M14.084 14.158a3 3 0 0 1-4.242-4.242",
            key: "151rxh"
        }
    ],
    [
        "path",
        {
            d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
            key: "13bj9a"
        }
    ],
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ]
];
const $056e74b7b26d3329$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("eye-off", $056e74b7b26d3329$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d6fe951f3901e9a6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7",
            key: "132q7q"
        }
    ],
    [
        "rect",
        {
            x: "2",
            y: "4",
            width: "20",
            height: "16",
            rx: "2",
            key: "izxlao"
        }
    ]
];
const $d6fe951f3901e9a6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("mail", $d6fe951f3901e9a6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $fb2238e39ffa2776$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M7 18v-6a5 5 0 1 1 10 0v6",
            key: "pcx96s"
        }
    ],
    [
        "path",
        {
            d: "M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z",
            key: "1b4s83"
        }
    ],
    [
        "path",
        {
            d: "M21 12h1",
            key: "jtio3y"
        }
    ],
    [
        "path",
        {
            d: "M18.5 4.5 18 5",
            key: "g5sp9y"
        }
    ],
    [
        "path",
        {
            d: "M2 12h1",
            key: "1uaihz"
        }
    ],
    [
        "path",
        {
            d: "M12 2v1",
            key: "11qlp1"
        }
    ],
    [
        "path",
        {
            d: "m4.929 4.929.707.707",
            key: "1i51kw"
        }
    ],
    [
        "path",
        {
            d: "M12 12v6",
            key: "3ahymv"
        }
    ]
];
const $fb2238e39ffa2776$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("siren", $fb2238e39ffa2776$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $eaf5d43eccd19b48$export$3efd853dbb351e94 = [
    [
        "line",
        {
            x1: "10",
            x2: "14",
            y1: "2",
            y2: "2",
            key: "14vaq8"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "15",
            y1: "14",
            y2: "11",
            key: "17fdiu"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "14",
            r: "8",
            key: "1e1u0o"
        }
    ]
];
const $eaf5d43eccd19b48$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("timer", $eaf5d43eccd19b48$export$3efd853dbb351e94);


const $c64b4fe17d116bf7$var$PROMISES = [
    {
        icon: (0, $3739d64fb7ddfae6$export$2e2bcd8739ae039),
        title: 'We collect only what we need',
        body: "Your email to run your account, and the details you enter about your situation and finances \u2014 because that\u2019s what your plan is built from. Card payments are handled by Stripe; your card number never touches our servers."
    },
    {
        icon: (0, $056e74b7b26d3329$export$2e2bcd8739ae039),
        title: 'Never sold, never advertising',
        body: "Your information is used for one thing: producing your plan and advice. We don\u2019t sell it, share it with marketers, or use it to profile you for ads. Full stop."
    },
    {
        icon: (0, $c978075baab28645$export$2e2bcd8739ae039),
        title: 'Stored in Australia',
        body: "Your personal and financial details are stored in Australia, protected by Australian privacy law, and encrypted so they\u2019re unreadable without keys we keep separately."
    },
    {
        icon: (0, $0d957a6b316cfc10$export$2e2bcd8739ae039),
        title: 'Shared only as you direct',
        body: "If a professional adviser invited you, they see the file they\u2019re helping you with \u2014 that\u2019s the service. Beyond that, your information goes only to the few specialist providers who help us run AgedCareWise \u2014 each described in our Privacy Policy \u2014 or where the law requires it."
    },
    {
        icon: (0, $eaf5d43eccd19b48$export$2e2bcd8739ae039),
        title: 'Kept only as long as needed',
        body: "If your access ends, your information is locked away \u2014 not deleted \u2014 so you can pick up where you left off if you return. Advice records must be kept for 7 years by law; we\u2019re upfront about that."
    },
    {
        icon: (0, $fb2238e39ffa2776$export$2e2bcd8739ae039),
        title: 'If something ever goes wrong',
        body: "In the unlikely event of a data breach that could cause you harm, we\u2019ll tell you and the privacy regulator promptly, plainly, and with clear steps \u2014 as the Notifiable Data Breaches scheme requires."
    }
];
const $c64b4fe17d116bf7$var$RIGHTS = [
    "Download a copy of your account and planning information, any time, from your account settings \u2014 and ask us for anything else we hold about you.",
    "Ask us to correct anything that\u2019s wrong.",
    "Ask us to delete your information when you no longer need the service (advice records the law requires us to keep are the one exception \u2014 we\u2019ll tell you exactly what and why).",
    "Complain \u2014 first to us, and if you\u2019re not satisfied, to the Office of the Australian Information Commissioner (OAIC)."
];
const $c64b4fe17d116bf7$var$PrivacyPage = ({ onBack: onBack, onOpenSecurity: onOpenSecurity })=>{
    const [viewDoc, setViewDoc] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen bg-slate-50",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "sticky top-0 z-10 border-b border-gray-200 bg-white/90 backdrop-blur",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mx-auto flex max-w-5xl items-center justify-between px-5 py-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            onClick: onBack,
                            className: "inline-flex items-center gap-1.5 rounded-lg px-2 py-1.5 text-sm font-medium text-gray-600 transition hover:bg-gray-100 hover:text-gray-900",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                    size: 16
                                }),
                                " Back"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-lg font-bold",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-slate-900",
                                    children: "AgedCare"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-[#17b8e0]",
                                    children: "Wise"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative overflow-hidden bg-gradient-to-br from-[#1a6fd4] to-[#17b8e0] text-white",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "pointer-events-none absolute -right-16 -top-20 h-64 w-64 rounded-full bg-white/10 blur-3xl"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "pointer-events-none absolute -left-10 bottom-0 h-48 w-48 rounded-full bg-white/5 blur-2xl"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative mx-auto max-w-5xl px-5 py-14 text-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/25 backdrop-blur",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a9bbf84fd0f8247$export$2e2bcd8739ae039), {
                                    className: "h-8 w-8"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-3xl font-bold sm:text-4xl",
                                children: "Your privacy"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mx-auto mt-3 max-w-2xl text-base text-white/90 sm:text-lg",
                                children: "Planning for aged care means sharing personal things. Here\u2019s exactly what we collect, what we do with it, and the control you keep \u2014 no legal maze."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-6 flex flex-wrap justify-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>setViewDoc((0, $23065750a32ab3de$export$ecf6508459835aaf)),
                                        className: "inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-[#1a6fd4] shadow-md transition hover:shadow-lg",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a9bbf84fd0f8247$export$2e2bcd8739ae039), {
                                                size: 16
                                            }),
                                            " Read the full Privacy Policy"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>setViewDoc((0, $296111d41e630adc$export$8f93e283f379672f)),
                                        className: "inline-flex items-center gap-2 rounded-full bg-white/15 px-5 py-2.5 text-sm font-semibold text-white ring-1 ring-white/30 transition hover:bg-white/25",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3739d64fb7ddfae6$export$2e2bcd8739ae039), {
                                                size: 16
                                            }),
                                            " How we handle your information"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mx-auto max-w-5xl px-5 py-12 space-y-12",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "grid gap-5 sm:grid-cols-2 lg:grid-cols-3",
                        children: $c64b4fe17d116bf7$var$PROMISES.map(({ icon: Icon, title: title, body: body })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "rounded-2xl border border-gray-200 bg-white p-6 shadow-sm transition hover:shadow-md",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-blue-50 text-[#1a6fd4]",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                            size: 22
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-base font-bold text-slate-900",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mt-2 text-sm leading-relaxed text-gray-600",
                                        children: body
                                    })
                                ]
                            }, title))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "rounded-2xl border border-gray-200 bg-white p-7 shadow-sm sm:p-9",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-start gap-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-[#1a6fd4]",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d957a6b316cfc10$export$2e2bcd8739ae039), {
                                        size: 24
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            className: "text-xl font-bold text-slate-900",
                                            children: "You stay in control"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "mt-2 text-sm leading-relaxed text-gray-600 sm:text-base",
                                            children: [
                                                "Under Australia\u2019s ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Privacy Act"
                                                }),
                                                " \u2014 and because it\u2019s simply right \u2014 your information belongs to you. At any time you can:"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                            className: "mt-4 space-y-2.5",
                                            children: $c64b4fe17d116bf7$var$RIGHTS.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    className: "flex items-start gap-2.5 text-sm text-gray-700",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                                            size: 17,
                                                            className: "mt-0.5 shrink-0 text-emerald-500"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: item
                                                        })
                                                    ]
                                                }, item))
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "rounded-2xl border border-gray-200 bg-white p-7 shadow-sm sm:p-9",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-start gap-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-[#1a6fd4]",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6fe951f3901e9a6$export$2e2bcd8739ae039), {
                                        size: 24
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            className: "text-xl font-bold text-slate-900",
                                            children: "One honest footnote"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "mt-2 text-sm leading-relaxed text-gray-600 sm:text-base",
                                            children: "When we email you (for example, a sign-in code), the email itself is delivered by a trusted provider whose servers may route it outside Australia \u2014 the same way most email works. Only your email address and the message travel that way. Your financial details and your plan are stored only in Australia, and our formal Privacy Policy lists every service provider we use and where they operate."
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "rounded-2xl border border-gray-200 bg-white p-7 shadow-sm sm:p-9",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-start gap-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-[#1a6fd4]",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                        size: 24
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            className: "text-xl font-bold text-slate-900",
                                            children: "How we protect it"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "mt-2 text-sm leading-relaxed text-gray-600 sm:text-base",
                                            children: "Bank-grade encryption, strict walls between every client\u2019s information, two-factor login, and independent security testing \u2014 the full picture is on our Security page."
                                        }),
                                        onOpenSecurity && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            onClick: onOpenSecurity,
                                            className: "mt-4 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#1a6fd4] to-[#17b8e0] px-5 py-2.5 text-sm font-semibold text-white shadow-md transition hover:shadow-lg",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                                    size: 16
                                                }),
                                                " See how we keep it safe"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "rounded-2xl bg-gradient-to-br from-slate-900 to-slate-700 p-7 text-center text-white sm:p-9",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mx-auto mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-white/10 ring-1 ring-white/20",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a9bbf84fd0f8247$export$2e2bcd8739ae039), {
                                    size: 20
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-lg font-bold sm:text-xl",
                                children: "Questions about your privacy?"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mx-auto mt-2 max-w-xl text-sm leading-relaxed text-white/80",
                                children: [
                                    "Write to us at ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-semibold text-white",
                                        children: "privacy@agedcarewise.com.au"
                                    }),
                                    " and a person \u2014 not a bot \u2014 will get back to you."
                                ]
                            })
                        ]
                    })
                ]
            }),
            viewDoc && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1cc4e5852e6af25$export$2e2bcd8739ae039), {
                doc: viewDoc,
                onClose: ()=>setViewDoc(null)
            })
        ]
    });
};
var $c64b4fe17d116bf7$export$2e2bcd8739ae039 = $c64b4fe17d116bf7$var$PrivacyPage;


/**
 * CostPage — public pricing for BOTH audiences, reachable from the landing-page "The Cost" nav
 * link. Sales-oriented: sell the value, keep the numbers honest (they mirror the live paywalls —
 * consumer $480 / 4 months in Paywall.js; partner $800+GST annual or $336+GST per client in
 * PartnerSubscribe.js). Positioning rule: consumers CAN see partner pricing here, so partner
 * rates are framed as practice/scale pricing for licensed professionals who bring their own
 * advice service — never as "the same thing cheaper".
 */ 
parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5afa39945382809a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
            key: "3c2336"
        }
    ],
    [
        "path",
        {
            d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8",
            key: "1h4pet"
        }
    ],
    [
        "path",
        {
            d: "M12 18V6",
            key: "zqpxq5"
        }
    ]
];
const $5afa39945382809a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("badge-dollar-sign", $5afa39945382809a$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7c62dd403424a2a8$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 14v2.2l1.6 1",
            key: "fo4ql5"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "path",
        {
            d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5",
            key: "1osxxc"
        }
    ],
    [
        "path",
        {
            d: "M3 10h5",
            key: "r794hk"
        }
    ],
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "circle",
        {
            cx: "16",
            cy: "16",
            r: "6",
            key: "qoo3c4"
        }
    ]
];
const $7c62dd403424a2a8$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("calendar-clock", $7c62dd403424a2a8$export$3efd853dbb351e94);


const $491b4022863a0e84$var$CONSUMER_INCLUDED = [
    "Every living arrangement modelled \u2014 staying home with support, residential care, retirement villages, granny flats, downsizing",
    "Your real numbers: care fees, cashflow, Age Pension and what\u2019s left to your estate, projected over time",
    "The Suggestion Engine \u2014 hundreds of strategy combinations searched and ranked for your situation",
    'A professional Statement of Advice you can keep and share',
    'AWise, your AI guide, on every screen',
    "Everything saved securely \u2014 leave and pick up where you stopped, as often as you like"
];
const $491b4022863a0e84$var$VALUE_POINTS = [
    {
        icon: (0, $c9921f4f81a419f0$export$2e2bcd8739ae039),
        title: 'Decisions worth tens of thousands',
        body: "Paying for a room with a lump sum or daily fee, keeping or selling the home, timing the move \u2014 the gap between a good and poor choice is often life-changing money. This is not a decision to guess."
    },
    {
        icon: (0, $5afa39945382809a$export$2e2bcd8739ae039),
        title: 'A fraction of bespoke advice',
        body: "Specialist aged-care financial advice is valuable \u2014 and typically costs thousands. AgedCareWise puts the same calculations and strategy thinking in your hands for one flat, upfront price."
    },
    {
        icon: (0, $7c62dd403424a2a8$export$2e2bcd8739ae039),
        title: 'One payment. No surprises.',
        body: "One payment covers four full months \u2014 enough time to explore, decide, and act. No subscription, no auto-renewal, no card kept on file. If you come back later, your information is waiting."
    }
];
const $491b4022863a0e84$var$PARTNER_POINTS_ANNUAL = [
    'Up to 20 active clients included',
    'Then just $70 + GST per additional client',
    'The full client experience, under your guidance'
];
const $491b4022863a0e84$var$PARTNER_POINTS_PAYG = [
    'Pay only for the clients you take on',
    'No annual commitment',
    'Switch to the annual plan any time'
];
const $491b4022863a0e84$var$CostPage = ({ onBack: onBack, onGetStarted: onGetStarted, onBecomePartner: onBecomePartner })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen bg-slate-50",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "sticky top-0 z-10 border-b border-gray-200 bg-white/90 backdrop-blur",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mx-auto flex max-w-5xl items-center justify-between px-5 py-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            onClick: onBack,
                            className: "inline-flex items-center gap-1.5 rounded-lg px-2 py-1.5 text-sm font-medium text-gray-600 transition hover:bg-gray-100 hover:text-gray-900",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                    size: 16
                                }),
                                " Back"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-lg font-bold",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-slate-900",
                                    children: "AgedCare"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-[#17b8e0]",
                                    children: "Wise"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative overflow-hidden bg-gradient-to-br from-[#1a6fd4] to-[#17b8e0] text-white",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "pointer-events-none absolute -right-16 -top-20 h-64 w-64 rounded-full bg-white/10 blur-3xl"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "pointer-events-none absolute -left-10 bottom-0 h-48 w-48 rounded-full bg-white/5 blur-2xl"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative mx-auto max-w-5xl px-5 py-14 text-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/25 backdrop-blur",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5afa39945382809a$export$2e2bcd8739ae039), {
                                    className: "h-8 w-8"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-3xl font-bold sm:text-4xl",
                                children: "Clear, honest pricing"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mx-auto mt-3 max-w-2xl text-base text-white/90 sm:text-lg",
                                children: "One upfront price. Everything included. Whether you\u2019re planning for your own family or you\u2019re a professional guiding many \u2014 here\u2019s exactly what it costs."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mx-auto max-w-5xl px-5 py-12 space-y-14",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "grid gap-5 sm:grid-cols-3",
                        children: $491b4022863a0e84$var$VALUE_POINTS.map(({ icon: Icon, title: title, body: body })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "rounded-2xl border border-gray-200 bg-white p-6 shadow-sm transition hover:shadow-md",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-blue-50 text-[#1a6fd4]",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                            size: 22
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-base font-bold text-slate-900",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mt-2 text-sm leading-relaxed text-gray-600",
                                        children: body
                                    })
                                ]
                            }, title))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        "aria-labelledby": "cost-families",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mb-6 text-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        id: "cost-families",
                                        className: "text-2xl font-bold text-slate-900",
                                        children: "For you and your family"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mt-1.5 text-gray-600",
                                        children: "Complete planning power, for one flat price."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mx-auto max-w-3xl overflow-hidden rounded-3xl border border-blue-100 bg-white shadow-xl shadow-blue-100/60",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "relative overflow-hidden bg-gradient-to-br from-[#1a6fd4] to-[#17b8e0] px-7 py-8 text-center text-white",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "pointer-events-none absolute -right-10 -top-14 h-44 w-44 rounded-full bg-white/10 blur-2xl"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "text-sm font-semibold uppercase tracking-wider text-white/80",
                                                        children: "Everything included"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mt-2 flex items-end justify-center gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-5xl font-bold",
                                                                children: "$480"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "pb-1.5 text-white/90",
                                                                children: "for 4 months of full access"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "mt-2 text-sm text-white/85",
                                                        children: "One payment \xb7 No subscription \xb7 No auto-renewal"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "p-7 sm:p-9",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                className: "space-y-3",
                                                children: $491b4022863a0e84$var$CONSUMER_INCLUDED.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                        className: "flex items-start gap-2.5 text-sm text-gray-700 sm:text-base",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                                                size: 18,
                                                                className: "mt-0.5 shrink-0 text-emerald-500"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: item
                                                            })
                                                        ]
                                                    }, item))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mt-7 flex flex-col items-center gap-3",
                                                children: [
                                                    onGetStarted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        onClick: onGetStarted,
                                                        className: "inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#1a6fd4] to-[#17b8e0] px-8 py-3 text-base font-semibold text-white shadow-lg transition hover:shadow-xl",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                                                                size: 18
                                                            }),
                                                            " Get Started"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex items-center gap-2 text-xs text-gray-500",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e20ffdae2aa9b33f$export$2e2bcd8739ae039), {
                                                                size: 13
                                                            }),
                                                            "Secure payment by Stripe \xb7 Your card details never touch our servers"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mx-auto mt-4 max-w-2xl text-center text-sm text-gray-500",
                                children: "After 4 months your account locks but nothing is deleted \u2014 your plan is kept safe, and one payment reopens everything exactly where you left it."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        "aria-labelledby": "cost-partners",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mb-6 text-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        id: "cost-partners",
                                        className: "text-2xl font-bold text-slate-900",
                                        children: "For professionals & providers"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mx-auto mt-1.5 max-w-2xl text-gray-600",
                                        children: "Accountants, financial advisers, aged-care and home-care providers, and retirement-living operators use AgedCareWise to guide many families \u2014 with their own expertise and service wrapped around it. Practice pricing reflects that scale."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mx-auto grid max-w-4xl gap-5 sm:grid-cols-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "relative overflow-hidden rounded-3xl border-2 border-[#1a6fd4]/30 bg-white p-7 shadow-lg",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "absolute right-4 top-4 rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold text-[#1a6fd4]",
                                                children: "Best value"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-blue-50 text-[#1a6fd4]",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3e517ec92034a$export$2e2bcd8739ae039), {
                                                    size: 22
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-lg font-bold text-slate-900",
                                                children: "Annual practice plan"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mt-2 flex items-end gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-3xl font-bold text-slate-900",
                                                        children: "$800"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "pb-1 text-sm text-gray-500",
                                                        children: "+ GST per year"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                className: "mt-4 space-y-2.5",
                                                children: $491b4022863a0e84$var$PARTNER_POINTS_ANNUAL.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                        className: "flex items-start gap-2.5 text-sm text-gray-700",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                                                size: 16,
                                                                className: "mt-0.5 shrink-0 text-emerald-500"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: item
                                                            })
                                                        ]
                                                    }, item))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "rounded-3xl border border-gray-200 bg-white p-7 shadow-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-blue-50 text-[#1a6fd4]",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                                    size: 22
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-lg font-bold text-slate-900",
                                                children: "Pay per client"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mt-2 flex items-end gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-3xl font-bold text-slate-900",
                                                        children: "$336"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "pb-1 text-sm text-gray-500",
                                                        children: "+ GST per client"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                className: "mt-4 space-y-2.5",
                                                children: $491b4022863a0e84$var$PARTNER_POINTS_PAYG.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                        className: "flex items-start gap-2.5 text-sm text-gray-700",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                                                size: 16,
                                                                className: "mt-0.5 shrink-0 text-emerald-500"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: item
                                                            })
                                                        ]
                                                    }, item))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-6 text-center",
                                children: [
                                    onBecomePartner && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: onBecomePartner,
                                        className: "inline-flex items-center gap-2 rounded-full border-2 border-[#1a6fd4] px-7 py-2.5 text-sm font-semibold text-[#1a6fd4] transition hover:bg-blue-50",
                                        children: [
                                            "Become a partner ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                size: 16
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mx-auto mt-3 max-w-xl text-xs text-gray-500",
                                        children: "Partner plans licence the software to your firm. You provide your advice service to your clients under your own arrangements \u2014 your clients never pay AgedCareWise."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "rounded-2xl border border-gray-200 bg-white p-7 shadow-sm sm:p-9",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-start gap-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-[#1a6fd4]",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                        size: 24
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            className: "text-xl font-bold text-slate-900",
                                            children: "What\u2019s behind the price"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "mt-2 text-sm leading-relaxed text-gray-600 sm:text-base",
                                            children: "AgedCareWise was built by advisers on the real, current Australian rules \u2014 means testing, Age Pension, care fees, the lot \u2014 and it\u2019s kept up to date as the rules change. Your price includes the modelling engine, the strategy search, your Statement of Advice, the AWise assistant, and bank-grade protection of everything you enter."
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "rounded-2xl bg-gradient-to-br from-slate-900 to-slate-700 p-7 text-center text-white sm:p-9",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mx-auto mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-white/10 ring-1 ring-white/20",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8afc40d49a7e79bf$export$2e2bcd8739ae039), {
                                    size: 20
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-lg font-bold sm:text-xl",
                                children: "Not sure yet?"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mx-auto mt-2 max-w-xl text-sm leading-relaxed text-white/80",
                                children: "Explore the free education topics and ask AWise your questions right from the home page \u2014 then step inside when you\u2019re ready."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mx-auto mt-3 flex items-center justify-center gap-2 text-xs text-white/60",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                        size: 14
                                    }),
                                    " Prices shown for individuals include GST. Partner prices exclude GST."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $491b4022863a0e84$export$2e2bcd8739ae039 = $491b4022863a0e84$var$CostPage;


/**
 * FaqPage — public FAQs from the landing-page nav, split into the two audiences (families /
 * professionals & providers). Answers must stay true to what's actually built and priced —
 * pricing mirrors the paywalls, the Xplan answer promises a roadmap (not a feature), and the
 * SOA-scope answer states the strategic-advice boundary the owner set (no portfolio/fund
 * selection; advisers can issue their own limited-scope SOA for fund adjustments).
 */ 

var $acw62 = parcelRequire("acw62");

const $c90e7468b758bca1$var$CLIENT_FAQS = [
    {
        q: 'What does it cost?',
        a: "$480 including GST for 4 months of full access \u2014 one payment, no subscription, no auto-renewal, and we don\u2019t keep your card on file. Everything is included: every living arrangement, the Suggestion Engine, your Statement of Advice, and the AWise assistant. The Cost page has the full breakdown."
    },
    {
        q: 'What happens when my 4 months end?',
        a: "Your account locks, but nothing is deleted \u2014 your plan and information are kept safe. If you come back next month or next year, one payment reopens everything exactly where you left it. You never start again from scratch."
    },
    {
        q: 'Is this real financial advice, or just a calculator?',
        a: "It\u2019s much more than a calculator. Everything is modelled on your actual situation \u2014 your home, savings, pension and goals \u2014 and the result is a personal plan with a Statement of Advice, produced under Australian financial services licensing arrangements. Calculators give you a number; AgedCareWise gives you a strategy and shows its working."
    },
    {
        q: 'Do I still need a financial adviser?',
        a: "Many people complete their whole plan on their own \u2014 that\u2019s what AgedCareWise is designed for. If you already work with an adviser or accountant, they may be an AgedCareWise partner and can work with you right inside the tool. And if part of your situation needs help beyond what guided modelling can properly cover, we\u2019ll tell you rather than guess."
    },
    {
        q: 'Which living situations does it cover?',
        a: 'All the big ones: staying at home with Support at Home, residential aged care, retirement villages, granny flat arrangements, and downsizing. You can model several side by side and compare what each means for your money, your pension and your estate.'
    },
    {
        q: "We\u2019re a couple \u2014 can it handle both of us?",
        a: "Yes \u2014 couples are a core strength, including the hardest scenario: when one of you needs care and the other stays home. AgedCareWise applies the special couple rules (like Centrelink\u2019s more generous treatment of couples separated by illness) automatically."
    },
    {
        q: 'How long does it take?',
        a: "About ten minutes to tell us your story. After that, explore as much as you like \u2014 everything saves automatically, so you can leave and pick up exactly where you stopped, as often as you want, for your full 4 months."
    },
    {
        q: 'Is my information safe?',
        a: 'Your details are stored in Australia, protected with bank-grade encryption, and never sold or used for advertising. You can download everything we hold about you, or ask us to delete it, at any time. The Security and Privacy pages explain how.'
    },
    {
        q: "What if the rules change while I\u2019m planning?",
        a: "Aged-care and pension rules are updated regularly (many rates change every March and September). We keep the modelling current with the Australian rules in force, so your plan reflects today\u2019s law \u2014 not last year\u2019s."
    }
];
const $c90e7468b758bca1$var$PARTNER_FAQS = [
    {
        q: 'Who is providing the advice to the client?',
        a: "It depends on who you are. Financial advisers advise under their own AFSL \u2014 AgedCareWise is your modelling and SOA engine, and the advice is yours. Other partners (accountants, aged-care and home-care providers, retirement-living operators) aren\u2019t giving financial advice at all: you simply provide your clients access to the tool, and the advice is provided by AgedCareWise under its licensing arrangements."
    },
    {
        q: 'What does it cost the firm?',
        a: "Two options: $800 + GST per year including 20 activated clients (then $70 + GST per extra client), or pay-as-you-go at $336 + GST per client with no annual commitment. Your clients never pay AgedCareWise, and we never take a share of the fees you charge them \u2014 how you price your service is entirely yours."
    },
    {
        q: 'Does it integrate with Xplan or other planning software?',
        a: "AgedCareWise runs alongside your existing stack today \u2014 client files and Statements of Advice export cleanly for your records and file notes. Direct practice-software integrations, including Xplan, are on our roadmap and will be prioritised by partner demand, so tell us what your workflow needs."
    },
    {
        q: 'Can we white-label or co-brand it?',
        a: "Your firm is front and centre in the client experience today: your practice\u2019s identity carries through the portal, and every Statement of Advice is attributed to the adviser and licence that produced it. Deeper co-branding and full white-label arrangements are available by agreement \u2014 talk to us."
    },
    {
        q: "What does the Statement of Advice cover \u2014 and what doesn\u2019t it?",
        a: "The SOA covers the strategic decision: the living arrangement, how to fund it, means-testing and Age Pension impacts, cashflow and estate outcomes, and the recommended strategy \u2014 including which assets to draw on or sell down, driven by income, growth and capital-gains-tax assumptions rather than specific product features. It deliberately does not provide portfolio construction advice. Advisers who need to adjust underlying investments as part of the strategy can issue their own limited-scope SOA for those changes alongside ours."
    },
    {
        q: "How much of the journey do we control \u2014 can clients self-serve?",
        a: "That\u2019s up to you \u2014 the tool is designed for different practice models and skill sets. Fully self-directed: send the invite link and your client (or their family) completes the whole journey themselves. Hybrid: have the client complete just the fact-find in their own time, then you take over the modelling together in a meeting. Full control: run everything in the room \u2014 and if you\u2019d rather own the narrative yourself, simply close the Insight panel and the tool stays quiet while you do the explaining."
    },
    {
        q: 'How does inviting clients work?',
        a: "One click creates a secure, one-time invitation link. Your client signs in with their own private login and tells their story in their own time \u2014 and you track every file in your workspace: invited, in progress, plan ready. Prefer to sit together? You can also create and complete files with the client in the room."
    },
    {
        q: "We\u2019re an aged-care or home-care provider, not an adviser \u2014 is this for us?",
        a: "Very much so. Providers and retirement-living operators use AgedCareWise to give families clear, personal answers on funding a decision they\u2019re often facing for the first time \u2014 which means faster, more confident decisions. You provide the access; the advice is provided by AgedCareWise."
    },
    {
        q: "How is our client data protected \u2014 including from other firms?",
        a: 'Strict tenant isolation is enforced by the server, not the screen: your firm can only ever see its own clients, and no other firm can ever see yours. Firm logins require two-factor authentication, every important action lands on a tamper-evident audit trail, and everything is stored encrypted in Australia.'
    },
    {
        q: 'Is there a free trial for firms?',
        a: "No \u2014 and that\u2019s deliberate: the tool delivers real, licensed advice value from the first client. The Experience page gives you a genuine tour of the full journey, and the pay-as-you-go option means you can start with a single client for $336 + GST and scale to the annual plan when it earns its keep."
    }
];
const $c90e7468b758bca1$var$FaqItem = ({ q: q, a: a })=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm transition hover:shadow-md",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: ()=>setOpen((o)=>!o),
                "aria-expanded": open,
                className: "flex w-full items-center justify-between gap-4 px-5 py-4 text-left",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-sm font-semibold text-slate-900 sm:text-base",
                        children: q
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                        size: 18,
                        className: `shrink-0 text-[#1a6fd4] transition-transform duration-300 ${open ? 'rotate-180' : ''}`
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "px-5 pb-5 text-sm leading-relaxed text-gray-600",
                children: a
            })
        ]
    });
};
const $c90e7468b758bca1$var$FaqSection = ({ icon: Icon, title: title, subtitle: subtitle, faqs: faqs })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-5 flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex h-11 w-11 items-center justify-center rounded-xl bg-blue-50 text-[#1a6fd4]",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                            size: 22
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-xl font-bold text-slate-900",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-gray-500",
                                children: subtitle
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "space-y-3",
                children: faqs.map((f)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c90e7468b758bca1$var$FaqItem, {
                        ...f
                    }, f.q))
            })
        ]
    });
const $c90e7468b758bca1$var$FaqPage = ({ onBack: onBack, onGetStarted: onGetStarted, onBecomePartner: onBecomePartner })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen bg-slate-50",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "sticky top-0 z-10 border-b border-gray-200 bg-white/90 backdrop-blur",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mx-auto flex max-w-5xl items-center justify-between px-5 py-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            onClick: onBack,
                            className: "inline-flex items-center gap-1.5 rounded-lg px-2 py-1.5 text-sm font-medium text-gray-600 transition hover:bg-gray-100 hover:text-gray-900",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                    size: 16
                                }),
                                " Back"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-lg font-bold",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-slate-900",
                                    children: "AgedCare"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-[#17b8e0]",
                                    children: "Wise"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative overflow-hidden bg-gradient-to-br from-[#1a6fd4] to-[#17b8e0] text-white",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "pointer-events-none absolute -right-16 -top-20 h-64 w-64 rounded-full bg-white/10 blur-3xl"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "pointer-events-none absolute -left-10 bottom-0 h-48 w-48 rounded-full bg-white/5 blur-2xl"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative mx-auto max-w-5xl px-5 py-14 text-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/25 backdrop-blur",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c00fae44777e2393$export$2e2bcd8739ae039), {
                                    className: "h-8 w-8"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-3xl font-bold sm:text-4xl",
                                children: "Questions, answered"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mx-auto mt-3 max-w-2xl text-base text-white/90 sm:text-lg",
                                children: "The things families and professionals ask us most \u2014 answered straight, in plain English."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mx-auto max-w-3xl space-y-14 px-5 py-12",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c90e7468b758bca1$var$FaqSection, {
                        icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
                        title: "For you and your family",
                        subtitle: "Planning your own, or a parent\u2019s, next chapter",
                        faqs: $c90e7468b758bca1$var$CLIENT_FAQS
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c90e7468b758bca1$var$FaqSection, {
                        icon: (0, $34c3e517ec92034a$export$2e2bcd8739ae039),
                        title: "For professionals & providers",
                        subtitle: "Advisers, accountants, care providers and retirement-living operators",
                        faqs: $c90e7468b758bca1$var$PARTNER_FAQS
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "rounded-2xl bg-gradient-to-br from-slate-900 to-slate-700 p-7 text-center text-white sm:p-9",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-lg font-bold sm:text-xl",
                                children: "Didn\u2019t find your question?"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mx-auto mt-2 max-w-xl text-sm leading-relaxed text-white/80",
                                children: "Ask AWise on the home page \u2014 or just step inside and see for yourself."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-5 flex flex-wrap items-center justify-center gap-3",
                                children: [
                                    onGetStarted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: onGetStarted,
                                        className: "inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#1a6fd4] to-[#17b8e0] px-7 py-3 text-sm font-semibold text-white shadow-lg transition hover:shadow-xl",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                                                size: 16
                                            }),
                                            " Get Started"
                                        ]
                                    }),
                                    onBecomePartner && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: onBecomePartner,
                                        className: "inline-flex items-center gap-2 rounded-full border border-white/40 px-7 py-3 text-sm font-semibold text-white transition hover:bg-white/10",
                                        children: [
                                            "For partners & providers ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                                size: 16
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $c90e7468b758bca1$export$2e2bcd8739ae039 = $c90e7468b758bca1$var$FaqPage;


/**
 * ExperiencePage — "The Experience": the interactive pre-purchase showcase reachable from the
 * landing-page nav. There is no free trial, so this page carries the conversion load: seven short
 * chapters, each with a LIVE ANIMATED mock of the real product. Chapter 1 is interactive — the
 * visitor picks a living arrangement and the mock fact-find + results re-curate to it (owner
 * feedback 10 Jul: don't let the tour read as aged-care-only). All visuals are built in-code —
 * no video assets required; a produced walkthrough video can become an extra chapter later.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9b547c0f28739ad4$export$3efd853dbb351e94 = [
    [
        "polygon",
        {
            points: "6 3 20 12 6 21 6 3",
            key: "1oa8hb"
        }
    ]
];
const $9b547c0f28739ad4$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("play", $9b547c0f28739ad4$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $527b9d2547be6d0a$export$3efd853dbb351e94 = [
    [
        "line",
        {
            x1: "21",
            x2: "14",
            y1: "4",
            y2: "4",
            key: "obuewd"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "3",
            y1: "4",
            y2: "4",
            key: "1q6298"
        }
    ],
    [
        "line",
        {
            x1: "21",
            x2: "12",
            y1: "12",
            y2: "12",
            key: "1iu8h1"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "3",
            y1: "12",
            y2: "12",
            key: "ntss68"
        }
    ],
    [
        "line",
        {
            x1: "21",
            x2: "16",
            y1: "20",
            y2: "20",
            key: "14d8ph"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "3",
            y1: "20",
            y2: "20",
            key: "m0wm8r"
        }
    ],
    [
        "line",
        {
            x1: "14",
            x2: "14",
            y1: "2",
            y2: "6",
            key: "14e1ph"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "8",
            y1: "10",
            y2: "14",
            key: "1i6ji0"
        }
    ],
    [
        "line",
        {
            x1: "16",
            x2: "16",
            y1: "18",
            y2: "22",
            key: "1lctlv"
        }
    ]
];
const $527b9d2547be6d0a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("sliders-horizontal", $527b9d2547be6d0a$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $993a4e0d8b7d2457$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 14.66v1.626a2 2 0 0 1-.976 1.696A5 5 0 0 0 7 21.978",
            key: "1n3hpd"
        }
    ],
    [
        "path",
        {
            d: "M14 14.66v1.626a2 2 0 0 0 .976 1.696A5 5 0 0 1 17 21.978",
            key: "rfe1zi"
        }
    ],
    [
        "path",
        {
            d: "M18 9h1.5a1 1 0 0 0 0-5H18",
            key: "7xy6bh"
        }
    ],
    [
        "path",
        {
            d: "M4 22h16",
            key: "57wxv0"
        }
    ],
    [
        "path",
        {
            d: "M6 9a6 6 0 0 0 12 0V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1z",
            key: "1mhfuq"
        }
    ],
    [
        "path",
        {
            d: "M6 9H4.5a1 1 0 0 1 0-5H6",
            key: "tex48p"
        }
    ]
];
const $993a4e0d8b7d2457$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("trophy", $993a4e0d8b7d2457$export$3efd853dbb351e94);


/* ---------- animation utilities ---------- */ /** Count from 0 to target over `duration` ms, restarting whenever `replayKey` changes. */ function $ecca3e63fd9dabf8$var$useCountUp(target, duration = 1400, replayKey = 0, delay = 0) {
    const [value, setValue] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        let raf;
        let start;
        setValue(0);
        const tick = (now)=>{
            if (start === undefined) start = now + delay;
            const elapsed = now - start;
            if (elapsed < 0) {
                raf = requestAnimationFrame(tick);
                return;
            }
            const t = Math.min(1, elapsed / duration);
            const eased = 1 - Math.pow(1 - t, 3);
            setValue(Math.round(target * eased));
            if (t < 1) raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return ()=>cancelAnimationFrame(raf);
    }, [
        target,
        duration,
        replayKey,
        delay
    ]);
    return value;
}
const $ecca3e63fd9dabf8$var$aud = (n)=>'$' + n.toLocaleString('en-AU');
/** Reveal children one-by-one with a stagger, restarting on replayKey change. */ const $ecca3e63fd9dabf8$var$Stagger = ({ replayKey: replayKey, step: step = 450, children: children })=>{
    const items = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children);
    const [shown, setShown] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        setShown(0);
        const timers = items.map((_, i)=>setTimeout(()=>setShown((s)=>Math.max(s, i + 1)), 300 + i * step));
        return ()=>timers.forEach(clearTimeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        replayKey,
        step,
        items.length
    ]);
    return items.map((child, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "transition-all duration-500",
            style: {
                opacity: i < shown ? 1 : 0,
                transform: i < shown ? 'translateY(0)' : 'translateY(10px)'
            },
            children: child
        }, i));
};
const $ecca3e63fd9dabf8$export$f676c05811fdd915 = [
    {
        key: 'aged_care',
        label: 'Aged care'
    },
    {
        key: 'home_care',
        label: 'Support at home'
    },
    {
        key: 'village',
        label: 'Retirement village'
    },
    {
        key: 'granny_flat',
        label: 'Granny flat'
    },
    {
        key: 'downsize',
        label: 'Downsizing'
    }
];
const $ecca3e63fd9dabf8$var$CURATED = {
    aged_care: {
        tag: 'Residential aged care',
        story: [
            {
                label: 'The family home',
                value: "Owned \xb7 valued at $950,000"
            },
            {
                label: 'Savings & investments',
                value: "$380,000 \xb7 full Age Pension"
            }
        ],
        banner: "We\u2019ll model keeping, renting or selling the home \u2014 and who stays in it",
        results: [
            {
                label: 'Room price (RAD)',
                target: 550000,
                tone: 'text-[#1a6fd4]'
            },
            {
                label: 'Age Pension / yr',
                target: 29874,
                tone: 'text-emerald-600'
            },
            {
                label: 'Care fees / yr',
                target: 38915,
                tone: 'text-slate-800'
            }
        ],
        strategies: {
            searched: 327,
            metric: 'Estate after 10 years',
            top: {
                title: 'Keep the home & rent it, pay part-RAD',
                target: 1284000
            },
            alt: {
                title: 'Sell the home, pay full RAD',
                target: 1121000
            },
            punchline: [
                'A ',
                '$163,000',
                " difference \u2014 found in seconds, explained in plain English."
            ]
        },
        manual: {
            metrics: [
                'Estate after 10 years',
                'Age Pension / yr'
            ],
            a: {
                label: 'Keep & rent the home',
                values: [
                    1284000,
                    29874
                ],
                insight: "Keeping the home holds onto an asset that keeps growing, and the rent helps cover the daily accommodation payment \u2014 though rent does count as income. For Margaret, this path leaves the larger estate."
            },
            b: {
                label: 'Sell the home',
                values: [
                    1121000,
                    22350
                ],
                insight: "Selling pays the room in full \u2014 simpler, nothing owing daily \u2014 but the sale proceeds now count in the means test, so the pension falls. Simplicity has a price: a smaller estate over 10 years."
            }
        },
        awise: {
            q: "What happens to Mum\u2019s pension if she keeps the house?",
            a: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "Great question. While your mum is in care, her former home is treated specially \u2014 and if a",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: " protected person"
                    }),
                    " (like her partner) still lives there, it stays out of the aged care means test entirely. Your model on the next screen shows both cases\u2026"
                ]
            })
        }
    },
    home_care: {
        tag: 'Support at Home',
        story: [
            {
                label: 'Staying at home',
                value: "Support at Home \xb7 own home"
            },
            {
                label: 'Savings & investments',
                value: "$380,000 \xb7 full Age Pension"
            }
        ],
        banner: "We\u2019ll fit the right services inside your funding budget \u2014 and model your contributions",
        results: [
            {
                label: 'Govt funding / yr',
                target: 52000,
                tone: 'text-[#1a6fd4]'
            },
            {
                label: 'Your contribution / yr',
                target: 6400,
                tone: 'text-slate-800'
            },
            {
                label: 'Age Pension / yr',
                target: 29874,
                tone: 'text-emerald-600'
            }
        ],
        strategies: {
            searched: 214,
            metric: 'Out of pocket / yr',
            top: {
                title: "Curated service mix \u2014 care hours, cleaning, transport \u2014 inside the budget",
                target: 4900
            },
            alt: {
                title: 'Wish-list services, self-funded top-ups',
                target: 12300
            },
            punchline: [
                '',
                '$7,400 a year',
                " back in your pocket \u2014 the same care priorities, a smarter service mix."
            ]
        },
        manual: {
            metrics: [
                'Out of pocket / yr',
                'Care hours / week'
            ],
            a: {
                label: 'Essential services',
                values: [
                    4900,
                    9
                ],
                insight: "Your chosen services sit comfortably inside the government funding level, with room to spare. The panel prices every service line as you add it \u2014 so you always know what fits."
            },
            b: {
                label: 'Add gardening + social support',
                values: [
                    8200,
                    12
                ],
                insight: "The extra services push past the funded budget, so the difference is self-funded. The panel shows exactly what each added hour costs you \u2014 trade-offs made visible, before you commit."
            }
        },
        awise: {
            q: 'Can we add more help at home without blowing the budget?',
            a: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "Often, yes. Your Support at Home budget covers a set amount each year \u2014 the tool shows what your chosen services cost against it, and where a ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "different service mix"
                    }),
                    " (or a small self-funded top-up) gets you more of the help that matters most."
                ]
            })
        }
    },
    village: {
        tag: 'Retirement village',
        story: [
            {
                label: 'The village',
                value: "Entry price $650,000 \xb7 lease/licence"
            },
            {
                label: 'Savings & investments',
                value: "$380,000 \xb7 full Age Pension"
            }
        ],
        banner: "We\u2019ll model the entry price, exit fees, and your pension either side of the move",
        results: [
            {
                label: 'Entry contribution',
                target: 650000,
                tone: 'text-[#1a6fd4]'
            },
            {
                label: 'Age Pension / yr',
                target: 29874,
                tone: 'text-emerald-600'
            },
            {
                label: 'Exit fee (10 yrs)',
                target: 195000,
                tone: 'text-slate-800'
            }
        ],
        strategies: {
            searched: 186,
            metric: 'Estate after 10 years',
            top: {
                title: 'Lower entry price, standard exit fee',
                target: 1062000
            },
            alt: {
                title: 'Premium entry price, capped exit fee',
                target: 1018000
            },
            punchline: [
                'A ',
                '$44,000',
                " difference \u2014 with the pension impact of each entry price shown before you sign."
            ]
        },
        manual: {
            metrics: [
                'Age Pension / yr',
                'Estate after 10 years'
            ],
            a: {
                label: 'Entry price $650,000',
                values: [
                    29874,
                    1062000
                ],
                insight: "At this entry price Centrelink treats you as a homeowner \u2014 the contribution itself is exempt from the assets test, and your pension holds steady."
            },
            b: {
                label: 'Entry price $220,000',
                values: [
                    33400,
                    1041000
                ],
                insight: "Below the threshold you\u2019re a non-homeowner: the contribution counts in the assets test, but higher limits apply and Rent Assistance can top up your pension. The maths cuts both ways \u2014 so we model it."
            }
        },
        awise: {
            q: 'Do exit fees really matter that much?',
            a: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "They can be the biggest cost of the whole move. A ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "deferred management fee"
                    }),
                    ' ',
                    "quietly grows every year you stay, and some contracts share your capital gain too \u2014 the tool projects what actually comes back to you, and your estate, when you leave."
                ]
            })
        }
    },
    granny_flat: {
        tag: 'Granny flat',
        story: [
            {
                label: 'The arrangement',
                value: "$400,000 toward the kids\u2019 home"
            },
            {
                label: 'Savings & investments',
                value: "$380,000 \xb7 full Age Pension"
            }
        ],
        banner: "We\u2019ll apply Centrelink\u2019s reasonableness test to your contribution as you type",
        results: [
            {
                label: 'Your contribution',
                target: 400000,
                tone: 'text-[#1a6fd4]'
            },
            {
                label: 'Counted as a gift',
                target: 0,
                tone: 'text-emerald-600'
            },
            {
                label: 'Age Pension / yr',
                target: 31200,
                tone: 'text-emerald-600'
            }
        ],
        strategies: {
            searched: 158,
            metric: 'Age Pension / yr',
            top: {
                title: "Contribute at the assessed value \u2014 nothing counts as a gift",
                target: 31200
            },
            alt: {
                title: 'Contribute $100,000 above the assessed value',
                target: 27100
            },
            punchline: [
                'Paying above the assessed value is a ',
                'gift that counts for five years',
                " \u2014 the engine finds the line before you cross it."
            ]
        },
        manual: {
            metrics: [
                'Counted as a gift',
                'Age Pension / yr'
            ],
            a: {
                label: 'Contribute $400,000',
                values: [
                    0,
                    31200
                ],
                insight: "Your contribution sits under Centrelink\u2019s assessed value of the lifetime right \u2014 so none of it is treated as a gift, and your pension is untouched."
            },
            b: {
                label: 'Contribute $520,000',
                values: [
                    90000,
                    27100
                ],
                insight: "The amount above the assessed value is deprivation \u2014 counted as if you still had it, for five years. The panel shows the exact overshoot so the family can set the contribution with confidence."
            }
        },
        awise: {
            q: 'If I help the kids build a granny flat, will I lose my pension?',
            a: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "Not if it\u2019s structured well. Centrelink values your lifetime right to live there using the",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "reasonableness test"
                    }),
                    " \u2014 pay up to that value and nothing is a gift. The tool calculates that value for your family\u2019s numbers and flags the safe range."
                ]
            })
        }
    },
    downsize: {
        tag: 'Downsizing',
        story: [
            {
                label: 'The move',
                value: "Selling $950,000 \xb7 buying $700,000"
            },
            {
                label: 'Savings & investments',
                value: "$380,000 \xb7 full Age Pension"
            }
        ],
        banner: "We\u2019ll model the freed-up capital, super options, and the pension impact",
        results: [
            {
                label: 'Sale proceeds',
                target: 950000,
                tone: 'text-[#1a6fd4]'
            },
            {
                label: 'New home',
                target: 700000,
                tone: 'text-slate-800'
            },
            {
                label: 'Freed to invest',
                target: 250000,
                tone: 'text-emerald-600'
            }
        ],
        strategies: {
            searched: 243,
            metric: 'Estate after 10 years',
            top: {
                title: 'Downsizer contribution to super with the freed-up capital',
                target: 1395000
            },
            alt: {
                title: 'Freed-up capital to the bank',
                target: 1344000
            },
            punchline: [
                'A ',
                '$51,000',
                " difference \u2014 with the pension effect of each path modelled before you list the house."
            ]
        },
        manual: {
            metrics: [
                'Estate after 10 years',
                'Age Pension / yr'
            ],
            a: {
                label: 'Downsizer super contribution',
                values: [
                    1395000,
                    24600
                ],
                insight: "Inside super the money still counts for the means test at pension age \u2014 but tax-effective earnings compound year after year. The panel shows the long-run difference, honestly."
            },
            b: {
                label: 'Keep it in the bank',
                values: [
                    1344000,
                    24600
                ],
                insight: "In the bank the money is deemed to earn income and the interest is taxed. Notice the pension barely moves either way \u2014 it\u2019s the estate line where this decision really shows up."
            }
        },
        awise: {
            q: 'Will downsizing cost me my pension?',
            a: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    "It can, if the freed-up money isn\u2019t planned for \u2014 dollars that were ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "exempt"
                    }),
                    " in your home become ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "assessable"
                    }),
                    " once they\u2019re in the bank. The tool shows the pension impact of the move, and the strategies that soften it, before you commit."
                ]
            })
        }
    }
};
const $ecca3e63fd9dabf8$var$MockWindow = ({ title: title, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl shadow-blue-200/40",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-2 border-b border-slate-100 bg-slate-50 px-4 py-2.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "h-2.5 w-2.5 rounded-full bg-red-300"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "h-2.5 w-2.5 rounded-full bg-amber-300"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "h-2.5 w-2.5 rounded-full bg-emerald-300"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ml-3 text-xs font-medium text-slate-500",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "p-5",
                children: children
            })
        ]
    });
const $ecca3e63fd9dabf8$var$FactFindVisual = ({ replayKey: replayKey, arrangement: arrangement, onArrangement: onArrangement })=>{
    const curated = $ecca3e63fd9dabf8$var$CURATED[arrangement];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ecca3e63fd9dabf8$var$MockWindow, {
        title: "AgedCareWise \u2014 Your story",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-1.5 text-[11px] font-medium uppercase tracking-wide text-slate-400",
                        children: [
                            "What are you exploring? ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "normal-case text-slate-300",
                                children: "(try one)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-wrap gap-1.5",
                        children: $ecca3e63fd9dabf8$export$f676c05811fdd915.map((a)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>onArrangement(a.key),
                                className: `rounded-full px-3 py-1 text-xs font-semibold transition ${a.key === arrangement ? 'bg-gradient-to-r from-[#1a6fd4] to-[#17b8e0] text-white shadow' : 'border border-slate-200 bg-white text-slate-600 hover:border-[#1a6fd4]/50 hover:text-[#1a6fd4]'}`,
                                children: a.label
                            }, a.key))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ecca3e63fd9dabf8$var$Stagger, {
                replayKey: `${replayKey}-${arrangement}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-3 flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f45c1e8ae52ad76$export$2e2bcd8739ae039), {
                                size: 18,
                                className: "text-[#1a6fd4]"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-[11px] font-medium uppercase tracking-wide text-slate-400",
                                        children: "Your name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-sm font-semibold text-slate-800",
                                        children: "Margaret Wilson, 84"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                size: 18,
                                className: "text-emerald-500"
                            })
                        ]
                    }),
                    curated.story.map(({ label: label, value: value })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mb-3 flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                    size: 18,
                                    className: "shrink-0 text-emerald-500"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "text-[11px] font-medium uppercase tracking-wide text-slate-400",
                                            children: label
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "text-sm font-semibold text-slate-800",
                                            children: value
                                        })
                                    ]
                                })
                            ]
                        }, label)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "rounded-xl bg-gradient-to-r from-[#1a6fd4] to-[#17b8e0] px-4 py-3 text-center text-sm font-semibold text-white shadow-md",
                        children: curated.banner
                    })
                ]
            })
        ]
    });
};
const $ecca3e63fd9dabf8$var$CountUpMetric = ({ label: label, target: target, tone: tone, replayKey: replayKey, delay: delay })=>{
    const value = $ecca3e63fd9dabf8$var$useCountUp(target, 1600, replayKey, delay);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-xl border border-slate-200 bg-slate-50 p-3 text-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `text-lg font-bold tabular-nums ${tone}`,
                children: $ecca3e63fd9dabf8$var$aud(value)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-1 text-[11px] font-medium text-slate-500",
                children: label
            })
        ]
    });
};
const $ecca3e63fd9dabf8$var$ResultsVisual = ({ replayKey: replayKey, arrangement: arrangement })=>{
    const metrics = $ecca3e63fd9dabf8$var$CURATED[arrangement].results;
    const bars = [
        62,
        84,
        47
    ];
    const key = `${replayKey}-${arrangement}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ecca3e63fd9dabf8$var$MockWindow, {
        title: "AgedCareWise \u2014 Your results",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid grid-cols-3 gap-3",
                children: metrics.map((m, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ecca3e63fd9dabf8$var$CountUpMetric, {
                        ...m,
                        replayKey: key,
                        delay: 200 + i * 300
                    }, m.label))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-4 rounded-xl border border-slate-200 p-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mb-3 text-xs font-semibold text-slate-500",
                        children: "Cashflow, pension & estate \u2014 projected over 10 years"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex h-24 items-end gap-4",
                        children: bars.map((h, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-1 flex-col items-center gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "w-full rounded-t-lg bg-gradient-to-t from-[#1a6fd4] to-[#17b8e0] transition-all duration-1000 ease-out",
                                        style: {
                                            height: `${h}%`,
                                            transitionDelay: `${300 + i * 250}ms`
                                        }
                                    }, `${key}-${i}`),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-[10px] text-slate-400",
                                        children: [
                                            'Year 1',
                                            'Year 5',
                                            'Year 10'
                                        ][i]
                                    })
                                ]
                            }, i))
                    })
                ]
            })
        ]
    });
};
const $ecca3e63fd9dabf8$var$StrategiesVisual = ({ replayKey: replayKey, arrangement: arrangement })=>{
    const s = $ecca3e63fd9dabf8$var$CURATED[arrangement].strategies;
    const key = `${replayKey}-${arrangement}`;
    const topValue = $ecca3e63fd9dabf8$var$useCountUp(s.top.target, 1500, key, 700);
    const altValue = $ecca3e63fd9dabf8$var$useCountUp(s.alt.target, 1500, key, 900);
    const [pre, highlight, post] = s.punchline;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ecca3e63fd9dabf8$var$MockWindow, {
        title: "AgedCareWise \u2014 Suggestion Engine",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-3 flex items-center gap-2 text-xs font-medium text-slate-500",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {
                        size: 14,
                        className: "text-[#1a6fd4]"
                    }),
                    s.searched,
                    " strategy combinations searched for Margaret\u2026"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ecca3e63fd9dabf8$var$Stagger, {
                replayKey: key,
                step: 600,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-3 rounded-xl border-2 border-emerald-300 bg-emerald-50/60 p-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center justify-between gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $993a4e0d8b7d2457$export$2e2bcd8739ae039), {
                                                size: 16,
                                                className: "shrink-0 text-emerald-600"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm font-bold text-slate-800",
                                                children: s.top.title
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "shrink-0 rounded-full bg-emerald-500 px-2.5 py-0.5 text-[11px] font-bold text-white",
                                        children: "Top strategy"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-2 flex items-end justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-xs text-slate-500",
                                        children: s.metric
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-lg font-bold tabular-nums text-emerald-700",
                                        children: $ecca3e63fd9dabf8$var$aud(topValue)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "rounded-xl border border-slate-200 bg-white p-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center justify-between gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-sm font-semibold text-slate-700",
                                        children: s.alt.title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "shrink-0 rounded-full bg-slate-100 px-2.5 py-0.5 text-[11px] font-semibold text-slate-500",
                                        children: "Compared"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-2 flex items-end justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-xs text-slate-500",
                                        children: s.metric
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-lg font-bold tabular-nums text-slate-600",
                                        children: $ecca3e63fd9dabf8$var$aud(altValue)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-3 text-center text-xs font-medium text-slate-500",
                        children: [
                            pre,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-bold text-emerald-600",
                                children: highlight
                            }),
                            post
                        ]
                    })
                ]
            })
        ]
    });
};
const $ecca3e63fd9dabf8$var$ManualControlVisual = ({ replayKey: replayKey, arrangement: arrangement })=>{
    const m = $ecca3e63fd9dabf8$var$CURATED[arrangement].manual;
    const [scenario, setScenario] = (0, $acw62.useState)('a');
    (0, $acw62.useEffect)(()=>{
        setScenario('a');
        const t = setTimeout(()=>setScenario('b'), 2800); // show the flip happening by itself
        return ()=>clearTimeout(t);
    }, [
        replayKey,
        arrangement
    ]);
    const active = m[scenario];
    const key = `${replayKey}-${arrangement}-${scenario}`;
    const first = $ecca3e63fd9dabf8$var$useCountUp(active.values[0], 1100, key);
    const second = $ecca3e63fd9dabf8$var$useCountUp(active.values[1], 1100, key, 150);
    const shown = [
        first,
        second
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ecca3e63fd9dabf8$var$MockWindow, {
        title: "AgedCareWise \u2014 Manual control",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mb-4 grid grid-cols-2 gap-1 rounded-xl bg-slate-100 p-1",
                children: [
                    'a',
                    'b'
                ].map((k)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setScenario(k),
                        className: `rounded-lg px-3 py-2 text-xs font-semibold transition ${k === scenario ? 'bg-white text-[#1a6fd4] shadow' : 'text-slate-500 hover:text-slate-700'}`,
                        children: m[k].label
                    }, k))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid grid-cols-2 gap-3",
                children: m.metrics.map((label, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "rounded-xl border border-slate-200 bg-slate-50 p-3 text-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: `text-lg font-bold tabular-nums ${i === 0 ? 'text-slate-800' : 'text-emerald-600'}`,
                                children: label.includes('hours') ? shown[i] : $ecca3e63fd9dabf8$var$aud(shown[i])
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-1 text-[11px] font-medium text-slate-500",
                                children: label
                            })
                        ]
                    }, label))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-4 rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white p-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-1.5 flex items-center gap-2 text-xs font-bold uppercase tracking-wide text-amber-700",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e57d6b071418ede9$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            " Insight"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm leading-relaxed text-slate-700",
                        children: active.insight
                    }, key)
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-3 text-center text-[11px] font-medium text-slate-400",
                children: "Flip the setting \u2014 the numbers and the explanation update instantly."
            })
        ]
    });
};
const $ecca3e63fd9dabf8$var$SoaVisual = ({ replayKey: replayKey, arrangement: arrangement })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ecca3e63fd9dabf8$var$MockWindow, {
        title: "AgedCareWise \u2014 Statement of Advice",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "mx-auto max-w-sm rounded-xl border border-slate-200 bg-white p-5 shadow-inner",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ecca3e63fd9dabf8$var$Stagger, {
                replayKey: `${replayKey}-${arrangement}`,
                step: 380,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-3 flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                size: 18,
                                className: "shrink-0 text-[#1a6fd4]"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-sm font-bold text-slate-800",
                                children: [
                                    "Statement of Advice",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "ml-1.5 font-medium text-slate-400",
                                        children: [
                                            "\xb7 ",
                                            $ecca3e63fd9dabf8$var$CURATED[arrangement].tag
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mb-2 h-2.5 w-3/4 rounded bg-slate-200"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mb-2 h-2.5 w-full rounded bg-slate-100"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mb-2 h-2.5 w-5/6 rounded bg-slate-100"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mb-4 h-2.5 w-2/3 rounded bg-slate-100"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-2 flex items-center gap-2 text-xs text-slate-600",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                size: 14,
                                className: "text-emerald-500"
                            }),
                            " Your situation & goals"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-2 flex items-center gap-2 text-xs text-slate-600",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                size: 14,
                                className: "text-emerald-500"
                            }),
                            " The strategy, step by step"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-2 flex items-center gap-2 text-xs text-slate-600",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                size: 14,
                                className: "text-emerald-500"
                            }),
                            " Projections & assumptions, shown honestly"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-4 rounded-lg bg-gradient-to-r from-[#1a6fd4] to-[#17b8e0] py-2 text-center text-xs font-semibold text-white",
                        children: "Your plan \u2014 ready to keep, share or action"
                    })
                ]
            })
        })
    });
const $ecca3e63fd9dabf8$var$AwiseVisual = ({ replayKey: replayKey, arrangement: arrangement })=>{
    const chat = $ecca3e63fd9dabf8$var$CURATED[arrangement].awise;
    const [typing, setTyping] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>{
        setTyping(true);
        const t = setTimeout(()=>setTyping(false), 1600);
        return ()=>clearTimeout(t);
    }, [
        replayKey,
        arrangement
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ecca3e63fd9dabf8$var$MockWindow, {
        title: "AWise \u2014 your guide",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-3",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-auto max-w-[80%] rounded-2xl rounded-br-sm bg-[#1a6fd4] px-4 py-2.5 text-sm text-white",
                    children: chat.q
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-start gap-2.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#1a6fd4] to-[#17b8e0] text-white",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8afc40d49a7e79bf$export$2e2bcd8739ae039), {
                                size: 16
                            })
                        }),
                        typing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "rounded-2xl rounded-bl-sm bg-slate-100 px-4 py-3",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "inline-flex gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "h-1.5 w-1.5 animate-bounce rounded-full bg-slate-400",
                                        style: {
                                            animationDelay: '0ms'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "h-1.5 w-1.5 animate-bounce rounded-full bg-slate-400",
                                        style: {
                                            animationDelay: '150ms'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "h-1.5 w-1.5 animate-bounce rounded-full bg-slate-400",
                                        style: {
                                            animationDelay: '300ms'
                                        }
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "max-w-[85%] rounded-2xl rounded-bl-sm bg-slate-100 px-4 py-2.5 text-sm leading-relaxed text-slate-700",
                            children: chat.a
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-center text-[11px] font-medium text-slate-400",
                    children: "AWise knows the rules on every screen \u2014 ask anything, any time."
                })
            ]
        })
    });
};
const $ecca3e63fd9dabf8$var$PartnerVisual = ({ replayKey: replayKey })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ecca3e63fd9dabf8$var$MockWindow, {
        title: "AgedCareWise \u2014 Partner portal",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ecca3e63fd9dabf8$var$Stagger, {
            replayKey: replayKey,
            step: 420,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mb-3 flex items-center justify-between rounded-xl border border-slate-200 bg-slate-50 px-4 py-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-sm font-bold text-slate-800",
                                    children: "Taylor Accounting Pty Ltd"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-[11px] text-slate-500",
                                    children: "Your firm\u2019s secure workspace"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3e517ec92034a$export$2e2bcd8739ae039), {
                            size: 18,
                            className: "text-[#1a6fd4]"
                        })
                    ]
                }),
                [
                    {
                        name: 'Margaret Wilson',
                        status: "Plan complete \xb7 SOA ready",
                        tone: 'bg-emerald-100 text-emerald-700'
                    },
                    {
                        name: 'Frank & Elaine Rossi',
                        status: 'Fact-find in progress',
                        tone: 'bg-blue-100 text-blue-700'
                    },
                    {
                        name: 'The Chen family',
                        status: "Invited \xb7 awaiting sign-in",
                        tone: 'bg-amber-100 text-amber-700'
                    }
                ].map(({ name: name, status: status, tone: tone })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-3 flex items-center justify-between rounded-xl border border-slate-200 bg-white px-4 py-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-sm font-semibold text-slate-700",
                                children: name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${tone}`,
                                children: status
                            })
                        ]
                    }, name)),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "rounded-xl border-2 border-dashed border-[#1a6fd4]/40 bg-blue-50/50 px-4 py-3 text-center text-sm font-semibold text-[#1a6fd4]",
                    children: "+ Invite a client \u2014 they tell their story in their own secure login"
                })
            ]
        })
    });
const $ecca3e63fd9dabf8$var$CHAPTERS = [
    {
        key: 'story',
        nav: 'Your story',
        eyebrow: 'Step 1',
        title: "Start with what you\u2019re thinking",
        body: "Pick the living arrangement on your mind \u2014 staying home with support, a village, a granny flat, downsizing, or residential care \u2014 and AgedCareWise curates the whole journey to it. Then answer friendly, plain-English questions; everything saves automatically as you go. (Not sure which path? Explore them all \u2014 switching is free.)",
        Visual: $ecca3e63fd9dabf8$var$FactFindVisual,
        interactive: true
    },
    {
        key: 'results',
        nav: 'Real numbers',
        eyebrow: 'Step 2',
        title: 'See your real numbers, instantly',
        body: "The moment your story is in, AgedCareWise turns Australia\u2019s means-testing rules into YOUR numbers for the path you chose \u2014 costs, entitlements, cashflow and estate, projected over the years ahead. Change the arrangement in step 1 and watch this screen re-curate.",
        Visual: $ecca3e63fd9dabf8$var$ResultsVisual
    },
    {
        key: 'strategies',
        nav: 'Strategies',
        eyebrow: 'Step 3',
        title: 'Watch strategies compete for you',
        body: "The Suggestion Engine searches hundreds of combinations for the path you chose and shows you which wins, by how much, and why. For aged care that\u2019s keep-or-sell the home and lump-sum-or-daily-fee; for care at home it\u2019s fitting the right services inside your funding budget; for a granny flat, finding the gifting line before you cross it. Change the arrangement in step 1 and this race re-runs.",
        Visual: $ecca3e63fd9dabf8$var$StrategiesVisual
    },
    {
        key: 'manual',
        nav: 'Manual control',
        eyebrow: 'Step 4',
        title: 'Or take the controls yourself',
        body: "Prefer your own hands on the wheel? Manual control lets you build and compare your own scenarios for whichever path you\u2019re exploring. As you change a setting, the numbers move and an Insight panel explains the implications \u2014 just like a human adviser would, live and instantaneous.",
        Visual: $ecca3e63fd9dabf8$var$ManualControlVisual
    },
    {
        key: 'soa',
        nav: 'Your plan',
        eyebrow: 'Step 5',
        title: 'Walk away with a professional plan',
        body: "Your chosen strategy becomes a professional Statement of Advice \u2014 your situation, the recommendation, and honest projections \u2014 ready to keep, share with family, or act on.",
        Visual: $ecca3e63fd9dabf8$var$SoaVisual
    },
    {
        key: 'awise',
        nav: 'Meet AWise',
        eyebrow: 'Always with you',
        title: 'Never stuck, never alone',
        body: "AWise, your built-in AI guide, understands aged-care rules and the exact screen you\u2019re on. Ask anything in plain English, whenever a question pops into your head.",
        Visual: $ecca3e63fd9dabf8$var$AwiseVisual
    },
    {
        key: 'partners',
        nav: 'Partners & providers',
        eyebrow: 'For professionals & providers',
        title: 'Guide every client, at scale',
        body: "Accountants, financial advisers, aged-care and home-care providers, and retirement-living operators run their clients through this same engine from a secure firm workspace. Invite clients by link and track every file \u2014 invited, in progress, plan ready. Advisers advise under their own AFSL; other partners simply provide access, with the advice provided by AgedCareWise.",
        Visual: $ecca3e63fd9dabf8$var$PartnerVisual
    }
];
const $ecca3e63fd9dabf8$var$ExperiencePage = ({ onBack: onBack, onGetStarted: onGetStarted, onBecomePartner: onBecomePartner })=>{
    const [chapter, setChapter] = (0, $acw62.useState)(0);
    const [replayKey, setReplayKey] = (0, $acw62.useState)(0);
    const [autoPlay, setAutoPlay] = (0, $acw62.useState)(true);
    const [arrangement, setArrangement] = (0, $acw62.useState)('aged_care');
    const active = $ecca3e63fd9dabf8$var$CHAPTERS[chapter];
    const { Visual: Visual } = active;
    const timerRef = (0, $acw62.useRef)(null);
    // Gentle auto-advance so the page "plays itself" like a tour; any manual action takes over.
    (0, $acw62.useEffect)(()=>{
        if (!autoPlay) return undefined;
        timerRef.current = setTimeout(()=>{
            setChapter((c)=>c + 1 < $ecca3e63fd9dabf8$var$CHAPTERS.length ? c + 1 : c);
            if (chapter + 1 >= $ecca3e63fd9dabf8$var$CHAPTERS.length - 1) setAutoPlay(false);
        }, 7000);
        return ()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [
        chapter,
        autoPlay
    ]);
    const goTo = (i)=>{
        setAutoPlay(false);
        setChapter(i);
        setReplayKey((k)=>k + 1);
    };
    const pickArrangement = (key)=>{
        setAutoPlay(false); // the visitor is playing — don't yank the tour forward
        setArrangement(key);
    };
    const progress = (0, $acw62.useMemo)(()=>(chapter + 1) / $ecca3e63fd9dabf8$var$CHAPTERS.length * 100, [
        chapter
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen bg-slate-50",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "sticky top-0 z-10 border-b border-gray-200 bg-white/90 backdrop-blur",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mx-auto flex max-w-5xl items-center justify-between px-5 py-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            onClick: onBack,
                            className: "inline-flex items-center gap-1.5 rounded-lg px-2 py-1.5 text-sm font-medium text-gray-600 transition hover:bg-gray-100 hover:text-gray-900",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                    size: 16
                                }),
                                " Back"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-lg font-bold",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-slate-900",
                                    children: "AgedCare"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-[#17b8e0]",
                                    children: "Wise"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative overflow-hidden bg-gradient-to-br from-[#1a6fd4] to-[#17b8e0] text-white",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "pointer-events-none absolute -right-16 -top-20 h-64 w-64 rounded-full bg-white/10 blur-3xl"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "pointer-events-none absolute -left-10 bottom-0 h-48 w-48 rounded-full bg-white/5 blur-2xl"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative mx-auto max-w-5xl px-5 py-12 text-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/25 backdrop-blur",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b547c0f28739ad4$export$2e2bcd8739ae039), {
                                    className: "h-8 w-8"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-3xl font-bold sm:text-4xl",
                                children: "See it before you start"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mx-auto mt-3 max-w-2xl text-base text-white/90 sm:text-lg",
                                children: "A two-minute tour of exactly what happens inside AgedCareWise \u2014 from your first answer to a plan you can act on."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mx-auto max-w-5xl px-5 py-10",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mb-2 flex flex-wrap items-center justify-center gap-2",
                        children: $ecca3e63fd9dabf8$var$CHAPTERS.map((c, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>goTo(i),
                                className: `rounded-full px-4 py-1.5 text-xs font-semibold transition sm:text-sm ${i === chapter ? 'bg-gradient-to-r from-[#1a6fd4] to-[#17b8e0] text-white shadow-md' : 'bg-white text-slate-600 border border-slate-200 hover:border-[#1a6fd4]/50 hover:text-[#1a6fd4]'}`,
                                children: c.nav
                            }, c.key))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mx-auto mb-8 h-1 max-w-md overflow-hidden rounded-full bg-slate-200",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "h-full rounded-full bg-gradient-to-r from-[#1a6fd4] to-[#17b8e0] transition-all duration-700",
                            style: {
                                width: `${progress}%`
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid items-center gap-8 lg:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "order-2 lg:order-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-sm font-semibold uppercase tracking-wider text-[#1a6fd4]",
                                        children: active.eyebrow
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "mt-2 text-2xl font-bold text-slate-900 sm:text-3xl",
                                        children: active.title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mt-3 text-base leading-relaxed text-gray-600",
                                        children: active.body
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-6 flex items-center gap-3",
                                        children: [
                                            chapter < $ecca3e63fd9dabf8$var$CHAPTERS.length - 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>goTo(chapter + 1),
                                                className: "inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#1a6fd4] to-[#17b8e0] px-6 py-2.5 text-sm font-semibold text-white shadow-md transition hover:shadow-lg",
                                                children: [
                                                    "Next ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                        size: 16
                                                    })
                                                ]
                                            }) : onGetStarted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                onClick: onGetStarted,
                                                className: "inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#1a6fd4] to-[#17b8e0] px-6 py-2.5 text-sm font-semibold text-white shadow-md transition hover:shadow-lg",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                                                        size: 16
                                                    }),
                                                    " Start your plan"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>setReplayKey((k)=>k + 1),
                                                className: "inline-flex items-center gap-1.5 rounded-full border border-slate-300 px-4 py-2.5 text-sm font-medium text-slate-600 transition hover:border-[#1a6fd4]/50 hover:text-[#1a6fd4]",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6e669e1fd7e7ff8$export$2e2bcd8739ae039), {
                                                        size: 14
                                                    }),
                                                    " Replay"
                                                ]
                                            })
                                        ]
                                    }),
                                    active.key === 'manual' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4 flex items-center gap-2 text-xs font-medium text-slate-400",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $527b9d2547be6d0a$export$2e2bcd8739ae039), {
                                                size: 14
                                            }),
                                            " Automation when you want it, control when you don\u2019t."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "order-1 lg:order-2",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Visual, {
                                    replayKey: `${chapter}-${replayKey}`,
                                    arrangement: arrangement,
                                    onArrangement: pickArrangement
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-14 rounded-2xl bg-gradient-to-br from-slate-900 to-slate-700 p-7 text-center text-white sm:p-10",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-xl font-bold sm:text-2xl",
                                children: "Ready when you are"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mx-auto mt-2 max-w-xl text-sm leading-relaxed text-white/80 sm:text-base",
                                children: "Everything you just saw runs on your real numbers the moment you begin \u2014 and your first answers take about ten minutes."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-5 flex flex-wrap items-center justify-center gap-3",
                                children: [
                                    onGetStarted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: onGetStarted,
                                        className: "inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#1a6fd4] to-[#17b8e0] px-7 py-3 text-sm font-semibold text-white shadow-lg transition hover:shadow-xl",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                                                size: 16
                                            }),
                                            " Get Started"
                                        ]
                                    }),
                                    onBecomePartner && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: onBecomePartner,
                                        className: "inline-flex items-center gap-2 rounded-full border border-white/40 px-7 py-3 text-sm font-semibold text-white transition hover:bg-white/10",
                                        children: [
                                            "For partners & providers ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                                size: 16
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $ecca3e63fd9dabf8$export$2e2bcd8739ae039 = $ecca3e63fd9dabf8$var$ExperiencePage;


/**
 * Platform owner/super-admin console (Task #25). Lists every partner firm and lets the platform
 * owner APPROVE (activate) or SUSPEND them. Suspension is enforced in the database (migration
 * 0009) — a suspended firm's staff lose all access, this screen just drives it.
 *
 * This screen shows firm METADATA only (name, licence, owner email, member count) — never any
 * client's data. Access is gated server-side (platform admin + authenticator); this component is
 * only ever mounted once /v1/admin/whoami confirms the caller is an admin.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a2dfa57d290a8089$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m4.9 4.9 14.2 14.2",
            key: "1m5liu"
        }
    ]
];
const $a2dfa57d290a8089$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ban", $a2dfa57d290a8089$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $73a7d1cabb6a0e3c$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "8",
            height: "4",
            x: "8",
            y: "2",
            rx: "1",
            ry: "1",
            key: "tgr4d6"
        }
    ],
    [
        "path",
        {
            d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
            key: "116196"
        }
    ],
    [
        "path",
        {
            d: "m9 14 2 2 4-4",
            key: "df797q"
        }
    ]
];
const $73a7d1cabb6a0e3c$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("clipboard-check", $73a7d1cabb6a0e3c$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f6409c0860044c1d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4",
            key: "1pf5j1"
        }
    ],
    [
        "path",
        {
            d: "M14 2v4a2 2 0 0 0 2 2h4",
            key: "tnqrlb"
        }
    ],
    [
        "path",
        {
            d: "m5 12-3 3 3 3",
            key: "oke12k"
        }
    ],
    [
        "path",
        {
            d: "m9 18 3-3-3-3",
            key: "112psh"
        }
    ]
];
const $f6409c0860044c1d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("file-code-2", $f6409c0860044c1d$export$3efd853dbb351e94);


/**
 * Platform usage (owner, 1 Oct 2026): how the platform is being used across every firm and direct
 * client. Counts and dates only — the server's platform_usage_summary() never returns a name or a
 * fact-find, so this is safe for firms advising under their own AFSL too.
 */ 

var $acw62 = parcelRequire("acw62");



/**
 * The frame every platform-admin screen sits in (owner, 1 Oct 2026: "happy with the colour, but the
 * pastel infills look old and tired").
 *
 * The look: a deep navy header band — the same navy as the partner portal's sidebar — carrying the
 * title, actions and tabs; white working surfaces with hairline borders below; colour used for
 * meaning only (solid primary actions, a coloured dot for status, a solid icon on a message), never as
 * a tinted fill behind content.
 */ 
parcelRequire("acw62");

const $521cb9d4345e01f6$export$cc80f7155587094a = '#0b1a33';
const $521cb9d4345e01f6$export$f6da9c53b5f792a9 = '#1a6fd4';
function $521cb9d4345e01f6$export$a49248195eaa6c68({ title: title, subtitle: subtitle, icon: icon, onBack: onBack, backLabel: backLabel = 'Back', actions: actions, tabs: tabs, activeTab: activeTab, onTab: onTab, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen bg-white",
        style: {
            fontFamily: "'DM Sans', system-ui, sans-serif"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("header", {
                style: {
                    background: $521cb9d4345e01f6$export$cc80f7155587094a
                },
                className: "text-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mx-auto max-w-6xl px-4 pt-5 sm:px-8",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            onClick: onBack,
                            className: "mb-5 inline-flex items-center gap-1.5 text-sm text-white/60 transition hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#17b8e0] rounded",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                    size: 15
                                }),
                                " ",
                                backLabel
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap items-end gap-4 pb-5",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-3.5",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex h-11 w-11 items-center justify-center rounded-xl text-white",
                                            style: {
                                                background: `linear-gradient(135deg, ${$521cb9d4345e01f6$export$f6da9c53b5f792a9}, #17b8e0)`
                                            },
                                            children: icon
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                                    className: "text-2xl font-semibold tracking-tight",
                                                    children: title
                                                }),
                                                subtitle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "mt-0.5 text-sm text-white/60",
                                                    children: subtitle
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                actions && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "ml-auto flex flex-wrap items-center gap-2",
                                    children: actions
                                })
                            ]
                        }),
                        tabs && tabs.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                            className: "-mb-px flex gap-6",
                            role: "tablist",
                            children: tabs.map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    role: "tab",
                                    "aria-selected": activeTab === t.key,
                                    onClick: ()=>onTab?.(t.key),
                                    className: `border-b-2 pb-3 text-sm font-semibold transition focus-visible:outline-none ${activeTab === t.key ? 'border-[#17b8e0] text-white' : 'border-transparent text-white/55 hover:text-white'}`,
                                    children: t.label
                                }, t.key))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                className: "mx-auto max-w-6xl px-4 py-7 sm:px-8",
                children: children
            })
        ]
    });
}
const $521cb9d4345e01f6$export$c7c73467b57835d = ({ onClick: onClick, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        type: "button",
        onClick: onClick,
        className: "inline-flex items-center gap-1.5 rounded-lg border border-white/15 px-3 py-2 text-sm font-medium text-white/85 transition hover:border-white/35 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#17b8e0]",
        children: children
    });
const $521cb9d4345e01f6$export$daed298da1cab5c8 = ({ tone: tone, children: children })=>{
    const style = {
        error: {
            ring: 'border-red-300',
            dot: 'bg-red-600',
            Icon: (0, $00824d397ec63c04$export$2e2bcd8739ae039)
        },
        success: {
            ring: 'border-emerald-300',
            dot: 'bg-emerald-600',
            Icon: (0, $f36710bd138be5d0$export$2e2bcd8739ae039)
        },
        info: {
            ring: 'border-slate-200',
            dot: 'bg-[#1a6fd4]',
            Icon: (0, $e52b122f04c04d7d$export$2e2bcd8739ae039)
        }
    }[tone];
    const { Icon: Icon } = style;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `mb-5 flex items-start gap-3 rounded-xl border bg-white px-4 py-3 ${style.ring}`,
        role: tone === 'error' ? 'alert' : 'status',
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: `mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-white ${style.dot}`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                    size: 14
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-sm leading-relaxed text-slate-700",
                children: children
            })
        ]
    });
};
const $521cb9d4345e01f6$export$eaa9dcd62e0d5ec6 = ({ color: color, label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "inline-flex items-center gap-1.5 text-sm font-medium text-slate-700",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "h-2 w-2 rounded-full",
                style: {
                    background: color
                },
                "aria-hidden": true
            }),
            label
        ]
    });
const $521cb9d4345e01f6$export$97bcfb831ca24418 = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
        className: "mb-3 text-xs font-semibold uppercase tracking-[0.08em] text-slate-500",
        children: children
    });


const $64dc039f94f63a00$var$MODULE_LABELS = {
    aged_care: 'Aged care',
    support_at_home: 'Support at Home'
};
const $64dc039f94f63a00$var$fmtMonth = (ym)=>{
    const [y, m] = ym.split('-').map(Number);
    return new Date(y ?? 2000, (m ?? 1) - 1, 1).toLocaleDateString('en-AU', {
        month: 'short',
        year: '2-digit'
    });
};
const $64dc039f94f63a00$var$fmtDate = (iso)=>iso ? new Date(iso).toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }) : "\u2014";
const $64dc039f94f63a00$var$n = (v)=>v.toLocaleString('en-AU');
/** One headline figure: the number large, what it counts beneath, the breakdown below that. */ const $64dc039f94f63a00$var$Figure = ({ label: label, value: value, detail: detail })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-w-0 py-1",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-[11px] font-semibold uppercase tracking-[0.08em] text-slate-500",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-1.5 text-4xl font-semibold tabular-nums tracking-tight text-slate-900",
                children: $64dc039f94f63a00$var$n(value)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "mt-2 space-y-0.5 text-xs text-slate-500",
                children: detail.map((d)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: d
                    }, d))
            })
        ]
    });
const $64dc039f94f63a00$var$UsagePanel = ()=>{
    const [usage, setUsage] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let live = true;
        (0, $0aae0b39fc034917$export$75494d979f4a3d6c)().then((u)=>{
            if (live) setUsage(u);
        }).catch((err)=>{
            if (live) setError((0, $0aae0b39fc034917$export$bab87a1130a0d7b8)(err, 'Could not load usage.'));
        });
        return ()=>{
            live = false;
        };
    }, []);
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$daed298da1cab5c8), {
        tone: "error",
        children: error
    });
    if (!usage) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center justify-center gap-2 py-20 text-slate-400",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                size: 18,
                className: "animate-spin"
            }),
            " Loading usage\u2026"
        ]
    });
    const maxMonth = Math.max(1, ...usage.soasByMonth.map((m)=>m.generated));
    const modules = Object.entries(usage.savedScenariosByModule);
    const moduleTotal = modules.reduce((sum, [, v])=>sum + v, 0) || 1;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-10",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "grid grid-cols-2 gap-x-8 gap-y-6 border-b border-slate-200 pb-8 md:grid-cols-3 xl:grid-cols-5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($64dc039f94f63a00$var$Figure, {
                        label: "Firms",
                        value: usage.firms.total,
                        detail: [
                            `${$64dc039f94f63a00$var$n(usage.firms.ownLicence)} on their own AFSL`,
                            `${$64dc039f94f63a00$var$n(usage.firms.underOurLicence)} under ours`,
                            ...usage.firms.notActive ? [
                                `${$64dc039f94f63a00$var$n(usage.firms.notActive)} not active`
                            ] : []
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($64dc039f94f63a00$var$Figure, {
                        label: "Advisers",
                        value: usage.advisers,
                        detail: [
                            'Owners and advisers'
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($64dc039f94f63a00$var$Figure, {
                        label: "Client files",
                        value: usage.clientFiles.total,
                        detail: [
                            `${$64dc039f94f63a00$var$n(usage.clientFiles.viaFirms)} via firms \xb7 ${$64dc039f94f63a00$var$n(usage.clientFiles.direct)} direct`,
                            `${$64dc039f94f63a00$var$n(usage.clientFiles.factFindComplete)} fact-finds complete`,
                            `${$64dc039f94f63a00$var$n(usage.clientFiles.new30d)} new in 30 days`
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($64dc039f94f63a00$var$Figure, {
                        label: "Statements of Advice",
                        value: usage.soas.total,
                        detail: [
                            `${$64dc039f94f63a00$var$n(usage.soas.published)} published`,
                            `${$64dc039f94f63a00$var$n(usage.soas.ourLicence)} under our licence`,
                            `${$64dc039f94f63a00$var$n(usage.soas.new30d)} in 30 days`
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($64dc039f94f63a00$var$Figure, {
                        label: "Accounts",
                        value: usage.accounts.total,
                        detail: [
                            `${$64dc039f94f63a00$var$n(usage.accounts.active30d)} active in 30 days`,
                            `${$64dc039f94f63a00$var$n(usage.accounts.active90d)} in 90 days`,
                            `${$64dc039f94f63a00$var$n(usage.accounts.new30d)} new in 30 days`
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "grid gap-10 lg:grid-cols-[1.6fr_1fr]",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$97bcfb831ca24418), {
                                children: "Statements of Advice, last 12 months"
                            }),
                            usage.soasByMonth.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-slate-500",
                                children: "None yet."
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex h-44 items-end gap-2 border-b border-slate-200",
                                        role: "img",
                                        "aria-label": "Statements of Advice generated and published by month",
                                        children: usage.soasByMonth.map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex h-full flex-1 flex-col justify-end",
                                                title: `${$64dc039f94f63a00$var$fmtMonth(m.month)}: ${m.generated} generated, ${m.published} published`,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "mb-1 text-center text-[11px] font-semibold tabular-nums text-slate-600",
                                                        children: m.generated
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "relative w-full rounded-t-md bg-[#1a6fd4]",
                                                        style: {
                                                            height: `${m.generated / maxMonth * 100}%`,
                                                            minHeight: 2
                                                        },
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "absolute bottom-0 w-full rounded-t-md bg-[#0b1a33]",
                                                            style: {
                                                                height: `${m.generated ? m.published / m.generated * 100 : 0}%`
                                                            }
                                                        })
                                                    })
                                                ]
                                            }, m.month))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-1.5 flex gap-2",
                                        children: usage.soasByMonth.map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex-1 text-center text-[11px] text-slate-500",
                                                children: $64dc039f94f63a00$var$fmtMonth(m.month)
                                            }, m.month))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-3 flex gap-5 text-xs text-slate-600",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$eaa9dcd62e0d5ec6), {
                                                color: "#1a6fd4",
                                                label: "Generated"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$eaa9dcd62e0d5ec6), {
                                                color: "#0b1a33",
                                                label: "Published"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$97bcfb831ca24418), {
                                children: "Saved scenarios by module"
                            }),
                            modules.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-slate-500",
                                children: "None saved yet."
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "space-y-4",
                                children: modules.map(([m, v])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-baseline justify-between text-sm",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-slate-700",
                                                        children: $64dc039f94f63a00$var$MODULE_LABELS[m] ?? m
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-semibold tabular-nums text-slate-900",
                                                        children: $64dc039f94f63a00$var$n(v)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "mt-1.5 h-1.5 rounded-full bg-slate-100",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "h-1.5 rounded-full bg-[#17b8e0]",
                                                    style: {
                                                        width: `${v / moduleTotal * 100}%`
                                                    }
                                                })
                                            })
                                        ]
                                    }, m))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-4 text-xs leading-relaxed text-slate-500",
                                children: "Only aged care and Support at Home scenarios are saved to the server today."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$97bcfb831ca24418), {
                        children: "By firm"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "overflow-x-auto rounded-xl border border-slate-200",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "w-full min-w-[760px] text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "border-b border-slate-200 text-left text-[11px] uppercase tracking-[0.08em] text-slate-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3 font-semibold",
                                                children: "Firm"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-3 py-3 text-right font-semibold",
                                                children: "Advisers"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-3 py-3 text-right font-semibold",
                                                children: "Client files"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-3 py-3 text-right font-semibold",
                                                children: "Fact-finds complete"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-3 py-3 text-right font-semibold",
                                                children: "SOAs"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-3 py-3 text-right font-semibold",
                                                children: "Published"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3 font-semibold",
                                                children: "Last activity"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                    className: "divide-y divide-slate-100",
                                    children: [
                                        usage.byFirm.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: 7,
                                                className: "px-5 py-8 text-center text-sm text-slate-500",
                                                children: "No partner firms yet."
                                            })
                                        }),
                                        usage.byFirm.map((f)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "transition hover:bg-slate-50/70",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "px-5 py-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "font-semibold text-slate-900",
                                                                children: f.name
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "text-xs text-slate-500",
                                                                children: [
                                                                    f.profession ? (0, $442533e192804693$export$b59df854b6295776)[f.profession] ?? f.profession : 'Firm',
                                                                    f.status !== 'active' ? ` \xb7 ${f.status}` : ''
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-3 py-3 text-right tabular-nums text-slate-700",
                                                        children: f.advisers
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-3 py-3 text-right font-semibold tabular-nums text-slate-900",
                                                        children: f.clientFiles
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-3 py-3 text-right tabular-nums text-slate-700",
                                                        children: f.factFindsComplete
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-3 py-3 text-right tabular-nums text-slate-700",
                                                        children: f.soasGenerated
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-3 py-3 text-right tabular-nums text-slate-700",
                                                        children: f.soasPublished
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-5 py-3 text-slate-500",
                                                        children: $64dc039f94f63a00$var$fmtDate(f.lastActivity)
                                                    })
                                                ]
                                            }, f.id))
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-center text-xs text-slate-400",
                children: [
                    "Counts and dates only \u2014 no client names or details. Updated ",
                    new Date(usage.generatedAt).toLocaleString('en-AU'),
                    "."
                ]
            })
        ]
    });
};
var $64dc039f94f63a00$export$2e2bcd8739ae039 = $64dc039f94f63a00$var$UsagePanel;


/**
 * Client insights (owner, 1 Oct 2026): who comes to us and what for — clients advised under OUR
 * licence only, from the de-identified summary each save writes (shared/src/factFind/clientInsights.ts,
 * migration 0031). Bands and counts only; any group under ten people arrives as null and is shown as
 * "fewer than 10", so nothing here can be traced to a person.
 */ 

var $acw62 = parcelRequire("acw62");


/**
 * THE DE-IDENTIFIED SUMMARY OF A CLIENT FILE (owner decision, 1 Oct 2026).
 *
 * The platform owner wants to understand the people the service helps — which goals they come with,
 * and the broad shape of their wealth and spending — without anyone's file being opened. This is the
 * whole of what leaves a fact-find for that purpose: a household type, an age band, which goals are
 * ticked, whether they own their home, and BANDS (never amounts) for home value, super, net wealth and
 * living expenses. No name, date of birth, contact detail, location or exact figure.
 *
 * It is computed on every save, written beside the encrypted file, and kept ONLY for clients advised
 * under our own licence — the database function that stores it refuses anything else (migration
 * 0031). Reports suppress any group smaller than ten people, so a band cannot be traced to a person.
 *
 * Bands are deliberately coarse: widen them rather than narrow them. A change here changes what the
 * Privacy Policy describes, so read section 5 of it before adding a field.
 */ const $c18ae4cfcd17ffb2$export$a4d0550f41b2b59f = [
    'home_care',
    'downsize_home',
    'retirement_village',
    'granny_flat',
    'aged_care',
    'meet_costs',
    'maximise_support',
    'preserve_assets',
    'funding_guidance'
];
/** Upper bounds (exclusive) and labels. The last band is open-ended. */ const $c18ae4cfcd17ffb2$var$WEALTH_BANDS = [
    [
        250000,
        'under $250k'
    ],
    [
        500000,
        "$250k\u2013$500k"
    ],
    [
        750000,
        "$500k\u2013$750k"
    ],
    [
        1000000,
        "$750k\u2013$1m"
    ],
    [
        1500000,
        "$1m\u2013$1.5m"
    ],
    [
        2000000,
        "$1.5m\u2013$2m"
    ],
    [
        3000000,
        "$2m\u2013$3m"
    ],
    [
        Infinity,
        '$3m and over'
    ]
];
const $c18ae4cfcd17ffb2$var$SUPER_BANDS = [
    [
        100000,
        'under $100k'
    ],
    [
        250000,
        "$100k\u2013$250k"
    ],
    [
        500000,
        "$250k\u2013$500k"
    ],
    [
        1000000,
        "$500k\u2013$1m"
    ],
    [
        Infinity,
        '$1m and over'
    ]
];
const $c18ae4cfcd17ffb2$var$EXPENSE_BANDS = [
    [
        40000,
        'under $40k a year'
    ],
    [
        60000,
        "$40k\u2013$60k a year"
    ],
    [
        80000,
        "$60k\u2013$80k a year"
    ],
    [
        100000,
        "$80k\u2013$100k a year"
    ],
    [
        150000,
        "$100k\u2013$150k a year"
    ],
    [
        Infinity,
        '$150k a year and over'
    ]
];
const $c18ae4cfcd17ffb2$var$AGE_BANDS = [
    [
        65,
        'under 65'
    ],
    [
        70,
        "65\u201369"
    ],
    [
        75,
        "70\u201374"
    ],
    [
        80,
        "75\u201379"
    ],
    [
        85,
        "80\u201384"
    ],
    [
        90,
        "85\u201389"
    ],
    [
        Infinity,
        '90 and over'
    ]
];
const $c18ae4cfcd17ffb2$export$54c52dc0f5519e71 = {
    wealth: $c18ae4cfcd17ffb2$var$WEALTH_BANDS.map(([, l])=>l),
    super: $c18ae4cfcd17ffb2$var$SUPER_BANDS.map(([, l])=>l),
    expenses: $c18ae4cfcd17ffb2$var$EXPENSE_BANDS.map(([, l])=>l),
    age: $c18ae4cfcd17ffb2$var$AGE_BANDS.map(([, l])=>l)
};
const $c18ae4cfcd17ffb2$var$band = (value, bands)=>bands.find(([upper])=>value < upper)?.[1] ?? bands[bands.length - 1][1];
const $c18ae4cfcd17ffb2$var$amountOf = (row)=>{
    const v = Number(row.value ?? row.balance ?? 0);
    return Number.isFinite(v) && v > 0 ? v : 0;
};
const $c18ae4cfcd17ffb2$var$sumRows = (rows)=>(rows ?? []).reduce((total, r)=>total + $c18ae4cfcd17ffb2$var$amountOf(r), 0);
function $c18ae4cfcd17ffb2$var$ageOn(dob, today) {
    if (!dob) return null;
    const born = new Date(dob);
    if (Number.isNaN(born.getTime())) return null;
    let age = today.getFullYear() - born.getFullYear();
    const m = today.getMonth() - born.getMonth();
    if (m < 0 || m === 0 && today.getDate() < born.getDate()) age -= 1;
    return age >= 0 && age < 130 ? age : null;
}
function $c18ae4cfcd17ffb2$export$c56d171a5a49f24c(factFind, today = new Date()) {
    const fd = factFind ?? {};
    const goals = $c18ae4cfcd17ffb2$export$a4d0550f41b2b59f.filter((g)=>fd.goals?.[g] === true);
    const homeValue = Number(fd.home?.value ?? 0);
    const ownsHome = fd.client?.currentResidency === 'own_home' || Number.isFinite(homeValue) && homeValue > 0;
    const assets = Object.values(fd.assets ?? {}).reduce((total, rows)=>total + $c18ae4cfcd17ffb2$var$sumRows(rows), 0);
    const debts = Object.values(fd.liabilities ?? {}).reduce((total, rows)=>total + $c18ae4cfcd17ffb2$var$sumRows(rows), 0);
    const superTotal = $c18ae4cfcd17ffb2$var$sumRows(fd.assets?.superannuation) + $c18ae4cfcd17ffb2$var$sumRows(fd.assets?.accountBasedPensions);
    const homePart = Number.isFinite(homeValue) && homeValue > 0 ? homeValue : 0;
    const anyWealthEntered = homePart > 0 || assets > 0 || debts > 0;
    const netWealth = homePart + assets - debts;
    const living = Number(fd.expenses?.livingExpenses ?? 0);
    const age = $c18ae4cfcd17ffb2$var$ageOn(fd.client?.dob, today);
    return {
        household: fd.adviceFor === 'couple' ? 'couple' : 'single',
        ageBand: age === null ? null : $c18ae4cfcd17ffb2$var$band(age, $c18ae4cfcd17ffb2$var$AGE_BANDS),
        goals: goals,
        homeOwner: ownsHome,
        homeValueBand: homePart > 0 ? $c18ae4cfcd17ffb2$var$band(homePart, $c18ae4cfcd17ffb2$var$WEALTH_BANDS) : null,
        superBand: superTotal > 0 ? $c18ae4cfcd17ffb2$var$band(superTotal, $c18ae4cfcd17ffb2$var$SUPER_BANDS) : null,
        // A negative net wealth is a real answer (debts exceed assets) and falls in the lowest band.
        netWealthBand: anyWealthEntered ? $c18ae4cfcd17ffb2$var$band(Math.max(0, netWealth), $c18ae4cfcd17ffb2$var$WEALTH_BANDS) : null,
        livingExpensesBand: Number.isFinite(living) && living > 0 ? $c18ae4cfcd17ffb2$var$band(living, $c18ae4cfcd17ffb2$var$EXPENSE_BANDS) : null
    };
}



const $83439fe9a92c407f$var$GOAL_LABELS = {
    home_care: 'Care at home',
    downsize_home: 'Downsize the home',
    retirement_village: 'Retirement village',
    granny_flat: 'Granny flat',
    aged_care: 'Residential aged care',
    meet_costs: 'Meet the costs',
    maximise_support: 'Maximise government support',
    preserve_assets: 'Preserve assets for the family',
    funding_guidance: 'Guidance on funding'
};
/** One distribution as horizontal bars, in a fixed order, with suppressed groups said plainly. */ const $83439fe9a92c407f$var$Distribution = ({ title: title, counts: counts, order: order, labels: labels })=>{
    const entries = order.filter((k)=>counts && k in counts).map((k)=>[
            k,
            counts[k] ?? null
        ]);
    const max = Math.max(1, ...entries.map(([, v])=>v ?? 0));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$97bcfb831ca24418), {
                children: title
            }),
            entries.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-sm text-slate-500",
                children: "Nothing recorded yet."
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "space-y-2.5",
                children: entries.map(([k, v])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        className: "grid grid-cols-[minmax(0,11rem)_1fr_4.5rem] items-center gap-3 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "truncate text-slate-700",
                                children: labels?.[k] ?? k
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "h-2 rounded-full bg-slate-100",
                                children: v !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "block h-2 rounded-full bg-[#1a6fd4]",
                                    style: {
                                        width: `${v / max * 100}%`
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `text-right tabular-nums ${v === null ? 'text-xs text-slate-400' : 'font-semibold text-slate-900'}`,
                                children: v === null ? 'fewer than 10' : v.toLocaleString('en-AU')
                            })
                        ]
                    }, k))
            })
        ]
    });
};
const $83439fe9a92c407f$var$InsightsPanel = ()=>{
    const [report, setReport] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let live = true;
        (0, $0aae0b39fc034917$export$beb13e603a77f43b)().then((r)=>{
            if (live) setReport(r);
        }).catch((err)=>{
            if (live) setError((0, $0aae0b39fc034917$export$bab87a1130a0d7b8)(err, 'Could not load client insights.'));
        });
        return ()=>{
            live = false;
        };
    }, []);
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$daed298da1cab5c8), {
        tone: "error",
        children: error
    });
    if (!report) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center justify-center gap-2 py-20 text-slate-400",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                size: 18,
                className: "animate-spin"
            }),
            " Loading insights\u2026"
        ]
    });
    const intro = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        className: "mb-8 max-w-3xl text-sm leading-relaxed text-slate-600",
        children: [
            "Clients advised under our licence: direct clients and clients of firms that are not licensed themselves. Built from a de-identified summary of each file \u2014 bands, never amounts, names or dates. Any group of fewer than ",
            report.minGroup,
            " people is hidden so no one can be picked out."
        ]
    });
    if (report.tooFew) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            intro,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $521cb9d4345e01f6$export$daed298da1cab5c8), {
                tone: "info",
                children: [
                    report.filesCounted,
                    " client file",
                    report.filesCounted === 1 ? '' : 's',
                    " so far. Insights appear once there are at least",
                    ' ',
                    report.minGroup,
                    ", so that no one can be picked out."
                ]
            })
        ]
    });
    // Goal mix within each wealth band, for the bands that have enough people to show.
    const byWealth = new Map();
    for (const row of report.goalsByNetWealth ?? [])byWealth.set(row.band, [
        ...byWealth.get(row.band) ?? [],
        {
            goal: row.goal,
            count: row.count
        }
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-10",
        children: [
            intro,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-baseline gap-x-10 gap-y-2 border-b border-slate-200 pb-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-[11px] font-semibold uppercase tracking-[0.08em] text-slate-500",
                                children: "Client files counted"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-1.5 text-4xl font-semibold tabular-nums tracking-tight text-slate-900",
                                children: report.filesCounted.toLocaleString('en-AU')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-sm text-slate-600",
                        children: [
                            Object.entries(report.household ?? {}).map(([k, v])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "mr-5",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold text-slate-900",
                                            children: v ?? 'fewer than 10'
                                        }),
                                        " ",
                                        k === 'couple' ? 'couples' : 'single'
                                    ]
                                }, k)),
                            Object.entries(report.homeOwner ?? {}).map(([k, v])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "mr-5",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold text-slate-900",
                                            children: v ?? 'fewer than 10'
                                        }),
                                        " ",
                                        k === 'owner' ? 'own their home' : "don't own a home"
                                    ]
                                }, k))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid gap-10 lg:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($83439fe9a92c407f$var$Distribution, {
                        title: "Goals chosen",
                        counts: report.goals,
                        order: (0, $c18ae4cfcd17ffb2$export$a4d0550f41b2b59f),
                        labels: $83439fe9a92c407f$var$GOAL_LABELS
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($83439fe9a92c407f$var$Distribution, {
                        title: "Age of the client",
                        counts: report.ageBand,
                        order: (0, $c18ae4cfcd17ffb2$export$54c52dc0f5519e71).age
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($83439fe9a92c407f$var$Distribution, {
                        title: "Net wealth, including the home",
                        counts: report.netWealthBand,
                        order: (0, $c18ae4cfcd17ffb2$export$54c52dc0f5519e71).wealth
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($83439fe9a92c407f$var$Distribution, {
                        title: "Home value",
                        counts: report.homeValueBand,
                        order: (0, $c18ae4cfcd17ffb2$export$54c52dc0f5519e71).wealth
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($83439fe9a92c407f$var$Distribution, {
                        title: "Super and account-based pensions",
                        counts: report.superBand,
                        order: (0, $c18ae4cfcd17ffb2$export$54c52dc0f5519e71).super
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($83439fe9a92c407f$var$Distribution, {
                        title: "Living expenses in retirement",
                        counts: report.livingExpensesBand,
                        order: (0, $c18ae4cfcd17ffb2$export$54c52dc0f5519e71).expenses
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$97bcfb831ca24418), {
                        children: "What people come to us for, by net wealth"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "overflow-x-auto rounded-xl border border-slate-200",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "w-full min-w-[760px] text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "border-b border-slate-200 text-left text-[11px] uppercase tracking-[0.08em] text-slate-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-5 py-3 font-semibold",
                                                children: "Net wealth"
                                            }),
                                            (0, $c18ae4cfcd17ffb2$export$a4d0550f41b2b59f).map((g)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "px-2 py-3 text-right font-semibold",
                                                    children: $83439fe9a92c407f$var$GOAL_LABELS[g]
                                                }, g))
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    className: "divide-y divide-slate-100",
                                    children: (0, $c18ae4cfcd17ffb2$export$54c52dc0f5519e71).wealth.filter((b)=>byWealth.has(b)).map((b)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "whitespace-nowrap px-5 py-2.5 font-medium text-slate-800",
                                                    children: b
                                                }),
                                                (0, $c18ae4cfcd17ffb2$export$a4d0550f41b2b59f).map((g)=>{
                                                    const cell = byWealth.get(b)?.find((x)=>x.goal === g);
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-2 py-2.5 text-right tabular-nums",
                                                        children: !cell ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-slate-300",
                                                            children: "\u2014"
                                                        }) : cell.count === null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "text-xs text-slate-400",
                                                            children: [
                                                                "<",
                                                                report.minGroup
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-slate-800",
                                                            children: cell.count
                                                        })
                                                    }, g);
                                                })
                                            ]
                                        }, b))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-center text-xs text-slate-400",
                children: [
                    "Our-licence clients only. Each file counts as it stood at its last save. Updated ",
                    new Date(report.generatedAt).toLocaleString('en-AU'),
                    "."
                ]
            })
        ]
    });
};
var $83439fe9a92c407f$export$2e2bcd8739ae039 = $83439fe9a92c407f$var$InsightsPanel;


/**
 * Platform Admin → Regulatory prompts. Shows the government-source changes the weekly sweep judged
 * relevant to the engine, so the owner is prompted to update a threshold or rule. It never changes a
 * calculation — each prompt is a reminder; a human makes the actual change via code, tests and the
 * actuarial review pack.
 *
 * The top line is the HEARTBEAT: when the job last ran and whether it worked, so an empty list reads as
 * "nothing relevant this week" and never as "the job quietly broke". "Run now" triggers a sweep on
 * demand (the weekly timer is the normal path). "Show AI-dismissed" reveals what the filter set aside,
 * for auditing false negatives.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5fb1f1f001dd40b4$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 11a9 9 0 0 1 9 9",
            key: "pv89mb"
        }
    ],
    [
        "path",
        {
            d: "M4 4a16 16 0 0 1 16 16",
            key: "k0647b"
        }
    ],
    [
        "circle",
        {
            cx: "5",
            cy: "19",
            r: "1",
            key: "bfqh0e"
        }
    ]
];
const $5fb1f1f001dd40b4$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("rss", $5fb1f1f001dd40b4$export$3efd853dbb351e94);




const $e60ae8e3772551db$var$MODULE_LABELS = {
    aged_care: 'Residential aged care',
    support_at_home: 'Support at Home',
    age_pension: 'Age Pension & social security',
    super_tax: 'Super, tax & investments'
};
const $e60ae8e3772551db$var$STATUS_COLOR = {
    new: '#1a6fd4',
    reviewed: '#d97706',
    actioned: '#059669',
    dismissed: '#94a3b8'
};
const $e60ae8e3772551db$var$STATUS_LABEL = {
    new: 'New',
    reviewed: 'Reviewed',
    actioned: 'Actioned',
    dismissed: 'Dismissed'
};
const $e60ae8e3772551db$var$confidenceColor = (c)=>c === 'high' ? '#059669' : c === 'medium' ? '#d97706' : '#94a3b8';
const $e60ae8e3772551db$var$fmtDate = (iso)=>iso ? new Date(iso).toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }) : "\u2014";
const $e60ae8e3772551db$var$fmtDateTime = (iso)=>iso ? new Date(iso).toLocaleString('en-AU') : "\u2014";
const $e60ae8e3772551db$var$FILTERS = [
    'all',
    'new',
    'reviewed',
    'actioned',
    'dismissed'
];
const $e60ae8e3772551db$var$FILTER_LABEL = {
    all: 'All',
    new: 'New',
    reviewed: 'Reviewed',
    actioned: 'Actioned',
    dismissed: 'Dismissed'
};
const $e60ae8e3772551db$var$quietButton = 'inline-flex items-center gap-1.5 rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-semibold text-slate-700 transition hover:border-slate-300 hover:text-slate-900 disabled:opacity-50';
/** The heartbeat line: a plain-English summary of the last sweep. */ const $e60ae8e3772551db$var$Heartbeat = ({ run: run })=>{
    if (!run) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "text-sm text-slate-500",
        children: "The sweep hasn\u2019t run yet. Use \u201CRun now\u201D to check the feeds for the first time."
    });
    const failed = run.ok === false || run.finishedAt && run.ok !== true;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-wrap items-center gap-x-4 gap-y-1 text-sm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$eaa9dcd62e0d5ec6), {
                color: run.ok === true ? '#059669' : failed ? '#dc2626' : '#d97706',
                label: run.ok === true ? 'Last check OK' : failed ? 'Last check had problems' : "Running\u2026"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "text-slate-500",
                children: [
                    $e60ae8e3772551db$var$fmtDateTime(run.finishedAt ?? run.startedAt),
                    " \xb7 ",
                    run.feedsChecked,
                    " feed",
                    run.feedsChecked === 1 ? '' : 's',
                    " \xb7 ",
                    run.itemsNew,
                    " new item",
                    run.itemsNew === 1 ? '' : 's',
                    " \xb7 ",
                    run.itemsRelevant,
                    " relevant"
                ]
            }),
            run.error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-red-600",
                children: run.error
            })
        ]
    });
};
const $e60ae8e3772551db$var$RegulatoryPanel = ()=>{
    const [prompts, setPrompts] = (0, $acw62.useState)(null);
    const [lastRun, setLastRun] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    const [notice, setNotice] = (0, $acw62.useState)(null);
    const [includeDismissed, setIncludeDismissed] = (0, $acw62.useState)(false);
    const [filter, setFilter] = (0, $acw62.useState)('all');
    const [busyId, setBusyId] = (0, $acw62.useState)(null);
    const [sweeping, setSweeping] = (0, $acw62.useState)(false);
    const load = async (withDismissed = includeDismissed)=>{
        setError(null);
        try {
            const { prompts: p, lastRun: r } = await (0, $0aae0b39fc034917$export$3577149374211382)(withDismissed);
            setPrompts(p);
            setLastRun(r);
        } catch (err) {
            setPrompts([]);
            setError((0, $0aae0b39fc034917$export$bab87a1130a0d7b8)(err, 'Could not load regulatory prompts.'));
        }
    };
    (0, $acw62.useEffect)(()=>{
        load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const changeStatus = async (prompt, status)=>{
        setBusyId(prompt.id);
        setNotice(null);
        try {
            await (0, $0aae0b39fc034917$export$d39fbc51d3c94dc2)(prompt.id, status);
            setPrompts((prev)=>prev ? prev.map((p)=>p.id === prompt.id ? {
                        ...p,
                        status: status
                    } : p) : prev);
        } catch (err) {
            setNotice({
                tone: 'error',
                text: (0, $0aae0b39fc034917$export$bab87a1130a0d7b8)(err, 'Could not update the prompt.')
            });
        } finally{
            setBusyId(null);
        }
    };
    const sweepNow = async ()=>{
        setSweeping(true);
        setNotice(null);
        try {
            const { result: result } = await (0, $0aae0b39fc034917$export$3d161c819b962710)();
            setNotice({
                tone: 'success',
                text: result.skipped ? "A sweep is already running \u2014 try again shortly." : `Checked ${result.feedsChecked} feed${result.feedsChecked === 1 ? '' : 's'}: ${result.itemsNew} new item${result.itemsNew === 1 ? '' : 's'}, ${result.itemsRelevant} relevant.`
            });
            await load();
        } catch (err) {
            setNotice({
                tone: 'error',
                text: (0, $0aae0b39fc034917$export$bab87a1130a0d7b8)(err, 'The sweep could not be completed.')
            });
        } finally{
            setSweeping(false);
        }
    };
    const toggleDismissed = async ()=>{
        const next = !includeDismissed;
        setIncludeDismissed(next);
        setPrompts(null);
        await load(next);
    };
    const visible = (prompts ?? []).filter((p)=>filter === 'all' || p.status === filter);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-6",
        children: [
            notice && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$daed298da1cab5c8), {
                tone: notice.tone,
                children: notice.text
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$daed298da1cab5c8), {
                tone: "error",
                children: error
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200 px-4 py-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e60ae8e3772551db$var$Heartbeat, {
                        run: lastRun
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: toggleDismissed,
                                className: $e60ae8e3772551db$var$quietButton,
                                title: "Show items the AI judged not relevant",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                        size: 14
                                    }),
                                    " ",
                                    includeDismissed ? 'Hide AI-dismissed' : 'Show AI-dismissed'
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: sweepNow,
                                disabled: sweeping,
                                className: $e60ae8e3772551db$var$quietButton,
                                children: [
                                    sweeping ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                        size: 14,
                                        className: "animate-spin"
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                        size: 14
                                    }),
                                    " Run now"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$97bcfb831ca24418), {
                        children: "Prompts"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex gap-1.5",
                        children: $e60ae8e3772551db$var$FILTERS.map((f)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setFilter(f),
                                className: `rounded-full px-3 py-1 text-xs font-semibold transition ${filter === f ? 'bg-slate-800 text-white' : 'text-slate-500 hover:bg-slate-100'}`,
                                children: $e60ae8e3772551db$var$FILTER_LABEL[f]
                            }, f))
                    })
                ]
            }),
            prompts === null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center justify-center gap-2 py-20 text-slate-400",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                        size: 18,
                        className: "animate-spin"
                    }),
                    " Loading prompts\u2026"
                ]
            }) : visible.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "rounded-xl border border-dashed border-slate-300 py-16 text-center text-slate-500",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5fb1f1f001dd40b4$export$2e2bcd8739ae039), {
                        size: 26,
                        className: "mx-auto mb-3 text-slate-300"
                    }),
                    filter === 'all' ? "No regulatory prompts yet. The weekly sweep will add any it finds \u2014 or use \u201CRun now\u201D." : `No ${$e60ae8e3772551db$var$FILTER_LABEL[filter].toLowerCase()} prompts.`
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "space-y-4",
                children: visible.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        className: `rounded-xl border border-slate-200 p-5 ${p.status === 'dismissed' || !p.relevant ? 'opacity-60' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex flex-wrap items-start justify-between gap-3",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "min-w-0",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-wrap items-center gap-2",
                                            children: [
                                                p.relevant ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$eaa9dcd62e0d5ec6), {
                                                    color: $e60ae8e3772551db$var$STATUS_COLOR[p.status],
                                                    label: $e60ae8e3772551db$var$STATUS_LABEL[p.status]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$eaa9dcd62e0d5ec6), {
                                                    color: "#94a3b8",
                                                    label: "AI-dismissed"
                                                }),
                                                p.confidence && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "rounded-full px-2 py-0.5 text-[11px] font-semibold text-white",
                                                    style: {
                                                        background: $e60ae8e3772551db$var$confidenceColor(p.confidence)
                                                    },
                                                    children: [
                                                        p.confidence,
                                                        " confidence"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "text-xs text-slate-500",
                                                    children: [
                                                        p.sourceLabel,
                                                        " \xb7 published ",
                                                        $e60ae8e3772551db$var$fmtDate(p.publishedAt),
                                                        " \xb7 found ",
                                                        $e60ae8e3772551db$var$fmtDate(p.detectedAt)
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                            href: p.url,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            className: "mt-1.5 inline-flex items-center gap-1.5 text-base font-semibold text-slate-900 hover:text-[#1a6fd4]",
                                            children: [
                                                p.title,
                                                " ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                    size: 14,
                                                    className: "shrink-0 text-slate-400"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            p.summary && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-2 max-w-prose text-sm leading-relaxed text-slate-700",
                                children: p.summary
                            }),
                            p.affectedModules.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-3 flex flex-wrap gap-1.5",
                                children: p.affectedModules.map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "rounded-md bg-slate-100 px-2 py-0.5 text-[11px] font-medium text-slate-600",
                                        children: $e60ae8e3772551db$var$MODULE_LABELS[m] ?? m
                                    }, m))
                            }),
                            p.sourceUrls.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-3 text-xs text-slate-500",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-semibold",
                                        children: "Read:"
                                    }),
                                    ' ',
                                    p.sourceUrls.map((u, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                            children: [
                                                i > 0 && " \xb7 ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                    href: u,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    className: "underline hover:text-[#1a6fd4]",
                                                    children: [
                                                        "source ",
                                                        i + 1
                                                    ]
                                                })
                                            ]
                                        }, u))
                                ]
                            }),
                            p.relevant && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-4 flex flex-wrap gap-2 border-t border-slate-100 pt-3",
                                children: [
                                    p.status !== 'reviewed' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        disabled: busyId === p.id,
                                        onClick: ()=>changeStatus(p, 'reviewed'),
                                        className: $e60ae8e3772551db$var$quietButton,
                                        children: [
                                            busyId === p.id ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                size: 13,
                                                className: "animate-spin"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                                size: 13
                                            }),
                                            " Mark reviewed"
                                        ]
                                    }),
                                    p.status !== 'actioned' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        disabled: busyId === p.id,
                                        onClick: ()=>changeStatus(p, 'actioned'),
                                        className: "inline-flex items-center gap-1.5 rounded-lg border border-emerald-200 px-3 py-1.5 text-xs font-semibold text-emerald-700 transition hover:border-emerald-300 disabled:opacity-50",
                                        children: [
                                            busyId === p.id ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                size: 13,
                                                className: "animate-spin"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                                size: 13
                                            }),
                                            " Mark actioned"
                                        ]
                                    }),
                                    p.status !== 'dismissed' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        disabled: busyId === p.id,
                                        onClick: ()=>changeStatus(p, 'dismissed'),
                                        className: "inline-flex items-center gap-1.5 rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-semibold text-slate-500 transition hover:border-red-300 hover:text-red-600 disabled:opacity-50",
                                        children: [
                                            busyId === p.id ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                size: 13,
                                                className: "animate-spin"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2dfa57d290a8089$export$2e2bcd8739ae039), {
                                                size: 13
                                            }),
                                            " Dismiss"
                                        ]
                                    }),
                                    p.status !== 'new' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        disabled: busyId === p.id,
                                        onClick: ()=>changeStatus(p, 'new'),
                                        className: $e60ae8e3772551db$var$quietButton,
                                        children: [
                                            busyId === p.id ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                size: 13,
                                                className: "animate-spin"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6e669e1fd7e7ff8$export$2e2bcd8739ae039), {
                                                size: 13
                                            }),
                                            " Reopen"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, p.id))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-start gap-2 rounded-xl border border-slate-200 bg-slate-50/60 px-4 py-3 text-xs leading-relaxed text-slate-500",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                        size: 14,
                        className: "mt-0.5 shrink-0 text-slate-400"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "These prompts are reminders drawn from public government sources \u2014 they never change a calculation. Confirm the detail at the source, then make any change through the usual code, tests and actuarial review."
                    })
                ]
            })
        ]
    });
};
var $e60ae8e3772551db$export$2e2bcd8739ae039 = $e60ae8e3772551db$var$RegulatoryPanel;






const $ede43e0935f69fa3$var$TABS = [
    {
        key: 'firms',
        label: 'Firms'
    },
    {
        key: 'usage',
        label: 'Usage'
    },
    {
        key: 'insights',
        label: 'Client insights'
    },
    {
        key: 'regulatory',
        label: 'Regulatory prompts'
    }
];
/** Status as a colour: the dot carries the meaning, the word says it. */ const $ede43e0935f69fa3$var$statusColor = (status)=>status === 'active' ? '#059669' : status === 'suspended' ? '#dc2626' : '#d97706';
/** Plain-language access for a firm row. "Free access" (comp), "Paid", or "No plan". */ const $ede43e0935f69fa3$var$accessBadge = (t)=>{
    if (t.freeAccess) return {
        label: 'Free access',
        color: '#7c3aed'
    };
    if (t.hasAccess) return {
        label: 'Paid',
        color: '#059669'
    };
    return {
        label: 'No plan',
        color: '#94a3b8'
    };
};
const $ede43e0935f69fa3$var$quietButton = 'inline-flex items-center gap-1.5 rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-semibold text-slate-700 transition hover:border-slate-300 hover:text-slate-900 disabled:opacity-50';
const $ede43e0935f69fa3$var$AdminConsole = ({ onBack: onBack, backLabel: backLabel, onOpenApiDocs: onOpenApiDocs, onOpenCompliance: onOpenCompliance })=>{
    // Firms (manage), Usage (counts across the platform), Client insights, or Regulatory prompts. All
    // client-data-free.
    const [tab, setTab] = (0, $acw62.useState)('firms');
    const [tenants, setTenants] = (0, $acw62.useState)(null); // null = loading
    const [error, setError] = (0, $acw62.useState)(null);
    const [notice, setNotice] = (0, $acw62.useState)(null);
    const [busyId, setBusyId] = (0, $acw62.useState)(null);
    const [freeBusyId, setFreeBusyId] = (0, $acw62.useState)(null);
    const [consumerEmail, setConsumerEmail] = (0, $acw62.useState)('');
    const [consumerBusy, setConsumerBusy] = (0, $acw62.useState)(false);
    const [freeEmails, setFreeEmails] = (0, $acw62.useState)([]);
    const [emailBusy, setEmailBusy] = (0, $acw62.useState)(null); // email currently being removed
    const load = async ()=>{
        setError(null);
        try {
            setTenants(await (0, $0aae0b39fc034917$export$841aa9cdb59544d0)());
        } catch (err) {
            setTenants([]);
            setError((0, $0aae0b39fc034917$export$bab87a1130a0d7b8)(err, 'Could not load firms just now.'));
        }
        try {
            setFreeEmails(await (0, $0aae0b39fc034917$export$d9829425852634cb)());
        } catch  {
        /* the allowlist is a secondary panel — don't block the firms view on it */ }
    };
    (0, $acw62.useEffect)(()=>{
        load();
    }, []);
    const changeStatus = async (tenant, status)=>{
        const verb = status === 'suspended' ? 'suspend' : 'reactivate';
        if (status === 'suspended') {
            const sure = await (0, $8e1e84c918e07c84$export$71edf76f07903b9c)(`Suspend ${tenant.name}? Everyone at the firm immediately loses access to their client files until you reactivate it. Client data is preserved.`);
            if (!sure) return;
        }
        setBusyId(tenant.id);
        setNotice(null);
        try {
            await (0, $0aae0b39fc034917$export$a5c81fd34ec479)(tenant.id, status);
            setTenants((prev)=>prev ? prev.map((t)=>t.id === tenant.id ? {
                        ...t,
                        status: status
                    } : t) : prev);
            setNotice({
                tone: 'success',
                text: `${tenant.name} ${status === 'suspended' ? 'suspended' : 'reactivated'}.`
            });
        } catch (err) {
            setNotice({
                tone: 'error',
                text: (0, $0aae0b39fc034917$export$bab87a1130a0d7b8)(err, `Could not ${verb} the firm.`)
            });
        } finally{
            setBusyId(null);
        }
    };
    const toggleFreeAccess = async (tenant)=>{
        const turningOn = !tenant.freeAccess;
        if (!turningOn) {
            const sure = await (0, $8e1e84c918e07c84$export$71edf76f07903b9c)(`Remove free access from ${tenant.name}? They'll be locked out until they subscribe or you grant it again. This never touches a paid subscription.`);
            if (!sure) return;
        }
        setFreeBusyId(tenant.id);
        setNotice(null);
        try {
            if (turningOn) await (0, $0aae0b39fc034917$export$46623589dd9298dc)(tenant.id);
            else await (0, $0aae0b39fc034917$export$bc0bf79c02123600)(tenant.id);
            setTenants((prev)=>prev ? prev.map((t)=>t.id === tenant.id ? {
                        ...t,
                        freeAccess: turningOn,
                        hasAccess: turningOn ? true : t.hasAccess && t.plan !== 'comp' ? t.hasAccess : false
                    } : t) : prev);
            setNotice({
                tone: 'success',
                text: `${turningOn ? 'Granted' : 'Removed'} free access ${turningOn ? 'to' : 'from'} ${tenant.name}.`
            });
        } catch (err) {
            setNotice({
                tone: 'error',
                text: (0, $0aae0b39fc034917$export$bab87a1130a0d7b8)(err, `Could not ${turningOn ? 'grant' : 'remove'} free access.`)
            });
        } finally{
            setFreeBusyId(null);
        }
    };
    const grantConsumer = async (e)=>{
        e.preventDefault();
        const email = consumerEmail.trim();
        if (!email) return;
        setConsumerBusy(true);
        setNotice(null);
        try {
            const res = await (0, $0aae0b39fc034917$export$1dcb38cea112e29a)(email);
            setNotice({
                tone: 'success',
                text: res?.applied ? `Free access is now active for ${res.tenantName || email}.` : `${email} is on the free-access list \u{2014} they won't be charged when they sign up.`
            });
            setConsumerEmail('');
            try {
                setFreeEmails(await (0, $0aae0b39fc034917$export$d9829425852634cb)());
            } catch  {}
        } catch (err) {
            setNotice({
                tone: 'error',
                text: (0, $0aae0b39fc034917$export$bab87a1130a0d7b8)(err, 'Could not add that email to free access.')
            });
        } finally{
            setConsumerBusy(false);
        }
    };
    const removeEmail = async (email)=>{
        if (!await (0, $8e1e84c918e07c84$export$71edf76f07903b9c)(`Remove free access for ${email}? If they already have an account, their free access is turned off too.`)) return;
        setEmailBusy(email);
        setNotice(null);
        try {
            await (0, $0aae0b39fc034917$export$11e63ebb02ab53d9)(email);
            setFreeEmails((prev)=>prev.filter((r)=>r.email !== email));
            setNotice({
                tone: 'success',
                text: `Removed free access for ${email}.`
            });
        } catch (err) {
            setNotice({
                tone: 'error',
                text: (0, $0aae0b39fc034917$export$bab87a1130a0d7b8)(err, 'Could not remove that email.')
            });
        } finally{
            setEmailBusy(null);
        }
    };
    const pendingCount = (tenants || []).filter((t)=>t.status !== 'active').length;
    const subtitle = tenants === null ? "Loading\u2026" : `${tenants.length} firm${tenants.length === 1 ? '' : 's'}${pendingCount > 0 ? ` \xb7 ${pendingCount} not active` : ''}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$a49248195eaa6c68), {
        title: "Platform admin",
        subtitle: subtitle,
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
            size: 22
        }),
        onBack: onBack,
        backLabel: backLabel,
        tabs: $ede43e0935f69fa3$var$TABS,
        activeTab: tab,
        onTab: setTab,
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                onOpenCompliance && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $521cb9d4345e01f6$export$c7c73467b57835d), {
                    onClick: onOpenCompliance,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $73a7d1cabb6a0e3c$export$2e2bcd8739ae039), {
                            size: 15
                        }),
                        " Advice under our licence"
                    ]
                }),
                onOpenApiDocs && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $521cb9d4345e01f6$export$c7c73467b57835d), {
                    onClick: onOpenApiDocs,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f6409c0860044c1d$export$2e2bcd8739ae039), {
                            size: 15
                        }),
                        " API docs"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $521cb9d4345e01f6$export$c7c73467b57835d), {
                    onClick: load,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                            size: 15
                        }),
                        " Refresh"
                    ]
                })
            ]
        }),
        children: tab === 'usage' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64dc039f94f63a00$export$2e2bcd8739ae039), {}) : tab === 'insights' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83439fe9a92c407f$export$2e2bcd8739ae039), {}) : tab === 'regulatory' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e60ae8e3772551db$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                notice && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$daed298da1cab5c8), {
                    tone: notice.tone,
                    children: notice.text
                }),
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$daed298da1cab5c8), {
                    tone: "error",
                    children: error
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$97bcfb831ca24418), {
                    children: "Partner firms"
                }),
                tenants === null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center justify-center gap-2 py-20 text-slate-400",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                            size: 20,
                            className: "animate-spin"
                        }),
                        " Loading firms\u2026"
                    ]
                }) : tenants.length === 0 && !error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "rounded-xl border border-dashed border-slate-300 py-16 text-center text-slate-500",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $224502d93617e0e1$export$2e2bcd8739ae039), {
                            size: 28,
                            className: "mx-auto mb-3 text-slate-300"
                        }),
                        "No partner firms yet."
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-x-auto rounded-xl border border-slate-200",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "w-full min-w-[760px] text-left text-sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    className: "border-b border-slate-200 text-[11px] uppercase tracking-[0.08em] text-slate-500",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-5 py-3 font-semibold",
                                            children: "Firm"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-4 py-3 font-semibold",
                                            children: "Licence"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-4 py-3 font-semibold",
                                            children: "Owner"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-4 py-3 font-semibold",
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-4 py-3 font-semibold",
                                            children: "Access"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "px-5 py-3 text-right font-semibold",
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                className: "divide-y divide-slate-100",
                                children: tenants.map((t)=>{
                                    const access = $ede43e0935f69fa3$var$accessBadge(t);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "align-middle transition hover:bg-slate-50/70",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                className: "px-5 py-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "font-semibold text-slate-900",
                                                        children: t.name
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mt-0.5 text-xs text-slate-500",
                                                        children: [
                                                            t.profession ? (0, $442533e192804693$export$b59df854b6295776)[t.profession] ?? t.profession : "\u2014",
                                                            " \xb7 ",
                                                            t.memberCount,
                                                            " member",
                                                            t.memberCount === 1 ? '' : 's',
                                                            t.createdAt ? ` \xb7 joined ${new Date(t.createdAt).toLocaleDateString('en-AU')}` : ''
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-4 py-4 text-slate-700",
                                                children: t.afslLicenseeName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        t.afslLicenseeName,
                                                        t.afslNumber ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "text-xs tabular-nums text-slate-500",
                                                            children: [
                                                                "AFSL ",
                                                                t.afslNumber
                                                            ]
                                                        }) : null
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-slate-500",
                                                    children: "Under our licence"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-4 py-4 text-slate-700",
                                                children: t.ownerEmail || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-slate-400",
                                                    children: "\u2014"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-4 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$eaa9dcd62e0d5ec6), {
                                                    color: $ede43e0935f69fa3$var$statusColor(t.status),
                                                    label: t.status.charAt(0).toUpperCase() + t.status.slice(1)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-4 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$eaa9dcd62e0d5ec6), {
                                                    color: access.color,
                                                    label: access.label
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "px-5 py-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex justify-end gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            type: "button",
                                                            disabled: freeBusyId === t.id,
                                                            onClick: ()=>toggleFreeAccess(t),
                                                            className: $ede43e0935f69fa3$var$quietButton,
                                                            children: [
                                                                freeBusyId === t.id ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                                    size: 14,
                                                                    className: "animate-spin"
                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6315759428919b56$export$2e2bcd8739ae039), {
                                                                    size: 14,
                                                                    className: t.freeAccess ? '' : 'text-violet-600'
                                                                }),
                                                                t.freeAccess ? 'Remove free access' : 'Free access'
                                                            ]
                                                        }),
                                                        t.status === 'suspended' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            type: "button",
                                                            disabled: busyId === t.id,
                                                            onClick: ()=>changeStatus(t, 'active'),
                                                            className: "inline-flex items-center gap-1.5 rounded-lg bg-emerald-600 px-3 py-1.5 text-xs font-semibold text-white transition hover:bg-emerald-700 disabled:opacity-50",
                                                            children: [
                                                                busyId === t.id ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                                    size: 14,
                                                                    className: "animate-spin"
                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                                                    size: 14
                                                                }),
                                                                " Reactivate"
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            type: "button",
                                                            disabled: busyId === t.id,
                                                            onClick: ()=>changeStatus(t, 'suspended'),
                                                            className: "inline-flex items-center gap-1.5 rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-semibold text-red-600 transition hover:border-red-300 hover:text-red-700 disabled:opacity-50",
                                                            children: [
                                                                busyId === t.id ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                                    size: 14,
                                                                    className: "animate-spin"
                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2dfa57d290a8089$export$2e2bcd8739ae039), {
                                                                    size: 14
                                                                }),
                                                                " Suspend"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, t.id);
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    className: "mt-10 grid gap-6 border-t border-slate-200 pt-8 lg:grid-cols-[1fr_1.1fr]",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$97bcfb831ca24418), {
                                    children: "Free access for a person"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "max-w-prose text-sm leading-relaxed text-slate-600",
                                    children: "For a direct customer, not a firm. Enter the email they sign in with and they won\u2019t be charged when they sign up or sign in. It works before or after they create an account, and you can remove it at any time."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                    onSubmit: grantConsumer,
                                    className: "flex flex-col gap-2 sm:flex-row",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            className: "relative flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Email address"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6fe951f3901e9a6$export$2e2bcd8739ae039), {
                                                    size: 15,
                                                    className: "pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "email",
                                                    value: consumerEmail,
                                                    onChange: (e)=>setConsumerEmail(e.target.value),
                                                    placeholder: "person@example.com",
                                                    className: "w-full rounded-lg border border-slate-300 bg-white py-2.5 pl-9 pr-3 text-sm text-slate-800 outline-none transition focus:border-[#1a6fd4] focus:ring-2 focus:ring-[#1a6fd4]/20"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "submit",
                                            disabled: consumerBusy || !consumerEmail.trim(),
                                            className: "inline-flex items-center justify-center gap-1.5 rounded-lg bg-violet-600 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-violet-700 disabled:bg-slate-300 disabled:text-white",
                                            children: [
                                                consumerBusy ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                    size: 15,
                                                    className: "animate-spin"
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6315759428919b56$export$2e2bcd8739ae039), {
                                                    size: 15
                                                }),
                                                " Give free access"
                                            ]
                                        })
                                    ]
                                }),
                                freeEmails.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-5",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mb-2 text-xs text-slate-500",
                                            children: [
                                                freeEmails.length,
                                                " ",
                                                freeEmails.length === 1 ? 'person has' : 'people have',
                                                " free access"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                            className: "divide-y divide-slate-100 rounded-xl border border-slate-200",
                                            children: freeEmails.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    className: "flex items-center justify-between gap-3 px-4 py-2.5 text-sm",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "truncate text-slate-700",
                                                            children: r.email
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            type: "button",
                                                            onClick: ()=>removeEmail(r.email),
                                                            disabled: emailBusy === r.email,
                                                            className: "inline-flex shrink-0 items-center gap-1 text-xs font-semibold text-slate-500 transition hover:text-red-600 disabled:opacity-50",
                                                            children: [
                                                                emailBusy === r.email ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                                    size: 13,
                                                                    className: "animate-spin"
                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                                    size: 13
                                                                }),
                                                                " Remove"
                                                            ]
                                                        })
                                                    ]
                                                }, r.email))
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "mt-10 text-center text-xs text-slate-400",
                    children: "Actions here are recorded on the tamper-evident audit trail. This screen never shows client data."
                })
            ]
        })
    });
};
var $ede43e0935f69fa3$export$2e2bcd8739ae039 = $ede43e0935f69fa3$var$AdminConsole;


/**
 * Advice under our licence — LICENSEE OVERSIGHT (owner, 1 Oct 2026).
 *
 * Every client advised under AgedCareWise's own AFSL: the direct channel, and clients of firms that
 * are not licensed themselves. Never a client of an adviser firm on its own AFSL. Read-only.
 *
 * The server and database enforce all of it (server/src/rest/compliance/compliance.ts, migration
 * 0030): reviewers only, our-licence records only, a second factor, and every look recorded on the
 * audit trail — opening a record also records the reason typed here.
 *
 * Layout (owner, 1 Oct 2026): one row per client showing the latest version, the rest folded behind
 * a toggle, 25 clients a page — so thousands of clients with many versions each stay scannable. An
 * opened record reads like a document: labelled client details, the fact-find as labelled sections,
 * and the Statement of Advice itself opened as the client saw it. The raw data is still there, folded
 * away, for anyone who needs it.
 */ 

var $acw62 = parcelRequire("acw62");



/**
 * "WHAT THE ADVICE WAS BASED ON", COMPLETE (owner, 1 Oct 2026: "a section for every screen with every
 * response captured").
 *
 * The oversight view first borrowed the Statement of Advice's appendix walker, which is selective by
 * design — the document shows assets, debts and income in its own tables, so its appendix skips them.
 * A compliance reviewer needs the opposite: everything the client told us, laid out the way they
 * entered it. So this walks the sealed fact-find screen by screen, in the order of the fact-find's own
 * steps, and lists every answer — each asset and debt line by line. Anything that belongs to no known
 * screen still appears, under "Other answers recorded", so nothing can silently drop out.
 *
 * Only values the app injects itself (firm assumptions, saved app state) are left out; they are not
 * the client's answers, and the technical record below still holds them.
 */ /** Keys the app writes for itself, not answers anyone gave. */ const $cb7cc8164588f412$var$NOT_ANSWERS = new Set([
    'firmAssumptions',
    '__appState',
    '__appData',
    '__grannyFlatFundingMeta'
]);
/** Internal identifiers inside an answer: meaningless to a reader. */ const $cb7cc8164588f412$var$SKIP_FIELDS = new Set([
    'id',
    'entityId',
    'assetLink'
]);
const $cb7cc8164588f412$var$LABELS = {
    adviceFor: 'Advice is for',
    completer: 'Completed by',
    completerFirstName: "Completed by \u2014 first name",
    completerLastName: "Completed by \u2014 last name",
    completerRelationship: "Completed by \u2014 relationship",
    dob: 'Date of birth',
    phi: 'Private health insurance',
    preferredPhone: 'Phone',
    currentResidency: 'Living arrangement',
    healthStatus: 'Health',
    transferBalanceUsed: 'Transfer balance used',
    acat: 'Aged care assessment',
    clientAcat: "Client \u2014 aged care assessment",
    partnerAcat: "Partner \u2014 aged care assessment",
    rad: 'RAD',
    dap: 'DAP',
    phiNotes: 'Private health insurance notes',
    livingExpenses: 'Living expenses (a year)'
};
const $cb7cc8164588f412$var$prettify = (key)=>{
    if ($cb7cc8164588f412$var$LABELS[key]) return $cb7cc8164588f412$var$LABELS[key];
    const words = key.replace(/^__/, '').replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/_/g, ' ').trim().toLowerCase();
    return words.charAt(0).toUpperCase() + words.slice(1);
};
/** Stored codes in plain words: "own_home" -> "Own home", "sah_level_7" -> "Support at Home level 7". */ const $cb7cc8164588f412$var$CODE_WORDS = {
    own_home: 'Own home',
    with_family: 'Living with family',
    aged_care: 'Residential aged care',
    home_care: 'Care at home',
    support_at_home: 'Support at Home',
    in_progress: 'In progress',
    pi: 'Principal and interest',
    io: 'Interest only'
};
function $cb7cc8164588f412$var$humanise(text) {
    if (!/^[a-z0-9_]+$/.test(text)) return text; // free text and anything already readable
    if ($cb7cc8164588f412$var$CODE_WORDS[text]) return $cb7cc8164588f412$var$CODE_WORDS[text];
    const sah = /^sah_level_(\d+)$/.exec(text);
    if (sah) return `Support at Home level ${sah[1]}`;
    const hcp = /^hcp_transition_(\d+)$/.exec(text);
    if (hcp) return `Home Care Package level ${hcp[1]} (transitioned)`;
    const words = text.replace(/_/g, ' ');
    return words.charAt(0).toUpperCase() + words.slice(1);
}
const $cb7cc8164588f412$var$show = (v)=>{
    if (v === null || v === undefined || v === '') return null;
    if (typeof v === 'boolean') return v ? 'Yes' : 'No';
    if (typeof v === 'number') return Number.isFinite(v) ? v.toLocaleString('en-AU') : null;
    if (typeof v === 'string') return $cb7cc8164588f412$var$humanise(v.trim()) || null;
    return null;
};
/** Every answer under `value`, labelled by its path ("Bank accounts 1 (Westpac) › Value"). */ function $cb7cc8164588f412$var$flatten(value, label, out) {
    if (Array.isArray(value)) {
        value.forEach((item, i)=>{
            if (item && typeof item === 'object' && !Array.isArray(item)) {
                const desc = $cb7cc8164588f412$var$show(item.description ?? item.name);
                $cb7cc8164588f412$var$flatten(item, `${label} ${i + 1}${desc ? ` (${desc})` : ''}`, out);
            } else {
                const v = $cb7cc8164588f412$var$show(item);
                if (v !== null) out.push({
                    label: `${label} ${i + 1}`,
                    value: v
                });
            }
        });
        return;
    }
    if (value && typeof value === 'object') {
        for (const [k, v] of Object.entries(value)){
            if ($cb7cc8164588f412$var$SKIP_FIELDS.has(k)) continue;
            $cb7cc8164588f412$var$flatten(v, label ? `${label} \u{203A} ${$cb7cc8164588f412$var$prettify(k)}` : $cb7cc8164588f412$var$prettify(k), out);
        }
        return;
    }
    const v = $cb7cc8164588f412$var$show(value);
    if (v !== null) out.push({
        label: label || 'Answer',
        value: v
    });
}
/** The fact-find's screens, in order, and the parts of the file each one collects. */ const $cb7cc8164588f412$var$SCREENS = [
    {
        title: "Who's completing",
        keys: [
            'completer',
            'completerFirstName',
            'completerLastName',
            'completerRelationship',
            'adviceFor'
        ]
    },
    {
        title: 'Your details',
        keys: [
            'client',
            'partner',
            'relationship'
        ]
    },
    {
        title: 'Goals',
        keys: [
            'goals'
        ]
    },
    {
        title: 'Living arrangements',
        keys: [
            'home',
            'rent',
            'retirementVillage',
            'grannyFlat',
            'livingWithFamily'
        ]
    },
    {
        title: 'Care needs',
        keys: [
            'careNeeds',
            'servicePlan',
            'sahContributionRateOverride'
        ]
    },
    {
        title: 'Assets',
        keys: [
            'assets'
        ]
    },
    {
        title: 'Trusts and companies',
        keys: [
            'structures',
            'structuresGateAnswer',
            'structureFundingInSuggestions'
        ]
    },
    {
        title: 'Liabilities',
        keys: [
            'liabilities',
            'liabilitiesConfirmedNone'
        ]
    },
    {
        title: 'Income and expenses',
        keys: [
            'income',
            'expenses',
            'giftsHistory'
        ]
    },
    {
        title: 'Family and estate',
        keys: [
            'family'
        ]
    }
];
/** What each bag is called when its answers are listed ('' = its own entries name themselves). */ const $cb7cc8164588f412$var$BAG_PREFIX = {
    client: 'Client',
    partner: 'Partner',
    relationship: 'Relationship',
    home: 'Home',
    rent: 'Renting',
    retirementVillage: 'Retirement village',
    grannyFlat: 'Granny flat',
    livingWithFamily: 'Living with family',
    servicePlan: 'Service plan',
    sahContributionRateOverride: 'Contribution rates entered',
    income: 'Income',
    expenses: 'Expenses',
    giftsHistory: 'Gifts'
};
/*
 * ASSETS SHOW ONLY THE QUESTIONS THEIR SCREEN ASKS (owner, 1 Oct 2026). Every new asset is created
 * from one template (buildNewAsset.tsx) carrying defaults for every kind — franking 70%, funding source
 * "super", an annuity start-date option — and the asset screen only shows the questions that apply to
 * the type, so those defaults sit in the file unseen. A bank account listing "Funding source: Super"
 * reads as an answer the client gave; it is not. These lists mirror the questions on the Assets step
 * (ClientProfileSteps.tsx, the per-type switch); the raw record still holds everything.
 */ const $cb7cc8164588f412$var$ASSET_COMMON = [
    'description',
    'value',
    'ownership'
];
const $cb7cc8164588f412$var$ASSET_QUESTIONS = {
    bankAccounts: [
        'incomeRate'
    ],
    termDeposits: [
        'incomeRate',
        'maturityDate'
    ],
    shares: [
        'incomeRate',
        'frankingCredit',
        'growthRate',
        'costBase',
        'acquiredOn',
        'reinvest'
    ],
    investmentBonds: [
        'growthRate',
        'commencementDate'
    ],
    investmentProperty: [
        'growthRate',
        'costBase',
        'acquiredOn',
        'rent',
        'expenses'
    ],
    superannuation: [
        'growthRate'
    ],
    accountBasedPensions: [
        'growthRate',
        'income',
        'commencementDateOption',
        'commencementDate',
        'commencementDateUnsure',
        'purchasePrice'
    ],
    annuities: [
        'income',
        'annuityType',
        'commencementDate',
        'term',
        'purchasePrice',
        'rcv',
        'fundingSource'
    ],
    funeralBonds: [],
    prepaidFuneral: [],
    loansToOthers: [
        'incomeRate',
        'purchasePrice',
        'commencementDate'
    ],
    personalAssets: [
        'growthRate'
    ],
    other: [
        'income',
        'expenses',
        'growthRate',
        'costBase',
        'acquiredOn'
    ]
};
const $cb7cc8164588f412$var$ASSET_KIND = {
    bankAccounts: 'Bank account',
    termDeposits: 'Term deposit',
    shares: 'Shares and managed funds',
    investmentBonds: 'Investment bond',
    investmentProperty: 'Investment property',
    superannuation: 'Super',
    accountBasedPensions: 'Account-based pension',
    annuities: 'Annuity',
    funeralBonds: 'Funeral bond',
    prepaidFuneral: 'Prepaid funeral',
    loansToOthers: 'Money lent to others',
    personalAssets: 'Personal assets',
    other: 'Other asset'
};
/** A loan's fields are named for what they hold on that card (ClientProfileSteps.tsx). */ const $cb7cc8164588f412$var$LOAN_FIELD = {
    value: 'Still owed',
    ownership: 'Lent by',
    purchasePrice: 'Amount first lent',
    commencementDate: 'Date lent',
    incomeRate: 'Interest charged (% a year)'
};
const $cb7cc8164588f412$var$ASSET_FIELD = {
    description: 'Description',
    value: 'Current value',
    ownership: 'Owner',
    incomeRate: 'Income rate (% a year)',
    growthRate: 'Growth rate (% a year)',
    frankingCredit: 'Franking credit (%)',
    costBase: 'Cost base',
    acquiredOn: 'Month acquired',
    reinvest: 'Reinvest distributions',
    maturityDate: 'Maturity date',
    commencementDate: 'Start date',
    commencementDateOption: 'Started',
    commencementDateUnsure: 'Start date not known',
    purchasePrice: 'Purchase price',
    income: 'Annual payment or income',
    rent: 'Annual rent',
    expenses: 'Annual expenses',
    annuityType: 'Annuity type',
    term: 'Term (years)',
    rcv: 'Residual capital value',
    fundingSource: 'Funded from'
};
function $cb7cc8164588f412$var$assetRows(assets) {
    const rows = [];
    if (!assets || typeof assets !== 'object') return rows;
    for (const [category, list] of Object.entries(assets)){
        if (!Array.isArray(list)) continue;
        const fields = $cb7cc8164588f412$var$ASSET_QUESTIONS[category];
        list.forEach((raw, i)=>{
            if (!raw || typeof raw !== 'object') return;
            const item = raw;
            const desc = $cb7cc8164588f412$var$show(item.description);
            const head = `${$cb7cc8164588f412$var$ASSET_KIND[category] ?? $cb7cc8164588f412$var$prettify(category)} ${i + 1}${desc ? ` (${desc})` : ''}`;
            if (!fields) {
                // A kind of asset this view does not know yet: show all of it rather than hide an answer.
                $cb7cc8164588f412$var$flatten(item, head, rows);
                return;
            }
            for (const field of [
                ...$cb7cc8164588f412$var$ASSET_COMMON,
                ...fields
            ]){
                if (field === 'description') continue; // already in the heading
                const v = $cb7cc8164588f412$var$show(item[field]);
                const label = category === 'loansToOthers' && $cb7cc8164588f412$var$LOAN_FIELD[field] || $cb7cc8164588f412$var$ASSET_FIELD[field] || $cb7cc8164588f412$var$prettify(field);
                if (v !== null) rows.push({
                    label: `${head} \u{203A} ${label}`,
                    value: v
                });
            }
        });
    }
    return rows;
}
function $cb7cc8164588f412$export$3be459669bbc51cf(factFind) {
    const fd = factFind && typeof factFind === 'object' ? factFind : {};
    const sections = [];
    const used = new Set();
    for (const screen of $cb7cc8164588f412$var$SCREENS){
        const rows = [];
        for (const key of screen.keys){
            used.add(key);
            if (!(key in fd)) continue;
            const v = fd[key];
            // A screen's own bag is labelled by what is inside it, under a plain prefix where the screen
            // holds more than one ("Home › Value", "Expenses › Living expenses"); a list or a single answer
            // is labelled by its own name.
            if (key === 'assets') rows.push(...$cb7cc8164588f412$var$assetRows(v));
            else if (v && typeof v === 'object' && !Array.isArray(v)) $cb7cc8164588f412$var$flatten(v, $cb7cc8164588f412$var$BAG_PREFIX[key] ?? '', rows);
            else $cb7cc8164588f412$var$flatten(v, $cb7cc8164588f412$var$prettify(key), rows);
        }
        if (rows.length > 0) sections.push({
            title: screen.title,
            rows: rows
        });
    }
    const other = [];
    for (const [key, v] of Object.entries(fd)){
        if (used.has(key) || $cb7cc8164588f412$var$NOT_ANSWERS.has(key)) continue;
        $cb7cc8164588f412$var$flatten(v, $cb7cc8164588f412$var$prettify(key), other);
    }
    if (other.length > 0) sections.push({
        title: 'Other answers recorded',
        rows: other
    });
    return sections;
}





const $d0e0fde18cf45dd8$var$MODULE_LABELS = {
    aged_care: 'Aged care',
    support_at_home: 'Support at Home'
};
const $d0e0fde18cf45dd8$var$PAGE_SIZE = 25;
const $d0e0fde18cf45dd8$var$fmtDate = (iso)=>iso ? new Date(iso).toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }) : "\u2014";
/** "completerFirstName" -> "Completer first name", for any identity field without a label below. */ const $d0e0fde18cf45dd8$var$prettify = (key)=>{
    const words = key.replace(/([A-Z])/g, ' $1').replace(/_/g, ' ').trim().toLowerCase();
    return words.charAt(0).toUpperCase() + words.slice(1);
};
const $d0e0fde18cf45dd8$var$IDENTITY_LABELS = {
    fullName: 'Name',
    partnerFullName: 'Partner',
    dateOfBirth: 'Date of birth',
    email: 'Email',
    phone: 'Phone'
};
/** The client block, as people read it: name, partner, birth date, contact, then who filled it in. */ function $d0e0fde18cf45dd8$var$identityRows(identity) {
    const text = (v)=>typeof v === 'string' ? v.trim() : '';
    const rows = [];
    for (const key of [
        'fullName',
        'partnerFullName',
        'dateOfBirth',
        'email',
        'phone'
    ]){
        const v = text(identity[key]);
        if (v) rows.push([
            $d0e0fde18cf45dd8$var$IDENTITY_LABELS[key],
            key === 'dateOfBirth' ? $d0e0fde18cf45dd8$var$fmtDate(v) : v
        ]);
    }
    const completedBy = [
        text(identity.completerFirstName),
        text(identity.completerLastName)
    ].filter(Boolean).join(' ');
    if (completedBy) rows.push([
        'Completed by',
        completedBy
    ]);
    const handled = new Set([
        'fullName',
        'partnerFullName',
        'dateOfBirth',
        'email',
        'phone',
        'completerFirstName',
        'completerLastName'
    ]);
    for (const [k, v] of Object.entries(identity))if (!handled.has(k) && text(v)) rows.push([
        $d0e0fde18cf45dd8$var$prettify(k),
        text(v)
    ]);
    return rows;
}
/** The stored document is the saved scenario; its printable snapshot is what the client was given. */ function $d0e0fde18cf45dd8$var$documentHtml(module, doc) {
    const snapshot = doc?.soaSnapshot;
    if (!snapshot) return null;
    try {
        if ([
            'retirement_village',
            'downsizer',
            'granny_flat',
            'cashflow_pension'
        ].includes(module)) return (0, $482dbb064a59e381$export$f4681787750c522d)(snapshot);
        return module === 'support_at_home' ? (0, $39348679b8be0d72$export$b71867531de1aafe)(snapshot) : (0, $02a659cad5e2280d$export$b78bc62a2cc2a880)(snapshot);
    } catch  {
        return null;
    }
}
const $d0e0fde18cf45dd8$var$ComplianceConsole = ({ onBack: onBack })=>{
    const [records, setRecords] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    const [query, setQuery] = (0, $acw62.useState)('');
    const [page, setPage] = (0, $acw62.useState)(0);
    const [expanded, setExpanded] = (0, $acw62.useState)(new Set());
    const [opening, setOpening] = (0, $acw62.useState)(null);
    const [reason, setReason] = (0, $acw62.useState)('');
    const [openBusy, setOpenBusy] = (0, $acw62.useState)(false);
    const [openError, setOpenError] = (0, $acw62.useState)(null);
    const [opened, setOpened] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let live = true;
        (0, $0aae0b39fc034917$export$e66931258b72f27a)().then((r)=>{
            if (live) setRecords(r);
        }).catch((err)=>{
            if (live) setError((0, $0aae0b39fc034917$export$bab87a1130a0d7b8)(err, 'Could not load the advice register.'));
        });
        return ()=>{
            live = false;
        };
    }, []);
    const groups = (0, $acw62.useMemo)(()=>{
        const byFile = new Map();
        for (const r of records ?? []){
            const g = byFile.get(r.profileId) ?? {
                profileId: r.profileId,
                clientName: r.clientName,
                partnerName: r.partnerName,
                channel: r.channel,
                firmName: r.firmName,
                fileDeleted: r.fileDeleted,
                soas: [],
                latestAt: 0
            };
            g.soas.push(r);
            g.latestAt = Math.max(g.latestAt, new Date(r.publishedAt ?? r.createdAt).getTime());
            byFile.set(r.profileId, g);
        }
        const q = query.trim().toLowerCase();
        return [
            ...byFile.values()
        ].map((g)=>({
                ...g,
                soas: [
                    ...g.soas
                ].sort((a, b)=>b.version - a.version || b.createdAt.localeCompare(a.createdAt))
            })).filter((g)=>!q || [
                g.clientName,
                g.partnerName,
                g.firmName ?? 'direct'
            ].some((v)=>v?.toLowerCase().includes(q))).sort((a, b)=>b.latestAt - a.latestAt);
    }, [
        records,
        query
    ]);
    (0, $acw62.useEffect)(()=>setPage(0), [
        query
    ]);
    const pageCount = Math.max(1, Math.ceil(groups.length / $d0e0fde18cf45dd8$var$PAGE_SIZE));
    const shown = groups.slice(page * $d0e0fde18cf45dd8$var$PAGE_SIZE, page * $d0e0fde18cf45dd8$var$PAGE_SIZE + $d0e0fde18cf45dd8$var$PAGE_SIZE);
    const toggle = (id)=>setExpanded((prev)=>{
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    const startOpen = (r)=>{
        setOpening(r);
        setReason('');
        setOpenError(null);
        setOpened(null);
    };
    const closeRecord = ()=>{
        setOpening(null);
        setOpened(null);
        setOpenError(null);
    };
    const confirmOpen = async ()=>{
        if (!opening || reason.trim().length < 3) return;
        setOpenBusy(true);
        setOpenError(null);
        try {
            setOpened(await (0, $0aae0b39fc034917$export$b0af5bc150562a8c)(opening.soaId, reason.trim()));
        } catch (err) {
            setOpenError((0, $0aae0b39fc034917$export$bab87a1130a0d7b8)(err, 'Could not open this record.'));
        } finally{
            setOpenBusy(false);
        }
    };
    const html = opened ? $d0e0fde18cf45dd8$var$documentHtml(opened.module, opened.document) : null;
    const readDocument = ()=>{
        if (!html) return;
        const tab = window.open('', '_blank');
        if (!tab) return;
        tab.document.open();
        tab.document.write(html);
        tab.document.close();
    };
    const download = ()=>{
        if (!opened || !opening) return;
        const blob = new Blob([
            JSON.stringify(opened, null, 2)
        ], {
            type: 'application/json'
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `advice-record-${opening.clientName.replace(/\W+/g, '-').toLowerCase()}-v${opened.version}.json`;
        a.click();
        URL.revokeObjectURL(url);
    };
    // Every screen, every answer — see adviceBasisSections.ts for why not the SOA's own appendix.
    const factSections = opened ? (0, $cb7cc8164588f412$export$3be459669bbc51cf)(opened.basis.factFind) : [];
    const subtitle = records === null ? "Loading\u2026" : `${groups.length} client${groups.length === 1 ? '' : 's'} \xb7 ${records.length} Statement${records.length === 1 ? '' : 's'} of Advice \xb7 read-only`;
    const soaLine = (r, primary)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "grid grid-cols-[minmax(0,1fr)_auto] items-center gap-3 sm:grid-cols-[7.5rem_minmax(0,1fr)_auto_auto]",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: `${primary ? 'font-semibold text-slate-900' : 'text-slate-700'}`,
                    children: [
                        $d0e0fde18cf45dd8$var$MODULE_LABELS[r.module] ?? r.module,
                        " \xb7 v",
                        r.version
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "hidden sm:block",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$eaa9dcd62e0d5ec6), {
                        color: r.status === 'published' ? '#059669' : '#94a3b8',
                        label: r.status === 'published' ? `Published ${$d0e0fde18cf45dd8$var$fmtDate(r.publishedAt)}` : `Draft ${$d0e0fde18cf45dd8$var$fmtDate(r.createdAt)}`
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "hidden text-xs text-slate-500 sm:block",
                    children: [
                        "Kept until ",
                        $d0e0fde18cf45dd8$var$fmtDate(r.keepUntil)
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: ()=>startOpen(r),
                    className: "justify-self-end rounded-lg bg-[#1a6fd4] px-3 py-1.5 text-xs font-semibold text-white transition hover:bg-[#155bb0] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1a6fd4]/40",
                    children: "Open record"
                })
            ]
        }, r.soaId);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $521cb9d4345e01f6$export$a49248195eaa6c68), {
        title: "Advice under our licence",
        subtitle: subtitle,
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $73a7d1cabb6a0e3c$export$2e2bcd8739ae039), {
            size: 22
        }),
        onBack: onBack,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mb-6 flex max-w-3xl items-start gap-2 text-sm leading-relaxed text-slate-600",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e20ffdae2aa9b33f$export$2e2bcd8739ae039), {
                        size: 15,
                        className: "mt-0.5 shrink-0 text-[#1a6fd4]"
                    }),
                    "Direct clients, and clients of firms that are not licensed themselves. Clients of advisers on their own AFSL are never shown. Opening this list, and every record, is recorded on the audit trail."
                ]
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$daed298da1cab5c8), {
                tone: "error",
                children: error
            }),
            records === null && !error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center justify-center gap-2 py-20 text-slate-400",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                        size: 18,
                        className: "animate-spin"
                    }),
                    " Loading\u2026"
                ]
            }) : records && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        className: "mb-5 flex max-w-md items-center gap-2 rounded-lg border border-slate-300 px-3 py-2.5 focus-within:border-[#1a6fd4] focus-within:ring-2 focus-within:ring-[#1a6fd4]/20",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                size: 16,
                                className: "text-slate-400"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "sr-only",
                                children: "Search"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                value: query,
                                onChange: (e)=>setQuery(e.target.value),
                                placeholder: "Search by client or firm",
                                className: "w-full bg-transparent text-sm outline-none"
                            })
                        ]
                    }),
                    groups.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "rounded-xl border border-dashed border-slate-300 py-14 text-center text-sm text-slate-500",
                        children: records.length === 0 ? 'No advice has been given under our licence yet.' : 'No client matches that search.'
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "divide-y divide-slate-200 rounded-xl border border-slate-200",
                                children: shown.map((g)=>{
                                    const [latest, ...older] = g.soas;
                                    const isOpen = expanded.has(g.profileId);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        className: "px-5 py-4",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "grid gap-3 text-sm md:grid-cols-[minmax(0,15rem)_minmax(0,1fr)]",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "min-w-0",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "font-semibold text-slate-900",
                                                            children: [
                                                                g.clientName,
                                                                g.partnerName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "font-normal text-slate-500",
                                                                    children: [
                                                                        " & ",
                                                                        g.partnerName
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-slate-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: g.channel === 'direct' ? 'Direct client' : `Via ${g.firmName ?? 'a firm'}`
                                                                }),
                                                                g.fileDeleted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$eaa9dcd62e0d5ec6), {
                                                                    color: "#d97706",
                                                                    label: "File deleted, record kept"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "space-y-2",
                                                    children: [
                                                        latest && soaLine(latest, true),
                                                        older.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            type: "button",
                                                            onClick: ()=>toggle(g.profileId),
                                                            "aria-expanded": isOpen,
                                                            className: "inline-flex items-center gap-1 text-xs font-semibold text-[#1a6fd4] hover:underline",
                                                            children: [
                                                                isOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                                                    size: 14
                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                                                    size: 14
                                                                }),
                                                                isOpen ? 'Hide earlier versions' : `${older.length} earlier version${older.length === 1 ? '' : 's'}`
                                                            ]
                                                        }),
                                                        isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "space-y-2 border-l-2 border-slate-100 pl-3",
                                                            children: older.map((r)=>soaLine(r, false))
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, g.profileId);
                                })
                            }),
                            pageCount > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-4 flex items-center justify-between text-sm text-slate-600",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "Clients ",
                                            page * $d0e0fde18cf45dd8$var$PAGE_SIZE + 1,
                                            "\u2013",
                                            Math.min(groups.length, (page + 1) * $d0e0fde18cf45dd8$var$PAGE_SIZE),
                                            " of ",
                                            groups.length
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "flex gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                disabled: page === 0,
                                                onClick: ()=>setPage((p)=>p - 1),
                                                className: "inline-flex items-center gap-1 rounded-lg border border-slate-300 px-3 py-1.5 font-medium disabled:opacity-40",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                                        size: 15
                                                    }),
                                                    " Previous"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                disabled: page >= pageCount - 1,
                                                onClick: ()=>setPage((p)=>p + 1),
                                                className: "inline-flex items-center gap-1 rounded-lg border border-slate-300 px-3 py-1.5 font-medium disabled:opacity-40",
                                                children: [
                                                    "Next ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                                        size: 15
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            opening && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-slate-900/60 p-4 backdrop-blur-[2px] sm:p-10",
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "record-title",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full max-w-3xl overflow-hidden rounded-2xl bg-white shadow-2xl ring-1 ring-slate-900/10",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-start justify-between gap-4 border-b border-slate-200 px-6 py-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            id: "record-title",
                                            className: "text-lg font-semibold text-slate-900",
                                            children: opening.clientName
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "text-sm text-slate-500",
                                            children: [
                                                $d0e0fde18cf45dd8$var$MODULE_LABELS[opening.module] ?? opening.module,
                                                " Statement of Advice \xb7 version ",
                                                opening.version
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: closeRecord,
                                    "aria-label": "Close",
                                    className: "rounded-lg p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                        size: 18
                                    })
                                })
                            ]
                        }),
                        !opened ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-3 px-6 py-6",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-sm font-semibold text-slate-800",
                                    htmlFor: "compliance-reason",
                                    children: "Why are you opening this record?"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "compliance-reason",
                                    value: reason,
                                    onChange: (e)=>setReason(e.target.value),
                                    onKeyDown: (e)=>{
                                        if (e.key === 'Enter') confirmOpen();
                                    },
                                    placeholder: "e.g. Quarterly advice review, or a complaint reference",
                                    maxLength: 300,
                                    autoFocus: true,
                                    className: "w-full rounded-lg border border-slate-300 px-3 py-2.5 text-sm outline-none focus:border-[#1a6fd4] focus:ring-2 focus:ring-[#1a6fd4]/20"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-xs text-slate-500",
                                    children: "Your reason is saved on the audit trail with your name and the time."
                                }),
                                openError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$daed298da1cab5c8), {
                                    tone: "error",
                                    children: openError
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex justify-end",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: confirmOpen,
                                        disabled: openBusy || reason.trim().length < 3,
                                        className: "inline-flex items-center gap-1.5 rounded-lg bg-[#1a6fd4] px-4 py-2 text-sm font-semibold text-white transition hover:bg-[#155bb0] disabled:bg-slate-300",
                                        children: [
                                            openBusy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                size: 14,
                                                className: "animate-spin"
                                            }),
                                            " Open record"
                                        ]
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-6 px-6 py-6 text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dl", {
                                    className: "grid grid-cols-2 gap-x-6 gap-y-4 sm:grid-cols-4",
                                    children: [
                                        [
                                            'Status',
                                            opened.status === 'published' ? `Published ${$d0e0fde18cf45dd8$var$fmtDate(opened.publishedAt)}` : `Draft, ${$d0e0fde18cf45dd8$var$fmtDate(opened.createdAt)}`
                                        ],
                                        [
                                            'Licensee',
                                            opened.licenseeName ? `${opened.licenseeName}${opened.afslNumber ? ` \xb7 AFSL ${opened.afslNumber}` : ''}` : 'Not recorded'
                                        ],
                                        [
                                            'Kept until',
                                            $d0e0fde18cf45dd8$var$fmtDate(opened.keepUntil)
                                        ],
                                        [
                                            'Details sealed',
                                            $d0e0fde18cf45dd8$var$fmtDate(opened.basisSealedAt)
                                        ]
                                    ].map(([k, v])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                                    className: "text-[11px] font-semibold uppercase tracking-[0.08em] text-slate-500",
                                                    children: k
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                                    className: "mt-1 text-slate-900",
                                                    children: v
                                                })
                                            ]
                                        }, k))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-wrap items-center gap-3 rounded-xl border border-slate-200 px-4 py-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                            size: 18,
                                            className: "shrink-0 text-[#1a6fd4]"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "min-w-0 flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "font-semibold text-slate-900",
                                                    children: "The Statement of Advice"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "text-xs text-slate-500",
                                                    children: html ? 'Opens in a new tab, as the client saw it.' : 'This version was saved without its printable document; the record below is complete.'
                                                })
                                            ]
                                        }),
                                        html && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: readDocument,
                                            className: "rounded-lg bg-[#1a6fd4] px-3.5 py-2 text-sm font-semibold text-white transition hover:bg-[#155bb0]",
                                            children: "Read the Statement of Advice"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: "mb-2 text-[11px] font-semibold uppercase tracking-[0.08em] text-slate-500",
                                            children: "Client, as at the advice"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dl", {
                                            className: "grid gap-x-8 gap-y-2 sm:grid-cols-2",
                                            children: $d0e0fde18cf45dd8$var$identityRows(opened.basis.identity).map(([k, v])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "grid grid-cols-[8.5rem_minmax(0,1fr)] gap-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                                            className: "text-slate-500",
                                                            children: k
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                                            className: "break-words text-slate-900",
                                                            children: v
                                                        })
                                                    ]
                                                }, k))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: "mb-2 text-[11px] font-semibold uppercase tracking-[0.08em] text-slate-500",
                                            children: "What the advice was based on"
                                        }),
                                        factSections.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-slate-500",
                                            children: "No fact-find details were recorded."
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "space-y-2",
                                            children: factSections.map((section)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                                                    className: "rounded-lg border border-slate-200",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("summary", {
                                                            className: "cursor-pointer px-4 py-2.5 font-medium text-slate-800",
                                                            children: section.title
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dl", {
                                                            className: "divide-y divide-slate-100 border-t border-slate-200",
                                                            children: section.rows.map((row, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)] gap-4 px-4 py-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                                                            className: "text-slate-500",
                                                                            children: row.label
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                                                            className: "break-words text-slate-900",
                                                                            children: row.value
                                                                        })
                                                                    ]
                                                                }, `${row.label}-${i}`))
                                                        })
                                                    ]
                                                }, section.title))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                                    className: "rounded-lg border border-dashed border-slate-300",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("summary", {
                                            className: "cursor-pointer px-4 py-2.5 text-slate-600",
                                            children: "Technical record (raw data, for IT or a regulator's request)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "space-y-3 border-t border-slate-200 px-4 py-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                                                    className: "max-h-64 overflow-auto font-mono text-xs leading-relaxed text-slate-700",
                                                    children: JSON.stringify(opened.basis.factFind, null, 2)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                                                    className: "max-h-64 overflow-auto font-mono text-xs leading-relaxed text-slate-700",
                                                    children: JSON.stringify(opened.document, null, 2)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    onClick: download,
                                                    className: "inline-flex items-center gap-1.5 rounded-lg border border-slate-300 px-3 py-2 text-sm font-medium text-slate-700 transition hover:border-slate-400 hover:text-slate-900",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d252ca8c87a49232$export$2e2bcd8739ae039), {
                                                            size: 15
                                                        }),
                                                        " Download the full record"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $d0e0fde18cf45dd8$export$2e2bcd8739ae039 = $d0e0fde18cf45dd8$var$ComplianceConsole;


/**
 * Platform owner/super-admin REST API documentation (linked from AdminConsole). Renders the
 * generated OpenAPI 3 document (GET /rest/admin/openapi.json — see server/src/app.ts's
 * @fastify/swagger registration) with ReDoc, an industry-standard OpenAPI renderer. Admin-only:
 * gated the same way as every other /rest/admin/* call — a non-admin caller's fetch simply 403s.
 *
 * Rendered inside a same-origin(-to-the-API) <iframe> running redoc's own prebuilt standalone
 * bundle, fetched from the API server (GET /vendor/redoc-standalone.js — see app.ts) rather than
 * bundled by Parcel or loaded straight into this page:
 *   - redoc's React wrapper package ships ONLY prebuilt webpack bundles as its main/browser
 *     entries (no raw ESM source); those bundles embed internal `webpack://` source-map
 *     references that Parcel tries to resolve as real file paths and fails the build on.
 *   - The standalone bundle (redoc's own documented drop-in <script> embed) is a classic UMD
 *     build that feature-detects its environment via `typeof module === 'object'`. Referencing it
 *     through Parcel's asset graph at all — even via a raw/no-parse pipeline — still wraps the
 *     output in Parcel's own JS module runtime (`module = {...}` etc.), which makes the UMD check
 *     wrongly take the CommonJS branch and throw ("Cannot find module 'null'"). Serving it from
 *     the API as a byte-for-byte static file sidesteps Parcel entirely; the iframe then gives it
 *     a clean global scope of its own, same as any "embed a legacy third-party widget" pattern.
 */ 

var $acw62 = parcelRequire("acw62");




// Under /rest/vendor, from the shared constant, and not a hand-written /vendor: on the deployment
// where the app and the API share an origin only /rest, /oauth and /webhooks reach the API, so a
// /vendor url was answered with the app's own index.html — the iframe then ran a page of HTML as
// JavaScript, no Redoc global ever appeared, and this console could say only that the renderer
// failed to load. See shared/src/api/routePaths.ts.
const $5d916b5e4cd7b884$var$redocScriptUrl = `${(0, $0aae0b39fc034917$export$4d28219d42798a75)()}${(0, $513a114750c50b5a$export$d53cd462a7c8d50d)}/redoc-standalone.js`;
const $5d916b5e4cd7b884$var$IFRAME_HTML = `<!doctype html>
<html>
<head><meta charset="utf-8"><style>html,body,#redoc-container{margin:0;padding:0;height:100%}</style></head>
<body><div id="redoc-container"></div><script src="${$5d916b5e4cd7b884$var$redocScriptUrl}"></script></body>
</html>`;
const $5d916b5e4cd7b884$var$ApiDocsConsole = ({ onBack: onBack })=>{
    const [spec, setSpec] = (0, $acw62.useState)(null); // null = loading
    const [error, setError] = (0, $acw62.useState)(null);
    const iframeRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        let live = true;
        (0, $0aae0b39fc034917$export$2f21c3786b41ab81)().then((data)=>{
            if (live) setSpec(data);
        }).catch((err)=>{
            if (live) setError((0, $0aae0b39fc034917$export$bab87a1130a0d7b8)(err, 'Could not load the API documentation just now.'));
        });
        return ()=>{
            live = false;
        };
    }, []);
    const handleIframeLoad = ()=>{
        if (!spec || !iframeRef.current) return;
        const frameWindow = iframeRef.current.contentWindow;
        const frameDoc = iframeRef.current.contentDocument;
        if (!frameWindow?.Redoc || !frameDoc) {
            setError('The API documentation renderer failed to load.');
            return;
        }
        frameWindow.Redoc.init(spec, {
            hideDownloadButton: false,
            expandResponses: '200,201',
            jsonSampleExpandLevel: 2,
            sortPropsAlphabetically: false,
            theme: {
                colors: {
                    primary: {
                        main: '#0F52E0'
                    }
                }
            }
        }, frameDoc.getElementById('redoc-container'));
    };
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$a49248195eaa6c68), {
        title: "API documentation",
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f6409c0860044c1d$export$2e2bcd8739ae039), {
            size: 22
        }),
        onBack: onBack,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $521cb9d4345e01f6$export$daed298da1cab5c8), {
            tone: "error",
            children: error
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex min-h-screen flex-col bg-white",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "px-4 py-3 sm:px-8",
                style: {
                    background: (0, $521cb9d4345e01f6$export$cc80f7155587094a)
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    type: "button",
                    onClick: onBack,
                    className: "inline-flex items-center gap-1.5 text-sm text-white/70 transition hover:text-white",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                            size: 15
                        }),
                        " Back to admin console"
                    ]
                })
            }),
            !spec ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-1 items-center justify-center gap-2 text-slate-400",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                        size: 20,
                        className: "animate-spin"
                    }),
                    " Loading API documentation\u2026"
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                ref: iframeRef,
                title: "REST API documentation",
                srcDoc: $5d916b5e4cd7b884$var$IFRAME_HTML,
                onLoad: handleIframeLoad,
                className: "flex-1 border-0"
            })
        ]
    });
};
var $5d916b5e4cd7b884$export$2e2bcd8739ae039 = $5d916b5e4cd7b884$var$ApiDocsConsole;


/**
 * Consumer paywall (Option A — pay at Get Started, before the fact-find). Only ever shown when
 * billing is live AND the signed-in consumer has no active access. Redirects to Stripe hosted
 * Checkout; on return the app re-checks entitlement and lets them in.
 */ 

var $acw62 = parcelRequire("acw62");


const $2e7682735b2509c0$var$INCLUDED = [
    "Your full personalised plan \u2014 fees, cashflow, Age Pension and estate outcomes over time",
    'Model it yourself, or let the Suggestion Engine compare strategies for you',
    'Your Statement of Advice and the AI assistant',
    "Everything saved securely \u2014 revisit any time during your access period"
];
const $2e7682735b2509c0$var$Paywall = ({ onSignOut: onSignOut, notice: notice })=>{
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const pay = async ()=>{
        setBusy(true);
        setError(null);
        try {
            const res = await (0, $9969e0eb851fd9fb$export$b439f56cc3105c)('consumer');
            if (!res.ok) {
                setError(res.message || 'Could not start the payment page. Please try again.');
                setBusy(false);
            }
        // On success the browser navigates to Stripe — no further UI needed here.
        } catch  {
            setError("We couldn\u2019t reach the payment service. Please try again in a moment.");
            setBusy(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "min-h-screen flex items-center justify-center bg-slate-50 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-2xl ring-1 ring-black/5",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "relative overflow-hidden bg-gradient-to-br from-[#1a6fd4] to-[#17b8e0] px-6 pt-7 pb-8 text-center text-white",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "pointer-events-none absolute -right-8 -top-10 h-32 w-32 rounded-full bg-white/10 blur-2xl"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/25 backdrop-blur",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e20ffdae2aa9b33f$export$2e2bcd8739ae039), {
                                className: "h-7 w-7"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            className: "text-2xl font-bold",
                            children: "Unlock your full plan"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mt-1 text-sm text-white/85",
                            children: "Full access for 4 months \u2014 one payment, no auto-renewal"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "p-6 space-y-5",
                    children: [
                        notice && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-start gap-2.5 rounded-xl border border-blue-200 bg-white px-4 py-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                    size: 16,
                                    className: "mt-0.5 shrink-0 text-blue-600"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-blue-800",
                                    children: notice
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-3xl font-bold text-slate-900",
                                    children: "$480"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-sm text-slate-500",
                                    children: "for 4 months of full access"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                            className: "space-y-2.5",
                            children: $2e7682735b2509c0$var$INCLUDED.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    className: "flex items-start gap-2.5 text-sm text-slate-700",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-600",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                                size: 13
                                            })
                                        }),
                                        item
                                    ]
                                }, item))
                        }),
                        error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-start gap-2.5 rounded-xl border border-red-200 bg-red-50 px-4 py-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                    size: 16,
                                    className: "mt-0.5 shrink-0 text-red-600"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-red-700",
                                    children: error
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: pay,
                            disabled: busy,
                            className: "w-full inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#1a6fd4] to-[#17b8e0] py-3 font-semibold text-white shadow-lg shadow-blue-600/25 transition hover:shadow-xl hover:brightness-[1.04] disabled:opacity-50 disabled:cursor-not-allowed",
                            children: busy ? "Taking you to secure payment\u2026" : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "Pay securely & continue ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                        size: 16
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center justify-center gap-1.5 text-xs text-slate-400",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                    size: 13
                                }),
                                " Secure payment by Stripe \xb7 Your card details never touch our servers"
                            ]
                        }),
                        onSignOut && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            onClick: onSignOut,
                            className: "flex w-full items-center justify-center gap-1.5 text-sm text-slate-500 transition hover:text-slate-700",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5473793717b51056$export$2e2bcd8739ae039), {
                                    size: 14
                                }),
                                " Sign out"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $2e7682735b2509c0$export$2e2bcd8739ae039 = $2e7682735b2509c0$var$Paywall;


/**
 * Partner billing SETUP screen. Shown when a firm member enters the portal but the FIRM hasn't
 * chosen a billing option yet (server reports summary.mode === 'none'), and billing is live.
 *
 * The firm picks ONE of two ways to pay (the client never pays the adviser through the app):
 *   • Annual plan   — $800+GST/yr, includes 20 clients (then $70 each). A Stripe subscription.
 *   • Pay per client — $336+GST per client. Choosing this charges the FIRST client now; each later
 *                      client is charged when they take it on.
 * Only the firm owner can do this (server also enforces owner + aal2). Safe while billing is off —
 * the server reports mode null and this screen never appears.
 */ 

var $acw62 = parcelRequire("acw62");


const $057f29bbee31fc12$var$ANNUAL_POINTS = [
    'Up to 20 active clients included',
    'Then just $70 + GST per extra client',
    'Best value once you have a handful of clients'
];
const $057f29bbee31fc12$var$PAYG_POINTS = [
    'Pay only for the clients you take on',
    'No yearly commitment',
    'Switch to the annual plan any time'
];
const $057f29bbee31fc12$var$PartnerSubscribe = ({ firmName: firmName, tenantId: tenantId, onSignOut: onSignOut })=>{
    const [busy, setBusy] = (0, $acw62.useState)(null); // 'partner' | 'partner_client' | null
    const [error, setError] = (0, $acw62.useState)(null);
    const choose = async (plan)=>{
        setBusy(plan);
        setError(null);
        try {
            const res = await (0, $9969e0eb851fd9fb$export$b439f56cc3105c)(plan, tenantId);
            if (!res.ok) {
                setError(res.message || 'Could not start the payment page. Please try again.');
                setBusy(null);
            }
        } catch  {
            setError("We couldn\u2019t reach the payment service. Please try again in a moment.");
            setBusy(null);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "min-h-screen flex items-center justify-center bg-slate-50 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "w-full max-w-2xl overflow-hidden rounded-3xl bg-white shadow-2xl ring-1 ring-black/5",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "relative overflow-hidden bg-gradient-to-br from-[#1a6fd4] to-[#17b8e0] px-6 pt-7 pb-8 text-center text-white",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "pointer-events-none absolute -right-8 -top-10 h-32 w-32 rounded-full bg-white/10 blur-2xl"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/25 backdrop-blur",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $224502d93617e0e1$export$2e2bcd8739ae039), {
                                className: "h-7 w-7"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                            className: "text-2xl font-bold",
                            children: [
                                "Choose how ",
                                firmName || 'your firm',
                                " pays"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mt-1 text-sm text-white/85",
                            children: "Pick the option that suits you \u2014 you can change later"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "p-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "grid gap-4 sm:grid-cols-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-col rounded-2xl border-2 border-[#1a6fd4]/30 bg-white p-5",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mb-1 flex items-center gap-2 text-[#1a6fd4]",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c62dd403424a2a8$export$2e2bcd8739ae039), {
                                                    size: 18
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-sm font-semibold uppercase tracking-wide",
                                                    children: "Annual plan"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "text-3xl font-bold text-slate-900",
                                            children: [
                                                "$800",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-base font-semibold text-slate-500",
                                                    children: " + GST"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "mb-3 text-sm text-slate-500",
                                            children: "per year"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                            className: "mb-4 space-y-2 text-sm text-slate-700",
                                            children: $057f29bbee31fc12$var$ANNUAL_POINTS.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    className: "flex items-start gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-600",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                                                size: 12
                                                            })
                                                        }),
                                                        p
                                                    ]
                                                }, p))
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>choose('partner'),
                                            disabled: busy !== null,
                                            className: "mt-auto inline-flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#1a6fd4] to-[#17b8e0] py-3 font-semibold text-white shadow-lg shadow-blue-600/25 transition hover:brightness-[1.04] disabled:opacity-50",
                                            children: busy === 'partner' ? "Taking you to payment\u2026" : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    "Choose annual ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                        size: 16
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-col rounded-2xl border border-slate-200 p-5",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mb-1 flex items-center gap-2 text-slate-600",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09365e579c2377bf$export$2e2bcd8739ae039), {
                                                    size: 18
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-sm font-semibold uppercase tracking-wide",
                                                    children: "Pay per client"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "text-3xl font-bold text-slate-900",
                                            children: [
                                                "$336",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-base font-semibold text-slate-500",
                                                    children: " + GST"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "mb-3 text-sm text-slate-500",
                                            children: "per client"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                            className: "mb-4 space-y-2 text-sm text-slate-700",
                                            children: $057f29bbee31fc12$var$PAYG_POINTS.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    className: "flex items-start gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-slate-100 text-slate-500",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                                                size: 12
                                                            })
                                                        }),
                                                        p
                                                    ]
                                                }, p))
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>choose('partner_client'),
                                            disabled: busy !== null,
                                            className: "mt-auto inline-flex w-full items-center justify-center gap-2 rounded-xl border-2 border-[#1a6fd4] py-3 font-semibold text-[#1a6fd4] transition hover:bg-blue-50 disabled:opacity-50",
                                            children: busy === 'partner_client' ? "Taking you to payment\u2026" : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    "Start with 1 client ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                        size: 16
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mt-3 text-center text-xs text-slate-400",
                            children: "Choosing \u201Cpay per client\u201D charges for your first client now; you\u2019re only charged again when you take on another."
                        }),
                        error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mt-4 flex items-start gap-2.5 rounded-xl border border-red-200 bg-red-50 px-4 py-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                    size: 16,
                                    className: "mt-0.5 shrink-0 text-red-600"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-red-700",
                                    children: error
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mt-5 flex items-center justify-center gap-1.5 text-xs text-slate-400",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                    size: 13
                                }),
                                " Secure payment by Stripe \xb7 Cancel any time from your billing portal"
                            ]
                        }),
                        onSignOut && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            onClick: onSignOut,
                            className: "mt-3 flex w-full items-center justify-center gap-1.5 text-sm text-slate-500 transition hover:text-slate-700",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5473793717b51056$export$2e2bcd8739ae039), {
                                    size: 14
                                }),
                                " Sign out"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $057f29bbee31fc12$export$2e2bcd8739ae039 = $057f29bbee31fc12$var$PartnerSubscribe;


/**
 * Shown inside the portal when an adviser tries to take on a client but the firm is out of paid
 * capacity. What it offers depends on the server's `summary.needs`:
 *   'partner_client'  — pay-as-you-go firm: $336 for this client, or switch to the annual plan.
 *   'partner_overage' — annual firm past its included 20: $70 for this extra client.
 * Every button routes to Stripe hosted Checkout; on return the adviser adds the client again with
 * capacity available. Only the firm owner will succeed (the server enforces owner + aal2).
 */ 

var $acw62 = parcelRequire("acw62");


const $779f7aef03fcc8b3$var$AddClientPaywall = ({ summary: summary, tenantId: tenantId, onClose: onClose })=>{
    const [busy, setBusy] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    const needs = summary?.needs || 'partner_client';
    const isOverage = needs === 'partner_overage';
    const go = async (plan)=>{
        setBusy(plan);
        setError(null);
        try {
            const res = await (0, $9969e0eb851fd9fb$export$b439f56cc3105c)(plan, tenantId);
            if (!res.ok) {
                setError(res.message || 'Could not start the payment page. Please try again.');
                setBusy(null);
            }
        } catch  {
            setError("We couldn\u2019t reach the payment service. Please try again in a moment.");
            setBusy(null);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4 backdrop-blur-sm",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-2xl",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-start justify-between border-b border-slate-100 p-5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "text-lg font-bold text-slate-900",
                                    children: isOverage ? 'One more client' : 'Add another client'
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-0.5 text-sm text-slate-500",
                                    children: isOverage ? "Your annual plan includes 20 clients \u2014 this one is extra." : "You\u2019ve used the clients you\u2019ve paid for so far."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: onClose,
                            className: "rounded-lg p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-600",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 18
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "space-y-3 p-5",
                    children: [
                        isOverage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            onClick: ()=>go('partner_overage'),
                            disabled: busy !== null,
                            className: "flex w-full items-center justify-between gap-2 rounded-xl bg-gradient-to-r from-[#1a6fd4] to-[#17b8e0] px-4 py-3.5 text-left font-semibold text-white shadow-lg shadow-blue-600/25 transition hover:brightness-[1.04] disabled:opacity-50",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09365e579c2377bf$export$2e2bcd8739ae039), {
                                            size: 17
                                        }),
                                        " Add this client \u2014 $70 + GST"
                                    ]
                                }),
                                busy === 'partner_overage' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-sm",
                                    children: "One moment\u2026"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                    size: 16
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>go('partner_client'),
                                    disabled: busy !== null,
                                    className: "flex w-full items-center justify-between gap-2 rounded-xl bg-gradient-to-r from-[#1a6fd4] to-[#17b8e0] px-4 py-3.5 text-left font-semibold text-white shadow-lg shadow-blue-600/25 transition hover:brightness-[1.04] disabled:opacity-50",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09365e579c2377bf$export$2e2bcd8739ae039), {
                                                    size: 17
                                                }),
                                                " Add this client \u2014 $336 + GST"
                                            ]
                                        }),
                                        busy === 'partner_client' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-sm",
                                            children: "One moment\u2026"
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                            size: 16
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>go('partner'),
                                    disabled: busy !== null,
                                    className: "flex w-full items-center justify-between gap-2 rounded-xl border-2 border-[#1a6fd4] px-4 py-3.5 text-left font-semibold text-[#1a6fd4] transition hover:bg-blue-50 disabled:opacity-50",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c62dd403424a2a8$export$2e2bcd8739ae039), {
                                                    size: 17
                                                }),
                                                " Switch to annual \u2014 $800 + GST/yr"
                                            ]
                                        }),
                                        busy === 'partner' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-sm",
                                            children: "One moment\u2026"
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                            size: 16
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-center text-xs text-slate-400",
                                    children: "The annual plan includes 20 clients, then $70 each."
                                })
                            ]
                        }),
                        error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-start gap-2.5 rounded-xl border border-red-200 bg-red-50 px-4 py-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                    size: 16,
                                    className: "mt-0.5 shrink-0 text-red-600"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-red-700",
                                    children: error
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center justify-center gap-1.5 pt-1 text-xs text-slate-400",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                    size: 13
                                }),
                                " Secure payment by Stripe"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $779f7aef03fcc8b3$export$2e2bcd8739ae039 = $779f7aef03fcc8b3$var$AddClientPaywall;


/**
 * LandingPage – entry screen with topic cards (Living Arrangements, Funding, Impacts, Next Steps).
 * Used by App.js when activePage === 'LandingPage'.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $28949866b6a8641c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2 6h4",
            key: "aawbzj"
        }
    ],
    [
        "path",
        {
            d: "M2 10h4",
            key: "l0bgd4"
        }
    ],
    [
        "path",
        {
            d: "M2 14h4",
            key: "1gsvsf"
        }
    ],
    [
        "path",
        {
            d: "M2 18h4",
            key: "1bu2t1"
        }
    ],
    [
        "rect",
        {
            width: "16",
            height: "20",
            x: "4",
            y: "2",
            rx: "2",
            key: "1nb95v"
        }
    ],
    [
        "path",
        {
            d: "M9.5 8h5",
            key: "11mslq"
        }
    ],
    [
        "path",
        {
            d: "M9.5 12H16",
            key: "ktog6x"
        }
    ],
    [
        "path",
        {
            d: "M9.5 16H14",
            key: "p1seyn"
        }
    ]
];
const $28949866b6a8641c$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("notebook-text", $28949866b6a8641c$export$3efd853dbb351e94);








const $f216bfa0510b464b$var$LIVING_PATHWAY_PILLS = [
    'Support at home',
    'Downsizing',
    'Retirement village',
    'Granny flat',
    'Aged care'
];
const $f216bfa0510b464b$var$TopicCard = ({ icon: Icon, title: title, text: text, onClick: onClick })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: onClick,
        className: "group relative bg-white/80 backdrop-blur-xl p-6 rounded-2xl text-left transition-all duration-300 cursor-pointer border border-gray-200/50 overflow-hidden hover:shadow-2xl hover:shadow-blue-200/50 hover:-translate-y-2 hover:border-blue-300/50",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute top-0 left-0 w-full h-full bg-gradient-to-br from-blue-50 via-transparent to-teal-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative z-10",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "w-14 h-14 mb-4 rounded-xl flex items-center justify-center bg-gradient-to-br from-blue-500 to-teal-400 text-white shadow-lg shadow-blue-500/30 group-hover:scale-110 transition-transform duration-300",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                            size: 32,
                            className: "group-hover:scale-110 transition-transform duration-300"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-xl font-bold text-gray-900 mb-2 group-hover:text-blue-700 transition-colors duration-300",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-gray-600 group-hover:text-gray-700 transition-colors duration-300",
                        children: text
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                size: 24,
                className: "absolute bottom-6 right-6 text-gray-400 opacity-0 group-hover:opacity-100 group-hover:translate-x-0 translate-x-4 transition-all duration-300 group-hover:text-blue-500"
            })
        ]
    });
const $f216bfa0510b464b$var$LandingPage = ({ setShowGeneralAdvice: setShowGeneralAdvice, setShowRegistration: setShowRegistration, onProfessionalLogin: onProfessionalLogin, onClientLogin: onClientLogin, onOpenSecurity: onOpenSecurity, onOpenPrivacy: onOpenPrivacy, onOpenCost: onOpenCost, onOpenExperience: onOpenExperience, onOpenFaqs: onOpenFaqs })=>{
    const [chatOpen, setChatOpen] = (0, $acw62.useState)(false);
    const [chatMessages, setChatMessages] = (0, $acw62.useState)([
        {
            sender: 'bot',
            text: (0, $076d4db919791ede$export$c772c4977cceb0b8)
        }
    ]);
    const [chatInput, setChatInput] = (0, $acw62.useState)('');
    const [chatSending, setChatSending] = (0, $acw62.useState)(false);
    const topics = [
        {
            icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
            title: "Living Arrangements",
            text: "Explore support at home, downsizing, retirement villages, granny flats, or aged care facilities.",
            section: "living"
        },
        {
            icon: (0, $52885985d1db6c06$export$2e2bcd8739ae039),
            title: "Funding Options",
            text: "Understand costs: keep/sell your home, RAD vs DAP, or government subsidies.",
            section: "funding"
        },
        {
            icon: (0, $95e9e50748ea8ef2$export$2e2bcd8739ae039),
            title: "Care & Financial Impacts",
            text: "See how your choices affect cash flow, pensions, estate planning & risk.",
            section: "impacts"
        },
        {
            icon: (0, $28949866b6a8641c$export$2e2bcd8739ae039),
            title: "Next Steps",
            text: "Get actionable tasks: paperwork, expert contacts, and timelines.",
            section: "nextSteps"
        }
    ];
    const submitChatMessage = (0, $acw62.useCallback)(async ()=>{
        const trimmed = chatInput.trim();
        if (!trimmed || chatSending) return;
        setChatOpen(true);
        setChatSending(true);
        const history = chatMessages;
        setChatMessages((msgs)=>[
                ...msgs,
                {
                    sender: 'user',
                    text: trimmed
                }
            ]);
        setChatInput('');
        try {
            const aiReply = await (0, $17f95ada13b08766$export$58ecd998c8d4e9d3)({
                message: trimmed,
                systemInstruction: (0, $076d4db919791ede$export$c25880153d3c2847),
                conversationHistory: history
            });
            setChatMessages((msgs)=>[
                    ...msgs,
                    {
                        sender: 'bot',
                        text: aiReply
                    }
                ]);
        } catch (e) {
            setChatMessages((msgs)=>[
                    ...msgs,
                    {
                        sender: 'bot',
                        text: 'Something went wrong sending your message. You can try again in a moment.'
                    }
                ]);
        } finally{
            setChatSending(false);
        }
    }, [
        chatInput,
        chatSending,
        chatMessages
    ]);
    const openChat = ()=>setChatOpen(true);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative min-h-screen w-full bg-[#F0F7FF] font-sans text-gray-800 overflow-x-hidden",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute inset-0 -z-10",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "absolute top-0 left-0 w-full h-[60vh] bg-gradient-to-b from-blue-100 via-blue-50 to-transparent"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("header", {
                className: "absolute top-0 left-0 right-0 z-10 px-4 sm:px-6 py-4 md:py-5 max-w-screen-2xl mx-auto w-full",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-3 md:gap-3.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center justify-between gap-3 min-w-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "shrink-0 min-w-0 flex items-center gap-0.5 sm:gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, $fa6d1caa5fe64367$export$6c23acffafc6aa0a),
                                            alt: "",
                                            width: 80,
                                            height: 80,
                                            className: "h-[3.35rem] w-[3.35rem] sm:h-[4.45rem] sm:w-[4.45rem] md:h-[5.55rem] md:w-[5.55rem] shrink-0 object-contain object-left select-none -mr-2.5 sm:-mr-3 md:-mr-3.5",
                                            decoding: "async",
                                            draggable: false
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $421c0497858a4b09$export$2e2bcd8739ae039), {
                                            className: "h-12 sm:h-16 md:h-20 w-auto min-w-0"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "shrink-0 flex flex-col gap-2 w-full max-w-[15rem] sm:max-w-[16rem] md:max-w-[18rem]",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "flex-1 min-w-0 text-center text-[11px] sm:text-xs font-semibold rounded-full border-2 border-blue-600/70 text-blue-700 bg-white/20 backdrop-blur-md hover:bg-white/35 hover:border-blue-600 py-2 px-1.5 sm:px-2 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500/60 focus:ring-offset-2 leading-tight shadow-sm shadow-blue-900/10",
                                                    onClick: ()=>{
                                                        if (onClientLogin) onClientLogin();
                                                    },
                                                    children: "Client Login"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "flex-1 min-w-0 text-center text-[11px] sm:text-xs font-semibold rounded-full border-2 border-blue-600/70 text-blue-700 bg-white/20 backdrop-blur-md hover:bg-white/35 hover:border-blue-600 py-2 px-1.5 sm:px-2 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500/60 focus:ring-offset-2 leading-tight shadow-sm shadow-blue-900/10",
                                                    onClick: ()=>{
                                                        if (onProfessionalLogin) onProfessionalLogin();
                                                    },
                                                    children: "Partner Portal"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>{
                                                setShowRegistration(true);
                                            },
                                            className: "w-full bg-blue-600 text-white font-semibold py-2.5 rounded-full text-sm shadow-lg hover:bg-blue-700 hover:shadow-xl transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2",
                                            children: "Get Started"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                            className: "hidden md:flex items-center justify-center gap-x-4 lg:gap-x-6 xl:gap-x-8 flex-wrap text-gray-600 font-medium text-xs lg:text-sm leading-normal",
                            "aria-label": "Site sections",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>onOpenExperience && onOpenExperience(),
                                    className: "whitespace-nowrap hover:text-blue-600 transition-colors duration-300",
                                    children: "The Experience"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>onOpenCost && onOpenCost(),
                                    className: "whitespace-nowrap hover:text-blue-600 transition-colors duration-300",
                                    children: "The Cost"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>onOpenPrivacy && onOpenPrivacy(),
                                    className: "whitespace-nowrap hover:text-blue-600 transition-colors duration-300",
                                    children: "Privacy"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>onOpenSecurity && onOpenSecurity(),
                                    className: "whitespace-nowrap hover:text-blue-600 transition-colors duration-300",
                                    children: "Security"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>onOpenFaqs && onOpenFaqs(),
                                    className: "whitespace-nowrap hover:text-blue-600 transition-colors duration-300",
                                    children: "FAQs"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "#",
                                    className: "whitespace-nowrap hover:text-blue-600 transition-colors duration-300",
                                    children: "About Us"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d5b7fd8298af6838$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                className: "relative pt-36 md:pt-48 pb-24 flex flex-col items-center text-center px-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bg-blue-100 text-blue-700 font-semibold px-4 py-1.5 rounded-full mb-4 text-sm",
                        children: "Your Personal Aged Care Adviser"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                        className: "text-4xl md:text-6xl font-bold text-gray-900 max-w-4xl leading-tight",
                        children: [
                            "Navigate your ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6288781efbc92679$export$2e2bcd8739ae039), {
                                children: "Retirement"
                            }),
                            " & ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6288781efbc92679$export$2e2bcd8739ae039), {
                                children: "Aged Care"
                            }),
                            " Living Decisions"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mt-5 max-w-2xl text-base sm:text-lg text-gray-600 leading-relaxed",
                        children: [
                            "Explore how different living arrangements impact your cashflow, Age Pension, and what's left to your estate.",
                            ' ',
                            "Let us work through strategies to improve your outcomes."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-6 flex flex-wrap items-center justify-center gap-2 max-w-3xl",
                        role: "list",
                        "aria-label": "Living pathways",
                        children: $f216bfa0510b464b$var$LIVING_PATHWAY_PILLS.map((label)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                role: "listitem",
                                className: "px-3 py-1.5 rounded-full bg-white/80 border border-blue-200 text-sm font-medium text-slate-700 backdrop-blur-sm",
                                children: label
                            }, label))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-8 flex flex-col md:flex-row items-center gap-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white/70 backdrop-blur-sm p-3 rounded-full shadow-md flex items-center gap-3 hover:bg-white/80 hover:shadow-lg transition-all duration-300",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                        className: "text-blue-500"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-semibold",
                                        children: "Data is Secure"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white/70 backdrop-blur-sm p-3 rounded-full shadow-md flex items-center gap-3 hover:bg-white/80 hover:shadow-lg transition-all duration-300",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c38b5b11d1e2b813$export$2e2bcd8739ae039), {
                                        className: "text-teal-500"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-semibold",
                                        children: "Built by Advisers"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 w-full max-w-screen-xl",
                        children: topics.map((topic, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f216bfa0510b464b$var$TopicCard, {
                                ...topic,
                                onClick: ()=>{
                                    setShowGeneralAdvice(topic.section);
                                }
                            }, i))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("footer", {
                className: "sticky bottom-6 w-full max-w-3xl mx-auto px-4 z-30",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "bg-white/80 backdrop-blur-lg rounded-xl shadow-2xl shadow-blue-200/50 p-3 flex items-center gap-3 hover:shadow-3xl hover:shadow-blue-300/50 transition-all duration-300",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: openChat,
                            className: "shrink-0 text-blue-600 hover:text-blue-800 p-1 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/50",
                            "aria-label": "Open AWise chat",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8afc40d49a7e79bf$export$2e2bcd8739ae039), {
                                className: "h-8 w-8"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            placeholder: "What's on your mind?",
                            className: "w-full bg-transparent focus:outline-none text-gray-700 placeholder-gray-500 text-sm sm:text-base",
                            "aria-label": "Ask AWise",
                            value: chatInput,
                            onChange: (e)=>setChatInput(e.target.value),
                            onFocus: openChat,
                            onKeyDown: (e)=>{
                                if (e.key !== 'Enter' || e.shiftKey) return;
                                e.preventDefault();
                                submitChatMessage();
                            },
                            disabled: chatSending
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "bg-blue-600 p-2 rounded-lg text-white hover:bg-blue-700 hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-60 shrink-0",
                            onClick: submitChatMessage,
                            disabled: chatSending || !chatInput.trim(),
                            "aria-label": "Send message",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                size: 20
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e31cd18cd0725a6f$export$2e2bcd8739ae039), {
                open: chatOpen,
                onClose: ()=>setChatOpen(false),
                messages: chatMessages,
                chatInput: chatInput,
                onChatInputChange: setChatInput,
                onSubmit: submitChatMessage,
                sending: chatSending,
                onSubscribe: ()=>setShowRegistration(true),
                subscribeLabel: "Get Started"
            })
        ]
    });
};
var $f216bfa0510b464b$export$2e2bcd8739ae039 = $f216bfa0510b464b$var$LandingPage;


/**
 * Account modal — real sign-up / sign-in / password reset / settings, backed by our own OAuth2
 * backend. This is the user's first branded touch-point, so it's designed to feel premium:
 * a gradient hero, icon-led inputs, gradient CTAs and a trust footer.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1b19608dd471de3d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 13v8l-4-4",
            key: "1f5nwf"
        }
    ],
    [
        "path",
        {
            d: "m12 21 4-4",
            key: "1lfcce"
        }
    ],
    [
        "path",
        {
            d: "M4.393 15.269A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.436 8.284",
            key: "ui1hmy"
        }
    ]
];
const $1b19608dd471de3d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("cloud-download", $1b19608dd471de3d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c9173589173e62cb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m10 17 5-5-5-5",
            key: "1bsop3"
        }
    ],
    [
        "path",
        {
            d: "M15 12H3",
            key: "6jk70r"
        }
    ],
    [
        "path",
        {
            d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4",
            key: "u53s6r"
        }
    ]
];
const $c9173589173e62cb$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("log-in", $c9173589173e62cb$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0740549741641712$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "8",
            r: "5",
            key: "1hypcn"
        }
    ],
    [
        "path",
        {
            d: "M20 21a8 8 0 0 0-16 0",
            key: "rfgkzh"
        }
    ]
];
const $0740549741641712$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("user-round", $0740549741641712$export$3efd853dbb351e94);











// ── Design tokens (shared, premium look) ────────────────────────────────────────────────────────
const $b85e9b46e4618b3e$var$label = 'block text-sm font-medium text-gray-700 mb-1.5';
const $b85e9b46e4618b3e$var$inputBase = 'w-full rounded-xl border border-gray-200 bg-gray-50/70 px-3.5 py-2.5 text-gray-900 placeholder-gray-400 shadow-sm transition focus:bg-white focus:border-blue-400 focus:ring-2 focus:ring-blue-500/40 focus:outline-none';
const $b85e9b46e4618b3e$var$inputWithIcon = `${$b85e9b46e4618b3e$var$inputBase} pl-10`;
const $b85e9b46e4618b3e$var$primaryBtn = 'w-full inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#1a6fd4] to-[#17b8e0] py-2.5 font-semibold text-white shadow-lg shadow-blue-600/25 transition hover:shadow-xl hover:brightness-[1.04] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none';
const $b85e9b46e4618b3e$var$secondaryBtn = 'w-full inline-flex items-center justify-center gap-2 rounded-xl border-2 border-blue-600/50 bg-white py-2.5 font-semibold text-blue-700 transition hover:bg-blue-50 disabled:opacity-50';
const $b85e9b46e4618b3e$var$otpInput = 'w-full rounded-xl border border-gray-200 bg-gray-50/70 px-3.5 py-3 text-center text-2xl font-mono tracking-[0.6em] text-gray-900 shadow-inner transition focus:bg-white focus:border-blue-400 focus:ring-2 focus:ring-blue-500/40 focus:outline-none';
/** Input with a leading icon for a more finished feel. */ const $b85e9b46e4618b3e$var$IconField = ({ icon: Icon, ...props })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                size: 16,
                className: "pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                ...props,
                className: $b85e9b46e4618b3e$var$inputWithIcon
            })
        ]
    });
const $b85e9b46e4618b3e$var$AccountModal = ({ onClose: onClose, setFactFind: setFactFind, initialMode: initialMode, resetToken: resetToken, context: context, onSignedUp: onSignedUp, onSignedIn: onSignedIn, onSignOut: onSignOut })=>{
    // loading | signin | signup | verify | account | forgot | reset
    const [mode, setMode] = (0, $acw62.useState)('loading');
    const [user, setUser] = (0, $acw62.useState)(null);
    const [email, setEmail] = (0, $acw62.useState)('');
    const [password, setPassword] = (0, $acw62.useState)('');
    const [password2, setPassword2] = (0, $acw62.useState)('');
    const [code, setCode] = (0, $acw62.useState)('');
    /** Held only between the password step and the code step — never persisted, never a session. */ const [mfaToken, setMfaToken] = (0, $acw62.useState)('');
    const [trustThisDevice, setTrustThisDevice] = (0, $acw62.useState)(true);
    const [twoFactor, setTwoFactor] = (0, $acw62.useState)(null);
    /*
   * How we arrived at the setup screen, which decides where "Done" goes. Someone who came from their
   * account settings expects to land back there; an adviser who was just made to do this on the way
   * in expects to be at work. Sending the second one to a settings panel strands them one click short
   * of the thing they signed in to do.
   */ const [setupCameFromSignIn, setSetupCameFromSignIn] = (0, $acw62.useState)(false);
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [notice, setNotice] = (0, $acw62.useState)(null);
    const [agreedTerms, setAgreedTerms] = (0, $acw62.useState)(false); // signup clickwrap checkbox
    const [viewDoc, setViewDoc] = (0, $acw62.useState)(null); // legal document open in the reader
    (0, $acw62.useEffect)(()=>{
        (async ()=>{
            if (initialMode === 'reset') {
                setMode('reset');
                return;
            }
            const current = await (0, $cc9e8a24185b91b0$export$a79e7ef8c396bb0e)();
            if (current) {
                if (onSignedIn) {
                    setUser(current);
                    const loaded = await (0, $a0f9af581f384312$export$4310a59bd5b0b729)().catch(()=>null);
                    if (loaded) setFactFind(loaded.factFind);
                    onSignedIn(loaded);
                    return;
                }
                setUser(current);
                setMode('account');
            } else setMode(initialMode === 'signup' ? 'signup' : 'signin');
        })();
    }, [
        initialMode
    ]);
    const friendlyError = (raw)=>{
        const msg = typeof raw === 'string' ? raw : '';
        if (!msg || msg === '{}' || /unexpected_failure|error sending|fetch failed/i.test(msg)) return "We couldn't send the email just now. Please try again in a few minutes \u2014 if it keeps happening, contact support.";
        return msg;
    };
    const run = async (fn)=>{
        setBusy(true);
        setNotice(null);
        try {
            await fn();
        } catch (err) {
            const apiMsg = err?.response?.data?.error?.message;
            const message = err instanceof Error ? err.message : undefined;
            setNotice({
                tone: 'error',
                text: friendlyError(apiMsg || message)
            });
        } finally{
            setBusy(false);
        }
    };
    /** Keeps the security panel honest — it reads what the server says, never what we assume. */ const refreshTwoFactor = async ()=>{
        setTwoFactor(await (0, $cc9e8a24185b91b0$export$765583c85b261dc2)());
    };
    /*
   * Fetch it when the panel opens rather than at sign-in: it changes (they enrol, they turn it off,
   * they spend a recovery code), and a status read once and cached is how a screen ends up telling
   * someone the opposite of what is true.
   */ (0, $acw62.useEffect)(()=>{
        if (mode !== 'account') return;
        let cancelled = false;
        (async ()=>{
            const status = await (0, $cc9e8a24185b91b0$export$765583c85b261dc2)();
            if (!cancelled) setTwoFactor(status);
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        mode
    ]);
    const finishSignIn = async ()=>{
        setUser(await (0, $cc9e8a24185b91b0$export$a79e7ef8c396bb0e)());
        if (onSignedIn) {
            const loaded = await (0, $a0f9af581f384312$export$4310a59bd5b0b729)().catch(()=>null);
            if (loaded) setFactFind(loaded.factFind);
            onSignedIn(loaded);
            return;
        }
        setMode('account');
    };
    const handleSignIn = ()=>run(async ()=>{
            const res = await (0, $cc9e8a24185b91b0$export$9670d83f11d4b64a)(email.trim(), password);
            if (!res.ok) {
                /*
         * The password was right, and that is now only half of it. This must be handled BEFORE the
         * generic failure below: falling through would tell someone their password was wrong at the
         * exact moment it was accepted, which is the most confusing thing the screen could say.
         */ if ('mfaRequired' in res && res.mfaRequired) {
                    setMfaToken(res.mfaToken);
                    setCode('');
                    setTrustThisDevice(true);
                    setMode('twofactor');
                    return setNotice(null);
                }
                // They created an account but never entered the emailed code: don't dead-end on a raw
                // error — send a fresh code and take them straight to the confirmation screen.
                if ('needsEmailConfirm' in res && res.needsEmailConfirm) {
                    await (0, $cc9e8a24185b91b0$export$bb28b2d3718a590f)(email.trim()).catch(()=>{});
                    setCode('');
                    setMode('verify');
                    return setNotice({
                        tone: 'info',
                        text: `Your email hasn't been confirmed yet. We've just sent a fresh code to ${email.trim()} \u{2014} enter it below to finish.`
                    });
                }
                return setNotice({
                    tone: 'error',
                    text: 'message' in res ? res.message : 'Incorrect email or password.'
                });
            }
            /*
       * An adviser or firm member without an authenticator yet. They ARE signed in — they have to be,
       * or they could never reach this screen — but almost everything is refused until they finish,
       * so dropping them on a dashboard that says no to everything would just look broken.
       */ if (res.mustSetUpTwoFactor) {
                await refreshTwoFactor();
                setSetupCameFromSignIn(true);
                setMode('setup2fa');
                return setNotice({
                    tone: 'info',
                    text: 'Adviser accounts need a second step at sign in. It takes about a minute to set up.'
                });
            }
            await finishSignIn();
        });
    /**
   * The second step of signing in. The same box takes a six-digit code or a recovery code, because
   * someone reaching for a recovery code has already lost their phone and should not also have to
   * find a different screen.
   */ const handleTwoFactor = ()=>run(async ()=>{
            const res = await (0, $cc9e8a24185b91b0$export$e58ad95e33a8ebbd)(mfaToken, code.trim(), trustThisDevice);
            if (!res.ok) {
                setCode('');
                return setNotice({
                    tone: 'error',
                    text: res.message
                });
            }
            if (res.usedRecoveryCode) // Say this plainly: a code they can never use again has just been spent.
            setNotice({
                tone: 'info',
                text: res.recoveryCodesRemaining === 0 ? 'That recovery code is now used, and it was your last one. Set up new ones from Account as soon as you can.' : `That recovery code is now used \u{2014} you have ${res.recoveryCodesRemaining} left.`
            });
            await finishSignIn();
        });
    const handleSignUp = ()=>run(async ()=>{
            if (password.length < 10) return setNotice({
                tone: 'error',
                text: 'Please use a password of at least 10 characters.'
            });
            if (!agreedTerms) return setNotice({
                tone: 'error',
                text: 'Please tick the box to agree to the Terms of Use and Privacy Policy first.'
            });
            const res = await (0, $cc9e8a24185b91b0$export$cf64224bcd829024)(email.trim(), password);
            if (!res.ok) return setNotice({
                tone: 'error',
                text: friendlyError(res.message)
            });
            if (res.needsEmailConfirm) {
                // Single-screen confirmation: stay right here and ask for the 6-digit code we email.
                // No confirmation link, so no second browser tab to get lost in.
                setCode('');
                setMode('verify');
                return setNotice({
                    tone: 'info',
                    text: `We've emailed a code to ${email.trim()}. Enter it below to finish.`
                });
            }
            // A live session exists already: straight into the app.
            await continueIntoApp();
        });
    /**
   * A fresh session is live (just signed up, or just confirmed a code): route the person INTO the
   * app. onSignedUp/onSignedIn navigate to the fact-find or their saved plan; the settings panel
   * is only ever reached deliberately from inside the app.
   */ const continueIntoApp = async ()=>{
        setUser(await (0, $cc9e8a24185b91b0$export$a79e7ef8c396bb0e)());
        if (agreedTerms) // Record the clickwrap acceptance on the server ledger now a session exists. Fire-and-forget:
        // a transient failure must not block entry (the server's status endpoint lets us re-prompt).
        (0, $1124d5012b356e89$export$2fe2928877a2a98)([
            'consumer_terms',
            'privacy_policy'
        ], 'signup').catch(()=>{});
        if (onSignedUp) {
            onSignedUp();
            return;
        }
        await finishSignIn();
    };
    const handleVerifyCode = ()=>run(async ()=>{
            const res = await (0, $cc9e8a24185b91b0$export$feab9165e44c6d62)(email.trim(), code);
            if (!res.ok) return setNotice({
                tone: 'error',
                text: "That code wasn't accepted \u2014 check the digits in your email and try again."
            });
            setCode('');
            setNotice(null);
            // A new account that must use an authenticator (a platform admin): set it up now, as a
            // password sign-in would, rather than landing on screens that refuse a password-only session.
            if (res.mustSetUpTwoFactor) {
                await refreshTwoFactor();
                setSetupCameFromSignIn(true);
                setMode('setup2fa');
                return setNotice({
                    tone: 'info',
                    text: 'This account needs a second step at sign in. It takes about a minute to set up.'
                });
            }
            await continueIntoApp();
        });
    const handleResendCode = ()=>run(async ()=>{
            const res = await (0, $cc9e8a24185b91b0$export$bb28b2d3718a590f)(email.trim());
            if (!res.ok) return setNotice({
                tone: 'error',
                text: friendlyError(res.message)
            });
            setNotice({
                tone: 'success',
                text: `A fresh code is on its way to ${email.trim()}.`
            });
        });
    const handleForgot = ()=>run(async ()=>{
            const res = await (0, $cc9e8a24185b91b0$export$db579c517e4aeb29)(email.trim());
            if (!res.ok) return setNotice({
                tone: 'error',
                text: friendlyError(res.message)
            });
            if (!res.exists) return setNotice({
                tone: 'error',
                text: "We couldn't find an account with that email address. Check the spelling, or create a new account instead."
            });
            setNotice({
                tone: 'success',
                text: `Your reset link is on its way to ${email.trim()}. It usually arrives within a minute \u{2014} check your junk folder if you don't see it.`
            });
        });
    const handleSetNewPassword = ()=>run(async ()=>{
            if (password.length < 10) return setNotice({
                tone: 'error',
                text: 'Please use a password of at least 10 characters.'
            });
            if (password !== password2) return setNotice({
                tone: 'error',
                text: 'The two passwords do not match.'
            });
            const res = await (0, $cc9e8a24185b91b0$export$e2853351e15b7895)(resetToken || '', password);
            if (!res.ok) return setNotice({
                tone: 'error',
                text: friendlyError(res.message)
            });
            setPassword('');
            setPassword2('');
            // Password changed and the user is signed in — route them into their proper workspace
            // (partner portal / their plan), NOT the settings panel. Only fall back to the settings
            // view when this modal has no app-navigation handler (i.e. opened from inside the app).
            if (onSignedIn || onSignedUp) {
                await continueIntoApp();
                return;
            }
            setUser(await (0, $cc9e8a24185b91b0$export$a79e7ef8c396bb0e)());
            setMode('account');
            setNotice({
                tone: 'success',
                text: 'Your password has been changed. You are signed in.'
            });
        });
    const handleSignOut = ()=>run(async ()=>{
            await (0, $cc9e8a24185b91b0$export$b0ac3a1c242cb1ea)();
            (0, $a0f9af581f384312$export$1db2a6d91babbd88)(null);
            setUser(null);
            setPassword('');
            setMode('signin');
            if (onSignOut) onSignOut();
        });
    const noticeStyle = notice && ({
        error: {
            Icon: (0, $5415d98bde6b29f1$export$2e2bcd8739ae039),
            chip: 'bg-red-100 text-red-600',
            ring: 'border-red-200'
        },
        success: {
            Icon: (0, $f36710bd138be5d0$export$2e2bcd8739ae039),
            chip: 'bg-emerald-100 text-emerald-600',
            ring: 'border-emerald-200'
        },
        info: {
            Icon: (0, $e52b122f04c04d7d$export$2e2bcd8739ae039),
            chip: 'bg-blue-100 text-blue-600',
            ring: 'border-blue-200'
        }
    })[notice.tone];
    // Hero title + supportive subtitle, tuned per mode (and per channel for sign-in).
    const isPartner = context === 'partner';
    /* Advisers and firm staff see the professional term; consumers see plain words. */ const twoFactorWords = (0, $19ccc74b4bce727a$export$6f8ad042a19877fc)(Boolean(twoFactor?.required));
    const HeroIcon = mode === 'twofactor' || mode === 'setup2fa' ? (0, $e325251f2797f6cf$export$2e2bcd8739ae039) : mode === 'account' ? (0, $0740549741641712$export$2e2bcd8739ae039) : mode === 'verify' ? (0, $d6fe951f3901e9a6$export$2e2bcd8739ae039) : mode === 'reset' || mode === 'forgot' ? (0, $e325251f2797f6cf$export$2e2bcd8739ae039) : isPartner ? (0, $224502d93617e0e1$export$2e2bcd8739ae039) : (0, $c9173589173e62cb$export$2e2bcd8739ae039);
    const heading = {
        loading: "One moment\u2026",
        signin: isPartner ? 'Partner sign in' : 'Welcome back',
        signup: 'Create your account',
        verify: 'Confirm your email',
        account: 'Your account',
        forgot: 'Reset your password',
        reset: 'Choose a new password',
        twofactor: 'One more step',
        setup2fa: twoFactorWords.title
    }[mode];
    const subtitle = {
        loading: 'Checking your session',
        signin: isPartner ? "Sign in to your firm\u2019s secure workspace" : 'Sign in to pick up right where you left off',
        signup: "It takes about a minute \u2014 your details are encrypted",
        verify: 'Enter the code we just emailed you',
        account: user?.email || 'Manage your security and privacy',
        forgot: "We\u2019ll email you a secure link to reset it",
        reset: "Almost done \u2014 set a new password below",
        twofactor: 'Enter the code from your authenticator app',
        setup2fa: 'Add a code from your phone to your login'
    }[mode];
    const showTrustFooter = mode === 'signin' || mode === 'signup' || mode === 'verify' || mode === 'forgot' || mode === 'twofactor';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "fixed inset-0 z-[10000] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "no-scrollbar w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-2xl ring-1 ring-black/5 max-h-[92vh] overflow-y-auto",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative overflow-hidden bg-gradient-to-br from-[#1a6fd4] to-[#17b8e0] px-6 pt-6 pb-7 text-white",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "pointer-events-none absolute -right-8 -top-10 h-32 w-32 rounded-full bg-white/10 blur-2xl"
                            }),
                            mode === 'setup2fa' && setupCameFromSignIn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: handleSignOut,
                                disabled: busy,
                                className: "absolute right-4 top-4 rounded-full px-3 py-1.5 text-xs font-medium text-white/85 transition hover:bg-white/15 hover:text-white",
                                children: "Sign out"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: onClose,
                                className: "absolute right-4 top-4 rounded-full p-1.5 text-white/80 transition hover:bg-white/15 hover:text-white",
                                "aria-label": "Close",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                    size: 18
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-3.5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/25 backdrop-blur",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(HeroIcon, {
                                            className: "h-6 w-6"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                className: "text-xl font-bold leading-tight",
                                                children: heading
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-white/85",
                                                children: subtitle
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-6 space-y-4",
                        children: [
                            notice && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: `flex items-start gap-3 rounded-xl border bg-white px-4 py-3 shadow-sm ${noticeStyle.ring}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: `mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full ${noticeStyle.chip}`,
                                        children: noticeStyle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(noticeStyle.Icon, {
                                            size: 16,
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm leading-relaxed text-gray-700",
                                        children: notice.text
                                    })
                                ]
                            }),
                            mode === 'loading' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center justify-center gap-3 py-6 text-sm text-gray-500",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "h-5 w-5 animate-spin rounded-full border-2 border-blue-100 border-t-blue-500"
                                    }),
                                    "Checking your session\u2026"
                                ]
                            }),
                            (mode === 'signin' || mode === 'signup') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: (e)=>{
                                    e.preventDefault();
                                    (mode === 'signin' ? handleSignIn : handleSignUp)();
                                },
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: "account-email",
                                                className: $b85e9b46e4618b3e$var$label,
                                                children: "Email"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b85e9b46e4618b3e$var$IconField, {
                                                icon: (0, $d6fe951f3901e9a6$export$2e2bcd8739ae039),
                                                id: "account-email",
                                                type: "email",
                                                required: true,
                                                autoComplete: "username",
                                                value: email,
                                                onChange: (e)=>setEmail(e.target.value),
                                                placeholder: "you@example.com"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: "account-password",
                                                className: $b85e9b46e4618b3e$var$label,
                                                children: "Password"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b85e9b46e4618b3e$var$IconField, {
                                                icon: (0, $e20ffdae2aa9b33f$export$2e2bcd8739ae039),
                                                id: "account-password",
                                                type: "password",
                                                required: true,
                                                autoComplete: mode === 'signin' ? 'current-password' : 'new-password',
                                                value: password,
                                                onChange: (e)=>setPassword(e.target.value),
                                                placeholder: mode === 'signup' ? 'At least 10 characters' : "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022"
                                            })
                                        ]
                                    }),
                                    mode === 'signup' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "flex cursor-pointer items-start gap-2.5 rounded-xl border border-gray-200 bg-gray-50/70 px-3.5 py-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: agreedTerms,
                                                        onChange: (e)=>setAgreedTerms(e.target.checked),
                                                        className: "mt-0.5 h-4 w-4 shrink-0 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-xs leading-relaxed text-gray-600",
                                                        children: [
                                                            "I have read and agree to the",
                                                            ' ',
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                onClick: ()=>setViewDoc((0, $53b9787b76ac25b0$export$4aeb9bf2c158bdb6)),
                                                                className: "font-semibold text-blue-600 underline decoration-blue-300 underline-offset-2 hover:text-blue-700",
                                                                children: "Terms of Use"
                                                            }),
                                                            ' ',
                                                            "and the",
                                                            ' ',
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                type: "button",
                                                                onClick: ()=>setViewDoc((0, $23065750a32ab3de$export$ecf6508459835aaf)),
                                                                className: "font-semibold text-blue-600 underline decoration-blue-300 underline-offset-2 hover:text-blue-700",
                                                                children: "Privacy Policy"
                                                            }),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $849c9b7caca39f06$export$2e2bcd8739ae039), {
                                                variant: "signup"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "submit",
                                        disabled: busy || mode === 'signup' && !agreedTerms,
                                        className: $b85e9b46e4618b3e$var$primaryBtn,
                                        children: busy ? "Working\u2026" : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                mode === 'signin' ? 'Sign in' : 'Create account',
                                                " ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                    size: 16
                                                })
                                            ]
                                        })
                                    }),
                                    mode === 'signin' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        disabled: busy,
                                        onClick: ()=>{
                                            setNotice(null);
                                            setMode('forgot');
                                        },
                                        className: "w-full text-sm text-gray-500 transition hover:text-gray-700",
                                        children: "Forgot your password?"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "relative py-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "absolute inset-0 flex items-center",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "w-full border-t border-gray-100"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "relative flex justify-center",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "bg-white px-2 text-xs text-gray-400",
                                                    children: "or"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        disabled: busy,
                                        onClick: ()=>{
                                            setNotice(null);
                                            setMode(mode === 'signin' ? 'signup' : 'signin');
                                        },
                                        className: "flex w-full items-center justify-center gap-1.5 text-sm font-medium text-blue-600 transition hover:text-blue-700",
                                        children: mode === 'signin' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09365e579c2377bf$export$2e2bcd8739ae039), {
                                                    size: 15
                                                }),
                                                " New here? Create an account"
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9173589173e62cb$export$2e2bcd8739ae039), {
                                                    size: 15
                                                }),
                                                " Already have an account? Sign in"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            mode === 'verify' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: (e)=>{
                                    e.preventDefault();
                                    handleVerifyCode();
                                },
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "Enter the code we emailed to ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: email
                                            }),
                                            ". It can take a minute to arrive \u2014 please check your junk or spam folder before asking for a new one."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        inputMode: "numeric",
                                        autoComplete: "one-time-code",
                                        maxLength: 6,
                                        value: code,
                                        autoFocus: true,
                                        onChange: (e)=>setCode(e.target.value.replace(/\D/g, '')),
                                        className: `${$b85e9b46e4618b3e$var$otpInput} tracking-[0.35em]`,
                                        placeholder: "Enter code"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "submit",
                                        disabled: busy || code.length < 6,
                                        className: $b85e9b46e4618b3e$var$primaryBtn,
                                        children: busy ? "Checking\u2026" : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                "Confirm & continue ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                    size: 16
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        disabled: busy,
                                        onClick: handleResendCode,
                                        className: "w-full text-sm text-gray-500 transition hover:text-gray-700",
                                        children: "Didn't get it? Resend the code"
                                    })
                                ]
                            }),
                            mode === 'twofactor' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: (e)=>{
                                    e.preventDefault();
                                    handleTwoFactor();
                                },
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-gray-600",
                                        children: "Open your authenticator app and enter the 6-digit code it shows for AgedCareWise."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        inputMode: "text",
                                        autoComplete: "one-time-code",
                                        maxLength: 20,
                                        value: code,
                                        autoFocus: true,
                                        onChange: (e)=>setCode(e.target.value),
                                        className: `${$b85e9b46e4618b3e$var$otpInput} tracking-[0.35em]`,
                                        placeholder: "000000",
                                        "aria-label": "Authentication code"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "flex items-start gap-2.5 text-sm text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: trustThisDevice,
                                                onChange: (e)=>setTrustThisDevice(e.target.checked),
                                                className: "mt-0.5 h-4 w-4 rounded border-gray-300 text-blue-600"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    "Don't ask again on this device for 30 days",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "mt-0.5 block text-xs text-gray-400",
                                                        children: "Only tick this on a computer that's yours."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "submit",
                                        disabled: busy || code.trim().length < 6,
                                        className: $b85e9b46e4618b3e$var$primaryBtn,
                                        children: busy ? "Checking\u2026" : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                "Confirm & sign in ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                    size: 16
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-center text-xs text-gray-500",
                                        children: "Lost your phone? Enter one of your recovery codes in the box above instead."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        disabled: busy,
                                        onClick: ()=>{
                                            setNotice(null);
                                            setCode('');
                                            setMfaToken('');
                                            setMode('signin');
                                        },
                                        className: "w-full text-sm text-blue-600 transition hover:text-blue-700",
                                        children: "Back to sign in"
                                    })
                                ]
                            }),
                            mode === 'forgot' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: (e)=>{
                                    e.preventDefault();
                                    handleForgot();
                                },
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: "forgot-email",
                                                className: $b85e9b46e4618b3e$var$label,
                                                children: "Email"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b85e9b46e4618b3e$var$IconField, {
                                                icon: (0, $d6fe951f3901e9a6$export$2e2bcd8739ae039),
                                                id: "forgot-email",
                                                type: "email",
                                                required: true,
                                                autoComplete: "username",
                                                value: email,
                                                onChange: (e)=>setEmail(e.target.value),
                                                placeholder: "you@example.com"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "submit",
                                        disabled: busy,
                                        className: $b85e9b46e4618b3e$var$primaryBtn,
                                        children: busy ? "Sending\u2026" : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                "Email me a reset link ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                    size: 16
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        disabled: busy,
                                        onClick: ()=>{
                                            setNotice(null);
                                            setMode('signin');
                                        },
                                        className: "w-full text-sm text-blue-600 transition hover:text-blue-700",
                                        children: "Back to sign in"
                                    })
                                ]
                            }),
                            mode === 'reset' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: (e)=>{
                                    e.preventDefault();
                                    handleSetNewPassword();
                                },
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: "reset-password",
                                                className: $b85e9b46e4618b3e$var$label,
                                                children: "New password"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b85e9b46e4618b3e$var$IconField, {
                                                icon: (0, $e20ffdae2aa9b33f$export$2e2bcd8739ae039),
                                                id: "reset-password",
                                                type: "password",
                                                required: true,
                                                autoComplete: "new-password",
                                                value: password,
                                                onChange: (e)=>setPassword(e.target.value),
                                                placeholder: "At least 10 characters"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: "reset-password2",
                                                className: $b85e9b46e4618b3e$var$label,
                                                children: "Repeat new password"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b85e9b46e4618b3e$var$IconField, {
                                                icon: (0, $e20ffdae2aa9b33f$export$2e2bcd8739ae039),
                                                id: "reset-password2",
                                                type: "password",
                                                required: true,
                                                autoComplete: "new-password",
                                                value: password2,
                                                onChange: (e)=>setPassword2(e.target.value),
                                                placeholder: "Same password again"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "submit",
                                        disabled: busy,
                                        className: $b85e9b46e4618b3e$var$primaryBtn,
                                        children: busy ? "Saving\u2026" : 'Set new password'
                                    })
                                ]
                            }),
                            mode === 'setup2fa' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $810a19cb10a15a4b$export$2e2bcd8739ae039), {
                                mandatory: Boolean(twoFactor?.required),
                                onDone: async ()=>{
                                    await refreshTwoFactor();
                                    if (setupCameFromSignIn) {
                                        // Straight on into the app — this was the last thing between them and their work.
                                        setSetupCameFromSignIn(false);
                                        await finishSignIn();
                                        return;
                                    }
                                    setMode('account');
                                    setNotice({
                                        tone: 'success',
                                        text: `${twoFactorWords.isOn}. You have been signed out on your other devices.`
                                    });
                                },
                                onCancel: ()=>{
                                    setNotice(null);
                                    setSetupCameFromSignIn(false);
                                    setMode('account');
                                }
                            }),
                            mode === 'account' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "rounded-xl border border-gray-200 p-4 space-y-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-sm font-semibold text-gray-800",
                                                children: "Sign-in security"
                                            }),
                                            twoFactor === null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "h-9 animate-pulse rounded-lg bg-gray-100"
                                            }) : twoFactor.enrolled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "flex items-center gap-1.5 text-sm text-green-700",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                                                size: 15
                                                            }),
                                                            " ",
                                                            twoFactorWords.isOn
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs text-gray-500",
                                                        children: twoFactor.recoveryCodesRemaining > 0 ? `${twoFactor.recoveryCodesRemaining} recovery ${twoFactor.recoveryCodesRemaining === 1 ? 'code' : 'codes'} left.` : "You have no recovery codes left \u2014 if you lose your phone you will need us to reset it."
                                                    }),
                                                    twoFactor.required ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs text-gray-500",
                                                        children: "Adviser and firm accounts must keep this on."
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        disabled: busy,
                                                        className: "w-full pt-1 text-sm text-gray-500 transition hover:text-red-600",
                                                        onClick: ()=>run(async ()=>{
                                                                if (!await (0, $8e1e84c918e07c84$export$71edf76f07903b9c)(`${twoFactorWords.turnOff}? A password alone will then be enough to get into your account.`)) return;
                                                                const res = await (0, $cc9e8a24185b91b0$export$5441625492178b0a)();
                                                                if (!res.ok) return setNotice({
                                                                    tone: 'error',
                                                                    text: res.message
                                                                });
                                                                await refreshTwoFactor();
                                                                setNotice({
                                                                    tone: 'info',
                                                                    text: `${twoFactorWords.isOff}. Any other devices you were signed in on have been signed out.`
                                                                });
                                                            }),
                                                        children: twoFactorWords.turnOff
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-sm text-gray-600",
                                                        children: twoFactor.required ? 'Your account needs a code from your phone as well as a password.' : 'Add a code from your phone to your login, so a password alone is never enough.'
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        disabled: busy,
                                                        className: $b85e9b46e4618b3e$var$secondaryBtn,
                                                        onClick: ()=>{
                                                            setNotice(null);
                                                            setSetupCameFromSignIn(false);
                                                            setMode('setup2fa');
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                                                size: 16
                                                            }),
                                                            " ",
                                                            twoFactorWords.setUp
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "rounded-xl border border-gray-200 p-4 space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-sm font-semibold text-gray-800",
                                                children: "Your privacy rights"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                disabled: busy,
                                                className: $b85e9b46e4618b3e$var$secondaryBtn,
                                                onClick: ()=>run(async ()=>{
                                                        const data = await (0, $a0f9af581f384312$export$25a6622c6a8b28cc)();
                                                        const blob = new Blob([
                                                            JSON.stringify(data, null, 2)
                                                        ], {
                                                            type: 'application/json'
                                                        });
                                                        const url = URL.createObjectURL(blob);
                                                        const a = document.createElement('a');
                                                        a.href = url;
                                                        a.download = 'agedcarewise-my-data.json';
                                                        a.click();
                                                        URL.revokeObjectURL(url);
                                                        setNotice({
                                                            tone: 'success',
                                                            text: 'Your data has been downloaded as a file on this computer.'
                                                        });
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b19608dd471de3d$export$2e2bcd8739ae039), {
                                                        size: 16
                                                    }),
                                                    " Download my data"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "button",
                                                disabled: busy,
                                                className: "w-full pt-1 text-sm text-gray-500 transition hover:text-red-600",
                                                onClick: ()=>run(async ()=>{
                                                        if (!await (0, $8e1e84c918e07c84$export$71edf76f07903b9c)('Request deletion of your account and data? This will be actioned within 30 days.')) return;
                                                        const res = await (0, $a0f9af581f384312$export$19641b75d6358d63)();
                                                        setNotice({
                                                            tone: 'info',
                                                            text: typeof res.message === 'string' ? res.message : 'Your deletion request has been received.'
                                                        });
                                                    }),
                                                children: "Request account deletion"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: onClose,
                                        disabled: busy,
                                        className: $b85e9b46e4618b3e$var$primaryBtn,
                                        children: [
                                            isPartner ? 'Done' : "Done \u2014 back to my plan",
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                size: 16
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: handleSignOut,
                                        disabled: busy,
                                        className: "flex w-full items-center justify-center gap-1.5 text-sm text-gray-500 transition hover:text-gray-700",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5473793717b51056$export$2e2bcd8739ae039), {
                                                size: 14
                                            }),
                                            " Sign out"
                                        ]
                                    })
                                ]
                            }),
                            showTrustFooter && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center justify-center gap-1.5 pt-1 text-xs text-gray-400",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e20ffdae2aa9b33f$export$2e2bcd8739ae039), {
                                        size: 12
                                    }),
                                    " Bank-level encryption \xb7 Your data is stored in Australia"
                                ]
                            })
                        ]
                    })
                ]
            }),
            viewDoc && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1cc4e5852e6af25$export$2e2bcd8739ae039), {
                doc: viewDoc,
                onClose: ()=>setViewDoc(null)
            })
        ]
    });
};
var $b85e9b46e4618b3e$export$2e2bcd8739ae039 = $b85e9b46e4618b3e$var$AccountModal;



/**
 * MainAppLayout.js – app shell: sidebar nav, header, and background per page.
 * Used by App.js to wrap Dashboard, Client Profile, Aged Care, etc.
 *
 * THE MENU (owner, 22–24 Sep 2026): what is on it and in what state is one rule, clientMenu.ts —
 * the client file's name, the profile's steps with what is done, the living options for the goals
 * ticked, and Reports once an advice document exists. This file only draws it. See clientMenu.ts
 * for the decisions behind it, including why there is no lock.
 */ 

var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3eb8b08a7e082855$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "7",
            height: "9",
            x: "3",
            y: "3",
            rx: "1",
            key: "10lvy0"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "5",
            x: "14",
            y: "3",
            rx: "1",
            key: "16une8"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "9",
            x: "14",
            y: "12",
            rx: "1",
            key: "1hutg5"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "5",
            x: "3",
            y: "16",
            rx: "1",
            key: "ldoo1y"
        }
    ]
];
const $3eb8b08a7e082855$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("layout-dashboard", $3eb8b08a7e082855$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $efa6e18e6227061d$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            key: "afitv7"
        }
    ],
    [
        "path",
        {
            d: "M9 3v18",
            key: "fh3hqa"
        }
    ]
];
const $efa6e18e6227061d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("panel-left", $efa6e18e6227061d$export$3efd853dbb351e94);







/**
 * A cohesive family of calm, serene landscapes (curated + verified visually under the app's
 * 85% white overlay). The backdrop changes on every screen — and on every Client Profile step —
 * to keep the experience tranquil and interesting rather than sterile, while staying on-mood.
 */ const $da881c21841264e4$var$bgUrl = (id)=>(0, $5bb9a0b2f90fb898$export$260036ae09c24358)(id, 1920, 1080);
const $da881c21841264e4$var$SERENE_BACKDROPS = [
    $da881c21841264e4$var$bgUrl('1441974231531-c6227db76b6e'),
    $da881c21841264e4$var$bgUrl('1506905925346-21bda4d32df4'),
    $da881c21841264e4$var$bgUrl('1559827260-dc66d52bef19'),
    $da881c21841264e4$var$bgUrl('1439066615861-d1af74d74000'),
    $da881c21841264e4$var$bgUrl('1717964134799-a98f497172a5'),
    $da881c21841264e4$var$bgUrl('1683041133891-613b76cbebc7'),
    $da881c21841264e4$var$bgUrl('1683041132892-0fe990b3afc3'),
    $da881c21841264e4$var$bgUrl('1636893580433-5ac59809bb13'),
    $da881c21841264e4$var$bgUrl('1776894873397-78ce93defb29'),
    $da881c21841264e4$var$bgUrl('1662189793032-ccb6135a9159'),
    $da881c21841264e4$var$bgUrl('1595885914073-3af381bbee7e')
];
// Intentional per-page assignments (any page not listed gets a stable hashed pick below).
const $da881c21841264e4$var$PAGE_BACKDROP = {
    'Dashboard': $da881c21841264e4$var$SERENE_BACKDROPS[1],
    'Reports': $da881c21841264e4$var$SERENE_BACKDROPS[9],
    'Partners': $da881c21841264e4$var$SERENE_BACKDROPS[10],
    'AssumptionsPage': $da881c21841264e4$var$SERENE_BACKDROPS[5],
    'Assumptions': $da881c21841264e4$var$SERENE_BACKDROPS[5],
    'Aged Care Funding Analyser': $da881c21841264e4$var$SERENE_BACKDROPS[2],
    'Understanding Aged Care Costs': $da881c21841264e4$var$SERENE_BACKDROPS[3],
    'Manual Control Projections': $da881c21841264e4$var$SERENE_BACKDROPS[6],
    'Enhanced Suggestion Engine': $da881c21841264e4$var$SERENE_BACKDROPS[7]
};
// One backdrop per Client Profile step (1–8), so stepping through the form keeps changing the scene.
const $da881c21841264e4$var$CLIENT_PROFILE_STEP_BACKDROPS = [
    $da881c21841264e4$var$SERENE_BACKDROPS[3],
    $da881c21841264e4$var$SERENE_BACKDROPS[0],
    $da881c21841264e4$var$SERENE_BACKDROPS[4],
    $da881c21841264e4$var$SERENE_BACKDROPS[10],
    $da881c21841264e4$var$SERENE_BACKDROPS[5],
    $da881c21841264e4$var$SERENE_BACKDROPS[6],
    $da881c21841264e4$var$SERENE_BACKDROPS[7],
    $da881c21841264e4$var$SERENE_BACKDROPS[8]
];
function $da881c21841264e4$var$getBackgroundImage(activePage, clientProfileStep) {
    if (activePage === 'Client Profile') {
        const i = (Number(clientProfileStep) || 1) - 1;
        return $da881c21841264e4$var$CLIENT_PROFILE_STEP_BACKDROPS[i] || $da881c21841264e4$var$CLIENT_PROFILE_STEP_BACKDROPS[0];
    }
    if ($da881c21841264e4$var$PAGE_BACKDROP[activePage]) return $da881c21841264e4$var$PAGE_BACKDROP[activePage];
    // Stable, distinct backdrop for any other screen so it still changes on navigation.
    let h = 0;
    const key = String(activePage || '');
    for(let k = 0; k < key.length; k += 1)h = h * 31 + key.charCodeAt(k) >>> 0;
    return $da881c21841264e4$var$SERENE_BACKDROPS[h % $da881c21841264e4$var$SERENE_BACKDROPS.length];
}
// Matches Tailwind's `lg` breakpoint — the width at which the 16rem sidebar can sit beside the
// content without squeezing it. Below this the same nav is presented as a hamburger drawer.
const $da881c21841264e4$var$DESKTOP_QUERY = '(min-width: 1024px)';
/** True when the sidebar is docked (desktop), false when it collapses into the hamburger drawer. */ function $da881c21841264e4$var$useIsDesktop() {
    const [isDesktop, setIsDesktop] = (0, $acw62.useState)(()=>typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia($da881c21841264e4$var$DESKTOP_QUERY).matches : true);
    (0, $acw62.useEffect)(()=>{
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
        const mql = window.matchMedia($da881c21841264e4$var$DESKTOP_QUERY);
        const onChange = (e)=>setIsDesktop(e.matches);
        setIsDesktop(mql.matches);
        mql.addEventListener('change', onChange);
        return ()=>mql.removeEventListener('change', onChange);
    }, []);
    return isDesktop;
}
/** One icon per living option, keyed by the plan type clientMenu.ts names. */ const $da881c21841264e4$var$OPTION_ICONS = (0, $d5c3c2c5a9eb8655$export$388c0e4f7230aadf);
/** A small count or state beside a menu line: "2 plans", "1 draft", "Complete". */ const $da881c21841264e4$var$Tag = ({ children: children, tone: tone })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `ml-auto shrink-0 rounded-full px-2 py-0.5 text-[10px] font-semibold leading-4 ${tone === 'blue' ? 'bg-blue-100 text-blue-800' : tone === 'green' ? 'bg-emerald-100 text-emerald-800' : 'bg-slate-100 text-slate-600'}`,
        children: children
    });
const $da881c21841264e4$var$GroupHeading = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "px-5 pt-4 pb-1.5 text-[10px] font-semibold uppercase tracking-wider text-slate-400",
        children: children
    });
const $da881c21841264e4$var$Hint = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "mx-3 mb-1 px-4 text-[11px] leading-snug text-slate-400",
        children: children
    });
const $da881c21841264e4$var$Sidebar = ({ activePage: activePage, setActivePage: setActivePage, clientProfileStep: clientProfileStep = 1, setClientProfileStep: setClientProfileStep, showReturnToPartnerPortal: showReturnToPartnerPortal, onReturnToPartnerPortal: onReturnToPartnerPortal, onSignOut: onSignOut, onOpenAccount: onOpenAccount, onOpenAdmin: onOpenAdmin, showAccount: showAccount, showAdmin: showAdmin, showCompliance: showCompliance, onOpenCompliance: onOpenCompliance, factFind: factFind, savedStrategies: savedStrategies, savedCaseStudies: savedCaseStudies, professionalCaseId: professionalCaseId, clientFileFallbackName: clientFileFallbackName, isOpen: isOpen, isDesktop: isDesktop, onClose: onClose })=>{
    const [navMarkFailed, setNavMarkFailed] = (0, $acw62.useState)(false);
    const closeButtonRef = (0, $acw62.useRef)(null);
    const menu = (0, $acw62.useMemo)(()=>(0, $e990f63b36c4bd03$export$3410c5544a8327c2)({
            factFind: factFind,
            savedStrategies: savedStrategies,
            savedCaseStudies: savedCaseStudies,
            professionalCaseId: professionalCaseId,
            fallbackName: clientFileFallbackName
        }), [
        factFind,
        savedStrategies,
        savedCaseStudies,
        professionalCaseId,
        clientFileFallbackName
    ]);
    // Drawer mode only: Escape closes, and opening moves focus into the panel so keyboard and
    // screen-reader users land on the nav rather than being left behind on the page.
    (0, $acw62.useEffect)(()=>{
        if (isDesktop || !isOpen) return undefined;
        closeButtonRef.current?.focus();
        const onKeyDown = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', onKeyDown);
        return ()=>document.removeEventListener('keydown', onKeyDown);
    }, [
        isDesktop,
        isOpen,
        onClose
    ]);
    // Picking anything in the drawer means you're going somewhere — get the drawer out of the way.
    const dismissAfterNavigation = ()=>{
        if (!isDesktop) onClose();
    };
    /*
     * Land at the top on every page change. "Finish & View Dashboard" used to drop the reader
     * partway down the new page, because nothing reset the scroll position when the page swapped
     * (reported 2026-08-22 — the Dashboard opened at the bottom). Instant rather than smooth: the
     * old page is already gone, so animating a scroll on content the reader never saw is just a
     * delay before they can read the new page.
     */ (0, $acw62.useEffect)(()=>{
        (0, $dec1f2e646bc0140$export$d9e308d9ad0c84b6)('auto');
    }, [
        activePage
    ]);
    const onProfilePage = activePage === 'Client Profile';
    // The steps stay open while the profile is being filled in, from any page; once it is complete
    // they fold away behind the tag, unless the reader is on the profile itself.
    const showSteps = onProfilePage || !menu.profileComplete;
    const goTo = (page)=>{
        // Choosing the page already open tells it to start over (granny flat review, 18 Oct 2026:
        // the menu item did nothing from inside the module). A page that does not listen is unaffected.
        if (page === activePage) window.dispatchEvent(new CustomEvent('acw:page-reselected', {
            detail: {
                page: page
            }
        }));
        setActivePage(page);
        dismissAfterNavigation();
    };
    const goToStep = (step)=>{
        setClientProfileStep?.(step);
        if (!onProfilePage) setActivePage('Client Profile');
        dismissAfterNavigation();
    };
    /**
     * Reports opens the advice documents where they live — the Dashboard's "SOA Generated
     * Scenarios" section — rather than a page of its own that would say "coming soon". The page
     * change scrolls to the top first (the effect above), so the scroll to the section follows it.
     */ const goToReports = ()=>{
        /*
         * ONE DOCUMENT: open it (UX review, 17 Oct 2026 — "Reports" scrolled to a section the reader then
         * had to click again). Several: the Home section lists them.
         */ const visibleDocs = (savedCaseStudies ?? []).filter((s)=>!professionalCaseId || !s.caseId || s.caseId === professionalCaseId);
        if (visibleDocs.length === 1) {
            const snapshot = visibleDocs[0].soaSnapshot;
            if (snapshot) {
                (0, $02a659cad5e2280d$export$eed5e3bcf209d966)(snapshot);
                dismissAfterNavigation();
                return;
            }
        }
        const scroll = ()=>document.getElementById((0, $e990f63b36c4bd03$export$b2f3bf9c7e33d4ec))?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        if (activePage === 'Dashboard') scroll();
        else {
            setActivePage('Dashboard');
            window.setTimeout(scroll, 150);
        }
        dismissAfterNavigation();
    };
    const navLinkBase = 'group relative flex items-center w-full py-2.5 rounded-lg transition-colors duration-200';
    const navLinkActive = 'bg-blue-50 text-[#001E7A] font-semibold shadow-sm before:absolute before:left-0 before:top-2 before:bottom-2 before:w-[3px] before:rounded-r before:bg-[#0F52E0]';
    const navLinkInactive = 'text-slate-600 hover:bg-slate-50 hover:text-slate-900';
    const footLink = 'w-full flex items-center gap-3 px-3 py-2.5 text-left text-slate-600 hover:bg-slate-50 hover:text-[#001E7A] rounded-lg transition-colors duration-200';
    // Off-canvas below `lg`, docked from `lg` up. When the drawer is shut its links are hidden from
    // assistive tech and taken out of the tab order, so tabbing can't wander into an invisible menu.
    const isHiddenDrawer = !isDesktop && !isOpen;
    const goToDashboard = ()=>goTo('Dashboard');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
        id: "app-sidebar",
        "aria-label": "Main",
        "aria-hidden": isHiddenDrawer || undefined,
        inert: isHiddenDrawer || undefined,
        className: `fixed inset-y-0 left-0 z-40 w-64 max-w-[85vw] shrink-0 flex flex-col overflow-hidden py-5 short:pt-3 short:pb-2 bg-white border-r border-slate-200/90 shadow-2xl transition-transform duration-300 ease-in-out lg:relative lg:z-10 lg:max-w-none lg:translate-x-0 lg:shadow-sm ${isOpen ? 'translate-x-0' : '-translate-x-full'}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                ref: closeButtonRef,
                onClick: onClose,
                "aria-label": "Close menu",
                className: "absolute top-3 right-3 p-2 rounded-lg text-slate-500 hover:bg-slate-100 hover:text-slate-900 transition-colors duration-200 lg:hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                    size: 20,
                    "aria-hidden": true
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex-1 min-h-0 overflow-y-auto",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "w-20 h-20 mb-5 short:w-14 short:h-14 short:mb-3 cursor-pointer mx-auto",
                        onClick: goToDashboard,
                        role: "button",
                        tabIndex: 0,
                        "aria-label": "AgedCareWise \u2014 go to Dashboard",
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                goToDashboard();
                            }
                        },
                        children: navMarkFailed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                            width: "96",
                            height: "96",
                            viewBox: "0 0 40 40",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "h-full w-full",
                            "aria-hidden": true,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M35.25 15.8333C37.8864 19.539 38.3333 24.1973 36.4167 28.3333C34.5 32.4694 30.4606 35.4167 25.8333 36.4167C21.2061 37.4167 16.4223 36.3125 12.75 33.5C9.07767 30.6875 6.94491 26.4924 6.94491 21.9444C6.94491 17.3965 9.07767 13.2014 12.75 10.3889C16.4223 7.57639 21.2061 6.47222 25.8333 7.47222",
                                    stroke: "#2B6CB0",
                                    strokeWidth: "6",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                    cx: "21.6667",
                                    cy: "18.3333",
                                    r: "5",
                                    fill: "#3B82F6"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M15 30C15 26.3181 18.134 23.3333 22.0833 23.3333C26.0326 23.3333 29.1667 26.3181 29.1667 30H15Z",
                                    fill: "#3B82F6"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, $fa6d1caa5fe64367$export$6c23acffafc6aa0a),
                            alt: "",
                            width: 96,
                            height: 96,
                            className: "h-full w-full object-contain object-center p-1 select-none",
                            draggable: false,
                            decoding: "async",
                            onError: ()=>setNavMarkFailed(true)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mx-3 mb-3 rounded-[10px] border border-slate-200 bg-slate-50 px-3 py-2.5",
                        "data-testid": "client-file",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-[10px] font-semibold uppercase tracking-wider text-slate-400",
                                children: "Client file"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: `mt-0.5 text-sm font-bold leading-snug ${menu.fileName ? 'text-slate-900' : 'text-slate-400 font-semibold'}`,
                                children: menu.fileName ?? 'Not yet named'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                        className: "space-y-1 px-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                    href: "#",
                                    onClick: (e)=>{
                                        e.preventDefault();
                                        goToDashboard();
                                    },
                                    className: `${navLinkBase} pl-4 pr-3 ${activePage === 'Dashboard' ? navLinkActive : navLinkInactive}`,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3eb8b08a7e082855$export$2e2bcd8739ae039), {
                                            size: 20,
                                            className: "mr-3 shrink-0 opacity-90",
                                            strokeWidth: activePage === 'Dashboard' ? 2.25 : 2
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-sm",
                                            children: "Home"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: "#",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            goTo('Client Profile');
                                        },
                                        className: `${navLinkBase} pl-4 pr-3 ${onProfilePage ? 'text-[#001E7A] font-semibold' : navLinkInactive}`,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f45c1e8ae52ad76$export$2e2bcd8739ae039), {
                                                size: 20,
                                                className: "mr-3 shrink-0 opacity-90",
                                                strokeWidth: onProfilePage ? 2.25 : 2
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm",
                                                children: "Client Profile"
                                            }),
                                            menu.profileComplete && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($da881c21841264e4$var$Tag, {
                                                tone: "green",
                                                children: "Complete"
                                            })
                                        ]
                                    }),
                                    showSteps && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-2 mb-1 pl-3 pr-1",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                            className: "space-y-0.5 border-l border-slate-200 ml-2 pl-2",
                                            children: menu.steps.map((s)=>{
                                                const subActive = onProfilePage && clientProfileStep === s.step;
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                        href: "#",
                                                        onClick: (e)=>{
                                                            e.preventDefault();
                                                            goToStep(s.step);
                                                        },
                                                        className: `flex items-start gap-2 py-1.5 pl-2 pr-2 rounded-md text-xs transition-colors duration-200 ${subActive ? 'bg-blue-50 text-[#001E7A] font-semibold' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: `mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[10px] font-bold ${subActive ? 'bg-[#0F52E0] text-white' : s.done ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-500'}`,
                                                                "aria-hidden": true,
                                                                children: s.done && !subActive ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                                                    size: 11,
                                                                    strokeWidth: 3
                                                                }) : s.step
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "leading-snug pt-0.5",
                                                                children: s.name
                                                            })
                                                        ]
                                                    })
                                                }, s.step);
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    menu.livingOptions.length === 0 && menu.livingHint && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($da881c21841264e4$var$Hint, {
                        children: menu.livingHint
                    }),
                    menu.livingOptions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($da881c21841264e4$var$GroupHeading, {
                                children: "Living options"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "space-y-1 px-3",
                                children: menu.livingOptions.map((o)=>{
                                    const Icon = $da881c21841264e4$var$OPTION_ICONS[o.planType] ?? (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039);
                                    const active = activePage === o.page;
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                            href: "#",
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                goTo(o.page);
                                            },
                                            className: `${navLinkBase} pl-4 pr-3 ${active ? navLinkActive : navLinkInactive}`,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                                    size: 20,
                                                    className: "mr-3 shrink-0 opacity-90",
                                                    strokeWidth: active ? 2.25 : 2
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-sm",
                                                    children: o.label
                                                }),
                                                o.planTag && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($da881c21841264e4$var$Tag, {
                                                    tone: "blue",
                                                    children: o.planTag
                                                })
                                            ]
                                        })
                                    }, o.page);
                                })
                            }),
                            menu.livingHint && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($da881c21841264e4$var$Hint, {
                                children: menu.livingHint
                            })
                        ]
                    }),
                    menu.reports && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($da881c21841264e4$var$GroupHeading, {
                                children: "Documents"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "space-y-1 px-3",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: "#",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            goToReports();
                                        },
                                        className: `${navLinkBase} pl-4 pr-3 ${navLinkInactive}`,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                                                size: 20,
                                                className: "mr-3 shrink-0 opacity-90",
                                                strokeWidth: 2
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm",
                                                children: "Advice document"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($da881c21841264e4$var$Tag, {
                                                tone: "grey",
                                                children: menu.reports.tag
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-auto px-3 pt-4 border-t border-slate-200/80 space-y-0.5 shrink-0 short:pt-2 short:space-y-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>goTo('AssumptionsPage'),
                        className: `${footLink} ${activePage === 'AssumptionsPage' ? 'bg-blue-50 text-[#001E7A] font-semibold' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                size: 20,
                                className: "flex-shrink-0",
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-sm font-medium",
                                children: "Assumptions"
                            })
                        ]
                    }),
                    showReturnToPartnerPortal && onReturnToPartnerPortal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>{
                            onReturnToPartnerPortal();
                            dismissAfterNavigation();
                        },
                        "aria-label": "Return to Partner Portal",
                        className: footLink,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $efa6e18e6227061d$export$2e2bcd8739ae039), {
                                size: 20,
                                className: "flex-shrink-0",
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-sm font-medium",
                                children: "Return to Portal"
                            })
                        ]
                    }),
                    showAccount && onOpenAccount && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>{
                            onOpenAccount();
                            dismissAfterNavigation();
                        },
                        className: footLink,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f45c1e8ae52ad76$export$2e2bcd8739ae039), {
                                size: 20,
                                className: "flex-shrink-0",
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-sm font-medium",
                                children: "Account"
                            })
                        ]
                    }),
                    showAdmin && onOpenAdmin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>{
                            onOpenAdmin();
                            dismissAfterNavigation();
                        },
                        className: footLink,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                                size: 20,
                                className: "flex-shrink-0",
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-sm font-medium",
                                children: "Admin"
                            })
                        ]
                    }),
                    showCompliance && onOpenCompliance && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>{
                            onOpenCompliance();
                            dismissAfterNavigation();
                        },
                        className: footLink,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $73a7d1cabb6a0e3c$export$2e2bcd8739ae039), {
                                size: 20,
                                className: "flex-shrink-0",
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-sm font-medium",
                                children: "Our advice"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>{
                            // A REAL sign-out must end the auth session and reset app state — App.js owns
                            // that (handleSignedOut). The old storage-only wipe left the session alive and
                            // the previous user's data on screen for the next person (shared computers).
                            if (onSignOut) {
                                onSignOut();
                                return;
                            }
                            // Demo builds (no accounts wired): keep the original local wipe.
                            sessionStorage.clear();
                            localStorage.clear();
                            setActivePage('LandingPage');
                        },
                        className: "w-full flex items-center gap-3 px-3 py-2.5 text-slate-600 hover:bg-red-50 hover:text-red-700 rounded-lg transition-colors duration-200",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5473793717b51056$export$2e2bcd8739ae039), {
                                size: 20
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-sm font-medium",
                                children: "Sign Out"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* On a short screen the header gives most of its height back: the wordmark drops from 80px to 44px
   and the padding halves, so the page's own heading starts ~80px higher on a 1366×768 laptop. */ const $da881c21841264e4$var$Header = ({ onOpenMenu: onOpenMenu, menuOpen: menuOpen })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
        className: "flex items-center gap-3 p-4 sm:p-6 lg:p-8 short:px-6 short:pt-4 short:pb-2 short:lg:px-8",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onOpenMenu,
                "aria-label": "Open menu",
                "aria-controls": "app-sidebar",
                "aria-expanded": menuOpen,
                className: "shrink-0 p-2 -ml-1 rounded-lg bg-white/80 text-slate-700 border border-slate-200/90 shadow-sm hover:bg-white hover:text-[#001E7A] transition-colors duration-200 lg:hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b66c39b6083b2b9$export$2e2bcd8739ae039), {
                    size: 24,
                    "aria-hidden": true
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $421c0497858a4b09$export$2e2bcd8739ae039), {
                className: "h-14 w-auto sm:h-20 short:h-11"
            })
        ]
    });
const $da881c21841264e4$var$MainAppLayout = ({ activePage: activePage, setActivePage: setActivePage, children: children, clientProfileStep: clientProfileStep, setClientProfileStep: setClientProfileStep, showReturnToPartnerPortal: showReturnToPartnerPortal, onReturnToPartnerPortal: onReturnToPartnerPortal, onSignOut: onSignOut, onOpenAccount: onOpenAccount, onOpenAdmin: onOpenAdmin, showAccount: showAccount, showAdmin: showAdmin, showCompliance: showCompliance, onOpenCompliance: onOpenCompliance, factFind: factFind, savedStrategies: savedStrategies, savedCaseStudies: savedCaseStudies, professionalCaseId: professionalCaseId, clientFileFallbackName: clientFileFallbackName })=>{
    const isDesktop = $da881c21841264e4$var$useIsDesktop();
    const [menuOpen, setMenuOpen] = (0, $acw62.useState)(false);
    const closeMenu = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setMenuOpen(false), []);
    // Widening back to desktop docks the sidebar again — don't leave a stale "open drawer" state
    // behind that would re-open as an overlay the next time the window narrows.
    (0, $acw62.useEffect)(()=>{
        if (isDesktop) setMenuOpen(false);
    }, [
        isDesktop
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative flex h-screen font-sans text-gray-800 overflow-hidden",
        style: {
            backgroundImage: `linear-gradient(rgba(255,255,255,0.85), rgba(255,255,255,0.85)), url("${$da881c21841264e4$var$getBackgroundImage(activePage, clientProfileStep)}")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed',
            backgroundRepeat: 'no-repeat'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "absolute top-0 left-0 w-full h-full -z-10 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute top-[-30%] left-[-25%] w-[70rem] h-[70rem] bg-blue-400/25 rounded-full filter blur-3xl animate-blob"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute bottom-[-30%] right-[-25%] w-[70rem] h-[70rem] bg-teal-400/25 rounded-full filter blur-3xl animate-blob animation-delay-2000"
                    })
                ]
            }),
            menuOpen && !isDesktop && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed inset-0 z-30 bg-slate-900/40 lg:hidden",
                onClick: closeMenu,
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($da881c21841264e4$var$Sidebar, {
                isOpen: isDesktop || menuOpen,
                isDesktop: isDesktop,
                onClose: closeMenu,
                activePage: activePage,
                setActivePage: setActivePage,
                clientProfileStep: clientProfileStep,
                setClientProfileStep: setClientProfileStep,
                showReturnToPartnerPortal: showReturnToPartnerPortal,
                onReturnToPartnerPortal: onReturnToPartnerPortal,
                onSignOut: onSignOut,
                onOpenAccount: onOpenAccount,
                onOpenAdmin: onOpenAdmin,
                showAccount: showAccount,
                showAdmin: showAdmin,
                showCompliance: showCompliance,
                onOpenCompliance: onOpenCompliance,
                factFind: factFind,
                savedStrategies: savedStrategies,
                savedCaseStudies: savedCaseStudies,
                professionalCaseId: professionalCaseId,
                clientFileFallbackName: clientFileFallbackName
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                "data-app-scroll-container": true,
                className: "flex-1 min-w-0 flex flex-col overflow-y-auto",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($da881c21841264e4$var$Header, {
                        onOpenMenu: ()=>setMenuOpen(true),
                        menuOpen: menuOpen
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                        className: "flex-1 p-4 sm:p-6 lg:p-8 pb-28 short:pt-2",
                        children: children
                    })
                ]
            })
        ]
    });
};
var $da881c21841264e4$export$2e2bcd8739ae039 = $da881c21841264e4$var$MainAppLayout;





function $d329efc25751b153$export$2e2bcd8739ae039({ showGeneralAdvice: showGeneralAdvice, setShowGeneralAdvice: setShowGeneralAdvice, showSecurity: showSecurity, setShowSecurity: setShowSecurity, showPrivacy: showPrivacy, setShowPrivacy: setShowPrivacy, showCost: showCost, setShowCost: setShowCost, showFaqs: showFaqs, setShowFaqs: setShowFaqs, showExperience: showExperience, setShowExperience: setShowExperience, showAdmin: showAdmin, setShowAdmin: setShowAdmin, isPlatformAdmin: isPlatformAdmin, canReviewAdvice: canReviewAdvice, showCompliance: showCompliance, setShowCompliance: setShowCompliance, showApiDocs: showApiDocs, setShowApiDocs: setShowApiDocs, closeAdmin: closeAdmin, adminIsHome: adminIsHome, showPaywall: showPaywall, partnerPaywall: partnerPaywall, activePage: activePage, setActivePage: setActivePage, renderPageContent: renderPageContent, setShowRegistration: setShowRegistration, showAccountModal: showAccountModal, setShowAccountModal: setShowAccountModal, accountModalMode: accountModalMode, resetToken: resetToken, closeAccountModal: closeAccountModal, resumeFromSignIn: resumeFromSignIn, handleSignedOut: handleSignedOut, setFactFind: setFactFind, setAccountUser: setAccountUser, showPartnerEntry: showPartnerEntry, setShowPartnerEntry: setShowPartnerEntry, setActiveProfessionalCaseId: setActiveProfessionalCaseId, partnerIntent: partnerIntent, setPartnerIntent: setPartnerIntent, partnerFirm: partnerFirm, setPartnerFirm: setPartnerFirm, setProfessionalCases: setProfessionalCases, showPartnerWizard: showPartnerWizard, setShowPartnerWizard: setShowPartnerWizard, setPartnerResolving: setPartnerResolving, portalEntryError: portalEntryError, setPortalEntryError: setPortalEntryError, setPortalRefreshNonce: setPortalRefreshNonce, addClientPaywall: addClientPaywall, setAddClientPaywall: setAddClientPaywall, clientProfileStep: clientProfileStep, setClientProfileStep: setClientProfileStep, activeProfessionalCaseId: activeProfessionalCaseId, factFind: factFind, savedStrategies: savedStrategies, savedCaseStudies: savedCaseStudies, activeProfessionalCaseName: activeProfessionalCaseName, registrationOverlay: registrationOverlay, inviteNoticeToast: inviteNoticeToast, chatWidget: chatWidget }) {
    // Who is reading: an adviser opens a client's file from the partner portal; anyone else is the client
    // (owner, 21 Oct 2026: "you" when the client is signed in, names when an adviser is — householdVoice).
    (0, $5d864ab5b3ee155d$export$ac23cdfd4b789bf)(Boolean(activeProfessionalCaseId));
    if (showGeneralAdvice) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cbea7fe05b0c10b5$export$2e2bcd8739ae039), {
                // showGeneralAdvice is a plain string (matches LandingPage's loose setShowGeneralAdvice
                // signature); GeneralAdvice.tsx's own section prop is the strict keyof-lookup type — the
                // values that ever land here always come from LANDING_PAGE topic ids that match it.
                section: showGeneralAdvice,
                onBack: ()=>setShowGeneralAdvice(null)
            }),
            registrationOverlay
        ]
    });
    if (showSecurity) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $704e9efeb37f3b49$export$2e2bcd8739ae039), {
        onBack: ()=>setShowSecurity(false)
    });
    if (showPrivacy) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c64b4fe17d116bf7$export$2e2bcd8739ae039), {
        onBack: ()=>setShowPrivacy(false),
        onOpenSecurity: ()=>{
            setShowPrivacy(false);
            setShowSecurity(true);
        }
    });
    if (showCost) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $491b4022863a0e84$export$2e2bcd8739ae039), {
        onBack: ()=>setShowCost(false),
        onGetStarted: ()=>{
            setShowCost(false);
            setShowRegistration(true);
        },
        onBecomePartner: ()=>{
            setShowCost(false);
            setActiveProfessionalCaseId(null);
            setShowPartnerEntry(true);
        }
    });
    if (showFaqs) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90e7468b758bca1$export$2e2bcd8739ae039), {
        onBack: ()=>setShowFaqs(false),
        onGetStarted: ()=>{
            setShowFaqs(false);
            setShowRegistration(true);
        },
        onBecomePartner: ()=>{
            setShowFaqs(false);
            setActiveProfessionalCaseId(null);
            setShowPartnerEntry(true);
        }
    });
    if (showExperience) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ecca3e63fd9dabf8$export$2e2bcd8739ae039), {
        onBack: ()=>setShowExperience(false),
        onGetStarted: ()=>{
            setShowExperience(false);
            setShowRegistration(true);
        },
        onBecomePartner: ()=>{
            setShowExperience(false);
            setActiveProfessionalCaseId(null);
            setShowPartnerEntry(true);
        }
    });
    if (showCompliance && canReviewAdvice) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d0e0fde18cf45dd8$export$2e2bcd8739ae039), {
        onBack: ()=>setShowCompliance(false)
    });
    if (showAdmin && isPlatformAdmin) return showApiDocs ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d916b5e4cd7b884$export$2e2bcd8739ae039), {
        onBack: ()=>setShowApiDocs(false)
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ede43e0935f69fa3$export$2e2bcd8739ae039), {
        onBack: adminIsHome ? ()=>{
            handleSignedOut();
        } : closeAdmin,
        backLabel: adminIsHome ? 'Sign out' : 'Back',
        onOpenApiDocs: ()=>setShowApiDocs(true),
        onOpenCompliance: canReviewAdvice ? ()=>setShowCompliance(true) : undefined
    });
    if (showPaywall) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e7682735b2509c0$export$2e2bcd8739ae039), {
        onSignOut: handleSignedOut,
        notice: "Your account is ready. One step to unlock your full plan and get started."
    });
    if (partnerPaywall) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $057f29bbee31fc12$export$2e2bcd8739ae039), {
        firmName: partnerPaywall.firmName,
        tenantId: partnerPaywall.tenantId,
        onSignOut: handleSignedOut
    });
    if (activePage === 'LandingPage') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f216bfa0510b464b$export$2e2bcd8739ae039), {
                setActivePage: setActivePage,
                setShowGeneralAdvice: setShowGeneralAdvice,
                setShowRegistration: setShowRegistration,
                onOpenSecurity: ()=>setShowSecurity(true),
                onOpenPrivacy: ()=>setShowPrivacy(true),
                onOpenCost: ()=>setShowCost(true),
                onOpenExperience: ()=>setShowExperience(true),
                onOpenFaqs: ()=>setShowFaqs(true),
                onProfessionalLogin: ()=>{
                    setActiveProfessionalCaseId(null);
                    setShowPartnerEntry(true);
                },
                onClientLogin: ()=>{
                    // The other half of the rule: through the client door you land on the client
                    // dashboard, or wherever you left off — even if you also happen to own a firm.
                    (0, $c68a4714eced6b3d$export$40966f30a56fb32)('client');
                    setShowAccountModal(true);
                }
            }),
            showAccountModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b85e9b46e4618b3e$export$2e2bcd8739ae039), {
                initialMode: accountModalMode,
                resetToken: resetToken,
                context: partnerIntent ? 'partner' : undefined,
                onClose: closeAccountModal,
                setFactFind: setFactFind,
                onSignedIn: resumeFromSignIn,
                onSignOut: handleSignedOut
            }),
            registrationOverlay,
            inviteNoticeToast,
            showPartnerEntry && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[10000] p-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 space-y-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            className: "text-xl font-bold text-gray-900",
                            children: "Professional partners"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-gray-600",
                            children: "Work with your clients in your firm's own secure workspace."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "w-full bg-blue-600 text-white font-semibold py-2.5 rounded-lg hover:bg-blue-700 transition-colors",
                            onClick: ()=>{
                                setShowPartnerEntry(false);
                                setPartnerIntent(true);
                                // Remembered for the tab, so a reload — and the auto-resume that races this
                                // sign-in — both still know this person came through the partner door.
                                (0, $c68a4714eced6b3d$export$40966f30a56fb32)('partner');
                                setShowAccountModal(true);
                            },
                            children: "Partner sign in"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "w-full bg-white text-blue-600 border-2 border-blue-600 font-semibold py-2 rounded-lg hover:bg-blue-50 transition-colors",
                            onClick: ()=>{
                                setShowPartnerEntry(false);
                                setShowPartnerWizard(true);
                            },
                            children: "Become a partner"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "w-full text-sm text-gray-400 hover:text-gray-600",
                            onClick: ()=>setShowPartnerEntry(false),
                            children: "Cancel"
                        })
                    ]
                })
            }),
            showPartnerWizard && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32ebf447c4b68a2b$export$2e2bcd8739ae039), {
                onClose: ()=>{
                    (0, $32ebf447c4b68a2b$export$93c6d857426f1fc7)();
                    setShowPartnerWizard(false);
                },
                onComplete: async ()=>{
                    setShowPartnerWizard(false);
                    setPartnerResolving(true); // branded loader, never the demo login, from frame 1
                    // The wizard signs the user in itself (its own signUp/verifySignupCode calls), so
                    // App-level accountUser is still null at this point — without this, the real-mode
                    // resolution effect below (gated on accountUser) never runs and the workspace loader
                    // spins forever.
                    setAccountUser(await (0, $cc9e8a24185b91b0$export$a79e7ef8c396bb0e)());
                    setActivePage('PartnerPortal');
                }
            })
        ]
    });
    if (activePage === 'PartnerPortal') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            renderPageContent(),
            inviteNoticeToast,
            portalEntryError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed inset-0 z-[10000] flex items-center justify-center bg-white p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full max-w-sm space-y-4 text-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                            size: 36,
                            className: "mx-auto text-amber-500",
                            "aria-hidden": "true"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            className: "text-lg font-bold text-gray-900",
                            children: "We couldn't open your workspace"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm leading-relaxed text-gray-600",
                            children: "The connection hiccupped (this can happen when the server is waking up). Your data is safe \u2014 give it another go."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>{
                                setPortalEntryError(false);
                                setPortalRefreshNonce((n)=>n + 1); // re-run workspace resolution
                            },
                            className: "w-full rounded-xl bg-blue-600 hover:bg-blue-700 py-2.5 font-semibold text-white shadow-lg shadow-blue-600/25 transition hover:shadow-xl",
                            children: "Try again"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: handleSignedOut,
                            className: "w-full text-sm text-gray-500 transition hover:text-gray-700",
                            children: "Sign out instead"
                        })
                    ]
                })
            }),
            showPartnerWizard && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32ebf447c4b68a2b$export$2e2bcd8739ae039), {
                onClose: ()=>{
                    (0, $32ebf447c4b68a2b$export$93c6d857426f1fc7)();
                    setShowPartnerWizard(false);
                    // No firm yet and they've declined onboarding — leaving them on the portal page
                    // would strand them on the workspace loader. Back to the front door instead.
                    if (!partnerFirm) setActivePage('LandingPage');
                },
                onComplete: ()=>{
                    setShowPartnerWizard(false);
                    setPortalRefreshNonce((n)=>n + 1); // re-resolve the workspace in real mode
                }
            }),
            showAccountModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b85e9b46e4618b3e$export$2e2bcd8739ae039), {
                initialMode: accountModalMode,
                resetToken: resetToken,
                context: partnerIntent ? 'partner' : undefined,
                onClose: closeAccountModal,
                setFactFind: setFactFind,
                onSignOut: handleSignedOut
            }),
            addClientPaywall && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $779f7aef03fcc8b3$export$2e2bcd8739ae039), {
                summary: addClientPaywall.summary,
                tenantId: addClientPaywall.tenantId,
                onClose: ()=>setAddClientPaywall(null)
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da881c21841264e4$export$2e2bcd8739ae039), {
                activePage: activePage,
                setActivePage: setActivePage,
                clientProfileStep: clientProfileStep,
                setClientProfileStep: setClientProfileStep,
                showReturnToPartnerPortal: Boolean(activeProfessionalCaseId),
                onReturnToPartnerPortal: ()=>setActivePage('PartnerPortal'),
                onSignOut: handleSignedOut,
                // Account/Admin live in the sidebar's bottom action cluster (not floating pills) — one nav
                // language, no overlap. Hidden inside an adviser's client journey (the portal owns that chrome).
                showAccount: !activeProfessionalCaseId,
                onOpenAccount: ()=>setShowAccountModal(true),
                showAdmin: isPlatformAdmin && !activeProfessionalCaseId,
                onOpenAdmin: ()=>setShowAdmin(true),
                showCompliance: canReviewAdvice && !activeProfessionalCaseId,
                onOpenCompliance: ()=>setShowCompliance(true),
                factFind: factFind,
                savedStrategies: savedStrategies,
                savedCaseStudies: savedCaseStudies,
                professionalCaseId: activeProfessionalCaseId,
                clientFileFallbackName: activeProfessionalCaseName,
                children: renderPageContent()
            }),
            showAccountModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b85e9b46e4618b3e$export$2e2bcd8739ae039), {
                initialMode: accountModalMode,
                resetToken: resetToken,
                context: partnerIntent ? 'partner' : undefined,
                onClose: closeAccountModal,
                setFactFind: setFactFind,
                onSignOut: handleSignedOut
            }),
            showPartnerWizard && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32ebf447c4b68a2b$export$2e2bcd8739ae039), {
                onClose: ()=>{
                    (0, $32ebf447c4b68a2b$export$93c6d857426f1fc7)();
                    setShowPartnerWizard(false);
                },
                onComplete: ()=>{
                    setShowPartnerWizard(false);
                    setPartnerResolving(true); // branded loader, never the demo login, from frame 1
                    setActivePage('PartnerPortal');
                }
            }),
            chatWidget,
            registrationOverlay,
            inviteNoticeToast
        ]
    });
}











/**
 * A friendly heads-up, shown once per visit, when someone opens one of the planning modules on a
 * phone.
 *
 * The client profile is a form and works fine on a phone — this is deliberately NOT shown there.
 * The modules are a different proposition: strategies compared side by side, charts, projections
 * and long tables of figures. They are legible on a laptop or tablet and a squeeze on a handset.
 *
 * ADVISORY, NEVER A BARRIER. Whoever is holding the phone may have good reason to be — sitting
 * with a parent, or away from a desk — so "Continue anyway" is the primary action and the notice
 * never returns for the rest of the session once answered. Blocking them would be presumptuous
 * about a device we cannot see the circumstances of.
 *
 * The cut is at 768px (Tailwind's `md`): tablets are on the recommended side of it, which matches
 * the advice the copy actually gives.
 */ 

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $27047bb67f23145f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 5a2 2 0 0 1 2 2v8.526a2 2 0 0 0 .212.897l1.068 2.127a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45l1.068-2.127A2 2 0 0 0 4 15.526V7a2 2 0 0 1 2-2z",
            key: "1pdavp"
        }
    ],
    [
        "path",
        {
            d: "M20.054 15.987H3.946",
            key: "14rxg9"
        }
    ]
];
const $27047bb67f23145f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("laptop", $27047bb67f23145f$export$3efd853dbb351e94);


/** Answered once, remembered for the tab — asking again on each module would nag. */ const $600b183a8c376037$var$DISMISS_KEY = 'acw:smallScreenNoticeAnswered';
const $600b183a8c376037$var$answeredAlready = ()=>{
    try {
        return window.sessionStorage.getItem($600b183a8c376037$var$DISMISS_KEY) === '1';
    } catch  {
        // Private browsing or blocked storage: better to show the notice than to crash on it.
        return false;
    }
};
const $600b183a8c376037$var$rememberAnswer = ()=>{
    try {
        window.sessionStorage.setItem($600b183a8c376037$var$DISMISS_KEY, '1');
    } catch  {
    /* Nothing to do — it will simply ask again next time. */ }
};
const $600b183a8c376037$var$SmallScreenNotice = ({ onBack: onBack })=>{
    const [answered, setAnswered] = (0, $acw62.useState)($600b183a8c376037$var$answeredAlready);
    const [isPhone, setIsPhone] = (0, $acw62.useState)(()=>typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches);
    (0, $acw62.useEffect)(()=>{
        if (typeof window === 'undefined') return undefined;
        const mq = window.matchMedia('(max-width: 767px)');
        const onChange = (e)=>setIsPhone(e.matches);
        mq.addEventListener('change', onChange);
        setIsPhone(mq.matches);
        return ()=>mq.removeEventListener('change', onChange);
    }, []);
    if (answered || !isPhone) return null;
    const answer = (then)=>{
        $600b183a8c376037$var$rememberAnswer();
        setAnswered(true);
        then?.();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "fixed inset-0 z-[70] flex items-end sm:items-center justify-center p-4",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "small-screen-notice-title",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute inset-0 bg-slate-900/50",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>answer(),
                        "aria-label": "Close",
                        className: "absolute right-3 top-3 flex h-10 w-10 items-center justify-center rounded-full text-gray-400 hover:bg-slate-100 hover:text-gray-600",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                            size: 18,
                            "aria-hidden": "true"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-brand-navy shadow-lg shadow-blue-500/25",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $27047bb67f23145f$export$2e2bcd8739ae039), {
                            size: 26,
                            className: "text-white",
                            "aria-hidden": "true"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        id: "small-screen-notice-title",
                        className: "text-xl font-bold text-gray-900 leading-snug",
                        children: "This part is easier on a bigger screen"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-2 text-sm leading-relaxed text-gray-600",
                        children: "There's a fair bit to weigh up here \u2014 options compared side by side, charts, and figures projected over several years. It all fits together much more clearly on a laptop or an iPad."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-2 text-sm leading-relaxed text-gray-600",
                        children: "You're very welcome to carry on here if now is the right moment \u2014 nothing is hidden on a phone."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-6 flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>answer(),
                                className: "w-full min-h-[48px] rounded-lg bg-blue-600 hover:bg-blue-700 px-4 py-3 font-semibold text-white shadow-md",
                                children: "Continue anyway"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>answer(onBack),
                                className: "w-full min-h-[48px] rounded-lg border border-slate-300 bg-white px-4 py-3 font-semibold text-gray-700",
                                children: "Back to dashboard"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $600b183a8c376037$export$2e2bcd8739ae039 = $600b183a8c376037$var$SmallScreenNotice;


/**
 * "We've updated our privacy policy" — shown once to a signed-in user whose last acknowledged
 * version is older than the current one (owner, 15 Oct 2026: keep it to the one sentence). The
 * server already knew both versions; nothing read them until this. Pressing the button records the
 * acknowledgement, and the notice does not come back. A new sign-up accepts the current version at
 * sign-up and never sees it.
 */ 

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");




const $3034cbc16e4c7b14$export$47f267ab5b43338c = "We've updated our privacy policy";
function $3034cbc16e4c7b14$export$9fcb4c42b89af58d(status) {
    const current = status?.current?.privacy_policy;
    const accepted = status?.accepted?.privacy_policy?.version;
    if (!current || !accepted) return false;
    return accepted !== current;
}
const $3034cbc16e4c7b14$var$PrivacyPolicyUpdateNotice = ({ userKey: userKey })=>{
    const [show, setShow] = (0, $acw62.useState)(false);
    const [reading, setReading] = (0, $acw62.useState)(false);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        let live = true;
        if (!userKey) {
            setShow(false);
            return undefined;
        }
        // A build without accounts, a lapsed session or an unreachable server: no notice, no noise.
        (0, $1124d5012b356e89$export$1da9236be1858959)().then((status)=>{
            if (live) setShow($3034cbc16e4c7b14$export$9fcb4c42b89af58d(status));
        }).catch(()=>{
            if (live) setShow(false);
        });
        return ()=>{
            live = false;
        };
    }, [
        userKey
    ]);
    if (!show || typeof document === 'undefined') return null;
    const acknowledge = async ()=>{
        setSaving(true);
        try {
            await (0, $1124d5012b356e89$export$2fe2928877a2a98)([
                'privacy_policy'
            ], 'reacceptance');
            setShow(false);
        } catch  {
            // Leave the notice up; the next sign-in asks again.
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed inset-0 z-[9000] flex items-center justify-center bg-slate-900/40 backdrop-blur-sm p-4",
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "privacy-update-heading",
                "data-testid": "privacy-policy-update-notice",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "bg-white rounded-2xl shadow-2xl w-full max-w-md p-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            id: "privacy-update-heading",
                            className: "text-lg font-bold text-slate-900",
                            children: $3034cbc16e4c7b14$export$47f267ab5b43338c
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "mt-2 text-sm text-slate-600 leading-relaxed",
                            children: [
                                "Please take a moment to read the updated policy (version ",
                                (0, $23065750a32ab3de$export$ecf6508459835aaf).effectiveDate,
                                ")."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mt-5 flex flex-wrap gap-2 justify-end",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    size: "sm",
                                    onClick: ()=>setReading(true),
                                    children: "Read the policy"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ba5b1d72823edd$export$2e2bcd8739ae039), {
                                    variant: "brand",
                                    size: "sm",
                                    onClick: acknowledge,
                                    disabled: saving,
                                    children: saving ? "Saving\u2026" : "I've read it"
                                })
                            ]
                        })
                    ]
                })
            }),
            reading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1cc4e5852e6af25$export$2e2bcd8739ae039), {
                doc: (0, $23065750a32ab3de$export$ecf6508459835aaf),
                onClose: ()=>setReading(false)
            })
        ]
    }), document.body);
};
var $3034cbc16e4c7b14$export$2e2bcd8739ae039 = $3034cbc16e4c7b14$var$PrivacyPolicyUpdateNotice;




/** Each module's page, as AWise's screen key, when no plans are on screen yet. */ const $19d9deac12f277fb$var$MODULE_SCREEN_KEYS = {
    HomeCarePage: 'support-at-home',
    RetirementVillagePage: 'retirement-village',
    DownsizingPage: 'downsizing',
    GrannyFlatPage: 'granny-flat',
    CashflowPensionPage: 'cashflow-pension'
};
// --- FINANCIAL CALCULATION ENGINE: uses imported calculateFinancials from FinancialCalculations.js ---
// --- MAIN APP COMPONENT ---
function $19d9deac12f277fb$var$App() {
    const [activePage, setActivePage] = (0, $acw62.useState)('LandingPage');
    /*
     * Which door the Cashflow & Age Pension page was opened through, so its Back returns there
     * (review, 18 Oct 2026: Back always went to Support at home). Worked out during render from the
     * page before it, so the page's first paint already knows; a re-render on the same page changes
     * nothing.
     */ const lastPageRef = (0, $acw62.useRef)(activePage);
    const cashflowCameFromRef = (0, $acw62.useRef)('home');
    if (lastPageRef.current !== activePage) {
        if (activePage === 'CashflowPensionPage') cashflowCameFromRef.current = lastPageRef.current === 'HomeCarePage' ? 'support_at_home' : 'home';
        lastPageRef.current = activePage;
    }
    const [showGeneralAdvice, setShowGeneralAdvice] = (0, $acw62.useState)(null);
    const [showSecurity, setShowSecurity] = (0, $acw62.useState)(false);
    const [showPrivacy, setShowPrivacy] = (0, $acw62.useState)(false);
    const [showCost, setShowCost] = (0, $acw62.useState)(false);
    const [showExperience, setShowExperience] = (0, $acw62.useState)(false);
    const [showFaqs, setShowFaqs] = (0, $acw62.useState)(false);
    // Platform owner/super-admin console — only ever shown when the SERVER confirms admin rights.
    const [isPlatformAdmin, setIsPlatformAdmin] = (0, $acw62.useState)(false);
    const [showAdmin, setShowAdmin] = (0, $acw62.useState)(false);
    // Licensee oversight (advice under our licence): who may open it, and whether it is open.
    const [canReviewAdvice, setCanReviewAdvice] = (0, $acw62.useState)(false);
    const [showCompliance, setShowCompliance] = (0, $acw62.useState)(false);
    // The API docs are a sub-screen of the admin console (linked from it, not the sidebar) —
    // only meaningful while showAdmin is true; closeAdmin() below resets both together so a fresh
    // "Admin" entry always lands back on the firms list, not wherever the last visit left off.
    const [showApiDocs, setShowApiDocs] = (0, $acw62.useState)(false);
    const closeAdmin = ()=>{
        setShowAdmin(false);
        setShowApiDocs(false);
    };
    /*
     * True when the admin console was opened as the admin's HOME — they signed in and have no firm,
     * so routePlatformAdminWithoutFirm put them here. "Back" from there landed on their own empty
     * personal client file, which made no sense (owner, 1 Oct 2026); the console's link becomes
     * "Sign out" instead. Opened from the sidebar or the portal, it stays "Back".
     */ const [adminIsHome, setAdminIsHome] = (0, $acw62.useState)(false);
    // Consumer paywall (Option A). Only ever shown when billing is LIVE and the consumer has no
    // active access — while billing is off the server reports hasAccess:true and this stays false.
    const [showPaywall, setShowPaywall] = (0, $acw62.useState)(false);
    // Partner-channel entry (real accounts): the two-door chooser + the onboarding wizard.
    const [showPartnerEntry, setShowPartnerEntry] = (0, $acw62.useState)(false);
    // Who is signed in (null when signed out) — drives auto-save and the portal's real mode.
    const [accountUser, setAccountUser] = (0, $acw62.useState)(null);
    // Ask the server whether this signed-in user is a platform admin (drives the admin entry point).
    // The server re-checks on every admin call regardless — this only decides whether to show it.
    (0, $acw62.useEffect)(()=>{
        if (!accountUser) {
            setIsPlatformAdmin(false);
            setShowAdmin(false);
            setCanReviewAdvice(false);
            setShowCompliance(false);
            setAdminIsHome(false);
            return;
        }
        let live = true;
        (0, $0aae0b39fc034917$export$50b438d8bcaa9dbd)().then((access)=>{
            if (!live) return;
            setIsPlatformAdmin(access.isAdmin);
            setCanReviewAdvice(access.canReviewAdvice);
        });
        return ()=>{
            live = false;
        };
    }, [
        accountUser
    ]);
    /*
     * A PLATFORM ADMIN IS NEVER OFFERED "BECOME A PARTNER" (owner-reported, 1 Oct 2026).
     *
     * Signing in through the professionals door, or opening the portal, with no firm membership
     * opens the partner onboarding wizard. A platform admin usually has no firm, so the owner signed
     * in successfully and was asked to create a partner profile — while a fresh tab showed the
     * dashboard with the Admin item, proving the sign-in had worked. Every automatic opener of the
     * wizard now asks this first; when the server confirms admin rights the admin console opens
     * instead. The explicit "Become a partner" button is left alone: clicking it is a choice.
     */ const routePlatformAdminWithoutFirm = async ()=>{
        const admin = await (0, $0aae0b39fc034917$export$de308d3ddda5dcbc)().catch(()=>false);
        if (!admin) return false;
        (0, $32ebf447c4b68a2b$export$93c6d857426f1fc7)();
        setIsPlatformAdmin(true);
        setShowAdmin(true);
        setAdminIsHome(true);
        setActivePage('Dashboard');
        return true;
    };
    const [factFind, setFactFind] = (0, $acw62.useState)(()=>structuredClone((0, $b116352393ba4abb$export$55f731ae3600e88a)));
    const [strategyOptions, setStrategyOptions] = (0, $acw62.useState)({});
    const [selectedStrategy, setSelectedStrategy] = (0, $acw62.useState)(null);
    const [clientProfileStep, setClientProfileStep] = (0, $acw62.useState)(1);
    /** Seeds AgedCareAnalyser's own local legacy-years state; that component owns the value from
     *  here on (see AgedCareAnalyserProps.legacyYears/setLegacyYears in AgedCareAnalyser.tsx). */ const [legacyYears, setLegacyYears] = (0, $acw62.useState)((0, $77d0522707ddb581$export$39a105507aa40371));
    // Scroll to top whenever the active page changes
    (0, $acw62.useEffect)(()=>{
        // Find the scrollable container
        const scrollableContainer = document.querySelector('.overflow-y-auto');
        if (scrollableContainer) scrollableContainer.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        else window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [
        activePage
    ]);
    // Per FILE, not per tab: reset whenever the client file changes (coupleValidationDefaults.ts).
    const [coupleValidation, setCoupleValidation] = (0, $acw62.useState)(()=>(0, $87baeb3af1e4d5de$export$8c4af9c383a44b94)());
    // Strategy management state - moved to App level (session-based for POC)
    const [savedStrategies, setSavedStrategies] = (0, $acw62.useState)(()=>{
        // For POC: Clear any existing strategies on app start to ensure fresh session
        // Check both possible keys that might contain data
        const storedStrategies = sessionStorage.getItem('careCompanionStrategies');
        const storedScenarios = sessionStorage.getItem('careCompanionScenarios');
        if (storedStrategies || storedScenarios) {
            // Clear all stored data to ensure fresh start for POC
            sessionStorage.removeItem('careCompanionStrategies');
            sessionStorage.removeItem('careCompanionCaseStudies');
            sessionStorage.removeItem('careCompanionScenarios'); // Also clear this key used by AgedCareSuggestionEnginePanel
            sessionStorage.removeItem('careCompanionReopenStrategy');
        }
        return [];
    });
    const [savedCaseStudies, setSavedCaseStudies] = (0, $acw62.useState)(()=>{
        return [];
    });
    const [chatOpen, setChatOpen] = (0, $acw62.useState)(false);
    const [chatMessages, setChatMessages] = (0, $acw62.useState)([
        {
            sender: 'bot',
            text: (0, $076d4db919791ede$export$18735436527b64b6)
        }
    ]);
    const [chatInput, setChatInput] = (0, $acw62.useState)('');
    const [chatSending, setChatSending] = (0, $acw62.useState)(false);
    const submitChatMessage = (0, $acw62.useCallback)(async ()=>{
        const trimmed = chatInput.trim();
        if (!trimmed || chatSending) return;
        setChatSending(true);
        const history = chatMessages;
        setChatMessages((msgs)=>[
                ...msgs,
                {
                    sender: 'user',
                    text: trimmed
                }
            ]);
        setChatInput('');
        try {
            // The Aged care module says which of its screens is showing, and the facts on it (UX review,
            // 17 Oct 2026: AWise had no context there at all).
            const agedCareScreen = activePage === 'AgedCarePage' ? (0, $6067e4a24a943681$export$49a9c588fd4c5f9d)() : null;
            // The other modules (owner, 22 Oct 2026): the module itself, and the plans on screen with their debts.
            const moduleScreen = (0, $a84adeeb3afb300d$export$144de64fbfa9a324)(activePage);
            const screenKey = activePage === 'Client Profile' ? `factfind-${clientProfileStep}` : activePage === 'Dashboard' ? 'dashboard' : agedCareScreen ? `aged-care-${agedCareScreen.screen}` : moduleScreen ? moduleScreen.screen : $19d9deac12f277fb$var$MODULE_SCREEN_KEYS[activePage] ?? null;
            const aiReply = await (0, $17f95ada13b08766$export$58ecd998c8d4e9d3)({
                message: trimmed,
                systemInstruction: (0, $076d4db919791ede$export$7bd5b69b343d3c3a)(screenKey || '', agedCareScreen?.note ?? moduleScreen?.note ?? null),
                conversationHistory: history
            });
            setChatMessages((msgs)=>[
                    ...msgs,
                    {
                        sender: 'bot',
                        text: aiReply
                    }
                ]);
        } catch (e) {
            setChatMessages((msgs)=>[
                    ...msgs,
                    {
                        sender: 'bot',
                        text: "Something went wrong sending your message. You can try again in a moment."
                    }
                ]);
        } finally{
            setChatSending(false);
        }
    }, [
        chatInput,
        chatSending,
        chatMessages,
        activePage,
        clientProfileStep
    ]);
    const { professionalRole: professionalRole, setProfessionalRole: setProfessionalRole, setProfessionalCases: setProfessionalCases, scopedProfessionalCases: scopedProfessionalCases, activeProfessionalCaseId: activeProfessionalCaseId, setActiveProfessionalCaseId: setActiveProfessionalCaseId, activeProfessionalCase: activeProfessionalCase, partnerPortalReviewNonce: partnerPortalReviewNonce, setPartnerPortalReviewNonce: setPartnerPortalReviewNonce, partnerIntent: partnerIntent, setPartnerIntent: setPartnerIntent, partnerFirm: partnerFirm, setPartnerFirm: setPartnerFirm, activeRealProfileId: activeRealProfileId, setActiveRealProfileId: setActiveRealProfileId, partnerResolving: partnerResolving, setPartnerResolving: setPartnerResolving, portalEntryError: portalEntryError, setPortalEntryError: setPortalEntryError, setPortalRefreshNonce: setPortalRefreshNonce, partnerPaywall: partnerPaywall, setPartnerPaywall: setPartnerPaywall, partnerBilling: partnerBilling, addClientPaywall: addClientPaywall, setAddClientPaywall: setAddClientPaywall, showPartnerWizard: showPartnerWizard, setShowPartnerWizard: setShowPartnerWizard, updateProfessionalCase: updateProfessionalCase, markProfessionalCaseSoaStatus: markProfessionalCaseSoaStatus, setCurrentSoaForCase: setCurrentSoaForCase, publishSoaForCase: publishSoaForCase, deleteDraftSoa: deleteDraftSoa, openProfessionalCaseJourney: openProfessionalCaseJourney, createInPersonProfessionalCase: createInPersonProfessionalCase, createInviteProfessionalCase: createInviteProfessionalCase, submitProfessionalCaseToAdviser: submitProfessionalCaseToAdviser, registeredSoasByProfileId: registeredSoasByProfileId, analyticsDataState: analyticsDataState, loadFactFindsForAnalytics: loadFactFindsForAnalytics, remindClient: remindClient, firmSettings: firmSettings, autoReminders: autoReminders, messageDefaults: messageDefaults, saveFirmSettings: saveFirmSettings } = (0, $4a3ab415a7732163$export$2aa10d7f02877481)({
        accountUser: accountUser,
        activePage: activePage,
        setActivePage: setActivePage,
        factFind: factFind,
        setFactFind: setFactFind,
        clientProfileStep: clientProfileStep,
        setClientProfileStep: setClientProfileStep,
        setSavedStrategies: setSavedStrategies,
        setCoupleValidation: setCoupleValidation,
        savedCaseStudies: savedCaseStudies,
        setSavedCaseStudies: setSavedCaseStudies,
        routePlatformAdminWithoutFirm: routePlatformAdminWithoutFirm
    });
    // --- Insight Panel State ---
    /**
   * The planning modules — strategies side by side, charts, multi-year projections. Legible on a
   * laptop or tablet, a squeeze on a phone, which is what SmallScreenNotice says (once) to anyone
   * who opens one on a handset. The client profile is a form and is deliberately absent: it works
   * fine on a phone and now carries its own supporting column there.
   */ const MODULE_PAGES = new Set([
        'AgedCarePage',
        'HomeCarePage',
        'RetirementVillagePage',
        'GrannyFlatPage',
        'DownsizingPage'
    ]);
    /**
   * Every generated Statement of Advice lands on the server's versioned advice register — immutable,
   * numbered, attributed to the licensee, on the tamper-evident trail, and kept for its retention
   * period. One function for every module (owner, 1 Oct 2026: Support at Home's never reached it).
   *   - A firm working on a real client file: registered against that file.
   *   - A signed-in client on their own file (the direct channel, our licence): they have no file id
   *     in the browser, so it goes through the id-free route — it used to go nowhere at all.
   *   - Anything else (a demo journey, signed out): nothing to register. Returns null.
   */ const registerGeneratedSoa = (module, document1)=>{
        const request = activeRealProfileId ? (0, $3ca5b2fc75d0c72b$export$900fe88f3237d3b7)(activeRealProfileId, module, document1) : accountUser && !activeProfessionalCaseId ? (0, $3ca5b2fc75d0c72b$export$1191fb166f7f7cba)(module, document1) : null;
        return request?.catch((err)=>{
            if ("production" === 'development') console.warn('[soa-register]', err instanceof Error ? err.message : err);
            throw err;
        });
    };
    const renderPageContent = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                MODULE_PAGES.has(activePage) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $600b183a8c376037$export$2e2bcd8739ae039), {
                    onBack: ()=>setActivePage('Dashboard')
                }),
                renderActivePage()
            ]
        });
    const renderActivePage = ()=>{
        switch(activePage){
            case 'Dashboard':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91e8bd92d2abf1ed$export$2e2bcd8739ae039), {
                    setActivePage: setActivePage,
                    setClientProfileStep: setClientProfileStep,
                    factFind: factFind,
                    setFactFind: setFactFind,
                    savedStrategies: savedStrategies,
                    setSavedStrategies: setSavedStrategies,
                    savedCaseStudies: savedCaseStudies,
                    setSavedCaseStudies: setSavedCaseStudies,
                    onDeleteDraftSoa: deleteDraftSoa,
                    selectedStrategy: selectedStrategy,
                    setSelectedStrategy: (s)=>setSelectedStrategy(s),
                    professionalContext: activeProfessionalCase ? {
                        enabled: true,
                        caseId: activeProfessionalCase.id,
                        accessMode: activeProfessionalCase.accessMode,
                        submissionDate: activeProfessionalCase.submissionDate ?? undefined
                    } : null,
                    onSubmitToAdviser: submitProfessionalCaseToAdviser
                });
            case 'Client Profile':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $985134edd4f7191c$export$2e2bcd8739ae039), {
                    setActivePage: setActivePage,
                    factFind: factFind,
                    setFactFind: setFactFind,
                    clientProfileStep: clientProfileStep,
                    setClientProfileStep: setClientProfileStep,
                    hideApplicantContactFields: true,
                    showStructureAdviserFields: Boolean(activeProfessionalCaseId)
                });
            case 'AgedCarePage':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $30c9565ba55bece8$export$2e2bcd8739ae039), {
                    setActivePage: setActivePage,
                    factFind: factFind,
                    setFactFind: setFactFind,
                    strategyOptions: strategyOptions,
                    setStrategyOptions: setStrategyOptions,
                    legacyYears: legacyYears,
                    setLegacyYears: setLegacyYears,
                    selectedStrategy: selectedStrategy,
                    setSelectedStrategy: setSelectedStrategy,
                    coupleValidation: coupleValidation,
                    setCoupleValidation: setCoupleValidation,
                    // App.tsx's savedStrategies/savedCaseStudies use the dashboardConfig.tsx shapes (the App-level,
                    // cross-feature canonical ones — see Dashboard/RetirementVillagePage); AgedCareAnalyser's own
                    // SavedAgedCareStrategy/SavedCaseStudy types are a stricter aged-care-specific view of the same
                    // persisted rows. Both sides carry an index signature and only differ in which fields are
                    // required, so this is a documented boundary cast, not a real type-safety gap.
                    savedStrategies: savedStrategies,
                    setSavedStrategies: setSavedStrategies,
                    savedCaseStudies: savedCaseStudies,
                    setSavedCaseStudies: setSavedCaseStudies,
                    isProfessionalJourney: Boolean(activeProfessionalCaseId),
                    professionalCaseId: activeProfessionalCaseId,
                    onStrategySaved: (strategy)=>{
                        // REAL client file: persist the modelling to the server so it survives sign-out and so the
                        // Partner Portal can see that this client HAS been modelled (the pipeline reads saved_models).
                        // Best-effort — the in-app copy in sessionStorage remains the working view either way.
                        if (!activeRealProfileId || !strategy?.id) return;
                        (0, $3ca5b2fc75d0c72b$export$524c7af693144442)(activeRealProfileId, 'aged_care', String(strategy.name || 'Aged care strategy'), strategy).catch((err)=>{});
                    },
                    onSoaGenerated: (scenario)=>{
                        const caseId = String(scenario?.caseId ?? activeProfessionalCaseId ?? '');
                        if (caseId) {
                            updateProfessionalCase(caseId, {
                                currentSoaId: scenario?.id ? String(scenario.id) : undefined
                            });
                            markProfessionalCaseSoaStatus(caseId, 'draft');
                        }
                        if (scenario?.id) registerGeneratedSoa('aged_care', scenario)?.then((reg)=>{
                            setSavedCaseStudies((prev)=>prev.map((sc)=>sc.id === scenario.id ? {
                                        ...sc,
                                        serverSoaId: reg.soaId,
                                        serverSoaVersion: reg.version,
                                        licenseeName: reg.licenseeName,
                                        afslNumber: reg.afslNumber
                                    } : sc));
                        }).catch((err)=>{
                            if ("production" === 'development') console.warn('[soa-register]', err instanceof Error ? err.message : err);
                        });
                    },
                    AgedCareAnalyser: (0, $39641e97aa80005f$export$2e2bcd8739ae039)
                });
            case 'AssumptionsPage':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ff70e3ad4640938$export$2e2bcd8739ae039), {
                    setActivePage: setActivePage
                });
            case 'HomeCarePage':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b8484c25c6d1bce9$export$2e2bcd8739ae039), {
                    setActivePage: setActivePage,
                    factFind: factFind,
                    setFactFind: setFactFind,
                    setSavedStrategies: setSavedStrategies,
                    onSoaGenerated: (document1)=>{
                        registerGeneratedSoa('support_at_home', document1)?.catch(()=>undefined);
                    }
                });
            /*
       * Its own page key, not a tab inside Support at Home (owner direction, 2026-08-28). The module
       * is deliberately general — it models a client with no care event at all — and since 18 Oct
       * 2026 the client menu and Home open it too. `cameFrom` says which door was used (worked out
       * above from the page before), so its copy and its Back follow the journey without the module
       * knowing anything about Support at Home.
       */ case 'CashflowPensionPage':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61e08b09c5525908$export$2e2bcd8739ae039), {
                    setActivePage: setActivePage,
                    factFind: factFind,
                    onIncomeOnlyUnderstoodChange: (0, $5eae79c7e46ed27e$export$415ddf94c95c9134)(setFactFind),
                    onGuaranteedIncomeGoals: (0, $2663acaa6cb9dd5e$export$53527fb30548f6a8)(setFactFind),
                    onCashflowGoals: (0, $2663acaa6cb9dd5e$export$650f0b37276dc44d)(setFactFind),
                    setSavedStrategies: setSavedStrategies,
                    savedStrategies: savedStrategies,
                    cameFrom: cashflowCameFromRef.current,
                    onSoaGenerated: (document1)=>{
                        registerGeneratedSoa('cashflow_pension', document1)?.catch(()=>undefined);
                    }
                });
            case 'RetirementVillagePage':
                // RetirementVillagePage.tsx defines its own local (stricter) SavedStrategy shape — see the
                // AgedCarePage savedStrategies comment above for why this is a documented boundary cast.
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7911ccd6eced4ff4$export$2e2bcd8739ae039), {
                    setActivePage: setActivePage,
                    factFind: factFind,
                    savedStrategies: savedStrategies,
                    setSavedStrategies: setSavedStrategies,
                    setFactFind: setFactFind,
                    onSoaGenerated: (document1)=>{
                        registerGeneratedSoa('retirement_village', document1)?.catch(()=>undefined);
                    }
                });
            case 'GrannyFlatPage':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f34df9d62ff01218$export$2e2bcd8739ae039), {
                    setActivePage: setActivePage,
                    factFind: factFind,
                    savedStrategies: savedStrategies,
                    setSavedStrategies: setSavedStrategies,
                    setFactFind: setFactFind,
                    onSoaGenerated: (document1)=>{
                        registerGeneratedSoa('granny_flat', document1)?.catch(()=>undefined);
                    }
                });
            case 'DownsizingPage':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d2901929448dacd$export$2e2bcd8739ae039), {
                    setActivePage: setActivePage,
                    factFind: factFind,
                    savedStrategies: savedStrategies,
                    setSavedStrategies: setSavedStrategies,
                    setFactFind: setFactFind,
                    onSoaGenerated: (document1)=>{
                        registerGeneratedSoa('downsizer', document1)?.catch(()=>undefined);
                    }
                });
            case 'PartnerPortal':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3bd107510f74a4b4$export$2e2bcd8739ae039), {
                    realIdentity: partnerFirm ? partnerFirm.identity : null,
                    realModeLoading: partnerResolving || Boolean(accountUser),
                    role: professionalRole,
                    setRole: setProfessionalRole,
                    cases: scopedProfessionalCases,
                    // dashboardConfig.tsx's SavedCaseStudy (App's canonical shape) is looser than PartnerPortal's
                    // own SoaScenario (id/caseId are optional here, required there) — documented boundary cast.
                    savedCaseStudies: savedCaseStudies,
                    onCreateInPersonCase: createInPersonProfessionalCase,
                    onCreateInviteCase: createInviteProfessionalCase,
                    onOpenCaseJourney: openProfessionalCaseJourney,
                    reviewNavigationNonce: partnerPortalReviewNonce,
                    focusedCaseId: activeProfessionalCaseId,
                    onOpenCaseFromModel: (caseId)=>{
                        setActiveProfessionalCaseId(caseId);
                        setPartnerPortalReviewNonce((n)=>n + 1);
                        setActivePage('PartnerPortal');
                    },
                    onMarkSoaSent: (caseId, soaId)=>publishSoaForCase(caseId, soaId),
                    onSetCurrentSoaForCase: setCurrentSoaForCase,
                    onDeleteDraftSoa: deleteDraftSoa,
                    registeredSoasByProfileId: registeredSoasByProfileId,
                    analyticsDataState: analyticsDataState,
                    onNeedAnalyticsData: loadFactFindsForAnalytics,
                    // A reassigned or restricted file changes which rows this adviser may see at all, so the
                    // list is re-read from the server rather than patched locally — the server is the one that
                    // decides, and guessing here is how a screen starts disagreeing with the database.
                    onClientAssignmentChanged: ()=>setPortalRefreshNonce((n)=>n + 1),
                    onRemindClient: remindClient,
                    firmSettings: firmSettings,
                    autoReminders: autoReminders,
                    messageDefaults: messageDefaults,
                    onSaveFirmSettings: saveFirmSettings,
                    onExitToConsumer: partnerFirm ? handleSignedOut // real firm member: actually sign out (clears the session)
                     : ()=>{
                        // No firm behind this session: just leave the portal.
                        setActivePage('LandingPage');
                    },
                    // Platform owner: the Admin entry lives IN the portal sidebar (not a floating pill).
                    onOpenAdmin: isPlatformAdmin ? ()=>setShowAdmin(true) : undefined,
                    // Per-client billing (real mode only): plan summary + owner billing actions in Settings.
                    // billingApi.ts's PartnerBillingSummary (server response — mode includes 'none', capacity/
                    // remaining are nullable) vs PartnerPortal's own display-only BillingSummary (no 'none',
                    // no nulls) — documented boundary cast, mirrors the savedCaseStudies one above.
                    billingSummary: partnerFirm ? partnerBilling : null,
                    onManageBilling: partnerFirm ? ()=>(0, $9969e0eb851fd9fb$export$f4dd4b2c29960b0f)() : undefined,
                    onUpgradeAnnual: partnerFirm ? ()=>(0, $9969e0eb851fd9fb$export$b439f56cc3105c)('partner', partnerFirm.tenantId) : undefined,
                    onBuyClient: partnerFirm ? ()=>(0, $9969e0eb851fd9fb$export$b439f56cc3105c)('partner_client', partnerFirm.tenantId) : undefined
                });
            default:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e228dc2671f7e61$export$2e2bcd8739ae039), {
                    title: activePage,
                    setActivePage: setActivePage
                });
        }
    };
    const { flushPendingSave: flushPendingSave, saveFailure: saveFailure, retrySave: retrySave, savedElsewhere: savedElsewhere } = (0, $b563189de2094b70$export$7bd7a03f2ad77f7a)({
        accountUser: accountUser,
        activeProfessionalCaseId: activeProfessionalCaseId,
        activeRealProfileId: activeRealProfileId,
        activePage: activePage,
        factFind: factFind,
        clientProfileStep: clientProfileStep,
        savedStrategies: savedStrategies,
        savedCaseStudies: savedCaseStudies,
        coupleValidation: coupleValidation
    });
    const { resetToken: resetToken, accountModalMode: accountModalMode, showAccountModal: showAccountModal, setShowAccountModal: setShowAccountModal, showRegistration: showRegistration, setShowRegistration: setShowRegistration, inviteNotice: inviteNotice, setInviteNotice: setInviteNotice, enterConsumerWithBilling: enterConsumerWithBilling, resumeFromSignIn: resumeFromSignIn, handleSignedOut: handleSignedOut, closeAccountModal: closeAccountModal } = (0, $36466739b029c3d8$export$6af6f333c20ef9be)({
        accountUser: accountUser,
        setAccountUser: setAccountUser,
        activePage: activePage,
        setActivePage: setActivePage,
        setFactFind: setFactFind,
        setClientProfileStep: setClientProfileStep,
        setSavedStrategies: setSavedStrategies,
        setSavedCaseStudies: setSavedCaseStudies,
        setCoupleValidation: setCoupleValidation,
        setShowPaywall: setShowPaywall,
        partnerIntent: partnerIntent,
        setPartnerIntent: setPartnerIntent,
        setActiveProfessionalCaseId: setActiveProfessionalCaseId,
        setActiveRealProfileId: setActiveRealProfileId,
        setPartnerFirm: setPartnerFirm,
        setPartnerResolving: setPartnerResolving,
        setPortalRefreshNonce: setPortalRefreshNonce,
        showPartnerWizard: showPartnerWizard,
        setShowPartnerWizard: setShowPartnerWizard,
        setPartnerPaywall: setPartnerPaywall,
        setAddClientPaywall: setAddClientPaywall,
        flushPendingSave: flushPendingSave,
        routePlatformAdminWithoutFirm: routePlatformAdminWithoutFirm
    });
    /**
   * "Get Started" overlay: with real accounts configured this creates an actual account
   * (email + password only — no mobile; we don't collect what we don't use) and drops the new
   * user straight into the fact-find. Demo builds keep the original wireframe modal.
   */ // NOTE: the platform-admin entry is NEVER a floating pill. It lives in the sidebar's action
    // cluster in the consumer app, and in the portal's own sidebar footer (onOpenAdmin). It is not
    // shown on the public landing page at all.
    /** Invite outcome toast — shown over any screen, dismissible, auto-hides after 12s. */ const inviteNoticeToast = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            inviteNotice && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed top-4 left-1/2 z-[10002] w-[calc(100%-2rem)] max-w-md -translate-x-1/2",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: `flex items-start gap-3 rounded-xl border bg-white px-4 py-3 shadow-xl ${inviteNotice.tone === 'error' ? 'border-red-200' : 'border-emerald-200'}`,
                    children: [
                        inviteNotice.tone === 'error' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                            size: 18,
                            className: "mt-0.5 shrink-0 text-red-500",
                            "aria-hidden": "true"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                            size: 18,
                            className: "mt-0.5 shrink-0 text-emerald-600",
                            "aria-hidden": "true"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "flex-1 text-sm leading-relaxed text-gray-700",
                            children: inviteNotice.text
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>setInviteNotice(null),
                            className: "shrink-0 rounded p-0.5 text-gray-400 transition hover:text-gray-600",
                            "aria-label": "Dismiss",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 16
                            })
                        })
                    ]
                })
            }),
            saveFailure && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed bottom-6 left-1/2 z-[10002] w-[calc(100%-2rem)] max-w-lg -translate-x-1/2",
                role: "alert",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-start gap-3 rounded-xl border border-amber-300 bg-white px-4 py-3 shadow-xl",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                            size: 18,
                            className: "mt-0.5 shrink-0 text-amber-600",
                            "aria-hidden": "true"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "flex-1 text-sm leading-relaxed text-gray-700",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "font-semibold text-gray-900",
                                    children: "Your latest changes are not being saved."
                                }),
                                " ",
                                saveFailure
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: savedElsewhere ? ()=>window.location.reload() : retrySave,
                            className: "shrink-0 rounded-lg border border-slate-300 px-3 py-1 text-xs font-semibold text-slate-700 hover:border-blue-300 hover:text-blue-800",
                            "data-testid": "save-failure-action",
                            children: savedElsewhere ? 'Reload' : 'Try again'
                        })
                    ]
                })
            })
        ]
    });
    const registrationOverlay = showRegistration && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b85e9b46e4618b3e$export$2e2bcd8739ae039), {
        initialMode: "signup",
        factFind: factFind,
        setFactFind: setFactFind,
        onClose: ()=>setShowRegistration(false),
        onSignedUp: async ()=>{
            // See resumeFromSignIn's matching comment: without this, auto-save never enables for a
            // session that just signed up this page load.
            setAccountUser(await (0, $cc9e8a24185b91b0$export$a79e7ef8c396bb0e)());
            setShowRegistration(false);
            setShowGeneralAdvice(null);
            (0, $357e6188006bbf96$export$2e58bf066eef6dcd)();
            const inviteToken = (0, $442533e192804693$export$ec6a2e3c3bb73e9c)();
            if (inviteToken) {
                const res = await (0, $442533e192804693$export$f17229473791149b)(inviteToken).finally(()=>(0, $442533e192804693$export$900988654c72c4e3)());
                if (res.ok && [
                    'owner',
                    'adviser',
                    'staff'
                ].includes(res.role)) {
                    setPartnerResolving(true); // branded loader, never the demo login, from frame 1
                    setActivePage('PartnerPortal');
                    return;
                }
                // A client invite just linked their adviser-prepared file — load it so their details
                // are already there, and so auto-save UPDATES that file instead of orphaning it.
                if (res.ok && res.role === 'client') {
                    const loaded = await (0, $a0f9af581f384312$export$4310a59bd5b0b729)().catch(()=>null);
                    if (loaded) {
                        setFactFind(loaded.factFind);
                        setClientProfileStep(1);
                        setActivePage('Client Profile');
                        return;
                    }
                }
            }
            // Brand-new direct consumer: pay at Get Started (Option A) if billing is live, otherwise
            // straight into the fact-find. Fact-find starts EMPTY — never data left by a prior session.
            await enterConsumerWithBilling(()=>{
                setFactFind(structuredClone((0, $b116352393ba4abb$export$55f731ae3600e88a)));
                setClientProfileStep(1);
                setActivePage('Client Profile');
            });
        },
        onSignedIn: (loaded)=>{
            // "Get Started" → "Already have an account? Sign in": a RETURNING user must resume
            // their plan like any other sign-in — never dead-end on the account settings panel.
            setShowRegistration(false);
            setShowGeneralAdvice(null);
            return resumeFromSignIn(loaded);
        }
    });
    const chatWidget = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                "aria-label": "Ask AWise",
                className: "fixed bottom-4 right-4 h-12 w-12 justify-center p-0 sm:h-auto sm:w-auto sm:justify-start sm:bottom-8 sm:right-8 sm:p-4 sm:short:bottom-5 sm:short:right-5 sm:short:p-3 bg-blue-600 text-white rounded-full shadow-lg z-50 flex items-center gap-2 hover:bg-blue-700 hover:shadow-xl hover:scale-110 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2",
                onClick: ()=>setChatOpen(true),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8afc40d49a7e79bf$export$2e2bcd8739ae039), {
                        size: 24,
                        className: "shrink-0",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "hidden sm:inline-flex",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2c4379c8d623235$export$2e2bcd8739ae039), {
                            size: "base",
                            variant: "onDark"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e31cd18cd0725a6f$export$2e2bcd8739ae039), {
                open: chatOpen,
                onClose: ()=>setChatOpen(false),
                messages: chatMessages,
                chatInput: chatInput,
                onChatInputChange: setChatInput,
                onSubmit: submitChatMessage,
                sending: chatSending,
                signedIn: !!accountUser,
                className: "z-[9999]"
            })
        ]
    });
    const signedInUserKey = accountUser ? String(accountUser.id ?? accountUser.email ?? 'user') : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3034cbc16e4c7b14$export$2e2bcd8739ae039), {
                userKey: signedInUserKey
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e1e84c918e07c84$export$6238edd9774d82aa), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d329efc25751b153$export$2e2bcd8739ae039), {
                showGeneralAdvice: showGeneralAdvice,
                setShowGeneralAdvice: setShowGeneralAdvice,
                showSecurity: showSecurity,
                setShowSecurity: setShowSecurity,
                showPrivacy: showPrivacy,
                setShowPrivacy: setShowPrivacy,
                showCost: showCost,
                setShowCost: setShowCost,
                showFaqs: showFaqs,
                setShowFaqs: setShowFaqs,
                showExperience: showExperience,
                setShowExperience: setShowExperience,
                showAdmin: showAdmin,
                setShowAdmin: setShowAdmin,
                isPlatformAdmin: isPlatformAdmin,
                canReviewAdvice: canReviewAdvice,
                showCompliance: showCompliance,
                setShowCompliance: setShowCompliance,
                showApiDocs: showApiDocs,
                setShowApiDocs: setShowApiDocs,
                closeAdmin: closeAdmin,
                adminIsHome: adminIsHome,
                showPaywall: showPaywall,
                partnerPaywall: partnerPaywall,
                activePage: activePage,
                setActivePage: setActivePage,
                renderPageContent: renderPageContent,
                setShowRegistration: setShowRegistration,
                showAccountModal: showAccountModal,
                setShowAccountModal: setShowAccountModal,
                accountModalMode: accountModalMode,
                resetToken: resetToken,
                closeAccountModal: closeAccountModal,
                resumeFromSignIn: resumeFromSignIn,
                handleSignedOut: handleSignedOut,
                setFactFind: setFactFind,
                setAccountUser: setAccountUser,
                showPartnerEntry: showPartnerEntry,
                setShowPartnerEntry: setShowPartnerEntry,
                setActiveProfessionalCaseId: setActiveProfessionalCaseId,
                partnerIntent: partnerIntent,
                setPartnerIntent: setPartnerIntent,
                partnerFirm: partnerFirm,
                setPartnerFirm: setPartnerFirm,
                setProfessionalCases: setProfessionalCases,
                showPartnerWizard: showPartnerWizard,
                setShowPartnerWizard: setShowPartnerWizard,
                setPartnerResolving: setPartnerResolving,
                portalEntryError: portalEntryError,
                setPortalEntryError: setPortalEntryError,
                setPortalRefreshNonce: setPortalRefreshNonce,
                addClientPaywall: addClientPaywall,
                setAddClientPaywall: setAddClientPaywall,
                clientProfileStep: clientProfileStep,
                setClientProfileStep: setClientProfileStep,
                activeProfessionalCaseId: activeProfessionalCaseId,
                factFind: factFind,
                savedStrategies: savedStrategies,
                savedCaseStudies: savedCaseStudies,
                activeProfessionalCaseName: activeProfessionalCase?.clientName ?? null,
                registrationOverlay: registrationOverlay,
                inviteNoticeToast: inviteNoticeToast,
                chatWidget: chatWidget
            })
        ]
    });
}
var // ClientProfile + steps (and their WelcomeInsight/AcatInsightCard) extracted to src/pages/ClientProfile/
// AgedCareAnalyser extracted to src/features/agedCare/AgedCareAnalyser.js
// Aged Care optimisation UI and logic live in AgedCareSuggestionEnginePanel (formerly AgedCareSuggestionEnginePanel).
$19d9deac12f277fb$export$2e2bcd8739ae039 = $19d9deac12f277fb$var$App;


/**
 * BetaGate — the "beta access" password screen shown before the app during a private beta.
 *
 * Purpose: keep casual visitors and search engines out of an unfinished tool. It is NOT a security
 * control for client data — the real protection is the account login and encryption behind it.
 *
 * THE GATE IS NOW A SERVER SETTING (owner-directed, 2026-09-10: "refactor the beta password
 * function into a .env variable that we can set on production").
 *
 * It was already an env variable — `REACT_APP_BETA_PASSWORD` — but a BUILD-TIME one, inlined into
 * the bundle by Parcel. Two consequences, both of which bit:
 *
 *   SETTING IT ON PRODUCTION DID NOTHING. The value had to exist on whichever machine ran the
 *   build, so the server's environment was irrelevant.
 *
 *   A REBUILD WITHOUT IT SILENTLY REMOVED THE GATE. Moving to the new server compiled
 *   `const BETA_PASSWORD = String('')`, `isBetaGated()` returned false, and the site was open to
 *   anyone. Nothing errored and nothing was logged — the protection just stopped being there.
 *
 * Now the server decides: `BETA_PASSWORD` in its environment, read per request, switched on or off
 * with a restart and no rebuild. The password is never sent to the browser — the typed candidate
 * goes to the server and comes back yes or no — so it can no longer be read out of the JavaScript.
 *
 * FAILS CLOSED. If the status check cannot reach the API the gate stays shut and offers a retry,
 * because the point of it is keeping people out of un-signed-off financial modelling: an API blip
 * must not be a way in. The cost is that a cold-starting API shows the retry for a few seconds.
 */ 

var $acw62 = parcelRequire("acw62");


const $eafc71a542e8f9d8$var$UNLOCK_KEY = 'awiseBetaUnlocked';
function $eafc71a542e8f9d8$var$alreadyUnlocked() {
    try {
        return localStorage.getItem($eafc71a542e8f9d8$var$UNLOCK_KEY) === '1';
    } catch  {
        return false;
    }
}
/** Ask the server whether this deployment is gated. Never receives the password itself. */ async function $eafc71a542e8f9d8$var$fetchGateRequired() {
    const res = await fetch(`${(0, $0aae0b39fc034917$export$4d28219d42798a75)()}/rest/beta/status`, {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        }
    });
    if (!res.ok) throw new Error(`status ${res.status}`);
    const body = await res.json();
    return Boolean(body?.required);
}
/** Ask the server to check a candidate password. */ async function $eafc71a542e8f9d8$var$checkPassword(password) {
    const res = await fetch(`${(0, $0aae0b39fc034917$export$4d28219d42798a75)()}/rest/beta/unlock`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify({
            password: password
        })
    });
    if (!res.ok) throw new Error(`status ${res.status}`);
    const body = await res.json();
    return Boolean(body?.ok);
}
const $eafc71a542e8f9d8$var$BetaGate = ({ children: children })=>{
    const [state, setState] = (0, $acw62.useState)(()=>$eafc71a542e8f9d8$var$alreadyUnlocked() ? 'open' : 'checking');
    const [entry, setEntry] = (0, $acw62.useState)('');
    const [error, setError] = (0, $acw62.useState)(null);
    const [submitting, setSubmitting] = (0, $acw62.useState)(false);
    const check = (0, $acw62.useCallback)(async ()=>{
        setState('checking');
        try {
            setState(await $eafc71a542e8f9d8$var$fetchGateRequired() ? 'locked' : 'open');
        } catch  {
            // Fails CLOSED — see the file comment. An unreachable API is not a way past the gate.
            setState('unreachable');
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        if ($eafc71a542e8f9d8$var$alreadyUnlocked()) return;
        check();
    }, [
        check
    ]);
    const submit = async (e)=>{
        e.preventDefault();
        if (submitting) return;
        setSubmitting(true);
        setError(null);
        try {
            if (await $eafc71a542e8f9d8$var$checkPassword(entry.trim())) {
                try {
                    localStorage.setItem($eafc71a542e8f9d8$var$UNLOCK_KEY, '1');
                } catch  {}
                setState('open');
            } else setError("That password wasn\u2019t recognised. Please check and try again.");
        } catch  {
            setError("We couldn\u2019t reach the server to check that. Please try again in a moment.");
        } finally{
            setSubmitting(false);
        }
    };
    if (state === 'open') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
    const Shell = ({ children: inner })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "min-h-screen flex items-center justify-center bg-slate-50 p-4",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-2xl ring-1 ring-black/5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative overflow-hidden bg-gradient-to-br from-[#1a6fd4] to-[#17b8e0] px-6 pt-7 pb-8 text-center text-white",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "pointer-events-none absolute -right-8 -top-10 h-32 w-32 rounded-full bg-white/10 blur-2xl"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/25 backdrop-blur",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e20ffdae2aa9b33f$export$2e2bcd8739ae039), {
                                    className: "h-7 w-7"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                                className: "text-2xl font-bold",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "AgedCare"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-white/90",
                                        children: "Wise"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-1 text-sm text-white/85",
                                children: "Private beta \u2014 access by invitation"
                            })
                        ]
                    }),
                    inner
                ]
            })
        });
    /* Waiting on the server. Said plainly rather than shown as an empty screen. */ if (state === 'checking') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Shell, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex items-center justify-center gap-2.5 p-8 text-sm text-gray-600",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                    size: 16,
                    className: "animate-spin text-blue-600"
                }),
                "Checking access\u2026"
            ]
        })
    });
    /* The API could not be reached. The gate stays shut, and says why. */ if (state === 'unreachable') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Shell, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-4 p-6",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-start gap-2.5 rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                            size: 16,
                            className: "mt-0.5 shrink-0 text-amber-600"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-slate-700",
                            children: "We couldn\u2019t reach the server to check access. If the site has been idle it may be starting up \u2014 this usually clears in under a minute."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    type: "button",
                    onClick: ()=>void check(),
                    className: "w-full inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#1a6fd4] to-[#17b8e0] py-2.5 font-semibold text-white shadow-lg shadow-blue-600/25 transition hover:shadow-xl hover:brightness-[1.04] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                            size: 16
                        }),
                        " Try again"
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Shell, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            onSubmit: submit,
            className: "p-6 space-y-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-sm text-gray-600",
                    children: "Enter the beta access password you were given to continue."
                }),
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-start gap-2.5 rounded-xl border border-red-200 bg-red-50 px-4 py-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                            size: 16,
                            className: "mt-0.5 shrink-0 text-red-600"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-red-700",
                            children: error
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: "beta-pw",
                            className: "block text-sm font-medium text-gray-700 mb-1.5",
                            children: "Access password"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            id: "beta-pw",
                            type: "password",
                            autoFocus: true,
                            value: entry,
                            onChange: (e)=>{
                                setEntry(e.target.value);
                                setError(null);
                            },
                            className: "w-full rounded-xl border border-gray-200 bg-gray-50/70 px-3.5 py-2.5 text-gray-900 placeholder-gray-400 shadow-sm transition focus:bg-white focus:border-blue-400 focus:ring-2 focus:ring-blue-500/40 focus:outline-none",
                            placeholder: "Beta password"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "submit",
                    disabled: !entry.trim() || submitting,
                    className: "w-full inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#1a6fd4] to-[#17b8e0] py-2.5 font-semibold text-white shadow-lg shadow-blue-600/25 transition hover:shadow-xl hover:brightness-[1.04] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none",
                    children: submitting ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                size: 16,
                                className: "animate-spin"
                            }),
                            " Checking\u2026"
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "Enter ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                size: 16
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-center text-xs text-gray-400",
                    children: "AgedCareWise is in private beta. It\u2019s a demonstration and not personal financial advice."
                })
            ]
        })
    });
};
var $eafc71a542e8f9d8$export$2e2bcd8739ae039 = $eafc71a542e8f9d8$var$BetaGate;


class $f85b6d3c5c511c65$var$ErrorBoundary extends (0, $acw62.Component) {
    state = {
        hasError: false,
        error: null
    };
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error: error
        };
    }
    componentDidCatch(error, info) {
        console.error("App error:", error, info);
    }
    render() {
        if (this.state.hasError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "min-h-screen bg-red-50 p-8 flex flex-col items-center justify-center",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "text-2xl font-bold text-red-800 mb-4",
                    children: "Something went wrong"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                    className: "bg-white p-4 rounded-lg text-sm text-red-700 overflow-auto max-w-2xl",
                    children: this.state.error?.toString?.() || "Unknown error"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    onClick: ()=>this.setState({
                            hasError: false,
                            error: null
                        }),
                    className: "mt-4 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700",
                    children: "Try again"
                })
            ]
        });
        return this.props.children;
    }
}
const $f85b6d3c5c511c65$var$container = document.getElementById("root");
if (!$f85b6d3c5c511c65$var$container) throw new Error('Root container not found');
const $f85b6d3c5c511c65$var$root = (0, $7e96a608cb33bf79$exports.createRoot)($f85b6d3c5c511c65$var$container);
$f85b6d3c5c511c65$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f85b6d3c5c511c65$var$ErrorBoundary, {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eafc71a542e8f9d8$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $19d9deac12f277fb$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=frontend.1a64930a.js.map
